/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/web/public";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 1004);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _atUtils = __webpack_require__(5);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MessageResource = function () {
    function MessageResource(messageBundle, messageSubstitutions) {
        _classCallCheck(this, MessageResource);

        this.messageBundle = messageBundle;
        this.messageSubstitutions = messageSubstitutions;
    }

    _createClass(MessageResource, [{
        key: "applyMacrosSubstitutions",
        value: function applyMacrosSubstitutions(message, escapeMacros) {
            // quick check
            if (message.indexOf("#") < 0) return message;

            for (var i = 0; i < this.messageSubstitutions.length; i++) {
                message = message.replace(this.messageSubstitutions[i].regexp, escapeMacros ? (0, _atUtils.escapeHtmlSymbols)(this.messageSubstitutions[i].value) : this.messageSubstitutions[i].value);
            }

            return message;
        }
    }, {
        key: "applyParamsSubstitutions",
        value: function applyParamsSubstitutions(message, params) {
            var escape = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

            if (params && params.length > 0) {
                for (var j = 0; j < params.length; j++) {
                    message = message.replace(new RegExp("{" + j + "[,a-zA-Z]*}", "g"), escape ? (0, _atUtils.escapeHtmlSymbols)(params[j]) : params[j]);
                }
            }

            return message;
        }
    }, {
        key: "applyAllSubstitutions",
        value: function applyAllSubstitutions(message, params, escapeMacros, escapeArgs) {
            message = this.applyMacrosSubstitutions(message, escapeMacros);
            message = this.applyParamsSubstitutions(message, params, escapeArgs);
            return message;
        }
    }, {
        key: "getMessage",
        value: function getMessage(key, params, escapeMacros, escapeArgs) {
            var message = this.messageBundle[key];
            if ((typeof message === "undefined" ? "undefined" : _typeof(message)) === ( true ? "undefined" : _typeof(undefined))) {
                if ((typeof console === "undefined" ? "undefined" : _typeof(console)) !== ( true ? "undefined" : _typeof(undefined)) && console.trace) console.trace("could not find message with key: " + key);
                return undefined;
            }
            return this.applyAllSubstitutions(message, params, escapeMacros, escapeArgs);
        }
    }, {
        key: "getEscapedMessage",
        value: function getEscapedMessage(key, params) {
            return (0, _atUtils.escapeHtmlSymbols)(this.getMessage(key, params));
        }
    }, {
        key: "getMessageWithEscapedMacros",
        value: function getMessageWithEscapedMacros(key, params) {
            return this.getMessage(key, params, true);
        }
    }, {
        key: "getMessageWithEscapedArgs",
        value: function getMessageWithEscapedArgs(key, params) {
            return this.getMessage(key, params, false, true);
        }
    }, {
        key: "getEscapedMessageNoEscapeArgs",
        value: function getEscapedMessageNoEscapeArgs(key, params) {
            //noinspection JSUnresolvedVariable
            var message = this.messageBundle[key];
            if ((typeof message === "undefined" ? "undefined" : _typeof(message)) === ( true ? "undefined" : _typeof(undefined))) {
                if ((typeof console === "undefined" ? "undefined" : _typeof(console)) !== ( true ? "undefined" : _typeof(undefined)) && console.trace) console.trace("could not find message with key: " + key);
                return undefined;
            }
            message = this.applyMacrosSubstitutions(message);
            message = (0, _atUtils.escapeHtmlSymbols)(message);
            message = this.applyParamsSubstitutions(message, params);
            return message;
        }
    }, {
        key: "printMessage",
        value: function printMessage(key, params, escapeMacros) {
            document.write(this.getMessage(key, params, escapeMacros));
        }
    }]);

    return MessageResource;
}();

var messageResource = new MessageResource(window.MESSAGE_BUNDLE, window.MESSAGE_SUBSTITUTIONS);
exports.default = messageResource;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _View2 = __webpack_require__(20);

var _View3 = _interopRequireDefault(_View2);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var isPrototypeOfDefined = Object.getPrototypeOf;

/**
 * Implementation of View class, which uses Underscore or plain HTML strings as templates for rendering.
 * @param $containerEl - element for render component
 * @constructor
 */

var TemplateView = function (_View) {
    _inherits(TemplateView, _View);

    function TemplateView($containerEl) {
        _classCallCheck(this, TemplateView);

        return _possibleConstructorReturn(this, (TemplateView.__proto__ || Object.getPrototypeOf(TemplateView)).call(this, $containerEl));
    }

    /**
     * HTML template or just plain markup used to render the view.
     */


    _createClass(TemplateView, [{
        key: "templateHtml",
        value: function templateHtml() {
            // TODO: Eventually make this abstract, or empty div. Legacy TemplateView classes have their markup in the "html" field, so this line is for them.
            return this["html"];
        }

        /**
         * Defines if a view should use Underscore templates functionality.
         * If template HTML is static, it would be beneficial to set this to false.
         * @return {boolean}
         */

    }, {
        key: "useUnderscoreTemplate",
        value: function useUnderscoreTemplate() {
            return true;
        }
    }, {
        key: "render",
        value: function render() {
            if (!this.$el) this.$el = (0, _jquery2.default)(this.toHtml());
            this.appendToContainer();
            return this;
        }
    }, {
        key: "appendToContainer",
        value: function appendToContainer() {
            this.$containerEl.append(this.$el);
        }
    }, {
        key: "toHtml",
        value: function toHtml() {
            if (!this._htmlCache) this._htmlCache = this._toHtml();
            return this._htmlCache;
        }
    }, {
        key: "_toHtml",
        value: function _toHtml() {
            var html = void 0;
            if (this.useUnderscoreTemplate()) {
                var template = void 0;
                if (isPrototypeOfDefined) {
                    template = Object.getPrototypeOf(this)._cachedTemplate;
                    if (!template) {
                        template = _underscore2.default.template(this.templateHtml());
                        Object.getPrototypeOf(this)._cachedTemplate = template;
                    }
                } else {
                    template = _underscore2.default.template(this.templateHtml());
                }

                var model = this.templateModel();
                var messageKeys = this.messageKeys();
                _underscore2.default.each(_underscore2.default.keys(messageKeys), function (modelKey) {
                    return model[modelKey] = _messageResource2.default.getMessage(messageKeys[modelKey]);
                });
                html = template(model);
            } else html = this.templateHtml();

            return html;
        }

        /**
         * When TemplateView is rendered using Underscore template,
         * this function's returned object will be used as a model.
         * @returns {Object}
         */

    }, {
        key: "templateModel",
        value: function templateModel() {
            return this;
        }

        /**
         * Works similarly to .templateModel() method, but interprets object keys as messageKeys
         * for messageResource, which will be exchanged to actual message strings during render.
         * @returns {Object}
         */

    }, {
        key: "messageKeys",
        value: function messageKeys() {
            return {};
        }
    }]);

    return TemplateView;
}(_View3.default);

exports.default = TemplateView;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var $ = window.$;
exports.default = $;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//     Underscore.js 1.8.3
//     http://underscorejs.org
//     (c) 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
//     Underscore may be freely distributed under the MIT license.

(function() {

  // Baseline setup
  // --------------

  // Establish the root object, `window` in the browser, or `exports` on the server.
  var root = this;

  // Save the previous value of the `_` variable.
  var previousUnderscore = root._;

  // Save bytes in the minified (but not gzipped) version:
  var ArrayProto = Array.prototype, ObjProto = Object.prototype, FuncProto = Function.prototype;

  // Create quick reference variables for speed access to core prototypes.
  var
    push             = ArrayProto.push,
    slice            = ArrayProto.slice,
    toString         = ObjProto.toString,
    hasOwnProperty   = ObjProto.hasOwnProperty;

  // All **ECMAScript 5** native function implementations that we hope to use
  // are declared here.
  var
    nativeIsArray      = Array.isArray,
    nativeKeys         = Object.keys,
    nativeBind         = FuncProto.bind,
    nativeCreate       = Object.create;

  // Naked function reference for surrogate-prototype-swapping.
  var Ctor = function(){};

  // Create a safe reference to the Underscore object for use below.
  var _ = function(obj) {
    if (obj instanceof _) return obj;
    if (!(this instanceof _)) return new _(obj);
    this._wrapped = obj;
  };

  // Export the Underscore object for **Node.js**, with
  // backwards-compatibility for the old `require()` API. If we're in
  // the browser, add `_` as a global object.
  if (true) {
    if (typeof module !== 'undefined' && module.exports) {
      exports = module.exports = _;
    }
    exports._ = _;
  } else {
    root._ = _;
  }

  // Current version.
  _.VERSION = '1.8.3';

  // Internal function that returns an efficient (for current engines) version
  // of the passed-in callback, to be repeatedly applied in other Underscore
  // functions.
  var optimizeCb = function(func, context, argCount) {
    if (context === void 0) return func;
    switch (argCount == null ? 3 : argCount) {
      case 1: return function(value) {
        return func.call(context, value);
      };
      case 2: return function(value, other) {
        return func.call(context, value, other);
      };
      case 3: return function(value, index, collection) {
        return func.call(context, value, index, collection);
      };
      case 4: return function(accumulator, value, index, collection) {
        return func.call(context, accumulator, value, index, collection);
      };
    }
    return function() {
      return func.apply(context, arguments);
    };
  };

  // A mostly-internal function to generate callbacks that can be applied
  // to each element in a collection, returning the desired result — either
  // identity, an arbitrary callback, a property matcher, or a property accessor.
  var cb = function(value, context, argCount) {
    if (value == null) return _.identity;
    if (_.isFunction(value)) return optimizeCb(value, context, argCount);
    if (_.isObject(value)) return _.matcher(value);
    return _.property(value);
  };
  _.iteratee = function(value, context) {
    return cb(value, context, Infinity);
  };

  // An internal function for creating assigner functions.
  var createAssigner = function(keysFunc, undefinedOnly) {
    return function(obj) {
      var length = arguments.length;
      if (length < 2 || obj == null) return obj;
      for (var index = 1; index < length; index++) {
        var source = arguments[index],
            keys = keysFunc(source),
            l = keys.length;
        for (var i = 0; i < l; i++) {
          var key = keys[i];
          if (!undefinedOnly || obj[key] === void 0) obj[key] = source[key];
        }
      }
      return obj;
    };
  };

  // An internal function for creating a new object that inherits from another.
  var baseCreate = function(prototype) {
    if (!_.isObject(prototype)) return {};
    if (nativeCreate) return nativeCreate(prototype);
    Ctor.prototype = prototype;
    var result = new Ctor;
    Ctor.prototype = null;
    return result;
  };

  var property = function(key) {
    return function(obj) {
      return obj == null ? void 0 : obj[key];
    };
  };

  // Helper for collection methods to determine whether a collection
  // should be iterated as an array or as an object
  // Related: http://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
  // Avoids a very nasty iOS 8 JIT bug on ARM-64. #2094
  var MAX_ARRAY_INDEX = Math.pow(2, 53) - 1;
  var getLength = property('length');
  var isArrayLike = function(collection) {
    var length = getLength(collection);
    return typeof length == 'number' && length >= 0 && length <= MAX_ARRAY_INDEX;
  };

  // Collection Functions
  // --------------------

  // The cornerstone, an `each` implementation, aka `forEach`.
  // Handles raw objects in addition to array-likes. Treats all
  // sparse array-likes as if they were dense.
  _.each = _.forEach = function(obj, iteratee, context) {
    iteratee = optimizeCb(iteratee, context);
    var i, length;
    if (isArrayLike(obj)) {
      for (i = 0, length = obj.length; i < length; i++) {
        iteratee(obj[i], i, obj);
      }
    } else {
      var keys = _.keys(obj);
      for (i = 0, length = keys.length; i < length; i++) {
        iteratee(obj[keys[i]], keys[i], obj);
      }
    }
    return obj;
  };

  // Return the results of applying the iteratee to each element.
  _.map = _.collect = function(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
        length = (keys || obj).length,
        results = Array(length);
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      results[index] = iteratee(obj[currentKey], currentKey, obj);
    }
    return results;
  };

  // Create a reducing function iterating left or right.
  function createReduce(dir) {
    // Optimized iterator function as using arguments.length
    // in the main function will deoptimize the, see #1991.
    function iterator(obj, iteratee, memo, keys, index, length) {
      for (; index >= 0 && index < length; index += dir) {
        var currentKey = keys ? keys[index] : index;
        memo = iteratee(memo, obj[currentKey], currentKey, obj);
      }
      return memo;
    }

    return function(obj, iteratee, memo, context) {
      iteratee = optimizeCb(iteratee, context, 4);
      var keys = !isArrayLike(obj) && _.keys(obj),
          length = (keys || obj).length,
          index = dir > 0 ? 0 : length - 1;
      // Determine the initial value if none is provided.
      if (arguments.length < 3) {
        memo = obj[keys ? keys[index] : index];
        index += dir;
      }
      return iterator(obj, iteratee, memo, keys, index, length);
    };
  }

  // **Reduce** builds up a single result from a list of values, aka `inject`,
  // or `foldl`.
  _.reduce = _.foldl = _.inject = createReduce(1);

  // The right-associative version of reduce, also known as `foldr`.
  _.reduceRight = _.foldr = createReduce(-1);

  // Return the first value which passes a truth test. Aliased as `detect`.
  _.find = _.detect = function(obj, predicate, context) {
    var key;
    if (isArrayLike(obj)) {
      key = _.findIndex(obj, predicate, context);
    } else {
      key = _.findKey(obj, predicate, context);
    }
    if (key !== void 0 && key !== -1) return obj[key];
  };

  // Return all the elements that pass a truth test.
  // Aliased as `select`.
  _.filter = _.select = function(obj, predicate, context) {
    var results = [];
    predicate = cb(predicate, context);
    _.each(obj, function(value, index, list) {
      if (predicate(value, index, list)) results.push(value);
    });
    return results;
  };

  // Return all the elements for which a truth test fails.
  _.reject = function(obj, predicate, context) {
    return _.filter(obj, _.negate(cb(predicate)), context);
  };

  // Determine whether all of the elements match a truth test.
  // Aliased as `all`.
  _.every = _.all = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
        length = (keys || obj).length;
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      if (!predicate(obj[currentKey], currentKey, obj)) return false;
    }
    return true;
  };

  // Determine if at least one element in the object matches a truth test.
  // Aliased as `any`.
  _.some = _.any = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
        length = (keys || obj).length;
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      if (predicate(obj[currentKey], currentKey, obj)) return true;
    }
    return false;
  };

  // Determine if the array or object contains a given item (using `===`).
  // Aliased as `includes` and `include`.
  _.contains = _.includes = _.include = function(obj, item, fromIndex, guard) {
    if (!isArrayLike(obj)) obj = _.values(obj);
    if (typeof fromIndex != 'number' || guard) fromIndex = 0;
    return _.indexOf(obj, item, fromIndex) >= 0;
  };

  // Invoke a method (with arguments) on every item in a collection.
  _.invoke = function(obj, method) {
    var args = slice.call(arguments, 2);
    var isFunc = _.isFunction(method);
    return _.map(obj, function(value) {
      var func = isFunc ? method : value[method];
      return func == null ? func : func.apply(value, args);
    });
  };

  // Convenience version of a common use case of `map`: fetching a property.
  _.pluck = function(obj, key) {
    return _.map(obj, _.property(key));
  };

  // Convenience version of a common use case of `filter`: selecting only objects
  // containing specific `key:value` pairs.
  _.where = function(obj, attrs) {
    return _.filter(obj, _.matcher(attrs));
  };

  // Convenience version of a common use case of `find`: getting the first object
  // containing specific `key:value` pairs.
  _.findWhere = function(obj, attrs) {
    return _.find(obj, _.matcher(attrs));
  };

  // Return the maximum element (or element-based computation).
  _.max = function(obj, iteratee, context) {
    var result = -Infinity, lastComputed = -Infinity,
        value, computed;
    if (iteratee == null && obj != null) {
      obj = isArrayLike(obj) ? obj : _.values(obj);
      for (var i = 0, length = obj.length; i < length; i++) {
        value = obj[i];
        if (value > result) {
          result = value;
        }
      }
    } else {
      iteratee = cb(iteratee, context);
      _.each(obj, function(value, index, list) {
        computed = iteratee(value, index, list);
        if (computed > lastComputed || computed === -Infinity && result === -Infinity) {
          result = value;
          lastComputed = computed;
        }
      });
    }
    return result;
  };

  // Return the minimum element (or element-based computation).
  _.min = function(obj, iteratee, context) {
    var result = Infinity, lastComputed = Infinity,
        value, computed;
    if (iteratee == null && obj != null) {
      obj = isArrayLike(obj) ? obj : _.values(obj);
      for (var i = 0, length = obj.length; i < length; i++) {
        value = obj[i];
        if (value < result) {
          result = value;
        }
      }
    } else {
      iteratee = cb(iteratee, context);
      _.each(obj, function(value, index, list) {
        computed = iteratee(value, index, list);
        if (computed < lastComputed || computed === Infinity && result === Infinity) {
          result = value;
          lastComputed = computed;
        }
      });
    }
    return result;
  };

  // Shuffle a collection, using the modern version of the
  // [Fisher-Yates shuffle](http://en.wikipedia.org/wiki/Fisher–Yates_shuffle).
  _.shuffle = function(obj) {
    var set = isArrayLike(obj) ? obj : _.values(obj);
    var length = set.length;
    var shuffled = Array(length);
    for (var index = 0, rand; index < length; index++) {
      rand = _.random(0, index);
      if (rand !== index) shuffled[index] = shuffled[rand];
      shuffled[rand] = set[index];
    }
    return shuffled;
  };

  // Sample **n** random values from a collection.
  // If **n** is not specified, returns a single random element.
  // The internal `guard` argument allows it to work with `map`.
  _.sample = function(obj, n, guard) {
    if (n == null || guard) {
      if (!isArrayLike(obj)) obj = _.values(obj);
      return obj[_.random(obj.length - 1)];
    }
    return _.shuffle(obj).slice(0, Math.max(0, n));
  };

  // Sort the object's values by a criterion produced by an iteratee.
  _.sortBy = function(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    return _.pluck(_.map(obj, function(value, index, list) {
      return {
        value: value,
        index: index,
        criteria: iteratee(value, index, list)
      };
    }).sort(function(left, right) {
      var a = left.criteria;
      var b = right.criteria;
      if (a !== b) {
        if (a > b || a === void 0) return 1;
        if (a < b || b === void 0) return -1;
      }
      return left.index - right.index;
    }), 'value');
  };

  // An internal function used for aggregate "group by" operations.
  var group = function(behavior) {
    return function(obj, iteratee, context) {
      var result = {};
      iteratee = cb(iteratee, context);
      _.each(obj, function(value, index) {
        var key = iteratee(value, index, obj);
        behavior(result, value, key);
      });
      return result;
    };
  };

  // Groups the object's values by a criterion. Pass either a string attribute
  // to group by, or a function that returns the criterion.
  _.groupBy = group(function(result, value, key) {
    if (_.has(result, key)) result[key].push(value); else result[key] = [value];
  });

  // Indexes the object's values by a criterion, similar to `groupBy`, but for
  // when you know that your index values will be unique.
  _.indexBy = group(function(result, value, key) {
    result[key] = value;
  });

  // Counts instances of an object that group by a certain criterion. Pass
  // either a string attribute to count by, or a function that returns the
  // criterion.
  _.countBy = group(function(result, value, key) {
    if (_.has(result, key)) result[key]++; else result[key] = 1;
  });

  // Safely create a real, live array from anything iterable.
  _.toArray = function(obj) {
    if (!obj) return [];
    if (_.isArray(obj)) return slice.call(obj);
    if (isArrayLike(obj)) return _.map(obj, _.identity);
    return _.values(obj);
  };

  // Return the number of elements in an object.
  _.size = function(obj) {
    if (obj == null) return 0;
    return isArrayLike(obj) ? obj.length : _.keys(obj).length;
  };

  // Split a collection into two arrays: one whose elements all satisfy the given
  // predicate, and one whose elements all do not satisfy the predicate.
  _.partition = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var pass = [], fail = [];
    _.each(obj, function(value, key, obj) {
      (predicate(value, key, obj) ? pass : fail).push(value);
    });
    return [pass, fail];
  };

  // Array Functions
  // ---------------

  // Get the first element of an array. Passing **n** will return the first N
  // values in the array. Aliased as `head` and `take`. The **guard** check
  // allows it to work with `_.map`.
  _.first = _.head = _.take = function(array, n, guard) {
    if (array == null) return void 0;
    if (n == null || guard) return array[0];
    return _.initial(array, array.length - n);
  };

  // Returns everything but the last entry of the array. Especially useful on
  // the arguments object. Passing **n** will return all the values in
  // the array, excluding the last N.
  _.initial = function(array, n, guard) {
    return slice.call(array, 0, Math.max(0, array.length - (n == null || guard ? 1 : n)));
  };

  // Get the last element of an array. Passing **n** will return the last N
  // values in the array.
  _.last = function(array, n, guard) {
    if (array == null) return void 0;
    if (n == null || guard) return array[array.length - 1];
    return _.rest(array, Math.max(0, array.length - n));
  };

  // Returns everything but the first entry of the array. Aliased as `tail` and `drop`.
  // Especially useful on the arguments object. Passing an **n** will return
  // the rest N values in the array.
  _.rest = _.tail = _.drop = function(array, n, guard) {
    return slice.call(array, n == null || guard ? 1 : n);
  };

  // Trim out all falsy values from an array.
  _.compact = function(array) {
    return _.filter(array, _.identity);
  };

  // Internal implementation of a recursive `flatten` function.
  var flatten = function(input, shallow, strict, startIndex) {
    var output = [], idx = 0;
    for (var i = startIndex || 0, length = getLength(input); i < length; i++) {
      var value = input[i];
      if (isArrayLike(value) && (_.isArray(value) || _.isArguments(value))) {
        //flatten current level of array or arguments object
        if (!shallow) value = flatten(value, shallow, strict);
        var j = 0, len = value.length;
        output.length += len;
        while (j < len) {
          output[idx++] = value[j++];
        }
      } else if (!strict) {
        output[idx++] = value;
      }
    }
    return output;
  };

  // Flatten out an array, either recursively (by default), or just one level.
  _.flatten = function(array, shallow) {
    return flatten(array, shallow, false);
  };

  // Return a version of the array that does not contain the specified value(s).
  _.without = function(array) {
    return _.difference(array, slice.call(arguments, 1));
  };

  // Produce a duplicate-free version of the array. If the array has already
  // been sorted, you have the option of using a faster algorithm.
  // Aliased as `unique`.
  _.uniq = _.unique = function(array, isSorted, iteratee, context) {
    if (!_.isBoolean(isSorted)) {
      context = iteratee;
      iteratee = isSorted;
      isSorted = false;
    }
    if (iteratee != null) iteratee = cb(iteratee, context);
    var result = [];
    var seen = [];
    for (var i = 0, length = getLength(array); i < length; i++) {
      var value = array[i],
          computed = iteratee ? iteratee(value, i, array) : value;
      if (isSorted) {
        if (!i || seen !== computed) result.push(value);
        seen = computed;
      } else if (iteratee) {
        if (!_.contains(seen, computed)) {
          seen.push(computed);
          result.push(value);
        }
      } else if (!_.contains(result, value)) {
        result.push(value);
      }
    }
    return result;
  };

  // Produce an array that contains the union: each distinct element from all of
  // the passed-in arrays.
  _.union = function() {
    return _.uniq(flatten(arguments, true, true));
  };

  // Produce an array that contains every item shared between all the
  // passed-in arrays.
  _.intersection = function(array) {
    var result = [];
    var argsLength = arguments.length;
    for (var i = 0, length = getLength(array); i < length; i++) {
      var item = array[i];
      if (_.contains(result, item)) continue;
      for (var j = 1; j < argsLength; j++) {
        if (!_.contains(arguments[j], item)) break;
      }
      if (j === argsLength) result.push(item);
    }
    return result;
  };

  // Take the difference between one array and a number of other arrays.
  // Only the elements present in just the first array will remain.
  _.difference = function(array) {
    var rest = flatten(arguments, true, true, 1);
    return _.filter(array, function(value){
      return !_.contains(rest, value);
    });
  };

  // Zip together multiple lists into a single array -- elements that share
  // an index go together.
  _.zip = function() {
    return _.unzip(arguments);
  };

  // Complement of _.zip. Unzip accepts an array of arrays and groups
  // each array's elements on shared indices
  _.unzip = function(array) {
    var length = array && _.max(array, getLength).length || 0;
    var result = Array(length);

    for (var index = 0; index < length; index++) {
      result[index] = _.pluck(array, index);
    }
    return result;
  };

  // Converts lists into objects. Pass either a single array of `[key, value]`
  // pairs, or two parallel arrays of the same length -- one of keys, and one of
  // the corresponding values.
  _.object = function(list, values) {
    var result = {};
    for (var i = 0, length = getLength(list); i < length; i++) {
      if (values) {
        result[list[i]] = values[i];
      } else {
        result[list[i][0]] = list[i][1];
      }
    }
    return result;
  };

  // Generator function to create the findIndex and findLastIndex functions
  function createPredicateIndexFinder(dir) {
    return function(array, predicate, context) {
      predicate = cb(predicate, context);
      var length = getLength(array);
      var index = dir > 0 ? 0 : length - 1;
      for (; index >= 0 && index < length; index += dir) {
        if (predicate(array[index], index, array)) return index;
      }
      return -1;
    };
  }

  // Returns the first index on an array-like that passes a predicate test
  _.findIndex = createPredicateIndexFinder(1);
  _.findLastIndex = createPredicateIndexFinder(-1);

  // Use a comparator function to figure out the smallest index at which
  // an object should be inserted so as to maintain order. Uses binary search.
  _.sortedIndex = function(array, obj, iteratee, context) {
    iteratee = cb(iteratee, context, 1);
    var value = iteratee(obj);
    var low = 0, high = getLength(array);
    while (low < high) {
      var mid = Math.floor((low + high) / 2);
      if (iteratee(array[mid]) < value) low = mid + 1; else high = mid;
    }
    return low;
  };

  // Generator function to create the indexOf and lastIndexOf functions
  function createIndexFinder(dir, predicateFind, sortedIndex) {
    return function(array, item, idx) {
      var i = 0, length = getLength(array);
      if (typeof idx == 'number') {
        if (dir > 0) {
            i = idx >= 0 ? idx : Math.max(idx + length, i);
        } else {
            length = idx >= 0 ? Math.min(idx + 1, length) : idx + length + 1;
        }
      } else if (sortedIndex && idx && length) {
        idx = sortedIndex(array, item);
        return array[idx] === item ? idx : -1;
      }
      if (item !== item) {
        idx = predicateFind(slice.call(array, i, length), _.isNaN);
        return idx >= 0 ? idx + i : -1;
      }
      for (idx = dir > 0 ? i : length - 1; idx >= 0 && idx < length; idx += dir) {
        if (array[idx] === item) return idx;
      }
      return -1;
    };
  }

  // Return the position of the first occurrence of an item in an array,
  // or -1 if the item is not included in the array.
  // If the array is large and already in sort order, pass `true`
  // for **isSorted** to use binary search.
  _.indexOf = createIndexFinder(1, _.findIndex, _.sortedIndex);
  _.lastIndexOf = createIndexFinder(-1, _.findLastIndex);

  // Generate an integer Array containing an arithmetic progression. A port of
  // the native Python `range()` function. See
  // [the Python documentation](http://docs.python.org/library/functions.html#range).
  _.range = function(start, stop, step) {
    if (stop == null) {
      stop = start || 0;
      start = 0;
    }
    step = step || 1;

    var length = Math.max(Math.ceil((stop - start) / step), 0);
    var range = Array(length);

    for (var idx = 0; idx < length; idx++, start += step) {
      range[idx] = start;
    }

    return range;
  };

  // Function (ahem) Functions
  // ------------------

  // Determines whether to execute a function as a constructor
  // or a normal function with the provided arguments
  var executeBound = function(sourceFunc, boundFunc, context, callingContext, args) {
    if (!(callingContext instanceof boundFunc)) return sourceFunc.apply(context, args);
    var self = baseCreate(sourceFunc.prototype);
    var result = sourceFunc.apply(self, args);
    if (_.isObject(result)) return result;
    return self;
  };

  // Create a function bound to a given object (assigning `this`, and arguments,
  // optionally). Delegates to **ECMAScript 5**'s native `Function.bind` if
  // available.
  _.bind = function(func, context) {
    if (nativeBind && func.bind === nativeBind) return nativeBind.apply(func, slice.call(arguments, 1));
    if (!_.isFunction(func)) throw new TypeError('Bind must be called on a function');
    var args = slice.call(arguments, 2);
    var bound = function() {
      return executeBound(func, bound, context, this, args.concat(slice.call(arguments)));
    };
    return bound;
  };

  // Partially apply a function by creating a version that has had some of its
  // arguments pre-filled, without changing its dynamic `this` context. _ acts
  // as a placeholder, allowing any combination of arguments to be pre-filled.
  _.partial = function(func) {
    var boundArgs = slice.call(arguments, 1);
    var bound = function() {
      var position = 0, length = boundArgs.length;
      var args = Array(length);
      for (var i = 0; i < length; i++) {
        args[i] = boundArgs[i] === _ ? arguments[position++] : boundArgs[i];
      }
      while (position < arguments.length) args.push(arguments[position++]);
      return executeBound(func, bound, this, this, args);
    };
    return bound;
  };

  // Bind a number of an object's methods to that object. Remaining arguments
  // are the method names to be bound. Useful for ensuring that all callbacks
  // defined on an object belong to it.
  _.bindAll = function(obj) {
    var i, length = arguments.length, key;
    if (length <= 1) throw new Error('bindAll must be passed function names');
    for (i = 1; i < length; i++) {
      key = arguments[i];
      obj[key] = _.bind(obj[key], obj);
    }
    return obj;
  };

  // Memoize an expensive function by storing its results.
  _.memoize = function(func, hasher) {
    var memoize = function(key) {
      var cache = memoize.cache;
      var address = '' + (hasher ? hasher.apply(this, arguments) : key);
      if (!_.has(cache, address)) cache[address] = func.apply(this, arguments);
      return cache[address];
    };
    memoize.cache = {};
    return memoize;
  };

  // Delays a function for the given number of milliseconds, and then calls
  // it with the arguments supplied.
  _.delay = function(func, wait) {
    var args = slice.call(arguments, 2);
    return setTimeout(function(){
      return func.apply(null, args);
    }, wait);
  };

  // Defers a function, scheduling it to run after the current call stack has
  // cleared.
  _.defer = _.partial(_.delay, _, 1);

  // Returns a function, that, when invoked, will only be triggered at most once
  // during a given window of time. Normally, the throttled function will run
  // as much as it can, without ever going more than once per `wait` duration;
  // but if you'd like to disable the execution on the leading edge, pass
  // `{leading: false}`. To disable execution on the trailing edge, ditto.
  _.throttle = function(func, wait, options) {
    var context, args, result;
    var timeout = null;
    var previous = 0;
    if (!options) options = {};
    var later = function() {
      previous = options.leading === false ? 0 : _.now();
      timeout = null;
      result = func.apply(context, args);
      if (!timeout) context = args = null;
    };
    return function() {
      var now = _.now();
      if (!previous && options.leading === false) previous = now;
      var remaining = wait - (now - previous);
      context = this;
      args = arguments;
      if (remaining <= 0 || remaining > wait) {
        if (timeout) {
          clearTimeout(timeout);
          timeout = null;
        }
        previous = now;
        result = func.apply(context, args);
        if (!timeout) context = args = null;
      } else if (!timeout && options.trailing !== false) {
        timeout = setTimeout(later, remaining);
      }
      return result;
    };
  };

  // Returns a function, that, as long as it continues to be invoked, will not
  // be triggered. The function will be called after it stops being called for
  // N milliseconds. If `immediate` is passed, trigger the function on the
  // leading edge, instead of the trailing.
  _.debounce = function(func, wait, immediate) {
    var timeout, args, context, timestamp, result;

    var later = function() {
      var last = _.now() - timestamp;

      if (last < wait && last >= 0) {
        timeout = setTimeout(later, wait - last);
      } else {
        timeout = null;
        if (!immediate) {
          result = func.apply(context, args);
          if (!timeout) context = args = null;
        }
      }
    };

    return function() {
      context = this;
      args = arguments;
      timestamp = _.now();
      var callNow = immediate && !timeout;
      if (!timeout) timeout = setTimeout(later, wait);
      if (callNow) {
        result = func.apply(context, args);
        context = args = null;
      }

      return result;
    };
  };

  // Returns the first function passed as an argument to the second,
  // allowing you to adjust arguments, run code before and after, and
  // conditionally execute the original function.
  _.wrap = function(func, wrapper) {
    return _.partial(wrapper, func);
  };

  // Returns a negated version of the passed-in predicate.
  _.negate = function(predicate) {
    return function() {
      return !predicate.apply(this, arguments);
    };
  };

  // Returns a function that is the composition of a list of functions, each
  // consuming the return value of the function that follows.
  _.compose = function() {
    var args = arguments;
    var start = args.length - 1;
    return function() {
      var i = start;
      var result = args[start].apply(this, arguments);
      while (i--) result = args[i].call(this, result);
      return result;
    };
  };

  // Returns a function that will only be executed on and after the Nth call.
  _.after = function(times, func) {
    return function() {
      if (--times < 1) {
        return func.apply(this, arguments);
      }
    };
  };

  // Returns a function that will only be executed up to (but not including) the Nth call.
  _.before = function(times, func) {
    var memo;
    return function() {
      if (--times > 0) {
        memo = func.apply(this, arguments);
      }
      if (times <= 1) func = null;
      return memo;
    };
  };

  // Returns a function that will be executed at most one time, no matter how
  // often you call it. Useful for lazy initialization.
  _.once = _.partial(_.before, 2);

  // Object Functions
  // ----------------

  // Keys in IE < 9 that won't be iterated by `for key in ...` and thus missed.
  var hasEnumBug = !{toString: null}.propertyIsEnumerable('toString');
  var nonEnumerableProps = ['valueOf', 'isPrototypeOf', 'toString',
                      'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];

  function collectNonEnumProps(obj, keys) {
    var nonEnumIdx = nonEnumerableProps.length;
    var constructor = obj.constructor;
    var proto = (_.isFunction(constructor) && constructor.prototype) || ObjProto;

    // Constructor is a special case.
    var prop = 'constructor';
    if (_.has(obj, prop) && !_.contains(keys, prop)) keys.push(prop);

    while (nonEnumIdx--) {
      prop = nonEnumerableProps[nonEnumIdx];
      if (prop in obj && obj[prop] !== proto[prop] && !_.contains(keys, prop)) {
        keys.push(prop);
      }
    }
  }

  // Retrieve the names of an object's own properties.
  // Delegates to **ECMAScript 5**'s native `Object.keys`
  _.keys = function(obj) {
    if (!_.isObject(obj)) return [];
    if (nativeKeys) return nativeKeys(obj);
    var keys = [];
    for (var key in obj) if (_.has(obj, key)) keys.push(key);
    // Ahem, IE < 9.
    if (hasEnumBug) collectNonEnumProps(obj, keys);
    return keys;
  };

  // Retrieve all the property names of an object.
  _.allKeys = function(obj) {
    if (!_.isObject(obj)) return [];
    var keys = [];
    for (var key in obj) keys.push(key);
    // Ahem, IE < 9.
    if (hasEnumBug) collectNonEnumProps(obj, keys);
    return keys;
  };

  // Retrieve the values of an object's properties.
  _.values = function(obj) {
    var keys = _.keys(obj);
    var length = keys.length;
    var values = Array(length);
    for (var i = 0; i < length; i++) {
      values[i] = obj[keys[i]];
    }
    return values;
  };

  // Returns the results of applying the iteratee to each element of the object
  // In contrast to _.map it returns an object
  _.mapObject = function(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    var keys =  _.keys(obj),
          length = keys.length,
          results = {},
          currentKey;
      for (var index = 0; index < length; index++) {
        currentKey = keys[index];
        results[currentKey] = iteratee(obj[currentKey], currentKey, obj);
      }
      return results;
  };

  // Convert an object into a list of `[key, value]` pairs.
  _.pairs = function(obj) {
    var keys = _.keys(obj);
    var length = keys.length;
    var pairs = Array(length);
    for (var i = 0; i < length; i++) {
      pairs[i] = [keys[i], obj[keys[i]]];
    }
    return pairs;
  };

  // Invert the keys and values of an object. The values must be serializable.
  _.invert = function(obj) {
    var result = {};
    var keys = _.keys(obj);
    for (var i = 0, length = keys.length; i < length; i++) {
      result[obj[keys[i]]] = keys[i];
    }
    return result;
  };

  // Return a sorted list of the function names available on the object.
  // Aliased as `methods`
  _.functions = _.methods = function(obj) {
    var names = [];
    for (var key in obj) {
      if (_.isFunction(obj[key])) names.push(key);
    }
    return names.sort();
  };

  // Extend a given object with all the properties in passed-in object(s).
  _.extend = createAssigner(_.allKeys);

  // Assigns a given object with all the own properties in the passed-in object(s)
  // (https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/assign)
  _.extendOwn = _.assign = createAssigner(_.keys);

  // Returns the first key on an object that passes a predicate test
  _.findKey = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = _.keys(obj), key;
    for (var i = 0, length = keys.length; i < length; i++) {
      key = keys[i];
      if (predicate(obj[key], key, obj)) return key;
    }
  };

  // Return a copy of the object only containing the whitelisted properties.
  _.pick = function(object, oiteratee, context) {
    var result = {}, obj = object, iteratee, keys;
    if (obj == null) return result;
    if (_.isFunction(oiteratee)) {
      keys = _.allKeys(obj);
      iteratee = optimizeCb(oiteratee, context);
    } else {
      keys = flatten(arguments, false, false, 1);
      iteratee = function(value, key, obj) { return key in obj; };
      obj = Object(obj);
    }
    for (var i = 0, length = keys.length; i < length; i++) {
      var key = keys[i];
      var value = obj[key];
      if (iteratee(value, key, obj)) result[key] = value;
    }
    return result;
  };

   // Return a copy of the object without the blacklisted properties.
  _.omit = function(obj, iteratee, context) {
    if (_.isFunction(iteratee)) {
      iteratee = _.negate(iteratee);
    } else {
      var keys = _.map(flatten(arguments, false, false, 1), String);
      iteratee = function(value, key) {
        return !_.contains(keys, key);
      };
    }
    return _.pick(obj, iteratee, context);
  };

  // Fill in a given object with default properties.
  _.defaults = createAssigner(_.allKeys, true);

  // Creates an object that inherits from the given prototype object.
  // If additional properties are provided then they will be added to the
  // created object.
  _.create = function(prototype, props) {
    var result = baseCreate(prototype);
    if (props) _.extendOwn(result, props);
    return result;
  };

  // Create a (shallow-cloned) duplicate of an object.
  _.clone = function(obj) {
    if (!_.isObject(obj)) return obj;
    return _.isArray(obj) ? obj.slice() : _.extend({}, obj);
  };

  // Invokes interceptor with the obj, and then returns obj.
  // The primary purpose of this method is to "tap into" a method chain, in
  // order to perform operations on intermediate results within the chain.
  _.tap = function(obj, interceptor) {
    interceptor(obj);
    return obj;
  };

  // Returns whether an object has a given set of `key:value` pairs.
  _.isMatch = function(object, attrs) {
    var keys = _.keys(attrs), length = keys.length;
    if (object == null) return !length;
    var obj = Object(object);
    for (var i = 0; i < length; i++) {
      var key = keys[i];
      if (attrs[key] !== obj[key] || !(key in obj)) return false;
    }
    return true;
  };


  // Internal recursive comparison function for `isEqual`.
  var eq = function(a, b, aStack, bStack) {
    // Identical objects are equal. `0 === -0`, but they aren't identical.
    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
    if (a === b) return a !== 0 || 1 / a === 1 / b;
    // A strict comparison is necessary because `null == undefined`.
    if (a == null || b == null) return a === b;
    // Unwrap any wrapped objects.
    if (a instanceof _) a = a._wrapped;
    if (b instanceof _) b = b._wrapped;
    // Compare `[[Class]]` names.
    var className = toString.call(a);
    if (className !== toString.call(b)) return false;
    switch (className) {
      // Strings, numbers, regular expressions, dates, and booleans are compared by value.
      case '[object RegExp]':
      // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
      case '[object String]':
        // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
        // equivalent to `new String("5")`.
        return '' + a === '' + b;
      case '[object Number]':
        // `NaN`s are equivalent, but non-reflexive.
        // Object(NaN) is equivalent to NaN
        if (+a !== +a) return +b !== +b;
        // An `egal` comparison is performed for other numeric values.
        return +a === 0 ? 1 / +a === 1 / b : +a === +b;
      case '[object Date]':
      case '[object Boolean]':
        // Coerce dates and booleans to numeric primitive values. Dates are compared by their
        // millisecond representations. Note that invalid dates with millisecond representations
        // of `NaN` are not equivalent.
        return +a === +b;
    }

    var areArrays = className === '[object Array]';
    if (!areArrays) {
      if (typeof a != 'object' || typeof b != 'object') return false;

      // Objects with different constructors are not equivalent, but `Object`s or `Array`s
      // from different frames are.
      var aCtor = a.constructor, bCtor = b.constructor;
      if (aCtor !== bCtor && !(_.isFunction(aCtor) && aCtor instanceof aCtor &&
                               _.isFunction(bCtor) && bCtor instanceof bCtor)
                          && ('constructor' in a && 'constructor' in b)) {
        return false;
      }
    }
    // Assume equality for cyclic structures. The algorithm for detecting cyclic
    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.

    // Initializing stack of traversed objects.
    // It's done here since we only need them for objects and arrays comparison.
    aStack = aStack || [];
    bStack = bStack || [];
    var length = aStack.length;
    while (length--) {
      // Linear search. Performance is inversely proportional to the number of
      // unique nested structures.
      if (aStack[length] === a) return bStack[length] === b;
    }

    // Add the first object to the stack of traversed objects.
    aStack.push(a);
    bStack.push(b);

    // Recursively compare objects and arrays.
    if (areArrays) {
      // Compare array lengths to determine if a deep comparison is necessary.
      length = a.length;
      if (length !== b.length) return false;
      // Deep compare the contents, ignoring non-numeric properties.
      while (length--) {
        if (!eq(a[length], b[length], aStack, bStack)) return false;
      }
    } else {
      // Deep compare objects.
      var keys = _.keys(a), key;
      length = keys.length;
      // Ensure that both objects contain the same number of properties before comparing deep equality.
      if (_.keys(b).length !== length) return false;
      while (length--) {
        // Deep compare each member
        key = keys[length];
        if (!(_.has(b, key) && eq(a[key], b[key], aStack, bStack))) return false;
      }
    }
    // Remove the first object from the stack of traversed objects.
    aStack.pop();
    bStack.pop();
    return true;
  };

  // Perform a deep comparison to check if two objects are equal.
  _.isEqual = function(a, b) {
    return eq(a, b);
  };

  // Is a given array, string, or object empty?
  // An "empty" object has no enumerable own-properties.
  _.isEmpty = function(obj) {
    if (obj == null) return true;
    if (isArrayLike(obj) && (_.isArray(obj) || _.isString(obj) || _.isArguments(obj))) return obj.length === 0;
    return _.keys(obj).length === 0;
  };

  // Is a given value a DOM element?
  _.isElement = function(obj) {
    return !!(obj && obj.nodeType === 1);
  };

  // Is a given value an array?
  // Delegates to ECMA5's native Array.isArray
  _.isArray = nativeIsArray || function(obj) {
    return toString.call(obj) === '[object Array]';
  };

  // Is a given variable an object?
  _.isObject = function(obj) {
    var type = typeof obj;
    return type === 'function' || type === 'object' && !!obj;
  };

  // Add some isType methods: isArguments, isFunction, isString, isNumber, isDate, isRegExp, isError.
  _.each(['Arguments', 'Function', 'String', 'Number', 'Date', 'RegExp', 'Error'], function(name) {
    _['is' + name] = function(obj) {
      return toString.call(obj) === '[object ' + name + ']';
    };
  });

  // Define a fallback version of the method in browsers (ahem, IE < 9), where
  // there isn't any inspectable "Arguments" type.
  if (!_.isArguments(arguments)) {
    _.isArguments = function(obj) {
      return _.has(obj, 'callee');
    };
  }

  // Optimize `isFunction` if appropriate. Work around some typeof bugs in old v8,
  // IE 11 (#1621), and in Safari 8 (#1929).
  if (typeof /./ != 'function' && typeof Int8Array != 'object') {
    _.isFunction = function(obj) {
      return typeof obj == 'function' || false;
    };
  }

  // Is a given object a finite number?
  _.isFinite = function(obj) {
    return isFinite(obj) && !isNaN(parseFloat(obj));
  };

  // Is the given value `NaN`? (NaN is the only number which does not equal itself).
  _.isNaN = function(obj) {
    return _.isNumber(obj) && obj !== +obj;
  };

  // Is a given value a boolean?
  _.isBoolean = function(obj) {
    return obj === true || obj === false || toString.call(obj) === '[object Boolean]';
  };

  // Is a given value equal to null?
  _.isNull = function(obj) {
    return obj === null;
  };

  // Is a given variable undefined?
  _.isUndefined = function(obj) {
    return obj === void 0;
  };

  // Shortcut function for checking if an object has a given property directly
  // on itself (in other words, not on a prototype).
  _.has = function(obj, key) {
    return obj != null && hasOwnProperty.call(obj, key);
  };

  // Utility Functions
  // -----------------

  // Run Underscore.js in *noConflict* mode, returning the `_` variable to its
  // previous owner. Returns a reference to the Underscore object.
  _.noConflict = function() {
    root._ = previousUnderscore;
    return this;
  };

  // Keep the identity function around for default iteratees.
  _.identity = function(value) {
    return value;
  };

  // Predicate-generating functions. Often useful outside of Underscore.
  _.constant = function(value) {
    return function() {
      return value;
    };
  };

  _.noop = function(){};

  _.property = property;

  // Generates a function for a given object that returns a given property.
  _.propertyOf = function(obj) {
    return obj == null ? function(){} : function(key) {
      return obj[key];
    };
  };

  // Returns a predicate for checking whether an object has a given set of
  // `key:value` pairs.
  _.matcher = _.matches = function(attrs) {
    attrs = _.extendOwn({}, attrs);
    return function(obj) {
      return _.isMatch(obj, attrs);
    };
  };

  // Run a function **n** times.
  _.times = function(n, iteratee, context) {
    var accum = Array(Math.max(0, n));
    iteratee = optimizeCb(iteratee, context, 1);
    for (var i = 0; i < n; i++) accum[i] = iteratee(i);
    return accum;
  };

  // Return a random integer between min and max (inclusive).
  _.random = function(min, max) {
    if (max == null) {
      max = min;
      min = 0;
    }
    return min + Math.floor(Math.random() * (max - min + 1));
  };

  // A (possibly faster) way to get the current timestamp as an integer.
  _.now = Date.now || function() {
    return new Date().getTime();
  };

   // List of HTML entities for escaping.
  var escapeMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#x27;',
    '`': '&#x60;'
  };
  var unescapeMap = _.invert(escapeMap);

  // Functions for escaping and unescaping strings to/from HTML interpolation.
  var createEscaper = function(map) {
    var escaper = function(match) {
      return map[match];
    };
    // Regexes for identifying a key that needs to be escaped
    var source = '(?:' + _.keys(map).join('|') + ')';
    var testRegexp = RegExp(source);
    var replaceRegexp = RegExp(source, 'g');
    return function(string) {
      string = string == null ? '' : '' + string;
      return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
    };
  };
  _.escape = createEscaper(escapeMap);
  _.unescape = createEscaper(unescapeMap);

  // If the value of the named `property` is a function then invoke it with the
  // `object` as context; otherwise, return it.
  _.result = function(object, property, fallback) {
    var value = object == null ? void 0 : object[property];
    if (value === void 0) {
      value = fallback;
    }
    return _.isFunction(value) ? value.call(object) : value;
  };

  // Generate a unique integer id (unique within the entire client session).
  // Useful for temporary DOM ids.
  var idCounter = 0;
  _.uniqueId = function(prefix) {
    var id = ++idCounter + '';
    return prefix ? prefix + id : id;
  };

  // By default, Underscore uses ERB-style template delimiters, change the
  // following template settings to use alternative delimiters.
  _.templateSettings = {
    evaluate    : /<%([\s\S]+?)%>/g,
    interpolate : /<%=([\s\S]+?)%>/g,
    escape      : /<%-([\s\S]+?)%>/g
  };

  // When customizing `templateSettings`, if you don't want to define an
  // interpolation, evaluation or escaping regex, we need one that is
  // guaranteed not to match.
  var noMatch = /(.)^/;

  // Certain characters need to be escaped so that they can be put into a
  // string literal.
  var escapes = {
    "'":      "'",
    '\\':     '\\',
    '\r':     'r',
    '\n':     'n',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  var escaper = /\\|'|\r|\n|\u2028|\u2029/g;

  var escapeChar = function(match) {
    return '\\' + escapes[match];
  };

  // JavaScript micro-templating, similar to John Resig's implementation.
  // Underscore templating handles arbitrary delimiters, preserves whitespace,
  // and correctly escapes quotes within interpolated code.
  // NB: `oldSettings` only exists for backwards compatibility.
  _.template = function(text, settings, oldSettings) {
    if (!settings && oldSettings) settings = oldSettings;
    settings = _.defaults({}, settings, _.templateSettings);

    // Combine delimiters into one regular expression via alternation.
    var matcher = RegExp([
      (settings.escape || noMatch).source,
      (settings.interpolate || noMatch).source,
      (settings.evaluate || noMatch).source
    ].join('|') + '|$', 'g');

    // Compile the template source, escaping string literals appropriately.
    var index = 0;
    var source = "__p+='";
    text.replace(matcher, function(match, escape, interpolate, evaluate, offset) {
      source += text.slice(index, offset).replace(escaper, escapeChar);
      index = offset + match.length;

      if (escape) {
        source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
      } else if (interpolate) {
        source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
      } else if (evaluate) {
        source += "';\n" + evaluate + "\n__p+='";
      }

      // Adobe VMs need the match returned to produce the correct offest.
      return match;
    });
    source += "';\n";

    // If a variable is not specified, place data values in local scope.
    if (!settings.variable) source = 'with(obj||{}){\n' + source + '}\n';

    source = "var __t,__p='',__j=Array.prototype.join," +
      "print=function(){__p+=__j.call(arguments,'');};\n" +
      source + 'return __p;\n';

    try {
      var render = new Function(settings.variable || 'obj', '_', source);
    } catch (e) {
      e.source = source;
      throw e;
    }

    var template = function(data) {
      return render.call(this, data, _);
    };

    // Provide the compiled source as a convenience for precompilation.
    var argument = settings.variable || 'obj';
    template.source = 'function(' + argument + '){\n' + source + '}';

    return template;
  };

  // Add a "chain" function. Start chaining a wrapped Underscore object.
  _.chain = function(obj) {
    var instance = _(obj);
    instance._chain = true;
    return instance;
  };

  // OOP
  // ---------------
  // If Underscore is called as a function, it returns a wrapped object that
  // can be used OO-style. This wrapper holds altered versions of all the
  // underscore functions. Wrapped objects may be chained.

  // Helper function to continue chaining intermediate results.
  var result = function(instance, obj) {
    return instance._chain ? _(obj).chain() : obj;
  };

  // Add your own custom functions to the Underscore object.
  _.mixin = function(obj) {
    _.each(_.functions(obj), function(name) {
      var func = _[name] = obj[name];
      _.prototype[name] = function() {
        var args = [this._wrapped];
        push.apply(args, arguments);
        return result(this, func.apply(_, args));
      };
    });
  };

  // Add all of the Underscore functions to the wrapper object.
  _.mixin(_);

  // Add all mutator Array functions to the wrapper.
  _.each(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function(name) {
    var method = ArrayProto[name];
    _.prototype[name] = function() {
      var obj = this._wrapped;
      method.apply(obj, arguments);
      if ((name === 'shift' || name === 'splice') && obj.length === 0) delete obj[0];
      return result(this, obj);
    };
  });

  // Add all accessor Array functions to the wrapper.
  _.each(['concat', 'join', 'slice'], function(name) {
    var method = ArrayProto[name];
    _.prototype[name] = function() {
      return result(this, method.apply(this._wrapped, arguments));
    };
  });

  // Extracts the result from a wrapped and chained object.
  _.prototype.value = function() {
    return this._wrapped;
  };

  // Provide unwrapping proxy for some methods used in engine operations
  // such as arithmetic and JSON stringification.
  _.prototype.valueOf = _.prototype.toJSON = _.prototype.value;

  _.prototype.toString = function() {
    return '' + this._wrapped;
  };

  // AMD registration happens at the end for compatibility with AMD loaders
  // that may not enforce next-turn semantics on modules. Even though general
  // practice for AMD registration is to be anonymous, underscore registers
  // as a named module because, like jQuery, it is a base library that is
  // popular enough to be bundled in a third party lib, but not be part of
  // an AMD load request. Those cases could generate an error when an
  // anonymous define() is called outside of a loader request.
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function() {
      return _;
    }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
}.call(this));


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var GC = window.__GENERATED_CONSTANTS__;

var BASE_PATH = exports.BASE_PATH = GC.BASE_PATH;
var CURRENT_PRODUCT = exports.CURRENT_PRODUCT = GC.CURRENT_PRODUCT;
var isOlVersion = exports.isOlVersion = window.isOlVersion;
var isDemoVersion = exports.isDemoVersion = window.isDemoVersion;

var Product = exports.Product = {
    actiTIME: GC.Product.actiTIME,
    actiPLANS: GC.Product.actiPLANS
};

var UserHierarchyAssignmentType = exports.UserHierarchyAssignmentType = {
    WORK: GC.UserHierarchyAssignmentType.WORK,
    MANAGEMENT: GC.UserHierarchyAssignmentType.MANAGEMENT
};

var UserHierarchyAssignmentEntityType = exports.UserHierarchyAssignmentEntityType = {
    CUSTOMER: GC.UserHierarchyAssignmentEntityType.CUSTOMER,
    PROJECT: GC.UserHierarchyAssignmentEntityType.PROJECT,
    TASK: GC.UserHierarchyAssignmentEntityType.TASK
};

var CopyWorkAssignmentOptions = exports.CopyWorkAssignmentOptions = {
    APPEND: GC.CopyWorkAssignmentOptions.APPEND,
    OVERWRITE: GC.CopyWorkAssignmentOptions.OVERWRITE
};

var EntityType = exports.EntityType = {
    CUSTOMER: GC.EntityType.CUSTOMER,
    PROJECT: GC.EntityType.PROJECT,
    TASK: GC.EntityType.TASK
};

var BulkMoveTypes = exports.BulkMoveTypes = {
    TO_OPEN: GC.BulkMoveTypes.TO_OPEN,
    ARCHIVED_TO_ARCHIVED: GC.BulkMoveTypes.ARCHIVED_TO_ARCHIVED,
    OPEN_TO_ARCHIVED_WITH_COMPLETION: GC.BulkMoveTypes.OPEN_TO_ARCHIVED_WITH_COMPLETION,
    OPEN_TO_ARCHIVED_WITH_RESTORE: GC.BulkMoveTypes.OPEN_TO_ARCHIVED_WITH_RESTORE
};

var CustomersProjectsSelectionQualifier = exports.CustomersProjectsSelectionQualifier = {
    ALL: GC.CustomersProjectsSelectionQualifier.ALL,
    ALL_ACTIVE: GC.CustomersProjectsSelectionQualifier.ALL_ACTIVE,
    SELECTED: GC.CustomersProjectsSelectionQualifier.SELECTED
};

var AccessRights = exports.AccessRights = {
    MANAGE_USERS: GC.AccessRight.MANAGE_USERS,
    SUBMIT_OTHER_USER_TIME_TRACK: GC.AccessRight.SUBMIT_OTHER_USER_TIME_TRACK,
    EDIT_HIERARCHY: GC.AccessRight.EDIT_HIERARCHY,
    GENERATE_MONEY_REPORTS: GC.AccessRight.GENERATE_MONEY_REPORTS,

    SUBMIT_TIME_TRACK: GC.AccessRight.SUBMIT_TIME_TRACK,
    LOCK_TIME_TRACK: GC.AccessRight.LOCK_TIME_TRACK,
    MANAGE_PTO_AND_SICK: GC.AccessRight.MANAGE_PTO_AND_SICK,
    MANAGE_GENERAL_SETTINGS: GC.AccessRight.MANAGE_GENERAL_SETTINGS,
    MANAGE_LICENSE: GC.AccessRight.MANAGE_LICENSE,

    AP_MANAGE_GENERAL_SETTINGS: GC.AccessRight.ACCOUNT_SETTINGS_MANAGER
};

var UserManagementConstants = exports.UserManagementConstants = GC.UserManagementConstants;

var DEFAULT_TIME_ZONE_GROUP_ID = exports.DEFAULT_TIME_ZONE_GROUP_ID = GC.DEFAULT_TIME_ZONE_GROUP_ID;
var USERS_WITHOUT_GROUP_ID = exports.USERS_WITHOUT_GROUP_ID = GC.USERS_WITHOUT_GROUP_ID;
var DEFAULT_PERMISSIONS_TEMPLATE_ID = exports.DEFAULT_PERMISSIONS_TEMPLATE_ID = GC.DEFAULT_PERMISSIONS_TEMPLATE_ID;
var NON_BILLABLE_DEFAULT_TYPE_ID = exports.NON_BILLABLE_DEFAULT_TYPE_ID = window.__GENERATED_CONSTANTS__.NON_BILLABLE_DEFAULT_TYPE_ID;

var CalendarFrequencyType = exports.CalendarFrequencyType = {
    WEEKLY: GC.CalendarFrequencyType.WEEKLY,
    BIWEEKLY: GC.CalendarFrequencyType.BIWEEKLY,
    SEMI_MONTHLY: GC.CalendarFrequencyType.SEMI_MONTHLY,
    MONTHLY: GC.CalendarFrequencyType.MONTHLY,
    YEARLY: GC.CalendarFrequencyType.YEARLY,
    ON_HIRE_DATE: GC.CalendarFrequencyType.ON_HIRE_DATE,

    descriptionFor: GC.CalendarFrequencyType.descriptionFor,

    parametersFormatterFor: GC.CalendarFrequencyType.parametersFormatterFor
};

var ProductVersion = exports.ProductVersion = {
    isOlVersion: GC.ProductVersion.isOlVersion,
    isDemoVersion: GC.ProductVersion.isDemoVersion
};

var LicenseInfo = exports.LicenseInfo = {
    isAtActive: GC.LicenseInfo.isAtActive,
    isApActive: GC.LicenseInfo.isApActive
};

var PRODUCTS_INTEGRATED = exports.PRODUCTS_INTEGRATED = GC.PRODUCTS_INTEGRATED;

var LeaveBalanceCorrectionType = exports.LeaveBalanceCorrectionType = {
    ADD: GC.LeaveBalanceCorrectionType.ADD,
    SUB: GC.LeaveBalanceCorrectionType.SUB,
    SET: GC.LeaveBalanceCorrectionType.SET
};

var LeaveBalanceUnits = exports.LeaveBalanceUnits = {
    HOURS: GC.LeaveBalanceUnits.HOURS,
    DAYS: GC.LeaveBalanceUnits.DAYS
};

var LeaveTypeSelectionQualifier = exports.LeaveTypeSelectionQualifier = {
    ALL: GC.LeaveTypeSelectionQualifier.ALL,
    SELECTED: GC.LeaveTypeSelectionQualifier.SELECTED
};

var OTHER_USERS_ENTITY_ID = exports.OTHER_USERS_ENTITY_ID = GC.OTHER_USERS_ENTITY_ID;
var OTHER_USER_GROUPS_ENTITY_ID = exports.OTHER_USER_GROUPS_ENTITY_ID = GC.OTHER_USER_GROUPS_ENTITY_ID;

var HierarchyLevels = exports.HierarchyLevels = {
    CUSTOMER: "CUSTOMER",
    PROJECT: "PROJECT",
    TASK: "TASK"
};

var MAX_RATE = exports.MAX_RATE = GC.MAX_RATE;

var Pager = exports.Pager = {
    CUSTOM_PAGE_SET_2: [10, 25, 50, 100, 150]
};

var DateRangeSelectionQualifier = exports.DateRangeSelectionQualifier = {
    CURRENT_MONTH: GC.DateRangeSelectionQualifier.CURRENT_MONTH,
    CURRENT_MONTH_TILL_TODAY: GC.DateRangeSelectionQualifier.CURRENT_MONTH_TILL_TODAY,
    PREVIOUS_MONTH: GC.DateRangeSelectionQualifier.PREVIOUS_MONTH,
    NEXT_MONTH: GC.DateRangeSelectionQualifier.NEXT_MONTH,
    CURRENT_WEEK: GC.DateRangeSelectionQualifier.CURRENT_WEEK,
    CURRENT_WEEK_TILL_TODAY: GC.DateRangeSelectionQualifier.CURRENT_WEEK_TILL_TODAY,
    NEXT_WEEK: GC.DateRangeSelectionQualifier.NEXT_WEEK,
    PREVIOUS_WEEK: GC.DateRangeSelectionQualifier.PREVIOUS_WEEK,
    CURRENT_AND_PREVIOUS_WEEK: GC.DateRangeSelectionQualifier.CURRENT_AND_PREVIOUS_WEEK,
    CURRENT_AND_TWO_PREVIOUS_WEEKS: GC.DateRangeSelectionQualifier.CURRENT_AND_TWO_PREVIOUS_WEEKS,
    LAST_7_DAYS: GC.DateRangeSelectionQualifier.LAST_7_DAYS,
    LAST_14_DAYS: GC.DateRangeSelectionQualifier.LAST_14_DAYS,
    LAST_21_DAYS: GC.DateRangeSelectionQualifier.LAST_21_DAYS,
    CURRENT_YEAR: GC.DateRangeSelectionQualifier.CURRENT_YEAR,
    CURRENT_YEAR_TILL_TODAY: GC.DateRangeSelectionQualifier.CURRENT_YEAR_TILL_TODAY,
    PREVIOUS_YEAR: GC.DateRangeSelectionQualifier.PREVIOUS_YEAR,
    CURRENT_QUARTER: GC.DateRangeSelectionQualifier.CURRENT_QUARTER,
    PREVIOUS_QUARTER: GC.DateRangeSelectionQualifier.PREVIOUS_QUARTER,
    CUSTOM: GC.DateRangeSelectionQualifier.CUSTOM
};

var EvaDateQualifier = exports.EvaDateQualifier = {
    TODAY: GC.EvaDateQualifier.TODAY,
    YESTERDAY: GC.EvaDateQualifier.YESTERDAY,

    LAST_MONDAY: GC.EvaDateQualifier.LAST_MONDAY,
    LAST_TUESDAY: GC.EvaDateQualifier.LAST_TUESDAY,
    LAST_WEDNESDAY: GC.EvaDateQualifier.LAST_WEDNESDAY,
    LAST_THURSDAY: GC.EvaDateQualifier.LAST_THURSDAY,
    LAST_FRIDAY: GC.EvaDateQualifier.LAST_FRIDAY,
    LAST_SATURDAY: GC.EvaDateQualifier.LAST_SATURDAY,
    LAST_SUNDAY: GC.EvaDateQualifier.LAST_SUNDAY,

    END_OF_PREVIOUS_MONTH: GC.EvaDateQualifier.END_OF_PREVIOUS_MONTH,
    BEGINNING_OF_CURRENT_MONTH: GC.EvaDateQualifier.BEGINNING_OF_CURRENT_MONTH,

    CUSTOM: GC.EvaDateQualifier.CUSTOM
};

var SubmitTTFormConstants = exports.SubmitTTFormConstants = {
    ADD_TASKS_ACTION: GC.SubmitTTForm.ADD_TASKS_ACTION,
    HIGHLIGHT_TASKS_ACTION: GC.SubmitTTForm.HIGHLIGHT_TASKS_ACTION,
    REMOVE_DELETED_TASK: GC.SubmitTTForm.REMOVE_DELETED_TASK,
    ADD_ALL_PREVIOUS_WEEK_TASKS_ACTION: GC.SubmitTTForm.ADD_ALL_PREVIOUS_WEEK_TASKS_ACTION,
    ADD_REPORTED_PREVIOUS_WEEK_TASKS_ACTION: GC.SubmitTTForm.ADD_REPORTED_PREVIOUS_WEEK_TASKS_ACTION,
    SHOW_NEXT_READY_WEEK: GC.SubmitTTForm.SHOW_NEXT_READY_WEEK,
    SHOW_PREV_READY_WEEK: GC.SubmitTTForm.SHOW_PREV_READY_WEEK,
    ENTER_TT_RELOAD_ACTION: GC.SubmitTTForm.ENTER_TT_RELOAD_ACTION,
    REOPEN_TASK_ACTION: GC.SubmitTTForm.REOPEN_TASK_ACTION
};

var TimeApprovalStatus = exports.TimeApprovalStatus = {
    APPROVED: GC.TimeApprovalStatus.APPROVED,
    NOT_APPROVED: GC.TimeApprovalStatus.NOT_APPROVED,
    BOTH: GC.TimeApprovalStatus.BOTH
};

var TimeFormat = exports.TimeFormat = {
    DECIMAL: GC.TimeFormat.DECIMAL,
    TIME: GC.TimeFormat.TIME
};

var ReportConfigConstants = exports.ReportConfigConstants = {
    LEAVES_REPORT_ALL_SELECTED_LEAVES_DELETED: GC.ReportConfigConstants.LEAVES_REPORT_ALL_SELECTED_LEAVES_DELETED,
    NO_RIGHTS_FOR_MANAGING_PTO_AND_SICK: GC.ReportConfigConstants.NO_RIGHTS_FOR_MANAGING_PTO_AND_SICK,
    ALL_SELECTED_FOR_REPORT_USERS_WERE_DELETED: GC.ReportConfigConstants.ALL_SELECTED_FOR_REPORT_USERS_WERE_DELETED,
    ALL_SELECTED_FOR_REPORT_PROJECTS_ARE_UNAVAILABLE_OR_DELETED: GC.ReportConfigConstants.ALL_SELECTED_FOR_REPORT_PROJECTS_ARE_UNAVAILABLE_OR_DELETED,
    OVERTIME_FOR_ALL_SELECTED_USERS_WAS_DISABLED: GC.ReportConfigConstants.OVERTIME_FOR_ALL_SELECTED_USERS_WAS_DISABLED,
    NO_BILLABLE_TASKS: GC.ReportConfigConstants.NO_BILLABLE_TASKS,
    SAVED_REPORTS_PAGE_URL: GC.ReportConfigConstants.SAVED_REPORTS_PAGE_URL,
    REPORTS_DASHBOARD_URL: GC.ReportConfigConstants.REPORTS_DASHBOARD_URL
};

var StaffPerformanceColumnsConfig = exports.StaffPerformanceColumnsConfig = {
    USERS_ONLY: GC.StaffPerformanceColumnsConfig.USERS_ONLY,
    GROUPS_ONLY: GC.StaffPerformanceColumnsConfig.GROUPS_ONLY,
    USERS_BY_GROUPS_WITHOUT_SUBTOTALS: GC.StaffPerformanceColumnsConfig.USERS_BY_GROUPS_WITHOUT_SUBTOTALS,
    USERS_BY_GROUPS_WITH_SUBTOTALS: GC.StaffPerformanceColumnsConfig.USERS_BY_GROUPS_WITH_SUBTOTALS,
    TZ_GROUPS_ONLY: GC.StaffPerformanceColumnsConfig.TZ_GROUPS_ONLY,
    USERS_BY_TIME_ZONE_GROUPS_WITHOUT_SUBTOTALS: GC.StaffPerformanceColumnsConfig.USERS_BY_TIME_ZONE_GROUPS_WITHOUT_SUBTOTALS,
    USERS_BY_TIME_ZONE_GROUPS_WITH_SUBTOTALS: GC.StaffPerformanceColumnsConfig.USERS_BY_TIME_ZONE_GROUPS_WITH_SUBTOTALS
};

var BillingSummaryReportInfo = exports.BillingSummaryReportInfo = {
    TIME_ON_BILLABLE_TASKS: GC.BillingSummaryReportInfo.TIME_ON_BILLABLE_TASKS,
    TIME_ON_NON_BILLABLE_TASKS: GC.BillingSummaryReportInfo.TIME_ON_NON_BILLABLE_TASKS,
    TIME_ON_BOTH_BILLABLE_AND_NON_BILLABLE_TASKS: GC.BillingSummaryReportInfo.TIME_ON_BOTH_BILLABLE_AND_NON_BILLABLE_TASKS,
    BILLABLE_AMOUNT: GC.BillingSummaryReportInfo.BILLABLE_AMOUNT,
    BILLABLE_TIME_AND_BILLABLE_AMOUNT: GC.BillingSummaryReportInfo.BILLABLE_TIME_AND_BILLABLE_AMOUNT,
    BILLABLE_TIME_AND_BILLABLE_AMOUNT_WITH_AVERAGE_RATES: GC.BillingSummaryReportInfo.BILLABLE_TIME_AND_BILLABLE_AMOUNT_WITH_AVERAGE_RATES
};

var ReportColumnsFormatCostOfWork = exports.ReportColumnsFormatCostOfWork = {
    USERS_ONLY: GC.ReportColumnsFormatCostOfWork.USERS_ONLY,
    GROUPS_ONLY: GC.ReportColumnsFormatCostOfWork.GROUPS_ONLY,
    USERS_BY_GROUPS: GC.ReportColumnsFormatCostOfWork.USERS_BY_GROUPS
};

var ManagementAssignmentsSelection = exports.ManagementAssignmentsSelection = {
    SELECTED: GC.ManagementAssignmentsSelection.SELECTED,
    ALL: GC.ManagementAssignmentsSelection.ALL,
    NO: GC.ManagementAssignmentsSelection.NO
};

var WeekApprovalStatus = exports.WeekApprovalStatus = {
    NOT_READY: GC.WeekApprovalStatus.NOT_READY,
    READY: GC.WeekApprovalStatus.READY,
    APPROVED: GC.WeekApprovalStatus.APPROVED,
    REJECTED: GC.WeekApprovalStatus.REJECTED
};

var EntityTextLimits = exports.EntityTextLimits = {
    MAX_CPT_NAME: GC.EntityTextLimits.MAX_CPT_NAME,
    MAX_CPT_DESCRIPTION: GC.EntityTextLimits.MAX_CPT_DESCRIPTION,
    MAX_CPT_COMMENT: GC.EntityTextLimits.MAX_CPT_COMMENT,
    MAX_TT_COMMENT: GC.EntityTextLimits.MAX_TT_COMMENT,
    MAX_BILLING_TYPE_NAME: GC.EntityTextLimits.MAX_BILLING_TYPE_NAME,
    MAX_LEAVE_TYPE_NAME: GC.EntityTextLimits.MAX_LEAVE_TYPE_NAME,
    MAX_WORKFLOW_STATUS_NAME: GC.EntityTextLimits.MAX_WORKFLOW_STATUS_NAME,
    CUSTOM_FIELD_STRING_VALUE: 2000,
    MAX_PRIORITY_NAME: 80 //got from next: com.actitime.backend.app.modules.customfields.DropdownCustomFieldValidationSupplier#MAX_LENGTH
};

var PasswordPolicyLengthRange = exports.PasswordPolicyLengthRange = {
    MIN_PASSWORD_LENGTH: GC.PasswordValidators.MIN_PASSWORD_LENGTH,
    MAX_PASSWORD_LENGTH: GC.PasswordValidators.MAX_PASSWORD_LENGTH
};

var OvertimeTrackingLevel = exports.OvertimeTrackingLevel = {
    HIDDEN: GC.OvertimeTrackingLevel.HIDDEN,
    READONLY: GC.OvertimeTrackingLevel.READONLY,
    TRUSTED: GC.OvertimeTrackingLevel.TRUSTED
};

var ReportType = exports.ReportType = {
    STAFF_PERFORMANCE: GC.ReportType.STAFF_PERFORMANCE,
    OVERTIME: GC.ReportType.OVERTIME,
    LEAVE_TIME: GC.ReportType.LEAVE_TIME,
    TIME_TRACK_IN_DETAIL: GC.ReportType.TIME_TRACK_IN_DETAIL,
    ESTIMATED_VS_ACTUAL: GC.ReportType.ESTIMATED_VS_ACTUAL,

    BILLING_SUMMARY: GC.ReportType.BILLING_SUMMARY,
    INVOICING: GC.ReportType.INVOICING,
    COST_OF_WORK: GC.ReportType.COST_OF_WORK,
    PROFIT_LOSS: GC.ReportType.PROFIT_LOSS
};

var ReportChartType = exports.ReportChartType = {
    TOTAL_WORKING_HOURS: GC.ReportChartType.TOTAL_WORKING_HOURS,
    APPROVED_WORKING_HOURS: GC.ReportChartType.APPROVED_WORKING_HOURS,
    LEAVE_HOURS: GC.ReportChartType.LEAVE_HOURS,
    PTO_BALANCE: GC.ReportChartType.PTO_BALANCE,
    SICK_DAYS_BALANCE: GC.ReportChartType.SICK_DAYS_BALANCE,
    OVERTIME_HOURS: GC.ReportChartType.OVERTIME_HOURS,
    COST_OF_WORK: GC.ReportChartType.COST_OF_WORK,
    BILLABLE_AMOUNTS: GC.ReportChartType.BILLABLE_AMOUNTS
};

var ProductWebSiteURLs = exports.ProductWebSiteURLs = {
    CURRENT_PRODUCT_SITE_URL: GC.ProductWebSiteURLs.CURRENT_PRODUCT_SITE_URL,
    USER_GUIDE_URL: GC.ProductWebSiteURLs.USER_GUIDE_URL,
    QBI_INTEGRATOR_GUIDE_URL: GC.ProductWebSiteURLs.QBI_INTEGRATOR_GUIDE_URL,
    SERVICE_AGREEMENT_URL: GC.ProductWebSiteURLs.SERVICE_AGREEMENT_URL,
    DATA_PROCESSING_AGREEMENT_URL: GC.ProductWebSiteURLs.DATA_PROCESSING_AGREEMENT_URL,

    OTHER_PRODUCT_WEB_SITE_URL: GC.ProductWebSiteURLs.OTHER_PRODUCT_WEB_SITE_URL,
    OTHER_PRODUCT_SERVICE_AGREEMENT_URL: GC.ProductWebSiteURLs.OTHER_PRODUCT_SERVICE_AGREEMENT_URL,
    OTHER_PRODUCT_DATA_PROCESSING_AGREEMENT_URL: GC.ProductWebSiteURLs.OTHER_PRODUCT_DATA_PROCESSING_AGREEMENT_URL,
    OTHER_PRODUCT_INTEGRATION_URL: GC.ProductWebSiteURLs.OTHER_PRODUCT_INTEGRATION_URL
};

var RequestVerification = exports.RequestVerification = {
    FORM_INPUT_NAME: GC.RequestVerification.FORM_INPUT_NAME,
    FORM_INPUT_VALUE: GC.RequestVerification.FORM_INPUT_VALUE
};

var PRODUCT_SWITCHER_URL = exports.PRODUCT_SWITCHER_URL = GC.PRODUCT_SWITCHER_URL;

var TASK_MANAGEMENT_RELATIVE_PATH = exports.TASK_MANAGEMENT_RELATIVE_PATH = 'tasks/tasklist.do';
var REPORT_LOGO_PATH = exports.REPORT_LOGO_PATH = window.__GENERATED_CONSTANTS__.REPORT_LOGO_PATH;
var INTERFACE_LOGO_PATH = exports.INTERFACE_LOGO_PATH = window.__GENERATED_CONSTANTS__.INTERFACE_LOGO_PATH;

var EnterTT = exports.EnterTT = GC.EnterTT;

var Browser = exports.Browser = {
    CHROME: 'chrome',
    SAFARI: 'safari',
    EDGE: 'edge',
    IE: 'ie',
    FIREFOX: 'firefox',
    OPERA: 'opera',
    OTHER: 'other'
};

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.convertUsersFilterDependingOnFeatures = exports.SORT_ORDER = exports.isOrderFullyExistsAtTheBeginningOf = exports.getDiffOfSets = exports.filterSet = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.arrayToSet = arrayToSet;
exports.arrayToMap = arrayToMap;
exports.changeItemPosition = changeItemPosition;
exports.areUnorderedArraysEqual = areUnorderedArraysEqual;
exports.unorderedArraysDifference = unorderedArraysDifference;
exports.isArraysItemsOrderEqual = isArraysItemsOrderEqual;
exports.isArraysWithIdsItemsOrderEqual = isArraysWithIdsItemsOrderEqual;
exports.isMapsWithIdsItemsOrderEqual = isMapsWithIdsItemsOrderEqual;
exports.escapeHtmlSymbols = escapeHtmlSymbols;
exports.unescapeHtmlSymbols = unescapeHtmlSymbols;
exports.concatStr = concatStr;
exports.truncateStringByLength = truncateStringByLength;
exports.stringComparator = stringComparator;
exports.stringComparatorCaseSensitive = stringComparatorCaseSensitive;
exports.nameComparator = nameComparator;
exports.numberComparator = numberComparator;
exports.userGroupsComparator = userGroupsComparator;
exports.timeZoneGroupsComparator = timeZoneGroupsComparator;
exports.trim = trim;
exports.leadZero = leadZero;
exports.formatRawSecondsOffset = formatRawSecondsOffset;
exports.makeMapAndOrderForEntitiesArray = makeMapAndOrderForEntitiesArray;
exports.makeMapForEntitiesArray = makeMapForEntitiesArray;
exports.isEmailValid = isEmailValid;
exports.compareDates = compareDates;
exports.compareNullableStrDates = compareNullableStrDates;
exports.areDatesEqual = areDatesEqual;
exports.promisifyWithDelay = promisifyWithDelay;
exports.makeHandler = makeHandler;
exports.getStringWithUnifiedNewLineSymbol = getStringWithUnifiedNewLineSymbol;
exports.isNotEmpty = isNotEmpty;
exports.removeContextFromProductUrl = removeContextFromProductUrl;
exports.comparator = comparator;
exports.defer = defer;
exports.throttle = throttle;
exports.throttlePromise = throttlePromise;
exports.filterMapByKeys = filterMapByKeys;
exports.filterMapByKey = filterMapByKey;
exports.filterArrayByKeys = filterArrayByKeys;
exports.filterMapByPredicate = filterMapByPredicate;
exports.filterArrayByArrayOfIds = filterArrayByArrayOfIds;
exports.anyInSet = anyInSet;
exports.isInt = isInt;
exports.isPositiveInt = isPositiveInt;
exports.createArrayOfObjectFromMap = createArrayOfObjectFromMap;
exports.saveFileSupported = saveFileSupported;
exports.saveFile = saveFile;
exports.toggleElements = toggleElements;
exports.createAbsoluteLink = createAbsoluteLink;
exports.removeHashAndQueryFromLink = removeHashAndQueryFromLink;
exports.getCurrentRelativeLinkWithoutQuery = getCurrentRelativeLinkWithoutQuery;

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _urijs = __webpack_require__(340);

var _urijs2 = _interopRequireDefault(_urijs);

var _constants = __webpack_require__(4);

var _GroupType = __webpack_require__(34);

var _GroupType2 = _interopRequireDefault(_GroupType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Converts array of objects to set ([1, 5, 7] -> {1: true, 5: true, 7: true}.
 * @param {Array} array Array of objects to convert.
 */
function arrayToSet(array) {
    var set = {};
    array.forEach(function (item) {
        return set[item] = true;
    });
    return set;
}

function arrayToMap(array) {
    var keyMapper = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (item) {
        return item.id;
    };

    var map = {};
    array.forEach(function (item) {
        return map[keyMapper(item)] = item;
    });
    return map;
}

/**
 * Take set ({1: true, 2: false, 3: false}) and filter its keys by predicate
 */
var filterSet = exports.filterSet = function filterSet(set, predicate) {
    return Object.keys(set).filter(predicate).reduce(function (res, key) {
        return Object.assign(res, _defineProperty({}, key, set[key]));
    }, {});
};

var getDiffOfSets = exports.getDiffOfSets = function getDiffOfSets(before, after) {
    var added = {};
    var removed = {};

    Object.keys(before).forEach(function (key) {
        if (before[key] && !after[key]) removed[key] = true;
    });
    Object.keys(after).forEach(function (key) {
        if (after[key] && !before[key]) added[key] = true;
    });

    return {
        added: added,
        removed: removed
    };
};

/**
 * Move item after specified item in array. Use only with primitives.
 * @param {Array} array Array of primitives.
 * @param item Item to move.
 * @param insertAfterItem Item, after witch insert. If null or it not exist in array, insert at start
 */
function changeItemPosition(array, item, insertAfterItem) {
    var result = [].concat(_toConsumableArray(array));
    result.splice(array.indexOf(item), 1);
    var insertIndex = insertAfterItem === null ? 0 : result.indexOf(insertAfterItem) + 1;
    result.splice(insertIndex, 0, item);
    return result;
}

function areUnorderedArraysEqual(a1, a2) {
    if (a1.length !== a2.length) return false;
    var s1 = arrayToSet(a1);
    return a2.every(function (item) {
        return s1[item];
    });
}

function unorderedArraysDifference(before, after) {
    var beforeSet = arrayToSet(before);
    var afterSet = arrayToSet(after);

    var added = [];
    after.forEach(function (item) {
        if (!beforeSet[item]) {
            added.push(item);
        }
    });

    var removed = [];
    before.forEach(function (item) {
        if (!afterSet[item]) {
            removed.push(item);
        }
    });

    return { added: added, removed: removed };
}

function isArraysItemsOrderEqual(a1, a2) {
    return a1.length === a2.length && a1.every(function (item, index) {
        return item === a2[index];
    });
}

function isArraysWithIdsItemsOrderEqual(a1, a2) {
    return a1.length === a2.length && a1.every(function (item, index) {
        return item.id === a2[index].id;
    });
}

function isMapsWithIdsItemsOrderEqual(a1, a2) {
    return _underscore2.default.size(a1) === _underscore2.default.size(a2) && Object.keys(a1).every(function (item) {
        return a2.hasOwnProperty(item);
    });
}

var isOrderFullyExistsAtTheBeginningOf = exports.isOrderFullyExistsAtTheBeginningOf = function isOrderFullyExistsAtTheBeginningOf(array, tested) {
    var compFn = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (el1, el2) {
        return el1.id === el2.id;
    };

    return tested.length >= array.length && array.every(function (item, index) {
        return compFn(item, tested[index]);
    });
};

/**
 * Escapes &amp;, &gt;, &lt; and &quot; symbols to display str on a page.
 * Returns escaped string.
 */
function escapeHtmlSymbols(str) {
    if (str !== undefined && typeof str === "string") {
        return str.replace(/&/g, '&amp;').replace(/>/g, '&gt;').replace(/</g, '&lt;').replace(/"/g, '&quot;');
    }

    return "";
}

/**
 * Opposite to escapeHtmlSymbols
 * Replaces &amp;, &gt;, &lt; and &quot; with corresponding characters.
 * Returns new string.
 */
function unescapeHtmlSymbols(str) {
    if (str !== undefined && typeof str === "string") {
        return str.replace(/&amp;/g, '&').replace(/&gt;/g, '>').replace(/&lt;/g, '<').replace(/&quot;/g, '"').replace(/&#39;/g, "'");
    } else {
        return "";
    }
}

/**
 * Returns a concatenation of two passed strings. If any string is NULL,
 * the other one will be return. Returns NULL if both strings are NULL
 * @param stringA
 * @param stringB
 * @param delimiter
 */
function concatStr(stringA, stringB, delimiter) {
    var del = delimiter ? delimiter : "";
    if (stringB) stringA = stringA ? stringA + del + stringB : stringB;
    return stringA;
}

/**
 * Returns <code>maxLength</code> first symbols of <code>string</code>. If length of <code>string</code> is less then
 * <code>maxLength</code>, whole <code>string</code> will be returned.
 *
 * @param string the string to truncate
 * @param maxLength maximum length of returning string
 * @param ignoreSuffixLength specifies whether suffix should be assumed as a part of returning string. If false, then
 *        returning string will contains n = (maxLength - passedSuffix.length) first symbols of <code>string</code>
 *        and suffix. If true, then n = maxLength.
 *        [Optional] default : true
 * @param passedSuffix the string to be appended to returning string if string's length greater then maxLength.
 *        [Optional] default : "..."
 */
function truncateStringByLength(string, maxLength, ignoreSuffixLength, passedSuffix) {
    var suffix = passedSuffix ? passedSuffix : "...";
    var resultLength = ignoreSuffixLength ? maxLength : maxLength - suffix.length;

    if (string.length > maxLength) return string.substring(0, resultLength) + suffix;else return string;
}

/**
 * Compare two strings in case-insensitive alphabetic order. If supported, uses "en-US" locale.
 * @param a first string
 * @param b second string
 */
function stringComparator(a, b) {
    // set "en-US" locale for compare strings (it works only in modern browsers expect "safari") see bug #54120
    return a.toLocaleLowerCase().localeCompare(b.toLocaleLowerCase(), "en-US");
}

/**
 * Compare two strings in case-sensitive alphabetic order. If supported, uses "en-US" locale.
 * @param a first string
 * @param b second string
 */
function stringComparatorCaseSensitive(a, b) {
    // set "en-US" locale for compare strings (it works only in modern browsers expect "safari") see bug #54120
    return a.localeCompare(b, "en-US");
}

/**
 * Compare two entities with 'name' property by this property.
 * @param a first entity
 * @param b second entity
 */
function nameComparator(a, b) {
    return stringComparator(a.name, b.name);
}

/**
 * Compare two numbers
 * @param a first number
 * @param b second number
 */
function numberComparator(a, b) {
    return a - b;
}

function userGroupsComparator(g1, g2) {
    return groupsComparator(g1, g2, _constants.USERS_WITHOUT_GROUP_ID);
}

function timeZoneGroupsComparator(g1, g2) {
    return groupsComparator(g1, g2, _constants.DEFAULT_TIME_ZONE_GROUP_ID);
}

function groupsComparator(g1, g2, defaultGroupId) {
    if (g1.id === g2.id) return 0;
    if (g1.id === defaultGroupId) return -1;
    if (g2.id === defaultGroupId) return 1;
    return stringComparator(g1.name, g2.name);
}

/**
 * Function trims specified value
 * @param str - if str converted to boolean is false then empty string will be returned
 * @returns {String}
 */
function trim(str) {
    str = String(str);
    var whitespace = ' \n\r\t\f\x0B\xA0\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u200B\u2028\u2029\u3000';

    var lUk = void 0,
        rUk = void 0;
    for (lUk = 0; lUk < str.length; lUk++) {
        if (whitespace.indexOf(str.charAt(lUk)) === -1) break;
    }
    if (lUk === str.length) return '';

    for (rUk = str.length - 1;; rUk--) {
        if (whitespace.indexOf(str.charAt(rUk)) === -1) break;
    }

    return str.substring(lUk, rUk + 1);
}

function leadZero(n) {
    if (n < 10) return '0' + n;else return '' + n;
}

function formatRawSecondsOffset(rawSecondsOffset) {
    var absMinutesOffset = Math.abs(rawSecondsOffset) / 60;
    var offsetValue = Math.round(absMinutesOffset / 60 - absMinutesOffset % 60 / 60) + ":" + leadZero(absMinutesOffset % 60);
    return rawSecondsOffset < 0 ? '-' + offsetValue : "+" + offsetValue;
}

/**
 * Make map of id -> entity and array of its order in this map by array of entities with "id" property
 */
function makeMapAndOrderForEntitiesArray(array) {
    var map = {};
    var order = [];
    for (var i = 0; i < array.length; i++) {
        var id = array[i].id;
        map[id] = array[i];
        order.push(id);
    }
    return {
        map: map,
        order: order
    };
}

/**
 * Make map of id -> entity by array of entities with "id" property
 */
function makeMapForEntitiesArray(array) {
    var result = {};
    for (var i = 0; i < array.length; i++) {
        result[array[i].id] = array[i];
    }
    return result;
}

function isEmailValid(email) {
    var str = email.trim();
    var withoutWhitespaces = /^\S*$/.test(str);
    return withoutWhitespaces && /.+@.+/i.test(str);
}

/**
 * Compare two dates only by "date" part, excluding "time" part
 *
 * @param date1
 * @param date2
 * @return Number : negative if date1<date2, 0 if date1 == date2, positive if date1>date2 (only date, excluding time)
 */
function compareDates(date1, date2) {
    return date1.getFullYear() - date2.getFullYear() || date1.getMonth() - date2.getMonth() || date1.getDate() - date2.getDate();
}

function compareNullableStrDates(date1, date2) {
    if (!date1 && !date2) return 0;
    if (!date2) return -1;
    if (!date1) return 1;
    if (typeof date1 === 'string') date1 = Date.parseJSONDate(date1);
    if (typeof date2 === 'string') date2 = Date.parseJSONDate(date2);
    return compareDates(date1, date2);
}

/**
 * Compare two dates only by "date" part, excluding "time" part
 * @param date1
 * @param date2
 */
function areDatesEqual(date1, date2) {
    return date1.getFullYear() === date2.getFullYear() && date1.getMonth() === date2.getMonth() && date1.getDate() === date2.getDate();
}

function promisifyWithDelay(f) {
    var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;

    return function () {
        var args = arguments;
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                try {
                    var result = f.apply(null, args);
                    resolve(result);
                } catch (e) {
                    reject(e);
                }
            }, delay);
        });
    };
}
/**
 * Creates a handler that will call given function on given scope
 * @param f function
 * @param scope scope object
 */
function makeHandler(f, scope) {
    return function (event) {
        return f.call(scope, event);
    };
}

/*
 * Unifies new line symbol in the specified string. It is needed for unified string length determining in various
 * browsers, because in some browser (e.g. IE) new line symbol is '\r\n', but in others (e.g. Firefox) new line symbol
 * is '\n'. Because of these differences length of a string can vary in various browsers. To avoid differences this
 * function should be called before a string length determining.
 *
 * @param str a string where new line symbol should be unified.
 * @return string with unified new line symbol.
 */
function getStringWithUnifiedNewLineSymbol(str) {
    return str.replace(/(\r?\n)|(\r\n?)/g, '\r\n');
}

function isNotEmpty(str) {
    return trim(str).length > 0;
}

function removeContextFromProductUrl(productUrl) {
    return productUrl.substr(0, productUrl.lastIndexOf('/') + 1);
}

/**
 * Client sorting orders
 * @type {{ASC: string, DESC: string}}
 */

var SORT_ORDER = exports.SORT_ORDER = {
    ASC: "Asc",
    DESC: "Desc"

    /**
     * Get comparator function to sort object arrays by field values: arr.sort(comparator("name", ORDER.ASC))
     * @param field field to sort by. Should be number or strings values.
     * @param order order to sort
     * @return {function(*, *)} comparator function
     */

};function comparator(field, order) {
    return function (a, b) {
        var result = 0;
        if (a[field] < b[field]) {
            result = -1;
        } else if (a[field] > b[field]) {
            result = 1;
        }
        return order === SORT_ORDER.ASC ? result : -result;
    };
}

/**
 * Defers function execution, calling it after 10 ms (not 0 ms, necessary for certain browsers).
 * @param f Function to call.
 * @param context Function context (this).
 */
function defer(f, context) {
    if (context) return setTimeout(function () {
        f.apply(context);
    }, 10);else return setTimeout(f, 10);
}

function throttle(func, ms) {
    var isThrottled = false;
    var savedArgs = null;
    var savedContext = null;

    function wrapper() {
        if (isThrottled) {
            savedArgs = arguments;
            savedContext = this;
            return;
        }
        func.apply(this, arguments);
        isThrottled = true;
        setTimeout(function () {
            isThrottled = false;
            if (savedArgs) {
                wrapper.apply(savedContext, savedArgs);
                savedArgs = null;
                savedContext = null;
            }
        }, ms);
    }

    return wrapper;
}

function throttlePromise(func, ms) {
    var isThrottled = false;
    var savedArgs = null;
    var savedContext = null;
    var promiseResolve = void 0;
    var promiseReject = void 0;

    function wrapper() {
        if (isThrottled) {
            savedArgs = arguments;
            savedContext = this;
            return new Promise(function (resolve, reject) {
                promiseResolve = resolve;
                promiseReject = reject;
            });
        }
        isThrottled = true;

        setTimeout(function () {
            isThrottled = false;
            if (savedArgs) {
                wrapper.apply(savedContext, savedArgs).then(promiseResolve, promiseReject);
                savedArgs = null;
                savedContext = null;
            }
        }, ms);
        return func.apply(this, arguments);
    }

    return wrapper;
}

function filterMapByKeys(map, keys) {
    map = _extends({}, map);
    keys.forEach(function (key) {
        return delete map[key];
    });
    return map;
}

function filterMapByKey(map, key) {
    return filterMapByKeys(map, [key]);
}

function filterArrayByKeys(arr, keys) {
    var keyMapper = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (item) {
        return item;
    };

    var keysSet = arrayToSet(keys);
    return arr.filter(function (item) {
        return !keysSet[keyMapper(item)];
    });
}

function filterMapByPredicate(map, predicate) {
    var result = {};

    _underscore2.default.each(map, function (value, key) {
        if (predicate(value, key)) {
            result[key] = value;
        }
    });

    return result;
}

function filterArrayByArrayOfIds(array, ids) {
    var idsSet = arrayToSet(ids);
    return array.filter(function (item) {
        return !!idsSet[item.id];
    });
}

function anyInSet(set) {
    return Object.keys(set).some(function (element) {
        return set[element];
    });
}

function isInt(num) {
    return !isNaN(num) && parseInt(num) == parseFloat(num);
}

function isPositiveInt(num) {
    return !isNaN(num) && parseInt(num) == parseFloat(num) && parseInt(num) > 0;
}

function createArrayOfObjectFromMap(map, mapObjectFunc) {
    var keys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

    var array = [];

    if (keys.length === 0) {
        keys = Object.keys(map);
    }

    keys.forEach(function (key) {
        array.push(mapObjectFunc(key, map[key]));
    });

    return array;
}

/**
 * Converts string to bytes encoded in UTF-16LE
 * @param str String to convert.
 * @returns {ArrayBuffer}
 */
function stringToUTF16(str) {
    var buffer = new ArrayBuffer(str.length * 2);
    var bufferProxy = new Uint16Array(buffer);
    for (var i = 0; i < str.length; i++) {
        bufferProxy[i] = str.charCodeAt(i);
    }return buffer;
}

/**
 * Detects if browser supports saving files from client code.
 * @returns {boolean}
 */
function saveFileSupported() {
    return !!window.Blob;
}

/**
 * Saves file to local file system.
 * @param content String or byte buffer with file contents.
 * @param fileName Desired file name.
 * @param blobOptions Default implementation uses Blob for saving, here you can pass blob options such as encoding, type, etc.
 */
function saveFile(content, fileName, blobOptions) {
    if (window.Blob) {
        var utf16 = blobOptions.encoding.toLowerCase() === 'utf-16';
        var blobData = [];
        if (utf16) {
            blobData.push(new Uint8Array([0xFF, 0xFE]));
            if (_underscore2.default.isString(content)) content = stringToUTF16(content);
        }
        blobData.push(content);

        var blob = new Blob(blobData, blobOptions);
        // Use FileSaver.js library
        window.saveAs(blob, fileName);
    }
}

function toggleElements(jqueryElementsArray, toggle) {
    jqueryElementsArray.forEach(function ($el) {
        return $el.toggle(toggle);
    });
}

var convertUsersFilterDependingOnFeatures = exports.convertUsersFilterDependingOnFeatures = function convertUsersFilterDependingOnFeatures(usersFilter, ugrEnabled, tzgEnabled, availableUsers) {
    var selectedGroups = usersFilter.groupIds;

    if (selectedGroups && selectedGroups.length > 0) {
        if (!ugrEnabled && usersFilter.groupType === _GroupType2.default.USER_GROUP) {
            return convertGroupsForFilter(selectedGroups, availableUsers, usersFilter, function (groupId, user) {
                return groupId === user.userGroupId;
            });
        } else if (!tzgEnabled && usersFilter.groupType === _GroupType2.default.TIME_ZONE_GROUP) {
            return convertGroupsForFilter(selectedGroups, availableUsers, usersFilter, function (groupId, user) {
                return groupId === user.timeZoneGroupId;
            });
        }
    }

    return usersFilter;
};

var convertGroupsForFilter = function convertGroupsForFilter(selectedGroups, availableUsers, usersFilter) {
    var groupPredicate = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function (groupId, user) {};

    var userIdsFromGroups = availableUsers.filter(function (user) {
        return selectedGroups.some(function (groupId) {
            return groupPredicate(groupId, user);
        });
    }).map(function (user) {
        return user.id;
    });
    return _extends({}, usersFilter, {
        userIds: [].concat(_toConsumableArray(usersFilter.userIds), _toConsumableArray(userIdsFromGroups)),
        groupIds: [],
        groupType: null
    });
};

/**
 * Creates absolute link with preceding base path and query params.
 */
function createAbsoluteLink(path) {
    return (0, _urijs2.default)().pathname(_urijs2.default.joinPaths(window.BASE_PATH, path)).toString();
}

function removeHashAndQueryFromLink(path) {
    var urlObj = new URL(path);
    urlObj.hash = '';
    urlObj.search = '';

    return urlObj.toString();
}

/**
 * Get current relative link without context, query and hash. "/timetrack/enter.do"
 */
function getCurrentRelativeLinkWithoutQuery() {
    var absoluteLink = removeHashAndQueryFromLink(createAbsoluteLink(''));
    var windowHrefWithoutQuery = removeHashAndQueryFromLink(window.location.href);

    return windowHrefWithoutQuery.substring(absoluteLink.length - 1, windowHrefWithoutQuery.length);
}

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.createDeepEqualSelector = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.subscribeToStore = subscribeToStore;
exports.connect = connect;
exports.createActionObject = createActionObject;
exports.unsafe_selectWithState = unsafe_selectWithState;
exports.unsafe_bindActions = unsafe_bindActions;

var _store = __webpack_require__(222);

var _reselect = __webpack_require__(13);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function subscribeToStore(handler) {
    var _handler = function _handler() {
        return handler((0, _store.getStore)().getState());
    };
    (0, _store.getStore)().subscribe(_handler);
    _handler();
}

function connect() {
    var mapState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var mapDispatch = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
        return {};
    };

    return function (ContainerClass) {
        function ConnectedContainerClass(args) {
            var _this = this;

            ContainerClass.call(this, _extends({}, args, mapDispatch((0, _store.getStore)().dispatch)));

            if (mapState !== null) {
                subscribeToStore(function () {
                    _this.setState(mapState((0, _store.getStore)().getState()));
                });
            }
        }

        ConnectedContainerClass.prototype = Object.create(ContainerClass.prototype);
        ConnectedContainerClass.prototype.constructor = ConnectedContainerClass;
        ConnectedContainerClass.prototype.init = function () {
            ContainerClass.prototype.init.apply(this, arguments);
            this.callStateChangeHandlersWithCurrentState();
            return this;
        };

        return ConnectedContainerClass;
    };
}

/**
 * Creates simple object for dispatch to redux.
 * Simple version of operation performed with `redux-actions`: createAction(type)(data)
 * @param type dispatched type
 * @param [payload] action payload for reducers
 * @returns {{type: *, payload: *}}
 */
function createActionObject(type, payload) {
    return {
        type: type,
        payload: payload
    };
}

/**
 * !Attention
 * Use only for bind redux with old code.
 * @param selector - function that should take store as first argument and returns selected object
 */
function unsafe_selectWithState() {
    var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (state) {};

    return selector((0, _store.getStore)().getState());
}

/**
 * !Attention
 * !TODO May be the method is candidate for regular usage (https://github.com/Actimind-Development/actitime/issues/941)
 * Use only for bind redux actions in old code or if not impossible use `connect` method
 * @param actionsMapper function that calls with dispatch and return bind actions
 * @returns {*}
 */
function unsafe_bindActions(actionsMapper) {
    return actionsMapper((0, _store.getStore)().dispatch);
}

/**
 * Create deep equals selector using underscore _.isEqual instead of ===
 */
var createDeepEqualSelector = exports.createDeepEqualSelector = (0, _reselect.createSelectorCreator)(_reselect.defaultMemoize, _underscore2.default.isEqual);

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(643);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__combineReducers__ = __webpack_require__(1179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__ = __webpack_require__(1180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__ = __webpack_require__(1181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__compose__ = __webpack_require__(647);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_warning__ = __webpack_require__(646);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createStore", function() { return __WEBPACK_IMPORTED_MODULE_0__createStore__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "combineReducers", function() { return __WEBPACK_IMPORTED_MODULE_1__combineReducers__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "bindActionCreators", function() { return __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "applyMiddleware", function() { return __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "compose", function() { return __WEBPACK_IMPORTED_MODULE_4__compose__["a"]; });







/*
* This is a dummy function to check if the function name has been altered by minification.
* If the function has been minified and NODE_ENV !== 'production', warn the user.
*/
function isCrushed() {}

if (false) {
  warning('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
}



/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.copyToClipboard = exports.registerOnClickOutside = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.getBodyScrollLeft = getBodyScrollLeft;
exports.getBodyScrollTop = getBodyScrollTop;
exports.disableTextSelection = disableTextSelection;
exports.getCookie = getCookie;
exports.setCookie = setCookie;
exports.saveArrayIntoCookies = saveArrayIntoCookies;
exports.getArrayFromCookies = getArrayFromCookies;
exports.isLetterOrDigitSymbolPressed = isLetterOrDigitSymbolPressed;
exports.addClass = addClass;
exports.hasClass = hasClass;
exports.removeClass = removeClass;
exports.replaceClass = replaceClass;
exports.getEventObj = getEventObj;
exports.isKeyPressed = isKeyPressed;
exports.isTabPressed = isTabPressed;
exports.handleTab = handleTab;
exports.isEscapePressed = isEscapePressed;
exports.handleEscape = handleEscape;
exports.isEnterPressed = isEnterPressed;
exports.handleEnter = handleEnter;
exports.cancelBubble = cancelBubble;
exports.atImgPath = atImgPath;
exports.imgPath = imgPath;
exports.calculateCoords = calculateCoords;
exports.calculateObjectCoords = calculateObjectCoords;
exports.findPosX = findPosX;
exports.findPosY = findPosY;
exports.shiftTo = shiftTo;
exports.getClientSize = getClientSize;
exports.getObjectWidth = getObjectWidth;
exports.getObjectHeight = getObjectHeight;
exports.getInsideWindowWidth = getInsideWindowWidth;
exports.getInsideWindowHeight = getInsideWindowHeight;
exports.getViewport = getViewport;
exports.scrollToElementIfNeeded = scrollToElementIfNeeded;
exports.scrollWindowIfNeeded = scrollWindowIfNeeded;
exports.smoothlyScrollDownToElement = smoothlyScrollDownToElement;
exports.isMSIE = isMSIE;
exports.isIE8 = isIE8;
exports.showElementAt = showElementAt;
exports.onOutsideClick = onOutsideClick;
exports.fixIScrollInnerWheelEvent = fixIScrollInnerWheelEvent;
exports.setMouseDownOutsideHandler = setMouseDownOutsideHandler;
exports.calculateTooltipOffset = calculateTooltipOffset;
exports.calculateElementOffset = calculateElementOffset;
exports.calculateTooltipOffsetByItParameters = calculateTooltipOffsetByItParameters;
exports.doOnceOn = doOnceOn;
exports.doOnceOnWindowResize = doOnceOnWindowResize;
exports.whichButtonPressed = whichButtonPressed;
exports.preventDefault = preventDefault;
exports.setFocusIntoFieldWithPlaceholder = setFocusIntoFieldWithPlaceholder;
exports.scrollToElementInPopup = scrollToElementInPopup;
exports.enableTextSelectionBack = enableTextSelectionBack;
exports.createElement = createElement;
exports.createElementWithProperties = createElementWithProperties;
exports.assign = assign;
exports.checkAncestorHasClass = checkAncestorHasClass;
exports.checkElementOrAncestorHasClass = checkElementOrAncestorHasClass;
exports.px = px;
exports.getBrowser = getBrowser;

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _constants = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getBodyScrollLeft() {
    var scrollX = 0;
    if (document.body && !_underscore2.default.isUndefined(document.body.scrollLeft)) {
        scrollX += document.body.scrollLeft;
        if (document.body.parentNode && document.body.parentNode.scrollLeft && document.body.scrollLeft !== document.body.parentNode.scrollLeft) {
            scrollX += document.body.parentNode.scrollLeft;
        }
    } else if (window.pageXOffset) {
        scrollX += window.pageXOffset;
    }
    return scrollX;
}

function getBodyScrollTop() {
    var scrollY = 0;
    if (document.body && !_underscore2.default.isUndefined(document.body.scrollTop)) {
        scrollY += document.body.scrollTop;
        if (document.body.parentNode && document.body.parentNode.scrollTop && document.body.scrollTop !== document.body.parentNode.scrollTop) {
            scrollY += document.body.parentNode.scrollTop;
        }
    } else if (window.pageYOffset) {
        scrollY += window.pageYOffset;
    }
    return scrollY;
}

/**
 * Disables text selection in the specified element in IE and FF
 * @param element
 * @param dontChangeCursor
 */
function disableTextSelection(element, dontChangeCursor) {
    if (!element.aTDisabledSel) {
        element.prevOnselectstart = element.onselectstart;
        element.prevOndragstart = element.ondragstart;
        element.prevUnselectable = element.unselectable;
        element.prevMozUserSelect = element.style.MozUserSelect;
        element.prevCursor = element.style.cursor;

        element.onselectstart = function () {
            return false;
        };
        element.ondragstart = function () {
            return false;
        };
        element.unselectable = "on";
        element.style.MozUserSelect = "none";

        if (!dontChangeCursor) element.style.cursor = "default";

        element.aTDisabledSel = true;
    }
}

/**
 * Gets cookie value.
 * Note: return null if cookie not found or cookies disabled.
 *
 * @param name - cookie name
 * @return cookie value
 */
function getCookie(name) {
    var cookies = document.cookie.split('; ');
    for (var index = 0; index < cookies.length; index++) {
        var nameValPair = cookies[index].split('=');
        if (name === nameValPair[0]) return nameValPair[1];
    }
    return null;
}

/**
 * Saves value with specified cookie name.
 * Delete cookie if value is null.
 * Note: do nothing if cookies disabled.
 *
 * @param name - cookie name
 * @param value - saving value
 * @param path
 */
function setCookie(name, value, path) {
    //current time
    var expireDate = new Date();
    if (value !== null) {
        //current time + ~10 years
        expireDate = new Date(expireDate.getTime() + 310000000000);
    }
    document.cookie = [name, "=", value, ";expires=", expireDate.toGMTString(), path ? ";path=" + path : ""].join("");
}

/**
 * Save array of items in cookie in csv format.
 * If length of csv is larger than max cookie size then first items of array will be exclude from cookie
 * If cookies is disabled do nothing
 * @param arr array
 * @param cookieName name of key in cookie
 */
function saveArrayIntoCookies(arr, cookieName) {
    var COUNT_OF_DELETED_ITEMS = 10;

    var arrayStr = arr.join(",");
    setCookie(cookieName, arrayStr);

    // max length of cookie is about 4000 symbols only,
    // therefore should delete old ids to release place for new ids
    var savedValue = getCookie(cookieName);
    if (savedValue && savedValue !== arrayStr) {
        arr.splice(0, COUNT_OF_DELETED_ITEMS);
        saveArrayIntoCookies(arr, cookieName);
    }
}

/**
 * Return array of items from cookie(if in cookie it is stored in csv).
 * If cookies is disabled, returns empty array
 * @param cookieName name of key in cookie
 */
function getArrayFromCookies(cookieName) {
    var arrayStr = getCookie(cookieName);

    if (arrayStr === null) return [];else return arrayStr.split(",");
}

/**
 * Defines fact that letter or digit symbol is pressed by key code. If event has no key code returns false
 * @param event event
 */
function isLetterOrDigitSymbolPressed(event) {
    event = event || window.event;
    var keyCode = event.keyCode;
    if (!keyCode) return false;
    return keyCode > 32 && keyCode < 91;
}

/**
 * Adds a new class to element's classname. Duplicated classes are ignored.
 * No error checking is performed for input parameters.
 * @param element HTMLElement
 * @param className String
 */
function addClass(element, className) {
    if (!hasClass(element, className)) {
        if (!element.className) element.className = "";
        element.className = element.className + " " + className;
    }
}

/**
 * Checks is the element has specified CSS class. No error checking is performed for input parameters.
 * @param element HTMLElement
 * @param className String - CSS class name to check
 */
function hasClass(element, className) {
    return element.className && (' ' + element.className + ' ').indexOf(' ' + className + ' ') > -1;
}

/**
 * Removes the given class from the element.
 * If the element has no class with the given name, then does nothing.
 * @param element HTMLElement
 * @param className String name of the class to remove
 */
function removeClass(element, className) {
    replaceClass(element, className, null);
}

/**
 * Replaces one class with another for the given element.
 * If oldClass has not been added to the element, this method has no effect.
 * If newClass is null, undefined or of zero length, old class will just be removed.
 * No error checking is performed for input parameters.
 * @param element HTMLElement.
 * @param oldClass String Old CSS class name.
 * @param newClass String New CSS class name.
 */
function replaceClass(element, oldClass, newClass) {
    var newElClassName = ' ' + element.className + ' ';

    if (newClass && newClass.length > 0) newElClassName = newElClassName.replace(' ' + oldClass + ' ', ' ' + newClass + ' ');else newElClassName = newElClassName.replace(' ' + oldClass + ' ', ' ');

    if (newElClassName.charAt(0) === ' ') newElClassName = newElClassName.substr(1);
    if (newElClassName.length > 0 && newElClassName.charAt(newElClassName.length - 1) === ' ') newElClassName = newElClassName.substr(0, newElClassName.length - 1);

    element.className = newElClassName;
}

function getEventObj(evt) {
    var eventObj = null;

    if ((typeof evt === "undefined" ? "undefined" : _typeof(evt)) !== ( true ? "undefined" : _typeof(undefined)) && evt !== null) eventObj = evt;else if ((typeof event === "undefined" ? "undefined" : _typeof(event)) !== ( true ? "undefined" : _typeof(undefined)) && event !== null) eventObj = event;

    return eventObj;
}

/**
 * Determines whether keyboard button having the specified keyCode has been pressed or not.
 * @return true if keyboard button having the specified keyCode has been pressed and false otherwise.
 */
function isKeyPressed(keyCode, evt) {
    var eventObj = getEventObj(evt);

    if (eventObj !== null && eventObj.keyCode === keyCode) {
        if (document.all && navigator.userAgent.indexOf("Opera") === -1) {
            eventObj.returnValue = false;
        } else {
            eventObj.preventDefault();
        }

        return true;
    }

    return false;
}

/**
 * Determines whether TAB keyboard button has been pressed or not.
 * @return true if TAB has been pressed and false otherwise.
 */
function isTabPressed(evt) {
    return isKeyPressed(9, evt);
}

/**
 * Calls the specified handler if TAB keyboard button has been pressed.
 */
function handleTab(tabHandler, evt) {
    if (isTabPressed(evt)) {
        tabHandler();
    }
}

/**
 * Determines whether ESC keyboard button has been pressed or not.
 * @return true if ESC has been pressed and false otherwise.
 */
function isEscapePressed(evt) {
    return isKeyPressed(27, evt);
}

/**
 * Calls the specified handler if ESC keyboard button has been pressed.
 */
function handleEscape(escHandler, evt) {
    if (isEscapePressed(evt)) {
        escHandler(evt);
    }
}

/**
 * Determines whether ENTER keyboard button has been pressed or not.
 * @return true if ENTER has been pressed and false otherwise.
 */
function isEnterPressed(evt) {
    return isKeyPressed(13, evt);
}

/**
 * Calls the specified handler if ENTER keyboard button has been pressed.
 */
function handleEnter(enterHandler, evt) {
    if (isEnterPressed(evt)) {
        enterHandler(evt);
    }
}

/**
 * Cancel event bubbling in all browsers
 * @param event action event
 */
function cancelBubble(event) {
    event = event || window.event;
    event.cancelBubble = true;
}

function atImgPath(relativePath) {
    return window.AT_IMAGE_PATH + "default/" + relativePath + "?hash=" + window.HASH;
}

function imgPath(relativePath) {
    return window.IMAGE_PATH + "default/" + relativePath + "?hash=" + window.HASH;
}

function calculateCoords(event) {
    var targetEl = event.srcElement;
    if (!targetEl) targetEl = event.target;
    return calculateObjectCoords(targetEl);
}

function calculateObjectCoords(obj) {
    return { x: findPosX(obj), y: findPosY(obj) };
}

function findPosX(obj) {
    var curleft = 0;
    if (obj.offsetParent) {
        while (obj.offsetParent) {
            curleft += obj.offsetLeft;
            obj = obj.offsetParent;
        }
        curleft += obj.offsetLeft;
    } else if (obj.x) curleft += obj.x;
    return curleft;
}

function findPosY(obj) {
    var curtop = 0;
    if (obj.offsetParent) {
        while (obj.offsetParent) {
            curtop += obj.offsetTop;
            obj = obj.offsetParent;
        }
        curtop += obj.offsetTop;
    } else if (obj.y) curtop += obj.y;
    return curtop;
}

function shiftTo(obj, x, y, isOriginAtBottom) {
    var units = typeof obj.style.left === "string" ? "px" : 0;

    obj.style.left = x + units;

    if (isOriginAtBottom) obj.style.top = y - getObjectHeight(obj.id) + units;else obj.style.top = y + units;
}

/**
 * Return client size
 */
function getClientSize() {
    return [getInsideWindowWidth() + getBodyScrollLeft(), getInsideWindowHeight() + getBodyScrollTop()];
}

/**
 * Retrieve the rendered width of an element
 * @param objId
 * @return {Number}
 */
function getObjectWidth(objId) {
    var elem = document.getElementById(objId);
    var result = 0;
    if (elem.offsetWidth) result = elem.offsetWidth;else if (elem.clip && elem.clip.width) result = elem.clip.width;else if (elem.style && elem.style.pixelWidth) result = elem.style.pixelWidth;
    return parseInt(result, 10);
}

/**
 * Retrieve the rendered height of an element
 * @param obj_id
 * @return {Number}
 */
function getObjectHeight(obj_id) {
    var elem = document.getElementById(obj_id);
    var result = 0;
    if (elem.offsetHeight) result = elem.offsetHeight;else if (elem.clip && elem.clip.height) result = elem.clip.height;else if (elem.style && elem.style.pixelHeight) result = elem.style.pixelHeight;
    return parseInt(result, 10);
}

/**
 * Return the available content width space in browser window
 * Note: under Firefox, Safari & Opera the scroller width will be included.
 */
function getInsideWindowWidth() {
    if (window.innerWidth) return window.innerWidth;else if (document.documentElement && document.documentElement.clientWidth) return document.documentElement.clientWidth;else if (document.body && document.body.clientWidth) return document.body.clientWidth;else if (document.body && document.body.parentElement) return document.body.parentElement.clientWidth;
    return 0;
}

/**
 * Return the available content height space in browser window
 * Note: under Safari & Opera the scroller height will be included.
 */
function getInsideWindowHeight() {
    if (window.innerHeight) return window.innerHeight;else if (document.documentElement && document.documentElement.clientHeight) return document.documentElement.clientHeight;else if (document.body && document.body.clientHeight) return document.body.clientHeight;else if (document.body && document.body.parentElement) return document.body.parentElement.clientHeight;
    return 0;
}

function getViewport() {
    var scrollLeft = getBodyScrollLeft();
    var scrollTop = getBodyScrollTop();
    return {
        leftUpperCorner: { x: scrollLeft, y: scrollTop },
        rightBottomCorner: { x: scrollLeft + getInsideWindowWidth(), y: scrollTop + getInsideWindowHeight() }
    };
}

function scrollToElementIfNeeded(element) {
    var elementOffsetLeft = findPosX(element);
    var elementOffsetTop = findPosY(element);
    var leftUpperCorner = { x: elementOffsetLeft, y: elementOffsetTop };
    var rightBottomCorner = { x: elementOffsetLeft + element.clientWidth, y: elementOffsetTop + element.clientHeight };
    var viewport = getViewport();
    var viewportLeftUpperCorner = viewport.leftUpperCorner;
    var viewportRightBottomCorner = viewport.rightBottomCorner;

    var spacing = document.body.clientHeight / 3; // to create a space between element and window border
    var scrollY = 0;
    if (rightBottomCorner.y > viewportRightBottomCorner.y) scrollY = rightBottomCorner.y + spacing - viewportRightBottomCorner.y;else if (leftUpperCorner.y < viewportLeftUpperCorner.y) scrollY = leftUpperCorner.y - (viewportLeftUpperCorner.y + spacing);
    if (scrollY !== 0) window.scrollBy(0, scrollY);
}

function scrollWindowIfNeeded(object, alignRight) {
    var $object = (0, _jquery2.default)(object);
    var objectOffsetLeft = findPosX(object);
    var objectOffsetTop = findPosY(object);
    var leftUpperCorner = { x: objectOffsetLeft, y: objectOffsetTop };
    var rightBottomCorner = { x: objectOffsetLeft + $object.outerWidth(true), y: objectOffsetTop + $object.outerHeight(true) };
    var viewport = getViewport();
    var viewportLeftUpperCorner = viewport.leftUpperCorner;
    var viewportRightBottomCorner = viewport.rightBottomCorner;

    var scrollX = 0;
    if (leftUpperCorner.x < viewportLeftUpperCorner.x) {
        scrollX = leftUpperCorner.x - viewportLeftUpperCorner.x;
    } else if (alignRight && rightBottomCorner.x > viewportRightBottomCorner.x) {
        scrollX = rightBottomCorner.x - viewportRightBottomCorner.x;
    }

    var scrollY = 0;
    if (rightBottomCorner.y > viewportRightBottomCorner.y) scrollY = rightBottomCorner.y - viewportRightBottomCorner.y;

    if (scrollX !== 0 || scrollY !== 0) {
        /*alert("VIEWPORT\ntop-left.x = " + viewportLeftUpperCorner.x + ", top-left.y = " + viewportLeftUpperCorner.y +
              "; bottom-right.x = " + viewportRightBottomCorner.x + ", bottom-right.y = " + viewportRightBottomCorner.y + "\n\n" +
              "object\ntop-left.x = " + leftUpperCorner.x + ", top-left.y = " + leftUpperCorner.y +
              "; bottom-right.x = " + rightBottomCorner.x + ", bottom-right.y = " + rightBottomCorner.y + "\n\n" +
              "SCROLL BY\nscrollX = " + scrollX + ", scrollY = " + scrollY);*/
        window.scrollBy(scrollX, scrollY);
    }
}

/**
 * Smoothly scrolls the window down so that the needed element is fully visible.
 * Only scrolls down, doesn't scroll up even if the element is not visible.
 * Requires jQuery.
 *
 * @param element element to scroll to (either an element, selector or jQuery object)
 * @param [offset] how many pixels should be between the element bottom and the window bottom. Default is 0.
 * @param [duration] how long the animation will take. If not specified, then jQuery default is used.
 */
function smoothlyScrollDownToElement(element, offset, duration) {
    element = (0, _jquery2.default)(element);

    if (_underscore2.default.isUndefined(offset)) offset = 0;

    var initialScrollTop = (0, _jquery2.default)(document).scrollTop();
    var scrollTopChange = Math.max(0, -initialScrollTop + element.offset().top + element.outerHeight() - (0, _jquery2.default)(window).height() + offset);

    (0, _jquery2.default)("body,html").animate({ scrollTop: initialScrollTop + scrollTopChange }, duration);

    // Although we can use scrollTop() method on $(document), animate() doesn't work on it.
    // Instead, we use animate() on body and html elements (some browsers require body and some html).
}

function isMSIE() {
    // This is the same logic as in RequestUtil.isIEUserAgent.
    // If you change here, be sure to also change there.
    return navigator.userAgent.indexOf("Trident") !== -1;
}

function isIE8() {
    return navigator.userAgent.toLowerCase().indexOf("msie 8") > -1;
}

/**
 * Show jQuery element at position with positionParams.
 * If part of the element is shown outside left or top border of the document, try to fix it by changing collision parameter
 */
function showElementAt(element, positionParams) {
    var pos = {};
    pos.of = positionParams.of;
    pos.my = positionParams.my ? positionParams.my : "left top";
    pos.at = positionParams.at ? positionParams.at : "left bottom";
    pos.offset = positionParams.offset;
    var col = (positionParams.collision ? positionParams.collision : "flip").split(" ");
    pos.horCollision = col[0];
    pos.vertCollision = col[col.length - 1];

    pos.collision = pos.horCollision + " " + pos.vertCollision;

    pos.within = positionParams.within ? positionParams.within : (0, _jquery2.default)(window);
    element.position(pos);

    var offset = element.offset();
    if (offset.left < 0 && pos.horCollision !== "none" || offset.top < 0 && pos.vertCollision !== "none") {
        if (offset.left < 0) pos.horCollision = "none";
        if (offset.top < 0) pos.vertCollision = "none";

        pos.collision = pos.horCollision + " " + pos.vertCollision;
        element.position(pos);
    }
}

/**
 * Subscribes element to outside click event.
 * @param $el Element.
 * @param eventNamespace Click event namespace to prevent unwanted unsubscribing.
 * @param clickHandler Click handler.
 * @param ignoreEventPredicate Custom ignore predicate, when it returns true, click handler doesn't trigger.
 * @param $outsideContainer outside element, where outside clicks are handled. Default value - document body
 *
 * @returns string registered event name
 */
function onOutsideClick($el, eventNamespace, clickHandler, ignoreEventPredicate, $outsideContainer) {
    var eventName = "click." + eventNamespace;
    if (!$outsideContainer) $outsideContainer = (0, _jquery2.default)(document);
    $outsideContainer.off(eventName).on(eventName, function (e) {
        if (ignoreEventPredicate(e) || e.target === document.body || $el.is(e.target) || $el.has(e.target).length > 0) return;

        clickHandler(e);
    });

    return eventName;
}

var registerOnClickOutside = exports.registerOnClickOutside = function registerOnClickOutside($el, eventNamespace, clickHandler) {
    var ignoreEventPredicate = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function () {
        return false;
    };
    var $outsideContainer = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : (0, _jquery2.default)(document);


    var eName = onOutsideClick($el, eventNamespace, clickHandler, ignoreEventPredicate, $outsideContainer);
    return function () {
        $outsideContainer.off(eName);
    };
};
/**
 * Fixes wheel event for elements, which are located inside iScroll containers.
 * @param $el Inner element with native scroll.
 */
function fixIScrollInnerWheelEvent($el) {
    $el.on("wheel mousewheel DOMMouseScroll", function (e) {
        var el = $el[0];
        if (el.clientHeight < el.scrollHeight) e.stopPropagation();
    });
}

/**
 * Sets the handler for clicking outside an element.
 * Requires jQuery.
 *
 * TODO: there must be a way to unset the handler. This function should store the actual handler (not the given one,
 *       but the one which is dynamically created and attached to the document mousedown) in the given elements data()
 *       property. This would allow the creation of the 'unsetMouseDownOutsideHandler' function, which would get the
 *       actual handler from the element's data() and unset it from the document.
 *
 * TODO: seems that this handler is actually for clicking outside the _children_ of the element.
 *       So if I click inside the element but outside any of its children, the handler won't be executed.
 *
 * @param element - an element, selector or jQuery object
 * @param handler - function
 */
function setMouseDownOutsideHandler(element, handler) {
    element = (0, _jquery2.default)(element);

    (0, _jquery2.default)(document).mousedown(function (event) {
        if ((0, _jquery2.default)(event.target).parents().index(element) === -1) {
            handler(event);
        }
    });
}

function calculateTooltipOffset(tooltip, event, bottomBarHeight) {
    return calculateTooltipOffsetByItParameters(tooltip.getHeight(), tooltip.getWidth(), event, bottomBarHeight);
}

function calculateElementOffset(height, width, event, bottomBarHeight) {
    return calculateTooltipOffsetByItParameters(height, width, event, bottomBarHeight);
}

function calculateTooltipOffsetByItParameters(tooltipHeight, tooltipWidth, event, bottomBarHeight) {
    var bottomBarHeightValue = bottomBarHeight ? bottomBarHeight : 0;
    var top = event.pageY + 5;
    if (top + tooltipHeight + bottomBarHeightValue - getBodyScrollTop() > (0, _jquery2.default)(window).height()) top -= tooltipHeight;
    var left = event.pageX + 15;
    if (left + tooltipWidth - getBodyScrollLeft() > (0, _jquery2.default)(window).width()) left -= tooltipWidth + 22;
    return { top: top, left: left };
}

function doOnceOn(element, actionName, callback) {
    var handler = function handler() {
        callback();
        (0, _jquery2.default)(element).off(actionName, handler);
    };
    (0, _jquery2.default)(element).on(actionName, handler);
    return function () {
        (0, _jquery2.default)(element).off(actionName, handler);
    };
}

function doOnceOnWindowResize(callback) {
    return doOnceOn(window, "resize", callback);
}

/**
 * Determines which mouse button was pressed.
 * @param event - the event object from the onmousedown event handler (it may work in some other events, too)
 */
function whichButtonPressed(event) {
    if (event.which === null) {
        // IE case
        return event.button < 2 ? "left" : event.button === 4 ? "middle" : "right";
    } else {
        // All others
        return event.which < 2 ? "left" : event.which === 2 ? "middle" : "right";
    }
}

/**
 * Prevent event in all browsers
 * @param event action event
 */
function preventDefault(event) {
    event = event || window.event;
    event.preventDefault ? event.preventDefault() : event.returnValue = false;
}

function setFocusIntoFieldWithPlaceholder(field) {
    if (!isMSIE()) // IE hides placeholder on focus, so we don't autofocus in IE
        (0, _jquery2.default)(field).focus();
}

function scrollToElementInPopup(scrollableContainer, element) {
    var popupOffset = scrollableContainer.offset().top;
    var popupHeight = scrollableContainer.height();
    var windowScroll = (0, _jquery2.default)(window).scrollTop();
    var windowFullHeight = window.innerHeight + windowScroll;

    var elementHeight = element.height();
    var marginTop = element.position().top;
    var marginBottom = popupHeight - marginTop - elementHeight;

    //container fully visible in window frame.
    if (popupOffset > windowScroll && popupHeight + popupOffset < windowFullHeight) {
        //element is not fully visible in container
        if (marginTop < 0 || marginBottom < 0) {
            var scrollPosition = scrollableContainer.scrollTop();
            scrollableContainer.scrollTop(scrollPosition + marginTop);
        }
    } else {
        var elementTopOffset = marginTop + popupOffset;

        //element is not fully visible in window
        if (elementTopOffset < windowScroll || elementTopOffset + elementHeight > windowFullHeight) {
            //double scroll to element.
            element[0].scrollIntoView(true);
        }
    }
}

function enableTextSelectionBack(element) {
    if (element.aTDisabledSel) {
        element.onselectstart = element.prevOnselectstart;
        element.ondragstart = element.prevOndragstart;
        element.unselectable = element.prevUnselectable;
        element.style.MozUserSelect = element.prevMozUserSelect;
        element.style.cursor = element.prevCursor;
        element.aTDisabledSel = false;
    }
}

function createElement(tagName) {
    return document.createElement(tagName);
}

function createElementWithProperties(tagName, properties) {
    var element = createElement(tagName);
    for (var key in properties) {
        assign(element, key, properties[key]);
    }
    return element;
}

function assign(obj, compositeKey, value) {
    var keyParts = compositeKey.split(".");
    var lastKeyIndex = keyParts.length - 1;
    for (var i = 0; i < lastKeyIndex; i++) {
        var key = keyParts[i];
        if (!(key in obj)) {
            obj[key] = {};
        }
        obj = obj[key];
    }
    obj[keyParts[lastKeyIndex]] = value;
}

function checkAncestorHasClass(node, className) {
    var nextParent = node.parentNode;
    while (nextParent && nextParent !== document) {
        if (nextParent.classList.contains(className)) {
            return true;
        }
        nextParent = nextParent.parentNode;
    }
    return false;
}

function checkElementOrAncestorHasClass(element, className) {
    return element.classList.contains(className) || checkAncestorHasClass(element, className);
}

/**
 * Copy text to clipboard via creating temporary input
 * @param text for copy
 * @param onCopy callback after copy
 */
var copyToClipboard = exports.copyToClipboard = function copyToClipboard(text) {
    var onCopy = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};

    var input = document.createElement('input');
    input.setAttribute('value', text);
    document.body.appendChild(input);
    input.select();
    var result = document.execCommand('copy');
    document.body.removeChild(input);
    onCopy(result);
};

/**
 * Converts size to CSS pixel size string (for example, 15 to "15px")
 * @param size Size in pixels.
 */
function px(size) {
    return size + 'px';
}

/**
 * Determines which browser is used
 */
function getBrowser() {
    var sUsrAg = navigator.userAgent.toLowerCase();

    //The order matters here, and this may report false positives for unlisted browsers.
    if (sUsrAg.indexOf("firefox") > -1) {
        return _constants.Browser.FIREFOX;
    } else if (sUsrAg.indexOf("opera") > -1) {
        return _constants.Browser.OPERA;
    } else if (sUsrAg.indexOf("trident") > -1) {
        return _constants.Browser.IE;
    } else if (sUsrAg.indexOf("edge") > -1 || sUsrAg.indexOf("edg") > -1) {
        return _constants.Browser.EDGE;
    } else if (sUsrAg.indexOf("chrome") > -1) {
        return _constants.Browser.CHROME;
    } else if (sUsrAg.indexOf("safari") > -1) {
        return _constants.Browser.SAFARI;
    } else {
        return _constants.Browser.OTHER;
    }
}

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createAction__ = __webpack_require__(649);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__handleAction__ = __webpack_require__(650);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__handleActions__ = __webpack_require__(1219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__combineActions__ = __webpack_require__(660);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__createActions__ = __webpack_require__(1222);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createAction", function() { return __WEBPACK_IMPORTED_MODULE_0__createAction__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createActions", function() { return __WEBPACK_IMPORTED_MODULE_4__createActions__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "handleAction", function() { return __WEBPACK_IMPORTED_MODULE_1__handleAction__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "handleActions", function() { return __WEBPACK_IMPORTED_MODULE_2__handleActions__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "combineActions", function() { return __WEBPACK_IMPORTED_MODULE_3__combineActions__["b"]; });








/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(35);
var core = __webpack_require__(37);
var hide = __webpack_require__(87);
var redefine = __webpack_require__(74);
var ctx = __webpack_require__(112);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var GC = window.__GENERATED_CONSTANTS__;

var ReportGroupingLevel = exports.ReportGroupingLevel = {
    NONE: GC.ReportGroupingLevel.NONE,

    USER: GC.ReportGroupingLevel.USER,
    USER_GROUP: GC.ReportGroupingLevel.USER_GROUP,
    TIME_ZONE_GROUP: GC.ReportGroupingLevel.TIME_ZONE_GROUP,
    LEAVE_TYPE: GC.ReportGroupingLevel.LEAVE_TYPE,
    USER_RATE: GC.ReportGroupingLevel.USER_RATE,

    CUSTOMER: GC.ReportGroupingLevel.CUSTOMER,
    PROJECT: GC.ReportGroupingLevel.PROJECT,
    PROJECT_NAME: GC.ReportGroupingLevel.PROJECT_NAME,
    TASK: GC.ReportGroupingLevel.TASK,
    TASK_NAME: GC.ReportGroupingLevel.TASK_NAME,

    BILLING_TYPE: GC.ReportGroupingLevel.BILLING_TYPE,

    TT_COMMENTS: GC.ReportGroupingLevel.TT_COMMENTS,

    TASK_AND_TT_COMMENTS: GC.ReportGroupingLevel.TASK_AND_TT_COMMENTS,
    PROJECT_AND_TT_COMMENTS: GC.ReportGroupingLevel.PROJECT_AND_TT_COMMENTS,
    CUSTOMER_AND_TT_COMMENTS: GC.ReportGroupingLevel.CUSTOMER_AND_TT_COMMENTS,

    DATE: GC.ReportGroupingLevel.DATE,
    WEEK: GC.ReportGroupingLevel.WEEK,
    MONTH: GC.ReportGroupingLevel.MONTH
};

var ReportType = exports.ReportType = {
    STAFF_PERFORMANCE: GC.ReportType.STAFF_PERFORMANCE,
    OVERTIME: GC.ReportType.OVERTIME,
    LEAVE_TIME: GC.ReportType.LEAVE_TIME,
    TIME_TRACK_IN_DETAIL: GC.ReportType.TIME_TRACK_IN_DETAIL,
    ESTIMATED_VS_ACTUAL: GC.ReportType.ESTIMATED_VS_ACTUAL,
    WORK_STATUSES: 'WORK_STATUSES',
    TIME_CARDS: 'TIME_CARDS',
    TIME_TRACK: 'NEW_TIME_TRACK',

    BILLING_SUMMARY: GC.ReportType.BILLING_SUMMARY,
    INVOICING: GC.ReportType.INVOICING,
    COST_OF_WORK: GC.ReportType.COST_OF_WORK,
    PROFIT_LOSS: GC.ReportType.PROFIT_LOSS,

    CUSTOM_FIELDS: 'CUSTOM_FIELDS'
};

var ReportChartType = exports.ReportChartType = {
    TOTAL_WORKING_HOURS: GC.ReportChartType.TOTAL_WORKING_HOURS,
    APPROVED_WORKING_HOURS: GC.ReportChartType.APPROVED_WORKING_HOURS,
    LEAVE_HOURS: GC.ReportChartType.LEAVE_HOURS,
    PTO_BALANCE: GC.ReportChartType.PTO_BALANCE,
    SICK_DAYS_BALANCE: GC.ReportChartType.SICK_DAYS_BALANCE,
    OVERTIME_HOURS: GC.ReportChartType.OVERTIME_HOURS,
    COST_OF_WORK: GC.ReportChartType.COST_OF_WORK,
    BILLABLE_AMOUNTS: GC.ReportChartType.BILLABLE_AMOUNTS
};

var ChartType = exports.ChartType = {
    VERTICAL_BAR: GC.ChartType.VERTICAL_BAR,
    HORIZONTAL_BAR: GC.ChartType.HORIZONTAL_BAR,
    PIE_CHART: GC.ChartType.PIE_CHART
};

var ChartSortOptions = exports.ChartSortOptions = {
    ALPHABETICALLY: GC.ChartSortOptions.ALPHABETICALLY,
    BY_VALUES: GC.ChartSortOptions.BY_VALUES,
    CHRONOLOGICALLY: GC.ChartSortOptions.CHRONOLOGICALLY
};

var ChartColor = exports.ChartColor = GC.ChartColor;

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var Ext = window.Ext;
exports.default = Ext;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.defaultMemoize = defaultMemoize;
exports.createSelectorCreator = createSelectorCreator;
exports.createStructuredSelector = createStructuredSelector;
function defaultEqualityCheck(a, b) {
  return a === b;
}

function areArgumentsShallowlyEqual(equalityCheck, prev, next) {
  if (prev === null || next === null || prev.length !== next.length) {
    return false;
  }

  // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.
  var length = prev.length;
  for (var i = 0; i < length; i++) {
    if (!equalityCheck(prev[i], next[i])) {
      return false;
    }
  }

  return true;
}

function defaultMemoize(func) {
  var equalityCheck = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultEqualityCheck;

  var lastArgs = null;
  var lastResult = null;
  // we reference arguments instead of spreading them for performance reasons
  return function () {
    if (!areArgumentsShallowlyEqual(equalityCheck, lastArgs, arguments)) {
      // apply arguments instead of spreading for performance.
      lastResult = func.apply(null, arguments);
    }

    lastArgs = arguments;
    return lastResult;
  };
}

function getDependencies(funcs) {
  var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;

  if (!dependencies.every(function (dep) {
    return typeof dep === 'function';
  })) {
    var dependencyTypes = dependencies.map(function (dep) {
      return typeof dep;
    }).join(', ');
    throw new Error('Selector creators expect all input-selectors to be functions, ' + ('instead received the following types: [' + dependencyTypes + ']'));
  }

  return dependencies;
}

function createSelectorCreator(memoize) {
  for (var _len = arguments.length, memoizeOptions = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    memoizeOptions[_key - 1] = arguments[_key];
  }

  return function () {
    for (var _len2 = arguments.length, funcs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      funcs[_key2] = arguments[_key2];
    }

    var recomputations = 0;
    var resultFunc = funcs.pop();
    var dependencies = getDependencies(funcs);

    var memoizedResultFunc = memoize.apply(undefined, [function () {
      recomputations++;
      // apply arguments instead of spreading for performance.
      return resultFunc.apply(null, arguments);
    }].concat(memoizeOptions));

    // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
    var selector = defaultMemoize(function () {
      var params = [];
      var length = dependencies.length;

      for (var i = 0; i < length; i++) {
        // apply arguments instead of spreading and mutate a local list of params for performance.
        params.push(dependencies[i].apply(null, arguments));
      }

      // apply arguments instead of spreading for performance.
      return memoizedResultFunc.apply(null, params);
    });

    selector.resultFunc = resultFunc;
    selector.recomputations = function () {
      return recomputations;
    };
    selector.resetRecomputations = function () {
      return recomputations = 0;
    };
    return selector;
  };
}

var createSelector = exports.createSelector = createSelectorCreator(defaultMemoize);

function createStructuredSelector(selectors) {
  var selectorCreator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : createSelector;

  if (typeof selectors !== 'object') {
    throw new Error('createStructuredSelector expects first argument to be an object ' + ('where each property is a selector, instead received a ' + typeof selectors));
  }
  var objectKeys = Object.keys(selectors);
  return selectorCreator(objectKeys.map(function (key) {
    return selectors[key];
  }), function () {
    for (var _len3 = arguments.length, values = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      values[_key3] = arguments[_key3];
    }

    return values.reduce(function (composition, value, index) {
      composition[objectKeys[index]] = value;
      return composition;
    }, {});
  });
}

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getLeaveTypesArray = exports.getLeaveTypes = exports.getTimeZoneGroupsArray = exports.getTimeZoneGroups = exports.getUserGroupsArrayWithDefault = exports.getUserGroupsWithDefault = exports.getUserGroups = exports.getWorkflowStatus = exports.getNextWorkflowStatusesArray = exports.getWorkflowStatusesArray = exports.getWorkflowStatuses = exports.getTypeOfWork = exports.getTypesOfWork = exports.getCustomer = exports.getCustomers = exports.getProject = exports.getProjects = exports.getTask = exports.getTasks = exports.getUser = exports.getActiveUsersArray = exports.getUsers = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reselect = __webpack_require__(13);

var _constants = __webpack_require__(4);

var _groupUtils = __webpack_require__(71);

var _selectors = __webpack_require__(15);

var _constants2 = __webpack_require__(23);

var _atUtils = __webpack_require__(5);

var _GroupType = __webpack_require__(34);

var _GroupType2 = _interopRequireDefault(_GroupType);

var _utils = __webpack_require__(135);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var getEntitiesState = function getEntitiesState(state) {
    return state.entities;
};

var getUsers = exports.getUsers = function getUsers(state) {
    return getEntitiesState(state).users;
};

var getActiveUsersArray = exports.getActiveUsersArray = (0, _reselect.createSelector)(getUsers, function (users) {
    return getEntitiesArray(users).filter(function (user) {
        return user.active;
    });
});

var getUser = exports.getUser = function getUser(state, id) {
    return getEntitiesState(state).users[id];
};

var getTasks = exports.getTasks = function getTasks(state) {
    return getEntitiesState(state).tasks;
};

var getTask = exports.getTask = function getTask(state, id) {
    return getEntitiesState(state).tasks[id];
};

var getProjects = exports.getProjects = function getProjects(state) {
    return getEntitiesState(state).projects;
};

var getProject = exports.getProject = function getProject(state, id) {
    return getEntitiesState(state).projects[id];
};

var getCustomers = exports.getCustomers = function getCustomers(state) {
    return getEntitiesState(state).customers;
};

var getCustomer = exports.getCustomer = function getCustomer(state, id) {
    return getEntitiesState(state).customers[id];
};

var getTypesOfWork = exports.getTypesOfWork = function getTypesOfWork(state) {
    return getEntitiesState(state).typesOfWork;
};

var getTypeOfWork = exports.getTypeOfWork = function getTypeOfWork(state, id) {
    return getEntitiesState(state).typesOfWork[id];
};

var getWorkflowStatusesRegardlessTWSFeature = function getWorkflowStatusesRegardlessTWSFeature(state) {
    return getEntitiesState(state).workflowStatuses;
};

var getWorkflowStatuses = exports.getWorkflowStatuses = (0, _reselect.createSelector)(_selectors.isTWSEnabled, getWorkflowStatusesRegardlessTWSFeature, function (twsEnabled, statuses) {
    return twsEnabled ? statuses : (0, _atUtils.arrayToMap)(_constants2.FAKE_WORKFLOW_STATUSES);
});

var getWorkflowStatusesArray = exports.getWorkflowStatusesArray = (0, _reselect.createSelector)(getWorkflowStatuses, function (statusesMap) {
    return Object.values(statusesMap);
});

var getNextWorkflowStatusesArray = exports.getNextWorkflowStatusesArray = (0, _reselect.createSelector)(_selectors.isTWSEnabled, getWorkflowStatusesArray, function (twsEnabled, statuses) {
    return twsEnabled ? statuses.sort(function (a, b) {
        var typeA = a.type === _constants2.WorkflowStatusType.OPEN ? 1 : 0;
        var typeB = b.type === _constants2.WorkflowStatusType.OPEN ? 1 : 0;
        return typeA - typeB || a.position - b.position;
    }).map(_utils.convertClassicWorkflowStatusToNext) : [];
});

var getWorkflowStatus = exports.getWorkflowStatus = function getWorkflowStatus(state, id) {
    return getEntitiesState(state).workflowStatuses[id];
};

var getUserGroups = exports.getUserGroups = function getUserGroups(state) {
    return getEntitiesState(state).userGroups;
};

var getUserGroupsWithDefault = exports.getUserGroupsWithDefault = (0, _reselect.createSelector)(getUserGroups, function (userGroups) {
    return _extends(_defineProperty({}, _constants.USERS_WITHOUT_GROUP_ID, (0, _groupUtils.createDefaultUserGroup)()), userGroups);
});

var getUserGroupsArrayWithDefault = exports.getUserGroupsArrayWithDefault = (0, _reselect.createSelector)(getUserGroupsWithDefault, function (userGroups) {
    return getEntitiesArray(userGroups).sort((0, _groupUtils.createGroupComparator)(_GroupType2.default.USER_GROUP));
});

var getTimeZoneGroups = exports.getTimeZoneGroups = function getTimeZoneGroups(state) {
    return getEntitiesState(state).timeZoneGroups;
};

var getTimeZoneGroupsArray = exports.getTimeZoneGroupsArray = (0, _reselect.createSelector)(getTimeZoneGroups, function (timeZoneGroups) {
    return getEntitiesArray(timeZoneGroups).sort((0, _groupUtils.createGroupComparator)(_GroupType2.default.TIME_ZONE_GROUP));
});

var getLeaveTypes = exports.getLeaveTypes = function getLeaveTypes(state) {
    return getEntitiesState(state).leaveTypes;
};

var getLeaveTypesArray = exports.getLeaveTypesArray = (0, _reselect.createSelector)(getLeaveTypes, function (leaveTypes) {
    return getEntitiesArray(leaveTypes);
});

var getEntitiesArray = function getEntitiesArray(entities) {
    return entities ? Object.values(entities) : [];
};

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isAnyTZGEnabled = exports.isAnyUGREnabled = exports.isQBIEnabled = exports.isLTTEnabled = exports.isLVTEnabled = exports.isOVREnabled = exports.isURAEnabled = exports.isBRAEnabled = exports.isBTYEnabled = exports.isTWSEnabled = exports.isTTAEnabled = exports.isWSDEnabled = exports.isWASEnabled = exports.isSDBEnabled = exports.isPTOEnabled = exports.isUGREnabled = exports.isTSTEnabled = exports.isESTEnabled = exports.isTZGEnabled = exports.isCPTBUDEnabled = exports.isFeatureEnabled = exports.selectFeatures = undefined;

var _reselect = __webpack_require__(13);

var _constants = __webpack_require__(78);

var _utils = __webpack_require__(118);

var selectFeatures = exports.selectFeatures = function selectFeatures(state) {
    return state.features;
};

var isFeatureEnabled = exports.isFeatureEnabled = function isFeatureEnabled(state, feature) {
    return (0, _utils.isEnabled)(selectFeatures(state), feature);
};

var isCPTBUDEnabled = exports.isCPTBUDEnabled = (0, _reselect.createSelector)(selectFeatures, function (features) {
    return (0, _utils.isEnabled)(features, _constants.Feature.CPTBUD);
});

var isTZGEnabled = exports.isTZGEnabled = (0, _reselect.createSelector)(selectFeatures, function (features) {
    return (0, _utils.isEnabled)(features, _constants.Feature.TZG);
});

var isESTEnabled = exports.isESTEnabled = (0, _reselect.createSelector)(selectFeatures, function (features) {
    return (0, _utils.isEnabled)(features, _constants.Feature.EST);
});

var isTSTEnabled = exports.isTSTEnabled = (0, _reselect.createSelector)(selectFeatures, function (features) {
    return (0, _utils.isEnabled)(features, _constants.Feature.TST);
});

var isUGREnabled = exports.isUGREnabled = (0, _reselect.createSelector)(selectFeatures, function (features) {
    return (0, _utils.isEnabled)(features, _constants.Feature.UGR);
});

var isPTOEnabled = exports.isPTOEnabled = (0, _reselect.createSelector)(selectFeatures, function (features) {
    return (0, _utils.isEnabled)(features, _constants.Feature.PTO);
});

var isSDBEnabled = exports.isSDBEnabled = (0, _reselect.createSelector)(selectFeatures, function (features) {
    return (0, _utils.isEnabled)(features, _constants.Feature.SDB);
});

var isWASEnabled = exports.isWASEnabled = (0, _reselect.createSelector)(selectFeatures, function (features) {
    return (0, _utils.isEnabled)(features, _constants.Feature.WAS);
});

var isWSDEnabled = exports.isWSDEnabled = (0, _reselect.createSelector)(selectFeatures, function (features) {
    return (0, _utils.isEnabled)(features, _constants.Feature.WSD);
});

var isTTAEnabled = exports.isTTAEnabled = (0, _reselect.createSelector)(selectFeatures, function (features) {
    return (0, _utils.isEnabled)(features, _constants.Feature.TTA);
});

var isTWSEnabled = exports.isTWSEnabled = (0, _reselect.createSelector)(selectFeatures, function (features) {
    return (0, _utils.isEnabled)(features, _constants.Feature.TWS);
});

var isBTYEnabled = exports.isBTYEnabled = (0, _reselect.createSelector)(selectFeatures, function (features) {
    return (0, _utils.isEnabled)(features, _constants.Feature.BTY);
});

var isBRAEnabled = exports.isBRAEnabled = (0, _reselect.createSelector)(selectFeatures, function (features) {
    return (0, _utils.isEnabled)(features, _constants.Feature.BRA);
});

var isURAEnabled = exports.isURAEnabled = (0, _reselect.createSelector)(selectFeatures, function (features) {
    return (0, _utils.isEnabled)(features, _constants.Feature.URA);
});

var isOVREnabled = exports.isOVREnabled = (0, _reselect.createSelector)(selectFeatures, function (features) {
    return (0, _utils.isEnabled)(features, _constants.Feature.OVR);
});

var isLVTEnabled = exports.isLVTEnabled = (0, _reselect.createSelector)(selectFeatures, function (features) {
    return (0, _utils.isEnabled)(features, _constants.Feature.LVT);
});

var isLTTEnabled = exports.isLTTEnabled = (0, _reselect.createSelector)(selectFeatures, function (features) {
    return (0, _utils.isEnabled)(features, _constants.Feature.LTT);
});

var isQBIEnabled = exports.isQBIEnabled = (0, _reselect.createSelector)(selectFeatures, function (features) {
    return (0, _utils.isEnabled)(features, _constants.Feature.QBI);
});

var isAnyUGREnabled = exports.isAnyUGREnabled = (0, _reselect.createSelector)(selectFeatures, function (features) {
    return (0, _utils.isEnabled)(features, _constants.Feature.APUGR) || (0, _utils.isEnabled)(features, _constants.Feature.UGR);
});

var isAnyTZGEnabled = exports.isAnyTZGEnabled = (0, _reselect.createSelector)(selectFeatures, function (features) {
    return (0, _utils.isEnabled)(features, _constants.Feature.APTZG) || (0, _utils.isEnabled)(features, _constants.Feature.TZG);
});

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DateFormat = DateFormat;
exports.formatTime = formatTime;
exports.getShortTime = getShortTime;
function DateFormat(dateFmt, clockFmt) {
    var _this = this;

    this.dateFormat = dateFmt;
    this.clockFormat = clockFmt;
    this.formatDate = formatDate;
    this.formatTime = function (date) {
        return formatTime(date, _this.clockFormat);
    };
    this.formatDateTime = formatDateTime;
    this.getShortTime = function (date, initialFormat) {
        return getShortTime(date, initialFormat, _this.clockFormat);
    };
}

function formatDate(d) {
    var result = this.dateFormat;
    var tokens = this.dateFormat.split(/[ \/,-]+/, 4);

    for (var i = 0; i < tokens.length; i++) {
        if (tokens[i] == 'MM') result = result.replace(/MM/, getNumWithLeadingZero(d.getMonth() + 1));else if (tokens[i] == 'MMM') result = result.replace(/MMM/, Date.monthNamesShort[d.getMonth()]);else if (tokens[i] == 'MMMM') result = result.replace(/MMMM/, Date.monthNames[d.getMonth()]);else if (tokens[i] == 'dd') result = result.replace(/dd/, getNumWithLeadingZero(d.getDate()));else if (tokens[i] == 'yy') result = result.replace(/yy/, getShortYear(d.getFullYear()));else if (tokens[i] == 'yyyy') result = result.replace(/yyyy/, d.getFullYear());else if (tokens[i] == 'EEE') result = result.replace(/EEE/, Date.dayNamesShort[d.getDay()]);else if (tokens[i] == 'EEEE') result = result.replace(/EEEE/, Date.dayNames[d.getDay()]);
    }

    return result;
}

function formatTime(date, clockFormat) {
    var hours = date.getHours();
    var minutes = date.getMinutes();
    minutes = minutes < 10 ? '0' + minutes : minutes;
    var strTime = hours + ':' + minutes;
    return clockFormat ? ClassicBridge.convertTimeToFormat(strTime, true, clockFormat) : strTime;
}

function formatDateTime(date) {
    return this.formatDate(date) + ", " + this.formatTime(date);
}

function getNumWithLeadingZero(num) {
    if (num < 10) return new String('0' + num);
    return num;
}

function getShortYear(year) {
    return new String(year).substring(2, 4);
}

function getShortTime(date, initialFormat, clockFormat) {
    var timeFormat = (clockFormat || SystemSettings.clockFormat) === "12" ? "h:i A" : "H:i";
    return date ? Date.parseDate(date, initialFormat).format("M d, " + timeFormat) : null;
}

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.formatFL = exports.formatFmlWithCheck = exports.formatFMLU = exports.formatFML = exports.formatLFM = exports.formatLFMU = undefined;

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var formatLFMU = exports.formatLFMU = function formatLFMU(firstName, lastName, middleName, username, lastFirstNamesSeparator) {
    return formatLFM(firstName, lastName, middleName, lastFirstNamesSeparator) + " (" + username + ")";
};

var formatLFM = exports.formatLFM = function formatLFM(firstName, lastName, middleName, lastFirstNamesSeparator) {
    var separator = lastFirstNamesSeparator ? lastFirstNamesSeparator : ", ";
    var result = lastName + separator + firstName;
    if (middleName) result += " " + middleName + ".";
    return result;
};

var formatFML = exports.formatFML = function formatFML(firstName, lastName, middleName) {
    var result = firstName;
    if (middleName) result += " " + middleName + ".";
    return result + " " + lastName;
};

var formatFMLU = exports.formatFMLU = function formatFMLU(firstName, lastName, middleName, username) {
    return formatFML(firstName, lastName, middleName) + " (" + username + ")";
};

var formatFmlWithCheck = exports.formatFmlWithCheck = function formatFmlWithCheck(_ref) {
    var firstName = _ref.firstName,
        middleInitial = _ref.middleInitial,
        lastName = _ref.lastName;

    if (firstName && lastName) return formatFML(firstName, lastName, middleInitial);
    if (firstName) return firstName;
    if (lastName) {
        var result = "";
        if (middleInitial) result += middleInitial + ". ";
        result += lastName;
        return result;
    }
    return _messageResource2.default.getMessage('user.singular');
};

var formatFL = exports.formatFL = function formatFL(_ref2) {
    var firstName = _ref2.firstName,
        lastName = _ref2.lastName;

    return firstName + ' ' + lastName;
};

exports.default = {
    formatLFMU: formatLFMU,
    formatLFM: formatLFM,
    formatFML: formatFML,
    formatFMLU: formatFMLU,
    formatFL: formatFL
};

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ClassicBridge = {
    patchUser: function patchUser(userId, patch) {
        return window.ClassicBridge.patchUser(userId, patch);
    },
    getTasksForTaskList: function getTasksForTaskList(params, settings) {
        return window.ClassicBridge.getTasksForTaskList(params, settings);
    },
    getTasksForTaskListSynced: function getTasksForTaskListSynced(params, settings) {
        return ClassicBridge.syncChangesFromClassic().then(function () {
            return window.ClassicBridge.getTasksForTaskList(params, settings);
        });
    },
    getTasksSummary: function getTasksSummary(params) {
        return window.ClassicBridge.getTasksSummary(params);
    },
    getLeaveTypes: function getLeaveTypes() {
        return window.ClassicBridge.getLeaveTypes();
    },
    getKanbanSummary: function getKanbanSummary(params) {
        return ClassicBridge.syncChangesFromClassic().then(function () {
            return window.ClassicBridge.getKanbanSummary(params);
        });
    },
    getUsersByClassicIds: function getUsersByClassicIds(ids) {
        return window.ClassicBridge.getUsersByClassicIds(ids);
    },
    getDefaultWorkStatusPlanningByUserId: function getDefaultWorkStatusPlanningByUserId(id) {
        return window.ClassicBridge.getDefaultWorkStatusPlanningByUserId(id);
    },
    putUserDefaultWorkStatuses: function putUserDefaultWorkStatuses(id, patch) {
        return window.ClassicBridge.putUserDefaultWorkStatuses(id, patch);
    },
    getWorkStatusesForUserProfile: function getWorkStatusesForUserProfile() {
        return window.ClassicBridge.getWorkStatusesForUserProfile();
    },
    canImportTimeTrack: function canImportTimeTrack() {
        return window.ClassicBridge.canImportTimeTrack();
    },
    getTaskCustomFieldsList: function getTaskCustomFieldsList() {
        return window.ClassicBridge.getTaskCustomFieldsList();
    },
    isCustomField: function isCustomField(key) {
        return window.ClassicBridge.isCustomField(key);
    },
    getWorkflowStatusesList: function getWorkflowStatusesList() {
        return window.ClassicBridge.getWorkflowStatusesList();
    },
    patchTaskCustomField: function patchTaskCustomField(id, fieldName, value) {
        return window.ClassicBridge.patchTaskCustomField(id, fieldName, value);
    },
    patchTask: function patchTask(id, patch) {
        return window.ClassicBridge.patchTask(id, patch);
    },


    /**
     * Returns object with setProps method
     * @param el
     * @returns {*}
     */
    integrateTaskPanelDetails: function integrateTaskPanelDetails(el) {
        return window.ClassicBridge.integrateTaskPanelDetails(el);
    },
    integrateBudgetsTab: function integrateBudgetsTab(el, props) {
        return window.ClassicBridge.integrateBudgetsTab(el, props);
    },
    integrateCalendar: function integrateCalendar(el, props) {
        return window.ClassicBridge.integrateCalendar(el, props);
    },
    integrateFromDateSelector: function integrateFromDateSelector(el, props) {
        return window.ClassicBridge.integrateFromDateSelector(el, props);
    },
    getNextBiweeklyAccrualDateFromDate: function getNextBiweeklyAccrualDateFromDate(today, fromDate, dateFormat) {
        return window.ClassicBridge.getNextBiweeklyAccrualDateFromDate(today, fromDate, dateFormat);
    },
    getShortNextBiweeklyAccrualDateFromDate: function getShortNextBiweeklyAccrualDateFromDate(today, fromDate, dateFormat) {
        return window.ClassicBridge.getShortNextBiweeklyAccrualDateFromDate(today, fromDate, dateFormat);
    },
    getNextFridayDate: function getNextFridayDate(today) {
        return window.ClassicBridge.getNextFridayDate(today);
    },
    getDateWeekday: function getDateWeekday(date) {
        return window.ClassicBridge.getDateWeekday(date);
    },
    integrateTaskListFiltersPanel: function integrateTaskListFiltersPanel(el, props) {
        return window.ClassicBridge.integrateTaskListFiltersPanel(el, props);
    },
    integrateTaskListColumnConfigurator: function integrateTaskListColumnConfigurator(el, props) {
        return window.ClassicBridge.integrateTaskListColumnConfigurator(el, props);
    },
    integrateAddFilters: function integrateAddFilters(el, props) {
        return window.ClassicBridge.integrateAddFilters(el, props);
    },
    integrateInputWithSuggestions: function integrateInputWithSuggestions(el, props, fieldId) {
        return window.ClassicBridge.integrateInputWithSuggestions(el, props, fieldId);
    },
    integrateDefaultWorkStatusPlanning: function integrateDefaultWorkStatusPlanning(el, props) {
        return window.ClassicBridge.integrateDefaultWorkStatusPlanning(el, props);
    },
    integrateDefaultWorkdayStartEnd: function integrateDefaultWorkdayStartEnd(el, props) {
        return window.ClassicBridge.integrateDefaultWorkdayStartEnd(el, props);
    },
    integrateTooltipDefaultWorkStatusPlanning: function integrateTooltipDefaultWorkStatusPlanning(el, props) {
        return window.ClassicBridge.integrateTooltipDefaultWorkStatusPlanning(el, props);
    },
    integrateInitialDefaultWorkStatus: function integrateInitialDefaultWorkStatus(el, props) {
        return window.ClassicBridge.integrateInitialDefaultWorkStatus(el, props);
    },
    integrateExportCPDropdown: function integrateExportCPDropdown(el, props) {
        return window.ClassicBridge.integrateExportCPDropdown(el, props);
    },
    integrateExportUsersDropdown: function integrateExportUsersDropdown(el, props) {
        return window.ClassicBridge.integrateExportUsersDropdown(el, props);
    },
    integrateDeadlineSelector: function integrateDeadlineSelector(el, props) {
        return window.ClassicBridge.integrateDeadlineSelector(el, props);
    },
    integrateCFDropdownSelector: function integrateCFDropdownSelector(el, props) {
        return window.ClassicBridge.integrateCFDropdownSelector(el, props);
    },
    integrateCsvUserImportModal: function integrateCsvUserImportModal(el) {
        return window.ClassicBridge.integrateCsvUserImportModal(el);
    },
    integrateWorkSchedulingTable: function integrateWorkSchedulingTable(el, mode) {
        return window.ClassicBridge.integrateWorkSchedulingTable(el, mode);
    },
    integrateWorkStatusesReport: function integrateWorkStatusesReport(el) {
        return window.ClassicBridge.integrateWorkStatusesReport(el);
    },
    integrateUserFilter: function integrateUserFilter(el, props) {
        return window.ClassicBridge.integrateUserFilter(el, props);
    },
    integrateProgressBar: function integrateProgressBar(el, props) {
        return window.ClassicBridge.integrateProgressBar(el, props);
    },
    integrateFullscreenSpinner: function integrateFullscreenSpinner(el, props) {
        return window.ClassicBridge.integrateFullscreenSpinner(el, props);
    },
    integrateSpinner: function integrateSpinner(el, props) {
        return window.ClassicBridge.integrateSpinner(el, props);
    },


    /**
     * !!Usage note
     * Because of the existent implementation, doesn't work without 'special' container
     * You may use a code like this:
     *  ```
     *  $('<div/>').addClass('atNextMount atNextOverlays').appendTo($('body'))
     *  ```
     */
    integrateProgressFullscreenSpinner: function integrateProgressFullscreenSpinner(el, props) {
        return window.ClassicBridge.integrateProgressFullscreenSpinner(el, props);
    },
    integrateAddTaskToTimesheetButton: function integrateAddTaskToTimesheetButton(el, props) {
        return window.ClassicBridge.integrateAddTaskToTimesheetButton(el, props);
    },
    integrateMarkAsLeaveBlackoutConfirmation: function integrateMarkAsLeaveBlackoutConfirmation(el, props) {
        return window.ClassicBridge.integrateMarkAsLeaveBlackoutConfirmation(el, props);
    },
    integrateLeaveBlackoutLegendDropdown: function integrateLeaveBlackoutLegendDropdown(el, props) {
        return window.ClassicBridge.integrateLeaveBlackoutLegendDropdown(el, props);
    },
    findCurrentInterval: function findCurrentInterval(today, intervals) {
        return window.ClassicBridge.findCurrentInterval(today, intervals);
    },


    /**
     * Waiting while actual data will by synced from classic. For example, waiting after task creation
     * @returns {*}
     */
    syncChangesFromClassic: function syncChangesFromClassic() {
        return window.ClassicBridge.syncChangesFromClassic();
    },
    getTasksAfterModification: function getTasksAfterModification(classicTaskIds) {
        return new Promise(function (res) {
            window.ClassicBridge.syncChangesFromClassic().then(function () {
                window.ClassicBridge.getTasksForTaskList({ taskIds: classicTaskIds }).then(function (nextData) {
                    if (nextData.items.length !== 0) {
                        return res(nextData.items);
                    }

                    return res(null);
                });
            }).catch(function () {
                return res(null);
            });
        });
    },
    convertTimeToFormat: function convertTimeToFormat(value, allowZero, outFormat) {
        return window.ClassicBridge.convertTimeToFormat(value, allowZero, outFormat);
    },
    sendUserEvent: function sendUserEvent(event) {
        var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var async = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

        return window.ClassicBridge.sendUserEvent(event, params, async);
    },
    getImportTasksFromCsvRequestUrl: function getImportTasksFromCsvRequestUrl() {
        return window.ClassicBridge.getImportTasksFromCsvRequestUrl();
    },
    postImportTasksRequest: function postImportTasksRequest(table, index, totalRows, operationId) {
        return window.ClassicBridge.postImportTasksRequest(table, index, totalRows, operationId);
    },
    showSuccessToast: function showSuccessToast(message) {
        return window.ClassicBridge.showSuccessToast(message);
    },
    getLeaveBlackoutDays: function getLeaveBlackoutDays(year) {
        return window.ClassicBridge.getLeaveBlackoutDays(year);
    },
    addLeaveBlackoutDay: function addLeaveBlackoutDay(date) {
        return window.ClassicBridge.addLeaveBlackoutDay(date);
    },
    getNonApprovedLeaveRequestsForDay: function getNonApprovedLeaveRequestsForDay(date) {
        return window.ClassicBridge.getNonApprovedLeaveRequestsForDay(date);
    },
    deleteLeaveBlackoutDay: function deleteLeaveBlackoutDay(date) {
        return window.ClassicBridge.deleteLeaveBlackoutDay(date);
    },
    setLeaveBlackoutPresetStyles: function setLeaveBlackoutPresetStyles(color) {
        window.ClassicBridge.setLeaveBlackoutPresetStyles(color);
    },
    integrateHistogram: function integrateHistogram(el, props) {
        return window.ClassicBridge.integrateHistogram(el, props);
    }
};

/**
 *
 * @param taskId
 * @param retryIfNoData - retry request while data will not available or attempts will end
 * Usually chains of request performed:
 * -> POST to classic data modifications
 * -> /sync-data-from-classic - waiting while data was synced {@see ClassicBridge#syncChangesFromClassic}
 * -> GET data from next
 * But sometimes due https://jira.actimind.com/browse/AT-7569 data is not synced after `sync-data-from-classic`
 * Retry reading allow to retrieve data with small delay
 * @returns {Promise<unknown>}
 */
ClassicBridge.getTask = function (taskId) {
    var retryIfNoData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    var timesToRepeat = retryIfNoData ? 10 : 1;
    var nRepeats = 0;
    var msBetweenRepeat = 500;
    var recCall = function recCall(resolve, reject) {
        ClassicBridge.getTasksForTaskList({ taskIds: [taskId] }).then(function (result) {
            var task = result.items[0];
            if (task) {
                resolve(task);
            } else {
                if (++nRepeats >= timesToRepeat) {
                    reject('task not fetching in ' + timesToRepeat + ' repeats');
                } else {
                    setTimeout(function () {
                        return recCall(resolve, reject);
                    }, msBetweenRepeat);
                }
            }
        });
    };
    return new Promise(recCall);
};

ClassicBridge.onDemoDataJustLoaded = function () {
    (0, _jquery2.default)(document).trigger('demo_data_just_loaded');
};

exports.default = ClassicBridge;

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getFirstName = exports.getEmail = exports.hasEmail = exports.canSwitchToQBI = exports.canManageSystemSettings = exports.hasSick = exports.hasPto = exports.getAccessRights = exports.hasManageScopeRights = exports.canManageAllTeamScope = exports.canAccessSomeTeamAssignment = exports.hasAccessAllManagementScope = exports.canManagePtoAndSickDays = exports.canSubmitOtherUsersTT = exports.canGenerateMoneyReports = exports.canManageAccountsAndPermissions = exports.canEditHierarchy = exports.isFirstAdmin = exports.getLoggedInUserId = exports.getLoggedInUser = undefined;

var _reselect = __webpack_require__(13);

var _accessRightsUtils = __webpack_require__(188);

var _atUtils = __webpack_require__(5);

var _selectors = __webpack_require__(15);

//First created user in the context
var FIRST_ADMIN_ID = 1;

var getLoggedInUser = exports.getLoggedInUser = function getLoggedInUser(state) {
    return state.loggedInUser;
};

var getLoggedInUserId = exports.getLoggedInUserId = function getLoggedInUserId(state) {
    return getLoggedInUser(state).id;
};

var isFirstAdmin = exports.isFirstAdmin = (0, _reselect.createSelector)(getLoggedInUserId, function (userId) {
    return userId === FIRST_ADMIN_ID;
});

var canEditHierarchy = exports.canEditHierarchy = (0, _reselect.createSelector)(getLoggedInUser, function (user) {
    return (0, _accessRightsUtils.hasEditHierarchyRight)(user);
});

var canManageAccountsAndPermissions = exports.canManageAccountsAndPermissions = (0, _reselect.createSelector)(getLoggedInUser, function (user) {
    return (0, _accessRightsUtils.hasManageUsersRight)(user);
});

var canGenerateMoneyReports = exports.canGenerateMoneyReports = (0, _reselect.createSelector)(getLoggedInUser, function (user) {
    return (0, _accessRightsUtils.hasGenerateMoneyReportsRight)(user);
});

var canSubmitOtherUsersTT = exports.canSubmitOtherUsersTT = (0, _reselect.createSelector)(getLoggedInUser, function (user) {
    return (0, _accessRightsUtils.hasSubmitOtherUsersTTRight)(user);
});

var canManagePtoAndSickDays = exports.canManagePtoAndSickDays = (0, _reselect.createSelector)(getLoggedInUser, function (user) {
    return (0, _accessRightsUtils.hasManagePtoAndSickDays)(user);
});

var hasAccessAllManagementScope = exports.hasAccessAllManagementScope = (0, _reselect.createSelector)(getLoggedInUser, function (user) {
    return (0, _accessRightsUtils.canAccessAllManagementScope)(user);
});

var canAccessSomeTeamAssignment = exports.canAccessSomeTeamAssignment = (0, _reselect.createSelector)(getLoggedInUser, function (user) {
    return (0, _accessRightsUtils.hasSomeTeamAssignment)(user);
});

var canManageAllTeamScope = exports.canManageAllTeamScope = (0, _reselect.createSelector)(getLoggedInUser, function (user) {
    return (0, _accessRightsUtils.canAccessAllTeamScope)(user);
});

var hasManageScopeRights = exports.hasManageScopeRights = (0, _reselect.createSelector)(canGenerateMoneyReports, canEditHierarchy, canManageAccountsAndPermissions, canSubmitOtherUsersTT, _selectors.isURAEnabled, _selectors.isBTYEnabled, function (canGenerateMoneyReports, canEditHierarchy, canManageAccountsAndPermissions, canSubmitOtherUsersTT, isURAEnabled, isBTYEnabled) {
    return canGenerateMoneyReports && (isURAEnabled || isBTYEnabled) || canEditHierarchy || canManageAccountsAndPermissions || canSubmitOtherUsersTT;
});

var getAccessRights = exports.getAccessRights = (0, _reselect.createSelector)(getLoggedInUser, function (user) {
    return (0, _atUtils.arrayToSet)(user.accessRights);
});

var hasPto = exports.hasPto = (0, _reselect.createSelector)(getLoggedInUser, function (user) {
    return user.pto;
});

var hasSick = exports.hasSick = (0, _reselect.createSelector)(getLoggedInUser, function (user) {
    return user.sick;
});

var canManageSystemSettings = exports.canManageSystemSettings = (0, _reselect.createSelector)(getLoggedInUser, function (user) {
    return (0, _accessRightsUtils.hasManageSystemSettingsRight)(user);
});

var canSwitchToQBI = exports.canSwitchToQBI = (0, _reselect.createSelector)(canGenerateMoneyReports, hasAccessAllManagementScope, canManageAllTeamScope, function (canGenerateMoneyReports, hasAccessAllManagementScope, canManageAllTeamScope) {
    return canGenerateMoneyReports && hasAccessAllManagementScope && canManageAllTeamScope;
});

var hasEmail = exports.hasEmail = (0, _reselect.createSelector)(getLoggedInUser, function (user) {
    return user.hasEmail;
});

var getEmail = exports.getEmail = (0, _reselect.createSelector)(getLoggedInUser, function (user) {
    return user.email;
});

var getFirstName = exports.getFirstName = (0, _reselect.createSelector)(getLoggedInUser, function (user) {
    return user.firstName;
});

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _StateComponent2 = __webpack_require__(105);

var _StateComponent3 = _interopRequireDefault(_StateComponent2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Base class for custom views. Contains base
 * @param [$containerEl] jQuery selector for element, which is going to be view's container.
 *                       It's not necessary to specify it in constructor, it can can done in .init() method.
 * @constructor
 */
var View = function (_StateComponent) {
    _inherits(View, _StateComponent);

    function View() {
        var $containerEl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

        _classCallCheck(this, View);

        var _this = _possibleConstructorReturn(this, (View.__proto__ || Object.getPrototypeOf(View)).call(this, {}));

        _this.$containerEl = $containerEl;
        _this.$el = null;

        // display css-property for saving via hide-show
        _this._displayCssProp = null;
        // children components (View.js) for delegate base methods calls
        _this._childrenComponents = [];
        // prevent handling changes while component not rendered
        _this.stopHandlingStateChanges();
        return _this;
    }

    /**
     * Renders the view, calls before and after hooks and optionally calls the update function.
     * @param [$containerEl] jQuery selector for element, which is going to be view's container.
     *                       This is alternative to passing container element in the constructor,
     *                       which is useful for postponed render.
     * @returns {View}
     */


    _createClass(View, [{
        key: "init",
        value: function init($containerEl) {
            if ($containerEl) this.$containerEl = $containerEl;

            this.beforeRender();
            this.render();
            this.afterRender();
            this.rendered = true;
            this.resumeHandlingStateChanges(false);

            if (this.shouldUpdateOnInit()) this.update();

            return this;
        }

        /**
         * Abstract render function, should put the view into container.
         */

    }, {
        key: "render",
        value: function render() {}

        /**
         * Before-render hook.
         */

    }, {
        key: "beforeRender",
        value: function beforeRender() {}

        /**
         * After-render hook.
         */

    }, {
        key: "afterRender",
        value: function afterRender() {}

        /**
         * Abstract update function, which should render any dynamic changes in the view.
         */

    }, {
        key: "update",
        value: function update() {}

        /**
         * Defines if .update() method will be called once on .init()
         */

    }, {
        key: "shouldUpdateOnInit",
        value: function shouldUpdateOnInit() {
            // TODO: Eventually remove this. Currently it's needed for legacy views, which may have this field.
            if (_underscore2.default.isBoolean(this["updateOnInit"])) return this["updateOnInit"];

            return true;
        }

        /**
         * Shortcut to jQuery $.on() function for event binding.
         * @param eventName {String} Event name.
         * @param handler {Function} Event handler.
         */

    }, {
        key: "on",
        value: function on(eventName, handler) {
            (0, _jquery2.default)(this).on(eventName, handler);
        }

        /**
         * Shortcut to jQuery $.trigger() function for event binding.
         * @param eventName {String} Event name.
         * @param data {object} Event data.
         */

    }, {
        key: "trigger",
        value: function trigger(eventName, data) {
            (0, _jquery2.default)(this).trigger(eventName, data);
        }

        /**
         * Shortcut for binding a function to view's instance. Useful when you want some callback to be a class method.
         * @param f {Function} Function to bind.
         * @returns {Function}
         */

    }, {
        key: "bind",
        value: function bind(f) {
            return _underscore2.default.bind(f, this);
        }

        /**
         * Shortcut for finding view's sub-elements using jQuery.
         * @param selector jQuery selector.
         */

    }, {
        key: "find",
        value: function find(selector) {
            return this.$el.find(selector);
        }

        /**
         * Shortcut for finding view's sub-elements using jQuery and binding a click handler.
         * @param selector jQuery selector.
         * @param handler {Function} Click handler.
         */

    }, {
        key: "findAndBindClick",
        value: function findAndBindClick(selector, handler) {
            return this.find(selector).click(this.bind(handler));
        }

        /**
         * Shortcut for binding a click handler to the entire view.
         * @param handler {Function} Click handler.
         */

    }, {
        key: "bindClick",
        value: function bindClick(handler) {
            return this.$el.click(this.bind(handler));
        }

        /**
         * Shows view.
         */

    }, {
        key: "show",
        value: function show() {
            this.resumeHandlingStateChanges();
            if (this._displayCssProp !== null && this._displayCssProp !== 'none') {
                this.$el.css('display', this._displayCssProp);
            } else {
                this.$el.show();
            }
            this.applyForChildrenComponents(function (child) {
                return child.show();
            });
        }

        /**
         * Hides view.
         */

    }, {
        key: "hide",
        value: function hide() {
            this.stopHandlingStateChanges();
            this._displayCssProp = this.$el.css('display');
            this.$el.hide();
            this.applyForChildrenComponents(function (child) {
                return child.hide();
            });
        }
    }, {
        key: "resumeHandlingStateChanges",
        value: function resumeHandlingStateChanges(handlePendingChanges) {
            _get(View.prototype.__proto__ || Object.getPrototypeOf(View.prototype), "resumeHandlingStateChanges", this).call(this, handlePendingChanges);
            this.applyForChildrenComponents(function (child) {
                return child.resumeHandlingStateChanges(handlePendingChanges);
            });
        }
    }, {
        key: "stopHandlingStateChanges",
        value: function stopHandlingStateChanges() {
            _get(View.prototype.__proto__ || Object.getPrototypeOf(View.prototype), "stopHandlingStateChanges", this).call(this);
            this.applyForChildrenComponents(function (child) {
                return child.stopHandlingStateChanges();
            });
        }
    }, {
        key: "callStateChangeHandlersWithCurrentState",
        value: function callStateChangeHandlersWithCurrentState() {
            _get(View.prototype.__proto__ || Object.getPrototypeOf(View.prototype), "callStateChangeHandlersWithCurrentState", this).call(this);
        }

        /**
         * Toggles view visibility, calling .show() if parameter is true and .hide() if false.
         * @param {Boolean} show
         */

    }, {
        key: "toggle",
        value: function toggle(show) {
            if (show) this.show();else this.hide();
        }

        /**
         * Disables re-renders and updates for the view (only those initiated by standard functions).
         * Rendering is disabled for the rest of view's lifespan, which should be short.
         * This can be useful to prevent unwanted effects just before the view will be destroyed.
         */

    }, {
        key: "disableRendering",
        value: function disableRendering() {
            this.render = _underscore2.default.noop;
            this.beforeRender = _underscore2.default.noop;
            this.afterRender = _underscore2.default.noop;
            this.update = _underscore2.default.noop;
        }

        /**
         * Makes sure that view's initial state is rendered by forcefully calling all state change handlers.
         * Should only be called once – please, do not abuse this method.
         */

    }, {
        key: "renderInitialState",
        value: function renderInitialState() {
            this.callStateChangeHandlersWithCurrentState();
        }

        /**
         * Add children components for delegate base methods
         * @param components
         */

    }, {
        key: "registerChildComponents",
        value: function registerChildComponents() {
            var _childrenComponents;

            (_childrenComponents = this._childrenComponents).push.apply(_childrenComponents, arguments);
        }
    }, {
        key: "getChildrenComponents",
        value: function getChildrenComponents() {
            return this._childrenComponents;
        }

        /**
         * Apply function for every child component
         * @param fn
         */

    }, {
        key: "applyForChildrenComponents",
        value: function applyForChildrenComponents() {
            var fn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (child) {};

            this._childrenComponents.forEach(fn);
        }
    }, {
        key: "getEl",
        value: function getEl() {
            return this.$el;
        }
    }, {
        key: "_getContainerEl",
        value: function _getContainerEl() {
            return this.$containerEl;
        }
    }]);

    return View;
}(_StateComponent3.default);

exports.default = View;

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ValidationErrorsToSc, _ValidationErrorsScro;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var GC = window.__GENERATED_CONSTANTS__;

var GROUP_NEW_OR_NOT_KNOWN = exports.GROUP_NEW_OR_NOT_KNOWN = GC.GROUP_NEW_OR_NOT_KNOWN;

var TabKeys = exports.TabKeys = {
    ACCOUNT_SETTINGS: 'accountSettings',
    PERMISSIONS: 'permissions'
};

var ValidationErrors = exports.ValidationErrors = {
    NO_SUCH_USER: "noSuchUser",
    NO_RIGHTS: "noRights",
    USER_IS_LOCKED: "userIsLocked",
    FIRST_NAME_EMPTY: "firstNameEmpty",
    LAST_NAME_EMPTY: "lastNameEmpty",
    EMAIL_WAS_EMPTY: "emailWasEmpty",
    EMAIL_EMPTY: "emailEmpty",
    PASSWORD_EMPTY: "passwordEmpty",
    PASSWORDS_DO_NOT_MATCH: "passwordsDoNotMatch",
    PASSWORD_COPY_EMPTY: "passwordCopyEmpty",
    PASSWORD_RESTRICTIONS_VIOLATED: "passwordError",
    OLD_PASSWORD_EMPTY: "oldPasswordEmpty",
    OLD_PASSWORD_INCORRECT: "oldPasswordIncorrect",
    USERNAME_EMPTY: "usernameEmpty",
    USERNAME_DUPLICATE: "duplicateUsername",
    NEW_USER_GROUP_EMPTY: "newUserGroupEmpty",
    NEW_TIME_ZONE_GROUP_EMPTY: "newTimeZoneGroupEmpty",
    DUPLICATE_TIME_ZONE_GROUP: "duplicateTimeZoneGroupError",
    CITY_DATA_EMPTY: "cityDataEmpty",
    HIRE_DATE_EMPTY: "hireDateEmpty",
    HIRE_DATE_IN_FUTURE: "hireDateInFuture",
    HIRE_DATE_IN_FUTURE_FOR_SELF: "hireDateInFutureForSelf",
    RELEASE_DATE_IS_BEFORE_HIRE_DATE: "releaseDateIsBeforeHireDate",
    RELEASE_DATE_WAS_BEFORE_HIRE_DATE: "releaseDateWasBeforeHireDate",
    DUPLICATE_USERNAME: "duplicateUsername",
    LAST_MANAGER_IN_OTHER_PRODUCT: "lastManagerInOtherProduct",
    EMAIL_INVALID: "emailInvalid",
    ACTION_CONFIRMED: "confirmed",
    ACTION_NOT_CONFIRMED: "not_confirmed",
    DUPLICATED_EFFECTIVE_DATE: "duplicatedEffectiveDate",
    DISABLED_DUE_TO_LICENSE_TERMS: "disabledDueToLicenseTerms",
    USER_RATES_ERROR: 'userRatesError',
    WORK_SCHEDULE_ERROR: 'workScheduleError',
    LEAVES_OR_TT_BEFORE_NEW_HIRE_DATE: 'LeavesOrTTBeforeNewHireDateException',
    WORKDAY_END_BEFORE_WORKDAY_START: 'workdayEndBeforeWorkdayStart'
};

var ValidationErrorsScrollClasses = exports.ValidationErrorsScrollClasses = {
    ACCOUNT_INFORMATION: 'accountInformationScrollPoint',
    TIME_TRACK_APPROVAL: 'timeTrackApprovalScrollPoint',
    WORK_SCHEDULE: 'workScheduleScrollPoint',
    DEFAULT_WORK_STATUS_PLANNING: 'defaultWorkStatusPlanningScrollPoint',
    USER_RATES: 'userRatesScrollPoint'
};

var ValidationErrorsToScrollClasses = exports.ValidationErrorsToScrollClasses = (_ValidationErrorsToSc = {}, _defineProperty(_ValidationErrorsToSc, ValidationErrors.FIRST_NAME_EMPTY, ValidationErrorsScrollClasses.ACCOUNT_INFORMATION), _defineProperty(_ValidationErrorsToSc, ValidationErrors.LAST_NAME_EMPTY, ValidationErrorsScrollClasses.ACCOUNT_INFORMATION), _defineProperty(_ValidationErrorsToSc, ValidationErrors.EMAIL_EMPTY, ValidationErrorsScrollClasses.ACCOUNT_INFORMATION), _defineProperty(_ValidationErrorsToSc, ValidationErrors.EMAIL_INVALID, ValidationErrorsScrollClasses.ACCOUNT_INFORMATION), _defineProperty(_ValidationErrorsToSc, ValidationErrors.PASSWORD_EMPTY, ValidationErrorsScrollClasses.ACCOUNT_INFORMATION), _defineProperty(_ValidationErrorsToSc, ValidationErrors.PASSWORD_RESTRICTIONS_VIOLATED, ValidationErrorsScrollClasses.ACCOUNT_INFORMATION), _defineProperty(_ValidationErrorsToSc, ValidationErrors.PASSWORDS_DO_NOT_MATCH, ValidationErrorsScrollClasses.ACCOUNT_INFORMATION), _defineProperty(_ValidationErrorsToSc, ValidationErrors.PASSWORD_COPY_EMPTY, ValidationErrorsScrollClasses.ACCOUNT_INFORMATION), _defineProperty(_ValidationErrorsToSc, ValidationErrors.USERNAME_EMPTY, ValidationErrorsScrollClasses.ACCOUNT_INFORMATION), _defineProperty(_ValidationErrorsToSc, ValidationErrors.USERNAME_DUPLICATE, ValidationErrorsScrollClasses.ACCOUNT_INFORMATION), _defineProperty(_ValidationErrorsToSc, ValidationErrors.NEW_USER_GROUP_EMPTY, ValidationErrorsScrollClasses.ACCOUNT_INFORMATION), _defineProperty(_ValidationErrorsToSc, ValidationErrors.NEW_TIME_ZONE_GROUP_EMPTY, ValidationErrorsScrollClasses.ACCOUNT_INFORMATION), _defineProperty(_ValidationErrorsToSc, ValidationErrors.DUPLICATE_TIME_ZONE_GROUP, ValidationErrorsScrollClasses.ACCOUNT_INFORMATION), _defineProperty(_ValidationErrorsToSc, ValidationErrors.CITY_DATA_EMPTY, ValidationErrorsScrollClasses.ACCOUNT_INFORMATION), _defineProperty(_ValidationErrorsToSc, ValidationErrors.HIRE_DATE_EMPTY, ValidationErrorsScrollClasses.ACCOUNT_INFORMATION), _defineProperty(_ValidationErrorsToSc, ValidationErrors.HIRE_DATE_IN_FUTURE, ValidationErrorsScrollClasses.ACCOUNT_INFORMATION), _defineProperty(_ValidationErrorsToSc, ValidationErrors.HIRE_DATE_IN_FUTURE_FOR_SELF, ValidationErrorsScrollClasses.ACCOUNT_INFORMATION), _defineProperty(_ValidationErrorsToSc, ValidationErrors.RELEASE_DATE_IS_BEFORE_HIRE_DATE, ValidationErrorsScrollClasses.ACCOUNT_INFORMATION), _defineProperty(_ValidationErrorsToSc, ValidationErrors.WORK_SCHEDULE_ERROR, ValidationErrorsScrollClasses.WORK_SCHEDULE), _defineProperty(_ValidationErrorsToSc, ValidationErrors.USER_RATES_ERROR, ValidationErrorsScrollClasses.USER_RATES), _ValidationErrorsToSc);

var ValidationErrorsScrollClassesPriority = exports.ValidationErrorsScrollClassesPriority = (_ValidationErrorsScro = {}, _defineProperty(_ValidationErrorsScro, ValidationErrorsScrollClasses.ACCOUNT_INFORMATION, 4), _defineProperty(_ValidationErrorsScro, ValidationErrorsScrollClasses.TIME_TRACK_APPROVAL, 3), _defineProperty(_ValidationErrorsScro, ValidationErrorsScrollClasses.WORK_SCHEDULE, 2), _defineProperty(_ValidationErrorsScro, ValidationErrorsScrollClasses.USER_RATES, 1), _ValidationErrorsScro);

var UserTeamAssignmentType = exports.UserTeamAssignmentType = {
    SELECTED: GC.UserTeamAssignmentType.SELECTED,
    ALL: GC.UserTeamAssignmentType.ALL,
    NO: GC.UserTeamAssignmentType.NO
};

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _constants = __webpack_require__(78);

Object.defineProperty(exports, 'Feature', {
  enumerable: true,
  get: function get() {
    return _constants.Feature;
  }
});

var _enabledFeatures = __webpack_require__(1300);

Object.defineProperty(exports, 'isEnabled', {
  enumerable: true,
  get: function get() {
    return _enabledFeatures.isEnabled;
  }
});

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _CLASS_MAP_BY_COLOR, _CLASS_MAP_BY_STATUS_, _STATUS_TYPE_CLASS_MA;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var GC = window.__GENERATED_CONSTANTS__;

var WorkflowStatusType = exports.WorkflowStatusType = {
    OPEN: GC.WorkflowStatusType.OPEN,
    COMPLETED: GC.WorkflowStatusType.COMPLETED
};

var COLORS = exports.COLORS = {
    PINK: 0,
    ORANGE: 1,
    YELLOW: 2,
    LIGHT_GREEN: 3,
    DARK_GREEN: 4,
    AQUAMARINE: 5,
    BLUE: 6,
    VIOLET: 7,
    LIGHT_GRAY: 8,
    DARK_GRAY: 9
};

var DEFAULT_COLOR_ID = exports.DEFAULT_COLOR_ID = COLORS.PINK;

/**
 * Map used for bound color id with css class contains relative colors
 *
 * see css/workflowStatus/status_colors_constants.less `.workflowStatusColorMixin` mixin
 * @type {{}}
 */
var CLASS_MAP_BY_COLOR = exports.CLASS_MAP_BY_COLOR = (_CLASS_MAP_BY_COLOR = {}, _defineProperty(_CLASS_MAP_BY_COLOR, COLORS.PINK, 'statusColor_pink'), _defineProperty(_CLASS_MAP_BY_COLOR, COLORS.ORANGE, 'statusColor_orange'), _defineProperty(_CLASS_MAP_BY_COLOR, COLORS.YELLOW, 'statusColor_yellow'), _defineProperty(_CLASS_MAP_BY_COLOR, COLORS.LIGHT_GREEN, 'statusColor_lightGreen'), _defineProperty(_CLASS_MAP_BY_COLOR, COLORS.DARK_GREEN, 'statusColor_darkGreen'), _defineProperty(_CLASS_MAP_BY_COLOR, COLORS.AQUAMARINE, 'statusColor_aquamarine'), _defineProperty(_CLASS_MAP_BY_COLOR, COLORS.BLUE, 'statusColor_blue'), _defineProperty(_CLASS_MAP_BY_COLOR, COLORS.VIOLET, 'statusColor_violet'), _defineProperty(_CLASS_MAP_BY_COLOR, COLORS.LIGHT_GRAY, 'statusColor_lightGray'), _defineProperty(_CLASS_MAP_BY_COLOR, COLORS.DARK_GRAY, 'statusColor_darkGray'), _CLASS_MAP_BY_COLOR);

/**
 * Map used for bound status type with css class with relative type images
 *
 * see css/workflowStatus/status_colors_constants.less `.workflowStatusTypeMixin` mixin
 * @type {{}}
 */
var CLASS_MAP_BY_STATUS_TYPE = exports.CLASS_MAP_BY_STATUS_TYPE = (_CLASS_MAP_BY_STATUS_ = {}, _defineProperty(_CLASS_MAP_BY_STATUS_, WorkflowStatusType.OPEN, 'statusType_open'), _defineProperty(_CLASS_MAP_BY_STATUS_, WorkflowStatusType.COMPLETED, 'statusType_completed'), _CLASS_MAP_BY_STATUS_);

/**
 * Map used for bound status type with css class with relative type images. Use with CLASS_MAP_BY_STATUS_TYPE
 *
 * see css/workflowStatus/status_colors_constants.less `.workflowStatusTypeMixin` mixin
 * @type {{}}
 */
var STATUS_TYPE_CLASS_MAP_BY_COLOR = exports.STATUS_TYPE_CLASS_MAP_BY_COLOR = (_STATUS_TYPE_CLASS_MA = {}, _defineProperty(_STATUS_TYPE_CLASS_MA, COLORS.PINK, 'statusTypeIcon_pink'), _defineProperty(_STATUS_TYPE_CLASS_MA, COLORS.ORANGE, 'statusTypeIcon_orange'), _defineProperty(_STATUS_TYPE_CLASS_MA, COLORS.YELLOW, 'statusTypeIcon_yellow'), _defineProperty(_STATUS_TYPE_CLASS_MA, COLORS.LIGHT_GREEN, 'statusTypeIcon_lightGreen'), _defineProperty(_STATUS_TYPE_CLASS_MA, COLORS.DARK_GREEN, 'statusTypeIcon_darkGreen'), _defineProperty(_STATUS_TYPE_CLASS_MA, COLORS.AQUAMARINE, 'statusTypeIcon_aquamarine'), _defineProperty(_STATUS_TYPE_CLASS_MA, COLORS.BLUE, 'statusTypeIcon_blue'), _defineProperty(_STATUS_TYPE_CLASS_MA, COLORS.VIOLET, 'statusTypeIcon_violet'), _defineProperty(_STATUS_TYPE_CLASS_MA, COLORS.LIGHT_GRAY, 'statusTypeIcon_lightGray'), _defineProperty(_STATUS_TYPE_CLASS_MA, COLORS.DARK_GRAY, 'statusTypeIcon_darkGray'), _STATUS_TYPE_CLASS_MA);

var FAKE_OPEN_WORKFLOW_STATUS_ID = exports.FAKE_OPEN_WORKFLOW_STATUS_ID = -10;
var FAKE_COMPLETED_WORKFLOW_STATUS_ID = exports.FAKE_COMPLETED_WORKFLOW_STATUS_ID = -20;

/**
 * Array of statuses that used when TWS feature off.
 * @type {*[]}
 */
var FAKE_WORKFLOW_STATUSES = exports.FAKE_WORKFLOW_STATUSES = [{
    id: FAKE_OPEN_WORKFLOW_STATUS_ID,
    type: WorkflowStatusType.OPEN,
    position: 0,
    colorId: COLORS.LIGHT_GREEN,
    name: 'Open'
}, {
    id: FAKE_COMPLETED_WORKFLOW_STATUS_ID,
    type: WorkflowStatusType.COMPLETED,
    position: 1,
    colorId: COLORS.DARK_GRAY,
    name: 'Completed'
}];

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.abortCall = exports.longRpcCall = exports.rpcCall = undefined;
exports.batchedRpcCall = batchedRpcCall;

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _jquery_rpc = __webpack_require__(26);

var _jquery_rpc2 = _interopRequireDefault(_jquery_rpc);

var _RpcError = __webpack_require__(281);

var _RpcError2 = _interopRequireDefault(_RpcError);

var _batch = __webpack_require__(117);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// global storage of current rpc calls
var rpcCalls = {};

/**
 *
 * Perform rpc call and return promise function
 *
 * @param method
 * @param params
 * @param customHandler handler if need to prevent default error handler
 * @param abortKey string key
 *                 used to identify running rpcCall, by this key you can abort request
 *                 if key is null - request can not be aborted
 *                 default value equals name of requested method
 * @returns {Promise}
 */
var rpcCall = exports.rpcCall = function rpcCall(method, params) {
    var customHandler = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (error) {
        return null;
    };
    var abortKey = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : method;

    if (abortKey) abortCall(abortKey);

    return new Promise(function (resolve, reject) {
        var call = (0, _jquery_rpc2.default)(method, params, function (data) {
            if (abortKey) _removeCall(abortKey);
            resolve(data);
        }, function (jqXHR, textStatus, errorThrown) {
            if (abortKey) _removeCall(abortKey);

            // create error
            var error = new _RpcError2.default(jqXHR, textStatus, errorThrown);
            // TODO: get rid of legacy custome handler behavior - don't rely on it returning true/false
            var isHandled_legacy = customHandler(error);
            if (error.isHandled()) {
                reject(error.getNewError() !== null ? error.getNewError() : error);
                return true;
            } else {
                reject(error);
                return isHandled_legacy;
            }
        });

        if (abortKey) _addCall(abortKey, call);
    });
};

var _addCall = function _addCall(abortKey, call) {
    rpcCalls[abortKey] = call;
};

var _removeCall = function _removeCall(abortKey) {
    rpcCalls = _underscore2.default.omit(rpcCalls, abortKey);
};

var LONG_TASK_POLL_INTERVAL = 10000;
/**
 * Wraps potentially long RPC call, so if it ends with timeout
 * then this function does not return error immediately. Instead
 * it periodically polls server for response of call made (not repeating same call, just
 * waiting for response)
 *
 * That is done via  'LongTaskService'
 *
 * TLDR: if your 'method' is fast, use 'rpcCall', if it may be slow
 * and may do longer than 60 seconds - use 'longRpcCall'
 */
var longRpcCall = exports.longRpcCall = function longRpcCall(method, params) {
    var customHandler = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (error) {
        return null;
    };
    var abortKey = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : method;

    var longTaskId = crypto.randomUUID();

    function pollForResult(originalTimeoutError) {
        return new Promise(function (resolve, reject) {
            var doPoll = function doPoll() {
                return setTimeout(function () {
                    rpcCall("LongTaskService.getStatus", [longTaskId]).then(function (_ref) {
                        var registered = _ref.registered,
                            finished = _ref.finished,
                            result = _ref.result;

                        if (!registered) {
                            reject(originalTimeoutError); //timeout
                        } else if (finished) {
                            resolve(result.result);
                        } else {
                            doPoll();
                        }
                    }).catch(function (error) {
                        reject(error);
                    });
                }, LONG_TASK_POLL_INTERVAL);
            };
            doPoll();
        });
    }

    function isTimeout(error) {
        return error.getTextStatus() === "timeout" || error.getJQXHR().status === 504;
    }

    function errorHandler(error) {
        if (isTimeout(error)) {
            //prevent default processing
            error.handle();
        } else {
            return customHandler(error);
        }
    }

    return rpcCall("LongTaskService.longTask", [longTaskId, method, params], errorHandler, abortKey).then(function (result) {
        rpcCall("LongTaskService.resultReceived", [longTaskId]);
        return result;
    }).catch(function (e) {
        if (isTimeout(e) && e.isHandled()) {
            return pollForResult(e);
        } else {
            throw e;
        }
    });
};

/**
 * Abort rpc call by key
 * @param abortKey
 */
var abortCall = exports.abortCall = function abortCall(abortKey) {
    var call = rpcCalls[abortKey];
    if (call) {
        call.abort();
        _removeCall(abortKey);
    }
};

/**
 * Version of 'rpcCall' with enabled redux batching.
 * Use it instead of standard 'rpcCall' if you want to enable batching in result promise.
 * @returns {BatchPromiseWrapper}
 */
function batchedRpcCall(method, params) {
    var customHandler = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {
        return null;
    };
    var abortKey = arguments[3];

    return (0, _batch.batchedPromise)(rpcCall(method, params, (0, _batch.batched)(customHandler), abortKey));
}

exports.default = rpcCall;

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getFakeUpdateAuditAction = exports.resolveAuditActions = undefined;
exports.setEventPreventHiding = setEventPreventHiding;
exports.shouldEventPreventHiding = shouldEventPreventHiding;
exports.shouldEventPreventHidingAllPanels = shouldEventPreventHidingAllPanels;
exports.setEventPreventHidingEditUserSlidingPanel = setEventPreventHidingEditUserSlidingPanel;
exports.shouldEventPreventHidingEditUserSlidingPanel = shouldEventPreventHidingEditUserSlidingPanel;
exports.setEventPreventHidingEditProjectSlidingPanel = setEventPreventHidingEditProjectSlidingPanel;
exports.shouldEventPreventHidingEditProjectSlidingPanel = shouldEventPreventHidingEditProjectSlidingPanel;
exports.setEventPreventHidingEditCustomerSlidingPanel = setEventPreventHidingEditCustomerSlidingPanel;
exports.shouldEventPreventHidingEditCustomerSlidingPanel = shouldEventPreventHidingEditCustomerSlidingPanel;
exports.setEventPreventHidingEditTaskSlidingPanel = setEventPreventHidingEditTaskSlidingPanel;
exports.shouldEventPreventHidingEditTaskSlidingPanel = shouldEventPreventHidingEditTaskSlidingPanel;
exports.setEventPreventHidingCreateTaskSlidingPanel = setEventPreventHidingCreateTaskSlidingPanel;
exports.setEventPreventHidingWorkAssignmentSlidingPanel = setEventPreventHidingWorkAssignmentSlidingPanel;
exports.shouldEventPreventHidingWorkAssignmentSlidingPanel = shouldEventPreventHidingWorkAssignmentSlidingPanel;
exports.setEventPreventHidingTeamAssignmentSlidingPanel = setEventPreventHidingTeamAssignmentSlidingPanel;
exports.shouldEventPreventHidingTeamAssignmentSlidingPanel = shouldEventPreventHidingTeamAssignmentSlidingPanel;
exports.setEventPreventHidingWorkAssignmentsEditorSlidingPanel = setEventPreventHidingWorkAssignmentsEditorSlidingPanel;
exports.setEventPreventHidingManagementAssignmentsEditorSlidingPanel = setEventPreventHidingManagementAssignmentsEditorSlidingPanel;
exports.setEventPreventHidingManagementAssignmentsSlidingPanel = setEventPreventHidingManagementAssignmentsSlidingPanel;
exports.setEventPreventHidingAllPanels = setEventPreventHidingAllPanels;

var _constants = __webpack_require__(62);

var _atBrowserUtils = __webpack_require__(8);

var _UserNameFormat = __webpack_require__(17);

var _UserNameFormat2 = _interopRequireDefault(_UserNameFormat);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Sets property to event. Uses when needs to prevent element hiding.
 * @param e Event.
 * @param elementType Unique type of element that is needed to prevent from hiding.
 */
function setEventPreventHiding(e, elementType) {
    e.originalEvent[getPropertyName(elementType)] = true;
}

function shouldEventPreventHiding(e, elementType) {
    return e.originalEvent && e.originalEvent[getPropertyName(elementType)] || (0, _atBrowserUtils.checkElementOrAncestorHasClass)(e.target, 'preventPanelsHiding');
}

function shouldEventPreventHidingAllPanels(e) {
    return e.originalEvent && e.originalEvent[getPropertyName(_constants.PANEL_TYPES.ALL)];
}

function getPropertyName(elementType) {
    return '_at_' + elementType + '_preventHiding';
}

function setEventPreventHidingEditUserSlidingPanel(e) {
    setEventPreventHiding(e, _constants.PANEL_TYPES.EDIT_USER);
}

function shouldEventPreventHidingEditUserSlidingPanel(e) {
    return shouldEventPreventHiding(e, _constants.PANEL_TYPES.EDIT_USER);
}

function setEventPreventHidingEditProjectSlidingPanel(e) {
    setEventPreventHiding(e, _constants.PANEL_TYPES.EDIT_PROJECT);
}

function shouldEventPreventHidingEditProjectSlidingPanel(e) {
    return shouldEventPreventHiding(e, _constants.PANEL_TYPES.EDIT_PROJECT);
}

function setEventPreventHidingEditCustomerSlidingPanel(e) {
    setEventPreventHiding(e, _constants.PANEL_TYPES.EDIT_CUSTOMER);
}

function shouldEventPreventHidingEditCustomerSlidingPanel(e) {
    return shouldEventPreventHiding(e, _constants.PANEL_TYPES.EDIT_CUSTOMER);
}

function setEventPreventHidingEditTaskSlidingPanel(e) {
    setEventPreventHiding(e, _constants.PANEL_TYPES.EDIT_TASK);
}

function shouldEventPreventHidingEditTaskSlidingPanel(e) {
    return shouldEventPreventHiding(e, _constants.PANEL_TYPES.EDIT_TASK);
}

function setEventPreventHidingCreateTaskSlidingPanel(e) {
    setEventPreventHiding(e, _constants.PANEL_TYPES.CREATE_TASK);
}

function setEventPreventHidingWorkAssignmentSlidingPanel(e) {
    setEventPreventHiding(e, _constants.PANEL_TYPES.WORK_ASSIGNMENTS_PANEL);
}

function shouldEventPreventHidingWorkAssignmentSlidingPanel(e) {
    return shouldEventPreventHiding(e, _constants.PANEL_TYPES.WORK_ASSIGNMENTS_PANEL);
}

function setEventPreventHidingTeamAssignmentSlidingPanel(e) {
    setEventPreventHiding(e, _constants.PANEL_TYPES.TEAM_ASSIGNMENT);
}

function shouldEventPreventHidingTeamAssignmentSlidingPanel(e) {
    return shouldEventPreventHiding(e, _constants.PANEL_TYPES.TEAM_ASSIGNMENT);
}

function setEventPreventHidingWorkAssignmentsEditorSlidingPanel(e) {
    setEventPreventHiding(e, _constants.PANEL_TYPES.WORK_ASSIGNMENTS_EDITOR);
}

function setEventPreventHidingManagementAssignmentsEditorSlidingPanel(e) {
    setEventPreventHiding(e, _constants.PANEL_TYPES.MANAGEMENT_ASSIGNMENTS_EDITOR);
}

function setEventPreventHidingManagementAssignmentsSlidingPanel(e) {
    setEventPreventHiding(e, _constants.PANEL_TYPES.MANAGEMENT_ASSIGNMENTS_PANEL);
}

function setEventPreventHidingAllPanels(e) {
    setEventPreventHiding(e, _constants.PANEL_TYPES.ALL);
}

var resolveAuditActions = exports.resolveAuditActions = function resolveAuditActions(auditActions, dependencies, auditType) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = auditActions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var auditAction = _step.value;

            if (auditAction['data']) auditAction['data'] = JSON.parse(auditAction['data']);
            auditAction['subject']['data'] = JSON.parse(auditAction['subject']['data']);
            auditAction['dependencies'] = auditAction['dependencies'].list.map(function (key) {
                var found = dependencies.find(function (dependency) {
                    return dependency['type'] === key['type'] && dependency['id'] === key['id'];
                });
                if (_.isString(found['data'])) {
                    found['data'] = JSON.parse(found['data']);
                }
                return found;
            });
            auditAction.object = { type: auditType };
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    return auditActions;
};

var getFakeUpdateAuditAction = exports.getFakeUpdateAuditAction = function getFakeUpdateAuditAction(loggedInUser) {
    var updateAction = {
        timestamp: currentUserTime().format(Date.JSON_TIME_FORMAT),
        subject: {
            data: JSON.stringify({ name: _UserNameFormat2.default.formatLFM(loggedInUser.firstName, loggedInUser.lastName, loggedInUser.middleName) })
        },
        type: null //we don't need to specify type, because we don't know what event happened
    };
    return updateAction;
};

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = makeRpcCall;
/**
 * @author kostenko
 *
 * Makes a JSON-RPC request using jQuery.
 *
 * Requires at.js and constants_js.jsp
 *
 * @param method method to call
 * @param params method params
 *
 * @param [successHandler] function (data, textStatus, jqXHR) success callback function.
 *              It has the same signature as the 'success' callback of jQuery ajax() function,
 *              but the passed 'data' is not the whole AJAX response body, but a JSON-RPC response result field only.
 *              In case of JSON-RPC error, this callback is not called at all, and 'errorHandler' is invoked instead.
 *
 * @param [errorHandler] function (jqXHR, textStatus, errorThrown) error callback function.
 *              It has the same signature as the 'error' callback of jQuery.ajax() function,
 *              but is called also on JSON-RPC-level errors. In those cases, textStatus will be one of the following :
 *                rpc_sessionExpired
 *                rpc_noRights
 *                rpc_customException
 *                rpc_unexpectedError
 *              and errorThrown will be the JSON-RPC error object. For the convenience, errorThrown.exception property
 *              will contain the full name of the exception class, extracted from errorThrown.trace property.
 *
 *              NOTE: this handler is invoked also when the request is aborted by the client code.
 *              It may appear unexpected, but this is how jQuery.ajax() works, and we don't treat this situation
 *              in a special way (except as noted below).
 *
 *              The error handler must return true if the error is fully handled and no more action is needed.
 *              If any other value is returned or if there's no error handler provided at all, the built-in handler is
 *              invoked.
 *
 *              The built-in handler provides the generic behaviour for the following cases:
 *              - if the request was aborted by the client code then nothing is done
 *              - on timeout an alert is displayed
 *              - if user session has expired then an alert is shown and the page is reloaded
 *              - if the user has no required rights or account is disabled, an alert is shown and the page is reloaded
 *              - on any other error (including unexpected) an alert with the appropriate error message is shown,
 *                and a stack trace, if present, is written to the browser console.
 *
 * @param [alertErrorMessagePrefix] a string that will be shown in the beginning of error alerts
 *
 * @param [timeout] timeout in ms (default is 60000)
 *
 * @return the jqXHR object
 *
 * @name PRODUCT_NAME (defined in constants_js.jsp)
 * @name RPC_LINK (defined in constants_js.jsp)
 * @name JQUERY_RPC_ERROR_MESSAGES (defined in constants_js.jsp)
 */
function makeRpcCall(method, params, successHandler, errorHandler, alertErrorMessagePrefix, timeout) {
    if (!successHandler) successHandler = function successHandler() {};

    if (!errorHandler) errorHandler = function errorHandler() {};

    if (alertErrorMessagePrefix) alertErrorMessagePrefix += "\n\n";else alertErrorMessagePrefix = "";

    var alertWithPrefix = function alertWithPrefix(msg) {
        alert(alertErrorMessagePrefix + msg);
    };

    var JSON_RPC_ERROR_EXCEPTION = 490;
    var JSON_RPC_ERROR_NO_SUCH_METHOD = 591;
    var EXCEPTION_NO_RIGHTS = "com.actimind.actitime.services.NoRightsForRemoteCallException";
    var EXCEPTION_FUTURE_HIRE_DATE = "com.actimind.common.services.AccountHireDateInFutureException";
    var SESSION_NOT_VALID_EXCEPTION = 'com.actimind.actitime.services.SessionNotValidException';

    function showUnexpectedErrorMessage(details) {
        alertWithPrefix(JQUERY_RPC_ERROR_MESSAGES.UNEXPECTED_ERROR + details);
    }

    /**
     * @param jqXHR
     * @config status
     * @config statusText
     * @param textStatus
     * @param errorThrown
     * @config code
     * @config exception
     * @config trace
     */
    function combinedErrorHandler(jqXHR, textStatus, errorThrown) {
        if (!errorHandler(jqXHR, textStatus, errorThrown)) {
            switch (textStatus) {

                case 'abort':
                    break; // the request was aborted by the calling code; do nothing

                case 'timeout':
                    alertWithPrefix(JQUERY_RPC_ERROR_MESSAGES.TIMEOUT);
                    break;

                case 'rpc_sessionExpired':
                case 'rpc_session_not_valid':
                    alertWithPrefix(JQUERY_RPC_ERROR_MESSAGES.SESSION_EXPIRED);
                    ExitConfirmationHandlersManager.resetExitConfirmation();
                    document.location.reload();
                    break;

                case 'rpc_noRights':
                    alertWithPrefix(JQUERY_RPC_ERROR_MESSAGES.NO_RIGHTS);
                    ExitConfirmationHandlersManager.resetExitConfirmation();
                    document.location.reload();
                    break;

                case 'rpc_future_hire_date':
                    alertWithPrefix(JQUERY_RPC_ERROR_MESSAGES.FUTURE_HIRE_DATE);
                    ExitConfirmationHandlersManager.resetExitConfirmation();
                    document.location.reload();
                    break;

                case 'rpc_customException':
                case 'rpc_unexpectedError':
                    if (errorThrown.trace) console.log(errorThrown.trace);

                    showUnexpectedErrorMessage(JQUERY_RPC_ERROR_MESSAGES.JSON_RPC_ERROR + " " + errorThrown.code + (errorThrown.exception ? "\n" + JQUERY_RPC_ERROR_MESSAGES.EXCEPTION + " " + errorThrown.exception : "") + "\n" + JQUERY_RPC_ERROR_MESSAGES.MESSAGE + " " + errorThrown.msg + (errorThrown.trace ? JQUERY_RPC_ERROR_MESSAGES.MORE_INFO : ""));
                    break;

                case 'parseerror':
                    showUnexpectedErrorMessage(JQUERY_RPC_ERROR_MESSAGES.PARSE_ERROR);
                    break;

                case 'error':
                    if (jqXHR.status >= 100 && jqXHR.status < 1000) {
                        showUnexpectedErrorMessage(JQUERY_RPC_ERROR_MESSAGES.HTTP_ERROR + " " + jqXHR.status + " " + jqXHR.statusText);
                    } else {
                        alertWithPrefix(JQUERY_RPC_ERROR_MESSAGES.NETWORK_ERROR);
                    }
                    break;

                default:
                    showUnexpectedErrorMessage(JQUERY_RPC_ERROR_MESSAGES.TEXT_STATUS + " " + textStatus + "\n" + JQUERY_RPC_ERROR_MESSAGES.ERROR_THROWN + " " + errorThrown);
            }
        }
    }

    /**
     * @param data
     * @config result
     * @config error
     * @param textStatus
     * @param jqXHR
     */
    function combinedSuccessHandler(data, textStatus, jqXHR) {
        if (data.error) {

            switch (data.error.code) {

                case JSON_RPC_ERROR_NO_SUCH_METHOD:
                    // on healthy installation this most probably means that the session has expired
                    // and auto-login is off

                    combinedErrorHandler(jqXHR, 'rpc_sessionExpired', data.error);
                    break;

                case JSON_RPC_ERROR_EXCEPTION:
                    data.error.exception = getExceptionNameFromTrace(data.error.trace);

                    if (data.error.exception == EXCEPTION_NO_RIGHTS) {
                        // this may also mean that the user's account is disabled, there's no way to determine it exactly
                        combinedErrorHandler(jqXHR, 'rpc_noRights', data.error);
                    } else if (data.error.exception == EXCEPTION_FUTURE_HIRE_DATE) {
                        combinedErrorHandler(jqXHR, 'rpc_future_hire_date', data.error);
                    } else if (data.error.exception == SESSION_NOT_VALID_EXCEPTION) {
                        combinedErrorHandler(jqXHR, 'rpc_session_not_valid', data.error);
                    } else combinedErrorHandler(jqXHR, 'rpc_customException', data.error);
                    break;

                default:
                    combinedErrorHandler(jqXHR, 'rpc_unexpectedError', data.error);
            }
        } else {
            successHandler(data.result, textStatus, jqXHR);
        }
    }

    return $.ajax({
        dataType: 'json',
        contentType: 'application/json',
        type: 'POST',
        url: RPC_LINK,
        data: JSON.stringify({ method: method, params: params }),
        headers: { "X-RPC-Method": method },
        success: combinedSuccessHandler,
        error: combinedErrorHandler,
        timeout: timeout ? timeout : 60000
    });
}

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getTaskCustomFieldsMap = exports.getNextWorkflowStatusesIsLoaded = exports.getTasksSelectionFilters = exports.isBulkOperationsPanelShown = exports.isCPPanelClosed = exports.isNeedToShowSelection = exports.isNeedToShowScopeFilter = exports.isViewerCanManageAllTasksOfCPSelection = exports.getCustomerIdsWhereCanManageLeastOneProject = exports.getEditableCustomerIdsWithExcludeSelf = exports.getEditableCustomerIds = exports.getManageableCustomerIdsWithExcludeSelf = exports.getManageableCustomerIds = exports.getEditableProjectIdsWithExcludeSelf = exports.getEditableProjectIds = exports.isPossibleToAddTasks = exports.getManageableProjectsWithExcludeSelf = exports.getManageableProjectIdsWithExcludeSelf = exports.getManageableProjectIds = exports.getEditableTaskIds = exports.getManageableTaskIds = exports.isPossibleToAddProjects = exports.isPossibleToAddCustomers = exports.getManageableProjects = exports.isSelectedProjectArchived = exports.canManageSelectedProject = exports.canViewerEditTaskStatus = exports.isViewerHasManageableTasks = exports.isViewerHasNoTeamAccess = exports.isViewerHasAccessToAllManagementScope = exports.getViewerSettings = exports.getCustomersManagementAssignments = exports.getManagementAssignments = exports.getRecentlyCreatedTaskIds = exports.getTaskNameFilter = exports.getCustomFieldsFilters = exports.getFilteredTaskStatusIds = exports.getNextTaskStatusFilter = exports.getTaskStatusFilter = exports.isSingleCustomerSelected = exports.isSingleProjectSelected = exports.getIntersectedCPSelection = exports.getCustomerProjectNameFilter = exports.getFilterCPSelection = exports.getSingleCPSelection = exports.getViewMode = exports.isShowViewMode = exports.getSelectedFilterKeys = exports.getAvailableFiltersSet = exports.getAvailableFilters = exports.getSelectedViewMode = exports.isShowOnlyManageableTasks = exports.getLastCreatedTaskIds = exports.getRecentlyCreatedProjectIds = exports.getRecentlyCreatedCustomerIds = exports.getCommonState = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reselect = __webpack_require__(13);

var _selectors = __webpack_require__(189);

var _atUtils = __webpack_require__(5);

var _utils = __webpack_require__(486);

var _features = __webpack_require__(22);

var _selectors2 = __webpack_require__(14);

var _utils2 = __webpack_require__(242);

var _constants = __webpack_require__(44);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _selectors3 = __webpack_require__(15);

var _selectors4 = __webpack_require__(19);

var _selectors5 = __webpack_require__(190);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var getCommonState = exports.getCommonState = (0, _reselect.createSelector)(_selectors.selectTaskManagement, function (tmState) {
    return tmState.common;
});

var getRecentlyCreatedCustomerIds = exports.getRecentlyCreatedCustomerIds = function getRecentlyCreatedCustomerIds(state) {
    return getCommonState(state).recentlyCreatedCustomerIds;
};
var getRecentlyCreatedProjectIds = exports.getRecentlyCreatedProjectIds = function getRecentlyCreatedProjectIds(state) {
    return getCommonState(state).recentlyCreatedProjectIds;
};
var getLastCreatedTaskIds = exports.getLastCreatedTaskIds = function getLastCreatedTaskIds(state) {
    return getCommonState(state).lastCreatedTaskIds;
};

var isShowOnlyManageableTasks = exports.isShowOnlyManageableTasks = function isShowOnlyManageableTasks(state) {
    return getCommonState(state).showOnlyManageableTasks;
};

var getSelectedViewMode = exports.getSelectedViewMode = (0, _reselect.createSelector)(getCommonState, function (commonState) {
    return commonState.viewMode;
});

var getAvailableFilters = exports.getAvailableFilters = (0, _reselect.createSelector)(_selectors5.selectTaskCustomFields, function (customFields) {
    var customFieldsFilters = customFields.map(function (customField) {
        return {
            key: customField.fieldName,
            title: customField.title
        };
    });

    return [].concat(_toConsumableArray(_constants.TaskListStaticFilters), _toConsumableArray(customFieldsFilters));
});

var getAvailableFiltersSet = exports.getAvailableFiltersSet = (0, _reselect.createSelector)(getAvailableFilters, function (availableFilters) {
    return new Set(availableFilters.map(function (filter) {
        return filter.key;
    }));
});

var getSelectedFilterKeys = exports.getSelectedFilterKeys = (0, _reselect.createSelector)(getCommonState, getAvailableFiltersSet, function (commonState, availableFiltersSet) {
    return commonState.selectedFilterKeys.filter(function (key) {
        return availableFiltersSet.has(key);
    });
});

var isShowViewMode = exports.isShowViewMode = (0, _reselect.createSelector)(_selectors3.isTWSEnabled, function (enabled) {
    return enabled;
});

var getViewMode = exports.getViewMode = (0, _reselect.createSelector)(isShowViewMode, getSelectedViewMode, function (showViewMode, selectedViewMode) {
    return showViewMode ? selectedViewMode : _constants.TaskManagementViewMode.TABLE;
});

var getSingleCPSelection = exports.getSingleCPSelection = (0, _reselect.createSelector)(getCommonState, _selectors2.getCustomers, _selectors2.getProjects, function (commonState, customers, projects) {
    var _commonState$singleCu = commonState.singleCustomerProjectSelection,
        projectId = _commonState$singleCu.projectId,
        customerId = _commonState$singleCu.customerId;


    if (projectId !== null && !projects[projectId]) {
        projectId = null;
    }
    if (customerId !== null && !customers[customerId]) {
        customerId = null;
        projectId = null;
    }

    return {
        customerId: customerId,
        projectId: projectId
    };
});

var getFilterCPSelection = exports.getFilterCPSelection = (0, _reselect.createSelector)(getCommonState, function (commonState) {
    return commonState.filterCustomerProjectSelection;
});

var getCustomerProjectNameFilter = exports.getCustomerProjectNameFilter = function getCustomerProjectNameFilter(state) {
    return getCommonState(state).customerProjectNameFilter;
};

var getIntersectedCPSelection = exports.getIntersectedCPSelection = (0, _reselect.createSelector)(getFilterCPSelection, getSingleCPSelection, _selectors2.getCustomers, _selectors2.getProjects, function (filterCPSelection, singleCPSelection, customers, projects) {
    return (0, _utils2.createIntersectedCPSelection)(filterCPSelection, singleCPSelection, customers, projects).toPlainObject();
});

var isSingleProjectSelected = exports.isSingleProjectSelected = (0, _reselect.createSelector)(getSingleCPSelection, function (singleCPSelection) {
    return singleCPSelection.customerId !== null && singleCPSelection.projectId !== null;
});

var isSingleCustomerSelected = exports.isSingleCustomerSelected = (0, _reselect.createSelector)(getSingleCPSelection, function (singleCPSelection) {
    return singleCPSelection.customerId !== null && singleCPSelection.projectId === null;
});

var getTaskStatusFilterInitial = (0, _reselect.createSelector)(getCommonState, function (commonState) {
    return commonState.taskStatusFilter;
});

var getCustomFieldsFiltersInitial = (0, _reselect.createSelector)(getCommonState, function (commonState) {
    return commonState.customFieldsFilters;
});

var removeDeletedStatusesFromFilter = function removeDeletedStatusesFromFilter(taskStatusFilter, statusesMap) {
    var filter = {
        allSelected: false,
        statusIds: [],
        statusTypes: []
    };

    filter.statusIds = taskStatusFilter.statusIds.filter(function (statusId) {
        return !!statusesMap[statusId];
    });
    if (filter.statusIds.length === 0 && taskStatusFilter.statusTypes.length === 0) filter.allSelected = true;
    filter.statusTypes = taskStatusFilter.statusTypes;

    return filter;
};

var getTaskStatusFilter = exports.getTaskStatusFilter = (0, _reselect.createSelector)(getTaskStatusFilterInitial, _selectors2.getWorkflowStatuses, getSelectedFilterKeys, function (filter, statusesMap, selectedFilterKeys) {
    if (!(0, _features.isEnabled)(_features.Feature.TWS) && filter.statusIds.length > 0 || !selectedFilterKeys.includes(_constants.TaskFieldFilterKey.STATUS)) return _utils.ALL_FILTER;else {
        return removeDeletedStatusesFromFilter(filter, statusesMap);
    }
});

var getNextTaskStatusFilter = exports.getNextTaskStatusFilter = (0, _reselect.createSelector)(getTaskStatusFilter, _selectors2.getWorkflowStatuses, function (filter, statusesMap) {
    var statusIds = filter.statusIds.map(function (statusId) {
        return statusesMap[statusId] ? statusesMap[statusId].nextId : statusId;
    });
    return _extends({}, filter, {
        statusIds: statusIds
    });
});

var getFilteredTaskStatusIds = exports.getFilteredTaskStatusIds = (0, _reselect.createSelector)(getTaskStatusFilter, _selectors2.getWorkflowStatusesArray, function (filter, taskStatuses) {
    var result = [];

    if (filter.allSelected) {
        return taskStatuses.map(function (taskStatus) {
            return taskStatus.id;
        });
    }
    if (filter.statusTypes.length !== 0) {
        result = taskStatuses.filter(function (taskStatus) {
            return filter.statusTypes.includes(taskStatus.type);
        }).map(function (taskStatus) {
            return taskStatus.id;
        });
    }
    if (filter.statusIds.length !== 0) {
        result = [].concat(_toConsumableArray(result), _toConsumableArray(taskStatuses.filter(function (taskStatus) {
            return filter.statusIds.includes(taskStatus.id);
        }).map(function (taskStatus) {
            return taskStatus.id;
        })));
    }

    return result;
});

var getCustomFieldsFilters = exports.getCustomFieldsFilters = (0, _reselect.createSelector)(getCustomFieldsFiltersInitial, getAvailableFilters, getSelectedFilterKeys, _selectors5.selectTaskCustomFields, function (customFieldsFilters, availableFilters, selectedFilterKeys, customFields) {
    return Object.fromEntries(Object.entries(customFieldsFilters).filter(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            key = _ref2[0],
            values = _ref2[1];

        var customField = customFields.find(function (field) {
            return field.fieldName === key;
        });
        if (!customField || values === null) return false;

        return availableFilters.find(function (filter) {
            return filter.key === key;
        }) && selectedFilterKeys.includes(key);
    }).map(function (_ref3) {
        var _ref4 = _slicedToArray(_ref3, 2),
            key = _ref4[0],
            values = _ref4[1];

        var customField = customFields.find(function (field) {
            return field.fieldName === key;
        });

        if (!customField.options) return [key, values];

        return [key, values.filter(function (value) {
            return customField.options.find(function (option) {
                return value === option.value;
            });
        })];
    }));
});

var getTaskNameFilter = exports.getTaskNameFilter = (0, _reselect.createSelector)(getCommonState, function (commonState) {
    return commonState.taskNameFilter;
});

var getRecentlyCreatedTaskIds = exports.getRecentlyCreatedTaskIds = function getRecentlyCreatedTaskIds(state) {
    return getCommonState(state).recentlyCreatedTaskIds;
};

var getManagementAssignments = exports.getManagementAssignments = (0, _reselect.createSelector)(getCommonState, function (commonState) {
    return commonState.managementAssignments;
});

var getCustomersManagementAssignments = exports.getCustomersManagementAssignments = (0, _reselect.createSelector)(getManagementAssignments, function (managementAssignments) {
    return managementAssignments.customers;
});

var getViewerSettings = exports.getViewerSettings = (0, _reselect.createSelector)(getCommonState, function (commonState) {
    return commonState.viewerSettings;
});

var isViewerHasAccessToAllManagementScope = exports.isViewerHasAccessToAllManagementScope = (0, _reselect.createSelector)(getViewerSettings, function (viewerSettings) {
    return viewerSettings.hasAccessToAllManagementScope;
});

var isViewerHasNoTeamAccess = exports.isViewerHasNoTeamAccess = (0, _reselect.createSelector)(getViewerSettings, function (viewerSettings) {
    return viewerSettings.noTeamAccess;
});

var isViewerHasManageableTasks = exports.isViewerHasManageableTasks = (0, _reselect.createSelector)(getCommonState, function (commonState) {
    return commonState.hasManageableTasks;
});

var canViewerEditTaskStatus = exports.canViewerEditTaskStatus = (0, _reselect.createSelector)(getViewerSettings, function (viewerSettings) {
    return viewerSettings.canEditTaskStatus;
});

var canManageSelectedProject = exports.canManageSelectedProject = (0, _reselect.createSelector)(getViewerSettings, getManagementAssignments, getSingleCPSelection, _selectors2.getProjects, function (viewerSettings, ma, cpSelection) {
    return !!cpSelection.projectId && viewerSettings.hasEditHierarchyRight && (viewerSettings.hasAccessToAllManagementScope || !!ma.customers[cpSelection.customerId] || !!ma.projects[cpSelection.projectId]);
});

var isSelectedProjectArchived = exports.isSelectedProjectArchived = (0, _reselect.createSelector)(getSingleCPSelection, _selectors2.getProjects, function (cpSelection, projects) {
    return !!cpSelection.projectId && !!projects[cpSelection.projectId] && projects[cpSelection.projectId].archived;
});

var getManageableProjects = exports.getManageableProjects = (0, _reselect.createSelector)(getViewerSettings, _selectors2.getProjects, getManagementAssignments, function (viewerSettings, projects, ma) {
    return viewerSettings.hasAccessToAllManagementScope ? projects : (0, _utils2.getProjectsFilteredByAssignments)(Object.values(projects), ma);
});

var isPossibleToAddCustomers = exports.isPossibleToAddCustomers = (0, _reselect.createSelector)(getViewerSettings, function (viewerSettings) {
    return viewerSettings.hasEditHierarchyRight && viewerSettings.hasAccessToAllManagementScope;
});

var isPossibleToAddProjects = exports.isPossibleToAddProjects = (0, _reselect.createSelector)(getViewerSettings, getCustomersManagementAssignments, function (viewerSettings, customersMA) {
    return viewerSettings.hasEditHierarchyRight && (viewerSettings.hasAccessToAllManagementScope || !_underscore2.default.isEmpty(customersMA));
});

var getManageableTaskIds = exports.getManageableTaskIds = (0, _reselect.createSelector)(getViewerSettings, _selectors2.getTasks, getManagementAssignments, function (viewerSettings, tasks, ma) {
    return viewerSettings.hasAccessToAllManagementScope ? (0, _atUtils.arrayToSet)(Object.keys(tasks)) : (0, _atUtils.arrayToSet)((0, _utils2.getTaskIdsFilteredByAssignments)(Object.values(tasks), ma));
});

var getEditableTaskIds = exports.getEditableTaskIds = (0, _reselect.createSelector)(_selectors4.canEditHierarchy, getManageableTaskIds, function (canEditHierarchy, tIds) {
    return canEditHierarchy ? tIds : {};
});

var getManageableProjectIds = exports.getManageableProjectIds = (0, _reselect.createSelector)(getViewerSettings, _selectors2.getProjects, getManagementAssignments, function (viewerSettings, projects, ma) {
    return viewerSettings.hasAccessToAllManagementScope ? (0, _atUtils.arrayToSet)(Object.keys(projects)) : (0, _atUtils.arrayToSet)((0, _utils2.getProjectIdsFilteredByAssignments)(Object.values(projects), ma));
});

var getManageableProjectIdsWithExcludeSelf = exports.getManageableProjectIdsWithExcludeSelf = (0, _reselect.createSelector)(getViewerSettings, _selectors2.getProjects, getManagementAssignments, function (viewerSettings, projects, ma) {
    return viewerSettings.hasAccessToAllManagementScope ? (0, _atUtils.arrayToSet)(Object.keys(projects)) : (0, _atUtils.arrayToSet)((0, _utils2.getProjectIdsFilteredByAssignments)(Object.values(projects), ma, false));
});

var getManageableProjectsWithExcludeSelf = exports.getManageableProjectsWithExcludeSelf = (0, _reselect.createSelector)(getViewerSettings, _selectors2.getProjects, getManagementAssignments, function (viewerSettings, projects, ma) {
    return viewerSettings.hasAccessToAllManagementScope ? projects : (0, _utils2.getProjectsFilteredByAssignments)(Object.values(projects), ma, false);
});

var isPossibleToAddTasks = exports.isPossibleToAddTasks = (0, _reselect.createSelector)(getViewerSettings, getManageableProjectsWithExcludeSelf, isPossibleToAddProjects, function (viewerSettings, maProjects, isPossibleToAddProjects) {
    return viewerSettings.hasEditHierarchyRight && (isPossibleToAddProjects || Object.values(maProjects).some(function (p) {
        return !p.archived;
    }));
});

var getEditableProjectIds = exports.getEditableProjectIds = (0, _reselect.createSelector)(_selectors4.canEditHierarchy, getManageableProjectIds, function (canEditHierarchy, pIds) {
    return canEditHierarchy ? pIds : {};
});

var getEditableProjectIdsWithExcludeSelf = exports.getEditableProjectIdsWithExcludeSelf = (0, _reselect.createSelector)(_selectors4.canEditHierarchy, getManageableProjectIdsWithExcludeSelf, function (canEditHierarchy, pIds) {
    return canEditHierarchy ? pIds : {};
});

var getManageableCustomerIds = exports.getManageableCustomerIds = (0, _reselect.createSelector)(getViewerSettings, _selectors2.getCustomers, getCustomersManagementAssignments, function (viewerSettings, customers, customerMA) {
    if (!viewerSettings.hasEditHierarchyRight) {
        return {};
    }

    var customerIds = Object.keys(customers);
    return viewerSettings.hasAccessToAllManagementScope ? (0, _atUtils.arrayToSet)(customerIds) : (0, _atUtils.arrayToSet)((0, _utils2.getCustomerIdsFilteredByAssignments)(customerIds, customerMA));
});

var getManageableCustomerIdsWithExcludeSelf = exports.getManageableCustomerIdsWithExcludeSelf = (0, _reselect.createSelector)(getViewerSettings, _selectors2.getCustomers, getCustomersManagementAssignments, function (viewerSettings, customers, customerMA) {
    if (!viewerSettings.hasEditHierarchyRight) {
        return {};
    }

    var customerIds = Object.keys(customers);
    return viewerSettings.hasAccessToAllManagementScope ? (0, _atUtils.arrayToSet)(customerIds) : (0, _atUtils.arrayToSet)((0, _utils2.getCustomerIdsFilteredByAssignments)(customerIds, customerMA, false));
});

var getEditableCustomerIds = exports.getEditableCustomerIds = (0, _reselect.createSelector)(_selectors4.canEditHierarchy, getManageableCustomerIds, function (canEditHierarchy, cIds) {
    return canEditHierarchy ? cIds : {};
});

var getEditableCustomerIdsWithExcludeSelf = exports.getEditableCustomerIdsWithExcludeSelf = (0, _reselect.createSelector)(_selectors4.canEditHierarchy, getManageableCustomerIdsWithExcludeSelf, function (canEditHierarchy, cIds) {
    return canEditHierarchy ? cIds : {};
});

var getCustomerIdsWhereCanManageLeastOneProject = exports.getCustomerIdsWhereCanManageLeastOneProject = (0, _reselect.createSelector)(_selectors4.canEditHierarchy, _selectors2.getCustomers, getEditableCustomerIdsWithExcludeSelf, getManageableProjectsWithExcludeSelf, function (canEditHierarchy, allCustomers, manageableCustomerIds, manageableProjects) {
    var allCustomerIds = Object.keys(allCustomers);
    var filteredCustomerIds = [];
    if (canEditHierarchy) {
        filteredCustomerIds = allCustomerIds.filter(function (cId) {
            return !!manageableCustomerIds[cId] || manageableProjects.some(function (project) {
                return project.customerId === +cId;
            });
        });
    }
    return (0, _atUtils.arrayToSet)(filteredCustomerIds);
});

var isViewerCanManageAllTasksOfCPSelection = exports.isViewerCanManageAllTasksOfCPSelection = (0, _reselect.createSelector)(getViewerSettings, getSingleCPSelection, _selectors2.getProjects, getManagementAssignments, function (viewerSettings, cpSelection, projects, ma) {
    if (!viewerSettings.hasEditHierarchyRight) {
        return false;
    }

    var customerId = cpSelection.customerId;
    var projectId = cpSelection.projectId;

    return viewerSettings.hasAccessToAllManagementScope || customerId !== null && (0, _utils2.isCustomerAssignedForManage)(ma.customers, customerId, false) || projectId !== null && !!projects[projectId] && (0, _utils2.isPossibleToManageProject)(projects[projectId], viewerSettings, ma.customers, ma.projects);
});

var isNeedToShowScopeFilter = exports.isNeedToShowScopeFilter = (0, _reselect.createSelector)(isViewerHasManageableTasks, isViewerCanManageAllTasksOfCPSelection, function (isViewerHasManageableTasks, isViewerCanManageAllTasksOfCPSelection) {
    return isViewerHasManageableTasks && !isViewerCanManageAllTasksOfCPSelection;
});

var isNeedToShowSelection = exports.isNeedToShowSelection = (0, _reselect.createSelector)(isNeedToShowScopeFilter, isShowOnlyManageableTasks, isViewerCanManageAllTasksOfCPSelection, function (isNeedToShowScopeFilter, isShowOnlyManageableTasks, isViewerCanManageAllTasksOfCPSelection) {
    return isNeedToShowScopeFilter && isShowOnlyManageableTasks || !isNeedToShowScopeFilter && isViewerCanManageAllTasksOfCPSelection;
});

var isCPPanelClosed = exports.isCPPanelClosed = (0, _reselect.createSelector)(getCommonState, function (common) {
    return common.cpPanelClosed;
});

var isBulkOperationsPanelShown = exports.isBulkOperationsPanelShown = (0, _reselect.createSelector)(getCommonState, function (commonState) {
    return commonState.bulkOperationsPanelShown;
});

var getTasksSelectionFilters = exports.getTasksSelectionFilters = (0, _reselect.createSelector)(getIntersectedCPSelection, getTaskStatusFilter, getTaskNameFilter, function (cpSelectionFilter, taskStatusFilter, taskNameFilter) {
    return {
        cpSelection: cpSelectionFilter,
        taskStatus: taskStatusFilter,
        wordFilter: taskNameFilter
    };
});
var getNextWorkflowStatusesIsLoaded = exports.getNextWorkflowStatusesIsLoaded = (0, _reselect.createSelector)(getCommonState, function (state) {
    return state.isNextWorkflowStatusesLoaded;
});

var getTaskCustomFieldsMap = exports.getTaskCustomFieldsMap = (0, _reselect.createSelector)(_selectors5.selectTaskCustomFields, function (customFields) {
    var obj = {};
    customFields.forEach(function (cf) {
        obj[cf.fieldName] = cf;
    });
    return obj;
});

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _LoadingMoire = __webpack_require__(92);

var _LoadingMoire2 = _interopRequireDefault(_LoadingMoire);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LoadingContainer = function (_TemplateView) {
    _inherits(LoadingContainer, _TemplateView);

    function LoadingContainer(_ref) {
        var $containerEl = _ref.$containerEl,
            contentComponent = _ref.contentComponent,
            containerClass = _ref.containerClass,
            contentClass = _ref.contentClass,
            _ref$showAnimated = _ref.showAnimated,
            showAnimated = _ref$showAnimated === undefined ? true : _ref$showAnimated,
            _ref$hideAnimated = _ref.hideAnimated,
            hideAnimated = _ref$hideAnimated === undefined ? true : _ref$hideAnimated,
            _ref$loadingMoireConf = _ref.loadingMoireConfig,
            loadingMoireConfig = _ref$loadingMoireConf === undefined ? {} : _ref$loadingMoireConf,
            _ref$proxySetState = _ref.proxySetState,
            proxySetState = _ref$proxySetState === undefined ? true : _ref$proxySetState;

        _classCallCheck(this, LoadingContainer);

        var _this = _possibleConstructorReturn(this, (LoadingContainer.__proto__ || Object.getPrototypeOf(LoadingContainer)).call(this, $containerEl));

        _this.state = {
            loading: false
        };

        _this.contentComponent = contentComponent;
        _this.containerClass = containerClass;
        _this.contentClass = contentClass;
        _this.showAnimated = showAnimated;
        _this.hideAnimated = hideAnimated;

        _this.params = {
            loadingMoireConfig: loadingMoireConfig,
            proxySetState: proxySetState
        };

        _this.onStatePropertyChanged("loading", function (loading) {
            return _this.loadingMoire.toggle(loading);
        });
        return _this;
    }

    _createClass(LoadingContainer, [{
        key: "afterRender",
        value: function afterRender() {
            var _this2 = this;

            this.content = this.find(".content");
            if (this.contentComponent instanceof Array) {
                this.contentComponent.forEach(function (c) {
                    return c.init(_this2.content);
                });
                this.registerChildComponents.apply(this, _toConsumableArray(this.contentComponent));
            } else {
                this.contentComponent.init(this.content);
                this.registerChildComponents(this.contentComponent);
            }

            this.loadingMoire = new _LoadingMoire2.default(this.params.loadingMoireConfig).init(this.$el);
            this.loadingMoire.showAnimated = this.showAnimated;
            this.loadingMoire.hideAnimated = this.hideAnimated;
        }
    }, {
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='loadingContainer <%=containerClass%>'>" + "  <div class='content <%=contentClass%>'></div>" + "</div>";
        }
    }, {
        key: "templateModel",
        value: function templateModel() {
            return {
                containerClass: this.containerClass,
                contentClass: this.contentClass
            };
        }
    }, {
        key: "setState",
        value: function setState(stateChanges) {
            _get(LoadingContainer.prototype.__proto__ || Object.getPrototypeOf(LoadingContainer.prototype), "setState", this).call(this, stateChanges);
            if (this.params.proxySetState) this.applyForChildrenComponents(function (child) {
                return child.setState(stateChanges);
            });
        }
    }, {
        key: "hide",
        value: function hide() {
            _get(LoadingContainer.prototype.__proto__ || Object.getPrototypeOf(LoadingContainer.prototype), "hide", this).call(this);
            this.loadingMoire.toggle(false);
        }
    }, {
        key: "show",
        value: function show() {
            _get(LoadingContainer.prototype.__proto__ || Object.getPrototypeOf(LoadingContainer.prototype), "show", this).call(this);
            this.loadingMoire.toggle(this.state.loading);
        }
    }]);

    return LoadingContainer;
}(_TemplateView3.default);

exports.default = LoadingContainer;

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setLeaveTypesList = exports.setLeaveTypes = exports.setTypesOfWorkList = exports.setTypesOfWork = exports.removeWorkflowStatus = exports.removeWorkflowStatuses = exports.setWorkflowStatusesList = exports.setWorkflowStatuses = exports.addWorkflowStatus = exports.addWorkflowStatuses = exports.removeCustomer = exports.removeCustomers = exports.addCustomer = exports.addCustomers = exports.removeProject = exports.removeProjects = exports.addProject = exports.addProjects = exports.clearTasks = exports.removeTask = exports.removeTasks = exports.addTask = exports.addTasks = exports.setTimeZoneGroupsList = exports.setTimeZoneGroups = exports.addTimeZoneGroup = exports.addTimeZoneGroups = exports.setUserGroupsList = exports.setUserGroups = exports.addUserGroup = exports.addUserGroups = exports.removeUser = exports.removeUsers = exports.setUsersList = exports.setUsers = exports.addUser = exports.addUsers = undefined;

var _reduxActions = __webpack_require__(9);

var _actionTypes = __webpack_require__(102);

var ActionTypes = _interopRequireWildcard(_actionTypes);

var _atUtils = __webpack_require__(5);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var addUsers = exports.addUsers = (0, _reduxActions.createAction)(ActionTypes.USERS_ADD);
var addUser = exports.addUser = function addUser(user) {
  return function (dispatch) {
    return dispatch(addUsers([user]));
  };
};
var setUsers = exports.setUsers = (0, _reduxActions.createAction)(ActionTypes.USERS_SET);
var setUsersList = exports.setUsersList = function setUsersList(users) {
  return function (dispatch) {
    return dispatch(setUsers((0, _atUtils.arrayToMap)(users)));
  };
};

var removeUsers = exports.removeUsers = (0, _reduxActions.createAction)(ActionTypes.USERS_REMOVE);
var removeUser = exports.removeUser = function removeUser(userId) {
  return function (dispatch) {
    return dispatch(removeUsers([userId]));
  };
};

var addUserGroups = exports.addUserGroups = (0, _reduxActions.createAction)(ActionTypes.USER_GROUPS_ADD);
var addUserGroup = exports.addUserGroup = function addUserGroup(userGroup) {
  return function (dispatch) {
    return dispatch(addUserGroups([userGroup]));
  };
};

var setUserGroups = exports.setUserGroups = (0, _reduxActions.createAction)(ActionTypes.USER_GROUPS_SET);
var setUserGroupsList = exports.setUserGroupsList = function setUserGroupsList(userGroups) {
  return function (dispatch) {
    return dispatch(setUserGroups((0, _atUtils.arrayToMap)(userGroups)));
  };
};

var addTimeZoneGroups = exports.addTimeZoneGroups = (0, _reduxActions.createAction)(ActionTypes.TIME_ZONE_GROUPS_ADD);
var addTimeZoneGroup = exports.addTimeZoneGroup = function addTimeZoneGroup(timeZoneGroup) {
  return function (dispatch) {
    return dispatch(addTimeZoneGroups[timeZoneGroup]);
  };
};

var setTimeZoneGroups = exports.setTimeZoneGroups = (0, _reduxActions.createAction)(ActionTypes.TIME_ZONE_GROUPS_SET);
var setTimeZoneGroupsList = exports.setTimeZoneGroupsList = function setTimeZoneGroupsList(timeZoneGroups) {
  return function (dispatch) {
    return dispatch(setTimeZoneGroups((0, _atUtils.arrayToMap)(timeZoneGroups)));
  };
};

var addTasks = exports.addTasks = (0, _reduxActions.createAction)(ActionTypes.TASKS_ADD);
var addTask = exports.addTask = function addTask(task) {
  return function (dispatch) {
    return dispatch(addTasks([task]));
  };
};

var removeTasks = exports.removeTasks = (0, _reduxActions.createAction)(ActionTypes.TASKS_REMOVE);
var removeTask = exports.removeTask = function removeTask(taskId) {
  return function (dispatch) {
    return dispatch(removeTasks([taskId]));
  };
};
var clearTasks = exports.clearTasks = (0, _reduxActions.createAction)(ActionTypes.TASKS_CLEAR);

var addProjects = exports.addProjects = (0, _reduxActions.createAction)(ActionTypes.PROJECTS_ADD);
var addProject = exports.addProject = function addProject(project) {
  return function (dispatch) {
    return dispatch(addProjects([project]));
  };
};

var removeProjects = exports.removeProjects = (0, _reduxActions.createAction)(ActionTypes.PROJECTS_REMOVE);
var removeProject = exports.removeProject = function removeProject(projectId) {
  return function (dispatch) {
    return dispatch(removeProjects([projectId]));
  };
};

var addCustomers = exports.addCustomers = (0, _reduxActions.createAction)(ActionTypes.CUSTOMERS_ADD);
var addCustomer = exports.addCustomer = function addCustomer(customer) {
  return function (dispatch) {
    return dispatch(addCustomers([customer]));
  };
};

var removeCustomers = exports.removeCustomers = (0, _reduxActions.createAction)(ActionTypes.CUSTOMERS_REMOVE);
var removeCustomer = exports.removeCustomer = function removeCustomer(customerId) {
  return function (dispatch) {
    return dispatch(removeCustomers([customerId]));
  };
};

var addWorkflowStatuses = exports.addWorkflowStatuses = (0, _reduxActions.createAction)(ActionTypes.WORKFLOW_STATUSES_ADD);
var addWorkflowStatus = exports.addWorkflowStatus = function addWorkflowStatus(workflowStatus) {
  return function (dispatch) {
    return dispatch(addWorkflowStatuses([workflowStatus]));
  };
};

var setWorkflowStatuses = exports.setWorkflowStatuses = (0, _reduxActions.createAction)(ActionTypes.WORKFLOW_STATUSES_SET);
var setWorkflowStatusesList = exports.setWorkflowStatusesList = function setWorkflowStatusesList(workflowStatuses) {
  return function (dispatch) {
    return dispatch(setWorkflowStatuses((0, _atUtils.arrayToMap)(workflowStatuses)));
  };
};

var removeWorkflowStatuses = exports.removeWorkflowStatuses = (0, _reduxActions.createAction)(ActionTypes.WORKFLOW_STATUSES_REMOVE);
var removeWorkflowStatus = exports.removeWorkflowStatus = function removeWorkflowStatus(workflowStatusId) {
  return function (dispatch) {
    return dispatch(removeWorkflowStatuses([workflowStatusId]));
  };
};

var setTypesOfWork = exports.setTypesOfWork = (0, _reduxActions.createAction)(ActionTypes.TYPES_OF_WORK_SET);
var setTypesOfWorkList = exports.setTypesOfWorkList = function setTypesOfWorkList(typesOfWork) {
  return function (dispatch) {
    return dispatch(setTypesOfWork((0, _atUtils.arrayToMap)(typesOfWork)));
  };
};

var setLeaveTypes = exports.setLeaveTypes = (0, _reduxActions.createAction)(ActionTypes.LEAVE_TYPES_SET);
var setLeaveTypesList = exports.setLeaveTypesList = function setLeaveTypesList(leaveTypes) {
  return function (dispatch) {
    return dispatch(setLeaveTypes((0, _atUtils.arrayToMap)(leaveTypes)));
  };
};

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _atUtils = __webpack_require__(5);

/**
 * This class request system_settings_js.jsp and numbers_validator.js to be included.
 */

var UserTime = {};

UserTime.parseTime = function (s, digitGroupingSymbol, decimalSeparator) {
    if (s == null) return null;

    s = (0, _atUtils.trim)(s);

    if (s == '') return 0;

    if (digitGroupingSymbol) s = String(s).replace(digitGroupingSymbol, '');

    if (s.indexOf(':') != -1) {
        return UserTime.parseTimeDelimiterColon(s);
    } else if (s.indexOf(decimalSeparator) != -1 || s.indexOf('.') != -1 || s.indexOf(',') != -1) {
        return UserTime.parseTimeDecimalSeparator(s, decimalSeparator, digitGroupingSymbol);
    } else {
        var h = UserTime.myParseInt(s);
        if (isNaN(h)) return null;else return h * 60;
    }
};

UserTime.parseTimeWithSystemSettings = function (s, isDigitGroupingSymbolUsed, decimalSeparator) {
    return UserTime.parseTime(s, isDigitGroupingSymbolUsed ? window.SystemSettings.digitGroupingSymbol : undefined, decimalSeparator ? decimalSeparator : window.SystemSettings.decimalSeparator);
};

UserTime.formatTime = function (n) {
    var absN = Math.abs(n);
    var result = Math.round(absN / 60 - absN % 60 / 60) + ":" + (0, _atUtils.leadZero)(absN % 60);
    return n < 0 ? '-' + result : result;
};

UserTime.formatTimeWithoutMinutesIfPossible = function (n) {
    var absN = Math.abs(n);
    var hours = Math.round(absN / 60 - absN % 60 / 60);
    var minutes = absN % 60;
    var result = String(hours);
    if (minutes != 0) result += ":" + (0, _atUtils.leadZero)(minutes);
    return n < 0 ? '-' + result : result;
};

UserTime.formatTimeWithDigitSeparator = function (time) {
    var absN = Math.abs(time);
    var hours = String(Math.round(absN / 60 - absN % 60 / 60));

    if (window.SystemSettings.digitGroupingSymbol != "" && hours >= 1000) {
        var separatedHours = "";

        var n = hours.length;
        while (n > 3) {
            separatedHours = window.SystemSettings.digitGroupingSymbol + hours.substr(n - 3, 3) + separatedHours;
            n -= 3;
        }

        if (n > 0) separatedHours = hours.substr(0, n) + separatedHours;

        hours = separatedHours;
    }

    var result = hours + ":" + (0, _atUtils.leadZero)(absN % 60);
    return time < 0 ? '-' + result : result;
};

UserTime.parseTimeDelimiterColon = function (s) {
    var h = 0;
    var m = 0;
    var i = s.indexOf(':');
    if (i == 0) {
        h = 0;
    } else {
        h = UserTime.myParseInt(s.substring(0, i));
    }

    if (isNaN(h)) return null;
    if (s.length > i + 1) {
        m = UserTime.myParseInt(s.substring(i + 1, s.length));
        if (isNaN(m) || m < 0) return null;
    }
    var sign = h < 0 || s.indexOf('-') == 0 ? -1 : 1;
    return h * 60 + m * sign;
};

UserTime.parseTimeDecimalSeparator = function (s, decimalSeparator, digitGroupingSymbol) {
    var validator = new FloatNumbersValidator(decimalSeparator, digitGroupingSymbol, null, false, true);

    var number = validator.parseNumber(s);

    if (number == null) return null;

    // here we can safely apply parseFloat function
    return Math.round(number * 60);
};

UserTime.myParseInt = function (s) {
    var n = parseInt(s, 10);
    if (!/^[+-]?\d+$/.test(s)) return NaN;
    if (isNaN(n)) return NaN;
    return n;
};

exports.default = UserTime;

/***/ }),
/* 31 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 32 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _SimpleTooltip = __webpack_require__(36);

var _SimpleTooltip2 = _interopRequireDefault(_SimpleTooltip);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _keyHandlers = __webpack_require__(48);

var _DotsLoadingIndicator = __webpack_require__(1336);

var _DotsLoadingIndicator2 = _interopRequireDefault(_DotsLoadingIndicator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LOADING_DELAY = 250;

var Button = function (_TemplateView) {
    _inherits(Button, _TemplateView);

    function Button(_ref) {
        var _ref$additionalClass = _ref.additionalClass,
            additionalClass = _ref$additionalClass === undefined ? '' : _ref$additionalClass,
            _ref$onClickCb = _ref.onClickCb,
            onClickCb = _ref$onClickCb === undefined ? function () {} : _ref$onClickCb,
            _ref$label = _ref.label,
            label = _ref$label === undefined ? '' : _ref$label,
            _ref$withPlusIcon = _ref.withPlusIcon,
            withPlusIcon = _ref$withPlusIcon === undefined ? false : _ref$withPlusIcon,
            _ref$withDisableToolt = _ref.withDisableTooltip,
            withDisableTooltip = _ref$withDisableToolt === undefined ? false : _ref$withDisableToolt,
            _ref$disableTooltipTe = _ref.disableTooltipText,
            disableTooltipText = _ref$disableTooltipTe === undefined ? '' : _ref$disableTooltipTe,
            _ref$tooltipAdditiona = _ref.tooltipAdditionalClass,
            tooltipAdditionalClass = _ref$tooltipAdditiona === undefined ? false : _ref$tooltipAdditiona,
            _ref$tabindex = _ref.tabindex,
            tabindex = _ref$tabindex === undefined ? -1 : _ref$tabindex,
            _ref$handleEnterKeydo = _ref.handleEnterKeydown,
            handleEnterKeydown = _ref$handleEnterKeydo === undefined ? false : _ref$handleEnterKeydo,
            _ref$withLoading = _ref.withLoading,
            withLoading = _ref$withLoading === undefined ? false : _ref$withLoading;

        _classCallCheck(this, Button);

        var _this = _possibleConstructorReturn(this, (Button.__proto__ || Object.getPrototypeOf(Button)).call(this, null));

        _this._handleClick = function (e) {
            e.stopPropagation();
            if (!_this.state.disabled && !_this.state.loading) {
                _this.params.onClickCb(e);
            }
        };

        _this.params = {
            additionalClass: additionalClass,
            onClickCb: onClickCb,
            withDisableTooltip: withDisableTooltip,
            tooltipAdditionalClass: tooltipAdditionalClass,
            tabindex: tabindex,
            handleEnterKeydown: handleEnterKeydown,
            withLoading: withLoading
        };

        _this.state = {
            label: label,
            disabled: false,
            disableTooltipText: disableTooltipText,
            withPlusIcon: withPlusIcon,
            loading: false
        };

        _this.onAnyStatePropertyChanged(['disabled', 'disableTooltipText'], function (_ref2) {
            var disabled = _ref2.disabled,
                disableTooltipText = _ref2.disableTooltipText;

            _this.$el.toggleClass('disabled', disabled);
            if (_this.params.withDisableTooltip) {
                _this.tooltip.setText(disableTooltipText);
                _this.tooltip.toggle(disabled);
            }
        });
        _this.onStatePropertyChanged('label', function (label) {
            return _this.$label.text(label);
        });
        _this.onStatePropertyChanged('withPlusIcon', function (withPlusIcon) {
            return _this.getEl().toggleClass('withPlusIcon', withPlusIcon);
        });
        _this.onStatePropertyChanged('loading', function (loading) {
            return _this._refreshLoading(loading);
        });
        return _this;
    }

    _createClass(Button, [{
        key: 'templateModel',
        value: function templateModel() {
            return {
                additionalClass: this.params.additionalClass,
                label: this.state.label,
                tabindex: this.params.tabindex
            };
        }
    }, {
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class=\'components_button <%=additionalClass%>\' tabindex=<%=tabindex%>>\n                    <div class=\'components_button_label\'>\n                        <%-label%>\n                    </div>\n                    <div class=\'loadingIndicatorContainer\'/>\n               </div>';
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            var _this2 = this;

            this.$el.on('click', this._handleClick);

            if (this.params.withDisableTooltip) {
                this.tooltip = new _SimpleTooltip2.default({
                    extraClass: this.params.tooltipAdditionalClass
                }).init((0, _jquery2.default)('body'));
                this.tooltip.subscribeToMouseEvents(this.$el);
                this.tooltip.disable();
            }

            if (this.params.handleEnterKeydown) {
                this.$el.keydown(function (e) {
                    if ((0, _keyHandlers.isEnter)(e.keyCode)) {
                        _this2.params.onClickCb();
                    }
                });
            }

            this.$label = this.find('.components_button_label');
            if (this.params.withLoading) {
                new _DotsLoadingIndicator2.default().init(this.find('.loadingIndicatorContainer'));
            }

            this.renderInitialState();
        }
    }, {
        key: 'focus',
        value: function focus() {
            this.$el.focus();
        }
    }, {
        key: '_refreshLoading',
        value: function _refreshLoading(loading) {
            var _this3 = this;

            if (this.params.withLoading) {
                clearTimeout(this.loadingAnimationTimeout);
                this.loadingAnimationTimeout = setTimeout(function () {
                    return _this3.getEl().toggleClass('loading', loading);
                }, loading ? LOADING_DELAY : 0);
            }
        }
    }]);

    return Button;
}(_TemplateView3.default);

exports.default = Button;

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var GroupType = {
    USER_GROUP: 'USER_GROUP',
    TIME_ZONE_GROUP: 'TIME_ZONE_GROUP'
};

exports.default = GroupType;

/***/ }),
/* 35 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _Tooltip2 = __webpack_require__(183);

var _Tooltip3 = _interopRequireDefault(_Tooltip2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SimpleTooltip = function (_Tooltip) {
    _inherits(SimpleTooltip, _Tooltip);

    function SimpleTooltip() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            _ref$text = _ref.text,
            text = _ref$text === undefined ? '' : _ref$text,
            _ref$extraClass = _ref.extraClass,
            extraClass = _ref$extraClass === undefined ? '' : _ref$extraClass;

        _classCallCheck(this, SimpleTooltip);

        var _this = _possibleConstructorReturn(this, (SimpleTooltip.__proto__ || Object.getPrototypeOf(SimpleTooltip)).call(this));

        _this.text = text;
        _this.extraClass = extraClass;
        return _this;
    }

    _createClass(SimpleTooltip, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return "<div class='simpleTooltip'><%-text%></div>";
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            _get(SimpleTooltip.prototype.__proto__ || Object.getPrototypeOf(SimpleTooltip.prototype), 'afterRender', this).call(this);
            if (this.extraClass) this.$el.addClass(this.extraClass);
        }
    }, {
        key: 'setText',
        value: function setText(text) {
            this.$el.text(text);
        }
    }, {
        key: 'setHtml',
        value: function setHtml(html) {
            this.$el.html(html);
        }
    }]);

    return SimpleTooltip;
}(_Tooltip3.default);

exports.default = SimpleTooltip;

/***/ }),
/* 37 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.1' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(31);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _IScroll = __webpack_require__(1297);

var _IScroll2 = _interopRequireDefault(_IScroll);

var _atBrowserUtils = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ScrollUtils = {};

ScrollUtils.POSITIONS = {
    TOP: 'top',
    CENTER: 'center',
    BOTTOM: 'bottom',
    LEFT: 'left',
    RIGHT: 'right'
};

/**
 * Add horizontal scroll to element - wrapper
 * if browser is ie8 then set custom scroll with mouse wheel event
 * @param jqEl - element wrapper (has has scrollable first child)
 * @param options like isFaded - if need to hide scroll when it not used
 */
ScrollUtils.addHorizontalScroll = function (jqEl, options) {
    var scroll = null;
    if ((0, _atBrowserUtils.isIE8)()) {
        jqEl.css("overflow-x", "scroll"); // set correct overflow-x property
        var scrollDelta = 30;
        jqEl.on(ScrollUtils.getWheelEventName(), function (e) {
            var delta = e.originalEvent.deltaY || e.originalEvent.detail || -1 * e.originalEvent.wheelDelta;

            if (jqEl.outerWidth() != jqEl[0].scrollWidth) {
                var currentScrLeft = jqEl.scrollLeft();
                if (delta > 0) {
                    jqEl.scrollLeft(currentScrLeft + scrollDelta);
                } else {
                    jqEl.scrollLeft(currentScrLeft - scrollDelta);
                }
                e.preventDefault();
            }
        });
    } else {
        jqEl.css("overflow-x", "hide"); // set correct overflow-x property
        scroll = ScrollUtils.getCustomScroll(jqEl, false, options);
    }
    return scroll;
};

/**
 * Add vertical scroll to element - wrapper
 * if browser is ie8 then used std scroll
 * @param jqEl - element wrapper (has has scrollable first child)
 * @param options like isFaded - if need to hide scroll when it not used
 */
ScrollUtils.addVerticalScroll = function (jqEl, options) {
    var scroll = null;
    if ((0, _atBrowserUtils.isIE8)()) {
        jqEl.css("overflow-y", "scroll"); // set correct overflow-x property
    } else {
        jqEl.css("overflow-y", "hidden"); // set correct overflow-x property
        scroll = ScrollUtils.getCustomScroll(jqEl, true, options);
    }
    return scroll;
};

ScrollUtils.getCustomScroll = function (jqEl, isVertical, options) {
    options = _underscore2.default.isUndefined(options) ? { isFaded: false, mouseWheel: true, appendTo: null } : options;
    var isFaded = _underscore2.default.isUndefined(options.isFaded) ? false : options.isFaded;
    var mouseWheel = _underscore2.default.isUndefined(options.mouseWheel) ? true : options.mouseWheel;

    var customScroll = new _IScroll2.default(jqEl[0], {
        scrollX: !isVertical,
        scrollY: isVertical,
        mouseWheel: mouseWheel,
        bounce: false, // no need (animation)
        interactiveScrollbars: true, // allow user actions
        fadeScrollbars: isFaded, //at first time always hide scrollbars
        scrollbars: 'custom', // custom styles for scroller @see customscroll.less
        disableMouse: true, //disable drag by mouse event
        disablePointer: true, //disable drag by pointer event
        disableTouch: true, //disable drag by touch event
        probeType: options.probeType
    });

    if (options.appendTo) {
        var scrollClass = isVertical ? ".iScrollVerticalScrollbar" : ".iScrollHorizontalScrollbar";
        var scroll = jqEl.find(scrollClass);
        options.appendTo.append(scroll);
    }

    // function checks if there is overflow content for current custom scroll
    var isScrollNeeded = function isScrollNeeded() {
        return isVertical ? customScroll.hasVerticalScroll : customScroll.hasHorizontalScroll;
    };

    var indicator = customScroll.indicators[0];
    // hide scroll placeholder if there is no scrollable content
    customScroll.on("refresh", function () {
        indicator.wrapperStyle[_IScroll2.default.utils.style.transitionDuration] = 0 + 'ms';
        indicator.wrapperStyle.visibility = isScrollNeeded() ? 'visible' : 'hidden';
    });
    if (isFaded) {
        jqEl.hover(function () {
            if (isScrollNeeded()) {
                indicator.fade(1);
            }
        }, function () {
            if (isScrollNeeded()) {
                indicator.fade();
            }
        });
    }

    setTimeout(function () {
        customScroll.refresh();
    }, 0.1);
    customScroll.refresh();

    return customScroll;
};

ScrollUtils.refreshCustomScroll = function (customScroll) {
    if (customScroll) {
        customScroll.refresh();
    }
};

/**
 * Scroll element vertical to visible are (if there is no custom scroll - scroll by jquery)
 * @param customScroll object of custom scroll for perform scrolling
 * @param element element for scrolling
 * @param position top/bot/center in visible area
 * @param onlyIfElIsNotVisible scroll only of element is not fully visible
 * @param time for scrolling (duration of animation)
 */
ScrollUtils.scrollIntoViewVertical = function (customScroll, element) {
    var position = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ScrollUtils.POSITIONS.TOP;
    var onlyIfElIsNotVisible = arguments[3];
    var time = arguments[4];

    var pos = void 0;
    var offset = 0;
    if (_underscore2.default.isString(position)) {
        pos = position;
    } else {
        pos = position.pos || ScrollUtils.POSITIONS.TOP;
        offset = position.offset || 0;
    }
    time = time || 0;
    if (customScroll) {
        if (!onlyIfElIsNotVisible || !ScrollUtils.isElementIsFullyVisibleVertical(customScroll, element)) {
            var offsetY = -offset;
            if (pos === ScrollUtils.POSITIONS.CENTER) {
                offsetY -= -Math.round(_IScroll2.default.utils.getRect(element).height / 2 - _IScroll2.default.utils.getRect(customScroll.wrapper).height / 2);
            }
            if (pos === ScrollUtils.POSITIONS.BOTTOM) {
                offsetY -= customScroll.wrapperHeight - element.offsetHeight;
            }
            customScroll.scrollToElement(element, time, null, offsetY);
        }
    } else {
        (0, _jquery2.default)(element).scrollintoview({ duration: time });
    }
};

ScrollUtils.scrollToTop = function (customScroll, $containerEl) {
    var time = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

    if (customScroll) {
        customScroll.scrollTo(0, 0, time);
    } else {
        $containerEl.scrollTop(0);
    }
};

ScrollUtils.scrollToBottom = function (customScroll) {
    if (customScroll) {
        customScroll.scrollTo(0, customScroll.maxScrollY);
    }
};

ScrollUtils.performIfScrollToBottom = function (customScroll, verticalGap, callback) {
    if (!customScroll || customScroll.y - customScroll.maxScrollY < verticalGap) {
        callback();
    }
};

ScrollUtils.performIfScrollToTop = function (customScroll, verticalGap, callback) {
    if (!customScroll || Math.abs(customScroll.y) <= verticalGap) {
        callback();
    }
};

ScrollUtils.isElementIsFullyVisibleVertical = function (customScroll, element) {
    if (customScroll) {
        var elTopOffsetPos = element.offsetTop;
        var elBottomOffsetPos = element.offsetTop + element.offsetHeight;

        var isTopOfElementIsVisible = elTopOffsetPos >= Math.abs(customScroll.y);
        var isBottomOfElementIsVisible = elBottomOffsetPos <= Math.abs(customScroll.y) + customScroll.wrapperHeight;
        return isTopOfElementIsVisible && isBottomOfElementIsVisible;
    }
    return false;
};

/**
 * Scroll element horizontal to visible area(if custom is not exists - scroll by jquery )
 * @param customScroll object of custom scroll
 * @param element element for scrolling
 * @param position left/right/center on visible area
 * @param time for scrolling (duration of animation)
 */
ScrollUtils.scrollIntoViewHorizontal = function (customScroll, element, position, time) {
    var pos = position || ScrollUtils.POSITIONS.RIGHT;
    time = time || 0;
    if (customScroll) {
        var offsetX = null;
        if (pos == ScrollUtils.POSITIONS.CENTER) {
            offsetX = true;
        }
        if (pos == ScrollUtils.POSITIONS.LEFT) {
            offsetX = -(customScroll.wrapperWidth - element.offsetWidth);
        }
        customScroll.scrollToElement(element, time, offsetX);
    } else {
        (0, _jquery2.default)(element).scrollintoview({ duration: time });
    }
};

ScrollUtils.getWheelEventName = function () {
    var wheelEventName = "";
    if ('onwheel' in document) {
        // IE9+, FF17+, Ch31+
        wheelEventName = "wheel";
    } else if ('onmousewheel' in document) {
        // old event
        wheelEventName = "mousewheel";
    } else {
        // Firefox < 17
        wheelEventName = "MozMousePixelScroll";
    }
    return wheelEventName;
};

/**
 * Returns custom listener for mouse wheel event
 * When mouse wheel event fires over element and element has scroll and scroll bar reaches top or bot position
 * by default parent element start scrolling
 * Default behavior not convenient for popups and selectors with scroll
 * This listener eliminate default behavior
 * Listener need to apply to element that has scroll or for element - parent of element(s) with scroll
 * Uses delegated event
 * For use into another handlers need to bind context of outer handler with context of this function
 */
ScrollUtils.getWheelEventListenerForPreventScrollParents = function () {
    return function (e) {
        var target = e.target;

        // this - context of element that has this listener 
        // delegate event from target to scrollable element if exist
        while (target && target != this.parentNode) {

            var scrlEl = (0, _jquery2.default)(target);

            // if inner height not eq scroll height - maybe  element has a scroll
            if (scrlEl.innerHeight() != scrlEl[0].scrollHeight) {

                // but heights may not equals is overflow is "hidden" or "visible"
                var overflowStyle = scrlEl.css("overflow-y");
                var isOverflowHidden = overflowStyle == "hidden";
                var isOverflowVisible = overflowStyle == "" || overflowStyle == "visible";

                // check overflow styles
                if (!isOverflowHidden && !isOverflowVisible) {
                    // calculate scroll delta(for ie it has inverted value)
                    var delta = e.originalEvent.deltaY || e.originalEvent.detail || -1 * e.originalEvent.wheelDelta;
                    // for ie
                    if ((0, _atBrowserUtils.isMSIE)()) {
                        // prevent scroll window if delta is big (ie has acceleration)
                        if (scrlEl.scrollTop() + delta <= 0) {
                            scrlEl.scrollTop(0);
                            e.preventDefault();
                            return;
                        }
                        var scrollMaxBottomPosition = scrlEl[0].scrollHeight - scrlEl.outerHeight(true);
                        if (scrlEl.scrollTop() + delta > scrollMaxBottomPosition) {
                            scrlEl.scrollTop(scrollMaxBottomPosition);
                            e.preventDefault();
                            return;
                        }
                    }
                    // if scroll on top - prevent scroll to top
                    if (delta < 0 && scrlEl.scrollTop() == 0) {
                        e.preventDefault();
                        return;
                    }
                    // if scroll on bot - prevent scroll to bot
                    if (delta > 0 && scrlEl[0].scrollHeight - scrlEl.outerHeight(true) - scrlEl.scrollTop() <= 1) {
                        e.preventDefault();
                        return;
                    }

                    return;
                }
            }
            target = target.parentNode;
        }
    };
};

exports.default = ScrollUtils;

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.daysNameLower = exports.tzgNameCapitalized = exports.tzgNameCapitalizedPlural = exports.tzgNameCapitalizedSingular = exports.departmentNameCapitalized = exports.departmentNameCapitalizedPlural = exports.departmentNameCapitalizedSingular = exports.userNameCapitalized = exports.userNameCapitalizedPlural = exports.userNameCapitalizedSingular = exports.managerCapitalized = exports.managerLower = exports.userNameLower = exports.tzgNameLower = exports.departmentNameLower = exports.projectNameLower = exports.customerNameLower = exports.taskNameLower = undefined;

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var taskNameLower = exports.taskNameLower = function taskNameLower(n) {
    return n !== 1 ? _messageResource2.default.getMessage('common.tasks') : _messageResource2.default.getMessage('common.task');
};

var customerNameLower = exports.customerNameLower = function customerNameLower(n) {
    return n !== 1 ? _messageResource2.default.getMessage('common.customers') : _messageResource2.default.getMessage('common.customer');
};

var projectNameLower = exports.projectNameLower = function projectNameLower(n) {
    return n !== 1 ? _messageResource2.default.getMessage('common.projects') : _messageResource2.default.getMessage('common.project');
};

var departmentNameLower = exports.departmentNameLower = function departmentNameLower(n) {
    return n !== 1 ? _messageResource2.default.getMessage('common.user_groups') : _messageResource2.default.getMessage('common.user_group');
};

var tzgNameLower = exports.tzgNameLower = function tzgNameLower(n) {
    return n !== 1 ? _messageResource2.default.getMessage('common.time_zone_groups') : _messageResource2.default.getMessage('common.time_zone_group');
};

var userNameLower = exports.userNameLower = function userNameLower(n) {
    return n !== 1 ? _messageResource2.default.getMessage('common.users') : _messageResource2.default.getMessage('common.user');
};

var managerLower = exports.managerLower = function managerLower(n) {
    return n !== 1 ? _messageResource2.default.getMessage('common.managers') : _messageResource2.default.getMessage('common.manager');
};

var managerCapitalized = exports.managerCapitalized = function managerCapitalized(n) {
    return n !== 1 ? _messageResource2.default.getMessage('common.Managers') : _messageResource2.default.getMessage('common.Manager');
};

var userNameCapitalizedSingular = exports.userNameCapitalizedSingular = function userNameCapitalizedSingular() {
    return _messageResource2.default.getMessage('common.User');
};

var userNameCapitalizedPlural = exports.userNameCapitalizedPlural = function userNameCapitalizedPlural() {
    return _messageResource2.default.getMessage('common.Users');
};

var userNameCapitalized = exports.userNameCapitalized = function userNameCapitalized(n) {
    return n !== 1 ? userNameCapitalizedPlural() : userNameCapitalizedSingular();
};

var departmentNameCapitalizedSingular = exports.departmentNameCapitalizedSingular = function departmentNameCapitalizedSingular() {
    return _messageResource2.default.getMessage('common.User_Group');
};
var departmentNameCapitalizedPlural = exports.departmentNameCapitalizedPlural = function departmentNameCapitalizedPlural() {
    return _messageResource2.default.getMessage('common.User_Groups');
};
var departmentNameCapitalized = exports.departmentNameCapitalized = function departmentNameCapitalized(n) {
    return n !== 1 ? departmentNameCapitalizedPlural() : departmentNameCapitalizedSingular();
};

var tzgNameCapitalizedSingular = exports.tzgNameCapitalizedSingular = function tzgNameCapitalizedSingular() {
    return _messageResource2.default.getMessage('common.Time_Zone_Group');
};
var tzgNameCapitalizedPlural = exports.tzgNameCapitalizedPlural = function tzgNameCapitalizedPlural() {
    return _messageResource2.default.getMessage('common.Time_Zone_Groups');
};
var tzgNameCapitalized = exports.tzgNameCapitalized = function tzgNameCapitalized(n) {
    return n !== 1 ? tzgNameCapitalizedPlural() : tzgNameCapitalizedSingular();
};

var daysNameLower = exports.daysNameLower = function daysNameLower(n) {
    return n === 1 ? _messageResource2.default.getMessage('common.day') : _messageResource2.default.getMessage('common.days');
};

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(421)('wks');
var uid = __webpack_require__(174);
var Symbol = __webpack_require__(35).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _index = __webpack_require__(48);

var _index2 = _interopRequireDefault(_index);

var _atBrowserUtils = __webpack_require__(8);

var _keyCodes = __webpack_require__(66);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DropdownTemplateView = function (_TemplateView) {
    _inherits(DropdownTemplateView, _TemplateView);

    function DropdownTemplateView($containerEl) {
        var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
            _ref$toggleMode = _ref.toggleMode,
            toggleMode = _ref$toggleMode === undefined ? true : _ref$toggleMode,
            _ref$onHide = _ref.onHide,
            onHide = _ref$onHide === undefined ? function () {} : _ref$onHide,
            _ref$onShow = _ref.onShow,
            onShow = _ref$onShow === undefined ? function () {} : _ref$onShow;

        _classCallCheck(this, DropdownTemplateView);

        var _this = _possibleConstructorReturn(this, (DropdownTemplateView.__proto__ || Object.getPrototypeOf(DropdownTemplateView)).call(this, $containerEl));

        _this._keyDownHandler = function (keycode, event) {
            if (_this.isShown) {
                switch (keycode) {
                    case _keyCodes.KEY_CODE_ESC:
                    case _keyCodes.KEY_CODE_TAB:
                        _this.hide();
                        return true;
                }
            }
        };

        _this.params = {
            toggleMode: toggleMode,
            onHide: onHide,
            onShow: onShow
        };
        return _this;
    }

    _createClass(DropdownTemplateView, [{
        key: "showAt",
        value: function showAt($element, positionParams, $positionEl) {
            if (!$positionEl) $positionEl = $element;

            // prevent next showing if closed by mouse down to $element
            if (this.params.toggleMode && this.ignoreNextShowing) {
                this.ignoreNextShowing = false;
                return;
            }

            var ie8 = (0, _atBrowserUtils.isIE8)();
            if (ie8) {
                this.lastWindowWidth = (0, _jquery2.default)(window).width;
                this.lastWindowHeight = (0, _jquery2.default)(window).height;
            }

            this._registerHideHandlers();

            this.update(); // update before show

            this.$elementShowAt = $element;
            positionParams = positionParams || {};
            positionParams.of = $positionEl;
            this.show();
            this._showElementAt(this.$el, positionParams);
            if (!this.isShown) {
                this.isShown = true;
                this.onShow();
            }
        }
    }, {
        key: "_registerHideHandlers",
        value: function _registerHideHandlers() {
            this.mouseDownTargetElement().on("mousedown.dropdownList", _jquery2.default.proxy(this._mouseDownHandler, this));
            (0, _jquery2.default)(window).on("resize.dropdownList", _jquery2.default.proxy((0, _atBrowserUtils.isIE8)() ? this._resizeIE8Handler : this._resizeHandler, this));
        }
    }, {
        key: "mouseDownTargetElement",
        value: function mouseDownTargetElement() {
            return this.$containerEl;
        }
    }, {
        key: "_mouseDownIgnoreElement",
        value: function _mouseDownIgnoreElement() {
            return this.$el;
        }
    }, {
        key: "_showElementAt",
        value: function _showElementAt($el, positionParams) {
            (0, _atBrowserUtils.showElementAt)($el, positionParams);
        }
    }, {
        key: "onShow",
        value: function onShow() {
            this._removeKeydownHandler = _index2.default.onKeyDown(this._keyDownHandler);
            if (this.params.onShow) this.params.onShow();
        }
    }, {
        key: "onHide",
        value: function onHide() {
            if (this._removeKeydownHandler) this._removeKeydownHandler();
        }
    }, {
        key: "_isPossibleToHide",
        value: function _isPossibleToHide() {
            return true;
        }
    }, {
        key: "hide",
        value: function hide() {
            var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            if (this.isShown && (force || this._isPossibleToHide())) {
                this.isShown = false;
                _get(DropdownTemplateView.prototype.__proto__ || Object.getPrototypeOf(DropdownTemplateView.prototype), "hide", this).call(this);
                this.$el.hide();

                this.mouseDownTargetElement().off("mousedown.dropdownList");
                (0, _jquery2.default)(window).off("resize.dropdownList");
                this.$containerEl.off("keydown.dropdownList");
                this.onHide();
                if (this.params.onHide) this.params.onHide();
            }
        }
    }, {
        key: "_resizeHandler",
        value: function _resizeHandler() {
            this.hide();
        }
    }, {
        key: "_resizeIE8Handler",
        value: function _resizeIE8Handler() {
            if ((0, _jquery2.default)(window).width() !== this.lastWindowWidth || (0, _jquery2.default)(window).height() !== this.lastWindowHeight) {
                this.lastWindowWidth = (0, _jquery2.default)(window).width();
                this.lastWindowHeight = (0, _jquery2.default)(window).height();
                this.hide();
            }
        }
    }, {
        key: "_scrollHandler",
        value: function _scrollHandler() {
            this.hide();
        }
    }, {
        key: "_mouseDownHandler",
        value: function _mouseDownHandler(event) {
            if (this.isShown) {
                var target = event.target;
                while (target) {
                    if (target === this.$elementShowAt[0]) {
                        this.ignoreNextShowing = true;
                    }
                    if (target === this._mouseDownIgnoreElement()[0]) {
                        return;
                    }
                    target = target.parentElement;
                }
                (0, _atBrowserUtils.cancelBubble)(event);
                this.hide();
                event.preventDefault();
            }
        }
    }]);

    return DropdownTemplateView;
}(_TemplateView3.default);

exports.default = DropdownTemplateView;

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = CSVPreviewSection;

var _PreviewSection = __webpack_require__(67);

var _PreviewSection2 = _interopRequireDefault(_PreviewSection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CSVPreviewSection() {}

CSVPreviewSection.prototype = new _PreviewSection2.default();

CSVPreviewSection.prototype.init = function () {
    _PreviewSection2.default.prototype.init.call(this);
    return this;
};
CSVPreviewSection.prototype.addRow = function (tBody, row) {
    this._addRow(tBody, row, "rowHeader");
};

CSVPreviewSection.prototype.addRowWithAdditionalClass = function (tBody, row, newClass) {
    this._addRow(tBody, row, "rowHeader " + newClass);
};

CSVPreviewSection.prototype._addRow = function (tBody, row, cellClass) {
    var rowNum = tBody.childNodes.length;
    row.insertBefore(ReportPreviewUtils.createCell(rowNum, cellClass), row.firstChild);
    _PreviewSection2.default.prototype.addRow.call(this, tBody, row);
};

CSVPreviewSection.prototype.addCellWithFloatingContent = function (row, notEscapedContent) {
    ReportPreviewUtils.addCellWithFloatingContent(row, notEscapedContent);
};

CSVPreviewSection.prototype.addValueCell = function (row, innerHTML) {
    this.addCell(row, innerHTML, "value");
};

CSVPreviewSection.prototype.addTimeValueCell = function (row) {
    this.addValueCell(row, ReportPreviewUtils.getCSVTimeValue());
};

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var GC = window.__GENERATED_CONSTANTS__;

var TaskFieldFilterKey = exports.TaskFieldFilterKey = {
    STATUS: 'STATUS'
};

var TaskSortBy = exports.TaskSortBy = {
    CUSTOMER: GC.TaskSortBy.CUSTOMER,
    PROJECT: GC.TaskSortBy.PROJECT,
    TASK: GC.TaskSortBy.TASK,
    STATUS: GC.TaskSortBy.STATUS,
    WORKFLOW_STATUS: GC.TaskSortBy.WORKFLOW_STATUS,
    DEADLINE: GC.TaskSortBy.DEADLINE,
    ESTIMATE: GC.TaskSortBy.ESTIMATE,
    LAST_TRACKING_DATE: GC.TaskSortBy.LAST_TRACKING_DATE,
    TYPE_OF_WORK: GC.TaskSortBy.TYPE_OF_WORK,
    CREATION_DATE: GC.TaskSortBy.CREATION_DATE,
    SPENT_TIME: GC.TaskSortBy.SPENT_TIME,
    VARIANCE_MAN_HOURS: "VARIANCE_MAN_HOURS",
    VARIANCE_PERCENTS: "VARIANCE_PERCENTS",
    VARIANCE_PROGRESS_BAR: "VARIANCE_PROGRESS_BAR"
};

var TaskTableDefaultSorting = exports.TaskTableDefaultSorting = { by: TaskSortBy.TASK, asc: true };

var TaskManagementViewMode = exports.TaskManagementViewMode = {
    TABLE: 'TABLE',
    KANBAN: 'KANBAN'
};

var TableTasksConstants = exports.TableTasksConstants = {
    OPEN_TASK_EXISTS_ERROR: GC.TableTasksConstants.OPEN_TASK_EXISTS_ERROR,
    COMPLETED_TASK_EXISTS_ERROR: GC.TableTasksConstants.COMPLETED_TASK_EXISTS_ERROR,
    UNKNOWN_TASK_EXISTS_ERROR: GC.TableTasksConstants.UNKNOWN_TASK_EXISTS_ERROR,
    BILLING_TYPE_DELETED_OR_ARCHIVED_ERROR: GC.TableTasksConstants.BILLING_TYPE_DELETED_OR_ARCHIVED_ERROR
};

var TaskListStaticFilters = exports.TaskListStaticFilters = [{
    key: TaskFieldFilterKey.STATUS,
    title: 'Status'
}];

var TaskTableConfigurableColumns = exports.TaskTableConfigurableColumns = {
    DEADLINE: GC.TaskSortBy.DEADLINE,
    ESTIMATE: GC.TaskSortBy.ESTIMATE,
    LAST_TRACKING_DATE: GC.TaskSortBy.LAST_TRACKING_DATE,
    TYPE_OF_WORK: GC.TaskSortBy.TYPE_OF_WORK,
    CREATION_DATE: GC.TaskSortBy.CREATION_DATE,
    SPENT_TIME: GC.TaskSortBy.SPENT_TIME,
    VARIANCE_MAN_HOURS: TaskSortBy.VARIANCE_MAN_HOURS,
    VARIANCE_PERCENTS: TaskSortBy.VARIANCE_PERCENTS,
    VARIANCE_PROGRESS_BAR: TaskSortBy.VARIANCE_PROGRESS_BAR
};

var TASK_LOAD_LIMIT = exports.TASK_LOAD_LIMIT = 20;

var PRIORITY_FIELD_NAME = exports.PRIORITY_FIELD_NAME = 'priority';

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getInstance = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

exports.default = tooltip;

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _SimpleTooltip2 = __webpack_require__(36);

var _SimpleTooltip3 = _interopRequireDefault(_SimpleTooltip2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SimpleSingletonTooltip = function (_SimpleTooltip) {
    _inherits(SimpleSingletonTooltip, _SimpleTooltip);

    function SimpleSingletonTooltip() {
        _classCallCheck(this, SimpleSingletonTooltip);

        var _this = _possibleConstructorReturn(this, (SimpleSingletonTooltip.__proto__ || Object.getPrototypeOf(SimpleSingletonTooltip)).call(this, { extraClass: 'simpleSingletonTooltip' }));

        _this.state = {
            text: '',
            html: '',
            extraClass: ''

            /*
            * There are two incompatible properties in state - text and html.
            * Only one property affect to representation at the moment.
            * Think about refactoring
            * */
        };_this.onStatePropertyChanged('text', function (text) {
            if (text) {
                _this.state.html = '';
                _this.setText(text);
            }
        });

        _this.onStatePropertyChanged('html', function (html) {
            if (html) {
                _this.state.text = '';
                _this.setHtml(html);
            }
        });

        _this.onStatePropertyChanged('extraClass', function (newExtraClass, oldExtraClass) {
            _this.$el.removeClass(oldExtraClass);
            _this.$el.addClass(newExtraClass);
        });

        _this.stateStack = [];
        return _this;
    }

    _createClass(SimpleSingletonTooltip, [{
        key: 'show',
        value: function show() {
            _get(SimpleSingletonTooltip.prototype.__proto__ || Object.getPrototypeOf(SimpleSingletonTooltip.prototype), 'show', this).call(this);
            this.stateStack.push(this.state);
        }
    }, {
        key: 'hide',
        value: function hide() {
            this.stateStack.pop();
            if (this.stateStack.length === 0) {
                _get(SimpleSingletonTooltip.prototype.__proto__ || Object.getPrototypeOf(SimpleSingletonTooltip.prototype), 'hide', this).call(this);
            } else {
                this.setState(this.stateStack[this.stateStack.length - 1]);
            }
        }
    }]);

    return SimpleSingletonTooltip;
}(_SimpleTooltip3.default);

var instance = null;
var getInstance = exports.getInstance = function getInstance() {
    if (instance === null) {
        instance = new SimpleSingletonTooltip().init((0, _jquery2.default)('body'));
    }
    return instance;
};

function tooltip($el, state) {
    getInstance().subscribeToMouseEvents($el, function () {
        return getInstance().setState(state);
    });
}

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(38);
var IE8_DOM_DEFINE = __webpack_require__(606);
var toPrimitive = __webpack_require__(131);
var dP = Object.defineProperty;

exports.f = __webpack_require__(47) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(32)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.onKeyPress = exports.onKeyUp = exports.onKeyDown = exports.KEY_HANDLERS = undefined;

var _keyHelpers = __webpack_require__(1289);

Object.keys(_keyHelpers).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _keyHelpers[key];
        }
    });
});

var _keyModifiersHelper = __webpack_require__(1290);

Object.keys(_keyModifiersHelper).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _keyModifiersHelper[key];
        }
    });
});

var _domHelper = __webpack_require__(1291);

var _domHelper2 = _interopRequireDefault(_domHelper);

var _HandlersStack = __webpack_require__(718);

var _HandlersStack2 = _interopRequireDefault(_HandlersStack);

var _constants = __webpack_require__(719);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _domHelper2.default)();

var KEY_HANDLERS = exports.KEY_HANDLERS = {
    onKeyDown: function onKeyDown(handler) {
        return _HandlersStack2.default.addHandler(_constants.EVENTS.KEY_DOWN, handler);
    },
    onKeyUp: function onKeyUp(handler) {
        return _HandlersStack2.default.addHandler(_constants.EVENTS.KEY_UP, handler);
    },
    onKeyPress: function onKeyPress(handler) {
        return _HandlersStack2.default.addHandler(_constants.EVENTS.KEY_PRESS, handler);
    }
};

var onKeyDown = exports.onKeyDown = KEY_HANDLERS.onKeyDown;
var onKeyUp = exports.onKeyUp = KEY_HANDLERS.onKeyUp;
var onKeyPress = exports.onKeyPress = KEY_HANDLERS.onKeyPress;

exports.default = KEY_HANDLERS;

window.KEY_HANDLERS = KEY_HANDLERS;

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _ScrollUtils = __webpack_require__(39);

var _ScrollUtils2 = _interopRequireDefault(_ScrollUtils);

var _ScrollDragHandler = __webpack_require__(769);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _ScrollToTopButton = __webpack_require__(770);

var _ScrollToTopButton2 = _interopRequireDefault(_ScrollToTopButton);

var _atBrowserUtils = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ScrollableContainer = function (_TemplateView) {
    _inherits(ScrollableContainer, _TemplateView);

    function ScrollableContainer($el, contentComponent) {
        var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
            _ref$containerClass = _ref.containerClass,
            containerClass = _ref$containerClass === undefined ? '' : _ref$containerClass,
            _ref$contentWrapperCl = _ref.contentWrapperClass,
            contentWrapperClass = _ref$contentWrapperCl === undefined ? '' : _ref$contentWrapperCl,
            _ref$iScrollParams = _ref.iScrollParams,
            iScrollParams = _ref$iScrollParams === undefined ? {} : _ref$iScrollParams,
            _ref$triggerScrollEve = _ref.triggerScrollEvent,
            triggerScrollEvent = _ref$triggerScrollEve === undefined ? false : _ref$triggerScrollEve,
            _ref$needRefreshOnRes = _ref.needRefreshOnResize,
            needRefreshOnResize = _ref$needRefreshOnRes === undefined ? false : _ref$needRefreshOnRes,
            _ref$onScrollCb = _ref.onScrollCb,
            onScrollCb = _ref$onScrollCb === undefined ? function (scrollPosition, maxScrollY) {} : _ref$onScrollCb,
            _ref$onScrollToBottom = _ref.onScrollToBottom,
            onScrollToBottom = _ref$onScrollToBottom === undefined ? function () {} : _ref$onScrollToBottom,
            _ref$maxScrollToBotto = _ref.maxScrollToBottomOffset,
            maxScrollToBottomOffset = _ref$maxScrollToBotto === undefined ? 200 : _ref$maxScrollToBotto,
            _ref$showScrollToTopB = _ref.showScrollToTopButton,
            showScrollToTopButton = _ref$showScrollToTopB === undefined ? false : _ref$showScrollToTopB,
            _ref$scrollToTopButto = _ref.scrollToTopButtonAdditionalClass,
            scrollToTopButtonAdditionalClass = _ref$scrollToTopButto === undefined ? '' : _ref$scrollToTopButto,
            _ref$shouldUpdateOnIn = _ref.shouldUpdateOnInit,
            shouldUpdateOnInit = _ref$shouldUpdateOnIn === undefined ? true : _ref$shouldUpdateOnIn,
            _ref$ignoreScrollingP = _ref.ignoreScrollingPredicate,
            ignoreScrollingPredicate = _ref$ignoreScrollingP === undefined ? function () {
            return false;
        } : _ref$ignoreScrollingP,
            _ref$autoScrollEnable = _ref.autoScrollEnabled,
            autoScrollEnabled = _ref$autoScrollEnable === undefined ? false : _ref$autoScrollEnable,
            scrollDelta = _ref.scrollDelta,
            scrollOffset = _ref.scrollOffset,
            _ref$scrollEvent = _ref.scrollEvent,
            scrollEvent = _ref$scrollEvent === undefined ? '' : _ref$scrollEvent;

        _classCallCheck(this, ScrollableContainer);

        var _this = _possibleConstructorReturn(this, (ScrollableContainer.__proto__ || Object.getPrototypeOf(ScrollableContainer)).call(this, $el));

        _this.contentComponent = contentComponent;

        _this.containerClass = containerClass;
        _this.contentWrapperClass = contentWrapperClass;

        _this.params = {
            iScrollParams: iScrollParams,
            triggerScrollEvent: triggerScrollEvent,
            needRefreshOnResize: needRefreshOnResize,
            showScrollToTopButton: showScrollToTopButton,
            scrollToTopButtonAdditionalClass: scrollToTopButtonAdditionalClass,
            shouldUpdateOnInit: shouldUpdateOnInit,
            maxScrollToBottomOffset: maxScrollToBottomOffset,
            ignoreScrollingPredicate: ignoreScrollingPredicate,
            autoScrollEnabled: autoScrollEnabled,
            scrollEvent: scrollEvent,
            scrollDelta: scrollDelta,
            scrollOffset: scrollOffset
        };

        _this.callbacks = {
            onScrollCb: onScrollCb,
            onScrollToBottom: onScrollToBottom
        };
        return _this;
    }

    _createClass(ScrollableContainer, [{
        key: 'afterRender',
        value: function afterRender() {
            var _this2 = this;

            this.$el.on(_ScrollUtils2.default.getWheelEventName(), function (e) {
                // disable iscroll if scroll event already used by another component
                // usually predicate is checking classname in event target tree
                if (_this2.params.ignoreScrollingPredicate(e.originalEvent)) {
                    _this2.innerScroll.disable();
                    setTimeout(function () {
                        _this2.innerScroll.enable();
                    }, 0);
                }
            });

            this.innerScroll = _ScrollUtils2.default.addVerticalScroll(this.$el, this.params.iScrollParams);
            //prevent parent scrollable containers scroll
            (0, _atBrowserUtils.fixIScrollInnerWheelEvent)(this.$el);

            if (this.params.showScrollToTopButton) {
                this.scrollToTopButton = new _ScrollToTopButton2.default({
                    fadingHeight: 250,
                    onClickCb: function onClickCb() {
                        _this2.scrollToTop(1000);
                        _this2.scrollToTopButton.fadeOut(1000);
                    },
                    scrollToTopButtonAdditionalClass: this.params.scrollToTopButtonAdditionalClass
                }).init(this.find('.scrollToTopButtonPlaceholder'));
            }

            this.contentComponent = this.contentComponent.init(this.getContainer());
            this.registerChildComponents(this.contentComponent);

            this.innerComponentMethods = {
                setState: this.contentComponent.setState,
                update: this.contentComponent.update
                // proxy some method of inner component
            };var self = this;
            this.contentComponent.setState = function () {
                self.innerComponentMethods.setState.apply(this, arguments);
                self.forceUpdate();
            };
            this.contentComponent.update = function () {
                self.innerComponentMethods.update.apply(this);
                self.forceUpdate();
            };

            if (this.params.triggerScrollEvent) {
                this.innerScroll.on('scrollStart', function () {
                    if (_this2.innerScroll.hasVerticalScroll) {
                        _this2.contentComponent.getEl().trigger('scroll');
                    }
                });

                this.innerScroll.on('scroll', function () {
                    _this2.contentComponent.getEl().trigger('verticalScroll', {
                        y: _this2.innerScroll.y,
                        maxScrollY: _this2.innerScroll.maxScrollY
                    });
                    _this2.scrollToTopButton.updateVisibility(_this2.innerScroll.y);
                });
            }

            this.innerScroll.on('scroll', function () {
                _this2.callbacks.onScrollCb(_this2.innerScroll.y, _this2.innerScroll.maxScrollY);
                _this2._checkIfScrolledToBottom();
            });

            if (this.params.needRefreshOnResize) {
                (0, _jquery2.default)(window).resizeThrottle(function () {
                    return _this2.forceUpdate();
                }, 100);
            }

            if (this.params.autoScrollEnabled) {
                this._subscribeVerticalScrollHandler();
            }
        }
    }, {
        key: 'templateHtml',
        value: function templateHtml() {
            return "" + "<div class='scrollableContainer <%=containerClass%>'>" + "    <div class='contentWrapper <%=contentWrapperClass%>'></div>" + "    <div class='scrollToTopButtonPlaceholder'></div>" + "</div>";
        }
    }, {
        key: 'templateModel',
        value: function templateModel() {
            return {
                containerClass: this.containerClass,
                contentWrapperClass: this.contentWrapperClass
            };
        }
    }, {
        key: 'setState',
        value: function setState(data) {
            this.applyForChildrenComponents(function (child) {
                return child.setState(data);
            });
            this.forceUpdate();
        }
    }, {
        key: 'getContainer',
        value: function getContainer() {
            return this.find('.contentWrapper');
        }
    }, {
        key: 'forceUpdate',
        value: function forceUpdate() {
            _ScrollUtils2.default.refreshCustomScroll(this.innerScroll);

            if (this.params.showScrollToTopButton) this.scrollToTopButton.updateVisibility(this.innerScroll.y);
            this._checkIfScrolledToBottom();
        }
    }, {
        key: 'shouldUpdateOnInit',
        value: function shouldUpdateOnInit() {
            return this.params.shouldUpdateOnInit;
        }
    }, {
        key: 'scrollToTop',
        value: function scrollToTop() {
            var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

            _ScrollUtils2.default.scrollToTop(this.innerScroll, this.getEl(), time);
        }
    }, {
        key: 'scrollToBottom',
        value: function scrollToBottom() {
            _ScrollUtils2.default.scrollToBottom(this.innerScroll);
        }

        /**
         * @deprecated Use onScrollToBottom callback instead
         */

    }, {
        key: 'performIfScrollToBottom',
        value: function performIfScrollToBottom(callback) {
            var verticalGap = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;

            _ScrollUtils2.default.performIfScrollToBottom(this.innerScroll, verticalGap, function () {
                callback();
            });
        }
    }, {
        key: 'scrollToElementVertical',
        value: function scrollToElementVertical($el, position, timeMs) {
            _ScrollUtils2.default.scrollIntoViewVertical(this.innerScroll, $el[0], position, false, timeMs);
        }
    }, {
        key: 'update',
        value: function update() {
            this.applyForChildrenComponents(function (child) {
                return child.update();
            });
            this.forceUpdate();
        }
    }, {
        key: '_checkIfScrolledToBottom',
        value: function _checkIfScrolledToBottom() {
            _ScrollUtils2.default.performIfScrollToBottom(this.innerScroll, this.params.maxScrollToBottomOffset, this.callbacks.onScrollToBottom);
        }
    }, {
        key: '_subscribeVerticalScrollHandler',
        value: function _subscribeVerticalScrollHandler() {
            var _this3 = this;

            this.scrollDragHandler = new _ScrollDragHandler.VerticalScrollDragHandler({
                scroll: this.innerScroll,
                scrollableEl: this.getEl(),
                scrollOffset: this.params.scrollOffset,
                scrollDelta: this.params.scrollDelta,
                onUpdateScroll: function onUpdateScroll() {
                    return _this3.forceUpdate();
                }
            });

            this.getEl().on(this.params.scrollEvent, function (_, event) {
                _this3.scrollDragHandler.handleEvent(event);
            });

            this.getEl().on('mouseout', function (e) {
                _this3.scrollDragHandler.clearAutoScrollTimer();
            });
        }
    }]);

    return ScrollableContainer;
}(_TemplateView3.default);

exports.default = ScrollableContainer;

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.handleCommonError = exports.handleKeptMaAfterRemoveWaByToast = exports.updateUsersListUserGroupId = exports.closeAllPanels = exports.removeUserFromList = exports.setUserList = exports.addNewUsersToList = exports.setViewerManagementAssignmentsCounters = exports.addNewUserIds = exports.setNewUserIdSet = exports.setLicenseCounters = exports.setUsersWithoutApprovers = exports.setUserManagementData = exports.setViewerSettings = exports.setActiveTabAction = undefined;

var _actionTypes = __webpack_require__(104);

var ActionTypes = _interopRequireWildcard(_actionTypes);

var _reduxActions = __webpack_require__(9);

var _utils = __webpack_require__(6);

var _syncCallbacks = __webpack_require__(1634);

var UserManagementSyncCallbacks = _interopRequireWildcard(_syncCallbacks);

var _utils2 = __webpack_require__(202);

var _actions = __webpack_require__(56);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _constants = __webpack_require__(4);

var _util = __webpack_require__(254);

var _actions2 = __webpack_require__(29);

var _syncCallbacks2 = __webpack_require__(256);

var SyncCallbacks = _interopRequireWildcard(_syncCallbacks2);

var _RpcError = __webpack_require__(281);

var _RpcError2 = _interopRequireDefault(_RpcError);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var setActiveTabAction = exports.setActiveTabAction = function setActiveTabAction(tabNum) {
    return function (dispatch) {
        dispatch((0, _utils.createActionObject)(ActionTypes.SET_ACTIVE_TAB, tabNum));
        (0, _utils2.saveActiveTabNum)(tabNum);

        UserManagementSyncCallbacks.triggerActiveTabChanged(tabNum);
    };
};

var setViewerSettings = exports.setViewerSettings = (0, _reduxActions.createAction)(ActionTypes.SET_VIEWER_SETTINGS);
var setUserManagementData = exports.setUserManagementData = (0, _reduxActions.createAction)(ActionTypes.USER_MANAGEMENT_DATA_SET);
var setUsersWithoutApprovers = exports.setUsersWithoutApprovers = (0, _reduxActions.createAction)(ActionTypes.SET_USERS_WITHOUT_APPROVERS);
var setLicenseCounters = exports.setLicenseCounters = (0, _reduxActions.createAction)(ActionTypes.SET_LICENSE_COUNTERS);
var setNewUserIdSet = exports.setNewUserIdSet = (0, _reduxActions.createAction)(ActionTypes.SET_NEW_USER_IDS);
var addNewUserIds = exports.addNewUserIds = (0, _reduxActions.createAction)(ActionTypes.ADD_NEW_USER_IDS);
var setViewerManagementAssignmentsCounters = exports.setViewerManagementAssignmentsCounters = (0, _reduxActions.createAction)(ActionTypes.SET_VIEWER_MANAGEMENT_ASSIGNMENTS_COUNTERS);
var addNewUsersToList = exports.addNewUsersToList = (0, _reduxActions.createAction)(ActionTypes.USERS_LIST_ADD);
var setUserList = exports.setUserList = (0, _reduxActions.createAction)(ActionTypes.USERS_LIST_SET);
var removeUserFromList = exports.removeUserFromList = (0, _reduxActions.createAction)(ActionTypes.USERS_LIST_REMOVE);
var closeAllPanels = exports.closeAllPanels = (0, _reduxActions.createAction)(ActionTypes.CLOSE_ALL_PANELS);
var updateUsersListUserGroupId = exports.updateUsersListUserGroupId = (0, _reduxActions.createAction)(ActionTypes.USERS_LIST_USER_GROUP_ID_UPDATE);

var handleKeptMaAfterRemoveWaByToast = exports.handleKeptMaAfterRemoveWaByToast = function handleKeptMaAfterRemoveWaByToast(_ref) {
    var cptWaChangesFlags = _ref.cptWaChangesFlags,
        level = _ref.level,
        _ref$all = _ref.all,
        all = _ref$all === undefined ? false : _ref$all;
    return function (dispatch) {
        if (!cptWaChangesFlags.customersKept && !cptWaChangesFlags.projectsKept && !cptWaChangesFlags.tasksKept && !cptWaChangesFlags.noDeletions) return;

        var levelName = "";
        var levelNames = "";

        switch (level) {
            case _constants.HierarchyLevels.CUSTOMER:
                levelName = _messageResource2.default.getMessage('common.customer');
                levelNames = _messageResource2.default.getMessage('common.customers');
                break;
            case _constants.HierarchyLevels.PROJECT:
                levelName = _messageResource2.default.getMessage('common.project');
                levelNames = _messageResource2.default.getMessage('common.projects');
                break;
            case _constants.HierarchyLevels.TASK:
                levelName = _messageResource2.default.getMessage('common.task');
                levelNames = _messageResource2.default.getMessage('common.tasks');
                break;
        }

        if (!!cptWaChangesFlags) {
            if (all && cptWaChangesFlags.noDeletions) {
                dispatch((0, _actions.toast)(_messageResource2.default.getMessage('assigned_users_editor.work.toast.revoke_all.wa_kept_as_ma', [levelNames])));
                return;
            }

            var maItemLevelNames = void 0;
            if (cptWaChangesFlags.customersKept && cptWaChangesFlags.projectsKept && cptWaChangesFlags.tasksKept) {
                maItemLevelNames = _messageResource2.default.getMessage('common.customers') + ", " + _messageResource2.default.getMessage('common.projects') + " and " + _messageResource2.default.getMessage('common.tasks');
            } else if (cptWaChangesFlags.projectsKept && cptWaChangesFlags.tasksKept) {
                maItemLevelNames = _messageResource2.default.getMessage('common.projects') + " and " + _messageResource2.default.getMessage('common.tasks');
            } else if (cptWaChangesFlags.customersKept && cptWaChangesFlags.projectsKept) {
                maItemLevelNames = _messageResource2.default.getMessage('common.customers') + " and " + _messageResource2.default.getMessage('common.projects');
            } else if (cptWaChangesFlags.customersKept && cptWaChangesFlags.tasksKept) {
                maItemLevelNames = _messageResource2.default.getMessage('common.customers') + " and " + _messageResource2.default.getMessage('common.tasks');
            } else if (cptWaChangesFlags.customersKept) {
                maItemLevelNames = _messageResource2.default.getMessage('common.customers');
            } else if (cptWaChangesFlags.projectsKept) {
                maItemLevelNames = _messageResource2.default.getMessage('common.projects');
            } else if (cptWaChangesFlags.tasksKept) {
                maItemLevelNames = _messageResource2.default.getMessage('common.tasks');
            }

            if (all) {
                dispatch((0, _actions.toast)(_messageResource2.default.getMessage('assigned_users_editor.work.toast.revoke_all.wa_kept_as_ma', [maItemLevelNames])));
            } else if (cptWaChangesFlags.noDeletions) {
                dispatch((0, _actions.toast)(_messageResource2.default.getMessage('assigned_users_editor.work.toast.all_wa_kept_as_ma', [levelName, maItemLevelNames])));
            } else {
                dispatch((0, _actions.toast)(_messageResource2.default.getMessage('assigned_users_editor.work.toast.some_wa_kept_as_ma', [levelName, maItemLevelNames])));
            }
        }
    };
};

var handleCommonError = exports.handleCommonError = function handleCommonError(userId, error) {
    return function (dispatch) {
        if (error instanceof _RpcError2.default) {
            switch (error.getException()) {
                case _util.EXCEPTIONS.NoSuchUserException:
                    alert(_messageResource2.default.getMessage('user.js.error_user_was_deleted'));
                    dispatch((0, _actions2.removeUser)(userId));
                    SyncCallbacks.onNoSuchUserException(userId);
                    break;
                case _util.EXCEPTIONS.NoRightsToManageAccountSettings:
                    alert(_messageResource2.default.getMessage('userlist.js.error_manage_account_settings_right_revoked'));
                    window.location.reload();
                    break;
                default:
                    console.error(error);
            }
        }
    };
};

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.NO_SUCH_ICAL_FEED_SETTINGS_EXCEPTION = exports.NO_RIGHT_FOR_RPC_EXCEPTION = exports.ICALENDAR_KEY = exports.FEEDS_TOOLTIP_EXTRA_CLASS = exports.RENDER_LEAVE_TYPES_LIMIT = exports.ICalLightboxType = exports.DEFAULT_SORTING = exports.SortingProperty = exports.LEARN_MORE_URL = exports.ICalTabType = undefined;

var _constants = __webpack_require__(4);

var ICalTabType = exports.ICalTabType = {
    ALL_FEEDS: 'allFeeds',
    USER_FEEDS: 'userFeeds'
};

var LEARN_MORE_URL = exports.LEARN_MORE_URL = _constants.ProductWebSiteURLs.USER_GUIDE_URL + 'calendars.html#ical';

var SortingProperty = exports.SortingProperty = {
    FEED_NAME: 'BY_FEED_NAME',
    CREATOR_NAME: 'BY_CREATOR_NAME',
    EDITOR_NAME: 'BY_EDITOR_NAME',
    CREATED_DATE: 'BY_CREATED_DATE',
    EDITED_DATE: 'BY_EDITED_DATE',
    LAST_SYNC: 'BY_LAST_SYNC'
};

var DEFAULT_SORTING = exports.DEFAULT_SORTING = {
    property: SortingProperty.FEED_NAME,
    isAsc: true
};

var ICalLightboxType = exports.ICalLightboxType = {
    CREATE: 'create',
    EDIT: 'edit',
    EXPORT: 'export'
};

var RENDER_LEAVE_TYPES_LIMIT = exports.RENDER_LEAVE_TYPES_LIMIT = 6;
var FEEDS_TOOLTIP_EXTRA_CLASS = exports.FEEDS_TOOLTIP_EXTRA_CLASS = 'feedsTooltip';
var ICALENDAR_KEY = exports.ICALENDAR_KEY = 'iCalendar';

var NO_RIGHT_FOR_RPC_EXCEPTION = exports.NO_RIGHT_FOR_RPC_EXCEPTION = 'com.actimind.actitime.services.NoRightsForRemoteCallException';
var NO_SUCH_ICAL_FEED_SETTINGS_EXCEPTION = exports.NO_SUCH_ICAL_FEED_SETTINGS_EXCEPTION = 'com.actimind.actiplans.icalendar.NoSuchICalFeedSettingsException';

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _constants = __webpack_require__(4);

var _atUtils = __webpack_require__(5);

var _UserSelectorUtils = __webpack_require__(514);

var _UserSelectorUtils2 = _interopRequireDefault(_UserSelectorUtils);

var _pluralizeUtils = __webpack_require__(40);

var _selectors = __webpack_require__(19);

var _utils = __webpack_require__(6);

var _BaseReportParamsStringBuilder = __webpack_require__(803);

var _BaseReportParamsStringBuilder2 = _interopRequireDefault(_BaseReportParamsStringBuilder);

var _date_format = __webpack_require__(16);

var _constants2 = __webpack_require__(4);

var _selectors2 = __webpack_require__(15);

var _FormatUtils = __webpack_require__(142);

var _FormatUtils2 = _interopRequireDefault(_FormatUtils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ATReportParamsStringBuilder = function (_BaseReportParamsStri) {
    _inherits(ATReportParamsStringBuilder, _BaseReportParamsStri);

    function ATReportParamsStringBuilder(_ref) {
        var data = _ref.data,
            dateFormat = _ref.dateFormat,
            reportAuthorizationInfo = _ref.reportAuthorizationInfo,
            _ref$userFormatter = _ref.userFormatter,
            userFormatter = _ref$userFormatter === undefined ? _FormatUtils2.default.reportUserFormatterWithUsernameIfNeeded : _ref$userFormatter;

        _classCallCheck(this, ATReportParamsStringBuilder);

        var _this = _possibleConstructorReturn(this, (ATReportParamsStringBuilder.__proto__ || Object.getPrototypeOf(ATReportParamsStringBuilder)).call(this, { data: data, dateFormat: dateFormat, userFormatter: userFormatter }));

        _this.userGroupsFeatureEnabled = (0, _utils.unsafe_selectWithState)(function (state) {
            return (0, _selectors2.isUGREnabled)(state);
        });
        _this.tzGroupsFeatureEnabled = (0, _utils.unsafe_selectWithState)(function (state) {
            return (0, _selectors2.isTZGEnabled)(state);
        });

        _this.manageableUserIdsSet = !!data.manageableUserIds && (0, _atUtils.arrayToSet)(data.manageableUserIds);

        _this.customersWithMaIds = !!data.customersWithMaIds && (0, _atUtils.arrayToSet)(data.customersWithMaIds);
        _this.projectsWithMaIds = !!data.projectsWithMaIds && (0, _atUtils.arrayToSet)(data.projectsWithMaIds);

        _this.loggedInUserId = (0, _utils.unsafe_selectWithState)(function (state) {
            return (0, _selectors.getLoggedInUserId)(state);
        });
        _this.isViewerNotAssignedToTeam = data.manageableUserIds && data.users && data.manageableUserIds.indexOf(_this.loggedInUserId) === -1 && data.users.some(function (u) {
            return u.id === _this.loggedInUserId;
        });

        _this.reportAuthorizationInfo = reportAuthorizationInfo;

        _this.customers = data.cpList ? (0, _atUtils.arrayToMap)(data.cpList.customers) : {};
        _this.projects = data.cpList ? (0, _atUtils.arrayToMap)(data.cpList.projects) : {};
        return _this;
    }

    _createClass(ATReportParamsStringBuilder, [{
        key: 'getFilteredCustomers',
        value: function getFilteredCustomers(cpSelection) {
            var _this2 = this;

            return cpSelection.includeOnlyManagementScope ? [] : cpSelection.customers.map(function (cId) {
                return _this2.customers[cId];
            }).filter(function (c) {
                return !!c;
            });
        }
    }, {
        key: 'getFilteredProjects',
        value: function getFilteredProjects(cpSelection) {
            var _this3 = this;

            var selectedProjectsIdsSet = (0, _atUtils.arrayToSet)(cpSelection.projects);
            var projectsFilterPredicate = void 0;

            if (cpSelection.includeOnlyManagementScope) {
                var selectedCustomersIdsSet = (0, _atUtils.arrayToSet)(cpSelection.customers);
                projectsFilterPredicate = function projectsFilterPredicate(project) {
                    return _this3.projectsWithMaIds[project.id] && (selectedProjectsIdsSet[project.id] || selectedCustomersIdsSet[project.customerId]);
                };
            } else {
                projectsFilterPredicate = function projectsFilterPredicate(project) {
                    return selectedProjectsIdsSet[project.id] && _this3.projects[project.id];
                };
            }

            return Object.values(this.projects).filter(projectsFilterPredicate);
        }
    }, {
        key: 'getUserSelectionParamString',
        value: function getUserSelectionParamString(userSelection) {
            var _this4 = this;

            if (!this.reportAuthorizationInfo.allUsersAvailable && !this.reportAuthorizationInfo.anyOtherUsersAvailable) {
                return this.userFormatter.format(this.getUser(this.loggedInUserId));
            }
            return _get(ATReportParamsStringBuilder.prototype.__proto__ || Object.getPrototypeOf(ATReportParamsStringBuilder.prototype), 'getUserSelectionParamString', this).call(this, userSelection, function () {
                return _this4._getAllUsersMessage();
            });
        }
    }, {
        key: 'getCPSelectionParamString',
        value: function getCPSelectionParamString(cpSelection) {

            var AND_DELIMITER = " & ";

            if (cpSelection.qualifier === _constants.CustomersProjectsSelectionQualifier.ALL) return _messageResource2.default.getMessage("saved_reports.cp_selector.all_projects");

            if (cpSelection.qualifier === _constants.CustomersProjectsSelectionQualifier.ALL_ACTIVE) {
                return _messageResource2.default.getMessage("saved_reports.cp_selector.all_active_projects");
            } else {
                var customers = this.getFilteredCustomers(cpSelection);
                var projects = this.getFilteredProjects(cpSelection);

                if (customers.length === 0 && projects.length === 0) return _messageResource2.default.getMessage("saved_reports.cp_selector.emty_selection"); //error_class

                if (customers.length === 1 && projects.length === 0) {
                    return _messageResource2.default.getMessage("saved_reports.cp_selector.single_element.customer", [customers[0].name]);
                }

                if (projects.length === 1 && customers.length === 0) {
                    return _messageResource2.default.getMessage("saved_reports.cp_selector.single_element.project", [projects[0].name]);
                }

                var getCustomersPart = function getCustomersPart(customers, availableSuffix, activeProjectsSuffix) {
                    return customers.length.toString() + " " + (0, _pluralizeUtils.customerNameLower)(customers.length) + " " + _messageResource2.default.getMessage("saved_reports.cp_selector.multiple_customer", [availableSuffix, activeProjectsSuffix]);
                };

                var getProjectsPart = function getProjectsPart(projects) {
                    return projects.length.toString() + " " + (0, _pluralizeUtils.projectNameLower)(projects.length);
                };

                var customersPart = "",
                    projectsPart = "";
                if (customers.length > 0) {
                    customersPart = getCustomersPart(customers, "", "");
                }

                if (projects.length > 0) {
                    projectsPart = getProjectsPart(projects);
                }
                return customersPart + (customersPart.length > 0 && projectsPart.length > 0 ? AND_DELIMITER : "") + projectsPart;
            }
        }
    }, {
        key: 'getUserSelectionDetailsString',
        value: function getUserSelectionDetailsString(userSelection) {
            var _this5 = this;

            if (userSelection.includeUserTeamOnly) {
                var usersFromSelectionUsersIds = this.getFilteredUsers(userSelection.selectedUsers);
                var selectedUsersAndUsersFromGroups = this._convertSelectedGroupsToSelectedUsersIfNecessary(usersFromSelectionUsersIds, userSelection).filter(function (user) {
                    return _this5.manageableUserIdsSet[user.id];
                });
                var res = [];

                res.push(this.getTitle(_messageResource2.default.getMessage("saved_reports.user_selector.title_header"), selectedUsersAndUsersFromGroups, this.userFormatter));
                return this.joinStrings(res, "\n", "\n");
            }

            return _get(ATReportParamsStringBuilder.prototype.__proto__ || Object.getPrototypeOf(ATReportParamsStringBuilder.prototype), 'getUserSelectionDetailsString', this).call(this, userSelection);
        }
    }, {
        key: 'getEvaDateParamString',
        value: function getEvaDateParamString(dateSelection) {
            if (dateSelection.qualifier !== _constants2.DateRangeSelectionQualifier.CUSTOM) {
                return _messageResource2.default.getMessage(EvaDateStateUtil[dateSelection.qualifier]);
            }
            var date = dateSelection.date.parseJSONDate();
            return new _date_format.DateFormat(this.dateFormat).formatDate(date) + ", " + Date.dayNames[date.getDay()];
        }
    }, {
        key: 'getEvaDateDetailsString',
        value: function getEvaDateDetailsString(dateSelection) {
            if (dateSelection.qualifier !== _constants2.DateRangeSelectionQualifier.CUSTOM) {
                var date = dateSelection.date.parseJSONDate();
                return new _date_format.DateFormat(this.dateFormat).formatDate(date) + ", " + Date.dayNames[date.getDay()];
            }
            return "";
        }
    }, {
        key: 'getEvaDateCSVString',
        value: function getEvaDateCSVString(dateSelection) {
            var date = dateSelection.date;
            return new _date_format.DateFormat(this.dateFormat).formatDate(date) + ", " + Date.dayNames[date.getDay()];
        }
    }, {
        key: 'getEvATaskDetailsString',
        value: function getEvATaskDetailsString(taskParams, dateSelection) {
            var mainInfo = "",
                additionalInfo = "";
            switch (taskParams.tasksConfig) {
                case "ALL":
                    mainInfo = _messageResource2.default.getMessage("report.budgeted_vs_actual.filter_view.open_and_completed_tasks");
                    break;
                case "OPEN_ONLY":
                    mainInfo = _messageResource2.default.getMessage("report.budgeted_vs_actual.filter_view.open_tasks");
                    break;
                case "COMPLETED_ONLY":
                    mainInfo = _messageResource2.default.getMessage("report.budgeted_vs_actual.filter_view.completed_tasks");
            }

            if (!taskParams.includeNotEstimated && !taskParams.includeNotStarted) additionalInfo = _messageResource2.default.getMessage("report.budgeted_vs_actual.except_started_after_and_not_estimated", [this.getEvaDateCSVString(dateSelection)]);else if (!taskParams.includeNotStarted) additionalInfo = _messageResource2.default.getMessage("report.budgeted_vs_actual.except_started_after", [this.getEvaDateCSVString(dateSelection)]);else if (!taskParams.includeNotEstimated) additionalInfo = _messageResource2.default.getMessage("report.budgeted_vs_actual.except_not_estimated");

            return mainInfo + " " + additionalInfo;
        }
    }, {
        key: '_getAllUsersMessage',
        value: function _getAllUsersMessage() {
            var allUsersAvailable = this.reportAuthorizationInfo.allUsersAvailable;
            var anyOtherUsersAvailable = _underscore2.default.isUndefined(this.reportAuthorizationInfo.anyOtherUsersAvailable) || this.reportAuthorizationInfo.anyOtherUsersAvailable;

            if (!allUsersAvailable && anyOtherUsersAvailable) {
                return this.isViewerNotAssignedToTeam ? _messageResource2.default.getMessage("users_selector.reports.team_users_and_me") : _messageResource2.default.getMessage("common.report.all_staff.assigned_to_me");
            } else {
                return _messageResource2.default.getMessage("users_selector.reports.all_users");
            }
        }
    }, {
        key: '_getIncludeUserTeamOnlyMessage',
        value: function _getIncludeUserTeamOnlyMessage(users) {
            var _this6 = this;

            var filteredUsers = users.filter(function (user) {
                return _this6.manageableUserIdsSet[user.id];
            });
            return filteredUsers.length === 1 ? this.userFormatter.format(filteredUsers[0]) : filteredUsers.length + ' ' + (0, _pluralizeUtils.userNameLower)(filteredUsers.length);
        }
    }, {
        key: '_convertSelectedGroupsToSelectedUsersIfNecessary',
        value: function _convertSelectedGroupsToSelectedUsersIfNecessary(users, userSelection) {
            var convertedUsers = _UserSelectorUtils2.default.convertSelectedGroupsIntoSelectedUsersConsideringTeamOnlyIfNecessary(this.users, userSelection.groupType, userSelection.allUsers, userSelection.showDisabled, userSelection.selectedGroups, this.userGroupsFeatureEnabled, this.tzGroupsFeatureEnabled, userSelection.includeUserTeamOnly);

            return _jquery2.default.merge(users, convertedUsers);
        }
    }]);

    return ATReportParamsStringBuilder;
}(_BaseReportParamsStringBuilder2.default);

exports.default = ATReportParamsStringBuilder;

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getDefaultWorkSchedule = exports.getPermissionsTemplates = exports.getUserManagementData = exports.getUsersListForWorkAssignmentsTab = exports.getActiveAssignedUserIds = exports.getSortedUsersList = exports.getUsersList = exports.isGenerateMoneyReportsEnabled = exports.getEditingUserId = exports.getAssignedUserIds = exports.getViewerManagementCounters = exports.getNewUsersIdSet = exports.licenseViolated = exports.isPossibleToCreateUsers = exports.isAllowedToManageAccountSettings = exports.getLicenseCounters = exports.getUsersWithoutApprovers = exports.getActiveTabNum = exports.isAccountSettingsTabVisible = exports.isWASTabVisible = exports.isSDBTabVisible = exports.isPTOTabVisible = exports.getViewerSettings = exports.getCommonState = undefined;

var _reselect = __webpack_require__(13);

var _selectors = __webpack_require__(15);

var _constants = __webpack_require__(4);

var _selectors2 = __webpack_require__(146);

var _selectors3 = __webpack_require__(203);

var _selectors4 = __webpack_require__(204);

var _utils = __webpack_require__(202);

var _selectors5 = __webpack_require__(313);

var _atUtils = __webpack_require__(5);

var _selectors6 = __webpack_require__(19);

var _user_group_selector_util = __webpack_require__(98);

var _utils2 = __webpack_require__(6);

var getCommonState = exports.getCommonState = function getCommonState(state) {
    return state.userManagement.common;
};

var getViewerSettings = exports.getViewerSettings = (0, _reselect.createSelector)(getCommonState, function (commonState) {
    return commonState.viewerSettings;
});

var isPTOTabVisible = exports.isPTOTabVisible = (0, _reselect.createSelector)(getViewerSettings, _selectors.isPTOEnabled, function (viewerSettings, ptoEnabled) {
    return viewerSettings.allowedToManageLeaveBalanceSettings && ptoEnabled;
});

var isSDBTabVisible = exports.isSDBTabVisible = (0, _reselect.createSelector)(getViewerSettings, _selectors.isSDBEnabled, function (viewerSettings, sdbEnabled) {
    return viewerSettings.allowedToManageLeaveBalanceSettings && sdbEnabled;
});

var isWASTabVisible = exports.isWASTabVisible = (0, _reselect.createSelector)(getViewerSettings, _selectors.isWASEnabled, function (viewerSettings, wasEnabled) {
    return viewerSettings.allowedToManageScope && (viewerSettings.allowedToManageAccountSettings || viewerSettings.hasAccessToScopeOfWork && viewerSettings.hasAccessToUsers) && wasEnabled;
});

var isAccountSettingsTabVisible = exports.isAccountSettingsTabVisible = (0, _reselect.createSelector)(getViewerSettings, function (viewerSettings) {
    return viewerSettings.showAccountSettings;
});

var getActiveTabNum = exports.getActiveTabNum = (0, _reselect.createSelector)(getCommonState, isAccountSettingsTabVisible, isPTOTabVisible, isSDBTabVisible, isWASTabVisible, function (commonState, showAccSettings, showPTO, showSDB, showWAS) {
    var tabNum = commonState.activeTab;
    if (!showPTO && tabNum === _constants.UserManagementConstants.PTO_SETTINGS_TAB_NUM) {
        tabNum = _constants.UserManagementConstants.ACCOUNT_SETTINGS_TAB_NUM;
    }
    if (!showSDB && tabNum === _constants.UserManagementConstants.SICK_DAYS_SETTINGS_TAB_NUM) {
        tabNum = _constants.UserManagementConstants.ACCOUNT_SETTINGS_TAB_NUM;
    }
    if (!showWAS && tabNum === _constants.UserManagementConstants.WORK_ASSIGNMENTS_TAB_NUM) {
        tabNum = _constants.UserManagementConstants.ACCOUNT_SETTINGS_TAB_NUM;
    }
    if (!showAccSettings && tabNum === _constants.UserManagementConstants.ACCOUNT_SETTINGS_TAB_NUM) {
        if (showPTO) tabNum = _constants.UserManagementConstants.PTO_SETTINGS_TAB_NUM;else if (showSDB) tabNum = _constants.UserManagementConstants.SICK_DAYS_SETTINGS_TAB_NUM;else tabNum = _constants.UserManagementConstants.WORK_ASSIGNMENTS_TAB_NUM;
    }

    return tabNum;
});

var getUsersWithoutApprovers = exports.getUsersWithoutApprovers = (0, _reselect.createSelector)(getCommonState, function (commonState) {
    return commonState.usersWithoutApprovers;
});

var getLicenseCounters = exports.getLicenseCounters = (0, _reselect.createSelector)(getCommonState, function (commonState) {
    return commonState.licenseCounters;
});

var isAllowedToManageAccountSettings = exports.isAllowedToManageAccountSettings = (0, _reselect.createSelector)(getViewerSettings, function (viewerSettings) {
    return viewerSettings.allowedToManageAccountSettings;
});

var isPossibleToCreateUsers = exports.isPossibleToCreateUsers = (0, _reselect.createSelector)(isAllowedToManageAccountSettings, getLicenseCounters, function (allowedToManageAccountSettings, licenseCounters) {
    return allowedToManageAccountSettings && !(0, _utils.isLicenseViolated)(licenseCounters) && (0, _utils.haveMoreLicenses)(licenseCounters);
});

var licenseViolated = exports.licenseViolated = (0, _reselect.createSelector)(getLicenseCounters, function (licenseCounters) {
    return (0, _utils.isLicenseViolated)(licenseCounters);
});

var getNewUsersIdSet = exports.getNewUsersIdSet = (0, _reselect.createSelector)(getCommonState, function (commonState) {
    return commonState.newUsersIdSet;
});

var getViewerManagementCounters = exports.getViewerManagementCounters = function getViewerManagementCounters(state) {
    return getCommonState(state).viewerManagementAssignmentsCounters;
};

var getAssignedUserIds = exports.getAssignedUserIds = (0, _reselect.createSelector)(getViewerSettings, function (viewer) {
    return viewer.assignedUserIds;
});

var getEditingUserId = exports.getEditingUserId = (0, _reselect.createSelector)(_selectors2.getEditUserId, _selectors3.getUserId, _selectors4.getUserId, _selectors5.getUserId, function (editPanelUserId, workAssignmentsPanelUserId, managementAssignmentsPanelUserId, teamAssignmentsUserId) {
    return editPanelUserId || workAssignmentsPanelUserId || managementAssignmentsPanelUserId || teamAssignmentsUserId;
});

var isGenerateMoneyReportsEnabled = exports.isGenerateMoneyReportsEnabled = (0, _reselect.createSelector)(_selectors.isURAEnabled, _selectors.isBTYEnabled, function (URAEnabled, BTYEnabled) {
    return URAEnabled || BTYEnabled;
});

var getUsersList = exports.getUsersList = (0, _reselect.createSelector)(getCommonState, function (commonState) {
    return commonState.usersList;
});

var getSortedUsersList = exports.getSortedUsersList = (0, _utils2.createDeepEqualSelector)(getUsersList, function (usersListMap) {
    return Object.values(usersListMap).sort(_user_group_selector_util.userComparator);
});

var getActiveAssignedUserIds = exports.getActiveAssignedUserIds = (0, _reselect.createSelector)(getUsersList, getAssignedUserIds, function (usersList, assignedUserIds) {
    return assignedUserIds !== null ? assignedUserIds.filter(function (id) {
        return usersList[id].activeInAT || usersList[id].enabled;
    }) : null;
});

var getUsersListForWorkAssignmentsTab = exports.getUsersListForWorkAssignmentsTab = (0, _reselect.createSelector)(getSortedUsersList, getAssignedUserIds, _selectors6.getLoggedInUser, function (usersList, assignedUserIds, loggedInUser) {
    if (assignedUserIds == null) {
        return usersList.filter(function (user) {
            return (user.activeInAT || user.enabled) && user.id !== loggedInUser.id;
        });
    } else {
        var assignedIdsSet = (0, _atUtils.arrayToSet)(assignedUserIds);
        return usersList.filter(function (user) {
            return !!assignedIdsSet[user.id] && (user.activeInAT || user.enabled) && user.id !== loggedInUser.id;
        });
    }
});

var getUserManagementData = exports.getUserManagementData = (0, _reselect.createSelector)(getCommonState, function (commonState) {
    return commonState.userManagementData;
});

var getPermissionsTemplates = exports.getPermissionsTemplates = (0, _reselect.createSelector)(getUserManagementData, function (userManagementData) {
    return userManagementData.permissionsTemplates;
});

var getDefaultWorkSchedule = exports.getDefaultWorkSchedule = function getDefaultWorkSchedule(state) {
    return getUserManagementData(state).defaultWorkSchedule;
};

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(111);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.loadNextWorkflowStatuses = exports.handleFeatureChange = exports.collapsePanel = exports.expandPanel = exports.reloadTasks = exports.handleCommonTaskUpdateErrors = exports.setBulkOperationsPanelShownState = exports.savePageSettings = exports.setHasManageableTasks = exports.setViewerSettings = exports.updateProject = exports.archiveProjectAndReloadTasks = exports.archiveProjectsOfCustomerAndReloadTasks = exports.removeCustomer = exports.removeProject = exports.removeTasks = exports.addTasks = exports.setManagementAssignments = exports.setRecentlyCreatedProjects = exports.setRecentlyCreatedCustomers = exports.addNewTasks = exports.changeTaskNameFilterAction = exports.setSelectedFilterKeys = exports.setTaskListFilters = exports.applyTaskStatusFilterAction = exports.changeCustomerProjectNameFilter = exports.changeCPSelection = exports.changeFilterCPSelectionAction = exports.changeSingleCPSelectionAction = exports.removeLastCreatedTaskIdsAction = exports.switchViewMode = exports.setShowOnlyManageableTasks = exports.removeLastCreatedTaskIds = exports.setLastCreatedTaskIds = exports.addRecentlyCreatedTasks = exports.toggleLoadingMoire = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reduxActions = __webpack_require__(9);

var _selectors = __webpack_require__(27);

var _actions = __webpack_require__(364);

var _actions2 = __webpack_require__(195);

var _actions3 = __webpack_require__(29);

var EntitiesActions = _interopRequireWildcard(_actions3);

var _selectors2 = __webpack_require__(14);

var _actionTypes = __webpack_require__(449);

var ActionTypes = _interopRequireWildcard(_actionTypes);

var _selectors3 = __webpack_require__(243);

var _rpcCalls = __webpack_require__(24);

var _rpcCalls2 = _interopRequireDefault(_rpcCalls);

var _syncCallbacks = __webpack_require__(161);

var SyncCallbacks = _interopRequireWildcard(_syncCallbacks);

var _utils = __webpack_require__(6);

var _utils2 = __webpack_require__(242);

var _selectors4 = __webpack_require__(82);

var _atUtils = __webpack_require__(5);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _CustomerProjectSelection = __webpack_require__(156);

var _CustomerProjectSelection2 = _interopRequireDefault(_CustomerProjectSelection);

var _utils3 = __webpack_require__(118);

var _batch = __webpack_require__(117);

var _ExceptionsTypes = __webpack_require__(107);

var _constants = __webpack_require__(44);

var _ClassicBridge = __webpack_require__(18);

var _ClassicBridge2 = _interopRequireDefault(_ClassicBridge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var setViewMode = (0, _reduxActions.createAction)(ActionTypes.VIEW_MODE_SET);

var toggleLoadingMoire = exports.toggleLoadingMoire = (0, _reduxActions.createAction)(ActionTypes.TOGGLE_LOADING_MOIRE);

var addRecentlyCreatedTasks = exports.addRecentlyCreatedTasks = function addRecentlyCreatedTasks(taskIds) {
    return (0, _batch.batched)(function (dispatch) {
        dispatch((0, _utils.createActionObject)(ActionTypes.RECENTLY_CREATED_TASKS_ADD, taskIds));
        dispatch((0, _actions.addRecentlyCreatedTasks)(taskIds));
        dispatch((0, _actions2.addRecentlyCreatedTasks)(taskIds));
    });
};

var setLastCreatedTaskIds = exports.setLastCreatedTaskIds = (0, _reduxActions.createAction)(ActionTypes.LAST_CREATED_TASK_IDS_SET);
var removeLastCreatedTaskIds = exports.removeLastCreatedTaskIds = (0, _reduxActions.createAction)(ActionTypes.LAST_CREATED_TASK_IDS_REMOVE);

var setShowOnlyManageableTasks = exports.setShowOnlyManageableTasks = function setShowOnlyManageableTasks(onlyManageable) {
    return function (dispatch) {
        dispatch((0, _utils.createActionObject)(ActionTypes.SHOW_ONLY_MANAGEABLE_TASKS_SET, onlyManageable));
        dispatch(reloadTasks());
        dispatch(savePageSettings());
    };
};

var switchViewMode = exports.switchViewMode = function switchViewMode(viewMode) {
    return function (dispatch) {
        dispatch(setViewMode(viewMode));
        dispatch(savePageSettings());
    };
};

var removeLastCreatedTaskIdsAction = exports.removeLastCreatedTaskIdsAction = function removeLastCreatedTaskIdsAction(id) {
    return function (dispatch) {
        return dispatch(removeLastCreatedTaskIds(id));
    };
};

var changeSingleCPSelectionAction = exports.changeSingleCPSelectionAction = function changeSingleCPSelectionAction(selection) {
    var skipReload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return function (dispatch) {
        dispatch(changeSingleCPSelection(selection));
        dispatch((0, _utils.createActionObject)(ActionTypes.SHOW_ONLY_MANAGEABLE_TASKS_SET, false));
        if (!skipReload) {
            dispatch(reloadTasks());
        }
    };
};

var changeFilterCPSelectionAction = exports.changeFilterCPSelectionAction = function changeFilterCPSelectionAction(selection) {
    var skipReload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return function (dispatch, getState) {
        var state = getState();
        var filterCPSelection = _CustomerProjectSelection2.default.fromPlainObject(selection);
        var prevFilterCPSelection = _CustomerProjectSelection2.default.fromPlainObject((0, _selectors.getFilterCPSelection)(state));

        if (!filterCPSelection.isEmpty() && !filterCPSelection.equals(prevFilterCPSelection)) {
            dispatch((0, _utils.createActionObject)(ActionTypes.RECENTLY_CREATED_CUSTOMERS_PROJECTS_CLEAR));

            var intersectedCpSelection = (0, _utils2.createIntersectedCPSelection)(selection, (0, _selectors.getSingleCPSelection)(state), (0, _selectors2.getCustomers)(state), (0, _selectors2.getProjects)(state));

            if (intersectedCpSelection.isEmpty()) {
                dispatch(changeSingleCPSelection({ customerId: null, projectId: null }));
            }

            dispatch((0, _utils.createActionObject)(ActionTypes.FILTER_CP_SELECTION_CHANGE, filterCPSelection.toPlainObject()));
            dispatch((0, _utils.createActionObject)(ActionTypes.SHOW_ONLY_MANAGEABLE_TASKS_SET, false));
            if (!skipReload) {
                dispatch(reloadTasks());
            }
            dispatch(savePageSettings());
        }
    };
};

//TODO remove this action after correct tasks reloading on intersected CP selection change. See https://github.com/Actimind-Development/actitime/issues/1428
var changeCPSelection = exports.changeCPSelection = function changeCPSelection(singleCPSelection, filteredCPSelection) {
    return function (dispatch) {
        // skip task loading fix https://github.com/Actimind-Development/actitime/pull/1427 (without batch)
        // batch is not possible to use cause `savePageSettings` called with old state
        dispatch(changeFilterCPSelectionAction(filteredCPSelection, true));
        dispatch(changeSingleCPSelectionAction(singleCPSelection, true));
        dispatch(reloadTasks());
    };
};

var changeCustomerProjectNameFilter = exports.changeCustomerProjectNameFilter = function changeCustomerProjectNameFilter(text) {
    return function (dispatch) {
        dispatch((0, _utils.createActionObject)(ActionTypes.RECENTLY_CREATED_CUSTOMERS_PROJECTS_CLEAR));
        dispatch((0, _utils.createActionObject)(ActionTypes.CP_NAME_FILTER_SET, text));
    };
};

var applyTaskStatusFilterAction = exports.applyTaskStatusFilterAction = function applyTaskStatusFilterAction(filter) {
    return function (dispatch) {
        dispatch((0, _reduxActions.createAction)(ActionTypes.TASK_STATUS_FILTER_CHANGE)(filter));
        dispatch(reloadTasks());
        dispatch(savePageSettings());
        SyncCallbacks.afterChangeStatusFilterSelection(filter);
    };
};

var setTaskListFilters = exports.setTaskListFilters = function setTaskListFilters(filters) {
    return function (dispatch) {
        dispatch((0, _reduxActions.createAction)(ActionTypes.TASK_STATUS_FILTER_CHANGE)(filters.status));
        dispatch((0, _reduxActions.createAction)(ActionTypes.CUSTOM_FIELDS_FILTERS_SET)(filters.customFields));
        dispatch(reloadTasks());
        dispatch(savePageSettings());
    };
};

var setSelectedFilterKeys = exports.setSelectedFilterKeys = function setSelectedFilterKeys(selectedFilterKeys) {
    return function (dispatch) {
        dispatch((0, _utils.createActionObject)(ActionTypes.SELECTED_FILTER_KEYS_SET, selectedFilterKeys));
        dispatch(reloadTasks());
        dispatch(savePageSettings());
    };
};

var changeTaskNameFilterAction = exports.changeTaskNameFilterAction = function changeTaskNameFilterAction(filter) {
    return function (dispatch) {
        dispatch((0, _reduxActions.createAction)(ActionTypes.TASK_NAME_FILTER_CHANGE)(filter));
        dispatch(reloadTasks());
    };
};

var addNewTasks = exports.addNewTasks = function addNewTasks(_ref) {
    var tasks = _ref.tasks,
        projects = _ref.projects,
        customers = _ref.customers;
    return function (dispatch) {
        dispatch(EntitiesActions.addTasks(tasks));
        dispatch(EntitiesActions.addProjects(projects));
        dispatch(EntitiesActions.addCustomers(customers));

        var taskIds = tasks.map(function (task) {
            return task.id;
        });
        dispatch(setLastCreatedTaskIds(taskIds));
        dispatch(addRecentlyCreatedTasks(taskIds));
    };
};

var setRecentlyCreatedCustomers = exports.setRecentlyCreatedCustomers = function setRecentlyCreatedCustomers(customerIds) {
    return function (dispatch) {
        dispatch((0, _utils.createActionObject)(ActionTypes.RECENTLY_CREATED_CUSTOMER_IDS_SET, customerIds));
    };
};

var setRecentlyCreatedProjects = exports.setRecentlyCreatedProjects = function setRecentlyCreatedProjects(projectIds) {
    return function (dispatch) {
        dispatch((0, _utils.createActionObject)(ActionTypes.RECENTLY_CREATED_PROJECT_IDS_SET, projectIds));
    };
};

var setManagementAssignments = exports.setManagementAssignments = function setManagementAssignments(managementAssignments) {
    return function (dispatch, getState) {
        dispatch((0, _utils.createActionObject)(ActionTypes.MANAGEMENT_ASSIGNMENTS_SET, {
            customers: (0, _atUtils.arrayToMap)(managementAssignments['customers']),
            projects: (0, _atUtils.arrayToMap)(managementAssignments['projects']),
            tasks: (0, _atUtils.arrayToMap)(managementAssignments['tasks'])
        }));

        //TODO temporary for TaskPanelController, remove after connect to redux
        SyncCallbacks.setEditableProjectIds((0, _selectors.getEditableProjectIds)(getState()));
        SyncCallbacks.setEditableCustomerIds((0, _selectors.getEditableCustomerIds)(getState()));
    };
};

var addTasks = exports.addTasks = function addTasks(tasks) {
    return function (dispatch) {
        dispatch(EntitiesActions.addTasks(tasks));
        SyncCallbacks.addTasks(tasks);
    };
};

var removeTasks = exports.removeTasks = function removeTasks(taskIds) {
    return function (dispatch) {
        dispatch(EntitiesActions.removeTasks(taskIds));
        SyncCallbacks.removeTasks(taskIds);
    };
};

var removeProject = exports.removeProject = function removeProject(projectId) {
    return function (dispatch, getState) {
        var state = getState();
        var filterCPSelection = (0, _utils2.removeProjectFromCPSelection)(projectId, (0, _selectors.getFilterCPSelection)(state));
        var singleCPSelection = (0, _selectors.getSingleCPSelection)(state);
        dispatch(changeFilterCPSelectionAction(filterCPSelection));
        if (singleCPSelection.projectId === projectId) {
            dispatch(changeSingleCPSelectionAction({ customerId: null, projectId: null }));
        }

        var recentlyCreatedProjectIds = state.taskManagement.common.recentlyCreatedProjectIds;
        dispatch(setRecentlyCreatedProjects(recentlyCreatedProjectIds.filter(function (id) {
            return id !== projectId;
        })));

        dispatch(EntitiesActions.removeProject(projectId));
    };
};

var removeCustomer = exports.removeCustomer = function removeCustomer(customerId) {
    return function (dispatch, getState) {
        var state = getState();
        var projects = (0, _selectors2.getProjects)(state);
        var singleCPSelection = (0, _selectors.getSingleCPSelection)(state);
        var filterCPSelection = (0, _utils2.removeCustomerFromCPSelection)((0, _selectors.getFilterCPSelection)(state), customerId, projects);
        dispatch(changeFilterCPSelectionAction(filterCPSelection));
        if (singleCPSelection.customerId === customerId) {
            dispatch(changeSingleCPSelectionAction({ customerId: null, projectId: null }));
        }
        var projectsOfCustomerIds = Object.values(projects).filter(function (project) {
            return project.customerId === customerId;
        }).map(function (p) {
            return p.id;
        });

        dispatch(EntitiesActions.removeProjects(projectsOfCustomerIds));

        var recentlyCreatedCustomerIds = state.taskManagement.common.recentlyCreatedCustomerIds;
        dispatch(setRecentlyCreatedCustomers(recentlyCreatedCustomerIds.filter(function (id) {
            return id !== customerId;
        })));

        var recentlyCreatedProjectIds = state.taskManagement.common.recentlyCreatedProjectIds;
        var projectsOfCustomerIdsSet = (0, _atUtils.arrayToSet)(projectsOfCustomerIds);
        dispatch(setRecentlyCreatedProjects(recentlyCreatedProjectIds.filter(function (id) {
            return !projectsOfCustomerIdsSet[id];
        })));

        dispatch(EntitiesActions.removeCustomer(customerId));
    };
};

var archiveProjectsOfCustomerAndReloadTasks = exports.archiveProjectsOfCustomerAndReloadTasks = function archiveProjectsOfCustomerAndReloadTasks(customerId) {
    return function (dispatch, getState) {
        var state = getState();
        var projects = Object.values((0, _selectors2.getProjects)(state)).filter(function (p) {
            return p.customerId === customerId && !p.archived;
        });
        projects.forEach(function (p) {
            return dispatch(archiveProject(p.id));
        });
        dispatch(reloadTasks());
    };
};

var archiveProjectAndReloadTasks = exports.archiveProjectAndReloadTasks = function archiveProjectAndReloadTasks(projectId) {
    return function (dispatch) {
        dispatch(archiveProject(projectId));
        dispatch(reloadTasks());
    };
};

var updateProject = exports.updateProject = function updateProject(project) {
    return function (dispatch, getState) {
        if (!project.archived && (0, _selectors2.getProject)(getState(), project.id).archived) {
            dispatch(unarchiveCustomer(project.customerId));
        }
        SyncCallbacks.afterProjectCustomerStatusChangeCb();
        dispatch((0, _actions3.addProject)(project));
    };
};

var unarchiveCustomer = function unarchiveCustomer(customerId) {
    return function (dispatch, getState) {
        var customer = (0, _selectors2.getCustomer)(getState(), customerId);
        dispatch(EntitiesActions.addCustomers([_extends({}, customer, { archived: false })]));
    };
};

var archiveProject = function archiveProject(projectId) {
    return function (dispatch, getState) {
        var state = getState();
        var project = (0, _selectors2.getProject)(state, projectId);
        dispatch(EntitiesActions.addProjects([_extends({}, project, { archived: true })]));
    };
};

var setViewerSettings = exports.setViewerSettings = function setViewerSettings(viewerSettings) {
    return function (dispatch) {
        dispatch((0, _utils.createActionObject)(ActionTypes.VIEWER_SETTINGS_SET, viewerSettings));
    };
};

var setHasManageableTasks = exports.setHasManageableTasks = function setHasManageableTasks(hasManageableTasks) {
    return function (dispatch) {
        dispatch((0, _utils.createActionObject)(ActionTypes.HAS_MANAGEABLE_TASKS_SET, hasManageableTasks));
    };
};

var savePageSettings = exports.savePageSettings = function savePageSettings() {
    return function (dispatch, getState) {
        var state = getState();

        var _getTasksSorting = (0, _selectors4.getTasksSorting)(state),
            by = _getTasksSorting.by,
            asc = _getTasksSorting.asc;

        var shownColumns = (0, _selectors4.getShownColumns)(state);
        var isSummaryRowShown = (0, _selectors4.getIsSummaryRowShown)(state);
        (0, _rpcCalls2.default)("TaskManagementService.savePageSettings", [(0, _selectors.getFilterCPSelection)(state), by, asc, (0, _selectors.getTaskStatusFilter)(state), (0, _selectors3.isMinimizedCards)(state), (0, _selectors.getViewMode)(state), (0, _selectors4.getColumnsOrder)(state), shownColumns, (0, _selectors.getSelectedFilterKeys)(state), JSON.stringify((0, _selectors.getCustomFieldsFilters)(state)), isSummaryRowShown], function () {
            return true;
        }).catch(function (e) {
            return console.error(e);
        });
    };
};

var setBulkOperationsPanelShownState = exports.setBulkOperationsPanelShownState = function setBulkOperationsPanelShownState(shown) {
    return function (dispatch) {
        dispatch((0, _utils.createActionObject)(ActionTypes.BULK_OPERATIONS_PANEL_SHOWN_SET, shown));
    };
};

var handleCommonTaskUpdateErrors = exports.handleCommonTaskUpdateErrors = function handleCommonTaskUpdateErrors(task, exception, dispatch) {
    switch (exception) {
        case _ExceptionsTypes.NO_SUCH_TASK_EXCEPTION:
            dispatch(removeTasks([task.id]));
            alert(_messageResource2.default.getMessage("task.error.concurrently_deleted.cannot_edit"));
            return true;
        case _ExceptionsTypes.TASK_UNAVAILABLE_EXCEPTION:
            if (task) {
                dispatch(removeTasks([task.id]));
            }
            alert(_messageResource2.default.getMessage("task.list.error.update_task.task_unavailable"));
            return true;
        case _ExceptionsTypes.TASK_CANNOT_BE_MODIFIED_EXCEPTION:
            alert(_messageResource2.default.getMessage("common.no_rights_for_operation_anymore"));
            window.location.reload();
            return true;
        case _ExceptionsTypes.PROJECT_IS_NOT_AVAILABLE_EXCEPTION:
            alert(_messageResource2.default.getMessage("common.no_rights_for_operation_anymore"));
            dispatch(removeProject(task.projectId));
            dispatch(reloadTasks());
            return true;
        case _ExceptionsTypes.PROJECT_CANNOT_BE_MODIFIED_EXCEPTION:
            alert(_messageResource2.default.getMessage("common.no_rights_for_operation_anymore"));
            dispatch(reloadTasks());
            return true;
        case _ExceptionsTypes.CUSTOMER_UNAVAILABLE_EXCEPTION:
            alert(_messageResource2.default.getMessage("common.no_rights_for_operation_anymore"));
            dispatch(removeCustomer(task.customerId));
            dispatch(reloadTasks());
            return true;
        case _ExceptionsTypes.CUSTOMER_CANNOT_BE_MODIFIED_EXCEPTION:
            alert(_messageResource2.default.getMessage("common.no_rights_for_operation_anymore"));
            dispatch(reloadTasks());
            return true;
    }
    return false;
};

var reloadTasks = exports.reloadTasks = function reloadTasks() {
    return function (dispatch, getState) {
        if (_constants.TaskManagementViewMode.TABLE === (0, _selectors.getViewMode)(getState())) {
            dispatch((0, _actions2.setLoaded)(true));
            dispatch((0, _actions2.setLoaded)(false));
            dispatch((0, _actions.setLoaded)(false));
        } else {
            dispatch((0, _actions.setLoaded)(true));
            dispatch((0, _actions.setLoaded)(false));
            dispatch((0, _actions2.setLoaded)(false));
        }
    };
};

var expandPanel = exports.expandPanel = function expandPanel() {
    return function (dispatch) {
        (0, _utils2.setCpPanelClosedStateInLocalStorage)(false);
        dispatch((0, _utils.createActionObject)(ActionTypes.CP_PANEL_CLOSED_STATE_CHANGE, false));
    };
};

var collapsePanel = exports.collapsePanel = function collapsePanel() {
    return function (dispatch) {
        (0, _utils2.setCpPanelClosedStateInLocalStorage)(true);
        dispatch((0, _utils.createActionObject)(ActionTypes.CP_PANEL_CLOSED_STATE_CHANGE, true));
    };
};

var handleFeatureChange = exports.handleFeatureChange = function handleFeatureChange(changedFeatures) {
    return function () {
        var message = (0, _utils3.getFeaturesChangesMessage)(changedFeatures).concat(_messageResource2.default.getMessage('common.interface_will_updated'));
        alert(message);
    };
};

var changeSingleCPSelection = function changeSingleCPSelection(selection) {
    return function (dispatch) {
        (0, _utils2.saveSingleCPSelectionToLocalStorage)(selection);
        dispatch((0, _utils.createActionObject)(ActionTypes.SINGLE_CP_SELECTION_CHANGE, selection));
    };
};

var loadNextWorkflowStatuses = exports.loadNextWorkflowStatuses = function loadNextWorkflowStatuses() {
    return function (dispatch) {
        _ClassicBridge2.default.getWorkflowStatusesList().then(function (items) {
            dispatch((0, _utils.createActionObject)(ActionTypes.NEXT_WORKFLOW_STATUSES_SET, items));
        });
    };
};

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.closeToast = exports.warning = exports.toast = exports.toastHtml = undefined;

var _reduxActions = __webpack_require__(9);

var _actionTypes = __webpack_require__(707);

var ActionTypes = _interopRequireWildcard(_actionTypes);

var _selectors = __webpack_require__(764);

var _atUtils = __webpack_require__(5);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var MESSAGES_LIMIT = 3;
var MESSAGE_TIMEOUT = 5000;
var WARNING_TIMEOUT = 30000;

var setMessages = (0, _reduxActions.createAction)(ActionTypes.MESSAGES_SET);

var idSequence = 0;

var toastHtml = exports.toastHtml = function toastHtml(html) {
    var isWarning = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return function (dispatch, getState) {
        var id = idSequence++;
        var oldMessages = (0, _selectors.getMessages)(getState());
        var newMessages = void 0;

        if (oldMessages.length < MESSAGES_LIMIT) {
            newMessages = [].concat(_toConsumableArray(oldMessages), [{ id: id, html: html, isWarning: isWarning }]);
        } else {
            newMessages = [].concat(_toConsumableArray(oldMessages.slice(1)), [{ id: id, html: html, isWarning: isWarning }]);
        }

        dispatch(setMessages(newMessages));

        setTimeout(function () {
            return dispatch(closeToast(id));
        }, isWarning ? WARNING_TIMEOUT : MESSAGE_TIMEOUT);
    };
};

var toast = exports.toast = function toast(text) {
    return function (dispatch) {
        var html = (0, _atUtils.escapeHtmlSymbols)(text);
        dispatch(toastHtml(html));
    };
};

var warning = exports.warning = function warning(text) {
    return function (dispatch) {
        var html = (0, _atUtils.escapeHtmlSymbols)(text);
        dispatch(toastHtml(html, true));
    };
};

var closeToast = exports.closeToast = function closeToast(id) {
    return function (dispatch, getState) {
        var oldMessages = (0, _selectors.getMessages)(getState());
        var newMessages = oldMessages.filter(function (message) {
            return message.id !== id;
        });
        dispatch(setMessages(newMessages));
    };
};

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.selectFirstStatusByType = exports.getFirstCompletedWorkflowStatus = exports.getDefaultOpenWorkflowStatus = exports.getSortedOpenWorkflowStatusList = exports.getSortedWorkflowStatusList = exports.getWorkflowStatusesList = exports.selectStatusById = undefined;
exports.selectStatusByTask = selectStatusByTask;
exports.selectStatusIdByTask = selectStatusIdByTask;
exports.selectFakeStatusIdByTaskComplete = selectFakeStatusIdByTaskComplete;

var _reselect = __webpack_require__(13);

var _constants = __webpack_require__(23);

var _index = __webpack_require__(22);

var _utils = __webpack_require__(80);

var _selectors = __webpack_require__(14);

var selectStatusById = exports.selectStatusById = function selectStatusById(state, id) {
    return (0, _selectors.getWorkflowStatuses)(state)[id];
};

function selectStatusByTask(state, task) {

    return selectStatusById(state, selectStatusIdByTask(task));
}

function selectStatusIdByTask(task) {
    var id = void 0;
    if ((0, _index.isEnabled)(_index.Feature.TWS)) {
        id = task.workflowStatusId;
    } else {
        id = selectFakeStatusIdByTaskComplete(task.completed);
    }
    return id;
}

function selectFakeStatusIdByTaskComplete(completed) {
    return completed ? _constants.FAKE_COMPLETED_WORKFLOW_STATUS_ID : _constants.FAKE_OPEN_WORKFLOW_STATUS_ID;
}

var getWorkflowStatusesList = exports.getWorkflowStatusesList = (0, _reselect.createSelector)(_selectors.getWorkflowStatuses, function (workflowStatusesMap) {
    return Object.values(workflowStatusesMap);
});

var getSortedWorkflowStatusList = exports.getSortedWorkflowStatusList = (0, _reselect.createSelector)(getWorkflowStatusesList, function (workflowStatusesList) {
    return workflowStatusesList.sort(_utils.workflowStatusComparatorWithStatusType);
});

var getSortedOpenWorkflowStatusList = exports.getSortedOpenWorkflowStatusList = (0, _reselect.createSelector)(getWorkflowStatusesList, function (workflowStatusesList) {
    return workflowStatusesList.filter(function (status) {
        return status.type === _constants.WorkflowStatusType.OPEN;
    }).sort(_utils.workflowStatusComparatorWithStatusType);
});

var getDefaultOpenWorkflowStatus = exports.getDefaultOpenWorkflowStatus = (0, _reselect.createSelector)(getSortedOpenWorkflowStatusList, function (wsList) {
    return wsList[0];
});

var getFirstCompletedWorkflowStatus = exports.getFirstCompletedWorkflowStatus = function getFirstCompletedWorkflowStatus(state) {
    return selectFirstStatusByType(state, _constants.WorkflowStatusType.COMPLETED);
};

var selectFirstStatusByType = exports.selectFirstStatusByType = function selectFirstStatusByType(state, type) {
    return getSortedWorkflowStatusList(state).find(function (status) {
        return status.type === type;
    });
};

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(151);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _EntityWithIdStore = __webpack_require__(342);

var _EntityWithIdStore2 = _interopRequireDefault(_EntityWithIdStore);

var _EntityWithNameStore2 = __webpack_require__(278);

var _EntityWithNameStore3 = _interopRequireDefault(_EntityWithNameStore2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ProjectStoreClass = function (_EntityWithNameStore) {
    _inherits(ProjectStoreClass, _EntityWithNameStore);

    function ProjectStoreClass() {
        _classCallCheck(this, ProjectStoreClass);

        var _this = _possibleConstructorReturn(this, (ProjectStoreClass.__proto__ || Object.getPrototypeOf(ProjectStoreClass)).call(this));

        _this._customerProjects = {};
        return _this;
    }

    _createClass(ProjectStoreClass, [{
        key: "getByCustomer",
        value: function getByCustomer(customerId) {
            var projectsByCustomer = this._customerProjects[customerId];
            return projectsByCustomer ? projectsByCustomer.getAll() : [];
        }
    }, {
        key: "_onAdd",
        value: function _onAdd(newProject, oldProject, first) {
            _get(ProjectStoreClass.prototype.__proto__ || Object.getPrototypeOf(ProjectStoreClass.prototype), "_onAdd", this).call(this, newProject, oldProject, first);

            if (oldProject && oldProject.customerId !== newProject.customerId) this._customerProjects[oldProject.customerId].remove(oldProject.id);

            var projectsByCustomer = this._customerProjects[newProject.customerId];
            if (!projectsByCustomer) {
                projectsByCustomer = new _EntityWithIdStore2.default();
                this._customerProjects[newProject.customerId] = projectsByCustomer;
            }

            if (first) projectsByCustomer.addFirst(newProject);else projectsByCustomer.add(newProject);
        }
    }, {
        key: "_onRemove",
        value: function _onRemove(project) {
            _get(ProjectStoreClass.prototype.__proto__ || Object.getPrototypeOf(ProjectStoreClass.prototype), "_onRemove", this).call(this, project);
            this._customerProjects[project.customerId].remove(project.id);
        }
    }]);

    return ProjectStoreClass;
}(_EntityWithNameStore3.default);

var ProjectStore = new ProjectStoreClass();
exports.default = ProjectStore;

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _hierarchy_selector_util = __webpack_require__(95);

var _hierarchy_selector_util2 = _interopRequireDefault(_hierarchy_selector_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TreeNode = function () {
    function TreeNode(value, id) {
        _classCallCheck(this, TreeNode);

        this.value = value;
        this.id = !_underscore2.default.isUndefined(id) ? id : this.createId();
        this.level = 0;
        this.parent = null;
        this.children = [];
    }

    _createClass(TreeNode, [{
        key: "getParent",
        value: function getParent() {
            return this.parent;
        }
    }, {
        key: "setParent",
        value: function setParent(parent) {
            this.parent = parent;
        }
    }, {
        key: "_notifyChildAddedInDepth",
        value: function _notifyChildAddedInDepth(child, root) {
            root._childAdded(child);
            var children = child.getChildren();
            for (var i = 0; i < children.length; i++) {
                this._notifyChildAddedInDepth(children[i], root);
            }
        }
    }, {
        key: "appendChild",
        value: function appendChild(child) {
            this.children.push(child);
            child.setParent(this);
            child.setLevel(this.level + 1);
            var root = this.getRoot();
            if (root) this._notifyChildAddedInDepth(child, root);
        }
    }, {
        key: "getChildren",
        value: function getChildren() {
            return this.children;
        }
    }, {
        key: "getValue",
        value: function getValue() {
            return this.value;
        }
    }, {
        key: "getLevel",
        value: function getLevel() {
            return this.level;
        }
    }, {
        key: "setLevel",
        value: function setLevel(level) {
            return this.level = level;
        }
    }, {
        key: "hasChildren",
        value: function hasChildren() {
            return this.children.length > 0;
        }
    }, {
        key: "getId",
        value: function getId() {
            return this.id;
        }
    }, {
        key: "getRoot",
        value: function getRoot() {
            return this.parent ? this.parent.getRoot() : null;
        }
    }, {
        key: "createId",
        value: function createId() {
            return _hierarchy_selector_util2.default.makeTreeNodeId(this.getIdPrefix(), this.getIdIndex());
        }
    }, {
        key: "getIdPrefix",
        value: function getIdPrefix() {
            // Abstract
        }
    }, {
        key: "getIdIndex",
        value: function getIdIndex() {
            return this.value ? this.value.id : 0;
        }
    }, {
        key: "getType",
        value: function getType() {
            // Abstract
        }
    }, {
        key: "isCollapsible",
        value: function isCollapsible() {
            return true;
        }
    }]);

    return TreeNode;
}();

exports.default = TreeNode;


TreeNode.TYPE_DEFAULT = 0;
TreeNode.TYPE_CUSTOMER = 1;
TreeNode.TYPE_PROJECT = 2;
TreeNode.TYPE_GROUP = 3;
TreeNode.TYPE_USER = 4;
TreeNode.TYPE_DISABLED_USERS_PARENT = 5;
TreeNode.TYPE_ARCHIVED_PROJECTS_PARENT = 6;
TreeNode.TYPE_ARCHIVED_CUSTOMERS_PARENT = 7;

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _atUtils = __webpack_require__(5);

/**
 * @param {number | undefined} minFractionDigits
 *   Minimum digits in fractional part of the formatted result.
 *   Must be no larger than `precision`.
 *   If undefined, then equals to `precision`.
 *   Ignored if `trimTrailingZeros` is true.
 * 
 * Examples when precision == 4 and minFractionDigits == 2:
 *   1       => 1.00
 *   1.2     => 1.20
 *   1.23    => 1.23
 *   1.234   => 1.234
 *   1.2345  => 1.2345
 *   1.23456 => 1.2346
 */
function NumberFormatter(decimalSeparator, digitGroupingSymbol, precision, trimTrailingZeros, prefix, postfix, nullValue, minFractionDigits) {
    this.decimalSeparator = decimalSeparator;
    this.digitGroupingSymbol = digitGroupingSymbol;
    this.precision = precision;
    this.trimTrailingZeros = trimTrailingZeros;
    this.prefix = prefix !== undefined ? prefix : '';
    this.postfix = postfix !== undefined ? postfix : '';
    this.nullValue = nullValue || "";
    this.minFractionDigits = minFractionDigits !== undefined ? minFractionDigits : precision;
}

NumberFormatter.prototype.format = function (value) {
    if (value == null || (0, _atUtils.trim)(value) === "") return this.nullValue;

    var fixed = Number(value).toFixed(this.precision);
    var str;

    if (this.trimTrailingZeros) {
        str = Number(fixed).toString();
    } else if (this.minFractionDigits != this.precision) {
        var fixedWithMinimumDigits = Number(value).toFixed(this.minFractionDigits);
        if (Number(fixedWithMinimumDigits) == Number(fixed)) str = fixedWithMinimumDigits; // if no precision is lost then use the variant with minimum digits
        else str = Number(fixed).toString(); // else just trim zeros
    } else {
        str = fixed;
    }

    if (this.digitGroupingSymbol && this.digitGroupingSymbol != "") {
        var strParts = str.split('.');
        var str = strParts[0];
        var srtDec = strParts[1] ? this.decimalSeparator + strParts[1] : "";

        var sign = "";
        if (fixed < 0) {
            sign = str.charAt(0);
            str = str.substr(1);
        }

        strParts = str.split(/(?=(?:\d{3})+(?:\.|$))/g);
        str = strParts.join(this.digitGroupingSymbol);

        str = sign + str + srtDec;
    } else {
        if (this.decimalSeparator) str = str.replace(".", this.decimalSeparator);
    }

    return this.prefix + str + this.postfix;
};

NumberFormatter.prototype.normalize = function (text) {
    text = text.trim();

    // in case '-' is configured as decimal separator or digit grouping symbol,
    // we still need to treat the leading '-' as negative number sign

    var negative = false;

    if (text[0] === '-') {
        text = text.substr(1);
        negative = true;
    }

    if (this.digitGroupingSymbol !== '') text = text.split(this.digitGroupingSymbol).join('');

    text = text.replace(this.decimalSeparator, '.');
    text = text.replace(',', '.');

    if (negative) text = '-' + text;

    return text;
};

NumberFormatter.prototype.isNegativeValue = function (value) {
    if (value == null || (0, _atUtils.trim)(value) === "") return this.nullValue;
    var formatValue = Number(value).toFixed(this.precision);
    if (formatValue == 0 && 1 / formatValue === -Infinity) formatValue = +0;
    return formatValue < 0;
};

exports.default = NumberFormatter;

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var PANEL_TYPES = exports.PANEL_TYPES = {
    EDIT_USER: 'edit_user_sliding_panel',
    EDIT_TASK: 'edit_task_sliding_panel',
    CREATE_TASK: 'create_task_sliding_panel',
    EDIT_PROJECT: 'edit_project_sliding_panel',
    EDIT_CUSTOMER: 'edit_customer_sliding_panel',
    TEAM_ASSIGNMENT: 'team_assignment_sliding_panel',
    WORK_ASSIGNMENTS_PANEL: 'work_assignments_sliding_panel',
    WORK_ASSIGNMENTS_EDITOR: 'work_assignments_editor_sliding_panel',
    MANAGEMENT_ASSIGNMENTS_PANEL: 'management_assignments_panel_sliding_panel',
    MANAGEMENT_ASSIGNMENTS_EDITOR: 'management_assignments_editor_sliding_panel',
    HOLIDAY_LIST_PANEL: 'holiday_list_panel',
    IMPORT_HOLIDAYS_PANEL: 'import_holidays_sliding_panel',
    ALL: 'all_panels'
};

var SHOW_ANIMATION_CLASSES = exports.SHOW_ANIMATION_CLASSES = {
    SLIDE_LEFT: "anim-show-slide-left",
    SLIDE_UP: "anim-show-slide-up",
    SLIDE_RIGHT: "anim-show-slide-right"
};

var HIDE_ANIMATION_CLASSES = exports.HIDE_ANIMATION_CLASSES = {
    SLIDE_LEFT: "anim-hide-slide-left",
    SLIDE_UP: "anim-hide-slide-up",
    SLIDE_RIGHT: "anim-hide-slide-right"
};

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TableCellRenderer = function () {
    function TableCellRenderer() {
        _classCallCheck(this, TableCellRenderer);

        this.extraCls = [];
    }

    _createClass(TableCellRenderer, [{
        key: "addExtraClass",
        value: function addExtraClass(cls) {
            this.extraCls.push(cls);
        }
    }, {
        key: "removeExtraClass",
        value: function removeExtraClass(cls) {
            this.extraCls = _underscore2.default.filter(this.extraCls, function (eCls) {
                return eCls !== cls;
            });
        }
    }, {
        key: "writeContent",
        value: function writeContent(cell) {
            this.generateContent(cell);
            this.updateUI(cell);
        }
    }, {
        key: "generateContent",
        value: function generateContent(cell) {
            cell.getCellEl().innerHTML = cell.getValue();
        }
    }, {
        key: "updateContent",
        value: function updateContent(cell) {
            // should be implemented if necessary
            // for example when you need to update only one cell with new data without recreating the whole row
            // see AssignTTApproversCell, AssignTTApproversCellRenderer
        }
    }, {
        key: "updateUI",
        value: function updateUI(cell) {
            var classesArray = this.getCellClassName(cell);
            this.appendToCellClassesArray(cell, classesArray);
            classesArray = this.concatExtraClasses(cell, classesArray);

            this.setCssClass(cell, classesArray.join(" "));
        }
    }, {
        key: "appendToCellClassesArray",
        value: function appendToCellClassesArray(cell, classesArray) {
            this.appendPositionClassesIfNeeded(cell, classesArray);
            this.appendSelectionClassesIfNeeded(cell, classesArray);
            this.appendHoverClassesIfNeeded(cell, classesArray);
        }
    }, {
        key: "appendPositionClassesIfNeeded",
        value: function appendPositionClassesIfNeeded(cell, classesArray) {
            if (cell.isFirst()) classesArray.push("first");

            if (cell.isLast()) classesArray.push("last");
        }
    }, {
        key: "appendSelectionClassesIfNeeded",
        value: function appendSelectionClassesIfNeeded(cell, classesArray) {
            var selectionController = this.getSelectionController(cell);

            if (selectionController.getSelection().containsCell(cell)) classesArray.push("selected");

            if (selectionController.hasSelection()) {
                if (this.needsSelectionTopBorder(cell)) classesArray.push("selectionTopBorder");
                if (this.needsSelectionRightBorder(cell)) classesArray.push("selectionRightBorder");
                if (this.needsSelectionBottomBorder(cell)) classesArray.push("selectionBottomBorder");
                if (this.needsSelectionLeftBorder(cell)) classesArray.push("selectionLeftBorder");
            }
        }
    }, {
        key: "appendHoverClassesIfNeeded",
        value: function appendHoverClassesIfNeeded(cell, classesArray) {
            if (this.isHovered(cell)) classesArray.push("hover");
        }
    }, {
        key: "concatExtraClasses",
        value: function concatExtraClasses(cell, classesArray) {
            return classesArray.concat(this.extraCls);
        }

        //noinspection JSUnusedLocalSymbols

    }, {
        key: "getCellClassName",
        value: function getCellClassName(cell) {
            return [];
        }
    }, {
        key: "needsSelectionTopBorder",
        value: function needsSelectionTopBorder(cell) {
            var selection = this.getSelectionController(cell).getSelection();
            if (selection.containsCell(cell)) {
                return selection.isUpwardmostCell(cell);
            } else {
                var upperCell = cell.upperCell();
                if (upperCell) return selection.containsCell(upperCell) && selection.isDownwardmostCell(upperCell);
            }

            return false;
        }
    }, {
        key: "needsSelectionRightBorder",
        value: function needsSelectionRightBorder(cell) {
            if (cell.isLast()) {
                var selection = this.getSelectionController(cell).getSelection();
                return selection.containsCell(cell);
            }

            return false;
        }
    }, {
        key: "needsSelectionLeftBorder",
        value: function needsSelectionLeftBorder(cell) {
            var selection = this.getSelectionController(cell).getSelection();
            if (selection.containsCell(cell)) {
                return selection.isLeftmostCell(cell);
            } else {
                var leftCell = cell.leftCell();
                if (leftCell) return selection.containsCell(leftCell) && selection.isRightmostCell(leftCell);
            }

            return false;
        }
    }, {
        key: "needsSelectionBottomBorder",
        value: function needsSelectionBottomBorder(cell) {
            if (cell.getRow().isLast()) {
                var selection = this.getSelectionController(cell).getSelection();
                return selection.containsCell(cell);
            }

            return false;
        }
    }, {
        key: "setCssClass",
        value: function setCssClass(cell, cssClassName) {
            cell.getCellEl().className = cssClassName;
        }
    }, {
        key: "getSelectionController",
        value: function getSelectionController(cell) {
            return cell.getRow().getTable().getSelectionController();
        }
    }, {
        key: "getHoverController",
        value: function getHoverController(cell) {
            return cell.getRow().getTable().getHoverController();
        }
    }, {
        key: "isSelected",
        value: function isSelected(cell) {
            return this.getSelectionController(cell).isSelected(cell.getRow().getRowIdx(), cell.getColIdx());
        }
    }, {
        key: "isHovered",
        value: function isHovered(cell) {
            return this.getHoverController(cell).isHovered(cell);
        }
    }]);

    return TableCellRenderer;
}();

exports.default = TableCellRenderer;

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getUserFML = exports.getCurrentTimeInUserTimeZone = exports.getWorkSchedule = exports.getUserDataWithAdditionalData = exports.getUserRatesValidationData = exports.areManagementAssignmentsCountersLoaded = exports.getAllApprovers = exports.getUserRights = exports.getUserTeamAssignmentsData = exports.getManagementAssignmentsSelection = exports.getManagementAssignmentsCounters = exports.getUserPanelHasLeavesOrTTBeforeNewHireDateError = exports.getAllUsers = exports.getUserPanelPasswordValidationResult = exports.getUserPanelErrors = exports.getUserManagementAssignmentsData = exports.getExtendedData = exports.getTimeZoneGroupRowData = exports.getUserGroupRowData = exports.getFullUserInfo = exports.getPasswordCopy = exports.getPassword = exports.getUserDataState = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reselect = __webpack_require__(13);

var _constants = __webpack_require__(4);

var _selectors = __webpack_require__(15);

var _utils = __webpack_require__(118);

var _constants2 = __webpack_require__(78);

var _selectors2 = __webpack_require__(53);

var getUserDataState = exports.getUserDataState = function getUserDataState(state) {
    return state.panels.user.userData;
};

var getPassword = exports.getPassword = function getPassword(state) {
    return getFullUserInfo(state).password;
};

var getPasswordCopy = exports.getPasswordCopy = function getPasswordCopy(state) {
    return getFullUserInfo(state).retypedPassword;
};

var getFullUserInfo = exports.getFullUserInfo = function getFullUserInfo(state) {
    return getUserDataState(state).fullUserInfo;
};

var getUserGroupRowData = exports.getUserGroupRowData = function getUserGroupRowData(state) {
    return getUserDataState(state).userGroupRowData;
};
var getTimeZoneGroupRowData = exports.getTimeZoneGroupRowData = function getTimeZoneGroupRowData(state) {
    return getUserDataState(state).timeZoneGroupRowData;
};

var getExtendedData = exports.getExtendedData = function getExtendedData(state) {
    return getUserDataState(state).extendedData;
};

var getUserManagementAssignmentsData = exports.getUserManagementAssignmentsData = function getUserManagementAssignmentsData(state) {
    return getUserDataState(state).userManageAssignmentsData;
};

var getUserPanelErrors = exports.getUserPanelErrors = function getUserPanelErrors(state) {
    return getUserDataState(state).providerErrors;
};

var getUserPanelPasswordValidationResult = exports.getUserPanelPasswordValidationResult = function getUserPanelPasswordValidationResult(state) {
    return getUserDataState(state).passwordValidationResult;
};

var getAllUsers = exports.getAllUsers = function getAllUsers(state) {
    return getUserDataState(state).allUsers;
};

var getUserPanelHasLeavesOrTTBeforeNewHireDateError = exports.getUserPanelHasLeavesOrTTBeforeNewHireDateError = function getUserPanelHasLeavesOrTTBeforeNewHireDateError(state) {
    return getUserDataState(state).hasLeavesOrTTBeforeNewHireDateError;
};

var getManagementAssignmentsCounters = exports.getManagementAssignmentsCounters = function getManagementAssignmentsCounters(state) {
    return getUserDataState(state).managementAssignmentsCounters;
};

var getManagementAssignmentsSelection = exports.getManagementAssignmentsSelection = function getManagementAssignmentsSelection(state) {
    return getUserManagementAssignmentsData(state).managementAssignmentsSelection;
};

var getUserTeamAssignmentsData = exports.getUserTeamAssignmentsData = function getUserTeamAssignmentsData(state) {
    return getUserDataState(state).userTeamAssignmentsData;
};

var getUserRights = exports.getUserRights = function getUserRights(state) {
    return getFullUserInfo(state).accessRights;
};

var getAllApprovers = exports.getAllApprovers = function getAllApprovers(state) {
    return getUserDataState(state).allApprovers;
};

var areManagementAssignmentsCountersLoaded = exports.areManagementAssignmentsCountersLoaded = (0, _reselect.createSelector)(getManagementAssignmentsCounters, function (counters) {
    return counters.loaded;
});

var getUserRatesValidationData = exports.getUserRatesValidationData = (0, _reselect.createSelector)(getFullUserInfo, _selectors2.getUserManagementData, _selectors.isLVTEnabled, _selectors.isOVREnabled, function (fullUserInfo, userManagementData, isLVTEnabled, isOVREnabled) {
    return {
        leaveTypesEnabled: isLVTEnabled && userManagementData.activeLeaveTypes && userManagementData.activeLeaveTypes.length > 0,
        overtimeEnabled: isOVREnabled && fullUserInfo.overtimeLevel !== _constants.UserManagementConstants.OVERTIME_OFF
    };
});

var getUserDataWithAdditionalData = exports.getUserDataWithAdditionalData = (0, _reselect.createSelector)(getUserDataState, _selectors.selectFeatures, function (userDataState, features) {
    return _extends({}, userDataState, {
        isUGREnabled: (0, _utils.isEnabled)(features, _constants2.Feature.UGR),
        isTZGEnabled: (0, _utils.isEnabled)(features, _constants2.Feature.TZG),
        isURAEnabled: (0, _utils.isEnabled)(features, _constants2.Feature.URA),
        isTTAEnabled: (0, _utils.isEnabled)(features, _constants2.Feature.TTA),
        isBTYEnabled: (0, _utils.isEnabled)(features, _constants2.Feature.BTY),
        isLTTEnabled: (0, _utils.isEnabled)(features, _constants2.Feature.LTT),
        isPTOEnabled: (0, _utils.isEnabled)(features, _constants2.Feature.PTO),
        isSDBEnabled: (0, _utils.isEnabled)(features, _constants2.Feature.SDB),
        isOVREnabled: (0, _utils.isEnabled)(features, _constants2.Feature.OVR)
    });
});

var getWorkSchedule = exports.getWorkSchedule = (0, _reselect.createSelector)(getFullUserInfo, function (fullUserInfo) {
    return fullUserInfo.workSchedule;
});

var getCurrentTimeInUserTimeZone = exports.getCurrentTimeInUserTimeZone = (0, _reselect.createSelector)(getExtendedData, function (extendedData) {
    return extendedData.currentTime;
});

var getUserFML = exports.getUserFML = (0, _reselect.createSelector)(getFullUserInfo, function (fullUserInfo) {
    return fullUserInfo ? {
        firstName: fullUserInfo.firstName,
        middleInitial: fullUserInfo.middleInitial,
        lastName: fullUserInfo.lastName
    } : {};
});

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _EntityWithNameStore2 = __webpack_require__(278);

var _EntityWithNameStore3 = _interopRequireDefault(_EntityWithNameStore2);

var _ProjectStore = __webpack_require__(59);

var _ProjectStore2 = _interopRequireDefault(_ProjectStore);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CustomerStoreClass = function (_EntityWithNameStore) {
    _inherits(CustomerStoreClass, _EntityWithNameStore);

    function CustomerStoreClass() {
        _classCallCheck(this, CustomerStoreClass);

        return _possibleConstructorReturn(this, (CustomerStoreClass.__proto__ || Object.getPrototypeOf(CustomerStoreClass)).apply(this, arguments));
    }

    _createClass(CustomerStoreClass, [{
        key: "_onRemove",
        value: function _onRemove(customer) {
            _get(CustomerStoreClass.prototype.__proto__ || Object.getPrototypeOf(CustomerStoreClass.prototype), "_onRemove", this).call(this, customer);
            _ProjectStore2.default.removeMany(_underscore2.default.pluck(_ProjectStore2.default.getByCustomer(customer.id), 'id'));
        }
    }]);

    return CustomerStoreClass;
}(_EntityWithNameStore3.default);

var CustomerStore = new CustomerStoreClass();
exports.default = CustomerStore;

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var KEY_CODE_UP = exports.KEY_CODE_UP = 38;
var KEY_CODE_DOWN = exports.KEY_CODE_DOWN = 40;
var KEY_CODE_ESC = exports.KEY_CODE_ESC = 27;
var KEY_CODE_ENTER = exports.KEY_CODE_ENTER = 13;
var KEY_CODE_TAB = exports.KEY_CODE_TAB = 9;
var KEY_CODE_DEL = exports.KEY_CODE_DEL = 46;
var KEY_CODE_SPACE = exports.KEY_CODE_SPACE = 32;
var KEY_CODE_PAGE_UP = exports.KEY_CODE_PAGE_UP = 33;
var KEY_CODE_PAGE_DOWN = exports.KEY_CODE_PAGE_DOWN = 34;

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = PreviewSection;

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function PreviewSection() {}

PreviewSection.prototype.init = function () {
    return this;
};

PreviewSection.prototype.addRows = function (tBody) {
    // abstract
};

PreviewSection.prototype.addRow = function (tBody, row) {
    tBody.appendChild(row);
};

PreviewSection.prototype.createRow = function (className) {
    var tr = document.createElement("tr");
    if (className) tr.className = className;
    return tr;
};

PreviewSection.prototype.addCell = function (row, innerHTML, className, colSpan, rowSpan) {
    ReportPreviewUtils.addCell(row, innerHTML, className, colSpan, rowSpan);
};

PreviewSection.prototype.message = function (key, params) {
    return _messageResource2.default.getMessage(key, params);
};

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.updateFeatures = exports.setEnabledFeatures = exports.setFeatures = undefined;

var _reduxActions = __webpack_require__(9);

var _actionTypes = __webpack_require__(697);

var ActionTypes = _interopRequireWildcard(_actionTypes);

var _selectors = __webpack_require__(15);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var setFeatures = exports.setFeatures = (0, _reduxActions.createAction)(ActionTypes.SET_FEATURES);

var setEnabledFeatures = exports.setEnabledFeatures = function setEnabledFeatures(enabledFeatures) {
    return function (dispatch, getState) {
        dispatch(setFeatures(_underscore2.default.mapObject((0, _selectors.selectFeatures)(getState()), function (val, feature) {
            return !!enabledFeatures[feature];
        })));
    };
};

var updateFeatures = exports.updateFeatures = (0, _reduxActions.createAction)(ActionTypes.UPDATE_FEATURES);

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _spin = __webpack_require__(93);

var _spin2 = _interopRequireDefault(_spin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function SpinnerController(notCreateDefaultSpinner) {
    if (!notCreateDefaultSpinner) {
        this._spinner = new _spin2.default(SpinnerController.getDefaultSettings());
    }
}

SpinnerController.getDefaultSettings = function () {
    var safeCopy = {};
    _jquery2.default.extend(true, safeCopy, {
        lines: 11, // The number of lines to draw
        length: 3, // The length of each line
        width: 2, // The line thickness
        radius: 4, // The radius of the inner circle
        corners: 1, // Corner roundness (0..1)
        rotate: 0, // The rotation offset
        direction: 1, // 1: clockwise, -1: counterclockwise
        color: '#bbbbbb', // #rgb or #rrggbb
        speed: 1, // Rounds per second
        trail: 60, // Afterglow percentage
        shadow: false, // Whether to render a shadow
        hwaccel: false, // Whether to use hardware acceleration
        className: 'spinner', // The CSS class to assign to the spinner
        zIndex: 2e9, // The z-index (defaults to 2000000000)
        top: 'auto', // Top position relative to parent in px
        left: 'auto' // Left position relative to parent in px
    });
    return safeCopy;
};

SpinnerController.prototype = {
    setSpinner: function setSpinner(spinner) {
        this._spinner = spinner;
    },

    spin: function spin(spinnerContainerId) {
        if (spinnerContainerId) {
            this._spinner.spin();
            document.getElementById(spinnerContainerId).appendChild(this._spinner.el);
        }
    },

    stop: function stop() {
        this._spinner.stop();
    },

    spinInElement: function spinInElement(element) {
        if (element) {
            this._spinner.spin();
            element.append(this._spinner.el);
        }
    }
};

exports.default = SpinnerController;

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Represents a selection in two level selector
 */
var TwoLevelSelection = function () {
    /**
     * @param firstLevel selected first level entity
     * @param secondLevel selected users (users in selected groups do not include in this parameter)
     */
    function TwoLevelSelection(firstLevel, secondLevel) {
        _classCallCheck(this, TwoLevelSelection);

        this.firstLevel = firstLevel;
        this.secondLevel = secondLevel;
    }

    _createClass(TwoLevelSelection, [{
        key: "getFirstLevel",
        value: function getFirstLevel() {
            return this.firstLevel;
        }
    }, {
        key: "getSecondLevel",
        value: function getSecondLevel() {
            return this.secondLevel;
        }
    }, {
        key: "isEmpty",
        value: function isEmpty() {
            return this.firstLevel.length === 0 && this.secondLevel.length === 0;
        }
    }], [{
        key: "emptySelection",
        value: function emptySelection() {
            if (!TwoLevelSelection.EMPTY_SELECTION) TwoLevelSelection.EMPTY_SELECTION = new TwoLevelSelection([], []);
            return TwoLevelSelection.EMPTY_SELECTION;
        }
    }]);

    return TwoLevelSelection;
}();

exports.default = TwoLevelSelection;


TwoLevelSelection.FIRST_LEVEL_INDEX = 0;
TwoLevelSelection.SECOND_LEVEL_INDEX = 1;

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.transformListToGroups = exports.createGroupComparator = undefined;
exports.createDefaultUserGroup = createDefaultUserGroup;
exports.addDefaultUserGroup = addDefaultUserGroup;

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _constants = __webpack_require__(4);

var _atUtils = __webpack_require__(5);

var _GroupType = __webpack_require__(34);

var _GroupType2 = _interopRequireDefault(_GroupType);

var _Group = __webpack_require__(158);

var _Group2 = _interopRequireDefault(_Group);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function createDefaultUserGroup() {
    return {
        id: _constants.USERS_WITHOUT_GROUP_ID,
        name: _messageResource2.default.getMessage('common.users_without_group')
    };
}

function addDefaultUserGroup(userGroups) {
    return [createDefaultUserGroup()].concat(_toConsumableArray(userGroups));
}

var createGroupComparator = exports.createGroupComparator = function createGroupComparator(groupType) {
    var defaultGroupId = groupType === _GroupType2.default.USER_GROUP ? _constants.USERS_WITHOUT_GROUP_ID : _constants.DEFAULT_TIME_ZONE_GROUP_ID;
    return function (a, b) {
        if (a.id === b.id) return 0;

        if (a.id === defaultGroupId) {
            return -1;
        }
        if (b.id === defaultGroupId) {
            return 1;
        }
        return (0, _atUtils.stringComparator)(a.name, b.name);
    };
};

var transformListToGroups = exports.transformListToGroups = function transformListToGroups(listOfGroups) {
    return listOfGroups !== null ? listOfGroups.map(function (group) {
        return new _Group2.default(group["id"], group["name"]);
    }) : null;
};

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var LocalStorage = exports.LocalStorage = function () {
    function LocalStorage(loggedInUserId, context) {
        _classCallCheck(this, LocalStorage);

        this.loggedInUserId = loggedInUserId;
        this.context = context;
    }

    _createClass(LocalStorage, [{
        key: "setItem",
        value: function setItem(key, value) {
            var appendUserId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
            var appendContext = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

            var k = appendUserId ? key + this.loggedInUserId : key;
            k = appendContext ? k + this.context : k;
            try {
                localStorage.setItem(k, JSON.stringify(value));
            } catch (e) {
                console.error("can't store (" + k + ", " + value + ") cause: \n", e);
            }
        }
    }, {
        key: "getItem",
        value: function getItem(key) {
            var withUserId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
            var withContext = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

            var k = withUserId ? key + this.loggedInUserId : key;
            k = withContext ? k + this.context : k;
            try {
                return JSON.parse(localStorage.getItem(k));
            } catch (e) {
                console.error("can't retrieve stored value with key " + k + " cause: \n", e);
                return null;
            }
        }
    }, {
        key: "removeItem",
        value: function removeItem(key) {
            var appendUserId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
            var withContext = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

            var k = appendUserId ? key + this.loggedInUserId : key;
            k = withContext ? k + this.context : k;
            try {
                localStorage.removeItem(k);
            } catch (e) {
                console.error("can't remove stored value with key " + k + " cause: \n", e);
            }
        }
    }]);

    return LocalStorage;
}();

var instance = void 0;

var initLocalStorage = exports.initLocalStorage = function initLocalStorage(loggedInUserId, context) {
    instance = new LocalStorage(loggedInUserId, context);
};

var getLocalStorage = exports.getLocalStorage = function getLocalStorage() {
    return instance;
};

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var ViewTTStore = {
    data: null,
    detailsTableConfig: null,
    dateRangeConfig: null,
    filter: null,
    chartSectionConfig: null,
    weekStartDay: null,
    viewerId: -1,
    selectedUserId: -1,
    userInfo: null,
    dateFormat: null,
    assignedCPList: null,
    assignedCPMaps: null,
    generatedPDF: null,
    fileName: "file.pdf",
    printNumberOfPages: null,
    printParametersForSave: null,
    printParametersForGenerate: null,
    users: null,
    groups: null,
    needToRenderUsersSelector: false,
    balancesData: null,
    balancesViewerConfig: null,
    formatterConfig: null,
    cptMaps: {
        customersById: {},
        projectsById: {},
        tasksById: {}
    },
    //TODO maybe need find another place for enabled features (actual)
    enabledFeatures: null,
    mergedCpList: null,

    // to backup settings for load data or any other needs
    backup: {},
    // this field functionally also used for backup
    // we restore balance viewer date by this value
    balancesViewerDate: null,

    getData: function getData() {
        return this.data;
    },

    setData: function setData(data, cptMaps) {
        this.data = data;
        this.cptMaps = cptMaps;
        $(this).trigger("dataChange");
    },

    getCptMaps: function getCptMaps() {
        return this.cptMaps;
    },

    getCustomer: function getCustomer(id) {
        return this.cptMaps.customersById[id];
    },

    getProject: function getProject(id) {
        return this.cptMaps.projectsById[id];
    },

    getTask: function getTask(id) {
        return this.cptMaps.tasksById[id];
    },

    updateTask: function updateTask(task) {
        if (!this.getTask(task.id)) return;
        this.cptMaps.tasksById[task.id] = _extends({}, this.getTask(task.id), task);
    },

    setProject: function setProject(project) {
        this.cptMaps.projectsById[project.id] = project;
    },

    setCustomer: function setCustomer(customer) {
        this.cptMaps.customersById[customer.id] = customer;
    },

    getChartSectionConfig: function getChartSectionConfig() {
        return this.chartSectionConfig;
    },

    setChartSectionConfig: function setChartSectionConfig(chartSectionConfig) {
        this.chartSectionConfig = chartSectionConfig;
        $(this).trigger("chartSectionConfigChange");
    },

    getDetailsTableConfig: function getDetailsTableConfig() {
        return this.detailsTableConfig;
    },

    setDetailsTableConfig: function setDetailsTableConfig(detailsTableConfig) {
        this.detailsTableConfig = detailsTableConfig;
        $(this).trigger("detailsTableConfigChange");
    },

    setDateRangeConfig: function setDateRangeConfig(dateRangeConfig) {
        this.dateRangeConfig = dateRangeConfig;
        $(this).trigger("dateRangeConfigChange");
    },

    getDateRangeConfig: function getDateRangeConfig() {
        return this.dateRangeConfig;
    },

    setFilter: function setFilter(filter) {
        this.filter = filter;
        $(this).trigger("filterChange");
    },

    getFilter: function getFilter() {
        return this.filter;
    },

    getWeekStartDay: function getWeekStartDay() {
        return this.weekStartDay;
    },

    setWeekStartDay: function setWeekStartDay(weekStartDay) {
        this.weekStartDay = weekStartDay;
    },

    setViewerId: function setViewerId(viewerId) {
        this.viewerId = viewerId;
    },

    getViewerId: function getViewerId() {
        return this.viewerId;
    },

    setSelectedUserId: function setSelectedUserId(userId) {
        this.selectedUserId = userId;
        $(this).trigger("selectedUserIdChange");
    },

    getSelectedUserId: function getSelectedUserId() {
        return this.selectedUserId;
    },

    setDateFormat: function setDateFormat(dateFormat) {
        this.dateFormat = dateFormat;
    },

    getDateFormat: function getDateFormat() {
        return this.dateFormat;
    },

    setAssignedCPList: function setAssignedCPList(cpList) {
        this.assignedCPList = cpList;
    },

    getAssignedCPList: function getAssignedCPList() {
        return this.assignedCPList;
    },

    setAssignedCPMaps: function setAssignedCPMaps(cpMaps) {
        this.assignedCPMaps = cpMaps;
    },

    getAssignedCPMaps: function getAssignedCPMaps() {
        return this.assignedCPMaps;
    },

    setGeneratedPDF: function setGeneratedPDF(generatedPDF) {
        this.generatedPDF = generatedPDF;
        $(this).trigger("generatedPDFChange");
    },

    getGeneratedPDF: function getGeneratedPDF() {
        return this.generatedPDF;
    },

    setPDFFileName: function setPDFFileName(fileName) {
        this.fileName = fileName;
    },

    getPDFFileName: function getPDFFileName() {
        return this.fileName;
    },

    getPrintParametersForSave: function getPrintParametersForSave() {
        return this.printParametersForSave;
    },

    setPrintParametersForSave: function setPrintParametersForSave(printParametersForSave) {
        this.printParametersForSave = printParametersForSave;
        $(this).trigger("printParametersForSaveChange");
    },

    getPrintParametersForGenerate: function getPrintParametersForGenerate() {
        return this.printParametersForGenerate;
    },

    setPrintParametersForGenerate: function setPrintParametersForGenerate(printParametersForSave) {
        this.printParametersForGenerate = printParametersForSave;
    },

    setUsersAndGroups: function setUsersAndGroups(users, groups) {
        this.users = users;
        this.groups = groups;
    },

    getUsers: function getUsers() {
        return this.users;
    },

    getGroups: function getGroups() {
        return this.groups;
    },

    setNeedToRenderUsersSelector: function setNeedToRenderUsersSelector(needToRender) {
        this.needToRenderUsersSelector = needToRender;
    },

    isNeedToRenderUsersSelector: function isNeedToRenderUsersSelector() {
        return this.needToRenderUsersSelector;
    },

    setBalancesData: function setBalancesData(balancesData) {
        this.balancesData = balancesData;
        $(this).trigger("balancesDataChange");
    },

    getBalancesData: function getBalancesData() {
        return this.balancesData;
    },

    setBalancesViewerConfig: function setBalancesViewerConfig(balancesViewerConfig) {
        this.balancesViewerConfig = balancesViewerConfig;
    },

    getBalancesViewerConfig: function getBalancesViewerConfig() {
        return this.balancesViewerConfig;
    },

    setFormatterConfig: function setFormatterConfig(formatterConfig) {
        this.formatterConfig = formatterConfig;
    },

    getFormatterConfig: function getFormatterConfig() {
        return this.formatterConfig;
    },

    getEnabledFeatures: function getEnabledFeatures() {
        return this.enabledFeatures;
    },

    setEnabledFeatures: function setEnabledFeatures(enabledFeatures) {
        this.enabledFeatures = enabledFeatures;
    },

    setMergedCp: function setMergedCp(mergedCpList) {
        this.mergedCpList = mergedCpList;
    },

    getMergedCpList: function getMergedCpList() {
        return this.mergedCpList;
    },

    setUserInfo: function setUserInfo(userInfo) {
        this.userInfo = userInfo;
    },

    getUserInfo: function getUserInfo() {
        return this.userInfo;
    },

    /**
     * Backup stable state of configuration for loading data
     */
    backupDataConfig: function backupDataConfig() {
        this.backup.selectedUserId = this.getSelectedUserId();
        this.backup.dateRangeConfig = this.getDateRangeConfig();
        this.backup.filter = this.getFilter();
    },

    /**
     * Restoring configuration for loading data and notify about it
     */
    restoreDataConfig: function restoreDataConfig() {
        this.setSelectedUserId(this.backup.selectedUserId);
        this.setDateRangeConfig(this.backup.dateRangeConfig);
        this.setFilter(this.backup.filter);

        $(this).trigger("dataConfigRestored");
    },

    setBalancesViewerDate: function setBalancesViewerDate(date) {
        this.balancesViewerDate = date;
    },

    getBalancesViewerDate: function getBalancesViewerDate() {
        return this.balancesViewerDate;
    },

    getSelectedUser: function getSelectedUser() {
        return _.find(this.users, _.bind(function (user) {
            return user.id == this.selectedUserId;
        }, this));
    }
};

exports.default = ViewTTStore;

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(35);
var hide = __webpack_require__(87);
var has = __webpack_require__(75);
var SRC = __webpack_require__(174)('src');
var TO_STRING = 'toString';
var $toString = Function[TO_STRING];
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__(37).inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),
/* 75 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(10);
var fails = __webpack_require__(32);
var defined = __webpack_require__(151);
var quot = /"/g;
// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
var createHTML = function (string, tag, attribute, value) {
  var S = String(defined(string));
  var p1 = '<' + tag;
  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};
module.exports = function (NAME, exec) {
  var O = {};
  O[NAME] = exec(createHTML);
  $export($export.P + $export.F * fails(function () {
    var test = ''[NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  }), 'String', O);
};


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var GC = window.__GENERATED_CONSTANTS__;

var reportUrls = exports.reportUrls = GC.reportUrls;
var reportNameKeys = exports.reportNameKeys = GC.reportNameKeys;

// only used in next
var TaskPredefinedFieldNames = exports.TaskPredefinedFieldNames = {
    Deadline: 'Deadline',
    TypeOfWork: 'TypeOfWork'
};

var NextGroupLevelId = exports.NextGroupLevelId = {
    Project: 1,
    Customer: 0
};

var NextWorkflowStatusColorKeyToClassicMap = exports.NextWorkflowStatusColorKeyToClassicMap = {
    pink: 0,
    orange: 1,
    yellow: 2,
    light_green: 3,
    dark_green: 4,
    aquamarine: 5,
    blue: 6,
    violet: 7,
    light_gray: 8,
    dark_gray: 9
};

var ClassicWorkflowStatusColorKeyToNextMap = exports.ClassicWorkflowStatusColorKeyToNextMap = Object.fromEntries(Object.entries(NextWorkflowStatusColorKeyToClassicMap).map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];

    return [value, key];
}));

/**
 * !! Don't change value without corresponding change in next web
 */
var AtNextCustomScrollbarUsedClassName = exports.AtNextCustomScrollbarUsedClassName = '_internal_atNextCustomScrollbarUsed';

var ApiErrorKeys = exports.ApiErrorKeys = {
    NotFoundEntity: 'not_found.entity',
    Unauthenticated: 'unauthenticated'
};

var ApiEntityTypes = exports.ApiEntityTypes = {
    CustomField: 'custom_field'
};

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var F = window.__GENERATED_CONSTANTS__.Features;

var Feature = exports.Feature = {
    CPTBUD: F.CPTBUD, //Customer, Project or Task Budgets
    TTF: F.TTF, // Time Track in Future
    LVT: F.LVT, // Leave Time Tracking
    TST: F.TST, // Timesheet Tracking (Table View)
    FTT: F.FTT, // From-To Timetrack (Calendar View)
    PTO: F.PTO, // LVT -> PTO Balance
    SDB: F.SDB, // LVT -> Sick Days Balance
    OVR: F.OVR, // Overtime
    TTA: F.TTA, // Time Track Approval
    UGR: F.UGR, // User Groups
    TZG: F.TZG, // Time Zone Groups
    EST: F.EST, // Estimate
    TWS: F.TWS, // Task Workflow Statuses
    WAS: F.WAS, // Work Assignments
    URA: F.URA, // User Rates
    BTY: F.BTY, // Billing Types
    BRA: F.BRA, // BTY -> Billing Rates

    LTT: F.LTT, // Lock Time Track
    TTC: F.TTC, // Time Track in Details Report
    CLT: F.CLT, // Custom Leave Types
    QBI: F.QBI, // QuickBooks Integration
    CFI: F.CFI, // Custom fields
    WSD: F.WSD, // Work Scheduling / Work Statuses

    // actiPLANS
    APUGR: F.APUGR,
    APTZG: F.APTZG,
    APPTO: F.APPTO,
    APSDB: F.APSDB,
    APWSD: F.APWSD
};

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TreeNodeSet = function () {
    function TreeNodeSet() {
        _classCallCheck(this, TreeNodeSet);

        this.map = {};
    }

    _createClass(TreeNodeSet, [{
        key: "clone",
        value: function clone() {
            var target = {};
            for (var level in this.map) {
                //noinspection JSUnfilteredForInLoop
                var sourceObj = this.map[level];
                var targetObj = {};

                for (var id in sourceObj) {
                    //noinspection JSUnfilteredForInLoop
                    targetObj[id] = sourceObj[id];
                }

                //noinspection JSUnfilteredForInLoop
                target[level] = targetObj;
            }

            var result = new TreeNodeSet();
            result.map = target;

            return result;
        }
    }, {
        key: "add",
        value: function add(treeNode) {
            var levelMap = this.getLevelMap(treeNode.getLevel());
            levelMap[treeNode.getId()] = treeNode;
        }
    }, {
        key: "remove",
        value: function remove(treeNode) {
            var levelMap = this.getLevelMap(treeNode.getLevel());
            delete levelMap[treeNode.getId()];
        }
    }, {
        key: "contains",
        value: function contains(treeNode) {
            var levelObj = this.map[treeNode.getLevel()];
            return levelObj && levelObj[treeNode.getId()] ? true : false;
        }
    }, {
        key: "containsAll",
        value: function containsAll(treeNodes) {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = treeNodes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var node = _step.value;

                    if (!this.contains(node)) return false;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            return true;
        }
    }, {
        key: "isEmpty",
        value: function isEmpty() {
            for (var level in this.map) {
                if (!this.isLevelEmpty(level)) return false;
            }return true;
        }
    }, {
        key: "isLevelEmpty",
        value: function isLevelEmpty(level) {
            if (!this.map[level]) return true;
            //noinspection LoopStatementThatDoesntLoopJS, JSUnusedLocalSymbols
            for (var p in this.map[level]) {
                return false;
            }return true;
        }
    }, {
        key: "getLevelMap",
        value: function getLevelMap(level) {
            var levelMap = this.map[level];
            if (!levelMap) {
                levelMap = {};
                this.map[level] = levelMap;
            }
            return levelMap;
        }
    }, {
        key: "getAllLevels",
        value: function getAllLevels() {
            var levels = [];

            for (var level in this.map) {
                levels.push(level);
            }return levels;
        }
    }, {
        key: "getAllNodes",
        value: function getAllNodes() {
            var nodes = [];
            _underscore2.default.each(_underscore2.default.values(this.map), function (levelMap) {
                _underscore2.default.each(_underscore2.default.values(levelMap), function (node) {
                    nodes.push(node);
                });
            });

            return nodes;
        }
    }, {
        key: "addAll",
        value: function addAll(otherTreeNodeSet) {
            for (var level in otherTreeNodeSet.map) {
                //noinspection JSUnfilteredForInLoop
                var sourceObj = otherTreeNodeSet.map[level];
                //noinspection JSUnfilteredForInLoop
                var targetObj = this.getLevelMap(level);
                for (var id in sourceObj) {
                    //noinspection JSUnfilteredForInLoop
                    targetObj[id] = sourceObj[id];
                }
            }
        }
    }, {
        key: "makePathsNodeSet",
        value: function makePathsNodeSet() {
            var target = {};
            _underscore2.default.each(this.getAllNodes(), function (node) {
                var parent = node.getParent();
                while (parent) {
                    var targetObj = target[parent.getLevel()];
                    if (!targetObj) {
                        targetObj = {};
                        target[parent.getLevel()] = targetObj;
                    }

                    targetObj[parent.getId()] = parent;

                    parent = parent.getParent();
                }
            });

            var result = new TreeNodeSet();
            result.map = target;
            return result;
        }
    }, {
        key: "getNodeIds",
        value: function getNodeIds(level) {
            var result = [];
            if (this.map[level]) for (var p in this.map[level]) {
                result.push(p);
            }return result;
        }
    }, {
        key: "intersection",
        value: function intersection(treeNodeSet) {
            var result = new TreeNodeSet();

            for (var level in this.map) {
                //noinspection JSUnfilteredForInLoop
                var levelObj = this.map[level];
                for (var id in levelObj) {
                    //noinspection JSUnfilteredForInLoop
                    var node = levelObj[id];
                    if (treeNodeSet.contains(node)) result.add(node);
                }
            }

            return result;
        }
    }, {
        key: "union",
        value: function union(treeNodeSet) {
            var result = this.clone();
            result.addAll(treeNodeSet);
            return result;
        }
    }, {
        key: "equals",
        value: function equals(other) {
            var self = this;
            var selfNodes = self.getAllNodes();
            var otherNodes = other.getAllNodes();
            return selfNodes.length === otherNodes.length && _underscore2.default.all(selfNodes, function (node) {
                return other.contains(node);
            }) && _underscore2.default.all(otherNodes, function (node) {
                return self.contains(node);
            });
        }
    }]);

    return TreeNodeSet;
}();

exports.default = TreeNodeSet;

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getColorClassById = getColorClassById;
exports.getStatusClassByType = getStatusClassByType;
exports.getStatusTypeClassByColorId = getStatusTypeClassByColorId;
exports.workflowStatusComparator = workflowStatusComparator;
exports.workflowStatusComparatorWithStatusType = workflowStatusComparatorWithStatusType;

var _constants = __webpack_require__(23);

function getColorClassById(id) {
    return _constants.CLASS_MAP_BY_COLOR[id];
}

function getStatusClassByType(type) {
    return _constants.CLASS_MAP_BY_STATUS_TYPE[type];
}

function getStatusTypeClassByColorId(id) {
    return _constants.STATUS_TYPE_CLASS_MAP_BY_COLOR[id];
}

function workflowStatusComparator(st1, st2) {
    return st1.position - st2.position;
}

function workflowStatusComparatorWithStatusType(s1, s2) {
    if (s1.type === _constants.WorkflowStatusType.OPEN && s2.type === _constants.WorkflowStatusType.COMPLETED) {
        return -1;
    } else if (s2.type === _constants.WorkflowStatusType.OPEN && s1.type === _constants.WorkflowStatusType.COMPLETED) {
        return 1;
    } else {
        return s1.position - s2.position;
    }
}

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.updateCustomField = exports.copyLinkTo = exports.loadEditTaskPanelData = exports.openLastTaskPanelTab = exports.updateNewCommentText = exports.reloadComments = exports.toggleNewCommentInput = exports.saveEditingComment = exports.startEditComment = exports.deleteComment = exports.saveComment = exports.loadMoreComments = exports.commentsActions = exports.loadTaskAuditHistory = exports.deleteTask = exports.copyTask = exports.moveTask = exports.updateStatus = exports.updateDescription = exports.updateEstimate = exports.updateTypeOfWork = exports.updateDeadline = exports.updateName = exports.loadEditTaskPanelDataAction = exports.saveSortingSettings = exports.loadTimeComments = exports.closeEditTaskPanel = exports.closeAnyTaskPanel = exports.setTaskPanelTab = exports.openEditTaskPanel = exports.closeTaskPanel = exports.openTaskPanel = exports.setLastTaskPanelTab = exports.setPanelOpenedFromUrl = exports.setOpenTask = exports.updateAssignedManagers = exports.deleteAssignedManager = exports.updateAssignedUsers = exports.deleteAssignedUser = exports.resetDeletionStatus = exports.setUpdatingState = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _constants = __webpack_require__(157);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _rpcCalls = __webpack_require__(24);

var _rpcCalls2 = _interopRequireDefault(_rpcCalls);

var _selectors = __webpack_require__(15);

var _selectors2 = __webpack_require__(57);

var _constants2 = __webpack_require__(23);

var _selectors3 = __webpack_require__(14);

var _actions = __webpack_require__(29);

var EntitiesActions = _interopRequireWildcard(_actions);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _syncCallbacks = __webpack_require__(1345);

var SyncCallbacks = _interopRequireWildcard(_syncCallbacks);

var _actionTypes = __webpack_require__(681);

var ActionTypes = _interopRequireWildcard(_actionTypes);

var _reduxActions = __webpack_require__(9);

var _actionsGenerator = __webpack_require__(762);

var _actionsGenerator2 = _interopRequireDefault(_actionsGenerator);

var _actionsGenerator3 = __webpack_require__(763);

var _actionsGenerator4 = _interopRequireDefault(_actionsGenerator3);

var _constants3 = __webpack_require__(4);

var _commentsActionsGenerator = __webpack_require__(489);

var _commentsActionsGenerator2 = _interopRequireDefault(_commentsActionsGenerator);

var _selectors4 = __webpack_require__(97);

var selectors = _interopRequireWildcard(_selectors4);

var _actionsGenerator5 = __webpack_require__(490);

var _actionsGenerator6 = _interopRequireDefault(_actionsGenerator5);

var _actions2 = __webpack_require__(68);

var FeaturesActions = _interopRequireWildcard(_actions2);

var _constants4 = __webpack_require__(78);

var _actionsProviders = __webpack_require__(363);

var _errors = __webpack_require__(193);

var _actions3 = __webpack_require__(55);

var TaskManagementActions = _interopRequireWildcard(_actions3);

var _utils = __webpack_require__(25);

var _constants5 = __webpack_require__(229);

var _utils2 = __webpack_require__(118);

var _actions4 = __webpack_require__(56);

var _actions5 = __webpack_require__(491);

var _atUtils = __webpack_require__(5);

var _batch = __webpack_require__(117);

var _utils3 = __webpack_require__(192);

var _selectors5 = __webpack_require__(19);

var _rpcUtils = __webpack_require__(160);

var _ExceptionsTypes = __webpack_require__(107);

var _actions6 = __webpack_require__(141);

var _utils4 = __webpack_require__(766);

var _utils5 = __webpack_require__(369);

var _atBrowserUtils = __webpack_require__(8);

var _actions7 = __webpack_require__(493);

var _ClassicBridge = __webpack_require__(18);

var _ClassicBridge2 = _interopRequireDefault(_ClassicBridge);

var _utils6 = __webpack_require__(341);

var _utils7 = __webpack_require__(135);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//TODO: remove alerts and Toasts

var setUpdatingState = exports.setUpdatingState = (0, _reduxActions.createAction)(ActionTypes.TASK_PANEL_UPDATING_STATE_SET);
var resetDeletionStatus = exports.resetDeletionStatus = (0, _reduxActions.createAction)(ActionTypes.TASK_DELETION_STATUS_RESET);

var setTaskDetails = (0, _reduxActions.createAction)(ActionTypes.TASK_DETAILS_SET);
var setTaskExecutorsSummary = (0, _reduxActions.createAction)(ActionTypes.TASK_EXECUTORS_SUMMARY_SET);
var setAllTimeCommentsLoaded = (0, _reduxActions.createAction)(ActionTypes.ALL_TIME_COMMENTS_LOADED_SET);
var setTimeAndCommentsLoading = (0, _reduxActions.createAction)(ActionTypes.TIME_AND_COMMENTS_LOADING_SET);
var setReportedTimeComments = (0, _reduxActions.createAction)(ActionTypes.REPORTED_TIME_COMMENTS_SET);
var addReportedTimeComments = (0, _reduxActions.createAction)(ActionTypes.REPORTED_TIME_COMMENTS_ADD);
var setSortingSettings = (0, _reduxActions.createAction)(ActionTypes.SORTING_SETTINGS_SET);
var updateCustomFieldsValues = (0, _reduxActions.createAction)(ActionTypes.CUSTOM_FIELDS_VALUES_UPDATE);
var setCustomFieldsValues = (0, _reduxActions.createAction)(ActionTypes.CUSTOM_FIELDS_VALUES_SET);

var taskPanelActions = (0, _actionsGenerator2.default)({
    actionTypes: ActionTypes
});
var setTaskDeletedSuccessfully = (0, _reduxActions.createAction)(ActionTypes.TASK_DELETED_SUCCESSFULLY_SET);
var setTaskDeletedUnsuccessfully = (0, _reduxActions.createAction)(ActionTypes.TASK_DELETED_UNSUCCESSFULLY_SET);
var setAuditHistoryInfo = (0, _reduxActions.createAction)(ActionTypes.TASK_AUDIT_HISTORY_INFO_SET);
var addAuditHistory = (0, _reduxActions.createAction)(ActionTypes.AUDIT_HISTORY_ADD);
var setAuditHistory = (0, _reduxActions.createAction)(ActionTypes.AUDIT_HISTORY_SET);

var assignmentsActions = (0, _actionsGenerator4.default)({
    actionTypes: {
        ASSIGNED_USERS_SET: ActionTypes.ASSIGNED_USERS_SET,
        ASSIGNED_MANAGERS_SET: ActionTypes.ASSIGNED_MANAGERS_SET,
        CAN_MODIFY_ANY_USER_SET: ActionTypes.CAN_MODIFY_ANY_USER_SET,
        CAN_MODIFY_ANY_MANAGER_SET: ActionTypes.CAN_MODIFY_ANY_MANAGER_SET
    }
});

var _updateAssignedUsersErrorHandler = function _updateAssignedUsersErrorHandler(e) {
    if (e instanceof _errors.NotFoundError) alert(_messageResource2.default.getMessage("task.error.concurrently_deleted"));
    if (e instanceof _errors.NoRightsError) alert(_messageResource2.default.getMessage("task.error.task_not_assigned"));
    if (e instanceof _errors.NoEditHierarchyRightError) alert(_messageResource2.default.getMessage("task.list.error.no_manage_scope_right"));
    if (e instanceof _errors.NotAssignedError) alert(_messageResource2.default.getMessage("task.list.error.user_is_not_assigned_to_manager"));
    if (e instanceof _errors.NoSubmitTTRightError) alert(_messageResource2.default.getMessage("task.list.error.user_does_not_have_submit_tt_right"));
    if (e instanceof _errors.NoSuchUserError) alert(_messageResource2.default.getMessage("task.list.error.no_such_user"));
    if (e instanceof _errors.EditingUserDisabled) alert(_messageResource2.default.getMessage("task.list.error.editing_user_disabled"));

    window.location.reload();
};

var _updateManagerErrorHandler = function _updateManagerErrorHandler(e) {
    if (e instanceof _errors.NotFoundError) alert(_messageResource2.default.getMessage("task.error.concurrently_deleted"));
    if (e instanceof _errors.NoManageUsersRightError) alert(_messageResource2.default.getMessage("task.list.error.no_manage_users_right"));
    if (e instanceof _errors.EditingUserDisabled) alert(_messageResource2.default.getMessage("task.list.error.editing_user_disabled"));
    if (e instanceof _errors.NoSuchUserError) alert(_messageResource2.default.getMessage("task.list.error.no_such_user"));
    if (e instanceof _errors.NoAccessToScopeError) alert(_messageResource2.default.getMessage("task.list.error.user_does_not_have_any_scope_rights"));
    window.location.reload();
};

var _deleteAssignedUser = function _deleteAssignedUser(entityId, userId) {
    return function (dispatch) {
        dispatch(_updateAssignedUsers(entityId, [], [userId]));
    };
};

var _applyUpdateUsersResult = function _applyUpdateUsersResult(result) {
    return function (dispatch) {
        //editor.setState({loading: true}); todo koshik set loading
        result.then(function (data) {
            dispatch(assignmentsActions.setAssignedUsersData(data));
        }).catch(function (e) {
            //editor.setState({loading: false});
            _updateAssignedUsersErrorHandler(e);
        });
    };
};

var _updateAssignedUsers = function _updateAssignedUsers(entityId, addedUserIds, removedUserIds) {
    return function (dispatch) {
        var promise = _actionsProviders.taskActionsProvider.updateAssignedUsers(entityId, addedUserIds, removedUserIds);
        dispatch(_applyUpdateUsersResult(promise));
    };
};

var _getAssignedUsers = function _getAssignedUsers(entityId) {
    return function (dispatch) {
        var promise = _actionsProviders.taskActionsProvider.getAssignedUsers(entityId);
        dispatch(_applyUpdateUsersResult(promise));
    };
};

var _deleteManager = function _deleteManager(entityId, userId) {
    return function (dispatch) {
        dispatch(_updateManagers(entityId, [], [userId]));
    };
};

var _updateManagers = function _updateManagers(entityId, addedUserIds, removedUserIds) {
    return function (dispatch) {
        //editor.setState({loading: true}); todo koshik set loading
        _actionsProviders.taskActionsProvider.updateManagers(entityId, addedUserIds, removedUserIds).then(function (data) {
            dispatch(assignmentsActions.setAssignedManagersData(data));
            dispatch(_getAssignedUsers(entityId));
        }).catch(function (e) {
            //editor.setState({loading: false});
            console.error(e);
            _updateManagerErrorHandler(e);
        });
    };
};

var deleteAssignedUser = exports.deleteAssignedUser = function deleteAssignedUser(userId) {
    return function (dispatch, getState) {
        var taskId = (0, _selectors4.getOpenTaskId)(getState());
        dispatch(_deleteAssignedUser(taskId, userId));
    };
};

var updateAssignedUsers = exports.updateAssignedUsers = function updateAssignedUsers(addedUserIds, removedUserIds) {
    return function (dispatch, getState) {
        var taskId = (0, _selectors4.getOpenTaskId)(getState());
        dispatch(_updateAssignedUsers(taskId, addedUserIds, removedUserIds));
    };
};

var deleteAssignedManager = exports.deleteAssignedManager = function deleteAssignedManager(userData) {
    return function (dispatch, getState) {
        var taskId = (0, _selectors4.getOpenTaskId)(getState());
        dispatch(_deleteManager(taskId, userData.id));
    };
};

var updateAssignedManagers = exports.updateAssignedManagers = function updateAssignedManagers(addedUserIds, removedUserIds) {
    return function (dispatch, getState) {
        var taskId = (0, _selectors4.getOpenTaskId)(getState());
        dispatch(_updateManagers(taskId, addedUserIds, removedUserIds));
    };
};

var setOpenTask = exports.setOpenTask = (0, _reduxActions.createAction)(ActionTypes.OPEN_TASK_SET);
var setPanelOpenedFromUrl = exports.setPanelOpenedFromUrl = (0, _reduxActions.createAction)(ActionTypes.TASK_PANEL_OPENED_FROM_URL_SET);
var setLastTaskPanelTab = exports.setLastTaskPanelTab = taskPanelActions.setLastTaskPanelTab;
var openTaskPanel = exports.openTaskPanel = taskPanelActions.openTaskPanel;
var closeTaskPanel = exports.closeTaskPanel = taskPanelActions.closeTaskPanel;

var setPanelEditable = (0, _reduxActions.createAction)(ActionTypes.TASK_PANEL_EDITABLE_SET);
var resetPanelState = (0, _reduxActions.createAction)(ActionTypes.TASK_PANEL_STATE_RESET);

var openEditTaskPanel = exports.openEditTaskPanel = function openEditTaskPanel(taskId) {
    var fromUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return function (dispatch, getState) {
        var openTaskId = (0, _selectors4.getOpenTaskId)(getState());

        if (openTaskId !== taskId) {
            dispatch(resetPanelState());
            dispatch(setOpenTask(taskId));
            dispatch(setPanelOpenedFromUrl(fromUrl));
            dispatch(taskPanelActions.openTaskPanel());
            dispatch(reloadPanelData());
        } else {
            dispatch(closeEditTaskPanel(openTaskId));
        }
    };
};

var setTaskPanelTab = exports.setTaskPanelTab = function setTaskPanelTab(tabKey) {
    return function (dispatch, getState) {
        var state = getState();

        if ((0, _selectors4.getTaskPanelTabKey)(state) === tabKey) return;

        if (!Object.values(_constants.TaskDialogs).includes(tabKey)) {
            dispatch(setLastTaskPanelTab(tabKey));
        }
        if (tabKey === _constants.TasksTabs.REPORTED_TAB) {
            var sortSettings = (0, _selectors4.getSortingSettings)(state);
            dispatch(loadTimeComments(sortSettings.sortBy, sortSettings.sortOrder, 0));
        }
        if (tabKey !== _constants.TasksTabs.DETAILS_TAB) {
            dispatch(saveEditingComment());
        }
        dispatch(taskPanelActions.setTaskPanelTab(tabKey));
    };
};

var closeAnyTaskPanel = exports.closeAnyTaskPanel = function closeAnyTaskPanel() {
    return function (dispatch, getState) {
        dispatch(closeEditTaskPanel((0, _selectors4.getOpenTaskId)(getState())));
    };
};

var reloadPanelData = function reloadPanelData() {
    return function (dispatch) {
        (0, _rpcCalls.abortCall)(_constants.Methods.LOAD_EDIT_TASK_PANEL);
        dispatch(taskPanelActions.setTaskPanelLoaded(true));
        dispatch(taskPanelActions.setTaskPanelLoaded(false));
    };
};

var closeEditTaskPanel = exports.closeEditTaskPanel = function closeEditTaskPanel(taskId) {
    return function (dispatch, getState) {
        var state = getState();
        var openTaskId = (0, _selectors4.getOpenTaskId)(state);

        if (openTaskId !== taskId) return;

        (0, _rpcCalls.abortCall)(_constants.Methods.LOAD_EDIT_TASK_PANEL);
        dispatch(saveEditingComment());
        dispatch(taskPanelActions.setTaskPanelTab((0, _selectors4.getLastTaskPanelTabKey)(state)));
        dispatch(setOpenTask(null));
        dispatch(setPanelOpenedFromUrl(false));
        dispatch(closeTaskPanel());
    };
};

var loadTimeComments = exports.loadTimeComments = function loadTimeComments(sortBy, sortOrder, offset) {
    return function (dispatch, getState) {
        if ((0, _selectors4.isTimeAndCommentsLoading)(getState())) {
            return;
        }

        dispatch(setTimeAndCommentsLoading(true));
        var taskId = (0, _selectors4.getOpenTaskId)(getState());

        if (taskId) {
            (0, _rpcCalls2.default)(_constants.Methods.TIME_COMMENTS, [taskId, sortBy, sortOrder, offset, _constants.REPORTED_TIME_COMMENTS_RECORDS_LIMIT]).then(function (loadedData) {
                dispatch(setTimeAndCommentsLoading(false));
                dispatch(setAllTimeCommentsLoaded(loadedData.reportedTimeComments.list.length < _constants.REPORTED_TIME_COMMENTS_RECORDS_LIMIT));
                if (offset > 0) {
                    dispatch(addReportedTimeComments(loadedData.reportedTimeComments.list));
                } else {
                    dispatch(setReportedTimeComments(loadedData.reportedTimeComments.list));
                }
            });
        } else {
            dispatch(setTimeAndCommentsLoading(false));
        }
    };
};

var saveSortingSettings = exports.saveSortingSettings = function saveSortingSettings(sortBy, sortOrder) {
    return function (dispatch) {
        (0, _rpcCalls2.default)(_constants.Methods.SAVE_SETTINGS, [sortBy, sortOrder]).then(function () {
            dispatch(setSortingSettings({
                sortBy: sortBy,
                sortOrder: sortOrder
            }));
        });
    };
};

/**
 * Don't use as container's action.
 * This action to specify error handler for interface with TaskPanel
 *
 * @param errorHandler
 * @returns {Function}
 */
var loadEditTaskPanelDataAction = exports.loadEditTaskPanelDataAction = function loadEditTaskPanelDataAction() {
    var errorHandler = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (taskId, error, getState, dispatch) {};
    return function () {
        return function (dispatch, getState) {
            dispatch(taskPanelActions.setTaskPanelLoading(true));
            dispatch((0, _actions7.loadCustomFields)());
            var taskId = (0, _selectors4.getOpenTaskId)(getState());

            var detailPromise = (0, _rpcCalls2.default)(_constants.Methods.LOAD_EDIT_TASK_PANEL, [taskId], function (error) {
                return errorHandler(taskId, error, getState, dispatch);
            });
            var nextTargetPromise = _ClassicBridge2.default.getTasksForTaskList({ taskIds: [taskId] });

            Promise.all([detailPromise, nextTargetPromise]).then(function (_ref) {
                var _ref2 = _slicedToArray(_ref, 2),
                    loadedData = _ref2[0],
                    nextResponse = _ref2[1];

                var target = nextResponse.items[0];
                var customFieldsValues = (0, _utils6.collectCustomFieldValues)(target);
                dispatch(setCustomFieldsValues(customFieldsValues));
                dispatch(EntitiesActions.addTask({
                    id: taskId,
                    customFieldsValues: customFieldsValues,
                    nextId: target.id
                }));

                var enabledFeatures = (0, _atUtils.arrayToSet)(loadedData['enabledFeatures']);
                if ((0, _utils2.isEnabled)(enabledFeatures, _constants4.Feature.TWS)) {
                    dispatch(EntitiesActions.setWorkflowStatusesList(loadedData['workflowStatuses']));
                }

                dispatch(FeaturesActions.setEnabledFeatures(enabledFeatures));

                if ((0, _utils2.isEnabled)(enabledFeatures, _constants4.Feature.BTY)) {
                    dispatch(EntitiesActions.setTypesOfWorkList(loadedData['billingTypes']['list']));
                }

                dispatch(setPanelEditable(loadedData['canEdit']));
                //update information about manageable projects and customers
                dispatch(addProjectsAndCustomers(loadedData['customers'].list, loadedData['projects'].list));

                dispatch(prepareTaskDetails(loadedData['taskDetails'], target));

                dispatch(setAllTimeCommentsLoaded(false));
                dispatch(setReportedTimeComments([]));

                dispatch(TaskManagementActions.setManagementAssignments(loadedData['managementAssignments']));
                dispatch(TaskManagementActions.setViewerSettings(loadedData.viewerSettings));

                if ((0, _utils2.isEnabled)(enabledFeatures, _constants4.Feature.WAS)) dispatch(assignmentsActions.setAssignedUsersData(loadedData['assignedUsersData']));

                dispatch(assignmentsActions.setAssignedManagersData(loadedData['assignedUsersDataForManagers']));

                dispatch(setLastAuditActions(loadedData['lastAuditActions']));

                dispatch(taskPanelActions.setTaskPanelLoading(false));
                dispatch(taskPanelActions.setTaskPanelLoaded(true));
                dispatch(taskPanelActions.setTaskPanelErrors([]));
            }).then(function () {
                return dispatch(commentsServiceActions.reloadComments());
            }).catch(function (error) {
                if ((0, _rpcUtils.isAborted)(error) || error.isHandled()) return;

                console.error(error);
            });
        };
    };
};

var setLastAuditActions = function setLastAuditActions(lastAuditActions) {
    return function (dispatch, getState) {
        var createAction = lastAuditActions['createAction'];
        if (_underscore2.default.isNull(createAction)) createAction = {
            timestamp: (0, _selectors4.getCreationTimestamp)(getState()),
            type: window.__GENERATED_CONSTANTS__.AuditActionTypes.CREATED,
            data: null,
            subject: null
        };
        var updateAction = lastAuditActions['updateAction'];
        dispatch(setAuditHistoryInfo({
            allAuditHistoryLoaded: false,
            lastAuditActions: {
                createAction: createAction,
                updateAction: updateAction
            }
        }));
    };
};

var setFakeLastUpdateAuditAction = function setFakeLastUpdateAuditAction() {
    return function (dispatch, getState) {
        var lastAuditActions = (0, _selectors4.getLastAuditActions)(getState());
        var updateAction = (0, _utils.getFakeUpdateAuditAction)((0, _selectors5.getLoggedInUser)(getState()));
        dispatch(setLastAuditActions(_extends({}, lastAuditActions, {
            updateAction: updateAction
        })));
    };
};

var prepareTaskDetails = function prepareTaskDetails(data) {
    var dataFromNext = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return (0, _batch.batched)(function (dispatch, getState) {
        var taskData = data;
        var taskProject = (0, _utils3.projectFromRpc)(taskData.task['project']);
        var taskCustomer = (0, _utils3.customerFromRpc)(taskData.task['project']['customer']);
        dispatch(addProjectsAndCustomers([taskCustomer], [taskProject]));

        var taskFromRequest = taskData.task;

        taskFromRequest.estimatedTime = _underscore2.default.isNumber(taskData.task['budgetedTime']) ? taskData.task['budgetedTime'] : null;
        taskFromRequest.deadline = _underscore2.default.isString(taskData.task['deadlineDate']) ? Date.parseJSONDate(taskData.task['deadlineDate']) : null;
        taskFromRequest.lastTrackingDate = _underscore2.default.isString(taskData['lastTTDate']) ? Date.parseJSONDate(taskData['lastTTDate']) : null;
        taskFromRequest.typeOfWorkId = _underscore2.default.isNumber(taskData.task['billingTypeId']) ? taskData.task['billingTypeId'] : null;
        taskFromRequest.commentsNumber = _underscore2.default.isNumber(taskData['commentsNumber']) ? taskData['commentsNumber'] : null;

        var spentTime = (0, _selectors4.getSpentTime)(getState());
        if (dataFromNext["spentTime"]) {
            taskFromRequest.spentTime = (0, _utils7.nextDurationToMinutes)(dataFromNext["spentTime"]);
        } else {
            taskFromRequest.spentTime = spentTime;
        }

        dispatch(setTaskInfo(taskFromRequest));

        dispatch(taskPanelActions.setTaskInfo({
            creationTimestamp: taskFromRequest.creationTimestamp,
            completed: taskFromRequest.completed,
            workflowStatusId: taskFromRequest.workflowStatusId,
            name: taskFromRequest.name,
            deadline: _underscore2.default.isString(taskFromRequest["deadlineDate"]) ? Date.parseJSONDate(taskFromRequest["deadlineDate"]) : null,
            typeOfWorkId: taskFromRequest.typeOfWorkId,
            estimatedTime: taskFromRequest.estimatedTime,
            spentTime: taskFromRequest.spentTime,
            description: taskFromRequest.description
        }));

        dispatch(setTaskDetails({
            blockedDueToLockedTime: taskData['blockedDueToLockedTime'],
            blockedDueToUnavailableToModifyTimeTrack: taskData['blockedDueToUnavailableToModifyTimeTrack'],
            taskHasOtherUsersTimeTrack: taskData['taskHasOtherUsersTimeTrack'],
            taskHasManagerTimeTrack: taskData['taskHasManagerTimeTrack'],
            taskHasOtherUsersApprovedTimeTrack: taskData['taskHasOtherUsersApprovedTimeTrack'],
            taskHasManagerApprovedTimeTrack: taskData['taskHasManagerApprovedTimeTrack'],
            hasManagerApprover: taskData['hasManagerApprover'],
            canManageAllUsersWithoutAutoApproved: taskData['canManageAllUsersWithoutAutoApproved']
        }));

        dispatch(setTaskExecutorsSummary({
            total: taskData.executorsSummary.total,
            myRecord: taskData.executorsSummary.myRecord,
            myTeamRecords: taskData.executorsSummary.myTeamRecords,
            othersRecords: taskData.executorsSummary.othersRecords,
            myTeamTotal: taskData.executorsSummary.myTeamTotal,
            othersTotal: taskData.executorsSummary.othersTotal
        }));

        dispatch(setSortingSettings({
            sortBy: taskData.settings.sortBy,
            sortOrder: taskData.settings.sortOrder
        }));
    });
};

var setTaskInfo = function setTaskInfo(taskFromRequest) {
    return function (dispatch) {
        var task = {
            id: taskFromRequest.id,
            commentsNumber: taskFromRequest.commentsNumber,
            completed: taskFromRequest.completed,
            creationDate: Date.parseJSONDate(taskFromRequest['creationTimestamp']),
            customerId: taskFromRequest.customerId,
            deadline: taskFromRequest.deadline,
            estimatedTime: taskFromRequest.estimatedTime,
            lastTrackingDate: taskFromRequest.lastTrackingDate,
            name: taskFromRequest.name,
            projectId: taskFromRequest.projectId,
            spentTime: taskFromRequest.spentTime,
            typeOfWorkId: taskFromRequest.typeOfWorkId,
            workflowStatusId: taskFromRequest.workflowStatusId
        };
        dispatch(EntitiesActions.addTask(task));
        SyncCallbacks.afterTaskLoadedCb(task);
    };
};

var addProjectsAndCustomers = function addProjectsAndCustomers(customers, projects) {
    return (0, _batch.batched)(function (dispatch) {
        dispatch(EntitiesActions.addCustomers(customers.map(function (c) {
            return (0, _utils3.customerFromRpc)(c);
        })));
        SyncCallbacks.updateCustomers(customers);

        dispatch(EntitiesActions.addProjects(projects.map(function (p) {
            return (0, _utils3.projectFromRpc)(p);
        })));
        SyncCallbacks.updateProjects(projects);
    });
};

var updateName = exports.updateName = function updateName(newName, prevName) {
    return function (dispatch, getState) {
        if (newName && newName !== prevName) {
            dispatch(setUpdatingState({ name: true }));
            var taskId = (0, _selectors4.getOpenTaskId)(getState());

            dispatch(updateTask(taskId, _constants.Methods.NAME, [newName], function (data) {
                var task = (0, _selectors3.getTask)(getState(), taskId);
                var updatedInfo = { name: newName };
                dispatch(updateTaskInfo(_extends({}, task, { name: newName }), updatedInfo, updatedInfo));
                dispatch(setUpdatingState({ name: false }));
                dispatch(prepareTaskDetails(data.taskDetails));
                dispatch(taskPanelActions.removeTaskPanelErrors([_constants.ValidationErrors.TASK_NAME_EMPTY, _constants.ValidationErrors.TASK_NAME_DUPLICATE]));
            }, function (error) {
                dispatch(setUpdatingState({ name: false }));
                dispatch(taskPanelActions.setTaskInfo({ name: newName }));
                if (error.textStatus === "rpc_customException") {
                    switch (error.errorThrown.exception) {
                        case "com.actimind.actitime.task.TaskExistsException":
                            dispatch(taskPanelActions.removeTaskPanelErrors([_constants.ValidationErrors.TASK_NAME_EMPTY]));
                            dispatch(taskPanelActions.addTaskPanelErrors([_constants.ValidationErrors.TASK_NAME_DUPLICATE]));
                            return true;
                    }
                }
                return false;
            }));
        } else if (!newName) {
            dispatch(taskPanelActions.setTaskInfo({ name: newName }));
            dispatch(taskPanelActions.addTaskPanelErrors([_constants.ValidationErrors.TASK_NAME_EMPTY]));
            dispatch(taskPanelActions.removeTaskPanelErrors([_constants.ValidationErrors.TASK_NAME_DUPLICATE]));
        }
    };
};

var updateDeadline = exports.updateDeadline = function updateDeadline(deadline) {
    return function (dispatch, getState) {
        dispatch(setUpdatingState({ deadline: true }));
        var taskId = (0, _selectors4.getOpenTaskId)(getState());

        dispatch(updateTask(taskId, _constants.Methods.DEADLINE, [deadline], function (data) {
            var task = (0, _selectors3.getTask)(getState(), taskId);
            var updatedInfo = { deadline: deadline };
            dispatch(updateTaskInfo(_extends({}, task, { deadline: deadline }), updatedInfo, updatedInfo));
            dispatch(prepareTaskDetails(data.taskDetails));
            dispatch(setUpdatingState({ deadline: false }));
        }, function () {
            dispatch(setUpdatingState({ deadline: false }));
            return false;
        }));
    };
};

var updateTypeOfWork = exports.updateTypeOfWork = function updateTypeOfWork(typeId) {
    return function (dispatch, getState) {
        dispatch(setUpdatingState({ typeOfWork: true }));
        var taskId = (0, _selectors4.getOpenTaskId)(getState());

        dispatch(updateTask(taskId, _constants.Methods.BILLING_TYPE, [typeId], function (data) {
            dispatch(setUpdatingState({ typeOfWork: false }));

            if (data.resultCode === _constants.ResultCodes.billingTypeNotExists) {
                alert(_messageResource2.default.getMessage("task.edit_popup.billing_type_not_exists"));
                dispatch(EntitiesActions.setTypesOfWorkList(data['billingTypes']['list']));
                return;
            }
            if (data.resultCode === _constants.ResultCodes.billingTypeIsArchived) {
                alert(_messageResource2.default.getMessage("task.edit_popup.billing_type_was_archived"));
                dispatch(EntitiesActions.setTypesOfWorkList(data['billingTypes']['list']));
                return;
            }
            if (data.resultCode === _constants.ResultCodes.billingTypeFeatureOff) {
                //feature off handled in updateTask action
                return;
            }

            var state = getState();
            var task = (0, _selectors3.getTask)(state, taskId);
            var updatedInfo = {
                typeOfWorkId: typeId
            };
            dispatch(updateTaskInfo(_extends({}, task, { typeOfWorkId: typeId }), updatedInfo, updatedInfo));
            dispatch(prepareTaskDetails(data.taskDetails));
        }, function (result) {
            dispatch(setUpdatingState({ typeOfWork: false }));

            return false;
        }));
    };
};

var updateEstimate = exports.updateEstimate = function updateEstimate(time) {
    return function (dispatch, getState) {
        dispatch(setUpdatingState({ estimate: true }));
        var taskId = (0, _selectors4.getOpenTaskId)(getState());

        dispatch(updateTask(taskId, _constants.Methods.ESTIMATED_TIME, [time], function (data) {
            _ClassicBridge2.default.getTasksAfterModification([taskId]).then(function (nextTasks) {
                dispatch(setUpdatingState({ estimate: false }));

                if (data.resultCode === _constants.ResultCodes.estimateFeatureOff) {
                    alert(_messageResource2.default.getMessage("task.list.error.estimate_off"));
                    window.location.reload();
                    return;
                }

                var updatedInfo = { estimatedTime: time };
                var task = (0, _selectors3.getTask)(getState(), taskId);

                if (nextTasks) {
                    task = (0, _utils7.mergeClassicAndNextTask)(task, nextTasks[0]);

                    updatedInfo.variance = task.variance;
                    updatedInfo.progress = task.progress;
                }

                dispatch(updateTaskInfo(_extends({}, task, { estimatedTime: time }), updatedInfo, updatedInfo));
                dispatch(prepareTaskDetails(data.taskDetails));
            });
        }, function (error) {
            dispatch(setUpdatingState({ estimate: false }));

            return false;
        }));
    };
};

var updateDescription = exports.updateDescription = function updateDescription(description) {
    return function (dispatch, getState) {
        dispatch(setUpdatingState({ description: true }));
        var taskId = (0, _selectors4.getOpenTaskId)(getState());

        dispatch(updateTask(taskId, _constants.Methods.DESCRIPTION, [description], function (data) {
            dispatch(setUpdatingState({ description: false }));
            var task = (0, _selectors3.getTask)(getState(), taskId);
            var updatedInfo = { description: description };
            dispatch(updateTaskInfo(task, updatedInfo, updatedInfo));
        }, function (error) {
            dispatch(setUpdatingState({ description: false }));
            return false;
        }));
    };
};

var updateStatus = exports.updateStatus = function updateStatus(statusId) {
    var forceReopenArchivedProject = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return function (dispatch, getState) {
        dispatch(setUpdatingState({ status: true }));
        var state = getState();
        var taskId = (0, _selectors4.getOpenTaskId)(state);

        var workflowStatusesEnabled = (0, _selectors.isTWSEnabled)(state);
        var workflowStatusBean = (0, _selectors2.selectStatusById)(state, statusId);
        var completed = workflowStatusBean.type === _constants2.WorkflowStatusType.COMPLETED;
        var method = workflowStatusesEnabled ? _constants.Methods.WORKFLOW_STATUS : _constants.Methods.STATUS;
        var params = workflowStatusesEnabled ? [workflowStatusBean.type, workflowStatusBean.id, workflowStatusBean.name, forceReopenArchivedProject] : [workflowStatusBean.type, forceReopenArchivedProject];

        dispatch(updateTask(taskId, method, params, function (data) {
            dispatch(setUpdatingState({ status: false }));
            var state = getState();
            var task = (0, _selectors3.getTask)(state, taskId);

            if (forceReopenArchivedProject) {
                dispatch(reopenProject(task.projectId, task.customerId));
            }
            var updatedInfo = {
                workflowStatusId: statusId,
                completed: completed
            };
            dispatch(updateTaskInfo(_extends({}, task, updatedInfo), updatedInfo, updatedInfo));
            dispatch(prepareTaskDetails(data.taskDetails));
            dispatch((0, _actions5.changedTaskWorkflowStatus)({ taskId: taskId, workflowStatusId: statusId, prevWorkflowStatusId: task.workflowStatusId }));
            dispatch((0, _actions4.toast)(_messageResource2.default.getMessage("status.task.toast", [task.name])));
        }, function (error) {
            dispatch(setUpdatingState({ status: false }));
            if (error.textStatus === "rpc_customException") {
                switch (error.errorThrown.exception) {
                    case _ExceptionsTypes.PROJECT_IS_ARCHIVED_EXCEPTION:
                        if (confirm(_messageResource2.default.getMessage('task.error.reopen.project_archived'))) dispatch(updateStatus(statusId, true));
                        error.handle();
                        return true;
                    case _ExceptionsTypes.TASK_CANNOT_BE_MODIFIED_EXCEPTION:
                        alert(_messageResource2.default.getMessage("common.no_rights_for_operation_anymore"));
                        window.location.reload();
                        return true;
                    case _ExceptionsTypes.WORKFLOW_STATUS_CHANGED_EXCEPTION:
                        alert(_messageResource2.default.getMessage("change_tasks_workflow_status.workflow_status_changed_error"));
                        window.location.reload();
                        return true;
                    case _ExceptionsTypes.NO_SUCH_WORKFLOW_STATUSES_EXCEPTION:
                        alert(_messageResource2.default.getMessage("change_tasks_workflow_status.no_such_workflow_status_error"));
                        window.location.reload();
                        return true;
                    case _ExceptionsTypes.WORKFLOW_STATUSES_FEATURE_BECOME_ENABLED_EXCEPTION:
                        alert(_messageResource2.default.getMessage("change_tasks_workflow_status.feature_became_enabled"));
                        window.location.reload();
                        return true;
                    case _ExceptionsTypes.WORKFLOW_STATUSES_FEATURE_BECAME_DISABLED_EXCEPTION:
                        alert(_messageResource2.default.getMessage("change_tasks_workflow_status.feature_became_disabled"));
                        window.location.reload();
                        return true;
                }
            }
            return false;
        }));
    };
};

var moveTask = exports.moveTask = function moveTask(customer, project, forceReopen, newWorkflowStatusId, onTaskMovedCb) {
    return function (dispatch, getState) {
        dispatch(setUpdatingState({ moveToDialog: true }));
        var state = getState();
        var taskId = (0, _selectors4.getOpenTaskId)(state);

        dispatch(updateTask(taskId, _constants.Methods.MOVE_TASK, [forceReopen, newWorkflowStatusId, project.id], function (data) {
            var state = getState();
            var task = (0, _selectors3.getTask)(state, taskId);
            var taskName = task.name;
            var projectName = project.name;
            SyncCallbacks.afterTaskMovedCb(project, customer);

            var updatedInfo = { projectId: project.id, customerId: customer.id };
            dispatch(updateTaskInfo(_extends({}, task, updatedInfo), updatedInfo, updatedInfo));
            dispatch(prepareTaskDetails(data.taskDetails));
            onTaskMovedCb(taskId);
            dispatch((0, _actions3.reloadTasks)());

            dispatch((0, _actions4.toast)(_messageResource2.default.getMessage('move.task.toast', [taskName, projectName])));

            if (forceReopen) {
                if (customer.archived) {
                    dispatch((0, _actions4.toast)(_messageResource2.default.getMessage("status.customer.restored.toast", [customer.name])));
                }
                dispatch((0, _actions4.toast)(_messageResource2.default.getMessage("status.project.restored.toast", [projectName])));
            } else if (!task.completed && (customer.archived || project.archived)) {
                dispatch((0, _actions4.toast)(_messageResource2.default.getMessage("status.task.completed.toast", [taskName])));
            }

            if (data.taskDetails.task.name !== task.name) dispatch((0, _actions4.toast)(_messageResource2.default.getMessage('move.task.duplicate_name.toast')));

            dispatch(setUpdatingState({ moveToDialog: false }));
        }, function (error) {
            dispatch(setUpdatingState({ moveToDialog: false }));
            if (error.textStatus === "rpc_customException") {
                var exception = error.errorThrown.exception;
                switch (exception) {
                    case _ExceptionsTypes.NO_RIGHT_TO_EDIT_HIERARCHY_EXCEPTION:
                        alert(_messageResource2.default.getMessage("task.error.move.no_manage_scope_right"));
                        window.location.reload();
                        return true;
                    case _ExceptionsTypes.TASK_IS_NOT_ASSIGNED_TO_USER_EXCEPTION:
                    case _ExceptionsTypes.TASK_UNAVAILABLE_EXCEPTION:
                        alert(_messageResource2.default.getMessage("task.error.move.task_not_assigned"));
                        window.location.reload();
                        return true;
                    case _ExceptionsTypes.NO_SUCH_TASK_EXCEPTION:
                        alert(_messageResource2.default.getMessage("task.error.move.task_deleted"));
                        window.location.reload();
                        return true;
                    case _ExceptionsTypes.NO_SUCH_PROJECT_EXCEPTION:
                        alert(_messageResource2.default.getMessage("task.error.move.project_not_exists"));
                        EntitiesActions.removeProject(project.id);
                        SyncCallbacks.onProjectDeleted(project.id); //todo koshik on some interfaces removal of project will not be displayed until the page is reloaded
                        return true;
                    case _ExceptionsTypes.PROJECT_IS_NOT_AVAILABLE_EXCEPTION:
                        alert(_messageResource2.default.getMessage("task.error.move.project_not_available"));
                        EntitiesActions.removeProject(project.id);
                        SyncCallbacks.onProjectDeleted(project.id);
                        return true;
                    case _ExceptionsTypes.PROJECT_IS_NOT_ASSIGNED_EXCEPTION:
                        alert(_messageResource2.default.getMessage("task.error.move.project_not_available"));
                        return true;
                    case _ExceptionsTypes.PROJECT_IS_ARCHIVED_EXCEPTION:
                        if (!project.archived) alert(_messageResource2.default.getMessage("task.list.error.project_archived.single"));else alert(_messageResource2.default.getMessage("task.error.move.task_reopened.single"));
                        window.location.reload();
                        return true;
                    case _ExceptionsTypes.CUSTOMER_UNAVAILABLE_EXCEPTION:
                        alert(_messageResource2.default.getMessage("task.error.move.customer_not_available"));
                        return true;
                    case _ExceptionsTypes.NO_SUCH_CUSTOMER_EXCEPTION:
                        alert(_messageResource2.default.getMessage("task.error.move.customer_deleted"));
                        window.location.reload();
                        return true;
                    case _ExceptionsTypes.NO_SUCH_WORKFLOW_STATUSES_EXCEPTION:
                        alert(_messageResource2.default.getMessage("change_tasks_workflow_status.no_such_workflow_status_error"));
                        window.location.reload();
                        return true;
                    case _ExceptionsTypes.ACTIVE_TASKS_PROJECT_IS_ARCHIVED_EXCEPTION:
                        alert(_messageResource2.default.getMessage("task.error.move.only_active_project"));
                        window.location.reload();
                        return true;
                    case _ExceptionsTypes.TASK_EXISTS_EXCEPTION:
                        alert(_messageResource2.default.getMessage("task.error.task_with_same_name_exists"));
                        return true;
                    default:
                        return false;
                }
            }
            return false;
        }));
    };
};

var copyTask = exports.copyTask = function copyTask(customerId, projectId, settings) {
    return function (dispatch, getState) {
        var state = getState();
        var taskId = (0, _selectors4.getOpenTaskId)(state);

        (0, _rpcCalls2.default)(_constants.Methods.COPY_TASK, [taskId, projectId, (0, _actions6.separateTaskCopySettings)(settings)], _utils4.copyTaskRpcErrorHandler).then(function (data) {
            if (data['enabledFeatures']) {
                dispatch(FeaturesActions.setEnabledFeatures((0, _atUtils.arrayToSet)(data['enabledFeatures'])));
            }
            var state = getState();
            var task = (0, _selectors3.getTask)(state, taskId);
            var project = (0, _selectors3.getProject)(state, projectId);
            var taskName = task.name;
            var projectName = project.name;

            dispatch((0, _actions3.reloadTasks)());

            dispatch((0, _actions4.toast)(_messageResource2.default.getMessage('copy.task.toast', [taskName, projectName])));

            if (data.taskDetails.task.name !== task.name) dispatch((0, _actions4.toast)(_messageResource2.default.getMessage('copy.task.duplicate_name.toast')));
        }).catch(function (err) {
            switch (err.getException()) {
                case _ExceptionsTypes.NO_RIGHT_TO_EDIT_HIERARCHY_EXCEPTION:
                    alert(_messageResource2.default.getMessage("task.error.copy.no_manage_scope_right"));
                    window.location.reload();
                    break;
                case _ExceptionsTypes.TASK_IS_NOT_ASSIGNED_TO_USER_EXCEPTION:
                    alert(_messageResource2.default.getMessage("task.error.copy.task_not_assigned"));
                    window.location.reload();
                    break;
                case _ExceptionsTypes.PROJECT_IS_NOT_AVAILABLE_EXCEPTION:
                    alert(_messageResource2.default.getMessage("task.error.copy.project_not_available"));
                    window.location.reload();
                    break;
                case _ExceptionsTypes.NO_SUCH_TASK_EXCEPTION:
                    alert(_messageResource2.default.getMessage("task.error.copy.task_deleted"));
                    window.location.reload();
                    break;
                case _ExceptionsTypes.NO_SUCH_PROJECT_EXCEPTION:
                    alert(_messageResource2.default.getMessage("task.error.copy.project_not_exists"));
                    window.location.reload();
                    break;
                case _ExceptionsTypes.PROJECT_IS_ARCHIVED_EXCEPTION:
                    alert(_messageResource2.default.getMessage("task.error.copy.project_archived"));
                    window.location.reload();
                    break;
            }
        });
    };
};

var deleteTask = exports.deleteTask = function deleteTask(revokeStatuses) {
    return function (dispatch, getState) {
        var state = getState();
        var taskId = (0, _selectors4.getOpenTaskId)(state);
        var taskName = (0, _selectors4.getTaskName)(state);

        (0, _rpcCalls2.default)(_constants.Methods.DELETE_TASK, [taskId, revokeStatuses], function (errorThrown) {
            return dispatch(handleDeleteException(taskId, errorThrown));
        }).then(function () {
            dispatch(setTaskDeletedSuccessfully());
            dispatch(closeEditTaskPanel(taskId));

            dispatch(EntitiesActions.removeTask(taskId));
            SyncCallbacks.afterTaskDeleted(taskId);

            dispatch((0, _actions4.toast)(_messageResource2.default.getMessage("delete.tasks.toast.singular", [taskName])));
        });
    };
};

var loadTaskAuditHistory = exports.loadTaskAuditHistory = function loadTaskAuditHistory(limit, recordsLength) {
    return function (dispatch, getState) {
        var state = getState();
        var taskId = (0, _selectors4.getOpenTaskId)(state);

        if (!(0, _selectors4.isAuditHistoryLoading)(state)) {
            dispatch(setAuditHistoryInfo({
                auditHistoryLoading: true
            }));

            (0, _rpcCalls2.default)(_constants.Methods.GET_AUDIT_RECORDS, [taskId, limit, recordsLength]).then(function (result) {
                dispatch(setAuditHistoryInfo({
                    allAuditHistoryLoaded: result['auditActions'].list.length < limit,
                    auditDependencies: result['dependencies'].list,
                    auditHistoryLoading: false
                }));
                if (recordsLength > 0) {
                    dispatch(addAuditHistory((0, _utils.resolveAuditActions)(result['auditActions'].list, result['dependencies'].list, _constants5.AuditEntityTypes['TASK'])));
                } else {
                    dispatch(setAuditHistory((0, _utils.resolveAuditActions)(result['auditActions'].list, result['dependencies'].list, _constants5.AuditEntityTypes['TASK'])));
                }
            });
        }
    };
};

var handleDeleteException = function handleDeleteException(taskId, error) {
    return function (dispatch) {
        var message = null;
        if (error.errorThrown.exception === "com.actimind.actitime.task.NoPermissionToModifyTTOfSpecifiedUsers") {
            message = _messageResource2.default.getMessage("hierarchy_entity.edit_popup.cannot_delete_due_to_unavailable_modify_time", [_messageResource2.default.getMessage("common.task")]);
        } else if (error.errorThrown.exception === "com.actimind.actitime.task.TaskHasLockedTTException") {
            message = _messageResource2.default.getMessage("task.edit_popup.cannot_delete_due_to_lock_time");
        } else if (error.errorThrown.exception === "java.lang.IllegalArgumentException") {
            message = _messageResource2.default.getMessage("task.edit_popup.footer_error.invalid_fields_sent_to_server");
        }

        if (message !== null) {
            alert(message);
            dispatch(setTaskDeletedUnsuccessfully());
            // panel.header.actions.disableDeleteButton(message); //todo koshik
            return true;
        }

        return false;
    };
};

var reopenProject = function reopenProject(projectId, customerId) {
    return function (dispatch, getState) {
        var state = getState();
        var project = (0, _selectors3.getProject)(state, projectId);
        var customer = (0, _selectors3.getCustomer)(state, customerId);

        dispatch(EntitiesActions.addCustomer(_extends({}, customer, {
            archived: false
        })));

        dispatch(EntitiesActions.addProject(_extends({}, project, {
            archived: false
        })));
    };
};

var updateTask = function updateTask(taskId, method, params) {
    var dataHandler = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function () {};
    var errorHandler = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : function () {};
    return function (dispatch, getState) {
        (0, _rpcCalls2.default)(method, [taskId].concat(_toConsumableArray(params)), function (error) {
            if ((0, _rpcUtils.isAborted)(error)) return true;
            return errorHandler(error) || commonErrorHandler(taskId, error, getState, dispatch);
        }).then(function (data) {
            if (data['enabledFeatures']) {
                dispatch(FeaturesActions.setEnabledFeatures((0, _atUtils.arrayToSet)(data['enabledFeatures'])));
            }
            dispatch(setFakeLastUpdateAuditAction());
            dataHandler(data);
        }).catch(function (error) {
            if ((0, _rpcUtils.isAborted)(error) || error.handled) return;
            console.log(error);
        });
    };
};

var commonErrorHandler = function commonErrorHandler(taskId, error, getState, dispatch) {
    if ((0, _rpcUtils.isAborted)(error)) return true;

    if ((0, _selectors4.isPanelOpenedFromUrl)(getState()) && [_ExceptionsTypes.NO_SUCH_TASK_EXCEPTION, _ExceptionsTypes.TASK_IS_NOT_ASSIGNED_TO_USER_EXCEPTION].includes(error.getException())) {
        dispatch(closeEditTaskPanel(taskId));
        dispatch((0, _actions4.warning)(_messageResource2.default.getMessage('task.edit_panel.cannot_viewed_from_url')));
        error.handle();
        return true;
    }

    if (error.errorThrown.exception === _ExceptionsTypes.NO_SUCH_TASK_EXCEPTION) {
        alert(_messageResource2.default.getMessage("task.error.concurrently_deleted.cannot_edit"));
        handleTaskIsNotAvailableError(taskId, dispatch);
        error.handle();
    }

    if (error.errorThrown.exception === _ExceptionsTypes.NO_RIGHTS_TO_MANAGE_TASK_EXCEPTION) {
        alert(_messageResource2.default.getMessage("task.edit_popup.no_rights_to_manage_tasks"));
        dispatch(closeEditTaskPanel(taskId));
        error.handle();
    }

    if (error.errorThrown.exception === _ExceptionsTypes.TASK_IS_NOT_ASSIGNED_TO_USER_EXCEPTION) {
        alert(_messageResource2.default.getMessage("task.error.task_not_assigned"));
        handleTaskIsNotAvailableError(taskId, dispatch);
        error.handle();
    }

    if (error.errorThrown.exception === _ExceptionsTypes.NO_RIGHT_TO_EDIT_HIERARCHY_EXCEPTION) {
        alert(_messageResource2.default.getMessage('common.no_rights_for_operation_anymore'));
        window.location.reload();
        error.handle();
    }

    return error.isHandled();
};

var updateTaskInfo = function updateTaskInfo(task, updatedTaskInfo) {
    var storeUpdatedInfo = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    return function (dispatch) {
        SyncCallbacks.afterTaskUpdateCb(task.id, storeUpdatedInfo);
        dispatch(taskPanelActions.setTaskInfo(updatedTaskInfo));
        dispatch(EntitiesActions.addTask(task));
    };
};

var commentsActions = exports.commentsActions = (0, _actionsGenerator6.default)({
    actionTypes: ActionTypes
});

var updateCommentsCountSuccess = function updateCommentsCountSuccess(taskId, commentsInfo) {
    return function (dispatch, getState) {
        var task = (0, _selectors3.getTask)(getState(), taskId);
        var updatedInfo = { commentsNumber: commentsInfo.commentsCount };
        dispatch(updateTaskInfo(_extends({}, task, { commentsNumber: commentsInfo.commentsCount }), updatedInfo, updatedInfo));
    };
};

var commentsServiceActions = (0, _commentsActionsGenerator2.default)({
    actions: _extends({}, commentsActions, {
        updateCommentsCountSuccess: updateCommentsCountSuccess
    }),
    selectors: _extends({}, selectors, {
        getOpenEntityId: selectors.getOpenTaskId
    }),
    handleServiceError: function handleServiceError(taskId, error, dispatch) {
        return _handleServiceError(taskId, error, dispatch);
    },
    entityType: _constants3.EntityType.TASK
});

var loadMoreComments = exports.loadMoreComments = commentsServiceActions.loadMoreComments;
var saveComment = exports.saveComment = commentsServiceActions.saveComment;
var deleteComment = exports.deleteComment = commentsServiceActions.deleteComment;
var startEditComment = exports.startEditComment = commentsServiceActions.startEditComment;
var saveEditingComment = exports.saveEditingComment = commentsServiceActions.saveEditingComment;
var toggleNewCommentInput = exports.toggleNewCommentInput = commentsServiceActions.toggleNewCommentInput;
var reloadComments = exports.reloadComments = commentsServiceActions.reloadComments;

var updateNewCommentText = exports.updateNewCommentText = function updateNewCommentText(text) {
    return function (dispatch, getState) {
        var state = getState();
        var taskId = (0, _selectors4.getOpenTaskId)(state);
        if (text !== '') {
            dispatch(commentsActions.setNewComment({ entityId: taskId, text: text }));
        } else {
            dispatch(commentsActions.removeNewComment(taskId));
        }
        dispatch(commentsServiceActions.saveEntityNewCommentsTextsInLocalStorage());
    };
};

var openLastTaskPanelTab = exports.openLastTaskPanelTab = function openLastTaskPanelTab() {
    return function (dispatch, getState) {
        var state = getState();
        var lastTaskPanelTabKey = (0, _selectors4.getLastTaskPanelTabKey)(state);
        dispatch(setTaskPanelTab(lastTaskPanelTabKey));
    };
};

var _handleServiceError = function _handleServiceError(taskId, error, dispatch) {
    if (error.getTextStatus() === 'rpc_customException') {
        switch (error.getErrorThrown().exception) {
            case 'com.actimind.actitime.services.impl.comments.NoSuchEntityException':
                alert(_messageResource2.default.getMessage('task.error.concurrently_deleted.cannot_edit'));
                handleTaskIsNotAvailableError(taskId, dispatch);
                return true;
            case 'com.actimind.actitime.services.impl.comments.EntityNotAssignedException':
                alert(_messageResource2.default.getMessage('common.no_rights_for_operation_anymore'));
                handleTaskIsNotAvailableError(taskId, dispatch);
                return true;
            case 'com.actimind.actitime.services.NoRightToEditHierarchyException':
                alert(_messageResource2.default.getMessage('common.no_rights_for_operation_anymore'));
                window.location.reload();
                return true;
            case 'com.actimind.actitime.services.impl.comments.NoSuchCommentException':
                alert(_messageResource2.default.getMessage('panel.common.comments.comment_concurrently_deleted'));
                return true;
        }
    }
    return false;
};

var handleTaskIsNotAvailableError = function handleTaskIsNotAvailableError(taskId, dispatch) {
    dispatch((0, _actions.removeTask)(taskId));
    dispatch(closeEditTaskPanel(taskId));
    SyncCallbacks.afterTaskDeleted(taskId);
};

var loadEditTaskPanelData = exports.loadEditTaskPanelData = loadEditTaskPanelDataAction(commonErrorHandler);

var copyLinkTo = exports.copyLinkTo = function copyLinkTo() {
    return function (dispatch, getState) {
        var taskId = (0, _selectors4.getOpenTaskId)(getState());
        (0, _atBrowserUtils.copyToClipboard)((0, _utils5.createLinkToTask)(taskId), function () {
            dispatch((0, _actions4.toast)(_messageResource2.default.getMessage('panel.common.link_copied')));
        });
    };
};

var updateCustomField = exports.updateCustomField = function updateCustomField(fieldName, value) {
    return function (dispatch, getState) {
        var taskId = (0, _selectors4.getOpenTaskId)(getState());
        var task = (0, _selectors3.getTask)(getState(), taskId);
        dispatch(updateCustomFieldsValues(_defineProperty({}, fieldName, value)));
        _ClassicBridge2.default.patchTaskCustomField(task.nextId, fieldName, value).then(function () {
            var updatedData = {
                id: taskId,
                customFieldsValues: _extends({}, task.customFieldsValues, _defineProperty({}, fieldName, value))
            };
            dispatch(EntitiesActions.addTask(updatedData));
            SyncCallbacks.afterTaskUpdateCb(taskId, updatedData);
        });
    };
};

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.thereAreTableTasks = exports.getLoadedTaskIds = exports.getVisibleTableTaskIds = exports.getArchivedCustomerIds = exports.getArchivedProjectIds = exports.isNeedToReloadTasks = exports.isSummaryRowLoaded = exports.isLoaded = exports.isInitialDataLoaded = exports.getTasksSorting = exports.getShownColumnsWithOrderForCsv = exports.getShownColumnsWithOrder = exports.getOrderedColumns = exports.getConfigurableTableColumns = exports.getSummaryRow = exports.getIsSummaryRowShown = exports.getShownColumns = exports.getColumnsOrder = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reselect = __webpack_require__(13);

var _selectors = __webpack_require__(189);

var _selectors2 = __webpack_require__(27);

var _constants = __webpack_require__(44);

var _index = __webpack_require__(22);

var _selectors3 = __webpack_require__(14);

var _atUtils = __webpack_require__(5);

var _TaskManagementStore = __webpack_require__(140);

var _TaskManagementStore2 = _interopRequireDefault(_TaskManagementStore);

var _selectors4 = __webpack_require__(15);

var _selectors5 = __webpack_require__(190);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getTaskTableState = function getTaskTableState(state) {
    return (0, _selectors.selectTaskManagement)(state).taskTable;
};

var getColumnsOrder = exports.getColumnsOrder = function getColumnsOrder(state) {
    return getTaskTableState(state).columnsOrder;
};

var getShownColumns = exports.getShownColumns = function getShownColumns(state) {
    return getTaskTableState(state).columnsShown;
};

var getIsSummaryRowShown = exports.getIsSummaryRowShown = function getIsSummaryRowShown(state) {
    return getTaskTableState(state).isSummaryRowShown;
};
var getSummaryRow = exports.getSummaryRow = function getSummaryRow(state) {
    return getTaskTableState(state).summaryRow;
};

var getConfigurableTableColumns = exports.getConfigurableTableColumns = (0, _reselect.createSelector)(_selectors4.isESTEnabled, _selectors4.isBTYEnabled, _selectors2.getTaskCustomFieldsMap, function (isESTEnabled, isBTYEnabled, customFieldsMap) {
    var estimateRelatedColumns = [_constants.TaskTableConfigurableColumns.ESTIMATE, _constants.TaskTableConfigurableColumns.VARIANCE_MAN_HOURS, _constants.TaskTableConfigurableColumns.VARIANCE_PERCENTS, _constants.TaskTableConfigurableColumns.VARIANCE_PROGRESS_BAR];

    var predefined = Object.keys(_constants.TaskTableConfigurableColumns).filter(function (column) {
        return !(estimateRelatedColumns.includes(column) && !isESTEnabled || column === _constants.TaskTableConfigurableColumns.TYPE_OF_WORK && !isBTYEnabled);
    });
    Object.values(customFieldsMap).map(function (cf) {
        return cf.fieldName;
    }).forEach(function (column) {
        predefined.push(column);
    });
    return predefined;
});

var getOrderedColumns = exports.getOrderedColumns = (0, _reselect.createSelector)(getConfigurableTableColumns, getColumnsOrder, function (columns, order) {
    return columns.slice().sort(function (c1, c2) {
        return order.indexOf(c1) - order.indexOf(c2);
    });
});

var getShownColumnsWithOrder = exports.getShownColumnsWithOrder = (0, _reselect.createSelector)(getOrderedColumns, getShownColumns, function (columns, shown) {
    var shownSet = (0, _atUtils.arrayToSet)(shown);
    return columns.filter(function (column) {
        return !!shownSet[column];
    });
});

var getShownColumnsWithOrderForCsv = exports.getShownColumnsWithOrderForCsv = (0, _reselect.createSelector)(getShownColumnsWithOrder, function (columns) {
    return columns.filter(function (column) {
        return column !== _constants.TaskSortBy.VARIANCE_PROGRESS_BAR;
    });
});

var getTasksSorting = exports.getTasksSorting = (0, _reselect.createSelector)(getTaskTableState, function (taskTable) {
    var sorting = taskTable.sorting;
    if ((0, _index.isEnabled)(_index.Feature.TWS) && sorting.by === _constants.TaskSortBy.STATUS) {
        return _extends({}, sorting, {
            by: _constants.TaskSortBy.WORKFLOW_STATUS
        });
    }

    if (!(0, _index.isEnabled)(_index.Feature.TWS) && sorting.by === _constants.TaskSortBy.WORKFLOW_STATUS) {
        return _extends({}, sorting, {
            by: _constants.TaskSortBy.STATUS
        });
    }

    return sorting;
});

var isInitialDataLoaded = exports.isInitialDataLoaded = (0, _reselect.createSelector)(_selectors5.selectTaskCustomFieldsIsLoaded, _selectors2.getNextWorkflowStatusesIsLoaded, function (isTaskCustomFieldsLoaded, isNextWorkflowStatusesLoaded) {
    return isTaskCustomFieldsLoaded && isNextWorkflowStatusesLoaded;
});

var isLoaded = exports.isLoaded = function isLoaded(state) {
    return getTaskTableState(state).isLoaded;
};

var isSummaryRowLoaded = exports.isSummaryRowLoaded = function isSummaryRowLoaded(state) {
    return getTaskTableState(state).isSummaryRowLoaded;
};

var isNeedToReloadTasks = exports.isNeedToReloadTasks = (0, _reselect.createSelector)(_selectors2.getViewMode, isLoaded, isInitialDataLoaded, function (viewMode, isLoaded, isInitialDataLoaded) {
    return viewMode === _constants.TaskManagementViewMode.TABLE && isLoaded === false && isInitialDataLoaded;
});

var getArchivedProjectIds = exports.getArchivedProjectIds = (0, _reselect.createSelector)(_selectors3.getProjects, function (projects) {
    return (0, _atUtils.arrayToSet)(Object.values(projects).filter(function (p) {
        return p.archived;
    }).map(function (p) {
        return p.id;
    }));
});

var getArchivedCustomerIds = exports.getArchivedCustomerIds = (0, _reselect.createSelector)(_selectors3.getCustomers, function (customers) {
    return (0, _atUtils.arrayToSet)(Object.values(customers).filter(function (c) {
        return c.archived;
    }).map(function (c) {
        return c.id;
    }));
});

/**
 * @Deprecated but used in many places
 */
var getVisibleTableTaskIds = exports.getVisibleTableTaskIds = function getVisibleTableTaskIds() {
    return _TaskManagementStore2.default.getTaskIds();
};

/**
 * Like `getVisibleTableTaskIds` but used only for SelectionController
 */
var getLoadedTaskIds = exports.getLoadedTaskIds = (0, _reselect.createSelector)(getTaskTableState, function (taskTableState) {
    return taskTableState.loadedTaskIds;
});

var thereAreTableTasks = exports.thereAreTableTasks = (0, _reselect.createSelector)(getLoadedTaskIds, function (taskIds) {
    return taskIds.length !== 0;
});

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _constants = __webpack_require__(508);

var _CustomSelector2 = __webpack_require__(1413);

var _CustomSelector3 = _interopRequireDefault(_CustomSelector2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CustomCheckbox = function (_CustomSelector) {
    _inherits(CustomCheckbox, _CustomSelector);

    function CustomCheckbox(props) {
        _classCallCheck(this, CustomCheckbox);

        return _possibleConstructorReturn(this, (CustomCheckbox.__proto__ || Object.getPrototypeOf(CustomCheckbox)).call(this, _extends({
            type: _constants.CustomSelectorType.CHECKBOX
        }, props)));
    }

    return CustomCheckbox;
}(_CustomSelector3.default);

exports.default = CustomCheckbox;

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _StateComponent2 = __webpack_require__(105);

var _StateComponent3 = _interopRequireDefault(_StateComponent2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DescriptionStrategy = function (_StateComponent) {
    _inherits(DescriptionStrategy, _StateComponent);

    function DescriptionStrategy() {
        _classCallCheck(this, DescriptionStrategy);

        return _possibleConstructorReturn(this, (DescriptionStrategy.__proto__ || Object.getPrototypeOf(DescriptionStrategy)).apply(this, arguments));
    }

    _createClass(DescriptionStrategy, [{
        key: 'getHeader',
        value: function getHeader() {
            return '';
        }
    }, {
        key: 'getDescription',
        value: function getDescription() {
            return '';
        }
    }, {
        key: 'getGenerateCallback',
        value: function getGenerateCallback() {
            return function () {};
        }
    }, {
        key: 'getDetailsCallback',
        value: function getDetailsCallback() {
            return function () {};
        }
    }]);

    return DescriptionStrategy;
}(_StateComponent3.default);

exports.default = DescriptionStrategy;

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.validateFile = exports.convertEffectiveDateInWorkSchedule = exports.createYearsListForSelector = exports.sortHolidaysArray = exports.getSortedArrayFromObjectByName = exports.getSortedArrayFromObjectByDate = exports.MonthIterator = exports.DayIteratorWithWorkSchedule = exports.DatesIterator = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.getMonthNameKey = getMonthNameKey;
exports.getAbbrDayNameKey = getAbbrDayNameKey;
exports.getShortDayNameKey = getShortDayNameKey;
exports.isSameDate = isSameDate;
exports.isSameMonth = isSameMonth;
exports.dateWithoutTime = dateWithoutTime;
exports.createHolidayListObject = createHolidayListObject;

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _constants = __webpack_require__(116);

var _LocalStorage = __webpack_require__(72);

var _atUtils = __webpack_require__(5);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function getMonthNameKey(monthNum) {
    return _constants.MONTH_NAME_KEYS[monthNum];
}

function getAbbrDayNameKey(dayNum) {
    return _constants.ABBR_DAY_NAME_KEYS[dayNum];
}

function getShortDayNameKey(dayNum) {
    return _constants.SHORT_DAY_NAME_KEYS[dayNum];
}

function isSameDate(d1, d2) {
    return d1.getDate() === d2.getDate() && d1.getMonth() === d2.getMonth() && d1.getFullYear() === d2.getFullYear();
}

function isSameMonth(d1, d2) {
    return d1.getMonth() === d2.getMonth() && d1.getFullYear() === d2.getFullYear();
}

function dateWithoutTime(date) {
    var d = new Date(date);
    d.setHours(0, 0, 0, 0);
    return d;
}

function getWorkScheduleNumForDate(date, workSchedules) {
    return _underscore2.default.findLastIndex(workSchedules, function (ws) {
        return ws.effectiveDate <= date;
    });
}

var DatesIterator = exports.DatesIterator = function () {
    function DatesIterator(dateFrom, dateTo) {
        _classCallCheck(this, DatesIterator);

        this.yFrom = dateFrom.getFullYear();
        this.mFrom = dateFrom.getMonth();
        this.dFrom = dateFrom.getDate();
        this.nextDate = Date.create(this.yFrom, this.mFrom, this.dFrom);
        this.dateTo = dateTo != null ? dateTo.truncateTime() : null;
    }

    _createClass(DatesIterator, [{
        key: 'next',
        value: function next() {
            var result = this.nextDate;
            this.dFrom++;
            this.nextDate = Date.create(this.yFrom, this.mFrom, this.dFrom);
            return result;
        }
    }, {
        key: 'hasNext',
        value: function hasNext() {
            return this.dateTo && this.nextDate <= this.dateTo;
        }
    }]);

    return DatesIterator;
}();

var DayIteratorWithWorkSchedule = exports.DayIteratorWithWorkSchedule = function (_DatesIterator) {
    _inherits(DayIteratorWithWorkSchedule, _DatesIterator);

    function DayIteratorWithWorkSchedule(dateFrom, dateTo, workSchedules) {
        _classCallCheck(this, DayIteratorWithWorkSchedule);

        var _this = _possibleConstructorReturn(this, (DayIteratorWithWorkSchedule.__proto__ || Object.getPrototypeOf(DayIteratorWithWorkSchedule)).call(this, dateFrom, dateTo));

        _this.nextDate = Date.create(_this.yFrom, _this.mFrom, _this.dFrom);
        _this.effectiveScheduleNum = getWorkScheduleNumForDate(dateFrom, workSchedules);
        _this.workSchedules = workSchedules;
        return _this;
    }

    _createClass(DayIteratorWithWorkSchedule, [{
        key: 'next',
        value: function next() {
            if (this.workSchedules[this.effectiveScheduleNum + 1] && isSameDate(this.nextDate, this.workSchedules[this.effectiveScheduleNum + 1].effectiveDate)) {
                this.effectiveScheduleNum++;
            }
            var nonWorking = this.workSchedules[this.effectiveScheduleNum].dayDurations[this.nextDate.getDay()] === 0;
            var result = {
                date: this.nextDate,
                nonWorking: nonWorking
            };
            this.dFrom++;
            this.nextDate = Date.create(this.yFrom, this.mFrom, this.dFrom);
            return result;
        }
    }]);

    return DayIteratorWithWorkSchedule;
}(DatesIterator);

var MonthIterator = exports.MonthIterator = function () {
    function MonthIterator(dateFrom, dateTo) {
        _classCallCheck(this, MonthIterator);

        this.yFrom = dateFrom.getFullYear();
        this.mFrom = dateFrom.getMonth();
        this.nextDate = new Date(this.yFrom, this.mFrom);
        this.dateTo = dateTo;
    }

    _createClass(MonthIterator, [{
        key: 'next',
        value: function next() {
            var result = this.nextDate;
            this.mFrom++;
            this.nextDate = new Date(this.yFrom, this.mFrom);
            return result;
        }
    }, {
        key: 'hasNext',
        value: function hasNext() {
            return this.dateTo && this.nextDate <= this.dateTo;
        }
    }]);

    return MonthIterator;
}();

function createHolidayListObject(key, value) {
    return {
        date: key,
        name: value.name
    };
}

var getSortedArrayFromObjectByDate = exports.getSortedArrayFromObjectByDate = function getSortedArrayFromObjectByDate(object, isAsc) {
    var sortedKeys = Object.keys(object).sort(function (a, b) {
        return isAsc ? ascSort(a, b) : descSort(a, b);
    });

    return (0, _atUtils.createArrayOfObjectFromMap)(object, createHolidayListObject, sortedKeys);
};

var getSortedArrayFromObjectByName = exports.getSortedArrayFromObjectByName = function getSortedArrayFromObjectByName(object, isAsc) {
    var sortedKeys = Object.keys(object).sort(function (a, b) {
        return isAsc ? ascSort(object[a].name.toLowerCase(), object[b].name.toLowerCase()) : descSort(object[a].name.toLowerCase(), object[b].name.toLowerCase());
    });

    return (0, _atUtils.createArrayOfObjectFromMap)(object, createHolidayListObject, sortedKeys);
};

var sortHolidaysArray = exports.sortHolidaysArray = function sortHolidaysArray(array, isAsc) {
    return array.sort(function (a, b) {
        return isAsc ? ascSort(a.date, b.date) : descSort(a.date, b.date);
    });
};

var ascSort = function ascSort(a, b) {
    return a > b ? -1 : a < b ? 1 : 0;
};

var descSort = function descSort(a, b) {
    return a < b ? -1 : a > b ? 1 : 0;
};

var createYearsListForSelector = exports.createYearsListForSelector = function createYearsListForSelector(yearFrom, yearTo) {
    var list = [];

    for (var i = yearFrom; i <= yearTo; i++) {
        list.push({ year: i });
    }

    return list.reverse();
};

var convertEffectiveDateInWorkSchedule = exports.convertEffectiveDateInWorkSchedule = function convertEffectiveDateInWorkSchedule(workSchedules) {
    workSchedules.forEach(function (schedule) {
        schedule['effectiveDate'] = new Date(schedule.effectiveDate);
    });

    return workSchedules;
};

var validateFile = exports.validateFile = function validateFile(file) {
    if (file.size === 0 || !!file.type && file.type !== 'text/calendar' || file.name.split('.')[1] !== 'ics') {
        return _messageResource2.default.getMessage('work_schedule.ical_load_file_filed');
    }

    return null;
};

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _PageOverlayTipsManager = __webpack_require__(408);

var _PageOverlayTipsManager2 = _interopRequireDefault(_PageOverlayTipsManager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OverlayTips = {
    DIRECTION_TOP_LEFT: 5,
    DIRECTION_TOP_RIGHT: 6,
    DIRECTION_BOTTOM_LEFT: 9,
    DIRECTION_BOTTOM_RIGHT: 10,

    _ANCHOR_LEFT: 1,
    _ANCHOR_RIGHT: 2,
    _ANCHOR_TOP: 4,
    _ANCHOR_BOTTOM: 8,

    _idSequence: 0,
    _initialized: false,

    /**
     * Initializes overlay tips system. Runs only one time.
     * @private
     */
    init: function init() {
        if (!this._initialized) {
            // Reposition on window resize
            (0, _jquery2.default)(window).resizeThrottle(this._repositionOutsideTips, 100);
            this._initialized = true;
        }
    },

    _repositionOutsideTips: function _repositionOutsideTips() {
        _PageOverlayTipsManager2.default.getInstance().repositionOutsideTips();
    }
};

exports.default = OverlayTips;

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(46);
var createDesc = __webpack_require__(173);
module.exports = __webpack_require__(47) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 88 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(273);
var defined = __webpack_require__(151);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(274);
var createDesc = __webpack_require__(173);
var toIObject = __webpack_require__(89);
var toPrimitive = __webpack_require__(131);
var has = __webpack_require__(75);
var IE8_DOM_DEFINE = __webpack_require__(606);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(47) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _EntityWithIdStore = __webpack_require__(342);

var _EntityWithIdStore2 = _interopRequireDefault(_EntityWithIdStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TaskStore = new _EntityWithIdStore2.default();
exports.default = TaskStore;


window.TaskStore = TaskStore;

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _SpinnerController = __webpack_require__(69);

var _SpinnerController2 = _interopRequireDefault(_SpinnerController);

var _spin = __webpack_require__(93);

var _spin2 = _interopRequireDefault(_spin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LoadingMoire = function (_TemplateView) {
    _inherits(LoadingMoire, _TemplateView);

    function LoadingMoire() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            _ref$additionalClass = _ref.additionalClass,
            additionalClass = _ref$additionalClass === undefined ? '' : _ref$additionalClass,
            additionalSpinnerSettings = _ref.additionalSpinnerSettings,
            _ref$showAnimated = _ref.showAnimated,
            showAnimated = _ref$showAnimated === undefined ? true : _ref$showAnimated,
            _ref$hideAnimated = _ref.hideAnimated,
            hideAnimated = _ref$hideAnimated === undefined ? true : _ref$hideAnimated,
            delay = _ref.delay,
            _ref$innerContent = _ref.innerContent,
            innerContent = _ref$innerContent === undefined ? null : _ref$innerContent;

        _classCallCheck(this, LoadingMoire);

        var _this = _possibleConstructorReturn(this, (LoadingMoire.__proto__ || Object.getPrototypeOf(LoadingMoire)).call(this));

        _this.params = {
            additionalClass: additionalClass,
            additionalSpinnerSettings: additionalSpinnerSettings,
            showAnimated: showAnimated,
            hideAnimated: hideAnimated,
            delay: delay,
            innerContent: innerContent
        };
        return _this;
    }

    _createClass(LoadingMoire, [{
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='loadingMoire <%=additionalClass%>'>" + "    <div class='spinnerPlaceholder'></div>" + "</div>";
        }
    }, {
        key: "templateModel",
        value: function templateModel() {
            return {
                additionalClass: this.params.additionalClass
            };
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            this.$el.hide();
            this.$spinnerPlaceholder = this.find('.spinnerPlaceholder');
            this.spinnerController = new _SpinnerController2.default(true);
            var spinnerSettings = _SpinnerController2.default.getDefaultSettings();
            spinnerSettings = _extends({}, spinnerSettings, this.params.additionalSpinnerSettings);
            this.spinnerController.setSpinner(new _spin2.default(spinnerSettings));

            if (this.params.innerContent) {
                this.params.innerContent.init(this.$el);
            }
        }
    }, {
        key: "show",
        value: function show() {
            var _this2 = this;

            clearTimeout(this._showOpaqueTimeout);
            this._showOpaqueCalled = false;

            if (this.params.delay) {
                this._showTransparent();
                this._showOpaqueTimeout = setTimeout(function () {
                    return _this2._showOpaque();
                }, this.params.delay);
            } else {
                this._showOpaque();
            }
        }
    }, {
        key: "hide",
        value: function hide() {
            clearTimeout(this._showOpaqueTimeout);

            if (this.params.hideAnimated && this._showOpaqueCalled) this.$el.atAnimation().fadeOut();else this.$el.hide();

            this.spinnerController.stop();
        }
    }, {
        key: "toggle",
        value: function toggle(isLoading) {
            if (isLoading) {
                this.show();
            } else {
                this.hide();
            }
        }
    }, {
        key: "_showTransparent",
        value: function _showTransparent() {
            this.$el.addClass('transparent');
            this.$el.show();
        }
    }, {
        key: "_showOpaque",
        value: function _showOpaque() {
            this.$el.removeClass('transparent');
            this._showOpaqueCalled = true;
            if (this.params.showAnimated) this.$el.atAnimation().fadeIn();else this.$el.show();
            this.spinnerController.spinInElement(this.$spinnerPlaceholder);
        }
    }]);

    return LoadingMoire;
}(_TemplateView3.default);

exports.default = LoadingMoire;

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

(function (t, e) {
  if (( false ? "undefined" : _typeof(exports)) == "object") module.exports = e();else if (true) !(__WEBPACK_AMD_DEFINE_FACTORY__ = (e),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else t.Spinner = e();
})(undefined, function () {
  "use strict";
  var t = ["webkit", "Moz", "ms", "O"],
      e = {},
      i;function o(t, e) {
    var i = document.createElement(t || "div"),
        o;for (o in e) {
      i[o] = e[o];
    }return i;
  }function n(t) {
    for (var e = 1, i = arguments.length; e < i; e++) {
      t.appendChild(arguments[e]);
    }return t;
  }var r = function () {
    var t = o("style", { type: "text/css" });n(document.getElementsByTagName("head")[0], t);return t.sheet || t.styleSheet;
  }();function s(t, o, n, s) {
    var a = ["opacity", o, ~~(t * 100), n, s].join("-"),
        f = .01 + n / s * 100,
        l = Math.max(1 - (1 - t) / o * (100 - f), t),
        d = i.substring(0, i.indexOf("Animation")).toLowerCase(),
        u = d && "-" + d + "-" || "";if (!e[a]) {
      r.insertRule("@" + u + "keyframes " + a + "{" + "0%{opacity:" + l + "}" + f + "%{opacity:" + t + "}" + (f + .01) + "%{opacity:1}" + (f + o) % 100 + "%{opacity:" + t + "}" + "100%{opacity:" + l + "}" + "}", r.cssRules.length);e[a] = 1;
    }return a;
  }function a(e, i) {
    var o = e.style,
        n,
        r;if (o[i] !== undefined) return i;i = i.charAt(0).toUpperCase() + i.slice(1);for (r = 0; r < t.length; r++) {
      n = t[r] + i;if (o[n] !== undefined) return n;
    }
  }function f(t, e) {
    for (var i in e) {
      t.style[a(t, i) || i] = e[i];
    }return t;
  }function l(t) {
    for (var e = 1; e < arguments.length; e++) {
      var i = arguments[e];for (var o in i) {
        if (t[o] === undefined) t[o] = i[o];
      }
    }return t;
  }function d(t) {
    var e = { x: t.offsetLeft, y: t.offsetTop };while (t = t.offsetParent) {
      e.x += t.offsetLeft, e.y += t.offsetTop;
    }return e;
  }var u = { lines: 12, length: 7, width: 5, radius: 10, rotate: 0, corners: 1, color: "#000", direction: 1, speed: 1, trail: 100, opacity: 1 / 4, fps: 20, zIndex: 2e9, className: "spinner", top: "auto", left: "auto", position: "relative" };function p(t) {
    if (typeof this == "undefined") return new p(t);this.opts = l(t || {}, p.defaults, u);
  }p.defaults = {};l(p.prototype, { spin: function spin(t) {
      this.stop();var e = this,
          n = e.opts,
          r = e.el = f(o(0, { className: n.className }), { position: n.position, width: 0, zIndex: n.zIndex }),
          s = n.radius + n.length + n.width,
          a,
          l;if (t) {
        t.insertBefore(r, t.firstChild || null);l = d(t);a = d(r);f(r, { left: (n.left == "auto" ? l.x - a.x + (t.offsetWidth >> 1) : parseInt(n.left, 10) + s) + "px", top: (n.top == "auto" ? l.y - a.y + (t.offsetHeight >> 1) : parseInt(n.top, 10) + s) + "px" });
      }r.setAttribute("role", "progressbar");e.lines(r, e.opts);if (!i) {
        var u = 0,
            p = (n.lines - 1) * (1 - n.direction) / 2,
            c,
            h = n.fps,
            m = h / n.speed,
            y = (1 - n.opacity) / (m * n.trail / 100),
            g = m / n.lines;(function v() {
          u++;for (var t = 0; t < n.lines; t++) {
            c = Math.max(1 - (u + (n.lines - t) * g) % m * y, n.opacity);e.opacity(r, t * n.direction + p, c, n);
          }e.timeout = e.el && setTimeout(v, ~~(1e3 / h));
        })();
      }return e;
    }, stop: function stop() {
      var t = this.el;if (t) {
        clearTimeout(this.timeout);if (t.parentNode) t.parentNode.removeChild(t);this.el = undefined;
      }return this;
    }, lines: function lines(t, e) {
      var r = 0,
          a = (e.lines - 1) * (1 - e.direction) / 2,
          l;function d(t, i) {
        return f(o(), { position: "absolute", width: e.length + e.width + "px", height: e.width + "px", background: t, boxShadow: i, transformOrigin: "left", transform: "rotate(" + ~~(360 / e.lines * r + e.rotate) + "deg) translate(" + e.radius + "px" + ",0)", borderRadius: (e.corners * e.width >> 1) + "px" });
      }for (; r < e.lines; r++) {
        l = f(o(), { position: "absolute", top: 1 + ~(e.width / 2) + "px", transform: e.hwaccel ? "translate3d(0,0,0)" : "", opacity: e.opacity, animation: i && s(e.opacity, e.trail, a + r * e.direction, e.lines) + " " + 1 / e.speed + "s linear infinite" });if (e.shadow) n(l, f(d("#000", "0 0 4px " + "#000"), { top: 2 + "px" }));n(t, n(l, d(e.color, "0 0 1px rgba(0,0,0,.1)")));
      }return t;
    }, opacity: function opacity(t, e, i) {
      if (e < t.childNodes.length) t.childNodes[e].style.opacity = i;
    } });function c() {
    function t(t, e) {
      return o("<" + t + ' xmlns="urn:schemas-microsoft.com:vml" class="spin-vml">', e);
    }r.addRule(".spin-vml", "behavior:url(#default#VML)");p.prototype.lines = function (e, i) {
      var o = i.length + i.width,
          r = 2 * o;function s() {
        return f(t("group", { coordsize: r + " " + r, coordorigin: -o + " " + -o }), { width: r, height: r });
      }var a = -(i.width + i.length) * 2 + "px",
          l = f(s(), { position: "absolute", top: a, left: a }),
          d;function u(e, r, a) {
        n(l, n(f(s(), { rotation: 360 / i.lines * e + "deg", left: ~~r }), n(f(t("roundrect", { arcsize: i.corners }), { width: o, height: i.width, left: i.radius, top: -i.width >> 1, filter: a }), t("fill", { color: i.color, opacity: i.opacity }), t("stroke", { opacity: 0 }))));
      }if (i.shadow) for (d = 1; d <= i.lines; d++) {
        u(d, -2, "progid:DXImageTransform.Microsoft.Blur(pixelradius=2,makeshadow=1,shadowopacity=.3)");
      }for (d = 1; d <= i.lines; d++) {
        u(d);
      }return n(e, l);
    };p.prototype.opacity = function (t, e, i, o) {
      var n = t.firstChild;o = o.shadow && o.lines || 0;if (n && e + o < n.childNodes.length) {
        n = n.childNodes[e + o];n = n && n.firstChild;n = n && n.firstChild;if (n) n.opacity = i;
      }
    };
  }var h = f(o("group"), { behavior: "url(#default#VML)" });if (!a(h, "transform") && h.adj) c();else i = a(h, "animation");return p;
});

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = TokensHighlighter;
exports.createTokensHighlighterForSearch = createTokensHighlighterForSearch;

var _RegExpSpecialSymbols = __webpack_require__(343);

var _RegExpSpecialSymbols2 = _interopRequireDefault(_RegExpSpecialSymbols);

var _DiacriticsUtil = __webpack_require__(451);

var _DiacriticsUtil2 = _interopRequireDefault(_DiacriticsUtil);

var _atUtils = __webpack_require__(5);

var _StringTokenizer = __webpack_require__(103);

var _StringTokenizer2 = _interopRequireDefault(_StringTokenizer);

var _EmptyHighlighter = __webpack_require__(137);

var _EmptyHighlighter2 = _interopRequireDefault(_EmptyHighlighter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function TokensHighlighter(tokens, punctuators, hlStart, hlEnd) {
    // need to sort, because longest prefixes must be highlighted
    this.tokens = tokens.slice().sort(function (a, b) {
        return b.length - a.length;
    });
    this.hlStart = hlStart || "<span class=\"highlightToken\">";
    this.hlEnd = hlEnd || "</span>";
    this.pattern = "(^|[\\s" + _RegExpSpecialSymbols2.default.escapeRegexpSpecialSymbols(punctuators) + "])((";
    this.pattern += _DiacriticsUtil2.default.makeMatchingRegexp(this.tokens[0]);
    for (var i = 1; i < this.tokens.length; i++) {
        this.pattern += ")|(" + _DiacriticsUtil2.default.makeMatchingRegexp(this.tokens[i]);
    }this.pattern += "))";
}

TokensHighlighter.prototype.highlightTokens = function (text) {
    if (!text) return null;

    var regexp = new RegExp(this.pattern, "gi");

    var lastIndex = 0;
    var result = "";
    var found = regexp.exec(text);

    while (found) {
        var token = found[2];
        result += (0, _atUtils.escapeHtmlSymbols)(text.substring(lastIndex, regexp.lastIndex - token.length));
        result += this.hlStart + (0, _atUtils.escapeHtmlSymbols)(token) + this.hlEnd;
        lastIndex = regexp.lastIndex;
        found = regexp.exec(text);
    }
    result += (0, _atUtils.escapeHtmlSymbols)(text.substring(lastIndex));
    return result;
};

function createTokensHighlighterForSearch(searchString) {
    if (!searchString) return new _EmptyHighlighter2.default();

    var stringTokenizer = new _StringTokenizer2.default(_StringTokenizer2.default.PUNCTUATORS_FOR_SEARCH);
    var tokens = stringTokenizer.getTokens(searchString);
    if (tokens.length === 0) return new _EmptyHighlighter2.default();
    return new TokensHighlighter(tokens, stringTokenizer.getPunctuators());
}

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = HierarchySelectorUtil;

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _TreeNodeSet = __webpack_require__(79);

var _TreeNodeSet2 = _interopRequireDefault(_TreeNodeSet);

var _two_level_selection = __webpack_require__(70);

var _two_level_selection2 = _interopRequireDefault(_two_level_selection);

var _atUtils = __webpack_require__(5);

var _atBrowserUtils = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function HierarchySelectorUtil() {}

HierarchySelectorUtil.addNodesFromIdsArray = function (nodeIdsArray, treeNodeSet, rootNode, idPrefix) {
    for (var i = 0; i < nodeIdsArray.length; i++) {
        var treeNodeId = idPrefix ? HierarchySelectorUtil.makeTreeNodeId(idPrefix, nodeIdsArray[i]) : nodeIdsArray[i];
        var treeNode = rootNode.getNodeById(treeNodeId);
        if (treeNode) treeNodeSet.add(treeNode);
    }
};

HierarchySelectorUtil.makeNodeSetByTwoLevelSelection = function (twoLevelSelection, rootNode, firstLevelIdPrefix, secondLevelIdPrefix) {
    var nodeSet = new _TreeNodeSet2.default();
    HierarchySelectorUtil.addNodesFromIdsArray(twoLevelSelection.getFirstLevel(), nodeSet, rootNode, firstLevelIdPrefix);
    HierarchySelectorUtil.addNodesFromIdsArray(twoLevelSelection.getSecondLevel(), nodeSet, rootNode, secondLevelIdPrefix);
    return nodeSet;
};

/**
 * Make id for tree node
 * @param prefix text presentation of type of a node
 * @param valueId id of node value
 */
HierarchySelectorUtil.makeTreeNodeId = function (prefix, valueId) {
    return prefix + "_" + valueId;
};

HierarchySelectorUtil.isSelectionChanged = function (tree) {
    var selected = tree.getSelectionController().getSelectedNodeSet();
    var initiallySelected = tree.getSelectionController().getInitiallySelectedNodeSet();
    return !selected.equals(initiallySelected);
};

HierarchySelectorUtil.renderSimpleEntityName = function (renderer, treeNode, labelEl) {
    var entity = treeNode.getValue();
    labelEl.innerHTML = (0, _atUtils.concatStr)(renderer.selectorFilter.highlightTokens(entity.name), renderer.selectionHelper.getListDescriptionItemStatus(entity), " ");
    labelEl.title = renderer.getTitle(entity);
};

HierarchySelectorUtil.saveCollapsedNodesIntoCookies = function (tree, cookiesKey, nodeType) {
    var allNodes = tree.getExpandController().getCollapsedNodeSet().getAllNodes();
    var collapsedArray = [];
    _underscore2.default.each(allNodes, function (node) {
        if (node.getType() === nodeType) collapsedArray.push(node.getId());
    });
    (0, _atBrowserUtils.saveArrayIntoCookies)(collapsedArray, cookiesKey);
};

HierarchySelectorUtil.makeSelectionFromNodeSet = function (nodeSet, isFullFormed, nodeTypeResultLevelMapping, maxLevel) {
    var resultArrays = [[], []];
    var resultSet = {};

    for (var level = 1; level <= maxLevel; level++) {
        var levelMap = nodeSet.getLevelMap(level);
        _underscore2.default.each(_underscore2.default.values(levelMap), function (node) {
            var parent = node.getParent();
            while (parent) {
                if (resultSet[parent.getId()]) return;
                parent = parent.getParent();
            }

            var resultArrayIndex = nodeTypeResultLevelMapping[node.getType()];
            if (_underscore2.default.isNumber(resultArrayIndex)) {
                var value = node.getValue();
                resultArrays[resultArrayIndex].push(isFullFormed ? value : value.id);
                resultSet[node.getId()] = true;
            }
        });
    }

    return new _two_level_selection2.default(resultArrays[0], resultArrays[1]);
};

HierarchySelectorUtil.disableOrEnableSelector = function (button, selector, enabled, customText) {
    button.setEnabled(enabled);
    if (!enabled) {
        button.setText(selector.getAllSelectedMessage());
    } else {
        if (selector.isAlreadyShown()) {
            selector.fireChangeEvent();
        } else {
            button.setText(customText);
        }
    }
};

HierarchySelectorUtil.selectNodesParents = function (nodeSet, nodesLevel) {
    var parentNodes = new _TreeNodeSet2.default();
    var nodes = Object.values(nodeSet.getLevelMap(nodesLevel));
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = nodes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var node = _step.value;

            parentNodes.add(node.getParent());
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    var selectedParents = new _TreeNodeSet2.default();
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
        for (var _iterator2 = parentNodes.getAllNodes()[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var parent = _step2.value;

            if (nodeSet.containsAll(parent.getChildren())) selectedParents.add(parent);
        }
    } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
            }
        } finally {
            if (_didIteratorError2) {
                throw _iteratorError2;
            }
        }
    }

    return selectedParents;
};

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _abstract_dropdown_button = __webpack_require__(233);

var _abstract_dropdown_button2 = _interopRequireDefault(_abstract_dropdown_button);

var _dropdown_list_button = __webpack_require__(482);

var _dropdown_list_button2 = _interopRequireDefault(_dropdown_list_button);

var _Ext = __webpack_require__(12);

var _Ext2 = _interopRequireDefault(_Ext);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ListSelector = _Ext2.default.extend(_abstract_dropdown_button2.default, {

    menuCls: "",
    listItems: [],
    textPropName: "text",
    valuePropName: "value",
    clsPropName: "styleCls",
    value: null,
    maxNonScrollableItems: 10,

    // private
    currentItem: null,

    initComponent: function initComponent() {
        var _this = this;

        this.addEvents("change");

        this.itemClickHandler = function (item) {
            var wasActuallySet = _this.setItem(item);
            if (wasActuallySet) _this.fireEvent("change", _this, item.origObj);
        };

        var mCls = "at-dropdown-list-btn-menu ";
        if (this.listItems.length > this.maxNonScrollableItems) mCls += "scrollable ";
        mCls += this.menuCls;

        this.menu = new _Ext2.default.menu.Menu({
            cls: mCls,
            parentEl: this.renderTo
        });

        if (this.listItems.length !== 0) {
            this.addItems(this.listItems);

            if (!this.currentItem) this.setItem(this.menu.items.items[0]);
        }
        this.cls = "at-dropdown-list-btn " + (this.cls ? this.cls : "");
        this.ctCls = "at-dropdown-list-btn-ct " + (this.ctCls ? this.ctCls : "");

        _dropdown_list_button2.default.superclass.initComponent.call(this);
    },

    setItem: function setItem(item) {
        if (this.currentItem) {
            if (this.currentItem === item) return false;
            this.currentItem.setIconClass("");
        }
        this.currentItem = item;
        this.currentItem.setIconClass("selected");
        this.value = item.value;
        this.setText(item.text);
        return true;
    },

    setActiveItemByValue: function setActiveItemByValue(value, suppressChangeEvent) {
        var item = this.menu.items.find(function (item) {
            return item.value === value;
        });
        if (item) {
            this.setItem(item);
            if (!suppressChangeEvent) this.fireEvent("change", this, item.origObj);
        }
    },

    /**
     * @deprecated
     */
    getValue: function getValue() {
        return this.value;
    },

    getSelectedItem: function getSelectedItem() {
        return this.currentItem == null ? null : this.currentItem.origObj;
    },

    createItem: function createItem(listItem) {
        return {
            text: listItem[this.textPropName],
            value: listItem[this.valuePropName],
            cls: listItem[this.clsPropName],
            origObj: listItem
        };
    },

    addItems: function addItems(listItems) {
        for (var i = 0; i < listItems.length; i++) {
            var listItem = listItems[i];

            var itemConfig = this.createItem(listItem);
            itemConfig.listeners = { click: this.itemClickHandler };

            var item = this.menu.addMenuItem(itemConfig);

            if (this.value === item.value) this.setItem(item);
        }
    },

    addSeparator: function addSeparator() {
        this.menu.addSeparator();
    },

    getItemByValue: function getItemByValue(value) {
        return this.menu.items.find(function (item) {
            return item.value === value;
        });
    }
});

exports.default = ListSelector;

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getReadOnlyFields = exports.isPanelOpenedFromUrl = exports.isShowNewCommentInput = exports.getTaskNewComment = exports.isSendingComment = exports.getNewCommentsTexts = exports.getUpdatingCommentId = exports.isCommentsLoading = exports.getEditingCommentText = exports.getEditingCommentId = exports.getCommentsScrollTo = exports.getNewestCommentId = exports.isNewCommentsOnTop = exports.needMoreComments = exports.getRecentlyAddedCommentsIds = exports.getAllCommentsUserIds = exports.getCommentsCount = exports.getUsers = exports.getComments = exports.canMoveTask = exports.canReopenProject = exports.isTaskManageable = exports.getCustomerName = exports.getProjectName = exports.getCustomerFromTask = exports.getIsOpenTaskCompleted = exports.getOpenTaskNextId = exports.getLastAuditActions = exports.getAuditActions = exports.isAuditHistoryLoading = exports.isAllAuditHistoryLoaded = exports.getTaskAuditInfo = exports.getSortingSettings = exports.isTimeAndCommentsLoading = exports.isAllTimeCommentsLoaded = exports.getReportedTimeComments = exports.getTaskExecutorsSummary = exports.getTaskCustomFieldsValues = exports.isTaskDeletedUnsuccessfully = exports.isTaskDeletedSuccessfully = exports.getTaskDetails = exports.canModifyAnyManager = exports.canModifyAnyUser = exports.getAssignedManagers = exports.getAssignedUsers = exports.getLastTaskPanelTabKey = exports.getTaskPanelTabKey = exports.getTaskPanelErrors = exports.isWorkTypeBillable = exports.getBillingType = exports.getBillableTypeName = exports.getTaskDescription = exports.getSpentTime = exports.getEstimatedTime = exports.getTaskName = exports.getTaskDeadline = exports.getTaskStatusId = exports.getCreationTimestamp = exports.isTaskCompleted = exports.isNeedToLoadData = exports.isPanelOpened = exports.isLoading = exports.isLoaded = exports.isMoveToDialogLoading = exports.isStatusUpdating = exports.isDescriptionUpdating = exports.isEstimateUpdating = exports.isTypeOfWorkUpdating = exports.isDeadlineUpdating = exports.isNameUpdating = exports.isEditTaskPanelEditable = exports.getOpenTaskId = exports.getTaskPanelState = undefined;

var _selectorsGenerator = __webpack_require__(756);

var _selectorsGenerator2 = _interopRequireDefault(_selectorsGenerator);

var _selectorsGenerator3 = __webpack_require__(757);

var _selectorsGenerator4 = _interopRequireDefault(_selectorsGenerator3);

var _selectorsGenerator5 = __webpack_require__(485);

var _selectorsGenerator6 = _interopRequireDefault(_selectorsGenerator5);

var _reselect = __webpack_require__(13);

var _selectors = __webpack_require__(14);

var _selectors2 = __webpack_require__(27);

var _selectors3 = __webpack_require__(190);

var _selectors4 = __webpack_require__(19);

var _constants = __webpack_require__(77);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getTaskPanelState = exports.getTaskPanelState = function getTaskPanelState(state) {
    return state.panels.task.edit;
};

var getOpenTaskId = exports.getOpenTaskId = function getOpenTaskId(state) {
    return getTaskPanelState(state).openTaskId;
};

var getUpdatingState = function getUpdatingState(state) {
    return getTaskPanelState(state).updatingState;
};

var isEditTaskPanelEditable = exports.isEditTaskPanelEditable = function isEditTaskPanelEditable(state) {
    return getTaskPanelState(state).canEdit;
};

var isNameUpdating = exports.isNameUpdating = function isNameUpdating(state) {
    return getUpdatingState(state).name;
};
var isDeadlineUpdating = exports.isDeadlineUpdating = function isDeadlineUpdating(state) {
    return getUpdatingState(state).deadline;
};
var isTypeOfWorkUpdating = exports.isTypeOfWorkUpdating = function isTypeOfWorkUpdating(state) {
    return getUpdatingState(state).typeOfWork;
};
var isEstimateUpdating = exports.isEstimateUpdating = function isEstimateUpdating(state) {
    return getUpdatingState(state).estimate;
};
var isDescriptionUpdating = exports.isDescriptionUpdating = function isDescriptionUpdating(state) {
    return getUpdatingState(state).description;
};
var isStatusUpdating = exports.isStatusUpdating = function isStatusUpdating(state) {
    return getUpdatingState(state).status;
};
var isMoveToDialogLoading = exports.isMoveToDialogLoading = function isMoveToDialogLoading(state) {
    return getUpdatingState(state).moveToDialog;
};

var taskPanelSelectors = (0, _selectorsGenerator2.default)(getTaskPanelState);
var assignmentsSelectors = (0, _selectorsGenerator4.default)(getTaskPanelState);

var isLoaded = exports.isLoaded = taskPanelSelectors.isLoaded;
var isLoading = exports.isLoading = taskPanelSelectors.isLoading;
var isPanelOpened = exports.isPanelOpened = taskPanelSelectors.isPanelOpened;
var isNeedToLoadData = exports.isNeedToLoadData = taskPanelSelectors.isNeedToLoadData;
var isTaskCompleted = exports.isTaskCompleted = taskPanelSelectors.isTaskCompleted;
var getCreationTimestamp = exports.getCreationTimestamp = taskPanelSelectors.getCreationTimestamp;
var getTaskStatusId = exports.getTaskStatusId = taskPanelSelectors.getTaskStatusId;
var getTaskDeadline = exports.getTaskDeadline = taskPanelSelectors.getTaskDeadline;
var getTaskName = exports.getTaskName = taskPanelSelectors.getTaskName;
var getEstimatedTime = exports.getEstimatedTime = taskPanelSelectors.getEstimatedTime;
var getSpentTime = exports.getSpentTime = taskPanelSelectors.getSpentTime;
var getTaskDescription = exports.getTaskDescription = taskPanelSelectors.getTaskDescription;
var getBillableTypeName = exports.getBillableTypeName = taskPanelSelectors.getBillableTypeName;
var getBillingType = exports.getBillingType = taskPanelSelectors.getBillingType;
var isWorkTypeBillable = exports.isWorkTypeBillable = taskPanelSelectors.isWorkTypeBillable;
var getTaskPanelErrors = exports.getTaskPanelErrors = taskPanelSelectors.getTaskPanelErrors;

var getTaskPanelTabKey = exports.getTaskPanelTabKey = taskPanelSelectors.getTaskPanelTabKey;
var getLastTaskPanelTabKey = exports.getLastTaskPanelTabKey = taskPanelSelectors.getLastTaskPanelTabKey;

var getAssignedUsers = exports.getAssignedUsers = assignmentsSelectors.getAssignedUsers;
var getAssignedManagers = exports.getAssignedManagers = assignmentsSelectors.getAssignedManagers;
var canModifyAnyUser = exports.canModifyAnyUser = assignmentsSelectors.canModifyAnyUser;
var canModifyAnyManager = exports.canModifyAnyManager = assignmentsSelectors.canModifyAnyManager;

var getTaskDetails = exports.getTaskDetails = function getTaskDetails(state) {
    return getTaskPanelState(state).taskDetails;
};
var isTaskDeletedSuccessfully = exports.isTaskDeletedSuccessfully = function isTaskDeletedSuccessfully(state) {
    return getTaskPanelState(state).taskDeletedSuccessfully;
};
var isTaskDeletedUnsuccessfully = exports.isTaskDeletedUnsuccessfully = function isTaskDeletedUnsuccessfully(state) {
    return getTaskPanelState(state).taskDeletedUnsuccessfully;
};
var getTaskCustomFieldsValues = exports.getTaskCustomFieldsValues = function getTaskCustomFieldsValues(state) {
    return getTaskPanelState(state).customFieldsValues;
};

var getTaskExecutorsSummary = exports.getTaskExecutorsSummary = function getTaskExecutorsSummary(state) {
    return getTaskPanelState(state).executorsSummary;
};

var getReportedTimeComments = exports.getReportedTimeComments = function getReportedTimeComments(state) {
    return getTaskPanelState(state).reportedTimeComments;
};
var isAllTimeCommentsLoaded = exports.isAllTimeCommentsLoaded = function isAllTimeCommentsLoaded(state) {
    return getTaskPanelState(state).allTimeCommentsLoaded;
};
var isTimeAndCommentsLoading = exports.isTimeAndCommentsLoading = function isTimeAndCommentsLoading(state) {
    return getTaskPanelState(state).timeAndCommentsLoading;
};
var getSortingSettings = exports.getSortingSettings = function getSortingSettings(state) {
    return getTaskPanelState(state).sortingSettings;
};

var getTaskAuditInfo = exports.getTaskAuditInfo = function getTaskAuditInfo(state) {
    return getTaskPanelState(state).auditInfo;
};
var isAllAuditHistoryLoaded = exports.isAllAuditHistoryLoaded = function isAllAuditHistoryLoaded(state) {
    return getTaskAuditInfo(state).allAuditHistoryLoaded;
};
var isAuditHistoryLoading = exports.isAuditHistoryLoading = function isAuditHistoryLoading(state) {
    return getTaskAuditInfo(state).auditHistoryLoading;
};
var getAuditActions = exports.getAuditActions = function getAuditActions(state) {
    return getTaskAuditInfo(state).auditActions;
};
var getLastAuditActions = exports.getLastAuditActions = function getLastAuditActions(state) {
    return getTaskAuditInfo(state).lastAuditActions;
};

var getTaskProjectId = (0, _reselect.createSelector)(getOpenTaskId, _selectors.getTasks, function (id, tasks) {
    return tasks[id] ? tasks[id].projectId : -1;
});

var getProjectFromTask = (0, _reselect.createSelector)(getTaskProjectId, _selectors.getProjects, function (id, projects) {
    return projects[id] ? projects[id] : null;
});

var getTaskCustomerId = (0, _reselect.createSelector)(getOpenTaskId, _selectors.getTasks, function (id, tasks) {
    return tasks[id] ? tasks[id].customerId : -1;
});

var getOpenTaskNextId = exports.getOpenTaskNextId = (0, _reselect.createSelector)(getOpenTaskId, _selectors.getTasks, function (id, tasks) {
    return tasks[id] ? tasks[id].nextId : -1;
});

var getIsOpenTaskCompleted = exports.getIsOpenTaskCompleted = (0, _reselect.createSelector)(getOpenTaskId, _selectors.getTasks, function (id, tasks) {
    return tasks[id] ? tasks[id].completed : -1;
});

var getCustomerFromTask = exports.getCustomerFromTask = (0, _reselect.createSelector)(getTaskCustomerId, _selectors.getCustomers, function (id, customers) {
    return customers[id] ? customers[id] : null;
});

var getProjectName = exports.getProjectName = (0, _reselect.createSelector)(getProjectFromTask, function (project) {
    return project ? project.name : '';
});

var getCustomerName = exports.getCustomerName = (0, _reselect.createSelector)(getCustomerFromTask, function (customer) {
    return customer ? customer.name : '';
});

var isTaskManageable = exports.isTaskManageable = (0, _reselect.createSelector)(getOpenTaskId, _selectors2.getManageableTaskIds, function (taskId, manageableTaskIds) {
    return !!manageableTaskIds[taskId];
});

var canReopenProject = exports.canReopenProject = (0, _reselect.createSelector)(getTaskProjectId, getProjectFromTask, getTaskCustomerId, getCustomerFromTask, _selectors2.getEditableProjectIds, _selectors2.getEditableCustomerIds, function (projectId, project, customerId, customer, editableProjectIds, editableCustomerIds) {
    return !!project && !project.archived || !!editableProjectIds[projectId] && !!customer && !customer.archived || !!editableCustomerIds[customerId];
});

var canMoveTask = exports.canMoveTask = (0, _reselect.createSelector)(getOpenTaskId, _selectors2.getEditableTaskIds, function (taskId, editableTaskIds) {
    return !!editableTaskIds[taskId];
});

var commentsSelector = (0, _selectorsGenerator6.default)(getTaskPanelState);

var getComments = exports.getComments = commentsSelector.getComments;
var getUsers = exports.getUsers = commentsSelector.getUsers;
var getCommentsCount = exports.getCommentsCount = commentsSelector.getCommentsCount;
var getAllCommentsUserIds = exports.getAllCommentsUserIds = commentsSelector.getAllCommentsUserIds;
var getRecentlyAddedCommentsIds = exports.getRecentlyAddedCommentsIds = commentsSelector.getRecentlyAddedCommentsIds;
var needMoreComments = exports.needMoreComments = commentsSelector.needMoreComments;
var isNewCommentsOnTop = exports.isNewCommentsOnTop = commentsSelector.isNewCommentsOnTop;
var getNewestCommentId = exports.getNewestCommentId = commentsSelector.getNewestCommentId;
var getCommentsScrollTo = exports.getCommentsScrollTo = commentsSelector.getCommentsScrollTo;
var getEditingCommentId = exports.getEditingCommentId = commentsSelector.getEditingCommentId;
var getEditingCommentText = exports.getEditingCommentText = commentsSelector.getEditingCommentText;
var isCommentsLoading = exports.isCommentsLoading = commentsSelector.isLoading;
var getUpdatingCommentId = exports.getUpdatingCommentId = commentsSelector.getUpdatingCommentId;
var getNewCommentsTexts = exports.getNewCommentsTexts = commentsSelector.getNewCommentsTexts;
var isSendingComment = exports.isSendingComment = commentsSelector.isSendingComment;

var getTaskNewComment = exports.getTaskNewComment = (0, _reselect.createSelector)(getOpenTaskId, commentsSelector.getNewCommentsTexts, function (taskId, comments) {
    return comments[taskId] ? comments[taskId] : '';
});

var isShowNewCommentInput = exports.isShowNewCommentInput = (0, _reselect.createSelector)(commentsSelector.isShowNewCommentInput, getOpenTaskId, commentsSelector.getNewCommentsTexts, function (showInput, taskId, comments) {
    return showInput || comments[taskId] !== undefined;
});

var isPanelOpenedFromUrl = exports.isPanelOpenedFromUrl = (0, _reselect.createSelector)(getTaskPanelState, function (panelState) {
    return panelState.openedFromUrl;
});

var getReadOnlyFields = exports.getReadOnlyFields = (0, _reselect.createSelector)(_selectors3.selectTaskCustomFields, isEditTaskPanelEditable, isTaskManageable, _selectors4.canGenerateMoneyReports, function (customFields, editable, isTaskManageable, canGenerateMoneyReport) {
    if (editable) return [];

    var readonly = customFields.map(function (cf) {
        return cf.fieldName;
    });
    readonly.push(_constants.TaskPredefinedFieldNames.Deadline);
    if (!(canGenerateMoneyReport && isTaskManageable)) {
        readonly.push(_constants.TaskPredefinedFieldNames.TypeOfWork);
    }
    return readonly;
});

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.userComparator = userComparator;
exports.buildUserSelectorTreeWithUserGroupsData = buildUserSelectorTreeWithUserGroupsData;
exports.buildUserSelectorTreeWithTimeZoneGroupsData = buildUserSelectorTreeWithTimeZoneGroupsData;
exports.getUserSelectorFeatureStrategy = getUserSelectorFeatureStrategy;

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _UserSelectorTreeBuilder = __webpack_require__(749);

var _UserSelectorTreeBuilder2 = _interopRequireDefault(_UserSelectorTreeBuilder);

var _atUtils = __webpack_require__(5);

var _HideUserGroupsStrategy = __webpack_require__(480);

var _HideUserGroupsStrategy2 = _interopRequireDefault(_HideUserGroupsStrategy);

var _ShowUserGroupsStrategy = __webpack_require__(356);

var _ShowUserGroupsStrategy2 = _interopRequireDefault(_ShowUserGroupsStrategy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Compare two User objects
 * @param a first user
 * @param b second user
 */
function userComparator(a, b) {
    var result = (0, _atUtils.stringComparator)(a.lastName, b.lastName);
    if (result === 0) {
        result = (0, _atUtils.stringComparator)(a.firstName, b.firstName);
        if (result === 0) {
            // empty string = false is ok there
            result = (0, _atUtils.stringComparator)(a.middleName || "", b.middleName || "");
            if (result === 0) {
                result = (0, _atUtils.stringComparator)(a.username || "", b.username || "");
            }
        }
    }
    return result;
}

function buildUserSelectorTreeWithGroupsData(users, groupsData, rootNode, observer, filter, getGroupIdFromUserCallback) {
    if (filter) users = _underscore2.default.filter(users, function (user) {
        return filter.matches(user);
    });

    var treeBuilder = new _UserSelectorTreeBuilder2.default(rootNode, users, groupsData ? groupsData.map : null, groupsData ? groupsData.order : null, observer, getGroupIdFromUserCallback);
    treeBuilder.buildTree();
}

function buildUserSelectorTreeWithUserGroupsData(users, userGroupsData, rootNode, observer, filter) {
    buildUserSelectorTreeWithGroupsData(users, userGroupsData, rootNode, observer, filter, function (user) {
        return user.userGroupId;
    });
}

function buildUserSelectorTreeWithTimeZoneGroupsData(users, timeZoneGroupsData, rootNode, observer, filter) {
    buildUserSelectorTreeWithGroupsData(users, timeZoneGroupsData, rootNode, observer, filter, function (user) {
        return user.timeZoneGroupId;
    });
}

function getUserSelectorFeatureStrategy() {
    return window.EnabledFeatures.TZG || window.EnabledFeatures.UGR ? new _ShowUserGroupsStrategy2.default() : new _HideUserGroupsStrategy2.default();
}

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.EventsHandlersMap = exports.MonitoredEventsMap = exports.BudgetTabOpenEventEntityParams = exports.UserEventsMap = undefined;

var _EventsHandlersMap;

var _handlePageVisited = __webpack_require__(1395);

var _handlePageVisited2 = _interopRequireDefault(_handlePageVisited);

var _handlePopupVideo = __webpack_require__(1396);

var _handlePopupVideo2 = _interopRequireDefault(_handlePopupVideo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var UserEventsMap = exports.UserEventsMap = {
    //TODO: AT-10144 - remove unused startup wizard popup event
    PLAY_VIDEO: 'Play Video',
    VIDEO_TIMELINE_UPDATED: 'Video Timeline Update',
    PAGE_VISIBLE: 'Page Visible',
    PAGE_HIDDEN: 'Page Hidden',
    POPUP_CLOSED: 'Popup Closed',
    POPUP_OPENED: 'Open Welcome Pop-Up',
    PAGE_VISITED: 'Page Visited',
    VIDEO_WATCHED: 'Video Watched',
    LICENSE_OBTAINED: 'License Obtained',
    ARTICLE_VISITED: 'Article Visited',
    TRIAL_READY: 'Trial Ready',
    BUDGET_TAB_OPEN: 'Budget Tab Open'
};

var BudgetTabOpenEventEntityParams = exports.BudgetTabOpenEventEntityParams = {
    TASK: { Entity: "Task" },
    PROJECT: { Entity: "Project" },
    CUSTOMER: { Entity: "Customer" }
};

var MonitoredEventsMap = exports.MonitoredEventsMap = {
    POPUP_OPENED: UserEventsMap.POPUP_OPENED,
    PAGE_VISITED: UserEventsMap.PAGE_VISITED,
    VIDEO_WATCHED: UserEventsMap.VIDEO_WATCHED,
    LICENSE_OBTAINED: UserEventsMap.LICENSE_OBTAINED
};

var EventsHandlersMap = exports.EventsHandlersMap = (_EventsHandlersMap = {}, _defineProperty(_EventsHandlersMap, UserEventsMap.PAGE_VISIBLE, [_handlePageVisited2.default]), _defineProperty(_EventsHandlersMap, UserEventsMap.PAGE_HIDDEN, [_handlePageVisited2.default, _handlePopupVideo2.default]), _defineProperty(_EventsHandlersMap, UserEventsMap.PLAY_VIDEO, [_handlePopupVideo2.default]), _defineProperty(_EventsHandlersMap, UserEventsMap.VIDEO_TIMELINE_UPDATED, [_handlePopupVideo2.default]), _defineProperty(_EventsHandlersMap, UserEventsMap.POPUP_CLOSED, [_handlePopupVideo2.default]), _EventsHandlersMap);

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var REPORT_LOGO_PATH = exports.REPORT_LOGO_PATH = window.__GENERATED_CONSTANTS__.REPORT_LOGO_PATH;

var PaperSize = exports.PaperSize = {
    LETTER: window.__GENERATED_CONSTANTS__.PaperSize.LETTER,
    A4: window.__GENERATED_CONSTANTS__.PaperSize.A4
};

var PaperOrientation = exports.PaperOrientation = {
    PORTRAIT: window.__GENERATED_CONSTANTS__.PaperOrientation.PORTRAIT,
    LANDSCAPE: window.__GENERATED_CONSTANTS__.PaperOrientation.LANDSCAPE
};

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(32);

module.exports = function (method, arg) {
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call
    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
  });
};


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var USERS_ADD = exports.USERS_ADD = 'at/entities/USERS_ADD';
var USERS_REMOVE = exports.USERS_REMOVE = 'at/entities/USERS_REMOVE';
var USERS_SET = exports.USERS_SET = 'at/entities/USERS_SET';
var USER_GROUPS_ADD = exports.USER_GROUPS_ADD = 'at/entities/USER_GROUPS_ADD';
var USER_GROUPS_SET = exports.USER_GROUPS_SET = 'at/entities/USER_GROUPS_SET';
var USER_GROUPS_REMOVE = exports.USER_GROUPS_REMOVE = 'at/entities/USER_GROUPS_REMOVE';
var TIME_ZONE_GROUPS_ADD = exports.TIME_ZONE_GROUPS_ADD = 'at/entities/TIME_ZONE_GROUPS_ADD';
var TIME_ZONE_GROUPS_SET = exports.TIME_ZONE_GROUPS_SET = 'at/entities/TIME_ZONE_GROUPS_SET';
var TIME_ZONE_GROUPS_REMOVE = exports.TIME_ZONE_GROUPS_REMOVE = 'at/entities/TIME_ZONE_GROUPS_REMOVE';
var TASKS_ADD = exports.TASKS_ADD = 'at/entities/TASKS_ADD';
var TASKS_REMOVE = exports.TASKS_REMOVE = 'at/entities/TASKS_REMOVE';
var TASKS_CLEAR = exports.TASKS_CLEAR = 'at/entities/TASKS_CLEAR';
var PROJECTS_ADD = exports.PROJECTS_ADD = 'at/entities/PROJECTS_ADD';
var PROJECTS_REMOVE = exports.PROJECTS_REMOVE = 'at/entities/PROJECTS_REMOVE';
var CUSTOMERS_ADD = exports.CUSTOMERS_ADD = 'at/entities/CUSTOMERS_ADD';
var CUSTOMERS_REMOVE = exports.CUSTOMERS_REMOVE = 'at/entities/CUSTOMERS/REMOVE';
var WORKFLOW_STATUSES_ADD = exports.WORKFLOW_STATUSES_ADD = 'at/entities/WORKFLOW_STATUSES_ADD';
var WORKFLOW_STATUSES_SET = exports.WORKFLOW_STATUSES_SET = 'at/entities/WORKFLOW_STATUSES_SET';
var WORKFLOW_STATUSES_REMOVE = exports.WORKFLOW_STATUSES_REMOVE = 'at/entities/WORKFLOW_STATUSES_REMOVE';
var TYPES_OF_WORK_SET = exports.TYPES_OF_WORK_SET = 'at/entities/TYPES_OF_WORK_SET';
var LEAVE_TYPES_SET = exports.LEAVE_TYPES_SET = 'at/entitiews/LEAVE_TYPES_SET';

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = StringTokenizer;

var _RegExpSpecialSymbols = __webpack_require__(343);

var _RegExpSpecialSymbols2 = _interopRequireDefault(_RegExpSpecialSymbols);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// TODO: convert to class
function StringTokenizer(punctuators) {
    this.punctuators = punctuators || StringTokenizer.DEFAULT_PUNCTUATORS;
    this.replacePunctuatorsPattern = new RegExp("[" + _RegExpSpecialSymbols2.default.escapeRegexpSpecialSymbols(this.punctuators) + "]+", "g");
}

StringTokenizer.DEFAULT_PUNCTUATORS = "()-,.\"':";
StringTokenizer.PUNCTUATORS_FOR_SEARCH = StringTokenizer.DEFAULT_PUNCTUATORS.concat("!#$%&()*+,-.:;<=>?@]/[^_`{|}~\\");

StringTokenizer.prototype.getPunctuators = function () {
    return this.punctuators;
};

StringTokenizer.prototype.getTokens = function (s) {
    var results = [];
    var duplicates = {};

    var words = s.replace(this.replacePunctuatorsPattern, " ").split(/\s+/);

    for (var i = 0; i < words.length; i++) {
        var w = words[i];
        if (w.length > 0 && !duplicates[w]) {
            results.push(w);
            duplicates[w] = 1;
        }
    }

    return results;
};

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var SET_ACTIVE_TAB = exports.SET_ACTIVE_TAB = 'at/userManagement/common/SET_ACTIVE_TAB';
var SET_USERS_WITHOUT_APPROVERS = exports.SET_USERS_WITHOUT_APPROVERS = 'at/userManagement/common/SET_USERS_WITHOUT_APPROVERS';
var SET_LICENSE_COUNTERS = exports.SET_LICENSE_COUNTERS = 'at/userManagement/common/SET_LICENSE_COUNTERS';
var SET_VIEWER_SETTINGS = exports.SET_VIEWER_SETTINGS = 'at/userManagement/common/SET_VIEWER_SETTINGS';
var SET_NEW_USER_IDS = exports.SET_NEW_USER_IDS = 'at/userManagement/common/SET_NEW_USER_IDS';
var ADD_NEW_USER_IDS = exports.ADD_NEW_USER_IDS = 'at/userManagement/common/ADD_NEW_USER_IDS';
var SET_VIEWER_MANAGEMENT_ASSIGNMENTS_COUNTERS = exports.SET_VIEWER_MANAGEMENT_ASSIGNMENTS_COUNTERS = 'at/userManagement/common/SET_VIEWER_MANAGEMENT_ASSIGNMENTS_COUNTERS';
var USERS_LIST_ADD = exports.USERS_LIST_ADD = 'at/userManagement/common/USERS_LIST_ADD';
var USERS_LIST_REMOVE = exports.USERS_LIST_REMOVE = 'at/userManagement/common/USERS_LIST_REMOVE';
var USERS_LIST_SET = exports.USERS_LIST_SET = 'at/userManagement/common/USERS_LIST_SET';
var CLOSE_ALL_PANELS = exports.CLOSE_ALL_PANELS = 'at/userManagement/common/CLOSE_ALL_PANELS';
var USER_MANAGEMENT_DATA_SET = exports.USER_MANAGEMENT_DATA_SET = 'at/userManagement/common/USER_MANAGEMENT_DATA_SET';

var USERS_LIST_USER_GROUP_ID_UPDATE = exports.USERS_LIST_USER_GROUP_ID_UPDATE = 'at/userManagement/common/USERS_LIST_USER_GROUP_ID_UPDATE';

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Class with internal state that helps for register state change listeners
 * Extracted from View.js
 */
var StateComponent = function () {
    function StateComponent() {
        var initialState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        _classCallCheck(this, StateComponent);

        this.state = initialState;
        this._stateChangeHandlers = [];

        this._freezedState = {}; // variable for store state at the time when stop handling changes
        this._handleChanges = true;
    }

    /**
     * Changes current state object, merging current state with specified state changes object.
     * As a side-effect, state change handlers are called to apply state changes.
     * @param {object} stateChanges
     */


    _createClass(StateComponent, [{
        key: 'setState',
        value: function setState(stateChanges) {
            var prevState = this.state;
            this.state = _extends({}, this.state, stateChanges);
            if (this._handleChanges) {
                this._callStateChangeHandlers(prevState);
            }
            return this;
        }

        /**
         * Changes current state object, merging current state with specified state changes object.
         * Does not call state change handlers and should only be used internally
         * to keep state up-to-date with inner visual components.
         * @param stateChanges
         */

    }, {
        key: 'setStateInternal',
        value: function setStateInternal(stateChanges) {
            this.state = _extends({}, this.state, stateChanges);
        }

        /**
         * Gets current state object.
         * @return {object}
         */

    }, {
        key: 'getState',
        value: function getState() {
            return this.state;
        }

        /**
         * !!! NOTE this handler called every setState and it is not good. Use onStateDeeplyChanged instead
         * Register handler, which will be called when entire state is changed.
         * @param handler
         */

    }, {
        key: 'onStateChanged',
        value: function onStateChanged(handler) {
            this._stateChangeHandlers.push(function (state, prevState) {
                if (state !== prevState) handler(state, prevState);
            });
        }

        /**
         * Register handler, which will be called when entire state is changed (compared for deep equality).
         * @param handler
         */

    }, {
        key: 'onStateDeeplyChanged',
        value: function onStateDeeplyChanged(handler) {
            this._stateChangeHandlers.push(function (state, prevState) {
                if (!_underscore2.default.isEqual(state, prevState)) handler(state, prevState);
            });
        }

        /**
         * Register handler, which will be called when single state property is changed.
         * @param name
         * @param handler
         */

    }, {
        key: 'onStatePropertyChanged',
        value: function onStatePropertyChanged(name, handler) {
            this._stateChangeHandlers.push(function (state, prevState) {
                if (!prevState || state[name] !== prevState[name]) handler(state[name], prevState[name]);
            });
        }

        /**
         * Register handler, which will be called when single state property is changed (compared for deep equality).
         * @param name
         * @param handler
         */

    }, {
        key: 'onStatePropertyDeeplyChanged',
        value: function onStatePropertyDeeplyChanged(name, handler) {
            this._stateChangeHandlers.push(function (state, prevState) {
                if (!prevState || !_underscore2.default.isEqual(state[name], prevState[name])) handler(state[name], prevState[name]);
            });
        }

        /**
         * Register handler, which will be called when any of specified state properties is changed.
         * @param {Array} names
         * @param handler
         */

    }, {
        key: 'onAnyStatePropertyChanged',
        value: function onAnyStatePropertyChanged(names, handler) {
            this._stateChangeHandlers.push(function (state, prevState) {
                if (!prevState || names.some(function (name) {
                    return state[name] !== prevState[name];
                })) handler(state, prevState);
            });
        }

        /**
         * Register handler, which will be called when any of specified state properties is changed (compared for deep equality).
         * @param {Array} names
         * @param handler
         */

    }, {
        key: 'onAnyStatePropertyDeeplyChanged',
        value: function onAnyStatePropertyDeeplyChanged(names, handler) {
            this._stateChangeHandlers.push(function (state, prevState) {
                if (!prevState || names.some(function (name) {
                    return !_underscore2.default.isEqual(state[name], prevState[name]);
                })) handler(state, prevState);
            });
        }

        /**
         * Register handler, which will be called when single state property is changed to 'true' value
         * @param name
         * @param handler
         */

    }, {
        key: 'onStatePropertyBecameTrue',
        value: function onStatePropertyBecameTrue(name, handler) {
            this._stateChangeHandlers.push(function (state, prevState) {
                if ((!prevState || state[name] !== prevState[name]) && state[name] === true) handler(state[name], prevState[name]);
            });
        }

        /**
         * Register handler, which will be called when single state property changed to equivalent of specified value
         * @param name
         * @param value
         * @param handler
         */

    }, {
        key: 'onStatePropertyBecameValue',
        value: function onStatePropertyBecameValue(name, value, handler) {
            this._stateChangeHandlers.push(function (state, prevState) {
                if ((!prevState || !_underscore2.default.isEqual(state[name], prevState[name])) && _underscore2.default.isEqual(state[name], value)) handler(state[name], prevState[name]);
            });
        }

        /**
         * Call all handlers with current state and pass prev state = empty object
         * It's means that all handlers will be handled with current state
         */

    }, {
        key: 'callStateChangeHandlersWithCurrentState',
        value: function callStateChangeHandlersWithCurrentState() {
            this._callStateChangeHandlers({});
        }

        /**
         * Stop handling state changes via #setState
         */

    }, {
        key: 'stopHandlingStateChanges',
        value: function stopHandlingStateChanges() {
            if (this._handleChanges === true) {
                this._handleChanges = false;
                this._freezedState = this.state;
            }
        }

        /**
         * Resume handling changes
         */

    }, {
        key: 'resumeHandlingStateChanges',
        value: function resumeHandlingStateChanges() {
            var handlePendingChanges = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

            if (this._handleChanges === false) {
                this._handleChanges = true;
                if (handlePendingChanges) {
                    this._callStateChangeHandlers(this._freezedState);
                }
            }
        }

        /**
         * Toggle handling changes
         */

    }, {
        key: 'toggleHandlingChanges',
        value: function toggleHandlingChanges(toggle) {
            toggle ? this.resumeHandlingStateChanges() : this.stopHandlingStateChanges();
        }
    }, {
        key: 'clearStateListeners',
        value: function clearStateListeners() {
            this._stateChangeHandlers = [];
        }

        /**
         * Calls every state change handler, assuming specified parameter as previous state.
         * @param prevState
         * @private
         */

    }, {
        key: '_callStateChangeHandlers',
        value: function _callStateChangeHandlers(prevState) {
            var _this = this;

            this._stateChangeHandlers.forEach(function (h) {
                return h(_this.state, prevState);
            });
        }
    }]);

    return StateComponent;
}();

exports.default = StateComponent;

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isAllTasksSelectedCheckboxChecked = exports.isAllTasksSelected = exports.getExistingTaskIdsForView = exports.getVisibleTaskIds = exports.isTasksLoaded = exports.isNeedToLoadExistingTaskIds = exports.getSelectedTaskIdsArray = exports.getSelectedTaskIds = exports.isExistingTaskIdsLoaded = exports.isPendingSelectAll = exports.isExistingTaskIdsLoading = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reselect = __webpack_require__(13);

var _selectors = __webpack_require__(189);

var _selectors2 = __webpack_require__(27);

var _selectors3 = __webpack_require__(243);

var _selectors4 = __webpack_require__(82);

var _constants = __webpack_require__(44);

var _atUtils = __webpack_require__(5);

var getTaskSelection = function getTaskSelection(state) {
    return (0, _selectors.selectTaskManagement)(state).taskSelection;
};

var isExistingTaskIdsLoading = exports.isExistingTaskIdsLoading = (0, _reselect.createSelector)(getTaskSelection, function (taskSelectionState) {
    return taskSelectionState.existingTaskIdsLoading;
});

var isPendingSelectAll = exports.isPendingSelectAll = (0, _reselect.createSelector)(getTaskSelection, function (taskSelectionState) {
    return taskSelectionState.pendingSelectAll;
});

var isExistingTaskIdsLoaded = exports.isExistingTaskIdsLoaded = (0, _reselect.createSelector)(getTaskSelection, function (taskSelection) {
    return taskSelection.existingTaskIdsLoaded;
});

/**
 * Ids of selected tasks for perform operations.
 */
var getSelectedTaskIds = exports.getSelectedTaskIds = (0, _reselect.createSelector)(getTaskSelection, function (taskSelectionState) {
    return taskSelectionState.selectedTaskIds;
});

var getExistingTaskIdsByFilters = (0, _reselect.createSelector)(getTaskSelection, function (taskSelectionState) {
    return taskSelectionState.existingTaskIdsByFilters;
});

var getSelectedTaskIdsArray = exports.getSelectedTaskIdsArray = (0, _reselect.createSelector)(getSelectedTaskIds, function (selectedTaskIds) {
    return Object.keys(selectedTaskIds);
});

var isNeedToLoadExistingTaskIds = exports.isNeedToLoadExistingTaskIds = (0, _reselect.createSelector)(getSelectedTaskIdsArray, isPendingSelectAll, isExistingTaskIdsLoaded, isExistingTaskIdsLoading, function (selectedTaskIds, pendingSelectAll, loaded, loading) {
    return !loading && !loaded && (selectedTaskIds.length > 0 || pendingSelectAll);
});

var isTasksLoaded = exports.isTasksLoaded = (0, _reselect.createSelector)(_selectors2.getViewMode, _selectors3.isLoaded, _selectors4.isLoaded, function (viewMode, kanbanTasksLoaded, tableTasksLoaded) {
    return viewMode === _constants.TaskManagementViewMode.KANBAN ? kanbanTasksLoaded : tableTasksLoaded;
});

/**
 * Ids of tasks that visible
 */
var getVisibleTaskIds = exports.getVisibleTaskIds = (0, _reselect.createSelector)(_selectors2.getViewMode, _selectors3.getVisibleTaskIds, _selectors4.getLoadedTaskIds, function (viewMode, kanbanTaskIds, tableTaskIds) {
    return (0, _atUtils.arrayToSet)(viewMode === _constants.TaskManagementViewMode.KANBAN ? kanbanTaskIds : tableTaskIds);
});

/**
 * Visible and existing tasks for filters
 */
var getExistingTaskIdsForView = exports.getExistingTaskIdsForView = (0, _reselect.createSelector)(getExistingTaskIdsByFilters, getVisibleTaskIds, function (existingIds, visibleIds) {
    return _extends({}, existingIds, visibleIds);
});

var isAllTasksSelected = exports.isAllTasksSelected = (0, _reselect.createSelector)(getExistingTaskIdsForView, isExistingTaskIdsLoaded, getSelectedTaskIds, function (existingTaskIds, existingTaskIdsLoaded, selectedTaskIds) {
    return Object.keys(selectedTaskIds).length !== 0 && existingTaskIdsLoaded && Object.keys(existingTaskIds).every(function (id) {
        return !!selectedTaskIds[id];
    });
});

var isAllTasksSelectedCheckboxChecked = exports.isAllTasksSelectedCheckboxChecked = (0, _reselect.createSelector)(isAllTasksSelected, isPendingSelectAll, function (allTasksSelected, pendingSelectAll) {
    return allTasksSelected || pendingSelectAll;
});

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var NO_RIGHT_TO_EDIT_HIERARCHY_EXCEPTION = exports.NO_RIGHT_TO_EDIT_HIERARCHY_EXCEPTION = "com.actimind.actitime.services.NoRightToEditHierarchyException";

// Task
var NO_SUCH_TASK_EXCEPTION = exports.NO_SUCH_TASK_EXCEPTION = "com.actimind.actitime.task.NoSuchTaskException";
var TASK_UNAVAILABLE_EXCEPTION = exports.TASK_UNAVAILABLE_EXCEPTION = "com.actimind.actitime.task.TaskUnavailableException";
var TASK_CANNOT_BE_MODIFIED_EXCEPTION = exports.TASK_CANNOT_BE_MODIFIED_EXCEPTION = "com.actimind.actitime.task.TaskCannotBeModifiedException";
var TASK_ESTIMATE_DISABLED_EXCEPTION = exports.TASK_ESTIMATE_DISABLED_EXCEPTION = "com.actimind.actitime.services.beans.taskmanagement.TaskEstimateDisabledException";
var NO_RIGHTS_TO_MANAGE_TASK_EXCEPTION = exports.NO_RIGHTS_TO_MANAGE_TASK_EXCEPTION = "com.actimind.actitime.services.EditTaskService$NoRightsToManageTaskException";
var TASK_EXISTS_EXCEPTION = exports.TASK_EXISTS_EXCEPTION = "com.actimind.actitime.task.TaskExistsException";
var ACTIVE_TASKS_PROJECT_IS_ARCHIVED_EXCEPTION = exports.ACTIVE_TASKS_PROJECT_IS_ARCHIVED_EXCEPTION = "com.actimind.actitime.task.ActiveTasksProjectIsArchivedException";
var TASK_IS_NOT_ASSIGNED_TO_USER_EXCEPTION = exports.TASK_IS_NOT_ASSIGNED_TO_USER_EXCEPTION = "com.actimind.actitime.task.TaskIsNotAssignedToUserException";

// Project
var PROJECT_IS_NOT_AVAILABLE_EXCEPTION = exports.PROJECT_IS_NOT_AVAILABLE_EXCEPTION = "com.actimind.actitime.task.ProjectIsNotAvailableException";
var PROJECT_CANNOT_BE_MODIFIED_EXCEPTION = exports.PROJECT_CANNOT_BE_MODIFIED_EXCEPTION = "com.actimind.actitime.project.ProjectCannotBeModifiedException";
var PROJECT_IS_ARCHIVED_EXCEPTION = exports.PROJECT_IS_ARCHIVED_EXCEPTION = "com.actimind.actitime.task.ProjectIsArchivedException";
var NO_SUCH_PROJECT_EXCEPTION = exports.NO_SUCH_PROJECT_EXCEPTION = "com.actimind.actitime.project.NoSuchProjectException";
var PROJECT_IS_NOT_ASSIGNED_EXCEPTION = exports.PROJECT_IS_NOT_ASSIGNED_EXCEPTION = "com.actimind.actitime.project.ProjectIsNotAssignedException";
var PROJECT_EXISTS_EXCEPTION = exports.PROJECT_EXISTS_EXCEPTION = "com.actimind.actitime.project.ProjectExistsException";

// Customer
var CUSTOMER_CANNOT_BE_MODIFIED_EXCEPTION = exports.CUSTOMER_CANNOT_BE_MODIFIED_EXCEPTION = "com.actimind.actitime.customer.CustomerCannotBeModifiedException";
var CUSTOMER_UNAVAILABLE_EXCEPTION = exports.CUSTOMER_UNAVAILABLE_EXCEPTION = "com.actimind.actitime.customer.CustomerUnavailableException";
var NO_SUCH_CUSTOMER_EXCEPTION = exports.NO_SUCH_CUSTOMER_EXCEPTION = "com.actimind.actitime.customer.NoSuchCustomerException";
var CUSTOMER_IS_NOT_ASSIGNED_EXCEPTION = exports.CUSTOMER_IS_NOT_ASSIGNED_EXCEPTION = "com.actimind.actitime.customer.CustomerIsNotAssignedException";
var CUSTOMER_ARCHIVED_EXCEPTION = exports.CUSTOMER_ARCHIVED_EXCEPTION = "com.actimind.actitime.customer.CustomerArchivedException";

// Statuses
var WORKFLOW_STATUS_CHANGED_EXCEPTION = exports.WORKFLOW_STATUS_CHANGED_EXCEPTION = "com.actimind.actitime.services.WorkflowStatusChangedException";
var NO_SUCH_WORKFLOW_STATUSES_EXCEPTION = exports.NO_SUCH_WORKFLOW_STATUSES_EXCEPTION = "com.actimind.actitime.administration.NoSuchWorkflowStatusException";
var WORKFLOW_STATUSES_FEATURE_BECOME_ENABLED_EXCEPTION = exports.WORKFLOW_STATUSES_FEATURE_BECOME_ENABLED_EXCEPTION = "com.actimind.actitime.services.WorkflowStatusesFeatureBecameEnabledException";
var WORKFLOW_STATUSES_FEATURE_BECAME_DISABLED_EXCEPTION = exports.WORKFLOW_STATUSES_FEATURE_BECAME_DISABLED_EXCEPTION = "com.actimind.actitime.services.WorkflowStatusesFeatureBecameDisabledException";

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var Exceptions = exports.Exceptions = {
    NO_RIGHTS_FOR_REMOTE_CALL_EXCEPTION: "com.actimind.actitime.services.NoRightsForRemoteCallException",
    NO_RIGHTS_TO_SUBMIT_TT_EXCEPTION: "com.actimind.actitime.services.NoRightsToSubmitTTException",
    USER_HAS_NO_ACCESS_TO_SCOPE_EXCEPTION: "com.actimind.actitime.services.UserHasNoAccessToScopeException",
    WORK_ASSIGNMENTS_FEATURE_DISABLED_EXCEPTION: "com.actimind.actitime.services.WorkAssignmentsFeatureDisabledException",
    USER_IS_NOT_ASSIGNED_TO_MANAGER_EXCEPTION: "com.actimind.actitime.services.UserIsNotAssignedToManagerException",
    USER_IS_DISABLED_EXCEPTION: "com.actimind.actitime.administration.UserIsDisabledException",
    NO_SUCH_USER_EXCEPTION: "com.actimind.actitime.administration.NoSuchUserException"
};

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _atBrowserUtils = __webpack_require__(8);

var _Moire = __webpack_require__(785);

var _index = __webpack_require__(48);

var _utils = __webpack_require__(25);

var _ScrollUtils = __webpack_require__(39);

var _ScrollUtils2 = _interopRequireDefault(_ScrollUtils);

var _constants = __webpack_require__(77);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PanelContainer = function (_TemplateView) {
    _inherits(PanelContainer, _TemplateView);

    function PanelContainer(_ref) {
        var _ref$component = _ref.component,
            component = _ref$component === undefined ? null : _ref$component,
            _ref$additionalClass = _ref.additionalClass,
            additionalClass = _ref$additionalClass === undefined ? "" : _ref$additionalClass,
            _ref$onShowCallback = _ref.onShowCallback,
            onShowCallback = _ref$onShowCallback === undefined ? function () {} : _ref$onShowCallback,
            _ref$onHideCallback = _ref.onHideCallback,
            onHideCallback = _ref$onHideCallback === undefined ? function () {} : _ref$onHideCallback,
            _ref$onClickContentCa = _ref.onClickContentCallback,
            onClickContentCallback = _ref$onClickContentCa === undefined ? function (e) {} : _ref$onClickContentCa,
            _ref$showAnimationCla = _ref.showAnimationClass,
            showAnimationClass = _ref$showAnimationCla === undefined ? "" : _ref$showAnimationCla,
            _ref$hideAnimationCla = _ref.hideAnimationClass,
            hideAnimationClass = _ref$hideAnimationCla === undefined ? "" : _ref$hideAnimationCla,
            _ref$showCopyLink = _ref.showCopyLink,
            showCopyLink = _ref$showCopyLink === undefined ? false : _ref$showCopyLink,
            _ref$copyLinkTooltipT = _ref.copyLinkTooltipText,
            copyLinkTooltipText = _ref$copyLinkTooltipT === undefined ? '' : _ref$copyLinkTooltipT,
            _ref$showHideButton = _ref.showHideButton,
            showHideButton = _ref$showHideButton === undefined ? false : _ref$showHideButton,
            _ref$hideOnEsc = _ref.hideOnEsc,
            hideOnEsc = _ref$hideOnEsc === undefined ? false : _ref$hideOnEsc,
            _ref$hideOnClickOutsi = _ref.hideOnClickOutside,
            hideOnClickOutside = _ref$hideOnClickOutsi === undefined ? {
            hideOnClick: false,
            outsideElement: (0, _jquery2.default)(document),
            panelType: ""
        } : _ref$hideOnClickOutsi,
            _ref$preventHidingCal = _ref.preventHidingCallback,
            preventHidingCallback = _ref$preventHidingCal === undefined ? function () {
            return false;
        } : _ref$preventHidingCal,
            showMoire = _ref.showMoire,
            _ref$hideHandler = _ref.hideHandler,
            hideHandler = _ref$hideHandler === undefined ? function () {
            return _this.setState({ isShown: false });
        } : _ref$hideHandler,
            _ref$onCopyLinkClick = _ref.onCopyLinkClick,
            onCopyLinkClick = _ref$onCopyLinkClick === undefined ? function () {} : _ref$onCopyLinkClick,
            _ref$onClickCloseButt = _ref.onClickCloseButton,
            onClickCloseButton = _ref$onClickCloseButt === undefined ? function () {} : _ref$onClickCloseButt,
            taskNextId = _ref.taskNextId,
            headerButtons = _ref.headerButtons;

        _classCallCheck(this, PanelContainer);

        var _this = _possibleConstructorReturn(this, (PanelContainer.__proto__ || Object.getPrototypeOf(PanelContainer)).call(this));

        _this.state = {
            isShown: false,
            taskNextId: taskNextId
        };

        _this.params = {
            component: component,
            additionalClass: additionalClass,
            onHideCallback: onHideCallback,
            onShowCallback: onShowCallback,
            onClickContentCallback: onClickContentCallback,
            showAnimationClass: showAnimationClass,
            hideAnimationClass: hideAnimationClass,
            showCopyLink: showCopyLink,
            copyLinkTooltipText: copyLinkTooltipText,
            showHideButton: showHideButton,
            hideOnEsc: hideOnEsc,
            hideOnClickOutside: hideOnClickOutside,
            preventHidingCallback: preventHidingCallback,
            showMoire: showMoire,
            hideHandler: hideHandler,
            onCopyLinkClick: onCopyLinkClick,
            onClickCloseButton: onClickCloseButton,
            headerButtons: headerButtons
        };

        _this.onStatePropertyChanged('isShown', function (isShown) {
            return _this.toggle(isShown);
        });
        return _this;
    }

    _createClass(PanelContainer, [{
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='<%-additionalClass%> components_panelContainer'>" + "  <div class='content_panelContainer'/>" + "  <div class='headerButtons_panelContainer'/>" + "  <div class='copyLink_panelContainer' title='<%-copyLinkTooltipText%>'><%=copyLink%></div>" + "  <div class='hideButton_panelContainer'/>" + "</div>";
        }
    }, {
        key: "messageKeys",
        value: function messageKeys() {
            return {
                copyLink: 'panel.common.copy_link'
            };
        }
    }, {
        key: "templateModel",
        value: function templateModel() {
            return {
                additionalClass: this.params.additionalClass,
                copyLinkTooltipText: this.params.copyLinkTooltipText
            };
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            var _this2 = this;

            this.$el.click(this.params.onClickContentCallback);

            this.$content = this.find(".content_panelContainer");
            this.$hideButton = this.find(".hideButton_panelContainer");
            this.$copyLink = this.find(".copyLink_panelContainer");
            this.params.component.init(this.$content);
            this.$headerButtons = this.find(".headerButtons_panelContainer");

            this.params.headerButtons && this.params.headerButtons.appendTo(this.$headerButtons);
            this.$headerButtons.toggleClass('noCopyLink', !this.params.showCopyLink);

            if (this.params.showCopyLink) {
                this.$copyLink.click(function () {
                    return _this2.params.onCopyLinkClick();
                });
            } else {
                this.$copyLink.hide();
            }

            if (!this.params.showHideButton) {
                this.$hideButton.hide();
            } else {
                this.$hideButton.click(function () {
                    return _this2.params.onClickCloseButton();
                });
            }
            this.getEl().hide();

            this.params.component.stopHandlingStateChanges();

            this.$el.on(_ScrollUtils2.default.getWheelEventName(), function (e) {
                if (!(0, _atBrowserUtils.checkElementOrAncestorHasClass)(e.target, _constants.AtNextCustomScrollbarUsedClassName)) {
                    e.preventDefault();
                }
            });
        }
    }, {
        key: "hide",
        value: function hide() {
            this.params.component.stopHandlingStateChanges();

            if (this.params.hideAnimationClass) this.$el.atAnimation().hideAnimated(this.params.hideAnimationClass);else this.$el.hide();

            if (this.params.hideOnEsc) this._unsubscribeEscapeEventListener();

            if (this.params.hideOnClickOutside.hideOnClick) this._unsubscribeOnOutsideClick();

            this.params.onHideCallback();

            if (this.params.showMoire) {
                _Moire.Moire.getInstance().hide();
            }
        }
    }, {
        key: "show",
        value: function show() {
            this.params.component.resumeHandlingStateChanges();

            if (this.params.showAnimationClass) this.$el.atAnimation().showAnimated(this.params.showAnimationClass);else this.$el.show();

            if (this.params.hideOnClickOutside.hideOnClick) this._subscribeOnOutsideClick();

            if (this.params.hideOnEsc) this._subscribeEscapeEventListener();

            this.params.onShowCallback();

            if (this.params.showMoire) {
                _Moire.Moire.getInstance().show();
            }
        }
    }, {
        key: "_subscribeOnOutsideClick",
        value: function _subscribeOnOutsideClick() {
            var _this3 = this;

            var config = this.params.hideOnClickOutside;

            this._unsubscribeOnClickOutsideCb = (0, _atBrowserUtils.registerOnClickOutside)(this.$el, config.panelType, function () {
                return _this3.params.hideHandler();
            }, function (e) {
                return _this3.params.preventHidingCallback(e) || (0, _utils.shouldEventPreventHiding)(e, config.panelType) || (0, _utils.shouldEventPreventHidingAllPanels)(e);
            }, config.outsideElement);
        }
    }, {
        key: "_unsubscribeOnOutsideClick",
        value: function _unsubscribeOnOutsideClick() {
            if (this._unsubscribeOnClickOutsideCb) this._unsubscribeOnClickOutsideCb();
        }
    }, {
        key: "_unsubscribeEscapeEventListener",
        value: function _unsubscribeEscapeEventListener() {
            if (this._restoreOldKeydownHandler) this._restoreOldKeydownHandler();
        }
    }, {
        key: "_subscribeEscapeEventListener",
        value: function _subscribeEscapeEventListener() {
            var _this4 = this;

            this._restoreOldKeydownHandler = (0, _index.onKeyDown)(function (keycode, e) {
                if ((0, _index.isEsc)(keycode)) {
                    _this4.params.hideHandler();
                    return true;
                }
            });
        }
    }]);

    return PanelContainer;
}(_TemplateView3.default);

exports.default = PanelContainer;

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ModalAlertOffsets;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ModalAlertPointerPosition = exports.ModalAlertPointerPosition = {
    LEFT: 'left',
    CENTER: 'center',
    RIGHT: 'right'
};

var ModalAlertOffsets = exports.ModalAlertOffsets = (_ModalAlertOffsets = {}, _defineProperty(_ModalAlertOffsets, ModalAlertPointerPosition.LEFT, {
    left: -50,
    top: 20
}), _defineProperty(_ModalAlertOffsets, ModalAlertPointerPosition.CENTER, {
    left: 0,
    top: 20
}), _defineProperty(_ModalAlertOffsets, ModalAlertPointerPosition.RIGHT, {
    left: 50,
    top: 20
}), _ModalAlertOffsets);

/***/ }),
/* 111 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(88);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(112);
var IObject = __webpack_require__(273);
var toObject = __webpack_require__(58);
var toLength = __webpack_require__(54);
var asc = __webpack_require__(427);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(10);
var core = __webpack_require__(37);
var fails = __webpack_require__(32);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = StringIndex;

var _StringTokenizer = __webpack_require__(103);

var _StringTokenizer2 = _interopRequireDefault(_StringTokenizer);

var _DiacriticsUtil = __webpack_require__(451);

var _DiacriticsUtil2 = _interopRequireDefault(_DiacriticsUtil);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// TODO: convert to class
function StringIndex(tokenizer) {
    this.index = {};
    this.tokenizer = tokenizer || new _StringTokenizer2.default();
}

StringIndex.prototype.getFirstCharWithoutDiacritics = function (token) {
    var firstChar = token.charAt(0);
    //noinspection JSUnresolvedVariable
    var nonDiacriticFirstChar = window.DiacriticsUtilConstants.LIGATURES_REVERSE_MAP[firstChar];
    if (nonDiacriticFirstChar) return nonDiacriticFirstChar.charAt(0);
    //noinspection JSUnresolvedVariable
    nonDiacriticFirstChar = window.DiacriticsUtilConstants.DIACRITICS_REVERSE_MAP[firstChar];
    if (nonDiacriticFirstChar) return nonDiacriticFirstChar;
    return firstChar;
};

StringIndex.prototype._getTokenObject = function (token, create) {
    var firstChar = this.getFirstCharWithoutDiacritics(token);
    var firstCharObject = this.index[firstChar];
    if (!firstCharObject) {
        firstCharObject = {};
        this.index[firstChar] = firstCharObject;
    }
    var tokenObject = firstCharObject[token];
    if (!tokenObject && create) {
        tokenObject = {};
        firstCharObject[token] = tokenObject;
    }

    return tokenObject;
};

StringIndex.prototype.addToken = function (token, objId) {
    this._getTokenObject(token, true)[objId] = objId;
};

StringIndex.prototype.removeToken = function (token, objId) {
    var tokenObject = this._getTokenObject(token, false);
    if (tokenObject) delete tokenObject[objId];
};

StringIndex.prototype.getTokenizer = function () {
    return this.tokenizer;
};

StringIndex.prototype.addTokens = function (tokens, objId) {
    for (var i = 0; i < tokens.length; i++) {
        this.addToken(tokens[i], objId);
    }
};

StringIndex.prototype.removeTokens = function (tokens, objId) {
    for (var i = 0; i < tokens.length; i++) {
        this.removeToken(tokens[i], objId);
    }
};

StringIndex.prototype.add = function (str, objId) {
    var tokens = this.tokenizer.getTokens(str.toLowerCase());
    this.addTokens(tokens, objId);
};

StringIndex.prototype.remove = function (str, objId) {
    var tokens = this.tokenizer.getTokens(str.toLowerCase());
    this.removeTokens(tokens, objId);
};

StringIndex.prototype.search = function (tokens) {
    var result = {};

    if (tokens.length == 0) return result;

    this.addIdsForToken(tokens[0], result);

    for (var i = 1; i < tokens.length; i++) {
        result = this.intersectWithSearchResultsForToken(tokens[i], result);
    }return result;
};

StringIndex.prototype.createTokenPattern = function (token) {
    //noinspection JSUnresolvedVariable, JSUnresolvedFunction
    return new RegExp("^" + _DiacriticsUtil2.default.makeMatchingRegexp(token));
};

StringIndex.prototype.addIdsForToken = function (token, result) {
    var firstChar = this.getFirstCharWithoutDiacritics(token);
    var firstCharObject = this.index[firstChar];
    if (firstCharObject) {
        var regexp = this.createTokenPattern(token);
        for (var str in firstCharObject) {
            //noinspection JSUnfilteredForInLoop
            if (regexp.test(str)) {
                //noinspection JSUnfilteredForInLoop
                var strObj = firstCharObject[str];
                for (var id in strObj) {
                    //noinspection JSUnfilteredForInLoop
                    result[id] = id;
                }
            }
        }
    }
};

StringIndex.prototype.intersectWithSearchResultsForToken = function (token, result) {
    var intersection = {};
    var firstChar = this.getFirstCharWithoutDiacritics(token);
    var firstCharObject = this.index[firstChar];
    if (firstCharObject) {
        var regexp = this.createTokenPattern(token);
        for (var str in firstCharObject) {
            //noinspection JSUnfilteredForInLoop
            if (regexp.test(str)) {
                //noinspection JSUnfilteredForInLoop
                var strObj = firstCharObject[str];
                for (var id in strObj) {
                    //noinspection JSUnfilteredForInLoop
                    if (result[id])
                        //noinspection JSUnfilteredForInLoop
                        intersection[id] = id;
                }
            }
        }
    }
    return intersection;
};

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var dayStatuses = exports.dayStatuses = {
    CORPORATE_HOLIDAY: 'corporateHoliday',
    NON_STANDARD_WORKING_DAY: 'nonStandardWorkingDay',
    STANDARD_DAY: 'standardDay'
};

var MONTH_NAME_KEYS = exports.MONTH_NAME_KEYS = ["month.full.jan", "month.full.feb", "month.full.mar", "month.full.apr", "month.full.may", "month.full.jun", "month.full.jul", "month.full.aug", "month.full.sep", "month.full.oct", "month.full.nov", "month.full.dec"];

var ABBR_DAY_NAME_KEYS = exports.ABBR_DAY_NAME_KEYS = ["week.abbr.sun", "week.abbr.mon", "week.abbr.tue", "week.abbr.wed", "week.abbr.thu", "week.abbr.fri", "week.abbr.sat"];

var SHORT_DAY_NAME_KEYS = exports.SHORT_DAY_NAME_KEYS = ['week.short.capital.sun', 'week.short.capital.mon', 'week.short.capital.tue', 'week.short.capital.wed', 'week.short.capital.thu', 'week.short.capital.fri', 'week.short.capital.sat'];

var WORK_SCHEDULE_YEAR_START = exports.WORK_SCHEDULE_YEAR_START = 2003;

var corporateHolidayEditorModes = exports.corporateHolidayEditorModes = {
    CHANGE_NAME: 'changeName',
    DELETE: 'delete',
    MARK_AS_WORKING: 'markAsWorking'
};

var sortBy = exports.sortBy = {
    DATE: 'date',
    NAME: 'name'
};
var Exception = exports.Exception = {
    RETRIEVE_HOLIDAYS_EXCEPTION: 'com.actimind.common.services.RetrieveHolidaysException',
    RETRIEVE_COUNTRIES_EXCEPTION: 'com.actimind.common.services.RetrieveCountriesException'
};

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.batched = batched;
exports.batchedPromise = batchedPromise;
exports.batchReducerWrapper = batchReducerWrapper;
exports.batchMiddleware = batchMiddleware;

var _store = __webpack_require__(222);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var BATCH_ACTION_TYPE = '@@BATCH';

/**
 * Current batch wrapper call depth.
 * @type {number}
 */
var depth = 0;

/**
 * This array contains batch of real action objects, which are dispatched when batch wrapper ends execution.
 * @type {Array}
 */
var accumulatedActions = [];

/**
 * Wraps any function enabling redux actions batching while function is executed.
 * @param f {Function}
 * @returns {Function|undefined}
 */
function batched(f) {
    if (!f) {
        return;
    }

    return function () {
        // Mark batched execution start.
        // Wrapped function may call another batch wrapper, each call increments counter more.
        depth++;

        try {
            return f.apply(this, arguments);
        } finally {
            if (--depth === 0 && accumulatedActions.length > 0) {
                // All batched execution is completed, dispatch special action
                var payload = accumulatedActions;
                accumulatedActions = [];
                (0, _store.getStore)().dispatch({ type: BATCH_ACTION_TYPE, payload: payload });
            }
        }
    };
}

/**
 * Wraps any promise enabling redux actions batching while resolving promises.
 * .then() and .catch() calls are wrapped as well as consecutive promises in the chain.
 *
 * Example:
 *
 * batchedPromise(somePromise)
 *     .then(() => {
 *         // batched actions are enabled here
 *     })
 *     .then(() => {
 *         // batched actions are enabled here too
 *     })
 *     .catch(() => {
 *         // batched actions are enabled here too
 *     })
 *
 * @returns {BatchPromiseWrapper}
 */
function batchedPromise(p) {
    return new BatchPromiseWrapper(p);
}

var BatchPromiseWrapper = function () {
    function BatchPromiseWrapper(promise) {
        _classCallCheck(this, BatchPromiseWrapper);

        this.promise = promise;
    }

    _createClass(BatchPromiseWrapper, [{
        key: 'then',
        value: function then(onResolve, onReject) {
            return new BatchPromiseWrapper(this.promise.then(batched(onResolve), batched(onReject)));
        }
    }, {
        key: 'catch',
        value: function _catch(onReject) {
            return new BatchPromiseWrapper(this.promise.catch(batched(onReject)));
        }
    }]);

    return BatchPromiseWrapper;
}();

/**
 * Wraps reducer enabling support of batched actions.
 * @param reducer
 * @returns {Function}
 */


function batchReducerWrapper(reducer) {
    return function (state, action) {
        if (action.type === BATCH_ACTION_TYPE) {
            // Call original reducer for every action in batch
            return action.payload.reduce(reducer, state);
        } else {
            // Pass regular actions directly into original reducer
            return reducer(state, action);
        }
    };
}

/**
 * Redux middleware for catching action objects and collecting them into batch.
 */
function batchMiddleware() {
    return function (next) {
        return function (action) {
            if (depth > 0 && typeof action !== 'function') {
                accumulatedActions.push(action);
                return action;
            }

            return next(action);
        };
    };
}

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getFeaturesChangesMessage = exports.isEnabled = undefined;

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isEnabled = exports.isEnabled = function isEnabled(features, feature) {
    return features[feature] === true;
};

var getFeaturesChangesMessage = exports.getFeaturesChangesMessage = function getFeaturesChangesMessage(featuresChanges) {
    return Object.keys(featuresChanges).reduce(function (msg, feature) {
        var featureTitle = _messageResource2.default.getMessage('features.' + feature + '.title');
        var msgKey = featuresChanges[feature] ? 'common.admin_enabled_functionality' : 'common.admin_disabled_functionality';
        return msg.concat(_messageResource2.default.getMessage(msgKey, [featureTitle]));
    }, '');
};

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _UserNameFormat = __webpack_require__(17);

var _UserNameFormat2 = _interopRequireDefault(_UserNameFormat);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var User = function () {
    function User(id, firstName, lastName, middleName, username, active, emailExists, userGroupId, timeZoneGroupId, isPTO, isSick, isOvertimeTracking, overtimeTrackingLevel) {
        _classCallCheck(this, User);

        this.id = id;
        this.firstName = firstName;
        this.lastName = lastName;
        this.middleName = middleName;
        this.username = username;
        this.active = active;
        this.emailExists = emailExists;
        this.userGroupId = userGroupId;
        this.timeZoneGroupId = timeZoneGroupId;
        this.isPTO = isPTO;
        this.isSick = isSick;
        this.isOvertimeTracking = isOvertimeTracking;
        this.overtimeTrackingLevel = overtimeTrackingLevel;
    }

    _createClass(User, [{
        key: "isActive",
        value: function isActive() {
            return this.active;
        }
    }, {
        key: "formatNameFMLU",
        value: function formatNameFMLU() {
            return _UserNameFormat2.default.formatFMLU(this.firstName, this.lastName, this.middleName, this.username);
        }
    }, {
        key: "formatNameFML",
        value: function formatNameFML() {
            return _UserNameFormat2.default.formatFML(this.firstName, this.lastName, this.middleName);
        }
    }, {
        key: "formatNameLFMU",
        value: function formatNameLFMU() {
            return _UserNameFormat2.default.formatLFMU(this.firstName, this.lastName, this.middleName, this.username);
        }
    }, {
        key: "formatNameLFM",
        value: function formatNameLFM() {
            return _UserNameFormat2.default.formatLFM(this.firstName, this.lastName, this.middleName);
        }
    }, {
        key: "getUserGroupId",
        value: function getUserGroupId() {
            return this.userGroupId;
        }
    }, {
        key: "getTimeZoneGroupId",
        value: function getTimeZoneGroupId() {
            return this.timeZoneGroupId;
        }
    }, {
        key: "clone",
        value: function clone() {
            return new User(this.id, this.firstName, this.lastName, this.middleName, this.username, this.active, this.emailExists, this.userGroupId, this.timeZoneGroupId, this.isPTO, this.isSick, this.isOvertimeTracking, this.overtimeTrackingLevel);
        }
    }, {
        key: "hasEmail",
        value: function hasEmail() {
            return this.emailExists;
        }
    }, {
        key: "setRequiresTTApproval",
        value: function setRequiresTTApproval(isRequiresTTApproval) {
            this.isRequiresTTApproval = isRequiresTTApproval;
        }
    }]);

    return User;
}();

exports.default = User;

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.NUMBER_ALLOWED_CHARACTERS = exports.LOAD_COMMENTS_LIMIT = exports.COMMENTS_SCROLL_TO = exports.LOGGED_IN_USER_ICON_COLOR = exports.USER_INITIALS_ICON_COLORS = undefined;

var _constants = __webpack_require__(4);

var USER_INITIALS_ICON_COLORS = exports.USER_INITIALS_ICON_COLORS = [
//'#3f6bb5', this color used for logged in user
'#8bc34a', '#ff9800', '#e91e63', '#009688', '#b7c621', '#2196f3', '#4caf50', '#607d8b', '#f44336', '#9c3dac', '#00bcd4', '#795548', '#9e9e9e', '#673ab7'];

var LOGGED_IN_USER_ICON_COLOR = exports.LOGGED_IN_USER_ICON_COLOR = '#3f6bb5';

var COMMENTS_SCROLL_TO = exports.COMMENTS_SCROLL_TO = {
    RECENTLY_ADDED: 'recentlyAdded',
    LOADED_OLDER: 'loadedOlder'
};

var LOAD_COMMENTS_LIMIT = exports.LOAD_COMMENTS_LIMIT = 10;

var NUMBER_ALLOWED_CHARACTERS = exports.NUMBER_ALLOWED_CHARACTERS = _constants.EntityTextLimits.MAX_CPT_COMMENT;

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.splitToLines = splitToLines;
exports.insertBrakes = insertBrakes;
exports.convertLineBreaksToBR = convertLineBreaksToBR;
exports.cutLongText = cutLongText;
exports.cutNumberOfTextLines = cutNumberOfTextLines;
exports.isNotEmptyString = isNotEmptyString;
exports.isNullOrBlank = isNullOrBlank;

var _atUtils = __webpack_require__(5);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function splitToLines(str, limit, delimiter, partsLimit, ellipsis, recursively) {
    if (str.length < limit) return [str];

    var indices = [];
    for (var i = 0; i < str.length; i++) {
        if (str[i] === delimiter) indices.push(i);
    }
    if (indices.length == 0) {
        return [str.substr(0, partsLimit - ellipsis.length) + ellipsis];
    }
    //lets find delimiter which is the closest one to string's middle!
    var stringMiddle = str.length / 2;
    var closest = indices[0];
    _jquery2.default.each(indices, function (i, item) {
        if (Math.abs(item - stringMiddle) < Math.abs(closest - stringMiddle)) {
            closest = item;
        }
    });
    var part1 = str.substr(0, closest).trim();
    var parts1 = part1.length > partsLimit ? recursively ? splitToLines(part1, limit, delimiter, partsLimit, ellipsis, true) : [part1.substr(0, partsLimit) + (ellipsis ? ellipsis : "")] : [part1];
    var part2 = str.substr(closest).trim();
    var parts2 = part2.length > partsLimit ? recursively ? splitToLines(part2, limit, delimiter, partsLimit, ellipsis, true) : [part2.substr(0, partsLimit) + (ellipsis ? ellipsis : "")] : [part2];
    return _jquery2.default.merge(parts1, parts2);
}

function insertBrakes(str, limit, delimiter, partsLimit, ellipsis, escape, recursively) {
    var parts = splitToLines(str, limit, delimiter, partsLimit, ellipsis, recursively);
    var result = escape ? (0, _atUtils.escapeHtmlSymbols)(parts[0]) : parts[0];
    for (var i = 1; i < parts.length; i++) {
        result += "<br>" + (escape ? (0, _atUtils.escapeHtmlSymbols)(parts[i]) : parts[i]);
    }
    return result;
}

function convertLineBreaksToBR(str) {
    return str.replace(/\n/g, "<br>");
}

function cutLongText(str, maxLen) {
    if (str && str.length > maxLen) {
        return str.substr(0, maxLen - 3) + '...';
    }
    return str;
}

/**
 * Method detect new line symbol and count lines. If number of lines more than limit - cut remaining text
 * @param str string for cut
 * @param maxLines number of lines
 * @returns {string} cut sting
 */
function cutNumberOfTextLines(str, maxLines) {
    var newLine = '\n';
    var lineCount = 0;
    var charCount;
    var needToLimitStr = false;
    for (charCount = 0; charCount < str.length; charCount++) {
        var currentChar = str[charCount];
        if (currentChar == newLine) {
            lineCount++;
        }
        if (lineCount >= maxLines) {
            needToLimitStr = true;
            break;
        }
    }
    if (needToLimitStr) {
        return str.substr(0, charCount) + "\n...";
    }
    return str;
}

/**
 * @param str (could be null or undefined)
 * @returns {boolean} is string not empty
 */
function isNotEmptyString(str) {
    return _underscore2.default.isString(str) && str.length > 0;
}

function isNullOrBlank(str) {
    return !str || _underscore2.default.isEmpty(str.trim());
}

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PDFImageCache = function () {
    function PDFImageCache() {
        _classCallCheck(this, PDFImageCache);

        this.imagesCache = {};
    }

    /**
     * Preload not cached images
     * @param images map with {name: {url, saveAlpha}}
     * @returns {Promise} on images loaded
     */


    _createClass(PDFImageCache, [{
        key: "preloadImages",
        value: function preloadImages(images) {
            var self = this;
            // filter names of already loaded images
            var names = _underscore2.default.filter(_underscore2.default.keys(images), function (name) {
                return !_underscore2.default.has(self.imagesCache, name);
            });

            var imagePromises = [];
            // create promises for load images
            _underscore2.default.each(names, function (name) {
                var url = images[name]["url"];
                var saveAlpha = images[name]["saveAlpha"];
                saveAlpha = _underscore2.default.isUndefined(saveAlpha) ? false : saveAlpha;
                imagePromises.push(self._createImagePromise(name, url, saveAlpha));
            });
            return Promise.all(imagePromises);
        }
    }, {
        key: "getImage",
        value: function getImage(name) {
            return this.imagesCache[name];
        }
    }, {
        key: "_createImagePromise",
        value: function _createImagePromise(name, url, saveAlpha) {
            var s = this;
            return new Promise(function (resolve) {
                var image = new Image();
                image["onload"] = function () {
                    var canvas = document.createElement('canvas');
                    canvas.width = this.naturalWidth; // or 'width' if you want a special/scaled size
                    canvas.height = this.naturalHeight; // or 'height' if you want a special/scaled size

                    var context = canvas.getContext('2d');
                    context.drawImage(this, 0, 0);
                    // code below needs for set white background for transparent images
                    context.globalCompositeOperation = "destination-over";
                    if (saveAlpha) {
                        context.fillStyle = "rgba(255, 255, 255, 0.0)";
                    } else {
                        context.fillStyle = "#FFFFFF";
                    }
                    context.fillRect(0, 0, this.naturalWidth, this.naturalHeight);

                    // on image load add into cache
                    s.imagesCache[name] = {
                        image: canvas.toDataURL('image/' + (saveAlpha ? 'png' : 'jpeg')),
                        height: this.naturalHeight,
                        width: this.naturalWidth
                    };
                    resolve();
                };
                image.src = url;
            });
        }
    }]);

    return PDFImageCache;
}();

var instance = new PDFImageCache();

exports.default = instance;

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TableCellRenderer2 = __webpack_require__(63);

var _TableCellRenderer3 = _interopRequireDefault(_TableCellRenderer2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LockTableCellRenderer = function (_TableCellRenderer) {
    _inherits(LockTableCellRenderer, _TableCellRenderer);

    function LockTableCellRenderer() {
        _classCallCheck(this, LockTableCellRenderer);

        return _possibleConstructorReturn(this, (LockTableCellRenderer.__proto__ || Object.getPrototypeOf(LockTableCellRenderer)).apply(this, arguments));
    }

    _createClass(LockTableCellRenderer, [{
        key: "updateUI",
        value: function updateUI(cell) {
            var className = [this.getCellClassName(cell), this.getTopBorderClassName(cell), this.getRightBorderClassName(cell), this.getLeftBorderClassName(cell), this.getComplicatedBorderClassName(cell)].join(" ");
            this.setCssClass(cell, className);
        }
    }, {
        key: "getComplicatedBorderClassName",
        value: function getComplicatedBorderClassName(cell) {
            return "";
        }
    }, {
        key: "getTopBorderClassName",
        value: function getTopBorderClassName(cell) {
            var selectionController = this.getSelectionController(cell);
            if (this.isSelected(cell)) {
                if (selectionController.isUpwardmostSelectedCell(cell) && selectionController.visitSelection(this.getSelectionTopBorderChecker())) return "selectionTopBorder";
            } else {
                var upperRowIdx = cell.getRow().getRowIdx() - 1;
                if (upperRowIdx > 0) {
                    var upperCell = cell.getRow().getTable().getCell(upperRowIdx, cell.getColIdx());
                    if (selectionController.isDownwardmostSelectedCell(upperCell) && this.shouldDrawSelectionTopBorder(selectionController)) return "selectionTopBorder";
                }
            }
            return "";
        }
    }, {
        key: "getRightBorderClassName",
        value: function getRightBorderClassName(cell) {
            if (this.isLastCell(cell)) {
                if (this.isSelected(cell) && this.getSelectionController(cell).visitSelection(this.getSelectionRightBorderChecker(cell))) {
                    return "selectionRightBorder";
                } else {
                    return this.getLastCellRightBorderClassName();
                }
            }
            return "";
        }
    }, {
        key: "getLastCellRightBorderClassName",
        value: function getLastCellRightBorderClassName() {
            return "lockTableRightBorder";
        }
    }, {
        key: "getSelectionLeftBorderChecker",
        value: function getSelectionLeftBorderChecker(cell) {
            return {
                visitCellSelection: function visitCellSelection() {
                    return true;
                },
                visitDateSelection: function visitDateSelection() {
                    return true;
                },
                visitRunnerSelection: function visitRunnerSelection() {
                    var runnerController = cell.getRow().getTable().getRunnerController();
                    return runnerController.getLastLockedDate() != null && runnerController.getNewLastLockDate() < runnerController.getLastLockedDate();
                }
            };
        }
    }, {
        key: "shouldDrawSelectionTopBorder",
        value: function shouldDrawSelectionTopBorder(selectionController) {
            return selectionController.visitSelection({
                visitCellSelection: function visitCellSelection() {
                    return true;
                },
                visitDateSelection: function visitDateSelection() {
                    return false;
                },
                visitRunnerSelection: function visitRunnerSelection() {
                    return false;
                }
            });
        }
    }, {
        key: "getSelectionTopBorderChecker",
        value: function getSelectionTopBorderChecker() {
            return {
                visitCellSelection: function visitCellSelection() {
                    return true;
                },
                visitDateSelection: function visitDateSelection() {
                    return false;
                },
                visitRunnerSelection: function visitRunnerSelection() {
                    return false;
                }
            };
        }
    }, {
        key: "getSelectionRightBorderChecker",
        value: function getSelectionRightBorderChecker(cell) {
            return {
                visitCellSelection: function visitCellSelection() {
                    return true;
                },
                visitDateSelection: function visitDateSelection() {
                    return true;
                },
                visitRunnerSelection: function visitRunnerSelection() {
                    var runnerController = cell.getRow().getTable().getRunnerController();
                    return runnerController.getLastLockedDate() == null || runnerController.getNewLastLockDate() > runnerController.getLastLockedDate();
                }
            };
        }
    }, {
        key: "getLeftBorderClassName",
        value: function getLeftBorderClassName(cell) {
            var selectionController = this.getSelectionController(cell);
            if (this.isSelected(cell)) {
                if (selectionController.isLeftmostSelectedCell(cell)) {
                    if (selectionController.visitSelection(this.getSelectionLeftBorderChecker(cell))) return "selectionLeftBorder";
                }
            } else {
                var leftColIdx = cell.getColIdx() - 1;
                if (leftColIdx > 0) {
                    if (selectionController.isRightmostSelectedCell(cell.getRow().getCell(leftColIdx)) && selectionController.visitSelection(this.getSelectionRightBorderChecker(cell))) return "selectionLeftBorder";
                }
            }

            if (cell.getColIdx() > 1) {
                if (this.isFirstCellOfWeek(cell)) return this.getWeekSeparatorClass();
            }
            return this.getLeftBorderSpecificClassName(cell);
        }
    }, {
        key: "getLeftBorderSpecificClassName",
        value: function getLeftBorderSpecificClassName(cell) {
            return "";
        }
    }, {
        key: "getWeekSeparatorClass",
        value: function getWeekSeparatorClass(cell) {
            return "weekSeparator";
        }
    }, {
        key: "isFirstCellOfWeek",
        value: function isFirstCellOfWeek(cell) {
            var columnHeader = cell.getRow().getTable().getFirstRow().getCell(cell.getColIdx());
            return columnHeader.getValue().date.getDay() == cell.getRow().getTable().getWeekStartDay();
        }
    }, {
        key: "getCellClassName",
        value: function getCellClassName(cell) {
            //Note: should be implemented in inheritors
        }
    }, {
        key: "isHovered",
        value: function isHovered(cell) {
            return cell.getRow().getTable().getHoverController().isHovered(cell);
        }
    }, {
        key: "isLastCell",
        value: function isLastCell(cell) {
            return cell.getRow().getCells().length - 1 == cell.getColIdx();
        }
    }, {
        key: "isWorkingCell",
        value: function isWorkingCell(cell) {
            return cell.getRow().getTable().getDatesRow().getCell(cell.getColIdx()).getValue().working;
        }
    }]);

    return LockTableCellRenderer;
}(_TableCellRenderer3.default);

exports.default = LockTableCellRenderer;

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var LeaveTypeStore = {
    leaveTypes: null,
    leaveTypesOrder: null,
    leaveTypesOrdered: null,

    getLeaveTypes: function getLeaveTypes() {
        return this.leaveTypes;
    },

    getLeaveType: function getLeaveType(id) {
        return this.leaveTypes[id];
    },

    setLeaveTypes: function setLeaveTypes(leaveTypes) {
        this.leaveTypes = leaveTypes;
    },

    getLeaveTypesOrder: function getLeaveTypesOrder() {
        return this.leaveTypesOrder;
    },

    setLeaveTypesOrder: function setLeaveTypesOrder(leaveTypesOrder) {
        this.leaveTypesOrder = leaveTypesOrder;
    },

    getLeaveTypesOrdered: function getLeaveTypesOrdered() {
        return this.leaveTypesOrdered;
    },

    setLeaveTypesOrdered: function setLeaveTypesOrdered(leaveTypesOrdered) {
        this.leaveTypesOrdered = leaveTypesOrdered;
    }
};

exports.default = LeaveTypeStore;

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.BALANCE_RULES_VALUES = undefined;
exports.BaseBalanceRulesControl = BaseBalanceRulesControl;
exports.BalanceRulesEditor = BalanceRulesEditor;
exports.AdvancedBalanceRulesEditor = AdvancedBalanceRulesEditor;
exports.BalanceRulesTooltip = BalanceRulesTooltip;
exports.BalanceRulesViewer = BalanceRulesViewer;
exports.BalanceRulesEditorDialog = BalanceRulesEditorDialog;
exports.BalanceRulesManager = BalanceRulesManager;

var _constants = __webpack_require__(4);

var _ClassicBridge = __webpack_require__(18);

var _ClassicBridge2 = _interopRequireDefault(_ClassicBridge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function BaseBalanceRulesControl() {}

var BALANCE_RULES_VALUES = exports.BALANCE_RULES_VALUES = {};
BALANCE_RULES_VALUES.ACCRUAL_RULE_ENABLED = "AccrualRuleEnabled";
BALANCE_RULES_VALUES.ACCRUAL_RULE_VALUE = "AccrualRuleValue";
BALANCE_RULES_VALUES.ACCRUAL_RULE_FREQUENCY_TYPE = "AccrualRuleFrequencyTypeName";
BALANCE_RULES_VALUES.ACCRUAL_RULE_PARAMETERS = "AccrualRuleParameters";
BALANCE_RULES_VALUES.RESET_RULE_FREQUENCY_TYPE = "ResetRuleFrequencyTypeName";
BALANCE_RULES_VALUES.RESET_RULE_PARAMETERS = "ResetRuleParameters";
BALANCE_RULES_VALUES.RESET_RULE_ENABLED = "ResetRuleEnabled";
BALANCE_RULES_VALUES.RESET_RULE_VALUE = "ResetRuleValue";
BALANCE_RULES_VALUES.CAP_RULE_ENABLED = "CapRuleEnabled";
BALANCE_RULES_VALUES.CAP_RULE_VALUE = "CapRuleValue";

BaseBalanceRulesControl.DEFAULT_VALUES = {};
BaseBalanceRulesControl.DEFAULT_VALUES[BALANCE_RULES_VALUES.ACCRUAL_RULE_ENABLED] = true;
BaseBalanceRulesControl.DEFAULT_VALUES[BALANCE_RULES_VALUES.ACCRUAL_RULE_VALUE] = 2;
BaseBalanceRulesControl.DEFAULT_VALUES[BALANCE_RULES_VALUES.ACCRUAL_RULE_FREQUENCY_TYPE] = "MONTHLY";
BaseBalanceRulesControl.DEFAULT_VALUES[BALANCE_RULES_VALUES.ACCRUAL_RULE_PARAMETERS] = [1];
BaseBalanceRulesControl.DEFAULT_VALUES[BALANCE_RULES_VALUES.RESET_RULE_FREQUENCY_TYPE] = "YEARLY";
BaseBalanceRulesControl.DEFAULT_VALUES[BALANCE_RULES_VALUES.RESET_RULE_PARAMETERS] = [1, 1];
BaseBalanceRulesControl.DEFAULT_VALUES[BALANCE_RULES_VALUES.RESET_RULE_ENABLED] = true;
BaseBalanceRulesControl.DEFAULT_VALUES[BALANCE_RULES_VALUES.RESET_RULE_VALUE] = 0;
BaseBalanceRulesControl.DEFAULT_VALUES[BALANCE_RULES_VALUES.CAP_RULE_ENABLED] = true;
BaseBalanceRulesControl.DEFAULT_VALUES[BALANCE_RULES_VALUES.CAP_RULE_VALUE] = 30;

BaseBalanceRulesControl.prototype.init = function (countHoursPerDay) {
    this.values = null;
    this.defaultValues = BaseBalanceRulesControl.DEFAULT_VALUES;

    this.defaultWorkDayDuration = countHoursPerDay;

    this.units = LeaveBalanceUnits.DAYS;
};

// abstract
BaseBalanceRulesControl.prototype._fillElementsWithValues = function (useDefault) {};

BaseBalanceRulesControl.prototype.setValues = function (values) {
    this.values = values;

    if (this.values && this.units == LeaveBalanceUnits.HOURS) this._recalculateValuesFromDaysToHours(this.values);

    if (!this.values) {
        this._fillElementsWithValues(true, true);
        this.values = null;
        return;
    }

    this._fillElementsWithValues(false);
};

BaseBalanceRulesControl.prototype.setBalanceData = function (balanceData) {
    this.setValues(this._getValuesFromBalanaceData(balanceData));
};

BaseBalanceRulesControl.prototype.setDefaultBalanceData = function (defaultBalanceData) {
    this.defaultValues = this._getValuesFromBalanaceData(defaultBalanceData);
    if (!this.defaultValues) this.defaultValues = BaseBalanceRulesControl.DEFAULT_VALUES;

    if (defaultBalanceData && defaultBalanceData.showBalanceInHours) this.setBalanceUnits(LeaveBalanceUnits.HOURS);
};

BaseBalanceRulesControl.prototype._getValues = function () {
    return this.values ? this.values : this.defaultValues;
};

BaseBalanceRulesControl.prototype.setBalanceUnits = function (units) {
    this._recalculateTo(units);
};

BaseBalanceRulesControl.prototype.setWorkdayDuration = function (defaultWorkDayDuration) {
    this.defaultWorkDayDuration = defaultWorkDayDuration / 60;
};

BaseBalanceRulesControl.prototype.setWorkdayDurationInHours = function (defaultWorkDayDurationInHours) {
    this.defaultWorkDayDuration = defaultWorkDayDurationInHours;
};

BaseBalanceRulesControl.prototype._recalculateTo = function (newUnits) {
    if (newUnits == LeaveBalanceUnits.DAYS && this.units == LeaveBalanceUnits.HOURS) this._recalculateFromHoursToDays();else if (newUnits == LeaveBalanceUnits.HOURS && this.units == LeaveBalanceUnits.DAYS) this._recalculateFromDaysToHours();
};

BaseBalanceRulesControl.prototype._recalculateFromHoursToDays = function () {
    this._recalculateValuesFromHoursToDays(this.values);
    this._recalculateValuesFromHoursToDays(this.defaultValues);

    this.units = LeaveBalanceUnits.DAYS;
};

BaseBalanceRulesControl.prototype._recalculateFromDaysToHours = function () {
    this._recalculateValuesFromDaysToHours(this.values);
    this._recalculateValuesFromDaysToHours(this.defaultValues);

    this.units = LeaveBalanceUnits.HOURS;
};

BaseBalanceRulesControl.prototype._recalculateValuesFromHoursToDays = function (values) {
    this._recalculateValueFromHoursToDays(values, BALANCE_RULES_VALUES.ACCRUAL_RULE_VALUE);
    this._recalculateValueFromHoursToDays(values, BALANCE_RULES_VALUES.RESET_RULE_VALUE);
    this._recalculateValueFromHoursToDays(values, BALANCE_RULES_VALUES.CAP_RULE_VALUE);
};

BaseBalanceRulesControl.prototype._recalculateValuesFromDaysToHours = function (values) {
    this._recalculateValueFromDaysToHours(values, BALANCE_RULES_VALUES.ACCRUAL_RULE_VALUE);
    this._recalculateValueFromDaysToHours(values, BALANCE_RULES_VALUES.RESET_RULE_VALUE);
    this._recalculateValueFromDaysToHours(values, BALANCE_RULES_VALUES.CAP_RULE_VALUE);
};

BaseBalanceRulesControl.prototype._recalculateValueFromHoursToDays = function (values, key) {
    if (values) values[key] /= this.defaultWorkDayDuration;
};

BaseBalanceRulesControl.prototype._recalculateValueFromDaysToHours = function (values, key) {
    if (values) values[key] *= this.defaultWorkDayDuration;
};

BaseBalanceRulesControl.prototype._getDefaultValueInDays = function (key) {
    var valueInDays = this.defaultValues[key];
    if (this.units == LeaveBalanceUnits.HOURS) valueInDays /= this.defaultWorkDayDuration;
    return valueInDays;
};

BaseBalanceRulesControl.prototype._getValuesFromBalanaceData = function (balanceData) {
    if (!balanceData) return null;

    var values = {};

    values[BALANCE_RULES_VALUES.ACCRUAL_RULE_ENABLED] = balanceData.accrualRule ? true : false;
    if (values[BALANCE_RULES_VALUES.ACCRUAL_RULE_ENABLED]) {
        values[BALANCE_RULES_VALUES.ACCRUAL_RULE_VALUE] = balanceData.accrualRule.value;
        values[BALANCE_RULES_VALUES.ACCRUAL_RULE_FREQUENCY_TYPE] = balanceData.accrualRule.frequency.type;
        values[BALANCE_RULES_VALUES.ACCRUAL_RULE_PARAMETERS] = balanceData.accrualRule.frequency.params;
    } else {
        values[BALANCE_RULES_VALUES.ACCRUAL_RULE_VALUE] = this._getDefaultValueInDays(BALANCE_RULES_VALUES.ACCRUAL_RULE_VALUE);
        values[BALANCE_RULES_VALUES.ACCRUAL_RULE_FREQUENCY_TYPE] = this.defaultValues[BALANCE_RULES_VALUES.ACCRUAL_RULE_FREQUENCY_TYPE];
        values[BALANCE_RULES_VALUES.ACCRUAL_RULE_PARAMETERS] = this.defaultValues[BALANCE_RULES_VALUES.ACCRUAL_RULE_PARAMETERS];
    }

    if (values[BALANCE_RULES_VALUES.ACCRUAL_RULE_FREQUENCY_TYPE] == _constants.CalendarFrequencyType.ON_HIRE_DATE) {
        values[BALANCE_RULES_VALUES.ACCRUAL_RULE_PARAMETERS] = [balanceData.hireDate];
    }

    values[BALANCE_RULES_VALUES.RESET_RULE_ENABLED] = balanceData.resetRule ? true : false;
    if (values[BALANCE_RULES_VALUES.RESET_RULE_ENABLED]) {
        values[BALANCE_RULES_VALUES.RESET_RULE_VALUE] = balanceData.resetRule.value;
        values[BALANCE_RULES_VALUES.RESET_RULE_FREQUENCY_TYPE] = balanceData.resetRule.frequency.type;
        values[BALANCE_RULES_VALUES.RESET_RULE_PARAMETERS] = balanceData.resetRule.frequency.params;
    } else {
        values[BALANCE_RULES_VALUES.RESET_RULE_VALUE] = this._getDefaultValueInDays(BALANCE_RULES_VALUES.RESET_RULE_VALUE);
        values[BALANCE_RULES_VALUES.RESET_RULE_FREQUENCY_TYPE] = this.defaultValues[BALANCE_RULES_VALUES.RESET_RULE_FREQUENCY_TYPE];
        values[BALANCE_RULES_VALUES.RESET_RULE_PARAMETERS] = this.defaultValues[BALANCE_RULES_VALUES.RESET_RULE_PARAMETERS];
    }
    if (values[BALANCE_RULES_VALUES.RESET_RULE_FREQUENCY_TYPE] == _constants.CalendarFrequencyType.ON_HIRE_DATE) {
        values[BALANCE_RULES_VALUES.RESET_RULE_PARAMETERS] = [balanceData.hireDate];
    }

    values[BALANCE_RULES_VALUES.CAP_RULE_ENABLED] = balanceData.balanceCap !== null;
    if (values[BALANCE_RULES_VALUES.CAP_RULE_ENABLED]) values[BALANCE_RULES_VALUES.CAP_RULE_VALUE] = balanceData.balanceCap;else values[BALANCE_RULES_VALUES.CAP_RULE_VALUE] = this._getDefaultValueInDays(BALANCE_RULES_VALUES.CAP_RULE_VALUE);

    return values;
};

/**
 * Requires: smart_field.js, constants_js.jsp, system_settings_js.jsp, date_js.jsp, dropdown_list_button.js
 * @param balanceRulesTypePrefix
 * @param parameters
 * parameters[accrueRuleLabel]
 * parameters[resetRuleLabel]
 * parameters[capRuleLabel]
 * @param changesCallback
 * @param countHoursPerDay
 * @param [decimalSeparator]
 * @param scrollableContainer
 **/

function BalanceRulesEditor() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$balanceRulesType = _ref.balanceRulesTypePrefix,
        balanceRulesTypePrefix = _ref$balanceRulesType === undefined ? '' : _ref$balanceRulesType,
        _ref$parameters = _ref.parameters,
        parameters = _ref$parameters === undefined ? {} : _ref$parameters,
        _ref$changesCallback = _ref.changesCallback,
        changesCallback = _ref$changesCallback === undefined ? function () {} : _ref$changesCallback,
        _ref$countHoursPerDay = _ref.countHoursPerDay,
        countHoursPerDay = _ref$countHoursPerDay === undefined ? '' : _ref$countHoursPerDay,
        _ref$decimalSeparator = _ref.decimalSeparator,
        decimalSeparator = _ref$decimalSeparator === undefined ? '' : _ref$decimalSeparator,
        _ref$scrollableContai = _ref.scrollableContainer,
        scrollableContainer = _ref$scrollableContai === undefined ? null : _ref$scrollableContai;

    this.balanceRulesTypePrefix = balanceRulesTypePrefix;
    this.parameters = parameters;
    this._changesCallback = changesCallback;
    this.countHoursPerDay = countHoursPerDay;
    this._decimalSeparator = decimalSeparator ? decimalSeparator : SystemSettings.decimalSeparator;
    this.scrollableContainer = scrollableContainer;
}

BalanceRulesEditor.prototype = new BaseBalanceRulesControl();

/**
 * Init BalanceRulesEditor
 */
BalanceRulesEditor.prototype.init = function () {
    BaseBalanceRulesControl.prototype.init.call(this, this.countHoursPerDay);

    var MAX_DAYS_VALUE_LENGTH = 6;
    var MAX_DAYS_FRACTIONAL_DIGITS = 2;

    this.contentDiv = this._getElementById("modifyBalanceAccrualRules");
    var self = this;

    this._supressButtonChangeEvent = false;

    var accrueBalanceFieldEl = this._getElementById('accrueBalanceField');
    var resetBalanceFieldEl = this._getElementById('resetBalanceField');
    var capBalanceFieldEl = this._getElementById('capBalanceField');

    accrueBalanceFieldEl.off();
    resetBalanceFieldEl.off();
    capBalanceFieldEl.off();

    this.accrueBalanceField = new DecimalField(accrueBalanceFieldEl, false, MAX_DAYS_VALUE_LENGTH, MAX_DAYS_FRACTIONAL_DIGITS, this._decimalSeparator, true, SystemSettings.digitGroupingSymbol, messageResource.getMessage('common.js.invalid_number', this._decimalSeparator));
    this.resetBalanceField = new DecimalField(resetBalanceFieldEl, false, MAX_DAYS_VALUE_LENGTH, MAX_DAYS_FRACTIONAL_DIGITS, this._decimalSeparator, true, SystemSettings.digitGroupingSymbol, messageResource.getMessage('common.js.invalid_number', this._decimalSeparator));
    this.capBalanceField = new DecimalField(capBalanceFieldEl, false, MAX_DAYS_VALUE_LENGTH, MAX_DAYS_FRACTIONAL_DIGITS, this._decimalSeparator, true, SystemSettings.digitGroupingSymbol, messageResource.getMessage('common.js.invalid_number', this._decimalSeparator));

    this._createPeriodSelect(this._getElementById('accruePeriodSelectPlaceholder'), this._getIdElement('accruePeriodSelect'));
    this._createResetPeriodSelect(this._getElementById('resetPeriodSelectPlaceholder'), this._getIdElement('resetPeriodSelect'));
    this._createMonthDaySelect(this._getElementById('accrueMonthDaySelectPlaceholder'), this._getIdElement('accrueMonthDaySelect'));
    this._createMonthSelect(this._getElementById('accrueMonthSelectPlaceholder'), this._getIdElement('accrueMonthSelect'));
    this._createWeekDaySelect(this._getElementById('accrueWeekdaySelectPlaceholder'), this._getIdElement('accrueWeekdaySelect'));
    this._createMonthSelect(this._getElementById("resetMonthSelectPlaceholder"), this._getIdElement("resetMonthSelect"));
    this._createMonthDaySelect(this._getElementById('resetMonthDaySelectPlaceholder'), this._getIdElement('resetMonthDaySelect'));

    this.accruePeriodButton = new AT.DropdownListButton({ menuCls: 'accruePeriod', applyTo: this._getIdElement('accruePeriodSelect'), scrollableContainer: this.scrollableContainer });
    this.accrueWeekdayButton = new AT.DropdownListButton({ menuCls: 'accrueWeekday', applyTo: this._getIdElement('accrueWeekdaySelect'), scrollableContainer: this.scrollableContainer });
    this.accrueMonthDayButton = new AT.DropdownListButton({ applyTo: this._getIdElement('accrueMonthDaySelect'), menuCls: 'accrual-rules-day-selector-menu', scrollableContainer: this.scrollableContainer });
    this.accrueMonthButton = new AT.DropdownListButton({ applyTo: this._getIdElement('accrueMonthSelect'), menuCls: 'accrual-rules-month-selector-menu', scrollableContainer: this.scrollableContainer });
    this.accrueFromDateSelector = new AccrualRuleFromDateSelector(this._getElementById('accrueFromDateSelectorPlaceholder')[0], SystemSettings.dateFormat, function () {
        self.updateDefaultBalanceNote();
    });
    this.accrueParamsPrefix = this._getElementById("accrueParamsPrefix");
    this.resetPeriodButton = new AT.DropdownListButton({ menuCls: 'resetPeriod', applyTo: this._getIdElement('resetPeriodSelect'), scrollableContainer: this.scrollableContainer });
    this.resetMonthButton = new AT.DropdownListButton({ menuCls: 'resetMonthSelect', applyTo: this._getIdElement('resetMonthSelect'), scrollableContainer: this.scrollableContainer });
    this.resetMonthDayButton = new AT.DropdownListButton({ applyTo: this._getIdElement('resetMonthDaySelect'), menuCls: 'accrual-rules-day-selector-menu', scrollableContainer: this.scrollableContainer });
    this.resetOnWordCell = this._getElementById("resetOn");

    this._showAppropriateAccrualPeriodParameters();

    this._formatAccrualMonthDayButtonText(this.accrueMonthDayButton);
    this._formatResetMonthDayButtonText(this.resetMonthDayButton);

    this._addButtonChangeHandler(this.accruePeriodButton, function () {
        self.updateDefaultBalanceNote();
        self._showAppropriateAccrualPeriodParameters();
    });
    this._addButtonChangeHandler(this.accrueWeekdayButton, function () {
        self._showAppropriateAccrualPeriodParameters();
    });
    this._addButtonChangeHandler(this.accrueMonthButton, function () {
        self._setCorrectDayOfMonthForAccrualRuleIfNeeded();
    });
    this._addButtonChangeHandler(this.accrueMonthDayButton, function () {
        self._setCorrectDayOfMonthForAccrualRuleIfNeeded();
        self._formatAccrualMonthDayButtonText(self.accrueMonthDayButton);
    });
    this._addButtonChangeHandler(this.accruePeriodButton, function () {
        self._setCorrectDayOfMonthForAccrualRuleIfNeeded();
        self._formatAccrualMonthDayButtonText(self.accrueMonthDayButton);
    });

    this._addButtonChangeHandler(this.resetPeriodButton, function () {
        self._showAppropriateResetPeriodParameters();
    });
    this._addButtonChangeHandler(this.resetMonthButton, function () {
        self._setCorrectDayOfMonth(self.resetMonthButton, self.resetMonthDayButton);
    });
    this._addButtonChangeHandler(this.resetMonthDayButton, function () {
        self._setCorrectDayOfMonth(self.resetMonthButton, self.resetMonthDayButton);
        self._formatResetMonthDayButtonText(self.resetMonthDayButton);
    });

    this.accrueRuleSection = {
        checkbox: this._getElementById('accrueRuleCheckbox'),
        valueField: this.accrueBalanceField,
        valueFieldEl: accrueBalanceFieldEl,
        buttons: [this.accruePeriodButton, this.accrueWeekdayButton, this.accrueMonthDayButton, this.accrueMonthButton, this.accrueFromDateSelector]
    };
    this.resetRuleSection = {
        checkbox: this._getElementById('resetRuleCheckbox'),
        valueField: this.resetBalanceField,
        valueFieldEl: resetBalanceFieldEl,
        buttons: [this.resetPeriodButton, this.resetMonthButton, this.resetMonthDayButton]
    };
    this.capRuleSection = {
        checkbox: this._getElementById('capRuleCheckbox'),
        valueField: this.capBalanceField,
        valueFieldEl: capBalanceFieldEl,
        buttons: []
    };

    this.sections = [this.accrueRuleSection, this.resetRuleSection, this.capRuleSection];

    $.each(this.sections, function () {
        self._addCheckboxClickHandler(this);
    });

    this._addFieldBlurHandler(this.accrueRuleSection, BALANCE_RULES_VALUES.ACCRUAL_RULE_VALUE);
    this._addFieldBlurHandler(this.resetRuleSection, BALANCE_RULES_VALUES.RESET_RULE_VALUE);
    this._addFieldBlurHandler(this.capRuleSection, BALANCE_RULES_VALUES.CAP_RULE_VALUE);

    this.setBalanceUnits(LeaveBalanceUnits.DAYS);
};

BalanceRulesEditor.prototype._getElementById = function (element) {
    return $("#" + this.balanceRulesTypePrefix + "_" + element);
};

BalanceRulesEditor.prototype._getIdElement = function (postfix) {
    return this.balanceRulesTypePrefix + "_" + postfix;
};

BalanceRulesEditor.prototype._getMaxDayOfMonth = function (month) {
    return new Date(2011, month, 0).getDate(); // 2011 is a non-leap year, February 29 is disallowed
};

BalanceRulesEditor.prototype._setCorrectDayOfMonthForAccrualRuleIfNeeded = function () {
    if (this.accruePeriodButton.getValue() == _constants.CalendarFrequencyType.YEARLY) this._setCorrectDayOfMonth(this.accrueMonthButton, this.accrueMonthDayButton);
};

BalanceRulesEditor.prototype._setCorrectDayOfMonth = function (monthButton, monthDayButton) {
    var maxDaysInMonth = this._getMaxDayOfMonth(monthButton.getValue());
    if (monthDayButton.getValue() > maxDaysInMonth) monthDayButton.setActiveItemByPosition(maxDaysInMonth - 1);
};

BalanceRulesEditor.prototype._addCheckboxClickHandler = function (section) {
    var self = this;
    section.checkbox.unbind("click").click(function () {
        var checked = $(this).attr('checked');
        if (checked) self._enableSection(section);else self._disableSection(section, false);
        self._onChange();
    });
};

BalanceRulesEditor.prototype._addFieldBlurHandler = function (section, key) {
    var self = this;
    section.valueFieldEl.blur(function () {
        self._validateField(section);

        var oldValue = section.valueField.oldValue !== undefined ? section.valueField.oldValue : self.values ? self.values[key] : self.defaultValues[key];
        var valueChanged = oldValue != section.valueField.getValue();

        self._updateOldValueOfField(section.valueField);

        if (section.valueField.getValue() == "" && oldValue == 0 || section.valueField.getValue() == 0 && oldValue === "") {
            valueChanged = true;
        }

        if (section.valueField.isValid()) {
            if (self.values) self.values[key] = section.valueField.getValueAsNumber();
        }

        if (valueChanged) self._onChange();
    });
};

BalanceRulesEditor.prototype._updateOldValueOfField = function (field) {
    field.oldValue = field.getValue();
};

BalanceRulesEditor.prototype._addButtonChangeHandler = function (button, handler) {
    var self = this;
    button.addListener('change', function () {
        if (handler) handler();
        if (!self._supressButtonChangeEvent) self._onChange();
    });
};

BalanceRulesEditor.prototype._formatAccrualMonthDayButtonText = function (button) {
    if (this.accruePeriodButton.getValue() == _constants.CalendarFrequencyType.MONTHLY) button.setText(formatMonthDay(button.getValue()));else {
        var buttonValue = button.getValue();
        if (buttonValue < 10) {
            button.setText('0' + buttonValue);
        } else {
            button.setText(buttonValue);
        }
    }
};

BalanceRulesEditor.prototype._formatResetMonthDayButtonText = function (button) {
    var buttonText = button.getText();
    if (buttonText < 10) button.setText('0' + buttonText);
};

BalanceRulesEditor.prototype._onChange = function () {
    if (this._changesCallback) this._changesCallback();
};

BalanceRulesEditor.prototype._validateField = function (section) {
    section.valueField.process();
};

BalanceRulesEditor.prototype._clearFieldValidationResult = function (section) {
    section.valueField.clearValidationResult();
};

BalanceRulesEditor.prototype._enableSection = function (section) {
    section.valueFieldEl.prop('disabled', false);
    this._validateField(section);
    for (var i = 0; i < section.buttons.length; i++) {
        section.buttons[i].enable();
    }section.checkbox.prop('disabled', false);
};

BalanceRulesEditor.prototype._disableSection = function (section, disableCheckbox) {
    this._clearFieldValidationResult(section);
    section.valueFieldEl.prop('disabled', true);
    for (var i = 0; i < section.buttons.length; i++) {
        section.buttons[i].disable();
    }if (disableCheckbox) section.checkbox.prop('disabled', true);
};

BalanceRulesEditor.prototype.setToday = function (today) {
    this.today = today;
};

BalanceRulesEditor.prototype._fillElementsWithValues = function (useDefault) {
    var values = useDefault ? this.defaultValues : this._getValues();

    this._supressButtonChangeEvent = true;

    this.accrueRuleSection.checkbox.attr('checked', values[BALANCE_RULES_VALUES.ACCRUAL_RULE_ENABLED]);
    this._fillSectionFieldWithValue(this.accrueRuleSection, values[BALANCE_RULES_VALUES.ACCRUAL_RULE_VALUE]);
    this.accruePeriodButton.setActiveItemByValue(values[BALANCE_RULES_VALUES.ACCRUAL_RULE_FREQUENCY_TYPE]);

    if (this.accruePeriodButton.getValue() !== _constants.CalendarFrequencyType.BIWEEKLY) {
        this.accrueFromDateSelector.setPlaceholderDateValue(this.today);
    }

    switch (this.accruePeriodButton.getValue()) {
        case _constants.CalendarFrequencyType.WEEKLY:
            this.accrueWeekdayButton.setActiveItemByValue(values[BALANCE_RULES_VALUES.ACCRUAL_RULE_PARAMETERS]);
            break;
        case _constants.CalendarFrequencyType.BIWEEKLY:
            this.accrueFromDateSelector.setDates(values[BALANCE_RULES_VALUES.ACCRUAL_RULE_PARAMETERS][0], this.today);
            break;
        case _constants.CalendarFrequencyType.YEARLY:
            this.accrueMonthDayButton.setActiveItemByValue(values[BALANCE_RULES_VALUES.ACCRUAL_RULE_PARAMETERS][1]);
            this.accrueMonthButton.setActiveItemByValue(values[BALANCE_RULES_VALUES.ACCRUAL_RULE_PARAMETERS][0]);
            break;
        case _constants.CalendarFrequencyType.ON_HIRE_DATE:
            break;
        case _constants.CalendarFrequencyType.MONTHLY:
            this.accrueMonthDayButton.setActiveItemByValue(values[BALANCE_RULES_VALUES.ACCRUAL_RULE_PARAMETERS]);
            break;
    }

    this.resetRuleSection.checkbox.attr('checked', values[BALANCE_RULES_VALUES.RESET_RULE_ENABLED]);
    this._fillSectionFieldWithValue(this.resetRuleSection, values[BALANCE_RULES_VALUES.RESET_RULE_VALUE]);
    this.resetPeriodButton.setActiveItemByValue(values[BALANCE_RULES_VALUES.RESET_RULE_FREQUENCY_TYPE]);
    switch (this.resetPeriodButton.getValue()) {
        case _constants.CalendarFrequencyType.YEARLY:
            this.resetMonthButton.setActiveItemByValue(values[BALANCE_RULES_VALUES.RESET_RULE_PARAMETERS][0]);
            this.resetMonthDayButton.setActiveItemByValue(values[BALANCE_RULES_VALUES.RESET_RULE_PARAMETERS][1]);
            break;
        case _constants.CalendarFrequencyType.ON_HIRE_DATE:
            break;
    }

    this.capRuleSection.checkbox.attr('checked', values[BALANCE_RULES_VALUES.CAP_RULE_ENABLED]);
    this._fillSectionFieldWithValue(this.capRuleSection, values[BALANCE_RULES_VALUES.CAP_RULE_VALUE]);

    var self = this;
    $.each(this.sections, function () {
        var checked = this.checkbox.attr('checked');
        if (!checked) self._disableSection(this);else self._enableSection(this);

        this.checkbox[0].defaultValue = checked ? "on" : "off";
    });

    this._supressButtonChangeEvent = false;
};

BalanceRulesEditor.prototype._fillSectionFieldWithValue = function (section, value) {
    section.valueField.setValueAsNumber(value);
    section.valueFieldEl[0].defaultValue = section.valueField.getValue();
    this._updateOldValueOfField(section.valueField);
};

BalanceRulesEditor.prototype._getAppropriateAccrualPeriodParametersControls = function () {
    var result = [];

    switch (this.accruePeriodButton.getValue()) {
        case _constants.CalendarFrequencyType.WEEKLY:
            result.push(this.accrueWeekdayButton);
            break;
        case _constants.CalendarFrequencyType.MONTHLY:
            result.push(this.accrueMonthDayButton);
            break;
        case _constants.CalendarFrequencyType.YEARLY:
            result.push(this.accrueMonthButton);
            result.push(this.accrueMonthDayButton);
            break;
        case _constants.CalendarFrequencyType.BIWEEKLY:
            result.push(this.accrueFromDateSelector);
            break;
        case _constants.CalendarFrequencyType.ON_HIRE_DATE:
            break;
    }

    return result;
};

BalanceRulesEditor.prototype._getAppropriateResetPeriodParametersControls = function () {
    var result = [];

    switch (this.resetPeriodButton.getValue()) {
        case _constants.CalendarFrequencyType.YEARLY:
            result.push(this.resetMonthButton);
            result.push(this.resetMonthDayButton);
            break;
        case _constants.CalendarFrequencyType.ON_HIRE_DATE:
            break;
    }

    return result;
};

BalanceRulesEditor.prototype._createPeriodSelect = function (element, id) {
    var select = '<select id="' + id + '">';

    select += "<option value='" + _constants.CalendarFrequencyType.WEEKLY + "'>" + _constants.CalendarFrequencyType.descriptionFor[_constants.CalendarFrequencyType.WEEKLY] + "</option>";
    select += "<option value='" + _constants.CalendarFrequencyType.BIWEEKLY + "'>" + _constants.CalendarFrequencyType.descriptionFor[_constants.CalendarFrequencyType.BIWEEKLY] + "</option>";
    select += "<option value='" + _constants.CalendarFrequencyType.MONTHLY + "'>" + _constants.CalendarFrequencyType.descriptionFor[_constants.CalendarFrequencyType.MONTHLY] + "</option>";
    select += "<option value='" + _constants.CalendarFrequencyType.YEARLY + "'>" + _constants.CalendarFrequencyType.descriptionFor[_constants.CalendarFrequencyType.YEARLY] + "</option>";
    select += "<option value='" + _constants.CalendarFrequencyType.ON_HIRE_DATE + "'>" + _constants.CalendarFrequencyType.descriptionFor[_constants.CalendarFrequencyType.ON_HIRE_DATE] + "</option>";

    select += "</select>";

    $(element).html(select);
};

BalanceRulesEditor.prototype._createResetPeriodSelect = function (element, id) {
    var select = '<select id="' + id + '">';

    select += "<option value='" + _constants.CalendarFrequencyType.YEARLY + "'>" + _constants.CalendarFrequencyType.descriptionFor[_constants.CalendarFrequencyType.YEARLY] + "</option>";
    select += "<option value='" + _constants.CalendarFrequencyType.ON_HIRE_DATE + "'>" + _constants.CalendarFrequencyType.descriptionFor[_constants.CalendarFrequencyType.ON_HIRE_DATE] + "</option>";

    select += "</select>";

    $(element).html(select);
};

BalanceRulesEditor.prototype._createMonthDaySelect = function (element, id) {
    var select = '<select id="' + id + '">';

    for (var i = 1; i <= 31; i++) {
        select += "<option value='" + i + "'>" + i + "</option>";
    }select += "</select>";

    $(element).html(select);
};

BalanceRulesEditor.prototype._createMonthSelect = function (element, id) {
    var select = '<select id="' + id + '">';

    var monthNames = Date.monthNamesShort;

    for (var i = 0; i < monthNames.length; i++) {
        select += "<option value='" + (i + 1) + "'>" + monthNames[i] + "</option>";
    }select += "</select>";

    $(element).html(select);
};

BalanceRulesEditor.prototype._createWeekDaySelect = function (element, id) {
    var select = '<select id="' + id + '">';

    var weekStartDay = SystemSettings.weekStartDay - 1;

    for (var i = 1; i <= 7; i++) {
        var dayOfWeek = (weekStartDay + i - 1) % 7;
        var dayOfWeekName = Date.dayNamesShort[dayOfWeek];
        select += "<option value='" + (dayOfWeek + 1) + "'>" + dayOfWeekName + "</option>";
    }

    select += "</select>";

    $(element).html(select);
};

BalanceRulesEditor.prototype._showAppropriateAccrualPeriodParameters = function () {
    this.accrueWeekdayButton.hide();
    this.accrueMonthDayButton.hide();
    this.accrueMonthButton.hide();
    this.accrueFromDateSelector.hide();

    if (this.accruePeriodButton.getValue() == _constants.CalendarFrequencyType.ON_HIRE_DATE) {
        this.accrueParamsPrefix.hide();
    } else {
        var prefix = '';
        if (this.accruePeriodButton.getValue() == _constants.CalendarFrequencyType.BIWEEKLY) {
            prefix = messageResource.getMessage('balance_editor.from');
        } else {
            prefix = messageResource.getMessage('balance_editor.on');
        }

        this.accrueParamsPrefix.html(prefix);
        this.accrueParamsPrefix.show();
    }

    $.each(this._getAppropriateAccrualPeriodParametersControls(), function () {
        this.show();
    });
};

BalanceRulesEditor.prototype._showAppropriateResetPeriodParameters = function () {
    this.resetMonthDayButton.hide();
    this.resetMonthButton.hide();

    if (this.resetPeriodButton.getValue() == _constants.CalendarFrequencyType.ON_HIRE_DATE) this.resetOnWordCell.hide();else this.resetOnWordCell.show();

    $.each(this._getAppropriateResetPeriodParametersControls(), function () {
        this.show();
    });
};

BalanceRulesEditor.prototype.hasErrors = function () {
    var self = this;
    var hasErrors = false;
    $.each(this.sections, function () {
        if (self._hasError(this)) hasErrors = true;
    });
    return hasErrors;
};

BalanceRulesEditor.prototype._hasError = function (section) {
    var enabled = section.checkbox.attr('checked');
    if (enabled) {
        section.valueField.process();

        if (!section.valueField.isValid()) return true;
    }
    return false;
};

BalanceRulesEditor.prototype.getValues = function () {
    var values = [];

    var accrueEnabled = this.accrueRuleSection.checkbox.attr('checked') == 'checked';
    var resetEnabled = this.resetRuleSection.checkbox.attr('checked') == 'checked';
    var capEnabled = this.capRuleSection.checkbox.attr('checked') == 'checked';

    var accrualFrequencyParameterControls = this._getAppropriateAccrualPeriodParametersControls();
    var accrualFrequencyParameters = [];

    $.each(accrualFrequencyParameterControls, function () {
        accrualFrequencyParameters.push(this.getValue());
    });

    var resetFrequencyParameterControls = this._getAppropriateResetPeriodParametersControls();
    var resetFrequencyParameters = [];

    $.each(resetFrequencyParameterControls, function () {
        resetFrequencyParameters.push(this.getValue());
    });

    var accrualRuleValue = this.accrueRuleSection.valueField.getValueAsNumber();
    var resetRuleValue = this.resetRuleSection.valueField.getValueAsNumber();
    var capRuleValue = this.capRuleSection.valueField.getValueAsNumber();
    if (this.units == LeaveBalanceUnits.HOURS) {
        accrualRuleValue /= this.defaultWorkDayDuration;
        resetRuleValue /= this.defaultWorkDayDuration;
        capRuleValue /= this.defaultWorkDayDuration;
    }

    values.push({ name: BALANCE_RULES_VALUES.ACCRUAL_RULE_ENABLED, value: accrueEnabled });
    if (this.accrueRuleSection.valueField.isValid()) values.push({ name: BALANCE_RULES_VALUES.ACCRUAL_RULE_VALUE, value: accrualRuleValue });
    values.push({ name: BALANCE_RULES_VALUES.ACCRUAL_RULE_FREQUENCY_TYPE, value: this.accruePeriodButton.getValue() });
    values.push({ name: BALANCE_RULES_VALUES.ACCRUAL_RULE_PARAMETERS, value: accrualFrequencyParameters });

    values.push({ name: BALANCE_RULES_VALUES.RESET_RULE_ENABLED, value: resetEnabled });
    if (this.resetRuleSection.valueField.isValid()) values.push({ name: BALANCE_RULES_VALUES.RESET_RULE_VALUE, value: resetRuleValue });
    values.push({ name: BALANCE_RULES_VALUES.RESET_RULE_FREQUENCY_TYPE, value: this.resetPeriodButton.getValue() });
    values.push({ name: BALANCE_RULES_VALUES.RESET_RULE_PARAMETERS, value: resetFrequencyParameters });

    if (this.capRuleSection.valueField.isValid()) values.push({ name: BALANCE_RULES_VALUES.CAP_RULE_VALUE, value: capRuleValue });
    values.push({ name: BALANCE_RULES_VALUES.CAP_RULE_ENABLED, value: capEnabled });

    return values;
};

BalanceRulesEditor.prototype.getAccrualRules = function () {
    var newValues = this.getValuesAsMap();
    var accrualRule = null;
    var resetRule = null;
    var capRule = null;

    if (newValues[BALANCE_RULES_VALUES.ACCRUAL_RULE_ENABLED]) {
        accrualRule = {
            value: newValues[BALANCE_RULES_VALUES.ACCRUAL_RULE_VALUE],
            frequency: {
                type: newValues[BALANCE_RULES_VALUES.ACCRUAL_RULE_FREQUENCY_TYPE],
                params: newValues[BALANCE_RULES_VALUES.ACCRUAL_RULE_PARAMETERS]
            }
        };
    }
    if (newValues[BALANCE_RULES_VALUES.RESET_RULE_ENABLED]) {
        resetRule = {
            value: newValues[BALANCE_RULES_VALUES.RESET_RULE_VALUE],
            frequency: {
                type: newValues[BALANCE_RULES_VALUES.RESET_RULE_FREQUENCY_TYPE],
                params: newValues[BALANCE_RULES_VALUES.RESET_RULE_PARAMETERS]
            }
        };
    }
    if (newValues[BALANCE_RULES_VALUES.CAP_RULE_ENABLED]) {
        capRule = newValues[BALANCE_RULES_VALUES.CAP_RULE_VALUE];
    }

    return { accrualRule: accrualRule, resetRule: resetRule, balanceCap: capRule };
};

BalanceRulesEditor.prototype.getValuesAsMap = function () {
    var valuesMap = {};
    var values = this.getValues();
    $.each(values, function () {
        valuesMap[this.name] = this.value;
    });
    return valuesMap;
};

BalanceRulesEditor.prototype.enable = function () {
    var self = this;
    $.each(this.sections, function () {
        self._enableSection(this);
    });
};

BalanceRulesEditor.prototype.disable = function () {
    var self = this;
    $.each(this.sections, function () {
        self._disableSection(this, true);
    });
};

BalanceRulesEditor.prototype._recalculateTo = function (newUnits) {
    BaseBalanceRulesControl.prototype._recalculateTo.call(this, newUnits);

    if (this.values) {
        this._fillSectionFieldWithValue(this.accrueRuleSection, this.values[BALANCE_RULES_VALUES.ACCRUAL_RULE_VALUE]);
        this._fillSectionFieldWithValue(this.resetRuleSection, this.values[BALANCE_RULES_VALUES.RESET_RULE_VALUE]);
        this._fillSectionFieldWithValue(this.capRuleSection, this.values[BALANCE_RULES_VALUES.CAP_RULE_VALUE]);
    }

    this.contentDiv.toggleClass('daysMode', this.units == LeaveBalanceUnits.DAYS);
    this.contentDiv.toggleClass('hoursMode', this.units == LeaveBalanceUnits.HOURS);
};

BalanceRulesEditor.prototype.updateDecimalSeparator = function () {
    var self = this;
    $.each(this.sections, function () {
        this.valueField.setDecimalSeparator(SystemSettings.decimalSeparator);
        this.valueField.setInvalidHint(messageResource.getMessage('common.js.invalid_number', SystemSettings.decimalSeparator));
        self._updateOldValueOfField(this.valueField);
    });
};

BalanceRulesEditor.prototype.updateDigitGroupingSymbol = function () {
    var self = this;
    $.each(this.sections, function () {
        this.valueField.setDigitGroupingSymbol(SystemSettings.digitGroupingSymbol);
        this.valueField.oldValue = this.valueField.getValue();
        self._updateOldValueOfField(this.valueField);
    });
};

BalanceRulesEditor.prototype.getInputs = function () {
    var inputs = [];
    $.each(this.sections, function () {
        inputs.push(this.valueFieldEl[0]);
    });
    return inputs;
};

function AdvancedBalanceRulesEditor() {
    var balanceRulesTypePrefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var parameters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var changesCallback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};
    var switcherPlaceholder = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
    var countHoursPerDay = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';
    var decimalSeparator = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';
    var scrollableContainer = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;

    this.balanceRulesTypePrefix = balanceRulesTypePrefix;
    this.parameters = parameters;
    this._changesCallback = changesCallback;
    this.switcherPlaceholder = switcherPlaceholder;
    this.countHoursPerDay = countHoursPerDay;
    this._decimalSeparator = decimalSeparator ? decimalSeparator : SystemSettings.decimalSeparator;
    this.scrollableContainer = scrollableContainer;
}

AdvancedBalanceRulesEditor.prototype = new BalanceRulesEditor();

AdvancedBalanceRulesEditor.prototype.init = function () {
    BalanceRulesEditor.prototype.init.call(this);
    this._defaultsViewer = new BalanceRulesViewer();
    this._defaultsViewer.init(this.balanceRulesTypePrefix, this.contentDiv, true, this.countHoursPerDay, this._decimalSeparator);

    if (this.switcherPlaceholder) this._addSwitcher(this.switcherPlaceholder);

    this.setUseDefaultRules(false);
};

AdvancedBalanceRulesEditor.prototype._fillElementsWithValues = function (useDefault) {
    BalanceRulesEditor.prototype._fillElementsWithValues.call(this, useDefault);
    this._defaultsViewer.updateValues();
};

AdvancedBalanceRulesEditor.prototype.setDefaultBalanceData = function (balanceData) {
    BalanceRulesEditor.prototype.setDefaultBalanceData.call(this, balanceData);
    this._defaultsViewer.setDefaultBalanceData(balanceData);
};

AdvancedBalanceRulesEditor.prototype.setUseDefaultRules = function (useDefaultRules) {
    this.useDefaultRules = useDefaultRules;

    this.contentDiv.toggleClass('editMode', !useDefaultRules);
    this.contentDiv.toggleClass('readMode', useDefaultRules);

    if (this._defaultSwitcher) {
        this._defaultSwitcher.toggleClass('active', useDefaultRules);
        this._customSwitcher.toggleClass('active', !useDefaultRules);
    }

    this._fillElementsWithValues(useDefaultRules);

    if (this.parameters) {
        var titleKey = this.parameters.titleNoteKey;
        $(".userDefaultRulesSpan").html(messageResource.getMessage(titleKey));
    }

    this.updateDefaultBalanceNote();

    var self = this;
    $.each(this.sections, function () {
        this.checkbox.prop('disabled', useDefaultRules);
    });
};

AdvancedBalanceRulesEditor.prototype.updateDefaultBalanceNote = function () {
    if (this.parameters) {
        var additionalInfo = '';
        if (this.accruePeriodButton.getValue() === _constants.CalendarFrequencyType.BIWEEKLY) {
            var nextDate = _ClassicBridge2.default.getNextBiweeklyAccrualDateFromDate(this.today, this.accrueFromDateSelector.getValue(), SystemSettings.dateFormat);
            additionalInfo = '. ' + messageResource.getMessage('balance_editor.next_accrual_date', [nextDate]);
        }

        var messageKey = this.useDefaultRules ? this.parameters.defaultMessageNoteKey : this.parameters.customMessageNoteKey;

        $(".defaultBalanceNote").html(messageResource.getMessage(messageKey) + additionalInfo);
    }
};

AdvancedBalanceRulesEditor.prototype.switchToHours = function () {
    this.setBalanceUnits(LeaveBalanceUnits.HOURS);
    this._defaultsViewer.setBalanceUnits(LeaveBalanceUnits.HOURS);
};

AdvancedBalanceRulesEditor.prototype.blinkErrors = function () {
    var errorEls = this.contentDiv.find(".invalid");
    errorEls.removeClass("invalid");
    window.setTimeout(function () {
        errorEls.addClass("invalid");
    }, 250);
};

AdvancedBalanceRulesEditor.prototype._addSwitcher = function (switcherPlaceholder, changeCallback) {
    this._defaultCustomSwitcher = this._createSwitcher(switcherPlaceholder);
    this._defaultSwitcher = this._defaultCustomSwitcher.find("#defaultSwitcher");
    this._customSwitcher = this._defaultCustomSwitcher.find("#customSwitcher");
    var that = this;
    this._defaultSwitcher.click(function () {
        if (!that.useDefaultRules) {
            that.setUseDefaultRules(true);
            that._onChange();
        }
    });
    this._customSwitcher.click(function () {
        if (that.useDefaultRules) {
            that.setUseDefaultRules(false);
            that._onChange();
        }
    });
};

AdvancedBalanceRulesEditor.prototype._createSwitcher = function (switcherPlaceholder) {
    switcherPlaceholder.html("");
    var switcherEl = document.createElement("div");
    switcherEl.className = "defaultCustomSwitcher";

    var defaultSwitcher = document.createElement("div");
    defaultSwitcher.id = "defaultSwitcher";
    defaultSwitcher.className = "switcher";
    $(defaultSwitcher).html("<span>" + messageResource.getMessage("balance_rules_editor.default") + "</span>");

    var customSwitcher = document.createElement("div");
    customSwitcher.id = "customSwitcher";
    customSwitcher.className = "switcher";
    $(customSwitcher).html("<span>" + messageResource.getMessage("balance_rules_editor.custom") + "</span>");

    switcherEl.appendChild(defaultSwitcher);
    switcherEl.appendChild(customSwitcher);
    switcherPlaceholder.append(switcherEl);

    return $(switcherEl);
};

AdvancedBalanceRulesEditor.prototype.isUseDefault = function () {
    return this.useDefaultRules;
};

function BalanceRulesTooltip() {}

BalanceRulesTooltip.prototype.init = function (prefixId, countHoursPerDay, parameters) {
    this._tooltip = $("#" + prefixId + "_balanceRulesDescriptionTooltip");
    this._tooltip.find(".customRules").html(messageResource.getMessage(parameters.customTitleTooltip));
    this._tooltip.find(".defaultRules").html(messageResource.getMessage(parameters.defaultTitleTooltip));
    this._rulesViewer = new BalanceRulesViewer();
    this._rulesViewer.init(prefixId, this._tooltip, true, countHoursPerDay);
};

BalanceRulesTooltip.prototype.show = function () {
    this._tooltip.show();
};

BalanceRulesTooltip.prototype.hide = function () {
    this._tooltip.hide();
};

BalanceRulesTooltip.prototype.moveTo = function (x, y) {
    this._tooltip[0].style.left = x + "px";
    this._tooltip[0].style.top = y + "px";
};

BalanceRulesTooltip.prototype.getEl = function () {
    return this._tooltip;
};

BalanceRulesTooltip.prototype.setDefaultBalanceData = function (defaultBalanceData) {
    this._rulesViewer.setDefaultBalanceData(defaultBalanceData);
};

BalanceRulesTooltip.prototype.setValues = function (values) {
    this._rulesViewer.setValues(values);
};

BalanceRulesTooltip.prototype.setBalanceData = function (balanceData) {
    this._rulesViewer.setBalanceData(balanceData);
};

BalanceRulesTooltip.prototype.setWorkdayDurationInHours = function (workdayDurationInHours) {
    this._rulesViewer.setWorkdayDurationInHours(workdayDurationInHours);
};

BalanceRulesTooltip.prototype.setDefault = function (isDefault) {
    this._tooltip.toggleClass("default", isDefault);
};

BalanceRulesTooltip.prototype.switchToHours = function () {
    this._rulesViewer.setBalanceUnits(LeaveBalanceUnits.HOURS);
};

function BalanceRulesViewer() {}

BalanceRulesViewer.prototype = new BaseBalanceRulesControl();

BalanceRulesViewer.prototype.init = function (prefixId, contentDiv, hideDisabledRules, countHoursPerDay, decimalSeparator, showAdditionalInfo, today) {
    BaseBalanceRulesControl.prototype.init.call(this, countHoursPerDay);
    this.prefixId = prefixId;
    this.decimalSeparator = decimalSeparator ? decimalSeparator : SystemSettings.decimalSeparator;

    this.daysFormatter = new NumberFormatter(this.decimalSeparator, SystemSettings.digitGroupingSymbol, 2, true, '', messageResource.getMessage("common.balance_units.days.short"));
    this.hoursFormatter = new NumberFormatter(this.decimalSeparator, SystemSettings.digitGroupingSymbol, 2, true, '', messageResource.getMessage("common.balance_units.hours.short"));

    this.format = function (value) {
        if (this.units == LeaveBalanceUnits.DAYS) return this.daysFormatter.format(value);else if (this.units == LeaveBalanceUnits.HOURS) return this.hoursFormatter.format(value);
        return value;
    };

    this.contentDiv = $(contentDiv);

    this.accrualRuleDiv = this.contentDiv.find(".readOnlyAccrualRule");
    this.resetRuleDiv = this.contentDiv.find(".readOnlyResetRule");
    this.capRuleDiv = this.contentDiv.find(".readOnlyCapRule");

    this.hideDisabledRules = hideDisabledRules;
    this.showAdditionalInfo = showAdditionalInfo;
    this.today = today;
};

BalanceRulesViewer.prototype._fillElementsWithValues = function (useDefault, noBold, isShort) {
    var values = useDefault ? this.defaultValues : this._getValues();

    this.accrualRuleDiv.html(messageResource.getMessage(noBold ? "balance_rules_editor.balance_rules.accrue_rule_no_bold" : "balance_rules_editor.balance_rules.accrue_rule", [this.format(values[BALANCE_RULES_VALUES.ACCRUAL_RULE_VALUE]), _constants.CalendarFrequencyType.descriptionFor[values[BALANCE_RULES_VALUES.ACCRUAL_RULE_FREQUENCY_TYPE]], _constants.CalendarFrequencyType.parametersFormatterFor[values[BALANCE_RULES_VALUES.ACCRUAL_RULE_FREQUENCY_TYPE]](values[BALANCE_RULES_VALUES.ACCRUAL_RULE_PARAMETERS], isShort)]));

    this.resetRuleDiv.html(messageResource.getMessage(noBold ? "balance_rules_editor.balance_rules.reset_rule_no_bold" : "balance_rules_editor.balance_rules.reset_rule", [this.format(values[BALANCE_RULES_VALUES.RESET_RULE_VALUE]), _constants.CalendarFrequencyType.descriptionFor[values[BALANCE_RULES_VALUES.RESET_RULE_FREQUENCY_TYPE]], _constants.CalendarFrequencyType.parametersFormatterFor[values[BALANCE_RULES_VALUES.RESET_RULE_FREQUENCY_TYPE]](values[BALANCE_RULES_VALUES.RESET_RULE_PARAMETERS])]));

    this.capRuleDiv.html(messageResource.getMessage(noBold ? "balance_rules_editor.balance_rules.cap_rule_no_bold" : "balance_rules_editor.balance_rules.cap_rule", [this.format(values[BALANCE_RULES_VALUES.CAP_RULE_VALUE])]));

    if (this.hideDisabledRules) {
        this.accrualRuleDiv.toggle(values[BALANCE_RULES_VALUES.ACCRUAL_RULE_ENABLED]);
        this.resetRuleDiv.toggle(values[BALANCE_RULES_VALUES.RESET_RULE_ENABLED]);
        this.capRuleDiv.toggle(values[BALANCE_RULES_VALUES.CAP_RULE_ENABLED]);

        if (!values[BALANCE_RULES_VALUES.ACCRUAL_RULE_ENABLED] && !values[BALANCE_RULES_VALUES.RESET_RULE_ENABLED] && !values[BALANCE_RULES_VALUES.CAP_RULE_ENABLED]) {
            this.accrualRuleDiv.html(messageResource.getMessage("balance_rules_editor.no_accrual_rules." + this.prefixId));
            this.accrualRuleDiv.toggle(true);
        }
    }

    if (this.showAdditionalInfo) {
        if (values[BALANCE_RULES_VALUES.ACCRUAL_RULE_FREQUENCY_TYPE] === _constants.CalendarFrequencyType.BIWEEKLY && this.today) {
            var nextDate = _ClassicBridge2.default.getShortNextBiweeklyAccrualDateFromDate(this.today, values[BALANCE_RULES_VALUES.ACCRUAL_RULE_PARAMETERS], SystemSettings.dateFormat);
            this.accrualRuleDiv.append(', ' + messageResource.getMessage('balance_editor.next_accrual_date.short', [nextDate]));
        }
    }
};

BalanceRulesViewer.prototype.updateValues = function () {
    this._fillElementsWithValues(false);
};

function BalanceRulesEditorDialog() {}

BalanceRulesEditorDialog.prototype.init = function (prefixId, countHoursPerDay, parameters) {
    var that = this;
    this.dialogDiv = $("#" + prefixId + "_balanceRulesEditorDialog");
    this._balanceRulesEditor = new AdvancedBalanceRulesEditor(prefixId, parameters, null, this.dialogDiv.find(".switcherPlaceholder"), countHoursPerDay);
    this._balanceRulesEditor.init();

    this.wrapperClass = "balanceRulesEditorDialog";

    this._modifyBalanceAccrualRulesDialog = new DropdownDialog({
        dialogDiv: this.dialogDiv,
        okButtonText: messageResource.getMessage("common.buttons.save_changes"),
        wrapperClass: this.wrapperClass,
        showEmptyTitleBar: true,
        onClose: function onClose() {
            if (that.closeCallback) that.closeCallback();
        },
        hideOnResize: true
    });

    this._createGradientButtons();

    this._buttonsEnabled = true;
};

BalanceRulesEditorDialog.prototype.setToday = function (today) {
    this._balanceRulesEditor.setToday(today);
};

BalanceRulesEditorDialog.prototype.updateDefaultBalanceNote = function () {
    this._balanceRulesEditor.updateDefaultBalanceNote();
};

BalanceRulesEditorDialog.prototype._createGradientButtons = function () {
    this.dialogDiv.parent().find(".ui-dialog-buttonpane div").remove();
    var buttonsPane = this.dialogDiv.parent().find(".ui-dialog-buttonpane");
    this._buttonsPane = $(buttonsPane);

    var that = this;
    this._createSaveButton(buttonsPane);

    this._createGradientButton(buttonsPane, messageResource.getMessage("common.cancel"), "greyButton", function () {
        that._modifyBalanceAccrualRulesDialog.hide();
    });
};

BalanceRulesEditorDialog.prototype._createSaveButton = function (buttonsPane) {
    var that = this;
    var saveButton = this._createGradientButton(buttonsPane, messageResource.getMessage("common.buttons.save_changes"), "greyButton", function () {
        if (that._onModifyBalanceAccrualRulesOkClick()) that._modifyBalanceAccrualRulesDialog.hide();
    });
    var spanEl = document.createElement("span");
    spanEl.className = "savingText";
    spanEl.innerHTML = messageResource.getMessage("common.saving.ellipsis");

    $(saveButton).addClass("saveButton");
    saveButton.appendChild(spanEl);

    return saveButton;
};

BalanceRulesEditorDialog.prototype._createGradientButton = function (buttonsPane, text, className, callback) {

    var buttonEl = document.createElement("div");
    buttonEl.className = className;

    var spanEl = document.createElement("span");
    spanEl.innerHTML = text;

    buttonEl.appendChild(spanEl);

    buttonsPane[0].appendChild(buttonEl);

    var that = this;
    $(buttonEl).click(function () {
        if (that._buttonsEnabled) callback();
    });

    return buttonEl;
};

BalanceRulesEditorDialog.prototype.setUseDefaultRules = function (useDefaultRules) {
    this._balanceRulesEditor.setUseDefaultRules(useDefaultRules);
};

BalanceRulesEditorDialog.prototype.setValues = function (values) {
    this._balanceRulesEditor.setValues(values);
};

BalanceRulesEditorDialog.prototype.setBalanceData = function (balanceData) {
    this._balanceRulesEditor.setBalanceData(balanceData);
};

BalanceRulesEditorDialog.prototype.setDefaultBalanceData = function (values) {
    this._balanceRulesEditor.setDefaultBalanceData(values);
};

BalanceRulesEditorDialog.prototype.setWorkdayDurationInHours = function (workdayDurationInHours) {
    this._balanceRulesEditor.setWorkdayDurationInHours(workdayDurationInHours);
};

BalanceRulesEditorDialog.prototype.showAt = function (element, params) {
    this._modifyBalanceAccrualRulesDialog.showAt(element, params);
};

BalanceRulesEditorDialog.prototype.setModifyBalanceAccrualRulesOkClick = function (callback) {
    var that = this;
    this._onModifyBalanceAccrualRulesOkClick = function () {
        if (!that._balanceRulesEditor.hasErrors()) {
            this._buttonsEnabled = false;
            this._modifyBalanceAccrualRulesDialog.preventClose();
            this._buttonsPane.addClass('savingMode');

            callback();
            return true;
        } else that._balanceRulesEditor.blinkErrors();
        return false;
    };
};

BalanceRulesEditorDialog.prototype.getAccrualRules = function () {
    return this._balanceRulesEditor.getAccrualRules();
};

BalanceRulesEditorDialog.prototype.switchToHours = function () {
    this._balanceRulesEditor.switchToHours();
};

BalanceRulesEditorDialog.prototype.isUseDefault = function () {
    return this._balanceRulesEditor.isUseDefault();
};

BalanceRulesEditorDialog.prototype.setOnCloseCallback = function (closeCallback) {
    this.closeCallback = closeCallback;
};

BalanceRulesEditorDialog.prototype.hide = function () {
    this._buttonsPane.removeClass('savingMode');
    this._buttonsEnabled = true;
    this._modifyBalanceAccrualRulesDialog.allowClose();
    this._modifyBalanceAccrualRulesDialog.hide();
};

// ------------------------------------------------------ //

function BalanceRulesManager() {}

BalanceRulesManager.prototype.init = function (prefixId, balanceDefaults, countHoursPerDay, parameters) {
    this._balanceAccrualRulesDialog = new BalanceRulesEditorDialog();
    this._balanceAccrualRulesDialog.init(prefixId, countHoursPerDay, parameters);
    this._balanceAccrualRulesDialog.setDefaultBalanceData(balanceDefaults);

    this._balanceAccrualRulesTooltip = new BalanceRulesTooltip();
    this._balanceAccrualRulesTooltip.init(prefixId, countHoursPerDay, parameters);
    this._balanceAccrualRulesTooltip.setDefaultBalanceData(balanceDefaults);

    //TODO: evdokimov hot fix.
    if (balanceDefaults && balanceDefaults.showBalanceInHours) {
        this._balanceAccrualRulesDialog.switchToHours();
        this._balanceAccrualRulesTooltip.switchToHours();
    }

    return this;
};

BalanceRulesManager.prototype.reinitAccrualRulesControls = function (countHoursPerDay) {
    this._balanceAccrualRulesDialog.setWorkdayDurationInHours(countHoursPerDay);
    this._balanceAccrualRulesTooltip.setWorkdayDurationInHours(countHoursPerDay);
};

BalanceRulesManager.prototype.showAccrualRulesTooltip = function (jQueryEvent, balanceData) {
    if (!balanceData) return;
    this._balanceAccrualRulesTooltip.setDefault(balanceData.defaultRules);

    this._balanceAccrualRulesTooltip.setBalanceData(balanceData);
    var offset = this._getTooltipOffset(jQueryEvent, this._balanceAccrualRulesTooltip.getEl());
    this._balanceAccrualRulesTooltip.moveTo(offset.left, offset.top);
    this._balanceAccrualRulesTooltip.show();
};

BalanceRulesManager.prototype.hideAccrualRulesTooltip = function () {
    this._balanceAccrualRulesTooltip.hide();
};

BalanceRulesManager.prototype.hideAccrualRulesTooltip = function () {
    this._balanceAccrualRulesTooltip.hide();
};

BalanceRulesManager.prototype.moveAccrualRulesTooltip = function (jQueryEvent) {
    var offset = this._getTooltipOffset(jQueryEvent, this._balanceAccrualRulesTooltip.getEl());
    this._balanceAccrualRulesTooltip.moveTo(offset.left, offset.top);
};

BalanceRulesManager.prototype._getTooltipOffset = function (jQueryEvent, tooltipEl) {
    var BOTTOM_BAR_HEIGHT = 26;
    var top = jQueryEvent.pageY + 5;
    var tooltipHeight = $(tooltipEl).outerHeight();
    if (top + tooltipHeight + BOTTOM_BAR_HEIGHT - getBodyScrollTop() > $(window).height()) top -= tooltipHeight;

    return { top: top, left: jQueryEvent.pageX + 15 };
};

BalanceRulesManager.prototype.updateDialog = function (balanceData, today) {
    this._balanceAccrualRulesDialog.setToday(today);
    this._balanceAccrualRulesDialog.updateDefaultBalanceNote();

    if (balanceData.defaultRules) {
        this._balanceAccrualRulesDialog.setBalanceData(null);
        this._balanceAccrualRulesDialog.setUseDefaultRules(true);
    } else {
        this._balanceAccrualRulesDialog.setBalanceData(balanceData);
        this._balanceAccrualRulesDialog.setUseDefaultRules(false);
    }
};

BalanceRulesManager.prototype.setModifyBalanceAccrualRulesOkClick = function (callback) {
    this._balanceAccrualRulesDialog.setModifyBalanceAccrualRulesOkClick(callback);
};

BalanceRulesManager.prototype.setOnCloseCallback = function (closeCallback) {
    this._balanceAccrualRulesDialog.setOnCloseCallback(closeCallback);
};

BalanceRulesManager.prototype.showDialogAt = function (target, offset) {
    this._balanceAccrualRulesDialog.showAt(target, offset);
};

BalanceRulesManager.prototype.hideDialog = function () {
    this._balanceAccrualRulesDialog.hide();
};

BalanceRulesManager.prototype.getDialogValues = function () {
    var result = { useDefaults: this._balanceAccrualRulesDialog.isUseDefault(), accrualRule: null, resetRule: null, capRule: null };

    if (!result.useDefaults) {
        var rules = this._balanceAccrualRulesDialog.getAccrualRules();
        if (rules) {
            result.accrualRule = rules.accrualRule;
            result.resetRule = rules.resetRule;
            result.capRule = rules.balanceCap;
        }
    }

    return result;
};

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.performUpdateCall = exports.changeTeamAssignmentsWithId = exports.changeTeamAssignments = exports.deleteUserSchedule = exports.updateInitialUserSchedule = exports.addNewSchedule = exports.updateUserSchedules = exports.updateOvertime = exports.updateRequireApproval = exports.updateAccessAP = exports.updateAccess = exports.updateUserRights = exports.updateReleaseDate = exports.setHasLeavesOrTTBeforeNewHireDateError = exports.updateHireDate = exports.updateTimeZoneGroup = exports.updateUserGroup = exports.updatePassword = exports.updateEmail = exports.updateUserName = exports.updateMiddleName = exports.updateDefaultWorkStatuses = exports.updateLastName = exports.updateFirstName = exports.deleteUser = exports.closeEditUserPanel = exports.loadEditUserPanelDataWithId = exports.loadEditUserPanelData = exports.restoreState = exports.reloadUserData = exports.openEditUserPanel = exports.GET_EDIT_USER_DATA_METHOD = exports.setLastLicenseManagerOnDisableApAlertShown = exports.setLastLicenseManagerOnDisableAtAlertShown = exports.setLastLicenseManagerOnDeleteAlertShown = exports.updateErrorBackup = exports.setUpdatingWorkSchedule = exports.setLoaded = exports.setUserPanelState = exports.setUserPanelTab = exports.setUpdatingData = exports.setUserPanelLoading = exports.setEditingUserId = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _rpcCalls = __webpack_require__(24);

var _rpcCalls2 = _interopRequireDefault(_rpcCalls);

var _utils = __webpack_require__(311);

var _constants = __webpack_require__(21);

var _util = __webpack_require__(254);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _UserListConfirmation = __webpack_require__(545);

var _UserListConfirmation2 = _interopRequireDefault(_UserListConfirmation);

var _constants2 = __webpack_require__(4);

var _selectors = __webpack_require__(146);

var _actionTypes = __webpack_require__(678);

var ActionTypes = _interopRequireWildcard(_actionTypes);

var _actions = __webpack_require__(147);

var UserDataActions = _interopRequireWildcard(_actions);

var _reduxActions = __webpack_require__(9);

var _validation = __webpack_require__(550);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _selectors2 = __webpack_require__(19);

var _selectors3 = __webpack_require__(64);

var _syncCallbacks = __webpack_require__(256);

var SyncCallbacks = _interopRequireWildcard(_syncCallbacks);

var _actions2 = __webpack_require__(50);

var _actions3 = __webpack_require__(68);

var _actions4 = __webpack_require__(29);

var _actions5 = __webpack_require__(864);

var _selectors4 = __webpack_require__(53);

var _validationUtils = __webpack_require__(205);

var _selectors5 = __webpack_require__(257);

var _selectors6 = __webpack_require__(15);

var _actions6 = __webpack_require__(551);

var UserRatesActions = _interopRequireWildcard(_actions6);

var _utils2 = __webpack_require__(865);

var _atUtils = __webpack_require__(5);

var _actions7 = __webpack_require__(56);

var _constants3 = __webpack_require__(201);

var _actions8 = __webpack_require__(1635);

var _actions9 = __webpack_require__(258);

var _selectors7 = __webpack_require__(14);

var _rpcUtils = __webpack_require__(160);

var _errors = __webpack_require__(193);

var _PasswordSettings = __webpack_require__(279);

var _actions10 = __webpack_require__(554);

var _ClassicBridge = __webpack_require__(18);

var _ClassicBridge2 = _interopRequireDefault(_ClassicBridge);

var _constants4 = __webpack_require__(77);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var setEditingUserId = exports.setEditingUserId = (0, _reduxActions.createAction)(ActionTypes.EDIT_USER_ID_SET);

var setUserPanelLoading = exports.setUserPanelLoading = (0, _reduxActions.createAction)(ActionTypes.USER_PANEL_LOADING_SET);

var setUpdatingData = exports.setUpdatingData = (0, _reduxActions.createAction)(ActionTypes.UPDATING_DATA_SET);

var setUserPanelTab = exports.setUserPanelTab = (0, _reduxActions.createAction)(ActionTypes.USER_PANEL_TAB_SET);

var setUserPanelState = exports.setUserPanelState = (0, _reduxActions.createAction)(ActionTypes.USER_PANEL_STATE_SET);

var setLoaded = exports.setLoaded = (0, _reduxActions.createAction)(ActionTypes.LOADED_SET);

var setUpdatingWorkSchedule = exports.setUpdatingWorkSchedule = (0, _reduxActions.createAction)(ActionTypes.UPDATING_WORK_SCHEDULE_SET);

var updateErrorBackup = exports.updateErrorBackup = (0, _reduxActions.createAction)(ActionTypes.ERROR_BACKUP_UPDATE);

var setLastLicenseManagerOnDeleteAlertShown = exports.setLastLicenseManagerOnDeleteAlertShown = (0, _reduxActions.createAction)(ActionTypes.LAST_LICENSE_MANAGER_ON_DELETE_ALERT_SHOWN_SET);
var setLastLicenseManagerOnDisableAtAlertShown = exports.setLastLicenseManagerOnDisableAtAlertShown = (0, _reduxActions.createAction)(ActionTypes.LAST_LICENSE_MANAGER_ON_DISABLE_AT_ALERT_SHOWN_SET);
var setLastLicenseManagerOnDisableApAlertShown = exports.setLastLicenseManagerOnDisableApAlertShown = (0, _reduxActions.createAction)(ActionTypes.LAST_LICENSE_MANAGER_ON_DISABLE_AP_ALERT_SHOWN_SET);

var GET_EDIT_USER_DATA_METHOD = exports.GET_EDIT_USER_DATA_METHOD = 'UserManagementService.getEditUserData';

var openEditUserPanel = exports.openEditUserPanel = function openEditUserPanel(userId) {
    var tab = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _constants.TabKeys.ACCOUNT_SETTINGS;
    return function (dispatch, getState) {
        var editUserId = (0, _selectors.getEditUserId)(getState());
        if (editUserId !== userId) {
            dispatch(setUserPanelState({
                userId: userId,
                selectedTab: tab
            }));
            dispatch(reloadUserData());
        } else {
            if ((0, _selectors.getSelectedTab)(getState()) !== tab) {
                dispatch(setUserPanelTab(tab));
            } else {
                dispatch(closeEditUserPanel());
            }
        }
    };
};

var reloadUserData = exports.reloadUserData = function reloadUserData() {
    return function (dispatch) {
        (0, _rpcCalls.abortCall)(GET_EDIT_USER_DATA_METHOD);
        dispatch(setLoaded(true));
        dispatch(setLoaded(false));
    };
};

var restoreState = exports.restoreState = function restoreState() {
    return function (dispatch, getState) {
        var backup = (0, _selectors.getErrorBackup)(getState());
        dispatch((0, _actions.setFullUserInfo)(backup));
        var providerErrors = (0, _atUtils.filterMapByKey)((0, _selectors3.getUserPanelErrors)(getState()), _constants.ValidationErrors.USERNAME_DUPLICATE);
        var validationResult = (0, _validation.validateFirstName)(providerErrors, backup.firstName);
        validationResult = (0, _validation.validateLastName)(validationResult.errors, backup.lastName);
        validationResult = (0, _validation.validateUserName)(validationResult.errors, backup.username);
        validationResult = (0, _validation.validateEmail)(validationResult.errors, backup.email, false, backup.email);
        validationResult = (0, _validation.validateHireDate)(validationResult.errors, false, Date.parseJSONDate(backup.hireDate));
        var releaseDate = backup.releaseDate ? Date.parseJSONDate(backup.releaseDate) : null;
        validationResult = (0, _validation.validateReleaseDate)(validationResult.errors, releaseDate, Date.parseJSONDate(backup.hireDate), backup.releaseDate);
        dispatch((0, _actions.setUserPanelErrors)(validationResult.errors));
    };
};

var loadEditUserPanelData = exports.loadEditUserPanelData = function loadEditUserPanelData() {
    return function (dispatch, getState) {
        var editUserId = (0, _selectors.getEditUserId)(getState());
        dispatch(loadEditUserPanelDataWithId(editUserId));
    };
};

var loadEditUserPanelDataWithId = exports.loadEditUserPanelDataWithId = function loadEditUserPanelDataWithId(editUserId) {
    return function (dispatch, getState) {
        dispatch(setUserPanelLoading(true));
        var manageAccountsOfViewerWasEnabled = (0, _selectors4.isAllowedToManageAccountSettings)(getState());

        var WSDEnabled = (0, _selectors6.isWSDEnabled)(getState());

        var loads = [makeRpcCall(GET_EDIT_USER_DATA_METHOD, [editUserId]), WSDEnabled && _ClassicBridge2.default.getWorkStatusesForUserProfile(), WSDEnabled && _ClassicBridge2.default.getUsersByClassicIds([editUserId])];

        Promise.all(loads).then(function (_ref) {
            var _ref2 = _slicedToArray(_ref, 3),
                userClassicData = _ref2[0],
                workStatuses = _ref2[1],
                usersNextData = _ref2[2];

            if (!WSDEnabled) {
                return [userClassicData];
            }

            var _usersNextData$items = _slicedToArray(usersNextData.items, 1),
                userNextData = _usersNextData$items[0];

            return new Promise(function (res) {
                return _ClassicBridge2.default.getDefaultWorkStatusPlanningByUserId(userNextData.id).then(function (defaultWorkStatusPlanningData) {
                    return res([userClassicData, workStatuses, userNextData, defaultWorkStatusPlanningData]);
                });
            });
        }).then(function (_ref3) {
            var _ref4 = _slicedToArray(_ref3, 4),
                userClassicData = _ref4[0],
                workStatuses = _ref4[1],
                userNextData = _ref4[2],
                defaultWorkStatusPlanningData = _ref4[3];

            dispatch(UserDataActions.clearUserPanelErrors());
            dispatch(UserRatesActions.clearErrors());

            var manageAccountsOfViewerIsEnabled = userClassicData.userManagementData.viewerSettings.allowedToManageAccountSettings;
            if (!manageAccountsOfViewerWasEnabled && manageAccountsOfViewerIsEnabled) {
                alert(_messageResource2.default.getMessage("userlist.manage_accounts_were_granted"));
                window.location.reload();
            }

            dispatch(updateStateFromEditUserData(userClassicData));

            var fullUserInfo = _extends({}, userClassicData['fullUserInfo']['userAccountSettings'], {
                password: "",
                retypedPassword: ""
            });
            var userGroupRowData = {
                groupId: fullUserInfo.userGroupId,
                newGroupCreating: false
            };
            var userManagementData = userClassicData['userManagementData'];
            var timeZoneGroupRowData = {
                groupId: fullUserInfo.timeZoneGroupId,
                newGroupCreating: false,
                timeZoneGroupsOffset: (0, _utils.getTimeZoneOffsets)(userManagementData.allTimeZoneGroups),
                newTimeZonEGroup: null
            };

            var rates = fullUserInfo.rates ? [].concat(_toConsumableArray(fullUserInfo.rates)) : [];

            dispatch((0, _actions2.setUserManagementData)(userManagementData));
            dispatch(UserDataActions.setUserData({
                fullUserInfo: _extends({}, fullUserInfo, {
                    rates: rates
                }),
                userGroupRowData: userGroupRowData,
                timeZoneGroupRowData: timeZoneGroupRowData,
                hasTimeTrack: userClassicData['hasTimeTrack'],
                firstTTDate: userClassicData['firstTTDate'],
                firstLeaveRequestDate: userClassicData['firstLeaveRequestDate'],
                lastLoginTime: userClassicData['lastLoginTime'],
                lastOtherProductAdmin: userClassicData['lastOtherProductAdmin'],
                userTeamAssignmentsData: userClassicData['userTeamAssignmentsData'],
                allApprovers: userClassicData['allApprovers'] ? userClassicData['allApprovers'] : {},
                userNextId: WSDEnabled && userNextData.id,
                extendedData: {
                    lastLoginTime: userClassicData['lastLoginTime'],
                    firstTTDate: userClassicData['firstTTDate'],
                    hasTimeTrack: userClassicData['hasTimeTrack'],
                    lastOtherProductAdmin: userClassicData['lastOtherProductAdmin'],
                    lastLicensesManager: userClassicData['lastLicensesManager'],
                    currentTime: userClassicData['currentTimeInUserTimeZone'],
                    firstRequestDate: userClassicData['firstRequestDate'],
                    isAllowedToSeeAllUsersTT: userClassicData['userIsAllowedToSeeAllUsersTT']
                }
            }));

            if (!!userClassicData['userManageAssignmentsData']) {
                dispatch(UserDataActions.setUserManageAssignmentsData((0, _utils.convertManagementAssignmentsDataFromRpc)(userClassicData['userManageAssignmentsData'])));
            } else {
                dispatch(UserDataActions.setUserManageAssignmentsData({
                    managementAssignmentsSelection: userClassicData['managementAssignmentsSelection']
                }));
            }

            var maCountersData = userClassicData['managementAssignmentsCounters'];
            dispatch(UserDataActions.managementAssignmentsCountsLoadSuccess({
                customers: maCountersData ? maCountersData.customers : 0,
                projects: maCountersData ? maCountersData.projects : 0,
                tasks: maCountersData ? maCountersData.tasks : 0
            }));

            dispatch((0, _actions2.setUserList)(userClassicData.availableUsers.list));

            if (WSDEnabled) {
                dispatch((0, _actions10.setWorkStatuses)(workStatuses));
                dispatch((0, _actions10.setDefaultWorkStatusPlanningData)(defaultWorkStatusPlanningData));
            }

            dispatch((0, _actions5.setAuthorizationInfo)(userClassicData['authorizationInfo']));

            dispatch(setLoaded(true));
            dispatch(setUserPanelLoading(false));
            dispatch(updateErrorBackup(_extends({}, fullUserInfo, { rates: rates })));
            if (userClassicData['authorizationInfo']['accountInformationEditable'] && !fullUserInfo.email) setTimeout(function () {
                return dispatch((0, _actions.setUserPanelErrors)(_defineProperty({}, _constants.ValidationErrors.EMAIL_WAS_EMPTY, true)));
            }, 300);
            if ((0, _atUtils.compareNullableStrDates)(fullUserInfo.hireDate, fullUserInfo.releaseDate) > 0) {
                setTimeout(function () {
                    return dispatch((0, _actions.setUserPanelErrors)(_defineProperty({}, _constants.ValidationErrors.RELEASE_DATE_WAS_BEFORE_HIRE_DATE, true)));
                }, 300);
            }
        }).catch(function (error) {
            if ((0, _rpcUtils.isAborted)(error)) {
                return;
            }

            dispatch(setEditingUserId(null));
            dispatch(setUserPanelLoading(false));
            if (error._providerStatus === _constants.ValidationErrors.NO_SUCH_USER) {
                alert(_messageResource2.default.getEscapedMessage("user.js.error_user_was_deleted"));

                dispatch(updateStateOnUserDelete(editUserId));
                SyncCallbacks.onNoSuchUserException(editUserId);
                dispatch((0, _actions2.removeUserFromList)(editUserId));
            }
            if (error._providerStatus === _constants.ValidationErrors.USER_IS_LOCKED) {
                // todo: lamanov change message
                alert(_messageResource2.default.getEscapedMessage("userlist.js.error_no_such_user"));
            }
        });
    };
};

var closeEditUserPanel = exports.closeEditUserPanel = function closeEditUserPanel() {
    return function (dispatch) {
        (0, _rpcCalls.abortCall)(GET_EDIT_USER_DATA_METHOD);
        dispatch(setEditingUserId(null));
        dispatch(UserDataActions.clearUserPanelErrors());
        dispatch(UserRatesActions.clearErrors());
    };
};

var deleteUser = exports.deleteUser = function deleteUser() {
    var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var forceLastLicenseManagerUpdate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return function (dispatch, getState) {
        var state = getState();
        var userId = (0, _selectors.getEditUserId)(state);
        dispatch(UserDataActions.removeUserPanelErrors([_constants.ValidationErrors.ACTION_NOT_CONFIRMED, _constants.ValidationErrors.ACTION_CONFIRMED]));

        dispatch(setUpdatingData(true));
        makeRpcCall("UserManagementService.deleteUser", [userId, force, forceLastLicenseManagerUpdate]).then(function (data) {
            dispatch(setUpdatingData(false));
            dispatch(closeEditUserPanel());

            dispatch(updateStateOnUserDeleteSuccess(userId, data));
            dispatch(updateAdditionalData(data, state));
            SyncCallbacks.onDeleteUser(_extends({}, data, { id: userId }));
        }).catch(function (error) {
            dispatch(setUpdatingData(false));
            if (error._providerStatus === _constants.ValidationErrors.ACTION_CONFIRMED) {
                dispatch(deleteUser(true));
            }

            if (error._providerStatus === _constants.ValidationErrors.NO_SUCH_USER) {
                alert(_messageResource2.default.getEscapedMessage("userlist.js.error_no_such_user"));

                dispatch(updateStateOnUserDelete(userId));
                SyncCallbacks.onDeleteUser(_extends({}, error, { id: userId }));
            }
            if (error._providerStatus === _constants.ValidationErrors.USER_IS_LOCKED) {
                // todo: lamanov change message
                alert(_messageResource2.default.getEscapedMessage("userlist.js.error_no_such_user"));
            }
            if (error._providerStatus === _constants.ValidationErrors.LAST_MANAGER_IN_OTHER_PRODUCT) {
                alert(_messageResource2.default.getMessage("user.edit.js.cannot_delete.last_admin_ap"));
                dispatch(UserDataActions.addUserPanelErrors([error._providerStatus]));
                dispatch(UserDataActions.updateExtendedData({
                    lastOtherProductAdmin: true
                }));
            }
            if (error._providerStatus === 'UserIsLastLicensesManagerException') {
                if (forceLastLicenseManagerUpdate) dispatch(deleteUser(force, true));else dispatch(setLastLicenseManagerOnDeleteAlertShown(true));
            }
        });
    };
};

var updateFirstName = exports.updateFirstName = function updateFirstName(newFName) {
    return function (dispatch, getState) {
        var state = getState();
        var providerErrors = (0, _selectors3.getUserPanelErrors)(state);

        var validationResult = (0, _validation.validateFirstName)(providerErrors, newFName);
        dispatch(updateErrorBackup((0, _selectors3.getFullUserInfo)(getState())));
        if (validationResult.isValid) {
            dispatch(performUpdateCall("UserManagementService.updateFirstName", [newFName]));
        } else {
            dispatch(UserDataActions.setFullUserInfo({ firstName: newFName }));
        }
        dispatch(UserDataActions.setUserPanelErrors(validationResult.errors));
    };
};

var updateLastName = exports.updateLastName = function updateLastName(newLName) {
    return function (dispatch, getState) {
        var state = getState();
        var providerErrors = (0, _selectors3.getUserPanelErrors)(state);

        var validationResult = (0, _validation.validateLastName)(providerErrors, newLName);
        dispatch(updateErrorBackup((0, _selectors3.getFullUserInfo)(getState())));
        if (validationResult.isValid) {
            dispatch(performUpdateCall("UserManagementService.updateLastName", [newLName]));
        } else {
            dispatch(UserDataActions.setFullUserInfo({ lastName: newLName }));
        }
        dispatch(UserDataActions.setUserPanelErrors(validationResult.errors));
    };
};

var updateDefaultWorkStatuses = exports.updateDefaultWorkStatuses = function updateDefaultWorkStatuses(newDefaultWorkStatuses) {
    return function (dispatch, getState) {
        var state = getState();
        var userInfo = (0, _selectors3.getUserDataState)(state);
        dispatch(setUpdatingData(true));
        _ClassicBridge2.default.putUserDefaultWorkStatuses(userInfo.userNextId, { items: newDefaultWorkStatuses }).then(function () {
            dispatch(setUpdatingData(false));
        }).catch(function (e) {
            if (e.body && e.body.errorKey === _constants4.ApiErrorKeys.NotFoundEntity && e.body.entityType === 'user') {
                alert(_messageResource2.default.getMessage('userlist.js.error_no_such_user.edit_user'));
                dispatch(updateStateOnUserDelete(userInfo.fullUserInfo.id));
                return dispatch(setEditingUserId(null));
            } else if (e.body && e.body.errorKey === _constants4.ApiErrorKeys.NotFoundEntity && e.body.entityType === 'target') {
                alert(_messageResource2.default.getMessage('userlist.js.error_no_such_work_status.edit_user'));
                return document.location.reload();
            }
            alert(_messageResource2.default.getMessage('error.js.lightbox_loader.unexpected_error', [PRODUCT_NAME]));
        });
    };
};

var updateMiddleName = exports.updateMiddleName = function updateMiddleName(newMName) {
    return function (dispatch) {
        dispatch(performUpdateCall("UserManagementService.updateMiddleName", [newMName]));
    };
};

var updateUserName = exports.updateUserName = function updateUserName(newUName, duplicateError) {
    return function (dispatch, getState) {
        //updating state by modifying panel errors
        if (duplicateError) {
            dispatch(UserDataActions.addUserPanelErrors([_constants.ValidationErrors.DUPLICATE_USERNAME]));
        } else {
            dispatch(UserDataActions.removeUserPanelErrors([_constants.ValidationErrors.DUPLICATE_USERNAME]));
        }

        //calling getState() to retrieve updated set of errors
        var providerErrors = (0, _selectors3.getUserPanelErrors)(getState());

        var validationResult = (0, _validation.validateUserName)(providerErrors, newUName);
        dispatch(updateErrorBackup((0, _selectors3.getFullUserInfo)(getState())));
        if (validationResult.isValid) {
            dispatch(performUpdateCall("UserManagementService.updateUsername", [newUName]));
        }
        dispatch(UserDataActions.setUserPanelErrors(validationResult.errors));
    };
};

var updateEmail = exports.updateEmail = function updateEmail(newEmail) {
    return function (dispatch, getState) {
        var state = getState();
        var providerErrors = (0, _selectors3.getUserPanelErrors)(state);
        var backupEmail = (0, _selectors.getErrorBackup)(getState()).email;
        var validationResult = updateEmailValidation(dispatch, newEmail, backupEmail, providerErrors);
        dispatch(updateErrorBackup((0, _selectors3.getFullUserInfo)(getState())));
        if (validationResult.isValid) {
            dispatch(performUpdateCall("UserManagementService.updateEmail", [newEmail]));
        } else {
            dispatch(UserDataActions.setFullUserInfo({ email: newEmail }));
        }
    };
};

var updatePassword = exports.updatePassword = function updatePassword(newPassword, retypedPassword, isPasswordChanged, isPasswordCopyChanged) {
    return function (dispatch, getState) {
        var state = getState();
        var providerErrors = (0, _selectors3.getUserPanelErrors)(state);

        function removeOldErrors() {
            dispatch(UserDataActions.removeUserPanelErrors([_constants.ValidationErrors.PASSWORDS_DO_NOT_MATCH, _constants.ValidationErrors.PASSWORD_COPY_EMPTY, _constants.ValidationErrors.PASSWORD_RESTRICTIONS_VIOLATED]));
            dispatch(UserDataActions.setPasswordValidationResult(null));
        }

        // clear all errors if main password field is empty
        if (newPassword.length === 0) {
            removeOldErrors();
            dispatch(UserDataActions.setFullUserInfo({
                password: "",
                retypedPassword: retypedPassword
            }));
        } else {
            if (providerErrors.length > 0) {
                return; //there are already errors
            }
            removeOldErrors();

            dispatch(performUpdateCall("UserManagementService.changePassword", [newPassword, retypedPassword]));
            dispatch(UserDataActions.setFullUserInfo({
                password: newPassword,
                retypedPassword: retypedPassword
            }));
        }
    };
};

var updateUserGroup = exports.updateUserGroup = function updateUserGroup(ugrId, newUgrName) {
    return function (dispatch, getState) {
        var state = getState();
        var providerErrors = (0, _selectors3.getUserPanelErrors)(state);
        var userId = (0, _selectors.getEditUserId)(state);

        var validationResult = (0, _validation.validateUserGroupName)(providerErrors, ugrId, newUgrName);

        if (validationResult.isValid) {
            dispatch(performUpdateCall("UserManagementService.updateUserGroup", [ugrId, newUgrName], function (resultData) {
                dispatch(UserDataActions.setAllApprovers(resultData.allApprovers));
                // update user group id in usersList for user
                if (ugrId !== resultData.userInfo.userGroupId) dispatch((0, _actions2.updateUsersListUserGroupId)({ userId: userId, userGroupId: resultData.userInfo.userGroupId }));
            }));
        } else {
            dispatch(UserDataActions.setUserGroupData({
                userGroupId: ugrId
            }));
            dispatch(UserDataActions.setFullUserInfo({
                userGroupId: ugrId,
                newUserGroupName: newUgrName
            }));
        }
        dispatch(UserDataActions.setUserPanelErrors(validationResult.errors));
    };
};

var updateTimeZoneGroup = exports.updateTimeZoneGroup = function updateTimeZoneGroup(tzgId, newTzg) {
    return function (dispatch, getState) {
        var state = getState();

        dispatch(UserDataActions.removeUserPanelErrors([_constants.ValidationErrors.DUPLICATE_TIME_ZONE_GROUP, _constants.ValidationErrors.CITY_DATA_EMPTY, _constants.ValidationErrors.NEW_TIME_ZONE_GROUP_EMPTY]));
        var providerErrors = (0, _selectors3.getUserPanelErrors)(state);

        var validationResult = (0, _validation.validateTimezoneGroup)(providerErrors, tzgId, newTzg);

        if (validationResult.isValid) {
            dispatch(performUpdateCall("UserManagementService.updateTimezoneGroup", [tzgId, newTzg]));
        }
        dispatch(UserDataActions.setUserPanelErrors(validationResult.errors));
    };
};

var updateHireDate = exports.updateHireDate = function updateHireDate(hireDate, forceUpdate) {
    return function (dispatch, getState) {
        var state = getState();

        dispatch(UserDataActions.removeUserPanelErrors([_constants.ValidationErrors.LAST_MANAGER_IN_OTHER_PRODUCT]));
        var providerErrors = (0, _selectors3.getUserPanelErrors)(state);

        var isEditHimself = (0, _selectors2.getLoggedInUserId)(state) === (0, _selectors.getEditUserId)(state);

        var releaseDate = (0, _selectors3.getFullUserInfo)(state).releaseDate ? Date.parseJSONDate((0, _selectors3.getFullUserInfo)(state).releaseDate) : null;
        var validationResult = (0, _validation.validateHireDate)(providerErrors, isEditHimself, Date.parseJSONDate(hireDate), releaseDate);
        if (validationResult.isValid) {
            validationResult = (0, _validation.validateReleaseDate)(providerErrors, releaseDate, Date.parseJSONDate(hireDate));
        }

        if (validationResult.isValid) {
            dispatch((0, _actions.setUserPanelHasLeavesOrTTBeforeNewHireDateError)(false));
            dispatch(performUpdateCall("UserManagementService.updateHireDate", [Date.parseJSONDate(hireDate), forceUpdate], function (data) {
                if (data.additionalResultData !== null) {
                    var additionalData = data.additionalResultData.map;
                    dispatch(UserDataActions.setUserData({
                        firstTTDate: additionalData['firstTTDate'],
                        firstLeaveRequestDate: additionalData['firstLeaveRequestDate'],
                        extendedData: _extends({}, (0, _selectors3.getExtendedData)(getState()), {
                            currentTime: additionalData['currentTimeInUserTimeZone'],
                            firstTTDate: additionalData['firstTTDate'],
                            firstLeaveRequestDate: additionalData['firstLeaveRequestDate']
                        })
                    }));
                }
            }, function (err) {
                if (err._providerStatus === _constants.ValidationErrors.LEAVES_OR_TT_BEFORE_NEW_HIRE_DATE) {
                    dispatch((0, _actions.setUserPanelHasLeavesOrTTBeforeNewHireDateError)(true));
                }
                if (err._providerStatus === _constants.ValidationErrors.LAST_MANAGER_IN_OTHER_PRODUCT) {
                    alert(_messageResource2.default.getEscapedMessage("user.edit.js.cannot_disable.last_admin_at"));
                }
            }));
        } else {
            dispatch(UserDataActions.setFullUserInfo({
                hireDate: hireDate
            }));
        }
        dispatch(UserDataActions.setUserPanelErrors(validationResult.errors));
    };
};

var setHasLeavesOrTTBeforeNewHireDateError = exports.setHasLeavesOrTTBeforeNewHireDateError = function setHasLeavesOrTTBeforeNewHireDateError(userPanelHasLeavesOrTTBeforeNewHireDateError) {
    return function (dispatch) {
        dispatch((0, _actions.setUserPanelHasLeavesOrTTBeforeNewHireDateError)(userPanelHasLeavesOrTTBeforeNewHireDateError));
    };
};

var updateReleaseDate = exports.updateReleaseDate = function updateReleaseDate(releaseDate) {
    return function (dispatch, getState) {
        var state = getState();

        var providerErrors = (0, _selectors3.getUserPanelErrors)(state);
        var jsonDate = releaseDate ? Date.parseJSONDate(releaseDate) : null;
        var hireDate = Date.parseJSONDate((0, _selectors3.getFullUserInfo)(state).hireDate);
        var backupReleaseDate = (0, _selectors.getErrorBackup)(getState()).releaseDate;
        var validationResult = (0, _validation.validateReleaseDate)(providerErrors, jsonDate, hireDate, backupReleaseDate);

        if (validationResult.isValid) {
            dispatch(performUpdateCall("UserManagementService.updateReleaseDate", [jsonDate]));
        } else {
            dispatch(UserDataActions.setFullUserInfo({ releaseDate: releaseDate }));
        }
        dispatch(UserDataActions.setUserPanelErrors(validationResult.errors));
    };
};

var updateUserRights = exports.updateUserRights = function updateUserRights() {
    var accessRights = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return function (dispatch, getState) {
        var oldRights = (0, _selectors3.getFullUserInfo)(getState()).accessRights;
        var isEntireScope = (0, _utils2.isEntireManagementScopeAssigned)((0, _selectors3.getManagementAssignmentsSelection)(getState()), (0, _selectors3.getUserRights)(getState()));
        var hasAccessToManagementScope = (0, _utils2.isManagerScopesAvailable)((0, _selectors3.getUserRights)(getState()), {
            isURAEnabled: (0, _selectors6.isURAEnabled)(getState()),
            isBTYEnabled: (0, _selectors6.isBTYEnabled)(getState())
        });
        var isWAFeatureEnabled = (0, _selectors6.isWASEnabled)(getState());
        dispatch(performUpdateCall("UserManagementService.updateUserRights", [accessRights, force], function (data) {
            dispatch(UserDataActions.setFullUserInfo({
                accessRights: (0, _utils.convertUserAccessRightsDataFromRpc)(data.userInfo)
            }));

            dispatch((0, _actions4.addUser)(data.userInfo));
            dispatch((0, _actions9.updateWorkAssignmentsCounters)(data));
            var maCountersData = data.additionalResultData.map['managementAssignmentsCounters'];
            if (maCountersData) {
                dispatch((0, _actions.managementAssignmentsCountsLoadSuccess)(maCountersData));
            }

            var revokeAllManagementScope = isEntireScope && !(0, _utils2.isEntireManagementScopeAssigned)((0, _selectors3.getManagementAssignmentsSelection)(getState()), (0, _selectors3.getUserRights)(getState()));
            var revokeAccessToManagementScope = hasAccessToManagementScope && !(0, _utils2.isManagerScopesAvailable)((0, _selectors3.getUserRights)(getState()), {
                isURAEnabled: (0, _selectors6.isURAEnabled)(getState()),
                isBTYEnabled: (0, _selectors6.isBTYEnabled)(getState())
            });
            if ((revokeAccessToManagementScope || revokeAllManagementScope) && isWAFeatureEnabled) {
                dispatch((0, _actions7.toast)(_messageResource2.default.getMessage('user_list.toasts.revoke_all_management_scope')));
            }
        }, function (error) {
            if (error._providerStatus === _constants.ValidationErrors.ACTION_CONFIRMED) {
                dispatch(updateUserRights(accessRights, true));
            } else if (error._providerStatus === _constants.ValidationErrors.ACTION_NOT_CONFIRMED) {
                dispatch(UserDataActions.setFullUserInfo({
                    accessRights: oldRights
                }));
            }
        }));
    };
};

var updateAccess = exports.updateAccess = function updateAccess(enabled, force) {
    var forceLastLicenseManagerUpdate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    return function (dispatch, getState) {
        var wasEnabled = (0, _selectors3.getFullUserInfo)(getState()).enabled;
        dispatch(UserDataActions.removeUserPanelErrors([_constants.ValidationErrors.ACTION_CONFIRMED, _constants.ValidationErrors.ACTION_NOT_CONFIRMED]));

        dispatch(performUpdateCall("UserManagementService.updateAccess", [enabled, force, forceLastLicenseManagerUpdate], function (data) {
            dispatch(UserDataActions.setFullUserInfo({
                enabled: data.userInfo.enabled
            }));
        }, function (error) {
            if (error._providerStatus === _constants.ValidationErrors.ACTION_CONFIRMED) {
                dispatch(updateAccess(enabled, true, forceLastLicenseManagerUpdate));
            } else if (error._providerStatus === _constants.ValidationErrors.ACTION_NOT_CONFIRMED) {
                dispatch(UserDataActions.setFullUserInfo({
                    enabled: wasEnabled
                }));
            } else if (error._providerStatus === _constants.ValidationErrors.DISABLED_DUE_TO_LICENSE_TERMS) {
                dispatch(UserDataActions.setFullUserInfo({
                    enabled: false
                }));
            } else if (error._providerStatus === 'UserIsLastLicensesManagerException') {
                if (forceLastLicenseManagerUpdate) dispatch(updateAccess(enabled, force, true));else dispatch(setLastLicenseManagerOnDisableAtAlertShown(true));
            }
        }));
    };
};

var updateAccessAP = exports.updateAccessAP = function updateAccessAP(enabled, force) {
    var forceLastLicenseManagerUpdate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    return function (dispatch, getState) {
        var wasEnabled = (0, _selectors3.getFullUserInfo)(getState()).enabledInOtherProduct;
        dispatch(UserDataActions.removeUserPanelErrors([_constants.ValidationErrors.LAST_MANAGER_IN_OTHER_PRODUCT]));

        dispatch(UserDataActions.setFullUserInfo({
            enabledInOtherProduct: enabled
        }));

        dispatch(performUpdateCall("UserManagementService.updateAccessOtherProduct", [enabled, force, forceLastLicenseManagerUpdate], function (data) {
            dispatch(UserDataActions.setFullUserInfo({
                enabledInOtherProduct: data.userInfo.enabledInOtherProduct
            }));
            dispatch((0, _actions5.setAuthorizationInfo)(data.additionalResultData.map['authorizationInfo']));
        }, function (error) {
            if (error._providerStatus === _constants.ValidationErrors.ACTION_CONFIRMED) {
                dispatch(updateAccessAP(enabled, true, forceLastLicenseManagerUpdate));
            } else if (error._providerStatus === _constants.ValidationErrors.ACTION_NOT_CONFIRMED) {
                dispatch(UserDataActions.setFullUserInfo({
                    enabledInOtherProduct: wasEnabled
                }));
            } else if (error._providerStatus === _constants.ValidationErrors.DISABLED_DUE_TO_LICENSE_TERMS) {
                dispatch(UserDataActions.setFullUserInfo({
                    enabledInOtherProduct: false
                }));
            } else if (error._providerStatus === 'UserIsLastLicensesManagerException') {
                if (forceLastLicenseManagerUpdate) dispatch(updateAccessAP(enabled, force, true));else dispatch(setLastLicenseManagerOnDisableApAlertShown(true));
            }
        }));
    };
};

var updateRequireApproval = exports.updateRequireApproval = function updateRequireApproval(needApproval) {
    return function (dispatch) {
        dispatch(performUpdateCall("UserManagementService.updateApproval", [needApproval]));
    };
};

var updateOvertime = exports.updateOvertime = function updateOvertime(level) {
    return function (dispatch) {

        dispatch(performUpdateCall("UserManagementService.updateOvertime", [level], function () {
            dispatch(UserDataActions.setFullUserInfo({
                overtimeLevel: level
            }));
        }));
    };
};

var updateUserSchedules = exports.updateUserSchedules = function updateUserSchedules() {
    var workSchedules = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return function (dispatch, getState) {
        var userManagementData = (0, _selectors4.getUserManagementData)(getState());
        var currentDate = userManagementData.todayInViewerTimeZone.parseJSONDate();
        workSchedules = workSchedules.map(function (ws) {
            var sameAsDefault = ws.effectiveDate !== null && ws.effectiveDate.parseJSONDate() >= currentDate ? ws.sameAsDefault : false;
            return _extends({}, ws, {
                sameAsDefault: sameAsDefault,
                durations: sameAsDefault ? userManagementData.defaultWorkSchedule : ws.durations
            });
        });

        dispatch(UserDataActions.removeUserPanelErrors([_constants.ValidationErrors.DUPLICATED_EFFECTIVE_DATE]));

        var schedulesToUpdate = workSchedules.filter(function (ws) {
            return ws.effectiveDate !== null;
        });

        dispatch(setUpdatingWorkSchedule(true));

        dispatch(performUpdateCall("UserManagementService.updateUserSchedules", [schedulesToUpdate], function () {
            dispatch(setUpdatingWorkSchedule(false));
            dispatch(UserDataActions.setFullUserInfo({
                workSchedule: workSchedules
            }));
        }, function (error) {
            dispatch(setUpdatingWorkSchedule(false));
            if (error._providerStatus === _constants.ValidationErrors.DUPLICATED_EFFECTIVE_DATE) {
                alert(_messageResource2.default.getMessage('userlist.userdata.schedules.duplicate_effective'));
                dispatch(UserDataActions.setFullUserInfo({
                    defaultInitialSchedule: error.defaultInitialSchedule,
                    initialSchedule: error.initialSchedule,
                    workSchedule: error.workSchedule
                }));
            }
        }));
    };
};

var addNewSchedule = exports.addNewSchedule = function addNewSchedule() {
    return function (dispatch, getState) {
        var state = getState();
        var workSchedule = (0, _selectors3.getWorkSchedule)(state);
        var userManagementData = (0, _selectors4.getUserManagementData)(state);
        var currentDateStr = userManagementData.todayInViewerTimeZone.parseJSONDate().toJSON();
        var effectiveDate = workSchedule.find(function (ws) {
            return ws.effectiveDate === currentDateStr;
        }) ? null : currentDateStr;

        var newSchedule = {
            effectiveDate: effectiveDate,
            durations: userManagementData.defaultWorkSchedule,
            sameAsDefault: effectiveDate === currentDateStr
        };

        if (newSchedule.effectiveDate !== null) {
            dispatch(updateUserSchedules([].concat(_toConsumableArray(workSchedule), [newSchedule]).map(function (ws) {
                return _extends({}, ws, { oldEffectiveDate: ws.effectiveDate });
            })));
        } else {
            dispatch(UserDataActions.setFullUserInfo({
                workSchedule: [].concat(_toConsumableArray(workSchedule), [newSchedule])
            }));
        }
    };
};

var updateInitialUserSchedule = exports.updateInitialUserSchedule = function updateInitialUserSchedule(_ref5) {
    var _ref5$isDefaultInitia = _ref5.isDefaultInitialSchedule,
        isDefaultInitialSchedule = _ref5$isDefaultInitia === undefined ? false : _ref5$isDefaultInitia,
        _ref5$initialSchedule = _ref5.initialSchedule,
        initialSchedule = _ref5$initialSchedule === undefined ? [] : _ref5$initialSchedule;
    return function (dispatch, getState) {
        initialSchedule = isDefaultInitialSchedule ? (0, _selectors4.getUserManagementData)(getState()).defaultWorkSchedule : initialSchedule;

        dispatch(setUpdatingWorkSchedule(true));
        dispatch(performUpdateCall("UserManagementService.updateInitialUserSchedule", [isDefaultInitialSchedule, initialSchedule], function () {
            dispatch(UserDataActions.setFullUserInfo({
                defaultInitialSchedule: isDefaultInitialSchedule,
                initialSchedule: initialSchedule
            }));
            dispatch(setUpdatingWorkSchedule(false));
        }), function () {
            dispatch(setUpdatingWorkSchedule(false));
        });
    };
};

var deleteUserSchedule = exports.deleteUserSchedule = function deleteUserSchedule(_ref6) {
    var _ref6$scheduleToRemov = _ref6.scheduleToRemove,
        scheduleToRemove = _ref6$scheduleToRemov === undefined ? [] : _ref6$scheduleToRemov,
        _ref6$removePermanent = _ref6.removePermanently,
        removePermanently = _ref6$removePermanent === undefined ? false : _ref6$removePermanent,
        index = _ref6.index;
    return function (dispatch, getState) {
        var state = getState();
        var workSchedule = [].concat(_toConsumableArray((0, _selectors3.getFullUserInfo)(state).workSchedule));

        if (removePermanently) {
            workSchedule.splice(index, 1);
            dispatch(UserDataActions.setFullUserInfo({
                workSchedule: workSchedule
            }));
        } else {
            dispatch(setUpdatingWorkSchedule(true));
            dispatch(performUpdateCall("UserManagementService.deleteUserSchedule", [scheduleToRemove], function () {
                dispatch(setUpdatingWorkSchedule(false));
                dispatch(UserDataActions.setFullUserInfo({
                    workSchedule: workSchedule.filter(function (ws) {
                        return ws.effectiveDate !== scheduleToRemove.oldEffectiveDate;
                    })
                }));
            }), function () {
                dispatch(setUpdatingWorkSchedule(false));
            });
        }
    };
};

var changeTeamAssignments = exports.changeTeamAssignments = function changeTeamAssignments(_ref7) {
    var teamAssignmentType = _ref7.teamAssignmentType,
        assignedGroupIds = _ref7.assignedGroupIds;
    return function (dispatch, getState) {
        var editUserId = (0, _selectors.getEditUserId)(getState());
        dispatch(changeTeamAssignmentsWithId(editUserId, { teamAssignmentType: teamAssignmentType, assignedGroupIds: assignedGroupIds }));
    };
};

var changeTeamAssignmentsWithId = exports.changeTeamAssignmentsWithId = function changeTeamAssignmentsWithId(userId, _ref8) {
    var _ref8$teamAssignmentT = _ref8.teamAssignmentType,
        teamAssignmentType = _ref8$teamAssignmentT === undefined ? '' : _ref8$teamAssignmentT,
        _ref8$assignedGroupId = _ref8.assignedGroupIds,
        assignedGroupIds = _ref8$assignedGroupId === undefined ? [] : _ref8$assignedGroupId,
        _ref8$assignedUserIds = _ref8.assignedUserIds,
        assignedUserIds = _ref8$assignedUserIds === undefined ? [] : _ref8$assignedUserIds;
    return function (dispatch) {
        dispatch(performUpdateCallWithId(userId, "UserManagementService.saveUserTeamAssignments", [teamAssignmentType, assignedGroupIds, assignedUserIds], function (data) {
            var teamAssignmentsData = data.additionalResultData.map['userTeamAssignmentsData'];
            dispatch(UserDataActions.setUserTeamAssignmentsData(teamAssignmentsData));
        }, function (error) {
            if (error instanceof _errors.SelectedUserDeletedError) {
                alert(_messageResource2.default.getMessage('userlist.js.error_selected_user_deleted'));
                dispatch(reloadUserData());
                return true;
            }
            if (error instanceof _errors.NoSuchUserGroupError) {
                alert(_messageResource2.default.getMessage('userlist.js.error_selected_user_group_deleted'));
                dispatch(reloadUserData());
                return true;
            }
        }));
    };
};

var updateEmailValidation = function updateEmailValidation(dispatch, email, backupEmail, providerErrors) {
    var validationResult = (0, _validation.validateEmail)(providerErrors, email, false, backupEmail);
    dispatch(UserDataActions.setUserPanelErrors(validationResult.errors));
    return validationResult;
};

var performUpdateCall = exports.performUpdateCall = function performUpdateCall(method, params, dataHandler, errorHandler) {
    return function (dispatch, getState) {
        var editUserId = (0, _selectors.getEditUserId)(getState());
        dispatch(performUpdateCallWithId(editUserId, method, params, dataHandler, errorHandler));
    };
};

var performUpdateCallWithId = function performUpdateCallWithId(editUserId, method, params) {
    var dataHandler = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function () {};
    var errorHandler = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : function () {};
    return function (dispatch, getState) {
        dispatch(setUpdatingData(true));

        var prevState = getState();

        makeRpcCall(method, [editUserId].concat(_toConsumableArray(params))).then(function (data) {
            var userInfo = data.userInfo;

            if ((0, _selectors2.getLoggedInUserId)(prevState) === editUserId) {
                dispatch((0, _actions8.updateLoggedInUser)((0, _util.pickLoggedInUserInfo)(userInfo)));
            }

            var userManagementData = {
                viewerSettings: data.viewerSettings
            };
            if (data.userGroups) {
                userManagementData.allUserGroups = data.userGroups;
            }
            if (data.timeZoneGroups) {
                userManagementData.allTimeZoneGroups = data.timeZoneGroups;
            }
            dispatch((0, _actions2.setUserManagementData)(userManagementData));

            dispatch(UserDataActions.setFullUserInfo(_extends({}, userInfo, {
                accessRights: (0, _utils.convertUserAccessRightsDataFromRpc)(userInfo)
            })));

            dispatch(updateAdditionalData(data, prevState));
            dispatch(setUpdatingData(false));
            dispatch(updateStateFromUpdateResult(data));
            dataHandler(data);
            SyncCallbacks.onUpdateUserData(data);
        }).catch(function (error) {
            dispatch(setUpdatingData(false));
            errorHandler(error);
            dispatch(UserDataActions.setPasswordValidationResult(error.additionalResultData ? error.additionalResultData.map[_PasswordSettings.PasswordValidators.PASSWORD_VALIDATION_RESULT_JSON] : null));
            dispatch(UserDataActions.addUserPanelErrors([error._providerStatus]));
            dispatch(handleCommonErrors(error));
        });
    };
};

var updateAdditionalData = function updateAdditionalData(data, prevState) {
    return function (dispatch) {
        if (data.additionalResultData) {
            var additionalData = data.additionalResultData.map;

            if (additionalData.rates) {
                dispatch(UserDataActions.setFullUserInfo({
                    rates: (0, _selectors6.isURAEnabled)(prevState) ? (0, _validationUtils.mergeUserRates)((0, _selectors5.getUserRates)(prevState), additionalData.rates) : additionalData.rates
                }));
            }

            if (!!additionalData[_constants3.AdditionalDataConstants.USERS_WITHOUT_APPROVERS_DATA]) {
                dispatch((0, _actions2.setUsersWithoutApprovers)(additionalData[_constants3.AdditionalDataConstants.USERS_WITHOUT_APPROVERS_DATA]));
            }

            if (!!additionalData[_constants3.AdditionalDataConstants.ALL_USERS_AUTOAPPROVED]) {
                dispatch(setUsersAutoApproved());
            }

            if (!!additionalData[_constants3.AdditionalDataConstants.ACTIVE_LEAVE_TYPES]) {
                dispatch((0, _actions2.setUserManagementData)({
                    activeLeaveTypes: additionalData.activeLeaveTypes
                }));
            }

            if (!!additionalData[_constants3.AdditionalDataConstants.TIME_ZONE_GROUPS_DATA]) {
                var allTimeZoneGroupOffsets = (0, _utils.getTimeZoneOffsets)(additionalData[_constants3.AdditionalDataConstants.TIME_ZONE_GROUPS_DATA].list);
                dispatch((0, _actions2.setUserManagementData)({ allTimeZoneGroupOffsets: allTimeZoneGroupOffsets }));
                dispatch((0, _actions.setTimeZoneGroupData)({ timeZoneGroupsOffset: allTimeZoneGroupOffsets }));
            }
        }
    };
};

var handleCommonErrors = function handleCommonErrors(data) {
    return function (dispatch, getState) {
        var editUserId = (0, _selectors.getEditUserId)(getState());

        if (data._providerStatus === _constants.ValidationErrors.NO_SUCH_USER) {
            alert(_messageResource2.default.getEscapedMessage("userlist.js.error_no_such_user"));

            dispatch(updateStateOnUserDelete(editUserId));
            SyncCallbacks.onDeleteUser(_extends({}, data, { id: editUserId }));
            dispatch(setEditingUserId(null));
        }
        if (data._providerStatus === _constants.ValidationErrors.USER_IS_LOCKED) {
            // todo: lamanov change message
            alert(_messageResource2.default.getEscapedMessage("userlist.js.error_no_such_user"));
            dispatch(setEditingUserId(null));
        }
    };
};

function makeRpcCall(method, params) {
    return new Promise(function (resolve, reject) {
        var _rpcErrorHandler = function _rpcErrorHandler(error) {
            var errorThrown = error.getErrorThrown();
            error.handleOnException(_util.EXCEPTIONS.LeavesOrTTBeforeNewHireDateException, { _providerStatus: _constants.ValidationErrors.LEAVES_OR_TT_BEFORE_NEW_HIRE_DATE });
            error.handleOnException(_util.EXCEPTIONS.UserIsLockedException, { _providerStatus: _constants.ValidationErrors.USER_IS_LOCKED });
            error.handleOnException(_util.EXCEPTIONS.UserEmailInvalidException, { _providerStatus: _constants.ValidationErrors.EMAIL_INVALID });
            error.handleOnException(_util.EXCEPTIONS.NoSuchUserException, { _providerStatus: _constants.ValidationErrors.NO_SUCH_USER });
            error.handleOnException(_util.EXCEPTIONS.UserIsLastLicensesManagerException, { _providerStatus: "UserIsLastLicensesManagerException" });

            if (errorThrown.exception === _util.EXCEPTIONS.NoRightsToManageAccountSettings) {
                alert(_messageResource2.default.getEscapedMessage("userlist.js.error_manage_account_settings_right_revoked"));
                window.location.reload();
                error.handle();
            }
            error.handleOnException(_util.EXCEPTIONS.DuplicateTimeZone, {
                _providerStatus: _constants.ValidationErrors.DUPLICATE_TIME_ZONE_GROUP,
                timeZones: errorThrown.timeZones
            });

            if (errorThrown.exception === _util.EXCEPTIONS.DuplicateEffectiveDatesInUserSchedulesException || errorThrown.exception === _util.EXCEPTIONS.DuplicateEffectiveDatesInUserRatesException) {
                error.handle(_extends({
                    _providerStatus: _constants.ValidationErrors.DUPLICATED_EFFECTIVE_DATE
                }, errorThrown));
            }

            if (errorThrown.exception === _util.EXCEPTIONS.AccountDisabledDueToThisProductLicenseException) {
                alert(_messageResource2.default.getMessage("user.edit.js.cannot_enable.at_license"));
                error.handle({
                    _providerStatus: _constants.ValidationErrors.DISABLED_DUE_TO_LICENSE_TERMS
                });
            }
            if (errorThrown.exception === _util.EXCEPTIONS.AccountDisabledDueToOtherProductLicenseException) {
                alert(_messageResource2.default.getMessage("user.edit.js.cannot_enable.ap_license"));
                error.handle({
                    _providerStatus: _constants.ValidationErrors.DISABLED_DUE_TO_LICENSE_TERMS
                });
            }

            if (errorThrown.exception === _util.EXCEPTIONS.EditUserConfirmationIsNeededException || errorThrown.exception === _util.EXCEPTIONS.DeleteUserConfirmationIsNeededException) {

                var confirmationMessage = errorThrown.exception === _util.EXCEPTIONS.EditUserConfirmationIsNeededException ? new _UserListConfirmation2.default().createEditConfirmationMsg(errorThrown) : new _UserListConfirmation2.default().createDeleteConfirmationMsg(errorThrown);
                if (confirm(confirmationMessage)) {
                    error.handle({
                        _providerStatus: _constants.ValidationErrors.ACTION_CONFIRMED
                    });
                } else {
                    error.handle({
                        _providerStatus: _constants.ValidationErrors.ACTION_NOT_CONFIRMED
                    });
                }
            }

            error.handleOnException(_util.EXCEPTIONS.NoSuchUserGroupException, new _errors.NoSuchUserGroupError());
            error.handleOnException(_util.EXCEPTIONS.SelectedUserDeletedException, new _errors.SelectedUserDeletedError());
        };

        (0, _rpcCalls2.default)(method, params, _rpcErrorHandler).then(function (data) {
            var _Code2ErrorMap;

            if (_underscore2.default.isUndefined(data.resultCode) || data.resultCode === _constants2.UserManagementConstants.RESULT_CODE_SUCCESS) {
                resolve(data);
            }

            if (data.resultCode === _constants2.UserManagementConstants.ERROR_NO_RIGHTS_TO_MANAGE_ACCOUNT_SETTINGS) {
                alert(_messageResource2.default.getEscapedMessage("userlist.js.error_manage_account_settings_right_revoked"));
                window.location.reload();
                return;
            }
            var Code2ErrorMap = (_Code2ErrorMap = {}, _defineProperty(_Code2ErrorMap, _constants2.UserManagementConstants.PASSWORD_RESTRICTIONS_VIOLATED, _constants.ValidationErrors.PASSWORD_RESTRICTIONS_VIOLATED), _defineProperty(_Code2ErrorMap, _constants2.UserManagementConstants.PASSWORD_COPY_EMPTY, _constants.ValidationErrors.PASSWORD_COPY_EMPTY), _defineProperty(_Code2ErrorMap, _constants2.UserManagementConstants.PASSWORD_EMPTY, _constants.ValidationErrors.PASSWORD_EMPTY), _defineProperty(_Code2ErrorMap, _constants2.UserManagementConstants.PASSWORD_COPY_MISMATCH, _constants.ValidationErrors.PASSWORDS_DO_NOT_MATCH), _defineProperty(_Code2ErrorMap, _constants2.UserManagementConstants.ERROR_NO_SUCH_USER, _constants.ValidationErrors.NO_SUCH_USER), _defineProperty(_Code2ErrorMap, _constants2.UserManagementConstants.ERROR_DUPLICATE_USERNAME, _constants.ValidationErrors.DUPLICATE_USERNAME), _defineProperty(_Code2ErrorMap, _constants2.UserManagementConstants.ERROR_CANNOT_DISABLE_LAST_USER_MANAGER_IN_OTHER_PRODUCT, _constants.ValidationErrors.LAST_MANAGER_IN_OTHER_PRODUCT), _Code2ErrorMap);
            var status = Code2ErrorMap[data.resultCode];
            if (status) {
                reject(_extends({}, data, { _providerStatus: status }));
            }
        }).catch(reject);
    });
}

var updateStateFromUpdateResult = function updateStateFromUpdateResult(result) {
    return function (dispatch) {
        dispatch((0, _actions2.setLicenseCounters)(result.licenseCounters));
        dispatch((0, _actions2.setViewerSettings)(result.viewerSettings));
        if (result.userGroups) {
            dispatch((0, _actions4.setUserGroupsList)(result.userGroups));
        }
        if (result.timeZoneGroups) {
            dispatch((0, _actions4.setTimeZoneGroupsList)(result.timeZoneGroups));
        }

        dispatch((0, _actions3.setEnabledFeatures)(result.viewerSettings.enabledFeatures));
        dispatch((0, _actions4.addUser)(result.userInfo));
    };
};

var updateStateFromEditUserData = function updateStateFromEditUserData(data) {
    return function (dispatch) {
        if (data.userManagementData.allUserGroups) {
            dispatch((0, _actions4.setUserGroupsList)(data.userManagementData.allUserGroups));
        }
        if (data.userManagementData.allTimeZoneGroups) {
            dispatch((0, _actions4.setTimeZoneGroupsList)(data.userManagementData.allTimeZoneGroups));
        }
        dispatch((0, _actions.updateStateFromViewerSettings)(data.userManagementData.viewerSettings));

        SyncCallbacks.onUpdateUserData(data.userManagementResult);
    };
};

var updateStateOnUserDelete = function updateStateOnUserDelete(id) {
    return function (dispatch) {
        dispatch((0, _actions4.removeUser)(id));
    };
};

var updateStateOnUserDeleteSuccess = function updateStateOnUserDeleteSuccess(id, result) {
    return function (dispatch) {
        dispatch((0, _actions2.setLicenseCounters)(result.licenseCounters));
        dispatch((0, _actions2.setViewerSettings)(result.viewerSettings));
        if (result.userGroups) {
            dispatch((0, _actions4.addUserGroups)(result.userGroups));
        }
        if (result.timeZoneGroups) {
            dispatch((0, _actions4.addTimeZoneGroups)(result.timeZoneGroups));
        }
        dispatch((0, _actions3.setEnabledFeatures)(result.viewerSettings.enabledFeatures));
        dispatch(updateStateOnUserDelete(id));
    };
};

var setUsersAutoApproved = function setUsersAutoApproved() {
    return function (dispatch, getState) {
        var state = getState();
        var users = Object.values((0, _selectors4.getUsersList)(state)).map(function (user) {
            return _extends({}, user, { requiresTTApproval: false });
        });
        dispatch((0, _actions2.addNewUsersToList)(users));
        var entitiesUsers = Object.values((0, _selectors7.getUsers)(state)).map(function (user) {
            return _extends({}, user, { requiresTTApproval: false });
        });
        dispatch((0, _actions4.addUsers)(entitiesUsers));
    };
};

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.downloadJsonAsCSV = downloadJsonAsCSV;

var _atUtils = __webpack_require__(5);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _json2csv = __webpack_require__(576);

var _json2csv2 = _interopRequireDefault(_json2csv);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function downloadJsonAsCSV(jsons, fileName) {
    var callback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};

    if (!(0, _atUtils.saveFileSupported)()) alert(_messageResource2.default.getMessage('js.alert.operation_unsupported'));

    var eol = '\r\n';
    var separator = window.SystemSettings.csvSeparator;

    var encoding = window.SystemSettings.csvMultilanguage ? 'UTF-16' : 'UTF-8';

    (0, _json2csv2.default)(jsons, separator, eol, false, function (csv) {
        (0, _atUtils.saveFile)(csv, fileName, { encoding: encoding, 'type': 'text/csv;charset=' + encoding });
        callback();
    });
}

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isFeedsContentLoading = exports.isUserActionLoading = exports.getICalInfo = exports.isTopButtonsShown = exports.isLoading = exports.isFeedsEmpty = exports.getSharedFeedsForTable = exports.getSharedFeedsMap = exports.getAllFeedsForTable = exports.getAllFeedsMap = exports.getSharedFeedsSorting = exports.getAllFeedsSorting = exports.getRecentlyConfiguredFeedId = exports.getActiveTab = undefined;

var _reselect = __webpack_require__(13);

var _constants = __webpack_require__(51);

var _selectors = __webpack_require__(14);

var _utils = __webpack_require__(168);

var getICalendarFeedsState = function getICalendarFeedsState(state) {
    return state.iCalendar.feeds;
};

var getActiveTab = exports.getActiveTab = (0, _reselect.createSelector)(getICalendarFeedsState, function (state) {
    return state.activeTab;
});

var getRecentlyConfiguredFeedId = exports.getRecentlyConfiguredFeedId = (0, _reselect.createSelector)(getICalendarFeedsState, function (state) {
    return state.recentlyConfiguredFeedId;
});

var getAllFeedsSorting = exports.getAllFeedsSorting = (0, _reselect.createSelector)(getICalendarFeedsState, function (state) {
    return state.allSorting;
});

var getSharedFeedsSorting = exports.getSharedFeedsSorting = (0, _reselect.createSelector)(getICalendarFeedsState, function (state) {
    return state.sharedSorting;
});

var getAllFeedsMap = exports.getAllFeedsMap = (0, _reselect.createSelector)(getICalendarFeedsState, function (state) {
    return state.allFeeds;
});

var getAllFeedsForTable = exports.getAllFeedsForTable = (0, _reselect.createSelector)(getAllFeedsMap, _selectors.getUsers, _selectors.getLeaveTypes, _selectors.getUserGroupsWithDefault, _selectors.getTimeZoneGroups, getRecentlyConfiguredFeedId, getAllFeedsSorting, function (feeds, users, lt, ug, tz, recentlyConfiguredId, sorting) {
    return (0, _utils.sortFeedsBySetting)((0, _utils.convertData)(feeds, lt, users, ug, tz, recentlyConfiguredId), sorting);
});

var getSharedFeedsMap = exports.getSharedFeedsMap = (0, _reselect.createSelector)(getICalendarFeedsState, function (state) {
    return state.sharedFeeds;
});

var getSharedFeedsForTable = exports.getSharedFeedsForTable = (0, _reselect.createSelector)(getSharedFeedsMap, _selectors.getUsers, _selectors.getLeaveTypes, _selectors.getUserGroupsWithDefault, _selectors.getTimeZoneGroups, getSharedFeedsSorting, function (feeds, users, lt, ug, tz, sorting) {
    return (0, _utils.sortFeedsBySetting)((0, _utils.convertData)(feeds, lt, users, ug, tz), sorting);
});

var isFeedsEmpty = exports.isFeedsEmpty = (0, _reselect.createSelector)(getICalendarFeedsState, function (state) {
    return state.activeTab === _constants.ICalTabType.ALL_FEEDS && (!state.allFeeds || window.isObjectEmpty(state.allFeeds)) || state.activeTab === _constants.ICalTabType.USER_FEEDS && (!state.sharedFeeds || window.isObjectEmpty(state.sharedFeeds));
});

var isLoading = exports.isLoading = (0, _reselect.createSelector)(getICalendarFeedsState, function (state) {
    return state.loading;
});

var isTopButtonsShown = exports.isTopButtonsShown = (0, _reselect.createSelector)(isLoading, getActiveTab, getAllFeedsMap, function (loading, activeTab, allFeeds) {
    return !loading && activeTab === _constants.ICalTabType.ALL_FEEDS && !!allFeeds && !window.isObjectEmpty(allFeeds);
});

var getICalInfo = exports.getICalInfo = (0, _reselect.createSelector)(getICalendarFeedsState, function (state) {
    return {
        activeTab: state.activeTab,
        allSorting: state.allSorting,
        sharedSorting: state.sharedSorting
    };
});

var isUserActionLoading = exports.isUserActionLoading = function isUserActionLoading(state) {
    return getICalendarFeedsState(state).userActionLoading;
};

var isFeedsContentLoading = exports.isFeedsContentLoading = function isFeedsContentLoading(state) {
    return getICalendarFeedsState(state).feedsContentLoading;
};

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var LeaveTypeColumnConfig = exports.LeaveTypeColumnConfig = {
    LEAVE_TIME_ONLY: window.__GENERATED_CONSTANTS__.LeaveTypeColumnConfig.LEAVE_TIME_ONLY,
    BALANCES_ONLY: window.__GENERATED_CONSTANTS__.LeaveTypeColumnConfig.BALANCES_ONLY,
    LEAVE_TIME_AND_BALANCES: window.__GENERATED_CONSTANTS__.LeaveTypeColumnConfig.LEAVE_TIME_AND_BALANCES
};

var LeaveTypeBalanceQualifier = exports.LeaveTypeBalanceQualifier = {
    SICK_DAYS_ONLY: window.__GENERATED_CONSTANTS__.LeaveTypeBalanceQualifier.SICK_DAYS_ONLY,
    PTO_ONLY: window.__GENERATED_CONSTANTS__.LeaveTypeBalanceQualifier.PTO_ONLY,
    PTO_AND_SICK_DAYS: window.__GENERATED_CONSTANTS__.LeaveTypeBalanceQualifier.PTO_AND_SICK_DAYS
};

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var ColumnsConfig = exports.ColumnsConfig = {
    TIME_BALANCE_ONLY: "TIME_BALANCE_ONLY",
    OVERTIME_ONLY: "OVERTIME_ONLY",
    TIME_BALANCE_AND_OVERTIME: "TIME_BALANCE_AND_OVERTIME"
};

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(31);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 132 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(75);
var toObject = __webpack_require__(58);
var IE_PROTO = __webpack_require__(420)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

if (__webpack_require__(47)) {
  var LIBRARY = __webpack_require__(172);
  var global = __webpack_require__(35);
  var fails = __webpack_require__(32);
  var $export = __webpack_require__(10);
  var $typed = __webpack_require__(337);
  var $buffer = __webpack_require__(439);
  var ctx = __webpack_require__(112);
  var anInstance = __webpack_require__(220);
  var propertyDesc = __webpack_require__(173);
  var hide = __webpack_require__(87);
  var redefineAll = __webpack_require__(219);
  var toInteger = __webpack_require__(111);
  var toLength = __webpack_require__(54);
  var toIndex = __webpack_require__(636);
  var toAbsoluteIndex = __webpack_require__(177);
  var toPrimitive = __webpack_require__(131);
  var has = __webpack_require__(75);
  var classof = __webpack_require__(328);
  var isObject = __webpack_require__(31);
  var toObject = __webpack_require__(58);
  var isArrayIter = __webpack_require__(424);
  var create = __webpack_require__(175);
  var getPrototypeOf = __webpack_require__(133);
  var gOPN = __webpack_require__(178).f;
  var getIterFn = __webpack_require__(426);
  var uid = __webpack_require__(174);
  var wks = __webpack_require__(41);
  var createArrayMethod = __webpack_require__(113);
  var createArrayIncludes = __webpack_require__(326);
  var speciesConstructor = __webpack_require__(434);
  var ArrayIterators = __webpack_require__(330);
  var Iterators = __webpack_require__(216);
  var $iterDetect = __webpack_require__(329);
  var setSpecies = __webpack_require__(218);
  var arrayFill = __webpack_require__(428);
  var arrayCopyWithin = __webpack_require__(612);
  var $DP = __webpack_require__(46);
  var $GOPD = __webpack_require__(90);
  var dP = $DP.f;
  var gOPD = $GOPD.f;
  var RangeError = global.RangeError;
  var TypeError = global.TypeError;
  var Uint8Array = global.Uint8Array;
  var ARRAY_BUFFER = 'ArrayBuffer';
  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
  var PROTOTYPE = 'prototype';
  var ArrayProto = Array[PROTOTYPE];
  var $ArrayBuffer = $buffer.ArrayBuffer;
  var $DataView = $buffer.DataView;
  var arrayForEach = createArrayMethod(0);
  var arrayFilter = createArrayMethod(2);
  var arraySome = createArrayMethod(3);
  var arrayEvery = createArrayMethod(4);
  var arrayFind = createArrayMethod(5);
  var arrayFindIndex = createArrayMethod(6);
  var arrayIncludes = createArrayIncludes(true);
  var arrayIndexOf = createArrayIncludes(false);
  var arrayValues = ArrayIterators.values;
  var arrayKeys = ArrayIterators.keys;
  var arrayEntries = ArrayIterators.entries;
  var arrayLastIndexOf = ArrayProto.lastIndexOf;
  var arrayReduce = ArrayProto.reduce;
  var arrayReduceRight = ArrayProto.reduceRight;
  var arrayJoin = ArrayProto.join;
  var arraySort = ArrayProto.sort;
  var arraySlice = ArrayProto.slice;
  var arrayToString = ArrayProto.toString;
  var arrayToLocaleString = ArrayProto.toLocaleString;
  var ITERATOR = wks('iterator');
  var TAG = wks('toStringTag');
  var TYPED_CONSTRUCTOR = uid('typed_constructor');
  var DEF_CONSTRUCTOR = uid('def_constructor');
  var ALL_CONSTRUCTORS = $typed.CONSTR;
  var TYPED_ARRAY = $typed.TYPED;
  var VIEW = $typed.VIEW;
  var WRONG_LENGTH = 'Wrong length!';

  var $map = createArrayMethod(1, function (O, length) {
    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
  });

  var LITTLE_ENDIAN = fails(function () {
    // eslint-disable-next-line no-undef
    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
  });

  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
    new Uint8Array(1).set({});
  });

  var toOffset = function (it, BYTES) {
    var offset = toInteger(it);
    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
    return offset;
  };

  var validate = function (it) {
    if (isObject(it) && TYPED_ARRAY in it) return it;
    throw TypeError(it + ' is not a typed array!');
  };

  var allocate = function (C, length) {
    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
      throw TypeError('It is not a typed array constructor!');
    } return new C(length);
  };

  var speciesFromList = function (O, list) {
    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
  };

  var fromList = function (C, list) {
    var index = 0;
    var length = list.length;
    var result = allocate(C, length);
    while (length > index) result[index] = list[index++];
    return result;
  };

  var addGetter = function (it, key, internal) {
    dP(it, key, { get: function () { return this._d[internal]; } });
  };

  var $from = function from(source /* , mapfn, thisArg */) {
    var O = toObject(source);
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var iterFn = getIterFn(O);
    var i, length, values, result, step, iterator;
    if (iterFn != undefined && !isArrayIter(iterFn)) {
      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
        values.push(step.value);
      } O = values;
    }
    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
      result[i] = mapping ? mapfn(O[i], i) : O[i];
    }
    return result;
  };

  var $of = function of(/* ...items */) {
    var index = 0;
    var length = arguments.length;
    var result = allocate(this, length);
    while (length > index) result[index] = arguments[index++];
    return result;
  };

  // iOS Safari 6.x fails here
  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });

  var $toLocaleString = function toLocaleString() {
    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
  };

  var proto = {
    copyWithin: function copyWithin(target, start /* , end */) {
      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
    },
    every: function every(callbackfn /* , thisArg */) {
      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
      return arrayFill.apply(validate(this), arguments);
    },
    filter: function filter(callbackfn /* , thisArg */) {
      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
        arguments.length > 1 ? arguments[1] : undefined));
    },
    find: function find(predicate /* , thisArg */) {
      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    findIndex: function findIndex(predicate /* , thisArg */) {
      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    forEach: function forEach(callbackfn /* , thisArg */) {
      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    indexOf: function indexOf(searchElement /* , fromIndex */) {
      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    includes: function includes(searchElement /* , fromIndex */) {
      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    join: function join(separator) { // eslint-disable-line no-unused-vars
      return arrayJoin.apply(validate(this), arguments);
    },
    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
      return arrayLastIndexOf.apply(validate(this), arguments);
    },
    map: function map(mapfn /* , thisArg */) {
      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduce.apply(validate(this), arguments);
    },
    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduceRight.apply(validate(this), arguments);
    },
    reverse: function reverse() {
      var that = this;
      var length = validate(that).length;
      var middle = Math.floor(length / 2);
      var index = 0;
      var value;
      while (index < middle) {
        value = that[index];
        that[index++] = that[--length];
        that[length] = value;
      } return that;
    },
    some: function some(callbackfn /* , thisArg */) {
      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    sort: function sort(comparefn) {
      return arraySort.call(validate(this), comparefn);
    },
    subarray: function subarray(begin, end) {
      var O = validate(this);
      var length = O.length;
      var $begin = toAbsoluteIndex(begin, length);
      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
        O.buffer,
        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
      );
    }
  };

  var $slice = function slice(start, end) {
    return speciesFromList(this, arraySlice.call(validate(this), start, end));
  };

  var $set = function set(arrayLike /* , offset */) {
    validate(this);
    var offset = toOffset(arguments[1], 1);
    var length = this.length;
    var src = toObject(arrayLike);
    var len = toLength(src.length);
    var index = 0;
    if (len + offset > length) throw RangeError(WRONG_LENGTH);
    while (index < len) this[offset + index] = src[index++];
  };

  var $iterators = {
    entries: function entries() {
      return arrayEntries.call(validate(this));
    },
    keys: function keys() {
      return arrayKeys.call(validate(this));
    },
    values: function values() {
      return arrayValues.call(validate(this));
    }
  };

  var isTAIndex = function (target, key) {
    return isObject(target)
      && target[TYPED_ARRAY]
      && typeof key != 'symbol'
      && key in target
      && String(+key) == String(key);
  };
  var $getDesc = function getOwnPropertyDescriptor(target, key) {
    return isTAIndex(target, key = toPrimitive(key, true))
      ? propertyDesc(2, target[key])
      : gOPD(target, key);
  };
  var $setDesc = function defineProperty(target, key, desc) {
    if (isTAIndex(target, key = toPrimitive(key, true))
      && isObject(desc)
      && has(desc, 'value')
      && !has(desc, 'get')
      && !has(desc, 'set')
      // TODO: add validation descriptor w/o calling accessors
      && !desc.configurable
      && (!has(desc, 'writable') || desc.writable)
      && (!has(desc, 'enumerable') || desc.enumerable)
    ) {
      target[key] = desc.value;
      return target;
    } return dP(target, key, desc);
  };

  if (!ALL_CONSTRUCTORS) {
    $GOPD.f = $getDesc;
    $DP.f = $setDesc;
  }

  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
    getOwnPropertyDescriptor: $getDesc,
    defineProperty: $setDesc
  });

  if (fails(function () { arrayToString.call({}); })) {
    arrayToString = arrayToLocaleString = function toString() {
      return arrayJoin.call(this);
    };
  }

  var $TypedArrayPrototype$ = redefineAll({}, proto);
  redefineAll($TypedArrayPrototype$, $iterators);
  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
  redefineAll($TypedArrayPrototype$, {
    slice: $slice,
    set: $set,
    constructor: function () { /* noop */ },
    toString: arrayToString,
    toLocaleString: $toLocaleString
  });
  addGetter($TypedArrayPrototype$, 'buffer', 'b');
  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
  addGetter($TypedArrayPrototype$, 'length', 'e');
  dP($TypedArrayPrototype$, TAG, {
    get: function () { return this[TYPED_ARRAY]; }
  });

  // eslint-disable-next-line max-statements
  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
    CLAMPED = !!CLAMPED;
    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
    var GETTER = 'get' + KEY;
    var SETTER = 'set' + KEY;
    var TypedArray = global[NAME];
    var Base = TypedArray || {};
    var TAC = TypedArray && getPrototypeOf(TypedArray);
    var FORCED = !TypedArray || !$typed.ABV;
    var O = {};
    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
    var getter = function (that, index) {
      var data = that._d;
      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
    };
    var setter = function (that, index, value) {
      var data = that._d;
      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
    };
    var addElement = function (that, index) {
      dP(that, index, {
        get: function () {
          return getter(this, index);
        },
        set: function (value) {
          return setter(this, index, value);
        },
        enumerable: true
      });
    };
    if (FORCED) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME, '_d');
        var index = 0;
        var offset = 0;
        var buffer, byteLength, length, klass;
        if (!isObject(data)) {
          length = toIndex(data);
          byteLength = length * BYTES;
          buffer = new $ArrayBuffer(byteLength);
        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          buffer = data;
          offset = toOffset($offset, BYTES);
          var $len = data.byteLength;
          if ($length === undefined) {
            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
            byteLength = $len - offset;
            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
          } else {
            byteLength = toLength($length) * BYTES;
            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
          }
          length = byteLength / BYTES;
        } else if (TYPED_ARRAY in data) {
          return fromList(TypedArray, data);
        } else {
          return $from.call(TypedArray, data);
        }
        hide(that, '_d', {
          b: buffer,
          o: offset,
          l: byteLength,
          e: length,
          v: new $DataView(buffer)
        });
        while (index < length) addElement(that, index++);
      });
      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
      hide(TypedArrayPrototype, 'constructor', TypedArray);
    } else if (!fails(function () {
      TypedArray(1);
    }) || !fails(function () {
      new TypedArray(-1); // eslint-disable-line no-new
    }) || !$iterDetect(function (iter) {
      new TypedArray(); // eslint-disable-line no-new
      new TypedArray(null); // eslint-disable-line no-new
      new TypedArray(1.5); // eslint-disable-line no-new
      new TypedArray(iter); // eslint-disable-line no-new
    }, true)) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME);
        var klass;
        // `ws` module bug, temporarily remove validation length for Uint8Array
        // https://github.com/websockets/ws/pull/645
        if (!isObject(data)) return new Base(toIndex(data));
        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          return $length !== undefined
            ? new Base(data, toOffset($offset, BYTES), $length)
            : $offset !== undefined
              ? new Base(data, toOffset($offset, BYTES))
              : new Base(data);
        }
        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
        return $from.call(TypedArray, data);
      });
      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
      });
      TypedArray[PROTOTYPE] = TypedArrayPrototype;
      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
    }
    var $nativeIterator = TypedArrayPrototype[ITERATOR];
    var CORRECT_ITER_NAME = !!$nativeIterator
      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
    var $iterator = $iterators.values;
    hide(TypedArray, TYPED_CONSTRUCTOR, true);
    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
    hide(TypedArrayPrototype, VIEW, true);
    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);

    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
      dP(TypedArrayPrototype, TAG, {
        get: function () { return NAME; }
      });
    }

    O[NAME] = TypedArray;

    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);

    $export($export.S, NAME, {
      BYTES_PER_ELEMENT: BYTES
    });

    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
      from: $from,
      of: $of
    });

    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);

    $export($export.P, NAME, proto);

    setSpecies(NAME);

    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });

    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);

    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;

    $export($export.P + $export.F * fails(function () {
      new TypedArray(1).slice();
    }), NAME, { slice: $slice });

    $export($export.P + $export.F * (fails(function () {
      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
    }) || !fails(function () {
      TypedArrayPrototype.toLocaleString.call([1, 2]);
    })), NAME, { toLocaleString: $toLocaleString });

    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
  };
} else module.exports = function () { /* empty */ };


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.isNextApiError = isNextApiError;
exports.isNetworkError = isNetworkError;
exports.isNotFoundError = isNotFoundError;
exports.isUnauthenticated = isUnauthenticated;
exports.mergePreviousWorkflowStatuses = mergePreviousWorkflowStatuses;
exports.mergeClassicAndNextTask = mergeClassicAndNextTask;
exports.nextDurationToMinutes = nextDurationToMinutes;
exports.convertVariance = convertVariance;
exports.mergeRpcAndNextTaskData = mergeRpcAndNextTaskData;
exports.convertClassicWorkflowStatusToNext = convertClassicWorkflowStatusToNext;
exports.convertNextWorkflowStatusToClassic = convertNextWorkflowStatusToClassic;
exports.convertNextWorkflowStatusesToClassic = convertNextWorkflowStatusesToClassic;
exports.convertNextTargetGroupToClassic = convertNextTargetGroupToClassic;
exports.convertNextKanbanSummaryToClassicKanbanInitial = convertNextKanbanSummaryToClassicKanbanInitial;

var _constants = __webpack_require__(77);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _utils = __webpack_require__(341);

var _constants2 = __webpack_require__(23);

var _atUtils = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function isNextApiError(error) {
    return error.name && error.name === 'ApiError';
}

function isNetworkError(error) {
    return error.name && error.name === 'NetworkError';
}

function isNotFoundError(error, entityType) {
    var body = error.body;
    return body.errorKey === _constants.ApiErrorKeys.NotFoundEntity && (!entityType || body.entityType === entityType);
}

function isUnauthenticated(error) {
    var body = error.body;
    return body.errorKey === _constants.ApiErrorKeys.Unauthenticated;
}

function mergePreviousWorkflowStatuses(previousWorkflowStatuses, workflowStatuses) {
    return Object.entries(workflowStatuses).reduce(function (acc, _ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            id = _ref2[0],
            workflowStatus = _ref2[1];

        var previousWorkflowStatus = previousWorkflowStatuses[id];
        if (!previousWorkflowStatus || previousWorkflowStatus.nextId === undefined) return _extends({}, acc, _defineProperty({}, id, workflowStatus));
        return _extends({}, acc, _defineProperty({}, id, _extends({}, workflowStatus, { nextId: previousWorkflowStatus.nextId })));
    }, {});
}

function mergeClassicAndNextTask(classicTask, nextTask) {
    return _extends({}, classicTask, {
        nextId: nextTask.id,
        customFieldsValues: (0, _utils.collectCustomFieldValues)(nextTask),
        spentTime: nextTask.spentTime ? nextDurationToMinutes(nextTask.spentTime) : null,
        variance: convertVariance(nextTask.variance),
        progress: convertProgress(nextTask.progress)
    });
}

function nextDurationToMinutes(durationStr) {
    var reptms = /^PT(?:(-?\d+)H)?(?:(-?\d+)M)?$/;
    var hours = 0,
        minutes = 0,
        seconds = 0,
        totalMinutes = 0;

    if (reptms.test(durationStr)) {
        var matches = reptms.exec(durationStr);
        if (matches[1]) hours = Number(matches[1]);
        if (matches[2]) minutes = Number(matches[2]);
        totalMinutes = hours * 60 + minutes;
    }
    return totalMinutes;
}

function convertVariance(variance) {
    return variance ? {
        duration: variance.duration ? nextDurationToMinutes(variance.duration) : null,
        percentage: (0, _underscore.isNumber)(variance.percentage) ? variance.percentage * 100 : null
    } : null;
}

function convertProgress(progress) {
    return (0, _underscore.isNumber)(progress) ? progress : null;
}

function mergeRpcAndNextTaskData(rpcTasks, nextData) {
    var nextValuesDataMap = {};
    nextData.items.forEach(function (nextTask) {
        return nextValuesDataMap[nextTask.classicId] = nextTask;
    });

    return rpcTasks.map(function (classicTask) {
        var nextTask = nextValuesDataMap[classicTask.id];
        if (nextTask) return mergeClassicAndNextTask(classicTask, nextTask);

        return classicTask;
    });
}

function convertClassicWorkflowStatusToNext(classicWorkflowStatus) {
    return {
        id: classicWorkflowStatus.nextId,
        classicId: classicWorkflowStatus.id,
        name: classicWorkflowStatus.name,
        position: classicWorkflowStatus.position,
        targetActive: classicWorkflowStatus.type === _constants2.WorkflowStatusType.OPEN,
        colorKey: _constants.ClassicWorkflowStatusColorKeyToNextMap[classicWorkflowStatus.colorId]
    };
}

function convertNextWorkflowStatusToClassic(nextWorkflowStatus) {
    return {
        id: nextWorkflowStatus.classicId,
        nextId: nextWorkflowStatus.id,
        name: nextWorkflowStatus.name,
        position: nextWorkflowStatus.position,
        type: nextWorkflowStatus.targetActive ? _constants2.WorkflowStatusType.OPEN : _constants2.WorkflowStatusType.COMPLETED,
        colorId: _constants.NextWorkflowStatusColorKeyToClassicMap[nextWorkflowStatus.colorKey] || 0
    };
}

function convertNextWorkflowStatusesToClassic(nextWorkflowStatuses) {
    return nextWorkflowStatuses.reduce(function (acc, nextWorkflowStatus) {
        return _extends({}, acc, _defineProperty({}, nextWorkflowStatus.classicId, convertNextWorkflowStatusToClassic(nextWorkflowStatus)));
    }, {});
}

function convertNextTargetGroupToClassic(nextTargetGroup) {
    var nextParentTargetGroups = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

    var nextParentTargetGroup = nextParentTargetGroups.find(function (nextParentTargetGroup) {
        return nextTargetGroup.parentId === nextParentTargetGroup.id;
    });

    return {
        id: nextTargetGroup.classicId,
        name: nextTargetGroup.title,
        archived: !nextTargetGroup.active,
        customerId: nextParentTargetGroup && nextParentTargetGroup.classicId
    };
}

function convertNextKanbanSummaryToClassicKanbanInitial(nextKanbanSummary) {
    var referencedNextTargetGroups = nextKanbanSummary.referenced.targetGroups ? Object.values(nextKanbanSummary.referenced.targetGroups) : [];
    var nextProjects = referencedNextTargetGroups.filter(function (nextTargetGroup) {
        return nextTargetGroup.levelId === _constants.NextGroupLevelId.Project;
    });
    var nextCustomers = referencedNextTargetGroups.filter(function (nextTargetGroup) {
        return nextTargetGroup.levelId === _constants.NextGroupLevelId.Customer;
    }).sort(function (a, b) {
        return (0, _atUtils.stringComparator)(a.title, b.title);
    });
    var nextWorkflowStatuses = nextKanbanSummary.referenced.workflowStatuses ? Object.values(nextKanbanSummary.referenced.workflowStatuses) : [];

    nextProjects = nextCustomers.reduce(function (acc, nextCustomer) {
        var groupedNextProject = nextProjects.filter(function (project) {
            return project.parentId === nextCustomer.id;
        });
        return [].concat(_toConsumableArray(acc), _toConsumableArray(groupedNextProject.sort(function (a, b) {
            return (0, _atUtils.stringComparator)(a.title, b.title);
        })));
    }, []);

    var classicWorkflowStatuses = nextWorkflowStatuses.map(function (nextWorkflowStatus) {
        return convertNextWorkflowStatusToClassic(nextWorkflowStatus);
    });

    nextKanbanSummary.items = nextKanbanSummary.items.map(function (item) {
        var classicWorkflowStatus = classicWorkflowStatuses.find(function (workflowStatus) {
            return workflowStatus.nextId === item.workflowStatusId;
        });
        return _extends({}, item, {
            classicId: classicWorkflowStatus.id
        });
    });

    var taskCountByStatusId = nextKanbanSummary.items.reduce(function (acc, curr) {
        return _extends({}, acc, _defineProperty({}, curr.classicId, curr.targetsCount));
    }, {});

    return {
        taskCountByStatusId: taskCountByStatusId,
        workflowStatuses: classicWorkflowStatuses,
        customersProjectsInfo: {
            projects: nextProjects.map(function (nextProject) {
                return convertNextTargetGroupToClassic(nextProject, nextCustomers);
            }),
            customers: nextCustomers.map(function (nextCustomer) {
                return convertNextTargetGroupToClassic(nextCustomer);
            }, []),
            projectIdsContainingTasks: nextProjects.map(function (nextProject) {
                return nextProject.classicId;
            })
        }
    };
}

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _LoadingMoire = __webpack_require__(92);

var _LoadingMoire2 = _interopRequireDefault(_LoadingMoire);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LoadingControlMixin = {
    isLoading: function isLoading() {
        return this._loadingControl;
    },

    setLoading: function setLoading(loading) {
        if (this._loadingControl !== loading) {
            this._loadingControl = loading;
            this._getLoadingControlMoire().toggle(loading);
        }
    },

    _getLoadingControlMoire: function _getLoadingControlMoire() {
        if (!this._loadingControlMoire) {
            this._loadingControlMoire = new _LoadingMoire2.default().init(this.$el);
        }
        return this._loadingControlMoire;
    }
};

exports.default = LoadingControlMixin;

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = EmptyHighlighter;

var _atUtils = __webpack_require__(5);

function EmptyHighlighter() {}

EmptyHighlighter.prototype.highlightTokens = function (text) {
    return (0, _atUtils.escapeHtmlSymbols)(text);
};

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _User2 = __webpack_require__(119);

var _User3 = _interopRequireDefault(_User2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UserWithAccessRights = function (_User) {
    _inherits(UserWithAccessRights, _User);

    function UserWithAccessRights(id, firstName, lastName, middleName, username, active, emailExists, userGroupId, timeZoneGroupId, isPTO, isSick, isOvertimeTracking, overtimeTrackingLevel, accessRights) {
        _classCallCheck(this, UserWithAccessRights);

        var _this = _possibleConstructorReturn(this, (UserWithAccessRights.__proto__ || Object.getPrototypeOf(UserWithAccessRights)).call(this, id, firstName, lastName, middleName, username, active, emailExists, userGroupId, timeZoneGroupId, isPTO, isSick, isOvertimeTracking, overtimeTrackingLevel));

        _this.accessRight = accessRights;
        // TODO: replace all usages of "accessRight" with "accessRights"
        _this.accessRights = accessRights;
        return _this;
    }

    _createClass(UserWithAccessRights, [{
        key: "setOvertimeEnabled",
        value: function setOvertimeEnabled(overtimeEnabled) {
            this.overtimeEnabled = overtimeEnabled;
        }
    }, {
        key: "isOvertimeEnabled",
        value: function isOvertimeEnabled() {
            return this.overtimeEnabled;
        }
    }, {
        key: "clone",
        value: function clone() {
            return new UserWithAccessRights(this.id, this.firstName, this.lastName, this.middleName, this.username, this.active, this.emailExists, this.userGroupId, this.timeZoneGroupId, this.isPTO, this.isSick, this.isOvertimeTracking, this.overtimeTrackingLevel, this.accessRight);
        }
    }], [{
        key: "fromRPC",
        value: function fromRPC(data) {
            return new UserWithAccessRights(data["id"], data["firstName"], data["lastName"], data["middleName"], data["username"], data["active"], data["emailExists"], data["userGroupId"], data["timeZoneGroupId"], data["isPTO"], data["isSick"], data["isOvertimeTracking"], data["overtimeTrackingLevel"], data["accessRights"]);
        }
    }]);

    return UserWithAccessRights;
}(_User3.default);

exports.default = UserWithAccessRights;

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.RelativePositioning = RelativePositioning;
exports.ElementRelativePositioning = ElementRelativePositioning;
exports.ElementRelativeOnTheRightEdgePositioning = ElementRelativeOnTheRightEdgePositioning;
exports.ElementRelativeInTheContainerPositioning = ElementRelativeInTheContainerPositioning;
exports.ShowHideByDisplayPropertyStrategy = ShowHideByDisplayPropertyStrategy;
exports.ShowHideByVisibilityPropertyStrategy = ShowHideByVisibilityPropertyStrategy;
exports.default = DhtmlPopup;

var _atBrowserUtils = __webpack_require__(8);

// Popup positioning strategies

// Base class for all positioning strategies
function PositioningStrategy() {}

/**
 * Calculates and returns cooridnates
 */
PositioningStrategy.prototype.calculateCoordinates = null;

/*
 With this strategy popup window is displayed relative to position of page element, click on which
 causes popup to be shown. Reference to the element is obtained from "event" object.
 */
RelativePositioning.prototype = new PositioningStrategy();

function RelativePositioning() {}

/**
 * Calculates and returns cooridnates
 *
 * @return coordinates {x, y}
 */
RelativePositioning.prototype.calculateCoordinates = function () {

    var event = window.event;
    return (0, _atBrowserUtils.calculateCoords)(event);
};

/**
 * Specific element relative positoning
 */
ElementRelativePositioning.prototype = new PositioningStrategy();

/**
 * @param elementId is the id of an element relative to which positioning should be performed
 */
function ElementRelativePositioning(elementId) {

    this.elementId = elementId;
}

/**
 * Returns reference to object relative to which coordinates should be calculated
 *
 * @return reference to object relative to which coordinates should be calculated
 */
ElementRelativePositioning.prototype.getReferenceElement = function () {

    return document.getElementById(this.elementId);
};

/**
 * Calculates and returns coordinates
 *
 * @return coordinates {x, y}
 */
ElementRelativePositioning.prototype.calculateCoordinates = function () {

    return (0, _atBrowserUtils.calculateObjectCoords)(this.getReferenceElement());
};

/**
 * Specific element relative positoning
 */
ElementRelativeOnTheRightEdgePositioning.prototype = new PositioningStrategy();

/**
 * @param elementId is the id of an element relative to which positioning should be performed
 * @param elementToPosId is the id of an element should be performed
 */
function ElementRelativeOnTheRightEdgePositioning(elementId, elementToPosId) {

    this.elementId = elementId;
    this.elementToPosId = elementToPosId;
}

/**
 * Returns reference to object relative to which coordinates should be calculated
 *
 * @return reference to object relative to which coordinates should be calculated
 */
ElementRelativeOnTheRightEdgePositioning.prototype.getReferenceElement = function () {

    return document.getElementById(this.elementId);
};

/**
 * Returns reference to object to be positioned
 *
 * @return reference to object to be positioned
 */
ElementRelativeOnTheRightEdgePositioning.prototype.getElementToPosition = function () {

    return document.getElementById(this.elementToPosId);
};

/**
 * Calculates and returns coordinates
 *
 * @return coordinates {x, y}
 */
ElementRelativeOnTheRightEdgePositioning.prototype.calculateCoordinates = function () {

    var refEl = this.getReferenceElement();
    var posEl = this.getElementToPosition();
    var coords = (0, _atBrowserUtils.calculateObjectCoords)(refEl);

    coords.x += refEl.offsetWidth - posEl.offsetWidth;

    return coords;
};

/**
 * Specify element relative positioning in container
 */
ElementRelativeInTheContainerPositioning.prototype = new PositioningStrategy();

/**
 *
 * @param relativeElementId id of an element relative to which positioning should be performed
 * @param containerElementId id of container where relative and positioned element placed
 */
function ElementRelativeInTheContainerPositioning(relativeElementId, containerElementId) {

    this.relativeElementId = relativeElementId;
    this.containerElementId = containerElementId;
}

/**
 * Returns element relative to which positioning should be performed
 */
ElementRelativeInTheContainerPositioning.prototype.getReferenceElement = function () {

    return document.getElementById(this.relativeElementId);
};

/**
 * Returns container where relative and positioned element placed
 */
ElementRelativeInTheContainerPositioning.prototype.getContainerElement = function () {

    return document.getElementById(this.containerElementId);
};

/**
 * Calculates and returns coordinates
 *
 * @return coordinates {x, y}
 */
ElementRelativeInTheContainerPositioning.prototype.calculateCoordinates = function () {

    var refEl = this.getReferenceElement();
    var containerEl = this.getContainerElement();
    var refCoords = (0, _atBrowserUtils.calculateObjectCoords)(refEl);
    var containerCoords = (0, _atBrowserUtils.calculateObjectCoords)(containerEl);

    return {
        x: Math.abs(refCoords.x - containerCoords.x),
        y: Math.abs(refCoords.y - containerCoords.y)
    };
};

/**
 * Base class for all showing strategies.
 * Showing strategies is strategies for showing/hiding popups.
 *
 * @param element is element to use.
 */
function ShowHideStrategy(elementId) {
    this.elementId = elementId;
}
/**
 * Shows element with this strategy.
 */
ShowHideStrategy.prototype.show = null;

/**
 * Hides element with this strategy.
 */
ShowHideStrategy.prototype.hide = null;

/**
 * Determinates if element is visible
 */
ShowHideStrategy.prototype.isVisible = null;

ShowHideStrategy.prototype.getElement = function () {
    return document.getElementById(this.elementId);
};

// --------showHideByDisplayPropertyStrategy
ShowHideByDisplayPropertyStrategy.prototype = new ShowHideStrategy();
ShowHideByDisplayPropertyStrategy.prototype.parentClass = ShowHideStrategy;

/**
 * Initializes strategy. This strategy shows/hides element using 'display' style element property.
 *
 * @param elementId is the id of an element to work with.
 */
function ShowHideByDisplayPropertyStrategy(elementId) {
    this.parentClass(elementId);
}

/**
 * Shows element using 'display' property.
 */
ShowHideByDisplayPropertyStrategy.prototype.show = function () {
    this.getElement().style.display = "block";
};

/**
 * Hides element using 'display' property.
 */
ShowHideByDisplayPropertyStrategy.prototype.hide = function () {

    this.getElement().style.display = "none";
};

/**
 * Determinates if element is visible
 */
ShowHideByDisplayPropertyStrategy.prototype.isVisible = function () {

    return this.getElement().style.display != "none";
};

// --------showHideByDisplayPropertyStrategy
ShowHideByVisibilityPropertyStrategy.prototype = new ShowHideStrategy();
ShowHideByVisibilityPropertyStrategy.prototype.parentClass = ShowHideStrategy;

/**
 * Initializes strategy. This strategy shows/hides element using 'display' style element property.
 *
 * @param elementId is the id of an element to work with.
 */
function ShowHideByVisibilityPropertyStrategy(elementId) {
    this.parentClass(elementId);
}

/**
 * Shows element using 'display' property.
 */
ShowHideByVisibilityPropertyStrategy.prototype.show = function () {
    this.getElement().style.visibility = "visible";
};

/**
 * Hides element using 'display' property.
 *
 * @param element is element to hide.
 */
ShowHideByVisibilityPropertyStrategy.prototype.hide = function () {

    this.getElement().style.visibility = "hidden";
};

/**
 * Determinates if element is visible
 */
ShowHideByVisibilityPropertyStrategy.prototype.isVisible = function () {

    return this.getElement().style.visibility != "hidden";
};

/**
 * DHTML popup base class
 */
function DhtmlPopup(divId) {

    this.divId = divId;

    this.afterHideHandler = null; // Handler that is executed after popup is hidden
    this.beforeHideHandler = null; // Handler that is executed before popup is hidden
    this.afterShowHandler = null; // Handler that is executed after popup is shown
    this.popupPositionNeededHandler = null; //Handler that executed when popup needs repositioning.

    this.owner = null;

    this.showHideStrategy = new ShowHideByDisplayPropertyStrategy(divId);

    // Specify events to be dereferenced
    this.addEventDereferencer("click");
    this.addEventDereferencer("keydown");

    this.applyBeyondScreenDisplayFix = false;
}

DhtmlPopup.prototype.setShowHideStrategyClass = function (Strategy) {
    this.showHideStrategy = new Strategy(this.divId);
};

/**
 * @return popup DIV element id
 */
DhtmlPopup.prototype.getDivId = function () {
    return this.divId;
};

DhtmlPopup.prototype.setOwner = function (owner) {
    this.owner = owner;
};

DhtmlPopup.prototype.getOwner = function () {
    return this.owner;
};

/**
 * Dereferences "Event" object (browsers other then IE) so it can be referred as "window.event"
 * for event specified by event name parameter
 * @param eventName name of an event
 */
DhtmlPopup.prototype.addEventDereferencer = function (eventName) {

    if (document.addEventListener) {
        document.addEventListener(eventName, function (e) {
            var n = "event";window[n] = e;
        }, true);
    }
};

DhtmlPopup.prototype.setAfterShowHandler = function (afterShowHandler) {
    this.afterShowHandler = afterShowHandler;
};

DhtmlPopup.prototype.setBeforeShowHandler = function (beforeShowHandler) {
    this.beforeShowHandler = beforeShowHandler;
};

DhtmlPopup.prototype.setAfterHideHandler = function (afterHideHandler) {
    this.afterHideHandler = afterHideHandler;
};

DhtmlPopup.prototype.setPopupPositionNeededHandler = function (popupPositionNeededHandler) {
    this.popupPositionNeededHandler = popupPositionNeededHandler;
};

/* beforeHideHandler must return true or false. if true is returned, then popup will be hided, if false - it will not */
DhtmlPopup.prototype.setBeforeHideHandler = function (beforeHideHandler) {
    this.beforeHideHandler = beforeHideHandler;
};

/**
 * Sets the postioning strategy for popup
 * @param posStrategy strategy to set
 */
DhtmlPopup.prototype.setPositioningStrategy = function (posStrategy) {

    this.posStrategy = posStrategy;
};

DhtmlPopup.prototype.getPopupDiv = function () {
    return document.getElementById(this.divId);
};

/**
 * Calculates and returns coordinates of this popup
 * @return coordinates of this popup
 */
DhtmlPopup.prototype.getPopupCoordinates = function () {

    return this.posStrategy.calculateCoordinates();
};

/**
 * Shows popup at specified offsets from coordinates defined by popup position calculation strategy
 *
 * @param offsetX x coordinate offset
 * @param offsetY y coordinate offset
 * @param width width of the popup in pixels (if null then width won't be set)
 * @param height height of the popup in pixels (if null then height won't be set)
 * @param isOriginAtBottom - if true then popup's origin is considered to be at the bottom side instead of top
 *
 * NOTE: the popup will be shown twice while positioning himself. First time to calculate coordinates,
 *       second time to avoid browser related display issues like Bug 40520.
 *       So if there is some action to be performed after the popup is shown, it should be done using the window.setTimeout.
 */
DhtmlPopup.prototype.show = function (offsetX, offsetY, width, height, isOriginAtBottom) {
    // Register new event handlers for document elements
    this.registerEventHandlers();

    if (this.beforeShowHandler) this.beforeShowHandler();

    this.positionPopup(offsetX, offsetY, width, height, isOriginAtBottom);

    // check is needed because if popup is hidden then scrolling will be incorrect
    // see DhtmlPopup.prototype.applyBeyondScreenDisplayFixIfNeeded
    if (!this.applyBeyondScreenDisplayFix) {
        this.scrollWindowIfNeeded();
    }

    // Execute "After show" handler if there is one
    if (this.afterShowHandler) this.afterShowHandler();
};

/**
 * Positions and shows popup if it is hidden.
 * @param offsetX - x offset relative to reference element.
 * @param offsetY - y offset relative to reference element.
 * @param width - popup width, can be null
 * @param height - popup height, can be null
 * @param isOriginAtBottom - orientation
 */
DhtmlPopup.prototype.positionPopup = function (offsetX, offsetY, width, height, isOriginAtBottom) {
    // Get popup coordinates and apply offsets to them
    var coords = this.getPopupCoordinates();
    if (offsetX != undefined) coords.x += offsetX;
    if (offsetY != undefined) coords.y += offsetY;

    var popupDiv = this.getPopupDiv();

    var showHideStrategy = this.showHideStrategy;

    // Show popup to calculate its width
    showHideStrategy.show();

    if (width) popupDiv.style.width = width + "px";
    if (height) popupDiv.style.height = height + "px";

    // Position popup to calculated coordinates
    (0, _atBrowserUtils.shiftTo)(popupDiv, coords.x, coords.y, isOriginAtBottom);

    // if popup's right edge is beyond the window edge, move it to the left
    // TODO: similar functionality is in dhtml_title.js, make it reusable (kostenko)
    var curWidth = (0, _atBrowserUtils.getObjectWidth)(popupDiv.id);
    var reserveForScroller = 20;
    var oversize = coords.x + curWidth - (0, _atBrowserUtils.getBodyScrollLeft)() - (0, _atBrowserUtils.getInsideWindowWidth)() + reserveForScroller;
    if (oversize > 0) {
        (0, _atBrowserUtils.shiftTo)(popupDiv, coords.x - oversize, coords.y, isOriginAtBottom);
    }

    // Fix for a Bug 39607
    this.applyBeyondScreenDisplayFixIfNeeded();
};

// Following code is a workaround for Bug 40520 'Chrome: Enter TT/ Edit timesheet template: Comments pannel is broken some times'
// The issue reason is that when popup is show in the position where window oversize occurs and it been moved back to avoid
// scrollbar, Сhrome does not draw the popup properly. So we need to re-draw it when popup has been properly located.
DhtmlPopup.prototype.applyBeyondScreenDisplayFixIfNeeded = function () {
    if (this.applyBeyondScreenDisplayFix) {
        var that = this;
        var showHideStrategy = this.showHideStrategy;
        showHideStrategy.hide();
        window.setTimeout(function () {
            showHideStrategy.show();
            that.scrollWindowIfNeeded();
        }, 0);
    }
};

DhtmlPopup.prototype.setApplyBeyondScreenDisplayFix = function (needToApply) {
    this.applyBeyondScreenDisplayFix = needToApply;
};

DhtmlPopup.prototype.scrollWindowIfNeeded = function () {

    (0, _atBrowserUtils.scrollWindowIfNeeded)(this.getContentElement());
};

DhtmlPopup.prototype.updatePopupPosition = function () {
    if (!this.isVisible()) return;

    if (this.popupPositionNeededHandler) this.popupPositionNeededHandler(this);
};

DhtmlPopup.prototype.getContentElement = function () {
    return this.getPopupDiv();
};

/**
 * Used for get popup visibility.
 *
 * @return true if popup is visible, else false.
 */
DhtmlPopup.prototype.isVisible = function () {

    return this.showHideStrategy.isVisible();
};

/**
 * Hides popup
 *
 * @return true if popup is successfully hidden, false otherwise
 */
DhtmlPopup.prototype.hide = function () {

    // Simply return if popup is not visible
    if (!this.isVisible()) {
        return true;
    }

    // Execute "Before hide" handler if there is one
    if (this.beforeHideHandler && !this.beforeHideHandler()) return false; // Do not hide if error returned

    // Restore previous event handlers for document elements
    this.restoreEventHandlers();

    // Make popup non-visible
    this.showHideStrategy.hide();

    // Execute "After hide" handler
    if (this.afterHideHandler) this.afterHideHandler();

    // Return "true" to indicate success
    return true;
};

/**
 * Registers event handlers
 */
DhtmlPopup.prototype.registerEventHandlers = function () {}

// Do nothing


/**
 * Restores event handlers
 */
;DhtmlPopup.prototype.restoreEventHandlers = function () {}

// Do nothing


/**
 * Returns handler to function that closes this popup
 */
;DhtmlPopup.prototype.getClosePopupHandler = function () {

    var popupObj = this; // Dereference this popup

    // Create and return handler
    var closePopupHandler = function closePopupHandler() {
        window.event.returnValue = false;
        return popupObj.hide();
    };

    return closePopupHandler;
};

/**
 * Sets the caller element - for example, the button that causes the popup to be shown.
 * The value set can be then used in event handlers (e.g. afterHideHandler).
 */
DhtmlPopup.prototype.setCallerElement = function (callerElement) {

    this.callerElement = callerElement;
};

/**
 * Returns the caller element set by setCallerElement().
 * This can be then used in event handlers (e.g. afterHideHandler).
 */
DhtmlPopup.prototype.getCallerElement = function () {

    return this.callerElement;
};

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _EntityStore = __webpack_require__(450);

var _EntityStore2 = _interopRequireDefault(_EntityStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @Deprecated it is obsolete store use instead `taskManagement/common` state of redux
 */
var TaskManagementStore = function () {
    function TaskManagementStore() {
        _classCallCheck(this, TaskManagementStore);

        this.visibleCustomers = [];
        this.visibleCustomersFiltered = null;
        this.customerProjectNameFilter = null;
        this.filterCustomerProjectSelection = null;
        this.singleCustomerProjectSelection = null;
        this.intersectedCustomerProjectSelection = null;
        this.taskStatusFilter = {
            allSelected: true,
            statusIds: [],
            groupTypes: []
        };
        this.taskNameFilter = null;
        this.taskIds = new _EntityStore2.default();
        this.createdTaskIds = [];
        this.allTasksLoaded = false;
        this.taskSelection = {
            isAllSelected: false,
            selectedTasks: {},
            count: 0,
            countLoading: false
        };
        this.isNeedApproval = false;
        this.taskIdInEdit = null;
        this.projectIdInEdit = null;
        this.customerIdInEdit = null;

        this.editableProjectIds = {};
        this.editableCustomerIds = {};
    }

    _createClass(TaskManagementStore, [{
        key: "getTaskStatusFilter",
        value: function getTaskStatusFilter() {
            return this.taskStatusFilter;
        }
    }, {
        key: "setTaskStatusFilter",
        value: function setTaskStatusFilter(taskStatusFilter) {
            this.taskStatusFilter = taskStatusFilter;
            (0, _jquery2.default)(this).trigger("taskStatusFilterChange");
        }
    }, {
        key: "setTaskNameFilter",
        value: function setTaskNameFilter(taskNameFilter) {
            this.taskNameFilter = taskNameFilter;
        }
    }, {
        key: "getTaskNameFilter",
        value: function getTaskNameFilter() {
            return this.taskNameFilter;
        }
    }, {
        key: "getTaskIds",
        value: function getTaskIds() {
            return this.taskIds.getAll();
        }
    }, {
        key: "isAllTasksLoaded",
        value: function isAllTasksLoaded() {
            return this.allTasksLoaded;
        }
    }, {
        key: "setAllTasksLoaded",
        value: function setAllTasksLoaded(allTasksLoaded) {
            this.allTasksLoaded = allTasksLoaded;
        }
    }, {
        key: "getTaskSelection",
        value: function getTaskSelection() {
            return this.taskSelection;
        }
    }, {
        key: "resetTaskSelection",
        value: function resetTaskSelection() {
            this.setTaskSelection({
                isAllSelected: false,
                selectedTasks: {},
                countLoading: false,
                count: 0
            });
        }
    }, {
        key: "setTaskSelection",
        value: function setTaskSelection() {
            var taskSelectionChange = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            this.taskSelection = _extends({}, this.taskSelection, taskSelectionChange);
        }
    }, {
        key: "isTaskSelectionEmpty",
        value: function isTaskSelectionEmpty() {
            return !this.taskSelection.isAllSelected && _underscore2.default.size(this.taskSelection.selectedTasks) === 0;
        }
    }, {
        key: "getSelectedTasks",
        value: function getSelectedTasks() {
            return this.taskSelection.selectedTasks;
        }
    }, {
        key: "isAllTasksSelected",
        value: function isAllTasksSelected() {
            return this.taskSelection.isAllSelected;
        }
    }, {
        key: "setPopupInfo",
        value: function setPopupInfo(popupInfo) {
            this.popupInfo = popupInfo;
            (0, _jquery2.default)(this).trigger("popupInfoReceived");
        }
    }, {
        key: "appendTaskIds",
        value: function appendTaskIds(taskIds) {
            this.taskIds.mergeAll(taskIds);
            (0, _jquery2.default)(this).trigger("taskIdsAppend");
        }
    }, {
        key: "appendCreatedTaskIds",
        value: function appendCreatedTaskIds(taskIds) {
            this.createdTaskIds.concat(taskIds);
            this.taskIds.mergeAll(taskIds);
            (0, _jquery2.default)(this).trigger("createdTaskIdsAppend", [taskIds]);
        }
    }, {
        key: "replaceCreatedTaskIds",
        value: function replaceCreatedTaskIds(taskIds) {
            this.createdTaskIds = taskIds;
            this.taskIds.mergeAll(taskIds);
        }
    }, {
        key: "getCreatedTaskIds",
        value: function getCreatedTaskIds() {
            return this.createdTaskIds;
        }
    }, {
        key: "resetCreatedTaskIds",
        value: function resetCreatedTaskIds() {
            this.createdTaskIds = [];
            (0, _jquery2.default)(this).trigger("createdTaskIdsReset");
        }
    }, {
        key: "replaceTaskIds",
        value: function replaceTaskIds(taskIds) {
            this.taskIds.replaceAll(taskIds);
            this.resetCreatedTaskIds();
            (0, _jquery2.default)(this).trigger("taskIdsReplace");
        }
    }, {
        key: "removeTasks",
        value: function removeTasks(taskIds) {
            this.taskIds.removeMany(taskIds);
            this.taskSelection.selectedTasks = _underscore2.default.omit(this.taskSelection.selectedTasks, taskIds);
        }
    }, {
        key: "setManagerNeedApproval",
        value: function setManagerNeedApproval(isNeedApproval) {
            this.isNeedApproval = isNeedApproval;
        }
    }, {
        key: "getManagerNeedApproval",
        value: function getManagerNeedApproval() {
            return this.isNeedApproval;
        }
    }, {
        key: "setTaskIdInEdit",
        value: function setTaskIdInEdit(taskId) {
            this.taskIdInEdit = taskId;
        }
    }, {
        key: "getTaskIdInEdit",
        value: function getTaskIdInEdit() {
            return this.taskIdInEdit;
        }
    }, {
        key: "getEditableProjectIds",
        value: function getEditableProjectIds() {
            return this.editableProjectIds;
        }
    }, {
        key: "setEditableProjectIds",
        value: function setEditableProjectIds(editableProjectIds) {
            this.editableProjectIds = editableProjectIds;
        }
    }, {
        key: "getEditableCustomerIds",
        value: function getEditableCustomerIds() {
            return this.editableCustomerIds;
        }
    }, {
        key: "setEditableCustomerIds",
        value: function setEditableCustomerIds(editableCustomerIds) {
            this.editableCustomerIds = editableCustomerIds;
        }
    }]);

    return TaskManagementStore;
}();

exports.default = new TaskManagementStore();

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.copyLinkTo = exports.separateTaskCopySettings = exports.separateProjectCopySettings = exports.copyProjectAction = exports.updateNewCommentText = exports.reloadComments = exports.closeProjectPanel = exports.openProjectPanel = exports.commentsServiceActions = exports.commentsActions = exports.setCanManageProject = exports.setAllTasksAssigned = exports.setPanelOpenedFromUrl = exports.setOpenProject = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _actionTypes = __webpack_require__(674);

var ActionTypes = _interopRequireWildcard(_actionTypes);

var _selectors = __webpack_require__(244);

var selectors = _interopRequireWildcard(_selectors);

var _constants = __webpack_require__(4);

var _actionsGenerator = __webpack_require__(490);

var _actionsGenerator2 = _interopRequireDefault(_actionsGenerator);

var _reduxActions = __webpack_require__(9);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _commentsActionsGenerator = __webpack_require__(489);

var _commentsActionsGenerator2 = _interopRequireDefault(_commentsActionsGenerator);

var _rpcCalls = __webpack_require__(24);

var _rpcCalls2 = _interopRequireDefault(_rpcCalls);

var _CustomerStore = __webpack_require__(65);

var _CustomerStore2 = _interopRequireDefault(_CustomerStore);

var _actions = __webpack_require__(366);

var _constants2 = __webpack_require__(492);

var _ProjectStore = __webpack_require__(59);

var _ProjectStore2 = _interopRequireDefault(_ProjectStore);

var _actions2 = __webpack_require__(29);

var _actions3 = __webpack_require__(56);

var _actions4 = __webpack_require__(55);

var _selectors2 = __webpack_require__(14);

var _atBrowserUtils = __webpack_require__(8);

var _utils = __webpack_require__(369);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var setOpenProject = exports.setOpenProject = (0, _reduxActions.createAction)(ActionTypes.OPEN_PROJECT_SET);
var setPanelOpenedFromUrl = exports.setPanelOpenedFromUrl = (0, _reduxActions.createAction)(ActionTypes.PROJECT_PANEL_OPENED_FROM_URL_SET);
var setAllTasksAssigned = exports.setAllTasksAssigned = (0, _reduxActions.createAction)(ActionTypes.ALL_TASKS_ASSIGNED_SET);
var setCanManageProject = exports.setCanManageProject = (0, _reduxActions.createAction)(ActionTypes.CAN_MANAGE_SET);

var commentsActions = exports.commentsActions = (0, _actionsGenerator2.default)({
    actionTypes: ActionTypes
});

var commentsServiceActions = exports.commentsServiceActions = (0, _commentsActionsGenerator2.default)({
    actions: commentsActions,
    selectors: _extends({}, selectors, {
        getOpenEntityId: selectors.getOpenProjectId
    }),
    handleServiceError: function handleServiceError(projectId, error) {
        return _handleServiceError(projectId, error);
    },
    entityType: _constants.EntityType.PROJECT
});

var openProjectPanel = exports.openProjectPanel = function openProjectPanel(projectId) {
    var fromUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return function (dispatch, getState) {
        var state = getState();

        var openProjectId = (0, _selectors.getOpenProjectId)(state);

        if (openProjectId !== projectId) {
            dispatch(setPanelOpenedFromUrl(fromUrl));
            dispatch(setOpenProject(projectId));
        } else {
            dispatch(closeProjectPanel());
        }
    };
};

var closeProjectPanel = exports.closeProjectPanel = function closeProjectPanel() {
    return function (dispatch) {
        dispatch(setOpenProject(null));
        dispatch(setPanelOpenedFromUrl(false));
    };
};

var reloadComments = exports.reloadComments = commentsServiceActions.reloadComments;

var updateNewCommentText = exports.updateNewCommentText = function updateNewCommentText(text) {
    return function (dispatch, getState) {
        var state = getState();
        var projectId = (0, _selectors.getOpenProjectId)(state);
        if (text !== '') {
            dispatch(commentsActions.setNewComment({ entityId: projectId, text: text }));
        } else {
            dispatch(commentsActions.removeNewComment(projectId));
        }
        dispatch(commentsServiceActions.saveEntityNewCommentsTextsInLocalStorage());
    };
};

var _handleServiceError = function _handleServiceError(projectId, error) {
    if (error.getTextStatus() === 'rpc_customException') {
        switch (error.getErrorThrown().exception) {
            case 'com.actimind.actitime.services.impl.comments.NoSuchEntityException':
                alert(_messageResource2.default.getMessage('project.edit.deleted_concurrently'));
                window.location.reload();
                return true;
            case 'com.actimind.actitime.services.impl.comments.EntityNotAssignedException':
                alert(_messageResource2.default.getMessage('common.no_rights_for_operation_anymore'));
                window.location.reload();
                return true;
            case 'com.actimind.actitime.services.NoRightToEditHierarchyException':
                alert(_messageResource2.default.getMessage('common.no_rights_for_operation_anymore'));
                window.location.reload();
                return true;
            case 'com.actimind.actitime.services.impl.comments.NoSuchCommentException':
                alert(_messageResource2.default.getMessage('panel.common.comments.comment_concurrently_deleted'));
                return true;
        }
    }
    return false;
};

var copyProjectAction = exports.copyProjectAction = function copyProjectAction(customerId, settings) {
    var onProjectCopiedCb = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};
    return function (dispatch, getState) {
        var state = getState();
        var projectId = (0, _selectors.getOpenProjectId)(state);
        var oldProject = (0, _selectors2.getProject)(state, projectId);
        dispatch((0, _actions4.toggleLoadingMoire)(true));
        dispatch((0, _actions.setBulkOperationProgress)(null));
        (0, _rpcCalls.longRpcCall)('ProjectInfoService.copyProject', [projectId, customerId, separateProjectCopySettings(settings)], function (error) {
            if (error.getTextStatus() === 'rpc_customException') {
                switch (error.getErrorThrown().exception) {
                    case 'com.actimind.actitime.services.NoRightToEditHierarchyException':
                        alert(_messageResource2.default.getMessage("project.error.copy.no_manage_scope_right"));
                        window.location.reload();
                        error.handle();
                        return true;
                    case 'com.actimind.actitime.project.NoSuchProjectException':
                        alert(_messageResource2.default.getMessage("project.error.copy.project_deleted_concurrently"));
                        window.location.reload();
                        error.handle();
                        return true;
                    case 'com.actimind.actitime.customer.NoSuchCustomerException':
                        alert(_messageResource2.default.getMessage("project.error.copy.customer_deleted_concurrently"));
                        window.location.reload();
                        error.handle();
                        return true;
                    case 'com.actimind.actitime.customer.CustomerArchivedException':
                        alert(_messageResource2.default.getMessage("project.error.copy.customer_archived_concurrently"));
                        window.location.reload();
                        error.handle();
                        return true;
                    case 'com.actimind.actitime.project.ProjectIsNotAssignedException':
                        alert(_messageResource2.default.getMessage("project.error.copy.project_not_assigned"));
                        window.location.reload();
                        error.handle();
                        return true;
                    case 'com.actimind.actitime.customer.CustomerUnavailableException':
                        alert(_messageResource2.default.getMessage("project.error.copy.customer_not_assigned"));
                        window.location.reload();
                        error.handle();
                        return true;
                    case 'com.actimind.actitime.project.ProjectExistsException':
                        alert(_messageResource2.default.getMessage("project.error.project_with_same_name_exists"));
                        dispatch((0, _actions4.toggleLoadingMoire)(false));
                        error.handle();
                        return true;
                }
            }
            return false;
        }).then(function (data) {
            var project = data.project;
            _ProjectStore2.default.addFirst(project);
            dispatch((0, _actions2.addProjects)([project]));
            if (data.taskIds.length > 0) {
                dispatch((0, _actions.copyTasksAction)(data.taskIds, project.id, settings, data.operationId));
            }
            dispatch((0, _actions4.toggleLoadingMoire)(false));

            var customerName = _CustomerStore2.default.get(project.customerId).name;
            dispatch((0, _actions3.toast)(_messageResource2.default.getMessage("copy.project.toast", [project.name, customerName])));

            if (oldProject.name !== project.name) dispatch((0, _actions3.toast)(_messageResource2.default.getMessage('copy.project.duplicate_name.toast')));

            onProjectCopiedCb();
        }).catch(function (error) {
            if (!error.isHandled()) console.error(error);
        });
    };
};

var separateProjectCopySettings = exports.separateProjectCopySettings = function separateProjectCopySettings(settings) {
    return {
        copyDescription: !!settings[_constants2.CopySettingsTypes.COPY_PROJECT_DESCRIPTION],
        copyAssignedUsers: !!settings[_constants2.CopySettingsTypes.COPY_ASSIGNED_USERS],
        copyManagers: !!settings[_constants2.CopySettingsTypes.COPY_MANAGERS]
    };
};

var separateTaskCopySettings = exports.separateTaskCopySettings = function separateTaskCopySettings(settings) {
    return {
        copyWorkflowStatus: !!settings[_constants2.CopySettingsTypes.COPY_TASK_STATUS],
        copyTypeOfWork: !!settings[_constants2.CopySettingsTypes.COPY_TASK_TYPE_OF_WORK],
        copyEstimate: !!settings[_constants2.CopySettingsTypes.COPY_TASK_ESTIMATE],
        copyDescription: settings[_constants2.CopySettingsTypes.COPY_TASK_DESCRIPTION],
        copyAssignedUsers: !!settings[_constants2.CopySettingsTypes.COPY_ASSIGNED_USERS],
        copyManagers: !!settings[_constants2.CopySettingsTypes.COPY_MANAGERS]
    };
};

var copyLinkTo = exports.copyLinkTo = function copyLinkTo() {
    return function (dispatch, getState) {
        var projectId = (0, _selectors.getOpenProjectId)(getState());
        (0, _atBrowserUtils.copyToClipboard)((0, _utils.createLinkToProject)(projectId), function () {
            dispatch((0, _actions3.toast)(_messageResource2.default.getMessage('panel.common.link_copied')));
        });
    };
};

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _date_format = __webpack_require__(16);

var _number_formatter = __webpack_require__(61);

var _number_formatter2 = _interopRequireDefault(_number_formatter);

var _user_time = __webpack_require__(30);

var _user_time2 = _interopRequireDefault(_user_time);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _constants = __webpack_require__(11);

var _StringUtils = __webpack_require__(121);

var StringUtils = _interopRequireWildcard(_StringUtils);

var _UserNameFormat = __webpack_require__(17);

var _UserNameFormat2 = _interopRequireDefault(_UserNameFormat);

var _utils = __webpack_require__(6);

var _selectors = __webpack_require__(515);

var _constants2 = __webpack_require__(4);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var BaseReportFormatUtils = function () {
    function BaseReportFormatUtils() {
        _classCallCheck(this, BaseReportFormatUtils);
    }

    _createClass(BaseReportFormatUtils, null, [{
        key: "formatTime",
        value: function formatTime(time, timeFormat) {
            return time ? timeFormat == TimeFormat.TIME ? _user_time2.default.formatTimeWithDigitSeparator(time) : this._timeNumberFormatter.format(time / 60) : "-";
        }
    }, {
        key: "formatPureTime",
        value: function formatPureTime(time, timeFormat) {
            if (time == null) return "-";
            return timeFormat == TimeFormat.TIME ? _user_time2.default.formatTimeWithDigitSeparator(time) : this._timeNumberFormatter.format(time / 60);
        }
    }, {
        key: "formatDifferenceTime",
        value: function formatDifferenceTime(time, timeFormat) {
            var sign = time > 0 ? "+" : "";
            return sign + this.formatPureTime(time, timeFormat);
        }
    }, {
        key: "formatTimeFormat",
        value: function formatTimeFormat(timeFormat) {
            return timeFormat === TimeFormat.DECIMAL ? _messageResource2.default.getEscapedMessage("time_format_selector.time_format_decimal", window.SystemSettings.decimalSeparator) : _messageResource2.default.getMessage("common.hh_mm");
        }
    }, {
        key: "formatPercent",
        value: function formatPercent(value) {
            if (value == null) return "-";
            return parseFloat(Math.round(value * 10) / 10).toFixed(1).toString() + "%";
        }
    }, {
        key: "formatGroupingLevel",
        value: function formatGroupingLevel(groupingLevel) {
            switch (groupingLevel) {
                case _constants.ReportGroupingLevel.USER:
                    return _messageResource2.default.getMessage("common.Users");
                case _constants.ReportGroupingLevel.USER_GROUP:
                    return _messageResource2.default.getMessage("common.User_Groups");
                case _constants.ReportGroupingLevel.TIME_ZONE_GROUP:
                    return _messageResource2.default.getMessage("common.Time_Zone_Groups");

                case _constants.ReportGroupingLevel.DATE:
                    return _messageResource2.default.getMessage("common.Days");
                case _constants.ReportGroupingLevel.WEEK:
                    return _messageResource2.default.getMessage("common.Weeks");
                case _constants.ReportGroupingLevel.MONTH:
                    return _messageResource2.default.getMessage("common.Months");

                case _constants.ReportGroupingLevel.CUSTOMER:
                    return _messageResource2.default.getMessage("common.Customers");
                case _constants.ReportGroupingLevel.PROJECT:
                    return _messageResource2.default.getMessage("common.Projects");
                case _constants.ReportGroupingLevel.TASK:
                    return _messageResource2.default.getMessage("common.Tasks");

                case _constants.ReportGroupingLevel.PROJECT_NAME:
                    return _messageResource2.default.getMessage("report.common.projects_by_name");
                case _constants.ReportGroupingLevel.TASK_NAME:
                    return _messageResource2.default.getMessage("report.common.tasks_by_name");
                case _constants.ReportGroupingLevel.BILLING_TYPE:
                    return _messageResource2.default.getMessage("report.common.billing_types");

                case _constants.ReportGroupingLevel.NONE:
                    return "";
            }
        }
    }, {
        key: "formatByName",
        value: function formatByName(namedBean) {
            return namedBean.name;
        }
    }, {
        key: "makeGroupingPresentationFlags",
        value: function makeGroupingPresentationFlags(groupingLevels) {
            var groupingPresentationFlags = {};

            if (_.contains(groupingLevels, _constants.ReportGroupingLevel.CUSTOMER)) {
                groupingPresentationFlags.customerIsShown = true;
            }

            if (_.contains(groupingLevels, _constants.ReportGroupingLevel.PROJECT)) {
                groupingPresentationFlags.projectIsShown = true;
            }

            return groupingPresentationFlags;
        }
    }, {
        key: "formatTask",
        value: function formatTask(task, groupingPresentationFlags, isCSV) {
            var taskName = task.name;

            if (!groupingPresentationFlags.projectIsShown) {
                var project = task.project;
                var customer = project.customer;

                if (groupingPresentationFlags.customerIsShown) taskName += " (" + project.name + ")";else taskName += " (" + customer.name + ", " + project.name + ")";
            }

            if (!task.estimated && isCSV) {
                taskName += ' (' + _messageResource2.default.getMessage("report.budgeted_vs_actual.not_estimated_note") + ")";
            }

            return taskName;
        }
    }, {
        key: "formatProject",
        value: function formatProject(project, groupingPresentationFlags) {
            if (groupingPresentationFlags.customerIsShown) return project.name;

            return project.name + " (" + project.customer.name + ")";
        }
    }, {
        key: "formatUser",
        value: function formatUser(user) {
            if (user["id"] == OTHER_USERS_ENTITY_ID) return _messageResource2.default.getMessage("report.other_users");
            return this.getFormattedUser(user["firstName"], user["lastName"], user["middleInitial"], user["username"]);
        }
    }, {
        key: "formatUserAndTrim",
        value: function formatUserAndTrim(user, maxLen) {
            if (user["id"] == OTHER_USERS_ENTITY_ID) return _messageResource2.default.getMessage("report.other_users");

            var fn = StringUtils.cutLongText(user["firstName"], maxLen);
            var ln = StringUtils.cutLongText(user["lastName"], maxLen);
            var mn = StringUtils.cutLongText(user["middleInitial"], maxLen);
            var un = StringUtils.cutLongText(user["username"], maxLen);
            return this.getFormattedUser(fn, ln, mn, un);
        }
    }, {
        key: "formatUserGroup",
        value: function formatUserGroup(group) {
            return group.id !== USERS_WITHOUT_GROUP_ID ? group.name : _messageResource2.default.getMessage("report.user_groups.default_group_name");
        }
    }, {
        key: "formatTimeZoneGroup",
        value: function formatTimeZoneGroup(group) {
            return group.id !== DEFAULT_TIME_ZONE_GROUP_ID ? group.name : group.name + " " + _messageResource2.default.getMessage("common.default_group");
        }
    }, {
        key: "formatDateForHeader",
        value: function formatDateForHeader(date) {
            return this._dateForHeaderFormat.formatDate(date);
        }
    }, {
        key: "formatDateForDataRow",
        value: function formatDateForDataRow(date) {
            return this._dateForDataRowFormat.formatDate(date);
        }
    }, {
        key: "formatWeekForDataRow",
        value: function formatWeekForDataRow(week) {
            var dateRange = {
                from: Date.parseJSONDate(week.from),
                to: Date.parseJSONDate(week.to)
            };
            // look at TimeUtils.java#formatDateRange
            if (dateRange.from.getFullYear() == dateRange.to.getFullYear()) {
                // check if interval contains only one day
                if (dateRange.from.getMonth() == dateRange.to.getMonth() && dateRange.from.getDate() == dateRange.to.getDate()) return this._dateWithYearFormat.formatDate(dateRange.from);
                return this._weekForDataRowFormat.formatDate(dateRange.from) + " - " + this._dateWithYearFormat.formatDate(dateRange.to);
            }

            return this._dateWithYearFormat.formatDate(dateRange.from) + " - " + this._dateWithYearFormat.formatDate(dateRange.to);
        }
    }, {
        key: "formatMonthForDataRow",
        value: function formatMonthForDataRow(date) {
            return this._monthForDataRowFormat.formatDate(date);
        }
    }, {
        key: "getGroupingLevelTitle",
        value: function getGroupingLevelTitle(groupingLevel, identity, store, maxLen) {
            switch (groupingLevel) {
                case _constants.ReportGroupingLevel.DATE:
                    return this.formatDateForDataRow(Date.parseJSONDate(store.getDateInfo(identity).date));
                case _constants.ReportGroupingLevel.WEEK:
                    return this.formatWeekForDataRow(store.getWeek(identity));
                case _constants.ReportGroupingLevel.MONTH:
                    return this.formatMonthForDataRow(Date.parseJSONDate(store.getMonth(identity).date));
                case _constants.ReportGroupingLevel.USER:
                    if (maxLen === undefined) return this.formatUser(store.getUser(identity));
                    return this.formatUserAndTrim(store.getUser(identity), maxLen);
                case _constants.ReportGroupingLevel.USER_GROUP:
                    return this.formatUserGroup(store.getUserGroup(identity));
                case _constants.ReportGroupingLevel.TIME_ZONE_GROUP:
                    return this.formatTimeZoneGroup(store.getTimeZoneGroup(identity));
                case _constants.ReportGroupingLevel.PROJECT_NAME:
                    return BaseReportFormatUtils.formatByName(store.getProjectName(identity));
                case _constants.ReportGroupingLevel.TASK_NAME:
                    return BaseReportFormatUtils.formatByName(store.getTaskName(identity));
                case _constants.ReportGroupingLevel.BILLING_TYPE:
                    return BaseReportFormatUtils.formatByName(store.getTypeOfWork(identity));
                case _constants.ReportGroupingLevel.PROJECT:
                    return this.formatProject(store.getProject(identity), store.getGroupingPresentationFlags());
                case _constants.ReportGroupingLevel.CUSTOMER:
                    return BaseReportFormatUtils.formatByName(store.getCustomer(identity));
                case _constants.ReportGroupingLevel.TASK:
                    return this.formatTask(store.getTask(identity), store.getGroupingPresentationFlags());
            }
        }
    }, {
        key: "getFormattedUser",
        value: function getFormattedUser(firstName, lastName, middleInitial, username) {
            var showUsername = _constants2.CURRENT_PRODUCT === _constants2.Product.actiTIME ? (0, _utils.unsafe_selectWithState)(function (state) {
                return (0, _selectors.doesShowUsernameInReports)(state);
            }) : false;
            return showUsername ? _UserNameFormat2.default.formatLFMU(firstName, lastName, middleInitial, username) : _UserNameFormat2.default.formatLFM(firstName, lastName, middleInitial);
        }
    }]);

    return BaseReportFormatUtils;
}();

BaseReportFormatUtils._dateForHeaderFormat = new _date_format.DateFormat(window.SystemSettings.dateFormat);
BaseReportFormatUtils._dateForDataRowFormat = new _date_format.DateFormat(window.SystemSettings.dateFormat + ", EEEE");
BaseReportFormatUtils._dateWithYearFormat = new _date_format.DateFormat("MMM dd, yyyy");
BaseReportFormatUtils._weekForDataRowFormat = new _date_format.DateFormat("MMM dd");
BaseReportFormatUtils._monthForDataRowFormat = new _date_format.DateFormat("MMMM yyyy");
BaseReportFormatUtils._balanceNumberFormatter = new _number_formatter2.default(window.SystemSettings.decimalSeparator, window.SystemSettings.digitGroupingSymbol, 2, true);
BaseReportFormatUtils._timeNumberFormatter = new _number_formatter2.default(window.SystemSettings.decimalSeparator, window.SystemSettings.digitGroupingSymbol, 2, false);
BaseReportFormatUtils.reportUserFormatterWithUsernameIfNeeded = {
    format: function format(user) {
        return BaseReportFormatUtils.getFormattedUser(user.firstName, user.lastName, user.middleInitial, user.username);
    }
};
BaseReportFormatUtils.reportUserFormatterWithoutUsername = {
    format: function format(user) {
        return (0, _UserNameFormat.formatFmlWithCheck)(user);
    }
};
exports.default = BaseReportFormatUtils;

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.currentUsedUserCount = exports.wasOtherProductEverIntegrated = exports.isOtherProductLicenseViolated = exports.isLicenseViolated = exports.isLicenseTrialWithoutRenewal = exports.getLicenseType = exports.isLicenseTrial = exports.isLicenseFree = exports.isOtherProductLicenseExpired = exports.isLicenseExpired = exports.isShowLicenseCountDownTip = exports.loggedInUserCanManageLicenses = exports.getLicenseCountDaysToExpiration = undefined;

var _reselect = __webpack_require__(13);

var _constants = __webpack_require__(4);

var _constants2 = __webpack_require__(1486);

var getActiveLicenseInfoState = function getActiveLicenseInfoState(state) {
    return state.activeLicenseInfo;
};

var getLicenseCountDaysToExpiration = exports.getLicenseCountDaysToExpiration = (0, _reselect.createSelector)(getActiveLicenseInfoState, function (activeLicenseInfo) {
    return activeLicenseInfo.daysToExpiration;
});

var loggedInUserCanManageLicenses = exports.loggedInUserCanManageLicenses = (0, _reselect.createSelector)(getActiveLicenseInfoState, function (activeLicenseInfo) {
    return activeLicenseInfo.licenseManagerStatus === _constants2.LicenseManagerStatus.ACTIVE || activeLicenseInfo.licenseManagerStatus === _constants2.LicenseManagerStatus.PREDEFINED;
});

var isShowLicenseCountDownTip = exports.isShowLicenseCountDownTip = (0, _reselect.createSelector)(getActiveLicenseInfoState, loggedInUserCanManageLicenses, function (activeLicenseInfo, canManageLicense) {
    return !_constants.isDemoVersion && canManageLicense && activeLicenseInfo.daysToExpiration > 0 && activeLicenseInfo.daysToExpiration <= _constants2.SHOW_COUNTDOWN_TIP_LICENSE_DAYS_TO_EXPIRATION && !activeLicenseInfo.thereARenewal;
});

var isLicenseExpired = exports.isLicenseExpired = (0, _reselect.createSelector)(getActiveLicenseInfoState, function (state) {
    return state.daysToExpiration === 0;
});

var isOtherProductLicenseExpired = exports.isOtherProductLicenseExpired = (0, _reselect.createSelector)(getActiveLicenseInfoState, function (state) {
    return state.otherProductExpired;
});

var isLicenseFree = exports.isLicenseFree = (0, _reselect.createSelector)(getActiveLicenseInfoState, function (activeLicenseInfo) {
    return activeLicenseInfo.type === _constants2.licensesType.FREE;
});

var isLicenseTrial = exports.isLicenseTrial = (0, _reselect.createSelector)(getActiveLicenseInfoState, function (activeLicenseInfo) {
    return activeLicenseInfo.type === _constants2.licensesType.TRIAL;
});

var getLicenseType = exports.getLicenseType = (0, _reselect.createSelector)(getActiveLicenseInfoState, function (activeLicenseInfo) {
    return activeLicenseInfo.type;
});

var isLicenseTrialWithoutRenewal = exports.isLicenseTrialWithoutRenewal = (0, _reselect.createSelector)(getActiveLicenseInfoState, isLicenseTrial, function (activeLicenseInfo, isLicenseTrial) {
    return !activeLicenseInfo.thereARenewal && isLicenseTrial;
});

var isLicenseViolated = exports.isLicenseViolated = (0, _reselect.createSelector)(getActiveLicenseInfoState, function (activeLicenseInfo) {
    return activeLicenseInfo.violated;
});

var isOtherProductLicenseViolated = exports.isOtherProductLicenseViolated = (0, _reselect.createSelector)(getActiveLicenseInfoState, function (activeLicenseInfo) {
    return activeLicenseInfo.otherProductViolated;
});

var wasOtherProductEverIntegrated = exports.wasOtherProductEverIntegrated = (0, _reselect.createSelector)(getActiveLicenseInfoState, function (activeLicenseInfo) {
    return activeLicenseInfo.wasOtherProductEverIntegrated;
});

var currentUsedUserCount = exports.currentUsedUserCount = (0, _reselect.createSelector)(getActiveLicenseInfoState, function (activeLicenseInfo) {
    return activeLicenseInfo.userCounters.actualCount;
});

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TableRegion2 = __webpack_require__(145);

var _TableRegion3 = _interopRequireDefault(_TableRegion2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NullTableRegion = function (_TableRegion) {
    _inherits(NullTableRegion, _TableRegion);

    function NullTableRegion() {
        _classCallCheck(this, NullTableRegion);

        return _possibleConstructorReturn(this, (NullTableRegion.__proto__ || Object.getPrototypeOf(NullTableRegion)).call(this, 0, 0, 0, 0));
    }

    _createClass(NullTableRegion, [{
        key: "containsCell",
        value: function containsCell(cell) {
            return false;
        }
    }, {
        key: "containsCol",
        value: function containsCol(col) {
            return false;
        }
    }, {
        key: "containsRow",
        value: function containsRow(row) {
            return false;
        }
    }, {
        key: "contains",
        value: function contains(row, col) {
            return false;
        }
    }, {
        key: "union",
        value: function union(otherRegion) {
            return otherRegion;
        }
    }, {
        key: "toString",
        value: function toString() {
            return "[Null Region]";
        }
    }, {
        key: "isLeftmostCell",
        value: function isLeftmostCell(cell) {
            return false;
        }
    }, {
        key: "isUpwardmostCell",
        value: function isUpwardmostCell(cell) {
            return false;
        }
    }, {
        key: "isRightmostCell",
        value: function isRightmostCell(cell) {
            return false;
        }
    }, {
        key: "isDownwardmostCell",
        value: function isDownwardmostCell(cell) {
            return false;
        }
    }]);

    return NullTableRegion;
}(_TableRegion3.default);

exports.default = new NullTableRegion();

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TableRegion = function () {
    function TableRegion(startRow, startCol, endRow, endCol) {
        _classCallCheck(this, TableRegion);

        this.rowMin = Math.min(startRow, endRow);
        this.rowMax = Math.max(startRow, endRow);
        this.colMin = Math.min(startCol, endCol);
        this.colMax = Math.max(startCol, endCol);
    }

    _createClass(TableRegion, [{
        key: "createFromCells",
        value: function createFromCells(startCell, endCell) {
            return new TableRegion(startCell.getRow().getRowIdx(), startCell.getColIdx(), endCell.getRow().getRowIdx(), endCell.getColIdx());
        }
    }, {
        key: "containsCol",
        value: function containsCol(col) {
            return this.colMin <= col && this.colMax >= col;
        }
    }, {
        key: "containsRow",
        value: function containsRow(row) {
            return this.rowMin <= row && this.rowMax >= row;
        }
    }, {
        key: "contains",
        value: function contains(row, col) {
            return this.containsCol(col) && this.containsRow(row);
        }
    }, {
        key: "containsCell",
        value: function containsCell(cell) {
            return this.containsCol(cell.getColIdx()) && this.containsRow(cell.getRow().getRowIdx());
        }
    }, {
        key: "union",
        value: function union(otherRegion) {
            return otherRegion == this.NULL ? this : new TableRegion(Math.min(this.rowMin, otherRegion.rowMin), Math.min(this.colMin, otherRegion.colMin), Math.max(this.rowMax, otherRegion.rowMax), Math.max(this.colMax, otherRegion.colMax));
        }
    }, {
        key: "equals",
        value: function equals(region) {
            return region != this.NULL && this.rowMin == region.rowMin && this.colMin == region.colMin && this.rowMax == region.rowMax && this.colMax == region.colMax;
        }
    }, {
        key: "toString",
        value: function toString() {
            return this.rowMin + "," + this.colMin + "," + this.rowMax + "," + this.colMax;
        }
    }, {
        key: "isLeftmostCell",
        value: function isLeftmostCell(cell) {
            return this.colMin == cell.getColIdx();
        }
    }, {
        key: "isUpwardmostCell",
        value: function isUpwardmostCell(cell) {
            return this.rowMin == cell.getRow().getRowIdx();
        }
    }, {
        key: "isRightmostCell",
        value: function isRightmostCell(cell) {
            return this.colMax == cell.getColIdx();
        }
    }, {
        key: "isDownwardmostCell",
        value: function isDownwardmostCell(cell) {
            return this.rowMax == cell.getRow().getRowIdx();
        }
    }]);

    return TableRegion;
}();

exports.default = TableRegion;

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isNeedToLoadData = exports.isLastLicenseManagerOnDisableApAlertShown = exports.isLastLicenseManagerOnDisableAtAlertShown = exports.isLastLicenseManagerOnDeleteAlertShown = exports.getSelectedTab = exports.getErrorBackup = exports.isUpdatingWorkSchedule = exports.isPanelOpened = exports.isLoaded = exports.isUpdatingData = exports.isLoading = exports.getEditUserId = exports.selectEditUserPanel = undefined;

var _reselect = __webpack_require__(13);

var _selector = __webpack_require__(255);

var selectEditUserPanel = exports.selectEditUserPanel = (0, _reselect.createSelector)(_selector.selectUserPanel, function (userPanel) {
    return userPanel.editPanel;
});

var getEditUserId = exports.getEditUserId = function getEditUserId(state) {
    return selectEditUserPanel(state).userId;
};

var isLoading = exports.isLoading = function isLoading(state) {
    return selectEditUserPanel(state).loading;
};

var isUpdatingData = exports.isUpdatingData = function isUpdatingData(state) {
    return selectEditUserPanel(state).updatingData;
};

var isLoaded = exports.isLoaded = function isLoaded(state) {
    return selectEditUserPanel(state).loaded;
};

var isPanelOpened = exports.isPanelOpened = function isPanelOpened(state) {
    return selectEditUserPanel(state).userId !== null;
};

var isUpdatingWorkSchedule = exports.isUpdatingWorkSchedule = function isUpdatingWorkSchedule(state) {
    return selectEditUserPanel(state).updatingWorkSchedule;
};

var getErrorBackup = exports.getErrorBackup = function getErrorBackup(state) {
    return selectEditUserPanel(state).errorBackup;
};

var getSelectedTab = exports.getSelectedTab = function getSelectedTab(state) {
    return selectEditUserPanel(state).selectedTab;
};

var isLastLicenseManagerOnDeleteAlertShown = exports.isLastLicenseManagerOnDeleteAlertShown = (0, _reselect.createSelector)(selectEditUserPanel, function (editPanel) {
    return editPanel.isLastLicenseManagerOnDeleteAlertShown;
});

var isLastLicenseManagerOnDisableAtAlertShown = exports.isLastLicenseManagerOnDisableAtAlertShown = (0, _reselect.createSelector)(selectEditUserPanel, function (editPanel) {
    return editPanel.isLastLicenseManagerOnDisableAtAlertShown;
});

var isLastLicenseManagerOnDisableApAlertShown = exports.isLastLicenseManagerOnDisableApAlertShown = (0, _reselect.createSelector)(selectEditUserPanel, function (editPanel) {
    return editPanel.isLastLicenseManagerOnDisableApAlertShown;
});

var isNeedToLoadData = exports.isNeedToLoadData = (0, _reselect.createSelector)(isLoaded, isPanelOpened, function (loaded, opened) {
    return opened === true && loaded === false;
});

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.resetTimeZoneGroupRow = exports.resetUserGroupRow = exports.updateStateFromViewerSettings = exports.validateTimeZoneGroup = exports.setFullUserInfo = exports.setAllApprovers = exports.setTimeZoneGroupData = exports.setUserGroupData = exports.managementAssignmentsCountsLoadFailure = exports.managementAssignmentsCountsLoadSuccess = exports.managementAssignmentsCountsLoad = exports.setManagementAssignmentsCountsLoaded = exports.setUserPanelHasLeavesOrTTBeforeNewHireDateError = exports.clearUserPanelErrors = exports.removeUserPanelErrors = exports.setUserPanelErrors = exports.setPasswordValidationResult = exports.addUserPanelErrors = exports.setUserData = exports.setUserTeamAssignmentsData = exports.setUserManagementAssignmentsSelection = exports.setUserManageAssignmentsData = exports.updateExtendedData = exports.setSimpleFullUserInfo = undefined;

var _reduxActions = __webpack_require__(9);

var _actionTypes = __webpack_require__(676);

var ActionTypes = _interopRequireWildcard(_actionTypes);

var _actions = __webpack_require__(68);

var _actions2 = __webpack_require__(50);

var _selectors = __webpack_require__(64);

var _constants = __webpack_require__(21);

var _validation = __webpack_require__(550);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var setSimpleFullUserInfo = exports.setSimpleFullUserInfo = (0, _reduxActions.createAction)(ActionTypes.FULL_USER_INFO_SET);

var updateExtendedData = exports.updateExtendedData = (0, _reduxActions.createAction)(ActionTypes.EXTENDED_DATA_UPDATE);

var setUserManageAssignmentsData = exports.setUserManageAssignmentsData = (0, _reduxActions.createAction)(ActionTypes.USER_MANAGE_ASSIGNMENTS_DATA_SET);

var setUserManagementAssignmentsSelection = exports.setUserManagementAssignmentsSelection = (0, _reduxActions.createAction)(ActionTypes.USER_MANAGEMENT_ASSIGNMENTS_SELECTION_SET);

var setUserTeamAssignmentsData = exports.setUserTeamAssignmentsData = (0, _reduxActions.createAction)(ActionTypes.USER_TEAM_ASSIGNMENTS_DATA_SET);

var setUserData = exports.setUserData = (0, _reduxActions.createAction)(ActionTypes.USER_DATA_SET);

var addUserPanelErrors = exports.addUserPanelErrors = (0, _reduxActions.createAction)(ActionTypes.USER_PANEL_ERROR_ADD);

var setPasswordValidationResult = exports.setPasswordValidationResult = (0, _reduxActions.createAction)(ActionTypes.USER_PANEL_PASSWORD_VALIDATION_RESULT_SET);

var setUserPanelErrors = exports.setUserPanelErrors = (0, _reduxActions.createAction)(ActionTypes.USER_PANEL_ERRORS_SET);

var removeUserPanelErrors = exports.removeUserPanelErrors = (0, _reduxActions.createAction)(ActionTypes.USER_PANEL_ERRORS_REMOVE);

var clearUserPanelErrors = exports.clearUserPanelErrors = (0, _reduxActions.createAction)(ActionTypes.USER_PANEL_ERRORS_CLEAR);

var setUserPanelHasLeavesOrTTBeforeNewHireDateError = exports.setUserPanelHasLeavesOrTTBeforeNewHireDateError = (0, _reduxActions.createAction)(ActionTypes.USER_PANEL_HAS_LEAVES_OR_TT_BEFORE_NEW_HIRE_DATE_ERROR);

var setManagementAssignmentsCountsLoaded = exports.setManagementAssignmentsCountsLoaded = (0, _reduxActions.createAction)(ActionTypes.MANAGEMENT_ASSIGNMENTS_COUNTS_LOADED_SET);

var managementAssignmentsCountsLoad = exports.managementAssignmentsCountsLoad = (0, _reduxActions.createAction)(ActionTypes.MANAGEMENT_ASSIGNMENTS_COUNTS_LOAD);

var managementAssignmentsCountsLoadSuccess = exports.managementAssignmentsCountsLoadSuccess = (0, _reduxActions.createAction)(ActionTypes.MANAGEMENT_ASSIGNMENTS_COUNTS_LOAD_SUCCESS);

var managementAssignmentsCountsLoadFailure = exports.managementAssignmentsCountsLoadFailure = (0, _reduxActions.createAction)(ActionTypes.MANAGEMENT_ASSIGNMENTS_COUNTS_LOAD_FAILURE);

var setUserGroupData = exports.setUserGroupData = (0, _reduxActions.createAction)(ActionTypes.USER_GROUP_DATA_SET);

var setTimeZoneGroupData = exports.setTimeZoneGroupData = (0, _reduxActions.createAction)(ActionTypes.TIME_ZONE_GROUP_DATA_SET);

var setAllApprovers = exports.setAllApprovers = (0, _reduxActions.createAction)(ActionTypes.ALL_APPROVERS_SET);

var setFullUserInfo = exports.setFullUserInfo = function setFullUserInfo(info) {
    return function (dispatch) {
        dispatch(setSimpleFullUserInfo(info));

        if (info.userGroupId) dispatch(setUserGroupData({ groupId: info.userGroupId }));

        if (info.timeZoneGroupId) dispatch(setTimeZoneGroupData({ groupId: info.timeZoneGroupId }));
    };
};

var validateTimeZoneGroup = exports.validateTimeZoneGroup = function validateTimeZoneGroup(tzgId, newTzg) {
    return function (dispatch, getState) {
        dispatch(removeUserPanelErrors([_constants.ValidationErrors.DUPLICATE_TIME_ZONE_GROUP, _constants.ValidationErrors.CITY_DATA_EMPTY, _constants.ValidationErrors.NEW_TIME_ZONE_GROUP_EMPTY]));

        var state = getState();
        var providerErrors = (0, _selectors.getUserPanelErrors)(state);

        var validationResult = (0, _validation.validateTimezoneGroup)(providerErrors, tzgId, newTzg);

        dispatch(setUserPanelErrors(validationResult.errors));
    };
};

var updateStateFromViewerSettings = exports.updateStateFromViewerSettings = function updateStateFromViewerSettings(viewerSettings) {
    return function (dispatch) {
        dispatch((0, _actions2.setViewerSettings)(viewerSettings));
        dispatch((0, _actions.setEnabledFeatures)(viewerSettings.enabledFeatures));
    };
};

var resetUserGroupRow = exports.resetUserGroupRow = function resetUserGroupRow() {
    return function (dispatch, getState) {
        var groupId = (0, _selectors.getFullUserInfo)(getState()).userGroupId;
        dispatch(setUserGroupData({
            groupId: groupId
        }));
    };
};

var resetTimeZoneGroupRow = exports.resetTimeZoneGroupRow = function resetTimeZoneGroupRow() {
    return function (dispatch, getState) {
        var groupId = (0, _selectors.getFullUserInfo)(getState()).timeZoneGroupId;
        dispatch(setTimeZoneGroupData({
            groupId: groupId
        }));
    };
};

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.updateStateFromCreateResult = exports.loadManagementAssignmentsCounts = exports.changeManagementAssignmentsSelection = exports.changeCustomerAssignments = exports.changeProjectAssignments = exports.changeTasksAssignments = exports.changeTeamAssignments = exports.updateInitialUserSchedule = exports.updateUserSchedules = exports.deleteUserRate = exports.addNewUserRate = exports.updateUserRates = exports.updateOvertime = exports.updateRequireApproval = exports.updateAccessAP = exports.updateAccess = exports.updateUserRights = exports.updateReleaseDate = exports.updateHireDate = exports.updateTimeZoneGroup = exports.updateUserGroup = exports.onPasswordValidationEnd = exports.onPasswordValidationStart = exports.updatePassword = exports.updateEmail = exports.updateUserName = exports.updateMiddleName = exports.updateLastName = exports.updateFirstName = exports.copyUserSettings = exports.updateValidateWorkScheduleResult = exports.updateValidateUserRatesResult = exports.saveUser = exports.validateAndSaveUser = exports.cancelUserCreation = exports.closeCreateUserPanel = exports.loadCreateUserPanelData = exports.inviteOneMoreUser = exports.openCreateUserPanel = exports.setCopyUserId = exports.setPasswordValidationDone = exports.setPasswordValidationRequested = exports.setLoaded = exports.setShowFutureInvitation = exports.addTasksManageAssignments = exports.setTasksOfProjectCount = exports.setProjectsOfCustomerCount = exports.setCustomersCount = exports.setManageAssignments = exports.setUserPanelTab = exports.resetPanelState = exports.setLoading = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _rpcCalls = __webpack_require__(24);

var _rpcCalls2 = _interopRequireDefault(_rpcCalls);

var _constants = __webpack_require__(4);

var _actions = __webpack_require__(147);

var UserDataActions = _interopRequireWildcard(_actions);

var _reduxActions = __webpack_require__(9);

var _utils = __webpack_require__(866);

var _validation = __webpack_require__(550);

var _selectors = __webpack_require__(64);

var _selectors2 = __webpack_require__(208);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _utils2 = __webpack_require__(6);

var _actionTypes = __webpack_require__(454);

var ActionTypes = _interopRequireWildcard(_actionTypes);

var _selectors3 = __webpack_require__(14);

var _syncCallbacks = __webpack_require__(1637);

var SyncCallbacks = _interopRequireWildcard(_syncCallbacks);

var _util = __webpack_require__(254);

var _utils3 = __webpack_require__(311);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _actions2 = __webpack_require__(29);

var _actions3 = __webpack_require__(50);

var _actions4 = __webpack_require__(68);

var _actions5 = __webpack_require__(167);

var _constants2 = __webpack_require__(21);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _ExitConfirmationHandlersManager = __webpack_require__(298);

var _ExitConfirmationHandlersManager2 = _interopRequireDefault(_ExitConfirmationHandlersManager);

var _constants3 = __webpack_require__(4);

var _selectors4 = __webpack_require__(257);

var _validationUtils = __webpack_require__(205);

var _actions6 = __webpack_require__(864);

var AuthorizationInfoActions = _interopRequireWildcard(_actions6);

var _actions7 = __webpack_require__(551);

var UserRatesActions = _interopRequireWildcard(_actions7);

var _selectors5 = __webpack_require__(15);

var _constants4 = __webpack_require__(201);

var _selectors6 = __webpack_require__(53);

var _atUtils = __webpack_require__(5);

var _constants5 = __webpack_require__(1638);

var _accessRightsUtils = __webpack_require__(188);

var _ClassicBridge = __webpack_require__(18);

var _ClassicBridge2 = _interopRequireDefault(_ClassicBridge);

var _actions8 = __webpack_require__(554);

var _selectors7 = __webpack_require__(867);

var _selectors8 = __webpack_require__(146);

var _constants6 = __webpack_require__(77);

var _actions9 = __webpack_require__(126);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var setLoading = exports.setLoading = (0, _reduxActions.createAction)(ActionTypes.LOADING_SET);

var resetPanelState = exports.resetPanelState = (0, _reduxActions.createAction)(ActionTypes.RESET_CREATE_USER_PANEL_STATE);

var setUserPanelTab = exports.setUserPanelTab = (0, _reduxActions.createAction)(ActionTypes.CREATE_USER_PANEL_TAB_SET);

var setManageAssignments = exports.setManageAssignments = (0, _reduxActions.createAction)(ActionTypes.MANAGE_ASSIGNMENTS_SET);
var setCustomersCount = exports.setCustomersCount = (0, _reduxActions.createAction)(ActionTypes.CUSTOMERS_COUNT_SET);
var setProjectsOfCustomerCount = exports.setProjectsOfCustomerCount = (0, _reduxActions.createAction)(ActionTypes.PROJECTS_COUNT_SET);
var setTasksOfProjectCount = exports.setTasksOfProjectCount = (0, _reduxActions.createAction)(ActionTypes.TASKS_COUNT_SET);

var addTasksManageAssignments = exports.addTasksManageAssignments = (0, _reduxActions.createAction)(ActionTypes.MANAGE_ASSIGNMENTS_TASKS_ADD);

var setShowFutureInvitation = exports.setShowFutureInvitation = (0, _reduxActions.createAction)(ActionTypes.SHOW_FUTURE_INVITATION_SET);

var setLoaded = exports.setLoaded = (0, _reduxActions.createAction)(ActionTypes.LOADED_SET);

var setDefaultUserInfo = (0, _reduxActions.createAction)(ActionTypes.DEFAULT_USER_INFO_SET);
var setDefaultTeamAssignments = (0, _reduxActions.createAction)(ActionTypes.DEFAULT_TEAM_ASSIGNMENTS_SET);
var setDefaultManageAssignments = (0, _reduxActions.createAction)(ActionTypes.DEFAULT_MANAGE_ASSIGNMENTS_SET);
var setPasswordValidationRequested = exports.setPasswordValidationRequested = (0, _reduxActions.createAction)(ActionTypes.PASSWORD_VALIDATION_REQUESTED);
var setPasswordValidationDone = exports.setPasswordValidationDone = (0, _reduxActions.createAction)(ActionTypes.PASSWORD_VALIDATION_DONE);

var setCopyUserId = exports.setCopyUserId = (0, _reduxActions.createAction)(ActionTypes.COPY_USER_CHANGED);

var setUpExitConfirmation = function setUpExitConfirmation(getState) {
    _ExitConfirmationHandlersManager2.default.setUpExitConfirmation(_messageResource2.default.getMessage('user.add.js.cancel_confirmation'), function () {
        return (0, _selectors2.isUserDataChanged)(getState());
    }, false);
};

var openCreateUserPanel = exports.openCreateUserPanel = function openCreateUserPanel() {
    return function (dispatch, getState) {
        setUpExitConfirmation(getState);
        dispatch(setLoaded(false));
        dispatch((0, _utils2.createActionObject)(ActionTypes.TOGGLE_CREATE_USER_PANEL, true));
    };
};

var inviteOneMoreUser = exports.inviteOneMoreUser = function inviteOneMoreUser() {
    return function (dispatch) {
        dispatch(setLoaded(false));
        dispatch(resetPanelState());
    };
};

var loadCreateUserPanelData = exports.loadCreateUserPanelData = function loadCreateUserPanelData() {
    return function (dispatch, getState) {
        dispatch(setLoading(true));

        var errorHandler = function errorHandler(error) {
            var msg = error.errorThrown.msg;
            if (!!msg && msg.indexOf('com.actimind.common.licensing.LicenseViolatedException') !== -1) {
                alert(_messageResource2.default.getMessage('common.license_violated_exception.action_is_not_available'));
                return true;
            }
            if (!!msg && msg.indexOf('com.actimind.common.licensing.NoActiveLicensesException') !== -1) {
                alert(_messageResource2.default.getMessage('common.license_expired_exception.reload_page'));
                document.location.reload();
                return true;
            }
        };

        var WSDEnabled = (0, _selectors5.isWSDEnabled)(getState());

        var loads = [(0, _rpcCalls2.default)("UserManagementService.getCreateUserData", [], errorHandler), WSDEnabled && _ClassicBridge2.default.getWorkStatusesForUserProfile()];

        Promise.all(loads).then(function (_ref) {
            var _ref2 = _slicedToArray(_ref, 2),
                createData = _ref2[0],
                workStatuses = _ref2[1];

            var state = getState();
            dispatch(setLoaded(true));

            var defaultAccountSetting = _extends({}, (0, _utils.makeDefaultUserAccountSettings)(createData.userManagementData, createData.showAPStatusControl), {
                password: null,
                retypedPassword: null
            });

            var allTimeZoneGroupOffsets = (0, _utils3.getTimeZoneOffsets)(createData.userManagementData.allTimeZoneGroups);
            var userGroupRowData = {
                groupId: _constants.UserManagementConstants.USER_GROUP_NOT_ASSIGNED_ID,
                newGroupCreating: false
            };
            var timeZoneGroupRowData = {
                groupId: _constants.UserManagementConstants.DEFAULT_TIME_ZONE_GROUP_ID,
                newGroupCreating: false,
                timeZoneGroupsOffset: allTimeZoneGroupOffsets,
                newTimeZoneGroup: null
            };
            var userData = _extends({}, defaultAccountSetting, {
                manageAssignments: {
                    managementAssignmentsSelection: _constants3.ManagementAssignmentsSelection.SELECTED,
                    addedTaskIds: [],
                    addedProjectIds: [],
                    addedProjectIdsExcludingSelf: [],
                    addedCustomerIds: [],
                    addedCustomerIdsExcludingSelf: [],
                    taskCountsByProjects: {},
                    projectCountsByCustomers: {}
                },
                teamAssignments: {
                    teamAssignmentType: _constants2.UserTeamAssignmentType.SELECTED,
                    assignedGroups: [],
                    assignedUsers: []
                },
                approversByGroups: createData.approversByGroups.map,
                userManagementData: {
                    userGroups: createData.userManagementData.allUserGroups,
                    timeZoneGroups: createData.userManagementData.allTimeZoneGroups
                }
            });

            var extendedData = {
                currentTime: createData.currentTimeInDefaultTimeZone
            };
            var userManageAssignmentsData = (0, _utils.createManagementAssignmentsData)(userData.manageAssignments, (0, _selectors3.getCustomers)(state), (0, _selectors3.getProjects)(state), {});

            var userTeamAssignmentsData = {
                teamAssignmentType: _constants2.UserTeamAssignmentType.SELECTED,
                assignedGroups: [],
                assignedUsers: [],
                assignedUsersCount: 0
            };

            if (createData.userManagementData.allUserGroups) {
                dispatch((0, _actions2.addUserGroups)(createData.userManagementData.allUserGroups));
            }
            if (createData.userManagementData.allTimeZoneGroups) {
                dispatch((0, _actions2.addTimeZoneGroups)(createData.userManagementData.allTimeZoneGroups));
            }
            dispatch((0, _actions.updateStateFromViewerSettings)(createData.userManagementData.viewerSettings));

            dispatch(UserDataActions.setUserData(_extends({}, createData, {
                fullUserInfo: defaultAccountSetting,
                userGroupRowData: userGroupRowData,
                timeZoneGroupRowData: timeZoneGroupRowData,
                allApprovers: createData.approversByGroups.map[_constants.UserManagementConstants.USER_GROUP_NOT_ASSIGNED_ID],
                userManageAssignmentsData: userManageAssignmentsData,
                userTeamAssignmentsData: userTeamAssignmentsData,
                extendedData: extendedData,
                providerErrors: {}
            })));
            dispatch((0, _utils2.createActionObject)(ActionTypes.CREATE_USER_PANEL_TAB_SET, _constants2.TabKeys.ACCOUNT_SETTINGS));

            dispatch((0, _actions.managementAssignmentsCountsLoadSuccess)({
                customers: 0,
                projects: 0,
                tasks: 0
            }));

            dispatch(AuthorizationInfoActions.setAuthorizationInfo(createData.authorizationInfo));

            dispatch(setDefaultUserInfo(defaultAccountSetting));
            dispatch(setDefaultTeamAssignments(userTeamAssignmentsData));
            dispatch(setDefaultManageAssignments(userData.manageAssignments));
            dispatch((0, _utils2.createActionObject)(ActionTypes.APPROVERS_BY_GROUPS_SET, createData.approversByGroups.map));
            dispatch((0, _actions3.setUserManagementData)(createData.userManagementData));

            if (WSDEnabled) {
                dispatch((0, _actions8.setWorkStatuses)(workStatuses));

                var defaultWorkStatus = workStatuses.items.find(function (workStatus) {
                    return workStatus.default;
                });
                var initialDefaultWorkStatus = {
                    dateFrom: null,
                    dateTo: null,
                    workStatusId: defaultWorkStatus.id
                };

                dispatch((0, _actions8.setInitialDefaultWorkStatus)(initialDefaultWorkStatus));
            }

            dispatch(setLoading(false));
        }).catch(function (data) {
            dispatch(setLoading(false));
            console.error(data);
            dispatch((0, _utils2.createActionObject)(ActionTypes.TOGGLE_CREATE_USER_PANEL, false));
        });
    };
};

var closeCreateUserPanel = exports.closeCreateUserPanel = function closeCreateUserPanel() {
    return function (dispatch) {
        _ExitConfirmationHandlersManager2.default.restoreExitConfirmation();
        dispatch((0, _utils2.createActionObject)(ActionTypes.TOGGLE_CREATE_USER_PANEL, false));
        dispatch(setLoaded(false));
        dispatch(resetPanelState());
        dispatch(UserDataActions.clearUserPanelErrors());
        dispatch(UserDataActions.setPasswordValidationResult(null));
        SyncCallbacks.onCreateUserPanelClosed();
    };
};

var cancelUserCreation = exports.cancelUserCreation = function cancelUserCreation() {
    return function (dispatch, getState) {
        var state = getState();
        var dataChanged = (0, _selectors2.isUserDataChanged)(state);

        if ((0, _selectors2.isUserCreated)(getState()) || !dataChanged || confirmCancelUserCreation()) {
            dispatch(UserDataActions.clearUserPanelErrors());
            dispatch(UserRatesActions.clearErrors());
            dispatch((0, _actions3.closeAllPanels)());
        }
    };
};

var confirmCancelUserCreation = function confirmCancelUserCreation() {
    return confirm(_messageResource2.default.getMessage('user.add.js.cancel_confirmation'));
};

var validateAndSaveUser = exports.validateAndSaveUser = function validateAndSaveUser() {
    return function (dispatch, getState) {
        var state = getState();
        var uraEnabled = (0, _selectors5.isURAEnabled)(state);

        var isUserRatesValid = false;

        if (uraEnabled) {
            var rates = (0, _selectors4.getUserRates)(state);

            var _getUserRatesValidati = (0, _selectors.getUserRatesValidationData)(state),
                overtimeEnabled = _getUserRatesValidati.overtimeEnabled,
                leaveTypesEnabled = _getUserRatesValidati.leaveTypesEnabled;

            var _getUserRatesErrors = (0, _validationUtils.getUserRatesErrors)(rates, overtimeEnabled, leaveTypesEnabled, false),
                isValid = _getUserRatesErrors.isValid,
                errors = _getUserRatesErrors.errors;

            isUserRatesValid = isValid;
            dispatch(updateValidateUserRatesResult(isValid));
            dispatch(UserRatesActions.setErrors(errors));
        }

        var initialSchedule = (0, _selectors.getFullUserInfo)(state).initialSchedule;
        var isWorkScheduleValid = (0, _validationUtils.isInitialScheduleValid)(initialSchedule);

        dispatch(updateValidateWorkScheduleResult(isWorkScheduleValid));

        if ((!uraEnabled || isUserRatesValid) && isWorkScheduleValid) dispatch(saveUser());
    };
};

var saveUser = exports.saveUser = function saveUser() {
    var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return function (dispatch, getState) {
        var state = getState();
        var userInfo = (0, _selectors.getFullUserInfo)(state);
        var userGroupData = (0, _selectors.getUserGroupRowData)(state);
        var timeZoneGroupData = (0, _selectors.getTimeZoneGroupRowData)(state);
        var providerErrors = (0, _selectors.getUserPanelErrors)(state);

        var validationResult = validateUserForCreate(userInfo, userGroupData, timeZoneGroupData, providerErrors);

        if (validationResult.isValid) {
            if (_constants.isOlVersion) {
                getCurrentTimeInfo(userInfo.timeZoneGroupId).then(function (currentTimeInfo) {
                    //hire date isn't in future
                    if (force || userInfo.hireDate.parseJSONDate().getTime() <= currentTimeInfo.currentTime.parseJSONDate().getTime()) {
                        dispatch(saveUserWithoutHireDateCheck());
                    } else {
                        dispatch(setUserPanelTab(_constants2.TabKeys.ACCOUNT_SETTINGS));
                        dispatch(setShowFutureInvitation(true));
                    }
                });
            } else {
                // no need to check hire date in downloadable version
                dispatch(saveUserWithoutHireDateCheck());
            }
        } else {
            dispatch(UserDataActions.setUserPanelErrors(validationResult.providerErrors));
        }
    };
};

var updateValidateUserRatesResult = exports.updateValidateUserRatesResult = function updateValidateUserRatesResult(isValid) {
    return function (dispatch) {
        if (isValid) {
            dispatch(UserDataActions.removeUserPanelErrors([_constants2.ValidationErrors.USER_RATES_ERROR]));
        } else {
            dispatch(UserDataActions.addUserPanelErrors([_constants2.ValidationErrors.USER_RATES_ERROR]));
        }
    };
};

var updateValidateWorkScheduleResult = exports.updateValidateWorkScheduleResult = function updateValidateWorkScheduleResult(isValid) {
    return function (dispatch) {
        if (isValid) {
            dispatch(UserDataActions.removeUserPanelErrors([_constants2.ValidationErrors.WORK_SCHEDULE_ERROR]));
        } else {
            dispatch(UserDataActions.addUserPanelErrors([_constants2.ValidationErrors.WORK_SCHEDULE_ERROR]));
        }
    };
};

var saveUserWithoutHireDateCheck = function saveUserWithoutHireDateCheck() {
    return function (dispatch, getState) {
        var state = getState();

        var uraEnabled = (0, _selectors5.isURAEnabled)(state);
        var wsdEnabled = (0, _selectors5.isWSDEnabled)(state);
        var userData = (0, _selectors.getUserDataState)(state);
        var userInfo = userData.fullUserInfo;
        var userGroupData = (0, _selectors.getUserGroupRowData)(state);
        var timeZoneGroupData = (0, _selectors.getTimeZoneGroupRowData)(state);

        var manageAssignments = (0, _accessRightsUtils.canAccessManagersScope)(userInfo) ? (0, _selectors2.getManageAssignments)(state) : _constants5.DEFAULT_MANAGEMENT_ASSIGNMENTS;
        var teamAssignments = (0, _accessRightsUtils.canAccessManagersScope)(userInfo) ? userData.userTeamAssignmentsData : _constants5.DEFAULT_TEAM_ASSIGNMENTS;

        dispatch((0, _utils2.createActionObject)(ActionTypes.SAVE_USER));

        var accountSettings = pickAccountSettingsForCreateUser(state, userData.fullUserInfo);

        if (uraEnabled) {
            var _getUserRatesValidati2 = (0, _selectors.getUserRatesValidationData)(state),
                leaveTypesEnabled = _getUserRatesValidati2.leaveTypesEnabled;

            accountSettings = _extends({}, accountSettings, {
                rates: (0, _validationUtils.getValidRates)({ rates: accountSettings.rates, leaveTypesEnabled: leaveTypesEnabled, overtimeEnabled: false })
            });
        }

        (0, _rpcCalls2.default)("UserManagementService.createUser", [accountSettings, userGroupData.newUserGroupName, timeZoneGroupData.newTimeZoneGroup, userInfo.password ? userInfo.password : null, teamAssignments, manageAssignments], function (error) {
            var errorThrown = error.getErrorThrown();
            error.handleOnException(_util.EXCEPTIONS.DuplicateTimeZone, {
                _providerStatus: _constants2.ValidationErrors.DUPLICATE_TIME_ZONE_GROUP,
                timeZones: errorThrown.timeZones
            });
            error.handleOnException(_util.EXCEPTIONS.UserEmailInvalidException, { _providerStatus: _constants2.ValidationErrors.EMAIL_INVALID });
            error.handleOnException(_util.EXCEPTIONS.UserExistsException, { _providerStatus: _constants2.ValidationErrors.DUPLICATE_USERNAME });

            if (error.getException() === 'com.actimind.common.licensing.LicenseViolatedException') {
                alert(_messageResource2.default.getMessage('common.license_violated_exception.action_is_not_available'));
                return true;
            }
            if (error.getException() === 'com.actimind.common.licensing.NoActiveLicensesException') {
                alert(_messageResource2.default.getMessage('common.license_expired_exception.reload_page'));
                document.location.reload();
                return true;
            }
        }).then(function (createUserResult) {
            if ((_underscore2.default.isUndefined(createUserResult.resultCode) || createUserResult.resultCode === _constants.UserManagementConstants.RESULT_CODE_SUCCESS) && wsdEnabled) {
                var id = createUserResult.userInfo.id;
                _ClassicBridge2.default.syncChangesFromClassic().then(function () {
                    _ClassicBridge2.default.getUsersByClassicIds([id]).then(function (result) {
                        var userNextData = result.items[0];
                        var initial = (0, _selectors7.getInitialDefaultWorkStatus)(state);
                        initial.dateFrom = undefined;
                        initial.dateTo = undefined;
                        initial.id = undefined;

                        return Promise.all([new Promise(function (res) {
                            return res(createUserResult);
                        }), _ClassicBridge2.default.putUserDefaultWorkStatuses(userNextData.id, { items: [initial] })]).catch(function (e) {
                            if (e.body && e.body.errorKey === _constants6.ApiErrorKeys.NotFoundEntity && e.body.entityType === 'target') {
                                alert(_messageResource2.default.getMessage('userlist.js.error_no_such_work_status.edit_user'));
                                dispatch(closeCreateUserPanel());
                                return document.location.reload();
                            }
                            alert(_messageResource2.default.getMessage('error.js.lightbox_loader.unexpected_error', [PRODUCT_NAME]));
                        });
                    });
                });
            }

            return [createUserResult];
        }).then(function (_ref3) {
            var _ref4 = _slicedToArray(_ref3, 1),
                createUserResult = _ref4[0];

            if (_underscore2.default.isUndefined(createUserResult.resultCode) || createUserResult.resultCode === _constants.UserManagementConstants.RESULT_CODE_SUCCESS) {
                var additionalData = createUserResult.additionalResultData.map;
                if (_constants.isOlVersion) {
                    dispatch(UserDataActions.setFullUserInfo(createUserResult.userInfo));
                    dispatch((0, _utils2.createActionObject)(ActionTypes.SAVE_USER_SUCCESS, {
                        invitationSent: additionalData.invitationSent
                    }));
                } else {
                    dispatch(closeCreateUserPanel());
                }

                if (!!additionalData[_constants4.AdditionalDataConstants.USERS_WITHOUT_APPROVERS_DATA]) {
                    dispatch((0, _actions3.setUsersWithoutApprovers)(additionalData[_constants4.AdditionalDataConstants.USERS_WITHOUT_APPROVERS_DATA]));
                }

                if (!!additionalData[_constants4.AdditionalDataConstants.WORK_ASSIGNMENTS_COUNTERS]) {
                    dispatch((0, _actions5.setWorkAssignmentsCountersForUser)(createUserResult.userInfo.id, additionalData[_constants4.AdditionalDataConstants.WORK_ASSIGNMENTS_COUNTERS]));
                }

                dispatch(updateStateFromCreateResult(createUserResult));
                SyncCallbacks.onUserCreated(createUserResult);
            }

            if (createUserResult.resultCode === _constants.UserManagementConstants.ERROR_NO_RIGHTS_TO_MANAGE_ACCOUNT_SETTINGS) {
                alert(_messageResource2.default.getEscapedMessage("userlist.js.error_manage_account_settings_right_revoked"));
                window.location.reload();
            }
        }).catch(function (error) {
            dispatch((0, _utils2.createActionObject)(ActionTypes.SAVE_USER_FAILURE));
            if (error._providerStatus) {
                dispatch(UserDataActions.addUserPanelErrors([error._providerStatus]));
            }
            dispatch(UserDataActions.setFullUserInfo(userInfo));
        });
    };
};

var copyUserSettings = exports.copyUserSettings = function copyUserSettings(userId) {
    return function (dispatch, getState) {
        var wsdEnabled = (0, _selectors5.isWSDEnabled)(getState());
        (0, _rpcCalls2.default)("UserManagementService.getCopyUserSettingsData", [userId], function (error) {
            error.handleOnException(_util.EXCEPTIONS.NoRightsToManageAccountSettings, { _providerStatus: _constants2.ValidationErrors.NO_RIGHTS });
            error.handleOnException(_util.EXCEPTIONS.NoSuchUserException, { _providerStatus: _constants2.ValidationErrors.NO_SUCH_USER });
        }).then(function (copySettingsData) {
            if (wsdEnabled) {
                return Promise.all([copySettingsData, _ClassicBridge2.default.getUsersByClassicIds([copySettingsData.fullUserInfo.id]).then(function (nextUsers) {
                    var nextUser = nextUsers.items[0];
                    return _ClassicBridge2.default.getDefaultWorkStatusPlanningByUserId(nextUser.id);
                })]);
            } else {
                return Promise.all([copySettingsData]);
            }
        }).then(function (_ref5) {
            var _ref6 = _slicedToArray(_ref5, 2),
                copySettingsData = _ref6[0],
                copyDefaultWorkStatuses = _ref6[1];

            var userData = (0, _selectors.getUserDataState)(getState());
            copySettingsData['fullUserInfo'] = copySettingsData['fullUserInfo']['userAccountSettings'];

            dispatch(setManageAssignments((0, _utils.convertManageAssignmentsToArrays)(copySettingsData.userManageAssignmentsData)));

            var userGroupRowData = {
                groupId: copySettingsData.fullUserInfo.userGroupId,
                newGroupCreating: false
            };
            var timeZoneGroupRowData = {
                groupId: copySettingsData.fullUserInfo.timeZoneGroupId,
                newGroupCreating: false,
                newTimeZoneGroup: null
            };

            dispatch(UserDataActions.setUserData(_extends({}, copySettingsData, {
                fullUserInfo: _extends({}, pickAccountSettings(userData.fullUserInfo), pickAccountSettingFromCopyData(copySettingsData.fullUserInfo)),
                userGroupRowData: userGroupRowData,
                timeZoneGroupRowData: timeZoneGroupRowData,
                allApprovers: userData.approversByGroups.map[userData.fullUserInfo.userGroupId],
                userManageAssignmentsData: (0, _utils3.convertManagementAssignmentsDataFromRpc)(copySettingsData.userManageAssignmentsData),
                extendedData: {
                    currentTime: copySettingsData.currentTimeInUserTimeZone
                }
            })));

            dispatch(setCopyUserId(userId));

            if (wsdEnabled) {
                var currentInterval = _ClassicBridge2.default.findCurrentInterval(Date.now(), copyDefaultWorkStatuses.items);
                dispatch((0, _actions8.setInitialDefaultWorkStatus)(currentInterval));
            }
        }).catch(function (error) {
            if (error._providerStatus === _constants2.ValidationErrors.NO_RIGHTS) {
                alert(_messageResource2.default.getMessage('userlist.js.error_cant_create_user_account'));
                document.location.reload();
            }
            if (error._providerStatus === _constants2.ValidationErrors.NO_SUCH_USER) {
                alert(_messageResource2.default.getEscapedMessage("userlist.js.error_no_such_user.short"));
                dispatch(); //TODO delete user
            }
        });
    };
};

var getCurrentTimeInfo = function getCurrentTimeInfo(timeZoneGroupId) {
    return (0, _rpcCalls2.default)("CurrentTimeInfoService.getCurrentTimeInfo", [timeZoneGroupId]).then(function (currentTimeInfo) {
        return currentTimeInfo;
    });
};

var pickAccountSettingsForCreateUser = function pickAccountSettingsForCreateUser(state, userInfo) {
    var accountSettings = pickAccountSettings(userInfo);
    if (!(0, _selectors5.isUGREnabled)(state)) accountSettings.userGroupId = _constants3.USERS_WITHOUT_GROUP_ID;
    if (!(0, _selectors5.isTZGEnabled)(state)) accountSettings.timeZoneGroupId = _constants3.DEFAULT_TIME_ZONE_GROUP_ID;
    return accountSettings;
};

var pickAccountSettings = function pickAccountSettings(state) {
    return _underscore2.default.pick(state, ['firstName', 'lastName', 'middleInitial', 'username', 'email', 'userGroupId', 'timeZoneGroupId', 'hireDate', 'releaseDate', 'enabled', 'enabledInOtherProduct', 'accessRights', 'rates', 'requiresTTApproval', 'overtimeLevel', 'defaultInitialSchedule', 'initialSchedule', 'workSchedule', 'password', 'retypedPassword']);
};

var pickAccountSettingFromCopyData = function pickAccountSettingFromCopyData(settings) {
    return _extends({}, _underscore2.default.pick(settings, ['enabled', 'enabledInOtherProduct', 'accessRights', 'userGroupId', 'timeZoneGroupId', 'overtimeLevel', 'rates', 'requiresTTApproval', 'initialSchedule', 'defaultInitialSchedule', 'workSchedule']), {
        newUserGroupName: null,
        newTimeZoneGroup: null
    });
};

var validateUserForCreate = function validateUserForCreate(userInfo, userGroupData, timeZoneGroupData, providerErrors) {
    var validationResults = [(0, _validation.validateFirstName)(providerErrors, userInfo.firstName), (0, _validation.validateLastName)(providerErrors, userInfo.lastName), (0, _validation.validateEmail)(providerErrors, userInfo.email, true), (0, _validation.validateUserGroupName)(providerErrors, userGroupData.groupId, userGroupData.newUserGroupName), (0, _validation.validateTimezoneGroup)(providerErrors, timeZoneGroupData.groupId, timeZoneGroupData.newTimeZoneGroup), (0, _validation.validateHireDate)(providerErrors, false, userInfo.hireDate), (0, _validation.validateReleaseDate)(providerErrors, userInfo.releaseDate, userInfo.hireDate)];

    if (!_constants.isOlVersion) {
        validationResults.push((0, _validation.validateUserName)(providerErrors, userInfo.username), (0, _validation.validatePassword)(providerErrors, userInfo.password));
    }

    var resultErrors = validationResults.reduce(function (providerErrors, r) {
        return providerErrors = _extends({}, providerErrors, r.errors);
    }, {});
    return {
        isValid: _jquery2.default.isEmptyObject(resultErrors),
        providerErrors: resultErrors
    };
};

var validate = function validate(validateFn) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
    }

    return function (dispatch, getState) {
        var state = getState();
        var providerErrors = (0, _selectors.getUserPanelErrors)(state);
        var validationResult = validateFn.apply(undefined, [providerErrors].concat(args));
        dispatch(UserDataActions.setUserPanelErrors(validationResult.errors));
    };
};

var updateUserInfo = function updateUserInfo(info) {
    return function (dispatch) {
        dispatch(UserDataActions.setFullUserInfo(info));
    };
};

var updateFirstName = exports.updateFirstName = function updateFirstName(newFName) {
    return function (dispatch) {
        dispatch(updateUserInfo({ firstName: newFName }));
        dispatch(validate(_validation.validateFirstName, newFName));
    };
};

var updateLastName = exports.updateLastName = function updateLastName(newLName) {
    return function (dispatch) {
        dispatch(updateUserInfo({ lastName: newLName }));
        dispatch(validate(_validation.validateLastName, newLName));
    };
};

var updateMiddleName = exports.updateMiddleName = function updateMiddleName(newMName) {
    return function (dispatch) {
        dispatch(updateUserInfo({ middleInitial: newMName }));
    };
};

var updateUserName = exports.updateUserName = function updateUserName(newUName, duplicateError) {
    return function (dispatch) {
        dispatch(updateUserInfo({ username: newUName }));
        if (duplicateError) {
            dispatch(UserDataActions.addUserPanelErrors([_constants2.ValidationErrors.DUPLICATE_USERNAME]));
        } else {
            dispatch(UserDataActions.removeUserPanelErrors([_constants2.ValidationErrors.DUPLICATE_USERNAME]));
        }
        dispatch(validate(_validation.validateUserName, newUName));
    };
};

var updateEmail = exports.updateEmail = function updateEmail(newEmail) {
    return function (dispatch) {
        dispatch(updateUserInfo({ email: newEmail }));
        dispatch(validate(_validation.validateEmail, newEmail, true));
    };
};

var updatePassword = exports.updatePassword = function updatePassword(newPassword, retypedPassword) {
    return function (dispatch) {
        dispatch(updateUserInfo({
            password: newPassword,
            retypedPassword: retypedPassword
        }));
        dispatch(setPasswordValidationRequested());
    };
};

var onPasswordValidationStart = exports.onPasswordValidationStart = function onPasswordValidationStart() {
    return function (dispatch) {
        dispatch(UserDataActions.removeUserPanelErrors([_constants2.ValidationErrors.PASSWORD_EMPTY, _constants2.ValidationErrors.PASSWORD_COPY_EMPTY, _constants2.ValidationErrors.PASSWORD_RESTRICTIONS_VIOLATED, _constants2.ValidationErrors.PASSWORDS_DO_NOT_MATCH]));
        dispatch(UserDataActions.setPasswordValidationResult(null));
    };
};

var onPasswordValidationEnd = exports.onPasswordValidationEnd = function onPasswordValidationEnd(errorKey, passwordValidationJson) {
    return function (dispatch) {
        if (errorKey) {
            dispatch(UserDataActions.addUserPanelErrors([errorKey]));
            dispatch(UserDataActions.setPasswordValidationResult(passwordValidationJson));
        }
        dispatch(setPasswordValidationDone());
    };
};

var updateUserGroup = exports.updateUserGroup = function updateUserGroup(ugrId, newUgrName) {
    return function (dispatch) {
        dispatch(updateUserInfo({
            userGroupId: ugrId
        }));
        dispatch((0, _actions.setUserGroupData)({
            groupId: ugrId,
            newGroupCreating: ugrId === _constants2.GROUP_NEW_OR_NOT_KNOWN,
            newUserGroupName: newUgrName
        }));
        dispatch(validate(_validation.validateUserGroupName, ugrId, newUgrName));
    };
};

var updateTimeZoneGroup = exports.updateTimeZoneGroup = function updateTimeZoneGroup(tzgId, newTzg) {
    return function (dispatch) {
        dispatch(UserDataActions.removeUserPanelErrors([_constants2.ValidationErrors.DUPLICATE_TIME_ZONE_GROUP, _constants2.ValidationErrors.NEW_TIME_ZONE_GROUP_EMPTY, _constants2.ValidationErrors.CITY_DATA_EMPTY]));
        dispatch(updateUserInfo({
            timeZoneGroupId: tzgId
        }));
        dispatch((0, _actions.setTimeZoneGroupData)({
            groupId: tzgId,
            newTimeZoneGroup: newTzg
        }));
        dispatch(validate(_validation.validateTimezoneGroup, tzgId, newTzg));
    };
};

var updateHireDate = exports.updateHireDate = function updateHireDate(hireDate) {
    return function (dispatch, getState) {
        dispatch(UserDataActions.removeUserPanelErrors([_constants2.ValidationErrors.LAST_MANAGER_IN_OTHER_PRODUCT]));
        dispatch(updateUserInfo({
            hireDate: hireDate
        }));
        dispatch(validate(_validation.validateHireDate, false, hireDate));
        var releaseDateStr = (0, _selectors.getFullUserInfo)(getState()).releaseDate;
        var backupReleaseDateStr = (0, _selectors8.getErrorBackup)(getState()).releaseDate;
        dispatch(validate(_validation.validateReleaseDate, releaseDateStr ? Date.parseJSONDate(releaseDateStr) : null, hireDate, backupReleaseDateStr));
    };
};

var updateReleaseDate = exports.updateReleaseDate = function updateReleaseDate(releaseDate) {
    return function (dispatch) {
        dispatch(updateUserInfo({
            releaseDate: releaseDate
        }));
    };
};

var updateUserRights = exports.updateUserRights = function updateUserRights() {
    var accessRights = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return function (dispatch) {
        dispatch(updateUserInfo({
            accessRights: accessRights
        }));
    };
};

var updateAccess = exports.updateAccess = function updateAccess(enabled) {
    return function (dispatch) {
        dispatch(updateUserInfo({
            enabled: enabled
        }));
    };
};

var updateAccessAP = exports.updateAccessAP = function updateAccessAP(enabled) {
    return function (dispatch) {
        dispatch(updateUserInfo({
            enabledInOtherProduct: enabled
        }));
    };
};

var updateRequireApproval = exports.updateRequireApproval = function updateRequireApproval(needApproval) {
    return function (dispatch) {
        dispatch(updateUserInfo({
            requiresTTApproval: needApproval
        }));
    };
};

var updateOvertime = exports.updateOvertime = function updateOvertime(level) {
    return function (dispatch) {
        dispatch(updateUserInfo({
            overtimeLevel: level
        }));
    };
};

var updateUserRates = exports.updateUserRates = function updateUserRates(_ref7) {
    var index = _ref7.index,
        rate = _ref7.rate;
    return function (dispatch, getState) {
        var state = getState();
        var prevRates = (0, _selectors4.getUserRates)(state);
        var rates = [].concat(_toConsumableArray(prevRates));
        rates.splice(index, 1, rate);

        var _getUserRatesValidati3 = (0, _selectors.getUserRatesValidationData)(state),
            overtimeEnabled = _getUserRatesValidati3.overtimeEnabled,
            leaveTypesEnabled = _getUserRatesValidati3.leaveTypesEnabled;

        var _getUserRatesErrors2 = (0, _validationUtils.getUserRatesErrors)(rates, overtimeEnabled, leaveTypesEnabled, false),
            errors = _getUserRatesErrors2.errors;

        dispatch(updateUserInfo({ rates: rates }));
        dispatch(UserRatesActions.setErrors(errors));
    };
};

var addNewUserRate = exports.addNewUserRate = function addNewUserRate() {
    return function (dispatch, getState) {
        var state = getState();
        var userRates = (0, _selectors4.getUserRates)(state);
        var currentDateStr = (0, _selectors6.getUserManagementData)(state).todayInViewerTimeZone.parseJSONDate().toJSON();

        var newRate = {
            rateId: -1,
            effectiveDate: userRates.find(function (rate) {
                return rate.effectiveDate === currentDateStr;
            }) ? null : currentDateStr,
            leaveRates: []
        };

        dispatch(updateUserInfo({ rates: [].concat(_toConsumableArray(userRates), [newRate]) }));
    };
};

var deleteUserRate = exports.deleteUserRate = function deleteUserRate(_ref8) {
    var index = _ref8.index;
    return function (dispatch, getState) {
        var state = getState();

        var rates = [].concat(_toConsumableArray((0, _selectors4.getUserRates)(state)));
        rates.splice(index, 1);

        var errors = [].concat(_toConsumableArray((0, _selectors4.getErrors)(state)));
        errors.splice(index, 1);

        dispatch(updateUserInfo({ rates: rates }));
        dispatch(UserRatesActions.setErrors(errors));
    };
};

var updateUserSchedules = exports.updateUserSchedules = function updateUserSchedules(_ref9) {
    var _ref9$workSchedules = _ref9.workSchedules,
        workSchedules = _ref9$workSchedules === undefined ? [] : _ref9$workSchedules;
    return function (dispatch) {
        dispatch(updateUserInfo({
            workSchedule: workSchedules
        }));
    };
};

var updateInitialUserSchedule = exports.updateInitialUserSchedule = function updateInitialUserSchedule(_ref10) {
    var _ref10$isDefaultIniti = _ref10.isDefaultInitialSchedule,
        isDefaultInitialSchedule = _ref10$isDefaultIniti === undefined ? false : _ref10$isDefaultIniti,
        _ref10$initialSchedul = _ref10.initialSchedule,
        initialSchedule = _ref10$initialSchedul === undefined ? [] : _ref10$initialSchedul;
    return function (dispatch, getState) {
        dispatch(updateUserInfo({
            defaultInitialSchedule: isDefaultInitialSchedule,
            initialSchedule: isDefaultInitialSchedule ? (0, _selectors6.getDefaultWorkSchedule)(getState()) : initialSchedule
        }));
    };
};

var changeTeamAssignments = exports.changeTeamAssignments = function changeTeamAssignments(_ref11) {
    var _ref11$teamAssignment = _ref11.teamAssignmentType,
        teamAssignmentType = _ref11$teamAssignment === undefined ? _constants2.UserTeamAssignmentType.NO : _ref11$teamAssignment,
        _ref11$assignedGroupI = _ref11.assignedGroupIds,
        assignedGroupIds = _ref11$assignedGroupI === undefined ? [] : _ref11$assignedGroupI,
        _ref11$assignedUserId = _ref11.assignedUserIds,
        assignedUserIds = _ref11$assignedUserId === undefined ? [] : _ref11$assignedUserId;
    return function (dispatch, getState) {
        var state = getState();

        var userTeamAssignmentsData = {
            teamAssignmentType: teamAssignmentType,
            assignedGroups: assignedGroupIds,
            assignedUsers: assignedUserIds
        };

        dispatch(UserDataActions.setUserTeamAssignmentsData(_extends({}, userTeamAssignmentsData, {
            assignedUsersCount: (0, _utils.getAssignedUsersCount)({
                userTeamAssignmentsData: userTeamAssignmentsData,
                allUsers: (0, _selectors.getAllUsers)(state),
                isUGREnabled: (0, _selectors5.isUGREnabled)(state)
            })
        })));
    };
};

var changeTasksAssignments = exports.changeTasksAssignments = function changeTasksAssignments(_ref12) {
    var _ref12$addedIds = _ref12.addedIds,
        addedIds = _ref12$addedIds === undefined ? [] : _ref12$addedIds,
        _ref12$removedIds = _ref12.removedIds,
        removedIds = _ref12$removedIds === undefined ? [] : _ref12$removedIds,
        _ref12$addedProjectId = _ref12.addedProjectIds,
        addedProjectIds = _ref12$addedProjectId === undefined ? [] : _ref12$addedProjectId,
        _ref12$removedProject = _ref12.removedProjectIds,
        removedProjectIds = _ref12$removedProject === undefined ? [] : _ref12$removedProject,
        _ref12$taskList = _ref12.taskList,
        taskList = _ref12$taskList === undefined ? [] : _ref12$taskList;
    return function (dispatch, getState) {
        var state = getState();

        var tasks = (0, _selectors3.getTasks)(state);
        var addedIdsSet = (0, _atUtils.arrayToSet)(addedIds);
        var addedTasksList = Object.values(tasks).filter(function (task) {
            return !!addedIdsSet[task.id];
        });
        dispatch(addTasksManageAssignments(addedTasksList));
        var tasksMap = (0, _selectors2.getManageAssignmentsTasks)(getState());
        var ma = _extends({}, (0, _selectors2.getManageAssignments)(state));

        ma.addedProjectIdsExcludingSelf = (0, _utils.mergeAssignments)(ma.addedProjectIdsExcludingSelf, {
            added: addedProjectIds,
            removed: removedProjectIds
        });

        //  get ids of tasks already added via c or p
        var taskIdsOfCP = (0, _utils.getTaskIdsOfCustomersAndProjects)(tasks, [], addedProjectIds);

        ma.addedTaskIds = (0, _utils.mergeAssignments)(ma.addedTaskIds, {
            added: addedIds,
            removed: removedIds.concat(taskIdsOfCP)
        });

        dispatch(setManageAssignments(ma));
    };
};

var changeProjectAssignments = exports.changeProjectAssignments = function changeProjectAssignments(_ref13) {
    var _ref13$addedIds = _ref13.addedIds,
        addedIds = _ref13$addedIds === undefined ? [] : _ref13$addedIds,
        _ref13$removedIds = _ref13.removedIds,
        removedIds = _ref13$removedIds === undefined ? [] : _ref13$removedIds,
        _ref13$addedCustomerI = _ref13.addedCustomerIds,
        addedCustomerIds = _ref13$addedCustomerI === undefined ? [] : _ref13$addedCustomerI,
        _ref13$removedCustome = _ref13.removedCustomerIds,
        removedCustomerIds = _ref13$removedCustome === undefined ? [] : _ref13$removedCustome;
    return function (dispatch, getState) {
        var state = getState();
        var tasksMap = (0, _selectors2.getManageAssignmentsTasks)(state);
        var ma = _extends({}, (0, _selectors2.getManageAssignments)(state));

        // remove all projects of excluding self customers
        var projectsOfExcludingCustomers = getProjectIdsOfCustomers(addedCustomerIds, (0, _selectors3.getProjects)(state));

        ma.addedProjectIds = (0, _utils.mergeAssignments)(ma.addedProjectIds, {
            added: addedIds, removed: [].concat(_toConsumableArray(removedIds), _toConsumableArray(projectsOfExcludingCustomers))
        });
        ma.addedProjectIdsExcludingSelf = (0, _utils.mergeAssignments)(ma.addedProjectIdsExcludingSelf, {
            added: [], removed: [].concat(_toConsumableArray(removedIds), _toConsumableArray(addedIds), _toConsumableArray(projectsOfExcludingCustomers))
        });
        ma.addedCustomerIdsExcludingSelf = (0, _utils.mergeAssignments)(ma.addedCustomerIdsExcludingSelf, {
            added: addedCustomerIds, removed: removedCustomerIds
        });

        // remove all tasks of excluding self customers and including self projects
        ma.addedTaskIds = (0, _utils.mergeAssignments)(ma.addedTaskIds, {
            added: [],
            removed: (0, _utils.getTaskIdsOfCustomersAndProjects)(tasksMap, addedCustomerIds, [].concat(_toConsumableArray(addedIds), _toConsumableArray(removedIds)))
        });

        // get project counts by customers excluding self
        ma.projectCountsByCustomers = (0, _utils.calculateProjectsByCustomerIds)(ma.addedCustomerIdsExcludingSelf, (0, _selectors3.getProjects)(state));

        dispatch(setManageAssignments(ma));
        dispatch(UserDataActions.setUserManageAssignmentsData((0, _utils.createManagementAssignmentsData)(ma, (0, _selectors3.getCustomers)(state), (0, _selectors3.getProjects)(state), tasksMap)));
    };
};

var changeCustomerAssignments = exports.changeCustomerAssignments = function changeCustomerAssignments(_ref14) {
    var _ref14$addedIds = _ref14.addedIds,
        addedIds = _ref14$addedIds === undefined ? [] : _ref14$addedIds,
        _ref14$removedIds = _ref14.removedIds,
        removedIds = _ref14$removedIds === undefined ? [] : _ref14$removedIds;
    return function (dispatch, getState) {
        var state = getState();
        var tasksMap = (0, _selectors2.getManageAssignmentsTasks)(state);
        var ma = _extends({}, (0, _selectors2.getManageAssignments)(state));
        var projects = (0, _selectors3.getProjects)(state);

        // also remove all projects of including self customers
        var projectsOfAssignCustomers = getProjectIdsOfCustomers(addedIds, projects);
        ma.addedProjectIdsExcludingSelf = (0, _utils.mergeAssignments)(ma.addedProjectIdsExcludingSelf, {
            added: [], removed: projectsOfAssignCustomers
        });
        var projectsOfUnassignedCustomers = getProjectIdsOfCustomers(removedIds, projects);
        ma.addedProjectIds = (0, _utils.mergeAssignments)(ma.addedProjectIds, {
            added: [], removed: [].concat(_toConsumableArray(projectsOfAssignCustomers), _toConsumableArray(projectsOfUnassignedCustomers))
        });

        ma.addedCustomerIds = (0, _utils.mergeAssignments)(ma.addedCustomerIds, {
            added: addedIds, removed: removedIds
        });
        ma.addedCustomerIdsExcludingSelf = (0, _utils.mergeAssignments)(ma.addedCustomerIdsExcludingSelf, {
            added: [], removed: removedIds
        });

        // remove all tasks of including self customers
        ma.addedTaskIds = (0, _utils.mergeAssignments)(ma.addedTaskIds, {
            added: [],
            removed: (0, _utils.getTaskIdsOfCustomersAndProjects)(tasksMap, [].concat(_toConsumableArray(addedIds), _toConsumableArray(removedIds)))
        });

        dispatch(setManageAssignments(ma));
        dispatch(UserDataActions.setUserManageAssignmentsData((0, _utils.createManagementAssignmentsData)(ma, (0, _selectors3.getCustomers)(state), (0, _selectors3.getProjects)(state), tasksMap)));
    };
};

var changeManagementAssignmentsSelection = exports.changeManagementAssignmentsSelection = function changeManagementAssignmentsSelection(managementAssignmentsSelection) {
    return function (dispatch, getState) {
        var state = getState();
        var tasksMap = (0, _selectors2.getManageAssignmentsTasks)(state);
        var ma = _extends({}, (0, _selectors2.getManageAssignments)(state));

        ma.managementAssignmentsSelection = managementAssignmentsSelection;

        dispatch(setManageAssignments(ma));
        dispatch(UserDataActions.setUserManageAssignmentsData(_extends({}, (0, _utils.createManagementAssignmentsData)(ma, (0, _selectors3.getCustomers)(state), (0, _selectors3.getProjects)(state), tasksMap))));
    };
};

function getProjectIdsOfCustomers() {
    var customerIds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var projectsMap = arguments[1];

    var customerIdsSet = (0, _atUtils.arrayToSet)(customerIds);
    return Object.values(projectsMap).filter(function (project) {
        return !!customerIdsSet[project.customerId];
    }).map(function (project) {
        return project.id;
    });
}

function loadTaskCountsByProjects() {
    var projectIds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    return (0, _rpcCalls2.default)('UserManagementService.countTasksByProjectsForCreateUser', [projectIds]).then(function (result) {
        return result.map;
    });
}

var loadManagementAssignmentsCounts = exports.loadManagementAssignmentsCounts = function loadManagementAssignmentsCounts() {
    return function (dispatch, getState) {
        dispatch((0, _actions.managementAssignmentsCountsLoad)(true));

        var assignedIds = (0, _selectors2.getManagementAssignmentsCptIds)(getState());
        (0, _rpcCalls2.default)('UserManagementService.getCptCountersForManagementAssignmentsEditor', [assignedIds]).then(function (data) {
            dispatch((0, _actions.managementAssignmentsCountsLoadSuccess)({
                customers: data['customers'],
                projects: data['projects'],
                tasks: data['tasks']
            }));
        }).catch(function (error) {
            return dispatch((0, _actions.managementAssignmentsCountsLoadFailure)(error));
        });
    };
};

var updateStateFromCreateResult = exports.updateStateFromCreateResult = function updateStateFromCreateResult(result) {
    return function (dispatch) {
        dispatch((0, _actions3.setLicenseCounters)(result.licenseCounters));
        dispatch((0, _actions3.setViewerSettings)(result.viewerSettings));
        if (result.userGroups) {
            dispatch((0, _actions2.addUserGroups)(result.userGroups));
        }
        if (result.timeZoneGroups) {
            dispatch((0, _actions2.addTimeZoneGroups)(result.timeZoneGroups));
        }

        dispatch((0, _actions4.setEnabledFeatures)(result.viewerSettings.enabledFeatures));
        dispatch((0, _actions2.addUser)(result.userInfo));
        dispatch((0, _actions3.addNewUserIds)([result.userInfo.id]));
        dispatch((0, _actions5.prependUserIdsOrder)([result.userInfo.id]));
    };
};

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MODE = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _constants = __webpack_require__(4);

var _AccountSettings = __webpack_require__(1641);

var _AccountSettings2 = _interopRequireDefault(_AccountSettings);

var _Permissions = __webpack_require__(1666);

var _Permissions2 = _interopRequireDefault(_Permissions);

var _PermissionsTemplatesButtonController = __webpack_require__(752);

var _PermissionsTemplatesButtonController2 = _interopRequireDefault(_PermissionsTemplatesButtonController);

var _PermissionsDescriptionLightBox = __webpack_require__(546);

var _PermissionsDescriptionLightBox2 = _interopRequireDefault(_PermissionsDescriptionLightBox);

var _constants2 = __webpack_require__(21);

var _UserPanelContent = __webpack_require__(1675);

var _UserPanelContent2 = _interopRequireDefault(_UserPanelContent);

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _ScrollableContainer = __webpack_require__(49);

var _ScrollableContainer2 = _interopRequireDefault(_ScrollableContainer);

var _utils = __webpack_require__(311);

var _utils2 = __webpack_require__(25);

var _constants3 = __webpack_require__(4);

var _ScrollUtils = __webpack_require__(39);

var _ScrollUtils2 = _interopRequireDefault(_ScrollUtils);

var _actions = __webpack_require__(126);

var _groupUtils = __webpack_require__(71);

var _atBrowserUtils = __webpack_require__(8);

var _constants4 = __webpack_require__(77);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MODE = exports.MODE = {
    CREATE: "create",
    EDIT: "edit"
};

var UserPanelContainer = function (_TemplateView) {
    _inherits(UserPanelContainer, _TemplateView);

    function UserPanelContainer(_ref) {
        var accountSettingsId = _ref.accountSettingsId,
            mode = _ref.mode,
            _ref$actions = _ref.actions,
            actions = _ref$actions === undefined ? {
            updateFirstName: function updateFirstName() {},
            updateLastName: function updateLastName() {},
            updateMiddleName: function updateMiddleName() {},
            updateUserName: function updateUserName() {},
            updateEmail: function updateEmail() {},
            updatePassword: function updatePassword() {},
            updateUserGroup: function updateUserGroup() {},
            updateTimeZoneGroup: function updateTimeZoneGroup() {},
            validateTimeZoneGroup: function validateTimeZoneGroup() {},
            updateHireDate: function updateHireDate() {},
            setHasLeavesOrTTBeforeNewHireDateError: function setHasLeavesOrTTBeforeNewHireDateError() {},
            updateReleaseDate: function updateReleaseDate() {},
            updateUserRights: function updateUserRights() {},
            updateAccess: function updateAccess() {},
            updateAccessAP: function updateAccessAP() {},
            updateRequireApproval: function updateRequireApproval() {},
            updateUserSchedules: function updateUserSchedules() {},
            updateInitialUserSchedule: function updateInitialUserSchedule() {},
            updateDefaultWorkStatuses: function updateDefaultWorkStatuses() {},
            deleteUserSchedule: function deleteUserSchedule() {},
            updateOvertime: function updateOvertime() {},
            changeTeamAssignments: function changeTeamAssignments() {},
            openManagementAssignmentPanel: function openManagementAssignmentPanel() {},
            restoreState: function restoreState() {},
            setUserManagementData: function setUserManagementData() {},
            setLastLicenseManagerOnDeleteAlertShown: function setLastLicenseManagerOnDeleteAlertShown() {},
            setLastLicenseManagerOnDisableAtAlertShown: function setLastLicenseManagerOnDisableAtAlertShown() {},
            setLastLicenseManagerOnDisableApAlertShown: function setLastLicenseManagerOnDisableApAlertShown() {}
        } : _ref$actions;

        _classCallCheck(this, UserPanelContainer);

        var _this = _possibleConstructorReturn(this, (UserPanelContainer.__proto__ || Object.getPrototypeOf(UserPanelContainer)).call(this, null));

        _this._handleTeamAssignmentsPanelVisibility = function (visible, e) {};

        _this._handleManagementAssignmentsCellClick = function (e) {
            (0, _utils2.setEventPreventHidingManagementAssignmentsSlidingPanel)(e);
            _this.actions.openManagementAssignmentPanel(_this.state.userId, _constants3.HierarchyLevels.CUSTOMER);
        };

        _this._handleChangeCustomersSelectorVisibility = function (visible) {
            _this.permissionsTab.getEl().toggleClass('customersSelectorOpen', visible);
            _this.userPanelContentWrapper.forceUpdate();
        };

        _this._handleChangeProjectsSelectorVisibility = function (visible) {
            _this.permissionsTab.getEl().toggleClass('projectsSelectorOpen', visible);
            _this.userPanelContentWrapper.forceUpdate();
        };

        _this._handleChangeTasksSelectorVisibility = function (visible) {
            _this.permissionsTab.getEl().toggleClass('tasksSelectorOpen', visible);
            _this.userPanelContentWrapper.forceUpdate();
        };

        _this._handleChangePermissionsDialogVisibility = function (visible) {
            _this.permissionsTab.getEl().toggleClass('permissionsDialogOpen', visible);
            _this.userPanelContentWrapper.forceUpdate();
        };

        _this._handleChangePermissionsTemplates = function (_ref2) {
            var templates = _ref2.templates,
                permissions = _ref2.permissions,
                userLoggedIn = _ref2.userLoggedIn;

            _this._onChangePermissions(permissions, userLoggedIn);
            _this.actions.setUserManagementData({
                permissionsTemplates: templates
            });
        };

        _this.params = {
            accountSettingsId: accountSettingsId,
            mode: mode
        };

        _this.actions = actions;

        _this.state = {
            updatingData: false,
            loggedInUserId: null,
            userId: null,
            selectedTab: _constants2.TabKeys.ACCOUNT_SETTINGS,
            fullUserInfo: {
                firstName: null,
                lastName: null,
                middleInitial: null,
                username: null,
                email: null,
                password: "",
                retypedPassword: "",
                userGroupId: null,
                timeZoneGroupId: null,
                hireDate: new Date().toJSON(),
                releaseDate: null,
                enabled: false,
                enabledInOtherProduct: false,
                overtimeLevel: 1,
                accessRights: [],
                rates: [],
                requiresTTApproval: false,
                initialSchedule: [],
                defaultInitialSchedule: true,
                workSchedule: []
            },
            userGroupRowData: {
                groupId: null,
                newGroupCreating: false
            },
            timeZoneGroupRowData: {
                groupId: null,
                newGroupCreating: false,
                timeZoneGroupOffsets: {}
            },
            userTeamAssignmentsData: {
                teamAssignmentType: _constants2.UserTeamAssignmentType.SELECTED,
                assignedGroups: [],
                assignedUsers: [],
                assignedUsersCount: 0
            },
            userManageAssignmentsData: {
                managementAssignmentsSelection: _constants3.ManagementAssignmentsSelection.SELECTED,
                customers: {},
                projects: {},
                tasks: {},
                customerAssignments: [],
                projectAssignments: [],
                taskAssignments: [],
                taskCountsByProjects: {},
                projectCountsByCustomers: {}
            },
            managementAssignmentsCounts: {
                customers: 0,
                projects: 0,
                tasks: 0
            },
            allApprovers: {},
            userManagementData: {
                activeLeaveTypes: [],
                overtimeRateCoefficient: 0,
                decimalSeparator: '.',
                dateFormat: 'MMM dd, yyyy',
                defaultWorkSchedule: [],
                invertedDaysMap: {},
                weekStartDay: 1,
                permissionsTemplates: [],
                viewerSettings: {
                    enabledFeatures: {},
                    allowedToManageLeaveBalanceSettings: false,
                    allowedToManageScope: false,
                    hasAccessToScopeOfWork: false,
                    hasAccessToUsers: false,
                    allowedToManageAccountSettings: false,
                    assignedUserIds: null,
                    showAccountSettings: false
                },
                todayInViewerTimeZone: new Date().toJSON(),
                allTimeZoneGroupOffsets: {}
            },
            allUserGroups: [],
            allTimeZoneGroups: [],
            extendedData: {
                lastLoginTime: null,
                firstTTDate: null,
                hasTimeTrack: false,
                lastOtherProductAdmin: false,
                lastLicensesManager: false,
                currentTime: new Date().toJSON(),
                isAllowedToSeeAllUsersTT: false
            },
            providerErrors: {},
            passwordValidationResult: null,
            hasLeavesOrTTBeforeNewHireDateError: false,
            isUGREnabled: false,
            isTZGEnabled: false,
            isURAEnabled: false,
            isTTAEnabled: false,
            updatingUserRates: false,
            updatingWorkSchedule: false,
            isBTYEnabled: false,
            isLTTEnabled: false,
            isPTOEnabled: false,
            idSDBEnabled: false,
            isOVREnabled: false,
            isWSDEnabled: false,

            baseAccountInformationEditable: false,
            accessToActiTimeEditable: false,
            accessToActiPlansEditable: false,
            departmentEditable: false,
            timeZoneEditable: false,
            hireAndReleaseDatesEditable: false,
            approvalSettingsEditable: false,
            workScheduleEditable: false,
            overtimeSettingsEditable: false,
            costOfWorkRatesEditable: false,

            permissionsEditable: false,
            teamScopeEditable: false,
            manageScopeEditable: false,

            hasRightsToDeleteUser: false,

            loaded: false
        };

        _this.onStatePropertyChanged('updatingData', function (loading) {
            _this.header.setState({ updateLoading: loading });
            _this.permissionsTab.setState({ disabled: loading });
        });

        _this.onStatePropertyChanged('loaded', function (loaded) {
            _this.accountSettingsTab.setState({ loaded: loaded });
        });

        _this.onStatePropertyChanged('selectedTab', function (currentTabKey) {
            _this.userPanelContent.setState({ currentTabKey: currentTabKey });
            _this.userPanelContentWrapper.forceUpdate();
            _this.scrollToTop();
        });

        _this.onStatePropertyChanged('userId', function (userId) {
            if (userId !== null) {
                _this.scrollToTop();
            }
        });

        _this.onStatePropertyChanged('fullUserInfo', function (fullUserInfo) {
            return _this._onFullUserInfoChanged(fullUserInfo);
        });
        _this.onStatePropertyChanged('userGroupRowData', function (userGroupRowData) {
            return _this.userGroupRow.setState(userGroupRowData);
        });
        _this.onStatePropertyChanged('timeZoneGroupRowData', function (timeZoneGroupRowData) {
            return _this.timeZoneGroupRow.setState(timeZoneGroupRowData);
        });
        _this.onStatePropertyChanged('userManagementData', function (userManagementData) {
            return _this._onUserManagementDataChanged(userManagementData);
        });
        _this.onStatePropertyChanged('userManageAssignmentsData', function (ma) {
            return _this._onUserManageAssignmentsDataChanged(ma);
        });
        _this.onStatePropertyChanged('managementAssignmentsCounts', function (counts) {
            return _this._onManagementAssignmentsCountsChanged(counts);
        });
        _this.onStatePropertyChanged('userTeamAssignmentsData', function (ta) {
            return _this._onUserTeamAssignmentsDataChanged(ta);
        });
        _this.onStatePropertyChanged('extendedData', function (extendedData) {
            return _this._onExtendedDataChanged(extendedData);
        });
        _this.onStatePropertyChanged('allUserGroups', function (userGroups) {
            return _this._onUserGroupsChanged(userGroups);
        });
        _this.onStatePropertyChanged('allTimeZoneGroups', function (allTimeZoneGroups) {
            return _this._onTimeZoneGroupsChanged(allTimeZoneGroups);
        });

        _this.onStatePropertyChanged('providerErrors', function (providerErrors) {
            _this.accountSettingsTab.accountInformation.setState({ providerErrors: providerErrors });
            _this.userGroupRow.setState({ errors: providerErrors });
            _this.timeZoneGroupRow.setState({ errors: providerErrors });
        });
        _this.onStatePropertyChanged('passwordValidationResult', function (passwordValidationResult) {
            _this.accountSettingsTab.accountInformation.setState({ passwordValidationResult: passwordValidationResult });
        });
        _this.onStatePropertyChanged('hasLeavesOrTTBeforeNewHireDateError', function (hasLeavesOrTTBeforeNewHireDateError) {
            _this.accountSettingsTab.accountInformation.setState({ hasLeavesOrTTBeforeNewHireDateError: hasLeavesOrTTBeforeNewHireDateError });
        });

        _this.onStatePropertyChanged('isUGREnabled', function (isUGREnabled) {
            _this.permissionsTab.setState({
                isUGREnabled: isUGREnabled
            });
            _this.userGroupRow.toggle(isUGREnabled);
        });

        _this.onStatePropertyChanged('departmentEditable', function (editable) {
            _this.userGroupRow.setState({ editable: editable });
        });

        _this.onStatePropertyChanged('timeZoneEditable', function (editable) {
            _this.timeZoneGroupRow.setState({ editable: editable });
        });

        _this.onStatePropertyChanged('isTZGEnabled', function (isTZGEnabled) {
            _this.timeZoneGroupRow.toggle(isTZGEnabled);
        });

        _this.onStatePropertyChanged('updatingUserRates', function (updatingUserRates) {
            _this.accountSettingsTab.setState({ updatingUserRates: updatingUserRates });
        });

        _this.onStatePropertyChanged('updatingWorkSchedule', function (updating) {
            return _this.accountSettingsTab.workSchedule.setState({ updating: updating });
        });

        _this.onStatePropertyChanged('isURAEnabled', function (isURAEnabled) {
            _this.permissionsTab.setState({ isURAEnabled: isURAEnabled });
            _this.accountSettingsTab.setState({ showUserRates: isURAEnabled });
            _this.permissionsTemplatesButtonController.setState({ isURAEnabled: isURAEnabled });
        });

        _this.onStatePropertyChanged('isBTYEnabled', function (enabled) {
            _this.permissionsTab.setState({
                isBTYEnabled: enabled
            });
            _this.permissionsTemplatesButtonController.setState({ isBTYEnabled: enabled });
        });

        _this.onStatePropertyChanged('isLTTEnabled', function (enabled) {
            _this.permissionsTab.setState({
                isLTTEnabled: enabled
            });

            _this.permissionsTemplatesButtonController.setState({ isLTTEnabled: enabled });
        });
        _this.onStatePropertyChanged('isPTOEnabled', function (enabled) {
            _this.permissionsTab.setState({
                isPTOEnabled: enabled
            });

            _this.permissionsTemplatesButtonController.setState({ isPTOEnabled: enabled });
        });

        _this.onStatePropertyChanged('isSDBEnabled', function (enabled) {
            _this.permissionsTab.setState({
                isSDBEnabled: enabled
            });

            _this.permissionsTemplatesButtonController.setState({ isSDBEnabled: enabled });
        });

        _this.onStatePropertyChanged('isOVREnabled', function (enabled) {
            _this.accountSettingsTab.setState({
                showOvertime: enabled
            });
        });

        _this.onStatePropertyChanged('isWSDEnabled', function (enabled) {
            _this.accountSettingsTab.setState({
                isWSDEnabled: enabled
            });
        });

        _this.onStatePropertyChanged('baseAccountInformationEditable', function (baseAccountInformationEditable) {
            _this.accountSettingsTab.accountInformation.setState({ baseAccountInformationReadOnly: !baseAccountInformationEditable });
        });

        _this.onStatePropertyChanged('accessToActiPlansEditable', function (accessToActiPlansEditable) {
            _this.accountSettingsTab.accountInformation.setState({ accessToActiPlansEditable: accessToActiPlansEditable });
        });

        _this.onStatePropertyChanged('accessToActiTimeEditable', function (accessToActiTimeEditable) {
            _this.accountSettingsTab.accountInformation.setState({ accessToActiTimeEditable: accessToActiTimeEditable });
        });

        _this.onStatePropertyChanged('hireAndReleaseDatesEditable', function (editable) {
            _this.accountSettingsTab.accountInformation.setState({ hireAndReleaseDatesEditable: editable });
        });

        _this.onAnyStatePropertyChanged(['approvalSettingsEditable'], function () {
            _this.accountSettingsTab.timeTrackApprovalSetting.setState({ editable: _this.state.approvalSettingsEditable });
        });

        _this.onStatePropertyChanged('workScheduleEditable', function (editable) {
            _this.accountSettingsTab.workSchedule.setState({ readOnly: !editable });
        });

        _this.onStatePropertyChanged('overtimeSettingsEditable', function (editable) {
            if (!!_this.accountSettingsTab.overtime) _this.accountSettingsTab.overtime.setState({ readOnly: !editable });
        });

        _this.onAnyStatePropertyChanged(['permissionsEditable', 'teamScopeEditable', 'manageScopeEditable'], function () {
            _this.permissionsTab.setState({
                permissionsReadOnly: !_this.state.permissionsEditable,
                teamScopeReadOnly: !_this.state.teamScopeEditable,
                manageScopeReadOnly: !_this.state.manageScopeEditable
            });
        });

        _this.onStatePropertyChanged('hasRightsToDeleteUser', function (hasRightsToDelete) {
            return _this.header.setState({ noRightsToDelete: !hasRightsToDelete });
        });

        _this.onStateChanged(function () {
            _this.userPanelContentWrapper.forceUpdate();
        });
        return _this;
    }

    _createClass(UserPanelContainer, [{
        key: "templateHtml",
        value: function templateHtml() {
            return '<div class="userPanelContainer">' + '    <div class="panelHeader"/>' + '    <div class="panelContent"/>' + '    <div class="panelFooter"/>' + '</div>';
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            var _this2 = this;

            this.$header = this.find('.panelHeader');
            this.$footer = this.find('.panelFooter');

            this.userGroupRow = this._createUserGroupRowComponent();
            this.timeZoneGroupRow = this._createTimeZoneGroupRowComponent();

            this.accountSettingsTab = new _AccountSettings2.default({
                wrapperId: this.params.accountSettingsId,
                mode: this.params.mode,
                userGroupRow: this.userGroupRow,
                timeZoneGroupRow: this.timeZoneGroupRow,
                onInitialScheduleChanged: this.actions.updateInitialUserSchedule,
                onWorkScheduleChanged: this.actions.updateUserSchedules,
                onDefaultWorkStatusesChanged: this.actions.updateDefaultWorkStatuses,
                deleteWorkSchedule: this.actions.deleteUserSchedule,
                addNewSchedule: this.actions.addNewSchedule,
                refreshScrollCb: function refreshScrollCb() {
                    return _this2.userPanelContentWrapper.forceUpdate();
                },
                scrollToElement: function scrollToElement($element) {
                    return _this2.scrollToElementInstant($element);
                },
                scrollToTop: function scrollToTop() {
                    return _this2.scrollToTop();
                },
                restoreState: this.actions.restoreState
            });

            this.permissionsTab = new _Permissions2.default(null, {
                onTeamAssignmentsCellClick: this._handleTeamAssignmentsPanelVisibility,
                onManagementAssignmentsCellClick: this._handleManagementAssignmentsCellClick
            });
            this.permissionsTab.setState({
                isUGREnabled: this.state.isUGREnabled
            });

            this.userPanelContent = new _UserPanelContent2.default({
                $headerTabs: {
                    $accountSettingsTab: this.header.$accountSettingsTab,
                    $permissionsTab: this.header.$permissionsTab
                },
                accountSettings: this.accountSettingsTab,
                permissions: this.permissionsTab,
                tabSwitchedCallback: function tabSwitchedCallback(tabKey) {
                    return _this2.actions.switchTab(tabKey);
                }
            });

            this.userPanelContentWrapper = new _ScrollableContainer2.default(null, this.userPanelContent, {
                containerClass: "userPanelContent",
                iScrollParams: {
                    probeType: 2
                },
                onScrollCb: function onScrollCb() {
                    _this2.userPanelContent.onScroll();
                },
                ignoreScrollingPredicate: function ignoreScrollingPredicate(e) {
                    return (0, _atBrowserUtils.checkElementOrAncestorHasClass)(e.target, _constants4.AtNextCustomScrollbarUsedClassName);
                }
            });
            this.userPanelContentWrapper.init(this.find('.panelContent'));

            this.permissionsTemplatesButtonController = new _PermissionsTemplatesButtonController2.default({
                $containerEl: this.permissionsTab.$templatePanel,
                $button: this.permissionsTab.permissionsBlock.$permissionTemplatesMenuButton,
                withoutChoosing: false,
                onChangeDialogVisibility: this._handleChangePermissionsDialogVisibility,
                onChangeTemplates: this._handleChangePermissionsTemplates
            }).init();

            this.subscribeForEvents();

            this.registerChildComponents(this.accountSettingsTab, this.permissionsTab, this.userPanelContent);
        }
    }, {
        key: "adjustSize",
        value: function adjustSize() {
            this.userPanelContentWrapper.forceUpdate();
        }
    }, {
        key: "scrollToTop",
        value: function scrollToTop() {
            this.userPanelContentWrapper.scrollToTop();
        }
    }, {
        key: "scrollToElement",
        value: function scrollToElement($element) {
            this.userPanelContentWrapper.scrollToElementVertical($element, {
                pos: _ScrollUtils2.default.POSITIONS.TOP
            }, 800);
        }
    }, {
        key: "scrollToElementInstant",
        value: function scrollToElementInstant($element) {
            this.userPanelContentWrapper.scrollToElementVertical($element, {
                pos: _ScrollUtils2.default.POSITIONS.TOP
            }, 0);
        }
    }, {
        key: "scrollToError",
        value: function scrollToError(providerErrors) {
            if (!_jquery2.default.isEmptyObject(providerErrors)) {
                var maxPriority = 0;
                var maxPriorityError = '';
                for (var error in providerErrors) {
                    var errorClass = _constants2.ValidationErrorsToScrollClasses[error];
                    if (!errorClass) {
                        console.warn("No scroll class for error ", error, " -> skip");
                        continue;
                    }
                    var nextPriority = _constants2.ValidationErrorsScrollClassesPriority[errorClass];
                    if (nextPriority > maxPriority) {
                        maxPriority = nextPriority;
                        maxPriorityError = errorClass;
                    }
                }
                this.scrollToElement(this.userPanelContent.find("." + maxPriorityError));
            }
        }
    }, {
        key: "show",
        value: function show() {
            _get(UserPanelContainer.prototype.__proto__ || Object.getPrototypeOf(UserPanelContainer.prototype), "show", this).call(this);
            this.userPanelContentWrapper.forceUpdate();
        }
    }, {
        key: "_onChangePermissions",
        value: function _onChangePermissions(rights, editUserIsLoggedIn) {
            // cannot remove manage users permission from yourself
            var canManageUsers = rights.indexOf(_constants.AccessRights.MANAGE_USERS) === -1;
            if (editUserIsLoggedIn && canManageUsers) {
                rights.push(_constants.AccessRights.MANAGE_USERS);
            }
            this.actions.updateUserRights(rights, false);
        }
    }, {
        key: "subscribeForEvents",
        value: function subscribeForEvents() {
            var _this3 = this;

            var accountInformation = this.accountSettingsTab.accountInformation;
            accountInformation.on('changeFirstName', function (e, newName) {
                _this3.actions.updateFirstName(newName);
            });

            accountInformation.on('changeLastName', function (e, newName) {
                _this3.actions.updateLastName(newName);
            });

            accountInformation.on('changeMiddleName', function (e, newName) {
                _this3.actions.updateMiddleName(newName);
            });

            accountInformation.on('changeEmail', function (e, email) {
                _this3.actions.updateEmail(email);
            });

            var timetrackApprovalSetting = this.accountSettingsTab.timeTrackApprovalSetting;

            accountInformation.on('changeUsername', function (e, username, duplicateError) {
                _this3.actions.updateUserName(username, duplicateError);
            });

            accountInformation.on('changePassword', function (e, password, retypedPassword, isPasswordChanged, isPasswordCopyChanged) {
                _this3.actions.updatePassword(password, retypedPassword, isPasswordChanged, isPasswordCopyChanged);
            });

            accountInformation.on('changeHireDate', function (e, hireDate, needToRemoveDataHandler) {
                var forceUpdate = false;
                _this3.actions.updateHireDate(hireDate, forceUpdate, needToRemoveDataHandler);
            });

            accountInformation.on('forceChangeHireDate', function (e, hireDate) {
                var forceUpdate = true;
                _this3.actions.updateHireDate(hireDate, forceUpdate);
            });

            accountInformation.on('setHasLeavesOrTTBeforeNewHireDateError', function (e, hasLeavesOrTTBeforeNewHireDateError) {
                _this3.actions.setHasLeavesOrTTBeforeNewHireDateError(hasLeavesOrTTBeforeNewHireDateError);
            });

            accountInformation.on('changeReleaseDate', function (e, releaseDate) {
                _this3.actions.updateReleaseDate(releaseDate);
            });

            timetrackApprovalSetting.on('changeApprovalState', function (e, needApproval) {
                _this3.actions.updateRequireApproval(needApproval);
            });

            var overtime = this.accountSettingsTab.overtime;
            if (overtime) {
                overtime.on('changeOvertime', function (e, overtimeLevel) {
                    _this3.actions.updateOvertime(overtimeLevel);
                });
            }

            this.permissionsTab.permissionsBlock.on('permissionsChanged', function (e, rights, userLoggedIn) {
                return _this3._onChangePermissions(rights, userLoggedIn);
            });

            new _PermissionsDescriptionLightBox2.default({
                onClickDialogContent: function onClickDialogContent(e) {
                    return (0, _utils2.setEventPreventHidingEditUserSlidingPanel)(e);
                }
            }).init(this.permissionsTab.$permissionsInfoButton);

            (0, _jquery2.default)(this.permissionsTemplatesButtonController).on('applyTemplate', function (e, rights, userLoggedIn) {
                return _this3._onChangePermissions(rights, userLoggedIn);
            });
        }
    }, {
        key: "_onFullUserInfoChanged",
        value: function _onFullUserInfoChanged(fullUserInfo) {
            this.header.setState(_extends({}, fullUserInfo, {
                loggedIn: fullUserInfo.id ? fullUserInfo.id === this.state.loggedInUserId : false
            }));

            this.accountSettingsTab.accountInformation.setState(_extends({}, fullUserInfo, {
                editUserIsLoggedIn: this.state.loggedInUserId === fullUserInfo.id,
                userId: fullUserInfo.id
            }));

            this.accountSettingsTab.workSchedule.setState({
                accountSettings: fullUserInfo,
                userManagementData: this.state.userManagementData,
                currentTime: this.state.extendedData.currentTime
            });

            if (this.accountSettingsTab.overtime) {
                this.accountSettingsTab.overtime.setState({
                    overtimeLevel: fullUserInfo.overtimeLevel
                });
            }

            var groupId = fullUserInfo.userGroupId;
            var isUGREnabled = this.state.isUGREnabled;

            var nameGroup = '';
            if (groupId !== _constants2.GROUP_NEW_OR_NOT_KNOWN && groupId !== _constants.UserManagementConstants.USER_GROUP_NOT_ASSIGNED_ID && isUGREnabled) {
                var group = this.state.allUserGroups.find(function (group) {
                    return group.id === groupId;
                });
                nameGroup = group ? group.name : '';
            }

            this.accountSettingsTab.timeTrackApprovalSetting.setState({
                requiresTTApproval: fullUserInfo.requiresTTApproval,
                nameGroup: nameGroup
            });

            this.permissionsTab.setState({
                editUserIsLoggedIn: fullUserInfo.id ? fullUserInfo.id === this.state.loggedInUserId : false,
                accessRights: fullUserInfo.accessRights,
                manageAssignmentsData: this.state.userManageAssignmentsData,
                teamAssignmentsData: this.state.userTeamAssignmentsData,
                userFirstName: fullUserInfo.firstName
            });

            this.permissionsTemplatesButtonController.setState({
                editUserIsLoggedIn: fullUserInfo.id === this.state.loggedInUserId
            });
        }
    }, {
        key: "_onUserManagementDataChanged",
        value: function _onUserManagementDataChanged(userManagementData) {
            this.accountSettingsTab.accountInformation.setState({
                userManagementData: _extends({}, userManagementData, {
                    userGroups: this.state.allUserGroups,
                    timeZoneGroups: this.state.allTimeZoneGroups
                })
            });

            this.accountSettingsTab.workSchedule.setState({ userManagementData: userManagementData });

            var isUGREnabled = this.state.isUGREnabled;
            var isTTAEnabled = this.state.isTTAEnabled;

            this.accountSettingsTab.timeTrackApprovalSetting.setState({
                isUGREnabled: isUGREnabled,
                isTTAEnabled: isTTAEnabled
            });

            this.permissionsTemplatesButtonController.setState({
                templates: userManagementData.permissionsTemplates
            });
        }
    }, {
        key: "_onUserGroupsChanged",
        value: function _onUserGroupsChanged(userGroups) {
            this.accountSettingsTab.accountInformation.setState({
                userManagementData: _extends({}, this.state.userManagementData, {
                    userGroups: this.state.allUserGroups,
                    timeZoneGroups: this.state.allTimeZoneGroups
                })
            });
            this.userGroupRow.setState({ userGroups: userGroups });
            this.permissionsTab.setState({
                userGroups: (0, _groupUtils.addDefaultUserGroup)(userGroups)
            });
        }
    }, {
        key: "_onTimeZoneGroupsChanged",
        value: function _onTimeZoneGroupsChanged(timeZoneGroups) {
            this.accountSettingsTab.accountInformation.setState({
                userManagementData: _extends({}, this.state.userManagementData, {
                    userGroups: this.state.allUserGroups,
                    timeZoneGroups: this.state.allTimeZoneGroups
                })
            });
            this.timeZoneGroupRow.setState({ timeZoneGroups: timeZoneGroups });
        }
    }, {
        key: "_onUserManageAssignmentsDataChanged",
        value: function _onUserManageAssignmentsDataChanged(userManageAssignmentsData) {
            this.permissionsTab.setState({
                managementAssignmentsSelection: userManageAssignmentsData.managementAssignmentsSelection
            });
        }
    }, {
        key: "_onManagementAssignmentsCountsChanged",
        value: function _onManagementAssignmentsCountsChanged(counts) {
            this.permissionsTab.setState({
                managementAssignmentsCounts: counts
            });
        }
    }, {
        key: "_onUserTeamAssignmentsDataChanged",
        value: function _onUserTeamAssignmentsDataChanged(userTeamAssignmentsData) {
            this.permissionsTab.setState({
                teamAssignmentsData: userTeamAssignmentsData
            });
        }
    }, {
        key: "_onExtendedDataChanged",
        value: function _onExtendedDataChanged(extendedData) {
            this.header.setState({
                lastLoginTime: extendedData.lastLoginTime,
                hasTimeTrack: extendedData.hasTimeTrack,
                lastOtherProductAdmin: extendedData.lastOtherProductAdmin
            });

            var currentTime = extendedData.currentTime;

            this.accountSettingsTab.accountInformation.setState({
                firstTTDate: extendedData.firstTTDate ? Date.parseJSONDate(extendedData.firstTTDate) : null,
                firstRequestDate: extendedData.firstRequestDate ? Date.parseJSONDate(extendedData.firstLeaveRequestDate) : null,
                currentTime: currentTime
            });

            this.accountSettingsTab.workSchedule.setState({
                currentTime: currentTime
            });

            this.permissionsTab.setState({
                isAllowedToSeeAllUsersTT: this.state.extendedData.isAllowedToSeeAllUsersTT ? this.state.extendedData.isAllowedToSeeAllUsersTT : false
            });
        }
    }, {
        key: "_createUserGroupRowComponent",
        value: function _createUserGroupRowComponent() {
            // abstract
        }
    }, {
        key: "_createTimeZoneGroupRowComponent",
        value: function _createTimeZoneGroupRowComponent() {
            // abstract
        }
    }]);

    return UserPanelContainer;
}(_TemplateView3.default);

exports.default = UserPanelContainer;

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = CSVParametersBuilder;

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _constants = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CSVParametersBuilder() {}

CSVParametersBuilder.prototype.init = function () {
    this.parameters = [];
    return this;
};

CSVParametersBuilder.prototype.addDateRangeParam = function (dateRangeSelection, reportParamsStringBuilder) {
    this.parameters.push([_messageResource2.default.getMessage("report.date_range_label"), reportParamsStringBuilder.getDateRangeCSVString(dateRangeSelection)]);
};

CSVParametersBuilder.prototype.addCPParam = function (customersProjectsSelection, reportParamsStringBuilder) {
    this.parameters.push([_messageResource2.default.getMessage("report.customers_projects_label"), reportParamsStringBuilder.getCPSelectionParamString(customersProjectsSelection)]);
};

CSVParametersBuilder.prototype.addUsersParam = function (userSelection, reportParamsStringBuilder, assignedInfo) {
    this.parameters.push([_messageResource2.default.getMessage("report.staff_label"), reportParamsStringBuilder.getUserSelectionParamString(userSelection, assignedInfo)]);
};

CSVParametersBuilder.prototype.addOvertimeUsersParam = function (userSelection, reportParamsStringBuilder) {
    this.parameters.push([_messageResource2.default.getMessage("report.staff_label"), reportParamsStringBuilder.getUserSelectionParamString(userSelection)]);
};

CSVParametersBuilder.prototype.addTimeTrackStatusParam = function (timeTrackStatus) {
    var textStatus = void 0;
    switch (timeTrackStatus) {
        case _constants.TimeApprovalStatus.APPROVED:
            textStatus = _messageResource2.default.getMessage("report.form.show_only_approved");break;
        case _constants.TimeApprovalStatus.NOT_APPROVED:
            textStatus = _messageResource2.default.getMessage("report.form.show_only_not_approved");break;
        default:
            textStatus = _messageResource2.default.getMessage("report.form.show_both_approved_and_not");
    }
    this.parameters.push([_messageResource2.default.getMessage("report.time_track_status") + ":", textStatus]);
};

CSVParametersBuilder.prototype.addBillingSummaryReportTypeParam = function (reportType) {
    var reportTypeMsgKey = reportType === BillingReportType.ALL_TIME_WITHIN_DATE_RANGE ? "report.billing_summary.time_for_date_range" : "report.billing_summary.time_task_completed_for_date_range";
    this.parameters.push([_messageResource2.default.getMessage("report.billing_summary.report_type_label"), _messageResource2.default.getMessage(reportTypeMsgKey)]);
};

CSVParametersBuilder.prototype.addBillingSummaryTasksParam = function (reportInfo) {
    var reportInfoMsgKey = "";
    if (reportInfo === _constants.BillingSummaryReportInfo.TIME_ON_NON_BILLABLE_TASKS) reportInfoMsgKey = "report.billing_summary.non_billable_only";else if (reportInfo === _constants.BillingSummaryReportInfo.TIME_ON_BOTH_BILLABLE_AND_NON_BILLABLE_TASKS) reportInfoMsgKey = "report.billing_summary.billable_nonbillable";else reportInfoMsgKey = "report.billing_summary.billable_only";
    this.parameters.push([_messageResource2.default.getMessage("common.Tasks") + ":", _messageResource2.default.getMessage(reportInfoMsgKey)]);
};

CSVParametersBuilder.prototype.addLeavesParam = function (leaveTypesSelection, reportParamsStringBuilder) {
    this.parameters.push([_messageResource2.default.getMessage("report.leave_types.label"), reportParamsStringBuilder.getLeaveTypeSelectionParamString(leaveTypesSelection)]);
};

CSVParametersBuilder.prototype.addEvATasksParam = function (taskParams, dateSelection, reportParamsStringBuilder) {
    this.parameters.push([_messageResource2.default.getMessage("report.budgeted_vs_actual.tasks"), reportParamsStringBuilder.getEvATaskDetailsString(taskParams, dateSelection)]);
};

CSVParametersBuilder.prototype.getParameters = function () {
    return this.parameters;
};

/***/ }),
/* 151 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__(41)('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(87)(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.3.6 Object.prototype.toString()
var classof = __webpack_require__(328);
var test = {};
test[__webpack_require__(41)('toStringTag')] = 'z';
if (test + '' != '[object z]') {
  __webpack_require__(74)(Object.prototype, 'toString', function toString() {
    return '[object ' + classof(this) + ']';
  }, true);
}


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(174)('meta');
var isObject = __webpack_require__(31);
var has = __webpack_require__(75);
var setDesc = __webpack_require__(46).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(32)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__(644);


/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */] || freeSelf || Function('return this')();

/* harmony default export */ __webpack_exports__["a"] = (root);


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _atUtils = __webpack_require__(5);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _CustomerStore = __webpack_require__(65);

var _CustomerStore2 = _interopRequireDefault(_CustomerStore);

var _ProjectStore = __webpack_require__(59);

var _ProjectStore2 = _interopRequireDefault(_ProjectStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Represents customer/project selection, which is widely used in reports and filters.
 * @Deprecated contains usages of old entities store
 */
var CustomerProjectSelection = function () {
    /**
     * @param {String} [qualifier] Selection qualifier, can be "ALL", "ALL_ACTIVE" or "SELECTED" (see CustomerProjectSelection.Qualifier enum). Defaults to "ALL".
     * @param {Array} [customers] IDs of selected customers. Ignored if 'qualifier' param is "ALL" or "ALL_ACTIVE".
     * @param {Array} [projects] IDs of selected projects. Ignored if 'qualifier' param is "ALL" or "ALL_ACTIVE".
     * @param {Boolean} [activeOnly] Indicates if selection should only include active entities (NB! inactive entities will not count even if they are specified in customers/projects arrays!)
     */
    function CustomerProjectSelection(qualifier, customers, projects) {
        var activeOnly = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

        _classCallCheck(this, CustomerProjectSelection);

        this.qualifier = qualifier || CustomerProjectSelection.Qualifier.ALL;

        this._all = this.qualifier === CustomerProjectSelection.Qualifier.ALL || this.qualifier === CustomerProjectSelection.Qualifier.ALL_ACTIVE;
        this.activeOnly = this.qualifier === CustomerProjectSelection.Qualifier.ALL_ACTIVE || activeOnly;

        if (!this._all) {
            this.customers = customers || [];
            this.projects = projects || [];
        } else {
            this.customers = [];
            this.projects = [];
        }

        this._customersSet = (0, _atUtils.arrayToSet)(this.customers);
        this._projectsSet = (0, _atUtils.arrayToSet)(this.projects);
    }

    /**
     * Makes selection instance converting it from plain object form, commonly used in project.
     * @param {Object} cpSelectionObject
     * @param {String} cpSelectionObject.qualifier Selection qualifier.
     * @param {Array} cpSelectionObject.customers IDs of selected customers.
     * @param {Array} cpSelectionObject.projects IDs of selected projects.
     * @returns {CustomerProjectSelection}
     */


    _createClass(CustomerProjectSelection, [{
        key: "includesCustomer",


        /**
         * Determines if customer is included in this selection.
         * @param {Customer} customer
         * @param {boolean} [transitive]
         * @returns {boolean}
         */
        value: function includesCustomer(customer) {
            var _this = this;

            var transitive = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            if (!customer) return false;
            if (this.activeOnly && customer.archived) return false;else if (this._all) return true;else return !!this._customersSet[customer.id] || transitive && _underscore2.default.any(_ProjectStore2.default.getByCustomer(customer.id), function (p) {
                return _this.includesProject(p);
            });
        }

        /**
         * Determines if project is included in this selection.
         * @param {Project} project
         * @returns {boolean}
         */

    }, {
        key: "includesProject",
        value: function includesProject(project) {
            if (!project) return false;
            if (this.activeOnly && project.archived) return false;else if (this._all) return true;else return !!this._projectsSet[project.id] || !!this._customersSet[project.customerId];
        }

        /**
         * Determines if this selection is empty and thus guaranteed to not include any customer/project
         * (i.e. has "SELECTED" qualifier and doesn't specify any customer/project ID).
         * @returns {boolean}
         */

    }, {
        key: "isEmpty",
        value: function isEmpty() {
            return !this._all && this.customers.length === 0 && this.projects.length === 0;
        }

        /**
         * Determines if this selection is equal to another.
         * @param {CustomerProjectSelection} otherSelection
         * @return {boolean}
         */

    }, {
        key: "equals",
        value: function equals(otherSelection) {
            var _this2 = this;

            if (otherSelection && this.qualifier === otherSelection.qualifier) {
                return this === otherSelection || this._all || this.customers.length === otherSelection.customers.length && _underscore2.default.all(otherSelection.customers, function (c) {
                    return _this2._customersSet[c];
                }) && this.projects.length === otherSelection.projects.length && _underscore2.default.all(otherSelection.projects, function (p) {
                    return _this2._projectsSet[p];
                });
            }

            return false;
        }

        /**
         * Intersects this selection with other, returning selection, which only includes customers/projects from both.
         * @param {CustomerProjectSelection} otherSelection
         * @returns {CustomerProjectSelection}
         */

    }, {
        key: "intersect",
        value: function intersect(otherSelection) {
            var _this3 = this;

            var intersectionQualifier = void 0;
            if (this.qualifier === CustomerProjectSelection.Qualifier.ALL) {
                intersectionQualifier = otherSelection.qualifier;
            } else if (this.qualifier === CustomerProjectSelection.Qualifier.ALL_ACTIVE) {
                if (otherSelection.qualifier === CustomerProjectSelection.Qualifier.ALL) intersectionQualifier = this.qualifier;else intersectionQualifier = otherSelection.qualifier;
            } else if (this.qualifier === CustomerProjectSelection.Qualifier.SELECTED) {
                intersectionQualifier = this.qualifier;
            }

            var intersectionCustomersSet = {};
            this.customers.forEach(function (customerId) {
                var customer = _CustomerStore2.default.get(customerId);
                if (customer && otherSelection.includesProject(customer)) intersectionCustomersSet[customer.id] = true;
            });
            otherSelection.customers.forEach(function (customerId) {
                var customer = _CustomerStore2.default.get(customerId);
                if (customer && _this3.includesCustomer(customer)) intersectionCustomersSet[customer.id] = true;
            });
            var intersectionCustomers = _underscore2.default.keys(intersectionCustomersSet);

            var intersectionProjectsSet = {};
            this.projects.forEach(function (projectId) {
                var project = _ProjectStore2.default.get(projectId);
                if (project && otherSelection.includesProject(project)) intersectionProjectsSet[projectId] = true;
            });
            otherSelection.projects.forEach(function (projectId) {
                var project = _ProjectStore2.default.get(projectId);
                if (project && _this3.includesProject(project)) intersectionProjectsSet[projectId] = true;
            });
            var intersectionProjects = _underscore2.default.keys(intersectionProjectsSet);

            var intersectionActiveOnly = this.activeOnly || otherSelection.activeOnly;

            return new CustomerProjectSelection(intersectionQualifier, intersectionCustomers, intersectionProjects, intersectionActiveOnly);
        }
    }, {
        key: "toPlainObject",
        value: function toPlainObject() {
            return {
                qualifier: this.qualifier,
                activeOnly: this.activeOnly,
                customers: this.customers,
                projects: this.projects
            };
        }
    }], [{
        key: "fromPlainObject",
        value: function fromPlainObject(cpSelectionObject) {
            return new CustomerProjectSelection(cpSelectionObject.qualifier, cpSelectionObject.customers, cpSelectionObject.projects);
        }
    }]);

    return CustomerProjectSelection;
}();

/**
 * Enums customer/project selection qualifiers.
 */


exports.default = CustomerProjectSelection;
CustomerProjectSelection.Qualifier = {
    ALL: "ALL",
    ALL_ACTIVE: "ALL_ACTIVE",
    SELECTED: "SELECTED"
};

/**
 * Instance of customer/project selection with "ALL" qualifier.
 * @type {CustomerProjectSelection}
 */
CustomerProjectSelection.ALL = new CustomerProjectSelection();

/**
 * Instance of customer/project selection with "ALL_ACTIVE" qualifier.
 * @type {CustomerProjectSelection}
 */
CustomerProjectSelection.ALL_ACTIVE = new CustomerProjectSelection(CustomerProjectSelection.Qualifier.ALL_ACTIVE);

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var ErrorsExceptions = exports.ErrorsExceptions = {
    TASK_NAME_DUPLICATE: 'com.actimind.actitime.task.TaskExistsException',
    PROJECT_REMOVED: 'com.actimind.actitime.project.NoSuchProjectException',
    PROJECT_ARCHIVED: 'com.actimind.actitime.project.ProjectArchivedException',
    CUSTOMER_REMOVED: 'com.actimind.actitime.customer.NoSuchCustomerException',
    BILLING_TYPE_REMOVED: 'com.actimind.actitime.administration.NoSuchATTypeException'
};

var Methods = exports.Methods = {
    STATUS: "EditTaskService.updateTaskStatus",
    WORKFLOW_STATUS: 'EditTaskService.updateTaskWorkflowStatus',
    ESTIMATED_TIME: "EditTaskService.updateTaskEstimatedTime",
    DEADLINE: "EditTaskService.updateTaskDeadline",
    BILLING_TYPE: "EditTaskService.updateBillingType",
    NAME: "EditTaskService.updateTaskName",
    DESCRIPTION: "EditTaskService.updateTaskDescription",
    TIME_COMMENTS: "EditTaskService.getTimeComments",
    SAVE_SETTINGS: "EditTaskService.saveTimeCommentSettings",
    MOVE_TASK: "EditTaskService.moveTask",
    COPY_TASK: "EditTaskService.copyTask",
    DELETE_TASK: "EditTaskService.deleteTaskFromPanel",
    GET_LAST_AUDIT_INFO: "EditTaskService.getLastAuditActionsInfo",
    GET_AUDIT_RECORDS: "EditTaskService.getAuditActions",
    LOAD_EDIT_TASK_PANEL: "EditTaskService.loadEditTaskPanel",
    LOAD_CREATE_TASK_PANEL: "EditTaskService.loadCreateTaskPanel",
    CREATE_TASK: "EditTaskService.createTask"
};

var ResultCodes = exports.ResultCodes = window.__GENERATED_CONSTANTS__.EditTaskServiceResultCodes;

var REPORTED_TIME_COMMENTS_RECORDS_LIMIT = exports.REPORTED_TIME_COMMENTS_RECORDS_LIMIT = 20;

var ReportedTimeSortConstants = exports.ReportedTimeSortConstants = {
    BY_DATE: "date",
    BY_USER: "user",
    ASC: "Asc",
    DESC: "Desc"
};

var ValidationErrors = exports.ValidationErrors = {
    TASK_NAME_DUPLICATE: "taskNameDuplicate",
    TASK_NAME_EMPTY: "taskNameIsEmpty"
};

var TasksTabs = exports.TasksTabs = {
    DETAILS_TAB: 'details',
    REPORTED_TAB: 'reportedTime',
    ASSIGNED_USERS_TAB: 'assignedUsers',
    MANAGERS_TAB: 'managers',
    BUDGETS: 'budgets'
};

var TaskDialogs = exports.TaskDialogs = {
    MOVE_DIALOG: 'move',
    COPY_DIALOG: 'copy',
    DELETE_DIALOG: 'delete'
};

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Group = function () {
    function Group(id, name) {
        _classCallCheck(this, Group);

        this.id = id;
        this.name = name;
    }

    _createClass(Group, [{
        key: "getId",
        value: function getId() {
            return this.id;
        }
    }, {
        key: "getName",
        value: function getName() {
            return this.name;
        }
    }, {
        key: "clone",
        value: function clone() {
            return new Group(this.id, this.name);
        }
    }]);

    return Group;
}();

exports.default = Group;

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Ext = __webpack_require__(12);

var _Ext2 = _interopRequireDefault(_Ext);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _atBrowserUtils = __webpack_require__(8);

var _AtMap = __webpack_require__(728);

var _AtMap2 = _interopRequireDefault(_AtMap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SharedUserButtonMenu = _Ext2.default.extend(_Ext2.default.menu.Menu, {
    cls: "at-selector-menu",

    constructor: function constructor(_ref) {
        var panel = _ref.panel,
            additionalCls = _ref.additionalCls,
            _ref$disableClickBubb = _ref.disableClickBubble,
            disableClickBubble = _ref$disableClickBubb === undefined ? true : _ref$disableClickBubb,
            _ref$parentEl = _ref.parentEl,
            parentEl = _ref$parentEl === undefined ? null : _ref$parentEl;

        this.panel = panel;
        this.disableClickBubble = disableClickBubble;
        this.parentEl = parentEl;
        if (additionalCls) {
            this.cls += " " + additionalCls;
        }
        this.shadow = false;
        SharedUserButtonMenu.superclass.constructor.call(this, { items: [panel] });
        this.panel.on("close", this.hide, this);
    },

    show: function show(el, pos, parentMenu) {
        // we need to render the panel before calling of this.panel.showCallback(), since it may
        // need to update its content.
        if (!this.el) this.render();

        if (this.disableClickBubble) (0, _jquery2.default)(this.el.dom).off('click').on('click', function (e) {
            return e.stopPropagation();
        });

        if (this.panel.showCallback) this.panel.showCallback();

        SharedUserButtonMenu.superclass.show.call(this, el, pos, parentMenu);

        var diff = this.el.getBottom() - ((0, _atBrowserUtils.getBodyScrollTop)() + document.body.clientHeight);
        if (diff > 0) {
            _Ext2.default.getBody().scroll("down", diff);
        }
    },

    getSelectorPanel: function getSelectorPanel() {
        return this.panel;
    },

    hide: function hide() {
        if (this.panel.processHide()) {
            SharedUserButtonMenu.superclass.hide.call(this);
        }
    },

    /*
    following functionality is for reusing one instance of the panel
    for multiple controls
     */
    currentParentId: null,
    states: new _AtMap2.default(),

    setStateFor: function setStateFor(parent, state) {
        this.setCurrentParent(parent);
        this.panel.loadState(state);
    },

    switchState: function switchState(parentId, noSwitchState) {
        if (!noSwitchState) {
            if (this.currentParentId != null) this.states.put(this.currentParentId, this.panel.getState());
            if (!this.states.get(parentId)) this.states.put(parentId, this.panel.createDefaultState(parentId));
        }
        this.currentParentId = parentId;
        if (!noSwitchState) this.panel.loadState(this.states.get(parentId));
    },

    setCurrentParent: function setCurrentParent(parent, noSwitchState) {
        var parentId = parent.id;
        if (this.currentParentId != parentId) this.switchState(parentId, noSwitchState);
    },

    isCurrentParent: function isCurrentParent(toCheck) {
        return this.currentParentId == toCheck.id;
    },

    makeHandlerForSpecificParent: function makeHandlerForSpecificParent(parent, callback) {
        var self = this;
        return function () {
            if (self.isCurrentParent(parent)) return callback.apply(this, arguments);
        };
    }
});

exports.default = SharedUserButtonMenu;

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isAborted = exports.map = undefined;

var _RpcError = __webpack_require__(281);

var _RpcError2 = _interopRequireDefault(_RpcError);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var JABSORB_JAVA_CLASS_FIELD = 'javaClass';
var JAVA_MAP = 'java.util.Map';

/**
 * Wrap simple key value object to sent via rpc for service java.util.Map parameter
 * */
var map = exports.map = function map(obj) {
    var _ref;

    return _ref = {}, _defineProperty(_ref, JABSORB_JAVA_CLASS_FIELD, JAVA_MAP), _defineProperty(_ref, 'map', obj), _ref;
};

var isAborted = exports.isAborted = function isAborted(error) {
    return error instanceof _RpcError2.default && error.getTextStatus() === 'abort';
};

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.afterTaskListExportRequestFailed = exports.exportErrorEvent = exports.afterImportTasksSuccess = exports.importTasksSuccessEvent = exports.setEditableCustomerIds = exports.setEditableProjectIds = exports.removeTasks = exports.addTasks = exports.afterUpdateTaskStatusAndPositionCb = exports.afterProjectCustomerStatusChangeCb = exports.afterBulkTasksStatusChangeCb = exports.afterBulkTasksMovedToCb = exports.afterBulkChangeTasksAssignmentsCb = exports.afterChangeStatusFilterSelection = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*
                                                                                                                                                                                                                                                                     file contains functions that used from redux actions and perform operations for synchronise data with old components/stores
                                                                                                                                                                                                                                                                   */


var _TaskStore = __webpack_require__(91);

var _TaskStore2 = _interopRequireDefault(_TaskStore);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _constants = __webpack_require__(23);

var _TaskManagementStore = __webpack_require__(140);

var _TaskManagementStore2 = _interopRequireDefault(_TaskManagementStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var afterChangeStatusFilterSelection = exports.afterChangeStatusFilterSelection = function afterChangeStatusFilterSelection(filter) {
    (0, _jquery2.default)(document).trigger('taskManagement_tasksTable_statusFilterChange', [filter]);
};

var afterBulkChangeTasksAssignmentsCb = exports.afterBulkChangeTasksAssignmentsCb = function afterBulkChangeTasksAssignmentsCb(data) {
    (0, _jquery2.default)(document).trigger("taskManagement_tasksAssignedTo", data);
};

var afterBulkTasksMovedToCb = exports.afterBulkTasksMovedToCb = function afterBulkTasksMovedToCb() {
    (0, _jquery2.default)(document).trigger("taskManagement_tasksMovedTo");
};

var afterBulkTasksStatusChangeCb = exports.afterBulkTasksStatusChangeCb = function afterBulkTasksStatusChangeCb() {
    (0, _jquery2.default)(document).trigger("taskManagement_tasksStatusChanged");
};

var afterProjectCustomerStatusChangeCb = exports.afterProjectCustomerStatusChangeCb = function afterProjectCustomerStatusChangeCb() {
    (0, _jquery2.default)(document).trigger("taskManagement_projectCustomerStatusChanged");
};

var updateTaskInStore = function updateTaskInStore(taskId, updatedData) {
    var task = _TaskStore2.default.get(taskId);
    if (task) {
        task = _extends({}, task, updatedData);
        _TaskStore2.default.add(task);
    }
};

var afterUpdateTaskStatusAndPositionCb = exports.afterUpdateTaskStatusAndPositionCb = function afterUpdateTaskStatusAndPositionCb(taskId, projectId, workflowStatus) {
    var completed = workflowStatus.type === _constants.WorkflowStatusType.COMPLETED;

    updateTaskInStore(taskId, {
        workflowStatusId: workflowStatus.id,
        completed: completed,
        projectId: projectId
    });

    var result = {
        taskIds: [taskId],
        workflowStatusId: workflowStatus.id,
        isCompleted: completed
    };

    (0, _jquery2.default)(document).trigger("taskManagement_tasksStatusChange", result);
};

var addTasks = exports.addTasks = function addTasks(tasks) {
    _TaskStore2.default.mergeAll(tasks);
};

var removeTasks = exports.removeTasks = function removeTasks(taskIds) {
    _TaskStore2.default.removeMany(taskIds);
    _TaskManagementStore2.default.removeTasks(taskIds);
    (0, _jquery2.default)(document).trigger("taskManagement_removeTasks", [taskIds]);
};

var setEditableProjectIds = exports.setEditableProjectIds = function setEditableProjectIds(editableProjectIds) {
    _TaskManagementStore2.default.setEditableProjectIds(editableProjectIds);
};

var setEditableCustomerIds = exports.setEditableCustomerIds = function setEditableCustomerIds(editableCustomerIds) {
    _TaskManagementStore2.default.setEditableCustomerIds(editableCustomerIds);
};

var importTasksSuccessEvent = exports.importTasksSuccessEvent = "taskManagement_import_tasks_success";
var afterImportTasksSuccess = exports.afterImportTasksSuccess = function afterImportTasksSuccess() {
    (0, _jquery2.default)(document).trigger(importTasksSuccessEvent);
};

var exportErrorEvent = exports.exportErrorEvent = "taskManagement_export_error";

var afterTaskListExportRequestFailed = exports.afterTaskListExportRequestFailed = function afterTaskListExportRequestFailed(err) {
    (0, _jquery2.default)(document).trigger(exportErrorEvent, [err]);
};

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Ext = __webpack_require__(12);

var _Ext2 = _interopRequireDefault(_Ext);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _at_hierarchical_selector_panel = __webpack_require__(735);

var _at_hierarchical_selector_panel2 = _interopRequireDefault(_at_hierarchical_selector_panel);

var _TreeNode = __webpack_require__(60);

var _TreeNode2 = _interopRequireDefault(_TreeNode);

var _TreeRootNode = __webpack_require__(354);

var _TreeRootNode2 = _interopRequireDefault(_TreeRootNode);

var _GroupType = __webpack_require__(34);

var _GroupType2 = _interopRequireDefault(_GroupType);

var _at_group_selector_switcher = __webpack_require__(373);

var _at_group_selector_switcher2 = _interopRequireDefault(_at_group_selector_switcher);

var _StringIndex = __webpack_require__(115);

var _StringIndex2 = _interopRequireDefault(_StringIndex);

var _TreeNodeSet = __webpack_require__(79);

var _TreeNodeSet2 = _interopRequireDefault(_TreeNodeSet);

var _two_level_selection = __webpack_require__(70);

var _two_level_selection2 = _interopRequireDefault(_two_level_selection);

var _ShowUserGroupsStrategy = __webpack_require__(356);

var _ShowUserGroupsStrategy2 = _interopRequireDefault(_ShowUserGroupsStrategy);

var _HideUserGroupsStrategy = __webpack_require__(480);

var _HideUserGroupsStrategy2 = _interopRequireDefault(_HideUserGroupsStrategy);

var _atUtils = __webpack_require__(5);

var _atBrowserUtils = __webpack_require__(8);

var _user_group_selector_util = __webpack_require__(98);

var _UserSelectorTreeBuilderObserver = __webpack_require__(481);

var _UserSelectorTreeBuilderObserver2 = _interopRequireDefault(_UserSelectorTreeBuilderObserver);

var _simple_users_and_groups_selection_helper = __webpack_require__(374);

var _simple_users_and_groups_selection_helper2 = _interopRequireDefault(_simple_users_and_groups_selection_helper);

var _UserGroupNodeRenderer = __webpack_require__(238);

var _UserGroupNodeRenderer2 = _interopRequireDefault(_UserGroupNodeRenderer);

var _TimeZoneGroupNodeRenderer = __webpack_require__(746);

var _TimeZoneGroupNodeRenderer2 = _interopRequireDefault(_TimeZoneGroupNodeRenderer);

var _UserSelectorEmptyMessageBuilder = __webpack_require__(358);

var _UserSelectorEmptyMessageBuilder2 = _interopRequireDefault(_UserSelectorEmptyMessageBuilder);

var _UserNodeRenderer = __webpack_require__(357);

var _UserNodeRenderer2 = _interopRequireDefault(_UserNodeRenderer);

var _DisabledUsersParentNodeRenderer = __webpack_require__(776);

var _DisabledUsersParentNodeRenderer2 = _interopRequireDefault(_DisabledUsersParentNodeRenderer);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _Switcher = __webpack_require__(236);

var _Switcher2 = _interopRequireDefault(_Switcher);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Selector panel for the users list.
 *
 * Depends on:
 * <code>/js/selectorControls/at_generic_selector_panel.js</code>
 * <code>/js/controls/selectorControls/at_tree_node_helper.js</code>
 * <code>/js/controls/selectorControls/at_user_tree_node_helper.js</code>
 * <code>/js/message_resources.js</code> with prefixes "users_selector", "usersselector"
 *
 * @constructor
 */
var UsersSelectorPanel = _Ext2.default.extend(_at_hierarchical_selector_panel2.default, {
    /**
     * @cfg {Boolean} Specifies whether item's email should be checked when item is displayed in the list
     */
    checkEmail: false,

    optionValue: true,

    allItemsOptionValue: true,
    customOptionValue: false,
    /**
     * @cfg {int} maximum length of each item label, the rest of symbols will be truncated. If equal null, the whole
     * name will be shown
     */
    itemLabelMaxLength: null,

    allItemsOptionLabelKey: "users_selector.all_users",
    customOptionLabelKey: "users_selector.selected_users",
    showInactiveLabelKey: "users_selector.show_disabled",

    labelItemNounSingularKey: "users_selector.label.singular",
    labelItemNounPluralKey: "users_selector.label.plural",

    userSelectorGroupsStrategy: null,

    collapsedCookiesKey: "",

    groupBySettingCookieName: "userSelectorGroupBySetting",

    createComponents: function createComponents() {

        this.collapsedUserGroupsCookiesKey = this.collapsedCookiesKey + "CollapsedUserGroups";
        this.collapsedTimeZoneGroupsCookiesKey = this.collapsedCookiesKey + "CollapsedTimeZoneGroups";
        UsersSelectorPanel.superclass.createComponents.call(this);
        this.viewByPanel = new _at_group_selector_switcher2.default();

        var self = this;
        this.selectAllButton.on("click", function () {
            var selectionToProcess = self.groupType == _GroupType2.default.USER_GROUP ? self.timeZoneSelection : self.userGroupSelection;
            if (!selectionToProcess) return;

            for (var i = 0; i < self.users.length; i++) {
                var userId = self.users[i].id;
                if (self.groupType == _GroupType2.default.USER_GROUP) self.addUserIdToSelection(userId, selectionToProcess, _GroupType2.default.TIME_ZONE_GROUP);else self.addUserIdToSelection(userId, selectionToProcess, _GroupType2.default.USER_GROUP);
            }
        });

        this.clearButton.on("click", function () {
            self.clearPreviousSelection();
        });
        this.addClass("user-selector-panel");
    },

    makeSelectionTree: function makeSelectionTree() {
        //do nothing
    },

    getFilterWordsPopupCoordinates: function getFilterWordsPopupCoordinates() {
        return {
            x: 2,
            y: -4
        };
    },

    saveCollapsedNodesIntoCookies: function saveCollapsedNodesIntoCookies() {
        var cookiesKey = this.groupType == _GroupType2.default.USER_GROUP ? this.collapsedUserGroupsCookiesKey : this.collapsedTimeZoneGroupsCookiesKey;
        this.userSelectorGroupsStrategy.saveCollapsedNodesIntoCookies(this.selectorTree, cookiesKey);
    },

    canExpandCollapseNodes: function canExpandCollapseNodes() {
        return this.userSelectorGroupsStrategy.canExpandCollapseNodes();
    },

    getSelection: function getSelection(isFullFormed) {
        return this.userSelectorGroupsStrategy.makeSelectionFromNodeSet(this.getSelectedNodeSet(), isFullFormed, this.mapSelectionGroupsToUsers(), this.getGroupType());
    },

    mapSelectionGroupsToUsers: function mapSelectionGroupsToUsers() {
        return false;
    },

    getGroupType: function getGroupType() {
        return this.isCustomOptionSelected() && this.groupType ? this.groupType : null;
    },

    getTreePanelClasses: function getTreePanelClasses() {
        var classes = UsersSelectorPanel.superclass.getTreePanelClasses.call(this);
        return classes.concat(this.userSelectorGroupsStrategy.getAdditionalTreePanelClasses());
    },

    getOnlyUsersSelection: function getOnlyUsersSelection() {
        return this.userSelectorGroupsStrategy.makeOnlyUsersSelection(this.getSelectedNodeSet());
    },

    getAllSelectedUsers: function getAllSelectedUsers() {
        return this.userSelectorGroupsStrategy.makeAllSelectedUsersSelection(this.getSelectedNodeSet());
    },

    makeNodeSet: function makeNodeSet(selection) {
        return this.userSelectorGroupsStrategy.makeNodeSet(selection, this.selectorTree.getRootNode());
    },

    makeSelectionHelper: function makeSelectionHelper() {
        this.selectionHelper = new _simple_users_and_groups_selection_helper2.default({
            itemNounSingularKey: this.labelItemNounSingularKey,
            itemNounPluralKey: this.labelItemNounPluralKey,
            showInactiveCount: true,
            showSingleItemInactiveText: false,
            userSelectorGroupsStrategy: this.userSelectorGroupsStrategy,
            maxCharacters: this.labelMaxChars
        });
    },

    createEmptyMessageBuilder: function createEmptyMessageBuilder() {
        return new _UserSelectorEmptyMessageBuilder2.default(this.userSelectorGroupsStrategy);
    },

    getNodeRenderers: function getNodeRenderers() {
        var result = {};
        this.userNodeRenderer = this.getUserNodeRenderer();
        result[_TreeNode2.default.TYPE_USER] = this.userNodeRenderer;
        result[_TreeNode2.default.TYPE_GROUP] = this.groupType == _GroupType2.default.USER_GROUP ? this.getUserGroupNodeRenderer() : this.getTimeZoneGroupNodeRenderer();
        result[_TreeNode2.default.TYPE_DISABLED_USERS_PARENT] = this.getDisabledUsersParentNodeRenderer();
        return result;
    },

    createTree: function createTree() {
        return this.userSelectorGroupsStrategy.createTree(this.rootNode, this.createEmptyMessageBuilder(), this.getCollapsedNodeIdsFromCookies(this.groupType));
    },

    getCollapsedNodeIdsFromCookies: function getCollapsedNodeIdsFromCookies(groupType) {
        var cookiesKey = groupType == _GroupType2.default.USER_GROUP ? this.collapsedUserGroupsCookiesKey : this.collapsedTimeZoneGroupsCookiesKey;
        return this.canExpandCollapseNodes() ? (0, _atBrowserUtils.getArrayFromCookies)(cookiesKey) : [];
    },

    processFirstPanelOpen: function processFirstPanelOpen() {
        UsersSelectorPanel.superclass.processFirstPanelOpen.call(this);
        this.buildSelectorTree();
        this.initialTreeSet = this.selectorTree.getSelectionController().getInitiallySelectedNodeSet();
        if (this.viewByPanel) this.viewByPanel.updateUI(this.groupType);
    },

    isTopNodeLevel: function isTopNodeLevel(treeNode) {
        return this.userSelectorGroupsStrategy.isUserGroupNodeLevel(treeNode);
    },

    isLowNodeLevel: function isLowNodeLevel(treeNode) {
        return this.userSelectorGroupsStrategy.isUserNodeLevel(treeNode);
    },

    isHiddenNodeSelected: function isHiddenNodeSelected(treeNode) {
        return this.checkHiddenNodeSelectionTemplate(treeNode, function () {
            return treeNode.getType() == _TreeNode2.default.TYPE_DISABLED_USERS_PARENT || !treeNode.getValue().isActive();
        });
    },

    getUserGroupNodeRenderer: function getUserGroupNodeRenderer() {
        return new _UserGroupNodeRenderer2.default(this.selectorTree, this.selectorFilter, this.getExpandCollapseCallback());
    },

    getTimeZoneGroupNodeRenderer: function getTimeZoneGroupNodeRenderer() {
        return new _TimeZoneGroupNodeRenderer2.default(this.selectorTree, this.selectorFilter, this.getExpandCollapseCallback());
    },

    getUserNodeRenderer: function getUserNodeRenderer() {
        return new _UserNodeRenderer2.default(this.selectorTree, this.selectorFilter, this.getSelectionHelper());
    },

    getDisabledUsersParentNodeRenderer: function getDisabledUsersParentNodeRenderer() {
        return new _DisabledUsersParentNodeRenderer2.default(this.selectorTree, this.selectorFilter, this.getExpandCollapseCallback());
    },

    getState: function getState() {
        return _Ext2.default.applyIf({ labelMaxChars: this.labelMaxChars,
            treeItemTooltipMessageParams: this.treeItemTooltipMessageParams,
            checkEmail: this.checkEmail,
            itemLabelMaxLength: this.itemLabelMaxLength,
            groupType: this.groupType }, UsersSelectorPanel.superclass.getState.call(this));
    },

    loadState: function loadState(state, doNotUpdateGroupType) {
        if (!doNotUpdateGroupType) this.setGroupType(state.groupType);
        UsersSelectorPanel.superclass.loadState.call(this, state);
    },

    loadPermanentState: function loadPermanentState(state) {
        UsersSelectorPanel.superclass.loadPermanentState.call(this, state);
        this.labelMaxChars = state.labelMaxChars;
        this.treeItemTooltipMessageParams = state.treeItemTooltipMessageParams;
        this.checkEmail = state.checkEmail;
        this.itemLabelMaxLength = state.itemLabelMaxLength;
    },

    isStateChanged: function isStateChanged() {
        return UsersSelectorPanel.superclass.isStateChanged.call(this) || this.groupTypeInit != this.groupType;
    },

    setPredefinedParameters: function setPredefinedParameters(state) {
        this.showInactive = state.showInactive;
        this.setInitialOptionValue(state.optionValue);
        if (this.isAlreadyShown()) {
            this.markPredefinedNodesAsSelected(state.selection);
            this.updateInitialTreeSet();
        }
    },

    updateInitialTreeSet: function updateInitialTreeSet() {
        this.initialTreeSet = this.selectorTree.getSelectionController().getInitiallySelectedNodeSet();
    },

    updateInitialGroupType: function updateInitialGroupType() {
        this.groupTypeInit = this.groupType;
    },

    groupByUserGroup: function groupByUserGroup() {
        var settings = this.collectCurrentSettings();

        this.groupType = _GroupType2.default.USER_GROUP;
        this.prepareForGroupByChange();

        this.changeUserSelectorGroupsStrategy(this.initShowGroupsStrategy());

        this.buildGroupByUserGroupsTreeData();

        this.setTreeData(this.groupByUserGroupsTreeData);

        this.recreateTreeSetSelectorSettingsAndBuildTree(settings);

        this.viewByPanel.updateUI(this.groupType);
        this.saveGroupBySettingsToCookie("groupByUserGroups");
    },

    groupByTimeZoneGroup: function groupByTimeZoneGroup() {
        var settings = this.collectCurrentSettings();

        this.groupType = _GroupType2.default.TIME_ZONE_GROUP;
        this.prepareForGroupByChange();

        this.changeUserSelectorGroupsStrategy(this.initShowGroupsStrategy());

        this.buildGroupByTimeZoneGroupsTreeData();

        this.setTreeData(this.groupByTimeZoneGroupsTreeData);

        this.recreateTreeSetSelectorSettingsAndBuildTree(settings);

        this.viewByPanel.updateUI(this.groupType);
        this.saveGroupBySettingsToCookie("groupByTimeZoneGroups");
    },

    getUsersToShow: function getUsersToShow() {
        return this.users;
    },

    buildGroupByUserGroupsTreeData: function buildGroupByUserGroupsTreeData() {
        var rootNode = new _TreeRootNode2.default();
        var searchIndex = new _StringIndex2.default();
        var allActiveSet = new _TreeNodeSet2.default();

        var groupsData = this.userGroupsEnabled ? (0, _atUtils.makeMapAndOrderForEntitiesArray)(this.userGroups) : null;
        (0, _user_group_selector_util.buildUserSelectorTreeWithUserGroupsData)(this.getUsersToShow(), groupsData, rootNode, this.createUserSelectorTreeBuilderObserver(searchIndex, allActiveSet), this.getUsersFilter());

        this.groupByUserGroupsTreeData = {
            rootNode: rootNode,
            searchIndex: searchIndex,
            allActiveSet: allActiveSet
        };
    },

    buildGroupByTimeZoneGroupsTreeData: function buildGroupByTimeZoneGroupsTreeData() {
        var rootNode = new _TreeRootNode2.default();
        var searchIndex = new _StringIndex2.default();
        var allActiveSet = new _TreeNodeSet2.default();

        var groupsData = this.timeZoneGroupsEnabled ? (0, _atUtils.makeMapAndOrderForEntitiesArray)(this.timeZoneGroups) : null;
        (0, _user_group_selector_util.buildUserSelectorTreeWithTimeZoneGroupsData)(this.getUsersToShow(), groupsData, rootNode, this.createUserSelectorTreeBuilderObserver(searchIndex, allActiveSet), this.getUsersFilter());

        this.groupByTimeZoneGroupsTreeData = {
            rootNode: rootNode,
            searchIndex: searchIndex,
            allActiveSet: allActiveSet
        };
    },

    createUserSelectorTreeBuilderObserver: function createUserSelectorTreeBuilderObserver(searchIndex, allActiveSet) {
        return new _UserSelectorTreeBuilderObserver2.default(searchIndex, allActiveSet);
    },

    getUsersFilter: function getUsersFilter() {
        return null;
    },

    setGroupByUserGroupsTreeData: function setGroupByUserGroupsTreeData(groupByUserGroupsTreeData) {
        this.groupByUserGroupsTreeData = groupByUserGroupsTreeData;
    },

    setGroupByTimeZoneGroupsTreeData: function setGroupByTimeZoneGroupsTreeData(groupByTimeZoneGroupsTreeData) {
        this.groupByTimeZoneGroupsTreeData = groupByTimeZoneGroupsTreeData;
    },

    setTreeData: function setTreeData(treeData) {
        this.rootNode = treeData.rootNode;
        this.searchIndex = treeData.searchIndex;
        this.allActiveSet = treeData.allActiveSet;
    },

    setGroupType: function setGroupType(newGroupType) {
        if (!newGroupType) {
            var groupBySettingFromCookies = _jquery2.default.cookie(this.groupBySettingCookieName);
            newGroupType = this.getGroupTypeFromString(groupBySettingFromCookies);
        }

        if (newGroupType == _GroupType2.default.USER_GROUP && !this.userGroupsEnabled) newGroupType = this.timeZoneGroupsEnabled ? _GroupType2.default.TIME_ZONE_GROUP : null;

        if (newGroupType == _GroupType2.default.TIME_ZONE_GROUP && !this.timeZoneGroupsEnabled) newGroupType = this.userGroupsEnabled ? _GroupType2.default.USER_GROUP : null;

        if (this.isAlreadyShown()) {
            this.regroupUsers(newGroupType);
        } else {
            this.groupType = newGroupType;
            this.initTreeData();
            this.createSelectorTree();
            this.viewByPanel.updateUI(this.groupType);
            this.groupTypeInit = this.groupType;
        }
    },

    regroupUsers: function regroupUsers(newGroupType) {
        if (newGroupType == _GroupType2.default.TIME_ZONE_GROUP) this.groupByTimeZoneGroup();
        if (newGroupType == _GroupType2.default.USER_GROUP) this.groupByUserGroup();
    },

    clearPreviousSelection: function clearPreviousSelection() {
        this.userGroupSelection = null;
        this.timeZoneSelection = null;
    },

    initTreeData: function initTreeData() {
        if (this.groupType == _GroupType2.default.USER_GROUP) {
            this.userSelectorGroupsStrategy = this.userGroupsEnabled ? this.initShowGroupsStrategy() : this.initHideGroupsStrategy();
            if (!this.groupByUserGroupsTreeData) this.buildGroupByUserGroupsTreeData();
            this.setTreeData(this.groupByUserGroupsTreeData);
        } else {
            this.userSelectorGroupsStrategy = this.timeZoneGroupsEnabled ? this.initShowGroupsStrategy() : this.initHideGroupsStrategy();
            if (!this.groupByTimeZoneGroupsTreeData) this.buildGroupByTimeZoneGroupsTreeData();
            this.setTreeData(this.groupByTimeZoneGroupsTreeData);
        }
    },

    getGroupTypeFromString: function getGroupTypeFromString(groupBySettingsString) {
        if (groupBySettingsString == "groupByTimeZoneGroups") return _GroupType2.default.TIME_ZONE_GROUP;else return _GroupType2.default.USER_GROUP;
    },

    getCustomOptionSection: function getCustomOptionSection() {
        var customOptionControls = [];
        // from left to right
        customOptionControls.push(this.viewByPanel);
        customOptionControls.push(this.getCustomOptionButtonsSection());

        this.customControlsContainer = new _Ext2.default.Container({
            cls: "userSelectorCustomControlsContainer",
            autoEl: "div",
            items: customOptionControls
        });
        return [this.customOption, this.customControlsContainer];
    },

    getCustomOptionButtonsSection: function getCustomOptionButtonsSection() {
        var additionalClass = "";
        if (!this.userGroupsEnabled && !this.timeZoneGroupsEnabled) {
            additionalClass = "noGroups";
        }
        return new _Ext2.default.Panel({
            cls: "buttonsPanel " + additionalClass,
            autEl: "div",
            items: this.getCustomOptionButtons()
        });
    },

    getCustomOptionButtons: function getCustomOptionButtons() {
        var buttons = [];
        buttons.push(this.filterButton, this.makeVerticalSeparator());
        buttons.push(this.hideNonSelectedButton, this.makeVerticalSeparator());
        buttons.push(this.selectAllButton, this.makeVerticalSeparator());
        buttons.push(this.clearButton);
        if (this.canExpandCollapseNodes()) {
            buttons.push(this.makeVerticalSeparator(), this.collapseAllButton, this.expandAllButton);
        }

        return buttons;
    },

    initializeViewByPanel: function initializeViewByPanel() {
        var self = this;
        this.viewByPanel.init(this.userGroupsEnabled, this.timeZoneGroupsEnabled, function () {
            self.treeActionHandler(_jquery2.default.proxy(self.groupByUserGroup, self), true, false);
        }, function () {
            self.treeActionHandler(_jquery2.default.proxy(self.groupByTimeZoneGroup, self), true, false);
        });
    },

    initialize: function initialize(userGroupsEnabled, timeZoneGroupsEnabled, users, userGroups, timeZoneGroups) {
        this.userGroupsEnabled = userGroupsEnabled;
        this.timeZoneGroupsEnabled = timeZoneGroupsEnabled;
        this.users = users;
        this.userGroups = userGroups;
        this.timeZoneGroups = timeZoneGroups;
        this.groupByUserGroupsTreeData = null;

        this.setGroupType(null);

        this.createGroupsUsersMaps();
        this.initializeViewByPanel();

        if (this.showShowInactiveCheckbox) {
            var anyDisabled = _underscore2.default.any(users, function (u) {
                return !u.isActive();
            });
            if (!anyDisabled) this.showInactiveCheckbox.hide();
        }
    },

    createGroupsUsersMaps: function createGroupsUsersMaps() {
        this.usersMap = {};
        this.userGroupsUsersMap = {};
        this.timeZoneGroupsUsersMap = {};
        this.userGroupsDisabledUsersMap = {};
        this.timeZoneGroupsDisabledUsersMap = {};

        for (var i = 0; i < this.users.length; i++) {
            var user = this.users[i];
            this.usersMap[user.id] = user;

            var userGroupId = user.userGroupId;
            if (!this.userGroupsUsersMap[userGroupId]) this.userGroupsUsersMap[userGroupId] = [];
            this.userGroupsUsersMap[userGroupId].push(user.id);

            var timeZoneGroupId = user.timeZoneGroupId;
            if (!this.timeZoneGroupsUsersMap[timeZoneGroupId]) this.timeZoneGroupsUsersMap[timeZoneGroupId] = [];
            this.timeZoneGroupsUsersMap[timeZoneGroupId].push(user.id);

            if (!user.isActive()) {
                if (!this.userGroupsDisabledUsersMap[userGroupId]) this.userGroupsDisabledUsersMap[userGroupId] = [];
                this.userGroupsDisabledUsersMap[userGroupId].push(user.id);

                if (!this.timeZoneGroupsDisabledUsersMap[timeZoneGroupId]) this.timeZoneGroupsDisabledUsersMap[timeZoneGroupId] = [];
                this.timeZoneGroupsDisabledUsersMap[timeZoneGroupId].push(user.id);
            }
        }
    },

    initHideGroupsStrategy: function initHideGroupsStrategy() {
        return new _HideUserGroupsStrategy2.default();
    },

    initShowGroupsStrategy: function initShowGroupsStrategy() {
        var self = this;
        return new _ShowUserGroupsStrategy2.default({
            getGroupIdFromUserCallback: function getGroupIdFromUserCallback(user) {
                return self.groupType == _GroupType2.default.USER_GROUP ? user.getUserGroupId() : user.getTimeZoneGroupId();
            },
            noSelectedNodesMessageKey: self.groupType == _GroupType2.default.USER_GROUP ? "users_selector.hide_not_selected.no_users_or_user_groups_selected" : "users_selector.hide_not_selected.no_users_or_time_zone_groups_selected",
            noNodesMatchingSearchMessageKey: self.groupType == _GroupType2.default.USER_GROUP ? "users_selector.users_or_user_groups_no_results_in_search" : "users_selector.users_or_time_zone_groups_no_results_in_search"
        });
    },

    collectCurrentSettings: function collectCurrentSettings() {
        var currentState = this.getState();
        var currentSelectionWithHiddenUsers = this.getSelection(false, true);

        var groupsUsersMap;
        var prevSelection;
        if (this.groupType == _GroupType2.default.USER_GROUP) {
            groupsUsersMap = this.userGroupsUsersMap;
            prevSelection = this.timeZoneSelection;
            this.userGroupSelection = new _two_level_selection2.default(currentSelectionWithHiddenUsers.getFirstLevel(), currentSelectionWithHiddenUsers.getSecondLevel());
        } else {
            groupsUsersMap = this.timeZoneGroupsUsersMap;
            prevSelection = this.userGroupSelection;
            this.timeZoneSelection = new _two_level_selection2.default(currentSelectionWithHiddenUsers.getFirstLevel(), currentSelectionWithHiddenUsers.getSecondLevel());
        }

        var selection;
        if (prevSelection) {
            selection = prevSelection;
        } else {
            var selectedUserIds = currentSelectionWithHiddenUsers.getSecondLevel();
            var selectedGroupIds = currentSelectionWithHiddenUsers.getFirstLevel();

            for (var i = 0; i < selectedGroupIds.length; i++) {
                selectedUserIds = selectedUserIds.concat(groupsUsersMap[selectedGroupIds[i]]);
            }selection = new _two_level_selection2.default([], selectedUserIds);
        }

        return {
            showInactiveCheckboxValue: currentState.showInactive,
            allUsers: currentState.optionValue,
            selection: selection,
            searchString: this.filterWordsField ? this.filterWordsField.getSearchString() : null,
            hideNonSelectedButtonChecked: this.hideNonSelectedButtonChecked,
            optionValueInit: this.optionValueInit,
            initialSelection: this.userSelectorGroupsStrategy.makeSelectionFromNodeSet(this.selectorTree.getSelectionController().getInitiallySelectedNodeSet(), false, true),
            labelMaxChars: currentState.labelMaxChars,
            treeItemTooltipMessageParams: currentState.treeItemTooltipMessageParams,
            checkEmail: currentState.checkEmail,
            itemLabelMaxLength: currentState.itemLabelMaxLength
        };
    },

    /* This method must be called after selection is got */
    prepareForGroupByChange: function prepareForGroupByChange() {
        this.alreadyShown = false;
        this.fireSelectionChangeAllowed = false;
    },

    changeUserSelectorGroupsStrategy: function changeUserSelectorGroupsStrategy(newUserSelectorGroupsStrategy) {
        this.userSelectorGroupsStrategy = newUserSelectorGroupsStrategy;
        this.selectionHelper.setUserSelectorGroupsStrategy(newUserSelectorGroupsStrategy);
    },

    /*creates, sets given settings to selector panel and builds selector tree*/
    recreateTreeSetSelectorSettingsAndBuildTree: function recreateTreeSetSelectorSettingsAndBuildTree(setting) {
        this.createSelectorTree();
        (0, _jquery2.default)(this.treePanel).empty();
        this.setSettingsBeforeTreeRebuilding(setting);
        this.buildSelectorTree();
        this.setSettingsAfterTreeRebuilding(setting);
    },

    /*
     1. Use this method to configure filtering, showInactive checkbox, etc. while regrouping.
     2. No refiltering is performed while configuring selector filter here, tree will be built considering filter settings
     3. Set manually the value of showInactiveCheckbox to selectorFilter, because this value doesn't change while regrouping and oncheck-event is not called
     */
    setSettingsBeforeTreeRebuilding: function setSettingsBeforeTreeRebuilding(settings) {
        this.loadState(this.getStateFromSettings(settings), true);
        this.selectorFilter.setShowInactive(settings.showInactiveCheckboxValue);
        if (settings.searchString) this.selectorFilter.setSearchString(settings.searchString);
    },

    /**
     * We have settings, state and conversion between them.
     * So if you reimplement <b>collectSettings</b> probably you need to reimplement this method and <b>loadState</b>
     */
    getStateFromSettings: function getStateFromSettings(settings) {
        return {
            optionValue: settings.allUsers,
            showInactive: settings.showInactiveCheckboxValue,
            selection: settings.selection,
            groupType: this.groupType,
            labelMaxChars: settings.labelMaxChars,
            treeItemTooltipMessageParams: settings.treeItemTooltipMessageParams,
            checkEmail: settings.checkEmail,
            itemLabelMaxLength: settings.itemLabelMaxLength
        };
    },

    /*
     Use this method to configure initial state - state when selector was opened (for correct work of reset link).
     */
    setSettingsAfterTreeRebuilding: function setSettingsAfterTreeRebuilding(settings) {
        this.optionValueInit = settings.optionValueInit;
        this.markPredefinedNodesAsSelected(settings.initialSelection);
        if (this.filterWordsPopup && this.filterWordsPopup.isShown()) {
            this.selectorTree.expandAll();
            this.saveCollapsedNodesIntoCookies();
        }
        this.setHideNonSelectedButtonState(settings.hideNonSelectedButtonChecked);
    },

    createSelectorTree: function createSelectorTree() {
        UsersSelectorPanel.superclass.createSelectorTree.call(this);
        this.addSelectorTreeChangeListener();
    },

    beforeResetAction: function beforeResetAction() {
        var self = this;
        if (this.groupTypeInit && this.groupType !== _GroupType2.default.USER_GROUP && this.groupTypeInit === _GroupType2.default.USER_GROUP) {
            self.groupByUserGroup();
        }
        if (this.groupTypeInit && this.groupType !== _GroupType2.default.TIME_ZONE_GROUP && this.groupTypeInit === _GroupType2.default.TIME_ZONE_GROUP) {
            self.groupByTimeZoneGroup();
        }
    },

    afterResetAction: function afterResetAction() {
        UsersSelectorPanel.superclass.afterResetAction.call(this);
        this.clearPreviousSelection();
        this.viewByPanel.updateUI(this.groupTypeInit);
    },

    setInitialValuesFromCurrent: function setInitialValuesFromCurrent() {
        UsersSelectorPanel.superclass.setInitialValuesFromCurrent.call(this);
        this.groupTypeInit = this.groupType;
    },

    saveGroupBySettingsToCookie: function saveGroupBySettingsToCookie(value) {
        _jquery2.default.cookie(this.groupBySettingCookieName, value, { expires: 365 });
    },

    addSelectorTreeChangeListener: function addSelectorTreeChangeListener() {
        var self = this;
        this.selectorTree.getSelectionController().addListener({
            nodeDeselected: function nodeDeselected(treeNode) {
                var selectionToProcess = self.groupType == _GroupType2.default.USER_GROUP ? self.timeZoneSelection : self.userGroupSelection;
                if (!selectionToProcess) return;

                var selectionGroupType = selectionToProcess.groupType;

                if (self.isLowNodeLevel(treeNode)) {
                    self.removeUserIdFromSelection(treeNode.value.id, selectionToProcess, selectionGroupType);
                } else {
                    var usersFromGroup = self.getUsersFromTreeNode(treeNode);
                    for (var i = 0; i < usersFromGroup.length; i++) {
                        self.removeUserIdFromSelection(usersFromGroup[i], selectionToProcess, selectionGroupType);
                    }
                }
            },
            nodeSelected: function nodeSelected(treeNode) {
                var selectionToProcess = self.groupType == _GroupType2.default.USER_GROUP ? self.timeZoneSelection : self.userGroupSelection;
                if (!selectionToProcess) return;

                var selectionGroupType = selectionToProcess.groupType;

                if (self.isLowNodeLevel(treeNode)) {
                    self.addUserIdToSelection(treeNode.value.id, selectionToProcess, selectionGroupType);
                } else {
                    var usersFromGroup = self.getUsersFromTreeNode(treeNode);
                    for (var i = 0; i < usersFromGroup.length; i++) {
                        self.addUserIdToSelection(usersFromGroup[i], selectionToProcess, selectionGroupType);
                    }
                }
            }
        });
    },

    getUsersFromTreeNode: function getUsersFromTreeNode(treeNode) {
        var groupsUsersMap;
        var groupId;
        if (treeNode.getType() == _TreeNode2.default.TYPE_GROUP) {
            groupsUsersMap = this.groupType == _GroupType2.default.USER_GROUP ? this.userGroupsUsersMap : this.timeZoneGroupsUsersMap;
            groupId = treeNode.getValue().id;
        } else if (treeNode.getType() == _TreeNode2.default.TYPE_DISABLED_USERS_PARENT) {
            groupsUsersMap = this.groupType == _GroupType2.default.USER_GROUP ? this.userGroupsDisabledUsersMap : this.timeZoneGroupsDisabledUsersMap;
            groupId = treeNode.getParent().getValue().id;
        }

        return groupsUsersMap[groupId];
    },

    addUserIdToSelection: function addUserIdToSelection(userId, selection, selectionGroupType) {
        var user = this.usersMap[userId];
        var groupId = selectionGroupType == _GroupType2.default.USER_GROUP ? user.userGroupId : user.timeZoneGroupId;

        // do not add userId if user is in already selected group
        if (_jquery2.default.inArray(groupId, selection.getFirstLevel()) != -1) return;

        if (_jquery2.default.inArray(userId, selection.getSecondLevel()) == -1) selection.getSecondLevel().push(userId);
    },

    removeUserIdFromSelection: function removeUserIdFromSelection(userId, selection, selectionGroupType) {
        selection.secondLevel = _jquery2.default.grep(selection.secondLevel, function (id) {
            return userId != id;
        });

        var user = this.usersMap[userId];
        var groupId = selectionGroupType == _GroupType2.default.USER_GROUP ? user.userGroupId : user.timeZoneGroupId;

        var needToDeleteGroupFromSelection = _jquery2.default.inArray(groupId, selection.getFirstLevel()) != -1;
        if (!needToDeleteGroupFromSelection) return;

        selection.firstLevel = _jquery2.default.grep(selection.firstLevel, function (id) {
            return groupId != id;
        });

        var groupsUsersMap = selectionGroupType == _GroupType2.default.USER_GROUP ? this.userGroupsUsersMap : this.timeZoneGroupsUsersMap;
        var usersFromGroup = groupsUsersMap[groupId];
        for (var i = 0; i < usersFromGroup.length; i++) {
            var userFromGroupId = usersFromGroup[i];
            if (userFromGroupId != userId) {
                if (_jquery2.default.inArray(userFromGroupId, selection.getSecondLevel()) == -1) selection.getSecondLevel().push(userFromGroupId);
            }
        }
    },

    resetNodes: function resetNodes() {
        if (this.groupTypeInit == _GroupType2.default.USER_GROUP) this.groupByUserGroup();else if (this.groupTypeInit == _GroupType2.default.TIME_ZONE_GROUP) this.groupByTimeZoneGroup();

        this.selectorTree.resetNodes(this.initialTreeSet);
    },

    onGenericOptionSelect: function onGenericOptionSelect(option, checked) {

        if (checked) {
            this.addClass("hideCustomOptionField");
        }
        UsersSelectorPanel.superclass.onGenericOptionSelect.call(this, option, checked);
    },

    onCustomOptionSelect: function onCustomOptionSelect(option, checked) {
        if (checked) {
            this.removeClass("hideCustomOptionField");
            if (!_jquery2.default.isEmptyObject(this.selectorTree)) {
                this.selectorTree.refreshScroller();
            }
        }
        UsersSelectorPanel.superclass.onCustomOptionSelect.call(this, option, checked);
    },

    setAllUsersIfNoneSelected: function setAllUsersIfNoneSelected() {
        if (this.getSelectedNodeSet().isEmpty() && this.isCustomOptionSelected()) this.selectOption(this.allItemsOptionValue);
    }
});

_Ext2.default.reg("at_users_selector_panel", UsersSelectorPanel);

exports.default = UsersSelectorPanel;

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _dhtml_popup_with_moire = __webpack_require__(506);

var _dhtml_popup_with_moire2 = _interopRequireDefault(_dhtml_popup_with_moire);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _atUtils = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function BasicLightbox() {}

//this constants must be init in child classes;
BasicLightbox.prototype.exist_invalid_fields_message_key = null;
BasicLightbox.prototype.close_tab_confirmation_message_key = null;

BasicLightbox.prototype = _.create(_dhtml_popup_with_moire2.default.prototype);

BasicLightbox.prototype.init = function (popupId, closeBtnId, moireDivId) {
    _dhtml_popup_with_moire2.default.call(this, popupId, moireDivId);

    if (this.exist_invalid_fields_message_key == null || this.close_tab_confirmation_message_key == null) {
        throw "not initialized constants in child class";
    }

    var self = this;

    this.hideOnMouseDown = function () {
        return false;
    };
    this.hideOnResize = function () {
        return false;
    };
    this.hideOnEscape = function () {
        return false;
    };
    this.onEscape = function () {
        this.cancel();
    };

    this.lightBoxEl = this.getPopupEl()[0];
    this.innerContent = this.getPopupEl().find('.innerContent');

    this._errorMessageBox = this.getPopupEl().find('.errorMessageBox');
    this.removeErrorInFooter();
    this._validateCallback = function () {
        if (self.hasErrors()) return;
        self.removeErrorInFooter();
    };

    this.closeButton = this.getCloseButtonEl(closeBtnId);

    if (this.closeButton) {
        this.closeButton.onclick = function () {
            self.cancel();
        };
    }
    this._cancelEnabled = true;
    this._commitEnabled = true;

    this.commitButton = this.getCommitButtonEl();
    this.cancelButton = this.getCancelButtonEl();

    if (this.commitButton) this.commitButton.onclick = function () {
        self.commit();
    };else this._commitEnabled = false;

    if (this.cancelButton) this.cancelButton.onclick = function () {
        self.cancel();
    };

    this.successCallback = null;
    this.cancelCallback = null;

    // Callback to do some action after fail validate
    this.failureValidateCallback = null;

    this.footerEl = this.getFooterEl();

    if (this.footerEl) {
        this.footerClassName = "basicLightboxFooter";
        this.footerEl.className = this.footerClassName;
    }

    return this;
};

BasicLightbox.prototype.getCommitButtonEl = function () {
    return document.getElementById(this.popupId + "_commitBtn");
};

BasicLightbox.prototype.getCancelButtonEl = function () {
    return document.getElementById(this.popupId + "_cancelBtn");
};

BasicLightbox.prototype.getFooterEl = function () {
    return document.getElementById(this.popupId + "_footer");
};

BasicLightbox.prototype.getCloseButtonEl = function (id) {
    return document.getElementById(id);
};

BasicLightbox.prototype.show = function () {
    if (typeof onloadLightbox == 'function') {
        if (!onloadLightbox()) return;
    }

    _dhtml_popup_with_moire2.default.prototype.show.call(this);

    if (this.close_tab_confirmation_message_key) {
        var self = this;
        ExitConfirmationHandlersManager.setUpExitConfirmation(_messageResource2.default.getMessage(this.close_tab_confirmation_message_key), function () {
            return self.wereDataChanged();
        }, false);
    }
};

BasicLightbox.prototype.hide = function () {

    if (typeof onHideLightBox == 'function') {
        this.lightBoxHideHandle();
    }
    ExitConfirmationHandlersManager.restoreExitConfirmation();
    _dhtml_popup_with_moire2.default.prototype.hide.call(this);
};

BasicLightbox.prototype.toggle = function (toggle) {
    if (toggle) {
        this.show();
    } else {
        this.hide();
    }
};

BasicLightbox.prototype.lightBoxHideHandle = function () {
    onHideLightBox();
};

BasicLightbox.prototype.disableUserInputWhileSaving = function () {
    (0, _jquery2.default)(this.lightBoxEl).addClass("savingState");
    this.disableButtons();
};

BasicLightbox.prototype.enableUserInputWhileSaving = function () {
    (0, _jquery2.default)(this.lightBoxEl).removeClass("savingState");
    this.enableButtons();
};

BasicLightbox.prototype.setSuccessCallback = function (successCallback) {
    this.successCallback = successCallback;
};

BasicLightbox.prototype.setFailureValidateCallback = function (failureValidateCallback) {
    this.failureValidateCallback = failureValidateCallback;
};

BasicLightbox.prototype.setCancelCallback = function (cancelCallback) {
    this.cancelCallback = cancelCallback;
};

BasicLightbox.prototype.updateUI = function () {
    // abstract
};

BasicLightbox.prototype.validate = function () {
    // abstract
};

BasicLightbox.prototype.cancel = function () {
    if (this._cancelEnabled && (!this.wereDataChanged() || this.confirmCancelModifications())) if (this.cancelCallback) this.cancelCallback();
};

BasicLightbox.prototype.getErrorsMap = function () {
    //abstract
};

BasicLightbox.prototype.setErrorClasses = function (classes) {
    //abstract
};

BasicLightbox.prototype.hasErrors = function () {
    var classes = [];
    var errorsMap = this.getErrorsMap();
    for (var p in errorsMap) {
        if (errorsMap[p]) classes.push(p);
    }this.setErrorClasses(classes);
    return classes.length > 0;
};

BasicLightbox.prototype.commit = function () {
    if (!this._commitEnabled) return;

    var valid = this.validate();
    this.updateUI();
    if (this.hasErrors()) {
        this.printErrorInFooter(_messageResource2.default.getMessage(this.exist_invalid_fields_message_key));
        this.failureValidateCallback && this.failureValidateCallback();
    }
    this._blinkErrorInFooter();
    if (valid && this.successCallback) {
        var inputData = this.getDataToCommit();
        this.successCallback.apply(this, inputData);
    }
};

BasicLightbox.prototype.getDataToCommit = function () {
    // subclasses of BasicLightbox should override this method, if they need to collect data for applying to successCallback
    // (or they can collect it inside successCallback function instead)
    // if we return undefined or null, it will cause errors in IE8
    return [];
};

BasicLightbox.prototype.changesDetected = function () {};

BasicLightbox.prototype.wereDataChanged = function () {
    return this.dataChanged;
};

BasicLightbox.prototype.confirmCancelModifications = function () {
    return confirm(_messageResource2.default.getMessage(this.cancel_confirmation_message_key));
};

BasicLightbox.prototype.printErrorInFooter = function (error) {
    this._errorMessageBox.find(".errormsg").text(error);
    this._errorMessageBox.removeClass("disabled");
};

BasicLightbox.prototype.displayErrorInFooter = function (error) {
    this._errorMessageBox.removeClass("disabled");
};

BasicLightbox.prototype.removeErrorInFooter = function () {
    this._errorMessageBox.addClass("disabled");
};

BasicLightbox.prototype._hasErrorInFooter = function () {
    return !this._errorMessageBox.hasClass("disabled");
};

BasicLightbox.prototype._blinkErrorInFooter = function () {
    this._errorMessageBox.addClass("blinkDisabled");
    var self = this;
    window.setTimeout(function () {
        self._errorMessageBox.removeClass("blinkDisabled");
    }, 250);
};

BasicLightbox.prototype.setDeleteButtonVisibility = function (visible) {
    this.deleteButton.style.visibility = visible ? "visible" : "hidden";
};

BasicLightbox.prototype.disableButtons = function () {
    this._cancelEnabled = false;
    this._commitEnabled = false;
};

BasicLightbox.prototype.enableButtons = function () {
    this._cancelEnabled = true;
    this._commitEnabled = true;
};

BasicLightbox.prototype.setCommitButtonTitle = function (title, defaultMessage, maxLength) {
    this.setTextForElement(this.commitButtonTitlePlaceholder, title, defaultMessage, maxLength);
};

// function to set value for input text fields with placeholder
BasicLightbox.prototype.changesCallback = function () {
    this.changesDetected();
};

// function to set value for input text fields with placeholder
BasicLightbox.prototype.setValue = function (field, value) {
    field.removeClass('placeholder'); // IE8 doesn't switch placeholder class when field value is set
    field[0].value = value;
    field[0].prevValue = field[0].value;
};

BasicLightbox.prototype.basicOnKeyPressedHandler = function () {
    this.keyPressed = true;
};

BasicLightbox.prototype.basicKeyUpChangesHandler = function (additionalHandler) {
    var self = this;
    return function () {
        this.keyPressed = false;
        if (!this.prevValue && !!this.value || this.prevValue != this.value) self.changesCallback();

        if (additionalHandler) additionalHandler();
    };
};

BasicLightbox.prototype.scrollToSection = function (sectionEl) {
    var correction = this.getContentOffset ? this.getContentOffset() : 0;
    this.innerContent.animate({ scrollTop: this.innerContent.scrollTop() + sectionEl.position().top + correction });
};

BasicLightbox.prototype.basicOnBlurFieldHandler = function (additionalHandler) {
    var self = this;
    return function () {
        (0, _jquery2.default)(this).pVal((0, _atUtils.trim)(this.value));
        //see Bug 48539
        if (this.keyPressed) self.basicKeyUpChangesHandler.call(this);

        if (additionalHandler) additionalHandler();
    };
};

BasicLightbox.prototype.checkEmpty = function (field, errorCode, onlyRemoveEmptyError, hasPlaceholder) {
    var errorsMap = this.getErrorsMap();
    if (!hasPlaceholder ? field.value.length == 0 : field.pVal().length == 0) {
        if (!onlyRemoveEmptyError) {
            errorsMap[errorCode] = true;
        }
    } else {
        errorsMap[errorCode] = false;
    }
    return errorsMap[errorCode];
};

BasicLightbox.prototype.setTextForElement = function (element, title, defaultMessage, maxLength) {
    if (defaultMessage) {
        if (!maxLength) maxLength = 16;
        if (title.length > maxLength) {
            (0, _jquery2.default)(element).text(defaultMessage);
        } else (0, _jquery2.default)(element).text(title);
    } else {
        (0, _jquery2.default)(element).text(title);
    }
};

exports.default = BasicLightbox;

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/**
 * Download last generated pdf from browser to client
 * Filesaver.js are used
 */
var downloadPDF = exports.downloadPDF = function downloadPDF(encodedPDF, fileName) {
    var blob = void 0;
    try {
        blob = new Blob([encodedPDF], { type: 'application/pdf' });
    } catch (e) {
        // Old browser which can't handle it without making it an byte array (ie10)
        if (e.name === "InvalidStateError") {
            var byteArray = new Uint8Array(encodedPDF);
            blob = new Blob([byteArray.buffer], { type: 'application/pdf' });
        }
    }
    if (blob) {
        window.saveAs(blob, fileName); // used FileSaver.js library
    } else {
        throw 'Could not generate blob';
    }
};

/**
 * Wrap function of `pdfMake` for use in imports
 * !!Note pdfMake may not present in window. Need to include `pdfmake.webpack.js` bundle on page
 * @returns {*}
 */
var createPdf = exports.createPdf = function createPdf() {
    return window.pdfMake.createPdf.apply(this, arguments);
};

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _DateFormattingStrategy = __webpack_require__(805);

var _DateFormattingStrategy2 = _interopRequireDefault(_DateFormattingStrategy);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _constants = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DateRangeFormattingStrategy = function (_DateFormattingStrate) {
    _inherits(DateRangeFormattingStrategy, _DateFormattingStrate);

    function DateRangeFormattingStrategy() {
        _classCallCheck(this, DateRangeFormattingStrategy);

        return _possibleConstructorReturn(this, (DateRangeFormattingStrategy.__proto__ || Object.getPrototypeOf(DateRangeFormattingStrategy)).apply(this, arguments));
    }

    _createClass(DateRangeFormattingStrategy, [{
        key: 'formatForDateInformation',
        value: function formatForDateInformation(dateParameters) {
            var dateRangeSelection = dateParameters.dateRangeSelection;

            var dateString = void 0;
            if (dateRangeSelection.qualifier === _constants.DateRangeSelectionQualifier.CUSTOM) dateString = this.formatDateRange(dateRangeSelection.fromDate, dateRangeSelection.toDate);else dateString = _messageResource2.default.getMessage("common.pdf.formatting.date.the") + " " + _messageResource2.default.getMessage(DateRangeStateUtil[dateRangeSelection.qualifier]).toLowerCase();

            return _messageResource2.default.getMessage("common.pdf.formatting.date.range", [dateString]);
        }
    }, {
        key: 'formatSpecifyingInformation',
        value: function formatSpecifyingInformation(dateParameters) {
            var dateRangeSelection = dateParameters.dateRangeSelection;

            if (dateRangeSelection.qualifier === _constants.DateRangeSelectionQualifier.CUSTOM) return "";

            return " (" + this.formatDateRange(dateRangeSelection.fromDate, dateRangeSelection.toDate) + ")";
        }
    }, {
        key: 'formatDateRange',
        value: function formatDateRange(fromDate, toDate) {
            return this.formatDate(fromDate) + " - " + this.formatDate(toDate);
        }
    }]);

    return DateRangeFormattingStrategy;
}(_DateFormattingStrategy2.default);

exports.default = DateRangeFormattingStrategy;

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _atBrowserUtils = __webpack_require__(8);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TableCell = function () {
    function TableCell(value, rowObj) {
        _classCallCheck(this, TableCell);

        this.value = value;
        this.colIdx = -1;
        this.rowObj = rowObj;
        this.renderer = null;
        this.cellElem = document.createElement("td");
        this.cellElem.cellObj = this;
    }

    _createClass(TableCell, [{
        key: "getRow",
        value: function getRow() {
            return this.rowObj;
        }
    }, {
        key: "setColspan",
        value: function setColspan(colspan) {
            return this.colspan = colspan;
        }
    }, {
        key: "setRow",
        value: function setRow(rowObj) {
            this.rowObj = rowObj;
        }
    }, {
        key: "setColIdx",
        value: function setColIdx(colIdx) {
            this.colIdx = colIdx;
        }
    }, {
        key: "getColIdx",
        value: function getColIdx() {
            return this.colIdx;
        }
    }, {
        key: "getCellEl",
        value: function getCellEl() {
            return this.cellElem;
        }
    }, {
        key: "setRenderer",
        value: function setRenderer(renderer) {
            this.renderer = renderer;
        }
    }, {
        key: "getRenderer",
        value: function getRenderer() {
            return this.renderer;
        }
    }, {
        key: "updateUI",
        value: function updateUI() {
            this.renderer.updateUI(this);
        }
    }, {
        key: "writeContent",
        value: function writeContent() {
            this.renderer.writeContent(this);
        }

        // use, when you need to update cell content and cell UI with new data (see UsersForTTApproverCellRenderer, AssignTTApproversCellRenderer, for example)

    }, {
        key: "updateCell",
        value: function updateCell() {
            this.renderer.updateContent(this);
            this.updateUI();
        }
    }, {
        key: "getValue",
        value: function getValue() {
            return this.value;
        }
    }, {
        key: "setValue",
        value: function setValue(value) {
            this.value = value;
        }
    }, {
        key: "isFirst",
        value: function isFirst() {
            return this.colIdx === 0;
        }
    }, {
        key: "isLast",
        value: function isLast() {
            return this.colIdx === this.getRow().getCells().length - 1;
        }
    }, {
        key: "getTable",
        value: function getTable() {
            return this.getRow().getTable();
        }
    }, {
        key: "leftCell",
        value: function leftCell() {
            var leftIndex = this.getColIdx() - 1;
            if (leftIndex >= 0) return this.getRow().getCell(leftIndex);
        }
    }, {
        key: "upperCell",
        value: function upperCell() {
            var upperRowIndex = this.getRow().getRowIdx() - 1;
            if (upperRowIndex >= 0) return this.getRow().getTable().getCell(upperRowIndex, this.getColIdx());
        }
    }, {
        key: "getMouseHandler",
        value: function getMouseHandler() {
            return this.getRow().getTable().getMouseEventsHandler();
        }
    }, {
        key: "mouseOver",
        value: function mouseOver(evt) {
            return this.getMouseHandler().mouseOver(evt, this);
        }
    }, {
        key: "mouseOut",
        value: function mouseOut(evt) {
            return this.getMouseHandler().mouseOut(evt, this);
        }
    }, {
        key: "mouseDown",
        value: function mouseDown(evt) {
            return this.getMouseHandler().mouseDown(evt, this);
        }
    }, {
        key: "mouseUp",
        value: function mouseUp(evt) {
            return this.getMouseHandler().mouseUp(evt, this);
        }
    }, {
        key: "mouseMove",
        value: function mouseMove(evt) {
            return this.getMouseHandler().mouseMove(evt, this);
        }
    }, {
        key: "contextMenu",
        value: function contextMenu(evt) {
            return this.getMouseHandler().contextMenu(evt, this);
        }
    }, {
        key: "setupMouseHandlers",
        value: function setupMouseHandlers() {
            this.cellElem.onmouseover = function (evt) {
                this.cellObj.mouseOver((0, _atBrowserUtils.getEventObj)(evt));
            };
            this.cellElem.onmouseout = function (evt) {
                this.cellObj.mouseOut((0, _atBrowserUtils.getEventObj)(evt));
            };
            this.cellElem.onmousedown = function (evt) {
                this.cellObj.mouseDown((0, _atBrowserUtils.getEventObj)(evt));
            };
            this.cellElem.onmouseup = function (evt) {
                this.cellObj.mouseUp((0, _atBrowserUtils.getEventObj)(evt));
            };
            this.cellElem.onmousemove = function (evt) {
                this.cellObj.mouseMove((0, _atBrowserUtils.getEventObj)(evt));
            };
            this.cellElem.oncontextmenu = function (evt) {
                this.cellObj.contextMenu((0, _atBrowserUtils.getEventObj)(evt));
            };
        }
    }]);

    return TableCell;
}();

exports.default = TableCell;

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.setWorkAssignmentsCountersForUser = exports.setUsersWorkAssignmentsCounters = exports.changeWorkAssignmentsFilter = exports.changeCurrentPageNum = exports.changeUsersPerPage = exports.changeWordsFilter = exports.changeUsersFilter = exports.changeSorting = exports.saveUserSettings = exports.loadUsersDataAction = exports.getUsersForWorkAssignmentTab = exports.setLoaded = exports.setLoading = exports.removeUserIdFromOrder = exports.prependUserIdsOrder = exports.setUserIdsOrder = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reduxActions = __webpack_require__(9);

var _actionTypes = __webpack_require__(687);

var ActionTypes = _interopRequireWildcard(_actionTypes);

var _actions = __webpack_require__(29);

var _actions2 = __webpack_require__(68);

var _actions3 = __webpack_require__(50);

var _selectors = __webpack_require__(316);

var _utils = __webpack_require__(6);

var _rpcCalls = __webpack_require__(24);

var _rpcCalls2 = _interopRequireDefault(_rpcCalls);

var _StringTokenizer = __webpack_require__(103);

var _StringTokenizer2 = _interopRequireDefault(_StringTokenizer);

var _utils2 = __webpack_require__(688);

var _selectors2 = __webpack_require__(53);

var _constants = __webpack_require__(1636);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var setUserIdsOrder = exports.setUserIdsOrder = (0, _reduxActions.createAction)(ActionTypes.USER_IDS_ORDER_SET);
var prependUserIdsOrder = exports.prependUserIdsOrder = function prependUserIdsOrder(ids) {
    return function (dispatch, getState) {
        dispatch(setUserIdsOrder([].concat(_toConsumableArray(ids), _toConsumableArray((0, _selectors.getUserIdsOrder)(getState())))));
    };
};
var removeUserIdFromOrder = exports.removeUserIdFromOrder = function removeUserIdFromOrder(id) {
    return function (dispatch, getState) {
        dispatch(setUserIdsOrder((0, _selectors.getUserIdsOrder)(getState()).filter(function (userId) {
            return userId !== id;
        })));
    };
};

var setLoading = exports.setLoading = (0, _reduxActions.createAction)(ActionTypes.SET_LOADING);
var setLoaded = exports.setLoaded = (0, _reduxActions.createAction)(ActionTypes.SET_LOADED);

function isNeedMoreLoad(NUsersPerPage, partNum) {
    return NUsersPerPage > partNum * _constants.RECORDS_LOAD_LIMIT;
}

function getPageNumByRecordsLimit(partNum, pageNum, NUsersPerPage) {
    return Math.ceil(NUsersPerPage / _constants.RECORDS_LOAD_LIMIT) * (pageNum - 1) + partNum;
}

var getUsersForWorkAssignmentTab = exports.getUsersForWorkAssignmentTab = function getUsersForWorkAssignmentTab(_ref) {
    var usersFilter = _ref.usersFilter,
        partNum = _ref.partNum,
        tokens = _ref.tokens;
    return function (dispatch, getState) {

        var NUsersPerPage = (0, _selectors.getNUsersPerPage)(getState());

        (0, _rpcCalls2.default)('UserManagementService.getUsersWorkAssignmentsCounters', [usersFilter.userIds, usersFilter.groupIds, usersFilter.groupType, usersFilter.allSelected, (0, _selectors.getWorkAssignmentsFilter)(getState()), tokens, (0, _selectors.getSorting)(getState()), getPageNumByRecordsLimit(partNum, (0, _selectors.getCurrentPageNum)(getState()), NUsersPerPage), _constants.RECORDS_LOAD_LIMIT], function () {
            return false;
        }).then(function (data) {

            dispatch(setUsersWorkAssignmentsCounters(_extends({}, (0, _selectors.getUsersWorkAssignmentsCounters)(getState()), data.map)));

            if (isNeedMoreLoad(NUsersPerPage, partNum)) {
                partNum++;
                dispatch(getUsersForWorkAssignmentTab({ usersFilter: usersFilter, partNum: partNum, tokens: tokens }));
            } else {
                dispatch(setLoading(false));
            }
        }).catch(function (err) {
            dispatch((0, _utils.createActionObject)(ActionTypes.LOAD_USERS_DATA_FAILURE));
            console.error(err);
        });
    };
};

var loadUsersDataAction = exports.loadUsersDataAction = function loadUsersDataAction() {
    return function (dispatch, getState) {
        dispatch((0, _reduxActions.createAction)(ActionTypes.LOAD_USERS_DATA)());

        var usersFilter = (0, _selectors.getUsersFilter)(getState());
        var wordsFilter = (0, _selectors.getWordsFilter)(getState());
        var tokens = new _StringTokenizer2.default(_StringTokenizer2.default.PUNCTUATORS_FOR_SEARCH).getTokens(wordsFilter.toLowerCase());

        dispatch(setLoaded(true));

        (0, _rpcCalls2.default)('UserManagementService.getWorkAssignmentTabSettings', [usersFilter.userIds, usersFilter.groupIds, usersFilter.groupType, usersFilter.allSelected, (0, _selectors.getWorkAssignmentsFilter)(getState()), tokens, (0, _selectors.getSorting)(getState()), (0, _selectors.getCurrentPageNum)(getState()), (0, _selectors.getNUsersPerPage)(getState())], function () {
            return false;
        }).then(function (data) {

            dispatch((0, _utils.createActionObject)(ActionTypes.LOAD_USERS_DATA_SUCCESS, {
                nTotalUsers: data.totalRecords,
                currentPage: data.pageNum
            }));

            if (data.allUserGroups !== null) {
                dispatch((0, _actions.addUserGroups)(data.allUserGroups));
            }
            if (data.allTimeZoneGroups !== null) {
                dispatch((0, _actions.addTimeZoneGroups)(data.allTimeZoneGroups));
            }

            dispatch((0, _utils.createActionObject)(ActionTypes.SET_SUBMITTED_WORDS_FILTER, wordsFilter));
            dispatch((0, _actions2.setEnabledFeatures)(data.viewerSettings.enabledFeatures));
            dispatch((0, _actions3.setViewerSettings)(data.viewerSettings));
            dispatch((0, _actions3.setLicenseCounters)(data.licenseCounters));
            dispatch((0, _actions3.setViewerManagementAssignmentsCounters)(data.viewerManagementAssignmentsCounters));
            dispatch((0, _actions3.setUsersWithoutApprovers)(data.usersWithoutApprovers));

            var newUserIdsSet = (0, _selectors2.getNewUsersIdSet)(getState());

            var userIds = [].concat(_toConsumableArray(Object.keys(newUserIdsSet)), _toConsumableArray(data.records.filter(function (record) {
                return !newUserIdsSet[record.id];
            }).map(function (record) {
                return record.id;
            })));
            dispatch((0, _actions.addUsers)(data.records));
            dispatch(setUserIdsOrder(userIds));

            dispatch(setLoading(true));

            dispatch(getUsersForWorkAssignmentTab({ usersFilter: usersFilter, partNum: 1, tokens: tokens }));
        }).catch(function (err) {
            dispatch((0, _utils.createActionObject)(ActionTypes.LOAD_USERS_DATA_FAILURE));
            console.error(err);
        });
    };
};

var saveUserSettings = exports.saveUserSettings = function saveUserSettings() {
    return function (dispatch, getState) {
        (0, _rpcCalls2.default)('UserManagementService.saveUserSettingsForWorkAssignmentsTab', [JSON.stringify((0, _utils2.createSettingsJsonData)((0, _selectors.getUsersFilter)(getState()), (0, _selectors.getSorting)(getState()), (0, _selectors.getWorkAssignmentsFilter)(getState()), (0, _selectors.getNUsersPerPage)(getState())))], function () {
            return false;
        }).then(function () {}).catch(console.error);
    };
};

var changeSorting = exports.changeSorting = function changeSorting(sorting) {
    return function (dispatch) {
        dispatch((0, _utils.createActionObject)(ActionTypes.SET_SORTING, sorting));
        dispatch(reloadData());
        dispatch(saveUserSettings());
    };
};

var changeUsersFilter = exports.changeUsersFilter = function changeUsersFilter(usersFilter) {
    return function (dispatch) {
        dispatch((0, _utils.createActionObject)(ActionTypes.SET_USERS_FILTER, usersFilter));
        dispatch(reloadData());
        dispatch(saveUserSettings());
    };
};

var changeWordsFilter = exports.changeWordsFilter = function changeWordsFilter(text) {
    return function (dispatch) {
        dispatch((0, _utils.createActionObject)(ActionTypes.SET_WORDS_FILTER, text));
        dispatch(reloadData());
    };
};

var changeUsersPerPage = exports.changeUsersPerPage = function changeUsersPerPage(usersPerPage) {
    return function (dispatch) {
        dispatch((0, _utils.createActionObject)(ActionTypes.SET_USERS_PER_PAGE, usersPerPage));
        dispatch(reloadData());
        dispatch(saveUserSettings());
    };
};

var changeCurrentPageNum = exports.changeCurrentPageNum = function changeCurrentPageNum(pageNum) {
    return function (dispatch) {
        dispatch((0, _utils.createActionObject)(ActionTypes.SET_PAGE_NUM, pageNum));
        dispatch(reloadData());
    };
};

var changeWorkAssignmentsFilter = exports.changeWorkAssignmentsFilter = function changeWorkAssignmentsFilter(filter) {
    return function (dispatch) {
        dispatch((0, _utils.createActionObject)(ActionTypes.SET_WORK_ASSIGNMENTS_FILTER, filter));
        dispatch(reloadData());
        dispatch(saveUserSettings());
    };
};

var reloadData = function reloadData() {
    return function (dispatch) {
        dispatch((0, _actions3.setNewUserIdSet)({}));
        dispatch(setLoaded(false));
    };
};

var setUsersWorkAssignmentsCounters = exports.setUsersWorkAssignmentsCounters = (0, _reduxActions.createAction)(ActionTypes.SET_USERS_WORK_ASSIGNMENTS_COUNTERS);
var setWorkAssignmentsCountersForUser = exports.setWorkAssignmentsCountersForUser = function setWorkAssignmentsCountersForUser(userId, counters) {
    return function (dispatch) {
        dispatch((0, _utils.createActionObject)(ActionTypes.ADD_USER_WORK_ASSIGNMENTS_COUNTERS, _defineProperty({}, userId, counters)));
    };
};

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getDefaultDateRange = exports.saveICalInfoToLocalStorage = exports.getICalInfoFromLocalStorage = exports.sortFeedsBySetting = exports.formatUserName = exports.convertData = exports.getTextForUserSelectionDescription = exports.isUserSelectionEmpty = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _constants = __webpack_require__(51);

var _LocalStorage = __webpack_require__(72);

var _pluralizeUtils = __webpack_require__(40);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _GroupType = __webpack_require__(34);

var _GroupType2 = _interopRequireDefault(_GroupType);

var _UserNameFormat = __webpack_require__(17);

var _UserNameFormat2 = _interopRequireDefault(_UserNameFormat);

var _atUtils = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var isUserSelectionEmpty = exports.isUserSelectionEmpty = function isUserSelectionEmpty(_ref) {
    var all = _ref.all,
        groups = _ref.groups,
        users = _ref.users;
    return !all && groups.length + users.length === 0;
};

var getTextForUserSelectionDescription = exports.getTextForUserSelectionDescription = function getTextForUserSelectionDescription(_ref2, emptySelectionMessageKey) {
    var all = _ref2.all,
        groups = _ref2.groups,
        users = _ref2.users,
        groupType = _ref2.groupType;

    if (all) {
        return _messageResource2.default.getMessage('my_schedule.users_selector.all_users');
    }

    if (isUserSelectionEmpty({ all: all, groups: groups, users: users })) {
        return _messageResource2.default.getMessage(emptySelectionMessageKey);
    }

    if (groups.length + users.length === 1) {
        return groups.length === 0 ? formatUserName(users[0]) : groups[0].name;
    }

    return _getMultipleEntitiesDescription(groups, users, groupType);
};

var _getMultipleEntitiesDescription = function _getMultipleEntitiesDescription(groups, users, groupType) {
    var userGroupNameLower = groupType === _GroupType2.default.TIME_ZONE_GROUP ? _pluralizeUtils.tzgNameLower : _pluralizeUtils.departmentNameLower;
    var shortDescription = '';
    if (groups.length > 0) {
        shortDescription += groups.length + ' ' + userGroupNameLower(groups.length);
    }
    if (groups.length > 0 && users.length > 0) {
        shortDescription += ' ' + _messageResource2.default.getMessage('common.amp') + ' ';
    }
    if (users.length > 0) {
        shortDescription += users.length + ' ' + (0, _pluralizeUtils.userNameLower)(users.length);
    }
    return shortDescription;
};

var convertData = function convertData(feeds, leaveTypes, users, userGroups, timeZoneGroups, recentlyConfiguredId) {
    return Object.values(feeds).map(function (_ref3) {
        var creatorId = _ref3.creatorId,
            editorId = _ref3.editorId,
            leaveTypesFilter = _ref3.leaveTypesFilter,
            usersFilter = _ref3.usersFilter,
            sharedUsersFilter = _ref3.sharedUsersFilter,
            feed = _objectWithoutProperties(_ref3, ['creatorId', 'editorId', 'leaveTypesFilter', 'usersFilter', 'sharedUsersFilter']);

        return _extends({}, feed, {
            recentlyConfiguredFeed: recentlyConfiguredId === feed.id,
            leaveTypes: convertLeaveTypes(leaveTypesFilter, leaveTypes),
            userSelection: convertUserSelection(usersFilter, users, userGroups, timeZoneGroups),
            sharedUserSelection: sharedUsersFilter && convertUserSelection(sharedUsersFilter, users, userGroups, timeZoneGroups),
            creator: users[creatorId],
            editor: editorId ? users[editorId] : null,
            createdDate: new Date(feed.createdDate),
            editedDate: feed.editedDate ? new Date(feed.editedDate) : null,
            lastSyncDate: feed.lastSyncDate ? new Date.parseJSONTime(feed.lastSyncDate) : null
        });
    });
};

exports.convertData = convertData;
var convertLeaveTypes = function convertLeaveTypes(leaveTypesFilter, leaveTypes) {
    return leaveTypesFilter.qualifier === window.LeaveTypeSelectionQualifier.ALL ? Object.values(leaveTypes) : leaveTypesFilter.leaveTypes.filter(function (leaveTypeId) {
        return !!leaveTypes[leaveTypeId];
    }).map(function (leaveTypeId) {
        return leaveTypes[leaveTypeId];
    });
};

var convertUserSelection = function convertUserSelection(usersFilter, users, userGroups, timezoneGroups) {
    var UGREnabled = window.SystemSettings.apUGREnabled;
    var TZGEnabled = window.SystemSettings.apTZGEnabled;

    var usersFilterConverted = (0, _atUtils.convertUsersFilterDependingOnFeatures)(usersFilter, UGREnabled, TZGEnabled, Object.values(users));

    var userSelection = {
        all: usersFilterConverted.all,
        groupType: usersFilterConverted.groupType
    };

    if (!usersFilterConverted.all) {
        var groups = usersFilterConverted.groupType === _GroupType2.default.TIME_ZONE_GROUP ? timezoneGroups : userGroups;
        userSelection.groups = usersFilterConverted.groupIds.map(function (groupId) {
            return groups[groupId];
        }).filter(function (group) {
            return !!group;
        });
        userSelection.users = usersFilterConverted.userIds.map(function (userId) {
            return users[userId];
        }).filter(function (user) {
            return !!user && user.active;
        });
    }
    return userSelection;
};

var formatUserName = exports.formatUserName = function formatUserName(user) {
    return _UserNameFormat2.default.formatFML(user.firstName, user.lastName, user.middleInitial);
};
var formatUserNameLFM = function formatUserNameLFM(user) {
    return _UserNameFormat2.default.formatLFM(user.firstName, user.lastName, user.middleInitial);
};

var _nullSafeComparator = function _nullSafeComparator(firstFeed, secondFeed, getProperty, comparator) {
    var firstProperty = getProperty(firstFeed);
    var secondProperty = getProperty(secondFeed);
    if (firstProperty && secondProperty) {
        return comparator(firstProperty, secondProperty);
    }

    if (!firstProperty && !secondProperty) {
        var comparisonResult = feedByCreatorNameAscComparator(firstFeed, secondFeed);
        if (comparisonResult === 0) {
            comparisonResult = feedByCreatedDateAscComparator(firstFeed, secondFeed);
        }
        return comparisonResult;
    }

    if (firstProperty) {
        return 1;
    }

    return -1;
};

var feedByNameAscComparator = function feedByNameAscComparator(firstFeed, secondFeed) {
    return (0, _atUtils.nameComparator)(firstFeed, secondFeed);
};
var feedByCreatorNameAscComparator = function feedByCreatorNameAscComparator(firstFeed, secondFeed) {
    return (0, _atUtils.stringComparator)(formatUserNameLFM(firstFeed.creator), formatUserNameLFM(secondFeed.creator));
};

var feedByEditorNameAscComparator = function feedByEditorNameAscComparator(firstFeed, secondFeed) {
    return _nullSafeComparator(firstFeed, secondFeed, function (feed) {
        return feed.editor;
    }, function (firstEditor, secondEditor) {
        return (0, _atUtils.stringComparator)(formatUserNameLFM(firstEditor), formatUserNameLFM(secondEditor));
    });
};

var feedByCreatedDateAscComparator = function feedByCreatedDateAscComparator(firstFeed, secondFeed) {
    return (0, _atUtils.numberComparator)(firstFeed.createdDate, secondFeed.createdDate);
};
var feedByEditedDateAscComparator = function feedByEditedDateAscComparator(firstFeed, secondFeed) {
    return _nullSafeComparator(firstFeed, secondFeed, function (feed) {
        return feed.editedDate;
    }, _atUtils.numberComparator);
};
var feedByLastSyncDateAscComparator = function feedByLastSyncDateAscComparator(firstFeed, secondFeed) {
    return _nullSafeComparator(firstFeed, secondFeed, function (feed) {
        return feed.lastSyncDate;
    }, _atUtils.numberComparator);
};

var _createComparatorsMap = function _createComparatorsMap() {
    var map = {};
    map[_constants.SortingProperty.FEED_NAME] = feedByNameAscComparator;
    map[_constants.SortingProperty.CREATOR_NAME] = feedByCreatorNameAscComparator;
    map[_constants.SortingProperty.EDITOR_NAME] = feedByEditorNameAscComparator;
    map[_constants.SortingProperty.CREATED_DATE] = feedByCreatedDateAscComparator;
    map[_constants.SortingProperty.EDITED_DATE] = feedByEditedDateAscComparator;
    map[_constants.SortingProperty.LAST_SYNC] = feedByLastSyncDateAscComparator;
    return map;
};

var _comparatorsMap = _createComparatorsMap();

var sortFeedsBySetting = exports.sortFeedsBySetting = function sortFeedsBySetting(feeds, sorting) {
    return feeds.sort(_comparatorsMap[sorting.property]);
};

var getICalInfoFromLocalStorage = exports.getICalInfoFromLocalStorage = function getICalInfoFromLocalStorage() {
    return (0, _LocalStorage.getLocalStorage)().getItem(_constants.ICALENDAR_KEY);
};

var saveICalInfoToLocalStorage = exports.saveICalInfoToLocalStorage = function saveICalInfoToLocalStorage(_ref4) {
    var activeTab = _ref4.activeTab,
        allSorting = _ref4.allSorting,
        sharedSorting = _ref4.sharedSorting;

    (0, _LocalStorage.getLocalStorage)().setItem(_constants.ICALENDAR_KEY, {
        activeTab: activeTab,
        allSorting: allSorting,
        sharedSorting: sharedSorting
    });
};

var defaultDateRange = null;

var getDefaultDateRange = exports.getDefaultDateRange = function getDefaultDateRange() {
    if (!defaultDateRange) {
        defaultDateRange = {
            qualifier: window.DateRangeSelectionQualifier.CURRENT_YEAR,
            fromDate: window.AT.CurrentYearDateRangeStateInstance.getFromDate(),
            toDate: window.AT.CurrentYearDateRangeStateInstance.getToDate()
        };
    }

    return defaultDateRange;
};

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _utils = __webpack_require__(6);

var _selectors = __webpack_require__(19);

var _ReportEditConfigController = __webpack_require__(593);

var _ReportEditConfigController2 = _interopRequireDefault(_ReportEditConfigController);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _utils.connect)(function (state) {
    return {
        loggedInUserId: (0, _selectors.getLoggedInUserId)(state)
    };
})(_ReportEditConfigController2.default);

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = CSVParametersSection;

var _CSVPreviewSection = __webpack_require__(43);

var _CSVPreviewSection2 = _interopRequireDefault(_CSVPreviewSection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CSVParametersSection() {}

CSVParametersSection.prototype = new _CSVPreviewSection2.default();

CSVParametersSection.prototype.init = function (parametersBuilder, totalNumOfColumns) {
    _CSVPreviewSection2.default.prototype.init.call(this);
    this.parametersBuilder = parametersBuilder;
    this.totalNumOfColumns = totalNumOfColumns;
    return this;
};

CSVParametersSection.prototype.addRows = function (tBody) {
    var params = this.parametersBuilder.getParameters();
    for (var i = 0; i < params.length; i++) {
        var row = this.createRow();
        row.className = "parametersRow" + i;
        ReportPreviewUtils.addCell(row, params[i][0], "paramNameCell");
        ReportPreviewUtils.addCellWithFloatingContent(row, params[i][1]);
        ReportPreviewUtils.addEmptyCells(row, this.totalNumOfColumns - 2);
        this.addRow(tBody, row);
    }

    var emptyRow = this.createRow();
    ReportPreviewUtils.addEmptyCells(emptyRow, this.totalNumOfColumns);
    this.addRow(tBody, emptyRow);
};

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _LeaveReportConfig = __webpack_require__(129);

var _constants = __webpack_require__(4);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _date_format = __webpack_require__(16);

var _index = __webpack_require__(22);

var _constants2 = __webpack_require__(4);

var _ParametersFormatter = __webpack_require__(592);

var _ParametersFormatter2 = _interopRequireDefault(_ParametersFormatter);

var _FormatUtils = __webpack_require__(142);

var _FormatUtils2 = _interopRequireDefault(_FormatUtils);

var _ATReportParamsStringBuilder = __webpack_require__(52);

var _ATReportParamsStringBuilder2 = _interopRequireDefault(_ATReportParamsStringBuilder);

var _atUtils = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ReportPrintableHeadersBuilder = function ReportPrintableHeadersBuilder() {};

ReportPrintableHeadersBuilder.prototype.init = function (data) {
    this.isFilteredByAssignments = data.isFilteredByAssignments;

    this.paramStringBuilder = new _ATReportParamsStringBuilder2.default({
        data: {
            users: data.users,
            userGroupsFeatureEnabled: (0, _index.isEnabled)(_index.Feature.UGR),
            userGroups: data.userGroups,
            timeZoneGroups: data.timeZoneGroups,
            cpList: data.cpList,
            leaveTypesMap: data.leaveTypesMap,
            manageableUserIds: ATReportsStore.getManageableUserIds(),
            projectsWithMaIds: ATReportsStore.getProjectsWithMaIds()
        },
        reportAuthorizationInfo: ATReportsStore.getReportAuthorizationInfo()
    });

    return this;
};

ReportPrintableHeadersBuilder.prototype._customerFormatter = {
    format: function format(customer) {
        return customer.name;
    }
};

ReportPrintableHeadersBuilder.prototype._projectFormatter = {
    format: function format(project) {
        return project.name;
    }
};

ReportPrintableHeadersBuilder.prototype._userFormatter = {
    format: function format(user) {
        return _FormatUtils2.default.getFormattedUser(user.firstName, user.lastName, user.middleName, user.username);
    }
};

ReportPrintableHeadersBuilder.prototype._userGroupFormatter = {
    format: function format(group) {
        return group.name;
    }
};

ReportPrintableHeadersBuilder.prototype._leaveTypesFormatter = {
    format: function format(leaveType) {
        return leaveType.name;
    }
};

ReportPrintableHeadersBuilder.prototype._getCPKeySuffix = function () {
    return this.isFilteredByAssignments ? '_filtered' : '';
};

ReportPrintableHeadersBuilder.prototype._toEmphasis = function (str) {
    return '<span class="param">' + str + '</span>';
};

ReportPrintableHeadersBuilder.prototype._getNames = function (objects, formatter, delimiter) {
    if (!delimiter) delimiter = ',';
    var names = '';
    for (var i = 0; i < objects.length - 1; i++) {
        names += formatter.format(objects[i]) + delimiter + ' ';
    }
    if (objects.length) {
        names += formatter.format(objects[objects.length - 1]);
    }
    return (0, _atUtils.escapeHtmlSymbols)(names);
};

ReportPrintableHeadersBuilder.prototype.addCPSelectionParamsStringToArray = function (cpSelection, array) {
    var keySuffix = this._getCPKeySuffix();

    if (cpSelection.qualifier === _constants.CustomersProjectsSelectionQualifier.ALL_ACTIVE || cpSelection.qualifier === _constants.CustomersProjectsSelectionQualifier.ALL) {
        var activeOnly = cpSelection.qualifier === _constants.CustomersProjectsSelectionQualifier.ALL_ACTIVE;
        var label = _messageResource2.default.getEscapedMessage('projects_customers_selector.customers_and_projects') + ':';
        var value = void 0;
        if (activeOnly) value = _messageResource2.default.getEscapedMessage("projects_customers_selector.all_active_projects_customers" + keySuffix);else value = _messageResource2.default.getEscapedMessage("projects_customers_selector.all_projects_customers" + keySuffix);
        array.push(new PrintableHeader().init(label, value));
    } else {
        var customers = this.paramStringBuilder.getFilteredCustomers(cpSelection);
        var projects = this.paramStringBuilder.getFilteredProjects(cpSelection);
        var _label = void 0,
            names = void 0;

        if (customers.length) {
            var customerKey = customers.length === 1 ? "common.Customer" : "common.Customers";
            _label = _messageResource2.default.getEscapedMessage(customerKey) + ':';

            var postfix = "projects_customers_selector.with_all_projects" + keySuffix;

            postfix = this._toEmphasis(_messageResource2.default.getEscapedMessage(postfix));
            names = this._getNames(customers, this._customerFormatter) + ' ' + postfix;
            array.push(new PrintableHeader().init(_label, names));
        }
        names = '';
        if (projects.length) {
            var projectKey = projects.length === 1 ? "common.Project" : "common.Projects";
            _label = _messageResource2.default.getEscapedMessage(projectKey) + ':';

            names = this._getNames(projects, this._projectFormatter);
            array.push(new PrintableHeader().init(_label, names));
        } else if (customers.length === 0) {
            array.push(new PrintableHeader().init(_messageResource2.default.getEscapedMessage('common.Projects') + ':', _messageResource2.default.getEscapedMessage('report.no_projects')));
        }
    }
};

ReportPrintableHeadersBuilder.prototype.addStaffSelectionParamsToArray = function (userSelection, array) {
    var label = this._getStaffSelectionLabelToArray();
    array.push(new PrintableHeader().init(label, (0, _atUtils.escapeHtmlSymbols)(this.paramStringBuilder.getUserSelectionParamString(userSelection))));
};

ReportPrintableHeadersBuilder.prototype._getStaffSelectionLabelToArray = function () {
    return _messageResource2.default.getMessage("report.staff_label");
};

ReportPrintableHeadersBuilder.prototype.addTimeApprovalStatusToArray = function (timeApprovalStatus, array) {
    if ((0, _index.isEnabled)(_index.Feature.TTA) || timeApprovalStatus !== _constants2.TimeApprovalStatus.BOTH) {
        var label = _messageResource2.default.getMessage("report.time_track_status") + ":";
        var value = '';

        switch (timeApprovalStatus) {
            case _constants2.TimeApprovalStatus.BOTH:
                {
                    value = _messageResource2.default.getMessage("report.form.show_both_approved_and_not");
                    break;
                }
            case _constants2.TimeApprovalStatus.APPROVED:
                {
                    value = _messageResource2.default.getMessage("report.form.show_only_approved");
                    break;
                }
            case _constants2.TimeApprovalStatus.NOT_APPROVED:
                {
                    value = _messageResource2.default.getMessage("report.form.show_only_not_approved");
                    break;
                }
        }
        array.push(new PrintableHeader().init(label, value));
    }
};

ReportPrintableHeadersBuilder.prototype.addDateRangeHeaderString = function (dateRangeSelection) {
    return _messageResource2.default.getMessage("range.custom.pattern", [new _date_format.DateFormat(window.SystemSettings.dateFormat).formatDate(dateRangeSelection.fromDate.parseJSONDate()), new _date_format.DateFormat(window.SystemSettings.dateFormat).formatDate(dateRangeSelection.toDate.parseJSONDate())]);
};

ReportPrintableHeadersBuilder.prototype.addDateRangeHeaderStringParsed = function (dateRangeSelection) {
    return _messageResource2.default.getMessage("range.custom.pattern", [new _date_format.DateFormat(window.SystemSettings.dateFormat).formatDate(dateRangeSelection.fromDate), new _date_format.DateFormat(window.SystemSettings.dateFormat).formatDate(dateRangeSelection.toDate)]);
};

ReportPrintableHeadersBuilder.prototype.addEvaDateHeaderString = function (dateSelection) {
    return _messageResource2.default.getMessage("report.budgeted_vs_actual.view.printable_date_range_prefix") + ' ' + new _date_format.DateFormat(window.SystemSettings.dateFormat).formatDate(dateSelection.date.parseJSONDate());
};

ReportPrintableHeadersBuilder.prototype.addEvaDateHeaderStringParsed = function (dateSelection) {
    return _messageResource2.default.getMessage("report.budgeted_vs_actual.view.printable_date_range_prefix") + ' ' + new _date_format.DateFormat(window.SystemSettings.dateFormat).formatDate(dateSelection.date);
};

ReportPrintableHeadersBuilder.prototype.addLeaveTypesParamsToArray = function (leaveTypeSelection, columnsConfig, array) {
    if (columnsConfig === _LeaveReportConfig.LeaveTypeColumnConfig.BALANCES_ONLY) return;

    var label = _messageResource2.default.getMessage("report.leave_types.label");
    var value = '';

    switch (leaveTypeSelection.qualifier) {
        case _constants2.LeaveTypeSelectionQualifier.ALL:
            {
                value = _messageResource2.default.getMessage("report.leave_types.all");
                break;
            }
        case _constants2.LeaveTypeSelectionQualifier.SELECTED:
            {
                var leaveTypes = this.paramStringBuilder.getFilteredLeaveTypes(leaveTypeSelection.leaveTypes);
                value = this._getNames(leaveTypes, this._leaveTypesFormatter);
                break;
            }
    }
    array.push(new PrintableHeader().init(label, value));
};

ReportPrintableHeadersBuilder.prototype.addTaskSelectionParamsStringToArray = function (tasksConfig, includeNotEstimated, includeNotStarted, dateSelectionJSON, array) {
    var label = _messageResource2.default.getEscapedMessage("common.Tasks") + ':';
    var value = new _ParametersFormatter2.default().init({}).formatTaskSelectionParamsString(tasksConfig, includeNotEstimated, includeNotStarted, {
        dateSelection: dateSelectionJSON,
        isParsed: true
    });

    array.push(new PrintableHeader().init(label, (0, _atUtils.escapeHtmlSymbols)(value)));
};

ReportPrintableHeadersBuilder.prototype.addBillableTaskSelectionParamsStringToArray = function (reportInfo, array) {
    var messageKey = '';
    switch (reportInfo) {
        case _constants2.BillingSummaryReportInfo.TIME_ON_NON_BILLABLE_TASKS:
            messageKey = "report.billing_summary.non_billable_only";
            break;
        case _constants2.BillingSummaryReportInfo.TIME_ON_BOTH_BILLABLE_AND_NON_BILLABLE_TASKS:
            messageKey = "report.billing_summary.billable_nonbillable";
            break;
        default:
            messageKey = "report.billing_summary.billable_only";
    }
    array.push(new PrintableHeader().init(_messageResource2.default.getEscapedMessage("common.Tasks") + ":", _messageResource2.default.getEscapedMessage(messageKey)));
};

ReportPrintableHeadersBuilder.prototype.addBillableReportTypeParamsStringToArray = function (reportType, array) {
    var label = _messageResource2.default.getMessage("report.billing_summary.report_type_label");
    var messageKey = '';
    switch (reportType) {
        case "ALL_TIME_WITHIN_DATE_RANGE":
            messageKey = "report.billing_summary.time_for_date_range";
            break;
        case "ONLY_FOR_COMPLETED_TASKS":
            messageKey = "report.billing_summary.time_task_completed_for_date_range";
            break;
    }
    array.push(new PrintableHeader().init(label, _messageResource2.default.getEscapedMessage(messageKey)));
};

var PrintableHeader = function () {
    function PrintableHeader() {
        _classCallCheck(this, PrintableHeader);
    }

    _createClass(PrintableHeader, [{
        key: "init",
        value: function init(label, value) {
            this.label = label;
            this.value = value;
            return this;
        }
    }]);

    return PrintableHeader;
}();

exports.default = ReportPrintableHeadersBuilder;

/***/ }),
/* 172 */
/***/ (function(module, exports) {

module.exports = false;


/***/ }),
/* 173 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 174 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(38);
var dPs = __webpack_require__(608);
var enumBugKeys = __webpack_require__(422);
var IE_PROTO = __webpack_require__(420)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(419)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(423).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(609);
var enumBugKeys = __webpack_require__(422);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(111);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(609);
var hiddenKeys = __webpack_require__(422).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getRawTag_js__ = __webpack_require__(1173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objectToString_js__ = __webpack_require__(1174);




/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? Object(__WEBPACK_IMPORTED_MODULE_1__getRawTag_js__["a" /* default */])(value)
    : Object(__WEBPACK_IMPORTED_MODULE_2__objectToString_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (baseGetTag);


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ENABLED_STATUS_MESSAGE_KEY_BY_STATUS = exports.enabledStatus = exports.apiExceptions = exports.ValidationErrors = exports.NEW_STATUS_COLOR_ID = exports.NEW_STATUS_ID = undefined;

var _ENABLED_STATUS_MESSA;

var _constants = __webpack_require__(23);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var NEW_STATUS_ID = exports.NEW_STATUS_ID = -1;
var NEW_STATUS_COLOR_ID = exports.NEW_STATUS_COLOR_ID = _constants.DEFAULT_COLOR_ID;

var ValidationErrors = exports.ValidationErrors = {
    DUPLICATE_NAME_ERROR: 'DUPLICATE_NAME_ERROR',
    EMPTY_NAME_ERROR: 'EMPTY_NAME_ERROR',
    STATUS_DELETED: 'STATUS_DELETED',
    STATUS_IN_USE: 'STATUS_IN_USE',
    STATUS_IS_LAST: 'STATUS_IS_LAST'
};

var apiExceptions = exports.apiExceptions = {
    FEATURE_DISABLED_EXCEPTION: 'com.actimind.actitime.services.FeatureIsDisabledException',
    DUPLICATE_NAME_EXCEPTION: 'com.actimind.actitime.services.WorkflowStatusNameDuplicateException',
    STATUS_DELETED_EXCEPTION: 'com.actimind.actitime.services.WorkflowStatusConcurrentlyDeletedException',
    STATUS_IN_USE_EXCEPTION: 'com.actimind.actitime.services.WorkflowStatusIsInUseException',
    STATUS_IS_LAST_EXCEPTION: 'com.actimind.actitime.services.WorkflowStatusIsLastException'
};

var enabledStatus = exports.enabledStatus = {
    ENABLED: 'ENABLED',
    IN_USE: 'IN_USE',
    LAST: 'LAST'
};

var ENABLED_STATUS_MESSAGE_KEY_BY_STATUS = exports.ENABLED_STATUS_MESSAGE_KEY_BY_STATUS = (_ENABLED_STATUS_MESSA = {}, _defineProperty(_ENABLED_STATUS_MESSA, enabledStatus.IN_USE, 'workflow_settings.errors.status_in_use'), _defineProperty(_ENABLED_STATUS_MESSA, enabledStatus.LAST, 'workflow_settings.errors.status_is_last'), _ENABLED_STATUS_MESSA);

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var supportFormMode = exports.supportFormMode = {
    EDITOR: 'editor',
    SUCCESS: 'success'
};

var supportPopupPositionStrategy = exports.supportPopupPositionStrategy = {
    CENTER: 'center',
    FROM_TOP_LEFT: 'fromTopLeft',
    FROM_BOTTOM_RIGHT: 'fromBottomRight'
};

var supportPopupOffsets = exports.supportPopupOffsets = {
    LEFT: 32,
    TOP: -30
};

var NO_DRAG_CLASS = exports.NO_DRAG_CLASS = 'noDragClass';
var SUPPORT_NUMBER_ALLOWED_CHARACTERS = exports.SUPPORT_NUMBER_ALLOWED_CHARACTERS = 32000;
var SUPPORT_INPUT_HEIGHT = exports.SUPPORT_INPUT_HEIGHT = 125;
var SUPPORT_EMAIL_NUMBER_ALLOWED_CHARACTERS = exports.SUPPORT_EMAIL_NUMBER_ALLOWED_CHARACTERS = 255;

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _DropdownTemplateView2 = __webpack_require__(42);

var _DropdownTemplateView3 = _interopRequireDefault(_DropdownTemplateView2);

var _atBrowserUtils = __webpack_require__(8);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DropdownDialogWithPointerWrapper = function (_DropdownTemplateView) {
    _inherits(DropdownDialogWithPointerWrapper, _DropdownTemplateView);

    function DropdownDialogWithPointerWrapper(_ref) {
        var _ref$toggleMode = _ref.toggleMode,
            toggleMode = _ref$toggleMode === undefined ? false : _ref$toggleMode,
            _ref$additionalClass = _ref.additionalClass,
            additionalClass = _ref$additionalClass === undefined ? "" : _ref$additionalClass,
            showAnimationClass = _ref.showAnimationClass,
            hideAnimationClass = _ref.hideAnimationClass,
            dialog = _ref.dialog,
            _ref$dialogOffsets = _ref.dialogOffsets,
            dialogOffsets = _ref$dialogOffsets === undefined ? {
            left: 0,
            top: 0
        } : _ref$dialogOffsets,
            _ref$pointerHorizonta = _ref.pointerHorizontalAlignments,
            pointerHorizontalAlignments = _ref$pointerHorizonta === undefined ? {
            my: "center",
            at: "center"
        } : _ref$pointerHorizonta,
            _ref$pointerLeftOffse = _ref.pointerLeftOffset,
            pointerLeftOffset = _ref$pointerLeftOffse === undefined ? 0 : _ref$pointerLeftOffse,
            _ref$onHide = _ref.onHide,
            onHide = _ref$onHide === undefined ? function () {} : _ref$onHide;

        _classCallCheck(this, DropdownDialogWithPointerWrapper);

        var _this = _possibleConstructorReturn(this, (DropdownDialogWithPointerWrapper.__proto__ || Object.getPrototypeOf(DropdownDialogWithPointerWrapper)).call(this, null, {
            toggleMode: toggleMode,
            onHide: onHide
        }));

        _this.params = _extends({}, _this.params, {
            additionalClass: additionalClass,
            showAnimationClass: showAnimationClass,
            hideAnimationClass: hideAnimationClass,
            dialog: dialog,
            pointerLeftOffset: pointerLeftOffset,
            dialogOffsets: dialogOffsets,
            pointerHorizontalAlignments: pointerHorizontalAlignments
        });
        return _this;
    }

    _createClass(DropdownDialogWithPointerWrapper, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class="dropdownDialogWithPointerWrapper <%=additionalClass%>">' + '  <div class="content"></div>' + '  <div class="pointer"></div>' + '</div>';
        }
    }, {
        key: 'templateModel',
        value: function templateModel() {
            return {
                additionalClass: this.params.additionalClass
            };
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            _get(DropdownDialogWithPointerWrapper.prototype.__proto__ || Object.getPrototypeOf(DropdownDialogWithPointerWrapper.prototype), 'afterRender', this).call(this);

            this.$content = this.find('.content');
            this.$pointer = this.find('.pointer');
            this.params.dialog.init(this.$content);
            this.$content.hide();
            this.registerChildComponents(this.params.dialog);
        }
    }, {
        key: 'show',
        value: function show() {
            _get(DropdownDialogWithPointerWrapper.prototype.__proto__ || Object.getPrototypeOf(DropdownDialogWithPointerWrapper.prototype), 'show', this).call(this);
            if (this.params.showAnimationClass) {
                this.$content.atAnimation().showAnimated(this.params.showAnimationClass);
            } else {
                this.$content.show();
            }
        }
    }, {
        key: 'hide',
        value: function hide() {
            var _this2 = this;

            var animated = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            if (animated && this.params.hideAnimationClass) {
                this.$content.atAnimation().hideAnimated(this.params.hideAnimationClass, function () {
                    return _get(DropdownDialogWithPointerWrapper.prototype.__proto__ || Object.getPrototypeOf(DropdownDialogWithPointerWrapper.prototype), 'hide', _this2).call(_this2, true);
                });
            } else {
                this.$content.hide();
                _get(DropdownDialogWithPointerWrapper.prototype.__proto__ || Object.getPrototypeOf(DropdownDialogWithPointerWrapper.prototype), 'hide', this).call(this);
            }
        }
    }, {
        key: 'showAt',
        value: function showAt($element) {
            var positionParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            var $positionEl = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $element;

            _get(DropdownDialogWithPointerWrapper.prototype.__proto__ || Object.getPrototypeOf(DropdownDialogWithPointerWrapper.prototype), 'showAt', this).call(this, $element, _extends({
                offset: this.params.dialogOffsets.left + 'px ' + this.params.dialogOffsets.top + 'px'
            }, positionParams), $positionEl);
            this._adjustPointer($positionEl);
        }
    }, {
        key: '_adjustPointer',
        value: function _adjustPointer($element) {
            this.getEl().removeClass("pointerAbove pointerBelow pointerLeft");

            var pointerHeight = this.$pointer.height();
            var pointerPositionParams = {};

            if (this.$el.offset().left > $element.offset().left) {
                this.$el.addClass("pointerLeft");
                var leftOffset = this.params.dialogOffsets.left - this.$pointer.width();
                pointerPositionParams = {
                    my: "left center",
                    at: "right center",
                    of: $element,
                    offset: leftOffset + "px " + 0 + "px"
                };
            } else if (this.$el.offset().top < $element.offset().top) {
                this.$el.addClass("pointerBelow");

                var topOffset = -($element.offset().top - this.$el.offset().top - this.$el.outerHeight() - pointerHeight);
                pointerPositionParams = {
                    my: "center bottom",
                    at: "center top",
                    of: $element,
                    offset: this.params.pointerLeftOffset + "px " + topOffset + "px"
                };
            } else {
                this.getEl().addClass("pointerAbove");

                var _topOffset = this.$el.offset().top - $element.offset().top - $element.outerHeight() - pointerHeight;
                pointerPositionParams = {
                    my: "center top",
                    at: "center bottom",
                    of: $element,
                    offset: this.params.pointerLeftOffset + "px " + _topOffset + "px"
                };
            }

            (0, _atBrowserUtils.showElementAt)(this.$pointer, pointerPositionParams);
        }
    }, {
        key: 'setState',
        value: function setState(state) {
            _get(DropdownDialogWithPointerWrapper.prototype.__proto__ || Object.getPrototypeOf(DropdownDialogWithPointerWrapper.prototype), 'setState', this).call(this, state);
            this.applyForChildrenComponents(function (child) {
                return child.setState(state);
            });
        }
    }, {
        key: 'update',
        value: function update() {
            _get(DropdownDialogWithPointerWrapper.prototype.__proto__ || Object.getPrototypeOf(DropdownDialogWithPointerWrapper.prototype), 'update', this).call(this);
            this.applyForChildrenComponents(function (child) {
                return child.update();
            });
        }
    }, {
        key: 'mouseDownTargetElement',
        value: function mouseDownTargetElement() {
            return (0, _jquery2.default)('body');
        }
    }]);

    return DropdownDialogWithPointerWrapper;
}(_DropdownTemplateView3.default);

exports.default = DropdownDialogWithPointerWrapper;

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _atBrowserUtils = __webpack_require__(8);

var _raf = __webpack_require__(1293);

var _raf2 = _interopRequireDefault(_raf);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Tooltip = function (_TemplateView) {
    _inherits(Tooltip, _TemplateView);

    function Tooltip($containerEl) {
        _classCallCheck(this, Tooltip);

        var _this = _possibleConstructorReturn(this, (Tooltip.__proto__ || Object.getPrototypeOf(Tooltip)).call(this, $containerEl));

        _this.autoFollowMouseCursor = true;
        return _this;
    }

    _createClass(Tooltip, [{
        key: "moveAfterCursor",
        value: function moveAfterCursor(event) {
            var _this2 = this;

            if (this._disabled || !this._visible) return;

            (0, _raf2.default)(function () {
                return _this2._positionTooltip(event);
            });
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            this.$el.hide();
            this.$el.addClass("yellowTooltip tooltipTex noprint");
        }
    }, {
        key: "show",
        value: function show() {
            if (!this._visible) {
                this._visible = true;
                if (!this._disabled) this.$el.show();
            }
        }
    }, {
        key: "hide",
        value: function hide() {
            if (this._visible) {
                this._visible = false;
                if (!this._disabled) this.$el.hide();
            }
        }
    }, {
        key: "enable",
        value: function enable() {
            this._disabled = false;
            if (this._visible) this.$el.show();
        }
    }, {
        key: "disable",
        value: function disable() {
            this._disabled = true;
            if (this._visible) this.$el.hide();
        }
    }, {
        key: "toggle",
        value: function toggle(show) {
            if (show) this.enable();else this.disable();
        }
    }, {
        key: "setEnabled",
        value: function setEnabled(enabled) {
            if (enabled) this.enable();else this.disable();
        }
    }, {
        key: "subscribeToMouseEvents",
        value: function subscribeToMouseEvents($el, beforeShowCallback) {
            var _this3 = this;

            var showHandler = function showHandler(e) {
                if (beforeShowCallback) beforeShowCallback();
                if (_this3.autoFollowMouseCursor) _this3._positionTooltip(e);
                _this3.show();
            };
            var hideHandler = function hideHandler() {
                return _this3.hide();
            };
            var moveHandler = function moveHandler(e) {
                return _this3.moveAfterCursor(e);
            };

            $el.on('mouseenter', showHandler).on('mouseleave', hideHandler).on('wheel', hideHandler);

            if (this.autoFollowMouseCursor) $el.on('mousemove', moveHandler);

            return function () {
                $el.off('mouseenter', showHandler).off('mousemove', moveHandler).off('mouseleave', hideHandler).off('wheel', hideHandler);
            };
        }
    }, {
        key: "_positionTooltip",
        value: function _positionTooltip(event) {
            var tooltipWidth = this.$el.outerWidth();
            var tooltipHeight = this.$el.outerHeight();
            var xOffset = 15;
            var yOffset = 15;
            var minDistanceToBorderX = 15;
            var minDistanceToBorderY = 15;

            var x = event.clientX + xOffset;
            if (x + tooltipWidth + minDistanceToBorderX > (0, _jquery2.default)(window).width()) x -= tooltipWidth + xOffset;

            var y = event.clientY + yOffset;
            if (y + tooltipHeight + minDistanceToBorderY > (0, _jquery2.default)(window).height()) y -= tooltipHeight + yOffset;

            var top = y + (0, _atBrowserUtils.getBodyScrollTop)();
            var left = x + (0, _atBrowserUtils.getBodyScrollLeft)();

            // Via HTML instead jQuery for IE
            this.$el[0].style.top = top + "px";
            this.$el[0].style.left = left + "px";
        }
    }]);

    return Tooltip;
}(_TemplateView3.default);

exports.default = Tooltip;

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = KeyDownHandler;
/**
 * @Deprecated try to use js/keyHandlers
 * Object for key down handler manipulating.
 */
function KeyDownHandler() {}

/**
 * @Deprecated
 * Sets key down handler to the document, saves old handler.
 * @param userFunction
 */
KeyDownHandler.setOnKeyDownHandler = function (userFunction) {
    if (!this.oldDocumentKeydownHandler) this.oldDocumentKeydownHandler = new Array();
    this.oldDocumentKeydownHandler.push(document.onkeydown);

    document.onkeydown = function (event) {
        userFunction(event);
    };
};

/**
 * Restores key down handler saved by KeyDownHandler.setOnKeyDownHandler.
 */
KeyDownHandler.restoreOnKeyDownHandler = function () {
    var oldHandler;
    if (this.oldDocumentKeydownHandler && (oldHandler = this.oldDocumentKeydownHandler.pop())) {
        document.onkeydown = oldHandler;
    } else {
        document.onkeydown = null; // We assign null to onkeydown if old handler was undefined,
        // because assigning undefined value fails under IE.
    }
};

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _atBrowserUtils = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @author kostenko
 *
 * @constructor
 *
 * @param config configuration object
 *
 * @config dialogDiv HTML div with dialog content (a selector, element, jQuery object or HTML snippet)
 * @config [onOkClick] function to perform after the user clicks 'OK' button, but before the dialog is closed.
 *                     Must return true to close the dialog and false to cancel closing
 *                     Mandatory if hideButtons is false.
 * @config [onClose] function to perform when the dialog is closed (either way)
 * @config [okButtonText] text for the 'OK' button ('OK' by default)
 * @config [cancelButtonText] text for the 'Cancel' button ('Cancel' by default)
 * @config [buttonsPlaceholder] buttons placeholder (a selector, element, or jQuery object)
 *                              (if not specified, a standard button pane will be shown)
 * @config [hideButtons] if true, then button pane won't be displayed (false by default)
 * @config [wrapperClass] additional class for wrapper. (ignore by default)
 * @config [isWithBeak] if true, then dialog will be with beak (false by default)
 * @config [beakOnBottom] if true, then beak will be on bottom (false by default, ignored when isWithBeak==false)
 * @config [notModal] if true, then dialog won't be modal, and there will be no overlay to handle 'outside' clicks to close the dialog (false by default)
 * @config [hideOnResize] if true, then dialog will be hidden on window resize (false by default)
 * @config [showEmptyTitleBar] if true, title bar will be visible even if title is empty
 */
function DropdownDialog(config) {
    /**
     * Shows the dialog at the specified element (e.g. a button).
     * @param element HTML element to show the dialog at (a selector, element, or jQuery object)
     * @param positionParams params which will be user is positioning (if not specified, default params will be used)
     * @positionParams [my]
     * @positionParams [at]
     * @positionParams [offset]
     * @positionParams [collision]
     */
    this.showAt = function (element, positionParams) {
        dialog.dialog('open');

        if (!positionParams) positionParams = {};
        positionParams.of = (0, _jquery2.default)(element);
        (0, _atBrowserUtils.showElementAt)(wrapper, positionParams);

        var outside = (0, _jquery2.default)('.ui-widget-overlay');
        if (config.outsideClickCallback) outside.click(config.outsideClickCallback);else {
            // close the dialog when user clicks outside
            outside.click(function () {
                dialog.dialog('close');
            });
        }

        if (config.hideOnResize) this.removeListenersFn = (0, _atBrowserUtils.doOnceOnWindowResize)(function () {
            dialog.dialog('close');
            if (config.hideOnResizeCallback) config.hideOnResizeCallback();
        });
    };

    this.hide = function () {
        dialog.dialog('close');
        if (this.removeListenersFn) this.removeListenersFn();
        this.removeListenersFn = null;
    };

    this.getWrapper = function () {
        return dialog.parent();
    };

    this.removeOverlay = function () {
        (0, _jquery2.default)('.ui-widget-overlay').remove();
    };

    /**
     * After calling this method it would be impossible to close the dialog in any way.
     * It also applies 'disabled' class to the close button element, so it can be styled as disabled.
     */
    this.preventClose = function () {
        dialog.on("dialogbeforeclose", false);
        wrapper.find(".ui-dialog-titlebar-close").addClass("disabled");
    };

    /**
     * Call this method to allow closing the dialog again.
     */
    this.allowClose = function () {
        dialog.off("dialogbeforeclose");
        wrapper.find(".ui-dialog-titlebar-close").removeClass("disabled");
    };

    this.setBeak = function (beakOnBottom) {
        wrapper.toggleClass("ui-dialog-with-top-beak", !beakOnBottom);
        wrapper.toggleClass("ui-dialog-with-bottom-beak", !!beakOnBottom);
    };

    // ---------- private ----------

    // If the provided div is an HTML snippet, we must insert it into DOM.
    // Actually, jQuery UI Dialog can accept HTML snippet, but we cannot determine its width until it is in DOM.
    // And we need its width to initialize jQuery UI Dialog, to allow the user to use CSS to set the width.
    if (_jquery2.default.type(config.dialogDiv) == "string") config.dialogDiv = (0, _jquery2.default)(config.dialogDiv).appendTo('body');

    var dialog = (0, _jquery2.default)(config.dialogDiv).dialog({
        autoOpen: false,
        draggable: false,
        resizable: false,
        modal: !config.notModal, // this is needed for overlay to appear, so we can handle 'outside' clicks to close the dialog
        buttons: [{
            text: config.okButtonText || 'OK',
            click: function click() {
                if (config.onOkClick()) dialog.dialog('close');
            }
        }, {
            text: config.cancelButtonText || 'Cancel',
            click: function click() {
                dialog.dialog('close');
            }
        }],
        close: config.onClose,
        width: (0, _jquery2.default)(config.dialogDiv).width(), // this is why we need the dialog div to be in DOM already
        minHeight: 0,
        //TODO: needs zindex refactoring
        zIndex: config.zIndex,
        closeOnEscape: _underscore2.default.isUndefined(config.closeOnEscape) ? true : config.closeOnEscape
    });

    // when the dialog is created, it is wrapped into a container, let's store the reference to it
    var wrapper = dialog.parent();

    if (config.wrapperClass) {
        wrapper.addClass(config.wrapperClass);
    }

    var ua = navigator.userAgent.toLowerCase();
    var isIE8 = ua.indexOf("msie 8") > -1;
    var isIE7 = ua.indexOf("msie 7") > -1;

    if (config.isWithBeak && !isIE8 && !isIE7) {
        wrapper.addClass("ui-dialog-with-beak");
        this.setBeak(!!config.beakOnBottom);
    }

    if (config.hideButtons) {
        wrapper.find('.ui-dialog-buttonpane').hide();
    } else if (config.buttonsPlaceholder) {
        wrapper.find('.ui-dialog-buttonset').appendTo(dialog.find(config.buttonsPlaceholder));
        wrapper.find('.ui-dialog-buttonpane').hide();
    }

    if (!config.showEmptyTitleBar && !dialog.dialog('option', 'title')) wrapper.find('.ui-dialog-titlebar').hide();
}

exports.default = DropdownDialog;

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TimeZoneGroupValidatorStrategy = TimeZoneGroupValidatorStrategy;
exports.UserGroupValidatorStrategy = UserGroupValidatorStrategy;

var _atUtils = __webpack_require__(5);

/**
 * Created by filatov on 23.03.2016.
 */

function GroupValidatorStrategy() {}

GroupValidatorStrategy.prototype.isNullGroup = function (group) {
    //abstract;
};

GroupValidatorStrategy.prototype.isDefaultGroup = function (group) {
    //abstract;
};

/* TimeZoneGroupValidatorStrategy*/
function TimeZoneGroupValidatorStrategy() {}

TimeZoneGroupValidatorStrategy.prototype = new GroupValidatorStrategy();

TimeZoneGroupValidatorStrategy.prototype.isNullGroup = function (group) {
    return false;
};

TimeZoneGroupValidatorStrategy.prototype.isDefaultGroup = function (group) {
    return group.id == window.DEFAULT_TIME_ZONE_GROUP_ID;
};

TimeZoneGroupValidatorStrategy.prototype.getComparator = function () {
    var self = this;
    return function groupComparator(a, b) {
        if (self.isDefaultGroup(a)) {
            return self.isDefaultGroup(b) ? 0 : -1;
        }
        if (self.isDefaultGroup(b)) {
            return 1;
        }
        return (0, _atUtils.stringComparator)(a.name, b.name);
    };
};

/* UserGroupValidatorStrategy*/
function UserGroupValidatorStrategy() {}

UserGroupValidatorStrategy.prototype = new GroupValidatorStrategy();

UserGroupValidatorStrategy.prototype.isNullGroup = function (group) {
    return group.id == window.USERS_WITHOUT_GROUP_ID;
};

UserGroupValidatorStrategy.prototype.isDefaultGroup = function (group) {
    return false;
};

UserGroupValidatorStrategy.prototype.getComparator = function () {
    var self = this;
    return function groupComparator(a, b) {
        if (self.isNullGroup(a)) {
            return self.isNullGroup(b) ? 0 : -1;
        }
        if (self.isNullGroup(b)) {
            return 1;
        }
        return (0, _atUtils.stringComparator)(a.name, b.name);
    };
};

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _SimpleListMenu = __webpack_require__(1326);

var _SimpleListMenu2 = _interopRequireDefault(_SimpleListMenu);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SimpleListMenuButton = function (_TemplateView) {
    _inherits(SimpleListMenuButton, _TemplateView);

    function SimpleListMenuButton(_ref) {
        var _ref$itemHtmlCallback = _ref.itemHtmlCallback,
            itemHtmlCallback = _ref$itemHtmlCallback === undefined ? function (item) {
            return "<div></div>";
        } : _ref$itemHtmlCallback,
            _ref$emptySelectionMe = _ref.emptySelectionMessageKey,
            emptySelectionMessageKey = _ref$emptySelectionMe === undefined ? null : _ref$emptySelectionMe,
            _ref$emptyListMessage = _ref.emptyListMessageKey,
            emptyListMessageKey = _ref$emptyListMessage === undefined ? null : _ref$emptyListMessage,
            _ref$extraClass = _ref.extraClass,
            extraClass = _ref$extraClass === undefined ? "" : _ref$extraClass,
            _ref$menuPositionPara = _ref.menuPositionParams,
            menuPositionParams = _ref$menuPositionPara === undefined ? null : _ref$menuPositionPara,
            _ref$menuExtraClass = _ref.menuExtraClass,
            menuExtraClass = _ref$menuExtraClass === undefined ? "" : _ref$menuExtraClass,
            _ref$autoMenuWidth = _ref.autoMenuWidth,
            autoMenuWidth = _ref$autoMenuWidth === undefined ? true : _ref$autoMenuWidth,
            _ref$onSelect = _ref.onSelect,
            onSelect = _ref$onSelect === undefined ? function (item) {
            return null;
        } : _ref$onSelect,
            itemHeight = _ref.itemHeight;

        _classCallCheck(this, SimpleListMenuButton);

        var _this = _possibleConstructorReturn(this, (SimpleListMenuButton.__proto__ || Object.getPrototypeOf(SimpleListMenuButton)).call(this));

        _this.emptySelectionMessageKey = emptySelectionMessageKey;
        _this.emptyListMessageKey = emptyListMessageKey;
        _this.itemHtmlCallback = itemHtmlCallback;
        _this.extraClass = extraClass;
        _this.menuExtraClass = menuExtraClass;
        _this.menuPositionParams = menuPositionParams;
        _this.autoMenuWidth = autoMenuWidth;
        _this.onSelect = onSelect;
        _this.itemHeight = itemHeight;
        return _this;
    }

    _createClass(SimpleListMenuButton, [{
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='simpleListMenuButton <%=extraClass%>'>" + "  <div class='title'></div>" + "  <div class='downIcon'>&nbsp;</div>" + "</div>";
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            var _this2 = this;

            this.$title = this.find(".title");

            this.menu = new _SimpleListMenu2.default({
                onItemClick: function onItemClick(item) {
                    _this2._selectItem(item);
                    _this2.trigger("select", item);
                    if (_this2.onSelect) _this2.onSelect(item);
                },
                itemHtmlCallback: this.itemHtmlCallback,
                extraClass: this.menuExtraClass,
                itemHeight: this.itemHeight,
                onHide: function onHide() {
                    return _this2.$el.removeClass('active');
                },
                onShow: function onShow() {
                    return _this2.$el.addClass('active');
                }
            }).init(this.$containerEl);

            this.getEl().click(function () {
                if (!_this2.disabled && _this2.getItems().length > 0) {
                    if (_this2.autoMenuWidth) {
                        _this2.menu.getEl().width(_this2.getEl().width());
                    }
                    _this2.menu.showAt(_this2.getEl(), _this2.menuPositionParams);
                }
            });

            this.setItems([]);
        }
    }, {
        key: "getSelectedItem",
        value: function getSelectedItem() {
            return this.selectedItem;
        }
    }, {
        key: "getItems",
        value: function getItems() {
            return this.menu.getItems();
        }
    }, {
        key: "setDisabled",
        value: function setDisabled(disabled) {
            this.disabled = disabled;
        }
    }, {
        key: "disableAndHide",
        value: function disableAndHide() {
            this.setDisabled(true);
            this.getMenu().hide();
        }
    }, {
        key: "setItems",
        value: function setItems(items, selectedItem) {
            this.menu.setItems(items, selectedItem);
            this.$el.toggleClass("empty", items.length === 0);
            this.$el.toggleClass("notEmpty", items.length > 0);
            this.setSelectedItem(selectedItem);
        }
    }, {
        key: "getMenu",
        value: function getMenu() {
            return this.menu;
        }
    }, {
        key: "setActiveItemByPredicate",
        value: function setActiveItemByPredicate() {
            var itemPredicate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (item) {};

            this._selectItem(this.getItems().find(itemPredicate));
        }
    }, {
        key: "setSelectedItem",
        value: function setSelectedItem(item) {
            this._selectItem(item);
        }
    }, {
        key: "_selectItem",
        value: function _selectItem(item) {
            if (!item) {
                if (this.getItems().length > 0) {
                    this.$title.text(this.emptySelectionMessageKey ? _messageResource2.default.getMessage(this.emptySelectionMessageKey) : "");
                } else {
                    this.$title.text(this.emptyListMessageKey ? _messageResource2.default.getMessage(this.emptyListMessageKey) : "");
                    this.getEl().addClass("emptyList");
                }
                this.getEl().addClass("emptySelection");
            } else {
                this.$title.html(this.menu.itemHtmlCallback(item));
                this.getEl().removeClass("emptySelection");
                this.menu.selectItem(item);
            }

            this.selectedItem = item;
        }
    }]);

    return SimpleListMenuButton;
}(_TemplateView3.default);

exports.default = SimpleListMenuButton;

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasSomeTeamAssignment = exports.canAccessAllTeamScope = exports.canAccessAllManagementScope = exports.canAccessManagersScope = exports.hasManageSystemSettingsRight = exports.hasManagePtoAndSickDays = exports.hasLockTTRight = exports.hasSubmitTTRight = exports.hasGenerateMoneyReportsRight = exports.hasEditHierarchyRight = exports.hasSubmitOtherUsersTTRight = exports.hasManageUsersRight = undefined;

var _AccessRightsChecker = __webpack_require__(1330);

var hasManageUsersRight = exports.hasManageUsersRight = function hasManageUsersRight(user) {
  return (0, _AccessRightsChecker.getInstance)().hasManageUsersRight(user);
};
var hasSubmitOtherUsersTTRight = exports.hasSubmitOtherUsersTTRight = function hasSubmitOtherUsersTTRight(user) {
  return (0, _AccessRightsChecker.getInstance)().hasSubmitOtherUsersTTRight(user);
};
var hasEditHierarchyRight = exports.hasEditHierarchyRight = function hasEditHierarchyRight(user) {
  return (0, _AccessRightsChecker.getInstance)().hasEditHierarchyRight(user);
};
var hasGenerateMoneyReportsRight = exports.hasGenerateMoneyReportsRight = function hasGenerateMoneyReportsRight(user) {
  return (0, _AccessRightsChecker.getInstance)().hasGenerateMoneyReportsRight(user);
};

var hasSubmitTTRight = exports.hasSubmitTTRight = function hasSubmitTTRight(user) {
  return (0, _AccessRightsChecker.getInstance)().hasSubmitTTRight(user);
};
var hasLockTTRight = exports.hasLockTTRight = function hasLockTTRight(user) {
  return (0, _AccessRightsChecker.getInstance)().hasLockTTRight(user);
};
var hasManagePtoAndSickDays = exports.hasManagePtoAndSickDays = function hasManagePtoAndSickDays(user) {
  return (0, _AccessRightsChecker.getInstance)().hasManagePtoAndSickDays(user);
};
var hasManageSystemSettingsRight = exports.hasManageSystemSettingsRight = function hasManageSystemSettingsRight(user) {
  return (0, _AccessRightsChecker.getInstance)().hasManageSystemSettingsRight(user);
};

var canAccessManagersScope = exports.canAccessManagersScope = function canAccessManagersScope(user) {
  return (0, _AccessRightsChecker.getInstance)().canAccessManagersScope(user);
};
var canAccessAllManagementScope = exports.canAccessAllManagementScope = function canAccessAllManagementScope(user) {
  return (0, _AccessRightsChecker.getInstance)().canAccessAllManagementScope(user);
};
var canAccessAllTeamScope = exports.canAccessAllTeamScope = function canAccessAllTeamScope(user) {
  return (0, _AccessRightsChecker.getInstance)().canAccessAllTeamScope(user);
};
var hasSomeTeamAssignment = exports.hasSomeTeamAssignment = function hasSomeTeamAssignment(user) {
  return (0, _AccessRightsChecker.getInstance)().hasSomeTeamAssignment(user);
};

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var selectTaskManagement = exports.selectTaskManagement = function selectTaskManagement(state) {
  return state.taskManagement;
};

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var selectTaskCustomFields = exports.selectTaskCustomFields = function selectTaskCustomFields(state) {
  return state.customFields.items;
};
var selectTaskCustomFieldsIsLoaded = exports.selectTaskCustomFieldsIsLoaded = function selectTaskCustomFieldsIsLoaded(state) {
  return state.customFields.isLoaded;
};

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _SpinnerController = __webpack_require__(69);

var _SpinnerController2 = _interopRequireDefault(_SpinnerController);

var _spin = __webpack_require__(93);

var _spin2 = _interopRequireDefault(_spin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LoadingSpinner = function (_TemplateView) {
    _inherits(LoadingSpinner, _TemplateView);

    function LoadingSpinner() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            _ref$delay = _ref.delay,
            delay = _ref$delay === undefined ? 0 : _ref$delay,
            _ref$config = _ref.config,
            config = _ref$config === undefined ? {} : _ref$config;

        _classCallCheck(this, LoadingSpinner);

        var _this = _possibleConstructorReturn(this, (LoadingSpinner.__proto__ || Object.getPrototypeOf(LoadingSpinner)).call(this, null));

        _this.params = {
            delay: delay,
            config: config
        };

        _this.state = {
            show: false
        };

        _this.onStatePropertyChanged('show', function (show) {
            return _this._show(show);
        });
        return _this;
    }

    _createClass(LoadingSpinner, [{
        key: "templateHtml",
        value: function templateHtml() {
            return '<div class="loadingSpinner"/>';
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            this.$el.hide();
            this.spinnerController = new _SpinnerController2.default(true);
            this.spinnerController.setSpinner(new _spin2.default(_extends({}, _SpinnerController2.default.getDefaultSettings(), this.params.config)));
        }
    }, {
        key: "_show",
        value: function _show(show) {
            var _this2 = this;

            clearTimeout(this._showTimeout);

            if (show) {
                if (this.params.delay) {
                    this._showTimeout = setTimeout(function () {
                        return _this2.$el.show();
                    }, this.params.delay);
                } else {
                    this.$el.show();
                }
                this.spinnerController.spinInElement(this.getEl());
            } else {
                this.spinnerController.stop();
                this.$el.hide();
            }
        }
    }]);

    return LoadingSpinner;
}(_TemplateView3.default);

exports.default = LoadingSpinner;

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.taskFromRpc = exports.projectFromRpc = exports.customerFromRpc = exports.createdTasksToast = undefined;

var _ProjectStore = __webpack_require__(59);

var _ProjectStore2 = _interopRequireDefault(_ProjectStore);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _CustomerStore = __webpack_require__(65);

var _CustomerStore2 = _interopRequireDefault(_CustomerStore);

var _TaskStore = __webpack_require__(91);

var _TaskStore2 = _interopRequireDefault(_TaskStore);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _utils = __webpack_require__(341);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createdTasksToast = exports.createdTasksToast = function createdTasksToast(taskIds, projects, customers) {
    var message = "";
    if (taskIds.length > 0) {
        if (taskIds.length > 1) message += _messageResource2.default.getMessage("create.tasks.toast", [taskIds.length]);else message += _messageResource2.default.getMessage("create.task.toast", [_TaskStore2.default.get(taskIds[0]).name]);

        if (projects.length > 1) message += " " + _messageResource2.default.getMessage("create.task.toast.project_postfix_plural", [projects.length]);else message += " " + _messageResource2.default.getMessage("create.task.toast.project_postfix_singular", [_ProjectStore2.default.get(projects[0]).name]);

        if (customers.length > 1) message += " " + _messageResource2.default.getMessage("create.task.toast.customer_postfix_plural", [customers.length]);else message += " " + _messageResource2.default.getMessage("create.task.toast.customer_postfix_singular", [_CustomerStore2.default.get(customers[0]).name]);
    } else {
        message = _messageResource2.default.getMessage("create.task.toast.no_tasks_created");
    }
    return message;
};

var customerFromRpc = exports.customerFromRpc = function customerFromRpc(data) {
    return {
        id: data['id'],
        name: data['name'],
        archived: _underscore2.default.isUndefined(data['archived']) ? !data['activeCustomer'] : data['archived']
    };
};

var projectFromRpc = exports.projectFromRpc = function projectFromRpc(data) {
    return {
        id: data['id'],
        name: data['name'],
        customerId: data['customerId'],
        archived: _underscore2.default.isUndefined(data['archived']) ? !data['activeProject'] : data['archived']
    };
};

var taskFromRpc = exports.taskFromRpc = function taskFromRpc(data) {
    return {
        id: data['id'],
        name: data['name'],
        projectId: data['projectId'],
        customerId: data['customerId'],
        completed: _underscore2.default.isUndefined(data['open']) ? data['completed'] : !data['open'],
        estimatedTime: data['estimatedTime'],
        deadline: _underscore2.default.isString(data['deadline']) ? Date.parseJSONDate(data['deadline']) : null,
        lastTrackingDate: _underscore2.default.isString(data['lastTTDate']) ? Date.parseJSONDate(data['lastTTDate']) : null,
        workflowStatusId: data['workflowStatusId'],
        typeOfWorkId: data['typeOfWorkId'],
        creationDate: _underscore2.default.isString(data['creationTimestamp']) ? Date.parseJSONDate(data['creationTimestamp']) : null,
        spentTime: data['spentTime'],
        commentsNumber: data['commentsNumber'],
        nextId: data['nextId'],
        variance: data['variance'],
        progress: data['progress'],
        customFieldsValues: data['customFieldsValues']
    };
};

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var NoEditHierarchyRightError = exports.NoEditHierarchyRightError = function NoEditHierarchyRightError() {
  _classCallCheck(this, NoEditHierarchyRightError);
};

var NoManageUsersRightError = exports.NoManageUsersRightError = function NoManageUsersRightError() {
  _classCallCheck(this, NoManageUsersRightError);
};

var NoRightsError = exports.NoRightsError = function NoRightsError() {
  _classCallCheck(this, NoRightsError);
};

var NoSubmitTTRightError = exports.NoSubmitTTRightError = function NoSubmitTTRightError() {
  _classCallCheck(this, NoSubmitTTRightError);
};

var NoAccessToScopeError = exports.NoAccessToScopeError = function NoAccessToScopeError() {
  _classCallCheck(this, NoAccessToScopeError);
};

var NotFoundError = exports.NotFoundError = function NotFoundError() {
  _classCallCheck(this, NotFoundError);
};

var NoSuchUserError = exports.NoSuchUserError = function NoSuchUserError() {
  _classCallCheck(this, NoSuchUserError);
};

var NotAssignedError = exports.NotAssignedError = function NotAssignedError() {
  _classCallCheck(this, NotAssignedError);
};

var EditingUserDisabled = exports.EditingUserDisabled = function EditingUserDisabled() {
  _classCallCheck(this, EditingUserDisabled);
};

var NoSuchUserGroupError = exports.NoSuchUserGroupError = function NoSuchUserGroupError() {
  _classCallCheck(this, NoSuchUserGroupError);
};

var SelectedUserDeletedError = exports.SelectedUserDeletedError = function SelectedUserDeletedError() {
  _classCallCheck(this, SelectedUserDeletedError);
};

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.loadExistingTaskIdsAction = exports.changeAllTasksSelected = exports.changeTaskSelected = exports.cleanupNonExistingSelectedIds = exports.cleanupExistingTaskIds = exports.cleanupSelectionsData = exports.clearTaskSelectionAction = exports.resetExistingTaskIdsLoaded = exports.setExistingTaskIdsByFilters = exports.changeSelectedTaskIds = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _reduxActions = __webpack_require__(9);

var _selectors = __webpack_require__(27);

var _atUtils = __webpack_require__(5);

var _actionTypes = __webpack_require__(669);

var ActionTypes = _interopRequireWildcard(_actionTypes);

var _utils = __webpack_require__(6);

var _ClassicBridge = __webpack_require__(18);

var _ClassicBridge2 = _interopRequireDefault(_ClassicBridge);

var _rpcCalls = __webpack_require__(24);

var _selectors2 = __webpack_require__(106);

var _batch = __webpack_require__(117);

var _rpcUtils = __webpack_require__(160);

var _connector = __webpack_require__(288);

var _selectors3 = __webpack_require__(14);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var LOAD_EXISTING_TASK_IDS_SERVICE_METHOD = 'TaskManagementService.getAvailableTaskIdsByFilters';

var setPendingSelectAll = (0, _reduxActions.createAction)(ActionTypes.PENDING_SELECT_ALL_SET);
var resetPendingSelectAll = (0, _reduxActions.createAction)(ActionTypes.PENDING_SELECT_ALL_RESET);

var changeSelectedTaskIds = exports.changeSelectedTaskIds = (0, _reduxActions.createAction)(ActionTypes.SELECTED_TASK_IDS_CHANGE);
var setExistingTaskIdsByFilters = exports.setExistingTaskIdsByFilters = (0, _reduxActions.createAction)(ActionTypes.EXISTING_TASK_IDS_BY_FILTERS_SET);
var resetExistingTaskIdsLoaded = exports.resetExistingTaskIdsLoaded = (0, _reduxActions.createAction)(ActionTypes.EXISTING_TASK_IDS_LOADED_RESET);

var clearTaskSelectionAction = exports.clearTaskSelectionAction = function clearTaskSelectionAction() {
    return function (dispatch) {
        dispatch(resetPendingSelectAll());
        dispatch(changeSelectedTaskIds({}));
    };
};

var cleanupSelectionsData = exports.cleanupSelectionsData = function cleanupSelectionsData() {
    return (0, _batch.batched)(function (dispatch) {
        dispatch(resetPendingSelectAll());
        dispatch(changeSelectedTaskIds({}));
        dispatch(cleanupExistingTaskIds());
    });
};

var cleanupExistingTaskIds = exports.cleanupExistingTaskIds = function cleanupExistingTaskIds() {
    return (0, _batch.batched)(function (dispatch) {
        (0, _rpcCalls.abortCall)(LOAD_EXISTING_TASK_IDS_SERVICE_METHOD);
        dispatch(setExistingTaskIdsByFilters());
        dispatch(resetExistingTaskIdsLoaded());
    });
};

var cleanupNonExistingSelectedIds = exports.cleanupNonExistingSelectedIds = function cleanupNonExistingSelectedIds() {
    return function (dispatch, getState) {
        var actualExistingIds = (0, _selectors2.getExistingTaskIdsForView)(getState());
        var actualSelectedIds = _underscore2.default.omit((0, _selectors2.getSelectedTaskIds)(getState()), function (val, id) {
            return !actualExistingIds[id];
        });
        dispatch(changeSelectedTaskIds(actualSelectedIds));
    };
};

var changeTaskSelected = exports.changeTaskSelected = function changeTaskSelected(id, selected) {
    return (0, _batch.batched)(function (dispatch, getState) {
        var ids = (0, _selectors2.getSelectedTaskIds)(getState());
        var newIds = [];
        if (selected === true) {
            newIds = _extends({}, ids, _defineProperty({}, id, true));
        } else {
            newIds = (0, _atUtils.filterMapByKey)(ids, id);
        }
        // reset select all for situations when data about selection not yet loaded
        dispatch(resetPendingSelectAll());
        dispatch(changeSelectedTaskIds(newIds));
    });
};

/**
 *
 * Change `allTasksSelected` dependent on current state of selection
 * If all existing tasks selected or pending select all - unselect all tasks
 * If not all tasks selected and not pending select all
 *   - if existing tasks not loaded start pending select all (visual state as all selected)
 *   - mark as selected all tasks visible and existing (if loaded, else empty set)
 *
 * @param loadedTaskIds taskIds loaded for concrete view. Need for preselect visible tasks
 */
var changeAllTasksSelected = exports.changeAllTasksSelected = function changeAllTasksSelected(loadedTaskIds) {
    return (0, _batch.batched)(function (dispatch, getState) {
        var allSelected = (0, _selectors2.isAllTasksSelected)(getState());
        var pendingSelectAll = (0, _selectors2.isPendingSelectAll)(getState());
        if (allSelected || pendingSelectAll) {
            // unselect all
            dispatch(resetPendingSelectAll());
            dispatch(changeSelectedTaskIds({}));
        } else {
            var existingTaskIdsLoaded = (0, _selectors2.isExistingTaskIdsLoaded)(getState());
            var existingTaskIds = (0, _selectors2.getExistingTaskIdsForView)(getState());
            if (!existingTaskIdsLoaded) {
                // if not loaded existing task ids - pending select all
                // preselect visible and known existing tasks
                // visible tasks is needed for check visible checkboxes while existing ids data loading
                dispatch(setPendingSelectAll(existingTaskIds));
            } else {
                // select all existing for view
                dispatch(changeSelectedTaskIds(existingTaskIds));
            }
        }
    });
};

var loadExistingTaskIdsAction = exports.loadExistingTaskIdsAction = function loadExistingTaskIdsAction() {
    return function (dispatch, getState) {
        dispatch((0, _utils.createActionObject)(ActionTypes.LOAD_EXISTING_TASK_IDS));

        var state = getState();
        var selectedIdsBeforeRequest = (0, _selectors2.getSelectedTaskIds)(state);
        var pendingSelectAllBeforeRequest = (0, _selectors2.isPendingSelectAll)(state);

        var params = {
            customFieldsFilters: (0, _selectors.getCustomFieldsFilters)(state),
            include: 'basic'
        };

        (0, _connector.fillNextDataParams)({
            intersectedCPSelection: (0, _selectors.getIntersectedCPSelection)(state),
            taskStatusFilter: (0, _selectors.getTaskStatusFilter)(state),
            taskNameFilter: (0, _selectors.getTaskNameFilter)(state),
            showOnlyManageableTasks: (0, _selectors.isShowOnlyManageableTasks)(state)
        }, {
            taskWorkflowStatuses: (0, _selectors3.getWorkflowStatusesArray)(state)
        })(params);

        /* TODO: AT-9208
         * This may be heavy request in case of all customers and projects with no filters selected
         * May be replaced in fututre
         */
        _ClassicBridge2.default.getTasksForTaskList(params).then(function (nextData) {
            return nextData.items.map(function (item) {
                return item.classicId;
            });
        }).then(function (ids) {
            dispatch((0, _utils.createActionObject)(ActionTypes.LOAD_EXISTING_TASK_IDS_SUCCESS, (0, _atUtils.arrayToSet)(ids)));

            var mergedExistingTaskIds = _extends({}, (0, _atUtils.arrayToSet)(ids), (0, _selectors2.getVisibleTaskIds)(getState()));

            var pendingSelectAll = (0, _selectors2.isPendingSelectAll)(getState());
            // case when we `select all` and didn't change while data loaded
            if (pendingSelectAll) {
                dispatch(resetPendingSelectAll());
                dispatch(changeSelectedTaskIds(mergedExistingTaskIds));
            } else if (pendingSelectAllBeforeRequest) {
                // case when we `select all` and then unselect several checkboxes

                // fill all retrieved ids as selected expect ids that will be unchecked while data is loaded
                var currentSelectedIds = (0, _selectors2.getSelectedTaskIds)(getState());
                var unselectedIds = _underscore2.default.omit(selectedIdsBeforeRequest, function (val, id) {
                    return !!currentSelectedIds[id];
                });
                var actualSelectedIds = _underscore2.default.omit(mergedExistingTaskIds, function (val, id) {
                    return !!unselectedIds[id];
                });
                dispatch(changeSelectedTaskIds(actualSelectedIds));
            } else {
                // filter selected ids that not in existed
                var _actualSelectedIds = _underscore2.default.omit((0, _selectors2.getSelectedTaskIds)(getState()), function (val, id) {
                    return !mergedExistingTaskIds[id];
                });
                dispatch(changeSelectedTaskIds(_actualSelectedIds));
            }

            if (Object.keys(mergedExistingTaskIds).length === 0) {
                dispatch(cleanupSelectionsData());
            }
        }).catch(function (err) {
            if ((0, _rpcUtils.isAborted)(err)) {
                return;
            }

            dispatch((0, _utils.createActionObject)(ActionTypes.LOAD_EXISTING_TASK_IDS_FAILURE));
            throw err;
        });
    };
};

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.updateTaskCustomField = exports.updateTaskTypeOfWork = exports.updateSummaryRow = exports.setSummaryRowIsLoaded = exports.setLoaded = exports.changeAllTasksSelectedAction = exports.changeTasksSortingAction = exports.addRecentlyCreatedTasks = exports.addLoadedTaskIds = exports.setLoadedTaskIds = exports.setIsSummaryRowShown = exports.setColumnsShown = exports.setColumnsOrder = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _reduxActions = __webpack_require__(9);

var _actionTypes = __webpack_require__(668);

var ActionTypes = _interopRequireWildcard(_actionTypes);

var _utils = __webpack_require__(6);

var _actions = __webpack_require__(55);

var _rpcCalls = __webpack_require__(24);

var _rpcCalls2 = _interopRequireDefault(_rpcCalls);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _selectors = __webpack_require__(14);

var _syncCallbacks = __webpack_require__(1350);

var SyncCallbacks = _interopRequireWildcard(_syncCallbacks);

var _actions2 = __webpack_require__(29);

var _selectors2 = __webpack_require__(82);

var _atUtils = __webpack_require__(5);

var _actions3 = __webpack_require__(194);

var _utils2 = __webpack_require__(192);

var _ClassicBridge = __webpack_require__(18);

var _ClassicBridge2 = _interopRequireDefault(_ClassicBridge);

var _connector = __webpack_require__(288);

var _selectors3 = __webpack_require__(27);

var _utils3 = __webpack_require__(135);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _constants = __webpack_require__(44);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var setColumnsOrder = exports.setColumnsOrder = (0, _reduxActions.createAction)(ActionTypes.COLUMNS_ORDER_SET);

var setColumnsShown = exports.setColumnsShown = (0, _reduxActions.createAction)(ActionTypes.COLUMNS_SHOWN_SET);

var setIsSummaryRowShown = exports.setIsSummaryRowShown = (0, _reduxActions.createAction)(ActionTypes.IS_SUMMARY_ROW_SHOWN_SET);

var setLoadedTaskIds = exports.setLoadedTaskIds = (0, _reduxActions.createAction)(ActionTypes.LOADED_TASK_IDS_SET);
var addLoadedTaskIds = exports.addLoadedTaskIds = (0, _reduxActions.createAction)(ActionTypes.LOADED_TASK_IDS_ADD);
var prependLoadedTaskIds = (0, _reduxActions.createAction)(ActionTypes.LOADED_TASK_IDS_PREPEND);

var addRecentlyCreatedTasks = exports.addRecentlyCreatedTasks = function addRecentlyCreatedTasks(ids) {
    return prependLoadedTaskIds(ids);
};

var changeTasksSortingAction = exports.changeTasksSortingAction = function changeTasksSortingAction(sorting) {
    return function (dispatch) {
        dispatch((0, _utils.createActionObject)(ActionTypes.TASKS_SORTING_CHANGE, sorting));
        dispatch(setLoaded(false));
        dispatch((0, _actions.savePageSettings)());
    };
};

var changeAllTasksSelectedAction = exports.changeAllTasksSelectedAction = function changeAllTasksSelectedAction() {
    return function (dispatch, getState) {
        dispatch((0, _actions3.changeAllTasksSelected)((0, _atUtils.arrayToSet)((0, _selectors2.getVisibleTableTaskIds)(getState()))));
    };
};

var setLoaded = exports.setLoaded = (0, _reduxActions.createAction)(ActionTypes.IS_LOADED_SET);
var setSummaryRowIsLoaded = exports.setSummaryRowIsLoaded = (0, _reduxActions.createAction)(ActionTypes.IS_SUMMARY_ROW_LOADED_SET);

var setSummaryRow = (0, _reduxActions.createAction)(ActionTypes.SUMMARY_ROW_SET);

var updateSummaryRow = exports.updateSummaryRow = function updateSummaryRow() {
    return function (dispatch, getState) {
        var state = getState();
        var params = {
            customFieldsFilters: (0, _selectors3.getCustomFieldsFilters)(state)
        };

        (0, _connector.fillNextDataParams)({
            intersectedCPSelection: (0, _selectors3.getIntersectedCPSelection)(state),
            taskStatusFilter: (0, _selectors3.getTaskStatusFilter)(state),
            taskNameFilter: (0, _selectors3.getTaskNameFilter)(state),
            showOnlyManageableTasks: (0, _selectors3.isShowOnlyManageableTasks)(state)
        }, {
            taskWorkflowStatuses: (0, _selectors.getWorkflowStatusesArray)(state)
        })(params);

        dispatch(setSummaryRowIsLoaded(false));
        dispatch(setSummaryRow({}));

        return _ClassicBridge2.default.syncChangesFromClassic().then(function () {
            return _ClassicBridge2.default.getTasksSummary(params).then(function (result) {
                dispatch(setSummaryRow({
                    taskCount: result.count,
                    spentTime: (0, _utils3.nextDurationToMinutes)(result.spentTime),
                    estimate: result.estimate ? (0, _utils3.nextDurationToMinutes)(result.estimate) : null,
                    variance: (0, _utils3.convertVariance)(result.variance),
                    workflowstatuses: result.workflowStatuses,
                    active: result.active,
                    closestDeadline: result.closestDeadline,
                    lastTrackingDate: result.lastTrackingDate,
                    lastCreationDate: result.lastCreationDate
                }));
            });
        }).finally(function () {
            dispatch(setSummaryRowIsLoaded(true));
        });
    };
};

var updateTaskTypeOfWork = exports.updateTaskTypeOfWork = function updateTaskTypeOfWork(taskId, typeOfWorkId) {
    return function (dispatch, getState) {
        var prevTask = (0, _selectors.getTask)(getState(), taskId);
        (0, _rpcCalls2.default)("TaskManagementService.updateTaskTypeOfWork", [taskId, typeOfWorkId], function (rpcError) {
            if (rpcError.getTextStatus() === "rpc_customException") {
                var exception = rpcError.getErrorThrown().exception;
                switch (exception) {
                    case "com.actimind.actitime.services.taskManagement.TypeOfWorkDeletedException":
                        alert(_messageResource2.default.getMessage("billing_type.js.error_type_was_deleted"));
                        dispatch((0, _actions2.setTypesOfWorkList)(rpcError.getErrorThrown().typesOfWork));
                        SyncCallbacks.afterTaskUpdated(taskId);
                        return true;
                    case "com.actimind.actitime.services.taskManagement.TypeOfWorkArchivedException":
                        alert(_messageResource2.default.getMessage("billing_type.js.error_type_was_archived"));
                        dispatch((0, _actions2.setTypesOfWorkList)(rpcError.getErrorThrown().typesOfWork));
                        SyncCallbacks.afterTaskUpdated(taskId);
                        return true;
                    case "com.actimind.actitime.services.FeatureIsDisabledException":
                        alert(_messageResource2.default.getMessage("task.error.billing_types_off"));
                        window.location.reload();
                        return true;
                    default:
                        return (0, _actions.handleCommonTaskUpdateErrors)(prevTask, exception, dispatch);
                }
            }
        }).then(function (rpcData) {
            return Promise.all([rpcData, _ClassicBridge2.default.getTasksAfterModification([prevTask.id])]);
        }).then(function (_ref) {
            var _ref2 = _slicedToArray(_ref, 2),
                rpcData = _ref2[0],
                nextTasks = _ref2[1];

            var task = (0, _utils2.taskFromRpc)(rpcData["task"]);

            if (nextTasks) {
                task = (0, _utils3.mergeClassicAndNextTask)(task, nextTasks[0]);
            }

            task.spentTime = prevTask.spentTime; // do not overwrite
            dispatch((0, _actions.addTasks)([task]));
            SyncCallbacks.afterTaskUpdated(taskId);
        }).catch(function () {
            // error actions dispatched in error handler
        });
    };
};

var updateTaskCustomField = exports.updateTaskCustomField = function updateTaskCustomField(taskId, fieldName, value) {
    return function (dispatch, getState) {
        var task = (0, _selectors.getTask)(getState(), taskId);
        _ClassicBridge2.default.patchTaskCustomField(task.nextId, fieldName, value).then(function () {
            var taskCopy = _underscore2.default.clone(task);
            taskCopy.customFieldsValues = _extends({}, task.customFieldsValues, _defineProperty({}, fieldName, value));

            dispatch((0, _actions.addTasks)([taskCopy]));
            SyncCallbacks.afterTaskUpdated(taskId);
        }).catch(function (err) {
            if (!(err && err.body)) {
                alert(_messageResource2.default.getMessage('api.error.unexpected_error'));
                window.location.reload();
            }
            if (err.body.reason === "feature_disabled") {
                alert(_messageResource2.default.getMessage(fieldName === _constants.PRIORITY_FIELD_NAME ? "task.list.error.prfi_feature_disabled" : "task.list.error.cfi_feature_disabled"));
                window.location.reload();
            }
            if (err.body.reason === "permission_denied") {
                alert(_messageResource2.default.getMessage('task.edit_popup.no_rights_to_manage_tasks'));
                window.location.reload();
            }
            var errDetail = err.body.details && err.body.details[0];
            if (errDetail && errDetail.name === 'priority' && errDetail.errorKey === 'enum_key.unknown') {
                alert(_messageResource2.default.getMessage('task.edit_popup.priority_not_exists'));
                window.location.reload();
            }
        });
    };
};

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _BasicLightbox = __webpack_require__(163);

var _BasicLightbox2 = _interopRequireDefault(_BasicLightbox);

var _LightBoxWrapper = __webpack_require__(1409);

var _LightBoxWrapper2 = _interopRequireDefault(_LightBoxWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LightBox = function (_BasicLightBox) {
    _inherits(LightBox, _BasicLightBox);

    function LightBox() {
        var $el = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _jquery2.default)('body');

        var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
            _ref$close_tab_confir = _ref.close_tab_confirmation_message_key,
            close_tab_confirmation_message_key = _ref$close_tab_confir === undefined ? '' : _ref$close_tab_confir,
            _ref$exist_invalid_fi = _ref.exist_invalid_fields_message_key,
            exist_invalid_fields_message_key = _ref$exist_invalid_fi === undefined ? '' : _ref$exist_invalid_fi,
            _ref$cancel_confirmat = _ref.cancel_confirmation_message_key,
            cancel_confirmation_message_key = _ref$cancel_confirmat === undefined ? '' : _ref$cancel_confirmat;

        _classCallCheck(this, LightBox);

        var _this = _possibleConstructorReturn(this, (LightBox.__proto__ || Object.getPrototypeOf(LightBox)).call(this));

        _this.params = {
            $el: $el
        };

        _this.close_tab_confirmation_message_key = close_tab_confirmation_message_key;
        _this.exist_invalid_fields_message_key = exist_invalid_fields_message_key;
        _this.cancel_confirmation_message_key = cancel_confirmation_message_key;
        return _this;
    }

    _createClass(LightBox, [{
        key: 'init',
        value: function init(_ref2) {
            var _this2 = this;

            var id = _ref2.id,
                _ref2$header = _ref2.header,
                header = _ref2$header === undefined ? null : _ref2$header,
                _ref2$content = _ref2.content,
                content = _ref2$content === undefined ? null : _ref2$content,
                _ref2$footer = _ref2.footer,
                footer = _ref2$footer === undefined ? null : _ref2$footer,
                _ref2$classNames = _ref2.classNames,
                classNames = _ref2$classNames === undefined ? '' : _ref2$classNames,
                _ref2$correctionOffse = _ref2.correctionOffset,
                correctionOffset = _ref2$correctionOffse === undefined ? 0 : _ref2$correctionOffse,
                moireDivId = _ref2.moireDivId,
                _ref2$cancelCallback = _ref2.cancelCallback,
                cancelCallback = _ref2$cancelCallback === undefined ? function () {
                return _this2.hide();
            } : _ref2$cancelCallback;


            this.components = {
                header: header,
                footer: footer,
                content: content

                // temporary we need this
            };(0, _jquery2.default)('#' + id).remove();

            this.wrapper = new _LightBoxWrapper2.default(this.params.$el, {
                id: id,
                header: header,
                content: content,
                footer: footer,
                classNames: classNames,
                correctionOffset: correctionOffset
            }).init();

            _get(LightBox.prototype.__proto__ || Object.getPrototypeOf(LightBox.prototype), 'init', this).call(this, null, null, moireDivId);

            this.setCancelCallback(cancelCallback);

            return this;
        }
    }, {
        key: 'getWrapper',
        value: function getWrapper() {
            return this.wrapper;
        }
    }, {
        key: 'getContent',
        value: function getContent() {
            return this.components.content;
        }
    }, {
        key: 'getHeader',
        value: function getHeader() {
            return this.components.header;
        }
    }, {
        key: 'getFooter',
        value: function getFooter() {
            return this.components.footer;
        }

        /**
         * Temporary solution for compatibility with BasicLightbox
         */

    }, {
        key: 'getPopupEl',
        value: function getPopupEl() {
            return this.wrapper.getEl();
        }

        /**
         * Temporary solution for compatibility with BasicLightbox
         */

    }, {
        key: 'getFooterEl',
        value: function getFooterEl() {
            return this.components.footer.getEl()[0];
        }

        /**
         * Temporary solution for compatibility with BasicLightbox
         */

    }, {
        key: 'getCommitButtonEl',
        value: function getCommitButtonEl() {
            return this.components.footer.getCommitBtnEl()[0];
        }

        /**
         * Temporary solution for compatibility with BasicLightbox
         */

    }, {
        key: 'getCancelButtonEl',
        value: function getCancelButtonEl() {
            return this.components.footer.getCancelBtnEl()[0];
        }

        /**
         * Temporary solution for compatibility with BasicLightbox
         */

    }, {
        key: 'getCloseButtonEl',
        value: function getCloseButtonEl() {
            return this.components.header.getCloseButtonEl()[0];
        }
    }, {
        key: 'getScrollPosition',
        value: function getScrollPosition() {
            return this.wrapper.scrollableContainer.innerScroll.y;
        }
    }, {
        key: 'refreshScroll',
        value: function refreshScroll() {
            this.wrapper.update();
        }
    }, {
        key: 'updateErrors',
        value: function updateErrors(showErrorInFooter) {
            if (this.hasErrors()) {
                if (showErrorInFooter) this.displayErrorInFooter();
            } else this.removeErrorInFooter();
        }
    }]);

    return LightBox;
}(_BasicLightbox2.default);

exports.default = LightBox;

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var Errors = exports.Errors = {
    ERROR_EMPTY_TASK_USER_SELECTION: "errorEmptyTaskUserSelection",
    ERROR_EMPTY_BALANCE_USER_SELECTION: "errorEmptyBalanceUserSelection",
    ERROR_EMPTY_BILLABLE_USER_SELECTION: "errorEmptyBillableUserSelection",
    ERROR_EMPTY_OVERTIME_USER_SELECTION: "errorEmptyOvertimeUserSelection",
    ERROR_EMPTY_CP_SELECTION: "errorEmptyCPSelection",
    ERROR_EMPTY_LEAVE_TYPES_SELECTION: "errorEmptyLeaveTypesSelection",
    ERROR_INCORRECT_DATE_RANGE: "errorIncorrectDateRange"
};

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ChartPDFParameters = exports.getMaxValuesOnFitPageWithoutImageProperty = exports.getMaxValuesOnPageWithoutImageProperty = exports.getMaxValuesOnFitPageProperty = exports.getMaxValuesOnPageProperty = exports.getNeededImageDimensions = exports.ChartPDFFooters = exports.ChartPDFStyles = exports.ChartPDFOptions = exports.ChartPDFPlaceholderConstructors = exports.ChartPDFTemplateConstructors = undefined;

var _PaperSize$A, _PaperSize$LETTER, _PaperOrientation$LAN, _PaperSize$A2, _PaperSize$LETTER2, _PaperOrientation$POR, _ChartPDFParameters;

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _date_format = __webpack_require__(16);

var _constants = __webpack_require__(11);

var _constants2 = __webpack_require__(100);

var _PDFImageCache = __webpack_require__(122);

var _PDFImageCache2 = _interopRequireDefault(_PDFImageCache);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*
Its file contains parts for construct pdf files
All sizes are specific for pdfmake .For convert it to mm need divide by coeff = 2.835
 */
var ChartPDFTemplateConstructors = exports.ChartPDFTemplateConstructors = {

    imageWithSizes: function imageWithSizes(imageSizes, imageBase64) {
        return {
            height: imageSizes.h,
            width: imageSizes.w,
            image: imageBase64
        };
    },

    fakeImage: function fakeImage() {
        return '';
    },

    logoPicture: function logoPicture(logoPictureBase64, dimensions) {
        return {
            width: dimensions.w,
            height: dimensions.h,
            marginTop: dimensions.mT,
            marginLeft: dimensions.mL,
            rowSpan: 3,
            image: logoPictureBase64
        };
    },

    filterView: function filterView(filterViewParams, firstRowLeftText, secondRowText) {
        var margins = filterViewParams.margins;
        var marginsImage = filterViewParams.imageMargins;
        var firstRowMargins = filterViewParams.firstRowMargins;
        var secondRowMargins = filterViewParams.secondRowMargins;

        return {
            style: 'filterView',
            layout: 'thinBordersNoPaddingsForFilterView',
            marginTop: margins.top,
            fontSize: filterViewParams.fontSize,

            table: {
                widths: filterViewParams.widths,

                body: [[{
                    marginLeft: marginsImage.left,
                    marginTop: marginsImage.top,
                    rowSpan: 2,
                    width: filterViewParams.imageWidth,
                    margin: [12, firstRowMargins.top, 6, firstRowMargins.bottom],
                    // filter.png image in base64 format
                    image: _PDFImageCache2.default.getImage('filterIcon').image
                }, {
                    marginTop: firstRowMargins.top,
                    marginBottom: firstRowMargins.bottom,
                    noWrap: true,
                    text: firstRowLeftText
                }], ['', { marginRight: 12, marginBottom: secondRowMargins.bottom, noWrap: true, text: secondRowText }]]
            }
        };
    },

    filterViewWithThreeRows: function filterViewWithThreeRows(filterViewParams, firstRowLeftText, secondRowText, thirdRowText) {
        var margins = filterViewParams.margins;
        var marginsImage = filterViewParams.imageMargins;
        var firstRowMargins = filterViewParams.firstRowMargins;
        var secondRowMargins = filterViewParams.secondRowMargins;
        var thirdRowMargins = filterViewParams.thirdRowMargins;

        return {
            style: 'filterView',
            layout: 'thinBordersNoPaddingsForFilterView',
            marginTop: margins.top,
            fontSize: filterViewParams.fontSize,

            table: {
                widths: filterViewParams.widths,

                body: [[{
                    marginLeft: marginsImage.left,
                    marginTop: marginsImage.top,
                    width: filterViewParams.imageWidth,
                    image: _PDFImageCache2.default.getImage('filterIcon').image
                }, {
                    marginTop: firstRowMargins.top,
                    marginBottom: firstRowMargins.bottom,
                    noWrap: true,
                    text: firstRowLeftText
                }], [{ text: '' }, {
                    marginTop: secondRowMargins.top,
                    marginBottom: secondRowMargins.bottom,
                    noWrap: true,
                    text: secondRowText
                }], [{ text: '' }, {
                    marginRight: 12,
                    marginTop: thirdRowMargins.top,
                    marginBottom: thirdRowMargins.bottom,
                    noWrap: true,
                    text: thirdRowText
                }]]
            }
        };
    },


    chartInformation: function chartInformation(chartInfoParams, logoElement, reportName, dateDescription, grandTotalDescription, grandTotalValue) {
        var columnWidths = chartInfoParams.widths;
        var splitterLen = chartInfoParams.splitterLen;
        return {
            widths: columnWidths,
            body: [[logoElement, [{ style: 'chartNameLabel', text: reportName }, { style: 'dateRangeLabel', text: dateDescription }]], ['', {
                style: 'headerSeparator',
                canvas: [{
                    type: 'line',
                    x1: 0, x2: splitterLen,
                    y1: 0, y2: 0,
                    lineWidth: 0.9,
                    dash: { length: 2 },
                    lineColor: '#b7b7b7'
                }]
            }], ['', {
                style: 'grandTotalLabel',
                text: [{ text: grandTotalDescription.label }, ' ', { style: 'grandValue', text: grandTotalValue }, ' ', { style: 'grandPostfix', text: grandTotalDescription.postfix }]
            }]]
        };
    },

    colorValuePercentRow: function colorValuePercentRow(color, categoryName, value, percents, styles, isSecond) {
        var rectDimensions = styles.colorRectangleDimensions;
        var fillColor = isSecond ? '#eeeeee' : '';
        return [{
            width: 0,
            canvas: [{
                type: 'rect',
                x: rectDimensions.x,
                y: rectDimensions.y,
                w: rectDimensions.w,
                h: rectDimensions.h,
                color: color,
                strokeOpacity: 0.001 // hide rect line that visible when color not specified
            }]
        }, { width: "*", noWrap: true, marginLeft: rectDimensions.paddingLeft, style: styles.dataNameStyle, text: categoryName, fillColor: fillColor }, { width: "auto", noWrap: true, style: styles.dataValueWithPercentStyle, text: value, fillColor: fillColor }, { width: 40, style: styles.dataValueStyle, text: percents, fillColor: fillColor }];
    },

    colorValueRow: function colorValueRow(color, categoryName, value, styles, isSecond) {
        var rectDimensions = styles.colorRectangleDimensions;
        var fillColor = isSecond ? '#eeeeee' : '';
        return [{
            width: 0,
            canvas: [{
                type: 'rect',
                x: rectDimensions.x,
                y: rectDimensions.y,
                w: rectDimensions.w,
                h: rectDimensions.h,
                color: color,
                strokeOpacity: 0.001 // hide rect line that visible when color not specified
            }]
        }, { width: "*", noWrap: true, marginLeft: rectDimensions.paddingLeft, style: styles.dataNameStyle, text: categoryName, fillColor: fillColor }, { width: "auto", noWrap: true, style: styles.dataValueStyle, text: value, fillColor: fillColor }];
    },

    valueRow: function valueRow(categoryName, value, styles, isSecond) {
        var fillColor = isSecond ? '#eeeeee' : '';
        return [{ width: "*", noWrap: true, style: styles.dataNameStyle, text: categoryName, fillColor: fillColor }, { width: "auto", noWrap: true, style: styles.dataValueStyle, text: value, fillColor: fillColor }];
    },

    stackedValueRow: function stackedValueRow(categoryName, categoryWidths, totalValue, totalWidths, values, valuesWidths, styles, isSecond, isHeader) {
        var fillColor = isSecond ? '#eeeeee' : '';
        var fontSize = isHeader ? 6 : undefined;
        var fontColor = isHeader ? '#636363' : '';
        var row = [{
            noWrap: true,
            style: styles.dataNameStyle,
            text: categoryName,
            fillColor: fillColor,
            fontSize: fontSize,
            color: fontColor,
            width: categoryWidths
        }, {
            noWrap: true,
            style: styles.dataValueStyle,
            text: totalValue,
            fillColor: fillColor,
            fontSize: fontSize,
            color: fontColor,
            width: totalWidths
        }];

        for (var i = 0; i < values.length; i++) {
            row.push({
                noWrap: true,
                style: styles.dataValueStyle,
                text: values[i].value,
                fillColor: fillColor,
                fontSize: fontSize,
                color: fontColor,
                width: valuesWidths[i]
            });
        }

        return row;
    },

    valuePercentRow: function valuePercentRow(categoryName, value, percents, styles, isSecond) {
        var fillColor = isSecond ? '#eeeeee' : '';
        return [{ width: "*", noWrap: true, style: styles.dataNameStyle, text: categoryName, fillColor: fillColor }, { width: "auto", noWrap: true, style: styles.dataValueWithPercentStyle, text: value, fillColor: fillColor }, { width: 40, style: styles.dataValueStyle, text: percents, fillColor: fillColor }];
    }
};

var ChartPDFPlaceholderConstructors = exports.ChartPDFPlaceholderConstructors = {

    headerLandscape: function headerLandscape(chartInformation, filterView) {
        return {
            columns: [{
                width: '67%',
                layout: 'noBordersNoPadding',

                table: chartInformation
            }, filterView]
        };
    },

    headerPortrait: function headerPortrait(chartInformation) {
        return {
            layout: 'noBordersNoPadding',

            table: chartInformation
        };
    },

    singleImage: function singleImage(image, margins) {
        return {
            layout: 'noBordersNoPadding',
            marginTop: margins.top,
            table: {
                width: ['100%'],
                body: [[image]]
            }
        };
    },

    pageBreaker: function pageBreaker() {
        return {
            pageBreak: 'after',
            text: ''
        };
    },

    horizontalDoubleImages: function horizontalDoubleImages(imageLeft, imageRight, marginsImage) {
        return {
            columns: [{
                layout: 'noBordersNoPadding',
                width: '49%',
                marginTop: marginsImage.top,
                table: {
                    width: ['100%'],
                    body: [[imageLeft]]
                }
            }, {
                width: '2%',
                text: ''
            }, {
                layout: 'noBordersNoPadding',
                marginTop: marginsImage.top,
                table: {
                    width: ['100%'],
                    body: [[imageRight]]
                }
            }]
        };
    },

    simpleTable: function simpleTable(dataRows, margins, tableStyle) {
        var widths = [];
        for (var i = 0; i < dataRows[0].length; i++) {
            widths.push(dataRows[0][i].width);
        }
        return {
            style: tableStyle,
            layout: 'noBordersNoPadding',
            marginTop: margins.top,
            marginRight: margins.right,

            table: {
                dontBreakRows: true,
                widths: widths,
                body: dataRows
            }
        };
    },

    stackedChartTable: function stackedChartTable(dataRows, margins, tableStyle) {
        var widths = [];
        for (var i = 0; i < dataRows[0].length; i++) {
            widths.push(dataRows[0][i].width);
        }
        return {
            style: tableStyle,
            layout: 'headerBorderNoPadding',
            marginTop: 0,

            table: {
                dontBreakRows: true,
                widths: widths,
                body: dataRows
            }
        };
    }
};

var ChartPDFOptions = exports.ChartPDFOptions = {
    tableLayouts: {
        noBordersNoPadding: {
            hLineWidth: function hLineWidth(i, node) {
                return 0;
            },
            vLineWidth: function vLineWidth(i, node) {
                return 0;
            },
            paddingLeft: function paddingLeft(i, node) {
                return 0;
            },
            paddingRight: function paddingRight(i, node) {
                return 0;
            },
            paddingTop: function paddingTop(i, node) {
                return 0;
            },
            paddingBottom: function paddingBottom(i, node) {
                return 0;
            }
        },
        simpleBorders: {
            hLineWidth: function hLineWidth(i, node) {
                return 1;
            },
            vLineWidth: function vLineWidth(i, node) {
                return 1;
            },
            paddingLeft: function paddingLeft(i, node) {
                return 0;
            },
            paddingRight: function paddingRight(i, node) {
                return 0;
            },
            paddingTop: function paddingTop(i, node) {
                return 0;
            },
            paddingBottom: function paddingBottom(i, node) {
                return 0;
            }
        },
        thinBordersNoPaddingsForFilterView: {
            hLineWidth: function hLineWidth(i, node) {
                return 0.4;
            },
            vLineWidth: function vLineWidth(i, node) {
                return 0.4;
            },
            paddingLeft: function paddingLeft(i, node) {
                return 0;
            },
            paddingRight: function paddingRight(i, node) {
                return 0;
            },
            paddingTop: function paddingTop(i, node) {
                return 0;
            },
            paddingBottom: function paddingBottom(i, node) {
                return 0;
            },
            hLineColor: function hLineColor(i, node) {
                return '#EFEFEF';
            },
            vLineColor: function vLineColor(i, node) {
                return '#EFEFEF';
            }
        },
        headerBorderSeparatedRows: {
            hLineWidth: function hLineWidth(i, node) {
                return 0.4;
            },
            vLineWidth: function vLineWidth(i, node) {
                return 0;
            },
            paddingLeft: function paddingLeft(i, node) {
                return 5;
            },
            paddingRight: function paddingRight(i, node) {
                return 5;
            },
            paddingTop: function paddingTop(i, node) {
                return 5;
            },
            paddingBottom: function paddingBottom(i, node) {
                return 5;
            },
            hLineColor: function hLineColor(i, node) {
                return i === 0 || i === node.table.body.length ? '#fbfbfb' : '#f0f0f0';
            },
            vLineColor: function vLineColor(i, node) {
                return i === 0 || i === node.table.widths.length ? 'red' : 'blue';
            }
        },
        headerBorderNoPadding: {
            hLineWidth: function hLineWidth(i, node) {
                return i === 1 ? 2 : 0;
            },
            vLineWidth: function vLineWidth() {
                return 0;
            },
            hLineColor: function hLineColor() {
                return '#eeeeee';
            },
            paddingLeft: function paddingLeft() {
                return 0;
            },
            paddingRight: function paddingRight() {
                return 0;
            },
            paddingTop: function paddingTop() {
                return 0;
            },
            paddingBottom: function paddingBottom() {
                return 0;
            }
        }
    }
};

var ChartPDFStyles = exports.ChartPDFStyles = {
    headerSeparator: {
        marginTop: 6,
        marginBottom: 8
    },
    chartNameLabel: {
        fontSize: 12,
        bold: true
    },
    dateRangeLabel: {
        marginTop: 5,
        fontSize: 12
    },
    grandTotalLabel: {
        fontSize: 9
    },
    grandValue: {
        bold: true
    },
    grandPostfix: {
        bold: true
    },

    filterView: {
        fillColor: '#EFEFEF',
        color: '#373737'
    },
    dataTable: {
        fontSize: 7,
        color: '#111111'
    },

    dataTableSmall: {
        fontSize: 5.4,
        color: '#111111'
    },
    secondDataRow: {
        fillColor: '#EFEFEF'
    },
    dataName: {
        alignment: 'left',
        margin: [10, 2, 0, 2]
    },
    dataNameSmall: {
        alignment: 'left',
        margin: [10, 0, 0, 0]
    },
    dataValue: {
        alignment: 'right',
        margin: [5, 2, 5, 2]
    },
    dataValueSmall: {
        alignment: 'right',
        margin: [5, 0, 5, 0]
    },
    dataValueWithPercents: {
        alignment: 'right',
        margin: [2, 2, 0, 2]
    },
    dataValueWithPercentsSmall: {
        alignment: 'right',
        margin: [2, 0, 0, 0]
    },
    footerTable: {
        margin: [23, 0, 23, 0],
        fontSize: 7
    },

    rightFooterPart: {
        alignment: 'right',
        color: '#3D3D3D'
    },
    leftFooterPart: {
        alignment: 'left',
        color: '#6A6A6A'
    }
};

var ChartPDFFooters = exports.ChartPDFFooters = {
    simpleFooter: function simpleFooter() {

        return function (currentPage, pageCount) {

            return {
                style: 'footerTable',
                layout: 'noBordersNoPadding',

                table: {
                    widths: ['90%', '10%'],
                    body: [[{
                        style: 'leftFooterPart',
                        text: _messageResource2.default.getMessage('report.chart_pdf.leftFooterLabel', [new _date_format.DateFormat(window.SystemSettings.dateFormat).formatDate(new Date())])
                    }, {
                        style: 'rightFooterPart',
                        text: _messageResource2.default.getMessage('report.chart_pdf.rightFooterLabel', [currentPage, pageCount])
                    }]]
                }
            };
        };
    }
};

/**
 * utils method needed to return sizes of images depends on parameters
 * @param paperOrientation - page orientation
 * @param paperSize - papers size
 * @param chartType - current chartType
 * @param isDoubleImagesOnPage - singleOrDoubleImages on page (double if no need to show data list)
 * @returns {*}
 */
var getNeededImageDimensions = exports.getNeededImageDimensions = function getNeededImageDimensions(paperOrientation, paperSize, chartType, isDoubleImagesOnPage) {
    var dimensions = {};
    _jquery2.default.extend(true, dimensions, _getChartDependentsParameters(paperOrientation, paperSize, chartType).imageParams);
    if (isDoubleImagesOnPage) {
        return dimensions.doubleImage.sizes;
    } else {
        return dimensions.singleImage.sizes;
    }
};

var _getChartDependentsParameters = function _getChartDependentsParameters(paperOrientation, paperSize, chartType) {
    var paramsForReturn = {};
    var chartTypeParams = ChartPDFParameters[paperOrientation][paperSize][chartType];
    _jquery2.default.extend(paramsForReturn, chartTypeParams);
    return paramsForReturn;
};

var getMaxValuesOnPageProperty = exports.getMaxValuesOnPageProperty = function getMaxValuesOnPageProperty(_ref) {
    var paperOrientation = _ref.paperOrientation,
        paperSize = _ref.paperSize,
        chartType = _ref.chartType;

    return _getChartDependentsParameters(paperOrientation, paperSize, chartType).maxValuesOnPage;
};

var getMaxValuesOnFitPageProperty = exports.getMaxValuesOnFitPageProperty = function getMaxValuesOnFitPageProperty(_ref2) {
    var paperOrientation = _ref2.paperOrientation,
        paperSize = _ref2.paperSize,
        chartType = _ref2.chartType;

    return _getChartDependentsParameters(paperOrientation, paperSize, chartType).maxValuesOnFitPage;
};

var getMaxValuesOnPageWithoutImageProperty = exports.getMaxValuesOnPageWithoutImageProperty = function getMaxValuesOnPageWithoutImageProperty(_ref3) {
    var paperOrientation = _ref3.paperOrientation,
        paperSize = _ref3.paperSize,
        chartType = _ref3.chartType,
        withHeader = _ref3.withHeader;

    if (withHeader) {
        return _getChartDependentsParameters(paperOrientation, paperSize, chartType).maxValuesOnPageWithoutImage.withHeader;
    }
    return _getChartDependentsParameters(paperOrientation, paperSize, chartType).maxValuesOnPageWithoutImage.withoutHeader;
};

var getMaxValuesOnFitPageWithoutImageProperty = exports.getMaxValuesOnFitPageWithoutImageProperty = function getMaxValuesOnFitPageWithoutImageProperty(_ref4) {
    var paperOrientation = _ref4.paperOrientation,
        paperSize = _ref4.paperSize,
        chartType = _ref4.chartType,
        withHeader = _ref4.withHeader;

    if (withHeader) {
        return _getChartDependentsParameters(paperOrientation, paperSize, chartType).maxValuesOnFitPageWithoutImage.withHeader;
    }
    return _getChartDependentsParameters(paperOrientation, paperSize, chartType).maxValuesOnFitPageWithoutImage.withoutHeader;
};

var ChartPDFParameters = exports.ChartPDFParameters = (_ChartPDFParameters = {

    dataTableCommonStyles: {
        small: {
            tableStyle: 'dataTableSmall',
            tableValueStyles: {
                dataValueStyle: 'dataValueSmall',
                dataValueWithPercentStyle: 'dataValueWithPercentsSmall',
                dataNameStyle: 'dataNameSmall',
                colorRectangleDimensions: {
                    paddingLeft: 16,
                    x: 4,
                    y: 1.25,
                    h: 3.8,
                    w: 7
                }
            }
        },
        big: {
            tableStyle: 'dataTable',
            tableValueStyles: {
                dataValueStyle: 'dataValue',
                dataValueWithPercentStyle: 'dataValueWithPercents',
                dataNameStyle: 'dataName',
                colorRectangleDimensions: {
                    paddingLeft: 18,
                    x: 4,
                    y: 4,
                    h: 5,
                    w: 9
                }
            }
        }
    },

    logoPlaceholderSizes: {
        width: 100,
        height: 56
    }

}, _defineProperty(_ChartPDFParameters, _constants2.PaperOrientation.LANDSCAPE, (_PaperOrientation$LAN = {
    pageOrientation: 'landscape',
    pageMargins: [56, 28, 56, 28],

    filterViewParameters: {
        margins: {
            top: 0
        },
        imageWidth: 10,
        fontSize: 9,
        widths: ['12%', '88%']
    },

    filterViewParametersWithTwoRows: {
        imageMargins: {
            top: 11,
            left: 12
        },
        firstRowMargins: {
            top: 10,
            bottom: 5
        },
        secondRowMargins: {
            top: 8,
            bottom: 9
        }
    },

    filterViewParametersWithThreeRows: {
        imageMargins: {
            top: 8,
            left: 12
        },
        firstRowMargins: {
            top: 7,
            bottom: 0
        },
        secondRowMargins: {
            top: 3,
            bottom: 0
        },
        thirdRowMargins: {
            top: 4,
            bottom: 7
        }
    }

}, _defineProperty(_PaperOrientation$LAN, _constants2.PaperSize.A4, (_PaperSize$A = {
    pageSize: 'A4',

    filterViewTextLen: 51, //57

    chartInfoParameters: {
        withLogo: {
            splitterLen: 350,
            widths: ['25%', '75%']
        },
        withoutLogo: {
            splitterLen: 460,
            widths: ['0%', '100%']
        }
    }

}, _defineProperty(_PaperSize$A, _constants.ChartType.VERTICAL_BAR, {
    maxValuesOnPage: 21,
    maxValuesOnFitPage: 42,

    rowDataMaxLen: {
        normal: {
            valueAndPercents: 120,
            valueOrPercents: 126
        },
        fit: {
            valueAndPercents: 160,
            valueOrPercents: 165
        }
    },
    dataTableMargins: {
        top: 10,
        right: 200
    },
    imageParams: {
        singleImage: {
            margins: {
                top: 20
            },
            sizes: {
                h: 180,
                w: 725
            }
        },
        doubleImage: {
            margins: {
                top: 20
            },
            sizes: {
                h: 180,
                w: 725
            }
        }
    }
}), _defineProperty(_PaperSize$A, _constants.ChartType.HORIZONTAL_BAR, {
    maxValuesOnPage: -1, // not used
    maxValuesOnFitPage: -1, // not used

    maxValuesOnPageWithoutImage: {
        withHeader: 36,
        withoutHeader: 42
    },

    maxValuesOnFitPageWithoutImage: {
        withHeader: 72,
        withoutHeader: 82
    },

    rowDataMaxLen: {
        normal: {
            valueAndPercents: 120,
            valueOrPercents: 126
        },
        fit: {
            valueAndPercents: 160,
            valueOrPercents: 165
        }
    },
    dataTableMargins: {
        top: 0,
        right: 200
    },
    imageParams: {
        singleImage: {
            margins: {
                top: 15
            },
            sizes: {
                h: 460,
                w: 735
            }
        },
        doubleImage: {
            margins: {
                top: 15
            },
            sizes: {
                h: 460,
                w: 354
            }
        }
    }
}), _defineProperty(_PaperSize$A, _constants.ChartType.PIE_CHART, {}), _PaperSize$A)), _defineProperty(_PaperOrientation$LAN, _constants2.PaperSize.LETTER, (_PaperSize$LETTER = {
    pageSize: 'Letter',

    filterViewTextLen: 48, //54

    chartInfoParameters: {
        withLogo: {
            splitterLen: 315,
            widths: ['25%', '75%']
        },
        withoutLogo: {
            splitterLen: 430,
            widths: ['0%', '100%']
        }
    }

}, _defineProperty(_PaperSize$LETTER, _constants.ChartType.VERTICAL_BAR, {
    maxValuesOnPage: 22,
    maxValuesOnFitPage: 44,

    rowDataMaxLen: {
        normal: {
            valueAndPercents: 125,
            valueOrPercents: 135
        },
        fit: {
            valueAndPercents: 165,
            valueOrPercents: 170
        }
    },
    dataTableMargins: {
        top: 10,
        right: 140
    },
    imageParams: {
        singleImage: {
            margins: {
                top: 20
            },
            sizes: {
                h: 180,
                w: 675
            }
        },
        doubleImage: {
            margins: {
                top: 20
            },
            sizes: {
                h: 180,
                w: 675
            }
        }
    }
}), _defineProperty(_PaperSize$LETTER, _constants.ChartType.HORIZONTAL_BAR, {
    maxValuesOnPage: -1, // not used
    maxValuesOnFitPage: -1, // not used

    maxValuesOnPageWithoutImage: {
        withHeader: 38,
        withoutHeader: 44
    },

    maxValuesOnFitPageWithoutImage: {
        withHeader: 76,
        withoutHeader: 86
    },

    rowDataMaxLen: {
        normal: {
            valueAndPercents: 125,
            valueOrPercents: 135
        },
        fit: {
            valueAndPercents: 165,
            valueOrPercents: 170
        }
    },
    dataTableMargins: {
        top: 15,
        right: 140
    },
    imageParams: {

        singleImage: {
            margins: {
                top: 15
            },
            sizes: {
                h: 465,
                w: 690
            }
        },
        doubleImage: {
            margins: {
                top: 15
            },
            sizes: {
                h: 465,
                w: 330
            }
        }
    }
}), _defineProperty(_PaperSize$LETTER, _constants.ChartType.PIE_CHART, {}), _PaperSize$LETTER)), _PaperOrientation$LAN)), _defineProperty(_ChartPDFParameters, _constants2.PaperOrientation.PORTRAIT, (_PaperOrientation$POR = {
    pageOrientation: 'portrait',
    pageMargins: [40, 28, 40, 28],

    filterViewParameters: {
        margins: {
            top: 12
        },
        widths: ['6%', '94%'],
        imageWidth: 10,
        fontSize: 9
    },

    filterViewParametersWithTwoRows: {
        imageMargins: {
            top: 11,
            left: 12
        },
        firstRowMargins: {
            top: 10,
            bottom: 5
        },
        secondRowMargins: {
            top: 8,
            bottom: 9
        }
    },

    filterViewParametersWithThreeRows: {
        imageMargins: {
            top: 6,
            left: 12
        },
        firstRowMargins: {
            top: 5,
            bottom: 0
        },
        secondRowMargins: {
            top: 3,
            bottom: 0
        },
        thirdRowMargins: {
            top: 3,
            bottom: 5
        }
    }

}, _defineProperty(_PaperOrientation$POR, _constants2.PaperSize.A4, (_PaperSize$A2 = {
    pageSize: 'A4',

    filterViewTextLen: 102, //108

    chartInfoParameters: {
        withLogo: {
            splitterLen: 403,
            widths: ['22%', '78%']
        },
        withoutLogo: {
            splitterLen: 517,
            widths: ['0%', '100%']
        }
    }

}, _defineProperty(_PaperSize$A2, _constants.ChartType.VERTICAL_BAR, {
    maxValuesOnPage: 28,
    maxValuesOnFitPage: 56,

    rowDataMaxLen: {
        normal: {
            valueAndPercents: 120,
            valueOrPercents: 126
        },
        fit: {
            valueAndPercents: 160,
            valueOrPercents: 165
        }
    },
    dataTableMargins: {
        top: 18
    },
    imageParams: {
        singleImage: {
            margins: {
                top: 15
            },
            sizes: {
                h: 260,
                w: 513
            }
        },
        doubleImage: {
            margins: {
                top: 15
            },
            sizes: {
                h: 260,
                w: 513
            }
        }
    }
}), _defineProperty(_PaperSize$A2, _constants.ChartType.HORIZONTAL_BAR, {
    maxValuesOnPage: 24,
    maxValuesOnFitPage: 48,

    rowDataMaxLen: {
        normal: {
            valueAndPercents: 120,
            valueOrPercents: 126
        },
        fit: {
            valueAndPercents: 160,
            valueOrPercents: 165
        }
    },
    dataTableMargins: {
        top: 18
    },
    imageParams: {
        singleImage: {
            margins: {
                top: 15
            },
            sizes: {
                h: 330,
                w: 513
            }
        },
        doubleImage: {
            margins: {
                top: 20
            },
            sizes: {
                h: 290,
                w: 513
            }
        }
    }
}), _defineProperty(_PaperSize$A2, _constants.ChartType.PIE_CHART, {
    maxValuesOnPage: 26,
    maxValuesOnFitPage: 52,

    maxValuesOnPageWithoutImage: {
        withHeader: 52,
        withoutHeader: 62
    },

    rowDataMaxLen: {
        normal: {
            valueAndPercents: 115,
            valueOrPercents: 120
        },
        fit: {
            valueAndPercents: 155,
            valueOrPercents: 160
        }
    },
    dataTableMargins: {
        top: 8
    },
    imageParams: {
        singleImage: {
            margins: {
                top: 25
            },
            sizes: {
                h: 305,
                w: 513
            }
        },
        doubleImage: {} //no need fot this chart type
    }
}), _PaperSize$A2)), _defineProperty(_PaperOrientation$POR, _constants2.PaperSize.LETTER, (_PaperSize$LETTER2 = {
    pageSize: 'Letter',

    filterViewTextLen: 105, // 111

    chartInfoParameters: {
        withLogo: {
            splitterLen: 415,
            widths: ['22%', '78%']
        },
        withoutLogo: {
            splitterLen: 533,
            widths: ['0%', '100%']
        }
    }

}, _defineProperty(_PaperSize$LETTER2, _constants.ChartType.VERTICAL_BAR, {
    maxValuesOnPage: 24,
    maxValuesOnFitPage: 48,

    rowDataMaxLen: {
        normal: {
            valueAndPercents: 125,
            valueOrPercents: 135
        },
        fit: {
            valueAndPercents: 165,
            valueOrPercents: 170
        }
    },
    dataTableMargins: {
        top: 18
    },
    imageParams: {
        singleImage: {
            margins: {
                top: 15
            },
            sizes: {
                h: 260,
                w: 530
            }
        },
        doubleImage: {
            margins: {
                top: 15
            },
            sizes: {
                h: 260,
                w: 530
            }
        }
    }
}), _defineProperty(_PaperSize$LETTER2, _constants.ChartType.HORIZONTAL_BAR, {
    maxValuesOnPage: 20,
    maxValuesOnFitPage: 40,

    rowDataMaxLen: {
        normal: {
            valueAndPercents: 125,
            valueOrPercents: 135
        },
        fit: {
            valueAndPercents: 165,
            valueOrPercents: 170
        }
    },
    dataTableMargins: {
        top: 18
    },
    imageParams: {
        singleImage: {
            margins: {
                top: 15
            },
            sizes: {
                h: 330,
                w: 530
            }
        },
        doubleImage: {
            margins: {
                top: 15
            },
            sizes: {
                h: 280,
                w: 530
            }
        }
    }
}), _defineProperty(_PaperSize$LETTER2, _constants.ChartType.PIE_CHART, {
    maxValuesOnPage: 22,
    maxValuesOnFitPage: 44,

    maxValuesOnPageWithoutImage: {
        withHeader: 49,
        withoutHeader: 58

    },

    rowDataMaxLen: {
        normal: {
            valueAndPercents: 120,
            valueOrPercents: 130
        },
        fit: {
            valueAndPercents: 160,
            valueOrPercents: 165
        }
    },
    dataTableMargins: {
        top: 8
    },
    imageParams: {
        singleImage: {
            margins: {
                top: 25
            },
            sizes: {
                h: 305,
                w: 530
            }
        },
        doubleImage: {} //no need fot this chart type
    }
}), _PaperSize$LETTER2)), _PaperOrientation$POR)), _ChartPDFParameters);

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _BaseReportStore2 = __webpack_require__(830);

var _BaseReportStore3 = _interopRequireDefault(_BaseReportStore2);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Has common store components for Leaves report, its PDF export etc
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


var LeavesReportStore = function (_BaseReportStore) {
    _inherits(LeavesReportStore, _BaseReportStore);

    function LeavesReportStore() {
        _classCallCheck(this, LeavesReportStore);

        var _this = _possibleConstructorReturn(this, (LeavesReportStore.__proto__ || Object.getPrototypeOf(LeavesReportStore)).call(this));

        _this.showAssignedOnlyEnabled = false;
        _this.showAssignedOnly = false;
        _this.viewerInfo = null;
        _this.chartSectionConfig = {
            showChart: false
        };
        _this.manageableUserIds = [];
        _this.reportAuthorizationInfo = {};
        return _this;
    }

    _createClass(LeavesReportStore, [{
        key: 'setReportAuthorizationInfo',
        value: function setReportAuthorizationInfo(reportAuthorizationInfo) {
            this.reportAuthorizationInfo = reportAuthorizationInfo;
        }
    }, {
        key: 'getReportAuthorizationInfo',
        value: function getReportAuthorizationInfo() {
            return this.reportAuthorizationInfo;
        }
    }, {
        key: 'setManageableUserIds',
        value: function setManageableUserIds(manageableUserIds) {
            this.manageableUserIds = manageableUserIds;
        }
    }, {
        key: 'getManageableUserIds',
        value: function getManageableUserIds() {
            return this.manageableUserIds;
        }
    }, {
        key: 'isShowAssignedOnlyEnabled',
        value: function isShowAssignedOnlyEnabled() {
            return this.showAssignedOnlyEnabled;
        }
    }, {
        key: 'setShowAssignedOnlyEnabled',
        value: function setShowAssignedOnlyEnabled(showAssignedOnlyEnabled) {
            this.showAssignedOnlyEnabled = showAssignedOnlyEnabled;
        }
    }, {
        key: 'getViewerInfo',
        value: function getViewerInfo() {
            return this.viewerInfo;
        }
    }, {
        key: 'setViewerInfo',
        value: function setViewerInfo(viewerInfo) {
            this.viewerInfo = viewerInfo;
        }
    }, {
        key: 'isShowAssignedOnly',
        value: function isShowAssignedOnly() {
            return this.showAssignedOnly;
        }
    }, {
        key: 'setShowAssignedOnly',
        value: function setShowAssignedOnly(showAssignedOnly) {
            this.showAssignedOnly = showAssignedOnly;
        }
    }, {
        key: 'getChartSectionConfig',
        value: function getChartSectionConfig() {
            return this.chartSectionConfig;
        }
    }, {
        key: 'setChartSectionConfig',
        value: function setChartSectionConfig(chartSectionConfig) {
            this.chartSectionConfig = chartSectionConfig;
            (0, _jquery2.default)(this).trigger("chartSectionConfigChange");
        }
    }, {
        key: 'getDefaultWorkDayDuration',
        value: function getDefaultWorkDayDuration() {
            return this.defaultWorkDayDuration;
        }
    }, {
        key: 'setDefaultWorkDayDuration',
        value: function setDefaultWorkDayDuration(defaultWorkDayDuration) {
            this.defaultWorkDayDuration = defaultWorkDayDuration;
        }
    }, {
        key: 'mergeGeneralStore',
        value: function mergeGeneralStore(generalStore) {
            if (!this.groupingData.USER) this.groupingData.USER = {};
            mergeArrayToNullableMap(this.groupingData.USER, generalStore.getVisibleUsers());
            if (!this.groupingData.USER_GROUP) this.groupingData.USER_GROUP = {};
            mergeArrayToNullableMap(this.groupingData.USER_GROUP, generalStore.getUserGroups());
            if (!this.groupingData.TIME_ZONE_GROUP) this.groupingData.TIME_ZONE_GROUP = {};
            mergeArrayToNullableMap(this.groupingData.TIME_ZONE_GROUP, generalStore.getTimeZoneGroups());

            generalStore.getReportAuthorizationInfo && this.setReportAuthorizationInfo(generalStore.getReportAuthorizationInfo());
            generalStore.getManageableUserIds && this.setManageableUserIds(generalStore.getManageableUserIds());
        }
    }]);

    return LeavesReportStore;
}(_BaseReportStore3.default);

var store = new LeavesReportStore();
exports.default = store;

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getUserSelectionDescription = exports.createWarningMsgs = undefined;
exports.canUserAccessManagerScopes = canUserAccessManagerScopes;
exports.canManageUsersRight = canManageUsersRight;
exports.isPossibleToEditUserAssignments = isPossibleToEditUserAssignments;
exports.canAccessAllWorkScope = canAccessAllWorkScope;
exports.doesUserCanEnterTimeTrack = doesUserCanEnterTimeTrack;
exports.isWorkScopeChangeable = isWorkScopeChangeable;

var _constants = __webpack_require__(4);

var _date_format = __webpack_require__(16);

var _UserNameFormat = __webpack_require__(17);

var _UserNameFormat2 = _interopRequireDefault(_UserNameFormat);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _constants2 = __webpack_require__(201);

var _GroupType = __webpack_require__(34);

var _GroupType2 = _interopRequireDefault(_GroupType);

var _atUtils = __webpack_require__(5);

var _pluralizeUtils = __webpack_require__(40);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function canUserAccessManagerScopes(_ref) {
    var userInfo = _ref.userInfo,
        isURAEnabled = _ref.isURAEnabled,
        isBTYEnabled = _ref.isBTYEnabled;
    var hasManageUsersRight = userInfo.hasManageUsersRight,
        hasManageScopeRight = userInfo.hasManageScopeRight,
        hasGenerateMoneyReportsRight = userInfo.hasGenerateMoneyReportsRight,
        hasManageOtherTTRight = userInfo.hasManageOtherTTRight;


    return hasManageUsersRight || hasManageScopeRight || hasManageOtherTTRight || hasGenerateMoneyReportsRight && (isURAEnabled || isBTYEnabled);
}

function canManageUsersRight(userInfo) {
    return userInfo.hasManageUsersRight;
}

function isPossibleToEditUserAssignments(_ref2) {
    var userInfo = _ref2.userInfo,
        isURAEnabled = _ref2.isURAEnabled,
        isBTYEnabled = _ref2.isBTYEnabled;

    return canUserAccessManagerScopes({ userInfo: userInfo, isURAEnabled: isURAEnabled, isBTYEnabled: isBTYEnabled }) && !canManageUsersRight(userInfo);
}

function canAccessAllWorkScope(_ref3) {
    var userInfo = _ref3.userInfo,
        isURAEnabled = _ref3.isURAEnabled,
        isBTYEnabled = _ref3.isBTYEnabled;

    return userInfo.hasManageUsersRight || canUserAccessManagerScopes({ userInfo: userInfo, isURAEnabled: isURAEnabled, isBTYEnabled: isBTYEnabled }) && userInfo.managementAssignmentsSelection === _constants.ManagementAssignmentsSelection.ALL;
}

function doesUserCanEnterTimeTrack(userInfo) {
    return userInfo.hasSubmitTTRight;
}

function isWorkScopeChangeable(_ref4) {
    var userInfo = _ref4.userInfo,
        isURAEnabled = _ref4.isURAEnabled,
        isBTYEnabled = _ref4.isBTYEnabled;
    var hasManageUsersRight = userInfo.hasManageUsersRight,
        canManageAllScope = userInfo.canManageAllScope;


    return !hasManageUsersRight && !(canUserAccessManagerScopes({ userInfo: userInfo, isURAEnabled: isURAEnabled, isBTYEnabled: isBTYEnabled }) && canManageAllScope);
}

var createWarningMsgs = exports.createWarningMsgs = function createWarningMsgs(userInfo, isCreatingUser) {
    var warnings = userInfo.warnings;
    if (!warnings) return {};

    var warningMsgs = [];
    var infoMsgs = [];

    var fullName = _UserNameFormat2.default.formatFML(userInfo.firstName, userInfo.lastName, userInfo.middleInitial);

    for (var i = 0; i < warnings.length; i++) {
        var warningCode = warnings[i];

        if (warningCode === _constants.UserManagementConstants.WARNING_ACCOUNT_DISABLED_DUE_TO_LICENSE_TERMS || warningCode === _constants.UserManagementConstants.WARNING_ACCOUNT_DISABLED_IN_OTHER_PRODUCT_DUE_TO_LICENSE_TERMS || warningCode === _constants.UserManagementConstants.WARNING_ACCOUNT_DISABLED_IN_BOTH_PRODUCTS_DUE_TO_LICENSE_TERMS) {

            var key = warningCode === _constants.UserManagementConstants.WARNING_ACCOUNT_DISABLED_DUE_TO_LICENSE_TERMS ? "userlist.js.warning_account_disabled_due_to_license_terms_at" : warningCode === _constants.UserManagementConstants.WARNING_ACCOUNT_DISABLED_IN_OTHER_PRODUCT_DUE_TO_LICENSE_TERMS ? "userlist.js.warning_account_disabled_due_to_license_terms_ap" : "userlist.js.warning_account_disabled_due_to_license_terms_both_products";

            var messagePart1 = _messageResource2.default.getEscapedMessage(key, [fullName]);
            var messagePart2 = _messageResource2.default.getEscapedMessage("userlist.js.warning_account_disabled_due_to_license_terms_info", [fullName]);

            warningMsgs.push(messagePart1 + "<p class='sameMsgNewParagraph'>" + messagePart2 + "</p>");
        } else if (warningCode === _constants.UserManagementConstants.WARNING_USER_GROUP_NO_LONGER_EXISTS) {
            warningMsgs.push(_messageResource2.default.getEscapedMessage("userlist.js.warning_user_group_no_longer_exists", [fullName]));
        } else if (warningCode === _constants.UserManagementConstants.WARNING_TIME_ZONE_GROUP_NO_LONGER_EXISTS) {
            warningMsgs.push(_messageResource2.default.getEscapedMessage("userlist.js.warning_time_zone_group_no_longer_exists", [fullName]));
        } else if (warningCode === _constants.UserManagementConstants.WARNING_NO_RIGHT_TO_EDIT_STATUS_IN_OTHER_PRODUCT) {
            warningMsgs.push(_messageResource2.default.getEscapedMessage(isCreatingUser ? "userlist.js.warning_no_right_to_edit_status_in_ap.creating" : "userlist.js.warning_no_right_to_edit_status_in_ap.editing"));
        } else if (warningCode === _constants.UserManagementConstants.WARNING_ACCOUNT_DISABLED_DUE_TO_FUTURE_HIRE_DATE) {
            var formattedHireDate = new _date_format.DateFormat(window.SystemSettings.dateFormat).formatDate(userInfo.hireDate.parseJSONDate());
            infoMsgs.push(_messageResource2.default.getEscapedMessage("userlist.js.warning_account_disabled_due_to_future_hire_date_at", [formattedHireDate]));
        } else if (warningCode === _constants.UserManagementConstants.WARNING_ACCOUNT_DISABLED_IN_OTHER_PRODUCT_DUE_TO_FUTURE_HIRE_DATE) {
            var _formattedHireDate = new _date_format.DateFormat(window.SystemSettings.dateFormat).formatDate(userInfo.hireDate.parseJSONDate());
            infoMsgs.push(_messageResource2.default.getEscapedMessage("userlist.js.warning_account_disabled_due_to_future_hire_date_ap", [_formattedHireDate]));
        } else if (warningCode === _constants.UserManagementConstants.WARNING_ACCOUNT_DISABLED_IN_BOTH_PRODUCTS_DUE_TO_FUTURE_HIRE_DATE) {
            var _formattedHireDate2 = new _date_format.DateFormat(window.SystemSettings.dateFormat).formatDate(userInfo.hireDate.parseJSONDate());
            infoMsgs.push(_messageResource2.default.getEscapedMessage("userlist.js.warning_account_disabled_due_to_future_hire_date_both_products", [_formattedHireDate2]));
        } else if (_constants2.WarningsMap.hasOwnProperty([warningCode])) warningMsgs.push(_messageResource2.default.getEscapedMessage(_constants2.WarningsMap[warningCode]));else throw "Unknown warning code has been received from the server: " + warningCode;
    }

    return { warningMsgs: warningMsgs, infoMsgs: infoMsgs };
};

var getUserSelectionDescription = exports.getUserSelectionDescription = function getUserSelectionDescription(selection, allUsers) {
    var groups = selection.getFirstLevel();
    var users = selection.getSecondLevel();
    var type = selection.groupType;

    var noneSelected = !type && users.length === 0 || groups.length === 0 && users.length === 0;
    if (noneSelected) {
        return _messageResource2.default.getEscapedMessage("users_selector.short_no_users_selected");
    } else {
        var groupIds = (0, _atUtils.arrayToSet)(groups.map(function (g) {
            return g.id;
        }));
        var userIds = (0, _atUtils.arrayToSet)(users.map(function (u) {
            return u.id;
        }));
        var selectedUsers = users;
        if (type === _GroupType2.default.USER_GROUP) {
            selectedUsers = allUsers.filter(function (user) {
                return groupIds[user.userGroupId] || userIds[user.id];
            });
        } else if (type === _GroupType2.default.TIME_ZONE_GROUP) {
            selectedUsers = allUsers.filter(function (user) {
                return groupIds[user.timeZoneGroupId] || userIds[user.id];
            });
        }
        var itemNoun = (0, _pluralizeUtils.userNameLower)(selectedUsers.length);
        return selectedUsers.length + " " + itemNoun;
    }
};

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ErrorsExceptions = exports.AdditionalDataConstants = exports.WarningsMap = undefined;

var _WarningsMap;

var _constants = __webpack_require__(4);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var GC = window.__GENERATED_CONSTANTS__;

var WarningsMap = exports.WarningsMap = (_WarningsMap = {}, _defineProperty(_WarningsMap, _constants.UserManagementConstants.WARNING_MANAGE_BALANCE_RIGHT_REVOKED, "userlist.js.warning_manage_balance_right_revoked"), _defineProperty(_WarningsMap, _constants.UserManagementConstants.WARNING_MANAGE_ACCOUNT_SETTINGS_RIGHT_REVOKED, "userlist.js.warning_manage_account_settings_right_revoked"), _defineProperty(_WarningsMap, _constants.UserManagementConstants.WARNING_PTO_FEATURE_DISABLED, "userlist.js.warning_pto_feature_disabled"), _defineProperty(_WarningsMap, _constants.UserManagementConstants.WARNING_SICK_FEATURE_DISABLED, "userlist.js.warning_pto_feature_disabled"), _WarningsMap);

var AdditionalDataConstants = exports.AdditionalDataConstants = {
    MANAGE_ASSIGNMENTS_DATA: GC.UserManagementAdditionalData.MANAGEMENT_ASSIGNMENTS_COUNTERS,
    TEAM_ASSIGNMENTS_DATA: GC.UserManagementAdditionalData.TEAM_ASSIGNMENTS_DATA,
    USERS_WITHOUT_APPROVERS_DATA: GC.UserManagementAdditionalData.USERS_WITHOUT_APPROVERS_DATA,
    ALL_USERS_AUTOAPPROVED: GC.UserManagementAdditionalData.ALL_USERS_AUTOAPPROVED,
    MANAGEMENT_ASSIGNMENTS_COUNTERS: GC.UserManagementAdditionalData.MANAGEMENT_ASSIGNMENTS_COUNTERS,
    WORK_ASSIGNMENTS_COUNTERS: GC.UserManagementAdditionalData.WORK_ASSIGNMENTS_COUNTERS,
    ALL_ASSIGNED_INFO: GC.UserManagementAdditionalData.ALL_ASSIGNED_INFO,
    RATES: GC.UserManagementAdditionalData.RATES,
    CONCURRENTLY_REMOVED_ENTITIES: GC.UserManagementAdditionalData.CONCURRENTLY_REMOVED_ENTITIES,
    ACTIVE_LEAVE_TYPES: GC.UserManagementAdditionalData.ACTIVE_LEAVE_TYPES,
    TIME_ZONE_GROUPS_DATA: GC.UserManagementAdditionalData.TIME_ZONE_GROUPS_DATA
};

var ErrorsExceptions = exports.ErrorsExceptions = {
    NO_SUCH_USER: "com.actimind.actitime.administration.NoSuchUserException"
};

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.handleCommonExceptions = exports.isLicenseViolated = exports.isLicenseUnlimited = exports.haveMoreLicenses = exports.saveActiveTabNum = exports.getSavedActiveTabNumOrDefault = undefined;

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _constants = __webpack_require__(4);

var _util = __webpack_require__(254);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getSavedActiveTabNumOrDefault = exports.getSavedActiveTabNumOrDefault = function getSavedActiveTabNumOrDefault() {
    var tabVal = _jquery2.default.cookie("actiTime-userlist-tabs");
    if (tabVal) {
        tabVal = Number(tabVal);
    } else {
        tabVal = _constants.UserManagementConstants.ACCOUNT_SETTINGS_TAB_NUM;
    }
    return tabVal;
};

var saveActiveTabNum = exports.saveActiveTabNum = function saveActiveTabNum(tabNum) {
    _jquery2.default.cookie("actiTime-userlist-tabs", tabNum, { expires: 4000 });
};

var haveMoreLicenses = exports.haveMoreLicenses = function haveMoreLicenses(licenseCounters) {
    var remainingCount = licenseCounters.remainingCount;
    return isLicenseUnlimited(licenseCounters) || remainingCount > 0;
};

var isLicenseUnlimited = exports.isLicenseUnlimited = function isLicenseUnlimited(licenseCounters) {
    return licenseCounters.remainingCount === _constants.UserManagementConstants.LICENSE_UNLIM;
};

var isLicenseViolated = exports.isLicenseViolated = function isLicenseViolated(licenseCounters) {
    return licenseCounters.licenseViolated;
};

var handleCommonExceptions = exports.handleCommonExceptions = function handleCommonExceptions(rpcError) {
    rpcError.handleOnException(_util.EXCEPTIONS.NoSuchUserException);
    rpcError.handleOnException(_util.EXCEPTIONS.NoRightsToManageAccountSettings);
};

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getCopyUserFrom = exports.getSelectorsUsers = exports.isViewerHasEntireScope = exports.getCopySelectedOption = exports.isCopyUserAllScope = exports.getCopyUserCounters = exports.isAssignAllScopeContentLoading = exports.isCopyLoading = exports.getCopyUserId = exports.getAssignAllScopeContent = exports.isNoCptAssignedToUserAtAll = exports.getCopyContentState = exports.isShowAllAssignScopeContent = exports.isShowCopyContent = exports.getEntirelyAssignedProjectCounter = exports.getEntirelyAssignedTasksCounter = exports.isNeedToLoadData = exports.isShown = exports.isShowArchivedEntities = exports.isLoaded = exports.isLoading = exports.selectCustomerEntities = exports.selectProjectEntities = exports.selectTaskEntities = exports.getPanelUserFML = exports.getPanelUserFirstName = exports.getCounters = exports.loadedTabs = exports.isSearchOpen = exports.getSearch = exports.getProjectIds = exports.getTaskIds = exports.getTab = exports.getUserId = undefined;

var _reselect = __webpack_require__(13);

var _selectors = __webpack_require__(312);

var _selectorsGenerator = __webpack_require__(394);

var _selectorsGenerator2 = _interopRequireDefault(_selectorsGenerator);

var _atUtils = __webpack_require__(5);

var _accessRightsUtils = __webpack_require__(188);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getWorkAssignmentsPanelState = function getWorkAssignmentsPanelState(state) {
    return state.userManagement.workAssignmentsPanel;
};
var hierarchyAssignmentsPanelTabSelectors = (0, _selectorsGenerator2.default)(getWorkAssignmentsPanelState);

var getUserId = exports.getUserId = hierarchyAssignmentsPanelTabSelectors.getUserId;

var getTab = exports.getTab = hierarchyAssignmentsPanelTabSelectors.getTab;

var getTaskIds = exports.getTaskIds = hierarchyAssignmentsPanelTabSelectors.getTaskIds;

var getProjectIds = exports.getProjectIds = hierarchyAssignmentsPanelTabSelectors.getProjectIds;

var getSearch = exports.getSearch = hierarchyAssignmentsPanelTabSelectors.getSearch;

var isSearchOpen = exports.isSearchOpen = hierarchyAssignmentsPanelTabSelectors.isSearchOpen;

var loadedTabs = exports.loadedTabs = hierarchyAssignmentsPanelTabSelectors.getLoadedTabs;

var getCounters = exports.getCounters = hierarchyAssignmentsPanelTabSelectors.getCounters;

var getPanelUserFirstName = exports.getPanelUserFirstName = hierarchyAssignmentsPanelTabSelectors.getPanelUserFirstName;

var getPanelUserFML = exports.getPanelUserFML = hierarchyAssignmentsPanelTabSelectors.getPanelUserFML;

var selectTaskEntities = exports.selectTaskEntities = hierarchyAssignmentsPanelTabSelectors.selectTaskWaEntities;

var selectProjectEntities = exports.selectProjectEntities = hierarchyAssignmentsPanelTabSelectors.selectProjectWaEntities;

var selectCustomerEntities = exports.selectCustomerEntities = hierarchyAssignmentsPanelTabSelectors.selectCustomerWaEntities;

var isLoading = exports.isLoading = hierarchyAssignmentsPanelTabSelectors.isLoading;

var isLoaded = exports.isLoaded = hierarchyAssignmentsPanelTabSelectors.isLoaded;

var isShowArchivedEntities = exports.isShowArchivedEntities = hierarchyAssignmentsPanelTabSelectors.isShowArchivedEntities;

var isShown = exports.isShown = (0, _reselect.createSelector)(getUserId, function (userId) {
    return userId !== null;
});

var isNeedToLoadData = exports.isNeedToLoadData = (0, _reselect.createSelector)(isShown, isLoaded, getTab, loadedTabs, _selectors.showEditor, function (show, loaded, tab, loadedTabs, showEditor) {
    return show === true && (loaded === false || loadedTabs[tab] === false) && showEditor === false;
});

var getEntirelyAssignedTasksCounter = exports.getEntirelyAssignedTasksCounter = (0, _reselect.createSelector)(getTaskIds, getCounters, function (ids, counters) {
    return counters.tasks.curValue - ids.length;
});

var getEntirelyAssignedProjectCounter = exports.getEntirelyAssignedProjectCounter = (0, _reselect.createSelector)(getProjectIds, getCounters, function (ids, counters) {
    return counters.projects.curValue - ids.length;
});

var isShowCopyContent = exports.isShowCopyContent = function isShowCopyContent(state) {
    return getWorkAssignmentsPanelState(state).showCopyContent;
};

var isShowAllAssignScopeContent = exports.isShowAllAssignScopeContent = function isShowAllAssignScopeContent(state) {
    return getAssignAllScopeContent(state).show;
};

var getCopyContentState = exports.getCopyContentState = function getCopyContentState(state) {
    return getWorkAssignmentsPanelState(state).copyContent;
};

var isNoCptAssignedToUserAtAll = exports.isNoCptAssignedToUserAtAll = function isNoCptAssignedToUserAtAll(state) {
    return getWorkAssignmentsPanelState(state).noCptAssignedToUserAtAll;
};

var getAssignAllScopeContent = exports.getAssignAllScopeContent = function getAssignAllScopeContent(state) {
    return getWorkAssignmentsPanelState(state).assignAllScopeContent;
};

var getCopyUserId = exports.getCopyUserId = function getCopyUserId(state) {
    return getCopyContentState(state).userId;
};

var isCopyLoading = exports.isCopyLoading = function isCopyLoading(state) {
    return getCopyContentState(state).loading;
};

var isAssignAllScopeContentLoading = exports.isAssignAllScopeContentLoading = function isAssignAllScopeContentLoading(state) {
    return getAssignAllScopeContent(state).loading;
};

var getCopyUserCounters = exports.getCopyUserCounters = function getCopyUserCounters(state) {
    return getCopyContentState(state).counters;
};

var isCopyUserAllScope = exports.isCopyUserAllScope = function isCopyUserAllScope(state) {
    return getCopyContentState(state).isAllScopeToCopyUserFrom;
};

var getCopySelectedOption = exports.getCopySelectedOption = function getCopySelectedOption(state) {
    return getCopyContentState(state).selectedOption;
};

var isViewerHasEntireScope = exports.isViewerHasEntireScope = function isViewerHasEntireScope(state) {
    return getCopyContentState(state).viewerHasEntireScope;
};

var _getSelectorsUsers = (0, _reselect.createSelector)(getCopyContentState, function (copyContent) {
    return copyContent.usersForSelector;
});

var getSelectorsUsers = exports.getSelectorsUsers = (0, _reselect.createSelector)(_getSelectorsUsers, getUserId, function (usersForSelector, userToId) {
    return usersForSelector.filter(function (user) {
        return user.id !== userToId && (0, _accessRightsUtils.hasSubmitTTRight)(user);
    });
});

var getCopyUserFrom = exports.getCopyUserFrom = (0, _reselect.createSelector)(getCopyUserId, getSelectorsUsers, function (id, users) {
    var usersMap = (0, _atUtils.arrayToMap)(users);
    return usersMap[id];
});

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isUserHasSelectedScope = exports.getCopyUserFrom = exports.getSelectorsUsers = exports.getCopyUserCounters = exports.isCopyLoading = exports.getCopyUserId = exports.getCopyContentState = exports.isShowCopyContent = exports.getEntirelyAssignedProjectCounter = exports.getEntirelyAssignedTasksCounter = exports.isNeedToLoadData = exports.isShown = exports.isShowArchivedEntities = exports.getManagementAssignmentsSelection = exports.isPanelOpened = exports.isLoaded = exports.isLoading = exports.selectCustomerEntities = exports.selectProjectEntities = exports.selectTaskEntities = exports.getPanelUser = exports.getPanelUserFML = exports.getPanelUserFirstName = exports.getUsersCounters = exports.getCounters = exports.loadedTabs = exports.isSearchOpen = exports.getSearch = exports.getProjectIds = exports.getTaskIds = exports.getTab = exports.getUserId = undefined;

var _reselect = __webpack_require__(13);

var _selectorsGenerator = __webpack_require__(394);

var _selectorsGenerator2 = _interopRequireDefault(_selectorsGenerator);

var _selectors = __webpack_require__(312);

var _selectors2 = __webpack_require__(64);

var _atUtils = __webpack_require__(5);

var _constants = __webpack_require__(4);

var _accessRightsUtils = __webpack_require__(188);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getEditManagementAssignmentsPanelState = function getEditManagementAssignmentsPanelState(state) {
    return state.userManagement.editManagementAssignmentsPanel;
};
var hierarchyAssignmentsPanelTabSelectors = (0, _selectorsGenerator2.default)(getEditManagementAssignmentsPanelState);

var getUserId = exports.getUserId = hierarchyAssignmentsPanelTabSelectors.getUserId;

var getTab = exports.getTab = hierarchyAssignmentsPanelTabSelectors.getTab;

var getTaskIds = exports.getTaskIds = hierarchyAssignmentsPanelTabSelectors.getTaskIds;

var getProjectIds = exports.getProjectIds = hierarchyAssignmentsPanelTabSelectors.getProjectIds;

var getSearch = exports.getSearch = hierarchyAssignmentsPanelTabSelectors.getSearch;

var isSearchOpen = exports.isSearchOpen = hierarchyAssignmentsPanelTabSelectors.isSearchOpen;

var loadedTabs = exports.loadedTabs = hierarchyAssignmentsPanelTabSelectors.getLoadedTabs;

var getCounters = exports.getCounters = hierarchyAssignmentsPanelTabSelectors.getCounters;

var getUsersCounters = exports.getUsersCounters = hierarchyAssignmentsPanelTabSelectors.getUsersCounters;

var getPanelUserFirstName = exports.getPanelUserFirstName = hierarchyAssignmentsPanelTabSelectors.getPanelUserFirstName;

var getPanelUserFML = exports.getPanelUserFML = hierarchyAssignmentsPanelTabSelectors.getPanelUserFML;

var getPanelUser = exports.getPanelUser = hierarchyAssignmentsPanelTabSelectors.getPanelUser;

var selectTaskEntities = exports.selectTaskEntities = hierarchyAssignmentsPanelTabSelectors.selectTaskMaEntities;

var selectProjectEntities = exports.selectProjectEntities = hierarchyAssignmentsPanelTabSelectors.selectProjectMaEntities;

var selectCustomerEntities = exports.selectCustomerEntities = hierarchyAssignmentsPanelTabSelectors.selectCustomerMaEntities;

var isLoading = exports.isLoading = hierarchyAssignmentsPanelTabSelectors.isLoading;

var isLoaded = exports.isLoaded = hierarchyAssignmentsPanelTabSelectors.isLoaded;

var isPanelOpened = exports.isPanelOpened = function isPanelOpened(state) {
    return getEditManagementAssignmentsPanelState(state).userId !== null;
};

var getManagementAssignmentsSelection = exports.getManagementAssignmentsSelection = function getManagementAssignmentsSelection(state) {
    return (0, _selectors2.getManagementAssignmentsSelection)(state);
};

var isShowArchivedEntities = exports.isShowArchivedEntities = hierarchyAssignmentsPanelTabSelectors.isShowArchivedEntities;

var isShown = exports.isShown = (0, _reselect.createSelector)(getUserId, function (userId) {
    return userId !== null;
});

var isNeedToLoadData = exports.isNeedToLoadData = (0, _reselect.createSelector)(isShown, isLoaded, getTab, loadedTabs, _selectors.showEditor, function (show, loaded, tab, loadedTabs, showEditor) {
    return show === true && (loaded === false || loadedTabs[tab] === false) && showEditor === false;
});

var getEntirelyAssignedTasksCounter = exports.getEntirelyAssignedTasksCounter = (0, _reselect.createSelector)(getTaskIds, getCounters, function (ids, counters) {
    return counters.tasks.curValue - ids.length;
});

var getEntirelyAssignedProjectCounter = exports.getEntirelyAssignedProjectCounter = (0, _reselect.createSelector)(getProjectIds, getCounters, function (ids, counters) {
    return counters.projects.curValue - ids.length;
});

var isShowCopyContent = exports.isShowCopyContent = (0, _reselect.createSelector)(getEditManagementAssignmentsPanelState, function (panelState) {
    return panelState.showCopyContent;
});

var getCopyContentState = exports.getCopyContentState = (0, _reselect.createSelector)(getEditManagementAssignmentsPanelState, function (panelState) {
    return panelState.copyContent;
});

var getCopyUserId = exports.getCopyUserId = (0, _reselect.createSelector)(getCopyContentState, function (copyContent) {
    return copyContent.userId;
});

var isCopyLoading = exports.isCopyLoading = (0, _reselect.createSelector)(getCopyContentState, function (copyContent) {
    return copyContent.loading;
});

var getCopyUserCounters = exports.getCopyUserCounters = (0, _reselect.createSelector)(getCopyContentState, function (copyContent) {
    return copyContent.counters;
});

var _getSelectorsUsers = (0, _reselect.createSelector)(getCopyContentState, function (copyContent) {
    return copyContent.usersForSelector;
});

var getSelectorsUsers = exports.getSelectorsUsers = (0, _reselect.createSelector)(_getSelectorsUsers, getUserId, function (usersForSelector, userToId) {
    return usersForSelector.filter(function (user) {
        return user.id !== userToId && (0, _accessRightsUtils.canAccessManagersScope)(user) && !(0, _accessRightsUtils.canAccessAllManagementScope)(user) && user.managementAssignmentsSelection === _constants.ManagementAssignmentsSelection.SELECTED;
    });
});

var getCopyUserFrom = exports.getCopyUserFrom = (0, _reselect.createSelector)(getCopyUserId, getSelectorsUsers, function (id, users) {
    var usersMap = (0, _atUtils.arrayToMap)(users);
    return usersMap[id];
});

var isUserHasSelectedScope = exports.isUserHasSelectedScope = (0, _reselect.createSelector)(getUsersCounters, function (counters) {
    return counters.tasks > 0;
});

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getUserRatesErrors = exports.isInitialScheduleValid = exports.isUserRateValid = exports.isRateValid = exports.isLeaveRatesValid = exports.isLeaveRatesEmpty = exports.isRateEmpty = exports.isValueEmpty = exports.mergeUserRates = exports.getValidRates = undefined;

var _FloatNumberValidator = __webpack_require__(314);

var _FloatNumberValidator2 = _interopRequireDefault(_FloatNumberValidator);

var _constants = __webpack_require__(4);

var _constants2 = __webpack_require__(206);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _constants3 = __webpack_require__(21);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var floatNumberValidator = new _FloatNumberValidator2.default(window.SystemSettings.decimalSeparator);

var getValidRates = exports.getValidRates = function getValidRates(_ref) {
    var rates = _ref.rates,
        leaveTypesEnabled = _ref.leaveTypesEnabled,
        overtimeEnabled = _ref.overtimeEnabled;


    return rates.filter(function (rate) {
        return isUserRateValid(rate, overtimeEnabled, leaveTypesEnabled);
    });
};

var mergeUserRates = exports.mergeUserRates = function mergeUserRates(oldRates, newRates) {
    var ratesByDate = {};
    newRates.forEach(function (rate) {
        return ratesByDate[rate.effectiveDate] = rate;
    });
    var result = [];
    oldRates.forEach(function (rate) {
        if (ratesByDate[rate.effectiveDate]) {
            result.push(ratesByDate[rate.effectiveDate]);
        } else {
            result.push(rate);
        }
    });
    return result;
};

var isValueEmpty = exports.isValueEmpty = function isValueEmpty(rate) {
    return rate === undefined || rate === null || rate.length === 0;
};

var isRateEmpty = exports.isRateEmpty = function isRateEmpty(rate, overtimeEnabled, leaveTypesEnabled) {
    return isValueEmpty(rate.regularRate) && (!overtimeEnabled || isValueEmpty(rate.overtimeRate)) && (!leaveTypesEnabled || isLeaveRatesEmpty(rate.leaveRates));
};

var isLeaveRatesEmpty = exports.isLeaveRatesEmpty = function isLeaveRatesEmpty(leaveRates) {
    return !leaveRates || leaveRates.length === 0 || leaveRates.every(function (leaveRate) {
        return isValueEmpty(leaveRate.rate);
    });
};

var isLeaveRatesValid = exports.isLeaveRatesValid = function isLeaveRatesValid(leaveRates) {
    return leaveRates && leaveRates.every(function (leaveRate) {
        return isRateValid(leaveRate.rate);
    });
};

var isRateValid = exports.isRateValid = function isRateValid(rate) {
    return floatNumberValidator.isValidNumber(rate) && floatNumberValidator.parseFloat(rate) < _constants.MAX_RATE;
};

var isUserRateValid = exports.isUserRateValid = function isUserRateValid(rate, overtimeEnabled, leaveTypesEnabled) {
    return rate.effectiveDate !== null && !isValueEmpty(rate.regularRate) && isRateValid(rate.regularRate) && (!overtimeEnabled || !isValueEmpty(rate.overtimeRate) && isRateValid(rate.overtimeRate)) && (!leaveTypesEnabled || !isLeaveRatesEmpty(rate.leaveRates) && isLeaveRatesValid(rate.leaveRates));
};

var isInitialScheduleValid = exports.isInitialScheduleValid = function isInitialScheduleValid(initialSchedule) {
    return initialSchedule.every(function (d) {
        return d !== null;
    });
};

var getUserRatesErrors = exports.getUserRatesErrors = function getUserRatesErrors(rates, overtimeEnabled, leaveTypesEnabled, withWarning, updatingRateIndex, updatingRate) {
    var isValid = true;
    var errors = {};

    var rateByEffectiveDate = _underscore2.default.groupBy(rates.filter(function (rate) {
        return rate.effectiveDate !== null;
    }), 'effectiveDate');

    rates.forEach(function (rate, index) {
        var error = {};

        var rateEmpty = isRateEmpty(rate, overtimeEnabled, leaveTypesEnabled);

        error[_constants2.UserRatesErrors.EFFECTIVE_DATE_EMPTY] = !rateEmpty && isValueEmpty(rate.effectiveDate);
        error[_constants3.ValidationErrors.DUPLICATED_EFFECTIVE_DATE] = rate.effectiveDate !== null && rateByEffectiveDate[rate.effectiveDate].length > 1;

        error[_constants2.UserRatesErrors.REGULAR_RATE_EMPTY] = !rateEmpty && isValueEmpty(rate.regularRate);
        error[_constants2.UserRatesErrors.REGULAR_RATE_INVALID] = !rateEmpty && !isRateValid(rate.regularRate);

        if (overtimeEnabled) {
            error[_constants2.UserRatesErrors.OVERTIME_RATE_EMPTY] = !rateEmpty && isValueEmpty(rate.overtimeRate);

            error[_constants2.UserRatesErrors.OVERTIME_RATE_INVALID] = !rateEmpty && !isRateValid(rate.overtimeRate);
        }
        if (leaveTypesEnabled) {
            error[_constants2.UserRatesErrors.LEAVE_RATES_EMPTY] = !rateEmpty && isLeaveRatesEmpty(rate.leaveRates);
            error[_constants2.UserRatesErrors.LEAVE_RATES_INVALID] = !rateEmpty && !isLeaveRatesValid(rate.leaveRates);
        }
        if (Object.values(error).some(function (value) {
            return value === true;
        })) errors[index] = error;

        isValid = isValid && !errors[index];
    });

    if (withWarning && !!errors[updatingRateIndex]) {
        var rateWasEmpty = isRateEmpty(updatingRate, overtimeEnabled, leaveTypesEnabled);

        if (rateWasEmpty && updatingRate.regularRate !== rates[updatingRateIndex].regularRate && errors[updatingRateIndex][_constants2.UserRatesErrors.REGULAR_RATE_INVALID]) errors[updatingRateIndex] = _defineProperty({}, _constants2.UserRatesErrors.REGULAR_RATE_INVALID, true);

        if (rateWasEmpty && updatingRate.overtimeRate !== rates[updatingRateIndex].overtimeRate && errors[updatingRateIndex][_constants2.UserRatesErrors.OVERTIME_RATE_INVALID]) errors[updatingRateIndex] = _defineProperty({}, _constants2.UserRatesErrors.OVERTIME_RATE_INVALID, true);

        if (rateWasEmpty && !_underscore2.default.isEqual(updatingRate.leaveRates, rates[updatingRateIndex].leaveRates) && errors[updatingRateIndex][_constants2.UserRatesErrors.LEAVE_RATES_INVALID]) errors[updatingRateIndex] = _defineProperty({}, _constants2.UserRatesErrors.LEAVE_RATES_INVALID, true);

        errors[updatingRateIndex].showWarning = getWarning(updatingRate, rates[updatingRateIndex], errors[updatingRateIndex]);
    }

    return {
        isValid: isValid,
        errors: errors
    };
};

var getWarning = function getWarning(updatingRate, rate, error) {
    return (error[_constants2.UserRatesErrors.EFFECTIVE_DATE_EMPTY] || error[_constants3.ValidationErrors.DUPLICATED_EFFECTIVE_DATE]) && updatingRate.effectiveDate !== rate.effectiveDate ? _constants2.ShowWarning.EFFECTIVE_DATE_WARNING : (error[_constants2.UserRatesErrors.REGULAR_RATE_EMPTY] || error[_constants2.UserRatesErrors.REGULAR_RATE_INVALID]) && updatingRate.regularRate !== rate.regularRate ? _constants2.ShowWarning.REGULAR_RATE_WARNING : (error[_constants2.UserRatesErrors.OVERTIME_RATE_EMPTY] || error[_constants2.UserRatesErrors.OVERTIME_RATE_INVALID]) && updatingRate.overtimeRate !== rate.overtimeRate ? _constants2.ShowWarning.OVERTIME_RATE_WARNING : (error[_constants2.UserRatesErrors.LEAVE_RATES_EMPTY] || error[_constants2.UserRatesErrors.LEAVE_RATES_INVALID]) && !_underscore2.default.isEqual(updatingRate.leaveRates, rate.leaveRates) ? _constants2.ShowWarning.LEAVE_RATES_WARNING : null;
};

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var UserRatesErrors = exports.UserRatesErrors = {
    EFFECTIVE_DATE_EMPTY: "effectiveDateEmpty",
    EFFECTIVE_DATE_DUPLICATE: "effectiveDateDuplicate",
    REGULAR_RATE_EMPTY: "regularRateEmpty",
    REGULAR_RATE_INVALID: "regularRateInvalid",
    OVERTIME_RATE_EMPTY: "overtimeRateEmpty",
    OVERTIME_RATE_INVALID: "overtimeRateInvalid",
    LEAVE_RATES_EMPTY: "leaveRatesEmpty",
    LEAVE_RATES_INVALID: "leaveRatesInvalid",

    RATE_EMPTY: "rateEmpty",
    RATE_INVALID: "rateInvalid"
};

var ShowWarning = exports.ShowWarning = {
    EFFECTIVE_DATE_WARNING: "effectiveDateWarning",
    REGULAR_RATE_WARNING: "regularRateWarning",
    OVERTIME_RATE_WARNING: "overtimeRateWarning",
    LEAVE_RATES_WARNING: "leaveRatesWarning"
};

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.copyAssignments = exports.loadCopyManagementAssignmentSelectorUsers = exports.loadUserCounters = exports.cancelCopy = exports.showCopyContent = exports.revokeEntitiesAction = exports.revokeAllTypeAction = exports.loadManagementAssignmentPanelDataAction = exports.prepareLoadedData = exports.closePanel = exports.openManagementAssignmentPanel = exports.changeAssignmentPanelTab = exports.changeManagementAssignmentsSelection = exports.setCopySelectorUsers = exports.setCopyCounters = exports.setCopyLoading = exports.setCopyUserId = exports.setIsShowArchiveEntities = exports.clearTabsLoaded = exports.openPanel = exports.setLoaded = exports.setLoading = exports.setSearchOpen = exports.setSearchString = exports.setCustomerTabLoaded = exports.setProjectTabLoaded = exports.setTaskTabLoaded = exports.setUserCounters = exports.setManageExcludingSelfCustomerIds = exports.setManageCustomerIds = exports.setManageExcludingSelfProjectIds = exports.setManageProjectIds = exports.setManageTaskIds = exports.setTab = exports.setUserId = exports.setCustomerIds = exports.setProjectIds = exports.setTaskIds = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _actionTypes = __webpack_require__(691);

var ActionTypes = _interopRequireWildcard(_actionTypes);

var _actions = __webpack_require__(147);

var UserDataActions = _interopRequireWildcard(_actions);

var _utils = __webpack_require__(311);

var _actions2 = __webpack_require__(126);

var _syncCallbacks = __webpack_require__(256);

var SyncCallbacks = _interopRequireWildcard(_syncCallbacks);

var _selectors = __webpack_require__(204);

var _rpcCalls = __webpack_require__(24);

var _rpcCalls2 = _interopRequireDefault(_rpcCalls);

var _actionsGenerator = __webpack_require__(395);

var _actionsGenerator2 = _interopRequireDefault(_actionsGenerator);

var _actions3 = __webpack_require__(29);

var _constants = __webpack_require__(4);

var _actions4 = __webpack_require__(50);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _selectors2 = __webpack_require__(14);

var _actions5 = __webpack_require__(56);

var _actions6 = __webpack_require__(258);

var _atUtils = __webpack_require__(5);

var _selectors3 = __webpack_require__(15);

var _reduxActions = __webpack_require__(9);

var _actions7 = __webpack_require__(68);

var _batch = __webpack_require__(117);

var _rpcUtils = __webpack_require__(160);

var _actions8 = __webpack_require__(167);

var _util = __webpack_require__(254);

var _utils2 = __webpack_require__(202);

var _constants2 = __webpack_require__(259);

var _constants3 = __webpack_require__(108);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var GET_VIEW_USER_MANAGEMENT_ASSIGNMENTS_METHOD = 'UserManagementService.getViewUserManagementAssignments';

var hierarchyAssignmentsTabActions = (0, _actionsGenerator2.default)({
    actionTypes: ActionTypes
});

var setTaskIds = exports.setTaskIds = hierarchyAssignmentsTabActions.setTaskIds;

var setProjectIds = exports.setProjectIds = hierarchyAssignmentsTabActions.setProjectIds;

var setCustomerIds = exports.setCustomerIds = hierarchyAssignmentsTabActions.setCustomerIds;

var setUserId = exports.setUserId = hierarchyAssignmentsTabActions.setUserId;

var setTab = exports.setTab = hierarchyAssignmentsTabActions.setTab;

var setManageTaskIds = exports.setManageTaskIds = hierarchyAssignmentsTabActions.setManageTaskIds;

var setManageProjectIds = exports.setManageProjectIds = hierarchyAssignmentsTabActions.setManageProjectIds;

var setManageExcludingSelfProjectIds = exports.setManageExcludingSelfProjectIds = hierarchyAssignmentsTabActions.setManageExcludingSelfProjectIds;

var setManageCustomerIds = exports.setManageCustomerIds = hierarchyAssignmentsTabActions.setManageCustomerIds;

var setManageExcludingSelfCustomerIds = exports.setManageExcludingSelfCustomerIds = hierarchyAssignmentsTabActions.setManageExcludingSelfCustomerIds;

var setUserCounters = exports.setUserCounters = hierarchyAssignmentsTabActions.setUserCounters;

var setTaskTabLoaded = exports.setTaskTabLoaded = hierarchyAssignmentsTabActions.setTaskTabLoaded;

var setProjectTabLoaded = exports.setProjectTabLoaded = hierarchyAssignmentsTabActions.setProjectTabLoaded;

var setCustomerTabLoaded = exports.setCustomerTabLoaded = hierarchyAssignmentsTabActions.setCustomerTabLoaded;

var setSearchString = exports.setSearchString = hierarchyAssignmentsTabActions.setSearchString;

var setSearchOpen = exports.setSearchOpen = hierarchyAssignmentsTabActions.setSearchOpen;

var setLoading = exports.setLoading = hierarchyAssignmentsTabActions.setLoading;

var setLoaded = exports.setLoaded = hierarchyAssignmentsTabActions.setLoaded;

var openPanel = exports.openPanel = hierarchyAssignmentsTabActions.openPanel;

var clearTabsLoaded = exports.clearTabsLoaded = hierarchyAssignmentsTabActions.clearTabsLoaded;

var setIsShowArchiveEntities = exports.setIsShowArchiveEntities = hierarchyAssignmentsTabActions.setIsShowArchiveEntities;

var openCopyContent = (0, _reduxActions.createAction)(ActionTypes.COPY_CONTENT_OPEN);

var closeCopyContent = (0, _reduxActions.createAction)(ActionTypes.COPY_CONTENT_CLOSE);

var setCopyUserId = exports.setCopyUserId = (0, _reduxActions.createAction)(ActionTypes.COPY_USER_ID_SET);

var setCopyLoading = exports.setCopyLoading = (0, _reduxActions.createAction)(ActionTypes.COPY_LOADING_SET);

var setCopyCounters = exports.setCopyCounters = (0, _reduxActions.createAction)(ActionTypes.COPY_COUNTERS_SET);

var setCopySelectorUsers = exports.setCopySelectorUsers = (0, _reduxActions.createAction)(ActionTypes.COPY_USER_IDS_FOR_SELECTOR_SET);

var resetSearch = hierarchyAssignmentsTabActions.resetSearch;

var changeManagementAssignmentsSelection = exports.changeManagementAssignmentsSelection = function changeManagementAssignmentsSelection(managementAssignmentsSelection) {
    return function (dispatch, getState) {
        dispatch((0, _actions2.setUpdatingData)(true));
        var editUserId = (0, _selectors.getUserId)(getState());
        var prevManagementAssignmentsSelection = (0, _selectors.getManagementAssignmentsSelection)(getState());
        var isWAFeatureEnabled = (0, _selectors3.isWASEnabled)(getState());

        (0, _rpcCalls2.default)("UserManagementService.changeUserManagementAssignmentsSelection", [editUserId, managementAssignmentsSelection], function (rpcError) {
            return (0, _utils2.handleCommonExceptions)(rpcError);
        }).then(function (data) {
            var userInfo = data.userInfo;

            var userManagementData = {
                viewerSettings: data.viewerSettings
            };
            if (data.userGroups) {
                userManagementData.allUserGroups = data.userGroups;
            }
            if (data.timeZoneGroups) {
                userManagementData.allTimeZoneGroups = data.timeZoneGroups;
            }

            dispatch((0, _actions4.setUserManagementData)(userManagementData));

            dispatch(UserDataActions.setFullUserInfo(_extends({}, userInfo, {
                accessRights: (0, _utils.convertUserAccessRightsDataFromRpc)(userInfo)
            })));

            dispatch((0, _actions3.addUser)(userInfo));
            dispatch((0, _actions6.updateWorkAssignmentsCounters)(data));

            dispatch((0, _actions2.setUpdatingData)(false));
            dispatch(UserDataActions.setUserManageAssignmentsData((0, _utils.convertManagementAssignmentsDataFromRpc)(data.additionalResultData.map['manageAssignmentsData'])));
            SyncCallbacks.onUpdateUserData(data);

            if ((managementAssignmentsSelection === _constants.ManagementAssignmentsSelection.NO || managementAssignmentsSelection === _constants.ManagementAssignmentsSelection.SELECTED && prevManagementAssignmentsSelection === _constants.ManagementAssignmentsSelection.ALL) && isWAFeatureEnabled) {
                dispatch((0, _actions5.toast)(_messageResource2.default.getMessage('user_list.toasts.revoke_all_management_scope')));
            }
        }).catch(function (error) {
            dispatch((0, _actions4.handleCommonError)(editUserId, error));
            dispatch((0, _actions2.setUpdatingData)(false));
            dispatch(UserDataActions.addUserPanelErrors([error._providerStatus]));
        });
    };
};

var changeAssignmentPanelTab = exports.changeAssignmentPanelTab = function changeAssignmentPanelTab(tab) {
    return function (dispatch, getState) {
        dispatch(closeCopyContent());
        var prevTab = (0, _selectors.getTab)(getState());
        if (prevTab !== tab) {
            dispatch(resetSearch());
            dispatch(setTab(tab));
        }
    };
};

var openManagementAssignmentPanel = exports.openManagementAssignmentPanel = function openManagementAssignmentPanel(id, tab) {
    return function (dispatch, getState) {
        if (id === null) return;

        var prevId = (0, _selectors.getUserId)(getState());
        var prevTab = (0, _selectors.getTab)(getState());
        if (id !== prevId) {
            dispatch(cancelLoadData());
            dispatch(openPanel({ userId: id, tab: tab }));
        } else if (tab !== prevTab) {
            dispatch(setTab(tab));
        } else {
            dispatch(closePanel());
        }
    };
};

var cancelLoadData = function cancelLoadData() {
    return function (dispatch) {
        (0, _rpcCalls.abortCall)(GET_VIEW_USER_MANAGEMENT_ASSIGNMENTS_METHOD);
        dispatch(setLoaded(true));
        dispatch(setCustomerTabLoaded(true));
        dispatch(setProjectTabLoaded(true));
        dispatch(setTaskTabLoaded(true));
    };
};

var closePanel = exports.closePanel = function closePanel() {
    return function (dispatch) {
        (0, _rpcCalls.abortCall)(GET_VIEW_USER_MANAGEMENT_ASSIGNMENTS_METHOD);
        dispatch(hierarchyAssignmentsTabActions.closePanel());
        dispatch(closeCopyContent());
    };
};

var prepareLoadedData = exports.prepareLoadedData = function prepareLoadedData(data, tabType) {
    return function (dispatch) {
        dispatch((0, _actions3.addCustomers)(data.customers));
        dispatch((0, _actions3.addProjects)(data.projects));
        dispatch((0, _actions3.addTasks)(data.tasks));

        dispatch((0, _actions.managementAssignmentsCountsLoadSuccess)(data.userCounter));
        dispatch(setUserCounters(data.userCounter));
        dispatch((0, _actions4.setViewerManagementAssignmentsCounters)(data.viewerCounter));

        var maCptIds = data.managementAssignmentsCptIds;

        dispatch(setManageTaskIds((0, _atUtils.arrayToSet)(maCptIds.taskIds)));
        dispatch(setManageProjectIds((0, _atUtils.arrayToSet)(maCptIds.projectIds)));
        dispatch(setManageExcludingSelfProjectIds((0, _atUtils.arrayToSet)(maCptIds.projectIdsExcludingSelf)));
        dispatch(setManageCustomerIds((0, _atUtils.arrayToSet)(maCptIds.customerIds)));
        dispatch(setManageExcludingSelfCustomerIds((0, _atUtils.arrayToSet)(maCptIds.customerIdsExcludingSelf)));

        switch (tabType) {
            case _constants.HierarchyLevels.TASK:
                dispatch(setTaskIds(data.taskIds));
                dispatch(setTaskTabLoaded(true));
                break;
            case _constants.HierarchyLevels.PROJECT:
                dispatch(setProjectIds(data.projectIds));
                dispatch(setProjectTabLoaded(true));
                break;
            case _constants.HierarchyLevels.CUSTOMER:
                dispatch(setCustomerIds(data.customerIds));
                dispatch(setCustomerTabLoaded(true));
                break;
        }
        dispatch(setLoaded(true));
    };
};

var loadManagementAssignmentPanelDataAction = exports.loadManagementAssignmentPanelDataAction = function loadManagementAssignmentPanelDataAction() {
    return function (dispatch, getState) {
        var userId = (0, _selectors.getUserId)(getState());
        var tabType = (0, _selectors.getTab)(getState());
        dispatch(setLoading(true));
        (0, _rpcCalls2.default)(GET_VIEW_USER_MANAGEMENT_ASSIGNMENTS_METHOD, [userId, tabType], function (rpcError) {
            return (0, _utils2.handleCommonExceptions)(rpcError);
        }).then((0, _batch.batched)(function (data) {
            dispatch(prepareLoadedData(data.viewAssignmentsData, tabType));
            dispatch((0, _actions8.setWorkAssignmentsCountersForUser)(userId, data.userWorkAssignmentsCounters));
            dispatch((0, _actions.setUserManagementAssignmentsSelection)(data.managementAssignmentsSelection));
            dispatch(setLoading(false));
        })).catch(function (err) {
            if ((0, _rpcUtils.isAborted)(err)) return;

            dispatch(setLoading(false));
            dispatch((0, _actions4.handleCommonError)(userId, err));
            dispatch(closePanel());
        });
    };
};

var revokeAllTypeAction = exports.revokeAllTypeAction = function revokeAllTypeAction() {
    return function (dispatch, getState) {
        var userId = (0, _selectors.getUserId)(getState());
        var type = (0, _selectors.getTab)(getState());
        dispatch(setLoading(true));

        var isWAFeatureEnabled = (0, _selectors3.isWASEnabled)(getState());

        (0, _rpcCalls2.default)('UserManagementService.revokeAllManagementAssignment', [userId, type], function (rpcError) {
            return (0, _utils2.handleCommonExceptions)(rpcError);
        }).then(function (data) {
            dispatch(prepareLoadedData(data.additionalResultData.map['manageAssignmentsData'], type));
            dispatch(setLoading(false));
            SyncCallbacks.onUpdateUserData(data);
            if (isWAFeatureEnabled) dispatch((0, _actions5.toast)(getAllEntitiesRevokedMessage(type)));
        }).catch(function (error) {
            dispatch(setLoading(false));
            dispatch((0, _actions4.handleCommonError)(userId, error));
        });
    };
};

var revokeEntitiesAction = exports.revokeEntitiesAction = function revokeEntitiesAction(revokeEntityLevel, id) {
    return function (dispatch, getState) {
        var userId = (0, _selectors.getUserId)(getState());
        var typeTab = (0, _selectors.getTab)(getState());
        dispatch(setLoading(true));

        var isWAFeatureEnabled = (0, _selectors3.isWASEnabled)(getState());

        (0, _rpcCalls2.default)('UserManagementService.revokeEntityManagementAssignment', [userId, typeTab, id, revokeEntityLevel], function (rpcError) {
            return (0, _utils2.handleCommonExceptions)(rpcError);
        }).then(function (data) {
            dispatch(prepareLoadedData(data.additionalResultData.map['manageAssignmentsData'], typeTab));
            dispatch(setLoading(false));
            SyncCallbacks.onUpdateUserData(data);

            // TODO bakharev: what if typeTab != revokeEntityLevel
            if (isWAFeatureEnabled) dispatch((0, _actions5.toast)(getEntityRevokedMessage(getState, revokeEntityLevel, id)));
        }).catch(function (error) {
            dispatch(setLoading(false));
            dispatch((0, _actions4.handleCommonError)(userId, error));
        });
    };
};

var showCopyContent = exports.showCopyContent = function showCopyContent() {
    return function (dispatch) {
        dispatch(openCopyContent());
        dispatch(loadCopyManagementAssignmentSelectorUsers());
    };
};

var cancelCopy = exports.cancelCopy = function cancelCopy() {
    return function (dispatch) {
        dispatch(closeCopyContent());
    };
};

var loadUserCounters = exports.loadUserCounters = function loadUserCounters(userId) {
    return function (dispatch) {
        dispatch(setCopyLoading(true));
        (0, _rpcCalls2.default)('UserManagementService.getUserManagementAssignmentsCounters', [userId], function (rpcError) {
            return (0, _utils2.handleCommonExceptions)(rpcError);
        }).then((0, _batch.batched)(function (data) {
            dispatch(setCopyCounters(data));
            dispatch(setCopyUserId(userId));
            dispatch(setCopyLoading(false));
        })).catch(function (error) {
            dispatch((0, _actions4.handleCommonError)(userId, error));
            dispatch(setCopyLoading(false));
        });
    };
};

var loadCopyManagementAssignmentSelectorUsers = exports.loadCopyManagementAssignmentSelectorUsers = function loadCopyManagementAssignmentSelectorUsers() {
    return function (dispatch) {
        dispatch(setCopyLoading(true));
        (0, _rpcCalls2.default)('UserManagementService.getUserSelectorData', [], function (rpcError) {
            return (0, _utils2.handleCommonExceptions)(rpcError);
        }).then((0, _batch.batched)(function (data) {
            dispatch(setCopyLoading(false));
            dispatch((0, _actions7.updateFeatures)({
                UGR: data.ugrEnabled,
                TZG: data.tzgEnabled
            }));
            dispatch((0, _actions3.addTimeZoneGroups)(data.timeZoneGroups));
            dispatch((0, _actions3.addUserGroups)(data.userGroups));
            dispatch(setCopySelectorUsers(data.users));
        })).catch(function (error) {
            dispatch(setCopyLoading(false));
        });
    };
};

var copyAssignments = exports.copyAssignments = function copyAssignments() {
    return function (dispatch, getState) {
        var state = getState();
        var userTo = (0, _selectors.getPanelUser)(state);
        var userFrom = (0, _selectors.getCopyUserFrom)(state);

        dispatch(setCopyLoading(true));
        (0, _rpcCalls2.default)('UserManagementService.copyManagementAssignmentsFrom', [userTo.id, userFrom.id], function (rpcError) {
            rpcError.handleOnExceptions([].concat(_toConsumableArray(Object.values(_constants2.Exceptions)), [_constants3.Exceptions.USER_HAS_NO_ACCESS_TO_SCOPE_EXCEPTION]));
            (0, _utils2.handleCommonExceptions)(rpcError);
        }).then((0, _batch.batched)(function (data) {
            dispatch((0, _actions5.toast)(_messageResource2.default.getMessage('management_assignment.panel.copy.toast.settings_copied', [userTo.firstName, userFrom.firstName])));
            dispatch(setCopyLoading(false));
            dispatch(closeCopyContent());
            dispatch(setCustomerTabLoaded(false));
            dispatch(setProjectTabLoaded(false));
            dispatch(setTaskTabLoaded(false));
            dispatch((0, _actions3.addUser)(data.userInfo));
        })).catch(function (error) {
            dispatch((0, _actions4.handleCommonError)(userTo.id, error));
            switch (error.getException()) {
                case _constants2.Exceptions.NoSuchUserException:
                    dispatch((0, _actions4.closeAllPanels)());
                    break;
                case _constants2.Exceptions.NoSuchCopyUserException:
                    alert(_messageResource2.default.getMessage('work_assignments.panel.copy.error.user_deleted'));
                    dispatch((0, _actions3.removeUser)(userFrom.id));
                    SyncCallbacks.onNoSuchUserException(userFrom.id);
                    break;
                case _constants2.Exceptions.UserHasAccessToAllScopeException:
                    alert(_messageResource2.default.getMessage('management_assignment.error.copy.user_to_has_entire_scope'));
                    window.location.reload();
                    break;
                case _constants3.Exceptions.USER_HAS_NO_ACCESS_TO_SCOPE_EXCEPTION:
                    alert(_messageResource2.default.getMessage('management_assignment.error.copy.user_to_has_no_access'));
                    window.location.reload();
                    break;
                default:
                    console.error(error);
                    dispatch(closeCopyContent());
            }
            dispatch(setCopyLoading(false));
        });
    };
};

var getEntityRevokedMessage = function getEntityRevokedMessage(getState, entityType, entityId) {
    var name = void 0;
    switch (entityType) {
        case _constants.HierarchyLevels.CUSTOMER:
            name = (0, _selectors2.getCustomer)(getState(), entityId).name;
            return _messageResource2.default.getMessage('user_list.toasts.revoke_manage_customer_from_user', [name]);
        case _constants.HierarchyLevels.PROJECT:
            name = (0, _selectors2.getProject)(getState(), entityId).name;
            return _messageResource2.default.getMessage('user_list.toasts.revoke_manage_project_from_user', [name]);
        case _constants.HierarchyLevels.TASK:
            name = (0, _selectors2.getTask)(getState(), entityId).name;
            return _messageResource2.default.getMessage('user_list.toasts.revoke_manage_task_from_user', [name]);
    }
    return '';
};

var getAllEntitiesRevokedMessage = function getAllEntitiesRevokedMessage(entityType) {
    switch (entityType) {
        case _constants.HierarchyLevels.CUSTOMER:
            return _messageResource2.default.getMessage('user_list.toasts.revoke_all_customers.view_management_scope');
        case _constants.HierarchyLevels.PROJECT:
            return _messageResource2.default.getMessage('user_list.toasts.revoke_all_projects.view_management_scope');
        case _constants.HierarchyLevels.TASK:
            return _messageResource2.default.getMessage('user_list.toasts.revoke_all_tasks.view_management_scope');
    }
    return '';
};

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getUserPanelPasswordValidationRequested = exports.isUserDataChanged = exports.getApproversByGroupIds = exports.isNeedToLoadData = exports.isLoaded = exports.getManagementAssignmentsCptIds = exports.getCopyUser = exports.getCopyUserId = exports.getManageAssignmentsTasks = exports.getManageAssignments = exports.isShowFutureInvitation = exports.isInvitationSent = exports.isSaving = exports.isUserCreated = exports.getSelectedTab = exports.isLoading = exports.isShown = exports.selectCreateUserPanel = undefined;

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _reselect = __webpack_require__(13);

var _selector = __webpack_require__(255);

var _selectors = __webpack_require__(64);

var _utils = __webpack_require__(866);

var _atUtils = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var selectCreateUserPanel = exports.selectCreateUserPanel = (0, _reselect.createSelector)(_selector.selectUserPanel, function (userPanel) {
    return userPanel.createPanel;
});

var isShown = exports.isShown = function isShown(state) {
    return selectCreateUserPanel(state).show;
};

var isLoading = exports.isLoading = function isLoading(state) {
    return selectCreateUserPanel(state).loading;
};

var getSelectedTab = exports.getSelectedTab = function getSelectedTab(state) {
    return selectCreateUserPanel(state).selectedTab;
};

var isUserCreated = exports.isUserCreated = function isUserCreated(state) {
    return selectCreateUserPanel(state).userCreated;
};

var isSaving = exports.isSaving = function isSaving(state) {
    return selectCreateUserPanel(state).saving;
};

var isInvitationSent = exports.isInvitationSent = function isInvitationSent(state) {
    return selectCreateUserPanel(state).invitationSent;
};

var isShowFutureInvitation = exports.isShowFutureInvitation = function isShowFutureInvitation(state) {
    return selectCreateUserPanel(state).showFutureInvitation;
};

var getManageAssignments = exports.getManageAssignments = function getManageAssignments(state) {
    return selectCreateUserPanel(state).manageAssignments;
};

var getManageAssignmentsTasks = exports.getManageAssignmentsTasks = function getManageAssignmentsTasks(state) {
    return selectCreateUserPanel(state).tasksMap;
};

var getCopyUserId = exports.getCopyUserId = function getCopyUserId(state) {
    return selectCreateUserPanel(state).copyUserId;
};

var getCopyUser = exports.getCopyUser = (0, _reselect.createSelector)(getCopyUserId, _selectors.getAllUsers, function (id, users) {
    return id ? users.find(function (user) {
        return user.id === id;
    }) : null;
});

var getManagementAssignmentsCptIds = exports.getManagementAssignmentsCptIds = (0, _reselect.createSelector)(getManageAssignments, function (ma) {
    return {
        customerIds: ma.addedCustomerIds,
        customerIdsExcludingSelf: ma.addedCustomerIdsExcludingSelf,
        projectIds: ma.addedProjectIds,
        projectIdsExcludingSelf: ma.addedProjectIdsExcludingSelf,
        taskIds: ma.addedTaskIds
    };
});

var isLoaded = exports.isLoaded = function isLoaded(state) {
    return selectCreateUserPanel(state).loaded;
};

var isNeedToLoadData = exports.isNeedToLoadData = (0, _reselect.createSelector)(isShown, isLoaded, function (show, loaded) {
    return show === true && loaded === false;
});

var getApproversByGroupIds = exports.getApproversByGroupIds = function getApproversByGroupIds(state) {
    return selectCreateUserPanel(state).approversByGroupIds;
};

var getDefaultUserInfo = function getDefaultUserInfo(state) {
    return selectCreateUserPanel(state).defaultUserInfo;
};
var getDefaultTeamAssignments = function getDefaultTeamAssignments(state) {
    return selectCreateUserPanel(state).defaultTeamAssignments;
};
var getDefaultManageAssignments = function getDefaultManageAssignments(state) {
    return selectCreateUserPanel(state).defaultManageAssignments;
};

var isFullUserInfoChanged = (0, _reselect.createSelector)(_selectors.getFullUserInfo, getDefaultUserInfo, function (userInfo, defaultUserInfo) {
    return userInfo.firstName !== defaultUserInfo.firstName || userInfo.lastName !== defaultUserInfo.lastName || userInfo.middleInitial !== defaultUserInfo.middleInitial || userInfo.username !== defaultUserInfo.username || userInfo.email !== defaultUserInfo.email || userInfo.password !== defaultUserInfo.password || userInfo.retypedPassword !== defaultUserInfo.retypedPassword || userInfo.userGroupId !== defaultUserInfo.userGroupId || userInfo.timeZoneGroupId !== defaultUserInfo.timeZoneGroupId || userInfo.hireDate !== defaultUserInfo.hireDate || userInfo.enabled !== defaultUserInfo.enabled || userInfo.enabledInOtherProduct !== defaultUserInfo.enabledInOtherProduct || userInfo.overtimeLevel !== defaultUserInfo.overtimeLevel || userInfo.requiresTTApproval !== defaultUserInfo.requiresTTApproval || userInfo.defaultInitialSchedule !== defaultUserInfo.defaultInitialSchedule || !_underscore2.default.isEqual(userInfo.initialSchedule, defaultUserInfo.initialSchedule) || !(0, _utils.areRatesEqual)(userInfo.rates, defaultUserInfo.rates) || !(0, _atUtils.areUnorderedArraysEqual)(userInfo.accessRights, defaultUserInfo.accessRights);
});

var isTeamAssignmentsChanged = (0, _reselect.createSelector)(_selectors.getUserTeamAssignmentsData, getDefaultTeamAssignments, function (teamAssignments, defaultTeamAssignments) {
    return teamAssignments.teamAssignmentType !== defaultTeamAssignments.teamAssignmentType || teamAssignments.assignedUsersCount !== defaultTeamAssignments.assignedUsersCount || !(0, _atUtils.areUnorderedArraysEqual)(teamAssignments.assignedGroups, defaultTeamAssignments.assignedGroups) || !(0, _atUtils.areUnorderedArraysEqual)(teamAssignments.assignedUsers, defaultTeamAssignments.assignedUsers);
});

var isManageAssignmentsChanged = (0, _reselect.createSelector)(getManageAssignments, getDefaultManageAssignments, function (manageAssignments, defaultManageAssignments) {
    return manageAssignments.managementAssignmentsSelection !== defaultManageAssignments.managementAssignmentsSelection || !(0, _atUtils.areUnorderedArraysEqual)(manageAssignments.addedTaskIds, defaultManageAssignments.addedTaskIds) || !(0, _atUtils.areUnorderedArraysEqual)(manageAssignments.addedProjectIds, defaultManageAssignments.addedProjectIds) || !(0, _atUtils.areUnorderedArraysEqual)(manageAssignments.addedCustomerIds, defaultManageAssignments.addedCustomerIds);
});

var isUserDataChanged = exports.isUserDataChanged = (0, _reselect.createSelector)(isFullUserInfoChanged, isTeamAssignmentsChanged, isManageAssignmentsChanged, function (fullUserInfoChanged, teamAssignmentsChanged, manageAssignmentsChanged) {
    return fullUserInfoChanged || teamAssignmentsChanged || manageAssignmentsChanged;
});

var getUserPanelPasswordValidationRequested = exports.getUserPanelPasswordValidationRequested = function getUserPanelPasswordValidationRequested(state) {
    return selectCreateUserPanel(state).passwordValidationRequired;
};

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getInstance = exports.createInstance = undefined;

var _ModalAlert = __webpack_require__(318);

var _ModalAlert2 = _interopRequireDefault(_ModalAlert);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var instance = null;

var createInstance = exports.createInstance = function createInstance($container) {
    instance = new _ModalAlert2.default().init($container);
    return instance;
};

var getInstance = exports.getInstance = function getInstance() {
    if (!instance) {
        throw new ['No such modal instance']();
    }
    return instance;
};

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _CounterProgressBar = __webpack_require__(1674);

var _CounterProgressBar2 = _interopRequireDefault(_CounterProgressBar);

var _Counter = __webpack_require__(876);

var _Counter2 = _interopRequireDefault(_Counter);

var _constants = __webpack_require__(261);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CounterWithProgressBar = function (_TemplateView) {
    _inherits(CounterWithProgressBar, _TemplateView);

    function CounterWithProgressBar(_ref) {
        var _ref$title = _ref.title,
            title = _ref$title === undefined ? "" : _ref$title,
            _ref$hierarchyLevel = _ref.hierarchyLevel,
            hierarchyLevel = _ref$hierarchyLevel === undefined ? "" : _ref$hierarchyLevel,
            _ref$pale = _ref.pale,
            pale = _ref$pale === undefined ? false : _ref$pale,
            _ref$hasProgressBar = _ref.hasProgressBar,
            hasProgressBar = _ref$hasProgressBar === undefined ? false : _ref$hasProgressBar;

        _classCallCheck(this, CounterWithProgressBar);

        var _this = _possibleConstructorReturn(this, (CounterWithProgressBar.__proto__ || Object.getPrototypeOf(CounterWithProgressBar)).call(this));

        _this.props = {
            title: title,
            hierarchyLevel: hierarchyLevel,
            hasProgressBar: hasProgressBar
        };
        _this.state = {
            all: false,
            curValue: 0,
            maxValue: 0,
            title: title,
            active: true,
            pale: pale
        };

        _this.onAnyStatePropertyChanged(['all', 'curValue', 'maxValue', 'active', 'pale'], function () {
            return _this._updateView();
        });

        _this.onStatePropertyChanged('title', function (title) {
            return _this._updateTitle(title);
        });
        return _this;
    }

    _createClass(CounterWithProgressBar, [{
        key: "_updateView",
        value: function _updateView() {
            var counterValue = this.state.curValue;
            this.counter.setState({
                value: counterValue
            });

            var ratio = this.state.maxValue !== 0 ? this.state.curValue / this.state.maxValue : 0;
            if (this.props.hasProgressBar) {
                this.progress.setState({
                    ratio: ratio <= 1 ? ratio : 1
                });
            }

            this.$el.toggleClass("inactive", !this.state.active);

            this.counter.setState({ pale: this.state.pale });
        }
    }, {
        key: "_updateTitle",
        value: function _updateTitle(title) {
            this.$title.text(title);
        }
    }, {
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='workAssignment_counter'>" + "   <div class='counterPlaceholder'/>" + "   <div class='title <%-hierarchyLevelClass%>'><%-title%></div>" + "   <div class='progressPlaceholder'/>" + "</div>";
        }
    }, {
        key: "templateModel",
        value: function templateModel() {
            return {
                hierarchyLevelClass: _constants.HIERARCHY_LEVEL_CLASSES[this.props.hierarchyLevel],
                title: this.props.title
            };
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            this.counter = new _Counter2.default({
                hierarchyLevel: this.props.hierarchyLevel
            }).init(this.find('.counterPlaceholder'));

            if (this.props.hasProgressBar) {
                this.progress = new _CounterProgressBar2.default({
                    hierarchyLevel: this.props.hierarchyLevel
                }).init(this.find('.progressPlaceholder'));
            }

            this.$el.toggleClass("withoutTitle", this.props.title === "");

            this.$title = this.find('.title');

            this.renderInitialState();
        }
    }]);

    return CounterWithProgressBar;
}(_TemplateView3.default);

exports.default = CounterWithProgressBar;

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.assignAllWorkAssignments = exports.closeAssignAllScopeContentMenu = exports.openAssignAllScopeContentMenu = exports.copyAssignments = exports.loadUsers = exports.loadUserCounters = exports.openCopyMenu = exports.setCopySelectorUsers = exports.setCopyOption = exports.setCopyCounters = exports.setCopyAllScope = exports.setCopyLoading = exports.setViewerHasEntireScope = exports.setCopyUserId = exports.setShowCopy = exports.closeCopyContentMenu = exports.openCopyContentMenu = exports.revokeEntitiesAction = exports.revokeAllTypeAction = exports.loadWorkAssignmentPanelDataAction = exports.closePanel = exports.openWorkAssignmentPanel = exports.changeWorkAssignmentPanelTab = exports.setIsShowArchiveEntities = exports.clearTabsLoaded = exports.openPanel = exports.setLoading = exports.setLoaded = exports.setSearchOpen = exports.setSearchString = exports.setCustomerTabLoaded = exports.setProjectTabLoaded = exports.setTaskTabLoaded = exports.setUserCounters = exports.setManageExcludingSelfCustomerIds = exports.setManageCustomerIds = exports.setManageExcludingSelfProjectIds = exports.setManageProjectIds = exports.setManageTaskIds = exports.setTab = exports.setUserId = exports.setCustomerIds = exports.setProjectIds = exports.setTaskIds = exports.setUserHaveNoCptAtAll = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _actionTypes = __webpack_require__(689);

var ActionTypes = _interopRequireWildcard(_actionTypes);

var _reduxActions = __webpack_require__(9);

var _rpcCalls = __webpack_require__(24);

var _rpcCalls2 = _interopRequireDefault(_rpcCalls);

var _actions = __webpack_require__(29);

var _selectors = __webpack_require__(203);

var _constants = __webpack_require__(4);

var _actionsGenerator = __webpack_require__(395);

var _actionsGenerator2 = _interopRequireDefault(_actionsGenerator);

var _actions2 = __webpack_require__(167);

var _actions3 = __webpack_require__(50);

var _actions4 = __webpack_require__(68);

var _selectors2 = __webpack_require__(19);

var _selectors3 = __webpack_require__(53);

var _atUtils = __webpack_require__(5);

var _selectors4 = __webpack_require__(14);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _utils = __webpack_require__(1716);

var _rpcUtils = __webpack_require__(160);

var _constants2 = __webpack_require__(259);

var _constants3 = __webpack_require__(108);

var _syncCallbacks = __webpack_require__(256);

var SyncCallbacks = _interopRequireWildcard(_syncCallbacks);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var GET_VIEW_USER_WORK_ASSIGNMENTS_METHOD = 'UserManagementService.getViewUserWorkAssignments';

var hierarchyAssignmentsTabActions = (0, _actionsGenerator2.default)({
    actionTypes: ActionTypes
});

var setUserHaveNoCptAtAll = exports.setUserHaveNoCptAtAll = (0, _reduxActions.createAction)(ActionTypes.USER_HAVE_NO_CPT_AT_ALL_SET);

var setTaskIds = exports.setTaskIds = hierarchyAssignmentsTabActions.setTaskIds;

var setProjectIds = exports.setProjectIds = hierarchyAssignmentsTabActions.setProjectIds;

var setCustomerIds = exports.setCustomerIds = hierarchyAssignmentsTabActions.setCustomerIds;

var setUserId = exports.setUserId = hierarchyAssignmentsTabActions.setUserId;

var setTab = exports.setTab = hierarchyAssignmentsTabActions.setTab;

var setManageTaskIds = exports.setManageTaskIds = hierarchyAssignmentsTabActions.setManageTaskIds;

var setManageProjectIds = exports.setManageProjectIds = hierarchyAssignmentsTabActions.setManageProjectIds;

var setManageExcludingSelfProjectIds = exports.setManageExcludingSelfProjectIds = hierarchyAssignmentsTabActions.setManageExcludingSelfProjectIds;

var setManageCustomerIds = exports.setManageCustomerIds = hierarchyAssignmentsTabActions.setManageCustomerIds;

var setManageExcludingSelfCustomerIds = exports.setManageExcludingSelfCustomerIds = hierarchyAssignmentsTabActions.setManageExcludingSelfCustomerIds;

var setUserCounters = exports.setUserCounters = hierarchyAssignmentsTabActions.setUserCounters;

var setTaskTabLoaded = exports.setTaskTabLoaded = hierarchyAssignmentsTabActions.setTaskTabLoaded;

var setProjectTabLoaded = exports.setProjectTabLoaded = hierarchyAssignmentsTabActions.setProjectTabLoaded;

var setCustomerTabLoaded = exports.setCustomerTabLoaded = hierarchyAssignmentsTabActions.setCustomerTabLoaded;

var setSearchString = exports.setSearchString = hierarchyAssignmentsTabActions.setSearchString;

var setSearchOpen = exports.setSearchOpen = hierarchyAssignmentsTabActions.setSearchOpen;

var setLoaded = exports.setLoaded = hierarchyAssignmentsTabActions.setLoaded;

var setLoading = exports.setLoading = hierarchyAssignmentsTabActions.setLoading;

var openPanel = exports.openPanel = hierarchyAssignmentsTabActions.openPanel;

var clearTabsLoaded = exports.clearTabsLoaded = hierarchyAssignmentsTabActions.clearTabsLoaded;

var setIsShowArchiveEntities = exports.setIsShowArchiveEntities = hierarchyAssignmentsTabActions.setIsShowArchiveEntities;

var resetSearch = hierarchyAssignmentsTabActions.resetSearch;

var changeWorkAssignmentPanelTab = exports.changeWorkAssignmentPanelTab = function changeWorkAssignmentPanelTab(tab) {
    return function (dispatch, getState) {
        var prevTab = (0, _selectors.getTab)(getState());
        if (prevTab !== tab) {
            dispatch(resetSearch());
            dispatch(setTab(tab));
        }
    };
};

var openWorkAssignmentPanel = exports.openWorkAssignmentPanel = function openWorkAssignmentPanel(id, tab) {
    return function (dispatch, getState) {
        if (id === null) return;

        var prevId = (0, _selectors.getUserId)(getState());
        var prevTab = (0, _selectors.getTab)(getState());
        if (id !== prevId) {
            dispatch(cancelLoadData());
            dispatch(openPanel({ userId: id, tab: tab }));
            dispatch(closeCopyContentMenu());
            dispatch(closeAssignAllScopeContentMenu());
        } else if (tab !== prevTab) {
            dispatch(setTab(tab));
        } else {
            dispatch(closePanel());
        }
    };
};

var closePanel = exports.closePanel = function closePanel() {
    return function (dispatch) {
        (0, _rpcCalls.abortCall)(GET_VIEW_USER_WORK_ASSIGNMENTS_METHOD);
        dispatch(hierarchyAssignmentsTabActions.closePanel());
    };
};

var cancelLoadData = function cancelLoadData() {
    return function (dispatch) {
        (0, _rpcCalls.abortCall)(GET_VIEW_USER_WORK_ASSIGNMENTS_METHOD);
        dispatch(setLoaded(true));
        dispatch(setCustomerTabLoaded(true));
        dispatch(setProjectTabLoaded(true));
        dispatch(setTaskTabLoaded(true));
    };
};

var prepareLoadedData = function prepareLoadedData(data, tabType, userId) {
    return function (dispatch) {
        dispatch((0, _actions.addCustomers)(data.customers));
        dispatch((0, _actions.addProjects)(data.projects));
        dispatch((0, _actions.addTasks)(data.tasks));
        dispatch(setUserHaveNoCptAtAll(data.noCptAssignedToUserAtAll));

        dispatch(setUserCounters(data.userCounter));
        dispatch((0, _actions3.setViewerManagementAssignmentsCounters)(data.viewerCounter));
        dispatch((0, _actions2.setWorkAssignmentsCountersForUser)(userId, data.userCounter));

        var maCptIds = data.managementAssignmentsCptIds;

        dispatch(setManageTaskIds((0, _atUtils.arrayToSet)(maCptIds.taskIds)));
        dispatch(setManageProjectIds((0, _atUtils.arrayToSet)(maCptIds.projectIds)));
        dispatch(setManageExcludingSelfProjectIds((0, _atUtils.arrayToSet)(maCptIds.projectIdsExcludingSelf)));
        dispatch(setManageCustomerIds((0, _atUtils.arrayToSet)(maCptIds.customerIds)));
        dispatch(setManageExcludingSelfCustomerIds((0, _atUtils.arrayToSet)(maCptIds.customerIdsExcludingSelf)));

        switch (tabType) {
            case _constants.HierarchyLevels.TASK:
                dispatch(setTaskIds(data.taskIds));
                dispatch(setTaskTabLoaded(true));
                break;
            case _constants.HierarchyLevels.PROJECT:
                dispatch(setProjectIds(data.projectIds));
                dispatch(setProjectTabLoaded(true));
                break;
            case _constants.HierarchyLevels.CUSTOMER:
                dispatch(setCustomerIds(data.customerIds));
                dispatch(setCustomerTabLoaded(true));
                break;
        }
        dispatch(setLoaded(true));
    };
};

var loadWorkAssignmentPanelDataAction = exports.loadWorkAssignmentPanelDataAction = function loadWorkAssignmentPanelDataAction() {
    return function (dispatch, getState) {
        var userId = (0, _selectors.getUserId)(getState());
        var tabType = (0, _selectors.getTab)(getState());
        dispatch(setLoading(true));
        (0, _rpcCalls2.default)(GET_VIEW_USER_WORK_ASSIGNMENTS_METHOD, [userId, tabType], _utils.rpcErrorHandler).then(function (data) {
            dispatch(prepareLoadedData(data, tabType, userId));
            dispatch(setLoading(false));
        }).catch(function (err) {
            if ((0, _rpcUtils.isAborted)(err)) return;
            dispatch(commonWAPanelErrorHandler(err));

            dispatch(setLoading(false));
        });
    };
};

var revokeAllTypeAction = exports.revokeAllTypeAction = function revokeAllTypeAction() {
    return function (dispatch, getState) {
        var userId = (0, _selectors.getUserId)(getState());
        var type = (0, _selectors.getTab)(getState());
        dispatch(setLoading(true));
        (0, _rpcCalls2.default)('UserManagementService.revokeAllWorkAssignment', [userId, type], _utils.rpcErrorHandler).then(function (data) {
            dispatch(prepareLoadedData(data, type, userId));
            dispatch(setLoading(false));
            dispatch((0, _actions3.handleKeptMaAfterRemoveWaByToast)({ cptWaChangesFlags: data.cptWaChangesFlags, level: type, all: true }));
            dispatch(updateUserHasAssignedWorkScope(userId, !data.noCptAssignedToUserAtAll));
        }).catch(function (err) {
            dispatch(setLoading(false));
            dispatch(commonWAPanelErrorHandler(err));
        });
    };
};

var revokeEntitiesAction = exports.revokeEntitiesAction = function revokeEntitiesAction(revokeEntityLevel, id) {
    return function (dispatch, getState) {
        var userId = (0, _selectors.getUserId)(getState());
        var typeTab = (0, _selectors.getTab)(getState());
        dispatch(setLoading(true));
        (0, _rpcCalls2.default)('UserManagementService.revokeEntityWorkAssignment', [userId, typeTab, id, revokeEntityLevel], _utils.rpcErrorHandler).then(function (data) {
            dispatch(prepareLoadedData(data, typeTab, userId));
            dispatch(setLoading(false));
            dispatch((0, _actions3.handleKeptMaAfterRemoveWaByToast)({ cptWaChangesFlags: data.cptWaChangesFlags, level: revokeEntityLevel, all: false }));
            dispatch(updateUserHasAssignedWorkScope(userId, !data.noCptAssignedToUserAtAll));
        }).catch(function (err) {
            dispatch(setLoading(false));
            dispatch(commonWAPanelErrorHandler(err));
        });
    };
};

var updateUserHasAssignedWorkScope = function updateUserHasAssignedWorkScope(userId, hasAssignedWorkScope) {
    return function (dispatch, getState) {
        var user = (0, _selectors4.getUser)(getState(), userId);
        dispatch((0, _actions.addUser)(_extends({}, user, {
            hasAssignedWorkScope: hasAssignedWorkScope
        })));
    };
};

var openCopyContentMenu = exports.openCopyContentMenu = (0, _reduxActions.createAction)(ActionTypes.COPY_CONTENT_OPEN);

var closeCopyContentMenu = exports.closeCopyContentMenu = (0, _reduxActions.createAction)(ActionTypes.COPY_CONTENT_CLOSE);

var setShowCopy = exports.setShowCopy = (0, _reduxActions.createAction)(ActionTypes.SHOW_COPY_SET);

var setCopyUserId = exports.setCopyUserId = (0, _reduxActions.createAction)(ActionTypes.COPY_USER_ID_SET);

var setViewerHasEntireScope = exports.setViewerHasEntireScope = (0, _reduxActions.createAction)(ActionTypes.COPY_VIEWER_HAS_ENTIRE_SCOPE_SET);

var setCopyLoading = exports.setCopyLoading = (0, _reduxActions.createAction)(ActionTypes.COPY_LOADING_SET);

var setCopyAllScope = exports.setCopyAllScope = (0, _reduxActions.createAction)(ActionTypes.COPY_ALL_SCOPE_SET);

var setCopyCounters = exports.setCopyCounters = (0, _reduxActions.createAction)(ActionTypes.COPY_COUNTERS_SET);

var setCopyOption = exports.setCopyOption = (0, _reduxActions.createAction)(ActionTypes.COPY_OPTION_SET);

var setCopySelectorUsers = exports.setCopySelectorUsers = (0, _reduxActions.createAction)(ActionTypes.COPY_USER_IDS_FOR_SELECTOR_SET);

var openCopyMenu = exports.openCopyMenu = function openCopyMenu() {
    return function (dispatch) {
        dispatch(openCopyContentMenu());
        dispatch(loadUsers());
    };
};

var loadUserCounters = exports.loadUserCounters = function loadUserCounters(userId) {
    return function (dispatch, getState) {
        dispatch(setCopyLoading(true));
        (0, _rpcCalls2.default)('UserManagementService.getUserWorkAssignmentsCounters', [userId], _utils.rpcErrorHandler).then(function (data) {
            dispatch(setCopyAllScope(data.canManageAllScope && data.canUserManageAllScope));

            var copyCounters = data.cptCounters;
            if (!data.canManageAllScope && data.canUserManageAllScope) {
                copyCounters = (0, _selectors3.getViewerManagementCounters)(getState());
            }
            dispatch(setCopyCounters(copyCounters));

            dispatch(setCopyUserId(userId));
            dispatch(setCopyOption(null));
            dispatch(setCopyLoading(false));

            dispatch(setViewerHasEntireScope(data.viewerHasEntireScope));
        }).catch(function (err) {
            dispatch(setCopyLoading(false));
            dispatch(commonWAPanelErrorHandler(err));
            dispatch(closeCopyContentMenu());
        });
    };
};

var loadUsers = exports.loadUsers = function loadUsers() {
    return function (dispatch) {
        (0, _rpcCalls2.default)('UserManagementService.getUserSelectorData', []).then(function (data) {
            dispatch((0, _actions4.updateFeatures)({
                UGR: data.ugrEnabled,
                TZG: data.tzgEnabled
            }));
            dispatch((0, _actions.addTimeZoneGroups)(data.timeZoneGroups));
            dispatch((0, _actions.addUserGroups)(data.userGroups));
            dispatch(setCopySelectorUsers(data.users));
        }).catch(function (err) {
            // TODO add error handling
            console.log(err);
        });
    };
};

var copyAssignments = exports.copyAssignments = function copyAssignments() {
    return function (dispatch, getState) {
        var userTo = (0, _selectors.getUserId)(getState());
        var userFrom = (0, _selectors.getCopyUserId)(getState());
        var option = (0, _selectors.getCopySelectedOption)(getState());

        (0, _rpcCalls2.default)('UserManagementService.copyWorkAssignmentsFrom', [userTo, userFrom, option], _utils.rpcErrorHandler).then(function (data) {
            dispatch(closeCopyContentMenu());
            dispatch(setTaskTabLoaded(false));
            dispatch(setProjectTabLoaded(false));
            dispatch(setCustomerTabLoaded(false));
            dispatch((0, _actions.addUser)(data.userInfo));
        }).catch(function (error) {
            switch (error.getException()) {
                case _constants2.Exceptions.NoSuchUserException:
                    dispatch((0, _actions3.closeAllPanels)());
                    break;
                case _constants2.Exceptions.NoSuchCopyUserException:
                    alert(_messageResource2.default.getMessage('work_assignments.panel.copy.error.user_deleted'));
                    dispatch((0, _actions.removeUser)(userFrom.id));
                    SyncCallbacks.onNoSuchUserException(userFrom.id);
                    break;
                case _constants2.Exceptions.UserHasAccessToAllScopeException:
                    alert(_messageResource2.default.getMessage('work_assignment.error.copy.userTo_has_entire_scope'));
                    window.location.reload();
                    break;
                case _constants3.Exceptions.NO_RIGHTS_TO_SUBMIT_TT_EXCEPTION:
                    alert(_messageResource2.default.getMessage('work_assignment.error.copy.userTo_hast_submitTT'));
                    window.location.reload();
                    break;
                default:
                    dispatch(commonWAPanelErrorHandler(error));
                    console.error(error);
                    dispatch(closeCopyContentMenu());
            }
        });
    };
};

var openAssignAllScopeContentMenu = exports.openAssignAllScopeContentMenu = (0, _reduxActions.createAction)(ActionTypes.ASSIGN_ALL_SCOPE_CONTENT_OPEN);

var closeAssignAllScopeContentMenu = exports.closeAssignAllScopeContentMenu = (0, _reduxActions.createAction)(ActionTypes.ASSIGN_ALL_SCOPE_CONTENT_CLOSE);

var assignAllWorkAssignments = exports.assignAllWorkAssignments = function assignAllWorkAssignments() {
    return function (dispatch, getState) {
        var userTo = (0, _selectors.getUserId)(getState());

        (0, _rpcCalls2.default)('UserManagementService.assignAllWorkAssignmentsFromMyScope', [userTo], _utils.rpcErrorHandler).then(function (data) {
            dispatch(closeAssignAllScopeContentMenu());
            dispatch(setTaskTabLoaded(false));
            dispatch(setProjectTabLoaded(false));
            dispatch(setCustomerTabLoaded(false));
            dispatch((0, _actions.addUser)(data.userInfo));
        }).catch(function (err) {
            switch (err.getException()) {
                case _constants2.Exceptions.UserHasAccessToAllScopeException:
                    alert(_messageResource2.default.getMessage('work_assignment.error.copy.userTo_has_entire_scope'));
                    window.location.reload();
                    break;
                case _constants3.Exceptions.NO_RIGHTS_TO_SUBMIT_TT_EXCEPTION:
                    alert(_messageResource2.default.getMessage('work_assignment.error.copy.userTo_hast_submitTT'));
                    window.location.reload();
                    break;
                default:
                    dispatch(commonWAPanelErrorHandler(err));
                    console.error(err);
                    dispatch(closeCopyContentMenu());
            }

            return true;
        });
    };
};

var commonWAPanelErrorHandler = function commonWAPanelErrorHandler(error) {
    return function (dispatch) {
        dispatch((0, _actions3.handleCommonError)(error));

        switch (error.getException()) {
            case _constants2.Exceptions.WORK_ASSIGNMENTS_FEATURE_DISABLED_EXCEPTION:
                alert(_messageResource2.default.getMessage("common.turned_off_functionality", [_messageResource2.default.getMessage("features.WAS.title")]));
                window.location.reload();
                break;
            case _constants2.Exceptions.UserHasAccessToAllScopeException:
                alert(_messageResource2.default.getMessage('work_assignments.error.selected_user_have_entire_scope'));
                window.location.reload();
                break;
            case _constants3.Exceptions.NO_RIGHTS_TO_SUBMIT_TT_EXCEPTION:
                alert(_messageResource2.default.getMessage('work_assignments.error.selected_user_does_not_have_submit_tt'));
                window.location.reload();
                break;
        }
    };
};

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isLoadingCountries = exports.getCountries = exports.getDefaultTimeZoneCountry = exports.getLeaveBlackoutDaysForSelectedYear = exports.getLeaveBlackoutDays = exports.getCorporateDaysForSelectedYear = exports.getCorporateDays = exports.getDefaultWorkSchedule = exports.geSelectedYear = exports.isFirstLoading = exports.isEditing = exports.getEditingDays = exports.isLoading = undefined;

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _reselect = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getWorkScheduleStateCommon = function getWorkScheduleStateCommon(state) {
    return state.workSchedule;
};

var getWorkScheduleState = (0, _reselect.createSelector)(getWorkScheduleStateCommon, function (commonState) {
    return commonState.page;
});

var isLoading = exports.isLoading = (0, _reselect.createSelector)(getWorkScheduleState, function (workScheduleState) {
    return workScheduleState.loading;
});

var getEditingDays = exports.getEditingDays = (0, _reselect.createSelector)(getWorkScheduleState, function (workScheduleState) {
    return workScheduleState.editingDays;
});

var isEditing = exports.isEditing = (0, _reselect.createSelector)(getEditingDays, function (editingDays) {
    return _underscore2.default.size(editingDays) > 0;
});

var isFirstLoading = exports.isFirstLoading = (0, _reselect.createSelector)(getWorkScheduleState, function (workScheduleState) {
    return workScheduleState.firstLoading;
});

var geSelectedYear = exports.geSelectedYear = (0, _reselect.createSelector)(getWorkScheduleState, function (workScheduleState) {
    return workScheduleState.selectedYear;
});

var getDefaultWorkSchedule = exports.getDefaultWorkSchedule = (0, _reselect.createSelector)(getWorkScheduleState, function (workScheduleState) {
    return workScheduleState.defaultWorkSchedules;
});

var getCorporateDays = exports.getCorporateDays = (0, _reselect.createSelector)(getWorkScheduleState, function (workScheduleState) {
    return workScheduleState.corporateDays;
});

var getCorporateDaysForSelectedYear = exports.getCorporateDaysForSelectedYear = (0, _reselect.createSelector)(getCorporateDays, geSelectedYear, function (corporateDays, year) {
    return corporateDays[year];
});

var getLeaveBlackoutDays = exports.getLeaveBlackoutDays = (0, _reselect.createSelector)(getWorkScheduleState, function (workScheduleState) {
    return workScheduleState.leaveBlackoutDays;
});

var getLeaveBlackoutDaysForSelectedYear = exports.getLeaveBlackoutDaysForSelectedYear = (0, _reselect.createSelector)(getLeaveBlackoutDays, geSelectedYear, function (leaveBlackoutDays, year) {
    return leaveBlackoutDays[year];
});

var getDefaultTimeZoneCountry = exports.getDefaultTimeZoneCountry = (0, _reselect.createSelector)(getWorkScheduleState, function (workScheduleState) {
    return workScheduleState.defaultTimeZoneCountry;
});

var getCountries = exports.getCountries = (0, _reselect.createSelector)(getWorkScheduleState, function (workScheduleState) {
    return workScheduleState.countries;
});

var isLoadingCountries = exports.isLoadingCountries = (0, _reselect.createSelector)(getWorkScheduleState, function (workScheduleState) {
    return workScheduleState.loadingCountries;
});

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.deleteLeaveBlackoutAndAddCorporateDay = exports.deleteLeaveBlackoutDay = exports.addLeaveBlackoutDay = exports.exportSchedule = exports.loadCountries = exports.deleteCorporateDay = exports.addCorporateDay = exports.selectYear = exports.loadWorkScheduleData = exports.loadData = exports.removeLeaveBlackout = exports.addLeaveBlackout = exports.loadedDataSet = exports.removeCorporateDaysByYear = exports.removeEditingDay = exports.addEditingDay = undefined;

var _reduxActions = __webpack_require__(9);

var _utils = __webpack_require__(6);

var _actionTypes = __webpack_require__(711);

var ActionTypes = _interopRequireWildcard(_actionTypes);

var _apiCalls = __webpack_require__(567);

var api = _interopRequireWildcard(_apiCalls);

var _utils2 = __webpack_require__(85);

var _batch = __webpack_require__(117);

var _selectors = __webpack_require__(404);

var _atUtils = __webpack_require__(5);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _ClassicBridge = __webpack_require__(18);

var _ClassicBridge2 = _interopRequireDefault(_ClassicBridge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var addEditingDay = exports.addEditingDay = (0, _reduxActions.createAction)(ActionTypes.EDITING_DAYS_ADD);
var removeEditingDay = exports.removeEditingDay = (0, _reduxActions.createAction)(ActionTypes.EDITING_DAYS_REMOVE);
var removeCorporateDaysByYear = exports.removeCorporateDaysByYear = (0, _reduxActions.createAction)(ActionTypes.CORPORATE_DAYS_REMOVE_BY_YEAR);

var loadedDataSet = exports.loadedDataSet = function loadedDataSet(loadedData) {
    return function (dispatch) {
        dispatch((0, _utils.createActionObject)(ActionTypes.LOADED_DATA_SET, loadedData));
    };
};

var addLeaveBlackout = exports.addLeaveBlackout = function addLeaveBlackout(data) {
    return function (dispatch) {
        dispatch((0, _utils.createActionObject)(ActionTypes.LEAVE_BLACKOUT_DAYS_ADD, data));
    };
};

var removeLeaveBlackout = exports.removeLeaveBlackout = function removeLeaveBlackout(data) {
    return function (dispatch) {
        dispatch((0, _utils.createActionObject)(ActionTypes.LEAVE_BLACKOUT_DAYS_REMOVE, data));
    };
};

var loadData = exports.loadData = function loadData(year) {
    return function (dispatch) {
        dispatch((0, _utils.createActionObject)(ActionTypes.LOAD_DATA));
        dispatch(loadWorkScheduleData(year, function () {
            return dispatch((0, _utils.createActionObject)(ActionTypes.LOAD_DATA_SUCCESS));
        }, function () {
            return dispatch((0, _utils.createActionObject)(ActionTypes.LOAD_DATA_FAILURE));
        }));
    };
};

var loadWorkScheduleData = exports.loadWorkScheduleData = function loadWorkScheduleData(year) {
    var successCallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
    var failureCallback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};
    return function (dispatch) {
        api.getPageData(year).then((0, _batch.batched)(function (data) {
            dispatch(loadedDataSet({
                corporateDays: _defineProperty({}, year, data.corporateDays),
                leaveBlackoutDays: _defineProperty({}, year, data.blackoutDays),
                defaultWorkSchedules: (0, _utils2.convertEffectiveDateInWorkSchedule)(data.defaultWorkSchedules)
            }));
            successCallback();
        })).catch(function (_ref) {
            var error = _ref.error;

            failureCallback(error);
        });
    };
};

var selectYear = exports.selectYear = (0, _reduxActions.createAction)(ActionTypes.YEAR_SELECTED);

var addCorporateDay = exports.addCorporateDay = function addCorporateDay(date, isWorking, title) {
    return function (dispatch) {
        dispatch(addEditingDay(date));

        api.addCorporateDay(date, isWorking, title).then(function (data) {
            dispatch(setCorporateDayEditedResult(date, data));
        }).catch(function () {
            dispatch(removeEditingDay(date));
        });
    };
};

var deleteCorporateDay = exports.deleteCorporateDay = function deleteCorporateDay(date) {
    return function (dispatch) {
        dispatch(addEditingDay(date));

        api.deleteCorporateDay(date).then(function (data) {
            dispatch(setCorporateDayEditedResult(date, data));
        }).catch(function () {
            dispatch(removeEditingDay(date));
        });
    };
};

var loadCountries = exports.loadCountries = function loadCountries() {
    return function (dispatch) {
        dispatch((0, _utils.createActionObject)(ActionTypes.LOAD_COUNTRIES));
        api.getCountries().then(function (result) {
            dispatch((0, _utils.createActionObject)(ActionTypes.LOAD_COUNTRIES_SUCCESS, result));
        }).catch(function (error) {
            console.error(error);
            dispatch((0, _utils.createActionObject)(ActionTypes.LOAD_COUNTRIES_FAILURE));
        });
    };
};

var exportSchedule = exports.exportSchedule = function exportSchedule() {
    return function (dispatch, getState) {
        var year = (0, _selectors.getYear)(getState());
        api.getCorporateScheduleICalendar(year).then(function (result) {
            var fileName = _messageResource2.default.getMessage('work_schedule.header.export_holidays_file_name', [year]);
            (0, _atUtils.saveFile)(result, fileName, { type: 'text/calendar', encoding: 'UTF-8' });
        }).catch(function (error) {
            console.error(error);
        });
    };
};

var addLeaveBlackoutDay = exports.addLeaveBlackoutDay = function addLeaveBlackoutDay(date) {
    return function (dispatch) {
        dispatch(addEditingDay(date));

        _ClassicBridge2.default.addLeaveBlackoutDay(date).then(function () {
            dispatch(addLeaveBlackout(date));
        }).finally(function () {
            dispatch(removeEditingDay(date));
        });
    };
};

var deleteLeaveBlackoutDay = exports.deleteLeaveBlackoutDay = function deleteLeaveBlackoutDay(date) {
    return function (dispatch) {
        dispatch(addEditingDay(date));

        return _ClassicBridge2.default.deleteLeaveBlackoutDay(date).then(function () {
            dispatch(removeLeaveBlackout(date));
        }).finally(function () {
            dispatch(removeEditingDay(date));
        });
    };
};

var deleteLeaveBlackoutAndAddCorporateDay = exports.deleteLeaveBlackoutAndAddCorporateDay = function deleteLeaveBlackoutAndAddCorporateDay(date, isWorking, title) {
    return function (dispatch) {
        return dispatch(deleteLeaveBlackoutDay(date)).then(function () {
            return dispatch(addCorporateDay(date, isWorking, title));
        });
    };
};

var setCorporateDayEditedResult = function setCorporateDayEditedResult(editedDate, data) {
    return (0, _batch.batched)(function (dispatch) {
        dispatch(loadedDataSet({
            corporateDays: _defineProperty({}, editedDate.getFullYear(), data.corporateDays),
            defaultWorkSchedules: (0, _utils2.convertEffectiveDateInWorkSchedule)(data.defaultWorkSchedules)
        }));
        dispatch(removeEditingDay(editedDate));
    });
};

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.handleError = exports.handleExceptions = exports.copyLink = exports.getFeedUrl = exports.setEntitiesByICalResult = exports.startPageLoading = exports.deleteFeed = exports.regenerateFeedUrl = exports.changeActiveTab = exports.changeSharedSorting = exports.changeAllSorting = exports.setFeedsContentLoading = exports.setRecentlyConfiguredFeedId = exports.setSharedSorting = exports.setAllSorting = exports.setAllFeeds = exports.setSharedFeeds = exports.setLoading = exports.setActiveTab = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reduxActions = __webpack_require__(9);

var _actionTypes = __webpack_require__(953);

var ActionTypes = _interopRequireWildcard(_actionTypes);

var _constants = __webpack_require__(51);

var _constants2 = __webpack_require__(915);

var _utils = __webpack_require__(168);

var _selectors = __webpack_require__(128);

var _atBrowserUtils = __webpack_require__(8);

var _selectors2 = __webpack_require__(19);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _actions = __webpack_require__(56);

var _RpcError = __webpack_require__(281);

var _RpcError2 = _interopRequireDefault(_RpcError);

var _rpcCalls = __webpack_require__(24);

var _actions2 = __webpack_require__(29);

var _batch = __webpack_require__(117);

var _utils2 = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var setActiveTab = exports.setActiveTab = (0, _reduxActions.createAction)(ActionTypes.ACTIVE_TAB_SET);
var setLoading = exports.setLoading = (0, _reduxActions.createAction)(ActionTypes.LOADING_SET);
var setSharedFeeds = exports.setSharedFeeds = (0, _reduxActions.createAction)(ActionTypes.SHARED_FEEDS_LIST_SET);
var setAllFeeds = exports.setAllFeeds = (0, _reduxActions.createAction)(ActionTypes.ALL_FEEDS_LIST_SET);
var setAllSorting = exports.setAllSorting = (0, _reduxActions.createAction)(ActionTypes.ALL_SORTING_SET);
var setSharedSorting = exports.setSharedSorting = (0, _reduxActions.createAction)(ActionTypes.SHARED_SORTING_SET);
var setRecentlyConfiguredFeedId = exports.setRecentlyConfiguredFeedId = (0, _reduxActions.createAction)(ActionTypes.RECENTLY_CONFIGURED_FEED_ID_SET);
var setFeedsContentLoading = exports.setFeedsContentLoading = (0, _reduxActions.createAction)(ActionTypes.FEEDS_CONTENT_LOADING_SET);

var changeAllSorting = exports.changeAllSorting = function changeAllSorting(sorting) {
    return function (dispatch, getState) {
        dispatch(setAllSorting(sorting));
        (0, _utils.saveICalInfoToLocalStorage)((0, _selectors.getICalInfo)(getState()));
    };
};

var changeSharedSorting = exports.changeSharedSorting = function changeSharedSorting(sorting) {
    return function (dispatch, getState) {
        dispatch(setSharedSorting(sorting));
        (0, _utils.saveICalInfoToLocalStorage)((0, _selectors.getICalInfo)(getState()));
    };
};

var changeActiveTab = exports.changeActiveTab = function changeActiveTab(activeTab) {
    return function (dispatch, getState) {
        dispatch(setFeedsContentLoading(true));
        dispatch(setActiveTab(activeTab));
        dispatch(loadActualFeeds);
        (0, _utils.saveICalInfoToLocalStorage)((0, _selectors.getICalInfo)(getState()));
        dispatch(setFeedsContentLoading(false));
    };
};

var regenerateFeedUrl = exports.regenerateFeedUrl = function regenerateFeedUrl(id, successCallback) {
    return function (dispatch, getState) {
        dispatch((0, _utils2.createActionObject)(ActionTypes.RENGERATE_FEED_LINK_DATA_LOAD));
        (0, _rpcCalls.rpcCall)('ICalFeedSettingsService.regenerateFeedLinks', [id], handleExceptions).then(function () {
            successCallback();
            dispatch((0, _actions.toast)(_messageResource2.default.getMessage('icalendar.dialog.regenerate.success')));
            var currentFeed = (0, _selectors.getAllFeedsMap)(getState())[id];
            dispatch((0, _utils2.createActionObject)(ActionTypes.RENGERATE_FEED_LINK_DATA_LOAD_SUCCESS, _extends({}, currentFeed, {
                lastSyncDate: null
            })));
        }).catch(function (error) {
            dispatch((0, _utils2.createActionObject)(ActionTypes.RENGERATE_FEED_LINK_DATA_LOAD_FAILURE));
            dispatch(handleError(error));
        });
    };
};

var deleteFeed = exports.deleteFeed = function deleteFeed(id, successCallback) {
    return function (dispatch) {
        dispatch((0, _utils2.createActionObject)(ActionTypes.DELETE_FEED_DATA_LOAD));
        (0, _rpcCalls.rpcCall)('ICalFeedSettingsService.deleteICalFeedSettings', [id], handleExceptions).then(function () {
            successCallback();
            dispatch((0, _utils2.createActionObject)(ActionTypes.DELETE_FEED_DATA_LOAD_SUCCESS, id));
            dispatch((0, _actions.toast)(_messageResource2.default.getMessage('icalendar.dialog.delete.success')));
        }).catch(function (error) {
            dispatch((0, _utils2.createActionObject)(ActionTypes.DELETE_FEED_DATA_LOAD_FAILURE));
            dispatch(handleError(error));
        });
    };
};

var startPageLoading = exports.startPageLoading = function startPageLoading() {
    return function (dispatch, getState) {
        dispatch(setLoading(true));
        var state = getState();
        if (!(0, _selectors2.canManageAccountsAndPermissions)(state)) {
            dispatch(setActiveTab(_constants.ICalTabType.USER_FEEDS));
        } else if (!(0, _selectors.getActiveTab)(state)) {
            dispatch(setActiveTab(_constants.ICalTabType.ALL_FEEDS));
        }
        dispatch(loadActualFeeds);
    };
};

var loadActualFeeds = function loadActualFeeds(dispatch, getState) {
    if ((0, _selectors.getActiveTab)(getState()) === _constants.ICalTabType.ALL_FEEDS) {
        dispatch(loadAllFeeds);
    } else {
        dispatch(loadSharedFeeds);
    }
};

var setFeedSettingsData = function setFeedSettingsData(result, setActualFeeds) {
    return (0, _batch.batched)(function (dispatch) {
        dispatch(setEntitiesByICalResult(result.entitiesInfo));
        dispatch(setActualFeeds(result.feedSettings));
    });
};

var setEntitiesByICalResult = exports.setEntitiesByICalResult = function setEntitiesByICalResult(_ref) {
    var _ref$leaveTypes = _ref.leaveTypes,
        leaveTypes = _ref$leaveTypes === undefined ? [] : _ref$leaveTypes,
        _ref$users = _ref.users,
        users = _ref$users === undefined ? [] : _ref$users,
        _ref$userGroups = _ref.userGroups,
        userGroups = _ref$userGroups === undefined ? [] : _ref$userGroups,
        _ref$timeZoneGroups = _ref.timeZoneGroups,
        timeZoneGroups = _ref$timeZoneGroups === undefined ? [] : _ref$timeZoneGroups;
    return (0, _batch.batched)(function (dispatch) {
        dispatch((0, _actions2.setLeaveTypesList)(leaveTypes));
        dispatch((0, _actions2.setUsersList)(users));
        dispatch((0, _actions2.setUserGroupsList)(userGroups));
        dispatch((0, _actions2.setTimeZoneGroupsList)(timeZoneGroups));
    });
};

var loadSharedFeeds = function loadSharedFeeds(dispatch) {
    (0, _rpcCalls.rpcCall)('ICalFeedSettingsService.getSharedWithMeFeedSettingsInfo', [], handleExceptions).then(function (result) {
        dispatch(setFeedSettingsData(result, setSharedFeeds));
        dispatch(setLoading(false));
    }).catch(function (error) {
        dispatch(setLoading(false));
        dispatch(handleError(error));
    });
};

var loadAllFeeds = function loadAllFeeds(dispatch) {
    (0, _rpcCalls.rpcCall)('ICalFeedSettingsService.getAllFeedSettingsInfo', [], handleExceptions).then(function (result) {
        dispatch(setFeedSettingsData(result, setAllFeeds));
        dispatch(setLoading(false));
    }).catch(function (error) {
        dispatch(setLoading(false));
        dispatch(handleError(error));
    });
};

var getFeedUrl = exports.getFeedUrl = function getFeedUrl(id) {
    var onSuccessCb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (url) {};
    var onFailureCb = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};
    return function (dispatch) {
        (0, _rpcCalls.rpcCall)('ICalFeedSettingsService.getFeedAccessURL', [id], handleExceptions).then(function (result) {
            onSuccessCb(result);
        }).catch(function (error) {
            onFailureCb();
            dispatch(handleError(error));
        });
    };
};

var copyLink = exports.copyLink = function copyLink(link) {
    return function (dispatch) {
        (0, _atBrowserUtils.copyToClipboard)(link);
        dispatch((0, _actions.toast)(_messageResource2.default.getMessage('icalendar.dialog.copy.success')));
    };
};

var handleExceptions = exports.handleExceptions = function handleExceptions(rpcError) {
    rpcError.handleOnException(_constants.NO_RIGHT_FOR_RPC_EXCEPTION);
    rpcError.handleOnException(_constants.NO_SUCH_ICAL_FEED_SETTINGS_EXCEPTION);
    rpcError.handleOnException(_constants2.Exceptions.EMPTY_COMPONENTS_EXCEPTION);
};

var handleError = exports.handleError = function handleError(error) {
    return function (dispatch) {
        if (error instanceof _RpcError2.default) {
            switch (error.getException()) {
                case _constants.NO_RIGHT_FOR_RPC_EXCEPTION:
                    alert(_messageResource2.default.getMessage('common.concurrent.exception.alert'));
                    window.location.reload();
                    return;
                case _constants.NO_SUCH_ICAL_FEED_SETTINGS_EXCEPTION:
                    alert(_messageResource2.default.getMessage('common.concurrent.exception.alert'));
                    window.location.reload();
                    return;
                case _constants2.Exceptions.EMPTY_COMPONENTS_EXCEPTION:
                    alert(_messageResource2.default.getMessage('icalendar.pagee.lightbox.export.no_leaves'));
                    return;
            }
        }
        console.error(error);
    };
};

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = BaseHTMLColumnStrategy;

var _HTMLColumnsStrategy = __webpack_require__(270);

var _HTMLColumnsStrategy2 = _interopRequireDefault(_HTMLColumnsStrategy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function BaseHTMLColumnStrategy() {} // interface for column strategies


BaseHTMLColumnStrategy.prototype = new _HTMLColumnsStrategy2.default();

BaseHTMLColumnStrategy.prototype.init = function (timeformat) {
    _HTMLColumnsStrategy2.default.prototype.init.call(this, timeformat);

    return this;
};

BaseHTMLColumnStrategy.prototype.getLevelsNumber = function () {
    // abstract
};

BaseHTMLColumnStrategy.prototype.addFirstHeaderRowCells = function (row, levelsNumber) {
    // abstract
};

BaseHTMLColumnStrategy.prototype.addSecondHeaderRowCells = function (row, levelsNumber) {
    // abstract
};

BaseHTMLColumnStrategy.prototype.addColumnValueCells = function (row) {
    // abstract
};

/***/ }),
/* 216 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(46).f;
var has = __webpack_require__(75);
var TAG = __webpack_require__(41)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(35);
var dP = __webpack_require__(46);
var DESCRIPTORS = __webpack_require__(47);
var SPECIES = __webpack_require__(41)('species');

module.exports = function (KEY) {
  var C = global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__(74);
module.exports = function (target, src, safe) {
  for (var key in src) redefine(target, key, src[key], safe);
  return target;
};


/***/ }),
/* 220 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(31);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getStore = exports.initStore = undefined;

var _redux = __webpack_require__(7);

var _reduxThunk = __webpack_require__(1182);

var _reduxThunk2 = _interopRequireDefault(_reduxThunk);

var _reducer = __webpack_require__(1183);

var _reducer2 = _interopRequireDefault(_reducer);

var _batch = __webpack_require__(117);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var store = void 0;
var initStore = exports.initStore = function initStore(initAppData) {
    var createReducer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _reducer2.default;

    var _compose = _redux.compose;
    if (false) {
        if (window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) {
            _compose = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;
        }
    }

    store = (0, _redux.createStore)((0, _batch.batchReducerWrapper)(createReducer(initAppData)), _compose((0, _redux.applyMiddleware)(_reduxThunk2.default, _batch.batchMiddleware)));
};

/**
 * Get instance of redux store
 * @returns {*}
 */
var getStore = exports.getStore = function getStore() {
    return store;
};

/***/ }),
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getPrototype_js__ = __webpack_require__(1175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__(224);




/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["a" /* default */])(value) || Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) != objectTag) {
    return false;
  }
  var proto = Object(__WEBPACK_IMPORTED_MODULE_1__getPrototype_js__["a" /* default */])(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

/* harmony default export */ __webpack_exports__["a"] = (isPlainObject);


/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/* harmony default export */ __webpack_exports__["a"] = (isObjectLike);


/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObject_js__ = __webpack_require__(444);



/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_1__isObject_js__["a" /* default */])(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

/* harmony default export */ __webpack_exports__["a"] = (isFunction);


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var DemoDataStageType = exports.DemoDataStageType = {
    IDLE: 'idle',
    ACTIVE: 'active',
    COMPLETED: 'completed',
    ERROR: 'error'
};

var WelcomeScreenFrameId = exports.WelcomeScreenFrameId = 'welcomeScreenFrame';

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _PasswordSettings = __webpack_require__(279);

var _PasswordValidators = __webpack_require__(1294);

var _PasswordValidators2 = _interopRequireDefault(_PasswordValidators);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Knows how to render password settings tips and error messages
 */
var PasswordPolicyManager = {
    getErrorMessage: function getErrorMessage(_ref) {
        var _ref$settings = _ref.settings,
            settings = _ref$settings === undefined ? (0, _PasswordSettings.getPasswordSettings)() : _ref$settings,
            _ref$violatedRules = _ref.violatedRules,
            violatedRules = _ref$violatedRules === undefined ? [] : _ref$violatedRules;

        var violatedRulesSet = new Set(violatedRules);
        var messages = [];
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            for (var _iterator = this.validators[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var validator = _step.value;

                validator.addMessage(messages, violatedRulesSet, settings);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }

        return messages[0];
    },


    validators: _PasswordValidators2.default,

    getSingleTipFor: function getSingleTipFor(id) {
        var settings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, _PasswordSettings.getPasswordSettings)();

        return this.getPasswordTips((0, _PasswordSettings.forOnlyId)(settings, id))[0];
    },
    getPasswordTips: function getPasswordTips() {
        var settings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _PasswordSettings.getPasswordSettings)();

        var tips = [];
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
            for (var _iterator2 = this.validators[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var validator = _step2.value;

                validator.addTips(tips, settings);
            }
        } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                    _iterator2.return();
                }
            } finally {
                if (_didIteratorError2) {
                    throw _iteratorError2;
                }
            }
        }

        return tips;
    },
    hasPasswordRequirements: function hasPasswordRequirements() {
        return true;
    },
    hasSpecialCharacter: function hasSpecialCharacter() {
        return (0, _PasswordSettings.getPasswordSettings)().ruleIds.includes(_PasswordSettings.PasswordValidatorId.SPECIAL_VALIDATOR);
    }
};

exports.default = PasswordPolicyManager;

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.AuditHistoryView = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _AuditHistoryMenu = __webpack_require__(1298);

var _AuditHistoryMenu2 = _interopRequireDefault(_AuditHistoryMenu);

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _AuditInfoRecord = __webpack_require__(1302);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AuditHistoryView = exports.AuditHistoryView = function (_TemplateView) {
    _inherits(AuditHistoryView, _TemplateView);

    function AuditHistoryView(_ref) {
        var _ref$extraClass = _ref.extraClass,
            extraClass = _ref$extraClass === undefined ? "" : _ref$extraClass,
            _ref$loadAuditRecords = _ref.loadAuditRecordsCb,
            loadAuditRecordsCb = _ref$loadAuditRecords === undefined ? function () {} : _ref$loadAuditRecords,
            _ref$onHistoryClickCb = _ref.onHistoryClickCb,
            onHistoryClickCb = _ref$onHistoryClickCb === undefined ? function () {} : _ref$onHistoryClickCb;

        _classCallCheck(this, AuditHistoryView);

        var _this = _possibleConstructorReturn(this, (AuditHistoryView.__proto__ || Object.getPrototypeOf(AuditHistoryView)).call(this));

        _this.lastUpdateAuditAction = null;
        _this.createAuditAction = null;
        _this.extraClass = extraClass;
        _this.callbacks = {
            loadAuditRecordsCb: loadAuditRecordsCb,
            onHistoryClickCb: onHistoryClickCb
        };

        _this.state = {
            allAuditHistoryLoaded: false
        };

        _this.onStatePropertyChanged('allAuditHistoryLoaded', function (allAuditHistoryLoaded) {
            _this.auditHistoryMenu.setState({ allAuditHistoryLoaded: allAuditHistoryLoaded });
        });

        return _this;
    }

    _createClass(AuditHistoryView, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return "<div class='auditHistory'>" + " <div class='createRecord auditRecord'/>" + " <div class='updateRecord auditRecord'/>" + " <div class='viewMore'><%=viewLabel%></div>" + "</div>";
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            var _this2 = this;

            this.$createRecord = this.find('.createRecord');
            this.$updateRecord = this.find('.updateRecord');
            this.$viewMore = this.find('.viewMore');

            this.auditHistoryMenu = new _AuditHistoryMenu2.default((0, _jquery2.default)('body'), this.extraClass, this.callbacks.onHistoryClickCb).init();
            this.$viewMore.click(function () {
                _this2.trigger(AuditHistoryView.LoadAuditRecrodsEvent, { offset: 0 });
                _this2.callbacks.loadAuditRecordsCb(AuditHistoryView.RECORD_LIMIT, 0);
                _this2.auditHistoryMenu.showAt(_this2.$viewMore, { right: 0 });
            });
            this.auditHistoryMenu.scrollView.on("scrollToEnd", function () {
                _this2.trigger(AuditHistoryView.LoadAuditRecrodsEvent, { offset: _this2.getRecords().length });
                _this2.callbacks.loadAuditRecordsCb(AuditHistoryView.RECORD_LIMIT, _this2.getRecords().length);
            });
        }
    }, {
        key: 'setDateFormat',
        value: function setDateFormat(dateFormat) {
            this.auditHistoryMenu.setDateFormat(dateFormat);
        }
    }, {
        key: 'update',
        value: function update() {
            this.$createRecord.empty();
            this.$updateRecord.empty();
            if (this.createAuditAction) new _AuditInfoRecord.AuditInfoRecord(this.createAuditAction).init(this.$createRecord);
            var hasUpdateHistory = !_underscore2.default.isNull(this.lastUpdateAuditAction);
            if (hasUpdateHistory) new _AuditInfoRecord.AuditInfoRecord(this.lastUpdateAuditAction).init(this.$updateRecord);
            this.$updateRecord.toggle(hasUpdateHistory);
            this.$viewMore.toggle(hasUpdateHistory);
        }
    }, {
        key: 'messageKeys',
        value: function messageKeys() {
            return { viewLabel: "audit.audit_history.view_more" };
        }
    }, {
        key: 'addRecords',
        value: function addRecords(auditRecords, dependencies) {
            this.auditHistoryMenu.addItems(auditRecords, dependencies);
        }
    }, {
        key: 'setRecords',
        value: function setRecords(auditRecords) {
            this.auditHistoryMenu.setItems(auditRecords);
        }
    }, {
        key: 'getRecords',
        value: function getRecords() {
            return this.auditHistoryMenu.getItems();
        }
    }, {
        key: 'setAuditActions',
        value: function setAuditActions(createAudit, lastUpdateAudit, auditRecords) {
            this.createAuditAction = createAudit;
            this.lastUpdateAuditAction = lastUpdateAudit;
            this.auditHistoryMenu.setItems(auditRecords);
            this.update();
            this.show();
        }
    }, {
        key: 'setLastAuditAction',
        value: function setLastAuditAction(lastUpdateAudit) {
            this.lastUpdateAuditAction = lastUpdateAudit;
            this.update();
            this.show();
        }
    }]);

    return AuditHistoryView;
}(_TemplateView3.default);

AuditHistoryView.LoadAuditRecrodsEvent = "loadAuditRecords";
AuditHistoryView.RECORD_LIMIT = 5;

exports.default = AuditHistoryView;

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var GC = window.__GENERATED_CONSTANTS__;

var AuditActionTypes = exports.AuditActionTypes = GC.AuditActionTypes;
var AuditEntityTypes = exports.AuditEntityTypes = GC.AuditEntityTypes;

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.BalanceFormatter = BalanceFormatter;
exports.SickFormatter = SickFormatter;
exports.PTOFormatter = PTOFormatter;

var _number_formatter = __webpack_require__(61);

var _number_formatter2 = _interopRequireDefault(_number_formatter);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function BalanceFormatter() {
    this.constructor = BalanceFormatter;
}

/**
 * @param hoursPerDay
 * @param [roundToWholeNumberIfNeeded]
 * @param [isShowInHours]
 * @return {*}
 */
BalanceFormatter.prototype.init = function (hoursPerDay, isShowInHours, roundToWholeNumberIfNeeded) {
    this._hoursPerDay = hoursPerDay;
    this._decimalSeparator = window.SystemSettings.decimalSeparator;
    this._showBalanceInHours = isShowInHours;

    var roundToWholeNumber = !!roundToWholeNumberIfNeeded;
    this._daysFormatter = new _number_formatter2.default(this._decimalSeparator, window.SystemSettings.digitGroupingSymbol, roundToWholeNumber ? 0 : 2, true, '', 'd', 'N/A');
    this._hoursFormatter = new _number_formatter2.default(this._decimalSeparator, window.SystemSettings.digitGroupingSymbol, roundToWholeNumber ? 0 : 2, true, '', 'h', 'N/A');

    return this;
};

BalanceFormatter.prototype._recalculateFromDaysToHours = function (value) {
    return _underscore2.default.isNull(value) ? null : value * this._hoursPerDay;
};

BalanceFormatter.prototype.format = function (value, reverted) {
    var showInHours = reverted ? !this._showBalanceInHours : this._showBalanceInHours;
    if (showInHours) return this._hoursFormatter.format(this._recalculateFromDaysToHours(value));else return this._daysFormatter.format(value);
};

BalanceFormatter.prototype.isShowInHours = function () {
    return this._showBalanceInHours;
};

BalanceFormatter.prototype.setShowInHours = function (showInHours) {
    this._showBalanceInHours = showInHours;
};

BalanceFormatter.prototype.isNegativePTO = function (value, reverted) {
    var showInHours = reverted ? !this._showBalanceInHours : this._showBalanceInHours;
    if (showInHours) return this._hoursFormatter.isNegativeValue(this._recalculateFromDaysToHours(value));
    return this._daysFormatter.isNegativeValue(value);
};

//Sick Formatter
function SickFormatter() {}

SickFormatter.prototype = _underscore2.default.create(BalanceFormatter.prototype, {
    init: function init(hoursPerDay, roundToWholeNumberIfNeeded) {
        BalanceFormatter.prototype.init.call(this, hoursPerDay, window.SystemSettings.showSickInHours, roundToWholeNumberIfNeeded);
        return this;
    }
});

//PTO Formatter
function PTOFormatter() {}

PTOFormatter.prototype = _underscore2.default.create(BalanceFormatter.prototype, {
    init: function init(hoursPerDay, roundToWholeNumberIfNeeded) {
        BalanceFormatter.prototype.init.call(this, hoursPerDay, window.SystemSettings.showPTOInHours, roundToWholeNumberIfNeeded);
        return this;
    }
});

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = SelectorPanelWithApplyButtonHelper;

var _at_gradient_button = __webpack_require__(285);

var _at_gradient_button2 = _interopRequireDefault(_at_gradient_button);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function SelectorPanelWithApplyButtonHelper() {}

/**
 * Creates an object which add Apply button to a selector panel. Panel must be a subclass of AT.GenericSelectorPanel.
 * @param currentClass - a name of a class to extend
 * @returns object
 */
SelectorPanelWithApplyButtonHelper.getApplyButtonExtension = function (currentClass) {
    return {
        closeButtonLabelKey: "common.apply",
        cancelButtonLabelKey: "common.cancel",
        resetOnHide: true,

        createFooterButtons: function createFooterButtons() {
            currentClass.superclass.createFooterButtons.call(this);

            this.cancelButton = new _at_gradient_button2.default({
                text: _messageResource2.default.getMessage(this.cancelButtonLabelKey),
                minWidth: 60,
                cls: "greyButton close-button cancel-button"
            });
        },

        getFooterSection: function getFooterSection() {
            var res = currentClass.superclass.getFooterSection.call(this);
            return [this.cancelButton].concat(res);
        }
    };
};

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Ext = __webpack_require__(12);

var _Ext2 = _interopRequireDefault(_Ext);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _at_dropdown_button = __webpack_require__(469);

var _at_dropdown_button2 = _interopRequireDefault(_at_dropdown_button);

var _atBrowserUtils = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Drop-down button intended for use with hierarchy selector panels.
 * Creates single instance of the menu for each type of the selector
 * and the reuses it
 *
 * almost duplicates {@link AT.SelectorDropdownButton}
 * Depends on:
 * <code>/js/controls/at_dropdown_button.js</code>
 *
 * @cfg {AT.SelectorPanel} selectorPanel hierarchy selector panel to be displayed in dropdown (required).
 * @constructor
 */
var HierarchySelectorDropdownButton = _Ext2.default.extend(_at_dropdown_button2.default, {

    /**
     * @cfg {Number} specifies selector panel height. Is used to adjust menu align properly whether it is drop UP or DOWN
     */
    selectorPanelHeight: 350,
    selectorPanel: null,

    /**
     * @cfg {AT.SharedUserButtonMenu} menu specifies menu with hierarchy selector for the button
     */
    menu: null,
    labelCls: "ellipsis",
    cls: "dropdown-button at-selector-button",
    errorCls: "error",
    disabledCls: "disabledButton",
    plainTextCls: "plainCpText",

    dropDownMenuAnchor: "td.bottom-left-cell",
    dropUpMenuAnchor: "td.top-left-cell",

    innerTooltipsEnabled: false,
    getInnerTooltipTextCallback: null,

    enabled: true,
    plainTextMode: false,

    permitToShowCallback: function permitToShowCallback() {
        return true;
    },

    constructor: function constructor(config) {
        if (config.additionalCls) {
            this.cls += " " + config.additionalCls;
        }
        this.selectorPanel = config.menu.getSelectorPanel();
        HierarchySelectorDropdownButton.superclass.constructor.call(this, config);
    },

    setEnabled: function setEnabled(enabled) {
        this.enabled = enabled;
        if (enabled) {
            this.removeClass(this.disabledCls);
        } else {
            this.addClass(this.disabledCls);
        }
    },

    getEnabled: function getEnabled() {
        return this.enabled;
    },

    setPlainTextMode: function setPlainTextMode(plainTextMode) {
        this.plainTextMode = plainTextMode;
        if (plainTextMode) {
            this.addClass(this.plainTextCls);
        } else {
            this.removeClass(this.plainTextCls);
        }
    },

    initComponent: function initComponent() {
        HierarchySelectorDropdownButton.superclass.initComponent.call(this);

        this.selectorPanel.on("change", this.menu.makeHandlerForSpecificParent(this, this.updateButton), this);

        _Ext2.default.EventManager.on(window, "resize", this.menu.hide, this.menu);

        this.menu.setCurrentParent(this, true);

        this.onMenuShow = this.menu.makeHandlerForSpecificParent(this, this.onMenuShow);
        this.onMenuHide = this.menu.makeHandlerForSpecificParent(this, this.onMenuHide);
    },

    afterRender: function afterRender() {
        HierarchySelectorDropdownButton.superclass.afterRender.call(this);
        this.el.child("span:first").addClass(this.labelCls);
    },

    /**
     * Updates text label on the button.
     * @private
     */
    updateButton: function updateButton() {
        this.setText(this.selectorPanel.getLabelText(this.id));
        this.setDisplayInputError(false);
        this.setInnerTooltipsEnabled(this.selectorPanel.isInnerTooltipsEnabled());
        this.setTooltipEnabled(!this.innerTooltipsEnabled && this.selectorPanel.isTooltipEnabled());
        //we don't need inner tooltips of DropdownControl, now we need own inner tooltips of this button
        this.clearGetInnerTooltipCallback();
    },

    setInnerTooltipsEnabled: function setInnerTooltipsEnabled(enabled) {
        this.innerTooltipsEnabled = enabled;
    },

    showTooltipEnabled: function showTooltipEnabled() {
        return this.tooltipObject && this.tooltipEnabled && !this.innerTooltipsEnabled;
    },

    showInnerTooltip: function showInnerTooltip(element, isForTopLevelEntity) {
        if (this.tooltipObject && this.innerTooltipsEnabled) {
            var text = this.getInnerTooltipTextCallback ? this.getInnerTooltipTextCallback(isForTopLevelEntity) : this.selectorPanel.getPartialTooltipText(isForTopLevelEntity);
            this.doShowTooltip(text, element);
        }
    },

    /**
     * Replaces get inner tooltips text from selector panel to get it from passed callback(intended for DropdownControl)
     * @param callback function returns text inner tooltip for users and groups
     */
    setGetInnerTooltipCallback: function setGetInnerTooltipCallback(callback) {
        this.getInnerTooltipTextCallback = callback;
    },

    clearGetInnerTooltipCallback: function clearGetInnerTooltipCallback() {
        this.getInnerTooltipTextCallback = null;
    },

    setPermitToShowCallback: function setPermitToShowCallback(callback) {
        this.permitToShowCallback = callback;
    },

    showMenu: function showMenu() {
        if (this.enabled && !this.plainTextMode && this.permitToShowCallback()) {
            var dropDownAnchor = this.el.child(this.dropDownMenuAnchor);
            var dropUpAnchor = this.el.child(this.dropUpMenuAnchor);
            var yShift = dropDownAnchor.getTop() - dropUpAnchor.getTop();
            var enoughTopSpace = dropUpAnchor.getTop() - this.selectorPanelHeight > 0;
            this.menuAnchor = enoughTopSpace ? this.dropDownMenuAnchor : this.dropUpMenuAnchor;

            this.menu.setCurrentParent(this);

            HierarchySelectorDropdownButton.superclass.showMenu.call(this);

            var element = this.menu.el;
            var topLeft = element.getXY();

            if (this.menuAnchor == this.dropUpMenuAnchor && element.getBottom() > dropDownAnchor.getBottom()) topLeft[1] += yShift;
            if (this.menuAnchor == this.dropDownMenuAnchor && element.getTop() < dropUpAnchor.getTop()) topLeft[1] -= yShift;

            var customShifty = (0, _jquery2.default)(this.container.dom).attr("dropdown-menu-shift-y");
            if (customShifty) topLeft[1] += parseInt(customShifty);

            element.setXY(topLeft);
            (0, _atBrowserUtils.scrollWindowIfNeeded)(element.dom);
        }
    }

});

_Ext2.default.reg("at_hierarchy_selector_dropdown_button", HierarchySelectorDropdownButton);

exports.default = HierarchySelectorDropdownButton;

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Ext = __webpack_require__(12);

var _Ext2 = _interopRequireDefault(_Ext);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _AncestorEventsMixins = __webpack_require__(234);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * An abstract button with dropdown menu, based on the Ext.Button.
 * The class specifies handles for ESC and ENTER keys press events
 *
 *
 * Methods:
 *  onEnterKeyDown - method to be called when ENTER key press event occurs
 *  onEscKeyDown - method to be called when ENTER key press event occurs
 *
 * Required files:
 *  ExtJS library
 *  util.js
 */
var AbstractDropdownButton = _Ext2.default.extend(_Ext2.default.Button, {

    scrollHandler: function scrollHandler() {},

    onMenuHide: function onMenuHide(menu) {
        AbstractDropdownButton.superclass.onMenuHide.call(this, menu);
        this.restoreWindowKeyDownHandler();
        (0, _jquery2.default)(window).off("resize.dropdownButton", this.resizeHandler);
        if (this.scrollableContainer) {
            (0, _jquery2.default)(this.scrollableContainer).off("scroll", this.scrollHandler);
        }

        this.triggerDOMEvent("dropdown.menuHide");
    },

    onMenuShow: function onMenuShow(menu) {
        AbstractDropdownButton.superclass.onMenuShow.call(this, menu);
        this.setWindowKeyDownHandler();

        var self = this;

        // timeout is needed for fix bug #45198
        setTimeout(function () {
            (0, _jquery2.default)(window).off("resize.dropdownButton", self.resizeHandler);
            self.resizeHandler = function () {
                self.hideMenuOnScrollOrResize();
            };
            (0, _jquery2.default)(window).on("resize.dropdownButton", self.resizeHandler);

            if (self.scrollableContainer) {
                (0, _jquery2.default)(self.scrollableContainer).off("scroll", self.scrollHandler);
                self.scrollHandler = function () {
                    self.hideMenuOnScrollOrResize();
                };
                (0, _jquery2.default)(self.scrollableContainer).on("scroll", self.scrollHandler);
            }
        }, 100);

        this.triggerDOMEvent("dropdown.menuShow");
    },

    afterRender: function afterRender() {
        var self = this;
        var $el = (0, _jquery2.default)(this.el.dom);
        this.initDescendantEventsEmitter($el);
        this.initAncestorEventsListener($el, {
            "popup.hide": function popupHide() {
                self.hideMenu();
                self.disable();
            }
        });
    },

    hideMenuOnScrollOrResize: function hideMenuOnScrollOrResize() {
        this.hideMenu();
    },

    setWindowKeyDownHandler: function setWindowKeyDownHandler() {
        var thisButton = this;
        if (!this.escKeyMap) this.escKeyMap = new _Ext2.default.KeyMap(_Ext2.default.getBody().parent(), {
            key: _Ext2.default.EventObject.ESC,
            fn: function fn(key, ev) {
                thisButton.onEscKeyDown();
            },
            scope: thisButton,
            stopEvent: true
        });
        if (!this.enterKeyMap) this.enterKeyMap = new _Ext2.default.KeyMap(_Ext2.default.getBody().parent(), {
            key: _Ext2.default.EventObject.ENTER,
            fn: function fn(key, ev) {
                thisButton.onEnterKeyDown();
            },
            scope: thisButton,
            stopEvent: true
        });
        this.escKeyMap.enable();
        this.enterKeyMap.enable();
    },

    restoreWindowKeyDownHandler: function restoreWindowKeyDownHandler() {
        if (this.escKeyMap) {
            this.escKeyMap.disable();
        }
        if (this.enterKeyMap) {
            this.enterKeyMap.disable();
        }
    },

    /**
     *  The method is called if ENTER key is pressed when button's menu is being shown and
     */
    onEnterKeyDown: function onEnterKeyDown() {
        return false;
    },

    /**
     *  The method is called if ESC key is pressed when button's menu is being shown and
     */
    onEscKeyDown: function onEscKeyDown() {
        this.hideMenu();
    }

});
// register xtype
_Ext2.default.reg('abstract_dropdown_button', AbstractDropdownButton);

/**
 * Registers potential parent element for dropdown buttons. Should be called once parent element is shown.
 * @param $parentEl Parent element.
 */
AbstractDropdownButton.handleParentShow = function ($parentEl) {
    $parentEl.addClass("atDropdownButtonsParent");
    $parentEl[0].atDropdownButtonsParent = {
        buttons: [],
        hidden: false
    };
};

/**
 * Should be called once parent element is hidden.
 * @param $parentEl Parent element.
 */
AbstractDropdownButton.handleParentHide = function ($parentEl) {
    $parentEl[0].atDropdownButtonsParent.hidden = true;
    _underscore2.default.each($parentEl[0].atDropdownButtonsParent.buttons, function (button) {
        button.hideMenu();
    });
};

_underscore2.default.extend(AbstractDropdownButton.prototype, _AncestorEventsMixins.AncestorEventsListenerMixin, _AncestorEventsMixins.DescendantEventsEmitterMixin);

exports.default = AbstractDropdownButton;

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DescendantEventsEmitterMixin = exports.DescendantEventsListenerMixin = exports.AncestorEventsEmitterMixin = exports.AncestorEventsListenerMixin = undefined;

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DOMEventsListenerMixin = {
    /**
     * Starts listening to DOM events.
     * @param $el DOM element of the component.
     * @param handlers Object containing functions-handlers as properties.
     */
    _initDOMEventsListener: function _initDOMEventsListener($el, handlers, className, findEmittersFunction) {
        this._domEventHandlers = handlers;

        // Link DOM element and event listener component
        $el[0].domEventsListener = this;
        // Add class for DOM search later
        $el.addClass(className);

        // Try to find existing emitters in DOM and subscribe to them (works in case the emitter was initialized before listener)
        _underscore2.default.each(findEmittersFunction($el), function (emitterEl) {
            emitterEl.domEventsEmitter._addDOMEventsListener(this);
        }, this);
    },

    /**
     * Calls event handler of specified name (if found).
     * @param eventName Event name.
     */
    _handleDOMEvent: function _handleDOMEvent(eventName) {
        if (this._domEventHandlers && this._domEventHandlers[eventName]) this._domEventHandlers[eventName]();
    }
};

var DOMEventsEmitterMixin = {
    /**
     * Fires event with specified name.
     * @param eventName Event name.
     */
    triggerDOMEvent: function triggerDOMEvent(eventName) {
        _underscore2.default.each(this._domEventsListeners, function (listener) {
            listener._handleDOMEvent(eventName);
        });
    },

    /**
     * Initializes DOM events emitter.
     * @param $el DOM element of the component.
     */
    _initDOMEventsEmitter: function _initDOMEventsEmitter($el, className, findListenersFunction) {
        // Link DOM element and event emitter component
        $el[0].domEventsEmitter = this;
        // Add class for DOM search later
        $el.addClass(className);

        // Try to find event listeners in DOM subscribe them to self (works in case any listeners were initialized before the emitter)
        _underscore2.default.each(findListenersFunction($el), function (listenerEl) {
            this._addDOMEventsListener(listenerEl.domEventsListener);
        }, this);
    },

    /**
     * Subscribes specified listener to the emitter.
     * @param listener Listener object.
     */
    _addDOMEventsListener: function _addDOMEventsListener(listener) {
        if (!this._domEventsListeners) this._domEventsListeners = [];

        // Make sure listeners can't be subscribed many times
        if (!_underscore2.default.contains(this._domEventsListeners, listener)) this._domEventsListeners.push(listener);
    }
};

/**
 * Gives component an ability to listen to ancestor events - custom-defined events fired from ancestor DOM element.
 */
var AncestorEventsListenerMixin = exports.AncestorEventsListenerMixin = _underscore2.default.extend({
    initAncestorEventsListener: function initAncestorEventsListener($el, handlers) {
        this._initDOMEventsListener($el, handlers, "ancestorEventsListener", function ($el) {
            return $el.parents(".ancestorEventsEmitter");
        });
    }
}, DOMEventsListenerMixin);

/**
 * Gives component an ability to emit ancestor event, which components related to descendant DOM elements may listen to.
 */
var AncestorEventsEmitterMixin = exports.AncestorEventsEmitterMixin = _underscore2.default.extend({
    initAncestorEventsEmitter: function initAncestorEventsEmitter($el) {
        this._initDOMEventsEmitter($el, "ancestorEventsEmitter", function ($el) {
            return $el.find(".ancestorEventsListener");
        });
    }
}, DOMEventsEmitterMixin);

/**
 * Gives component an ability to listen to descendant events - custom-defined events fired from descendant DOM element.
 */
var DescendantEventsListenerMixin = exports.DescendantEventsListenerMixin = _underscore2.default.extend({
    initDescendantEventsListener: function initDescendantEventsListener($el, handlers) {
        this._initDOMEventsListener($el, handlers, "descendantEventsListener", function ($el) {
            return $el.find(".descendantEventsEmitter");
        });
    }
}, DOMEventsListenerMixin);

/**
 * Gives component an ability to emit descendant event, which components related to parent DOM may listen to.
 */
var DescendantEventsEmitterMixin = exports.DescendantEventsEmitterMixin = _underscore2.default.extend({
    initDescendantEventsEmitter: function initDescendantEventsEmitter($el) {
        this._initDOMEventsEmitter($el, "descendantEventsEmitter", function ($el) {
            return $el.parents(".descendantEventsListener");
        });
    }
}, DOMEventsEmitterMixin);

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = RpcControlManager;
// NOTE: it is recommended to use jquery_rpc.js instead, because it's much simpler to use.

/*
 * Base manager class for all page control updating data via rpc.
 */
function RpcControlManager() {}

RpcControlManager.timeout = 10000;
RpcControlManager.currentRpcControlManager = undefined;
RpcControlManager.retryController = undefined;

/*
 * General prefix for message names shown by manager.
 */
RpcControlManager.prototype.messagePrefix = "";

/**
 * ID of the request made by <code>makeRemoteCall</code> method or <code>null</code> if no request has been made
 */
RpcControlManager.prototype.requestId = null;

/*
 * Set initial manager state if needed.
 */
RpcControlManager.prototype.init = function () {
    /* note: inheritor should override this method */
};

/*
 * Call remote service to change control data.
 *
 * @return Request ID
 */
RpcControlManager.prototype.makeRemoteCall = function (callback) {
    /* note: inheritor should override this method */
};

/*
 * Get remote service used for state changing.
 */
RpcControlManager.prototype.getService = function () {
    /* note: inheritor should override this method */
};

/**
 * Get list of service methods used by this manager as array of strings
 */
RpcControlManager.prototype.getMethods = function () {
    /* note: inheritor should override this method */
};

/*
 * Return message text, which will be shown to user when remote call timeout exceeded.
 */
RpcControlManager.prototype.getTimeoutMsg = function () {
    /* note: inheritor should override this method */
};

/*
 * Handle specific errors.
 * Return true if error was handled, othervise false.
 */
RpcControlManager.prototype.handleSpecificError = function (exception) {
    /* note: inheritor can override this method for specific error handling*/
    return false;
};

RpcControlManager.prototype.beginSavingData = function () {
    /* note: inheritor should override this method */
};

RpcControlManager.prototype.endSavingData = function (success) {
    /* note: inheritor should override this method */
};

/*
 * Event is fired after changing cell state is complete.
 */
RpcControlManager.prototype.onDataSavingComplete = function (result) {
    /* note: inheritor should override this method */
};

RpcControlManager.prototype.setRequestId = function (id) {
    this.requestId = id;
};

RpcControlManager.prototype.getRequestId = function () {
    return this.requestId;
};

RpcControlManager.prototype.handleError = function (exception) {
    if (!this.handleSpecificError(exception)) {
        alert(this.getRpcErrorMsg());
        this.endSavingData(false);
    }
};

RpcControlManager.prototype.getRpcErrorMsg = function () {
    /* note: inheritor should override this method */
    return "RPC error";
};

RpcControlManager.prototype.handleNoRightsError = function (exception) {
    if (exception.name.indexOf('com.actimind.actitime.services.NoRightsForRemoteCallException') != -1) {
        document.location.reload();
        return true;
    }
    return false;
};

RpcControlManager.saveRpcControlBoundData = function (manager, isSilent) {
    if (RpcControlManager.isRpcBusy()) {
        return;
    }

    RpcControlManager.currentRpcControlManager = manager;
    RpcControlManager.currentRpcControlManager.init();
    RpcControlManager.currentRpcControlManager.beginSavingData();

    RpcControlManager.retryController = new RpcRetryController(isSilent ? null : RpcControlManager.timeout, function () {
        RpcControlManager.saveRpcControlBoundDataWithDelay();
    }, function () {
        RpcControlManager.timeoutSaving();
    }, function (exception) {
        RpcControlManager.processRpcError(exception);
    });
    RpcControlManager.retryController.start();
};

RpcControlManager.saveRpcControlBoundDataWithDelay = function () {
    try {
        if (!isRpcReady(RpcControlManager.currentRpcControlManager.getMethods())) {
            if (RpcControlManager.isRpcBusy()) {
                RpcControlManager.retryController.retry();
            }
            return;
        }

        if (RpcControlManager.isRpcBusy() && RpcControlManager.currentRpcControlManager.getService()) {
            var reqId = RpcControlManager.currentRpcControlManager.makeRemoteCall(RpcControlManager.rpcControlCallback);
            RpcControlManager.currentRpcControlManager.setRequestId(reqId);
        } else {
            /* service is unavailable, most likely we've been logged out */
            document.location.reload();
        }
    } catch (e) {
        if (RpcControlManager.isRpcBusy()) RpcControlManager.retryController.handleErrorOrRetry(e);
    }
};

RpcControlManager.rpcControlCallback = function (result, exception) {
    if (RpcControlManager.isRpcBusy()) {
        if (exception != null) {
            RpcControlManager.retryController.handleErrorOrRetry(exception);
        } else {
            RpcControlManager.currentRpcControlManager.endSavingData(true);
            RpcControlManager.currentRpcControlManager.onDataSavingComplete(result);
            RpcControlManager.cleanup();
        }
    }
};

RpcControlManager.cleanup = function () {
    if (RpcControlManager.isRpcBusy()) {
        if (RpcControlManager.retryController) {
            RpcControlManager.retryController.stop();
            RpcControlManager.retryController = undefined;
        }
        RpcControlManager.currentRpcControlManager = undefined;
    }
};

RpcControlManager.cancelAllAJAXRequests = function () {
    // this will release the RpcRetryController and its scheduled timeout.
    RpcControlManager.cleanup();

    // this will release all current and pending AJAX calls
    if (jsonrpc) jsonrpc.abortAllRequests();
};

RpcControlManager.processRpcError = function (exception) {
    if (RpcControlManager.currentRpcControlManager.handleNoRightsError(exception)) {
        return;
    }

    RpcControlManager.currentRpcControlManager.handleError(exception);

    RpcControlManager.cleanup();
};

RpcControlManager.isRpcBusy = function () {
    return RpcControlManager.currentRpcControlManager != undefined;
};

RpcControlManager.timeoutSaving = function () {
    if (RpcControlManager.isRpcBusy()) {
        var currentRequest = RpcControlManager.currentRpcControlManager.getRequestId();
        if (currentRequest) {
            JSONRpcClient.cancelRequest(currentRequest);
        }
        jsonrpc.abortAllRequests();

        var msg = RpcControlManager.currentRpcControlManager.getTimeoutMsg();
        if (!confirm(msg)) {
            RpcControlManager.currentRpcControlManager.endSavingData(false);
            RpcControlManager.cleanup();
        } else {
            if (RpcControlManager.retryController) {
                RpcControlManager.retryController.stop();
                RpcControlManager.retryController.start();
            }
        }
    }
};

RpcControlManager.setRpcTimeout = function (newTimeout) {
    RpcControlManager.timeout = newTimeout;
};

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Switcher = function (_TemplateView) {
    _inherits(Switcher, _TemplateView);

    function Switcher(_ref) {
        var additionalClass = _ref.additionalClass,
            onSwitchCallback = _ref.onSwitchCallback;

        _classCallCheck(this, Switcher);

        var _this = _possibleConstructorReturn(this, (Switcher.__proto__ || Object.getPrototypeOf(Switcher)).call(this, null));

        _this.additionalClass = additionalClass;
        _this.onSwitchCallback = onSwitchCallback;

        _this.state = {
            enabled: false,
            readOnly: false,
            animated: false
        };

        _this.onStatePropertyChanged('enabled', function (enabled) {
            _this._updateEnabled(enabled);
        });

        _this.onStatePropertyChanged('readOnly', function (readOnly) {
            return _this.getEl().toggleClass('disabled', readOnly);
        });

        _this.onStatePropertyChanged('animated', function (animated) {
            _this.getEl().toggleClass('animated', animated);
        });
        return _this;
    }

    _createClass(Switcher, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class="components_switcher <%=additionalClass%>"/>';
        }
    }, {
        key: 'templateModel',
        value: function templateModel() {
            return {
                additionalClass: this.additionalClass
            };
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            var _this2 = this;

            this.getEl().on('click', function () {
                if (!_this2.state.readOnly) {
                    _this2.setState({ enabled: !_this2.state.enabled });
                    _this2.onSwitchCallback(_this2.state.enabled);
                }
            });

            this.renderInitialState();
        }
    }, {
        key: '_updateEnabled',
        value: function _updateEnabled(enabled) {
            this.getEl().toggleClass('on', enabled);
            this.getEl().toggleClass('off', !enabled);
        }
    }]);

    return Switcher;
}(_TemplateView3.default);

exports.default = Switcher;

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function TableTooltip() {}

TableTooltip.prototype.init = function (tooltipId) {
    this._tooltipEl = (0, _jquery2.default)("#" + tooltipId);
    this._tooltipTextPlaceholder = this._tooltipEl.find("#" + tooltipId + "_textPlaceholder");

    return this;
};

TableTooltip.prototype.updateUI = function (config) {
    // abstract
};

TableTooltip.prototype.updateUIAndShow = function (config, offset) {
    this.updateUI(config);
    this.show();

    if (offset) this.move(offset);
};

TableTooltip.prototype.move = function (offset) {
    this._tooltipEl.offset(offset);
};

TableTooltip.prototype.show = function () {
    this._tooltipEl.show();
};

TableTooltip.prototype.hide = function () {
    this._tooltipEl.hide();
};

TableTooltip.prototype.getHeight = function () {
    return this._tooltipEl.outerHeight();
};

TableTooltip.prototype.getWidth = function () {
    return this._tooltipEl.outerWidth();
};

TableTooltip.prototype.setHtml = function (html) {
    this._tooltipTextPlaceholder.html(html);
};

exports.default = TableTooltip;

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = UserGroupNodeRenderer;

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _ExpandCollapseNodeRenderer = __webpack_require__(352);

var _ExpandCollapseNodeRenderer2 = _interopRequireDefault(_ExpandCollapseNodeRenderer);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function UserGroupNodeRenderer(tree, selectorFilter, expandCollapseCallback) {
    _ExpandCollapseNodeRenderer2.default.call(this, tree, selectorFilter, expandCollapseCallback);
}

UserGroupNodeRenderer.prototype = _underscore2.default.create(_ExpandCollapseNodeRenderer2.default.prototype);

UserGroupNodeRenderer.prototype.getEmptyEntityTooltip = function () {
    return _messageResource2.default.getMessage("users_selector.expand_collapse_disabled.user_group.tooltip");
};

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _View2 = __webpack_require__(20);

var _View3 = _interopRequireDefault(_View2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TabsController = function (_View) {
    _inherits(TabsController, _View);

    function TabsController(_ref) {
        var _ref$tabs = _ref.tabs,
            tabs = _ref$tabs === undefined ? new Map() : _ref$tabs;

        _classCallCheck(this, TabsController);

        var _this = _possibleConstructorReturn(this, (TabsController.__proto__ || Object.getPrototypeOf(TabsController)).call(this));

        _this._switchTab = function (selectedTabKey, prevTabKey) {
            if (prevTabKey) _this.tabs.get(prevTabKey).hide();
            if (selectedTabKey) _this.tabs.get(selectedTabKey).show();
        };

        _this.state = {
            selectedTabKey: null
        };
        _this.tabs = tabs;
        _this.onStatePropertyChanged('selectedTabKey', _this._switchTab);
        return _this;
    }

    _createClass(TabsController, [{
        key: 'afterRender',
        value: function afterRender() {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = this.tabs.values()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var tab = _step.value;

                    tab.hide();
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    }]);

    return TabsController;
}(_View3.default);

exports.default = TabsController;

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _MenuButton2 = __webpack_require__(484);

var _MenuButton3 = _interopRequireDefault(_MenuButton2);

var _WorkflowStatus = __webpack_require__(360);

var _WorkflowStatus2 = _interopRequireDefault(_WorkflowStatus);

var _selectors = __webpack_require__(57);

var _utils = __webpack_require__(6);

var _SimpleSingletonTooltip = __webpack_require__(45);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TaskStatusButton = function (_MenuButton) {
    _inherits(TaskStatusButton, _MenuButton);

    function TaskStatusButton(_ref) {
        var _ref$editable = _ref.editable,
            editable = _ref$editable === undefined ? true : _ref$editable,
            _ref$taskStatusMenu = _ref.taskStatusMenu,
            taskStatusMenu = _ref$taskStatusMenu === undefined ? null : _ref$taskStatusMenu,
            _ref$showStatusTypePr = _ref.showStatusTypePrefix,
            showStatusTypePrefix = _ref$showStatusTypePr === undefined ? false : _ref$showStatusTypePr,
            _ref$hideName = _ref.hideName,
            hideName = _ref$hideName === undefined ? false : _ref$hideName,
            _ref$onStatusChangedC = _ref.onStatusChangedCb,
            onStatusChangedCb = _ref$onStatusChangedC === undefined ? function (id) {} : _ref$onStatusChangedC,
            _ref$positionParams = _ref.positionParams,
            positionParams = _ref$positionParams === undefined ? { offset: "0px 1px" } : _ref$positionParams,
            _ref$onShowMenu = _ref.onShowMenu,
            onShowMenu = _ref$onShowMenu === undefined ? function () {} : _ref$onShowMenu,
            _ref$onHideMenu = _ref.onHideMenu,
            onHideMenu = _ref$onHideMenu === undefined ? function () {} : _ref$onHideMenu;

        _classCallCheck(this, TaskStatusButton);

        var _this = _possibleConstructorReturn(this, (TaskStatusButton.__proto__ || Object.getPrototypeOf(TaskStatusButton)).call(this, {
            editable: editable,
            positionParams: positionParams,
            onShowMenu: onShowMenu,
            onHideMenu: onHideMenu
        }));

        _this.taskStatusMenu = taskStatusMenu;
        _this.showStatusTypePrefix = showStatusTypePrefix;
        _this.hideName = hideName;

        _this.state = {
            statusId: -1,
            canReopenProject: false
        };

        _this.callbacks = {
            onStatusChangedCb: onStatusChangedCb
        };

        _this.onStatePropertyChanged('statusId', function () {
            if (_this.rendered) {
                _this._renderStatus();
            }
        });
        return _this;
    }

    _createClass(TaskStatusButton, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return "<div class='taskStatusButton'></div>";
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            _get(TaskStatusButton.prototype.__proto__ || Object.getPrototypeOf(TaskStatusButton.prototype), 'afterRender', this).call(this);
        }
    }, {
        key: '_renderStatus',
        value: function _renderStatus() {
            var _this2 = this;

            this.getEl().empty();
            this.status = new _WorkflowStatus2.default(_extends({}, (0, _utils.unsafe_selectWithState)(function (state) {
                return (0, _selectors.selectStatusById)(state, _this2.state.statusId);
            }), {
                showTypePrefix: this.showStatusTypePrefix,
                showArrow: this.editable,
                hideName: this.hideName
            })).init(this.getEl());
        }
    }, {
        key: 'setEditable',
        value: function setEditable(editable) {
            this.editable = editable;
            this.getEl().toggleClass('disabled', !editable);
            this._renderStatus();
            this.update();
        }
    }, {
        key: 'getMenu',
        value: function getMenu() {
            this.taskStatusMenu.setStatusId(this.state.statusId);
            this.taskStatusMenu.setInactiveOpenStatuses(!this.state.canReopenProject);
            return this.taskStatusMenu;
        }
    }, {
        key: '_change',
        value: function _change(id) {
            if (id !== this.state.statusId) {
                this.callbacks.onStatusChangedCb(id);
                return true;
            }
            return false;
        }
    }]);

    return TaskStatusButton;
}(_MenuButton3.default);

exports.default = TaskStatusButton;

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _utils = __webpack_require__(80);

var _utils2 = __webpack_require__(80);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var WorkFlowStatusIcon = function (_TemplateView) {
    _inherits(WorkFlowStatusIcon, _TemplateView);

    function WorkFlowStatusIcon($containerEl, _ref) {
        var type = _ref.type,
            colorId = _ref.colorId,
            _ref$additionalClass = _ref.additionalClass,
            additionalClass = _ref$additionalClass === undefined ? '' : _ref$additionalClass;

        _classCallCheck(this, WorkFlowStatusIcon);

        var _this = _possibleConstructorReturn(this, (WorkFlowStatusIcon.__proto__ || Object.getPrototypeOf(WorkFlowStatusIcon)).call(this, $containerEl));

        _this.typeClass = (0, _utils.getStatusClassByType)(type);
        _this.colorClass = (0, _utils2.getColorClassById)(colorId);

        _this.params = {
            additionalClass: additionalClass,
            clazz: 'workflowStatusIcon'
        };

        _this.state = {
            type: type,
            colorId: colorId
        };

        _this.onStateChanged(function () {
            _this._updateClasses();
        });
        return _this;
    }

    _createClass(WorkFlowStatusIcon, [{
        key: "_updateClasses",
        value: function _updateClasses() {
            var classes = [this.params.clazz, this.params.additionalClass, (0, _utils.getStatusClassByType)(this.state.type), (0, _utils2.getColorClassById)(this.state.colorId)];
            this.$el.removeClass().addClass(classes.join(' '));
        }
    }, {
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='workflowStatusIcon <%-typeClass%> <%-colorClass%>'></div>";
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            this._updateClasses();
        }
    }]);

    return WorkFlowStatusIcon;
}(_TemplateView3.default);

exports.default = WorkFlowStatusIcon;

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getSingleCPSelectionFromLocalStorage = exports.saveSingleCPSelectionToLocalStorage = exports.getCpPanelClosedStateInLocalStorage = exports.setCpPanelClosedStateInLocalStorage = exports.removeProjectFromCPSelection = exports.removeCustomerFromCPSelection = exports.filterEntitiesBySearch = exports.createIntersectedCPSelection = exports.createCPSelectionFromSingleCPSelectionObject = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.isCustomerAssignedForManage = isCustomerAssignedForManage;
exports.isProjectAssignedForManage = isProjectAssignedForManage;
exports.isTaskAssignedForManage = isTaskAssignedForManage;
exports.isPossibleToAddProjectsToCustomer = isPossibleToAddProjectsToCustomer;
exports.isPossibleToManageProject = isPossibleToManageProject;
exports.getCustomerIdsFilteredByAssignments = getCustomerIdsFilteredByAssignments;
exports.getProjectIdsFilteredByAssignments = getProjectIdsFilteredByAssignments;
exports.getProjectsFilteredByAssignments = getProjectsFilteredByAssignments;
exports.getTaskIdsFilteredByAssignments = getTaskIdsFilteredByAssignments;

var _CustomerProjectSelection = __webpack_require__(156);

var _CustomerProjectSelection2 = _interopRequireDefault(_CustomerProjectSelection);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _CustomerStore = __webpack_require__(65);

var _CustomerStore2 = _interopRequireDefault(_CustomerStore);

var _TaskManagementStore = __webpack_require__(140);

var _TaskManagementStore2 = _interopRequireDefault(_TaskManagementStore);

var _ProjectStore = __webpack_require__(59);

var _ProjectStore2 = _interopRequireDefault(_ProjectStore);

var _StringIndex = __webpack_require__(115);

var _StringIndex2 = _interopRequireDefault(_StringIndex);

var _atUtils = __webpack_require__(5);

var _LocalStorage = __webpack_require__(72);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createCPSelectionFromSingleCPSelectionObject = exports.createCPSelectionFromSingleCPSelectionObject = function createCPSelectionFromSingleCPSelectionObject(singleCPSelection) {
    var qualifier = _CustomerProjectSelection2.default.Qualifier.ALL;
    var customers = [];
    var projects = [];

    if (singleCPSelection.customerId) {
        qualifier = _CustomerProjectSelection2.default.Qualifier.SELECTED;
        if (singleCPSelection.projectId) projects.push(singleCPSelection.projectId);else customers.push(singleCPSelection.customerId);
    }

    return new _CustomerProjectSelection2.default(qualifier, customers, projects);
};

var createIntersectedCPSelection = exports.createIntersectedCPSelection = function createIntersectedCPSelection(filterCPSelection, singleCPSelection, customersMap, projectsMap) {
    var convertedSingleCPSelection = createCPSelectionFromSingleCPSelectionObject(singleCPSelection);
    var convertedFilterCPSelection = _CustomerProjectSelection2.default.fromPlainObject(filterCPSelection);
    return createIntersectedCPSelectionInternal(convertedSingleCPSelection, convertedFilterCPSelection, customersMap, projectsMap);
};

var createIntersectedCPSelectionInternal = function createIntersectedCPSelectionInternal(singleCPSelection, filterCPSelection, customersMap, projectsMap) {
    var intersectionQualifier = void 0;
    if (singleCPSelection.qualifier === _CustomerProjectSelection2.default.Qualifier.ALL) {
        intersectionQualifier = filterCPSelection.qualifier;
    } else {
        intersectionQualifier = _CustomerProjectSelection2.default.Qualifier.SELECTED; // only select is available for `singleCPSelection`
    }

    var intersectionActiveOnly = filterCPSelection.activeOnly;
    if (intersectionQualifier !== _CustomerProjectSelection2.default.Qualifier.SELECTED) {
        return new _CustomerProjectSelection2.default(intersectionQualifier, [], [], intersectionActiveOnly);
    }

    var intersectionCustomersSet = {};
    var intersectionProjectsSet = {};
    var singleCustomerSelected = singleCPSelection.customers.length !== 0;
    var singleProjectSelected = singleCPSelection.projects.length !== 0;
    if (singleCustomerSelected) {
        var singleSelectedCustomerId = singleCPSelection.customers[0];
        var customer = customersMap[singleSelectedCustomerId];
        var filteredProjectsOfCustomer = filterCPSelection.projects.filter(function (projectId) {
            var project = projectsMap[projectId];
            return project && project.customerId === customer.id;
        });
        if (filteredProjectsOfCustomer.length !== 0) {
            filteredProjectsOfCustomer.forEach(function (projectId) {
                intersectionProjectsSet[projectId] = true;
            });
        } else {
            // just select customer
            intersectionCustomersSet[customer.id] = true;
        }
    } else if (singleProjectSelected) {
        // one project selected - just add project
        var singleSelectedProjectId = singleCPSelection.projects[0];
        intersectionProjectsSet[singleSelectedProjectId] = true;
    } else {
        // ALL in `singleCPSelection`
        filterCPSelection.customers.forEach(function (customerId) {
            var customer = customersMap[customerId];
            if (customer) intersectionCustomersSet[customer.id] = true;
        });
        filterCPSelection.projects.forEach(function (projectId) {
            var project = projectsMap[projectId];
            if (project) intersectionProjectsSet[projectId] = true;
        });
    }
    var intersectionCustomers = _underscore2.default.keys(intersectionCustomersSet);
    var intersectionProjects = _underscore2.default.keys(intersectionProjectsSet);
    // if any project selected, activeOnly flag should be set off
    // to prevent empty list when selected project is archived
    if (intersectionProjects.length) intersectionActiveOnly = false;

    return new _CustomerProjectSelection2.default(intersectionQualifier, intersectionCustomers, intersectionProjects, intersectionActiveOnly);
};

function isCustomerAssignedForManage(customersMA, id) {
    var withIncludeSelf = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

    var assignment = customersMA[id];
    return assignment !== undefined && (!withIncludeSelf || assignment.includeSelf === true);
}

function isProjectAssignedForManage(projectsMA, id) {
    var withIncludeSelf = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

    var assignment = projectsMA[id];
    return assignment !== undefined && (!withIncludeSelf || assignment.includeSelf === true);
}

function isTaskAssignedForManage(tasksMA, id) {
    var withIncludeSelf = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

    var assignment = tasksMA[id];
    return assignment !== undefined && (!withIncludeSelf || assignment.includeSelf === true);
}

function isPossibleToAddProjectsToCustomer(id, viewerSettings, customersMA) {
    return viewerSettings.hasEditHierarchyRight && (viewerSettings.hasAccessToAllManagementScope || isCustomerAssignedForManage(customersMA, id, false));
}

function isPossibleToManageProject(project, viewerSettings, customersMa, projectsMA) {
    return viewerSettings.hasEditHierarchyRight && (viewerSettings.hasAccessToAllManagementScope || isCustomerAssignedForManage(customersMa, project.customerId, false) || isProjectAssignedForManage(projectsMA, project.id));
}

function getCustomerIdsFilteredByAssignments(customerIds, customerMA) {
    var withIncludeSelf = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

    return customerIds.filter(function (cId) {
        return isCustomerAssignedForManage(customerMA, cId, withIncludeSelf);
    });
}

function getProjectIdsFilteredByAssignments(projects, ma) {
    var withIncludeSelf = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

    return projects.filter(function (project) {
        return isCustomerAssignedForManage(ma.customers, project.customerId, false) || isProjectAssignedForManage(ma.projects, project.id, withIncludeSelf);
    }).map(function (p) {
        return p.id;
    });
}

function getProjectsFilteredByAssignments(projects, ma) {
    var withIncludeSelf = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

    return projects.filter(function (project) {
        return isCustomerAssignedForManage(ma.customers, project.customerId, false) || isProjectAssignedForManage(ma.projects, project.id, withIncludeSelf);
    });
}

function getTaskIdsFilteredByAssignments(tasks, ma) {
    return tasks.filter(function (task) {
        return isCustomerAssignedForManage(ma.customers, task.customerId, false) || isProjectAssignedForManage(ma.projects, task.projectId, false) || isTaskAssignedForManage(ma.tasks, task.id);
    }).map(function (t) {
        return t.id;
    });
}

var filterEntitiesBySearch = exports.filterEntitiesBySearch = function filterEntitiesBySearch(entities, search) {
    if (search) {
        var stringIndex = new _StringIndex2.default();
        entities.forEach(function (entity) {
            stringIndex.add(entity.name, entity.id);
        });
        var tokens = stringIndex.getTokenizer().getTokens(search.toLowerCase());
        var searchIds = (0, _atUtils.arrayToSet)(Object.keys(stringIndex.search(tokens)));
        return entities.filter(function (entity) {
            return searchIds[entity.id] === true;
        });
    }
    return entities;
};

var removeCustomerFromCPSelection = exports.removeCustomerFromCPSelection = function removeCustomerFromCPSelection(cpSelection, customerId, projectsMap) {
    var filteredCustomers = cpSelection.customers.filter(function (cId) {
        return cId !== customerId;
    });
    var filteredProjects = cpSelection.projects.filter(function (pId) {
        return projectsMap[pId].customerId !== customerId;
    });
    return _extends({}, cpSelection, {
        qualifier: filteredProjects.length !== 0 || cpSelection.customers.length !== 0 ? _CustomerProjectSelection2.default.Qualifier.SELECTED : cpSelection.qualifier,
        customers: filteredCustomers,
        projects: filteredProjects
    });
};

var removeProjectFromCPSelection = exports.removeProjectFromCPSelection = function removeProjectFromCPSelection(projectId, cpSelection) {
    var filteredProjects = cpSelection.projects.filter(function (pId) {
        return pId !== projectId;
    });
    return _extends({}, cpSelection, {
        qualifier: filteredProjects.length !== 0 || cpSelection.customers.length !== 0 ? _CustomerProjectSelection2.default.Qualifier.SELECTED : cpSelection.qualifier,
        projects: filteredProjects
    });
};
var setCpPanelClosedStateInLocalStorage = exports.setCpPanelClosedStateInLocalStorage = function setCpPanelClosedStateInLocalStorage(closed) {
    (0, _LocalStorage.getLocalStorage)().setItem('customersProjectsPanelClosed', closed);
};

var getCpPanelClosedStateInLocalStorage = exports.getCpPanelClosedStateInLocalStorage = function getCpPanelClosedStateInLocalStorage() {
    return !!(0, _LocalStorage.getLocalStorage)().getItem('customersProjectsPanelClosed');
};

var SINGLE_CP_SELECTION_KEY = 'singleCPSelection';

var saveSingleCPSelectionToLocalStorage = exports.saveSingleCPSelectionToLocalStorage = function saveSingleCPSelectionToLocalStorage(selection) {
    (0, _LocalStorage.getLocalStorage)().setItem(SINGLE_CP_SELECTION_KEY, selection);
};

var getSingleCPSelectionFromLocalStorage = exports.getSingleCPSelectionFromLocalStorage = function getSingleCPSelectionFromLocalStorage() {
    return (0, _LocalStorage.getLocalStorage)().getItem(SINGLE_CP_SELECTION_KEY);
};

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getVisibleTaskIds = exports.thereAreNoTasks = exports.getProjectsWithGroupedTasks = exports.getTasksWithHighlightedNames = exports.getLoadedTasksNameTokensHighlighter = exports.areProjectsFullyLoaded = exports.getLoadableProjectPredicate = exports.getProjectCollapsedPredicate = exports.getCollapsedProjectsIdsSet = exports.doesIgnoreCollapse = exports.getVisibleProjectPredicate = exports.isSearchEnable = exports.isLoading = exports.getWorkflowStatuses = exports.getProjects = exports.getTasks = exports.getProjectIdsContainingTasks = exports.getLoadedTasksNameFilter = exports.getUpdatingTaskIds = exports.isNeedToReloadKanban = exports.getCollapsedProjectsWithIdsSet = exports.getCollapsedProjects = exports.isNeedToReloadCounters = exports.isMinimizedCards = exports.getTaskIdsOrder = exports.isLoaded = exports.isLoadingTasks = exports.getLoadingProjectId = exports.isLoadingInitialData = exports.getProjectLoadingPositions = exports.getProjectIds = exports.getTaskCountsByWorkflowStatus = exports.getWorkflowStatusIds = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reselect = __webpack_require__(13);

var _selectors = __webpack_require__(14);

var EntitiesSelectors = _interopRequireWildcard(_selectors);

var _selectors2 = __webpack_require__(27);

var _constants = __webpack_require__(44);

var _utils = __webpack_require__(365);

var _utils2 = __webpack_require__(80);

var _TokensHighlighter = __webpack_require__(94);

var _atUtils = __webpack_require__(5);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _utils3 = __webpack_require__(486);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var getKanbanState = function getKanbanState(state) {
    return state.taskManagement.kanban;
};

var getWorkflowStatusIds = exports.getWorkflowStatusIds = function getWorkflowStatusIds(state) {
    return getKanbanState(state).workflowStatusIds;
};

var getTaskCountsByWorkflowStatus = exports.getTaskCountsByWorkflowStatus = function getTaskCountsByWorkflowStatus(state) {
    return getKanbanState(state).taskCountsByWorkflowStatus;
};

var getProjectIds = exports.getProjectIds = function getProjectIds(state) {
    return getKanbanState(state).projectIds;
};

var getProjectLoadingPositions = exports.getProjectLoadingPositions = function getProjectLoadingPositions(state) {
    return getKanbanState(state).projectLoadingPositions;
};

var isLoadingInitialData = exports.isLoadingInitialData = function isLoadingInitialData(state) {
    return getKanbanState(state).loadingInitialData;
};

var getLoadingProjectId = exports.getLoadingProjectId = function getLoadingProjectId(state) {
    return getKanbanState(state).loadingProjectId;
};

var isLoadingTasks = exports.isLoadingTasks = function isLoadingTasks(state) {
    return getLoadingProjectId(state) !== null;
};

var isLoaded = exports.isLoaded = function isLoaded(state) {
    return getKanbanState(state).isLoaded;
};

var getTaskIdsOrder = exports.getTaskIdsOrder = function getTaskIdsOrder(state) {
    return getKanbanState(state).taskIdsOrder;
};

var isMinimizedCards = exports.isMinimizedCards = function isMinimizedCards(state) {
    return getKanbanState(state).minimizedCards;
};

var isNeedToReloadCounters = exports.isNeedToReloadCounters = function isNeedToReloadCounters(state) {
    return getKanbanState(state).needToLoadCounters;
};

var getCollapsedProjects = exports.getCollapsedProjects = (0, _reselect.createSelector)(getKanbanState, function (kanbanState) {
    return kanbanState.collapsedProjects;
});

var getCollapsedProjectsWithIdsSet = exports.getCollapsedProjectsWithIdsSet = (0, _reselect.createSelector)(getCollapsedProjects, function (collapsedProjects) {
    return {
        all: collapsedProjects.all,
        idsSet: (0, _atUtils.arrayToSet)(collapsedProjects.ids)
    };
});

var isNeedToReloadKanban = exports.isNeedToReloadKanban = (0, _reselect.createSelector)(_selectors2.getViewMode, isLoaded, function (viewMode, isLoaded) {
    return viewMode === _constants.TaskManagementViewMode.KANBAN && isLoaded === false;
});

var getUpdatingTaskIds = exports.getUpdatingTaskIds = function getUpdatingTaskIds(state) {
    return getKanbanState(state).updatingTaskIds;
};

var getLoadedTasksNameFilter = exports.getLoadedTasksNameFilter = function getLoadedTasksNameFilter(state) {
    return getKanbanState(state).loadedTasksNameFilter;
};

// use only for checking empty project and not send request to server
var getProjectIdsContainingTasks = exports.getProjectIdsContainingTasks = function getProjectIdsContainingTasks(state) {
    return getKanbanState(state).projectIdsContainingTasks;
};

var getTasks = exports.getTasks = (0, _reselect.createSelector)(EntitiesSelectors.getTasks, getTaskIdsOrder, function (allTasks, taskIds) {
    return taskIds.map(function (taskId) {
        return allTasks[taskId];
    });
});

var getProjects = exports.getProjects = (0, _reselect.createSelector)(EntitiesSelectors.getProjects, getProjectIds, function (allProjects, projectIds) {
    return projectIds.map(function (projectId) {
        return allProjects[projectId];
    });
});

var getWorkflowStatuses = exports.getWorkflowStatuses = (0, _reselect.createSelector)(EntitiesSelectors.getWorkflowStatuses, getWorkflowStatusIds, getTaskCountsByWorkflowStatus, function (allStatuses, kanbanWorkflowStatusIds, kanbanTaskCounts) {
    var statuses = kanbanWorkflowStatusIds.map(function (id) {
        return _extends({}, allStatuses[id], { count: kanbanTaskCounts[id] });
    });
    statuses.sort(_utils2.workflowStatusComparatorWithStatusType);
    return statuses;
});

var isLoading = exports.isLoading = (0, _reselect.createSelector)(isLoadingInitialData, isLoadingTasks, function (loadingInitial, loadingTasks) {
    return loadingInitial || loadingTasks;
});

/**
 * Detects that search enable for loaded kanban data
 */
var isSearchEnable = exports.isSearchEnable = (0, _reselect.createSelector)(getLoadedTasksNameFilter, function (loadedTasksNameFilter) {
    return !_underscore2.default.isEmpty(loadedTasksNameFilter);
});

/**
 * Predicate that checks is possible to see project on kanban
 */
var getVisibleProjectPredicate = exports.getVisibleProjectPredicate = (0, _reselect.createSelector)(isSearchEnable, getProjectIdsContainingTasks, EntitiesSelectors.getProjects, _selectors2.getTaskStatusFilter, function (searchEnable, projectWithTasksIds, projectsMap, taskStatusFilter) {
    return function (projectId) {
        // always show project with tasks
        if (!!projectWithTasksIds[projectId]) {
            return true;
        }

        // search enable -> hide all empty
        if (searchEnable) {
            return false;
        }

        // if directly statuses -> hide all empty
        if ((0, _utils3.isOnlyDirectlySelectedStatuses)(taskStatusFilter)) {
            return false;
        }

        // if open group selected -> hide archived
        if ((0, _utils3.isOpenTypeSelected)(taskStatusFilter) && !(0, _utils3.isCompletedTypeSelected)(taskStatusFilter)) {
            return !projectsMap[projectId].archived;
        }

        return true;
    };
});

/**
 * Detect that projects should always expanded
 */
var doesIgnoreCollapse = exports.doesIgnoreCollapse = (0, _reselect.createSelector)(_selectors2.isSingleProjectSelected, isSearchEnable, function (isSingleProjectSelected, isSearchEnable) {
    return isSingleProjectSelected || isSearchEnable;
});

/**
 * Set of ids that collapsed. Consider `all` option
 */
var getCollapsedProjectsIdsSet = exports.getCollapsedProjectsIdsSet = (0, _reselect.createSelector)(getCollapsedProjects, getProjectIds, function (collapsedProjects, projectIds) {
    return (0, _atUtils.arrayToSet)(collapsedProjects.all === true ? projectIds : collapsedProjects.ids);
});

/**
 * Get predicate which checks that project is collapsed or not on page
 */
var getProjectCollapsedPredicate = exports.getProjectCollapsedPredicate = (0, _reselect.createSelector)(doesIgnoreCollapse, getCollapsedProjectsIdsSet, function (ignoreCollapse, collapsedProjectIds) {
    return function (projectId) {
        return !ignoreCollapse && !!collapsedProjectIds[projectId];
    };
});

/**
 * Get predicate which checks that for project need to load data
 */
var getLoadableProjectPredicate = exports.getLoadableProjectPredicate = (0, _reselect.createSelector)(getProjectCollapsedPredicate, getVisibleProjectPredicate, function (isProjectCollapsed, isProjectVisiblePredicate) {
    return function (projectId) {
        return !isProjectCollapsed(projectId) && isProjectVisiblePredicate(projectId);
    };
});

/**
 * Checks that all loadable projects are loaded
 */
var areProjectsFullyLoaded = exports.areProjectsFullyLoaded = (0, _reselect.createSelector)(getProjectIds, getProjectLoadingPositions, getLoadableProjectPredicate, function (projectIds, loadingPositions, isProjectLoadable) {
    return projectIds.every(function (id) {
        return !isProjectLoadable(id) || (0, _utils.isProjectFullyLoaded)(id, loadingPositions);
    });
});

var getLoadedTasksNameTokensHighlighter = exports.getLoadedTasksNameTokensHighlighter = (0, _reselect.createSelector)(getLoadedTasksNameFilter, function (nameFilter) {
    return (0, _TokensHighlighter.createTokensHighlighterForSearch)(nameFilter);
});

var getTasksWithHighlightedNames = exports.getTasksWithHighlightedNames = (0, _reselect.createSelector)(getTasks, getLoadedTasksNameTokensHighlighter, function (tasks, tokensHighlighter) {
    return tasks.map(function (task) {
        return _extends({}, task, {
            highlightedName: tokensHighlighter ? tokensHighlighter.highlightTokens(task.name) : null
        });
    });
});

/**
 * Get all projects with grouped tasks. For internal usage.
 */
var getAllProjectsWithGroupedTasks = (0, _reselect.createSelector)(getProjects, _selectors.getCustomers, getTasksWithHighlightedNames, _selectors2.getEditableProjectIds, _selectors2.getEditableProjectIdsWithExcludeSelf, _selectors2.getEditableCustomerIds, _selectors2.getEditableCustomerIdsWithExcludeSelf, function (projects, customers, tasks, editableProjectIds, editableProjectIdsWithExcludeSelf, editableCustomerIds, editableCustomerIdsWithExcludeSelf) {
    return (0, _utils.calcProjectsWithGroupedTasks)(projects, customers, tasks, editableProjectIds, editableProjectIdsWithExcludeSelf, editableCustomerIds, editableCustomerIdsWithExcludeSelf);
});

/**
 * Get projects with tasks that will be rendered on page
 */
var getProjectsWithGroupedTasks = exports.getProjectsWithGroupedTasks = (0, _reselect.createSelector)(getAllProjectsWithGroupedTasks, getProjectCollapsedPredicate, getProjectLoadingPositions, getVisibleProjectPredicate, function (allProjects, isProjectCollapsedPredicate, projectLoadingPositions, isProjectVisiblePredicate) {
    return (0, _utils.filterVisibleProjects)(allProjects, isProjectCollapsedPredicate, projectLoadingPositions, isProjectVisiblePredicate);
});

/**
 * Detect that no tasks in current filters.
 * The only way to detect it is task's counters now.
* */
var thereAreNoTasks = exports.thereAreNoTasks = (0, _reselect.createSelector)(getTaskCountsByWorkflowStatus, isLoading, function (counters, isLoading) {
    return Object.values(counters).every(function (count) {
        return count === 0;
    }) && !isLoading;
});

/**
 * Select list of ids that currently visible on kanban
 */
var getVisibleTaskIds = exports.getVisibleTaskIds = (0, _reselect.createSelector)(getTaskIdsOrder, getWorkflowStatusIds, EntitiesSelectors.getTasks, function (taskIds, workflowStatusIds, tasks) {
    var wfsIdsSet = (0, _atUtils.arrayToSet)(workflowStatusIds);
    return taskIds.filter(function (id) {
        return !!tasks[id] && !!wfsIdsSet[tasks[id].workflowStatusId];
    });
});

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isPanelOpenedFromUrl = exports.canMoveProject = exports.canReopenProject = exports.isShowNewCommentInput = exports.getIsOpenProjectAssigned = exports.getProjectNewComment = exports.getNewCommentsTexts = exports.getUpdatingCommentId = exports.isSendingComment = exports.isCommentsLoading = exports.getEditingCommentText = exports.getEditingCommentId = exports.getCommentsScrollTo = exports.getNewestCommentId = exports.isNewCommentsOnTop = exports.needMoreComments = exports.getRecentlyAddedCommentsIds = exports.getAllCommentsUserIds = exports.getCommentsCount = exports.getUsers = exports.getComments = exports.canManage = exports.isCommentsReadOnly = exports.isAllTasksAssigned = exports.getOpenProjectId = undefined;

var _reselect = __webpack_require__(13);

var _selectorsGenerator = __webpack_require__(485);

var _selectorsGenerator2 = _interopRequireDefault(_selectorsGenerator);

var _selectors = __webpack_require__(14);

var _selectors2 = __webpack_require__(27);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getProjectPanelState = function getProjectPanelState(state) {
    return state.panels.project;
};

var getOpenProjectId = exports.getOpenProjectId = function getOpenProjectId(state) {
    return getProjectPanelState(state).openProjectId;
};
var isAllTasksAssigned = exports.isAllTasksAssigned = function isAllTasksAssigned(state) {
    return getProjectPanelState(state).allTasksAssigned;
};
var isCommentsReadOnly = exports.isCommentsReadOnly = function isCommentsReadOnly(state) {
    return !isAllTasksAssigned(state);
};
var canManage = exports.canManage = function canManage(state) {
    return getProjectPanelState(state).canManage;
};

var commentsSelector = (0, _selectorsGenerator2.default)(getProjectPanelState);

var getComments = exports.getComments = commentsSelector.getComments;
var getUsers = exports.getUsers = commentsSelector.getUsers;
var getCommentsCount = exports.getCommentsCount = commentsSelector.getCommentsCount;
var getAllCommentsUserIds = exports.getAllCommentsUserIds = commentsSelector.getAllCommentsUserIds;
var getRecentlyAddedCommentsIds = exports.getRecentlyAddedCommentsIds = commentsSelector.getRecentlyAddedCommentsIds;
var needMoreComments = exports.needMoreComments = commentsSelector.needMoreComments;
var isNewCommentsOnTop = exports.isNewCommentsOnTop = commentsSelector.isNewCommentsOnTop;
var getNewestCommentId = exports.getNewestCommentId = commentsSelector.getNewestCommentId;
var getCommentsScrollTo = exports.getCommentsScrollTo = commentsSelector.getCommentsScrollTo;
var getEditingCommentId = exports.getEditingCommentId = commentsSelector.getEditingCommentId;
var getEditingCommentText = exports.getEditingCommentText = commentsSelector.getEditingCommentText;
var isCommentsLoading = exports.isCommentsLoading = commentsSelector.isLoading;
var isSendingComment = exports.isSendingComment = commentsSelector.isSendingComment;
var getUpdatingCommentId = exports.getUpdatingCommentId = commentsSelector.getUpdatingCommentId;
var getNewCommentsTexts = exports.getNewCommentsTexts = commentsSelector.getNewCommentsTexts;

var getProjectNewComment = exports.getProjectNewComment = (0, _reselect.createSelector)(getOpenProjectId, commentsSelector.getNewCommentsTexts, function (taskId, comments) {
    return comments[taskId] ? comments[taskId] : '';
});

var getIsOpenProjectAssigned = exports.getIsOpenProjectAssigned = (0, _reselect.createSelector)(getOpenProjectId, _selectors2.getManageableProjectIds, function (projectId, manageableProjectIds) {
    return !!manageableProjectIds[projectId];
});

var isShowNewCommentInput = exports.isShowNewCommentInput = (0, _reselect.createSelector)(commentsSelector.isShowNewCommentInput, getOpenProjectId, commentsSelector.getNewCommentsTexts, function (showInput, projectId, comments) {
    return showInput || comments[projectId] !== undefined;
});

var getCustomerId = (0, _reselect.createSelector)(getOpenProjectId, _selectors.getProjects, function (id, projects) {
    return projects[id] ? projects[id].customerId : -1;
});

var getCustomer = (0, _reselect.createSelector)(getCustomerId, _selectors.getCustomers, function (id, customers) {
    return customers[id] ? customers[id] : null;
});

var getProject = (0, _reselect.createSelector)(getOpenProjectId, _selectors.getProjects, function (id, projects) {
    return projects[id] ? projects[id] : null;
});

var canReopenProject = exports.canReopenProject = (0, _reselect.createSelector)(getOpenProjectId, getProject, isAllTasksAssigned, getCustomerId, getCustomer, _selectors2.getEditableProjectIds, _selectors2.getEditableCustomerIds, function (projectId, project, isAllTasksAssigned, customerId, customer, editableProjectIds, editableCustomerIds) {
    return !!project && !project.archived || !!editableProjectIds[projectId] && !!customer && !customer.archived || !!editableCustomerIds[customerId];
});

var canMoveProject = exports.canMoveProject = (0, _reselect.createSelector)(getOpenProjectId, _selectors2.getEditableProjectIds, function (projectId, editableProjectIds) {
    return !!editableProjectIds[projectId];
});

var isPanelOpenedFromUrl = exports.isPanelOpenedFromUrl = (0, _reselect.createSelector)(getProjectPanelState, function (panelState) {
    return panelState.openedFromUrl;
});

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _ChartPDFParametersFormatter = __webpack_require__(1474);

var _ChartPDFParametersFormatter2 = _interopRequireDefault(_ChartPDFParametersFormatter);

var _features = __webpack_require__(22);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ChartPDFParametersFormattingStrategy = function () {
    function ChartPDFParametersFormattingStrategy() {
        _classCallCheck(this, ChartPDFParametersFormattingStrategy);
    }

    _createClass(ChartPDFParametersFormattingStrategy, [{
        key: 'init',
        value: function init(selectorsData, dateFormat, dateFormatForFile, reportAuthorizationInfo, reportParamsStringBuilderConstructor) {
            var ugrEnabled = selectorsData.enabledFeatures ? selectorsData.enabledFeatures.hasOwnProperty(_features.Feature.UGR) : null;
            var tzgEnabled = selectorsData.enabledFeatures ? selectorsData.enabledFeatures.hasOwnProperty(_features.Feature.TZG) : null;
            this.parametersFormatter = new _ChartPDFParametersFormatter2.default().init({
                selectorsData: selectorsData,
                dateFormat: dateFormat,
                ugrEnabled: ugrEnabled,
                tzgEnabled: tzgEnabled,
                reportAuthorizationInfo: reportAuthorizationInfo,
                reportParamsStringBuilderConstructor: reportParamsStringBuilderConstructor
            });

            this.dateParametersFormattingStrategy = this.createDateParametersFormattingStrategy(dateFormat, dateFormatForFile);

            return this;
        }
    }, {
        key: 'createDateParametersFormattingStrategy',
        value: function createDateParametersFormattingStrategy(dateFormat, dateFormatForFile) {
            // abstract
        }
    }, {
        key: 'formatChartPDFFilterInformation',
        value: function formatChartPDFFilterInformation(selectedParameters) {
            // abstract
        }
    }, {
        key: 'formatChartPDFHeaderTitle',
        value: function formatChartPDFHeaderTitle(selectedParameters) {
            return _messageResource2.default.getMessage('report.chart_pdf.header_label', [this.parametersFormatter.formatChartTypeValue(selectedParameters.chartTypeValue), this.parametersFormatter.formatGroupingLevelValue(selectedParameters.groupingLevelValue)]);
        }
    }, {
        key: 'getTableHeaders',
        value: function getTableHeaders(selectedParameters) {
            return {
                category: this.parametersFormatter.getChartCategoryName(selectedParameters.groupingLevelValue),
                total: _messageResource2.default.getMessage('report.chart_pdf.table_header.total'),
                user: _messageResource2.default.getMessage('report.chart_pdf.table_header.me'),
                team: _messageResource2.default.getMessage('report.chart_pdf.table_header.my_team'),
                notAssigned: _messageResource2.default.getMessage('report.chart_pdf.table_header.not_assigned_users')
            };
        }
    }, {
        key: 'formatChartPDFHeaderDateInformation',
        value: function formatChartPDFHeaderDateInformation(selectedParameters) {
            return this.dateParametersFormattingStrategy.formatDateInformation(selectedParameters.dateParameters);
        }
    }, {
        key: 'formatGrandTotalDescription',
        value: function formatGrandTotalDescription(selectedParameters) {
            return {
                label: _messageResource2.default.getMessage('report.chart_pdf.grand_total_label', [this.parametersFormatter.formatGrandTotalValueType(selectedParameters.chartTypeValue)]),
                postfix: this.parametersFormatter.formatGrandTotalPostfix(selectedParameters.chartTypeValue)
            };
        }
    }, {
        key: 'formatChartPDFFileName',
        value: function formatChartPDFFileName(selectedParameters) {
            var fileNameParts = [];
            fileNameParts.push(this._capitalizeFirstLetterInWords(this.parametersFormatter.formatChartTypeValue(selectedParameters.chartTypeValue))); //show..
            fileNameParts.push(this._capitalizeFirstLetterInWords(this.parametersFormatter.formatGroupingLevelValue(selectedParameters.groupingLevelValue))); //by..
            fileNameParts.push(this.dateParametersFormattingStrategy.formatDateForFileName(selectedParameters.dateParameters)); //date range
            return _messageResource2.default.getMessage('report.chart_pdf.file_name', fileNameParts);
        }
    }, {
        key: '_capitalizeFirstLetterInWords',
        value: function _capitalizeFirstLetterInWords(string) {
            var replacer = function replacer(str, p1, p2, offset, s) {
                return p1 ? p1.toUpperCase() : p2.toUpperCase();
            };
            return string.replace(/(\s\w)|(^\w)/g, replacer);
        }
    }]);

    return ChartPDFParametersFormattingStrategy;
}();

exports.default = ChartPDFParametersFormattingStrategy;

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ParametersFormatter = function () {
    function ParametersFormatter() {
        _classCallCheck(this, ParametersFormatter);
    }

    _createClass(ParametersFormatter, [{
        key: "init",
        value: function init(_ref) {
            var selectorsData = _ref.selectorsData,
                dateFormat = _ref.dateFormat,
                ugrFeatureEnabled = _ref.ugrFeatureEnabled,
                tzgFeatureEnabled = _ref.tzgFeatureEnabled,
                reportAuthorizationInfo = _ref.reportAuthorizationInfo,
                reportParamsStringBuilderConstructor = _ref.reportParamsStringBuilderConstructor;

            this.reportParamsStringBuilder = new reportParamsStringBuilderConstructor({
                data: {
                    users: selectorsData.users,
                    userGroupsFeatureEnabled: ugrFeatureEnabled,
                    tzGroupsFeatureEnabled: tzgFeatureEnabled,
                    userGroups: selectorsData.userGroups,
                    timeZoneGroups: selectorsData.timeZoneGroups,
                    cpList: selectorsData.customersProjects,
                    leaveTypesMap: selectorsData.leaveTypesMap,
                    statuses: selectorsData.statuses,
                    manageableUserIds: selectorsData.manageableUserIds,
                    projectsWithMaIds: selectorsData.projectsWithMaIds
                },
                dateFormat: dateFormat,
                reportAuthorizationInfo: reportAuthorizationInfo
            });
            return this;
        }
    }, {
        key: "formatUsersSelection",
        value: function formatUsersSelection(userSelection, assignedInfo) {
            return this.reportParamsStringBuilder.getUserSelectionParamString(userSelection, assignedInfo);
        }
    }, {
        key: "formatOvertimeUsersSelection",
        value: function formatOvertimeUsersSelection(userSelection) {
            return this.reportParamsStringBuilder.getUserSelectionParamString(userSelection);
        }
    }, {
        key: "formatCustomersAndProjectsSelection",
        value: function formatCustomersAndProjectsSelection(cpSelection) {
            return this.reportParamsStringBuilder.getCPSelectionParamString(cpSelection);
        }
    }, {
        key: "formatLeaveTypesSelection",
        value: function formatLeaveTypesSelection(leaveTypeSelection) {
            return this.reportParamsStringBuilder.getLeaveTypeSelectionParamString(leaveTypeSelection);
        }
    }, {
        key: "formatStatusesSelection",
        value: function formatStatusesSelection(statuses) {
            return this.reportParamsStringBuilder.getStatusesSelectionParamString(statuses);
        }
    }]);

    return ParametersFormatter;
}();

exports.default = ParametersFormatter;

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ChartPDFDateFormattingStrategy = __webpack_require__(804);

var _ChartPDFDateFormattingStrategy2 = _interopRequireDefault(_ChartPDFDateFormattingStrategy);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _DateRangeFormattingStrategy = __webpack_require__(165);

var _DateRangeFormattingStrategy2 = _interopRequireDefault(_DateRangeFormattingStrategy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ChartPDFDateRangeFormattingStrategy = function (_ChartPDFDateFormatti) {
    _inherits(ChartPDFDateRangeFormattingStrategy, _ChartPDFDateFormatti);

    function ChartPDFDateRangeFormattingStrategy(dateFormat, dateFormatForFileName) {
        _classCallCheck(this, ChartPDFDateRangeFormattingStrategy);

        var _this = _possibleConstructorReturn(this, (ChartPDFDateRangeFormattingStrategy.__proto__ || Object.getPrototypeOf(ChartPDFDateRangeFormattingStrategy)).call(this, dateFormat, dateFormatForFileName));

        _this.previewDateFormatStrategy = new _DateRangeFormattingStrategy2.default(dateFormat); // for use methods from lightbox preview header formatter
        return _this;
    }

    _createClass(ChartPDFDateRangeFormattingStrategy, [{
        key: 'formatDateInformation',
        value: function formatDateInformation(dateParameters) {
            return this.previewDateFormatStrategy.formatForDateInformation(dateParameters) + " " + this.previewDateFormatStrategy.formatSpecifyingInformation(dateParameters);
        }
    }, {
        key: 'formatDateForFileName',
        value: function formatDateForFileName(dateParameters) {
            var dateRangeSelection = dateParameters.dateRangeSelection;
            return _messageResource2.default.getMessage('common.pdf.formatting.file_name_date_range_template', [this.formatFileNameDate(dateRangeSelection.fromDate), this.formatFileNameDate(dateRangeSelection.toDate)]);
        }
    }]);

    return ChartPDFDateRangeFormattingStrategy;
}(_ChartPDFDateFormattingStrategy2.default);

exports.default = ChartPDFDateRangeFormattingStrategy;

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var BaseParametersFormattingStrategy = function () {
    function BaseParametersFormattingStrategy() {
        _classCallCheck(this, BaseParametersFormattingStrategy);
    }

    _createClass(BaseParametersFormattingStrategy, [{
        key: "init",
        value: function init(config) {
            this.parametersFormatter = this.createParametersFormatter(config);
            this.dateParametersFormattingStrategy = this.createDateParametersFormattingStrategy(config);

            return this;
        }
    }, {
        key: "createParametersFormatter",
        value: function createParametersFormatter(config) {
            // abstract
        }
    }, {
        key: "createDateParametersFormattingStrategy",
        value: function createDateParametersFormattingStrategy(config) {
            // abstract
        }
    }, {
        key: "formatMainPartOfLightboxTitle",
        value: function formatMainPartOfLightboxTitle(selectedParameters) {
            // abstract
        }
    }, {
        key: "formatParametersText",
        value: function formatParametersText(selectedParameters) {
            // abstract
        }
    }, {
        key: "formatSpecifyingPartOfLightboxTitle",
        value: function formatSpecifyingPartOfLightboxTitle(selectedParameters) {
            return this.dateParametersFormattingStrategy.formatSpecifyingInformation(selectedParameters.dateParameters);
        }
    }]);

    return BaseParametersFormattingStrategy;
}();

exports.default = BaseParametersFormattingStrategy;

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isPanelOpenedFromUrl = exports.getOpenCustomerName = exports.getIsOpenCustomerAssigned = exports.isShowNewCommentInput = exports.getCustomerNewComment = exports.getNewCommentsTexts = exports.getUpdatingCommentId = exports.isSendingComment = exports.isCommentsLoading = exports.getEditingCommentText = exports.getEditingCommentId = exports.getCommentsScrollTo = exports.getNewestCommentId = exports.isNewCommentsOnTop = exports.needMoreComments = exports.getRecentlyAddedCommentsIds = exports.getAllCommentsUserIds = exports.getCommentsCount = exports.getUsers = exports.getComments = exports.canManage = exports.isCommentsReadOnly = exports.isAllProjectsAssigned = exports.getOpenCustomerId = undefined;

var _reselect = __webpack_require__(13);

var _selectorsGenerator = __webpack_require__(485);

var _selectorsGenerator2 = _interopRequireDefault(_selectorsGenerator);

var _selectors = __webpack_require__(14);

var _selectors2 = __webpack_require__(27);

var _utils = __webpack_require__(242);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getCustomerPanelState = function getCustomerPanelState(state) {
    return state.panels.customer;
};

var getOpenCustomerId = exports.getOpenCustomerId = function getOpenCustomerId(state) {
    return getCustomerPanelState(state).openCustomerId;
};
var isAllProjectsAssigned = exports.isAllProjectsAssigned = function isAllProjectsAssigned(state) {
    return getCustomerPanelState(state).allProjectsAssigned;
};
var isCommentsReadOnly = exports.isCommentsReadOnly = function isCommentsReadOnly(state) {
    return !isAllProjectsAssigned(state);
};
var canManage = exports.canManage = function canManage(state) {
    return getCustomerPanelState(state).canManage;
};

var commentsSelector = (0, _selectorsGenerator2.default)(getCustomerPanelState);

var getComments = exports.getComments = commentsSelector.getComments;
var getUsers = exports.getUsers = commentsSelector.getUsers;
var getCommentsCount = exports.getCommentsCount = commentsSelector.getCommentsCount;
var getAllCommentsUserIds = exports.getAllCommentsUserIds = commentsSelector.getAllCommentsUserIds;
var getRecentlyAddedCommentsIds = exports.getRecentlyAddedCommentsIds = commentsSelector.getRecentlyAddedCommentsIds;
var needMoreComments = exports.needMoreComments = commentsSelector.needMoreComments;
var isNewCommentsOnTop = exports.isNewCommentsOnTop = commentsSelector.isNewCommentsOnTop;
var getNewestCommentId = exports.getNewestCommentId = commentsSelector.getNewestCommentId;
var getCommentsScrollTo = exports.getCommentsScrollTo = commentsSelector.getCommentsScrollTo;
var getEditingCommentId = exports.getEditingCommentId = commentsSelector.getEditingCommentId;
var getEditingCommentText = exports.getEditingCommentText = commentsSelector.getEditingCommentText;
var isCommentsLoading = exports.isCommentsLoading = commentsSelector.isLoading;
var isSendingComment = exports.isSendingComment = commentsSelector.isSendingComment;
var getUpdatingCommentId = exports.getUpdatingCommentId = commentsSelector.getUpdatingCommentId;
var getNewCommentsTexts = exports.getNewCommentsTexts = commentsSelector.getNewCommentsTexts;

var getCustomerNewComment = exports.getCustomerNewComment = (0, _reselect.createSelector)(getOpenCustomerId, commentsSelector.getNewCommentsTexts, function (taskId, comments) {
    return comments[taskId] ? comments[taskId] : '';
});

var isShowNewCommentInput = exports.isShowNewCommentInput = (0, _reselect.createSelector)(commentsSelector.isShowNewCommentInput, getOpenCustomerId, commentsSelector.getNewCommentsTexts, function (showInput, customerId, comments) {
    return showInput || comments[customerId] !== undefined;
});

var getOpenCustomer = (0, _reselect.createSelector)(getOpenCustomerId, _selectors.getCustomers, function (id, customers) {
    return customers[id] ? customers[id] : null;
});

var getIsOpenCustomerAssigned = exports.getIsOpenCustomerAssigned = (0, _reselect.createSelector)(_selectors2.getViewerSettings, getOpenCustomerId, _selectors2.getCustomersManagementAssignments, function (viewerSettings, customerId, customerMA) {
    return viewerSettings.hasAccessToAllManagementScope ? true : (0, _utils.isCustomerAssignedForManage)(customerMA, customerId);
});

var getOpenCustomerName = exports.getOpenCustomerName = (0, _reselect.createSelector)(getOpenCustomer, function (customer) {
    return customer ? customer.name : '';
});

var isPanelOpenedFromUrl = exports.isPanelOpenedFromUrl = (0, _reselect.createSelector)(getCustomerPanelState, function (panelState) {
    return panelState.openedFromUrl;
});

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _TableCell = __webpack_require__(166);

var _TableCell2 = _interopRequireDefault(_TableCell);

var _TableCellRenderer = __webpack_require__(63);

var _TableCellRenderer2 = _interopRequireDefault(_TableCellRenderer);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function TableRow(rowEl) {
    this.cells = [];
    this.rowEl = rowEl ? rowEl : document.createElement("tr");
    this.table = null;
    this.rowIdx = -1;
}

TableRow.prototype = _underscore2.default.create(Object.prototype, {
    setRowIdx: function setRowIdx(rowIdx) {
        this.rowIdx = rowIdx;
    },

    getRowIdx: function getRowIdx() {
        return this.rowIdx;
    },

    createCellObj: function createCellObj(value) {
        return new _TableCell2.default(value, this);
    },

    createCellObjAndAdd: function createCellObjAndAdd(value) {
        var cellObj = this.createCellObj(value);
        this.addCellObj(cellObj);
        return cellObj;
    },

    addCell: function addCell(value) {
        var cellObj = this.createCellObjAndAdd(value);
        cellObj.setupMouseHandlers();
    },

    addCellObj: function addCellObj(cellObj) {
        cellObj.setRow(this);
        cellObj.setColIdx(this.cells.length);
        this.cells.push(cellObj);
        this.getRowEl().appendChild(cellObj.getCellEl());

        if (cellObj.colspan) (0, _jquery2.default)(cellObj.getCellEl()).attr('colspan', cellObj.colspan);
    },

    setTable: function setTable(table) {
        this.table = table;
    },

    getTable: function getTable() {
        return this.table;
    },

    getRowEl: function getRowEl() {
        return this.rowEl;
    },

    getCells: function getCells() {
        return this.cells;
    },

    getCell: function getCell(colIdx) {
        return this.cells[colIdx];
    },

    getLastCell: function getLastCell() {
        return this.cells[this.cells.length - 1];
    },

    hasCell: function hasCell(colIdx) {
        return this.cells.length > colIdx;
    },

    writeCellsContent: function writeCellsContent() {
        for (var i = 0; i < this.cells.length; i++) {
            var cell = this.cells[i];
            cell.setRenderer(this.createCellRenderer(cell));
            cell.writeContent();
        }
    },

    showHide: function showHide(isShow) {
        this.getRowEl().style.display = isShow ? "" : "none";
    },

    updateUI: function updateUI() {},

    createCellRenderer: function createCellRenderer(cell) {
        return new _TableCellRenderer2.default();
    },

    updateCellUI: function updateCellUI(colIdx) {
        this.getCell(colIdx).updateUI();
    },

    buildDOM: function buildDOM(parentEl) {
        parentEl.appendChild(this.getRowEl());
    },

    accept: function accept(visitor, cell) {
        if (visitor.visitOtherRow) visitor.visitOtherRow(cell);
    },

    isLast: function isLast() {
        return this.rowIdx == this.table.getRows().length - 1;
    },

    getRowClasses: function getRowClasses() {
        return [];
    }
});

exports.default = TableRow;

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _CommentsNumberCounter = __webpack_require__(1519);

var _CommentsNumberCounter2 = _interopRequireDefault(_CommentsNumberCounter);

var _View2 = __webpack_require__(20);

var _View3 = _interopRequireDefault(_View2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CommentsNumberContainer = function (_View) {
    _inherits(CommentsNumberContainer, _View);

    function CommentsNumberContainer() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            _ref$onClick = _ref.onClick,
            onClick = _ref$onClick === undefined ? function () {} : _ref$onClick;

        _classCallCheck(this, CommentsNumberContainer);

        var _this = _possibleConstructorReturn(this, (CommentsNumberContainer.__proto__ || Object.getPrototypeOf(CommentsNumberContainer)).call(this));

        _this.commentsCounter = new _CommentsNumberCounter2.default({
            onClick: onClick
        });

        _this.state = {
            commentsNumber: 0
        };

        _this.onStatePropertyChanged('commentsNumber', function (number) {
            _this.commentsCounter.setState(_this.state);
            _this.commentsCounter.toggle(number !== 0);
        });
        return _this;
    }

    _createClass(CommentsNumberContainer, [{
        key: 'afterRender',
        value: function afterRender() {
            this.commentsCounter = this.commentsCounter.init(this.$containerEl);

            this.renderInitialState();
        }
    }]);

    return CommentsNumberContainer;
}(_View3.default);

exports.default = CommentsNumberContainer;

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var LockTableMouseEventsHandlerState = function () {
    function LockTableMouseEventsHandlerState(mouseEventsHandler) {
        _classCallCheck(this, LockTableMouseEventsHandlerState);

        this.mouseEventsHandler = mouseEventsHandler;
    }

    _createClass(LockTableMouseEventsHandlerState, [{
        key: "mouseDown",
        value: function mouseDown(evt, cell) {}
    }, {
        key: "mouseUp",
        value: function mouseUp(evt, cell) {}
    }, {
        key: "mouseMove",
        value: function mouseMove(evt, cell) {}
    }, {
        key: "mouseOver",
        value: function mouseOver(evt, cell) {
            this.lastHoveredCell = cell;
        }
    }, {
        key: "mouseOut",
        value: function mouseOut(evt, cell) {
            this.lastHoveredCell = null;
        }
    }]);

    return LockTableMouseEventsHandlerState;
}();

exports.default = LockTableMouseEventsHandlerState;

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var BalanceType = exports.BalanceType = {
    PTO: window.__GENERATED_CONSTANTS__.BalanceType.PTO,
    SICK: window.__GENERATED_CONSTANTS__.BalanceType.SICK
};

exports.default = BalanceType;

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.pickLoggedInUserInfo = exports.EXCEPTIONS = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _utils = __webpack_require__(311);

var EXCEPTIONS = exports.EXCEPTIONS = {
    EditUserConfirmationIsNeededException: "com.actimind.common.administration.EditUserConfirmationIsNeededException",
    DeleteUserConfirmationIsNeededException: "com.actimind.common.administration.DeleteUserConfirmationIsNeededException",
    UserIsLockedException: "com.actimind.actitime.administration.UserIsLockedException",
    UserEmailInvalidException: "com.actimind.common.services.UserEmailInvalidException",
    NoSuchUserException: "com.actimind.actitime.administration.NoSuchUserException",
    NoRightsToManageAccountSettings: "com.actimind.actitime.services.NoRightsToManageAccountSettings",
    DuplicateTimeZone: "com.actimind.actitime.administration.DuplicateTimeZoneGroupNameException",
    DuplicateEffectiveDatesInUserSchedulesException: "com.actimind.actitime.services.DuplicateEffectiveDatesInUserSchedulesException",
    DuplicateEffectiveDatesInUserRatesException: "com.actimind.actitime.services.DuplicateEffectiveDatesInUserRatesException",
    AccountDisabledDueToThisProductLicenseException: "com.actimind.common.administration.AccountDisabledDueToThisProductLicenseException",
    AccountDisabledDueToOtherProductLicenseException: "com.actimind.common.administration.AccountDisabledDueToOtherProductLicenseException",
    AccountDisabledDueToBothProductsLicenseException: "com.actimind.common.administration.AccountDisabledDueToBothProductsLicenseException",
    LeavesOrTTBeforeNewHireDateException: "com.actimind.common.services.LeavesOrTTBeforeNewHireDateException",
    NoSuchUserGroupException: "com.actimind.actitime.administration.NoSuchUserGroupException",
    SelectedUserDeletedException: "com.actimind.actitime.administration.SelectedUserDeletedException",
    UserExistsException: "com.actimind.actitime.administration.UserExistsException",
    UserIsLastLicensesManagerException: "com.actimind.common.administration.UserIsLastLicensesManagerException"
};

var pickLoggedInUserInfo = exports.pickLoggedInUserInfo = function pickLoggedInUserInfo(fullUserInfo) {
    return _extends({}, _.pick(fullUserInfo, ['firstName', 'lastName', 'middleInitial', 'username', 'email', 'userGroupId', 'timeZoneGroupId', 'pto', 'sick', 'accessRights']), {
        accessRights: (0, _utils.convertUserAccessRightsDataFromRpc)(fullUserInfo)
    });
};

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.selectUserPanel = undefined;

var _reselect = __webpack_require__(13);

var _selector = __webpack_require__(1633);

var selectUserPanel = exports.selectUserPanel = (0, _reselect.createSelector)(_selector.selectPanels, function (panels) {
    return panels.user;
});

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.onNoSuchUserException = exports.onDeleteUser = exports.onUpdateUserData = undefined;

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var onUpdateUserData = exports.onUpdateUserData = function onUpdateUserData(data) {
    (0, _jquery2.default)(document).trigger('editUserPanel_updateUserData', [data]);
};

var onDeleteUser = exports.onDeleteUser = function onDeleteUser(data) {
    (0, _jquery2.default)(document).trigger('editUserPanel_deleteUserSucceeded', [data]);
};

var onNoSuchUserException = exports.onNoSuchUserException = function onNoSuchUserException(userId) {
    (0, _jquery2.default)(document).trigger('editUserPanel_noSuchUserException', [userId]);
};

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isUpdating = exports.getLastEditedUserRate = exports.getErrors = exports.getUserManagementDataForUserRates = exports.getOvertimeLevel = exports.getUserRates = undefined;

var _reselect = __webpack_require__(13);

var _selectors = __webpack_require__(64);

var _selector = __webpack_require__(255);

var _selectors2 = __webpack_require__(53);

var getUserRatesSectionState = (0, _reselect.createSelector)(_selector.selectUserPanel, function (userPanel) {
    return userPanel.userRates;
});

var getUserRates = exports.getUserRates = (0, _reselect.createSelector)(_selectors.getFullUserInfo, function (userInfo) {
    return userInfo.rates ? userInfo.rates : [];
});

var getOvertimeLevel = exports.getOvertimeLevel = (0, _reselect.createSelector)(_selectors.getFullUserInfo, function (userInfo) {
    return userInfo.overtimeLevel;
});

var getUserManagementDataForUserRates = exports.getUserManagementDataForUserRates = (0, _reselect.createSelector)(_selectors2.getUserManagementData, function (userManagementData) {
    return {
        defaultWorkSchedule: userManagementData.defaultWorkSchedule,
        currentDate: userManagementData.todayInViewerTimeZone,
        weekStartDay: userManagementData.weekStartDay,
        invertedDaysMap: userManagementData.defaultWorkSchedule,
        activeLeaveTypes: userManagementData.activeLeaveTypes,
        overtimeRateCoefficient: userManagementData.overtimeRateCoefficient
    };
});

var getErrors = exports.getErrors = (0, _reselect.createSelector)(getUserRatesSectionState, function (userRates) {
    return userRates.errors;
});

var getLastEditedUserRate = exports.getLastEditedUserRate = (0, _reselect.createSelector)(getUserRatesSectionState, function (userRates) {
    return userRates.lastEditedUserRate;
});

var isUpdating = exports.isUpdating = (0, _reselect.createSelector)(getUserRatesSectionState, function (userRates) {
    return userRates.updating;
});

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.clearTasksSearchText = exports.changeTasksSearchText = exports.clearProjectsSearchText = exports.changeProjectsSearchText = exports.clearCustomersSearchText = exports.changeCustomersSearchText = exports.changeAllExistingAndFutureTasksAssignment = exports.changeAllExistingAndFutureProjectsAssignment = exports.changeOnlyActive = exports.changeAllTasksAssignments = exports.changeAllProjectsAssignments = exports.changeAllCustomersAssignments = exports.changeTaskAssignment = exports.changeProjectAssignment = exports.changeCustomerAssignment = exports.updateWorkAssignmentsCounters = exports.loadMoreTasks = exports.loadMoreProjects = exports.loadMoreCustomers = exports.loadMoreEntities = exports.deselectProject = exports.deselectCustomer = exports.selectProject = exports.selectCustomer = exports.closeEditor = exports.openEditor = undefined;

var _actionTypes = __webpack_require__(693);

var ActionTypes = _interopRequireWildcard(_actionTypes);

var _utils = __webpack_require__(6);

var _rpcCalls = __webpack_require__(24);

var _selectors = __webpack_require__(552);

var _actions = __webpack_require__(29);

var EntitiesActions = _interopRequireWildcard(_actions);

var _actionsGenerator = __webpack_require__(553);

var _actionsGenerator2 = _interopRequireDefault(_actionsGenerator);

var _actions2 = __webpack_require__(147);

var _actions3 = __webpack_require__(207);

var AssignmentsPanelActions = _interopRequireWildcard(_actions3);

var _selectors2 = __webpack_require__(204);

var _actions4 = __webpack_require__(167);

var _syncCallbacks = __webpack_require__(256);

var SyncCallbacks = _interopRequireWildcard(_syncCallbacks);

var _utils2 = __webpack_require__(393);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _selectors3 = __webpack_require__(14);

var _actions5 = __webpack_require__(56);

var _selectors4 = __webpack_require__(15);

var _constants = __webpack_require__(201);

var _util = __webpack_require__(254);

var _actions6 = __webpack_require__(50);

var _utils3 = __webpack_require__(202);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var hierarchyAssignmentsEditorActions = (0, _actionsGenerator2.default)({
    actionTypes: ActionTypes
});

var LOAD_LIMIT = 20;

var openEditor = exports.openEditor = function openEditor() {
    return function (dispatch, getState) {
        var userId = (0, _selectors2.getUserId)(getState());
        if (userId !== null) {
            dispatch(hierarchyAssignmentsEditorActions.openEditor(userId));
        }
    };
};

var closeEditor = exports.closeEditor = hierarchyAssignmentsEditorActions.closeEditor;

var selectCustomer = exports.selectCustomer = hierarchyAssignmentsEditorActions.selectCustomer;

var selectProject = exports.selectProject = hierarchyAssignmentsEditorActions.selectProject;

var deselectCustomer = exports.deselectCustomer = hierarchyAssignmentsEditorActions.deselectCustomer;

var deselectProject = exports.deselectProject = hierarchyAssignmentsEditorActions.deselectProject;

var loadMoreEntities = exports.loadMoreEntities = function loadMoreEntities() {
    return function (dispatch) {
        dispatch(loadMoreCustomers());
        dispatch(loadMoreProjects());
        dispatch(loadMoreTasks());
    };
};

var loadMoreCustomers = exports.loadMoreCustomers = function loadMoreCustomers() {
    return function (dispatch, getState) {
        var state = getState();
        if ((0, _selectors.needMoreCustomers)(state)) {
            var userId = (0, _selectors.getEditingUserId)(state);
            var onlyActive = (0, _selectors.showOnlyActiveEntities)(state);
            var searchText = (0, _selectors.getCustomersSearchText)(state);
            var offset = (0, _selectors.getCustomerIdsOrder)(state).length;

            dispatch((0, _utils.createActionObject)(ActionTypes.LOAD_CUSTOMER_ASSIGNMENTS_EDITOR_DATA));
            (0, _rpcCalls.rpcCall)('UserManagementService.getCustomerManagementAssignmentsEditorData', [userId, onlyActive, searchText, offset, LOAD_LIMIT], function (rpcError) {
                return (0, _utils3.handleCommonExceptions)(rpcError);
            }).then(function (data) {
                dispatch(EntitiesActions.addCustomers(data['customers'].map(function (c) {
                    return c['customer'];
                })));
                dispatch(hierarchyAssignmentsEditorActions.loadCustomersSuccess(data, LOAD_LIMIT));
            }).catch(function (error) {
                dispatch((0, _actions6.handleCommonError)(userId, error));
                dispatch(hierarchyAssignmentsEditorActions.loadCustomersFailure(error));
            });
        }
    };
};

var loadMoreProjects = exports.loadMoreProjects = function loadMoreProjects() {
    return function (dispatch, getState) {
        var state = getState();
        if ((0, _selectors.needMoreProjects)(state)) {
            var userId = (0, _selectors.getEditingUserId)(state);
            var customerId = (0, _selectors.getEditingLevel)(state).customerId;
            var onlyActive = (0, _selectors.showOnlyActiveEntities)(state);
            var searchText = (0, _selectors.getProjectsSearchText)(state);
            var offset = (0, _selectors.getProjectIdsOrder)(state).length;

            dispatch((0, _utils.createActionObject)(ActionTypes.LOAD_PROJECT_ASSIGNMENTS_EDITOR_DATA));
            (0, _rpcCalls.rpcCall)('UserManagementService.getProjectManagementAssignmentsEditorData', [userId, customerId, onlyActive, searchText, offset, LOAD_LIMIT], function (rpcError) {
                return (0, _utils3.handleCommonExceptions)(rpcError);
            }).then(function (data) {
                dispatch(EntitiesActions.addProjects(data['projects'].map(function (p) {
                    return p['project'];
                })));
                dispatch(hierarchyAssignmentsEditorActions.loadProjectsSuccess(data, LOAD_LIMIT));
            }).catch(function (error) {
                dispatch((0, _actions6.handleCommonError)(userId, error));
                dispatch(hierarchyAssignmentsEditorActions.loadProjectsFailure(error));
            });
        }
    };
};

var loadMoreTasks = exports.loadMoreTasks = function loadMoreTasks() {
    return function (dispatch, getState) {
        var state = getState();
        if ((0, _selectors.needMoreTasks)(state)) {
            var userId = (0, _selectors.getEditingUserId)(state);
            var projectId = (0, _selectors.getEditingLevel)(state).projectId;
            var onlyOpen = (0, _selectors.showOnlyActiveEntities)(state);
            var searchText = (0, _selectors.getTasksSearchText)(state);
            var offset = (0, _selectors.getTaskIdsOrder)(state).length;

            dispatch((0, _utils.createActionObject)(ActionTypes.LOAD_TASK_ASSIGNMENTS_EDITOR_DATA));
            (0, _rpcCalls.rpcCall)('UserManagementService.getTaskManagementAssignmentsEditorData', [userId, projectId, onlyOpen, searchText, offset, LOAD_LIMIT], function (rpcError) {
                return (0, _utils3.handleCommonExceptions)(rpcError);
            }).then(function (data) {
                dispatch(EntitiesActions.addTasks(data['tasks'].map(function (t) {
                    return t['task'];
                })));
                dispatch(hierarchyAssignmentsEditorActions.loadTasksSuccess(data, LOAD_LIMIT));
            }).catch(function (error) {
                dispatch((0, _actions6.handleCommonError)(userId, error));
                hierarchyAssignmentsEditorActions.loadTasksFailure(error);
            });
        }
    };
};

var updateManagementAssignmentsTabCounters = function updateManagementAssignmentsTabCounters(userManagementResult) {
    return function (dispatch) {
        var cptCounters = userManagementResult['additionalResultData']['map']['managementAssignmentsCounters'];
        if (cptCounters) {
            dispatch((0, _actions2.managementAssignmentsCountsLoadSuccess)(cptCounters));
        }
    };
};

var updateWorkAssignmentsCounters = exports.updateWorkAssignmentsCounters = function updateWorkAssignmentsCounters(userManagementResult) {
    return function (dispatch) {
        var userId = userManagementResult['userInfo']['id'];
        var workAssignmentsCounters = userManagementResult['additionalResultData']['map']['workAssignmentsCounters'];
        if (workAssignmentsCounters) {
            dispatch((0, _actions4.setWorkAssignmentsCountersForUser)(userId, workAssignmentsCounters));
        }
        dispatch((0, _actions.addUser)(userManagementResult['userInfo']));
    };
};

var updateCounters = function updateCounters(userManagementResult) {
    return function (dispatch) {
        dispatch(updateManagementAssignmentsTabCounters(userManagementResult));
        dispatch(updateWorkAssignmentsCounters(userManagementResult));
    };
};

var changeCustomerAssignment = exports.changeCustomerAssignment = function changeCustomerAssignment(customerId, assigned) {
    return function (dispatch, getState) {
        var state = getState();
        var userId = (0, _selectors.getEditingUserId)(state);
        var isWAFeatureEnabled = (0, _selectors4.isWASEnabled)(state);

        dispatch((0, _utils.createActionObject)(ActionTypes.CHANGE_CUSTOMER_ASSIGNMENT, {
            customerId: customerId,
            assigned: assigned
        }));

        var addedCustomerIds = assigned ? [customerId] : [];
        var removedCustomerIds = assigned ? [] : [customerId];
        (0, _rpcCalls.rpcCall)('UserManagementService.changeUserCustomerManageAssignments', [userId, addedCustomerIds, removedCustomerIds, true], function (rpcError) {
            return (0, _utils3.handleCommonExceptions)(rpcError);
        }).then(function (data) {
            if ((0, _utils2.hasConcurrentlyRemovedEntities)(data)) {
                dispatch(handleConcurrentlyRemovedEntities(data));
            } else {
                var _data$additionalResul = data.additionalResultData.map[_constants.AdditionalDataConstants.ALL_ASSIGNED_INFO],
                    someAssigned = _data$additionalResul.someAssigned,
                    allAssigned = _data$additionalResul.allAssigned;

                dispatch(hierarchyAssignmentsEditorActions.changeCustomerAssignmentSuccess(customerId, assigned, assigned, someAssigned, allAssigned));
                if (!assigned) {
                    dispatch(hierarchyAssignmentsEditorActions.clearCustomersTasksCount([customerId]));
                    dispatch(hierarchyAssignmentsEditorActions.clearCustomersProjectsCount([customerId]));
                }
            }
            SyncCallbacks.onUpdateUserData(data);
            dispatch(updateCounters(data));
            dispatch(AssignmentsPanelActions.clearTabsLoaded());

            if (!assigned && isWAFeatureEnabled) {
                var name = (0, _selectors3.getCustomer)(getState(), customerId).name;
                dispatch((0, _actions5.toast)(_messageResource2.default.getMessage('user_list.toasts.revoke_manage_customer_from_user', [name])));
            }
        }).catch(function (error) {
            dispatch((0, _actions6.handleCommonError)(userId, error));
            dispatch(hierarchyAssignmentsEditorActions.changeCustomerAssignmentFailure(customerId, assigned, error));
        });
    };
};

var changeProjectAssignment = exports.changeProjectAssignment = function changeProjectAssignment(projectId, assigned) {
    return function (dispatch, getState) {
        var state = getState();
        var userId = (0, _selectors.getEditingUserId)(state);
        var customerId = (0, _selectors.getEditingLevel)(state).customerId;
        var isWAFeatureEnabled = (0, _selectors4.isWASEnabled)(getState());

        dispatch((0, _utils.createActionObject)(ActionTypes.CHANGE_PROJECT_ASSIGNMENT, {
            projectId: projectId,
            assigned: assigned
        }));

        var addedProjectIds = assigned ? [projectId] : [];
        var removedProjectIds = assigned ? [] : [projectId];
        (0, _rpcCalls.rpcCall)('UserManagementService.changeUserProjectManageAssignments', [userId, addedProjectIds, removedProjectIds, true, customerId], function (rpcError) {
            return (0, _utils3.handleCommonExceptions)(rpcError);
        }).then(function (data) {
            if ((0, _utils2.hasConcurrentlyRemovedEntities)(data)) {
                dispatch(handleConcurrentlyRemovedEntities(data));
            } else {
                var _data$additionalResul2 = data.additionalResultData.map[_constants.AdditionalDataConstants.ALL_ASSIGNED_INFO],
                    someAssigned = _data$additionalResul2.someAssigned,
                    allAssigned = _data$additionalResul2.allAssigned;

                dispatch(hierarchyAssignmentsEditorActions.changeProjectAssignmentSuccess(projectId, assigned, assigned, someAssigned, allAssigned));
                if (!assigned) dispatch(hierarchyAssignmentsEditorActions.clearProjectsTasksCount([projectId]));
            }
            SyncCallbacks.onUpdateUserData(data);
            dispatch(updateCounters(data));
            dispatch(AssignmentsPanelActions.clearTabsLoaded());

            if (!assigned && isWAFeatureEnabled) {
                var name = (0, _selectors3.getProject)(getState(), projectId).name;
                dispatch((0, _actions5.toast)(_messageResource2.default.getMessage('user_list.toasts.revoke_manage_project_from_user', [name])));
            }
        }).catch(function (error) {
            dispatch((0, _actions6.handleCommonError)(userId, error));
            dispatch(hierarchyAssignmentsEditorActions.changeProjectAssignmentFailure(projectId, assigned, error));
        });
    };
};

var changeTaskAssignment = exports.changeTaskAssignment = function changeTaskAssignment(taskId, assigned) {
    return function (dispatch, getState) {
        var state = getState();
        var userId = (0, _selectors.getEditingUserId)(state);

        var _getEditingLevel = (0, _selectors.getEditingLevel)(state),
            customerId = _getEditingLevel.customerId,
            projectId = _getEditingLevel.projectId;

        var isWAFeatureEnabled = (0, _selectors4.isWASEnabled)(state);

        dispatch((0, _utils.createActionObject)(ActionTypes.CHANGE_TASK_ASSIGNMENT, {
            taskId: taskId,
            assigned: assigned
        }));

        var addedTaskIds = assigned ? [taskId] : [];
        var removedTaskIds = assigned ? [] : [taskId];
        (0, _rpcCalls.rpcCall)('UserManagementService.changeUserTaskManageAssignments', [userId, addedTaskIds, removedTaskIds, customerId, projectId], function (rpcError) {
            return (0, _utils3.handleCommonExceptions)(rpcError);
        }).then(function (data) {
            if ((0, _utils2.hasConcurrentlyRemovedEntities)(data)) {
                dispatch(handleConcurrentlyRemovedEntities(data));
            } else {
                var _data$additionalResul3 = data.additionalResultData.map[_constants.AdditionalDataConstants.ALL_ASSIGNED_INFO],
                    someAssigned = _data$additionalResul3.someAssigned,
                    allAssigned = _data$additionalResul3.allAssigned;

                dispatch(hierarchyAssignmentsEditorActions.changeTaskAssignmentSuccess(taskId, assigned, assigned, someAssigned, allAssigned));
            }
            SyncCallbacks.onUpdateUserData(data);
            dispatch(updateCounters(data));
            dispatch(AssignmentsPanelActions.clearTabsLoaded());

            if (!assigned && isWAFeatureEnabled) {
                var name = (0, _selectors3.getTask)(getState(), taskId).name;
                dispatch((0, _actions5.toast)(_messageResource2.default.getMessage('user_list.toasts.revoke_manage_task_from_user', [name])));
            }
        }).catch(function (error) {
            dispatch((0, _actions6.handleCommonError)(userId, error));
            dispatch(hierarchyAssignmentsEditorActions.changeTaskAssignmentFailure(taskId, assigned, error));
        });
    };
};

var handleConcurrentlyRemovedEntities = function handleConcurrentlyRemovedEntities(data, assignAll) {
    return function (dispatch) {
        dispatch((0, _utils2.handleConcurrentlyRemovedEntitiesAction)({
            getEditingLevel: _selectors.getEditingLevel,
            hierarchyAssignmentsEditorActions: hierarchyAssignmentsEditorActions
        })(data, assignAll));
    };
};

var changeAllCustomersAssignments = exports.changeAllCustomersAssignments = function changeAllCustomersAssignments(assigned) {
    return function (dispatch, getState) {
        var state = getState();
        var userId = (0, _selectors.getEditingUserId)(state);
        var isWAFeatureEnabled = (0, _selectors4.isWASEnabled)(state);

        dispatch((0, _utils.createActionObject)(ActionTypes.CHANGE_ALL_ASSIGNMENTS));

        (0, _rpcCalls.rpcCall)('UserManagementService.changeAllCustomersManagementAssignments', [userId, assigned], function (rpcError) {
            return (0, _utils3.handleCommonExceptions)(rpcError);
        }).then(function (data) {
            if ((0, _utils2.hasConcurrentlyRemovedEntities)(data)) {
                dispatch(handleConcurrentlyRemovedEntities(data, true));
            }
            dispatch(hierarchyAssignmentsEditorActions.assignAllCustomersSuccess());
            SyncCallbacks.onUpdateUserData(data);
            dispatch(updateCounters(data));
            dispatch(AssignmentsPanelActions.clearTabsLoaded());

            if (!assigned && isWAFeatureEnabled) {
                dispatch((0, _actions5.toast)(_messageResource2.default.getMessage('user_list.toasts.revoke_all_customers.edit_management_scope')));
            }
        }).catch(function (error) {
            dispatch((0, _actions6.handleCommonError)(userId, error));
            dispatch((0, _utils.createActionObject)(ActionTypes.CHANGE_ALL_ASSIGNMENTS_FAILURE));
        });
    };
};

var changeAllProjectsAssignments = exports.changeAllProjectsAssignments = function changeAllProjectsAssignments(assigned) {
    return function (dispatch, getState) {
        var state = getState();
        var userId = (0, _selectors.getEditingUserId)(state);
        var customerId = (0, _selectors.getEditingLevel)(state).customerId;
        var isWAFeatureEnabled = (0, _selectors4.isWASEnabled)(state);

        dispatch((0, _utils.createActionObject)(ActionTypes.CHANGE_ALL_ASSIGNMENTS));

        (0, _rpcCalls.rpcCall)('UserManagementService.changeAllProjectsManagementAssignments', [userId, customerId, assigned], function (rpcError) {
            return (0, _utils3.handleCommonExceptions)(rpcError);
        }).then(function (data) {
            if ((0, _utils2.hasConcurrentlyRemovedEntities)(data)) {
                dispatch(handleConcurrentlyRemovedEntities(data, true));
            }
            dispatch(hierarchyAssignmentsEditorActions.assignAllProjectsSuccess());
            SyncCallbacks.onUpdateUserData(data);
            dispatch(updateCounters(data));
            dispatch(AssignmentsPanelActions.clearTabsLoaded());

            if (!assigned && isWAFeatureEnabled) {
                dispatch((0, _actions5.toast)(_messageResource2.default.getMessage('user_list.toasts.revoke_all_projects_from_customer.edit_management_scope')));
            }
        }).catch(function (error) {
            dispatch((0, _actions6.handleCommonError)(userId, error));
            dispatch((0, _utils.createActionObject)(ActionTypes.CHANGE_ALL_ASSIGNMENTS_FAILURE));
        });
    };
};

var changeAllTasksAssignments = exports.changeAllTasksAssignments = function changeAllTasksAssignments(assigned) {
    return function (dispatch, getState) {
        var state = getState();
        var userId = (0, _selectors.getEditingUserId)(state);

        var _getEditingLevel2 = (0, _selectors.getEditingLevel)(state),
            customerId = _getEditingLevel2.customerId,
            projectId = _getEditingLevel2.projectId;

        var isWAFeatureEnabled = (0, _selectors4.isWASEnabled)(state);

        dispatch((0, _utils.createActionObject)(ActionTypes.CHANGE_ALL_ASSIGNMENTS));

        (0, _rpcCalls.rpcCall)('UserManagementService.changeAllTasksManagementAssignments', [userId, customerId, projectId, assigned], function (rpcError) {
            return (0, _utils3.handleCommonExceptions)(rpcError);
        }).then(function (data) {
            if ((0, _utils2.hasConcurrentlyRemovedEntities)(data)) {
                dispatch(handleConcurrentlyRemovedEntities(data, true));
            }
            dispatch(hierarchyAssignmentsEditorActions.assignAllTasksSuccess());
            SyncCallbacks.onUpdateUserData(data);
            dispatch(updateCounters(data));
            dispatch(AssignmentsPanelActions.clearTabsLoaded());

            if (!assigned && isWAFeatureEnabled) {
                dispatch((0, _actions5.toast)(_messageResource2.default.getMessage('user_list.toasts.revoke_all_tasks_from_project.edit_management_scope')));
            }
        }).catch(function (error) {
            dispatch((0, _actions6.handleCommonError)(userId, error));
            dispatch((0, _utils.createActionObject)(ActionTypes.CHANGE_ALL_ASSIGNMENTS_FAILURE));
        });
    };
};

var changeOnlyActive = exports.changeOnlyActive = function changeOnlyActive(onlyActive) {
    return function (dispatch) {
        dispatch((0, _utils.createActionObject)(ActionTypes.ONLY_ACTIVE_ENTITIES_SET, onlyActive));
        dispatch(hierarchyAssignmentsEditorActions.clearAll());
        dispatch(hierarchyAssignmentsEditorActions.setCustomersLoaded(false));
        dispatch(hierarchyAssignmentsEditorActions.setProjectsLoaded(false));
        dispatch(hierarchyAssignmentsEditorActions.setTasksLoaded(false));
    };
};

var changeAllExistingAndFutureProjectsAssignment = exports.changeAllExistingAndFutureProjectsAssignment = function changeAllExistingAndFutureProjectsAssignment(futureProjectsAssigned) {
    return function (dispatch, getState) {
        var state = getState();
        var userId = (0, _selectors.getEditingUserId)(state);
        var customerId = (0, _selectors.getEditingLevel)(state).customerId;
        var isWAFeatureEnabled = (0, _selectors4.isWASEnabled)(state);

        var addedCustomerIds = futureProjectsAssigned ? [customerId] : [];
        var removedCustomerIds = futureProjectsAssigned ? [] : [customerId];

        (0, _rpcCalls.rpcCall)('UserManagementService.changeUserCustomerManageAssignments', [userId, addedCustomerIds, removedCustomerIds, false], function (rpcError) {
            return (0, _utils3.handleCommonExceptions)(rpcError);
        }).then(function (data) {
            if ((0, _utils2.hasConcurrentlyRemovedEntities)(data)) {
                dispatch(handleConcurrentlyRemovedEntities(data));
            } else {
                dispatch(hierarchyAssignmentsEditorActions.assignAllProjectsSuccess());
            }
            dispatch((0, _utils.createActionObject)(ActionTypes.ALL_EXISTING_AND_FUTURE_PROJECTS, futureProjectsAssigned));
            SyncCallbacks.onUpdateUserData(data);
            dispatch(updateCounters(data));
            dispatch(AssignmentsPanelActions.clearTabsLoaded());

            if (!futureProjectsAssigned && isWAFeatureEnabled) {
                var name = (0, _selectors3.getCustomer)(getState(), customerId).name;
                dispatch((0, _actions5.toast)(_messageResource2.default.getMessage('user_list.toasts.revoke_manage_customer_from_user', [name])));
            }
        }).catch(function (error) {
            dispatch((0, _actions6.handleCommonError)(userId, error));
            dispatch((0, _utils.createActionObject)(ActionTypes.CHANGE_ALL_ASSIGNMENTS_FAILURE));
        });
    };
};

var changeAllExistingAndFutureTasksAssignment = exports.changeAllExistingAndFutureTasksAssignment = function changeAllExistingAndFutureTasksAssignment(futureTasksAssigned) {
    return function (dispatch, getState) {
        var state = getState();
        var userId = (0, _selectors.getEditingUserId)(state);

        var _getEditingLevel3 = (0, _selectors.getEditingLevel)(state),
            customerId = _getEditingLevel3.customerId,
            projectId = _getEditingLevel3.projectId;

        var isWAFeatureEnabled = (0, _selectors4.isWASEnabled)(state);

        var addedProjectIds = futureTasksAssigned ? [projectId] : [];
        var removedProjectIds = futureTasksAssigned ? [] : [projectId];

        (0, _rpcCalls.rpcCall)('UserManagementService.changeUserProjectManageAssignments', [userId, addedProjectIds, removedProjectIds, false, customerId], function (rpcError) {
            return (0, _utils3.handleCommonExceptions)(rpcError);
        }).then(function (data) {
            if ((0, _utils2.hasConcurrentlyRemovedEntities)(data)) {
                dispatch(handleConcurrentlyRemovedEntities(data));
            } else {
                dispatch(hierarchyAssignmentsEditorActions.assignAllTasksSuccess());
            }
            dispatch((0, _utils.createActionObject)(ActionTypes.ALL_EXISTING_AND_FUTURE_TASKS, futureTasksAssigned));
            SyncCallbacks.onUpdateUserData(data);
            dispatch(updateCounters(data));
            dispatch(AssignmentsPanelActions.clearTabsLoaded());

            if (!futureTasksAssigned && isWAFeatureEnabled) {
                var name = (0, _selectors3.getProject)(getState(), projectId).name;
                dispatch((0, _actions5.toast)(_messageResource2.default.getMessage('user_list.toasts.revoke_manage_project_from_user', [name])));
            }
        }).catch(function (error) {
            dispatch((0, _actions6.handleCommonError)(userId, error));
            dispatch((0, _utils.createActionObject)(ActionTypes.CHANGE_ALL_ASSIGNMENTS_FAILURE));
        });
    };
};

var changeCustomersSearchText = exports.changeCustomersSearchText = hierarchyAssignmentsEditorActions.changeCustomersSearchText;
var clearCustomersSearchText = exports.clearCustomersSearchText = hierarchyAssignmentsEditorActions.clearCustomersSearchText;

var changeProjectsSearchText = exports.changeProjectsSearchText = hierarchyAssignmentsEditorActions.changeProjectsSearchText;
var clearProjectsSearchText = exports.clearProjectsSearchText = hierarchyAssignmentsEditorActions.clearProjectsSearchText;

var changeTasksSearchText = exports.changeTasksSearchText = hierarchyAssignmentsEditorActions.changeTasksSearchText;
var clearTasksSearchText = exports.clearTasksSearchText = hierarchyAssignmentsEditorActions.clearTasksSearchText;

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var Exceptions = exports.Exceptions = {
    NoSuchUserException: 'com.actimind.actitime.administration.NoSuchUserException',
    NoSuchCopyUserException: 'com.actimind.actitime.administration.SelectedUserDeletedException',
    NoRightsToManageAccountSettings: 'com.actimind.actitime.administration.NoSuchUserException',
    UserHasAccessToAllScopeException: 'com.actimind.actitime.services.UserHasAccessToAllScopeException'
};

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _atBrowserUtils = __webpack_require__(8);

var _atUtils = __webpack_require__(5);

var _user_time = __webpack_require__(30);

var _user_time2 = _interopRequireDefault(_user_time);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function WorkdayDurationsEditor() {}

WorkdayDurationsEditor.WEEK_LENGTH = 7;

WorkdayDurationsEditor.prototype.init = function (durations, weekStartDay, changesCallback, showHeader, invalidTooltipMessage, decimalSeparator, readOnly) {
    this.weekStartDay = weekStartDay;
    this.value = durations;
    this.headTrEl = null;
    this.changesCallback = changesCallback;
    this.showHeader = showHeader;
    this.invalidTooltipMessage = invalidTooltipMessage;
    this._decimalSeparator = decimalSeparator;
    this.readOnly = readOnly;
    var self = this;

    this.inputs = [];
    for (var j = 0; j < WorkdayDurationsEditor.WEEK_LENGTH; j++) {
        var input = document.createElement("input");
        input.type = "text";
        input.dayIdx = j;
        input.maxLength = 6;
        input.onblur = function () {
            self.onBlur(this, readOnly);
        };
        input.onfocus = function () {
            self.onFocus(this, readOnly);
        };
        input.onkeydown = function (e) {
            if ((0, _atBrowserUtils.isEscapePressed)(e) || (0, _atBrowserUtils.isEnterPressed)(e)) {
                this.blur();
                e.stopPropagation();
            }
        };

        this.inputs.push(input);
    }

    return this;
};

WorkdayDurationsEditor.prototype.setInvalidTooltipMessage = function (invalidTooltipMessage) {
    this.invalidTooltipMessage = invalidTooltipMessage;
    for (var i = 0; i < this.inputs.length; i++) {
        if (this.inputs[i].title) this.inputs[i].title = invalidTooltipMessage;
    }
};

WorkdayDurationsEditor.prototype.setWeekStartDay = function (weekStartDay) {
    this.weekStartDay = weekStartDay;
};

WorkdayDurationsEditor.buildHeader = function (weekStartDay) {
    var headerEl = document.createElement("tHead");
    headerEl.className = "wdEditorHeader";

    var headerTr = document.createElement("tr");
    headerEl.appendChild(headerTr);

    weekStartDay--;
    for (var j = 0; j < WorkdayDurationsEditor.WEEK_LENGTH; j++) {
        var th = document.createElement("th");
        th.innerHTML = Date.dayNamesShort[weekStartDay];
        headerTr.appendChild(th);
        weekStartDay++;
        if (weekStartDay == 7) weekStartDay = 0;
    }

    return headerEl;
};

WorkdayDurationsEditor.buildTableHeader = function (weekStartDay) {
    var tHead = document.createElement("thead");
    var tr = document.createElement("tr");
    tHead.appendChild(tr);
    tr.appendChild(document.createElement("th"));

    var daysTable = document.createElement("table");
    daysTable.cellPadding = 0;
    daysTable.cellSpacing = 0;
    daysTable.appendChild(this.buildHeader(weekStartDay));
    var th = document.createElement("th");
    th.appendChild(daysTable);
    tr.appendChild(th);

    tr.appendChild(document.createElement("th"));
    tr.appendChild(document.createElement("th"));

    th = document.createElement("th");
    th.className = "last";
    tr.appendChild(th);

    return tHead;
};

WorkdayDurationsEditor.prototype.renderTo = function (containerEl) {
    var tableEl = document.createElement("table");
    var tBodyEl = document.createElement("tbody");

    var bodyTrEl = document.createElement("tr");

    if (this.showHeader) {
        var tHeadEl = WorkdayDurationsEditor.buildHeader(this.weekStartDay);
        this.headTrEl = tHeadEl.firstChild;
        tableEl.appendChild(tHeadEl);
    }

    tableEl.appendChild(tBodyEl);
    tBodyEl.appendChild(bodyTrEl);

    tableEl.cellPadding = 0;
    tableEl.cellSpacing = 0;
    tableEl.className = this.getTableClassName();

    var inputOffset = this.weekStartDay - 1;

    for (var i = 0; i < WorkdayDurationsEditor.WEEK_LENGTH; i++) {
        var bodyTdEl = document.createElement("td");
        var cellInput = this.inputs[inputOffset];
        cellInput.cellIdx = i;
        bodyTdEl.appendChild(cellInput);
        bodyTrEl.appendChild(bodyTdEl);
        inputOffset = inputOffset == 6 ? 0 : inputOffset + 1;
    }

    this.updateUI();

    containerEl.appendChild(tableEl);
};

WorkdayDurationsEditor.prototype.getTableClassName = function () {
    return "wdEditor";
};

WorkdayDurationsEditor.prototype.addBorderClasses = function (td, className) {
    (0, _jquery2.default)(td).addClass(className);
    var nextTd = td.nextSibling;
    if (nextTd) (0, _jquery2.default)(nextTd).addClass(className + "Left");
};

WorkdayDurationsEditor.prototype.removeBorderClasses = function (td, className) {
    (0, _jquery2.default)(td).removeClass(className);
    var nextTd = td.nextSibling;
    if (nextTd) (0, _jquery2.default)(nextTd).removeClass(className + "Left");
};

WorkdayDurationsEditor.prototype.onFocus = function (input, readOnly) {
    if (!readOnly) this.addBorderClasses(input.parentNode, "focus");
};

WorkdayDurationsEditor.prototype.onBlur = function (input, readOnly) {
    if (!readOnly) {
        input.value = (0, _atUtils.trim)(input.value);
        this.removeBorderClasses(input.parentNode, "focus");
        this.updateValueFromInput(input);
    }
};

WorkdayDurationsEditor.prototype.updateValueFromInput = function (input) {
    var value = input.value.length == 0 ? 0 : _user_time2.default.parseTimeWithSystemSettings(input.value, false, this._decimalSeparator);
    value = value < 0 ? null : value;
    var valueChanged = this.value[input.dayIdx] != value;
    this.value[input.dayIdx] = value;
    this.updateUIForCell(input.dayIdx);
    if (input.parentNode.nextSibling) this.updateUIForCell(input.parentNode.nextSibling.firstChild.dayIdx);
    if (this.changesCallback && valueChanged) this.changesCallback(input.dayIdx, value, this.value);
};

WorkdayDurationsEditor.prototype.getDurations = function () {
    return this.value;
};

WorkdayDurationsEditor.prototype.hasErrors = function () {
    for (var i = 0; i < WorkdayDurationsEditor.WEEK_LENGTH; i++) {
        if (this.value[i] == null) return true;
    }return false;
};

WorkdayDurationsEditor.prototype.setDurations = function (durations) {
    this.value = durations;
};

WorkdayDurationsEditor.prototype.updateUI = function () {
    for (var i = 0; i < WorkdayDurationsEditor.WEEK_LENGTH; i++) {
        this.updateUIForCell(i);
    }
};

WorkdayDurationsEditor.prototype.updateUIForCell = function (dayIdx) {
    var value = this.value[dayIdx];
    var input = this.inputs[dayIdx];
    var td = input.parentNode;
    var classes = [];

    if (!td.previousSibling) classes.push("first");

    if (!td.nextSibling) classes.push("last");

    if (value != null) {
        input.value = _user_time2.default.formatTimeWithoutMinutesIfPossible(value);
        input.defaultValue = input.value;
        input.removeAttribute("title");
        if (value == 0) classes.push("nonWorking");
    } else {
        classes.push("error");
        if (this.invalidTooltipMessage) input.title = this.invalidTooltipMessage;
    }

    if (td.previousSibling && this.value[td.previousSibling.firstChild.dayIdx] == null) classes.push("errorLeft");

    if (this.readOnly) classes.push("readOnly");

    td.className = classes.length == 0 ? null : classes.join(" ");

    if (this.headTrEl) {
        var th = this.headTrEl.children[input.cellIdx];
        th.className = value == null ? "error" : null;
    }
};

WorkdayDurationsEditor.prototype.setInputDisabled = function (disabled) {
    if (!this.inputs) return;
    // ie9 has bug so we have to disable text selection on parent element (see bug #45351)
    for (var i = 0; i < this.inputs.length; i++) {
        this.inputs[i].disabled = disabled;
        var input = (0, _jquery2.default)(this.inputs[i]);
        if (disabled) {
            input.addClass("disabled");
            (0, _atBrowserUtils.disableTextSelection)(this.inputs[i]);
            (0, _atBrowserUtils.disableTextSelection)(input.parent().get(0));
        } else {
            input.removeClass("disabled");
            (0, _atBrowserUtils.enableTextSelectionBack)(this.inputs[i]);
            (0, _atBrowserUtils.enableTextSelectionBack)(input.parent().get(0));
        }
    }
};

WorkdayDurationsEditor.sumDurations = function (durations) {
    var sum = 0;
    for (var i = 0; i < durations.length; i++) {
        sum += durations[i];
    }return sum;
};

WorkdayDurationsEditor.prototype.getInputs = function () {
    return this.inputs;
};

exports.default = WorkdayDurationsEditor;

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.HIERARCHY_LEVEL_CLASSES = undefined;

var _HIERARCHY_LEVEL_CLAS;

var _constants = __webpack_require__(4);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var HIERARCHY_LEVEL_CLASSES = exports.HIERARCHY_LEVEL_CLASSES = (_HIERARCHY_LEVEL_CLAS = {}, _defineProperty(_HIERARCHY_LEVEL_CLAS, _constants.HierarchyLevels.CUSTOMER, "hierarchyClass_customer"), _defineProperty(_HIERARCHY_LEVEL_CLAS, _constants.HierarchyLevels.PROJECT, "hierarchyClass_project"), _defineProperty(_HIERARCHY_LEVEL_CLAS, _constants.HierarchyLevels.TASK, "hierarchyClass_task"), _HIERARCHY_LEVEL_CLAS);

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.clearTasksSearchText = exports.changeTasksSearchText = exports.clearProjectsSearchText = exports.changeProjectsSearchText = exports.clearCustomersSearchText = exports.changeCustomersSearchText = exports.changeAllExistingAndFutureTasksAssignment = exports.changeAllExistingAndFutureProjectsAssignment = exports.changeOnlyActive = exports.changeAllTasksAssignments = exports.changeAllProjectsAssignments = exports.changeAllCustomersAssignments = exports.changeTaskAssignment = exports.changeProjectAssignment = exports.changeCustomerAssignment = exports.loadMoreTasks = exports.loadMoreProjects = exports.loadMoreCustomers = exports.loadMoreEntities = exports.deselectProject = exports.deselectCustomer = exports.selectProject = exports.selectCustomer = exports.closeEditor = exports.openEditor = exports.hierarchyAssignmentsEditorActions = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _actionTypes = __webpack_require__(686);

var ActionTypes = _interopRequireWildcard(_actionTypes);

var _utils = __webpack_require__(6);

var _rpcCalls = __webpack_require__(24);

var _selectors = __webpack_require__(398);

var _actions = __webpack_require__(148);

var CreatePanelActions = _interopRequireWildcard(_actions);

var _selectors2 = __webpack_require__(208);

var CreatePanelSelectors = _interopRequireWildcard(_selectors2);

var _actions2 = __webpack_require__(29);

var EntitiesActions = _interopRequireWildcard(_actions2);

var _actionsGenerator = __webpack_require__(553);

var _actionsGenerator2 = _interopRequireDefault(_actionsGenerator);

var _actions3 = __webpack_require__(147);

var _actions4 = __webpack_require__(319);

var AssignmentsPanelActions = _interopRequireWildcard(_actions4);

var _selectors3 = __webpack_require__(14);

var _atUtils = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var hierarchyAssignmentsEditorActions = exports.hierarchyAssignmentsEditorActions = (0, _actionsGenerator2.default)({
    actionTypes: ActionTypes
});

var LOAD_LIMIT = 20;

var openEditor = exports.openEditor = function openEditor() {
    return function (dispatch) {
        dispatch(hierarchyAssignmentsEditorActions.resetSearchState());
        dispatch(hierarchyAssignmentsEditorActions.clearAll());
        dispatch((0, _utils.createActionObject)(ActionTypes.SHOW_SET, true));
    };
};

var closeEditor = exports.closeEditor = function closeEditor() {
    return function (dispatch) {
        dispatch((0, _utils.createActionObject)(ActionTypes.SHOW_SET, false));
    };
};

var selectCustomer = exports.selectCustomer = hierarchyAssignmentsEditorActions.selectCustomer;

var selectProject = exports.selectProject = hierarchyAssignmentsEditorActions.selectProject;

var deselectCustomer = exports.deselectCustomer = hierarchyAssignmentsEditorActions.deselectCustomer;

var deselectProject = exports.deselectProject = hierarchyAssignmentsEditorActions.deselectProject;

var loadMoreEntities = exports.loadMoreEntities = function loadMoreEntities() {
    return function (dispatch) {
        dispatch(loadMoreCustomers());
        dispatch(loadMoreProjects());
        dispatch(loadMoreTasks());
    };
};

var loadMoreCustomers = exports.loadMoreCustomers = function loadMoreCustomers() {
    return function (dispatch, getState) {
        var state = getState();
        if ((0, _selectors.needMoreCustomers)(state)) {
            var assignedIds = CreatePanelSelectors.getManagementAssignmentsCptIds(state);
            var onlyActive = (0, _selectors.showOnlyActiveEntities)(state);
            var searchText = (0, _selectors.getCustomersSearchText)(state);
            var offset = (0, _selectors.getCustomerIdsOrder)(state).length;

            dispatch((0, _utils.createActionObject)(ActionTypes.LOAD_CUSTOMER_ASSIGNMENTS_EDITOR_DATA));
            (0, _rpcCalls.rpcCall)('UserManagementService.getCustomerManagementAssignmentsEditorDataForCreateUser', [assignedIds, onlyActive, searchText, offset, LOAD_LIMIT]).then(function (data) {
                var someCustomersOrLowerAssigned = assignedIds.customerIds.length > 0 || assignedIds.customerIdsExcludingSelf.length > 0 || assignedIds.projectIds.length > 0 || assignedIds.projectIdsExcludingSelf.length > 0 || assignedIds.taskIds.length > 0;
                data = _extends({}, data, {
                    someCustomersOrLowerAssigned: someCustomersOrLowerAssigned,
                    allCustomersAssigned: data.customersCount === assignedIds.customerIds.length && assignedIds.customerIds.length !== 0
                });
                dispatch(EntitiesActions.addCustomers(data['customers'].map(function (c) {
                    return c['customer'];
                })));
                dispatch(hierarchyAssignmentsEditorActions.loadCustomersSuccess(data, LOAD_LIMIT));
                dispatch(CreatePanelActions.setCustomersCount(data.customersCount));
            }).catch(function (error) {
                dispatch(closeEditor());
                dispatch(hierarchyAssignmentsEditorActions.loadCustomersFailure(error));
            });
        }
    };
};

var loadMoreProjects = exports.loadMoreProjects = function loadMoreProjects() {
    return function (dispatch, getState) {
        var state = getState();
        if ((0, _selectors.needMoreProjects)(state)) {
            var assignedIds = CreatePanelSelectors.getManagementAssignmentsCptIds(state);
            var customerId = (0, _selectors.getEditingLevel)(state).customerId;
            var onlyActive = (0, _selectors.showOnlyActiveEntities)(state);
            var searchText = (0, _selectors.getProjectsSearchText)(state);
            var offset = (0, _selectors.getProjectIdsOrder)(state).length;

            dispatch((0, _utils.createActionObject)(ActionTypes.LOAD_PROJECT_ASSIGNMENTS_EDITOR_DATA));
            (0, _rpcCalls.rpcCall)('UserManagementService.getProjectManagementAssignmentsEditorDataForCreateUser', [assignedIds, customerId, onlyActive, searchText, offset, LOAD_LIMIT]).then(function (data) {
                var projects = (0, _selectors3.getProjects)(getState());
                var tasks = (0, _selectors3.getTasks)(getState());

                var assignedProjectIdsInCurrentCustomer = [].concat(_toConsumableArray(assignedIds.projectIds), _toConsumableArray(assignedIds.projectIdsExcludingSelf)).filter(function (id) {
                    return projects[id].customerId === customerId;
                });

                var assignedTaskIdsInCurrentCustomer = assignedIds.taskIds.filter(function (id) {
                    return tasks[id].customerId === customerId;
                });

                var someProjectsOrLowerAssigned = assignedProjectIdsInCurrentCustomer.length > 0 || assignedTaskIdsInCurrentCustomer.length > 0;
                data = _extends({}, data, {
                    futureProjectsAssigned: assignedIds.customerIdsExcludingSelf.includes(customerId),
                    someProjectsOrLowerAssigned: someProjectsOrLowerAssigned,
                    allProjectsAssigned: data.projectsCount === assignedProjectIdsInCurrentCustomer.length && assignedProjectIdsInCurrentCustomer.length !== 0
                });
                dispatch(EntitiesActions.addProjects(data['projects'].map(function (p) {
                    return p['project'];
                })));
                dispatch(hierarchyAssignmentsEditorActions.loadProjectsSuccess(data, LOAD_LIMIT));
                dispatch(CreatePanelActions.setProjectsOfCustomerCount(data.projectsCount));
            }).catch(function (error) {
                dispatch(closeEditor());
                dispatch(hierarchyAssignmentsEditorActions.loadProjectsFailure(error));
            });
        }
    };
};

var loadMoreTasks = exports.loadMoreTasks = function loadMoreTasks() {
    return function (dispatch, getState) {
        var state = getState();
        if ((0, _selectors.needMoreTasks)(state)) {
            var assignedIds = CreatePanelSelectors.getManagementAssignmentsCptIds(state);
            var projectId = (0, _selectors.getEditingLevel)(state).projectId;
            var onlyOpen = (0, _selectors.showOnlyActiveEntities)(state);
            var searchText = (0, _selectors.getTasksSearchText)(state);
            var offset = (0, _selectors.getTaskIdsOrder)(state).length;

            dispatch((0, _utils.createActionObject)(ActionTypes.LOAD_TASK_ASSIGNMENTS_EDITOR_DATA));
            (0, _rpcCalls.rpcCall)('UserManagementService.getTaskManagementAssignmentsEditorDataForCreateUser', [assignedIds, projectId, onlyOpen, searchText, offset, LOAD_LIMIT]).then(function (data) {
                var tasks = (0, _selectors3.getTasks)(getState());
                var assignedTaskIdsInCurrentProject = assignedIds.taskIds.filter(function (id) {
                    return tasks[id].projectId === projectId;
                });
                data = _extends({}, data, {
                    futureTasksAssigned: assignedIds.projectIdsExcludingSelf.includes(projectId),
                    someTasksAssigned: data.tasksCount - assignedTaskIdsInCurrentProject.length > 0 && assignedTaskIdsInCurrentProject.length !== 0,
                    allTasksAssigned: data.tasksCount === assignedTaskIdsInCurrentProject.length && assignedTaskIdsInCurrentProject.length !== 0
                });
                dispatch(EntitiesActions.addTasks(data['tasks'].map(function (t) {
                    return t['task'];
                })));
                dispatch(hierarchyAssignmentsEditorActions.loadTasksSuccess(data, LOAD_LIMIT));
                dispatch(CreatePanelActions.setTasksOfProjectCount(data.tasksCount));
            }).catch(function (error) {
                dispatch(closeEditor());
                dispatch(hierarchyAssignmentsEditorActions.loadTasksFailure(error));
            });
        }
    };
};

var changeCustomerAssignment = exports.changeCustomerAssignment = function changeCustomerAssignment(customerId, assigned) {
    return function (dispatch, getState) {
        dispatch(CreatePanelActions.changeCustomerAssignments({
            addedIds: assigned ? [customerId] : [],
            removedIds: assigned ? [] : [customerId]
        }));

        var ma = CreatePanelSelectors.getManageAssignments(getState());

        dispatch((0, _utils.createActionObject)(ActionTypes.CHANGE_CUSTOMER_ASSIGNMENT_SUCCESS, {
            customerId: customerId,
            canWork: false,
            canManage: assigned,
            someAssigned: ma.customersCount - ma.addedCustomerIds.length > 0 && ma.addedCustomerIds.length !== 0,
            allAssigned: ma.customersCount === ma.addedCustomerIds.length && ma.addedCustomerIds.length !== 0
        }));

        if (!assigned) {
            dispatch(hierarchyAssignmentsEditorActions.clearCustomersTasksCount([customerId]));
            dispatch(hierarchyAssignmentsEditorActions.clearCustomersProjectsCount([customerId]));
        }

        dispatch((0, _actions3.setManagementAssignmentsCountsLoaded)(false));
        dispatch(AssignmentsPanelActions.clearTabsLoaded());
    };
};

var changeProjectAssignment = exports.changeProjectAssignment = function changeProjectAssignment(projectId, assigned) {
    return function (dispatch, getState) {
        dispatch(CreatePanelActions.changeProjectAssignments({
            addedIds: assigned ? [projectId] : [],
            removedIds: assigned ? [] : [projectId]
        }));

        var ma = CreatePanelSelectors.getManageAssignments(getState());

        dispatch((0, _utils.createActionObject)(ActionTypes.CHANGE_PROJECT_ASSIGNMENT_SUCCESS, {
            projectId: projectId,
            canWork: false,
            canManage: assigned,
            someAssigned: ma.projectsOfCustomerCount - ma.addedProjectIds.length > 0 && ma.addedProjectIds.length !== 0,
            allAssigned: ma.projectsOfCustomerCount === ma.addedProjectIds.length && ma.addedProjectIds.length !== 0
        }));

        if (!assigned) {
            dispatch(hierarchyAssignmentsEditorActions.clearProjectsTasksCount([projectId]));
        }

        dispatch((0, _utils.createActionObject)(ActionTypes.CLEAR_CUSTOMERS));
        dispatch((0, _actions3.setManagementAssignmentsCountsLoaded)(false));
        dispatch(AssignmentsPanelActions.clearTabsLoaded());
    };
};

var changeTaskAssignment = exports.changeTaskAssignment = function changeTaskAssignment(taskId, assigned) {
    return function (dispatch, getState) {
        dispatch(CreatePanelActions.changeTasksAssignments({
            addedIds: assigned ? [taskId] : [],
            removedIds: assigned ? [] : [taskId]
        }));

        var ma = CreatePanelSelectors.getManageAssignments(getState());

        dispatch((0, _utils.createActionObject)(ActionTypes.CHANGE_TASK_ASSIGNMENT_SUCCESS, {
            taskId: taskId,
            canWork: false,
            canManage: assigned,
            someAssigned: ma.tasksOfProjectCount - ma.addedTaskIds.length > 0 && ma.addedTaskIds.length !== 0,
            allAssigned: ma.tasksOfProjectCount === ma.addedTaskIds.length && ma.addedTaskIds.length !== 0
        }));

        dispatch((0, _utils.createActionObject)(ActionTypes.CLEAR_PROJECTS));
        dispatch((0, _utils.createActionObject)(ActionTypes.CLEAR_CUSTOMERS));
        dispatch((0, _actions3.setManagementAssignmentsCountsLoaded)(false));
        dispatch(AssignmentsPanelActions.clearTabsLoaded());
    };
};

var changeAllCustomersAssignments = exports.changeAllCustomersAssignments = function changeAllCustomersAssignments(assign) {
    return function (dispatch, getState) {
        var successHandler = function successHandler(customerIds) {
            var manageableCustomerIds = customerIds.reduce(function (map, cur) {
                map[cur] = assign;
                return map;
            }, {});
            dispatch((0, _utils.createActionObject)(ActionTypes.ASSIGN_ALL_CUSTOMERS_SUCCESS, {
                canManageCustomerIds: manageableCustomerIds,
                allCustomersAssigned: assign,
                someCustomersOrLowerAssigned: assign
            }));
            dispatch(CreatePanelActions.changeCustomerAssignments({
                addedIds: assign ? customerIds : [],
                removedIds: assign ? [] : customerIds
            }));

            dispatch((0, _actions3.setManagementAssignmentsCountsLoaded)(false));
            dispatch(AssignmentsPanelActions.clearTabsLoaded());
        };

        dispatch((0, _utils.createActionObject)(ActionTypes.ASSIGN_ALL_CUSTOMERS));

        if (assign) {
            (0, _rpcCalls.rpcCall)('UserManagementService.getExistingCustomerIdsForManagementAssignmentsEditor', []).then(function (customerIds) {
                return successHandler(customerIds);
            }).catch(function (error) {
                dispatch((0, _utils.createActionObject)(ActionTypes.ASSIGN_ALL_CUSTOMERS_FAILURE, {
                    error: error
                }));
            });
        } else {
            var customerIds = Object.keys((0, _selectors3.getCustomers)(getState()));
            successHandler(customerIds);
            dispatch(hierarchyAssignmentsEditorActions.clearCustomersTasksCount(customerIds));
            dispatch(hierarchyAssignmentsEditorActions.clearCustomersProjectsCount(customerIds));
        }
    };
};

var changeAllProjectsAssignments = exports.changeAllProjectsAssignments = function changeAllProjectsAssignments(assign) {
    return function (dispatch, getState) {
        var successHandler = function successHandler(projectIds) {
            var canManageProjectIds = projectIds.reduce(function (map, cur) {
                map[cur] = assign;
                return map;
            }, {});
            dispatch((0, _utils.createActionObject)(ActionTypes.ASSIGN_ALL_PROJECTS_SUCCESS, {
                canManageProjectIds: canManageProjectIds,
                allProjectsAssigned: assign,
                someProjectsOrLowerAssigned: assign
            }));
            dispatch(CreatePanelActions.changeProjectAssignments({
                addedIds: assign ? projectIds : [],
                removedIds: assign ? [] : projectIds
            }));

            dispatch((0, _utils.createActionObject)(ActionTypes.CLEAR_CUSTOMERS));
            dispatch((0, _actions3.setManagementAssignmentsCountsLoaded)(false));
            dispatch(AssignmentsPanelActions.clearTabsLoaded());
        };

        dispatch((0, _utils.createActionObject)(ActionTypes.ASSIGN_ALL_PROJECTS));
        var customerId = (0, _selectors.getEditingLevel)(getState()).customerId;

        if (assign) {
            (0, _rpcCalls.rpcCall)('UserManagementService.getProjectIdsOfCustomerForManagementAssignmentsEditor', [customerId]).then(function (projectIds) {
                return successHandler(projectIds);
            }).catch(function (error) {
                dispatch((0, _utils.createActionObject)(ActionTypes.ASSIGN_ALL_PROJECTS_FAILURE, { error: error }));
            });
        } else {
            var projectIds = Object.values((0, _selectors3.getProjects)(getState())).filter(function (project) {
                return project.customerId === customerId;
            }).map(function (p) {
                return p.id;
            });
            successHandler(projectIds);
            dispatch(hierarchyAssignmentsEditorActions.clearProjectsTasksCount(projectIds));
        }
    };
};

var changeAllTasksAssignments = exports.changeAllTasksAssignments = function changeAllTasksAssignments(assign) {
    return function (dispatch, getState) {
        var successHandler = function successHandler(taskIds) {
            var canManageTaskIds = taskIds.reduce(function (map, cur) {
                map[cur] = assign;
                return map;
            }, {});
            dispatch((0, _utils.createActionObject)(ActionTypes.ASSIGN_ALL_TASKS_SUCCESS, {
                canManageTaskIds: canManageTaskIds,
                allTasksAssigned: assign,
                someTasksAssigned: assign
            }));
            dispatch(CreatePanelActions.changeTasksAssignments({
                addedIds: assign ? taskIds : [],
                removedIds: assign ? [] : taskIds
            }));

            dispatch((0, _utils.createActionObject)(ActionTypes.CLEAR_PROJECTS));
            dispatch((0, _utils.createActionObject)(ActionTypes.CLEAR_CUSTOMERS));
            dispatch((0, _actions3.setManagementAssignmentsCountsLoaded)(false));
            dispatch(AssignmentsPanelActions.clearTabsLoaded());
        };

        dispatch((0, _utils.createActionObject)(ActionTypes.ASSIGN_ALL_TASKS));
        var projectId = (0, _selectors.getEditingLevel)(getState()).projectId;

        if (assign) {
            (0, _rpcCalls.rpcCall)('UserManagementService.getTaskIdsOfProjectForManagementAssignmentsEditor', [projectId]).then(function (taskIds) {
                return successHandler(taskIds);
            }).catch(function (error) {
                dispatch((0, _utils.createActionObject)(ActionTypes.ASSIGN_ALL_TASKS_FAILURE, {
                    error: error
                }));
            });
        } else {
            var taskIds = Object.values((0, _selectors3.getTasks)(getState())).filter(function (task) {
                return task.projectId === projectId;
            }).map(function (t) {
                return t.id;
            });
            successHandler(taskIds);
        }
    };
};

var changeOnlyActive = exports.changeOnlyActive = function changeOnlyActive(onlyActive) {
    return function (dispatch) {
        dispatch((0, _utils.createActionObject)(ActionTypes.ONLY_ACTIVE_ENTITIES_SET, onlyActive));
        dispatch((0, _utils.createActionObject)(ActionTypes.CLEAR_TASKS));
        dispatch((0, _utils.createActionObject)(ActionTypes.CLEAR_PROJECTS));
        dispatch((0, _utils.createActionObject)(ActionTypes.CLEAR_CUSTOMERS));
    };
};

var changeAllExistingAndFutureProjectsAssignment = exports.changeAllExistingAndFutureProjectsAssignment = function changeAllExistingAndFutureProjectsAssignment(futureProjectsAssigned) {
    return function (dispatch, getState) {
        var state = getState();
        var customerId = (0, _selectors.getEditingLevel)(state).customerId;

        var addedCustomerIds = futureProjectsAssigned ? [customerId] : [];
        var removedCustomerIds = futureProjectsAssigned ? [] : [customerId];
        var projectIds = Object.values((0, _selectors3.getProjects)(getState())).filter(function (project) {
            return project.customerId === customerId;
        }).map(function (p) {
            return p.id;
        });

        dispatch((0, _utils.createActionObject)(_actionTypes.LOAD_PROJECT_ASSIGNMENTS_EDITOR_DATA_SUCCESS, {
            canManageParentCustomer: false,
            projectIds: [],
            canWorkProjectIds: [],
            canManageProjectIds: futureProjectsAssigned ? projectIds : [],
            canManageProjectExcludeSelfIds: [],
            viewerCanManageProjectIds: [],
            taskCounts: {},
            futureProjectsAssigned: futureProjectsAssigned,
            someProjectsOrLowerAssigned: true,
            allProjectsAssigned: true
        }));

        dispatch(CreatePanelActions.changeProjectAssignments({
            addedIds: futureProjectsAssigned ? [] : projectIds,
            addedCustomerIds: addedCustomerIds,
            removedCustomerIds: removedCustomerIds
        }));

        dispatch((0, _utils.createActionObject)(ActionTypes.CLEAR_CUSTOMERS));
        dispatch((0, _actions3.setManagementAssignmentsCountsLoaded)(false));
        dispatch(AssignmentsPanelActions.clearTabsLoaded());
    };
};

var changeAllExistingAndFutureTasksAssignment = exports.changeAllExistingAndFutureTasksAssignment = function changeAllExistingAndFutureTasksAssignment(futureTasksAssigned) {
    return function (dispatch, getState) {

        var state = getState();
        var projectId = (0, _selectors.getEditingLevel)(state).projectId;

        var addedProjectIds = futureTasksAssigned ? [projectId] : [];
        var removedProjectIds = futureTasksAssigned ? [] : [projectId];

        var taskIds = Object.values((0, _selectors3.getTasks)(getState())).filter(function (task) {
            return task.projectId === projectId;
        }).map(function (t) {
            return t.id;
        });

        dispatch((0, _utils.createActionObject)(_actionTypes.LOAD_TASK_ASSIGNMENTS_EDITOR_DATA_SUCCESS, {
            canManageParentCustomer: false,
            canManageParentProject: false,
            taskIds: [],
            canWorkTaskIds: [],
            canManageTaskIds: futureTasksAssigned ? taskIds : [],
            futureTasksAssigned: futureTasksAssigned,
            someTasksAssigned: true,
            allTasksAssigned: true
        }));

        dispatch(CreatePanelActions.changeTasksAssignments({
            addedIds: futureTasksAssigned ? [] : taskIds,
            addedProjectIds: addedProjectIds,
            removedProjectIds: removedProjectIds
        }));

        dispatch((0, _utils.createActionObject)(ActionTypes.CLEAR_PROJECTS));
        dispatch((0, _utils.createActionObject)(ActionTypes.CLEAR_CUSTOMERS));
        dispatch((0, _actions3.setManagementAssignmentsCountsLoaded)(false));
        dispatch(AssignmentsPanelActions.clearTabsLoaded());
    };
};

var changeCustomersSearchText = exports.changeCustomersSearchText = hierarchyAssignmentsEditorActions.changeCustomersSearchText;
var clearCustomersSearchText = exports.clearCustomersSearchText = hierarchyAssignmentsEditorActions.clearCustomersSearchText;

var changeProjectsSearchText = exports.changeProjectsSearchText = hierarchyAssignmentsEditorActions.changeProjectsSearchText;
var clearProjectsSearchText = exports.clearProjectsSearchText = hierarchyAssignmentsEditorActions.clearProjectsSearchText;

var changeTasksSearchText = exports.changeTasksSearchText = hierarchyAssignmentsEditorActions.changeTasksSearchText;
var clearTasksSearchText = exports.clearTasksSearchText = hierarchyAssignmentsEditorActions.clearTasksSearchText;

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getImportedHolidayDatess = exports.getSorting = exports.isListTransformed = exports.getHolidays = exports.getPanelSelectedYear = exports.isShownRemoveAllConfirm = exports.isLoadingHolidayList = exports.isShownHolidayList = exports.getHolidayListPanelState = undefined;

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _reselect = __webpack_require__(13);

var _selectors = __webpack_require__(212);

var _date_format = __webpack_require__(16);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getHolidayListPanelState = exports.getHolidayListPanelState = function getHolidayListPanelState(state) {
    return state.workSchedule.holidayListPanel;
};

var isShownHolidayList = exports.isShownHolidayList = (0, _reselect.createSelector)(getHolidayListPanelState, function (holidayListPanel) {
    return holidayListPanel.isShow;
});

var isLoadingHolidayList = exports.isLoadingHolidayList = (0, _reselect.createSelector)(getHolidayListPanelState, function (holidayListPanel) {
    return holidayListPanel.loading;
});

var isShownRemoveAllConfirm = exports.isShownRemoveAllConfirm = (0, _reselect.createSelector)(getHolidayListPanelState, function (holidayListPanel) {
    return holidayListPanel.isShownRemoveAllConfirm;
});

var getPanelSelectedYear = exports.getPanelSelectedYear = (0, _reselect.createSelector)(getHolidayListPanelState, function (holidayListPanel) {
    return holidayListPanel.selectedYear;
});

var getHolidays = exports.getHolidays = (0, _reselect.createSelector)(_selectors.getCorporateDays, getPanelSelectedYear, function (corporateDaysByYears, year) {
    var corporateDaysByMonths = corporateDaysByYears[year];
    if (_underscore2.default.size(corporateDaysByMonths) === 0) return {};
    var holidays = {};
    Object.keys(corporateDaysByMonths).forEach(function (month) {
        var corporateDays = corporateDaysByMonths[month];
        Object.keys(corporateDays).filter(function (day) {
            return !corporateDays[day].working;
        }).forEach(function (day) {
            holidays[new _date_format.DateFormat("yyyy-MM-dd").formatDate(new Date(year, month, day))] = corporateDays[day];
        });
    });
    return holidays;
});

var isListTransformed = exports.isListTransformed = (0, _reselect.createSelector)(getHolidayListPanelState, function (holidayListPanel) {
    return holidayListPanel.isListTransformed;
});

var getSorting = exports.getSorting = (0, _reselect.createSelector)(getHolidayListPanelState, function (holidayListPanel) {
    return holidayListPanel.sorting;
});

var getImportedHolidayDatess = exports.getImportedHolidayDatess = (0, _reselect.createSelector)(getHolidayListPanelState, function (holidayListPanel) {
    return holidayListPanel.importedHolidayDates;
});

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DEFAULT_SHARED_WITH_USER_SELECTION = exports.DEFAULT_USER_SELECTION = exports.DEFAULT_LEAVE_TYPE_SELECTION = exports.DEFAULT_FEED_NAME_KEY = undefined;

var _GroupType = __webpack_require__(34);

var _GroupType2 = _interopRequireDefault(_GroupType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT_FEED_NAME_KEY = exports.DEFAULT_FEED_NAME_KEY = 'icalendar.page.lightbox.name.default';
var DEFAULT_LEAVE_TYPE_SELECTION = exports.DEFAULT_LEAVE_TYPE_SELECTION = {
    showArchived: false,
    qualifier: window.LeaveTypeSelectionQualifier.ALL,
    leaveTypes: []
};
var DEFAULT_USER_SELECTION = exports.DEFAULT_USER_SELECTION = {
    all: true,
    userIds: [],
    groupIds: [],
    groupType: _GroupType2.default.USER_GROUP
};

var DEFAULT_SHARED_WITH_USER_SELECTION = exports.DEFAULT_SHARED_WITH_USER_SELECTION = {
    all: false,
    userIds: [],
    groupIds: [],
    groupType: _GroupType2.default.USER_GROUP
};

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.saveFeedSettings = exports.exportICal = exports.openExportICalLightBox = exports.openCreateFeedLightBox = exports.openEditFeedLightBox = exports.closeICalLightBox = exports.setDateRangeSelection = exports.setSharedUserSelection = exports.setUserSelection = exports.setIncludeNotApproved = exports.setFeedLeaveTypeSelection = exports.setFeedName = undefined;

var _reduxActions = __webpack_require__(9);

var _actionTypes = __webpack_require__(580);

var ActionTypes = _interopRequireWildcard(_actionTypes);

var _selectors = __webpack_require__(266);

var _actions = __webpack_require__(214);

var _constants = __webpack_require__(51);

var _rpcCalls = __webpack_require__(24);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _date_format = __webpack_require__(16);

var _atUtils = __webpack_require__(5);

var _utils = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var setFeedName = exports.setFeedName = (0, _reduxActions.createAction)(ActionTypes.FEED_NAME_SET);
var setFeedLeaveTypeSelection = exports.setFeedLeaveTypeSelection = (0, _reduxActions.createAction)(ActionTypes.LEAVE_TYPE_SELECTION_SET);
var setIncludeNotApproved = exports.setIncludeNotApproved = (0, _reduxActions.createAction)(ActionTypes.INCLUDE_NOT_APPROVED_SET);
var setUserSelection = exports.setUserSelection = (0, _reduxActions.createAction)(ActionTypes.USER_SELECTION_SET);
var setSharedUserSelection = exports.setSharedUserSelection = (0, _reduxActions.createAction)(ActionTypes.SHARED_USER_SELECTION_SET);
var setDateRangeSelection = exports.setDateRangeSelection = (0, _reduxActions.createAction)(ActionTypes.DATE_RANGE_SELECITON_SET);
var closeICalLightBox = exports.closeICalLightBox = (0, _reduxActions.createAction)(ActionTypes.CLOSE_ICAL_LIGHTBOX);

var openEditFeedLightBox = exports.openEditFeedLightBox = function openEditFeedLightBox(id) {
    return function (dispatch) {
        dispatch((0, _utils.createActionObject)(ActionTypes.EDIT_FEED_LIGHTBOX_DATA_LOAD));
        (0, _rpcCalls.rpcCall)('ICalFeedSettingsService.getFeedSettingsInfo', [id], _actions.handleExceptions).then(function (result) {
            dispatch((0, _actions.setEntitiesByICalResult)(result.entitiesInfo));
            var feed = result.feedSettings[0];
            dispatch((0, _utils.createActionObject)(ActionTypes.EDIT_FEED_LIGHTBOX_DATA_LOAD_SUCCESS, feed));
        }).catch(function (error) {
            dispatch((0, _utils.createActionObject)(ActionTypes.EDIT_FEED_LIGHTBOX_DATA_LOAD_FAILURE));
            dispatch((0, _actions.handleError)(error));
        });
    };
};

var openCreateFeedLightBox = exports.openCreateFeedLightBox = function openCreateFeedLightBox() {
    return function (dispatch) {
        dispatch((0, _utils.createActionObject)(ActionTypes.CREATE_FEED_LIGHTBOX_DATA_LOAD));
        (0, _rpcCalls.rpcCall)('ICalFeedSettingsService.getEntitiesInfo', [], _actions.handleExceptions).then(function (result) {
            dispatch((0, _actions.setEntitiesByICalResult)(result));
            dispatch((0, _utils.createActionObject)(ActionTypes.CREATE_FEED_LIGHTBOX_DATA_LOAD_SUCCESS));
        }).catch(function (error) {
            dispatch((0, _utils.createActionObject)(ActionTypes.CREATE_FEED_LIGHTBOX_DATA_LOAD_FAILURE));
            dispatch((0, _actions.handleError)(error));
        });
    };
};

var openExportICalLightBox = exports.openExportICalLightBox = function openExportICalLightBox() {
    return function (dispatch) {
        dispatch((0, _utils.createActionObject)(ActionTypes.EXPORT_ICAL_LIGHTBOX_DATA_LOAD));
        (0, _rpcCalls.rpcCall)('ICalFeedSettingsService.getEntitiesInfo', [], _actions.handleExceptions).then(function (result) {
            dispatch((0, _actions.setEntitiesByICalResult)(result));
            dispatch((0, _utils.createActionObject)(ActionTypes.EXPORT_ICAL_LIGHTBOX_DATA_LOAD_SUCCESS));
        }).catch(function (error) {
            dispatch((0, _utils.createActionObject)(ActionTypes.EXPORT_ICAL_LIGHTBOX_DATA_LOAD_FAILURE));
            dispatch((0, _actions.handleError)(error));
        });
    };
};

var createFeed = function createFeed(dispatch, getState) {
    dispatch((0, _utils.createActionObject)(ActionTypes.CREATE_FEED_LOAD_DATA));
    (0, _rpcCalls.rpcCall)('ICalFeedSettingsService.createICalFeedSettings', getParamsForCreateOrEditFeed(getState()), _actions.handleExceptions).then(function (result) {
        dispatch((0, _utils.createActionObject)(ActionTypes.CREATE_FEED_LOAD_DATA_SUCCESS, result));
        dispatch((0, _actions.setRecentlyConfiguredFeedId)(result.id));
    }).catch(function (error) {
        dispatch((0, _utils.createActionObject)(ActionTypes.CREATE_FEED_LOAD_DATA_FAILURE));
        dispatch((0, _actions.handleError)(error));
    });
};

var editFeed = function editFeed(dispatch, getState) {
    dispatch((0, _utils.createActionObject)(ActionTypes.EDIT_FEED_LOAD_DATA));
    var state = getState();
    (0, _rpcCalls.rpcCall)('ICalFeedSettingsService.editICalFeedSettings', [(0, _selectors.getEditedFeedId)(state)].concat(getParamsForCreateOrEditFeed(state)), _actions.handleExceptions).then(function (result) {
        dispatch((0, _utils.createActionObject)(ActionTypes.EDIT_FEED_LOAD_DATA_SUCCESS, result));
        dispatch((0, _actions.setRecentlyConfiguredFeedId)(result.id));
    }).catch(function (error) {
        dispatch((0, _utils.createActionObject)(ActionTypes.EDIT_FEED_LOAD_DATA_FAILURE));
        dispatch((0, _actions.handleError)(error));
    });
};

var exportICal = exports.exportICal = function exportICal() {
    return function (dispatch, getState) {
        dispatch((0, _utils.createActionObject)(ActionTypes.EXPORT_ICAL_LOAD_DATA));
        var state = getState();
        var dateRangeSelection = (0, _selectors.getDateRangeSelection)(state);
        (0, _rpcCalls.rpcCall)('ICalFeedSettingsService.getLeaveScheduleICalendar', [(0, _selectors.getUserSelection)(state), (0, _selectors.getLeaveTypeSelectionForServer)(state), dateRangeSelection], _actions.handleExceptions).then(function (result) {
            var dateFormat = new _date_format.DateFormat('MMM dd, yyyy');
            var fileName = _messageResource2.default.getMessage('icalendar.page.export.file.name', [dateFormat.formatDate(dateRangeSelection.fromDate), dateFormat.formatDate(dateRangeSelection.toDate)]);
            (0, _atUtils.saveFile)(result, fileName, { type: 'text/calendar', encoding: 'UTF-8' });
            dispatch((0, _utils.createActionObject)(ActionTypes.EXPORT_ICAL_LOAD_DATA_SUCCESS));
        }).catch(function (error) {
            dispatch((0, _utils.createActionObject)(ActionTypes.EXPORT_ICAL_LOAD_DATA_FAILURE));
            dispatch((0, _actions.handleError)(error));
        });
    };
};

var saveFeedSettings = exports.saveFeedSettings = function saveFeedSettings() {
    return function (dispatch, getState) {
        var lightboxType = (0, _selectors.getLightBoxType)(getState());
        if (lightboxType === _constants.ICalLightboxType.CREATE) {
            dispatch(createFeed);
        } else if (lightboxType === _constants.ICalLightboxType.EDIT) {
            dispatch(editFeed);
        }
    };
};

var getParamsForCreateOrEditFeed = function getParamsForCreateOrEditFeed(state) {
    return [(0, _selectors.getFeedName)(state), (0, _selectors.getUserSelection)(state), (0, _selectors.getLeaveTypeSelectionForServer)(state), (0, _selectors.getSharedUserSelection)(state)];
};

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isLightBoxLoading = exports.isExportLightBoxDataChanged = exports.isEditLightBoxDataChanged = exports.isDateRangeSelectionValid = exports.isEditLightBoxShown = exports.isExportLightBoxShown = exports.getDateRangeSelection = exports.getLeaveTypeSelectionForServer = exports.isIncludesNotApproved = exports.getLeaveTypeSelection = exports.getSharedUserSelection = exports.getUserSelection = exports.isEditLightBoxSubmitEnabled = exports.getFeedName = exports.getEditedFeedId = exports.getLightBoxType = undefined;

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _index = __webpack_require__(13);

var _constants = __webpack_require__(51);

var _selectors = __webpack_require__(14);

var _atUtils = __webpack_require__(5);

var _constants2 = __webpack_require__(264);

var _selectors2 = __webpack_require__(128);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _utils = __webpack_require__(168);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getICalConfiguredFeedState = function getICalConfiguredFeedState(state) {
    return state.iCalendar.configuredFeed;
};

var getLightBoxType = exports.getLightBoxType = (0, _index.createSelector)(getICalConfiguredFeedState, function (state) {
    return state.lightboxType;
});

var getEditedFeedId = exports.getEditedFeedId = (0, _index.createSelector)(getICalConfiguredFeedState, function (state) {
    return state.editedFeedId;
});

var getFeedName = exports.getFeedName = (0, _index.createSelector)(getICalConfiguredFeedState, function (state) {
    return state.feedName;
});

var isEditLightBoxSubmitEnabled = exports.isEditLightBoxSubmitEnabled = (0, _index.createSelector)(getICalConfiguredFeedState, function (state) {
    return !!state.feedName;
});

var getUserSelection = exports.getUserSelection = (0, _index.createSelector)(getICalConfiguredFeedState, _selectors.getActiveUsersArray, function (state, users) {
    return state.userSelection ? (0, _atUtils.convertUsersFilterDependingOnFeatures)(state.userSelection, window.SystemSettings.apUGREnabled, window.SystemSettings.apTZGEnabled, users) : null;
});

var getSharedUserSelection = exports.getSharedUserSelection = (0, _index.createSelector)(getICalConfiguredFeedState, _selectors.getActiveUsersArray, function (state, users) {
    return state.sharedUserSelection ? (0, _atUtils.convertUsersFilterDependingOnFeatures)(state.sharedUserSelection, window.SystemSettings.apUGREnabled, window.SystemSettings.apTZGEnabled, users) : null;
});

var getLeaveTypeSelection = exports.getLeaveTypeSelection = (0, _index.createSelector)(getICalConfiguredFeedState, function (state) {
    return state.feedLeaveTypeSelection;
});

var isIncludesNotApproved = exports.isIncludesNotApproved = (0, _index.createSelector)(getICalConfiguredFeedState, function (state) {
    return state.includeNotApproved;
});

var getLeaveTypeSelectionForServer = exports.getLeaveTypeSelectionForServer = (0, _index.createSelector)(getLeaveTypeSelection, isIncludesNotApproved, function (leaveTypeSelection, includeNotApproved) {
    return {
        qualifier: leaveTypeSelection.qualifier,
        leaveTypes: leaveTypeSelection.leaveTypes,
        includeNotApproved: includeNotApproved
    };
});

var getDateRangeSelection = exports.getDateRangeSelection = (0, _index.createSelector)(getICalConfiguredFeedState, function (state) {
    return state.dateRangeSelection;
});

var isExportLightBoxShown = exports.isExportLightBoxShown = (0, _index.createSelector)(getICalConfiguredFeedState, function (state) {
    return state.lightboxType === _constants.ICalLightboxType.EXPORT;
});

var isEditLightBoxShown = exports.isEditLightBoxShown = (0, _index.createSelector)(getICalConfiguredFeedState, function (state) {
    return state.lightboxType === _constants.ICalLightboxType.CREATE || state.lightboxType === _constants.ICalLightboxType.EDIT;
});

var isDateRangeSelectionValid = exports.isDateRangeSelectionValid = (0, _index.createSelector)(getICalConfiguredFeedState, function (state) {
    return state.dateRangeValid;
});

var getEditedFeed = (0, _index.createSelector)(_selectors2.getAllFeedsMap, getEditedFeedId, function (allFeeds, feedId) {
    return allFeeds[feedId];
});

var isCreateFeedDataChanged = (0, _index.createSelector)(getLightBoxType, getFeedName, getUserSelection, getSharedUserSelection, getLeaveTypeSelection, isIncludesNotApproved, function (lightboxType, feedName, userSelection, sharedUserSelection, leaveTypeSelection, includeNotApproved) {
    return lightboxType == _constants.ICalLightboxType.CREATE && (feedName !== _messageResource2.default.getMessage(_constants2.DEFAULT_FEED_NAME_KEY) || userSelection !== _constants2.DEFAULT_USER_SELECTION || sharedUserSelection !== _constants2.DEFAULT_SHARED_WITH_USER_SELECTION || leaveTypeSelection !== _constants2.DEFAULT_LEAVE_TYPE_SELECTION || includeNotApproved);
});

var isEditFeedDataChanged = (0, _index.createSelector)(getLightBoxType, getFeedName, getUserSelection, getSharedUserSelection, getLeaveTypeSelection, isIncludesNotApproved, getEditedFeed, function (lightboxType, feedName, userSelection, sharedUserSelection, leaveTypeSelection, includeNotApproved, editedFeed) {
    return lightboxType === _constants.ICalLightboxType.EDIT && (feedName !== editedFeed.name || !_underscore2.default.isEqual(userSelection, editedFeed.usersFilter) || !_underscore2.default.isEqual(sharedUserSelection, editedFeed.sharedUsersFilter) || leaveTypeSelection.qualifier !== editedFeed.leaveTypesFilter.qualifier || !_underscore2.default.isEqual(leaveTypeSelection.leaveTypes, editedFeed.leaveTypesFilter.leaveTypes) || includeNotApproved !== editedFeed.leaveTypesFilter.includeNotApproved);
});

var isEditLightBoxDataChanged = exports.isEditLightBoxDataChanged = (0, _index.createSelector)(isCreateFeedDataChanged, isEditFeedDataChanged, function (createFeedDataChanged, editFeedDataChanged) {
    return createFeedDataChanged || editFeedDataChanged;
});

var isExportLightBoxDataChanged = exports.isExportLightBoxDataChanged = (0, _index.createSelector)(getLightBoxType, getUserSelection, getLeaveTypeSelection, isIncludesNotApproved, getDateRangeSelection, function (lightboxType, userSelection, leaveTypeSelection, includeNotApproved, dateRangeSelection) {
    return lightboxType === _constants.ICalLightboxType.EXPORT && (userSelection !== _constants2.DEFAULT_USER_SELECTION || leaveTypeSelection !== _constants2.DEFAULT_LEAVE_TYPE_SELECTION || includeNotApproved || dateRangeSelection !== (0, _utils.getDefaultDateRange)());
});

var isLightBoxLoading = exports.isLightBoxLoading = (0, _index.createSelector)(getICalConfiguredFeedState, function (state) {
    return state.lightboxLoading;
});

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var RowType = exports.RowType = {
    HEADER: 1,
    TOTALS: 2,
    FIRST_LEVEL: 3,
    SECOND_LEVEL: 4,
    THIRD_LEVEL: 5,
    FORTH_LEVEL: 6
};

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = OldReportMediator;

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _ReportMediator = __webpack_require__(321);

var _ReportMediator2 = _interopRequireDefault(_ReportMediator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Created by evdokimov on 26.05.2017.
 */
function OldReportMediator() {}

OldReportMediator.prototype = _underscore2.default.create(_ReportMediator2.default.prototype, {
    makeServiceParams: function makeServiceParams(reportParams) {
        return reportParams;
    },

    getDateRangeParameter: function getDateRangeParameter() {
        return this.dateRangeSelector.getSelectedRangeJSON();
    },

    setDateRangeParameter: function setDateRangeParameter(reportParameters) {
        this.dateRangeSelector.setSelectedRangeJSON(reportParameters);
    },

    _createPrintableDateRangeHeader: function _createPrintableDateRangeHeader() {
        return this.printableHeadersBuilder.addDateRangeHeaderString(this.reportParameters.dateRangeSelection);
    },

    // default date range selector. must be override in concrete child if necessary
    createDateRangeSelector: function createDateRangeSelector(reportParameters) {
        var dateRangeSelectorConfig = {
            dateRangeSelection: reportParameters.dateRangeSelection,
            menuStates: new DateRangeMenuItemsUtil().createDefaultDateRangeMenuItems(reportParameters.dateRangeSelection.qualifier),
            callOnChangeCallbackIfInvalid: true
        };

        return new DateRangeSelectorController().init(dateRangeSelectorConfig);
    }
});

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = BaseFormMediator;

var _constants = __webpack_require__(4);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _jquery_rpc = __webpack_require__(26);

var _jquery_rpc2 = _interopRequireDefault(_jquery_rpc);

var _utils = __webpack_require__(127);

var _indicateExportingOnButton = __webpack_require__(978);

var _indicateExportingOnButton2 = _interopRequireDefault(_indicateExportingOnButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function BaseFormMediator() {} /**
                                * @author evdokimov
                                */


BaseFormMediator.prototype.init = function (config) {
    var self = this;

    this.reportsPageLink = _constants.ReportConfigConstants.REPORTS_DASHBOARD_URL;

    this.container = (0, _jquery2.default)("#mainContainer");

    this.dateRangeSelector = this.createDateRangeSelector(config.reportParameters);
    this.dateRangeSelector.setOnChangeCallback(function () {
        self.changeParametersCallback();
    });

    ATReportsStore.setManageableUserIds(config.manageableUserIds);
    ATReportsStore.setProjectsWithMaIds(config.projectsWithMaIds);
    ATReportsStore.setReportAuthorizationInfo(config.reportAuthorizationInfo);

    this.configController = this.initEditConfigController(config);

    this.reportParamsStringBuilder = this.initParamsStringBuilder(config);

    this.reportPreviewPlaceholder = (0, _jquery2.default)("#reportPreviewPlaceholder");

    this.initButtons();
    this.initPreview();

    // global variable defined in messages.jsp
    if (window.hasServerSideErrors) this.validateAndUpdateUIIfInvalid();

    return this;
};

BaseFormMediator.prototype.initParamsStringBuilder = function (config) {
    //abstract
};

BaseFormMediator.prototype.initPreview = function () {
    this.lastSuccessfulPreviewParameters = this.collectReportParameters();
    this.initPreviewGeneratorsAndGeneratePreview();
};

BaseFormMediator.prototype.initPreviewGeneratorsAndGeneratePreview = function () {
    this.htmlPeviewGenerator = this.initHtmlGenerator();
    this.csvPeviewGenerator = this.initCsvGenerator();
    this.switchOnHTMLPreview();
};

BaseFormMediator.prototype.initCsvGenerator = function () {
    // abstract
};

BaseFormMediator.prototype.initHtmlGenerator = function () {
    // abstract
};

BaseFormMediator.prototype.initEditConfigController = function (config) {
    // abstract
};

BaseFormMediator.prototype.changeParametersCallback = function () {
    if (!this.configController || !this.validateAndUpdateUIIfInvalid()) return;

    var oldLastSuccessfulPreviewParameters = this.lastSuccessfulPreviewParameters;
    this.lastSuccessfulPreviewParameters = this.collectReportParameters();
    if (this.htmlPreviewChosen === false) this.lastSuccessfulPreviewParameters.timeFormat = oldLastSuccessfulPreviewParameters.timeFormat;

    this.updatePreview();
};

BaseFormMediator.prototype.validateAndUpdateUIIfInvalid = function () {
    var controllsValidateResult = this.configController.validate();
    var dateRangeValidateResult = !this.dateRangeSelector.hasErrors();
    if (!dateRangeValidateResult) {
        this.configController.setAdditionalError(this.dateRangeSelector.getErrorMessageKey());
    } else {
        this.configController.removeAdditionalError();
    }
    if (!controllsValidateResult || !dateRangeValidateResult) {
        this.configController.updateUI(true);
    }

    return dateRangeValidateResult && controllsValidateResult;
};

BaseFormMediator.prototype.validate = function () {
    var dateRangeValidateResult = !this.dateRangeSelector.hasErrors();
    var controllsValidateResult = this.configController.validate();

    return dateRangeValidateResult && controllsValidateResult;
};

// default date range selector. must be override in concrete child if necessary
BaseFormMediator.prototype.createDateRangeSelector = function (reportParameters) {
    var dateRangeSelectorConfig = {
        dateRangeSelection: reportParameters.dateRangeSelection,
        menuStates: new DateRangeMenuItemsUtil().createDefaultDateRangeMenuItems(reportParameters.dateRangeSelection.qualifier),
        shortDateFormat: true,
        callOnChangeCallbackIfInvalid: true
    };

    return new DateRangeSelectorController().init(dateRangeSelectorConfig);
};

BaseFormMediator.prototype.initButtons = function () {
    var self = this;

    var hoveredHtml = function hoveredHtml() {
        self.container.addClass("htmlHovered");
    };
    var unHoveredHtml = function unHoveredHtml() {
        self.container.removeClass("htmlHovered");
    };

    var hoveredCsv = function hoveredCsv() {
        self.container.addClass("csvHovered");
    };
    var unHoveredCsv = function unHoveredCsv() {
        self.container.removeClass("csvHovered");
    };

    (0, _jquery2.default)("#htmlPreviewTab").click(function () {
        self.switchOnHTMLPreview();
    }).hover(hoveredHtml, unHoveredHtml);
    (0, _jquery2.default)("#csvPreviewTab").click(function () {
        self.switchOnCSVPreview();
    }).hover(hoveredCsv, unHoveredCsv);

    this.applyHtmlButton = (0, _jquery2.default)("#applyReportConfiguration").click(function () {
        self.onApply();
    });
    this.applyCsvButton = (0, _jquery2.default)("#genCSVReportConfiguration").click(function () {
        self.onApplyCSV();
    });

    (0, _jquery2.default)("#cancelReportConfiguration").click(function () {
        self.onCancel();
    });
};

BaseFormMediator.prototype.collectReportParameters = function () {
    var reportParameters = {};
    this.fillDateSelection(reportParameters);
    return _jquery2.default.extend(reportParameters, this.configController.getConfig());
};

BaseFormMediator.prototype.onApply = function () {
    if (!this.validateAndUpdateUIIfInvalid()) return;

    this.submitForm();
};

BaseFormMediator.prototype.onApplyCSV = function () {
    if (!this.validateAndUpdateUIIfInvalid()) return;

    (0, _indicateExportingOnButton2.default)(this.applyCsvButton);
    this.exportToCSV();
};

BaseFormMediator.prototype.onCancel = function () {
    window.location.href = this.reportsPageLink;
};

BaseFormMediator.prototype.makeServiceParams = function (reportParams) {
    var serviceParams = _underscore2.default.clone(reportParams);
    serviceParams.dateRangeSelection = {
        qualifier: reportParams.dateRangeSelection.qualifier,
        fromDate: reportParams.dateRangeSelection.fromDate.toJSON(),
        toDate: reportParams.dateRangeSelection.toDate.toJSON()
    };

    return serviceParams;
};

BaseFormMediator.prototype.fillDateSelection = function (reportParametersObject) {
    reportParametersObject.dateRangeSelection = this.dateRangeSelector.getSelectedRange();
};

BaseFormMediator.prototype.switchOnCSVPreview = function () {
    if (this.htmlPreviewChosen === false) return;

    this.configController.switchTimeFormatBetweenCSVAndHTML(true);
    this.generatePreviewFnc = this.generateCSVPreview;
    this.container.removeClass("html");
    this.container.addClass("csv");
    this.applyHtmlButton.addClass("hidden");
    this.applyCsvButton.removeClass("hidden");
    this.updatePreview();
    this.htmlPreviewChosen = false;
};

BaseFormMediator.prototype.switchOnHTMLPreview = function () {
    if (this.htmlPreviewChosen === true) return;

    this.configController.switchTimeFormatBetweenCSVAndHTML(false);
    this.updateTimeFormatInLastSuccessfulPreviewParametersIfConfigurationValid();
    this.generatePreviewFnc = this.generateHtmlPreview;
    this.container.removeClass("csv");
    this.container.addClass("html");
    this.applyHtmlButton.removeClass("hidden");
    this.applyCsvButton.addClass("hidden");
    this.updatePreview();
    this.htmlPreviewChosen = true;
};

BaseFormMediator.prototype.updateTimeFormatInLastSuccessfulPreviewParametersIfConfigurationValid = function () {
    if (this.validate()) this.lastSuccessfulPreviewParameters.timeFormat = this.configController.getConfig().timeFormat;
};

BaseFormMediator.prototype.submitForm = function () {
    var form = document.getElementById("actionForm");
    form["reportParameters"].value = JSON.stringify(this.collectReportParameters());
    form.submit();
};

BaseFormMediator.prototype.exportToCSV = function () {
    var form = document.getElementById("reportExportToCSVForm");
    form["reportParameters"].value = JSON.stringify(this.collectReportParameters());
    form.submit();
};

BaseFormMediator.prototype.updatePreview = function () {
    this.generatePreviewFnc(this.lastSuccessfulPreviewParameters);
};

BaseFormMediator.prototype.generateCSVPreview = function (reportParameters) {
    this.reportPreviewPlaceholder.empty()[0].appendChild(this.csvPeviewGenerator.generatePreviewTable(reportParameters, this.reportParamsStringBuilder));
};

BaseFormMediator.prototype.generateHtmlPreview = function (reportParameters) {
    this.reportPreviewPlaceholder.empty()[0].appendChild(this.htmlPeviewGenerator.generatePreviewTable(reportParameters));
};

BaseFormMediator.prototype.generateCSVName = function (generator, reportParams) {
    return generator.generateCSVName(reportParams);
};

BaseFormMediator.prototype._exportToCSV = function (reportParams, successFn, serviceName, serviceParams) {
    var self = this;
    function successMethod(result) {
        var generator = successFn(result);

        var data = result.rootItem;
        (0, _utils.downloadJsonAsCSV)(generator.getJsons(reportParams, data), self.generateCSVName(generator, reportParams));
    }

    function errorMethod(jqXHR, textStatus, errorThrown) {
        if (textStatus === "rpc_customException") {
            var messageKey = null;

            switch (errorThrown.exception) {
                case "com.actimind.actitime.reports.AllSelectedUsersWereDeletedException":
                    messageKey = "userlist.js.error_all_selected_useds_deleted";
                    break;
                case "com.actimind.actitime.reports.AllSelectedLeaveTypesWereDeletedException":
                    messageKey = "report.common.all_selected_leave_types_deleted";
                    break;
            }

            if (messageKey) {
                alert(_messageResource2.default.getMessage(messageKey));
                window.location.reload();
                return true;
            }
        }

        return false;
    }

    return (0, _jquery_rpc2.default)(serviceName, serviceParams, successMethod, errorMethod);
};

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = HTMLColumnsStrategy;

var _BaseColumnsStrategy = __webpack_require__(984);

var _BaseColumnsStrategy2 = _interopRequireDefault(_BaseColumnsStrategy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function HTMLColumnsStrategy() {}

HTMLColumnsStrategy.prototype = new _BaseColumnsStrategy2.default();

HTMLColumnsStrategy.prototype.init = function (timeformat) {
    this.timeFormat = timeformat;
    _BaseColumnsStrategy2.default.prototype.init.call(this);
    return this;
};

HTMLColumnsStrategy.prototype.createTimeValueCell = function (className) {
    return ReportPreviewUtils.createCell(this.makeTimeValue(), "timeValueCell " + (className ? className : ""));
};

HTMLColumnsStrategy.prototype.makeTimeValue = function () {
    return ReportPreviewUtils.getHTMLTimeValue(this.timeFormat);
};

HTMLColumnsStrategy.prototype.createOthersHeaderCell = function (rowSpan) {
    return ReportPreviewUtils.createCell(this.message("report.common.others"), "user", 1, rowSpan);
};

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = OldBaseFormMediator;

var _BaseFormMediator = __webpack_require__(269);

var _BaseFormMediator2 = _interopRequireDefault(_BaseFormMediator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function OldBaseFormMediator() {} /**
                                   * Created by evdokimov on 26.05.2017.
                                   */


OldBaseFormMediator.prototype = _.create(_BaseFormMediator2.default.prototype, {

    fillDateSelection: function fillDateSelection(reportParametersObject) {
        reportParametersObject.dateRangeSelection = this.dateRangeSelector.getSelectedRangeJSON();
    }

});

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(605)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(418)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(132);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 274 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/* harmony default export */ __webpack_exports__["a"] = (isArray);


/***/ }),
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsNative_js__ = __webpack_require__(1209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getValue_js__ = __webpack_require__(1212);



/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = Object(__WEBPACK_IMPORTED_MODULE_1__getValue_js__["a" /* default */])(object, key);
  return Object(__WEBPACK_IMPORTED_MODULE_0__baseIsNative_js__["a" /* default */])(value) ? value : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = (getNative);


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _EntityWithIdStore2 = __webpack_require__(342);

var _EntityWithIdStore3 = _interopRequireDefault(_EntityWithIdStore2);

var _StringIndex = __webpack_require__(115);

var _StringIndex2 = _interopRequireDefault(_StringIndex);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EntityWithNameStore = function (_EntityWithIdStore) {
    _inherits(EntityWithNameStore, _EntityWithIdStore);

    function EntityWithNameStore() {
        _classCallCheck(this, EntityWithNameStore);

        var _this = _possibleConstructorReturn(this, (EntityWithNameStore.__proto__ || Object.getPrototypeOf(EntityWithNameStore)).call(this));

        _this._stringIndex = new _StringIndex2.default();
        return _this;
    }

    _createClass(EntityWithNameStore, [{
        key: "searchByName",
        value: function searchByName(name, sorted) {
            var _this2 = this;

            var resultObject = this._stringIndex.search(this._stringIndex.getTokenizer().getTokens(name.toLowerCase()));
            var resultArray = _underscore2.default.keys(resultObject);
            return sorted ? _underscore2.default.sortBy(resultArray, function (id) {
                return _this2._orderIndex[id];
            }) : resultArray;
        }
    }, {
        key: "getEntityName",
        value: function getEntityName(entity) {
            return entity.name;
        }
    }, {
        key: "_onAdd",
        value: function _onAdd(newEntity, oldEntity, first) {
            if (oldEntity) this._removeFromStringIndex(oldEntity);
            this._stringIndex.add(this.getEntityName(newEntity), this.getEntityId(newEntity));
        }
    }, {
        key: "_onRemove",
        value: function _onRemove(entity) {
            this._removeFromStringIndex(entity);
        }
    }, {
        key: "_removeFromStringIndex",
        value: function _removeFromStringIndex(entity) {
            this._stringIndex.remove(this.getEntityName(entity), this.getEntityId(entity));
        }
    }]);

    return EntityWithNameStore;
}(_EntityWithIdStore3.default);

exports.default = EntityWithNameStore;

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.PasswordValidatorId = exports.PasswordValidators = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.create = create;
exports.hasRuleId = hasRuleId;
exports.forOnlyId = forOnlyId;
exports.addRuleId = addRuleId;
exports.removeRuleId = removeRuleId;
exports.change = change;
exports.toggleRuleId = toggleRuleId;
exports.getPasswordSettings = getPasswordSettings;
exports.setPasswordSettings = setPasswordSettings;

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SystemSettings = window.SystemSettings;


//Functional-style methods to work with settings. Useful for reducers.

function create() {
    var settings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        minimalLength: 0,
        ruleIds: []
    };

    return _extends({
        ruleIds: [],
        minimalLength: 0
    }, settings);
}

function hasRuleId(settings, rule) {
    return _underscore2.default.contains(settings.ruleIds, rule);
}

function forOnlyId(settings, ruleId) {
    return _extends({}, settings, {
        ruleIds: [ruleId]
    });
}

function addRuleId(settings, ruleId) {
    return _extends({}, settings, {
        ruleIds: _underscore2.default.union(settings.ruleIds, [ruleId])
    });
}

function removeRuleId(settings, ruleId) {
    return _extends({}, settings, {
        ruleIds: _underscore2.default.without(settings.ruleIds, ruleId)
    });
}

function change(settings, change) {
    return _extends({}, settings, change);
}

function toggleRuleId(settings, ruleId, value) {
    return value ? addRuleId(settings, ruleId) : removeRuleId(settings, ruleId);
}

var PasswordSettingsInstance = null;

function getPasswordSettings() {
    if (PasswordSettingsInstance === null) {
        PasswordSettingsInstance = create(SystemSettings.passwordSettings);
    }
    return PasswordSettingsInstance;
}

function setPasswordSettings(newSettings) {
    PasswordSettingsInstance = create(newSettings);
}

var PasswordValidators = exports.PasswordValidators = window.__GENERATED_CONSTANTS__.PasswordValidators;
var PasswordValidatorId = exports.PasswordValidatorId = window.__GENERATED_CONSTANTS__.PasswordValidatorId;

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.validatePassword = validatePassword;
exports.validatePasswordWithNewPolicy = validatePasswordWithNewPolicy;
exports.cancelPasswordValidation = cancelPasswordValidation;
exports.getPasswordValidator = getPasswordValidator;

var _rpcCalls = __webpack_require__(24);

var _rpcCalls2 = _interopRequireDefault(_rpcCalls);

var _constants = __webpack_require__(21);

var _StateComponent2 = __webpack_require__(105);

var _StateComponent3 = _interopRequireDefault(_StateComponent2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var VALIDATE_PASSWORD_RPC = "PasswordValidationService.validatePassword";
var VALIDATE_PASSWORD_WITH_NEW_POLICY_RPC = "PasswordValidationService.validatePasswordWithNewPolicy";

function isEmpty(str) {
    return !str || !str.length;
}

function validatePassword(password) {
    cancelPasswordValidation();
    return (0, _rpcCalls2.default)(VALIDATE_PASSWORD_RPC, [password]);
}

function validatePasswordWithNewPolicy(password, policy) {
    cancelPasswordValidation();
    return (0, _rpcCalls2.default)(VALIDATE_PASSWORD_WITH_NEW_POLICY_RPC, [password, policy]);
}

function cancelPasswordValidation() {
    (0, _rpcCalls.abortCall)(VALIDATE_PASSWORD_RPC);
}

function getPasswordValidator(_ref) {
    var _ref$validatePassword = _ref.validatePasswordCopy,
        validatePasswordCopy = _ref$validatePassword === undefined ? true : _ref$validatePassword,
        _ref$ignoreBothEmptyn = _ref.ignoreBothEmptyness,
        ignoreBothEmptyness = _ref$ignoreBothEmptyn === undefined ? false : _ref$ignoreBothEmptyn,
        _ref$validateWithNewP = _ref.validateWithNewPolicy,
        validateWithNewPolicy = _ref$validateWithNewP === undefined ? false : _ref$validateWithNewP,
        _ref$onValidationStar = _ref.onValidationStart,
        onValidationStart = _ref$onValidationStar === undefined ? function () {} : _ref$onValidationStar,
        _ref$onValidationEnd = _ref.onValidationEnd,
        onValidationEnd = _ref$onValidationEnd === undefined ? function (errorKey) {
        var restrictionResultJson = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    } : _ref$onValidationEnd;

    return new PasswordAsyncValidator({
        validatePasswordCopy: validatePasswordCopy,
        ignoreBothEmptyness: ignoreBothEmptyness,
        remoteValidate: validateWithNewPolicy ? validatePasswordWithNewPolicy : validatePassword,
        onValidationStart: onValidationStart,
        onValidationEnd: onValidationEnd
    });
}

var PasswordAsyncValidator = function (_StateComponent) {
    _inherits(PasswordAsyncValidator, _StateComponent);

    function PasswordAsyncValidator() {
        var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            _ref2$validatePasswor = _ref2.validatePasswordCopy,
            validatePasswordCopy = _ref2$validatePasswor === undefined ? true : _ref2$validatePasswor,
            _ref2$ignoreBothEmpty = _ref2.ignoreBothEmptyness,
            ignoreBothEmptyness = _ref2$ignoreBothEmpty === undefined ? false : _ref2$ignoreBothEmpty,
            _ref2$remoteValidate = _ref2.remoteValidate,
            remoteValidate = _ref2$remoteValidate === undefined ? function () {
            return Promise.resolve({ ok: true });
        } : _ref2$remoteValidate,
            _ref2$onValidationSta = _ref2.onValidationStart,
            onValidationStart = _ref2$onValidationSta === undefined ? function () {} : _ref2$onValidationSta,
            _ref2$onValidationEnd = _ref2.onValidationEnd,
            onValidationEnd = _ref2$onValidationEnd === undefined ? function (errorKey) {
            var restrictionResultJson = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        } : _ref2$onValidationEnd;

        _classCallCheck(this, PasswordAsyncValidator);

        var _this = _possibleConstructorReturn(this, (PasswordAsyncValidator.__proto__ || Object.getPrototypeOf(PasswordAsyncValidator)).call(this));

        _this.state = {
            password: null,
            passwordCopy: null,

            validating: false,
            passwordIsOk: true,
            forcePasswordCheck: false,
            ignoreBothEmptyness: ignoreBothEmptyness,
            newPasswordPolicy: {}
        };
        _this.validatePasswordCopy = validatePasswordCopy;
        _this.onValidationEnd = onValidationEnd;
        _this.onValidationStart = onValidationStart;
        _this.remoteValidate = remoteValidate;

        _this.onStatePropertyChanged("password", _this._doValidatePassword.bind(_this));
        _this.onStatePropertyBecameTrue("forcePasswordCheck", function () {
            return _this._doValidatePassword(_this.state.password);
        });
        if (_this.validatePasswordCopy) {
            _this.onStatePropertyChanged("passwordCopy", function (passwordCopy) {
                if (_this.state.validating || !_this.state.passwordIsOk) return;
                _this.onValidationStart();

                if (_this._canIgnoreDueToBothEmpty()) return;
                _this._checkPasswordCopy();
            });
        }
        _this.resumeHandlingStateChanges(false);
        return _this;
    }

    _createClass(PasswordAsyncValidator, [{
        key: '_canIgnoreDueToBothEmpty',
        value: function _canIgnoreDueToBothEmpty() {
            if (this.validatePasswordCopy && this.state.ignoreBothEmptyness && isEmpty(this.state.password) && isEmpty(this.state.passwordCopy)) {
                this.setState({ passwordIsOk: true });
                this.onValidationEnd(null);
                return true;
            }
            return false;
        }
    }, {
        key: '_doValidatePassword',
        value: function _doValidatePassword(password) {
            var _this2 = this;

            this.onValidationStart();
            this.setState({ forcePasswordCheck: false });
            if (this._canIgnoreDueToBothEmpty()) return;
            if (isEmpty(password)) {
                this.setState({ passwordIsOk: false });
                this.onValidationEnd(_constants.ValidationErrors.PASSWORD_EMPTY);
            } else {
                this.setState({ validating: true });
                this.remoteValidate(password, this.state.newPasswordPolicy).then(function (result) {
                    _this2.setState({ validating: false, passwordIsOk: result.ok });
                    if (result.ok) {
                        if (_this2.validatePasswordCopy) {
                            _this2._checkPasswordCopy();
                        } else {
                            _this2.onValidationEnd(null);
                        }
                    } else {
                        _this2.onValidationEnd(_constants.ValidationErrors.PASSWORD_RESTRICTIONS_VIOLATED, result);
                    }
                });
            }
        }
    }, {
        key: 'init',
        value: function init() {}
    }, {
        key: '_checkPasswordCopy',
        value: function _checkPasswordCopy() {
            if (isEmpty(this.state.passwordCopy)) {
                this.onValidationEnd(_constants.ValidationErrors.PASSWORD_COPY_EMPTY);
            } else if (this.state.passwordCopy !== this.state.password) {
                this.onValidationEnd(_constants.ValidationErrors.PASSWORDS_DO_NOT_MATCH);
            } else {
                this.onValidationEnd(null);
            }
        }
    }]);

    return PasswordAsyncValidator;
}(_StateComponent3.default);

PasswordAsyncValidator.ValidationErrors = _constants.ValidationErrors;
exports.default = PasswordAsyncValidator;

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var RpcError = function () {
    function RpcError(jqXHR, textStatus, errorThrown) {
        _classCallCheck(this, RpcError);

        this.jqXHR = jqXHR;
        this.textStatus = textStatus;
        this.errorThrown = errorThrown;
        this.handled = false;
        this.newError = null;
    }

    _createClass(RpcError, [{
        key: "getJQXHR",
        value: function getJQXHR() {
            return this.jqXHR;
        }
    }, {
        key: "getTextStatus",
        value: function getTextStatus() {
            return this.textStatus;
        }
    }, {
        key: "getErrorThrown",
        value: function getErrorThrown() {
            return this.errorThrown;
        }
    }, {
        key: "getException",
        value: function getException() {
            return this.errorThrown.exception;
        }
    }, {
        key: "handle",
        value: function handle() {
            var newError = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

            this.handled = true;
            this.newError = newError;
        }
    }, {
        key: "handleOnException",
        value: function handleOnException(exception) {
            var newError = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

            if (this.getException() === exception) {
                this.handle(newError);
            }
        }
    }, {
        key: "handleOnExceptions",
        value: function handleOnExceptions(exceptions) {
            var _this = this;

            var errorMapper = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
                return null;
            };

            var exception = exceptions.find(function (e) {
                return e === _this.getException();
            });
            if (exception) this.handle(errorMapper(this.errorThrown));
        }
    }, {
        key: "isHandled",
        value: function isHandled() {
            return this.handled;
        }
    }, {
        key: "getNewError",
        value: function getNewError() {
            return this.newError;
        }
    }]);

    return RpcError;
}();

exports.default = RpcError;

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TreeFilter2 = __webpack_require__(725);

var _TreeFilter3 = _interopRequireDefault(_TreeFilter2);

var _TreeNodeSet = __webpack_require__(79);

var _TreeNodeSet2 = _interopRequireDefault(_TreeNodeSet);

var _TokensHighlighter = __webpack_require__(94);

var _TokensHighlighter2 = _interopRequireDefault(_TokensHighlighter);

var _EmptyHighlighter = __webpack_require__(137);

var _EmptyHighlighter2 = _interopRequireDefault(_EmptyHighlighter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SelectorFilter = function (_TreeFilter) {
    _inherits(SelectorFilter, _TreeFilter);

    function SelectorFilter(tree, searchIndex, allActiveSet) {
        _classCallCheck(this, SelectorFilter);

        var _this = _possibleConstructorReturn(this, (SelectorFilter.__proto__ || Object.getPrototypeOf(SelectorFilter)).call(this));

        _this.allActiveSet = allActiveSet;
        _this.activeOnlySet = _this.allActiveSet;
        _this.selectedOnlySet = null;
        _this.keywordSet = null;
        _this.highlighter = new _EmptyHighlighter2.default();
        _this.searchIndex = searchIndex;
        _this.tree = tree;
        _this.KEYWORD_EMPTY_MESSAGE_KEY = 'keyword';
        _this.SELECTED_ONLY_EMPTY_MESSAGE_KEY = 'selectedOnly';
        _this.NO_ACTIVE_NODES_EMPTY_MESSAGE_KEY = 'noEnabled';
        _this.NO_NODES_EMPTY_MESSAGE_KEY = 'emptyTree';
        return _this;
    }

    _createClass(SelectorFilter, [{
        key: "getFilterClasses",
        value: function getFilterClasses() {
            var classes = [];
            if (this.keywordSet) classes.push("keywordFilter");
            if (!this.activeOnlySet) classes.push("showDisabled");else classes.push("hideDisabled");
            if (this.getResults().isEmpty()) {
                var classesMap = this.getClassesForEmptyMessages();

                for (var key in classesMap) {
                    //noinspection JSUnfilteredForInLoop
                    classes.push(classesMap[key]);
                }
            }
            return classes;
        }
    }, {
        key: "getClassesForEmptyMessages",
        value: function getClassesForEmptyMessages() {
            var classesMap = {};
            if (this.keywordSet) {
                classesMap[this.KEYWORD_EMPTY_MESSAGE_KEY] = "showNoNodesMatchingSearch";
            } else if (this.selectedOnlySet) {
                classesMap[this.SELECTED_ONLY_EMPTY_MESSAGE_KEY] = this.selectedOnlySet.isEmpty() ? "showNoSelectedNodes" : this.getClassNameForEmptyVisibleSelection();
            } else if (this.activeOnlySet && this.tree.getRootNode().hasChildren()) {
                classesMap[this.NO_ACTIVE_NODES_EMPTY_MESSAGE_KEY] = "showNoActiveNodes";
            } else {
                classesMap[this.NO_NODES_EMPTY_MESSAGE_KEY] = "empty";
            }
            return classesMap;
        }
    }, {
        key: "getClassNameForEmptyVisibleSelection",
        value: function getClassNameForEmptyVisibleSelection() {
            return "showNoSelectedNodesHasDisabled";
        }
    }, {
        key: "setShowInactiveAndReFilter",
        value: function setShowInactiveAndReFilter(showDisabled) {
            this.setShowInactiveAndReFilterIfNeeded(showDisabled, true);
        }
    }, {
        key: "setShowInactive",
        value: function setShowInactive(showDisabled) {
            this.setShowInactiveAndReFilterIfNeeded(showDisabled, false);
        }
    }, {
        key: "setShowInactiveAndReFilterIfNeeded",
        value: function setShowInactiveAndReFilterIfNeeded(showDisabled, needToReFilter) {
            if (showDisabled && this.activeOnlySet) {
                this.activeOnlySet = null;
                if (needToReFilter) this.reFilter();
            } else if (!showDisabled && !this.activeOnlySet) {
                this.activeOnlySet = this.allActiveSet;
                if (needToReFilter) this.reFilter();
            }
        }
    }, {
        key: "setShowSelectedOnlyAndReFilter",
        value: function setShowSelectedOnlyAndReFilter(showSelectedOnly) {
            if (showSelectedOnly && !this.selectedOnlySet) {
                this.selectedOnlySet = this.tree.getSelectionController().getSelectedNodeSet().clone();
                this.reFilter();
            } else if (!showSelectedOnly && this.selectedOnlySet) {
                this.selectedOnlySet = null;
                this.reFilter();
            }
        }

        //  selectedOnlySet is set from initially selected nodes (may be necessary, if tree is not build yet).
        //  no refiltering is performed.

    }, {
        key: "setSelectedOnlyFromInitiallySelectedNodeSet",
        value: function setSelectedOnlyFromInitiallySelectedNodeSet() {
            this.selectedOnlySet = this.tree.getSelectionController().getInitiallySelectedNodeSet().clone();
        }
    }, {
        key: "updateSelectedOnlyState",
        value: function updateSelectedOnlyState() {
            if (this.selectedOnlySet != null) this.selectedOnlySet = this.tree.getSelectionController().getSelectedNodeSet().clone();
        }
    }, {
        key: "isShowSelectedOnly",
        value: function isShowSelectedOnly() {
            return this.selectedOnlySet != null;
        }
    }, {
        key: "setSearchString",
        value: function setSearchString(searchString) {
            this.setSearchStringAndReFilterIfNeeded(searchString, false);
        }
    }, {
        key: "setSearchStringAndReFilter",
        value: function setSearchStringAndReFilter(searchString) {
            this.setSearchStringAndReFilterIfNeeded(searchString, true);
        }
    }, {
        key: "setSearchStringAndReFilterIfNeeded",
        value: function setSearchStringAndReFilterIfNeeded(searchString, needToReFilter) {
            var tokens = this.searchIndex.getTokenizer().getTokens(searchString.toLowerCase());
            if (tokens.length > 0) {
                var searchResults = this.searchIndex.search(tokens);
                this.keywordSet = new _TreeNodeSet2.default();
                for (var id in searchResults) {
                    //noinspection JSUnfilteredForInLoop
                    this.keywordSet.add(this.tree.getRootNode().getNodeById(id));
                }
                this.highlighter = new _TokensHighlighter2.default(tokens, this.searchIndex.getTokenizer().getPunctuators());
                if (needToReFilter) this.reFilter();
            } else {
                if (this.keywordSet) {
                    this.keywordSet = null;
                    this.highlighter = new _EmptyHighlighter2.default();
                    if (needToReFilter) this.reFilter();
                }
            }
        }
    }, {
        key: "doFilter",
        value: function doFilter() {
            var result = void 0;
            if (this.keywordSet) {
                if (this.activeOnlySet) {
                    result = this.keywordSet.intersection(this.activeOnlySet);
                    if (result.isEmpty() && !this.keywordSet.isEmpty()) result = this.keywordSet.clone();
                } else {
                    result = this.keywordSet.clone();
                }
            } else {
                if (this.activeOnlySet) {
                    result = this.selectedOnlySet ? this.selectedOnlySet.intersection(this.activeOnlySet) : this.activeOnlySet.clone();
                } else {
                    result = this.selectedOnlySet ? this.selectedOnlySet.clone() : this.selectedOnlySet;
                }
            }

            return result;
        }
    }, {
        key: "reFilter",
        value: function reFilter() {
            if (this.hasNoFilter()) this.tree.resetFilter();else this.tree.applyFilter(this);
        }
    }, {
        key: "hasNoFilter",
        value: function hasNoFilter() {
            return !this.activeOnlySet && !this.selectedOnlySet && !this.keywordSet;
        }
    }, {
        key: "hasKeywordFilter",
        value: function hasKeywordFilter() {
            return this.keywordSet != null;
        }
    }, {
        key: "getVisibleNodeSet",
        value: function getVisibleNodeSet(selectedNodeSet) {
            return this.safeIntersection(selectedNodeSet, this.activeOnlySet);
        }
    }, {
        key: "containsTokens",
        value: function containsTokens(userNode) {
            return this.keywordSet && this.keywordSet.contains(userNode);
        }
    }, {
        key: "highlightTokens",
        value: function highlightTokens(str) {
            return this.highlighter.highlightTokens(str);
        }

        /**
         * Intersects two node sets. If second node set is not exists returns clone of first
         * @param existingSet set which is not null or undefined
         * @param secondSet set which can be null or undefined
         */

    }, {
        key: "safeIntersection",
        value: function safeIntersection(existingSet, secondSet) {
            if (!secondSet) return existingSet.clone();

            return existingSet.intersection(secondSet);
        }
    }]);

    return SelectorFilter;
}(_TreeFilter3.default);

exports.default = SelectorFilter;

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TreeNode2 = __webpack_require__(60);

var _TreeNode3 = _interopRequireDefault(_TreeNode2);

var _hierarchy_selector_util = __webpack_require__(95);

var _hierarchy_selector_util2 = _interopRequireDefault(_hierarchy_selector_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DisabledNodesParentTreeNode = function (_TreeNode) {
    _inherits(DisabledNodesParentTreeNode, _TreeNode);

    function DisabledNodesParentTreeNode(idPrefix, parentId) {
        _classCallCheck(this, DisabledNodesParentTreeNode);

        var _this = _possibleConstructorReturn(this, (DisabledNodesParentTreeNode.__proto__ || Object.getPrototypeOf(DisabledNodesParentTreeNode)).call(this, null, _hierarchy_selector_util2.default.makeTreeNodeId(idPrefix, parentId)));

        _this.idPrefix = idPrefix;
        _this.parentId = parentId;
        return _this;
    }

    _createClass(DisabledNodesParentTreeNode, [{
        key: "getIdPrefix",
        value: function getIdPrefix() {
            return this.idPrefix;
        }
    }, {
        key: "getIdIndex",
        value: function getIdIndex() {
            return this.parentId;
        }
    }, {
        key: "isCollapsible",
        value: function isCollapsible() {
            return false;
        }
    }]);

    return DisabledNodesParentTreeNode;
}(_TreeNode3.default);

exports.default = DisabledNodesParentTreeNode;

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var CoarseSelection = {
    SPECIFIC: "specific",
    ALL_ACTIVE: "all_active",
    ALL: "all"
};

exports.default = CoarseSelection;

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Ext = __webpack_require__(12);

var _Ext2 = _interopRequireDefault(_Ext);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Gradient button implementation, rendered as an div tag with span with text inside.
 */
var GradientButton = _Ext2.default.extend(_Ext2.default.Button, {
    overCls: 'hover',
    buttonSelector: "span:first-child",
    icon: "",

    initComponent: function initComponent() {
        GradientButton.superclass.initComponent.call(this);
        this.template = new _Ext2.default.Template('<div><span>{0}</span></div>');
    }
});

_Ext2.default.reg("at_gradient_button", GradientButton);

exports.default = GradientButton;

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _DropdownTemplateView2 = __webpack_require__(42);

var _DropdownTemplateView3 = _interopRequireDefault(_DropdownTemplateView2);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AnimatedDialogWrapper = function (_DropdownTemplateView) {
    _inherits(AnimatedDialogWrapper, _DropdownTemplateView);

    function AnimatedDialogWrapper($el, _ref) {
        var dialog = _ref.dialog,
            className = _ref.className,
            _ref$keyFrameClass = _ref.keyFrameClass,
            keyFrameClass = _ref$keyFrameClass === undefined ? null : _ref$keyFrameClass,
            _ref$onHide = _ref.onHide,
            onHide = _ref$onHide === undefined ? function () {} : _ref$onHide,
            _ref$preventHide = _ref.preventHide,
            preventHide = _ref$preventHide === undefined ? function () {
            return false;
        } : _ref$preventHide,
            _ref$autoPosition = _ref.autoPosition,
            autoPosition = _ref$autoPosition === undefined ? false : _ref$autoPosition,
            _ref$toggleMode = _ref.toggleMode,
            toggleMode = _ref$toggleMode === undefined ? false : _ref$toggleMode;

        _classCallCheck(this, AnimatedDialogWrapper);

        var _this = _possibleConstructorReturn(this, (AnimatedDialogWrapper.__proto__ || Object.getPrototypeOf(AnimatedDialogWrapper)).call(this, $el, {
            toggleMode: toggleMode
        }));

        _this.params = {
            dialog: dialog,
            className: className,
            onHide: onHide,
            keyFrameClass: keyFrameClass,
            preventHide: preventHide,
            autoPosition: autoPosition
        };
        return _this;
    }

    _createClass(AnimatedDialogWrapper, [{
        key: 'shouldUpdateOnInit',
        value: function shouldUpdateOnInit() {
            return false;
        }
    }, {
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class="panelAnimatedDialogWrapper <%=className%>"></div>';
        }
    }, {
        key: 'templateModel',
        value: function templateModel() {
            return _extends({}, this.params);
        }
    }, {
        key: 'onHide',
        value: function onHide() {
            _get(AnimatedDialogWrapper.prototype.__proto__ || Object.getPrototypeOf(AnimatedDialogWrapper.prototype), 'onHide', this).call(this);
            this.params.onHide();
            this.applyForChildrenComponents(function (c) {
                return c.hide();
            });
        }
    }, {
        key: 'update',
        value: function update() {
            _get(AnimatedDialogWrapper.prototype.__proto__ || Object.getPrototypeOf(AnimatedDialogWrapper.prototype), 'update', this).call(this);
            this.applyForChildrenComponents(function (child) {
                return child.update();
            });
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            this.params.dialog.init(this.$el).hide();
            this.registerChildComponents(this.params.dialog);
        }
    }, {
        key: 'showAt',
        value: function showAt($el) {
            var positionParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            var $positionEl = arguments[2];

            _get(AnimatedDialogWrapper.prototype.__proto__ || Object.getPrototypeOf(AnimatedDialogWrapper.prototype), 'showAt', this).call(this, $el, _extends({
                my: 'right top',
                at: 'right top'
            }, positionParams), $positionEl);
        }
    }, {
        key: '_showElementAt',
        value: function _showElementAt($el, pos) {
            if (this.params.autoPosition) {
                _get(AnimatedDialogWrapper.prototype.__proto__ || Object.getPrototypeOf(AnimatedDialogWrapper.prototype), '_showElementAt', this).call(this, $el, pos);
            }
        }
    }, {
        key: 'mouseDownTargetElement',
        value: function mouseDownTargetElement() {
            return (0, _jquery2.default)('body');
        }
    }, {
        key: '_isPossibleToHide',
        value: function _isPossibleToHide() {
            var possible = !this.params.preventHide();

            if (this.params.dialog.closeable !== undefined) {
                possible = possible && this.params.dialog.closeable();
            }

            return possible;
        }
    }, {
        key: 'show',
        value: function show() {
            var _this2 = this;

            this.resumeHandlingStateChanges();
            if (this.params.keyFrameClass !== null) {
                this.$el.removeClass(this.params.keyFrameClass);
                this.$el.show();
                this.$el.atAnimation().oneAnimationEnd(function () {
                    if (_this2.isShown) {
                        _this2.applyForChildrenComponents(function (child) {
                            return child.show();
                        });
                        _this2.applyForChildrenComponents(function (child) {
                            return child.update();
                        });
                    }
                });
                this.$el.addClass(this.params.keyFrameClass);
            } else {
                this.$el.show();
                this.applyForChildrenComponents(function (child) {
                    return child.show();
                });
            }
        }
    }, {
        key: 'setState',
        value: function setState(data) {
            _get(AnimatedDialogWrapper.prototype.__proto__ || Object.getPrototypeOf(AnimatedDialogWrapper.prototype), 'setState', this).call(this, data);
            this.applyForChildrenComponents(function (child) {
                return child.setState(data);
            });
        }
    }]);

    return AnimatedDialogWrapper;
}(_DropdownTemplateView3.default);

exports.default = AnimatedDialogWrapper;

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _LoadingControlMixin = __webpack_require__(136);

var _LoadingControlMixin2 = _interopRequireDefault(_LoadingControlMixin);

var _atBrowserUtils = __webpack_require__(8);

var _atUtils = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MAX_LENGTH_LIMIT = 50000;

var ResizableInput = function (_TemplateView) {
    _inherits(ResizableInput, _TemplateView);

    function ResizableInput() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            _ref$showCounter = _ref.showCounter,
            showCounter = _ref$showCounter === undefined ? true : _ref$showCounter,
            _ref$heightLimit = _ref.heightLimit,
            heightLimit = _ref$heightLimit === undefined ? 200 : _ref$heightLimit,
            _ref$minHeight = _ref.minHeight,
            minHeight = _ref$minHeight === undefined ? 64 : _ref$minHeight,
            _ref$maxLength = _ref.maxLength,
            maxLength = _ref$maxLength === undefined ? 2000 : _ref$maxLength,
            _ref$allowInputOverMa = _ref.allowInputOverMaxLength,
            allowInputOverMaxLength = _ref$allowInputOverMa === undefined ? false : _ref$allowInputOverMa,
            _ref$additionalClass = _ref.additionalClass,
            additionalClass = _ref$additionalClass === undefined ? '' : _ref$additionalClass,
            _ref$onKeyDown = _ref.onKeyDown,
            onKeyDown = _ref$onKeyDown === undefined ? function () {} : _ref$onKeyDown,
            _ref$onFocus = _ref.onFocus,
            onFocus = _ref$onFocus === undefined ? function () {} : _ref$onFocus,
            _ref$onBlur = _ref.onBlur,
            onBlur = _ref$onBlur === undefined ? function () {} : _ref$onBlur,
            _ref$onChange = _ref.onChange,
            onChange = _ref$onChange === undefined ? function () {} : _ref$onChange,
            _ref$onResize = _ref.onResize,
            onResize = _ref$onResize === undefined ? function () {} : _ref$onResize;

        _classCallCheck(this, ResizableInput);

        var _this = _possibleConstructorReturn(this, (ResizableInput.__proto__ || Object.getPrototypeOf(ResizableInput)).call(this));

        _this._handleOnInputChange = function (e) {
            var text = e.target.value.trim();
            _this.params.onChange(text);
        };

        _this.params = {
            additionalClass: additionalClass,
            onKeyDown: onKeyDown,
            onFocus: onFocus,
            onBlur: onBlur,
            showCounter: showCounter,
            heightLimit: heightLimit,
            minHeight: minHeight,
            maxLength: maxLength,
            allowInputOverMaxLength: allowInputOverMaxLength,
            onChange: onChange,
            onResize: onResize
        };

        _this.state = {
            editing: false,
            editable: true,
            text: '',
            placeholder: ''
        };

        _this.onStatePropertyChanged('text', function () {
            return _this._handleTextChanged();
        });
        _this.onStatePropertyChanged('placeholder', function () {
            return _this.$input.attr('placeholder', _this.state.placeholder).placeholder();
        });

        _this.onStatePropertyChanged('editable', function (editable) {
            _this.$el.toggleClass('editable', editable);
            _this.$input.attr('disabled', !editable);
        });
        return _this;
    }

    _createClass(ResizableInput, [{
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='components_resizableInput <%=additionalClass%>'>" + "  <div class='inputContainer'><textarea class='textarea' maxlength='<%=maxLength%>'/></div>" + "  <div class='characterCounter'></div>" + "</div>";
        }
    }, {
        key: "templateModel",
        value: function templateModel() {
            return {
                additionalClass: this.params.additionalClass,
                maxLength: this.params.allowInputOverMaxLength ? MAX_LENGTH_LIMIT : this.params.maxLength
            };
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            var _this2 = this;

            this.$input = this.find('.textarea');
            this.textarea = this.find('textarea')[0];
            this.$inputContainer = this.find('.inputContainer');
            this.$counter = this.find('.characterCounter');

            this.$input.blur(function () {
                return _this2._onBlur();
            });
            this.$inputContainer.click(function () {
                return _this2._onFocus();
            });
            (0, _atBrowserUtils.fixIScrollInnerWheelEvent)(this.$input);

            this.$input.keyup(function () {
                _this2.updateResize();
                _this2.counterUpdate();
            });

            this.$input.keydown(function (e) {
                _this2.params.onKeyDown(e);
                (0, _atBrowserUtils.handleEscape)(function () {
                    e.stopPropagation();
                    _this2.$input.blur();
                }, e);
            });

            this.$input.on('input', this._handleOnInputChange);

            this.$counter.hide();
        }

        /* ugly hack for resizing textarea
        *  additional line height needs for hiding scroll while textarea is resizing
        * */

    }, {
        key: "updateResize",
        value: function updateResize() {
            var lineHeight = 22;
            var additionalHeight = this.state.editing ? lineHeight : 0;
            // refresh scroll
            var prevHeight = this.getEl().height();

            this.textarea.style.height = "0px";
            this.textarea.style.height = Math.max(this.params.minHeight, Math.min(this.textarea.scrollHeight + additionalHeight, this.params.heightLimit)) + "px";

            if (prevHeight !== this.getEl().height()) {
                this.params.onResize();
            }
        }
    }, {
        key: "getText",
        value: function getText() {
            return this.$input.pVal();
        }
    }, {
        key: "counterUpdate",
        value: function counterUpdate() {
            if (this.params.showCounter) {
                var characterCount = (0, _atUtils.trim)(this.$input.pVal()).length;
                var counterText = characterCount + "/" + this.params.maxLength;
                this.$counter.text(counterText);

                if (characterCount <= this.params.maxLength) this.clearError();else this.setError();
            }
        }
    }, {
        key: "setError",
        value: function setError() {
            this.$el.addClass("invalid");
            this.invalid = true;
        }
    }, {
        key: "clearError",
        value: function clearError() {
            this.$el.removeClass("invalid");
            this.invalid = false;
        }
    }, {
        key: "focus",
        value: function focus() {
            this.$input.focus();
            this.updateResize();
            this._onFocus();
        }
    }, {
        key: "_onFocus",
        value: function _onFocus() {
            this.updateResize();
            this.setStateInternal({ editing: true });
            if (!this.state.editable) return;

            if (this.params.showCounter) this.$counter.show();

            this.params.onFocus();
        }
    }, {
        key: "_onBlur",
        value: function _onBlur() {
            this.setStateInternal({ editing: false });
            var newText = (0, _atUtils.trim)(this.$input.pVal());
            if (newText !== this.state.text && !this.invalid) {
                this.trigger('change', newText);
                // this.params.onChange(newText);  - uncomment after refactoring
            }

            if (!this.invalid) {
                this.$counter.hide();
            }
            this.params.onBlur(newText);
        }
    }, {
        key: "_handleTextChanged",
        value: function _handleTextChanged() {
            this.$input.pVal(this.state.text);
            this.updateResize();
            this.counterUpdate();
        }
    }]);

    return ResizableInput;
}(_TemplateView3.default);

exports.default = ResizableInput;


_underscore2.default.extend(ResizableInput.prototype, _LoadingControlMixin2.default);

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fillNextDataParams = exports.NEXT_SORTING_FIELDS = undefined;

var _NEXT_SORTING_FIELDS_;

exports.makeLoadTasksRequest = makeLoadTasksRequest;
exports.loadAndMergeRpcAndNextData = loadAndMergeRpcAndNextData;
exports.fillNextParamsWithTaskNameFilter = fillNextParamsWithTaskNameFilter;
exports.fillNextParamsWithOnlyManageableTasks = fillNextParamsWithOnlyManageableTasks;

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _rpcCalls = __webpack_require__(24);

var _rpcCalls2 = _interopRequireDefault(_rpcCalls);

var _CustomerProjectSelection = __webpack_require__(156);

var _CustomerProjectSelection2 = _interopRequireDefault(_CustomerProjectSelection);

var _utils = __webpack_require__(486);

var _ClassicBridge = __webpack_require__(18);

var _ClassicBridge2 = _interopRequireDefault(_ClassicBridge);

var _atUtils = __webpack_require__(5);

var _constants = __webpack_require__(44);

var _utils2 = __webpack_require__(135);

var _utils3 = __webpack_require__(6);

var _selectors = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ID_LIMIT_IN_QUERY = 500;

var NEXT_SORTING_FIELDS = exports.NEXT_SORTING_FIELDS = {
    CUSTOMER: "group.parent.title",
    PROJECT: "group.title",
    TASK: "title",
    STATUS: "active",
    WORKFLOW_STATUS: "workflowStatus",
    ESTIMATE: "estimate",
    DEADLINE: "deadline",
    LAST_TRACKING_DATE: "last_submitted_at",
    TYPE_OF_WORK: "typeOfWork.position",
    CREATION_DATE: "created_at",
    SPENT_TIME: "spentTime",
    VARIANCE_MAN_HOURS: "variance.duration",
    VARIANCE_PERCENTS: "variance.percentage",
    VARIANCE_PROGRESS_BAR: "progress",
    KANBAN_POSITION: "kanbanPosition"
};

var NEXT_SORTING_FIELDS_MAP = (_NEXT_SORTING_FIELDS_ = {}, _defineProperty(_NEXT_SORTING_FIELDS_, _constants.TaskSortBy.CUSTOMER, NEXT_SORTING_FIELDS.CUSTOMER), _defineProperty(_NEXT_SORTING_FIELDS_, _constants.TaskSortBy.PROJECT, NEXT_SORTING_FIELDS.PROJECT), _defineProperty(_NEXT_SORTING_FIELDS_, _constants.TaskSortBy.TASK, NEXT_SORTING_FIELDS.TASK), _defineProperty(_NEXT_SORTING_FIELDS_, _constants.TaskSortBy.STATUS, NEXT_SORTING_FIELDS.STATUS), _defineProperty(_NEXT_SORTING_FIELDS_, _constants.TaskSortBy.WORKFLOW_STATUS, NEXT_SORTING_FIELDS.WORKFLOW_STATUS), _defineProperty(_NEXT_SORTING_FIELDS_, _constants.TaskSortBy.ESTIMATE, NEXT_SORTING_FIELDS.ESTIMATE), _defineProperty(_NEXT_SORTING_FIELDS_, _constants.TaskSortBy.DEADLINE, NEXT_SORTING_FIELDS.DEADLINE), _defineProperty(_NEXT_SORTING_FIELDS_, _constants.TaskSortBy.LAST_TRACKING_DATE, NEXT_SORTING_FIELDS.LAST_TRACKING_DATE), _defineProperty(_NEXT_SORTING_FIELDS_, _constants.TaskSortBy.TYPE_OF_WORK, NEXT_SORTING_FIELDS.TYPE_OF_WORK), _defineProperty(_NEXT_SORTING_FIELDS_, _constants.TaskSortBy.CREATION_DATE, NEXT_SORTING_FIELDS.CREATION_DATE), _defineProperty(_NEXT_SORTING_FIELDS_, _constants.TaskSortBy.SPENT_TIME, NEXT_SORTING_FIELDS.SPENT_TIME), _defineProperty(_NEXT_SORTING_FIELDS_, _constants.TaskSortBy.VARIANCE_MAN_HOURS, NEXT_SORTING_FIELDS.VARIANCE_MAN_HOURS), _defineProperty(_NEXT_SORTING_FIELDS_, _constants.TaskSortBy.VARIANCE_PERCENTS, NEXT_SORTING_FIELDS.VARIANCE_PERCENTS), _defineProperty(_NEXT_SORTING_FIELDS_, _constants.TaskSortBy.VARIANCE_PROGRESS_BAR, NEXT_SORTING_FIELDS.VARIANCE_PROGRESS_BAR), _NEXT_SORTING_FIELDS_);

function makeLoadTasksRequest(_ref) {
    var intersectedCPSelection = _ref.intersectedCPSelection,
        taskStatusFilter = _ref.taskStatusFilter,
        customFieldsFilters = _ref.customFieldsFilters,
        taskNameFilter = _ref.taskNameFilter,
        showOnlyManageableTasks = _ref.showOnlyManageableTasks,
        taskSorting = _ref.taskSorting,
        _ref$offset = _ref.offset,
        offset = _ref$offset === undefined ? 0 : _ref$offset,
        _ref$limit = _ref.limit,
        limit = _ref$limit === undefined ? null : _ref$limit,
        noRetry = _ref.noRetry;

    var fillCommonNextDataParams = fillNextDataParams({
        intersectedCPSelection: intersectedCPSelection,
        taskStatusFilter: taskStatusFilter,
        taskNameFilter: taskNameFilter,
        showOnlyManageableTasks: showOnlyManageableTasks
    }, {
        taskWorkflowStatuses: (0, _utils3.unsafe_selectWithState)(_selectors.getWorkflowStatusesArray)
    });

    var sortField = _ClassicBridge2.default.isCustomField(taskSorting.by) ? taskSorting.by : NEXT_SORTING_FIELDS_MAP[taskSorting.by];

    var params = {
        sortField: sortField,
        ascSort: taskSorting.asc,
        offset: offset,
        limit: limit,
        customFieldsFilters: customFieldsFilters
    };
    fillCommonNextDataParams(params);

    var settings = {
        noRetry: noRetry
    };

    return _ClassicBridge2.default.getTasksForTaskListSynced(params, settings).then(function (nextData) {
        return loadAndMergeRpcAndNextData(nextData, intersectedCPSelection);
    });
}

function loadAndMergeRpcAndNextData(nextData, intersectedCPSelection) {
    var taskIds = _underscore2.default.pluck(nextData.items, "classicId");

    /* Load classic task entities with additional fields:
     * - creationTimestamp
     * - commentsNumber
     * - lasTTDate
     *
     * As well load additional page data
     */
    return (0, _rpcCalls2.default)("TaskManagementService.getTasks", [taskIds, intersectedCPSelection], // intersectedCPSelection is required for this request
    function () {
        return true;
    }).then(function (rpcData) {
        return mergeRpcAndNextData(rpcData, nextData);
    });
}

function mergeRpcAndNextData(rpcData, nextData) {
    var taskIds = _underscore2.default.pluck(nextData.items, "classicId");

    // sort tasks by next data
    rpcData.tasks = _underscore2.default.sortBy(rpcData.tasks, function (task) {
        return taskIds.indexOf(task.id);
    });

    rpcData.tasks = (0, _utils2.mergeRpcAndNextTaskData)(rpcData.tasks, nextData);
    return rpcData;
}

function fillNextParamsWithCPSelection(params, cpSelection) {
    if (cpSelection.qualifier === _CustomerProjectSelection2.default.Qualifier.SELECTED) {
        if (cpSelection.customers.length !== 0) params.customerIds = cpSelection.customers;
        if (cpSelection.projects.length !== 0) params.projectIds = cpSelection.projects;
    }
    if (cpSelection.qualifier === _CustomerProjectSelection2.default.Qualifier.ALL_ACTIVE) {
        params.activeCPOnly = true;
    } else {
        params.activeCPOnly = cpSelection.activeOnly;
    }
}

var fillNextDataParams = exports.fillNextDataParams = function fillNextDataParams(_ref2) {
    var intersectedCPSelection = _ref2.intersectedCPSelection,
        taskStatusFilter = _ref2.taskStatusFilter,
        taskNameFilter = _ref2.taskNameFilter,
        showOnlyManageableTasks = _ref2.showOnlyManageableTasks;

    var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref3$taskWorkflowSta = _ref3.taskWorkflowStatuses,
        taskWorkflowStatuses = _ref3$taskWorkflowSta === undefined ? [] : _ref3$taskWorkflowSta;

    return function (params) {
        intersectedCPSelection && fillNextParamsWithCPSelection(params, intersectedCPSelection);
        fillNextParamsWithTaskStatusFilter(params, taskStatusFilter, taskWorkflowStatuses);
        fillNextParamsWithTaskNameFilter(params, taskNameFilter);
        fillNextParamsWithOnlyManageableTasks(params, showOnlyManageableTasks);
    };
};

function fillNextParamsWithTaskStatusFilter(params, taskStatusFilter) {
    var taskWorkflowStatuses = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

    if ((0, _utils.isOnlyOpenType)(taskStatusFilter)) params.active = true;else if ((0, _utils.isOnlyCompletedType)(taskStatusFilter)) params.active = false;else if (!(0, _utils.isAll)(taskStatusFilter)) {
        var selectedIdsSet = (0, _atUtils.arrayToSet)(taskStatusFilter.statusIds);
        params.workflowStatusIds = taskWorkflowStatuses.filter(function (status) {
            return !!selectedIdsSet[status.id] || taskStatusFilter.statusTypes.includes(status.type);
        }).map(function (status) {
            return status.id;
        });
    }
}

function fillNextParamsWithTaskNameFilter(params, taskNameFilter) {
    if (taskNameFilter) params.titleSearch = taskNameFilter;
}

function fillNextParamsWithOnlyManageableTasks(params, onlyManageableTasks) {
    if (onlyManageableTasks) params.onlyEditable = onlyManageableTasks;
}

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _DropdownTemplateView2 = __webpack_require__(42);

var _DropdownTemplateView3 = _interopRequireDefault(_DropdownTemplateView2);

var _WorkflowStatusSelector = __webpack_require__(768);

var _WorkflowStatusSelector2 = _interopRequireDefault(_WorkflowStatusSelector);

var _index = __webpack_require__(22);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TaskStatusMenu = function (_DropdownTemplateView) {
    _inherits(TaskStatusMenu, _DropdownTemplateView);

    function TaskStatusMenu($containerEl) {
        var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
            _ref$showActionNames = _ref.showActionNames,
            showActionNames = _ref$showActionNames === undefined ? false : _ref$showActionNames,
            _ref$showSelectedFirs = _ref.showSelectedFirst,
            showSelectedFirst = _ref$showSelectedFirs === undefined ? false : _ref$showSelectedFirs,
            _ref$showMenuCb = _ref.showMenuCb,
            showMenuCb = _ref$showMenuCb === undefined ? function () {} : _ref$showMenuCb,
            _ref$hideMenuCb = _ref.hideMenuCb,
            hideMenuCb = _ref$hideMenuCb === undefined ? function () {} : _ref$hideMenuCb;

        _classCallCheck(this, TaskStatusMenu);

        var _this = _possibleConstructorReturn(this, (TaskStatusMenu.__proto__ || Object.getPrototypeOf(TaskStatusMenu)).call(this, $containerEl));

        _this.params = {
            showActionNames: showActionNames
        };

        _this.showMenuCb = showMenuCb;
        _this.hideMenuCb = hideMenuCb;

        _this.state = {
            showCompletedFirst: false,
            showReopenLabel: false
        };

        _this.onAnyStatePropertyChanged(['showCompletedFirst', 'showReopenLabel'], function (_ref2) {
            var showCompletedFirst = _ref2.showCompletedFirst,
                showReopenLabel = _ref2.showReopenLabel;

            _this.statusesSelector.setState({
                showCompletedFirst: showCompletedFirst,
                showReopenLabel: showReopenLabel
            });
        });
        return _this;
    }

    _createClass(TaskStatusMenu, [{
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='dropdownContainer taskStatusMenu'></div>";
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            var _this2 = this;

            this.statusesSelector = new _WorkflowStatusSelector2.default({
                onSelectStatus: function onSelectStatus(id) {
                    _this2._selectStatus(id);
                },
                groupByStatusType: (0, _index.isEnabled)(_index.Feature.TWS),
                showActionNames: this.params.showActionNames,
                showSelectedFirst: this.params.showSelectedFirst
            }).init(this.$el);

            this.getEl().on('click', function (e) {
                return e.stopPropagation();
            });
        }
    }, {
        key: "update",
        value: function update() {
            this.statusesSelector.update();
        }
    }, {
        key: "showAt",
        value: function showAt($element, positionParams, callback) {
            _get(TaskStatusMenu.prototype.__proto__ || Object.getPrototypeOf(TaskStatusMenu.prototype), "showAt", this).call(this, $element, positionParams);
            this.update();
            this.callback = callback;
        }
    }, {
        key: "onHide",
        value: function onHide() {
            _get(TaskStatusMenu.prototype.__proto__ || Object.getPrototypeOf(TaskStatusMenu.prototype), "onHide", this).call(this);
            this.callback(this.statusId);
            this.hideMenuCb();
        }
    }, {
        key: "onShow",
        value: function onShow() {
            _get(TaskStatusMenu.prototype.__proto__ || Object.getPrototypeOf(TaskStatusMenu.prototype), "onShow", this).call(this);
            this.showMenuCb();
        }
    }, {
        key: "setStatusId",
        value: function setStatusId(id) {
            this.statusId = id;
            this.statusesSelector.setState({
                selectedStatusId: id
            });
        }
    }, {
        key: "setInactiveOpenStatuses",
        value: function setInactiveOpenStatuses(inactiveOpenStatuses) {
            this.statusesSelector.setState({
                inactiveOpenStatuses: inactiveOpenStatuses
            });
        }
    }, {
        key: "_selectStatus",
        value: function _selectStatus(id) {
            this.setStatusId(id);
            this.hide();
        }
    }, {
        key: "mouseDownTargetElement",
        value: function mouseDownTargetElement() {
            return (0, _jquery2.default)('body');
        }
    }]);

    return TaskStatusMenu;
}(_DropdownTemplateView3.default);

exports.default = TaskStatusMenu;

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Description = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _ResizableInput = __webpack_require__(287);

var _ResizableInput2 = _interopRequireDefault(_ResizableInput);

var _ScrollableContainer = __webpack_require__(49);

var _ScrollableContainer2 = _interopRequireDefault(_ScrollableContainer);

var _LinkifiedText = __webpack_require__(1359);

var _constants = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Description = exports.Description = function (_TemplateView) {
    _inherits(Description, _TemplateView);

    function Description() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            _ref$maxLength = _ref.maxLength,
            maxLength = _ref$maxLength === undefined ? _constants.EntityTextLimits.MAX_CPT_DESCRIPTION : _ref$maxLength,
            _ref$onKeyDown = _ref.onKeyDown,
            onKeyDown = _ref$onKeyDown === undefined ? function () {} : _ref$onKeyDown,
            _ref$onChange = _ref.onChange,
            onChange = _ref$onChange === undefined ? function () {} : _ref$onChange;

        _classCallCheck(this, Description);

        var _this = _possibleConstructorReturn(this, (Description.__proto__ || Object.getPrototypeOf(Description)).call(this));

        _this.params = {
            maxLength: maxLength
        };

        _this.callbacks = {
            onKeyDown: onKeyDown,
            onChange: onChange
        };

        _this.state = {
            editable: false,
            loading: false,
            text: '',
            placeholder: ''
        };

        _this.onStatePropertyChanged('loading', function (loading) {
            return _this.resizableInput.setLoading(loading);
        });
        _this.onStatePropertyChanged('placeholder', function (placeholder) {
            return _this.resizableInput.setState({ placeholder: placeholder });
        });
        _this.onStatePropertyChanged('editable', function (editable) {
            _this.resizableInput.setState({ editable: editable });
        });

        _this.onStatePropertyChanged('text', function (text) {
            _this.resizableInput.toggle(!text);
            _this.textPlaceholder.toggle(!!text);
            _this.resizableInput.setState({ text: text });
            _this.textPlaceholder.setState({ text: text });
        });

        return _this;
    }

    _createClass(Description, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class="components_description"/>';
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            var _this2 = this;

            this.resizableInput = new _ResizableInput2.default({
                maxLength: this.params.maxLength,
                onKeyDown: function onKeyDown() {
                    return _this2.callbacks.onKeyDown();
                },
                onBlur: function onBlur(text) {
                    return _this2._handleInputChange(text);
                }
            }).init(this.$el);

            this.textPlaceholder = new _ScrollableContainer2.default(null, new _LinkifiedText.LinkifiedText(), {
                containerClass: 'descriptionScrollableWrapper',
                contentWrapperClass: 'descriptionText'
            }).init(this.$el);

            this.textPlaceholder.getEl().click(function () {
                return _this2._showInput();
            });

            this.renderInitialState();
        }
    }, {
        key: 'getText',
        value: function getText() {
            return this.state.text;
        }

        /**
         * Needed for old panel controllers
         */

    }, {
        key: 'setLoading',
        value: function setLoading(loading) {
            this.setState({ loading: loading });
        }
    }, {
        key: '_showInput',
        value: function _showInput() {
            this.textPlaceholder.toggle(false);
            this.resizableInput.toggle(true);
            this.resizableInput.focus();
        }
    }, {
        key: '_handleInputChange',
        value: function _handleInputChange(text) {
            this.textPlaceholder.toggle(!!text);
            this.resizableInput.toggle(!text);
            this.textPlaceholder.setState({ text: text });

            if (this.state.text !== text) this.callbacks.onChange(text);
        }
    }]);

    return Description;
}(_TemplateView3.default);

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _amcharts = __webpack_require__(772);

var _amcharts2 = _interopRequireDefault(_amcharts);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ChartGenerator = function ChartGenerator() {
    _classCallCheck(this, ChartGenerator);
};

exports.default = ChartGenerator;


ChartGenerator.prototype = {

    init: function init(defaultChartSize) {
        this.defaultChartSize = defaultChartSize;
        return this;
    },

    /**
     * Render chart in given container
     * @param container container id for render chart
     * @param chartData data for render chart
     * @param config additional parameters/settings/callbacks
     */
    renderChart: function renderChart(container, chartData, config) {
        var settings = this._prepareChartSettings(chartData, config);
        settings = _jquery2.default.extend(true, settings, {
            "listeners": this._getEventListeners(config),
            "export": {
                "enabled": false,
                "menu": [],
                "libs": {
                    "autoLoad": false
                }
            }
        });

        return this._makeChart(container, settings);
    },

    /**
     * Render chart in given container and export to JPG
     * @param container container id for render chart
     * @param chartData data for render chart
     * @param config additional parameters/settings/callbacks
     */
    exportChartToJPG: function exportChartToJPG(container, chartData, config) {
        config["onRendered"] = function (e) {
            e["chart"]['export'].capture({}, function () {
                // SAVE TO JPG
                this.toJPG({}, function (base64) {
                    config["onExported"](base64);
                });
            });
        };

        var slicedChartData = chartData;
        if (!_underscore2.default.isUndefined(config["startIndex"]) && !_underscore2.default.isUndefined(config["endIndex"])) {
            slicedChartData = this._sliceChartData(chartData, config["startIndex"], config["endIndex"]);
        }

        var settings = this._prepareChartSettings(slicedChartData, config);
        settings = _jquery2.default.extend(true, settings, {
            "listeners": this._getEventListeners(config),
            "export": {
                "enabled": true,
                "menu": [],
                "libs": {
                    "autoLoad": false
                }
            }
        });
        this._updateSettingsForExport(settings, slicedChartData, config);

        return this._makeChart(container, settings);
    },

    /**
     *  Slices chart data
     */
    _sliceChartData: function _sliceChartData(chartData, startIndex, endIndex) {
        if (startIndex == 0 && endIndex == chartData.length - 1) {
            return chartData;
        }
        var slicedChartData = [];
        for (var i = startIndex; i <= endIndex; i++) {
            slicedChartData.push(chartData[i]);
        }
        return slicedChartData;
    },

    _makeChart: function _makeChart(container, settings) {
        return _amcharts2.default.makeChart(container, settings, 10);
    },

    /*
        Create event listeners for bind with chart
     */
    _getEventListeners: function _getEventListeners(config) {
        var eventListeners = [{
            "event": "rendered",
            "method": function method(e) {
                config["onRendered"](e);
            }
        }];
        eventListeners = eventListeners.concat(this._getAdditionalEventListeners(config));
        return eventListeners;
    },

    /*
        Get scale between default chart size and given chart size (it need for adjust fonts/weight/margins of chart elements)
     */
    _getChartScales: function _getChartScales(config) {
        var horizontal = 1;
        var vertical = 1;
        var chartSize = config["chartSize"];
        if (!_underscore2.default.isUndefined(chartSize)) {
            horizontal = chartSize["width"] / this.defaultChartSize["width"];
            vertical = chartSize["height"] / this.defaultChartSize["height"];
        }
        return {
            "horizontal": horizontal,
            "vertical": vertical,
            "common": vertical
        };
    },

    /*
        Get additional event that will be bind with chart
     */
    _getAdditionalEventListeners: function _getAdditionalEventListeners(config) {
        return [];
    },

    /*
        Get main chart settings (see AmCharts docs)
     */
    _prepareChartSettings: function _prepareChartSettings(chartData, config) {
        // abstract
    },

    /*
      Update settings for export
     */
    _updateSettingsForExport: function _updateSettingsForExport(settings, chartData, config) {}
};

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _GroupBySelector = __webpack_require__(1383);

var _GroupBySelector2 = _interopRequireDefault(_GroupBySelector);

var _UsersList = __webpack_require__(1384);

var _UsersList2 = _interopRequireDefault(_UsersList);

var _UsersSelector = __webpack_require__(498);

var _UsersSelector2 = _interopRequireDefault(_UsersSelector);

var _GroupType = __webpack_require__(34);

var _GroupType2 = _interopRequireDefault(_GroupType);

var _UserWithAccessRights = __webpack_require__(138);

var _UserWithAccessRights2 = _interopRequireDefault(_UserWithAccessRights);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _utils = __webpack_require__(293);

var _SimpleTooltip = __webpack_require__(36);

var _SimpleTooltip2 = _interopRequireDefault(_SimpleTooltip);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _user_group_selector_util = __webpack_require__(98);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AssignedUsersEditor = function (_TemplateView) {
    _inherits(AssignedUsersEditor, _TemplateView);

    function AssignedUsersEditor(_ref) {
        var _ref$onUserDelete = _ref.onUserDelete,
            _onUserDelete = _ref$onUserDelete === undefined ? function (userData) {} : _ref$onUserDelete,
            _ref$onAssignedUsersC = _ref.onAssignedUsersChange,
            onAssignedUsersChange = _ref$onAssignedUsersC === undefined ? function (_ref2) {
            var addedUserIds = _ref2.addedUserIds,
                removedUserIds = _ref2.removedUserIds;
        } : _ref$onAssignedUsersC,
            _ref$titleMessageKey = _ref.titleMessageKey,
            titleMessageKey = _ref$titleMessageKey === undefined ? "" : _ref$titleMessageKey,
            _ref$userSubtitleGene = _ref.userSubtitleGenerator,
            userSubtitleGenerator = _ref$userSubtitleGene === undefined ? function (user) {
            return "";
        } : _ref$userSubtitleGene,
            _ref$managersMessageK = _ref.managersMessageKey,
            managersMessageKey = _ref$managersMessageK === undefined ? null : _ref$managersMessageK,
            _ref$addUsersMessageK = _ref.addUsersMessageKey,
            addUsersMessageKey = _ref$addUsersMessageK === undefined ? "" : _ref$addUsersMessageK,
            _ref$emptyListMessage = _ref.emptyListMessageKey,
            emptyListMessageKey = _ref$emptyListMessage === undefined ? "" : _ref$emptyListMessage,
            _ref$canEditManagers = _ref.canEditManagers,
            canEditManagers = _ref$canEditManagers === undefined ? true : _ref$canEditManagers,
            _ref$showPermissionIc = _ref.showPermissionIcons,
            showPermissionIcons = _ref$showPermissionIc === undefined ? false : _ref$showPermissionIc,
            _ref$usersSelectorTit = _ref.usersSelectorTitle,
            usersSelectorTitle = _ref$usersSelectorTit === undefined ? "" : _ref$usersSelectorTit,
            _ref$renderUserSelect = _ref.renderUserSelectorToContent,
            renderUserSelectorToContent = _ref$renderUserSelect === undefined ? false : _ref$renderUserSelect,
            _ref$refreshScrollCb = _ref.refreshScrollCb,
            refreshScrollCb = _ref$refreshScrollCb === undefined ? function () {} : _ref$refreshScrollCb,
            _ref$checkIfCanModify = _ref.checkIfCanModify,
            checkIfCanModify = _ref$checkIfCanModify === undefined ? function (user) {
            return true;
        } : _ref$checkIfCanModify,
            _ref$getListDisabledT = _ref.getListDisabledTooltipText,
            getListDisabledTooltipText = _ref$getListDisabledT === undefined ? function (user) {
            return '';
        } : _ref$getListDisabledT,
            _ref$getSelectorDisab = _ref.getSelectorDisabledTooltipText,
            getSelectorDisabledTooltipText = _ref$getSelectorDisab === undefined ? function (user) {
            return '';
        } : _ref$getSelectorDisab;

        _classCallCheck(this, AssignedUsersEditor);

        var _this = _possibleConstructorReturn(this, (AssignedUsersEditor.__proto__ || Object.getPrototypeOf(AssignedUsersEditor)).call(this));

        _this.params = {
            addUsersMessageKey: addUsersMessageKey,
            emptyListMessageKey: emptyListMessageKey,
            showPermissionIcons: showPermissionIcons,
            renderUserSelectorToContent: renderUserSelectorToContent,
            onAssignedUsersChange: onAssignedUsersChange,
            refreshScrollCb: refreshScrollCb,
            getListDisabledTooltipText: getListDisabledTooltipText,
            getSelectorDisabledTooltipText: getSelectorDisabledTooltipText,
            checkIfCanModify: checkIfCanModify
        };

        _this.state = {
            groupBy: _GroupType2.default.USER_GROUP,
            userGroupsEnabled: true,
            timeZoneGroupsEnabled: true,
            users: [],
            userGroups: [],
            timeZoneGroups: [],
            canModifyAny: false,
            isBTYEnabled: false,
            isURAEnabled: false,
            isTTAEnabled: false,
            hideAssignButton: false
        };

        _this.onStateChanged(function (state) {
            var groupBy = null;
            if (state.userGroupsEnabled && state.timeZoneGroupsEnabled) {
                groupBy = state.groupBy;
            } else if (state.userGroupsEnabled) {
                groupBy = _GroupType2.default.USER_GROUP;
            } else if (state.timeZoneGroupsEnabled) {
                groupBy = _GroupType2.default.TIME_ZONE_GROUP;
            }

            var assignedUsers = state.users.filter(_utils.userHasAssignments);
            var activeAssignedUsers = assignedUsers.filter(function (user) {
                return user.active;
            });
            var usersInList = canEditManagers ? activeAssignedUsers : activeAssignedUsers.filter(function (user) {
                return !user.hasManageAssignment;
            });
            _this.usersList.setState({
                users: usersInList,
                userGroups: state.userGroups,
                timeZoneGroups: state.timeZoneGroups,
                canModifyAny: state.canModifyAny,
                groupBy: groupBy,
                isBTYEnabled: state.isBTYEnabled,
                isURAEnabled: state.isURAEnabled,
                isTTAEnabled: state.isTTAEnabled
            });

            _this.groupBySelector.setState({
                groupBy: groupBy
            });

            if (state.canModifyAny) {
                var visibleInSelectorUsers = state.users.filter(function (user) {
                    return user.assignedToViewer;
                });
                var visibleAssignedUsers = _.intersection(assignedUsers, visibleInSelectorUsers);
                _this.usersSelector.setState({
                    selection: visibleAssignedUsers.map(function (user) {
                        return user.id;
                    }),
                    users: visibleInSelectorUsers.map(function (user) {
                        var userWithAccessRights = _UserWithAccessRights2.default.fromRPC(user);
                        Object.assign(userWithAccessRights, user);
                        userWithAccessRights.canBeModified = _this.params.checkIfCanModify(user);
                        return userWithAccessRights;
                    }).sort(_user_group_selector_util.userComparator),
                    userGroups: state.userGroups,
                    timeZoneGroups: state.timeZoneGroups,
                    userGroupsEnabled: state.userGroupsEnabled,
                    timeZoneGroupsEnabled: state.timeZoneGroupsEnabled,
                    groupBy: groupBy,
                    title: usersSelectorTitle,
                    isBTYEnabled: state.isBTYEnabled,
                    isURAEnabled: state.isURAEnabled,
                    isTTAEnabled: state.isTTAEnabled
                });
            }

            _this.$title.text(_messageResource2.default.getMessage(titleMessageKey, [activeAssignedUsers.length]));

            if (managersMessageKey) {
                var activeAssignedManagersCount = activeAssignedUsers.filter(function (user) {
                    return user.hasManageAssignment;
                }).length;
                if (activeAssignedManagersCount > 0) {
                    var managersMessage = _messageResource2.default.getMessage(managersMessageKey, [activeAssignedManagersCount]);
                    _this.$otherUsersMessage.text(managersMessage);
                    _this.$otherUsersMessage.show();
                } else {
                    _this.$otherUsersMessage.hide();
                }
            } else {
                _this.$otherUsersMessage.hide();
            }

            _this.$el.toggleClass("emptyList", usersInList.length === 0 && state.canModifyAny);
            _this.$el.toggleClass("hideGroupBySelector", !state.userGroupsEnabled || !state.timeZoneGroupsEnabled);
            _this.$el.toggleClass('hideAssignUsersButton', state.hideAssignButton);
            _this.$assignUsersButton.toggleClass("disabled", !state.canModifyAny);

            _this.tooltip.setEnabled(!state.canModifyAny && !state.hideAssignButton);
        });

        _this.usersList = new _UsersList2.default({
            onUserDelete: function onUserDelete(userId) {
                var userData = _this.state.users.find(function (user) {
                    return user.id === userId;
                });
                _onUserDelete(userData);
            },
            userSubtitleGenerator: userSubtitleGenerator,
            showPermissionIcons: _this.params.showPermissionIcons,
            getDisabledTooltipText: _this.params.getListDisabledTooltipText,
            canModifyPredicate: function canModifyPredicate(user) {
                return user.canBeModified && _this.params.checkIfCanModify(user);
            }
        });

        _this.groupBySelector = new _GroupBySelector2.default({
            onGroupBySelected: function onGroupBySelected(groupBy) {
                _this.setState({ groupBy: groupBy });
                _this.params.refreshScrollCb();
            }
        });
        return _this;
    }

    _createClass(AssignedUsersEditor, [{
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='assignedUsersEditor'>" + "  <div class='header'>" + "    <div class='toolbox'>" + "      <div class='groupBySelectorContainer'>" + "        <div class='groupBySelectorLabel'><%=groupByLabel%></div>" + "      </div>" + "      <div class='separator'></div>" + "      <div class='assignUserButton components_button withPlusIcon'><%=assignUsersLabel%></div>" + "    </div>" + "    <div class='title'></div>" + "  </div>" + "  <div class='content'>" + "    <div class='usersListContainer'></div>" + "    <div class='otherUsersMessage'></div>" + "    <div class='emptyListMessage'><%-emptyListLabel%></div>" + "    <div class='emptyListArrow'></div>" + "  </div>" + "</div>";
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            var _this2 = this;

            this.$title = this.find(".title");
            this.$otherUsersMessage = this.find(".otherUsersMessage");

            this.usersList.init(this.find(".usersListContainer"));
            this.groupBySelector.init(this.find(".groupBySelectorContainer"));

            this.$assignUsersButton = this.find(".assignUserButton");

            this.usersSelector = new _UsersSelector2.default({
                selectionCallback: this.params.onAssignedUsersChange,
                showPermissionIcons: this.params.showPermissionIcons,
                canDeselectUser: function canDeselectUser(user) {
                    return user.canBeModified;
                },
                parentEl: this.params.renderUserSelectorToContent ? this.getEl()[0] : null,
                refreshScrollOnShowCb: this.params.renderUserSelectorToContent ? function (height) {
                    return _this2.refreshScrollOnShow(height);
                } : function () {},
                refreshScrollOnHideCb: this.params.renderUserSelectorToContent ? function () {
                    return _this2.refreshScrollOnHide();
                } : function () {},
                getDisabledTooltipText: this.params.getSelectorDisabledTooltipText
            }).init();
            this.$assignUsersButton.click(function () {
                return _this2.state.canModifyAny && !_this2.state.hideAssignButton && _this2.usersSelector.showAt(_this2.$assignUsersButton, "tr-br");
            });

            this.tooltip = new _SimpleTooltip2.default({
                text: _messageResource2.default.getMessage('task.list.create_pop_up.disabled_button')
            }).init((0, _jquery2.default)('body'));
            this.tooltip.subscribeToMouseEvents(this.$assignUsersButton);
        }
    }, {
        key: "messageKeys",
        value: function messageKeys() {
            return {
                assignUsersLabel: this.params.addUsersMessageKey,
                groupByLabel: "assigned_users_editor.view_by"
            };
        }
    }, {
        key: "templateModel",
        value: function templateModel() {
            return {
                emptyListLabel: this.params.emptyListMessageKey ? _messageResource2.default.getMessage(this.params.emptyListMessageKey) : ""
            };
        }
    }, {
        key: "refreshScrollOnShow",
        value: function refreshScrollOnShow(menuBottom) {
            var top = this.$el.offset().top;
            var height = this.$el.outerHeight();
            if (top + height < menuBottom) {
                this.$el.height(menuBottom - top);
                this.params.refreshScrollCb();
            }
        }
    }, {
        key: "refreshScrollOnHide",
        value: function refreshScrollOnHide() {
            this.$el.css('height', '');
            this.params.refreshScrollCb();
        }
    }]);

    return AssignedUsersEditor;
}(_TemplateView3.default);

exports.default = AssignedUsersEditor;

/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.groupUsers = groupUsers;
exports.extractPermissionsFromUser = extractPermissionsFromUser;
exports.userHasAssignments = userHasAssignments;
exports.getTitleOfGenerateMoneyReportsRight = getTitleOfGenerateMoneyReportsRight;
exports.getTitleOfModifyTimeTrackRight = getTitleOfModifyTimeTrackRight;

var _atUtils = __webpack_require__(5);

var _UserNameFormat = __webpack_require__(17);

var _constants = __webpack_require__(4);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function groupUsers(users, groups, groupIdProp) {
    var groupsMap = (0, _atUtils.arrayToMap)(groups, function (g) {
        return g.id;
    });
    var groupedUsers = [];
    var currentGroup = {};

    [].concat(_toConsumableArray(users)).sort(function (a, b) {
        return (0, _atUtils.stringComparator)(groupsMap[a[groupIdProp]].name, groupsMap[b[groupIdProp]].name) || (0, _atUtils.stringComparator)((0, _UserNameFormat.formatFML)(a.firstName, a.middleName, a.lastName), (0, _UserNameFormat.formatFML)(b.firstName, b.middleName, b.lastName));
    }).forEach(function (user) {
        var groupId = user[groupIdProp];
        if (groupId !== currentGroup.id) {
            currentGroup = {
                id: groupId,
                name: groupsMap[groupId].name,
                users: []
            };
            groupedUsers.push(currentGroup);
        }
        currentGroup.users.push(user);
    });

    return groupedUsers;
}

function extractPermissionsFromUser(user) {
    var manageUsers = false,
        modifyTimeTrack = false,
        manageScope = false,
        costReports = false;

    user.accessRights.forEach(function (ar) {
        switch (ar) {
            case _constants.AccessRights.MANAGE_USERS:
                manageUsers = true;
                break;
            case _constants.AccessRights.SUBMIT_OTHER_USER_TIME_TRACK:
                modifyTimeTrack = true;
                break;
            case _constants.AccessRights.EDIT_HIERARCHY:
                manageScope = true;
                break;
            case _constants.AccessRights.GENERATE_MONEY_REPORTS:
                costReports = true;
                break;
        }
    });

    return { manageUsers: manageUsers, modifyTimeTrack: modifyTimeTrack, manageScope: manageScope, costReports: costReports };
}

function userHasAssignments(user) {
    return user.hasAllAssignments || user.hasCustomerAssignment || user.hasAllFutureProjectsOfCustomerAssignment || user.hasProjectAssignment || user.hasAllFutureTasksOfProjectAssignment || user.hasTaskAssignment;
}

function getTitleOfGenerateMoneyReportsRight(isBTYEnabled, isURAEnabled) {
    var title = "";
    if (isBTYEnabled && isURAEnabled) title = _messageResource2.default.getMessage('access_rights.generate_money_reports');
    if (isBTYEnabled && !isURAEnabled) title = _messageResource2.default.getMessage('access_rights.generate_money_reports_only_billing');
    if (!isBTYEnabled && isURAEnabled) title = _messageResource2.default.getMessage('access_rights.generate_money_reports_only_cost');

    return title;
}

function getTitleOfModifyTimeTrackRight(isTTAEnabled) {
    return _messageResource2.default.getMessage(isTTAEnabled ? 'access_rights.modify_and_approve_tt' : 'access_rights.submit_other_time_track');
}

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _View2 = __webpack_require__(20);

var _View3 = _interopRequireDefault(_View2);

var _GroupType = __webpack_require__(34);

var _GroupType2 = _interopRequireDefault(_GroupType);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _utils = __webpack_require__(293);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AssignedUsersEditorContainer = function (_View) {
    _inherits(AssignedUsersEditorContainer, _View);

    function AssignedUsersEditorContainer(_ref) {
        var assignedUsersEditor = _ref.assignedUsersEditor,
            $tabTitle = _ref.$tabTitle,
            _ref$tabTitleMessageK = _ref.tabTitleMessageKey,
            tabTitleMessageKey = _ref$tabTitleMessageK === undefined ? "" : _ref$tabTitleMessageK;

        _classCallCheck(this, AssignedUsersEditorContainer);

        var _this = _possibleConstructorReturn(this, (AssignedUsersEditorContainer.__proto__ || Object.getPrototypeOf(AssignedUsersEditorContainer)).call(this));

        _this.state = {
            userGroupsEnabled: true,
            timeZoneGroupsEnabled: true,
            users: [],
            userGroups: [],
            timeZoneGroups: [],
            canModifyAny: false,
            assignButtonVisible: false
        };

        _this.assignedUsersEditor = assignedUsersEditor;
        _this.$tabTitle = $tabTitle;

        _this.onStateChanged(function (state) {
            _this.assignedUsersEditor.setState(state);
            var usersCount = state.users.filter(function (user) {
                return (0, _utils.userHasAssignments)(user) && user.active;
            }).length;
            $tabTitle.text(_messageResource2.default.getMessage(tabTitleMessageKey, [usersCount]));
        });
        return _this;
    }

    return AssignedUsersEditorContainer;
}(_View3.default);

exports.default = AssignedUsersEditorContainer;

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _InformationBlockLine = __webpack_require__(1393);

var _InformationBlockLine2 = _interopRequireDefault(_InformationBlockLine);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InformationBlock = function (_TemplateView) {
    _inherits(InformationBlock, _TemplateView);

    function InformationBlock() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            _ref$title = _ref.title,
            title = _ref$title === undefined ? '' : _ref$title,
            _ref$paragraphs = _ref.paragraphs,
            paragraphs = _ref$paragraphs === undefined ? [] : _ref$paragraphs,
            _ref$additionalClass = _ref.additionalClass,
            additionalClass = _ref$additionalClass === undefined ? '' : _ref$additionalClass;

        _classCallCheck(this, InformationBlock);

        var _this = _possibleConstructorReturn(this, (InformationBlock.__proto__ || Object.getPrototypeOf(InformationBlock)).call(this));

        _this.title = title;
        _this.additionalClass = additionalClass;

        _this.state = {
            paragraphs: paragraphs
        };

        _this.onStatePropertyChanged('paragraphs', function () {
            return _this._updateParagraphs();
        });
        return _this;
    }

    _createClass(InformationBlock, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class="components_informationBlock <%-additionalClass%>">' + '    <div class="title"><%-title%></div>' + '    <div class="paragraphsPlaceholder"/>' + '    <div class="pointer"></div>' + '</div>';
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            this.find('.title').toggle(!!this.title);
            this.$paragraphsPlaceholder = this.find('.paragraphsPlaceholder');
            this.renderInitialState();
        }
    }, {
        key: '_updateParagraphs',
        value: function _updateParagraphs() {
            var _this2 = this;

            this.$paragraphsPlaceholder.empty();
            this.state.paragraphs.forEach(function (paragraph) {
                return new _InformationBlockLine2.default({
                    lineText: paragraph
                }).init(_this2.$paragraphsPlaceholder);
            });
        }
    }]);

    return InformationBlock;
}(_TemplateView3.default);

exports.default = InformationBlock;

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _CopySettingsItem = __webpack_require__(1394);

var _CopySettingsItem2 = _interopRequireDefault(_CopySettingsItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CopySettingsBlock = function (_TemplateView) {
    _inherits(CopySettingsBlock, _TemplateView);

    function CopySettingsBlock() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            _ref$additionalClass = _ref.additionalClass,
            additionalClass = _ref$additionalClass === undefined ? '' : _ref$additionalClass,
            _ref$assignmentsSetti = _ref.assignmentsSettings,
            assignmentsSettings = _ref$assignmentsSetti === undefined ? [] : _ref$assignmentsSetti,
            _ref$descriptionSetti = _ref.descriptionSettings,
            descriptionSettings = _ref$descriptionSetti === undefined ? [] : _ref$descriptionSetti,
            _ref$taskSettings = _ref.taskSettings,
            taskSettings = _ref$taskSettings === undefined ? [] : _ref$taskSettings;

        _classCallCheck(this, CopySettingsBlock);

        var _this = _possibleConstructorReturn(this, (CopySettingsBlock.__proto__ || Object.getPrototypeOf(CopySettingsBlock)).call(this));

        _this.state = {
            assignmentsSettings: assignmentsSettings,
            descriptionSettings: descriptionSettings,
            taskSettings: taskSettings
        };

        _this.additionalClass = additionalClass;
        _this.settingItems = {};

        _this.onStatePropertyChanged('assignmentsSettings', function (assignmentsSettings) {
            _this.$assignmentsSettings.empty();
            assignmentsSettings.forEach(function (setting) {
                _this.settingItems[setting.id] = new _CopySettingsItem2.default(setting).init(_this.$assignmentsSettings);
            });

            _this.$assignmentsSettings.toggle(assignmentsSettings.length > 0);
        });

        _this.onStatePropertyChanged('descriptionSettings', function (descriptionSettings) {
            _this.$descriptionSettings.empty();
            descriptionSettings.forEach(function (setting) {
                _this.settingItems[setting.id] = new _CopySettingsItem2.default(setting).init(_this.$descriptionSettings);
            });

            _this.$descriptionSettings.toggle(descriptionSettings.length > 0);
        });

        _this.onStatePropertyChanged('taskSettings', function (taskSettings) {
            _this.$taskSettings.empty();
            taskSettings.forEach(function (setting) {
                _this.settingItems[setting.id] = new _CopySettingsItem2.default(setting).init(_this.$taskSettings);
            });

            _this.$taskSettings.toggle(taskSettings.length > 0);
        });
        return _this;
    }

    _createClass(CopySettingsBlock, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class="components_copySettingsBlock <%-additionalClass%>">' + '    <div class="title"><%-title%></div>' + '    <div class="settingsPlaceholder">' + '        <div class="assignmentsSettings"/>' + '        <div class="descriptionSettings"/>' + '        <div class="taskSettings"/>' + '    </div>' + '</div>';
        }
    }, {
        key: 'messageKeys',
        value: function messageKeys() {
            return {
                title: 'task.list.copy_to.settings.copy_with'
            };
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            this.$assignmentsSettings = this.find('.assignmentsSettings');
            this.$descriptionSettings = this.find('.descriptionSettings');
            this.$taskSettings = this.find('.taskSettings');

            this.$assignmentsSettings.toggle(this.state.assignmentsSettings.length > 0);
            this.$descriptionSettings.toggle(this.state.descriptionSettings.length > 0);
            this.$taskSettings.toggle(this.state.taskSettings.length > 0);

            this.renderInitialState();
        }
    }, {
        key: 'getSelectedSettings',
        value: function getSelectedSettings() {
            var result = {};
            for (var setting in this.settingItems) {
                result[setting] = this.settingItems[setting].isChecked();
            }
            return result;
        }
    }]);

    return CopySettingsBlock;
}(_TemplateView3.default);

exports.default = CopySettingsBlock;

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getItemsForCopyTaskSettingsBlock = getItemsForCopyTaskSettingsBlock;
exports.getItemsForCopyProjectSettingsBlock = getItemsForCopyProjectSettingsBlock;
exports.getItemsForCopyCustomerSettingsBlock = getItemsForCopyCustomerSettingsBlock;

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _constants = __webpack_require__(492);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function getItemsForCopyTaskSettingsBlock(canManageAccountsAndPermissions, billingTypesEnabled, estimateEnabled, workflowStatusesEnabled, workAssignmentsEnabled, hasSomeTeamAssignment) {

    return {
        assignmentsSettings: getAssignmentsSettings(canManageAccountsAndPermissions, workAssignmentsEnabled, hasSomeTeamAssignment),
        descriptionSettings: [],
        taskSettings: getTaskSettings({
            workflowStatusesEnabled: workflowStatusesEnabled,
            billingTypesEnabled: billingTypesEnabled,
            estimateEnabled: estimateEnabled,
            descriptionMessageKey: 'task.list.copy_to.task.settings.task_description',
            statusMessageKey: 'task.list.copy_to.task.settings.task_status',
            typeOfWorkMessageKey: 'task.list.copy_to.task.settings.task_type_of_work',
            estimateMessageKey: 'task.list.copy_to.task.settings.task_estimate'
        })
    };
}

function getItemsForCopyProjectSettingsBlock(canManageAccountsAndPermissions, billingTypesEnabled, estimateEnabled, workflowStatusesEnabled, workAssignmentsEnabled, hasSomeTeamAssignment) {

    return {
        assignmentsSettings: getAssignmentsSettings(canManageAccountsAndPermissions, workAssignmentsEnabled, hasSomeTeamAssignment),
        descriptionSettings: getProjectSettings(),
        taskSettings: getTaskSettings({ workflowStatusesEnabled: workflowStatusesEnabled, billingTypesEnabled: billingTypesEnabled, estimateEnabled: estimateEnabled })
    };
}

function getItemsForCopyCustomerSettingsBlock(canManageAccountsAndPermissions, billingTypesEnabled, estimateEnabled, workflowStatusesEnabled, workAssignmentsEnabled, hasSomeTeamAssignment) {

    return {
        assignmentsSettings: getAssignmentsSettings(canManageAccountsAndPermissions, workAssignmentsEnabled, hasSomeTeamAssignment),
        descriptionSettings: [].concat(_toConsumableArray(getCustomerSettings()), _toConsumableArray(getProjectSettings())),
        taskSettings: getTaskSettings({ workflowStatusesEnabled: workflowStatusesEnabled, billingTypesEnabled: billingTypesEnabled, estimateEnabled: estimateEnabled })
    };
}

function getTaskSettings(_ref) {
    var workflowStatusesEnabled = _ref.workflowStatusesEnabled,
        billingTypesEnabled = _ref.billingTypesEnabled,
        estimateEnabled = _ref.estimateEnabled,
        _ref$descriptionMessa = _ref.descriptionMessageKey,
        descriptionMessageKey = _ref$descriptionMessa === undefined ? 'task.list.copy_to.settings.task_description' : _ref$descriptionMessa,
        _ref$statusMessageKey = _ref.statusMessageKey,
        statusMessageKey = _ref$statusMessageKey === undefined ? 'task.list.task_status' : _ref$statusMessageKey,
        _ref$typeOfWorkMessag = _ref.typeOfWorkMessageKey,
        typeOfWorkMessageKey = _ref$typeOfWorkMessag === undefined ? 'task.list.copy_to.settings.task_type_of_work' : _ref$typeOfWorkMessag,
        _ref$estimateMessageK = _ref.estimateMessageKey,
        estimateMessageKey = _ref$estimateMessageK === undefined ? 'task.list.copy_to.settings.task_estimate' : _ref$estimateMessageK;

    var taskSettings = [{
        id: _constants.CopySettingsTypes.COPY_TASK_DESCRIPTION,
        text: _messageResource2.default.getMessage(descriptionMessageKey)
    }];

    if (workflowStatusesEnabled) taskSettings.push({
        id: _constants.CopySettingsTypes.COPY_TASK_STATUS,
        text: _messageResource2.default.getMessage(statusMessageKey)
    });

    if (billingTypesEnabled) taskSettings.push({
        id: _constants.CopySettingsTypes.COPY_TASK_TYPE_OF_WORK,
        text: _messageResource2.default.getMessage(typeOfWorkMessageKey)
    });

    if (estimateEnabled) taskSettings.push({
        id: _constants.CopySettingsTypes.COPY_TASK_ESTIMATE,
        text: _messageResource2.default.getMessage(estimateMessageKey)
    });
    return taskSettings;
}

function getAssignmentsSettings(canManageAccountsAndPermissions, workAssignmentsEnabled, hasSomeTeamAssignment) {
    var assignmentsSettings = [];

    if (hasSomeTeamAssignment) {
        canManageAccountsAndPermissions && assignmentsSettings.push({
            id: _constants.CopySettingsTypes.COPY_MANAGERS,
            text: _messageResource2.default.getMessage('task.list.copy_to.settings.managers')
        });

        workAssignmentsEnabled && assignmentsSettings.push({
            id: _constants.CopySettingsTypes.COPY_ASSIGNED_USERS,
            text: canManageAccountsAndPermissions ? _messageResource2.default.getMessage('task.list.copy_to.settings.assigned_users') : _messageResource2.default.getMessage('task.list.copy_to.settings.assigned_users_from_my_team')
        });
    }
    return assignmentsSettings;
}

function getProjectSettings() {
    return [{
        id: _constants.CopySettingsTypes.COPY_PROJECT_DESCRIPTION,
        text: _messageResource2.default.getMessage('task.list.copy_to.settings.project_description')
    }];
}

function getCustomerSettings() {
    return [{
        id: _constants.CopySettingsTypes.COPY_CUSTOMER_DESCRIPTION,
        text: _messageResource2.default.getMessage('task.list.copy_to.settings.customer_description')
    }];
}

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var ExitConfirmationHandlersManager = function ExitConfirmationHandlersManager() {};

/**
 * Makes browser show a confirmation message before any navigation when
 * isConfirmationOnUnloadRequired() == true
 * @param isPopupMode if isPopupMode is true, then exit confirmation will be disabled, when window.opener close
 * @param message confirmation message that will be shown when user would try to close the popup or navigate to another page
 * @param isConfirmationOnUnloadRequired a callback method that must always return true when we need to show confirmation before any navigation and false otherwise
 * */
ExitConfirmationHandlersManager.setUpExitConfirmation = function (message, isConfirmationOnUnloadRequired, isPopupMode, mustNotWarnUserIfIsNotCurrent) {
    if (!window["exitConfirmationHandlers"]) window["exitConfirmationHandlers"] = [];else if (window.onbeforeunload != null) window["exitConfirmationHandlers"].push(window.onbeforeunload);

    var confirmationEnabled = true;
    var confirmExit = function confirmExit() {
        var confMessage = "";
        if (confirmationEnabled && isConfirmationOnUnloadRequired()) confMessage += message;

        if (window["exitConfirmationHandlers"] && window["exitConfirmationHandlers"].length > 0) {
            for (var i = window["exitConfirmationHandlers"].length - 1; i >= 0; i--) {
                var handler = window["exitConfirmationHandlers"][i];
                if (handler.mustWarnUser()) confMessage += (isNotEmpty(confMessage) ? "\n\n" : "") + handler.getConfirmationMessage();
            }
        }

        if (isNotEmpty(confMessage)) return confMessage;
    };
    confirmExit.mustWarnUser = function () {
        return !mustNotWarnUserIfIsNotCurrent && confirmationEnabled && isConfirmationOnUnloadRequired();
    };
    confirmExit.getConfirmationMessage = function () {
        return message;
    };

    var disableConfirmation = function disableConfirmation() {
        confirmationEnabled = false;
    };

    window.onbeforeunload = confirmExit;

    //after a navigation in the parent window it would try to close all the popups
    //opened from it. In this case popups shall be closed without any confirmations
    /* TODO:
     * the call of the EventListener causes an error in FF7 if parent window needs to be reload after popup is closed.
     * confirmationEnabled and disableConfirmation should be moved outside of this function in order to allow to
     * remove EventListener from parent window before popup closes. This is required, because to remove EventListener
     * you need to specify the same function you setup as a listener
     * For more information refers to Bug 33983: FF7: JS error when Edit Open Task or Create New Tasks pop-up is closed
     */
    if (isPopupMode) addListener(window.opener, "beforeunload", disableConfirmation);
};

ExitConfirmationHandlersManager.restoreExitConfirmation = function () {
    var oldHandler;
    if (window["exitConfirmationHandlers"] && (oldHandler = window["exitConfirmationHandlers"].pop())) window.onbeforeunload = oldHandler;else window.onbeforeunload = null;
};

// if we set window.onbeforeunload = undefined, it will cause errors in IE
ExitConfirmationHandlersManager.resetExitConfirmation = function () {
    window.onbeforeunload = null;
    window["exitConfirmationHandlers"] = null;
};

exports.default = ExitConfirmationHandlersManager;

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = LoadingPopup;

var _dhtml_popup_with_moire = __webpack_require__(506);

var _dhtml_popup_with_moire2 = _interopRequireDefault(_dhtml_popup_with_moire);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _spin = __webpack_require__(93);

var _spin2 = _interopRequireDefault(_spin);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function LoadingPopup() {}

LoadingPopup.prototype = _underscore2.default.create(_dhtml_popup_with_moire2.default.prototype);

LoadingPopup.prototype.init = function (divId, captionText) {
    _dhtml_popup_with_moire2.default.call(this, divId);

    this.hideOnMouseDown = function () {
        return false;
    };
    this.hideOnResize = function () {
        return false;
    };
    this.hideOnEscape = function () {
        return false;
    };

    this._contentContainer = (0, _jquery2.default)('#' + divId + ' .content');
    this._spinnerPlaceholder = (0, _jquery2.default)('#' + divId + ' .spinner');
    this._captionTextPlaceholder = (0, _jquery2.default)('#' + divId + ' .captionText');
    this._captionTextPlaceholder.text(captionText ? captionText : _messageResource2.default.getMessage("common.popup.loading"));

    var spinnerOptions = {
        lines: 11, // The number of lines to draw
        length: 4, // The length of each line
        width: 3, // The line thickness
        radius: 6, // The radius of the inner circle
        corners: 1, // Corner roundness (0..1)
        rotate: 0, // The rotation offset
        direction: 1, // 1: clockwise, -1: counterclockwise
        color: '#fff', // #rgb or #rrggbb
        speed: 1, // Rounds per second
        trail: 60, // Afterglow percentage
        shadow: false, // Whether to render a shadow
        hwaccel: false, // Whether to use hardware acceleration
        className: 'spinner', // The CSS class to assign to the spinner
        zIndex: 2e9, // The z-index (defaults to 2000000000)
        top: 'auto', // Top position relative to parent in px
        left: 'auto' // Left position relative to parent in px
    };
    this._spinner = new _spin2.default(spinnerOptions);

    return this;
};

LoadingPopup.prototype.show = function () {
    this._isHided = false;
    this._contentContainer.addClass("disabled");
    _dhtml_popup_with_moire2.default.prototype.show.call(this);

    var self = this;
    setTimeout(function () {
        if (!self._isHided) {
            self._contentContainer.removeClass("disabled");
            self._spinner.spin(self._spinnerPlaceholder[0]);
        }
    }, 200);
};

LoadingPopup.prototype.hide = function () {
    this._isHided = true;
    this._spinner.stop();
    _dhtml_popup_with_moire2.default.prototype.hide.call(this);
};

LoadingPopup.prototype.toggle = function (toggle) {
    if (toggle) {
        this.show();
    } else {
        this.hide();
    }
};

LoadingPopup.prototype.setOnEscapeCallback = function (onEscapeCallback) {
    this.hideOnEscape = function () {
        return true;
    };
    this._onEscapeCallback = onEscapeCallback;
};

LoadingPopup.prototype.onEscape = function () {
    _dhtml_popup_with_moire2.default.prototype.onEscape.call(this);
    if (this._onEscapeCallback) this._onEscapeCallback();
};

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ChartHierarchicalSelectorsSectionStrategy() {}

ChartHierarchicalSelectorsSectionStrategy.prototype.init = function (_ref) {
    var container = _ref.container,
        leaveTypesSelector = _ref.leaveTypesSelector,
        noteMsgContainer = _ref.noteMsgContainer,
        includeOtherUsersCheckbox = _ref.includeOtherUsersCheckbox,
        cpSelector = _ref.cpSelector;

    this.container = container;
    this.leaveTypesSelector = leaveTypesSelector;
    this.noteMsgContainer = noteMsgContainer;
    this.includeOtherUsersCheckbox = includeOtherUsersCheckbox;
    this.cpSelector = cpSelector;

    return this;
};

ChartHierarchicalSelectorsSectionStrategy.prototype.updateSectionUI = function () {
    (0, _jquery2.default)(this.container).removeClass(this.getVisibleTaskUsersSelectorClassName() + " " + this.getVisibleBalanceUsersSelectorClassName() + " " + this.getVisibleBillingUsersSelectorClassName() + " " + this.getVisibleOvertimeUsersSelectorClassName() + " " + this.getVisibleCPSelectorClassName() + " " + this.getVisibleLeaveTypesSelectorClassName() + " " + this.getVisibleNoteMsgClassName() + " " + this.getVisibleUserSelectorInfoIconClassName() + " " + this.getVisibleIncludeOtherUsersCheckboxClassName());
};

ChartHierarchicalSelectorsSectionStrategy.prototype.withUserSelector = function () {
    return false;
};

ChartHierarchicalSelectorsSectionStrategy.prototype.getUserSelection = function () {
    return {};
};

ChartHierarchicalSelectorsSectionStrategy.prototype.getSelectedParams = function () {
    // abstract
};

ChartHierarchicalSelectorsSectionStrategy.prototype.validate = function () {
    return [];
};

ChartHierarchicalSelectorsSectionStrategy.prototype.validateIsUserSelected = function () {
    return false;
};

ChartHierarchicalSelectorsSectionStrategy.prototype.isShowIncludeOtherUsersCheckbox = function () {
    return false;
};

ChartHierarchicalSelectorsSectionStrategy.prototype.getVisibleBalanceUsersSelectorClassName = function () {
    return "withBalanceUsersSelector";
};

ChartHierarchicalSelectorsSectionStrategy.prototype.getVisibleBillingUsersSelectorClassName = function () {
    return "withBillingUsersSelector";
};

ChartHierarchicalSelectorsSectionStrategy.prototype.getVisibleTaskUsersSelectorClassName = function () {
    return "withTaskUsersSelector";
};

ChartHierarchicalSelectorsSectionStrategy.prototype.getVisibleOvertimeUsersSelectorClassName = function () {
    return "withOvertimeUsersSelector";
};

ChartHierarchicalSelectorsSectionStrategy.prototype.getVisibleCPSelectorClassName = function () {
    return "withCPSelector";
};

ChartHierarchicalSelectorsSectionStrategy.prototype.getVisibleLeaveTypesSelectorClassName = function () {
    return "withLeaveTypesSelector";
};

ChartHierarchicalSelectorsSectionStrategy.prototype.getVisibleNoteMsgClassName = function () {
    return "withNoteMsg";
};

ChartHierarchicalSelectorsSectionStrategy.prototype.getVisibleUsernameClassName = function () {
    return "withUsername";
};

ChartHierarchicalSelectorsSectionStrategy.prototype.getVisibleUserSelectorInfoIconClassName = function () {
    return "withUserSelectorInfoIcon";
};

ChartHierarchicalSelectorsSectionStrategy.prototype.getVisibleIncludeOtherUsersCheckboxClassName = function () {
    return "withIncludeOtherUsersCheckbox";
};

ChartHierarchicalSelectorsSectionStrategy.prototype.setUserSelection = function (selection) {
    //abstract
};

exports.default = ChartHierarchicalSelectorsSectionStrategy;

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _atUtils = __webpack_require__(5);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _constants = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ChartGroupingLevelSelectorFillingStrategy() {}

ChartGroupingLevelSelectorFillingStrategy.prototype.init = function (isUGREnabled, isBTYEnabled, isTZGEnabled, initiallySelectedGroupingLevel) {
    this.isUGREnabled = isUGREnabled;
    this.isTZGEnabled = isTZGEnabled;
    this.isBTYEnabled = isBTYEnabled;
    this.initiallySelectedGroupingLevel = initiallySelectedGroupingLevel;

    return this;
};

ChartGroupingLevelSelectorFillingStrategy.prototype.fillGroupingLevelListSelector = function (listSelector) {
    // abstract
};

ChartGroupingLevelSelectorFillingStrategy.prototype.addUsersItem = function (listSelector) {
    this.addItem(listSelector, _messageResource2.default.getMessage("report.common.users"), _constants.ReportGroupingLevel.USER);
};

ChartGroupingLevelSelectorFillingStrategy.prototype.addUserGroupsItemIfNeeded = function (listSelector) {
    if (this.isUGREnabled || this.initiallySelectedGroupingLevel === _constants.ReportGroupingLevel.USER_GROUP) this.addItem(listSelector, _messageResource2.default.getMessage("common.User_Groups"), _constants.ReportGroupingLevel.USER_GROUP);
};

ChartGroupingLevelSelectorFillingStrategy.prototype.addTimeZoneGroupsItemIfNeeded = function (listSelector) {
    if (this.isTZGEnabled || this.initiallySelectedGroupingLevel === _constants.ReportGroupingLevel.TIME_ZONE_GROUP) this.addItem(listSelector, _messageResource2.default.getMessage("common.Time_Zone_Groups"), _constants.ReportGroupingLevel.TIME_ZONE_GROUP);
};

ChartGroupingLevelSelectorFillingStrategy.prototype.addLeaveTypesItem = function (listSelector) {
    this.addItem(listSelector, _messageResource2.default.getMessage("common.Leave_Types"), _constants.ReportGroupingLevel.LEAVE_TYPE);
};

ChartGroupingLevelSelectorFillingStrategy.prototype.addCustomersItem = function (listSelector) {
    this.addItem(listSelector, _messageResource2.default.getMessage("common.Customers"), _constants.ReportGroupingLevel.CUSTOMER);
};

ChartGroupingLevelSelectorFillingStrategy.prototype.addProjectsItem = function (listSelector) {
    this.addItem(listSelector, _messageResource2.default.getMessage("common.Projects"), _constants.ReportGroupingLevel.PROJECT);
};

ChartGroupingLevelSelectorFillingStrategy.prototype.addTypesOfWorkItemIfNeeded = function (listSelector) {
    if (this.isBTYEnabled || this.initiallySelectedGroupingLevel === _constants.ReportGroupingLevel.BILLING_TYPE) this.addItem(listSelector, _messageResource2.default.getMessage("report.common.billing_types"), _constants.ReportGroupingLevel.BILLING_TYPE);
};

ChartGroupingLevelSelectorFillingStrategy.prototype.addDaysItem = function (listSelector) {
    this.addItem(listSelector, _messageResource2.default.getMessage("report.common.dates"), _constants.ReportGroupingLevel.DATE);
};

ChartGroupingLevelSelectorFillingStrategy.prototype.addWeeksItem = function (listSelector) {
    this.addItem(listSelector, _messageResource2.default.getMessage("report.common.weeks"), _constants.ReportGroupingLevel.WEEK);
};

ChartGroupingLevelSelectorFillingStrategy.prototype.addMonthsItem = function (listSelector) {
    this.addItem(listSelector, _messageResource2.default.getMessage("report.common.months"), _constants.ReportGroupingLevel.MONTH);
};

ChartGroupingLevelSelectorFillingStrategy.prototype.addItem = function (listSelector, text, value) {
    listSelector.addItems([{ text: (0, _atUtils.escapeHtmlSymbols)(text), value: value }]);
};

exports.default = ChartGroupingLevelSelectorFillingStrategy;

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Ext = __webpack_require__(12);

var _Ext2 = _interopRequireDefault(_Ext);

var _at_users_selector_panel = __webpack_require__(162);

var _at_users_selector_panel2 = _interopRequireDefault(_at_users_selector_panel);

var _SwitcherWithWrapper = __webpack_require__(478);

var _SwitcherWithWrapper2 = _interopRequireDefault(_SwitcherWithWrapper);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _ReportsUsersSelectorFilter = __webpack_require__(796);

var _ReportsUsersSelectorFilter2 = _interopRequireDefault(_ReportsUsersSelectorFilter);

var _ReportsUserSelectorTreeBuilderObserver = __webpack_require__(797);

var _ReportsUserSelectorTreeBuilderObserver2 = _interopRequireDefault(_ReportsUserSelectorTreeBuilderObserver);

var _pluralizeUtils = __webpack_require__(40);

var _atUtils = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReportsSelectorUsersPanel = _Ext2.default.extend(_at_users_selector_panel2.default, {
    allUsersOptionLabelKey: "users_selector.reports.all_users",
    teamUsersItemsOptionLabelKey: "users_selector.reports.team_users",
    teamUsersAndMeOptionLabelKey: "users_selector.reports.team_users_and_me",
    customOptionLabelKey: "users_selector.reports.selected_users",
    showInactiveLabelKey: "users_selector.reports.show_disabled",
    predefinedState: null,
    hasPanel: true,
    resetOnHide: false,
    allUsersAvailable: true,
    loggedInUserNotInTeam: false,

    setSelectorFilter: function setSelectorFilter() {
        this.selectorFilter = new _ReportsUsersSelectorFilter2.default({
            tree: this.selectorTree,
            searchIndex: this.searchIndex,
            allActiveSet: this.allActiveSet,
            myTeamNodesSet: this.treeBuilderObserver.getManageableUsersNodeSet(),
            accessibleParentNodes: this.treeBuilderObserver.getAccessibleParentNodes(),
            showTeamOnly: this.showTeamOnly
        });
    },

    createUserSelectorTreeBuilderObserver: function createUserSelectorTreeBuilderObserver(searchIndex, allActiveSet) {
        this.treeBuilderObserver = new _ReportsUserSelectorTreeBuilderObserver2.default({
            searchIndex: searchIndex,
            allActiveSet: allActiveSet,
            manageableUsersIdsSet: this.manageableUsersIdsSet
        });
        return this.treeBuilderObserver;
    },

    initialize: function initialize(_ref) {
        var userGroupsEnabled = _ref.userGroupsEnabled,
            timeZoneGroupsEnabled = _ref.timeZoneGroupsEnabled,
            users = _ref.users,
            manageableUsersIds = _ref.manageableUsersIds,
            userGroups = _ref.userGroups,
            timeZoneGroups = _ref.timeZoneGroups,
            showTeamOnly = _ref.showTeamOnly;

        var state = this.isAlreadyShown() ? this.getState() : this.predefinedState;
        this.manageableUsersIdsSet = manageableUsersIds && manageableUsersIds.length > 0 ? new Set(manageableUsersIds) : null;

        if (!state.optionValue && !state.showInactive) {
            var selectedUserIds = state.selection.getSecondLevel();

            for (var i = 0; i < users.length; i++) {
                if (selectedUserIds.indexOf(users[i].id) !== -1) {
                    if (!users[i].active) {
                        state.showInactive = true;
                        break;
                    }
                }
            }
        }

        ReportsSelectorUsersPanel.superclass.initialize.call(this, userGroupsEnabled, timeZoneGroupsEnabled, users, userGroups, timeZoneGroups);

        this.showTeamOnly = showTeamOnly;
        this.showTeamOnlyInit = showTeamOnly;
        this.alreadyShown = false;
        this.clearPanel();

        this.loadState(state);

        this.selectorFilter.setShowInactive(state.showInactive);
    },

    getDescription: function getDescription(selectionHelper, dropdownButtonId) {
        var selectedVisibleNodeSet = this.selectorFilter.getVisibleNodeSet(this.getSelectedNodeSet());

        if (this.showTeamOnly) {
            var selectedUsers = (0, _atUtils.arrayToMap)(this.userSelectorGroupsStrategy.makeOnlyUsersSelection(selectedVisibleNodeSet));
            var manageableUsersNodeSet = this.treeBuilderObserver.getManageableUsersNodeSet().map[2];
            var selectedGroups = selectedVisibleNodeSet.map[1];
            if (!!manageableUsersNodeSet && !!selectedGroups) {
                Object.values(manageableUsersNodeSet).forEach(function (node) {
                    if (!!node.parent && !!selectedGroups[node.parent.id]) {
                        selectedUsers[node.value.id] = node.value;
                    }
                });
            }

            var selectedUsersArray = Object.values(selectedUsers);
            var selectedUsersLength = selectedUsersArray.length;

            if (selectedUsersLength === 0) {
                return _messageResource2.default.getEscapedMessage("users_selector.short_no_users_selected");
            } else if (selectedUsersLength === 1) {
                return selectionHelper.getSingleItemText(selectedUsersArray[0], false);
            } else if (selectedUsersLength > 1) {
                var itemNoun = (0, _pluralizeUtils.userNameLower)(selectedUsersLength);
                return selectedUsersLength + " " + itemNoun;
            }
        }

        var selection = this.userSelectorGroupsStrategy.makeSelectionFromNodeSet(selectedVisibleNodeSet, true, this.mapSelectionGroupsToUsers(), this.getGroupType());
        return selectionHelper.getDescription(selection, dropdownButtonId, true);
    },

    getAllItemsOptionLabelKey: function getAllItemsOptionLabelKey() {
        return this.allUsersAvailable ? this.allUsersOptionLabelKey : this.loggedInUserNotInTeam ? this.teamUsersAndMeOptionLabelKey : this.teamUsersItemsOptionLabelKey;
    },

    setPredefinedState: function setPredefinedState(predefinedState) {
        this.predefinedState = predefinedState;
    },

    createComponents: function createComponents() {
        var _this = this;

        ReportsSelectorUsersPanel.superclass.createComponents.call(this);

        this.on("afterlayout", function () {
            if (_this._isTeamOnlySwitcherAvailable()) {
                var $container = (0, _jquery2.default)(_this.el.dom).find('.custom');
                var switcherText = _messageResource2.default.getMessage('report.common.user_selector.team_switcher');
                _this.showTeamOnlySwither = new _SwitcherWithWrapper2.default({
                    containerAdditionalClass: 'teamSwitcherContainer',
                    switcherTextAdditionalClass: "teamSwitcherText",
                    switcherAdditionalClass: "teamSwitcher",
                    onSwitchCallback: function onSwitchCallback(show) {
                        return _this._teamSwitchedHandler(show);
                    },
                    switcherText: switcherText
                }).init($container);
                _this.showTeamOnlySwither.setState({ enabled: _this.showTeamOnly });
            }
        });
    },

    _isTeamOnlySwitcherAvailable: function _isTeamOnlySwitcherAvailable() {
        return this.manageableUsersIdsSet !== null && this.manageableUsersIdsSet.size !== this.users.length;
    },


    _teamSwitchedHandler: function _teamSwitchedHandler(show) {
        this.showTeamOnly = show;
        this.showTeamOnlySwither.setState({ enabled: show });
        this.selectorFilter.setShowUsersFromMyTeamOnly(show);
        this.onChange();
    },

    validateIsUsersSelected: function validateIsUsersSelected() {
        return !this.isCustomOptionSelected() || !this.getSelection().isEmpty();
    },

    makeSelectionTree: function makeSelectionTree() {
        //do nothing
    },

    setInitialValueFromCurrent: function setInitialValueFromCurrent() {
        if (this.isAlreadyShown()) {
            this.setFilterFlag(this.getShowInactive());
            this.selectorTree.initializeByNodeSet(this.makeNodeSet(this.getSelection()));
            this.setInitialOptionValue(!this.isCustomOptionSelected());
            this.updateInitialTreeSet();
            this.updateInitialGroupType();
            this.showTeamOnlyInit = this.showTeamOnly;
        }
    },

    initComponent: function initComponent() {
        ReportsSelectorUsersPanel.superclass.initComponent.call(this);
        this.collapsedCookiesKey += "CollapsedUsers";
        this.on("afterlayout", function () {
            var parentNode = this.getEl().findParentNode("div.at-selector-menu", 10, true);
            if (parentNode) parentNode.addClass("usersSelectorType");
        }, this);
    },

    isStateChanged: function isStateChanged() {
        if (this.isAlreadyShown()) {
            return ReportsSelectorUsersPanel.superclass.isStateChanged.call(this);
        } else {
            return false;
        }
    },

    resetState: function resetState(isEnableActiveActions) {
        if (this._isTeamOnlySwitcherAvailable()) {
            this._teamSwitchedHandler(this.showTeamOnlyInit);
        }

        ReportsSelectorUsersPanel.superclass.resetState.call(this, isEnableActiveActions);
    }
}); /**
     * Created by filatov on 14.08.2015.
     */


_Ext2.default.reg("at_reports_selector_users_panel", ReportsSelectorUsersPanel);

exports.default = ReportsSelectorUsersPanel;

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _constants = __webpack_require__(11);

var _atUtils = __webpack_require__(5);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _UserNameFormat = __webpack_require__(17);

var _UserNameFormat2 = _interopRequireDefault(_UserNameFormat);

var _constants2 = __webpack_require__(4);

var _date_format = __webpack_require__(16);

var _StringUtils = __webpack_require__(121);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ReportChartUtils = function () {
    function ReportChartUtils() {
        _classCallCheck(this, ReportChartUtils);
    }

    _createClass(ReportChartUtils, null, [{
        key: 'getChartColorSchemeById',
        value: function getChartColorSchemeById(colorId) {
            var schemas = {
                DEFAULT: {
                    singleColumn: '#5f94c5',
                    notAssigned: '#dedede',
                    userTeam: '#4986bf',
                    user: '#2e6699'
                },
                AZUREBLUE: {
                    singleColumn: '#7facd7',
                    notAssigned: '#dedede',
                    userTeam: '#6193c2',
                    user: '#2e6699'
                },
                AQUAMARINE: {
                    singleColumn: '#4ebdd4',
                    notAssigned: '#dedede',
                    userTeam: '#42a6b9',
                    user: '#1f8599'
                },
                FERNGREEN: {
                    singleColumn: '#6dbb7a',
                    notAssigned: '#dedede',
                    userTeam: '#55ab5f',
                    user: '#2e993b'
                },
                YELLOWGREEN: {
                    singleColumn: '#afd05b',
                    notAssigned: '#dedede',
                    userTeam: '#99bc41',
                    user: '#94991f'
                },
                CHARCOALGREY: {
                    singleColumn: '#95a9ba',
                    notAssigned: '#dedede',
                    userTeam: '#7b96ab',
                    user: '#54748c'
                },
                PURPLE: {
                    singleColumn: '#995fbf',
                    notAssigned: '#dedede',
                    userTeam: '#8c54b2',
                    user: '#681f99'
                },
                ORANGE: {
                    singleColumn: '#e2b145',
                    notAssigned: '#dedede',
                    userTeam: '#d59d30',
                    user: '#99701f'
                },
                RED: {
                    singleColumn: '#ca575b',
                    notAssigned: '#dedede',
                    userTeam: '#c13848',
                    user: '#991f2d'
                }
            };
            return schemas[colorId];
        }
    }, {
        key: 'getSortCategoryFunctionForChart',
        value: function getSortCategoryFunctionForChart(groupingLevel) {
            switch (groupingLevel) {
                case _constants.ReportGroupingLevel.USER:
                    return function (user1, user2) {
                        var res = (0, _atUtils.stringComparatorCaseSensitive)(user1.lastName, user2.lastName);
                        return res === 0 ? (0, _atUtils.stringComparatorCaseSensitive)(user1.firstName, user2.firstName) : res;
                    };
                case _constants.ReportGroupingLevel.USER_GROUP:
                    {
                        return function (item1, item2) {
                            if (item1.id === item2.id) return 0;
                            if (item1.id === _constants2.OTHER_USER_GROUPS_ENTITY_ID) return -1;
                            if (item2.id === _constants2.OTHER_USER_GROUPS_ENTITY_ID) return 1;
                            if (item1.id === window.SystemSettings.usersWithoutGroupId) return -1;
                            if (item2.id === window.SystemSettings.usersWithoutGroupId) return 1;

                            return (0, _atUtils.stringComparatorCaseSensitive)(item1.name, item2.name);
                        };
                    }
                case _constants.ReportGroupingLevel.TIME_ZONE_GROUP:
                    return function (item1, item2) {
                        if (item1.id === item2.id) return 0;
                        if (item1.id === _constants2.OTHER_USER_GROUPS_ENTITY_ID) return -1;
                        if (item2.id === _constants2.OTHER_USER_GROUPS_ENTITY_ID) return 1;
                        if (item1.id === _constants2.DEFAULT_TIME_ZONE_GROUP_ID) return -1;
                        if (item2.id === _constants2.DEFAULT_TIME_ZONE_GROUP_ID) return 1;

                        return (0, _atUtils.stringComparatorCaseSensitive)(item1.name, item2.name);
                    };
                case _constants.ReportGroupingLevel.LEAVE_TYPE:
                    return function (item1, item2) {
                        return (0, _atUtils.stringComparatorCaseSensitive)(item1.name, item2.name);
                    };
                case _constants.ReportGroupingLevel.CUSTOMER:
                case _constants.ReportGroupingLevel.PROJECT:
                case _constants.ReportGroupingLevel.BILLING_TYPE:
                    return function (item1, item2) {
                        return (0, _atUtils.stringComparatorCaseSensitive)(item1.name, item2.name);
                    };
                case _constants.ReportGroupingLevel.DATE:
                    return function (date1, date2) {
                        var jsDate1 = Date.parseJSONDate(date1);
                        var jsDate2 = Date.parseJSONDate(date2);
                        return jsDate1.getTime() > jsDate2.getTime() ? 1 : -1;
                    };
                case _constants.ReportGroupingLevel.WEEK:
                    return function (week1, week2) {
                        var jsDate1 = Date.parseJSONDate(week1.from);
                        var jsDate2 = Date.parseJSONDate(week2.from);
                        return jsDate1.getTime() > jsDate2.getTime() ? 1 : -1;
                    };
                case _constants.ReportGroupingLevel.MONTH:
                    return function (month1, month2) {
                        var jsDate1 = Date.parseJSONDate(month1);
                        var jsDate2 = Date.parseJSONDate(month2);
                        return jsDate1.getTime() > jsDate2.getTime() ? 1 : -1;
                    };
            }
        }
    }, {
        key: 'getFormatCategoryFunctionForChart',
        value: function getFormatCategoryFunctionForChart(selectedCategoryType, dateFormat, escape, partsLimit, recursively) {
            if (!partsLimit) partsLimit = 17;

            switch (selectedCategoryType) {
                case _constants.ReportGroupingLevel.USER:
                    return function (user) {
                        if (_jquery2.default.isEmptyObject(user)) return "";

                        if (user.id === _constants2.OTHER_USERS_ENTITY_ID) return _messageResource2.default.getMessage("report.other_users");
                        var formattedName = _UserNameFormat2.default.formatLFM(user.firstName, user.lastName, user.middleName);
                        if (formattedName.length < partsLimit) return escape ? (0, _atUtils.escapeHtmlSymbols)(formattedName) : formattedName;
                        var res = "";
                        if (user.lastName.length > partsLimit) res = (escape ? (0, _atUtils.escapeHtmlSymbols)(user.lastName.substr(0, partsLimit - 2)) : user.lastName.substr(0, partsLimit - 2)) + '...,<br>';else res = (escape ? (0, _atUtils.escapeHtmlSymbols)(user.lastName) : user.lastName) + ",<br>";
                        var firstWithMiddleName = user.firstName + (user.middleName ? " " + user.middleName + "." : "");
                        if (firstWithMiddleName.length > 18) res += (escape ? (0, _atUtils.escapeHtmlSymbols)(user.firstName.substr(0, partsLimit - 2)) : user.firstName.substr(0, partsLimit - 2)) + '...';else res += escape ? (0, _atUtils.escapeHtmlSymbols)(firstWithMiddleName) : firstWithMiddleName;
                        return res;
                    };
                case _constants.ReportGroupingLevel.USER_GROUP:
                    {
                        return function (item) {
                            if (item.id === window.SystemSettings.usersWithoutGroupId) {
                                item.name = _messageResource2.default.getMessage("common.users_without_group");
                            }
                            if (item.id === _constants2.OTHER_USER_GROUPS_ENTITY_ID) return _messageResource2.default.getMessage("report.create_chart.stacked_columns_popup.not_assigned_users");
                            return !_jquery2.default.isEmptyObject(item) ? (0, _StringUtils.insertBrakes)(item.name, partsLimit, ' ', partsLimit, "...", escape, recursively) : "";
                        };
                    }
                case _constants.ReportGroupingLevel.TIME_ZONE_GROUP:
                    {
                        return function (item) {
                            if (item.id === _constants2.OTHER_USER_GROUPS_ENTITY_ID) return _messageResource2.default.getMessage("report.create_chart.stacked_columns_popup.not_assigned_users");

                            var name = _underscore2.default.result(item, "name", "");
                            if (item.id === _constants2.DEFAULT_TIME_ZONE_GROUP_ID) {
                                name += " " + _messageResource2.default.getMessage("common.default_group");
                            }
                            return !_jquery2.default.isEmptyObject(item) ? (0, _StringUtils.insertBrakes)(name, partsLimit, ' ', partsLimit, "...", escape, recursively) : "";
                        };
                    }
                case _constants.ReportGroupingLevel.LEAVE_TYPE:
                    {
                        return function (item) {
                            if (_jquery2.default.isEmptyObject(item)) return "";
                            return (0, _StringUtils.insertBrakes)(LeaveTypeUtil.getLeaveTypeName(item), partsLimit, ' ', partsLimit, "...", escape, recursively);
                        };
                    }
                case _constants.ReportGroupingLevel.CUSTOMER:
                case _constants.ReportGroupingLevel.BILLING_TYPE:
                    return function (item) {
                        return !_jquery2.default.isEmptyObject(item) ? (0, _StringUtils.insertBrakes)(item.name, partsLimit, ' ', partsLimit, "...", escape, recursively) : "";
                    };
                case _constants.ReportGroupingLevel.PROJECT:
                    return function (item) {
                        return !_jquery2.default.isEmptyObject(item) ? (0, _StringUtils.insertBrakes)(item.name + " (" + item.customerInfo.name + ")", partsLimit, ' ', partsLimit, "...", escape, recursively) : "";
                    };
                case _constants.ReportGroupingLevel.DATE:
                    return function (date) {
                        if (_jquery2.default.isEmptyObject(date)) return "";
                        return new _date_format.DateFormat(dateFormat).formatDate(date.parseJSONDate());
                    };
                case _constants.ReportGroupingLevel.WEEK:
                    return function (week) {
                        if (_jquery2.default.isEmptyObject(week)) return "";
                        var from = week.from.parseJSONDate();
                        var to = week.to.parseJSONDate();
                        var firstPart = week.from === week.to ? "" : new _date_format.DateFormat('MMM dd').formatDate(from) + " - ";
                        return firstPart + new _date_format.DateFormat('MMM dd, yyyy').formatDate(to);
                    };
                case _constants.ReportGroupingLevel.MONTH:
                    return function (month) {
                        if (_jquery2.default.isEmptyObject(month)) return "";
                        return new _date_format.DateFormat('MMMM , yyyy').formatDate(month.parseJSONDate());
                    };
            }
        }
    }]);

    return ReportChartUtils;
}();

exports.default = ReportChartUtils;

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DateRange = function () {
    function DateRange(dateFrom, dateTo) {
        _classCallCheck(this, DateRange);

        this.dateFrom = dateFrom;
        this.dateTo = dateTo;
    }

    _createClass(DateRange, [{
        key: "contains",
        value: function contains(date) {
            if (date != null) {
                return !(date.getTime() > this.dateTo.getTime() || this.dateFrom && date.getTime() < this.dateFrom.getTime());
            }
        }
    }, {
        key: "isWholeMonth",
        value: function isWholeMonth() {
            if (this.dateFrom.getYear() != this.dateTo.getYear()) return false;

            if (this.dateFrom.getMonth() != this.dateTo.getMonth()) return false;

            if (this.dateFrom.getDate() != 1) return false;

            var daysNumber = void 0;
            switch (this.dateFrom.getMonth()) {
                case 0:
                case 2:
                case 4:
                case 6:
                case 7:
                case 9:
                case 11:
                    daysNumber = 31;
                    break;
                case 3:
                case 5:
                case 8:
                case 10:
                    daysNumber = 30;
                    break;
                case 1:
                    daysNumber = this.dateFrom.getFullYear() % 4 == 0 && this.dateFrom.getFullYear() % 100 != 0 || this.dateFrom.getFullYear() % 400 == 0 ? 29 : 28;
                    break;
            }

            return this.dateTo.getDate() == daysNumber;
        }
    }, {
        key: "isOneDay",
        value: function isOneDay() {
            return this.dateFrom.getYear() == this.dateTo.getYear() && this.dateFrom.getMonth() == this.dateTo.getMonth() && this.dateFrom.getDate() == this.dateTo.getDate();
        }
    }]);

    return DateRange;
}();

exports.default = DateRange;

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _BaseParametersFormattingStrategy = __webpack_require__(248);

var _BaseParametersFormattingStrategy2 = _interopRequireDefault(_BaseParametersFormattingStrategy);

var _ChartParametersFormatter = __webpack_require__(516);

var _ChartParametersFormatter2 = _interopRequireDefault(_ChartParametersFormatter);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _ATReportParamsStringBuilder = __webpack_require__(52);

var _ATReportParamsStringBuilder2 = _interopRequireDefault(_ATReportParamsStringBuilder);

var _features = __webpack_require__(22);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ChartParametersFormattingStrategy = function (_BaseParametersFormat) {
    _inherits(ChartParametersFormattingStrategy, _BaseParametersFormat);

    function ChartParametersFormattingStrategy() {
        _classCallCheck(this, ChartParametersFormattingStrategy);

        return _possibleConstructorReturn(this, (ChartParametersFormattingStrategy.__proto__ || Object.getPrototypeOf(ChartParametersFormattingStrategy)).apply(this, arguments));
    }

    _createClass(ChartParametersFormattingStrategy, [{
        key: "createParametersFormatter",
        value: function createParametersFormatter(_ref) {
            var selectorsData = _ref.selectorsData,
                dateFormat = _ref.dateFormat,
                reportAuthorizationInfo = _ref.reportAuthorizationInfo;

            var ugrEnabled = selectorsData.enabledFeatures ? selectorsData.enabledFeatures.hasOwnProperty(_features.Feature.UGR) : null;
            var tzgEnabled = selectorsData.enabledFeatures ? selectorsData.enabledFeatures.hasOwnProperty(_features.Feature.TZG) : null;
            return new _ChartParametersFormatter2.default().init({
                selectorsData: selectorsData,
                dateFormat: dateFormat,
                ugrFeatureEnabled: ugrEnabled,
                tzgFeatureEnabled: tzgEnabled,
                reportAuthorizationInfo: reportAuthorizationInfo,
                reportParamsStringBuilderConstructor: _ATReportParamsStringBuilder2.default
            });
        }
    }, {
        key: "formatMainPartOfLightboxTitle",
        value: function formatMainPartOfLightboxTitle(selectedParameters) {
            return _messageResource2.default.getMessage("report.chart_pdf_preview.title", [this.parametersFormatter.formatChartTypeValue(selectedParameters.chartTypeValue), this.parametersFormatter.formatGroupingLevelValue(selectedParameters.groupingLevelValue), this.dateParametersFormattingStrategy.formatForDateInformation(selectedParameters.dateParameters)]);
        }
    }]);

    return ChartParametersFormattingStrategy;
}(_BaseParametersFormattingStrategy2.default);

exports.default = ChartParametersFormattingStrategy;

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.sendQuestion = exports.resetSupportForm = exports.setSupportEmail = exports.setSupportAttachmentName = exports.setSupportAttachmentId = exports.setSupportText = exports.setSupportFormMode = exports.setSupportFormPosition = exports.closeSupportForm = exports.openSupportForm = exports.setSupportFormPositionAction = exports.stopLoading = exports.startLoading = undefined;

var _reduxActions = __webpack_require__(9);

var _actionTypes = __webpack_require__(714);

var ActionTypes = _interopRequireWildcard(_actionTypes);

var _rpcCalls = __webpack_require__(24);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _selectors = __webpack_require__(307);

var _constants = __webpack_require__(181);

var _utils = __webpack_require__(6);

var _utils2 = __webpack_require__(381);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var startLoading = exports.startLoading = (0, _reduxActions.createAction)(ActionTypes.LOADING_START);
var stopLoading = exports.stopLoading = (0, _reduxActions.createAction)(ActionTypes.LOADING_STOP);
var setSupportFormPositionAction = exports.setSupportFormPositionAction = (0, _reduxActions.createAction)(ActionTypes.SUPPORT_FORM_POSITION_SET);

var openSupportForm = exports.openSupportForm = function openSupportForm(_ref) {
    var positionStrategy = _ref.positionStrategy,
        _ref$position = _ref.position,
        position = _ref$position === undefined ? null : _ref$position;
    return function (dispatch, getState) {
        dispatch(setSupportFormPositionAction({ positionStrategy: positionStrategy, position: position }));
        dispatch((0, _utils.createActionObject)(ActionTypes.SUPPORT_FORM_OPEN));
        (0, _utils2.setSupportPopupInfoToLocalStorage)((0, _selectors.getPopupInfo)(getState()));
    };
};
var closeSupportForm = exports.closeSupportForm = function closeSupportForm() {
    return function (dispatch, getState) {
        dispatch((0, _utils.createActionObject)(ActionTypes.SUPPORT_FORM_CLOSE));
        (0, _utils2.setSupportPopupInfoToLocalStorage)((0, _selectors.getPopupInfo)(getState()));
    };
};
var setSupportFormPosition = exports.setSupportFormPosition = function setSupportFormPosition(_ref2) {
    var positionStrategy = _ref2.positionStrategy,
        _ref2$position = _ref2.position,
        position = _ref2$position === undefined ? null : _ref2$position;
    return function (dispatch, getState) {
        dispatch(setSupportFormPositionAction({ positionStrategy: positionStrategy, position: position }));
        (0, _utils2.setSupportPopupInfoToLocalStorage)((0, _selectors.getPopupInfo)(getState()));
    };
};
var setSupportFormMode = exports.setSupportFormMode = function setSupportFormMode(mode) {
    return function (dispatch, getState) {
        dispatch((0, _utils.createActionObject)(ActionTypes.SUPPORT_FORM_MODE_SET, mode));
        (0, _utils2.setSupportPopupInfoToLocalStorage)((0, _selectors.getPopupInfo)(getState()));
    };
};
var setSupportText = exports.setSupportText = function setSupportText(text) {
    return function (dispatch, getState) {
        dispatch((0, _utils.createActionObject)(ActionTypes.SUPPORT_FORM_TEXT_SET, text));
        (0, _utils2.setSupportPopupInfoToLocalStorage)((0, _selectors.getPopupInfo)(getState()));
    };
};
var setSupportAttachmentId = exports.setSupportAttachmentId = function setSupportAttachmentId(id) {
    return function (dispatch, getState) {
        dispatch((0, _utils.createActionObject)(ActionTypes.SUPPORT_FORM_ATTACHMENT_ID_SET, id));
        (0, _utils2.setSupportPopupInfoToLocalStorage)((0, _selectors.getPopupInfo)(getState()));
    };
};
var setSupportAttachmentName = exports.setSupportAttachmentName = function setSupportAttachmentName(name) {
    return function (dispatch, getState) {
        dispatch((0, _utils.createActionObject)(ActionTypes.SUPPORT_FORM_ATTACHMENT_NAME_SET, name));
        (0, _utils2.setSupportPopupInfoToLocalStorage)((0, _selectors.getPopupInfo)(getState()));
    };
};
var setSupportEmail = exports.setSupportEmail = function setSupportEmail(email) {
    return function (dispatch, getState) {
        dispatch((0, _utils.createActionObject)(ActionTypes.SUPPORT_FORM_EMAIL_SET, email));
        (0, _utils2.setSupportPopupInfoToLocalStorage)((0, _selectors.getPopupInfo)(getState()));
    };
};
var resetSupportForm = exports.resetSupportForm = function resetSupportForm() {
    return function (dispatch, getState) {
        dispatch((0, _utils.createActionObject)(ActionTypes.SUPPORT_FORM_RESET));
        (0, _utils2.setSupportPopupInfoToLocalStorage)((0, _selectors.getPopupInfo)(getState()));
    };
};

var sendQuestion = exports.sendQuestion = function sendQuestion() {
    return function (dispatch, getState) {
        dispatch(startLoading());
        var state = getState();
        (0, _rpcCalls.rpcCall)('ContactSupportService.send', [(0, _selectors.getSupportText)(state), null, null, (0, _selectors.getEmail)(state), null, (0, _selectors.getSupportAttachmentId)(state)], _handleError).then(function () {
            dispatch(setSupportFormMode(_constants.supportFormMode.SUCCESS));
            dispatch(resetSupportForm());
        }).catch(function (error) {
            dispatch(resetSupportForm());
            alert(error);
        });
    };
};

function _handleError(error) {
    if (error.exception === 'com.actimind.common.util.PWSCommunicationException') {
        alert(_messageResource2.default.getMessage('contact_support.error.communication_exception'));
    } else if (error.exception === 'com.actimind.actitime.services.ContactSupportValidationException') {
        alert(_messageResource2.default.getMessage('contact_support.error.validation_exception'));
    } else if (error.exception === 'com.actimind.actitime.services.UploadExpiredException') {
        alert(_messageResource2.default.getMessage('contact_support.error.upload_expired_exception'));
    } else {
        alert(_messageResource2.default.getMessage('contact_support.error.generic'));
    }
    return true;
}

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getPopupInfo = exports.getEmail = exports.getSupportEmail = exports.getSupportAttachmentName = exports.getSupportAttachmentId = exports.getSupportText = exports.getSupportFormMode = exports.getSupportFormPositionStrategy = exports.getSupportFormPosition = exports.isLoading = exports.isSupportFormShown = exports.showSupportQuestionButton = undefined;

var _reselect = __webpack_require__(13);

var _selectors = __webpack_require__(19);

var getSupportState = function getSupportState(state) {
    return state.support;
};

var showSupportQuestionButton = exports.showSupportQuestionButton = (0, _reselect.createSelector)(getSupportState, function (support) {
    return support.showSupportQuestionButton;
});

var isSupportFormShown = exports.isSupportFormShown = (0, _reselect.createSelector)(getSupportState, function (support) {
    return support.isShown;
});

var isLoading = exports.isLoading = (0, _reselect.createSelector)(getSupportState, function (support) {
    return support.loading;
});

var getSupportFormPosition = exports.getSupportFormPosition = (0, _reselect.createSelector)(getSupportState, function (support) {
    return support.position;
});

var getSupportFormPositionStrategy = exports.getSupportFormPositionStrategy = (0, _reselect.createSelector)(getSupportState, function (support) {
    return support.positionStrategy;
});

var getSupportFormMode = exports.getSupportFormMode = (0, _reselect.createSelector)(getSupportState, function (support) {
    return support.mode;
});

var getSupportText = exports.getSupportText = (0, _reselect.createSelector)(getSupportState, function (support) {
    return support.text;
});

var getSupportAttachmentId = exports.getSupportAttachmentId = (0, _reselect.createSelector)(getSupportState, function (support) {
    return support.attachmentId;
});

var getSupportAttachmentName = exports.getSupportAttachmentName = (0, _reselect.createSelector)(getSupportState, function (support) {
    return support.attachmentName;
});

var getSupportEmail = exports.getSupportEmail = (0, _reselect.createSelector)(getSupportState, function (support) {
    return support.email;
});

var getEmail = exports.getEmail = (0, _reselect.createSelector)(getSupportEmail, _selectors.getEmail, function (supportEmail, userEmail) {
    return supportEmail || userEmail;
});

var getPopupInfo = exports.getPopupInfo = (0, _reselect.createSelector)(getSupportState, function (support) {
    return {
        isShown: support.isShown,
        mode: support.mode,
        text: support.text,
        attachmentId: support.attachmentId,
        attachmentName: support.attachmentName,
        email: support.email,
        position: support.position,
        positionStrategy: support.positionStrategy
    };
});

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.copyLinkTo = exports.copyCustomer = exports.getNameForCopyCustomer = exports.updateNewCommentText = exports.reloadComments = exports.closeCustomerPanel = exports.openCustomerPanel = exports.commentsServiceActions = exports.commentsActions = exports.setCanManageCustomer = exports.setAllProjectsAssigned = exports.setPanelOpenedFromUrl = exports.setOpenCustomer = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _actionTypes = __webpack_require__(675);

var ActionTypes = _interopRequireWildcard(_actionTypes);

var _selectors = __webpack_require__(249);

var selectors = _interopRequireWildcard(_selectors);

var _constants = __webpack_require__(4);

var _actionsGenerator = __webpack_require__(490);

var _actionsGenerator2 = _interopRequireDefault(_actionsGenerator);

var _commentsActionsGenerator = __webpack_require__(489);

var _commentsActionsGenerator2 = _interopRequireDefault(_commentsActionsGenerator);

var _reduxActions = __webpack_require__(9);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _rpcCalls = __webpack_require__(24);

var _rpcCalls2 = _interopRequireDefault(_rpcCalls);

var _constants2 = __webpack_require__(492);

var _actions = __webpack_require__(366);

var _CustomerStore = __webpack_require__(65);

var _CustomerStore2 = _interopRequireDefault(_CustomerStore);

var _actions2 = __webpack_require__(29);

var _utils = __webpack_require__(192);

var _ProjectStore = __webpack_require__(59);

var _ProjectStore2 = _interopRequireDefault(_ProjectStore);

var _actions3 = __webpack_require__(55);

var _actions4 = __webpack_require__(56);

var _actions5 = __webpack_require__(141);

var _ExceptionsTypes = __webpack_require__(107);

var _constants3 = __webpack_require__(108);

var _utils2 = __webpack_require__(1493);

var _atBrowserUtils = __webpack_require__(8);

var _utils3 = __webpack_require__(369);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var setOpenCustomer = exports.setOpenCustomer = (0, _reduxActions.createAction)(ActionTypes.OPEN_CUSTOMER_SET);
var setPanelOpenedFromUrl = exports.setPanelOpenedFromUrl = (0, _reduxActions.createAction)(ActionTypes.CUSTOMER_PANEL_OPENED_FROM_URL_SET);
var setAllProjectsAssigned = exports.setAllProjectsAssigned = (0, _reduxActions.createAction)(ActionTypes.ALL_PROJECTS_ASSIGNED_SET);
var setCanManageCustomer = exports.setCanManageCustomer = (0, _reduxActions.createAction)(ActionTypes.CAN_MANAGE_SET);

var commentsActions = exports.commentsActions = (0, _actionsGenerator2.default)({
    actionTypes: ActionTypes
});

var commentsServiceActions = exports.commentsServiceActions = (0, _commentsActionsGenerator2.default)({
    actions: commentsActions,
    selectors: _extends({}, selectors, {
        getOpenEntityId: selectors.getOpenCustomerId
    }),
    handleServiceError: function handleServiceError(customerId, error) {
        return _handleServiceError(customerId, error);
    },
    entityType: _constants.EntityType.CUSTOMER
});

var openCustomerPanel = exports.openCustomerPanel = function openCustomerPanel(customerId) {
    var fromUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return function (dispatch, getState) {
        var state = getState();

        var openCustomerId = selectors.getOpenCustomerId(state);

        if (openCustomerId !== customerId) {
            dispatch(setPanelOpenedFromUrl(fromUrl));
            dispatch(setOpenCustomer(customerId));
        } else {
            dispatch(closeCustomerPanel());
        }
    };
};

var closeCustomerPanel = exports.closeCustomerPanel = function closeCustomerPanel() {
    return function (dispatch) {
        dispatch(setOpenCustomer(null));
        dispatch(setPanelOpenedFromUrl(false));
    };
};

var reloadComments = exports.reloadComments = commentsServiceActions.reloadComments;

var updateNewCommentText = exports.updateNewCommentText = function updateNewCommentText(text) {
    return function (dispatch, getState) {
        var state = getState();
        var customerId = (0, _selectors.getOpenCustomerId)(state);
        if (text !== '') {
            dispatch(commentsActions.setNewComment({ entityId: customerId, text: text }));
        } else {
            dispatch(commentsActions.removeNewComment(customerId));
        }
        dispatch(commentsServiceActions.saveEntityNewCommentsTextsInLocalStorage());
    };
};

var _handleServiceError = function _handleServiceError(customerId, error) {
    if (error.getTextStatus() === 'rpc_customException') {
        switch (error.getErrorThrown().exception) {
            case 'com.actimind.actitime.services.impl.comments.NoSuchEntityException':
                alert(_messageResource2.default.getMessage('customer.edit.cannot_edit_deleted_concurrently'));
                window.location.reload();
                return true;
            case 'com.actimind.actitime.services.impl.comments.EntityNotAssignedException':
                alert(_messageResource2.default.getMessage('common.no_rights_for_operation_anymore'));
                window.location.reload();
                return true;
            case 'com.actimind.actitime.services.NoRightToEditHierarchyException':
                alert(_messageResource2.default.getMessage('common.no_rights_for_operation_anymore'));
                window.location.reload();
                return true;
            case 'com.actimind.actitime.services.impl.comments.NoSuchCommentException':
                alert(_messageResource2.default.getMessage('panel.common.comments.comment_concurrently_deleted'));
                return true;
        }
    }
    return false;
};

var getNameForCopyCustomer = exports.getNameForCopyCustomer = function getNameForCopyCustomer() {
    var onSuccessCb = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};
    return function (dispatch, getState) {
        (0, _rpcCalls2.default)("CustomerInfoService.getCustomerNameWithVersion", [(0, _selectors.getOpenCustomerName)(getState())]).then(function (newCustomerName) {
            onSuccessCb(newCustomerName);
        }).catch(function () {
            //
        });
    };
};

var copyCustomer = exports.copyCustomer = function copyCustomer(customerName, copySettings) {
    var onSuccessCb = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};
    return function (dispatch, getState) {
        dispatch((0, _actions3.toggleLoadingMoire)(true));
        dispatch((0, _actions.setBulkOperationProgress)(null));
        var copyFromCustomerId = (0, _selectors.getOpenCustomerId)(getState());
        (0, _rpcCalls.longRpcCall)("CustomerInfoService.copyCustomer", [customerName, copyFromCustomerId, !!copySettings[_constants2.CopySettingsTypes.COPY_CUSTOMER_DESCRIPTION], (0, _actions5.separateProjectCopySettings)(copySettings)], _utils2.copyCustomerRpcErrorHandler).then(function (result) {
            var customer = (0, _utils.customerFromRpc)(result.customer);
            _CustomerStore2.default.addFirst(customer);
            dispatch((0, _actions2.addCustomer)(customer));

            if (result.projects) {
                var projects = result.projects.list.map(function (data) {
                    return (0, _utils.projectFromRpc)(data);
                });
                _ProjectStore2.default.mergeAll(projects);
                dispatch((0, _actions2.addProjects)(projects));
            }

            if (result.taskIds.length > 0) {
                dispatch((0, _actions.copyTasksToProjectsAction)(result.taskIds, result.projectsOldIdsToNewIds.map, copySettings, result.operationId));
            }

            dispatch((0, _actions3.toggleLoadingMoire)(false));

            var copyFromCustomerName = _CustomerStore2.default.get(copyFromCustomerId).name;
            dispatch((0, _actions4.toast)(_messageResource2.default.getMessage("customer.copy.toast", [customer.name, copyFromCustomerName])));

            if (customerName !== customer.name) dispatch((0, _actions4.toast)(_messageResource2.default.getMessage('customer.copy.duplicate_name.toast')));

            onSuccessCb();
        }).catch(function (err) {
            switch (err.getException()) {
                case _ExceptionsTypes.NO_RIGHT_TO_EDIT_HIERARCHY_EXCEPTION:
                    alert(_messageResource2.default.getMessage("customer.error.copy.no_manage_scope_right"));
                    window.location.reload();
                    break;
                case _ExceptionsTypes.NO_SUCH_CUSTOMER_EXCEPTION:
                    alert(_messageResource2.default.getMessage("customer.error.copy.customer_deleted"));
                    window.location.reload();
                    break;
                case _constants3.Exceptions.NO_RIGHTS_FOR_REMOTE_CALL_EXCEPTION:
                    alert(_messageResource2.default.getMessage("customer.error.copy.entire_scope_revoked"));
                    window.location.reload();
                    break;
            }
        });
    };
};

var copyLinkTo = exports.copyLinkTo = function copyLinkTo() {
    return function (dispatch, getState) {
        var customerId = (0, _selectors.getOpenCustomerId)(getState());
        (0, _atBrowserUtils.copyToClipboard)((0, _utils3.createLinkToCustomer)(customerId), function () {
            dispatch((0, _actions4.toast)(_messageResource2.default.getMessage('panel.common.link_copied')));
        });
    };
};

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TableRow2 = __webpack_require__(250);

var _TableRow3 = _interopRequireDefault(_TableRow2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LockTableRow = function (_TableRow) {
    _inherits(LockTableRow, _TableRow);

    function LockTableRow() {
        _classCallCheck(this, LockTableRow);

        return _possibleConstructorReturn(this, (LockTableRow.__proto__ || Object.getPrototypeOf(LockTableRow)).apply(this, arguments));
    }

    _createClass(LockTableRow, [{
        key: "createCellRenderer",
        value: function createCellRenderer(cell) {
            if (cell.getColIdx() == 0) return this.createRowHeaderRenderer();else return this.createLockCellRenderer();
        }
    }, {
        key: "isRowHeaderCreated",
        value: function isRowHeaderCreated() {
            return this.cells.length > 0;
        }
    }, {
        key: "addCellObjWithoutAppend",
        value: function addCellObjWithoutAppend(cellObj) {
            cellObj.setRow(this);
            cellObj.setColIdx(this.cells.length);
            this.cells.push(cellObj);
        }
    }, {
        key: "getHeaderCell",
        value: function getHeaderCell() {
            return this.getCell(0);
        }
    }, {
        key: "getTodayCell",
        value: function getTodayCell() {
            if (this.getTable().containsViewerTodayColumn()) {
                return this.getCell(this.getTable().getViewerTodayColIdx());
            }
            return null;
        }
    }, {
        key: "isViewerTodayCell",
        value: function isViewerTodayCell(cell) {
            if (this.getTable().containsViewerTodayColumn()) {
                return cell.getColIdx() == this.getTable().getViewerTodayColIdx();
            }
            return false;
        }
    }, {
        key: "createRowHeaderRenderer",
        value: function createRowHeaderRenderer() {
            //Note: should be implemented in inheritor
        }
    }, {
        key: "createLockCellRenderer",
        value: function createLockCellRenderer() {
            //Note: should be implemented in inheritor
        }
    }]);

    return LockTableRow;
}(_TableRow3.default);

exports.default = LockTableRow;

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.APUserGroupManagementController = exports.ATUserGroupManagementController = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.BaseGroupManagementController = BaseGroupManagementController;
exports.TimeZoneGroupManagementController = TimeZoneGroupManagementController;

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _group_management_util = __webpack_require__(386);

var _group_management_util2 = _interopRequireDefault(_group_management_util);

var _group_data_retrieve_rpc_manager = __webpack_require__(825);

var _group_data_retrieve_rpc_manager2 = _interopRequireDefault(_group_data_retrieve_rpc_manager);

var _rpc_control_manager = __webpack_require__(235);

var _rpc_control_manager2 = _interopRequireDefault(_rpc_control_manager);

var _StringIndex = __webpack_require__(115);

var _StringIndex2 = _interopRequireDefault(_StringIndex);

var _StringTokenizer = __webpack_require__(103);

var _StringTokenizer2 = _interopRequireDefault(_StringTokenizer);

var _FilterWordsField = __webpack_require__(348);

var _FilterWordsField2 = _interopRequireDefault(_FilterWordsField);

var _filter_words_popup = __webpack_require__(464);

var _filter_words_popup2 = _interopRequireDefault(_filter_words_popup);

var _TokensHighlighter = __webpack_require__(94);

var _TokensHighlighter2 = _interopRequireDefault(_TokensHighlighter);

var _ScrollUtils = __webpack_require__(39);

var _ScrollUtils2 = _interopRequireDefault(_ScrollUtils);

var _EmptyHighlighter = __webpack_require__(137);

var _EmptyHighlighter2 = _interopRequireDefault(_EmptyHighlighter);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _atBrowserUtils = __webpack_require__(8);

var _atUtils = __webpack_require__(5);

var _keyCodes = __webpack_require__(66);

var _GroupWithUsers = __webpack_require__(387);

var _GroupWithUsers2 = _interopRequireDefault(_GroupWithUsers);

var _UserInGroup = __webpack_require__(388);

var _UserInGroup2 = _interopRequireDefault(_UserInGroup);

var _ATUserGroupManagementService = __webpack_require__(826);

var _ATUserGroupManagementService2 = _interopRequireDefault(_ATUserGroupManagementService);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Main controller in group management lightbox. Contains references on another controllers. Provide key functions to manage groups.
 * Do not stored in global variable, passes into big amount of functions instead.
 */
function BaseGroupManagementController() {}
/**
 * @param renderer CommonRenderer instance
 * @param groupController GroupController instance
 * @param userController UserController instance
 * @param ddController DDController instance
 * @param addGroupController AddGroupController instance
 * @param highlightController HighlightController instance
 * @param emptyGroupResolver EmptyGroupResolver instance
 * @param groupContainer dom container with group rows
 * @param selectAllImg image on 'select all' button
 * @param clearAllImg image on 'clear all' button
 * @param filterUsersImg image on 'filter users' button
 * @param showDisabledCheckbox checkbox 'show users with disabled access'
 * @param showDisabledLabel label near checkbox 'show users with disabled access'
 * @param errorMessagesRow row where error messages placed
 * @param errorMessagesText text element into errorMessagesRow
 * @param lightboxContainer top dom element of the lightbox
 * @param opacityIconsClassName class name to make all icons transparent due to ajax request processing. Placed into lightboxContainer.
 * @param dragAndDropIsNowClassName class name to change state of elements due to drag and drop. Placed into lightboxContainer.
 * @param serviceName name of the RPC java service
 * @param groupNamingKey
 * @param spinnerController spinner controller
 * @param spinnerContainerId id of dom container to put spinner in
 * @param dataLoadingClassName class name to make spinner visible while data is loading
 * @param validatorGroupStrategy
 */
BaseGroupManagementController.prototype.init = function (renderer, groupController, userController, ddController, addGroupController, highlightController, emptyGroupResolver, groupContainer, selectAllImg, clearAllImg, filterUsersImg, showDisabledCheckbox, showDisabledLabel, errorMessagesRow, errorMessagesText, lightboxContainer, opacityIconsClassName, dragAndDropIsNowClassName, serviceName, groupNamingKey, spinnerController, spinnerContainerId, dataLoadingClassName, validatorGroupStrategy) {
    this.renderer = renderer;
    this.groupController = groupController;
    this.userController = userController;
    this.ddController = ddController;
    this.addGroupController = addGroupController;
    this.highlightController = highlightController;
    this.emptyGroupResolver = emptyGroupResolver;
    this.showDisabledCheckbox = showDisabledCheckbox;
    this.errorMessagesRow = errorMessagesRow;
    this.errorMessagesText = errorMessagesText;
    this.lightboxContainer = lightboxContainer;
    this.opacityIconsClassName = opacityIconsClassName;
    this.dragAndDropIsNowClassName = dragAndDropIsNowClassName;
    this.serviceName = serviceName;
    this.defineStateOfNotRenderedElements(selectAllImg, clearAllImg, filterUsersImg, showDisabledLabel);
    //Needed to enable/disable controls when AJAX request is processed
    this.isAJAXRequestProcessedNow = false;
    this.renderer.generateAddGroupControlContent();
    this.addGroupController.initAfterShowing(this);
    this.buildMoveToMenu();
    this.groupNamingKey = groupNamingKey;
    this.spinnerController = spinnerController;
    this.spinnerContainerId = spinnerContainerId;
    this.dataLoadingClassName = dataLoadingClassName;
    this.validatorGroupStrategy = validatorGroupStrategy;

    return this;
};

/**
 * Init needed controls after lightbox displaying
 */
BaseGroupManagementController.prototype.initAfterShowing = function () {
    (0, _atBrowserUtils.addClass)(this.lightboxContainer, this.dataLoadingClassName);
    this.spinnerController.spin(this.spinnerContainerId);
    var context = this;
    this.readData(function () {
        (0, _atBrowserUtils.removeClass)(context.lightboxContainer, context.dataLoadingClassName);
        context.spinnerController.stop();
    });
    //Override esc handler of lightbox(which placed in document)
    document.body.onkeydown = function (event) {
        _group_management_util2.default.createEscPressedHandler(event, function () {
            var ifEditControlsCancelled = false;
            if (context.moveToMenu && !context.moveToMenu.menu.hidden) {
                context.moveToMenu.hideMenu();
                ifEditControlsCancelled = true;
            }
            if (context.endGroupEditing(false)) {
                ifEditControlsCancelled = true;
                context.hideErrors();
            }
            if (context.endConfirmGroupDelete()) {
                ifEditControlsCancelled = true;
            }
            // if at least one canceled - prevent event bubble
            if (ifEditControlsCancelled) {
                (0, _atBrowserUtils.cancelBubble)(event);
                return;
            }
            // words popup closed latest
            if (context.filterWordsPopup && context.filterWordsPopup.isShown()) {
                context.filterWordsPopup.hide();
                (0, _atBrowserUtils.cancelBubble)(event);
            }
        });
    };
    this.isChangesMade = false;
};

/**
 * Read data via ajax from server.
 * @param afterSavingCallback function called after success data reading
 */
BaseGroupManagementController.prototype.readData = function (afterSavingCallback) {
    var context = this;
    var manager = new _group_data_retrieve_rpc_manager2.default(this.serviceName, this, function () {
        context.hideLightbox();
    }, afterSavingCallback);
    _rpc_control_manager2.default.saveRpcControlBoundData(manager, false);
};

/**
 * Set object with lightbox
 * @param lightbox CreateLightbox instance
 */
BaseGroupManagementController.prototype.setLightbox = function (lightbox) {
    lightbox.hideOnResize = function () {
        return false;
    };
    lightbox.hideOnMouseDown = function () {
        return false;
    };
    this.lightbox = lightbox;
};

/**
 * Force lightbox hiding
 */
BaseGroupManagementController.prototype.hideLightbox = function () {
    if (this.lightbox) {
        this.lightbox.hide();
    }
};

/**
 * Performs operations with data reading from server
 * @param result data
 */
BaseGroupManagementController.prototype.dataRetrievingCompleted = function (result) {
    this.storedData = this.castGroupBeanWithUsersToJsDataArrays(result);
    this.buildView(this.storedData, true);
};

/**
 * Set event handlers to not rendered elements(defined in group_management.jsp)
 * @param selectAllImg image on 'select all' button
 * @param clearAllImg image on 'clear all' button
 * @param filterUsersImg image on 'filter users button'
 * @param showDisabledLabel label near checkbox 'show users with disabled access'
**/
BaseGroupManagementController.prototype.defineStateOfNotRenderedElements = function (selectAllImg, clearAllImg, filterUsersImg, showDisabledLabel) {
    var context = this;
    var selectAllFunction = function selectAllFunction() {
        context.passiveEventHandler(function () {
            context.getUserController().selectAll();
        }, true);
    };
    var clearAllFunction = function clearAllFunction() {
        context.passiveEventHandler(function () {
            context.getUserController().clearAll();
        }, true);
    };
    var filterUsersFunction = function filterUsersFunction() {
        context.passiveEventHandler(function () {
            context.initUsersFilter(filterUsersImg);
        }, true);
    };
    selectAllImg.onclick = selectAllFunction;
    clearAllImg.onclick = clearAllFunction;
    filterUsersImg.onclick = filterUsersFunction;
    this.showDisabledCheckbox.onclick = function () {
        var that = this;
        context.passiveEventHandler(function () {
            context.reloadDisabledUsers(that.checked);
        }, true);
    };
    (0, _atBrowserUtils.disableTextSelection)(showDisabledLabel);
};

/**
 * Prepare search index for users of selected group
 * @returns {StringIndex}
 */
BaseGroupManagementController.prototype.prepareSearchIndexForSelectedGroupUsers = function () {
    var searchIndex = new _StringIndex2.default(new _StringTokenizer2.default(_StringTokenizer2.default.PUNCTUATORS));
    var currentGroupUsers = this.groupController.getSelectedGroup().users;

    _underscore2.default.each(currentGroupUsers, function (user) {
        searchIndex.add(user.name, user.id);
    });
    return searchIndex;
};
/**
 * Init users filter popup and show near filter button
 * @param filterUsersImg - button 'filter users'
 */
BaseGroupManagementController.prototype.initUsersFilter = function (filterUsersImg) {
    if (this.isAJAXRequestProcessedNow) {
        return;
    }

    var context = this;
    this.savedSelectedUserIds = [];

    this.searchIndex = this.prepareSearchIndexForSelectedGroupUsers(); //get actual search index
    if (!this.filterWordsPopup) {
        this.filterWordsField = new _FilterWordsField2.default().initAndRender(function () {
            context.filterUsersByName(context.searchIndex, context.filterWordsField.getSearchString());
        }, null, null, function () {
            context.filterWordsField.clearInputValue();
            context.filterUsersByName(context.searchIndex, context.filterWordsField.getSearchString());
        });
        this.filterWordsPopup = new _filter_words_popup2.default().initAndRender("filterWordsPopup-" + this.lightboxContainer.id, filterUsersImg.id, this.lightboxContainer.id, true, this.filterWordsField.getElement(), function () {
            context.filterWordsField.clearInputValue(true);
        });
    }

    this.filterWordsPopup.show(-95, -3);
    this.filterWordsField.activateAndFocus();
};

/**
 * Merge saved selected users ids with current selected ids
 * Add not selected user ids and remove currently unselected user ids
 * @param currentSelectedUsersIds
 * @returns {Array|*}
 */
BaseGroupManagementController.prototype.mergeSavedSelectedUsersIdsWithCurrent = function (currentSelectedUsersIds) {
    // merge selected users with actual selection
    var selectedUsersIds = this.savedSelectedUserIds;
    var selectedVisibleUsersIds = currentSelectedUsersIds;
    // add new selected users
    _underscore2.default.each(selectedVisibleUsersIds, function (id) {
        if (selectedUsersIds.indexOf(id) == -1) {
            selectedUsersIds.push(id);
        }
    });
    // merge unselected users
    var currentVisibleUsers = this.userController.getUsers();
    for (var ind in currentVisibleUsers) {
        //noinspection JSUnfilteredForInLoop
        var visibleUserId = currentVisibleUsers[ind].id;
        if (selectedUsersIds.indexOf(visibleUserId) != -1) // if previously selected user is visible currently
            {
                if (selectedVisibleUsersIds.indexOf(visibleUserId) == -1) // but became not selected
                    {
                        selectedUsersIds.remove(visibleUserId); // remove it
                    }
            }
    }
    this.savedSelectedUserIds = selectedUsersIds; // update selected users
    return selectedUsersIds;
};

/**
 * Filter users by name (show users that names contains text matches with entered text)
 * @param searchIndex - prepared search index for users of selected group
 * @param filterValue - search value
 */
BaseGroupManagementController.prototype.filterUsersByName = function (searchIndex, filterValue) {
    var selectedUsersIds = this.mergeSavedSelectedUsersIdsWithCurrent(this.userController.getSelectedUserIds(false));

    if (filterValue == '') {
        this.reloadUsers(selectedUsersIds);
    } else {
        var searchTokens = searchIndex.getTokenizer().getTokens(filterValue.toLowerCase());
        if (searchTokens.length > 0) {
            var filteredUserIds = searchIndex.search(searchTokens);
            var filteredUsers = [];
            _underscore2.default.each(this.groupController.getSelectedGroup().users, function (user) {
                if (filteredUserIds.hasOwnProperty(user.id)) {
                    filteredUsers.push(user);
                }
            });
            this.reloadUsersByFilteredUsersList(filteredUsers, selectedUsersIds, new _TokensHighlighter2.default(searchTokens, searchIndex.getTokenizer().getPunctuators()));
        }
    }
    this.initUserContainerCustomScroll();
};

/**
 * Update search index with actual data and perform filtering if filter popup opened
 */
BaseGroupManagementController.prototype.forceUserFilteringIfNeed = function () {
    if (this.filterWordsPopup && this.filterWordsPopup.isShown()) {
        this.savedSelectedUserIds = [];
        this.searchIndex = this.prepareSearchIndexForSelectedGroupUsers();
        this.filterUsersByName(this.searchIndex, this.filterWordsField.getSearchString());
    }
};

/**
 * Sort data from server
 * @param data array with GroupWithUsers instances
 */
BaseGroupManagementController.prototype.sortData = function (data) {
    data.sort(this.validatorGroupStrategy.getComparator());
    for (var i = 0; i < data.length; i++) {
        this.sortUsers(data[i].users);
    }
};

/**
 * Sort only users data from server
 * @param users array with UserInGroup instances
 */
BaseGroupManagementController.prototype.sortUsers = function (users) {
    users.sort(_atUtils.nameComparator);
};

/**
 * Build lightbox view. Define state of elements.
 * @param data array with GroupWithUsers instances
 * @param isNeededToReloadUsers is needed to reload rows with users in user container
 * @param savedSelectedUserIds saved users selection(optional)
 */
BaseGroupManagementController.prototype.buildView = function (data, isNeededToReloadUsers, savedSelectedUserIds) {
    this.isAJAXRequestProcessedNow = false;
    this.addGroupController.changeStateIfNeeded(this);
    this.sortData(data);
    if (isNeededToReloadUsers) {
        this.reloadAll(data, savedSelectedUserIds);
    } else {
        this.reloadGroups(data);
    }
    this.changeMoveToMenuState();

    this.initGroupContainerCustomScroll();
    this.initUserContainerCustomScroll();

    this.forceUserFilteringIfNeed();
};

BaseGroupManagementController.prototype.initGroupContainerCustomScroll = function () {
    if (!this.groupContainerScroll) this.groupContainerScroll = this.createCustomScroll((0, _jquery2.default)(this.renderer.userGroupContainer));else _ScrollUtils2.default.refreshCustomScroll(this.groupContainerScroll);
};

BaseGroupManagementController.prototype.initUserContainerCustomScroll = function () {
    if (!this.userContainerScroll) this.userContainerScroll = this.createCustomScroll((0, _jquery2.default)(this.renderer.userContainer));else _ScrollUtils2.default.refreshCustomScroll(this.userContainerScroll);
};

/**
 * Init custom scroll using iScroll library
 * for ie8 standard scroll is used
 * @param placeholderEl scrollable element (not wrapper)
 */
BaseGroupManagementController.prototype.createCustomScroll = function (placeholderEl) {
    return _ScrollUtils2.default.addVerticalScroll((0, _jquery2.default)(placeholderEl).parent(), { isFaded: true });
};

/**
 * Fires if group was selected
 * @param group GroupRow instance
 */
BaseGroupManagementController.prototype.groupSelected = function (group) {
    if (group.id != this.groupController.getSelectedGroup().id) {
        this.reInitControlsAfterGroupSelection(group.id);
        this.reloadUsers();
        this.initUserContainerCustomScroll();
        this.forceUserFilteringIfNeed();
    }
};

/**
 * Reinit all controls after group selection
 * @param groupId
 */
BaseGroupManagementController.prototype.reInitControlsAfterGroupSelection = function (groupId) {
    this.groupController.groupSelected(this, groupId);
    this.reInitMoveToMenu();
};

/**
 * Reinit move to menu items
 */
BaseGroupManagementController.prototype.reInitMoveToMenu = function () {
    var groupsForMoveToMenu = this.groupController.getGroupsSuitableForDrop();
    groupsForMoveToMenu.sort(this.validatorGroupStrategy.getComparator());
    this.renderer.reInitMoveToMenu(this, this.moveToMenu, groupsForMoveToMenu);
};

/**
 * Rebuild group rows in group container
 * @param data array with GroupWithUsers instances
 */
BaseGroupManagementController.prototype.reloadGroups = function (data) {
    this.renderer.generateGroupContent(data);
    this.groupController.initGroups(data, this);
    this.reInitControlsAfterGroupSelection(this.getNewSelectedGroupId());
};

/**
 * Rebuild user rows in user container for users in selected group
 * @param savedSelectedUserIds saved users selection
 */
BaseGroupManagementController.prototype.reloadUsers = function (savedSelectedUserIds) {
    this.reloadUsersByUsersList(this.groupController.getSelectedGroup().users, savedSelectedUserIds, false);
};

BaseGroupManagementController.prototype.reloadUsersByFilteredUsersList = function (users, savedSelectedUserIds, highlighter) {
    this.reloadUsersByUsersList(users, savedSelectedUserIds, highlighter, true);
};

/**
 * rebuild users rows in user container for lists of users with highlighting
 * @param users - list of users
 * @param savedSelectedUserIds - saved selection
 * @param highlighter - highlighter for users
 * @param filtered - is filter applied
 */
BaseGroupManagementController.prototype.reloadUsersByUsersList = function (users, savedSelectedUserIds, highlighter, filtered) {
    highlighter = highlighter || new _EmptyHighlighter2.default();
    var isShowDisabledUsers = this.showDisabledCheckbox.checked;

    var selectedGroup = this.groupController.getSelectedGroup();
    this.filtered = filtered;
    this.emptyDueToFilter = selectedGroup.users.length != 0 && users.length == 0 && filtered;

    this.renderer.generateUserContent(this, selectedGroup, users, isShowDisabledUsers, highlighter);

    this.userController.init(this, users, isShowDisabledUsers, this.isAJAXRequestProcessedNow);

    if (savedSelectedUserIds) {
        this.userController.selectSavedUsers(savedSelectedUserIds);
    }

    this.changeMoveToMenuState();
};

/**
 * Reload group and users
 * @param data array with GroupWithUsers instances
 * @param savedSelectedUserIds saved users selection
 */
BaseGroupManagementController.prototype.reloadAll = function (data, savedSelectedUserIds) {
    this.reloadGroups(data);
    this.reloadUsers(savedSelectedUserIds);
};

/**
 * Return new selected group id. If old selected group is not exists or there is a first lightbox creation, returns first group.
 */
BaseGroupManagementController.prototype.getNewSelectedGroupId = function () {
    var selectedGroup = this.groupController.getSelectedGroup();
    return selectedGroup ? selectedGroup.id : this.storedData[0].id;
};

/**
 * Build move to menu
 */
BaseGroupManagementController.prototype.buildMoveToMenu = function () {
    this.moveToMenu = this.renderer.generateMoveToMenu();
};

/**
 * Enable or disable move to menu in dependence of some lightbox controls state
 */
BaseGroupManagementController.prototype.changeMoveToMenuState = function () {
    if (this.userController.hasUsersSelected(this.isDisabledUsersShownDueToFilter()) && !this.isAJAXRequestProcessedNow && this.moveToMenu.menu.items.length != 0) {
        this.moveToMenu.enable();
    } else {
        this.moveToMenu.disable();
    }
};

BaseGroupManagementController.prototype.isDisabledUsersShownDueToFilter = function () {
    return this.filtered && !this.emptyDueToFilter;
};

/**
 * Handle 'Show disabled users' checkbox pressing
 * @param checked state of 'Show disabled users' checkbox
 */
BaseGroupManagementController.prototype.reloadDisabledUsers = function (checked) {
    var selectedGroup = this.getGroupController().getSelectedGroup();

    if (this.emptyDueToFilter) {
        this.emptyGroupResolver.resolveEmptyUserGroupAfterFilterApplied(selectedGroup);
    } else {
        var countOfDisabledUsers = this.userController.reloadDisabledUsers(checked, this.filtered);
        this.emptyGroupResolver.resolveEmptyUserGroupElementState(selectedGroup, checked, countOfDisabledUsers);
    }

    this.initUserContainerCustomScroll();
};

/**
 * Fires after lightbox hides
 * @param callback function called at user list if changes were made
 */
BaseGroupManagementController.prototype.hideLightboxHandler = function (callback) {
    if (this.moveToMenu) {
        this.moveToMenu.hideMenu();
    }
    this.hideErrors();
    this.addGroupController.resetRowIntoDefaultState();
    this.groupController.cleanup();
    this.renderer.cleanup();
    document.body.onkeydown = function () {};
    if (this.isChangesMade) {
        callback();
    }
    if (this.filterWordsPopup && this.filterWordsPopup.isShown()) {
        this.filterWordsPopup.hide();
    }
};

/**
 * Handles move to menu item click event
 * @param groupId id of selected group in menu
 */
BaseGroupManagementController.prototype.moveToMenuClicked = function (groupId) {
    var group = this.groupController.getGroup(groupId);
    _ScrollUtils2.default.scrollIntoViewVertical(this.groupContainerScroll, group.div, _ScrollUtils2.default.POSITIONS.CENTER);
    this.ddController.dropUsersWithChecking(this, groupId, this.userController.getSelectedUserIds(this.isDisabledUsersShownDueToFilter()));
};

/**
 * Lock all needed elements when ajax request is proccessing
 */
BaseGroupManagementController.prototype.lockNeededElementsDueToAJAX = function () {
    this.isAJAXRequestProcessedNow = true;
    this.setAJAXClassNamesToLightboxContainer();
    this.moveToMenu.disable();
    var users = this.userController.getUsers();
    for (var i in users) {
        //noinspection JSUnfilteredForInLoop
        users[i].ddWrapper.lock();
    }
    var groups = this.groupController.getGroups();
    for (var j in groups) {
        //noinspection JSUnfilteredForInLoop
        groups[j].disableControlsDueToAjax();
    }
    this.addGroupController.changeStateIfNeeded(this);
};

/**
 * Unlock all needed elements when ajax request processing is ended
 */
BaseGroupManagementController.prototype.unlockNeededElementsDueToAJAX = function () {
    this.isAJAXRequestProcessedNow = false;
    this.removeAJAXClassNamesFromLightboxContainer();
    this.changeMoveToMenuState();
    var users = this.userController.getUsers();
    for (var i in users) {
        //noinspection JSUnfilteredForInLoop
        users[i].ddWrapper.unlock();
    }
    var groups = this.groupController.getGroups();
    for (var j in groups) {
        //noinspection JSUnfilteredForInLoop
        groups[j].enableControls();
    }
    this.addGroupController.changeStateIfNeeded(this);
};

/**
 * Return true if user can hide lightbox and false otherwise
 */
BaseGroupManagementController.prototype.isPermitToHideLightbox = function () {
    return !this.isAJAXRequestProcessedNow;
};

/**
 * Delete group
 * @param group GroupRow instance
 */
BaseGroupManagementController.prototype.deleteGroup = function (group) {
    var manager = new GroupDeleteRPCManager(this.getServiceName(), this, group.id, this.groupNamingKey);
    _rpc_control_manager2.default.saveRpcControlBoundData(manager, false);
};

/**
 * Rework data and rebuild view with it after successful group deletion
 * @param groupId id of deleted user group
 */
BaseGroupManagementController.prototype.rebuildViewAfterGroupDeletion = function (groupId) {
    for (var i = 0; i < this.storedData.length; i++) {
        if (groupId == this.storedData[i].id) {
            var users = this.storedData[i].users;
            for (var j = 0; j < users.length; j++) {
                this.storedData[0].users.push(users[j]);
            }
            this.storedData.splice(i, 1);
            var selectedGroup = this.groupController.getSelectedGroup();
            this.buildView(this.storedData, groupId == selectedGroup.id || this.isNeedToRebuildUsersAfterGroupDeletion(selectedGroup));
            break;
        }
    }
};

/**
 * Rework data and rebuild view with it after successful group editing
 * @param group edited user group
 */
BaseGroupManagementController.prototype.rebuildViewAfterGroupEditing = function (group) {
    for (var i = 0; i < this.storedData.length; i++) {
        if (group.id == this.storedData[i].id) {
            var positionOld = i;
            var positionNew = -1;
            this.copyGroupData(this.storedData[i], group);
            this.buildView(this.storedData, false);
            for (var j = 0; j < this.storedData.length; j++) {
                if (group.id == this.storedData[j].id) {
                    positionNew = j;
                    break;
                }
            }
            if (positionOld != positionNew) {
                _ScrollUtils2.default.scrollIntoViewVertical(this.groupContainerScroll, this.groupController.getGroup(group.id).div, _ScrollUtils2.default.POSITIONS.CENTER);
            }
            if (this.groupController.getSelectedGroup().id == group.id) {
                this.emptyGroupResolver.replaceUserGroupNameInLabel(group.name);
            }
            //Fix for Chrome bug. It doesn't change cursor from waiting state.
            document.body.style.cursor = "default";
            break;
        }
    }
};

/**
 * Rebuild view after case when user get timeout message and clicks 'Cancel' on it
 */
BaseGroupManagementController.prototype.rebuildViewAfterTimeOutError = function () {
    this.buildView(this.storedData, false);
};

/**
 * Rework data and rebuild view with it after successful group creation
 * @param group new group
 */
BaseGroupManagementController.prototype.rebuildViewAfterGroupCreation = function (group) {
    this.addGroupController.resetRowIntoDefaultState();
    var groupWithUsers = new _GroupWithUsers2.default(group.id, group.name, this.validatorGroupStrategy, [], []);
    this.copyGroupData(groupWithUsers, group);
    this.storedData.push(groupWithUsers);
    this.buildView(this.storedData, false);
    _ScrollUtils2.default.scrollIntoViewVertical(this.groupContainerScroll, this.groupController.getGroup(group.id).div, _ScrollUtils2.default.POSITIONS.CENTER);
    this.groupController.highlightGroup(this, group.id);
};

/**
 * Rework data and rebuild view with it after successful moving users into another group
 * @param targetGroupId id of group intended for moving to
 * @param userIds ids of users intended for moving
 * @param concurrentlyDeletedUserIds user ids concurrently deleted on server
 */
BaseGroupManagementController.prototype.rebuildViewAfterUsersMoving = function (targetGroupId, userIds, concurrentlyDeletedUserIds) {
    var sourceGroupId = this.groupController.selectedGroup.id;
    var sourceUsers = null;
    var targetGroupIndex = -1;
    for (var i = 0; i < this.storedData.length; i++) {
        if (this.storedData[i].id == sourceGroupId) {
            sourceUsers = _group_management_util2.default.removeObjectsFromArrayAndReturnThem(userIds, this.storedData[i].users, concurrentlyDeletedUserIds);
            if (targetGroupIndex != -1) {
                i = targetGroupIndex;
            }
        }
        if (this.storedData[i].id == targetGroupId) {
            if (sourceUsers != null) {
                for (var j = 0; j < sourceUsers.length; j++) {
                    this.storedData[i].users.push(sourceUsers[j]);
                }
                break;
            } else {
                targetGroupIndex = i;
            }
        }
    }
    this.buildView(this.storedData, true, this.userController.getSelectedUserIds(false));
};

/**
 * Reinit needed controls when user start to edit group
 * @param group GroupRow instance
 */
BaseGroupManagementController.prototype.startGroupEditing = function (group) {
    this.groupController.startGroupEditing(group);
    this.reInitMoveToMenu();
};

BaseGroupManagementController.prototype.confirmGroupDelete = function (group) {
    this.groupController.confirmGroupDelete(group);
    this.reInitMoveToMenu();
};

/**
 * Show error message with specified text in bottom error messages row
 * @param text text of error message
 */
BaseGroupManagementController.prototype.showErrorMessage = function (text) {
    this.errorMessagesText.innerHTML = text;
    this.errorMessagesRow.style.display = '';
};

BaseGroupManagementController.prototype.showDuplicateUserGroupMessage = function () {
    this.showErrorMessage(_messageResource2.default.getMessage("group_management.group_exists"));
};

/**
 * Hide row with error messages
 */
BaseGroupManagementController.prototype.hideErrors = function () {
    this.errorMessagesRow.style.display = 'none';
    this.groupController.paintDuplicateGroupsAsValid();
    _group_management_util2.default.markCellAsValid(this.addGroupController.newGroupInputCell);
};

/**
 * Set class names to lightbox to change state of elements due to ajax
 */
BaseGroupManagementController.prototype.setAJAXClassNamesToLightboxContainer = function () {
    (0, _atBrowserUtils.addClass)(this.lightboxContainer, this.opacityIconsClassName);
};

/**
 * Remove class names from lightbox to change state of elements when ajax processing is ended
 */
BaseGroupManagementController.prototype.removeAJAXClassNamesFromLightboxContainer = function () {
    (0, _atBrowserUtils.removeClass)(this.lightboxContainer, this.opacityIconsClassName);
};

/**
 * Set class names to lightbox to change state of elements due drag and drop
 */
BaseGroupManagementController.prototype.setDragAndDropClassNamesToLightboxContainer = function () {
    (0, _atBrowserUtils.addClass)(this.lightboxContainer, this.dragAndDropIsNowClassName);
};

/**
 * Remove class names from lightbox to change state of elements when drag and drop is ended
 */
BaseGroupManagementController.prototype.removeDragAndDropClassNamesFromLightboxContainer = function () {
    (0, _atBrowserUtils.removeClass)(this.lightboxContainer, this.dragAndDropIsNowClassName);
};

/**
 * End editing of an group. If there are not currently edited group, do nothing.
 * @param isSave save new group name or not
 * Returns true if group editing ended without saving and false otherwise
 */
BaseGroupManagementController.prototype.endGroupEditing = function (isSave) {
    var result = false;
    if (isSave) {
        var editedGroup = this.groupController.getEditedGroup();
        if (editedGroup) {
            if (editedGroup.isNameChanged()) {
                this.groupController.startNewGroupNameSaving(this, editedGroup);
            } else {
                result = true;
            }
        }
    }
    if (!isSave || result) {
        result = this.groupController.endGroupEditing();
    }
    this.reInitMoveToMenu();
    this.changeMoveToMenuState();
    return result;
};

BaseGroupManagementController.prototype.endConfirmGroupDelete = function () {
    var result = this.groupController.endConfirmGroupDelete();
    this.reInitMoveToMenu();
    this.changeMoveToMenuState();
    return result;
};

/**
 * Handle unexpected error form server
 */
BaseGroupManagementController.prototype.handleUnexpectedServerError = function () {
    var context = this;
    this.readData(function () {
        context.showErrorMessage(_messageResource2.default.getMessage("common.ajax.unexpected_server_error"));
    });
};

/**
 * Returns selected group id if some group was selected and null otherwise
 */
BaseGroupManagementController.prototype.getSelectedUserGroupId = function () {
    var selectedGroup = this.groupController.getSelectedGroup();
    return selectedGroup ? selectedGroup.id : null;
};

/**
 * Action template. Defines action with groups
 * @param handler called function
 * @param isSaveEditedGroup save currently edited group(if it is present) or not
 */
BaseGroupManagementController.prototype.groupEventHandler = function (handler, isSaveEditedGroup) {
    this.hideErrors();
    this.endGroupEditing(isSaveEditedGroup);
    this.endConfirmGroupDelete(false);
    handler();
};

/**
 * Action template. Defines passive actions
 * @param handler called function
 * @param isMoveToMenuChangeStateNeeded change move to menu state or not
 */
BaseGroupManagementController.prototype.passiveEventHandler = function (handler, isMoveToMenuChangeStateNeeded) {
    this.hideErrors();
    handler();
    if (isMoveToMenuChangeStateNeeded) {
        this.changeMoveToMenuState();
    }
};

BaseGroupManagementController.prototype.getHighlightController = function () {
    return this.highlightController;
};

BaseGroupManagementController.prototype.getGroupController = function () {
    return this.groupController;
};

BaseGroupManagementController.prototype.getUserController = function () {
    return this.userController;
};

BaseGroupManagementController.prototype.getDDController = function () {
    return this.ddController;
};

BaseGroupManagementController.prototype.getAddGroupController = function () {
    return this.addGroupController;
};

BaseGroupManagementController.prototype.getEmptyGroupResolver = function () {
    return this.emptyGroupResolver;
};

BaseGroupManagementController.prototype.isShowDisabledUsers = function () {
    return this.userController.isShowDisabledUsers;
};

BaseGroupManagementController.prototype.getServiceName = function () {
    return this.serviceName;
};

BaseGroupManagementController.prototype.copyGroupData = function (groupWithUsers, group) {
    groupWithUsers.id = group.id;
    groupWithUsers.name = group.name;
    if (group.users) {
        groupWithUsers.users = group.users;
    }
};

/**
 * Cast data from server into arrays of javascript classes - GroupWithUsers and UserInGroup
 * @param data
 */
BaseGroupManagementController.prototype.castGroupBeanWithUsersToJsDataArrays = function (data) {
    var result = [];
    var groups = data.list;
    for (var i = 0; i < groups.length; i++) {
        var users = [];
        var sourceUsers = groups[i].users.list;
        for (var j = 0; j < sourceUsers.length; j++) {
            users.push(new _UserInGroup2.default(sourceUsers[j].id, _group_management_util2.default.formatUserName(sourceUsers[j]), sourceUsers[j].enabled, sourceUsers[j].requiresTTApproval));
        }
        var newGroupName = this.isNeedUsersWithoutGroupName(groups[i].group.id) ? groups[i].group.name : _messageResource2.default.getMessage('common.users_without_group');
        var groupWithUsers = new _GroupWithUsers2.default(groups[i].group.id, newGroupName, this.validatorGroupStrategy, users);
        this.copyGroupData(groupWithUsers, groups[i].group);
        result.push(groupWithUsers);
    }
    return result;
};

BaseGroupManagementController.prototype.isNeedUsersWithoutGroupName = function (group) {
    return this.validatorGroupStrategy.isNullGroup(group);
};

BaseGroupManagementController.prototype.isNeedToRebuildUsersAfterGroupDeletion = function (group) {
    return this.validatorGroupStrategy.isNullGroup(group);
};

function TimeZoneGroupManagementController() {}

TimeZoneGroupManagementController.prototype = new BaseGroupManagementController();

TimeZoneGroupManagementController.prototype.init = function (renderer, groupController, userController, ddController, addGroupController, highlightController, emptyGroupResolver, groupContainer, selectAllImg, clearAllImg, filterUsersImg, showDisabledCheckbox, showDisabledLabel, errorMessagesRow, errorMessagesText, lightboxContainer, opacityIconsClassName, dragAndDropIsNowClassName, serviceName, groupNamingKey, spinnerController, spinnerContainerId, dataLoadingClassName, validatorGroupStrategy, onlyOneGroupClassName) {
    BaseGroupManagementController.prototype.init.call(this, renderer, groupController, userController, ddController, addGroupController, highlightController, emptyGroupResolver, groupContainer, selectAllImg, clearAllImg, filterUsersImg, showDisabledCheckbox, showDisabledLabel, errorMessagesRow, errorMessagesText, lightboxContainer, opacityIconsClassName, dragAndDropIsNowClassName, serviceName, groupNamingKey, spinnerController, spinnerContainerId, dataLoadingClassName, validatorGroupStrategy);
    this.onlyOneGroupClassName = onlyOneGroupClassName;

    return this;
};

TimeZoneGroupManagementController.prototype.copyGroupData = function (groupWithUsers, group) {
    groupWithUsers.id = group.id;
    groupWithUsers.name = group.name;
    groupWithUsers.cityPlaceId = group.cityPlaceId;
    groupWithUsers.cityName = group.cityName;
    groupWithUsers.timeZoneId = group.timeZoneId;
    groupWithUsers.rawOffset = group.rawOffset;
    groupWithUsers.currentTime = group.currentTime;
};

TimeZoneGroupManagementController.prototype.isNeedUsersWithoutGroupName = function (groupId) {
    return false;
};

TimeZoneGroupManagementController.prototype.isNeedToRebuildUsersAfterGroupDeletion = function (group) {
    return this.validatorGroupStrategy.isDefaultGroup(group);
};

TimeZoneGroupManagementController.prototype.buildView = function (data, isNeededToReloadUsers, savedSelectedUserIds) {
    BaseGroupManagementController.prototype.buildView.call(this, data, isNeededToReloadUsers, savedSelectedUserIds);
    if (data && data.length == 1) this.setOnlyOneGroupClassNamesToLightboxContainer();else this.removeOnlyOneGroupClassNamesFromLightboxContainer();
};

TimeZoneGroupManagementController.prototype.setOnlyOneGroupClassNamesToLightboxContainer = function () {
    (0, _atBrowserUtils.addClass)(this.lightboxContainer, this.onlyOneGroupClassName);
};

TimeZoneGroupManagementController.prototype.removeOnlyOneGroupClassNamesFromLightboxContainer = function () {
    (0, _atBrowserUtils.removeClass)(this.lightboxContainer, this.onlyOneGroupClassName);
};

TimeZoneGroupManagementController.prototype.initGroupContainerCustomScroll = function () {
    BaseGroupManagementController.prototype.initGroupContainerCustomScroll.apply(this, arguments);
    var context = this;
    var onGroupContainerScrollCb = function onGroupContainerScrollCb() {
        context.getGroupController().getSelectedGroup().cleanup(); // clearup timezone group row
    };
    if (this.groupContainerScroll) {
        this.groupContainerScroll.on("scrollStart", onGroupContainerScrollCb);
    } else {
        (0, _jquery2.default)(this.renderer.userGroupContainer).parent().off("scroll", onGroupContainerScrollCb).on("scroll", onGroupContainerScrollCb);
    }

    // jump to search fields with TAB key (custom scroll)

    (0, _jquery2.default)(this.renderer.userGroupContainer).off('keyup.customScroll').on('keyup.customScroll', function (event) {
        if (event.keyCode == _keyCodes.KEY_CODE_TAB && (0, _jquery2.default)(event.target).hasClass('timeZonesSearchField')) {
            var selectedRow = context.getGroupController().getSelectedGroup();
            var nextRowEl = event.shiftKey ? (0, _jquery2.default)(selectedRow.div).prev('.userGroupDiv') : (0, _jquery2.default)(selectedRow.div).next('.userGroupDiv');
            var position = event.shiftKey ? _ScrollUtils2.default.POSITIONS.TOP : _ScrollUtils2.default.POSITIONS.BOTTOM;
            var doTabMove = function doTabMove() {
                selectedRow.citySelector.cancelSearch();
                nextRowEl.find('.selectedTimeZone').click();
                if (!_underscore2.default.isNull(context.groupContainerScroll)) context.groupContainerScroll.off('scrollEnd', doTabMove);
            };

            if (!_underscore2.default.isUndefined(nextRowEl.get(0)) && !_underscore2.default.isNull(context.groupContainerScroll) && !_ScrollUtils2.default.isElementIsFullyVisibleVertical(context.groupContainerScroll, nextRowEl.get(0))) {
                context.groupContainerScroll.on('scrollEnd', doTabMove);
                _ScrollUtils2.default.scrollIntoViewVertical(context.groupContainerScroll, nextRowEl.get(0), position, true, 100);
            } else {
                doTabMove();
            }
        }
    });
};

TimeZoneGroupManagementController.prototype.rebuildViewAfterGroupEditing = function (group) {
    this.updateStoredGroupsCurTimeByActualGroupTime(group);
    BaseGroupManagementController.prototype.rebuildViewAfterGroupEditing.apply(this, arguments);
};

TimeZoneGroupManagementController.prototype.rebuildViewAfterGroupCreation = function (group) {
    this.updateStoredGroupsCurTimeByActualGroupTime(group);
    BaseGroupManagementController.prototype.rebuildViewAfterGroupCreation.apply(this, arguments);
};

/**
 * Adjust time of stored groups by time of actual group that was edited or created
 * Its need to eliminate difference in minutes for "current time", that showing for time zone group (see bug 54094)
 * @param actualGroupData
 */
TimeZoneGroupManagementController.prototype.updateStoredGroupsCurTimeByActualGroupTime = function (actualGroupData) {
    var actualLocalTime = Date.parseJSONTime(actualGroupData.currentTime); // time of actual group (created/updated)

    _underscore2.default.each(this.storedData, function (group) {
        var currentGroupTime = group.currentTime;
        var initOffset = currentGroupTime.substring(currentGroupTime.length - 6); // save offset

        var diffMillis = actualLocalTime.getTime() - Date.parseJSONTime(currentGroupTime).getTime(); // calc difference between actual time and time of current group

        var groupNewTime = Date.parseJSONTimeWithoutTimeZone(group.currentTime);
        groupNewTime.setMilliseconds(diffMillis); // add diff to time
        group.currentTime = groupNewTime.format(Date.JSON_TIME_FORMAT_WITHOUT_TIME_ZONE) + initOffset; // set adjusted time with saving initial offset
    });
};

var ATUserGroupManagementController = exports.ATUserGroupManagementController = function (_BaseGroupManagementC) {
    _inherits(ATUserGroupManagementController, _BaseGroupManagementC);

    function ATUserGroupManagementController() {
        _classCallCheck(this, ATUserGroupManagementController);

        return _possibleConstructorReturn(this, (ATUserGroupManagementController.__proto__ || Object.getPrototypeOf(ATUserGroupManagementController)).apply(this, arguments));
    }

    _createClass(ATUserGroupManagementController, [{
        key: "init",
        value: function init() {
            BaseGroupManagementController.prototype.init.apply(this, arguments);
            this.serviceName = "ATUserGroupManagementService";
        }
    }]);

    return ATUserGroupManagementController;
}(BaseGroupManagementController);

var APUserGroupManagementController = exports.APUserGroupManagementController = function (_BaseGroupManagementC2) {
    _inherits(APUserGroupManagementController, _BaseGroupManagementC2);

    function APUserGroupManagementController() {
        _classCallCheck(this, APUserGroupManagementController);

        return _possibleConstructorReturn(this, (APUserGroupManagementController.__proto__ || Object.getPrototypeOf(APUserGroupManagementController)).apply(this, arguments));
    }

    _createClass(APUserGroupManagementController, [{
        key: "init",
        value: function init() {
            BaseGroupManagementController.prototype.init.apply(this, arguments);
            this.serviceName = "APUserGroupManagementService";
        }
    }]);

    return APUserGroupManagementController;
}(BaseGroupManagementController);

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getTimeZoneOffsets = undefined;
exports.convertManagementAssignmentsDataFromRpc = convertManagementAssignmentsDataFromRpc;
exports.convertUserAccessRightsDataFromRpc = convertUserAccessRightsDataFromRpc;

var _constants = __webpack_require__(4);

var _atUtils = __webpack_require__(5);

var _constants2 = __webpack_require__(4);

function convertManagementAssignmentsDataFromRpc(rpcData) {
    return {
        managementAssignmentsSelection: rpcData.managementAssignmentsSelection,
        customers: rpcData.customers.map,
        projects: rpcData.projects.map,
        tasks: rpcData.tasks.map,
        customerAssignments: rpcData.customerAssignments,
        projectAssignments: rpcData.projectAssignments,
        taskAssignments: rpcData.taskAssignments,
        taskCountsByProjects: rpcData.taskCountsByProjects.map,
        projectCountsByCustomers: rpcData.projectCountsByCustomers.map,
        managementAssignmentsCounters: rpcData.managementAssignmentsCounters
    };
}

function convertUserAccessRightsDataFromRpc(rpcData) {
    var rights = [];
    if (rpcData['hasManageUsersRight']) {
        rights.push(_constants.AccessRights.MANAGE_USERS);
    }
    if (rpcData['hasManageOtherTTRight']) {
        rights.push(_constants.AccessRights.SUBMIT_OTHER_USER_TIME_TRACK);
    }
    if (rpcData['hasManageScopeRight']) {
        rights.push(_constants.AccessRights.EDIT_HIERARCHY);
    }
    if (rpcData['hasGenerateMoneyReportsRight']) {
        rights.push(_constants.AccessRights.GENERATE_MONEY_REPORTS);
    }
    if (rpcData['hasSubmitTTRight']) {
        rights.push(_constants.AccessRights.SUBMIT_TIME_TRACK);
    }
    if (rpcData['hasLockTTRight']) {
        rights.push(_constants.AccessRights.LOCK_TIME_TRACK);
    }
    if (rpcData['hasManagePTOAndSickRight']) {
        rights.push(_constants.AccessRights.MANAGE_PTO_AND_SICK);
    }
    if (rpcData['hasManageSettingsRight']) {
        rights.push(_constants.AccessRights.MANAGE_GENERAL_SETTINGS);
    }
    return rights;
}

var getTimeZoneOffsets = exports.getTimeZoneOffsets = function getTimeZoneOffsets(timeZones) {
    if (!timeZones) return {};

    return timeZones.reduce(function (result, item) {
        if (item.rawOffset !== undefined) result[item.id] = item.rawOffset;
        return result;
    }, {});
};

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getTasks = exports.getProjects = exports.getCustomers = exports.getSelectedProject = exports.getSelectedCustomer = exports.getEditingUser = exports.areTasksLoaded = exports.areProjectsLoaded = exports.areCustomersLoaded = exports.canManageParentProject = exports.canManageParentCustomer = exports.getViewerCanManageProjectIds = exports.getViewerCanManageCustomerIds = exports.isChangingAllAssignments = exports.getTasksSearchText = exports.getTasksSearchOpen = exports.getProjectsSearchText = exports.getProjectsSearchOpen = exports.getCustomersSearchText = exports.getCustomersSearchOpen = exports.getChangingTaskAssignments = exports.getChangingProjectAssignments = exports.getChangingCustomerAssignments = exports.isLoading = exports.areAllTasksAssigned = exports.areSomeTasksAssigned = exports.areAllProjectsAssigned = exports.areSomeProjectsOrLowerAssigned = exports.areAllCustomersAssigned = exports.areSomeCustomersOrLowerAssigned = exports.getTaskCountsByProjects = exports.getTaskCountsByCustomers = exports.getProjectCountsByCustomers = exports.getCanManageTaskIds = exports.getCanWorkTaskIds = exports.getCanManageProjectExcludeSelfIds = exports.getCanManageProjectIds = exports.getCanWorkProjectIds = exports.getCanManageCustomerExcludeSelfIds = exports.getCanManageCustomerIds = exports.getCanWorkCustomerIds = exports.areFutureTasksAssigned = exports.areFutureProjectsAssigned = exports.areFutureCustomersAssigned = exports.getTaskIdsOrder = exports.getProjectIdsOrder = exports.getCustomerIdsOrder = exports.getEditingLevel = exports.needMoreTasks = exports.needMoreProjects = exports.needMoreCustomers = exports.isLoaded = exports.showEditor = exports.getEditingUserId = undefined;

var _reselect = __webpack_require__(13);

var _selectors = __webpack_require__(14);

var EntitiesSelectors = _interopRequireWildcard(_selectors);

var _selectorsGenerator = __webpack_require__(548);

var _selectorsGenerator2 = _interopRequireDefault(_selectorsGenerator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var getWorkAssignmentsEditorState = function getWorkAssignmentsEditorState(state) {
    return state.userManagement.workAssignmentsEditor;
};
var hierarchyAssignmentsEditorSelectors = (0, _selectorsGenerator2.default)(getWorkAssignmentsEditorState);

var getEditingUserId = exports.getEditingUserId = hierarchyAssignmentsEditorSelectors.getEditingUserId;

var showEditor = exports.showEditor = hierarchyAssignmentsEditorSelectors.showEditor;

var isLoaded = exports.isLoaded = hierarchyAssignmentsEditorSelectors.isLoaded;

var needMoreCustomers = exports.needMoreCustomers = hierarchyAssignmentsEditorSelectors.needMoreCustomers;

var needMoreProjects = exports.needMoreProjects = hierarchyAssignmentsEditorSelectors.needMoreProjects;

var needMoreTasks = exports.needMoreTasks = hierarchyAssignmentsEditorSelectors.needMoreTasks;

var getEditingLevel = exports.getEditingLevel = hierarchyAssignmentsEditorSelectors.getEditingLevel;

var getCustomerIdsOrder = exports.getCustomerIdsOrder = hierarchyAssignmentsEditorSelectors.getCustomerIdsOrder;

var getProjectIdsOrder = exports.getProjectIdsOrder = hierarchyAssignmentsEditorSelectors.getProjectIdsOrder;

var getTaskIdsOrder = exports.getTaskIdsOrder = hierarchyAssignmentsEditorSelectors.getTaskIdsOrder;

var areFutureCustomersAssigned = exports.areFutureCustomersAssigned = hierarchyAssignmentsEditorSelectors.areFutureCustomersAssigned;

var areFutureProjectsAssigned = exports.areFutureProjectsAssigned = hierarchyAssignmentsEditorSelectors.areFutureProjectsAssigned;

var areFutureTasksAssigned = exports.areFutureTasksAssigned = hierarchyAssignmentsEditorSelectors.areFutureTasksAssigned;

var getCanWorkCustomerIds = exports.getCanWorkCustomerIds = hierarchyAssignmentsEditorSelectors.getCanWorkCustomerIds;

var getCanManageCustomerIds = exports.getCanManageCustomerIds = hierarchyAssignmentsEditorSelectors.getCanManageCustomerIds;

var getCanManageCustomerExcludeSelfIds = exports.getCanManageCustomerExcludeSelfIds = hierarchyAssignmentsEditorSelectors.getCanManageCustomerExcludeSelfIds;

var getCanWorkProjectIds = exports.getCanWorkProjectIds = hierarchyAssignmentsEditorSelectors.getCanWorkProjectIds;

var getCanManageProjectIds = exports.getCanManageProjectIds = hierarchyAssignmentsEditorSelectors.getCanManageProjectIds;

var getCanManageProjectExcludeSelfIds = exports.getCanManageProjectExcludeSelfIds = hierarchyAssignmentsEditorSelectors.getCanManageProjectExcludeSelfIds;

var getCanWorkTaskIds = exports.getCanWorkTaskIds = hierarchyAssignmentsEditorSelectors.getCanWorkTaskIds;

var getCanManageTaskIds = exports.getCanManageTaskIds = hierarchyAssignmentsEditorSelectors.getCanManageTaskIds;

var getProjectCountsByCustomers = exports.getProjectCountsByCustomers = hierarchyAssignmentsEditorSelectors.getProjectCountsByCustomers;

var getTaskCountsByCustomers = exports.getTaskCountsByCustomers = hierarchyAssignmentsEditorSelectors.getTaskCountsByCustomers;

var getTaskCountsByProjects = exports.getTaskCountsByProjects = hierarchyAssignmentsEditorSelectors.getTaskCountsByProjects;

var areSomeCustomersOrLowerAssigned = exports.areSomeCustomersOrLowerAssigned = hierarchyAssignmentsEditorSelectors.areSomeCustomersOrLowerAssigned;

var areAllCustomersAssigned = exports.areAllCustomersAssigned = hierarchyAssignmentsEditorSelectors.areAllCustomersAssigned;

var areSomeProjectsOrLowerAssigned = exports.areSomeProjectsOrLowerAssigned = hierarchyAssignmentsEditorSelectors.areSomeProjectsOrLowerAssigned;

var areAllProjectsAssigned = exports.areAllProjectsAssigned = hierarchyAssignmentsEditorSelectors.areAllProjectsAssigned;

var areSomeTasksAssigned = exports.areSomeTasksAssigned = hierarchyAssignmentsEditorSelectors.areSomeTasksAssigned;

var areAllTasksAssigned = exports.areAllTasksAssigned = hierarchyAssignmentsEditorSelectors.areAllTasksAssigned;

var isLoading = exports.isLoading = hierarchyAssignmentsEditorSelectors.isLoading;

var getChangingCustomerAssignments = exports.getChangingCustomerAssignments = hierarchyAssignmentsEditorSelectors.getChangingCustomerAssignments;

var getChangingProjectAssignments = exports.getChangingProjectAssignments = hierarchyAssignmentsEditorSelectors.getChangingProjectAssignments;

var getChangingTaskAssignments = exports.getChangingTaskAssignments = hierarchyAssignmentsEditorSelectors.getChangingTaskAssignments;

var getCustomersSearchOpen = exports.getCustomersSearchOpen = hierarchyAssignmentsEditorSelectors.getCustomersSearchOpen;

var getCustomersSearchText = exports.getCustomersSearchText = hierarchyAssignmentsEditorSelectors.getCustomersSearchText;

var getProjectsSearchOpen = exports.getProjectsSearchOpen = hierarchyAssignmentsEditorSelectors.getProjectsSearchOpen;

var getProjectsSearchText = exports.getProjectsSearchText = hierarchyAssignmentsEditorSelectors.getProjectsSearchText;

var getTasksSearchOpen = exports.getTasksSearchOpen = hierarchyAssignmentsEditorSelectors.getTasksSearchOpen;

var getTasksSearchText = exports.getTasksSearchText = hierarchyAssignmentsEditorSelectors.getTasksSearchText;

var isChangingAllAssignments = exports.isChangingAllAssignments = hierarchyAssignmentsEditorSelectors.isChangingAllAssignments;

var getViewerCanManageCustomerIds = exports.getViewerCanManageCustomerIds = hierarchyAssignmentsEditorSelectors.getViewerCanManageCustomerIds;

var getViewerCanManageProjectIds = exports.getViewerCanManageProjectIds = hierarchyAssignmentsEditorSelectors.getViewerCanManageProjectIds;

var canManageParentCustomer = exports.canManageParentCustomer = hierarchyAssignmentsEditorSelectors.canManageParentCustomer;

var canManageParentProject = exports.canManageParentProject = hierarchyAssignmentsEditorSelectors.canManageParentProject;

var areCustomersLoaded = exports.areCustomersLoaded = hierarchyAssignmentsEditorSelectors.areCustomersLoaded;

var areProjectsLoaded = exports.areProjectsLoaded = hierarchyAssignmentsEditorSelectors.areProjectsLoaded;

var areTasksLoaded = exports.areTasksLoaded = hierarchyAssignmentsEditorSelectors.areTasksLoaded;

var getEditingUser = exports.getEditingUser = (0, _reselect.createSelector)(EntitiesSelectors.getUsers, getEditingUserId, function (users, userId) {
    return users[userId];
});

var getSelectedCustomer = exports.getSelectedCustomer = (0, _reselect.createSelector)(EntitiesSelectors.getCustomers, getEditingLevel, function (customers, _ref) {
    var customerId = _ref.customerId;
    return customerId !== null ? customers[customerId] : null;
});

var getSelectedProject = exports.getSelectedProject = (0, _reselect.createSelector)(EntitiesSelectors.getProjects, getEditingLevel, function (projects, _ref2) {
    var projectId = _ref2.projectId;
    return projectId !== null ? projects[projectId] : null;
});

var getCustomers = exports.getCustomers = (0, _reselect.createSelector)(EntitiesSelectors.getCustomers, getCustomerIdsOrder, function (customers, customerIdsOrder) {
    return customerIdsOrder.map(function (id) {
        return customers[id];
    });
});

var getProjects = exports.getProjects = (0, _reselect.createSelector)(EntitiesSelectors.getProjects, getProjectIdsOrder, function (projects, projectIdsOrder) {
    return projectIdsOrder.map(function (id) {
        return projects[id];
    });
});

var getTasks = exports.getTasks = (0, _reselect.createSelector)(EntitiesSelectors.getTasks, getTaskIdsOrder, function (tasks, taskIdsOrder) {
    return taskIdsOrder.map(function (id) {
        return tasks[id];
    });
});

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getUserFromAssignedUsers = exports.getCopyUserFrom = exports.getSelectorsUsers = exports.isCopyLoading = exports.getCopyUserId = exports.getCopyContentState = exports.isShowCopyContent = exports.isNeedToLoadData = exports.isPanelOpened = exports.getPanelUserFirstName = exports.getPanelUser = exports.getUserId = exports.selectTeamAssignmentsPanel = undefined;

var _reselect = __webpack_require__(13);

var _selectors = __webpack_require__(146);

var _atUtils = __webpack_require__(5);

var _constants = __webpack_require__(21);

var _selectors2 = __webpack_require__(14);

var _accessRightsUtils = __webpack_require__(188);

var selectTeamAssignmentsPanel = exports.selectTeamAssignmentsPanel = function selectTeamAssignmentsPanel(state) {
    return state.userManagement.editTeamAssignmentsPanel;
};

var getUserId = exports.getUserId = (0, _reselect.createSelector)(selectTeamAssignmentsPanel, function (panel) {
    return panel.userId;
});

var getPanelUser = exports.getPanelUser = (0, _reselect.createSelector)(getUserId, _selectors2.getUsers, function (userId, users) {
    return users[userId];
});

var getPanelUserFirstName = exports.getPanelUserFirstName = (0, _reselect.createSelector)(getPanelUser, function (user) {
    return user ? user.firstName : '';
});

var isPanelOpened = exports.isPanelOpened = (0, _reselect.createSelector)(getUserId, function (userId) {
    return userId !== null;
});

var isNeedToLoadData = exports.isNeedToLoadData = (0, _reselect.createSelector)(isPanelOpened, _selectors.isLoaded, function (opened, loaded) {
    return opened === true && loaded === false;
});

var isShowCopyContent = exports.isShowCopyContent = (0, _reselect.createSelector)(selectTeamAssignmentsPanel, function (panelState) {
    return panelState.showCopyContent;
});

var getCopyContentState = exports.getCopyContentState = (0, _reselect.createSelector)(selectTeamAssignmentsPanel, function (panelState) {
    return panelState.copyContent;
});

var getCopyUserId = exports.getCopyUserId = (0, _reselect.createSelector)(getCopyContentState, function (copyContent) {
    return copyContent.userId;
});

var isCopyLoading = exports.isCopyLoading = (0, _reselect.createSelector)(getCopyContentState, function (copyContent) {
    return copyContent.loading;
});

var _getSelectorsUsers = (0, _reselect.createSelector)(getCopyContentState, function (copyContent) {
    return copyContent.usersForSelector;
});

var getSelectorsUsers = exports.getSelectorsUsers = (0, _reselect.createSelector)(_getSelectorsUsers, getUserId, function (usersForSelector, userToId) {
    return usersForSelector.filter(function (user) {
        return user.id !== userToId && (0, _accessRightsUtils.canAccessManagersScope)(user) && !(0, _accessRightsUtils.canAccessAllTeamScope)(user) && user.teamAssignmentType === _constants.UserTeamAssignmentType.SELECTED;
    });
});

var getCopyUserFrom = exports.getCopyUserFrom = (0, _reselect.createSelector)(getCopyUserId, getSelectorsUsers, function (id, users) {
    var usersMap = (0, _atUtils.arrayToMap)(users);
    return id ? usersMap[id] : null;
});

var getUserFromAssignedUsers = exports.getUserFromAssignedUsers = (0, _reselect.createSelector)(getCopyContentState, function (copyContent) {
    return copyContent.userFromAssignedUsers;
});

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FloatNumberValidator = function () {
    _createClass(FloatNumberValidator, null, [{
        key: 'getInstance',
        value: function getInstance() {
            return _getInstance();
        }
    }]);

    function FloatNumberValidator(decimalSeparator) {
        _classCallCheck(this, FloatNumberValidator);

        this.decimalSeparator = decimalSeparator || '.';
        this.validationRegexp = new RegExp('^\\d*[' + this.decimalSeparator + ',.]?\\d*$');
    }

    _createClass(FloatNumberValidator, [{
        key: 'getDecimalSeparator',
        value: function getDecimalSeparator() {
            return this.decimalSeparator;
        }
    }, {
        key: 'isValidNumber',
        value: function isValidNumber(string) {
            return String(string).match(this.validationRegexp) !== null;
        }
    }, {
        key: 'parseFloat',
        value: function (_parseFloat) {
            function parseFloat(_x) {
                return _parseFloat.apply(this, arguments);
            }

            parseFloat.toString = function () {
                return _parseFloat.toString();
            };

            return parseFloat;
        }(function (string) {
            string = String(string);
            string = string.replace(this.decimalSeparator, '.');
            string = string.replace(',', '.');

            if (string === '.') return 0;

            return parseFloat(string);
        })
    }]);

    return FloatNumberValidator;
}();

exports.default = FloatNumberValidator;


var instance = null;
var _getInstance = function _getInstance() {
    if (!instance) {
        instance = new FloatNumberValidator(window.SystemSettings.decimalSeparator);
    }
    return instance;
};

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SCOPE_CELL_STATUS = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SCOPE_CELL_STATUS = exports.SCOPE_CELL_STATUS = {
    ALL: 0,
    NOT_SELECTED: 1,
    NOT_ALLOWED: 2,
    SELECTED: 3,
    NO_ACCESS: 4
};

var ScopeCell = function (_TemplateView) {
    _inherits(ScopeCell, _TemplateView);

    function ScopeCell(_ref) {
        var _ref$onClickCb = _ref.onClickCb,
            onClickCb = _ref$onClickCb === undefined ? function () {} : _ref$onClickCb,
            _ref$detailsBlock = _ref.detailsBlock,
            detailsBlock = _ref$detailsBlock === undefined ? null : _ref$detailsBlock,
            _ref$notAllowedTextKe = _ref.notAllowedTextKey,
            notAllowedTextKey = _ref$notAllowedTextKe === undefined ? '' : _ref$notAllowedTextKe,
            _ref$notSelectedTextK = _ref.notSelectedTextKey,
            notSelectedTextKey = _ref$notSelectedTextK === undefined ? '' : _ref$notSelectedTextK,
            _ref$selectedTextKey = _ref.selectedTextKey,
            selectedTextKey = _ref$selectedTextKey === undefined ? '' : _ref$selectedTextKey,
            _ref$noAccessTextKey = _ref.noAccessTextKey,
            noAccessTextKey = _ref$noAccessTextKey === undefined ? '' : _ref$noAccessTextKey;

        _classCallCheck(this, ScopeCell);

        var _this = _possibleConstructorReturn(this, (ScopeCell.__proto__ || Object.getPrototypeOf(ScopeCell)).call(this));

        _this.params = {
            onClickCb: onClickCb,
            detailsBlock: detailsBlock,
            notAllowedTextKey: notAllowedTextKey,
            notSelectedTextKey: notSelectedTextKey,
            selectedTextKey: selectedTextKey,
            noAccessTextKey: noAccessTextKey
        };

        _this.state = {
            highlighted: false,
            disabled: false,
            status: SCOPE_CELL_STATUS.NOT_ALLOWED,
            allSelectedTextKey: ''
        };

        _this.onStateChanged(function () {
            _this.updateCellClass();
            _this.updateLabel();
            _this.toggleIcon();
        });
        return _this;
    }

    _createClass(ScopeCell, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return "<div class='userPanelScopeCell'>" + "    <div class='icon'></div>" + "    <div class='label'></div>" + "    <div class='detailsPlaceholder'></div>" + "</div>";
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            var _this2 = this;

            this.$el.on('click', function (e) {
                if (!_this2.state.disabled) {
                    _this2.params.onClickCb(_this2.$el, e);
                }
            });
            this.$label = this.find('.label');
            this.$icon = this.find('.icon');

            this.params.detailsBlock.init(this.find('.detailsPlaceholder'));
        }
    }, {
        key: 'updateCellClass',
        value: function updateCellClass() {
            this.$el.removeClass().addClass('userPanelScopeCell').toggleClass('all', this.state.status === SCOPE_CELL_STATUS.ALL).toggleClass('notSelected', this.state.status === SCOPE_CELL_STATUS.NOT_SELECTED).toggleClass('notAllowed', this.state.status === SCOPE_CELL_STATUS.NOT_ALLOWED).toggleClass('selected', this.state.status === SCOPE_CELL_STATUS.SELECTED).toggleClass('noAccess', this.state.status === SCOPE_CELL_STATUS.NO_ACCESS).toggleClass('disabled', this.state.disabled).toggleClass('highlighted', this.state.highlighted);
        }
    }, {
        key: 'toggleIcon',
        value: function toggleIcon() {
            this.$icon.toggle(this.state.status === SCOPE_CELL_STATUS.ALL || this.state.status === SCOPE_CELL_STATUS.NOT_ALLOWED);
        }
    }, {
        key: 'updateLabel',
        value: function updateLabel() {
            this.$label.toggle(this.state.status !== SCOPE_CELL_STATUS.SELECTED);
            if (this.state.status !== SCOPE_CELL_STATUS.SELECTED) this.$label.text(this.getLabelText());
        }
    }, {
        key: 'getLabelText',
        value: function getLabelText() {
            switch (this.state.status) {
                case SCOPE_CELL_STATUS.ALL:
                    return _messageResource2.default.getMessage(this.state.allSelectedTextKey);
                case SCOPE_CELL_STATUS.NOT_ALLOWED:
                    return _messageResource2.default.getMessage(this.params.notAllowedTextKey);
                case SCOPE_CELL_STATUS.NOT_SELECTED:
                    return _messageResource2.default.getMessage(this.params.notSelectedTextKey);
                case SCOPE_CELL_STATUS.SELECTED:
                    return _messageResource2.default.getMessage(this.params.selectedTextKey);
                case SCOPE_CELL_STATUS.NO_ACCESS:
                    return _messageResource2.default.getMessage(this.params.noAccessTextKey);
            }
        }
    }]);

    return ScopeCell;
}(_TemplateView3.default);

exports.default = ScopeCell;

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getUsersWorkAssignmentsCounters = exports.getWarningMsgsByUserId = exports.getSortedTimeZoneGroupsList = exports.getSortedUserGroupsList = exports.isNeedToReloadData = exports.getNTotalUsers = exports.getNUsersPerPage = exports.getSorting = exports.getUsersFilter = exports.getWorkAssignmentsFilter = exports.getCurrentPageNum = exports.getSubmittedWordsFilter = exports.getWordsFilter = exports.isLoading = exports.isLoaded = exports.getUsersList = exports.getUserIdsOrder = undefined;

var _reselect = __webpack_require__(13);

var _selectors = __webpack_require__(14);

var _selectors2 = __webpack_require__(53);

var _groupUtils = __webpack_require__(71);

var _constants = __webpack_require__(4);

var _GroupType = __webpack_require__(34);

var _GroupType2 = _interopRequireDefault(_GroupType);

var _utils = __webpack_require__(200);

var _selectors3 = __webpack_require__(15);

var _atUtils = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getWorkAssignmentsState = function getWorkAssignmentsState(state) {
    return state.userManagement.workAssignmentsTab;
};

var getUserIdsOrder = exports.getUserIdsOrder = function getUserIdsOrder(state) {
    return getWorkAssignmentsState(state).userIdsOrder;
};

var getUsersList = exports.getUsersList = (0, _reselect.createSelector)(getUserIdsOrder, _selectors.getUsers, function (userIds, usersMap) {
    return userIds.map(function (id) {
        return usersMap[id];
    });
});

var isLoaded = exports.isLoaded = (0, _reselect.createSelector)(getWorkAssignmentsState, function (wa) {
    return wa.loaded;
});

var isLoading = exports.isLoading = (0, _reselect.createSelector)(getWorkAssignmentsState, function (wa) {
    return wa.loading;
});

var getWordsFilter = exports.getWordsFilter = (0, _reselect.createSelector)(getWorkAssignmentsState, function (wa) {
    return wa.wordsFilter;
});

var getSubmittedWordsFilter = exports.getSubmittedWordsFilter = (0, _reselect.createSelector)(getWorkAssignmentsState, function (wa) {
    return wa.submittedWordsFilter;
});

var getCurrentPageNum = exports.getCurrentPageNum = (0, _reselect.createSelector)(getWorkAssignmentsState, function (wa) {
    return wa.currentPageNum;
});

var getWorkAssignmentsFilter = exports.getWorkAssignmentsFilter = (0, _reselect.createSelector)(getWorkAssignmentsState, function (wa) {
    return wa.workAssignmentsFilter;
});

var getUsersFilter = exports.getUsersFilter = (0, _reselect.createSelector)(getWorkAssignmentsState, _selectors3.isUGREnabled, _selectors3.isTZGEnabled, _selectors2.getUsersListForWorkAssignmentsTab, function (wa, ugrEnabled, tzgEnabled, availableUsers) {
    return (0, _atUtils.convertUsersFilterDependingOnFeatures)(wa.usersFilter, ugrEnabled, tzgEnabled, availableUsers);
});

var getSorting = exports.getSorting = (0, _reselect.createSelector)(getWorkAssignmentsState, _selectors3.isUGREnabled, _selectors3.isTZGEnabled, function (wa, ugrEnabled, tzgEnabled) {
    if (!ugrEnabled && wa.sorting.order === _constants.UserManagementConstants.USER_LIST_ORDER_BY_GROUP_NAME || !tzgEnabled && wa.sorting.order === _constants.UserManagementConstants.USER_LIST_ORDER_BY_TIME_ZONE_GROUP_NAME) {
        return {
            order: _constants.UserManagementConstants.USER_LIST_ORDER_BY_NAME,
            asc: true
        };
    }
    return wa.sorting;
});

var getNUsersPerPage = exports.getNUsersPerPage = (0, _reselect.createSelector)(getWorkAssignmentsState, function (wa) {
    return wa.nUsersPerPage;
});

var getNTotalUsers = exports.getNTotalUsers = (0, _reselect.createSelector)(getWorkAssignmentsState, function (wa) {
    return wa.nTotalUsers;
});

var isNeedToReloadData = exports.isNeedToReloadData = (0, _reselect.createSelector)(isLoaded, _selectors2.getActiveTabNum, function (loaded, tabNum) {
    return loaded === false && tabNum === _constants.UserManagementConstants.WORK_ASSIGNMENTS_TAB_NUM;
});

var getSortedUserGroupsList = exports.getSortedUserGroupsList = (0, _reselect.createSelector)(_selectors.getUserGroupsWithDefault, function (userGroups) {
    return Object.values(userGroups).sort((0, _groupUtils.createGroupComparator)(_GroupType2.default.USER_GROUP));
});

var getSortedTimeZoneGroupsList = exports.getSortedTimeZoneGroupsList = (0, _reselect.createSelector)(_selectors.getTimeZoneGroups, function (timeZoneGroups) {
    return Object.values(timeZoneGroups).sort((0, _groupUtils.createGroupComparator)(_GroupType2.default.TIME_ZONE_GROUP));
});

var getWarningMsgsByUserId = exports.getWarningMsgsByUserId = (0, _reselect.createSelector)(getUsersList, _selectors2.getNewUsersIdSet, function (users, newIds) {
    var warnings = {};
    users.forEach(function (user) {
        warnings[user.id] = (0, _utils.createWarningMsgs)(user, !!newIds[user.id]);
    });
    return warnings;
});

var getUsersWorkAssignmentsCounters = exports.getUsersWorkAssignmentsCounters = function getUsersWorkAssignmentsCounters(state) {
    return getWorkAssignmentsState(state).usersWorkAssignmentsCounters;
};

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _BaseUserInformationSection = __webpack_require__(555);

var _BaseUserInformationSection2 = _interopRequireDefault(_BaseUserInformationSection);

var _BaseUserDataSection = __webpack_require__(396);

var _BaseUserDataSection2 = _interopRequireDefault(_BaseUserDataSection);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _atUtils = __webpack_require__(5);

var _atBrowserUtils = __webpack_require__(8);

var _TimeZonesSelector = __webpack_require__(355);

var _TimeZonesSelector2 = _interopRequireDefault(_TimeZonesSelector);

var _HireDateWarning = __webpack_require__(869);

var _HireDateWarning2 = _interopRequireDefault(_HireDateWarning);

var _constants = __webpack_require__(4);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _constants2 = __webpack_require__(21);

var _Switcher = __webpack_require__(236);

var _Switcher2 = _interopRequireDefault(_Switcher);

var _UserPanelContainer = __webpack_require__(149);

var _SimpleListMenuButton = __webpack_require__(187);

var _SimpleListMenuButton2 = _interopRequireDefault(_SimpleListMenuButton);

var _utils = __webpack_require__(25);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                   requires /js/at.js to be included
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               */


var AccountInformationSection = function (_BaseUserInformationS) {
    _inherits(AccountInformationSection, _BaseUserInformationS);

    function AccountInformationSection() {
        _classCallCheck(this, AccountInformationSection);

        var _this = _possibleConstructorReturn(this, (AccountInformationSection.__proto__ || Object.getPrototypeOf(AccountInformationSection)).call(this));

        _this.state = {
            accessToOtherProductEditable: false,
            enabledInOtherProduct: false,
            editSelf: false
        };

        _this.onStatePropertyChanged('accessToOtherProductEditable', function (editable) {
            _this.$accessSelectorSeparator.toggle(_this.mode === _UserPanelContainer.MODE.EDIT && editable);
            _this.$accessToProductSelectorLabel.toggle(_this.mode === _UserPanelContainer.MODE.EDIT);
            _this.$accessToOtherProductSelectorLabel.toggle(_this.mode === _UserPanelContainer.MODE.EDIT && editable);
            _this.$accessToOnlyOtherProductSelectorLabel.toggle(_this.mode === _UserPanelContainer.MODE.CREATE && editable);
            _this.accessSelector.toggle(_this.mode === _UserPanelContainer.MODE.EDIT);
            _this.accessToOtherProductSelector.toggle(editable);
            _this.$accessBoxRow.toggle(!_this.state.editSelf && (_this.mode === _UserPanelContainer.MODE.EDIT || editable));
        });

        _this.onStatePropertyChanged('enabledInOtherProduct', function (enabled) {
            _this.accessToOtherProductSelector.setState({ enabled: enabled });
        });

        _this.onStatePropertyChanged('editSelf', function (editSelf) {
            (0, _jquery2.default)(_this.lightBoxEl).toggleClass('selfEdit', editSelf && _this.mode === _UserPanelContainer.MODE.EDIT);
            _this.$accessBoxRow.toggle(!editSelf && _this.mode === _UserPanelContainer.MODE.EDIT);
        });
        return _this;
    }

    return AccountInformationSection;
}(_BaseUserInformationSection2.default);

AccountInformationSection.GROUP_NEW_OR_NOT_KNOWN = _constants2.GROUP_NEW_OR_NOT_KNOWN;

AccountInformationSection.prototype.init = function (_ref) {
    var _ref$mode = _ref.mode,
        mode = _ref$mode === undefined ? _UserPanelContainer.MODE.EDIT : _ref$mode,
        _ref$lightBoxEl = _ref.lightBoxEl,
        lightBoxEl = _ref$lightBoxEl === undefined ? null : _ref$lightBoxEl,
        _ref$userManagementDa = _ref.userManagementData,
        userManagementData = _ref$userManagementDa === undefined ? null : _ref$userManagementDa,
        _ref$currentTime = _ref.currentTime,
        currentTime = _ref$currentTime === undefined ? null : _ref$currentTime,
        _ref$userId = _ref.userId,
        userId = _ref$userId === undefined ? null : _ref$userId,
        _ref$accountSettings = _ref.accountSettings,
        accountSettings = _ref$accountSettings === undefined ? null : _ref$accountSettings,
        _ref$changesCallback = _ref.changesCallback,
        changesCallback = _ref$changesCallback === undefined ? function () {} : _ref$changesCallback,
        _ref$validateCallback = _ref.validateCallback,
        validateCallback = _ref$validateCallback === undefined ? function () {} : _ref$validateCallback,
        _ref$checkUsernameErr = _ref.checkUsernameErrorHandler,
        checkUsernameErrorHandler = _ref$checkUsernameErr === undefined ? function () {} : _ref$checkUsernameErr,
        _ref$corporateSchedul = _ref.corporateSchedule,
        corporateSchedule = _ref$corporateSchedul === undefined ? null : _ref$corporateSchedul,
        _ref$userGroupsEnable = _ref.userGroupsEnabled,
        userGroupsEnabled = _ref$userGroupsEnable === undefined ? false : _ref$userGroupsEnable,
        _ref$timeZoneGroupsEn = _ref.timeZoneGroupsEnabled,
        timeZoneGroupsEnabled = _ref$timeZoneGroupsEn === undefined ? false : _ref$timeZoneGroupsEn,
        _ref$firstTTDate = _ref.firstTTDate,
        firstTTDate = _ref$firstTTDate === undefined ? null : _ref$firstTTDate,
        _ref$firstLeaveReques = _ref.firstLeaveRequestDate,
        firstLeaveRequestDate = _ref$firstLeaveReques === undefined ? null : _ref$firstLeaveReques,
        _ref$editedUserIsSelf = _ref.editedUserIsSelf,
        editedUserIsSelf = _ref$editedUserIsSelf === undefined ? false : _ref$editedUserIsSelf,
        _ref$handlerIfNoSuchU = _ref.handlerIfNoSuchUserAfterAjax,
        handlerIfNoSuchUserAfterAjax = _ref$handlerIfNoSuchU === undefined ? function () {} : _ref$handlerIfNoSuchU,
        _ref$specificVersionD = _ref.specificVersionDrawerConstructor,
        specificVersionDrawerConstructor = _ref$specificVersionD === undefined ? function () {} : _ref$specificVersionD,
        _ref$disableDuplicate = _ref.disableDuplicateUsernameCheck,
        disableDuplicateUsernameCheck = _ref$disableDuplicate === undefined ? false : _ref$disableDuplicate,
        _ref$disableEmptyUser = _ref.disableEmptyUsernameCheck,
        disableEmptyUsernameCheck = _ref$disableEmptyUser === undefined ? false : _ref$disableEmptyUser,
        _ref$scrollableContai = _ref.scrollableContainerEl,
        scrollableContainerEl = _ref$scrollableContai === undefined ? null : _ref$scrollableContai,
        _ref$showGroupRows = _ref.showGroupRows,
        showGroupRows = _ref$showGroupRows === undefined ? false : _ref$showGroupRows,
        _ref$needValidation = _ref.needValidation,
        needValidation = _ref$needValidation === undefined ? true : _ref$needValidation,
        _ref$hireDateLabelEl = _ref.hireDateLabelEl,
        hireDateLabelEl = _ref$hireDateLabelEl === undefined ? null : _ref$hireDateLabelEl;

    this.mode = mode;
    this.selfEdit = editedUserIsSelf;
    this.isUGREnabled = userGroupsEnabled;
    this.isTZGEnabled = timeZoneGroupsEnabled;
    var self = this;
    var sectionId = "accountInformationSection";
    var userData = {
        firstName: accountSettings.firstName,
        lastName: accountSettings.lastName,
        middleName: accountSettings.middleInitial,
        email: accountSettings.email
    };

    _BaseUserInformationSection2.default.prototype.init.call(this, {
        lightBoxEl: lightBoxEl,
        sectionId: sectionId,
        userData: userData,
        changesCallback: changesCallback,
        validateCallback: validateCallback,
        isInstantValidation: false,
        needValidation: needValidation
    });

    this.specificFieldsDrawerController = specificVersionDrawerConstructor.init({
        lightBoxEl: lightBoxEl,
        getElementByIdFunction: function getElementByIdFunction(subId) {
            return self.getElementBySubId(subId);
        },
        changeDetectedFunction: function changeDetectedFunction(notRequireConfirmationOnCopySettings) {
            self.changesDetected(notRequireConfirmationOnCopySettings);
        },
        updateUICallback: function updateUICallback(errors) {
            _jquery2.default.extend(self.errors, errors);self.updateUI();
        },
        validationDetectedCallback: function validationDetectedCallback() {
            self.validationDetected();
        },
        handlerIfNoSuchUserAfterAjax: handlerIfNoSuchUserAfterAjax,
        disableDuplicateUsernameCheck: disableDuplicateUsernameCheck && !needValidation,
        disableEmptyUsernameCheck: disableEmptyUsernameCheck && !needValidation,
        disableValidation: true
    });
    this.specificFieldsDrawerController.initFields({ accountSettings: accountSettings,
        currentTime: currentTime, editedUserIsSelf: editedUserIsSelf });
    this.userId = userId;
    this.corporateSchedule = corporateSchedule;

    this.scrollableContainerEl = scrollableContainerEl;

    this.savedPasswordData = accountSettings.passwordData;
    this.checkUsernameErrorHandler = checkUsernameErrorHandler;

    if (showGroupRows) {
        this.generateUserGroupFields(userManagementData, accountSettings);
        this.generateTimeZoneGroupFields(userManagementData, accountSettings);
    }

    this.$userDataTable = (0, _jquery2.default)(this.lightBoxEl).find(".userDataTable");

    this.$accessBoxRow = (0, _jquery2.default)(this.getElementBySubId("accessBoxRow"));
    this.$accessBoxRow.toggle(!this.selfEdit);

    this.accessSelector = this.createAccessSelector("changeAccess", accountSettings.enabled, this.getElementBySubId("accessSelectorPlaceholder"));

    this.$accessSelectorSeparator = this.$accessBoxRow.find('.accessSelectorSeparator');
    this.$accessToProductSelectorLabel = this.$accessBoxRow.find('.accessToProductSelectorLabel');
    this.$accessToOtherProductSelectorLabel = this.$accessBoxRow.find('.accessToOtherProductSelectorLabel');
    this.$accessToOnlyOtherProductSelectorLabel = this.$accessBoxRow.find('.accessToOnlyOtherProductSelectorLabel');
    this.accessToOtherProductSelector = this.createAccessSelector("changeAccessToOtherProduct", accountSettings.enabledInOtherProduct, this.getElementBySubId("accessToOtherProductSelectorPlaceholder"));

    this.delReleaseDateBtn = this.getElementBySubId("delReleaseDateBtn");

    this.hireDatePlaceholderEl = this.getElementBySubId("hireDatePlaceholder");
    this.hireDateLabelEl = hireDateLabelEl;
    this.updateHireDateSelector(userManagementData, accountSettings.hireDate);

    this.firstTTDate = firstTTDate;
    this.firstLeaveRequestDate = firstLeaveRequestDate;
    this.updateUI();

    this.callStateChangeHandlersWithCurrentState();

    return this;
};

AccountInformationSection.prototype.generateUserGroupFields = function (userManagementData, accountSettings) {
    var _this2 = this;

    this.newUserGroupNameField = this.$subId("newUserGroupNameField");
    this.newUserGroupNameField.off();
    this.setValue(this.newUserGroupNameField, "");
    this.newUserGroupNameField.attr("placeholder", _messageResource2.default.getMessage("user.add.js.user_group_selector.new_user_group_place_holder")).placeholder();
    this.newUserGroupNameField.blur(this.onBlurFieldHandler(function () {
        _this2._checkNewUserGroupNameValid(true);
        var name = (0, _atUtils.trim)(_this2.newUserGroupNameField.pVal());
        _this2.triggerUserGroupChanged(AccountInformationSection.GROUP_NEW_OR_NOT_KNOWN, name);
    }));

    this.userGroupSelectorPlaceholderEl = this.getElementBySubId("userGroupSelectorPlaceholder");
    this.userGroupSelectorPlaceholderEl.innerHTML = "";

    this.newUserGroupNameDiv = this.getElementBySubId("newUserGroupNameDiv");
    this.userGroupSelector = null;
    this.updateUserGroupsVisibility(this.isUGREnabled);

    if (this.isUGREnabled && userManagementData.allUserGroups) {
        this.userGroupSelector = this.createUserGroupSelector(userManagementData.allUserGroups, accountSettings.userGroupId, this.userGroupSelectorPlaceholderEl);
        this.updateNewUserGroupFieldVisibility(accountSettings.userGroupId);
    }
};

AccountInformationSection.prototype.generateTimeZoneGroupFields = function (userManagementData, accountSettings) {
    var _this3 = this;

    this.newTimeZoneGroupNameField = this.$subId("newTimeZoneGroupNameField");
    this.newTimeZoneGroupNameField.off();
    this.setValue(this.newTimeZoneGroupNameField, "");
    this.newTimeZoneGroupNameField.attr("placeholder", _messageResource2.default.getMessage("user.add.js.time_zone_group_selector.new_time_zone_group_placeholder")).placeholder();
    this.newTimeZoneGroupNameField.blur(this.onBlurFieldHandler(function () {
        _this3._checkNewTimeZoneGroupNameValid(true);
        _this3.triggerTimeZoneChanged(AccountInformationSection.GROUP_NEW_OR_NOT_KNOWN);
    }));
    this.newTimeZoneGroupNameField.on("change", function () {
        var value = (0, _atUtils.trim)(_this3.value);
        if (_this3.prevValue !== value) {
            _this3.setDuplicateTimeZoneGroupError(false);
        }
        _this3.prevValue = value;
    });

    this.timeZoneGroupSelectorPlaceholderEl = this.getElementBySubId("timeZoneGroupSelectorPlaceholder");
    this.timeZoneGroupSelectorPlaceholderEl.innerHTML = "";

    this.timeZonesSelectorPlaceholderEl = this.getElementBySubId("timeZonesSelectorPlaceholder");
    this.timeZonesSelectorPlaceholderEl.innerHTML = "";

    this.timeZoneGroupSelector = null;
    this.timeZonesSelector = null;

    this.updateTimeZoneGroupsVisibility(this.isTZGEnabled);

    if (this.isTZGEnabled && userManagementData.allTimeZoneGroups) {
        this.timeZoneGroupSelector = this.createTimeZoneGroupSelector(userManagementData.allTimeZoneGroups, accountSettings.timeZoneGroupId, this.timeZoneGroupSelectorPlaceholderEl);
        this.updateTimeZoneSelectorVisibility(accountSettings.timeZoneGroupId);
        this.timeZonesSelector = this.createTimeZonesSelector();
    }
};

AccountInformationSection.prototype.toggleHireDateChangedWrning = function (show) {
    if (show) {
        this.getHireDateChangedWarning().showAt((0, _jquery2.default)(this.getElementBySubId("hireDate")), "userlist.user_popup.hire_date_changed.integrated", this.getPreviousHireDate(), this.getHireDate());
    } else {
        this.getHireDateChangedWarning().hide();
    }
};

AccountInformationSection.prototype.updateHireDateSelector = function (userManagementData, hireDate) {
    var _this4 = this;

    var hireDateEditable = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;


    var self = this;
    this.hireDatePlaceholderEl = this.getElementBySubId("hireDatePlaceholder");
    (0, _jquery2.default)(this.hireDatePlaceholderEl).click(function (e) {
        return (0, _utils.setEventPreventHidingAllPanels)(e);
    });

    this.hireDateSelector = this.createDateSelector(userManagementData, "hireDate", this.hireDatePlaceholderEl, hireDate, this.corporateSchedule, function () {
        if (self._checkHireDateIsValid()) (0, _jquery2.default)(_this4).trigger('hireDateChanged', [_this4.getHireDate()]);
        self.updateUI();
    }, hireDateEditable);
};

AccountInformationSection.prototype.setReadOnly = function (readOnly) {
    _BaseUserInformationSection2.default.prototype.setReadOnly.call(this, readOnly);
    this.$userDataTable.toggleClass("readOnly", readOnly);
};

AccountInformationSection.prototype.triggerTimeZoneChanged = function (id) {
    (0, _jquery2.default)(this).trigger("timeZoneGroupChanged", [id, this.getNewTimeZoneGroup()]);
};

AccountInformationSection.prototype.triggerUserGroupChanged = function (id) {
    (0, _jquery2.default)(this).trigger("userGroupChanged", [id, this.getNewUserGroupName()]);
};

AccountInformationSection.prototype.getSpecificValues = function () {
    return this.specificFieldsDrawerController ? this.specificFieldsDrawerController.getSpecificValues() : {};
};

AccountInformationSection.prototype.getSpecificNotCopyValues = function () {
    return this.specificFieldsDrawerController ? this.specificFieldsDrawerController.getNotCopyValues() : {};
};

AccountInformationSection.prototype.validationDetected = function () {
    if (this.specificFieldsDrawerController) _jquery2.default.extend(this.errors, this.specificFieldsDrawerController.getErrors());
    _BaseUserDataSection2.default.prototype.validationDetected.call(this);
};

AccountInformationSection.prototype.createDateSelector = function (userManagementData, name, renderTo, strDate, corporateSchedule, onChange, isEditable) {
    var date = strDate && strDate.length > 0 ? strDate.parseJSONDate() : null;
    var renderToPlaceholder = (0, _jquery2.default)(renderTo)[0];
    var cellValue = date;
    var calendarValue = date;

    var self = this;
    var calendar = window.ClassicBridge.integrateCalendar(renderToPlaceholder, {
        onSelect: function onSelect(date) {
            calendarValue = Date.parseJSONDate(date);
            cellValue = calendarValue;
            calendar.setProps({ selectedDay: calendarValue, placeholder: '' });
            if (onChange) onChange(undefined, date);
            self.changesDetected(true);
        },
        selectedDay: date ? calendarValue : currentUserTime(),
        placeholder: !date && _messageResource2.default.getMessage("common.date_selector.select_date"),
        type: 'day',
        disabled: !isEditable
    });
    calendar.serverHireDate = date;
    calendar.previousDate = date;

    calendar.unsetValue = function () {
        cellValue = null;
        calendar.setProps({ placeholder: _messageResource2.default.getMessage("common.date_selector.select_date") });
    };

    calendar.fireEvent = function () {
        if (onChange) onChange(undefined, cellValue);
    };

    calendar.getValue = function () {
        return cellValue;
    };

    calendar.setValue = function (value) {
        calendarValue = value;
        cellValue = value;
        calendar.setProps({
            selectedDay: value,
            placeholder: !value && _messageResource2.default.getMessage("common.date_selector.select_date")
        });
    };

    calendar.hide = function () {
        calendar.remove();
    };

    calendar.formatDate = function () {};

    return calendar;
};

AccountInformationSection.prototype.sectionWasLoaded = function () {
    this._nameChanged();
};

AccountInformationSection.prototype.createAccessSelector = function (eventname, currentUserAccess, renderTo) {
    var _this5 = this;

    var $renderTo = (0, _jquery2.default)(renderTo);
    $renderTo.empty();
    var switcher = new _Switcher2.default({
        additionalClass: 'small',
        onSwitchCallback: function onSwitchCallback(enabled) {
            _this5.changesDetected(true);
            (0, _jquery2.default)(_this5).trigger(eventname, [enabled]);
        }
    }).init($renderTo);
    switcher.setState({
        enabled: !!currentUserAccess
    });
    return switcher;
};

AccountInformationSection.prototype.getHireDateChangedWarning = function () {
    var _this6 = this;

    if (_underscore2.default.isUndefined(this.hireDateChangedWarning)) {
        this.hireDateChangedWarning = new _HireDateWarning2.default((0, _jquery2.default)(this.lightBoxEl), (0, _jquery2.default)(this.lightBoxEl).find(".innerContent"), function (isConfirmed) {
            if (isConfirmed) {
                (0, _jquery2.default)(_this6).trigger('hireDateForceChanged', [_this6.getHireDate()]);
            } else {
                _this6.setHireDate(_this6.getPreviousHireDate());
            }
            (0, _jquery2.default)(_this6).trigger('setHasLeavesOrTTBeforeNewHireDateError', [false]);
        }).init();
    }
    return this.hireDateChangedWarning;
};

AccountInformationSection.prototype.createUserGroupSelector = function (userGroups, selectedGroupId, renderTo) {
    var _this7 = this;

    var userGroupNotAssignedGroup = {
        name: _messageResource2.default.getMessage("user.add.js.user_group_selector.user_group_not_selected_item_title"),
        id: _constants.UserManagementConstants.USER_GROUP_NOT_ASSIGNED_ID
    };

    var newUserGroupGroup = {
        name: _messageResource2.default.getMessage("user.add.js.user_group_selector.new_user_group_item_title"),
        id: AccountInformationSection.GROUP_NEW_OR_NOT_KNOWN
    };

    var listItems = [userGroupNotAssignedGroup, newUserGroupGroup].concat(userGroups);
    var escapedListItems = listItems.map(function (item) {
        return { id: item.id, name: (0, _atUtils.escapeHtmlSymbols)(item.name) };
    });

    var selector = new _SimpleListMenuButton2.default({
        itemHtmlCallback: function itemHtmlCallback(item) {
            return item.name;
        },
        extraClass: 'components_userGroupSelectorMenu',
        onSelect: function onSelect(item) {
            _this7.updateNewUserGroupFieldVisibility(item.id);
            _this7.changesDetected();
            _this7.validationDetected();
            _this7.triggerUserGroupChanged(item.id);
        },
        itemHeight: 28
    }).init((0, _jquery2.default)(renderTo));

    var selectedItem = escapedListItems.find(function (item) {
        return item.id === selectedGroupId;
    });
    selector.setItems(escapedListItems, selectedItem || escapedListItems[0]);

    return selector;
};

AccountInformationSection.prototype.createTimeZoneGroupSelector = function (timeZoneGroups, selectedTimeZoneGroupId, renderTo) {
    var _this8 = this;

    var newTimeZoneGroupGroup = {
        name: _messageResource2.default.getMessage("user.add.js.time_zone_group_selector.new_time_zone_group_item_title"),
        id: AccountInformationSection.GROUP_NEW_OR_NOT_KNOWN
    };

    var listItems = [newTimeZoneGroupGroup].concat(timeZoneGroups);
    var escapedListItems = listItems.map(function (item) {
        return { id: item.id, name: (0, _atUtils.escapeHtmlSymbols)(item.name), rawOffset: item.rawOffset };
    });

    var selector = new _SimpleListMenuButton2.default({
        itemHtmlCallback: function itemHtmlCallback(item) {
            if (item.id === AccountInformationSection.GROUP_NEW_OR_NOT_KNOWN) {
                return '<span class="nameGroup">' + item.name + '</spreturn>';
            } else {
                return '<span class="nameGroup">' + item.name + '</span> <span class="offset">' + _messageResource2.default.getMessage("time_zones_selector.js.gmt", [(0, _atUtils.formatRawSecondsOffset)(item.rawOffset)]) + '</span>';
            }
        },
        extraClass: 'components_userPanel_timeZoneGroupSelectorMenu',
        onSelect: function onSelect(item) {
            _this8.setDuplicateTimeZoneGroupError(false);
            _this8.updateTimeZoneSelectorVisibility(item.id);
            _this8.changesDetected();
            _this8.validationDetected();
            if (item.id !== AccountInformationSection.GROUP_NEW_OR_NOT_KNOWN) _this8.triggerTimeZoneChanged(item.id);
        },
        itemHeight: 28
    }).init((0, _jquery2.default)(renderTo));

    var selectedItem = escapedListItems.find(function (item) {
        return item.id === selectedTimeZoneGroupId;
    });
    selector.setItems(escapedListItems, selectedItem || escapedListItems[0]);

    return selector;
};

AccountInformationSection.prototype.createTimeZonesSelector = function () {
    var self = this;
    this.timeZonesSelectorPlaceholderEl.innerHTML = "";
    var selector = new _TimeZonesSelector2.default().init((0, _jquery2.default)('#' + this.timeZonesSelectorPlaceholderEl.id), null, function (data) {
        self._cityChanged(data);
    }, _messageResource2.default.getMessage('user.add.js.time_zone_group_selector.select_city_placeholder'), false, "userPopupSearch");
    (0, _jquery2.default)(this.lightBoxEl).find(".innerContent").off("scroll.userPopupTZSelector").on("scroll.userPopupTZSelector", function () {
        selector.cancelSearch();
    });
    return selector;
};

AccountInformationSection.prototype._cityChanged = function (cityData) {
    this.cityData = cityData;
    this.updateTimeZoneSelectorVisibility(this.timeZoneGroupSelector.getSelectedItem().id);
    if (this.newTimeZoneGroupNameField.pVal() === '') this.newTimeZoneGroupNameField.pVal(this.cityData.name.substring(0, 40));
    this._checkCityDataValid();
    this._checkNewTimeZoneGroupNameValid(true);
    this.triggerTimeZoneChanged(AccountInformationSection.GROUP_NEW_OR_NOT_KNOWN);
    this.updateUI();
    this.validationDetected();
};

AccountInformationSection.prototype._checkNewUserGroupNameValid = function (onlyRemoveEmptyError) {
    if (this._isNewUserGroupFieldActive()) {
        this._checkEmpty(this.newUserGroupNameField, _constants2.ValidationErrors.NEW_USER_GROUP_EMPTY, onlyRemoveEmptyError);
    }
};

AccountInformationSection.prototype.setDuplicateTimeZoneGroupError = function (value) {
    this.errors[_constants2.ValidationErrors.DUPLICATE_TIME_ZONE_GROUP] = value;
    this.updateUI();
};

AccountInformationSection.prototype.updateTimeZoneGroups = function (timeZoneGroups, selectedId) {
    var _selectedId = _underscore2.default.isUndefined(selectedId) ? AccountInformationSection.GROUP_NEW_OR_NOT_KNOWN : selectedId;
    this.timeZoneGroupSelectorPlaceholderEl.innerHTML = "";
    this.timeZoneGroupSelector = this.createTimeZoneGroupSelector(timeZoneGroups, _selectedId, this.timeZoneGroupSelectorPlaceholderEl);
};

AccountInformationSection.prototype.updateUserGroups = function (groups, selectedId) {
    this.userGroupSelectorPlaceholderEl.innerHTML = "";
    this.userGroupSelector = this.createUserGroupSelector(groups, selectedId, this.userGroupSelectorPlaceholderEl);
    this.updateNewUserGroupFieldVisibility(selectedId);
};

AccountInformationSection.prototype._checkNewTimeZoneGroupNameValid = function (onlyRemoveEmptyError) {
    if (this._isNewTimeZoneGroupFieldActive()) this._checkEmpty(this.newTimeZoneGroupNameField, _constants2.ValidationErrors.NEW_TIME_ZONE_GROUP_EMPTY, onlyRemoveEmptyError);
};

AccountInformationSection.prototype._checkCityDataValid = function () {
    this.errors[_constants2.ValidationErrors.CITY_DATA_EMPTY] = false;
    this.errors[_constants2.ValidationErrors.DUPLICATE_TIME_ZONE_GROUP] = false;

    if (this.timeZoneGroupSelector != null && this.timeZoneGroupSelector.getSelectedItem().id === AccountInformationSection.GROUP_NEW_OR_NOT_KNOWN && this.cityData == null) this.errors[_constants2.ValidationErrors.CITY_DATA_EMPTY] = true;
};

AccountInformationSection.prototype._checkHireDateIsValid = function () {
    this.errors[_constants2.ValidationErrors.HIRE_DATE_EMPTY] = false;
    this.errors[_constants2.ValidationErrors.HIRE_DATE_IN_FUTURE_FOR_SELF] = false;

    if (this.getHireDate() == null) {
        this.errors[_constants2.ValidationErrors.HIRE_DATE_EMPTY] = true;
        return false;
    }

    if (this.editedUserIsSelf && (0, _atUtils.compareDates)(this.getHireDate(), window.currentUserTime()) > 0) {
        this.errors[_constants2.ValidationErrors.HIRE_DATE_IN_FUTURE_FOR_SELF] = true;
        return false;
    }

    return true;
};

AccountInformationSection.prototype.customValidate = function (oldErrors) {
    _jquery2.default.extend(this.errors, this.specificFieldsDrawerController.validateFields(oldErrors, this.checkEmpty));
    this._checkNewUserGroupNameValid();
    this._checkCityDataValid();
    this._checkNewTimeZoneGroupNameValid();
    this._checkHireDateIsValid();
};

AccountInformationSection.prototype.updateUserGroupsVisibility = function (isUGREnabled) {
    this.getElementBySubId("userGroupRow").style.display = isUGREnabled ? "block" : "none";
};

AccountInformationSection.prototype.updateTimeZoneGroupsVisibility = function (isTZGEnabled) {
    this.getElementBySubId("timeZoneGroupRow").style.display = isTZGEnabled ? "block" : "none";
};

AccountInformationSection.prototype.updateNewUserGroupFieldVisibility = function (selectedGroupId) {
    var showNewGroupField = this.userGroupSelector != null && selectedGroupId == AccountInformationSection.GROUP_NEW_OR_NOT_KNOWN;
    this.newUserGroupNameDiv.style.display = showNewGroupField ? "inline-block" : "none";
    (0, _jquery2.default)(this.getElementBySubId("userGroupRow")).toggleClass("showNewGroupField", showNewGroupField);
};

AccountInformationSection.prototype.updateTimeZoneSelectorVisibility = function (selectedGroupId) {
    var showTimeZonesSelector = this.timeZoneGroupSelector != null && selectedGroupId == AccountInformationSection.GROUP_NEW_OR_NOT_KNOWN;
    (0, _jquery2.default)(this.getElementBySubId("timeZoneGroupRow")).toggleClass("showTimeZonesSelector", showTimeZonesSelector);
    this.updateNewTimeZoneGroupFieldVisibility(selectedGroupId);
};

AccountInformationSection.prototype.updateNewTimeZoneGroupFieldVisibility = function (selectedGroupId) {
    var showTimeZonesSelector = this.timeZoneGroupSelector != null && selectedGroupId == AccountInformationSection.GROUP_NEW_OR_NOT_KNOWN;
    var showNewTimeZoneGroupField = showTimeZonesSelector && this.cityData != null;
    (0, _jquery2.default)(this.getElementBySubId("timeZoneGroupRow")).toggleClass("showNewTimeZoneGroupField", showNewTimeZoneGroupField);
};

AccountInformationSection.prototype._isNewUserGroupFieldActive = function () {
    return this.userGroupSelector != null && this.newUserGroupNameDiv.style.display != "none";
};

AccountInformationSection.prototype._isNewTimeZoneDataActive = function () {
    return !!this.timeZoneGroupSelector && this.timeZoneGroupSelector.getSelectedItem().id === AccountInformationSection.GROUP_NEW_OR_NOT_KNOWN;
};

AccountInformationSection.prototype._isNewTimeZoneGroupFieldActive = function () {
    return this._isNewTimeZoneDataActive() && this.cityData != null;
};

AccountInformationSection.prototype.getNewUserGroupName = function () {
    if (!this.userGroupSelector) return null;
    if (this.userGroupSelector.getSelectedItem().id !== AccountInformationSection.GROUP_NEW_OR_NOT_KNOWN) return null;
    return this.newUserGroupNameField.pVal();
};

AccountInformationSection.prototype.getNewTimeZoneGroup = function () {
    if (!this.timeZoneGroupSelector) return null;
    if (this.timeZoneGroupSelector.getSelectedItem().id !== AccountInformationSection.GROUP_NEW_OR_NOT_KNOWN) return null;
    if (!this.cityData) return null;
    return {
        id: _constants2.GROUP_NEW_OR_NOT_KNOWN,
        name: this.newTimeZoneGroupNameField.pVal(),
        cityPlaceId: this.cityData.placeId,
        cityName: this.cityData.name,
        timeZoneId: this.cityData.timeZoneId
    };
};

AccountInformationSection.prototype.getUserId = function () {
    return this.userId;
};

AccountInformationSection.prototype.isEnabled = function () {
    return this.accessSelector.getState().enabled;
};

AccountInformationSection.prototype.isEnabledInOtherProduct = function () {
    return this.accessToOtherProductSelector.getState().enabled;
};

AccountInformationSection.prototype.getUserGroupId = function () {
    return this.userGroupSelector ? this.userGroupSelector.getSelectedItem().id : AccountInformationSection.GROUP_NEW_OR_NOT_KNOWN;
};

AccountInformationSection.prototype.getTimeZoneGroupId = function () {
    return this.timeZoneGroupSelector ? this.timeZoneGroupSelector.getSelectedItem().id : AccountInformationSection.GROUP_NEW_OR_NOT_KNOWN;
};

AccountInformationSection.prototype.getHireDate = function () {
    return this.hireDateSelector.getValue();
};

AccountInformationSection.prototype.setHireDate = function (date) {
    this.setPreviousHireDate(date);
    this._setHireDateLabel(date);
    return this.hireDateSelector.setValue(date);
};

AccountInformationSection.prototype.getPreviousHireDate = function () {
    return this.hireDateSelector.previousDate;
};

AccountInformationSection.prototype._setHireDateLabel = function (date) {
    if (!!date) this.hireDateLabelEl.text(this.hireDateSelector.formatDate(date));
};

AccountInformationSection.prototype.getServerHireDate = function () {
    return this.hireDateSelector.serverHireDate;
};

AccountInformationSection.prototype.setPreviousHireDate = function (date) {
    this.hireDateSelector.previousDate = date;
    this.hireDateSelector.setProps({ selectedDay: date });
};

AccountInformationSection.prototype.getReleaseDate = function () {
    return null;
};

AccountInformationSection.prototype.setReleaseDate = function (date) {};

AccountInformationSection.prototype.hasErrors = function () {
    var ignoredErrors = [];
    if (!this._isNewUserGroupFieldActive()) {
        ignoredErrors.push(_constants2.ValidationErrors.NEW_USER_GROUP_EMPTY);
    }
    if (!this._isNewTimeZoneDataActive()) {
        ignoredErrors.push(_constants2.ValidationErrors.NEW_TIME_ZONE_GROUP_EMPTY);
        ignoredErrors.push(_constants2.ValidationErrors.CITY_DATA_EMPTY);
    }
    //noinspection LoopStatementThatDoesntLoopJS
    for (var prop in this.errors) {
        if (this.errors[prop] && ignoredErrors.indexOf(prop) < 0) {
            return true;
        }
    }
    return false;
};

AccountInformationSection.prototype.getErrorState = function () {
    var errors = _jquery2.default.extend({}, this.errors);
    errors[_constants2.ValidationErrors.NEW_USER_GROUP_EMPTY] = false;
    errors[_constants2.ValidationErrors.NEW_TIME_ZONE_GROUP_EMPTY] = false;
    errors[_constants2.ValidationErrors.CITY_DATA_EMPTY] = false;
    return errors;
};

AccountInformationSection.prototype.setErrorState = function (errors, passwordValidationJson) //todo: maybe put passwordValidationJson into error map?
{
    // Errors can be taken from state and then they change in this class. Copy is created to avoid a possible state changes
    this.errors = _extends({}, errors);
    this.specificFieldsDrawerController.setErrorState(errors, passwordValidationJson);
    this.updateUI();
};

AccountInformationSection.prototype.setFocusIntoFirstNameField = function () {
    (0, _atBrowserUtils.setFocusIntoFieldWithPlaceholder)(this.firstNameField);
};

AccountInformationSection.prototype.setToDuplicateUsernameState = function () {
    if (this.specificFieldsDrawerController) {
        this.specificFieldsDrawerController.userNameDrawer._checkUsernameDuplicatesCallback(true);
    }
};

AccountInformationSection.prototype.setLoaded = function (loaded) {
    this.accessSelector.setState({ animated: loaded });
    this.accessToOtherProductSelector.setState({ animated: loaded });
};
exports.default = AccountInformationSection;

/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _DropdownTemplateView2 = __webpack_require__(42);

var _DropdownTemplateView3 = _interopRequireDefault(_DropdownTemplateView2);

var _Button = __webpack_require__(33);

var _Button2 = _interopRequireDefault(_Button);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _constants = __webpack_require__(110);

var _atBrowserUtils = __webpack_require__(8);

var _InvisibleMoire = __webpack_require__(1643);

var _ModalAlertLine = __webpack_require__(1644);

var _ModalAlertLine2 = _interopRequireDefault(_ModalAlertLine);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ModalAlert = function (_DropdownTemplateView) {
    _inherits(ModalAlert, _DropdownTemplateView);

    function ModalAlert() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            _ref$showCancelButton = _ref.showCancelButton,
            showCancelButton = _ref$showCancelButton === undefined ? false : _ref$showCancelButton,
            _ref$onConfirm = _ref.onConfirm,
            onConfirm = _ref$onConfirm === undefined ? function () {} : _ref$onConfirm,
            _ref$okButtonLabel = _ref.okButtonLabel,
            okButtonLabel = _ref$okButtonLabel === undefined ? _messageResource2.default.getMessage('common.ok') : _ref$okButtonLabel,
            _ref$onCancelButtonCl = _ref.onCancelButtonClick,
            onCancelButtonClick = _ref$onCancelButtonCl === undefined ? function () {} : _ref$onCancelButtonCl,
            _ref$returnToInitialP = _ref.returnToInitialPosition,
            returnToInitialPosition = _ref$returnToInitialP === undefined ? true : _ref$returnToInitialP,
            _ref$withLoading = _ref.withLoading,
            withLoading = _ref$withLoading === undefined ? false : _ref$withLoading;

        _classCallCheck(this, ModalAlert);

        var _this = _possibleConstructorReturn(this, (ModalAlert.__proto__ || Object.getPrototypeOf(ModalAlert)).call(this, null, {
            toggleMode: false
        }));

        _this.params = {
            showCancelButton: showCancelButton,
            onConfirm: onConfirm,
            okButtonLabel: okButtonLabel,
            onCancelButtonClick: onCancelButtonClick,
            returnToInitialPosition: returnToInitialPosition,
            withLoading: withLoading
        };

        _this.state = {
            header: '',
            text: '',
            additionalClass: '',
            pointerPosition: _constants.ModalAlertPointerPosition.CENTER,

            offsets: {
                left: null,
                top: null
            },

            showMoire: false,
            loading: false
        };

        _this.onStatePropertyChanged('header', function (header) {
            _this.$headerPlaceholder.empty();
            _this.$headerPlaceholder.text(header);
        });

        _this.onStatePropertyChanged('text', function (text) {
            _this.$textPlaceholder.empty();
            text.split('\n').forEach(function (lineText) {
                return new _ModalAlertLine2.default({
                    lineText: lineText
                }).init(_this.$textPlaceholder);
            });
        });

        _this.onStatePropertyChanged('additionalClass', function (newAdditionalClass, oldAdditionalClass) {
            _this.$el.removeClass(oldAdditionalClass);
            _this.$el.addClass(newAdditionalClass);
        });

        _this.onStatePropertyChanged('showMoire', function (show) {
            _this.moire.toggle(show);
        });

        _this.onStatePropertyChanged('loading', function (loading) {
            return _this.okButton.setState({ loading: _this.params.withLoading && loading });
        });
        return _this;
    }

    _createClass(ModalAlert, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class="components_modalAlert">' + '    <div class="content_modalAlert">' + '        <div class="iconPlaceholder"/>' + '        <div class="headerPlaceholder"/>' + '        <div class="textPlaceholder"/>' + '        <div class="footer"/>' + '    </div>' + '    <div class="pointerPlaceholder">' + '        <div class="pointer"></div>' + '    </div>' + '</div>';
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            var _this2 = this;

            this.$headerPlaceholder = this.find('.headerPlaceholder');
            this.$textPlaceholder = this.find('.textPlaceholder');
            this.$pointer = this.find('.pointer');
            this.$footer = this.find('.footer');

            this.okButton = new _Button2.default({
                label: this.params.okButtonLabel,
                additionalClass: 'okButton',
                handleEnterKeydown: true,
                withLoading: this.params.withLoading,
                onClickCb: function onClickCb(e) {
                    _this2.params.onConfirm();
                    if (!_this2.params.withLoading) {
                        _this2.hide();
                    }
                }
            }).init(this.$footer);
            if (this.params.showCancelButton) {
                this.cancelButton = new _Button2.default({
                    label: _messageResource2.default.getMessage('common.cancel'),
                    additionalClass: 'cancelButton',
                    onClickCb: function onClickCb(e) {
                        _this2.hide();
                        _this2.params.onCancelButtonClick();
                    }
                }).init(this.$footer);
            }

            this.getEl().click(function (e) {
                return e.stopPropagation();
            });

            this.moire = _InvisibleMoire.InvisibleMoire.getInstance();
            this.moire.getEl().click(function (e) {
                return e.stopPropagation();
            });
        }
    }, {
        key: 'onHide',
        value: function onHide() {
            _get(ModalAlert.prototype.__proto__ || Object.getPrototypeOf(ModalAlert.prototype), 'onHide', this).call(this);
            this.moire.hide();
            this.onHideCb();
            this.params.onCancelButtonClick();
            if (this.params.returnToInitialPosition) {
                this.setInitialState();
            }
        }
    }, {
        key: 'showAt',
        value: function showAt(element) {
            var onHideCb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};

            this.onHideCb = onHideCb;
            this.moire.toggle(this.state.showMoire);
            _get(ModalAlert.prototype.__proto__ || Object.getPrototypeOf(ModalAlert.prototype), 'showAt', this).call(this, element);
            this.okButton.focus();
        }
    }, {
        key: '_showElementAt',
        value: function _showElementAt($el, positionParams) {
            var leftOffset = this.state.offsets.left === null ? _constants.ModalAlertOffsets[this.state.pointerPosition].left : this.state.offsets.left;
            var topOffset = this.state.offsets.top === null ? _constants.ModalAlertOffsets[this.state.pointerPosition].top : this.state.offsets.top;
            _get(ModalAlert.prototype.__proto__ || Object.getPrototypeOf(ModalAlert.prototype), '_showElementAt', this).call(this, $el, _extends({}, positionParams, {
                my: this.state.pointerPosition + ' top',
                at: 'center bottom',
                offset: leftOffset + 'px ' + topOffset + 'px'
            }));
            this._setPointer(positionParams.of, leftOffset);
        }
    }, {
        key: 'mouseDownTargetElement',
        value: function mouseDownTargetElement() {
            return (0, _jquery2.default)('body');
        }
    }, {
        key: '_setPointer',
        value: function _setPointer(elementShowAt, alertLeftOffset) {
            this.$pointer.removeClass('pointerUp pointerDown');

            var pointerOffset = -alertLeftOffset + (this.state.pointerPosition === _constants.ModalAlertPointerPosition.RIGHT ? this.$el.width() / 2 : this.state.pointerPosition === _constants.ModalAlertPointerPosition.LEFT ? -this.$el.width() / 2 : 0);
            var elementOffset = elementShowAt.offset().top;
            var alertOffset = this.$el.offset().top;
            var positionParams = void 0;

            if (elementOffset < alertOffset) {
                //alert below element
                this.$pointer.addClass('pointerUp');
                positionParams = {
                    of: this.$el,
                    my: 'center bottom',
                    at: 'center top',
                    offset: pointerOffset + 'px 1px'
                };
            } else {
                this.$pointer.addClass('pointerDown');
                positionParams = {
                    of: this.$el,
                    my: 'center top',
                    at: 'center bottom',
                    offset: pointerOffset + 'px -1px'
                };
            }

            (0, _atBrowserUtils.showElementAt)(this.$pointer, positionParams);
        }
    }, {
        key: 'setInitialState',
        value: function setInitialState() {
            this.setState({
                pointerPosition: _constants.ModalAlertPointerPosition.CENTER,
                offsets: {
                    left: null,
                    top: null
                }
            });
        }
    }], [{
        key: 'getInstance',
        value: function getInstance() {
            return _getInstance();
        }
    }]);

    return ModalAlert;
}(_DropdownTemplateView3.default);

exports.default = ModalAlert;


var instance = null;
var _getInstance = function _getInstance() {
    if (!instance) {
        instance = new ModalAlert().init((0, _jquery2.default)("body"));
    }
    return instance;
};

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.revokeEntitiesAction = exports.revokeAllTypeAction = exports.openManagementAssignmentPanel = exports.changeAssignmentPanelTab = exports.changeManagementAssignmentsSelection = exports.loadData = exports.setCanManageAllScope = exports.setShown = exports.clearTabsLoaded = exports.closePanel = exports.setIsShowArchiveEntities = exports.openPanel = exports.setLoaded = exports.setLoading = exports.setSearchOpen = exports.setSearchString = exports.setCustomerTabLoaded = exports.setProjectTabLoaded = exports.setTaskTabLoaded = exports.setUserCounters = exports.setManageExcludingSelfCustomerIds = exports.setManageCustomerIds = exports.setManageExcludingSelfProjectIds = exports.setManageProjectIds = exports.setManageTaskIds = exports.setTab = exports.setUserId = exports.setCustomerIds = exports.setProjectIds = exports.setTaskIds = undefined;

var _reduxActions = __webpack_require__(9);

var _actionTypes = __webpack_require__(692);

var ActionTypes = _interopRequireWildcard(_actionTypes);

var _actions = __webpack_require__(148);

var _selectors = __webpack_require__(399);

var _actionsGenerator = __webpack_require__(395);

var _actionsGenerator2 = _interopRequireDefault(_actionsGenerator);

var _selectors2 = __webpack_require__(208);

var _constants = __webpack_require__(4);

var _rpcCalls = __webpack_require__(24);

var _rpcCalls2 = _interopRequireDefault(_rpcCalls);

var _actions2 = __webpack_require__(29);

var _actions3 = __webpack_require__(147);

var _actions4 = __webpack_require__(50);

var _actions5 = __webpack_require__(262);

var _atUtils = __webpack_require__(5);

var _selectors3 = __webpack_require__(64);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var hierarchyAssignmentsTabActions = (0, _actionsGenerator2.default)({
    actionTypes: ActionTypes
});

var setTaskIds = exports.setTaskIds = hierarchyAssignmentsTabActions.setTaskIds;

var setProjectIds = exports.setProjectIds = hierarchyAssignmentsTabActions.setProjectIds;

var setCustomerIds = exports.setCustomerIds = hierarchyAssignmentsTabActions.setCustomerIds;

var setUserId = exports.setUserId = hierarchyAssignmentsTabActions.setUserId;

var setTab = exports.setTab = hierarchyAssignmentsTabActions.setTab;

var setManageTaskIds = exports.setManageTaskIds = hierarchyAssignmentsTabActions.setManageTaskIds;

var setManageProjectIds = exports.setManageProjectIds = hierarchyAssignmentsTabActions.setManageProjectIds;

var setManageExcludingSelfProjectIds = exports.setManageExcludingSelfProjectIds = hierarchyAssignmentsTabActions.setManageExcludingSelfProjectIds;

var setManageCustomerIds = exports.setManageCustomerIds = hierarchyAssignmentsTabActions.setManageCustomerIds;

var setManageExcludingSelfCustomerIds = exports.setManageExcludingSelfCustomerIds = hierarchyAssignmentsTabActions.setManageExcludingSelfCustomerIds;

var setUserCounters = exports.setUserCounters = hierarchyAssignmentsTabActions.setUserCounters;

var setTaskTabLoaded = exports.setTaskTabLoaded = hierarchyAssignmentsTabActions.setTaskTabLoaded;

var setProjectTabLoaded = exports.setProjectTabLoaded = hierarchyAssignmentsTabActions.setProjectTabLoaded;

var setCustomerTabLoaded = exports.setCustomerTabLoaded = hierarchyAssignmentsTabActions.setCustomerTabLoaded;

var setSearchString = exports.setSearchString = hierarchyAssignmentsTabActions.setSearchString;

var setSearchOpen = exports.setSearchOpen = hierarchyAssignmentsTabActions.setSearchOpen;

var setLoading = exports.setLoading = hierarchyAssignmentsTabActions.setLoading;

var setLoaded = exports.setLoaded = hierarchyAssignmentsTabActions.setLoaded;

var openPanel = exports.openPanel = hierarchyAssignmentsTabActions.openPanel;

var setIsShowArchiveEntities = exports.setIsShowArchiveEntities = hierarchyAssignmentsTabActions.setIsShowArchiveEntities;

var closePanel = exports.closePanel = function closePanel() {
    return function (dispatch) {
        dispatch(setShown(false));
        dispatch(hierarchyAssignmentsTabActions.closePanel());
    };
};

var clearTabsLoaded = exports.clearTabsLoaded = hierarchyAssignmentsTabActions.clearTabsLoaded;

var setShown = exports.setShown = (0, _reduxActions.createAction)(ActionTypes.SHOWN_SET);

var setCanManageAllScope = exports.setCanManageAllScope = (0, _reduxActions.createAction)(ActionTypes.ALL_SCOPE_SET);

var loadData = exports.loadData = function loadData() {
    return function (dispatch, getState) {
        var userManagementData = (0, _selectors2.getManageAssignments)(getState());
        dispatch(setCanManageAllScope(userManagementData.canManageAllScope));

        var assignmentsCptIds = (0, _selectors2.getManagementAssignmentsCptIds)(getState());
        var tabType = (0, _selectors.getTab)(getState());
        dispatch(setLoading(true));
        (0, _rpcCalls2.default)('UserManagementService.getViewUserManagementAssignmentsForCreateUser', [assignmentsCptIds, tabType]).then(function (data) {
            dispatch(prepareLoadedData(data, tabType));
            dispatch(setLoading(false));
        }).catch(function (err) {
            dispatch(setLoading(false));
            console.log(err);
        });
    };
};

var prepareLoadedData = function prepareLoadedData(data, tabType) {
    return function (dispatch) {
        dispatch((0, _actions2.addCustomers)(data.customers));
        dispatch((0, _actions2.addProjects)(data.projects));
        dispatch((0, _actions2.addTasks)(data.tasks));

        dispatch((0, _actions3.managementAssignmentsCountsLoadSuccess)(data.userCounter));
        dispatch(setUserCounters(data.userCounter));
        dispatch((0, _actions4.setViewerManagementAssignmentsCounters)(data.viewerCounter));

        var maCptIds = data.managementAssignmentsCptIds;

        dispatch(setManageTaskIds((0, _atUtils.arrayToSet)(maCptIds.taskIds)));
        dispatch(setManageProjectIds((0, _atUtils.arrayToSet)(maCptIds.projectIds)));
        dispatch(setManageExcludingSelfProjectIds((0, _atUtils.arrayToSet)(maCptIds.projectIdsExcludingSelf)));
        dispatch(setManageCustomerIds((0, _atUtils.arrayToSet)(maCptIds.customerIds)));
        dispatch(setManageExcludingSelfCustomerIds((0, _atUtils.arrayToSet)(maCptIds.customerIdsExcludingSelf)));

        switch (tabType) {
            case _constants.HierarchyLevels.TASK:
                dispatch(setTaskIds(data.taskIds));
                dispatch(setTaskTabLoaded(true));
                break;
            case _constants.HierarchyLevels.PROJECT:
                dispatch(setProjectIds(data.projectIds));
                dispatch(setProjectTabLoaded(true));
                break;
            case _constants.HierarchyLevels.CUSTOMER:
                dispatch(setCustomerIds(data.customerIds));
                dispatch(setCustomerTabLoaded(true));
                break;
        }
        dispatch(setLoaded(true));
    };
};

var changeManagementAssignmentsSelection = exports.changeManagementAssignmentsSelection = function changeManagementAssignmentsSelection(managementAssignmentsSelection) {
    return function (dispatch) {
        dispatch((0, _actions.changeManagementAssignmentsSelection)(managementAssignmentsSelection));
        dispatch(loadData());
    };
};

var changeAssignmentPanelTab = exports.changeAssignmentPanelTab = function changeAssignmentPanelTab(tab) {
    return function (dispatch, getState) {
        var prevTab = (0, _selectors.getTab)(getState());
        if (prevTab !== tab) {
            dispatch(setSearchString(null));
            dispatch(setTab(tab));
        }
    };
};

var openManagementAssignmentPanel = exports.openManagementAssignmentPanel = function openManagementAssignmentPanel(id, tab) {
    return function (dispatch, getState) {
        var counters = (0, _selectors3.getManagementAssignmentsCounters)(getState());

        dispatch(setLoaded(counters.customers === 0 && counters.projects === 0 && counters.tasks === 0));
        dispatch(setCustomerTabLoaded(counters.customers === 0));
        dispatch(setProjectTabLoaded(counters.projects === 0));
        dispatch(setTaskTabLoaded(counters.tasks === 0));

        dispatch(setTab(tab));
        dispatch(setSearchString(null));

        dispatch(setShown(true));
    };
};

var revokeAllTypeAction = exports.revokeAllTypeAction = function revokeAllTypeAction() {
    return function (dispatch, getState) {
        var selectedTab = (0, _selectors.getTab)(getState());
        var entityIds = [];
        switch (selectedTab) {
            case _constants.HierarchyLevels.CUSTOMER:
                entityIds = (0, _selectors.getCustomerIds)(getState());
                dispatch((0, _actions.changeCustomerAssignments)({
                    removedIds: entityIds
                }));
                dispatch(_actions5.hierarchyAssignmentsEditorActions.clearAll());
                break;
            case _constants.HierarchyLevels.PROJECT:
                entityIds = (0, _selectors.getProjectIds)(getState());
                dispatch((0, _actions.changeProjectAssignments)({
                    removedIds: entityIds
                }));
                dispatch(_actions5.hierarchyAssignmentsEditorActions.clearAll());
                break;
            case _constants.HierarchyLevels.TASK:
                entityIds = (0, _selectors.getTaskIds)(getState());
                dispatch((0, _actions.changeTasksAssignments)({
                    removedIds: entityIds
                }));
                dispatch(_actions5.hierarchyAssignmentsEditorActions.clearAll());
                break;
        }
        // TODO bakharev: get counters for panel
        dispatch(loadData());
    };
};

var revokeEntitiesAction = exports.revokeEntitiesAction = function revokeEntitiesAction(revokeEntityLevel, id) {
    return function (dispatch, getState) {
        var selectedTab = (0, _selectors.getTab)(getState());
        var entityIds = [];
        switch (selectedTab) {
            case _constants.HierarchyLevels.CUSTOMER:
                entityIds = (0, _selectors.getCustomerIds)(getState());
                dispatch((0, _actions.changeCustomerAssignments)({
                    removedIds: [id]
                }));
                dispatch(_actions5.hierarchyAssignmentsEditorActions.clearAll());
                break;
            case _constants.HierarchyLevels.PROJECT:
                entityIds = (0, _selectors.getProjectIds)(getState());
                dispatch((0, _actions.changeProjectAssignments)({
                    removedCustomerIds: revokeEntityLevel === _constants.HierarchyLevels.CUSTOMER ? [id] : [],
                    removedIds: revokeEntityLevel === _constants.HierarchyLevels.PROJECT ? [id] : []
                }));
                dispatch(_actions5.hierarchyAssignmentsEditorActions.clearAll());
                break;
            case _constants.HierarchyLevels.TASK:
                entityIds = (0, _selectors.getTaskIds)(getState());
                dispatch((0, _actions.changeTasksAssignments)({
                    // TODO bakharev: add removedCustomerIds parameter
                    removedProjectIds: revokeEntityLevel === _constants.HierarchyLevels.PROJECT ? [id] : [],
                    removedIds: revokeEntityLevel === _constants.HierarchyLevels.TASK ? [id] : []
                }));
                dispatch(_actions5.hierarchyAssignmentsEditorActions.clearAll());
                break;
        }
        // TODO bakharev: get counters for panel
        dispatch(loadData());
    };
};

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.removeAllHolidays = exports.loadPanelData = exports.changeSort = exports.removeImportedHolidays = exports.addImportedHolidays = exports.setListTransformed = exports.closeRemoveAllConfirmation = exports.openRemoveAllConfirmation = exports.setPanelSelectedYear = exports.loadDataFailure = exports.loadDataSuccess = exports.loadData = exports.closePanel = exports.openPanel = exports.setPanelShown = undefined;

var _utils = __webpack_require__(6);

var _actionTypes = __webpack_require__(709);

var ActionTypes = _interopRequireWildcard(_actionTypes);

var _reduxActions = __webpack_require__(9);

var _selectors = __webpack_require__(263);

var _actions = __webpack_require__(213);

var _apiCalls = __webpack_require__(567);

var api = _interopRequireWildcard(_apiCalls);

var _utils2 = __webpack_require__(85);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var setPanelShown = exports.setPanelShown = (0, _reduxActions.createAction)(ActionTypes.HOLIDAYS_LIST_PANEL_SHOWN_SET);

var openPanel = exports.openPanel = function openPanel() {
    return function (dispatch, getState) {
        dispatch(setPanelShown());
        dispatch(loadPanelData((0, _selectors.getPanelSelectedYear)(getState())));
    };
};

var closePanel = exports.closePanel = (0, _reduxActions.createAction)(ActionTypes.CLOSE_PANEL);

var loadData = exports.loadData = (0, _reduxActions.createAction)(ActionTypes.LOAD_DATA);
var loadDataSuccess = exports.loadDataSuccess = (0, _reduxActions.createAction)(ActionTypes.LOAD_DATA_SUCCESS);
var loadDataFailure = exports.loadDataFailure = (0, _reduxActions.createAction)(ActionTypes.LOAD_DATA_FAILURE);
var setPanelSelectedYear = exports.setPanelSelectedYear = (0, _reduxActions.createAction)(ActionTypes.SELECTED_YEAR_SET);

var openRemoveAllConfirmation = exports.openRemoveAllConfirmation = (0, _reduxActions.createAction)(ActionTypes.REMOVE_ALL_CONFIRMATION_SHOW);

var closeRemoveAllConfirmation = exports.closeRemoveAllConfirmation = (0, _reduxActions.createAction)(ActionTypes.REMOVE_ALL_CONFIRMATION_CLOSE);

var setListTransformed = exports.setListTransformed = (0, _reduxActions.createAction)(ActionTypes.LIST_TRANSFORMED_SET);

var addImportedHolidays = exports.addImportedHolidays = (0, _reduxActions.createAction)(ActionTypes.IMPORTED_HOLIDAYS_ADD);
var removeImportedHolidays = exports.removeImportedHolidays = (0, _reduxActions.createAction)(ActionTypes.IMPORTED_HOLIDAYS_REMOVE);

var changeSort = exports.changeSort = function changeSort(sorting) {
    return function (dispatch) {
        dispatch((0, _utils.createActionObject)(ActionTypes.CHANGE_SORT, sorting));
        dispatch(setListTransformed(true));
    };
};

var loadPanelData = exports.loadPanelData = function loadPanelData(year) {
    return function (dispatch) {
        dispatch(loadData());
        dispatch((0, _actions.loadWorkScheduleData)(year, function () {
            dispatch(loadDataSuccess(year));
            dispatch(setPanelSelectedYear(year));
            dispatch(setListTransformed(true));
        }, function () {
            return dispatch(loadDataFailure());
        }));
    };
};

var removeAllHolidays = exports.removeAllHolidays = function removeAllHolidays() {
    return function (dispatch, getState) {
        dispatch(loadData());

        var panelSelectedYear = (0, _selectors.getPanelSelectedYear)(getState());
        api.deleteHolidays(panelSelectedYear).then(function (data) {
            dispatch(loadDataSuccess());
            dispatch((0, _actions.removeCorporateDaysByYear)(panelSelectedYear));
            dispatch((0, _actions.loadedDataSet)({
                corporateDays: _defineProperty({}, panelSelectedYear, data.corporateDays),
                defaultWorkSchedules: (0, _utils2.convertEffectiveDateInWorkSchedule)(data.defaultWorkSchedules)
            }));
            dispatch(closeRemoveAllConfirmation());
        }).catch(function () {
            dispatch(loadDataFailure());
            dispatch(closeRemoveAllConfirmation());
        });
    };
};

/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ReportMediator;

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _DropdownDialog = __webpack_require__(185);

var _DropdownDialog2 = _interopRequireDefault(_DropdownDialog);

var _atUtils = __webpack_require__(5);

var _SpinnerController = __webpack_require__(69);

var _SpinnerController2 = _interopRequireDefault(_SpinnerController);

var _spin = __webpack_require__(93);

var _spin2 = _interopRequireDefault(_spin);

var _constants = __webpack_require__(4);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _json2csv = __webpack_require__(576);

var _json2csv2 = _interopRequireDefault(_json2csv);

var _utils = __webpack_require__(164);

var _indicateExportingOnButton = __webpack_require__(978);

var _indicateExportingOnButton2 = _interopRequireDefault(_indicateExportingOnButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ReportMediator() {
    this.constructor = ReportMediator;
}

ReportMediator.prototype.init = function (config) {
    var self = this;
    this.editConfigurationButton = (0, _jquery2.default)(config.editConfigurationButton);
    this.exportToCsvButton = (0, _jquery2.default)(".exportToCSV");
    this.panelEl = (0, _jquery2.default)(config.panelId);

    this.reportPlaceholder = (0, _jquery2.default)("#reportPlaceholder");
    this.reportOverlay = (0, _jquery2.default)("#reportOverlay");

    this.generateReportUrl = config.generateReportUrl;
    this.generateCSVUrl = config.generateCSVUrl;
    this.reportParameters = config.reportParameters;
    this.reportConfigId = config.reportConfigId;
    this.reportConfigName = config.reportConfigName;

    this.dataWasChanged = false;

    ATReportsStore.setReportAuthorizationInfo(config.reportAuthorizationInfo);
    ATReportsStore.setManageableUserIds(config.manageableUserIds);
    ATReportsStore.setProjectsWithMaIds(config.projectsWithMaIds);

    this.initReportParameters = _jquery2.default.extend({}, this.reportParameters);
    this.historyController = new HistoryController().init({
        onPopstate: function onPopstate(e) {
            // NOTE: chrome! strange behaviour 
            // (it adds # (anchor) to url after confirmation closed so onPopstate event is triggered ).
            if (e.state != null) self.generateReportFromHistory();
        },
        initState: this._makeHistoryState()
    });
    this.updateParametersFromHistory();

    //NOTE: ugly hack. this.reportParameters might be changed somewhere before but all selectors are initialized from config.
    //NOTE: this.reportParameters can be modified by method updateParametersFromHistory, this need to keep not saved parameters between reloads
    //NOTE: for example see https://jira.actimind.com/browse/AT-3523
    _jquery2.default.extend(config.reportParameters, this.reportParameters);

    this.editConfigController = this.initEditConfigController(config);
    this.initEditConfigButtons();

    this.saveConfigControl = new SaveConfigurationControl().init({
        reportName: config.reportConfigName,
        reportType: this.getReportType(),
        hasChanges: this.dataWasChanged
    }, SaveConfigurationControl.REPORT_TYPE, function (reportName) {
        self.saveReportManager.saveReport({
            reportName: reportName,
            reportType: self.getReportType(),
            reportParameters: self.reportParameters
        });
    }, function (reportName) {
        self.saveReportManager.updateReport({
            reportId: self.reportConfigId,
            reportName: reportName,
            reportType: self.getReportType(),
            reportParameters: self.reportParameters
        });
    }, function () {
        return self._resetReport();
    });
    this.saveReportManager = this.getConstructorSaveManager().init(this.saveConfigControl, function (reportId, newConfigName) {
        self.commonSuccessSaveHandler(reportId, newConfigName);
    }, self._noRightsHandler);

    this.editConfPanelwrapperClassName = "editReportConfigurationWrapper ";
    var wrapperClass = this.editConfPanelwrapperClassName + (config.additionalPanelClass ? " " + config.additionalPanelClass : "");

    this.panel = new _DropdownDialog2.default({
        wrapperClass: wrapperClass,
        dialogDiv: this.panelEl,
        hideButtons: true,
        hideOnResize: true,
        showEmptyTitleBar: false,
        outsideClickCallback: function outsideClickCallback() {
            self.editConfigCanceled();
        },
        hideOnResizeCallback: function hideOnResizeCallback() {
            self.editConfigCanceled();
        },
        onClose: function onClose(event) {
            if (event.keyCode === _jquery2.default.ui.keyCode.ESCAPE) self.editConfigCanceled();

            self.editConfigurationButton.removeClass("active");
        }
    });

    this.editConfigurationButton.click(function (el) {
        self.editConfigurationButton.addClass("active");

        if ((0, _jquery2.default)(el.target).parents(".reportPageHeader").length) self.panel.showAt(this, {
            offset: "0 10px",
            my: "left top",
            at: "left bottom",
            collision: "none"
        });else self.panel.showAt(this, {
            offset: "0 -10px",
            my: "left bottom",
            at: "left top",
            collision: "none flip"
        });

        var panelTop = (0, _jquery2.default)(self.panelEl).offset().top;
        var panelWrapper = (0, _jquery2.default)("." + self.editConfPanelwrapperClassName);
        if (panelTop < (0, _jquery2.default)(el.target).offset().top) {
            panelWrapper.addClass("toTop");
            panelWrapper.removeClass("toBottom");
        } else {
            panelWrapper.addClass("toBottom");
            panelWrapper.removeClass("toTop");
        }
    });

    this.exportToCsvButton.click(function () {
        (0, _indicateExportingOnButton2.default)(self.exportToCsvButton);
        self.exportToCSV();
    });

    this.dateRangeSelector = this.createDateRangeSelector(this.reportParameters);
    this.setConfigDateRangeSelection(this.getDateRangeParameter());

    if (this.dateRangeSelector) {
        this.dateRangeSelector.setOnChangeCallback(function () {
            self.onDateRangeChanged();
        });
    }

    this.printReportNamePlh = (0, _jquery2.default)(".reportPageHeader .printHeader .printableReportName");
    this.printReportNamePlh.text(this.reportConfigName && (0, _atUtils.isNotEmpty)(this.reportConfigName) ? this.reportConfigName : config.reportTitle);

    this.printableHeadersBuilder = this.initPrintableHeadersBuilder(config);
    this._createPrintableHeaders();

    return this;
};

ReportMediator.prototype.getConstructorSaveManager = function () {
    return new SaveReportManager();
};

ReportMediator.prototype.changeParametersCallback = function () {
    if (this.editConfigController && !this.editConfigController.validate()) {
        this.saveConfigControl && this.saveConfigControl.disableEditConfig();
        this.editConfigController.updateUI(true);
        return;
    }

    this.saveConfigControl && this.saveConfigControl.enableEditConfig();
};

ReportMediator.prototype.getReportType = function () {
    // abstract
};

ReportMediator.prototype.initEditConfigController = function (config) {
    //abstract
};

ReportMediator.prototype.hasErrors = function () {
    return !!this.dateRangeSelector && this.dateRangeSelector.hasErrors() || this.editConfigController.hasErrors();
};

ReportMediator.prototype.setConfigDateRangeSelection = function (selection) {
    this.reportParameters.dateRangeSelection = selection;
};

ReportMediator.prototype.onDateRangeChanged = function () {
    this.setConfigDateRangeSelection(this.getDateRangeParameter());

    if (this.hasErrors()) {
        this.saveConfigControl && this.saveConfigControl.disableEditConfig();
        return;
    }

    this.saveConfigControl && this.saveConfigControl.enableEditConfig();
    this.dateRangeSelector.setInitStateFromCurrent();
    this.registerChanges();
    this._updatePrintableDateRangeHeader();
    this.generateReport(false); // do not verify if date range really changed
};

ReportMediator.prototype.registerChanges = function () {
    this.dataWasChanged = true;
    this.saveConfigControl.registerConfigChanged();
};

ReportMediator.prototype.editConfigApplied = function (extendedCheck) {
    if (!this.editConfigController.validate()) {
        this.editConfigController.updateUI(true);
        return;
    }

    if (extendedCheck && !extendedCheck()) return;

    var newState = this.editConfigController.getConfig();
    _jquery2.default.extend(this.reportParameters, newState);
    this.panel.hide();
    this._createPrintableHeaders();

    if (this.hasErrors()) return;
    this.registerChanges();

    this.editConfigController.setSelectorsInitStateFromCurrent();
    this.generateReport(false);
};

ReportMediator.prototype._makeHistoryState = function () {
    return {
        reportParameters: this.reportParameters,
        dataWasChanged: this.dataWasChanged
    };
};

ReportMediator.prototype._saveConfigToHistory = function () {
    this.historyController.saveState(this._makeHistoryState());
};

ReportMediator.prototype.editConfigCanceled = function () {
    this.editConfigController.resetConfig();
    // validate on close not when popup is opened to prevent error on first opening
    this.editConfigController.validate();
    this.editConfigController.updateUI();
    this.panel.hide();
};

ReportMediator.prototype.initEditConfigButtons = function () {
    var self = this;
    this.editConfigController.setConfigButtonHandlers({
        onApply: function onApply() {
            self.editConfigApplied();
        },
        onCancel: function onCancel() {
            self.editConfigCanceled();
        }
    });
};

ReportMediator.prototype._resetReport = function () {
    if (this.dataWasChanged) {
        this._updateReportParameters(this.initReportParameters);
        this.dataWasChanged = false;
        this.generateReport(false);
    }

    return true;
};

ReportMediator.prototype._updateReportParameters = function (reportParameters) {
    this.reportParameters = _jquery2.default.extend({}, reportParameters);
    this._updateReportControls();
};

ReportMediator.prototype.makeServiceParams = function (reportParams) {
    var serviceParams = _.clone(reportParams);
    serviceParams.dateRangeSelection = {
        qualifier: reportParams.dateRangeSelection.qualifier,
        fromDate: reportParams.dateRangeSelection.fromDate.toJSON(),
        toDate: reportParams.dateRangeSelection.toDate.toJSON()
    };

    return serviceParams;
};

ReportMediator.prototype.getDateRangeParameter = function () {
    return this.dateRangeSelector.getSelectedRange();
};

ReportMediator.prototype.setDateRangeParameter = function (reportParameters) {
    this.dateRangeSelector.setSelectedRange(reportParameters.dateRangeSelection);
};

ReportMediator.prototype._createPrintableDateRangeHeader = function () {
    return this.printableHeadersBuilder.addDateRangeHeaderStringParsed(this.reportParameters.dateRangeSelection);
};

ReportMediator.prototype.createDateRangeSelector = function (reportParameters) {
    var dateRangeSelectorConfig = {
        dateRangeSelection: reportParameters.dateRangeSelection,
        menuStates: new DateRangeMenuItemsUtil().createDefaultDateRangeMenuItems(reportParameters.dateRangeSelection.qualifier),
        dateRangeParsed: true,
        callOnChangeCallbackIfInvalid: true
    };

    return new DateRangeSelectorController().init(dateRangeSelectorConfig);
};

ReportMediator.prototype._updateReportControls = function () {
    this.setDateRangeParameter(this.reportParameters);
    this.editConfigController.setSelectorsFromReportParameters(this.reportParameters);
    this.editConfigController.resetConfig();
    this._updatePrintableDateRangeHeader();
};

ReportMediator.prototype.exportToCSV = function () {
    var form = (0, _jquery2.default)("#reportExportToCSVForm");
    form.attr("action", this.generateCSVUrl);
    form.find("input[name=configId]").val(this.reportConfigId);
    form.find("input[name=reportParameters]").val(JSON.stringify(this.reportParameters));

    this.saveConfigControl.toggleConfirmationOnExit(false);
    form.submit();
    var self = this;
    defer(function () {
        self.saveConfigControl.toggleConfirmationOnExit(true);
    });
};

ReportMediator.prototype.addReportOverlay = function () {
    if (!this.spinnerOverlay) {
        this.spinnerOverlay = new _SpinnerController2.default(true);
        this.spinnerOverlay.setSpinner(this.createSpinnerForOverLay());
    }
    var spinnerId = "spinnerReportOverlay";
    this.spinnerOverlay.spin(spinnerId);
    this.reportOverlay.show();

    var self = this;
    var element = this.reportPlaceholder.find("#report-table");
    if (element.length == 0) element = this.reportPlaceholder;

    this.offsetSpinnerAndOverlayInCenterElement(spinnerId, element);
    var scrollHandler = function scrollHandler() {
        self.offsetSpinnerAndOverlayInCenterElement(spinnerId, element);
    };
    var resizeHandler = function resizeHandler() {
        self.offsetSpinnerAndOverlayInCenterElement(spinnerId, element);
    };
    (0, _jquery2.default)(window).scroll(scrollHandler);
    (0, _jquery2.default)(window).resize(resizeHandler);
    this.unbindWindowHandlers = function () {
        (0, _jquery2.default)(window).off("scroll", scrollHandler);
        (0, _jquery2.default)(window).off("resize", resizeHandler);
    };
};

ReportMediator.prototype.createSpinnerForOverLay = function () {
    return new _spin2.default({
        lines: 11, // The number of lines to draw
        length: 6, // The length of each line
        width: 2, // The line thickness
        radius: 4, // The radius of the inner circle
        corners: 1, // Corner roundness (0..1)
        rotate: 0, // The rotation offset
        direction: 1, // 1: clockwise, -1: counterclockwise
        color: '#233446', // #rgb or #rrggbb
        speed: 1, // Rounds per second
        trail: 60, // Afterglow percentage
        shadow: false, // Whether to render a shadow
        hwaccel: false, // Whether to use hardware acceleration
        className: 'spinner', // The CSS class to assign to the spinner
        zIndex: 1001, // The z-index (defaults to 2000000000)
        top: 'auto', // Top position relative to parent in px
        left: 'auto' // Left position relative to parent in px
    });
};

ReportMediator.prototype.offsetSpinnerAndOverlayInCenterElement = function (spinnerId, element) {
    var windowTop = (0, _jquery2.default)(window).scrollTop();
    var windowBottom = (0, _jquery2.default)(window).scrollTop() + (0, _jquery2.default)(window).height();
    var tableTop = element.offset().top;
    var tableBottom = element.offset().top + element.height();

    var windowLeft = (0, _jquery2.default)(window).scrollLeft();
    var windowRight = (0, _jquery2.default)(window).scrollLeft() + (0, _jquery2.default)(window).width();
    var tableLeft = element.offset().left;
    var tableRight = element.offset().left + element.width();
    var top = Math.max(windowTop, tableTop);
    var bottom = Math.min(windowBottom, tableBottom);
    var left = Math.max(windowLeft, tableLeft);
    var right = Math.min(windowRight, tableRight);
    top += (bottom - top) / 2;
    left += (right - left) / 2;

    this.reportOverlay.width(Math.ceil(element.width()) + 2); // +2, because table with report has borders
    this.reportOverlay.height(Math.ceil(element.height()) + 1);
    this.reportOverlay.offset(element.position());
    (0, _jquery2.default)("#" + spinnerId).offset({ top: top, left: left });
};

ReportMediator.prototype.hideOverlay = function () {
    if (this.spinnerOverlay) this.spinnerOverlay.stop();
    this.reportPlaceholder.removeClass("empty");
    this.reportOverlay.hide();
    this.unbindWindowHandlers();
};

ReportMediator.prototype.updateParametersFromHistory = function () {
    var state = this.historyController.getState();

    if (state && state.reportParameters) {
        this.reportParameters = state.reportParameters;
        this.dataWasChanged = state.dataWasChanged;

        return true;
    }

    return false;
};

ReportMediator.prototype.generateReportFromHistory = function () {
    if (this.updateParametersFromHistory()) {
        if (!this.dataWasChanged) {
            this.dataWasChanged = true;
            this.historyController.updateState(this._makeHistoryState());
        }
        this.registerChanges();
    }

    this._updateReportControls();
    this.generateReport(true);
};

ReportMediator.prototype.generateReport = function (ignoreHistory) {
    this.baseGenerateReport(ignoreHistory);
};

ReportMediator.prototype.baseGenerateReport = function (ignoreHistory, additionalSuccessHandler) {
    if (!ignoreHistory) this._saveConfigToHistory();

    var self = this;
    var customErrorHandler = function customErrorHandler(errorCode, errorMessage) {
        if (errorCode === _constants.ReportConfigConstants.LEAVES_REPORT_ALL_SELECTED_LEAVES_DELETED) {
            self.showReportLoadingError(_messageResource2.default.getMessage("report.js.report_loading_error.no_selected_leave_types"));
            return true;
        }
        if (errorCode === _constants.ReportConfigConstants.NO_RIGHTS_FOR_MANAGING_PTO_AND_SICK) {
            if (EnabledFeatures.PTO && EnabledFeatures.SDB) {
                self.showReportLoadingError(_messageResource2.default.getMessage("report.js.report_loading_error.no_rights_manage_pto_and_sick"));
            } else if (EnabledFeatures.PTO) {
                self.showReportLoadingError(_messageResource2.default.getMessage("report.js.report_loading_error.no_rights_manage_pto"));
            } else if (EnabledFeatures.SDB) {
                self.showReportLoadingError(_messageResource2.default.getMessage("report.js.report_loading_error.no_rights_manage_sick"));
            }
            return true;
        }
        if (errorCode === _constants.ReportConfigConstants.ALL_SELECTED_FOR_REPORT_USERS_WERE_DELETED) {
            self.showReportLoadingError(_messageResource2.default.getMessage("report.js.report_loading_error.no_selected_users"));
            return true;
        }
        if (errorCode === _constants.ReportConfigConstants.OVERTIME_FOR_ALL_SELECTED_USERS_WAS_DISABLED) {
            self.showReportLoadingError(_messageResource2.default.getMessage("report.js.report_loading_error.no_selected_overtime_users"));
            return true;
        }
        if (errorCode === _constants.ReportConfigConstants.ALL_SELECTED_FOR_REPORT_PROJECTS_ARE_UNAVAILABLE_OR_DELETED) {
            self.showReportLoadingError(_messageResource2.default.getEscapedMessage("report.js.report_loading_error.no_selected_projects"));
            return true;
        }
        if (errorCode === _constants.ReportConfigConstants.NO_BILLABLE_TASKS) {
            self.showReportLoadingError(_messageResource2.default.getEscapedMessage("report.js.report_loading_error.no_billable_tasks"));
            return true;
        }
        if (errorCode === AJAX_USER_ACTION_ERROR_CODES.NO_RIGHTS) {
            alert(JQUERY_RPC_ERROR_MESSAGES.NO_RIGHTS);
            document.location.href = _constants.ReportConfigConstants.REPORTS_DASHBOARD_URL;
            return true;
        }
        if (errorCode == AJAX_USER_ACTION_ERROR_CODES.ERROR_STATE || errorCode == AJAX_USER_ACTION_ERROR_CODES.UNEXPECTED_ERROR) {
            self.showReportLoadingError(_messageResource2.default.getMessage("report.js.report_loading_error.unexpected_error", [PRODUCT_NAME]));
            if (errorMessage) console.log(errorMessage);
            return true;
        }
        return false;
    };

    var unknownErrorHandler = function unknownErrorHandler(jqXHR) {
        if (jqXHR.status >= 100 && jqXHR.status < 1000) self.showReportLoadingError(JQUERY_RPC_ERROR_MESSAGES.HTTP_ERROR + " " + jqXHR.status + " " + jqXHR.statusText);else self.showReportLoadingError(_messageResource2.default.getMessage("report.js.report_loading_error.network_error", [PRODUCT_NAME]));
    };

    var errorHandler = function errorHandler(jqXHR, textStatus) {
        self.hideOverlay();
        switch (textStatus) {
            case 'abort':
                break; // the request was aborted by the calling code; do nothing

            case 'timeout':
                self.showReportLoadingError(_messageResource2.default.getMessage("report.js.report_loading_error.timeout", [PRODUCT_NAME]));
                break;

            case 'error':
                handleAjaxUserActionError(jqXHR.status, jqXHR.responseText, customErrorHandler, unknownErrorHandler);
                break;

            default:
                self.showReportLoadingError(_messageResource2.default.getMessage("report.js.report_loading_error.unexpected_error", [PRODUCT_NAME]));
        }
    };

    var successHandler = function successHandler(data) {
        if (!self.validateGeneratedReport(data)) return;

        self.renderGeneratedReport(data);

        self.hideOverlay();

        if (additionalSuccessHandler) additionalSuccessHandler();
    };

    if (this.generateReportRequest) this.generateReportRequest.abort();

    this.addReportOverlay();
    this.generateReportRequest = this.requestGenerateReport(successHandler, errorHandler);
};

ReportMediator.prototype.requestGenerateReport = function (successHandler, errorHandler) {
    return _jquery2.default.ajax({
        url: this.generateReportUrl,
        type: 'POST',
        data: { configId: this.reportConfigId, configName: this.saveConfigControl.getReportConfigName(), reportParameters: JSON.stringify(this.reportParameters) },
        success: successHandler,
        error: errorHandler,
        timeout: 120000
    });
};

ReportMediator.prototype.validateGeneratedReport = function (data) {
    if (!data || data.length == 0) {
        this.hideOverlay();
        this.showReportLoadingError(_messageResource2.default.getMessage("report.js.report_loading_error.html_report_to_big"));
        return false;
    }

    return true;
};

ReportMediator.prototype.renderGeneratedReport = function (data) {
    this.reportPlaceholder.empty();
    this.reportPlaceholder.append(data);
};

ReportMediator.prototype.showReportLoadingError = function (errorMessage) {
    this.reportPlaceholder.html('<div class="reportLoadingError">' + errorMessage + '</div>');
    this.onReportLoadingError();
};

ReportMediator.prototype.onReportLoadingError = function () {
    // abstract
};

ReportMediator.prototype.commonSuccessSaveHandler = function (reportId, newConfigName) {
    if (reportId) this.reportConfigId = reportId;
    _jquery2.default.extend(this.initReportParameters, this.reportParameters);

    this.dataWasChanged = false;

    if (this.historyController.isSupported()) this.historyController.setUrlParam(this._makeHistoryState(), "?configId=" + this.reportConfigId);else window.location.href = window.location.pathname + "?configId=" + this.reportConfigId;

    this.printReportNamePlh.text(newConfigName);
};

ReportMediator.prototype._noRightsHandler = function (errorThrown) {
    if (errorThrown.exception && errorThrown.exception.indexOf('com.actimind.actitime.services.NoRightsForRemoteCallException') != -1) {
        alert(JQUERY_RPC_ERROR_MESSAGES.NO_RIGHTS);
        document.location.href = _constants.ReportConfigConstants.REPORTS_DASHBOARD_URL;
        return true;
    }

    return false;
};

ReportMediator.prototype._createPrintableHeaders = function () {
    var headersArray = [];
    this._clearPrintableHeadersFromPage();
    this._populateHeadersArray(headersArray);
    this._addPrintableHeadersToTable(headersArray);
};

ReportMediator.prototype._clearPrintableHeadersFromPage = function () {
    (0, _jquery2.default)('#printableDateRangeHeader').empty();
    (0, _jquery2.default)('#printableHeadersContainer').empty();
};

ReportMediator.prototype._addPrintableHeadersToTable = function (headersArray) {
    this._updatePrintableDateRangeHeader();

    var container = (0, _jquery2.default)('#printableHeadersContainer');
    var table = (0, _jquery2.default)('<table cellspacing="0" cellpadding="2" id="printableHeadersTable">');

    for (var i = 0; i < headersArray.length; i++) {
        table.append(this._createPrintableHeaderRow(headersArray[i]));
    }
    container.append(table);
};

ReportMediator.prototype._updatePrintableDateRangeHeader = function () {
    (0, _jquery2.default)('#printableDateRangeHeader').html(this._createPrintableDateRangeHeader());
};

ReportMediator.prototype._createPrintableHeaderRow = function (header) {
    return ['<tr class="reportParamRow">', '<td class="text printableHeaderLabelTD">', '<nobr>', '<span class="formblocktitle">', header.label, '</span>', '</nobr>', '</td>', '<td class="text printableHeaderValueTD">', header.value, '</td>', '</tr>'].join('');
};

ReportMediator.prototype.initPrintableHeadersBuilder = function (config) {
    //abstract
};

ReportMediator.prototype._populateHeadersArray = function (headersArray) {
    //abstract
};

ReportMediator.prototype.getEventName = function (event) {
    // abstract
};

ReportMediator.prototype.initPDFEvents = function () {
    var self = this;
    (0, _jquery2.default)(document).on(this.getEventName("showPDFPreview"), function () {
        self.pdfPreviewLightbox.show();
    });
    (0, _jquery2.default)(document).on(this.getEventName("pdfPreview.lightbox.hide"), function () {
        //do nothing
    });
    (0, _jquery2.default)(document).on(this.getEventName("pdfPreview.printParametersForSaveChange"), function (event, printParametersForSave) {
        self.store.setPrintParametersForSave(printParametersForSave);
    });
    (0, _jquery2.default)(document).on(this.getEventName("pdfPreview.printParametersForGenerateChange"), function (event, printParametersForGenerate) {
        self.store.setPrintParametersForGenerate(printParametersForGenerate);
        self.cancelAllPDFExportingProcesses();
        self.generatePDF();
    });
    (0, _jquery2.default)(document).on(this.getEventName("downloadPDF"), function () {
        (0, _utils.downloadPDF)(self.store.getGeneratedPDF(), self.store.getPDFFileName());
    });
};

ReportMediator.prototype.initCSVEvents = function () {
    var self = this;
    (0, _jquery2.default)(document).on(this.getEventName("createCSV"), function () {
        self.generateCSV();
    });
};

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = GroupingSelector;

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _ListSelector = __webpack_require__(96);

var _ListSelector2 = _interopRequireDefault(_ListSelector);

var _constants = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function GroupingSelector() {
    this.constructor = GroupingSelector;
}

GroupingSelector.ERROR_GROUPING_DUPLICATE = "errorGroupingDuplicate";
GroupingSelector.ERROR_DATES_AFTER_MONTHS = "errorDatesAfterMonths";
GroupingSelector.ERROR_DATES_AFTER_WEEKS = "errorDatesAfterWeeks";
GroupingSelector.ERROR_WEEKS_AFTER_MONTHS = "errorWeeksAfterMonths";
GroupingSelector.ERROR_INCORRECT_GROUPING_ORDER = "errorIncorrectGroupingOrder";

/**
 * Initializes selector
 * @param selectorId id of selector element
 * @param numberOfLevels - a number of grouping levels, 4 levels max
 * @param initialValues - an array containing initial values
 * @param changesCallback
 */
GroupingSelector.prototype.init = function (selectorId, numberOfLevels, initialValues, changesCallback) {
    if (numberOfLevels < 1 || numberOfLevels > 4) throw "Number of levels in Grouping selector cannot be " + numberOfLevels;

    this.numberOfLevels = numberOfLevels;

    this.selectorId = selectorId;
    this.selectorEl = (0, _jquery2.default)("#" + this.selectorId);

    this.initListSelectors(numberOfLevels, initialValues, changesCallback);

    for (var r = numberOfLevels; r <= 4; r++) {
        this.hideRow(r - 1);
    }this.updateTree();

    this.errorMessagesMap = {};
    this.errorMessagesMap[GroupingSelector.ERROR_GROUPING_DUPLICATE] = _messageResource2.default.getMessage("report.common.js.choose_grouping_opts");
    this.errorMessagesMap[GroupingSelector.ERROR_INCORRECT_GROUPING_ORDER] = _messageResource2.default.getMessage("report.form.choose_grouping_order_opts");
    this.errorMessagesMap[GroupingSelector.ERROR_DATES_AFTER_MONTHS] = _messageResource2.default.getMessage("report.common.js.grouping_dates_months");
    this.errorMessagesMap[GroupingSelector.ERROR_DATES_AFTER_WEEKS] = _messageResource2.default.getMessage("report.common.js.grouping_dates_weeks");
    this.errorMessagesMap[GroupingSelector.ERROR_WEEKS_AFTER_MONTHS] = _messageResource2.default.getMessage("report.common.js.grouping_weeks_months");
};

GroupingSelector.prototype.initListSelectors = function (numberOfLevels, initialValues, changesCallback) {
    this.listSelectors = [];

    var self = this;
    for (var i = 0; i < numberOfLevels; i++) {
        this.listSelectors[i] = this.initListSelector(i, initialValues[i], function () {
            self.onGroupingChange();
            if (changesCallback) changesCallback();
        });
    }
};

GroupingSelector.prototype.initListSelector = function (level, selectedValue, changesCallback) {
    var listSelector = new _ListSelector2.default({
        renderTo: this.selectorEl.find("#" + this.selectorId + "_groupingLevel" + level)[0]
    });
    this.fillListSelector(listSelector, level);
    listSelector.on("change", function () {
        if (changesCallback) changesCallback();
    });
    if (selectedValue) listSelector.setActiveItemByValue(selectedValue, true);
    return listSelector;
};

GroupingSelector.prototype.fillListSelector = function (listSelector, level) {
    // abstract
};

GroupingSelector.prototype.onGroupingChange = function () {
    this.updateTree();
};

GroupingSelector.prototype.getListSelectorValue = function (number) {
    return this.listSelectors[number].getSelectedItem().value;
};

GroupingSelector.prototype.updateTree = function () {
    // abstract
};

GroupingSelector.prototype.validate = function () {
    this.error = null;

    if (this.getNumberOfVisibleLevels() >= 2 && this.getListSelectorValue(0) === this.getListSelectorValue(1) && this.getListSelectorValue(1) !== _constants.ReportGroupingLevel.NONE) {
        this.error = GroupingSelector.ERROR_GROUPING_DUPLICATE;
        return false;
    }

    if (this.getNumberOfVisibleLevels() >= 3 && this.getListSelectorValue(2) !== _constants.ReportGroupingLevel.NONE && (this.getListSelectorValue(0) === this.getListSelectorValue(2) || this.getListSelectorValue(1) === this.getListSelectorValue(2))) {
        this.error = GroupingSelector.ERROR_GROUPING_DUPLICATE;
        return false;
    }

    return true;
};

GroupingSelector.prototype.verifyDateGroupingOrderFroTwoLevels = function () {
    var firstLevelValue = this.getListSelectorValue(0);
    var secondLevelValue = this.getListSelectorValue(1);

    if (firstLevelValue === _constants.ReportGroupingLevel.DATE && secondLevelValue === _constants.ReportGroupingLevel.MONTH) {
        this.error = GroupingSelector.ERROR_DATES_AFTER_MONTHS;
        return false;
    }
    if (firstLevelValue === _constants.ReportGroupingLevel.DATE && secondLevelValue === _constants.ReportGroupingLevel.WEEK) {
        this.error = GroupingSelector.ERROR_DATES_AFTER_WEEKS;
        return false;
    }
    if (firstLevelValue === _constants.ReportGroupingLevel.WEEK && secondLevelValue === _constants.ReportGroupingLevel.MONTH) {
        this.error = GroupingSelector.ERROR_WEEKS_AFTER_MONTHS;
        return false;
    }

    return true;
};

GroupingSelector.prototype.getErrorMessage = function () {
    return this.errorMessagesMap[this.error];
};

GroupingSelector.prototype.getValues = function () {
    var selection = [];

    for (var i = 0; i < this.getNumberOfVisibleLevels(); i++) {
        selection.push(this.getListSelectorValue(i));
    }return selection;
};

GroupingSelector.prototype.setValues = function (values) {
    for (var i = 0; i < values.length; i++) {
        this.listSelectors[i].setActiveItemByValue(values[i]);
    }
};

GroupingSelector.prototype.getRowEl = function (rowNumber) {
    return this.selectorEl.find("#" + this.selectorId + "_treeRow" + (rowNumber + 1));
};

GroupingSelector.prototype.setRowClassName = function (rowNumber, className) {
    this.getRowEl(rowNumber)[0].className = className;
};

GroupingSelector.prototype.addRowClassName = function (rowNumber, className) {
    this.getRowEl(rowNumber).addClass(className);
};

GroupingSelector.prototype.removeRowClassName = function (rowNumber, className) {
    this.getRowEl(rowNumber).removeClass(className);
};

GroupingSelector.prototype.hideRow = function (rowNumber) {
    this.addRowClassName(rowNumber, "tree-row-hidden");
};

GroupingSelector.prototype.showRow = function (rowNumber) {
    this.removeRowClassName(rowNumber, "tree-row-hidden");
};

GroupingSelector.prototype.getNumberOfVisibleLevels = function () {
    return this.numberOfLevels;
};

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ThreeLevelReportGroupingSelector;

var _GroupingSelectorWithDetailsLevel = __webpack_require__(982);

var _GroupingSelectorWithDetailsLevel2 = _interopRequireDefault(_GroupingSelectorWithDetailsLevel);

var _constants = __webpack_require__(11);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ThreeLevelReportGroupingSelector() {
    this.constructor = ThreeLevelReportGroupingSelector;
}

ThreeLevelReportGroupingSelector.prototype = _underscore2.default.create(_GroupingSelectorWithDetailsLevel2.default.prototype);

ThreeLevelReportGroupingSelector.prototype.init = function (config) {
    this.enableNoneFirstGrouping = config.enableNoneFirstGrouping;
    this.enableGroupByBillingType = config.enableGroupByBillingType;
    this.enableGroupByUsers = config.enableGroupByUsers;
    this.enableGroupByUserGroups = config.enableGroupByUserGroups;
    this.enableGroupByTimeZoneGroups = config.enableGroupByTimeZoneGroups;

    if (config.includeTTCommentsInDetailsLevel) {
        this.detailsLevelTaskGroupingTypes = [_constants.ReportGroupingLevel.TASK, _constants.ReportGroupingLevel.TT_COMMENTS, _constants.ReportGroupingLevel.TASK_AND_TT_COMMENTS];
        this.detailsLevelProjectGroupingTypes = [_constants.ReportGroupingLevel.PROJECT, _constants.ReportGroupingLevel.TT_COMMENTS, _constants.ReportGroupingLevel.PROJECT_AND_TT_COMMENTS];
        this.detailsLevelCustomerGroupingTypes = [_constants.ReportGroupingLevel.CUSTOMER, _constants.ReportGroupingLevel.TT_COMMENTS, _constants.ReportGroupingLevel.CUSTOMER_AND_TT_COMMENTS];
    } else {
        this.detailsLevelTaskGroupingTypes = [_constants.ReportGroupingLevel.TASK];
        this.detailsLevelProjectGroupingTypes = [_constants.ReportGroupingLevel.PROJECT];
        this.detailsLevelCustomerGroupingTypes = [_constants.ReportGroupingLevel.CUSTOMER];
    }

    _GroupingSelectorWithDetailsLevel2.default.prototype.init.call(this, config.selectorId, 2, config.groupingLevelsSelection, config.changesCallback);

    this.showRow(2);

    return this;
};

ThreeLevelReportGroupingSelector.prototype.fillListSelector = function (listSelector, level) {
    if (level === 0 || level === 1) {
        if (level === 1 || this.enableNoneFirstGrouping) {
            var itemTextKey = level === 0 ? "report.form.dont_use_1st_grouping_level" : "report.form.dont_use_2nd_grouping_level";
            listSelector.addItems([{
                text: _messageResource2.default.getMessage(itemTextKey),
                value: _constants.ReportGroupingLevel.NONE
            }]);
            listSelector.addSeparator();
        }
        listSelector.addItems([{
            text: _messageResource2.default.getEscapedMessage("common.Customers"),
            value: _constants.ReportGroupingLevel.CUSTOMER
        }, {
            text: _messageResource2.default.getEscapedMessage("common.Projects"),
            value: _constants.ReportGroupingLevel.PROJECT
        }, {
            text: _messageResource2.default.getEscapedMessage("report.form.projects_joined_by_name"),
            value: _constants.ReportGroupingLevel.PROJECT_NAME
        }, {
            text: _messageResource2.default.getEscapedMessage("report.form.tasks_joined_by_name"),
            value: _constants.ReportGroupingLevel.TASK_NAME
        }]);
        if (this.enableGroupByBillingType) {
            listSelector.addItems([{
                text: _messageResource2.default.getMessage("report.common.billing_types"),
                value: _constants.ReportGroupingLevel.BILLING_TYPE
            }]);
        }
        listSelector.addSeparator();
        if (this.enableGroupByUsers) {
            listSelector.addItems([{
                text: _messageResource2.default.getMessage("report.common.users"),
                value: _constants.ReportGroupingLevel.USER
            }]);
        }
        if (this.enableGroupByUserGroups) {
            listSelector.addItems([{
                text: _messageResource2.default.getEscapedMessage("common.User_Groups"),
                value: _constants.ReportGroupingLevel.USER_GROUP
            }]);
        }
        if (this.enableGroupByTimeZoneGroups) {
            listSelector.addItems([{
                text: _messageResource2.default.getEscapedMessage("common.Time_Zone_Groups"),
                value: _constants.ReportGroupingLevel.TIME_ZONE_GROUP
            }]);
        }
        if (this.enableGroupByUsers || this.enableGroupByUserGroups || this.enableGroupByTimeZoneGroups) {
            listSelector.addSeparator();
        }
        listSelector.addItems([{
            text: _messageResource2.default.getMessage("report.common.dates"),
            value: _constants.ReportGroupingLevel.DATE
        }, {
            text: _messageResource2.default.getMessage("report.common.weeks"),
            value: _constants.ReportGroupingLevel.WEEK
        }, {
            text: _messageResource2.default.getMessage("report.common.months"),
            value: _constants.ReportGroupingLevel.MONTH
        }]);
    } else {
        listSelector.addItems([{
            text: _messageResource2.default.getMessage("report.hide_details"),
            value: _constants.ReportGroupingLevel.NONE
        }, {
            text: _messageResource2.default.getEscapedMessage("common.Customers"),
            value: _constants.ReportGroupingLevel.CUSTOMER
        }, {
            text: _messageResource2.default.getEscapedMessage("common.Projects"),
            value: _constants.ReportGroupingLevel.PROJECT
        }, {
            text: _messageResource2.default.getEscapedMessage("common.Tasks"),
            value: _constants.ReportGroupingLevel.TASK
        }, {
            text: _messageResource2.default.getMessage("report.tt_comments"),
            value: _constants.ReportGroupingLevel.TT_COMMENTS
        }, {
            text: _messageResource2.default.getEscapedMessage("report.tasks.and_tt_comments"),
            value: _constants.ReportGroupingLevel.TASK_AND_TT_COMMENTS
        }, {
            text: _messageResource2.default.getEscapedMessage("report.projects.and_tt_comments"),
            value: _constants.ReportGroupingLevel.PROJECT_AND_TT_COMMENTS
        }, {
            text: _messageResource2.default.getEscapedMessage("report.customers.and_tt_comments"),
            value: _constants.ReportGroupingLevel.CUSTOMER_AND_TT_COMMENTS
        }]);
    }
};

ThreeLevelReportGroupingSelector.prototype.validate = function () {
    if (!_GroupingSelectorWithDetailsLevel2.default.prototype.validate.call(this)) return false;

    return this.verifyDateGroupingOrderFroTwoLevels();
};

ThreeLevelReportGroupingSelector.prototype.isProjectGroupingLevel = function (groupingLevel) {
    return groupingLevel === _constants.ReportGroupingLevel.PROJECT || groupingLevel === _constants.ReportGroupingLevel.PROJECT_NAME;
};

ThreeLevelReportGroupingSelector.prototype.isTaskGroupingLevel = function (groupingLevel) {
    return groupingLevel === _constants.ReportGroupingLevel.TASK_NAME;
};

ThreeLevelReportGroupingSelector.prototype.getDetailsGroupingSelection = function (allowedDetails, detailsGrouping) {
    var changeSelectionTo = [];
    if (detailsGrouping === _constants.ReportGroupingLevel.CUSTOMER_AND_TT_COMMENTS) changeSelectionTo = [_constants.ReportGroupingLevel.PROJECT_AND_TT_COMMENTS, _constants.ReportGroupingLevel.TASK_AND_TT_COMMENTS];
    if (detailsGrouping === _constants.ReportGroupingLevel.PROJECT_AND_TT_COMMENTS) changeSelectionTo = [_constants.ReportGroupingLevel.CUSTOMER_AND_TT_COMMENTS, _constants.ReportGroupingLevel.TASK_AND_TT_COMMENTS];
    if (detailsGrouping === _constants.ReportGroupingLevel.TASK_AND_TT_COMMENTS) changeSelectionTo = [_constants.ReportGroupingLevel.CUSTOMER_AND_TT_COMMENTS, _constants.ReportGroupingLevel.PROJECT_AND_TT_COMMENTS];

    for (var i = 0; i < changeSelectionTo.length; i++) {
        if (allowedDetails.includes(changeSelectionTo[i])) return changeSelectionTo[i];
    }
    return allowedDetails[0];
};

ThreeLevelReportGroupingSelector.prototype.updateDetailsOptions = function () {
    var firstGrouping = this.getListSelectorValue(0);
    var secondGrouping = this.getListSelectorValue(1);
    var detailsGrouping = this.getDetailsListSelectorValue();

    var allowedDetails = [];

    if (this.isTaskGroupingLevel(firstGrouping) || this.isTaskGroupingLevel(secondGrouping)) {
        if (this.isProjectGroupingLevel(firstGrouping) || this.isProjectGroupingLevel(secondGrouping)) allowedDetails = this.detailsLevelCustomerGroupingTypes.slice();else allowedDetails = this.detailsLevelProjectGroupingTypes.slice();
    } else allowedDetails = this.detailsLevelTaskGroupingTypes.slice();

    if (!(firstGrouping === _constants.ReportGroupingLevel.NONE && secondGrouping === _constants.ReportGroupingLevel.NONE)) allowedDetails.push(_constants.ReportGroupingLevel.NONE);

    this.detailsListSelector.menu.items.each(function (item) {
        if (allowedDetails.includes(item.value)) item.show();else item.hide();
    });

    var itemToSelect = allowedDetails.includes(detailsGrouping) ? detailsGrouping : this.getDetailsGroupingSelection(allowedDetails, detailsGrouping);

    this.detailsListSelector.setActiveItemByValue(itemToSelect);
};

ThreeLevelReportGroupingSelector.prototype.updateTree = function () {
    var firstShown = this.getListSelectorValue(0) !== _constants.ReportGroupingLevel.NONE;
    var secondShown = this.getListSelectorValue(1) !== _constants.ReportGroupingLevel.NONE;
    var detailsShown = this.getDetailsListSelectorValue() !== _constants.ReportGroupingLevel.NONE;

    if (firstShown) {
        this.setRowClassName(0, "");
        this.setRowClassName(1, secondShown ? "tree-row-A" : detailsShown ? "tree-row-J" : "tree-row-I");
        this.setRowClassName(2, detailsShown ? secondShown ? "tree-row-SA" : "tree-row-AL" : "tree-row-SI");
    } else {
        this.setRowClassName(0, "tree-row-I");
        this.setRowClassName(1, secondShown ? "tree-row-AI" : "tree-row-I");
        this.setRowClassName(2, detailsShown ? secondShown ? "tree-row-SA" : "tree-row-SAI" : "tree-row-SI");
    }
};

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = CSVPreviewEmptySection;

var _CSVPreviewSection = __webpack_require__(43);

var _CSVPreviewSection2 = _interopRequireDefault(_CSVPreviewSection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CSVPreviewEmptySection() {}

CSVPreviewEmptySection.prototype = new _CSVPreviewSection2.default();
CSVPreviewEmptySection.prototype.init = function (numOfRows, totalNumOfColumns) {
    _CSVPreviewSection2.default.prototype.init.call(this);
    this.numOfRows = numOfRows;
    this.totalNumOfColumns = totalNumOfColumns;
    return this;
};

CSVPreviewEmptySection.prototype.addRows = function (tBody) {
    for (var i = 0; i < this.numOfRows; i++) {
        this.addEmptyRow(tBody);
    }
};

CSVPreviewEmptySection.prototype.addEmptyRow = function (tBody) {
    var emptyRow = this.createRow();
    ReportPreviewUtils.addEmptyCells(emptyRow, this.totalNumOfColumns);
    this.addRow(tBody, emptyRow);
};

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = BillingSummaryCSVPreviewColumnsStrategy;

var _CSVColumnsStrategy = __webpack_require__(413);

var _CSVColumnsStrategy2 = _interopRequireDefault(_CSVColumnsStrategy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function BillingSummaryCSVPreviewColumnsStrategy() {}
BillingSummaryCSVPreviewColumnsStrategy.prototype = new _CSVColumnsStrategy2.default();
BillingSummaryCSVPreviewColumnsStrategy.prototype.init = function () {
    _CSVColumnsStrategy2.default.prototype.init.call(this);
    return this;
};

BillingSummaryCSVPreviewColumnsStrategy.prototype.getNumOfDataColumns = function () {
    // abstract
};

BillingSummaryCSVPreviewColumnsStrategy.prototype.addMainHeaderRowCells = function (mainHeaderRow) {
    // abstract
};

BillingSummaryCSVPreviewColumnsStrategy.prototype.addColumnGropingHeaderRowCells = function (colGroupingRow) {
    // abstract
};

BillingSummaryCSVPreviewColumnsStrategy.prototype.addDataCells = function (row) {
    for (var i = 0; i < this.getNumOfDataColumns(); i++) {
        this.addTimeValueCell(row);
    }
};

BillingSummaryCSVPreviewColumnsStrategy.prototype.addEmptyCells = function (row) {
    ReportPreviewUtils.addEmptyCells(row, this.getNumOfDataColumns());
};

BillingSummaryCSVPreviewColumnsStrategy.prototype.addBillingTypeCells = function (row, numOfCells) {
    for (var i = 0; i < numOfCells; i++) {
        this.addBillingTypeCell(row);
    }
};

BillingSummaryCSVPreviewColumnsStrategy.prototype.addBillingTypeCell = function (row) {
    this.addCell(row, this.message("report.billing_type"));
};

/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(89);
var toLength = __webpack_require__(54);
var toAbsoluteIndex = __webpack_require__(177);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(132);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(132);
var TAG = __webpack_require__(41)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(41)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(152);
var step = __webpack_require__(613);
var Iterators = __webpack_require__(216);
var toIObject = __webpack_require__(89);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(418)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

var $iterators = __webpack_require__(330);
var getKeys = __webpack_require__(176);
var redefine = __webpack_require__(74);
var global = __webpack_require__(35);
var hide = __webpack_require__(87);
var Iterators = __webpack_require__(216);
var wks = __webpack_require__(41);
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
  }
}


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(112);
var call = __webpack_require__(610);
var isArrayIter = __webpack_require__(424);
var anObject = __webpack_require__(38);
var toLength = __webpack_require__(54);
var getIterFn = __webpack_require__(426);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(35);
var $export = __webpack_require__(10);
var redefine = __webpack_require__(74);
var redefineAll = __webpack_require__(219);
var meta = __webpack_require__(154);
var forOf = __webpack_require__(332);
var anInstance = __webpack_require__(220);
var isObject = __webpack_require__(31);
var fails = __webpack_require__(32);
var $iterDetect = __webpack_require__(329);
var setToStringTag = __webpack_require__(217);
var inheritIfRequired = __webpack_require__(429);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  var fixMethod = function (KEY) {
    var fn = proto[KEY];
    redefine(proto, KEY,
      KEY == 'delete' ? function (a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'has' ? function has(a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'get' ? function get(a) {
        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
    );
  };
  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    var instance = new C();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new C();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });
    if (!ACCEPT_ITERABLES) {
      C = wrapper(function (target, iterable) {
        anInstance(target, C, NAME);
        var that = inheritIfRequired(new Base(), target, C);
        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
        return that;
      });
      C.prototype = proto;
      proto.constructor = C;
    }
    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }
    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
    // weak collections should not contains .clear method
    if (IS_WEAK && proto.clear) delete proto.clear;
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F * (C != Base), O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(10);
var defined = __webpack_require__(151);
var fails = __webpack_require__(32);
var spaces = __webpack_require__(433);
var space = '[' + spaces + ']';
var non = '\u200b\u0085';
var ltrim = RegExp('^' + space + space + '*');
var rtrim = RegExp(space + space + '*$');

var exporter = function (KEY, exec, ALIAS) {
  var exp = {};
  var FORCE = fails(function () {
    return !!spaces[KEY]() || non[KEY]() != non;
  });
  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
  if (ALIAS) exp[ALIAS] = fn;
  $export($export.P + $export.F * FORCE, 'String', exp);
};

// 1 -> String#trimLeft
// 2 -> String#trimRight
// 3 -> String#trim
var trim = exporter.trim = function (string, TYPE) {
  string = String(defined(string));
  if (TYPE & 1) string = string.replace(ltrim, '');
  if (TYPE & 2) string = string.replace(rtrim, '');
  return string;
};

module.exports = exporter;


/***/ }),
/* 335 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var hide = __webpack_require__(87);
var redefine = __webpack_require__(74);
var fails = __webpack_require__(32);
var defined = __webpack_require__(151);
var wks = __webpack_require__(41);

module.exports = function (KEY, length, exec) {
  var SYMBOL = wks(KEY);
  var fns = exec(defined, SYMBOL, ''[KEY]);
  var strfn = fns[0];
  var rxfn = fns[1];
  if (fails(function () {
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  })) {
    redefine(String.prototype, KEY, strfn);
    hide(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return rxfn.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return rxfn.call(string, this); }
    );
  }
};


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(35);
var hide = __webpack_require__(87);
var uid = __webpack_require__(174);
var TYPED = uid('typed_array');
var VIEW = uid('view');
var ABV = !!(global.ArrayBuffer && global.DataView);
var CONSTR = ABV;
var i = 0;
var l = 9;
var Typed;

var TypedArrayConstructors = (
  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
).split(',');

while (i < l) {
  if (Typed = global[TypedArrayConstructors[i++]]) {
    hide(Typed.prototype, TYPED, true);
    hide(Typed.prototype, VIEW, true);
  } else CONSTR = false;
}

module.exports = {
  ABV: ABV,
  CONSTR: CONSTR,
  TYPED: TYPED,
  VIEW: VIEW
};


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// Forced replacement prototype accessors methods
module.exports = __webpack_require__(172) || !__webpack_require__(32)(function () {
  var K = Math.random();
  // In FF throws only define methods
  // eslint-disable-next-line no-undef, no-useless-call
  __defineSetter__.call(null, K, function () { /* empty */ });
  delete __webpack_require__(35)[K];
});


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {
/*
 *
 * More info at [www.dropzonejs.com](http://www.dropzonejs.com)
 *
 * Copyright (c) 2012, Matias Meno
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 *
 */

(function() {
  var Dropzone, Emitter, camelize, contentLoaded, detectVerticalSquash, drawImageIOSFix, noop, without,
    __slice = [].slice,
    __hasProp = {}.hasOwnProperty,
    __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

  noop = function() {};

  Emitter = (function() {
    function Emitter() {}

    Emitter.prototype.addEventListener = Emitter.prototype.on;

    Emitter.prototype.on = function(event, fn) {
      this._callbacks = this._callbacks || {};
      if (!this._callbacks[event]) {
        this._callbacks[event] = [];
      }
      this._callbacks[event].push(fn);
      return this;
    };

    Emitter.prototype.emit = function() {
      var args, callback, callbacks, event, _i, _len;
      event = arguments[0], args = 2 <= arguments.length ? __slice.call(arguments, 1) : [];
      this._callbacks = this._callbacks || {};
      callbacks = this._callbacks[event];
      if (callbacks) {
        for (_i = 0, _len = callbacks.length; _i < _len; _i++) {
          callback = callbacks[_i];
          callback.apply(this, args);
        }
      }
      return this;
    };

    Emitter.prototype.removeListener = Emitter.prototype.off;

    Emitter.prototype.removeAllListeners = Emitter.prototype.off;

    Emitter.prototype.removeEventListener = Emitter.prototype.off;

    Emitter.prototype.off = function(event, fn) {
      var callback, callbacks, i, _i, _len;
      if (!this._callbacks || arguments.length === 0) {
        this._callbacks = {};
        return this;
      }
      callbacks = this._callbacks[event];
      if (!callbacks) {
        return this;
      }
      if (arguments.length === 1) {
        delete this._callbacks[event];
        return this;
      }
      for (i = _i = 0, _len = callbacks.length; _i < _len; i = ++_i) {
        callback = callbacks[i];
        if (callback === fn) {
          callbacks.splice(i, 1);
          break;
        }
      }
      return this;
    };

    return Emitter;

  })();

  Dropzone = (function(_super) {
    var extend, resolveOption;

    __extends(Dropzone, _super);

    Dropzone.prototype.Emitter = Emitter;


    /*
    This is a list of all available events you can register on a dropzone object.
    
    You can register an event handler like this:
    
        dropzone.on("dragEnter", function() { });
     */

    Dropzone.prototype.events = ["drop", "dragstart", "dragend", "dragenter", "dragover", "dragleave", "addedfile", "addedfiles", "removedfile", "thumbnail", "error", "errormultiple", "processing", "processingmultiple", "uploadprogress", "totaluploadprogress", "sending", "sendingmultiple", "success", "successmultiple", "canceled", "canceledmultiple", "complete", "completemultiple", "reset", "maxfilesexceeded", "maxfilesreached", "queuecomplete"];

    Dropzone.prototype.defaultOptions = {
      url: null,
      method: "post",
      withCredentials: false,
      parallelUploads: 2,
      uploadMultiple: false,
      maxFilesize: 256,
      paramName: "file",
      createImageThumbnails: true,
      maxThumbnailFilesize: 10,
      thumbnailWidth: 120,
      thumbnailHeight: 120,
      filesizeBase: 1000,
      maxFiles: null,
      params: {},
      clickable: true,
      ignoreHiddenFiles: true,
      acceptedFiles: null,
      acceptedMimeTypes: null,
      autoProcessQueue: true,
      autoQueue: true,
      addRemoveLinks: false,
      previewsContainer: null,
      hiddenInputContainer: "body",
      capture: null,
      renameFilename: null,
      dictDefaultMessage: "Drop files here to upload",
      dictFallbackMessage: "Your browser does not support drag'n'drop file uploads.",
      dictFallbackText: "Please use the fallback form below to upload your files like in the olden days.",
      dictFileTooBig: "File is too big ({{filesize}}MiB). Max filesize: {{maxFilesize}}MiB.",
      dictInvalidFileType: "You can't upload files of this type.",
      dictResponseError: "Server responded with {{statusCode}} code.",
      dictCancelUpload: "Cancel upload",
      dictCancelUploadConfirmation: "Are you sure you want to cancel this upload?",
      dictRemoveFile: "Remove file",
      dictRemoveFileConfirmation: null,
      dictMaxFilesExceeded: "You can not upload any more files.",
      accept: function(file, done) {
        return done();
      },
      init: function() {
        return noop;
      },
      forceFallback: false,
      fallback: function() {
        var child, messageElement, span, _i, _len, _ref;
        this.element.className = "" + this.element.className + " dz-browser-not-supported";
        _ref = this.element.getElementsByTagName("div");
        for (_i = 0, _len = _ref.length; _i < _len; _i++) {
          child = _ref[_i];
          if (/(^| )dz-message($| )/.test(child.className)) {
            messageElement = child;
            child.className = "dz-message";
            continue;
          }
        }
        if (!messageElement) {
          messageElement = Dropzone.createElement("<div class=\"dz-message\"><span></span></div>");
          this.element.appendChild(messageElement);
        }
        span = messageElement.getElementsByTagName("span")[0];
        if (span) {
          if (span.textContent != null) {
            span.textContent = this.options.dictFallbackMessage;
          } else if (span.innerText != null) {
            span.innerText = this.options.dictFallbackMessage;
          }
        }
        return this.element.appendChild(this.getFallbackForm());
      },
      resize: function(file) {
        var info, srcRatio, trgRatio;
        info = {
          srcX: 0,
          srcY: 0,
          srcWidth: file.width,
          srcHeight: file.height
        };
        srcRatio = file.width / file.height;
        info.optWidth = this.options.thumbnailWidth;
        info.optHeight = this.options.thumbnailHeight;
        if ((info.optWidth == null) && (info.optHeight == null)) {
          info.optWidth = info.srcWidth;
          info.optHeight = info.srcHeight;
        } else if (info.optWidth == null) {
          info.optWidth = srcRatio * info.optHeight;
        } else if (info.optHeight == null) {
          info.optHeight = (1 / srcRatio) * info.optWidth;
        }
        trgRatio = info.optWidth / info.optHeight;
        if (file.height < info.optHeight || file.width < info.optWidth) {
          info.trgHeight = info.srcHeight;
          info.trgWidth = info.srcWidth;
        } else {
          if (srcRatio > trgRatio) {
            info.srcHeight = file.height;
            info.srcWidth = info.srcHeight * trgRatio;
          } else {
            info.srcWidth = file.width;
            info.srcHeight = info.srcWidth / trgRatio;
          }
        }
        info.srcX = (file.width - info.srcWidth) / 2;
        info.srcY = (file.height - info.srcHeight) / 2;
        return info;
      },

      /*
      Those functions register themselves to the events on init and handle all
      the user interface specific stuff. Overwriting them won't break the upload
      but can break the way it's displayed.
      You can overwrite them if you don't like the default behavior. If you just
      want to add an additional event handler, register it on the dropzone object
      and don't overwrite those options.
       */
      drop: function(e) {
        return this.element.classList.remove("dz-drag-hover");
      },
      dragstart: noop,
      dragend: function(e) {
        return this.element.classList.remove("dz-drag-hover");
      },
      dragenter: function(e) {
        return this.element.classList.add("dz-drag-hover");
      },
      dragover: function(e) {
        return this.element.classList.add("dz-drag-hover");
      },
      dragleave: function(e) {
        return this.element.classList.remove("dz-drag-hover");
      },
      paste: noop,
      reset: function() {
        return this.element.classList.remove("dz-started");
      },
      addedfile: function(file) {
        var node, removeFileEvent, removeLink, _i, _j, _k, _len, _len1, _len2, _ref, _ref1, _ref2, _results;
        if (this.element === this.previewsContainer) {
          this.element.classList.add("dz-started");
        }
        if (this.previewsContainer) {
          file.previewElement = Dropzone.createElement(this.options.previewTemplate.trim());
          file.previewTemplate = file.previewElement;
          this.previewsContainer.appendChild(file.previewElement);
          _ref = file.previewElement.querySelectorAll("[data-dz-name]");
          for (_i = 0, _len = _ref.length; _i < _len; _i++) {
            node = _ref[_i];
            node.textContent = this._renameFilename(file.name);
          }
          _ref1 = file.previewElement.querySelectorAll("[data-dz-size]");
          for (_j = 0, _len1 = _ref1.length; _j < _len1; _j++) {
            node = _ref1[_j];
            node.innerHTML = this.filesize(file.size);
          }
          if (this.options.addRemoveLinks) {
            file._removeLink = Dropzone.createElement("<a class=\"dz-remove\" href=\"javascript:undefined;\" data-dz-remove>" + this.options.dictRemoveFile + "</a>");
            file.previewElement.appendChild(file._removeLink);
          }
          removeFileEvent = (function(_this) {
            return function(e) {
              e.preventDefault();
              e.stopPropagation();
              if (file.status === Dropzone.UPLOADING) {
                return Dropzone.confirm(_this.options.dictCancelUploadConfirmation, function() {
                  return _this.removeFile(file);
                });
              } else {
                if (_this.options.dictRemoveFileConfirmation) {
                  return Dropzone.confirm(_this.options.dictRemoveFileConfirmation, function() {
                    return _this.removeFile(file);
                  });
                } else {
                  return _this.removeFile(file);
                }
              }
            };
          })(this);
          _ref2 = file.previewElement.querySelectorAll("[data-dz-remove]");
          _results = [];
          for (_k = 0, _len2 = _ref2.length; _k < _len2; _k++) {
            removeLink = _ref2[_k];
            _results.push(removeLink.addEventListener("click", removeFileEvent));
          }
          return _results;
        }
      },
      removedfile: function(file) {
        var _ref;
        if (file.previewElement) {
          if ((_ref = file.previewElement) != null) {
            _ref.parentNode.removeChild(file.previewElement);
          }
        }
        return this._updateMaxFilesReachedClass();
      },
      thumbnail: function(file, dataUrl) {
        var thumbnailElement, _i, _len, _ref;
        if (file.previewElement) {
          file.previewElement.classList.remove("dz-file-preview");
          _ref = file.previewElement.querySelectorAll("[data-dz-thumbnail]");
          for (_i = 0, _len = _ref.length; _i < _len; _i++) {
            thumbnailElement = _ref[_i];
            thumbnailElement.alt = file.name;
            thumbnailElement.src = dataUrl;
          }
          return setTimeout(((function(_this) {
            return function() {
              return file.previewElement.classList.add("dz-image-preview");
            };
          })(this)), 1);
        }
      },
      error: function(file, message) {
        var node, _i, _len, _ref, _results;
        if (file.previewElement) {
          file.previewElement.classList.add("dz-error");
          if (typeof message !== "String" && message.error) {
            message = message.error;
          }
          _ref = file.previewElement.querySelectorAll("[data-dz-errormessage]");
          _results = [];
          for (_i = 0, _len = _ref.length; _i < _len; _i++) {
            node = _ref[_i];
            _results.push(node.textContent = message);
          }
          return _results;
        }
      },
      errormultiple: noop,
      processing: function(file) {
        if (file.previewElement) {
          file.previewElement.classList.add("dz-processing");
          if (file._removeLink) {
            return file._removeLink.textContent = this.options.dictCancelUpload;
          }
        }
      },
      processingmultiple: noop,
      uploadprogress: function(file, progress, bytesSent) {
        var node, _i, _len, _ref, _results;
        if (file.previewElement) {
          _ref = file.previewElement.querySelectorAll("[data-dz-uploadprogress]");
          _results = [];
          for (_i = 0, _len = _ref.length; _i < _len; _i++) {
            node = _ref[_i];
            if (node.nodeName === 'PROGRESS') {
              _results.push(node.value = progress);
            } else {
              _results.push(node.style.width = "" + progress + "%");
            }
          }
          return _results;
        }
      },
      totaluploadprogress: noop,
      sending: noop,
      sendingmultiple: noop,
      success: function(file) {
        if (file.previewElement) {
          return file.previewElement.classList.add("dz-success");
        }
      },
      successmultiple: noop,
      canceled: function(file) {
        return this.emit("error", file, "Upload canceled.");
      },
      canceledmultiple: noop,
      complete: function(file) {
        if (file._removeLink) {
          file._removeLink.textContent = this.options.dictRemoveFile;
        }
        if (file.previewElement) {
          return file.previewElement.classList.add("dz-complete");
        }
      },
      completemultiple: noop,
      maxfilesexceeded: noop,
      maxfilesreached: noop,
      queuecomplete: noop,
      addedfiles: noop,
      previewTemplate: "<div class=\"dz-preview dz-file-preview\">\n  <div class=\"dz-image\"><img data-dz-thumbnail /></div>\n  <div class=\"dz-details\">\n    <div class=\"dz-size\"><span data-dz-size></span></div>\n    <div class=\"dz-filename\"><span data-dz-name></span></div>\n  </div>\n  <div class=\"dz-progress\"><span class=\"dz-upload\" data-dz-uploadprogress></span></div>\n  <div class=\"dz-error-message\"><span data-dz-errormessage></span></div>\n  <div class=\"dz-success-mark\">\n    <svg width=\"54px\" height=\"54px\" viewBox=\"0 0 54 54\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" xmlns:sketch=\"http://www.bohemiancoding.com/sketch/ns\">\n      <title>Check</title>\n      <defs></defs>\n      <g id=\"Page-1\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" sketch:type=\"MSPage\">\n        <path d=\"M23.5,31.8431458 L17.5852419,25.9283877 C16.0248253,24.3679711 13.4910294,24.366835 11.9289322,25.9289322 C10.3700136,27.4878508 10.3665912,30.0234455 11.9283877,31.5852419 L20.4147581,40.0716123 C20.5133999,40.1702541 20.6159315,40.2626649 20.7218615,40.3488435 C22.2835669,41.8725651 24.794234,41.8626202 26.3461564,40.3106978 L43.3106978,23.3461564 C44.8771021,21.7797521 44.8758057,19.2483887 43.3137085,17.6862915 C41.7547899,16.1273729 39.2176035,16.1255422 37.6538436,17.6893022 L23.5,31.8431458 Z M27,53 C41.3594035,53 53,41.3594035 53,27 C53,12.6405965 41.3594035,1 27,1 C12.6405965,1 1,12.6405965 1,27 C1,41.3594035 12.6405965,53 27,53 Z\" id=\"Oval-2\" stroke-opacity=\"0.198794158\" stroke=\"#747474\" fill-opacity=\"0.816519475\" fill=\"#FFFFFF\" sketch:type=\"MSShapeGroup\"></path>\n      </g>\n    </svg>\n  </div>\n  <div class=\"dz-error-mark\">\n    <svg width=\"54px\" height=\"54px\" viewBox=\"0 0 54 54\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" xmlns:sketch=\"http://www.bohemiancoding.com/sketch/ns\">\n      <title>Error</title>\n      <defs></defs>\n      <g id=\"Page-1\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" sketch:type=\"MSPage\">\n        <g id=\"Check-+-Oval-2\" sketch:type=\"MSLayerGroup\" stroke=\"#747474\" stroke-opacity=\"0.198794158\" fill=\"#FFFFFF\" fill-opacity=\"0.816519475\">\n          <path d=\"M32.6568542,29 L38.3106978,23.3461564 C39.8771021,21.7797521 39.8758057,19.2483887 38.3137085,17.6862915 C36.7547899,16.1273729 34.2176035,16.1255422 32.6538436,17.6893022 L27,23.3431458 L21.3461564,17.6893022 C19.7823965,16.1255422 17.2452101,16.1273729 15.6862915,17.6862915 C14.1241943,19.2483887 14.1228979,21.7797521 15.6893022,23.3461564 L21.3431458,29 L15.6893022,34.6538436 C14.1228979,36.2202479 14.1241943,38.7516113 15.6862915,40.3137085 C17.2452101,41.8726271 19.7823965,41.8744578 21.3461564,40.3106978 L27,34.6568542 L32.6538436,40.3106978 C34.2176035,41.8744578 36.7547899,41.8726271 38.3137085,40.3137085 C39.8758057,38.7516113 39.8771021,36.2202479 38.3106978,34.6538436 L32.6568542,29 Z M27,53 C41.3594035,53 53,41.3594035 53,27 C53,12.6405965 41.3594035,1 27,1 C12.6405965,1 1,12.6405965 1,27 C1,41.3594035 12.6405965,53 27,53 Z\" id=\"Oval-2\" sketch:type=\"MSShapeGroup\"></path>\n        </g>\n      </g>\n    </svg>\n  </div>\n</div>"
    };

    extend = function() {
      var key, object, objects, target, val, _i, _len;
      target = arguments[0], objects = 2 <= arguments.length ? __slice.call(arguments, 1) : [];
      for (_i = 0, _len = objects.length; _i < _len; _i++) {
        object = objects[_i];
        for (key in object) {
          val = object[key];
          target[key] = val;
        }
      }
      return target;
    };

    function Dropzone(element, options) {
      var elementOptions, fallback, _ref;
      this.element = element;
      this.version = Dropzone.version;
      this.defaultOptions.previewTemplate = this.defaultOptions.previewTemplate.replace(/\n*/g, "");
      this.clickableElements = [];
      this.listeners = [];
      this.files = [];
      if (typeof this.element === "string") {
        this.element = document.querySelector(this.element);
      }
      if (!(this.element && (this.element.nodeType != null))) {
        throw new Error("Invalid dropzone element.");
      }
      if (this.element.dropzone) {
        throw new Error("Dropzone already attached.");
      }
      Dropzone.instances.push(this);
      this.element.dropzone = this;
      elementOptions = (_ref = Dropzone.optionsForElement(this.element)) != null ? _ref : {};
      this.options = extend({}, this.defaultOptions, elementOptions, options != null ? options : {});
      if (this.options.forceFallback || !Dropzone.isBrowserSupported()) {
        return this.options.fallback.call(this);
      }
      if (this.options.url == null) {
        this.options.url = this.element.getAttribute("action");
      }
      if (!this.options.url) {
        throw new Error("No URL provided.");
      }
      if (this.options.acceptedFiles && this.options.acceptedMimeTypes) {
        throw new Error("You can't provide both 'acceptedFiles' and 'acceptedMimeTypes'. 'acceptedMimeTypes' is deprecated.");
      }
      if (this.options.acceptedMimeTypes) {
        this.options.acceptedFiles = this.options.acceptedMimeTypes;
        delete this.options.acceptedMimeTypes;
      }
      this.options.method = this.options.method.toUpperCase();
      if ((fallback = this.getExistingFallback()) && fallback.parentNode) {
        fallback.parentNode.removeChild(fallback);
      }
      if (this.options.previewsContainer !== false) {
        if (this.options.previewsContainer) {
          this.previewsContainer = Dropzone.getElement(this.options.previewsContainer, "previewsContainer");
        } else {
          this.previewsContainer = this.element;
        }
      }
      if (this.options.clickable) {
        if (this.options.clickable === true) {
          this.clickableElements = [this.element];
        } else {
          this.clickableElements = Dropzone.getElements(this.options.clickable, "clickable");
        }
      }
      this.init();
    }

    Dropzone.prototype.getAcceptedFiles = function() {
      var file, _i, _len, _ref, _results;
      _ref = this.files;
      _results = [];
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        file = _ref[_i];
        if (file.accepted) {
          _results.push(file);
        }
      }
      return _results;
    };

    Dropzone.prototype.getRejectedFiles = function() {
      var file, _i, _len, _ref, _results;
      _ref = this.files;
      _results = [];
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        file = _ref[_i];
        if (!file.accepted) {
          _results.push(file);
        }
      }
      return _results;
    };

    Dropzone.prototype.getFilesWithStatus = function(status) {
      var file, _i, _len, _ref, _results;
      _ref = this.files;
      _results = [];
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        file = _ref[_i];
        if (file.status === status) {
          _results.push(file);
        }
      }
      return _results;
    };

    Dropzone.prototype.getQueuedFiles = function() {
      return this.getFilesWithStatus(Dropzone.QUEUED);
    };

    Dropzone.prototype.getUploadingFiles = function() {
      return this.getFilesWithStatus(Dropzone.UPLOADING);
    };

    Dropzone.prototype.getAddedFiles = function() {
      return this.getFilesWithStatus(Dropzone.ADDED);
    };

    Dropzone.prototype.getActiveFiles = function() {
      var file, _i, _len, _ref, _results;
      _ref = this.files;
      _results = [];
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        file = _ref[_i];
        if (file.status === Dropzone.UPLOADING || file.status === Dropzone.QUEUED) {
          _results.push(file);
        }
      }
      return _results;
    };

    Dropzone.prototype.init = function() {
      var eventName, noPropagation, setupHiddenFileInput, _i, _len, _ref, _ref1;
      if (this.element.tagName === "form") {
        this.element.setAttribute("enctype", "multipart/form-data");
      }
      if (this.element.classList.contains("dropzone") && !this.element.querySelector(".dz-message")) {
        this.element.appendChild(Dropzone.createElement("<div class=\"dz-default dz-message\"><span>" + this.options.dictDefaultMessage + "</span></div>"));
      }
      if (this.clickableElements.length) {
        setupHiddenFileInput = (function(_this) {
          return function() {
            if (_this.hiddenFileInput) {
              _this.hiddenFileInput.parentNode.removeChild(_this.hiddenFileInput);
            }
            _this.hiddenFileInput = document.createElement("input");
            _this.hiddenFileInput.setAttribute("type", "file");
            if ((_this.options.maxFiles == null) || _this.options.maxFiles > 1) {
              _this.hiddenFileInput.setAttribute("multiple", "multiple");
            }
            _this.hiddenFileInput.className = "dz-hidden-input";
            if (_this.options.acceptedFiles != null) {
              _this.hiddenFileInput.setAttribute("accept", _this.options.acceptedFiles);
            }
            if (_this.options.capture != null) {
              _this.hiddenFileInput.setAttribute("capture", _this.options.capture);
            }
            _this.hiddenFileInput.style.visibility = "hidden";
            _this.hiddenFileInput.style.position = "absolute";
            _this.hiddenFileInput.style.top = "0";
            _this.hiddenFileInput.style.left = "0";
            _this.hiddenFileInput.style.height = "0";
            _this.hiddenFileInput.style.width = "0";
            document.querySelector(_this.options.hiddenInputContainer).appendChild(_this.hiddenFileInput);
            return _this.hiddenFileInput.addEventListener("change", function() {
              var file, files, _i, _len;
              files = _this.hiddenFileInput.files;
              if (files.length) {
                for (_i = 0, _len = files.length; _i < _len; _i++) {
                  file = files[_i];
                  _this.addFile(file);
                }
              }
              _this.emit("addedfiles", files);
              return setupHiddenFileInput();
            });
          };
        })(this);
        setupHiddenFileInput();
      }
      this.URL = (_ref = window.URL) != null ? _ref : window.webkitURL;
      _ref1 = this.events;
      for (_i = 0, _len = _ref1.length; _i < _len; _i++) {
        eventName = _ref1[_i];
        this.on(eventName, this.options[eventName]);
      }
      this.on("uploadprogress", (function(_this) {
        return function() {
          return _this.updateTotalUploadProgress();
        };
      })(this));
      this.on("removedfile", (function(_this) {
        return function() {
          return _this.updateTotalUploadProgress();
        };
      })(this));
      this.on("canceled", (function(_this) {
        return function(file) {
          return _this.emit("complete", file);
        };
      })(this));
      this.on("complete", (function(_this) {
        return function(file) {
          if (_this.getAddedFiles().length === 0 && _this.getUploadingFiles().length === 0 && _this.getQueuedFiles().length === 0) {
            return setTimeout((function() {
              return _this.emit("queuecomplete");
            }), 0);
          }
        };
      })(this));
      noPropagation = function(e) {
        e.stopPropagation();
        if (e.preventDefault) {
          return e.preventDefault();
        } else {
          return e.returnValue = false;
        }
      };
      this.listeners = [
        {
          element: this.element,
          events: {
            "dragstart": (function(_this) {
              return function(e) {
                return _this.emit("dragstart", e);
              };
            })(this),
            "dragenter": (function(_this) {
              return function(e) {
                noPropagation(e);
                return _this.emit("dragenter", e);
              };
            })(this),
            "dragover": (function(_this) {
              return function(e) {
                var efct;
                try {
                  efct = e.dataTransfer.effectAllowed;
                } catch (_error) {}
                e.dataTransfer.dropEffect = 'move' === efct || 'linkMove' === efct ? 'move' : 'copy';
                noPropagation(e);
                return _this.emit("dragover", e);
              };
            })(this),
            "dragleave": (function(_this) {
              return function(e) {
                return _this.emit("dragleave", e);
              };
            })(this),
            "drop": (function(_this) {
              return function(e) {
                noPropagation(e);
                return _this.drop(e);
              };
            })(this),
            "dragend": (function(_this) {
              return function(e) {
                return _this.emit("dragend", e);
              };
            })(this)
          }
        }
      ];
      this.clickableElements.forEach((function(_this) {
        return function(clickableElement) {
          return _this.listeners.push({
            element: clickableElement,
            events: {
              "click": function(evt) {
                if ((clickableElement !== _this.element) || (evt.target === _this.element || Dropzone.elementInside(evt.target, _this.element.querySelector(".dz-message")))) {
                  _this.hiddenFileInput.click();
                }
                return true;
              }
            }
          });
        };
      })(this));
      this.enable();
      return this.options.init.call(this);
    };

    Dropzone.prototype.destroy = function() {
      var _ref;
      this.disable();
      this.removeAllFiles(true);
      if ((_ref = this.hiddenFileInput) != null ? _ref.parentNode : void 0) {
        this.hiddenFileInput.parentNode.removeChild(this.hiddenFileInput);
        this.hiddenFileInput = null;
      }
      delete this.element.dropzone;
      return Dropzone.instances.splice(Dropzone.instances.indexOf(this), 1);
    };

    Dropzone.prototype.updateTotalUploadProgress = function() {
      var activeFiles, file, totalBytes, totalBytesSent, totalUploadProgress, _i, _len, _ref;
      totalBytesSent = 0;
      totalBytes = 0;
      activeFiles = this.getActiveFiles();
      if (activeFiles.length) {
        _ref = this.getActiveFiles();
        for (_i = 0, _len = _ref.length; _i < _len; _i++) {
          file = _ref[_i];
          totalBytesSent += file.upload.bytesSent;
          totalBytes += file.upload.total;
        }
        totalUploadProgress = 100 * totalBytesSent / totalBytes;
      } else {
        totalUploadProgress = 100;
      }
      return this.emit("totaluploadprogress", totalUploadProgress, totalBytes, totalBytesSent);
    };

    Dropzone.prototype._getParamName = function(n) {
      if (typeof this.options.paramName === "function") {
        return this.options.paramName(n);
      } else {
        return "" + this.options.paramName + (this.options.uploadMultiple ? "[" + n + "]" : "");
      }
    };

    Dropzone.prototype._renameFilename = function(name) {
      if (typeof this.options.renameFilename !== "function") {
        return name;
      }
      return this.options.renameFilename(name);
    };

    Dropzone.prototype.getFallbackForm = function() {
      var existingFallback, fields, fieldsString, form;
      if (existingFallback = this.getExistingFallback()) {
        return existingFallback;
      }
      fieldsString = "<div class=\"dz-fallback\">";
      if (this.options.dictFallbackText) {
        fieldsString += "<p>" + this.options.dictFallbackText + "</p>";
      }
      fieldsString += "<input type=\"file\" name=\"" + (this._getParamName(0)) + "\" " + (this.options.uploadMultiple ? 'multiple="multiple"' : void 0) + " /><input type=\"submit\" value=\"Upload!\"></div>";
      fields = Dropzone.createElement(fieldsString);
      if (this.element.tagName !== "FORM") {
        form = Dropzone.createElement("<form action=\"" + this.options.url + "\" enctype=\"multipart/form-data\" method=\"" + this.options.method + "\"></form>");
        form.appendChild(fields);
      } else {
        this.element.setAttribute("enctype", "multipart/form-data");
        this.element.setAttribute("method", this.options.method);
      }
      return form != null ? form : fields;
    };

    Dropzone.prototype.getExistingFallback = function() {
      var fallback, getFallback, tagName, _i, _len, _ref;
      getFallback = function(elements) {
        var el, _i, _len;
        for (_i = 0, _len = elements.length; _i < _len; _i++) {
          el = elements[_i];
          if (/(^| )fallback($| )/.test(el.className)) {
            return el;
          }
        }
      };
      _ref = ["div", "form"];
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        tagName = _ref[_i];
        if (fallback = getFallback(this.element.getElementsByTagName(tagName))) {
          return fallback;
        }
      }
    };

    Dropzone.prototype.setupEventListeners = function() {
      var elementListeners, event, listener, _i, _len, _ref, _results;
      _ref = this.listeners;
      _results = [];
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        elementListeners = _ref[_i];
        _results.push((function() {
          var _ref1, _results1;
          _ref1 = elementListeners.events;
          _results1 = [];
          for (event in _ref1) {
            listener = _ref1[event];
            _results1.push(elementListeners.element.addEventListener(event, listener, false));
          }
          return _results1;
        })());
      }
      return _results;
    };

    Dropzone.prototype.removeEventListeners = function() {
      var elementListeners, event, listener, _i, _len, _ref, _results;
      _ref = this.listeners;
      _results = [];
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        elementListeners = _ref[_i];
        _results.push((function() {
          var _ref1, _results1;
          _ref1 = elementListeners.events;
          _results1 = [];
          for (event in _ref1) {
            listener = _ref1[event];
            _results1.push(elementListeners.element.removeEventListener(event, listener, false));
          }
          return _results1;
        })());
      }
      return _results;
    };

    Dropzone.prototype.disable = function() {
      var file, _i, _len, _ref, _results;
      this.clickableElements.forEach(function(element) {
        return element.classList.remove("dz-clickable");
      });
      this.removeEventListeners();
      _ref = this.files;
      _results = [];
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        file = _ref[_i];
        _results.push(this.cancelUpload(file));
      }
      return _results;
    };

    Dropzone.prototype.enable = function() {
      this.clickableElements.forEach(function(element) {
        return element.classList.add("dz-clickable");
      });
      return this.setupEventListeners();
    };

    Dropzone.prototype.filesize = function(size) {
      var cutoff, i, selectedSize, selectedUnit, unit, units, _i, _len;
      selectedSize = 0;
      selectedUnit = "b";
      if (size > 0) {
        units = ['TB', 'GB', 'MB', 'KB', 'b'];
        for (i = _i = 0, _len = units.length; _i < _len; i = ++_i) {
          unit = units[i];
          cutoff = Math.pow(this.options.filesizeBase, 4 - i) / 10;
          if (size >= cutoff) {
            selectedSize = size / Math.pow(this.options.filesizeBase, 4 - i);
            selectedUnit = unit;
            break;
          }
        }
        selectedSize = Math.round(10 * selectedSize) / 10;
      }
      return "<strong>" + selectedSize + "</strong> " + selectedUnit;
    };

    Dropzone.prototype._updateMaxFilesReachedClass = function() {
      if ((this.options.maxFiles != null) && this.getAcceptedFiles().length >= this.options.maxFiles) {
        if (this.getAcceptedFiles().length === this.options.maxFiles) {
          this.emit('maxfilesreached', this.files);
        }
        return this.element.classList.add("dz-max-files-reached");
      } else {
        return this.element.classList.remove("dz-max-files-reached");
      }
    };

    Dropzone.prototype.drop = function(e) {
      var files, items;
      if (!e.dataTransfer) {
        return;
      }
      this.emit("drop", e);
      files = e.dataTransfer.files;
      this.emit("addedfiles", files);
      if (files.length) {
        items = e.dataTransfer.items;
        if (items && items.length && (items[0].webkitGetAsEntry != null)) {
          this._addFilesFromItems(items);
        } else {
          this.handleFiles(files);
        }
      }
    };

    Dropzone.prototype.paste = function(e) {
      var items, _ref;
      if ((e != null ? (_ref = e.clipboardData) != null ? _ref.items : void 0 : void 0) == null) {
        return;
      }
      this.emit("paste", e);
      items = e.clipboardData.items;
      if (items.length) {
        return this._addFilesFromItems(items);
      }
    };

    Dropzone.prototype.handleFiles = function(files) {
      var file, _i, _len, _results;
      _results = [];
      for (_i = 0, _len = files.length; _i < _len; _i++) {
        file = files[_i];
        _results.push(this.addFile(file));
      }
      return _results;
    };

    Dropzone.prototype._addFilesFromItems = function(items) {
      var entry, item, _i, _len, _results;
      _results = [];
      for (_i = 0, _len = items.length; _i < _len; _i++) {
        item = items[_i];
        if ((item.webkitGetAsEntry != null) && (entry = item.webkitGetAsEntry())) {
          if (entry.isFile) {
            _results.push(this.addFile(item.getAsFile()));
          } else if (entry.isDirectory) {
            _results.push(this._addFilesFromDirectory(entry, entry.name));
          } else {
            _results.push(void 0);
          }
        } else if (item.getAsFile != null) {
          if ((item.kind == null) || item.kind === "file") {
            _results.push(this.addFile(item.getAsFile()));
          } else {
            _results.push(void 0);
          }
        } else {
          _results.push(void 0);
        }
      }
      return _results;
    };

    Dropzone.prototype._addFilesFromDirectory = function(directory, path) {
      var dirReader, errorHandler, readEntries;
      dirReader = directory.createReader();
      errorHandler = function(error) {
        return typeof console !== "undefined" && console !== null ? typeof console.log === "function" ? console.log(error) : void 0 : void 0;
      };
      readEntries = (function(_this) {
        return function() {
          return dirReader.readEntries(function(entries) {
            var entry, _i, _len;
            if (entries.length > 0) {
              for (_i = 0, _len = entries.length; _i < _len; _i++) {
                entry = entries[_i];
                if (entry.isFile) {
                  entry.file(function(file) {
                    if (_this.options.ignoreHiddenFiles && file.name.substring(0, 1) === '.') {
                      return;
                    }
                    file.fullPath = "" + path + "/" + file.name;
                    return _this.addFile(file);
                  });
                } else if (entry.isDirectory) {
                  _this._addFilesFromDirectory(entry, "" + path + "/" + entry.name);
                }
              }
              readEntries();
            }
            return null;
          }, errorHandler);
        };
      })(this);
      return readEntries();
    };

    Dropzone.prototype.accept = function(file, done) {
      if (file.size > this.options.maxFilesize * 1024 * 1024) {
        return done(this.options.dictFileTooBig.replace("{{filesize}}", Math.round(file.size / 1024 / 10.24) / 100).replace("{{maxFilesize}}", this.options.maxFilesize));
      } else if (!Dropzone.isValidFile(file, this.options.acceptedFiles)) {
        return done(this.options.dictInvalidFileType);
      } else if ((this.options.maxFiles != null) && this.getAcceptedFiles().length >= this.options.maxFiles) {
        done(this.options.dictMaxFilesExceeded.replace("{{maxFiles}}", this.options.maxFiles));
        return this.emit("maxfilesexceeded", file);
      } else {
        return this.options.accept.call(this, file, done);
      }
    };

    Dropzone.prototype.addFile = function(file) {
      file.upload = {
        progress: 0,
        total: file.size,
        bytesSent: 0
      };
      this.files.push(file);
      file.status = Dropzone.ADDED;
      this.emit("addedfile", file);
      this._enqueueThumbnail(file);
      return this.accept(file, (function(_this) {
        return function(error) {
          if (error) {
            file.accepted = false;
            _this._errorProcessing([file], error);
          } else {
            file.accepted = true;
            if (_this.options.autoQueue) {
              _this.enqueueFile(file);
            }
          }
          return _this._updateMaxFilesReachedClass();
        };
      })(this));
    };

    Dropzone.prototype.enqueueFiles = function(files) {
      var file, _i, _len;
      for (_i = 0, _len = files.length; _i < _len; _i++) {
        file = files[_i];
        this.enqueueFile(file);
      }
      return null;
    };

    Dropzone.prototype.enqueueFile = function(file) {
      if (file.status === Dropzone.ADDED && file.accepted === true) {
        file.status = Dropzone.QUEUED;
        if (this.options.autoProcessQueue) {
          return setTimeout(((function(_this) {
            return function() {
              return _this.processQueue();
            };
          })(this)), 0);
        }
      } else {
        throw new Error("This file can't be queued because it has already been processed or was rejected.");
      }
    };

    Dropzone.prototype._thumbnailQueue = [];

    Dropzone.prototype._processingThumbnail = false;

    Dropzone.prototype._enqueueThumbnail = function(file) {
      if (this.options.createImageThumbnails && file.type.match(/image.*/) && file.size <= this.options.maxThumbnailFilesize * 1024 * 1024) {
        this._thumbnailQueue.push(file);
        return setTimeout(((function(_this) {
          return function() {
            return _this._processThumbnailQueue();
          };
        })(this)), 0);
      }
    };

    Dropzone.prototype._processThumbnailQueue = function() {
      if (this._processingThumbnail || this._thumbnailQueue.length === 0) {
        return;
      }
      this._processingThumbnail = true;
      return this.createThumbnail(this._thumbnailQueue.shift(), (function(_this) {
        return function() {
          _this._processingThumbnail = false;
          return _this._processThumbnailQueue();
        };
      })(this));
    };

    Dropzone.prototype.removeFile = function(file) {
      if (file.status === Dropzone.UPLOADING) {
        this.cancelUpload(file);
      }
      this.files = without(this.files, file);
      this.emit("removedfile", file);
      if (this.files.length === 0) {
        return this.emit("reset");
      }
    };

    Dropzone.prototype.removeAllFiles = function(cancelIfNecessary) {
      var file, _i, _len, _ref;
      if (cancelIfNecessary == null) {
        cancelIfNecessary = false;
      }
      _ref = this.files.slice();
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        file = _ref[_i];
        if (file.status !== Dropzone.UPLOADING || cancelIfNecessary) {
          this.removeFile(file);
        }
      }
      return null;
    };

    Dropzone.prototype.createThumbnail = function(file, callback) {
      var fileReader;
      fileReader = new FileReader;
      fileReader.onload = (function(_this) {
        return function() {
          if (file.type === "image/svg+xml") {
            _this.emit("thumbnail", file, fileReader.result);
            if (callback != null) {
              callback();
            }
            return;
          }
          return _this.createThumbnailFromUrl(file, fileReader.result, callback);
        };
      })(this);
      return fileReader.readAsDataURL(file);
    };

    Dropzone.prototype.createThumbnailFromUrl = function(file, imageUrl, callback, crossOrigin) {
      var img;
      img = document.createElement("img");
      if (crossOrigin) {
        img.crossOrigin = crossOrigin;
      }
      img.onload = (function(_this) {
        return function() {
          var canvas, ctx, resizeInfo, thumbnail, _ref, _ref1, _ref2, _ref3;
          file.width = img.width;
          file.height = img.height;
          resizeInfo = _this.options.resize.call(_this, file);
          if (resizeInfo.trgWidth == null) {
            resizeInfo.trgWidth = resizeInfo.optWidth;
          }
          if (resizeInfo.trgHeight == null) {
            resizeInfo.trgHeight = resizeInfo.optHeight;
          }
          canvas = document.createElement("canvas");
          ctx = canvas.getContext("2d");
          canvas.width = resizeInfo.trgWidth;
          canvas.height = resizeInfo.trgHeight;
          drawImageIOSFix(ctx, img, (_ref = resizeInfo.srcX) != null ? _ref : 0, (_ref1 = resizeInfo.srcY) != null ? _ref1 : 0, resizeInfo.srcWidth, resizeInfo.srcHeight, (_ref2 = resizeInfo.trgX) != null ? _ref2 : 0, (_ref3 = resizeInfo.trgY) != null ? _ref3 : 0, resizeInfo.trgWidth, resizeInfo.trgHeight);
          thumbnail = canvas.toDataURL("image/png");
          _this.emit("thumbnail", file, thumbnail);
          if (callback != null) {
            return callback();
          }
        };
      })(this);
      if (callback != null) {
        img.onerror = callback;
      }
      return img.src = imageUrl;
    };

    Dropzone.prototype.processQueue = function() {
      var i, parallelUploads, processingLength, queuedFiles;
      parallelUploads = this.options.parallelUploads;
      processingLength = this.getUploadingFiles().length;
      i = processingLength;
      if (processingLength >= parallelUploads) {
        return;
      }
      queuedFiles = this.getQueuedFiles();
      if (!(queuedFiles.length > 0)) {
        return;
      }
      if (this.options.uploadMultiple) {
        return this.processFiles(queuedFiles.slice(0, parallelUploads - processingLength));
      } else {
        while (i < parallelUploads) {
          if (!queuedFiles.length) {
            return;
          }
          this.processFile(queuedFiles.shift());
          i++;
        }
      }
    };

    Dropzone.prototype.processFile = function(file) {
      return this.processFiles([file]);
    };

    Dropzone.prototype.processFiles = function(files) {
      var file, _i, _len;
      for (_i = 0, _len = files.length; _i < _len; _i++) {
        file = files[_i];
        file.processing = true;
        file.status = Dropzone.UPLOADING;
        this.emit("processing", file);
      }
      if (this.options.uploadMultiple) {
        this.emit("processingmultiple", files);
      }
      return this.uploadFiles(files);
    };

    Dropzone.prototype._getFilesWithXhr = function(xhr) {
      var file, files;
      return files = (function() {
        var _i, _len, _ref, _results;
        _ref = this.files;
        _results = [];
        for (_i = 0, _len = _ref.length; _i < _len; _i++) {
          file = _ref[_i];
          if (file.xhr === xhr) {
            _results.push(file);
          }
        }
        return _results;
      }).call(this);
    };

    Dropzone.prototype.cancelUpload = function(file) {
      var groupedFile, groupedFiles, _i, _j, _len, _len1, _ref;
      if (file.status === Dropzone.UPLOADING) {
        groupedFiles = this._getFilesWithXhr(file.xhr);
        for (_i = 0, _len = groupedFiles.length; _i < _len; _i++) {
          groupedFile = groupedFiles[_i];
          groupedFile.status = Dropzone.CANCELED;
        }
        file.xhr.abort();
        for (_j = 0, _len1 = groupedFiles.length; _j < _len1; _j++) {
          groupedFile = groupedFiles[_j];
          this.emit("canceled", groupedFile);
        }
        if (this.options.uploadMultiple) {
          this.emit("canceledmultiple", groupedFiles);
        }
      } else if ((_ref = file.status) === Dropzone.ADDED || _ref === Dropzone.QUEUED) {
        file.status = Dropzone.CANCELED;
        this.emit("canceled", file);
        if (this.options.uploadMultiple) {
          this.emit("canceledmultiple", [file]);
        }
      }
      if (this.options.autoProcessQueue) {
        return this.processQueue();
      }
    };

    resolveOption = function() {
      var args, option;
      option = arguments[0], args = 2 <= arguments.length ? __slice.call(arguments, 1) : [];
      if (typeof option === 'function') {
        return option.apply(this, args);
      }
      return option;
    };

    Dropzone.prototype.uploadFile = function(file) {
      return this.uploadFiles([file]);
    };

    Dropzone.prototype.uploadFiles = function(files) {
      var file, formData, handleError, headerName, headerValue, headers, i, input, inputName, inputType, key, method, option, progressObj, response, updateProgress, url, value, xhr, _i, _j, _k, _l, _len, _len1, _len2, _len3, _m, _ref, _ref1, _ref2, _ref3, _ref4, _ref5;
      xhr = new XMLHttpRequest();
      for (_i = 0, _len = files.length; _i < _len; _i++) {
        file = files[_i];
        file.xhr = xhr;
      }
      method = resolveOption(this.options.method, files);
      url = resolveOption(this.options.url, files);
      xhr.open(method, url, true);
      xhr.withCredentials = !!this.options.withCredentials;
      response = null;
      handleError = (function(_this) {
        return function() {
          var _j, _len1, _results;
          _results = [];
          for (_j = 0, _len1 = files.length; _j < _len1; _j++) {
            file = files[_j];
            _results.push(_this._errorProcessing(files, response || _this.options.dictResponseError.replace("{{statusCode}}", xhr.status), xhr));
          }
          return _results;
        };
      })(this);
      updateProgress = (function(_this) {
        return function(e) {
          var allFilesFinished, progress, _j, _k, _l, _len1, _len2, _len3, _results;
          if (e != null) {
            progress = 100 * e.loaded / e.total;
            for (_j = 0, _len1 = files.length; _j < _len1; _j++) {
              file = files[_j];
              file.upload = {
                progress: progress,
                total: e.total,
                bytesSent: e.loaded
              };
            }
          } else {
            allFilesFinished = true;
            progress = 100;
            for (_k = 0, _len2 = files.length; _k < _len2; _k++) {
              file = files[_k];
              if (!(file.upload.progress === 100 && file.upload.bytesSent === file.upload.total)) {
                allFilesFinished = false;
              }
              file.upload.progress = progress;
              file.upload.bytesSent = file.upload.total;
            }
            if (allFilesFinished) {
              return;
            }
          }
          _results = [];
          for (_l = 0, _len3 = files.length; _l < _len3; _l++) {
            file = files[_l];
            _results.push(_this.emit("uploadprogress", file, progress, file.upload.bytesSent));
          }
          return _results;
        };
      })(this);
      xhr.onload = (function(_this) {
        return function(e) {
          var _ref;
          if (files[0].status === Dropzone.CANCELED) {
            return;
          }
          if (xhr.readyState !== 4) {
            return;
          }
          response = xhr.responseText;
          if (xhr.getResponseHeader("content-type") && ~xhr.getResponseHeader("content-type").indexOf("application/json")) {
            try {
              response = JSON.parse(response);
            } catch (_error) {
              e = _error;
              response = "Invalid JSON response from server.";
            }
          }
          updateProgress();
          if (!((200 <= (_ref = xhr.status) && _ref < 300))) {
            return handleError();
          } else {
            return _this._finished(files, response, e);
          }
        };
      })(this);
      xhr.onerror = (function(_this) {
        return function() {
          if (files[0].status === Dropzone.CANCELED) {
            return;
          }
          return handleError();
        };
      })(this);
      progressObj = (_ref = xhr.upload) != null ? _ref : xhr;
      progressObj.onprogress = updateProgress;
      headers = {
        "Accept": "application/json",
        "Cache-Control": "no-cache",
        "X-Requested-With": "XMLHttpRequest"
      };
      if (this.options.headers) {
        extend(headers, this.options.headers);
      }
      for (headerName in headers) {
        headerValue = headers[headerName];
        if (headerValue) {
          xhr.setRequestHeader(headerName, headerValue);
        }
      }
      formData = new FormData();
      if (this.options.params) {
        _ref1 = this.options.params;
        for (key in _ref1) {
          value = _ref1[key];
          formData.append(key, value);
        }
      }
      for (_j = 0, _len1 = files.length; _j < _len1; _j++) {
        file = files[_j];
        this.emit("sending", file, xhr, formData);
      }
      if (this.options.uploadMultiple) {
        this.emit("sendingmultiple", files, xhr, formData);
      }
      if (this.element.tagName === "FORM") {
        _ref2 = this.element.querySelectorAll("input, textarea, select, button");
        for (_k = 0, _len2 = _ref2.length; _k < _len2; _k++) {
          input = _ref2[_k];
          inputName = input.getAttribute("name");
          inputType = input.getAttribute("type");
          if (input.tagName === "SELECT" && input.hasAttribute("multiple")) {
            _ref3 = input.options;
            for (_l = 0, _len3 = _ref3.length; _l < _len3; _l++) {
              option = _ref3[_l];
              if (option.selected) {
                formData.append(inputName, option.value);
              }
            }
          } else if (!inputType || ((_ref4 = inputType.toLowerCase()) !== "checkbox" && _ref4 !== "radio") || input.checked) {
            formData.append(inputName, input.value);
          }
        }
      }
      for (i = _m = 0, _ref5 = files.length - 1; 0 <= _ref5 ? _m <= _ref5 : _m >= _ref5; i = 0 <= _ref5 ? ++_m : --_m) {
        formData.append(this._getParamName(i), files[i], this._renameFilename(files[i].name));
      }
      return this.submitRequest(xhr, formData, files);
    };

    Dropzone.prototype.submitRequest = function(xhr, formData, files) {
      return xhr.send(formData);
    };

    Dropzone.prototype._finished = function(files, responseText, e) {
      var file, _i, _len;
      for (_i = 0, _len = files.length; _i < _len; _i++) {
        file = files[_i];
        file.status = Dropzone.SUCCESS;
        this.emit("success", file, responseText, e);
        this.emit("complete", file);
      }
      if (this.options.uploadMultiple) {
        this.emit("successmultiple", files, responseText, e);
        this.emit("completemultiple", files);
      }
      if (this.options.autoProcessQueue) {
        return this.processQueue();
      }
    };

    Dropzone.prototype._errorProcessing = function(files, message, xhr) {
      var file, _i, _len;
      for (_i = 0, _len = files.length; _i < _len; _i++) {
        file = files[_i];
        file.status = Dropzone.ERROR;
        this.emit("error", file, message, xhr);
        this.emit("complete", file);
      }
      if (this.options.uploadMultiple) {
        this.emit("errormultiple", files, message, xhr);
        this.emit("completemultiple", files);
      }
      if (this.options.autoProcessQueue) {
        return this.processQueue();
      }
    };

    return Dropzone;

  })(Emitter);

  Dropzone.version = "4.3.0";

  Dropzone.options = {};

  Dropzone.optionsForElement = function(element) {
    if (element.getAttribute("id")) {
      return Dropzone.options[camelize(element.getAttribute("id"))];
    } else {
      return void 0;
    }
  };

  Dropzone.instances = [];

  Dropzone.forElement = function(element) {
    if (typeof element === "string") {
      element = document.querySelector(element);
    }
    if ((element != null ? element.dropzone : void 0) == null) {
      throw new Error("No Dropzone found for given element. This is probably because you're trying to access it before Dropzone had the time to initialize. Use the `init` option to setup any additional observers on your Dropzone.");
    }
    return element.dropzone;
  };

  Dropzone.autoDiscover = true;

  Dropzone.discover = function() {
    var checkElements, dropzone, dropzones, _i, _len, _results;
    if (document.querySelectorAll) {
      dropzones = document.querySelectorAll(".dropzone");
    } else {
      dropzones = [];
      checkElements = function(elements) {
        var el, _i, _len, _results;
        _results = [];
        for (_i = 0, _len = elements.length; _i < _len; _i++) {
          el = elements[_i];
          if (/(^| )dropzone($| )/.test(el.className)) {
            _results.push(dropzones.push(el));
          } else {
            _results.push(void 0);
          }
        }
        return _results;
      };
      checkElements(document.getElementsByTagName("div"));
      checkElements(document.getElementsByTagName("form"));
    }
    _results = [];
    for (_i = 0, _len = dropzones.length; _i < _len; _i++) {
      dropzone = dropzones[_i];
      if (Dropzone.optionsForElement(dropzone) !== false) {
        _results.push(new Dropzone(dropzone));
      } else {
        _results.push(void 0);
      }
    }
    return _results;
  };

  Dropzone.blacklistedBrowsers = [/opera.*Macintosh.*version\/12/i];

  Dropzone.isBrowserSupported = function() {
    var capableBrowser, regex, _i, _len, _ref;
    capableBrowser = true;
    if (window.File && window.FileReader && window.FileList && window.Blob && window.FormData && document.querySelector) {
      if (!("classList" in document.createElement("a"))) {
        capableBrowser = false;
      } else {
        _ref = Dropzone.blacklistedBrowsers;
        for (_i = 0, _len = _ref.length; _i < _len; _i++) {
          regex = _ref[_i];
          if (regex.test(navigator.userAgent)) {
            capableBrowser = false;
            continue;
          }
        }
      }
    } else {
      capableBrowser = false;
    }
    return capableBrowser;
  };

  without = function(list, rejectedItem) {
    var item, _i, _len, _results;
    _results = [];
    for (_i = 0, _len = list.length; _i < _len; _i++) {
      item = list[_i];
      if (item !== rejectedItem) {
        _results.push(item);
      }
    }
    return _results;
  };

  camelize = function(str) {
    return str.replace(/[\-_](\w)/g, function(match) {
      return match.charAt(1).toUpperCase();
    });
  };

  Dropzone.createElement = function(string) {
    var div;
    div = document.createElement("div");
    div.innerHTML = string;
    return div.childNodes[0];
  };

  Dropzone.elementInside = function(element, container) {
    if (element === container) {
      return true;
    }
    while (element = element.parentNode) {
      if (element === container) {
        return true;
      }
    }
    return false;
  };

  Dropzone.getElement = function(el, name) {
    var element;
    if (typeof el === "string") {
      element = document.querySelector(el);
    } else if (el.nodeType != null) {
      element = el;
    }
    if (element == null) {
      throw new Error("Invalid `" + name + "` option provided. Please provide a CSS selector or a plain HTML element.");
    }
    return element;
  };

  Dropzone.getElements = function(els, name) {
    var e, el, elements, _i, _j, _len, _len1, _ref;
    if (els instanceof Array) {
      elements = [];
      try {
        for (_i = 0, _len = els.length; _i < _len; _i++) {
          el = els[_i];
          elements.push(this.getElement(el, name));
        }
      } catch (_error) {
        e = _error;
        elements = null;
      }
    } else if (typeof els === "string") {
      elements = [];
      _ref = document.querySelectorAll(els);
      for (_j = 0, _len1 = _ref.length; _j < _len1; _j++) {
        el = _ref[_j];
        elements.push(el);
      }
    } else if (els.nodeType != null) {
      elements = [els];
    }
    if (!((elements != null) && elements.length)) {
      throw new Error("Invalid `" + name + "` option provided. Please provide a CSS selector, a plain HTML element or a list of those.");
    }
    return elements;
  };

  Dropzone.confirm = function(question, accepted, rejected) {
    if (window.confirm(question)) {
      return accepted();
    } else if (rejected != null) {
      return rejected();
    }
  };

  Dropzone.isValidFile = function(file, acceptedFiles) {
    var baseMimeType, mimeType, validType, _i, _len;
    if (!acceptedFiles) {
      return true;
    }
    acceptedFiles = acceptedFiles.split(",");
    mimeType = file.type;
    baseMimeType = mimeType.replace(/\/.*$/, "");
    for (_i = 0, _len = acceptedFiles.length; _i < _len; _i++) {
      validType = acceptedFiles[_i];
      validType = validType.trim();
      if (validType.charAt(0) === ".") {
        if (file.name.toLowerCase().indexOf(validType.toLowerCase(), file.name.length - validType.length) !== -1) {
          return true;
        }
      } else if (/\/\*$/.test(validType)) {
        if (baseMimeType === validType.replace(/\/.*$/, "")) {
          return true;
        }
      } else {
        if (mimeType === validType) {
          return true;
        }
      }
    }
    return false;
  };

  if (typeof jQuery !== "undefined" && jQuery !== null) {
    jQuery.fn.dropzone = function(options) {
      return this.each(function() {
        return new Dropzone(this, options);
      });
    };
  }

  if (typeof module !== "undefined" && module !== null) {
    module.exports = Dropzone;
  } else {
    window.Dropzone = Dropzone;
  }

  Dropzone.ADDED = "added";

  Dropzone.QUEUED = "queued";

  Dropzone.ACCEPTED = Dropzone.QUEUED;

  Dropzone.UPLOADING = "uploading";

  Dropzone.PROCESSING = Dropzone.UPLOADING;

  Dropzone.CANCELED = "canceled";

  Dropzone.ERROR = "error";

  Dropzone.SUCCESS = "success";


  /*
  
  Bugfix for iOS 6 and 7
  Source: http://stackoverflow.com/questions/11929099/html5-canvas-drawimage-ratio-bug-ios
  based on the work of https://github.com/stomita/ios-imagefile-megapixel
   */

  detectVerticalSquash = function(img) {
    var alpha, canvas, ctx, data, ey, ih, iw, py, ratio, sy;
    iw = img.naturalWidth;
    ih = img.naturalHeight;
    canvas = document.createElement("canvas");
    canvas.width = 1;
    canvas.height = ih;
    ctx = canvas.getContext("2d");
    ctx.drawImage(img, 0, 0);
    data = ctx.getImageData(0, 0, 1, ih).data;
    sy = 0;
    ey = ih;
    py = ih;
    while (py > sy) {
      alpha = data[(py - 1) * 4 + 3];
      if (alpha === 0) {
        ey = py;
      } else {
        sy = py;
      }
      py = (ey + sy) >> 1;
    }
    ratio = py / ih;
    if (ratio === 0) {
      return 1;
    } else {
      return ratio;
    }
  };

  drawImageIOSFix = function(ctx, img, sx, sy, sw, sh, dx, dy, dw, dh) {
    var vertSquashRatio;
    vertSquashRatio = detectVerticalSquash(img);
    return ctx.drawImage(img, sx, sy, sw, sh, dx, dy, dw, dh / vertSquashRatio);
  };


  /*
   * contentloaded.js
   *
   * Author: Diego Perini (diego.perini at gmail.com)
   * Summary: cross-browser wrapper for DOMContentLoaded
   * Updated: 20101020
   * License: MIT
   * Version: 1.2
   *
   * URL:
   * http://javascript.nwbox.com/ContentLoaded/
   * http://javascript.nwbox.com/ContentLoaded/MIT-LICENSE
   */

  contentLoaded = function(win, fn) {
    var add, doc, done, init, poll, pre, rem, root, top;
    done = false;
    top = true;
    doc = win.document;
    root = doc.documentElement;
    add = (doc.addEventListener ? "addEventListener" : "attachEvent");
    rem = (doc.addEventListener ? "removeEventListener" : "detachEvent");
    pre = (doc.addEventListener ? "" : "on");
    init = function(e) {
      if (e.type === "readystatechange" && doc.readyState !== "complete") {
        return;
      }
      (e.type === "load" ? win : doc)[rem](pre + e.type, init, false);
      if (!done && (done = true)) {
        return fn.call(win, e.type || e);
      }
    };
    poll = function() {
      var e;
      try {
        root.doScroll("left");
      } catch (_error) {
        e = _error;
        setTimeout(poll, 50);
        return;
      }
      return init("poll");
    };
    if (doc.readyState !== "complete") {
      if (doc.createEventObject && root.doScroll) {
        try {
          top = !win.frameElement;
        } catch (_error) {}
        if (top) {
          poll();
        }
      }
      doc[add](pre + "DOMContentLoaded", init, false);
      doc[add](pre + "readystatechange", init, false);
      return win[add](pre + "load", init, false);
    }
  };

  Dropzone._autoDiscoverFunction = function() {
    if (Dropzone.autoDiscover) {
      return Dropzone.discover();
    }
  };

  contentLoaded(window, Dropzone._autoDiscoverFunction);

}).call(this);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(440)(module)))

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * URI.js - Mutating URLs
 *
 * Version: 1.19.1
 *
 * Author: Rodney Rehm
 * Web: http://medialize.github.io/URI.js/
 *
 * Licensed under
 *   MIT License http://www.opensource.org/licenses/mit-license
 *
 */
(function (root, factory) {
  'use strict';
  // https://github.com/umdjs/umd/blob/master/returnExports.js
  if (typeof module === 'object' && module.exports) {
    // Node
    module.exports = factory(__webpack_require__(640), __webpack_require__(641), __webpack_require__(642));
  } else if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(640), __webpack_require__(641), __webpack_require__(642)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {
    // Browser globals (root is window)
    root.URI = factory(root.punycode, root.IPv6, root.SecondLevelDomains, root);
  }
}(this, function (punycode, IPv6, SLD, root) {
  'use strict';
  /*global location, escape, unescape */
  // FIXME: v2.0.0 renamce non-camelCase properties to uppercase
  /*jshint camelcase: false */

  // save current URI variable, if any
  var _URI = root && root.URI;

  function URI(url, base) {
    var _urlSupplied = arguments.length >= 1;
    var _baseSupplied = arguments.length >= 2;

    // Allow instantiation without the 'new' keyword
    if (!(this instanceof URI)) {
      if (_urlSupplied) {
        if (_baseSupplied) {
          return new URI(url, base);
        }

        return new URI(url);
      }

      return new URI();
    }

    if (url === undefined) {
      if (_urlSupplied) {
        throw new TypeError('undefined is not a valid argument for URI');
      }

      if (typeof location !== 'undefined') {
        url = location.href + '';
      } else {
        url = '';
      }
    }

    if (url === null) {
      if (_urlSupplied) {
        throw new TypeError('null is not a valid argument for URI');
      }
    }

    this.href(url);

    // resolve to base according to http://dvcs.w3.org/hg/url/raw-file/tip/Overview.html#constructor
    if (base !== undefined) {
      return this.absoluteTo(base);
    }

    return this;
  }

  function isInteger(value) {
    return /^[0-9]+$/.test(value);
  }

  URI.version = '1.19.1';

  var p = URI.prototype;
  var hasOwn = Object.prototype.hasOwnProperty;

  function escapeRegEx(string) {
    // https://github.com/medialize/URI.js/commit/85ac21783c11f8ccab06106dba9735a31a86924d#commitcomment-821963
    return string.replace(/([.*+?^=!:${}()|[\]\/\\])/g, '\\$1');
  }

  function getType(value) {
    // IE8 doesn't return [Object Undefined] but [Object Object] for undefined value
    if (value === undefined) {
      return 'Undefined';
    }

    return String(Object.prototype.toString.call(value)).slice(8, -1);
  }

  function isArray(obj) {
    return getType(obj) === 'Array';
  }

  function filterArrayValues(data, value) {
    var lookup = {};
    var i, length;

    if (getType(value) === 'RegExp') {
      lookup = null;
    } else if (isArray(value)) {
      for (i = 0, length = value.length; i < length; i++) {
        lookup[value[i]] = true;
      }
    } else {
      lookup[value] = true;
    }

    for (i = 0, length = data.length; i < length; i++) {
      /*jshint laxbreak: true */
      var _match = lookup && lookup[data[i]] !== undefined
        || !lookup && value.test(data[i]);
      /*jshint laxbreak: false */
      if (_match) {
        data.splice(i, 1);
        length--;
        i--;
      }
    }

    return data;
  }

  function arrayContains(list, value) {
    var i, length;

    // value may be string, number, array, regexp
    if (isArray(value)) {
      // Note: this can be optimized to O(n) (instead of current O(m * n))
      for (i = 0, length = value.length; i < length; i++) {
        if (!arrayContains(list, value[i])) {
          return false;
        }
      }

      return true;
    }

    var _type = getType(value);
    for (i = 0, length = list.length; i < length; i++) {
      if (_type === 'RegExp') {
        if (typeof list[i] === 'string' && list[i].match(value)) {
          return true;
        }
      } else if (list[i] === value) {
        return true;
      }
    }

    return false;
  }

  function arraysEqual(one, two) {
    if (!isArray(one) || !isArray(two)) {
      return false;
    }

    // arrays can't be equal if they have different amount of content
    if (one.length !== two.length) {
      return false;
    }

    one.sort();
    two.sort();

    for (var i = 0, l = one.length; i < l; i++) {
      if (one[i] !== two[i]) {
        return false;
      }
    }

    return true;
  }

  function trimSlashes(text) {
    var trim_expression = /^\/+|\/+$/g;
    return text.replace(trim_expression, '');
  }

  URI._parts = function() {
    return {
      protocol: null,
      username: null,
      password: null,
      hostname: null,
      urn: null,
      port: null,
      path: null,
      query: null,
      fragment: null,
      // state
      preventInvalidHostname: URI.preventInvalidHostname,
      duplicateQueryParameters: URI.duplicateQueryParameters,
      escapeQuerySpace: URI.escapeQuerySpace
    };
  };
  // state: throw on invalid hostname
  // see https://github.com/medialize/URI.js/pull/345
  // and https://github.com/medialize/URI.js/issues/354
  URI.preventInvalidHostname = false;
  // state: allow duplicate query parameters (a=1&a=1)
  URI.duplicateQueryParameters = false;
  // state: replaces + with %20 (space in query strings)
  URI.escapeQuerySpace = true;
  // static properties
  URI.protocol_expression = /^[a-z][a-z0-9.+-]*$/i;
  URI.idn_expression = /[^a-z0-9\._-]/i;
  URI.punycode_expression = /(xn--)/i;
  // well, 333.444.555.666 matches, but it sure ain't no IPv4 - do we care?
  URI.ip4_expression = /^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/;
  // credits to Rich Brown
  // source: http://forums.intermapper.com/viewtopic.php?p=1096#1096
  // specification: http://www.ietf.org/rfc/rfc4291.txt
  URI.ip6_expression = /^\s*((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(%.+)?\s*$/;
  // expression used is "gruber revised" (@gruber v2) determined to be the
  // best solution in a regex-golf we did a couple of ages ago at
  // * http://mathiasbynens.be/demo/url-regex
  // * http://rodneyrehm.de/t/url-regex.html
  URI.find_uri_expression = /\b((?:[a-z][\w-]+:(?:\/{1,3}|[a-z0-9%])|www\d{0,3}[.]|[a-z0-9.\-]+[.][a-z]{2,4}\/)(?:[^\s()<>]+|\(([^\s()<>]+|(\([^\s()<>]+\)))*\))+(?:\(([^\s()<>]+|(\([^\s()<>]+\)))*\)|[^\s`!()\[\]{};:'".,<>?«»“”‘’]))/ig;
  URI.findUri = {
    // valid "scheme://" or "www."
    start: /\b(?:([a-z][a-z0-9.+-]*:\/\/)|www\.)/gi,
    // everything up to the next whitespace
    end: /[\s\r\n]|$/,
    // trim trailing punctuation captured by end RegExp
    trim: /[`!()\[\]{};:'".,<>?«»“”„‘’]+$/,
    // balanced parens inclusion (), [], {}, <>
    parens: /(\([^\)]*\)|\[[^\]]*\]|\{[^}]*\}|<[^>]*>)/g,
  };
  // http://www.iana.org/assignments/uri-schemes.html
  // http://en.wikipedia.org/wiki/List_of_TCP_and_UDP_port_numbers#Well-known_ports
  URI.defaultPorts = {
    http: '80',
    https: '443',
    ftp: '21',
    gopher: '70',
    ws: '80',
    wss: '443'
  };
  // list of protocols which always require a hostname
  URI.hostProtocols = [
    'http',
    'https'
  ];

  // allowed hostname characters according to RFC 3986
  // ALPHA DIGIT "-" "." "_" "~" "!" "$" "&" "'" "(" ")" "*" "+" "," ";" "=" %encoded
  // I've never seen a (non-IDN) hostname other than: ALPHA DIGIT . - _
  URI.invalid_hostname_characters = /[^a-zA-Z0-9\.\-:_]/;
  // map DOM Elements to their URI attribute
  URI.domAttributes = {
    'a': 'href',
    'blockquote': 'cite',
    'link': 'href',
    'base': 'href',
    'script': 'src',
    'form': 'action',
    'img': 'src',
    'area': 'href',
    'iframe': 'src',
    'embed': 'src',
    'source': 'src',
    'track': 'src',
    'input': 'src', // but only if type="image"
    'audio': 'src',
    'video': 'src'
  };
  URI.getDomAttribute = function(node) {
    if (!node || !node.nodeName) {
      return undefined;
    }

    var nodeName = node.nodeName.toLowerCase();
    // <input> should only expose src for type="image"
    if (nodeName === 'input' && node.type !== 'image') {
      return undefined;
    }

    return URI.domAttributes[nodeName];
  };

  function escapeForDumbFirefox36(value) {
    // https://github.com/medialize/URI.js/issues/91
    return escape(value);
  }

  // encoding / decoding according to RFC3986
  function strictEncodeURIComponent(string) {
    // see https://developer.mozilla.org/en-US/docs/JavaScript/Reference/Global_Objects/encodeURIComponent
    return encodeURIComponent(string)
      .replace(/[!'()*]/g, escapeForDumbFirefox36)
      .replace(/\*/g, '%2A');
  }
  URI.encode = strictEncodeURIComponent;
  URI.decode = decodeURIComponent;
  URI.iso8859 = function() {
    URI.encode = escape;
    URI.decode = unescape;
  };
  URI.unicode = function() {
    URI.encode = strictEncodeURIComponent;
    URI.decode = decodeURIComponent;
  };
  URI.characters = {
    pathname: {
      encode: {
        // RFC3986 2.1: For consistency, URI producers and normalizers should
        // use uppercase hexadecimal digits for all percent-encodings.
        expression: /%(24|26|2B|2C|3B|3D|3A|40)/ig,
        map: {
          // -._~!'()*
          '%24': '$',
          '%26': '&',
          '%2B': '+',
          '%2C': ',',
          '%3B': ';',
          '%3D': '=',
          '%3A': ':',
          '%40': '@'
        }
      },
      decode: {
        expression: /[\/\?#]/g,
        map: {
          '/': '%2F',
          '?': '%3F',
          '#': '%23'
        }
      }
    },
    reserved: {
      encode: {
        // RFC3986 2.1: For consistency, URI producers and normalizers should
        // use uppercase hexadecimal digits for all percent-encodings.
        expression: /%(21|23|24|26|27|28|29|2A|2B|2C|2F|3A|3B|3D|3F|40|5B|5D)/ig,
        map: {
          // gen-delims
          '%3A': ':',
          '%2F': '/',
          '%3F': '?',
          '%23': '#',
          '%5B': '[',
          '%5D': ']',
          '%40': '@',
          // sub-delims
          '%21': '!',
          '%24': '$',
          '%26': '&',
          '%27': '\'',
          '%28': '(',
          '%29': ')',
          '%2A': '*',
          '%2B': '+',
          '%2C': ',',
          '%3B': ';',
          '%3D': '='
        }
      }
    },
    urnpath: {
      // The characters under `encode` are the characters called out by RFC 2141 as being acceptable
      // for usage in a URN. RFC2141 also calls out "-", ".", and "_" as acceptable characters, but
      // these aren't encoded by encodeURIComponent, so we don't have to call them out here. Also
      // note that the colon character is not featured in the encoding map; this is because URI.js
      // gives the colons in URNs semantic meaning as the delimiters of path segements, and so it
      // should not appear unencoded in a segment itself.
      // See also the note above about RFC3986 and capitalalized hex digits.
      encode: {
        expression: /%(21|24|27|28|29|2A|2B|2C|3B|3D|40)/ig,
        map: {
          '%21': '!',
          '%24': '$',
          '%27': '\'',
          '%28': '(',
          '%29': ')',
          '%2A': '*',
          '%2B': '+',
          '%2C': ',',
          '%3B': ';',
          '%3D': '=',
          '%40': '@'
        }
      },
      // These characters are the characters called out by RFC2141 as "reserved" characters that
      // should never appear in a URN, plus the colon character (see note above).
      decode: {
        expression: /[\/\?#:]/g,
        map: {
          '/': '%2F',
          '?': '%3F',
          '#': '%23',
          ':': '%3A'
        }
      }
    }
  };
  URI.encodeQuery = function(string, escapeQuerySpace) {
    var escaped = URI.encode(string + '');
    if (escapeQuerySpace === undefined) {
      escapeQuerySpace = URI.escapeQuerySpace;
    }

    return escapeQuerySpace ? escaped.replace(/%20/g, '+') : escaped;
  };
  URI.decodeQuery = function(string, escapeQuerySpace) {
    string += '';
    if (escapeQuerySpace === undefined) {
      escapeQuerySpace = URI.escapeQuerySpace;
    }

    try {
      return URI.decode(escapeQuerySpace ? string.replace(/\+/g, '%20') : string);
    } catch(e) {
      // we're not going to mess with weird encodings,
      // give up and return the undecoded original string
      // see https://github.com/medialize/URI.js/issues/87
      // see https://github.com/medialize/URI.js/issues/92
      return string;
    }
  };
  // generate encode/decode path functions
  var _parts = {'encode':'encode', 'decode':'decode'};
  var _part;
  var generateAccessor = function(_group, _part) {
    return function(string) {
      try {
        return URI[_part](string + '').replace(URI.characters[_group][_part].expression, function(c) {
          return URI.characters[_group][_part].map[c];
        });
      } catch (e) {
        // we're not going to mess with weird encodings,
        // give up and return the undecoded original string
        // see https://github.com/medialize/URI.js/issues/87
        // see https://github.com/medialize/URI.js/issues/92
        return string;
      }
    };
  };

  for (_part in _parts) {
    URI[_part + 'PathSegment'] = generateAccessor('pathname', _parts[_part]);
    URI[_part + 'UrnPathSegment'] = generateAccessor('urnpath', _parts[_part]);
  }

  var generateSegmentedPathFunction = function(_sep, _codingFuncName, _innerCodingFuncName) {
    return function(string) {
      // Why pass in names of functions, rather than the function objects themselves? The
      // definitions of some functions (but in particular, URI.decode) will occasionally change due
      // to URI.js having ISO8859 and Unicode modes. Passing in the name and getting it will ensure
      // that the functions we use here are "fresh".
      var actualCodingFunc;
      if (!_innerCodingFuncName) {
        actualCodingFunc = URI[_codingFuncName];
      } else {
        actualCodingFunc = function(string) {
          return URI[_codingFuncName](URI[_innerCodingFuncName](string));
        };
      }

      var segments = (string + '').split(_sep);

      for (var i = 0, length = segments.length; i < length; i++) {
        segments[i] = actualCodingFunc(segments[i]);
      }

      return segments.join(_sep);
    };
  };

  // This takes place outside the above loop because we don't want, e.g., encodeUrnPath functions.
  URI.decodePath = generateSegmentedPathFunction('/', 'decodePathSegment');
  URI.decodeUrnPath = generateSegmentedPathFunction(':', 'decodeUrnPathSegment');
  URI.recodePath = generateSegmentedPathFunction('/', 'encodePathSegment', 'decode');
  URI.recodeUrnPath = generateSegmentedPathFunction(':', 'encodeUrnPathSegment', 'decode');

  URI.encodeReserved = generateAccessor('reserved', 'encode');

  URI.parse = function(string, parts) {
    var pos;
    if (!parts) {
      parts = {
        preventInvalidHostname: URI.preventInvalidHostname
      };
    }
    // [protocol"://"[username[":"password]"@"]hostname[":"port]"/"?][path]["?"querystring]["#"fragment]

    // extract fragment
    pos = string.indexOf('#');
    if (pos > -1) {
      // escaping?
      parts.fragment = string.substring(pos + 1) || null;
      string = string.substring(0, pos);
    }

    // extract query
    pos = string.indexOf('?');
    if (pos > -1) {
      // escaping?
      parts.query = string.substring(pos + 1) || null;
      string = string.substring(0, pos);
    }

    // extract protocol
    if (string.substring(0, 2) === '//') {
      // relative-scheme
      parts.protocol = null;
      string = string.substring(2);
      // extract "user:pass@host:port"
      string = URI.parseAuthority(string, parts);
    } else {
      pos = string.indexOf(':');
      if (pos > -1) {
        parts.protocol = string.substring(0, pos) || null;
        if (parts.protocol && !parts.protocol.match(URI.protocol_expression)) {
          // : may be within the path
          parts.protocol = undefined;
        } else if (string.substring(pos + 1, pos + 3) === '//') {
          string = string.substring(pos + 3);

          // extract "user:pass@host:port"
          string = URI.parseAuthority(string, parts);
        } else {
          string = string.substring(pos + 1);
          parts.urn = true;
        }
      }
    }

    // what's left must be the path
    parts.path = string;

    // and we're done
    return parts;
  };
  URI.parseHost = function(string, parts) {
    if (!string) {
      string = '';
    }

    // Copy chrome, IE, opera backslash-handling behavior.
    // Back slashes before the query string get converted to forward slashes
    // See: https://github.com/joyent/node/blob/386fd24f49b0e9d1a8a076592a404168faeecc34/lib/url.js#L115-L124
    // See: https://code.google.com/p/chromium/issues/detail?id=25916
    // https://github.com/medialize/URI.js/pull/233
    string = string.replace(/\\/g, '/');

    // extract host:port
    var pos = string.indexOf('/');
    var bracketPos;
    var t;

    if (pos === -1) {
      pos = string.length;
    }

    if (string.charAt(0) === '[') {
      // IPv6 host - http://tools.ietf.org/html/draft-ietf-6man-text-addr-representation-04#section-6
      // I claim most client software breaks on IPv6 anyways. To simplify things, URI only accepts
      // IPv6+port in the format [2001:db8::1]:80 (for the time being)
      bracketPos = string.indexOf(']');
      parts.hostname = string.substring(1, bracketPos) || null;
      parts.port = string.substring(bracketPos + 2, pos) || null;
      if (parts.port === '/') {
        parts.port = null;
      }
    } else {
      var firstColon = string.indexOf(':');
      var firstSlash = string.indexOf('/');
      var nextColon = string.indexOf(':', firstColon + 1);
      if (nextColon !== -1 && (firstSlash === -1 || nextColon < firstSlash)) {
        // IPv6 host contains multiple colons - but no port
        // this notation is actually not allowed by RFC 3986, but we're a liberal parser
        parts.hostname = string.substring(0, pos) || null;
        parts.port = null;
      } else {
        t = string.substring(0, pos).split(':');
        parts.hostname = t[0] || null;
        parts.port = t[1] || null;
      }
    }

    if (parts.hostname && string.substring(pos).charAt(0) !== '/') {
      pos++;
      string = '/' + string;
    }

    if (parts.preventInvalidHostname) {
      URI.ensureValidHostname(parts.hostname, parts.protocol);
    }

    if (parts.port) {
      URI.ensureValidPort(parts.port);
    }

    return string.substring(pos) || '/';
  };
  URI.parseAuthority = function(string, parts) {
    string = URI.parseUserinfo(string, parts);
    return URI.parseHost(string, parts);
  };
  URI.parseUserinfo = function(string, parts) {
    // extract username:password
    var firstSlash = string.indexOf('/');
    var pos = string.lastIndexOf('@', firstSlash > -1 ? firstSlash : string.length - 1);
    var t;

    // authority@ must come before /path
    if (pos > -1 && (firstSlash === -1 || pos < firstSlash)) {
      t = string.substring(0, pos).split(':');
      parts.username = t[0] ? URI.decode(t[0]) : null;
      t.shift();
      parts.password = t[0] ? URI.decode(t.join(':')) : null;
      string = string.substring(pos + 1);
    } else {
      parts.username = null;
      parts.password = null;
    }

    return string;
  };
  URI.parseQuery = function(string, escapeQuerySpace) {
    if (!string) {
      return {};
    }

    // throw out the funky business - "?"[name"="value"&"]+
    string = string.replace(/&+/g, '&').replace(/^\?*&*|&+$/g, '');

    if (!string) {
      return {};
    }

    var items = {};
    var splits = string.split('&');
    var length = splits.length;
    var v, name, value;

    for (var i = 0; i < length; i++) {
      v = splits[i].split('=');
      name = URI.decodeQuery(v.shift(), escapeQuerySpace);
      // no "=" is null according to http://dvcs.w3.org/hg/url/raw-file/tip/Overview.html#collect-url-parameters
      value = v.length ? URI.decodeQuery(v.join('='), escapeQuerySpace) : null;

      if (hasOwn.call(items, name)) {
        if (typeof items[name] === 'string' || items[name] === null) {
          items[name] = [items[name]];
        }

        items[name].push(value);
      } else {
        items[name] = value;
      }
    }

    return items;
  };

  URI.build = function(parts) {
    var t = '';

    if (parts.protocol) {
      t += parts.protocol + ':';
    }

    if (!parts.urn && (t || parts.hostname)) {
      t += '//';
    }

    t += (URI.buildAuthority(parts) || '');

    if (typeof parts.path === 'string') {
      if (parts.path.charAt(0) !== '/' && typeof parts.hostname === 'string') {
        t += '/';
      }

      t += parts.path;
    }

    if (typeof parts.query === 'string' && parts.query) {
      t += '?' + parts.query;
    }

    if (typeof parts.fragment === 'string' && parts.fragment) {
      t += '#' + parts.fragment;
    }
    return t;
  };
  URI.buildHost = function(parts) {
    var t = '';

    if (!parts.hostname) {
      return '';
    } else if (URI.ip6_expression.test(parts.hostname)) {
      t += '[' + parts.hostname + ']';
    } else {
      t += parts.hostname;
    }

    if (parts.port) {
      t += ':' + parts.port;
    }

    return t;
  };
  URI.buildAuthority = function(parts) {
    return URI.buildUserinfo(parts) + URI.buildHost(parts);
  };
  URI.buildUserinfo = function(parts) {
    var t = '';

    if (parts.username) {
      t += URI.encode(parts.username);
    }

    if (parts.password) {
      t += ':' + URI.encode(parts.password);
    }

    if (t) {
      t += '@';
    }

    return t;
  };
  URI.buildQuery = function(data, duplicateQueryParameters, escapeQuerySpace) {
    // according to http://tools.ietf.org/html/rfc3986 or http://labs.apache.org/webarch/uri/rfc/rfc3986.html
    // being »-._~!$&'()*+,;=:@/?« %HEX and alnum are allowed
    // the RFC explicitly states ?/foo being a valid use case, no mention of parameter syntax!
    // URI.js treats the query string as being application/x-www-form-urlencoded
    // see http://www.w3.org/TR/REC-html40/interact/forms.html#form-content-type

    var t = '';
    var unique, key, i, length;
    for (key in data) {
      if (hasOwn.call(data, key) && key) {
        if (isArray(data[key])) {
          unique = {};
          for (i = 0, length = data[key].length; i < length; i++) {
            if (data[key][i] !== undefined && unique[data[key][i] + ''] === undefined) {
              t += '&' + URI.buildQueryParameter(key, data[key][i], escapeQuerySpace);
              if (duplicateQueryParameters !== true) {
                unique[data[key][i] + ''] = true;
              }
            }
          }
        } else if (data[key] !== undefined) {
          t += '&' + URI.buildQueryParameter(key, data[key], escapeQuerySpace);
        }
      }
    }

    return t.substring(1);
  };
  URI.buildQueryParameter = function(name, value, escapeQuerySpace) {
    // http://www.w3.org/TR/REC-html40/interact/forms.html#form-content-type -- application/x-www-form-urlencoded
    // don't append "=" for null values, according to http://dvcs.w3.org/hg/url/raw-file/tip/Overview.html#url-parameter-serialization
    return URI.encodeQuery(name, escapeQuerySpace) + (value !== null ? '=' + URI.encodeQuery(value, escapeQuerySpace) : '');
  };

  URI.addQuery = function(data, name, value) {
    if (typeof name === 'object') {
      for (var key in name) {
        if (hasOwn.call(name, key)) {
          URI.addQuery(data, key, name[key]);
        }
      }
    } else if (typeof name === 'string') {
      if (data[name] === undefined) {
        data[name] = value;
        return;
      } else if (typeof data[name] === 'string') {
        data[name] = [data[name]];
      }

      if (!isArray(value)) {
        value = [value];
      }

      data[name] = (data[name] || []).concat(value);
    } else {
      throw new TypeError('URI.addQuery() accepts an object, string as the name parameter');
    }
  };

  URI.setQuery = function(data, name, value) {
    if (typeof name === 'object') {
      for (var key in name) {
        if (hasOwn.call(name, key)) {
          URI.setQuery(data, key, name[key]);
        }
      }
    } else if (typeof name === 'string') {
      data[name] = value === undefined ? null : value;
    } else {
      throw new TypeError('URI.setQuery() accepts an object, string as the name parameter');
    }
  };

  URI.removeQuery = function(data, name, value) {
    var i, length, key;

    if (isArray(name)) {
      for (i = 0, length = name.length; i < length; i++) {
        data[name[i]] = undefined;
      }
    } else if (getType(name) === 'RegExp') {
      for (key in data) {
        if (name.test(key)) {
          data[key] = undefined;
        }
      }
    } else if (typeof name === 'object') {
      for (key in name) {
        if (hasOwn.call(name, key)) {
          URI.removeQuery(data, key, name[key]);
        }
      }
    } else if (typeof name === 'string') {
      if (value !== undefined) {
        if (getType(value) === 'RegExp') {
          if (!isArray(data[name]) && value.test(data[name])) {
            data[name] = undefined;
          } else {
            data[name] = filterArrayValues(data[name], value);
          }
        } else if (data[name] === String(value) && (!isArray(value) || value.length === 1)) {
          data[name] = undefined;
        } else if (isArray(data[name])) {
          data[name] = filterArrayValues(data[name], value);
        }
      } else {
        data[name] = undefined;
      }
    } else {
      throw new TypeError('URI.removeQuery() accepts an object, string, RegExp as the first parameter');
    }
  };
  URI.hasQuery = function(data, name, value, withinArray) {
    switch (getType(name)) {
      case 'String':
        // Nothing to do here
        break;

      case 'RegExp':
        for (var key in data) {
          if (hasOwn.call(data, key)) {
            if (name.test(key) && (value === undefined || URI.hasQuery(data, key, value))) {
              return true;
            }
          }
        }

        return false;

      case 'Object':
        for (var _key in name) {
          if (hasOwn.call(name, _key)) {
            if (!URI.hasQuery(data, _key, name[_key])) {
              return false;
            }
          }
        }

        return true;

      default:
        throw new TypeError('URI.hasQuery() accepts a string, regular expression or object as the name parameter');
    }

    switch (getType(value)) {
      case 'Undefined':
        // true if exists (but may be empty)
        return name in data; // data[name] !== undefined;

      case 'Boolean':
        // true if exists and non-empty
        var _booly = Boolean(isArray(data[name]) ? data[name].length : data[name]);
        return value === _booly;

      case 'Function':
        // allow complex comparison
        return !!value(data[name], name, data);

      case 'Array':
        if (!isArray(data[name])) {
          return false;
        }

        var op = withinArray ? arrayContains : arraysEqual;
        return op(data[name], value);

      case 'RegExp':
        if (!isArray(data[name])) {
          return Boolean(data[name] && data[name].match(value));
        }

        if (!withinArray) {
          return false;
        }

        return arrayContains(data[name], value);

      case 'Number':
        value = String(value);
        /* falls through */
      case 'String':
        if (!isArray(data[name])) {
          return data[name] === value;
        }

        if (!withinArray) {
          return false;
        }

        return arrayContains(data[name], value);

      default:
        throw new TypeError('URI.hasQuery() accepts undefined, boolean, string, number, RegExp, Function as the value parameter');
    }
  };


  URI.joinPaths = function() {
    var input = [];
    var segments = [];
    var nonEmptySegments = 0;

    for (var i = 0; i < arguments.length; i++) {
      var url = new URI(arguments[i]);
      input.push(url);
      var _segments = url.segment();
      for (var s = 0; s < _segments.length; s++) {
        if (typeof _segments[s] === 'string') {
          segments.push(_segments[s]);
        }

        if (_segments[s]) {
          nonEmptySegments++;
        }
      }
    }

    if (!segments.length || !nonEmptySegments) {
      return new URI('');
    }

    var uri = new URI('').segment(segments);

    if (input[0].path() === '' || input[0].path().slice(0, 1) === '/') {
      uri.path('/' + uri.path());
    }

    return uri.normalize();
  };

  URI.commonPath = function(one, two) {
    var length = Math.min(one.length, two.length);
    var pos;

    // find first non-matching character
    for (pos = 0; pos < length; pos++) {
      if (one.charAt(pos) !== two.charAt(pos)) {
        pos--;
        break;
      }
    }

    if (pos < 1) {
      return one.charAt(0) === two.charAt(0) && one.charAt(0) === '/' ? '/' : '';
    }

    // revert to last /
    if (one.charAt(pos) !== '/' || two.charAt(pos) !== '/') {
      pos = one.substring(0, pos).lastIndexOf('/');
    }

    return one.substring(0, pos + 1);
  };

  URI.withinString = function(string, callback, options) {
    options || (options = {});
    var _start = options.start || URI.findUri.start;
    var _end = options.end || URI.findUri.end;
    var _trim = options.trim || URI.findUri.trim;
    var _parens = options.parens || URI.findUri.parens;
    var _attributeOpen = /[a-z0-9-]=["']?$/i;

    _start.lastIndex = 0;
    while (true) {
      var match = _start.exec(string);
      if (!match) {
        break;
      }

      var start = match.index;
      if (options.ignoreHtml) {
        // attribut(e=["']?$)
        var attributeOpen = string.slice(Math.max(start - 3, 0), start);
        if (attributeOpen && _attributeOpen.test(attributeOpen)) {
          continue;
        }
      }

      var end = start + string.slice(start).search(_end);
      var slice = string.slice(start, end);
      // make sure we include well balanced parens
      var parensEnd = -1;
      while (true) {
        var parensMatch = _parens.exec(slice);
        if (!parensMatch) {
          break;
        }

        var parensMatchEnd = parensMatch.index + parensMatch[0].length;
        parensEnd = Math.max(parensEnd, parensMatchEnd);
      }

      if (parensEnd > -1) {
        slice = slice.slice(0, parensEnd) + slice.slice(parensEnd).replace(_trim, '');
      } else {
        slice = slice.replace(_trim, '');
      }

      if (slice.length <= match[0].length) {
        // the extract only contains the starting marker of a URI,
        // e.g. "www" or "http://"
        continue;
      }

      if (options.ignore && options.ignore.test(slice)) {
        continue;
      }

      end = start + slice.length;
      var result = callback(slice, start, end, string);
      if (result === undefined) {
        _start.lastIndex = end;
        continue;
      }

      result = String(result);
      string = string.slice(0, start) + result + string.slice(end);
      _start.lastIndex = start + result.length;
    }

    _start.lastIndex = 0;
    return string;
  };

  URI.ensureValidHostname = function(v, protocol) {
    // Theoretically URIs allow percent-encoding in Hostnames (according to RFC 3986)
    // they are not part of DNS and therefore ignored by URI.js

    var hasHostname = !!v; // not null and not an empty string
    var hasProtocol = !!protocol;
    var rejectEmptyHostname = false;

    if (hasProtocol) {
      rejectEmptyHostname = arrayContains(URI.hostProtocols, protocol);
    }

    if (rejectEmptyHostname && !hasHostname) {
      throw new TypeError('Hostname cannot be empty, if protocol is ' + protocol);
    } else if (v && v.match(URI.invalid_hostname_characters)) {
      // test punycode
      if (!punycode) {
        throw new TypeError('Hostname "' + v + '" contains characters other than [A-Z0-9.-:_] and Punycode.js is not available');
      }
      if (punycode.toASCII(v).match(URI.invalid_hostname_characters)) {
        throw new TypeError('Hostname "' + v + '" contains characters other than [A-Z0-9.-:_]');
      }
    }
  };

  URI.ensureValidPort = function (v) {
    if (!v) {
      return;
    }

    var port = Number(v);
    if (isInteger(port) && (port > 0) && (port < 65536)) {
      return;
    }

    throw new TypeError('Port "' + v + '" is not a valid port');
  };

  // noConflict
  URI.noConflict = function(removeAll) {
    if (removeAll) {
      var unconflicted = {
        URI: this.noConflict()
      };

      if (root.URITemplate && typeof root.URITemplate.noConflict === 'function') {
        unconflicted.URITemplate = root.URITemplate.noConflict();
      }

      if (root.IPv6 && typeof root.IPv6.noConflict === 'function') {
        unconflicted.IPv6 = root.IPv6.noConflict();
      }

      if (root.SecondLevelDomains && typeof root.SecondLevelDomains.noConflict === 'function') {
        unconflicted.SecondLevelDomains = root.SecondLevelDomains.noConflict();
      }

      return unconflicted;
    } else if (root.URI === this) {
      root.URI = _URI;
    }

    return this;
  };

  p.build = function(deferBuild) {
    if (deferBuild === true) {
      this._deferred_build = true;
    } else if (deferBuild === undefined || this._deferred_build) {
      this._string = URI.build(this._parts);
      this._deferred_build = false;
    }

    return this;
  };

  p.clone = function() {
    return new URI(this);
  };

  p.valueOf = p.toString = function() {
    return this.build(false)._string;
  };


  function generateSimpleAccessor(_part){
    return function(v, build) {
      if (v === undefined) {
        return this._parts[_part] || '';
      } else {
        this._parts[_part] = v || null;
        this.build(!build);
        return this;
      }
    };
  }

  function generatePrefixAccessor(_part, _key){
    return function(v, build) {
      if (v === undefined) {
        return this._parts[_part] || '';
      } else {
        if (v !== null) {
          v = v + '';
          if (v.charAt(0) === _key) {
            v = v.substring(1);
          }
        }

        this._parts[_part] = v;
        this.build(!build);
        return this;
      }
    };
  }

  p.protocol = generateSimpleAccessor('protocol');
  p.username = generateSimpleAccessor('username');
  p.password = generateSimpleAccessor('password');
  p.hostname = generateSimpleAccessor('hostname');
  p.port = generateSimpleAccessor('port');
  p.query = generatePrefixAccessor('query', '?');
  p.fragment = generatePrefixAccessor('fragment', '#');

  p.search = function(v, build) {
    var t = this.query(v, build);
    return typeof t === 'string' && t.length ? ('?' + t) : t;
  };
  p.hash = function(v, build) {
    var t = this.fragment(v, build);
    return typeof t === 'string' && t.length ? ('#' + t) : t;
  };

  p.pathname = function(v, build) {
    if (v === undefined || v === true) {
      var res = this._parts.path || (this._parts.hostname ? '/' : '');
      return v ? (this._parts.urn ? URI.decodeUrnPath : URI.decodePath)(res) : res;
    } else {
      if (this._parts.urn) {
        this._parts.path = v ? URI.recodeUrnPath(v) : '';
      } else {
        this._parts.path = v ? URI.recodePath(v) : '/';
      }
      this.build(!build);
      return this;
    }
  };
  p.path = p.pathname;
  p.href = function(href, build) {
    var key;

    if (href === undefined) {
      return this.toString();
    }

    this._string = '';
    this._parts = URI._parts();

    var _URI = href instanceof URI;
    var _object = typeof href === 'object' && (href.hostname || href.path || href.pathname);
    if (href.nodeName) {
      var attribute = URI.getDomAttribute(href);
      href = href[attribute] || '';
      _object = false;
    }

    // window.location is reported to be an object, but it's not the sort
    // of object we're looking for:
    // * location.protocol ends with a colon
    // * location.query != object.search
    // * location.hash != object.fragment
    // simply serializing the unknown object should do the trick
    // (for location, not for everything...)
    if (!_URI && _object && href.pathname !== undefined) {
      href = href.toString();
    }

    if (typeof href === 'string' || href instanceof String) {
      this._parts = URI.parse(String(href), this._parts);
    } else if (_URI || _object) {
      var src = _URI ? href._parts : href;
      for (key in src) {
        if (key === 'query') { continue; }
        if (hasOwn.call(this._parts, key)) {
          this._parts[key] = src[key];
        }
      }
      if (src.query) {
        this.query(src.query, false);
      }
    } else {
      throw new TypeError('invalid input');
    }

    this.build(!build);
    return this;
  };

  // identification accessors
  p.is = function(what) {
    var ip = false;
    var ip4 = false;
    var ip6 = false;
    var name = false;
    var sld = false;
    var idn = false;
    var punycode = false;
    var relative = !this._parts.urn;

    if (this._parts.hostname) {
      relative = false;
      ip4 = URI.ip4_expression.test(this._parts.hostname);
      ip6 = URI.ip6_expression.test(this._parts.hostname);
      ip = ip4 || ip6;
      name = !ip;
      sld = name && SLD && SLD.has(this._parts.hostname);
      idn = name && URI.idn_expression.test(this._parts.hostname);
      punycode = name && URI.punycode_expression.test(this._parts.hostname);
    }

    switch (what.toLowerCase()) {
      case 'relative':
        return relative;

      case 'absolute':
        return !relative;

      // hostname identification
      case 'domain':
      case 'name':
        return name;

      case 'sld':
        return sld;

      case 'ip':
        return ip;

      case 'ip4':
      case 'ipv4':
      case 'inet4':
        return ip4;

      case 'ip6':
      case 'ipv6':
      case 'inet6':
        return ip6;

      case 'idn':
        return idn;

      case 'url':
        return !this._parts.urn;

      case 'urn':
        return !!this._parts.urn;

      case 'punycode':
        return punycode;
    }

    return null;
  };

  // component specific input validation
  var _protocol = p.protocol;
  var _port = p.port;
  var _hostname = p.hostname;

  p.protocol = function(v, build) {
    if (v) {
      // accept trailing ://
      v = v.replace(/:(\/\/)?$/, '');

      if (!v.match(URI.protocol_expression)) {
        throw new TypeError('Protocol "' + v + '" contains characters other than [A-Z0-9.+-] or doesn\'t start with [A-Z]');
      }
    }

    return _protocol.call(this, v, build);
  };
  p.scheme = p.protocol;
  p.port = function(v, build) {
    if (this._parts.urn) {
      return v === undefined ? '' : this;
    }

    if (v !== undefined) {
      if (v === 0) {
        v = null;
      }

      if (v) {
        v += '';
        if (v.charAt(0) === ':') {
          v = v.substring(1);
        }

        URI.ensureValidPort(v);
      }
    }
    return _port.call(this, v, build);
  };
  p.hostname = function(v, build) {
    if (this._parts.urn) {
      return v === undefined ? '' : this;
    }

    if (v !== undefined) {
      var x = { preventInvalidHostname: this._parts.preventInvalidHostname };
      var res = URI.parseHost(v, x);
      if (res !== '/') {
        throw new TypeError('Hostname "' + v + '" contains characters other than [A-Z0-9.-]');
      }

      v = x.hostname;
      if (this._parts.preventInvalidHostname) {
        URI.ensureValidHostname(v, this._parts.protocol);
      }
    }

    return _hostname.call(this, v, build);
  };

  // compound accessors
  p.origin = function(v, build) {
    if (this._parts.urn) {
      return v === undefined ? '' : this;
    }

    if (v === undefined) {
      var protocol = this.protocol();
      var authority = this.authority();
      if (!authority) {
        return '';
      }

      return (protocol ? protocol + '://' : '') + this.authority();
    } else {
      var origin = URI(v);
      this
        .protocol(origin.protocol())
        .authority(origin.authority())
        .build(!build);
      return this;
    }
  };
  p.host = function(v, build) {
    if (this._parts.urn) {
      return v === undefined ? '' : this;
    }

    if (v === undefined) {
      return this._parts.hostname ? URI.buildHost(this._parts) : '';
    } else {
      var res = URI.parseHost(v, this._parts);
      if (res !== '/') {
        throw new TypeError('Hostname "' + v + '" contains characters other than [A-Z0-9.-]');
      }

      this.build(!build);
      return this;
    }
  };
  p.authority = function(v, build) {
    if (this._parts.urn) {
      return v === undefined ? '' : this;
    }

    if (v === undefined) {
      return this._parts.hostname ? URI.buildAuthority(this._parts) : '';
    } else {
      var res = URI.parseAuthority(v, this._parts);
      if (res !== '/') {
        throw new TypeError('Hostname "' + v + '" contains characters other than [A-Z0-9.-]');
      }

      this.build(!build);
      return this;
    }
  };
  p.userinfo = function(v, build) {
    if (this._parts.urn) {
      return v === undefined ? '' : this;
    }

    if (v === undefined) {
      var t = URI.buildUserinfo(this._parts);
      return t ? t.substring(0, t.length -1) : t;
    } else {
      if (v[v.length-1] !== '@') {
        v += '@';
      }

      URI.parseUserinfo(v, this._parts);
      this.build(!build);
      return this;
    }
  };
  p.resource = function(v, build) {
    var parts;

    if (v === undefined) {
      return this.path() + this.search() + this.hash();
    }

    parts = URI.parse(v);
    this._parts.path = parts.path;
    this._parts.query = parts.query;
    this._parts.fragment = parts.fragment;
    this.build(!build);
    return this;
  };

  // fraction accessors
  p.subdomain = function(v, build) {
    if (this._parts.urn) {
      return v === undefined ? '' : this;
    }

    // convenience, return "www" from "www.example.org"
    if (v === undefined) {
      if (!this._parts.hostname || this.is('IP')) {
        return '';
      }

      // grab domain and add another segment
      var end = this._parts.hostname.length - this.domain().length - 1;
      return this._parts.hostname.substring(0, end) || '';
    } else {
      var e = this._parts.hostname.length - this.domain().length;
      var sub = this._parts.hostname.substring(0, e);
      var replace = new RegExp('^' + escapeRegEx(sub));

      if (v && v.charAt(v.length - 1) !== '.') {
        v += '.';
      }

      if (v.indexOf(':') !== -1) {
        throw new TypeError('Domains cannot contain colons');
      }

      if (v) {
        URI.ensureValidHostname(v, this._parts.protocol);
      }

      this._parts.hostname = this._parts.hostname.replace(replace, v);
      this.build(!build);
      return this;
    }
  };
  p.domain = function(v, build) {
    if (this._parts.urn) {
      return v === undefined ? '' : this;
    }

    if (typeof v === 'boolean') {
      build = v;
      v = undefined;
    }

    // convenience, return "example.org" from "www.example.org"
    if (v === undefined) {
      if (!this._parts.hostname || this.is('IP')) {
        return '';
      }

      // if hostname consists of 1 or 2 segments, it must be the domain
      var t = this._parts.hostname.match(/\./g);
      if (t && t.length < 2) {
        return this._parts.hostname;
      }

      // grab tld and add another segment
      var end = this._parts.hostname.length - this.tld(build).length - 1;
      end = this._parts.hostname.lastIndexOf('.', end -1) + 1;
      return this._parts.hostname.substring(end) || '';
    } else {
      if (!v) {
        throw new TypeError('cannot set domain empty');
      }

      if (v.indexOf(':') !== -1) {
        throw new TypeError('Domains cannot contain colons');
      }

      URI.ensureValidHostname(v, this._parts.protocol);

      if (!this._parts.hostname || this.is('IP')) {
        this._parts.hostname = v;
      } else {
        var replace = new RegExp(escapeRegEx(this.domain()) + '$');
        this._parts.hostname = this._parts.hostname.replace(replace, v);
      }

      this.build(!build);
      return this;
    }
  };
  p.tld = function(v, build) {
    if (this._parts.urn) {
      return v === undefined ? '' : this;
    }

    if (typeof v === 'boolean') {
      build = v;
      v = undefined;
    }

    // return "org" from "www.example.org"
    if (v === undefined) {
      if (!this._parts.hostname || this.is('IP')) {
        return '';
      }

      var pos = this._parts.hostname.lastIndexOf('.');
      var tld = this._parts.hostname.substring(pos + 1);

      if (build !== true && SLD && SLD.list[tld.toLowerCase()]) {
        return SLD.get(this._parts.hostname) || tld;
      }

      return tld;
    } else {
      var replace;

      if (!v) {
        throw new TypeError('cannot set TLD empty');
      } else if (v.match(/[^a-zA-Z0-9-]/)) {
        if (SLD && SLD.is(v)) {
          replace = new RegExp(escapeRegEx(this.tld()) + '$');
          this._parts.hostname = this._parts.hostname.replace(replace, v);
        } else {
          throw new TypeError('TLD "' + v + '" contains characters other than [A-Z0-9]');
        }
      } else if (!this._parts.hostname || this.is('IP')) {
        throw new ReferenceError('cannot set TLD on non-domain host');
      } else {
        replace = new RegExp(escapeRegEx(this.tld()) + '$');
        this._parts.hostname = this._parts.hostname.replace(replace, v);
      }

      this.build(!build);
      return this;
    }
  };
  p.directory = function(v, build) {
    if (this._parts.urn) {
      return v === undefined ? '' : this;
    }

    if (v === undefined || v === true) {
      if (!this._parts.path && !this._parts.hostname) {
        return '';
      }

      if (this._parts.path === '/') {
        return '/';
      }

      var end = this._parts.path.length - this.filename().length - 1;
      var res = this._parts.path.substring(0, end) || (this._parts.hostname ? '/' : '');

      return v ? URI.decodePath(res) : res;

    } else {
      var e = this._parts.path.length - this.filename().length;
      var directory = this._parts.path.substring(0, e);
      var replace = new RegExp('^' + escapeRegEx(directory));

      // fully qualifier directories begin with a slash
      if (!this.is('relative')) {
        if (!v) {
          v = '/';
        }

        if (v.charAt(0) !== '/') {
          v = '/' + v;
        }
      }

      // directories always end with a slash
      if (v && v.charAt(v.length - 1) !== '/') {
        v += '/';
      }

      v = URI.recodePath(v);
      this._parts.path = this._parts.path.replace(replace, v);
      this.build(!build);
      return this;
    }
  };
  p.filename = function(v, build) {
    if (this._parts.urn) {
      return v === undefined ? '' : this;
    }

    if (typeof v !== 'string') {
      if (!this._parts.path || this._parts.path === '/') {
        return '';
      }

      var pos = this._parts.path.lastIndexOf('/');
      var res = this._parts.path.substring(pos+1);

      return v ? URI.decodePathSegment(res) : res;
    } else {
      var mutatedDirectory = false;

      if (v.charAt(0) === '/') {
        v = v.substring(1);
      }

      if (v.match(/\.?\//)) {
        mutatedDirectory = true;
      }

      var replace = new RegExp(escapeRegEx(this.filename()) + '$');
      v = URI.recodePath(v);
      this._parts.path = this._parts.path.replace(replace, v);

      if (mutatedDirectory) {
        this.normalizePath(build);
      } else {
        this.build(!build);
      }

      return this;
    }
  };
  p.suffix = function(v, build) {
    if (this._parts.urn) {
      return v === undefined ? '' : this;
    }

    if (v === undefined || v === true) {
      if (!this._parts.path || this._parts.path === '/') {
        return '';
      }

      var filename = this.filename();
      var pos = filename.lastIndexOf('.');
      var s, res;

      if (pos === -1) {
        return '';
      }

      // suffix may only contain alnum characters (yup, I made this up.)
      s = filename.substring(pos+1);
      res = (/^[a-z0-9%]+$/i).test(s) ? s : '';
      return v ? URI.decodePathSegment(res) : res;
    } else {
      if (v.charAt(0) === '.') {
        v = v.substring(1);
      }

      var suffix = this.suffix();
      var replace;

      if (!suffix) {
        if (!v) {
          return this;
        }

        this._parts.path += '.' + URI.recodePath(v);
      } else if (!v) {
        replace = new RegExp(escapeRegEx('.' + suffix) + '$');
      } else {
        replace = new RegExp(escapeRegEx(suffix) + '$');
      }

      if (replace) {
        v = URI.recodePath(v);
        this._parts.path = this._parts.path.replace(replace, v);
      }

      this.build(!build);
      return this;
    }
  };
  p.segment = function(segment, v, build) {
    var separator = this._parts.urn ? ':' : '/';
    var path = this.path();
    var absolute = path.substring(0, 1) === '/';
    var segments = path.split(separator);

    if (segment !== undefined && typeof segment !== 'number') {
      build = v;
      v = segment;
      segment = undefined;
    }

    if (segment !== undefined && typeof segment !== 'number') {
      throw new Error('Bad segment "' + segment + '", must be 0-based integer');
    }

    if (absolute) {
      segments.shift();
    }

    if (segment < 0) {
      // allow negative indexes to address from the end
      segment = Math.max(segments.length + segment, 0);
    }

    if (v === undefined) {
      /*jshint laxbreak: true */
      return segment === undefined
        ? segments
        : segments[segment];
      /*jshint laxbreak: false */
    } else if (segment === null || segments[segment] === undefined) {
      if (isArray(v)) {
        segments = [];
        // collapse empty elements within array
        for (var i=0, l=v.length; i < l; i++) {
          if (!v[i].length && (!segments.length || !segments[segments.length -1].length)) {
            continue;
          }

          if (segments.length && !segments[segments.length -1].length) {
            segments.pop();
          }

          segments.push(trimSlashes(v[i]));
        }
      } else if (v || typeof v === 'string') {
        v = trimSlashes(v);
        if (segments[segments.length -1] === '') {
          // empty trailing elements have to be overwritten
          // to prevent results such as /foo//bar
          segments[segments.length -1] = v;
        } else {
          segments.push(v);
        }
      }
    } else {
      if (v) {
        segments[segment] = trimSlashes(v);
      } else {
        segments.splice(segment, 1);
      }
    }

    if (absolute) {
      segments.unshift('');
    }

    return this.path(segments.join(separator), build);
  };
  p.segmentCoded = function(segment, v, build) {
    var segments, i, l;

    if (typeof segment !== 'number') {
      build = v;
      v = segment;
      segment = undefined;
    }

    if (v === undefined) {
      segments = this.segment(segment, v, build);
      if (!isArray(segments)) {
        segments = segments !== undefined ? URI.decode(segments) : undefined;
      } else {
        for (i = 0, l = segments.length; i < l; i++) {
          segments[i] = URI.decode(segments[i]);
        }
      }

      return segments;
    }

    if (!isArray(v)) {
      v = (typeof v === 'string' || v instanceof String) ? URI.encode(v) : v;
    } else {
      for (i = 0, l = v.length; i < l; i++) {
        v[i] = URI.encode(v[i]);
      }
    }

    return this.segment(segment, v, build);
  };

  // mutating query string
  var q = p.query;
  p.query = function(v, build) {
    if (v === true) {
      return URI.parseQuery(this._parts.query, this._parts.escapeQuerySpace);
    } else if (typeof v === 'function') {
      var data = URI.parseQuery(this._parts.query, this._parts.escapeQuerySpace);
      var result = v.call(this, data);
      this._parts.query = URI.buildQuery(result || data, this._parts.duplicateQueryParameters, this._parts.escapeQuerySpace);
      this.build(!build);
      return this;
    } else if (v !== undefined && typeof v !== 'string') {
      this._parts.query = URI.buildQuery(v, this._parts.duplicateQueryParameters, this._parts.escapeQuerySpace);
      this.build(!build);
      return this;
    } else {
      return q.call(this, v, build);
    }
  };
  p.setQuery = function(name, value, build) {
    var data = URI.parseQuery(this._parts.query, this._parts.escapeQuerySpace);

    if (typeof name === 'string' || name instanceof String) {
      data[name] = value !== undefined ? value : null;
    } else if (typeof name === 'object') {
      for (var key in name) {
        if (hasOwn.call(name, key)) {
          data[key] = name[key];
        }
      }
    } else {
      throw new TypeError('URI.addQuery() accepts an object, string as the name parameter');
    }

    this._parts.query = URI.buildQuery(data, this._parts.duplicateQueryParameters, this._parts.escapeQuerySpace);
    if (typeof name !== 'string') {
      build = value;
    }

    this.build(!build);
    return this;
  };
  p.addQuery = function(name, value, build) {
    var data = URI.parseQuery(this._parts.query, this._parts.escapeQuerySpace);
    URI.addQuery(data, name, value === undefined ? null : value);
    this._parts.query = URI.buildQuery(data, this._parts.duplicateQueryParameters, this._parts.escapeQuerySpace);
    if (typeof name !== 'string') {
      build = value;
    }

    this.build(!build);
    return this;
  };
  p.removeQuery = function(name, value, build) {
    var data = URI.parseQuery(this._parts.query, this._parts.escapeQuerySpace);
    URI.removeQuery(data, name, value);
    this._parts.query = URI.buildQuery(data, this._parts.duplicateQueryParameters, this._parts.escapeQuerySpace);
    if (typeof name !== 'string') {
      build = value;
    }

    this.build(!build);
    return this;
  };
  p.hasQuery = function(name, value, withinArray) {
    var data = URI.parseQuery(this._parts.query, this._parts.escapeQuerySpace);
    return URI.hasQuery(data, name, value, withinArray);
  };
  p.setSearch = p.setQuery;
  p.addSearch = p.addQuery;
  p.removeSearch = p.removeQuery;
  p.hasSearch = p.hasQuery;

  // sanitizing URLs
  p.normalize = function() {
    if (this._parts.urn) {
      return this
        .normalizeProtocol(false)
        .normalizePath(false)
        .normalizeQuery(false)
        .normalizeFragment(false)
        .build();
    }

    return this
      .normalizeProtocol(false)
      .normalizeHostname(false)
      .normalizePort(false)
      .normalizePath(false)
      .normalizeQuery(false)
      .normalizeFragment(false)
      .build();
  };
  p.normalizeProtocol = function(build) {
    if (typeof this._parts.protocol === 'string') {
      this._parts.protocol = this._parts.protocol.toLowerCase();
      this.build(!build);
    }

    return this;
  };
  p.normalizeHostname = function(build) {
    if (this._parts.hostname) {
      if (this.is('IDN') && punycode) {
        this._parts.hostname = punycode.toASCII(this._parts.hostname);
      } else if (this.is('IPv6') && IPv6) {
        this._parts.hostname = IPv6.best(this._parts.hostname);
      }

      this._parts.hostname = this._parts.hostname.toLowerCase();
      this.build(!build);
    }

    return this;
  };
  p.normalizePort = function(build) {
    // remove port of it's the protocol's default
    if (typeof this._parts.protocol === 'string' && this._parts.port === URI.defaultPorts[this._parts.protocol]) {
      this._parts.port = null;
      this.build(!build);
    }

    return this;
  };
  p.normalizePath = function(build) {
    var _path = this._parts.path;
    if (!_path) {
      return this;
    }

    if (this._parts.urn) {
      this._parts.path = URI.recodeUrnPath(this._parts.path);
      this.build(!build);
      return this;
    }

    if (this._parts.path === '/') {
      return this;
    }

    _path = URI.recodePath(_path);

    var _was_relative;
    var _leadingParents = '';
    var _parent, _pos;

    // handle relative paths
    if (_path.charAt(0) !== '/') {
      _was_relative = true;
      _path = '/' + _path;
    }

    // handle relative files (as opposed to directories)
    if (_path.slice(-3) === '/..' || _path.slice(-2) === '/.') {
      _path += '/';
    }

    // resolve simples
    _path = _path
      .replace(/(\/(\.\/)+)|(\/\.$)/g, '/')
      .replace(/\/{2,}/g, '/');

    // remember leading parents
    if (_was_relative) {
      _leadingParents = _path.substring(1).match(/^(\.\.\/)+/) || '';
      if (_leadingParents) {
        _leadingParents = _leadingParents[0];
      }
    }

    // resolve parents
    while (true) {
      _parent = _path.search(/\/\.\.(\/|$)/);
      if (_parent === -1) {
        // no more ../ to resolve
        break;
      } else if (_parent === 0) {
        // top level cannot be relative, skip it
        _path = _path.substring(3);
        continue;
      }

      _pos = _path.substring(0, _parent).lastIndexOf('/');
      if (_pos === -1) {
        _pos = _parent;
      }
      _path = _path.substring(0, _pos) + _path.substring(_parent + 3);
    }

    // revert to relative
    if (_was_relative && this.is('relative')) {
      _path = _leadingParents + _path.substring(1);
    }

    this._parts.path = _path;
    this.build(!build);
    return this;
  };
  p.normalizePathname = p.normalizePath;
  p.normalizeQuery = function(build) {
    if (typeof this._parts.query === 'string') {
      if (!this._parts.query.length) {
        this._parts.query = null;
      } else {
        this.query(URI.parseQuery(this._parts.query, this._parts.escapeQuerySpace));
      }

      this.build(!build);
    }

    return this;
  };
  p.normalizeFragment = function(build) {
    if (!this._parts.fragment) {
      this._parts.fragment = null;
      this.build(!build);
    }

    return this;
  };
  p.normalizeSearch = p.normalizeQuery;
  p.normalizeHash = p.normalizeFragment;

  p.iso8859 = function() {
    // expect unicode input, iso8859 output
    var e = URI.encode;
    var d = URI.decode;

    URI.encode = escape;
    URI.decode = decodeURIComponent;
    try {
      this.normalize();
    } finally {
      URI.encode = e;
      URI.decode = d;
    }
    return this;
  };

  p.unicode = function() {
    // expect iso8859 input, unicode output
    var e = URI.encode;
    var d = URI.decode;

    URI.encode = strictEncodeURIComponent;
    URI.decode = unescape;
    try {
      this.normalize();
    } finally {
      URI.encode = e;
      URI.decode = d;
    }
    return this;
  };

  p.readable = function() {
    var uri = this.clone();
    // removing username, password, because they shouldn't be displayed according to RFC 3986
    uri.username('').password('').normalize();
    var t = '';
    if (uri._parts.protocol) {
      t += uri._parts.protocol + '://';
    }

    if (uri._parts.hostname) {
      if (uri.is('punycode') && punycode) {
        t += punycode.toUnicode(uri._parts.hostname);
        if (uri._parts.port) {
          t += ':' + uri._parts.port;
        }
      } else {
        t += uri.host();
      }
    }

    if (uri._parts.hostname && uri._parts.path && uri._parts.path.charAt(0) !== '/') {
      t += '/';
    }

    t += uri.path(true);
    if (uri._parts.query) {
      var q = '';
      for (var i = 0, qp = uri._parts.query.split('&'), l = qp.length; i < l; i++) {
        var kv = (qp[i] || '').split('=');
        q += '&' + URI.decodeQuery(kv[0], this._parts.escapeQuerySpace)
          .replace(/&/g, '%26');

        if (kv[1] !== undefined) {
          q += '=' + URI.decodeQuery(kv[1], this._parts.escapeQuerySpace)
            .replace(/&/g, '%26');
        }
      }
      t += '?' + q.substring(1);
    }

    t += URI.decodeQuery(uri.hash(), true);
    return t;
  };

  // resolving relative and absolute URLs
  p.absoluteTo = function(base) {
    var resolved = this.clone();
    var properties = ['protocol', 'username', 'password', 'hostname', 'port'];
    var basedir, i, p;

    if (this._parts.urn) {
      throw new Error('URNs do not have any generally defined hierarchical components');
    }

    if (!(base instanceof URI)) {
      base = new URI(base);
    }

    if (resolved._parts.protocol) {
      // Directly returns even if this._parts.hostname is empty.
      return resolved;
    } else {
      resolved._parts.protocol = base._parts.protocol;
    }

    if (this._parts.hostname) {
      return resolved;
    }

    for (i = 0; (p = properties[i]); i++) {
      resolved._parts[p] = base._parts[p];
    }

    if (!resolved._parts.path) {
      resolved._parts.path = base._parts.path;
      if (!resolved._parts.query) {
        resolved._parts.query = base._parts.query;
      }
    } else {
      if (resolved._parts.path.substring(-2) === '..') {
        resolved._parts.path += '/';
      }

      if (resolved.path().charAt(0) !== '/') {
        basedir = base.directory();
        basedir = basedir ? basedir : base.path().indexOf('/') === 0 ? '/' : '';
        resolved._parts.path = (basedir ? (basedir + '/') : '') + resolved._parts.path;
        resolved.normalizePath();
      }
    }

    resolved.build();
    return resolved;
  };
  p.relativeTo = function(base) {
    var relative = this.clone().normalize();
    var relativeParts, baseParts, common, relativePath, basePath;

    if (relative._parts.urn) {
      throw new Error('URNs do not have any generally defined hierarchical components');
    }

    base = new URI(base).normalize();
    relativeParts = relative._parts;
    baseParts = base._parts;
    relativePath = relative.path();
    basePath = base.path();

    if (relativePath.charAt(0) !== '/') {
      throw new Error('URI is already relative');
    }

    if (basePath.charAt(0) !== '/') {
      throw new Error('Cannot calculate a URI relative to another relative URI');
    }

    if (relativeParts.protocol === baseParts.protocol) {
      relativeParts.protocol = null;
    }

    if (relativeParts.username !== baseParts.username || relativeParts.password !== baseParts.password) {
      return relative.build();
    }

    if (relativeParts.protocol !== null || relativeParts.username !== null || relativeParts.password !== null) {
      return relative.build();
    }

    if (relativeParts.hostname === baseParts.hostname && relativeParts.port === baseParts.port) {
      relativeParts.hostname = null;
      relativeParts.port = null;
    } else {
      return relative.build();
    }

    if (relativePath === basePath) {
      relativeParts.path = '';
      return relative.build();
    }

    // determine common sub path
    common = URI.commonPath(relativePath, basePath);

    // If the paths have nothing in common, return a relative URL with the absolute path.
    if (!common) {
      return relative.build();
    }

    var parents = baseParts.path
      .substring(common.length)
      .replace(/[^\/]*$/, '')
      .replace(/.*?\//g, '../');

    relativeParts.path = (parents + relativeParts.path.substring(common.length)) || './';

    return relative.build();
  };

  // comparing URIs
  p.equals = function(uri) {
    var one = this.clone();
    var two = new URI(uri);
    var one_map = {};
    var two_map = {};
    var checked = {};
    var one_query, two_query, key;

    one.normalize();
    two.normalize();

    // exact match
    if (one.toString() === two.toString()) {
      return true;
    }

    // extract query string
    one_query = one.query();
    two_query = two.query();
    one.query('');
    two.query('');

    // definitely not equal if not even non-query parts match
    if (one.toString() !== two.toString()) {
      return false;
    }

    // query parameters have the same length, even if they're permuted
    if (one_query.length !== two_query.length) {
      return false;
    }

    one_map = URI.parseQuery(one_query, this._parts.escapeQuerySpace);
    two_map = URI.parseQuery(two_query, this._parts.escapeQuerySpace);

    for (key in one_map) {
      if (hasOwn.call(one_map, key)) {
        if (!isArray(one_map[key])) {
          if (one_map[key] !== two_map[key]) {
            return false;
          }
        } else if (!arraysEqual(one_map[key], two_map[key])) {
          return false;
        }

        checked[key] = true;
      }
    }

    for (key in two_map) {
      if (hasOwn.call(two_map, key)) {
        if (!checked[key]) {
          // two contains a parameter not present in one
          return false;
        }
      }
    }

    return true;
  };

  // state
  p.preventInvalidHostname = function(v) {
    this._parts.preventInvalidHostname = !!v;
    return this;
  };

  p.duplicateQueryParameters = function(v) {
    this._parts.duplicateQueryParameters = !!v;
    return this;
  };

  p.escapeQuerySpace = function(v) {
    this._parts.escapeQuerySpace = !!v;
    return this;
  };

  return URI;
}));


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.collectCustomFieldValues = collectCustomFieldValues;

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _ClassicBridge = __webpack_require__(18);

var _ClassicBridge2 = _interopRequireDefault(_ClassicBridge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function collectCustomFieldValues(target) {
    return _underscore2.default.pick(target, function (value, key) {
        return _ClassicBridge2.default.isCustomField(key);
    });
}

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _EntityStore2 = __webpack_require__(450);

var _EntityStore3 = _interopRequireDefault(_EntityStore2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EntityWithIdStore = function (_EntityStore) {
    _inherits(EntityWithIdStore, _EntityStore);

    function EntityWithIdStore() {
        _classCallCheck(this, EntityWithIdStore);

        return _possibleConstructorReturn(this, (EntityWithIdStore.__proto__ || Object.getPrototypeOf(EntityWithIdStore)).apply(this, arguments));
    }

    _createClass(EntityWithIdStore, [{
        key: "getEntityId",
        value: function getEntityId(entity) {
            return entity.id;
        }
    }]);

    return EntityWithIdStore;
}(_EntityStore3.default);

exports.default = EntityWithIdStore;

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = RegExpSpecialSymbols;
// TODO: export stuff separately
function RegExpSpecialSymbols() {}

RegExpSpecialSymbols.regexpSpecialSymbols = {
    '(': '\\(',
    ')': '\\)',
    ']': '\\]',
    '[': '\\[',
    '\\': '\\\\',
    '.': '\\.',
    '^': '\\^',
    '$': '\\$',
    '|': '\\|',
    '?': '\\?',
    '+': '\\+',
    '*': '\\*',
    '{': '\\{',
    ':': '\\:',
    '-': '\\-',
    '}': '\\}'
};

RegExpSpecialSymbols.replaceRegexpSpecialSymbol = function (s) {
    return RegExpSpecialSymbols.regexpSpecialSymbols[s] || s;
};

RegExpSpecialSymbols.escapeRegexpSpecialSymbols = function (s) {
    return s.replace(/[\(\)\]\[\\\.\^\$\|\?\+\*\{:\-\}]/g, RegExpSpecialSymbols.replaceRegexpSpecialSymbol);
};

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var LEFT_MIN_WIDTH = exports.LEFT_MIN_WIDTH = 360;
var RIGHT_MIN_WIDTH = exports.RIGHT_MIN_WIDTH = 900;
var CP_PANEL_INITIAL_WIDTH = exports.CP_PANEL_INITIAL_WIDTH = 400;

var TM_CP_PANEL_COLLAPSED_CUSTOMERS_SET_LS_KEY = exports.TM_CP_PANEL_COLLAPSED_CUSTOMERS_SET_LS_KEY = "cp_panel_collapsed_customers";
var TM_CP_PANEL_WIDTH_LS_KEY = exports.TM_CP_PANEL_WIDTH_LS_KEY = 'tm_cp_panel_width';

/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = function (_ref) {
    var _handlers;

    var _ref$actionTypes = _ref.actionTypes,
        PANEL_OPEN = _ref$actionTypes.PANEL_OPEN,
        PANEL_CLOSE = _ref$actionTypes.PANEL_CLOSE,
        LOADED_SET = _ref$actionTypes.LOADED_SET,
        LOADING_SET = _ref$actionTypes.LOADING_SET,
        USER_ID_SET = _ref$actionTypes.USER_ID_SET,
        PANEL_TAB_SET = _ref$actionTypes.PANEL_TAB_SET,
        TASK_IDS_SET = _ref$actionTypes.TASK_IDS_SET,
        PROJECT_IDS_SET = _ref$actionTypes.PROJECT_IDS_SET,
        CUSTOMER_IDS_SET = _ref$actionTypes.CUSTOMER_IDS_SET,
        MANAGE_TASK_IDS_SET = _ref$actionTypes.MANAGE_TASK_IDS_SET,
        MANAGE_PROJECT_IDS_SET = _ref$actionTypes.MANAGE_PROJECT_IDS_SET,
        MANAGE_EXCLUDING_SELF_PROJECT_IDS_SET = _ref$actionTypes.MANAGE_EXCLUDING_SELF_PROJECT_IDS_SET,
        MANAGE_CUSTOMER_IDS_SET = _ref$actionTypes.MANAGE_CUSTOMER_IDS_SET,
        MANAGE_EXCLUDING_SELF_CUSTOMER_IDS_SET = _ref$actionTypes.MANAGE_EXCLUDING_SELF_CUSTOMER_IDS_SET,
        TASK_TAB_LOADED = _ref$actionTypes.TASK_TAB_LOADED,
        PROJECT_TAB_LOADED = _ref$actionTypes.PROJECT_TAB_LOADED,
        CUSTOMER_TAB_LOADED = _ref$actionTypes.CUSTOMER_TAB_LOADED,
        USER_COUNTERS_SET = _ref$actionTypes.USER_COUNTERS_SET,
        PANEL_SEARCH_STRING_SET = _ref$actionTypes.PANEL_SEARCH_STRING_SET,
        PANEL_SEARCH_OPEN_SET = _ref$actionTypes.PANEL_SEARCH_OPEN_SET,
        SET_IS_SHOW_ARCHIVE_ENTITIES = _ref$actionTypes.SET_IS_SHOW_ARCHIVE_ENTITIES;

    return {
        initialState: {
            userId: null,
            tab: null,

            taskIds: [],
            projectIds: [],
            customerIds: [],

            manageCptIds: {
                customerIds: {},
                customerIdsExcludingSelf: {},
                projectIds: {},
                projectIdsExcludingSelf: {},
                taskIds: {}
            },

            isLoadedTaskTab: false,
            isLoadedProjectTab: false,
            isLoadedCustomerTab: false,

            userCounters: {
                customers: 0,
                projects: 0,
                tasks: 0
            },

            searchString: '',
            searchOpen: false,
            isShowArchivedEntities: false,

            loading: false,
            loaded: false
        },
        handlers: (_handlers = {}, _defineProperty(_handlers, PANEL_OPEN, function (state, _ref2) {
            var _ref2$payload = _ref2.payload,
                userId = _ref2$payload.userId,
                tab = _ref2$payload.tab;
            return _extends({}, state, {
                userId: userId,
                tab: tab,
                loaded: false,
                isLoadedCustomerTab: false,
                isLoadedProjectTab: false,
                isShowArchivedEntities: false,
                isLoadedTaskTab: false,
                searchString: null,
                searchOpen: false
            });
        }), _defineProperty(_handlers, PANEL_CLOSE, function (state) {
            return _extends({}, state, {
                userId: null,
                tab: null,
                loading: false,
                loaded: false,
                isLoadedCustomerTab: false,
                isLoadedProjectTab: false,
                isLoadedTaskTab: false,
                searchString: null,
                searchOpen: false
            });
        }), _defineProperty(_handlers, LOADED_SET, function (state, _ref3) {
            var loaded = _ref3.payload;
            return _extends({}, state, {
                loaded: loaded
            });
        }), _defineProperty(_handlers, LOADING_SET, function (state, _ref4) {
            var loading = _ref4.payload;
            return _extends({}, state, {
                loading: loading
            });
        }), _defineProperty(_handlers, USER_ID_SET, function (state, _ref5) {
            var userId = _ref5.payload;
            return _extends({}, state, {
                userId: userId
            });
        }), _defineProperty(_handlers, PANEL_TAB_SET, function (state, _ref6) {
            var tab = _ref6.payload;
            return _extends({}, state, {
                tab: tab,
                isShowArchivedEntities: false
            });
        }), _defineProperty(_handlers, TASK_IDS_SET, function (state, _ref7) {
            var taskIds = _ref7.payload;
            return _extends({}, state, {
                taskIds: taskIds
            });
        }), _defineProperty(_handlers, PROJECT_IDS_SET, function (state, _ref8) {
            var projectIds = _ref8.payload;
            return _extends({}, state, {
                projectIds: projectIds
            });
        }), _defineProperty(_handlers, CUSTOMER_IDS_SET, function (state, _ref9) {
            var customerIds = _ref9.payload;
            return _extends({}, state, {
                customerIds: customerIds
            });
        }), _defineProperty(_handlers, MANAGE_TASK_IDS_SET, function (state, _ref10) {
            var taskIds = _ref10.payload;
            return _extends({}, state, {
                manageCptIds: _extends({}, state.manageCptIds, { taskIds: taskIds })
            });
        }), _defineProperty(_handlers, MANAGE_PROJECT_IDS_SET, function (state, _ref11) {
            var projectIds = _ref11.payload;
            return _extends({}, state, {
                manageCptIds: _extends({}, state.manageCptIds, { projectIds: projectIds })
            });
        }), _defineProperty(_handlers, MANAGE_EXCLUDING_SELF_PROJECT_IDS_SET, function (state, _ref12) {
            var projectIdsExcludingSelf = _ref12.payload;
            return _extends({}, state, {
                manageCptIds: _extends({}, state.manageCptIds, { projectIdsExcludingSelf: projectIdsExcludingSelf })
            });
        }), _defineProperty(_handlers, MANAGE_CUSTOMER_IDS_SET, function (state, _ref13) {
            var customerIds = _ref13.payload;
            return _extends({}, state, {
                manageCptIds: _extends({}, state.manageCptIds, { customerIds: customerIds })
            });
        }), _defineProperty(_handlers, MANAGE_EXCLUDING_SELF_CUSTOMER_IDS_SET, function (state, _ref14) {
            var customerIdsExcludingSelf = _ref14.payload;
            return _extends({}, state, {
                manageCptIds: _extends({}, state.manageCptIds, { customerIdsExcludingSelf: customerIdsExcludingSelf })
            });
        }), _defineProperty(_handlers, TASK_TAB_LOADED, function (state, _ref15) {
            var loaded = _ref15.payload;
            return _extends({}, state, {
                isLoadedTaskTab: loaded
            });
        }), _defineProperty(_handlers, PROJECT_TAB_LOADED, function (state, _ref16) {
            var loaded = _ref16.payload;
            return _extends({}, state, {
                isLoadedProjectTab: loaded
            });
        }), _defineProperty(_handlers, CUSTOMER_TAB_LOADED, function (state, _ref17) {
            var loaded = _ref17.payload;
            return _extends({}, state, {
                isLoadedCustomerTab: loaded
            });
        }), _defineProperty(_handlers, USER_COUNTERS_SET, function (state, _ref18) {
            var userCounters = _ref18.payload;
            return _extends({}, state, {
                userCounters: userCounters
            });
        }), _defineProperty(_handlers, PANEL_SEARCH_STRING_SET, function (state, _ref19) {
            var text = _ref19.payload;
            return _extends({}, state, {
                searchString: text
            });
        }), _defineProperty(_handlers, PANEL_SEARCH_OPEN_SET, function (state, _ref20) {
            var open = _ref20.payload;
            return _extends({}, state, {
                searchOpen: open
            });
        }), _defineProperty(_handlers, EntitiesActionTypes.CUSTOMERS_REMOVE, function (state, _ref21) {
            var customerIds = _ref21.payload;
            return _extends({}, state, {
                customerIds: state.customerIds.filter(function (tId) {
                    return !(0, _atUtils.arrayToSet)(customerIds)[tId];
                }),
                manageCptIds: _extends({}, state.manageCptIds, {
                    customerIds: (0, _atUtils.filterMapByKeys)(state.manageCptIds.customerIds, customerIds),
                    customerIdsExcludingSelf: (0, _atUtils.filterMapByKeys)(state.manageCptIds.customerIdsExcludingSelf, customerIds)
                })
            });
        }), _defineProperty(_handlers, EntitiesActionTypes.PROJECTS_REMOVE, function (state, _ref22) {
            var projectIds = _ref22.payload;
            return _extends({}, state, {
                projectIds: state.projectIds.filter(function (tId) {
                    return !(0, _atUtils.arrayToSet)(projectIds)[tId];
                }),
                manageCptIds: _extends({}, state.manageCptIds, {
                    projectIds: (0, _atUtils.filterMapByKeys)(state.manageCptIds.projectIds, projectIds),
                    projectIdsExcludingSelf: (0, _atUtils.filterMapByKeys)(state.manageCptIds.projectIdsExcludingSelf, projectIds)
                })
            });
        }), _defineProperty(_handlers, EntitiesActionTypes.TASKS_REMOVE, function (state, _ref23) {
            var taskIds = _ref23.payload;
            return _extends({}, state, {
                taskIds: state.taskIds.filter(function (tId) {
                    return !(0, _atUtils.arrayToSet)(taskIds)[tId];
                }),
                manageCptIds: _extends({}, state.manageCptIds, {
                    taskIds: (0, _atUtils.filterMapByKeys)(state.manageCptIds.taskIds, taskIds)
                })
            });
        }), _defineProperty(_handlers, SET_IS_SHOW_ARCHIVE_ENTITIES, function (state, _ref24) {
            var value = _ref24.payload;
            return _extends({}, state, {
                isShowArchivedEntities: value
            });
        }), _defineProperty(_handlers, _actionTypes2.CLOSE_ALL_PANELS, function (state) {
            return _extends({}, state, {
                userId: null,
                tab: null,

                taskIds: [],
                projectIds: [],
                customerIds: [],

                manageCptIds: {
                    customerIds: {},
                    customerIdsExcludingSelf: {},
                    projectIds: {},
                    projectIdsExcludingSelf: {},
                    taskIds: {}
                },

                isLoadedTaskTab: false,
                isLoadedProjectTab: false,
                isLoadedCustomerTab: false,

                userCounters: {
                    customers: 0,
                    projects: 0,
                    tasks: 0
                },

                isShowArchivedEntities: false,

                loading: false,
                loaded: false,
                searchString: null,
                searchOpen: false
            });
        }), _handlers)
    };
};

var _atUtils = __webpack_require__(5);

var _actionTypes = __webpack_require__(102);

var EntitiesActionTypes = _interopRequireWildcard(_actionTypes);

var _actionTypes2 = __webpack_require__(104);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _TemplateView = __webpack_require__(1);

var _TemplateView2 = _interopRequireDefault(_TemplateView);

var _ScrollUtils = __webpack_require__(39);

var _ScrollUtils2 = _interopRequireDefault(_ScrollUtils);

var _atBrowserUtils = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ScrollView($containerEl, itemHeight) {
    _TemplateView2.default.call(this, $containerEl);
    this.itemHeight = itemHeight;
}

ScrollView.SHOW_EXTRA = 5;

ScrollView.prototype = _underscore2.default.create(_TemplateView2.default.prototype, {
    html: "<div class='scrollView scrollableContainer'>" + "  <div class='innerContainer'>" + "    <div class='placeholder top'></div>" + "    <div class='itemsContainer'></div>" + "    <div class='placeholder bottom'></div>" + "  </div>" + "</div>",

    afterRender: function afterRender() {
        var self = this;
        this.items = [];
        this._lastStartIndex = -1;
        this._lastEndIndex = -1;
        this._height = this.$el.height();

        this.$topPlaceholder = this.find(".placeholder.top");
        this.$bottomPlaceholder = this.find(".placeholder.bottom");
        this.$itemsContainer = this.find(".itemsContainer");

        this.verticalScroll = _ScrollUtils2.default.addVerticalScroll(this.$el, { probeType: 2 });
        if (!(0, _atBrowserUtils.isIE8)()) {
            this.verticalScroll.on("scroll", function () {
                self.updateScrollPosition();
                self.update();
                self.onScroll();
            });
        } else {
            this.$el.scroll(function () {
                self._scrollPosition = self.$el.scrollTop();
                self._maxScrollPosition = self.$el[0].scrollHeight;
                self.update();
            });
        }

        (0, _atBrowserUtils.fixIScrollInnerWheelEvent)(this.getEl());
    },

    update: function update() {
        var position = this._scrollPosition || 0;
        var itemHeight = this.itemHeight;
        var showCount = Math.ceil(this._height / itemHeight);
        var margin = ScrollView.SHOW_EXTRA;

        var startIndexWithoutMargin = Math.floor(position / itemHeight);
        var visibleEndIndex = Math.floor((position + this._height) / itemHeight);
        if (visibleEndIndex > this.items.length - 1) visibleEndIndex = this.items.length - 1;
        var endIndexWithoutMargin = startIndexWithoutMargin + showCount;
        if (endIndexWithoutMargin > this.items.length - 1) endIndexWithoutMargin = this.items.length - 1;

        if (this._updatedOnce && startIndexWithoutMargin >= this._lastStartIndex && visibleEndIndex <= this._lastEndIndex) return;

        this._updatedOnce = true;

        var startIndex = startIndexWithoutMargin - margin;
        if (startIndex < 0) startIndex = 0;
        if (startIndex > this.items.length - 1) startIndex = this.items.length - 1;
        var endIndex = endIndexWithoutMargin + margin;
        if (endIndex > this.items.length - 1) endIndex = this.items.length - 1;

        var topHeight = startIndex * itemHeight;
        var bottomHeight = (this.items.length - endIndex - 1) * itemHeight;

        this.$topPlaceholder.height(topHeight);
        this.$bottomPlaceholder.height(bottomHeight > 0 ? bottomHeight : 0);

        this.$itemsContainer.empty();
        for (var i = startIndex; i <= endIndex && i >= 0; i++) {
            this.items[i].init(this.$itemsContainer);
        }this._lastStartIndex = startIndex;
        this._lastEndIndex = endIndex;
    },

    getItems: function getItems() {
        return this.items;
    },

    setItems: function setItems(items) {
        this._updatedOnce = false;
        this.items = items;

        // TODO: make more optimal update here, full update happens twice
        this.update();
        this.refreshScroll();
    },

    scrollTo: function scrollTo(y) {
        if (y < 0) y = 0;
        if (y > this._maxScrollPosition) y = this._maxScrollPosition;

        if (!(0, _atBrowserUtils.isIE8)()) this.verticalScroll.scrollTo(0, -y);
        this._scrollPosition = y;
        this.update();
    },

    scrollToTop: function scrollToTop() {
        this.scrollTo(0);
    },

    scrollToItem: function scrollToItem(item) {
        var index = this.items.indexOf(item);
        if (index >= 0) {
            index -= ScrollView.SHOW_EXTRA - 1;
            this.scrollTo(this.itemHeight * index);
        }
    },

    refreshScroll: function refreshScroll() {
        this._height = this.$el.height();
        _ScrollUtils2.default.refreshCustomScroll(this.verticalScroll);
        this.updateScrollPosition();
        this.update();
    },

    updateScrollPosition: function updateScrollPosition() {
        if (!(0, _atBrowserUtils.isIE8)()) {
            this._scrollPosition = -this.verticalScroll.y;
            this._maxScrollPosition = -this.verticalScroll.maxScrollY;
        }
    },

    adjustHeightToWindowSize: function adjustHeightToWindowSize() {
        this.$el.adjustHeightToWindowSize();
        this.refreshScroll();
    },

    onScroll: function onScroll(position, maxPosition) {
        // Abstract
    },

    isEmpty: function isEmpty() {
        return this.items.length === 0;
    }
});

exports.default = ScrollView;

/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _HierarchySelectorNodeRenderer = __webpack_require__(462);

var _HierarchySelectorNodeRenderer2 = _interopRequireDefault(_HierarchySelectorNodeRenderer);

var _atBrowserUtils = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SimpleCheckboxNodeRenderer = function (_HierarchySelectorNod) {
    _inherits(SimpleCheckboxNodeRenderer, _HierarchySelectorNod);

    function SimpleCheckboxNodeRenderer(tree, selectorFilter, selectionHelper) {
        _classCallCheck(this, SimpleCheckboxNodeRenderer);

        var _this = _possibleConstructorReturn(this, (SimpleCheckboxNodeRenderer.__proto__ || Object.getPrototypeOf(SimpleCheckboxNodeRenderer)).call(this, tree, selectorFilter));

        _this.selectionHelper = selectionHelper;
        return _this;
    }

    _createClass(SimpleCheckboxNodeRenderer, [{
        key: "getSpecificNodeClassName",
        value: function getSpecificNodeClassName() {
            return "simpleCheckboxNode";
        }
    }, {
        key: "showNodeTooltip",
        value: function showNodeTooltip(tooltip, event) {
            tooltip.show();

            var tooltipInnerWidth = tooltip.width() + 1;
            tooltip.css("width", tooltipInnerWidth);

            var tooltipHeight = tooltip.outerHeight();
            var tooltipWidth = tooltip.outerWidth();

            var top = event.pageY + 13;
            if (top + tooltipHeight - (0, _atBrowserUtils.getBodyScrollTop)() > (0, _jquery2.default)(window).height()) top = event.pageY - 13 - tooltipHeight;
            var left = event.pageX + 15;
            if (left + tooltipWidth - (0, _atBrowserUtils.getBodyScrollLeft)() > (0, _jquery2.default)(window).width()) left = event.pageX - tooltipWidth - 15;

            tooltip.offset({ top: top, left: left });
        }
    }, {
        key: "hideNodeTooltip",
        value: function hideNodeTooltip(tooltip) {
            tooltip.hide();

            tooltip.css("width", "");
            tooltip.css("top", "");
            tooltip.css("left", "");
        }
    }]);

    return SimpleCheckboxNodeRenderer;
}(_HierarchySelectorNodeRenderer2.default);

exports.default = SimpleCheckboxNodeRenderer;

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = FilterWordsField;

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _atBrowserUtils = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function FilterWordsField() {}

FilterWordsField.prototype.initAndRender = function (onChangeCallback, renderTo, placeHolderTextKey, clearCallback) {
    var self = this;
    this.callback = onChangeCallback;
    var innerTable = document.createElement("table");
    innerTable.className = "filterWordsField";
    innerTable.tabIndex = -1;
    var innerTBody = document.createElement("tbody");
    var innerTr = document.createElement("tr");
    var inputInnerTd = document.createElement("td");
    var input = document.createElement("input");
    input.type = "text";
    input.maxLength = 100;
    (0, _jquery2.default)(input).addClass("filterFieldInput");
    this.alwaysPaintFocusedBorder = false;
    this.showPlaceholder = false;
    if (placeHolderTextKey) {
        this.showPlaceholder = true;
        (0, _jquery2.default)(input).attr('placeholder', _messageResource2.default.getMessage(placeHolderTextKey));
        (0, _jquery2.default)(input).addClass('inputFieldWithPlaceholder');
        (0, _jquery2.default)(input).placeholder();
    }
    var clearTd = document.createElement("td");
    var clearDiv = document.createElement("div");
    clearTd.className = "clearFilterButton";

    innerTable.appendChild(innerTBody);
    innerTBody.appendChild(innerTr);
    innerTr.appendChild(inputInnerTd);
    innerTr.appendChild(clearTd);
    inputInnerTd.appendChild(input);
    clearTd.appendChild(clearDiv);

    this.inputElement = input;
    this.clearButton = clearDiv;
    this.element = innerTable;

    (0, _jquery2.default)(innerTable).focusin(function () {
        (0, _atBrowserUtils.addClass)(self.element, "inputFocused");
    });
    (0, _jquery2.default)(innerTable).focusout(function () {
        self._deactivateBorderFocus();
    });
    (0, _jquery2.default)(innerTable).click(function () {
        (0, _jquery2.default)(self.inputElement).focus();
        (0, _atBrowserUtils.addClass)(self.element, "inputFocused");
    });

    this.clearFn = function () {
        self.inputElement.value = "";
        (0, _atBrowserUtils.addClass)(self.clearButton, "inactiveButton");
        (0, _jquery2.default)(self.clearButton).off("click");
        if (clearCallback) clearCallback();
    };
    (0, _jquery2.default)(input).keyup(function (event) {
        onChangeCallback(event);
        if (self.inputElement.value != "") {
            if ((0, _atBrowserUtils.hasClass)(self.clearButton, "inactiveButton")) {
                (0, _atBrowserUtils.removeClass)(self.clearButton, "inactiveButton");
                (0, _jquery2.default)(self.clearButton).click(self.clearFn);
            }
        } else if (!(0, _atBrowserUtils.hasClass)(self.clearButton, "inactiveButton")) {
            (0, _atBrowserUtils.addClass)(self.clearButton, "inactiveButton");
            (0, _jquery2.default)(self.clearButton).off("click");
        }
    });

    // fix for bug 54142
    (0, _jquery2.default)(input).keydown(function (event) {
        event.stopPropagation();
    });
    (0, _jquery2.default)(input).keypress(function (event) {
        event.stopPropagation();
    });

    (0, _atBrowserUtils.addClass)(self.clearButton, "inactiveButton");

    if (renderTo) renderTo.appendChild(this.element);

    return this;
};

FilterWordsField.prototype.getElement = function () {
    return this.element;
};

FilterWordsField.prototype.getSearchString = function () {
    return this.getInputElementValue();
};

FilterWordsField.prototype.isInputFieldActive = function () {
    return (0, _jquery2.default)(this.inputElement).is(":focus") || this.getInputElementValue().length != 0;
};

FilterWordsField.prototype.getInputElementValue = function () {
    return this.showPlaceholder ? (0, _jquery2.default)(this.inputElement).pVal() : this.inputElement.value;
};

FilterWordsField.prototype.setInputValue = function (value) {
    this.inputElement.value = value;
    if (value) {
        (0, _jquery2.default)(this.clearButton).click(this.clearFn);
        (0, _atBrowserUtils.removeClass)(this.clearButton, "inactiveButton");
    } else {
        (0, _jquery2.default)(this.clearButton).off("click");
        (0, _atBrowserUtils.addClass)(this.clearButton, "inactiveButton");
    }
};

FilterWordsField.prototype.clearInputValue = function (useClearCallback) {
    this.setInputValue("");
    if (useClearCallback && this.clearFn) this.clearFn();
};

FilterWordsField.prototype.getInnerInputElement = function () {
    return this.inputElement;
};

FilterWordsField.prototype.activateAndFocus = function () {
    this.inputElement.focus();
};

FilterWordsField.prototype.alwaysPaintFocusedBorderIfInputHasValue = function (value) {
    this.alwaysPaintFocusedBorder = value;
};

FilterWordsField.prototype._deactivateBorderFocus = function () {
    if (!this.alwaysPaintFocusedBorder || !this.inputElement.value) (0, _atBrowserUtils.removeClass)(this.element, "inputFocused");
};

FilterWordsField.prototype.isInputFieldActive = function () {
    return (0, _jquery2.default)(this.inputElement).is(":focus") || this.getInputElementValue().length != 0;
};

FilterWordsField.prototype.focusOutFromInput = function () {
    (0, _jquery2.default)(this.inputElement).focusout();
};

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _BaseFieldsDrawer2 = __webpack_require__(466);

var _BaseFieldsDrawer3 = _interopRequireDefault(_BaseFieldsDrawer2);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _jquery_rpc = __webpack_require__(26);

var _jquery_rpc2 = _interopRequireDefault(_jquery_rpc);

var _constants = __webpack_require__(21);

var _atUtils = __webpack_require__(5);

var _atBrowserUtils = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UserNameDrawer = function (_BaseFieldsDrawer) {
    _inherits(UserNameDrawer, _BaseFieldsDrawer);

    function UserNameDrawer() {
        _classCallCheck(this, UserNameDrawer);

        return _possibleConstructorReturn(this, (UserNameDrawer.__proto__ || Object.getPrototypeOf(UserNameDrawer)).apply(this, arguments));
    }

    _createClass(UserNameDrawer, [{
        key: "init",
        value: function init(config) {
            _get(UserNameDrawer.prototype.__proto__ || Object.getPrototypeOf(UserNameDrawer.prototype), "init", this).call(this, config);
            this.disableValidation = config.disableValidation;
            this.disableDuplicateUsernameCheck = config.disableDuplicateUsernameCheck;
            this.disableEmptyUsernameCheck = config.disableEmptyUsernameCheck;
            return this;
        }
    }, {
        key: "initFields",
        value: function initFields(accountSettings) {
            var _this2 = this;

            this.usernameCheckRpcCall = null;
            this.usernameCheckTimeId = null;
            var self = this;
            this.usernameField = (0, _jquery2.default)(this.getElementByIdFunction("usernameField"));
            this.setValue(this.usernameField, "");
            this.usernameField.off();
            this.usernameField.placeholder();
            if (accountSettings.username) this.setValue(this.usernameField, accountSettings.username);
            var onUsernameFieldKeyUp = function onUsernameFieldKeyUp() {
                this.keyPressed = false;
                //noinspection JSPotentiallyInvalidUsageOfThis
                if (!this.prevValue && !!this.value || this.prevValue !== this.value) {
                    this.prevValue = this.value;
                    if (!self.disableValidation) {
                        self.errors[_constants.ValidationErrors.USERNAME_EMPTY] = !self.disableEmptyUsernameCheck && self.usernameField.pVal().length === 0;

                        if (!self.errors[_constants.ValidationErrors.USERNAME_EMPTY] && !self.disableDuplicateUsernameCheck) self._checkUsernameDuplicates(this.value, accountSettings.id);else {
                            self._cancelUsernameDuplicateCheck();
                            self.errors[_constants.ValidationErrors.USERNAME_DUPLICATE] = false;
                        }
                    }
                    self.changeDetectedFunction(true);
                    self.updateUICallback(self.errors);
                }
            };

            // see Bug 47490
            var onUsernameFieldBlur = function onUsernameFieldBlur() {
                self.usernameField.pVal((0, _atUtils.trim)(this.value));
                if (this.keyPressed || this.prevValue !== this.value) {
                    onUsernameFieldKeyUp.call(this);
                }
                // check field on read only state
                if (!self.usernameField[0].readOnly) {
                    self.usernameField.trigger('changed', [self.usernameField.pVal(), self.errors[_constants.ValidationErrors.USERNAME_DUPLICATE]]);
                }
            };

            var onUsernameFieldKeyDown = function onUsernameFieldKeyDown(e) {
                if ((0, _atBrowserUtils.isEscapePressed)(e) || (0, _atBrowserUtils.isEnterPressed)(e)) {
                    _this2.usernameField.blur();
                    e.stopPropagation();
                }
            };

            this.usernameField.blur(onUsernameFieldBlur);
            this.usernameField.keyup(onUsernameFieldKeyUp);
            this.usernameField.on("input", onUsernameFieldKeyUp);
            this.usernameField.keydown(onUsernameFieldKeyDown);

            (0, _jquery2.default)(this.getElementByIdFunction("usernameColumn")).show();
        }
    }, {
        key: "getObjectValues",
        value: function getObjectValues() {
            return {
                username: this.usernameField.pVal()
            };
        }
    }, {
        key: "_cancelUsernameDuplicateCheck",
        value: function _cancelUsernameDuplicateCheck() {
            clearTimeout(this.usernameCheckTimeId);
            if (this.usernameCheckRpcCall) this.usernameCheckRpcCall.abort();
            this.usernameCheckRpcCall = null;
        }
    }, {
        key: "cancelAllServerSideChecks",
        value: function cancelAllServerSideChecks() {
            this._cancelUsernameDuplicateCheck();
        }
    }, {
        key: "_checkUsernameDuplicates",
        value: function _checkUsernameDuplicates(username, id) {
            this._cancelUsernameDuplicateCheck();
            if (!username || !(0, _atUtils.isNotEmpty)(username)) {
                this._checkUsernameDuplicatesCallback(false);
            } else {
                var self = this;
                this.usernameCheckTimeId = setTimeout(function () {
                    self._doCheckUsernameDuplicatesRPCCall((0, _atUtils.trim)(username), id);
                }, 200);
            }
        }
    }, {
        key: "_doCheckUsernameDuplicatesRPCCall",
        value: function _doCheckUsernameDuplicatesRPCCall(username, id) {
            var self = this;
            this.usernameCheckRpcCall = (0, _jquery_rpc2.default)("UserManagementService.checkUsernameExists", [username, id], function (result) {
                self._checkUsernameDuplicatesCallback(result);
            }, this.checkUsernameErrorHandler);
        }
    }, {
        key: "_checkUsernameDuplicatesCallback",
        value: function _checkUsernameDuplicatesCallback(result) {
            if (result) {
                this.errors[_constants.ValidationErrors.USERNAME_EMPTY] = false;
            }
            this.errors[_constants.ValidationErrors.USERNAME_DUPLICATE] = result;
            this.validationDetectedCallback();
            this.updateUICallback(this.errors);
        }
    }, {
        key: "validateFields",
        value: function validateFields(oldErrors) {
            if (this.usernameField.pVal().length === 0) {
                this.errors[_constants.ValidationErrors.USERNAME_EMPTY] = true;
                this.errors[_constants.ValidationErrors.USERNAME_DUPLICATE] = false;
            } else this.errors[_constants.ValidationErrors.USERNAME_DUPLICATE] = oldErrors[_constants.ValidationErrors.USERNAME_DUPLICATE];
            return this.errors;
        }
    }, {
        key: "setDuplicateNameError",
        value: function setDuplicateNameError() {
            this.errors[_constants.ValidationErrors.USERNAME_EMPTY] = false;
            this.errors[_constants.ValidationErrors.USERNAME_DUPLICATE] = true;
            return this.errors;
        }
    }, {
        key: "hasErrors",
        value: function hasErrors() {
            return this.errors[_constants.ValidationErrors.USERNAME_EMPTY] || this.errors[_constants.ValidationErrors.USERNAME_DUPLICATE];
        }
    }]);

    return UserNameDrawer;
}(_BaseFieldsDrawer3.default);

exports.default = UserNameDrawer;

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _Ext = __webpack_require__(12);

var _Ext2 = _interopRequireDefault(_Ext);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _at_shared_user_button_menu = __webpack_require__(159);

var _at_shared_user_button_menu2 = _interopRequireDefault(_at_shared_user_button_menu);

var _CoarseSelection = __webpack_require__(284);

var _CoarseSelection2 = _interopRequireDefault(_CoarseSelection);

var _two_level_selection = __webpack_require__(70);

var _two_level_selection2 = _interopRequireDefault(_two_level_selection);

var _at_selector_panel_with_apply_button_object = __webpack_require__(231);

var _at_selector_panel_with_apply_button_object2 = _interopRequireDefault(_at_selector_panel_with_apply_button_object);

var _at_hierarchy_selector_dropdown_button = __webpack_require__(232);

var _at_hierarchy_selector_dropdown_button2 = _interopRequireDefault(_at_hierarchy_selector_dropdown_button);

var _dhtml_title = __webpack_require__(470);

var _dhtml_title2 = _interopRequireDefault(_dhtml_title);

var _at_customer_project_two_generic_options_panel = __webpack_require__(733);

var _at_customer_project_two_generic_options_panel2 = _interopRequireDefault(_at_customer_project_two_generic_options_panel);

var _constants = __webpack_require__(4);

var _atUtils = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CPReportSelector = function () {
    function CPReportSelector(panelConfig) {
        _classCallCheck(this, CPReportSelector);

        this.panelConfig = _underscore2.default.defaults(panelConfig || {}, {
            isCustomersProjectsFiltered: true,
            allActiveItemsOptionLabelKeyFiltered: "projects_customers_selector.report.all_active_projects_customers_filtered",
            allItemsOptionLabelKeyFiltered: "projects_customers_selector.report.all_projects_customers_filtered"
        });
    }

    /**
     * Init selector with report config where placed cpSelectorData (selected customer, projects, qualifier)
     * Create button and disable it while CPReportSelector.initializeData not performed
     * This code is modification of CPSelectorServerUtil and CPSelectorClientUtil classes
     * @returns {*}
     */


    _createClass(CPReportSelector, [{
        key: "init",
        value: function init(customersProjectsSelection, cpSelectorId, changedCallback, withApplyButton) {
            var _this = this;

            var firstOpenCallback = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : function () {};

            this.cpSelection = customersProjectsSelection;
            this.predefinedState = this._createPredefinedStateFromSelection(customersProjectsSelection);

            // init panel
            var panelConfig = _Ext2.default.apply(this.panelConfig, {});
            if (withApplyButton) _Ext2.default.apply(panelConfig, _at_selector_panel_with_apply_button_object2.default.getApplyButtonExtension(_at_customer_project_two_generic_options_panel2.default));
            this.panel = new _at_customer_project_two_generic_options_panel2.default(panelConfig);

            this.menu = new _at_shared_user_button_menu2.default({ panel: this.panel });
            // set handler for get predefined state
            this.panel.setGetPredefinedSelectionCallback(function () {
                return _this.predefinedState;
            });

            // override process without use ajax call ( some code copied from AT.HierarchicalSelectorPanel.processFirstPanelOpen)
            this.panel.processFirstPanelOpen = function () {
                _this.panel.treePanel = document.createElement("div");
                var treePanelClasses = _this.panel.getTreePanelClasses();
                treePanelClasses.push("spinnerPanel"); // spin while panel is not loaded
                _this.panel.treePanel.className = treePanelClasses.join(" ");
                var targetEl = _this.panel.detailsContainer.el.dom;
                var firstChild = targetEl.childNodes[0];
                if (firstChild) {
                    targetEl.insertBefore(_this.panel.treePanel, firstChild);
                } else {
                    targetEl.appendChild(_this.panel.treePanel);
                }
                _this.panel.initializeSelector(_this.preloadedData);
                firstOpenCallback();
            };
            this.wasChanged = false;
            var buttonConfig = {
                renderTo: cpSelectorId,
                labelCls: "hierarchySelectorButton",
                menu: this.menu,
                tooltipObject: new _dhtml_title2.default("form-field-tooltip")
            };
            // create drop down button
            this.button = this._createDropDownButton(buttonConfig);
            this._initDropDownButton(changedCallback);

            return this;
        }
    }, {
        key: "_createDropDownButton",
        value: function _createDropDownButton(buttonConfig) {
            return new _at_hierarchy_selector_dropdown_button2.default(buttonConfig);
        }
    }, {
        key: "_initDropDownButton",
        value: function _initDropDownButton(changedCallback) {
            // show message while data download
            this.button.setText(_messageResource2.default.getMessage('saved_reports.cp_selector.data_loading'));
            this.button.setTooltipEnabled(false);
            // of button while data not loaded
            this.button.setEnabled(false);
            var self = this;
            this.button.setMenuHideCallback(function () {
                if (changedCallback) {
                    self.wasChanged = false;
                    changedCallback();
                }
            });
        }
    }, {
        key: "getButton",
        value: function getButton() {
            return this.button;
        }
    }, {
        key: "_createPredefinedStateFromSelection",
        value: function _createPredefinedStateFromSelection(cpSelection) {
            return {
                selection: cpSelection.qualifier == _constants.CustomersProjectsSelectionQualifier.SELECTED ? new _two_level_selection2.default(cpSelection.customers, cpSelection.projects) : _two_level_selection2.default.emptySelection(),
                optionValue: cpSelection.qualifier == _constants.CustomersProjectsSelectionQualifier.SELECTED ? _CoarseSelection2.default.SPECIFIC : cpSelection.qualifier == _constants.CustomersProjectsSelectionQualifier.ALL ? _CoarseSelection2.default.ALL : _CoarseSelection2.default.ALL_ACTIVE,
                showInactive: cpSelection.showArchivedProjects,
                manageScopeOnly: cpSelection.includeOnlyManagementScope
            };
        }
    }, {
        key: "setWasChanged",
        value: function setWasChanged() {
            this.wasChanged = true;
        }

        /**
         * Use this method while data load from server is performed
         * Activate button and set correct label
         * @param customersProjects CPList from server
         * @param customersWithMaIds array of customers ids user has another MA inside
         * @param projectsWithMaIds array of projects ids user has another MA inside
         */

    }, {
        key: "initializeData",
        value: function initializeData(customersProjects, customersWithMaIds, projectsWithMaIds) {
            this.preloadedData = customersProjects;

            if (projectsWithMaIds) {
                this.preloadedData.entirelyManageable = this.preloadedData.projects.length === projectsWithMaIds.length;
                this.preloadedData.manageable = projectsWithMaIds.length > 0;

                var projectWithMASet = (0, _atUtils.arrayToSet)(projectsWithMaIds);
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = this.preloadedData.projects[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var project = _step.value;

                        if (projectWithMASet[project.id]) {
                            project.fromManagementScope = true;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }

            // remove selection c&p that were deleted
            this._removeDeletedCPFromSelection(customersProjects, this.cpSelection);
            // set text when data is loaded
            this.button.setText(this._makePredefinedSelection(customersProjects));
            this.button.setEnabled(true);
        }
    }, {
        key: "_removeDeletedCPFromSelection",
        value: function _removeDeletedCPFromSelection(cpData, cpSelection) {
            var selectedCustomers = cpSelection.customers;
            var availableCustomersMap = {};
            for (var i = 0; i < cpData.customers.length; i++) {
                availableCustomersMap[cpData.customers[i].id] = true;
            }

            var selectedProjects = cpSelection.projects;
            var availableProjectsMap = {};
            for (i = 0; i < cpData.projects.length; i++) {
                availableProjectsMap[cpData.projects[i].id] = true;
            }

            // remove not exists selection
            for (i = selectedProjects.length - 1; i >= 0; i--) {
                if (!availableProjectsMap[selectedProjects[i]]) {
                    selectedProjects.splice(i, 1);
                }
            }
            for (i = selectedCustomers.length; i >= 0; i--) {
                if (!availableCustomersMap[selectedCustomers[i]]) {
                    selectedCustomers.splice(i, 1);
                }
            }
        }

        /**
         * Create string for text in button
         * @returns {*} text of label
         * @private
         */

    }, {
        key: "_makePredefinedSelection",
        value: function _makePredefinedSelection(customersProjects) {
            var state = this.predefinedState;
            if (state.optionValue === _CoarseSelection2.default.SPECIFIC) {
                var selectedCustomers = [].concat(_toConsumableArray(state.selection.getFirstLevel()));
                var selectedProjects = [].concat(_toConsumableArray(state.selection.getSecondLevel()));

                if (this.cpSelection.includeOnlyManagementScope) {
                    var selectedCustomersSet = (0, _atUtils.arrayToSet)(selectedCustomers);
                    var selectedProjectsSet = (0, _atUtils.arrayToSet)(selectedProjects);
                    selectedProjects = [];
                    customersProjects.projects.forEach(function (project) {
                        if ((selectedProjectsSet[project.id] || selectedCustomersSet[project.customerId]) && project.fromManagementScope) {
                            selectedProjects.push(project);
                        }
                    });
                    return this.panel.getSelectionHelper().getShortDescriptionForCustomersAndProjects([], selectedProjects, undefined);
                } else if (selectedCustomers.length + selectedProjects.length === 1) {
                    if (selectedCustomers.length === 1) {
                        // get data of selected customer
                        selectedCustomers[0] = _jquery2.default.map(customersProjects.customers, function (n) {
                            if (n.id === selectedCustomers[0]) {
                                return n;
                            }
                        })[0];
                    } else {
                        // get data of selected prj
                        selectedProjects[0] = _jquery2.default.map(customersProjects.projects, function (n) {
                            if (n.id === selectedProjects[0]) {
                                return n;
                            }
                        })[0];
                    }
                }

                return this.panel.getSelectionHelper().getDescription(new _two_level_selection2.default(selectedCustomers, selectedProjects), undefined, state.showInactive);
            } else if (state.optionValue === _CoarseSelection2.default.ALL) {
                return this.panel.getAllSelectedMessage();
            } else {
                return this.panel.getAllActiveItemsMessage();
            }
        }

        /**
         * Return false if there no one selection or true otherwise
         * @returns {boolean}
         */

    }, {
        key: "checkSelected",
        value: function checkSelected() {
            var isAllPredefined = this.predefinedState.optionValue == _CoarseSelection2.default.ALL_ACTIVE || this.predefinedState.optionValue == _CoarseSelection2.default.ALL;
            return !(this.panel.isAlreadyShown() && this.panel.isCustomOptionSelected() && this.panel.isEmptySelection() || !this.panel.isAlreadyShown() && this.predefinedState.selection.isEmpty() && !isAllPredefined);
        }

        /**
         * Save selected c&p in report config
         *
         */

    }, {
        key: "getCpSelection",
        value: function getCpSelection() {
            // if panel not shown do not read values from panel
            if (!this.panel.isAlreadyShown()) {
                return this.cpSelection;
            } else {
                var selection = this.panel.getSelection(false);
                // update predefined state
                return {
                    customers: selection.getFirstLevel(),
                    projects: selection.getSecondLevel(),
                    qualifier: this.panel.isCustomOptionSelected() ? _constants.CustomersProjectsSelectionQualifier.SELECTED : this.panel.isAllItemsOptionSelected() ? _constants.CustomersProjectsSelectionQualifier.ALL : _constants.CustomersProjectsSelectionQualifier.ALL_ACTIVE,
                    showArchivedProjects: this.panel.getShowInactive(),
                    includeOnlyManagementScope: this.panel.isShowOnlyManagementScope()
                };
            }
        }
    }, {
        key: "setInitialValueFromCurrent",
        value: function setInitialValueFromCurrent() {
            // only if panel already shown
            if (this.panel.isAlreadyShown()) {
                var selection = this.panel.getSelection(false);
                var predefinedState = {
                    selection: this.panel.isCustomOptionSelected() ? new _two_level_selection2.default(selection.getFirstLevel(), selection.getSecondLevel()) : _two_level_selection2.default.emptySelection(),
                    optionValue: this.panel.isCustomOptionSelected() ? _CoarseSelection2.default.SPECIFIC : this.panel.isAllItemsOptionSelected() ? _CoarseSelection2.default.ALL : _CoarseSelection2.default.ALL_ACTIVE,
                    showInactive: this.panel.getShowInactive(),
                    manageScopeOnly: this.panel.isShowOnlyManagementScope()
                };
                this.panel.setPredefinedParameters(predefinedState);
                this.panel.loadState(predefinedState);
            }
        }

        /**
         * Set selection from customersProjectsSelection
         * Method sets new initial values of selector
         * @param customersProjectsSelection
         */

    }, {
        key: "setSelection",
        value: function setSelection(customersProjectsSelection) {
            this.predefinedState = this._createPredefinedStateFromSelection(customersProjectsSelection);
            // only if panel already shown
            if (this.panel.isAlreadyShown()) {
                this.panel.loadState(this.predefinedState);
                this.panel.setPredefinedParameters(this.predefinedState);
                this.panel.resetState(true);
            } else {
                // need to update text label on button if c/p data is loaded from server and panel not show
                if (this.preloadedData) {
                    this.button.setText(this._makePredefinedSelection(this.preloadedData));
                }
            }
        }
    }, {
        key: "resetSelection",
        value: function resetSelection() {
            // if panel is shown
            if (this.panel.isAlreadyShown()) {
                this.panel.resetState(true);
            }
        }
    }, {
        key: "isStateChanged",
        value: function isStateChanged() {
            return this.panel.isStateChanged();
        }
    }, {
        key: "saveState",
        value: function saveState() {
            var cpSelection = this.getCpSelection();
            var predefinedState = this._createPredefinedStateFromSelection(cpSelection);
            this.panel.setPredefinedParameters(predefinedState);
            this.panel.loadState(predefinedState);
        }
    }]);

    return CPReportSelector;
}();

exports.default = CPReportSelector;

/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Ext = __webpack_require__(12);

var _Ext2 = _interopRequireDefault(_Ext);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * "Flat" button implementation, rendered as an anchor tag with text inside and an icon image in the background.
 *
 * @cfg {String} text button text.
 * @cfg {String} icon icon image URL.
 */
var FlatButton = _Ext2.default.extend(_Ext2.default.Button, {
    overCls: 'hover',
    buttonSelector: "a:first",
    cls: "at-flat-button",
    icon: "",
    text: "",

    initComponent: function initComponent() {
        FlatButton.superclass.initComponent.call(this);
        this.template = new _Ext2.default.Template('<div><a><span>{0}</span></a></div>');
    }
});

_Ext2.default.reg('at_flat_button', FlatButton);

exports.default = FlatButton;

/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _HierarchySelectorNodeRenderer = __webpack_require__(462);

var _HierarchySelectorNodeRenderer2 = _interopRequireDefault(_HierarchySelectorNodeRenderer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ExpandCollapseNodeRenderer = function (_HierarchySelectorNod) {
    _inherits(ExpandCollapseNodeRenderer, _HierarchySelectorNod);

    function ExpandCollapseNodeRenderer(tree, selectorFilter, expandCollapseCallback) {
        _classCallCheck(this, ExpandCollapseNodeRenderer);

        var _this = _possibleConstructorReturn(this, (ExpandCollapseNodeRenderer.__proto__ || Object.getPrototypeOf(ExpandCollapseNodeRenderer)).call(this, tree, selectorFilter));

        _this.expandCollapseCallback = expandCollapseCallback;
        return _this;
    }

    _createClass(ExpandCollapseNodeRenderer, [{
        key: "generateContent",
        value: function generateContent(treeNode, targetEl) {
            var tableEl = document.createElement("table");
            var tBodyEl = document.createElement("tbody");
            var trEl = document.createElement("tr");
            var checkboxTdEl = document.createElement("td");
            var collapseTdEl = document.createElement("td");

            //visibility of this buttons are maintained by css
            var normalExpandCollapseButton = this.generateExpandCollapseButton(treeNode, true, "normalExpandCollapseButton", null);
            var disabledExpandCollapseButtonWithTitle = this.generateExpandCollapseButton(treeNode, false, "disabledExpandCollapseButtonWithTitle", this.getExpandCollapseButtonTitle(treeNode));
            var disabledExpandCollapseButtonWithoutTitle = this.generateExpandCollapseButton(treeNode, false, "disabledExpandCollapseButtonWithoutTitle", null);

            tableEl.appendChild(tBodyEl);
            tBodyEl.appendChild(trEl);
            trEl.appendChild(checkboxTdEl);
            trEl.appendChild(collapseTdEl);
            collapseTdEl.appendChild(normalExpandCollapseButton);
            collapseTdEl.appendChild(disabledExpandCollapseButtonWithTitle);
            collapseTdEl.appendChild(disabledExpandCollapseButtonWithoutTitle);

            var spacerDiv = document.createElement("div");
            spacerDiv.className = "spacer";
            spacerDiv.innerHTML = "<b></b>"; // for IE to display correctly

            targetEl.appendChild(tableEl);
            targetEl.appendChild(spacerDiv);

            _get(ExpandCollapseNodeRenderer.prototype.__proto__ || Object.getPrototypeOf(ExpandCollapseNodeRenderer.prototype), "generateContent", this).call(this, treeNode, checkboxTdEl);
        }
    }, {
        key: "generateExpandCollapseButton",
        value: function generateExpandCollapseButton(treeNode, withOnClick, additionalClass, title) {
            var expandCollapseBtn = document.createElement("div");
            expandCollapseBtn.className = "collapseButton " + additionalClass;
            var context = this;
            expandCollapseBtn.onclick = withOnClick ? function () {
                context.expandCollapseCallback(function () {
                    var expandController = context.tree.getExpandController();
                    if (expandController.isCollapsed(treeNode)) expandController.expandAndScrollIfNeeded(treeNode);else expandController.collapse(treeNode);
                    //Fix bug for IE ( :active style doesn't disappear after click )
                    expandCollapseBtn.blur();
                });
            } : function () {};
            if (title) {
                expandCollapseBtn.title = title;
            }
            return expandCollapseBtn;
        }
    }, {
        key: "getExpandCollapseButtonTitle",
        value: function getExpandCollapseButtonTitle(treeNode) {
            if (this.tree.hasActiveFilter() && !this.tree.getActiveFilter().hasKeywordFilter() && !this.tree.doesContainChildrenMatchingFilterCriteria(treeNode)) {
                return this.getEmptyEntityTooltip();
            }
            return null;
        }
    }, {
        key: "generateLabel",
        value: function generateLabel(treeNode, labelEl) {
            var name = treeNode.getValue().name;
            labelEl.innerHTML = this.selectorFilter.highlightTokens(name);
            labelEl.title = this.getTitle(treeNode.getValue());
        }
    }, {
        key: "getSpecificNodeClassName",
        value: function getSpecificNodeClassName() {
            return "expandCollapseNode";
        }
    }, {
        key: "getEmptyEntityTooltip",
        value: function getEmptyEntityTooltip() {
            //abstract
        }
    }, {
        key: "getTitle",
        value: function getTitle(entity) {
            return entity.name;
        }
    }]);

    return ExpandCollapseNodeRenderer;
}(_HierarchySelectorNodeRenderer2.default);

exports.default = ExpandCollapseNodeRenderer;

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _SimpleCheckboxNodeRenderer = __webpack_require__(347);

var _SimpleCheckboxNodeRenderer2 = _interopRequireDefault(_SimpleCheckboxNodeRenderer);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _atUtils = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DisabledNodesParentNodeRenderer = function (_SimpleCheckboxNodeRe) {
    _inherits(DisabledNodesParentNodeRenderer, _SimpleCheckboxNodeRe);

    function DisabledNodesParentNodeRenderer(tree, selectorFilter, selectionHelper) {
        _classCallCheck(this, DisabledNodesParentNodeRenderer);

        return _possibleConstructorReturn(this, (DisabledNodesParentNodeRenderer.__proto__ || Object.getPrototypeOf(DisabledNodesParentNodeRenderer)).call(this, tree, selectorFilter, selectionHelper));
    }

    _createClass(DisabledNodesParentNodeRenderer, [{
        key: "generateLabel",
        value: function generateLabel(treeNode, labelEl) {
            var text = _messageResource2.default.getMessage(this.labelMessageKey(), [this.labelCounterValue(treeNode)]);
            labelEl.innerHTML = (0, _atUtils.escapeHtmlSymbols)(text);
            labelEl.title = text;
        }
    }, {
        key: "labelMessageKey",
        value: function labelMessageKey() {
            // Abstract
        }
    }, {
        key: "labelCounterValue",
        value: function labelCounterValue(treeNode) {
            if (this.tree.hasActiveFilter()) {
                var result = 0;
                _underscore2.default.each(treeNode.getChildren(), function (childNode) {
                    if (this.tree.doesMatchFilterCriteria(childNode) || this.tree.doesContainChildrenMatchingFilterCriteria(childNode)) result++;
                }, this);
                return result;
            } else {
                return treeNode.getChildren().length;
            }
        }
    }, {
        key: "getNodeClasses",
        value: function getNodeClasses(treeNode) {
            var classes = _get(DisabledNodesParentNodeRenderer.prototype.__proto__ || Object.getPrototypeOf(DisabledNodesParentNodeRenderer.prototype), "getNodeClasses", this).call(this, treeNode);
            classes.push("disabledNodesParent");
            if (this.tree.hasActiveFilter() && !this.tree.doesContainChildrenMatchingFilterCriteria(treeNode)) classes.push("emptyDisabledNodesParent");
            return classes;
        }
    }]);

    return DisabledNodesParentNodeRenderer;
}(_SimpleCheckboxNodeRenderer2.default);

exports.default = DisabledNodesParentNodeRenderer;

/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TreeNode2 = __webpack_require__(60);

var _TreeNode3 = _interopRequireDefault(_TreeNode2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TreeRootNode = function (_TreeNode) {
    _inherits(TreeRootNode, _TreeNode);

    function TreeRootNode() {
        _classCallCheck(this, TreeRootNode);

        var _this = _possibleConstructorReturn(this, (TreeRootNode.__proto__ || Object.getPrototypeOf(TreeRootNode)).call(this));

        _this.idMap = {};
        return _this;
    }

    _createClass(TreeRootNode, [{
        key: "getParent",
        value: function getParent() {
            return null;
        }
    }, {
        key: "setParent",
        value: function setParent() {}
    }, {
        key: "getRoot",
        value: function getRoot() {
            return this;
        }
    }, {
        key: "getNodeById",
        value: function getNodeById(id) {
            return this.idMap[id];
        }
    }, {
        key: "_childAdded",
        value: function _childAdded(treeNode) {
            this.idMap[treeNode.getId()] = treeNode;
        }
    }]);

    return TreeRootNode;
}(_TreeNode3.default);

exports.default = TreeRootNode;

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = TimeZonesSelector;

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _TableTooltip = __webpack_require__(237);

var _TableTooltip2 = _interopRequireDefault(_TableTooltip);

var _CitiesSearchController = __webpack_require__(1315);

var _CitiesSearchController2 = _interopRequireDefault(_CitiesSearchController);

var _SpinnerController = __webpack_require__(69);

var _SpinnerController2 = _interopRequireDefault(_SpinnerController);

var _spin = __webpack_require__(93);

var _spin2 = _interopRequireDefault(_spin);

var _jquery_rpc = __webpack_require__(26);

var _jquery_rpc2 = _interopRequireDefault(_jquery_rpc);

var _keyCodes = __webpack_require__(66);

var _atUtils = __webpack_require__(5);

var _atBrowserUtils = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function TimeZonesSelector() {}

TimeZonesSelector.prototype.init = function ($container, initCity, onChangeCallback, emptySelectionMessage, isShowSearchResultsToTop, additionalClasses, preventDefaultTabMoving) {

    var self = this;

    this.onChangeCallback = onChangeCallback;

    this.initialCity = initCity; // save initial value
    this.currentCity = initCity;

    this.selectorContainer = $container;
    this.selectorContainer.addClass("timeZonesSelector");

    this.selectedTZInfoContainer = (0, _jquery2.default)("<div class='selectedTimeZone'></div>");
    this.selectorContainer.append(this.selectedTZInfoContainer);

    this.searchField = (0, _jquery2.default)("<input type='text' maxlength='250' class='timeZonesSearchField'/>");
    this.selectorContainer.append(this.searchField);

    var tooltipId = "timeZoneSelectorTooltip";
    this.tooltipElement = _jquery2.default.find("#" + tooltipId);
    if (this.tooltipElement.length == 0) {
        this.tooltipElement = (0, _jquery2.default)("<div id='" + tooltipId + "' class='timeZoneSelectorTooltip yellowTooltip'></div>").hide();
        (0, _jquery2.default)("body").append(this.tooltipElement); //append to body
    } else {
        this.tooltipElement = (0, _jquery2.default)(this.tooltipElement[0]);
    }

    this.isNeedToShowTooltip = false;

    this.tooltip = new _TableTooltip2.default().init(tooltipId);
    this.selectedTZInfoContainer.on("mouseover", function () {
        if (self.isNeedToShowTooltip) {
            self.tooltip.show();
        }
    });
    this.selectedTZInfoContainer.on("mousemove", function (event) {
        self.tooltip.move((0, _atBrowserUtils.calculateTooltipOffset)(self.tooltip, event));
    });
    this.selectedTZInfoContainer.on("mouseout", function () {
        self.tooltip.hide();
    });

    this.isDisabled = false;
    // if service available init all controls otherwise show tooltip
    if (this._isServicesAvailable()) {
        this.selectedTZInfoContainer.on("click", function () {
            self._showSearchField(true, true);
        });

        this.searchField.on("keydown", function (event) {
            if (event.keyCode == _keyCodes.KEY_CODE_ESC) {
                self._onCancelAction();
                event.preventDefault();
                return false;
            }
        });
        this.searchField.on("focus", function () {
            if (self.rpc) {
                self.rpc.abort();
            }
            self._showSearchField(false, false); //show search panel
        });
        this.searchField.on("blur", function () {
            if ((0, _atUtils.trim)(self.searchField.val()) == "") // if there is no value un focus and set prev city
                {
                    self._showSelectedTimeZoneCity(self.currentCity, false);
                }
        });

        this.spinnerController = new _SpinnerController2.default(true);
        this.spinnerController.setSpinner(new _spin2.default({ length: 3, width: 2, radius: 3, lines: 8, color: '#aaaaaa', trail: 60 }));

        this.citiesSearchController = new _CitiesSearchController2.default().init(this.searchField, _jquery2.default.proxy(this._getTimeZoneInformationForCity, this), function () {
            self.spinnerController.spinInElement(self.selectorContainer);
        }, function () {
            self.spinnerController.stop();
        }, function () {
            self.spinnerController.stop();
            self._temporaryNotAvailableServiceErrorHandler();
        }, isShowSearchResultsToTop, additionalClasses, preventDefaultTabMoving ? true : false);

        (0, _jquery2.default)(document).on("mousedown", function (event) {
            if (self.isSearchState) {
                var target = event.target;
                while (target) {
                    if (target == self.searchField[0] || self.citiesSearchController.isShow() && target == self.citiesSearchController.getSearchPanelElement()[0]) {
                        return;
                    }
                    target = target.parentElement;
                }
                if (self.citiesSearchController.isShow()) {
                    self._onCancelAction();
                }
            }
        });
        var resizeCallback = function resizeCallback() {
            self.citiesSearchController.hide();self._showSelectedTimeZoneCity(self.currentCity, true);
        };
        (0, _jquery2.default)(window).off("resize", resizeCallback).on("resize", resizeCallback);
    } else {
        this.isDisabled = true;
        this.selectorContainer.addClass("disabled");
        this._showTooltip(_messageResource2.default.getMessage("time_zones_selector.js.error.service_not_available"));
    }

    this.emptySelectionMessage = emptySelectionMessage ? emptySelectionMessage : _messageResource2.default.getMessage("time_zones_selector.js.empty_selection");
    // show current city
    this._showSelectedTimeZoneCity(initCity, true);

    return this;
};

TimeZonesSelector.prototype._onCancelAction = function () {
    this.searchField.val("");
    this.citiesSearchController.hide();
    this._showSelectedTimeZoneCity(this.currentCity, true);
};

TimeZonesSelector.prototype._showSelectedTimeZoneCity = function (selectedCity, forceBlur) {
    if (forceBlur) {
        this.searchField.blur();
    }

    this.selectedTZInfoContainer.empty();
    if (selectedCity) {
        var cityName = (0, _jquery2.default)("<div class='cityName'>" + selectedCity.name + "</div>");

        var offset = (0, _jquery2.default)("<div class='tzOffset'>" + _messageResource2.default.getMessage("time_zones_selector.js.gmt", [(0, _atUtils.formatRawSecondsOffset)(selectedCity.rawOffset)]) + "</div>");
        this.selectedTZInfoContainer.append(cityName).append(offset);
    } else {
        this.selectedTZInfoContainer.append("<div class='emptySelection'>" + this.emptySelectionMessage + "</div>");
    }
    this.selectedTZInfoContainer.show();

    this.isSearchState = false;
};

TimeZonesSelector.prototype._showSearchField = function (forceFocus, updateValue) {
    this._hideErrors();

    if (updateValue) {
        if (this.currentCity) {
            this.searchField.val(this.currentCity.name);
        } else {
            this.searchField.val("");
        }
    }

    this.selectedTZInfoContainer.hide();
    if (forceFocus) {
        this.searchField.focus();
    }
    this.citiesSearchController.processSearchQuery();

    this.isSearchState = true;
};

TimeZonesSelector.prototype.resetToInit = function () {
    this.currentCity = this.initialCity;
    this._hideErrors();
    this.cancelSearch();
};

TimeZonesSelector.prototype.cancelSearch = function () {
    if (!this.isDisabled) {
        this._onCancelAction();
        if (this.rpc) {
            this.rpc.abort();
        }
    }
};

TimeZonesSelector.prototype._getTimeZoneInformationForCity = function (currentCity) {
    this.spinnerController.spinInElement(this.selectorContainer);

    var lat = currentCity.geometry.location.lat();
    var lng = currentCity.geometry.location.lng();
    var self = this;
    this.rpc = (0, _jquery_rpc2.default)("TimeZonesService.getTimeZoneInfo", [lat, lng], function (response) {
        var city = {
            name: currentCity.name,
            placeId: currentCity.place_id,
            timeZoneId: response.timeZoneId,
            rawOffset: response.rawOffset,
            currentTime: response.currentTime
        };

        self.onChangeCallback(city);
        self._showSelectedTimeZoneCity(city, true);
        self.currentCity = city;
        self.spinnerController.stop();
    }, function (jqXHR, textStatus, errorThrown) {
        self.spinnerController.stop();
        if (textStatus != 'abort') {
            self._temporaryNotAvailableServiceErrorHandler();
            if (errorThrown.exception == "com.actimind.common.services.TimeZoneNotReceivedException") {
                console.error(errorThrown.msg); //for support
                return true;
            }
        }
    });
};

TimeZonesSelector.prototype._isServicesAvailable = function () {
    return (window.google && window.google.maps && window.google.maps.places) != undefined;
};

TimeZonesSelector.prototype._showTooltip = function (message) {
    this.tooltipElement.empty().text(message);
    this.isNeedToShowTooltip = true;
};

TimeZonesSelector.prototype._temporaryNotAvailableServiceErrorHandler = function () {
    this._showSelectedTimeZoneCity(this.currentCity, true);
    this.selectorContainer.toggleClass("error", true);
    this._showTooltip(_messageResource2.default.getMessage("time_zones_selector.js.error.service_temporary_not_available"));
};

TimeZonesSelector.prototype._hideErrors = function () {
    this.isNeedToShowTooltip = false;
    this.selectorContainer.toggleClass("error", false);
};

/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ShowUserGroupsStrategy;

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _UserSelectorGroupsStrategy = __webpack_require__(740);

var _UserSelectorGroupsStrategy2 = _interopRequireDefault(_UserSelectorGroupsStrategy);

var _hierarchy_selector_util = __webpack_require__(95);

var _hierarchy_selector_util2 = _interopRequireDefault(_hierarchy_selector_util);

var _UserGroupSelectorTree = __webpack_require__(1316);

var _UserGroupSelectorTree2 = _interopRequireDefault(_UserGroupSelectorTree);

var _TreeNode = __webpack_require__(60);

var _TreeNode2 = _interopRequireDefault(_TreeNode);

var _TreeNodeSet = __webpack_require__(79);

var _TreeNodeSet2 = _interopRequireDefault(_TreeNodeSet);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

ShowUserGroupsStrategy.USER_GROUP_NODE_LEVEL = 1;
ShowUserGroupsStrategy.USER_NODE_LEVEL = 2;
ShowUserGroupsStrategy.DISABLED_USER_NODE_LEVEL = 3;

ShowUserGroupsStrategy.noNodesMatchingSearchMessageKey = "users_selector.users_or_user_groups_no_results_in_search";
ShowUserGroupsStrategy.noSelectedNodesMessageKey = "users_selector.hide_not_selected.no_users_or_user_groups_selected";

function ShowUserGroupsStrategy(conf) {
    _UserSelectorGroupsStrategy2.default.call(this);

    this.emptySelectionTooltipTextKey = conf && conf.emptySelectionTooltipTextKey ? conf.emptySelectionTooltipTextKey : window.EnabledFeatures.UGR && window.EnabledFeatures.TZG ? "mail_notifications.users_selector.tooltip.no_users_selected" : window.EnabledFeatures.TZG ? "mail_notifications.users_selector.tooltip.tgz_only.no_users_selected" : "mail_notifications.users_selector.tooltip.ug_only.no_users_selected";
    this.noNodesMatchingSearchMessageKey = conf && conf.noNodesMatchingSearchMessageKey ? conf.noNodesMatchingSearchMessageKey : ShowUserGroupsStrategy.noNodesMatchingSearchMessageKey;
    this.noSelectedNodesMessageKey = conf && conf.noSelectedNodesMessageKey ? conf.noSelectedNodesMessageKey : ShowUserGroupsStrategy.noSelectedNodesMessageKey;

    this.getGroupIdFromUserCallback = conf && conf.getGroupIdFromUserCallback ? conf.getGroupIdFromUserCallback : function (user) {
        return user.getUserGroupId();
    };
}

ShowUserGroupsStrategy.prototype = new _UserSelectorGroupsStrategy2.default();

ShowUserGroupsStrategy.prototype.canExpandCollapseNodes = function () {
    return true;
};

ShowUserGroupsStrategy.prototype.createTree = function (rootNode, emptyMessageBuilder, collapsedNodeIds) {
    return new _UserGroupSelectorTree2.default(rootNode, emptyMessageBuilder, collapsedNodeIds, this.getGroupIdFromUserCallback);
};

ShowUserGroupsStrategy.prototype.isGroupNodeRendererNeeded = function () {
    return true;
};

ShowUserGroupsStrategy.prototype.makeSelectionFromNodeSet = function (nodeSet, isFullFormed, mapFirstLevelToSecond, groupType) {
    var selection = _UserSelectorGroupsStrategy2.default.prototype.makeSelectionFromNodeSet.call(this, nodeSet, isFullFormed, mapFirstLevelToSecond);
    selection.groupType = groupType;
    return selection;
};

ShowUserGroupsStrategy.prototype.makeOnlyUsersSelection = function (nodeSet) {
    var usersArray = [];
    _underscore2.default.each(nodeSet.getAllNodes(), function (node) {
        if (node.getType() == _TreeNode2.default.TYPE_USER) usersArray.push(node.getValue());
    });
    return usersArray;
};

/**
 * Returns all selected user. Includes users from selected groups
 * @param nodeSet
 * @returns {Array} all selected users
 */
ShowUserGroupsStrategy.prototype.makeAllSelectedUsersSelection = function (nodeSet) {
    var usersArray = [];

    function addUsersRecursive(node) {
        if (node.getType() == _TreeNode2.default.TYPE_USER) usersArray.push(node.getValue());else _underscore2.default.each(node.getChildren(), addUsersRecursive);
    }

    _underscore2.default.each(nodeSet.getAllNodes(), function (node) {
        addUsersRecursive(node);
    });

    return usersArray;
};

ShowUserGroupsStrategy.prototype.saveCollapsedNodesIntoCookies = function (tree, cookiesKey) {
    _hierarchy_selector_util2.default.saveCollapsedNodesIntoCookies(tree, cookiesKey, _TreeNode2.default.TYPE_GROUP);
};

ShowUserGroupsStrategy.prototype.makeNodeSet = function (selection, rootNode) {
    var resultSet = _hierarchy_selector_util2.default.makeNodeSetByTwoLevelSelection(selection, rootNode, "g", "u");
    resultSet.addAll(_hierarchy_selector_util2.default.selectNodesParents(resultSet, ShowUserGroupsStrategy.DISABLED_USER_NODE_LEVEL));
    return resultSet;
};

ShowUserGroupsStrategy.prototype.getUserNodeLevel = function () {
    return ShowUserGroupsStrategy.USER_NODE_LEVEL;
};

/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = UserNodeRenderer;

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _SimpleCheckboxNodeRenderer = __webpack_require__(347);

var _SimpleCheckboxNodeRenderer2 = _interopRequireDefault(_SimpleCheckboxNodeRenderer);

var _UserNameFormat = __webpack_require__(17);

var _UserNameFormat2 = _interopRequireDefault(_UserNameFormat);

var _atUtils = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function UserNodeRenderer(tree, selectorFilter, selectionHelper) {
    _SimpleCheckboxNodeRenderer2.default.call(this, tree, selectorFilter, selectionHelper);
}

UserNodeRenderer.prototype = _underscore2.default.create(_SimpleCheckboxNodeRenderer2.default.prototype);

UserNodeRenderer.prototype.isNeedToPushDisabledClass = function (treeNode) {
    return !treeNode.getValue().isActive();
};

UserNodeRenderer.prototype.generateLabel = function (treeNode, labelEl) {
    var user = treeNode.getValue();

    var hlFirstName = this.selectorFilter.highlightTokens(user.firstName);
    var hlLastName = this.selectorFilter.highlightTokens(user.lastName);

    var result = _UserNameFormat2.default.formatLFM(hlFirstName, hlLastName, (0, _atUtils.escapeHtmlSymbols)(user.middleName));

    result = (0, _atUtils.concatStr)(result, this.selectionHelper.getListDescriptionItemStatus(user), " ");

    labelEl.innerHTML = result;

    labelEl.title = this.getTitle(treeNode.getValue());
};

UserNodeRenderer.prototype.getTitle = function (user) {
    return user.formatNameLFM();
};

UserNodeRenderer.prototype.getNodeClasses = function (treeNode) {
    var classes = _SimpleCheckboxNodeRenderer2.default.prototype.getNodeClasses.call(this, treeNode);
    if (!treeNode.getValue().isRequiresTTApproval) {
        classes.push("autoApproved");
    }
    return classes;
};

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = UserSelectorEmptyMessageBuilder;

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _EmptyMessageBuilder = __webpack_require__(748);

var _EmptyMessageBuilder2 = _interopRequireDefault(_EmptyMessageBuilder);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function UserSelectorEmptyMessageBuilder(userSelectorGroupsStrategy) {
    _EmptyMessageBuilder2.default.call(this);
    this.userSelectorGroupsStrategy = userSelectorGroupsStrategy;
}

UserSelectorEmptyMessageBuilder.prototype = _underscore2.default.create(_EmptyMessageBuilder2.default.prototype, {
    createMessages: function createMessages() {
        this.messages["noNodesMatchingSearch"] = this.userSelectorGroupsStrategy.getNoNodesMatchingSearchMessage();
        this.messages["noSelectedNodes"] = this.userSelectorGroupsStrategy.getNoSelectedNodesMessage();
        this.messages["noSelectedNodesHasDisabled"] = _messageResource2.default.getMessage("users_selector.hide_not_selected.only_disabled");
        this.messages["emptyTree"] = _messageResource2.default.getMessage("users_selector.no_users_assigned");
    }
});

/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getGenerateMoneyReportsRightTitle = undefined;
exports.generatePermissionRows = generatePermissionRows;
exports.getManagePtoAndSickDaysRightTitle = getManagePtoAndSickDaysRightTitle;

var _PermissionRow = __webpack_require__(1323);

var _PermissionRow2 = _interopRequireDefault(_PermissionRow);

var _constants = __webpack_require__(4);

var _index = __webpack_require__(22);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function generatePermissionRows($firstGroupContainer, $secondGroupContainer) {
    var permissionsRows = {};
    permissionsRows[_constants.AccessRights.MANAGE_USERS] = new _PermissionRow2.default($firstGroupContainer, _constants.AccessRights.MANAGE_USERS, {
        name: _messageResource2.default.getMessage('access_rights.manage_users')
    }).init();
    permissionsRows[_constants.AccessRights.SUBMIT_OTHER_USER_TIME_TRACK] = new _PermissionRow2.default($firstGroupContainer, _constants.AccessRights.SUBMIT_OTHER_USER_TIME_TRACK, {
        name: _messageResource2.default.getMessage((0, _index.isEnabled)(_index.Feature.TTA) ? 'access_rights.modify_and_approve_tt' : 'access_rights.submit_other_time_track')
    }).init();
    permissionsRows[_constants.AccessRights.EDIT_HIERARCHY] = new _PermissionRow2.default($firstGroupContainer, _constants.AccessRights.EDIT_HIERARCHY, {
        name: _messageResource2.default.getMessage('access_rights.edit_hierarchy')
    }).init();
    permissionsRows[_constants.AccessRights.GENERATE_MONEY_REPORTS] = new _PermissionRow2.default($firstGroupContainer, _constants.AccessRights.GENERATE_MONEY_REPORTS, {
        name: _messageResource2.default.getMessage('access_rights.generate_money_reports')
    }).init();
    permissionsRows[_constants.AccessRights.SUBMIT_TIME_TRACK] = new _PermissionRow2.default($secondGroupContainer, _constants.AccessRights.SUBMIT_TIME_TRACK, {
        name: _messageResource2.default.getMessage('access_rights.submit_time_track')
    }).init();
    permissionsRows[_constants.AccessRights.LOCK_TIME_TRACK] = new _PermissionRow2.default($secondGroupContainer, _constants.AccessRights.LOCK_TIME_TRACK, {
        name: _messageResource2.default.getMessage('access_rights.lock_time_track')
    }).init();
    permissionsRows[_constants.AccessRights.MANAGE_PTO_AND_SICK] = new _PermissionRow2.default($secondGroupContainer, _constants.AccessRights.MANAGE_PTO_AND_SICK, {
        name: _messageResource2.default.getMessage('access_rights.manage_pto_and_sick')
    }).init();
    permissionsRows[_constants.AccessRights.MANAGE_GENERAL_SETTINGS] = new _PermissionRow2.default($secondGroupContainer, _constants.AccessRights.MANAGE_GENERAL_SETTINGS, {
        name: _messageResource2.default.getMessage('access_rights.manage_general_settings')
    }).init();
    return permissionsRows;
}

function getManagePtoAndSickDaysRightTitle(isPtoEnabled, isSdbEnabled) {
    var title = '';
    if (isPtoEnabled && isSdbEnabled) title = _messageResource2.default.getMessage('access_rights.manage_pto_and_sick');else if (isPtoEnabled) title = _messageResource2.default.getMessage('access_rights.manage_pto_only');else if (isSdbEnabled) title = _messageResource2.default.getMessage('access_rights.manage_sick_only');

    return title;
}

var getGenerateMoneyReportsRightTitle = exports.getGenerateMoneyReportsRightTitle = function getGenerateMoneyReportsRightTitle(isURAEnabled, isBTYEnabled) {
    var generateMoneyReportsTitle = "";
    if (isBTYEnabled && isURAEnabled) generateMoneyReportsTitle = _messageResource2.default.getMessage('access_rights.generate_money_reports');
    if (isBTYEnabled && !isURAEnabled) generateMoneyReportsTitle = _messageResource2.default.getMessage('access_rights.generate_money_reports_only_billing');
    if (!isBTYEnabled && isURAEnabled) generateMoneyReportsTitle = _messageResource2.default.getMessage('access_rights.generate_money_reports_only_cost');

    return generateMoneyReportsTitle;
};

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _WorkflowStatusPrefix;

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _utils = __webpack_require__(80);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _constants = __webpack_require__(23);

var _WorkflowStatusIcon = __webpack_require__(241);

var _WorkflowStatusIcon2 = _interopRequireDefault(_WorkflowStatusIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var WorkflowStatusPrefixKeyByType = (_WorkflowStatusPrefix = {}, _defineProperty(_WorkflowStatusPrefix, _constants.WorkflowStatusType.OPEN, 'workflow_status.prefix.open'), _defineProperty(_WorkflowStatusPrefix, _constants.WorkflowStatusType.COMPLETED, 'workflow_status.prefix.completed'), _WorkflowStatusPrefix);

var WorkflowStatus = function (_TemplateView) {
    _inherits(WorkflowStatus, _TemplateView);

    function WorkflowStatus(_ref) {
        var _ref$onClickCb = _ref.onClickCb,
            onClickCb = _ref$onClickCb === undefined ? function () {} : _ref$onClickCb,
            name = _ref.name,
            type = _ref.type,
            colorId = _ref.colorId,
            _ref$showTypePrefix = _ref.showTypePrefix,
            showTypePrefix = _ref$showTypePrefix === undefined ? false : _ref$showTypePrefix,
            _ref$showArrow = _ref.showArrow,
            showArrow = _ref$showArrow === undefined ? false : _ref$showArrow,
            _ref$hideName = _ref.hideName,
            hideName = _ref$hideName === undefined ? false : _ref$hideName;

        _classCallCheck(this, WorkflowStatus);

        var _this = _possibleConstructorReturn(this, (WorkflowStatus.__proto__ || Object.getPrototypeOf(WorkflowStatus)).call(this, null));

        _this.params = {
            onClickCb: onClickCb
        };

        _this.state = {
            name: name,
            type: type,
            colorId: colorId,
            showTypePrefix: showTypePrefix,
            showArrow: showArrow,
            showName: !hideName
        };

        _this.onStatePropertyChanged('name', function () {
            return _this._updateName();
        });
        _this.onStatePropertyChanged('showName', function (show) {
            return _this.$name.toggle(show);
        });
        _this.onStatePropertyChanged('type', function (type, prevType) {
            return _this._updateType(type, prevType);
        });
        _this.onStatePropertyChanged('colorId', function (colorId, prevColorId) {
            return _this._updateColor(colorId, prevColorId);
        });
        _this.onStatePropertyChanged('showTypePrefix', function () {
            return _this._updatePrefixClass();
        });
        _this.onStatePropertyChanged('showArrow', function () {
            return _this._updateArrowClass();
        });
        _this.onAnyStatePropertyChanged(['colorId', 'type'], function () {
            return _this._updateWorkflowStatusIconState();
        });
        return _this;
    }

    _createClass(WorkflowStatus, [{
        key: '_updateName',
        value: function _updateName() {
            this.$name.text(this.state.name);
        }
    }, {
        key: '_updateColor',
        value: function _updateColor(colorId, prevColorId) {
            if (prevColorId) {
                this.getEl().removeClass((0, _utils.getColorClassById)(prevColorId));
                this.getEl().removeClass((0, _utils.getStatusTypeClassByColorId)(prevColorId));
            }
            if (colorId || colorId === 0) {
                this.getEl().addClass((0, _utils.getColorClassById)(colorId));
                this.getEl().addClass((0, _utils.getStatusTypeClassByColorId)(colorId));
            }
        }
    }, {
        key: '_updateType',
        value: function _updateType(type, prevType) {
            this._updateTypePrefix();
            if (prevType) this.getEl().removeClass((0, _utils.getStatusClassByType)(prevType));
            if (type) this.getEl().addClass((0, _utils.getStatusClassByType)(type));
        }
    }, {
        key: '_updateTypePrefix',
        value: function _updateTypePrefix() {
            this.$typePrefix.text(_messageResource2.default.getMessage(WorkflowStatusPrefixKeyByType[this.state.type]));
        }
    }, {
        key: '_updatePrefixClass',
        value: function _updatePrefixClass() {
            this.getEl().toggleClass('withPrefix', this.state.showTypePrefix);
        }
    }, {
        key: '_updateArrowClass',
        value: function _updateArrowClass() {
            this.getEl().toggleClass('showArrow', this.state.showArrow);
        }
    }, {
        key: '_updateWorkflowStatusIconState',
        value: function _updateWorkflowStatusIconState() {
            this.workflowStatusIcon.setState({
                colorId: this.state.colorId,
                type: this.state.type
            });
        }
    }, {
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class="workflowStatus">' + '    <div class="icon"></div>' + '    <div class="typePrefix"></div>' + '    <div class="name"></div>' + '</div>';
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            var _this2 = this;

            this.$name = this.find('.name');
            this.$typePrefix = this.find('.typePrefix');

            this.workflowStatusIcon = new _WorkflowStatusIcon2.default(null, {
                colorId: this.state.colorId,
                type: this.state.type
            }).init(this.find('.icon'));

            this.find('.typePrefix').toggle(this.state.showTypePrefix);
            this.getEl().on('click', function (e) {
                return _this2.params.onClickCb(e);
            });

            this.renderInitialState();
        }
    }]);

    return WorkflowStatus;
}(_TemplateView3.default);

exports.default = WorkflowStatus;

/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.inherits = inherits;
function inherits(parent, child) {
	var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

	var extended = Object.create(parent.prototype);
	for (var p in props) {
		extended[p] = props[p];
	}
	extended.constructor = child;
	child.prototype = extended;
	return child;
}

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.setCommentsOrderInLocalStorage = exports.getCommentsOrderFromLocalStorage = exports.validateCommentText = exports.getCustomerNewCommentsTextsFromLocalStorage = exports.getProjectNewCommentsTextsFromLocalStorage = exports.getTaskNewCommentsTextsFromLocalStorage = exports.setEntityCommentsInLocalStorage = exports.setCustomerNewCommentsTextsInLocalStorage = exports.setProjectNewCommentsTextsInLocalStorage = exports.setTaskNewCommentsTextsInLocalStorage = undefined;

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _constants = __webpack_require__(4);

var _LocalStorage = __webpack_require__(72);

var _constants2 = __webpack_require__(120);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEBOUNCE_DELAY = 500;

var setTaskNewCommentsTextsInLocalStorage = exports.setTaskNewCommentsTextsInLocalStorage = _underscore2.default.debounce(function (newComments) {
    (0, _LocalStorage.getLocalStorage)().setItem('taskPanelNewComments', newComments);
}, DEBOUNCE_DELAY);

var setProjectNewCommentsTextsInLocalStorage = exports.setProjectNewCommentsTextsInLocalStorage = _underscore2.default.debounce(function (newComments) {
    (0, _LocalStorage.getLocalStorage)().setItem('projectPanelNewComments', newComments);
}, DEBOUNCE_DELAY);

var setCustomerNewCommentsTextsInLocalStorage = exports.setCustomerNewCommentsTextsInLocalStorage = _underscore2.default.debounce(function (newComments) {
    (0, _LocalStorage.getLocalStorage)().setItem('customerPanelNewComments', newComments);
}, DEBOUNCE_DELAY);

var setEntityCommentsInLocalStorage = exports.setEntityCommentsInLocalStorage = function setEntityCommentsInLocalStorage(entityType, newComments) {
    switch (entityType) {
        case _constants.EntityType.TASK:
            setTaskNewCommentsTextsInLocalStorage(newComments);
            break;
        case _constants.EntityType.PROJECT:
            setProjectNewCommentsTextsInLocalStorage(newComments);
            break;
        case _constants.EntityType.CUSTOMER:
            setCustomerNewCommentsTextsInLocalStorage(newComments);
            break;
    }
};

var getTaskNewCommentsTextsFromLocalStorage = exports.getTaskNewCommentsTextsFromLocalStorage = function getTaskNewCommentsTextsFromLocalStorage() {
    var comments = (0, _LocalStorage.getLocalStorage)().getItem('taskPanelNewComments');
    return comments ? comments : {};
};

var getProjectNewCommentsTextsFromLocalStorage = exports.getProjectNewCommentsTextsFromLocalStorage = function getProjectNewCommentsTextsFromLocalStorage() {
    var comments = (0, _LocalStorage.getLocalStorage)().getItem('projectPanelNewComments');
    return comments ? comments : {};
};

var getCustomerNewCommentsTextsFromLocalStorage = exports.getCustomerNewCommentsTextsFromLocalStorage = function getCustomerNewCommentsTextsFromLocalStorage() {
    var comments = (0, _LocalStorage.getLocalStorage)().getItem('customerPanelNewComments');
    return comments ? comments : {};
};

var validateCommentText = exports.validateCommentText = function validateCommentText(text) {
    return text !== '' && text.length <= _constants2.NUMBER_ALLOWED_CHARACTERS;
};

var getCommentsOrderFromLocalStorage = exports.getCommentsOrderFromLocalStorage = function getCommentsOrderFromLocalStorage() {
    return !!(0, _LocalStorage.getLocalStorage)().getItem('entityPanelsCommentsOrder_newCommentsOnTop');
};

var setCommentsOrderInLocalStorage = exports.setCommentsOrderInLocalStorage = function setCommentsOrderInLocalStorage(isNewCommentsOnTop) {
    (0, _LocalStorage.getLocalStorage)().setItem('entityPanelsCommentsOrder_newCommentsOnTop', isNewCommentsOnTop);
};

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.customerActionsProvider = exports.projectActionsProvider = exports.taskActionsProvider = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _EditTaskService = __webpack_require__(1346);

var _EditTaskService2 = _interopRequireDefault(_EditTaskService);

var _ProjectInfoService = __webpack_require__(1347);

var _ProjectInfoService2 = _interopRequireDefault(_ProjectInfoService);

var _CustomerInfoService = __webpack_require__(1348);

var _CustomerInfoService2 = _interopRequireDefault(_CustomerInfoService);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TaskActionsProvider = function () {
    function TaskActionsProvider(editTaskService) {
        _classCallCheck(this, TaskActionsProvider);

        this.editTaskService = editTaskService;
    }

    _createClass(TaskActionsProvider, [{
        key: "getAssignedUsers",
        value: function getAssignedUsers(taskId) {
            return this.editTaskService.getAssignedUsers(taskId).catch(this._commonErrorsHandler);
        }
    }, {
        key: "updateAssignedUsers",
        value: function updateAssignedUsers(taskId, addedUserIds, removeUserIds) {
            return this.editTaskService.updateAssignedUsers(taskId, addedUserIds, removeUserIds).catch(this._commonErrorsHandler);
        }
    }, {
        key: "updateManagers",
        value: function updateManagers(taskId, addedUserIds, removeUserIds) {
            return this.editTaskService.updateManagers(taskId, addedUserIds, removeUserIds).catch(this._commonErrorsHandler);
        }
    }, {
        key: "_commonErrorsHandler",
        value: function _commonErrorsHandler(e) {
            throw e;
        }
    }]);

    return TaskActionsProvider;
}();

var ProjectActionsProvider = function () {
    function ProjectActionsProvider(projectInfoService) {
        _classCallCheck(this, ProjectActionsProvider);

        this.projectInfoService = projectInfoService;
    }

    _createClass(ProjectActionsProvider, [{
        key: "getAssignedUsers",
        value: function getAssignedUsers(projectId) {
            return this.projectInfoService.getAssignedUsers(projectId).catch(this._commonErrorsHandler);
        }
    }, {
        key: "updateAssignedUsers",
        value: function updateAssignedUsers(projectId, addedUserIds, removeUserIds) {
            return this.projectInfoService.updateAssignedUsers(projectId, addedUserIds, removeUserIds).catch(this._commonErrorsHandler);
        }
    }, {
        key: "updateManagers",
        value: function updateManagers(projectId, addedUserIds, removeUserIds) {
            return this.projectInfoService.updateManagers(projectId, addedUserIds, removeUserIds).catch(this._commonErrorsHandler);
        }
    }, {
        key: "_commonErrorsHandler",
        value: function _commonErrorsHandler(e) {
            throw e;
        }
    }]);

    return ProjectActionsProvider;
}();

var CustomerActionsProvider = function () {
    function CustomerActionsProvider(customerInfoService) {
        _classCallCheck(this, CustomerActionsProvider);

        this.customerInfoService = customerInfoService;
    }

    _createClass(CustomerActionsProvider, [{
        key: "getAssignedUsers",
        value: function getAssignedUsers(customerId) {
            return this.customerInfoService.getAssignedUsers(customerId).catch(this._commonErrorsHandler);
        }
    }, {
        key: "updateAssignedUsers",
        value: function updateAssignedUsers(customerId, addedUserIds, removeUserIds) {
            return this.customerInfoService.updateAssignedUsers(customerId, addedUserIds, removeUserIds).catch(this._commonErrorsHandler);
        }
    }, {
        key: "getManagers",
        value: function getManagers(customerId) {
            return this.customerInfoService.getManagers(customerId).catch(this._commonErrorsHandler);
        }
    }, {
        key: "updateManagers",
        value: function updateManagers(customerId, addedUserIds, removeUserIds) {
            return this.customerInfoService.updateManagers(customerId, addedUserIds, removeUserIds).catch(this._commonErrorsHandler);
        }
    }, {
        key: "getAssignedUsersForAll",
        value: function getAssignedUsersForAll() {
            return this.customerInfoService.getAssignedUsersForAll().catch(this._commonErrorsHandler);
        }
    }, {
        key: "getManagersForAll",
        value: function getManagersForAll() {
            return this.customerInfoService.getManagersForAll().catch(this._commonErrorsHandler);
        }
    }, {
        key: "_commonErrorsHandler",
        value: function _commonErrorsHandler(e) {
            throw e;
        }
    }]);

    return CustomerActionsProvider;
}();

var taskActionsProvider = exports.taskActionsProvider = new TaskActionsProvider(new _EditTaskService2.default());
var projectActionsProvider = exports.projectActionsProvider = new ProjectActionsProvider(new _ProjectInfoService2.default());
var customerActionsProvider = exports.customerActionsProvider = new CustomerActionsProvider(new _CustomerInfoService2.default());

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.addRecentlyCreatedTasks = exports.toggleMinimizedCards = exports.updateTaskStatusAndPosition = exports.loadOnScroll = exports.handleTasksAndProjectsLoadingOrder = exports.collapseProject = exports.expandProject = exports.collapseAllProjects = exports.changeCollapsedProjects = exports.toggleProjectCollapsed = exports.loadMoreTasks = exports.reloadCounters = exports.reloadKanban = exports.changeAllTasksSelectedAction = exports.setNeedToLoadCounters = exports.setProjectIdsContainingTasks = exports.toggleKanbanCardsView = exports.setLoaded = exports.setTasksCountByWorkflowStatuses = exports.setLoadingProjectId = exports.setLoadingInitialData = exports.resetProjectLoadingPositions = exports.setProjectLoadingPosition = exports.removeUpdatingTask = exports.addUpdatingTask = exports.setTasksOrder = exports.prependTasksOrder = exports.addTasksOrder = exports.addTasks = exports.setInitialData = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reduxActions = __webpack_require__(9);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _actionTypes = __webpack_require__(666);

var ActionTypes = _interopRequireWildcard(_actionTypes);

var _actions = __webpack_require__(29);

var EntitiesActions = _interopRequireWildcard(_actions);

var _actions2 = __webpack_require__(55);

var _TaskManagementService = __webpack_require__(1349);

var _TaskManagementService2 = _interopRequireDefault(_TaskManagementService);

var _selectors = __webpack_require__(243);

var _actions3 = __webpack_require__(194);

var _selectors2 = __webpack_require__(14);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _atUtils = __webpack_require__(5);

var _selectors3 = __webpack_require__(27);

var _utils = __webpack_require__(6);

var _rpcCalls = __webpack_require__(24);

var _rpcCalls2 = _interopRequireDefault(_rpcCalls);

var _syncCallbacks = __webpack_require__(161);

var SyncCallbacks = _interopRequireWildcard(_syncCallbacks);

var _actions4 = __webpack_require__(56);

var _utils2 = __webpack_require__(365);

var _actions5 = __webpack_require__(491);

var _constants = __webpack_require__(23);

var _rpcUtils = __webpack_require__(160);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var taskManagementService = new _TaskManagementService2.default();
var LOAD_TASKS_LIMIT = 20;

var setInitialData = exports.setInitialData = (0, _reduxActions.createAction)(ActionTypes.INITIAL_DATA_SET);

var addTasks = exports.addTasks = (0, _reduxActions.createAction)(ActionTypes.TASKS_ADD);

var addTasksOrder = exports.addTasksOrder = (0, _reduxActions.createAction)(ActionTypes.TASKS_ORDER_ADD);

var prependTasksOrder = exports.prependTasksOrder = (0, _reduxActions.createAction)(ActionTypes.TASKS_ORDER_PREPEND);

var setTasksOrder = exports.setTasksOrder = (0, _reduxActions.createAction)(ActionTypes.TASKS_ORDER_SET);

var addUpdatingTask = exports.addUpdatingTask = (0, _reduxActions.createAction)(ActionTypes.UPDATING_TASK_ADD);

var removeUpdatingTask = exports.removeUpdatingTask = (0, _reduxActions.createAction)(ActionTypes.UPDATING_TASK_REMOVE);

var setProjectLoadingPosition = exports.setProjectLoadingPosition = (0, _reduxActions.createAction)(ActionTypes.PROJECT_LOADING_POSITION_SET);

var resetProjectLoadingPositions = exports.resetProjectLoadingPositions = (0, _reduxActions.createAction)(ActionTypes.PROJECT_LOADING_POSITIONS_RESET);

var setLoadingInitialData = exports.setLoadingInitialData = (0, _reduxActions.createAction)(ActionTypes.LOADING_INITIAL_DATA_SET);

var setLoadingProjectId = exports.setLoadingProjectId = (0, _reduxActions.createAction)(ActionTypes.LOADING_PROJECT_ID_SET);

var setTasksCountByWorkflowStatuses = exports.setTasksCountByWorkflowStatuses = (0, _reduxActions.createAction)(ActionTypes.TASKS_COUNT_BY_WORKFLOW_STATUS_SET);

var setLoaded = exports.setLoaded = (0, _reduxActions.createAction)(ActionTypes.IS_LOADED_SET);

var toggleKanbanCardsView = exports.toggleKanbanCardsView = (0, _reduxActions.createAction)(ActionTypes.MINIMIZED_CARDS_SET);

var setProjectIdsContainingTasks = exports.setProjectIdsContainingTasks = (0, _reduxActions.createAction)(ActionTypes.PROJECTS_IDS_CONTAINING_TASK_ADD);

var setNeedToLoadCounters = exports.setNeedToLoadCounters = (0, _reduxActions.createAction)(ActionTypes.NEED_TO_LOAD_COUNTERS_SET);

var changeAllTasksSelectedAction = exports.changeAllTasksSelectedAction = function changeAllTasksSelectedAction() {
    return function (dispatch, getState) {
        // change only tasks in current projects exists. Optimization
        if (!(0, _selectors.thereAreNoTasks)(getState())) {
            dispatch((0, _actions3.changeAllTasksSelected)((0, _atUtils.arrayToSet)((0, _selectors.getTaskIdsOrder)(getState()))));
        }
    };
};

var reloadKanban = exports.reloadKanban = function reloadKanban() {
    return function (dispatch, getState) {
        dispatch(setLoadingInitialData(true));
        var state = getState();
        var cpSelection = (0, _selectors3.getIntersectedCPSelection)(state);
        var workflowStatusFilter = (0, _selectors3.getTaskStatusFilter)(state);
        var filteredWorkflowStatusIds = (0, _selectors3.getFilteredTaskStatusIds)(state);
        var customFieldsFilters = (0, _selectors3.getCustomFieldsFilters)(state);
        var taskWorkflowStatuses = (0, _selectors2.getWorkflowStatusesArray)(state);
        var nameFilter = (0, _selectors3.getTaskNameFilter)(state);
        var onlyManageableTasks = (0, _selectors3.isShowOnlyManageableTasks)(state);

        taskManagementService.loadKanbanInitial(cpSelection, workflowStatusFilter, customFieldsFilters, taskWorkflowStatuses, nameFilter, onlyManageableTasks).then(function (_ref) {
            var taskCountByStatusId = _ref.taskCountByStatusId,
                workflowStatuses = _ref.workflowStatuses,
                _ref$customersProject = _ref.customersProjectsInfo,
                projectIdsContainingTasks = _ref$customersProject.projectIdsContainingTasks,
                projects = _ref$customersProject.projects,
                customers = _ref$customersProject.customers;

            var filteredTaskCountByStatusId = filteredWorkflowStatusIds.reduce(function (acc, curr) {
                return _extends({}, acc, _defineProperty({}, curr, taskCountByStatusId[curr]));
            }, {});

            dispatch(EntitiesActions.addWorkflowStatuses(workflowStatuses));
            dispatch(EntitiesActions.addProjects(projects));
            dispatch(EntitiesActions.addCustomers(customers));

            dispatch(setInitialData({
                workflowStatusIds: Object.keys(filteredTaskCountByStatusId),
                taskCountsByWorkflowStatus: filteredTaskCountByStatusId,
                projectIds: projects.map(function (project) {
                    return project.id;
                })
            }));

            // place name filter applied to initial data and all tasks that will be loaded
            dispatch((0, _utils.createActionObject)(ActionTypes.LOADED_TASKS_NAME_FILTER_SET, nameFilter));
            dispatch(setProjectIdsContainingTasks(projectIdsContainingTasks));
            dispatch(setTasksOrder([]));

            dispatch(setLoaded(true));
            dispatch(setLoadingInitialData(false));
        }).catch(function (e) {
            if ((0, _rpcUtils.isAborted)(e)) return;
            throw e;
        });
    };
};

var reloadCounters = exports.reloadCounters = function reloadCounters() {
    return function (dispatch, getState) {
        var state = getState();
        var cpSelection = (0, _selectors3.getIntersectedCPSelection)(state);
        var workflowStatusFilter = (0, _selectors3.getTaskStatusFilter)(state);
        var filteredWorkflowStatusIds = (0, _selectors3.getFilteredTaskStatusIds)(state);
        var customFieldsFilters = (0, _selectors3.getCustomFieldsFilters)(state);
        var taskWorkflowStatuses = (0, _selectors2.getWorkflowStatusesArray)(state);
        var nameFilter = (0, _selectors3.getTaskNameFilter)(state);
        var onlyManageableTasks = (0, _selectors3.isShowOnlyManageableTasks)(state);

        taskManagementService.loadKanbanInitial(cpSelection, workflowStatusFilter, customFieldsFilters, taskWorkflowStatuses, nameFilter, onlyManageableTasks).then(function (_ref2) {
            var taskCountByStatusId = _ref2.taskCountByStatusId,
                workflowStatuses = _ref2.workflowStatuses;

            var filteredTaskCountByStatusId = filteredWorkflowStatusIds.reduce(function (acc, curr) {
                return _extends({}, acc, _defineProperty({}, curr, taskCountByStatusId[curr]));
            }, {});

            dispatch(EntitiesActions.addWorkflowStatuses(workflowStatuses));
            dispatch(setTasksCountByWorkflowStatuses(filteredTaskCountByStatusId));
            dispatch(setNeedToLoadCounters(false));
        });
    };
};

var loadMoreTasks = exports.loadMoreTasks = function loadMoreTasks() {
    return function (dispatch, getState) {
        var state = getState();
        var projectLoadingPositions = (0, _selectors.getProjectLoadingPositions)(state);
        var isProjectLoadablePredicate = (0, _selectors.getLoadableProjectPredicate)(state);

        var projectId = (0, _selectors.getProjectIds)(state).find(function (id) {
            return isProjectLoadablePredicate(id) && !(0, _utils2.isProjectFullyLoaded)(id, projectLoadingPositions);
        });

        // TODO may be need to replace with `getLoadedTasksNameFilter`
        var nameFilter = (0, _selectors3.getTaskNameFilter)(state);
        var onlyManageableTasks = (0, _selectors3.isShowOnlyManageableTasks)(state);
        var hasManageableTasks = (0, _selectors3.isViewerHasManageableTasks)(state);
        var intersectedCPSelection = (0, _selectors3.getIntersectedCPSelection)(state);
        var filteredWorkflowStatusIds = (0, _selectors3.getFilteredTaskStatusIds)(state);
        var customFieldsFilters = (0, _selectors3.getCustomFieldsFilters)(state);
        var taskWorkflowStatuses = (0, _selectors2.getWorkflowStatusesArray)(state);
        var loadingPosition = projectLoadingPositions[projectId];

        dispatch(setLoadingProjectId(projectId));

        taskManagementService.loadKanbanTasks(projectId, intersectedCPSelection, filteredWorkflowStatusIds, customFieldsFilters, taskWorkflowStatuses, nameFilter, onlyManageableTasks && hasManageableTasks, loadingPosition ? loadingPosition.count : 0, LOAD_TASKS_LIMIT).then(function (data) {
            var tasks = data.tasks;

            dispatch((0, _actions2.setManagementAssignments)(data["managementAssignments"]));
            dispatch((0, _actions2.setHasManageableTasks)(data["hasManageableTasks"]));

            dispatch(EntitiesActions.addTasks(tasks));
            dispatch(addTasksOrder(tasks.map(function (t) {
                return t.id;
            })));

            var count = tasks.length > 0 ? _underscore2.default.max(Object.values(_underscore2.default.groupBy(tasks, 'workflowStatusId')).map(function (tasksByStatus) {
                return tasksByStatus.length;
            })) : 0;
            dispatch(setProjectLoadingPosition({
                id: projectId,
                count: loadingPosition ? loadingPosition.count + count : count,
                fullyLoaded: count < LOAD_TASKS_LIMIT
            }));
            dispatch(setLoadingProjectId(null));
        }).catch(function (err) {
            setLoadingProjectId(null);
            if ((0, _rpcUtils.isAborted)(err)) {
                // it's okey
            } else {
                throw err;
            }
        });
    };
};

var toggleProjectCollapsed = exports.toggleProjectCollapsed = function toggleProjectCollapsed(projectId) {
    return function (dispatch, getState) {
        var state = getState();
        var collapsedProjectsWithIdsSet = (0, _selectors.getCollapsedProjectsWithIdsSet)(state);
        var collapsed = !(collapsedProjectsWithIdsSet.all || collapsedProjectsWithIdsSet.idsSet[projectId]);
        if (collapsed) dispatch(collapseProject(projectId));else dispatch(expandProject(projectId));
    };
};

var changeCollapsedProjects = exports.changeCollapsedProjects = (0, _reduxActions.createAction)(ActionTypes.COLLAPSED_PROJECTS_CHANGE);

var collapseAllProjects = exports.collapseAllProjects = function collapseAllProjects(isAllCollapsed) {
    return function (dispatch, getState) {
        dispatch(changeCollapsedProjects({
            all: isAllCollapsed,
            ids: []
        }));
        if (isAllCollapsed === false) {
            dispatch(handleTasksAndProjectsLoadingOrder((0, _selectors.getProjectIds)(getState()), []));
        }
    };
};

var expandProject = exports.expandProject = function expandProject(id) {
    return function (dispatch, getState) {
        var state = getState();

        var _getCollapsedProjects = (0, _selectors.getCollapsedProjects)(state),
            all = _getCollapsedProjects.all,
            ids = _getCollapsedProjects.ids;

        var allProjectIds = (0, _selectors.getProjectIds)(state);
        var newCollapsedIds = [];
        if (all) {
            newCollapsedIds = allProjectIds.filter(function (sId) {
                return sId !== id;
            });
        } else {
            newCollapsedIds = ids.filter(function (sId) {
                return sId !== id;
            });
        }

        dispatch(changeCollapsedProjects({
            all: false,
            ids: newCollapsedIds
        }));

        // reset loaded projects in case of expand
        if (all) {
            dispatch(handleTasksAndProjectsLoadingOrder(allProjectIds, []));
        } else {
            var projectIndex = allProjectIds.indexOf(id);
            // reset projects only if expanded project not fully loaded
            var fullyLoaded = (0, _utils2.isProjectFullyLoaded)(id, (0, _selectors.getProjectLoadingPositions)(state));
            if (projectIndex >= 0 && !fullyLoaded) {
                var projectIdsToReset = allProjectIds.slice(projectIndex + 1);

                var tasks = (0, _selectors2.getTasks)(state);
                var projectIdsToResetSet = (0, _atUtils.arrayToSet)(projectIdsToReset);
                var newTasksOrder = (0, _selectors.getTaskIdsOrder)(state).filter(function (taskId) {
                    var task = tasks[taskId];
                    return !projectIdsToResetSet[task.projectId];
                });
                dispatch(handleTasksAndProjectsLoadingOrder(projectIdsToReset, newTasksOrder));

                // init loading after reset prev projects
                dispatch(loadMoreTasks());
            }
        }
    };
};

var collapseProject = exports.collapseProject = function collapseProject(id) {
    return function (dispatch, getState) {
        var _getCollapsedProjects2 = (0, _selectors.getCollapsedProjects)(getState()),
            all = _getCollapsedProjects2.all,
            ids = _getCollapsedProjects2.ids;

        dispatch(changeCollapsedProjects({
            all: all,
            ids: ids.concat(id)
        }));
    };
};

var handleTasksAndProjectsLoadingOrder = exports.handleTasksAndProjectsLoadingOrder = function handleTasksAndProjectsLoadingOrder(projectIdsToReset, newTasksOrder) {
    return function (dispatch) {
        // don't change order of actions below
        dispatch(resetProjectLoadingPositions(projectIdsToReset));
        dispatch(setTasksOrder(newTasksOrder));
    };
};

var loadOnScroll = exports.loadOnScroll = function loadOnScroll() {
    return function (dispatch, getState) {
        var state = getState();
        if (!(0, _selectors.isLoading)(state) && !(0, _selectors.areProjectsFullyLoaded)(state)) {
            dispatch(loadMoreTasks());
        }
    };
};

var updateTaskStatusAndPosition = exports.updateTaskStatusAndPosition = function updateTaskStatusAndPosition(_ref3) {
    var taskId = _ref3.taskId,
        projectId = _ref3.projectId,
        workflowStatusId = _ref3.workflowStatusId,
        precedingTaskId = _ref3.precedingTaskId,
        currentPrecedingTaskId = _ref3.currentPrecedingTaskId,
        _ref3$forceReopen = _ref3.forceReopen,
        forceReopen = _ref3$forceReopen === undefined ? false : _ref3$forceReopen;
    return function (dispatch, getState) {
        var state = getState();
        var task = (0, _selectors2.getTask)(state, taskId);
        var targetProject = (0, _selectors2.getProject)(state, projectId);
        var targetCustomer = (0, _selectors2.getCustomer)(state, targetProject.customerId);
        var workflowStatus = (0, _selectors2.getWorkflowStatus)(state, workflowStatusId);

        dispatch(addUpdatingTask(taskId));

        dispatch(EntitiesActions.addTask(_extends({}, task, {
            workflowStatusId: workflowStatusId,
            projectId: projectId,
            open: workflowStatus.type !== _constants.WorkflowStatusType.COMPLETED
        })));

        dispatch(setTasksOrder((0, _atUtils.changeItemPosition)((0, _selectors.getTaskIdsOrder)(state), taskId, precedingTaskId)));

        var method = projectId === task.projectId ? 'TaskManagementService.updateTaskWorkflowStatusAndPosition' : 'TaskManagementService.moveTask';

        (0, _rpcCalls2.default)(method, [task.id, projectId, workflowStatus.type, workflowStatus.id, workflowStatus.name, precedingTaskId, forceReopen], function (error) {
            if (error.getTextStatus() === "rpc_customException") {
                var exception = error.getErrorThrown().exception;
                switch (exception) {
                    case 'com.actimind.actitime.task.InsufficientRightsToEditTaskStatus':
                        alert(_messageResource2.default.getMessage("change_tasks_workflow_status.insufficient_rights_to_edit_task_status"));
                        window.location.reload();
                        return true;
                    case 'com.actimind.actitime.task.ProjectIsArchivedException':
                        if (confirm(_messageResource2.default.getMessage('task.error.reopen.project_archived'))) {
                            dispatch(EntitiesActions.addTask(_extends({}, task)));
                            dispatch(updateTaskStatusAndPosition({ taskId: taskId, projectId: projectId, workflowStatusId: workflowStatusId, precedingTaskId: precedingTaskId, currentPrecedingTaskId: currentPrecedingTaskId, forceReopen: true }));
                            error.handle();
                        }
                        return true;
                    case "com.actimind.actitime.services.WorkflowStatusesFeatureBecameDisabledException":
                        alert(_messageResource2.default.getMessage("change_tasks_workflow_status.feature_became_disabled"));
                        window.location.reload();
                        return true;
                    case "com.actimind.actitime.services.NoRightToEditHierarchyException":
                        alert(_messageResource2.default.getMessage("task.error.move.no_manage_scope_right"));
                        window.location.reload();
                        return true;
                    case "com.actimind.actitime.project.NoSuchProjectException":
                        alert(_messageResource2.default.getMessage("task.error.move.project_not_exists"));
                        window.location.reload();
                        return true;
                    case "com.actimind.actitime.project.ProjectCannotBeModifiedException":
                        alert(_messageResource2.default.getMessage("task.error.move.project_not_available"));
                        window.location.reload();
                        return true;
                    case "com.actimind.actitime.task.NoSuchTaskException":
                        dispatch((0, _actions2.removeTasks)([task.id]));
                        alert(_messageResource2.default.getMessage("task.error.move.task_deleted"));
                        return true;
                    case "com.actimind.actitime.task.TaskIsNotAssignedToUserException":
                        alert(_messageResource2.default.getMessage("task.error.move.task_not_assigned"));
                        window.location.reload();
                        return true;
                    case "com.actimind.actitime.task.TaskExistsException":
                        alert(_messageResource2.default.getMessage("task.error.task_already_exists"));
                        return true;
                    default:
                        return (0, _actions2.handleCommonTaskUpdateErrors)(task, exception, dispatch);
                }
            }
        }).then(function (updatedTask) {
            dispatch(removeUpdatingTask(taskId));
            if (task.workflowStatusId !== workflowStatusId) {
                dispatch((0, _actions5.changedTaskWorkflowStatus)({
                    taskId: task.id,
                    workflowStatusId: workflowStatusId,
                    prevWorkflowStatusId: task.workflowStatusId
                }));
            }

            SyncCallbacks.afterUpdateTaskStatusAndPositionCb(taskId, projectId, workflowStatus);

            if (task.projectId !== targetProject.id) {
                dispatch(EntitiesActions.addTask(updatedTask));
                dispatch((0, _actions4.toast)(_messageResource2.default.getMessage('move.task.toast', [task.name, targetProject.name])));
            }

            if (updatedTask.name !== task.name) dispatch((0, _actions4.toast)(_messageResource2.default.getMessage('move.task.duplicate_name.toast')));

            if (forceReopen) {
                dispatch(EntitiesActions.addProject(_extends({}, targetProject, { archived: false })));
                dispatch(EntitiesActions.addCustomer(_extends({}, targetCustomer, { archived: false })));
                dispatch((0, _actions4.toast)(_messageResource2.default.getMessage("status.project.toast", [targetProject.name])));
            }
        }).catch(function (error) {
            if (error.isHandled()) return;
            dispatch(removeUpdatingTask(taskId));
            if ((0, _selectors2.getTask)(getState(), taskId)) {
                dispatch(setTasksOrder((0, _atUtils.changeItemPosition)((0, _selectors.getTaskIdsOrder)(state), taskId, currentPrecedingTaskId)));
                dispatch(EntitiesActions.addTask(task));
            }
        });
    };
};

var toggleMinimizedCards = exports.toggleMinimizedCards = function toggleMinimizedCards() {
    return function (dispatch, getState) {
        var state = getState();
        dispatch(toggleKanbanCardsView(!(0, _selectors.isMinimizedCards)(state)));
        dispatch((0, _actions2.savePageSettings)());
    };
};

var addRecentlyCreatedTasks = exports.addRecentlyCreatedTasks = function addRecentlyCreatedTasks(taskIds) {
    return function (dispatch, getState) {
        dispatch(prependTasksOrder(taskIds));
        var state = getState();
        var tasksCountByWorkflowStatuses = _extends({}, (0, _selectors.getTaskCountsByWorkflowStatus)(state));

        taskIds.forEach(function (taskId) {
            var task = (0, _selectors2.getTask)(state, taskId);
            tasksCountByWorkflowStatuses[task.workflowStatusId] = !!tasksCountByWorkflowStatuses[task.workflowStatusId] ? tasksCountByWorkflowStatuses[task.workflowStatusId] + 1 : 1;
        });
        dispatch(setTasksCountByWorkflowStatuses(tasksCountByWorkflowStatuses));
    };
};

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.calcProjectsWithGroupedTasks = calcProjectsWithGroupedTasks;
exports.filterVisibleProjects = filterVisibleProjects;
exports.isProjectFullyLoaded = isProjectFullyLoaded;
exports.storeCollapsedProjectsState = storeCollapsedProjectsState;
exports.getStoredCollapsedProjectsState = getStoredCollapsedProjectsState;

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _LocalStorage = __webpack_require__(72);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Group tasks by workflow status for every project
 * @param projects ordered projects
 * @param customers for fill names
 * @param tasks all tasks
 * @param editableProjectIds for fill possible actions
 * @param editableProjectIdsWithExcludeSelf for fill possible actions
 * @param editableCustomerIds for fill possible actions
 * @param editableCustomerIdsWithExcludeSelf for fill possible actions
 * @returns {*}
 */
function calcProjectsWithGroupedTasks(projects, customers, tasks, editableProjectIds, editableProjectIdsWithExcludeSelf, editableCustomerIds, editableCustomerIdsWithExcludeSelf) {
    return projects.map(function (project) {
        var tasksByStatus = _underscore2.default.groupBy(tasks.filter(function (task) {
            return task.projectId === project.id;
        }), 'workflowStatusId');
        return _extends({}, project, {
            tasksByStatus: tasksByStatus,
            canReopenProject: !!editableProjectIds[project.id] && !customers[project.customerId].archived || !!editableCustomerIds[project.customerId],
            canManageAllProjectTasks: !!editableProjectIdsWithExcludeSelf[project.id] || !!editableCustomerIdsWithExcludeSelf[project.customerId]
        });
    });
}

/**
 * Filter all projects and get only rendered on page
 * TODO when all projects collapsed - returns all projects together that may produce performance issues
 * @param allProjects
 * @param isProjectCollapsedPredicate check project collapsed
 * @param projectLoadingPositions check that projects fully loaded
 * @param isProjectVisiblePredicate check that project is possible to see on page
 * @returns {Array}
 */
function filterVisibleProjects(allProjects, isProjectCollapsedPredicate, projectLoadingPositions, isProjectVisiblePredicate) {
    // fill projects from start to first expanded not fully loaded
    var targetProjects = [];
    for (var i = 0; i < allProjects.length; i++) {
        var project = allProjects[i];

        var id = project.id;

        var collapsed = isProjectCollapsedPredicate(id);
        var fullyLoaded = isProjectFullyLoaded(id, projectLoadingPositions);

        if (isProjectVisiblePredicate(id)) {
            targetProjects.push(project);

            if (!collapsed && !fullyLoaded) {
                // it's last project that we should see
                break;
            }
        }
    }
    return targetProjects;
}

function isProjectFullyLoaded(projectId, projectLoadingPositions) {
    return !!(projectLoadingPositions[projectId] && projectLoadingPositions[projectId].fullyLoaded);
}

var KANBAN_COLLAPSED_PROJECTS_STATE_LS_KEY = 'kanbanCollapsedProjectsState';

function storeCollapsedProjectsState(collapsedProjects) {
    (0, _LocalStorage.getLocalStorage)().setItem(KANBAN_COLLAPSED_PROJECTS_STATE_LS_KEY, collapsedProjects);
}

function getStoredCollapsedProjectsState() {
    return (0, _LocalStorage.getLocalStorage)().getItem(KANBAN_COLLAPSED_PROJECTS_STATE_LS_KEY);
}

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.changeTasksStatusAction = exports.loadBulkChangeTasksStatusDialogDataAction = exports.startBulkChangeTasksStatusAction = exports.changeTasksAssignmentsAction = exports.changeBulkAssignDialogSelection = exports.loadAssignDialogDataAction = exports.startBulkAssignAction = exports.copyTasksToProjectsAction = exports.copyTasksAction = exports.moveTasksAction = exports.loadMoveDialogDataAction = exports.startBulkMoveAction = exports.deleteTasksAction = exports.loadDeleteDialogDataAction = exports.startBulkTasksDeleteAction = exports.startBulkCopyOperation = exports.cleanupDialogsDataAction = exports.setBulkOperationProgress = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reduxActions = __webpack_require__(9);

var _utils = __webpack_require__(6);

var _actions = __webpack_require__(29);

var _selectors = __webpack_require__(14);

var _actions2 = __webpack_require__(55);

var _actionTypes = __webpack_require__(672);

var ActionTypes = _interopRequireWildcard(_actionTypes);

var _rpcCalls = __webpack_require__(24);

var _rpcCalls2 = _interopRequireDefault(_rpcCalls);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _syncCallbacks = __webpack_require__(161);

var SyncCallbacks = _interopRequireWildcard(_syncCallbacks);

var _selectors2 = __webpack_require__(15);

var _constants = __webpack_require__(23);

var _selectors3 = __webpack_require__(367);

var _actions3 = __webpack_require__(56);

var _rpcUtils = __webpack_require__(160);

var _BulkDeleteTasksController = __webpack_require__(1351);

var _BulkDeleteTasksController2 = _interopRequireDefault(_BulkDeleteTasksController);

var _BulkMoveCopyTasksController = __webpack_require__(1352);

var _BulkMoveCopyTasksController2 = _interopRequireDefault(_BulkMoveCopyTasksController);

var _BulkChangeStatusTasksController = __webpack_require__(1353);

var _BulkChangeStatusTasksController2 = _interopRequireDefault(_BulkChangeStatusTasksController);

var _BulkChangeAssignmentsTasksController = __webpack_require__(1354);

var _BulkChangeAssignmentsTasksController2 = _interopRequireDefault(_BulkChangeAssignmentsTasksController);

var _actions4 = __webpack_require__(194);

var _selectors4 = __webpack_require__(106);

var _UserWithAccessRights = __webpack_require__(138);

var _UserWithAccessRights2 = _interopRequireDefault(_UserWithAccessRights);

var _selectors5 = __webpack_require__(19);

var _atUtils = __webpack_require__(5);

var _utils2 = __webpack_require__(1355);

var _ExceptionsTypes = __webpack_require__(107);

var _constants2 = __webpack_require__(4);

var _actions5 = __webpack_require__(141);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var setBulkOperationProgress = exports.setBulkOperationProgress = (0, _reduxActions.createAction)(ActionTypes.BULK_OPERATION_PROGRESS_SET);

var cleanupDialogsDataAction = exports.cleanupDialogsDataAction = (0, _reduxActions.createAction)(ActionTypes.CLEANUP_DIALOGS_DATA);
var startBulkCopyOperation = exports.startBulkCopyOperation = (0, _reduxActions.createAction)(ActionTypes.START_BULK_COPY_OPERATION);

var startBulkTasksDeleteAction = exports.startBulkTasksDeleteAction = function startBulkTasksDeleteAction(onSuccessCb) {
    return function (dispatch) {
        dispatch((0, _utils.createActionObject)(ActionTypes.START_BULK_TASKS_DELETE_OPERATION));
        dispatch(loadDeleteDialogDataAction(onSuccessCb));
    };
};

var loadDeleteDialogDataAction = exports.loadDeleteDialogDataAction = function loadDeleteDialogDataAction(onSuccessCb) {
    return function (dispatch, getState) {
        dispatch((0, _utils.createActionObject)(ActionTypes.LOAD_BULK_DELETE_DIALOG_DATA));
        (0, _rpcCalls2.default)("TaskManagementService.getDeleteTaskPopupInfo", [(0, _selectors4.getSelectedTaskIdsArray)(getState())], function (rpcError) {
            if (rpcError.getTextStatus() === "rpc_customException") {
                switch (rpcError.getErrorThrown().exception) {
                    case "com.actimind.actitime.services.BaseNewTasksService$NoRightsToManageTasksException":
                        alert(_messageResource2.default.getMessage("common.no_rights_for_operation_anymore"));
                        window.location.reload();
                        return true;
                }
            }
            return false;
        }).then(function (data) {
            if (data.taskIds.length === 0) {
                alert(_messageResource2.default.getMessage('task.delete.js.select_tasks_to_delete'));
            }
            dispatch((0, _utils.createActionObject)(ActionTypes.LOAD_BULK_DELETE_DIALOG_DATA_SUCCESS, _extends({}, data, { entitiesToDeleteCount: data.taskIds.length })));
            onSuccessCb();
        }).catch(function () {
            dispatch((0, _utils.createActionObject)(ActionTypes.LOAD_BULK_DELETE_DIALOG_DATA_FAILURE));
        });
    };
};

var deleteTasksAction = exports.deleteTasksAction = function deleteTasksAction(revokeStatus) {
    return function (dispatch, getState) {
        dispatch((0, _utils.createActionObject)(ActionTypes.BULK_TASKS_DELETE));

        var taskIds = (0, _selectors3.getBulkTaskDeleteDialogData)(getState()).taskIds;

        new _BulkDeleteTasksController2.default({
            onProgress: function onProgress(progress) {
                return dispatch(setBulkOperationProgress(progress));
            },
            onSuccess: function onSuccess(result) {
                dispatch((0, _utils.createActionObject)(ActionTypes.BULK_TASKS_DELETE_SUCCESS, result.successTaskIds));
                dispatch((0, _actions4.clearTaskSelectionAction)());
                dispatch((0, _actions3.toast)((0, _utils2.getDeletedTasksToastText)(result.successTaskIds, result.successTaskIds.length === 1 ? (0, _selectors.getTask)(getState(), result.successTaskIds[0]) : null)));
                dispatch((0, _actions2.removeTasks)(result.deletedTaskIds.concat(result.successTaskIds)));
                dispatch((0, _actions2.reloadTasks)());
            },
            onFailure: function onFailure(error) {
                dispatch((0, _utils.createActionObject)(ActionTypes.BULK_TASKS_DELETE_FAILURE));

                if (error.getTextStatus() === "rpc_customException") {
                    switch (error.getErrorThrown().exception) {
                        case "com.actimind.actitime.services.BaseNewTasksService$NoRightsToManageTasksException":
                            alert(_messageResource2.default.getMessage("common.no_rights_for_operation_anymore"));
                            window.location.reload();
                            return true;
                    }
                }
                return false;
            }
        }).processItems(taskIds, [revokeStatus], true);
    };
};

var startBulkMoveAction = exports.startBulkMoveAction = function startBulkMoveAction(onSuccessCb) {
    return function (dispatch) {
        dispatch((0, _utils.createActionObject)(ActionTypes.START_BULK_MOVE_OPERATION));
        dispatch(loadMoveDialogDataAction(onSuccessCb));
    };
};

var loadMoveDialogDataAction = exports.loadMoveDialogDataAction = function loadMoveDialogDataAction(onSuccessCb) {
    return function (dispatch, getState) {
        dispatch((0, _utils.createActionObject)(ActionTypes.LOAD_BULK_MOVE_DIALOG_DATA));
        (0, _rpcCalls2.default)("TaskManagementService.getMoveToDialogData", [(0, _selectors4.getSelectedTaskIdsArray)(getState())], function (rpcError) {
            if (rpcError.getTextStatus() === "rpc_customException") {
                switch (rpcError.getErrorThrown().exception) {
                    case "com.actimind.actitime.project.NoSuchProjectException":
                        alert(_messageResource2.default.getMessage("assign_to.tasks.project_was_deleted"));
                        window.location.reload();
                        return true;
                    case "com.actimind.actitime.task.ProjectIsNotAvailableException":
                        alert(_messageResource2.default.getMessage("common.no_rights_for_operation_anymore"));
                        window.location.reload();
                        return true;
                }
            }
            return false;
        }).then(function (data) {
            dispatch((0, _utils.createActionObject)(ActionTypes.LOAD_BULK_MOVE_DIALOG_DATA_SUCCESS, data));
            onSuccessCb();
        }).catch(function () {
            dispatch((0, _utils.createActionObject)(ActionTypes.LOAD_BULK_MOVE_DIALOG_DATA_FAILURE));
        });
    };
};

var moveTasksAction = exports.moveTasksAction = function moveTasksAction(customer, project, moveType, newWorkflowStatusId) {
    return function (dispatch, getState) {
        dispatch((0, _utils.createActionObject)(ActionTypes.BULK_TASKS_MOVE));
        var bulkMoveDialogData = (0, _selectors3.getBulkMoveDialogData)(getState());
        var taskIds = bulkMoveDialogData.taskIds;

        new _BulkMoveCopyTasksController2.default({
            method: 'TaskManagementService.moveTasks',
            onProgress: function onProgress(progress) {
                return dispatch(setBulkOperationProgress(progress));
            },
            onSuccess: function onSuccess(result) {
                dispatch((0, _utils.createActionObject)(ActionTypes.BULK_TASKS_MOVE_SUCCESS));
                if (result.successTasksCount > 0) {
                    dispatch((0, _actions2.reloadTasks)());
                }
                dispatch((0, _actions4.clearTaskSelectionAction)());
                var task = (0, _selectors.getTask)(getState(), taskIds[0]);
                dispatch((0, _actions3.toast)((0, _utils2.getMoveTasksToastText)(result.successTasksCount, project, result.successTasksCount === 1 ? task : null)));

                if (moveType === _constants2.BulkMoveTypes.OPEN_TO_ARCHIVED_WITH_RESTORE) {
                    if (customer.archived) {
                        dispatch((0, _actions3.toast)(_messageResource2.default.getMessage("status.customer.restored.toast", [customer.name])));
                        dispatch((0, _actions.addCustomer)(_extends({}, customer, { archived: false })));
                    }
                    dispatch((0, _actions.addProject)(_extends({}, project, { archived: false })));
                    dispatch((0, _actions3.toast)(_messageResource2.default.getMessage("status.project.restored.toast", [project.name])));
                } else if (bulkMoveDialogData.includeOpenTasks && (customer.archived || project.archived)) {
                    if (result.successTasksCount === 1) {
                        dispatch((0, _actions3.toast)(_messageResource2.default.getMessage("status.task.completed.toast", [task.name])));
                    } else {
                        dispatch((0, _actions3.toast)(_messageResource2.default.getMessage("status.tasks.completed.toast")));
                    }
                }

                if (result.duplicateNameTasksCount > 0) dispatch((0, _actions3.toast)(_messageResource2.default.getMessage('move.tasks.renamed.toast')));

                if (result.invalidTaskStatusCount > 0) {
                    dispatch((0, _actions3.toast)(_messageResource2.default.getMessage("task.error.move.task_reopened.bulk")));
                }

                SyncCallbacks.afterBulkTasksMovedToCb();
            },
            onFailure: function onFailure(error) {
                dispatch((0, _utils.createActionObject)(ActionTypes.BULK_TASKS_MOVE_FAILURE));
                if (error.errorThrown.exception === "com.actimind.actitime.services.NoRightsForRemoteCallException") {
                    alert(_messageResource2.default.getMessage("task.list.error.bulk.no_manage_scope_right"));
                    window.location.reload();
                    return true;
                }
                if (error.getTextStatus() === "rpc_customException") {
                    switch (error.getErrorThrown().exception) {
                        case _ExceptionsTypes.NO_SUCH_PROJECT_EXCEPTION:
                            alert(_messageResource2.default.getMessage("task.list.error.bulk.project_deleted"));
                            window.location.reload();
                            return true;
                        case _ExceptionsTypes.PROJECT_IS_NOT_ASSIGNED_EXCEPTION:
                            alert(_messageResource2.default.getMessage("task.list.error.bulk.project_not_assigned"));
                            window.location.reload();
                            return true;
                        case _ExceptionsTypes.PROJECT_IS_ARCHIVED_EXCEPTION:
                            alert(_messageResource2.default.getMessage("task.list.error.bulk.project_archived"));
                            window.location.reload();
                            return true;
                    }
                }
                return false;
            }
        }).processItems(taskIds, [project.id, moveType, newWorkflowStatusId], true);
    };
};

var copyTasksAction = exports.copyTasksAction = function copyTasksAction(taskIds, projectId, settings, operationId) {
    return function (dispatch, getState) {
        var successCb = function successCb(result) {
            dispatch((0, _actions4.clearTaskSelectionAction)());
            dispatch((0, _actions3.toast)((0, _utils2.getCopyTasksToastText)(result.successTasksCount, (0, _selectors.getProject)(getState(), projectId), result.successTasksCount === 1 ? (0, _selectors.getTask)(getState(), taskIds[0]) : null)));
            if (result.duplicateNameTasksCount > 0) dispatch((0, _actions3.toast)(_messageResource2.default.getMessage('copy.tasks.renamed.toast')));
        };

        dispatch(copyTasks('TaskManagementService.copyTasks', taskIds, [projectId, (0, _actions5.separateTaskCopySettings)(settings), operationId], successCb));
    };
};

var copyTasksToProjectsAction = exports.copyTasksToProjectsAction = function copyTasksToProjectsAction(taskIds, projectOldIdToNewId, settings, operationId) {
    return function (dispatch) {
        dispatch(copyTasks('TaskManagementService.copyTasksToProjects', taskIds, [(0, _rpcUtils.map)(projectOldIdToNewId), (0, _actions5.separateTaskCopySettings)(settings), operationId]));
    };
};

var copyTasks = function copyTasks(method, taskIds, params) {
    var successCb = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function () {};
    return function (dispatch) {
        dispatch((0, _utils.createActionObject)(ActionTypes.BULK_TASKS_COPY));

        new _BulkMoveCopyTasksController2.default({
            method: method,
            onProgress: function onProgress(progress) {
                return dispatch(setBulkOperationProgress(progress));
            },
            onSuccess: function onSuccess(result) {
                dispatch((0, _utils.createActionObject)(ActionTypes.BULK_TASKS_COPY_SUCCESS));

                if (result.successTasksCount > 0) {
                    dispatch((0, _actions2.reloadTasks)());
                }
                successCb(result);
            },
            onFailure: function onFailure(error) {
                dispatch((0, _utils.createActionObject)(ActionTypes.BULK_TASKS_COPY_FAILURE));

                if (error.getTextStatus() === "rpc_customException") {
                    switch (error.getErrorThrown().exception) {
                        case "com.actimind.actitime.services.NoRightsForRemoteCallException":
                            alert(_messageResource2.default.getMessage("task.list.copy_to.bulk.error.no_manage_scope_right"));
                            window.location.reload();
                            return true;
                        case "com.actimind.actitime.task.NoSuchTaskException":
                            alert(_messageResource2.default.getMessage("task.list.error.task_deleted"));
                            window.location.reload();
                            return true;
                        case "com.actimind.actitime.project.NoSuchProjectException":
                            alert(_messageResource2.default.getMessage("task.list.copy_to.bulk.error.project_deleted"));
                            window.location.reload();
                            return true;
                        case "com.actimind.actitime.project.ProjectIsNotAssignedException":
                            alert(_messageResource2.default.getMessage("task.list.copy_to.bulk.error.project_not_assigned"));
                            window.location.reload();
                            return true;
                        case "com.actimind.actitime.task.ProjectIsArchivedException":
                            alert(_messageResource2.default.getMessage("task.list.copy_to.bulk.error.project_archived"));
                            window.location.reload();
                            return true;
                        case "com.actimind.actitime.customer.NoSuchCustomerException":
                            alert(_messageResource2.default.getMessage("project.error.customer_deleted_concurrently"));
                            window.location.reload();
                            return true;
                    }
                }
                return false;
            }
        }).processItems(taskIds, params);
    };
};

var startBulkAssignAction = exports.startBulkAssignAction = function startBulkAssignAction(onSuccessCb) {
    return function (dispatch) {
        dispatch((0, _utils.createActionObject)(ActionTypes.START_BULK_ASSIGN_TASKS_OPERATION));
        dispatch(loadAssignDialogDataAction(onSuccessCb));
    };
};

var loadAssignDialogDataAction = exports.loadAssignDialogDataAction = function loadAssignDialogDataAction(onSuccessCb) {
    return function (dispatch, getState) {
        dispatch((0, _utils.createActionObject)(ActionTypes.LOAD_BULK_ASSIGN_DIALOG_DATA));
        (0, _rpcCalls2.default)('TaskManagementService.getAssignTasksPopupInfo', [(0, _selectors4.getSelectedTaskIdsArray)(getState())], function (rpcError) {
            if (rpcError.getTextStatus() === "rpc_customException") {
                switch (rpcError.getErrorThrown().exception) {
                    case "com.actimind.actitime.services.BaseNewTasksService$NoRightsToManageTasksException":
                        alert(_messageResource2.default.getMessage("common.no_rights_for_operation_anymore"));
                        window.location.reload();
                        return true;
                    case "com.actimind.actitime.project.NoSuchProjectException":
                        alert(_messageResource2.default.getMessage("assign_to.tasks.project_was_deleted"));
                        window.location.reload();
                        return true;
                    case "com.actimind.actitime.task.ProjectIsNotAvailableException":
                        alert(_messageResource2.default.getMessage("common.no_rights_for_operation_anymore"));
                        window.location.reload();
                        return true;
                }
            }

            return false;
        }).then(function (data) {
            var loggedInUserId = (0, _selectors5.getLoggedInUserId)(getState());
            var allManagers = data.assignedUsersData.users.map(function (user) {
                var userWithAccessRights = _UserWithAccessRights2.default.fromRPC(user);
                Object.assign(userWithAccessRights, user);
                userWithAccessRights.canBeModified = !user.hasManageAssignment;
                return userWithAccessRights;
            }).sort(function (u1, u2) {
                return u1.lastName.localeCompare(u2.lastName);
            });
            var availableManagers = allManagers.filter(function (user) {
                return user.assignedToViewer && user.id !== loggedInUserId;
            });
            var selectedUserIds = availableManagers.filter(function (user) {
                return !user.canBeModified;
            }).map(function (user) {
                return user.id;
            });

            dispatch((0, _utils.createActionObject)(ActionTypes.LOAD_BULK_ASSIGN_DIALOG_DATA_SUCCESS, _extends({}, data.assignedUsersData, {
                users: availableManagers,
                selectedUserIds: selectedUserIds,
                taskIds: data.taskIds,
                numberOfTasks: data.taskIds.length
            })));
            onSuccessCb();
        }).catch(function (e) {
            console.log(e);
            dispatch((0, _utils.createActionObject)(ActionTypes.LOAD_BULK_ASSIGN_DIALOG_DATA_FAILURE));
        });
    };
};

var setBulkAssignDialogSelection = (0, _reduxActions.createAction)(ActionTypes.BULK_ASSIGN_DIALOG_SELECTION_SET);

var changeBulkAssignDialogSelection = exports.changeBulkAssignDialogSelection = function changeBulkAssignDialogSelection(addedUserIds, removedUserIds) {
    return function (dispatch, getState) {
        var removedUserIdsSet = (0, _atUtils.arrayToSet)(removedUserIds);
        var selectedUserIds = (0, _selectors3.getBulkAssignDialogData)(getState()).selectedUserIds.concat(addedUserIds).filter(function (userId) {
            return !removedUserIdsSet[userId];
        });
        dispatch(setBulkAssignDialogSelection(selectedUserIds));
    };
};

var changeTasksAssignmentsAction = exports.changeTasksAssignmentsAction = function changeTasksAssignmentsAction(userIds) {
    return function (dispatch, getState) {
        dispatch((0, _utils.createActionObject)(ActionTypes.BULK_ASSIGN_TASKS));

        var taskIds = (0, _selectors3.getBulkAssignDialogData)(getState()).taskIds;

        new _BulkChangeAssignmentsTasksController2.default({
            onProgress: function onProgress(progress) {
                return dispatch(setBulkOperationProgress(progress));
            },
            onSuccess: function onSuccess(result) {
                dispatch((0, _utils.createActionObject)(ActionTypes.BULK_ASSIGN_TASKS_SUCCESS));
                dispatch((0, _actions4.clearTaskSelectionAction)());
                dispatch((0, _actions2.setViewerSettings)(result.viewerSettings));
                dispatch((0, _actions2.setManagementAssignments)(result.managementAssignments));

                var taskIdsSize = result.taskIds.length;
                var userIdsSize = Object.keys(result.userIds).length;

                dispatch((0, _actions3.toast)((0, _utils2.getAssignedTaskToastText)(taskIdsSize, userIdsSize, taskIdsSize === 1 ? (0, _selectors.getTask)(getState(), result.taskIds[0]) : null)));

                if (userIdsSize !== userIds.length) {
                    dispatch((0, _actions3.toast)(_messageResource2.default.getMessage('assign_to.tasks.toast.some_users_unassigned')));
                }

                if (taskIds.length !== taskIdsSize) {
                    dispatch((0, _actions2.reloadTasks)());
                }

                // update user settings
                SyncCallbacks.afterBulkChangeTasksAssignmentsCb(result);
            },
            onFailure: function onFailure(error) {
                dispatch((0, _utils.createActionObject)(ActionTypes.BULK_ASSIGN_TASKS_FAILURE));

                if (error.getTextStatus() === "rpc_customException") {
                    switch (error.getErrorThrown().exception) {
                        case "com.actimind.actitime.services.BaseNewTasksService$NoRightsToManageTasksException":
                            alert(_messageResource2.default.getMessage("common.no_rights_for_operation_anymore"));
                            window.location.reload();
                            return true;
                        case "com.actimind.actitime.project.NoSuchProjectException":
                            alert(_messageResource2.default.getMessage("assign_to.tasks.project_was_deleted"));
                            window.location.reload();
                            return true;
                        case "com.actimind.actitime.task.ProjectIsNotAvailableException":
                            alert(_messageResource2.default.getMessage("common.no_rights_for_operation_anymore"));
                            window.location.reload();
                            return true;
                    }
                }

                return false;
            }
        }).processItems(taskIds, [userIds]);
    };
};

var startBulkChangeTasksStatusAction = exports.startBulkChangeTasksStatusAction = function startBulkChangeTasksStatusAction(successCb) {
    return function (dispatch) {
        dispatch((0, _utils.createActionObject)(ActionTypes.START_BULK_CHANGE_TASKS_STATUS_OPERATION));
        dispatch(loadBulkChangeTasksStatusDialogDataAction(successCb));
    };
};

var loadBulkChangeTasksStatusDialogDataAction = exports.loadBulkChangeTasksStatusDialogDataAction = function loadBulkChangeTasksStatusDialogDataAction(successCb) {
    return function (dispatch, getState) {
        dispatch((0, _utils.createActionObject)(ActionTypes.LOAD_BULK_CHANGE_STATUS_DIALOG_DATA));
        (0, _rpcCalls2.default)("TaskManagementService.getChangeWorkflowStatusPopupInfo", [(0, _selectors4.getSelectedTaskIdsArray)(getState())], function (rpcError) {
            if (rpcError.getTextStatus() === "rpc_customException") {
                switch (rpcError.getErrorThrown().exception) {
                    case "com.actimind.actitime.services.BaseNewTasksService$NoRightsToManageTasksException":
                        alert(_messageResource2.default.getMessage("common.no_rights_for_operation_anymore"));
                        window.location.reload();
                        return true;
                    case "com.actimind.actitime.project.NoSuchProjectException":
                        alert(_messageResource2.default.getMessage("assign_to.tasks.project_was_deleted"));
                        window.location.reload();
                        return true;
                    case "com.actimind.actitime.task.ProjectIsNotAvailableException":
                        alert(_messageResource2.default.getMessage("common.no_rights_for_operation_anymore"));
                        window.location.reload();
                        return true;
                }
            }

            return false;
        }).then(function (data) {
            dispatch((0, _utils.createActionObject)(ActionTypes.LOAD_BULK_CHANGE_STATUS_DIALOG_DATA_SUCCESS, data));
            successCb();
        }).catch(function () {
            dispatch((0, _utils.createActionObject)(ActionTypes.LOAD_BULK_CHANGE_STATUS_DIALOG_DATA_FAILURE));
        });
    };
};

var changeTasksStatusAction = exports.changeTasksStatusAction = function changeTasksStatusAction(workflowStatusId) {
    var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return function (dispatch, getState) {
        dispatch((0, _utils.createActionObject)(ActionTypes.BULK_CHANGE_TASKS_STATUS));

        var state = getState();

        var taskIds = (0, _selectors3.getBulkChangeStatusDialogData)(state).taskIds;

        var workflowStatusesEnabled = (0, _selectors2.isTWSEnabled)(state);
        var workflowStatus = (0, _selectors.getWorkflowStatuses)(state)[workflowStatusId];
        var method = workflowStatusesEnabled ? 'TaskManagementService.changeWorkflowStatusTasks' : 'TaskManagementService.changeStatusTasks';
        var params = workflowStatusesEnabled ? [workflowStatus.type, workflowStatus.id, workflowStatus.name, force] : [workflowStatus.type, force];

        new _BulkChangeStatusTasksController2.default({
            method: method,
            onProgress: function onProgress(progress) {
                return dispatch(setBulkOperationProgress(progress));
            },
            onSuccess: function onSuccess(result) {
                dispatch((0, _utils.createActionObject)(ActionTypes.BULK_CHANGE_TASKS_STATUS_SUCCESS));

                var taskIds = result.taskIds;
                var completed = workflowStatus.type === _constants.WorkflowStatusType.COMPLETED;

                var allTasks = (0, _selectors.getTasks)(getState());
                var updatedTasks = [];
                /*
                   TODO incorrect action name using
                   https://github.com/Actimind-Development/actitime/issues/825
                 */
                dispatch((0, _actions2.setLastCreatedTaskIds)(taskIds));

                taskIds.forEach(function (id) {
                    var task = allTasks[id];
                    if (task) {
                        updatedTasks.push(_extends({}, allTasks[id], {
                            completed: completed,
                            workflowStatusId: workflowStatusId
                        }));
                    }
                });
                dispatch((0, _actions.addTasks)(updatedTasks));
                dispatch((0, _actions.addProjects)(Object.values(result.restoredProjects)));
                dispatch((0, _actions.addCustomers)(Object.values(result.restoredCustomers)));

                dispatch((0, _actions4.clearTaskSelectionAction)());

                dispatch((0, _actions3.toast)((0, _utils2.getStatusChangedTaskToastText)(taskIds.length, taskIds.length === 1 ? (0, _selectors.getTask)(getState(), result.taskIds[0]) : null)));
                dispatch((0, _actions2.reloadTasks)());
                SyncCallbacks.afterBulkTasksStatusChangeCb();
            },
            onFailure: function onFailure(error) {
                dispatch((0, _utils.createActionObject)(ActionTypes.BULK_CHANGE_TASKS_STATUS_FAILURE));

                if (error.getTextStatus() === "rpc_customException") {
                    switch (error.getErrorThrown().exception) {
                        case "com.actimind.actitime.services.BaseNewTasksService$NoRightsToManageTasksException":
                            alert(_messageResource2.default.getMessage("common.no_rights_for_operation_anymore"));
                            window.location.reload();
                            return true;
                        case "com.actimind.actitime.project.NoSuchProjectException":
                            alert(_messageResource2.default.getMessage("assign_to.tasks.project_was_deleted"));
                            window.location.reload();
                            return true;
                        case "com.actimind.actitime.task.ProjectIsNotAvailableException":
                            alert(_messageResource2.default.getMessage("common.no_rights_for_operation_anymore"));
                            window.location.reload();
                            return true;
                        case "com.actimind.actitime.task.ProjectIsArchivedException":
                            // confirm reopening of archived project containing this task
                            if (confirm(_messageResource2.default.getMessage('task.complete.js.reopening_confirmation_tasks_archived'))) {
                                dispatch(changeTasksStatusAction(workflowStatusId, true));
                            }
                            return true;
                        case "com.actimind.actitime.administration.NoSuchWorkflowStatusException":
                            alert(_messageResource2.default.getMessage("change_tasks_workflow_status.no_such_workflow_status_error"));
                            window.location.reload();
                            return true;
                        case "com.actimind.actitime.services.WorkflowStatusChangedException":
                            alert(_messageResource2.default.getMessage("change_tasks_workflow_status.workflow_status_changed_error"));
                            window.location.reload();
                            return true;
                        case "com.actimind.actitime.services.WorkflowStatusesFeatureBecameEnabledException":
                            alert(_messageResource2.default.getMessage("change_tasks_workflow_status.feature_became_enabled"));
                            window.location.reload();
                            return true;
                        case "com.actimind.actitime.services.WorkflowStatusesFeatureBecameDisabledException":
                            alert(_messageResource2.default.getMessage("change_tasks_workflow_status.feature_became_disabled"));
                            window.location.reload();
                            return true;
                    }
                }
                return false;
            }
        }).processItems(taskIds, params, true);
    };
};

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getBulkChangeStatusDialogData = exports.getBulkMoveDialogData = exports.getBulkAssignDialogData = exports.getBulkTaskDeleteDialogData = exports.getCurrentOperation = exports.getBulkOperationProgress = exports.isProcessingBulkOperation = exports.getBulkOperationsPanelState = exports.isShowPanel = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reselect = __webpack_require__(13);

var _selectors = __webpack_require__(189);

var _TaskManagementStore = __webpack_require__(140);

var _TaskManagementStore2 = _interopRequireDefault(_TaskManagementStore);

var _selectors2 = __webpack_require__(57);

var _selectors3 = __webpack_require__(106);

var _selectors4 = __webpack_require__(15);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getBulkOperationsPanel = (0, _reselect.createSelector)(_selectors.selectTaskManagement, function (tm) {
    return tm.bulkOperationsPanel;
});

var isShowPanel = exports.isShowPanel = (0, _reselect.createSelector)(_selectors3.getSelectedTaskIdsArray, _selectors3.isPendingSelectAll, function (selectedIds, pendingSelectAll) {
    return selectedIds.length > 0 || pendingSelectAll;
});

var getBulkOperationsPanelState = exports.getBulkOperationsPanelState = (0, _reselect.createSelector)(_selectors3.getSelectedTaskIdsArray, getBulkOperationsPanel, _selectors3.isExistingTaskIdsLoading, _selectors3.getExistingTaskIdsForView, _selectors3.isTasksLoaded, function (selectedTaskIds, bulkOperationsPanel, existingTaskIdsLoading, existingTaskIds, tasksLoaded) {
    return {
        loading: existingTaskIdsLoading || !tasksLoaded,
        selectedTasksCount: selectedTaskIds.length,
        existingTasksCount: Object.keys(existingTaskIds).length
    };
});

var isProcessingBulkOperation = exports.isProcessingBulkOperation = (0, _reselect.createSelector)(getBulkOperationsPanel, function (bulkOperationPanel) {
    return bulkOperationPanel.operationProcessing;
});

var getBulkOperationProgress = exports.getBulkOperationProgress = (0, _reselect.createSelector)(getBulkOperationsPanel, function (bulkOperationPanel) {
    return bulkOperationPanel.operationProgress;
});

var getCurrentOperation = exports.getCurrentOperation = (0, _reselect.createSelector)(getBulkOperationsPanel, function (bulkOperationPanel) {
    return bulkOperationPanel.currentOperation;
});

var getBulkTaskDeleteDialogData = exports.getBulkTaskDeleteDialogData = (0, _reselect.createSelector)(getBulkOperationsPanel, function (bulkOperationPanel) {
    var deleteDialogData = bulkOperationPanel.deleteDialogData;
    return _extends({}, deleteDialogData, {
        otherBlockedTaskCount: deleteDialogData.entitiesBlockedCount - deleteDialogData.entitiesBlocked.length,
        hasManagerApprover: _TaskManagementStore2.default.getManagerNeedApproval()
    });
});

var getBulkAssignDialogData = exports.getBulkAssignDialogData = (0, _reselect.createSelector)(getBulkOperationsPanel, _selectors4.isURAEnabled, _selectors4.isBTYEnabled, _selectors4.isTTAEnabled, function (bulkOperationsPanel, userRatesEnabled, billingTypesEnabled, timeTrackApprovalEnabled) {
    return _extends({}, bulkOperationsPanel.assignToDialogData, {
        userRatesEnabled: userRatesEnabled,
        billingTypesEnabled: billingTypesEnabled,
        timeTrackApprovalEnabled: timeTrackApprovalEnabled
    });
});

var getBulkMoveDialogData = exports.getBulkMoveDialogData = (0, _reselect.createSelector)(getBulkOperationsPanel, function (bulkOperationsPanel) {
    return bulkOperationsPanel.moveDialogData;
});

var getBulkChangeStatusDialogData = exports.getBulkChangeStatusDialogData = (0, _reselect.createSelector)(getBulkOperationsPanel, _selectors2.getDefaultOpenWorkflowStatus, function (bulkOperationsPanel, defaultStatus) {
    return _extends({}, bulkOperationsPanel.changeStatusDialogData, {
        numberOfTasks: bulkOperationsPanel.changeStatusDialogData.taskIds.length,
        defaultWorkflowStatusId: defaultStatus.id
    });
});

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _rpcCalls = __webpack_require__(24);

var _rpcCalls2 = _interopRequireDefault(_rpcCalls);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MAX_CHUNK_SIZE = 200;

var BulkOperationsController = function () {
    function BulkOperationsController(_ref) {
        var method = _ref.method,
            initialResult = _ref.initialResult,
            _ref$combineFn = _ref.combineFn,
            combineFn = _ref$combineFn === undefined ? function () {} : _ref$combineFn,
            _ref$onProgress = _ref.onProgress,
            onProgress = _ref$onProgress === undefined ? function () {} : _ref$onProgress,
            _ref$onSuccess = _ref.onSuccess,
            onSuccess = _ref$onSuccess === undefined ? function () {} : _ref$onSuccess,
            _ref$onFailure = _ref.onFailure,
            onFailure = _ref$onFailure === undefined ? function () {} : _ref$onFailure;

        _classCallCheck(this, BulkOperationsController);

        this.params = {
            method: method,
            initialResult: initialResult,
            combineFn: combineFn,
            onProgress: onProgress,
            onSuccess: onSuccess,
            onFailure: onFailure
        };
    }

    _createClass(BulkOperationsController, [{
        key: 'processItems',
        value: function processItems(items, args) {
            var _this = this;

            var operationIdRequired = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

            var index = 0;
            var result = this.params.initialResult;

            var methodParams = operationIdRequired ? [].concat(_toConsumableArray(args), [null]) : args;

            var makeRpcCall = function makeRpcCall() {
                var chunk = items.slice(index, index + MAX_CHUNK_SIZE);

                (0, _rpcCalls.longRpcCall)(_this.params.method, [chunk].concat(_toConsumableArray(methodParams)), function (error) {
                    return _this.params.onFailure(error);
                }).then(function (chunkResult) {
                    index += MAX_CHUNK_SIZE;
                    result = _this.params.combineFn(result, chunkResult);

                    if (operationIdRequired && chunkResult.operationId) methodParams = [].concat(_toConsumableArray(args), [chunkResult.operationId]);

                    var percent = Math.trunc(Math.min(index / items.length * 100, 100));
                    _this.params.onProgress(percent);

                    if (index < items.length) makeRpcCall();else _this.params.onSuccess(result);
                }).catch(function (error) {
                    // errors handled in errorHandler
                });
            };

            makeRpcCall();
        }
    }]);

    return BulkOperationsController;
}();

exports.default = BulkOperationsController;

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.createLinkToCustomer = exports.createLinkToProject = exports.createLinkToTask = exports.createAbsoluteLinkToEntity = exports.replaceIdIntoQuery = exports.removeUrlParamFromQuery = exports.getStringFromQuery = exports.getIdFromQuery = undefined;

var _urijs = __webpack_require__(340);

var _urijs2 = _interopRequireDefault(_urijs);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _constants = __webpack_require__(4);

var _constants2 = __webpack_require__(765);

var _atUtils = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Get num id from query by key
 * Take url from current location into browser
 * @param queryKey key of id
 * @returns {*} null or id of entity
 */
var getIdFromQuery = exports.getIdFromQuery = function getIdFromQuery(queryKey) {
    var uri = (0, _urijs2.default)();
    var hasKey = uri.hasQuery(queryKey);
    if (hasKey) {
        var value = getExtractedParamFromUrlByQuery(uri, queryKey);

        if (value !== null && value.length !== 0 && (0, _atUtils.isInt)(value)) {
            return Number(value);
        }
        return null;
    } else {
        return null;
    }
};

var getStringFromQuery = exports.getStringFromQuery = function getStringFromQuery(queryKey) {
    var uri = (0, _urijs2.default)();
    var hasKey = uri.hasQuery(queryKey);
    if (hasKey) {
        var value = getExtractedParamFromUrlByQuery(uri, queryKey);

        if (value !== null && value.length !== 0) {
            return value;
        }
        return null;
    } else {
        return null;
    }
};

var removeUrlParamFromQuery = exports.removeUrlParamFromQuery = function removeUrlParamFromQuery(queryKey) {
    window.history.replaceState({}, '', (0, _urijs2.default)().removeQuery([queryKey]));
};

var replaceIdIntoQuery = exports.replaceIdIntoQuery = function replaceIdIntoQuery(queryKey, id, prevId) {
    window.history.replaceState({}, '', (0, _urijs2.default)().removeQuery(queryKey, prevId).addQuery(queryKey, id));
};

var createAbsoluteLinkToEntity = exports.createAbsoluteLinkToEntity = function createAbsoluteLinkToEntity(queryKey, id) {
    return (0, _urijs2.default)().pathname(_urijs2.default.joinPaths(window.BASE_PATH, _constants.TASK_MANAGEMENT_RELATIVE_PATH)).query(_defineProperty({}, queryKey, id)).toString();
};

var createLinkToTask = exports.createLinkToTask = function createLinkToTask(id) {
    return createAbsoluteLinkToEntity(_constants2.TASK_ID_QUERY_KEY, id);
};
var createLinkToProject = exports.createLinkToProject = function createLinkToProject(id) {
    return createAbsoluteLinkToEntity(_constants2.PROJECT_ID_QUERY_KEY, id);
};
var createLinkToCustomer = exports.createLinkToCustomer = function createLinkToCustomer(id) {
    return createAbsoluteLinkToEntity(_constants2.CUSTOMER_ID_QUERY_KEY, id);
};

function getExtractedParamFromUrlByQuery(uri, queryKey) {
    var value = uri.query(true)[queryKey];
    if (_underscore2.default.isArray(value)) {
        value = value[0];
    }
    return value;
}

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _LoadingControlMixin = __webpack_require__(136);

var _LoadingControlMixin2 = _interopRequireDefault(_LoadingControlMixin);

var _Tooltip2 = __webpack_require__(183);

var _Tooltip3 = _interopRequireDefault(_Tooltip2);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _atBrowserUtils = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NameInput = function (_TemplateView) {
    _inherits(NameInput, _TemplateView);

    function NameInput(_ref) {
        var _ref$editable = _ref.editable,
            editable = _ref$editable === undefined ? false : _ref$editable,
            _ref$placeholder = _ref.placeholder,
            placeholder = _ref$placeholder === undefined ? '' : _ref$placeholder,
            _ref$maxLength = _ref.maxLength,
            maxLength = _ref$maxLength === undefined ? null : _ref$maxLength,
            _ref$showEmptyInput = _ref.showEmptyInput,
            showEmptyInput = _ref$showEmptyInput === undefined ? false : _ref$showEmptyInput,
            _ref$errorText = _ref.errorText,
            errorText = _ref$errorText === undefined ? _messageResource2.default.getMessage('panel.common.error_tooltip.empty_name') : _ref$errorText,
            _ref$onChangeCb = _ref.onChangeCb,
            onChangeCb = _ref$onChangeCb === undefined ? function (name, oldName) {} : _ref$onChangeCb,
            _ref$onFocusCb = _ref.onFocusCb,
            onFocusCb = _ref$onFocusCb === undefined ? function () {} : _ref$onFocusCb;

        _classCallCheck(this, NameInput);

        var _this = _possibleConstructorReturn(this, (NameInput.__proto__ || Object.getPrototypeOf(NameInput)).call(this));

        _this.params = {
            placeholder: placeholder,
            maxLength: maxLength
        };

        _this.callbacks = {
            onChangeCb: onChangeCb,
            onFocusCb: onFocusCb
        };

        _this.state = {
            name: '',
            focus: showEmptyInput,
            editable: editable,
            invalid: false,
            errorText: errorText,
            isNeedInitializeFocus: false
        };

        _this.onStatePropertyBecameTrue('isNeedInitializeFocus', function () {
            _underscore2.default.delay(function () {
                return _this.$input.focus();
            }, 1000);
        });

        _this.onStatePropertyChanged('invalid', function (invalid) {
            _this.$el.toggleClass('invalid', invalid);
            _this.errorTooltip.toggle(invalid);
        });

        _this.onStatePropertyChanged('name', function (name) {
            _this.$nameLabel.text(name);
            _this.$input.pVal(name);
            _this._updateTooltip();
        });

        _this.onStatePropertyChanged('editable', function (editable) {
            _this.$el.toggleClass('editable', editable);
            _this._updateTooltip();
        });

        _this.onStatePropertyChanged('focus', function (focus) {
            _this.$nameInput.toggle(focus);
            _this.$nameLabel.toggle(!focus);
        });

        _this.onStatePropertyChanged('errorText', function (text) {
            _this.errorTooltip.$el.text(text);
        });
        return _this;
    }

    _createClass(NameInput, [{
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='nameInfo'>" + "  <div class='nameLabel'/>" + "  <div class='nameInput'><input type='text' <% if (maxLength) {%>maxlength='<%-maxLength%>'<%}%>/></div>" + "</div>";
        }
    }, {
        key: "templateModel",
        value: function templateModel() {
            return {
                "maxLength": this.params.maxLength
            };
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            var _this2 = this;

            this.$nameLabel = this.find('.nameLabel');
            this.$input = this.find('input');
            this.$nameInput = this.find('.nameInput');

            this.$input.attr('placeholder', this.params.placeholder);
            this.$input.click(function () {
                return _this2._onFocus();
            });
            this.$nameInput.click(function () {
                return _this2._onFocus();
            });
            this.$nameLabel.click(function () {
                return _this2._onFocus();
            });
            this.$input.blur(function (e) {
                _this2._onBlur(e);
            });
            this.$input.keydown(function (e) {
                (0, _atBrowserUtils.handleEnter)(function (e) {
                    e.stopPropagation();
                    _this2.setState({
                        focus: false
                    });
                }, e);
                (0, _atBrowserUtils.handleEscape)(function (e) {
                    e.stopPropagation();
                    _this2.setState({
                        focus: false
                    });
                }, e);
            });

            this.errorTooltip = new ErrorTooltip().init((0, _jquery2.default)("body"));
            this.errorTooltip.subscribeToMouseEvents(this.$nameInput);

            this.renderInitialState();
        }
    }, {
        key: "getName",
        value: function getName() {
            return this.state.name;
        }
    }, {
        key: "resetName",
        value: function resetName(name) {
            this.setState({
                name: name,
                invalid: false,
                focus: false
            });
        }
    }, {
        key: "_onFocus",
        value: function _onFocus() {
            if (!this.state.editable) return;

            this.setState({
                invalid: false,
                focus: true
            });
            this.$input.focus();
            this.callbacks.onFocusCb();
        }
    }, {
        key: "_onBlur",
        value: function _onBlur() {
            this.setState({
                focus: false
            });
            var newName = this.$input.pVal().trim();
            this.callbacks.onChangeCb(newName, this.state.name);
        }
    }, {
        key: "_updateTooltip",
        value: function _updateTooltip() {
            !this.state.editable && this.$nameLabel.attr('title', this.state.name);
        }
    }, {
        key: "setEditable",
        value: function setEditable(editable) {
            this.setState({
                editable: editable
            });
        }
    }]);

    return NameInput;
}(_TemplateView3.default);

exports.default = NameInput;

var ErrorTooltip = function (_Tooltip) {
    _inherits(ErrorTooltip, _Tooltip);

    function ErrorTooltip() {
        _classCallCheck(this, ErrorTooltip);

        return _possibleConstructorReturn(this, (ErrorTooltip.__proto__ || Object.getPrototypeOf(ErrorTooltip)).apply(this, arguments));
    }

    _createClass(ErrorTooltip, [{
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='nameInputTooltip yellowTooltip tooltipTex noprint'/>";
        }
    }]);

    return ErrorTooltip;
}(_Tooltip3.default);

_underscore2.default.extend(NameInput.prototype, _LoadingControlMixin2.default);

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _ProjectStore = __webpack_require__(59);

var _ProjectStore2 = _interopRequireDefault(_ProjectStore);

var _CustomerStore = __webpack_require__(65);

var _CustomerStore2 = _interopRequireDefault(_CustomerStore);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _LoadingControlMixin = __webpack_require__(136);

var _LoadingControlMixin2 = _interopRequireDefault(_LoadingControlMixin);

var _atUtils = __webpack_require__(5);

var _SimpleTooltip = __webpack_require__(36);

var _SimpleTooltip2 = _interopRequireDefault(_SimpleTooltip);

var _BlockedTasksList = __webpack_require__(773);

var _BlockedTasksList2 = _interopRequireDefault(_BlockedTasksList);

var _CPCombobox = __webpack_require__(372);

var _CPCombobox2 = _interopRequireDefault(_CPCombobox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MoveToDialog = function (_TemplateView) {
    _inherits(MoveToDialog, _TemplateView);

    function MoveToDialog(_ref) {
        var mode = _ref.mode,
            titleMessageKey = _ref.titleMessageKey,
            buttonMessageKey = _ref.buttonMessageKey,
            _ref$onMoveCb = _ref.onMoveCb,
            onMoveCb = _ref$onMoveCb === undefined ? function (customerId, projectId, settings) {} : _ref$onMoveCb,
            _ref$onCancelCb = _ref.onCancelCb,
            onCancelCb = _ref$onCancelCb === undefined ? function () {} : _ref$onCancelCb,
            _ref$infoBlock = _ref.infoBlock,
            infoBlock = _ref$infoBlock === undefined ? null : _ref$infoBlock,
            _ref$settingsBlock = _ref.settingsBlock,
            settingsBlock = _ref$settingsBlock === undefined ? null : _ref$settingsBlock,
            _ref$selectedCustomer = _ref.selectedCustomer,
            selectedCustomer = _ref$selectedCustomer === undefined ? null : _ref$selectedCustomer;

        _classCallCheck(this, MoveToDialog);

        var _this = _possibleConstructorReturn(this, (MoveToDialog.__proto__ || Object.getPrototypeOf(MoveToDialog)).call(this));

        _this.props = {
            mode: mode,
            titleMessageKey: titleMessageKey,
            buttonMessageKey: buttonMessageKey
        };

        _this.state = {
            showArchived: false,

            selectedProject: null,
            selectedCustomer: selectedCustomer,
            moveEnabled: false,

            projectsToMove: {},
            customersToMove: {}
        };

        _this.components = {
            infoBlock: infoBlock,
            settingsBlock: settingsBlock
        };

        _this.callbacks = {
            onMoveCb: onMoveCb,
            onCancelCb: onCancelCb
        };

        _this.onStatePropertyChanged('selectedCustomer', function (selectedCustomer) {
            if (!!selectedCustomer && _this.projectsCombobox) {
                var projects = _ProjectStore2.default.getByCustomer(selectedCustomer.id).filter(function (p) {
                    return _this.state.projectsToMove[p.id] && (_this.state.showArchived || !p.archived);
                }).sort(_atUtils.nameComparator);
                _this.setStateInternal({
                    selectedProject: projects.length === 1 ? projects[0] : null
                });
                _this.projectsCombobox.setState({
                    items: projects,
                    selectedItemId: !!_this.state.selectedProject ? _this.state.selectedProject.id : DEFAULT_COMBOBOX_ITEM_ID
                });
            }
        });

        _this.onAnyStatePropertyChanged(['selectedProject', 'selectedCustomer'], function () {
            var moveEnabled = !!_this.state.selectedCustomer && (_this.props.mode === MoveToDialog.Mode.CUSTOMER || !!_this.state.selectedProject);
            _this.getEl().toggleClass("actionEnabled", moveEnabled);

            _this.setStateInternal({
                moveEnabled: moveEnabled
            });

            _this.customersCombobox.setState({
                selectedItemId: !!_this.state.selectedCustomer ? _this.state.selectedCustomer.id : DEFAULT_COMBOBOX_ITEM_ID
            });
            if (!!_this.projectsCombobox) _this.projectsCombobox.setState({
                selectedItemId: !!_this.state.selectedProject ? _this.state.selectedProject.id : DEFAULT_COMBOBOX_ITEM_ID
            });
        });

        _this.onStatePropertyChanged('showArchived', function (showArchived) {
            if (_this.projectsCombobox) {
                _this.projectsCombobox.setState({
                    emptyListMessageKey: showArchived ? "task.list.move_to.no_projects" : "task.list.move_to.no_active_projects"
                });
            }
        });
        return _this;
    }

    _createClass(MoveToDialog, [{
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='moveToDialog'>" + "  <div class='title'><%-titleMessageKey%></div>" + "  <div class='customer'>" + "    <div class='label'></div>" + "    <div class='selectorContainer'></div>" + "  </div>" + "  <div class='points'/>" + "  <div class='project'>" + "    <div class='label'></div>" + "    <div class='selectorContainer'></div>" + "  </div>" + "  <div class='settingsBlockContainer'/>" + "  <div class='informationBlockContainer'/>" + "  <div class='blockedWarningContainer'>" + "      <div class='link'><%-warningLinkText%></div>" + "      <div class='other'><%-warningCommentText%></div>" + "  </div>" + "  <div class='buttonsContainer'>" + "    <div class='ok button'><%=moveLabel%></div>" + "    <div class='cancel button'><%=cancelLabel%></div>" + "  </div>" + "</div>";
        }
    }, {
        key: "messageKeys",
        value: function messageKeys() {
            return {
                titleMessageKey: this.props.titleMessageKey,
                customerLabel: "common.Customer",
                projectLabel: "common.Project",
                moveLabel: this.props.buttonMessageKey,
                cancelLabel: "common.cancel",
                warningLinkText: "task.list.move_to.bulk.warning.link_text",
                warningCommentText: "task.list.move_to.bulk.warning.comment_text"
            };
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            var _this2 = this;

            this.$title = this.find('.title');
            this.$blockedWarningContainer = this.find('.blockedWarningContainer');
            this.$blockedWarningLink = this.find(".blockedWarningContainer .link");

            this.customersCombobox = new _CPCombobox2.default({
                emptySelectionMessageKey: "task.list.move_to.select_customer",
                notFoundMessageKey: "task.list.move_to.no_customers_found",
                hiddenItemsCollapsedMessageKey: 'task.list.move_to.show_archived_customers',
                hiddenItemsExpandedMessageKey: 'task.list.move_to.hide_archived_customers',
                emptyListMessageKey: "task.list.move_to.no_customers",
                onItemSelectedCb: function onItemSelectedCb(item) {
                    _this2.customersCombobox.setState({ selectedItemId: item.id });
                    _this2.setState({ selectedCustomer: item });
                }
            }).init(this.find(".customer .selectorContainer"));

            this.find(".points").toggle(this.props.mode === MoveToDialog.Mode.CUSTOMER_PROJECT);
            if (this.props.mode === MoveToDialog.Mode.CUSTOMER_PROJECT) {
                this.getEl().addClass("hasProject");

                this.projectsCombobox = new _CPCombobox2.default({
                    emptySelectionMessageKey: "task.list.move_to.select_project",
                    notFoundMessageKey: "task.list.move_to.no_projects_found",
                    emptyListMessageKey: "task.list.move_to.no_projects",
                    hiddenItemsCollapsedMessageKey: 'task.list.move_to.show_archived_projects',
                    hiddenItemsExpandedMessageKey: 'task.list.move_to.hide_archived_projects',
                    onItemSelectedCb: function onItemSelectedCb(item) {
                        _this2.projectsCombobox.setState({ selectedItemId: item.id });
                        _this2.setState({ selectedProject: item });
                    }
                }).init(this.find(".project .selectorContainer"));
            }

            this.find(".ok.button").click(function () {
                if (_this2.state.moveEnabled) {
                    (0, _jquery2.default)(_this2).trigger("move", {
                        projectId: _this2.state.selectedProject,
                        customerId: _this2.state.selectedCustomer
                    });
                    _this2.callbacks.onMoveCb(_this2.state.selectedCustomer, _this2.state.selectedProject ? _this2.state.selectedProject : null, _this2.components.settingsBlock ? _this2.components.settingsBlock.getSelectedSettings() : null);
                }
            });

            this.find(".cancel.button").click(function () {
                (0, _jquery2.default)(_this2).trigger("cancel");
                _this2.callbacks.onCancelCb();
            });

            this.$settingsBlockContainer = this.find('.settingsBlockContainer');
            this.$settingsBlockContainer.toggle(!!this.components.settingsBlock);
            if (this.components.settingsBlock) {
                this.components.settingsBlock.init(this.$settingsBlockContainer);
            }

            this.$informationBlockContainer = this.find('.informationBlockContainer');
            this.$informationBlockContainer.toggle(!!this.components.infoBlock);
            if (this.components.infoBlock) {
                this.components.infoBlock.init(this.$informationBlockContainer);
            }

            this.renderInitialState();
        }
    }, {
        key: "show",
        value: function show() {
            _get(MoveToDialog.prototype.__proto__ || Object.getPrototypeOf(MoveToDialog.prototype), "show", this).call(this);
            this.updateSelector();
        }
    }, {
        key: "updateSelector",
        value: function updateSelector() {
            var _this3 = this;

            this.setState({
                selectedProject: null
            });

            var customers = _CustomerStore2.default.getAll().filter(function (c) {
                return !!_this3.state.customersToMove[c.id] && (_this3.state.showArchived || !c.archived);
            }).sort(_atUtils.nameComparator);

            this.customersCombobox.setState({
                items: customers
            });
        }
    }, {
        key: "setShowArchived",
        value: function setShowArchived(showArchived) {
            this.setState({
                showArchived: showArchived
            });
        }
    }, {
        key: "setProjectsToMove",
        value: function setProjectsToMove(projectIds) {
            this.setState({
                projectsToMove: projectIds
            });
        }
    }, {
        key: "setCustomersToMove",
        value: function setCustomersToMove(customerIds) {
            this.setState({
                customersToMove: customerIds
            });
        }
    }, {
        key: "updateTitle",
        value: function updateTitle(title) {
            this.$title.text(title);
        }
    }, {
        key: "updateNotAvailableTasks",
        value: function updateNotAvailableTasks(tasks) {
            var _this4 = this;

            if (this.blockedEntitiesList) {
                this.blockedEntitiesList.setDisabled(true);
                this.blockedEntitiesList.getEl().remove();
            }
            this.$blockedWarningContainer.toggle(tasks.length !== 0);
            if (tasks.length !== 0) {
                this.blockedEntitiesList = new _BlockedTasksList2.default((0, _jquery2.default)("body"), tasks, 0).init();
                this.$blockedWarningLink.click(function () {
                    if (!_this4.blockedEntitiesList.isDisabled()) _this4.blockedEntitiesList.showAt(_this4.$blockedWarningLink, {
                        offset: "10px 20px",
                        at: "right bottom",
                        my: "left bottom",
                        collision: "none"
                    });
                });
            }
        }
    }]);

    return MoveToDialog;
}(_TemplateView3.default);

exports.default = MoveToDialog;


var DEFAULT_COMBOBOX_ITEM_ID = -1;

_underscore2.default.extend(MoveToDialog.prototype, _LoadingControlMixin2.default);

MoveToDialog.Mode = {
    CUSTOMER_PROJECT: "CUSTOMER_PROJECT",
    CUSTOMER: "CUSTOMER"
};

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Combobox2 = __webpack_require__(1379);

var _Combobox3 = _interopRequireDefault(_Combobox2);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _atUtils = __webpack_require__(5);

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _SearchItemList = __webpack_require__(774);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CPCombobox = function (_Combobox) {
    _inherits(CPCombobox, _Combobox);

    function CPCombobox(_ref) {
        var _ref$emptySelectionMe = _ref.emptySelectionMessageKey,
            emptySelectionMessageKey = _ref$emptySelectionMe === undefined ? '' : _ref$emptySelectionMe,
            _ref$notFoundMessageK = _ref.notFoundMessageKey,
            notFoundMessageKey = _ref$notFoundMessageK === undefined ? '' : _ref$notFoundMessageK,
            _ref$hiddenItemsColla = _ref.hiddenItemsCollapsedMessageKey,
            hiddenItemsCollapsedMessageKey = _ref$hiddenItemsColla === undefined ? '' : _ref$hiddenItemsColla,
            _ref$hiddenItemsExpan = _ref.hiddenItemsExpandedMessageKey,
            hiddenItemsExpandedMessageKey = _ref$hiddenItemsExpan === undefined ? '' : _ref$hiddenItemsExpan,
            _ref$emptyListMessage = _ref.emptyListMessageKey,
            emptyListMessageKey = _ref$emptyListMessage === undefined ? '' : _ref$emptyListMessage,
            _ref$emptySelectionId = _ref.emptySelectionId,
            emptySelectionId = _ref$emptySelectionId === undefined ? -1 : _ref$emptySelectionId,
            _ref$positionParams = _ref.positionParams,
            positionParams = _ref$positionParams === undefined ? null : _ref$positionParams,
            _ref$onItemSelectedCb = _ref.onItemSelectedCb,
            onItemSelectedCb = _ref$onItemSelectedCb === undefined ? function (entity) {} : _ref$onItemSelectedCb,
            _ref$onListShowCb = _ref.onListShowCb,
            onListShowCb = _ref$onListShowCb === undefined ? function () {} : _ref$onListShowCb,
            _ref$onListHideCb = _ref.onListHideCb,
            onListHideCb = _ref$onListHideCb === undefined ? function () {} : _ref$onListHideCb,
            inputMaxLength = _ref.inputMaxLength;

        _classCallCheck(this, CPCombobox);

        return _possibleConstructorReturn(this, (CPCombobox.__proto__ || Object.getPrototypeOf(CPCombobox)).call(this, {
            hideItemPredicate: function hideItemPredicate(item) {
                return item.archived;
            },
            onItemSelectedCb: onItemSelectedCb,
            onListShowCb: onListShowCb,
            onListHideCb: onListHideCb,
            hiddenItemsCollapsedMessageKey: hiddenItemsCollapsedMessageKey,
            hiddenItemsExpandedMessageKey: hiddenItemsExpandedMessageKey,
            notFoundMessageKey: notFoundMessageKey,
            emptySelectionMessageKey: emptySelectionMessageKey,
            emptyListMessageKey: emptyListMessageKey,
            positionParams: positionParams,
            emptySelectionId: emptySelectionId,
            additionalClass: "cpCombobox",
            inputMaxLength: inputMaxLength
        }));
    }

    _createClass(CPCombobox, [{
        key: 'renderMenuItem',
        value: function renderMenuItem(item, tokensHighlighter, selectedItemId) {
            var _this2 = this;

            return new CPItemRow({
                item: item,
                tokensHighlighter: tokensHighlighter,
                clickCallback: function clickCallback() {
                    return _this2._onItemSelected(item);
                },
                additionalClass: selectedItemId === item.id ? 'selected' : ''
            });
        }
    }, {
        key: 'renderAdditionalMenuItem',
        value: function renderAdditionalMenuItem(item, selectedItemId) {
            var _this3 = this;

            return new _SearchItemList.ItemRow({
                name: item.name,
                clickCallback: function clickCallback() {
                    return _this3._onItemSelected(item);
                },
                additionalClass: selectedItemId === item.id ? 'selected' : ''
            });
        }
    }, {
        key: 'renderSelectedItemHtml',
        value: function renderSelectedItemHtml(item) {
            return (0, _atUtils.escapeHtmlSymbols)(item.name) + (item.archived ? " <span class='archived'>" + _messageResource2.default.getMessage("common.archived") + "</span>" : "");
        }
    }]);

    return CPCombobox;
}(_Combobox3.default);

exports.default = CPCombobox;

var CPItemRow = function (_TemplateView) {
    _inherits(CPItemRow, _TemplateView);

    function CPItemRow(_ref2) {
        var item = _ref2.item,
            tokensHighlighter = _ref2.tokensHighlighter,
            _ref2$clickCallback = _ref2.clickCallback,
            clickCallback = _ref2$clickCallback === undefined ? function () {} : _ref2$clickCallback,
            _ref2$additionalClass = _ref2.additionalClass,
            additionalClass = _ref2$additionalClass === undefined ? '' : _ref2$additionalClass;

        _classCallCheck(this, CPItemRow);

        var _this4 = _possibleConstructorReturn(this, (CPItemRow.__proto__ || Object.getPrototypeOf(CPItemRow)).call(this));

        _this4.params = {
            item: item,
            tokensHighlighter: tokensHighlighter,
            clickCallback: clickCallback,
            additionalClass: additionalClass
        };
        return _this4;
    }

    _createClass(CPItemRow, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class="itemRow cpItemRow <%-additionalClass%>"><%=name%></div>';
        }
    }, {
        key: 'templateModel',
        value: function templateModel() {
            return {
                additionalClass: this.params.additionalClass,
                name: this.params.tokensHighlighter.highlightTokens(this.params.item.name) + (this.params.item.archived ? " <span class='archived'>" + _messageResource2.default.getMessage("common.archived") + "</span>" : "")
            };
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            var _this5 = this;

            this.$el.click(function () {
                return _this5.params.clickCallback();
            });
        }
    }]);

    return CPItemRow;
}(_TemplateView3.default);

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Ext = __webpack_require__(12);

var _Ext2 = _interopRequireDefault(_Ext);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _at_flat_button = __webpack_require__(351);

var _at_flat_button2 = _interopRequireDefault(_at_flat_button);

var _GroupType = __webpack_require__(34);

var _GroupType2 = _interopRequireDefault(_GroupType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GroupSelectorSwitcher = _Ext2.default.extend(_Ext2.default.Panel, {

    cls: "viewByPanel",

    init: function init(userGroupsEnabled, timeZoneGroupsEnabled, groupByUserGroupCallback, groupByTimeZoneGroupCallback) {
        this.userGroupsEnabled = userGroupsEnabled;
        this.timeZoneGroupsEnabled = timeZoneGroupsEnabled;

        this.groupByUserGroupCallback = groupByUserGroupCallback;
        this.groupByTimeZoneGroupCallback = groupByTimeZoneGroupCallback;

        this.addComponents();

        if (!userGroupsEnabled) this.addClass("uzgDisabled");

        if (!timeZoneGroupsEnabled) this.addClass("tzgDisabled");
    },

    addComponents: function addComponents() {
        if (this.userGroupsEnabled && this.timeZoneGroupsEnabled) {
            this.addSortByUserGroupLink();
            this.addSortByTimeZoneGroupLink();
        } else if (this.userGroupsEnabled) {
            this.addTextPanel(_messageResource2.default.getEscapedMessage("user_selector.group_by.by_user_groups") + ":");
        } else if (this.timeZoneGroupsEnabled) {
            this.addTextPanel(_messageResource2.default.getEscapedMessage("user_selector.group_by.by_time_zone_groups") + ":");
        }
    },

    addSortByUserGroupLink: function addSortByUserGroupLink() {
        this.addSortByLink(_messageResource2.default.getEscapedMessage("user_selector.group_by.by_user_groups"), "userGroupLabel", this.groupByUserGroupCallback);
    },

    addSortByTimeZoneGroupLink: function addSortByTimeZoneGroupLink() {
        this.addSortByLink(this.getSortByTimeZoneGroupLinkText(), "timeZoneGroupLabel", this.groupByTimeZoneGroupCallback);
    },

    getSortByTimeZoneGroupLinkText: function getSortByTimeZoneGroupLinkText() {
        return _messageResource2.default.getEscapedMessage("user_selector.group_by.by_time_zones");
    },

    addSortByLink: function addSortByLink(text, className, groupByCallback) {
        var sortByTimeZoneGroupLink = new _at_flat_button2.default({
            text: text,
            cls: "sortingLabel " + className
        });
        sortByTimeZoneGroupLink.on("click", groupByCallback, this);
        this.add(sortByTimeZoneGroupLink);
    },

    addTextPanel: function addTextPanel(text) {
        this.add(new _Ext2.default.Panel({
            html: text,
            cls: "sortingLabel textLabel"
        }));
    },

    updateUI: function updateUI(groupType) {
        this.removeClass('groupedByUserGroup');
        this.removeClass('groupedByTimeZoneGroup');
        if (groupType) {
            if (groupType == _GroupType2.default.TIME_ZONE_GROUP) {
                this.addClass('groupedByTimeZoneGroup');
            } else {
                this.addClass('groupedByUserGroup');
            }
        }
    }

});

_Ext2.default.reg("at_group_selector_switcher", GroupSelectorSwitcher);

exports.default = GroupSelectorSwitcher;

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Ext = __webpack_require__(12);

var _Ext2 = _interopRequireDefault(_Ext);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _at_hierarchy_selector_selection_helper = __webpack_require__(738);

var _at_hierarchy_selector_selection_helper2 = _interopRequireDefault(_at_hierarchy_selector_selection_helper);

var _GroupType = __webpack_require__(34);

var _GroupType2 = _interopRequireDefault(_GroupType);

var _GroupValidatorStrategy = __webpack_require__(186);

var _user_group_selector_util = __webpack_require__(98);

var _atUtils = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SimpleUsersAndGroupsSelectionHelper = _Ext2.default.extend(_at_hierarchy_selector_selection_helper2.default, {

    userSingularFormKey: "users_selector.user.singular",
    disabledUserKey: "users_selector.disabled",
    usersWithoutGroupKey: "users_selector.users_without_user_group_label",
    isNeededInformationAboutDisabledUsers: true,
    userSelectorGroupsStrategy: null,
    prefixTextForGroupsKey: null,
    pleaseSelectMessageKey: "users_selector.no_users_selected",
    userGroupMessageKey: "common.user_group",
    timeZoneGroupMessageKey: "common.time_zone.group",
    viewerId: null,

    getDescription: function getDescription(selection, dropdownButtonId) {
        var groups = selection.getFirstLevel();
        var users = selection.getSecondLevel();
        var type = selection.groupType;
        var validatorGroupStrategy = type == _GroupType2.default.TIME_ZONE_GROUP ? new _GroupValidatorStrategy.TimeZoneGroupValidatorStrategy() : new _GroupValidatorStrategy.UserGroupValidatorStrategy();
        if (groups.length == 0 && users.length == 0) {
            return this.getMessage(this.pleaseSelectMessageKey);
        } else if (groups.length + users.length == 1) {
            var isSingleGroupSelected = groups.length == 1;
            return this.getSingleItemText((isSingleGroupSelected ? groups : users)[0], isSingleGroupSelected, validatorGroupStrategy);
        } else {
            return this.getShortDescriptionForUsersAndGroups(groups, users, dropdownButtonId, type);
        }
    },

    getSingleItemText: function getSingleItemText(item, isGroup, strategy) {
        var text = "";
        if (isGroup) {
            text += strategy.isNullGroup(item) ? this.getMessage(this.usersWithoutGroupKey) : (0, _atUtils.escapeHtmlSymbols)(item.getName());
        } else {
            var nounMsg = this.getMessage(this.itemNounSingularKey);
            if (!_Ext2.default.isEmpty(nounMsg)) {
                text += nounMsg + " ";
            }
            var formattedUserName = this.viewerId === item.id ? _messageResource2.default.getMessage("usersselector.me") : (0, _atUtils.escapeHtmlSymbols)(this.formatUserNameInfo(item));
            text += formattedUserName;
        }

        if (this.showSingleItemInactiveText && !isGroup && !item.isActive()) {
            text += " " + this.getMessage(this.inactiveSingleItemTextKey);
        }
        return text;
    },

    getSingleGroupTextKey: function getSingleGroupTextKey(groupType) {
        return groupType == _GroupType2.default.USER_GROUP ? this.userGroupMessageKey : this.timeZoneGroupMessageKey;
    },

    getMultipleGroupTextKey: function getMultipleGroupTextKey(groupType) {
        return this.getSingleGroupTextKey(groupType) + "s";
    },

    getShortDescriptionForUsersAndGroups: function getShortDescriptionForUsersAndGroups(groups, users, dropdownButtonId, groupType) {
        var result = "";
        var isGroupsPresent = groups.length != 0;
        var isUsersPresent = users.length != 0;
        if (isGroupsPresent) {
            if (this.prefixTextForGroupsKey) result += this.getMessage(this.prefixTextForGroupsKey) + " ";
            result += groups.length + " ";
            result += groups.length == 1 ? this.getMessage(this.getSingleGroupTextKey(groupType)) : this.getMessage(this.getMultipleGroupTextKey(groupType));
            if (isUsersPresent) {
                if (dropdownButtonId) {
                    result = this.wrapTextByTitleSpans(result, dropdownButtonId, true);
                }
                result += " & ";
            }
        }
        if (isUsersPresent) {
            var itemNoun;
            var inactiveText = "";
            var subResult = "";

            if (users.length == 1) {
                itemNoun = this.getMessage(this.userSingularFormKey);
                inactiveText = !this.isNeededInformationAboutDisabledUsers || users[0].isActive() ? "" : " " + this.getMessage(this.disabledUserKey);
            } else {
                itemNoun = this.getMessage(this.itemNounPluralKey);
                if (this.isNeededInformationAboutDisabledUsers) {
                    var inactiveCount = 0;

                    for (var i = 0; i < users.length; i++) {
                        if (!users[i].isActive()) {
                            ++inactiveCount;
                        }
                    }
                }
            }

            subResult += users.length + " ";
            subResult += itemNoun + inactiveText;

            if (dropdownButtonId && isGroupsPresent) {
                subResult = this.wrapTextByTitleSpans(subResult, dropdownButtonId, false);
            }
            result += subResult;
        }
        return result;
    },

    getCertainEntityList: function getCertainEntityList(selection, isForGroup) {
        var context = this;
        if (isForGroup) {
            return this.getListDescription(selection.getFirstLevel(), function (item) {
                return context.getListDescriptionItemForGroup(item);
            }, selection.groupType == _GroupType2.default.TIME_ZONE_GROUP ? new _GroupValidatorStrategy.TimeZoneGroupValidatorStrategy().getComparator() : new _GroupValidatorStrategy.UserGroupValidatorStrategy().getComparator(), this.getMessage(this.getMultipleGroupTextKey(selection.groupType)));
        } else {
            return this.getListDescription(selection.getSecondLevel(), function (item) {
                return context.getListDescriptionItemForUser(item);
            }, _user_group_selector_util.userComparator);
        }
    },

    getListDescriptionItemForUser: function getListDescriptionItemForUser(user) {
        return (0, _atUtils.concatStr)(this.formatUserNameInfo(user), this.getListDescriptionItemStatus(user), " ");
    },

    getListDescriptionItemForGroup: function getListDescriptionItemForGroup(group) {
        return group.name;
    },

    getListDescriptionItemStatus: function getListDescriptionItemStatus(user) {
        if (!user.isActive()) {
            return this.getMessage(this.disabledUserKey);
        }
    },

    formatUserNameInfo: function formatUserNameInfo(user) {
        // not polymorphic. if in future we have more than 2 variants, how to format user name in selectors, we should use strategy here.
        return user.formatNameLFM();
    },

    setUserSelectorGroupsStrategy: function setUserSelectorGroupsStrategy(userSelectorGroupsStrategy) {
        this.userSelectorGroupsStrategy = userSelectorGroupsStrategy;
    }

});

exports.default = SimpleUsersAndGroupsSelectionHelper;

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.applyDataToAssignedUsersEditor = applyDataToAssignedUsersEditor;
exports.applyActionResultToAssignedUsersEditor = applyActionResultToAssignedUsersEditor;

var _groupUtils = __webpack_require__(71);

function applyDataToAssignedUsersEditor(editor, _ref) {
    var users = _ref.users,
        userGroups = _ref.userGroups,
        timeZoneGroups = _ref.timeZoneGroups,
        userGroupsEnabled = _ref.userGroupsEnabled,
        timeZoneGroupsEnabled = _ref.timeZoneGroupsEnabled,
        canModifyAny = _ref.canModifyAny;

    var userGroupsWithDefault = userGroups ? (0, _groupUtils.addDefaultUserGroup)(userGroups) : userGroups;
    editor.setState({
        users: users,
        userGroups: userGroupsWithDefault,
        timeZoneGroups: timeZoneGroups,
        userGroupsEnabled: userGroupsEnabled,
        timeZoneGroupsEnabled: timeZoneGroupsEnabled,
        canModifyAny: canModifyAny,
        loading: false
    });
}

function applyActionResultToAssignedUsersEditor(editor, actionResult) {
    editor.setState({ loading: true });

    return actionResult.then(function (data) {
        applyDataToAssignedUsersEditor(editor, data);
    }).catch(function (e) {
        editor.setState({ loading: false });
        throw e;
    });
}

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _EditTaskPanelContainer = __webpack_require__(377);

var _EditTaskPanelContainer2 = _interopRequireDefault(_EditTaskPanelContainer);

var _CreateTasksPopupController = __webpack_require__(505);

var _CreateTasksPopupController2 = _interopRequireDefault(_CreateTasksPopupController);

var _CreateReportPopup = __webpack_require__(791);

var _CreateReportPopup2 = _interopRequireDefault(_CreateReportPopup);

var _ChartMediator = __webpack_require__(794);

var _ChartMediator2 = _interopRequireDefault(_ChartMediator);

var _utils = __webpack_require__(6);

var _redux = __webpack_require__(7);

var _constants = __webpack_require__(181);

var _actions = __webpack_require__(81);

var _actions2 = __webpack_require__(306);

var _selectors = __webpack_require__(19);

var _selectors2 = __webpack_require__(143);

var _utils2 = __webpack_require__(25);

var _constants2 = __webpack_require__(77);

var _jquery_rpc = __webpack_require__(26);

var _jquery_rpc2 = _interopRequireDefault(_jquery_rpc);

var _checkAndSendLicenceUserEvent = __webpack_require__(1487);

var _checkAndSendLicenceUserEvent2 = _interopRequireDefault(_checkAndSendLicenceUserEvent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var NextBridge = function () {
    function NextBridge() {
        _classCallCheck(this, NextBridge);

        this.listeners = {
            customerPanelClosed: [],
            projectPanelClosed: [],
            taskPanelClosed: [],
            tasksCreated: [],
            taskDeleted: [],
            taskMoved: [],
            taskUpdated: [],
            taskAddedToTimesheet: [],
            projectDeleted: [],
            profileSettingsChanged: [],
            chartSaved: [],
            chartClosed: [],
            navigationResize: [],
            demoDataJustLoaded: []
        };
        this.basePath = window.BASE_PATH;
        this.GlobalConstants = window.__GENERATED_CONSTANTS__;
        this.SystemSettings = window.SystemSettings;
        this.stripeJsAuthKey = window.StripeConfig.KEY;
    }

    _createClass(NextBridge, [{
        key: 'getNavigationBarElement',
        value: function getNavigationBarElement() {
            return document.querySelector('.navBg');
        }
    }, {
        key: 'getLicenseTipElement',
        value: function getLicenseTipElement() {
            return document.querySelector('.licenseCountDownTip');
        }
    }, {
        key: 'getAddonsPopupElement',
        value: function getAddonsPopupElement() {
            return document.querySelector('.addonsMenuDropdownDialog');
        }
    }, {
        key: '_init',
        value: function _init() {
            var _this = this;

            this.actions = (0, _utils.unsafe_bindActions)(function (dispatch) {
                return {
                    openSupportForm: (0, _redux.bindActionCreators)(_actions2.openSupportForm, dispatch),
                    openEditTaskPanel: (0, _redux.bindActionCreators)(_actions.openEditTaskPanel, dispatch)
                };
            });

            (0, _jquery2.default)(document).on('close_user_profile_event', function () {
                _this.listeners.profileSettingsChanged.forEach(function (handler) {
                    return handler();
                });
            });

            (0, _jquery2.default)(document).on('navigation_resize_event', function (e, _ref) {
                var navigationCollapsed = _ref.navigationCollapsed;

                _this.listeners.navigationResize.forEach(function (handler) {
                    return handler(navigationCollapsed);
                });
            });

            (0, _jquery2.default)(document).on('task_added_to_timesheet_event', function (_, hasError) {
                _this.listeners.taskAddedToTimesheet.forEach(function (handler) {
                    return handler(hasError);
                });
            });

            (0, _jquery2.default)(document).on('demo_data_just_loaded', function () {
                _this.listeners.demoDataJustLoaded.forEach(function (handler) {
                    return handler();
                });
            });
        }
    }, {
        key: 'isNavigationCollapsed',
        value: function isNavigationCollapsed() {
            return window.NAVIGATION_COLLAPSED;
        }

        /**
         * Get logged in user from classic store
         */

    }, {
        key: 'getMe',
        value: function getMe() {
            return (0, _utils.unsafe_selectWithState)(function (state) {
                return (0, _selectors.getLoggedInUser)(state);
            });
        }

        /**
         * Init components necessary for enterTT
         */

    }, {
        key: 'initEnterTT',
        value: function initEnterTT() {
            this._init();
            this.initNewTaskPopup();
        }
    }, {
        key: 'initReports',
        value: function initReports() {
            this._init();
            this.initCreateReportPopup();
            this.initCreateChartPopup();
        }
    }, {
        key: 'initCustomFieldsList',
        value: function initCustomFieldsList() {
            this._init();
        }
    }, {
        key: 'initPriorityList',
        value: function initPriorityList() {
            this._init();
        }
    }, {
        key: 'initNextReport',
        value: function initNextReport() {
            this._init();
            this.initCreateReportPopup();
        }
    }, {
        key: 'initLicenses',
        value: function initLicenses() {
            this._init();
        }
    }, {
        key: 'initGeneralSettings',
        value: function initGeneralSettings(initialGeneralSettingsFormData) {
            this.initialGeneralSettingsFormData = initialGeneralSettingsFormData;
            this._init();
        }

        /**
         * Used only for lazy initialization
         */

    }, {
        key: 'initTaskPanel',
        value: function initTaskPanel() {
            var _this2 = this;

            this.editTaskPanelContainer = new _EditTaskPanelContainer2.default({
                onTaskDeletedCb: function onTaskDeletedCb(taskId) {
                    return _this2.listeners.taskDeleted.forEach(function (handler) {
                        return handler(taskId);
                    });
                },
                onTaskMovedCb: function onTaskMovedCb(taskId) {
                    return _this2.listeners.taskMoved.forEach(function (handler) {
                        return handler(taskId);
                    });
                }
            });
            (0, _jquery2.default)(document).on('editTaskPanel_updateTask', function (e, _ref2) {
                var taskId = _ref2.taskId;

                _this2.listeners.taskUpdated.forEach(function (handler) {
                    return handler(taskId);
                });
            });
            (0, _jquery2.default)(document).on('editTaskPanel_projectDeleted', function (e, _ref3) {
                var projectId = _ref3.projectId;

                _this2.listeners.projectDeleted.forEach(function (handler) {
                    return handler(projectId);
                });
            });
            this.editTaskPanelContainer.init();
        }
    }, {
        key: 'initNewTaskPopup',
        value: function initNewTaskPopup() {
            var _this3 = this;

            this.createTasksPopupController = new _CreateTasksPopupController2.default({
                successTaskCreationCb: function successTaskCreationCb(result) {
                    return _this3.listeners.tasksCreated.forEach(function (handler) {
                        return handler(result);
                    });
                },
                serviceName: "AddNewTasksService"
            });

            window.onloadLightbox = function () {
                if (window.editDescriptionPopup.hide()) {
                    window.editDescriptionPopup.showAboveBasicPopups();
                    return true;
                }
                return false;
            };
            window.onHideLightBox = function () {
                window.editDescriptionPopup.showUnderBasicPopups();
            };
        }

        /**
         * Open side task panel for specified taskId
         * @param taskId - classic task id
         * @param event - mouse event that caused the action
         */

    }, {
        key: 'openTaskPanel',
        value: function openTaskPanel(taskId, event) {
            if (!this.editTaskPanelContainer) {
                this.initTaskPanel();
            }
            (0, _utils2.setEventPreventHidingEditTaskSlidingPanel)(_jquery2.default.Event(event));
            this.actions.openEditTaskPanel(taskId);
        }

        /**
         * Open new task popup for specified user and dayOnWeek
         * @param selectedUserId
         * @param submitTtParams
         */

    }, {
        key: 'openNewTaskPopup',
        value: function openNewTaskPopup(selectedUserId, submitTtParams) {
            this.createTasksPopupController.showPopup(null, null, selectedUserId, false, submitTtParams);
        }
    }, {
        key: 'getLicensesData',
        value: function getLicensesData() {
            return {
                currentUsedUserCount: (0, _utils.unsafe_selectWithState)(function (state) {
                    return (0, _selectors2.currentUsedUserCount)(state);
                })
            };
        }

        /**
         * Subscribe to classic interface events.
         * - taskPanelClosed
         * - tasksCreated
         * - taskDeleted
         * - taskMoved
         * @param handlers - list of handlers in {[key:string] : handler: (data: any) => void}
         */

    }, {
        key: 'subscribeToEvent',
        value: function subscribeToEvent(handlers) {
            var _this4 = this;

            Object.keys(handlers).forEach(function (name) {
                var handler = handlers[name];
                if (!_this4.listeners[name]) throw new Error("Invalid event name " + name);
                if (!_this4.listeners[name].find(function (h) {
                    return h === handler;
                })) _this4.listeners[name].push(handler);
            });
        }
    }, {
        key: 'checkAndSendLicenseUserEvent',
        value: function checkAndSendLicenseUserEvent(isFree) {
            return (0, _checkAndSendLicenceUserEvent2.default)(isFree);
        }

        /**
         * Open support form
         * @param positionParams - forms positioning params:
         *  positionStrategy can take the values: 'center', 'fromTopLeft', 'fromBottomRight'
         *  position takes the coordinates
         */

    }, {
        key: 'openSupportForm',
        value: function openSupportForm() {
            var positionParams = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
                positionStrategy: _constants.supportPopupPositionStrategy.CENTER,
                position: { x: 0, y: 0 }
            };

            this.actions.openSupportForm(positionParams);
        }

        /**
         * Opens user profile settings popup (profile.do)
         */

    }, {
        key: 'openProfileSettingsPopup',
        value: function openProfileSettingsPopup() {
            var highlightStartingNewWeekSection = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            (0, _jquery2.default)(document).trigger('open_user_profile_event', [highlightStartingNewWeekSection]);
        }
    }, {
        key: 'initCreateReportPopup',
        value: function initCreateReportPopup() {
            this.createReportPopup = new _CreateReportPopup2.default({
                reportUrls: _constants2.reportUrls,
                reportNameKeys: _constants2.reportNameKeys
            }).init();
        }
    }, {
        key: 'initCreateChartPopup',
        value: function initCreateChartPopup() {
            var _this5 = this;

            this.chartMediator = new _ChartMediator2.default(false, false);
            (0, _jquery2.default)(document).on('chartSaved', function (e, _ref4) {
                var chartId = _ref4.chartId;

                _this5.listeners.chartSaved.forEach(function (handler) {
                    return handler(chartId);
                });
            });
            (0, _jquery2.default)(document).on('chartClosed', function (e, _ref5) {
                var chartId = _ref5.chartId;

                _this5.listeners.chartClosed.forEach(function (handler) {
                    return handler(chartId);
                });
            });
        }

        /**
         * Opens create report popup
         */

    }, {
        key: 'openCreateReportPopup',
        value: function openCreateReportPopup() {
            this.createReportPopup.show();
        }

        /**
         * Opens chart popup for create
         */

    }, {
        key: 'openCreateChartPopup',
        value: function openCreateChartPopup() {
            this.chartMediator.loadNewChartData();
        }

        /**
         * Opens chart popup for edit
         * @param configId - chart configuration identifier
         */

    }, {
        key: 'openEditChartPopup',
        value: function openEditChartPopup(configId) {
            this.chartMediator.showChart(configId);
        }
    }, {
        key: 'onTaskAddedToTimesheet',
        value: function onTaskAddedToTimesheet(hasError) {
            (0, _jquery2.default)(document).trigger('task_added_to_timesheet_event', hasError);
        }
    }, {
        key: 'generalSettingsForm',
        value: function generalSettingsForm() {
            return document.forms["GeneralSettingsForm"];
        }
    }, {
        key: 'encode64',
        value: function encode64(str) {
            return window.Base64.encode(str, false);
        }
    }, {
        key: 'decode64',
        value: function decode64(str) {
            return window.Base64.decode(str, false);
        }
    }]);

    return NextBridge;
}();

var nextBridge = new NextBridge();
exports.default = nextBridge;

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _redux = __webpack_require__(7);

var _utils = __webpack_require__(6);

var _selectors = __webpack_require__(97);

var _actions = __webpack_require__(81);

var _actions2 = __webpack_require__(782);

var _EditTaskPanelContainer = __webpack_require__(783);

var _EditTaskPanelContainer2 = _interopRequireDefault(_EditTaskPanelContainer);

var _selectors2 = __webpack_require__(19);

var _selectors3 = __webpack_require__(15);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _utils.connect)(function (state) {
    return {
        isShown: (0, _selectors.isPanelOpened)(state),
        needToLoadData: (0, _selectors.isNeedToLoadData)(state),
        loading: (0, _selectors.isLoading)(state),
        openTaskId: (0, _selectors.getOpenTaskId)(state),
        openTaskNextId: (0, _selectors.getOpenTaskNextId)(state),
        isOpenTaskCompleted: (0, _selectors.getIsOpenTaskCompleted)(state),
        isTSTEnabled: (0, _selectors3.isTSTEnabled)(state),
        userRights: (0, _selectors2.getAccessRights)(state)
    };
}, function (dispatch) {
    return {
        openPanel: (0, _redux.bindActionCreators)(_actions.openEditTaskPanel, dispatch),
        onPanelHide: (0, _redux.bindActionCreators)(_actions.closeEditTaskPanel, dispatch),
        loadPanelData: (0, _redux.bindActionCreators)(_actions2.loadEditTaskPanelData, dispatch),
        copyLink: (0, _redux.bindActionCreators)(_actions.copyLinkTo, dispatch)
    };
})(_EditTaskPanelContainer2.default);

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ScheduleCalculator = __webpack_require__(789);

var _ScheduleCalculator2 = _interopRequireDefault(_ScheduleCalculator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CorporateScheduleCalculator() {
    this.constructor = CorporateScheduleCalculator;
}

CorporateScheduleCalculator.prototype = new _ScheduleCalculator2.default();

CorporateScheduleCalculator.prototype.init = function (invertedDaysMap, corporateSchedule) {
    var schedules = [];

    schedules.push({ durations: corporateSchedule });

    _ScheduleCalculator2.default.prototype.init.call(this, invertedDaysMap, schedules);

    return this;
};

exports.default = CorporateScheduleCalculator;

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _constants = __webpack_require__(11);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _atUtils = __webpack_require__(5);

var _user_time = __webpack_require__(30);

var _user_time2 = _interopRequireDefault(_user_time);

var _number_formatter = __webpack_require__(61);

var _number_formatter2 = _interopRequireDefault(_number_formatter);

var _date_format = __webpack_require__(16);

var _constants2 = __webpack_require__(4);

var _UserNameFormat = __webpack_require__(17);

var _UserNameFormat2 = _interopRequireDefault(_UserNameFormat);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var BaseFormatterCreator = function () {
    function BaseFormatterCreator() {
        _classCallCheck(this, BaseFormatterCreator);

        this.DATE_FORMAT = window.SystemSettings.dateFormat;
        this.TIME_FORMAT = window.SystemSettings.defaultTimeFormatForHTMLReports;
    }

    _createClass(BaseFormatterCreator, [{
        key: 'getCategoryToStringFunction',
        value: function getCategoryToStringFunction(selectedCategoryType) {
            var _this = this;

            switch (selectedCategoryType) {
                case _constants.ReportGroupingLevel.USER:
                    return function (user) {
                        if (user.id === _constants2.OTHER_USERS_ENTITY_ID) {
                            return _messageResource2.default.getMessage("report.other_users");
                        }
                        return _UserNameFormat2.default.formatLFM(user.firstName, user.lastName, user.middleName);
                    };
                case _constants.ReportGroupingLevel.USER_GROUP:
                    return function (group) {
                        if (group.id === window.SystemSettings.usersWithoutGroupId) {
                            return _messageResource2.default.getMessage("common.users_without_group");
                        }
                        if (group.id === _constants2.OTHER_USER_GROUPS_ENTITY_ID) {
                            return _messageResource2.default.getMessage("report.other_user_groups");
                        }
                        return group.name;
                    };
                case _constants.ReportGroupingLevel.TIME_ZONE_GROUP:
                    return function (group) {
                        var name = group.name;
                        if (group.id === _constants2.DEFAULT_TIME_ZONE_GROUP_ID) {
                            name += " " + _messageResource2.default.getMessage("common.default_group");
                        }
                        return name;
                    };
                case _constants.ReportGroupingLevel.LEAVE_TYPE:
                    return function (leaveType) {
                        return LeaveTypeUtil.getLeaveTypeName(leaveType);
                    };
                case _constants.ReportGroupingLevel.CUSTOMER:
                    return function (customer) {
                        return customer.name;
                    };
                case _constants.ReportGroupingLevel.PROJECT:
                    return function (project) {
                        return project.name + " (" + project.customerInfo.name + ")";
                    };
                case _constants.ReportGroupingLevel.BILLING_TYPE:
                    return function (type) {
                        return type.name;
                    };
                case _constants.ReportGroupingLevel.DATE:
                    return function (date) {
                        if (_jquery2.default.isEmptyObject(date)) return "";
                        return new _date_format.DateFormat(_this.DATE_FORMAT).formatDate(date.parseJSONDate());
                    };

                case _constants.ReportGroupingLevel.WEEK:
                    return function (week) {
                        if (_jquery2.default.isEmptyObject(week)) return "";
                        var from = week.from.parseJSONDate();
                        var to = week.to.parseJSONDate();
                        var firstPart = week.from === week.to ? "" : new _date_format.DateFormat('MMM dd').formatDate(from) + " - ";
                        return firstPart + new _date_format.DateFormat('MMM dd, yyyy').formatDate(to);
                    };

                case _constants.ReportGroupingLevel.MONTH:
                    return function (month) {
                        if (_jquery2.default.isEmptyObject(month)) return "";
                        return new _date_format.DateFormat('MMMM , yyyy').formatDate(month.parseJSONDate());
                    };
            }
        }
    }, {
        key: 'getValueFormattedFunction',
        value: function getValueFormattedFunction(selectedValueType) {
            var _this2 = this;

            var numberFormatter = new _number_formatter2.default(window.SystemSettings.decimalSeparator, window.SystemSettings.digitGroupingSymbol, 2, false);

            switch (selectedValueType) {
                case _constants.ReportChartType.APPROVED_WORKING_HOURS:
                case _constants.ReportChartType.LEAVE_HOURS:
                case _constants.ReportChartType.OVERTIME_HOURS:
                case _constants.ReportChartType.TOTAL_WORKING_HOURS:
                    return function (value) {
                        if (!value.toString().length) return "";
                        return _this2.TIME_FORMAT === _constants2.TimeFormat.TIME ? _user_time2.default.formatTime(value) : numberFormatter.format(value / 60);
                    };
                case _constants.ReportChartType.PTO_BALANCE:
                    return function (value) {
                        return numberFormatter.format(window.SystemSettings.showPTOInHours ? value * (window.DEFAULT_WORKDAY_DURATION / 60) : value);
                    };
                case _constants.ReportChartType.SICK_DAYS_BALANCE:
                    return function (value) {
                        return numberFormatter.format(window.SystemSettings.showSickInHours ? value * (window.DEFAULT_WORKDAY_DURATION / 60) : value);
                    };
                case _constants.ReportChartType.BILLABLE_AMOUNTS:
                case _constants.ReportChartType.COST_OF_WORK:
                    return function (value) {
                        return numberFormatter.format(value);
                    };
            }
        }
    }, {
        key: 'getMeasureUnit',
        value: function getMeasureUnit(selectedValueType) {
            switch (selectedValueType) {
                case _constants.ReportChartType.APPROVED_WORKING_HOURS:
                case _constants.ReportChartType.LEAVE_HOURS:
                case _constants.ReportChartType.OVERTIME_HOURS:
                case _constants.ReportChartType.TOTAL_WORKING_HOURS:
                    return _messageResource2.default.getMessage("report.create_chart.man_hours_sign");
                case _constants.ReportChartType.PTO_BALANCE:
                    return window.SystemSettings.showPTOInHours ? _messageResource2.default.getMessage("report.create_chart.hours_sign") : _messageResource2.default.getMessage("report.create_chart.days_sign");
                case _constants.ReportChartType.SICK_DAYS_BALANCE:
                    return window.SystemSettings.showSickInHours ? _messageResource2.default.getMessage("report.create_chart.hours_sign") : _messageResource2.default.getMessage("report.create_chart.days_sign");
                case _constants.ReportChartType.BILLABLE_AMOUNTS:
                case _constants.ReportChartType.COST_OF_WORK:
                    return (0, _atUtils.escapeHtmlSymbols)(window.SystemSettings.currencySign);
            }
        }
    }]);

    return BaseFormatterCreator;
}();

exports.default = BaseFormatterCreator;

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _DelayTooltip = __webpack_require__(807);

var _DelayTooltip2 = _interopRequireDefault(_DelayTooltip);

var _atUtils = __webpack_require__(5);

var _atBrowserUtils = __webpack_require__(8);

var _date_format = __webpack_require__(16);

var _ChartPDFViewer = __webpack_require__(1478);

var _ChartPDFViewer2 = _interopRequireDefault(_ChartPDFViewer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PDFPreviewController = function PDFPreviewController() {};

PDFPreviewController.prototype = {
    init: function init(lightBoxEl, titleEl, lightboxId) {
        var self = this;
        this.lightBoxEl = lightBoxEl;
        this.titleEl = titleEl;
        this.chartConfigurationSection = (0, _jquery2.default)(document.getElementById(lightboxId + "_chartConfigurationSection"));

        this._initPdfSettingsPreview(lightboxId);

        this.pdfViewer = new _ChartPDFViewer2.default().init();

        // date format for lightbox title and pdf preview
        this.dateFormat = this._getDateFormatForPreviewSection();

        this.titleTooltip = new _DelayTooltip2.default().init(lightboxId + "_titleTooltip");
        this.titleTooltip.updateUI = function (text) {
            this._tooltipTextPlaceholder.html((0, _atUtils.escapeHtmlSymbols)(text));
        };

        this.downloadPDFBtn = (0, _jquery2.default)(document.getElementById(lightboxId + "_downloadPdfBtn"));
        this.downloadPDFBtn.off();
        this.downloadPDFBtn.click(function () {
            self.onDownloadPDFBtnClicked();
        });

        this._subscribeForEvents();

        return this;
    },

    _initPdfSettingsPreview: function _initPdfSettingsPreview() {
        // Abstract
    },

    _subscribeForEvents: function _subscribeForEvents() {
        // Abstract
    },

    cancelAllExportingProcesses: function cancelAllExportingProcesses() {
        // Abstract
    },

    _setTitle: function _setTitle(formattingStrategy, selectedParameters) {
        var self = this;
        var titleMainPart = formattingStrategy.formatMainPartOfLightboxTitle(selectedParameters);
        var titleMainPartSpan = (0, _jquery2.default)(document.createElement("span"));
        titleMainPartSpan.text(titleMainPart);

        var titleSpecifyingPart = formattingStrategy.formatSpecifyingPartOfLightboxTitle(selectedParameters);
        var specifyingPartSpan = (0, _jquery2.default)(document.createElement("span"));
        specifyingPartSpan.text(titleSpecifyingPart);
        specifyingPartSpan.addClass("specifyingPart");

        this.titleEl.empty().append(titleMainPartSpan).append(specifyingPartSpan);
        this.titleEl.off("mousemove");
        this.titleEl.off("hover");
        if (this.titleEl.outerWidth() < this.titleEl[0].scrollWidth) {
            this.titleEl.hover(function (event) {
                self.titleTooltip.updateUIAndShow(titleMainPart + titleSpecifyingPart, (0, _atBrowserUtils.calculateTooltipOffset)(self.titleTooltip, event));
            }, function () {
                self.titleTooltip.hide();
            });
            this.titleEl.mousemove(function (event) {
                self.titleTooltip.move((0, _atBrowserUtils.calculateTooltipOffset)(self.titleTooltip, event));
            });
        }

        this.chartConfigurationSection.text(formattingStrategy.formatParametersText(selectedParameters));
    },

    onDownloadPDFBtnClicked: function onDownloadPDFBtnClicked() {
        // Abstract
    },

    disableDownloadPDFButton: function disableDownloadPDFButton() {
        this.downloadPDFBtnEnabled = false;
        this.downloadPDFBtn.addClass("disabled");
    },

    enableDownloadPDFButton: function enableDownloadPDFButton() {
        this.downloadPDFBtnEnabled = true;
        this.downloadPDFBtn.removeClass("disabled");
    },

    onGeneratePDFCompleted: function onGeneratePDFCompleted() {
        // Abstract
    },

    /**
     * Get date format depends on system setting but in short version (year in format yy, month in format MMM)
     * @private
     */
    _getDateFormatForPreviewSection: function _getDateFormatForPreviewSection() {
        var dateFormat = window.SystemSettings.dateFormat;
        dateFormat = dateFormat.replace(/MMMM/, 'MMM');
        dateFormat = dateFormat.replace(/yyyy/, 'yy');
        return new _date_format.DateFormat(dateFormat);
    }
};

exports.default = PDFPreviewController;

/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.clearSupportPopupInfoInLocalStorage = exports.setSupportPopupInfoToLocalStorage = exports.getSupportPopupInfoFromLocalStorage = exports.SUPPORT_POPUP_INFO_LOCAL_STORAGE_KEY = undefined;
exports.openSupportForm = openSupportForm;

var _store = __webpack_require__(222);

var _actions = __webpack_require__(306);

var _LocalStorage = __webpack_require__(72);

var _constants = __webpack_require__(181);

/**
 * @deprecated This function connects directly to redux, which is discouraged. Dispatch pure redux version from actions instead.
 */
function openSupportForm() {
    (0, _store.getStore)().dispatch((0, _actions.openSupportForm)({
        positionStrategy: _constants.supportPopupPositionStrategy.CENTER,
        position: { x: 0, y: 0 }
    }));
}

var SUPPORT_POPUP_INFO_LOCAL_STORAGE_KEY = exports.SUPPORT_POPUP_INFO_LOCAL_STORAGE_KEY = 'supportPopupInfo';

var getSupportPopupInfoFromLocalStorage = exports.getSupportPopupInfoFromLocalStorage = function getSupportPopupInfoFromLocalStorage() {
    return (0, _LocalStorage.getLocalStorage)().getItem(SUPPORT_POPUP_INFO_LOCAL_STORAGE_KEY);
};

var setSupportPopupInfoToLocalStorage = exports.setSupportPopupInfoToLocalStorage = function setSupportPopupInfoToLocalStorage(info) {
    (0, _LocalStorage.getLocalStorage)().setItem(SUPPORT_POPUP_INFO_LOCAL_STORAGE_KEY, info);
};

var clearSupportPopupInfoInLocalStorage = exports.clearSupportPopupInfoInLocalStorage = function clearSupportPopupInfoInLocalStorage() {
    (0, _LocalStorage.getLocalStorage)().removeItem(SUPPORT_POPUP_INFO_LOCAL_STORAGE_KEY);
};

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CustomerPanelDialogs = exports.CustomerPanelTabs = exports.CustomerPanel = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _CustomerPanelHeader = __webpack_require__(1489);

var _CustomerPanelHeader2 = _interopRequireDefault(_CustomerPanelHeader);

var _CustomerPanelContent = __webpack_require__(1490);

var _CustomerPanelContent2 = _interopRequireDefault(_CustomerPanelContent);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _LoadingContainer = __webpack_require__(28);

var _LoadingContainer2 = _interopRequireDefault(_LoadingContainer);

var _AssignedUsersEditor = __webpack_require__(292);

var _AssignedUsersEditor2 = _interopRequireDefault(_AssignedUsersEditor);

var _AssignedUsersEditorContainer = __webpack_require__(294);

var _AssignedUsersEditorContainer2 = _interopRequireDefault(_AssignedUsersEditorContainer);

var _applyAction = __webpack_require__(375);

var _DeleteCustomerPopupConfirmationDialog = __webpack_require__(1494);

var _DeleteCustomerPopupConfirmationDialog2 = _interopRequireDefault(_DeleteCustomerPopupConfirmationDialog);

var _ArchiveCustomerDialog = __webpack_require__(1495);

var _ArchiveCustomerDialog2 = _interopRequireDefault(_ArchiveCustomerDialog);

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _ScrollableContainer = __webpack_require__(49);

var _ScrollableContainer2 = _interopRequireDefault(_ScrollableContainer);

var _TabsController = __webpack_require__(239);

var _TabsController2 = _interopRequireDefault(_TabsController);

var _CommentsFooter = __webpack_require__(500);

var _CommentsFooter2 = _interopRequireDefault(_CommentsFooter);

var _selectors = __webpack_require__(19);

var _utils = __webpack_require__(6);

var _redux = __webpack_require__(7);

var _actions = __webpack_require__(308);

var _selectors2 = __webpack_require__(249);

var _actions2 = __webpack_require__(68);

var _utils2 = __webpack_require__(118);

var _features = __webpack_require__(22);

var _selectors3 = __webpack_require__(15);

var _atUtils = __webpack_require__(5);

var _utils3 = __webpack_require__(25);

var _CopyCustomerDialog = __webpack_require__(1496);

var _CopyCustomerDialog2 = _interopRequireDefault(_CopyCustomerDialog);

var _selectors4 = __webpack_require__(27);

var _BudgetsTab = __webpack_require__(502);

var _BudgetsTab2 = _interopRequireDefault(_BudgetsTab);

var _NextBridge = __webpack_require__(376);

var _NextBridge2 = _interopRequireDefault(_NextBridge);

var _ClassicBridge = __webpack_require__(18);

var _ClassicBridge2 = _interopRequireDefault(_ClassicBridge);

var _UserEventsMap = __webpack_require__(99);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CustomerPanel = exports.CustomerPanel = function (_TemplateView) {
    _inherits(CustomerPanel, _TemplateView);

    function CustomerPanel(_ref) {
        var _ref$updateDescriptio = _ref.updateDescription,
            updateDescription = _ref$updateDescriptio === undefined ? function () {} : _ref$updateDescriptio,
            _ref$saveComment = _ref.saveComment,
            saveComment = _ref$saveComment === undefined ? function () {} : _ref$saveComment,
            _ref$saveEditingComme = _ref.saveEditingComment,
            saveEditingComment = _ref$saveEditingComme === undefined ? function () {} : _ref$saveEditingComme,
            _ref$toggleNewComment = _ref.toggleNewCommentInput,
            toggleNewCommentInput = _ref$toggleNewComment === undefined ? function () {} : _ref$toggleNewComment,
            _ref$updateNewComment = _ref.updateNewCommentText,
            updateNewCommentText = _ref$updateNewComment === undefined ? function () {} : _ref$updateNewComment,
            _ref$onPanelClose = _ref.onPanelClose,
            onPanelClose = _ref$onPanelClose === undefined ? function () {} : _ref$onPanelClose,
            _ref$updateEnabledFea = _ref.updateEnabledFeatures,
            updateEnabledFeatures = _ref$updateEnabledFea === undefined ? function () {} : _ref$updateEnabledFea,
            _ref$getNameForCopyCu = _ref.getNameForCopyCustomer,
            getNameForCopyCustomer = _ref$getNameForCopyCu === undefined ? function () {} : _ref$getNameForCopyCu,
            _ref$copyCustomer = _ref.copyCustomer,
            copyCustomer = _ref$copyCustomer === undefined ? function () {} : _ref$copyCustomer;

        _classCallCheck(this, CustomerPanel);

        var _this = _possibleConstructorReturn(this, (CustomerPanel.__proto__ || Object.getPrototypeOf(CustomerPanel)).call(this));

        _this._handleTabSwitched = function (selectedKey, previousKey) {
            _this.tabsController.setState({ selectedTabKey: selectedKey });

            var prevButton = _this.buttons.get(previousKey);
            if (prevButton) prevButton.toggleClass('selected', false);
            var button = _this.buttons.get(selectedKey);
            if (button) button.toggleClass('selected', true);

            if (selectedKey !== CustomerPanelDialogs.ARCHIVE_DIALOG && selectedKey !== CustomerPanelDialogs.DELETE_DIALOG && selectedKey !== CustomerPanelDialogs.COPY_DIALOG) {
                _this.lastSelectedTabKey = selectedKey;
            }

            _this.commentsFooter.toggle(selectedKey === CustomerPanelTabs.DETAILS_TAB);
            if (selectedKey !== CustomerPanelTabs.DETAILS_TAB) {
                _this.actions.saveEditingComment();
            }

            if (selectedKey === CustomerPanelTabs.BUDGETS) {
                _ClassicBridge2.default.sendUserEvent(_UserEventsMap.UserEventsMap.BUDGET_TAB_OPEN, _UserEventsMap.BudgetTabOpenEventEntityParams.CUSTOMER);
            }

            _this.tabs.get(selectedKey).update();
        };

        _this.updateOnInit = false;
        _this.isBlockedDelete = false;

        _this.actions = {
            updateDescription: updateDescription,
            saveComment: saveComment,
            saveEditingComment: saveEditingComment,
            toggleNewCommentInput: toggleNewCommentInput,
            updateNewCommentText: updateNewCommentText,
            onPanelClose: onPanelClose,
            updateEnabledFeatures: updateEnabledFeatures,
            getNameForCopyCustomer: getNameForCopyCustomer,
            copyCustomer: copyCustomer
        };

        _this.state = {
            currentTabKey: CustomerPanelTabs.DETAILS_TAB,
            customerId: null,
            customerName: '',
            loggedInUser: null,
            sendingComment: false,
            showNewCommentInput: false,
            newCommentText: '',
            allProjectsAssigned: false,
            isCustomerAssigned: false,

            isWASEnabled: false,
            isURAEnabled: false,
            isBTYEnabled: false,
            isBRAEnabled: false,
            isESTEnabled: false,
            isTWSEnabled: false,
            isCPTBUDEnabled: false,

            canManageAccountsAndPermissions: false,
            canEditTaskStatus: true,
            canGenerateMoneyReports: false,
            canEditHierarchy: false,
            hasSomeTeamAssignment: false
        };

        _this.onStatePropertyChanged('currentTabKey', _this._handleTabSwitched);

        _this.onStatePropertyChanged('loggedInUser', function (loggedInUser) {
            _this.commentsFooter.setState({ loggedInUser: loggedInUser });
        });

        _this.onStatePropertyChanged('customerId', function (customerId) {
            if (customerId !== null) {
                var selectedKey = _this.state.currentTabKey;
                if (selectedKey === CustomerPanelDialogs.DELETE_DIALOG || selectedKey === CustomerPanelDialogs.COPY_DIALOG || selectedKey === CustomerPanelDialogs.ARCHIVE_DIALOG) {
                    _this.openLastSelectedTab();
                }
            }
        });

        _this.onStatePropertyChanged('sendingComment', function (sendingComment) {
            _this.commentsFooter.setState({ sending: sendingComment });
        });

        _this.onStatePropertyChanged('showNewCommentInput', function (showNewCommentInput) {
            _this.commentsFooter.setState({ showNewCommentInput: showNewCommentInput });
        });

        _this.onStatePropertyChanged('newCommentText', function (newCommentText) {
            _this.commentsFooter.setState({ commentText: newCommentText });
        });

        _this.onStatePropertyChanged('canEditTaskStatus', function (canEditTaskStatus) {
            _this.archiveDialog.setState({ canEditTaskStatus: canEditTaskStatus });
        });

        _this.onAnyStatePropertyChanged(['allProjectsAssigned', 'isCustomerAssigned', 'customerId', 'canGenerateMoneyReports', 'canEditHierarchy', 'isWASEnabled', 'isURAEnabled', 'isBRAEnabled', 'isCPTBUDEnabled'], function (_ref2) {
            var allProjectsAssigned = _ref2.allProjectsAssigned,
                isCustomerAssigned = _ref2.isCustomerAssigned,
                canGenerateMoneyReports = _ref2.canGenerateMoneyReports,
                canEditHierarchy = _ref2.canEditHierarchy,
                isWASEnabled = _ref2.isWASEnabled,
                isURAEnabled = _ref2.isURAEnabled,
                isBRAEnabled = _ref2.isBRAEnabled,
                isCPTBUDEnabled = _ref2.isCPTBUDEnabled,
                customerId = _ref2.customerId;

            _this.header.$tabs[CustomerPanelTabs.DETAILS_TAB].toggle(allProjectsAssigned);
            _this.header.$tabs[CustomerPanelTabs.ASSIGNED_USERS_TAB].toggle(isWASEnabled && allProjectsAssigned);
            _this.header.$tabs[CustomerPanelTabs.MANAGERS_TAB].toggle(allProjectsAssigned);
            if (isCPTBUDEnabled && isCustomerAssigned && (canGenerateMoneyReports || canEditHierarchy)) {
                _this.header.$tabs[CustomerPanelTabs.BUDGETS].toggle(true);
                _this.budgetsTab.setState({
                    relatedId: customerId,
                    areCostBudgetsEnabled: isURAEnabled && canGenerateMoneyReports,
                    areBillingBudgetsEnabled: isBRAEnabled && canGenerateMoneyReports
                });
            } else {
                _this.header.$tabs[CustomerPanelTabs.BUDGETS].toggle(false);
                if (_this.state.currentTabKey === CustomerPanelTabs.BUDGETS) {
                    _this.openTabByKey(CustomerPanelTabs.DETAILS_TAB);
                }
            }

            if (!allProjectsAssigned) {
                _this.openTabByKey(CustomerPanelTabs.DETAILS_TAB);
            } else {
                _this.openLastSelectedTab();
            }

            _this.buttons.get(CustomerPanelTabs.ASSIGNED_USERS_TAB).toggle(isWASEnabled && allProjectsAssigned);

            var selectedKey = _this.state.currentTabKey;
            _this.commentsFooter.toggle(selectedKey === CustomerPanelTabs.DETAILS_TAB && allProjectsAssigned);
            _this.detailsTabScrollable.forceUpdate();
        });

        _this.onAnyStatePropertyChanged(['isURAEnabled', 'isBTYEnabled', 'isTTAEnabled'], function (_ref3) {
            var isURAEnabled = _ref3.isURAEnabled,
                isBTYEnabled = _ref3.isBTYEnabled,
                isTTAEnabled = _ref3.isTTAEnabled;

            _this.tabs.get(CustomerPanelTabs.MANAGERS_TAB).setState({ isURAEnabled: isURAEnabled, isBTYEnabled: isBTYEnabled, isTTAEnabled: isTTAEnabled });
        });

        _this.onAnyStatePropertyChanged(['customerName', 'canManageAccountsAndPermissions', 'isBTYEnabled', 'isESTEnabled', 'isTWSEnabled', 'isWASEnabled', 'hasSomeTeamAssignment'], function (_ref4) {
            var customerName = _ref4.customerName,
                canManageAccountsAndPermissions = _ref4.canManageAccountsAndPermissions,
                isBTYEnabled = _ref4.isBTYEnabled,
                isESTEnabled = _ref4.isESTEnabled,
                isTWSEnabled = _ref4.isTWSEnabled,
                isWASEnabled = _ref4.isWASEnabled,
                hasSomeTeamAssignment = _ref4.hasSomeTeamAssignment;

            _this.copyDialogScrollable.setState({
                customerName: customerName,
                canManageAccountsAndPermissions: canManageAccountsAndPermissions,
                isBTYEnabled: isBTYEnabled,
                isESTEnabled: isESTEnabled,
                isTWSEnabled: isTWSEnabled,
                isWASEnabled: isWASEnabled,
                hasSomeTeamAssignment: hasSomeTeamAssignment
            });
        });
        return _this;
    }

    _createClass(CustomerPanel, [{
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='taskManagement_customerPanel'>" + "  <div class='headerBlock'/>" + "  <div class='content_customerPanel'/>" + "  <div class='commentsFooterBlock'/>" + "</div>";
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            var _this2 = this;

            this.$header = this.find('.headerBlock');

            this.$content = this.find(".content_customerPanel");
            this.header = new _CustomerPanelHeader2.default(this.find(".headerBlock"), this.$el).init();
            this.detailsTab = new _CustomerPanelContent2.default({
                updateDescription: this.actions.updateDescription,
                refreshScrollCb: function refreshScrollCb() {
                    return _this2.detailsTabScrollable.forceUpdate();
                },
                scrollToElementCb: function scrollToElementCb($el, pos) {
                    return _this2.detailsTabScrollable.scrollToElementVertical($el, pos);
                }
            });
            this.detailsTabScrollable = new _ScrollableContainer2.default(null, this.detailsTab, { needRefreshOnResize: true });
            this.detailsTabScrollable.init(this.$content);

            var assignedUsersEditor = new _LoadingContainer2.default({
                contentComponent: new _AssignedUsersEditor2.default({
                    onUserDelete: function onUserDelete(userData) {
                        return _this2.trigger("assignedUserDelete", { userId: userData.id });
                    },
                    onAssignedUsersChange: function onAssignedUsersChange(_ref5) {
                        var addedUserIds = _ref5.addedUserIds,
                            removedUserIds = _ref5.removedUserIds;
                        return _this2.trigger("assignedUsersChange", { addedUserIds: addedUserIds, removedUserIds: removedUserIds });
                    },
                    titleMessageKey: "assigned_users_editor.customer.title",
                    userSubtitleGenerator: function userSubtitleGenerator(user) {
                        if (user.hasAllAssignments) {
                            return _messageResource2.default.getMessage("assigned_users_editor.customer.has_all_assignments");
                        }
                    },
                    managersMessageKey: "assigned_users_editor.customer.managers_count",
                    canEditManagers: false,
                    addUsersMessageKey: "assigned_users_editor.add_title",
                    emptyListMessageKey: "assigned_users_editor.customer.empty_list",
                    showPermissionIcons: false,
                    usersSelectorTitle: _messageResource2.default.getMessage("assigned_users_editor.customer.users_selector_title"),
                    renderUserSelectorToContent: true,
                    refreshScrollCb: function refreshScrollCb() {
                        return assignedUsersScrollableEditor.forceUpdate();
                    },
                    checkIfCanModify: function checkIfCanModify(user) {
                        return !user.hasManageAssignment;
                    },
                    getListDisabledTooltipText: function getListDisabledTooltipText(user) {
                        return _this2._getDisabledTooltipTextAssugnedUsersEditor(user);
                    },
                    getSelectorDisabledTooltipText: function getSelectorDisabledTooltipText(user) {
                        return _this2._getDisabledTooltipTextAssignedUsersSelector(user);
                    }
                }),
                containerClass: "assignedUsersTab panelTab"
            });
            var assignedUsersScrollableEditor = new _ScrollableContainer2.default(null, assignedUsersEditor, {
                needRefreshOnResize: true,
                containerClass: 'assignedUsersScrollableContainer'
            });
            this.assignedUsersEditorContainer = new _AssignedUsersEditorContainer2.default({
                assignedUsersEditor: assignedUsersScrollableEditor,
                $tabTitle: this.header.$assignedUsersTabTitle,
                tabTitleMessageKey: "task.edit_panel.tabs.assigned_users_with_count"
            }).init();

            var managersEditor = new _LoadingContainer2.default({
                contentComponent: new _AssignedUsersEditor2.default({
                    onUserDelete: function onUserDelete(userData) {
                        return _this2.trigger("managerDelete", { userData: userData });
                    },
                    onAssignedUsersChange: function onAssignedUsersChange(_ref6) {
                        var addedUserIds = _ref6.addedUserIds,
                            removedUserIds = _ref6.removedUserIds;
                        return _this2.trigger("managersChange", { addedUserIds: addedUserIds, removedUserIds: removedUserIds });
                    },
                    titleMessageKey: "assigned_users_editor.managers.customer.title",
                    userSubtitleGenerator: function userSubtitleGenerator(user) {
                        if (user.hasAllAssignments) {
                            return _messageResource2.default.getMessage("assigned_users_editor.managers.customer.has_all_assignments");
                        } else if (user.hasAllFutureProjectsOfCustomerAssignment) {
                            return _messageResource2.default.getMessage("assigned_users_editor.managers.customer.has_projects_only_assignments");
                        }
                    },
                    addUsersMessageKey: "assigned_users_editor.managers.add_title",
                    showPermissionIcons: true,
                    usersSelectorTitle: _messageResource2.default.getMessage("assigned_users_editor.managers.customer.users_selector_title"),
                    renderUserSelectorToContent: true,
                    refreshScrollCb: function refreshScrollCb() {
                        return managersScrollableEditor.forceUpdate();
                    },
                    checkIfCanModify: function checkIfCanModify(user) {
                        return !user.hasAllAssignments;
                    },
                    getListDisabledTooltipText: function getListDisabledTooltipText(user) {
                        return _this2._getDisabledTooltipText(user);
                    },
                    getSelectorDisabledTooltipText: function getSelectorDisabledTooltipText(user) {
                        return _this2._getDisabledTooltipText(user);
                    }
                }),
                containerClass: "managersTab panelTab"
            });
            var managersScrollableEditor = new _ScrollableContainer2.default(null, managersEditor, {
                needRefreshOnResize: true,
                containerClass: 'assignedUsersScrollableContainer'
            });
            this.managersEditorContainer = new _AssignedUsersEditorContainer2.default({
                assignedUsersEditor: managersScrollableEditor,
                $tabTitle: this.header.$managersTabTitle,
                tabTitleMessageKey: "task.edit_panel.tabs.managers_with_count"
            }).init();

            this.budgetsTab = new _BudgetsTab2.default({
                relatedType: _BudgetsTab.RelatedType.Customer
            });

            this.deleteDialog = new _DeleteCustomerPopupConfirmationDialog2.default(null, function () {
                (0, _jquery2.default)(_this2).trigger("cancelDelete");
            }, function (revokeStatuses) {
                (0, _jquery2.default)(_this2).trigger("delete", revokeStatuses);
            });
            this.deleteDialogScrollable = new _ScrollableContainer2.default(null, this.deleteDialog, { needRefreshOnResize: true }).init(this.$content);

            this.copyCustomerDialog = new _CopyCustomerDialog2.default({
                onCancelCb: function onCancelCb() {
                    return _this2.openLastSelectedTab();
                },
                onCopyCb: function onCopyCb(customerName, settings) {
                    _this2.actions.copyCustomer(customerName, settings, function () {
                        return _this2.openLastSelectedTab();
                    });
                }
            });
            this.copyDialogScrollable = new _ScrollableContainer2.default(null, this.copyCustomerDialog, { needRefreshOnResize: true }).init(this.$content);

            this.archiveDialog = new _ArchiveCustomerDialog2.default(null);
            this.archiveDialogScrollable = new _ScrollableContainer2.default(null, this.archiveDialog, { needRefreshOnResize: true }).init(this.$content);

            this.tabs = new Map([[CustomerPanelTabs.DETAILS_TAB, this.detailsTabScrollable], [CustomerPanelTabs.ASSIGNED_USERS_TAB, assignedUsersScrollableEditor.init(this.$content)], [CustomerPanelTabs.MANAGERS_TAB, managersScrollableEditor.init(this.$content)], [CustomerPanelTabs.BUDGETS, this.budgetsTab.init(this.$content)], [CustomerPanelDialogs.DELETE_DIALOG, this.deleteDialogScrollable], [CustomerPanelDialogs.COPY_DIALOG, this.copyDialogScrollable], [CustomerPanelDialogs.ARCHIVE_DIALOG, this.archiveDialogScrollable]]);

            this.tabs.forEach(function ($tab, tabKey) {
                $tab.hide();
            });

            this.tabsController = new _TabsController2.default({
                tabs: this.tabs
            }).init();

            this.buttons = new Map([[CustomerPanelTabs.DETAILS_TAB, this.header.$tabs[CustomerPanelTabs.DETAILS_TAB]], [CustomerPanelTabs.ASSIGNED_USERS_TAB, this.header.$tabs[CustomerPanelTabs.ASSIGNED_USERS_TAB]], [CustomerPanelTabs.MANAGERS_TAB, this.header.$tabs[CustomerPanelTabs.MANAGERS_TAB]], [CustomerPanelTabs.BUDGETS, this.header.$tabs[CustomerPanelTabs.BUDGETS]], [CustomerPanelDialogs.DELETE_DIALOG, this.header.actions.menu.$delete], [CustomerPanelDialogs.COPY_DIALOG, this.header.actions.menu.$copy]]);

            this.buttons.forEach(function ($button, key) {
                $button.click(function () {
                    if (key === CustomerPanelDialogs.DELETE_DIALOG && _this2.isBlockedDelete) {
                        return;
                    }

                    if (key === CustomerPanelDialogs.COPY_DIALOG) {
                        _this2.actions.getNameForCopyCustomer(function (newCustomerName) {
                            _this2.copyCustomerDialog.updateNewCustomerName(newCustomerName);
                            _this2.openTabByKey(key);
                        });
                    } else {
                        _this2.openTabByKey(key);
                    }
                });
            });

            this.commentsFooter = new _CommentsFooter2.default({
                onCommentTextChange: this.actions.updateNewCommentText,
                onShowInputChanged: this.actions.toggleNewCommentInput,
                onCommentAdded: this.actions.saveComment,
                refreshScrollCb: function refreshScrollCb() {
                    _this2.detailsTabScrollable.performIfScrollToBottom(function () {
                        _this2.detailsTabScrollable.forceUpdate();
                        _this2.detailsTabScrollable.scrollToBottom();
                    });
                    _this2.detailsTabScrollable.forceUpdate();
                }
            }).init(this.find('.commentsFooterBlock'));
        }
    }, {
        key: "update",
        value: function update(config) {
            if (!config) return;

            var customerInfo = config.customerInfo,
                customerSpentTimeValues = config.customerSpentTimeValues,
                enabledFeatures = config.enabledFeatures;


            this.actions.updateEnabledFeatures((0, _atUtils.arrayToSet)(enabledFeatures));
            this.header.update(customerInfo);

            this.detailsTab.updateState({
                readOnly: customerInfo.readOnly,
                active: customerInfo.active,
                spentTimeValues: customerSpentTimeValues,
                description: customerInfo.description
            });

            this._setIsBlockedDelete(customerInfo);

            if ((0, _utils2.isEnabled)((0, _atUtils.arrayToSet)(enabledFeatures), _features.Feature.WAS)) (0, _applyAction.applyDataToAssignedUsersEditor)(this.assignedUsersEditorContainer, config["assignedUsersData"]);

            (0, _applyAction.applyDataToAssignedUsersEditor)(this.managersEditorContainer, config["assignedUsersDataForManagers"]);
            this.assignedUsersEditorContainer.setState({
                hideAssignButton: customerInfo.readOnly
            });
            this.managersEditorContainer.setState({
                hideAssignButton: !config["assignedUsersDataForManagers"].canModifyAny
            });

            if (!this.isBlockedDelete) {
                this._initDeleteDialog(customerInfo);
            }
        }
    }, {
        key: "setFakeLastAudit",
        value: function setFakeLastAudit() {
            this.detailsTab.updateLastAudit((0, _utils3.getFakeUpdateAuditAction)(this.state.loggedInUser));
        }
    }, {
        key: "_getDisabledTooltipText",
        value: function _getDisabledTooltipText(user) {
            var msg = _messageResource2.default.getMessage('assigned_users_editor.managers.disabled_tooltip', [_messageResource2.default.getMessage('common.customer'), user.firstName]);
            msg += " " + _messageResource2.default.getMessage('assigned_users_editor.managers.disabled_tooltip.entire_scope');
            return msg;
        }
    }, {
        key: "_getDisabledTooltipTextAssugnedUsersEditor",
        value: function _getDisabledTooltipTextAssugnedUsersEditor(user) {
            return _messageResource2.default.getMessage('panel.common.cannot_unassign_user.tooltip', [_messageResource2.default.getMessage('common.customer'), user.firstName]);
        }
    }, {
        key: "_getDisabledTooltipTextAssignedUsersSelector",
        value: function _getDisabledTooltipTextAssignedUsersSelector(user) {
            return _messageResource2.default.getMessage('assigned_users_editor.work.disabled_tooltip.user_manages_item', [_messageResource2.default.getMessage('common.customer')]);
        }
    }, {
        key: "_setIsBlockedDelete",
        value: function _setIsBlockedDelete(customerInfo) {
            this.isBlockedDelete = customerInfo.blockedDueToUnavailableToModifyTimeTrack || customerInfo.blockedDueToLockedTime;
        }
    }, {
        key: "_initDeleteDialog",
        value: function _initDeleteDialog(config) {
            this.deleteDialog.setState({
                visibleProjectCount: config.activeProjectsNum + config.archivedProjectsNum,
                isCustomerActive: config.active,
                entityName: config.name,
                entitiesToDeleteCount: this.isBlockedDelete ? 0 : 1,
                entitiesBlocked: [],
                entitiesBlockedCount: 0,
                entitiesBlockedDueToLockedTimeCount: 0,
                entitiesBlockedDueToUnavailableToModifyTimeTrackCount: 0,
                entitiesWithManagerTimeTrackCount: config.customerHasManagerTimeTrack ? 1 : 0,
                entitiesWithOtherUsersTimeTrackCount: config.customerHasOtherUsersTimeTrack ? 1 : 0,
                entitiesWithManagerApprovedTimeTrackCount: config.customerHasManagerApprovedTimeTrack ? 1 : 0,
                entitiesWithOtherUsersApprovedTimeTrackCount: config.customerHasOtherUsersApprovedTimeTrack ? 1 : 0,
                hasManagerApprover: config.hasManagerApprover
            });
        }
    }, {
        key: "openLastSelectedTab",
        value: function openLastSelectedTab() {
            this.openTabByKey(this.lastSelectedTabKey ? this.lastSelectedTabKey : CustomerPanelTabs.DETAILS_TAB);
        }
    }, {
        key: "openTabByKey",
        value: function openTabByKey(key) {
            this.setState({ currentTabKey: key });
        }
    }, {
        key: "onHide",
        value: function onHide() {
            this.actions.saveEditingComment();
            this.header.actions.hideMenu();
            this.detailsTab.details.hideSelectors();
            this.detailsTab.details.hideAuditHistoryMenu();
            this.actions.onPanelClose();
            _NextBridge2.default.listeners.customerPanelClosed.forEach(function (handler) {
                return handler();
            });
        }
    }, {
        key: "onShow",
        value: function onShow() {
            this.detailsTab.details.setSelectorsDisabled(false);
            this.detailsTabScrollable.forceUpdate();
        }
    }, {
        key: "onScroll",
        value: function onScroll() {
            this.detailsTab.details.hideAuditHistoryMenu();
        }
    }, {
        key: "getTabView",
        value: function getTabView(tabKey) {
            return this.tabs.get(tabKey);
        }
    }, {
        key: "getSelectedTabKey",
        value: function getSelectedTabKey() {
            return this.state.currentTabKey;
        }
    }]);

    return CustomerPanel;
}(_TemplateView3.default);

exports.default = (0, _utils.connect)(function (state) {
    return {
        loggedInUser: (0, _selectors.getLoggedInUser)(state),
        sendingComment: (0, _selectors2.isSendingComment)(state),
        showNewCommentInput: (0, _selectors2.isShowNewCommentInput)(state),
        newCommentText: (0, _selectors2.getCustomerNewComment)(state),
        customerId: (0, _selectors2.getOpenCustomerId)(state),
        isCustomerAssigned: (0, _selectors2.getIsOpenCustomerAssigned)(state),
        customerName: (0, _selectors2.getOpenCustomerName)(state),
        allProjectsAssigned: (0, _selectors2.isAllProjectsAssigned)(state),
        isCPTBUDEnabled: (0, _selectors3.isCPTBUDEnabled)(state),
        isWASEnabled: (0, _selectors3.isWASEnabled)(state),
        isURAEnabled: (0, _selectors3.isURAEnabled)(state),
        isBTYEnabled: (0, _selectors3.isBTYEnabled)(state),
        isBRAEnabled: (0, _selectors3.isBRAEnabled)(state),
        isESTEnabled: (0, _selectors3.isESTEnabled)(state),
        isTWSEnabled: (0, _selectors3.isTWSEnabled)(state),
        isTTAEnabled: (0, _selectors3.isTTAEnabled)(state),
        canManageAccountsAndPermissions: (0, _selectors.canManageAccountsAndPermissions)(state),
        canEditTaskStatus: (0, _selectors4.canViewerEditTaskStatus)(state),
        canGenerateMoneyReports: (0, _selectors.canGenerateMoneyReports)(state),
        canEditHierarchy: (0, _selectors.canEditHierarchy)(state),
        hasSomeTeamAssignment: (0, _selectors.canAccessSomeTeamAssignment)(state)
    };
}, function (dispatch) {
    return {
        saveComment: (0, _redux.bindActionCreators)(_actions.commentsServiceActions.saveComment, dispatch),
        saveEditingComment: (0, _redux.bindActionCreators)(_actions.commentsServiceActions.saveEditingComment, dispatch),
        toggleNewCommentInput: (0, _redux.bindActionCreators)(_actions.commentsServiceActions.toggleNewCommentInput, dispatch),
        onPanelClose: (0, _redux.bindActionCreators)(_actions.closeCustomerPanel, dispatch),
        updateNewCommentText: (0, _redux.bindActionCreators)(_actions.updateNewCommentText, dispatch),
        updateEnabledFeatures: (0, _redux.bindActionCreators)(_actions2.setEnabledFeatures, dispatch),
        getNameForCopyCustomer: (0, _redux.bindActionCreators)(_actions.getNameForCopyCustomer, dispatch),
        copyCustomer: (0, _redux.bindActionCreators)(_actions.copyCustomer, dispatch)
    };
})(CustomerPanel);
var CustomerPanelTabs = exports.CustomerPanelTabs = {
    NONE: 'none',
    DETAILS_TAB: 'details',
    ASSIGNED_USERS_TAB: 'assignedUsers',
    MANAGERS_TAB: 'managers',
    BUDGETS: 'budgets'
};

var CustomerPanelDialogs = exports.CustomerPanelDialogs = {
    NONE: 'none',
    DELETE_DIALOG: 'delete',
    COPY_DIALOG: 'copy',
    ARCHIVE_DIALOG: 'archive'
};

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _DayCellRenderer2 = __webpack_require__(810);

var _DayCellRenderer3 = _interopRequireDefault(_DayCellRenderer2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DayDetailsCellRenderer = function (_DayCellRenderer) {
    _inherits(DayDetailsCellRenderer, _DayCellRenderer);

    function DayDetailsCellRenderer(cssBaseClass, cssTopBorderClass) {
        _classCallCheck(this, DayDetailsCellRenderer);

        var _this = _possibleConstructorReturn(this, (DayDetailsCellRenderer.__proto__ || Object.getPrototypeOf(DayDetailsCellRenderer)).call(this));

        _this.cssBaseClass = cssBaseClass;
        _this.cssTopBorderClass = cssTopBorderClass;
        return _this;
    }

    _createClass(DayDetailsCellRenderer, [{
        key: "getTopBorderClassName",
        value: function getTopBorderClassName(cell) {
            return this.cssTopBorderClass;
        }
    }, {
        key: "getComplicatedBorderClassName",
        value: function getComplicatedBorderClassName(cell) {
            var firstRow = cell.getRow().isFirstChildRow();
            var lastRow = cell.getRow().isLastChildRow();
            if (firstRow || lastRow) return firstRow && lastRow ? "singleDetailsRow" : firstRow ? "firstDetailsRow" : "lastDetailsRow";else return "";
        }
    }, {
        key: "getCellClassName",
        value: function getCellClassName(cell) {
            var className = [this.cssBaseClass];

            if (cell.getRow().getParentRow().isTodayCell(cell)) className.push("Today");else if (cell.getRow().getParentRow().isHolidayCell(cell)) className.push("Holiday");

            if (this.isLocked(cell)) className.push("Locked");
            if (this.isApproved(cell)) className.push("Approved");
            if (this.isSelected(cell)) className.push("Selected");else if (this.isHovered(cell)) className.push("Hover");
            return className.join(" ");
        }
    }, {
        key: "isLocked",
        value: function isLocked(cell) {
            return cell.getRow().getParentRow().getCell(cell.getColIdx()).getValue().locked;
        }
    }, {
        key: "isApproved",
        value: function isApproved(cell) {
            var approvedValue = cell.getRow().getParentRow().getCell(cell.getColIdx()).getValue().approveInfo;
            return approvedValue && (approvedValue.approved || approvedValue.autoApproved);
        }
    }, {
        key: "addTooltip",
        value: function addTooltip(cell) {
            var leaveInfo = cell.getValue();
            cell.getRow().getTable().getTooltipController().addDayTooltip(cell.getCellEl(), cell.getRow().getParentRow().getHeaderCell().getValue().id, cell.getRow().getTable().getDatesRow().getCell(cell.getColIdx()).getValue().date, { showWithoutTime: true, leaveInfo: leaveInfo.leaveInfo, time: leaveInfo.time }, { showOvertimeWhenZero: false, time: 0, showTime: false, overtimeText: cell.getRow().getHeaderCell().getValue() }, cell.getRow().getParentRow().getCell(cell.getColIdx()).getValue());
        }
    }]);

    return DayDetailsCellRenderer;
}(_DayCellRenderer3.default);

exports.default = DayDetailsCellRenderer;

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _LockTableCellRenderer = __webpack_require__(123);

var _LockTableCellRenderer2 = _interopRequireDefault(_LockTableCellRenderer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InactiveCellRenderer = function (_LockTableCellRendere) {
    _inherits(InactiveCellRenderer, _LockTableCellRendere);

    function InactiveCellRenderer(additionalCssClass) {
        _classCallCheck(this, InactiveCellRenderer);

        var _this = _possibleConstructorReturn(this, (InactiveCellRenderer.__proto__ || Object.getPrototypeOf(InactiveCellRenderer)).call(this));

        _this.cellClass = "inactiveCell";
        if (additionalCssClass) _this.cellClass += " " + additionalCssClass;
        return _this;
    }

    _createClass(InactiveCellRenderer, [{
        key: "getCellClassName",
        value: function getCellClassName(cell) {
            return this.cellClass;
        }
    }, {
        key: "getLastCellRightBorderClassName",
        value: function getLastCellRightBorderClassName() {
            return "";
        }
    }, {
        key: "getWeekSeparatorClass",
        value: function getWeekSeparatorClass(cell) {
            return "";
        }
    }]);

    return InactiveCellRenderer;
}(_LockTableCellRenderer2.default);

exports.default = InactiveCellRenderer;

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _atBrowserUtils = __webpack_require__(8);

var _SelectionController = __webpack_require__(816);

var _SelectionController2 = _interopRequireDefault(_SelectionController);

var _HoverController = __webpack_require__(1528);

var _HoverController2 = _interopRequireDefault(_HoverController);

var _TableMouseEventsHandler = __webpack_require__(525);

var _TableMouseEventsHandler2 = _interopRequireDefault(_TableMouseEventsHandler);

var _TableRegion = __webpack_require__(145);

var _TableRegion2 = _interopRequireDefault(_TableRegion);

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Table = function (_TemplateView) {
    _inherits(Table, _TemplateView);

    function Table(tHeadEl, containerEl) {
        _classCallCheck(this, Table);

        var _this = _possibleConstructorReturn(this, (Table.__proto__ || Object.getPrototypeOf(Table)).call(this, containerEl));

        _this.containerEl = containerEl;
        _this.rows = [];
        _this.tableEl = document.createElement("table");
        _this.tableEl.cellPadding = 0;
        _this.tableEl.cellSpacing = 0;
        _this.tableEl.border = 0;
        _this.tbody = document.createElement("tBody");

        // TODO: too much stuff happening in the constructor

        if (tHeadEl) _this.tableEl.appendChild(tHeadEl);
        _this.tableEl.appendChild(_this.tbody);

        //noinspection SpellCheckingInspection
        var thisDeref = _this;

        _this.selectionController = _this.createSelectionController();
        if (_this.selectionController != null) _this.selectionController.addSelectionChangeListener(function (selectionChangeEvent, mouseEvent) {
            thisDeref.selectionChanged(selectionChangeEvent, mouseEvent);
        });

        _this.hoverController = _this.createHoverController();
        if (_this.hoverController != null) _this.hoverController.addHoverChangeListener(function (hoverChangeEvent, mouseEvent) {
            thisDeref.hoverChanged(hoverChangeEvent, mouseEvent);
        });

        _this.mouseEventsHandler = _this.createMouseEventsHandler();
        return _this;
    }

    // abstract


    _createClass(Table, [{
        key: "createSelectionController",
        value: function createSelectionController() {
            return new _SelectionController2.default();
        }

        // abstract

    }, {
        key: "createHoverController",
        value: function createHoverController() {
            return new _HoverController2.default();
        }

        // abstract

    }, {
        key: "createMouseEventsHandler",
        value: function createMouseEventsHandler() {
            return new _TableMouseEventsHandler2.default(this, this.getSelectionController(), this.getHoverController());
        }
    }, {
        key: "getTBody",
        value: function getTBody() {
            return this.tbody;
        }
    }, {
        key: "getSelectionController",
        value: function getSelectionController() {
            return this.selectionController;
        }
    }, {
        key: "getHoverController",
        value: function getHoverController() {
            return this.hoverController;
        }
    }, {
        key: "getMouseEventsHandler",
        value: function getMouseEventsHandler() {
            return this.mouseEventsHandler;
        }
    }, {
        key: "setupRow",
        value: function setupRow(rowIdx, row) {
            row.setRowIdx(rowIdx);
            row.setTable(this);
        }
    }, {
        key: "addRow",
        value: function addRow(row) {
            this.setupRow(this.rows.length, row);
            this.rows.push(row);
        }
    }, {
        key: "replaceRowAndUpdateDOM",
        value: function replaceRowAndUpdateDOM(rowIdx, newRow, updateRowBelow) {
            var oldRow = this.rows[rowIdx];

            this.setupRow(rowIdx, newRow);
            this.rows[rowIdx] = newRow;

            var tmpTableEl = document.createElement("table");
            var tmpTBodyEl = document.createElement("tbody");
            tmpTableEl.appendChild(tmpTBodyEl);

            newRow.buildDOM(tmpTBodyEl);
            newRow.writeCellsContent();
            newRow.getRowEl().className = this.getRowElClasses(rowIdx).join(" ");

            oldRow.getRowEl().parentNode.replaceChild(newRow.getRowEl(), oldRow.getRowEl());

            if (updateRowBelow) {
                var belowIdx = rowIdx + 1;
                if (belowIdx <= this.getLastRow().getRowIdx()) {
                    var belowRow = this.getRow(belowIdx);
                    this.updateCellRegionUI(new _TableRegion2.default(belowIdx, 0, belowIdx, belowRow.getCells().length - 1));
                }
            }
        }
    }, {
        key: "getRows",
        value: function getRows(row) {
            return this.rows;
        }
    }, {
        key: "getRow",
        value: function getRow(rowIdx) {
            return this.rows[rowIdx];
        }
    }, {
        key: "getLastRow",
        value: function getLastRow() {
            return this.rows[this.rows.length - 1];
        }
    }, {
        key: "getFirstRow",
        value: function getFirstRow() {
            return this.rows[0];
        }
    }, {
        key: "getCell",
        value: function getCell(rowIdx, colIdx) {
            return this.rows[rowIdx].getCell(colIdx);
        }
    }, {
        key: "updateCell",
        value: function updateCell(cell) {
            cell.updateCell();
        }
    }, {
        key: "buildModelRowsDOM",
        value: function buildModelRowsDOM(containerEl) {
            var aRow = null;
            for (var i = 0; i < this.rows.length; i++) {
                aRow = this.rows[i];
                aRow.buildDOM(containerEl);
                aRow.writeCellsContent();
                aRow.getRowEl().className = this.getRowElClasses(i).join(" ");
            }
        }
    }, {
        key: "deleteAllRowsFromModelAndDom",
        value: function deleteAllRowsFromModelAndDom() {
            for (var i = 0; i < this.rows.length; i++) {
                this.tbody.removeChild(this.rows[i].getRowEl());
            }this.rows = [];
        }
    }, {
        key: "removeRow",
        value: function removeRow(rowIdx) {
            var row = this.rows[rowIdx];
            this.tbody.removeChild(row.getRowEl());
            this.rows.splice(rowIdx, 1);
            for (var i = rowIdx; i < this.rows.length; i++) {
                this.setupRow(i, this.rows[i]);
            }
        }
    }, {
        key: "getTableEl",
        value: function getTableEl() {
            return this.tableEl;
        }
    }, {
        key: "buildDOM",
        value: function buildDOM(containerEl) {
            this.buildModelRowsDOM(this.tbody);

            this.disableTextSelection();

            containerEl.appendChild(this.tableEl);
        }
    }, {
        key: "disableTextSelection",
        value: function disableTextSelection() {
            (0, _atBrowserUtils.disableTextSelection)(this.tableEl);
        }
    }, {
        key: "getBaseRowClasses",
        value: function getBaseRowClasses(rowIdx) {
            return [];
        }
    }, {
        key: "getRowElClasses",
        value: function getRowElClasses(rowIdx) {
            var rowClasses = this.getBaseRowClasses(rowIdx);
            this.appendSelectedRowClassIfNecessary(rowIdx, rowClasses);
            return rowClasses;
        }
    }, {
        key: "appendSelectedRowClassIfNecessary",
        value: function appendSelectedRowClassIfNecessary(rowIdx, rowClasses) {
            if (this.getSelectionController().getSelection().containsRow(rowIdx)) rowClasses.push("hasSelection");
        }
    }, {
        key: "updateCellRegionUI",
        value: function updateCellRegionUI(region) {
            // update region
            var row = null;
            for (var rowIdx = region.rowMin; rowIdx <= region.rowMax; rowIdx++) {
                row = this.rows[rowIdx];
                row.getRowEl().className = this.getRowElClasses(rowIdx).join(" ");
                for (var colIdx = region.colMin; colIdx <= region.colMax; colIdx++) {
                    row.updateCellUI(colIdx);
                }
            }
        }
    }, {
        key: "computeChangedRegion",
        value: function computeChangedRegion(regionChangeEvent) {
            return regionChangeEvent.oldValue.union(regionChangeEvent.newValue);
        }
    }, {
        key: "selectionChanged",
        value: function selectionChanged(selectionChangeEvent) {
            var updateRegion = this.computeChangedRegion(selectionChangeEvent);
            this.updateSelectionChangeRegionUI(updateRegion);
        }
    }, {
        key: "updateSelectionChangeRegionUI",
        value: function updateSelectionChangeRegionUI(updateRegion) {
            this.updateCellRegionUI(
            // +1 col and +1 row to update right and bottom borders of the selection region
            new _TableRegion2.default(updateRegion.rowMin, updateRegion.colMin, Math.min(updateRegion.rowMax + 1, this.getLastRow().getRowIdx()), Math.min(updateRegion.colMax + 1, this.getRow(updateRegion.rowMax).getCells().length - 1)));
        }
    }, {
        key: "hoverChanged",
        value: function hoverChanged(hoverChangeEvent) {
            var updateRegion = this.computeChangedRegion(hoverChangeEvent);
            if (updateRegion != null) this.updateCellRegionUI(updateRegion);
        }
    }, {
        key: "clearSelection",
        value: function clearSelection() {
            this.getSelectionController().clearSelection();
        }
    }, {
        key: "clearHover",
        value: function clearHover() {
            this.getHoverController().unhover();
        }
    }]);

    return Table;
}(_TemplateView3.default);

exports.default = Table;

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _UserNameFormat = __webpack_require__(17);

var _UserNameFormat2 = _interopRequireDefault(_UserNameFormat);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _time_zone_group_renderer = __webpack_require__(823);

var _time_zone_group_renderer2 = _interopRequireDefault(_time_zone_group_renderer);

var _time_zone_group_controller = __webpack_require__(1550);

var _time_zone_group_controller2 = _interopRequireDefault(_time_zone_group_controller);

var _SpinnerController = __webpack_require__(69);

var _SpinnerController2 = _interopRequireDefault(_SpinnerController);

var _atBrowserUtils = __webpack_require__(8);

var _GroupValidatorStrategy = __webpack_require__(186);

var _base_group_management_controller = __webpack_require__(310);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GroupManagementUtil = {}; // namespace

// Constants
GroupManagementUtil.redBorderClassName = "redBorder";
GroupManagementUtil.ellipsisOverflowClassName = "ellipsisOverflow";
GroupManagementUtil.textClassName = "text";

/**
 * Prepare user name to view in interface. Not escaped it.
 * @param user user object from server(converted java BasicUserInfo)
 */
GroupManagementUtil.formatUserName = function (user) {
    var result = _UserNameFormat2.default.formatLFM(user.firstName, user.lastName, user.middleInitial);
    if (!user.enabled) {
        result += " ";
        result += _messageResource2.default.getMessage("group_management.disable_user");
    }
    return result;
};

/**
 * Mark cell as invalid with red border and append tooltip for it
 * @param cell cell
 * @param title title
 */
GroupManagementUtil.markCellAsInvalid = function (cell, title) {
    (0, _atBrowserUtils.addClass)(cell, GroupManagementUtil.redBorderClassName);
    cell.title = title;
};

/**
 * Mark cell as valid and remove title
 * @param cell cell
 */
GroupManagementUtil.markCellAsValid = function (cell) {
    (0, _atBrowserUtils.removeClass)(cell, GroupManagementUtil.redBorderClassName);
    cell.title = "";
};

/**
 * Make id array from array of objects had 'id' property
 * @param objectArray array of objects had 'id' property
 */
GroupManagementUtil.makeIdArrayFromObjectArray = function (objectArray) {
    var idArray = [];
    for (var i = 0; i < objectArray.length; i++) {
        idArray.push(objectArray[i].id);
    }
    return idArray;
};

/**
 * Removes objects with id in specified array from array and returns removed objects.
 * @param idArray array of integers
 * @param sourceArray array for removing. Contains objects with 'id' property.
 * @param exceptIds array of integers. Contains that don't intended for removing.
 */
GroupManagementUtil.removeObjectsFromArrayAndReturnThem = function (idArray, sourceArray, exceptIds) {
    var objectArray = [];
    for (var i = 0; i < idArray.length; i++) {
        for (var j = 0; j < sourceArray.length; j++) {
            if (idArray[i] == sourceArray[j].id) {
                if (!isArrayContains(exceptIds, idArray[i])) {
                    objectArray.push(sourceArray[j]);
                }
                sourceArray.splice(j, 1);
                break;
            }
        }
    }
    return objectArray;
};

/**
 * Create handler on 'Enter' pressed key
 * @param event key down, key up, or key press event
 * @param func function to invoke
 */
GroupManagementUtil.createEnterPressedHandler = function (event, func) {
    event = event || window.event;
    if (event.keyCode == 13) {
        func();
    }
};

/**
 * Create handler on 'Esc' pressed key
 * @param event key down, key up, or key press event
 * @param func function to invoke
 */
GroupManagementUtil.createEscPressedHandler = function (event, func) {
    event = event || window.event;
    if (event.keyCode == 27) {
        func();
    }
};

/**
 * Create handler on no 'Enter' and no 'Esc' pressed key
 * @param event key down, key up, or key press event
 * @param func function to invoke
 */
GroupManagementUtil.createNoEnterAndEscPressedHandler = function (event, func) {
    event = event || window.event;
    if (event.keyCode != 27 && event.keyCode != 13) {
        func();
    }
};

/**
 * Returns element id by DOM element id if DOM element id constructed by {@link formatId()} function
 * @param domId id of an element in DOM
 */
GroupManagementUtil.getElementId = function (domId) {
    return +domId.substr(domId.lastIndexOf("_") + 1);
};

GroupManagementUtil.initializeGroupsLightBox = function (controller, groupRenderer, groupController, addGroupController) {
    var lightboxId = "groupManagementLightBox";
    var getElementBySubId = function getElementBySubId(subId) {
        return document.getElementById(formatId(lightboxId, subId));
    };
    var groupNamingKey = "common.user_group";
    var GroupNamingKey = "common.User_Group";

    var groupDivIdPrefix = formatId(lightboxId, "userGroupRow");
    var groupDeleteLinkIdPrefix = formatId(lightboxId, "userGroupDeleteLink");
    var deleteGroupUndoButtonIdPrefix = formatId(lightboxId, "confirmDeleteUndoButton");
    var deleteGroupAcceptButtonIdPrefix = formatId(lightboxId, "confirmDeleteAcceptButton");
    var editGroupUndoButtonIdPrefix = formatId(lightboxId, "editUserGroupUndoButton");
    var editGroupAcceptButtonIdPrefix = formatId(lightboxId, "editUserGroupAcceptButton");
    var editGroupInputIdPrefix = formatId(lightboxId, "editUserGroupInput");
    var groupNameCellIdPrefix = formatId(lightboxId, "userGroupNameCell");
    var groupEditInputCellIdPrefix = formatId(lightboxId, "userGroupEditInputCell");
    var groupEditTableCellIdPrefix = formatId(lightboxId, "userGroupEditTableCell");
    var groupWaitingAnimationCellIdPrefix = formatId(lightboxId, "userGroupWaitingAnimationCell");
    var groupSpinnerContainerIdPrefix = formatId(lightboxId, "groupSpinnerContainer");

    var userDivIdPrefix = formatId(lightboxId, "userDiv");
    var userCheckboxIdPrefix = formatId(lightboxId, "userCheckbox");

    var ajaxProcessingClassName = "ajaxProcessing";

    var groupContainer = getElementBySubId("groupContainer");
    var userContainer = getElementBySubId("userContainer");
    var addGroupContainer = getElementBySubId('addGroupContainer');
    var userContainerWrapper = getElementBySubId("userContainerWrapper");
    var validatorGroupStrategy = new _GroupValidatorStrategy.UserGroupValidatorStrategy();
    var emptyGroupMessageTable = getElementBySubId("emptyGroupMessageTable");
    var emptyGroupResolver = new EmptyGroupResolver(emptyGroupMessageTable, emptyGroupMessageTable.getElementsByTagName("td")[0], userContainerWrapper, {
        groupNamingKey: groupNamingKey,
        GroupNamingKey: GroupNamingKey,
        validatorGroupStrategy: validatorGroupStrategy
    });

    var addGroupTableId = formatId(lightboxId, 'addGroupRow');
    var addGroupInputId = formatId(lightboxId, 'newGroupInput');
    var addGroupButtonId = formatId(lightboxId, 'addGroupButton');
    var addGroupSpinnerId = formatId(lightboxId, 'addNewGroupWaitingAnimationCell');

    var spinnerController = GroupManagementUtil.createSpinnerControllerForGroupsLightbox();

    groupRenderer.init({
        groupDivClassName: "userGroupDiv",
        groupTableClassName: "entityTable",
        folderImgClassName: "folderImageCell",
        deleteGroupLinkClassName: "deleteGroupCell",
        groupNameCellClassName: "groupNameCell",
        counterSpanClassName: "counterCell",
        waitingAnimationCellClassName: "waitingAnimationCell",
        editTableCellClassName: "editGroupTableCell",
        editInputClassName: "editGroupInput",
        undoButtonClassName: "undoEdit",
        acceptButtonClassName: "acceptEdit",
        nullGroupClassName: "nullGroup",
        confirmDeleteCellClassName: "confirmDeleteGroupCell",
        confirmDeleteAcceptButtonClassName: "confirmDeleteGroupButton",
        confirmDeleteUndoButtonClassName: "cancelDeleteGroupButton",
        groupDivIdPrefix: groupDivIdPrefix,
        deleteLinkIdPrefix: groupDeleteLinkIdPrefix,
        undoEditIdPrefix: editGroupUndoButtonIdPrefix,
        acceptEditIdPrefix: editGroupAcceptButtonIdPrefix,
        editInputIdPrefix: editGroupInputIdPrefix,
        nameCellIdPrefix: groupNameCellIdPrefix,
        inputCellIdPrefix: groupEditInputCellIdPrefix,
        editGroupCellIdPrefix: groupEditTableCellIdPrefix,
        waitingAnimationCellIdPrefix: groupWaitingAnimationCellIdPrefix,
        spinnerContainerIdPrefix: groupSpinnerContainerIdPrefix,
        confirmDeleteCellIdPrefix: formatId(lightboxId, "confirmDeleteGroupId"),
        confirmDeleteAcceptButtonIdPrefix: deleteGroupAcceptButtonIdPrefix,
        confirmDeleteUndoButtonIdPrefix: deleteGroupUndoButtonIdPrefix,
        groupNamingKey: groupNamingKey,
        GroupNamingKey: GroupNamingKey,
        validatorGroupStrategy: validatorGroupStrategy
    });

    var userRenderer = new UserRenderer("userDiv", "entityTable", "dragImageCell", "usernameCell", "grayedText", "checkboxCell", userDivIdPrefix, userCheckboxIdPrefix);

    var ddController = new DragAndDropController("groupManagementLightBox_ddProxy", "groupManagementLightBox_ddProxyRow", "currentlyDraggedUserDiv", "undroppable", groupNamingKey);

    groupController.init({
        topGroupNameLabel: getElementBySubId("topGroupNameLabel"),
        deletedNowGroupClassName: ajaxProcessingClassName + " deletedNow",
        editedNowGroupClassName: ajaxProcessingClassName + " editedNow",
        movedInNowGroupClassName: ajaxProcessingClassName,
        editedClassName: "editedGroup",
        confirmDeleteClassName: "deleteConfirm",
        errorTextClassName: "errorText",
        groupDivIdPrefix: groupDivIdPrefix,
        groupDeleteLinkIdPrefix: groupDeleteLinkIdPrefix,
        undoDeleteIdPrefix: deleteGroupUndoButtonIdPrefix,
        acceptDeleteIdPrefix: deleteGroupAcceptButtonIdPrefix,
        undoEditIdPrefix: editGroupUndoButtonIdPrefix,
        acceptEditIdPrefix: editGroupAcceptButtonIdPrefix,
        editInputIdPrefix: editGroupInputIdPrefix,
        nameCellIdPrefix: groupNameCellIdPrefix,
        inputCellIdPrefix: groupEditInputCellIdPrefix,
        editGroupCellIdPrefix: groupEditTableCellIdPrefix,
        waitingAnimationCellIdPrefix: groupWaitingAnimationCellIdPrefix,
        spinnerContainerIdPrefix: groupSpinnerContainerIdPrefix,
        spinnerController: spinnerController,
        groupNamingKey: groupNamingKey,
        GroupNamingKey: GroupNamingKey
    });

    var userController = new UserController(userDivIdPrefix, userCheckboxIdPrefix, "selectedUser");

    var addGroupRenderer = new AddUserGroupRenderer().init({
        addGroupTableId: addGroupTableId,
        inputId: addGroupInputId,
        buttonId: addGroupButtonId,
        spinnerId: addGroupSpinnerId,
        imageCellClassName: 'addImageCell',
        inputCellClassName: 'newGroupInputCell',
        buttonCellClassName: 'addGroupButtonCell',
        spinnerCellClassName: 'waitingAnimationCell'
    });

    addGroupController.init({
        newGroupInputId: addGroupInputId,
        newGroupInputCellId: formatId(lightboxId, 'addGroupContainer'),
        addGroupButtonId: addGroupButtonId,
        addGroupRowId: addGroupTableId,
        rowHighlightedClassName: "rowHighlighted",
        ajaxProcessingClassName: ajaxProcessingClassName,
        waitingAnimationCellId: addGroupSpinnerId,
        groupNamingKey: groupNamingKey,
        GroupNamingKey: GroupNamingKey,
        spinnerController: spinnerController
    });

    var highlightController = new HighlightController("selectedUserGroupDiv", "userGroupDivHover", "groupButtonControlHover", "hoverUndoAcceptEditButton");

    var commonRenderer = new CommonRenderer(groupRenderer, userRenderer, addGroupRenderer, groupContainer, userContainer, addGroupContainer, formatId(lightboxId, "moveToMenu"));

    var showDisabledUsersCheckbox = getElementBySubId("showDisabledUsersCheckbox");
    var dataLoadingSpinnerContainerId = formatId(lightboxId, "dataLoadingSpinnerContainer");

    return controller.init(commonRenderer, groupController, userController, ddController, addGroupController, highlightController, emptyGroupResolver, groupContainer, getElementBySubId("selectAllButtonImg"), getElementBySubId("clearSelectionButtonImg"), getElementBySubId("filterSelectionButtonImg"), showDisabledUsersCheckbox, getElementBySubId("showDisabledUsersLabel"), getElementBySubId("errorMessagesRow"), getElementBySubId("bottomErrorMessageText"), document.getElementById(lightboxId), "ajaxIsNow", "dragAndDropIsNow", "UserGroupManagementService", GroupNamingKey, spinnerController, dataLoadingSpinnerContainerId, "dataLoading", validatorGroupStrategy);
};

GroupManagementUtil.initializeTimeZoneGroupsLightBox = function () {
    var groupNamingKey = "common.time_zone_group";
    var GroupNamingKey = "common.Time_Zone_Group";
    var lightboxId = "timeZoneGroupManagementLightBox";
    var getElementBySubId = function getElementBySubId(subId) {
        return document.getElementById(formatId(lightboxId, subId));
    };

    var groupDivIdPrefix = formatId(lightboxId, "userGroupRow");
    var groupDeleteLinkIdPrefix = formatId(lightboxId, "userGroupDeleteLink");
    var deleteGroupUndoButtonIdPrefix = formatId(lightboxId, "confirmDeleteUndoButton");
    var deleteGroupAcceptButtonIdPrefix = formatId(lightboxId, "confirmDeleteAcceptButton");
    var editGroupUndoButtonIdPrefix = formatId(lightboxId, "editUserGroupUndoButton");
    var editGroupAcceptButtonIdPrefix = formatId(lightboxId, "editUserGroupAcceptButton");
    var editGroupInputIdPrefix = formatId(lightboxId, "editUserGroupInput");
    var groupNameCellIdPrefix = formatId(lightboxId, "userGroupNameCell");
    var groupEditInputCellIdPrefix = formatId(lightboxId, "userGroupEditInputCell");
    var groupEditTableCellIdPrefix = formatId(lightboxId, "userGroupEditTableCell");
    var groupWaitingAnimationCellIdPrefix = formatId(lightboxId, "userGroupWaitingAnimationCell");
    var groupSpinnerContainerIdPrefix = formatId(lightboxId, "groupSpinnerContainer");
    var groupSelectorIdPrefix = formatId(lightboxId, 'groupCitySelector');
    var groupCurrentTimeIdPrefix = formatId(lightboxId, 'groupCurrentTime');

    var userDivIdPrefix = formatId(lightboxId, "userDiv");
    var userCheckboxIdPrefix = formatId(lightboxId, "userCheckbox");

    var ajaxProcessingClassName = "ajaxProcessing";

    var groupContainer = getElementBySubId("groupContainer");
    var userContainer = getElementBySubId("userContainer");
    var addGroupContainer = getElementBySubId('addGroupContainer');
    var userContainerWrapper = getElementBySubId("userContainerWrapper");
    var validatorGroupStrategy = new _GroupValidatorStrategy.TimeZoneGroupValidatorStrategy();
    var emptyGroupMessageTable = getElementBySubId("emptyGroupMessageTable");
    var emptyGroupResolver = new EmptyGroupResolver(emptyGroupMessageTable, emptyGroupMessageTable.getElementsByTagName("td")[0], userContainerWrapper, {
        groupNamingKey: groupNamingKey,
        GroupNamingKey: GroupNamingKey,
        validatorGroupStrategy: validatorGroupStrategy
    });

    var addGroupTableId = formatId(lightboxId, 'addGroupRow');
    var addGroupInputId = formatId(lightboxId, 'newGroupInput');
    var addGroupButtonId = formatId(lightboxId, 'addGroupButton');
    var addGroupSpinnerId = formatId(lightboxId, 'addNewGroupWaitingAnimationCell');
    var addGroupSelectorId = formatId(lightboxId, 'addGroupSelectorId');

    var spinnerController = GroupManagementUtil.createSpinnerControllerForGroupsLightbox();
    var groupRenderer = new _time_zone_group_renderer2.default().init({
        groupDivClassName: "userGroupDiv",
        groupTableClassName: "entityTable",
        folderImgClassName: "folderImageCell",
        deleteGroupLinkClassName: "deleteGroupCell",
        groupNameCellClassName: "groupNameCell",
        counterSpanClassName: "counterCell",
        waitingAnimationCellClassName: "waitingAnimationCell",
        editTableCellClassName: "editGroupTableCell",
        editInputClassName: "editGroupInput",
        undoButtonClassName: "undoEdit",
        acceptButtonClassName: "acceptEdit",
        defaultGroupClassName: "defaultGroup",
        confirmDeleteCellClassName: "confirmDeleteGroupCell",
        confirmDeleteAcceptButtonClassName: "confirmDeleteGroupButton",
        confirmDeleteUndoButtonClassName: "cancelDeleteGroupButton",
        selectorCellClassName: 'selectorCell',
        secondRowClassName: 'secondRow',
        defaultGroupLabelCellClassName: 'defaultGroupLabelCell',
        currentTimeCellClassName: 'currentTimeCell',
        groupDivIdPrefix: groupDivIdPrefix,
        deleteLinkIdPrefix: groupDeleteLinkIdPrefix,
        undoEditIdPrefix: editGroupUndoButtonIdPrefix,
        acceptEditIdPrefix: editGroupAcceptButtonIdPrefix,
        editInputIdPrefix: editGroupInputIdPrefix,
        nameCellIdPrefix: groupNameCellIdPrefix,
        inputCellIdPrefix: groupEditInputCellIdPrefix,
        editGroupCellIdPrefix: groupEditTableCellIdPrefix,
        waitingAnimationCellIdPrefix: groupWaitingAnimationCellIdPrefix,
        spinnerContainerIdPrefix: groupSpinnerContainerIdPrefix,
        confirmDeleteCellIdPrefix: formatId(lightboxId, "confirmDeleteGroupId"),
        confirmDeleteAcceptButtonIdPrefix: deleteGroupAcceptButtonIdPrefix,
        confirmDeleteUndoButtonIdPrefix: deleteGroupUndoButtonIdPrefix,
        selectorIdPrefix: groupSelectorIdPrefix,
        currentTimeIdPrefix: groupCurrentTimeIdPrefix,
        groupNamingKey: groupNamingKey,
        GroupNamingKey: GroupNamingKey,
        validatorGroupStrategy: validatorGroupStrategy
    });

    var userRenderer = new UserRenderer("userDiv", "entityTable", "dragImageCell", "usernameCell", "grayedText", "checkboxCell", userDivIdPrefix, userCheckboxIdPrefix);

    var ddController = new DragAndDropController("groupManagementLightBox_ddProxy", "groupManagementLightBox_ddProxyRow", "currentlyDraggedUserDiv", "undroppable", groupNamingKey);

    var groupController = new _time_zone_group_controller2.default().init({
        topGroupNameLabel: getElementBySubId("topGroupNameLabel"),
        deletedNowGroupClassName: ajaxProcessingClassName + " deletedNow",
        editedNowGroupClassName: ajaxProcessingClassName + " editedNow",
        movedInNowGroupClassName: ajaxProcessingClassName,
        editedClassName: "editedGroup",
        confirmDeleteClassName: "deleteConfirm",
        errorTextClassName: "errorText",
        groupDivIdPrefix: groupDivIdPrefix,
        groupDeleteLinkIdPrefix: groupDeleteLinkIdPrefix,
        undoDeleteIdPrefix: deleteGroupUndoButtonIdPrefix,
        acceptDeleteIdPrefix: deleteGroupAcceptButtonIdPrefix,
        undoEditIdPrefix: editGroupUndoButtonIdPrefix,
        acceptEditIdPrefix: editGroupAcceptButtonIdPrefix,
        editInputIdPrefix: editGroupInputIdPrefix,
        nameCellIdPrefix: groupNameCellIdPrefix,
        inputCellIdPrefix: groupEditInputCellIdPrefix,
        editGroupCellIdPrefix: groupEditTableCellIdPrefix,
        waitingAnimationCellIdPrefix: groupWaitingAnimationCellIdPrefix,
        spinnerContainerIdPrefix: groupSpinnerContainerIdPrefix,
        selectorIdPrefix: groupSelectorIdPrefix,
        spinnerController: spinnerController,
        currentTimeIdPrefix: groupCurrentTimeIdPrefix,
        groupNamingKey: groupNamingKey,
        GroupNamingKey: GroupNamingKey
    });

    var userController = new UserController(userDivIdPrefix, userCheckboxIdPrefix, "selectedUser");

    var addGroupRenderer = new AddTimeZoneGroupRenderer().init({
        addGroupTableId: addGroupTableId,
        inputId: addGroupInputId,
        buttonId: addGroupButtonId,
        spinnerId: addGroupSpinnerId,
        selectorId: addGroupSelectorId,
        imageCellClassName: 'addImageCell',
        inputCellClassName: 'newGroupInputCell',
        buttonCellClassName: 'addGroupButtonCell',
        spinnerCellClassName: 'waitingAnimationCell',
        selectorCellClassName: 'selectorCell',
        timeZoneImageCellClassName: 'timeZoneImageCell',
        groupNamingKey: groupNamingKey,
        GroupNamingKey: GroupNamingKey
    });

    var addGroupController = new AddTimeZoneGroupController().init({
        newGroupInputId: addGroupInputId,
        newGroupInputCellId: formatId(lightboxId, 'addGroupContainer'),
        addGroupButtonId: addGroupButtonId,
        addGroupRowId: addGroupTableId,
        addGroupSelectorId: addGroupSelectorId,
        rowHighlightedClassName: "rowHighlighted",
        ajaxProcessingClassName: ajaxProcessingClassName,
        waitingAnimationCellId: addGroupSpinnerId,
        editStateClassName: 'editState',
        groupNamingKey: groupNamingKey,
        GroupNamingKey: GroupNamingKey,
        spinnerController: spinnerController
    });

    var highlightController = new HighlightController("selectedUserGroupDiv", "userGroupDivHover", "groupButtonControlHover", "hoverUndoAcceptEditButton");

    var commonRenderer = new CommonRenderer(groupRenderer, userRenderer, addGroupRenderer, groupContainer, userContainer, addGroupContainer, formatId(lightboxId, "moveToMenu"));

    var showDisabledUsersCheckbox = getElementBySubId("showDisabledUsersCheckbox");
    var dataLoadingSpinnerContainerId = formatId(lightboxId, "dataLoadingSpinnerContainer");

    return new _base_group_management_controller.TimeZoneGroupManagementController().init(commonRenderer, groupController, userController, ddController, addGroupController, highlightController, emptyGroupResolver, groupContainer, getElementBySubId("selectAllButtonImg"), getElementBySubId("clearSelectionButtonImg"), getElementBySubId("filterSelectionButtonImg"), showDisabledUsersCheckbox, getElementBySubId("showDisabledUsersLabel"), getElementBySubId("errorMessagesRow"), getElementBySubId("bottomErrorMessageText"), document.getElementById(lightboxId), "ajaxIsNow", "dragAndDropIsNow", "TimeZoneGroupManagementService", GroupNamingKey, spinnerController, dataLoadingSpinnerContainerId, "dataLoading", validatorGroupStrategy, "onlyOneGroup");
};

GroupManagementUtil.createSpinnerControllerForGroupsLightbox = function () {
    var spinnerOptions = {
        lines: 11, // The number of lines to draw
        length: 6, // The length of each line
        width: 2, // The line thickness
        radius: 5, // The radius of the inner circle
        corners: 1, // Corner roundness (0..1)
        rotate: 0, // The rotation offset
        direction: 1, // 1: clockwise, -1: counterclockwise
        color: '#bbbbbb', // #rgb or #rrggbb
        speed: 1, // Rounds per second
        trail: 60, // Afterglow percentage
        shadow: false, // Whether to render a shadow
        hwaccel: false, // Whether to use hardware acceleration
        className: 'spinner', // The CSS class to assign to the spinner
        zIndex: 2e9, // The z-index (defaults to 2000000000)
        top: 'auto', // Top position relative to parent in px
        left: 'auto' // Left position relative to parent in px
    };
    var spinner = new Spinner(spinnerOptions);
    var spinnerController = new _SpinnerController2.default(true);
    spinnerController.setSpinner(spinner);
    return spinnerController;
};

exports.default = GroupManagementUtil;

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Group2 = __webpack_require__(158);

var _Group3 = _interopRequireDefault(_Group2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GroupWithUsers = function (_Group) {
    _inherits(GroupWithUsers, _Group);

    function GroupWithUsers(id, name, validatorGroupStrategy, users) {
        _classCallCheck(this, GroupWithUsers);

        var _this = _possibleConstructorReturn(this, (GroupWithUsers.__proto__ || Object.getPrototypeOf(GroupWithUsers)).call(this, id, name));

        _this.validatorGroupStrategy = validatorGroupStrategy;
        _this.users = users;
        return _this;
    }

    _createClass(GroupWithUsers, [{
        key: "countOfUserWithEnabledAccess",
        value: function countOfUserWithEnabledAccess() {
            var counter = 0;
            for (var i = 0; i < this.users.length; i++) {
                if (this.users[i].active) {
                    counter++;
                }
            }
            return counter;
        }
    }, {
        key: "countOfUsers",
        value: function countOfUsers() {
            return this.users.length;
        }
    }]);

    return GroupWithUsers;
}(_Group3.default);

exports.default = GroupWithUsers;

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UserInGroup = function UserInGroup(id, name, active, requiresTTApproval) {
    _classCallCheck(this, UserInGroup);

    this.id = id;
    this.name = name;
    this.active = active;
    this.requiresTTApproval = requiresTTApproval;
};

exports.default = UserInGroup;

/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Ext = __webpack_require__(12);

var _Ext2 = _interopRequireDefault(_Ext);

var _at_base_date_picker = __webpack_require__(536);

var _at_base_date_picker2 = _interopRequireDefault(_at_base_date_picker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_Ext2.default.namespace('AT');

var DatePicker = _Ext2.default.extend(_at_base_date_picker2.default, {
    showOkCancelButtons: true,
    showClearButton: false,
    /**
     * Determines whether to fire 'update' events.
     */
    useUpdateEvent: false,

    initComponent: function initComponent() {

        DatePicker.superclass.initComponent.call(this);

        this.addEvents(
        /*
         * @event update
         * Fires when the contents of the date picker are updated, e.g. when the cursor is moved or month is changed,
         * but the selection is not submitted (the date picker remains visible).
         * Fires only if {@link AT.DatePicker#useUpdateEvent} is true.
         * @param {DatePicker} this
         * @param {Date} date The currently selected date
         */
        'update',
        /*
         * Fires when the user cancels the date selection.
         * @param {DatePicker} this
         */
        'cancel');

        this.clearMonthYearSwitchingState();

        this.suppressActiveDayFocus = false;
    },

    // override
    update: function update(date, forceRefresh, wasMonthOrYearSwitched) {
        if (wasMonthOrYearSwitched) {
            this.setMonthYearSwitchingStateIfNotSet();

            if (this.getMonthYearSwitchingState() == 'keep_month_end') {
                date = date.getLastDateOfMonth();
            }
        } else if (date != this.activeDate) {
            this.clearMonthYearSwitchingState();
        }

        var vd = this.activeDate;

        var self = this;

        var fireUpdateEvent = function fireUpdateEvent() {
            if (self.useUpdateEvent) self.fireEvent("update", self, self.activeDate);
        };

        if (date < this.actualMin) {
            if (this.activeDate.getMonth() != this.actualMin.getMonth()) {
                this.activeDate = this.actualMin;
            }
        } else if (date > this.actualMax) {
            if (this.activeDate.getMonth() != this.actualMax.getMonth()) {
                this.activeDate = this.actualMax;
            }
        } else {
            this.activeDate = date;
        }

        if (!forceRefresh && vd && this.el) {
            var t = this.activeDate.getTime();
            if (vd.getMonth() == this.activeDate.getMonth() && vd.getFullYear() == this.activeDate.getFullYear()) {
                this.cells.removeClass("x-date-selected");
                this.cells.each(function (c) {
                    if (c.dom.firstChild.dateValue == t) {
                        c.addClass("x-date-selected");

                        if (!self.suppressActiveDayFocus) {
                            setTimeout(function () {
                                try {
                                    c.dom.firstChild.focus();
                                } catch (e) {}
                            }, 50);
                            return false;
                        }
                    }
                    return undefined;
                });
                fireUpdateEvent();
                this.suppressActiveDayFocus = false;
                return;
            }
        }

        if (this.todayBtn) this.todayBtn.setDisabled(this.todayIsDisabled);

        this.updateCells(this.activeDate);

        this.suppressActiveDayFocus = false;
        fireUpdateEvent();
    },

    setCellClasses: function setCellClasses(cell, isWeekend, date, today) {
        DatePicker.superclass.setCellClasses.call(this, cell, isWeekend, date, today);
        if (date.isSameDate(this.activeDate)) {
            cell.className += " x-date-selected";

            if (!this.suppressActiveDayFocus) {
                setTimeout(function () {
                    try {
                        cell.firstChild.focus();
                    } catch (e) {}
                }, 50);
            }
        }
    },

    // override
    onRender: function onRender(container, position) {
        DatePicker.superclass.onRender.call(this, container, position);

        // Due to the fact that 'showToday' is actually 'show bottom pane',
        // if showToday is false, the OK and Cancel buttons also won't be shown,
        // since there's no element to render them to.
        if (this.showToday) {
            var bottomArea = this.el.child("td.x-date-bottom", true);

            bottomArea.innerHTML = ['<table width="100%" cellpadding="0" cellspacing="0"><tbody><tr>', this.showClearButton ? '<td class="x-date-at-clear-cell"></td>' : '', this.showOkCancelButtons ? '<td class="x-date-at-ok-cancel-cell x-date-mp-btns"></td>' : '', '<td class="x-date-at-today-cell"></td>', '</tr></tbody></table>'].join('');

            // HTML copied (and slightly changed) from month picker
            var buttonTemplate = new _Ext2.default.Template('<em unselectable="on"><button type="button" type="{1}">{0}</button></em>');

            if (this.showClearButton) {
                this.clearButton = new _Ext2.default.Button({
                    renderTo: this.el.child("td.x-date-at-clear-cell", true),
                    text: this.clearText,
                    template: buttonTemplate,
                    handler: this.clear,
                    scope: this
                });
            }

            if (this.showOkCancelButtons) {
                //noinspection JSUnusedGlobalSymbols
                this.atOkBtn = new _Ext2.default.Button({
                    renderTo: this.el.child("td.x-date-at-ok-cancel-cell", true),
                    text: this.okText,
                    template: buttonTemplate,
                    handler: this.onOkClick,
                    scope: this
                });

                //noinspection JSUnusedGlobalSymbols
                this.atCancelBtn = new _Ext2.default.Button({
                    renderTo: this.el.child("td.x-date-at-ok-cancel-cell", true),
                    text: this.cancelText,
                    template: buttonTemplate,
                    handler: this.onCancelClick,
                    scope: this
                });
            }
            // Actually, the today button is created twice (the first time in the base class),
            // so this might be a subject for optimization.
            var today = window.currentUserTime().dateFormat(this.format);
            this.todayBtn = new _Ext2.default.Button({
                renderTo: this.el.child("td.x-date-at-today-cell", true),
                text: String.format(this.todayText, today),
                template: buttonTemplate,
                handler: this.selectToday,
                scope: this
            });

            // replace the default confusing spacebar handler
            this.todayKeyListener.disable();
            //noinspection JSUnusedGlobalSymbols
            this.spacebarListener = new _Ext2.default.KeyMap(this.eventEl, {
                key: _Ext2.default.EventObject.SPACE,
                handler: this.onOkClick,
                scope: this,
                stopEvent: true
            });
        }

        _Ext2.default.get(this.el).addClass("atap-date-picker");
    },

    /**
     * Behaves as if the user clicked on an active day ('active' means the day under cursor).
     * Selects the active day and fires the 'select' event.
     */
    selectActiveDate: function selectActiveDate() {
        this.suppressActiveDayFocus = true; // Hack: Suppress automatic active day focusing in the next update().
        // Because focusing is deferred, and the date picker is usually hidden
        // after calling this method, focusing would cause a lot of trouble.
        this.setValue(this.activeDate);
        this.fireEvent("select", this, this.value);
    },

    /**
     * Cancels the selection.
     */
    cancel: function cancel() {
        this.fireEvent("cancel", this);
    },

    onOkClick: function onOkClick() {
        this.selectActiveDate();
    },

    onCancelClick: function onCancelClick() {
        this.cancel();
    },

    // override
    showPrevMonth: function showPrevMonth() {
        this.update(this.activeDate.add("mo", -1), false, true);
    },

    // override
    showNextMonth: function showNextMonth() {
        this.update(this.activeDate.add("mo", 1), false, true);
    },

    // override
    showPrevYear: function showPrevYear() {
        var newDate = this.activeDate.add("y", -1);
        this.update(this.fix29februaryIssue(newDate), false, true);
    },

    // override
    showNextYear: function showNextYear() {
        var newDate = this.activeDate.add("y", 1);
        this.update(this.fix29februaryIssue(newDate), false, true);
    },

    monthPickerApply: function monthPickerApply(year, month) {
        var d = new Date(year, month, (this.activeDate || this.value).getDate());
        if (d.getMonth() != month) {
            // "fix" the JS rolling date conversion if needed
            d = new Date(year, month, 1).getLastDateOfMonth();
        }
        this.update(d, false, true);
        this.hideMonthPicker();
    },

    setMonthYearSwitchingStateIfNotSet: function setMonthYearSwitchingStateIfNotSet() {
        if (this.monthYearSwitchingState == 'off') {
            if (this.activeDate.format("j") == this.activeDate.getDaysInMonth()) this.monthYearSwitchingState = 'keep_month_end';else this.monthYearSwitchingState = 'keep_same_day';
        }
    },

    clearMonthYearSwitchingState: function clearMonthYearSwitchingState() {
        this.monthYearSwitchingState = 'off';
    },

    getMonthYearSwitchingState: function getMonthYearSwitchingState() {
        return this.monthYearSwitchingState;
    }
});

_Ext2.default.reg('atdatepicker', DatePicker);

exports.default = DatePicker;

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TableCellRenderer2 = __webpack_require__(63);

var _TableCellRenderer3 = _interopRequireDefault(_TableCellRenderer2);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BalanceRulesRenderer = function (_TableCellRenderer) {
    _inherits(BalanceRulesRenderer, _TableCellRenderer);

    function BalanceRulesRenderer() {
        _classCallCheck(this, BalanceRulesRenderer);

        return _possibleConstructorReturn(this, (BalanceRulesRenderer.__proto__ || Object.getPrototypeOf(BalanceRulesRenderer)).apply(this, arguments));
    }

    _createClass(BalanceRulesRenderer, [{
        key: 'init',
        value: function init(formatter, _ref) {
            var _ref$onClickHandler = _ref.onClickHandler,
                onClickHandler = _ref$onClickHandler === undefined ? function () {} : _ref$onClickHandler,
                _ref$onMouseOverHandl = _ref.onMouseOverHandler,
                onMouseOverHandler = _ref$onMouseOverHandl === undefined ? function () {} : _ref$onMouseOverHandl,
                _ref$onMouseOutHandle = _ref.onMouseOutHandler,
                onMouseOutHandler = _ref$onMouseOutHandle === undefined ? function () {} : _ref$onMouseOutHandle,
                _ref$onMouseMoveHandl = _ref.onMouseMoveHandler,
                onMouseMoveHandler = _ref$onMouseMoveHandl === undefined ? function () {} : _ref$onMouseMoveHandl;

            this.formatter = formatter;
            this.onClickHandler = onClickHandler;
            this.onMouseOverHandler = onMouseOverHandler;
            this.onMouseOutHandler = onMouseOutHandler;
            this.onMouseMoveHandler = onMouseMoveHandler;

            return this;
        }
    }, {
        key: 'getCellClassName',
        value: function getCellClassName(cell) {
            var data = this.getBalanceFromCellValue(cell.getValue());
            var result = [this.getCellGeneralClassName()];

            if (!data) result.push("noBalance");else if (data.defaultRules) result.push("defaultRules");

            result.push(this._customClassName());

            return result;
        }
    }, {
        key: 'getCellGeneralClassName',
        value: function getCellGeneralClassName() {
            return this.mixin.cellGeneralClassName;
        }
    }, {
        key: 'getBalanceFromCellValue',
        value: function getBalanceFromCellValue(value) {
            var balanceData = this.mixin.getBalanceFromCellValue(value);
            if (balanceData) {
                balanceData.hireDate = value.hireDate;
            }
            return balanceData;
        }
    }, {
        key: 'generateContent',
        value: function generateContent(cell) {
            var _this2 = this;

            var data = this.getBalanceFromCellValue(cell.getValue());

            if (!data) return;

            var cellEl = cell.getCellEl();

            if (!data.defaultRules || this._handleDefaultPTORules()) cellEl.innerHTML = !data ? "" : this._getRuleValue(data);

            if (this.onClickHandler) cellEl.onclick = function (e) {
                return _this2.onClickHandler(e, data, cell);
            };

            if (this.onMouseOverHandler) (0, _jquery2.default)(cellEl).hover(function (e) {
                return _this2.onMouseOverHandler(e, data);
            }, this.onMouseOutHandler);

            if (this.onMouseMoveHandler) (0, _jquery2.default)(cellEl).mousemove(this.onMouseMoveHandler);
        }
    }, {
        key: '_getRuleValue',
        value: function _getRuleValue(ptoData) {
            // abstract
        }
    }, {
        key: '_customClassName',
        value: function _customClassName(ptoData) {
            // abstract
        }
    }, {
        key: '_handleDefaultPTORules',
        value: function _handleDefaultPTORules(ptoData) {
            return false;
        }
    }]);

    return BalanceRulesRenderer;
}(_TableCellRenderer3.default);

exports.default = BalanceRulesRenderer;

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
function PtoRulesMixin() {}

PtoRulesMixin.prototype.cellGeneralClassName = "ptoRulesCell";
PtoRulesMixin.prototype.getBalanceFromCellValue = function (value) {
    return value.currentPTOBalance;
};

exports.default = PtoRulesMixin;

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
function SickDaysRulesMixin() {}
SickDaysRulesMixin.prototype.cellGeneralClassName = "sickDaysRulesCell";
SickDaysRulesMixin.prototype.getBalanceFromCellValue = function (value) {
    return value.currentSickDaysBalance;
};

exports.default = SickDaysRulesMixin;

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.handleConcurrentlyRemovedEntitiesAction = undefined;
exports.needMoreEntities = needMoreEntities;
exports.hasConcurrentlyRemovedEntities = hasConcurrentlyRemovedEntities;

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _actions = __webpack_require__(29);

var EntitiesActions = _interopRequireWildcard(_actions);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function needMoreEntities(showEditor, entitiesLevelSelected, entitiesLoading, entitiesLoaded) {
    return showEditor && entitiesLevelSelected && !entitiesLoading && !entitiesLoaded;
}

function hasConcurrentlyRemovedEntities(data) {
    var removedEntitiesIds = data['additionalResultData']['map']['concurrentlyRemovedEntities'];
    return removedEntitiesIds && (removedEntitiesIds.customers && removedEntitiesIds.customers.length > 0 || removedEntitiesIds.projects && removedEntitiesIds.projects.length > 0 || removedEntitiesIds.tasks && removedEntitiesIds.tasks.length > 0);
}

var handleConcurrentlyRemovedEntitiesAction = exports.handleConcurrentlyRemovedEntitiesAction = function handleConcurrentlyRemovedEntitiesAction(_ref) {
    var getEditingLevel = _ref.getEditingLevel,
        hierarchyAssignmentsEditorActions = _ref.hierarchyAssignmentsEditorActions;
    return function (data) {
        var assignAll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        return function (dispatch, getState) {

            var state = getState();

            var _getEditingLevel = getEditingLevel(state),
                customerId = _getEditingLevel.customerId,
                projectId = _getEditingLevel.projectId;

            var removedEntitiesIds = data['additionalResultData']['map']['concurrentlyRemovedEntities'];

            if (removedEntitiesIds) {
                if (removedEntitiesIds.customers && removedEntitiesIds.customers.length > 0) {
                    var msgKey = projectId !== null && !assignAll ? 'userlist.ha_editor.concurrently_deleted_error.customer_of_task' : customerId !== null && !assignAll ? 'userlist.ha_editor.concurrently_deleted_error.customer_of_project' : 'userlist.ha_editor.concurrently_deleted_error.customer';
                    alert(_messageResource2.default.getMessage(msgKey));
                    if (customerId !== null) {
                        dispatch(hierarchyAssignmentsEditorActions.deselectCustomer(customerId));
                    }
                    dispatch(EntitiesActions.removeCustomers(removedEntitiesIds.customers));
                } else if (removedEntitiesIds.projects && removedEntitiesIds.projects.length > 0) {
                    var _msgKey = projectId !== null && !assignAll ? 'userlist.ha_editor.concurrently_deleted_error.project_of_task' : 'userlist.ha_editor.concurrently_deleted_error.project';
                    alert(_messageResource2.default.getMessage(_msgKey));
                    if (projectId !== null) {
                        dispatch(hierarchyAssignmentsEditorActions.deselectProject(projectId));
                    }
                    dispatch(EntitiesActions.removeProjects(removedEntitiesIds.projects));
                } else if (removedEntitiesIds.tasks && removedEntitiesIds.tasks.length > 0) {
                    alert(_messageResource2.default.getMessage('userlist.ha_editor.concurrently_deleted_error.task'));
                    dispatch(EntitiesActions.removeTasks(removedEntitiesIds.tasks));
                }
            }
        };
    };
};

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (getTabState) {
    var getUserId = function getUserId(state) {
        return getTabState(state).userId;
    };
    var getTab = function getTab(state) {
        return getTabState(state).tab;
    };
    var getTaskIds = function getTaskIds(state) {
        return getTabState(state).taskIds;
    };
    var getProjectIds = function getProjectIds(state) {
        return getTabState(state).projectIds;
    };
    var getCustomerIds = function getCustomerIds(state) {
        return getTabState(state).customerIds;
    };
    var getManagementTaskIds = function getManagementTaskIds(state) {
        return getTabState(state).manageCptIds.taskIds;
    };
    var getManagementProjectIds = function getManagementProjectIds(state) {
        return getTabState(state).manageCptIds.projectIds;
    };
    var getManagementExcludingSelfProjectIds = function getManagementExcludingSelfProjectIds(state) {
        return getTabState(state).manageCptIds.projectIdsExcludingSelf;
    };
    var getManagementCustomerIds = function getManagementCustomerIds(state) {
        return getTabState(state).manageCptIds.customerIds;
    };
    var getManagementExcludingSelfCustomerIds = function getManagementExcludingSelfCustomerIds(state) {
        return getTabState(state).manageCptIds.customerIdsExcludingSelf;
    };
    var isCustomerTabLoaded = function isCustomerTabLoaded(state) {
        return getTabState(state).isLoadedCustomerTab;
    };
    var isProjectTabLoaded = function isProjectTabLoaded(state) {
        return getTabState(state).isLoadedProjectTab;
    };
    var isTaskTabLoaded = function isTaskTabLoaded(state) {
        return getTabState(state).isLoadedTaskTab;
    };
    var getUsersCounters = function getUsersCounters(state) {
        return getTabState(state).userCounters;
    };
    var getViewerCounters = function getViewerCounters(state) {
        return (0, _selectors2.getViewerManagementCounters)(state);
    };
    var getSearch = function getSearch(state) {
        return getTabState(state).searchString;
    };
    var isSearchOpen = function isSearchOpen(state) {
        return getTabState(state).searchOpen;
    };
    var isLoading = function isLoading(state) {
        return getTabState(state).loading;
    };
    var isLoaded = function isLoaded(state) {
        return getTabState(state).loaded;
    };
    var isShowArchivedEntities = function isShowArchivedEntities(state) {
        return getTabState(state).isShowArchivedEntities;
    };

    var getLoadedTabs = (0, _reselect.createSelector)(isCustomerTabLoaded, isProjectTabLoaded, isTaskTabLoaded, function (customer, project, task) {
        var _ref;

        return _ref = {}, _defineProperty(_ref, _constants.HierarchyLevels.CUSTOMER, customer), _defineProperty(_ref, _constants.HierarchyLevels.PROJECT, project), _defineProperty(_ref, _constants.HierarchyLevels.TASK, task), _ref;
    });

    var getCounters = (0, _reselect.createSelector)(getUsersCounters, getViewerCounters, function (userCounters, viewerCounters) {
        return {
            customers: {
                curValue: userCounters.customers,
                maxValue: viewerCounters.customers
            },
            projects: {
                curValue: userCounters.projects,
                maxValue: viewerCounters.projects
            },
            tasks: {
                curValue: userCounters.tasks,
                maxValue: viewerCounters.tasks
            }
        };
    });

    var getPanelUser = (0, _reselect.createSelector)(getUserId, _selectors.getUsers, function (userId, users) {
        return users[userId];
    });

    var getPanelUserFirstName = (0, _reselect.createSelector)(getPanelUser, function (user) {
        return user ? user.firstName : "";
    });

    var getPanelUserFML = (0, _reselect.createSelector)(getPanelUser, function (user) {
        return user ? {
            firstName: user.firstName,
            middleInitial: user.middleInitial,
            lastName: user.lastName
        } : {};
    });

    var getFilteredTaskIds = (0, _reselect.createSelector)(getTaskIds, _selectors.getTasks, getSearch, function (ids, tasks, search) {
        return (0, _utils.filterIdsBySearch)(ids, tasks, search);
    });

    var getFilteredProjectIds = (0, _reselect.createSelector)(getProjectIds, _selectors.getProjects, getSearch, function (ids, projects, search) {
        return (0, _utils.filterIdsBySearch)(ids, projects, search);
    });

    var getFilteredCustomerIds = (0, _reselect.createSelector)(getCustomerIds, _selectors.getCustomers, getSearch, function (ids, customers, search) {
        return (0, _utils.filterIdsBySearch)(ids, customers, search);
    });

    var getSortedTaskIds = (0, _reselect.createSelector)(getFilteredTaskIds, _selectors.getTasks, _selectors.getProjects, _selectors.getCustomers, _utils.getSortedTaskIdsByName);

    var getSortedProjectIds = (0, _reselect.createSelector)(getFilteredProjectIds, _selectors.getProjects, _selectors.getCustomers, _utils.getSortedProjectIdsByName);

    var getSortedCustomerIds = (0, _reselect.createSelector)(getFilteredCustomerIds, _selectors.getCustomers, _utils.getSortedCustomerIdsByName);

    var selectTaskMaEntities = (0, _reselect.createSelector)(getSortedTaskIds, _selectors.getTasks, _selectors.getProjects, _selectors.getCustomers, getManagementTaskIds, getManagementProjectIds, getManagementExcludingSelfProjectIds, getManagementCustomerIds, getManagementExcludingSelfCustomerIds, _utils.getTaskMaEntities);

    var selectTaskWaEntities = (0, _reselect.createSelector)(getSortedTaskIds, _selectors.getTasks, _selectors.getProjects, _selectors.getCustomers, getManagementTaskIds, getManagementProjectIds, getManagementExcludingSelfProjectIds, getManagementCustomerIds, getManagementExcludingSelfCustomerIds, _utils.getTaskWaEntities);

    var selectProjectWaEntities = (0, _reselect.createSelector)(getSortedProjectIds, _selectors.getProjects, _selectors.getCustomers, getManagementProjectIds, getManagementExcludingSelfProjectIds, getManagementCustomerIds, getManagementExcludingSelfCustomerIds, _utils.getProjectWaEntities);

    var selectProjectMaEntities = (0, _reselect.createSelector)(getSortedProjectIds, _selectors.getProjects, _selectors.getCustomers, getManagementProjectIds, getManagementExcludingSelfProjectIds, getManagementCustomerIds, getManagementExcludingSelfCustomerIds, _utils.getProjectMaEntities);

    var selectCustomerWaEntities = (0, _reselect.createSelector)(getSortedCustomerIds, _selectors.getCustomers, getManagementCustomerIds, getManagementExcludingSelfCustomerIds, _utils.getCustomerWaEntities);

    var selectCustomerMaEntities = (0, _reselect.createSelector)(getSortedCustomerIds, _selectors.getCustomers, getManagementCustomerIds, getManagementExcludingSelfCustomerIds, _utils.getCustomerMaEntities);

    return {
        getUserId: getUserId,
        getTab: getTab,
        getTaskIds: getTaskIds,
        getProjectIds: getProjectIds,
        getCustomerIds: getCustomerIds,
        getManagementTaskIds: getManagementTaskIds,
        getManagementProjectIds: getManagementProjectIds,
        getManagementExcludingSelfProjectIds: getManagementExcludingSelfProjectIds,
        getManagementCustomerIds: getManagementCustomerIds,
        getManagementExcludingSelfCustomerIds: getManagementExcludingSelfCustomerIds,
        isTaskTabLoaded: isTaskTabLoaded,
        isProjectTabLoaded: isProjectTabLoaded,
        isCustomerTabLoaded: isCustomerTabLoaded,
        getUsersCounters: getUsersCounters,
        getViewerCounters: getViewerCounters,
        getSearch: getSearch,
        isSearchOpen: isSearchOpen,
        getLoadedTabs: getLoadedTabs,
        getCounters: getCounters,
        getPanelUser: getPanelUser,
        getPanelUserFirstName: getPanelUserFirstName,
        getPanelUserFML: getPanelUserFML,
        getFilteredTaskIds: getFilteredTaskIds,
        getFilteredProjectIds: getFilteredProjectIds,
        getFilteredCustomerIds: getFilteredCustomerIds,
        getSortedTaskIds: getSortedTaskIds,
        getSortedProjectIds: getSortedProjectIds,
        getSortedCustomerIds: getSortedCustomerIds,
        selectTaskWaEntities: selectTaskWaEntities,
        selectTaskMaEntities: selectTaskMaEntities,
        selectProjectWaEntities: selectProjectWaEntities,
        selectProjectMaEntities: selectProjectMaEntities,
        selectCustomerWaEntities: selectCustomerWaEntities,
        selectCustomerMaEntities: selectCustomerMaEntities,
        isLoaded: isLoaded,
        isLoading: isLoading,
        isShowArchivedEntities: isShowArchivedEntities
    };
};

var _reselect = __webpack_require__(13);

var _utils = __webpack_require__(549);

var _selectors = __webpack_require__(14);

var _constants = __webpack_require__(4);

var _selectors2 = __webpack_require__(53);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (_ref) {
    var _ref$actionTypes = _ref.actionTypes,
        PANEL_OPEN = _ref$actionTypes.PANEL_OPEN,
        PANEL_CLOSE = _ref$actionTypes.PANEL_CLOSE,
        USER_ID_SET = _ref$actionTypes.USER_ID_SET,
        PANEL_TAB_SET = _ref$actionTypes.PANEL_TAB_SET,
        TASK_IDS_SET = _ref$actionTypes.TASK_IDS_SET,
        PROJECT_IDS_SET = _ref$actionTypes.PROJECT_IDS_SET,
        CUSTOMER_IDS_SET = _ref$actionTypes.CUSTOMER_IDS_SET,
        MANAGE_CUSTOMER_IDS_SET = _ref$actionTypes.MANAGE_CUSTOMER_IDS_SET,
        MANAGE_EXCLUDING_SELF_CUSTOMER_IDS_SET = _ref$actionTypes.MANAGE_EXCLUDING_SELF_CUSTOMER_IDS_SET,
        MANAGE_PROJECT_IDS_SET = _ref$actionTypes.MANAGE_PROJECT_IDS_SET,
        MANAGE_EXCLUDING_SELF_PROJECT_IDS_SET = _ref$actionTypes.MANAGE_EXCLUDING_SELF_PROJECT_IDS_SET,
        MANAGE_TASK_IDS_SET = _ref$actionTypes.MANAGE_TASK_IDS_SET,
        TASK_TAB_LOADED = _ref$actionTypes.TASK_TAB_LOADED,
        PROJECT_TAB_LOADED = _ref$actionTypes.PROJECT_TAB_LOADED,
        CUSTOMER_TAB_LOADED = _ref$actionTypes.CUSTOMER_TAB_LOADED,
        USER_COUNTERS_SET = _ref$actionTypes.USER_COUNTERS_SET,
        VIEWER_COUNTERS_SET = _ref$actionTypes.VIEWER_COUNTERS_SET,
        PANEL_SEARCH_STRING_SET = _ref$actionTypes.PANEL_SEARCH_STRING_SET,
        PANEL_SEARCH_OPEN_SET = _ref$actionTypes.PANEL_SEARCH_OPEN_SET,
        LOADED_SET = _ref$actionTypes.LOADED_SET,
        LOADING_SET = _ref$actionTypes.LOADING_SET,
        SET_IS_SHOW_ARCHIVE_ENTITIES = _ref$actionTypes.SET_IS_SHOW_ARCHIVE_ENTITIES;

    var setTaskIds = (0, _reduxActions.createAction)(TASK_IDS_SET);
    var setProjectIds = (0, _reduxActions.createAction)(PROJECT_IDS_SET);
    var setCustomerIds = (0, _reduxActions.createAction)(CUSTOMER_IDS_SET);

    var setUserId = (0, _reduxActions.createAction)(USER_ID_SET);
    var setTab = (0, _reduxActions.createAction)(PANEL_TAB_SET);

    var setManageTaskIds = (0, _reduxActions.createAction)(MANAGE_TASK_IDS_SET);
    var setManageProjectIds = (0, _reduxActions.createAction)(MANAGE_PROJECT_IDS_SET);
    var setManageExcludingSelfProjectIds = (0, _reduxActions.createAction)(MANAGE_EXCLUDING_SELF_PROJECT_IDS_SET);
    var setManageCustomerIds = (0, _reduxActions.createAction)(MANAGE_CUSTOMER_IDS_SET);
    var setManageExcludingSelfCustomerIds = (0, _reduxActions.createAction)(MANAGE_EXCLUDING_SELF_CUSTOMER_IDS_SET);

    var setUserCounters = (0, _reduxActions.createAction)(USER_COUNTERS_SET);

    var setCustomerTabLoaded = (0, _reduxActions.createAction)(CUSTOMER_TAB_LOADED);
    var setProjectTabLoaded = (0, _reduxActions.createAction)(PROJECT_TAB_LOADED);
    var setTaskTabLoaded = (0, _reduxActions.createAction)(TASK_TAB_LOADED);
    var setSearchString = (0, _reduxActions.createAction)(PANEL_SEARCH_STRING_SET);
    var setSearchOpen = (0, _reduxActions.createAction)(PANEL_SEARCH_OPEN_SET);

    var setLoaded = (0, _reduxActions.createAction)(LOADED_SET);
    var setLoading = (0, _reduxActions.createAction)(LOADING_SET);

    var openPanel = (0, _reduxActions.createAction)(PANEL_OPEN);
    var closePanel = (0, _reduxActions.createAction)(PANEL_CLOSE);

    var setIsShowArchiveEntities = (0, _reduxActions.createAction)(SET_IS_SHOW_ARCHIVE_ENTITIES);

    var clearTabsLoaded = function clearTabsLoaded() {
        return function (dispatch) {
            dispatch(setLoaded(false));
            dispatch(setCustomerTabLoaded(false));
            dispatch(setProjectTabLoaded(false));
            dispatch(setTaskTabLoaded(false));
        };
    };

    var resetSearch = function resetSearch() {
        return function (dispatch) {
            dispatch(setSearchOpen(false));
            dispatch(setSearchString(null));
        };
    };

    return {
        setTaskIds: setTaskIds,
        setProjectIds: setProjectIds,
        setCustomerIds: setCustomerIds,
        setUserId: setUserId,
        setTab: setTab,
        setManageTaskIds: setManageTaskIds,
        setManageProjectIds: setManageProjectIds,
        setManageExcludingSelfProjectIds: setManageExcludingSelfProjectIds,
        setManageCustomerIds: setManageCustomerIds,
        setManageExcludingSelfCustomerIds: setManageExcludingSelfCustomerIds,
        setUserCounters: setUserCounters,
        setCustomerTabLoaded: setCustomerTabLoaded,
        setProjectTabLoaded: setProjectTabLoaded,
        setTaskTabLoaded: setTaskTabLoaded,
        setSearchString: setSearchString,
        setSearchOpen: setSearchOpen,
        setLoaded: setLoaded,
        setLoading: setLoading,
        openPanel: openPanel,
        closePanel: closePanel,
        clearTabsLoaded: clearTabsLoaded,
        setIsShowArchiveEntities: setIsShowArchiveEntities,
        resetSearch: resetSearch
    };
};

var _reduxActions = __webpack_require__(9);

/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _atBrowserUtils = __webpack_require__(8);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _View2 = __webpack_require__(20);

var _View3 = _interopRequireDefault(_View2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BaseUserDataSection = function (_View) {
    _inherits(BaseUserDataSection, _View);

    function BaseUserDataSection() {
        _classCallCheck(this, BaseUserDataSection);

        return _possibleConstructorReturn(this, (BaseUserDataSection.__proto__ || Object.getPrototypeOf(BaseUserDataSection)).apply(this, arguments));
    }

    return BaseUserDataSection;
}(_View3.default);

BaseUserDataSection.prototype.init = function (lightBoxEl, changesCallback, validateCallback) {
    _View3.default.prototype.init.call(this);
    this.lightBoxEl = lightBoxEl;
    this.changesCallback = changesCallback;
    this.validateCallback = validateCallback;
};

BaseUserDataSection.prototype.getSectionElement = function () {
    //abstract
};

BaseUserDataSection.prototype.getElementBySubId = function (name) {
    return document.getElementById(this.lightBoxEl.id + "_" + name);
};

BaseUserDataSection.prototype.cancelAllServerSideChecks = function () {};

/**
 * @param [notRequireConfirmationOnCopySettings] is needed to confirm copying settings of another user (false by default)
 */
BaseUserDataSection.prototype.changesDetected = function (notRequireConfirmationOnCopySettings) {
    if (this.changesCallback) this.changesCallback(notRequireConfirmationOnCopySettings);
};

BaseUserDataSection.prototype.validationDetected = function () {
    if (this.validateCallback) this.validateCallback();
};

BaseUserDataSection.prototype.validate = function () {
    return true;
};

BaseUserDataSection.prototype.updateUI = function () {};

BaseUserDataSection.prototype.hasErrors = function () {
    //noinspection LoopStatementThatDoesntLoopJS
    for (var prop in this.errors) {
        if (this.errors[prop] == true) return true;
    }

    return false;
};

BaseUserDataSection.prototype.makeUnselectable = function (element) {
    (0, _jquery2.default)(element).addClass("unselectable");
    (0, _atBrowserUtils.disableTextSelection)(element);
};

BaseUserDataSection.prototype.getErrorState = function () {
    return null;
};

BaseUserDataSection.prototype.setErrorState = function (errorState) {};

exports.default = BaseUserDataSection;

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Ext = __webpack_require__(12);

var _Ext2 = _interopRequireDefault(_Ext);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _View2 = __webpack_require__(20);

var _View3 = _interopRequireDefault(_View2);

var _GroupType = __webpack_require__(34);

var _GroupType2 = _interopRequireDefault(_GroupType);

var _UsersSelector = __webpack_require__(498);

var _two_level_selection = __webpack_require__(70);

var _two_level_selection2 = _interopRequireDefault(_two_level_selection);

var _at_shared_user_button_menu = __webpack_require__(159);

var _at_shared_user_button_menu2 = _interopRequireDefault(_at_shared_user_button_menu);

var _utils = __webpack_require__(293);

var _keyHandlers = __webpack_require__(48);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CopyUserSelector = function (_View) {
    _inherits(CopyUserSelector, _View);

    function CopyUserSelector(_ref) {
        var _ref$selectionCallbac = _ref.selectionCallback,
            selectionCallback = _ref$selectionCallbac === undefined ? function (selectedUser) {} : _ref$selectionCallbac,
            _ref$onHideCb = _ref.onHideCb,
            onHideCb = _ref$onHideCb === undefined ? function () {} : _ref$onHideCb,
            _ref$title = _ref.title,
            title = _ref$title === undefined ? '' : _ref$title,
            _ref$showPermissionIc = _ref.showPermissionIcons,
            showPermissionIcons = _ref$showPermissionIc === undefined ? false : _ref$showPermissionIc,
            _ref$renderTo = _ref.renderTo,
            renderTo = _ref$renderTo === undefined ? null : _ref$renderTo;

        _classCallCheck(this, CopyUserSelector);

        var _this = _possibleConstructorReturn(this, (CopyUserSelector.__proto__ || Object.getPrototypeOf(CopyUserSelector)).call(this));

        _this.selectionCallback = selectionCallback;
        _this.onHideCb = onHideCb;
        _this.showPermissionIcons = showPermissionIcons;
        _this.title = title;
        _this.renderTo = renderTo;

        _this._restoreOldKeydownHandler = null;

        _this.state = {
            users: [],
            ugrEnabled: false,
            userGroups: [],
            groupBy: _GroupType2.default.USER_GROUP,
            tzgEnabled: false,
            timeZoneGroups: [],
            isURAEnabled: false,
            isBTYEnabled: false,
            isTTAEnabled: false
        };

        _this.onStateDeeplyChanged(function () {
            return _this._initPanel();
        });
        return _this;
    }

    _createClass(CopyUserSelector, [{
        key: "showAt",
        value: function showAt($el, position) {
            this.menu.show($el[0], position);
            this._subscribeEscapeEventListener();
        }
    }, {
        key: "hide",
        value: function hide() {
            this.menu.hide();
            this._unsubscribeEscapeEventListener();
        }
    }, {
        key: "_initPanel",
        value: function _initPanel() {
            var _this2 = this;

            this.panel = new SelectorPanel({
                showPermissionIcons: this.showPermissionIcons,
                selectionCallback: this.selectionCallback,
                title: this.title,
                showGenerateMoneyReportsIcon: this.state.isURAEnabled || this.state.isBTYEnabled,
                generateMoneyReportsIconTooltip: (0, _utils.getTitleOfGenerateMoneyReportsRight)(this.state.isBTYEnabled, this.state.isURAEnabled),
                modifyTimeTrackTooltipText: (0, _utils.getTitleOfModifyTimeTrackRight)(this.state.isTTAEnabled)
            });

            this.panel.initialize(this.state.ugrEnabled, this.state.tzgEnabled, this.state.users, this.state.userGroups, this.state.timeZoneGroups);
            this.panel.loadState({
                selection: new _two_level_selection2.default([], []),
                groupType: this.state.groupBy,
                additionalCheckBoxValue: false,
                optionValue: false,
                showInactive: false
            });

            this.menu = new _at_shared_user_button_menu2.default({
                panel: this.panel,
                parentEl: this.renderTo[0]
            });

            this.menu.on('hide', function () {
                _this2.onHideCb();
                _this2._unsubscribeEscapeEventListener();
            });
        }
    }, {
        key: "onUserDeleted",
        value: function onUserDeleted(deletedUserId) {
            this.setState({
                users: this.state.users.filter(function (u) {
                    return u.id !== deletedUserId;
                })
            });
        }
    }, {
        key: "_subscribeEscapeEventListener",
        value: function _subscribeEscapeEventListener() {
            var _this3 = this;

            this._restoreOldKeydownHandler = (0, _keyHandlers.onKeyDown)(function (keycode, e) {
                if ((0, _keyHandlers.isEsc)(keycode)) {
                    _this3.hide();
                    return true;
                }
            });
        }
    }, {
        key: "_unsubscribeEscapeEventListener",
        value: function _unsubscribeEscapeEventListener() {
            if (this._restoreOldKeydownHandler) this._restoreOldKeydownHandler();
        }
    }]);

    return CopyUserSelector;
}(_View3.default);

exports.default = CopyUserSelector;

var NodeRenderer = function (_NodeRenderP) {
    _inherits(NodeRenderer, _NodeRenderP);

    function NodeRenderer(_ref2) {
        var selectorTree = _ref2.selectorTree,
            selectorFilter = _ref2.selectorFilter,
            selectionHelper = _ref2.selectionHelper,
            showPermissionIcons = _ref2.showPermissionIcons,
            _ref2$showGenerateMon = _ref2.showGenerateMoneyReportsIcon,
            showGenerateMoneyReportsIcon = _ref2$showGenerateMon === undefined ? false : _ref2$showGenerateMon,
            _ref2$generateMoneyRe = _ref2.generateMoneyReportsIconTooltip,
            generateMoneyReportsIconTooltip = _ref2$generateMoneyRe === undefined ? "" : _ref2$generateMoneyRe,
            _ref2$modifyTimeTrack = _ref2.modifyTimeTrackTooltipText,
            modifyTimeTrackTooltipText = _ref2$modifyTimeTrack === undefined ? "" : _ref2$modifyTimeTrack,
            _ref2$onSelectCallbac = _ref2.onSelectCallback,
            onSelectCallback = _ref2$onSelectCallbac === undefined ? function () {} : _ref2$onSelectCallbac;

        _classCallCheck(this, NodeRenderer);

        var _this4 = _possibleConstructorReturn(this, (NodeRenderer.__proto__ || Object.getPrototypeOf(NodeRenderer)).call(this, {
            selectorTree: selectorTree,
            selectorFilter: selectorFilter,
            selectionHelper: selectionHelper,
            showPermissionIcons: showPermissionIcons,
            showGenerateMoneyReportsIcon: showGenerateMoneyReportsIcon,
            generateMoneyReportsIconTooltip: generateMoneyReportsIconTooltip,
            modifyTimeTrackTooltipText: modifyTimeTrackTooltipText
        }));

        _this4.params = {
            onSelectCallback: onSelectCallback
        };
        return _this4;
    }

    _createClass(NodeRenderer, [{
        key: "generateContent",
        value: function generateContent(treeNode, targetEl) {
            var _this5 = this;

            _get(NodeRenderer.prototype.__proto__ || Object.getPrototypeOf(NodeRenderer.prototype), "generateContent", this).call(this, treeNode, targetEl);

            (0, _jquery2.default)(targetEl).click(function () {
                return _this5.params.onSelectCallback(treeNode.getValue());
            });
        }
    }]);

    return NodeRenderer;
}(_UsersSelector.NodeRenderer);

var SelectorPanel = _Ext2.default.extend(_UsersSelector.SelectorPanel, {
    constructor: function constructor(config) {
        SelectorPanel.superclass.constructor.call(this, config);
        this.selectionCallback = config.selectionCallback;
        this.title = config.title;
        this.hideSelect = true;
        this.showGenerateMoneyReportsIcon = config.showGenerateMoneyReportsIcon;
        this.generateMoneyReportsIconTooltip = config.generateMoneyReportsIconTooltip;
        this.modifyTimeTrackTooltipText = config.modifyTimeTrackTooltipText;
    },
    createComponents: function createComponents() {
        _UsersSelector.SelectorPanel.superclass.createComponents.call(this);
        this.addClass("copySettingsUserSelector");
        if (this.showPermissionIcons) {
            this.addClass("withPermissionIcons");
        }
    },
    getUserNodeRenderer: function getUserNodeRenderer() {
        return new NodeRenderer({
            selectorTree: this.selectorTree,
            selectorFilter: this.selectorFilter,
            selectionHelper: this.getSelectionHelper(),
            showPermissionIcons: this.showPermissionIcons,
            showGenerateMoneyReportsIcon: this.showGenerateMoneyReportsIcon,
            generateMoneyReportsIconTooltip: this.generateMoneyReportsIconTooltip,
            modifyTimeTrackTooltipText: this.modifyTimeTrackTooltipText,
            onSelectCallback: this.selectionCallback
        });
    },
    getCustomOptionSection: function getCustomOptionSection() {
        return [new _Ext2.default.Container({
            cls: "copyUserSelectorLabelWrapper",
            autoEl: "div",
            items: new _Ext2.default.form.Label({
                cls: "copyUserSelectorLabel",
                text: this.title
            })
        }), new _Ext2.default.Container({
            cls: "userSelectorCustomControlsContainer",
            autoEl: "div",
            items: [this.viewByPanel, this.getCustomOptionButtonsSection()]
        })];
    },


    getCustomOptionButtons: function getCustomOptionButtons() {
        var buttons = [];
        buttons.push(this.filterButton, this.makeVerticalSeparator());
        if (this.canExpandCollapseNodes()) {
            buttons.push(this.collapseAllButton, this.expandAllButton);
        }

        return buttons;
    },

    getFooterSection: function getFooterSection() {
        return [];
    },
    getFilterWordsPopupCoordinates: function getFilterWordsPopupCoordinates() {
        return this.userGroupsEnabled || this.timeZoneGroupsEnabled ? { x: -92, y: -3 } : { x: 2, y: -3 };
    }
});

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getTasks = exports.getProjects = exports.getCustomers = exports.getSelectedProject = exports.getSelectedCustomer = exports.getEditingUser = exports.canManageParentProject = exports.canManageParentCustomer = exports.showOnlyActiveEntities = exports.getViewerCanManageProjectIds = exports.getViewerCanManageCustomerIds = exports.getTasksSearchText = exports.getTasksSearchOpen = exports.getProjectsSearchText = exports.getProjectsSearchOpen = exports.getCustomersSearchText = exports.getCustomersSearchOpen = exports.getChangingTaskAssignments = exports.getChangingProjectAssignments = exports.getChangingCustomerAssignments = exports.isLoading = exports.areAllTasksAssigned = exports.areSomeTasksAssigned = exports.areAllProjectsAssigned = exports.areSomeProjectsOrLowerAssigned = exports.areAllCustomersAssigned = exports.areSomeCustomersOrLowerAssigned = exports.getTaskCountsByProjects = exports.getTaskCountsByCustomers = exports.getProjectCountsByCustomers = exports.getCanManageTaskIds = exports.getCanWorkTaskIds = exports.getCanManageProjectExcludeSelfIds = exports.getCanManageProjectIds = exports.getCanWorkProjectIds = exports.getCanManageCustomerExcludeSelfIds = exports.getCanManageCustomerIds = exports.getCanWorkCustomerIds = exports.areFutureTasksAssigned = exports.areFutureProjectsAssigned = exports.areFutureCustomersAssigned = exports.getTaskIdsOrder = exports.getProjectIdsOrder = exports.getCustomerIdsOrder = exports.getEditingLevel = exports.needMoreTasks = exports.needMoreProjects = exports.needMoreCustomers = exports.isLoaded = exports.showEditor = undefined;

var _reselect = __webpack_require__(13);

var _selectors = __webpack_require__(14);

var EntitiesSelectors = _interopRequireWildcard(_selectors);

var _selectorsGenerator = __webpack_require__(548);

var _selectorsGenerator2 = _interopRequireDefault(_selectorsGenerator);

var _selectors2 = __webpack_require__(64);

var _utils = __webpack_require__(393);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var getManagementAssignmentsEditorState = function getManagementAssignmentsEditorState(state) {
    return state.userManagement.createManagementAssignmentsEditor;
};
var hierarchyAssignmentsEditorSelectors = (0, _selectorsGenerator2.default)(getManagementAssignmentsEditorState);

var showEditor = exports.showEditor = (0, _reselect.createSelector)(getManagementAssignmentsEditorState, function (state) {
    return state.show;
});

var isLoaded = exports.isLoaded = hierarchyAssignmentsEditorSelectors.isLoaded;

var needMoreCustomers = exports.needMoreCustomers = (0, _reselect.createSelector)(showEditor, hierarchyAssignmentsEditorSelectors.isCustomersLevelSelected, hierarchyAssignmentsEditorSelectors.isLoading, hierarchyAssignmentsEditorSelectors.areCustomersLoaded, function (show, levelSelected, loading, loaded) {
    return (0, _utils.needMoreEntities)(show, levelSelected, loading, loaded);
});

var needMoreProjects = exports.needMoreProjects = (0, _reselect.createSelector)(showEditor, hierarchyAssignmentsEditorSelectors.isProjectsLevelSelected, hierarchyAssignmentsEditorSelectors.isLoading, hierarchyAssignmentsEditorSelectors.areProjectsLoaded, function (show, levelSelected, loading, loaded) {
    return (0, _utils.needMoreEntities)(show, levelSelected, loading, loaded);
});

var needMoreTasks = exports.needMoreTasks = (0, _reselect.createSelector)(showEditor, hierarchyAssignmentsEditorSelectors.isTasksLevelSelected, hierarchyAssignmentsEditorSelectors.isLoading, hierarchyAssignmentsEditorSelectors.areTasksLoaded, function (show, levelSelected, loading, loaded) {
    return (0, _utils.needMoreEntities)(show, levelSelected, loading, loaded);
});

var getEditingLevel = exports.getEditingLevel = hierarchyAssignmentsEditorSelectors.getEditingLevel;

var getCustomerIdsOrder = exports.getCustomerIdsOrder = hierarchyAssignmentsEditorSelectors.getCustomerIdsOrder;

var getProjectIdsOrder = exports.getProjectIdsOrder = hierarchyAssignmentsEditorSelectors.getProjectIdsOrder;

var getTaskIdsOrder = exports.getTaskIdsOrder = hierarchyAssignmentsEditorSelectors.getTaskIdsOrder;

var areFutureCustomersAssigned = exports.areFutureCustomersAssigned = hierarchyAssignmentsEditorSelectors.areFutureCustomersAssigned;

var areFutureProjectsAssigned = exports.areFutureProjectsAssigned = hierarchyAssignmentsEditorSelectors.areFutureProjectsAssigned;

var areFutureTasksAssigned = exports.areFutureTasksAssigned = hierarchyAssignmentsEditorSelectors.areFutureTasksAssigned;

var getCanWorkCustomerIds = exports.getCanWorkCustomerIds = hierarchyAssignmentsEditorSelectors.getCanWorkCustomerIds;

var getCanManageCustomerIds = exports.getCanManageCustomerIds = hierarchyAssignmentsEditorSelectors.getCanManageCustomerIds;

var getCanManageCustomerExcludeSelfIds = exports.getCanManageCustomerExcludeSelfIds = hierarchyAssignmentsEditorSelectors.getCanManageCustomerExcludeSelfIds;

var getCanWorkProjectIds = exports.getCanWorkProjectIds = hierarchyAssignmentsEditorSelectors.getCanWorkProjectIds;

var getCanManageProjectIds = exports.getCanManageProjectIds = hierarchyAssignmentsEditorSelectors.getCanManageProjectIds;

var getCanManageProjectExcludeSelfIds = exports.getCanManageProjectExcludeSelfIds = hierarchyAssignmentsEditorSelectors.getCanManageProjectExcludeSelfIds;

var getCanWorkTaskIds = exports.getCanWorkTaskIds = hierarchyAssignmentsEditorSelectors.getCanWorkTaskIds;

var getCanManageTaskIds = exports.getCanManageTaskIds = hierarchyAssignmentsEditorSelectors.getCanManageTaskIds;

var getProjectCountsByCustomers = exports.getProjectCountsByCustomers = hierarchyAssignmentsEditorSelectors.getProjectCountsByCustomers;

var getTaskCountsByCustomers = exports.getTaskCountsByCustomers = hierarchyAssignmentsEditorSelectors.getTaskCountsByCustomers;

var getTaskCountsByProjects = exports.getTaskCountsByProjects = hierarchyAssignmentsEditorSelectors.getTaskCountsByProjects;

var areSomeCustomersOrLowerAssigned = exports.areSomeCustomersOrLowerAssigned = hierarchyAssignmentsEditorSelectors.areSomeCustomersOrLowerAssigned;

var areAllCustomersAssigned = exports.areAllCustomersAssigned = hierarchyAssignmentsEditorSelectors.areAllCustomersAssigned;

var areSomeProjectsOrLowerAssigned = exports.areSomeProjectsOrLowerAssigned = hierarchyAssignmentsEditorSelectors.areSomeProjectsOrLowerAssigned;

var areAllProjectsAssigned = exports.areAllProjectsAssigned = hierarchyAssignmentsEditorSelectors.areAllProjectsAssigned;

var areSomeTasksAssigned = exports.areSomeTasksAssigned = hierarchyAssignmentsEditorSelectors.areSomeTasksAssigned;

var areAllTasksAssigned = exports.areAllTasksAssigned = hierarchyAssignmentsEditorSelectors.areAllTasksAssigned;

var isLoading = exports.isLoading = hierarchyAssignmentsEditorSelectors.isLoading;

var getChangingCustomerAssignments = exports.getChangingCustomerAssignments = hierarchyAssignmentsEditorSelectors.getChangingCustomerAssignments;

var getChangingProjectAssignments = exports.getChangingProjectAssignments = hierarchyAssignmentsEditorSelectors.getChangingProjectAssignments;

var getChangingTaskAssignments = exports.getChangingTaskAssignments = hierarchyAssignmentsEditorSelectors.getChangingTaskAssignments;

var getCustomersSearchOpen = exports.getCustomersSearchOpen = hierarchyAssignmentsEditorSelectors.getCustomersSearchOpen;

var getCustomersSearchText = exports.getCustomersSearchText = hierarchyAssignmentsEditorSelectors.getCustomersSearchText;

var getProjectsSearchOpen = exports.getProjectsSearchOpen = hierarchyAssignmentsEditorSelectors.getProjectsSearchOpen;

var getProjectsSearchText = exports.getProjectsSearchText = hierarchyAssignmentsEditorSelectors.getProjectsSearchText;

var getTasksSearchOpen = exports.getTasksSearchOpen = hierarchyAssignmentsEditorSelectors.getTasksSearchOpen;

var getTasksSearchText = exports.getTasksSearchText = hierarchyAssignmentsEditorSelectors.getTasksSearchText;

var getViewerCanManageCustomerIds = exports.getViewerCanManageCustomerIds = hierarchyAssignmentsEditorSelectors.getViewerCanManageCustomerIds;

var getViewerCanManageProjectIds = exports.getViewerCanManageProjectIds = hierarchyAssignmentsEditorSelectors.getViewerCanManageProjectIds;

var showOnlyActiveEntities = exports.showOnlyActiveEntities = function showOnlyActiveEntities(state) {
    return getManagementAssignmentsEditorState(state).onlyActiveEntities;
};

var canManageParentCustomer = exports.canManageParentCustomer = hierarchyAssignmentsEditorSelectors.canManageParentCustomer;

var canManageParentProject = exports.canManageParentProject = hierarchyAssignmentsEditorSelectors.canManageParentProject;

var getEditingUser = exports.getEditingUser = _selectors2.getFullUserInfo;

var getSelectedCustomer = exports.getSelectedCustomer = (0, _reselect.createSelector)(EntitiesSelectors.getCustomers, getEditingLevel, function (customers, _ref) {
    var customerId = _ref.customerId;
    return customerId !== null ? customers[customerId] : null;
});

var getSelectedProject = exports.getSelectedProject = (0, _reselect.createSelector)(EntitiesSelectors.getProjects, getEditingLevel, function (projects, _ref2) {
    var projectId = _ref2.projectId;
    return projectId !== null ? projects[projectId] : null;
});

var getCustomers = exports.getCustomers = (0, _reselect.createSelector)(EntitiesSelectors.getCustomers, getCustomerIdsOrder, function (customers, customerIdsOrder) {
    return customerIdsOrder.map(function (id) {
        return customers[id];
    });
});

var getProjects = exports.getProjects = (0, _reselect.createSelector)(EntitiesSelectors.getProjects, getProjectIdsOrder, function (projects, projectIdsOrder) {
    return projectIdsOrder.map(function (id) {
        return projects[id];
    });
});

var getTasks = exports.getTasks = (0, _reselect.createSelector)(EntitiesSelectors.getTasks, getTaskIdsOrder, function (tasks, taskIdsOrder) {
    return taskIdsOrder.map(function (id) {
        return tasks[id];
    });
});

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getEntirelyAssignedProjectCounter = exports.getEntirelyAssignedTasksCounter = exports.isNeedToLoadData = exports.isShowArchivedEntities = exports.isShown = exports.getManagementAssignmentsSelection = exports.isLoaded = exports.isLoading = exports.selectCustomerEntities = exports.selectProjectEntities = exports.selectTaskEntities = exports.getPanelUserFirstName = exports.getUsersCounters = exports.getCounters = exports.loadedTabs = exports.isSearchOpen = exports.getSearch = exports.getCustomerIds = exports.getProjectIds = exports.getTaskIds = exports.getTab = exports.getUserId = undefined;

var _reselect = __webpack_require__(13);

var _selectorsGenerator = __webpack_require__(394);

var _selectorsGenerator2 = _interopRequireDefault(_selectorsGenerator);

var _selectors = __webpack_require__(398);

var _selectors2 = __webpack_require__(64);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getCreateManagementAssignmentsPanelState = function getCreateManagementAssignmentsPanelState(state) {
    return state.userManagement.createManagementAssignmentsPanel;
};
var hierarchyAssignmentsPanelTabSelectors = (0, _selectorsGenerator2.default)(getCreateManagementAssignmentsPanelState);

var getUserId = exports.getUserId = hierarchyAssignmentsPanelTabSelectors.getUserId;

var getTab = exports.getTab = hierarchyAssignmentsPanelTabSelectors.getTab;

var getTaskIds = exports.getTaskIds = hierarchyAssignmentsPanelTabSelectors.getTaskIds;

var getProjectIds = exports.getProjectIds = hierarchyAssignmentsPanelTabSelectors.getProjectIds;

var getCustomerIds = exports.getCustomerIds = hierarchyAssignmentsPanelTabSelectors.getCustomerIds;

var getSearch = exports.getSearch = hierarchyAssignmentsPanelTabSelectors.getSearch;

var isSearchOpen = exports.isSearchOpen = hierarchyAssignmentsPanelTabSelectors.isSearchOpen;

var loadedTabs = exports.loadedTabs = hierarchyAssignmentsPanelTabSelectors.getLoadedTabs;

var getCounters = exports.getCounters = hierarchyAssignmentsPanelTabSelectors.getCounters;

var getUsersCounters = exports.getUsersCounters = hierarchyAssignmentsPanelTabSelectors.getUsersCounters;

var getPanelUserFirstName = exports.getPanelUserFirstName = hierarchyAssignmentsPanelTabSelectors.getPanelUserFirstName;

var selectTaskEntities = exports.selectTaskEntities = hierarchyAssignmentsPanelTabSelectors.selectTaskMaEntities;

var selectProjectEntities = exports.selectProjectEntities = hierarchyAssignmentsPanelTabSelectors.selectProjectMaEntities;

var selectCustomerEntities = exports.selectCustomerEntities = hierarchyAssignmentsPanelTabSelectors.selectCustomerMaEntities;

var isLoading = exports.isLoading = hierarchyAssignmentsPanelTabSelectors.isLoading;

var isLoaded = exports.isLoaded = hierarchyAssignmentsPanelTabSelectors.isLoaded;

var getManagementAssignmentsSelection = exports.getManagementAssignmentsSelection = function getManagementAssignmentsSelection(state) {
    return (0, _selectors2.getManagementAssignmentsSelection)(state);
};

var isShown = exports.isShown = function isShown(state) {
    return getCreateManagementAssignmentsPanelState(state).isShown;
};

var isShowArchivedEntities = exports.isShowArchivedEntities = hierarchyAssignmentsPanelTabSelectors.isShowArchivedEntities;

var isNeedToLoadData = exports.isNeedToLoadData = (0, _reselect.createSelector)(isShown, isLoaded, getTab, loadedTabs, _selectors.showEditor, function (show, loaded, tab, loadedTabs, showEditor) {
    return show === true && (loaded === false || loadedTabs[tab] === false) && showEditor === false;
});

var getEntirelyAssignedTasksCounter = exports.getEntirelyAssignedTasksCounter = (0, _reselect.createSelector)(getTaskIds, getCounters, function (ids, counters) {
    return counters.tasks.curValue - ids.length;
});

var getEntirelyAssignedProjectCounter = exports.getEntirelyAssignedProjectCounter = (0, _reselect.createSelector)(getProjectIds, getCounters, function (ids, counters) {
    return counters.projects.curValue - ids.length;
});

/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _index = __webpack_require__(48);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var WordsFilter = function (_TemplateView) {
    _inherits(WordsFilter, _TemplateView);

    function WordsFilter(_ref) {
        var _ref$onChange = _ref.onChange,
            onChange = _ref$onChange === undefined ? function (text) {
            _this.setState({ text: text });
        } : _ref$onChange,
            _ref$onHide = _ref.onHide,
            onHide = _ref$onHide === undefined ? function () {
            _this.setState({
                open: false,
                text: ''
            });
        } : _ref$onHide,
            _ref$onShow = _ref.onShow,
            onShow = _ref$onShow === undefined ? function () {
            _this.setState({ open: true });
        } : _ref$onShow,
            _ref$placeholderClass = _ref.placeholderClass,
            placeholderClass = _ref$placeholderClass === undefined ? '' : _ref$placeholderClass;

        _classCallCheck(this, WordsFilter);

        var _this = _possibleConstructorReturn(this, (WordsFilter.__proto__ || Object.getPrototypeOf(WordsFilter)).call(this, null));

        _this._handleIconClick = function () {
            if (_this.state.disabled) return;

            _this.params.onShow();
        };

        _this._handleCloseClick = function () {
            _this.params.onChange('');
            _this.params.onHide();
        };

        _this._handleOnInputFocus = function () {
            _this.$inputPlaceholder.addClass('active');
            _this._keyPressHandlerRemover = (0, _index.onKeyDown)(function (keyCode) {
                if ((0, _index.isEsc)(keyCode)) {
                    _this._handleCloseClick();
                    return true;
                }
            });
        };

        _this._handleOnInputBlur = function () {
            _this.$inputPlaceholder.removeClass('active');
            _this._keyPressHandlerRemover();
        };

        _this._handleOnInputChange = function (e) {
            var text = e.target.value.trim();
            if (text !== _this.state.text) {
                _this.setStateInternal({ text: text });
                if (_this.state.open) _this._onChangeThrottled(text);
            }
        };

        _this.state = {
            text: '',
            open: false,
            disabled: false
        };

        _this.params = {
            placeholderClass: placeholderClass,
            onChange: onChange,
            onHide: onHide,
            onShow: onShow
        };

        _this.onStatePropertyChanged('open', function (open, prevOpen) {
            _this.$inputPlaceholder.toggleClass('hidden', !open);
            _this.$inputPlaceholder.toggleClass('animShowWordsField', open);
            if (open === true && prevOpen !== open) {
                setTimeout(function () {
                    if (_this.state.open) _this.$input.focus();
                }, 300);
            }
        });

        _this.onStatePropertyChanged('text', function () {
            _this.$input.attr('value', _this.state.text);
        });

        _this.onStatePropertyChanged('disabled', function (disabled) {
            _this.$icon.toggleClass('disabled', disabled);
        });

        _this._onChangeThrottled = _underscore2.default.debounce(_this.params.onChange, 500);
        _this._keyPressHandlerRemover = null;
        return _this;
    }

    _createClass(WordsFilter, [{
        key: 'templateModel',
        value: function templateModel() {
            return {
                placeholderClass: this.params.placeholderClass
            };
        }
    }, {
        key: 'messageKeys',
        value: function messageKeys() {
            return {
                placeholder: 'userlist.words_filter.start_typing'
            };
        }
    }, {
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class="userList_wordsFilter">' + '    <div class="icon"></div>' + '    <div class="inputPlaceholder <%=placeholderClass%>">' + '        <div class="lensIcon"></div>' + '        <input type="text" placeholder="<%=placeholder%>"/>' + '        <div class="close"></div>' + '    </div>' + '</div>';
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            this.$icon = this.find('.icon');
            this.$icon.on('click', this._handleIconClick);
            this.$inputPlaceholder = this.find('.inputPlaceholder');
            this.find('.close').on('click', this._handleCloseClick);
            this.$input = this.find('.inputPlaceholder input').on('input', this._handleOnInputChange).on('focus', this._handleOnInputFocus).on('blur', this._handleOnInputBlur);
            this.renderInitialState();
        }
    }]);

    return WordsFilter;
}(_TemplateView3.default);

exports.default = WordsFilter;

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _ScrollUtils = __webpack_require__(39);

var _ScrollUtils2 = _interopRequireDefault(_ScrollUtils);

var _ScrollDragHandler = __webpack_require__(769);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _ScrollToTopButton = __webpack_require__(770);

var _ScrollToTopButton2 = _interopRequireDefault(_ScrollToTopButton);

var _atBrowserUtils = __webpack_require__(8);

var _constants = __webpack_require__(77);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AutoScrollableWrapper = function (_TemplateView) {
    _inherits(AutoScrollableWrapper, _TemplateView);

    function AutoScrollableWrapper(_ref) {
        var components = _ref.components,
            _ref$additionalClasse = _ref.additionalClasses,
            additionalClasses = _ref$additionalClasse === undefined ? '' : _ref$additionalClasse,
            _ref$scrollEvent = _ref.scrollEvent,
            scrollEvent = _ref$scrollEvent === undefined ? 'mousemove' : _ref$scrollEvent,
            _ref$eventDataRetriev = _ref.eventDataRetriever,
            eventDataRetriever = _ref$eventDataRetriev === undefined ? function (event, data) {
            return event;
        } : _ref$eventDataRetriev,
            _ref$enableVerticalSc = _ref.enableVerticalScroll,
            enableVerticalScroll = _ref$enableVerticalSc === undefined ? false : _ref$enableVerticalSc,
            _ref$enableHorizontal = _ref.enableHorizontalScroll,
            enableHorizontalScroll = _ref$enableHorizontal === undefined ? false : _ref$enableHorizontal,
            _ref$verticalScrollCo = _ref.verticalScrollConfig,
            verticalScrollConfig = _ref$verticalScrollCo === undefined ? {} : _ref$verticalScrollCo,
            _ref$horizontalScroll = _ref.horizontalScrollConfig,
            horizontalScrollConfig = _ref$horizontalScroll === undefined ? {} : _ref$horizontalScroll,
            verticalScrollContainerClass = _ref.verticalScrollContainerClass,
            horizontalScrollContainerClass = _ref.horizontalScrollContainerClass,
            _ref$autoScrollEnable = _ref.autoScrollEnabled,
            autoScrollEnabled = _ref$autoScrollEnable === undefined ? false : _ref$autoScrollEnable,
            _ref$scrollOffset = _ref.scrollOffset,
            scrollOffset = _ref$scrollOffset === undefined ? 100 : _ref$scrollOffset,
            _ref$maxScrollToBotto = _ref.maxScrollToBottomOffset,
            maxScrollToBottomOffset = _ref$maxScrollToBotto === undefined ? 200 : _ref$maxScrollToBotto,
            _ref$scrollDelta = _ref.scrollDelta,
            scrollDelta = _ref$scrollDelta === undefined ? 10 : _ref$scrollDelta,
            _ref$onScrollToBottom = _ref.onScrollToBottom,
            onScrollToBottom = _ref$onScrollToBottom === undefined ? function () {} : _ref$onScrollToBottom,
            _ref$showScrollToTopB = _ref.showScrollToTopButton,
            showScrollToTopButton = _ref$showScrollToTopB === undefined ? false : _ref$showScrollToTopB,
            _ref$scrollToTopButto = _ref.scrollToTopButtonAdditionalClass,
            scrollToTopButtonAdditionalClass = _ref$scrollToTopButto === undefined ? '' : _ref$scrollToTopButto,
            _ref$onVerticalScroll = _ref.onVerticalScrollCb,
            onVerticalScrollCb = _ref$onVerticalScroll === undefined ? function (scrollPosition, maxScroll) {} : _ref$onVerticalScroll,
            _ref$onHorizontalScro = _ref.onHorizontalScrollCb,
            onHorizontalScrollCb = _ref$onHorizontalScro === undefined ? function (scrollPosition, maxScroll) {} : _ref$onHorizontalScro;

        _classCallCheck(this, AutoScrollableWrapper);

        var _this = _possibleConstructorReturn(this, (AutoScrollableWrapper.__proto__ || Object.getPrototypeOf(AutoScrollableWrapper)).call(this));

        _this.components = components;
        _this.additionalClasses = additionalClasses;
        _this.scrollToTopButtonAdditionalClass = scrollToTopButtonAdditionalClass;

        _this.scrollEvent = scrollEvent;
        _this.eventDataRetriever = eventDataRetriever;
        _this.enableVerticalScroll = enableVerticalScroll;
        _this.enableHorizontalScroll = enableHorizontalScroll;

        _this.verticalScrollConfig = verticalScrollConfig;
        _this.horizontalScrollConfig = horizontalScrollConfig;

        _this.verticalScrollContainerClass = verticalScrollContainerClass;
        _this.horizontalScrollContainerClass = horizontalScrollContainerClass;

        _this.autoScrollEnabled = autoScrollEnabled;
        _this.scrollOffset = scrollOffset;
        _this.maxScrollToBottomOffset = maxScrollToBottomOffset;
        _this.scrollDelta = scrollDelta;

        _this.onScrollToBottom = onScrollToBottom;
        _this.onVerticalScrollCb = onVerticalScrollCb;
        _this.onHorizontalScrollCb = onHorizontalScrollCb;

        _this.showScrollToTopButton = showScrollToTopButton;
        return _this;
    }

    _createClass(AutoScrollableWrapper, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return "<div class='autoScrollableWrapper scrollableContainer <%=additionalClasses%>'>" + "  <div class='innerScrollableContainer'></div>" + "  <div class='<%-scrollToTopButtonAdditionalClass%> scrollToTopButtonPlaceholder'></div>" + "</div>";
        }
    }, {
        key: 'templateModel',
        value: function templateModel() {
            return {
                additionalClasses: this.additionalClasses,
                scrollToTopButtonAdditionalClass: this.scrollToTopButtonAdditionalClass
            };
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            var _this2 = this;

            this.$el.on(_ScrollUtils2.default.getWheelEventName(), function (e) {
                // disable iscroll if scroll event already used by next components
                if ((0, _atBrowserUtils.checkElementOrAncestorHasClass)(e.target, _constants.AtNextCustomScrollbarUsedClassName)) {
                    _this2.verticalScroll && _this2.verticalScroll.disable();
                    _this2.horizontalScroll && _this2.horizontalScroll.disable();
                    setTimeout(function () {
                        _this2.verticalScroll && _this2.verticalScroll.enable();
                        _this2.horizontalScroll && _this2.horizontalScroll.enable();
                    }, 0);
                }
            });

            this.components.forEach(function (c) {
                return c.init(_this2.find('.innerScrollableContainer'));
            });

            if (this.enableVerticalScroll) {
                if (this.verticalScrollContainerClass) {
                    this.verticalScrollConfig.appendTo = (0, _jquery2.default)('.' + this.verticalScrollContainerClass);
                }

                if (this.showScrollToTopButton) {
                    this.scrollToTopButton = new _ScrollToTopButton2.default({
                        fadingHeight: 250,
                        onClickCb: function onClickCb() {
                            _this2.scrollToTop(1000);
                            _this2.scrollToTopButton.fadeOut(1000);
                        },
                        scrollToTopButtonAdditionalClass: this.scrollToTopButtonAdditionalClass
                    });

                    if (this.verticalScrollContainerClass) this.scrollToTopButton.init((0, _jquery2.default)('.' + this.verticalScrollContainerClass));else this.scrollToTopButton.init(this.$el);
                }

                this.verticalScroll = _ScrollUtils2.default.addVerticalScroll(this.$el, this.verticalScrollConfig);
                this.verticalScroll.on("scroll", function () {
                    _this2._checkIfScrolledToBottom();

                    if (_this2.showScrollToTopButton) {
                        _this2.scrollToTopButton.updateVisibility(_this2.verticalScroll.y);
                    }

                    _this2.onVerticalScrollCb(_this2.verticalScroll.y, _this2.verticalScroll.maxScrollY);
                });

                if (this.autoScrollEnabled) {
                    this._subscribeVerticalScrollHandler();
                }
            }

            if (this.enableHorizontalScroll) {
                if (this.horizontalScrollContainerClass) {
                    this.horizontalScrollConfig.appendTo = (0, _jquery2.default)('.' + this.horizontalScrollContainerClass);
                }
                this.horizontalScroll = _ScrollUtils2.default.addHorizontalScroll(this.$el, this.horizontalScrollConfig);

                if (this.autoScrollEnabled) {
                    this._subscribeHorizontalScrollHandler();
                }

                this.horizontalScroll.on("scroll", function () {
                    _this2.onHorizontalScrollCb(_this2.horizontalScroll.x, _this2.horizontalScroll.maxScrollX);
                });
            }

            if (!this.enableVerticalScroll && !this.enableHorizontalScroll) {
                this.getEl().off(this.scrollEvent).off('mouseout');
            }

            (0, _jquery2.default)(window).resizeThrottle(function () {
                return _this2.refreshScroll();
            }, 100);
        }
    }, {
        key: 'show',
        value: function show() {
            _get(AutoScrollableWrapper.prototype.__proto__ || Object.getPrototypeOf(AutoScrollableWrapper.prototype), 'show', this).call(this);
            this.refreshScroll();
        }
    }, {
        key: 'refreshScroll',
        value: function refreshScroll() {
            if (this.verticalScroll) {
                _ScrollUtils2.default.refreshCustomScroll(this.verticalScroll);
                this._checkIfScrolledToBottom();

                if (this.showScrollToTopButton) this.scrollToTopButton.updateVisibility(this.verticalScroll.y);
            }

            if (this.horizontalScroll) {
                _ScrollUtils2.default.refreshCustomScroll(this.horizontalScroll);
            }
        }
    }, {
        key: 'scrollToTop',
        value: function scrollToTop() {
            var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

            _ScrollUtils2.default.scrollToTop(this.verticalScroll, this.getEl(), time);
        }
    }, {
        key: '_checkIfScrolledToBottom',
        value: function _checkIfScrolledToBottom() {
            var _this3 = this;

            _ScrollUtils2.default.performIfScrollToBottom(this.verticalScroll, this.maxScrollToBottomOffset, function () {
                return _this3.onScrollToBottom();
            });
        }
    }, {
        key: '_subscribeVerticalScrollHandler',
        value: function _subscribeVerticalScrollHandler() {
            var _this4 = this;

            this.verticalScrollDragHandler = new _ScrollDragHandler.VerticalScrollDragHandler({
                scroll: this.verticalScroll,
                scrollableEl: this.getEl(),
                scrollOffset: this.scrollOffset,
                scrollDelta: this.scrollDelta,
                onUpdateScroll: function onUpdateScroll() {
                    return _this4.refreshScroll();
                }
            });

            this.getEl().on(this.scrollEvent, function (event, data) {
                var mouseEvent = _this4.eventDataRetriever(event, data);
                _this4.verticalScrollDragHandler.handleEvent(mouseEvent);
            });

            this.getEl().on('mouseout', function (e) {
                _this4.verticalScrollDragHandler.clearAutoScrollTimer();
            });
        }
    }, {
        key: '_subscribeHorizontalScrollHandler',
        value: function _subscribeHorizontalScrollHandler() {
            var _this5 = this;

            this.horizontalScrollDragHandler = new _ScrollDragHandler.HorizonalScrollDragHandler({
                scroll: this.horizontalScroll,
                scrollableEl: this.getEl(),
                scrollOffset: this.scrollOffset,
                scrollDelta: this.scrollDelta,
                onUpdateScroll: function onUpdateScroll() {
                    return _this5.refreshScroll();
                }
            });

            this.getEl().on(this.scrollEvent, function (event, data) {
                var mouseEvent = _this5.eventDataRetriever(event, data);
                _this5.horizontalScrollDragHandler.handleEvent(mouseEvent);
            });

            this.getEl().on('mouseout', function (e) {
                _this5.horizontalScrollDragHandler.clearAutoScrollTimer();
            });
        }
    }]);

    return AutoScrollableWrapper;
}(_TemplateView3.default);

exports.default = AutoScrollableWrapper;

/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Option = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView3 = __webpack_require__(1);

var _TemplateView4 = _interopRequireDefault(_TemplateView3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Option = exports.Option = function (_TemplateView) {
    _inherits(Option, _TemplateView);

    function Option(_ref) {
        var _ref$onSelected = _ref.onSelected,
            onSelected = _ref$onSelected === undefined ? function () {} : _ref$onSelected,
            _ref$additionalClass = _ref.additionalClass,
            additionalClass = _ref$additionalClass === undefined ? '' : _ref$additionalClass;

        _classCallCheck(this, Option);

        var _this = _possibleConstructorReturn(this, (Option.__proto__ || Object.getPrototypeOf(Option)).call(this));

        _this.state = {
            title: '',
            isLoading: false
        };

        _this.callbacks = {
            onSelected: onSelected
        };

        _this.params = {
            additionalClass: additionalClass
        };

        _this.onStatePropertyChanged('title', function (title) {
            _this.$title.text(title);
        });

        _this.onStatePropertyChanged('isLoading', function (isLoading) {
            _this.$el.find('.disableOverlay').toggle(isLoading);
            if (isLoading) _this.$el.addClass('disabled');else _this.$el.removeClass('disabled');
        });
        return _this;
    }

    _createClass(Option, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return "  <div class='option <%-additionalClass%>'>" + "    <div class='icon'></div>" + "    <div class='title'></div>" + "    <div class='disableOverlay'></div>" + "  </div>";
        }
    }, {
        key: 'templateModel',
        value: function templateModel() {
            return {
                additionalClass: this.params.additionalClass
            };
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            var _this2 = this;

            this.$title = this.find('.title');

            this.$el.click(function (e) {
                e.stopPropagation();
                _this2.callbacks.onSelected();
            });
        }
    }]);

    return Option;
}(_TemplateView4.default);

var SimpleMenu = function (_TemplateView2) {
    _inherits(SimpleMenu, _TemplateView2);

    function SimpleMenu() {
        var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            _ref2$additionalClass = _ref2.additionalClass,
            additionalClass = _ref2$additionalClass === undefined ? '' : _ref2$additionalClass;

        _classCallCheck(this, SimpleMenu);

        var _this3 = _possibleConstructorReturn(this, (SimpleMenu.__proto__ || Object.getPrototypeOf(SimpleMenu)).call(this));

        _this3.params = {
            additionalClass: additionalClass
        };
        return _this3;
    }

    _createClass(SimpleMenu, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return "<div class='components_simpleMenu <%-additionalClass%>'></div>";
        }
    }, {
        key: 'templateModel',
        value: function templateModel() {
            return {
                additionalClass: this.params.additionalClass
            };
        }
    }]);

    return SimpleMenu;
}(_TemplateView4.default);

exports.default = SimpleMenu;

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.copyAssignments = exports.loadUserFromAssignedUsers = exports.cancelCopy = exports.showCopyContent = exports.setUserFromAssignedUsers = exports.setCopySelectorUsers = exports.setCopyLoading = exports.setCopyUserId = exports.changeTeamAssignmentsData = exports.loadTeamAssignmentsData = exports.closeTeamAssignmentsPanel = exports.openTeamAssignmentsPanelFromEditPanel = exports.openTeamAssignmentsPanel = undefined;

var _actionTypes = __webpack_require__(694);

var ActionTypes = _interopRequireWildcard(_actionTypes);

var _actions = __webpack_require__(126);

var _selectors = __webpack_require__(313);

var _utils = __webpack_require__(6);

var _selectors2 = __webpack_require__(146);

var _rpcCalls = __webpack_require__(24);

var _rpcCalls2 = _interopRequireDefault(_rpcCalls);

var _actions2 = __webpack_require__(68);

var _actions3 = __webpack_require__(29);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _actions4 = __webpack_require__(56);

var _reduxActions = __webpack_require__(9);

var _constants = __webpack_require__(259);

var _batch = __webpack_require__(117);

var _constants2 = __webpack_require__(21);

var _syncCallbacks = __webpack_require__(256);

var SyncCallbacks = _interopRequireWildcard(_syncCallbacks);

var _actions5 = __webpack_require__(50);

var _UserNameFormat = __webpack_require__(17);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var openTeamAssignmentsPanel = exports.openTeamAssignmentsPanel = function openTeamAssignmentsPanel(userId) {
    return function (dispatch) {
        dispatch((0, _utils.createActionObject)(ActionTypes.TEAM_ASSIGNMENTS_PANEL_USER_ID_SET, userId));
    };
};

var openTeamAssignmentsPanelFromEditPanel = exports.openTeamAssignmentsPanelFromEditPanel = function openTeamAssignmentsPanelFromEditPanel() {
    return function (dispatch, getState) {
        dispatch(openTeamAssignmentsPanel((0, _selectors2.getEditUserId)(getState())));
    };
};

var closeTeamAssignmentsPanel = exports.closeTeamAssignmentsPanel = function closeTeamAssignmentsPanel() {
    return function (dispatch) {
        (0, _rpcCalls.abortCall)(_actions.GET_EDIT_USER_DATA_METHOD);
        dispatch((0, _utils.createActionObject)(ActionTypes.TEAM_ASSIGNMENTS_PANEL_USER_ID_SET, null));
    };
};

var loadTeamAssignmentsData = exports.loadTeamAssignmentsData = function loadTeamAssignmentsData() {
    return function (dispatch, getState) {
        dispatch((0, _actions.loadEditUserPanelDataWithId)((0, _selectors.getUserId)(getState())));
    };
};

var changeTeamAssignmentsData = exports.changeTeamAssignmentsData = function changeTeamAssignmentsData(_ref) {
    var teamAssignmentType = _ref.teamAssignmentType,
        assignedGroupIds = _ref.assignedGroupIds,
        assignedUserIds = _ref.assignedUserIds;
    return function (dispatch, getState) {
        if (teamAssignmentType !== _constants2.UserTeamAssignmentType.SELECTED) dispatch(closeCopyContent());

        dispatch((0, _actions.changeTeamAssignmentsWithId)((0, _selectors.getUserId)(getState()), { teamAssignmentType: teamAssignmentType, assignedGroupIds: assignedGroupIds, assignedUserIds: assignedUserIds }));
    };
};

var openCopyContent = (0, _reduxActions.createAction)(ActionTypes.COPY_CONTENT_OPEN);

var closeCopyContent = (0, _reduxActions.createAction)(ActionTypes.COPY_CONTENT_CLOSE);

var setCopyUserId = exports.setCopyUserId = (0, _reduxActions.createAction)(ActionTypes.COPY_USER_ID_SET);

var setCopyLoading = exports.setCopyLoading = (0, _reduxActions.createAction)(ActionTypes.COPY_LOADING_SET);

var setCopySelectorUsers = exports.setCopySelectorUsers = (0, _reduxActions.createAction)(ActionTypes.COPY_USERS_FOR_SELECTOR_SET);

var setUserFromAssignedUsers = exports.setUserFromAssignedUsers = (0, _reduxActions.createAction)(ActionTypes.USER_FROM_ASSIGNED_USERS_SET);

var showCopyContent = exports.showCopyContent = function showCopyContent() {
    return function (dispatch) {
        dispatch(openCopyContent());
        dispatch(loadCopyTeamAssignmentSelectorUsers());
    };
};

var cancelCopy = exports.cancelCopy = function cancelCopy() {
    return function (dispatch) {
        dispatch(closeCopyContent());
    };
};

var loadCopyTeamAssignmentSelectorUsers = function loadCopyTeamAssignmentSelectorUsers() {
    return function (dispatch) {
        dispatch(setCopyLoading(true));
        (0, _rpcCalls2.default)('UserManagementService.getUserSelectorData', []).then((0, _batch.batched)(function (data) {
            dispatch(setCopyLoading(false));
            dispatch((0, _actions2.updateFeatures)({
                UGR: data.ugrEnabled,
                TZG: data.tzgEnabled
            }));
            dispatch((0, _actions3.addTimeZoneGroups)(data.timeZoneGroups));
            dispatch((0, _actions3.addUserGroups)(data.userGroups));
            dispatch(setCopySelectorUsers(data.users));
        })).catch(function (err) {
            dispatch(setCopyLoading(false));
        });
    };
};

var loadUserFromAssignedUsers = exports.loadUserFromAssignedUsers = function loadUserFromAssignedUsers(userId) {
    return function (dispatch) {
        dispatch(setCopyLoading(true));
        (0, _rpcCalls2.default)('UserManagementService.getAssignedUsers', [userId], function (rpcError) {
            return rpcError.handleOnExceptions([_constants.Exceptions.NoSuchUserException, _constants.Exceptions.NoRightsToManageAccountSettings]);
        }).then((0, _batch.batched)(function (data) {
            dispatch(setUserFromAssignedUsers(data));
            dispatch(setCopyUserId(userId));
            dispatch(setCopyLoading(false));
        })).catch(function (error) {
            dispatch(setCopyLoading(false));
            switch (error.getException()) {
                case _constants.Exceptions.NoSuchUserException:
                    alert(_messageResource2.default.getMessage('work_assignments.panel.copy.error.user_deleted'));
                    dispatch((0, _actions3.removeUser)(userId));
                    SyncCallbacks.onNoSuchUserException(userId);
                    break;
                case _constants.Exceptions.NoRightsToManageAccountSettings:
                    alert(_messageResource2.default.getMessage('userlist.js.error_manage_account_settings_right_revoked'));
                    window.location.reload();
                    break;
                default:
                    console.error(error);
            }
        });
    };
};

var copyAssignments = exports.copyAssignments = function copyAssignments() {
    return function (dispatch, getState) {
        var state = getState();
        var userTo = (0, _selectors.getPanelUser)(state);
        var userFrom = (0, _selectors.getCopyUserFrom)(state);

        dispatch(setCopyLoading(true));
        (0, _rpcCalls2.default)('UserManagementService.copyTeamAssignmentsFrom', [userTo.id, userFrom.id], function (rpcError) {
            return rpcError.handleOnExceptions([_constants.Exceptions.NoSuchUserException, _constants.Exceptions.NoSuchCopyUserException, _constants.Exceptions.NoRightsToManageAccountSettings]);
        }).then((0, _batch.batched)(function () {
            dispatch(setCopyLoading(false));
            dispatch(closeCopyContent());
            dispatch(loadTeamAssignmentsData());
            dispatch((0, _actions4.toast)(_messageResource2.default.getMessage('user.panel.permissions.team_assignments.copy.toast.settings_copied', [userTo.firstName, (0, _UserNameFormat.formatFmlWithCheck)(userFrom)])));
        })).catch(function (error) {
            dispatch(setCopyLoading(false));
            dispatch((0, _actions5.handleCommonError)(userTo.id, error));
            switch (error.getException()) {
                case _constants.Exceptions.NoSuchUserException:
                    dispatch((0, _actions5.closeAllPanels)());
                    break;
                case _constants.Exceptions.NoSuchCopyUserException:
                    alert(_messageResource2.default.getMessage('work_assignments.panel.copy.error.user_deleted'));
                    dispatch((0, _actions3.removeUser)(userFrom.id));
                    SyncCallbacks.onNoSuchUserException(userFrom.id);
                    break;
                default:
                    console.error(error);
                    dispatch(closeCopyContent());
            }
        });
    };
};

/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isImportHolidaysInProcess = exports.hasHolidaysInPast = exports.hasHolidaysOnLeaveBlackoutDays = exports.getHolidays = exports.getFileName = exports.getCountry = exports.getYear = exports.isLoadingImportedHolidays = exports.isShownImportHolidaysPanel = exports.getImportHolidaysPanelState = undefined;

var _reselect = __webpack_require__(13);

var _selectors = __webpack_require__(263);

var _selectors2 = __webpack_require__(212);

var getImportHolidaysPanelState = exports.getImportHolidaysPanelState = function getImportHolidaysPanelState(state) {
    return state.workSchedule.importHolidaysPanel;
};

var isShownImportHolidaysPanel = exports.isShownImportHolidaysPanel = (0, _reselect.createSelector)(getImportHolidaysPanelState, function (importHolidaysPanel) {
    return importHolidaysPanel.isShown;
});

var isLoadingImportedHolidays = exports.isLoadingImportedHolidays = (0, _reselect.createSelector)(getImportHolidaysPanelState, function (importHolidaysPanel) {
    return importHolidaysPanel.loading;
});

var getYear = exports.getYear = (0, _reselect.createSelector)(_selectors.isShownHolidayList, _selectors.getPanelSelectedYear, _selectors2.geSelectedYear, function (isShownHolidayList, panelSelectedYear, workScheduleSelectedYear) {
    return isShownHolidayList ? panelSelectedYear : workScheduleSelectedYear;
});

var getCountry = exports.getCountry = (0, _reselect.createSelector)(getImportHolidaysPanelState, function (importHolidaysPanel) {
    return importHolidaysPanel.country;
});

var getFileName = exports.getFileName = (0, _reselect.createSelector)(getImportHolidaysPanelState, function (importHolidaysPanel) {
    return importHolidaysPanel.fileName;
});

var getHolidays = exports.getHolidays = (0, _reselect.createSelector)(getImportHolidaysPanelState, _selectors2.getLeaveBlackoutDaysForSelectedYear, function (importHolidaysPanel, leaveBlackoutDays) {
    return leaveBlackoutDays ? importHolidaysPanel.holidays.filter(function (holiday) {
        var date = new Date(holiday.date);
        var month = date.getMonth();
        var day = date.getDate();

        return !(leaveBlackoutDays[month] && leaveBlackoutDays[month][day]);
    }) : importHolidaysPanel.holidays;
});

var hasHolidaysOnLeaveBlackoutDays = exports.hasHolidaysOnLeaveBlackoutDays = (0, _reselect.createSelector)(getImportHolidaysPanelState, getHolidays, function (importHolidaysPanel, filteredHolidays) {
    return importHolidaysPanel.holidays.length > filteredHolidays.length;
});

var hasHolidaysInPast = exports.hasHolidaysInPast = (0, _reselect.createSelector)(getImportHolidaysPanelState, function (importHolidaysPanel) {
    return importHolidaysPanel.hasHolidaysInPast;
});

var isImportHolidaysInProcess = exports.isImportHolidaysInProcess = (0, _reselect.createSelector)(getImportHolidaysPanelState, function (importHolidaysPanel) {
    return importHolidaysPanel.importProcess;
});

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getCustomFieldsValuesWithDefaults = exports.isTaskDataChanged = exports.getCustomerName = exports.getProjectName = exports.getCustomFieldsValues = exports.isNeedInitializeFocus = exports.getDefaultTaskInfoState = exports.getAddedAssignedManagerIds = exports.getAddedAssignedUserIds = exports.canModifyAnyManager = exports.canModifyAnyUser = exports.getAssignedManagers = exports.getAssignedUsers = exports.getLastTaskPanelTabKey = exports.getTaskPanelTabKey = exports.getTaskInfo = exports.getTaskBillableTypeId = exports.getTaskPanelErrors = exports.isWorkTypeBillable = exports.getBillableTypeName = exports.getBillingType = exports.getTaskDescription = exports.getEstimatedTime = exports.getTaskName = exports.getTaskDeadline = exports.isTaskCompleted = exports.getTaskStatusId = exports.isNeedToLoadData = exports.isPanelOpened = exports.isLoading = exports.isLoaded = exports.getTaskPanelState = undefined;

var _selectorsGenerator = __webpack_require__(756);

var _selectorsGenerator2 = _interopRequireDefault(_selectorsGenerator);

var _selectorsGenerator3 = __webpack_require__(757);

var _selectorsGenerator4 = _interopRequireDefault(_selectorsGenerator3);

var _selectors = __webpack_require__(27);

var _selectors2 = __webpack_require__(14);

var _reselect = __webpack_require__(13);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _selectors3 = __webpack_require__(190);

var _constants = __webpack_require__(922);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getTaskPanelState = exports.getTaskPanelState = function getTaskPanelState(state) {
    return state.panels.task.create;
};

var taskPanelSelectors = (0, _selectorsGenerator2.default)(getTaskPanelState);
var assignmentsSelectors = (0, _selectorsGenerator4.default)(getTaskPanelState);

var isLoaded = exports.isLoaded = taskPanelSelectors.isLoaded;
var isLoading = exports.isLoading = taskPanelSelectors.isLoading;
var isPanelOpened = exports.isPanelOpened = taskPanelSelectors.isPanelOpened;
var isNeedToLoadData = exports.isNeedToLoadData = taskPanelSelectors.isNeedToLoadData;
var getTaskStatusId = exports.getTaskStatusId = taskPanelSelectors.getTaskStatusId;
var isTaskCompleted = exports.isTaskCompleted = taskPanelSelectors.isTaskCompleted;
var getTaskDeadline = exports.getTaskDeadline = taskPanelSelectors.getTaskDeadline;
var getTaskName = exports.getTaskName = taskPanelSelectors.getTaskName;
var getEstimatedTime = exports.getEstimatedTime = taskPanelSelectors.getEstimatedTime;
var getTaskDescription = exports.getTaskDescription = taskPanelSelectors.getTaskDescription;
var getBillingType = exports.getBillingType = taskPanelSelectors.getBillingType;
var getBillableTypeName = exports.getBillableTypeName = taskPanelSelectors.getBillableTypeName;
var isWorkTypeBillable = exports.isWorkTypeBillable = taskPanelSelectors.isWorkTypeBillable;
var getTaskPanelErrors = exports.getTaskPanelErrors = taskPanelSelectors.getTaskPanelErrors;
var getTaskBillableTypeId = exports.getTaskBillableTypeId = taskPanelSelectors.getTaskBillableTypeId;
var getTaskInfo = exports.getTaskInfo = taskPanelSelectors.getTaskInfo;

var getTaskPanelTabKey = exports.getTaskPanelTabKey = taskPanelSelectors.getTaskPanelTabKey;
var getLastTaskPanelTabKey = exports.getLastTaskPanelTabKey = taskPanelSelectors.getLastTaskPanelTabKey;

var getAssignedUsers = exports.getAssignedUsers = assignmentsSelectors.getAssignedUsers;
var getAssignedManagers = exports.getAssignedManagers = assignmentsSelectors.getAssignedManagers;
var canModifyAnyUser = exports.canModifyAnyUser = assignmentsSelectors.canModifyAnyUser;
var canModifyAnyManager = exports.canModifyAnyManager = assignmentsSelectors.canModifyAnyManager;

var getAddedAssignedUserIds = exports.getAddedAssignedUserIds = function getAddedAssignedUserIds(state) {
    return getTaskPanelState(state).addedAssignedUserIds;
};
var getAddedAssignedManagerIds = exports.getAddedAssignedManagerIds = function getAddedAssignedManagerIds(state) {
    return getTaskPanelState(state).addedAssignedManagerIds;
};

var getDefaultTaskInfoState = exports.getDefaultTaskInfoState = function getDefaultTaskInfoState(state) {
    return getTaskPanelState(state).taskInfoDefaultState;
};
var isNeedInitializeFocus = exports.isNeedInitializeFocus = function isNeedInitializeFocus(state) {
    return getTaskPanelState(state).isNeedInitializeFocus;
};
var getCustomFieldsValues = exports.getCustomFieldsValues = function getCustomFieldsValues(state) {
    return getTaskPanelState(state).customFieldsValues;
};

var getProjectName = exports.getProjectName = (0, _reselect.createSelector)(_selectors.getSingleCPSelection, _selectors2.getProjects, function (selector, projects) {
    return projects[selector.projectId] ? projects[selector.projectId].name : "";
});

var getCustomerName = exports.getCustomerName = (0, _reselect.createSelector)(_selectors.getSingleCPSelection, _selectors2.getCustomers, function (selector, customers) {
    return customers[selector.customerId] ? customers[selector.customerId].name : "";
});

var isTaskDataChanged = exports.isTaskDataChanged = (0, _reselect.createSelector)(getDefaultTaskInfoState, getTaskInfo, getAddedAssignedUserIds, getAddedAssignedManagerIds, function (defaultInfo, curInfo, addedAssignedUsersIds, addedAssignedManagersIds) {
    return !_underscore2.default.isEqual(defaultInfo, curInfo) || !_underscore2.default.isEmpty(addedAssignedUsersIds) || !_underscore2.default.isEmpty(addedAssignedManagersIds);
});

var getCustomFieldValueOrDefault = function getCustomFieldValueOrDefault(customField, customFieldValue) {
    if (customFieldValue === undefined) {
        if (customField.type === _constants.CustomFieldType.Dropdown) {
            return customField.options.find(function (option) {
                return option.value === customField.defaultValue;
            }).value;
        }
        return null;
    } else {
        return customFieldValue;
    }
};

var getCustomFieldsValuesWithDefaults = exports.getCustomFieldsValuesWithDefaults = (0, _reselect.createSelector)(_selectors3.selectTaskCustomFields, getCustomFieldsValues, function (customFields, customFieldsValues) {
    var result = {};
    customFields.forEach(function (cf) {
        result[cf.fieldName] = getCustomFieldValueOrDefault(cf, customFieldsValues[cf.fieldName]);
    });
    return result;
});

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isNeedToLoadDemoData = exports.getLoadExternalWelcomeScreen = exports.getHeight = exports.getWidth = exports.getUrl = exports.getDemoDataStage = exports.getShowExternalContent = exports.getPopupVisible = exports.getLoading = undefined;

var _reselect = __webpack_require__(13);

var getWelcomeState = function getWelcomeState(state) {
    return state.welcome;
};

var getLoading = exports.getLoading = (0, _reselect.createSelector)(getWelcomeState, function (state) {
    return state.loading;
});

var getPopupVisible = exports.getPopupVisible = (0, _reselect.createSelector)(getWelcomeState, function (state) {
    return state.popupVisible;
});

var getShowExternalContent = exports.getShowExternalContent = (0, _reselect.createSelector)(getWelcomeState, function (state) {
    return state.showExternalContent;
});

var getDemoDataStage = exports.getDemoDataStage = (0, _reselect.createSelector)(getWelcomeState, function (state) {
    return state.demoDataStage;
});

var getUrl = exports.getUrl = (0, _reselect.createSelector)(getWelcomeState, function (state) {
    return state.url;
});

var getWidth = exports.getWidth = (0, _reselect.createSelector)(getWelcomeState, function (state) {
    return state.size.width;
});

var getHeight = exports.getHeight = (0, _reselect.createSelector)(getWelcomeState, function (state) {
    return state.size.height;
});

var getLoadExternalWelcomeScreen = exports.getLoadExternalWelcomeScreen = (0, _reselect.createSelector)(getWelcomeState, function (state) {
    return state.loadExternalWelcomeScreen;
});

var isNeedToLoadDemoData = exports.isNeedToLoadDemoData = (0, _reselect.createSelector)(getWelcomeState, function (state) {
    return state.needToLoadDemoData;
});

/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
        value: true
});
exports.default = emitUserEvent;

var _UserEventsMap = __webpack_require__(99);

var _sendUserEvent = __webpack_require__(579);

var _sendUserEvent2 = _interopRequireDefault(_sendUserEvent);

var _isNeedToSendUserEvents = __webpack_require__(945);

var _isNeedToSendUserEvents2 = _interopRequireDefault(_isNeedToSendUserEvents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function emitUserEvent(event, params) {
        if (!(0, _isNeedToSendUserEvents2.default)()) return false;

        var handlers = _UserEventsMap.EventsHandlersMap[event];
        if (!handlers) return (0, _sendUserEvent2.default)(event, params);

        handlers.forEach(function (handler) {
                var _handler = handler(event, params),
                    resultEvent = _handler.event,
                    resultParams = _handler.params;

                if (Object.values(_UserEventsMap.MonitoredEventsMap).includes(resultEvent)) return (0, _sendUserEvent2.default)(resultEvent, resultParams);
        });
}

/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _OverlayTipsKit = __webpack_require__(1913);

var _OverlayTipsKit2 = _interopRequireDefault(_OverlayTipsKit);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _OverlayTips = __webpack_require__(86);

var _OverlayTips2 = _interopRequireDefault(_OverlayTips);

var _StateComponent2 = __webpack_require__(105);

var _StateComponent3 = _interopRequireDefault(_StateComponent2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PageOverlayTipsManager = function (_StateComponent) {
    _inherits(PageOverlayTipsManager, _StateComponent);

    /**
     * Adds page-specific tips, refreshes them when needed, enables/disables them.
     * @constructor
     */
    function PageOverlayTipsManager() {
        _classCallCheck(this, PageOverlayTipsManager);

        var _this = _possibleConstructorReturn(this, (PageOverlayTipsManager.__proto__ || Object.getPrototypeOf(PageOverlayTipsManager)).call(this));

        _this._dynamicTips = [];
        _this._deferredUntilEnabled = [];
        _this._refreshDynamicTipsDeferred = false;
        _this._enabledOnce = false;
        _this._tipsKit = new _OverlayTipsKit2.default();
        return _this;
    }

    _createClass(PageOverlayTipsManager, [{
        key: "init",
        value: function init() {
            if (_jquery2.default.cookie("at-tips-enabled")) this.enable();
            return this;
        }

        /**
         * Gets instance of overlay tips manager for current page.
         * @returns {PageOverlayTipsManager}
         */

    }, {
        key: "disableCookie",


        /**
         * Forgets tips enabled status from cookies.
         */
        value: function disableCookie() {
            _jquery2.default.cookie("at-tips-enabled", null, { path: "/", expires: 365 });
        }

        /**
         * Remembers tips enabled status in cookies.
         */

    }, {
        key: "enableCookie",
        value: function enableCookie() {
            _jquery2.default.cookie("at-tips-enabled", true, { path: "/", expires: 365 });
        }

        /**
         * Remembers tips first time status in cookies.
         */

    }, {
        key: "enableFirstTimeCookie",
        value: function enableFirstTimeCookie() {
            _jquery2.default.cookie("at-tips-first-time", true, { path: "/", expires: 365 });
        }

        /**
         * Remembers tips first time status in cookies.
         */

    }, {
        key: "disableFirstTimeCookie",
        value: function disableFirstTimeCookie() {
            _jquery2.default.cookie("at-tips-first-time", null, { path: "/", expires: 365 });
        }

        /**
         * Remembers a state, which prevents tips from showing immediately.
         */

    }, {
        key: "enableShowLater",
        value: function enableShowLater() {
            this._showLater = true;
        }
    }, {
        key: "showFirstTimeTips",
        value: function showFirstTimeTips() {
            this._tipsKit.showAll();
        }
    }, {
        key: "disableMenuIcon",
        value: function disableMenuIcon() {
            (0, _jquery2.default)(".popup_menu_button_tips").children(".popup_menu_icon").removeClass("tips_icon_light_on");
        }
    }, {
        key: "enableMenuIcon",
        value: function enableMenuIcon() {
            (0, _jquery2.default)(".popup_menu_button_tips").children('.popup_menu_icon').addClass("tips_icon_light_on");
        }

        /**
         * Base function, which adds initial tips, usually on page load.
         */

    }, {
        key: "addBaseTips",
        value: function addBaseTips() {
            if (_jquery2.default.cookie("at-tips-first-time")) {
                this._firstTimeTip = this.add((0, _jquery2.default)(".popup_menu_button_tips"), {
                    messageKey: "tips.toggle_tips",
                    direction: _OverlayTips2.default.DIRECTION_BOTTOM_LEFT,
                    offsetX: -20,
                    offsetY: 10,
                    extraClass: "toggleTipsTipZindex"
                });

                if (!this._showLater) this.disableFirstTimeCookie();
            }
        }

        /**
         * Toggles tips enabled status.
         */

    }, {
        key: "toggle",
        value: function toggle() {
            if (this.enabled) this.disable();else this.enable();
        }

        /**
         * Disables all tips on the page, hiding them,
         * and updates navigation tip button status.
         */

    }, {
        key: "disable",
        value: function disable() {
            this.enabled = false;
            this.disableCookie();

            if (this._firstTimeTip) {
                this._tipsKit.remove(this._firstTimeTip.id);
                this._firstTimeTip = null;
            }

            this._tipsKit.hideAll();
            this.disableMenuIcon();
        }

        /**
         * Enables all tips on the page, showing them,
         * and updates navigation tip button status.
         */

    }, {
        key: "enable",
        value: function enable() {
            this.enabled = true;
            this.enableCookie();

            if (!this._enabledOnce) {
                this.addBaseTips();
                for (var i = 0; i < this._deferredUntilEnabled.length; i++) {
                    this._deferredUntilEnabled[i].call(this);
                }this._enabledOnce = true;
            } else {
                this._tipsKit.showAll();
                this._scheduleQueueProcessing();
            }

            if (this._refreshDynamicTipsDeferred) this.refreshDynamicTips();

            this.enableMenuIcon();
        }
    }, {
        key: "_scheduleQueueProcessing",
        value: function _scheduleQueueProcessing() {
            if (!this._tipsKit.isQueueProcessed()) this._tipsKit.scheduleQueueProcessing();
        }

        /**
         * Add static or dynamic tip to specified element.
         * @param relative Relative jQuery element or a function returning jQuery element.
         *                 If a function is specified, added tip will be dynamic.
         * @param config OverlayTips config.
         */

    }, {
        key: "add",
        value: function add(relative, config) {
            if (_underscore2.default.isFunction(relative)) {
                // If relative element is a function, this is a dynamic tip.
                // Such tips are re-calculated each time refreshDynamicTips() is called.
                var relativeCalculated = relative();
                var configCalculated = relativeCalculated.config ? relativeCalculated.config : config;
                var elemCalculated = relativeCalculated.element ? relativeCalculated.element : relativeCalculated;
                this._dynamicTips.push({
                    element: elemCalculated,
                    relativeFunction: relative,
                    config: configCalculated
                });
                relative = elemCalculated;
                config = configCalculated;
            }

            return this._add(relative, config);
        }

        /**
         * Re-evaluates every dynamic tip, deleting them or moving to new relatives if necessary.
         */

    }, {
        key: "refreshDynamicTips",
        value: function refreshDynamicTips(animated) {
            if (_underscore2.default.isUndefined(animated)) animated = true;

            if (!this.enabled) {
                this._refreshDynamicTipsDeferred = true;
                return;
            }

            var self = this;
            _underscore2.default.each(this._dynamicTips, function (dt) {
                // Find dynamic tip element in DOM
                var tip = document.getElementById("overlayTip" + dt.config.id);
                var newRelative = dt.relativeFunction();
                var newElementCalculated = newRelative.element ? newRelative.element : newRelative;
                var newConfigCalculated = newRelative.config ? newRelative.config : dt.config;
                var oldElementCalculated = dt.element;
                var addAgain = false;
                if (tip) {
                    // Tip element exists, check if its relative is still valid
                    if (oldElementCalculated[0] != newElementCalculated[0] || !_underscore2.default.isMatch(dt.config, newConfigCalculated)) {
                        // Old relative is no longer valid, so we remove the tip and ask to re-add it
                        self._tipsKit.remove(dt.config.id);
                        addAgain = true;
                    }
                } else {
                    // Tip element is no longer in DOM, so we ask to re-add it
                    addAgain = true;
                }

                // Attempt to add the tip again. If newRelative is empty, nothing will be added
                if (addAgain) {
                    dt.element = newElementCalculated;
                    // If we don't clone the object, then we can get few instances of one object in queue
                    dt.config = _underscore2.default.clone(newConfigCalculated);
                    dt.config.refreshAnimated = animated;
                    self._add(dt.element, dt.config);
                }
            });
        }
    }, {
        key: "deferUntilEnabled",
        value: function deferUntilEnabled(f) {
            if (this.enabled) f.call(this);else this._deferredUntilEnabled.push(f);
        }

        /**
         * Adds new tip with specified config to the element.
         * @param relative Relative jQuery element.
         * @param config OverlayTips config.
         * @private
         */

    }, {
        key: "_add",
        value: function _add(relative, config) {
            var $el = relative.first();
            if ($el.length == 0) return;

            // config.show is a dynamic parameter
            config.show = this.enabled && !this._showLater;

            config.relativeTo = $el;
            return this._tipsKit.enqueueTip(config);
        }
    }, {
        key: "repositionOutsideTips",
        value: function repositionOutsideTips() {
            this._tipsKit.repositionOutsideTips();
        }
    }], [{
        key: "getInstance",
        value: function getInstance() {
            if (!PageOverlayTipsManager.instance) PageOverlayTipsManager.setInstance(new PageOverlayTipsManager());
            return this.instance;
        }

        /**
         * Sets instance of overlay tips manager for current page.
         * @param instance New instance
         */

    }, {
        key: "setInstance",
        value: function setInstance(instance) {
            if (PageOverlayTipsManager.instance !== instance) {
                var oldManager = PageOverlayTipsManager.instance;
                if (oldManager) {
                    instance.enabled = oldManager.enabled;
                    if (oldManager.enabled) {
                        oldManager._tipsKit.hideAll();
                        instance.enable();
                    } else {
                        instance._scheduleQueueProcessing();
                    }
                }

                PageOverlayTipsManager.instance = instance;
            }
        }
    }]);

    return PageOverlayTipsManager;
}(_StateComponent3.default);

exports.default = PageOverlayTipsManager;

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _constants = __webpack_require__(11);

var _RowType = __webpack_require__(267);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var BaseTableDataConverter = function () {
    function BaseTableDataConverter(reportData, reportParams) {
        _classCallCheck(this, BaseTableDataConverter);

        this.reportData = reportData;
        this.reportParams = reportParams;
    }

    _createClass(BaseTableDataConverter, [{
        key: "convert",
        value: function convert() {
            var groupingLevels = this.getGroupingLevels(this.reportParams);
            this.types = this.getTypes(groupingLevels);
            this.groupingTypes = this.getGroupingLevelsCollapsed(groupingLevels);

            var rows = [];
            rows.push(this._createHeader());
            rows.push(this._createDataRow(-1, _RowType.RowType.TOTALS, _constants.ReportGroupingLevel.NONE, this.reportData));

            this.addDataRecursive(this.reportData, rows, 0);
            return rows;
        }
    }, {
        key: "addDataRecursive",
        value: function addDataRecursive(item, rows, level) {
            if (item.items.length == 0) {
                return;
            }

            _underscore2.default.each(item["items"], function (item) {
                var groupingType = this.groupingTypes[level];
                var type = this.types[level];
                rows.push(this._createDataRow(level, type, groupingType, item));
                this.addDataRecursive(item, rows, level + 1);
            }, this);
        }
    }, {
        key: "getTypes",
        value: function getTypes(groupingLevels) {
            var types = {};
            var level = 0;
            for (var i = 0; i < groupingLevels.length; ++i) {
                if (groupingLevels[i] !== _constants.ReportGroupingLevel.NONE) {
                    types[level] = i + _RowType.RowType.FIRST_LEVEL;
                    level++;
                }
            }
            return types;
        }
    }, {
        key: "getGroupingLevelsCollapsed",
        value: function getGroupingLevelsCollapsed(groupingLevels) {
            return _underscore2.default.filter(groupingLevels, function (level) {
                return level !== _constants.ReportGroupingLevel.NONE;
            });
        }
    }, {
        key: "_createHeader",
        value: function _createHeader(reportData, reportParams) {
            // abstract
        }
    }, {
        key: "_createDataRow",
        value: function _createDataRow(level, type, groupingLevel, leavesReportItem) {
            // abstract
        }
    }, {
        key: "getGroupingLevels",
        value: function getGroupingLevels(params) {
            var array = [];
            array.push(params.firstGroupingLevel);
            array.push(params.secondGroupingLevel);
            return array;
        }
    }]);

    return BaseTableDataConverter;
}();

exports.default = BaseTableDataConverter;

/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Totals = exports.Levels = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _FormatUtils = __webpack_require__(142);

var _FormatUtils2 = _interopRequireDefault(_FormatUtils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var BasePDFDefinitionColumnBuilder = function () {
    function BasePDFDefinitionColumnBuilder() {
        _classCallCheck(this, BasePDFDefinitionColumnBuilder);

        this.tableHeaderStyleNoMargin = "reportHeader";
        this.tableHeaderMargin = "reportHeaderMargin";
        this.tableHeaderStyle = ["reportHeader", "reportHeaderMargin"];
        this.tableSubHeaderStyle = ["reportSubHeader", "reportHeaderMargin"];
        this.tableSubHeaderWithMarginStyle = ["reportSubHeader", "reportTitleNormalMargin"];
        this.tableThirdLvlHeaderStyle = ["reportSubHeader", "reportHeaderMargin", "smallText"];

        this.reportTotalValue = "reportTotalValue";
        this.reportTotalTitle = ["reportHeader", "reportTotalTitle"];
        this.reportTitleBigMargin = ["reportHeader", "reportTitleBigMargin"];
        this.reportTitleNormalMargin = ["reportHeader", "reportTitleNormalMargin"];
        this.reportTitleSmallMargin = ["reportHeader", "reportTitleSmallMargin"];
        this.reportGroupingValues = ["reportFirstGroupingValue", "reportSecondGroupingValue", "reportThirdGroupingValue", "reportFourthGroupingValue"];

        this.asterisk = "asterisk";

        this.smallText = "smallText";
        this.tinyText = "tinyText";
        this.negativeValue = "negativeValue";
        this.grayText = "grayText";
    }

    _createClass(BasePDFDefinitionColumnBuilder, [{
        key: "init",
        value: function init(config, rowSpanNumber) {
            this.timeFormat = config.timeFormat;
            this.formatUtil = _FormatUtils2.default;

            this.rowSpanNumber = rowSpanNumber;

            var emptyFn = _underscore2.default.constant(false);
            this.valueMask = [emptyFn, emptyFn, emptyFn, emptyFn];

            return this;
        }
    }, {
        key: "pushWidth",
        value: function pushWidth(destination, sizes) {}
    }, {
        key: "setParams",
        value: function setParams(params) {
            this.params = params;
        }
    }, {
        key: "makeHeader",
        value: function makeHeader() {}
    }, {
        key: "makeTotals",
        value: function makeTotals(data) {
            return this._makeRow(this.reportTotalValue, data, _underscore2.default.constant(false));
        }
    }, {
        key: "makeSubHeader",
        value: function makeSubHeader() {
            return '';
        }
    }, {
        key: "makeThirdLvlHeader",
        value: function makeThirdLvlHeader() {
            return '';
        }
    }, {
        key: "makeRow",
        value: function makeRow(lvl, data) {
            return this._makeRow(this.reportGroupingValues[lvl], data, this.valueMask[lvl]);
        }
    }, {
        key: "makeFirstRow",
        value: function makeFirstRow(data) {
            return this.makeRow(0, data);
        }
    }, {
        key: "makeSecondRow",
        value: function makeSecondRow(data) {
            return this.makeRow(1, data);
        }
    }, {
        key: "makeThirdRow",
        value: function makeThirdRow(data) {
            return this.makeRow(2, data);
        }
    }, {
        key: "makeFourthRow",
        value: function makeFourthRow(data) {
            return this.makeRow(3, data);
        }
    }, {
        key: "_makeRowDefinition",
        value: function _makeRowDefinition(style, text) {
            return {
                style: style,
                text: text
            };
        }
    }, {
        key: "_makeHeaderDefinition",
        value: function _makeHeaderDefinition(text, style) {
            if (_underscore2.default.isUndefined(style)) style = this.tableHeaderStyle;

            return {
                style: style,
                text: text,
                rowSpan: this.rowSpanNumber
            };
        }
    }, {
        key: "_formatTimeValue",
        value: function _formatTimeValue(value) {
            return this.formatUtil.formatPureTime(value, this.timeFormat);
        }
    }, {
        key: "_formatPercentValue",
        value: function _formatPercentValue(value) {
            return this.formatUtil.formatPercent(value);
        }
    }, {
        key: "_formatStyle",
        value: function _formatStyle(value, style) {
            return value < 0 ? [style, this.negativeValue] : style;
        }
    }, {
        key: "makeTimeCell",
        value: function makeTimeCell(value, style, valueIsMasked) {
            var newStyle = valueIsMasked ? valueIsMasked.style ? [valueIsMasked.style, style] : style : this._formatStyle(value, style);
            var newValue = valueIsMasked ? valueIsMasked.msg : this._formatTimeValue(value);
            return {
                noWrap: true,
                style: newStyle,
                text: newValue
            };
        }
    }, {
        key: "makeTextCell",
        value: function makeTextCell(value, style) {
            return {
                noWrap: true,
                style: style,
                text: value
            };
        }
    }, {
        key: "makeSignedTimeCell",
        value: function makeSignedTimeCell(value, style, valueIsMasked) {
            var newStyle = valueIsMasked ? valueIsMasked.style ? [valueIsMasked.style, style] : style : this._formatStyle(value, style);
            var newValue = valueIsMasked ? valueIsMasked.msg : this._formatTimeValue(value);
            var signedValue = value > 0 ? '+' + newValue : newValue;
            return {
                noWrap: true,
                style: newStyle,
                text: signedValue
            };
        }
    }, {
        key: "makePercentCell",
        value: function makePercentCell(value, style, valueIsMasked) {
            var newStyle = valueIsMasked ? valueIsMasked.style ? valueIsMasked.style : style : this._formatStyle(value, style);
            var newValue = valueIsMasked ? valueIsMasked.msg : this._formatPercentValue(value);
            return {
                noWrap: true,
                style: newStyle,
                text: newValue
            };
        }
    }, {
        key: "addAsterisk",
        value: function addAsterisk(text, asteriskChar) {
            return [{
                width: '*',
                text: ''
            }, {
                width: 'auto',
                text: text,
                marginRight: 1
            }, {
                width: 'auto',
                style: "asterisk",
                text: asteriskChar,
                marginLeft: 1,
                alignment: 'left'
            }, {
                width: '*',
                text: ''
            }];
        }
    }]);

    return BasePDFDefinitionColumnBuilder;
}();

exports.default = BasePDFDefinitionColumnBuilder;

var Levels = exports.Levels = function (_BasePDFDefinitionCol) {
    _inherits(Levels, _BasePDFDefinitionCol);

    function Levels() {
        _classCallCheck(this, Levels);

        return _possibleConstructorReturn(this, (Levels.__proto__ || Object.getPrototypeOf(Levels)).apply(this, arguments));
    }

    _createClass(Levels, [{
        key: "_getTitle",
        value: function _getTitle(groupingLevel, identity, maxLen) {
            return this.formatUtil.getGroupingLevelTitle(groupingLevel, identity, this.store, maxLen);
        }
    }]);

    return Levels;
}(BasePDFDefinitionColumnBuilder);

var Totals = exports.Totals = function (_BasePDFDefinitionCol2) {
    _inherits(Totals, _BasePDFDefinitionCol2);

    function Totals() {
        _classCallCheck(this, Totals);

        return _possibleConstructorReturn(this, (Totals.__proto__ || Object.getPrototypeOf(Totals)).apply(this, arguments));
    }

    _createClass(Totals, [{
        key: "pushWidth",
        value: function pushWidth(destination, sizes) {
            destination.push(sizes["totals"] + '%');
        }
    }, {
        key: "_getValue",
        value: function _getValue(data) {
            //abstract
        }
    }, {
        key: "_makeRow",
        value: function _makeRow(style, data, valueMask) {
            return this._makeRowDefinition(style, valueMask(this, data) ? "" : this._formatTimeValue(this._getValue(data)));
        }
    }]);

    return Totals;
}(BasePDFDefinitionColumnBuilder);

/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _BaseReportStore2 = __webpack_require__(830);

var _BaseReportStore3 = _interopRequireDefault(_BaseReportStore2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OvertimeReportStore = function (_BaseReportStore) {
    _inherits(OvertimeReportStore, _BaseReportStore);

    function OvertimeReportStore() {
        _classCallCheck(this, OvertimeReportStore);

        var _this = _possibleConstructorReturn(this, (OvertimeReportStore.__proto__ || Object.getPrototypeOf(OvertimeReportStore)).call(this));

        _this.convertedData = null;
        return _this;
    }

    _createClass(OvertimeReportStore, [{
        key: 'setConvertedData',
        value: function setConvertedData(data) {
            this.convertedData = data;
        }
    }, {
        key: 'getConvertedData',
        value: function getConvertedData() {
            return this.convertedData;
        }
    }, {
        key: 'getTimeFormat',
        value: function getTimeFormat() {
            return this.timeFormat;
        }
    }]);

    return OvertimeReportStore;
}(_BaseReportStore3.default);

var store = new OvertimeReportStore();
exports.default = store;

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = StaffPerformanceCSVPreviewBaseColumnsStrategy;

var _CSVColumnsStrategy = __webpack_require__(413);

var _CSVColumnsStrategy2 = _interopRequireDefault(_CSVColumnsStrategy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function StaffPerformanceCSVPreviewBaseColumnsStrategy() {}

StaffPerformanceCSVPreviewBaseColumnsStrategy.prototype = Object.create(_CSVColumnsStrategy2.default.prototype);

StaffPerformanceCSVPreviewBaseColumnsStrategy.prototype.init = function (includeOtherUsersColumn) {
    _CSVColumnsStrategy2.default.prototype.init.call(this);
    this.includeOtherUsersColumn = includeOtherUsersColumn;
    return this;
};

StaffPerformanceCSVPreviewBaseColumnsStrategy.prototype.addMainHeaderRowCells = function (mainHeaderRow) {
    this.addCell(mainHeaderRow, this.message("report.spent_time"));
};

StaffPerformanceCSVPreviewBaseColumnsStrategy.prototype.addColumnGropingHeaderRowCells = function (colGroupingRow) {
    this.addCell(colGroupingRow, ""); // above Spent Sum
};

StaffPerformanceCSVPreviewBaseColumnsStrategy.prototype.addDataCells = function (row) {
    for (var i = 0; i < this.getNumOfDataColumns(); i++) {
        this.addTimeValueCell(row);
    }
};

StaffPerformanceCSVPreviewBaseColumnsStrategy.prototype.addEmptyCells = function (row) {
    ReportPreviewUtils.addEmptyCells(row, this.getNumOfDataColumns());
};

StaffPerformanceCSVPreviewBaseColumnsStrategy.prototype.getNumOfDataColumns = function () {
    //abstract
};

/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = CSVColumnsStrategy;

var _BaseColumnsStrategy = __webpack_require__(984);

var _BaseColumnsStrategy2 = _interopRequireDefault(_BaseColumnsStrategy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CSVColumnsStrategy() {}

CSVColumnsStrategy.prototype = _.create(_BaseColumnsStrategy2.default.prototype);

CSVColumnsStrategy.prototype.init = function () {
    _BaseColumnsStrategy2.default.prototype.init.call(this);
    return this;
};

CSVColumnsStrategy.prototype.createTimeValueCell = function (className) {
    return ReportPreviewUtils.createCell(this.makeTimeValue(), className);
};

CSVColumnsStrategy.prototype.makeTimeValue = function () {
    return ReportPreviewUtils.getCSVTimeValue();
};

CSVColumnsStrategy.prototype.addTimeValueCell = function (row, className) {
    var resultClass = className ? "value " + className : "value";
    _BaseColumnsStrategy2.default.prototype.addTimeValueCell.call(this, row, resultClass);
};

/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = CostCSVPreviewBaseColumnsStrategy;

var _CSVColumnsStrategy = __webpack_require__(413);

var _CSVColumnsStrategy2 = _interopRequireDefault(_CSVColumnsStrategy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CostCSVPreviewBaseColumnsStrategy() {}

CostCSVPreviewBaseColumnsStrategy.prototype = new _CSVColumnsStrategy2.default();

CostCSVPreviewBaseColumnsStrategy.prototype.init = function (showSpentTime, showAverageRates) {
    _CSVColumnsStrategy2.default.prototype.init.call(this);
    this.showSpentTime = showSpentTime;
    this.showAverageRates = showAverageRates;
    return this;
};

CostCSVPreviewBaseColumnsStrategy.prototype.getNumOfDataColumns = function () {
    return this.getOverallColumnsCount() + this.getNumOfDetailsColumns();
};

CostCSVPreviewBaseColumnsStrategy.prototype.getNumOfDetailsColumns = function () {
    //abstract
};

CostCSVPreviewBaseColumnsStrategy.prototype.getOverallColumnsCount = function () {
    var count = 1;
    if (this.showSpentTime) count++;
    if (this.showAverageRates) count++;
    return count;
};

CostCSVPreviewBaseColumnsStrategy.prototype.addOverallHeaderCells = function (row) {
    if (this.showSpentTime) this.addCell(row, this.message("report.cost.overall_spent.csv"));
    if (this.showAverageRates) this.addCell(row, this.message("report.cost.average_rate.csv", [SystemSettings.currencySign]));
    this.addCell(row, this.message("report.cost.overall_cost.csv", [SystemSettings.currencySign]));
};

CostCSVPreviewBaseColumnsStrategy.prototype.addThirdHeaderRowDataCells = function (mainHeaderRow) {};

CostCSVPreviewBaseColumnsStrategy.prototype.getCountLevels = function (colGroupingRow) {
    // abstract
};

CostCSVPreviewBaseColumnsStrategy.prototype.addFirstHeaderRowDataCells = function (row) {};

CostCSVPreviewBaseColumnsStrategy.prototype.addSecondHeaderRowDataCells = function (row) {};

CostCSVPreviewBaseColumnsStrategy.prototype.addDataCells = function (row) {
    for (var i = 0; i < this.getNumOfDataColumns(); i++) {
        this.addTimeValueCell(row);
    }
};

/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = CostHTMLPreviewBaseColumnsStrategy;

var _HTMLColumnsStrategy = __webpack_require__(270);

var _HTMLColumnsStrategy2 = _interopRequireDefault(_HTMLColumnsStrategy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CostHTMLPreviewBaseColumnsStrategy() {}

CostHTMLPreviewBaseColumnsStrategy.prototype = new _HTMLColumnsStrategy2.default();

CostHTMLPreviewBaseColumnsStrategy.prototype.init = function (timeFormat, showSpentTime, showAverageRates) {
    _HTMLColumnsStrategy2.default.prototype.init.call(this, timeFormat);
    this.showSpentTime = showSpentTime;
    this.showAverageRates = showAverageRates;
    return this;
};

CostHTMLPreviewBaseColumnsStrategy.prototype.addOverallHeaderCells = function (row) {
    if (this.showSpentTime) this.addCell(row, this.message("report.cost.overall_spent.csv"), "overallSpent", 1, 3);
    if (this.showAverageRates) this.addCell(row, this.message("report.cost.average_rate.csv", [SystemSettings.currencySign]), "averageRate", 1, 3);
    this.addCell(row, this.message("report.cost.overall_cost.csv", [SystemSettings.currencySign]), "overallCost", 1, 3);
};

CostHTMLPreviewBaseColumnsStrategy.prototype.addOverallDataCells = function (row) {
    if (this.showSpentTime) this.addTimeValueCell(row, "spentTimeDataCell");
    if (this.showAverageRates) this.addMoneyValueCell(row);
    this.showSpentTime || this.showAverageRates ? this.addCostDataCell(row) : this.addMoneyValueCell(row);
};

CostHTMLPreviewBaseColumnsStrategy.prototype.getOverallColumnsCount = function () {
    var count = 1;
    if (this.showSpentTime) count++;
    if (this.showAverageRates) count++;
    return count;
};

CostHTMLPreviewBaseColumnsStrategy.prototype.addFirstHeaderRowDataCells = function (row) {
    // abstract
};

CostHTMLPreviewBaseColumnsStrategy.prototype.addSecondHeaderRowDataCells = function (row) {
    // abstract
};

CostHTMLPreviewBaseColumnsStrategy.prototype.addThirdHeaderRowDataCells = function (row) {
    // abstract
};

CostHTMLPreviewBaseColumnsStrategy.prototype.addDataCells = function (row) {
    // abstract
};

CostHTMLPreviewBaseColumnsStrategy.prototype.getDataColumnsCount = function () {
    // abstract
};

CostHTMLPreviewBaseColumnsStrategy.prototype.areThereTwoRowsInHeader = function () {
    return false;
};

CostHTMLPreviewBaseColumnsStrategy.prototype.addCostDataCell = function (row) {
    this.addMoneyValueCell(row, "darkMoneyValueCell");
};

/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = BSHtmlBaseBTStrategy;

var _BaseHTMLColumnStrategy = __webpack_require__(215);

var _BaseHTMLColumnStrategy2 = _interopRequireDefault(_BaseHTMLColumnStrategy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function BSHtmlBaseBTStrategy() {}

BSHtmlBaseBTStrategy.prototype = new _BaseHTMLColumnStrategy2.default();

BSHtmlBaseBTStrategy.prototype.getLevelsNumber = function () {
    return 1;
};

BSHtmlBaseBTStrategy.prototype.getColspan = function () {
    return 1;
};

BSHtmlBaseBTStrategy.prototype.addFirstHeaderRowCells = function (row, levelsNumber) {
    // do nothing
};

BSHtmlBaseBTStrategy.prototype.addSecondHeaderRowCells = function (row, levelsNumber) {
    // do nothing
};

BSHtmlBaseBTStrategy.prototype.addColumnValueCells = function (row) {
    // abstract
};

BSHtmlBaseBTStrategy.prototype.addTimeColumnValueCells = function (row) {
    this.addTimeValueCell(row);
};

BSHtmlBaseBTStrategy.prototype.addMoneyColumnValueCells = function (row) {
    this.addMoneyValueCell(row);
};

BSHtmlBaseBTStrategy.prototype.createNonBillableCell = function (levelsNumber) {
    return ReportPreviewUtils.createCell(this.message("report.billing_summary.billing_type.html") + "&nbsp; <span class='smallText'>" + this.message("report.billing_summary.non_billable.html") + "</span>", "typeOfWork nonBillable", this.getColspan(), levelsNumber);
};

BSHtmlBaseBTStrategy.prototype.createBillableCell = function (levelsNumber, typeClass) {
    return ReportPreviewUtils.createCell(this.message("report.billing_summary.billing_type.html"), "typeOfWork " + typeClass, this.getColspan(), levelsNumber);
};

/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ProfitLossHTMLPreviewBaseSection;

var _PreviewSection = __webpack_require__(67);

var _PreviewSection2 = _interopRequireDefault(_PreviewSection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ProfitLossHTMLPreviewBaseSection() {}

ProfitLossHTMLPreviewBaseSection.prototype = new _PreviewSection2.default();

ProfitLossHTMLPreviewBaseSection.prototype.init = function (columnsStrategy) {
    this.columnsStrategy = columnsStrategy;
    return this;
};

ProfitLossHTMLPreviewBaseSection.prototype.addRowWithMainCell = function (tBody, mainCellText, mainCellClass, rowClass) {
    var row = this.createRow(rowClass);
    this.addCell(row, mainCellText, mainCellClass);
    this.columnsStrategy.addDataCells(row);
    this.addRow(tBody, row);
};

/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(172);
var $export = __webpack_require__(10);
var redefine = __webpack_require__(74);
var hide = __webpack_require__(87);
var has = __webpack_require__(75);
var Iterators = __webpack_require__(216);
var $iterCreate = __webpack_require__(607);
var setToStringTag = __webpack_require__(217);
var getPrototypeOf = __webpack_require__(133);
var ITERATOR = __webpack_require__(41)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(31);
var document = __webpack_require__(35).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(421)('keys');
var uid = __webpack_require__(174);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(35);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});
module.exports = function (key) {
  return store[key] || (store[key] = {});
};


/***/ }),
/* 422 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(35).document;
module.exports = document && document.documentElement;


/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(216);
var ITERATOR = __webpack_require__(41)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(46);
var createDesc = __webpack_require__(173);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(328);
var ITERATOR = __webpack_require__(41)('iterator');
var Iterators = __webpack_require__(216);
module.exports = __webpack_require__(37).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(1013);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)

var toObject = __webpack_require__(58);
var toAbsoluteIndex = __webpack_require__(177);
var toLength = __webpack_require__(54);
module.exports = function fill(value /* , start = 0, end = @length */) {
  var O = toObject(this);
  var length = toLength(O.length);
  var aLen = arguments.length;
  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
  var end = aLen > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};


/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(31);
var setPrototypeOf = __webpack_require__(430).set;
module.exports = function (that, target, C) {
  var S = target.constructor;
  var P;
  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
    setPrototypeOf(that, P);
  } return that;
};


/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(31);
var anObject = __webpack_require__(38);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(112)(Function.call, __webpack_require__(90).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 431 */
/***/ (function(module, exports) {

// 20.2.2.28 Math.sign(x)
module.exports = Math.sign || function sign(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
};


/***/ }),
/* 432 */
/***/ (function(module, exports) {

// 20.2.2.14 Math.expm1(x)
var $expm1 = Math.expm1;
module.exports = (!$expm1
  // Old FF bug
  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
  // Tor Browser bug
  || $expm1(-2e-17) != -2e-17
) ? function expm1(x) {
  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
} : $expm1;


/***/ }),
/* 433 */
/***/ (function(module, exports) {

module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(38);
var aFunction = __webpack_require__(88);
var SPECIES = __webpack_require__(41)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.8 IsRegExp(argument)
var isObject = __webpack_require__(31);
var cof = __webpack_require__(132);
var MATCH = __webpack_require__(41)('match');
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};


/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.2.5.3 get RegExp.prototype.flags
var anObject = __webpack_require__(38);
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

// helper for String#{startsWith, endsWith, includes}
var isRegExp = __webpack_require__(435);
var defined = __webpack_require__(151);

module.exports = function (that, searchString, NAME) {
  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};


/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

var MATCH = __webpack_require__(41)('match');
module.exports = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch (f) { /* empty */ }
  } return true;
};


/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(35);
var DESCRIPTORS = __webpack_require__(47);
var LIBRARY = __webpack_require__(172);
var $typed = __webpack_require__(337);
var hide = __webpack_require__(87);
var redefineAll = __webpack_require__(219);
var fails = __webpack_require__(32);
var anInstance = __webpack_require__(220);
var toInteger = __webpack_require__(111);
var toLength = __webpack_require__(54);
var toIndex = __webpack_require__(636);
var gOPN = __webpack_require__(178).f;
var dP = __webpack_require__(46).f;
var arrayFill = __webpack_require__(428);
var setToStringTag = __webpack_require__(217);
var ARRAY_BUFFER = 'ArrayBuffer';
var DATA_VIEW = 'DataView';
var PROTOTYPE = 'prototype';
var WRONG_LENGTH = 'Wrong length!';
var WRONG_INDEX = 'Wrong index!';
var $ArrayBuffer = global[ARRAY_BUFFER];
var $DataView = global[DATA_VIEW];
var Math = global.Math;
var RangeError = global.RangeError;
// eslint-disable-next-line no-shadow-restricted-names
var Infinity = global.Infinity;
var BaseBuffer = $ArrayBuffer;
var abs = Math.abs;
var pow = Math.pow;
var floor = Math.floor;
var log = Math.log;
var LN2 = Math.LN2;
var BUFFER = 'buffer';
var BYTE_LENGTH = 'byteLength';
var BYTE_OFFSET = 'byteOffset';
var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;

// IEEE754 conversions based on https://github.com/feross/ieee754
function packIEEE754(value, mLen, nBytes) {
  var buffer = Array(nBytes);
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
  var i = 0;
  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
  var e, m, c;
  value = abs(value);
  // eslint-disable-next-line no-self-compare
  if (value != value || value === Infinity) {
    // eslint-disable-next-line no-self-compare
    m = value != value ? 1 : 0;
    e = eMax;
  } else {
    e = floor(log(value) / LN2);
    if (value * (c = pow(2, -e)) < 1) {
      e--;
      c *= 2;
    }
    if (e + eBias >= 1) {
      value += rt / c;
    } else {
      value += rt * pow(2, 1 - eBias);
    }
    if (value * c >= 2) {
      e++;
      c /= 2;
    }
    if (e + eBias >= eMax) {
      m = 0;
      e = eMax;
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * pow(2, mLen);
      e = e + eBias;
    } else {
      m = value * pow(2, eBias - 1) * pow(2, mLen);
      e = 0;
    }
  }
  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
  e = e << mLen | m;
  eLen += mLen;
  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
  buffer[--i] |= s * 128;
  return buffer;
}
function unpackIEEE754(buffer, mLen, nBytes) {
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var nBits = eLen - 7;
  var i = nBytes - 1;
  var s = buffer[i--];
  var e = s & 127;
  var m;
  s >>= 7;
  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
  m = e & (1 << -nBits) - 1;
  e >>= -nBits;
  nBits += mLen;
  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
  if (e === 0) {
    e = 1 - eBias;
  } else if (e === eMax) {
    return m ? NaN : s ? -Infinity : Infinity;
  } else {
    m = m + pow(2, mLen);
    e = e - eBias;
  } return (s ? -1 : 1) * m * pow(2, e - mLen);
}

function unpackI32(bytes) {
  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
}
function packI8(it) {
  return [it & 0xff];
}
function packI16(it) {
  return [it & 0xff, it >> 8 & 0xff];
}
function packI32(it) {
  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
}
function packF64(it) {
  return packIEEE754(it, 52, 8);
}
function packF32(it) {
  return packIEEE754(it, 23, 4);
}

function addGetter(C, key, internal) {
  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
}

function get(view, bytes, index, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = store.slice(start, start + bytes);
  return isLittleEndian ? pack : pack.reverse();
}
function set(view, bytes, index, conversion, value, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = conversion(+value);
  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
}

if (!$typed.ABV) {
  $ArrayBuffer = function ArrayBuffer(length) {
    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
    var byteLength = toIndex(length);
    this._b = arrayFill.call(Array(byteLength), 0);
    this[$LENGTH] = byteLength;
  };

  $DataView = function DataView(buffer, byteOffset, byteLength) {
    anInstance(this, $DataView, DATA_VIEW);
    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
    var bufferLength = buffer[$LENGTH];
    var offset = toInteger(byteOffset);
    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
    this[$BUFFER] = buffer;
    this[$OFFSET] = offset;
    this[$LENGTH] = byteLength;
  };

  if (DESCRIPTORS) {
    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
    addGetter($DataView, BUFFER, '_b');
    addGetter($DataView, BYTE_LENGTH, '_l');
    addGetter($DataView, BYTE_OFFSET, '_o');
  }

  redefineAll($DataView[PROTOTYPE], {
    getInt8: function getInt8(byteOffset) {
      return get(this, 1, byteOffset)[0] << 24 >> 24;
    },
    getUint8: function getUint8(byteOffset) {
      return get(this, 1, byteOffset)[0];
    },
    getInt16: function getInt16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
    },
    getUint16: function getUint16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return bytes[1] << 8 | bytes[0];
    },
    getInt32: function getInt32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1]));
    },
    getUint32: function getUint32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
    },
    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
    },
    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
    },
    setInt8: function setInt8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setUint8: function setUint8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packF32, value, arguments[2]);
    },
    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
      set(this, 8, byteOffset, packF64, value, arguments[2]);
    }
  });
} else {
  if (!fails(function () {
    $ArrayBuffer(1);
  }) || !fails(function () {
    new $ArrayBuffer(-1); // eslint-disable-line no-new
  }) || fails(function () {
    new $ArrayBuffer(); // eslint-disable-line no-new
    new $ArrayBuffer(1.5); // eslint-disable-line no-new
    new $ArrayBuffer(NaN); // eslint-disable-line no-new
    return $ArrayBuffer.name != ARRAY_BUFFER;
  })) {
    $ArrayBuffer = function ArrayBuffer(length) {
      anInstance(this, $ArrayBuffer);
      return new BaseBuffer(toIndex(length));
    };
    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
    }
    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
  }
  // iOS Safari 7.x bug
  var view = new $DataView(new $ArrayBuffer(2));
  var $setInt8 = $DataView[PROTOTYPE].setInt8;
  view.setInt8(0, 2147483648);
  view.setInt8(1, 2147483649);
  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
    setInt8: function setInt8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    },
    setUint8: function setUint8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    }
  }, true);
}
setToStringTag($ArrayBuffer, ARRAY_BUFFER);
setToStringTag($DataView, DATA_VIEW);
hide($DataView[PROTOTYPE], $typed.VIEW, true);
exports[ARRAY_BUFFER] = $ArrayBuffer;
exports[DATA_VIEW] = $DataView;


/***/ }),
/* 440 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 441 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(155);


/** Built-in value references. */
var Symbol = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Symbol;

/* harmony default export */ __webpack_exports__["a"] = (Symbol);


/***/ }),
/* 443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

/* harmony default export */ __webpack_exports__["a"] = (identity);


/***/ }),
/* 444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

/* harmony default export */ __webpack_exports__["a"] = (isObject);


/***/ }),
/* 445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isFunction_js__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isLength_js__ = __webpack_require__(652);



/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && Object(__WEBPACK_IMPORTED_MODULE_1__isLength_js__["a" /* default */])(value.length) && !Object(__WEBPACK_IMPORTED_MODULE_0__isFunction_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (isArrayLike);


/***/ }),
/* 446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isArray_js__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__(224);




/** `Object#toString` result references. */
var stringTag = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!Object(__WEBPACK_IMPORTED_MODULE_1__isArray_js__["a" /* default */])(value) && Object(__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["a" /* default */])(value) && Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) == stringTag);
}

/* harmony default export */ __webpack_exports__["a"] = (isString);


/***/ }),
/* 447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__ = __webpack_require__(224);



/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (Object(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(value) && Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) == symbolTag);
}

/* harmony default export */ __webpack_exports__["a"] = (isSymbol);


/***/ }),
/* 448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ownKeys;
function ownKeys(object) {
  if (typeof Reflect !== 'undefined' && typeof Reflect.ownKeys === 'function') {
    return Reflect.ownKeys(object);
  }

  var keys = Object.getOwnPropertyNames(object);

  if (typeof Object.getOwnPropertySymbols === 'function') {
    keys = keys.concat(Object.getOwnPropertySymbols(object));
  }

  return keys;
}

/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var VIEW_MODE_SET = exports.VIEW_MODE_SET = 'at/taskManagement/VIEW_MODE_SET';
var SINGLE_CP_SELECTION_CHANGE = exports.SINGLE_CP_SELECTION_CHANGE = 'at/taskManagement/SINGLE_CP_SELECTION_CHANGE';
var FILTER_CP_SELECTION_CHANGE = exports.FILTER_CP_SELECTION_CHANGE = 'at/taskManagement/FILTER_CP_SELECTION_CHANGE';
var CP_NAME_FILTER_SET = exports.CP_NAME_FILTER_SET = 'at/taskManagement/CP_NAME_FILTER_SET';
var TASK_STATUS_FILTER_CHANGE = exports.TASK_STATUS_FILTER_CHANGE = 'at/taskManagement/TASK_STATUS_FILTER_CHANGE';
var CUSTOM_FIELDS_FILTERS_SET = exports.CUSTOM_FIELDS_FILTERS_SET = 'at/taskManagement/CUSTOM_FIELDS_FILTERS_SET';
var SELECTED_FILTER_KEYS_SET = exports.SELECTED_FILTER_KEYS_SET = 'at/taskManagement/SELECTED_FILTER_KEYS_SET';
var TASK_NAME_FILTER_CHANGE = exports.TASK_NAME_FILTER_CHANGE = 'at/taskManagement/TASK_NAME_FILTER_CHANGE';
var LAST_CREATED_TASK_IDS_SET = exports.LAST_CREATED_TASK_IDS_SET = 'at/taskManagement/LAST_CREATED_TASK_IDS_SET';
var LAST_CREATED_TASK_IDS_REMOVE = exports.LAST_CREATED_TASK_IDS_REMOVE = 'at/taskManagement/LAST_CREATED_TASK_IDS_REMOVE';
var NEXT_WORKFLOW_STATUSES_SET = exports.NEXT_WORKFLOW_STATUSES_SET = 'at/taskManagement/NEXT_WORKFLOW_STATUSES_SET';
var RECENTLY_CREATED_TASKS_ADD = exports.RECENTLY_CREATED_TASKS_ADD = 'at/taskManagement/RECENTLY_CREATED_TASKS_ADD';
var RECENTLY_CREATED_CUSTOMER_IDS_SET = exports.RECENTLY_CREATED_CUSTOMER_IDS_SET = 'at/taskManagement/RECENTLY_CREATED_CUSTOMER_IDS_SET';
var RECENTLY_CREATED_PROJECT_IDS_SET = exports.RECENTLY_CREATED_PROJECT_IDS_SET = 'at/taskManagement/RECENTLY_CREATED_PROJECT_IDS_SET';
var RECENTLY_CREATED_CUSTOMERS_PROJECTS_CLEAR = exports.RECENTLY_CREATED_CUSTOMERS_PROJECTS_CLEAR = 'at/taskManagement/RECENTLY_CREATED_CUSTOMERS_PROJECTS_CLEAR';
var MANAGEMENT_ASSIGNMENTS_SET = exports.MANAGEMENT_ASSIGNMENTS_SET = 'at/taskManagement/MANAGEMENT_ASSIGNMENTS_SET';
var VIEWER_SETTINGS_SET = exports.VIEWER_SETTINGS_SET = 'at/taskManagement/VIEWER_SETTINGS_SET';
var HAS_MANAGEABLE_TASKS_SET = exports.HAS_MANAGEABLE_TASKS_SET = 'at/taskManagement/HAS_MANAGEABLE_TASKS_SET';
var SHOW_ONLY_MANAGEABLE_TASKS_SET = exports.SHOW_ONLY_MANAGEABLE_TASKS_SET = 'at/taskManagement/SHOW_ONLY_MANAGEABLE_TASKS_SET';
var CP_PANEL_CLOSED_STATE_CHANGE = exports.CP_PANEL_CLOSED_STATE_CHANGE = 'at/taskManagement/CP_PANEL_CLOSED_STATE_CHANGE';
// TODO this action only set read only property when bulk op dialog closed (after animation). Need for refresh scroll.
var BULK_OPERATIONS_PANEL_SHOWN_SET = exports.BULK_OPERATIONS_PANEL_SHOWN_SET = 'at/taskManagement/BULK_OPERATIONS_PANEL_SHOWN_SET';
var TOGGLE_LOADING_MOIRE = exports.TOGGLE_LOADING_MOIRE = 'at/taskManagement/TOGGLE_LOADING_MOIRE';

var TASK_CUSTOM_FIELDS_SET = exports.TASK_CUSTOM_FIELDS_SET = 'at/taskManagement/TASK_CUSTOM_FIELDS_SET';

/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _atUtils = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var EntityStore = function () {
    function EntityStore() {
        _classCallCheck(this, EntityStore);

        this._map = {};
        this._array = [];
        this._orderIndex = {};
    }

    _createClass(EntityStore, [{
        key: "mergeAll",
        value: function mergeAll(entities) {
            var _this = this;

            _underscore2.default.each(entities, function (entity) {
                return _this.add(entity);
            });
        }
    }, {
        key: "replaceAll",
        value: function replaceAll(entities) {
            this._map = {};
            this._array = [];
            this.mergeAll(entities);
        }
    }, {
        key: "add",
        value: function add(entity) {
            if (_underscore2.default.isObject(entity)) entity = Object.freeze(entity);

            var id = this.getEntityId(entity);
            var oldEntity = this._map[id];

            if (!oldEntity) {
                this._array.push(entity);
                this._orderIndex[id] = this._array.length - 1;
                this._onAdd(entity, null, false);
            } else {
                this._array[this._orderIndex[id]] = entity;
                this._onAdd(entity, oldEntity, false);
            }

            this._map[id] = entity;
            return oldEntity;
        }
    }, {
        key: "addFirst",
        value: function addFirst(item) {
            this.addManyFirst([item]);
        }
    }, {
        key: "addManyFirst",
        value: function addManyFirst(entities) {
            var _this2 = this;

            var newArray = [];
            var newEntitiesSet = {};

            _underscore2.default.each(entities, function (entity) {
                if (_underscore2.default.isObject(entity)) entity = Object.freeze(entity);

                var id = _this2.getEntityId(entity);
                if (!newEntitiesSet[id]) {
                    var oldEntity = _this2._map[id];
                    if (oldEntity) {
                        _this2._array[_this2._orderIndex[id]] = entity;
                        _this2._onAdd(entity, oldEntity, true);
                    } else {
                        newArray.push(entity);
                        _this2._orderIndex[id] = newArray.length - 1;
                        _this2._onAdd(entity, null, true);
                    }

                    _this2._map[id] = entity;
                    newEntitiesSet[id] = true;
                }
            });

            _underscore2.default.each(this._array, function (entity) {
                var id = _this2.getEntityId(entity);
                newArray.push(entity);
                _this2._orderIndex[id] = newArray.length - 1;
            });

            this._array = newArray;
        }
    }, {
        key: "remove",
        value: function remove(id) {
            this.removeMany([id]);
        }
    }, {
        key: "removeMany",
        value: function removeMany(ids) {
            var _this3 = this;

            this._orderIndex = {};

            var idsToRemoveSet = (0, _atUtils.arrayToSet)(ids);
            var newArray = [];
            _underscore2.default.each(this._array, function (entity) {
                var id = _this3.getEntityId(entity);
                if (!idsToRemoveSet[id]) {
                    newArray.push(entity);
                    _this3._orderIndex[id] = newArray.length - 1;
                } else {
                    delete _this3._map[id];
                    _this3._onRemove(entity);
                }
            });

            this._array = newArray;
        }
    }, {
        key: "get",
        value: function get(id) {
            return this._map[id];
        }
    }, {
        key: "getAll",
        value: function getAll() {
            return this._array;
        }
    }, {
        key: "getAllMap",
        value: function getAllMap() {
            return this._map;
        }
    }, {
        key: "getEntityId",
        value: function getEntityId(entity) {
            return entity;
        }
    }, {
        key: "_onAdd",
        value: function _onAdd(newEntity, oldEntity, first) {}
    }, {
        key: "_onRemove",
        value: function _onRemove(entity) {}
    }]);

    return EntityStore;
}();

exports.default = EntityStore;
;

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = DiacriticsUtil;

var _RegExpSpecialSymbols = __webpack_require__(343);

var _RegExpSpecialSymbols2 = _interopRequireDefault(_RegExpSpecialSymbols);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function StringBuilder() {
    this.strings = [];
}

StringBuilder.prototype.append = function (s) {
    this.strings.push(s);
    return this;
};

StringBuilder.prototype.toString = function () {
    return this.strings.join("");
};

function DiacriticsUtil() {}

DiacriticsUtil.a_CODE = "a".charCodeAt(0);
DiacriticsUtil.z_CODE = "z".charCodeAt(0);

DiacriticsUtil.makeMatchingRegexp = function (word) {
    var chars = word.toLowerCase();
    var result = new StringBuilder();
    for (var i = 0; i < chars.length; i++) {
        var c = chars.charAt(i);
        var cCode = c.charCodeAt(0);
        if (cCode >= DiacriticsUtil.a_CODE && cCode <= DiacriticsUtil.z_CODE) {
            var ligaturesSubMap = window.DiacriticsUtilConstants.LIGATURES[c];
            var ligatureEnd = i + 1;
            while (ligaturesSubMap != null && ligatureEnd < chars.length) {
                var c2 = chars.charAt(ligatureEnd);
                var c2Code = c2.charCodeAt(0);
                if (c2Code < DiacriticsUtil.a_CODE || c2 > DiacriticsUtil.z_CODE || !ligaturesSubMap[c2]) break;

                // ligature detected
                ligatureEnd++;

                // continue searching for other possible ligatures
                ligaturesSubMap = window.DiacriticsUtilConstants.LIGATURES[c2];
            }
            if (ligatureEnd - i > 1) {
                // found ligatures
                var ligatureSequenceInTheMiddle = ligatureEnd - i > 2 && (i > 0 || ligatureEnd < chars.length);
                if (ligatureSequenceInTheMiddle) result.append('(');
                DiacriticsUtil.appendLigaturesPattern(chars, i, ligatureEnd, result);
                if (ligatureSequenceInTheMiddle) result.append(')');
                i = ligatureEnd - 1;
            } else {
                if (ligaturesSubMap != null && ligatureEnd == chars.length) {
                    if (chars.length > 1) result.append('(');
                    DiacriticsUtil.appendDiacriticsPattern(c, result);

                    for (var e in ligaturesSubMap) {
                        //noinspection JSUnfilteredForInLoop
                        result.append('|').append(ligaturesSubMap[e]);
                    }if (chars.length > 1) result.append(')');
                } else {
                    DiacriticsUtil.appendDiacriticsPatternWithParentheses(c, result);
                }
            }
            continue;
        }

        var charWithoutDiacritics = window.DiacriticsUtilConstants.DIACRITICS_REVERSE_MAP[c];

        if (charWithoutDiacritics) {
            DiacriticsUtil.appendDiacriticsPatternWithParentheses(charWithoutDiacritics, result);
            continue;
        }

        var ligatureExpansion = window.DiacriticsUtilConstants.LIGATURES_REVERSE_MAP[c];
        if (ligatureExpansion) {
            // ligatures matching should be diacritics insensitive too, so we need to match all variants
            result.append('(').append(window.DiacriticsUtilConstants.LIGATURES[ligatureExpansion.charAt(0)][ligatureExpansion.charAt(1)]).append("|(").append(ligatureExpansion).append("))");
            continue;
        }

        result.append(_RegExpSpecialSymbols2.default.escapeRegexpSpecialSymbols(c));
    }

    return result.toString();
};

DiacriticsUtil.appendLigaturesPattern = function (chars, fromIdx, toIdx, pattern) {
    if (toIdx - fromIdx == 1) // one char
        {
            DiacriticsUtil.appendDiacriticsPatternWithParentheses(chars.charAt(toIdx - 1), pattern);
        } else if (toIdx - fromIdx == 2) // one possible ligature
        {
            DiacriticsUtil.appendLigaturePattern(chars, fromIdx, pattern);
        } else if (toIdx - fromIdx > 10) // two many possible ligatures, this may cause OutOfMemoryError
        {
            DiacriticsUtil.appendApproximateRegex(chars, fromIdx, toIdx, pattern);
        } else {
        for (var i = fromIdx; i < toIdx - 1; i++) {
            pattern.append('(');
            if (i > fromIdx) DiacriticsUtil.appendInternalLigaturesPattern(chars, fromIdx, i, pattern);
            DiacriticsUtil.appendLigaturePattern(chars, i, pattern);
            if (i + 2 < toIdx) DiacriticsUtil.appendInternalLigaturesPattern(chars, i + 2, toIdx, pattern);
            pattern.append(')');
            if (i + 2 < toIdx) pattern.append('|');
        }
    }
};

DiacriticsUtil.appendApproximateRegex = function (chars, fromIdx, toIdx, buf) {
    var idx = fromIdx;
    var uniqueChars = {};
    uniqueChars[chars.charAt(idx)] = true;
    var ligaturesSubMap = window.DiacriticsUtilConstants.LIGATURES[chars.charAt(idx)];
    while (++idx < toIdx) {
        uniqueChars[chars.charAt(idx)] = true;
        if (ligaturesSubMap) {
            var ligatures = ligaturesSubMap[chars.charAt(idx)];
            if (ligatures) uniqueChars[ligatures] = true;
        }
        ligaturesSubMap = window.DiacriticsUtilConstants.LIGATURES[chars.charAt(idx)];
    }
    buf.append('[');

    for (var str in uniqueChars) {
        //noinspection JSUnfilteredForInLoop
        buf.append(str);
    }buf.append("]{").append(Math.ceil((toIdx - fromIdx) / 2)).append(',').append(toIdx - fromIdx).append("}");
};

DiacriticsUtil.appendInternalLigaturesPattern = function (chars, fromIdx, toIdx, buf) {
    if (toIdx - fromIdx > 2) buf.append('(');
    DiacriticsUtil.appendLigaturesPattern(chars, fromIdx, toIdx, buf);
    if (toIdx - fromIdx > 2) buf.append(')');
};

DiacriticsUtil.appendLigaturePattern = function (chars, ligatureIdx, buf) {
    var ligatureSubMap = window.DiacriticsUtilConstants.LIGATURES[chars.charAt(ligatureIdx)];
    if (!ligatureSubMap) return false;
    var ligaturePattern = ligatureSubMap[chars.charAt(ligatureIdx + 1)];
    if (!ligaturePattern) return false;
    buf.append("(").append(ligaturePattern).append("|(");
    DiacriticsUtil.appendDiacriticsPatternWithParentheses(chars.charAt(ligatureIdx), buf);
    if (chars.charAt(ligatureIdx + 1) == chars.charAt(ligatureIdx)) buf.append("{2}");else DiacriticsUtil.appendDiacriticsPatternWithParentheses(chars.charAt(ligatureIdx + 1), buf);
    buf.append("))");
    return true;
};

DiacriticsUtil.appendDiacriticsPatternWithParentheses = function (charWithoutDiacritics, buf) {
    buf.append('(');
    DiacriticsUtil.appendDiacriticsPattern(charWithoutDiacritics, buf);
    buf.append(')');
};

DiacriticsUtil.appendDiacriticsPattern = function (charWithoutDiacritics, buf) {
    buf.append(charWithoutDiacritics).append('|').append(DiacriticsUtil.getDiacriticsPattern(charWithoutDiacritics));
};

DiacriticsUtil.getDiacriticsPattern = function (charWithoutDiacritics) {
    return window.DiacriticsUtilConstants.DIACRITICS[charWithoutDiacritics.charCodeAt(0) - DiacriticsUtil.a_CODE];
};

/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var BulkOperationType = exports.BulkOperationType = {
    COPY: 'copy',
    MOVE: 'move',
    CHANGE_STATUS: 'changeStatus',
    CHANGE_ASSIGNMENTS: 'changeAssignments',
    DELETE: 'delete'
};

/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = function (_ref) {
    var _handlers;

    var _ref$actionTypes = _ref.actionTypes,
        NEW_COMMENTS_ADD = _ref$actionTypes.NEW_COMMENTS_ADD,
        OLD_COMMENTS_ADD = _ref$actionTypes.OLD_COMMENTS_ADD,
        COMMENTS_INFO_CLEAR = _ref$actionTypes.COMMENTS_INFO_CLEAR,
        CHANGE_COMMENTS_ORDER = _ref$actionTypes.CHANGE_COMMENTS_ORDER,
        COMMENTS_LOADED_SET = _ref$actionTypes.COMMENTS_LOADED_SET,
        COMMENTS_LOADING_SET = _ref$actionTypes.COMMENTS_LOADING_SET,
        SENDING_COMMENT_SET = _ref$actionTypes.SENDING_COMMENT_SET,
        RECENTLY_ADDED_COMMENTS_ADD = _ref$actionTypes.RECENTLY_ADDED_COMMENTS_ADD,
        RECENTLY_ADDED_COMMENTS_REMOVE = _ref$actionTypes.RECENTLY_ADDED_COMMENTS_REMOVE,
        COMMENTS_SCROLL_TO_SET = _ref$actionTypes.COMMENTS_SCROLL_TO_SET,
        COMMENT_REMOVE = _ref$actionTypes.COMMENT_REMOVE,
        EDITING_COMMENT_ID_SET = _ref$actionTypes.EDITING_COMMENT_ID_SET,
        EDITING_COMMENT_TEXT_SET = _ref$actionTypes.EDITING_COMMENT_TEXT_SET,
        UPDATE_COMMENT = _ref$actionTypes.UPDATE_COMMENT,
        UPDATING_COMMENT_ID_SET = _ref$actionTypes.UPDATING_COMMENT_ID_SET,
        SHOW_NEW_COMMENT_INPUT_SET = _ref$actionTypes.SHOW_NEW_COMMENT_INPUT_SET,
        NEW_COMMENT_SET = _ref$actionTypes.NEW_COMMENT_SET,
        NEW_COMMENT_REMOVE = _ref$actionTypes.NEW_COMMENT_REMOVE,
        _ref$initAppData = _ref.initAppData,
        initAppData = _ref$initAppData === undefined ? {} : _ref$initAppData;


    var newCommentsTexts = initAppData.newCommentsTexts ? initAppData.newCommentsTexts : {};
    var isNewCommentsOnTop = !!initAppData.COMMENTS.IS_NEW_COMMENTS_ON_TOP;

    return {
        initialState: {
            users: {},
            comments: [],
            commentsCount: 0,
            allCommentsUserIds: [],
            isNewCommentsOnTop: isNewCommentsOnTop,
            commentsLoaded: false,
            loading: false,
            recentlyAddedCommentsIds: {},
            commentsScrollTo: null,
            editingCommentId: null,
            editingCommentText: '',
            sendingComment: false,
            updatingCommentId: null,
            showNewCommentInput: false,
            newCommentsTexts: newCommentsTexts
        },
        handlers: (_handlers = {}, _defineProperty(_handlers, NEW_COMMENTS_ADD, function (state, _ref2) {
            var _ref2$payload = _ref2.payload,
                comments = _ref2$payload.comments,
                users = _ref2$payload.users,
                commentsCount = _ref2$payload.commentsCount,
                allCommentsUserIds = _ref2$payload.allCommentsUserIds;
            return _extends({}, state, {
                comments: [].concat(_toConsumableArray(comments), _toConsumableArray(state.comments)),
                users: _extends({}, state.users, (0, _atUtils.arrayToMap)(users)),
                commentsCount: commentsCount,
                allCommentsUserIds: allCommentsUserIds
            });
        }), _defineProperty(_handlers, OLD_COMMENTS_ADD, function (state, _ref3) {
            var _ref3$payload = _ref3.payload,
                comments = _ref3$payload.comments,
                users = _ref3$payload.users,
                commentsCount = _ref3$payload.commentsCount,
                allCommentsUserIds = _ref3$payload.allCommentsUserIds;
            return _extends({}, state, {
                comments: [].concat(_toConsumableArray(state.comments), _toConsumableArray(comments)),
                users: _extends({}, state.users, (0, _atUtils.arrayToMap)(users)),
                commentsCount: commentsCount,
                allCommentsUserIds: allCommentsUserIds
            });
        }), _defineProperty(_handlers, UPDATE_COMMENT, function (state, _ref4) {
            var comment = _ref4.payload;

            return _extends({}, state, {
                comments: state.comments.map(function (c) {
                    return c.id === comment.id ? comment : c;
                })
            });
        }), _defineProperty(_handlers, COMMENTS_INFO_CLEAR, function (state) {
            return _extends({}, state, {
                comments: [],
                users: {},
                commentsCount: 0,
                allCommentsUserIds: [],
                commentsLoaded: false
            });
        }), _defineProperty(_handlers, COMMENT_REMOVE, function (state, _ref5) {
            var commentId = _ref5.payload;
            return _extends({}, state, {
                comments: state.comments.filter(function (c) {
                    return c.id !== commentId;
                })
            });
        }), _defineProperty(_handlers, EDITING_COMMENT_ID_SET, function (state, _ref6) {
            var editingCommentId = _ref6.payload;
            return _extends({}, state, {
                editingCommentId: editingCommentId
            });
        }), _defineProperty(_handlers, EDITING_COMMENT_TEXT_SET, function (state, _ref7) {
            var editingCommentText = _ref7.payload;
            return _extends({}, state, {
                editingCommentText: editingCommentText
            });
        }), _defineProperty(_handlers, CHANGE_COMMENTS_ORDER, function (state, _ref8) {
            var isNewCommentsOnTop = _ref8.payload;
            return _extends({}, state, {
                isNewCommentsOnTop: isNewCommentsOnTop
            });
        }), _defineProperty(_handlers, COMMENTS_LOADED_SET, function (state, _ref9) {
            var commentsLoaded = _ref9.payload;
            return _extends({}, state, {
                commentsLoaded: commentsLoaded
            });
        }), _defineProperty(_handlers, COMMENTS_LOADING_SET, function (state, _ref10) {
            var loading = _ref10.payload;
            return _extends({}, state, {
                loading: loading
            });
        }), _defineProperty(_handlers, SENDING_COMMENT_SET, function (state, _ref11) {
            var sendingComment = _ref11.payload;
            return _extends({}, state, {
                sendingComment: sendingComment
            });
        }), _defineProperty(_handlers, RECENTLY_ADDED_COMMENTS_ADD, function (state, _ref12) {
            var recentlyAddedComments = _ref12.payload;
            return _extends({}, state, {
                recentlyAddedCommentsIds: _extends({}, state.recentlyAddedCommentsIds, (0, _atUtils.arrayToSet)(recentlyAddedComments.map(function (c) {
                    return c.id;
                })))
            });
        }), _defineProperty(_handlers, RECENTLY_ADDED_COMMENTS_REMOVE, function (state, _ref13) {
            var recentlyAddedComments = _ref13.payload;
            return _extends({}, state, {
                recentlyAddedCommentsIds: (0, _atUtils.filterMapByKeys)(state.recentlyAddedCommentsIds, recentlyAddedComments.map(function (c) {
                    return c.id;
                }))
            });
        }), _defineProperty(_handlers, COMMENTS_SCROLL_TO_SET, function (state, _ref14) {
            var commentsScrollTo = _ref14.payload;
            return _extends({}, state, {
                commentsScrollTo: commentsScrollTo
            });
        }), _defineProperty(_handlers, UPDATING_COMMENT_ID_SET, function (state, _ref15) {
            var updatingCommentId = _ref15.payload;
            return _extends({}, state, {
                updatingCommentId: updatingCommentId
            });
        }), _defineProperty(_handlers, SHOW_NEW_COMMENT_INPUT_SET, function (state, _ref16) {
            var showNewCommentInput = _ref16.payload;
            return _extends({}, state, {
                showNewCommentInput: showNewCommentInput
            });
        }), _defineProperty(_handlers, NEW_COMMENT_SET, function (state, _ref17) {
            var _ref17$payload = _ref17.payload,
                entityId = _ref17$payload.entityId,
                text = _ref17$payload.text;
            return _extends({}, state, {
                newCommentsTexts: _extends({}, state.newCommentsTexts, _defineProperty({}, entityId, text))
            });
        }), _defineProperty(_handlers, NEW_COMMENT_REMOVE, function (state, _ref18) {
            var entityId = _ref18.payload;
            return _extends({}, state, {
                newCommentsTexts: (0, _atUtils.filterMapByKey)(state.newCommentsTexts, entityId)
            });
        }), _handlers)
    };
};

var _atUtils = __webpack_require__(5);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var LOADING_SET = exports.LOADING_SET = 'at/panels/user/createPanel/LOADING_SET';
var MANAGE_ASSIGNMENTS_SET = exports.MANAGE_ASSIGNMENTS_SET = 'at/panels/user/createPanel/MANAGE_ASSIGNMENTS_SET';
var CUSTOMERS_COUNT_SET = exports.CUSTOMERS_COUNT_SET = 'at/panels/user/createPanel/CUSTOMERS_COUNT_SET';
var PROJECTS_COUNT_SET = exports.PROJECTS_COUNT_SET = 'at/panels/user/createPanel/PROJECTS_COUNT_SET';
var TASKS_COUNT_SET = exports.TASKS_COUNT_SET = 'at/panels/user/createPanel/TASKS_COUNT_SET';
var CREATE_USER_PANEL_TAB_SET = exports.CREATE_USER_PANEL_TAB_SET = 'at/panels/user/createPanel/CREATE_USER_PANEL_TAB_SET';
var RESET_CREATE_USER_PANEL_STATE = exports.RESET_CREATE_USER_PANEL_STATE = 'at/panels/user/createPanel/RESET_CREATE_USER_PANEL_STATE';
var MANAGE_ASSIGNMENTS_TASKS_ADD = exports.MANAGE_ASSIGNMENTS_TASKS_ADD = 'at/panels/user/createPanel/MANAGE_ASSIGNMENTS_TASKS_ADD';
var SHOW_FUTURE_INVITATION_SET = exports.SHOW_FUTURE_INVITATION_SET = 'at/panels/user/createPanel/SHOW_FUTURE_INVITATION_SET';
var COPY_USER_CHANGED = exports.COPY_USER_CHANGED = 'at/panels/user/createPanel/COPY_USER_CHANGED';
var APPROVERS_BY_GROUPS_SET = exports.APPROVERS_BY_GROUPS_SET = 'at/panels/user/createPanel/APPROVERS_BY_GROUPS_SET';

var TOGGLE_CREATE_USER_PANEL = exports.TOGGLE_CREATE_USER_PANEL = 'at/panels/user/createPanel/TOGGLE_CREATE_USER_PANEL';
var LOADED_SET = exports.LOADED_SET = 'at/panels/user/createPanel/LOADED_SET';

var SAVE_USER = exports.SAVE_USER = 'at/panels/user/createPanel/SAVE_USER';
var SAVE_USER_SUCCESS = exports.SAVE_USER_SUCCESS = 'at/panels/user/createPanel/SAVE_USER_SUCCESS';
var SAVE_USER_FAILURE = exports.SAVE_USER_FAILURE = 'at/panels/user/createPanel/SAVE_USER_FAILURE';

var DEFAULT_USER_INFO_SET = exports.DEFAULT_USER_INFO_SET = 'at/panels/user/createPanel/DEFAULT_USER_INFO_SET';
var DEFAULT_TEAM_ASSIGNMENTS_SET = exports.DEFAULT_TEAM_ASSIGNMENTS_SET = 'at/panels/user/createPanel/DEFAULT_TEAM_ASSIGNMENTS_SET';
var DEFAULT_MANAGE_ASSIGNMENTS_SET = exports.DEFAULT_MANAGE_ASSIGNMENTS_SET = 'at/panels/user/createPanel/DEFAULT_MANAGE_ASSIGNMENTS_SET';

var PASSWORD_VALIDATION_REQUESTED = exports.PASSWORD_VALIDATION_REQUESTED = 'at/panels/user/createPanel/PASSWORD_VALIDATION_REQUESTED';
var PASSWORD_VALIDATION_DONE = exports.PASSWORD_VALIDATION_DONE = 'at/panels/user/createPanel/PASSWORD_VALIDATION_DONE';

/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = function (_ref) {
    var _handlers;

    var _ref$actionTypes = _ref.actionTypes,
        CLEAR = _ref$actionTypes.CLEAR,
        CLEAR_CUSTOMERS = _ref$actionTypes.CLEAR_CUSTOMERS,
        CLEAR_PROJECTS = _ref$actionTypes.CLEAR_PROJECTS,
        CLEAR_TASKS = _ref$actionTypes.CLEAR_TASKS,
        EDITING_USER_ID_SET = _ref$actionTypes.EDITING_USER_ID_SET,
        EDITING_LEVEL_SET = _ref$actionTypes.EDITING_LEVEL_SET,
        LOADED_SET = _ref$actionTypes.LOADED_SET,
        CUSTOMERS_LOADED_SET = _ref$actionTypes.CUSTOMERS_LOADED_SET,
        PROJECTS_LOADED_SET = _ref$actionTypes.PROJECTS_LOADED_SET,
        TASKS_LOADED_SET = _ref$actionTypes.TASKS_LOADED_SET,
        PROJECTS_TASKS_COUNT_CLEAR = _ref$actionTypes.PROJECTS_TASKS_COUNT_CLEAR,
        CUSTOMERS_TASKS_COUNT_CLEAR = _ref$actionTypes.CUSTOMERS_TASKS_COUNT_CLEAR,
        CUSTOMERS_PROJECTS_COUNT_CLEAR = _ref$actionTypes.CUSTOMERS_PROJECTS_COUNT_CLEAR,
        LOAD_CUSTOMER_ASSIGNMENTS_EDITOR_DATA = _ref$actionTypes.LOAD_CUSTOMER_ASSIGNMENTS_EDITOR_DATA,
        LOAD_CUSTOMER_ASSIGNMENTS_EDITOR_DATA_SUCCESS = _ref$actionTypes.LOAD_CUSTOMER_ASSIGNMENTS_EDITOR_DATA_SUCCESS,
        LOAD_CUSTOMER_ASSIGNMENTS_EDITOR_DATA_FAILURE = _ref$actionTypes.LOAD_CUSTOMER_ASSIGNMENTS_EDITOR_DATA_FAILURE,
        LOAD_PROJECT_ASSIGNMENTS_EDITOR_DATA = _ref$actionTypes.LOAD_PROJECT_ASSIGNMENTS_EDITOR_DATA,
        LOAD_PROJECT_ASSIGNMENTS_EDITOR_DATA_SUCCESS = _ref$actionTypes.LOAD_PROJECT_ASSIGNMENTS_EDITOR_DATA_SUCCESS,
        LOAD_PROJECT_ASSIGNMENTS_EDITOR_DATA_FAILURE = _ref$actionTypes.LOAD_PROJECT_ASSIGNMENTS_EDITOR_DATA_FAILURE,
        LOAD_TASK_ASSIGNMENTS_EDITOR_DATA = _ref$actionTypes.LOAD_TASK_ASSIGNMENTS_EDITOR_DATA,
        LOAD_TASK_ASSIGNMENTS_EDITOR_DATA_SUCCESS = _ref$actionTypes.LOAD_TASK_ASSIGNMENTS_EDITOR_DATA_SUCCESS,
        LOAD_TASK_ASSIGNMENTS_EDITOR_DATA_FAILURE = _ref$actionTypes.LOAD_TASK_ASSIGNMENTS_EDITOR_DATA_FAILURE,
        CHANGE_CUSTOMER_ASSIGNMENT = _ref$actionTypes.CHANGE_CUSTOMER_ASSIGNMENT,
        CHANGE_CUSTOMER_ASSIGNMENT_SUCCESS = _ref$actionTypes.CHANGE_CUSTOMER_ASSIGNMENT_SUCCESS,
        CHANGE_CUSTOMER_ASSIGNMENT_FAILURE = _ref$actionTypes.CHANGE_CUSTOMER_ASSIGNMENT_FAILURE,
        CHANGE_PROJECT_ASSIGNMENT = _ref$actionTypes.CHANGE_PROJECT_ASSIGNMENT,
        CHANGE_PROJECT_ASSIGNMENT_SUCCESS = _ref$actionTypes.CHANGE_PROJECT_ASSIGNMENT_SUCCESS,
        CHANGE_PROJECT_ASSIGNMENT_FAILURE = _ref$actionTypes.CHANGE_PROJECT_ASSIGNMENT_FAILURE,
        CHANGE_TASK_ASSIGNMENT = _ref$actionTypes.CHANGE_TASK_ASSIGNMENT,
        CHANGE_TASK_ASSIGNMENT_SUCCESS = _ref$actionTypes.CHANGE_TASK_ASSIGNMENT_SUCCESS,
        CHANGE_TASK_ASSIGNMENT_FAILURE = _ref$actionTypes.CHANGE_TASK_ASSIGNMENT_FAILURE,
        ASSIGN_ALL_CUSTOMERS = _ref$actionTypes.ASSIGN_ALL_CUSTOMERS,
        ASSIGN_ALL_CUSTOMERS_SUCCESS = _ref$actionTypes.ASSIGN_ALL_CUSTOMERS_SUCCESS,
        ASSIGN_ALL_CUSTOMERS_FAILURE = _ref$actionTypes.ASSIGN_ALL_CUSTOMERS_FAILURE,
        UNASSIGN_ALL_CUSTOMERS = _ref$actionTypes.UNASSIGN_ALL_CUSTOMERS,
        UNASSIGN_ALL_CUSTOMERS_SUCCESS = _ref$actionTypes.UNASSIGN_ALL_CUSTOMERS_SUCCESS,
        UNASSIGN_ALL_CUSTOMERS_FAILURE = _ref$actionTypes.UNASSIGN_ALL_CUSTOMERS_FAILURE,
        ASSIGN_ALL_PROJECTS = _ref$actionTypes.ASSIGN_ALL_PROJECTS,
        ASSIGN_ALL_PROJECTS_SUCCESS = _ref$actionTypes.ASSIGN_ALL_PROJECTS_SUCCESS,
        ASSIGN_ALL_PROJECTS_FAILURE = _ref$actionTypes.ASSIGN_ALL_PROJECTS_FAILURE,
        UNASSIGN_ALL_PROJECTS = _ref$actionTypes.UNASSIGN_ALL_PROJECTS,
        UNASSIGN_ALL_PROJECTS_SUCCESS = _ref$actionTypes.UNASSIGN_ALL_PROJECTS_SUCCESS,
        UNASSIGN_ALL_PROJECTS_FAILURE = _ref$actionTypes.UNASSIGN_ALL_PROJECTS_FAILURE,
        ASSIGN_ALL_TASKS = _ref$actionTypes.ASSIGN_ALL_TASKS,
        ASSIGN_ALL_TASKS_SUCCESS = _ref$actionTypes.ASSIGN_ALL_TASKS_SUCCESS,
        ASSIGN_ALL_TASKS_FAILURE = _ref$actionTypes.ASSIGN_ALL_TASKS_FAILURE,
        UNASSIGN_ALL_TASKS = _ref$actionTypes.UNASSIGN_ALL_TASKS,
        UNASSIGN_ALL_TASKS_SUCCESS = _ref$actionTypes.UNASSIGN_ALL_TASKS_SUCCESS,
        UNASSIGN_ALL_TASKS_FAILURE = _ref$actionTypes.UNASSIGN_ALL_TASKS_FAILURE,
        CHANGE_ALL_ASSIGNMENTS = _ref$actionTypes.CHANGE_ALL_ASSIGNMENTS,
        CHANGE_ALL_ASSIGNMENTS_SUCCESS = _ref$actionTypes.CHANGE_ALL_ASSIGNMENTS_SUCCESS,
        CHANGE_ALL_ASSIGNMENTS_FAILURE = _ref$actionTypes.CHANGE_ALL_ASSIGNMENTS_FAILURE,
        CUSTOMERS_SEARCH_OPEN_SET = _ref$actionTypes.CUSTOMERS_SEARCH_OPEN_SET,
        CUSTOMERS_SEARCH_TEXT_SET = _ref$actionTypes.CUSTOMERS_SEARCH_TEXT_SET,
        PROJECTS_SEARCH_OPEN_SET = _ref$actionTypes.PROJECTS_SEARCH_OPEN_SET,
        PROJECTS_SEARCH_TEXT_SET = _ref$actionTypes.PROJECTS_SEARCH_TEXT_SET,
        TASKS_SEARCH_OPEN_SET = _ref$actionTypes.TASKS_SEARCH_OPEN_SET,
        TASKS_SEARCH_TEXT_SET = _ref$actionTypes.TASKS_SEARCH_TEXT_SET;

    return {
        initialState: {
            editingUserId: null,
            editingLevel: {
                customerId: null,
                projectId: null
            },
            customerIdsOrder: [],
            projectIdsOrder: [],
            taskIdsOrder: [],
            canManageParentCustomer: false,
            canManageParentProject: false,
            canWorkCustomerIds: {},
            canManageCustomerIds: {},
            canManageCustomerExcludeSelfIds: {},
            canWorkProjectIds: {},
            canManageProjectIds: {},
            canManageProjectExcludeSelfIds: {},
            canWorkTaskIds: {},
            canManageTaskIds: {},
            projectCountsByCustomers: {},
            taskCountsByCustomers: {},
            taskCountsByProjects: {},
            futureCustomersAssigned: false,
            someCustomersOrLowerAssigned: false,
            allCustomersAssigned: false,
            futureProjectsAssigned: false,
            someProjectsOrLowerAssigned: false,
            allProjectsAssigned: false,
            futureTasksAssigned: false,
            someTasksAssigned: false,
            allTasksAssigned: false,
            loading: false,
            loaded: false,
            customersLoaded: false,
            projectsLoaded: false,
            tasksLoaded: false,
            changingCustomerAssignments: {},
            changingProjectAssignments: {},
            changingTaskAssignments: {},
            customersSearchOpen: false,
            customersSearchText: '',
            projectsSearchOpen: false,
            projectsSearchText: '',
            tasksSearchOpen: false,
            tasksSearchText: '',
            changingAllAssignments: false,
            viewerCanManageCustomerIds: {},
            viewerCanManageProjectIds: {}
        },
        handlers: (_handlers = {}, _defineProperty(_handlers, LOADED_SET, function (state, _ref2) {
            var loaded = _ref2.payload;
            return _extends({}, state, {
                loaded: loaded
            });
        }), _defineProperty(_handlers, CUSTOMERS_LOADED_SET, function (state, _ref3) {
            var customersLoaded = _ref3.payload;
            return _extends({}, state, {
                customersLoaded: customersLoaded
            });
        }), _defineProperty(_handlers, PROJECTS_LOADED_SET, function (state, _ref4) {
            var projectsLoaded = _ref4.payload;
            return _extends({}, state, {
                projectsLoaded: projectsLoaded
            });
        }), _defineProperty(_handlers, TASKS_LOADED_SET, function (state, _ref5) {
            var tasksLoaded = _ref5.payload;
            return _extends({}, state, {
                tasksLoaded: tasksLoaded
            });
        }), _defineProperty(_handlers, CLEAR, function (state) {
            return _extends({}, state, {
                editingLevel: {
                    customerId: null,
                    projectId: null
                },
                customerIdsOrder: [],
                projectIdsOrder: [],
                taskIdsOrder: [],
                canWorkCustomerIds: {},
                canManageCustomerIds: {},
                canManageCustomerExcludeSelfIds: {},
                canWorkProjectIds: {},
                canManageProjectIds: {},
                canManageProjectExcludeSelfIds: {},
                canWorkTaskIds: {},
                canManageTaskIds: {},
                projectCountsByCustomers: {},
                taskCountsByCustomers: {},
                taskCountsByProjects: {},
                loading: false,
                customersSearchOpen: false,
                customersSearchText: '',
                projectsSearchOpen: false,
                projectsSearchText: '',
                tasksSearchOpen: false,
                tasksSearchText: '',
                canManageParentCustomer: false,
                canManageParentProject: false
            });
        }), _defineProperty(_handlers, CLEAR_CUSTOMERS, function (state) {
            return _extends({}, state, {
                customerIdsOrder: [],
                canManageCustomerIds: {},
                canManageCustomerExcludeSelfIds: {},
                canWorkCustomerIds: {},
                projectCountsByCustomers: {},
                taskCountsByCustomers: {},
                futureCustomersAssigned: false,
                allCustomersAssigned: false,
                someCustomersOrLowerAssigned: false,
                customersLoaded: false
            });
        }), _defineProperty(_handlers, CLEAR_PROJECTS, function (state) {
            return _extends({}, state, {
                projectIdsOrder: [],
                canManageProjectIds: {},
                canManageProjectExcludeSelfIds: {},
                canWorkProjectIds: {},
                taskCountsByProjects: {},
                futureProjectsAssigned: false,
                allProjectsAssigned: false,
                someProjectsOrLowerAssigned: false,
                projectsLoaded: false,
                canManageParentCustomer: false
            });
        }), _defineProperty(_handlers, CLEAR_TASKS, function (state) {
            return _extends({}, state, {
                taskIdsOrder: [],
                canManageTaskIds: {},
                canWorkTaskIds: {},
                futureTasksAssigned: false,
                allTasksAssigned: false,
                someTasksAssigned: false,
                tasksLoaded: false,
                canManageParentCustomer: false,
                canManageParentProject: false
            });
        }), _defineProperty(_handlers, EDITING_USER_ID_SET, function (state, _ref6) {
            var editingUserId = _ref6.payload;
            return _extends({}, state, {
                editingUserId: editingUserId
            });
        }), _defineProperty(_handlers, EDITING_LEVEL_SET, function (state, _ref7) {
            var editingLevel = _ref7.payload;
            return _extends({}, state, {
                editingLevel: _extends({}, state.editingLevel, editingLevel)
            });
        }), _defineProperty(_handlers, CUSTOMERS_SEARCH_OPEN_SET, function (state, _ref8) {
            var customersSearchOpen = _ref8.payload;
            return _extends({}, state, {
                customersSearchOpen: customersSearchOpen
            });
        }), _defineProperty(_handlers, CUSTOMERS_SEARCH_TEXT_SET, function (state, _ref9) {
            var customersSearchText = _ref9.payload;
            return _extends({}, state, {
                customersSearchText: customersSearchText
            });
        }), _defineProperty(_handlers, PROJECTS_SEARCH_OPEN_SET, function (state, _ref10) {
            var projectsSearchOpen = _ref10.payload;
            return _extends({}, state, {
                projectsSearchOpen: projectsSearchOpen
            });
        }), _defineProperty(_handlers, PROJECTS_SEARCH_TEXT_SET, function (state, _ref11) {
            var projectsSearchText = _ref11.payload;
            return _extends({}, state, {
                projectsSearchText: projectsSearchText
            });
        }), _defineProperty(_handlers, TASKS_SEARCH_OPEN_SET, function (state, _ref12) {
            var tasksSearchOpen = _ref12.payload;
            return _extends({}, state, {
                tasksSearchOpen: tasksSearchOpen
            });
        }), _defineProperty(_handlers, TASKS_SEARCH_TEXT_SET, function (state, _ref13) {
            var tasksSearchText = _ref13.payload;
            return _extends({}, state, {
                tasksSearchText: tasksSearchText
            });
        }), _defineProperty(_handlers, PROJECTS_TASKS_COUNT_CLEAR, function (state, _ref14) {
            var projectIds = _ref14.payload;
            return _extends({}, state, {
                taskCountsByProjects: (0, _atUtils.filterMapByKeys)(state.taskCountsByProjects, projectIds)
            });
        }), _defineProperty(_handlers, CUSTOMERS_TASKS_COUNT_CLEAR, function (state, _ref15) {
            var customerIds = _ref15.payload;
            return _extends({}, state, {
                taskCountsByCustomers: (0, _atUtils.filterMapByKeys)(state.taskCountsByCustomers, customerIds)
            });
        }), _defineProperty(_handlers, CUSTOMERS_PROJECTS_COUNT_CLEAR, function (state, _ref16) {
            var customerIds = _ref16.payload;
            return _extends({}, state, {
                projectCountsByCustomers: (0, _atUtils.filterMapByKeys)(state.projectCountsByCustomers, customerIds)
            });
        }), _defineProperty(_handlers, (0, _reduxActions.combineActions)(LOAD_CUSTOMER_ASSIGNMENTS_EDITOR_DATA, LOAD_PROJECT_ASSIGNMENTS_EDITOR_DATA, LOAD_TASK_ASSIGNMENTS_EDITOR_DATA), function (state) {
            return _extends({}, state, {
                loading: true
            });
        }), _defineProperty(_handlers, (0, _reduxActions.combineActions)(LOAD_CUSTOMER_ASSIGNMENTS_EDITOR_DATA_FAILURE, LOAD_PROJECT_ASSIGNMENTS_EDITOR_DATA_FAILURE, LOAD_TASK_ASSIGNMENTS_EDITOR_DATA_FAILURE), function (state) {
            return _extends({}, state, {
                loading: false
            });
        }), _defineProperty(_handlers, LOAD_CUSTOMER_ASSIGNMENTS_EDITOR_DATA_SUCCESS, function (state, _ref17) {
            var _ref17$payload = _ref17.payload,
                customerIds = _ref17$payload.customerIds,
                canWorkCustomerIds = _ref17$payload.canWorkCustomerIds,
                canManageCustomerIds = _ref17$payload.canManageCustomerIds,
                canManageCustomerExcludeSelfIds = _ref17$payload.canManageCustomerExcludeSelfIds,
                projectCounts = _ref17$payload.projectCounts,
                taskCounts = _ref17$payload.taskCounts,
                futureCustomersAssigned = _ref17$payload.futureCustomersAssigned,
                someCustomersOrLowerAssigned = _ref17$payload.someCustomersOrLowerAssigned,
                allCustomersAssigned = _ref17$payload.allCustomersAssigned,
                viewerCanManageCustomerIds = _ref17$payload.viewerCanManageCustomerIds;
            return _extends({}, state, {
                customerIdsOrder: [].concat(_toConsumableArray(state.customerIdsOrder), _toConsumableArray(customerIds)),
                canWorkCustomerIds: _extends({}, state.canWorkCustomerIds, (0, _atUtils.arrayToSet)(canWorkCustomerIds)),
                canManageCustomerIds: _extends({}, state.canManageCustomerIds, (0, _atUtils.arrayToSet)(canManageCustomerIds)),
                canManageCustomerExcludeSelfIds: _extends({}, state.canManageCustomerExcludeSelfIds, (0, _atUtils.arrayToSet)(canManageCustomerExcludeSelfIds)),
                projectCountsByCustomers: _extends({}, state.projectCountsByCustomers, projectCounts),
                taskCountsByCustomers: _extends({}, state.taskCountsByCustomers, taskCounts),
                futureCustomersAssigned: futureCustomersAssigned,
                someCustomersOrLowerAssigned: someCustomersOrLowerAssigned,
                allCustomersAssigned: allCustomersAssigned,
                loading: false,
                viewerCanManageCustomerIds: _extends({}, state.viewerCanManageCustomerIds, (0, _atUtils.arrayToSet)(viewerCanManageCustomerIds))
            });
        }), _defineProperty(_handlers, LOAD_PROJECT_ASSIGNMENTS_EDITOR_DATA_SUCCESS, function (state, _ref18) {
            var _ref18$payload = _ref18.payload,
                canManageParentCustomer = _ref18$payload.canManageParentCustomer,
                projectIds = _ref18$payload.projectIds,
                canWorkProjectIds = _ref18$payload.canWorkProjectIds,
                canManageProjectIds = _ref18$payload.canManageProjectIds,
                canManageProjectExcludeSelfIds = _ref18$payload.canManageProjectExcludeSelfIds,
                taskCounts = _ref18$payload.taskCounts,
                futureProjectsAssigned = _ref18$payload.futureProjectsAssigned,
                someProjectsOrLowerAssigned = _ref18$payload.someProjectsOrLowerAssigned,
                allProjectsAssigned = _ref18$payload.allProjectsAssigned,
                viewerCanManageProjectIds = _ref18$payload.viewerCanManageProjectIds;
            return _extends({}, state, {
                canManageParentCustomer: canManageParentCustomer,
                projectIdsOrder: [].concat(_toConsumableArray(state.projectIdsOrder), _toConsumableArray(projectIds)),
                canWorkProjectIds: _extends({}, state.canWorkProjectIds, (0, _atUtils.arrayToSet)(canWorkProjectIds)),
                canManageProjectIds: _extends({}, state.canManageProjectIds, (0, _atUtils.arrayToSet)(canManageProjectIds)),
                canManageProjectExcludeSelfIds: _extends({}, state.canManageProjectExcludeSelfIds, (0, _atUtils.arrayToSet)(canManageProjectExcludeSelfIds)),
                taskCountsByProjects: _extends({}, state.taskCountsByProjects, taskCounts),
                futureProjectsAssigned: futureProjectsAssigned,
                someProjectsOrLowerAssigned: someProjectsOrLowerAssigned,
                allProjectsAssigned: allProjectsAssigned,
                loading: false,
                viewerCanManageProjectIds: _extends({}, state.viewerCanManageProjectIds, (0, _atUtils.arrayToSet)(viewerCanManageProjectIds))
            });
        }), _defineProperty(_handlers, LOAD_TASK_ASSIGNMENTS_EDITOR_DATA_SUCCESS, function (state, _ref19) {
            var _ref19$payload = _ref19.payload,
                canManageParentCustomer = _ref19$payload.canManageParentCustomer,
                canManageParentProject = _ref19$payload.canManageParentProject,
                taskIds = _ref19$payload.taskIds,
                canWorkTaskIds = _ref19$payload.canWorkTaskIds,
                canManageTaskIds = _ref19$payload.canManageTaskIds,
                futureTasksAssigned = _ref19$payload.futureTasksAssigned,
                someTasksAssigned = _ref19$payload.someTasksAssigned,
                allTasksAssigned = _ref19$payload.allTasksAssigned;
            return _extends({}, state, {
                canManageParentCustomer: canManageParentCustomer,
                canManageParentProject: canManageParentProject,
                taskIdsOrder: [].concat(_toConsumableArray(state.taskIdsOrder), _toConsumableArray(taskIds)),
                canWorkTaskIds: _extends({}, state.canWorkTaskIds, (0, _atUtils.arrayToSet)(canWorkTaskIds)),
                canManageTaskIds: _extends({}, state.canManageTaskIds, (0, _atUtils.arrayToSet)(canManageTaskIds)),
                futureTasksAssigned: futureTasksAssigned,
                someTasksAssigned: someTasksAssigned,
                allTasksAssigned: allTasksAssigned,
                loading: false
            });
        }), _defineProperty(_handlers, CHANGE_CUSTOMER_ASSIGNMENT, function (state, _ref20) {
            var customerId = _ref20.payload.customerId;
            return _extends({}, state, {
                changingCustomerAssignments: _extends({}, state.changingCustomerAssignments, _defineProperty({}, customerId, true))
            });
        }), _defineProperty(_handlers, CHANGE_CUSTOMER_ASSIGNMENT_SUCCESS, function (state, _ref21) {
            var _ref21$payload = _ref21.payload,
                customerId = _ref21$payload.customerId,
                canWork = _ref21$payload.canWork,
                canManage = _ref21$payload.canManage,
                someAssigned = _ref21$payload.someAssigned,
                allAssigned = _ref21$payload.allAssigned;
            return _extends({}, state, {
                canWorkCustomerIds: _extends({}, state.canWorkCustomerIds, _defineProperty({}, customerId, canWork)),
                canManageCustomerIds: _extends({}, state.canManageCustomerIds, _defineProperty({}, customerId, canManage)),
                canManageCustomerExcludeSelfIds: (0, _atUtils.filterMapByKey)(state.canManageCustomerExcludeSelfIds, customerId),
                changingCustomerAssignments: (0, _atUtils.filterMapByKey)(state.changingCustomerAssignments, customerId),
                someCustomersOrLowerAssigned: someAssigned,
                allCustomersAssigned: allAssigned
            });
        }), _defineProperty(_handlers, CHANGE_CUSTOMER_ASSIGNMENT_FAILURE, function (state, _ref22) {
            var customerId = _ref22.payload.customerId;
            return _extends({}, state, {
                changingCustomerAssignments: (0, _atUtils.filterMapByKey)(state.changingCustomerAssignments, customerId)
            });
        }), _defineProperty(_handlers, ASSIGN_ALL_CUSTOMERS_SUCCESS, function (state, _ref23) {
            var _ref23$payload = _ref23.payload,
                canManageCustomerIds = _ref23$payload.canManageCustomerIds,
                allCustomersAssigned = _ref23$payload.allCustomersAssigned,
                someCustomersOrLowerAssigned = _ref23$payload.someCustomersOrLowerAssigned;
            return _extends({}, state, {
                canManageCustomerIds: canManageCustomerIds,
                allCustomersAssigned: allCustomersAssigned,
                someCustomersOrLowerAssigned: someCustomersOrLowerAssigned,
                canManageCustomerExcludeSelfIds: {}
            });
        }), _defineProperty(_handlers, CHANGE_PROJECT_ASSIGNMENT, function (state, _ref24) {
            var projectId = _ref24.payload.projectId;
            return _extends({}, state, {
                changingProjectAssignments: _extends({}, state.changingProjectAssignments, _defineProperty({}, projectId, true))
            });
        }), _defineProperty(_handlers, CHANGE_PROJECT_ASSIGNMENT_SUCCESS, function (state, _ref25) {
            var _ref25$payload = _ref25.payload,
                projectId = _ref25$payload.projectId,
                canWork = _ref25$payload.canWork,
                canManage = _ref25$payload.canManage,
                someAssigned = _ref25$payload.someAssigned,
                allAssigned = _ref25$payload.allAssigned;
            return _extends({}, state, {
                canWorkProjectIds: _extends({}, state.canWorkProjectIds, _defineProperty({}, projectId, canWork)),
                canManageProjectIds: _extends({}, state.canManageProjectIds, _defineProperty({}, projectId, canManage)),
                canManageProjectExcludeSelfIds: (0, _atUtils.filterMapByKey)(state.canManageProjectExcludeSelfIds, projectId),
                changingProjectAssignments: (0, _atUtils.filterMapByKey)(state.changingProjectAssignments, projectId),
                someProjectsOrLowerAssigned: someAssigned,
                allProjectsAssigned: allAssigned
            });
        }), _defineProperty(_handlers, CHANGE_PROJECT_ASSIGNMENT_FAILURE, function (state, _ref26) {
            var projectId = _ref26.payload.projectId;
            return _extends({}, state, {
                changingProjectAssignments: (0, _atUtils.filterMapByKey)(state.changingProjectAssignments, projectId)
            });
        }), _defineProperty(_handlers, ASSIGN_ALL_PROJECTS_SUCCESS, function (state, _ref27) {
            var _ref27$payload = _ref27.payload,
                canManageProjectIds = _ref27$payload.canManageProjectIds,
                allProjectsAssigned = _ref27$payload.allProjectsAssigned,
                someProjectsOrLowerAssigned = _ref27$payload.someProjectsOrLowerAssigned;
            return _extends({}, state, {
                canManageProjectIds: canManageProjectIds,
                allProjectsAssigned: allProjectsAssigned,
                someProjectsOrLowerAssigned: someProjectsOrLowerAssigned,
                canManageProjectExcludeSelfIds: {}
            });
        }), _defineProperty(_handlers, CHANGE_TASK_ASSIGNMENT, function (state, _ref28) {
            var taskId = _ref28.payload.taskId;
            return _extends({}, state, {
                changingTaskAssignments: _extends({}, state.changingTaskAssignments, _defineProperty({}, taskId, true))
            });
        }), _defineProperty(_handlers, CHANGE_TASK_ASSIGNMENT_SUCCESS, function (state, _ref29) {
            var _ref29$payload = _ref29.payload,
                taskId = _ref29$payload.taskId,
                canWork = _ref29$payload.canWork,
                canManage = _ref29$payload.canManage,
                someAssigned = _ref29$payload.someAssigned,
                allAssigned = _ref29$payload.allAssigned;
            return _extends({}, state, {
                canWorkTaskIds: _extends({}, state.canWorkTaskIds, _defineProperty({}, taskId, canWork)),
                canManageTaskIds: _extends({}, state.canManageTaskIds, _defineProperty({}, taskId, canManage)),
                changingTaskAssignments: (0, _atUtils.filterMapByKey)(state.changingTaskAssignments, taskId),
                someTasksAssigned: someAssigned,
                allTasksAssigned: allAssigned
            });
        }), _defineProperty(_handlers, CHANGE_TASK_ASSIGNMENT_FAILURE, function (state, _ref30) {
            var taskId = _ref30.payload.taskId;
            return _extends({}, state, {
                changingTaskAssignments: (0, _atUtils.filterMapByKey)(state.changingTaskAssignments, taskId)
            });
        }), _defineProperty(_handlers, ASSIGN_ALL_TASKS_SUCCESS, function (state, _ref31) {
            var _ref31$payload = _ref31.payload,
                canManageTaskIds = _ref31$payload.canManageTaskIds,
                allTasksAssigned = _ref31$payload.allTasksAssigned,
                someTasksAssigned = _ref31$payload.someTasksAssigned;
            return _extends({}, state, {
                canManageTaskIds: canManageTaskIds,
                allTasksAssigned: allTasksAssigned,
                someTasksAssigned: someTasksAssigned
            });
        }), _defineProperty(_handlers, CHANGE_ALL_ASSIGNMENTS, function (state) {
            return _extends({}, state, {
                changingAllAssignments: true
            });
        }), _defineProperty(_handlers, (0, _reduxActions.combineActions)(CHANGE_ALL_ASSIGNMENTS_SUCCESS, CHANGE_ALL_ASSIGNMENTS_FAILURE), function (state) {
            return _extends({}, state, {
                changingAllAssignments: false
            });
        }), _defineProperty(_handlers, EntitiesActionTypes.CUSTOMERS_REMOVE, function (state, _ref32) {
            var customerIds = _ref32.payload;
            return _extends({}, state, {
                customerIdsOrder: state.customerIdsOrder.filter(function (tId) {
                    return !(0, _atUtils.arrayToSet)(customerIds)[tId];
                }),
                canManageCustomerIds: (0, _atUtils.filterMapByKeys)(state.canManageCustomerIds, customerIds),
                canManageCustomerExcludeSelfIds: {},
                canWorkCustomerIds: (0, _atUtils.filterMapByKeys)(state.canWorkCustomerIds, customerIds),
                changingCustomerAssignments: (0, _atUtils.filterMapByKeys)(state.changingCustomerAssignments, customerIds)
            });
        }), _defineProperty(_handlers, EntitiesActionTypes.PROJECTS_REMOVE, function (state, _ref33) {
            var projectIds = _ref33.payload;
            return _extends({}, state, {
                projectIdsOrder: state.projectIdsOrder.filter(function (tId) {
                    return !(0, _atUtils.arrayToSet)(projectIds)[tId];
                }),
                canManageProjectIds: (0, _atUtils.filterMapByKeys)(state.canManageProjectIds, projectIds),
                canManageProjectExcludeSelfIds: (0, _atUtils.filterMapByKeys)(state.canManageProjectExcludeSelfIds, projectIds),
                canWorkProjectIds: (0, _atUtils.filterMapByKeys)(state.canWorkProjectIds, projectIds),
                changingProjectAssignments: (0, _atUtils.filterMapByKeys)(state.changingProjectAssignments, projectIds)
            });
        }), _defineProperty(_handlers, EntitiesActionTypes.TASKS_REMOVE, function (state, _ref34) {
            var taskIds = _ref34.payload;
            return _extends({}, state, {
                taskIdsOrder: state.taskIdsOrder.filter(function (tId) {
                    return !(0, _atUtils.arrayToSet)(taskIds)[tId];
                }),
                canManageTaskIds: (0, _atUtils.filterMapByKeys)(state.canManageTaskIds, taskIds),
                canWorkTaskIds: (0, _atUtils.filterMapByKeys)(state.canWorkTaskIds, taskIds),
                changingTaskAssignments: (0, _atUtils.filterMapByKeys)(state.changingTaskAssignments, taskIds)
            });
        }), _defineProperty(_handlers, _actionTypes2.CLOSE_ALL_PANELS, function (state) {
            return _extends({}, state, {
                editingUserId: null,
                editingLevel: {
                    customerId: null,
                    projectId: null
                },
                customerIdsOrder: [],
                projectIdsOrder: [],
                taskIdsOrder: [],
                canManageParentCustomer: false,
                canManageParentProject: false,
                canWorkCustomerIds: {},
                canManageCustomerIds: {},
                canWorkProjectIds: {},
                canManageProjectIds: {},
                canManageProjectExcludeSelfIds: {},
                canWorkTaskIds: {},
                canManageTaskIds: {},
                projectCountsByCustomers: {},
                taskCountsByCustomers: {},
                taskCountsByProjects: {},
                futureCustomersAssigned: false,
                someCustomersOrLowerAssigned: false,
                allCustomersAssigned: false,
                futureProjectsAssigned: false,
                someProjectsOrLowerAssigned: false,
                allProjectsAssigned: false,
                futureTasksAssigned: false,
                someTasksAssigned: false,
                allTasksAssigned: false,
                loading: false,
                loaded: false,
                customersLoaded: false,
                projectsLoaded: false,
                tasksLoaded: false,
                changingCustomerAssignments: {},
                changingProjectAssignments: {},
                changingTaskAssignments: {},
                customersSearchOpen: false,
                customersSearchText: '',
                projectsSearchOpen: false,
                projectsSearchText: '',
                tasksSearchOpen: false,
                tasksSearchText: '',
                changingAllAssignments: false
            });
        }), _handlers)
    };
};

var _reduxActions = __webpack_require__(9);

var _atUtils = __webpack_require__(5);

var _actionTypes = __webpack_require__(102);

var EntitiesActionTypes = _interopRequireWildcard(_actionTypes);

var _actionTypes2 = __webpack_require__(104);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var CUSTOM_FIELDS_SET = exports.CUSTOM_FIELDS_SET = 'at/customFields/CUSTOM_FIELDS_SET';

/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _DropdownDialogWithPointerWrapper = __webpack_require__(182);

var _DropdownDialogWithPointerWrapper2 = _interopRequireDefault(_DropdownDialogWithPointerWrapper);

var _PasswordHint = __webpack_require__(1292);

var _PasswordHint2 = _interopRequireDefault(_PasswordHint);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PasswordHintTooltip = function (_DropdownDialogWithPo) {
    _inherits(PasswordHintTooltip, _DropdownDialogWithPo);

    function PasswordHintTooltip(policyManager, options) {
        _classCallCheck(this, PasswordHintTooltip);

        return _possibleConstructorReturn(this, (PasswordHintTooltip.__proto__ || Object.getPrototypeOf(PasswordHintTooltip)).call(this, _extends({
            toggleMode: true,
            dialogOffsets: {
                top: 0, left: 0
            },
            additionalClass: "passwordHintDialog"
        }, options, {
            dialog: new _PasswordHint2.default({ policyManager: policyManager })
        })));
    }

    return PasswordHintTooltip;
}(_DropdownDialogWithPointerWrapper2.default);

exports.default = PasswordHintTooltip;

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var WindowSizeDependedView = function (_TemplateView) {
    _inherits(WindowSizeDependedView, _TemplateView);

    function WindowSizeDependedView() {
        _classCallCheck(this, WindowSizeDependedView);

        return _possibleConstructorReturn(this, (WindowSizeDependedView.__proto__ || Object.getPrototypeOf(WindowSizeDependedView)).apply(this, arguments));
    }

    _createClass(WindowSizeDependedView, [{
        key: "afterRender",
        value: function afterRender() {
            var _this2 = this;

            (0, _jquery2.default)(window).resizeThrottle(function () {
                return _this2.adjustSize();
            }, 100);
            (0, _jquery2.default)(document).on("navigation_resize_event", function () {
                return _this2.adjustSize();
            });
            this.adjustSize();
        }
    }, {
        key: "adjustSize",
        value: function adjustSize() {
            this.$el.adjustHeightToWindowSize();
        }
    }]);

    return WindowSizeDependedView;
}(_TemplateView3.default);

exports.default = WindowSizeDependedView;

/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = BoolTimer;
/**
 * Holds a boolean value which can be switched to another one, but will automatically reset after the specified time.
 *
 * @param {boolean} defaultValue initial (default) value
 * @param {number} time time in milliseconds to hold the new value before reset
 * @constructor
 */
function BoolTimer(defaultValue, time) {
    var value = defaultValue;
    var timeout;

    /**
     * Switches the value to the opposite of the default and sets the timer to reset it back to default.
     */
    this.switchValue = function () {
        value = !defaultValue;

        clearTimeout(timeout);

        timeout = setTimeout(function () {
            value = defaultValue;
        }, time);
    };

    /**
     * @return {Boolean} whether the current value is true
     */
    this.isTrue = function () {
        return value === true;
    };

    /**
     * @return {Boolean} whether the current value is false
     */
    this.isFalse = function () {
        return value === false;
    };
}

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _EntityWithNameStore2 = __webpack_require__(278);

var _EntityWithNameStore3 = _interopRequireDefault(_EntityWithNameStore2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UserStore = function (_EntityWithNameStore) {
    _inherits(UserStore, _EntityWithNameStore);

    function UserStore() {
        _classCallCheck(this, UserStore);

        return _possibleConstructorReturn(this, (UserStore.__proto__ || Object.getPrototypeOf(UserStore)).apply(this, arguments));
    }

    _createClass(UserStore, [{
        key: "getEntityName",
        value: function getEntityName(user) {
            return user.formatNameLFMU();
        }
    }]);

    return UserStore;
}(_EntityWithNameStore3.default);

var userStore = new UserStore();
exports.default = userStore;

/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Pager = __webpack_require__(724);

var _Pager2 = _interopRequireDefault(_Pager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function PagerController() {
    this.constructor = PagerController;
}

/**
 * @param conf must has fields:
 *      .pagerData.pageNum
 *      .pagerData.recordsPerPage
 *      .pagerData.totalRecords
 *      .handlersMap.pageChanged (function(pageNum){})
 *      .handlersMap.recordsPerPageChanged (function(recordsPerPage){})
 *      .pagerControlsElementId
 *      .pagerElementId
 *      .recordsPerPageSelectorId
 *      .minRecordsPerPage
 *      .ignoreHashChange
 */
PagerController.prototype.init = function (_ref) {
    var _ref$pagerData = _ref.pagerData,
        pagerData = _ref$pagerData === undefined ? {
        pageNum: 1,
        recordsPerPage: 1,
        totalRecords: 1
    } : _ref$pagerData,
        _ref$pagerControlsEle = _ref.pagerControlsElementId,
        pagerControlsElementId = _ref$pagerControlsEle === undefined ? '' : _ref$pagerControlsEle,
        _ref$pagerControlsEle2 = _ref.pagerControlsElement,
        pagerControlsElement = _ref$pagerControlsEle2 === undefined ? null : _ref$pagerControlsEle2,
        _ref$minRecordsPerPag = _ref.minRecordsPerPage,
        minRecordsPerPage = _ref$minRecordsPerPag === undefined ? 1 : _ref$minRecordsPerPag,
        _ref$pagerElementId = _ref.pagerElementId,
        pagerElementId = _ref$pagerElementId === undefined ? '' : _ref$pagerElementId,
        _ref$pagerElement = _ref.pagerElement,
        pagerElement = _ref$pagerElement === undefined ? null : _ref$pagerElement,
        _ref$handlersMap = _ref.handlersMap,
        handlersMap = _ref$handlersMap === undefined ? {
        pageChanged: function pageChanged() {},
        recordsPerPageChanged: function recordsPerPageChanged() {}
    } : _ref$handlersMap,
        _ref$locationHashStri = _ref.locationHashString,
        locationHashString = _ref$locationHashStri === undefined ? '' : _ref$locationHashStri,
        _ref$ignoreHashChange = _ref.ignoreHashChange,
        ignoreHashChange = _ref$ignoreHashChange === undefined ? false : _ref$ignoreHashChange,
        _ref$recordsPerPageSe = _ref.recordsPerPageSelectorId,
        recordsPerPageSelectorId = _ref$recordsPerPageSe === undefined ? '' : _ref$recordsPerPageSe,
        _ref$recordsPerPageSe2 = _ref.recordsPerPageSelectorElement,
        recordsPerPageSelectorElement = _ref$recordsPerPageSe2 === undefined ? null : _ref$recordsPerPageSe2;

    this.pageNum = pagerData.pageNum;
    this.recordsPerPage = pagerData.recordsPerPage;
    // validate records per page
    if (this.recordsPerPage < 1) {
        console.warn("Incorrect records per page value: " + this.recordsPerPage);
    }
    this.totalRecords = pagerData.totalRecords;
    this.pagerData = pagerData;
    if (pagerControlsElement !== null) {
        this.pagerControlsElement = pagerControlsElement;
    } else {
        this.pagerControlsElement = document.getElementById(pagerControlsElementId);
    }
    this.minRecordsPerPage = minRecordsPerPage;

    var pagerContentEl = void 0;
    if (pagerElement !== null) {
        pagerContentEl = pagerElement;
    } else {
        pagerContentEl = document.getElementById(pagerElementId);
    }
    this.pager = new _Pager2.default(pagerContentEl, "&nbsp;", "&nbsp;", "...", handlersMap.pageChanged, locationHashString, ignoreHashChange);

    var self = this;
    if (recordsPerPageSelectorElement !== null) {
        this.recordsPerPageSelector = recordsPerPageSelectorElement;
    } else {
        this.recordsPerPageSelector = document.getElementById(recordsPerPageSelectorId);
    }
    this.recordsPerPageSelector.value = this.recordsPerPage;
    this.recordsPerPageSelector.onchange = function () {
        handlersMap.recordsPerPageChanged(self.recordsPerPageSelector.value);
    };

    return this;
};

PagerController.prototype.renderThisController = function () {
    this.render();
};

PagerController.prototype.getPageNum = function () {
    return this.pageNum;
};

PagerController.prototype.getTotalPages = function () {
    return _Pager2.default.getTotalPages(this.totalRecords, this.recordsPerPage);
};

PagerController.prototype.getTotalRecords = function () {
    return this.totalRecords;
};

PagerController.prototype.getRecordsPerPage = function () {
    return this.recordsPerPage;
};

PagerController.prototype.render = function () {
    if (this.totalRecords > this.minRecordsPerPage) {
        this.setRecordsPerPage(this.recordsPerPage);
        this.pagerControlsElement.style.display = "table";

        if (this.getTotalPages() > 1) this.pager.draw(this.totalRecords, this.recordsPerPage, this.pageNum);else this.pager.remove();
    } else {
        this.pagerControlsElement.style.display = "none";
    }
};

PagerController.prototype.setRecordsPerPage = function (value) {
    this.recordsPerPageSelector.value = value;
};

PagerController.prototype.setPagerStateAndUpdateUI = function (totalRecords, pageNum, recordsPerPage) {
    this.totalRecords = totalRecords;
    this.pageNum = pageNum;
    this.recordsPerPage = recordsPerPage;
    this.render();
};

PagerController.prototype.loadPage = function (pageNum) {
    this.pager.loadPage(pageNum);
};

PagerController.prototype.reloadEmptyPage = function () {
    if (this.getTotalPages() == this.getPageNum() && this.getTotalPages() > 1) {
        this.loadPage(this.getPageNum() - 1);
    } else {
        this.loadPage(this.getPageNum());
    }
};

exports.default = PagerController;

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _TriStateCheckboxTreeNodeRenderer = __webpack_require__(726);

var _TriStateCheckboxTreeNodeRenderer2 = _interopRequireDefault(_TriStateCheckboxTreeNodeRenderer);

var _DisabledNodesParentTreeNode = __webpack_require__(283);

var _DisabledNodesParentTreeNode2 = _interopRequireDefault(_DisabledNodesParentTreeNode);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var HierarchySelectorNodeRenderer = function (_TriStateCheckboxTree) {
    _inherits(HierarchySelectorNodeRenderer, _TriStateCheckboxTree);

    function HierarchySelectorNodeRenderer(tree, selectorFilter) {
        _classCallCheck(this, HierarchySelectorNodeRenderer);

        var _this = _possibleConstructorReturn(this, (HierarchySelectorNodeRenderer.__proto__ || Object.getPrototypeOf(HierarchySelectorNodeRenderer)).call(this, tree));

        _this.selectorFilter = selectorFilter;
        _this.disabledClassName = 'disabledNode';
        return _this;
    }

    _createClass(HierarchySelectorNodeRenderer, [{
        key: "updateUI",
        value: function updateUI(treeNode) {
            _get(HierarchySelectorNodeRenderer.prototype.__proto__ || Object.getPrototypeOf(HierarchySelectorNodeRenderer.prototype), "updateUI", this).call(this, treeNode);

            var uiObject = this.tree.getUIObjectForNode(treeNode);
            var shouldUpdateLabel = false;
            if (this.selectorFilter.containsTokens(treeNode)) {
                shouldUpdateLabel = true;
                uiObject.hasHighlight = true;
            } else if (uiObject.hasHighlight) {
                shouldUpdateLabel = true;
                delete uiObject.hasHighlight;
            } else if (treeNode instanceof _DisabledNodesParentTreeNode2.default) {
                shouldUpdateLabel = true;
            }

            if (shouldUpdateLabel) this.updateLabel(treeNode);
        }
    }, {
        key: "getNodeClasses",
        value: function getNodeClasses(treeNode) {
            var classes = _get(HierarchySelectorNodeRenderer.prototype.__proto__ || Object.getPrototypeOf(HierarchySelectorNodeRenderer.prototype), "getNodeClasses", this).call(this, treeNode);
            if (this.isNeedToPushDisabledClass(treeNode)) {
                classes.push(this.getDisabledClassName());
            }
            if (treeNode.children.length === 0 && treeNode.level === 1) {
                classes.push('childlessNode');
            }
            return classes;
        }
    }, {
        key: "isNeedToPushDisabledClass",
        value: function isNeedToPushDisabledClass(treeNode) {
            return false;
        }
    }, {
        key: "getDisabledClassName",
        value: function getDisabledClassName() {
            return this.disabledClassName;
        }
    }, {
        key: "getTitle",
        value: function getTitle(entity) {
            //abstract
        }
    }]);

    return HierarchySelectorNodeRenderer;
}(_TriStateCheckboxTreeNodeRenderer2.default);

exports.default = HierarchySelectorNodeRenderer;

/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TreeNodeRenderer = function () {
    function TreeNodeRenderer(tree) {
        _classCallCheck(this, TreeNodeRenderer);

        this.tree = tree;
    }

    //  abstract


    _createClass(TreeNodeRenderer, [{
        key: "generateContent",
        value: function generateContent(treeNode, targetEl) {}
    }, {
        key: "getNodeClasses",
        value: function getNodeClasses(treeNode) {
            var classes = ["node", this.getSpecificNodeClassName()];

            if (this.tree.getExpandController().isCollapsed(treeNode)) classes.push("collapsed");

            if (this.tree.hasActiveFilter()) {
                if (this.tree.doesMatchFilterCriteria(treeNode)) classes.push("matchesFilterCriteria");
                if (this.tree.doesContainChildrenMatchingFilterCriteria(treeNode)) classes.push("containsChildrenMatchingFilterCriteria");
            }

            var parentTreeNode = treeNode.getParent();
            if (parentTreeNode && parentTreeNode.getChildren().length > 1) classes.push("hasSiblings");

            return classes;
        }

        //  abstract

    }, {
        key: "getSpecificNodeClassName",
        value: function getSpecificNodeClassName() {}
    }, {
        key: "updateUI",
        value: function updateUI(treeNode) {
            var uiObject = this.tree.getUIObjectForNode(treeNode);
            if (uiObject.nodeEl) {
                uiObject.nodeEl.className = this.getNodeClasses(treeNode).join(" ");
            }
        }
    }]);

    return TreeNodeRenderer;
}();

exports.default = TreeNodeRenderer;

/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = FilterWordsPopup;

var _dhtml_popup = __webpack_require__(139);

var _dhtml_popup2 = _interopRequireDefault(_dhtml_popup);

var _atBrowserUtils = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Popup for filter words on user selector
 */
function FilterWordsPopup() {}

FilterWordsPopup.prototype = new _dhtml_popup2.default();

/**
 * @param divId dom id of root element of popup
 * @param relativeButtonId dom id of button relative to popup
 * @param containerId dom id of container where popup and relative button are placed
 * @param canUseContainerIdForPositioning defines if we should use container id for positioning FilterWordsPopup
 * @param innerComponentEl inner component element
 * @param onHideCallback this function will be called right before popup is hidden
 * If passes null it means that there is no container
 */
FilterWordsPopup.prototype.initAndRender = function (divId, relativeButtonId, containerId, canUseContainerIdForPositioning, innerComponentEl, onHideCallback) {
    _dhtml_popup2.default.call(this, divId);

    this.popupId = divId;

    if (canUseContainerIdForPositioning) {
        this.setPositioningStrategy(new _dhtml_popup.ElementRelativeInTheContainerPositioning(relativeButtonId, containerId));
    } else {
        this.setPositioningStrategy(new _dhtml_popup.ElementRelativePositioning(relativeButtonId));
    }

    var context = this;

    var commonDiv = document.createElement("div");
    commonDiv.id = this.popupId;
    commonDiv.className = "filterUsersPopup";
    var filterTable = document.createElement("table");
    filterTable.className = "filterTable";
    var filterTBody = document.createElement("tbody");
    var outerTr = document.createElement("tr");
    var innerComponentOuterTd = document.createElement("td");
    innerComponentOuterTd.className = "filterInputTableCell";
    this.innerComponentOuterTd = innerComponentOuterTd;
    var closeTd = document.createElement("td");
    closeTd.className = "closeFilterPanelButton";
    var closeSpan = document.createElement("span");

    commonDiv.appendChild(filterTable);
    filterTable.appendChild(filterTBody);
    filterTBody.appendChild(outerTr);
    outerTr.appendChild(innerComponentOuterTd);
    outerTr.appendChild(closeTd);
    innerComponentOuterTd.appendChild(innerComponentEl);
    closeTd.appendChild(closeSpan);

    document.getElementById(containerId).appendChild(commonDiv);

    this.closeButton = closeSpan;
    this.closeButton.onmouseover = function () {
        (0, _atBrowserUtils.addClass)(this, "hoverButton");
    };
    this.closeButton.onmouseout = function () {
        (0, _atBrowserUtils.removeClass)(this, "hoverButton");
    };
    this.closeButton.onclick = function () {
        context.hide();
    };

    this.innerComponentOuterTd.onkeyup = function (e) {
        if (context.isHideByEscape(e)) {
            (0, _atBrowserUtils.cancelBubble)(e);
            context.hide();
        }
    };

    this.shown = false;
    this.onHideCallback = onHideCallback;

    return this;
};

FilterWordsPopup.prototype.hide = function () {
    this.onHideCallback();
    _dhtml_popup2.default.prototype.hide.call(this);
    this.shown = false;
};

FilterWordsPopup.prototype.hideWithoutCallback = function () {
    _dhtml_popup2.default.prototype.hide.call(this);
    this.shown = false;
};

FilterWordsPopup.prototype.show = function (offsetX, offsetY, width, height, isOriginAtBottom) {
    _dhtml_popup2.default.prototype.show.call(this, offsetX, offsetY, width, height, isOriginAtBottom);
    this.shown = true;
};

/**
 * Defines that escape is pressed now and popup must be hidden due to this fact
 * @param event
 */
FilterWordsPopup.prototype.isHideByEscape = function (event) {
    return this.shown && window.event && (0, _atBrowserUtils.isEscapePressed)(event);
};

FilterWordsPopup.prototype.isShown = function () {
    return this.shown;
};

/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.OnlineAccountFieldsCreateUserPopupDrawer = OnlineAccountFieldsCreateUserPopupDrawer;
exports.OnlineAccountFieldsEditUserPopupDrawer = OnlineAccountFieldsEditUserPopupDrawer;

var _BaseFieldsDrawerController = __webpack_require__(729);

var _BaseFieldsDrawerController2 = _interopRequireDefault(_BaseFieldsDrawerController);

var _UserNameDrawer = __webpack_require__(349);

var _UserNameDrawer2 = _interopRequireDefault(_UserNameDrawer);

var _InvitationDrawer = __webpack_require__(730);

var _InvitationDrawer2 = _interopRequireDefault(_InvitationDrawer);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _atUtils = __webpack_require__(5);

var _utils = __webpack_require__(25);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function OnlineAccountFieldsUserPopupDrawer() {}

OnlineAccountFieldsUserPopupDrawer.prototype = new _BaseFieldsDrawerController2.default();

OnlineAccountFieldsUserPopupDrawer.prototype.getNewPassword = function () {
    return null;
};

/**
 * create
 */
function OnlineAccountFieldsCreateUserPopupDrawer() {}

OnlineAccountFieldsCreateUserPopupDrawer.prototype = new OnlineAccountFieldsUserPopupDrawer();

OnlineAccountFieldsCreateUserPopupDrawer.prototype.initFields = function () {
    (0, _jquery2.default)(this.getElementByIdFunction("resendInvitation")).hide();
    (0, _jquery2.default)(this.getElementByIdFunction("resetPasswordLink")).hide();
};

/**
 * edit
 */
function OnlineAccountFieldsEditUserPopupDrawer() {}

OnlineAccountFieldsEditUserPopupDrawer.prototype = new OnlineAccountFieldsUserPopupDrawer();

OnlineAccountFieldsEditUserPopupDrawer.prototype.init = function (config) {
    OnlineAccountFieldsUserPopupDrawer.prototype.init.call(this, config);
    this.userNameDrawer = new _UserNameDrawer2.default().init(config);
    this.invitationDrawer = new _InvitationDrawer2.default({
        onDialogContentClick: function onDialogContentClick(e) {
            return (0, _utils.setEventPreventHidingEditUserSlidingPanel)(e);
        }
    }).init(config);
    this.addDrawer(this.invitationDrawer);
    this.addDrawer(this.userNameDrawer);
    return this;
};

OnlineAccountFieldsEditUserPopupDrawer.prototype.initFields = function (config) {
    var accountSettings = config.accountSettings;
    var hire_date = Date.parseJSONDate(accountSettings.hireDate);
    var current_time = Date.parseJSONDate(config.currentTime);
    if (hire_date.getTime() <= current_time.getTime() && !accountSettings.activated) {
        this.invitationDrawer.setNeedDrawResendButton(true);
    } else {
        this.invitationDrawer.setNeedDrawResendButton(false);
    }
    if (!config.editedUserIsSelf && (0, _atUtils.isEmailValid)(accountSettings.email) && accountSettings.activated) {
        this.invitationDrawer.setNeedDrawResetButton(true);
    } else {
        this.invitationDrawer.setNeedDrawResetButton(false);
    }

    OnlineAccountFieldsUserPopupDrawer.prototype.initFields.call(this, config.accountSettings);
};

OnlineAccountFieldsEditUserPopupDrawer.prototype.updateAccountSettings = function (accountSettings) {
    this.invitationDrawer.initFields(accountSettings);
};

/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var BaseFieldsDrawer = function () {
    function BaseFieldsDrawer() {
        _classCallCheck(this, BaseFieldsDrawer);
    }

    _createClass(BaseFieldsDrawer, [{
        key: 'init',
        value: function init(_ref) {
            var _ref$lightBoxEl = _ref.lightBoxEl,
                lightBoxEl = _ref$lightBoxEl === undefined ? null : _ref$lightBoxEl,
                _ref$getElementByIdFu = _ref.getElementByIdFunction,
                getElementByIdFunction = _ref$getElementByIdFu === undefined ? function () {} : _ref$getElementByIdFu,
                _ref$changeDetectedFu = _ref.changeDetectedFunction,
                changeDetectedFunction = _ref$changeDetectedFu === undefined ? function () {} : _ref$changeDetectedFu,
                _ref$updateUICallback = _ref.updateUICallback,
                updateUICallback = _ref$updateUICallback === undefined ? function () {} : _ref$updateUICallback,
                _ref$validationDetect = _ref.validationDetectedCallback,
                validationDetectedCallback = _ref$validationDetect === undefined ? function () {} : _ref$validationDetect,
                _ref$handlerIfNoSuchU = _ref.handlerIfNoSuchUserAfterAjax,
                handlerIfNoSuchUserAfterAjax = _ref$handlerIfNoSuchU === undefined ? function () {} : _ref$handlerIfNoSuchU;

            this.lightBoxEl = lightBoxEl;
            this.getElementByIdFunction = getElementByIdFunction;
            this.changeDetectedFunction = changeDetectedFunction;
            this.updateUICallback = updateUICallback;
            this.validationDetectedCallback = validationDetectedCallback;
            this.handlerIfNoSuchUserAfterAjax = handlerIfNoSuchUserAfterAjax;
            this.errors = {};
            return this;
        }
    }, {
        key: 'setValue',
        value: function setValue(field, value) {
            field.removeClass('placeholder'); // IE8 doesn't switch placeholder class when field value is set
            field[0].value = value;
            field[0].prevValue = field[0].value;
        }
    }, {
        key: 'setFieldDisabled',
        value: function setFieldDisabled(field, disabled) {
            field.prop('disabled', disabled);
        }
    }, {
        key: 'initFields',
        value: function initFields() {}
    }, {
        key: 'getObjectValues',
        value: function getObjectValues() {}
    }, {
        key: 'getErrors',
        value: function getErrors() {
            return this.errors;
        }
    }, {
        key: 'validateFields',
        value: function validateFields(oldErrors) {}
    }]);

    return BaseFieldsDrawer;
}();

exports.default = BaseFieldsDrawer;

/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DownloadableAccountFieldsCreateUserPopupDrawer = DownloadableAccountFieldsCreateUserPopupDrawer;
exports.DownloadableAccountFieldsEditUserPopupDrawer = DownloadableAccountFieldsEditUserPopupDrawer;

var _BaseFieldsDrawerController = __webpack_require__(729);

var _BaseFieldsDrawerController2 = _interopRequireDefault(_BaseFieldsDrawerController);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _PasswordFieldsDrawer = __webpack_require__(468);

var _PasswordFieldsDrawer2 = _interopRequireDefault(_PasswordFieldsDrawer);

var _UserNameDrawer = __webpack_require__(349);

var _UserNameDrawer2 = _interopRequireDefault(_UserNameDrawer);

var _PasswordPolicyManager = __webpack_require__(227);

var _PasswordPolicyManager2 = _interopRequireDefault(_PasswordPolicyManager);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _PasswordHintLink = __webpack_require__(731);

var _PasswordHintLink2 = _interopRequireDefault(_PasswordHintLink);

var _PasswordErrorMessage = __webpack_require__(732);

var _PasswordErrorMessage2 = _interopRequireDefault(_PasswordErrorMessage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function DownloadableAccountFieldsUserPopupDrawer() {}

DownloadableAccountFieldsUserPopupDrawer.prototype = new _BaseFieldsDrawerController2.default();

DownloadableAccountFieldsUserPopupDrawer.prototype.init = function (config) {
    _BaseFieldsDrawerController2.default.prototype.init.call(this, config);
    this.passwordDrawer = new _PasswordFieldsDrawer2.default().init(config);
    this.userNameDrawer = new _UserNameDrawer2.default().init(config);
    this.addDrawer(this.passwordDrawer);
    this.addDrawer(this.userNameDrawer);
    var $passwordHintContainer = (0, _jquery2.default)(config.getElementByIdFunction("passwordRequirementsTip"));
    $passwordHintContainer.empty();
    this.passwordHint = new _PasswordHintLink2.default({
        passwordPolicy: _PasswordPolicyManager2.default,
        my: "right top", left: 10,
        $hintContainer: (0, _jquery2.default)(config.lightBoxEl)
    }).init($passwordHintContainer);
    return this;
};

DownloadableAccountFieldsUserPopupDrawer.prototype.getNotCopyValues = function () {
    return { passwordData: this.passwordDrawer.getPlainPasswordValues(), username: this.userNameDrawer.getObjectValues().username };
};

DownloadableAccountFieldsUserPopupDrawer.prototype.getNewPassword = function () {
    return this.passwordDrawer.getNewPassword();
};

/*Create Drawer*/
function DownloadableAccountFieldsCreateUserPopupDrawer() {}

DownloadableAccountFieldsCreateUserPopupDrawer.prototype = new DownloadableAccountFieldsUserPopupDrawer();

DownloadableAccountFieldsCreateUserPopupDrawer.prototype.init = function (config) {
    DownloadableAccountFieldsUserPopupDrawer.prototype.init.call(this, config);
    this.passwordFieldsError = new _PasswordErrorMessage2.default({ additionalClass: "inlineErrorMessage" }).init((0, _jquery2.default)(config.getElementByIdFunction("errorsContainer")));
    return this;
};

DownloadableAccountFieldsCreateUserPopupDrawer.prototype.initFields = function (config) {
    this.passwordDrawer.setPasswordsAreMandatory(true);
    _BaseFieldsDrawerController2.default.prototype.initFields.call(this, config.accountSettings);
    this.passwordDrawer.setPasswordFieldsPlaceholders(_messageResource2.default.getMessage("user.add.js.password_field.placeholder"), _messageResource2.default.getMessage("user.add.js.password_copy_field.placeholder"));
};

DownloadableAccountFieldsCreateUserPopupDrawer.prototype.setErrorState = function (errors, passwordValidationResult) {
    this.passwordFieldsError.setState({ passwordValidationResult: passwordValidationResult });
};

/* Edit drawer */
function DownloadableAccountFieldsEditUserPopupDrawer() {}

DownloadableAccountFieldsEditUserPopupDrawer.prototype = new DownloadableAccountFieldsUserPopupDrawer();

DownloadableAccountFieldsEditUserPopupDrawer.prototype.initFields = function (config) {
    this.passwordDrawer.setPasswordsAreMandatory(false);
    _BaseFieldsDrawerController2.default.prototype.initFields.call(this, config.accountSettings);
    if (!(this.passwordDrawer.getPlainPasswordValues().password || this.passwordDrawer.getPlainPasswordValues().passwordCopy)) this.passwordDrawer.setPasswordFieldsPlaceholders(_messageResource2.default.getMessage("user.edit.js.password_field.placeholder"), _messageResource2.default.getMessage("user.edit.js.password_copy_field.placeholder"));
};

/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = PasswordFieldsDrawer;

var _BaseFieldsDrawer = __webpack_require__(466);

var _BaseFieldsDrawer2 = _interopRequireDefault(_BaseFieldsDrawer);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _constants = __webpack_require__(21);

var _atBrowserUtils = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function PasswordFieldsDrawer() {}

PasswordFieldsDrawer.prototype = new _BaseFieldsDrawer2.default();

PasswordFieldsDrawer.prototype.init = function (config) {
    _BaseFieldsDrawer2.default.prototype.init.call(this, config);
    this.passwordsAreMandatory = config.passwordsAreMandatory;
    this.disableValidation = config.disableValidation; //todo[grishin]: for now it always true, as far as i see, so validation inside this class could be removed
    return this;
};

PasswordFieldsDrawer.prototype.initFields = function (accountSettings) {
    this.passwordField = (0, _jquery2.default)(this.getElementByIdFunction("passwordField"));
    this.passwordCopyField = (0, _jquery2.default)(this.getElementByIdFunction("passwordCopyField"));
    var self = this;
    this.passChangedHandler = function () {
        this.keyPressed = false;
        if (this.value.length > 0) self.changeDetectedFunction(true);
    };
    this.focusHandler = function () {
        this.inFocus = true;
    };

    this.passwordBlurHandlerGenerator = function (_ref) {
        var _ref$isPasswordChange = _ref.isPasswordChanged,
            isPasswordChanged = _ref$isPasswordChange === undefined ? false : _ref$isPasswordChange,
            _ref$isPasswordCopyCh = _ref.isPasswordCopyChanged,
            isPasswordCopyChanged = _ref$isPasswordCopyCh === undefined ? false : _ref$isPasswordCopyCh;
        return function () {
            this.inFocus = false;
            (0, _jquery2.default)(this).pVal(this.value);
            //see Bug 48539
            if (this.keyPressed) {
                self.passChangedHandler.call(this);
                self.changeDetectedFunction();
            }

            if (!self.disableValidation) {
                self._checkPasswordsMatch();
            }
            self.passwordField.trigger("changed", [self.getPlainPasswordValues().password, self.getPlainPasswordValues().passwordCopy, isPasswordChanged, isPasswordCopyChanged]);
            self.validationDetectedCallback();
            self.updateUICallback();
        };
    };
};

PasswordFieldsDrawer.prototype.setPasswordsAreMandatory = function (passwordsAreMandatory) {
    this.passwordsAreMandatory = passwordsAreMandatory;
};

PasswordFieldsDrawer.prototype.hasErrors = function () {
    return this.errors[_constants.ValidationErrors.PASSWORD_EMPTY] || this.errors[_constants.ValidationErrors.PASSWORD_COPY_EMPTY] || this.errors[_constants.ValidationErrors.PASSWORDS_DO_NOT_MATCH] || this.errors[_constants.ValidationErrors.PASSWORD_RESTRICTIONS_VIOLATED];
};

PasswordFieldsDrawer.prototype.setError = function (error) {
    var _arr = [_constants.ValidationErrors.PASSWORD_EMPTY, _constants.ValidationErrors.PASSWORD_COPY_EMPTY, _constants.ValidationErrors.PASSWORDS_DO_NOT_MATCH, _constants.ValidationErrors.PASSWORD_RESTRICTIONS_VIOLATED];

    for (var _i = 0; _i < _arr.length; _i++) {
        var err = _arr[_i];
        this.errors[err] = err === error;
    }
};

PasswordFieldsDrawer.prototype._checkPasswordsMatch = function () {
    var pswEmpty = this.passwordField.pVal().length == 0;
    var pswCopyEmpty = this.passwordCopyField.pVal().length == 0;

    this.errors[_constants.ValidationErrors.PASSWORD_EMPTY] = this.passwordsAreMandatory ? pswEmpty : false;
    this.errors[_constants.ValidationErrors.PASSWORD_COPY_EMPTY] = this.passwordsAreMandatory ? !pswEmpty && pswCopyEmpty : false;

    return this.errors[_constants.ValidationErrors.PASSWORDS_DO_NOT_MATCH] = (this.passwordsAreMandatory && !pswEmpty && !pswCopyEmpty || !this.passwordsAreMandatory) && this.passwordField.pVal() != this.passwordCopyField.pVal();
};

PasswordFieldsDrawer.prototype.setPasswordFieldsPlaceholders = function (pwdPlaceholder, pwdCopyPlaceholder) {
    this.passwordField.off();
    this.passwordCopyField.off();

    this.setValue(this.passwordField, "");
    this.setValue(this.passwordCopyField, "");

    if (pwdPlaceholder) this.passwordField.attr("placeholder", pwdPlaceholder);

    if (pwdCopyPlaceholder) this.passwordCopyField.attr("placeholder", pwdCopyPlaceholder);

    this.passwordField.placeholder();
    this.passwordCopyField.placeholder();

    var handleKeyDown = function handleKeyDown(e) {
        if ((0, _atBrowserUtils.isEscapePressed)(e) || (0, _atBrowserUtils.isEnterPressed)(e)) {
            this.blur();
            e.stopPropagation();
        }
    };

    this.passwordField.keydown(handleKeyDown);
    this.passwordCopyField.keydown(handleKeyDown);
    this.passwordField.keyup(this.passChangedHandler);
    this.passwordCopyField.keyup(this.passChangedHandler);
    this.passwordCopyField.focus(this.focusHandler);
    this.passwordField.blur(this.passwordBlurHandlerGenerator({ isPasswordChanged: true }));
    this.passwordCopyField.blur(this.passwordBlurHandlerGenerator({ isPasswordCopyChanged: true }));
};

PasswordFieldsDrawer.prototype.getNewPassword = function () {
    if (!this.passwordField) return null;
    var passwordValue = this.passwordField.pVal();
    if (passwordValue.length > 0) return passwordValue;
    return null;
};

PasswordFieldsDrawer.prototype.validateFields = function () {
    this._checkPasswordsMatch();
    return this.errors;
};

PasswordFieldsDrawer.prototype.getObjectValues = function () {
    return { newPassword: this.getNewPassword() };
};

PasswordFieldsDrawer.prototype.getPlainPasswordValues = function () {
    return {
        password: this.passwordField.pVal(),
        passwordCopy: this.passwordCopyField.pVal()
    };
};

PasswordFieldsDrawer.prototype.getNotCopyValues = function () {
    return { passwordData: this.getPlainPasswordValues() };
};

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Ext = __webpack_require__(12);

var _Ext2 = _interopRequireDefault(_Ext);

var _abstract_dropdown_button = __webpack_require__(233);

var _abstract_dropdown_button2 = _interopRequireDefault(_abstract_dropdown_button);

var _atBrowserUtils = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Custom button implementation for use with dropdown menus.
 * Its toggled state is tied to the menu's displayed/hidden status.
 *
 * Default styles in:
 * <code>/css/dropdown-button.less</code>
 *
 * Depends on:
 * <code>/js/controls/abstract-dropdown-button.js</code>
 *
 * @cfg {Ext.menu.Menu} menu menu to serve as dropdown.
 */
var DropdownButton = _Ext2.default.extend(_abstract_dropdown_button2.default, {
    overCls: 'hover',
    menuAlign: "tl-bl?",
    buttonSelector: "span:first",
    menuAnchor: "td.bottom-left-cell",
    menuAlignOffset: null,
    cls: "dropdown-button",
    tooltipObject: null,
    tooltipText: null,
    tooltipEnabled: true,
    menuHideCallback: null,

    initComponent: function initComponent() {
        DropdownButton.superclass.initComponent.call(this);

        if (!this.template) this.template = new _Ext2.default.Template('<table class="' + this.cls + '" cellspacing="0" cellpadding="0" border="0" width="100%">', '<tr>', '<td class="top-left-border" colspan="2"></td>', '<td class="top-left-cell"></td>', '<td class="top-separator"></td>', '<td class="top-right-cell"></td>', '<td class="top-right-border" colspan="2"></td>', '</tr>', '<tr>', '<td class="middle-left-border"></td>', '<td class="middle-left-subborder"></td>', '<td class="middle-left-cell contents">', '<span onmouseover="Ext.getCmp(\'' + this.id + '\').showTooltip(this)" ' + 'onmouseout="Ext.getCmp(\'' + this.id + '\').hideTooltip(this)">{0}</span>', '</td>', '<td class="middle-separator"></td>', '<td class="middle-right-cell"><div class="arrow"></div></td>', '<td class="middle-right-subborder"></td>', '<td class="middle-right-border"></td>', '</tr>', '<tr>', '<td class="bottom-left-border" colspan="2"></td>', '<td class="bottom-left-cell"></td>', '<td class="bottom-separator"></td>', '<td class="bottom-right-cell"></td>', '<td class="bottom-right-border" colspan="2"></td>', '</tr>', '</table>');

        this.on("menushow", function (btn) {
            btn.toggle(true);
        });
        this.on("menuhide", function (btn) {
            btn.toggle(false);this.handleMenuHide();
        }, this);
    },

    onMenuHide: function onMenuHide(menu) {
        // Reset all changes if menu is hidden without applying save
        if (this.selectorPanel && !this.selectorPanel.shouldSave) {
            this.selectorPanel.resetState(true);
        }

        DropdownButton.superclass.onMenuHide.call(this, menu);
    },

    onMenuShow: function onMenuShow(menu) {
        if (this.selectorPanel) {
            this.selectorPanel.shouldSave = !this.selectorPanel.resetOnHide;
        }

        DropdownButton.superclass.onMenuShow.call(this, menu);
    },

    handleMenuHide: function handleMenuHide() {
        if (this.menuHideCallback) this.menuHideCallback();
    },

    setMenuHideCallback: function setMenuHideCallback(callback) {
        this.menuHideCallback = callback;
    },

    setText: function setText(text) {
        this.text = text;
        if (this.el) {
            this.el.child(this.buttonSelector).update(text);
        }
        this.autoWidth();
    },

    setTooltipEnabled: function setTooltipEnabled(enabled) {
        this.tooltipEnabled = enabled;
    },

    setTooltipText: function setTooltipText(text) {
        this.tooltipText = text;
    },

    showTooltip: function showTooltip(element) {
        if (this.showTooltipEnabled()) {
            var text = this.tooltipText ? this.tooltipText : this.selectorPanel.getTooltipText();
            this.doShowTooltip(text, element);
        }
    },

    doShowTooltip: function doShowTooltip(text, element) {
        this.tooltipObject.showDelayedWithTimeout(text, element, 0, 22, 600);
    },

    showTooltipEnabled: function showTooltipEnabled() {
        return this.tooltipObject && this.tooltipEnabled;
    },

    setDisplayInputError: function setDisplayInputError(display, message) {
        if (!this.el) return;
        var parent = this.el.dom.parentNode;
        var errorElement = parent ? parent : this.el.dom;
        if (display) (0, _atBrowserUtils.addClass)(errorElement, this.errorCls);else (0, _atBrowserUtils.removeClass)(errorElement, this.errorCls);
        this.setTooltipEnabled(display);
        this.setTooltipText(message);
    },

    hideTooltip: function hideTooltip() {
        if (this.tooltipObject) this.tooltipObject.cancelDelayedShow();
    },

    afterRender: function afterRender() {
        DropdownButton.superclass.afterRender.call(this);
    },

    showMenu: function showMenu() {
        if (this.menu) {
            this.menu.show(this.el.child(this.menuAnchor), this.menuAlign);
        }
        return this;
    }

});

_Ext2.default.reg('at_dropdown_button', DropdownButton);

exports.default = DropdownButton;

/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = DhtmlTitle;

var _atBrowserUtils = __webpack_require__(8);

function DhtmlTitle(divId, disableTagFilter, disableMouseEvents) {
    this.divId = divId;
    this.delayedTid = null;
    this.disableTagFilter = disableTagFilter;
    this.disableMouseEvents = disableMouseEvents;
}

DhtmlTitle.prototype.getDiv = function () {
    return document.getElementById(this.divId);
};

DhtmlTitle.prototype.show = function (titleText, srcObject, offsetX, offsetY) {
    var x = offsetX;
    var y = offsetY;
    if (srcObject) {
        var coords = (0, _atBrowserUtils.calculateObjectCoords)(srcObject);
        x += coords.x;
        y += coords.y;
    }
    this.showAtPosition(titleText, srcObject, x, y);
};

//private
DhtmlTitle.prototype.showAtPosition = function (titleText, srcObject, x, y) {
    this.cancelDelayedShow();

    var div = this.getDiv();
    if (!this.disableTagFilter) titleText = titleText.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/\n/g, '<br>');
    div.innerHTML = titleText;

    div.style.display = 'block';
    this.shiftTo(x, y);

    var title = this;
    var objectMouseoverFunc;

    if (srcObject) objectMouseoverFunc = srcObject.onmouseover;

    var mouseoutFunc = function mouseoutFunc() {
        title.hide();
        title.restoreMouseover(srcObject, objectMouseoverFunc);
    };

    var mouseoverFunc = function mouseoverFunc() {
        title.cancelHide();
        title.restoreMouseover(srcObject, objectMouseoverFunc);
    };

    if (srcObject) {
        srcObject.onmouseout = mouseoutFunc;
        srcObject.onmouseover = mouseoverFunc;
    }

    if (!this.disableMouseEvents) {
        div.onmouseout = mouseoutFunc;
        div.onmouseover = mouseoverFunc;
    }
};

DhtmlTitle.prototype.showNearMouse = function (titleText, srcObject, mouse) {
    this.showAtPosition(titleText, srcObject, mouse.getX(), mouse.getY() + mouse.getCursorHeight());
};

DhtmlTitle.prototype.shiftTo = function (x, y) {
    // if popup's right edge is beyond the window edge, move it to the left
    var width = (0, _atBrowserUtils.getObjectWidth)(this.getDiv().id);
    var verticalScrollWidth = 17;
    var oversize = x + width - (0, _atBrowserUtils.getBodyScrollLeft)() - (0, _atBrowserUtils.getInsideWindowWidth)() + verticalScrollWidth;
    if (oversize > 0) {
        x -= oversize;
    }

    (0, _atBrowserUtils.shiftTo)(this.getDiv(), x, y);
};

DhtmlTitle.prototype.restoreMouseover = function (object, func) {
    if (!object) return;
    object.onmouseover = func;
};

DhtmlTitle.prototype.showDelayed = function (titleText, srcObject, offsetX, offsetY) {
    this.showDelayedWithTimeout(titleText, srcObject, offsetX, offsetY, 1000);
};

DhtmlTitle.prototype.showDelayedWithTimeout = function (titleText, srcObject, offsetX, offsetY, timeout) {
    this.cancelDelayedShow();
    var obj = this;
    this.delayedTid = window.setTimeout(function () {
        obj.show(titleText, srcObject, offsetX, offsetY);
    }, timeout);
};

DhtmlTitle.prototype.showDelayedWithTimeoutNearMouse = function (titleText, srcObject, mouse, timeout) {
    this.cancelDelayedShow();
    var obj = this;
    this.delayedTid = window.setTimeout(function () {
        obj.showNearMouse(titleText, srcObject, mouse);
    }, timeout);
};

DhtmlTitle.prototype.cancelDelayedShow = function () {
    if (this.delayedTid) {
        window.clearTimeout(this.delayedTid);
        this.delayedTid = null;
    }
};

DhtmlTitle.prototype.hide = function () {
    var title = this;
    this.cancelDelayedShow();
    this.tid = window.setTimeout(function () {
        title.immediateHide();
    }, 500);
};

DhtmlTitle.prototype.cancelHide = function () {
    if (this.tid) {
        window.clearTimeout(this.tid);
        this.tid = null;
    }
};

DhtmlTitle.prototype.immediateHide = function () {
    this.getDiv().style.display = 'none';
    if (document.setActive) document.setActive();
};

/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Ext = __webpack_require__(12);

var _Ext2 = _interopRequireDefault(_Ext);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * "Icon" button implementation, rendered as an anchor with an icon image in the background.
 *
 * @cfg {String} cls css class(appends to the base class).
 * @cfg {String} icon icon image URL.
 * @cfg {String} linkCls css class for inner "a" element.
 */
var IconButton = _Ext2.default.extend(_Ext2.default.Button, {
    buttonSelector: "a:first",
    baseCls: "at-icon-button",
    cls: "",
    icon: "",
    linkCls: "",
    tooltip: "",
    tooltipType: "title",

    initComponent: function initComponent() {
        IconButton.superclass.initComponent.call(this);
        var templateString = '<div><a class="' + this.linkCls + '">&#160;</a></div>';
        this.template = new _Ext2.default.Template(templateString);
        this.cls = this.baseCls + " " + this.cls;
    }
});

_Ext2.default.reg('at_icon_button', IconButton);

exports.default = IconButton;

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = CustomerNodeRenderer;

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _ExpandCollapseNodeRenderer = __webpack_require__(352);

var _ExpandCollapseNodeRenderer2 = _interopRequireDefault(_ExpandCollapseNodeRenderer);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _hierarchy_selector_util = __webpack_require__(95);

var _hierarchy_selector_util2 = _interopRequireDefault(_hierarchy_selector_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CustomerNodeRenderer(tree, selectorFilter, expandCollapseCallback, selectionHelper) {
    _ExpandCollapseNodeRenderer2.default.call(this, tree, selectorFilter, expandCollapseCallback);
    this.selectionHelper = selectionHelper;
}

CustomerNodeRenderer.prototype = _underscore2.default.create(_ExpandCollapseNodeRenderer2.default.prototype);

CustomerNodeRenderer.prototype.getEmptyEntityTooltip = function () {
    return _messageResource2.default.getMessage("projects_customers_selector.customer_is_empty.tooltip");
};

CustomerNodeRenderer.prototype.isNeedToPushDisabledClass = function (treeNode) {
    return treeNode.getValue().archived;
};

CustomerNodeRenderer.prototype.generateLabel = function (treeNode, labelEl) {
    _hierarchy_selector_util2.default.renderSimpleEntityName(this, treeNode, labelEl);
};

/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ProjectNodeRenderer;

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _SimpleCheckboxNodeRenderer = __webpack_require__(347);

var _SimpleCheckboxNodeRenderer2 = _interopRequireDefault(_SimpleCheckboxNodeRenderer);

var _hierarchy_selector_util = __webpack_require__(95);

var _hierarchy_selector_util2 = _interopRequireDefault(_hierarchy_selector_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ProjectNodeRenderer(tree, selectorFilter, selectionHelper) {
    _SimpleCheckboxNodeRenderer2.default.call(this, tree, selectorFilter, selectionHelper);
}

ProjectNodeRenderer.prototype = _underscore2.default.create(_SimpleCheckboxNodeRenderer2.default.prototype);

ProjectNodeRenderer.prototype.getTitle = function (entity) {
    return entity.name;
};

ProjectNodeRenderer.prototype.isNeedToPushDisabledClass = function (treeNode) {
    return treeNode.getValue().archived;
};

ProjectNodeRenderer.prototype.generateLabel = function (treeNode, labelEl) {
    _hierarchy_selector_util2.default.renderSimpleEntityName(this, treeNode, labelEl);
};

/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ArchivedProjectsParentNodeRenderer;

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _DisabledNodesParentNodeRenderer = __webpack_require__(353);

var _DisabledNodesParentNodeRenderer2 = _interopRequireDefault(_DisabledNodesParentNodeRenderer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ArchivedProjectsParentNodeRenderer(tree, selectorFilter, selectionHelper) {
    _DisabledNodesParentNodeRenderer2.default.call(this, tree, selectorFilter, selectionHelper);
}

ArchivedProjectsParentNodeRenderer.prototype = _underscore2.default.create(_DisabledNodesParentNodeRenderer2.default.prototype, {
    labelMessageKey: function labelMessageKey() {
        return "cp_selector.archived_projects_parent_node_label";
    }
});

/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ArchivedCustomersParentNodeRenderer;

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _DisabledNodesParentNodeRenderer = __webpack_require__(353);

var _DisabledNodesParentNodeRenderer2 = _interopRequireDefault(_DisabledNodesParentNodeRenderer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ArchivedCustomersParentNodeRenderer(tree, selectorFilter, selectionHelper) {
    _DisabledNodesParentNodeRenderer2.default.call(this, tree, selectorFilter, selectionHelper);
}

ArchivedCustomersParentNodeRenderer.prototype = _underscore2.default.create(_DisabledNodesParentNodeRenderer2.default.prototype, {
    labelMessageKey: function labelMessageKey() {
        return "cp_selector.archived_customers_parent_node_label";
    },

    getNodeClasses: function getNodeClasses(treeNode) {
        var classes = _DisabledNodesParentNodeRenderer2.default.prototype.getNodeClasses.call(this, treeNode);
        classes.push("archivedCustomersParent");
        return classes;
    }
});

/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TreeBuilder = function () {
    function TreeBuilder(rootNode, secondLevelEntities, firstLevelEntitiesMap, firstLevelEntitiesOrder) {
        _classCallCheck(this, TreeBuilder);

        this.rootNode = rootNode;
        this.secondLevelEntities = secondLevelEntities;
        this.firstLevelEntitiesMap = firstLevelEntitiesMap;
        this.firstLevelEntitiesOrder = firstLevelEntitiesOrder;
        this.skipFirstLevel = !(this.firstLevelEntitiesMap && this.firstLevelEntitiesOrder);
        this.nodes = {};
        this.disabledNodesParents = {};
    }

    _createClass(TreeBuilder, [{
        key: "buildTree",
        value: function buildTree() {
            // Add nodes for enabled second level entities
            _underscore2.default.each(this.secondLevelEntities, function (secondLevelEntity) {
                if (this.isSecondLevelEntityEnabled(secondLevelEntity)) {
                    var nodeForSecondLevelEntity = this.createTreeNodeForSecondLevelEntity(secondLevelEntity);
                    var parentTreeNode = !this.skipFirstLevel ? this.getOrCreateTreeNodeForFirstLevelEntity(this.getSecondLevelEntityParentId(secondLevelEntity), true) : this.rootNode;
                    parentTreeNode.appendChild(nodeForSecondLevelEntity);
                    this.onTreeNodeForSecondLevelEntityAdded(nodeForSecondLevelEntity);
                }
            }, this);

            // Add nodes for disabled second level entities
            _underscore2.default.each(this.secondLevelEntities, function (secondLevelEntity) {
                if (!this.isSecondLevelEntityEnabled(secondLevelEntity)) {
                    var nodeForSecondLevelEntity = this.createTreeNodeForSecondLevelEntity(secondLevelEntity);
                    // Node, which is normally a direct parent (for enabled second level entities) is a grandparent for disabled entities
                    var grandParentTreeNode = !this.skipFirstLevel ? this.getOrCreateTreeNodeForFirstLevelEntity(this.getSecondLevelEntityParentId(secondLevelEntity), true) : this.rootNode;
                    // Direct node parent is a special disabled nodes parent. Create it if not created before and append to grandparent
                    var parentTreeNodeId = !this.skipFirstLevel ? grandParentTreeNode.getValue().id : 0;
                    var parentTreeNode = this.disabledNodesParents[parentTreeNodeId];
                    if (!parentTreeNode) {
                        parentTreeNode = this.createDisabledNodesParentForSecondLevelEntity(parentTreeNodeId);
                        this.disabledNodesParents[parentTreeNodeId] = parentTreeNode;
                        grandParentTreeNode.appendChild(parentTreeNode);
                        this.onDisabledNodesParentForSecondLevelEntitiesAdded(parentTreeNode);
                    }

                    parentTreeNode.appendChild(nodeForSecondLevelEntity);
                    this.onTreeNodeForSecondLevelEntityAdded(nodeForSecondLevelEntity);
                }
            }, this);

            if (!this.skipFirstLevel) {
                // Add nodes for enabled first level entities
                _underscore2.default.each(this.firstLevelEntitiesOrder, function (firstLevelEntityId) {
                    var firstLevelEntity = this.firstLevelEntitiesMap[firstLevelEntityId];
                    if (this.isFirstLevelEntityEnabled(firstLevelEntity)) {
                        var treeNodeForFirstLevelEntity = this.getOrCreateTreeNodeForFirstLevelEntity(firstLevelEntityId, this.createEmptyFirstLevelEntityNodes());
                        if (treeNodeForFirstLevelEntity) {
                            this.rootNode.appendChild(treeNodeForFirstLevelEntity);
                            this.onTreeNodeForFirstLevelEntityAdded(treeNodeForFirstLevelEntity);
                        }
                    }
                }, this);

                // Add nodes for disabled first level entities
                _underscore2.default.each(this.firstLevelEntitiesOrder, function (firstLevelEntityId) {
                    var firstLevelEntity = this.firstLevelEntitiesMap[firstLevelEntityId];
                    if (!this.isFirstLevelEntityEnabled(firstLevelEntity)) {
                        var treeNodeForFirstLevelEntity = this.getOrCreateTreeNodeForFirstLevelEntity(firstLevelEntityId, this.createEmptyFirstLevelEntityNodes());
                        if (treeNodeForFirstLevelEntity) {
                            if (!this.disabledNodesParentForFirstLevelEntities) {
                                this.disabledNodesParentForFirstLevelEntities = this.createDisabledNodesParentForFirstLevelEntity(firstLevelEntity);
                                this.rootNode.appendChild(this.disabledNodesParentForFirstLevelEntities);
                                this.onDisabledNodesParentForFirstLevelEntitiesAdded(this.disabledNodesParentForFirstLevelEntities);
                            }

                            this.disabledNodesParentForFirstLevelEntities.appendChild(treeNodeForFirstLevelEntity);
                            this.onTreeNodeForFirstLevelEntityAdded(treeNodeForFirstLevelEntity);
                        }
                    }
                }, this);
            }
        }
    }, {
        key: "getOrCreateTreeNodeForFirstLevelEntity",
        value: function getOrCreateTreeNodeForFirstLevelEntity(id, createNonExisting) {
            var treeNode = this.nodes[id];
            if (!treeNode && createNonExisting) {
                treeNode = this.createTreeNodeForFirstLevelEntity(this.firstLevelEntitiesMap[id]);
                treeNode.setLevel(1);
                this.nodes[id] = treeNode;
            }
            return treeNode;
        }
    }, {
        key: "createEmptyFirstLevelEntityNodes",
        value: function createEmptyFirstLevelEntityNodes() {
            return false;
        }
    }, {
        key: "createTreeNodeForFirstLevelEntity",
        value: function createTreeNodeForFirstLevelEntity(firstLevelEntity) {
            // Abstract
        }
    }, {
        key: "createTreeNodeForSecondLevelEntity",
        value: function createTreeNodeForSecondLevelEntity(secondLevelEntity) {
            // Abstract
        }
    }, {
        key: "createDisabledNodesParentForFirstLevelEntity",
        value: function createDisabledNodesParentForFirstLevelEntity() {
            // Abstract
        }
    }, {
        key: "createDisabledNodesParentForSecondLevelEntity",
        value: function createDisabledNodesParentForSecondLevelEntity(parentId) {
            // Abstract
        }
    }, {
        key: "getSecondLevelEntityParentId",
        value: function getSecondLevelEntityParentId(secondLevelEntity) {
            // Abstract
        }
    }, {
        key: "isFirstLevelEntityEnabled",
        value: function isFirstLevelEntityEnabled(firstLevelEntity) {
            // Abstract
        }
    }, {
        key: "isSecondLevelEntityEnabled",
        value: function isSecondLevelEntityEnabled(secondLevelEntity) {
            // Abstract
        }
    }, {
        key: "onTreeNodeForFirstLevelEntityAdded",
        value: function onTreeNodeForFirstLevelEntityAdded(treeNode) {
            // Abstract
        }
    }, {
        key: "onTreeNodeForSecondLevelEntityAdded",
        value: function onTreeNodeForSecondLevelEntityAdded(treeNode) {
            // Abstract
        }
    }, {
        key: "onDisabledNodesParentForFirstLevelEntitiesAdded",
        value: function onDisabledNodesParentForFirstLevelEntitiesAdded(treeNode) {
            // Abstract
        }
    }, {
        key: "onDisabledNodesParentForSecondLevelEntitiesAdded",
        value: function onDisabledNodesParentForSecondLevelEntitiesAdded(treeNode) {
            // Abstract
        }
    }]);

    return TreeBuilder;
}();

exports.default = TreeBuilder;

/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Ext = __webpack_require__(12);

var _Ext2 = _interopRequireDefault(_Ext);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _atUtils = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SelectionHelper = function SelectionHelper(config) {
    _Ext2.default.apply(this, config);
};

SelectionHelper.prototype = {
    /**
     * @cfg {String} itemNounSingularKey item noun singular form message key (required).
     */
    itemNounSingularKey: null,

    /**
     * @cfg {String} itemNounSingularKey item noun plural form message key (required).
     */
    itemNounPluralKey: null,

    /**
     * @cfr {String} itemInactiveMessageKey item inactive message key for list description
     */
    itemInactiveMessageKey: "usersselector.users.disabled",

    /**
     * @cfg {String} noItemsSelectedKey no items selected message key (required).
     */
    noItemsSelectedKey: null,

    /**
     * @cfg {String} true to include inactive items count.
     */
    showInactiveCount: true,

    /**
     * @cfg {String} prefix text prefix.
     */
    prefix: "",

    /**
     * @cfg {String} suffix text suffix.
     */
    suffix: "",

    /**
     * @cfg {Boolean} showSingleItemInactiveText true to show "inactive" text with one item.
     */
    showSingleItemInactiveText: true,

    /**
     * @cfg {Boolean} useNameForSingleItem true to display item name for single item.
     */
    useNameForSingleItem: true,

    /**
     * @cfg {String} inactiveSingleItemTextKey single disabled item text message key.
     */
    inactiveSingleItemTextKey: "common.archived",

    /**
     * @cfg {Number} listDescriptionItemsAmount amount of items to be in list description
     */
    listDescriptionItemsAmount: 15,

    /**
     * @cfg {String} moreListDescriptionItemsMessageKey last row list description message key. To show
     * if more items selected then <code>listDescriptionItemsAmount</code> specifies
     */
    moreListDescriptionItemsMessageKey: "common.more_items",

    /**
     * @cfg {AT.GenericSelectorTreePropertiesController} propertiesController controller used
     * to extract tree item properties
     */
    propertiesController: null,

    /**
     * Returns formatted string that describes the list of items.
     * @param {Array} items list of items with properties {@link #itemNameProperty} and {@link #itemActiveProperty}.
     */
    getDescription: function getDescription(items) {
        var result = "";

        if (items.length == 0) {
            return this.getMessage(this.noItemsSelectedKey);
        } else if (items.length == 1 && this.useNameForSingleItem) {
            result = this.getSingleItemText(items[0]);
        } else {
            var itemNoun,
                inactiveText = "";

            if (items.length == 1) {
                itemNoun = this.getMessage(this.itemNounSingularKey);
                inactiveText = this.propertiesController.isActive(items[0]) ? "" : " " + this.getMessage(this.inactiveSingleItemTextKey);
            } else {
                itemNoun = this.getMessage(this.itemNounPluralKey);
            }

            result = items.length + " ";
            if (!_Ext2.default.isEmpty(this.prefix)) {
                result += this.prefix + " ";
            }
            result += itemNoun + inactiveText;
        }

        return result + (this.suffix ? " " + this.suffix : "");
    },

    /**
     * Formats text for single item.
     * @returns {String} formatted string.
     */
    getSingleItemText: function getSingleItemText(item) {
        var text = "";
        if (!_Ext2.default.isEmpty(this.prefix)) {
            text += this.prefix + " ";
        }
        var nounMsg = this.getMessage(this.itemNounSingularKey);
        if (!_Ext2.default.isEmpty(nounMsg)) {
            text += nounMsg + " ";
        }

        text += this.getItemName(item);

        if (this.showSingleItemInactiveText && !this.propertiesController.isActive(item)) text += " " + this.getMessage(this.inactiveSingleItemTextKey);

        return text;
    },

    getItemName: function getItemName(item) {
        return (0, _atUtils.escapeHtmlSymbols)(this.propertiesController.getName(item));
    },

    getMessage: function getMessage(key, args) {
        return _messageResource2.default.getEscapedMessage(key, args);
    },

    /**
     * Returns list of string based on passed list of items.
     */
    getListDescription: function getListDescription(items, oneItemCallback, sortCallback, itemPluralForm) {
        if (items.length == 0) return this.getMessage(this.noItemsSelectedKey);

        if (sortCallback) {
            items.sort(sortCallback);
        }
        var result = "";
        var displayAmount = this.listDescriptionItemsAmount >= items.length - 1 ? items.length : this.listDescriptionItemsAmount;

        var lastRow = null;
        if (displayAmount != items.length) {
            if (!itemPluralForm) {
                itemPluralForm = this.getMessage(this.itemNounPluralKey);
            }
            lastRow = "\n" + this.getMessage(this.moreListDescriptionItemsMessageKey, [items.length - displayAmount, itemPluralForm]);
        }
        for (var i = 0; i < displayAmount; i++) {
            result += oneItemCallback(items[i]);
            if (i != displayAmount - 1) result += "\n";
        }
        return lastRow ? result + lastRow : result;
    },

    /**
     * Return singel item string representation to display in list description
     * @param item
     */
    getListDescriptionItem: function getListDescriptionItem(item) {
        var result = "";
        result += this.propertiesController.getName(item);

        if (!this.propertiesController.isActive(item)) result += " " + this.getMessage(this.itemInactiveMessageKey);

        return result;
    }
};

exports.default = SelectionHelper;

/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _Switcher = __webpack_require__(236);

var _Switcher2 = _interopRequireDefault(_Switcher);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SwitcherWithWrapper = function (_TemplateView) {
    _inherits(SwitcherWithWrapper, _TemplateView);

    function SwitcherWithWrapper(_ref) {
        var _ref$containerAdditio = _ref.containerAdditionalClass,
            containerAdditionalClass = _ref$containerAdditio === undefined ? "" : _ref$containerAdditio,
            _ref$switcherWrapperA = _ref.switcherWrapperAdditionalClass,
            switcherWrapperAdditionalClass = _ref$switcherWrapperA === undefined ? "" : _ref$switcherWrapperA,
            _ref$switcherTextAddi = _ref.switcherTextAdditionalClass,
            switcherTextAdditionalClass = _ref$switcherTextAddi === undefined ? "" : _ref$switcherTextAddi,
            _ref$switcherAddition = _ref.switcherAdditionalClass,
            switcherAdditionalClass = _ref$switcherAddition === undefined ? "" : _ref$switcherAddition,
            _ref$onSwitchCallback = _ref.onSwitchCallback,
            onSwitchCallback = _ref$onSwitchCallback === undefined ? function () {} : _ref$onSwitchCallback,
            _ref$switcherText = _ref.switcherText,
            switcherText = _ref$switcherText === undefined ? "" : _ref$switcherText;

        _classCallCheck(this, SwitcherWithWrapper);

        var _this = _possibleConstructorReturn(this, (SwitcherWithWrapper.__proto__ || Object.getPrototypeOf(SwitcherWithWrapper)).call(this, null));

        _this.params = {
            containerAdditionalClass: containerAdditionalClass,
            switcherWrapperAdditionalClass: switcherWrapperAdditionalClass,
            switcherTextAdditionalClass: switcherTextAdditionalClass,
            switcherAdditionalClass: switcherAdditionalClass,
            onSwitchCallback: onSwitchCallback,
            switcherText: switcherText
        };

        _this.state = {
            enabled: false
        };

        _this.onStatePropertyChanged('enabled', function (enabled) {
            return _this.switcher.setState({ enabled: enabled });
        });
        return _this;
    }

    _createClass(SwitcherWithWrapper, [{
        key: "templateHtml",
        value: function templateHtml() {
            return '<div class="switcherContainer <%-containerAdditionalClass%>">' + '    <div class="switcherWrapper <%-switcherWrapperAdditionalClass%>"/>' + '    <div class="switcherText <%-switcherTextAdditionalClass%>"> <%-switcherText%> </div>' + '</div>';
        }
    }, {
        key: "templateModel",
        value: function templateModel() {
            return {
                containerAdditionalClass: this.params.containerAdditionalClass,
                switcherWrapperAdditionalClass: this.params.switcherWrapperAdditionalClass,
                switcherTextAdditionalClass: this.params.switcherTextAdditionalClass,
                switcherText: this.params.switcherText
            };
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            var _this2 = this;

            this.switcher = new _Switcher2.default({
                additionalClass: this.params.switcherAdditionalClass,
                onSwitchCallback: function onSwitchCallback(enabled) {
                    _this2.setStateInternal({ enabled: enabled });
                    _this2.params.onSwitchCallback(enabled);
                }
            }).init(this.find('.switcherWrapper'));
        }
    }]);

    return SwitcherWithWrapper;
}(_TemplateView3.default);

exports.default = SwitcherWithWrapper;

/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _TreeSelectionController = __webpack_require__(744);

var _TreeSelectionController2 = _interopRequireDefault(_TreeSelectionController);

var _TreeNodeSet = __webpack_require__(79);

var _TreeNodeSet2 = _interopRequireDefault(_TreeNodeSet);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TriStateSelectionController = function (_TreeSelectionControl) {
    _inherits(TriStateSelectionController, _TreeSelectionControl);

    function TriStateSelectionController(tree) {
        var alwaysSelectedNodes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

        _classCallCheck(this, TriStateSelectionController);

        var _this = _possibleConstructorReturn(this, (TriStateSelectionController.__proto__ || Object.getPrototypeOf(TriStateSelectionController)).call(this, tree));

        _this.alwaysSelectedNodes = alwaysSelectedNodes;
        _this.alwaysSelectedNodesSet = new _TreeNodeSet2.default();
        alwaysSelectedNodes.forEach(function (node) {
            return _this.alwaysSelectedNodesSet.add(node);
        });

        _this.intermediateSet = new _TreeNodeSet2.default();
        _this.listeners = [];
        return _this;
    }

    _createClass(TriStateSelectionController, [{
        key: "markSelected",
        value: function markSelected(treeNode) {
            if (!this.canSelectNode(treeNode)) {
                return;
            }

            _get(TriStateSelectionController.prototype.__proto__ || Object.getPrototypeOf(TriStateSelectionController.prototype), "markSelected", this).call(this, treeNode);
            this.intermediateSet.remove(treeNode);
        }
    }, {
        key: "markDeselected",
        value: function markDeselected(treeNode) {
            if (!this.canDeselectNode(treeNode)) {
                return;
            }

            _get(TriStateSelectionController.prototype.__proto__ || Object.getPrototypeOf(TriStateSelectionController.prototype), "markDeselected", this).call(this, treeNode);
            this.intermediateSet.remove(treeNode);
        }
    }, {
        key: "nodeSelected",
        value: function nodeSelected(treeNode) {
            if (!this.canSelectNode(treeNode)) {
                return;
            }

            this.selectSubtree(treeNode, true);
            this.fireNodeSelected(treeNode);
        }
    }, {
        key: "nodeDeselected",
        value: function nodeDeselected(treeNode) {
            if (!this.canDeselectNode(treeNode)) {
                return;
            }

            this.deselectSubtree(treeNode);
            this.fireNodeDeselected(treeNode);
        }
    }, {
        key: "selectSubtree",
        value: function selectSubtree(treeNode, updateUIofNodes) {
            if (!this.canSelectNode(treeNode)) {
                return;
            }

            this.markSelected(treeNode);

            if (updateUIofNodes) this.tree.updateUIForSingleTreeNode(treeNode);

            this.selectChildrenInDepth(treeNode, updateUIofNodes);

            // set intermediate selection state for all parent nodes
            var maxTopLevel = this.tree.isRootVisible() ? 0 : 1;
            var parentNode = treeNode.getParent();
            while (parentNode.getLevel() >= maxTopLevel) {
                this.updateParentNodeStateOnSubtreeSelected(parentNode);
                if (updateUIofNodes) this.tree.updateUIForSingleTreeNode(parentNode);
                parentNode = parentNode.getParent();
            }
        }
    }, {
        key: "updateParentNodeStateOnSubtreeSelected",
        value: function updateParentNodeStateOnSubtreeSelected(parentNode) {
            this.intermediateSet.add(parentNode);
        }
    }, {
        key: "markDeselectedAndUpdate",
        value: function markDeselectedAndUpdate(treeNode) {
            if (!this.canDeselectNode(treeNode)) {
                return;
            }

            this.markDeselected(treeNode);
            this.tree.updateUIForSingleTreeNode(treeNode);
        }
    }, {
        key: "deselectSubtree",
        value: function deselectSubtree(treeNode) {
            if (!this.canDeselectNode(treeNode)) {
                return;
            }

            this.markDeselectedAndUpdate(treeNode);

            var children = treeNode.getChildren();
            for (var i = 0; i < children.length; i++) {
                this.deselectSubtree(children[i]);
            }var maxTopLevel = this.tree.isRootVisible() ? 0 : 1;
            treeNode = treeNode.getParent();
            var foundIntermediate = false;
            while (treeNode.getLevel() >= maxTopLevel) {
                _get(TriStateSelectionController.prototype.__proto__ || Object.getPrototypeOf(TriStateSelectionController.prototype), "markDeselected", this).call(this, treeNode);

                if (foundIntermediate || this.hasAnySelectedChild(treeNode)) {
                    this.intermediateSet.add(treeNode);
                    foundIntermediate = true;
                } else {
                    this.intermediateSet.remove(treeNode);
                }

                this.tree.updateUIForSingleTreeNode(treeNode);
                treeNode = treeNode.getParent();
            }
        }
    }, {
        key: "hasAnySelectedChild",
        value: function hasAnySelectedChild(treeNode) {
            var children = treeNode.getChildren();
            for (var i = 0; i < children.length; i++) {
                var childNode = children[i];
                if (this.isSelected(childNode) || this.intermediateSet.contains(childNode)) return true;
            }
            return false;
        }
    }, {
        key: "hasAllChildrenSelected",
        value: function hasAllChildrenSelected(treeNode) {
            var children = treeNode.getChildren();
            for (var i = 0; i < children.length; i++) {
                var childNode = children[i];
                if (!this.isSelected(childNode)) return false;
            }
            return true;
        }
    }, {
        key: "hasAllChildrenDisabled",
        value: function hasAllChildrenDisabled(treeNode) {
            var children = treeNode.getChildren();
            for (var i = 0; i < children.length; i++) {
                var childNode = children[i];
                if (this.canDeselectNode(childNode)) return false;
            }
            return true;
        }
    }, {
        key: "deselectAll",
        value: function deselectAll() {
            var _this2 = this;

            var newSelection = new _TreeNodeSet2.default();
            var newIntermediate = new _TreeNodeSet2.default();

            this.alwaysSelectedNodes.forEach(function (node) {
                // Always selected nodes will appear in new selection
                newSelection.add(node);

                // Parents of always selected nodes should be checked as intermediate
                // unless they are also marked as always selected
                var parent = node.getParent();
                while (parent) {
                    if (!_this2.alwaysSelectedNodesSet.contains(parent)) {
                        newIntermediate.add(parent);
                    }
                    parent = parent.getParent();
                }
            });

            var oldSelection = this.nodeSet;
            this.nodeSet = newSelection;
            this.tree.updateUIForTreeNodeSet(oldSelection);

            var oldIntermediate = this.intermediateSet;
            this.intermediateSet = newIntermediate;
            this.tree.updateUIForTreeNodeSet(oldIntermediate);
        }
    }, {
        key: "containsSelectedChildren",
        value: function containsSelectedChildren(treeNode) {
            return this.intermediateSet.contains(treeNode);
        }
    }, {
        key: "addListener",
        value: function addListener(listener) {
            this.listeners.push(listener);
        }
    }, {
        key: "fireNodeSelected",
        value: function fireNodeSelected(treeNode) {
            for (var i = 0; i < this.listeners.length; i++) {
                this.listeners[i].nodeSelected(treeNode);
            }
        }
    }, {
        key: "fireNodeDeselected",
        value: function fireNodeDeselected(treeNode) {
            for (var i = 0; i < this.listeners.length; i++) {
                this.listeners[i].nodeDeselected(treeNode);
            }
        }
    }, {
        key: "updateUI",
        value: function updateUI() {
            _get(TriStateSelectionController.prototype.__proto__ || Object.getPrototypeOf(TriStateSelectionController.prototype), "updateUI", this).call(this);
            this.tree.updateUIForTreeNodeSet(this.intermediateSet);
        }
    }, {
        key: "selectChildrenInDepth",
        value: function selectChildrenInDepth(treeNode, updateUIofNodes) {
            var children = treeNode.getChildren();
            for (var i = 0; i < children.length; i++) {
                this.selectSubtree(children[i], updateUIofNodes);
            }
        }
    }, {
        key: "deselectChildrenInDepth",
        value: function deselectChildrenInDepth(treeNode, updateUIofNodes) {
            var children = treeNode.getChildren();
            for (var i = 0; i < children.length; i++) {
                this.deselectSubtree(children[i], updateUIofNodes);
            }
        }
    }, {
        key: "resetSelectedNodes",
        value: function resetSelectedNodes(nodeSet) {
            if (!nodeSet) {
                nodeSet = this.initiallySelectedNodeSet;
            }
            this.nodeSet = nodeSet.clone();

            var allLevels = nodeSet.getAllLevels();

            //todo optimise (it reselects nodes that were already selected due-to parent's selection)
            for (var i = 0; i < allLevels.length; i++) {
                //noinspection JSUnfilteredForInLoop
                var levelMap = nodeSet.getLevelMap(allLevels[i]);
                for (var j in levelMap) {
                    //noinspection JSUnfilteredForInLoop
                    if (this.nodeSet.contains(levelMap[j]))
                        //noinspection JSUnfilteredForInLoop
                        this.selectSubtree(levelMap[j], false);
                }
            }
        }
    }, {
        key: "canSelectNode",
        value: function canSelectNode(treeNode) {
            return true;
        }
    }, {
        key: "canDeselectNode",
        value: function canDeselectNode(treeNode) {
            return !this.alwaysSelectedNodesSet.contains(treeNode);
        }
    }]);

    return TriStateSelectionController;
}(_TreeSelectionController2.default);

exports.default = TriStateSelectionController;

/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = HideUserGroupsStrategy;

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _UserSelectorGroupsStrategy = __webpack_require__(740);

var _UserSelectorGroupsStrategy2 = _interopRequireDefault(_UserSelectorGroupsStrategy);

var _hierarchy_selector_util = __webpack_require__(95);

var _hierarchy_selector_util2 = _interopRequireDefault(_hierarchy_selector_util);

var _TreeNodeSet = __webpack_require__(79);

var _TreeNodeSet2 = _interopRequireDefault(_TreeNodeSet);

var _UsersSelectorTree = __webpack_require__(741);

var _UsersSelectorTree2 = _interopRequireDefault(_UsersSelectorTree);

var _ShowUserGroupsStrategy = __webpack_require__(356);

var _ShowUserGroupsStrategy2 = _interopRequireDefault(_ShowUserGroupsStrategy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

HideUserGroupsStrategy.USER_NODE_LEVEL = 1;
HideUserGroupsStrategy.DISABLED_USER_NODE_LEVEL = 2;

HideUserGroupsStrategy.pleaseSelectMessageKey = "users_selector.no_users_selected";
HideUserGroupsStrategy.emptySelectionTooltipTextKey = "mail_notifications.users_selector.no_users_selected";
HideUserGroupsStrategy.noNodesMatchingSearchMessageKey = "users_selector.only_users.no_results_in_search";
HideUserGroupsStrategy.noSelectedNodesMessageKey = "users_selector.hide_not_selected.no_users_selected";

function HideUserGroupsStrategy(conf) {
    _UserSelectorGroupsStrategy2.default.call(this);

    this.pleaseSelectMessageKey = conf && conf.pleaseSelectMessageKey ? conf.pleaseSelectMessageKey : HideUserGroupsStrategy.pleaseSelectMessageKey;
    this.emptySelectionTooltipTextKey = conf && conf.emptySelectionTooltipTextKey ? conf.emptySelectionTooltipTextKey : HideUserGroupsStrategy.emptySelectionTooltipTextKey;
    this.noNodesMatchingSearchMessageKey = conf && conf.noNodesMatchingSearchMessageKey ? conf.noNodesMatchingSearchMessageKey : HideUserGroupsStrategy.noNodesMatchingSearchMessageKey;
    this.noSelectedNodesMessageKey = conf && conf.noSelectedNodesMessageKey ? conf.noSelectedNodesMessageKey : HideUserGroupsStrategy.noSelectedNodesMessageKey;
}

HideUserGroupsStrategy.prototype = _underscore2.default.create(_UserSelectorGroupsStrategy2.default.prototype);

HideUserGroupsStrategy.prototype.canExpandCollapseNodes = function () {
    return false;
};

HideUserGroupsStrategy.prototype.createTree = function (rootNode, emptyMessageBuilder, collapsedNodeIds) {
    return new _UsersSelectorTree2.default(rootNode, emptyMessageBuilder, collapsedNodeIds);
};

HideUserGroupsStrategy.prototype.isGroupNodeRendererNeeded = function () {
    return false;
};

HideUserGroupsStrategy.prototype.getAdditionalTreePanelClasses = function () {
    return ["oneLevelTree"];
};

HideUserGroupsStrategy.prototype.makeAllSelectedUsersSelection = function (nodeSet) {
    return this.makeOnlyUsersSelection(nodeSet);
};

HideUserGroupsStrategy.prototype.saveCollapsedNodesIntoCookies = function (tree, cookiesKey) {
    //do nothing
};

HideUserGroupsStrategy.prototype.makeNodeSet = function (selection, rootNode) {
    var nodeSet = new _TreeNodeSet2.default();
    _hierarchy_selector_util2.default.addNodesFromIdsArray(selection.getSecondLevel(), nodeSet, rootNode, "u");
    nodeSet.addAll(_hierarchy_selector_util2.default.selectNodesParents(nodeSet, _ShowUserGroupsStrategy2.default.USER_NODE_LEVEL));
    return nodeSet;
};

HideUserGroupsStrategy.prototype.getUserNodeLevel = function () {
    return HideUserGroupsStrategy.USER_NODE_LEVEL;
};

/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = UserSelectorTreeBuilderObserver;
function UserSelectorTreeBuilderObserver(searchIndex, allActiveSet) {
    this.searchIndex = searchIndex;
    this.allActiveSet = allActiveSet;
}

UserSelectorTreeBuilderObserver.prototype = {
    userNodeAdded: function userNodeAdded(userNode) {
        var user = userNode.getValue();
        this.searchIndex.add(user.firstName, userNode.id);
        this.searchIndex.add(user.lastName, userNode.id);
        this.allActiveSet.add(userNode);
    },

    groupNodeAdded: function groupNodeAdded(groupNode) {
        this.searchIndex.add(groupNode.getValue().name, groupNode.id);
        this.allActiveSet.add(groupNode);
    },

    disabledUsersParentNodeAdded: function disabledUsersParentNodeAdded(parentNode) {
        this.allActiveSet.add(parentNode);
    }
};

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _abstract_dropdown_button = __webpack_require__(233);

var _abstract_dropdown_button2 = _interopRequireDefault(_abstract_dropdown_button);

var _Ext = __webpack_require__(12);

var _Ext2 = _interopRequireDefault(_Ext);

var _atUtils = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * A button with dropdown menu, based on the Ext.Button.
 * You may apply it to a standard HTML SELECT element, and it will be automatically converted to a button with dropdown
 * menu and hidden input. Option in SELECT with value '---' will convert to a separator.
 *
 * Events:
 *  change - fired when the selection is changed.
 *
 * Methods:
 *  getValue - get the currently selected value (the value that is to be sent to the server, NOT the visible text!)
 *  getItemByValue - returns the Ext.menu.Item with the specified value.
 *
 * CSS classes that will be automatically applied:
 *  at-dropdown-list-btn - the button's element
 *  at-dropdown-list-btn-ct - the button's container
 *  at-dropdown-list-btn-menu - the menu's element
 *
 * Required files:
 *  ExtJS library
 *  util.js
 *  /js/controls/abstract-dropdown-button.js
 */
var DropdownListButton = _Ext2.default.extend(_abstract_dropdown_button2.default, {

    defaultValue: null,
    firstMenuShow: true,
    menuCls: "",
    changeEventAllowed: true,

    initComponent: function initComponent() {
        var thisButton = this;

        var onCheckChange = function onCheckChange(item, checked) {
            if (checked) {
                thisButton.currentValue = item.value;
                thisButton.setText(item.text);
                thisButton.inputElement.value = item.value;
                if (thisButton.changeEventAllowed) thisButton.fireEvent('change', this);
            }
        };

        this.addEvents('change');

        var selectElement = _Ext2.default.get(this.applyTo);
        var options = selectElement.dom.options;

        var menuItems = [];

        for (var i = 0; i < options.length; i++) {
            var option = options[i];

            if (option.value == '---') {
                menuItems.push('-'); // separator
            } else {
                var item = {
                    text: (0, _atUtils.escapeHtmlSymbols)(option.text),
                    value: option.value,
                    group: selectElement.id,
                    checked: option.selected,
                    id: option.id,
                    hideDelay: 150,
                    listeners: {
                        checkchange: onCheckChange
                    }
                };

                menuItems.push(item);
            }

            if (option.selected) {
                this.setText(item.text);
                this.currentValue = item.value;
            }
        }

        this.menu = new _Ext2.default.menu.Menu({
            items: menuItems,
            cls: "at-dropdown-list-btn-menu " + this.menuCls
        });

        this.cls = "at-dropdown-list-btn " + (this.cls ? this.cls : "");
        this.ctCls = "at-dropdown-list-btn-ct " + (this.ctCls ? this.ctCls : "");

        this.inputElement = selectElement.insertHtml('afterEnd', '<input type="hidden" id="' + selectElement.id + '" name="' + selectElement.dom.name + '" value="' + this.currentValue + '">');
        selectElement.remove();
        DropdownListButton.superclass.initComponent.call(this);
    },

    getValue: function getValue() {
        return this.currentValue;
    },

    getItemByValue: function getItemByValue(value) {
        return this.menu.items.find(function (item) {
            return item.value === value;
        });
    },

    template: new _Ext2.default.Template('<table border="0" cellpadding="0" cellspacing="0" class="x-btn-wrap"><tbody><tr>', '<td class="x-btn-left"><i>&#160;</i></td><td class="x-btn-center"><em unselectable="on"><a href="javascript:void(0)" class="x-btn-text" type="{1}">{0}</a></em></td><td class="x-btn-right"><i>&#160;</i></td>', "</tr></tbody></table>"),

    buttonSelector: "a:first-child",

    onMenuHide: function onMenuHide(menu) {
        this.focus();
        DropdownListButton.superclass.onMenuHide.call(this, menu);
    },

    onMenuShow: function onMenuShow(menu) {
        this.menu.autoWidth();
        DropdownListButton.superclass.onMenuShow.call(this, menu);
        if (this.firstMenuShow) {
            this.adjustMenuItemIds(menu);
            this.firstMenuShow = false;
        }
    },

    adjustMenuItemIds: function adjustMenuItemIds(menu) {
        menu.items.each(function (item) {
            item.el.dom.id = item.id;
        });
    },

    setActiveItemByValue: function setActiveItemByValue(value, suppressChangeEvent) {
        this.changeEventAllowed = !suppressChangeEvent;

        var menuItems = this.menu.items.items;
        var setActiveFlag;
        for (var i = 0; i < menuItems.length; i++) {
            setActiveFlag = menuItems[i].value == value;
            menuItems[i].setChecked(setActiveFlag);
        }

        this.changeEventAllowed = true;
    },

    setActiveItemByPosition: function setActiveItemByPosition(position) {
        var menuItems = this.menu.items.items;
        var setActiveFlag;
        for (var i = 0; i < menuItems.length; i++) {
            setActiveFlag = i === position;
            menuItems[i].setChecked(setActiveFlag);
        }
    },

    getDefaultValue: function getDefaultValue() {
        return this.defaultValue;
    },

    setDefaultValue: function setDefaultValue(value) {
        this.defaultValue = value;
    }

});
// register xtype
_Ext2.default.reg('at_dropdown_list_button', DropdownListButton);

exports.default = DropdownListButton;

/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _TabsController = __webpack_require__(239);

var _TabsController2 = _interopRequireDefault(_TabsController);

var _TaskPanelDetails = __webpack_require__(1327);

var _TaskPanelDetails2 = _interopRequireDefault(_TaskPanelDetails);

var _Header = __webpack_require__(1360);

var _Header2 = _interopRequireDefault(_Header);

var _ReportedTime = __webpack_require__(1362);

var _ReportedTime2 = _interopRequireDefault(_ReportedTime);

var _MoveToDialog = __webpack_require__(371);

var _MoveToDialog2 = _interopRequireDefault(_MoveToDialog);

var _AssignedUsersEditor = __webpack_require__(292);

var _AssignedUsersEditor2 = _interopRequireDefault(_AssignedUsersEditor);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _LoadingContainer = __webpack_require__(28);

var _LoadingContainer2 = _interopRequireDefault(_LoadingContainer);

var _AssignedUsersEditorContainer = __webpack_require__(294);

var _AssignedUsersEditorContainer2 = _interopRequireDefault(_AssignedUsersEditorContainer);

var _DeleteTaskPopupConfirmationDialog = __webpack_require__(1390);

var _DeleteTaskPopupConfirmationDialog2 = _interopRequireDefault(_DeleteTaskPopupConfirmationDialog);

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _ScrollableContainer = __webpack_require__(49);

var _ScrollableContainer2 = _interopRequireDefault(_ScrollableContainer);

var _CommentsFooter = __webpack_require__(500);

var _CommentsFooter2 = _interopRequireDefault(_CommentsFooter);

var _CreateFooter = __webpack_require__(778);

var _CreateFooter2 = _interopRequireDefault(_CreateFooter);

var _constants = __webpack_require__(157);

var _utils = __webpack_require__(25);

var _InformationBlock = __webpack_require__(295);

var _InformationBlock2 = _interopRequireDefault(_InformationBlock);

var _UserNameFormat = __webpack_require__(17);

var _UserNameFormat2 = _interopRequireDefault(_UserNameFormat);

var _CopySettingsBlock = __webpack_require__(296);

var _CopySettingsBlock2 = _interopRequireDefault(_CopySettingsBlock);

var _utils2 = __webpack_require__(297);

var _MoveToArchivedConfirmationDialog = __webpack_require__(501);

var _MoveToArchivedConfirmationDialog2 = _interopRequireDefault(_MoveToArchivedConfirmationDialog);

var _atBrowserUtils = __webpack_require__(8);

var _constants2 = __webpack_require__(77);

var _BudgetsTab = __webpack_require__(502);

var _BudgetsTab2 = _interopRequireDefault(_BudgetsTab);

var _ClassicBridge = __webpack_require__(18);

var _ClassicBridge2 = _interopRequireDefault(_ClassicBridge);

var _UserEventsMap = __webpack_require__(99);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TaskPanel = function (_TemplateView) {
    _inherits(TaskPanel, _TemplateView);

    function TaskPanel(_ref) {
        var _ref$additionalClass = _ref.additionalClass,
            additionalClass = _ref$additionalClass === undefined ? "" : _ref$additionalClass,
            _ref$canEdit = _ref.canEdit,
            canEdit = _ref$canEdit === undefined ? false : _ref$canEdit,
            _ref$canEditTaskStatu = _ref.canEditTaskStatus,
            canEditTaskStatus = _ref$canEditTaskStatu === undefined ? true : _ref$canEditTaskStatu,
            _ref$showCreateFooter = _ref.showCreateFooter,
            showCreateFooter = _ref$showCreateFooter === undefined ? false : _ref$showCreateFooter,
            _ref$showComments = _ref.showComments,
            showComments = _ref$showComments === undefined ? false : _ref$showComments,
            _ref$showActions = _ref.showActions,
            showActions = _ref$showActions === undefined ? false : _ref$showActions,
            _ref$showReportTab = _ref.showReportTab,
            showReportTab = _ref$showReportTab === undefined ? false : _ref$showReportTab,
            _ref$showEmptyTaskNam = _ref.showEmptyTaskNameInput,
            showEmptyTaskNameInput = _ref$showEmptyTaskNam === undefined ? false : _ref$showEmptyTaskNam,
            dateFormat = _ref.dateFormat,
            _ref$onTaskMovedCb = _ref.onTaskMovedCb,
            onTaskMovedCb = _ref$onTaskMovedCb === undefined ? function (taskId) {} : _ref$onTaskMovedCb,
            _ref$onTaskDeletedCb = _ref.onTaskDeletedCb,
            onTaskDeletedCb = _ref$onTaskDeletedCb === undefined ? function () {} : _ref$onTaskDeletedCb,
            _ref$saveComment = _ref.saveComment,
            saveComment = _ref$saveComment === undefined ? function () {} : _ref$saveComment,
            _ref$saveEditingComme = _ref.saveEditingComment,
            saveEditingComment = _ref$saveEditingComme === undefined ? function () {} : _ref$saveEditingComme,
            _ref$toggleNewComment = _ref.toggleNewCommentInput,
            toggleNewCommentInput = _ref$toggleNewComment === undefined ? function () {} : _ref$toggleNewComment,
            _ref$updateNewComment = _ref.updateNewCommentText,
            updateNewCommentText = _ref$updateNewComment === undefined ? function () {} : _ref$updateNewComment,
            _ref$closeTaskPanel = _ref.closeTaskPanel,
            closeTaskPanel = _ref$closeTaskPanel === undefined ? function () {} : _ref$closeTaskPanel,
            _ref$setTaskPanelTab = _ref.setTaskPanelTab,
            setTaskPanelTab = _ref$setTaskPanelTab === undefined ? function () {} : _ref$setTaskPanelTab,
            _ref$setLastTaskPanel = _ref.setLastTaskPanelTab,
            setLastTaskPanelTab = _ref$setLastTaskPanel === undefined ? function () {} : _ref$setLastTaskPanel,
            _ref$openLastTaskPane = _ref.openLastTaskPanelTab,
            openLastTaskPanelTab = _ref$openLastTaskPane === undefined ? function () {} : _ref$openLastTaskPane,
            _ref$updateStatus = _ref.updateStatus,
            updateStatus = _ref$updateStatus === undefined ? function () {} : _ref$updateStatus,
            _ref$updateName = _ref.updateName,
            updateName = _ref$updateName === undefined ? function () {} : _ref$updateName,
            _ref$updateDeadline = _ref.updateDeadline,
            updateDeadline = _ref$updateDeadline === undefined ? function () {} : _ref$updateDeadline,
            _ref$updateTypeOfWork = _ref.updateTypeOfWork,
            updateTypeOfWork = _ref$updateTypeOfWork === undefined ? function () {} : _ref$updateTypeOfWork,
            _ref$updateEstimate = _ref.updateEstimate,
            updateEstimate = _ref$updateEstimate === undefined ? function () {} : _ref$updateEstimate,
            _ref$updateDescriptio = _ref.updateDescription,
            updateDescription = _ref$updateDescriptio === undefined ? function () {} : _ref$updateDescriptio,
            _ref$updateCustomFiel = _ref.updateCustomField,
            updateCustomField = _ref$updateCustomFiel === undefined ? function () {} : _ref$updateCustomFiel,
            _ref$createTask = _ref.createTask,
            createTask = _ref$createTask === undefined ? function () {} : _ref$createTask,
            _ref$deleteTask = _ref.deleteTask,
            deleteTask = _ref$deleteTask === undefined ? function () {} : _ref$deleteTask,
            _ref$moveTask = _ref.moveTask,
            moveTask = _ref$moveTask === undefined ? function () {} : _ref$moveTask,
            _ref$copyTask = _ref.copyTask,
            copyTask = _ref$copyTask === undefined ? function () {} : _ref$copyTask,
            _ref$resetDeletionSta = _ref.resetDeletionStatus,
            resetDeletionStatus = _ref$resetDeletionSta === undefined ? function () {} : _ref$resetDeletionSta,
            _ref$deleteAssignedUs = _ref.deleteAssignedUser,
            deleteAssignedUser = _ref$deleteAssignedUs === undefined ? function (userId) {} : _ref$deleteAssignedUs,
            _ref$updateAssignedUs = _ref.updateAssignedUsers,
            updateAssignedUsers = _ref$updateAssignedUs === undefined ? function () {} : _ref$updateAssignedUs,
            _ref$deleteAssignedMa = _ref.deleteAssignedManager,
            deleteAssignedManager = _ref$deleteAssignedMa === undefined ? function () {} : _ref$deleteAssignedMa,
            _ref$updateAssignedMa = _ref.updateAssignedManagers,
            updateAssignedManagers = _ref$updateAssignedMa === undefined ? function () {} : _ref$updateAssignedMa,
            _ref$loadTaskAuditHis = _ref.loadTaskAuditHistory,
            loadTaskAuditHistory = _ref$loadTaskAuditHis === undefined ? function () {} : _ref$loadTaskAuditHis,
            _ref$loadTimeComments = _ref.loadTimeComments,
            loadTimeComments = _ref$loadTimeComments === undefined ? function () {} : _ref$loadTimeComments,
            _ref$saveSortingSetti = _ref.saveSortingSettings,
            saveSortingSettings = _ref$saveSortingSetti === undefined ? function () {} : _ref$saveSortingSetti,
            _ref$toast = _ref.toast,
            toast = _ref$toast === undefined ? function (text) {} : _ref$toast;

        _classCallCheck(this, TaskPanel);

        var _this = _possibleConstructorReturn(this, (TaskPanel.__proto__ || Object.getPrototypeOf(TaskPanel)).call(this));

        _this._onMoveTask = function (customer, project) {
            if (project.archived && !_this.state.completed) {
                _this.moveToDialogScrollable.hide();

                var canRestore = customer.archived ? !!_this.state.editableCustomersIds[customer.id] : !!_this.state.editableProjectsIds[project.id];
                _this.archivingConfirmationScrollable.show();
                _this.archivingConfirmationScrollable.setState({
                    customer: customer,
                    project: project,
                    withRestoreOption: canRestore,
                    workflowStatusId: _this.state.defaultCompletedStatus.id,
                    title: !canRestore && !_this.state.isTWSEnabled ? _messageResource2.default.getMessage("task.list.move_to.move_to_archived.title.single_task.cannot_restore.feature_disabled") : _messageResource2.default.getMessage("task.list.move_to.move_to_archived.title.single_task"),
                    showRestoreNote: customer.archived && project.archived
                });
            } else {
                _this._confirmMoveHandler(customer, project, false, null);
            }
        };

        _this._handleTabSwitched = function (selectedKey, previousKey) {
            _this.archivingConfirmationScrollable.hide();

            _this.tabsController.setState({ selectedTabKey: selectedKey });

            _this.buttons.forEach(function (button, key) {
                button.toggleClass('selected', key === selectedKey);
            });

            if (selectedKey === _constants.TaskDialogs.MOVE_DIALOG) {
                _this.moveToDialogScrollable.update();
            } else if (selectedKey === _constants.TaskDialogs.COPY_DIALOG) {
                _this.copyToDialogScrollable.update();
            } else if (selectedKey === _constants.TaskDialogs.DELETE_DIALOG) {
                _this.deleteDialogScrollable.update();
            }

            _this.commentsFooter.toggle(_this.params.showComments && selectedKey === _constants.TasksTabs.DETAILS_TAB);

            //reported tab has no state, need to update scrollable container apart
            if (previousKey === _constants.TasksTabs.REPORTED_TAB) {
                _this.reportedTimeScrollable.forceUpdate();
            }

            // don't update reported time tab chart when not visible
            _this.reportedTime.totals.toggleHandlingChanges(selectedKey === _constants.TasksTabs.REPORTED_TAB);

            //in order not update details tab
            if (selectedKey === _constants.TasksTabs.DETAILS_TAB) {
                _this.taskPanelDetailsScrollable.forceUpdate();
            } else {
                _this.getTabView(selectedKey).update();
            }

            if (selectedKey === _constants.TasksTabs.BUDGETS) {
                _ClassicBridge2.default.sendUserEvent(_UserEventsMap.UserEventsMap.BUDGET_TAB_OPEN, _UserEventsMap.BudgetTabOpenEventEntityParams.TASK);
            }
        };

        _this.updateOnInit = false;

        _this.params = {
            canEdit: canEdit,
            additionalClass: additionalClass,
            dateFormat: dateFormat,

            showCreateFooter: showCreateFooter,
            showComments: showComments,
            showActions: showActions,
            showReportTab: showReportTab,
            showEmptyTaskNameInput: showEmptyTaskNameInput
        };

        _this.callbacks = {
            onTaskDeletedCb: onTaskDeletedCb,
            onTaskMovedCb: onTaskMovedCb
        };

        _this.actions = {
            saveComment: saveComment,
            saveEditingComment: saveEditingComment,
            toggleNewCommentInput: toggleNewCommentInput,
            updateNewCommentText: updateNewCommentText,
            closeTaskPanel: closeTaskPanel,
            setTaskPanelTab: setTaskPanelTab,
            setLastTaskPanelTab: setLastTaskPanelTab,
            openLastTaskPanelTab: openLastTaskPanelTab,
            updateStatus: updateStatus,
            updateName: updateName,
            updateDeadline: updateDeadline,
            updateTypeOfWork: updateTypeOfWork,
            updateEstimate: updateEstimate,
            updateDescription: updateDescription,
            updateCustomField: updateCustomField,
            createTask: createTask,
            deleteTask: deleteTask,
            moveTask: moveTask,
            copyTask: copyTask,
            resetDeletionStatus: resetDeletionStatus,
            deleteAssignedUser: deleteAssignedUser,
            updateAssignedUsers: updateAssignedUsers,
            deleteAssignedManager: deleteAssignedManager,
            updateAssignedManagers: updateAssignedManagers,
            loadTaskAuditHistory: loadTaskAuditHistory,
            loadTimeComments: loadTimeComments,
            saveSortingSettings: saveSortingSettings,
            toast: toast
        };

        _this.state = {
            currentTabKey: _constants.TasksTabs.DETAILS_TAB,
            lastSelectedTabKey: _constants.TasksTabs.DETAILS_TAB,
            loggedInUser: null,
            sendingComment: false,
            showNewCommentInput: false,
            newCommentText: '',

            canEdit: canEdit,
            openTaskId: null,
            openTaskNextId: null,
            loading: false,
            projectName: '',
            customerName: '',
            customer: {},

            completed: false,
            workflowStatusId: 0,
            name: '',
            deadline: null,
            typeOfWork: null,
            typesOfWork: [],
            estimatedTime: 0,
            spentTime: 0,
            description: '',
            commentsCount: 0,

            nameUpdating: false,
            deadlineUpdating: false,
            typeOfWorkUpdating: false,
            descriptionUpdating: false,
            estimateUpdating: false,
            statusUpdating: false,
            moveToDialogLoading: false,

            errors: {},

            isBTYEnabled: false,
            isURAEnabled: false,
            isBRAEnabled: false,
            isTWSEnabled: false,
            isESTEnabled: false,
            isWASEnabled: false,
            isTTAEnabled: false,
            isCPTBUDEnabled: false,

            assignedUsers: [],
            assignedManagers: [],
            userGroupsEnabled: true,
            timeZoneGroupsEnabled: true,
            userGroups: [],
            timeZoneGroups: [],
            canModifyAnyUser: false,
            canModifyAnyManager: false,
            canEditHierarchy: false,
            canEditTaskStatus: canEditTaskStatus,

            taskDetails: {},
            taskDeletedSuccessfully: false,
            taskDeletedUnsuccessfully: false,

            copyMoveSelectorsCustomerIds: {},
            copyMoveSelectorsProjectIds: {},
            editableCustomersIds: {},
            editableProjectsIds: {},

            auditActions: [],
            lastAuditActions: {
                createAction: null,
                updateAction: null
            },
            allAuditHistoryLoaded: false,

            canReopenProject: false,
            canMoveTask: true,
            canManageAccountsAndPermissions: false,
            canGenerateMoneyReports: false,
            hasManageScopeRights: false,

            executorsSummary: {
                total: null,
                myRecord: null,
                myTeamRecords: [],
                othersRecords: [],
                myTeamTotal: 0,
                othersTotal: 0
            },
            reportedTimeComments: [],
            allTimeCommentsLoaded: false,
            timeAndCommentsLoading: false,
            sortingSettings: {
                sortBy: null,
                sortOrder: null
            },

            isNeedInitializeFocus: false,

            defaultCompletedStatus: {},

            hasSomeTeamAssignment: false,
            isTaskAssigned: false,

            customFields: [],
            customFieldsValues: {},
            readOnlyFields: []
        };

        _this.onStatePropertyChanged('isNeedInitializeFocus', function (isNeedInitializeFocus) {
            _this.header.setState({ isNeedInitializeFocus: isNeedInitializeFocus });
        });

        _this.onStatePropertyChanged('currentTabKey', _this._handleTabSwitched);

        _this.onAnyStatePropertyChanged(['loggedInUser', 'sendingComment', 'showNewCommentInput', 'newCommentText'], function (state) {
            _this.commentsFooter.setState({
                loggedInUser: state.loggedInUser,
                sending: state.sendingComment,
                showNewCommentInput: state.showNewCommentInput,
                commentText: state.newCommentText
            });
        });

        _this.onAnyStatePropertyChanged(['name', 'nameUpdating', 'errors', 'projectName', 'customerName', 'canEdit'], function (state) {
            _this.header.setState({
                name: state.name,
                projectName: state.projectName,
                customerName: state.customerName,
                editable: state.canEdit,
                nameLoading: state.nameUpdating,
                errors: state.errors
            });
        });

        _this.onAnyStatePropertyChanged(['errors'], function (state) {
            _this.createFooter.setState({
                hasErrors: Object.keys(state.errors).length > 0
            });
        });

        _this.onStatePropertyChanged("openTaskId", function (taskId) {
            _this.getTabView(_constants.TasksTabs.DETAILS_TAB).setState({
                id: taskId
            });
            _this.actions.openLastTaskPanelTab();
        });

        _this.onAnyStatePropertyChanged(['openTaskId', 'completed', 'workflowStatusId', 'deadline', 'typeOfWork', 'typesOfWork', 'estimatedTime', 'spentTime', 'description', 'canReopenProject', 'isBTYEnabled', 'isTWSEnabled', 'isESTEnabled', 'customFieldsValues', 'customFields', 'deadlineUpdating', 'typeOfWorkUpdating', 'estimateUpdating', 'descriptionUpdating', 'statusUpdating', 'auditActions', 'auditDependencies', 'lastAuditActions', 'allAuditHistoryLoaded', 'readonlyFields'], function (state) {
            _this.getTabView(_constants.TasksTabs.DETAILS_TAB).setState({
                completed: state.completed,
                workflowStatusId: state.workflowStatusId,
                deadline: state.deadline,
                typeOfWork: state.typeOfWork,
                typesOfWork: state.typesOfWork,
                taskEstimatedTime: state.estimatedTime,
                taskSpentTime: state.spentTime,
                taskDescription: state.description,
                isBTYEnabled: state.isBTYEnabled,
                isTWSEnabled: state.isTWSEnabled,
                isESTEnabled: state.isESTEnabled,
                canReopenProject: state.canReopenProject,

                deadlineLoading: state.deadlineUpdating,
                typeOfWorkLoading: state.typeOfWorkUpdating,
                estimateLoading: state.estimateUpdating,
                taskDescriptionLoading: state.descriptionUpdating,
                statusLoading: state.statusUpdating,

                auditActions: state.auditActions,
                auditDependencies: state.auditDependencies,
                lastAuditActions: state.lastAuditActions,
                allAuditHistoryLoaded: state.allAuditHistoryLoaded,

                customFields: state.customFields,
                customFieldsValues: state.customFieldsValues,
                readonlyFields: state.readonlyFields
            });
        });

        _this.onStatePropertyChanged('estimatedTime', function (time) {
            _this.reportedTime.updateEstimated(time);
        });

        _this.onAnyStatePropertyChanged(['completed', 'moveToDialogLoading'], function (state) {
            _this.moveToDialog.setLoading(state.moveToDialogLoading);
        });

        _this.onAnyStatePropertyChanged(['customer'], function (state) {
            if (state.customer) {
                _this.moveToDialog.setState({ selectedCustomer: state.customer });
                _this.copyToDialog.setState({ selectedCustomer: state.customer });
            }
        });

        _this.onAnyStatePropertyChanged(['copyMoveSelectorsProjectIds', 'copyMoveSelectorsCustomerIds'], function (state) {
            _this.moveToDialog.setCustomersToMove(state.copyMoveSelectorsCustomerIds);
            _this.moveToDialog.setProjectsToMove(state.copyMoveSelectorsProjectIds);
            _this.copyToDialog.setCustomersToMove(state.copyMoveSelectorsCustomerIds);
            _this.copyToDialog.setProjectsToMove(state.copyMoveSelectorsProjectIds);
        });

        _this.onAnyStatePropertyChanged(['canManageAccountsAndPermissions', 'isBTYEnabled', 'isESTEnabled', 'isTWSEnabled', 'isWASEnabled', 'hasSomeTeamAssignment'], function () {
            _this.copySettingsBlock.setState((0, _utils2.getItemsForCopyTaskSettingsBlock)(_this.state.canManageAccountsAndPermissions, _this.state.isBTYEnabled, _this.state.isESTEnabled, _this.state.isTWSEnabled, _this.state.isWASEnabled, _this.state.hasSomeTeamAssignment));
        });

        _this.onStatePropertyChanged('canEdit', function (editable) {
            return _this.setEditable(editable);
        });

        _this.onStatePropertyChanged('openTaskId', function (openTaskId) {
            if (openTaskId !== null) {
                if (_this.state.currentTabKey === _constants.TasksTabs.REPORTED_TAB) {
                    _this.reportedTimeScrollable.scrollToTop();
                } else if (_this.state.currentTabKey === _constants.TaskDialogs.DETAILS_TAB || _this.state.currentTabKey === _constants.TaskDialogs.ASSIGNED_USERS_TAB || _this.state.currentTabKey === _constants.TaskDialogs.MANAGERS_TAB) {
                    _this.getTabView(_this.state.currentTabKey).scrollToTop();
                }
            }
        });

        _this.onStatePropertyChanged('assignedManagers', function (managers) {
            _this.managersEditorContainer.setState({ users: managers });
        });

        _this.onStatePropertyChanged('assignedUsers', function (users) {
            _this.assignedUsersEditorContainer.setState({ users: users });
        });

        // change state of assigned users tab
        _this.onAnyStatePropertyChanged(['userGroupsEnabled', 'timeZoneGroupsEnabled', 'userGroups', 'timeZoneGroups', 'canModifyAnyUser', 'canEdit'], function (_ref2) {
            var userGroupsEnabled = _ref2.userGroupsEnabled,
                timeZoneGroupsEnabled = _ref2.timeZoneGroupsEnabled,
                userGroups = _ref2.userGroups,
                timeZoneGroups = _ref2.timeZoneGroups,
                canModifyAnyUser = _ref2.canModifyAnyUser,
                canEdit = _ref2.canEdit;

            var data = { userGroupsEnabled: userGroupsEnabled, timeZoneGroupsEnabled: timeZoneGroupsEnabled, userGroups: userGroups, timeZoneGroups: timeZoneGroups,
                canModifyAny: canModifyAnyUser,
                hideAssignButton: !canEdit
            };
            _this.assignedUsersEditorContainer.setState(data);
        });

        _this.onStatePropertyChanged('canEditTaskStatus', function (canEditTaskStatus) {
            _this.taskPanelDetails.setState({ canEditTaskStatus: canEditTaskStatus });
            _this.archivingConfirmation.setState({ canEditTaskStatus: canEditTaskStatus });
        });

        // change state of assigned managers tab
        _this.onAnyStatePropertyChanged(['userGroupsEnabled', 'timeZoneGroupsEnabled', 'userGroups', 'timeZoneGroups', 'canModifyAnyManager'], function (_ref3) {
            var userGroupsEnabled = _ref3.userGroupsEnabled,
                timeZoneGroupsEnabled = _ref3.timeZoneGroupsEnabled,
                userGroups = _ref3.userGroups,
                timeZoneGroups = _ref3.timeZoneGroups,
                canModifyAnyManager = _ref3.canModifyAnyManager;

            var data = { userGroupsEnabled: userGroupsEnabled, timeZoneGroupsEnabled: timeZoneGroupsEnabled, userGroups: userGroups, timeZoneGroups: timeZoneGroups,
                canModifyAny: canModifyAnyManager,
                hideAssignButton: !canModifyAnyManager
            };
            _this.managersEditorContainer.setState(data);
        });

        _this.onAnyStatePropertyChanged(['name', 'taskDetails'], function (_ref4) {
            var name = _ref4.name,
                taskDetails = _ref4.taskDetails;

            _this.header.updateActions(taskDetails);
            _this.updateDeleteDialog(name, taskDetails);
        });

        _this.onStatePropertyBecameTrue('taskDeletedUnsuccessfully', function () {
            // this.header.actions.disableDeleteButton(message); //todo koshik message
            _this.actions.openLastTaskPanelTab();
            _this.actions.resetDeletionStatus();
        });

        _this.onStatePropertyBecameTrue('taskDeletedSuccessfully', function () {
            _this.callbacks.onTaskDeletedCb(_this.state.openTaskId);
            _this.actions.resetDeletionStatus();
        });

        _this.onStatePropertyChanged('executorsSummary', function () {
            _this.reportedTime.updateSummaryRecords(_this.state.executorsSummary);
        });

        _this.onStatePropertyChanged('timeAndCommentsLoading', function (timeAndCommentsLoading) {
            _this.reportedTime.setTimeAndCommentsLoading(timeAndCommentsLoading);
        });

        _this.onStatePropertyChanged('reportedTimeComments', function (reportedTimeComments) {
            _this.reportedTime.clearTimeRows();
            _this.reportedTime.updateTimeRows(reportedTimeComments);
            _this.reportedTimeScrollable.forceUpdate();
        });

        _this.onStatePropertyChanged('sortingSettings', function (sortingSettings) {
            _this.reportedTime.setTableSettings(sortingSettings);
        });

        _this.onAnyStatePropertyChanged(['isBTYEnabled', 'isURAEnabled', 'isTTAEnabled'], function (_ref5) {
            var isBTYEnabled = _ref5.isBTYEnabled,
                isURAEnabled = _ref5.isURAEnabled,
                isTTAEnabled = _ref5.isTTAEnabled;

            _this.managersEditorScrollable.setState({ isBTYEnabled: isBTYEnabled, isURAEnabled: isURAEnabled, isTTAEnabled: isTTAEnabled });
        });

        _this.onStatePropertyChanged('isWASEnabled', function (isWASEnabled) {
            _this.buttons.get(_constants.TasksTabs.ASSIGNED_USERS_TAB).toggle(isWASEnabled);
            _this._updateDialogsInfo();
        });

        _this.onStatePropertyChanged('isTWSEnabled', function (isTWSEnabled) {
            _this.archivingConfirmation.setState({
                isTWSEnabled: isTWSEnabled,
                archiveText: isTWSEnabled ? _messageResource2.default.getMessage("task.list.move_to.move_to_archived.complete_with_status.single_task") : _messageResource2.default.getMessage("task.list.move_to.move_to_archived.complete_with_status.single_task.feature_disabled")
            });
        });

        _this.onAnyStatePropertyChanged(['isCPTBUDEnabled', 'isURAEnabled', 'isTaskAssigned', 'isBRAEnabled', 'openTaskNextId', 'typeOfWork', 'canGenerateMoneyReports', 'canEditHierarchy'], function (_ref6) {
            var isCPTBUDEnabled = _ref6.isCPTBUDEnabled,
                isTaskAssigned = _ref6.isTaskAssigned,
                canGenerateMoneyReports = _ref6.canGenerateMoneyReports,
                canEditHierarchy = _ref6.canEditHierarchy,
                isURAEnabled = _ref6.isURAEnabled,
                isBRAEnabled = _ref6.isBRAEnabled,
                openTaskNextId = _ref6.openTaskNextId,
                typeOfWork = _ref6.typeOfWork;

            if ((canGenerateMoneyReports || canEditHierarchy) && isCPTBUDEnabled && isTaskAssigned && openTaskNextId !== null && openTaskNextId !== -1) {
                _this.header.$tabs[_constants.TasksTabs.BUDGETS].toggle(true);
                _this.budgetsTab.setState({
                    relatedId: openTaskNextId,
                    areCostBudgetsEnabled: isURAEnabled && canGenerateMoneyReports,
                    areBillingBudgetsEnabled: isBRAEnabled && canGenerateMoneyReports,
                    typeOfWork: typeOfWork
                });
            } else {
                if (_this.state.currentTabKey === _constants.TasksTabs.BUDGETS) {
                    //Do not remove this line - AT-11569
                    //Budgets tab will be asynchronously mounted again with relatedId of non existed target
                    _this.budgetsTab.setState({ relatedId: null });
                    _this.actions.setTaskPanelTab(_constants.TasksTabs.DETAILS_TAB);
                }
                _this.header.$tabs[_constants.TasksTabs.BUDGETS].toggle(false);
            }
        });
        return _this;
    }

    _createClass(TaskPanel, [{
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='taskPanelContent <%-additionalClass%>'>" + "  <div class='headerBlock'/>" + "  <div class='contentScrollableWrapper'>" + "    <div class='taskPanelInnerContent'/>" + "  </div>" + "  <div class='commentsFooterBlock'/>" + "  <div class='createFooterBlock'/>" + "</div>";
        }
    }, {
        key: "templateModel",
        value: function templateModel() {
            return {
                additionalClass: this.params.additionalClass
            };
        }
    }, {
        key: "update",
        value: function update() {
            var _this2 = this;

            if (!this.state.currentTabKey) {
                this.actions.setTaskPanelTab(_constants.TasksTabs.DETAILS_TAB);
            }

            this.header.update();

            _underscore2.default.forEach(_constants.TasksTabs, function (key) {
                var tabView = _this2.getTabView(key);
                if (tabView) {
                    tabView.update();
                }
            });
        }
    }, {
        key: "updateDeleteDialog",
        value: function updateDeleteDialog(name, state) {
            if (!state.blockedDueToLockedTime && !state.blockedDueToUnavailableToModifyTimeTrack) {
                this.deleteDialog.setState({
                    entityName: name,
                    entitiesToDeleteCount: 1,
                    entitiesBlocked: 0,
                    entitiesBlockedCount: 0,
                    entitiesBlockedDueToLockedTimeCount: 0,
                    entitiesBlockedDueToUnavailableToModifyTimeTrackCount: 0,
                    entitiesWithManagerTimeTrackCount: state.taskHasManagerTimeTrack ? 1 : 0,
                    entitiesWithOtherUsersTimeTrackCount: state.taskHasOtherUsersTimeTrack ? 1 : 0,
                    entitiesWithManagerApprovedTimeTrackCount: state.taskHasManagerApprovedTimeTrack ? 1 : 0,
                    entitiesWithOtherUsersApprovedTimeTrackCount: state.taskHasOtherUsersApprovedTimeTrack ? 1 : 0,
                    hasManagerApprover: state.hasManagerApprover
                });
                this.deleteDialogScrollable.update();
            }
        }
    }, {
        key: "setEditable",
        value: function setEditable(editable) {
            var _this3 = this;

            _underscore2.default.forEach(_constants.TasksTabs, function (key) {
                var tabView = _this3.getTabView(key);
                if (tabView && tabView.setEditable) {
                    tabView.setEditable(editable);
                }
                tabView.setState({
                    editable: editable
                });
            });
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            var _this4 = this;

            this.$content = this.find(".taskPanelInnerContent");
            this.$header = this.find(".headerBlock");
            this.$contentWrapper = this.find('.contentScrollableWrapper');

            this.header = new _Header2.default(this.$header, this.$el, {
                editable: this.state.canEdit,
                showActions: this.params.showActions,
                showReportTab: this.params.showReportTab,
                showEmptyNameInput: this.params.showEmptyTaskNameInput,
                onChangeNameCb: this.actions.updateName,
                onTabSwitchedCb: function onTabSwitchedCb(key) {
                    return _this4.actions.setTaskPanelTab(key);
                }
            }).init();

            var assignedUsersEditor = new _LoadingContainer2.default({
                contentComponent: new _AssignedUsersEditor2.default({
                    onUserDelete: function onUserDelete(userData) {
                        return _this4.actions.deleteAssignedUser(userData.id);
                    },
                    onAssignedUsersChange: function onAssignedUsersChange(_ref7) {
                        var addedUserIds = _ref7.addedUserIds,
                            removedUserIds = _ref7.removedUserIds;
                        return _this4.actions.updateAssignedUsers(addedUserIds, removedUserIds);
                    },
                    titleMessageKey: "assigned_users_editor.task.title",
                    userSubtitleGenerator: function userSubtitleGenerator(user) {
                        if (user.hasAllAssignments) {
                            return _messageResource2.default.getMessage("assigned_users_editor.task.has_all_assignments");
                        } else if (user.hasCustomerAssignment) {
                            return _messageResource2.default.getMessage("assigned_users_editor.task.has_customer_assignment");
                        } else if (user.hasProjectAssignment) {
                            return _messageResource2.default.getMessage("assigned_users_editor.task.has_project_assignment");
                        }
                    },
                    managersMessageKey: "assigned_users_editor.task.managers_count",
                    canEditManagers: false,
                    addUsersMessageKey: "assigned_users_editor.add_title",
                    emptyListMessageKey: "assigned_users_editor.task.empty_list",
                    showPermissionIcons: false,
                    usersSelectorTitle: _messageResource2.default.getMessage("assigned_users_editor.task.users_selector_title"),
                    renderUserSelectorToContent: true,
                    refreshScrollCb: function refreshScrollCb() {
                        return _this4.assignedUsersEditorScrollable.forceUpdate();
                    },
                    checkIfCanModify: function checkIfCanModify(user) {
                        return !user.hasManageAssignment;
                    },
                    getListDisabledTooltipText: function getListDisabledTooltipText(user) {
                        return _this4._getDisabledTooltipTextAssugnedUsersEditor(user);
                    },
                    getSelectorDisabledTooltipText: function getSelectorDisabledTooltipText(user) {
                        return _this4._getDisabledTooltipTextAssignedUsersSelector(user);
                    }
                }),
                containerClass: "assignedUsersTab panelTab"
            });
            this.assignedUsersEditorScrollable = new _ScrollableContainer2.default(null, assignedUsersEditor, {
                needRefreshOnResize: true,
                showScrollToTopButton: true,
                containerClass: 'assignedUsersScrollableContainer',
                triggerScrollEvent: true,
                iScrollParams: {
                    probeType: 2
                }
            }).init(this.$content);
            this.assignedUsersEditorContainer = new _AssignedUsersEditorContainer2.default({
                assignedUsersEditor: this.assignedUsersEditorScrollable,
                $tabTitle: this.header.$assignedUsersTabTitle,
                tabTitleMessageKey: "task.edit_panel.tabs.assigned_users_with_count"
            }).init();

            var managersEditor = new _LoadingContainer2.default({
                contentComponent: new _AssignedUsersEditor2.default({
                    onUserDelete: function onUserDelete(userData) {
                        _this4.actions.deleteAssignedManager(userData);
                        _this4._handleManagersRemovedToast([userData.id]);
                    },
                    onAssignedUsersChange: function onAssignedUsersChange(_ref8) {
                        var addedUserIds = _ref8.addedUserIds,
                            removedUserIds = _ref8.removedUserIds;

                        _this4.actions.updateAssignedManagers(addedUserIds, removedUserIds);

                        if (!_this4.params.showCreateFooter) {
                            _this4._handleManagersRemovedToast(removedUserIds);
                        }
                    },
                    titleMessageKey: "assigned_users_editor.managers.task.title",
                    userSubtitleGenerator: function userSubtitleGenerator(user) {
                        if (user.hasAllAssignments) {
                            return _messageResource2.default.getMessage("assigned_users_editor.managers.task.has_all_assignments");
                        } else if (user.hasCustomerAssignment) {
                            return _messageResource2.default.getMessage("assigned_users_editor.managers.task.has_customer_assignment");
                        } else if (user.hasProjectAssignment) {
                            return _messageResource2.default.getMessage("assigned_users_editor.managers.task.has_project_assignment");
                        }
                    },
                    addUsersMessageKey: "assigned_users_editor.managers.add_title",
                    showPermissionIcons: true,
                    usersSelectorTitle: _messageResource2.default.getMessage("assigned_users_editor.managers.task.users_selector_title"),
                    renderUserSelectorToContent: true,
                    refreshScrollCb: function refreshScrollCb() {
                        return _this4.managersEditorScrollable.forceUpdate();
                    },
                    checkIfCanModify: function checkIfCanModify(user) {
                        return !(user.hasAllAssignments || user.hasCustomerAssignment || user.hasAllFutureProjectsOfCustomerAssignment || user.hasProjectAssignment || user.hasAllFutureTasksOfProjectAssignment);
                    },
                    getListDisabledTooltipText: function getListDisabledTooltipText(user) {
                        return _this4._getDisabledTooltipText(user);
                    }
                }),
                containerClass: "managersTab panelTab"
            });
            this.managersEditorScrollable = new _ScrollableContainer2.default(null, managersEditor, {
                needRefreshOnResize: true,
                showScrollToTopButton: true,
                containerClass: 'assignedUsersScrollableContainer',
                triggerScrollEvent: true,
                iScrollParams: {
                    probeType: 2
                }
            }).init(this.$content);
            this.managersEditorContainer = new _AssignedUsersEditorContainer2.default({
                assignedUsersEditor: this.managersEditorScrollable,
                $tabTitle: this.header.$managersTabTitle,
                tabTitleMessageKey: "task.edit_panel.tabs.managers_with_count"
            }).init();

            this.budgetsTab = new _BudgetsTab2.default({
                relatedType: _BudgetsTab.RelatedType.Task
            }).init(this.$content);

            this._initMoveToDialog();
            this._initCopyToDialog();

            this.deleteDialog = new _DeleteTaskPopupConfirmationDialog2.default(this.$content, function () {
                return _this4.actions.openLastTaskPanelTab();
            }, function (revokeStatuses) {
                return _this4.actions.deleteTask(revokeStatuses);
            }).init();
            this.deleteDialogScrollable = new _ScrollableContainer2.default(null, this.deleteDialog, { needRefreshOnResize: true }).init(this.$content);

            this.taskPanelDetails = new _TaskPanelDetails2.default({
                editable: this.state.canEdit,
                showComments: this.params.showComments,
                dateFormat: this.params.dateFormat,
                refreshScrollCb: function refreshScrollCb() {
                    return _this4.taskPanelDetailsScrollable.forceUpdate();
                },
                scrollToElementCb: function scrollToElementCb($el, pos) {
                    return _this4.taskPanelDetailsScrollable.scrollToElementVertical($el, pos);
                },
                onStatusChangedCb: function onStatusChangedCb(id) {
                    return _this4.actions.updateStatus(id);
                },
                onDeadlineChangedCb: function onDeadlineChangedCb(date) {
                    return _this4.actions.updateDeadline(date);
                },
                onTypeOfWorkChangedCb: function onTypeOfWorkChangedCb(id) {
                    return _this4.actions.updateTypeOfWork(id);
                },
                onEstimateChangedCb: function onEstimateChangedCb(time) {
                    return _this4.actions.updateEstimate(time);
                },
                onDescriptionChangeCb: function onDescriptionChangeCb(text) {
                    return _this4.actions.updateDescription(text);
                },
                onCustomFieldChangeCb: function onCustomFieldChangeCb(field, value) {
                    return _this4.actions.updateCustomField(field, value);
                },
                loadAuditHistoryCb: this.actions.loadTaskAuditHistory,
                onHistoryClickCb: function onHistoryClickCb(e) {
                    return (0, _utils.setEventPreventHidingEditTaskSlidingPanel)(e);
                }
            });
            this.taskPanelDetailsScrollable = new _ScrollableContainer2.default(null, this.taskPanelDetails, {
                needRefreshOnResize: true,
                shouldUpdateOnInit: false,
                showScrollToTopButton: true,
                triggerScrollEvent: true,
                iScrollParams: {
                    probeType: 2,
                    eventPassthrough: 'vertical',
                    mouseWheel: true
                },
                ignoreScrollingPredicate: function ignoreScrollingPredicate(event) {
                    // prenvet block events for atnext scrollbar
                    return (0, _atBrowserUtils.checkElementOrAncestorHasClass)(event.target, _constants2.AtNextCustomScrollbarUsedClassName);
                }
            });
            this.taskPanelDetailsScrollable.init(this.$content);

            this.reportedTime = new _ReportedTime2.default(this.$content);
            this.reportedTimeScrollable = new _ScrollableContainer2.default(null, this.reportedTime, {
                needRefreshOnResize: true,
                shouldUpdateOnInit: false,
                showScrollToTopButton: true,
                triggerScrollEvent: true,
                onScrollToBottom: function onScrollToBottom() {
                    // TODO: this check should ideally be placed in redux actions, but this component is not ready for it yet
                    if (_this4.state.currentTabKey === _constants.TasksTabs.REPORTED_TAB && !_this4.state.allTimeCommentsLoaded) {
                        _this4.actions.loadTimeComments(_this4.state.sortingSettings.sortBy, _this4.state.sortingSettings.sortOrder, _this4.state.reportedTimeComments.length);
                    }
                },
                iScrollParams: {
                    probeType: 2
                }
            }).init(this.$content);

            this.tabs = new Map([[_constants.TasksTabs.DETAILS_TAB, this.taskPanelDetailsScrollable], [_constants.TasksTabs.REPORTED_TAB, this.reportedTimeScrollable], [_constants.TasksTabs.ASSIGNED_USERS_TAB, this.assignedUsersEditorScrollable], [_constants.TasksTabs.MANAGERS_TAB, this.managersEditorScrollable], [_constants.TasksTabs.BUDGETS, this.budgetsTab], [_constants.TaskDialogs.MOVE_DIALOG, this.moveToDialogScrollable], [_constants.TaskDialogs.COPY_DIALOG, this.copyToDialogScrollable], [_constants.TaskDialogs.DELETE_DIALOG, this.deleteDialogScrollable]]);

            this.commentsFooter = new _CommentsFooter2.default({
                onCommentTextChange: this.actions.updateNewCommentText,
                onShowInputChanged: this.actions.toggleNewCommentInput,
                onCommentAdded: this.actions.saveComment,
                refreshScrollCb: function refreshScrollCb() {
                    _this4.taskPanelDetailsScrollable.performIfScrollToBottom(function () {
                        _this4.taskPanelDetailsScrollable.forceUpdate();
                        _this4.taskPanelDetailsScrollable.scrollToBottom();
                    });
                    _this4.taskPanelDetailsScrollable.forceUpdate();
                }
            }).init(this.find('.commentsFooterBlock'));
            this.commentsFooter.toggle(this.params.showComments);

            this.tabs.forEach(function ($tab, tabKey) {
                $tab.hide();
            });

            this.tabsController = new _TabsController2.default({
                tabs: this.tabs
            }).init();

            this.buttons = new Map([[_constants.TasksTabs.DETAILS_TAB, this.header.$tabs[_constants.TasksTabs.DETAILS_TAB]], [_constants.TasksTabs.REPORTED_TAB, this.header.$tabs[_constants.TasksTabs.REPORTED_TAB]], [_constants.TasksTabs.ASSIGNED_USERS_TAB, this.header.$tabs[_constants.TasksTabs.ASSIGNED_USERS_TAB]], [_constants.TasksTabs.MANAGERS_TAB, this.header.$tabs[_constants.TasksTabs.MANAGERS_TAB]], [_constants.TasksTabs.BUDGETS, this.header.$tabs[_constants.TasksTabs.BUDGETS]], [_constants.TaskDialogs.DELETE_DIALOG, this.header.actions.menu.$delete], [_constants.TaskDialogs.MOVE_DIALOG, this.header.actions.menu.$move], [_constants.TaskDialogs.COPY_DIALOG, this.header.actions.menu.$copy]]);

            this.createFooter = new _CreateFooter2.default({
                additionalClass: 'taskPanel',
                submitBtnLabelMsgKey: 'task.create_panel.add_task',
                withPlusIcon: true,
                onSubmitCb: function onSubmitCb() {
                    return _this4.actions.createTask();
                },
                onCancelCb: function onCancelCb() {
                    return _this4.actions.closeTaskPanel();
                }
            }).init(this.find('.createFooterBlock'));
            this.createFooter.toggle(this.params.showCreateFooter);

            this.reportedTime.dateHeader.on('click', function () {
                return _this4._reportedTimeSortChangedHandler(_this4.reportedTime.dateHeader);
            });
            this.reportedTime.userHeader.on('click', function () {
                return _this4._reportedTimeSortChangedHandler(_this4.reportedTime.userHeader);
            });
        }
    }, {
        key: "_initCopyToDialog",
        value: function _initCopyToDialog() {
            var _this5 = this;

            this.copySettingsBlock = new _CopySettingsBlock2.default(_extends({}, (0, _utils2.getItemsForCopyTaskSettingsBlock)(this.state.canManageAccountsAndPermissions, this.state.isBTYEnabled, this.state.isESTEnabled, this.state.isTWSEnabled, this.state.isWASEnabled, this.state.hasSomeTeamAssignment)));

            this.copyToDialogInfoBlock = new _InformationBlock2.default();
            this.copyToDialog = new _MoveToDialog2.default({
                mode: _MoveToDialog2.default.Mode.CUSTOMER_PROJECT,
                titleMessageKey: "task.list.copy_to.task.title",
                buttonMessageKey: "edit_panel.action.copy",
                onMoveCb: function onMoveCb(customer, project, settings) {
                    return _this5._onCopyTask(customer.id, project.id, settings);
                },
                onCancelCb: function onCancelCb() {
                    return _this5.actions.openLastTaskPanelTab();
                },
                infoBlock: this.copyToDialogInfoBlock,
                settingsBlock: this.copySettingsBlock,
                selectedCustomer: this.state.customer
            });

            this.copyToDialogScrollable = new _ScrollableContainer2.default(null, this.copyToDialog, { needRefreshOnResize: true }).init(this.$content);
        }
    }, {
        key: "_initMoveToDialog",
        value: function _initMoveToDialog() {
            var _this6 = this;

            this.moveToDialogInfoBlock = new _InformationBlock2.default({
                title: _messageResource2.default.getMessage('task.list.move_to.task.info_title')
            });
            this.moveToDialog = new _MoveToDialog2.default({
                mode: _MoveToDialog2.default.Mode.CUSTOMER_PROJECT,
                titleMessageKey: "task.list.move_to.task.title",
                buttonMessageKey: "edit_panel.action.move",
                onMoveCb: this._onMoveTask,
                onCancelCb: function onCancelCb() {
                    return _this6.actions.openLastTaskPanelTab();
                },
                infoBlock: this.moveToDialogInfoBlock,
                selectedCustomer: this.state.customer
            });

            this.moveToDialogScrollable = new _ScrollableContainer2.default(null, this.moveToDialog, { needRefreshOnResize: true }).init(this.$content);
            this.moveToDialog.setState({ showArchived: true });

            this._initMoveToArchiveConfirmationDialog();
        }
    }, {
        key: "_initMoveToArchiveConfirmationDialog",
        value: function _initMoveToArchiveConfirmationDialog() {
            var _this7 = this;

            this.archivingConfirmation = new _MoveToArchivedConfirmationDialog2.default({
                confirmCallback: function confirmCallback(_ref9) {
                    var customer = _ref9.customer,
                        project = _ref9.project,
                        withRestore = _ref9.withRestore,
                        workflowStatusId = _ref9.workflowStatusId;

                    _this7.archivingConfirmationScrollable.hide();
                    _this7._confirmMoveHandler(customer, project, withRestore, withRestore ? null : workflowStatusId);
                },
                cancelCallback: function cancelCallback() {
                    _this7.archivingConfirmationScrollable.hide();
                    var moveToDialogState = _this7.moveToDialog.getState();
                    _this7.moveToDialogScrollable.show();
                    _this7.moveToDialog.setState(moveToDialogState);
                }
            });
            this.archivingConfirmation.setState({
                workflowStatusId: this.state.defaultCompletedStatus.id,
                title: _messageResource2.default.getMessage("task.list.move_to.move_to_archived.title.single_task"),
                singleOptionDescription: _messageResource2.default.getMessage("task.list.move_to.move_to_archived.can_not_manage_description.task"),
                multiOptionDescription: _messageResource2.default.getMessage("task.list.move_to.move_to_archived.can_manage_description"),
                archiveText: _messageResource2.default.getMessage("task.list.move_to.move_to_archived.complete_with_status.single_task"),
                restoreText: _messageResource2.default.getMessage("task.list.move_to.move_to_archived.restore_target_from_archive.project"),
                restoreNoteText: _messageResource2.default.getMessage("task.list.move_to.move_to_archived.restore_target_from_archive.description")
            });
            this.archivingConfirmationScrollable = new _ScrollableContainer2.default(null, this.archivingConfirmation, { needRefreshOnResize: true }).init(this.$content);
        }
    }, {
        key: "_updateDialogsInfo",
        value: function _updateDialogsInfo() {
            this.moveToDialogInfoBlock.setState({
                paragraphs: [_messageResource2.default.getMessage(this.state.isWASEnabled ? 'task.list.move_to.task.info_paragraph1' : 'task.list.move_to.task.info_paragraph1_was_off'), _messageResource2.default.getMessage(this.state.isWASEnabled ? 'task.list.move_to.task.info_paragraph2' : 'task.list.move_to.task.info_paragraph2_was_off')]
            });

            this.copyToDialogInfoBlock.setState({
                paragraphs: [_messageResource2.default.getMessage(this.state.isWASEnabled ? 'task.list.copy_to.task.info_paragraph' : 'task.list.copy_to.task.info_paragraph_was_off')]
            });
        }
    }, {
        key: "_handleManagersRemovedToast",
        value: function _handleManagersRemovedToast(removedUserIds) {
            if (removedUserIds.length === 1) {
                var user = this.state.assignedManagers.find(function (u) {
                    return u.id === removedUserIds[0];
                });
                var userName = _UserNameFormat2.default.formatFML(user.firstName, user.lastName, user.middleName);
                this.state.isWASEnabled && this.actions.toast(_messageResource2.default.getMessage("task.list.toasts.revoke_manage_task_from_user", [userName]));
            } else if (removedUserIds.length > 1) {
                this.state.isWASEnabled && this.actions.toast(_messageResource2.default.getMessage("task.list.toasts.n_users_no_longer_manage_task", [removedUserIds.length]));
            }
        }
    }, {
        key: "_confirmMoveHandler",
        value: function _confirmMoveHandler(customer, project, forceReopen, workflowStatusId) {
            var _this8 = this;

            this.header.actions.hideMenu();
            this.actions.moveTask(customer, project, forceReopen, workflowStatusId, function (taskId) {
                return _this8.callbacks.onTaskMovedCb(taskId);
            });
            this.actions.openLastTaskPanelTab();
        }
    }, {
        key: "_onCopyTask",
        value: function _onCopyTask(customerId, projectId, settings) {
            this.header.actions.hideMenu();
            this.actions.copyTask(customerId, projectId, settings);
            this.actions.openLastTaskPanelTab();
        }
    }, {
        key: "_getDisabledTooltipText",
        value: function _getDisabledTooltipText(user) {
            var msg = _messageResource2.default.getMessage('assigned_users_editor.managers.disabled_tooltip', [_messageResource2.default.getMessage('common.task'), user.firstName]);

            if (user.hasAllAssignments) {
                msg += " " + _messageResource2.default.getMessage('assigned_users_editor.managers.disabled_tooltip.entire_scope');
            } else if (user.hasAllFutureProjectsOfCustomerAssignment) {
                msg += " " + _messageResource2.default.getMessage('assigned_users_editor.managers.disabled_tooltip.all_existing_and_future_items_assignment', [_messageResource2.default.getMessage('common.projects'), _messageResource2.default.getMessage('common.customer')]);
            } else if (user.hasCustomerAssignment) {
                msg += " " + _messageResource2.default.getMessage('assigned_users_editor.managers.disabled_tooltip.entire_item_assignment', [_messageResource2.default.getMessage('common.customer')]);
            } else if (user.hasProjectAssignment) {
                msg += " " + _messageResource2.default.getMessage('assigned_users_editor.managers.disabled_tooltip.entire_item_assignment', [_messageResource2.default.getMessage('common.project')]);
            } else if (user.hasAllFutureTasksOfProjectAssignment) {
                msg += " " + _messageResource2.default.getMessage('assigned_users_editor.managers.disabled_tooltip.all_existing_and_future_items_assignment', [_messageResource2.default.getMessage('common.tasks'), _messageResource2.default.getMessage('common.project')]);
            }
            return msg;
        }
    }, {
        key: "_getDisabledTooltipTextAssugnedUsersEditor",
        value: function _getDisabledTooltipTextAssugnedUsersEditor(user) {
            return _messageResource2.default.getMessage('panel.common.cannot_unassign_user.tooltip', [_messageResource2.default.getMessage('common.task'), user.firstName]);
        }
    }, {
        key: "_getDisabledTooltipTextAssignedUsersSelector",
        value: function _getDisabledTooltipTextAssignedUsersSelector(user) {
            return _messageResource2.default.getMessage('assigned_users_editor.work.disabled_tooltip.user_manages_item', [_messageResource2.default.getMessage('common.task')]);
        }
    }, {
        key: "_reportedTimeSortChangedHandler",
        value: function _reportedTimeSortChangedHandler(header) {
            var newSortedOrder = header.isAsc() ? _constants.ReportedTimeSortConstants.ASC : _constants.ReportedTimeSortConstants.DESC;
            this.actions.saveSortingSettings(header.sortBy, newSortedOrder);
            this.actions.loadTimeComments(header.sortBy, newSortedOrder, 0);
        }
    }, {
        key: "onHide",
        value: function onHide() {
            this.header.actions.hideMenu();
            this.taskPanelDetails.hideSelectors();
            this.archivingConfirmationScrollable.hide();
        }
    }, {
        key: "getTabView",
        value: function getTabView(tabKey) {
            return this.tabs.get(tabKey);
        }
    }]);

    return TaskPanel;
}(_TemplateView3.default);

exports.default = TaskPanel;

/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _LoadingControlMixin = __webpack_require__(136);

var _LoadingControlMixin2 = _interopRequireDefault(_LoadingControlMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MenuButton = function (_TemplateView) {
    _inherits(MenuButton, _TemplateView);

    function MenuButton(_ref) {
        var editable = _ref.editable,
            _ref$positionParams = _ref.positionParams,
            positionParams = _ref$positionParams === undefined ? { offset: "0px 1px" } : _ref$positionParams,
            _ref$onShowMenu = _ref.onShowMenu,
            onShowMenu = _ref$onShowMenu === undefined ? function () {} : _ref$onShowMenu,
            _ref$onHideMenu = _ref.onHideMenu,
            onHideMenu = _ref$onHideMenu === undefined ? function () {} : _ref$onHideMenu;

        _classCallCheck(this, MenuButton);

        var _this = _possibleConstructorReturn(this, (MenuButton.__proto__ || Object.getPrototypeOf(MenuButton)).call(this));

        _this.editable = editable;
        _this.updateOnInit = false;
        _this.positionParams = positionParams;

        _this.onShowMenu = onShowMenu;
        _this.onHideMenu = onHideMenu;
        return _this;
    }

    _createClass(MenuButton, [{
        key: "afterRender",
        value: function afterRender() {
            var _this2 = this;

            this.disabled = false;
            this.$el.toggleClass('editable', this.editable);
            this.bindClick(function () {
                if (!_this2.editable || _this2.disabled || _this2.isLoading()) return;

                if (!_this2.getMenu().ignoreNextShowing) _this2.$el.addClass("pressed");
                _this2.onShowMenu();
                _this2.getMenu().showAt(_this2.$el, _this2.positionParams, function (selectedValue) {
                    _this2._onSelect(selectedValue);
                    _this2.onHideMenu();
                });
            });
        }
    }, {
        key: "update",
        value: function update() {
            this.$el.toggleClass('editable', this.editable);
        }
    }, {
        key: "_onSelect",
        value: function _onSelect(selectedValue) {
            this.$el.removeClass('pressed');
            if (this._change(selectedValue)) {
                this.update();
                this.trigger("change", selectedValue);
            }
        }

        /**
         * Get button actual menu instance
         * @returns menu {DropdownTemplateView}
         */

    }, {
        key: "getMenu",
        value: function getMenu() {}
        //    abstract


        /**
         * Change button data value
         * @param  selectedValue: new selected value in menu
         * @returns true if data was changed
         *          false otherwise
         */

    }, {
        key: "_change",
        value: function _change(selectedValue) {
            //    abstract
        }
    }, {
        key: "isDisabled",
        value: function isDisabled() {
            return this.disabled;
        }
    }, {
        key: "setDisabled",
        value: function setDisabled(disabled) {
            this.disabled = disabled;
            this.update();
        }
    }, {
        key: "disableAndHide",
        value: function disableAndHide() {
            this.setDisabled(true);
            this.getMenu().hide();
        }
    }, {
        key: "setEditable",
        value: function setEditable(editable) {
            this.editable = editable;
            this.update();
        }
    }]);

    return MenuButton;
}(_TemplateView3.default);

exports.default = MenuButton;


_underscore2.default.extend(MenuButton.prototype, _LoadingControlMixin2.default);

/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = function (getCommentsState) {
    var getComments = function getComments(state) {
        return getCommentsState(state).comments;
    };
    var getCommentsUsers = function getCommentsUsers(state) {
        return getCommentsState(state).users;
    };
    var getCommentsCount = function getCommentsCount(state) {
        return getCommentsState(state).commentsCount;
    };
    var getAllCommentsUserIds = function getAllCommentsUserIds(state) {
        return getCommentsState(state).allCommentsUserIds;
    };
    var areCommentsLoaded = function areCommentsLoaded(state) {
        return getCommentsState(state).commentsLoaded;
    };
    var isNewCommentsOnTop = function isNewCommentsOnTop(state) {
        return getCommentsState(state).isNewCommentsOnTop;
    };
    var isLoading = function isLoading(state) {
        return getCommentsState(state).loading;
    };
    var isSendingComment = function isSendingComment(state) {
        return getCommentsState(state).sendingComment;
    };
    var getRecentlyAddedCommentsIds = function getRecentlyAddedCommentsIds(state) {
        return getCommentsState(state).recentlyAddedCommentsIds;
    };
    var getCommentsScrollTo = function getCommentsScrollTo(state) {
        return getCommentsState(state).commentsScrollTo;
    };
    var getEditingCommentId = function getEditingCommentId(state) {
        return getCommentsState(state).editingCommentId;
    };
    var getEditingCommentText = function getEditingCommentText(state) {
        return getCommentsState(state).editingCommentText;
    };
    var getUpdatingCommentId = function getUpdatingCommentId(state) {
        return getCommentsState(state).updatingCommentId;
    };
    var isShowNewCommentInput = function isShowNewCommentInput(state) {
        return getCommentsState(state).showNewCommentInput;
    };
    var getNewCommentsTexts = function getNewCommentsTexts(state) {
        return getCommentsState(state).newCommentsTexts;
    };

    var needMoreComments = (0, _reselect.createSelector)(isLoading, areCommentsLoaded, function (loading, loaded) {
        return !loading && !loaded;
    });

    var getCommentsInfo = (0, _reselect.createSelector)(getComments, getCommentsUsers, getCommentsCount, getAllCommentsUserIds, function (comments, users, commentsCount, allCommentsUserIds) {
        return { comments: comments, users: users, commentsCount: commentsCount, allCommentsUserIds: allCommentsUserIds };
    });

    var getNewestCommentId = (0, _reselect.createSelector)(getComments, function (comments) {
        return comments.length > 0 ? comments[0].id : null;
    });

    var getUsers = (0, _reselect.createSelector)(getCommentsUsers, _selectors.getLoggedInUser, function (commentsUsers, loggedInUser) {
        return _extends({}, commentsUsers, _defineProperty({}, loggedInUser.id, loggedInUser));
    });

    return {
        getComments: getComments,
        getUsers: getUsers,
        getCommentsCount: getCommentsCount,
        getAllCommentsUserIds: getAllCommentsUserIds,
        getCommentsInfo: getCommentsInfo,
        needMoreComments: needMoreComments,
        isNewCommentsOnTop: isNewCommentsOnTop,
        getRecentlyAddedCommentsIds: getRecentlyAddedCommentsIds,
        getCommentsScrollTo: getCommentsScrollTo,
        getNewestCommentId: getNewestCommentId,
        getEditingCommentId: getEditingCommentId,
        getEditingCommentText: getEditingCommentText,
        isLoading: isLoading,
        isSendingComment: isSendingComment,
        getUpdatingCommentId: getUpdatingCommentId,
        isShowNewCommentInput: isShowNewCommentInput,
        getNewCommentsTexts: getNewCommentsTexts
    };
};

var _reselect = __webpack_require__(13);

var _selectors = __webpack_require__(19);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isFiltersEqual = exports.countStatuses = exports.isOnlyDirectlySelectedStatuses = exports.isCompletedTypeSelected = exports.isOnlyCompletedType = exports.isOpenTypeSelected = exports.isOnlyOpenType = exports.isAll = exports.ALL_FILTER = exports.COMPLETED_FILTER = exports.OPEN_FILTER = exports.convertToFilter = exports.convertToData = undefined;

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _constants = __webpack_require__(23);

var _atUtils = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var convertToData = exports.convertToData = function convertToData(filter) {
    return {
        allSelected: filter.allSelected,
        statusTypes: Object.keys(filter.statusTypes),
        statusIds: Object.keys(filter.statusIds)
    };
};

var convertToFilter = exports.convertToFilter = function convertToFilter(data) {
    return {
        allSelected: data.allSelected,
        statusTypes: (0, _atUtils.arrayToSet)(data.statusTypes),
        statusIds: (0, _atUtils.arrayToSet)(data.statusIds)
    };
};

var OPEN_FILTER = exports.OPEN_FILTER = {
    allSelected: false,
    statusTypes: [_constants.WorkflowStatusType.OPEN],
    statusIds: []
};

var COMPLETED_FILTER = exports.COMPLETED_FILTER = {
    allSelected: false,
    statusTypes: [_constants.WorkflowStatusType.COMPLETED],
    statusIds: []
};

var ALL_FILTER = exports.ALL_FILTER = {
    allSelected: true,
    statusTypes: [],
    statusIds: []
};

var isAll = exports.isAll = function isAll(filter) {
    return filter.allSelected || filter.statusTypes.includes(_constants.WorkflowStatusType.OPEN) && filter.statusTypes.includes(_constants.WorkflowStatusType.COMPLETED);
};

var isOneTypeSelection = function isOneTypeSelection(filter, type) {
    return isTypeSelected(filter, type) && filter.statusTypes.length === 1 && filter.statusIds.length === 0;
};

var isTypeSelected = function isTypeSelected(filter, type) {
    return !filter.allSelected && filter.statusTypes.includes(type);
};

var isOnlyOpenType = exports.isOnlyOpenType = function isOnlyOpenType(filter) {
    return isOneTypeSelection(filter, _constants.WorkflowStatusType.OPEN);
};

var isOpenTypeSelected = exports.isOpenTypeSelected = function isOpenTypeSelected(filter) {
    return isTypeSelected(filter, _constants.WorkflowStatusType.OPEN);
};

var isOnlyCompletedType = exports.isOnlyCompletedType = function isOnlyCompletedType(filter) {
    return isOneTypeSelection(filter, _constants.WorkflowStatusType.COMPLETED);
};

var isCompletedTypeSelected = exports.isCompletedTypeSelected = function isCompletedTypeSelected(filter) {
    return isTypeSelected(filter, _constants.WorkflowStatusType.COMPLETED);
};

var isOnlyDirectlySelectedStatuses = exports.isOnlyDirectlySelectedStatuses = function isOnlyDirectlySelectedStatuses(filter) {
    return !filter.allSelected && filter.statusTypes.length === 0 && filter.statusIds.length > 0;
};

var countStatuses = exports.countStatuses = function countStatuses(filter, statusesMap) {
    var statusesList = Object.values(statusesMap);
    if (isAll(filter)) return statusesList.length;

    var count = 0;
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        var _loop = function _loop() {
            var type = _step.value;

            count += statusesList.filter(function (status) {
                return status.type === type;
            }).length;
        };

        for (var _iterator = filter.statusTypes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            _loop();
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    count += filter.statusIds.length;
    return count;
};

var isFiltersEqual = exports.isFiltersEqual = function isFiltersEqual(filter1, filter2) {
    if (isAll(filter1) && isAll(filter2)) return true;

    if (isAll(filter1) || isAll(filter2)) return false;

    return _underscore2.default.isEqual(filter1, filter2);
};

/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _CommentsList = __webpack_require__(1333);

var _CommentsList2 = _interopRequireDefault(_CommentsList);

var _LoadMoreCommentsButton = __webpack_require__(1344);

var _LoadMoreCommentsButton2 = _interopRequireDefault(_LoadMoreCommentsButton);

var _constants = __webpack_require__(120);

var _ScrollUtils = __webpack_require__(39);

var _ScrollUtils2 = _interopRequireDefault(_ScrollUtils);

var _LoadingContainer = __webpack_require__(28);

var _LoadingContainer2 = _interopRequireDefault(_LoadingContainer);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _SimpleSingletonTooltip = __webpack_require__(45);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CommentsSection = function (_TemplateView) {
    _inherits(CommentsSection, _TemplateView);

    function CommentsSection(_ref) {
        var _ref$startEditComment = _ref.startEditComment,
            startEditComment = _ref$startEditComment === undefined ? function (id) {} : _ref$startEditComment,
            _ref$cancelEditCommen = _ref.cancelEditComment,
            cancelEditComment = _ref$cancelEditCommen === undefined ? function () {} : _ref$cancelEditCommen,
            _ref$updateEditingCom = _ref.updateEditingCommentText,
            updateEditingCommentText = _ref$updateEditingCom === undefined ? function (text) {} : _ref$updateEditingCom,
            _ref$saveEditingComme = _ref.saveEditingComment,
            saveEditingComment = _ref$saveEditingComme === undefined ? function () {} : _ref$saveEditingComme,
            _ref$deleteComment = _ref.deleteComment,
            deleteComment = _ref$deleteComment === undefined ? function (id) {} : _ref$deleteComment,
            _ref$loadMoreComments = _ref.loadMoreComments,
            loadMoreComments = _ref$loadMoreComments === undefined ? function () {} : _ref$loadMoreComments,
            _ref$changeCommentsOr = _ref.changeCommentsOrder,
            changeCommentsOrder = _ref$changeCommentsOr === undefined ? function () {} : _ref$changeCommentsOr,
            _ref$resetCommentsScr = _ref.resetCommentsScrollTo,
            resetCommentsScrollTo = _ref$resetCommentsScr === undefined ? function () {} : _ref$resetCommentsScr,
            _ref$refreshScrollCb = _ref.refreshScrollCb,
            refreshScrollCb = _ref$refreshScrollCb === undefined ? function () {} : _ref$refreshScrollCb,
            _ref$scrollToElementC = _ref.scrollToElementCb,
            scrollToElementCb = _ref$scrollToElementC === undefined ? function () {} : _ref$scrollToElementC;

        _classCallCheck(this, CommentsSection);

        var _this = _possibleConstructorReturn(this, (CommentsSection.__proto__ || Object.getPrototypeOf(CommentsSection)).call(this));

        _this._updateOrderButtonTooltipStateHandler = function () {
            var orderButtonTooltipKey = _this.state.isNewCommentsOnTop ? 'panel.common.comments.order_button.tooltip.newest_top' : 'panel.common.comments.order_button.tooltip.oldest_top';
            (0, _SimpleSingletonTooltip.getInstance)().setState({
                text: _messageResource2.default.getMessage(orderButtonTooltipKey),
                extraClass: ''
            });
        };

        _this.state = {
            loggedInUser: null,
            users: {},
            comments: [],
            commentsCount: 0,
            allCommentsUserIds: [],
            loading: false,
            isNewCommentsOnTop: false,
            recentlyAddedCommentsIds: {},
            commentsScrollTo: null,
            editingCommentId: null,
            editingCommentText: '',
            updatingCommentId: null,
            readOnly: false,
            canManage: false
        };

        _this.actions = {
            startEditComment: startEditComment,
            cancelEditComment: cancelEditComment,
            updateEditingCommentText: updateEditingCommentText,
            saveEditingComment: saveEditingComment,
            deleteComment: deleteComment,
            loadMoreComments: loadMoreComments,
            changeCommentsOrder: changeCommentsOrder,
            resetCommentsScrollTo: resetCommentsScrollTo
        };

        _this.callbacks = {
            refreshScrollCb: refreshScrollCb,
            scrollToElementCb: scrollToElementCb
        };

        _this.onStatePropertyChanged('loggedInUser', function (loggedInUser) {
            return _this.commentsList.setState({ loggedInUser: loggedInUser });
        });

        _this.onAnyStatePropertyChanged(['users', 'comments', 'allCommentsUserIds'], function () {
            _this.commentsList.setState({
                users: _this.state.users,
                comments: _this.state.comments,
                allCommentsUserIds: _this.state.allCommentsUserIds
            });

            _this.loadMoreButton.toggle(_this.state.commentsCount > _this.state.comments.length);
            _this.callbacks.refreshScrollCb();
        });

        _this.onStatePropertyChanged('isNewCommentsOnTop', function (isNewCommentsOnTop) {
            _this.$commentsListContainer.toggleClass('orderReversed', !isNewCommentsOnTop);
            _this.$orderButton.toggleClass('desc', !isNewCommentsOnTop);
            _this.commentsList.setState({ isNewCommentsOnTop: isNewCommentsOnTop });

            _this.unsubscribeOrderButtonTooltip && _this.unsubscribeOrderButtonTooltip();
            _this.unsubscribeOrderButtonTooltip = (0, _SimpleSingletonTooltip.getInstance)().subscribeToMouseEvents(_this.$orderButton, _this._updateOrderButtonTooltipStateHandler);
            _this._updateOrderButtonTooltipStateHandler();
        });

        _this.onStatePropertyChanged('commentsCount', function (commentsCount) {
            _this.commentsCount.text('(' + commentsCount + ')');
            _this.$orderButton.toggle(commentsCount > 1);
        });

        _this.onStatePropertyChanged('recentlyAddedCommentsIds', function (recentlyAddedCommentsIds) {
            _this.commentsList.setState({ recentlyAddedCommentsIds: recentlyAddedCommentsIds });
        });

        _this.onStatePropertyChanged('updatingCommentId', function (updatingCommentId) {
            _this.commentsList.setState({ updatingCommentId: updatingCommentId });
            _this.commentsListWrapper.setState({ loading: updatingCommentId !== null });
        });

        _this.onStatePropertyChanged('loading', function (loading) {
            return _this.loadMoreButton.setState({ loading: loading });
        });
        _this.onStatePropertyChanged('commentsScrollTo', function (commentsScrollTo) {
            return _this._scrollToLoadedComments(commentsScrollTo);
        });

        _this.onStatePropertyChanged('editingCommentId', function (editingCommentId) {
            return _this.commentsList.setState({ editingCommentId: editingCommentId });
        });
        _this.onStatePropertyChanged('editingCommentText', function (editingCommentText) {
            return _this.commentsList.setState({ editingCommentText: editingCommentText });
        });
        _this.onStatePropertyChanged('readOnly', function (readOnly) {
            return _this.commentsList.setState({ readOnly: readOnly });
        });
        _this.onStatePropertyChanged('canManage', function (canManage) {
            return _this.commentsList.setState({ canManage: canManage });
        });
        return _this;
    }

    _createClass(CommentsSection, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return "<div class='commentsSection section'>" + "    <div class='sectionHeader'>" + "        <span><%=header%></span>" + "        <span class='commentsCount'/>" + "        <div class='orderButton'/>" + "    </div>" + "    <div class='commentsListContainer'/>" + "</div>";
        }
    }, {
        key: 'messageKeys',
        value: function messageKeys() {
            return {
                header: "panel.common.comments.header"
            };
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            var _this2 = this;

            this.commentsCount = this.find('.commentsCount');
            this.$commentsListContainer = this.find('.commentsListContainer');
            this.commentsList = new _CommentsList2.default({
                startEditComment: this.actions.startEditComment,
                cancelEditComment: this.actions.cancelEditComment,
                updateEditingCommentText: this.actions.updateEditingCommentText,
                saveEditingComment: this.actions.saveEditingComment,
                onCommentDeleted: this.actions.deleteComment,
                refreshScrollCb: this.callbacks.refreshScrollCb
            });

            this.commentsListWrapper = new _LoadingContainer2.default({
                containerClass: 'commentsListLoadingWrapper',
                contentComponent: this.commentsList
            }).init(this.$commentsListContainer);
            this.loadMoreButton = new _LoadMoreCommentsButton2.default({
                onClickCb: this.actions.loadMoreComments
            }).init(this.$commentsListContainer);

            this.loadMoreButton.hide();

            this.$orderButton = this.find('.orderButton');
            this.$orderButton.on('click', function () {
                _this2.actions.changeCommentsOrder(!_this2.state.isNewCommentsOnTop);
            });
        }
    }, {
        key: '_scrollToLoadedComments',
        value: function _scrollToLoadedComments(scrollTo) {
            if (scrollTo === _constants.COMMENTS_SCROLL_TO.RECENTLY_ADDED) {
                !this.state.isNewCommentsOnTop ? this._scrollToCommentsSectionBottom() : this._scrollToCommentsSectionTop();
            } else if (scrollTo === _constants.COMMENTS_SCROLL_TO.LOADED_OLDER) {
                this.state.isNewCommentsOnTop ? this._scrollToCommentsSectionBottom() : this._scrollToCommentsSectionTop();
            }
        }
    }, {
        key: '_scrollToCommentsSectionTop',
        value: function _scrollToCommentsSectionTop() {
            this.callbacks.scrollToElementCb(this.getEl(), _ScrollUtils2.default.POSITIONS.TOP);
            this.actions.resetCommentsScrollTo();
        }
    }, {
        key: '_scrollToCommentsSectionBottom',
        value: function _scrollToCommentsSectionBottom() {
            this.callbacks.scrollToElementCb(this.getEl(), _ScrollUtils2.default.POSITIONS.BOTTOM);
            this.actions.resetCommentsScrollTo();
        }
    }]);

    return CommentsSection;
}(_TemplateView3.default);

exports.default = CommentsSection;

/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.AMPERSAND = exports.CLOSEPAREN = exports.CLOSEANGLEBRACKET = exports.CLOSEBRACKET = exports.CLOSEBRACE = exports.OPENPAREN = exports.OPENANGLEBRACKET = exports.OPENBRACKET = exports.OPENBRACE = exports.WS = exports.TLD = exports.SYM = exports.UNDERSCORE = exports.SLASH = exports.MAILTO = exports.PROTOCOL = exports.QUERY = exports.POUND = exports.PLUS = exports.NUM = exports.NL = exports.LOCALHOST = exports.PUNCTUATION = exports.DOT = exports.COLON = exports.AT = exports.DOMAIN = exports.Base = undefined;

var _createTokenClass = __webpack_require__(761);

var _class = __webpack_require__(361);

/******************************************************************************
	Text Tokens
	Tokens composed of strings
******************************************************************************/

/**
	Abstract class used for manufacturing text tokens.
	Pass in the value this token represents

	@class TextToken
	@abstract
*/
var TextToken = (0, _createTokenClass.createTokenClass)();
TextToken.prototype = {
	toString: function toString() {
		return this.v + '';
	}
};

function inheritsToken(value) {
	var props = value ? { v: value } : {};
	return (0, _class.inherits)(TextToken, (0, _createTokenClass.createTokenClass)(), props);
}

/**
	A valid domain token
	@class DOMAIN
	@extends TextToken
*/
var DOMAIN = inheritsToken();

/**
	@class AT
	@extends TextToken
*/
var AT = inheritsToken('@');

/**
	Represents a single colon `:` character

	@class COLON
	@extends TextToken
*/
var COLON = inheritsToken(':');

/**
	@class DOT
	@extends TextToken
*/
var DOT = inheritsToken('.');

/**
	A character class that can surround the URL, but which the URL cannot begin
	or end with. Does not include certain English punctuation like parentheses.

	@class PUNCTUATION
	@extends TextToken
*/
var PUNCTUATION = inheritsToken();

/**
	The word localhost (by itself)
	@class LOCALHOST
	@extends TextToken
*/
var LOCALHOST = inheritsToken();

/**
	Newline token
	@class NL
	@extends TextToken
*/
var NL = inheritsToken('\n');

/**
	@class NUM
	@extends TextToken
*/
var NUM = inheritsToken();

/**
	@class PLUS
	@extends TextToken
*/
var PLUS = inheritsToken('+');

/**
	@class POUND
	@extends TextToken
*/
var POUND = inheritsToken('#');

/**
	Represents a web URL protocol. Supported types include

	* `http:`
	* `https:`
	* `ftp:`
	* `ftps:`

	@class PROTOCOL
	@extends TextToken
*/
var PROTOCOL = inheritsToken();

/**
	Represents the start of the email URI protocol

	@class MAILTO
	@extends TextToken
*/
var MAILTO = inheritsToken('mailto:');

/**
	@class QUERY
	@extends TextToken
*/
var QUERY = inheritsToken('?');

/**
	@class SLASH
	@extends TextToken
*/
var SLASH = inheritsToken('/');

/**
	@class UNDERSCORE
	@extends TextToken
*/
var UNDERSCORE = inheritsToken('_');

/**
	One ore more non-whitespace symbol.
	@class SYM
	@extends TextToken
*/
var SYM = inheritsToken();

/**
	@class TLD
	@extends TextToken
*/
var TLD = inheritsToken();

/**
	Represents a string of consecutive whitespace characters

	@class WS
	@extends TextToken
*/
var WS = inheritsToken();

/**
	Opening/closing bracket classes
*/

var OPENBRACE = inheritsToken('{');
var OPENBRACKET = inheritsToken('[');
var OPENANGLEBRACKET = inheritsToken('<');
var OPENPAREN = inheritsToken('(');
var CLOSEBRACE = inheritsToken('}');
var CLOSEBRACKET = inheritsToken(']');
var CLOSEANGLEBRACKET = inheritsToken('>');
var CLOSEPAREN = inheritsToken(')');

var AMPERSAND = inheritsToken('&');

exports.Base = TextToken;
exports.DOMAIN = DOMAIN;
exports.AT = AT;
exports.COLON = COLON;
exports.DOT = DOT;
exports.PUNCTUATION = PUNCTUATION;
exports.LOCALHOST = LOCALHOST;
exports.NL = NL;
exports.NUM = NUM;
exports.PLUS = PLUS;
exports.POUND = POUND;
exports.QUERY = QUERY;
exports.PROTOCOL = PROTOCOL;
exports.MAILTO = MAILTO;
exports.SLASH = SLASH;
exports.UNDERSCORE = UNDERSCORE;
exports.SYM = SYM;
exports.TLD = TLD;
exports.WS = WS;
exports.OPENBRACE = OPENBRACE;
exports.OPENBRACKET = OPENBRACKET;
exports.OPENANGLEBRACKET = OPENANGLEBRACKET;
exports.OPENPAREN = OPENPAREN;
exports.CLOSEBRACE = CLOSEBRACE;
exports.CLOSEBRACKET = CLOSEBRACKET;
exports.CLOSEANGLEBRACKET = CLOSEANGLEBRACKET;
exports.CLOSEPAREN = CLOSEPAREN;
exports.AMPERSAND = AMPERSAND;

/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (_ref) {
    var _ref$actions = _ref.actions,
        saveCommentSuccess = _ref$actions.saveCommentSuccess,
        loadMoreCommentsSuccess = _ref$actions.loadMoreCommentsSuccess,
        deleteCommentSuccess = _ref$actions.deleteCommentSuccess,
        clearCommentsInfo = _ref$actions.clearCommentsInfo,
        changeCommentsOrder = _ref$actions.changeCommentsOrder,
        setCommentsLoading = _ref$actions.setCommentsLoading,
        setSendingComment = _ref$actions.setSendingComment,
        setCommentsLoaded = _ref$actions.setCommentsLoaded,
        resetCommentsScrollTo = _ref$actions.resetCommentsScrollTo,
        setEditingCommentId = _ref$actions.setEditingCommentId,
        updateEditingCommentText = _ref$actions.updateEditingCommentText,
        cancelEditComment = _ref$actions.cancelEditComment,
        updateCommentSuccess = _ref$actions.updateCommentSuccess,
        setUpdatingCommentId = _ref$actions.setUpdatingCommentId,
        removeComment = _ref$actions.removeComment,
        setShowNewCommentInput = _ref$actions.setShowNewCommentInput,
        removeNewComment = _ref$actions.removeNewComment,
        _ref$actions$updateCo = _ref$actions.updateCommentsCountSuccess,
        updateCommentsCountSuccess = _ref$actions$updateCo === undefined ? function (entityId, commentsInfo) {
        return function (dispatch) {};
    } : _ref$actions$updateCo,
        _ref$selectors = _ref.selectors;
    _ref$selectors = _ref$selectors === undefined ? {} : _ref$selectors;
    var getOpenEntityId = _ref$selectors.getOpenEntityId,
        getComments = _ref$selectors.getComments,
        getEditingCommentId = _ref$selectors.getEditingCommentId,
        getEditingCommentText = _ref$selectors.getEditingCommentText,
        getUpdatingCommentId = _ref$selectors.getUpdatingCommentId,
        getNewestCommentId = _ref$selectors.getNewestCommentId,
        isNewCommentsOnTop = _ref$selectors.isNewCommentsOnTop,
        needMoreComments = _ref$selectors.needMoreComments,
        getNewCommentsTexts = _ref$selectors.getNewCommentsTexts,
        handleServiceError = _ref.handleServiceError,
        entityType = _ref.entityType;


    var reloadComments = function reloadComments() {
        return function (dispatch) {
            dispatch(clearCommentsInfo());
            dispatch(loadMoreComments());
        };
    };

    var loadMoreComments = function loadMoreComments() {
        return function (dispatch, getState) {
            var state = getState();
            var entityId = getOpenEntityId(state);
            if (entityId !== null && needMoreComments(state)) {
                dispatch(setCommentsLoading(true));
                var offset = getComments(state).length;
                (0, _rpcCalls2.default)('EntityCommentsService.getCommentsInfo', [entityId, entityType, offset, _constants.LOAD_COMMENTS_LIMIT], function (error) {
                    return handleServiceError(entityId, error, dispatch);
                }).then(function (commentsInfo) {
                    dispatch(loadMoreCommentsSuccess(commentsInfo, offset, isNewCommentsOnTop(getState())));
                }).catch(function (error) {
                    dispatch(setCommentsLoading(false));
                    console.error(error);
                });
            }
        };
    };

    var saveComment = function saveComment(text) {
        return function (dispatch, getState) {
            var state = getState();
            var entityId = getOpenEntityId(state);
            var newestCommentId = getNewestCommentId(state);
            dispatch(setSendingComment(true));
            (0, _rpcCalls2.default)('EntityCommentsService.saveComment', [entityId, entityType, text, newestCommentId], function (error) {
                return handleServiceError(entityId, error, dispatch);
            }).then(function (commentsInfo) {
                dispatch(updateCommentsCountSuccess(entityId, commentsInfo));
                dispatch(removeNewComment(entityId));
                dispatch(saveCommentSuccess(commentsInfo));
                dispatch(saveEntityNewCommentsTextsInLocalStorage());
            }).catch(function (error) {
                dispatch(setSendingComment(false));
            });
        };
    };

    var deleteComment = function deleteComment(commentId) {
        return function (dispatch, getState) {
            var state = getState();
            var entityId = getOpenEntityId(state);
            var newestCommentId = getNewestCommentId(state);
            (0, _rpcCalls2.default)('EntityCommentsService.deleteComment', [entityId, entityType, commentId, newestCommentId], function (error) {
                return handleServiceError(entityId, error, dispatch);
            }).then(function (commentsInfo) {
                dispatch(updateCommentsCountSuccess(entityId, commentsInfo));
                dispatch(deleteCommentSuccess(commentId, commentsInfo));
            }).catch(function (error) {});
        };
    };

    var saveEditingComment = function saveEditingComment() {
        return function (dispatch, getState) {
            var state = getState();
            var editingCommentId = getEditingCommentId(state);
            if (editingCommentId !== null) {
                var prevText = getComments(state).find(function (c) {
                    return c.id === editingCommentId;
                }).text;
                var newText = getEditingCommentText(state);

                if (newText !== prevText && newText.length <= _constants.NUMBER_ALLOWED_CHARACTERS) {
                    var entityId = getOpenEntityId(state);
                    var newestCommentId = getNewestCommentId(state);
                    dispatch(setUpdatingCommentId(editingCommentId));
                    (0, _rpcCalls2.default)('EntityCommentsService.editComment', [editingCommentId, entityId, entityType, newText, newestCommentId], function (error) {
                        return handleServiceError(entityId, error, dispatch);
                    }).then(function (data) {
                        dispatch(updateCommentSuccess(data));
                    }).catch(function (error) {
                        dispatch(setUpdatingCommentId(null));
                        dispatch(setEditingCommentId(null));

                        if (error.getTextStatus() === 'rpc_customException' && error.getErrorThrown().exception === 'com.actimind.actitime.services.impl.comments.NoSuchCommentException') {
                            dispatch(removeComment(editingCommentId));
                        }
                    });
                } else {
                    dispatch(setEditingCommentId(null));
                }
            }
        };
    };

    var startEditComment = function startEditComment(id) {
        return function (dispatch, getState) {
            var state = getState();
            var updatingCommentId = getUpdatingCommentId(state);
            if (updatingCommentId !== null) return;

            var editingCommentId = getEditingCommentId(state);
            if (editingCommentId !== null && id !== editingCommentId) {
                dispatch(saveEditingComment());
                //hack to show other comment edit input if server response quickly, otherwise show loading moire
                setTimeout(function () {
                    if (getUpdatingCommentId(getState()) === null) {
                        dispatch(setEditingCommentId(id));
                    }
                }, 100);
            } else {
                dispatch(setEditingCommentId(id));
            }
        };
    };

    var toggleNewCommentInput = function toggleNewCommentInput(isShown) {
        return function (dispatch, getState) {
            var state = getState();
            var editingCommentId = getEditingCommentId(state);
            if (editingCommentId !== null) {
                dispatch(saveEditingComment());
            }

            dispatch(setShowNewCommentInput(isShown));
        };
    };

    var saveEntityNewCommentsTextsInLocalStorage = function saveEntityNewCommentsTextsInLocalStorage() {
        return function (dispatch, getState) {
            (0, _utils.setEntityCommentsInLocalStorage)(entityType, getNewCommentsTexts(getState()));
        };
    };

    return {
        reloadComments: reloadComments,
        loadMoreComments: loadMoreComments,
        saveComment: saveComment,
        deleteComment: deleteComment,
        saveEditingComment: saveEditingComment,
        startEditComment: startEditComment,
        toggleNewCommentInput: toggleNewCommentInput,
        saveEntityNewCommentsTextsInLocalStorage: saveEntityNewCommentsTextsInLocalStorage
    };
};

var _rpcCalls = __webpack_require__(24);

var _rpcCalls2 = _interopRequireDefault(_rpcCalls);

var _constants = __webpack_require__(120);

var _utils = __webpack_require__(362);

var _utils2 = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (_ref) {
    var _ref$actionTypes = _ref.actionTypes,
        NEW_COMMENTS_ADD = _ref$actionTypes.NEW_COMMENTS_ADD,
        OLD_COMMENTS_ADD = _ref$actionTypes.OLD_COMMENTS_ADD,
        COMMENTS_INFO_CLEAR = _ref$actionTypes.COMMENTS_INFO_CLEAR,
        COMMENT_REMOVE = _ref$actionTypes.COMMENT_REMOVE,
        CHANGE_COMMENTS_ORDER = _ref$actionTypes.CHANGE_COMMENTS_ORDER,
        COMMENTS_LOADED_SET = _ref$actionTypes.COMMENTS_LOADED_SET,
        COMMENTS_LOADING_SET = _ref$actionTypes.COMMENTS_LOADING_SET,
        SENDING_COMMENT_SET = _ref$actionTypes.SENDING_COMMENT_SET,
        RECENTLY_ADDED_COMMENTS_ADD = _ref$actionTypes.RECENTLY_ADDED_COMMENTS_ADD,
        RECENTLY_ADDED_COMMENTS_REMOVE = _ref$actionTypes.RECENTLY_ADDED_COMMENTS_REMOVE,
        COMMENTS_SCROLL_TO_SET = _ref$actionTypes.COMMENTS_SCROLL_TO_SET,
        EDITING_COMMENT_ID_SET = _ref$actionTypes.EDITING_COMMENT_ID_SET,
        EDITING_COMMENT_TEXT_SET = _ref$actionTypes.EDITING_COMMENT_TEXT_SET,
        UPDATE_COMMENT = _ref$actionTypes.UPDATE_COMMENT,
        UPDATING_COMMENT_ID_SET = _ref$actionTypes.UPDATING_COMMENT_ID_SET,
        SHOW_NEW_COMMENT_INPUT_SET = _ref$actionTypes.SHOW_NEW_COMMENT_INPUT_SET,
        NEW_COMMENT_SET = _ref$actionTypes.NEW_COMMENT_SET,
        NEW_COMMENT_REMOVE = _ref$actionTypes.NEW_COMMENT_REMOVE;

    var addNewComments = (0, _reduxActions.createAction)(NEW_COMMENTS_ADD);
    var addOldComments = (0, _reduxActions.createAction)(OLD_COMMENTS_ADD);
    var clearCommentsInfo = (0, _reduxActions.createAction)(COMMENTS_INFO_CLEAR);
    var removeComment = (0, _reduxActions.createAction)(COMMENT_REMOVE);
    var setCommentsLoaded = (0, _reduxActions.createAction)(COMMENTS_LOADED_SET);
    var setCommentsLoading = (0, _reduxActions.createAction)(COMMENTS_LOADING_SET);
    var setSendingComment = (0, _reduxActions.createAction)(SENDING_COMMENT_SET);
    var addRecentlyAddedComments = (0, _reduxActions.createAction)(RECENTLY_ADDED_COMMENTS_ADD);
    var removeRecentlyAddedComments = (0, _reduxActions.createAction)(RECENTLY_ADDED_COMMENTS_REMOVE);
    var setCommentsScrollTo = (0, _reduxActions.createAction)(COMMENTS_SCROLL_TO_SET);
    var setEditingCommentId = (0, _reduxActions.createAction)(EDITING_COMMENT_ID_SET);
    var setEditingCommentText = (0, _reduxActions.createAction)(EDITING_COMMENT_TEXT_SET);
    var updateComment = (0, _reduxActions.createAction)(UPDATE_COMMENT);
    var setUpdatingCommentId = (0, _reduxActions.createAction)(UPDATING_COMMENT_ID_SET);
    var setShowNewCommentInput = (0, _reduxActions.createAction)(SHOW_NEW_COMMENT_INPUT_SET);
    var setNewComment = (0, _reduxActions.createAction)(NEW_COMMENT_SET);
    var removeNewComment = (0, _reduxActions.createAction)(NEW_COMMENT_REMOVE);

    var saveCommentSuccess = function saveCommentSuccess(commentsInfo) {
        return function (dispatch) {
            dispatch(setSendingComment(false));
            dispatch(setShowNewCommentInput(false));
            dispatch(addNewComments(commentsInfo));
            dispatch(setCommentsScrollTo(_constants.COMMENTS_SCROLL_TO.RECENTLY_ADDED));
            dispatch(addRecentlyAddedComments(commentsInfo.comments));
            setTimeout(function () {
                return dispatch(removeRecentlyAddedComments(commentsInfo.comments));
            }, HIGHLIGHT_NEW_COMMENTS_DELAY);
        };
    };

    var deleteCommentSuccess = function deleteCommentSuccess(deletedCommentId, commentsInfo) {
        return function (dispatch) {
            dispatch(removeComment(deletedCommentId));
            dispatch(addNewComments(commentsInfo));
            dispatch(addRecentlyAddedComments(commentsInfo.comments));
            setTimeout(function () {
                return dispatch(removeRecentlyAddedComments(commentsInfo.comments));
            }, HIGHLIGHT_NEW_COMMENTS_DELAY);
        };
    };

    var loadMoreCommentsSuccess = function loadMoreCommentsSuccess(commentsInfo, offset, isNewCommentsOnTop) {
        return function (dispatch) {
            dispatch(setCommentsLoading(false));
            dispatch(addOldComments(commentsInfo));
            dispatch(setCommentsLoaded(commentsInfo.comments.length < _constants.LOAD_COMMENTS_LIMIT));
            if (offset > 0 && isNewCommentsOnTop) {
                dispatch(setCommentsScrollTo(_constants.COMMENTS_SCROLL_TO.LOADED_OLDER));
            }
        };
    };

    var updateCommentSuccess = function updateCommentSuccess(data) {
        return function (dispatch) {
            dispatch(setUpdatingCommentId(null));
            dispatch(setEditingCommentId(null));
            dispatch(setEditingCommentText(''));
            dispatch(addNewComments(data.commentsInfo));
            dispatch(addRecentlyAddedComments(data.commentsInfo.comments));
            setTimeout(function () {
                return dispatch(removeRecentlyAddedComments(data.commentsInfo.comments));
            }, HIGHLIGHT_NEW_COMMENTS_DELAY);
            dispatch(updateComment(data.updatedComment));
        };
    };

    var cancelEditComment = function cancelEditComment() {
        return function (dispatch) {
            dispatch(setEditingCommentText(''));
            dispatch(setEditingCommentId(null));
        };
    };

    var updateEditingCommentText = function updateEditingCommentText(text) {
        return function (dispatch) {
            dispatch(setEditingCommentText(text));
        };
    };

    var resetCommentsScrollTo = function resetCommentsScrollTo() {
        return function (dispatch) {
            dispatch(setCommentsScrollTo(null));
        };
    };

    var changeCommentsOrder = function changeCommentsOrder(isNewCommentsOnTop) {
        return function (dispatch) {
            dispatch((0, _utils.createActionObject)(CHANGE_COMMENTS_ORDER, isNewCommentsOnTop));
            (0, _utils2.setCommentsOrderInLocalStorage)(isNewCommentsOnTop);
        };
    };

    return {
        saveCommentSuccess: saveCommentSuccess,
        loadMoreCommentsSuccess: loadMoreCommentsSuccess,
        deleteCommentSuccess: deleteCommentSuccess,
        clearCommentsInfo: clearCommentsInfo,
        changeCommentsOrder: changeCommentsOrder,
        setCommentsLoading: setCommentsLoading,
        setSendingComment: setSendingComment,
        setCommentsLoaded: setCommentsLoaded,
        resetCommentsScrollTo: resetCommentsScrollTo,
        updateEditingCommentText: updateEditingCommentText,
        cancelEditComment: cancelEditComment,
        updateCommentSuccess: updateCommentSuccess,
        setUpdatingCommentId: setUpdatingCommentId,
        setEditingCommentId: setEditingCommentId,
        removeComment: removeComment,
        setShowNewCommentInput: setShowNewCommentInput,
        setNewComment: setNewComment,
        removeNewComment: removeNewComment
    };
};

var _reduxActions = __webpack_require__(9);

var _constants = __webpack_require__(120);

var _utils = __webpack_require__(6);

var _utils2 = __webpack_require__(362);

var HIGHLIGHT_NEW_COMMENTS_DELAY = 500;

/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.changedTaskWorkflowStatus = undefined;

var _actionTypes = __webpack_require__(667);

var ActionTypes = _interopRequireWildcard(_actionTypes);

var _utils = __webpack_require__(6);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var changedTaskWorkflowStatus = exports.changedTaskWorkflowStatus = function changedTaskWorkflowStatus() {
    var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        taskId: -1,
        workflowStatusId: -1,
        prevWorkflowStatusId: -1
    };

    return (0, _utils.createActionObject)(ActionTypes.WORKFLOW_STATUS_CHANGED, payload);
};

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var CopySettingsTypes = exports.CopySettingsTypes = {
    COPY_MANAGERS: "copyManagers",
    COPY_ASSIGNED_USERS: "copyAssignedUsers",
    COPY_PROJECT_DESCRIPTION: "copyProjectDescription",
    COPY_CUSTOMER_DESCRIPTION: "copyCustomerDescription",
    COPY_TASK_DESCRIPTION: "copyTaskDescription",
    COPY_TASK_STATUS: "copyTaskStatus",
    COPY_TASK_TYPE_OF_WORK: "copyTaskTypeOfWork",
    COPY_TASK_ESTIMATE: "copyTaskEstimate"
};

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.setCustomFields = exports.loadCustomFields = undefined;

var _ClassicBridge = __webpack_require__(18);

var _ClassicBridge2 = _interopRequireDefault(_ClassicBridge);

var _utils = __webpack_require__(6);

var _actionTypes = __webpack_require__(456);

var ActionTypes = _interopRequireWildcard(_actionTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var loadCustomFields = exports.loadCustomFields = function loadCustomFields() {
    return function (dispatch) {
        _ClassicBridge2.default.getTaskCustomFieldsList().then(function (_ref) {
            var items = _ref.items;

            dispatch((0, _utils.createActionObject)(ActionTypes.CUSTOM_FIELDS_SET, items));
        });
    };
};

var setCustomFields = exports.setCustomFields = function setCustomFields(items) {
    return function (dispatch) {
        dispatch((0, _utils.createActionObject)(ActionTypes.CUSTOM_FIELDS_SET, items));
    };
};

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _TemplateView = __webpack_require__(1);

var _TemplateView2 = _interopRequireDefault(_TemplateView);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _EditActionMenu = __webpack_require__(1361);

var _EditActionMenu2 = _interopRequireDefault(_EditActionMenu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function EditActionButton(_ref) {
    var panelEl = _ref.panelEl,
        headerEl = _ref.headerEl,
        needMove = _ref.needMove,
        needCopy = _ref.needCopy,
        needDelete = _ref.needDelete,
        _ref$copyButtonMessag = _ref.copyButtonMessageKey,
        copyButtonMessageKey = _ref$copyButtonMessag === undefined ? "edit_panel.actions.copy" : _ref$copyButtonMessag,
        _ref$onDeleteCb = _ref.onDeleteCb,
        onDeleteCb = _ref$onDeleteCb === undefined ? function () {} : _ref$onDeleteCb,
        _ref$onMoveCb = _ref.onMoveCb,
        onMoveCb = _ref$onMoveCb === undefined ? function () {} : _ref$onMoveCb,
        _ref$onCopyCb = _ref.onCopyCb,
        onCopyCb = _ref$onCopyCb === undefined ? function () {} : _ref$onCopyCb;

    _TemplateView2.default.call(this);
    this.$panel = panelEl;
    this.$header = headerEl;
    this.needMove = needMove;
    this.needCopy = needCopy;
    this.needDelete = needDelete;

    this.copyButtonMessageKey = copyButtonMessageKey;

    this.callbacks = {
        onDeleteCb: onDeleteCb,
        onMoveCb: onMoveCb,
        onCopyCb: onCopyCb
    };
}

EditActionButton.prototype = _underscore2.default.create(_TemplateView2.default.prototype, {
    html: "<div class='actionButtonWrapper'>" + "  <div class='actionButton'>" + "    <div class='img'></div>" + "    <div class='action'><%=action%></div>" + "  </div>" + "</div>",

    updateOnInit: false,
    positionParams: { offset: "-1px -4px" },

    messageKeys: function messageKeys() {
        return {
            action: "edit_panel.actions.title"
        };
    },

    afterRender: function afterRender() {
        var _this = this;

        this.menu = new _EditActionMenu2.default({
            buttonEl: this.find(".actionButton"),
            onDeleteCb: this.callbacks.onDeleteCb,
            onMoveCb: this.callbacks.onMoveCb,
            onCopyCb: this.callbacks.onCopyCb,
            copyButtonMessageKey: this.copyButtonMessageKey
        }).init(this.$panel);
        this.menu.setMove(this.needMove);
        this.menu.setCopy(this.needCopy);
        this.menu.setDelete(this.needDelete);
        this.menu.setEnableDeleteButton();
        this.menu.setEnableMoveButton();

        this.bindClick(function () {
            _this.$el.addClass('pressed');
            _this.menu.showAt(_this.$el, _this.$header, _this.positionParams, _underscore2.default.bind(_this._onSelect, _this));
        });
    },

    _onSelect: function _onSelect() {
        this.hideMenu();
    },

    disableDeleteButton: function disableDeleteButton(text) {
        if (text) this.menu.setDisableDeleteButton(text);else this.menu.setEnableDeleteButton();
    },

    disableMoveButton: function disableMoveButton(text) {
        if (text) this.menu.setDisableMoveButton(text);else this.menu.setEnableMoveButton();
    },

    hideMenu: function hideMenu() {
        this.menu.hide();
    },

    hide: function hide() {
        _TemplateView2.default.prototype.hide.call(this);
        this.hideMenu();
    }
});

exports.default = EditActionButton;

/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _atBrowserUtils = __webpack_require__(8);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SortableTableHeader = function (_TemplateView) {
    _inherits(SortableTableHeader, _TemplateView);

    function SortableTableHeader($containerEl, active, asc, titleMessageKey) {
        var titleLabel = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;

        _classCallCheck(this, SortableTableHeader);

        var _this = _possibleConstructorReturn(this, (SortableTableHeader.__proto__ || Object.getPrototypeOf(SortableTableHeader)).call(this, $containerEl));

        _this.active = active;
        _this.asc = asc;
        _this.titleLabel = !!titleMessageKey ? _messageResource2.default.getMessage(titleMessageKey) : titleLabel;
        return _this;
    }

    _createClass(SortableTableHeader, [{
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='sortableTableHeader'>" + "  <span class='titleLabel'><%-titleLabel%></span>" + "  <div class='arrowContainer'>" + "    <div class='ascArrow'><img src='<%=ascArrow%>'/> <span class='for-print-only'>&darr;</span></div>" + "    <div class='descArrow'><img src='<%=descArrow%>'/> <span class='for-print-only'>&uarr;</span></div>" + "  </div>" + "</div>";
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            this.bindClick(function () {
                if (!this.active) this.active = true;else this.asc = !this.asc;

                this.update();

                (0, _jquery2.default)(this).trigger("click");
            });
        }
    }, {
        key: "update",
        value: function update() {
            this.$el.toggleClass("active", this.active);
            this.$el.toggleClass("asc", this.asc);
            this.$el.toggleClass("desc", !this.asc);
        }
    }, {
        key: "templateModel",
        value: function templateModel() {
            return {
                ascArrow: (0, _atBrowserUtils.atImgPath)("taskManagement/sort-down.png"),
                descArrow: (0, _atBrowserUtils.atImgPath)("taskManagement/sort-up.png"),
                titleLabel: this.titleLabel
            };
        }
    }, {
        key: "isActive",
        value: function isActive() {
            return this.active;
        }
    }, {
        key: "setActive",
        value: function setActive(active) {
            this.active = active;
            this.update();
        }
    }, {
        key: "isAsc",
        value: function isAsc() {
            return this.asc;
        }
    }, {
        key: "setAsc",
        value: function setAsc(asc) {
            this.asc = asc;
            this.update();
        }
    }]);

    return SortableTableHeader;
}(_TemplateView3.default);

exports.default = SortableTableHeader;

/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _clamp = __webpack_require__(1364);

var _atUtils = __webpack_require__(5);

var _SimpleSingletonTooltip = __webpack_require__(45);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Component with text truncated by specified line count with ellipsis.
 *  Need line-height property to be defined in container element.
 */
var TruncatedTextView = function (_TemplateView) {
    _inherits(TruncatedTextView, _TemplateView);

    function TruncatedTextView() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            text = _ref.text,
            _ref$lineCount = _ref.lineCount,
            lineCount = _ref$lineCount === undefined ? 1 : _ref$lineCount,
            ellipsis = _ref.ellipsis;

        _classCallCheck(this, TruncatedTextView);

        var _this = _possibleConstructorReturn(this, (TruncatedTextView.__proto__ || Object.getPrototypeOf(TruncatedTextView)).call(this));

        _this.text = text;
        _this.lineCount = lineCount;
        _this.ellipsis = ellipsis;
        _this.truncated = false;
        return _this;
    }

    _createClass(TruncatedTextView, [{
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='wrapper'/>";
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            this._update();
        }
    }, {
        key: "_update",
        value: function _update() {
            var _this2 = this;

            this.$el.text(!_underscore2.default.isNull(this.text) ? this.text : "");
            (0, _atUtils.defer)(function () {
                _this2.truncated = (0, _clamp.clamp)(_this2.$el[0], { lineCount: _this2.lineCount, ellipsis: _this2.ellipsis });
                if (_this2.truncated) {
                    (0, _SimpleSingletonTooltip.getInstance)().subscribeToMouseEvents(_this2.$el, function () {
                        (0, _SimpleSingletonTooltip.getInstance)().setState({
                            text: _this2.text,
                            extraClass: 'truncatedTextViewTooltip'
                        });
                    });
                }
            }, this);
        }
    }, {
        key: "setText",
        value: function setText(text) {
            this.text = text;
            this._update();
        }
    }, {
        key: "isTruncated",
        value: function isTruncated() {
            return this.truncated;
        }
    }]);

    return TruncatedTextView;
}(_TemplateView3.default);

exports.default = TruncatedTextView;

/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _user_time = __webpack_require__(30);

var _user_time2 = _interopRequireDefault(_user_time);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SummaryRecord = function (_TemplateView) {
    _inherits(SummaryRecord, _TemplateView);

    function SummaryRecord($containerEl, label, containsOtherUsersEntity) {
        _classCallCheck(this, SummaryRecord);

        var _this = _possibleConstructorReturn(this, (SummaryRecord.__proto__ || Object.getPrototypeOf(SummaryRecord)).call(this, $containerEl));

        _this.label = label;
        _this.containsOtherUsersEntity = containsOtherUsersEntity;
        return _this;
    }

    _createClass(SummaryRecord, [{
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='summaryRecord'><span class='label ellipsis'><%-label%> </span><span class='value'/></div>";
        }
    }, {
        key: "shouldUpdateOnInit",
        value: function shouldUpdateOnInit() {
            return false;
        }
    }, {
        key: "templateModel",
        value: function templateModel() {
            return { label: this.label };
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            this.value = null;
            this.$value = this.find('.value');
        }
    }, {
        key: "setValue",
        value: function setValue(value) {
            this.value = value;
            this.update();
        }
    }, {
        key: "update",
        value: function update() {
            if (!_underscore2.default.isNull(this.value)) this.$value.text('  ' + _user_time2.default.formatTimeWithDigitSeparator(this.value));
            this.$el.toggleClass('otherUsersEntity', this.containsOtherUsersEntity);
        }
    }]);

    return SummaryRecord;
}(_TemplateView3.default);

exports.default = SummaryRecord;

/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SelectorPanel = exports.NodeRenderer = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _Ext = __webpack_require__(12);

var _Ext2 = _interopRequireDefault(_Ext);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _View2 = __webpack_require__(20);

var _View3 = _interopRequireDefault(_View2);

var _at_users_selector_panel = __webpack_require__(162);

var _at_users_selector_panel2 = _interopRequireDefault(_at_users_selector_panel);

var _at_shared_user_button_menu = __webpack_require__(159);

var _at_shared_user_button_menu2 = _interopRequireDefault(_at_shared_user_button_menu);

var _two_level_selection = __webpack_require__(70);

var _two_level_selection2 = _interopRequireDefault(_two_level_selection);

var _GroupType = __webpack_require__(34);

var _GroupType2 = _interopRequireDefault(_GroupType);

var _UserNodeRenderer2 = __webpack_require__(357);

var _UserNodeRenderer3 = _interopRequireDefault(_UserNodeRenderer2);

var _UserGroupSelectableNodeRenderer = __webpack_require__(1388);

var _UserGroupSelectableNodeRenderer2 = _interopRequireDefault(_UserGroupSelectableNodeRenderer);

var _DisabledUsersParentNodeRendererWithoutCheckbox = __webpack_require__(1389);

var _DisabledUsersParentNodeRendererWithoutCheckbox2 = _interopRequireDefault(_DisabledUsersParentNodeRendererWithoutCheckbox);

var _PermissionIcons = __webpack_require__(775);

var _PermissionIcons2 = _interopRequireDefault(_PermissionIcons);

var _atUtils = __webpack_require__(5);

var _utils = __webpack_require__(293);

var _TriStateSelectionController = __webpack_require__(479);

var _TriStateSelectionController2 = _interopRequireDefault(_TriStateSelectionController);

var _TreeNode = __webpack_require__(60);

var _TreeNode2 = _interopRequireDefault(_TreeNode);

var _SimpleSingletonTooltip = __webpack_require__(45);

var _keyHandlers = __webpack_require__(48);

var _keyCodes = __webpack_require__(66);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NodeRenderer = exports.NodeRenderer = function (_UserNodeRenderer) {
    _inherits(NodeRenderer, _UserNodeRenderer);

    function NodeRenderer(_ref) {
        var selectorTree = _ref.selectorTree,
            selectorFilter = _ref.selectorFilter,
            selectionHelper = _ref.selectionHelper,
            showPermissionIcons = _ref.showPermissionIcons,
            _ref$canDeselectUser = _ref.canDeselectUser,
            canDeselectUser = _ref$canDeselectUser === undefined ? function (user) {
            return true;
        } : _ref$canDeselectUser,
            _ref$showGenerateMone = _ref.showGenerateMoneyReportsIcon,
            showGenerateMoneyReportsIcon = _ref$showGenerateMone === undefined ? false : _ref$showGenerateMone,
            _ref$generateMoneyRep = _ref.generateMoneyReportsIconTooltip,
            generateMoneyReportsIconTooltip = _ref$generateMoneyRep === undefined ? "" : _ref$generateMoneyRep,
            _ref$modifyTimeTrackT = _ref.modifyTimeTrackTooltipText,
            modifyTimeTrackTooltipText = _ref$modifyTimeTrackT === undefined ? "" : _ref$modifyTimeTrackT,
            _ref$getDisabledToolt = _ref.getDisabledTooltipText,
            getDisabledTooltipText = _ref$getDisabledToolt === undefined ? function (user) {
            return "";
        } : _ref$getDisabledToolt;

        _classCallCheck(this, NodeRenderer);

        var _this = _possibleConstructorReturn(this, (NodeRenderer.__proto__ || Object.getPrototypeOf(NodeRenderer)).call(this, selectorTree, selectorFilter, selectionHelper));

        _this.showPermissionIcons = showPermissionIcons;
        _this.canDeselectUser = canDeselectUser;
        _this.showGenerateMoneyReportsIcon = showGenerateMoneyReportsIcon;
        _this.generateMoneyReportsIconTooltip = generateMoneyReportsIconTooltip;
        _this.modifyTimeTrackTooltipText = modifyTimeTrackTooltipText;
        _this.getDisabledTooltipText = getDisabledTooltipText;
        _this.unsubscribeTooltipMap = {};
        return _this;
    }

    _createClass(NodeRenderer, [{
        key: "generateContent",
        value: function generateContent(treeNode, targetEl) {
            _get(NodeRenderer.prototype.__proto__ || Object.getPrototypeOf(NodeRenderer.prototype), "generateContent", this).call(this, treeNode, targetEl);

            var user = treeNode.getValue();
            if (this.showPermissionIcons) {
                new _PermissionIcons2.default(_extends({}, (0, _utils.extractPermissionsFromUser)(user), {
                    showCostReports: this.showGenerateMoneyReportsIcon,
                    costReportsTooltipText: this.generateMoneyReportsIconTooltip,
                    modifyTimeTrackTooltipText: this.modifyTimeTrackTooltipText
                })).init((0, _jquery2.default)(targetEl));
            }

            if (!this.canDeselectUser(user)) {
                var disabledTooltipText = this.getDisabledTooltipText(user);
                this.unsubscribeTooltipMap[user.id] && this.unsubscribeTooltipMap[user.id]();
                if (disabledTooltipText) {
                    var $checkbox = (0, _jquery2.default)(targetEl).find('.checkbox');
                    this.unsubscribeTooltipMap[user.id] = (0, _SimpleSingletonTooltip.getInstance)().subscribeToMouseEvents($checkbox, function () {
                        (0, _SimpleSingletonTooltip.getInstance)().setState({
                            text: disabledTooltipText,
                            extraClass: 'hierarchyAssignmentsTooltip'
                        });
                    });
                }
            }
        }
    }]);

    return NodeRenderer;
}(_UserNodeRenderer3.default);

var SelectorPanel = exports.SelectorPanel = _Ext2.default.extend(_at_users_selector_panel2.default, {
    showPermissionIcons: false,
    canDeselectUser: function canDeselectUser(user) {
        return true;
    },
    title: "",
    showGenerateMoneyReportsIcon: false,
    generateMoneyReportsIconTooltip: "",
    getDisabledTooltipText: function getDisabledTooltipText(user) {
        return "";
    },
    hideSelect: false,

    createTree: function createTree() {
        var _this2 = this;

        var tree = SelectorPanel.superclass.createTree.call(this);
        var alwaysSelectedNodes = tree.getAllNodes().filter(function (node) {
            return node.getType() === _TreeNode2.default.TYPE_USER && !_this2.canDeselectUser(node.getValue());
        });
        tree.selectionController = new _TriStateSelectionController2.default(tree, alwaysSelectedNodes);
        return tree;
    },
    createComponents: function createComponents() {
        SelectorPanel.superclass.createComponents.call(this);
        this.addClass("assignedUserSelector");
        if (this.showPermissionIcons) {
            this.addClass("withPermissionIcons");
        }
    },
    getUserNodeRenderer: function getUserNodeRenderer() {
        return new NodeRenderer({
            selectorTree: this.selectorTree,
            selectorFilter: this.selectorFilter,
            selectionHelper: this.getSelectionHelper(),
            showPermissionIcons: this.showPermissionIcons,
            showGenerateMoneyReportsIcon: this.showGenerateMoneyReportsIcon,
            generateMoneyReportsIconTooltip: this.generateMoneyReportsIconTooltip,
            modifyTimeTrackTooltipText: this.modifyTimeTrackTooltipText,
            getDisabledTooltipText: this.getDisabledTooltipText,
            canDeselectUser: this.canDeselectUser
        });
    },


    getUserGroupNodeRenderer: function getUserGroupNodeRenderer() {
        return new _UserGroupSelectableNodeRenderer2.default(this.selectorTree, this.selectorFilter, this.getExpandCollapseCallback(), this.hideSelect);
    },

    getTimeZoneGroupNodeRenderer: function getTimeZoneGroupNodeRenderer() {
        return new _UserGroupSelectableNodeRenderer2.default(this.selectorTree, this.selectorFilter, this.getExpandCollapseCallback(), this.hideSelect);
    },

    getDisabledUsersParentNodeRenderer: function getDisabledUsersParentNodeRenderer() {
        return new _DisabledUsersParentNodeRendererWithoutCheckbox2.default(this.selectorTree, this.selectorFilter, this.getExpandCollapseCallback());
    },

    createGenericOptions: function createGenericOptions() {
        this.genericOptions = [];
    },
    createCustomOption: function createCustomOption() {},
    getGenericOptionsSection: function getGenericOptionsSection() {
        return [];
    },
    getCustomOptionSection: function getCustomOptionSection() {
        var toolbox = new _Ext2.default.Container({
            cls: "userSelectorCustomControlsContainer",
            autoEl: "div",
            items: [this.viewByPanel, this.getCustomOptionButtonsSection()]
        });
        if (this.title) {
            var titleLabel = {
                xtype: "box",
                cls: "panelTitle",
                autoEl: {
                    tag: "div",
                    html: (0, _atUtils.escapeHtmlSymbols)(this.title)
                }
            };
            return [titleLabel, toolbox];
        } else {
            return [toolbox];
        }
    },
    getDetailsSection: function getDetailsSection() {
        return [this.selectorTree, this.showInactiveCheckboxContainer];
    },
    getCurrentOptionValue: function getCurrentOptionValue() {
        return this.customOptionValue;
    },
    isCustomOptionSelected: function isCustomOptionSelected() {
        return true;
    },
    mapSelectionGroupsToUsers: function mapSelectionGroupsToUsers() {
        return true;
    }
});

var UsersSelector = function (_View) {
    _inherits(UsersSelector, _View);

    function UsersSelector(_ref2) {
        var _ref2$selectionCallba = _ref2.selectionCallback,
            selectionCallback = _ref2$selectionCallba === undefined ? function (_ref3) {
            var addedUserIds = _ref3.addedUserIds,
                removedUserIds = _ref3.removedUserIds;
        } : _ref2$selectionCallba,
            _ref2$showPermissionI = _ref2.showPermissionIcons,
            showPermissionIcons = _ref2$showPermissionI === undefined ? false : _ref2$showPermissionI,
            _ref2$canDeselectUser = _ref2.canDeselectUser,
            canDeselectUser = _ref2$canDeselectUser === undefined ? function (user) {
            return true;
        } : _ref2$canDeselectUser,
            _ref2$resetOnHide = _ref2.resetOnHide,
            resetOnHide = _ref2$resetOnHide === undefined ? true : _ref2$resetOnHide,
            _ref2$parentEl = _ref2.parentEl,
            parentEl = _ref2$parentEl === undefined ? null : _ref2$parentEl,
            _ref2$refreshScrollOn = _ref2.refreshScrollOnShowCb,
            refreshScrollOnShowCb = _ref2$refreshScrollOn === undefined ? function () {} : _ref2$refreshScrollOn,
            _ref2$refreshScrollOn2 = _ref2.refreshScrollOnHideCb,
            refreshScrollOnHideCb = _ref2$refreshScrollOn2 === undefined ? function () {} : _ref2$refreshScrollOn2,
            _ref2$getDisabledTool = _ref2.getDisabledTooltipText,
            getDisabledTooltipText = _ref2$getDisabledTool === undefined ? function (user) {
            return "";
        } : _ref2$getDisabledTool;

        _classCallCheck(this, UsersSelector);

        var _this3 = _possibleConstructorReturn(this, (UsersSelector.__proto__ || Object.getPrototypeOf(UsersSelector)).call(this));

        _this3.params = {
            showPermissionIcons: showPermissionIcons,
            resetOnHide: resetOnHide,
            parentEl: parentEl,
            selectionCallback: selectionCallback,
            canDeselectUser: canDeselectUser,
            refreshScrollOnShowCb: refreshScrollOnShowCb,
            refreshScrollOnHideCb: refreshScrollOnHideCb,
            getDisabledTooltipText: getDisabledTooltipText
        };

        _this3.state = {
            selection: [],
            users: [],
            userGroups: [],
            groupBy: _GroupType2.default.USER_GROUP,
            timeZoneGroups: [],
            userGroupsEnabled: true,
            timeZoneGroupsEnabled: true,
            title: "",
            isURAEnabled: false,
            isBTYEnabled: false,
            isTTAEnabled: false
        };

        _this3.onStateDeeplyChanged(function () {
            return _this3._initPanel();
        });
        return _this3;
    }

    _createClass(UsersSelector, [{
        key: "showAt",
        value: function showAt($el, position) {
            this.menu.show($el[0], position);
        }
    }, {
        key: "hide",
        value: function hide() {
            this.menu.hide();
        }
    }, {
        key: "_initPanel",
        value: function _initPanel() {
            var _this4 = this;

            var panel = new SelectorPanel({
                showPermissionIcons: this.params.showPermissionIcons,
                canDeselectUser: this.params.canDeselectUser,
                title: this.state.title,
                showGenerateMoneyReportsIcon: this.state.isBTYEnabled || this.state.isURAEnabled,
                generateMoneyReportsIconTooltip: (0, _utils.getTitleOfGenerateMoneyReportsRight)(this.state.isBTYEnabled, this.state.isURAEnabled),
                modifyTimeTrackTooltipText: (0, _utils.getTitleOfModifyTimeTrackRight)(this.state.isTTAEnabled),
                resetOnHide: this.params.resetOnHide,
                showShowInactiveCheckbox: false,
                getDisabledTooltipText: this.params.getDisabledTooltipText
            });
            panel.initialize(this.state.userGroupsEnabled, this.state.timeZoneGroupsEnabled, this.state.users, this.state.userGroups, this.state.timeZoneGroups);
            panel.loadState({
                selection: new _two_level_selection2.default([], this.state.selection),
                groupType: this.state.groupBy,
                additionalCheckBoxValue: false,
                optionValue: false,
                showInactive: false
            });

            var menu = new _at_shared_user_button_menu2.default({
                panel: panel,
                parentEl: this.params.parentEl
            });
            this._onKeyDownRemover = null;
            menu.on("hide", function () {
                var selection = panel.getSelection().getSecondLevel();

                var _unorderedArraysDiffe = (0, _atUtils.unorderedArraysDifference)(_this4.state.selection, selection),
                    addedUserIds = _unorderedArraysDiffe.added,
                    removedUserIds = _unorderedArraysDiffe.removed;

                if (addedUserIds.length > 0 || removedUserIds.length > 0) {
                    _this4.params.selectionCallback({ addedUserIds: addedUserIds, removedUserIds: removedUserIds });
                }
                if (_this4.params.resetOnHide) {
                    panel.resetNodes();
                }
                _this4.params.refreshScrollOnHideCb();

                if (_this4._onKeyDownRemover) _this4._onKeyDownRemover();
            });
            menu.on("show", function () {
                _this4.params.refreshScrollOnShowCb(menu.el.getBottom());
                _this4._onKeyDownRemover = (0, _keyHandlers.onKeyDown)(function (code) {
                    // handle event for components that contains this selector
                    if (code === _keyCodes.KEY_CODE_ESC) return true;
                });
            });

            this.menu = menu;
        }
    }]);

    return UsersSelector;
}(_View3.default);

exports.default = UsersSelector;

/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _keyCodes = __webpack_require__(66);

var _atBrowserUtils = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DeleteConfirmationDialog = function (_TemplateView) {
    _inherits(DeleteConfirmationDialog, _TemplateView);

    function DeleteConfirmationDialog($container, cancelHandler, deleteHandler) {
        _classCallCheck(this, DeleteConfirmationDialog);

        var _this = _possibleConstructorReturn(this, (DeleteConfirmationDialog.__proto__ || Object.getPrototypeOf(DeleteConfirmationDialog)).call(this, $container));

        _this.cancelHandler = cancelHandler;
        _this.deleteHandler = deleteHandler;

        _this.state = {
            hasManagerApprover: false,
            entityName: "",
            entitiesToDeleteCount: 0,
            entitiesBlocked: [],
            entitiesBlockedCount: 0,
            entitiesBlockedDueToLockedTimeCount: 0,
            entitiesBlockedDueToUnavailableToModifyTimeTrackCount: 0,
            entitiesWithManagerTimeTrackCount: 0,
            entitiesWithOtherUsersTimeTrackCount: 0,
            entitiesWithManagerApprovedTimeTrackCount: 0,
            entitiesWithOtherUsersApprovedTimeTrackCount: 0
        };

        _this.onStateChanged(function () {
            return _this.updateTitles();
        });
        return _this;
    }

    _createClass(DeleteConfirmationDialog, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class="operationConfirmDialog">' + '  <div class="operationConfirmDialogInnerContainer">' + '    <div class="warningIcon"></div>' + '    <div class="title"></div>' + '    <div class="orangeBlock">' + '      <span class="first"></span>' + '      <br>' + '      <span class="second"></span>' + '    </div>' + '    <ul class="pointsBlock">' + '      <li class="point entities"></li>' + '      <li class="point timetrack"></li>' + '      <li class="point managerApproveWeeksPoint"></li>' + '      <li class="point approveWeeksPoint"><%-approveRejectWeeksText%></li>' + '      <div class="choiceApprovalWeeks">' + '        <div class="weeksStatusRadioButton">' + '          <label>' + '            <input type="radio" value="true" class="revokeWeeksStatuses" name="revokeStatus" checked><%=revokeWeeksStatusesLabel%></label>' + '        </div>' + '        <div class="weeksStatusRadioButton">' + '          <label><input type="radio" value="false" class="keepWeeksStatuses" name="revokeStatus"><%=keepWeeksStatusesLabel%></label>' + '        </div>' + '      </div>' + '    </ul>' + '    <div class="blockedWarningContainer">' + '      <div class="link"></div>' + '      <div class="other"></div>' + '    </div>' + '    <div class="buttonsContainer">' + '      <div class="submitBtn withIcon commitBtn greyButton" tabindex="-1">' + '        <div class="buttonIcon">' + '          <span class="submitTitle buttonTitle"></span>' + '        </div>' + '      </div>' + '      <div class="cancelBtn greyButton"><%=cancelButtonText%></div>' + '    </div>' + '  </div>' + '</div>';
        }
    }, {
        key: 'messageKeys',
        value: function messageKeys() {
            return {
                approveRejectWeeksText: "delete.confirm.dialog.about_approve_weeks",
                revokeWeeksStatusesLabel: "delete.confirm.dialog.revoke_weeks_statuses_label",
                keepWeeksStatusesLabel: "delete.confirm.dialog.keep_weeks_statuses_label",
                cancelButtonText: "delete.confirm.dialog.cancel"
            };
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            this.$revokeWeeksStatusesButton = this.find(".revokeWeeksStatuses");
            this.setHandlers();
        }
    }, {
        key: 'allBlocked',
        value: function allBlocked() {
            return this.state.entitiesBlockedCount === this.state.entitiesToDeleteCount;
        }
    }, {
        key: 'someBlocked',
        value: function someBlocked() {
            return this.state.entitiesBlockedCount > 0 && this.state.entitiesBlockedCount < this.state.entitiesToDeleteCount;
        }
    }, {
        key: 'hasTimeTrack',
        value: function hasTimeTrack() {
            return this.state.entitiesWithOtherUsersTimeTrackCount > 0 || this.state.entitiesWithManagerTimeTrackCount > 0;
        }
    }, {
        key: 'hasApprovedWeeks',
        value: function hasApprovedWeeks() {
            return this.state.entitiesWithOtherUsersApprovedTimeTrackCount > 0;
        }
    }, {
        key: 'hasManagerApprovedWeeksAndApprover',
        value: function hasManagerApprovedWeeksAndApprover() {
            return this.state.entitiesWithManagerApprovedTimeTrackCount > 0 && this.state.hasManagerApprover;
        }
    }, {
        key: 'show',
        value: function show() {
            _get(DeleteConfirmationDialog.prototype.__proto__ || Object.getPrototypeOf(DeleteConfirmationDialog.prototype), 'show', this).call(this);

            this._setSavingState(false);

            if (this.showHandler) this.showHandler();
            var self = this;
            var $submitBtn = this.find(".submitBtn");
            $submitBtn.off("keydown").on("keydown", function (event) {
                switch (event.keyCode) {
                    case _keyCodes.KEY_CODE_SPACE:
                    case _keyCodes.KEY_CODE_ENTER:
                        self.onSubmit();
                        (0, _atBrowserUtils.cancelBubble)(event.originalEvent);
                        return false;
                }
            });
            if (this.blockedEntitiesList) this.blockedEntitiesList.setDisabled(false);

            this.$revokeWeeksStatusesButton.prop("checked", true);
        }
    }, {
        key: 'setHandlers',
        value: function setHandlers() {
            var _this2 = this;

            this.find(".cancelBtn").unbind().click(function () {
                return _this2.onCancel();
            });
            this.find(".submitBtn").unbind().click(function () {
                return _this2.onSubmit();
            });
        }
    }, {
        key: 'onCancel',
        value: function onCancel() {
            if (this.savingState) return;

            this._setSavingState(false);
            this._removeBlockedEntitiesList();
            this.cancelHandler();
        }
    }, {
        key: 'hide',
        value: function hide() {
            this._setSavingState(false);
            this._removeBlockedEntitiesList();
            _get(DeleteConfirmationDialog.prototype.__proto__ || Object.getPrototypeOf(DeleteConfirmationDialog.prototype), 'hide', this).call(this);
        }
    }, {
        key: 'onSubmit',
        value: function onSubmit() {
            if (this.savingState) return;

            this._setSavingState(true);

            var revokeStatuses = (0, _jquery2.default)("input[name='revokeStatus']:checked").val();
            this.deleteHandler(revokeStatuses);
        }
    }, {
        key: 'updateTitles',
        value: function updateTitles() {
            this.find(".title").text(this.titleText());
            this.find(".orangeBlock .first").text(this.firstOrangeSentence());
            this.find(".orangeBlock .second").text(this.secondOrangeSentence());
            this.find(".pointsBlock .entities").text(this.removeEntitiesPointText());
            this.find(".pointsBlock .timetrack").text(this.removeTimeTrackPointText());
            this.find(".pointsBlock .managerApproveWeeksPoint").text(this.getRemoveManagerApprovedTimeTrackText());
            this.find(".blockedWarningContainer .link").text(this.blockedWarningLinkText());
            this.find(".blockedWarningContainer .other").text(this.blockedWarningOtherText());
            this.find(".buttonTitle").text(this.deleteButtonText());

            this.$el.toggleClass("allBlocked", this.allBlocked());
            this.$el.toggleClass("someBlocked", this.someBlocked());
            this.$el.toggleClass("hasTimeTrack", this.hasTimeTrack());
            this.$el.toggleClass("hasApprovedWeeks", this.hasApprovedWeeks());
            this.$el.toggleClass("hasManagerApprovedWeeksAndApprover", this.hasManagerApprovedWeeksAndApprover());

            var $blockedWarningLink = this.find(".blockedWarningContainer .link");
            this._removeBlockedEntitiesList();
            var blockedEntitiesList = this.blockedEntitiesList = this.createBlockedEntitiesList();
            $blockedWarningLink.click(function () {
                if (!blockedEntitiesList.isDisabled()) blockedEntitiesList.showAt($blockedWarningLink, {
                    offset: "10px 20px",
                    at: "right bottom",
                    my: "left bottom",
                    collision: "none"
                });
            });
        }
    }, {
        key: 'getRemoveManagerApprovedTimeTrackText',
        value: function getRemoveManagerApprovedTimeTrackText() {
            return _messageResource2.default.getMessage(this.state.entitiesWithManagerApprovedTimeTrackCount > 1 ? "delete.confirm.dialog.about_approved_manager_time_track" : "delete.confirm.dialog.about_approved_manager_time_track_one_task");
        }
    }, {
        key: 'createBlockedEntitiesList',
        value: function createBlockedEntitiesList() {
            // Abstract
        }
    }, {
        key: 'titleText',
        value: function titleText() {
            // Abstract
        }
    }, {
        key: 'firstOrangeSentence',
        value: function firstOrangeSentence() {
            // Abstract
        }
    }, {
        key: 'secondOrangeSentence',
        value: function secondOrangeSentence() {
            // Abstract
        }
    }, {
        key: 'removeEntitiesPointText',
        value: function removeEntitiesPointText() {
            // Abstract
        }
    }, {
        key: 'removeTimeTrackPointText',
        value: function removeTimeTrackPointText() {
            // Abstract
        }
    }, {
        key: 'blockedWarningLinkText',
        value: function blockedWarningLinkText() {
            // Abstract
        }
    }, {
        key: 'blockedWarningOtherText',
        value: function blockedWarningOtherText() {
            // Abstract
        }
    }, {
        key: 'deleteButtonText',
        value: function deleteButtonText() {
            // Abstract
        }
    }, {
        key: '_setSavingState',
        value: function _setSavingState(saving) {
            this.$el.toggleClass('savingState', saving);
            this.savingState = saving;
        }
    }, {
        key: '_removeBlockedEntitiesList',
        value: function _removeBlockedEntitiesList() {
            if (this.blockedEntitiesList) {
                this.blockedEntitiesList.setDisabled(true);
                this.blockedEntitiesList.$el.remove();
            }
        }
    }]);

    return DeleteConfirmationDialog;
}(_TemplateView3.default);

exports.default = DeleteConfirmationDialog;

/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _CommentInputContainer = __webpack_require__(1391);

var _CommentInputContainer2 = _interopRequireDefault(_CommentInputContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CommentsFooter = function (_TemplateView) {
    _inherits(CommentsFooter, _TemplateView);

    function CommentsFooter(_ref) {
        var _ref$onCommentTextCha = _ref.onCommentTextChange,
            onCommentTextChange = _ref$onCommentTextCha === undefined ? function () {} : _ref$onCommentTextCha,
            _ref$onShowInputChang = _ref.onShowInputChanged,
            onShowInputChanged = _ref$onShowInputChang === undefined ? function () {} : _ref$onShowInputChang,
            _ref$onCommentAdded = _ref.onCommentAdded,
            onCommentAdded = _ref$onCommentAdded === undefined ? function () {} : _ref$onCommentAdded,
            _ref$refreshScrollCb = _ref.refreshScrollCb,
            refreshScrollCb = _ref$refreshScrollCb === undefined ? function () {} : _ref$refreshScrollCb;

        _classCallCheck(this, CommentsFooter);

        var _this = _possibleConstructorReturn(this, (CommentsFooter.__proto__ || Object.getPrototypeOf(CommentsFooter)).call(this));

        _this.callbacks = {
            onCommentTextChange: onCommentTextChange,
            onShowInputChanged: onShowInputChanged,
            onCommentAdded: onCommentAdded,
            refreshScrollCb: refreshScrollCb
        };

        _this.state = {
            loggedInUser: null,
            sending: false,
            showNewCommentInput: false,
            commentText: ''
        };

        _this.onStatePropertyChanged('loggedInUser', function () {
            return _this._renderCommentInput();
        });
        _this.onStatePropertyChanged('sending', function (sending) {
            return _this.commentInput.setState({ sending: sending });
        });
        _this.onStatePropertyChanged('showNewCommentInput', function (showCommentInput) {
            return _this.commentInput.setState({ showCommentInput: showCommentInput });
        });
        _this.onStatePropertyChanged('commentText', function (commentText) {
            return _this.commentInput.setState({ commentText: commentText });
        });
        return _this;
    }

    _createClass(CommentsFooter, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return "<div class='commentsFooter'>" + "    <div class='commentInputPlaceholder'/>" + "</div>";
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            this.$commentInput = this.find('.commentInputPlaceholder');
        }
    }, {
        key: '_renderCommentInput',
        value: function _renderCommentInput() {
            this.$commentInput.empty();
            this.commentInput = new _CommentInputContainer2.default({
                userInfo: this.state.loggedInUser,
                onCommentTextChange: this.callbacks.onCommentTextChange,
                onShowInputChanged: this.callbacks.onShowInputChanged,
                onCommentAdded: this.callbacks.onCommentAdded,
                refreshScrollCb: this.callbacks.refreshScrollCb
            }).init(this.$commentInput);
        }
    }]);

    return CommentsFooter;
}(_TemplateView3.default);

exports.default = CommentsFooter;

/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _CompletedTaskStatusMenu = __webpack_require__(779);

var _CompletedTaskStatusMenu2 = _interopRequireDefault(_CompletedTaskStatusMenu);

var _TaskStatusButton = __webpack_require__(240);

var _TaskStatusButton2 = _interopRequireDefault(_TaskStatusButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MoveToArchivedConfirmationDialog = function (_TemplateView) {
    _inherits(MoveToArchivedConfirmationDialog, _TemplateView);

    function MoveToArchivedConfirmationDialog(_ref) {
        var _ref$confirmCallback = _ref.confirmCallback,
            confirmCallback = _ref$confirmCallback === undefined ? function (_ref2) {
            var customer = _ref2.customer,
                project = _ref2.project,
                withRestore = _ref2.withRestore,
                workflowStatusId = _ref2.workflowStatusId;
        } : _ref$confirmCallback,
            _ref$cancelCallback = _ref.cancelCallback,
            cancelCallback = _ref$cancelCallback === undefined ? function () {} : _ref$cancelCallback,
            _ref$initStatusMenuTo = _ref.initStatusMenuTo,
            initStatusMenuTo = _ref$initStatusMenuTo === undefined ? null : _ref$initStatusMenuTo;

        _classCallCheck(this, MoveToArchivedConfirmationDialog);

        var _this = _possibleConstructorReturn(this, (MoveToArchivedConfirmationDialog.__proto__ || Object.getPrototypeOf(MoveToArchivedConfirmationDialog)).call(this));

        _this._updateRadio = function (completeOptionSelected) {
            _this.$restoreFromArchiveRadio.prop('checked', !completeOptionSelected);
            _this.$completeWithStatusRadio.prop('checked', completeOptionSelected);

            _this.$completeWithStatusOption.toggleClass('selected', completeOptionSelected);
            _this.$restoreFromArchiveOption.toggleClass('selected', !completeOptionSelected);

            _this.radioStatusButton.setEditable(completeOptionSelected && _this.state.canEditTaskStatus);
        };

        _this.params = {
            initStatusMenuTo: initStatusMenuTo
        };

        _this.callbacks = {
            confirmCallback: confirmCallback,
            cancelCallback: cancelCallback
        };

        _this.state = {
            customer: null,
            project: null,
            workflowStatusId: null,
            withRestoreOption: false,
            completeOptionSelected: true,
            canEditTaskStatus: true,
            isTWSEnabled: false,

            title: '',
            singleOptionDescription: '',
            multiOptionDescription: '',
            archiveText: '',
            restoreText: '',
            showRestoreNote: false
        };

        _this.onStatePropertyChanged("completeOptionSelected", _this._updateRadio);

        _this.onStatePropertyChanged("title", function () {
            return _this.$title.text(_this.state.title);
        });

        _this.onStatePropertyChanged("archiveText", function () {
            return _this.$archiveText.text(_this.state.archiveText);
        });

        _this.onStatePropertyChanged("restoreText", function () {
            return _this.$restoreText.text(_this.state.restoreText);
        });

        _this.onStatePropertyChanged("showRestoreNote", function () {
            return _this.$restoreNote.toggle(_this.state.showRestoreNote);
        });

        _this.onStatePropertyChanged("canEditTaskStatus", function (canEditTaskStatus) {
            if (_this.singleStatusButton && _this.singleStatusButton.setEditable) {
                _this.singleStatusButton.setEditable(canEditTaskStatus);
            }

            if (_this.radioStatusButton && _this.radioStatusButton.setEditable) {
                _this.radioStatusButton.setEditable(canEditTaskStatus);
            }
        });

        _this.onStatePropertyChanged("workflowStatusId", function (workflowStatusId) {
            _this.radioStatusButton.setState({ statusId: workflowStatusId });
            _this.singleStatusButton.setState({ statusId: workflowStatusId });
        });

        _this.onAnyStatePropertyChanged(['withRestoreOption', 'isTWSEnabled'], function () {
            _this.$description.toggle(_this.state.withRestoreOption || _this.state.isTWSEnabled);
            _this.$radioSection.toggle(_this.state.withRestoreOption);
            _this.$statusButton.toggle(!_this.state.withRestoreOption && _this.state.isTWSEnabled);
            _this.radioStatusButton.toggle(_this.state.withRestoreOption && _this.state.isTWSEnabled);

            _this._updateDescriptionText();
        });

        _this.onAnyStatePropertyChanged(['withRestoreOption', 'singleOptionDescription', 'multiOptionDescription'], function () {
            return _this._updateDescriptionText();
        });
        return _this;
    }

    _createClass(MoveToArchivedConfirmationDialog, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '\n        <div class=\'moveToArchivedConfirmationDialog\'>\n            <div class=\'flexWrapper\'>\n                <div class=\'title\'/>\n                <div class=\'description\'/>\n                <div class=\'statusSelector single\'/>\n                <div class=\'radioSection\'>\n                    <label>\n                        <div class=\'completeWithStatus radioOption\'>\n                            <input type=\'radio\' class=\'complete\' checked/>\n                            <div class=\'archiveText\'/>\n                            <div class=\'statusSelector radio\'/>\n                        </div>\n                    </label>\n                    <label>\n                        <div class=\'restoreFromArchive radioOption\'>\n                            <input type=\'radio\' class=\'restore\'/>\n                            <div class=\'restoreTextContainer\'>\n                                <div class=\'restoreText\'/>\n                                <div class=\'restoreNote\'><%-restoreNote%></div>\n                            </div>\n                        </div>\n                    </label>\n                </div>\n                <div class=\'separator\'/>\n                <div class=\'buttonsContainer\'>\n                    <div class=\'move button\'><%=moveLabel%></div>\n                    <div class=\'cancel button\'><%=cancelLabel%></div>\n                </div>\n            </div>\n        </div>\n        ';
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            var _this2 = this;

            this.$title = this.find(".title");

            this.$description = this.find(".description");
            this._updateDescriptionText();

            this.$archiveText = this.find(".archiveText");
            this.$restoreText = this.find(".restoreText");
            this.$restoreNote = this.find(".restoreNote");

            this.$statusButton = this.find(".statusSelector.single");
            this.singleStatusButton = this._createTaskStatusButton(this.$statusButton);

            this.$radioSection = this.find(".radioSection");
            this.radioStatusButton = this._createTaskStatusButton(this.find(".statusSelector.radio"));
            this.radioStatusButton.setState({ canReopenProject: true });

            this.$completeWithStatusOption = this.find(".completeWithStatus");
            this.$completeWithStatusRadio = this.$completeWithStatusOption.find(".complete").on('change', function () {
                return _this2.setState({ completeOptionSelected: true });
            });
            this.$restoreFromArchiveOption = this.find(".restoreFromArchive");
            this.$restoreFromArchiveRadio = this.$restoreFromArchiveOption.find(".restore").on('change', function () {
                return _this2.setState({ completeOptionSelected: false });
            });

            this.find(".move").click(function () {
                _this2.callbacks.confirmCallback({
                    customer: _this2.state.customer,
                    project: _this2.state.project,
                    withRestore: !_this2.state.completeOptionSelected,
                    workflowStatusId: _this2.state.workflowStatusId
                });
            });
            this.find(".cancel").click(function () {
                _this2.callbacks.cancelCallback();
            });

            this.renderInitialState();
        }
    }, {
        key: 'messageKeys',
        value: function messageKeys() {
            return {
                moveLabel: "edit_panel.action.move",
                cancelLabel: "common.cancel",
                restoreNote: "task.list.move_to.move_to_archived.restore_target_from_archive.description"
            };
        }
    }, {
        key: '_updateDescriptionText',
        value: function _updateDescriptionText() {
            this.$description.text(this.state.withRestoreOption ? this.state.multiOptionDescription : this.state.singleOptionDescription);
        }
    }, {
        key: '_createTaskStatusButton',
        value: function _createTaskStatusButton($container) {
            var _this3 = this;

            return new _TaskStatusButton2.default({
                editable: true,
                taskStatusMenu: new _CompletedTaskStatusMenu2.default().init(this.params.initStatusMenuTo || this.getEl()),
                showStatusTypePrefix: false,
                positionParams: {
                    within: this.params.initStatusMenuTo || this.getEl(),
                    collision: 'flipfit'
                },
                onStatusChangedCb: function onStatusChangedCb(workflowStatusId) {
                    return _this3.setState({
                        workflowStatusId: workflowStatusId
                    });
                }
            }).init($container);
        }
    }]);

    return MoveToArchivedConfirmationDialog;
}(_TemplateView3.default);

exports.default = MoveToArchivedConfirmationDialog;

/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.RelatedType = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _ClassicBridge = __webpack_require__(18);

var _ClassicBridge2 = _interopRequireDefault(_ClassicBridge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RelatedType = exports.RelatedType = {
    Customer: 'Customer',
    Project: 'Project',
    Task: 'Task'
};

var BudgetsTab = function (_TemplateView) {
    _inherits(BudgetsTab, _TemplateView);

    function BudgetsTab(_ref) {
        var relatedType = _ref.relatedType;

        _classCallCheck(this, BudgetsTab);

        var _this = _possibleConstructorReturn(this, (BudgetsTab.__proto__ || Object.getPrototypeOf(BudgetsTab)).call(this));

        _this.state = {
            relatedId: null,
            areCostBudgetsEnabled: false,
            areBillingBudgetsEnabled: false,
            typeOfWork: undefined
        };

        _this.relatedType = relatedType;

        _this.onAnyStatePropertyChanged(['relatedId', 'areCostBudgetsEnabled', 'areBillingBudgetsEnabled', 'typeOfWork'], function () {
            _this.update();
        });
        return _this;
    }

    _createClass(BudgetsTab, [{
        key: 'update',
        value: function update() {
            if (this.budgets) this.budgets.remove();
            if (!this.state.relatedId) return;

            this.budgets = _ClassicBridge2.default.integrateBudgetsTab(this.find('.atNextMount')[0], {
                relatedType: this.relatedType,
                relatedId: this.state.relatedId,
                areCostBudgetsEnabled: this.state.areCostBudgetsEnabled,
                areBillingBudgetsEnabled: this.state.areBillingBudgetsEnabled,
                typeOfWork: this.state.typeOfWork ? _extends({}, this.state.typeOfWork, {
                    title: this.state.typeOfWork.name
                }) : undefined
            });
        }
    }, {
        key: 'templateHtml',
        value: function templateHtml() {
            return "<div class='tab'>" + "  <div class='atNextMount'></div>" + "</div>";
        }
    }]);

    return BudgetsTab;
}(_TemplateView3.default);

exports.default = BudgetsTab;

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ProjectPanelDialogs = exports.ProjectPanelTabs = exports.ProjectPanel = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _MoveToDialog = __webpack_require__(371);

var _MoveToDialog2 = _interopRequireDefault(_MoveToDialog);

var _ProjectPanelHeader = __webpack_require__(1397);

var _ProjectPanelHeader2 = _interopRequireDefault(_ProjectPanelHeader);

var _ProjectPanelContent = __webpack_require__(1398);

var _ProjectPanelContent2 = _interopRequireDefault(_ProjectPanelContent);

var _LoadingContainer = __webpack_require__(28);

var _LoadingContainer2 = _interopRequireDefault(_LoadingContainer);

var _AssignedUsersEditor = __webpack_require__(292);

var _AssignedUsersEditor2 = _interopRequireDefault(_AssignedUsersEditor);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _AssignedUsersEditorContainer = __webpack_require__(294);

var _AssignedUsersEditorContainer2 = _interopRequireDefault(_AssignedUsersEditorContainer);

var _applyAction = __webpack_require__(375);

var _DeleteProjectPopupConfirmationDialog = __webpack_require__(1405);

var _DeleteProjectPopupConfirmationDialog2 = _interopRequireDefault(_DeleteProjectPopupConfirmationDialog);

var _ArchiveProjectDialog = __webpack_require__(1406);

var _ArchiveProjectDialog2 = _interopRequireDefault(_ArchiveProjectDialog);

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _ScrollableContainer = __webpack_require__(49);

var _ScrollableContainer2 = _interopRequireDefault(_ScrollableContainer);

var _CommentsFooter = __webpack_require__(500);

var _CommentsFooter2 = _interopRequireDefault(_CommentsFooter);

var _selectors = __webpack_require__(19);

var _utils = __webpack_require__(6);

var _redux = __webpack_require__(7);

var _actions = __webpack_require__(141);

var _selectors2 = __webpack_require__(244);

var _TabsController = __webpack_require__(239);

var _TabsController2 = _interopRequireDefault(_TabsController);

var _selectors3 = __webpack_require__(27);

var _InformationBlock = __webpack_require__(295);

var _InformationBlock2 = _interopRequireDefault(_InformationBlock);

var _CopySettingsBlock = __webpack_require__(296);

var _CopySettingsBlock2 = _interopRequireDefault(_CopySettingsBlock);

var _utils2 = __webpack_require__(297);

var _selectors4 = __webpack_require__(15);

var _utils3 = __webpack_require__(25);

var _MoveToArchivedConfirmationDialog = __webpack_require__(501);

var _MoveToArchivedConfirmationDialog2 = _interopRequireDefault(_MoveToArchivedConfirmationDialog);

var _selectors5 = __webpack_require__(57);

var _BudgetsTab = __webpack_require__(502);

var _BudgetsTab2 = _interopRequireDefault(_BudgetsTab);

var _NextBridge = __webpack_require__(376);

var _NextBridge2 = _interopRequireDefault(_NextBridge);

var _CustomerPanel = __webpack_require__(382);

var _ClassicBridge = __webpack_require__(18);

var _ClassicBridge2 = _interopRequireDefault(_ClassicBridge);

var _UserEventsMap = __webpack_require__(99);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ProjectPanel = exports.ProjectPanel = function (_TemplateView) {
    _inherits(ProjectPanel, _TemplateView);

    function ProjectPanel(_ref) {
        var _ref$updateDescriptio = _ref.updateDescription,
            updateDescription = _ref$updateDescriptio === undefined ? function () {} : _ref$updateDescriptio,
            _ref$saveComment = _ref.saveComment,
            saveComment = _ref$saveComment === undefined ? function () {} : _ref$saveComment,
            _ref$saveEditingComme = _ref.saveEditingComment,
            saveEditingComment = _ref$saveEditingComme === undefined ? function () {} : _ref$saveEditingComme,
            _ref$toggleNewComment = _ref.toggleNewCommentInput,
            toggleNewCommentInput = _ref$toggleNewComment === undefined ? function () {} : _ref$toggleNewComment,
            _ref$updateNewComment = _ref.updateNewCommentText,
            updateNewCommentText = _ref$updateNewComment === undefined ? function () {} : _ref$updateNewComment,
            _ref$onPanelClose = _ref.onPanelClose,
            onPanelClose = _ref$onPanelClose === undefined ? function () {} : _ref$onPanelClose,
            _ref$setAllTasksAssig = _ref.setAllTasksAssigned,
            setAllTasksAssigned = _ref$setAllTasksAssig === undefined ? function () {} : _ref$setAllTasksAssig,
            _ref$copyProject = _ref.copyProject,
            copyProject = _ref$copyProject === undefined ? function () {} : _ref$copyProject;

        _classCallCheck(this, ProjectPanel);

        var _this = _possibleConstructorReturn(this, (ProjectPanel.__proto__ || Object.getPrototypeOf(ProjectPanel)).call(this));

        _this._onProjectMove = function (customer) {
            if (customer.archived && _this.state.active) {
                _this.moveToDialogScrollable.hide();
                _this.archivingConfirmationScrollable.show();
                _this.archivingConfirmationScrollable.setState({
                    customer: customer,
                    withRestoreOption: !!_this.state.manageableCustomersIds[customer.id],
                    completeOptionSelected: true,
                    workflowStatusId: _this.state.defaultCompletedStatus.id
                });
            } else {
                _this.trigger("move", { customer: customer, forceReopen: false, newWorkflowStatusId: null });
            }
        };

        _this._handleTabSwitched = function (selectedKey, previousKey) {
            _this.archivingConfirmationScrollable.hide();
            _this.tabsController.setState({ selectedTabKey: selectedKey });

            var prevButton = _this.buttons.get(previousKey);
            if (prevButton) prevButton.toggleClass('selected', false);
            var button = _this.buttons.get(selectedKey);
            if (button) button.toggleClass('selected', true);

            if (selectedKey !== ProjectPanelDialogs.MOVE_DIALOG && selectedKey !== ProjectPanelDialogs.COPY_DIALOG && selectedKey !== ProjectPanelDialogs.DELETE_DIALOG && selectedKey !== ProjectPanelDialogs.ARCHIVE_DIALOG) {
                _this.lastSelectedTabKey = selectedKey;
            }

            _this.commentsFooter.toggle(selectedKey === ProjectPanelTabs.DETAILS_TAB);
            if (selectedKey !== ProjectPanelTabs.DETAILS_TAB) {
                _this.actions.saveEditingComment();
            }

            if (selectedKey === ProjectPanelTabs.BUDGETS) {
                _ClassicBridge2.default.sendUserEvent(_UserEventsMap.UserEventsMap.BUDGET_TAB_OPEN, _UserEventsMap.BudgetTabOpenEventEntityParams.PROJECT);
            }

            _this.tabs.get(selectedKey).update();
        };

        _this.isBlockedDelete = false;

        _this.actions = {
            updateDescription: updateDescription,
            saveComment: saveComment,
            saveEditingComment: saveEditingComment,
            toggleNewCommentInput: toggleNewCommentInput,
            updateNewCommentText: updateNewCommentText,
            onPanelClose: onPanelClose,
            setAllTasksAssigned: setAllTasksAssigned,
            copyProject: copyProject
        };

        _this.state = {
            currentTabKey: ProjectPanelTabs.DETAILS_TAB,
            loggedInUser: null,

            id: null,
            name: "",
            description: "",

            active: false,
            readOnly: false,
            allTasksAssigned: false,
            isProjectAssigned: false,

            customerName: '',

            projectSpentTimeValues: null,
            workflowStatuses: [],
            defaultCompletedStatus: {},

            assignedUsersData: null,
            assignedUsersDataForManagers: {
                userGroupsEnabled: false,
                timeZoneGroupsEnabled: false,
                users: [],
                userGroups: [],
                timeZoneGroups: [],
                canModifyAny: false,
                assignButtonVisible: false
            },

            deleteData: {},
            viewerSettings: {
                hasEditHierarchyRight: false,
                hasAccessToAllManagementScope: false
            },
            customersManagementAssignments: [],
            sendingComment: false,
            toggleNewCommentInput: false,
            newCommentText: '',

            copyMoveSelectorCustomersIds: {},
            manageableCustomersIds: {},
            canReopenProject: false,
            canMoveProject: true,

            isURAEnabled: false,
            isBRAEnabled: false,
            isBTYEnabled: false,
            isESTEnabled: false,
            isTWSEnabled: false,
            isWASEnabled: false,
            isCPTBUDEnabled: false,

            canManageAccountsAndPermissions: false,
            hasSomeTeamAssignment: false,
            canEditTaskStatus: true,
            canGenerateMoneyReports: false,
            canEditHierarchy: false
        };

        _this.onStatePropertyChanged('currentTabKey', _this._handleTabSwitched);
        _this.onAnyStatePropertyChanged(['name', 'description', 'active', 'readOnly', 'projectSpentTimeValues', 'workflowStatuses', 'assignedUsersDataForManagers', 'assignedUsersData', 'deleteData', 'viewerSettings', 'hasEditHierarchyRight', 'hasAccessToAllManagementScope', 'customersManagementAssignments', 'canReopenProject', 'canMoveProject'], function () {
            _this.updateView();
        });

        _this.onStatePropertyChanged('loggedInUser', function (loggedInUser) {
            _this.commentsFooter.setState({ loggedInUser: loggedInUser });
        });

        _this.onStatePropertyChanged('id', function (id) {
            if (id !== null) {
                var selectedKey = _this.state.currentTabKey;
                if (selectedKey === ProjectPanelDialogs.MOVE_DIALOG || selectedKey === ProjectPanelDialogs.COPY_DIALOG || selectedKey === ProjectPanelDialogs.DELETE_DIALOG || selectedKey === ProjectPanelDialogs.ARCHIVE_DIALOG || selectedKey === ProjectPanelDialogs.BUDGETS) {
                    _this.openLastSelectedTab();
                }
            }
        });

        _this.onStatePropertyChanged('sendingComment', function (sendingComment) {
            _this.commentsFooter.setState({ sending: sendingComment });
        });

        _this.onStatePropertyChanged('canEditTaskStatus', function (canEditTaskStatus) {
            _this.archiveDialog.setState({ canEditTaskStatus: canEditTaskStatus });
        });

        _this.onStatePropertyChanged('showNewCommentInput', function (showNewCommentInput) {
            _this.commentsFooter.setState({ showNewCommentInput: showNewCommentInput });
        });

        _this.onStatePropertyChanged('newCommentText', function (newCommentText) {
            _this.commentsFooter.setState({ commentText: newCommentText });
        });

        _this.onAnyStatePropertyChanged(['allTasksAssigned', 'isProjectAssigned', 'canGenerateMoneyReports', 'canEditHierarchy', 'isWASEnabled', 'isURAEnabled', 'isBRAEnabled', 'isCPTBUDEnabled', 'id'], function (_ref2) {
            var allTasksAssigned = _ref2.allTasksAssigned,
                canGenerateMoneyReports = _ref2.canGenerateMoneyReports,
                canEditHierarchy = _ref2.canEditHierarchy,
                isProjectAssigned = _ref2.isProjectAssigned,
                isWASEnabled = _ref2.isWASEnabled,
                isURAEnabled = _ref2.isURAEnabled,
                isBRAEnabled = _ref2.isBRAEnabled,
                isCPTBUDEnabled = _ref2.isCPTBUDEnabled,
                id = _ref2.id;

            var selectedKey = _this.state.currentTabKey;
            _this.commentsFooter.toggle(selectedKey === ProjectPanelTabs.DETAILS_TAB && allTasksAssigned);

            _this.header.$tabs[ProjectPanelTabs.DETAILS_TAB].toggle(allTasksAssigned);
            _this.header.$tabs[ProjectPanelTabs.ASSIGNED_USERS_TAB].toggle(isWASEnabled && allTasksAssigned);
            _this.header.$tabs[ProjectPanelTabs.MANAGERS_TAB].toggle(allTasksAssigned);
            if (isCPTBUDEnabled && isProjectAssigned && (canGenerateMoneyReports || canEditHierarchy)) {
                _this.header.$tabs[ProjectPanelTabs.BUDGETS].toggle(true);
                _this.budgetsTab.setState({
                    relatedId: id,
                    areCostBudgetsEnabled: isURAEnabled && canGenerateMoneyReports,
                    areBillingBudgetsEnabled: isBRAEnabled && canGenerateMoneyReports
                });
            } else {
                _this.header.$tabs[ProjectPanelTabs.BUDGETS].toggle(false);
                if (_this.state.currentTabKey === _CustomerPanel.CustomerPanelTabs.BUDGETS) {
                    _this.openTabByKey(_CustomerPanel.CustomerPanelTabs.DETAILS_TAB);
                }
            }

            if (!allTasksAssigned || !_this.lastSelectedTabKey) {
                _this.openTabByKey(ProjectPanelTabs.DETAILS_TAB);
            } else {
                _this.openLastSelectedTab();
            }

            _this.buttons.get(ProjectPanelTabs.ASSIGNED_USERS_TAB).toggle(isWASEnabled && allTasksAssigned);
        });

        _this.onAnyStatePropertyChanged(['copyMoveSelectorCustomersIds'], function (_ref3) {
            var copyMoveSelectorCustomersIds = _ref3.copyMoveSelectorCustomersIds;

            _this.moveToDialog.setCustomersToMove(copyMoveSelectorCustomersIds);
            _this.copyToDialog.setCustomersToMove(copyMoveSelectorCustomersIds);
        });

        _this.onAnyStatePropertyChanged(['canManageAccountsAndPermissions', 'isBTYEnabled', 'isESTEnabled', 'isTWSEnabled', 'isWASEnabled', 'hasSomeTeamAssignment'], function () {
            _this.copySettingsBlock.setState((0, _utils2.getItemsForCopyProjectSettingsBlock)(_this.state.canManageAccountsAndPermissions, _this.state.isBTYEnabled, _this.state.isESTEnabled, _this.state.isTWSEnabled, _this.state.isWASEnabled, _this.state.hasSomeTeamAssignment));
        });

        _this.onAnyStatePropertyChanged(['isURAEnabled', 'isBTYEnabled', 'isTTAEnabled'], function (_ref4) {
            var isURAEnabled = _ref4.isURAEnabled,
                isBTYEnabled = _ref4.isBTYEnabled,
                isTTAEnabled = _ref4.isTTAEnabled;

            _this.tabs.get(ProjectPanelTabs.MANAGERS_TAB).setState({
                isURAEnabled: isURAEnabled,
                isBTYEnabled: isBTYEnabled,
                isTTAEnabled: isTTAEnabled
            });
        });

        _this.onStatePropertyChanged('readOnly', function (readOnly) {
            _this.assignedUsersEditorContainer.setState({
                hideAssignButton: readOnly
            });
        });

        _this.onStatePropertyChanged('isWASEnabled', function () {
            return _this._updateDialogsInfo();
        });

        _this.onStatePropertyChanged('isTWSEnabled', function (isTWSEnabled) {
            return _this.archivingConfirmation.setState({ isTWSEnabled: isTWSEnabled });
        });

        _this.updateOnInit = false;
        return _this;
    }

    _createClass(ProjectPanel, [{
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='taskManagement_projectPanel'>" + "  <div class='headerBlock'/>" + "    <div class='content_projectPanel'/>" + "    <div class='commentsFooterBlock'/>" + "</div>";
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            var _this2 = this;

            this.$header = this.find('.headerBlock');
            this.$content = this.find(".content_projectPanel");
            this.header = new _ProjectPanelHeader2.default(this.find(".headerBlock"), this.$el).init();
            this.detailsTab = new _ProjectPanelContent2.default({
                updateDescription: this.actions.updateDescription,
                refreshScrollCb: function refreshScrollCb() {
                    return _this2.detailsTabScrollable.forceUpdate();
                },
                scrollToElementCb: function scrollToElementCb($el, pos) {
                    return _this2.detailsTabScrollable.scrollToElementVertical($el, pos);
                }
            });
            this.detailsTabScrollable = new _ScrollableContainer2.default(null, this.detailsTab, {
                needRefreshOnResize: true,
                containerClass: 'projectPanelContentWrapper'
            });
            this.detailsTabScrollable.init(this.$content);

            var assignedUsersEditor = new _LoadingContainer2.default({
                contentComponent: new _AssignedUsersEditor2.default({
                    onUserDelete: function onUserDelete(userData) {
                        return _this2.trigger("assignedUserDelete", { userId: userData.id });
                    },
                    onAssignedUsersChange: function onAssignedUsersChange(_ref5) {
                        var addedUserIds = _ref5.addedUserIds,
                            removedUserIds = _ref5.removedUserIds;
                        return _this2.trigger("assignedUsersChange", { addedUserIds: addedUserIds, removedUserIds: removedUserIds });
                    },
                    titleMessageKey: "assigned_users_editor.project.title",
                    userSubtitleGenerator: function userSubtitleGenerator(user) {
                        if (user.hasAllAssignments) {
                            return _messageResource2.default.getMessage("assigned_users_editor.project.has_all_assignments");
                        } else if (user.hasCustomerAssignment) {
                            return _messageResource2.default.getMessage("assigned_users_editor.project.has_customer_assignment");
                        }
                    },
                    managersMessageKey: "assigned_users_editor.project.managers_count",
                    canEditManagers: false,
                    addUsersMessageKey: "assigned_users_editor.add_title",
                    emptyListMessageKey: "assigned_users_editor.project.empty_list",
                    showPermissionIcons: false,
                    usersSelectorTitle: _messageResource2.default.getMessage("assigned_users_editor.project.users_selector_title"),
                    renderUserSelectorToContent: true,
                    refreshScrollCb: function refreshScrollCb() {
                        return assignedUsersEditorScrollable.forceUpdate();
                    },
                    checkIfCanModify: function checkIfCanModify(user) {
                        return !user.hasManageAssignment;
                    },
                    getListDisabledTooltipText: function getListDisabledTooltipText(user) {
                        return _this2._getDisabledTooltipTextAssugnedUsersEditor(user);
                    },
                    getSelectorDisabledTooltipText: function getSelectorDisabledTooltipText(user) {
                        return _this2._getDisabledTooltipTextAssignedUsersSelector(user);
                    }
                }),
                containerClass: "assignedUsersTab panelTab"
            });

            var assignedUsersEditorScrollable = new _ScrollableContainer2.default(null, assignedUsersEditor, {
                needRefreshOnResize: true,
                containerClass: 'assignedUsersScrollableContainer'
            });

            this.assignedUsersEditorContainer = new _AssignedUsersEditorContainer2.default({
                assignedUsersEditor: assignedUsersEditorScrollable,
                $tabTitle: this.header.$assignedUsersTabTitle,
                tabTitleMessageKey: "task.edit_panel.tabs.assigned_users_with_count"
            }).init();

            this.budgetsTab = new _BudgetsTab2.default({
                relatedType: _BudgetsTab.RelatedType.Project
            });

            var managersEditor = new _LoadingContainer2.default({
                contentComponent: new _AssignedUsersEditor2.default({
                    onUserDelete: function onUserDelete(userData) {
                        return _this2.trigger("managerDelete", { userData: userData });
                    },
                    onAssignedUsersChange: function onAssignedUsersChange(_ref6) {
                        var addedUserIds = _ref6.addedUserIds,
                            removedUserIds = _ref6.removedUserIds;
                        return _this2.trigger("managersChange", { addedUserIds: addedUserIds, removedUserIds: removedUserIds });
                    },
                    titleMessageKey: "assigned_users_editor.managers.project.title",
                    userSubtitleGenerator: function userSubtitleGenerator(user) {
                        if (user.hasAllAssignments) {
                            return _messageResource2.default.getMessage("assigned_users_editor.managers.project.has_all_assignments");
                        } else if (user.hasCustomerAssignment) {
                            return _messageResource2.default.getMessage("assigned_users_editor.managers.project.has_customer_assignment");
                        } else if (user.hasAllFutureTasksOfProjectAssignment) {
                            return _messageResource2.default.getMessage("assigned_users_editor.managers.project.has_only_tasks_assignment");
                        }
                    },
                    addUsersMessageKey: "assigned_users_editor.managers.add_title",
                    showPermissionIcons: true,
                    usersSelectorTitle: _messageResource2.default.getMessage("assigned_users_editor.managers.project.users_selector_title"),
                    renderUserSelectorToContent: true,
                    refreshScrollCb: function refreshScrollCb() {
                        return managersEditorScrollable.forceUpdate();
                    },
                    checkIfCanModify: function checkIfCanModify(user) {
                        return !user.hasAllAssignments && !user.hasCustomerAssignment && !user.hasAllFutureProjectsOfCustomerAssignment;
                    },
                    getListDisabledTooltipText: function getListDisabledTooltipText(user) {
                        return _this2._getDisabledTooltipTextManagersEditor(user);
                    },
                    getSelectorDisabledTooltipText: function getSelectorDisabledTooltipText(user) {
                        return _this2._getDisabledTooltipTextManagersEditor(user);
                    }
                }),
                containerClass: "managersTab panelTab"
            });

            var managersEditorScrollable = new _ScrollableContainer2.default(null, managersEditor, {
                needRefreshOnResize: true,
                containerClass: 'assignedUsersScrollableContainer'
            });

            this.managersEditorContainer = new _AssignedUsersEditorContainer2.default({
                assignedUsersEditor: managersEditorScrollable,
                $tabTitle: this.header.$managersTabTitle,
                tabTitleMessageKey: "task.edit_panel.tabs.managers_with_count"
            }).init();

            this._initMoveToDialog();
            this._initCopyToDialog();

            this.archiveDialog = new _ArchiveProjectDialog2.default(null);
            this.archiveDialogScrollable = new _ScrollableContainer2.default(null, this.archiveDialog, { needRefreshOnResize: true }).init(this.$content);

            this.deleteDialog = new _DeleteProjectPopupConfirmationDialog2.default(null, function () {
                return (0, _jquery2.default)(_this2).trigger("cancelDelete");
            }, function (revokeStatuses) {
                return (0, _jquery2.default)(_this2).trigger("delete", revokeStatuses);
            });
            this.deleteDialogScrollable = new _ScrollableContainer2.default(null, this.deleteDialog, { needRefreshOnResize: true }).init(this.$content);

            this.tabs = new Map([[ProjectPanelTabs.DETAILS_TAB, this.detailsTabScrollable], [ProjectPanelTabs.ASSIGNED_USERS_TAB, assignedUsersEditorScrollable.init(this.$content)], [ProjectPanelTabs.MANAGERS_TAB, managersEditorScrollable.init(this.$content)], [ProjectPanelTabs.BUDGETS, this.budgetsTab.init(this.$content)], [ProjectPanelDialogs.MOVE_DIALOG, this.moveToDialogScrollable], [ProjectPanelDialogs.COPY_DIALOG, this.copyToDialogScrollable], [ProjectPanelDialogs.DELETE_DIALOG, this.deleteDialogScrollable], [ProjectPanelDialogs.ARCHIVE_DIALOG, this.archiveDialogScrollable]]);

            this.tabs.forEach(function ($tab, tabKey) {
                $tab.hide();
            });

            this.tabsController = new _TabsController2.default({
                tabs: this.tabs
            }).init();

            this.buttons = new Map([[ProjectPanelTabs.DETAILS_TAB, this.header.$tabs[ProjectPanelTabs.DETAILS_TAB]], [ProjectPanelTabs.ASSIGNED_USERS_TAB, this.header.$tabs[ProjectPanelTabs.ASSIGNED_USERS_TAB]], [ProjectPanelTabs.MANAGERS_TAB, this.header.$tabs[ProjectPanelTabs.MANAGERS_TAB]], [ProjectPanelTabs.BUDGETS, this.header.$tabs[ProjectPanelTabs.BUDGETS]], [ProjectPanelDialogs.DELETE_DIALOG, this.header.actions.menu.$delete], [ProjectPanelDialogs.MOVE_DIALOG, this.header.actions.menu.$move], [ProjectPanelDialogs.COPY_DIALOG, this.header.actions.menu.$copy]]);

            this.buttons.forEach(function ($button, key) {
                $button.click(function () {
                    if (key !== ProjectPanelDialogs.DELETE_DIALOG && key !== ProjectPanelDialogs.MOVE_DIALOG || key === ProjectPanelDialogs.DELETE_DIALOG && !_this2.isBlockedDelete || key === ProjectPanelDialogs.MOVE_DIALOG && _this2.state.canMoveProject) {
                        _this2.openTabByKey(key);
                    }
                });
            });

            this.commentsFooter = new _CommentsFooter2.default({
                onCommentTextChange: this.actions.updateNewCommentText,
                onShowInputChanged: this.actions.toggleNewCommentInput,
                onCommentAdded: this.actions.saveComment,
                refreshScrollCb: function refreshScrollCb() {
                    _this2.detailsTabScrollable.performIfScrollToBottom(function () {
                        _this2.detailsTabScrollable.forceUpdate();
                        _this2.detailsTabScrollable.scrollToBottom();
                    });
                    _this2.detailsTabScrollable.forceUpdate();
                }
            }).init(this.find('.commentsFooterBlock'));
        }
    }, {
        key: "_initCopyToDialog",
        value: function _initCopyToDialog() {
            var _this3 = this;

            this.copySettingsBlock = new _CopySettingsBlock2.default(_extends({
                additionalClass: 'copyProject'
            }, (0, _utils2.getItemsForCopyProjectSettingsBlock)(this.state.canManageAccountsAndPermissions, this.state.isBTYEnabled, this.state.isESTEnabled, this.state.isTWSEnabled, this.state.isWASEnabled)));

            this.copyToDialogInfoBlock = new _InformationBlock2.default();

            this.copyToDialog = new _MoveToDialog2.default({
                mode: _MoveToDialog2.default.Mode.CUSTOMER,
                titleMessageKey: "task.list.copy_to.project.title",
                buttonMessageKey: "edit_panel.action.copy",
                onMoveCb: function onMoveCb(customer, project, settings) {
                    _this3.actions.copyProject(customer.id, settings, function () {
                        return _this3.openLastSelectedTab();
                    });
                },
                onCancelCb: function onCancelCb() {
                    return _this3.openLastSelectedTab();
                },
                infoBlock: this.copyToDialogInfoBlock,
                settingsBlock: this.copySettingsBlock
            });
            this.copyToDialog.setShowArchived(false);
            this.copyToDialogScrollable = new _ScrollableContainer2.default(null, this.copyToDialog, { needRefreshOnResize: true }).init(this.$content);
        }
    }, {
        key: "_initMoveToDialog",
        value: function _initMoveToDialog() {
            var _this4 = this;

            this.moveToDialogInfoBlock = new _InformationBlock2.default({
                title: _messageResource2.default.getMessage('task.list.move_to.project.info_title')
            });

            this.moveToDialog = new _MoveToDialog2.default({
                mode: _MoveToDialog2.default.Mode.CUSTOMER,
                titleMessageKey: "task.list.move_to.project.title",
                buttonMessageKey: "edit_panel.action.move",
                infoBlock: this.moveToDialogInfoBlock,
                onMoveCb: this._onProjectMove,
                onCancelCb: function onCancelCb() {
                    return _this4.openLastSelectedTab();
                }
            });
            this.moveToDialog.setState({ showArchived: true });
            this.moveToDialogScrollable = new _ScrollableContainer2.default(null, this.moveToDialog, { needRefreshOnResize: true }).init(this.$content);

            this._initMoveToArchiveConfirmationDialog();
        }
    }, {
        key: "_initMoveToArchiveConfirmationDialog",
        value: function _initMoveToArchiveConfirmationDialog() {
            var _this5 = this;

            this.archivingConfirmation = new _MoveToArchivedConfirmationDialog2.default({
                confirmCallback: function confirmCallback(_ref7) {
                    var customer = _ref7.customer,
                        withRestore = _ref7.withRestore,
                        workflowStatusId = _ref7.workflowStatusId;

                    _this5.archivingConfirmationScrollable.hide();
                    _this5.trigger("move", { customer: customer, forceReopen: withRestore, newWorkflowStatusId: workflowStatusId });
                },
                cancelCallback: function cancelCallback() {
                    _this5.archivingConfirmationScrollable.hide();
                    var moveToDialogState = _this5.moveToDialog.getState();
                    _this5.moveToDialogScrollable.show();
                    _this5.moveToDialog.setState(moveToDialogState);
                }
            });
            this.archivingConfirmation.setState({
                workflowStatusId: this.state.defaultCompletedStatus.id,
                title: _messageResource2.default.getMessage("task.list.move_to.project.archive_confirmation.title"),
                multiOptionDescription: _messageResource2.default.getMessage("task.list.move_to.project.archive_confirmation.description"),
                archiveText: _messageResource2.default.getMessage("task.list.move_to.project.archive_confirmation.complete_with_status"),
                restoreText: _messageResource2.default.getMessage("task.list.move_to.project.archive_confirmation.restore")
            });

            this.archivingConfirmationScrollable = new _ScrollableContainer2.default(null, this.archivingConfirmation, { needRefreshOnResize: true }).init(this.$content);
            this.archivingConfirmationScrollable.hide();
        }
    }, {
        key: "_updateDialogsInfo",
        value: function _updateDialogsInfo() {
            this.moveToDialogInfoBlock.setState({
                paragraphs: [_messageResource2.default.getMessage(this.state.isWASEnabled ? 'task.list.move_to.project.info_paragraph1' : 'task.list.move_to.project.info_paragraph1_was_off'), _messageResource2.default.getMessage(this.state.isWASEnabled ? 'task.list.move_to.project.info_paragraph2' : 'task.list.move_to.project.info_paragraph2_was_off')]
            });

            this.copyToDialogInfoBlock.setState({
                paragraphs: [_messageResource2.default.getMessage(this.state.isWASEnabled ? 'task.list.copy_to.project.info_paragraph' : 'task.list.copy_to.project.info_paragraph_was_off')]
            });
        }
    }, {
        key: "_getDisabledTooltipTextManagersEditor",
        value: function _getDisabledTooltipTextManagersEditor(user) {
            var msg = _messageResource2.default.getMessage('assigned_users_editor.managers.disabled_tooltip', [_messageResource2.default.getMessage('common.project'), user.firstName]);

            if (user.hasAllAssignments) {
                msg += " " + _messageResource2.default.getMessage('assigned_users_editor.managers.disabled_tooltip.entire_scope');
            } else if (user.hasAllFutureProjectsOfCustomerAssignment) {
                msg += " " + _messageResource2.default.getMessage('assigned_users_editor.managers.disabled_tooltip.all_existing_and_future_items_assignment', [_messageResource2.default.getMessage('common.projects'), _messageResource2.default.getMessage('common.customer')]);
            } else if (user.hasCustomerAssignment) {
                msg += " " + _messageResource2.default.getMessage('assigned_users_editor.managers.disabled_tooltip.entire_item_assignment', [_messageResource2.default.getMessage('common.customer')]);
            }
            return msg;
        }
    }, {
        key: "_getDisabledTooltipTextAssugnedUsersEditor",
        value: function _getDisabledTooltipTextAssugnedUsersEditor(user) {
            return _messageResource2.default.getMessage('panel.common.cannot_unassign_user.tooltip', [_messageResource2.default.getMessage('common.projects'), user.firstName]);
        }
    }, {
        key: "_getDisabledTooltipTextAssignedUsersSelector",
        value: function _getDisabledTooltipTextAssignedUsersSelector(user) {
            return _messageResource2.default.getMessage('assigned_users_editor.work.disabled_tooltip.user_manages_item', [_messageResource2.default.getMessage('common.project')]);
        }
    }, {
        key: "openLastSelectedTab",
        value: function openLastSelectedTab() {
            this.openTabByKey(this.lastSelectedTabKey);
        }
    }, {
        key: "openTabByKey",
        value: function openTabByKey(key) {
            this.setState({ currentTabKey: key });
        }
    }, {
        key: "onDependantDataUpdate",
        value: function onDependantDataUpdate(event) {
            _underscore2.default.each(this.listeners, function (listener) {
                listener.onDependantDataUpdate(event);
            });
        }
    }, {
        key: "updateView",
        value: function updateView() {
            this.projectId = this.state.id;

            this.header.setState({
                projectName: this.state.name,
                customerName: this.state.customerName,
                readOnly: this.state.readOnly,
                blockedDueToLockedTime: this.state.deleteData.blockedDueToLockedTime,
                blockedDueToUnavailableToModifyTimeTrack: this.state.deleteData.blockedDueToUnavailableToModifyTimeTrack,
                canManageAllUsersWithoutAutoApproved: this.state.deleteData.canManageAllUsersWithoutAutoApproved
            });

            var deletedData = this.state.deleteData;

            this._setIsBlockedDelete(deletedData);

            if (!this.isBlockedDelete) {
                this._initDeleteDialog(this.state.name, deletedData);
            }

            this.detailsTabScrollable.setState({
                active: this.state.active,
                readOnly: this.state.readOnly,
                description: this.state.description,
                projectSpentTimeValues: this.state.projectSpentTimeValues,
                workflowStatuses: this.state.workflowStatuses,
                canReopenProject: this.state.canReopenProject
            });

            if (this.state.assignedUsersData) (0, _applyAction.applyDataToAssignedUsersEditor)(this.assignedUsersEditorContainer, this.state.assignedUsersData);

            (0, _applyAction.applyDataToAssignedUsersEditor)(this.managersEditorContainer, this.state.assignedUsersDataForManagers);
            this.managersEditorContainer.setState({
                hideAssignButton: !this.state.assignedUsersDataForManagers.canModifyAny
            });
        }
    }, {
        key: "setFakeLastAudit",
        value: function setFakeLastAudit() {
            this.detailsTab.updateLastAudit((0, _utils3.getFakeUpdateAuditAction)(this.state.loggedInUser));
        }
    }, {
        key: "_setIsBlockedDelete",
        value: function _setIsBlockedDelete(deletedData) {
            this.isBlockedDelete = deletedData.blockedDueToLockedTime || deletedData.blockedDueToUnavailableToModifyTimeTrack;
        }
    }, {
        key: "_initDeleteDialog",
        value: function _initDeleteDialog(name, data) {
            this.deleteDialog.setState({
                entityName: name,
                entitiesToDeleteCount: 1,
                entitiesBlocked: 0,
                entitiesBlockedCount: 0,
                entitiesBlockedDueToLockedTimeCount: 0,
                entitiesBlockedDueToUnavailableToModifyTimeTrackCount: 0,
                entitiesWithManagerTimeTrackCount: data.projectHasManagerTimeTrack ? 1 : 0,
                entitiesWithOtherUsersTimeTrackCount: data.projectHasOtherUsersTimeTrack ? 1 : 0,
                entitiesWithManagerApprovedTimeTrackCount: data.projectHasManagerApprovedTimeTrack ? 1 : 0,
                entitiesWithOtherUsersApprovedTimeTrackCount: data.projectHasOtherUsersApprovedTimeTrack ? 1 : 0,
                hasManagerApprover: data.hasManagerApprover
            });
        }
    }, {
        key: "onHide",
        value: function onHide() {
            this.header.actions.hideMenu();
            this.detailsTab.details.hideSelectors();
            this.actions.saveEditingComment();
            this.actions.onPanelClose();
            this.archivingConfirmationScrollable.hide();
            _NextBridge2.default.listeners.projectPanelClosed.forEach(function (handler) {
                return handler();
            });
        }
    }, {
        key: "onShow",
        value: function onShow() {
            this.detailsTab.details.setSelectorsDisabled(false);
            this.detailsTabScrollable.forceUpdate();
        }
    }, {
        key: "onScroll",
        value: function onScroll() {
            _get(ProjectPanel.prototype.__proto__ || Object.getPrototypeOf(ProjectPanel.prototype), "onScroll", this).call(this);
            this.detailsTab.details.hideAuditHistoryMenu();
        }
    }, {
        key: "getTabView",
        value: function getTabView(tabKey) {
            return this.tabs.get(tabKey);
        }
    }, {
        key: "getSelectedTabKey",
        value: function getSelectedTabKey() {
            return this.state.currentTabKey;
        }
    }]);

    return ProjectPanel;
}(_TemplateView3.default);

exports.default = (0, _utils.connect)(function (state) {
    return {
        loggedInUser: (0, _selectors.getLoggedInUser)(state),
        sendingComment: (0, _selectors2.isSendingComment)(state),
        showNewCommentInput: (0, _selectors2.isShowNewCommentInput)(state),
        newCommentText: (0, _selectors2.getProjectNewComment)(state),
        id: (0, _selectors2.getOpenProjectId)(state),
        viewerSettings: (0, _selectors3.getViewerSettings)(state),
        allTasksAssigned: (0, _selectors2.isAllTasksAssigned)(state),
        copyMoveSelectorCustomersIds: (0, _selectors3.getEditableCustomerIdsWithExcludeSelf)(state),
        manageableCustomersIds: (0, _selectors3.getEditableCustomerIds)(state),
        canReopenProject: (0, _selectors2.canReopenProject)(state),
        canMoveProject: (0, _selectors2.canMoveProject)(state),
        canManageAccountsAndPermissions: (0, _selectors.canManageAccountsAndPermissions)(state),
        isCPTBUDEnabled: (0, _selectors4.isCPTBUDEnabled)(state),
        isBTYEnabled: (0, _selectors4.isBTYEnabled)(state),
        isURAEnabled: (0, _selectors4.isURAEnabled)(state),
        isBRAEnabled: (0, _selectors4.isBRAEnabled)(state),
        isTWSEnabled: (0, _selectors4.isTWSEnabled)(state),
        isESTEnabled: (0, _selectors4.isESTEnabled)(state),
        isWASEnabled: (0, _selectors4.isWASEnabled)(state),
        isTTAEnabled: (0, _selectors4.isTTAEnabled)(state),
        defaultCompletedStatus: (0, _selectors5.getFirstCompletedWorkflowStatus)(state),
        hasSomeTeamAssignment: (0, _selectors.canAccessSomeTeamAssignment)(state),
        canEditTaskStatus: (0, _selectors3.canViewerEditTaskStatus)(state),
        canGenerateMoneyReports: (0, _selectors.canGenerateMoneyReports)(state),
        canEditHierarchy: (0, _selectors.canEditHierarchy)(state),
        isProjectAssigned: (0, _selectors2.getIsOpenProjectAssigned)(state)
    };
}, function (dispatch) {
    return {
        saveComment: (0, _redux.bindActionCreators)(_actions.commentsServiceActions.saveComment, dispatch),
        saveEditingComment: (0, _redux.bindActionCreators)(_actions.commentsServiceActions.saveEditingComment, dispatch),
        onPanelClose: (0, _redux.bindActionCreators)(_actions.closeProjectPanel, dispatch),
        toggleNewCommentInput: (0, _redux.bindActionCreators)(_actions.commentsServiceActions.toggleNewCommentInput, dispatch),
        updateNewCommentText: (0, _redux.bindActionCreators)(_actions.updateNewCommentText, dispatch),
        copyProject: (0, _redux.bindActionCreators)(_actions.copyProjectAction, dispatch)
    };
})(ProjectPanel);
var ProjectPanelTabs = exports.ProjectPanelTabs = {
    NONE: "none",
    DETAILS_TAB: 'details',
    ASSIGNED_USERS_TAB: 'assignedUsers',
    MANAGERS_TAB: 'managers',
    BUDGETS: 'budgets'
};

var ProjectPanelDialogs = exports.ProjectPanelDialogs = {
    NONE: 'none',
    COPY_DIALOG: 'copy',
    MOVE_DIALOG: 'move',
    DELETE_DIALOG: 'delete',
    ARCHIVE_DIALOG: 'archive'
};

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getSortedTypeOfWorkList = undefined;

var _reselect = __webpack_require__(13);

var _selectors = __webpack_require__(14);

var _utils = __webpack_require__(786);

var getSortedTypeOfWorkList = exports.getSortedTypeOfWorkList = (0, _reselect.createSelector)(_selectors.getTypesOfWork, function (typesOfWork) {
    return Object.values(typesOfWork).sort(_utils.typeOfWorkComparator);
});

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _CreateTasksLightbox = __webpack_require__(1408);

var _CreateTasksLightbox2 = _interopRequireDefault(_CreateTasksLightbox);

var _CorporateScheduleCalculator = __webpack_require__(378);

var _CorporateScheduleCalculator2 = _interopRequireDefault(_CorporateScheduleCalculator);

var _PopupLoadingUtils = __webpack_require__(510);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _utils = __webpack_require__(6);

var _redux = __webpack_require__(7);

var _utils2 = __webpack_require__(790);

var _actions = __webpack_require__(29);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CreateTasksPopupController = function () {
    function CreateTasksPopupController(_ref) {
        var successTaskCreationCb = _ref.successTaskCreationCb,
            serviceName = _ref.serviceName;

        _classCallCheck(this, CreateTasksPopupController);

        this.actions = (0, _utils.unsafe_bindActions)(function (dispatch) {
            return {
                setTypesOfWorkList: (0, _redux.bindActionCreators)(_actions.setTypesOfWorkList, dispatch)
            };
        });

        this.callbacks = {
            successTaskCreationCb: successTaskCreationCb
        };

        this.params = {
            serviceName: serviceName
        };
    }

    _createClass(CreateTasksPopupController, [{
        key: 'showPopup',
        value: function showPopup(selectedCustomerId, selectedProjectId, selectedUserId, openedFromOpenTasks, params) {
            var _this = this;

            var _ref2 = params || {},
                taskCreationDate = _ref2.taskCreationDate,
                isOpenedFromCalendarHeader = _ref2.isOpenedFromCalendarHeader,
                duration = _ref2.duration,
                submitTaskCreationCallback = _ref2.submitTaskCreationCallback;

            this._requestPopupData(selectedCustomerId, selectedProjectId, selectedUserId, openedFromOpenTasks, taskCreationDate, function (contentData) {
                new _CreateTasksLightbox2.default(_this.params.serviceName, contentData, {
                    successTaskCreationCallback: function successTaskCreationCallback(result) {
                        return _this.callbacks.successTaskCreationCb(_extends({}, result, { params: { taskCreationDate: taskCreationDate, isOpenedFromCalendarHeader: isOpenedFromCalendarHeader, duration: duration } }));
                    },
                    submitTaskCreationCallback: submitTaskCreationCallback
                }).init().show();
            }, function (jqXHR, textStatus, errorThrown) {
                if (textStatus === "rpc_customException") {
                    if (errorThrown.exception === "com.actimind.actitime.services.BaseNewTasksService$NoAssignedProjectsException") {
                        alert(_messageResource2.default.getMessage("add_new_tasks.no_projects_assigned.error"));
                        window.location.reload();
                        return true;
                    }
                }
                return false;
            });
        }
    }, {
        key: '_requestPopupData',
        value: function _requestPopupData(selectedCustomerId, selectedProjectId, selectedUserId, openedFromOpenTasks, dayOnWeek, onSuccessCb, onErrorCb) {
            var _this2 = this;

            (0, _PopupLoadingUtils.loadPopupContentByRpcCall)(this.params.serviceName + ".getCreateNewTasksData", [], function (data) {
                var newTasksPopupData = data['details'];
                var customers = data['customers'].list;
                var projects = data['projects'].list;

                var billingTypes = newTasksPopupData.billingTypes ? newTasksPopupData.billingTypes.list : null;
                var defaultBillingTypeId = newTasksPopupData.defaultBillingTypeId;
                if (newTasksPopupData.billingTypes) _this2.actions.setTypesOfWorkList(newTasksPopupData.billingTypes.list);

                var corporateSchedule = data['corporateSchedule'];
                var scheduleCalculator = new _CorporateScheduleCalculator2.default().init(window.invertedDaysDateMap, corporateSchedule);

                var weekStartDay = data['weekStartDay'] - 1;

                var userManagementAssignmentsData = data['userManageAssignmentsData'];
                var canEditHierarchy = newTasksPopupData.canEditHierarchy;
                var canAddTasksToUser = newTasksPopupData.canAddTaskToTT;

                var isEstEnabled = data['estEnabled'];
                var isTstEnabled = data['tstEnabled'];

                var userSettings = data['userSettings'];
                var selectedCustomerIdFromSettings = userSettings['lastCustomerId'];
                var selectedProjectIdFromSettings = userSettings['lastProjectId'];
                var customerId = selectedCustomerId === null && (0, _utils2.isCustomerIdValid)(customers, selectedCustomerIdFromSettings) ? selectedCustomerIdFromSettings : selectedCustomerId;
                var projectId = selectedProjectId === null && (0, _utils2.isProjectIdValid)(projects, selectedProjectIdFromSettings) ? selectedProjectIdFromSettings : selectedProjectId;

                var projectsWithTasksExist = newTasksPopupData.projectsWithTasksExist;

                var user = data['user'];

                onSuccessCb({
                    customers: customers,
                    projects: projects,
                    billingTypes: billingTypes,
                    defaultBillingTypeId: defaultBillingTypeId,
                    canEditHierarchy: canEditHierarchy,
                    canAddTasksToUser: canAddTasksToUser,
                    weekStartDay: weekStartDay,
                    scheduleCalculator: scheduleCalculator,
                    estEnabled: isEstEnabled,
                    tstEnabled: isTstEnabled,
                    projectsWithTasksExist: projectsWithTasksExist,
                    isOpenedFromOpenTasks: openedFromOpenTasks,
                    selectedCustomerId: customerId,
                    selectedProjectId: projectId,
                    selectedUserId: selectedUserId,
                    user: user,
                    dayOnWeek: dayOnWeek,
                    userManagementAssignmentsData: userManagementAssignmentsData
                });
            }, true, onErrorCb, true);
        }
    }]);

    return CreateTasksPopupController;
}();

exports.default = CreateTasksPopupController;

/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _AncestorEventsMixins = __webpack_require__(234);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _key_down_handler = __webpack_require__(184);

var _key_down_handler2 = _interopRequireDefault(_key_down_handler);

var _atBrowserUtils = __webpack_require__(8);

var _ScrollUtils = __webpack_require__(39);

var _ScrollUtils2 = _interopRequireDefault(_ScrollUtils);

var _Ext = __webpack_require__(12);

var _Ext2 = _interopRequireDefault(_Ext);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * Id of HTML DOM object representing moire DIV.
 */
var DEFAULT_MOIRE_DIV_ID = "moireDiv";

/*
 * Id of HTML DOM object keeping HTML of the whole page. It is needed to block all page elements by placing in it moire.
 */
DHTMLPopupWithMoire.prototype.documentContainerId = "container";

/*
 * DHTMLPopupWithMoire is intended for showing pop-ups with moire.
 */
function DHTMLPopupWithMoire(popupId) {
    var moireDivId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_MOIRE_DIV_ID;

    /*
     * Property to keep window resizing handler before popup showing.
     */
    this.previousWindowResizeHandler = window.onresize;
    /*
     * Property to keep moire DIV mouse down handler before popup showing.
     */
    this.previousMoireDivMouseDownHandler = null;
    /*
     * Id of HTML DOM object keeping popup HTML-code.
     */
    this.popupId = popupId;

    this.moireDivId = moireDivId;

    /*
     * If page is fully loaded
     */
    this.pageLoaded = false;

    var thisPopup = this;
    (0, _jquery2.default)(document).ready(function () {
        thisPopup.pageLoaded = true;
    });
}

DHTMLPopupWithMoire.prototype.getPopupEl = function () {
    return (0, _jquery2.default)("#" + this.popupId);
};

DHTMLPopupWithMoire.prototype.focusPopupOnShow = function () {
    this.focusPopup();
};
/*
 * Shows the pop-up. Pop-up showing is accompanied by moire showing which blocks all page elements except the
 * pop-up.
 */
DHTMLPopupWithMoire.prototype.show = function (animated) {
    showMoire(this.moireDivId, DHTMLPopupWithMoire.prototype.documentContainerId);
    // Use animated approach by default
    animated = _underscore2.default.isUndefined(animated) ? true : animated;

    var popupDiv = this.getPopupEl();
    if (animated) {
        popupDiv.atAnimation().fadeInWithScale(_underscore2.default.bind(this.onShowAnimationEnd, this));
    } else {
        popupDiv.show();
        this.onShowAnimationEnd();
    }

    this.centrePopup();
    this.focusPopupOnShow(); // focusing pop-up to get out focus from underlying content

    this.setupKeyDownHandler();

    this.previousWindowResizeHandler = window.onresize;
    this.setupWindowResizeHandler();

    this.previousMoireDivMouseDownHandler = this.getMoireDiv().onmousedown;
    this.setupMouseDownHandler();

    this.setupWheelEventListener();

    this.isShowed = true;

    this.initAncestorEventsEmitter(popupDiv);
};

/*
 * Hides popup. Special moire is hided too.
 */
DHTMLPopupWithMoire.prototype.hide = function (animated) {
    // Use animated approach by default
    animated = _underscore2.default.isUndefined(animated) ? true : animated;

    if (animated) {
        this.getPopupEl().atAnimation().fadeOutWithScale(_underscore2.default.bind(this.onHideAnimationEnd, this));
    } else {
        hideElement(this.getPopupEl()[0]);
        this.onHideAnimationEnd();
    }

    if (!this.previousMoireDivMouseDownHandler) hideMoire(this.moireDivId, animated);

    this.restoreOnKeyDownHandler();
    window.onresize = this.previousWindowResizeHandler;

    this.getMoireDiv().onmousedown = this.previousMoireDivMouseDownHandler;

    this.isShowed = false;

    this.triggerOnHideEvent();
};

DHTMLPopupWithMoire.prototype.triggerOnHideEvent = function () {
    this.triggerDOMEvent("popup.hide");
};

DHTMLPopupWithMoire.prototype.restoreOnKeyDownHandler = function () {
    _key_down_handler2.default.restoreOnKeyDownHandler();
};

/*
 * Centres the pop-up on the screen.
 */
DHTMLPopupWithMoire.prototype.centrePopup = function () {
    var popup = this.getPopupEl()[0];

    var screenDimensions = (0, _atBrowserUtils.getClientSize)();
    var scrollXFactor = screenDimensions[0] - (0, _atBrowserUtils.getInsideWindowWidth)();
    var scrollYFactor = screenDimensions[1] - (0, _atBrowserUtils.getInsideWindowHeight)();

    (0, _atBrowserUtils.shiftTo)(popup, Math.max(2, scrollXFactor + (screenDimensions[0] - scrollXFactor) / 2 - popup.offsetWidth / 2), Math.max(2, scrollYFactor + (screenDimensions[1] - scrollYFactor) / 2 - parseInt(popup.offsetHeight, 10) / 2));
};

/*
 * Focuses pop-up to get out focus from underlying content.
 */
DHTMLPopupWithMoire.prototype.focusPopup = function () {
    this.getPopupEl().find('div,span,td').first().focus();
};

DHTMLPopupWithMoire.prototype.getMoireDiv = function () {
    return document.getElementById(this.moireDivId);
};

DHTMLPopupWithMoire.prototype.setupKeyDownHandler = function () {
    var thisPopup = this; // dereferencing of THIS object to use it asynchronously in various handlers
    _key_down_handler2.default.setOnKeyDownHandler(function (evt) {
        (0, _atBrowserUtils.handleEscape)(function () {
            thisPopup.onEscape();
        }, evt);
    });
};

DHTMLPopupWithMoire.prototype.setupWindowResizeHandler = function () {
    var thisPopup = this; // dereferencing of THIS object to use it asynchronously in various handlers

    window.onresize = function () {
        if (thisPopup.hideOnResize() && thisPopup.pageLoaded) // do not hide popup on resize if page was not fully loaded
            {
                thisPopup.hide();
            } else {
            thisPopup.centrePopup();
        }
    };
};

DHTMLPopupWithMoire.prototype.hideOnResize = function () {
    return true;
};

DHTMLPopupWithMoire.prototype.hideOnEscape = function () {
    return true;
};

DHTMLPopupWithMoire.prototype.onEscape = function () {
    if (this.hideOnEscape()) {
        this.hide();
    }
};

DHTMLPopupWithMoire.prototype.onHideAnimationEnd = function () {};
DHTMLPopupWithMoire.prototype.onShowAnimationEnd = function () {};

DHTMLPopupWithMoire.prototype.setupMouseDownHandler = function () {
    var thisPopup = this; // dereferencing of THIS object to use it asynchronously in various handlers

    this.getMoireDiv().onmousedown = function () {
        if (thisPopup.hideOnMouseDown()) thisPopup.hide();
    };
};

DHTMLPopupWithMoire.prototype.hideOnMouseDown = function () {
    return true;
};

/**
 * This method add event listener that prevent scroll window if there is scroll in popup
 */
DHTMLPopupWithMoire.prototype.setupWheelEventListener = function () {

    var self = this;

    var wheelListener = function wheelListener(e) {

        if (!self.isShowed) {
            return;
        } // prevent event if popup is closed
        _underscore2.default.bind(_ScrollUtils2.default.getWheelEventListenerForPreventScrollParents(), this)(e);
    };

    // set correct event name depends on browser
    var wheelEventName = _ScrollUtils2.default.getWheelEventName();

    _Ext2.default.ComponentMgr.register = function (c) {
        this.all.add(c);
        c.on("render", function (ctr, pos) {
            (0, _jquery2.default)(ctr.el.dom).on(wheelEventName, wheelListener); // add event to new ext.js components that was rendered
        });
    };

    this.getPopupEl().on(wheelEventName, wheelListener); // add listener to all popup content
};

_underscore2.default.extend(DHTMLPopupWithMoire.prototype, _AncestorEventsMixins.AncestorEventsEmitterMixin);

exports.default = DHTMLPopupWithMoire;

/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var GC = window.__GENERATED_CONSTANTS__;

var CREATE_TASKS_CONSTANTS = exports.CREATE_TASKS_CONSTANTS = {
    SELECT_CUSTOMER_OPTION_INDEX: GC.CREATE_TASKS_CONSTANTS.SELECT_CUSTOMER_OPTION_INDEX,
    NEW_CUSTOMER_OPTION_INDEX: GC.CREATE_TASKS_CONSTANTS.NEW_CUSTOMER_OPTION_INDEX,
    ALL_ACTIVE_CUSTOMERS_OPTION_INDEX: GC.CREATE_TASKS_CONSTANTS.ALL_ACTIVE_CUSTOMERS_OPTION_INDEX,

    SELECT_PROJECT_OPTION_INDEX: GC.CREATE_TASKS_CONSTANTS.SELECT_PROJECT_OPTION_INDEX,
    NEW_PROJECT_OPTION_INDEX: GC.CREATE_TASKS_CONSTANTS.NEW_PROJECT_OPTION_INDEX,
    ALL_ACTIVE_PROJECTS_OPTION_INDEX: GC.CREATE_TASKS_CONSTANTS.ALL_ACTIVE_PROJECTS_OPTION_INDEX,
    SELECTED_PROJECTS_OPTION_INDEX: GC.CREATE_TASKS_CONSTANTS.SELECTED_PROJECTS_OPTION_INDEX,

    CUSTOMER_IS_NOT_EXIST_ERROR: GC.CREATE_TASKS_CONSTANTS.CUSTOMER_IS_NOT_EXIST_ERROR,
    CUSTOMER_IS_NOT_ASSIGNED_ERROR: GC.CREATE_TASKS_CONSTANTS.CUSTOMER_IS_NOT_ASSIGNED_ERROR,
    CUSTOMER_EXISTS_ERROR: GC.CREATE_TASKS_CONSTANTS.CUSTOMER_EXISTS_ERROR,
    CUSTOMER_IS_ARCHIVED_ERROR: GC.CREATE_TASKS_CONSTANTS.CUSTOMER_IS_ARCHIVED_ERROR,
    NO_ACTIVE_CUSTOMERS_ERROR: GC.CREATE_TASKS_CONSTANTS.NO_ACTIVE_CUSTOMERS_ERROR,

    PROJECT_IS_NOT_EXIST_ERROR: GC.CREATE_TASKS_CONSTANTS.PROJECT_IS_NOT_EXIST_ERROR,
    PROJECT_IS_NOT_ASSIGNED_ERROR: GC.CREATE_TASKS_CONSTANTS.PROJECT_IS_NOT_ASSIGNED_ERROR,
    PROJECT_EXISTS_ERROR: GC.CREATE_TASKS_CONSTANTS.PROJECT_EXISTS_ERROR,
    PROJECT_IS_ARCHIVED_ERROR: GC.CREATE_TASKS_CONSTANTS.PROJECT_IS_ARCHIVED_ERROR,
    NO_ACTIVE_PROJECTS_ERROR: GC.CREATE_TASKS_CONSTANTS.NO_ACTIVE_PROJECTS_ERROR
};

var CreateTasksCustomerProjectSelectorErrors = exports.CreateTasksCustomerProjectSelectorErrors = {
    CUSTOMER_EMPTY: "customerEmpty",
    PROJECT_EMPTY: "projectEmpty",
    NO_CUSTOMERS: "noActiveCustomer",
    NO_PROJECTS: "noActiveProject",
    PROJECTS_NOT_SELECTED: "projectsNotSelected",
    CUSTOMER_NOT_SELECTED: "customerNotSelected",
    PROJECT_NOT_SELECTED: "projectNotSelected",
    PROJECT_EXISTS: "projectExists",
    CUSTOMER_EXISTS: "customerExists"
};

var CreateTasksCustomerProjectSelectorWarnings = exports.CreateTasksCustomerProjectSelectorWarnings = {
    NO_CUSTOMERS: "noActiveCustomerWarning",
    NO_PROJECTS: "noActiveProjectWarning"
};

/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var CustomSelectorSize = exports.CustomSelectorSize = {
    DEFAULT: 'default',
    LITTLE: 'little'
};

var CustomSelectorType = exports.CustomSelectorType = {
    CHECKBOX: 'checkbox',
    RADIO: 'radio'
};

/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _SimpleTooltip = __webpack_require__(36);

var _SimpleTooltip2 = _interopRequireDefault(_SimpleTooltip);

var _constants = __webpack_require__(44);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// TODO: we should make composition of this and import tasks selector

var TaskTableTemplate = function (_TemplateView) {
    _inherits(TaskTableTemplate, _TemplateView);

    function TaskTableTemplate($containerEl, _ref) {
        var billingTypes = _ref.billingTypes,
            _ref$showBillingTypeC = _ref.showBillingTypeColumn,
            showBillingTypeColumn = _ref$showBillingTypeC === undefined ? true : _ref$showBillingTypeC,
            defaultBillingTypeId = _ref.defaultBillingTypeId,
            canAddTasksToUser = _ref.canAddTasksToUser,
            weekStartDay = _ref.weekStartDay,
            scheduleCalculator = _ref.scheduleCalculator,
            estEnabled = _ref.estEnabled,
            tstEnabled = _ref.tstEnabled,
            defaultRowsNumber = _ref.defaultRowsNumber,
            isOpenedFromOpenTasks = _ref.isOpenedFromOpenTasks,
            changesCallback = _ref.changesCallback,
            validateCallback = _ref.validateCallback,
            scrollableContainer = _ref.scrollableContainer,
            getScrollPositionCallback = _ref.getScrollPositionCallback,
            _ref$refreshScrollCb = _ref.refreshScrollCb,
            refreshScrollCb = _ref$refreshScrollCb === undefined ? function () {} : _ref$refreshScrollCb;

        _classCallCheck(this, TaskTableTemplate);

        var _this = _possibleConstructorReturn(this, (TaskTableTemplate.__proto__ || Object.getPrototypeOf(TaskTableTemplate)).call(this, $containerEl));

        _this.params = {
            billingTypes: billingTypes,
            showBillingTypeColumn: showBillingTypeColumn,
            defaultBillingTypeId: defaultBillingTypeId,
            canAddTasksToUser: canAddTasksToUser,
            weekStartDay: weekStartDay,
            scheduleCalculator: scheduleCalculator,
            estEnabled: estEnabled,
            tstEnabled: tstEnabled,
            defaultRowsNumber: defaultRowsNumber,
            isOpenedFromOpenTasks: isOpenedFromOpenTasks,
            changesCallback: changesCallback,
            validateCallback: validateCallback,
            getScrollPositionCallback: getScrollPositionCallback,
            scrollableContainer: scrollableContainer,
            refreshScrollCb: refreshScrollCb
        };
        return _this;
    }

    _createClass(TaskTableTemplate, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return "<div class='taskTable'>" + "  <div class='taskTableContainer'>" + "    <table>" + "      <colgroup class='createTasksTableColgroup'>" + "          <col class='nameCell'>" + "          <col class='descriptionCell'>" + "          <col class='estimateCell'>" + "          <col class='deadlineCell'>" + "          <col class='billingTypeCell'>" + "          <col class='addToTTCell'>" + "          <col class='clearLineCell'>" + "      </colgroup>" + "      <thead class='createTasksTableHead'>" + "        <tr>" + "          <th class='taskNameCell' colspan='2'>" + "              <%-taskName%>" + "          </th>" + "          <th class='estimateCell'>" + "              <%=estimate%>" + "              <div class='infoIcon'/>" + "          </th>" + "          <th class='deadlineCell'>" + "            <%=deadline%>" + "          </th>" + "          <th class='billingTypeCell'>" + "             <%=typeOfWork%>" + "          </th>" + "          <th class='addToTTCell addToTTCellHeader'>" + "              <div class='tableHeaderCheckboxContainer'></div>" + "              <div class='infoIcon'/>" + "          </th>" + "          <th class='clearLineCell'>&nbsp;</th>" + "      </tr>" + "      </thead>" + "    </table>" + "  </div>" + "  <div class='addRowsContainer'>" + "    <div class='addRowsButton addRowButton'><%=addNewRow%></div>" + "    <div class='addRowsButton addFiveRows'>5 <%=rows%></div>" + "    <div class='addRowsButton addTenRows'>10 <%=rows%></div>" + "  </div>" + "</div>";
        }
    }, {
        key: 'messageKeys',
        value: function messageKeys() {
            return {
                "taskName": "add_new_tasks.task_name",
                "estimate": "add_new_tasks.columns.estimate",
                "deadline": "add_new_tasks.columns.deadline",
                "typeOfWork": "add_new_tasks.columns.billing_type",
                "addNewRow": "add_new_tasks.add_new_row",
                "rows": "add_new_tasks.rows"
            };
        }
    }, {
        key: 'update',
        value: function update() {}
    }, {
        key: 'afterRender',
        value: function afterRender() {
            var _this2 = this;

            this.$taskTable = this.$el.find(".taskTableContainer");
            this.spinner = new Spinner({ length: 3, width: 2, radius: 3, lines: 8, color: '#aaaaaa', trail: 60 });
            this.importSpinnerPlaceholder = this.$containerEl.find(".importSpinnerPlaceholder");
            this.oldGetOnPageDescription = window.getOnPageDescription;

            this.createCreateTasksTable();
            this.createTooltips();

            this.$addRowButton = this.$el.find(".addRowButton");
            this.$addRowButton.click(function () {
                _this2.createTasksTable.addEmptyRows(1);
            });

            if (this.params.isOpenedFromOpenTasks) {
                this.$addFiveRowsButton = this.$el.find(".addFiveRows");
                this.$addTenRowsButton = this.$el.find(".addTenRows");
                this.$addFiveRowsButton.click(function () {
                    _this2.createTasksTable.addEmptyRows(5);
                });
                this.$addTenRowsButton.click(function () {
                    _this2.createTasksTable.addEmptyRows(10);
                });
            } else {
                this.$el.find(".addRowsContainer").addClass("addOneRowOnly");
            }
        }
    }, {
        key: 'validate',
        value: function validate() {
            return this.createTasksTable.validate();
        }
    }, {
        key: 'isEmpty',
        value: function isEmpty() {
            return this.createTasksTable.isEmpty();
        }
    }, {
        key: 'hasErrors',
        value: function hasErrors() {
            return this.createTasksTable.hasErrors();
        }
    }, {
        key: 'createCreateTasksTable',
        value: function createCreateTasksTable() {
            this.createTasksTable = new CreateNewTasksTable().init(this.$taskTable.find(".createTasksTableHead")[0], this.$taskTable.find(".createTasksTableColgroup")[0], this.params.defaultRowsNumber, null, this.params.billingTypes, this.params.defaultBillingTypeId, this.params.showBillingTypeColumn, this.params.weekStartDay, this.params.scheduleCalculator, this.params.canAddTasksToUser && this.params.isOpenedFromOpenTasks && this.params.tstEnabled, this.params.canAddTasksToUser, this.params.estEnabled, this.params.validateCallback, this.params.changesCallback, this._self(this.showDescriptionPopup), this._self(this.hideDescriptionPopup), this.params.scrollableContainer);

            this.$taskTable[0].innerHTML = "";
            this.createTasksTable.buildDOM(this.$taskTable[0]);
        }
    }, {
        key: 'createTableTooltip',
        value: function createTableTooltip($tooltip, text, $position, extraClass) {
            $tooltip.remove();
            var tooltip = new _SimpleTooltip2.default({
                text: text,
                extraClass: extraClass
            }).init((0, _jquery2.default)('body'));
            tooltip.subscribeToMouseEvents($position);
        }
    }, {
        key: 'createTooltips',
        value: function createTooltips() {
            this.createTableTooltip((0, _jquery2.default)(".estimateTooltip.taskListPage"), _messageResource2.default.getMessage("add_new_tasks.estimate_tooltip_info"), this.find(".estimateCell .infoIcon"), "estimateTooltip taskListPage");

            if (this.params.canAddTasksToUser && this.params.isOpenedFromOpenTasks) {
                this.createTableTooltip((0, _jquery2.default)(".addToTimeTrackTooltip.taskListPage"), _messageResource2.default.getMessage("add_new_tasks.add_task_to_enter_tt_note.me"), this.find(".addToTTCell .infoIcon"), "addToTimeTrackTooltip taskListPage");
            }
        }
    }, {
        key: 'getTasks',
        value: function getTasks() {
            return this.createTasksTable.getTasks();
        }
    }, {
        key: 'getCreateTasksTable',
        value: function getCreateTasksTable() {
            return this.createTasksTable;
        }
    }, {
        key: '_self',
        value: function _self(func) {
            var self = this;

            return function () {
                return func.apply(self, arguments);
            };
        }
    }, {
        key: 'showDescriptionPopup',
        value: function showDescriptionPopup(description, descriptionCellId, descriptionTd, descriptionChangedCallback) {
            if (editDescriptionState) {
                if (editDescriptionState.objectId == descriptionCellId || !saveOnPageDescription()) return;
            }

            var offsetX = -100;
            var offsetY = 25 + this.params.getScrollPositionCallback();

            var self = this;
            (0, _jquery2.default)(this.params.scrollableContainer).on('scroll', function (e) {
                self.hideDescriptionPopup(false);
            });

            showSavingDescriptionWithOffset(descriptionCellId, descriptionTd.firstChild, new CreateTaskDescriptionUtil(description, descriptionChangedCallback), descriptionTd, true, offsetX, offsetY);
        }
    }, {
        key: 'hideDescriptionPopup',
        value: function hideDescriptionPopup(isConfirmNeeded) {
            if (isConfirmNeeded) {
                return editDescriptionPopup.hide();
            } else {
                saveOnPageDescription(true);
                return true;
            }
        }
    }, {
        key: 'restoreGetOnPageDescriptionFunction',
        value: function restoreGetOnPageDescriptionFunction() {
            window.getOnPageDescription = this.oldGetOnPageDescription;
        }
    }, {
        key: 'startImportSpin',
        value: function startImportSpin() {
            this.spinner.spin(this.importSpinnerPlaceholder[0]);
        }
    }, {
        key: 'stopImportSpin',
        value: function stopImportSpin() {
            this.spinner.stop();
        }
    }, {
        key: 'importTasksRequest',
        value: function importTasksRequest(taskIds, needToLoadDescriptions, customerId, projectId, isInActiveProjects) {
            var self = this;
            var requestedTaskCount = taskIds ? taskIds.length : -1;

            var errorHandler = function errorHandler(jqXHR, textStatus, errorThrown) {
                self.stopImportSpin();
                return false;
            };

            var successHandler = function successHandler(tasks) {
                self.createTasksTable.addTasks(tasks.list);
                self.stopImportSpin();
                var retrievedTaskCount = tasks.list.length;
                if (retrievedTaskCount == 0 && requestedTaskCount == -1 || retrievedTaskCount < requestedTaskCount) {
                    // TODO: change texts!
                    if (retrievedTaskCount == 0) {
                        if (!customerId) alert(_messageResource2.default.getMessage('add_new_tasks.import.err.all_tasks_deleted_unavailable'));else if (isInActiveProjects) alert(_messageResource2.default.getMessage('add_new_tasks.import.err.all_tasks_deleted_unavailable_archived'));else alert(_messageResource2.default.getMessage('add_new_tasks.import.err.all_tasks_deleted_unavailable_restored'));
                    } else alert(_messageResource2.default.getMessage('add_new_tasks.import.err.some_tasks_deleted_unavailable'));
                }
                self.params.refreshScrollCb();
            };

            if (requestedTaskCount == -1 || requestedTaskCount > 0) {
                self.startImportSpin();
                makeRpcCall("ImportTasksService.importTasks", [taskIds, needToLoadDescriptions, customerId || 0, projectId || 0, isInActiveProjects], successHandler, errorHandler);
            }
        }
    }, {
        key: 'handleTaskError',
        value: function handleTaskError(taskError, taskErrorRowNumber) {
            var self = this;
            switch (taskError) {
                case _constants.TableTasksConstants.OPEN_TASK_EXISTS_ERROR:
                    alert(_messageResource2.default.getMessage('add_new_tasks.err_duplicate_detected.open_task'));
                    self.getCreateTasksTable().showTaskNameExistsError(taskErrorRowNumber, false);
                    break;

                case _constants.TableTasksConstants.COMPLETED_TASK_EXISTS_ERROR:
                    alert(_messageResource2.default.getMessage('add_new_tasks.err_duplicate_detected.completed_task'));
                    self.getCreateTasksTable().showTaskNameExistsError(taskErrorRowNumber, true);
                    break;

                case _constants.TableTasksConstants.UNKNOWN_TASK_EXISTS_ERROR:
                    alert(_messageResource2.default.getMessage("add_new_tasks.js.unexpected_error"));
                    break;
            }
        }
    }, {
        key: 'handleBillingTypeError',
        value: function handleBillingTypeError(billingTypeError, billingTypes) {
            var self = this;
            switch (billingTypeError) {
                case _constants.TableTasksConstants.BILLING_TYPE_DELETED_OR_ARCHIVED_ERROR:
                    alert(_messageResource2.default.getMessage("add_new_tasks.billing_types_deleted_or_archived"));
                    self.getCreateTasksTable().updateBillingTypes(billingTypes);
                    break;
            }
        }
    }]);

    return TaskTableTemplate;
}(_TemplateView3.default);

exports.default = TaskTableTemplate;

/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.loadPopupContentByRpcCall = loadPopupContentByRpcCall;

var _jquery_rpc = __webpack_require__(26);

var _jquery_rpc2 = _interopRequireDefault(_jquery_rpc);

var _LoadingPopup = __webpack_require__(299);

var _LoadingPopup2 = _interopRequireDefault(_LoadingPopup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var loadingPopup = null;

var createPopupLoadingMoire = function createPopupLoadingMoire() {
    if (!loadingPopup) loadingPopup = new _LoadingPopup2.default().init("contentLoadingPopup");
};

var showPopupLoadingMoire = function showPopupLoadingMoire() {
    if (loadingPopup) loadingPopup.show();
};

var hidePopupLoadingMoire = function hidePopupLoadingMoire() {
    if (loadingPopup) loadingPopup.hide();
};

function errorHandler(jqXHR, textStatus, errorThrown, showLoadingPopup, customErrorHandler) {
    if (showLoadingPopup) hidePopupLoadingMoire();

    if (customErrorHandler) return customErrorHandler(jqXHR, textStatus, errorThrown);

    return false;
}

function successHandler(showLoadingPopup, data, customSuccessHandler) {

    var completeFunction = function completeFunction() {
        if (showLoadingPopup) hidePopupLoadingMoire();

        if (customSuccessHandler) customSuccessHandler(data);
    };

    completeFunction();
}

function loadPopupContentByRpcCall(rpcMethod, rpcParams, customSuccessHandler, showLoadingPopup, customErrorHandler) {
    hidePopupLoadingMoire();

    if (showLoadingPopup) {
        createPopupLoadingMoire();
        loadingPopup.setOnEscapeCallback(function () {
            if (loadPopupRequestObject) loadPopupRequestObject.abort();
        });
        loadingPopup.show();
    }

    var loadPopupRequestObject = (0, _jquery_rpc2.default)(rpcMethod, rpcParams, function (data) {
        return successHandler(showLoadingPopup, data, customSuccessHandler);
    }, function (jqXHR, textStatus, errorThrown) {
        return errorHandler(jqXHR, textStatus, errorThrown, showLoadingPopup, customErrorHandler);
    });
}

/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
                                                                                                                                                                                                                                                                   * Created by filatov on 12.08.2015.
                                                                                                                                                                                                                                                                   */


exports.default = ReportUserSelectorButton;

var _Ext = __webpack_require__(12);

var _Ext2 = _interopRequireDefault(_Ext);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _at_selector_panel_with_apply_button_object = __webpack_require__(231);

var _at_selector_panel_with_apply_button_object2 = _interopRequireDefault(_at_selector_panel_with_apply_button_object);

var _at_shared_user_button_menu = __webpack_require__(159);

var _at_shared_user_button_menu2 = _interopRequireDefault(_at_shared_user_button_menu);

var _at_hierarchy_selector_dropdown_button = __webpack_require__(232);

var _at_hierarchy_selector_dropdown_button2 = _interopRequireDefault(_at_hierarchy_selector_dropdown_button);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _User = __webpack_require__(119);

var _User2 = _interopRequireDefault(_User);

var _Group = __webpack_require__(158);

var _Group2 = _interopRequireDefault(_Group);

var _two_level_selection = __webpack_require__(70);

var _two_level_selection2 = _interopRequireDefault(_two_level_selection);

var _at_reports_selector_users_panel = __webpack_require__(302);

var _at_reports_selector_users_panel2 = _interopRequireDefault(_at_reports_selector_users_panel);

var _at_selector_panel_generic_additional_checkbox_extension = __webpack_require__(1452);

var _at_selector_panel_generic_additional_checkbox_extension2 = _interopRequireDefault(_at_selector_panel_generic_additional_checkbox_extension);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ReportUserSelectorButton() {}

ReportUserSelectorButton.prototype.init = function (config) {
    var self = this;
    this.containerId = config.selectorId;

    this.predefinedUserSelection = {};
    var reportConfigUserSelection = config.userSelection;

    this.settedWithPredefinedValues = !!reportConfigUserSelection;
    this.predefinedUserSelection.selectedUsers = reportConfigUserSelection && reportConfigUserSelection.selectedUsers ? reportConfigUserSelection.selectedUsers : [];
    this.predefinedUserSelection.selectedGroups = reportConfigUserSelection && reportConfigUserSelection.selectedGroups ? reportConfigUserSelection.selectedGroups : [];
    this.predefinedUserSelection.allUsers = reportConfigUserSelection ? !!reportConfigUserSelection.allUsers : true;
    this.predefinedUserSelection.showDisabled = reportConfigUserSelection ? !!reportConfigUserSelection.showDisabled : true;
    this.predefinedUserSelection.includeUsersWithoutData = reportConfigUserSelection ? !!reportConfigUserSelection.includeUsersWithoutData : false;
    this.predefinedUserSelection.groupType = reportConfigUserSelection ? reportConfigUserSelection.groupType : null;
    this.predefinedUserSelection.includeUserTeamOnly = reportConfigUserSelection ? reportConfigUserSelection.includeUserTeamOnly : false;

    var params = config.report_name ? { collapsedCookiesKey: config.report_name } : {};
    var panelConstructor = !config.specificConstructorPanel ? _at_reports_selector_users_panel2.default : config.specificConstructorPanel;
    if (config.withApplyButton) _Ext2.default.apply(params, _at_selector_panel_with_apply_button_object2.default.getApplyButtonExtension(panelConstructor));

    this.needAdditionalCheckbox = config.needAdditionalCheckbox;
    this.includeUsersWithoutDataDefaultValue = _underscore2.default.isUndefined(config.includeUsersWithoutDataDefaultValue) ? false : config.includeUsersWithoutDataDefaultValue;

    var selectorPanelHeight = 450;
    if (this.needAdditionalCheckbox) {
        _Ext2.default.apply(params, new _at_selector_panel_generic_additional_checkbox_extension2.default(panelConstructor, config.additionalCheckboxLabel));
        selectorPanelHeight += 20;
    }

    params = _extends({}, params, { allUsersAvailable: config.allUsersAvailable });

    this.panel = new panelConstructor(params);
    this.panel.setPredefinedState(this.convertPredefinedStateFromSelection(this.predefinedUserSelection));

    this.userSelectorMenu = new _at_shared_user_button_menu2.default({ panel: self.panel });
    this._createUserButton(this.containerId, this.userSelectorMenu, selectorPanelHeight, config);
    return this;
};

ReportUserSelectorButton.prototype._createUserButton = function (containerId, userSelectorMenu, selectorPanelHeight, config) {
    var self = this;
    this.chooseUserButton = new _at_hierarchy_selector_dropdown_button2.default({
        labelCls: "hierarchySelectorButton",
        renderTo: containerId,
        menu: userSelectorMenu,
        selectorPanelHeight: selectorPanelHeight
    });

    this.wasChanged = false;
    this.chooseUserButton.setMenuHideCallback(function () {
        if (config.changeCallback && self.wasChanged) self.wasChanged = false;
        config.changeCallback();
    });
    this.chooseUserButton.setText(_messageResource2.default.getMessage("users_selector.reports.loading"));
    this.chooseUserButton.setEnabled(false);
};

ReportUserSelectorButton.prototype.updateButton = function () {
    this.panel.updateAllSelectedLabel();
    this.chooseUserButton.updateButton();
};

ReportUserSelectorButton.prototype.getButton = function () {
    return this.chooseUserButton;
};

ReportUserSelectorButton.prototype.setInitialValueFromCurrent = function () {
    this.panel.setInitialValueFromCurrent();
};

ReportUserSelectorButton.prototype.updateSelector = function (users, userGroups, timeZoneGroups, manageableUsersIds, showTeamOnly) {
    var convertedUserGroups = userGroups == null ? null : this.convertUserGroupBeansToJsGroups(userGroups);
    var convertedTimeZoneGroups = timeZoneGroups == null ? null : this.convertGroupBeansToJsGroups(timeZoneGroups);
    this.initializeData(userGroups != null, timeZoneGroups != null, this.convertUserInfoToJsUsers(users), manageableUsersIds, convertedUserGroups, convertedTimeZoneGroups, showTeamOnly);
};

ReportUserSelectorButton.prototype.initializeData = function (userGroupsEnabled, timeZoneGroupsEnabled, users, manageableUsersIds, userGroups, timeZoneGroups, showTeamOnly) {
    this.panelWasConstructing = true;
    this.panel.initialize({
        userGroupsEnabled: userGroupsEnabled,
        timeZoneGroupsEnabled: timeZoneGroupsEnabled,
        users: users,
        manageableUsersIds: manageableUsersIds,
        userGroups: userGroups,
        timeZoneGroups: timeZoneGroups,
        showTeamOnly: showTeamOnly
    });
    this.chooseUserButton.setEnabled(true);
};

ReportUserSelectorButton.prototype.getSelection = function () {
    if (this.panelWasConstructing) {
        var result = {};
        result.allUsers = !this.panel.isCustomOptionSelected();
        var selection = this.panel.getSelection();
        result.selectedGroups = selection.getFirstLevel();
        result.selectedUsers = selection.getSecondLevel();
        result.showDisabled = this.panel.getShowInactive();
        result.includeUsersWithoutData = this.needAdditionalCheckbox ? this.panel.getAdditionalCheckboxValue() : result.allUsers ? false : this.includeUsersWithoutDataDefaultValue;
        result.groupType = this.panel.getGroupType();
        result.includeUserTeamOnly = !!this.panel.showTeamOnly;
        return result;
    }
    return this.predefinedUserSelection;
};

ReportUserSelectorButton.prototype.setSelection = function (userSelection) {
    var predefinedState = this.convertPredefinedStateFromSelection(userSelection);
    this.panel.setPredefinedState(predefinedState);
    if (this.panelWasConstructing) {
        this.panel.loadState(predefinedState);
    }
};

ReportUserSelectorButton.prototype.convertUserInfoToJsUsers = function (userbeans) {
    var users = [];
    for (var i = 0; i < userbeans.length; ++i) {
        var u = userbeans[i];
        users.push(new _User2.default(u.id, u.firstName, u.lastName, u.middleName, u.username, u.enabled, undefined, u.userGroupId, u.timeZoneGroupId));
    }
    return users;
};

ReportUserSelectorButton.prototype.convertUserGroupBeansToJsGroups = function (groupbeans) {
    var groups = this.convertGroupBeansToJsGroups(groupbeans);
    groups.unshift(new _Group2.default(window.SystemSettings.usersWithoutGroupId, _messageResource2.default.getMessage('common.users_without_group')));
    return groups;
};

ReportUserSelectorButton.prototype.convertGroupBeansToJsGroups = function (groupbeans) {
    var groups = [];
    for (var i = 0; i < groupbeans.length; ++i) {
        var g = groupbeans[i];
        groups.push(new _Group2.default(g.id, g.name));
    }
    return groups;
};

//need invoke when drop state on initial
ReportUserSelectorButton.prototype.resetValue = function () {
    if (this.panel.isAlreadyShown()) {
        this.panel.resetState(true);
    }
};

ReportUserSelectorButton.prototype.validateIsUserSelected = function () {
    return this.settedWithPredefinedValues || this.panel.isAlreadyShown() ? this.panel.validateIsUsersSelected() : this.predefinedUserSelection.allUsers || this.predefinedUserSelection.selectedUsers != [] || this.predefinedUserSelection.selectedGroups != [];
};

ReportUserSelectorButton.prototype.setWasChanged = function () {
    this.wasChanged = true;
};

ReportUserSelectorButton.prototype.convertPredefinedStateFromSelection = function (selection) {
    return {
        selection: selection.allUsers ? _two_level_selection2.default.emptySelection() : new _two_level_selection2.default(selection.selectedGroups, selection.selectedUsers),
        optionValue: selection.allUsers,
        showInactive: selection.showDisabled,
        additionalCheckBoxValue: selection.includeUsersWithoutData,
        groupType: selection.groupType
    };
};

ReportUserSelectorButton.prototype.isStateChanged = function () {
    return this.panel.isStateChanged();
};

/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = LeaveTypesSelectorButton;

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _at_selector_panel_with_apply_button_object = __webpack_require__(231);

var _at_selector_panel_with_apply_button_object2 = _interopRequireDefault(_at_selector_panel_with_apply_button_object);

var _Ext = __webpack_require__(12);

var _Ext2 = _interopRequireDefault(_Ext);

var _at_selector_dropdown_button = __webpack_require__(799);

var _at_selector_dropdown_button2 = _interopRequireDefault(_at_selector_dropdown_button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function LeaveTypesSelectorButton() {}

LeaveTypesSelectorButton.prototype.init = function (_ref) {
    var renderTo = _ref.renderTo,
        leavesSelection = _ref.leavesSelection,
        leavesData = _ref.leavesData,
        ptoFeatureEnabled = _ref.ptoFeatureEnabled,
        sickBalanceFeatureEnabled = _ref.sickBalanceFeatureEnabled,
        changeCallback = _ref.changeCallback,
        withApplyButton = _ref.withApplyButton,
        _ref$extraClass = _ref.extraClass,
        extraClass = _ref$extraClass === undefined ? '' : _ref$extraClass,
        _ref$isMarkAllSelecte = _ref.isMarkAllSelectedIfEmpty,
        isMarkAllSelectedIfEmpty = _ref$isMarkAllSelecte === undefined ? false : _ref$isMarkAllSelecte,
        _ref$showInactiveChec = _ref.showInactiveCheckbox,
        showInactiveCheckbox = _ref$showInactiveChec === undefined ? false : _ref$showInactiveChec,
        _ref$isMarkAllSelecte2 = _ref.isMarkAllSelectedIfEmptyOnInit,
        isMarkAllSelectedIfEmptyOnInit = _ref$isMarkAllSelecte2 === undefined ? true : _ref$isMarkAllSelecte2,
        _ref$labelNoItemsSele = _ref.labelNoItemsSelectedKey,
        labelNoItemsSelectedKey = _ref$labelNoItemsSele === undefined ? 'leaves_selector.label.no_items_selected' : _ref$labelNoItemsSele;

    var leaveSelectorUtil = new LeaveTypesSelectorUtil().init(leavesData, ptoFeatureEnabled, sickBalanceFeatureEnabled, leavesSelection.leaveTypes);

    var ptoName = _messageResource2.default.getMessage("leaves_selector.group_label.pto_balance");
    var sdbName = _messageResource2.default.getMessage("leaves_selector.group_label.sick_days_balance");
    var bothName = ptoFeatureEnabled && sickBalanceFeatureEnabled ? _messageResource2.default.getMessage("leaves_selector.group_label.both") : ptoFeatureEnabled ? ptoName : sdbName;

    var leaveSelectorData = leaveSelectorUtil.getDataForSelector({
        ptoLabel: _messageResource2.default.getMessage('leaves_selector.group_label.affects', [ptoName]),
        sickDaysLabel: _messageResource2.default.getMessage('leaves_selector.group_label.affects', [sdbName]),
        withoutBalancesLabel: _messageResource2.default.getMessage('leaves_selector.group_label.does_not_affect', [bothName])
    });

    var markupAllIfEmptyConfig = isMarkAllSelectedIfEmpty ? { allItemsOptionValue: true, customOptionValue: false } : {};

    var leavesConfig = _extends({
        data: leaveSelectorData,
        optionValue: leavesSelection.qualifier,
        showInactive: leaveSelectorUtil.isNeedToShowInactiveLeaves() || leavesSelection.showInactive,
        showResetButton: true,
        isMarkAllSelectedIsEmpty: isMarkAllSelectedIfEmpty,
        showShowInactiveCheckbox: showInactiveCheckbox,
        isMarkAllSelectedIfEmptyOnInit: isMarkAllSelectedIfEmptyOnInit,
        labelNoItemsSelectedKey: labelNoItemsSelectedKey
    }, markupAllIfEmptyConfig);

    var panelConstructor = AT.ReportLeavesSelectorPanel;
    leaveSelectorUtil.setSelectorTreeConstructorToPanel(panelConstructor);

    if (withApplyButton) _Ext2.default.apply(leavesConfig, _at_selector_panel_with_apply_button_object2.default.getApplyButtonExtension(panelConstructor));
    var leavesSelector = new panelConstructor(leavesConfig);

    var self = this;
    leavesSelector.on("change", function () {
        self.leavesSelector.wasChanged = true;
    });

    this.leavesSelector = new _at_selector_dropdown_button2.default({
        additionalMenuCls: 'leaveTypeSelector ' + extraClass,
        renderTo: renderTo,
        labelCls: "hierarchySelectorButton",
        minWidth: 457,
        selectorPanel: leavesSelector
    });

    this.leavesSelector.setMenuHideCallback(function () {
        if (changeCallback && (self.leavesSelector.wasChanged || self.leavesSelector.selectorPanel.isNeedToMarkAllSelected())) {
            self.leavesSelector.wasChanged = false;
            self.leavesSelector.selectorPanel.markAllSelectedIfNeeded();
            changeCallback();
        }
    });

    return this;
};

LeaveTypesSelectorButton.prototype.getLeaveTypeSelection = function () {
    var leavesSelector = this.leavesSelector.selectorPanel;
    var leaveTypes = [];
    for (var i = 0; i < leavesSelector.getSelection().length; ++i) {
        leaveTypes.push(leavesSelector.getSelection()[i].id);
    }

    return {
        leaveTypes: leaveTypes,
        qualifier: leavesSelector.getCurrentOptionValue(),
        showArchived: leavesSelector.getShowInactive()
    };
};

LeaveTypesSelectorButton.prototype.resetLeavesSelectionFunction = function () {
    this.leavesSelector.selectorPanel.resetState(true);
};

LeaveTypesSelectorButton.prototype.setInitialValuesFromCurrent = function () {
    this.leavesSelector.selectorPanel.setInitialValuesFromCurrent();
};

LeaveTypesSelectorButton.prototype.isEmptySelection = function () {
    return this.leavesSelector.selectorPanel.isEmptySelection();
};

LeaveTypesSelectorButton.prototype.isStateChanged = function () {
    return this.leavesSelector.selectorPanel.isStateChanged();
};

/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getParametersFormattingStrategy = exports.getUsersFilteredByAuthorizer = exports.getChartImageDimensionsInPixels = exports.getMaxValuesCalculator = exports.getTotalPagesCalculator = exports.getCreateDefinitionObjectStrategy = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _constants = __webpack_require__(11);

var _VerticalBarsChartStrategy = __webpack_require__(1470);

var _VerticalBarsChartStrategy2 = _interopRequireDefault(_VerticalBarsChartStrategy);

var _HorBarsChartStrategy = __webpack_require__(1471);

var _HorBarsChartStrategy2 = _interopRequireDefault(_HorBarsChartStrategy);

var _PieChartStrategy = __webpack_require__(1472);

var _PieChartStrategy2 = _interopRequireDefault(_PieChartStrategy);

var _atUtils = __webpack_require__(5);

var _ATReportParamsStringBuilder = __webpack_require__(52);

var _ATReportParamsStringBuilder2 = _interopRequireDefault(_ATReportParamsStringBuilder);

var _ChartPDFOvertimeParametersFormattingStrategy = __webpack_require__(1473);

var _ChartPDFOvertimeParametersFormattingStrategy2 = _interopRequireDefault(_ChartPDFOvertimeParametersFormattingStrategy);

var _date_format = __webpack_require__(16);

var _ChartPDFLeaveParametersFormattingStrategy = __webpack_require__(1475);

var _ChartPDFLeaveParametersFormattingStrategy2 = _interopRequireDefault(_ChartPDFLeaveParametersFormattingStrategy);

var _ChartPDFWorkingHoursCostBillingParametersFormattingStrategy = __webpack_require__(1476);

var _ChartPDFWorkingHoursCostBillingParametersFormattingStrategy2 = _interopRequireDefault(_ChartPDFWorkingHoursCostBillingParametersFormattingStrategy);

var _ChartPDFBalanceParametersFormattingStrategy = __webpack_require__(1477);

var _ChartPDFBalanceParametersFormattingStrategy2 = _interopRequireDefault(_ChartPDFBalanceParametersFormattingStrategy);

var _ChartPDFParametersFormattingStrategy = __webpack_require__(245);

var _ChartPDFParametersFormattingStrategy2 = _interopRequireDefault(_ChartPDFParametersFormattingStrategy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 *
 * @param chartType
 * @returns {BaseCreateDefinitionObjectStrategy}
 */
var getCreateDefinitionObjectStrategy = exports.getCreateDefinitionObjectStrategy = function getCreateDefinitionObjectStrategy(chartType) {
    switch (chartType) {
        case _constants.ChartType.VERTICAL_BAR:
            return new _VerticalBarsChartStrategy2.default();
        case _constants.ChartType.HORIZONTAL_BAR:
            return new _HorBarsChartStrategy2.default();
        case _constants.ChartType.PIE_CHART:
            return new _PieChartStrategy2.default();
    }
};

/**
 * Get calculator of total pages.
 * In feature it may be separate class
 * @param chartType type of target chart
 * @returns {*} - calculator
 */
var getTotalPagesCalculator = exports.getTotalPagesCalculator = function getTotalPagesCalculator(chartType) {
    return getCreateDefinitionObjectStrategy(chartType);
};

/**
 * Get calculator of max values on page
 * In feature it may be separate class
 * @param chartType type of target chart
 * @returns {*}
 */
var getMaxValuesCalculator = exports.getMaxValuesCalculator = function getMaxValuesCalculator(chartType) {
    return getCreateDefinitionObjectStrategy(chartType);
};

/**
 * Get chart image sizes in pixels
 * @param chartType
 * @param lengthOfDataList length of all data in pdf
 * @param pdfPrintParameters
 * @returns {{width: number, height: number}}
 */
var getChartImageDimensionsInPixels = exports.getChartImageDimensionsInPixels = function getChartImageDimensionsInPixels(chartType, lengthOfDataList, pdfPrintParameters) {
    var pdfImageSizes = getCreateDefinitionObjectStrategy(chartType).getChartImageDimensions(lengthOfDataList, pdfPrintParameters);
    var chartSizesMultiplyCoeff = 2;
    return {
        width: pdfImageSizes.w * chartSizesMultiplyCoeff,
        height: pdfImageSizes.h * chartSizesMultiplyCoeff
    };
};

/**
 * Get users array filtered by authorizationInfo
 */
var getUsersFilteredByAuthorizer = exports.getUsersFilteredByAuthorizer = function getUsersFilteredByAuthorizer(users, authorizationInfo) {
    return (0, _atUtils.filterArrayByArrayOfIds)(users, authorizationInfo.availableUserIds);
};

/**
 * Get chart PDF parameters formatting strategy by chart type
 * @returns {ChartPDFParametersFormattingStrategy}
 */
var getParametersFormattingStrategy = exports.getParametersFormattingStrategy = function getParametersFormattingStrategy(_ref) {
    var chartTypeValue = _ref.chartTypeValue,
        selectorsData = _ref.selectorsData,
        dateFormat = _ref.dateFormat,
        reportAuthorizationInfo = _ref.reportAuthorizationInfo;

    var dateFormatForFileName = new _date_format.DateFormat('yyyy-MM-dd');
    switch (chartTypeValue) {
        case _constants.ReportChartType.TOTAL_WORKING_HOURS:
        case _constants.ReportChartType.APPROVED_WORKING_HOURS:
            return new _ChartPDFWorkingHoursCostBillingParametersFormattingStrategy2.default().init(_extends({}, selectorsData, { users: getUsersFilteredByAuthorizer(selectorsData.users, reportAuthorizationInfo.taskChartsAuthorizationInfo) }), dateFormat, dateFormatForFileName, reportAuthorizationInfo.taskChartsAuthorizationInfo, _ATReportParamsStringBuilder2.default);
        case _constants.ReportChartType.COST_OF_WORK:
        case _constants.ReportChartType.BILLABLE_AMOUNTS:
            return new _ChartPDFWorkingHoursCostBillingParametersFormattingStrategy2.default().init(_extends({}, selectorsData, { users: getUsersFilteredByAuthorizer(selectorsData.users, reportAuthorizationInfo.billingChartsAuthorizationInfo) }), dateFormat, dateFormatForFileName, reportAuthorizationInfo.billingChartsAuthorizationInfo, _ATReportParamsStringBuilder2.default);
        case _constants.ReportChartType.LEAVE_HOURS:
            return new _ChartPDFLeaveParametersFormattingStrategy2.default().init(_extends({}, selectorsData, { users: getUsersFilteredByAuthorizer(selectorsData.users, reportAuthorizationInfo.taskChartsAuthorizationInfo) }), dateFormat, dateFormatForFileName, reportAuthorizationInfo.balanceChartsAuthorizationInfo, _ATReportParamsStringBuilder2.default);
        case _constants.ReportChartType.PTO_BALANCE:
        case _constants.ReportChartType.SICK_DAYS_BALANCE:
            return new _ChartPDFBalanceParametersFormattingStrategy2.default().init(_extends({}, selectorsData, { users: getUsersFilteredByAuthorizer(selectorsData.users, reportAuthorizationInfo.balanceChartsAuthorizationInfo) }), dateFormat, dateFormatForFileName, reportAuthorizationInfo.balanceChartsAuthorizationInfo, _ATReportParamsStringBuilder2.default);
        case _constants.ReportChartType.OVERTIME_HOURS:
            return new _ChartPDFOvertimeParametersFormattingStrategy2.default().init(_extends({}, selectorsData, { users: getUsersFilteredByAuthorizer(selectorsData.users, reportAuthorizationInfo.balanceChartsAuthorizationInfo) }), dateFormat, dateFormatForFileName, reportAuthorizationInfo.balanceChartsAuthorizationInfo, _ATReportParamsStringBuilder2.default);
    }
};

/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _GroupType = __webpack_require__(34);

var _GroupType2 = _interopRequireDefault(_GroupType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UserSelectorUtils = function () {
    function UserSelectorUtils() {
        _classCallCheck(this, UserSelectorUtils);
    }

    _createClass(UserSelectorUtils, null, [{
        key: 'convertSelectedGroupsIntoSelectedUsersIfNecessary',
        value: function convertSelectedGroupsIntoSelectedUsersIfNecessary(allUserList, groupType, allUsersSelected, showDisabled, selectedGroups, UGREnabled, TZGEnabled) {
            return UserSelectorUtils.convertSelectedGroupsIntoSelectedUsersConsideringTeamOnlyIfNecessary(allUserList, groupType, allUsersSelected, showDisabled, selectedGroups, UGREnabled, TZGEnabled, false);
        }
    }, {
        key: 'convertSelectedGroupsIntoSelectedUsersConsideringTeamOnlyIfNecessary',
        value: function convertSelectedGroupsIntoSelectedUsersConsideringTeamOnlyIfNecessary(allUserList, groupType, allUsersSelected, showDisabled, selectedGroups, UGREnabled, TZGEnabled, includeUserTeamOnly) {
            // this logic must be the same as in ReportParamsUtil.convertSelectedGroupsToSelectedUsersIfNecessary (ReportParamsUtil.java)
            if (!includeUserTeamOnly && (allUsersSelected || selectedGroups.length === 0 || UGREnabled && groupType === _GroupType2.default.USER_GROUP || TZGEnabled && groupType === _GroupType2.default.TIME_ZONE_GROUP)) {
                return [];
            }

            var selectedUsers = [];
            for (var groupId in selectedGroups) {
                //noinspection JSUnfilteredForInLoop
                var usersInGroup = UserSelectorUtils.getUsersByGroup(allUserList, selectedGroups[groupId], groupType);
                selectedUsers = _jquery2.default.merge(selectedUsers, UserSelectorUtils.getActiveAndSelectedDisabledUsers(showDisabled, usersInGroup));
            }

            return selectedUsers;
        }
    }, {
        key: 'getActiveAndSelectedDisabledUsers',
        value: function getActiveAndSelectedDisabledUsers(showDisabled, users) {
            if (showDisabled) return users;

            return _jquery2.default.grep(users, function (user) {
                /*see Bug 53301*/
                return user.active || user.enabled;
            });
        }
    }, {
        key: 'getUsersByGroup',
        value: function getUsersByGroup(allUserList, groupId, groupType) {
            var groupTypeFieldId = groupType === _GroupType2.default.USER_GROUP ? "userGroupId" : "timeZoneGroupId";
            return Object.values(allUserList).filter(function (user) {
                return user[groupTypeFieldId] === groupId;
            });
        }
    }]);

    return UserSelectorUtils;
}();

exports.default = UserSelectorUtils;

/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isTtmCanSeeAutoApprovedCollapsed = exports.isHideAccountSettingsCollapsed = exports.isHideDetailsOnLockTTCollapsed = exports.isHideNotAssignedTTDetailsCollapsed = exports.isShowUsernameInReportsCollapsed = exports.isAllowRegularUsersToEditTasksStatusesCollapsed = exports.isAllowUsersToSeeAllTTCollapsed = exports.getDARSettingsCollapsedState = exports.getAnyUserGroupsListWithDefault = exports.getUserGroupsListWithDefault = exports.getUserGroupsList = exports.getAnyTimeZoneGroupsList = exports.getTimeZoneGroupsList = exports.getUsersList = exports.getDARSettings = exports.doesTTMCanSeeAutoApproved = exports.doesHideAccountSettingsWhenDisabled = exports.doesHideDetailsOnLockTT = exports.doesHideNotAssignedTTDetails = exports.doesShowUsernameInReports = exports.getUsersForSeeAllTTFilter = exports.doesAllowRegularUsersToEditTaskStatuses = exports.doesAllowUsersToSeeAllTT = exports.getDARSettingsState = undefined;

var _reselect = __webpack_require__(13);

var _selectors = __webpack_require__(14);

var _UserWithAccessRights = __webpack_require__(138);

var _UserWithAccessRights2 = _interopRequireDefault(_UserWithAccessRights);

var _user_group_selector_util = __webpack_require__(98);

var _groupUtils = __webpack_require__(71);

var _GroupType = __webpack_require__(34);

var _GroupType2 = _interopRequireDefault(_GroupType);

var _selectors2 = __webpack_require__(15);

var _Group = __webpack_require__(158);

var _Group2 = _interopRequireDefault(_Group);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getDARSettingsState = exports.getDARSettingsState = function getDARSettingsState(state) {
    return state.darSettings;
};

var doesAllowUsersToSeeAllTT = exports.doesAllowUsersToSeeAllTT = function doesAllowUsersToSeeAllTT(state) {
    return getDARSettingsState(state).allowUsersToSeeAllTT;
};
var doesAllowRegularUsersToEditTaskStatuses = exports.doesAllowRegularUsersToEditTaskStatuses = function doesAllowRegularUsersToEditTaskStatuses(state) {
    return getDARSettingsState(state).allowRegularUsersToEditTasksStatuses;
};
var getUsersForSeeAllTTFilter = exports.getUsersForSeeAllTTFilter = function getUsersForSeeAllTTFilter(state) {
    return getDARSettingsState(state).usersForSeeAllTTFilter;
};
var doesShowUsernameInReports = exports.doesShowUsernameInReports = function doesShowUsernameInReports(state) {
    return getDARSettingsState(state).showUsernameInReports;
};
var doesHideNotAssignedTTDetails = exports.doesHideNotAssignedTTDetails = function doesHideNotAssignedTTDetails(state) {
    return getDARSettingsState(state).hideNotAssignedTTDetails;
};
var doesHideDetailsOnLockTT = exports.doesHideDetailsOnLockTT = function doesHideDetailsOnLockTT(state) {
    return getDARSettingsState(state).hideDetailsOnLockTT;
};
var doesHideAccountSettingsWhenDisabled = exports.doesHideAccountSettingsWhenDisabled = function doesHideAccountSettingsWhenDisabled(state) {
    return getDARSettingsState(state).hideAccountSettingsWhenDisabled;
};
var doesTTMCanSeeAutoApproved = exports.doesTTMCanSeeAutoApproved = function doesTTMCanSeeAutoApproved(state) {
    return getDARSettingsState(state).ttmCanSeeAutoApproved;
};

var getDARSettings = exports.getDARSettings = (0, _reselect.createSelector)(getDARSettingsState, function (darState) {
    return {
        allowUsersToSeeAllTT: darState.allowUsersToSeeAllTT,
        allowRegularUsersToEditTasksStatuses: darState.allowRegularUsersToEditTasksStatuses,
        usersForSeeAllTTFilter: darState.usersForSeeAllTTFilter,
        showUsernameInReports: darState.showUsernameInReports,
        hideNotAssignedTTDetails: darState.hideNotAssignedTTDetails,
        hideDetailsOnLockTT: darState.hideDetailsOnLockTT,
        hideAccountSettingsWhenDisabled: darState.hideAccountSettingsWhenDisabled,
        ttmCanSeeAutoApproved: darState.ttmCanSeeAutoApproved
    };
});

var getUsersList = exports.getUsersList = (0, _reselect.createSelector)(_selectors.getUsers, function (users) {
    return Object.values(users).map(function (u) {
        return _UserWithAccessRights2.default.fromRPC(u);
    }).sort(_user_group_selector_util.userComparator);
});

var getTimeZoneGroupsList = exports.getTimeZoneGroupsList = (0, _reselect.createSelector)(_selectors.getTimeZoneGroups, _selectors2.isTZGEnabled, function (timeZoneGroups, tzgEnabled) {
    return tzgEnabled ? Object.values(timeZoneGroups).map(function (g) {
        return new _Group2.default(g.id, g.name);
    }).sort((0, _groupUtils.createGroupComparator)(_GroupType2.default.TIME_ZONE_GROUP)) : [];
});

var getAnyTimeZoneGroupsList = exports.getAnyTimeZoneGroupsList = (0, _reselect.createSelector)(_selectors.getTimeZoneGroups, _selectors2.isAnyTZGEnabled, function (timeZoneGroups, tzgEnabled) {
    return tzgEnabled ? Object.values(timeZoneGroups).map(function (g) {
        return new _Group2.default(g.id, g.name);
    }).sort((0, _groupUtils.createGroupComparator)(_GroupType2.default.TIME_ZONE_GROUP)) : [];
});

var getUserGroupsList = exports.getUserGroupsList = (0, _reselect.createSelector)(_selectors.getUserGroups, _selectors2.isUGREnabled, function (userGroups, ugrEnabled) {
    return userGroupsToList(userGroups, ugrEnabled);
});

var getUserGroupsListWithDefault = exports.getUserGroupsListWithDefault = (0, _reselect.createSelector)(_selectors.getUserGroupsWithDefault, _selectors2.isUGREnabled, function (userGroups, ugrEnabled) {
    return userGroupsToList(userGroups, ugrEnabled);
});

var getAnyUserGroupsListWithDefault = exports.getAnyUserGroupsListWithDefault = (0, _reselect.createSelector)(_selectors.getUserGroupsWithDefault, _selectors2.isAnyUGREnabled, function (userGroups, ugrEnabled) {
    return userGroupsToList(userGroups, ugrEnabled);
});

var getDARSettingsCollapsedState = exports.getDARSettingsCollapsedState = (0, _reselect.createSelector)(getDARSettingsState, function (darSettings) {
    return {
        allowUsersToSeeAllTTCollapsed: darSettings.allowUsersToSeeAllTTCollapsed,
        allowRegularUsersToEditTasksStatusesCollapsed: darSettings.allowRegularUsersToEditTasksStatusesCollapsed,
        showUsernameInReportsCollapsed: darSettings.showUsernameInReportsCollapsed,
        hideNotAssignedTTDetailsCollapsed: darSettings.hideNotAssignedTTDetailsCollapsed,
        hideDetailsOnLockTTCollapsed: darSettings.hideDetailsOnLockTTCollapsed,
        hideAccountSettingsCollapsed: darSettings.hideAccountSettingsCollapsed,
        ttmCanSeeAutoApprovedCollapsed: darSettings.ttmCanSeeAutoApprovedCollapsed
    };
});

var isAllowUsersToSeeAllTTCollapsed = exports.isAllowUsersToSeeAllTTCollapsed = function isAllowUsersToSeeAllTTCollapsed(state) {
    return getDARSettingsState(state).allowUsersToSeeAllTTCollapsed;
};
var isAllowRegularUsersToEditTasksStatusesCollapsed = exports.isAllowRegularUsersToEditTasksStatusesCollapsed = function isAllowRegularUsersToEditTasksStatusesCollapsed(state) {
    return getDARSettingsState(state).allowRegularUsersToEditTasksStatusesCollapsed;
};
var isShowUsernameInReportsCollapsed = exports.isShowUsernameInReportsCollapsed = function isShowUsernameInReportsCollapsed(state) {
    return getDARSettingsState(state).showUsernameInReportsCollapsed;
};
var isHideNotAssignedTTDetailsCollapsed = exports.isHideNotAssignedTTDetailsCollapsed = function isHideNotAssignedTTDetailsCollapsed(state) {
    return getDARSettingsState(state).hideNotAssignedTTDetailsCollapsed;
};
var isHideDetailsOnLockTTCollapsed = exports.isHideDetailsOnLockTTCollapsed = function isHideDetailsOnLockTTCollapsed(state) {
    return getDARSettingsState(state).hideDetailsOnLockTTCollapsed;
};
var isHideAccountSettingsCollapsed = exports.isHideAccountSettingsCollapsed = function isHideAccountSettingsCollapsed(state) {
    return getDARSettingsState(state).hideAccountSettingsCollapsed;
};
var isTtmCanSeeAutoApprovedCollapsed = exports.isTtmCanSeeAutoApprovedCollapsed = function isTtmCanSeeAutoApprovedCollapsed(state) {
    return getDARSettingsState(state).ttmCanSeeAutoApprovedCollapsed;
};

var userGroupsToList = function userGroupsToList(userGroups, ugrEnabled) {
    return ugrEnabled ? Object.values(userGroups).map(function (g) {
        return new _Group2.default(g.id, g.name);
    }).sort((0, _groupUtils.createGroupComparator)(_GroupType2.default.USER_GROUP)) : [];
};

/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ParametersFormatter2 = __webpack_require__(246);

var _ParametersFormatter3 = _interopRequireDefault(_ParametersFormatter2);

var _constants = __webpack_require__(11);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _FormatUtils = __webpack_require__(142);

var _FormatUtils2 = _interopRequireDefault(_FormatUtils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ChartParametersFormatter = function (_ParametersFormatter) {
    _inherits(ChartParametersFormatter, _ParametersFormatter);

    function ChartParametersFormatter() {
        _classCallCheck(this, ChartParametersFormatter);

        return _possibleConstructorReturn(this, (ChartParametersFormatter.__proto__ || Object.getPrototypeOf(ChartParametersFormatter)).apply(this, arguments));
    }

    _createClass(ChartParametersFormatter, [{
        key: "init",
        value: function init(_ref) {
            var selectorsData = _ref.selectorsData,
                dateFormat = _ref.dateFormat,
                ugrFeatureEnabled = _ref.ugrFeatureEnabled,
                tzgFeatureEnabled = _ref.tzgFeatureEnabled,
                reportAuthorizationInfo = _ref.reportAuthorizationInfo,
                reportParamsStringBuilderConstructor = _ref.reportParamsStringBuilderConstructor;

            this.reportParamsStringBuilder = new reportParamsStringBuilderConstructor({
                data: {
                    users: selectorsData.users,
                    userGroupsFeatureEnabled: ugrFeatureEnabled,
                    tzGroupsFeatureEnabled: tzgFeatureEnabled,
                    userGroups: selectorsData.userGroups,
                    timeZoneGroups: selectorsData.timeZoneGroups,
                    cpList: selectorsData.customersProjects,
                    leaveTypesMap: selectorsData.leaveTypesMap,
                    statuses: selectorsData.statuses,
                    manageableUserIds: selectorsData.manageableUserIds,
                    projectsWithMaIds: selectorsData.projectsWithMaIds
                },
                dateFormat: dateFormat,
                reportAuthorizationInfo: reportAuthorizationInfo,
                userFormatter: _FormatUtils2.default.reportUserFormatterWithoutUsername
            });
            return this;
        }
    }, {
        key: "formatChartTypeValue",
        value: function formatChartTypeValue(chartType) {
            var key;
            switch (chartType) {
                case _constants.ReportChartType.TOTAL_WORKING_HOURS:
                    key = "report.chart_type.total_working_hours";
                    break;
                case _constants.ReportChartType.APPROVED_WORKING_HOURS:
                    key = "report.chart_type.approved_working_hours";
                    break;
                case _constants.ReportChartType.LEAVE_HOURS:
                    key = "report.chart_type.leave_hours";
                    break;
                case _constants.ReportChartType.PTO_BALANCE:
                    key = "report.chart_type.pto_balance";
                    break;
                case _constants.ReportChartType.SICK_DAYS_BALANCE:
                    key = "report.chart_type.sick_days_balance";
                    break;
                case _constants.ReportChartType.OVERTIME_HOURS:
                    key = "report.chart_type.overtime_hours";
                    break;
                case _constants.ReportChartType.COST_OF_WORK:
                    key = "report.chart_type.cost_of_work";
                    break;
                case _constants.ReportChartType.BILLABLE_AMOUNTS:
                    key = "report.chart_type.billable_amounts";
            }
            return _messageResource2.default.getMessage(key);
        }
    }, {
        key: "formatGroupingLevelValue",
        value: function formatGroupingLevelValue(groupingLevel) {
            var key;
            switch (groupingLevel) {
                case _constants.ReportGroupingLevel.USER:
                    key = "report.chart_pdf_preview.users";
                    break;
                case _constants.ReportGroupingLevel.USER_GROUP:
                    key = "common.user_groups";
                    break;
                case _constants.ReportGroupingLevel.TIME_ZONE_GROUP:
                    key = "common.time_zone_groups";
                    break;
                case _constants.ReportGroupingLevel.CUSTOMER:
                    key = "common.customers";
                    break;
                case _constants.ReportGroupingLevel.PROJECT:
                    key = "common.projects";
                    break;
                case _constants.ReportGroupingLevel.BILLING_TYPE:
                    key = "report.chart_pdf_preview.types_of_work";
                    break;
                case _constants.ReportGroupingLevel.MONTH:
                    key = "report.chart_pdf_preview.months";
                    break;
                case _constants.ReportGroupingLevel.WEEK:
                    key = "report.chart_pdf_preview.weeks";
                    break;
                case _constants.ReportGroupingLevel.DATE:
                    key = "report.chart_pdf_preview.days";
                    break;
                case _constants.ReportGroupingLevel.LEAVE_TYPE:
                    key = "report.chart_pdf_preview.leave_type";
                    break;
            }
            return _messageResource2.default.getMessage(key);
        }
    }, {
        key: "getChartCategoryName",
        value: function getChartCategoryName(groupingLevel) {
            switch (groupingLevel) {
                case _constants.ReportGroupingLevel.USER:
                    return _messageResource2.default.getMessage('common.User');
                case _constants.ReportGroupingLevel.USER_GROUP:
                    return _messageResource2.default.getMessage('common.User_Group');
                case _constants.ReportGroupingLevel.TIME_ZONE_GROUP:
                    return _messageResource2.default.getMessage('common.Time_Zone_Group');
                case _constants.ReportGroupingLevel.CUSTOMER:
                    return _messageResource2.default.getMessage('common.Customer');
                case _constants.ReportGroupingLevel.PROJECT:
                    return _messageResource2.default.getMessage('common.Project');
                case _constants.ReportGroupingLevel.LEAVE_TYPE:
                    return _messageResource2.default.getMessage('report.common.leave_type');
                case _constants.ReportGroupingLevel.BILLING_TYPE:
                    return _messageResource2.default.getMessage('report.common.billing_type');
                case _constants.ReportGroupingLevel.DATE:
                    return _messageResource2.default.getMessage('common.date');
                case _constants.ReportGroupingLevel.WEEK:
                    return _messageResource2.default.getMessage('common.week');
                case _constants.ReportGroupingLevel.MONTH:
                    return _messageResource2.default.getMessage('common.month');
                default:
                    return '';
            }
        }
    }]);

    return ChartParametersFormatter;
}(_ParametersFormatter3.default);

exports.default = ChartParametersFormatter;

/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _DateFormattingStrategy = __webpack_require__(805);

var _DateFormattingStrategy2 = _interopRequireDefault(_DateFormattingStrategy);

var _constants = __webpack_require__(4);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SingleDateFormattingStrategy = function (_DateFormattingStrate) {
    _inherits(SingleDateFormattingStrategy, _DateFormattingStrate);

    function SingleDateFormattingStrategy() {
        _classCallCheck(this, SingleDateFormattingStrategy);

        return _possibleConstructorReturn(this, (SingleDateFormattingStrategy.__proto__ || Object.getPrototypeOf(SingleDateFormattingStrategy)).apply(this, arguments));
    }

    _createClass(SingleDateFormattingStrategy, [{
        key: 'formatForDateInformation',
        value: function formatForDateInformation(dateParameters) {
            var dateSelection = dateParameters.dateSelection;

            var qualifier = dateSelection.qualifier;
            var date = dateSelection.date;

            var dateString = void 0;
            if (qualifier === _constants.EvaDateQualifier.CUSTOM) {
                dateString = this.formatDate(date);
            } else {
                dateString = (qualifier === _constants.EvaDateQualifier.TODAY || qualifier === _constants.EvaDateQualifier.YESTERDAY ? "" : _messageResource2.default.getMessage("common.pdf.formatting.date.the") + " ") + _messageResource2.default.getMessage(EvaDateStateUtil[qualifier]).toLowerCase();
            }

            return _messageResource2.default.getMessage("common.pdf.formatting.date.date_part.single", [dateString]);
        }
    }, {
        key: 'formatSpecifyingInformation',
        value: function formatSpecifyingInformation(dateParameters) {
            var dateSelection = dateParameters.dateSelection;

            if (dateSelection.qualifier === _constants.EvaDateQualifier.CUSTOM) return "";

            return " (" + this.formatDate(dateSelection.date) + ")";
        }
    }]);

    return SingleDateFormattingStrategy;
}(_DateFormattingStrategy2.default);

exports.default = SingleDateFormattingStrategy;

/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _constants = __webpack_require__(100);

var _ListSelector = __webpack_require__(96);

var _ListSelector2 = _interopRequireDefault(_ListSelector);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PDFSettingsPreview = function (_TemplateView) {
    _inherits(PDFSettingsPreview, _TemplateView);

    function PDFSettingsPreview($containerEl, lightboxId) {
        _classCallCheck(this, PDFSettingsPreview);

        var _this = _possibleConstructorReturn(this, (PDFSettingsPreview.__proto__ || Object.getPrototypeOf(PDFSettingsPreview)).call(this, $containerEl));

        _this.lightboxId = lightboxId;
        return _this;
    }

    _createClass(PDFSettingsPreview, [{
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='pdfPreviewModeElement pdfPreviewInnerContent'>" + "  <table cellpadding='0' cellspacing='0'>" + "    <tr>" + "      <td class='pdfParametersSectionTd'>" + "        <div id='<%=id%>_pdfParametersSection' class='pdfParametersSection'>" + "          <div class='pageSetupSection'>" + "            <div class='parametersSectionHeader'><%=pageSetupLabel%></div>" + "            <div>" + "              <div class='selectorLabel'><%=paperSizeLabel%></div>" + "              <div class='selectorContainer paperSizeSelectorCt' id='<%=id%>_paperSizeSelector'></div>" + "            </div>" + "            <div class='pageOrientationSelector'>" + "              <div class='selectorLabel'><%=orientationLabel%></div>" + "              <div class='selectorContainer paperOrientationSelectorCt'>" + "                <table>" + "                  <tr>" + "                    <td><input type='radio' name='<%=id%>_pageOrientation' id='<%=id%>_portrait'/></td>" + "                    <td><label for='<%=id%>_portrait'><%=orientationPortraitLabel%></label></td>" + "                  </tr>" + "                  <tr>" + "                    <td><input type='radio' name='<%=id%>_pageOrientation' id='<%=id%>_landscape'/></td>" + "                    <td><label for='<%=id%>_landscape'><%=orientationLandscapeLabel%></label></td>" + "                  </tr>" + "                </table>" + "              </div>" + "            </div>" + "            <div class='showHeaderOnEachPage'>" + "              <table>" + "                <tr>" + "                  <td><input type='checkbox' id='<%=id%>_headerOnEachPage'/></td>" + "                  <td><label for='<%=id%>_headerOnEachPage'><%=showHeaderLabel%></label></td>" + "                </tr>" + "              </table>" + "            </div>" + "            <div class='showLogoInHeader'>" + "              <table>" + "                <tr>" + "                  <td><input type='checkbox' id='<%=id%>_logoInHeader'/></td>" + "                  <td><label for='<%=id%>_logoInHeader'><%=showLogoLabel%></label></td>" + "                </tr>" + "              </table>" + "            </div>" + "          </div>" + "          <div class='delimiter'></div>" + "          <div class='customSettingsSectionContainer'></div>" + "          <div class='bottomSection'>" + "            <div class='delimiter'></div>" + "            <span id='<%=id%>_numberOfPages' class='numberOfPages'>" + "              <%=pagesNumberLabel%>" + "              <span id='<%=id%>_numberOfPagesContainer'></span>" + "            </span>" + "            <div id='<%=id%>_updatePreviewBtn' class='updatePreviewButton disabled'><%=updatePreviewButtonLabel%></div>" + "          </div>" + "        </div>" + "      </td>" + "      <td class='pdfPreviewTd'>" + "        <div id='pdfPreviewSectionId' class='pdfPreviewSection'></div>" + "        <div id='pdfPreviewSectionMoireId' class='pdfPreviewSectionMoire'>" + "          <div class='centeredContent'>" + "            <div class='previewSpinnerPlaceholder' id='previewChartPDFSpinner'></div>" + "            <div class='previewLoadingMessage'><%=loadingPreviewLabel%></div>" + "          </div>" + "        </div>" + "      </td>" + "    </tr>" + "  </table>" + "</div>";
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            var self = this;

            this.parametersChanged = false;
            this.changesCallback = function () {
                self.handleParameterChange();
            };

            this.section = (0, _jquery2.default)(document.getElementById(this.lightboxId + "_pdfParametersSection"));

            this.initPaperSizeSelector();
            this.initPaperOrientationRadio();
            this.initHeaderCheckboxes();

            this.numberOfPagesContainer = (0, _jquery2.default)(document.getElementById(this.lightboxId + "_numberOfPagesContainer"));

            this.updatePreviewButton = (0, _jquery2.default)(document.getElementById(this.lightboxId + "_updatePreviewBtn"));
            this.updatePreviewButton.off();
            this.updatePreviewButton.hover(function () {
                (0, _jquery2.default)(this).addClass("hovered");
            }, function () {
                (0, _jquery2.default)(this).removeClass("hovered");
            });
            this.updatePreviewButton.click(function () {
                self.onUpdatePreviewButtonClicked();
            });

            this.subscribeToEvents();
        }
    }, {
        key: "update",
        value: function update() {
            var printParameters = this.getStore().getPrintParametersForSave();

            this.paperSizeSelectorContainer.innerHTML = "";
            this.paperSizeSelector = new _ListSelector2.default({
                menuCls: "paperSizeSelectorMenu",
                renderTo: this.paperSizeSelectorContainer,
                value: printParameters.paperSize,
                listItems: [{
                    text: _messageResource2.default.getMessage("report.chart_pdf_preview.paper_size.letter"),
                    value: _constants.PaperSize.LETTER
                }, {
                    text: _messageResource2.default.getMessage("report.chart_pdf_preview.paper_size.a4"),
                    value: _constants.PaperSize.A4
                }]
            });
            this.paperSizeSelector.on("change", this.changesCallback);

            if (printParameters.paperOrientation == _constants.PaperOrientation.PORTRAIT) this.portraitOrientationRadio.checked = true;else this.landscapeOrientationRadio.checked = true;

            this.showHeaderOnEachPageCheckbox.checked = printParameters.showHeaderOnEachPage;
            this.showLogoInHeaderCheckbox.checked = printParameters.showLogoInHeader;
        }
    }, {
        key: "subscribeToEvents",
        value: function subscribeToEvents() {
            var $store = (0, _jquery2.default)(this.getStore());
            var self = this;
            $store.on("printParametersForSaveChange", function () {
                self.update();
            });
            $store.on("printNumberOfPagesChange", function () {
                self.updateNumberOfPagesInformation();
            });
        }
    }, {
        key: "unsubscribeFromEvents",
        value: function unsubscribeFromEvents() {
            (0, _jquery2.default)(this.getStore()).off("printParametersForSaveChange").off("printNumberOfPagesChange");
        }
    }, {
        key: "templateModel",
        value: function templateModel() {
            return { id: this.lightboxId };
        }
    }, {
        key: "messageKeys",
        value: function messageKeys() {
            return {
                "pageSetupLabel": "report.chart_pdf_preview.page_setup",
                "paperSizeLabel": "report.chart_pdf_preview.paper_size",
                "orientationLabel": "report.chart_pdf_preview.orientation",
                "orientationPortraitLabel": "report.chart_pdf_preview.orientation.portrait",
                "orientationLandscapeLabel": "report.chart_pdf_preview.orientation.landscape",
                "showHeaderLabel": "report.chart_pdf_preview.show_header_each_page",
                "showLogoLabel": "report.chart_pdf_preview.show_logo",
                "pagesNumberLabel": "report.chart_pdf_preview.pages_number",
                "updatePreviewButtonLabel": "report.chart_pdf_preview.updatePreviewButton.caption",
                "loadingPreviewLabel": "report.chart_pdf_preview.loading_preview"
            };
        }
    }, {
        key: "getStore",
        value: function getStore() {
            // Abstract
        }
    }, {
        key: "getCustomSettingsSectionContainer",
        value: function getCustomSettingsSectionContainer() {
            return this.find(".customSettingsSectionContainer");
        }
    }, {
        key: "initPaperSizeSelector",
        value: function initPaperSizeSelector() {
            this.paperSizeSelectorContainer = document.getElementById(this.lightboxId + "_paperSizeSelector");
        }
    }, {
        key: "initPaperOrientationRadio",
        value: function initPaperOrientationRadio() {
            this.portraitOrientationRadio = document.getElementById(this.lightboxId + "_portrait");
            this.landscapeOrientationRadio = document.getElementById(this.lightboxId + "_landscape");
            var radioGroupName = this.lightboxId + "_pageOrientation";
            (0, _jquery2.default)("input[type=radio][name=" + radioGroupName + "]").off().change(this.changesCallback);
        }
    }, {
        key: "initHeaderCheckboxes",
        value: function initHeaderCheckboxes() {
            this.showHeaderOnEachPageCheckbox = document.getElementById(this.lightboxId + "_headerOnEachPage");
            this.showHeaderOnEachPageCheckbox.onchange = this.changesCallback;
            this.showLogoInHeaderCheckbox = document.getElementById(this.lightboxId + "_logoInHeader");
            this.showLogoInHeaderCheckbox.onchange = this.changesCallback;
        }
    }, {
        key: "handleParameterChange",
        value: function handleParameterChange() {
            if (!this.parametersChanged) {
                this.parametersChanged = true;
                this.enableUpdatePreviewButton();
            }

            this.triggerIntermediatePrintParametersChange(this.collectPrintParametersForGenerate());
        }
    }, {
        key: "_getPaperOrientationParameter",
        value: function _getPaperOrientationParameter() {
            return this.portraitOrientationRadio.checked ? _constants.PaperOrientation.PORTRAIT : _constants.PaperOrientation.LANDSCAPE;
        }
    }, {
        key: "_getPaperSizeParameter",
        value: function _getPaperSizeParameter() {
            return this.paperSizeSelector.getSelectedItem().value;
        }
    }, {
        key: "collectPrintParametersForGenerate",
        value: function collectPrintParametersForGenerate() {
            return {
                paperSize: this._getPaperSizeParameter(),
                paperOrientation: this._getPaperOrientationParameter(),
                showHeaderOnEachPage: this.showHeaderOnEachPageCheckbox.checked,
                showLogoInHeader: this.showLogoInHeaderCheckbox.checked
            };
        }
    }, {
        key: "collectPrintParametersForSave",
        value: function collectPrintParametersForSave() {
            return {
                paperSize: this._getPaperSizeParameter(),
                showHeaderOnEachPage: this.showHeaderOnEachPageCheckbox.checked,
                showLogoInHeader: this.showLogoInHeaderCheckbox.checked,
                paperOrientation: this._getPaperOrientationParameter()
            };
        }
    }, {
        key: "disableUpdatePreviewButton",
        value: function disableUpdatePreviewButton() {
            this.updatePreviewBtnEnabled = false;
            this.updatePreviewButton.addClass("disabled");
        }
    }, {
        key: "enableUpdatePreviewButton",
        value: function enableUpdatePreviewButton() {
            this.updatePreviewBtnEnabled = true;
            this.updatePreviewButton.removeClass("disabled");
        }
    }, {
        key: "onUpdatePreviewButtonClicked",
        value: function onUpdatePreviewButtonClicked() {
            if (this.updatePreviewBtnEnabled) {
                this.unsubscribeFromEvents();
                this.triggerPrintParametersForSaveChange(this.collectPrintParametersForSave());
                this.subscribeToEvents();

                this.triggerPrintParametersForGenerateChange(this.collectPrintParametersForGenerate());
            }
        }
    }, {
        key: "triggerIntermediatePrintParametersChange",
        value: function triggerIntermediatePrintParametersChange(newPrintParameters) {
            // Abstract
        }
    }, {
        key: "triggerPrintParametersForSaveChange",
        value: function triggerPrintParametersForSaveChange(printParametersForSave) {
            // Abstract
        }
    }, {
        key: "triggerPrintParametersForGenerateChange",
        value: function triggerPrintParametersForGenerateChange(printParametersForGenerate) {
            // Empty by default
        }
    }, {
        key: "beforePreviewUpdate",
        value: function beforePreviewUpdate() {
            this.disableUpdatePreviewButton();
            this.parametersChanged = false;
        }
    }, {
        key: "updateNumberOfPagesInformation",
        value: function updateNumberOfPagesInformation() {
            this.numberOfPagesContainer.text(this.getStore().getPrintNumberOfPages());
        }
    }]);

    return PDFSettingsPreview;
}(_TemplateView3.default);

exports.default = PDFSettingsPreview;

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var ReportChartsStore = {
    printNumberOfPages: null,
    printParametersForSave: null,

    getPrintParametersForSave: function getPrintParametersForSave() {
        return this.printParametersForSave;
    },

    setPrintParametersForSave: function setPrintParametersForSave(printParametersForSave) {
        this.printParametersForSave = printParametersForSave;
        $(this).trigger("printParametersForSaveChange");
    },

    getPrintNumberOfPages: function getPrintNumberOfPages() {
        return this.printNumberOfPages;
    },

    setPrintNumberOfPages: function setPrintNumberOfPages(printNumberOfPages) {
        this.printNumberOfPages = printNumberOfPages;
        $(this).trigger("printNumberOfPagesChange");
    }
};

exports.default = ReportChartsStore;

/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _LockTableRow2 = __webpack_require__(309);

var _LockTableRow3 = _interopRequireDefault(_LockTableRow2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DetailsRow = function (_LockTableRow) {
    _inherits(DetailsRow, _LockTableRow);

    function DetailsRow() {
        _classCallCheck(this, DetailsRow);

        var _this = _possibleConstructorReturn(this, (DetailsRow.__proto__ || Object.getPrototypeOf(DetailsRow)).call(this));

        _this.parentRow = null;
        return _this;
    }

    _createClass(DetailsRow, [{
        key: "setParentRow",
        value: function setParentRow(parentRow) {
            this.parentRow = parentRow;
        }
    }, {
        key: "getParentRow",
        value: function getParentRow() {
            return this.parentRow;
        }
    }, {
        key: "accept",
        value: function accept(visitor, cell) {
            return visitor.visitDetailsRow(cell);
        }
    }, {
        key: "isFirstChildRow",
        value: function isFirstChildRow() {
            return this.getParentRow().getChildRows()[0].getRowIdx() == this.getRowIdx();
        }
    }, {
        key: "isLastChildRow",
        value: function isLastChildRow() {
            var childRows = this.getParentRow().getChildRows();
            return childRows[childRows.length - 1].getRowIdx() == this.getRowIdx();
        }
    }]);

    return DetailsRow;
}(_LockTableRow3.default);

exports.default = DetailsRow;

/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _LockTableRow2 = __webpack_require__(309);

var _LockTableRow3 = _interopRequireDefault(_LockTableRow2);

var _InactiveCellRenderer = __webpack_require__(384);

var _InactiveCellRenderer2 = _interopRequireDefault(_InactiveCellRenderer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InactiveRow = function (_LockTableRow) {
    _inherits(InactiveRow, _LockTableRow);

    function InactiveRow() {
        _classCallCheck(this, InactiveRow);

        var _this = _possibleConstructorReturn(this, (InactiveRow.__proto__ || Object.getPrototypeOf(InactiveRow)).call(this));

        _this.groupCell = document.createElement("td");
        _this.groupCell.innerHTML = "&nbsp;";
        _this.getRowEl().appendChild(_this.groupCell);

        _this.inactiveRenderer = new _InactiveCellRenderer2.default();
        return _this;
    }

    _createClass(InactiveRow, [{
        key: "createRowHeaderRenderer",
        value: function createRowHeaderRenderer() {
            return this.inactiveRenderer;
        }
    }, {
        key: "createLockCellRenderer",
        value: function createLockCellRenderer() {
            return this.inactiveRenderer;
        }
    }, {
        key: "accept",
        value: function accept(visitor, cell) {
            return visitor.visitInactiveRow(cell);
        }
    }]);

    return InactiveRow;
}(_LockTableRow3.default);

exports.default = InactiveRow;

/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _DateRange = __webpack_require__(304);

var _DateRange2 = _interopRequireDefault(_DateRange);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var BaseSelectionType = function () {
    function BaseSelectionType() {
        _classCallCheck(this, BaseSelectionType);
    }

    _createClass(BaseSelectionType, [{
        key: "accept",
        value: function accept(visitor, selectedRegion) {
            //should be implemented in inheritors
        }
    }, {
        key: "getSelectedData",
        value: function getSelectedData(lockTable, selectedRegion) {
            //should be implemented in inheritors
        }
    }, {
        key: "canBeLocked",
        value: function canBeLocked(lockTable, selectedRegion) {
            //should be implemented in inheritors
        }
    }, {
        key: "canBeUnlocked",
        value: function canBeUnlocked(lockTable, selectedRegion) {
            //should be implemented in inheritors
        }
    }, {
        key: "getSelectionDateRange",
        value: function getSelectionDateRange(datesRow, selectedRegion) {
            var dateFrom = datesRow.getCell(selectedRegion.colMin).getValue().date;
            var dateTo = datesRow.getCell(selectedRegion.colMax).getValue().date;
            return new _DateRange2.default(dateFrom, dateTo);
        }
    }]);

    return BaseSelectionType;
}();

exports.default = BaseSelectionType;

/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SelectedData = function SelectedData(dateRange, userIds) {
    _classCallCheck(this, SelectedData);

    this.dateRange = dateRange;
    this.userIds = userIds;
};

exports.default = SelectedData;

/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TableRegionChangeEvent = function TableRegionChangeEvent(oldValue, newValue) {
    _classCallCheck(this, TableRegionChangeEvent);

    this.oldValue = oldValue;
    this.newValue = newValue;
};

exports.default = TableRegionChangeEvent;

/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TableMouseEventsHandler = function () {
    function TableMouseEventsHandler(table, selectionController, hoverController) {
        _classCallCheck(this, TableMouseEventsHandler);

        this.table = table;
        this.selectionController = selectionController;
        this.hoverController = hoverController;
        this.selectionAnchor = null;
        this.mouseIsDown = false;
    }

    _createClass(TableMouseEventsHandler, [{
        key: "mouseOver",
        value: function mouseOver(evt, cell) {
            if (this.mouseIsDown) this.selectionController.changeSelectionTo(cell);else this.hoverController.hover(cell, cell);
        }
    }, {
        key: "mouseOut",
        value: function mouseOut(evt, cell) {
            if (!this.mouseIsDown) this.hoverController.unhover();
        }
    }, {
        key: "mouseDown",
        value: function mouseDown(evt, cell) {
            this.mouseIsDown = true;
            this.selectionController.clearSelection();
            this.selectionController.setSelectionAnchor(cell);
            this.selectionController.changeSelectionTo(cell);
        }
    }, {
        key: "mouseUp",
        value: function mouseUp(evt, cell) {
            this.mouseIsDown = false;
        }
    }, {
        key: "mouseMove",
        value: function mouseMove(evt, cell) {
            // nothing to do
        }
    }, {
        key: "contextMenu",
        value: function contextMenu(evt, cell) {
            // nothing
        }
    }, {
        key: "getSelectionController",
        value: function getSelectionController() {
            return this.selectionController;
        }
    }, {
        key: "getHoverController",
        value: function getHoverController() {
            return this.hoverController;
        }
    }]);

    return TableMouseEventsHandler;
}();

exports.default = TableMouseEventsHandler;

/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var LockTTStore = function () {
    function LockTTStore() {
        _classCallCheck(this, LockTTStore);

        this.dateRangeConfig = null;
        this.usersSelectorConfig = null;
        this.features = null;
        this.pagerConfig = null;
        this.lockedTillDate = null;
        this.selectionVeilImages = null;
        this.usersForSelector = null;
        this.timeZoneForSelector = null;
        this.usersGroupsForSelector = null;
        this.dateFormat = null;
        this.sortingOrder = null;
        this.timestamp = null;
        this.lockTableImagesLoaded = false;
        this.allLockedTillDateBeyondDateRange = null;
        this.deletedUsers = null;
        this.users = null;
        this.weekStartDay = null;
        this.loggedInUserToday = null;
        this.headerData = null;
        this.disabledUsersSelected = null;
        this.months = null;
        this.userDataGroups = null;
        this.userGroupFeature = false;
        this.timeZoneGroupFeature = false;
        this.calendarConfig = {
            invertedDaysDateMap: null,
            defaultUserSchedule: []
        };
        this.hideDetailsOnLockTT = false;
    }

    _createClass(LockTTStore, [{
        key: "setDateRangeConfig",
        value: function setDateRangeConfig(config) {
            this.dateRangeConfig = config;
        }
    }, {
        key: "getDateRangeConfig",
        value: function getDateRangeConfig() {
            return this.dateRangeConfig;
        }
    }, {
        key: "setUsersSelectorConfig",
        value: function setUsersSelectorConfig(config) {
            this.usersSelectorConfig = config;
        }
    }, {
        key: "getUsersSelectorConfig",
        value: function getUsersSelectorConfig() {
            return this.usersSelectorConfig;
        }
    }, {
        key: "setEnabledFeatures",
        value: function setEnabledFeatures(features) {
            this.features = features;
        }
    }, {
        key: "getEnabledFeatures",
        value: function getEnabledFeatures() {
            return this.features;
        }
    }, {
        key: "setPagerConfig",
        value: function setPagerConfig(config) {
            this.pagerConfig = config;
        }
    }, {
        key: "getPagerConfig",
        value: function getPagerConfig() {
            return this.pagerConfig;
        }
    }, {
        key: "setLockedTillDate",
        value: function setLockedTillDate(lockedTillDate) {
            this.lockedTillDate = lockedTillDate;
        }
    }, {
        key: "getLockedTillDate",
        value: function getLockedTillDate() {
            return this.lockedTillDate;
        }
    }, {
        key: "setSelectionVeilImages",
        value: function setSelectionVeilImages(selectionVeilImages) {
            this.selectionVeilImages = selectionVeilImages;
        }
    }, {
        key: "getSelectionVeilImages",
        value: function getSelectionVeilImages() {
            return this.selectionVeilImages;
        }
    }, {
        key: "setUsersForSelector",
        value: function setUsersForSelector(users) {
            this.usersForSelector = users;
        }
    }, {
        key: "getUsersForSelector",
        value: function getUsersForSelector() {
            return this.usersForSelector;
        }
    }, {
        key: "setTimeZonesForSelector",
        value: function setTimeZonesForSelector(timezones) {
            this.timeZoneForSelector = timezones;
        }
    }, {
        key: "getTimeZonesForSelector",
        value: function getTimeZonesForSelector() {
            return this.timeZoneForSelector;
        }
    }, {
        key: "setUsersGroupsForSelector",
        value: function setUsersGroupsForSelector(usersGroups) {
            this.usersGroupsForSelector = usersGroups;
        }
    }, {
        key: "getUsersGroupsForSelector",
        value: function getUsersGroupsForSelector() {
            return this.usersGroupsForSelector;
        }
    }, {
        key: "getDateFormat",
        value: function getDateFormat() {
            return this.dateFormat;
        }
    }, {
        key: "setDateFormat",
        value: function setDateFormat(dateFormat) {
            this.dateFormat = dateFormat;
        }
    }, {
        key: "getSortingOrder",
        value: function getSortingOrder() {
            return this.sortingOrder;
        }
    }, {
        key: "setSortingOrder",
        value: function setSortingOrder(sortingOrder) {
            this.sortingOrder = sortingOrder;
        }
    }, {
        key: "setTimestamp",
        value: function setTimestamp(timestamp) {
            this.timestamp = timestamp;
        }
    }, {
        key: "getTimestamp",
        value: function getTimestamp() {
            return this.timestamp;
        }
    }, {
        key: "setLockTableImagesLoaded",
        value: function setLockTableImagesLoaded(lockTableImagesLoaded) {
            this.lockTableImagesLoaded = lockTableImagesLoaded;
        }
    }, {
        key: "isLockTableImagesLoaded",
        value: function isLockTableImagesLoaded() {
            return this.lockTableImagesLoaded;
        }
    }, {
        key: "setAllLockedTillDateBeyondDateRange",
        value: function setAllLockedTillDateBeyondDateRange(allLockedTillDateBeyondDateRange) {
            this.allLockedTillDateBeyondDateRange = allLockedTillDateBeyondDateRange;
        }
    }, {
        key: "getAllLockedTillDateBeyondDateRange",
        value: function getAllLockedTillDateBeyondDateRange() {
            return this.allLockedTillDateBeyondDateRange;
        }
    }, {
        key: "setDeletedUsers",
        value: function setDeletedUsers(deletedUsers) {
            this.deletedUsers = deletedUsers;
        }
    }, {
        key: "getDeletedUsers",
        value: function getDeletedUsers() {
            return this.deletedUsers;
        }
    }, {
        key: "setUsers",
        value: function setUsers(users) {
            this.users = users;
        }
    }, {
        key: "getUsers",
        value: function getUsers() {
            return this.users;
        }
    }, {
        key: "setWeekStartDay",
        value: function setWeekStartDay(weekStartDay) {
            this.weekStartDay = weekStartDay;
        }
    }, {
        key: "getWeekStartDay",
        value: function getWeekStartDay() {
            return this.weekStartDay;
        }
    }, {
        key: "setLoggedInUserToday",
        value: function setLoggedInUserToday(loggedInUserToday) {
            this.loggedInUserToday = loggedInUserToday;
        }
    }, {
        key: "getLoggedInUserToday",
        value: function getLoggedInUserToday() {
            return this.loggedInUserToday;
        }
    }, {
        key: "setHeaderData",
        value: function setHeaderData(headerData) {
            this.headerData = headerData;
        }
    }, {
        key: "getHeaderData",
        value: function getHeaderData() {
            return this.headerData;
        }
    }, {
        key: "setDisabledUsersSelected",
        value: function setDisabledUsersSelected(disabledUsersSelected) {
            this.disabledUsersSelected = disabledUsersSelected;
        }
    }, {
        key: "getDisabledUsersSelected",
        value: function getDisabledUsersSelected() {
            return this.disabledUsersSelected;
        }
    }, {
        key: "setMonths",
        value: function setMonths(months) {
            this.months = months;
        }
    }, {
        key: "getMonths",
        value: function getMonths() {
            return this.months;
        }
    }, {
        key: "setUserDataGroups",
        value: function setUserDataGroups(userDataGroups) {
            this.userDataGroups = userDataGroups;
        }
    }, {
        key: "getUserDataGroups",
        value: function getUserDataGroups() {
            return this.userDataGroups;
        }
    }, {
        key: "setFeaturesForSelector",
        value: function setFeaturesForSelector(userGroupFeature, timeZoneGroupFeature) {
            this.userGroupFeature = userGroupFeature;
            this.timeZoneGroupFeature = timeZoneGroupFeature;
        }
    }, {
        key: "getUserGroupFeatureForSelector",
        value: function getUserGroupFeatureForSelector() {
            return this.userGroupFeature;
        }
    }, {
        key: "getTimeZoneGroupFeatureForSelector",
        value: function getTimeZoneGroupFeatureForSelector() {
            return this.timeZoneGroupFeature;
        }
    }, {
        key: "setCalendarConfig",
        value: function setCalendarConfig(config) {
            this.calendarConfig = config;
        }
    }, {
        key: "getCalendarConfig",
        value: function getCalendarConfig() {
            return this.calendarConfig;
        }
    }, {
        key: "setHideDetailsOnLockTT",
        value: function setHideDetailsOnLockTT(hideDetailsOnLockTT) {
            this.hideDetailsOnLockTT = hideDetailsOnLockTT;
        }
    }, {
        key: "isHideDetailsOnLockTT",
        value: function isHideDetailsOnLockTT() {
            return this.hideDetailsOnLockTT;
        }
    }]);

    return LockTTStore;
}();

exports.default = new LockTTStore();

/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = GroupController;

var _group_management_util = __webpack_require__(386);

var _group_management_util2 = _interopRequireDefault(_group_management_util);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _rpc_control_manager = __webpack_require__(235);

var _rpc_control_manager2 = _interopRequireDefault(_rpc_control_manager);

var _GroupValidatorStrategy = __webpack_require__(186);

var _atUtils = __webpack_require__(5);

var _atBrowserUtils = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Controls all operations with groups in group management lightbox
 */
function GroupController() {}

/**
 * @param config.topGroupNameLabel group name label over user container
 * @param config.deletedNowGroupClassName class name for group row in deleted in process state(ajax request processed now)
 * @param config.editedNowGroupClassName class name for group row in edited in process state(ajax request processed now)
 * @param config.movedInNowGroupClassName class name for group row in moved users into in process state(ajax request processed now)
 * @param config.editedClassName class name for group row in edited state
 * @param config.confirmDeleteClassName class name for group row in confirm delete state
 * @param config.errorTextClassName class name for groups duplicated on server
 * @param config.groupDivIdPrefix dom id prefix for group row
 * @param config.groupDeleteLinkIdPrefix dom id prefix for group delete button
 * @param config.undoDeleteIdPrefix dom id prefix for group undo delete button
 * @param config.acceptDeleteIdPrefix dom id prefix for group accept delete button
 * @param config.undoEditIdPrefix dom id prefix for group undo edit button
 * @param config.acceptEditIdPrefix dom id prefix for group accept edit button
 * @param config.editInputIdPrefix dom id prefix for group edit input field
 * @param config.nameCellIdPrefix dom id prefix for cell with group name
 * @param config.inputCellIdPrefix dom id prefix for cell with edit group input field
 * @param config.editGroupCellIdPrefix dom id prefix for cell for edited group table
 * @param config.waitingAnimationCellIdPrefix  dom id prefix for cell with waiting ajax animation
 * @param config.spinnerContainerIdPrefix  dom id prefix for spinner container
 */
GroupController.prototype.init = function (config) {
    this.topGroupNameLabel = config.topGroupNameLabel;
    this.deletedNowGroupClassName = config.deletedNowGroupClassName;
    this.editedNowGroupClassName = config.editedNowGroupClassName;
    this.movedInNowGroupClassName = config.movedInNowGroupClassName;
    this.editedClassName = config.editedClassName;
    this.confirmDeleteClassName = config.confirmDeleteClassName;
    this.errorTextClassName = config.errorTextClassName;
    this.groupDivIdPrefix = config.groupDivIdPrefix;
    this.groupDeleteLinkIdPrefix = config.groupDeleteLinkIdPrefix;
    this.undoDeleteIdPrefix = config.undoDeleteIdPrefix;
    this.acceptDeleteIdPrefix = config.acceptDeleteIdPrefix;
    this.undoEditIdPrefix = config.undoEditIdPrefix;
    this.acceptEditIdPrefix = config.acceptEditIdPrefix;
    this.editInputIdPrefix = config.editInputIdPrefix;
    this.nameCellIdPrefix = config.nameCellIdPrefix;
    this.inputCellIdPrefix = config.inputCellIdPrefix;
    this.editGroupCellIdPrefix = config.editGroupCellIdPrefix;
    this.waitingAnimationCellIdPrefix = config.waitingAnimationCellIdPrefix;
    this.spinnerContainerIdPrefix = config.spinnerContainerIdPrefix;
    this.spinnerController = config.spinnerController;
    this.selectedGroup = null;
    this.editedGroup = null;
    this.confirmDeleteGroup = null;
    this.markedAsDuplicateGroups = new Array();

    this.groupNamingKey = config.groupNamingKey;
    this.GroupNamingKey = config.GroupNamingKey;

    return this;
};

/**
 * Init controller
 * @param data array of GroupWithUsers instances
 * @param controller user group management controller
 */
GroupController.prototype.initGroups = function (data, controller) {
    this.cleanup();
    this.groups = {};
    for (var i = 0; i < data.length; i++) {
        this.groups[data[i].id] = this.createGroupRow(data[i], controller);
        controller.getDDController().makeDDWrapperForGroup(document.getElementById(formatId(this.groupDivIdPrefix, data[i].id)));
    }
    if (this.selectedGroup != null) {
        if (!this.groups[this.selectedGroup.id]) {
            this.selectedGroup = null;
        }
    }
};

GroupController.prototype.createGroupRow = function (group, controller) {
    return new GroupRow().init(document.getElementById(formatId(this.groupDivIdPrefix, group.id)), document.getElementById(formatId(this.groupDeleteLinkIdPrefix, group.id)), document.getElementById(formatId(this.undoDeleteIdPrefix, group.id)), document.getElementById(formatId(this.acceptDeleteIdPrefix, group.id)), document.getElementById(formatId(this.undoEditIdPrefix, group.id)), document.getElementById(formatId(this.acceptEditIdPrefix, group.id)), document.getElementById(formatId(this.editInputIdPrefix, group.id)), document.getElementById(formatId(this.nameCellIdPrefix, group.id)), document.getElementById(formatId(this.inputCellIdPrefix, group.id)), document.getElementById(formatId(this.editGroupCellIdPrefix, group.id)), document.getElementById(formatId(this.waitingAnimationCellIdPrefix, group.id)), group, new _GroupValidatorStrategy.UserGroupValidatorStrategy(), controller);
};

/**
 * Handles user group selection
 * @param controller user group management controller
 * @param groupId id of user group intended for selection
 */
GroupController.prototype.groupSelected = function (controller, groupId) {
    var newSelectedGroup = this.groups[groupId];
    if (this.selectedGroup) {
        controller.getHighlightController().unhighlightSelectedGroup(this.selectedGroup);
    }
    controller.getHighlightController().highlightSelectedGroup(newSelectedGroup);
    this.changeTopGroupNameLabel(newSelectedGroup);
    this.selectedGroup = newSelectedGroup;
};

GroupController.prototype.highlightGroup = function (controller, groupId) {
    var groupToHighlight = this.groups[groupId];
    controller.getHighlightController().highlightHoveredGroup(groupToHighlight);
    setTimeout(function () {
        controller.getHighlightController().unhighlightHoveredGroup(groupToHighlight);
    }, 1500);
};

/**
 * Change name of selected user group over user container
 * @param group
 */
GroupController.prototype.changeTopGroupNameLabel = function (group) {
    this.topGroupNameLabel.innerHTML = "<span class='groupName'>" + (0, _atUtils.escapeHtmlSymbols)(group.name) + '</span><span>&nbsp;(' + group.countOfUserWithEnabledAccess() + ')</span>';
};

/**
 * Get object of all GroupRow instances by id
 */
GroupController.prototype.getGroups = function () {
    return this.groups;
};

/**
 * Get GroupRow instance by id
 * @param groupId id of user group
 */
GroupController.prototype.getGroup = function (groupId) {
    return this.groups[groupId];
};

/**
 * Defines is group suitable for drop in or not
 * @param groupId
 */
GroupController.prototype.isGroupSuitableForDrop = function (groupId) {
    return groupId != this.selectedGroup.id && (this.editedGroup == null || groupId != this.editedGroup.id);
};

/**
 * Get all GroupRow instances suitable for drop in
 */
GroupController.prototype.getGroupsSuitableForDrop = function () {
    var suitableGroups = new Array();
    for (var i in this.groups) {
        //noinspection JSUnfilteredForInLoop
        if (this.isGroupSuitableForDrop(this.groups[i].id)) {
            //noinspection JSUnfilteredForInLoop
            suitableGroups.push(this.groups[i]);
        }
    }
    return suitableGroups;
};

/**
 * Mark user group row as deleted in process state(ajax request processed now)
 * @param groupId id of user group
 */
GroupController.prototype.markGroupAsDeletedNow = function (groupId) {
    var group = this.groups[groupId];
    group.markAsAjaxProcessedNow(this.deletedNowGroupClassName);

    this.spinnerController.spin(formatId(this.spinnerContainerIdPrefix, group.id));
};

/**
 * Mark user group row as edited in process state(ajax request processed now)
 * @param groupId id of user group
 */
GroupController.prototype.markGroupAsEditedNow = function (groupId) {
    var group = this.groups[groupId];
    group.markAsAjaxProcessedNow(this.editedNowGroupClassName);

    this.spinnerController.spin(formatId(this.spinnerContainerIdPrefix, group.id));
};

/**
 * Mark user group row as moved users into in process state(ajax request processed now)
 * @param groupId id of user group
 */
GroupController.prototype.markGroupAsMovedInNow = function (groupId) {
    var group = this.groups[groupId];
    group.markAsAjaxProcessedNow(this.movedInNowGroupClassName);

    this.spinnerController.spin(formatId(this.spinnerContainerIdPrefix, group.id));
};

/**
 * Change user group row state into editing
 * @param group GroupRow instance
 */
GroupController.prototype.startGroupEditing = function (group) {
    (0, _atBrowserUtils.addClass)(group.div, this.editedClassName);
    group.disableRowForEditing();
    this.editedGroup = group;
    setFocusToEndOfInput(group.input);
};

GroupController.prototype.confirmGroupDelete = function (group) {
    (0, _atBrowserUtils.addClass)(group.div, this.confirmDeleteClassName);
    group.disableRow();
    group.focusAcceptDeleteButton();
    this.confirmDeleteGroup = group;
};

/**
 * Change user group row state from editing to normal.
 * Returns true if there is edited user group now and false otherwise
 */
GroupController.prototype.endGroupEditing = function () {
    if (this.editedGroup) {
        (0, _atBrowserUtils.removeClass)(this.editedGroup.div, this.editedClassName);
        this.editedGroup.enableRow();
        this.editedGroup.revertInputText();
        _group_management_util2.default.markCellAsValid(this.editedGroup.inputCell);
        this.editedGroup.input.blur();
        this.editedGroup = null;
        return true;
    }
    return false;
};

GroupController.prototype.endConfirmGroupDelete = function () {
    if (this.confirmDeleteGroup) {
        (0, _atBrowserUtils.removeClass)(this.confirmDeleteGroup.div, this.confirmDeleteClassName);
        this.confirmDeleteGroup.enableRow();
        this.confirmDeleteGroup = null;
        return true;
    }
    return false;
};

/**
 * Start saving of new user group name. Check emptiness and uniqueness. Repaint row if group name is empty or duplicate.
 * @param controller user group management controller
 * @param group GroupRow instance
 */
GroupController.prototype.startNewGroupNameSaving = function (controller, group) {
    var name = group.input.value;
    var title = null;
    var errorMessage = null;
    if (name.trim() == '') {
        title = _messageResource2.default.getMessage("group_management.error.empty_name.user_group", [_messageResource2.default.getEscapedMessage(this.groupNamingKey)]);
        errorMessage = _messageResource2.default.getMessage("group_management.client_side.empty_name.user_group", [_messageResource2.default.getEscapedMessage(this.groupNamingKey)]);
    } else if (this.isDuplicateName(name, group.id)) {
        title = _messageResource2.default.getMessage("group_management.error.duplicate_name.user_group", [_messageResource2.default.getMessage(this.GroupNamingKey)]);
        errorMessage = _messageResource2.default.getMessage("group_management.client_side.group_exists.user_group", [_messageResource2.default.getEscapedMessage(this.groupNamingKey)]);
    }
    if (title) {
        _group_management_util2.default.markCellAsInvalid(group.inputCell, title);
        setTimeout(function () {
            controller.showErrorMessage(errorMessage);
        }, 100);
    } else {
        (0, _atBrowserUtils.removeClass)(group.div, this.editedClassName);
        var manager = new GroupEditRPCManager(controller.getServiceName(), controller, this.getGroupData(group, name), this.groupNamingKey);
        _rpc_control_manager2.default.saveRpcControlBoundData(manager, false);
    }
};

/**
 * Check duplicate name of user group on client side
 * @param name new name intended for check
 * @param unverifiedId id of user group doesn't take place in checking for duplicate(optional)
 */
GroupController.prototype.isDuplicateName = function (name, unverifiedId) {
    var trimmedLowercaseName = name.trim().toLowerCase();
    for (var i in this.groups) {
        //noinspection JSUnfilteredForInLoop
        if (this.groups[i].name.trim().toLowerCase() == trimmedLowercaseName && (!unverifiedId || this.groups[i].id != unverifiedId)) {
            return true;
        }
    }
    return false;
};

/**
 * Paint duplicated on server groups as red
 * @param editedGroupId group, edited before error
 * @param duplicatedName name of user group, caused an error
 */
GroupController.prototype.paintDuplicateGroupsAsRed = function (editedGroupId, duplicatedName) {
    var firstGroup = this.groups[editedGroupId];
    if (firstGroup) {
        (0, _atBrowserUtils.addClass)(firstGroup.nameCell, this.errorTextClassName);
        this.markedAsDuplicateGroups.push(firstGroup);
    }
    var trimmedLowerCaseGroupName = duplicatedName.trim().toLowerCase();
    for (var i in this.groups) {
        //noinspection JSUnfilteredForInLoop
        if (trimmedLowerCaseGroupName == this.groups[i].name.trim().toLowerCase()) {
            //noinspection JSUnfilteredForInLoop
            (0, _atBrowserUtils.addClass)(this.groups[i].nameCell, this.errorTextClassName);
            //noinspection JSUnfilteredForInLoop
            this.markedAsDuplicateGroups.push(this.groups[i]);
            break;
        }
    }
    //Fix for Chrome bug. It doesn't change cursor from waiting state.
    document.body.style.cursor = "default";
};

/**
 * Paint user groups marked as duplicate as normal
 */
GroupController.prototype.paintDuplicateGroupsAsValid = function () {
    for (var i = 0; i < this.markedAsDuplicateGroups.length; i++) {
        (0, _atBrowserUtils.removeClass)(this.markedAsDuplicateGroups[i].nameCell, this.errorTextClassName);
    }
    this.markedAsDuplicateGroups = new Array();
};

/**
 * Clean edited user group. Don't clean selected user group because it is saved.
 */
GroupController.prototype.cleanup = function () {
    this.editedGroup = null;
};

/**
 * Get selected now GroupRow instance
 */
GroupController.prototype.getSelectedGroup = function () {
    return this.selectedGroup;
};

/**
 * Get edited now GroupRow instance. Returns null if no user group is edited now.
 */
GroupController.prototype.getEditedGroup = function () {
    return this.editedGroup;
};

GroupController.prototype.getGroupData = function (group, name) {
    return {
        id: group.id,
        name: name
    };
};

/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UserGroupsDisabledError = exports.UserGroupsDisabledError = function UserGroupsDisabledError() {
  _classCallCheck(this, UserGroupsDisabledError);
};

var NoRightsToManageAccountSettingsError = exports.NoRightsToManageAccountSettingsError = function NoRightsToManageAccountSettingsError() {
  _classCallCheck(this, NoRightsToManageAccountSettingsError);
};

var GroupExistsError = exports.GroupExistsError = function GroupExistsError() {
  _classCallCheck(this, GroupExistsError);
};

/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _FeatureDiffController = __webpack_require__(831);

var _features = __webpack_require__(22);

var _utils = __webpack_require__(6);

var _selectors = __webpack_require__(15);

var _redux = __webpack_require__(7);

var _actions = __webpack_require__(782);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TimeTrackPageFeatureDiffController = function (_FeatureDiffControlle) {
    _inherits(TimeTrackPageFeatureDiffController, _FeatureDiffControlle);

    function TimeTrackPageFeatureDiffController(_ref) {
        var _ref$handleFeatureCha = _ref.handleFeatureChange,
            handleFeatureChange = _ref$handleFeatureCha === undefined ? function () {} : _ref$handleFeatureCha;

        _classCallCheck(this, TimeTrackPageFeatureDiffController);

        return _possibleConstructorReturn(this, (TimeTrackPageFeatureDiffController.__proto__ || Object.getPrototypeOf(TimeTrackPageFeatureDiffController)).call(this, {
            handledFeatures: [_features.Feature.TWS],
            onFeaturesChanged: handleFeatureChange
        }));
    }

    return TimeTrackPageFeatureDiffController;
}(_FeatureDiffController.FeatureDiffController);

exports.default = (0, _utils.connect)(function (state) {
    return {
        features: (0, _selectors.selectFeatures)(state)
    };
}, function (dispatch) {
    return {
        handleFeatureChange: (0, _redux.bindActionCreators)(_actions.handleFeatureChange, dispatch)
    };
})(TimeTrackPageFeatureDiffController);

/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Link = function (_TemplateView) {
    _inherits(Link, _TemplateView);

    function Link(_ref) {
        var _ref$extraClass = _ref.extraClass,
            extraClass = _ref$extraClass === undefined ? '' : _ref$extraClass,
            text = _ref.text,
            _ref$reference = _ref.reference,
            reference = _ref$reference === undefined ? '' : _ref$reference,
            _ref$onClickCallback = _ref.onClickCallback,
            onClickCallback = _ref$onClickCallback === undefined ? function () {} : _ref$onClickCallback,
            _ref$dark = _ref.dark,
            dark = _ref$dark === undefined ? false : _ref$dark;

        _classCallCheck(this, Link);

        var _this = _possibleConstructorReturn(this, (Link.__proto__ || Object.getPrototypeOf(Link)).call(this));

        _this.text = text;
        _this.extraClass = extraClass;
        _this.reference = reference;
        _this.dark = dark;
        _this.onClickCallback = onClickCallback;
        return _this;
    }

    _createClass(Link, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<a href=\'<%=reference%>\'\n                    class=\'components_link <%=extraClass%> <% if (dark) { %>dark<% } %>\'\n                    target=\'_blank\'\n                >\n                    <span><%=text%></span>\n                    <span class=\'linkIcon\'/>\n                </a>';
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            var _this2 = this;

            this.getEl().click(function () {
                return _this2.onClickCallback();
            });
        }
    }]);

    return Link;
}(_TemplateView3.default);

exports.default = Link;

/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.mergeCustomersProjectsFromRPC = mergeCustomersProjectsFromRPC;
exports.mergeCustomersProjectsFromJSP = mergeCustomersProjectsFromJSP;
exports.replaceTypesOfWorkFromRPC = replaceTypesOfWorkFromRPC;
exports.replaceUsersFromJSP = replaceUsersFromJSP;
exports.replaceUserGroupsFromJSP = replaceUserGroupsFromJSP;
exports.replaceTimeZoneGroupsFromJSP = replaceTimeZoneGroupsFromJSP;

var _UserWithAccessRights = __webpack_require__(138);

var _UserWithAccessRights2 = _interopRequireDefault(_UserWithAccessRights);

var _BillingType = __webpack_require__(721);

var _BillingType2 = _interopRequireDefault(_BillingType);

var _CustomerStore = __webpack_require__(65);

var _CustomerStore2 = _interopRequireDefault(_CustomerStore);

var _ProjectStore = __webpack_require__(59);

var _ProjectStore2 = _interopRequireDefault(_ProjectStore);

var _BillingTypeStore = __webpack_require__(720);

var _BillingTypeStore2 = _interopRequireDefault(_BillingTypeStore);

var _userStore = __webpack_require__(460);

var _userStore2 = _interopRequireDefault(_userStore);

var _userGroupStore = __webpack_require__(1559);

var _userGroupStore2 = _interopRequireDefault(_userGroupStore);

var _timeZoneGroupStore = __webpack_require__(1560);

var _timeZoneGroupStore2 = _interopRequireDefault(_timeZoneGroupStore);

var _Group = __webpack_require__(158);

var _Group2 = _interopRequireDefault(_Group);

var _atUtils = __webpack_require__(5);

var _utils = __webpack_require__(192);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mergeCustomersProjectsFromRPC(customers, projects, newCustomersFirst) {
    // sort data before insert into store
    var sortedCustomers = customers.map(_utils.customerFromRpc).sort(_atUtils.nameComparator);
    var sortedProjects = projects.map(_utils.projectFromRpc).sort(_atUtils.nameComparator);

    if (newCustomersFirst) {
        _CustomerStore2.default.addManyFirst(sortedCustomers);
    } else {
        _CustomerStore2.default.mergeAll(sortedCustomers);
    }

    _ProjectStore2.default.mergeAll(sortedProjects);
}

function mergeCustomersProjectsFromJSP(data) {
    // sort data before insert into store
    _CustomerStore2.default.mergeAll(data["customers"].map(_utils.customerFromRpc).sort(_atUtils.nameComparator));
    _ProjectStore2.default.mergeAll(data["projects"].map(_utils.projectFromRpc).sort(_atUtils.nameComparator));
}

function replaceTypesOfWorkFromRPC(typesOfWork) {
    _BillingTypeStore2.default.replaceAll(typesOfWork.map(_BillingType2.default.fromRPC));
}

function replaceUsersFromJSP(data) {
    _userStore2.default.replaceAll(data.map(_UserWithAccessRights2.default.fromRPC));
}

function replaceUserGroupsFromJSP(data) {
    _userGroupStore2.default.replaceAll(data.map(function (d) {
        return new _Group2.default(d["id"], d["name"]);
    }));
}

function replaceTimeZoneGroupsFromJSP(data) {
    _timeZoneGroupStore2.default.replaceAll(data.map(function (d) {
        return new _Group2.default(d["id"], d["name"]);
    }));
}

/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Controller containing operations with properties of the {@link AT.SelectorTreeNode}
 */
var GenericSelectorTreePropertiesController = function GenericSelectorTreePropertiesController() {};

GenericSelectorTreePropertiesController.prototype = {
    /**
     * @see AT.SelectorTreeNode#selectedProperty
     */
    selectedProperty: "selected",

    isSelected: function isSelected(item) {
        return item[this.selectedProperty];
    },

    setSelected: function setSelected(item, isSelected) {
        item[this.selectedProperty] = isSelected;
    },

    /**
     * @see AT.SelectorTreeNode#activeProperty
     */
    activeProperty: "active",

    isActive: function isActive(item) {
        return item[this.activeProperty];
    },

    /**
     * @see AT.SelectorTreeNode#hiddenProperty
     */
    hiddenProperty: "hidden",

    isHidden: function isHidden(item) {
        return item[this.hiddenProperty];
    },

    hiddenInitProperty: "hiddenInit",

    setHiddenInit: function setHiddenInit(item, isHiddenInit) {
        item[this.hiddenInitProperty] = isHiddenInit;
    },

    isHiddenInit: function isHiddenInit(item) {
        return item[this.hiddenInitProperty];
    },

    /**
     * Item name property name.
     */
    nameProperty: "name",

    getName: function getName(item) {
        return item[this.nameProperty];
    },

    /**
     * Item full name property name.
     */
    fullNameProperty: "fullName",

    getFullName: function getFullName(item) {
        return item[this.fullNameProperty];
    },

    /**
     * Item's email property name
     */
    emailProperty: "email",

    getEmail: function getEmail(item) {
        return item[this.emailProperty];
    },

    inactiveSuffixKey: "common.archived",

    getInactiveSuffixMessage: function getInactiveSuffixMessage() {
        return _messageResource2.default.getMessage(this.inactiveSuffixKey);
    },

    selectedInitProperty: "selectedInit",

    setSelectedInit: function setSelectedInit(item, isSelectedInit) {
        item[this.selectedInitProperty] = isSelectedInit;
    },

    isSelectedInit: function isSelectedInit(item) {
        return item[this.selectedInitProperty];
    }
};

exports.default = GenericSelectorTreePropertiesController;

/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Ext = __webpack_require__(12);

var _Ext2 = _interopRequireDefault(_Ext);

var _at_selector_tree = __webpack_require__(835);

var _at_selector_tree2 = _interopRequireDefault(_at_selector_tree);

var _at_selector_tree_checkbox = __webpack_require__(534);

var _at_selector_tree_checkbox2 = _interopRequireDefault(_at_selector_tree_checkbox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Abstract selector tree for a simple list of items.
 *
 * Depends on:
 * <code>/js/controls/dateControls/at_selector_tree.js</code>
 * <code>/js/controls/selectorControls/at_selector_tree_checkbox.js</code>
 * <code>/js/message_resources.js</code> with prefix "common"
 */
var SimpleListSelectorTree = _Ext2.default.extend(_at_selector_tree2.default, {

    initComponent: function initComponent() {
        SimpleListSelectorTree.superclass.initComponent.call(this);

        this.setInitialSelectionFromCurrent();
    },

    getNameWithStatus: function getNameWithStatus(item) {
        return this.nodeHelper.getNameWithStatus(item);
    },

    getFullNameWithStatus: function getFullNameWithStatus(item) {
        return this.nodeHelper.getFullNameWithStatus(item);
    },

    isActiveItem: function isActiveItem(item) {
        return this.nodeHelper.isActive(item);
    },

    getItemStyleClass: function getItemStyleClass(item) {
        return this.nodeHelper.getStyleClass(item);
    },

    createNodes: function createNodes() {
        var nodes = [];
        _Ext2.default.each(this.data, function (item) {
            var node = new _at_selector_tree_checkbox2.default({
                item: item,
                label: this.getNameWithStatus(item)
            });
            nodes.push(node);
            node.on("change", this.onChange, this);
        }, this);

        return nodes;
    },

    /**
     * @see {AT.SelectorTree}
     */
    resetNodes: function resetNodes() {
        this.cascade(function (node) {
            if (node.item) {
                node.doSelect(this.propertiesController.isSelectedInit(node.item));
            }
        }, this);
    },

    isSelectionChanged: function isSelectionChanged(selectHidden) {
        var selectionChanged = false;
        //If function inside cascade returns false, it immediately stop.
        this.cascade(function (node) {
            if (node.item) {
                var wasSelected = this.propertiesController.isSelectedInit(node.item);
                var isSelectedNow = this.propertiesController.isSelected(node.item);
                var wasVisibleButBecomeHidden = !selectHidden && this.propertiesController.isHidden(node.item);
                if (wasSelected !== isSelectedNow || wasSelected && wasVisibleButBecomeHidden) {
                    selectionChanged = true;
                    return false;
                }
            }
        }, this);
        return selectionChanged;
    },

    /**
     * @see {AT.SelectorTree}
     */
    getSelection: function getSelection(selectHidden) {
        var selection = [];
        _Ext2.default.each(this.data, function (entry) {
            if (this.propertiesController.isSelected(entry) && (selectHidden || !this.propertiesController.isHidden(entry))) {
                selection.push(entry);
            }
        }, this);
        return selection;
    },

    /**
     * Return the selection with all items
     */
    getAllItems: function getAllItems() {
        var selection = [];
        _Ext2.default.each(this.data, function (entry) {
            selection.push(entry);
        }, this);
        return selection;
    },

    /**
     * Replaces stored initial selection with the current one.
     */
    setInitialSelectionFromCurrent: function setInitialSelectionFromCurrent(newData) {
        _Ext2.default.each(this.data, function (item) {
            this.propertiesController.setSelectedInit(item, this.propertiesController.isSelected(item));
        }, this);
    },

    /*
     * Deletes all old nodes , create and inserts new nodes
     */
    rebuildTree: function rebuildTree(newData) {
        if (!this.data.length == 0) this.removeAll();

        this.data = newData;

        _Ext2.default.each(this.createNodes(), function (node) {
            this.add(node);
        }, this);

        this.setInitialSelectionFromCurrent();
    }

});

exports.default = SimpleListSelectorTree;

/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Ext = __webpack_require__(12);

var _Ext2 = _interopRequireDefault(_Ext);

var _at_selector_tree_node = __webpack_require__(837);

var _at_selector_tree_node2 = _interopRequireDefault(_at_selector_tree_node);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Selector tree checkbox node.
 *
 * Depends on:
 * <code>/js/controls/dateControls/at_selector_tree_node.js</code>
 *
 * @constructor
 * @cfg {String} label checkbox label.
 * @cfg {Object} item enclosed item (required).
 */
var SelectorTreeCheckbox = _Ext2.default.extend(_at_selector_tree_node2.default, {
    label: "",
    item: {},
    title: "",

    /**
     * @cfg {String} itemCls style class for the node body component.
     */
    itemCls: "at-selector-checkbox",

    /**
     * @cfg {String} itemCls style class for the node body component for inactive items.
     */
    itemInactiveCls: "at-selector-node-inactive",

    /**
     * @cfg {String} labelCls style class for the node body text label.
     */
    labelCls: "ellipsis",

    /**
     * @cfg {Boolean} specifies whether node's item is active or not
     */
    isActive: true,

    initComponent: function initComponent() {
        SelectorTreeCheckbox.superclass.initComponent.call(this);

        this.addEvents("change");
        this.nodeBody.on("check", this.onCheck, this);

        if (!this.isActive) {
            this.addClass(this.itemInactiveCls);
        }
    },

    /**
     * @see AT.SelectorTreeNode
     */
    getNodeBody: function getNodeBody() {
        var labelCls = this.labelCls;
        var title = this.title;
        return new _Ext2.default.form.Checkbox({
            cls: this.itemCls,
            boxLabel: this.createNodeLabel(this.item),
            checked: this.item[this.selectedProperty],
            afterRender: function afterRender() {
                _Ext2.default.form.Checkbox.prototype.afterRender.call(this);
                var label = _Ext2.default.get(this.el.dom.parentNode).child("label:first");
                if (title && title != "") label.dom.title = title;
                label.unselectable();
                label.addClass(labelCls);
            }
        });
    },

    createNodeLabel: function createNodeLabel(item) {
        return _Ext2.default.util.Format.htmlEncode(this.label);
    },

    /**
     * Checkbox "check" event handler.
     * @param checkbox this.
     * @param {Boolean} checked checked state.
     * @private
     */
    onCheck: function onCheck(checkbox, checked) {
        this.select(checked);
        this.fireEvent("change", this, checked);
    },

    /**
     * @see AT.SelectorTreeNode
     */
    doSelect: function doSelect(value) {
        this.item[this.selectedProperty] = value;
        this.nodeBody.setValue(value);
        SelectorTreeCheckbox.superclass.doSelect.call(this, value);
    },

    /**
     * @see AT.SelectorTreeNode
     */
    filter: function filter(condition, scope) {
        var visible = condition.call(scope, this.item);
        this.setVisible(visible);
        this.item[this.hiddenProperty] = !visible;
        if (visible) {
            SelectorTreeCheckbox.superclass.filter.call(this, condition);
        }
    }
});

_Ext2.default.reg("at_selector_tree_checkbox", SelectorTreeCheckbox);

exports.default = SelectorTreeCheckbox;

/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Ext = __webpack_require__(12);

var _Ext2 = _interopRequireDefault(_Ext);

var _abstract_dropdown_button = __webpack_require__(233);

var _abstract_dropdown_button2 = _interopRequireDefault(_abstract_dropdown_button);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _atUtils = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AbstractPickerButton = _Ext2.default.extend(_abstract_dropdown_button2.default, {

    menuListeners: {
        select: function select(m, d) {
            this.updateValueAndFireIfChanged(m, d);
        }
    },

    updateValueAndFireIfChanged: function updateValueAndFireIfChanged(m, d) {
        var oldDate = this.date;
        this.setValue(d);
        if (!oldDate || !(0, _atUtils.areDatesEqual)(oldDate, d)) this.fireEvent("change", this, d);
    },

    // abstract
    createMenu: function createMenu() {},

    initComponent: function initComponent() {
        this.cls = "at-dropdown-list-btn dateButton";
        this.ctCls = "at-dropdown-list-btn-ct";
        if (!this.format) this.format = Date.convertSmartToExtDateFormat(window.SystemSettings.dateFormat);

        AbstractPickerButton.superclass.initComponent.call(this);

        this.menu = this.createMenu();

        this.addEvents("change");

        this.menu.on(_Ext2.default.apply({}, this.menuListeners, { scope: this }));
        if (this.date) this.displayValue(this.date);else {
            this.unsetValue();
            this.fireEvent("change", this);
        }
    },

    formatDate: function formatDate(date) {
        return _Ext2.default.isDate(date) ? date.format(this.format) : date.toString();
    },

    setValue: function setValue(date) {
        this.date = date;
        this.displayValue(date);
        this.menu.picker.setValue(date);
    },

    /**
     * Displays the given date, but doesn't actually change the date (the user didn't submit the date picker yet).
     * @param date
     */
    displayValue: function displayValue(date) {
        this.setText(date ? this.formatDate(date) : _messageResource2.default.getMessage("common.date_selector.select_date"));
    },

    unsetValue: function unsetValue() {
        this.date = null;
        this.displayValue(null);
    },

    getValue: function getValue() {
        return this.date;
    }
});

exports.default = AbstractPickerButton;

/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Ext = __webpack_require__(12);

var _Ext2 = _interopRequireDefault(_Ext);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_Ext2.default.namespace('AT');

var BaseDatePicker = _Ext2.default.extend(_Ext2.default.DatePicker, {

    scheduleCalculator: null,

    initComponent: function initComponent() {
        BaseDatePicker.superclass.initComponent.call(this);
        this.effectiveScheduleCache = {};
        this.clearText = window.messageResource.getMessage("common.datepicker.clear");
        this.todayText = window.messageResource.getMessage("common.datepicker.today");
        if (!this.minText) this.minText = window.messageResource.getMessage("common.datepicker.minDateText");
        if (!this.maxText) this.maxText = window.messageResource.getMessage("common.datepicker.maxDateText");
        this.actualMin = this.minDate ? this.minDate.clearTime() : Number.NEGATIVE_INFINITY;
        this.actualMax = this.maxDate ? this.maxDate.clearTime() : Number.POSITIVE_INFINITY;
        this.disabledDatesJoinedString = false;
        this.todayIsDisabled = false;
    },

    /**
     * This needed for correct look and feel under IE.because IE doesn't support CSS selector as following
     * .x-date-weekend.x-date-disabled - should select element which has two classes(x-date-weekend and x-date-disabled),
     * IE select only x-date-disabled or x-date-weekend, but not two at once.
     **/
    getClassNameForDisableDay: function getClassNameForDisableDay(className) {
        if (className.indexOf("x-date-weekend") != -1) {
            if (className.indexOf("x-date-nextday") != -1) className = " x-date-disabled x-date-nextday-weekend-disabled";else if (className.indexOf("x-date-prevday") != -1) className = " x-date-disabled x-date-prevday-weekend-disabled";else className = " x-date-disabled x-date-active-weekend-disabled";
        } else className += " x-date-disabled";

        return className;
    },

    getEffectiveSchedule: function getEffectiveSchedule(startDate) {
        var firstDayInCalendar = new Date(startDate.getTime());
        var endDayInCalendar = new Date(startDate.getTime());
        firstDayInCalendar.setDate(firstDayInCalendar.getDate() + 1);
        endDayInCalendar.setDate(endDayInCalendar.getDate() + 42);

        var effectiveSchedule = this.effectiveScheduleCache[firstDayInCalendar.getTime()];

        //cache the schedule to prevent redundant calculations
        if (!effectiveSchedule) {
            effectiveSchedule = this.scheduleCalculator.getEffectiveSchedule(firstDayInCalendar, endDayInCalendar);
            this.effectiveScheduleCache[firstDayInCalendar.getTime()] = effectiveSchedule;
        }

        return effectiveSchedule;
    },

    applyWebKitWorkaround: function applyWebKitWorkaround() {
        if (_Ext2.default.isChrome) {
            var main = this.el.dom.firstChild;

            // Workaround for WebKit
            // Because main.offsetWidth in WebKit returns wrong value greater than 10000,
            // than believe that it was 175
            var w = 175;
            this.el.setWidth(w + this.el.getBorderWidth("lr"));
            _Ext2.default.fly(main).setWidth(w);
        }
    },

    setCellClasses: function setCellClasses(cell, isWeekend, date, today) {
        cell.title = "";

        var t = date.clearTime(true).getTime();
        cell.firstChild.dateValue = t;

        if (t == today) {
            cell.className += " x-date-today";
            cell.title = this.todayText;
        }

        if (isWeekend) cell.className += "x-date-weekend x-date-weekend";

        // disabling
        if (t < this.actualMin) {
            cell.className = this.getClassNameForDisableDay(cell.className);
            cell.title = this.minText;
            return;
        }
        if (t > this.actualMax) {
            cell.className = this.getClassNameForDisableDay(cell.className);
            cell.title = this.maxText;
            return;
        }

        if (this.disabledDatesJoinedString) {
            if (this.disabledDatesJoinedString.indexOf(date.getDay()) != -1) {
                cell.title = this.disabledDatesText;
                cell.className = " x-date-disabled";
            }
        }

        if (this.disabledDatesRE && this.format) {
            var fValue = date.dateFormat(this.format);
            if (this.disabledDatesRE.test(fValue)) {
                cell.title = this.disabledDatesText.replace("%0", fValue);
                cell.className = " x-date-disabled";
            }
        }
    },

    updateCells: function updateCells(date) {
        var days = date.getDaysInMonth();
        var firstOfMonth = date.getFirstDateOfMonth();
        var startingPos = firstOfMonth.getDay() - this.startDay;

        if (startingPos <= this.startDay) startingPos += 7;

        var prevMonth = date.add("mo", -1);
        var prevStart = prevMonth.getDaysInMonth() - startingPos;

        var cells = this.cells.elements;
        var textEls = this.textNodes;
        days += startingPos;

        // convert everything to numbers so it's fast
        var d = new Date(prevMonth.getFullYear(), prevMonth.getMonth(), prevStart, 12);
        var today = this.today().getTime();

        var effectiveSchedule = this.getEffectiveSchedule(d);

        var i = 0;
        for (; i < startingPos; i++) {
            textEls[i].innerHTML = ++prevStart;
            d.setDate(d.getDate() + 1);
            cells[i].className = "x-date-prevday";
            this.setCellClasses(cells[i], this.isWeekend(effectiveSchedule, i), d, today);
        }
        for (; i < days; i++) {
            var intDay = i - startingPos + 1;
            textEls[i].innerHTML = intDay;
            d.setDate(d.getDate() + 1);
            cells[i].className = "x-date-active";
            this.setCellClasses(cells[i], this.isWeekend(effectiveSchedule, i), d, today);
        }
        var extraDays = 0;
        for (; i < 42; i++) {
            textEls[i].innerHTML = ++extraDays;
            d.setDate(d.getDate() + 1);
            cells[i].className = "x-date-nextday";
            this.setCellClasses(cells[i], this.isWeekend(effectiveSchedule, i), d, today);
        }

        this.mbtn.setText(this.monthNames[date.getMonth()] + " " + date.getFullYear());

        this.applyWebKitWorkaround();
    },

    isWeekend: function isWeekend(effectiveSchedule, dayNumber) {
        return effectiveSchedule[dayNumber] == false;
    },

    initDisabledDays: function initDisabledDays() {
        BaseDatePicker.superclass.initDisabledDays.call(this);
        if (this.disabledDates) this.disabledDatesJoinedString = this.disabledDays ? this.disabledDays.join("") : false;

        var today = this.today();
        this.todayIsDisabled = today < this.actualMin || today > this.actualMax || this.disabledDatesRE && this.format && this.disabledDatesRE.test(today.dateFormat(this.format)) || this.disabledDatesJoinedString && this.disabledDatesJoinedString.indexOf(today.getDay()) != -1;
    },

    // override
    onRender: function onRender(container, position) {
        BaseDatePicker.superclass.onRender.call(this, container, position);

        _Ext2.default.get(this.el).addClass("atap-base-date-picker");

        // fix some tab index issues under FF
        var as = this.el.dom.getElementsByTagName('a');
        for (var i = 0; i < as.length; i++) {
            as[i].tabIndex = 0;
        }var yearSwitcher = _Ext2.default.get(this.el).child(".x-date-mp");
        if (!this.KeyListener) this.KeyListener = new _Ext2.default.KeyMap(_Ext2.default.getBody().parent(), {
            key: [_Ext2.default.EventObject.LEFT, _Ext2.default.EventObject.RIGHT],
            ctrl: true,
            fn: function fn(key, ev) {
                if (this.isVisible() && !yearSwitcher.isVisible()) {
                    if (key === _Ext2.default.EventObject.LEFT) this.showPrevMonth();else this.showNextMonth();
                }
            },
            scope: this,
            stopEvent: true
        });
    },

    /**
     * Behaves as if the user clicked on an active day ('active' means the day under cursor).
     * Selects the active day and fires the 'select' event.
     */
    selectActiveDate: function selectActiveDate() {
        this.suppressActiveDayFocus = true; // Hack: Suppress automatic active day focusing in the next update().
        // Because focusing is deferred, and the date picker is usually hidden
        // after calling this method, focusing would cause a lot of trouble.
        this.setValue(this.activeDate);
        this.fireEvent("select", this, this.value);
    },

    /**
     * Cancels the selection.
     */
    cancel: function cancel() {
        this.fireEvent("cancel", this);
    },

    onOkClick: function onOkClick() {
        this.selectActiveDate();
    },

    onCancelClick: function onCancelClick() {
        this.cancel();
    },

    // Fix issue with ExtJS Date.add method, which will return 1 March when adding or subtracting 1 year to 29 february.
    fix29februaryIssue: function fix29februaryIssue(newDate) {
        if (newDate.getMonth() != this.activeDate.getMonth()) return newDate.add(Date.DAY, -1);else return newDate;
    },

    // override
    onMonthClick: function onMonthClick(e, t) {
        e.stopEvent();
        var el = new _Ext2.default.Element(t);

        if (el.is('button.x-date-mp-ok')) {
            this.monthPickerApply(this.mpSelYear, this.mpSelMonth);
        } else {
            BaseDatePicker.superclass.onMonthClick.call(this, e, t);
        }
    },

    // override
    onMonthDblClick: function onMonthDblClick(e, t) {
        e.stopEvent();
        var el = new _Ext2.default.Element(t),
            pn;

        if (pn = el.up('td.x-date-mp-month', 2)) {
            this.monthPickerApply(this.mpSelYear, pn.dom.xmonth);
        } else if (pn = el.up('td.x-date-mp-year', 2)) {
            this.monthPickerApply(pn.dom.xyear, this.mpSelMonth);
        }
    },

    monthPickerApply: function monthPickerApply(year, month) {
        var d = new Date(year, month, (this.activeDate || this.value).getDate());
        if (d.getMonth() != month) {
            // "fix" the JS rolling date conversion if needed
            d = new Date(year, month, 1).getLastDateOfMonth();
        }
        this.update(d, false, true);
        this.hideMonthPicker();
    },

    setMonthYearSwitchingStateIfNotSet: function setMonthYearSwitchingStateIfNotSet() {
        if (this.monthYearSwitchingState == 'off') {
            if (this.activeDate.format("j") == this.activeDate.getDaysInMonth()) this.monthYearSwitchingState = 'keep_month_end';else this.monthYearSwitchingState = 'keep_same_day';
        }
    },

    clearMonthYearSwitchingState: function clearMonthYearSwitchingState() {
        this.monthYearSwitchingState = 'off';
    },

    getMonthYearSwitchingState: function getMonthYearSwitchingState() {
        return this.monthYearSwitchingState;
    },

    today: function today() {
        return window.currentUserTime().clearTime();
    },

    clear: function clear() {
        this.fireEvent("clear", this);
    },

    /**
     * Overrides function from Ext.DatePicker
     * Use correct current user time.
     */
    selectToday: function selectToday() {
        if (!this.todayIsDisabled) {
            this.setValue(this.today());
            this.fireEvent("select", this, this.value);
        }
    },

    focus: function focus() {
        // prevent calling of this.update() on mouseOver
    }

});

_Ext2.default.reg('atdatepickerbase', BaseDatePicker);

exports.default = BaseDatePicker;

/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SmartGroupsSelectorPanel = exports.GroupsSelectorPanel = undefined;

var _Ext = __webpack_require__(12);

var _Ext2 = _interopRequireDefault(_Ext);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _GroupType = __webpack_require__(34);

var _GroupType2 = _interopRequireDefault(_GroupType);

var _at_simple_selector_panel = __webpack_require__(834);

var _at_simple_selector_panel2 = _interopRequireDefault(_at_simple_selector_panel);

var _at_simple_list_selector_tree = __webpack_require__(533);

var _at_simple_list_selector_tree2 = _interopRequireDefault(_at_simple_list_selector_tree);

var _GenericSelectorTreePropertiesController = __webpack_require__(532);

var _GenericSelectorTreePropertiesController2 = _interopRequireDefault(_GenericSelectorTreePropertiesController);

var _at_selector_tree_checkbox = __webpack_require__(534);

var _at_selector_tree_checkbox2 = _interopRequireDefault(_at_selector_tree_checkbox);

var _at_group_selector_switcher = __webpack_require__(373);

var _at_group_selector_switcher2 = _interopRequireDefault(_at_group_selector_switcher);

var _atBrowserUtils = __webpack_require__(8);

var _ScrollUtils = __webpack_require__(39);

var _ScrollUtils2 = _interopRequireDefault(_ScrollUtils);

var _at_flat_button = __webpack_require__(351);

var _at_flat_button2 = _interopRequireDefault(_at_flat_button);

var _at_gradient_button = __webpack_require__(285);

var _at_gradient_button2 = _interopRequireDefault(_at_gradient_button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @author kostenko
 *
 * User groups selector panel.
 *
 * Depends on:
 * <code>/js/controls/selectorControls/at_simple_selector_panel.js</code>
 * <code>/js/message_resources.js</code> with prefixes "common" and "user_groups_selector"
 */

var UserGroupsSelectorTreePropertiesController = _Ext2.default.extend(_GenericSelectorTreePropertiesController2.default, {
    isActive: function isActive() {
        return true;
    } // archived groups are not supported
});

var TimeZoneGroupSelectorTreeCheckbox = _Ext2.default.extend(_at_selector_tree_checkbox2.default, {

    itemDefaultCls: "defaultGroup",

    createNodeLabel: function createNodeLabel(item) {
        var escapedName = _Ext2.default.util.Format.htmlEncode(this.label);
        if (!item.isDefault) return escapedName;

        return "<span class='defaultGroupName'>" + escapedName + "</span><span class='defaultGroupNote'>&nbsp;" + _messageResource2.default.getMessage("users_selector.default_group") + "</span>";
    },

    initComponent: function initComponent() {
        TimeZoneGroupSelectorTreeCheckbox.superclass.initComponent.call(this);

        if (this.item.isDefault) {
            this.addClass(this.itemDefaultCls);
        }
    }

});

var GroupsSelectorTree = _Ext2.default.extend(_at_simple_list_selector_tree2.default, {

    groupType: _GroupType2.default.USER_GROUP,

    createNodes: function createNodes() {
        var nodes = [];
        var selectorTreeCheckboxCtor = this.groupType === _GroupType2.default.TIME_ZONE_GROUP ? TimeZoneGroupSelectorTreeCheckbox : _at_selector_tree_checkbox2.default;
        _Ext2.default.each(this.data, function (item) {
            var node = new selectorTreeCheckboxCtor({
                item: item,
                label: this.getNameWithStatus(item)
            });
            nodes.push(node);
            node.on("change", this.onChange, this);
        }, this);

        return nodes;
    },

    setGroupType: function setGroupType(groupType) {
        this.groupType = groupType;
    }

});

var GroupsSelectorPanel = exports.GroupsSelectorPanel = _Ext2.default.extend(_at_simple_selector_panel2.default, {
    showShowInactiveCheckbox: false,

    allItemsOptionLabelKey: "user_groups_selector.options.all_items",
    selectedAllItemsOptionLabelKey: "user_groups_selector.smart.message.all_items.selected",
    allItemsBoldOptionLabelKey: 'user_groups_selector.options.all_items_bold',
    customOptionLabelKey: "user_groups_selector.options.custom",

    labelNoItemsSelectedKey: "user_groups_selector.smart.message.all_items.selected",

    closeButtonLabelKey: "user_groups_selector.close_button.label",

    labelUseNameForSingleItem: true,
    showInactiveLabelKey: "userlist.js.filter_by_groups.show_disabled_users",

    propertiesControllerCtor: UserGroupsSelectorTreePropertiesController,

    userGroupsData: null,
    timeZoneGroupsData: null,
    groupType: null,

    groupTypeSettingCookieName: "groupSelectorGroupTypeSetting",

    selectorTreeCtor: GroupsSelectorTree,

    createComponents: function createComponents() {
        GroupsSelectorPanel.superclass.createComponents.call(this);
        this.viewByPanel = new _at_group_selector_switcher2.default();
    },

    initComponent: function initComponent() {
        this.userGroupsEnabled = this.userGroupsData != null && this.userGroupsData.length !== 0;
        this.timeZoneGroupsEnabled = this.timeZoneGroupsData != null && this.timeZoneGroupsData.length !== 0;

        if (this.groupType !== _GroupType2.default.USER_GROUP && this.groupType !== _GroupType2.default.TIME_ZONE_GROUP) {
            var groupTypeSettingFromCookie = _jquery2.default.cookie(this.groupTypeSettingCookieName);
            if (groupTypeSettingFromCookie) {
                this.groupType = groupTypeSettingFromCookie === "timeZoneGroup" ? _GroupType2.default.TIME_ZONE_GROUP : _GroupType2.default.USER_GROUP;
            } else {
                this.groupType = _GroupType2.default.USER_GROUP;
            }
        }

        if (this.groupType === _GroupType2.default.TIME_ZONE_GROUP && !this.timeZoneGroupsEnabled) this.groupType = _GroupType2.default.USER_GROUP;

        if (this.groupType === _GroupType2.default.USER_GROUP && !this.userGroupsEnabled) this.groupType = _GroupType2.default.TIME_ZONE_GROUP;

        this.groupTypeInit = this.groupType;

        if (!this.data || this.data.length === 0) this.data = this.groupType === _GroupType2.default.USER_GROUP ? this.userGroupsData : this.timeZoneGroupsData;

        this.createInitialUserGroupsDataIfNeeded();
        this.createInitialTimeZoneGroupsDataIfNeeded();

        GroupsSelectorPanel.superclass.initComponent.call(this);
        this.addClass("group-selector-panel");

        var self = this;
        this.viewByPanel.init(this.userGroupsEnabled, this.timeZoneGroupsEnabled, function () {
            self.selectorTree.onChange();self.groupByUserGroup();
        }, function () {
            self.selectorTree.onChange();self.groupByTimeZoneGroup();
        });
        if (this.groupType === _GroupType2.default.TIME_ZONE_GROUP) {
            this.groupByTimeZoneGroup();
        } else {
            this.groupByUserGroup();
        }
    },

    setInitialValuesFromCurrent: function setInitialValuesFromCurrent() {
        GroupsSelectorPanel.superclass.setInitialValuesFromCurrent.call(this);
        this.groupTypeInit = this.groupType;
        this.createInitialUserGroupsDataIfNeeded();
        this.createInitialTimeZoneGroupsDataIfNeeded();
    },

    createInitialUserGroupsDataIfNeeded: function createInitialUserGroupsDataIfNeeded() {
        if (this.userGroupsEnabled) {
            this.initialUserGroupsData = _jquery2.default.map(this.userGroupsData, function (obj) {
                return _jquery2.default.extend({}, obj);
            });
        }
    },

    createInitialTimeZoneGroupsDataIfNeeded: function createInitialTimeZoneGroupsDataIfNeeded() {
        if (this.timeZoneGroupsEnabled) {
            this.initialTimeZoneGroupsData = _jquery2.default.map(this.timeZoneGroupsData, function (obj) {
                return _jquery2.default.extend({}, obj);
            });
        }
    },

    getCustomOptionSection: function getCustomOptionSection() {
        var buttons = [];
        buttons.push(this.selectAllButton);
        buttons.push(this.makeVerticalSeparator(), this.clearButton);

        var customOptionButtonsSection = new _Ext2.default.Panel({
            cls: "buttonsPanel",
            autEl: "div",
            items: buttons
        });

        var customOptionControls = [];
        // from left to right
        customOptionControls.push(this.viewByPanel);
        customOptionControls.push(customOptionButtonsSection);

        this.customControlsContainer = new _Ext2.default.Container({
            cls: "userSelectorCustomControlsContainer",
            autoEl: "div",
            items: customOptionControls
        });
        return [this.customOption, this.customControlsContainer];
    },

    groupByUserGroup: function groupByUserGroup() {
        this.data = this.userGroupsData;
        if (!this.data) return;

        this.groupType = _GroupType2.default.USER_GROUP;
        this.updateGroups(this.data);

        this.viewByPanel.updateUI(this.groupType);
        this.saveGroupBySettingsToCookie("userGroup");
    },

    groupByTimeZoneGroup: function groupByTimeZoneGroup() {
        this.data = this.timeZoneGroupsData;
        if (!this.data) return;

        this.groupType = _GroupType2.default.TIME_ZONE_GROUP;
        this.updateGroups(this.data);

        this.viewByPanel.updateUI(this.groupType);
        this.saveGroupBySettingsToCookie("timeZoneGroup");
    },

    createGenericOptions: function createGenericOptions() {
        this.genericOptions = [new _Ext2.default.form.Radio({
            boxLabel: _messageResource2.default.getMessage(this.allItemsBoldOptionLabelKey, [_messageResource2.default.getEscapedMessage(this.labelItemNounPluralKey)]),
            name: this.realOptionsName,
            inputValue: this.allItemsOptionValue
        })];
    },

    createCustomOption: function createCustomOption() {
        this.customOption = new _Ext2.default.form.Radio({
            boxLabel: _messageResource2.default.getMessage('user_groups_selector.options.custom_bold', [_messageResource2.default.getEscapedMessage(this.labelItemNounPluralKey)]),
            name: this.realOptionsName,
            inputValue: this.customOptionValue
        });
    },

    getAllSelectedString: function getAllSelectedString(maxLength) {
        return _messageResource2.default.getEscapedMessage(this.selectedAllItemsOptionLabelKey);
    },

    createFooterButtons: function createFooterButtons() {
        this.resetButton = new _at_flat_button2.default({
            icon: (0, _atBrowserUtils.atImgPath)("undo.gif"),
            text: _messageResource2.default.getMessage(this.resetButtonLabelKey)
        });
        this.closeButton = new _at_gradient_button2.default({
            text: _messageResource2.default.getMessage(this.closeButtonLabelKey),
            minWidth: 60,
            cls: "greyButton close-button"
        });
        this.resetButton.addClass("resetButton");
    },

    updateGroupsData: function updateGroupsData(userGroupWrappersList, timeZoneGroupWrappersList, skipUpdateInitialValues) {
        this.userGroupsData = userGroupWrappersList;
        this.timeZoneGroupsData = timeZoneGroupWrappersList;

        // We may not want to update init values, for instance when resetting
        if (!skipUpdateInitialValues) {
            this.setInitialValuesFromCurrent();
        }

        if (this.groupType === _GroupType2.default.USER_GROUP) this.groupByUserGroup();else this.groupByTimeZoneGroup();

        if (this.getSelection().length === 0) this.selectOption(this.allItemsOptionValue);
    },

    updateGroups: function updateGroups(groupWrappersList) {
        this.selectorTree.setGroupType(this.groupType);
        this.selectorTree.rebuildTree(groupWrappersList);
        this.selectorTree.setInitialSelectionFromCurrent();
        this.doLayout();
        this.fireChangeEvent();
        _ScrollUtils2.default.refreshCustomScroll(this.customScroller);
    },

    getGroupType: function getGroupType() {
        return this.isCustomOptionSelected() && this.groupType ? this.groupType : null;
    },

    saveGroupBySettingsToCookie: function saveGroupBySettingsToCookie(value) {
        _jquery2.default.cookie(this.groupTypeSettingCookieName, value, { expires: 365 });
    },

    resetState: function resetState(isEnableActiveActions) {
        this.beforeResetAction();
        GroupsSelectorPanel.superclass.resetState.call(this, isEnableActiveActions);
        this.afterResetAction();
    },

    beforeResetAction: function beforeResetAction() {
        this.groupType = this.groupTypeInit;
        if (this.userGroupsEnabled) {
            this.userGroupsData = _jquery2.default.map(this.initialUserGroupsData, function (obj) {
                return _jquery2.default.extend({}, obj);
            });
        }
        if (this.timeZoneGroupsEnabled) {
            this.timeZoneGroupsData = _jquery2.default.map(this.initialTimeZoneGroupsData, function (obj) {
                return _jquery2.default.extend({}, obj);
            });
        }

        this.updateGroupsData(this.userGroupsData, this.timeZoneGroupsData, true);
    },

    afterResetAction: function afterResetAction() {
        GroupsSelectorPanel.superclass.afterResetAction.call(this);
        this.viewByPanel.updateUI(this.groupTypeInit);
    },

    onGenericOptionSelect: function onGenericOptionSelect(option, checked) {
        if (checked) this.addClass("hideCustomOptionField");
        GroupsSelectorPanel.superclass.onGenericOptionSelect.call(this, option, checked);
    },

    onCustomOptionSelect: function onCustomOptionSelect(option, checked) {
        if (checked) {
            this.removeClass("hideCustomOptionField");
            _ScrollUtils2.default.refreshCustomScroll(this.customScroller);
        }
        GroupsSelectorPanel.superclass.onCustomOptionSelect.call(this, option, checked);
    },

    render: function render(ct, pos) {
        GroupsSelectorPanel.superclass.render.apply(this, arguments);
        this.customScroller = _ScrollUtils2.default.addVerticalScroll((0, _jquery2.default)(this.selectorTree.el.dom), { isFaded: false });
    },

    isStateChanged: function isStateChanged() {
        if (this.getCurrentOptionValue() !== this.optionValueInit) return true;

        if (this.groupTypeInit !== this.groupType) return true;

        var initialData = this.groupType === _GroupType2.default.USER_GROUP ? this.initialUserGroupsData : this.initialTimeZoneGroupsData;

        for (var i = 0; i < this.data.length; i++) {
            if (initialData[i] && initialData[i].selected !== this.data[i].selected) return true;
        }

        return false;
    }
});

var SmartGroupsSelectorPanel = exports.SmartGroupsSelectorPanel = _Ext2.default.extend(GroupsSelectorPanel, {
    cls: "selector-panel userGroupsSelector",

    labelUseNameForSingleItem: false,

    allItemsOptionLabelKey: "user_groups_selector.smart.options.all_items",
    allItemsBoldOptionLabelKey: 'user_groups_selector.smart.options.all_items_bold',

    labelItemNounSingularKey: "user_groups_selector.smart.label.user_group.singular",
    labelItemNounPluralKey: "user_groups_selector.smart.label.user_group.plural",
    labelNoItemsSelectedKey: "user_groups_selector.smart.message.all_items.selected",

    userWithoutDepartmentLabel: "user_groups_selector.without_department.label",

    selectAll: function selectAll() {
        this.selectOption(this.allItemsOptionValue);
    },

    getDescription: function getDescription(selectorHelper) {
        var selection = this.getSelection();
        if (selection.length === 1 && this.getGroupType() === _GroupType2.default.USER_GROUP && selection[0].id <= 0) {
            return _messageResource2.default.getEscapedMessage(this.userWithoutDepartmentLabel);
        }
        if (this.getGroupType() === _GroupType2.default.USER_GROUP) {
            this.labelItemNounSingularKey = "user_groups_selector.smart.label.user_group.singular";
            this.labelItemNounPluralKey = "user_groups_selector.smart.label.user_group.plural";
        }
        if (this.getGroupType() === _GroupType2.default.TIME_ZONE_GROUP) {
            this.labelItemNounSingularKey = "user_groups_selector.smart.label.time_zone_group.singular";
            this.labelItemNounPluralKey = "user_groups_selector.smart.label.time_zone_group.plural";
        }

        return GroupsSelectorPanel.superclass.getDescription.call(this, selectorHelper);
    }
});

/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Ext = __webpack_require__(12);

var _Ext2 = _interopRequireDefault(_Ext);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_Ext2.default.namespace('AT.menu');

/**
 * @class AT.menu.SpecialMenuMgr
 *
 * This is a copy of Ext.menu.MenuMgr with the following changes:
 *  - on escape key press the special flag is set. It may be queried with {@link #wasEscKeyDown} .
 *    This flag is reset before showing a menu.
 *
 * @singleton
 */
var SpecialMenuMgr = function () {
    var menus,
        active,
        groups = {},
        attached = false,
        lastShow = new Date();
    var _wasEscKeyDown = false;

    // private - called when first menu is created
    function init() {
        menus = {};
        active = new _Ext2.default.util.MixedCollection();
        _Ext2.default.getDoc().addKeyListener(27, function () {
            _wasEscKeyDown = true;
            if (active.length > 0) {
                _hideAll();
            }
        });
    }

    // private
    function _hideAll() {
        if (active && active.length > 0) {
            var c = active.clone();
            c.each(function (m) {
                m.hide();
            });
        }
    }

    // private
    function onHide(m) {
        active.remove(m);
        if (active.length < 1) {
            _Ext2.default.getDoc().un("mousedown", onMouseDown);
            attached = false;
        }
    }

    // private
    function onShow(m) {
        var last = active.last();
        lastShow = new Date();
        active.add(m);
        if (!attached) {
            _Ext2.default.getDoc().on("mousedown", onMouseDown);
            attached = true;
        }
        if (m.parentMenu) {
            m.getEl().setZIndex(parseInt(m.parentMenu.getEl().getStyle("z-index"), 10) + 3);
            m.parentMenu.activeChild = m;
        } else if (last && last.isVisible()) {
            m.getEl().setZIndex(parseInt(last.getEl().getStyle("z-index"), 10) + 3);
        }
    }

    // private
    function onBeforeHide(m) {
        if (m.activeChild) {
            m.activeChild.hide();
        }
        if (m.autoHideTimer) {
            clearTimeout(m.autoHideTimer);
            delete m.autoHideTimer;
        }
    }

    // private
    function onBeforeShow(m) {
        _wasEscKeyDown = false;
        var pm = m.parentMenu;
        if (!pm && !m.allowOtherMenus) {
            _hideAll();
        } else if (pm && pm.activeChild) {
            pm.activeChild.hide();
        }
    }

    // private
    function onMouseDown(e) {
        if (lastShow.getElapsed() > 50 && active.length > 0 && !e.getTarget(".x-menu")) {
            _hideAll();
        }
    }

    // private
    function onBeforeCheck(mi, state) {
        if (state) {
            var g = groups[mi.group];
            for (var i = 0, l = g.length; i < l; i++) {
                if (g[i] != mi) {
                    g[i].setChecked(false);
                }
            }
        }
    }

    return {

        /**
         * Hides all menus that are currently visible
         */
        hideAll: function hideAll() {
            _hideAll();
        },

        // private
        register: function register(menu) {
            if (!menus) {
                init();
            }
            menus[menu.id] = menu;
            menu.on("beforehide", onBeforeHide);
            menu.on("hide", onHide);
            menu.on("beforeshow", onBeforeShow);
            menu.on("show", onShow);
            var g = menu.group;
            if (g && menu.events["checkchange"]) {
                if (!groups[g]) {
                    groups[g] = [];
                }
                groups[g].push(menu);
                //
                menu.on("checkchange", window.onCheck);
            }
        },

        /**
         * Returns a {@link Ext.menu.Menu} object
         * @param {String/Object} menu The string menu id, an existing menu object reference, or a Menu config that will
         * be used to generate and return a new Menu instance.
         * @return {Ext.menu.Menu} The specified menu, or null if none are found
         */
        get: function get(menu) {
            if (typeof menu == "string") {
                // menu id
                if (!menus) {
                    // not initialized, no menus to return
                    return null;
                }
                return menus[menu];
            } else if (menu.events) {
                // menu instance
                return menu;
            } else if (typeof menu.length == 'number') {
                // array of menu items?
                return new _Ext2.default.menu.Menu({ items: menu });
            } else {
                // otherwise, must be a config
                return new _Ext2.default.menu.Menu(menu);
            }
        },

        // private
        unregister: function unregister(menu) {
            delete menus[menu.id];
            menu.un("beforehide", onBeforeHide);
            menu.un("hide", onHide);
            menu.un("beforeshow", onBeforeShow);
            menu.un("show", onShow);
            var g = menu.group;
            if (g && menu.events["checkchange"]) {
                groups[g].remove(menu);
                menu.un("checkchange", window.onCheck);
            }
        },

        // private
        registerCheckable: function registerCheckable(menuItem) {
            var g = menuItem.group;
            if (g) {
                if (!groups[g]) {
                    groups[g] = [];
                }
                groups[g].push(menuItem);
                menuItem.on("beforecheckchange", onBeforeCheck);
            }
        },

        // private
        unregisterCheckable: function unregisterCheckable(menuItem) {
            var g = menuItem.group;
            if (g) {
                groups[g].remove(menuItem);
                menuItem.un("beforecheckchange", onBeforeCheck);
            }
        },

        getCheckedItem: function getCheckedItem(groupId) {
            var g = groups[groupId];
            if (g) {
                for (var i = 0, l = g.length; i < l; i++) {
                    if (g[i].checked) {
                        return g[i];
                    }
                }
            }
            return null;
        },

        setCheckedItem: function setCheckedItem(groupId, itemId) {
            var g = groups[groupId];
            if (g) {
                for (var i = 0, l = g.length; i < l; i++) {
                    if (g[i].id == itemId) {
                        g[i].setChecked(true);
                    }
                }
            }
            return null;
        },

        wasEscKeyDown: function wasEscKeyDown() {
            return _wasEscKeyDown;
        }
    };
}();

exports.default = SpecialMenuMgr;

/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _at_picker_menu = __webpack_require__(540);

var _at_picker_menu2 = _interopRequireDefault(_at_picker_menu);

var _at_date_picker = __webpack_require__(389);

var _at_date_picker2 = _interopRequireDefault(_at_date_picker);

var _at_specialMenuMgr = __webpack_require__(538);

var _at_specialMenuMgr2 = _interopRequireDefault(_at_specialMenuMgr);

var _Ext = __webpack_require__(12);

var _Ext2 = _interopRequireDefault(_Ext);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_Ext2.default.namespace('AT.menu');

var DatePickerMenu = _Ext2.default.extend(_at_picker_menu2.default, {
    cancelOnHide: false,

    constructor: function constructor(config) {
        var picker = new _at_date_picker2.default(config);

        DatePickerMenu.superclass.constructor.call(this, config, picker);

        /*
         * @event datePickerUpdate
         * Fires when the contents of the date picker are updated, e.g. when the cursor is moved or month is changed,
         * but the selection is not submitted (the date picker remains visible).
         * Fires only in 'dynamic' mode ({@see AT.menu.DatePickerMenu#mode} )
         * @param {Date} date The currently selected date
         */
        this.addEvents('datePickerUpdate');

        /**
         * @event datePickerCancel
         * Fires when the user cancels the date selection.
         */
        this.addEvents('datePickerCancel');

        this.on('beforeshow', function () {
            if (this.picker) {
                this.picker.useUpdateEvent = this.isDynamicMode();
            }
        }, this);

        this.on('beforehide', function () {
            if (this.isDynamicMode()) {
                if (this.cancelOnHide || _at_specialMenuMgr2.default.wasEscKeyDown()) {
                    // behave as if the cancel event came from date picker
                    if (this.picker) this.picker.cancel();
                } else {
                    // Apply date selection on hide, but only if it wasn't applied yet.
                    if (!this.selectionFinished && this.picker) {
                        this.wasSelectionOnHide = true;
                        this.picker.selectActiveDate();
                    }
                }
            }
        }, this);

        this.picker.on("update", this.onDatePickerUpdate, this);
        this.picker.on("cancel", this.onDatePickerCancel, this);
        this.picker.on("clear", this.onDatePickerClear, this);
    } });

_Ext2.default.extend(DatePickerMenu, _at_picker_menu2.default, {
    mode: 'static',

    /**
     * True if the date selection was applied on date picker hide (if user clicked outside).
     * False if the the selection wasn't applied since the date picker was shown for the last time,
     * or it was applied explicitly (by clicking on a day, by clicking an OK button, or by pressing Enter).
     */
    wasSelectionOnHide: false,

    /**
     * In 'dynamic' mode the menu fires the "datePickerUpdate" event when user moves around in the date picker,
     * and the date selection is automatically applied when the date picker is closed (except for the Cancel button and
     * the Esc key).
     *
     * In 'static' mode the menu doesn't fire the "datePickerUpdate" event and the date selection is only applied when
     * the user clicks OK or presses Enter or clicks on a day.
     */
    isDynamicMode: function isDynamicMode() {
        return this.mode == 'dynamic';
    },

    show: function show(el, pos, parentMenu, mode) {
        if (mode) this.mode = mode;
        this.wasSelectionOnHide = false;
        DatePickerMenu.superclass.show.call(this, el, pos, parentMenu);
    },

    onDatePickerUpdate: function onDatePickerUpdate(picker, date) {
        this.fireEvent("datePickerUpdate", date);
    },

    onDatePickerCancel: function onDatePickerCancel() {
        this.selectionFinished = true;
        this.hide();
        this.fireEvent("datePickerCancel");
    },

    onDatePickerClear: function onDatePickerClear() {
        this.selectionFinished = true;
        this.hide();
        this.fireEvent("datePickerClear");
    }
});

exports.default = DatePickerMenu;

/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Ext = __webpack_require__(12);

var _Ext2 = _interopRequireDefault(_Ext);

var _at_picker_item = __webpack_require__(840);

var _at_picker_item2 = _interopRequireDefault(_at_picker_item);

var _at_specialMenuMgr = __webpack_require__(538);

var _at_specialMenuMgr2 = _interopRequireDefault(_at_specialMenuMgr);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_Ext2.default.namespace('AT.menu');

var PickerMenu = _Ext2.default.extend(_Ext2.default.menu.DateMenu, {

    constructor: function constructor(config, picker) {
        _Ext2.default.menu.DateMenu.superclass.constructor.call(this, config);

        this.picker = picker;
        this.plain = true;
        var di = new _at_picker_item2.default(config, picker);
        this.add(di);

        this.on('beforeshow', function () {
            if (this.picker) {
                this.picker.hideMonthPicker(true);
            }
        }, this);

        this.picker.on("select", this.onDatePickerSelect, this);

        // Switch from the default MenuMgr to our special one.
        _Ext2.default.menu.MenuMgr.unregister(this);
        _at_specialMenuMgr2.default.register(this);
    } });

_Ext2.default.extend(PickerMenu, _Ext2.default.menu.Menu, {
    cls: 'x-date-menu',

    isHiding: false,
    selectionFinished: false,

    beforeDestroy: function beforeDestroy() {
        this.picker.destroy();
    },

    show: function show(el, pos, parentMenu) {
        this.selectionFinished = false;

        this.parentMenu = parentMenu;
        if (!this.el) this.render();

        if (!this.fireEvent("beforeshow", this)) return;
        this.showAt(this.el.getAlignToXY(el, pos || this.defaultAlign), parentMenu, false);

        this.isHiding = false;
    },

    // override
    hide: function hide(deep) {
        if (!this.isHiding) {
            var activeDate = this.picker.activeDate;
            if (activeDate) {
                this.picker.updateCells(activeDate);
            }
            this.isHiding = true;
            PickerMenu.superclass.hide.call(this, deep);
        }
    },

    onDatePickerSelect: function onDatePickerSelect(picker, date) {
        this.selectionFinished = true;
        this.fireEvent("select", picker, date);
    }

});

exports.default = PickerMenu;

/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _PDFImageCache = __webpack_require__(122);

var _PDFImageCache2 = _interopRequireDefault(_PDFImageCache);

var _StringUtils = __webpack_require__(121);

var _constants = __webpack_require__(100);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var BasePDFDefinitionBuilder = function () {
    function BasePDFDefinitionBuilder() {
        _classCallCheck(this, BasePDFDefinitionBuilder);

        this.dd = null; // pdf doc definition
        this.params = null;
        this.styles = null;
    }

    _createClass(BasePDFDefinitionBuilder, [{
        key: "init",
        value: function init(paperOrientation, paperSize) {
            this.styles = {};
            this.styles = _jquery2.default.extend(true, this.styles, baseStyles);
            this.styles = _jquery2.default.extend(true, this.styles, this.getAdditionalStyles());

            var parameters = {};
            parameters = _jquery2.default.extend(true, parameters, baseParameters);
            parameters = _jquery2.default.extend(true, parameters, this.getAdditionalParameters());

            this.params = this.compactParameters(parameters, paperOrientation, paperSize);

            return this;
        }
    }, {
        key: "getAdditionalStyles",
        value: function getAdditionalStyles() {
            return {};
        }
    }, {
        key: "getAdditionalParameters",
        value: function getAdditionalParameters() {
            return {};
        }
    }, {
        key: "getAdditionalTableLayouts",
        value: function getAdditionalTableLayouts() {
            return {};
        }
    }, {
        key: "getTableLayouts",
        value: function getTableLayouts() {
            var layouts = {};
            layouts = _jquery2.default.extend(true, layouts, baseTabelLayouts);
            layouts = _jquery2.default.extend(true, layouts, this.getAdditionalTableLayouts());
            return layouts;
        }

        /**
         * Get definition builder parameter from current parameters map
         * @param name parameter name
         * @returns {*} parameter value
         */

    }, {
        key: "p",
        value: function p(name) {
            return this.params[name];
        }

        /**
         * Create flatten map of parameters depend on current page parameters
         * @param parameters builder parameters
         * @param paperOrientation current orientation
         * @param paperSize current paper size
         * @returns {*} flatten map of parameters
         */

    }, {
        key: "compactParameters",
        value: function compactParameters(parameters, paperOrientation, paperSize) {
            var paperOrientationKey = paperOrientation === _constants.PaperOrientation.LANDSCAPE ? "Landscape" : "Portrait";
            var paperSizeKey = paperSize === _constants.PaperSize.A4 ? "A4" : "Letter";

            var params = parameters[paperOrientationKey][paperSizeKey];
            var commonParams = _underscore2.default.omit(parameters, "Landscape", "Portrait");
            var orientationCommonParams = _underscore2.default.omit(parameters[paperOrientationKey], "A4", "Letter");

            _underscore2.default.extend(params, commonParams, orientationCommonParams);

            return params;
        }
    }, {
        key: "initDocDefinitionObject",
        value: function initDocDefinitionObject(headerOnEachPage) {
            this.dd = {};

            this.dd.pageSize = this.p("pageSize");
            this.dd.pageOrientation = this.p("pageOrientation");

            var margins = [];
            _underscore2.default.extend(margins, this.p("pageMargins"));
            if (headerOnEachPage) {
                margins[1] += this.p("headerHeight") + this.p("headerBottomMargin");
            }
            this.dd.pageMargins = margins;
            this.dd.styles = this.styles;

            this.dd.content = [];
        }

        /**
         * Append element to content list in doc definition
         * @param element - dd element fo add
         */

    }, {
        key: "appendContentElement",
        value: function appendContentElement(element) {
            this.dd.content.push(element);
        }

        /**
         * Add to doc definition page breaker
         */

    }, {
        key: "addPageBreaker",
        value: function addPageBreaker() {
            this.appendContentElement({
                pageBreak: 'after',
                text: ''
            });
        }
    }, {
        key: "createFilterView",
        value: function createFilterView(filterTexts) {
            var filterViewParameters = this.p("filterViewParameters");
            var margins = filterViewParameters.margins;
            var marginsImage = filterViewParameters.imageMargins;
            var firstRowMargins = filterViewParameters.firstRowMargins;
            var secondRowMargins = filterViewParameters.secondRowMargins;

            var filterTextMaxLen = this.p("filterViewTextLen");
            var withSecondRow = !_underscore2.default.isUndefined(filterTexts.secondRow);

            var body = [[{
                marginLeft: marginsImage.left,
                marginTop: marginsImage.top,
                rowSpan: withSecondRow ? 2 : 1,
                width: filterViewParameters.imageWidth,
                image: _PDFImageCache2.default.getImage("filterIcon")["image"]
            }, {
                marginTop: firstRowMargins.top,
                marginBottom: withSecondRow ? firstRowMargins.bottom : secondRowMargins.bottom,
                noWrap: true,
                text: (0, _StringUtils.cutLongText)(filterTexts.firstRow, filterTextMaxLen)
            }]];

            if (withSecondRow) {
                body.push(['', {
                    marginBottom: secondRowMargins.bottom,
                    noWrap: true,
                    text: (0, _StringUtils.cutLongText)(filterTexts.secondRow, filterTextMaxLen)
                }]);
            }

            return {
                style: 'filterView',
                layout: 'thinBordersNoPaddingsForFilterView',
                marginTop: margins.top,
                fontSize: filterViewParameters.fontSize,

                table: {
                    widths: filterViewParameters.widths,
                    body: body
                }
            };
        }
    }, {
        key: "createInformationSection",
        value: function createInformationSection(showLogo, logo, texts) {
            var logoElement;
            var infoParams;
            if (showLogo) {
                infoParams = this.p("pdfInfoParameters").withLogo;
                var dimensions = this.calculatePDFLogoDimensions(logo);
                logoElement = {
                    rowSpan: 2,
                    width: dimensions.w,
                    height: dimensions.h,
                    marginTop: dimensions.mT,
                    marginLeft: dimensions.mL,
                    image: logo.image
                };
            } else {
                logoElement = '';
                infoParams = this.p("pdfInfoParameters").withoutLogo;
            }
            var columnWidths = infoParams.widths;
            var body = [[logoElement, [{ style: 'titleLabel', text: texts.title }, { style: 'dateRangeLabel', text: texts.dateRange }]], ['', { text: '', marginTop: 5 }]];

            return {
                widths: columnWidths,
                body: body
            };
        }
    }, {
        key: "createHeaderLandscape",
        value: function createHeaderLandscape(information, filterView) {
            return {
                marginBottom: this.p("headerBottomMargin"),
                columns: [{
                    width: '67%',
                    layout: 'noBordersNoPadding',

                    table: information
                }, filterView]
            };
        }
    }, {
        key: "createHeaderPortrait",
        value: function createHeaderPortrait(information) {
            return {
                layout: 'noBordersNoPadding',

                table: information
            };
        }
    }, {
        key: "_createHeader",
        value: function _createHeader(showLogo, data, applier) {
            var filterTexts = data["filterTexts"];
            var informationTexts = data["informationTexts"];
            var logo = data["logo"];

            var filterView = this.createFilterView(filterTexts);

            var infoElement = this.createInformationSection(showLogo, logo, informationTexts);
            applier(infoElement, filterView);
        }
    }, {
        key: "addPortraitHeader",
        value: function addPortraitHeader(showOnEachPage, showLogo, data) {
            var s = this;
            var headerApplier;
            if (showOnEachPage) {
                headerApplier = function headerApplier(pdfInfo, filterView) {
                    s.dd.header = function () {
                        var stack = [];
                        stack.push(s.createHeaderPortrait(pdfInfo));
                        stack.push(filterView);
                        var margins = s.p("headerMargins")(s.p("pageMargins"));
                        return function () {
                            var st = [];
                            for (var i = 0; i < stack.length; i++) {
                                st[i] = _jquery2.default.extend(true, {}, stack[i]); // deep copy
                            }
                            return {
                                margin: margins,
                                stack: st
                            };
                        };
                    }();
                };
            } else {
                headerApplier = function headerApplier(pdfInfo, filterView) {
                    s.appendContentElement(s.createHeaderPortrait(pdfInfo));
                    s.appendContentElement(filterView);
                    s.appendContentElement({
                        marginBottom: s.p("headerBottomMargin"),
                        text: ""
                    });
                };
            }

            this._createHeader(showLogo, data, headerApplier);
        }
    }, {
        key: "addLandscapeHeader",
        value: function addLandscapeHeader(showOnEachPage, showLogo, data) {
            var s = this;
            var headerApplier;
            if (showOnEachPage) {
                headerApplier = function headerApplier(pdfInfo, filterView) {
                    s.dd.header = function () {
                        var stack = [];
                        stack.push(s.createHeaderLandscape(pdfInfo, filterView));
                        var margins = s.p("headerMargins")(s.p("pageMargins"));
                        return function () {
                            var st = [];
                            for (var i = 0; i < stack.length; i++) {
                                st[i] = _jquery2.default.extend(true, {}, stack[i]); // deep copy
                            }
                            return {
                                margin: margins,
                                stack: st
                            };
                        };
                    }();
                };
            } else {
                headerApplier = function headerApplier(pdfInfo, filterView) {
                    s.appendContentElement(s.createHeaderLandscape(pdfInfo, filterView));
                };
            }
            this._createHeader(showLogo, data, headerApplier);
        }

        /**
         * method calculate logo image dimensions for fit it to placeholder sizes and save ration
         * @param logoPicture logo picture (logo + sizes in pixels)
         * @returns {{w: number, h: number, mL: number, mT: number}}
         * @private
         */

    }, {
        key: "calculatePDFLogoDimensions",
        value: function calculatePDFLogoDimensions(logoPicture) {

            var maxW = this.p("logoPlaceholderSizes").width;
            var maxH = this.p("logoPlaceholderSizes").height;

            var widthInPix = logoPicture.width;
            var heightInPix = logoPicture.height;

            var ratioForPlace = maxW / maxH;
            var rationForPixSizes = widthInPix / heightInPix;

            var coeff = 0; // coeff for calculate pdf logo dimensions
            // if ration for placeholder(w/h) less than for image, then need to adjust max height of image or width otherwise
            if (ratioForPlace > rationForPixSizes) {
                coeff = heightInPix / maxH;
            } else {
                coeff = widthInPix / maxW;
            }
            var wInPDF = widthInPix / coeff;
            var hInPDF = heightInPix / coeff;
            return {
                w: wInPDF,
                h: hInPDF,
                mL: (maxW - wInPDF) / 2,
                mT: 0
            };
        }
    }, {
        key: "getDocDefinitionObject",
        value: function getDocDefinitionObject() {
            return this.dd;
        }
    }, {
        key: "addIconedNote",
        value: function addIconedNote(text) {
            var noteParameters = this.p("noteParameters");

            var body = [[{
                marginLeft: 0,
                width: 9,
                image: _PDFImageCache2.default.getImage("noteIcon")["image"]
            }, {
                marginLeft: noteParameters.marginLeft,
                fontSize: noteParameters.fontSize,
                text: text
            }]];

            this.appendContentElement({
                style: 'noteText',
                layout: 'noBordersNoPadding',
                marginTop: 5,
                table: {
                    widths: noteParameters.widths,
                    body: body
                }
            });
        }
    }, {
        key: "addNotes",
        value: function addNotes(text, asterisk, withMargin) {
            var noteParameters = this.p("noteParameters");
            var body = [[{
                marginLeft: 0,
                fontSize: noteParameters.asteriskSize,
                color: noteParameters.color,
                text: asterisk
            }, {
                marginLeft: noteParameters.marginLeft,
                fontSize: noteParameters.fontSize,
                text: text
            }]];

            this.appendContentElement({
                style: 'noteWithAsterisk',
                layout: 'noBordersNoPadding',
                marginTop: withMargin ? 20 : 5,
                table: {
                    widths: noteParameters.widths,
                    body: body
                }
            });
        }
    }]);

    return BasePDFDefinitionBuilder;
}();

exports.default = BasePDFDefinitionBuilder;


var baseStyles = {

    headerSeparator: {
        marginTop: 6,
        marginBottom: 8
    },
    titleLabel: {
        marginTop: 5,
        fontSize: 12,
        bold: true
    },

    dateRangeLabel: {
        marginTop: 5,
        fontSize: 12
    },

    filterView: {
        fillColor: '#EFEFEF',
        color: '#373737'
    },
    dataTable: {
        fontSize: 7,
        color: '#111111'
    },

    dataTableSmall: {
        fontSize: 5.4,
        color: '#111111'
    },
    secondDataRow: {
        fillColor: '#EFEFEF'
    },
    dataName: {
        alignment: 'left',
        margin: [10, 2, 0, 2]
    },
    dataNameSmall: {
        alignment: 'left',
        margin: [10, 0, 0, 0]
    },
    dataValue: {
        alignment: 'right',
        margin: [5, 2, 5, 2]
    },
    dataValueSmall: {
        alignment: 'right',
        margin: [5, 0, 5, 0]
    },
    dataValueWithPercents: {
        alignment: 'right',
        margin: [2, 2, 0, 2]
    },
    dataValueWithPercentsSmall: {
        alignment: 'right',
        margin: [2, 0, 0, 0]
    },
    footerTable: {
        margin: [23, 0, 23, 0],
        fontSize: 7
    },

    rightFooterPart: {
        alignment: 'right',
        color: '#3D3D3D'
    },
    leftFooterPart: {
        alignment: 'left',
        color: '#6A6A6A'
    },
    viewTTHeader: {
        fillColor: '#EFEFEF',
        color: '#373737',
        fontSize: 9,
        alignment: 'left',
        margin: [12, 9, 0, 9],
        border: 1
    },
    viewTTRows: {
        fontSize: 9,
        alignment: 'left'
    },

    coloredTime: {
        fillColor: '#f5f9fc',
        fontSize: 9,
        alignment: 'center'
    },

    coloredBoldTime: {
        bold: true,
        fillColor: '#ebf2f9'
    }
};

var baseParameters = {
    headerMargins: function headerMargins(pageMargins) {
        return [pageMargins[0], pageMargins[1], pageMargins[2], 0];
    },
    footerMargins: function footerMargins(pageMargins) {
        return [pageMargins[0], 0, pageMargins[2], 10];
    },


    Landscape: {
        logoPlaceholderSizes: {
            width: 100,
            height: 51
        },
        headerHeight: 51,
        headerBottomMargin: 5,
        pageOrientation: 'landscape',
        pageMargins: [56, 28, 56, 28],
        leaveTextLen: 36,
        itemTextLen: 80,

        noteParameters: {
            fontSize: 8,
            asteriskSize: 6,
            color: '#f58f0a',
            widths: ['2%', '98%'],
            marginLeft: 1
        },

        filterViewParameters: {
            margins: {
                top: 2
            },
            imageMargins: {
                top: 12,
                left: 10
            },
            firstRowMargins: {
                top: 12,
                bottom: 5
            },
            secondRowMargins: {
                bottom: 12
            },
            widths: ['12%', '88%'],
            imageWidth: 9,
            fontSize: 8
        },

        A4: {
            pageSize: 'A4',

            filterViewTextLen: 51, //57

            pdfInfoParameters: {
                withLogo: {
                    widths: ['25%', '75%']
                },
                withoutLogo: {
                    widths: ['0%', '100%']
                }
            }
        },

        Letter: {
            pageSize: 'Letter',

            filterViewTextLen: 48, //54

            pdfInfoParameters: {
                withLogo: {
                    widths: ['25%', '75%']
                },
                withoutLogo: {
                    widths: ['0%', '100%']
                }
            }
        }
    },
    Portrait: {
        logoPlaceholderSizes: {
            width: 100,
            height: 44
        },
        headerHeight: 102,
        headerBottomMargin: 5,
        pageOrientation: 'portrait',
        pageMargins: [40, 28, 40, 28],
        leaveTextLen: 24,
        itemTextLen: 40,

        noteParameters: {
            fontSize: 8,
            asteriskSize: 6,
            color: '#f58f0a',
            widths: ['2%', '98%'],
            marginLeft: 3
        },

        filterViewParameters: {
            margins: {
                top: 12
            },
            imageMargins: {
                top: 11,
                left: 12
            },
            firstRowMargins: {
                top: 10,
                bottom: 5
            },
            secondRowMargins: {
                bottom: 9
            },
            widths: ['6%', '94%'],
            imageWidth: 10,
            fontSize: 9
        },

        A4: {
            pageSize: 'A4',

            filterViewTextLen: 102, //108

            pdfInfoParameters: {
                withLogo: {
                    widths: ['22%', '78%']
                },
                withoutLogo: {
                    widths: ['0%', '100%']
                }
            }
        },
        Letter: {
            pageSize: 'Letter',

            filterViewTextLen: 105, // 111

            pdfInfoParameters: {
                withLogo: {
                    widths: ['22%', '78%']
                },
                withoutLogo: {
                    splitterLen: 533,
                    widths: ['0%', '100%']
                }
            }
        }
    }
};

var baseTabelLayouts = {
    noBordersNoPadding: {
        hLineWidth: function hLineWidth() {
            return 0;
        },
        vLineWidth: function vLineWidth() {
            return 0;
        },
        paddingLeft: function paddingLeft() {
            return 0;
        },
        paddingRight: function paddingRight() {
            return 0;
        },
        paddingTop: function paddingTop() {
            return 0;
        },
        paddingBottom: function paddingBottom() {
            return 0;
        }
    },
    simpleBorders: {
        hLineWidth: function hLineWidth() {
            return 1;
        },
        vLineWidth: function vLineWidth() {
            return 1;
        },
        paddingLeft: function paddingLeft() {
            return 0;
        },
        paddingRight: function paddingRight() {
            return 0;
        },
        paddingTop: function paddingTop() {
            return 0;
        },
        paddingBottom: function paddingBottom() {
            return 0;
        }
    },
    thinBordersNoPaddingsForFilterView: {
        hLineWidth: function hLineWidth() {
            return 0.4;
        },
        vLineWidth: function vLineWidth() {
            return 0.4;
        },
        paddingLeft: function paddingLeft() {
            return 0;
        },
        paddingRight: function paddingRight() {
            return 0;
        },
        paddingTop: function paddingTop() {
            return 0;
        },
        paddingBottom: function paddingBottom() {
            return 0;
        },
        hLineColor: function hLineColor() {
            return '#EFEFEF';
        },
        vLineColor: function vLineColor() {
            return '#EFEFEF';
        }
    },
    headerBorderSeparatedRows: {
        hLineWidth: function hLineWidth() {
            return 0.4;
        },
        vLineWidth: function vLineWidth() {
            return 0;
        },
        paddingLeft: function paddingLeft() {
            return 5;
        },
        paddingRight: function paddingRight() {
            return 5;
        },
        paddingTop: function paddingTop() {
            return 5;
        },
        paddingBottom: function paddingBottom() {
            return 5;
        },
        hLineColor: function hLineColor(i, node) {
            return i === 0 || i === node.table.body.length ? '#fbfbfb' : '#f0f0f0';
        },
        vLineColor: function vLineColor(i, node) {
            return i === 0 || i === node.table.widths.length ? 'red' : 'blue';
        }
    }
};

/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _DropdownDialog = __webpack_require__(185);

var _DropdownDialog2 = _interopRequireDefault(_DropdownDialog);

var _atBrowserUtils = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Created by evdokimov on 05.05.2016.
 */

function WarningsController() {
    this._warningsPopup = new _DropdownDialog2.default({
        wrapperClass: 'warningsPopup',
        dialogDiv: (0, _jquery2.default)(".warningsToShowDiv"),
        hideButtons: true,
        hideOnResize: true
    });
}

WarningsController.BOTTOM_BAR_HEIGHT = 29;

WarningsController.prototype.setInfoHoverEvents = function (noteJQEl, infos) {
    var self = this;

    noteJQEl.hover(function (e) {
        self.showWarningsPopup(infos, this, false);
        e.stopPropagation();
    }, function () {
        self.hideWarningsPopup();
    }).mousemove(function (e) {
        self.moveWarningsPopup(e, (0, _jquery2.default)(".warningsPopup"));
    });
};

WarningsController.prototype.setErrorHoverEvents = function (errorJQEl, errors) {
    var self = this;

    errorJQEl.hover(function (e) {
        self.showWarningsPopup(errors, this, false);
        e.stopPropagation();
    }, function () {
        self.hideWarningsPopup();
    }).mousemove(function (e) {
        self.moveWarningsPopup(e, (0, _jquery2.default)(".warningsPopup"));
    });
};

WarningsController.prototype.setWarnings = function (warningSection, warnings) {
    var warningEl = this._createWarningsElement(warnings);
    warningSection.replaceWith(warningEl);
};

WarningsController.prototype._createWarningsElement = function (warnings) {
    if (!warnings) return "<div class='warningsInRow'></div>";

    var warningSection = "<div class='warningsInRow'> <ul class='warning'>";

    var warning = warnings[0];
    warningSection += "<li class='firstWarning'>" + warning + "</li>";

    for (var i = 1; i < warnings.length; i++) {
        warning = warnings[i];
        warningSection += "<li>" + warning + "</li>";
    }
    warningSection += "</ul> </div>";

    return (0, _jquery2.default)(warningSection);
};

WarningsController.prototype.setClickEvents = function (noteJQEl, notes) {
    var self = this;
    noteJQEl.click(function (e) {
        (0, _jquery2.default)(".warningsToShowDiv").html((0, _jquery2.default)(".warningsDiv#" + (0, _jquery2.default)(this).attr('id')).html());
        self.showWarningsPopup(notes, this, true);
        e.stopPropagation();
    });
};

WarningsController.prototype.showWarningsPopup = function (warnings, icon, overlay) {
    var warning = warnings;

    var warningsDivContent = "<div class='firstWarning'>" + warning + "</div>";

    for (var i = 1; i < warnings.length; i++) {
        warning = warnings[i];
        warningsDivContent += "<div class='additionalWarning'>" + warning + "</div>";
    }

    (0, _jquery2.default)(".warningsToShowDiv").html(warningsDivContent);
    this._warningsPopup.showAt(icon, { offset: "-60px 7px", collision: "none" });
    if (!overlay) this._warningsPopup.removeOverlay();
};

WarningsController.prototype.hideWarningsPopup = function () {
    this._warningsPopup.hide();
};

WarningsController.prototype.moveWarningsPopup = function (event, popup) {
    popup.offset((0, _atBrowserUtils.calculateElementOffset)(popup.outerHeight(), popup.outerWidth(), event, WarningsController.BOTTOM_BAR_HEIGHT));
};

exports.default = WarningsController;

/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _BalanceRulesRenderer2 = __webpack_require__(390);

var _BalanceRulesRenderer3 = _interopRequireDefault(_BalanceRulesRenderer2);

var _constants = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ResetRulesCell = function (_BalanceRulesRenderer) {
    _inherits(ResetRulesCell, _BalanceRulesRenderer);

    function ResetRulesCell() {
        _classCallCheck(this, ResetRulesCell);

        return _possibleConstructorReturn(this, (ResetRulesCell.__proto__ || Object.getPrototypeOf(ResetRulesCell)).apply(this, arguments));
    }

    _createClass(ResetRulesCell, [{
        key: '_getRuleValue',
        value: function _getRuleValue(data) {
            return data.resetRule ? this.formatter(data.resetRule.value) + " " + (data.resetRule.frequency.type === _constants.CalendarFrequencyType.ON_HIRE_DATE ? _constants.CalendarFrequencyType.descriptionFor[data.resetRule.frequency.type] : "") + " " + _constants.CalendarFrequencyType.parametersFormatterFor[data.resetRule.frequency.type](data.resetRule.frequency.params) : "&ndash;";
        }
    }, {
        key: '_customClassName',
        value: function _customClassName(data) {
            return "resetRule";
        }
    }]);

    return ResetRulesCell;
}(_BalanceRulesRenderer3.default);

exports.default = ResetRulesCell;

/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _BalanceRulesRenderer2 = __webpack_require__(390);

var _BalanceRulesRenderer3 = _interopRequireDefault(_BalanceRulesRenderer2);

var _constants = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AccrualRulesCell = function (_BalanceRulesRenderer) {
    _inherits(AccrualRulesCell, _BalanceRulesRenderer);

    function AccrualRulesCell() {
        _classCallCheck(this, AccrualRulesCell);

        return _possibleConstructorReturn(this, (AccrualRulesCell.__proto__ || Object.getPrototypeOf(AccrualRulesCell)).apply(this, arguments));
    }

    _createClass(AccrualRulesCell, [{
        key: '_getRuleValue',
        value: function _getRuleValue(ptoData) {
            return ptoData.accrualRule ? this.formatter(ptoData.accrualRule.value) + " " + _constants.CalendarFrequencyType.descriptionFor[ptoData.accrualRule.frequency.type] : "&ndash;";
        }
    }, {
        key: '_customClassName',
        value: function _customClassName(ptoData) {
            return "accrualRule";
        }
    }]);

    return AccrualRulesCell;
}(_BalanceRulesRenderer3.default);

exports.default = AccrualRulesCell;

/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _UserListConfirmationConstants = __webpack_require__(1627);

var _UserListConfirmationConstants2 = _interopRequireDefault(_UserListConfirmationConstants);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function UserListConfirmation() {
    this.constructor = UserListConfirmation;
}

UserListConfirmation.prototype.WANT_TO_PROCEED_MESSAGE = _messageResource2.default.getMessage('userlist.js.confirmation.want_to_proceed');

UserListConfirmation.prototype.messageKeysMap = {};
UserListConfirmation.prototype.messageKeysMap[_UserListConfirmationConstants2.default.LAST_APPROVER_DISABLED] = EnabledFeatures.APWSD ? "userlist.js.confirmation.last_approver_disabled.wsd_feature_on" : "userlist.js.confirmation.last_approver_disabled";
UserListConfirmation.prototype.messageKeysMap[_UserListConfirmationConstants2.default.LAST_APPROVER_RIGHT_REVOKED] = "userlist.js.confirmation.last_approver_right_revoked";
UserListConfirmation.prototype.messageKeysMap[_UserListConfirmationConstants2.default.LAST_OTHER_PRODUCT_APPROVER_DISABLED] = "userlist.js.confirmation.last_other_product_approver_disabled";
UserListConfirmation.prototype.messageKeysMap[_UserListConfirmationConstants2.default.LAST_APPROVER_DELETED] = EnabledFeatures.APWSD ? "userlist.js.confirmation.last_approver_deleted.wsd_feature_on" : "userlist.js.confirmation.last_approver_deleted";
UserListConfirmation.prototype.messageKeysMap[_UserListConfirmationConstants2.default.LAST_OTHER_PRODUCT_APPROVER_DELETED] = "userlist.js.confirmation.last_other_product_approver_deleted";
UserListConfirmation.prototype.messageKeysMap[_UserListConfirmationConstants2.default.HAS_LEAVE_REQUESTS] = "userlist.js.confirmation.requests_exist";

// no extension. same messages
UserListConfirmation.prototype.messageKeysMapIfDisabledDueToHDInThisProduct = _jquery2.default.extend({}, UserListConfirmation.prototype.messageKeysMap);

UserListConfirmation.prototype._createConfirmationMsg = function (confirmationException, msgKeyMap) {
    var codes = confirmationException.confirmationCodes;

    var length = codes.length;
    var confirmationMessages = [];

    for (var i = 0; i < length; i++) {
        confirmationMessages[i] = _messageResource2.default.getMessage(msgKeyMap[codes[i]]);
    }

    confirmationMessages.push(this.WANT_TO_PROCEED_MESSAGE);

    return confirmationMessages.join('\n\n');
};

UserListConfirmation.prototype.createEditConfirmationMsg = function (confirmationException) {
    return this._createConfirmationMsg(confirmationException, this.messageKeysMap);
};

UserListConfirmation.prototype.createDeleteConfirmationMsg = function (confirmationException) {
    return this._createConfirmationMsg(confirmationException, this.messageKeysMap);
};

exports.default = UserListConfirmation;

/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _BasicLightbox2 = __webpack_require__(163);

var _BasicLightbox3 = _interopRequireDefault(_BasicLightbox2);

var _ScrollUtils = __webpack_require__(39);

var _ScrollUtils2 = _interopRequireDefault(_ScrollUtils);

var _index = __webpack_require__(48);

var _index2 = _interopRequireDefault(_index);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PermissionsDescriptionLightBox = function (_BasicLightbox) {
    _inherits(PermissionsDescriptionLightBox, _BasicLightbox);

    function PermissionsDescriptionLightBox() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            _ref$additionalClass = _ref.additionalClass,
            additionalClass = _ref$additionalClass === undefined ? '' : _ref$additionalClass,
            _ref$onClickDialogCon = _ref.onClickDialogContent,
            onClickDialogContent = _ref$onClickDialogCon === undefined ? function () {} : _ref$onClickDialogCon;

        _classCallCheck(this, PermissionsDescriptionLightBox);

        var _this = _possibleConstructorReturn(this, (PermissionsDescriptionLightBox.__proto__ || Object.getPrototypeOf(PermissionsDescriptionLightBox)).call(this));

        _this.additionalClass = additionalClass;
        _this.exist_invalid_fields_message_key = "";
        _this.close_tab_confirmation_message_key = "";
        _this.moireDivId = "permissionsMoireDiv";

        _this.params = {
            onClickDialogContent: onClickDialogContent
        };
        return _this;
    }

    _createClass(PermissionsDescriptionLightBox, [{
        key: "show",
        value: function show() {
            // this is place where we can place additional class, used in UserATProfileSection.js
            this.getPopupEl().addClass(this.additionalClass);
            _get(PermissionsDescriptionLightBox.prototype.__proto__ || Object.getPrototypeOf(PermissionsDescriptionLightBox.prototype), "show", this).call(this);
            if (_.isUndefined(this.verticalScroll)) this.verticalScroll = _ScrollUtils2.default.addVerticalScroll((0, _jquery2.default)("#permissionsDescriptionContainer"));
        }
    }, {
        key: "hide",
        value: function hide() {
            _get(PermissionsDescriptionLightBox.prototype.__proto__ || Object.getPrototypeOf(PermissionsDescriptionLightBox.prototype), "hide", this).call(this);
            this.getPopupEl().removeClass(this.additionalClass);
        }
    }, {
        key: "init",
        value: function init($elementToCallPopup) {
            var _this2 = this;

            _get(PermissionsDescriptionLightBox.prototype.__proto__ || Object.getPrototypeOf(PermissionsDescriptionLightBox.prototype), "init", this).call(this, "permissionsInfoLightBox", "closePermissionsDescriptionLightBoxBtn");
            var self = this;
            this.setCancelCallback(function () {
                return self.hide();
            });
            $elementToCallPopup.on("click", function () {
                return self.show();
            });
            this.getPopupEl().click(function (e) {
                return _this2.params.onClickDialogContent(e);
            });
            (0, _jquery2.default)(this.getMoireDiv()).click(function (e) {
                return _this2.params.onClickDialogContent(e);
            });
        }
    }, {
        key: "restoreOnKeyDownHandler",
        value: function restoreOnKeyDownHandler() {
            if (this.removeHandler) this.removeHandler();
        }
    }, {
        key: "setupKeyDownHandler",
        value: function setupKeyDownHandler() {
            var _this3 = this;

            this.removeHandler = _index2.default.onKeyDown(function (code) {
                if ((0, _index.isEsc)(code)) {
                    _this3.hide();
                    return true;
                }
            });
        }
    }]);

    return PermissionsDescriptionLightBox;
}(_BasicLightbox3.default);

exports.default = PermissionsDescriptionLightBox;

/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Ext = __webpack_require__(12);

var _Ext2 = _interopRequireDefault(_Ext);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _BalanceType = __webpack_require__(253);

var _BalanceType2 = _interopRequireDefault(_BalanceType);

var _constants = __webpack_require__(4);

var _number_formatter = __webpack_require__(61);

var _number_formatter2 = _interopRequireDefault(_number_formatter);

var _DropdownDialog = __webpack_require__(185);

var _DropdownDialog2 = _interopRequireDefault(_DropdownDialog);

var _keyCodes = __webpack_require__(66);

var _DecimalField = __webpack_require__(859);

var _DecimalField2 = _interopRequireDefault(_DecimalField);

var _atUtils = __webpack_require__(5);

var _at_elastic_textarea = __webpack_require__(839);

var _at_elastic_textarea2 = _interopRequireDefault(_at_elastic_textarea);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Requires: DropdownDialog.js, at_elastic_textarea.js, smart_field.js, system_settings_js.jsp,
 *           jquery_rpc.js, message_resources.js with 'leave_balance_editor' & 'common' prefixes
 * Markup: leave_balance_editor.jsp
 *
 * @author kostenko
 *
 * @name LeaveBalanceCorrectionType defined in constants_js.jsp
 * @name LeaveBalanceCorrectionType.SET
 * @name LeaveBalanceCorrectionType.ADD
 * @name LeaveBalanceCorrectionType.SUB
 * @name LeaveBalanceUnits defined in constants_js.jsp
 * @name LeaveBalanceUnits.DAYS
 * @name LeaveBalanceUnits.HOURS
 * @name SystemSettings defined in system_settings_js.jsp
 * @name SystemSettings.decimalSeparator
 * @name SystemSettings.showPTOInHours
 * @name SystemSettings.showSickInHours
 */
function LeaveBalanceEditor(element) {
    var MAX_FRACTION_DIGITS = 2;
    var MAX_COMMENT_LENGTH = 2000;

    this.show = function (element, baseValueInDays, userName, ptoHoursPerDay, balanceType) {
        setCorrectionMode(_constants.LeaveBalanceCorrectionType.SET);
        currentPtoHoursPerDay = ptoHoursPerDay;
        currentBalanceType = balanceType;
        var showBalanceInHours = balanceType == _BalanceType2.default.PTO ? window.SystemSettings.showPTOInHours : window.SystemSettings.showSickInHours;
        setUnits(showBalanceInHours ? _constants.LeaveBalanceUnits.HOURS : _constants.LeaveBalanceUnits.DAYS);
        currentUserName = userName;

        hardValueField.setValueAsNumber(recalculateValueFrom(_constants.LeaveBalanceUnits.DAYS, baseValueInDays));

        contentDiv.find(".inDaysMode .baseValue").text(formatter.format(baseValueInDays));
        contentDiv.find(".inHoursMode .baseValue").text(formatter.format(daysToHours(baseValueInDays)));

        relativeValueField.setValue('');
        relativeValueField.clearValidationResult(); // don't highlight although it's empty, only highlight on apply

        hideError();

        (0, _jquery2.default)(commentsArea.textarea.dom).pVal("");

        this.busyModeOff();
        dropdownDialog.showAt(element, { my: "left top", at: "left top" });
        focusField();
        commentsArea.fitToHeight();
    };

    this.hide = function () {
        this.busyModeOff();
        dropdownDialog.hide();
    };

    this.busyModeOff = function () {
        applyButton.prop('disabled', false);
        applyButton.removeClass('savingMode');
        dropdownDialog.allowClose();
    };

    this.showCapExceededError = function (capInDays) {
        this.busyModeOff();
        var key;
        if (currentBalanceType == _BalanceType2.default.PTO) key = units == _constants.LeaveBalanceUnits.DAYS ? "common.pto_error.cap_exceeded.days" : "common.pto_error.cap_exceeded.hours";else key = units == _constants.LeaveBalanceUnits.DAYS ? "common.sick_error.cap_exceeded.days" : "common.sick_error.cap_exceeded.hours";
        var value = formatter.format(recalculateValueFrom(_constants.LeaveBalanceUnits.DAYS, capInDays));
        blinkError(_messageResource2.default.getMessage(key, [value]));
    };

    /**
     * @param callback function( correctionType, valueInDays, comment )
     */
    this.setOnApplyCallback = function (callback) {
        onApplyCallback = callback;
    };

    this.setOnCloseCallback = function (callback) {
        onCloseCallback = callback;
    };

    var correctionType;
    var units;
    var contentDiv = element;
    var applyButton = contentDiv.find(".applyButton");
    var onApplyCallback;
    var onCloseCallback;
    var formatter = new _number_formatter2.default(window.SystemSettings.decimalSeparator, null, MAX_FRACTION_DIGITS, true);
    var currentUserName;
    var currentPtoHoursPerDay;
    var currentBalanceType;

    var balanceCorrectionMenu = new _Ext2.default.menu.Menu({
        items: [{
            text: _messageResource2.default.getMessage("leave_balance_editor.set_hard_value"),
            cls: "hard",
            listeners: {
                click: function click() {
                    setCorrectionMode(_constants.LeaveBalanceCorrectionType.SET);
                }
            }
        }, {
            text: _messageResource2.default.getMessage("leave_balance_editor.increase"),
            cls: "increase",
            listeners: {
                click: function click() {
                    setCorrectionMode(_constants.LeaveBalanceCorrectionType.ADD);
                }
            }
        }, {
            text: _messageResource2.default.getMessage("leave_balance_editor.decrease"),
            cls: "decrease",
            listeners: {
                click: function click() {
                    setCorrectionMode(_constants.LeaveBalanceCorrectionType.SUB);
                }
            }
        }],
        cls: "at-dropdown-list-btn-menu leaveBalanceEditorMode"
    });

    contentDiv.find('.correctionTypeButton').click(function () {
        balanceCorrectionMenu.show(this);
    });

    var hardValueErrorText = _messageResource2.default.getMessage('common.js.invalid_number', window.SystemSettings.decimalSeparator);
    var relativeValueErrorText = _messageResource2.default.getMessage('common.js.invalid_number.positive', window.SystemSettings.decimalSeparator);

    var hardValueField = new _DecimalField2.default(contentDiv.find('.hardValueField'), false, 7, MAX_FRACTION_DIGITS, window.SystemSettings.decimalSeparator, true, window.SystemSettings.digitGroupingSymbol, hardValueErrorText);
    var relativeValueField = new _DecimalField2.default(contentDiv.find('.relativeValueField'), false, 7, MAX_FRACTION_DIGITS, window.SystemSettings.decimalSeparator, false, window.SystemSettings.digitGroupingSymbol, relativeValueErrorText, false);

    contentDiv.find('.hardValueField').keypress(field_keypress);
    contentDiv.find('.relativeValueField').keypress(field_keypress);

    contentDiv.find(".daysButton").click(function () {
        setUnits(_constants.LeaveBalanceUnits.DAYS);
    });

    contentDiv.find(".hoursButton").click(function () {
        setUnits(_constants.LeaveBalanceUnits.HOURS);
    });

    applyButton.click(apply);

    var that = this;
    var dropdownDialog = new _DropdownDialog2.default({
        dialogDiv: contentDiv,
        hideButtons: true,
        wrapperClass: 'leaveBalanceEditor customPopup',
        showEmptyTitleBar: true,
        hideOnResize: true,
        onClose: function onClose() {
            if (onCloseCallback) onCloseCallback();
        }
    });

    var commentsArea = new _at_elastic_textarea2.default({ textarea: contentDiv.find(".comments")[0], expandMin: 19, expandMax: 200 });
    (0, _jquery2.default)(commentsArea.textarea.dom).placeholder();

    function field_keypress(event) {
        if (event.keyCode == _keyCodes.KEY_CODE_ENTER) {
            apply();
            return false;
        }

        return true;
    }

    function setCorrectionMode(mode) {
        balanceCorrectionMenu.hide();
        correctionType = mode;
        contentDiv.toggleClass('hardValueMode', correctionType == _constants.LeaveBalanceCorrectionType.SET);
        contentDiv.toggleClass('increaseValueMode', correctionType == _constants.LeaveBalanceCorrectionType.ADD);
        contentDiv.toggleClass('decreaseValueMode', correctionType == _constants.LeaveBalanceCorrectionType.SUB);
        focusField();
    }

    function setUnits(newUnits) {
        var oldUnits = units;
        units = newUnits;

        contentDiv.toggleClass('daysMode', units == _constants.LeaveBalanceUnits.DAYS);
        contentDiv.toggleClass('hoursMode', units == _constants.LeaveBalanceUnits.HOURS);

        recalculateFieldFrom(oldUnits, hardValueField);
        recalculateFieldFrom(oldUnits, relativeValueField);
    }

    function recalculateFieldFrom(oldUnits, field) {
        if (field.isValid()) field.setValueAsNumber(recalculateValueFrom(oldUnits, field.getValueAsNumber()));
    }

    function recalculateValueFrom(oldUnits, value) {
        if (oldUnits == _constants.LeaveBalanceUnits.DAYS && units == _constants.LeaveBalanceUnits.HOURS) return daysToHours(value);

        if (oldUnits == _constants.LeaveBalanceUnits.HOURS && units == _constants.LeaveBalanceUnits.DAYS) return hoursToDays(value);

        return value;
    }

    function daysToHours(days) {
        return days * currentPtoHoursPerDay;
    }

    function hoursToDays(hours) {
        return hours / currentPtoHoursPerDay;
    }

    function focusField() {
        if (correctionType == _constants.LeaveBalanceCorrectionType.SET) hardValueField.focus();else relativeValueField.focus();
    }

    function blinkError(message) {
        contentDiv.find('.errorTextCell').text(message);
        contentDiv.addClass('errorState').addClass('blinkError');

        setTimeout(function () {
            contentDiv.removeClass('blinkError');
        }, 200);
    }

    function hideError() {
        contentDiv.removeClass('errorState');
    }

    function apply() {
        var comment = _jquery2.default.trim((0, _jquery2.default)(commentsArea.textarea.dom).pVal());

        (0, _jquery2.default)(commentsArea.textarea.dom).pVal(comment);
        commentsArea.fitToHeight();

        var field = correctionType == _constants.LeaveBalanceCorrectionType.SET ? hardValueField : relativeValueField;

        field.process();

        if (field.isValid()) {
            var commentLength = (0, _atUtils.getStringWithUnifiedNewLineSymbol)(comment).length;

            if (commentLength <= MAX_COMMENT_LENGTH) {
                applyButton.prop('disabled', true);
                applyButton.addClass('savingMode');
                dropdownDialog.preventClose();

                var value = field.getValueAsNumber();

                if (units == _constants.LeaveBalanceUnits.HOURS) value = hoursToDays(value);

                if (onApplyCallback) onApplyCallback(correctionType, value, comment);
            } else {
                blinkError(_messageResource2.default.getMessage("common.pto_error.comments_too_long", [MAX_COMMENT_LENGTH, commentLength]));
            }
        } else {
            blinkError(field == hardValueField ? hardValueErrorText : relativeValueErrorText);
        }
    }
}

exports.default = LeaveBalanceEditor;

/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (getEditorState) {
    var getEditingUserId = function getEditingUserId(state) {
        return getEditorState(state).editingUserId;
    };

    var showEditor = (0, _reselect.createSelector)(getEditingUserId, function (userId) {
        return userId !== null;
    });

    var isLoaded = function isLoaded(state) {
        return getEditorState(state).loaded;
    };

    var isLoading = function isLoading(state) {
        return getEditorState(state).loading;
    };

    var areCustomersLoaded = function areCustomersLoaded(state) {
        return getEditorState(state).customersLoaded;
    };

    var areProjectsLoaded = function areProjectsLoaded(state) {
        return getEditorState(state).projectsLoaded;
    };

    var areTasksLoaded = function areTasksLoaded(state) {
        return getEditorState(state).tasksLoaded;
    };

    var getEditingLevel = function getEditingLevel(state) {
        return getEditorState(state).editingLevel;
    };

    var canManageParentCustomer = function canManageParentCustomer(state) {
        return getEditorState(state).canManageParentCustomer;
    };

    var canManageParentProject = function canManageParentProject(state) {
        return getEditorState(state).canManageParentProject;
    };

    var isCustomersLevelSelected = (0, _reselect.createSelector)(getEditingLevel, function (level) {
        return !level.customerId && !level.projectId;
    });

    var isProjectsLevelSelected = (0, _reselect.createSelector)(getEditingLevel, function (level) {
        return !!level.customerId && !level.projectId;
    });

    var isTasksLevelSelected = (0, _reselect.createSelector)(getEditingLevel, function (level) {
        return !!level.customerId && !!level.projectId;
    });

    var needMoreCustomers = (0, _reselect.createSelector)(showEditor, isCustomersLevelSelected, isLoading, areCustomersLoaded, function (show, levelSelected, loading, loaded) {
        return (0, _utils.needMoreEntities)(show, levelSelected, loading, loaded);
    });

    var needMoreProjects = (0, _reselect.createSelector)(showEditor, isProjectsLevelSelected, isLoading, areProjectsLoaded, function (show, levelSelected, loading, loaded) {
        return (0, _utils.needMoreEntities)(show, levelSelected, loading, loaded);
    });

    var needMoreTasks = (0, _reselect.createSelector)(showEditor, isTasksLevelSelected, isLoading, areTasksLoaded, function (show, levelSelected, loading, loaded) {
        return (0, _utils.needMoreEntities)(show, levelSelected, loading, loaded);
    });

    var getCustomerIdsOrder = function getCustomerIdsOrder(state) {
        return getEditorState(state).customerIdsOrder;
    };

    var getProjectIdsOrder = function getProjectIdsOrder(state) {
        return getEditorState(state).projectIdsOrder;
    };

    var getTaskIdsOrder = function getTaskIdsOrder(state) {
        return getEditorState(state).taskIdsOrder;
    };

    var areFutureCustomersAssigned = function areFutureCustomersAssigned(state) {
        return getEditorState(state).futureCustomersAssigned;
    };

    var areFutureProjectsAssigned = function areFutureProjectsAssigned(state) {
        return getEditorState(state).futureProjectsAssigned;
    };

    var areFutureTasksAssigned = function areFutureTasksAssigned(state) {
        return getEditorState(state).futureTasksAssigned;
    };

    var getCanWorkCustomerIds = function getCanWorkCustomerIds(state) {
        return getEditorState(state).canWorkCustomerIds;
    };

    var getCanManageCustomerIds = function getCanManageCustomerIds(state) {
        return getEditorState(state).canManageCustomerIds;
    };

    var getCanManageCustomerExcludeSelfIds = function getCanManageCustomerExcludeSelfIds(state) {
        return getEditorState(state).canManageCustomerExcludeSelfIds;
    };

    var getCanWorkProjectIds = function getCanWorkProjectIds(state) {
        return getEditorState(state).canWorkProjectIds;
    };

    var getCanManageProjectIds = function getCanManageProjectIds(state) {
        return getEditorState(state).canManageProjectIds;
    };

    var getCanManageProjectExcludeSelfIds = function getCanManageProjectExcludeSelfIds(state) {
        return getEditorState(state).canManageProjectExcludeSelfIds;
    };

    var getCanWorkTaskIds = function getCanWorkTaskIds(state) {
        return getEditorState(state).canWorkTaskIds;
    };

    var getCanManageTaskIds = function getCanManageTaskIds(state) {
        return getEditorState(state).canManageTaskIds;
    };

    var getProjectCountsByCustomers = function getProjectCountsByCustomers(state) {
        return getEditorState(state).projectCountsByCustomers;
    };

    var getTaskCountsByCustomers = function getTaskCountsByCustomers(state) {
        return getEditorState(state).taskCountsByCustomers;
    };

    var getTaskCountsByProjects = function getTaskCountsByProjects(state) {
        return getEditorState(state).taskCountsByProjects;
    };

    var areSomeCustomersOrLowerAssigned = function areSomeCustomersOrLowerAssigned(state) {
        return getEditorState(state).someCustomersOrLowerAssigned;
    };

    var areAllCustomersAssigned = function areAllCustomersAssigned(state) {
        return getEditorState(state).allCustomersAssigned;
    };

    var areSomeProjectsOrLowerAssigned = function areSomeProjectsOrLowerAssigned(state) {
        return getEditorState(state).someProjectsOrLowerAssigned;
    };

    var areAllProjectsAssigned = function areAllProjectsAssigned(state) {
        return getEditorState(state).allProjectsAssigned;
    };

    var areSomeTasksAssigned = function areSomeTasksAssigned(state) {
        return getEditorState(state).someTasksAssigned;
    };

    var areAllTasksAssigned = function areAllTasksAssigned(state) {
        return getEditorState(state).allTasksAssigned;
    };

    var getChangingCustomerAssignments = function getChangingCustomerAssignments(state) {
        return getEditorState(state).changingCustomerAssignments;
    };

    var getChangingProjectAssignments = function getChangingProjectAssignments(state) {
        return getEditorState(state).changingProjectAssignments;
    };

    var getChangingTaskAssignments = function getChangingTaskAssignments(state) {
        return getEditorState(state).changingTaskAssignments;
    };

    var isChangingAllAssignments = function isChangingAllAssignments(state) {
        return getEditorState(state).changingAllAssignments;
    };

    var getCustomersSearchOpen = function getCustomersSearchOpen(state) {
        return getEditorState(state).customersSearchOpen;
    };

    var getCustomersSearchText = function getCustomersSearchText(state) {
        return getEditorState(state).customersSearchText;
    };

    var getProjectsSearchOpen = function getProjectsSearchOpen(state) {
        return getEditorState(state).projectsSearchOpen;
    };

    var getProjectsSearchText = function getProjectsSearchText(state) {
        return getEditorState(state).projectsSearchText;
    };

    var getTasksSearchOpen = function getTasksSearchOpen(state) {
        return getEditorState(state).tasksSearchOpen;
    };

    var getTasksSearchText = function getTasksSearchText(state) {
        return getEditorState(state).tasksSearchText;
    };

    var getViewerCanManageCustomerIds = function getViewerCanManageCustomerIds(state) {
        return getEditorState(state).viewerCanManageCustomerIds;
    };

    var getViewerCanManageProjectIds = function getViewerCanManageProjectIds(state) {
        return getEditorState(state).viewerCanManageProjectIds;
    };

    return {
        getEditingUserId: getEditingUserId,
        showEditor: showEditor,
        isLoaded: isLoaded,
        needMoreCustomers: needMoreCustomers,
        needMoreProjects: needMoreProjects,
        needMoreTasks: needMoreTasks,
        isCustomersLevelSelected: isCustomersLevelSelected,
        isProjectsLevelSelected: isProjectsLevelSelected,
        isTasksLevelSelected: isTasksLevelSelected,
        areCustomersLoaded: areCustomersLoaded,
        areProjectsLoaded: areProjectsLoaded,
        areTasksLoaded: areTasksLoaded,
        getEditingLevel: getEditingLevel,
        getCustomerIdsOrder: getCustomerIdsOrder,
        getProjectIdsOrder: getProjectIdsOrder,
        getTaskIdsOrder: getTaskIdsOrder,
        areFutureCustomersAssigned: areFutureCustomersAssigned,
        areFutureProjectsAssigned: areFutureProjectsAssigned,
        areFutureTasksAssigned: areFutureTasksAssigned,
        getCanWorkCustomerIds: getCanWorkCustomerIds,
        getCanManageCustomerIds: getCanManageCustomerIds,
        getCanManageCustomerExcludeSelfIds: getCanManageCustomerExcludeSelfIds,
        getCanWorkProjectIds: getCanWorkProjectIds,
        getCanManageProjectIds: getCanManageProjectIds,
        getCanManageProjectExcludeSelfIds: getCanManageProjectExcludeSelfIds,
        getCanWorkTaskIds: getCanWorkTaskIds,
        getCanManageTaskIds: getCanManageTaskIds,
        getProjectCountsByCustomers: getProjectCountsByCustomers,
        getTaskCountsByCustomers: getTaskCountsByCustomers,
        getTaskCountsByProjects: getTaskCountsByProjects,
        areSomeCustomersOrLowerAssigned: areSomeCustomersOrLowerAssigned,
        areAllCustomersAssigned: areAllCustomersAssigned,
        areSomeProjectsOrLowerAssigned: areSomeProjectsOrLowerAssigned,
        areAllProjectsAssigned: areAllProjectsAssigned,
        areSomeTasksAssigned: areSomeTasksAssigned,
        areAllTasksAssigned: areAllTasksAssigned,
        isLoading: isLoading,
        getChangingCustomerAssignments: getChangingCustomerAssignments,
        getChangingProjectAssignments: getChangingProjectAssignments,
        getChangingTaskAssignments: getChangingTaskAssignments,
        isChangingAllAssignments: isChangingAllAssignments,
        getCustomersSearchOpen: getCustomersSearchOpen,
        getCustomersSearchText: getCustomersSearchText,
        getProjectsSearchOpen: getProjectsSearchOpen,
        getProjectsSearchText: getProjectsSearchText,
        getTasksSearchOpen: getTasksSearchOpen,
        getTasksSearchText: getTasksSearchText,
        getViewerCanManageCustomerIds: getViewerCanManageCustomerIds,
        getViewerCanManageProjectIds: getViewerCanManageProjectIds,
        canManageParentCustomer: canManageParentCustomer,
        canManageParentProject: canManageParentProject
    };
};

var _reselect = __webpack_require__(13);

var _utils = __webpack_require__(393);

/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.archivedComparator = exports.getSortedCustomerIdsByName = exports.getSortedProjectIdsByName = exports.getSortedTaskIdsByName = exports.getTaskMaEntities = exports.getTaskWaEntities = exports.getProjectWaEntities = exports.getProjectMaEntities = exports.getCustomerMaEntities = exports.getCustomerWaEntities = exports.createNodesForTaskList = exports.createNodesForProjectList = exports.entirelyAssignedTaskTitle = exports.entirelyAssignedProjectTitle = exports.entirelyAssignedCustomerTitle = exports.createNodesForCustomerList = exports.filterIdsBySearch = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _StringIndex = __webpack_require__(115);

var _StringIndex2 = _interopRequireDefault(_StringIndex);

var _constants = __webpack_require__(4);

var _TokensHighlighter = __webpack_require__(94);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _atUtils = __webpack_require__(5);

var _pluralizeUtils = __webpack_require__(40);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var filterIdsBySearch = exports.filterIdsBySearch = function filterIdsBySearch(ids, entities, search) {
    var searchIds = ids;

    if (search) {
        var stringIndex = new _StringIndex2.default();
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            for (var _iterator = searchIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var id = _step.value;

                var entity = entities[id];
                stringIndex.add(entity.name, entity.id);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }

        var tokens = stringIndex.getTokenizer().getTokens(search.toLowerCase());
        searchIds = Object.keys(stringIndex.search(tokens)).map(function (a) {
            return parseInt(a);
        });
    }
    return searchIds;
};

var createNodesForCustomerList = exports.createNodesForCustomerList = function createNodesForCustomerList(nodeEntities, searchText, revokeMap, isShowArchived) {
    var tokensHighlighter = (0, _TokensHighlighter.createTokensHighlighterForSearch)(searchText);
    var customerRevoked = revokeMap[_constants.HierarchyLevels.CUSTOMER];
    var nodeProperties = [];
    var countArchiveCustomers = 0;

    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
        for (var _iterator2 = nodeEntities[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var entity = _step2.value;


            if (!isShowArchived && entity.archived) {
                countArchiveCustomers++;
                continue;
            }

            nodeProperties.push(getCustomerNodeProperty({
                entity: entity,
                isShowArchived: isShowArchived,
                tokensHighlighter: tokensHighlighter,
                customerRevoked: customerRevoked,
                hierarchyLevel: _constants.HierarchyLevels.CUSTOMER
            }));
        }
    } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
            }
        } finally {
            if (_didIteratorError2) {
                throw _iteratorError2;
            }
        }
    }

    countArchiveCustomers && nodeProperties.push(getNodeProperty({
        isShowArchived: isShowArchived,
        entity: {},
        highlightedTitle: _messageResource2.default.getEscapedMessage("panel.common.archived_customers", [countArchiveCustomers]),
        additionalClass: "customer_row_archived"
    }));

    return nodeProperties;
};

var entirelyAssignedCustomerTitle = exports.entirelyAssignedCustomerTitle = function entirelyAssignedCustomerTitle(currentLevel, prevLevel) {
    return "";
};

var entirelyAssignedProjectTitle = exports.entirelyAssignedProjectTitle = function entirelyAssignedProjectTitle(currentLevel, prevLevel) {
    var message = "work_assignments.panel.projects.entirely";
    return currentLevel !== 0 ? _messageResource2.default.getMessage(message, [currentLevel, (0, _pluralizeUtils.projectNameLower)(currentLevel), prevLevel, (0, _pluralizeUtils.customerNameLower)(prevLevel)]) : "";
};

var entirelyAssignedTaskTitle = exports.entirelyAssignedTaskTitle = function entirelyAssignedTaskTitle(currentLevel, prevLevel) {
    var message = "work_assignments.panel.tasks.entirely";
    return currentLevel !== 0 ? _messageResource2.default.getMessage(message, [currentLevel, (0, _pluralizeUtils.taskNameLower)(currentLevel), prevLevel, (0, _pluralizeUtils.projectNameLower)(prevLevel)]) : "";
};

var createNodesForProjectList = exports.createNodesForProjectList = function createNodesForProjectList(nodeEntities, searchText, revokeMap, isShowArchived) {
    var tokensHighlighter = (0, _TokensHighlighter.createTokensHighlighterForSearch)(searchText);
    var nodeProperties = [];
    var customerRevoked = revokeMap[_constants.HierarchyLevels.CUSTOMER];
    var projectRevoked = revokeMap[_constants.HierarchyLevels.PROJECT];
    var countArchiveProject = 0;

    var _iteratorNormalCompletion3 = true;
    var _didIteratorError3 = false;
    var _iteratorError3 = undefined;

    try {
        for (var _iterator3 = nodeEntities[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var entity = _step3.value;


            var nodeProperty = {};

            if (!isShowArchived && entity.archived) {
                entity.type === _constants.HierarchyLevels.PROJECT && countArchiveProject++;
                continue;
            }

            switch (entity.type) {
                case _constants.HierarchyLevels.CUSTOMER:
                    nodeProperty = getCustomerNodeProperty({
                        entity: entity,
                        isShowArchived: isShowArchived,
                        customerRevoked: customerRevoked,
                        hierarchyLevel: _constants.HierarchyLevels.PROJECT
                    });
                    break;
                case _constants.HierarchyLevels.PROJECT:
                    nodeProperty = getProjectNodeProperty({
                        entity: entity,
                        isShowArchived: isShowArchived,
                        tokensHighlighter: tokensHighlighter,
                        projectRevoked: projectRevoked,
                        hierarchyLevel: _constants.HierarchyLevels.PROJECT
                    });
                    break;
            }

            nodeProperties.push(nodeProperty);
        }
    } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion3 && _iterator3.return) {
                _iterator3.return();
            }
        } finally {
            if (_didIteratorError3) {
                throw _iteratorError3;
            }
        }
    }

    countArchiveProject && nodeProperties.push(getNodeProperty({
        isShowArchived: isShowArchived,
        entity: {},
        highlightedTitle: _messageResource2.default.getEscapedMessage("panel.common.archived_projects", [countArchiveProject]),
        additionalClass: "customer_row_archived"
    }));

    return nodeProperties;
};

var createNodesForTaskList = exports.createNodesForTaskList = function createNodesForTaskList(nodeEntities, searchText, revokeMap, isShowArchived) {
    var tokensHighlighter = (0, _TokensHighlighter.createTokensHighlighterForSearch)(searchText);
    var nodeProperties = [];
    var customerRevoked = revokeMap[_constants.HierarchyLevels.CUSTOMER];
    var projectRevoked = revokeMap[_constants.HierarchyLevels.PROJECT];
    var taskRevoked = revokeMap[_constants.HierarchyLevels.TASK];

    var countCompletedTask = 0;

    var _iteratorNormalCompletion4 = true;
    var _didIteratorError4 = false;
    var _iteratorError4 = undefined;

    try {
        for (var _iterator4 = nodeEntities[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
            var entity = _step4.value;


            if (!isShowArchived && (entity.completed || entity.archived)) {
                entity.type === _constants.HierarchyLevels.TASK && countCompletedTask++;
                continue;
            }

            var nodeProperty = {};

            switch (entity.type) {
                case _constants.HierarchyLevels.CUSTOMER:
                    nodeProperty = getCustomerNodeProperty({
                        entity: entity,
                        isShowArchived: isShowArchived,
                        customerRevoked: customerRevoked,
                        hierarchyLevel: _constants.HierarchyLevels.TASK
                    });
                    break;
                case _constants.HierarchyLevels.PROJECT:
                    nodeProperty = getProjectNodeProperty({
                        entity: entity,
                        isShowArchived: isShowArchived,
                        projectRevoked: projectRevoked,
                        hierarchyLevel: _constants.HierarchyLevels.TASK
                    });
                    break;
                case _constants.HierarchyLevels.TASK:
                    nodeProperty = getTaskNodeProperty({
                        entity: entity,
                        isShowArchived: isShowArchived,
                        tokensHighlighter: tokensHighlighter,
                        taskRevoked: taskRevoked
                    });
                    break;
            }

            nodeProperties.push(nodeProperty);
        }
    } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion4 && _iterator4.return) {
                _iterator4.return();
            }
        } finally {
            if (_didIteratorError4) {
                throw _iteratorError4;
            }
        }
    }

    countCompletedTask && nodeProperties.push(getNodeProperty({
        isShowArchived: isShowArchived,
        entity: {},
        highlightedTitle: _messageResource2.default.getEscapedMessage("panel.common.archived_tasks", [countCompletedTask]),
        additionalClass: "customer_row_archived"
    }));

    return nodeProperties;
};

var getCustomerWaEntities = exports.getCustomerWaEntities = function getCustomerWaEntities(ids, customers, manageCustomersIds, manageCustomersExcludingSelfIds) {
    var customerEntities = [];
    var _iteratorNormalCompletion5 = true;
    var _didIteratorError5 = false;
    var _iteratorError5 = undefined;

    try {
        for (var _iterator5 = ids[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
            var id = _step5.value;

            var customer = customers[id];
            var cannotRevokeCustomer = manageCustomersIds[customer.id] || manageCustomersExcludingSelfIds[customer.id];
            var customerProperty = {
                id: customer.id,
                type: _constants.HierarchyLevels.CUSTOMER,
                title: customer.name,
                archived: customer.archived,
                revokeEnabled: !cannotRevokeCustomer,
                maExcludeSelf: manageCustomersExcludingSelfIds[customer.id]
            };
            customerEntities.push(customerProperty);
        }
    } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion5 && _iterator5.return) {
                _iterator5.return();
            }
        } finally {
            if (_didIteratorError5) {
                throw _iteratorError5;
            }
        }
    }

    return customerEntities;
};

var getCustomerMaEntities = exports.getCustomerMaEntities = function getCustomerMaEntities(ids, customers, manageCustomersIds, manageCustomersExcludingSelfIds) {
    var customerEntities = [];
    var _iteratorNormalCompletion6 = true;
    var _didIteratorError6 = false;
    var _iteratorError6 = undefined;

    try {
        for (var _iterator6 = ids[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
            var id = _step6.value;

            var customer = customers[id];
            var customerProperty = {
                id: customer.id,
                type: _constants.HierarchyLevels.CUSTOMER,
                title: customer.name,
                archived: customer.archived,
                revokeEnabled: true,
                maExcludeSelf: manageCustomersExcludingSelfIds[customer.id]
            };
            customerEntities.push(customerProperty);
        }
    } catch (err) {
        _didIteratorError6 = true;
        _iteratorError6 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion6 && _iterator6.return) {
                _iterator6.return();
            }
        } finally {
            if (_didIteratorError6) {
                throw _iteratorError6;
            }
        }
    }

    return customerEntities;
};

var getProjectMaEntities = exports.getProjectMaEntities = function getProjectMaEntities(ids, projects, customers, manageProjectsIds, manageProjectsExcludingSelfIds, manageCustomersIds, manageCustomersExcludingSelfIds) {
    var nodeProperties = [];
    var prevCustomerId = null;
    var prevCustomerIndex = null;

    var _iteratorNormalCompletion7 = true;
    var _didIteratorError7 = false;
    var _iteratorError7 = undefined;

    try {
        for (var _iterator7 = ids[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
            var id = _step7.value;

            var project = projects[id];
            if (prevCustomerId !== project.customerId) {
                var customer = customers[project.customerId];
                prevCustomerId = project.customerId;
                prevCustomerIndex = nodeProperties.length;
                nodeProperties.push({
                    id: prevCustomerId,
                    type: _constants.HierarchyLevels.CUSTOMER,
                    revokeEnabled: true,
                    title: customer.name,
                    archived: customer.archived,
                    numberOfProjects: 0,
                    maExcludeSelf: manageCustomersExcludingSelfIds[prevCustomerId]
                });
            }

            nodeProperties[prevCustomerIndex].numberOfProjects += 1;
            var cannotRevokeProject = manageCustomersIds[prevCustomerId];
            nodeProperties.push({
                id: project.id,
                title: project.name,
                type: _constants.HierarchyLevels.PROJECT,
                archived: project.archived,
                revokeEnabled: !cannotRevokeProject,
                maExcludeSelf: manageProjectsExcludingSelfIds[project.id]
            });
        }
    } catch (err) {
        _didIteratorError7 = true;
        _iteratorError7 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion7 && _iterator7.return) {
                _iterator7.return();
            }
        } finally {
            if (_didIteratorError7) {
                throw _iteratorError7;
            }
        }
    }

    return nodeProperties;
};

var getProjectWaEntities = exports.getProjectWaEntities = function getProjectWaEntities(ids, projects, customers, manageProjectsIds, manageProjectsExcludingSelfIds, manageCustomersIds, manageCustomersExcludingSelfIds) {
    var nodeProperties = [];
    var prevCustomerId = null;
    var prevCustomerIndex = null;

    var _iteratorNormalCompletion8 = true;
    var _didIteratorError8 = false;
    var _iteratorError8 = undefined;

    try {
        for (var _iterator8 = ids[Symbol.iterator](), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
            var id = _step8.value;

            var project = projects[id];
            var customerId = project.customerId;
            var cannotRevokeCustomer = manageCustomersIds[customerId] || manageCustomersExcludingSelfIds[customerId];
            if (prevCustomerId !== customerId) {
                var customer = customers[customerId];
                prevCustomerId = customerId;
                prevCustomerIndex = nodeProperties.length;
                nodeProperties.push({
                    id: prevCustomerId,
                    type: _constants.HierarchyLevels.CUSTOMER,
                    revokeEnabled: !cannotRevokeCustomer,
                    title: customer.name,
                    archived: customer.archived,
                    numberOfProjects: 0,
                    maExcludeSelf: manageCustomersExcludingSelfIds[prevCustomerId]
                });
            }

            nodeProperties[prevCustomerIndex].numberOfProjects += 1;
            var cannotRevokeProject = cannotRevokeCustomer || manageProjectsIds[project.id] || manageProjectsExcludingSelfIds[project.id];
            nodeProperties.push({
                id: project.id,
                title: project.name,
                type: _constants.HierarchyLevels.PROJECT,
                archived: project.archived,
                revokeEnabled: !cannotRevokeProject,
                maExcludeSelf: manageProjectsExcludingSelfIds[project.id]
            });
        }
    } catch (err) {
        _didIteratorError8 = true;
        _iteratorError8 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion8 && _iterator8.return) {
                _iterator8.return();
            }
        } finally {
            if (_didIteratorError8) {
                throw _iteratorError8;
            }
        }
    }

    return nodeProperties;
};

var getTaskWaEntities = exports.getTaskWaEntities = function getTaskWaEntities(ids, tasks, projects, customers, manageTasksIds, manageProjectsIds, manageProjectsExcludingSelfIds, manageCustomersIds, manageCustomersExcludingSelfIds) {
    var nodeProperties = [];
    var prevCustomerId = null;
    var prevCustomerIndex = null;

    var prevProjectId = null;
    var prevProjectIndex = null;

    var _iteratorNormalCompletion9 = true;
    var _didIteratorError9 = false;
    var _iteratorError9 = undefined;

    try {
        for (var _iterator9 = ids[Symbol.iterator](), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
            var id = _step9.value;

            var task = tasks[id];
            var project = projects[task.projectId];
            var customerId = project.customerId;
            var customer = customers[customerId];

            var cannotRevokeCustomer = manageCustomersIds[customerId] || manageCustomersExcludingSelfIds[customerId];
            if (prevCustomerId !== customerId) {
                prevCustomerIndex = nodeProperties.length;
                prevCustomerId = customerId;
                nodeProperties.push({
                    id: prevCustomerId,
                    title: customer.name,
                    archived: customer.archived,
                    type: _constants.HierarchyLevels.CUSTOMER,
                    revokeEnabled: !cannotRevokeCustomer,
                    maExcludeSelf: manageCustomersExcludingSelfIds[prevCustomerId]
                });
            }

            var cannotRevokeProject = cannotRevokeCustomer || manageProjectsIds[prevProjectId] || manageProjectsExcludingSelfIds[prevProjectId];
            if (prevProjectId !== task.projectId) {
                prevProjectIndex = nodeProperties.length;
                prevProjectId = task.projectId;
                nodeProperties.push({
                    id: prevProjectId,
                    title: project.name,
                    type: _constants.HierarchyLevels.PROJECT,
                    archived: project.archived,
                    revokeEnabled: !cannotRevokeProject,
                    numberOfTasks: 0,
                    maExcludeSelf: manageProjectsExcludingSelfIds[prevProjectId]
                });
            }
            var cannotRevokeTask = cannotRevokeProject || manageTasksIds[task.id];

            nodeProperties[prevProjectIndex].numberOfTasks += 1;

            nodeProperties.push({
                id: task.id,
                title: task.name,
                completed: task.completed,
                type: _constants.HierarchyLevels.TASK,
                revokeEnabled: !cannotRevokeTask
            });
        }
    } catch (err) {
        _didIteratorError9 = true;
        _iteratorError9 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion9 && _iterator9.return) {
                _iterator9.return();
            }
        } finally {
            if (_didIteratorError9) {
                throw _iteratorError9;
            }
        }
    }

    return nodeProperties;
};

var getTaskMaEntities = exports.getTaskMaEntities = function getTaskMaEntities(ids, tasks, projects, customers, manageTasksIds, manageProjectsIds, manageProjectsExcludingSelfIds, manageCustomersIds, manageCustomersExcludingSelfIds) {
    var nodeProperties = [];
    var prevCustomerId = null;
    var prevCustomerIndex = null;

    var prevProjectId = null;
    var prevProjectIndex = null;

    var _iteratorNormalCompletion10 = true;
    var _didIteratorError10 = false;
    var _iteratorError10 = undefined;

    try {
        for (var _iterator10 = ids[Symbol.iterator](), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
            var id = _step10.value;

            var task = tasks[id];
            var project = projects[task.projectId];
            var customer = customers[project.customerId];

            if (prevCustomerId !== project.customerId) {
                prevCustomerIndex = nodeProperties.length;
                prevCustomerId = project.customerId;
                nodeProperties.push({
                    id: prevCustomerId,
                    title: customer.name,
                    archived: customer.archived,
                    type: _constants.HierarchyLevels.CUSTOMER,
                    revokeEnabled: true,
                    maExcludeSelf: manageCustomersExcludingSelfIds[prevCustomerId]
                });
            }

            if (prevProjectId !== task.projectId) {
                prevProjectIndex = nodeProperties.length;
                prevProjectId = task.projectId;

                nodeProperties.push({
                    id: prevProjectId,
                    title: project.name,
                    type: _constants.HierarchyLevels.PROJECT,
                    archived: project.archived,
                    revokeEnabled: !manageCustomersIds[prevCustomerId],
                    numberOfTasks: 0,
                    maExcludeSelf: manageProjectsExcludingSelfIds[prevProjectId]
                });
            }
            var cannotRevokeTask = manageProjectsIds[prevProjectId] || manageCustomersIds[prevCustomerId];
            nodeProperties[prevProjectIndex].numberOfTasks += 1;

            nodeProperties.push({
                id: task.id,
                title: task.name,
                completed: !task.open,
                type: _constants.HierarchyLevels.TASK,
                revokeEnabled: !cannotRevokeTask
            });
        }
    } catch (err) {
        _didIteratorError10 = true;
        _iteratorError10 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion10 && _iterator10.return) {
                _iterator10.return();
            }
        } finally {
            if (_didIteratorError10) {
                throw _iteratorError10;
            }
        }
    }

    return nodeProperties;
};

var getSortedTaskIdsByName = exports.getSortedTaskIdsByName = function getSortedTaskIdsByName(ids, tasks, projects, customers) {
    return ids.map(function (id) {
        var task = tasks[id];
        var project = projects[task.projectId];
        var customer = customers[project.customerId];

        return {
            id: id,
            taskName: task.name,
            projectName: project.name,
            customerName: customer.name,
            customerArchived: customer.archived,
            projectArchived: project.archived,
            taskCompleted: !task.open
        };
    }).sort(customerProjectTaskComparator).map(function (e) {
        return e.id;
    });
};

var getSortedProjectIdsByName = exports.getSortedProjectIdsByName = function getSortedProjectIdsByName(ids, projects, customers) {
    return ids.map(function (id) {
        var project = projects[id];
        var customer = customers[project.customerId];

        return {
            id: id,
            projectName: project.name,
            customerName: customer.name,
            customerArchived: customer.archived,
            projectArchived: project.archived
        };
    }).sort(customerProjectComparator).map(function (e) {
        return e.id;
    });
};

var getSortedCustomerIdsByName = exports.getSortedCustomerIdsByName = function getSortedCustomerIdsByName(ids, customers) {
    return ids.map(function (id) {
        var customer = customers[id];

        return {
            id: id,
            customerName: customer.name,
            customerArchived: customer.archived
        };
    }).sort(customerComparator).map(function (e) {
        return e.id;
    });
};

var customerNameComparator = function customerNameComparator(a, b) {
    return (0, _atUtils.stringComparator)(a.customerName, b.customerName);
};
var projectNameComparator = function projectNameComparator(a, b) {
    return (0, _atUtils.stringComparator)(a.projectName, b.projectName);
};
var taskNameComparator = function taskNameComparator(a, b) {
    return (0, _atUtils.stringComparator)(a.taskName, b.taskName);
};

var customerComparator = function customerComparator(a, b) {
    return archivedComparator(a.customerArchived, b.customerArchived) || customerNameComparator(a, b);
};

var customerProjectComparator = function customerProjectComparator(a, b) {
    return archivedComparator(a.customerArchived, b.customerArchived) || archivedComparator(a.projectArchived, b.projectArchived) || customerNameComparator(a, b) || projectNameComparator(a, b);
};

var customerProjectTaskComparator = function customerProjectTaskComparator(a, b) {
    return archivedComparator(a.customerArchived, b.customerArchived) || archivedComparator(a.projectArchived, b.projectArchived) || archivedComparator(a.taskCompleted, b.taskCompleted) || customerNameComparator(a, b) || projectNameComparator(a, b) || taskNameComparator(a, b);
};

var archivedComparator = exports.archivedComparator = function archivedComparator(a, b) {
    if (a === b) {
        return 0;
    } else if (a) {
        return 1;
    } else if (b) {
        return -1;
    }
};

var getEntityAdditionalTitle = function getEntityAdditionalTitle(type) {
    if (type === _constants.HierarchyLevels.TASK) {
        return _messageResource2.default.getMessage("panel.common.Completed");
    }

    return _messageResource2.default.getMessage("panel.common.Archived");
};

var isEntityArchived = function isEntityArchived(entity) {
    return entity.type === _constants.HierarchyLevels.TASK ? entity.completed : entity.archived;
};

var getNodeProperty = function getNodeProperty(_ref) {
    var entity = _ref.entity,
        highlightedTitle = _ref.highlightedTitle,
        isShowArchived = _ref.isShowArchived,
        revokeCallback = _ref.revokeCallback,
        note = _ref.note,
        additionalClass = _ref.additionalClass,
        additionalClassArchived = _ref.additionalClassArchived;

    return _extends({}, entity, {
        highlightedTitle: highlightedTitle,
        additionalTitle: isShowArchived && isEntityArchived(entity) ? getEntityAdditionalTitle(entity.type) : "",
        revokeCallback: revokeCallback,
        note: note || "",
        additionalClass: isShowArchived && isEntityArchived(entity) ? additionalClassArchived || "" : additionalClass || "",
        revokeEnabled: entity.revokeEnabled
    });
};

var getNote = function getNote(entity, specificTextNoteKey) {
    var note = "";
    if (entity.maExcludeSelf) {
        note = _messageResource2.default.getMessage(specificTextNoteKey);
    } else if (!entity.revokeEnabled) {
        note = _messageResource2.default.getMessage("work_assignments.panel.tab_row.note");
    }
    return note;
};

var getNoteByHierarchyLevel = function getNoteByHierarchyLevel(level, entity) {
    switch (level) {
        case _constants.HierarchyLevels.CUSTOMER:
            return getNote(entity, 'userlist.ha_editor.customers.can_manage_existing_and_future');
        case _constants.HierarchyLevels.PROJECT:
            return getNote(entity, 'userlist.ha_editor.projects.can_manage_existing_and_future');
        case _constants.HierarchyLevels.TASK:
            return entity.revokeEnabled ? "" : _messageResource2.default.getMessage("work_assignments.panel.tab_row.note");
    }
};

var getCustomerHighlightTitle = function getCustomerHighlightTitle(level, entity, tokensHighlighter) {
    switch (level) {
        case _constants.HierarchyLevels.CUSTOMER:
            return tokensHighlighter.highlightTokens(entity.title);
        case _constants.HierarchyLevels.PROJECT:
            return _messageResource2.default.getEscapedMessage("work_assignments.panel.projects.customer_title", [entity.title, entity.numberOfProjects, (0, _pluralizeUtils.projectNameLower)(entity.numberOfProjects)]);
        case _constants.HierarchyLevels.TASK:
            return (0, _atUtils.escapeHtmlSymbols)(entity.title);
    }
};

var getProjectHighlightTitle = function getProjectHighlightTitle(level, entity, tokensHighlighter) {
    switch (level) {
        case _constants.HierarchyLevels.PROJECT:
            return tokensHighlighter.highlightTokens(entity.title);
        case _constants.HierarchyLevels.TASK:
            return _messageResource2.default.getEscapedMessage("work_assignments.panel.tasks.project_title", [entity.title, entity.numberOfTasks, (0, _pluralizeUtils.taskNameLower)(entity.numberOfTasks)]);
    }
};

var getCustomerNodeProperty = function getCustomerNodeProperty(_ref2) {
    var entity = _ref2.entity,
        isShowArchived = _ref2.isShowArchived,
        tokensHighlighter = _ref2.tokensHighlighter,
        customerRevoked = _ref2.customerRevoked,
        hierarchyLevel = _ref2.hierarchyLevel;


    var greyRowClass = hierarchyLevel !== _constants.HierarchyLevels.CUSTOMER ? " grey_row" : "";

    return getNodeProperty({
        entity: entity,
        isShowArchived: isShowArchived,
        note: getNoteByHierarchyLevel(hierarchyLevel, entity),
        highlightedTitle: getCustomerHighlightTitle(hierarchyLevel, entity, tokensHighlighter),
        revokeCallback: customerRevoked,
        additionalClass: "customer_row" + greyRowClass,
        additionalClassArchived: "customer_row_archived"
    });
};

var getProjectNodeProperty = function getProjectNodeProperty(_ref3) {
    var entity = _ref3.entity,
        isShowArchived = _ref3.isShowArchived,
        tokensHighlighter = _ref3.tokensHighlighter,
        projectRevoked = _ref3.projectRevoked,
        hierarchyLevel = _ref3.hierarchyLevel;


    var greyRowClass = hierarchyLevel === _constants.HierarchyLevels.TASK ? " grey_row" : "";

    return getNodeProperty({
        entity: entity,
        isShowArchived: isShowArchived,
        note: getNoteByHierarchyLevel(hierarchyLevel, entity),
        highlightedTitle: getProjectHighlightTitle(hierarchyLevel, entity, tokensHighlighter),
        revokeCallback: projectRevoked,
        additionalClass: "project_row" + greyRowClass,
        additionalClassArchived: "project_row_archived" + greyRowClass
    });
};

var getTaskNodeProperty = function getTaskNodeProperty(_ref4) {
    var entity = _ref4.entity,
        isShowArchived = _ref4.isShowArchived,
        tokensHighlighter = _ref4.tokensHighlighter,
        taskRevoked = _ref4.taskRevoked;

    return getNodeProperty({
        entity: entity,
        isShowArchived: isShowArchived,
        note: entity.revokeEnabled ? "" : _messageResource2.default.getMessage("work_assignments.panel.tab_row.note"),
        highlightedTitle: tokensHighlighter.highlightTokens(entity.title),
        revokeCallback: taskRevoked,
        additionalClass: "task_row",
        additionalClassArchived: "task_row_completed"
    });
};

/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ErrorProcessor = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.validateFirstName = validateFirstName;
exports.validateLastName = validateLastName;
exports.validateUserName = validateUserName;
exports.validateEmail = validateEmail;
exports.validateUserGroupName = validateUserGroupName;
exports.validateTimezoneGroup = validateTimezoneGroup;
exports.validateHireDate = validateHireDate;
exports.validateReleaseDate = validateReleaseDate;
exports.validatePassword = validatePassword;

var _StringUtils = __webpack_require__(121);

var _atUtils = __webpack_require__(5);

var _constants = __webpack_require__(21);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ErrorProcessor = exports.ErrorProcessor = function () {
    function ErrorProcessor() {
        var errors = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        var abortAfterFirstError = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

        _classCallCheck(this, ErrorProcessor);

        this.errors = errors;
        this._valid = true;
        this.abortAfterFirstError = abortAfterFirstError;
    }

    _createClass(ErrorProcessor, [{
        key: "processError",
        value: function processError(processedError, checkIsValid) {
            this.errors = (0, _atUtils.filterMapByKey)(this.errors, processedError);

            if (this.abortAfterFirstError && !this._valid) {
                return this;
            }

            var isValid = checkIsValid();
            if (!isValid) this.errors = _extends({}, this.errors, _defineProperty({}, processedError, true));
            this._valid = isValid;
            return this;
        }
    }, {
        key: "getErrorState",
        value: function getErrorState() {
            return {
                errors: this.errors,
                isValid: this._valid
            };
        }
    }]);

    return ErrorProcessor;
}();

function validateFirstName(errors, firstName) {
    return new ErrorProcessor(errors).processError(_constants.ValidationErrors.FIRST_NAME_EMPTY, function () {
        return (0, _StringUtils.isNotEmptyString)(firstName);
    }).getErrorState();
}

function validateLastName(errors, lastName) {
    return new ErrorProcessor(errors).processError(_constants.ValidationErrors.LAST_NAME_EMPTY, function () {
        return (0, _StringUtils.isNotEmptyString)(lastName);
    }).getErrorState();
}

function validateUserName(errors, username) {
    return new ErrorProcessor(errors).processError(_constants.ValidationErrors.USERNAME_EMPTY, function () {
        return (0, _StringUtils.isNotEmptyString)(username);
    }).getErrorState();
}

function validateEmail(errors, email) {
    var forCreate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var backupEmail = arguments[3];

    return new ErrorProcessor(errors).processError(_constants.ValidationErrors.EMAIL_WAS_EMPTY, function () {
        return forCreate || !(email.length === 0 && backupEmail.length === 0);
    }).processError(_constants.ValidationErrors.EMAIL_EMPTY, function () {
        return (0, _StringUtils.isNotEmptyString)(email);
    }).processError(_constants.ValidationErrors.EMAIL_INVALID, function () {
        return (0, _atUtils.isEmailValid)(email);
    }).getErrorState();
}

function validateUserGroupName(errors, ugrId, ugrName) {
    return new ErrorProcessor(errors).processError(_constants.ValidationErrors.NEW_USER_GROUP_EMPTY, function () {
        return ugrId !== _constants.GROUP_NEW_OR_NOT_KNOWN || (0, _StringUtils.isNotEmptyString)(ugrName);
    }).getErrorState();
}

function validateTimezoneGroup(errors, tzgId, tzg) {
    return new ErrorProcessor(errors, false).processError(_constants.ValidationErrors.NEW_TIME_ZONE_GROUP_EMPTY, function () {
        return tzgId !== _constants.GROUP_NEW_OR_NOT_KNOWN || tzg && (0, _StringUtils.isNotEmptyString)(tzg.name);
    }).processError(_constants.ValidationErrors.CITY_DATA_EMPTY, function () {
        return tzgId !== _constants.GROUP_NEW_OR_NOT_KNOWN || tzg && !!tzg.cityPlaceId;
    }).getErrorState();
}

function validateHireDate(errors, isEditHimself, hireDate) {
    return new ErrorProcessor(errors).processError(_constants.ValidationErrors.HIRE_DATE_EMPTY, function () {
        return hireDate !== null;
    }).processError(_constants.ValidationErrors.HIRE_DATE_IN_FUTURE_FOR_SELF, function () {
        return !isEditHimself || (0, _atUtils.compareDates)(hireDate, window.currentUserTime()) <= 0;
    }).getErrorState();
}

function validateReleaseDate(errors, releaseDate, hireDate, backupReleaseDate) {
    return new ErrorProcessor(errors).processError(_constants.ValidationErrors.RELEASE_DATE_WAS_BEFORE_HIRE_DATE, function () {
        return !backupReleaseDate || (0, _atUtils.compareNullableStrDates)(hireDate, backupReleaseDate) <= 0 || (0, _atUtils.compareNullableStrDates)(hireDate, releaseDate) <= 0;
    }).processError(_constants.ValidationErrors.RELEASE_DATE_IS_BEFORE_HIRE_DATE, function () {
        return !releaseDate || (0, _atUtils.compareNullableStrDates)(hireDate, releaseDate) <= 0;
    }).getErrorState();
}

function validatePassword(errors, password) {
    return new ErrorProcessor(errors).processError(_constants.ValidationErrors.PASSWORD_EMPTY, function () {
        return (0, _StringUtils.isNotEmptyString)(password);
    }).getErrorState();
}

/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.deleteUserRate = exports.addNewUserRate = exports.updateValidUserRates = exports.updateUserRates = exports.rollbackLastEditedUserRateChanges = exports.setUpdating = exports.setLastEditedUserRate = exports.clearErrors = exports.setErrors = undefined;

var _reduxActions = __webpack_require__(9);

var _actionTypes = __webpack_require__(677);

var ActionTypes = _interopRequireWildcard(_actionTypes);

var _constants = __webpack_require__(21);

var _selectors = __webpack_require__(64);

var _validationUtils = __webpack_require__(205);

var _selectors2 = __webpack_require__(257);

var _actions = __webpack_require__(147);

var UserDataActions = _interopRequireWildcard(_actions);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _actions2 = __webpack_require__(126);

var _selectors3 = __webpack_require__(53);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var setErrors = exports.setErrors = (0, _reduxActions.createAction)(ActionTypes.ERRORS_SET);
var clearErrors = exports.clearErrors = (0, _reduxActions.createAction)(ActionTypes.ERRORS_CLEAR);
var setLastEditedUserRate = exports.setLastEditedUserRate = (0, _reduxActions.createAction)(ActionTypes.LAST_EDITED_USER_RATE_SET);
var setUpdating = exports.setUpdating = (0, _reduxActions.createAction)(ActionTypes.UPDATING_SET);

var rollbackLastEditedUserRateChanges = exports.rollbackLastEditedUserRateChanges = function rollbackLastEditedUserRateChanges() {
    return function (dispatch, getState) {
        var state = getState();

        var _getLastEditedUserRat = (0, _selectors2.getLastEditedUserRate)(state),
            index = _getLastEditedUserRat.index,
            rate = _getLastEditedUserRat.rate;

        var rates = [].concat(_toConsumableArray((0, _selectors2.getUserRates)(state)));
        rates.splice(index, 1, rate);

        var _getUserRatesValidati = (0, _selectors.getUserRatesValidationData)(state),
            overtimeEnabled = _getUserRatesValidati.overtimeEnabled,
            leaveTypesEnabled = _getUserRatesValidati.leaveTypesEnabled;

        var _getUserRatesErrors = (0, _validationUtils.getUserRatesErrors)(rates, overtimeEnabled, leaveTypesEnabled, false, index, rate),
            errors = _getUserRatesErrors.errors;

        dispatch(setErrors(errors));
        dispatch(UserDataActions.setFullUserInfo({ rates: rates }));
    };
};

var updateUserRates = exports.updateUserRates = function updateUserRates(_ref) {
    var index = _ref.index,
        rate = _ref.rate;
    return function (dispatch, getState) {
        var state = getState();
        var prevRates = (0, _selectors2.getUserRates)(state);
        var rates = [].concat(_toConsumableArray(prevRates));
        rates.splice(index, 1, rate);

        var _getUserRatesValidati2 = (0, _selectors.getUserRatesValidationData)(state),
            overtimeEnabled = _getUserRatesValidati2.overtimeEnabled,
            leaveTypesEnabled = _getUserRatesValidati2.leaveTypesEnabled;

        var _getUserRatesErrors2 = (0, _validationUtils.getUserRatesErrors)(rates, overtimeEnabled, leaveTypesEnabled, true, index, prevRates[index]),
            errors = _getUserRatesErrors2.errors;

        dispatch(setLastEditedUserRate({ index: index, rate: prevRates[index] }));

        dispatch(UserDataActions.setFullUserInfo({ rates: rates }));

        dispatch(setErrors(errors));

        if (!errors[index] && !(0, _validationUtils.isRateEmpty)(rate, overtimeEnabled, leaveTypesEnabled)) {
            dispatch(updateValidUserRates(rates));
        }
    };
};

var updateValidUserRates = exports.updateValidUserRates = function updateValidUserRates(rates) {
    return function (dispatch, getState) {
        var _getUserRatesValidati3 = (0, _selectors.getUserRatesValidationData)(getState()),
            overtimeEnabled = _getUserRatesValidati3.overtimeEnabled,
            leaveTypesEnabled = _getUserRatesValidati3.leaveTypesEnabled;

        dispatch(UserDataActions.removeUserPanelErrors([_constants.ValidationErrors.DUPLICATED_EFFECTIVE_DATE]));

        var validRates = (0, _validationUtils.getValidRates)({ rates: rates, overtimeEnabled: overtimeEnabled, leaveTypesEnabled: leaveTypesEnabled });

        if (validRates.length === 0) {
            dispatch(UserDataActions.setFullUserInfo({ rates: rates }));
        } else {
            dispatch(setUpdating(true));
            dispatch((0, _actions2.performUpdateCall)("UserManagementService.updateUserRates", [validRates], function () {
                //rates updated in performUpdateCall, no need update here
                dispatch(setUpdating(false));
            }, function (error) {
                dispatch(setUpdating(false));
                if (error._providerStatus === _constants.ValidationErrors.DUPLICATED_EFFECTIVE_DATE) {
                    alert(_messageResource2.default.getMessage('userlist.userdata.user_rates.duplicate_effective'));
                    dispatch(UserDataActions.setFullUserInfo({ rates: rates }));
                }
            }));
        }
    };
};

var addNewUserRate = exports.addNewUserRate = function addNewUserRate() {
    return function (dispatch, getState) {
        var state = getState();
        var userRates = (0, _selectors2.getUserRates)(state);
        var currentDateStr = (0, _selectors3.getUserManagementData)(state).todayInViewerTimeZone.parseJSONDate().toJSON();

        var newRate = {
            rateId: -1,
            effectiveDate: userRates.find(function (rate) {
                return rate.effectiveDate === currentDateStr;
            }) ? null : currentDateStr,
            regularRate: null,
            overtimeRate: null,
            leaveRates: []
        };

        dispatch(UserDataActions.setFullUserInfo({
            rates: [].concat(_toConsumableArray(userRates), [newRate])
        }));
    };
};

var deleteUserRate = exports.deleteUserRate = function deleteUserRate(_ref2) {
    var rateId = _ref2.rateId,
        _ref2$removePermanent = _ref2.removePermanently,
        removePermanently = _ref2$removePermanent === undefined ? false : _ref2$removePermanent,
        index = _ref2.index;
    return function (dispatch, getState) {
        var state = getState();
        var rates = [].concat(_toConsumableArray((0, _selectors2.getUserRates)(state)));

        if (removePermanently) {
            rates.splice(index, 1);
            dispatch(UserDataActions.setFullUserInfo({ rates: rates }));
            var errors = [].concat(_toConsumableArray((0, _selectors2.getErrors)(state)));
            errors.splice(index, 1);
            dispatch(setErrors(errors));
        } else {
            dispatch(setUpdating(true));
            dispatch((0, _actions2.performUpdateCall)("UserManagementService.deleteUserRate", [rateId], function () {
                dispatch(setUpdating(false));
                var rates = (0, _selectors.getFullUserInfo)(state).rates.filter(function (rate) {
                    return rate.rateId !== rateId;
                });
                dispatch(UserDataActions.setFullUserInfo({ rates: rates }));
            }));
        }
    };
};

/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getTasks = exports.getProjects = exports.getCustomers = exports.getSelectedProject = exports.getSelectedCustomer = exports.getEditingUser = exports.showOnlyActiveEntities = exports.canManageParentProject = exports.canManageParentCustomer = exports.getViewerCanManageProjectIds = exports.getViewerCanManageCustomerIds = exports.getTasksSearchText = exports.getTasksSearchOpen = exports.getProjectsSearchText = exports.getProjectsSearchOpen = exports.getCustomersSearchText = exports.getCustomersSearchOpen = exports.isChangingAllAssignments = exports.getChangingTaskAssignments = exports.getChangingProjectAssignments = exports.getChangingCustomerAssignments = exports.isLoading = exports.areAllTasksAssigned = exports.areSomeTasksAssigned = exports.areAllProjectsAssigned = exports.areSomeProjectsOrLowerAssigned = exports.areAllCustomersAssigned = exports.areSomeCustomersOrLowerAssigned = exports.getTaskCountsByProjects = exports.getTaskCountsByCustomers = exports.getProjectCountsByCustomers = exports.getCanManageTaskIds = exports.getCanWorkTaskIds = exports.getCanManageProjectExcludeSelfIds = exports.getCanManageProjectIds = exports.getCanWorkProjectIds = exports.getCanManageCustomerExcludeSelfIds = exports.getCanManageCustomerIds = exports.getCanWorkCustomerIds = exports.areFutureTasksAssigned = exports.areFutureProjectsAssigned = exports.areFutureCustomersAssigned = exports.getTaskIdsOrder = exports.getProjectIdsOrder = exports.getCustomerIdsOrder = exports.getEditingLevel = exports.needMoreTasks = exports.needMoreProjects = exports.needMoreCustomers = exports.isLoaded = exports.showEditor = exports.getEditingUserId = exports.areTasksLoaded = exports.areProjectsLoaded = exports.areCustomersLoaded = undefined;

var _reselect = __webpack_require__(13);

var _selectors = __webpack_require__(14);

var EntitiesSelectors = _interopRequireWildcard(_selectors);

var _selectorsGenerator = __webpack_require__(548);

var _selectorsGenerator2 = _interopRequireDefault(_selectorsGenerator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var getManagementAssignmentsEditorState = function getManagementAssignmentsEditorState(state) {
    return state.userManagement.editManagementAssignmentsEditor;
};
var hierarchyAssignmentsEditorSelectors = (0, _selectorsGenerator2.default)(getManagementAssignmentsEditorState);

var areCustomersLoaded = exports.areCustomersLoaded = hierarchyAssignmentsEditorSelectors.areCustomersLoaded;

var areProjectsLoaded = exports.areProjectsLoaded = hierarchyAssignmentsEditorSelectors.areProjectsLoaded;

var areTasksLoaded = exports.areTasksLoaded = hierarchyAssignmentsEditorSelectors.areTasksLoaded;

var getEditingUserId = exports.getEditingUserId = hierarchyAssignmentsEditorSelectors.getEditingUserId;

var showEditor = exports.showEditor = hierarchyAssignmentsEditorSelectors.showEditor;

var isLoaded = exports.isLoaded = hierarchyAssignmentsEditorSelectors.isLoaded;

var needMoreCustomers = exports.needMoreCustomers = hierarchyAssignmentsEditorSelectors.needMoreCustomers;

var needMoreProjects = exports.needMoreProjects = hierarchyAssignmentsEditorSelectors.needMoreProjects;

var needMoreTasks = exports.needMoreTasks = hierarchyAssignmentsEditorSelectors.needMoreTasks;

var getEditingLevel = exports.getEditingLevel = hierarchyAssignmentsEditorSelectors.getEditingLevel;

var getCustomerIdsOrder = exports.getCustomerIdsOrder = hierarchyAssignmentsEditorSelectors.getCustomerIdsOrder;

var getProjectIdsOrder = exports.getProjectIdsOrder = hierarchyAssignmentsEditorSelectors.getProjectIdsOrder;

var getTaskIdsOrder = exports.getTaskIdsOrder = hierarchyAssignmentsEditorSelectors.getTaskIdsOrder;

var areFutureCustomersAssigned = exports.areFutureCustomersAssigned = hierarchyAssignmentsEditorSelectors.areFutureCustomersAssigned;

var areFutureProjectsAssigned = exports.areFutureProjectsAssigned = hierarchyAssignmentsEditorSelectors.areFutureProjectsAssigned;

var areFutureTasksAssigned = exports.areFutureTasksAssigned = hierarchyAssignmentsEditorSelectors.areFutureTasksAssigned;

var getCanWorkCustomerIds = exports.getCanWorkCustomerIds = hierarchyAssignmentsEditorSelectors.getCanWorkCustomerIds;

var getCanManageCustomerIds = exports.getCanManageCustomerIds = hierarchyAssignmentsEditorSelectors.getCanManageCustomerIds;

var getCanManageCustomerExcludeSelfIds = exports.getCanManageCustomerExcludeSelfIds = hierarchyAssignmentsEditorSelectors.getCanManageCustomerExcludeSelfIds;

var getCanWorkProjectIds = exports.getCanWorkProjectIds = hierarchyAssignmentsEditorSelectors.getCanWorkProjectIds;

var getCanManageProjectIds = exports.getCanManageProjectIds = hierarchyAssignmentsEditorSelectors.getCanManageProjectIds;

var getCanManageProjectExcludeSelfIds = exports.getCanManageProjectExcludeSelfIds = hierarchyAssignmentsEditorSelectors.getCanManageProjectExcludeSelfIds;

var getCanWorkTaskIds = exports.getCanWorkTaskIds = hierarchyAssignmentsEditorSelectors.getCanWorkTaskIds;

var getCanManageTaskIds = exports.getCanManageTaskIds = hierarchyAssignmentsEditorSelectors.getCanManageTaskIds;

var getProjectCountsByCustomers = exports.getProjectCountsByCustomers = hierarchyAssignmentsEditorSelectors.getProjectCountsByCustomers;

var getTaskCountsByCustomers = exports.getTaskCountsByCustomers = hierarchyAssignmentsEditorSelectors.getTaskCountsByCustomers;

var getTaskCountsByProjects = exports.getTaskCountsByProjects = hierarchyAssignmentsEditorSelectors.getTaskCountsByProjects;

var areSomeCustomersOrLowerAssigned = exports.areSomeCustomersOrLowerAssigned = hierarchyAssignmentsEditorSelectors.areSomeCustomersOrLowerAssigned;

var areAllCustomersAssigned = exports.areAllCustomersAssigned = hierarchyAssignmentsEditorSelectors.areAllCustomersAssigned;

var areSomeProjectsOrLowerAssigned = exports.areSomeProjectsOrLowerAssigned = hierarchyAssignmentsEditorSelectors.areSomeProjectsOrLowerAssigned;

var areAllProjectsAssigned = exports.areAllProjectsAssigned = hierarchyAssignmentsEditorSelectors.areAllProjectsAssigned;

var areSomeTasksAssigned = exports.areSomeTasksAssigned = hierarchyAssignmentsEditorSelectors.areSomeTasksAssigned;

var areAllTasksAssigned = exports.areAllTasksAssigned = hierarchyAssignmentsEditorSelectors.areAllTasksAssigned;

var isLoading = exports.isLoading = hierarchyAssignmentsEditorSelectors.isLoading;

var getChangingCustomerAssignments = exports.getChangingCustomerAssignments = hierarchyAssignmentsEditorSelectors.getChangingCustomerAssignments;

var getChangingProjectAssignments = exports.getChangingProjectAssignments = hierarchyAssignmentsEditorSelectors.getChangingProjectAssignments;

var getChangingTaskAssignments = exports.getChangingTaskAssignments = hierarchyAssignmentsEditorSelectors.getChangingTaskAssignments;

var isChangingAllAssignments = exports.isChangingAllAssignments = hierarchyAssignmentsEditorSelectors.isChangingAllAssignments;

var getCustomersSearchOpen = exports.getCustomersSearchOpen = hierarchyAssignmentsEditorSelectors.getCustomersSearchOpen;

var getCustomersSearchText = exports.getCustomersSearchText = hierarchyAssignmentsEditorSelectors.getCustomersSearchText;

var getProjectsSearchOpen = exports.getProjectsSearchOpen = hierarchyAssignmentsEditorSelectors.getProjectsSearchOpen;

var getProjectsSearchText = exports.getProjectsSearchText = hierarchyAssignmentsEditorSelectors.getProjectsSearchText;

var getTasksSearchOpen = exports.getTasksSearchOpen = hierarchyAssignmentsEditorSelectors.getTasksSearchOpen;

var getTasksSearchText = exports.getTasksSearchText = hierarchyAssignmentsEditorSelectors.getTasksSearchText;

var getViewerCanManageCustomerIds = exports.getViewerCanManageCustomerIds = hierarchyAssignmentsEditorSelectors.getViewerCanManageCustomerIds;

var getViewerCanManageProjectIds = exports.getViewerCanManageProjectIds = hierarchyAssignmentsEditorSelectors.getViewerCanManageProjectIds;

var canManageParentCustomer = exports.canManageParentCustomer = hierarchyAssignmentsEditorSelectors.canManageParentCustomer;

var canManageParentProject = exports.canManageParentProject = hierarchyAssignmentsEditorSelectors.canManageParentProject;

var showOnlyActiveEntities = exports.showOnlyActiveEntities = function showOnlyActiveEntities(state) {
    return getManagementAssignmentsEditorState(state).onlyActiveEntities;
};

var getEditingUser = exports.getEditingUser = (0, _reselect.createSelector)(EntitiesSelectors.getUsers, getEditingUserId, function (users, userId) {
    return users[userId];
});

var getSelectedCustomer = exports.getSelectedCustomer = (0, _reselect.createSelector)(EntitiesSelectors.getCustomers, getEditingLevel, function (customers, _ref) {
    var customerId = _ref.customerId;
    return customerId !== null ? customers[customerId] : null;
});

var getSelectedProject = exports.getSelectedProject = (0, _reselect.createSelector)(EntitiesSelectors.getProjects, getEditingLevel, function (projects, _ref2) {
    var projectId = _ref2.projectId;
    return projectId !== null ? projects[projectId] : null;
});

var getCustomers = exports.getCustomers = (0, _reselect.createSelector)(EntitiesSelectors.getCustomers, getCustomerIdsOrder, function (customers, customerIdsOrder) {
    return customerIdsOrder.map(function (id) {
        return customers[id];
    });
});

var getProjects = exports.getProjects = (0, _reselect.createSelector)(EntitiesSelectors.getProjects, getProjectIdsOrder, function (projects, projectIdsOrder) {
    return projectIdsOrder.map(function (id) {
        return projects[id];
    });
});

var getTasks = exports.getTasks = (0, _reselect.createSelector)(EntitiesSelectors.getTasks, getTaskIdsOrder, function (tasks, taskIdsOrder) {
    return taskIdsOrder.map(function (id) {
        return tasks[id];
    });
});

/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = function (_ref) {
    var _ref$actionTypes = _ref.actionTypes,
        CLEAR_CUSTOMERS = _ref$actionTypes.CLEAR_CUSTOMERS,
        CLEAR_PROJECTS = _ref$actionTypes.CLEAR_PROJECTS,
        CLEAR_TASKS = _ref$actionTypes.CLEAR_TASKS,
        LOADED_SET = _ref$actionTypes.LOADED_SET,
        CUSTOMERS_LOADED_SET = _ref$actionTypes.CUSTOMERS_LOADED_SET,
        PROJECTS_LOADED_SET = _ref$actionTypes.PROJECTS_LOADED_SET,
        TASKS_LOADED_SET = _ref$actionTypes.TASKS_LOADED_SET,
        EDITING_USER_ID_SET = _ref$actionTypes.EDITING_USER_ID_SET,
        EDITING_LEVEL_SET = _ref$actionTypes.EDITING_LEVEL_SET,
        PROJECTS_TASKS_COUNT_CLEAR = _ref$actionTypes.PROJECTS_TASKS_COUNT_CLEAR,
        CUSTOMERS_TASKS_COUNT_CLEAR = _ref$actionTypes.CUSTOMERS_TASKS_COUNT_CLEAR,
        CUSTOMERS_PROJECTS_COUNT_CLEAR = _ref$actionTypes.CUSTOMERS_PROJECTS_COUNT_CLEAR,
        LOAD_CUSTOMER_ASSIGNMENTS_EDITOR_DATA_SUCCESS = _ref$actionTypes.LOAD_CUSTOMER_ASSIGNMENTS_EDITOR_DATA_SUCCESS,
        LOAD_CUSTOMER_ASSIGNMENTS_EDITOR_DATA_FAILURE = _ref$actionTypes.LOAD_CUSTOMER_ASSIGNMENTS_EDITOR_DATA_FAILURE,
        LOAD_PROJECT_ASSIGNMENTS_EDITOR_DATA_SUCCESS = _ref$actionTypes.LOAD_PROJECT_ASSIGNMENTS_EDITOR_DATA_SUCCESS,
        LOAD_PROJECT_ASSIGNMENTS_EDITOR_DATA_FAILURE = _ref$actionTypes.LOAD_PROJECT_ASSIGNMENTS_EDITOR_DATA_FAILURE,
        LOAD_TASK_ASSIGNMENTS_EDITOR_DATA_SUCCESS = _ref$actionTypes.LOAD_TASK_ASSIGNMENTS_EDITOR_DATA_SUCCESS,
        LOAD_TASK_ASSIGNMENTS_EDITOR_DATA_FAILURE = _ref$actionTypes.LOAD_TASK_ASSIGNMENTS_EDITOR_DATA_FAILURE,
        CHANGE_CUSTOMER_ASSIGNMENT_SUCCESS = _ref$actionTypes.CHANGE_CUSTOMER_ASSIGNMENT_SUCCESS,
        CHANGE_CUSTOMER_ASSIGNMENT_FAILURE = _ref$actionTypes.CHANGE_CUSTOMER_ASSIGNMENT_FAILURE,
        CHANGE_PROJECT_ASSIGNMENT_SUCCESS = _ref$actionTypes.CHANGE_PROJECT_ASSIGNMENT_SUCCESS,
        CHANGE_PROJECT_ASSIGNMENT_FAILURE = _ref$actionTypes.CHANGE_PROJECT_ASSIGNMENT_FAILURE,
        CHANGE_TASK_ASSIGNMENT_SUCCESS = _ref$actionTypes.CHANGE_TASK_ASSIGNMENT_SUCCESS,
        CHANGE_TASK_ASSIGNMENT_FAILURE = _ref$actionTypes.CHANGE_TASK_ASSIGNMENT_FAILURE,
        CHANGE_ALL_ASSIGNMENTS_SUCCESS = _ref$actionTypes.CHANGE_ALL_ASSIGNMENTS_SUCCESS,
        CUSTOMERS_SEARCH_TEXT_SET = _ref$actionTypes.CUSTOMERS_SEARCH_TEXT_SET,
        CUSTOMERS_SEARCH_OPEN_SET = _ref$actionTypes.CUSTOMERS_SEARCH_OPEN_SET,
        PROJECTS_SEARCH_OPEN_SET = _ref$actionTypes.PROJECTS_SEARCH_OPEN_SET,
        PROJECTS_SEARCH_TEXT_SET = _ref$actionTypes.PROJECTS_SEARCH_TEXT_SET,
        TASKS_SEARCH_OPEN_SET = _ref$actionTypes.TASKS_SEARCH_OPEN_SET,
        TASKS_SEARCH_TEXT_SET = _ref$actionTypes.TASKS_SEARCH_TEXT_SET;

    var setLoaded = (0, _reduxActions.createAction)(LOADED_SET);
    var setCustomersLoaded = (0, _reduxActions.createAction)(CUSTOMERS_LOADED_SET);
    var setProjectsLoaded = (0, _reduxActions.createAction)(PROJECTS_LOADED_SET);
    var setTasksLoaded = (0, _reduxActions.createAction)(TASKS_LOADED_SET);

    var openEditor = function openEditor(userId) {
        return function (dispatch) {
            dispatch(clearAll());
            dispatch(resetSearchState());
            dispatch((0, _utils.createActionObject)(EDITING_USER_ID_SET, userId));
            dispatch((0, _utils.createActionObject)(EDITING_LEVEL_SET, {
                customerId: null,
                projectId: null
            }));
            dispatch(setCustomersLoaded(false));
        };
    };

    var closeEditor = function closeEditor() {
        return function (dispatch) {
            dispatch((0, _utils.createActionObject)(EDITING_USER_ID_SET, null));
        };
    };

    var resetSearchState = function resetSearchState() {
        return function (dispatch) {
            dispatch((0, _utils.createActionObject)(CUSTOMERS_SEARCH_OPEN_SET, false));
            dispatch((0, _utils.createActionObject)(CUSTOMERS_SEARCH_TEXT_SET, ''));
            dispatch((0, _utils.createActionObject)(PROJECTS_SEARCH_OPEN_SET, false));
            dispatch((0, _utils.createActionObject)(PROJECTS_SEARCH_TEXT_SET, ''));
            dispatch((0, _utils.createActionObject)(TASKS_SEARCH_OPEN_SET, false));
            dispatch((0, _utils.createActionObject)(TASKS_SEARCH_TEXT_SET, ''));
        };
    };

    var selectCustomer = function selectCustomer(customerId) {
        return function (dispatch) {
            dispatch((0, _utils.createActionObject)(CLEAR_PROJECTS));
            dispatch((0, _utils.createActionObject)(PROJECTS_SEARCH_OPEN_SET, false));
            dispatch((0, _utils.createActionObject)(PROJECTS_SEARCH_TEXT_SET, ''));
            dispatch((0, _utils.createActionObject)(EDITING_LEVEL_SET, {
                customerId: customerId,
                projectId: null
            }));
        };
    };

    var selectProject = function selectProject(projectId) {
        return function (dispatch) {
            dispatch((0, _utils.createActionObject)(CLEAR_TASKS));
            dispatch((0, _utils.createActionObject)(TASKS_SEARCH_OPEN_SET, false));
            dispatch((0, _utils.createActionObject)(TASKS_SEARCH_TEXT_SET, ''));
            dispatch((0, _utils.createActionObject)(EDITING_LEVEL_SET, {
                projectId: projectId
            }));
        };
    };

    var deselectCustomer = function deselectCustomer() {
        return function (dispatch) {
            dispatch((0, _utils.createActionObject)(EDITING_LEVEL_SET, {
                customerId: null,
                projectId: null
            }));
        };
    };

    var deselectProject = function deselectProject() {
        return function (dispatch) {
            dispatch((0, _utils.createActionObject)(EDITING_LEVEL_SET, {
                projectId: null
            }));
        };
    };

    var loadCustomersSuccess = function loadCustomersSuccess(data, loadLimit) {
        return function (dispatch) {
            var customers = data['customers'];
            dispatch((0, _utils.createActionObject)(LOAD_CUSTOMER_ASSIGNMENTS_EDITOR_DATA_SUCCESS, {
                customerIds: customers.map(function (c) {
                    return c['customer']['id'];
                }),
                canWorkCustomerIds: customers.filter(function (c) {
                    return c['canWork'];
                }).map(function (c) {
                    return c['customer']['id'];
                }),
                canManageCustomerIds: customers.filter(function (c) {
                    return c['canManage'];
                }).map(function (c) {
                    return c['customer']['id'];
                }),
                canManageCustomerExcludeSelfIds: customers.filter(function (c) {
                    return c['canManageExcludeSelf'];
                }).map(function (c) {
                    return c['customer']['id'];
                }),
                viewerCanManageCustomerIds: customers.filter(function (c) {
                    return c['viewerCanManage'];
                }).map(function (c) {
                    return c['customer']['id'];
                }),
                projectCounts: customers.reduce(function (acc, c) {
                    return _extends({}, acc, _defineProperty({}, c['customer']['id'], c['projectsCount']));
                }, {}),
                taskCounts: customers.reduce(function (acc, c) {
                    return _extends({}, acc, _defineProperty({}, c['customer']['id'], c['tasksCount']));
                }, {}),
                futureCustomersAssigned: data['futureCustomersAssigned'],
                someCustomersOrLowerAssigned: data['someCustomersOrLowerAssigned'],
                allCustomersAssigned: data['allCustomersAssigned']
            }));
            dispatch(setCustomersLoaded(customers.length < loadLimit));
        };
    };

    var loadCustomersFailure = (0, _reduxActions.createAction)(LOAD_CUSTOMER_ASSIGNMENTS_EDITOR_DATA_FAILURE);

    var loadProjectsSuccess = function loadProjectsSuccess(data, loadLimit) {
        return function (dispatch) {
            var projects = data['projects'];
            dispatch((0, _utils.createActionObject)(LOAD_PROJECT_ASSIGNMENTS_EDITOR_DATA_SUCCESS, {
                canManageParentCustomer: data['canManageParentCustomer'],
                projectIds: projects.map(function (p) {
                    return p['project']['id'];
                }),
                canWorkProjectIds: projects.filter(function (p) {
                    return p['canWork'];
                }).map(function (p) {
                    return p['project']['id'];
                }),
                canManageProjectIds: projects.filter(function (p) {
                    return p['canManage'];
                }).map(function (p) {
                    return p['project']['id'];
                }),
                canManageProjectExcludeSelfIds: projects.filter(function (c) {
                    return c['canManageExcludeSelf'];
                }).map(function (c) {
                    return c['project']['id'];
                }),
                viewerCanManageProjectIds: projects.filter(function (p) {
                    return p['viewerCanManage'];
                }).map(function (p) {
                    return p['project']['id'];
                }),
                taskCounts: projects.reduce(function (acc, p) {
                    return _extends({}, acc, _defineProperty({}, p['project']['id'], p['tasksCount']));
                }, {}),
                futureProjectsAssigned: data['futureProjectsAssigned'],
                someProjectsOrLowerAssigned: data['someProjectsOrLowerAssigned'],
                allProjectsAssigned: data['allProjectsAssigned']
            }));

            dispatch(setProjectsLoaded(projects.length < loadLimit));
        };
    };

    var loadProjectsFailure = (0, _reduxActions.createAction)(LOAD_PROJECT_ASSIGNMENTS_EDITOR_DATA_FAILURE);

    var loadTasksSuccess = function loadTasksSuccess(data, loadLimit) {
        return function (dispatch) {
            var tasks = data['tasks'];
            dispatch((0, _utils.createActionObject)(LOAD_TASK_ASSIGNMENTS_EDITOR_DATA_SUCCESS, {
                canManageParentCustomer: data['canManageParentCustomer'],
                canManageParentProject: data['canManageParentProject'],
                taskIds: tasks.map(function (t) {
                    return t['task']['id'];
                }),
                canWorkTaskIds: tasks.filter(function (t) {
                    return t['canWork'];
                }).map(function (t) {
                    return t['task']['id'];
                }),
                canManageTaskIds: tasks.filter(function (t) {
                    return t['canManage'];
                }).map(function (t) {
                    return t['task']['id'];
                }),
                futureTasksAssigned: data['futureTasksAssigned'],
                someTasksAssigned: data['someTasksAssigned'],
                allTasksAssigned: data['allTasksAssigned']
            }));

            dispatch(setTasksLoaded(tasks.length < loadLimit));
        };
    };

    var loadTasksFailure = (0, _reduxActions.createAction)(LOAD_TASK_ASSIGNMENTS_EDITOR_DATA_FAILURE);

    var changeCustomerAssignmentSuccess = function changeCustomerAssignmentSuccess(customerId, canWork, canManage, someAssigned, allAssigned) {
        return function (dispatch) {
            // TODO: implement on server
            dispatch((0, _utils.createActionObject)(CHANGE_CUSTOMER_ASSIGNMENT_SUCCESS, {
                customerId: customerId,
                canWork: canWork,
                canManage: canManage,
                someAssigned: someAssigned,
                allAssigned: allAssigned
            }));
        };
    };

    var changeCustomerAssignmentFailure = function changeCustomerAssignmentFailure(customerId, assigned, error) {
        return (0, _utils.createActionObject)(CHANGE_CUSTOMER_ASSIGNMENT_FAILURE, {
            customerId: customerId,
            assigned: assigned,
            error: error
        });
    };

    var changeProjectAssignmentSuccess = function changeProjectAssignmentSuccess(projectId, canWork, canManage, someAssigned, allAssigned) {
        return function (dispatch) {
            // TODO: implement on server
            dispatch((0, _utils.createActionObject)(CHANGE_PROJECT_ASSIGNMENT_SUCCESS, {
                projectId: projectId,
                canWork: canWork,
                canManage: canManage,
                someAssigned: someAssigned,
                allAssigned: allAssigned
            }));
            dispatch((0, _utils.createActionObject)(CLEAR_CUSTOMERS));
        };
    };

    var changeProjectAssignmentFailure = function changeProjectAssignmentFailure(projectId, assigned, error) {
        return (0, _utils.createActionObject)(CHANGE_PROJECT_ASSIGNMENT_FAILURE, {
            projectId: projectId,
            assigned: assigned,
            error: error
        });
    };

    var changeTaskAssignmentSuccess = function changeTaskAssignmentSuccess(taskId, canWork, canManage, someAssigned, allAssigned) {
        return function (dispatch) {
            // TODO: implement on server
            dispatch((0, _utils.createActionObject)(CHANGE_TASK_ASSIGNMENT_SUCCESS, {
                taskId: taskId,
                canWork: canWork,
                canManage: canManage,
                someAssigned: someAssigned,
                allAssigned: allAssigned
            }));
            dispatch((0, _utils.createActionObject)(CLEAR_CUSTOMERS));
            dispatch((0, _utils.createActionObject)(CLEAR_PROJECTS));
        };
    };

    var changeTaskAssignmentFailure = function changeTaskAssignmentFailure(taskId, assigned, error) {
        return (0, _utils.createActionObject)(CHANGE_TASK_ASSIGNMENT_FAILURE, {
            taskId: taskId,
            assigned: assigned,
            error: error
        });
    };

    var assignAllCustomersSuccess = function assignAllCustomersSuccess() {
        return function (dispatch) {
            dispatch((0, _utils.createActionObject)(CHANGE_ALL_ASSIGNMENTS_SUCCESS));
            dispatch((0, _utils.createActionObject)(CLEAR_CUSTOMERS));
        };
    };

    var assignAllProjectsSuccess = function assignAllProjectsSuccess() {
        return function (dispatch) {
            dispatch((0, _utils.createActionObject)(CHANGE_ALL_ASSIGNMENTS_SUCCESS));
            dispatch((0, _utils.createActionObject)(CLEAR_CUSTOMERS));
            dispatch((0, _utils.createActionObject)(CLEAR_PROJECTS));
        };
    };

    var assignAllTasksSuccess = function assignAllTasksSuccess() {
        return function (dispatch) {
            dispatch((0, _utils.createActionObject)(CHANGE_ALL_ASSIGNMENTS_SUCCESS));
            dispatch((0, _utils.createActionObject)(CLEAR_CUSTOMERS));
            dispatch((0, _utils.createActionObject)(CLEAR_PROJECTS));
            dispatch((0, _utils.createActionObject)(CLEAR_TASKS));
        };
    };

    var changeCustomersSearchText = function changeCustomersSearchText(text) {
        return function (dispatch) {
            dispatch((0, _utils.createActionObject)(CUSTOMERS_SEARCH_OPEN_SET, true));
            dispatch((0, _utils.createActionObject)(CUSTOMERS_SEARCH_TEXT_SET, text));
            dispatch((0, _utils.createActionObject)(CLEAR_CUSTOMERS));
            dispatch(setLoaded(false));
        };
    };

    var clearCustomersSearchText = function clearCustomersSearchText() {
        return function (dispatch) {
            dispatch((0, _utils.createActionObject)(CUSTOMERS_SEARCH_OPEN_SET, false));
            dispatch((0, _utils.createActionObject)(CUSTOMERS_SEARCH_TEXT_SET, ''));
            dispatch((0, _utils.createActionObject)(CLEAR_CUSTOMERS));
            dispatch(setLoaded(false));
        };
    };

    var changeProjectsSearchText = function changeProjectsSearchText(text) {
        return function (dispatch) {
            dispatch((0, _utils.createActionObject)(PROJECTS_SEARCH_OPEN_SET, true));
            dispatch((0, _utils.createActionObject)(PROJECTS_SEARCH_TEXT_SET, text));
            dispatch((0, _utils.createActionObject)(CLEAR_PROJECTS));
            dispatch(setLoaded(false));
        };
    };

    var clearProjectsSearchText = function clearProjectsSearchText() {
        return function (dispatch) {
            dispatch((0, _utils.createActionObject)(PROJECTS_SEARCH_OPEN_SET, false));
            dispatch((0, _utils.createActionObject)(PROJECTS_SEARCH_TEXT_SET, ''));
            dispatch((0, _utils.createActionObject)(CLEAR_PROJECTS));
            dispatch(setLoaded(false));
        };
    };

    var changeTasksSearchText = function changeTasksSearchText(text) {
        return function (dispatch) {
            dispatch((0, _utils.createActionObject)(TASKS_SEARCH_OPEN_SET, true));
            dispatch((0, _utils.createActionObject)(TASKS_SEARCH_TEXT_SET, text));
            dispatch((0, _utils.createActionObject)(CLEAR_TASKS));
            dispatch(setLoaded(false));
        };
    };

    var clearTasksSearchText = function clearTasksSearchText() {
        return function (dispatch) {
            dispatch((0, _utils.createActionObject)(TASKS_SEARCH_OPEN_SET, false));
            dispatch((0, _utils.createActionObject)(TASKS_SEARCH_TEXT_SET, ''));
            dispatch((0, _utils.createActionObject)(CLEAR_TASKS));
            dispatch(setLoaded(false));
        };
    };

    var clearProjectsTasksCount = function clearProjectsTasksCount(projectIds) {
        return function (dispatch) {
            dispatch((0, _utils.createActionObject)(PROJECTS_TASKS_COUNT_CLEAR, projectIds));
        };
    };

    var clearCustomersTasksCount = function clearCustomersTasksCount(customerIds) {
        return function (dispatch) {
            dispatch((0, _utils.createActionObject)(CUSTOMERS_TASKS_COUNT_CLEAR, customerIds));
        };
    };

    var clearCustomersProjectsCount = function clearCustomersProjectsCount(customerIds) {
        return function (dispatch) {
            dispatch((0, _utils.createActionObject)(CUSTOMERS_PROJECTS_COUNT_CLEAR, customerIds));
        };
    };

    var clearAll = function clearAll() {
        return function (dispatch) {
            dispatch((0, _utils.createActionObject)(CLEAR_CUSTOMERS));
            dispatch((0, _utils.createActionObject)(CLEAR_PROJECTS));
            dispatch((0, _utils.createActionObject)(CLEAR_TASKS));
        };
    };

    return {
        clearAll: clearAll,
        setCustomersLoaded: setCustomersLoaded,
        setProjectsLoaded: setProjectsLoaded,
        setTasksLoaded: setTasksLoaded,
        openEditor: openEditor,
        closeEditor: closeEditor,
        selectCustomer: selectCustomer,
        selectProject: selectProject,
        deselectCustomer: deselectCustomer,
        deselectProject: deselectProject,
        loadCustomersSuccess: loadCustomersSuccess,
        loadCustomersFailure: loadCustomersFailure,
        loadProjectsSuccess: loadProjectsSuccess,
        loadProjectsFailure: loadProjectsFailure,
        loadTasksSuccess: loadTasksSuccess,
        loadTasksFailure: loadTasksFailure,
        changeCustomerAssignmentSuccess: changeCustomerAssignmentSuccess,
        changeCustomerAssignmentFailure: changeCustomerAssignmentFailure,
        changeProjectAssignmentSuccess: changeProjectAssignmentSuccess,
        changeProjectAssignmentFailure: changeProjectAssignmentFailure,
        changeTaskAssignmentSuccess: changeTaskAssignmentSuccess,
        changeTaskAssignmentFailure: changeTaskAssignmentFailure,
        assignAllCustomersSuccess: assignAllCustomersSuccess,
        assignAllProjectsSuccess: assignAllProjectsSuccess,
        assignAllTasksSuccess: assignAllTasksSuccess,
        clearProjectsTasksCount: clearProjectsTasksCount,
        clearCustomersTasksCount: clearCustomersTasksCount,
        clearCustomersProjectsCount: clearCustomersProjectsCount,
        changeCustomersSearchText: changeCustomersSearchText,
        clearCustomersSearchText: clearCustomersSearchText,
        changeProjectsSearchText: changeProjectsSearchText,
        clearProjectsSearchText: clearProjectsSearchText,
        changeTasksSearchText: changeTasksSearchText,
        clearTasksSearchText: clearTasksSearchText,
        resetSearchState: resetSearchState
    };
};

var _reduxActions = __webpack_require__(9);

var _utils = __webpack_require__(6);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.setDefaultWorkStatusPlanningData = exports.setInitialDefaultWorkStatus = exports.setWorkStatuses = undefined;

var _actionTypes = __webpack_require__(679);

var ActionTypes = _interopRequireWildcard(_actionTypes);

var _utils = __webpack_require__(6);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var setWorkStatuses = exports.setWorkStatuses = function setWorkStatuses(workStatuses) {
    return function (dispatch) {
        dispatch((0, _utils.createActionObject)(ActionTypes.WORK_STATUSES_SET, workStatuses.items));
    };
};

var setInitialDefaultWorkStatus = exports.setInitialDefaultWorkStatus = function setInitialDefaultWorkStatus(initialDefaultWorkStatus) {
    return function (dispatch) {
        dispatch((0, _utils.createActionObject)(ActionTypes.INITIAL_DEFAULT_WORK_STATUS_SET, initialDefaultWorkStatus));
    };
};

var setDefaultWorkStatusPlanningData = exports.setDefaultWorkStatusPlanningData = function setDefaultWorkStatusPlanningData(defaultWorkStatusPlanningData) {
    return function (dispatch) {
        dispatch((0, _utils.createActionObject)(ActionTypes.DEFAULT_WORK_STATUS_PLANNING_DATA_SET, defaultWorkStatusPlanningData));
    };
};

/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _UserInformationError;

var _BaseUserDataSection2 = __webpack_require__(396);

var _BaseUserDataSection3 = _interopRequireDefault(_BaseUserDataSection2);

var _atUtils = __webpack_require__(5);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _constants = __webpack_require__(21);

var _atBrowserUtils = __webpack_require__(8);

var _ScrollUtils = __webpack_require__(39);

var _ScrollUtils2 = _interopRequireDefault(_ScrollUtils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BaseUserInformationSection = function (_BaseUserDataSection) {
    _inherits(BaseUserInformationSection, _BaseUserDataSection);

    function BaseUserInformationSection() {
        _classCallCheck(this, BaseUserInformationSection);

        return _possibleConstructorReturn(this, (BaseUserInformationSection.__proto__ || Object.getPrototypeOf(BaseUserInformationSection)).apply(this, arguments));
    }

    return BaseUserInformationSection;
}(_BaseUserDataSection3.default);

var UserInformationErrors = (_UserInformationError = {}, _defineProperty(_UserInformationError, _constants.ValidationErrors.FIRST_NAME_EMPTY, true), _defineProperty(_UserInformationError, _constants.ValidationErrors.LAST_NAME_EMPTY, true), _defineProperty(_UserInformationError, _constants.ValidationErrors.EMAIL_EMPTY, true), _defineProperty(_UserInformationError, _constants.ValidationErrors.EMAIL_INVALID, true), _defineProperty(_UserInformationError, _constants.ValidationErrors.PASSWORD_EMPTY, true), _defineProperty(_UserInformationError, _constants.ValidationErrors.PASSWORDS_DO_NOT_MATCH, true), _defineProperty(_UserInformationError, _constants.ValidationErrors.PASSWORD_COPY_EMPTY, true), _defineProperty(_UserInformationError, _constants.ValidationErrors.OLD_PASSWORD_EMPTY, true), _defineProperty(_UserInformationError, _constants.ValidationErrors.OLD_PASSWORD_INCORRECT, true), _defineProperty(_UserInformationError, _constants.ValidationErrors.PASSWORD_RESTRICTIONS_VIOLATED, true), _defineProperty(_UserInformationError, _constants.ValidationErrors.USERNAME_EMPTY, true), _defineProperty(_UserInformationError, _constants.ValidationErrors.USERNAME_DUPLICATE, true), _defineProperty(_UserInformationError, _constants.ValidationErrors.NEW_USER_GROUP_EMPTY, true), _defineProperty(_UserInformationError, _constants.ValidationErrors.NEW_TIME_ZONE_GROUP_EMPTY, true), _defineProperty(_UserInformationError, _constants.ValidationErrors.DUPLICATE_TIME_ZONE_GROUP, true), _defineProperty(_UserInformationError, _constants.ValidationErrors.CITY_DATA_EMPTY, true), _defineProperty(_UserInformationError, _constants.ValidationErrors.HIRE_DATE_EMPTY, true), _defineProperty(_UserInformationError, _constants.ValidationErrors.HIRE_DATE_IN_FUTURE, true), _defineProperty(_UserInformationError, _constants.ValidationErrors.HIRE_DATE_IN_FUTURE_FOR_SELF, true), _defineProperty(_UserInformationError, _constants.ValidationErrors.RELEASE_DATE_IS_BEFORE_HIRE_DATE, true), _UserInformationError);

BaseUserInformationSection.prototype.init = function (_ref) {
    var _ref$lightBoxEl = _ref.lightBoxEl,
        lightBoxEl = _ref$lightBoxEl === undefined ? null : _ref$lightBoxEl,
        _ref$sectionId = _ref.sectionId,
        sectionId = _ref$sectionId === undefined ? '' : _ref$sectionId,
        _ref$userData = _ref.userData,
        userData = _ref$userData === undefined ? null : _ref$userData,
        _ref$changesCallback = _ref.changesCallback,
        changesCallback = _ref$changesCallback === undefined ? function () {} : _ref$changesCallback,
        _ref$validateCallback = _ref.validateCallback,
        validateCallback = _ref$validateCallback === undefined ? function () {} : _ref$validateCallback,
        _ref$isInstantValidat = _ref.isInstantValidation,
        isInstantValidation = _ref$isInstantValidat === undefined ? false : _ref$isInstantValidat,
        _ref$needValidation = _ref.needValidation,
        needValidation = _ref$needValidation === undefined ? true : _ref$needValidation;

    _BaseUserDataSection3.default.prototype.init.call(this, lightBoxEl, changesCallback, validateCallback);

    this._isInstantValidation = isInstantValidation;
    this.needValidation = needValidation;

    this.sectionEl = this.getElementBySubId(sectionId);
    this.firstNameField = this.$subId("firstNameField");
    this.lastNameField = this.$subId("lastNameField");
    this.middleNameField = this.$subId("middleNameField");
    this.emailField = this.$subId("emailField");

    this.firstNameField.off();
    this.lastNameField.off();
    this.middleNameField.off();
    this.emailField.off();

    this.setValue(this.firstNameField, userData.firstName);
    this.setValue(this.lastNameField, userData.lastName);
    this.setValue(this.middleNameField, userData.middleName);
    this.setValue(this.emailField, userData.email);

    this.firstNameField.placeholder();
    this.lastNameField.placeholder();
    this.middleNameField.placeholder();
    this.emailField.placeholder();

    this.errors = {};

    var self = this;

    var keyUpChangesHandler = function keyUpChangesHandler() {
        this.keyPressed = false;
        if (!this.prevValue && !!this.value || this.prevValue != this.value) self.changesDetected(true);
    };

    this.onKeyPressedHandler = function () {
        this.keyPressed = true;
    };

    this.onBlurFieldHandler = function (validator) {
        return function () {
            keyUpChangesHandler.call(this);

            (0, _jquery2.default)(this).pVal((0, _atUtils.trim)(this.value));
            //see Bug 48539
            if (this.keyPressed) keyUpChangesHandler.call(this);

            validator();
            (0, _jquery2.default)(this).trigger("changed", [(0, _jquery2.default)(this).pVal()]);
            self.updateUI();
            self.validationDetected();
        };
    };

    var firstNameBlurHandler = this.onBlurFieldHandler(function () {
        return self.needValidation ? self._checkFirstNameValid(true) : true;
    });
    var lastNameBlurHandler = this.onBlurFieldHandler(function () {
        return self.needValidation ? self._checkLastNameValid(true) : true;
    });
    var middleNameBlurHandler = this.onBlurFieldHandler(function () {
        return true;
    });
    var emailBlurHandler = this.onBlurFieldHandler(function () {
        return self.needValidation ? self._checkEmailValid(true) : true;
    });

    var subscribeFieldEvents = function subscribeFieldEvents($field, blurHandler) {
        $field.blur(blurHandler).keydown(function (e) {
            if ((0, _atBrowserUtils.isEscapePressed)(e) || (0, _atBrowserUtils.isEnterPressed)(e)) {
                $field.blur();
                e.stopPropagation();
            }
        });
    };

    subscribeFieldEvents(this.firstNameField, firstNameBlurHandler);
    subscribeFieldEvents(this.lastNameField, lastNameBlurHandler);
    subscribeFieldEvents(this.middleNameField, middleNameBlurHandler);
    subscribeFieldEvents(this.emailField, emailBlurHandler);

    this.updateUI();
    return this;
};

BaseUserInformationSection.prototype.$subId = function (subId) {
    return (0, _jquery2.default)(this.getElementBySubId(subId));
};

BaseUserInformationSection.prototype.setValue = function (field, value) {
    field.removeClass('placeholder'); // IE8 doesn't switch placeholder class when field value is set
    field[0].value = value;
    field[0].prevValue = field[0].value;
};

_BaseUserDataSection3.default.prototype.setDisabled = function (disabled) {
    this.firstNameField.prop('disabled', disabled);
    this.middleNameField.prop('disabled', disabled);
    this.lastNameField.prop('disabled', disabled);
    this.emailField.prop('disabled', disabled);
};

BaseUserInformationSection.prototype.setUpNameCallback = function (nameCallback) {
    if (!nameCallback) return;

    this._nameChangedCallback = nameCallback;
    var self = this;
    var keyUpHandler = function keyUpHandler() {
        this.keyPressed = false;self.nameKeyUpHandler(this);
    };

    this.firstNameField.keyup(keyUpHandler);
    this.firstNameField.blur(keyUpHandler);

    this.lastNameField.keyup(keyUpHandler);
    this.lastNameField.blur(keyUpHandler);

    this.middleNameField.keyup(keyUpHandler);
    this.middleNameField.blur(keyUpHandler);
};

BaseUserInformationSection.prototype.nameKeyUpHandler = function (field) {
    var $field = (0, _jquery2.default)(field);
    if (!field.prevValue || field.prevValue != $field.pVal()) {
        field.prevValue = $field.pVal();
        this._nameChanged();
    }
};

BaseUserInformationSection.prototype._nameChanged = function () {
    this._nameChangedCallback(this.firstNameField.pVal(), this.lastNameField.pVal(), this.middleNameField.pVal());
};

BaseUserInformationSection.prototype._isEmailValid = function (email) {
    return email.length == 0 || (0, _atUtils.isEmailValid)(email);
};

BaseUserInformationSection.prototype._checkEmailValid = function (onlyRemoveEmptyError) {
    this.errors[_constants.ValidationErrors.EMAIL_INVALID] = false;

    if (!this._checkEmpty(this.emailField, _constants.ValidationErrors.EMAIL_EMPTY, onlyRemoveEmptyError)) this.errors[_constants.ValidationErrors.EMAIL_INVALID] = !this._isEmailValid(this.getEmail());

    return !this.errors[_constants.ValidationErrors.EMAIL_INVALID];
};

BaseUserInformationSection.prototype.setEmailInvalid = function () {
    this.errors[_constants.ValidationErrors.EMAIL_INVALID] = true;
    this.validate();
    this.updateUI();
};

BaseUserInformationSection.prototype._checkFirstNameValid = function (onlyRemoveEmptyError) {
    return !this._checkEmpty(this.firstNameField, _constants.ValidationErrors.FIRST_NAME_EMPTY, onlyRemoveEmptyError);
};

BaseUserInformationSection.prototype._checkLastNameValid = function (onlyRemoveEmptyError) {
    return !this._checkEmpty(this.lastNameField, _constants.ValidationErrors.LAST_NAME_EMPTY, onlyRemoveEmptyError);
};

BaseUserInformationSection.prototype._checkEmpty = function (field, errorCode, onlyRemoveEmptyError) {
    if (field.pVal().length == 0) {
        if (!onlyRemoveEmptyError || this._isInstantValidation) {
            this.errors[errorCode] = true;
        }
    } else {
        this.errors[errorCode] = false;
    }
    return this.errors[errorCode];
};

BaseUserInformationSection.prototype.validate = function () {
    if (!this.needValidation) return true;

    var oldErrors = this.errors;
    this.errors = {};
    this._checkFirstNameValid();
    this._checkLastNameValid();
    this._checkEmailValid(false, oldErrors);
    this.customValidate(oldErrors);

    this.updateUI();
    return !this.hasErrors();
};

BaseUserInformationSection.prototype.customValidate = function (oldErrors) {};

BaseUserInformationSection.prototype.updateUI = function () {
    var classes = [];
    for (var p in this.errors) {
        if (this.errors[p] && UserInformationErrors.hasOwnProperty(p)) classes.push(p);
    }this.sectionEl.className = classes.join(" ");
};

BaseUserInformationSection.prototype.getFirstName = function () {
    return this.firstNameField.pVal();
};

BaseUserInformationSection.prototype.getLastName = function () {
    return this.lastNameField.pVal();
};

BaseUserInformationSection.prototype.getMiddleInitial = function () {
    return this.middleNameField.pVal();
};

BaseUserInformationSection.prototype.getEmail = function () {
    return this.emailField.pVal();
};

BaseUserInformationSection.prototype.getSectionElement = function () {
    return this.sectionEl;
};

exports.default = BaseUserInformationSection;

/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isUserRatesReadOnly = exports.getAuthorizationInfo = undefined;

var _selector = __webpack_require__(255);

var getAuthorizationInfo = exports.getAuthorizationInfo = function getAuthorizationInfo(state) {
  return (0, _selector.selectUserPanel)(state).authorizationInfo;
};

var isUserRatesReadOnly = exports.isUserRatesReadOnly = function isUserRatesReadOnly(state) {
  return !getAuthorizationInfo(state).costOfWorkRatesEditable;
};

/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _UserNameFormat = __webpack_require__(17);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CopyAssignmentsFromButton = function (_TemplateView) {
    _inherits(CopyAssignmentsFromButton, _TemplateView);

    function CopyAssignmentsFromButton() {
        _classCallCheck(this, CopyAssignmentsFromButton);

        var _this = _possibleConstructorReturn(this, (CopyAssignmentsFromButton.__proto__ || Object.getPrototypeOf(CopyAssignmentsFromButton)).call(this));

        _this.state = {
            selectedUser: null
        };

        _this.onStatePropertyChanged('selectedUser', function (user) {
            var username = user ? (0, _UserNameFormat.formatFML)(user.firstName, user.lastName, user.middleName) : "";
            var buttonTitle = user ? username : _messageResource2.default.getMessage("assign_to.tasks.users_selector.empty_selection_text");
            _this.$userButton.text(buttonTitle);
        });
        return _this;
    }

    _createClass(CopyAssignmentsFromButton, [{
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='buttonWrapper'>" + "    <div class='user ellipsis'/>" + "</div>";
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            this.$userButton = this.find('.user');
            this.renderInitialState();
        }
    }]);

    return CopyAssignmentsFromButton;
}(_TemplateView3.default);

exports.default = CopyAssignmentsFromButton;

/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var ALL_TABS_EMPTY_KEY = exports.ALL_TABS_EMPTY_KEY = "ALL_TABS_EMPTY";

/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _Button = __webpack_require__(33);

var _Button2 = _interopRequireDefault(_Button);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _atBrowserUtils = __webpack_require__(8);

var _Moire = __webpack_require__(785);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ConfirmationDialog = function (_TemplateView) {
    _inherits(ConfirmationDialog, _TemplateView);

    function ConfirmationDialog() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            _ref$contentComponent = _ref.contentComponent,
            contentComponent = _ref$contentComponent === undefined ? null : _ref$contentComponent,
            _ref$additionalClass = _ref.additionalClass,
            additionalClass = _ref$additionalClass === undefined ? '' : _ref$additionalClass,
            _ref$onConfirm = _ref.onConfirm,
            onConfirm = _ref$onConfirm === undefined ? function () {} : _ref$onConfirm,
            _ref$onCancel = _ref.onCancel,
            onCancel = _ref$onCancel === undefined ? function () {} : _ref$onCancel,
            _ref$onShow = _ref.onShow,
            onShow = _ref$onShow === undefined ? function () {} : _ref$onShow,
            _ref$onHide = _ref.onHide,
            onHide = _ref$onHide === undefined ? function () {} : _ref$onHide;

        _classCallCheck(this, ConfirmationDialog);

        var _this = _possibleConstructorReturn(this, (ConfirmationDialog.__proto__ || Object.getPrototypeOf(ConfirmationDialog)).call(this, null));

        _this.params = {
            contentComponent: contentComponent,
            additionalClass: additionalClass
        };

        _this.callbacks = {
            onConfirm: onConfirm,
            onCancel: onCancel,
            onShow: onShow,
            onHide: onHide
        };
        return _this;
    }

    _createClass(ConfirmationDialog, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class="components_confirmationDialog <%=additionalClass%>">' + '    <div class="content"/>' + '    <div class="buttons"/>' + '</div>';
        }
    }, {
        key: 'templateModel',
        value: function templateModel() {
            return {
                additionalClass: this.params.additionalClass
            };
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            var _this2 = this;

            this.params.contentComponent.init(this.find('.content'));

            this.okButton = new _Button2.default({
                label: _messageResource2.default.getMessage('common.ok'),
                additionalClass: 'okButton',
                handleEnterKeydown: true,
                onClickCb: function onClickCb() {
                    _this2.callbacks.onConfirm();
                    _this2.hide();
                }
            }).init(this.find('.buttons'));

            this.cancelButton = new _Button2.default({
                label: _messageResource2.default.getMessage('common.cancel'),
                additionalClass: 'cancelButton',
                onClickCb: function onClickCb() {
                    _this2.callbacks.onCancel();
                    _this2.hide();
                }
            }).init(this.find('.buttons'));

            this.moire = _Moire.Moire.getInstance();
            this.moire.getEl().click(function (e) {
                return e.stopPropagation();
            });
        }
    }, {
        key: 'hide',
        value: function hide() {
            _get(ConfirmationDialog.prototype.__proto__ || Object.getPrototypeOf(ConfirmationDialog.prototype), 'hide', this).call(this);
            this.moire.hide();
            this.callbacks.onHide();
        }
    }, {
        key: 'show',
        value: function show() {
            this.centreAlert();
            this.callbacks.onShow();
            this.moire.show();
            _get(ConfirmationDialog.prototype.__proto__ || Object.getPrototypeOf(ConfirmationDialog.prototype), 'show', this).call(this);
        }
    }, {
        key: 'centreAlert',
        value: function centreAlert() {
            var alert = this.getEl();
            alert.css('left', (0, _atBrowserUtils.px)(Math.floor(((0, _atBrowserUtils.getInsideWindowWidth)() - alert.outerWidth()) / 2)));
            alert.css('top', (0, _atBrowserUtils.px)(Math.floor(((0, _atBrowserUtils.getInsideWindowHeight)() - alert.outerHeight()) / 2)));
        }
    }]);

    return ConfirmationDialog;
}(_TemplateView3.default);

exports.default = ConfirmationDialog;

/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _constants = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LastManagerInfo = function (_TemplateView) {
    _inherits(LastManagerInfo, _TemplateView);

    function LastManagerInfo() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            _ref$isDeleting = _ref.isDeleting,
            isDeleting = _ref$isDeleting === undefined ? false : _ref$isDeleting,
            _ref$product = _ref.product,
            product = _ref$product === undefined ? _constants.CURRENT_PRODUCT : _ref$product;

        _classCallCheck(this, LastManagerInfo);

        var _this = _possibleConstructorReturn(this, (LastManagerInfo.__proto__ || Object.getPrototypeOf(LastManagerInfo)).call(this));

        _this.params = {
            isDeleting: isDeleting,
            product: product
        };

        _this.state = {
            userName: ''
        };

        _this.onStatePropertyChanged('userName', function (userName) {
            _this.$title.text(_this.params.isDeleting ? _messageResource2.default.getMessage('user.last_manager.delete.title', [userName]) : _messageResource2.default.getMessage('user.last_manager.disable.title', [_constants.PRODUCTS_INTEGRATED ? _this.params.product : _constants.CURRENT_PRODUCT, userName]));

            var productNames = _constants.PRODUCTS_INTEGRATED ? _constants.Product.actiTIME + ' & ' + _constants.Product.actiPLANS : _constants.CURRENT_PRODUCT;
            _this.$description.text(_this.params.isDeleting ? _messageResource2.default.getMessage('user.last_manager.delete.description', [userName, productNames]) : _messageResource2.default.getMessage('user.last_manager.disable.description', [userName, productNames]));
        });
        return _this;
    }

    _createClass(LastManagerInfo, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class="lastManagerInfo">' + '    <div class="title"/>' + '    <div class="description"/>' + '    <div class="note">' + '        <div class="icon"/>' + '        <div class="text"><%=note%></div>' + '    </div>' + '</div>';
        }
    }, {
        key: 'messageKeys',
        value: function messageKeys() {
            return {
                note: 'user.last_manager.note'
            };
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            this.$title = this.find('.title');
            this.$description = this.find('.description');
            this.renderInitialState();
        }
    }]);

    return LastManagerInfo;
}(_TemplateView3.default);

exports.default = LastManagerInfo;

/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.clearTasksSearchText = exports.changeTasksSearchText = exports.clearProjectsSearchText = exports.changeProjectsSearchText = exports.clearCustomersSearchText = exports.changeCustomersSearchText = exports.changeAllTasksAssignments = exports.changeAllProjectsAssignments = exports.changeAllCustomersAssignments = exports.changeTaskAssignment = exports.changeProjectAssignment = exports.changeCustomerAssignment = exports.loadMoreTasks = exports.loadMoreProjects = exports.loadMoreCustomers = exports.loadMoreEntities = exports.deselectProject = exports.deselectCustomer = exports.selectProject = exports.selectCustomer = exports.closeEditor = exports.openEditor = undefined;

var _actionTypes = __webpack_require__(690);

var ActionTypes = _interopRequireWildcard(_actionTypes);

var _utils = __webpack_require__(6);

var _rpcCalls = __webpack_require__(24);

var _selectors = __webpack_require__(312);

var _actions = __webpack_require__(29);

var EntitiesActions = _interopRequireWildcard(_actions);

var _constants = __webpack_require__(4);

var _actions2 = __webpack_require__(211);

var _actionsGenerator = __webpack_require__(553);

var _actionsGenerator2 = _interopRequireDefault(_actionsGenerator);

var _actions3 = __webpack_require__(167);

var _utils2 = __webpack_require__(393);

var _actions4 = __webpack_require__(50);

var _constants2 = __webpack_require__(201);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _utils3 = __webpack_require__(1717);

var _constants3 = __webpack_require__(259);

var _constants4 = __webpack_require__(108);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var hierarchyAssignmentsEditorActions = (0, _actionsGenerator2.default)({
    actionTypes: ActionTypes
});

var LOAD_LIMIT = 20;

var openEditor = exports.openEditor = hierarchyAssignmentsEditorActions.openEditor;

var closeEditor = exports.closeEditor = hierarchyAssignmentsEditorActions.closeEditor;

var selectCustomer = exports.selectCustomer = hierarchyAssignmentsEditorActions.selectCustomer;

var selectProject = exports.selectProject = hierarchyAssignmentsEditorActions.selectProject;

var deselectCustomer = exports.deselectCustomer = hierarchyAssignmentsEditorActions.deselectCustomer;

var deselectProject = exports.deselectProject = hierarchyAssignmentsEditorActions.deselectProject;

var loadMoreEntities = exports.loadMoreEntities = function loadMoreEntities() {
    return function (dispatch) {
        dispatch(loadMoreCustomers());
        dispatch(loadMoreProjects());
        dispatch(loadMoreTasks());
    };
};

var loadMoreCustomers = exports.loadMoreCustomers = function loadMoreCustomers() {
    return function (dispatch, getState) {
        var state = getState();
        if ((0, _selectors.needMoreCustomers)(state)) {
            var userId = (0, _selectors.getEditingUserId)(state);
            var searchText = (0, _selectors.getCustomersSearchText)(state);
            var offset = (0, _selectors.getCustomerIdsOrder)(state).length;

            dispatch((0, _utils.createActionObject)(ActionTypes.LOAD_CUSTOMER_ASSIGNMENTS_EDITOR_DATA));
            (0, _rpcCalls.rpcCall)('UserManagementService.getCustomerWorkAssignmentsEditorData', [userId, searchText, offset, LOAD_LIMIT], _utils3.rpcErrorHandler).then(function (data) {
                dispatch(EntitiesActions.addCustomers(data['customers'].map(function (c) {
                    return c['customer'];
                })));
                dispatch(hierarchyAssignmentsEditorActions.loadCustomersSuccess(data, LOAD_LIMIT));
            }).catch(function (error) {
                dispatch(closeEditor());
                dispatch(hierarchyAssignmentsEditorActions.loadCustomersFailure(error));
                dispatch(commonWAEditorPanelErrorHandler(error));
            });
        }
    };
};

var loadMoreProjects = exports.loadMoreProjects = function loadMoreProjects() {
    return function (dispatch, getState) {
        var state = getState();
        if ((0, _selectors.needMoreProjects)(state)) {
            var userId = (0, _selectors.getEditingUserId)(state);
            var customerId = (0, _selectors.getEditingLevel)(state).customerId;
            var searchText = (0, _selectors.getProjectsSearchText)(state);
            var offset = (0, _selectors.getProjectIdsOrder)(state).length;

            dispatch((0, _utils.createActionObject)(ActionTypes.LOAD_PROJECT_ASSIGNMENTS_EDITOR_DATA));
            (0, _rpcCalls.rpcCall)('UserManagementService.getProjectWorkAssignmentsEditorData', [userId, customerId, searchText, offset, LOAD_LIMIT], _utils3.rpcErrorHandler).then(function (data) {
                dispatch(EntitiesActions.addProjects(data['projects'].map(function (p) {
                    return p['project'];
                })));
                dispatch(hierarchyAssignmentsEditorActions.loadProjectsSuccess(data, LOAD_LIMIT));
            }).catch(function (error) {
                dispatch(closeEditor());
                dispatch(commonWAEditorPanelErrorHandler(error));
                dispatch(hierarchyAssignmentsEditorActions.loadProjectsFailure(error));
            });
        }
    };
};

var loadMoreTasks = exports.loadMoreTasks = function loadMoreTasks() {
    return function (dispatch, getState) {
        var state = getState();
        if ((0, _selectors.needMoreTasks)(state)) {
            var userId = (0, _selectors.getEditingUserId)(state);
            var projectId = (0, _selectors.getEditingLevel)(state).projectId;
            var searchText = (0, _selectors.getTasksSearchText)(state);
            var offset = (0, _selectors.getTaskIdsOrder)(state).length;

            dispatch((0, _utils.createActionObject)(ActionTypes.LOAD_TASK_ASSIGNMENTS_EDITOR_DATA));
            (0, _rpcCalls.rpcCall)('UserManagementService.getTaskWorkAssignmentsEditorData', [userId, projectId, searchText, offset, LOAD_LIMIT], _utils3.rpcErrorHandler).then(function (data) {
                dispatch(EntitiesActions.addTasks(data['tasks'].map(function (t) {
                    return t['task'];
                })));
                dispatch(hierarchyAssignmentsEditorActions.loadTasksSuccess(data, LOAD_LIMIT));
            }).catch(function (error) {
                dispatch(closeEditor());
                dispatch(commonWAEditorPanelErrorHandler(error));
                hierarchyAssignmentsEditorActions.loadTasksFailure(error);
            });
        }
    };
};

var updateWorkAssignmentsTabCounters = function updateWorkAssignmentsTabCounters(userManagementResult) {
    return function (dispatch) {
        var userId = userManagementResult['userInfo']['id'];
        var cptCounters = userManagementResult['additionalResultData']['map']['workAssignmentsCounters'];
        if (cptCounters) {
            dispatch((0, _actions3.setWorkAssignmentsCountersForUser)(userId, cptCounters));
        }
        dispatch((0, _actions.addUser)(userManagementResult['userInfo']));
    };
};

var changeCustomerAssignment = exports.changeCustomerAssignment = function changeCustomerAssignment(customerId, assigned) {
    return function (dispatch, getState) {
        var state = getState();
        var userId = (0, _selectors.getEditingUserId)(state);

        dispatch((0, _utils.createActionObject)(ActionTypes.CHANGE_CUSTOMER_ASSIGNMENT, {
            customerId: customerId,
            assigned: assigned
        }));

        var method = assigned ? 'UserManagementService.changeUserWorkAssignments' : 'UserManagementService.removeUserWorkAssignments';
        var params = assigned ? [userId, false, [customerId], [], [], [], null, null] : [userId, customerId, _constants.UserHierarchyAssignmentEntityType.CUSTOMER, null, null];

        (0, _rpcCalls.rpcCall)(method, params, _utils3.rpcErrorHandler).then(function (data) {
            if ((0, _utils2.hasConcurrentlyRemovedEntities)(data)) {
                dispatch(handleConcurrentlyRemovedEntities(data));
            } else {
                if (!assigned) {
                    var keptCpt = data.additionalResultData.map.keptCptMaAfterRemoveWa;
                    if (keptCpt.customersKept || keptCpt.projectsKept || keptCpt.tasksKept || keptCpt.noDeletions) {
                        dispatch((0, _actions4.handleKeptMaAfterRemoveWaByToast)({ cptWaChangesFlags: keptCpt, level: _constants.HierarchyLevels.CUSTOMER, all: false }));
                        dispatch(hierarchyAssignmentsEditorActions.setProjectsLoaded(false));
                    } else {
                        dispatch(hierarchyAssignmentsEditorActions.clearCustomersTasksCount([customerId]));
                        dispatch(hierarchyAssignmentsEditorActions.clearCustomersProjectsCount([customerId]));
                    }
                }
                var _data$additionalResul = data.additionalResultData.map[_constants2.AdditionalDataConstants.ALL_ASSIGNED_INFO],
                    someAssigned = _data$additionalResul.someAssigned,
                    allAssigned = _data$additionalResul.allAssigned;

                dispatch(hierarchyAssignmentsEditorActions.changeCustomerAssignmentSuccess(customerId, assigned, undefined, someAssigned, allAssigned));
            }
            dispatch((0, _actions2.clearTabsLoaded)());
            dispatch(updateWorkAssignmentsTabCounters(data));
        }).catch(function (error) {
            dispatch(commonWAEditorPanelErrorHandler(error));
            dispatch(hierarchyAssignmentsEditorActions.changeCustomerAssignmentFailure(customerId, assigned, error));
        });
    };
};

var changeProjectAssignment = exports.changeProjectAssignment = function changeProjectAssignment(projectId, assigned) {
    return function (dispatch, getState) {
        var state = getState();
        var userId = (0, _selectors.getEditingUserId)(state);
        var customerId = (0, _selectors.getEditingLevel)(state).customerId;
        var canManage = (0, _selectors.getCanManageProjectIds)(state)[projectId] === true;

        dispatch((0, _utils.createActionObject)(ActionTypes.CHANGE_PROJECT_ASSIGNMENT, {
            projectId: projectId,
            assigned: assigned
        }));

        var method = assigned ? 'UserManagementService.changeUserWorkAssignments' : 'UserManagementService.removeUserWorkAssignments';
        var params = assigned ? [userId, false, [], [projectId], [], [], customerId, null] : [userId, projectId, _constants.UserHierarchyAssignmentEntityType.PROJECT, customerId, null];

        (0, _rpcCalls.rpcCall)(method, params, _utils3.rpcErrorHandler).then(function (data) {
            var keptCpt = data.additionalResultData.map.keptCptMaAfterRemoveWa;
            if ((0, _utils2.hasConcurrentlyRemovedEntities)(data)) {
                dispatch(handleConcurrentlyRemovedEntities(data));
            } else {
                if (!assigned && (keptCpt.customersKept || keptCpt.projectsKept || keptCpt.tasksKept || keptCpt.noDeletions)) {
                    dispatch((0, _actions4.handleKeptMaAfterRemoveWaByToast)({ cptWaChangesFlags: keptCpt, level: _constants.HierarchyLevels.PROJECT, all: true }));
                    dispatch(hierarchyAssignmentsEditorActions.setProjectsLoaded(false));
                } else {
                    if (!assigned) dispatch(hierarchyAssignmentsEditorActions.clearProjectsTasksCount([projectId]));
                }
                var _data$additionalResul2 = data.additionalResultData.map[_constants2.AdditionalDataConstants.ALL_ASSIGNED_INFO],
                    someAssigned = _data$additionalResul2.someAssigned,
                    allAssigned = _data$additionalResul2.allAssigned;

                dispatch(hierarchyAssignmentsEditorActions.changeProjectAssignmentSuccess(projectId, assigned, canManage, someAssigned, allAssigned));
            }
            dispatch((0, _actions2.clearTabsLoaded)());
            dispatch(updateWorkAssignmentsTabCounters(data));
        }).catch(function (error) {
            dispatch(hierarchyAssignmentsEditorActions.changeProjectAssignmentFailure(projectId, assigned, error));
            dispatch(commonWAEditorPanelErrorHandler(error));
        });
    };
};

var changeTaskAssignment = exports.changeTaskAssignment = function changeTaskAssignment(taskId, assigned) {
    return function (dispatch, getState) {
        var state = getState();
        var userId = (0, _selectors.getEditingUserId)(state);

        var _getEditingLevel = (0, _selectors.getEditingLevel)(state),
            customerId = _getEditingLevel.customerId,
            projectId = _getEditingLevel.projectId;

        dispatch((0, _utils.createActionObject)(ActionTypes.CHANGE_TASK_ASSIGNMENT, {
            taskId: taskId,
            assigned: assigned
        }));

        var method = assigned ? 'UserManagementService.changeUserWorkAssignments' : 'UserManagementService.removeUserWorkAssignments';
        var params = assigned ? [userId, false, [], [], [taskId], [], customerId, projectId] : [userId, taskId, _constants.UserHierarchyAssignmentEntityType.TASK, customerId, projectId];

        (0, _rpcCalls.rpcCall)(method, params, _utils3.rpcErrorHandler).then(function (data) {
            if ((0, _utils2.hasConcurrentlyRemovedEntities)(data)) {
                dispatch(handleConcurrentlyRemovedEntities(data));
            } else {
                var _data$additionalResul3 = data.additionalResultData.map[_constants2.AdditionalDataConstants.ALL_ASSIGNED_INFO],
                    someAssigned = _data$additionalResul3.someAssigned,
                    allAssigned = _data$additionalResul3.allAssigned;

                dispatch(hierarchyAssignmentsEditorActions.changeTaskAssignmentSuccess(taskId, assigned, undefined, someAssigned, allAssigned));
            }
            dispatch((0, _actions2.clearTabsLoaded)());
            dispatch(updateWorkAssignmentsTabCounters(data));
            if (!assigned) {
                dispatch((0, _actions4.handleKeptMaAfterRemoveWaByToast)({
                    cptWaChangesFlags: data.additionalResultData.map.keptCptMaAfterRemoveWa,
                    level: _constants.HierarchyLevels.TASK,
                    all: false
                }));
            }
        }).catch(function (error) {
            dispatch(hierarchyAssignmentsEditorActions.changeTaskAssignmentFailure(taskId, assigned, error));
            dispatch(commonWAEditorPanelErrorHandler(error));
        });
    };
};

var changeAllCustomersAssignments = exports.changeAllCustomersAssignments = function changeAllCustomersAssignments(assigned) {
    return function (dispatch, getState) {
        var state = getState();
        var userId = (0, _selectors.getEditingUserId)(state);

        dispatch((0, _utils.createActionObject)(ActionTypes.CHANGE_ALL_ASSIGNMENTS));

        (0, _rpcCalls.rpcCall)('UserManagementService.changeAllCustomersWorkAssignments', [userId, assigned], _utils3.rpcErrorHandler).then(function (data) {
            if ((0, _utils2.hasConcurrentlyRemovedEntities)(data)) {
                dispatch(handleConcurrentlyRemovedEntities(data, true));
            }
            dispatch(hierarchyAssignmentsEditorActions.assignAllCustomersSuccess());
            dispatch((0, _actions2.clearTabsLoaded)());
            dispatch(updateWorkAssignmentsTabCounters(data));
        }).catch(function (error) {
            dispatch((0, _utils.createActionObject)(ActionTypes.CHANGE_ALL_ASSIGNMENTS_FAILURE));
            dispatch(commonWAEditorPanelErrorHandler(error));
        });
    };
};

var changeAllProjectsAssignments = exports.changeAllProjectsAssignments = function changeAllProjectsAssignments(assigned) {
    return function (dispatch, getState) {
        var state = getState();
        var userId = (0, _selectors.getEditingUserId)(state);
        var customerId = (0, _selectors.getEditingLevel)(state).customerId;

        dispatch((0, _utils.createActionObject)(ActionTypes.CHANGE_ALL_ASSIGNMENTS));

        (0, _rpcCalls.rpcCall)('UserManagementService.changeAllProjectsWorkAssignments', [userId, customerId, assigned], _utils3.rpcErrorHandler).then(function (data) {
            if ((0, _utils2.hasConcurrentlyRemovedEntities)(data)) {
                dispatch(handleConcurrentlyRemovedEntities(data, true));
            }
            dispatch(hierarchyAssignmentsEditorActions.assignAllProjectsSuccess());
            dispatch((0, _actions2.clearTabsLoaded)());
            dispatch(updateWorkAssignmentsTabCounters(data));
        }).catch(function (error) {
            dispatch((0, _utils.createActionObject)(ActionTypes.CHANGE_ALL_ASSIGNMENTS_FAILURE));
            dispatch(commonWAEditorPanelErrorHandler(error));
        });
    };
};

var changeAllTasksAssignments = exports.changeAllTasksAssignments = function changeAllTasksAssignments(assigned) {
    return function (dispatch, getState) {
        var state = getState();
        var userId = (0, _selectors.getEditingUserId)(state);

        var _getEditingLevel2 = (0, _selectors.getEditingLevel)(state),
            customerId = _getEditingLevel2.customerId,
            projectId = _getEditingLevel2.projectId;

        dispatch((0, _utils.createActionObject)(ActionTypes.CHANGE_ALL_ASSIGNMENTS));

        (0, _rpcCalls.rpcCall)('UserManagementService.changeAllTasksWorkAssignments', [userId, customerId, projectId, assigned], _utils3.rpcErrorHandler).then(function (data) {
            if ((0, _utils2.hasConcurrentlyRemovedEntities)(data)) {
                dispatch(handleConcurrentlyRemovedEntities(data, true));
            }
            dispatch(hierarchyAssignmentsEditorActions.assignAllTasksSuccess());
            dispatch((0, _actions2.clearTabsLoaded)());
            dispatch(updateWorkAssignmentsTabCounters(data));
        }).catch(function (error) {
            dispatch((0, _utils.createActionObject)(ActionTypes.CHANGE_ALL_ASSIGNMENTS_FAILURE));
            dispatch(commonWAEditorPanelErrorHandler(error));
        });
    };
};

var handleConcurrentlyRemovedEntities = function handleConcurrentlyRemovedEntities(data, assignAll) {
    return function (dispatch) {
        dispatch((0, _utils2.handleConcurrentlyRemovedEntitiesAction)({
            getEditingLevel: _selectors.getEditingLevel,
            hierarchyAssignmentsEditorActions: hierarchyAssignmentsEditorActions
        })(data, assignAll));
    };
};

var changeCustomersSearchText = exports.changeCustomersSearchText = hierarchyAssignmentsEditorActions.changeCustomersSearchText;
var clearCustomersSearchText = exports.clearCustomersSearchText = hierarchyAssignmentsEditorActions.clearCustomersSearchText;

var changeProjectsSearchText = exports.changeProjectsSearchText = hierarchyAssignmentsEditorActions.changeProjectsSearchText;
var clearProjectsSearchText = exports.clearProjectsSearchText = hierarchyAssignmentsEditorActions.clearProjectsSearchText;

var changeTasksSearchText = exports.changeTasksSearchText = hierarchyAssignmentsEditorActions.changeTasksSearchText;
var clearTasksSearchText = exports.clearTasksSearchText = hierarchyAssignmentsEditorActions.clearTasksSearchText;

var commonWAEditorPanelErrorHandler = function commonWAEditorPanelErrorHandler(error) {
    return function (dispatch) {
        dispatch((0, _actions4.handleCommonError)(error));

        switch (error.getException()) {
            case _constants3.Exceptions.NoSuchUserException:
                alert(_messageResource2.default.getMessage('work_assignments.panel.copy.error.user_deleted'));
                break;
            case _constants4.Exceptions.WORK_ASSIGNMENTS_FEATURE_DISABLED_EXCEPTION:
                alert(_messageResource2.default.getMessage("common.turned_off_functionality", [_messageResource2.default.getMessage("features.WAS.title")]));
                window.location.reload();
                break;
            case _constants3.Exceptions.UserHasAccessToAllScopeException:
                alert(_messageResource2.default.getMessage('work_assignments.error.selected_user_have_entire_scope'));
                window.location.reload();
                break;
            case _constants4.Exceptions.NO_RIGHTS_TO_SUBMIT_TT_EXCEPTION:
                alert(_messageResource2.default.getMessage('work_assignments.error.selected_user_does_not_have_submit_tt'));
                window.location.reload();
                break;
        }
    };
};

/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _two_level_selection = __webpack_require__(70);

var _two_level_selection2 = _interopRequireDefault(_two_level_selection);

var _at_shared_user_button_menu = __webpack_require__(159);

var _at_shared_user_button_menu2 = _interopRequireDefault(_at_shared_user_button_menu);

var _at_users_selector_panel = __webpack_require__(162);

var _at_users_selector_panel2 = _interopRequireDefault(_at_users_selector_panel);

var _Ext = __webpack_require__(12);

var _Ext2 = _interopRequireDefault(_Ext);

var _at_selector_panel_with_apply_button_object = __webpack_require__(231);

var _at_selector_panel_with_apply_button_object2 = _interopRequireDefault(_at_selector_panel_with_apply_button_object);

var _at_hierarchy_selector_dropdown_button = __webpack_require__(232);

var _at_hierarchy_selector_dropdown_button2 = _interopRequireDefault(_at_hierarchy_selector_dropdown_button);

var _simple_users_and_groups_selection_helper = __webpack_require__(374);

var _simple_users_and_groups_selection_helper2 = _interopRequireDefault(_simple_users_and_groups_selection_helper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UsersFilter = function (_TemplateView) {
    _inherits(UsersFilter, _TemplateView);

    function UsersFilter(_ref) {
        var _ref$onChange = _ref.onChange,
            onChange = _ref$onChange === undefined ? function (_ref2) {
            var userIds = _ref2.userIds,
                groupIds = _ref2.groupIds,
                groupType = _ref2.groupType,
                allSelected = _ref2.allSelected;
        } : _ref$onChange,
            createSelectionDescription = _ref.createSelectionDescription,
            _ref$showInactiveChec = _ref.showInactiveCheckbox,
            showInactiveCheckbox = _ref$showInactiveChec === undefined ? true : _ref$showInactiveChec,
            _ref$setAllUsersIfNon = _ref.setAllUsersIfNoneSelected,
            setAllUsersIfNoneSelected = _ref$setAllUsersIfNon === undefined ? true : _ref$setAllUsersIfNon;

        _classCallCheck(this, UsersFilter);

        var _this = _possibleConstructorReturn(this, (UsersFilter.__proto__ || Object.getPrototypeOf(UsersFilter)).call(this));

        _this._handleSelectionChanged = function (data) {
            _this.params.onChange(data);
        };

        _this.panelMakeSelectionHelper = function () {
            var panel = _this.panel;
            panel.selectionHelper = new _simple_users_and_groups_selection_helper2.default({
                itemNounSingularKey: panel.labelItemNounSingularKey,
                itemNounPluralKey: panel.labelItemNounPluralKey,
                showInactiveCount: true,
                showSingleItemInactiveText: false,
                userSelectorGroupsStrategy: panel.userSelectorGroupsStrategy,
                maxCharacters: panel.labelMaxChars,
                isNeededInformationAboutDisabledUsers: false,
                pleaseSelectMessageKey: "users_selector.short_no_users_selected",
                useNameForSingleItem: false,
                getDescription: function getDescription(selection) {
                    return _this.params.createSelectionDescription(selection, _this.state.users);
                }
            });
        };

        _this.state = {
            users: [],
            userIds: [],
            groupIds: [],
            groupType: null,
            userGroups: null,
            timeZoneGroups: null,
            allSelected: false
        };

        _this.params = {
            onChange: onChange,
            createSelectionDescription: createSelectionDescription,
            showInactiveCheckbox: showInactiveCheckbox,
            setAllUsersIfNoneSelected: setAllUsersIfNoneSelected
        };

        _this.onStateDeeplyChanged(function () {
            _this._initPanel();
        });
        return _this;
    }

    _createClass(UsersFilter, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class="userList_usersFilter commonVisibleFilterButton whiteBackground">' + '    <div class="mainIcon"></div>' + '    <div class="label usersSelector"></div>' + '    <div class="downIcon"></div>' + '</div>';
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            this.$usersSelector = this.find('.usersSelector');
        }
    }, {
        key: '_initPanel',
        value: function _initPanel() {
            var _this2 = this;

            this.$el.toggleClass('filtered', !this.state.allSelected);

            var PanelCtr = _at_users_selector_panel2.default;
            var ctrParams = {};
            _Ext2.default.apply(ctrParams, _at_selector_panel_with_apply_button_object2.default.getApplyButtonExtension(PanelCtr));
            this.panel = new PanelCtr(_extends({}, ctrParams, {
                onCloseButtonClick: function onCloseButtonClick() {
                    _at_users_selector_panel2.default.superclass.onCloseButtonClick.call(_this2.panel);

                    var result = {
                        userIds: _this2.panel.getSelection().getSecondLevel(),
                        groupIds: _this2.panel.getSelection().getFirstLevel(),
                        groupType: _this2.panel.getGroupType(),
                        allSelected: !_this2.panel.isCustomOptionSelected()
                    };
                    _this2._handleSelectionChanged(result);
                },

                makeSelectionHelper: this.panelMakeSelectionHelper,
                allItemsOptionLabelKey: 'user_groups_selector.smart.message.all_items.selected',
                showShowInactiveCheckbox: this.params.showInactiveCheckbox
            }));
            this.panel.initialize(!!this.state.userGroups, !!this.state.timeZoneGroups, this.state.users, this.state.userGroups, this.state.timeZoneGroups);

            this.panel.loadState({
                selection: new _two_level_selection2.default(this.state.groupIds, this.state.userIds),
                groupType: this.state.groupType,
                additionalCheckBoxValue: false,
                optionValue: this.state.allSelected,
                showInactive: false
            });

            // if button not exists or linked menu already not actual - create new button and link with actual menu
            if (this.filterButton) {
                this.filterButton.menu = null; // because ext.js cannot destroy menu without problems
                this.filterButton.destroy(); // delete prev button
            }

            this.filterButton = new _at_hierarchy_selector_dropdown_button2.default({
                renderTo: this.$usersSelector[0],
                menu: new _at_shared_user_button_menu2.default({
                    panel: this.panel,
                    additionalCls: 'ul_components_usersFilter_menu'
                }),
                menuAlign: "tl-bl?",
                menuAnchor: "td.middle-left-cell"
            });

            if (this.params.setAllUsersIfNoneSelected) {
                this.filterButton.setMenuHideCallback(function () {
                    _this2.panel.setAllUsersIfNoneSelected();
                });
            }

            this.filterButton.on("menuhide", function () {
                return _this2.$el.removeClass("pressed");
            });
            this.filterButton.on("menushow", function () {
                return _this2.$el.addClass("pressed");
            });

            this.filterButton.updateButton();
        }
    }]);

    return UsersFilter;
}(_TemplateView3.default);

exports.default = UsersFilter;

/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Tab = function (_TemplateView) {
    _inherits(Tab, _TemplateView);

    function Tab(_ref) {
        var _ref$id = _ref.id,
            id = _ref$id === undefined ? -1 : _ref$id,
            _ref$text = _ref.text,
            text = _ref$text === undefined ? '' : _ref$text,
            _ref$extraClass = _ref.extraClass,
            extraClass = _ref$extraClass === undefined ? '' : _ref$extraClass,
            _ref$onClick = _ref.onClick,
            onClick = _ref$onClick === undefined ? function () {} : _ref$onClick;

        _classCallCheck(this, Tab);

        var _this = _possibleConstructorReturn(this, (Tab.__proto__ || Object.getPrototypeOf(Tab)).call(this, null));

        _this.props = {
            id: id,
            text: text,
            onClick: onClick,
            extraClass: extraClass
        };

        _this.state = {
            active: false
        };

        _this.onStateChanged(function () {
            _this.$el.toggleClass('active', _this.state.active);
        });
        return _this;
    }

    _createClass(Tab, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class="<%-extraClass%> components_tabButton ">' + '    <div class="tabText">                             ' + '        <%-text%>                                  ' + '    </div>                                         ' + '</div>                                             ';
        }
    }, {
        key: 'templateModel',
        value: function templateModel() {
            return _extends({}, this.props);
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            var _this2 = this;

            this.$el.on('click', function () {
                _this2.props.onClick(_this2.props.id);
            });
        }
    }]);

    return Tab;
}(_TemplateView3.default);

exports.default = Tab;

/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _BaseUserDataSection = __webpack_require__(396);

var _BaseUserDataSection2 = _interopRequireDefault(_BaseUserDataSection);

var _BaseUserInformationSection = __webpack_require__(555);

var _BaseUserInformationSection2 = _interopRequireDefault(_BaseUserInformationSection);

var _UserNameDrawer = __webpack_require__(349);

var _UserNameDrawer2 = _interopRequireDefault(_UserNameDrawer);

var _PasswordFieldsDrawer = __webpack_require__(468);

var _PasswordFieldsDrawer2 = _interopRequireDefault(_PasswordFieldsDrawer);

var _WorkdayDurationsEditor = __webpack_require__(260);

var _WorkdayDurationsEditor2 = _interopRequireDefault(_WorkdayDurationsEditor);

var _BalanceRulesEditor = __webpack_require__(125);

var _user_time = __webpack_require__(30);

var _user_time2 = _interopRequireDefault(_user_time);

var _date_format = __webpack_require__(16);

var _ScrollUtils = __webpack_require__(39);

var _ScrollUtils2 = _interopRequireDefault(_ScrollUtils);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _PasswordPolicyManager = __webpack_require__(227);

var _PasswordPolicyManager2 = _interopRequireDefault(_PasswordPolicyManager);

var _PasswordHintLink = __webpack_require__(731);

var _PasswordHintLink2 = _interopRequireDefault(_PasswordHintLink);

var _PasswordAsyncValidator = __webpack_require__(280);

var _PasswordErrorMessage = __webpack_require__(732);

var _PasswordErrorMessage2 = _interopRequireDefault(_PasswordErrorMessage);

var _constants = __webpack_require__(21);

var _atBrowserUtils = __webpack_require__(8);

var _constants2 = __webpack_require__(77);

var _DefaultWorkday = __webpack_require__(1752);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function UserProfileSection() {}

UserProfileSection.OLD_PASSWORD_EMPTY = "oldPasswordEmpty";

UserProfileSection.prototype = new _BaseUserInformationSection2.default();

UserProfileSection.prototype.init = function (lightBoxEl, userData, changesCallback, validateCallback, isInstantValidation, isPTOEnabled, isSickEnabled, mailSettingsSpecified, isWSDEnabled, isDefaultWorkdaySectionShown) {
    var _this = this;

    var sectionId = "userProfileSection";
    var self = this;
    _BaseUserInformationSection2.default.prototype.init.call(this, {
        lightBoxEl: lightBoxEl,
        sectionId: sectionId,
        userData: userData,
        changesCallback: changesCallback,
        validateCallback: validateCallback,
        isInstantValidation: isInstantValidation,
        needValidation: true
    });
    new _PasswordHintLink2.default({ passwordPolicy: _PasswordPolicyManager2.default }).init(this.$subId("passwordHintCell"));

    this.usernameFieldDrawer = new _UserNameDrawer2.default().init({
        getElementByIdFunction: function getElementByIdFunction(subId) {
            return self.getElementBySubId(subId);
        },
        changeDetectedFunction: function changeDetectedFunction(notRequireConfirmationOnCopySettings) {
            self.changesDetected(notRequireConfirmationOnCopySettings);
        },
        updateUICallback: function updateUICallback() {
            _jquery2.default.extend(self.errors, self.usernameFieldDrawer.getErrors());
            self.updateUI();
        },
        validationDetectedCallback: function validationDetectedCallback() {
            self.validationDetected();
        }
    });
    this.usernameFieldDrawer.initFields({ username: userData.username, id: userData.userId });

    this.passwordFieldDrawer = new _PasswordFieldsDrawer2.default().init({
        disableValidation: true,
        getElementByIdFunction: function getElementByIdFunction(subId) {
            return self.getElementBySubId(subId);
        },
        changeDetectedFunction: function changeDetectedFunction(notRequireConfirmationOnCopySettings) {
            self.changesDetected(notRequireConfirmationOnCopySettings);
        },

        updateUICallback: function updateUICallback() {
            _jquery2.default.extend(self.errors, self.passwordFieldDrawer.getErrors());
            self.updateUI();
        },
        validationDetectedCallback: function validationDetectedCallback() {
            self.validationDetected();
        }
    });
    this.passwordFieldDrawer.initFields(userData);
    this.passwordFieldDrawer.setPasswordFieldsPlaceholders();
    this.passwordFieldDrawer.passwordField.on("changed", function () {
        var _self$passwordFieldDr = self.passwordFieldDrawer.getPlainPasswordValues(),
            password = _self$passwordFieldDr.password,
            passwordCopy = _self$passwordFieldDr.passwordCopy;

        self.passwordAsyncValidator.setState({ password: password, passwordCopy: passwordCopy, forcePasswordCheck: true });
    });

    this.passwordAsyncValidator = (0, _PasswordAsyncValidator.getPasswordValidator)({
        ignoreBothEmptyness: true,
        onValidationEnd: function onValidationEnd(errorKey, passwordValidationJson) {
            _this.setPasswordError(errorKey, passwordValidationJson);
        }
    });
    this.passwordFieldsError = new _PasswordErrorMessage2.default({ additionalClass: "inlineErrorMessage" }).init(this.$subId("passwordErrorsContainer"));
    this.oldPasswordField = this.$subId("oldPasswordField");
    this.oldPasswordField.placeholder();

    this.oldPasswordField.keydown(this.onKeyPressedHandler);
    this.oldPasswordField.keyup(this.passChangedHandler);

    this.oldPasswordField.blur(function () {
        _this._checkOldPasswordSet();
        _this.errors[_constants.ValidationErrors.OLD_PASSWORD_INCORRECT] = false;
        _jquery2.default.extend(_this.errors, _this.passwordFieldDrawer.validateFields());
        _this.updateUI();
    });

    this.passwordFieldsContainer = this.$subId("passwordFieldsContainer");
    this.changePasswordSlider = this.$subId("changePassword");
    this.changePasswordSlider.click(function () {
        self.changePasswordSlider.toggleClass("shown");
        self.passwordFieldsContainer.toggleClass("shown");
        _ScrollUtils2.default.refreshCustomScroll(self.leftSectionScroll);
    });

    this.leftSectionScroll = _ScrollUtils2.default.addVerticalScroll((0, _jquery2.default)(".leftSection"), { isFaded: false });
    var currentTime = new _date_format.DateFormat(window.SystemSettings.dateFormat, window.SystemSettings.clockFormat).formatDateTime(Date.parseJSONTimeWithoutTimeZone(userData.currentTimeInTimeZone));
    (0, _jquery2.default)("#profileCurrentTime").html(currentTime);

    this.rightSectionScroll = _ScrollUtils2.default.addVerticalScroll((0, _jquery2.default)(".rightSection"), { isFaded: false });

    (0, _jquery2.default)(".rightSection").find('.scrollableContainer').on(_ScrollUtils2.default.getWheelEventName(), function (e) {
        if ((0, _atBrowserUtils.checkElementOrAncestorHasClass)(e.originalEvent.target, _constants2.AtNextCustomScrollbarUsedClassName)) {
            _this.rightSectionScroll.disable();
            setTimeout(function () {
                _this.rightSectionScroll.enable();
            }, 0);
            e.stopPropagation();
        }
    });

    this.defaultWorkStatusesSection = document.getElementById("defaultWorkStatusesSection");

    if (isWSDEnabled) {
        var defaultWorkStatusesBuilder = new EditDefaultWorkStatusesBuilder().init(userData);
        defaultWorkStatusesBuilder.createDefaultWorkStatuses(this.sectionEl, this.defaultWorkStatusesSection, changesCallback, validateCallback, userData, function () {
            _ScrollUtils2.default.refreshCustomScroll(self.rightSectionScroll);
        }, 'workStatusProfilePlanningRow', 'workStatusProfileSelect', 'workStatusProfileSelectLabel', true, true);
    }

    if (isDefaultWorkdaySectionShown) {
        this.defaultWorkdaySection = document.getElementById("defaultWorkdaySection");
        this.defaultWorkday = new _DefaultWorkday.DefaultWorkday().init(this.defaultWorkdaySection, userData, changesCallback, function () {
            _ScrollUtils2.default.refreshCustomScroll(self.rightSectionScroll);
        });
    }

    var workdayDurationsEditor = new _WorkdayDurationsEditor2.default().init(userData.effectiveSchedule, window.SystemSettings.weekStartDay, function () {}, true, null, window.SystemSettings.decimalSeparator, true);
    workdayDurationsEditor.onBlur = workdayDurationsEditor.onFocus = function () {};
    var edTotalEl = document.getElementById("weekTotalPlaceholder");
    edTotalEl.innerHTML = _user_time2.default.formatTime(_WorkdayDurationsEditor2.default.sumDurations(userData.effectiveSchedule));

    workdayDurationsEditor.renderTo(document.getElementById("schedulePlaceholder"));
    workdayDurationsEditor.setInputDisabled(true);

    var showPTORules = isPTOEnabled && userData.pto;
    var showSickRules = isSickEnabled && userData.sick;

    var balanceRulesSection = document.getElementById("profileBalanceRulesSection");
    if (showPTORules || showSickRules) {
        var balanceRulesSectionHeaderMsgKey = showPTORules ? showSickRules ? "profile.right_section.block_header_pto_sick_rules" : "profile.right_section.block__pto_sick_rules.pto" : "profile.right_section.block__pto_sick_rules.sick";
        (0, _jquery2.default)(balanceRulesSection).find(".sectionHeader").html(_messageResource2.default.getMessage(balanceRulesSectionHeaderMsgKey));

        var ptoRulesSection = document.getElementById("ptoRulesSection");
        var userToday = Date.parseJSONTimeWithoutTimeZone(userData.currentTimeInTimeZone).toJSON();

        if (showPTORules) {
            this._pto_rulesViewer = new _BalanceRulesEditor.BalanceRulesViewer();
            this._pto_rulesViewer.init("pto", ptoRulesSection, true, 8, undefined, true, userToday);
            (0, _jquery2.default)(ptoRulesSection).toggleClass("default", userData.ptoRules.defaultRules);
            this._pto_rulesViewer.setValues(this._pto_rulesViewer._getValuesFromBalanaceData(userData.ptoRules));
            this._pto_rulesViewer.setDefaultBalanceData(userData.defaultPtoRules);
            this._pto_rulesViewer._fillElementsWithValues(userData.ptoRules.defaultRules, true, true);
        } else {
            (0, _jquery2.default)(ptoRulesSection).hide();
        }

        var sickDaysRulesSection = document.getElementById("sickDaysRulesSection");
        if (showSickRules) {
            this._sickDaysRulesViewer = new _BalanceRulesEditor.BalanceRulesViewer();
            this._sickDaysRulesViewer.init("sick", sickDaysRulesSection, true, 8, undefined, true, userToday);
            (0, _jquery2.default)(sickDaysRulesSection).toggleClass("default", userData.sickDaysRules.defaultRules);
            this._sickDaysRulesViewer.setValues(this._sickDaysRulesViewer._getValuesFromBalanaceData(userData.sickDaysRules));
            this._sickDaysRulesViewer.setDefaultBalanceData(userData.defaultSickDaysRules);
            this._sickDaysRulesViewer._fillElementsWithValues(userData.sickDaysRules.defaultRules, true, true);
        } else {
            (0, _jquery2.default)(sickDaysRulesSection).hide();
        }
    } else {
        (0, _jquery2.default)(balanceRulesSection).hide();
    }

    // TODO: notifications are disabled for now, remove or rewrite later
    // this.receiveUserChangesChBox = this.$subId("receiveUserChangesChBox");
    // this.receiveUserChangesChBox.attr('checked', userData.receiveUserChangesNotification);
    // this.receiveUserChangesChBox.change(function() { self.changesDetected(); });
    // if (!mailSettingsSpecified) {
    //     this.receiveUserChangesChBox.attr('disabled', true);
    // }

    // this.receiveCommentsChangesChBox = this.$subId("receiveCommentsChangesChBox");
    // this.receiveCommentsChangesChBox.attr('checked', userData.receiveCommentsChangesNotification);
    // this.receiveCommentsChangesChBox.change(function() { self.changesDetected(); });
    // if (!mailSettingsSpecified) {
    //     this.receiveCommentsChangesChBox.attr('disabled', true);
    // }

    return this;
};

UserProfileSection.prototype.setPasswordError = function (errorKey, passwordValidationResult) {
    this.passwordFieldsError.setState({ passwordValidationResult: passwordValidationResult });
    this.passwordFieldDrawer.setError(errorKey);
    this.validationDetected();
    this.updateUI();
};

UserProfileSection.prototype.setOldPasswordIncorrectError = function () {
    this.errors[_constants.ValidationErrors.OLD_PASSWORD_INCORRECT] = true;
    this.updateUI();
};

UserProfileSection.prototype.customValidate = function (oldErrors) {
    _jquery2.default.extend(this.errors, this.passwordFieldDrawer.validateFields(oldErrors), this.usernameFieldDrawer.validateFields(oldErrors));
    this._checkOldPasswordSet();
    if (this.defaultWorkday) {
        _jquery2.default.extend(this.errors, this.defaultWorkday.validate());
    }

    this._showPasswordFieldsIfNeeded();
};

UserProfileSection.prototype._showPasswordFieldsIfNeeded = function () {
    var self = this;
    var isPasswordFieldsHasError = function isPasswordFieldsHasError() {
        var errors = self.passwordFieldDrawer.getErrors();
        for (var errorName in errors) {
            if (errors.hasOwnProperty(errorName) && errors[errorName]) {
                return true;
            }
        }
        return false;
    };
    if (this.errors[UserProfileSection.OLD_PASSWORD_EMPTY] || isPasswordFieldsHasError()) {
        this.changePasswordSlider.addClass("shown");
        this.passwordFieldsContainer.addClass("shown");
    }
};

UserProfileSection.prototype.validationDetected = function () {
    _jquery2.default.extend(this.errors, this.passwordFieldDrawer.getErrors(), this.usernameFieldDrawer.getErrors());
    _BaseUserDataSection2.default.prototype.validationDetected.call(this);
};

UserProfileSection.prototype._checkOldPasswordSet = function () {
    var oldPswEmpty = this.oldPasswordField.pVal().length === 0;

    this.passwordFieldDrawer.setPasswordsAreMandatory(!oldPswEmpty);

    this.passwordValues = this.passwordFieldDrawer.getPlainPasswordValues();

    var pswEmpty = this.passwordValues.password.length === 0;
    var pswCopyEmpty = this.passwordValues.passwordCopy.length === 0;

    this.errors[UserProfileSection.OLD_PASSWORD_EMPTY] = oldPswEmpty && (!pswEmpty || !pswCopyEmpty);
    return this.errors[UserProfileSection.OLD_PASSWORD_EMPTY];
};

UserProfileSection.prototype.setUsernameDuplicateError = function () {
    _jquery2.default.extend(this.errors, this.usernameFieldDrawer.setDuplicateNameError());
    this.validate();
    this.updateUI();
};

UserProfileSection.prototype.getOldPassword = function () {
    var passwordValue = this.oldPasswordField.pVal();
    return passwordValue.length > 0 ? passwordValue : null;
};

UserProfileSection.prototype.getNewPassword = function () {
    return this.passwordFieldDrawer.getNewPassword();
};

UserProfileSection.prototype.getUsername = function () {
    return this.usernameFieldDrawer.getObjectValues().username;
};

// TODO: notifications are disabled for now, remove or rewrite later
// UserProfileSection.prototype.getReceiveUserChangesOption = function() {
//     return this.receiveUserChangesChBox.attr('checked') === 'checked';
// };

// UserProfileSection.prototype.getReceiveCommentsChangesOption = function() {
//     return this.receiveCommentsChangesChBox.attr('checked') === 'checked';
// };

exports.default = UserProfileSection;

/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getMaxScaleValue = getMaxScaleValue;
exports.getMaxMinScaleValues = getMaxMinScaleValues;
exports.getVerticalGridCount = getVerticalGridCount;
// util methods was copied from removed ChartGenerator.Utils (see rev. 41004)

function getMaxScaleValue(maxValue, maxVerticalGridsCount) {
    var gapGenerator = _createGapGenerator();

    var maxScaleValue;
    while (true) {
        var gap = gapGenerator.next();
        var remain = maxValue % gap;
        var additive = gap; // additive for whole gap period
        if (remain / gap > 0.8) {
            additive = gap * 2;
        }
        maxScaleValue = maxValue - maxValue % gap + additive; // fill with full gap
        var calculatedGap = maxScaleValue / maxVerticalGridsCount;
        if (calculatedGap <= gap) {
            break;
        }
    }
    return maxScaleValue;
}

function getMaxMinScaleValues(maxValue, minValue, maxVerticalGridsCount) {
    var maxScaleValue = 0;
    var minScaleValue = 0;
    var absMinValue = Math.abs(minValue);

    if (maxValue >= 0 && minValue >= 0) {
        maxScaleValue = getMaxScaleValue(maxValue, maxVerticalGridsCount);
    } else if (maxValue <= 0 && minValue <= 0) {
        minScaleValue = -getMaxScaleValue(absMinValue, maxVerticalGridsCount);
    } else {
        var gapGenerator = _createGapGenerator();
        var absMinScaleValue;

        mainCycle: while (true) {
            var gap = gapGenerator.next();
            var remainForMax = maxValue % gap;
            var remainForMin = absMinValue % gap;
            var additiveForMax = gap; // additive for whole gap period for max
            var additiveForMin = gap; // additive for whole gap period for min
            if (remainForMax / gap > 0.8) {
                additiveForMax = gap * 2;
            }
            if (remainForMin / gap > 0.8) {
                additiveForMin = gap * 2;
            }
            maxScaleValue = maxValue - maxValue % gap + additiveForMax;
            absMinScaleValue = absMinValue - absMinValue % gap + additiveForMin;

            var calculatedGapForMax;
            var calculatedGapForMin;
            for (var verticalGridsCount = 1; verticalGridsCount < maxVerticalGridsCount; verticalGridsCount++) {
                calculatedGapForMax = maxScaleValue / verticalGridsCount;
                calculatedGapForMin = absMinScaleValue / (maxVerticalGridsCount - verticalGridsCount);
                if (calculatedGapForMax <= gap && calculatedGapForMin <= gap) {
                    break mainCycle;
                }
            }
        }
        minScaleValue = -absMinScaleValue;
    }

    return {
        "maxScaleValue": maxScaleValue,
        "minScaleValue": minScaleValue
    };
}

/**
 * create gap sequence generator
 */
function _createGapGenerator() {
    var availableGaps = [1, 2, 5];
    var index = 0;
    return {
        "next": function next() {
            var power = Math.ceil(index / availableGaps.length) - 1;
            if (power < 0) power = 0;
            return availableGaps[index++ % availableGaps.length] * Math.pow(10, power);
        }
    };
}

function getVerticalGridCount(maxScaleValue, minScaleValue, maxVerticalGridCount) {
    if (maxScaleValue >= 0 && minScaleValue >= 0) {
        return Math.min(maxScaleValue, maxVerticalGridCount);
    } else if (maxScaleValue <= 0 && minScaleValue <= 0) {
        return Math.min(Math.abs(minScaleValue), maxVerticalGridCount);
    } else {
        return Math.min(maxScaleValue + Math.abs(minScaleValue), maxVerticalGridCount);
    }
}

/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getErrors = exports.getEditDialogData = exports.isShowEditStatusDialog = exports.getPageStatuses = exports.getStatusesInUseIds = exports.isLoading = exports.isFirstLoading = exports.getWorkflowSettings = undefined;

var _reselect = __webpack_require__(13);

var _selectors = __webpack_require__(14);

var _utils = __webpack_require__(913);

var getWorkflowSettings = exports.getWorkflowSettings = function getWorkflowSettings(state) {
    return state.workflowSettings;
};

var isFirstLoading = exports.isFirstLoading = (0, _reselect.createSelector)(getWorkflowSettings, function (wfs) {
    return wfs.firstLoading;
});

var isLoading = exports.isLoading = (0, _reselect.createSelector)(getWorkflowSettings, function (wfs) {
    return wfs.loading;
});

var getStatusesInUseIds = exports.getStatusesInUseIds = (0, _reselect.createSelector)(getWorkflowSettings, function (wfs) {
    return wfs.statusesInUseIds;
});

var getPageStatuses = exports.getPageStatuses = (0, _reselect.createSelector)(getStatusesInUseIds, _selectors.getWorkflowStatuses, function (statusesInUseIds, statusesMap) {
    return (0, _utils.prepareWorkflowStatusesForPage)(statusesInUseIds, statusesMap);
});

var isShowEditStatusDialog = exports.isShowEditStatusDialog = (0, _reselect.createSelector)(getWorkflowSettings, function (wfs) {
    return wfs.showEditStatusDialog;
});

var getEditDialogData = exports.getEditDialogData = (0, _reselect.createSelector)(getWorkflowSettings, function (wfs) {
    return wfs.editingStatus;
});

var getErrors = exports.getErrors = (0, _reselect.createSelector)(getWorkflowSettings, function (wfs) {
    return wfs.errors;
});

/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getPageData = getPageData;
exports.addCorporateDay = addCorporateDay;
exports.deleteCorporateDay = deleteCorporateDay;
exports.addHolidays = addHolidays;
exports.deleteHolidays = deleteHolidays;
exports.getCountries = getCountries;
exports.getHolidays = getHolidays;
exports.getCorporateScheduleICalendar = getCorporateScheduleICalendar;

var _rpcCalls = __webpack_require__(24);

var _constants = __webpack_require__(4);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _constants2 = __webpack_require__(915);

var _constants3 = __webpack_require__(116);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getPageData(year) {
    return (0, _rpcCalls.rpcCall)("WorkScheduleService.getWorkScheduleData", [year], _handleError);
}

function addCorporateDay(date, isWorking, title) {
    return (0, _rpcCalls.rpcCall)("WorkScheduleService.addCorporateDay", [date, isWorking, title]);
}

function deleteCorporateDay(date) {
    return (0, _rpcCalls.rpcCall)("WorkScheduleService.deleteCorporateDay", [date]);
}

function addHolidays(year, holidays) {
    return (0, _rpcCalls.rpcCall)("WorkScheduleService.addHolidays", [year, holidays]);
}

function deleteHolidays(year) {
    return (0, _rpcCalls.rpcCall)("WorkScheduleService.deleteHolidays", [year]);
}

function getCountries() {
    return (0, _rpcCalls.rpcCall)("WorkScheduleService.getCountries", [], _handleError);
}

function getHolidays(countryId, year) {
    return (0, _rpcCalls.rpcCall)("WorkScheduleService.getHolidays", [countryId, year], _handleError);
}

function getCorporateScheduleICalendar(year) {
    return (0, _rpcCalls.rpcCall)("WorkScheduleService.getCorporateScheduleICalendar", [year], _handleError);
}

function _handleError(error) {
    if (error.getException() === _constants2.Exceptions.NO_RIGHTS_FOR_REMOTE_CALL_EXCEPTION) {
        alert(_messageResource2.default.getMessage('error.js.json_rpc.no_rights'));
        window.location.href = _constants.BASE_PATH;
    }

    if (error.getException() === _constants3.Exception.RETRIEVE_COUNTRIES_EXCEPTION) {
        //no alert, select country section will be hidden
        error.handle();
    }

    if (error.getException() === _constants3.Exception.RETRIEVE_HOLIDAYS_EXCEPTION) {
        alert('Error when retrieving holidays, load holidays from file or try later');
        error.handle();
    }

    if (error.getException() === _constants2.Exceptions.EMPTY_COMPONENTS_EXCEPTION) {
        alert(_messageResource2.default.getMessage('work_schedule.export.ical.no_corporate_days'));
        error.handle();
    }
}

/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.importHolidays = exports.openPreviewHolidaysPanelByFileImport = exports.openPreviewHolidaysPanelBySelectedCountry = exports.completeImportHolidays = exports.startImportHolidays = exports.loadDataFailure = exports.loadDataSuccess = exports.loadData = exports.closePanel = exports.openPanel = undefined;

var _utils = __webpack_require__(6);

var _actionTypes = __webpack_require__(710);

var ActionTypes = _interopRequireWildcard(_actionTypes);

var _reduxActions = __webpack_require__(9);

var _apiCalls = __webpack_require__(567);

var api = _interopRequireWildcard(_apiCalls);

var _utils2 = __webpack_require__(1785);

var _ICalParser = __webpack_require__(1786);

var _selectors = __webpack_require__(404);

var _utils3 = __webpack_require__(85);

var _actions = __webpack_require__(213);

var _batch = __webpack_require__(117);

var _actions2 = __webpack_require__(320);

var HolidaysListActions = _interopRequireWildcard(_actions2);

var _selectors2 = __webpack_require__(263);

var _date_format = __webpack_require__(16);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var HIGHLIGHT_IMPORTED_HOLIDAYS_DELAY = 3000;

var openPanel = exports.openPanel = function openPanel() {
    return function (dispatch) {
        dispatch((0, _utils.createActionObject)(ActionTypes.OPEN_PANEL));
    };
};
var closePanel = exports.closePanel = (0, _reduxActions.createAction)(ActionTypes.CLOSE_PANEL);

var loadData = exports.loadData = (0, _reduxActions.createAction)(ActionTypes.LOAD_DATA);
var loadDataSuccess = exports.loadDataSuccess = (0, _reduxActions.createAction)(ActionTypes.LOAD_DATA_SUCCESS);
var loadDataFailure = exports.loadDataFailure = (0, _reduxActions.createAction)(ActionTypes.LOAD_DATA_FAILURE);

var startImportHolidays = exports.startImportHolidays = (0, _reduxActions.createAction)(ActionTypes.IMPORT_HOLIDAYS_START);
var completeImportHolidays = exports.completeImportHolidays = (0, _reduxActions.createAction)(ActionTypes.IMPORT_HOLIDAYS_COMPLETE);

var openPreviewHolidaysPanelBySelectedCountry = exports.openPreviewHolidaysPanelBySelectedCountry = function openPreviewHolidaysPanelBySelectedCountry(country) {
    return function (dispatch) {
        dispatch(openPanel());
        dispatch(loadHolidays(country));
    };
};

var openPreviewHolidaysPanelByFileImport = exports.openPreviewHolidaysPanelByFileImport = function openPreviewHolidaysPanelByFileImport(file) {
    return function (dispatch) {
        dispatch(openPanel());
        dispatch(loadHolidaysFromFile(file));
    };
};

var importHolidays = exports.importHolidays = function importHolidays() {
    return function (dispatch, getState) {
        var state = getState();
        var year = (0, _selectors.getYear)(state);
        var holidays = (0, _selectors.getHolidays)(state);
        dispatch(startImportHolidays());
        api.addHolidays(year, holidays).then((0, _batch.batched)(function (data) {
            if (!(0, _selectors2.isShownHolidayList)(state)) {
                dispatch(HolidaysListActions.setPanelSelectedYear(year));
                dispatch(HolidaysListActions.setPanelShown());
            }

            dispatch((0, _actions.loadedDataSet)({
                corporateDays: _defineProperty({}, year, data.corporateDays),
                defaultWorkSchedules: (0, _utils3.convertEffectiveDateInWorkSchedule)(data.defaultWorkSchedules)
            }));

            dispatch(HolidaysListActions.setListTransformed(true));
            dispatch(completeImportHolidays());
            var dates = holidays.map(function (h) {
                return h.date;
            });
            dispatch(HolidaysListActions.addImportedHolidays(dates));
            setTimeout(function () {
                return dispatch(HolidaysListActions.removeImportedHolidays(dates));
            }, HIGHLIGHT_IMPORTED_HOLIDAYS_DELAY);
        })).catch(function (error) {
            console.error(error);
            dispatch(completeImportHolidays());
        });
    };
};

var loadHolidays = function loadHolidays(country) {
    return function (dispatch, getState) {
        dispatch(loadData());
        api.getHolidays(country.id, (0, _selectors.getYear)(getState())).then(function (data) {
            dispatch(loadDataSuccess({
                hasHolidaysInPast: data.hasHolidaysInPast,
                holidays: (0, _utils2.mergeHolidaysWithSameDate)(data.holidays),
                country: country.name
            }));
        }).catch(function (error) {
            console.error(error);
            dispatch(loadDataFailure());
        });
    };
};

var loadHolidaysFromFile = function loadHolidaysFromFile(file) {
    return function (dispatch, getState) {
        dispatch(loadData());
        new _ICalParser.ICalParser().parseHolidays(file, (0, _selectors.getYear)(getState()), function (holidays) {
            var today = window.currentUserTime().clearTime().getTime();
            var formatter = new _date_format.DateFormat("yyyy-MM-dd");
            var futureHolidays = holidays.filter(function (holiday) {
                return holiday.date >= today;
            }).map(function (holiday) {
                return {
                    date: formatter.formatDate(holiday.date),
                    name: holiday.name
                };
            });
            dispatch(loadDataSuccess({
                holidays: (0, _utils3.sortHolidaysArray)(futureHolidays),
                hasHolidaysInPast: futureHolidays.length < holidays.length,
                fileName: file.name
            }));
        }, function (error) {
            alert('Error while parsing iCal file: ' + error.message);
            dispatch(loadDataFailure());
        });
    };
};

/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SimpleDiv = function (_TemplateView) {
    _inherits(SimpleDiv, _TemplateView);

    function SimpleDiv() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            _ref$additionalClass = _ref.additionalClass,
            additionalClass = _ref$additionalClass === undefined ? '' : _ref$additionalClass,
            _ref$text = _ref.text,
            text = _ref$text === undefined ? '' : _ref$text;

        _classCallCheck(this, SimpleDiv);

        var _this = _possibleConstructorReturn(this, (SimpleDiv.__proto__ || Object.getPrototypeOf(SimpleDiv)).call(this));

        _this.additionalClass = additionalClass;
        _this.text = text;
        return _this;
    }

    _createClass(SimpleDiv, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return "<div class='<%-additionalClass%>'><%-text%></div>";
        }
    }]);

    return SimpleDiv;
}(_TemplateView3.default);

exports.default = SimpleDiv;

/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isColumnFixed = exports.isSortByColumnUnavailable = undefined;

var _constants = __webpack_require__(571);

var isSortByColumnUnavailable = exports.isSortByColumnUnavailable = function isSortByColumnUnavailable(sortBy, selectedMap) {
  return !_constants.NOT_CONFIGURABLE_COLUMNS.includes(sortBy.by) && !selectedMap[sortBy.by];
};

var isColumnFixed = exports.isColumnFixed = function isColumnFixed(column) {
  return _constants.FIXED_COLUMNS.includes(column);
};

/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.FIXED_COLUMNS = exports.NOT_CONFIGURABLE_COLUMNS = exports.ColumnTitlesKeys = undefined;

var _ColumnTitlesKeys;

var _constants = __webpack_require__(44);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ColumnTitlesKeys = exports.ColumnTitlesKeys = (_ColumnTitlesKeys = {}, _defineProperty(_ColumnTitlesKeys, _constants.TaskSortBy.DEADLINE, "task.list.deadline"), _defineProperty(_ColumnTitlesKeys, _constants.TaskSortBy.ESTIMATE, "task.list.estimate"), _defineProperty(_ColumnTitlesKeys, _constants.TaskSortBy.CREATION_DATE, "task.list.creation_date"), _defineProperty(_ColumnTitlesKeys, _constants.TaskSortBy.SPENT_TIME, "task.list.spent_time"), _defineProperty(_ColumnTitlesKeys, _constants.TaskSortBy.TYPE_OF_WORK, "task.list.type_of_work"), _defineProperty(_ColumnTitlesKeys, _constants.TaskSortBy.LAST_TRACKING_DATE, "task.list.last_tracking_date"), _defineProperty(_ColumnTitlesKeys, _constants.TaskSortBy.VARIANCE_MAN_HOURS, "task.list.variance_man_hours"), _defineProperty(_ColumnTitlesKeys, _constants.TaskSortBy.VARIANCE_PERCENTS, "task.list.variance_percents"), _defineProperty(_ColumnTitlesKeys, _constants.TaskSortBy.VARIANCE_PROGRESS_BAR, "task.list.variance_progress_bar"), _ColumnTitlesKeys);

var NOT_CONFIGURABLE_COLUMNS = exports.NOT_CONFIGURABLE_COLUMNS = [_constants.TaskSortBy.CUSTOMER, _constants.TaskSortBy.PROJECT, _constants.TaskSortBy.TASK, _constants.TaskSortBy.STATUS, _constants.TaskSortBy.WORKFLOW_STATUS];

var FIXED_COLUMNS = exports.FIXED_COLUMNS = [_constants.PRIORITY_FIELD_NAME];

/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Node = function (_TemplateView) {
    _inherits(Node, _TemplateView);

    function Node() {
        var onClick = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};

        _classCallCheck(this, Node);

        var _this = _possibleConstructorReturn(this, (Node.__proto__ || Object.getPrototypeOf(Node)).call(this, null));

        _this.onClick = onClick;

        _this.state = {
            selected: false
        };

        _this.onStateChanged(function () {
            return _this._updateClasses();
        });
        return _this;
    }

    _createClass(Node, [{
        key: "afterRender",
        value: function afterRender() {
            var _this2 = this;

            this.$el.click(function (e) {
                if (_this2.preventNextClick) {
                    _this2.preventNextClick = false;
                    return;
                }
                _this2.onClick();
            });
        }
    }, {
        key: "_updateClasses",
        value: function _updateClasses() {
            this.$el.toggleClass("selected", this.state.selected);
            this.$el.toggleClass("notSelected", !this.state.selected);
        }
    }]);

    return Node;
}(_TemplateView3.default);

exports.default = Node;

/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EditButton = function (_TemplateView) {
    _inherits(EditButton, _TemplateView);

    function EditButton($containerEl, onClick) {
        _classCallCheck(this, EditButton);

        var _this = _possibleConstructorReturn(this, (EditButton.__proto__ || Object.getPrototypeOf(EditButton)).call(this, $containerEl));

        _this.onClick = onClick;
        return _this;
    }

    _createClass(EditButton, [{
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='editButton'></div>";
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            if (this.onClick) {
                this.$el.on("click", this.onClick);
            }
        }
    }, {
        key: "setClickHandler",
        value: function setClickHandler(onClick) {
            this.$el.on("click", onClick);
        }
    }]);

    return EditButton;
}(_TemplateView3.default);

exports.default = EditButton;

/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getIsCustomersAsc = exports.getProjectIdsForExport = exports.getCustomerIdsForExport = exports.getCollapsedCustomersSet = exports.getCPPanelWidth = exports.getCPPanelMinWidth = exports.getCPPanelMaxWidth = exports.getCpPanelState = undefined;

var _reselect = __webpack_require__(13);

var _selectors = __webpack_require__(189);

var getCpPanelState = exports.getCpPanelState = (0, _reselect.createSelector)(_selectors.selectTaskManagement, function (tmState) {
    return tmState.cpPanel;
});

var getCPPanelMaxWidth = exports.getCPPanelMaxWidth = (0, _reselect.createSelector)(getCpPanelState, function (cpPanelState) {
    return cpPanelState.resizableMaxWidth;
});

var getCPPanelMinWidth = exports.getCPPanelMinWidth = (0, _reselect.createSelector)(getCpPanelState, function (cpPanelState) {
    return cpPanelState.resizableMinWidth;
});

var getCPPanelWidth = exports.getCPPanelWidth = (0, _reselect.createSelector)(getCpPanelState, function (cpPanelState) {
    return cpPanelState.width;
});

var getCollapsedCustomersSet = exports.getCollapsedCustomersSet = (0, _reselect.createSelector)(getCpPanelState, function (cpPanelState) {
    return cpPanelState.collapsedCustomersSet;
});

var getCustomerIdsForExport = exports.getCustomerIdsForExport = (0, _reselect.createSelector)(getCpPanelState, function (cpPanelState) {
    return cpPanelState.visibleCustomerIds;
});

var getProjectIdsForExport = exports.getProjectIdsForExport = (0, _reselect.createSelector)(getCpPanelState, function (cpPanelState) {
    return cpPanelState.visibleProjectIds;
});

var getIsCustomersAsc = exports.getIsCustomersAsc = (0, _reselect.createSelector)(getCpPanelState, function (cpPanelState) {
    return cpPanelState.isCustomersAsc;
});

/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.openLastTaskPanelTab = exports.setLastTaskPanelTab = exports.setTaskPanelTab = exports.updateCustomField = exports.updateDescription = exports.updateEstimate = exports.updateTypeOfWork = exports.updateDeadline = exports.updateStatus = exports.updateName = exports.createTask = exports.loadCreateTaskPanelData = exports.cancelTaskCreation = exports.closeCreateTaskPanel = exports.openCreateTaskPanel = exports.updateAssignedManagers = exports.deleteAssignedManager = exports.updateAssignedUsers = exports.deleteAssignedUser = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _actionTypes = __webpack_require__(684);

var ActionTypes = _interopRequireWildcard(_actionTypes);

var _actionsGenerator = __webpack_require__(762);

var _actionsGenerator2 = _interopRequireDefault(_actionsGenerator);

var _constants = __webpack_require__(157);

var _selectors = __webpack_require__(27);

var _actions = __webpack_require__(55);

var TaskManagementActions = _interopRequireWildcard(_actions);

var _constants2 = __webpack_require__(78);

var _actions2 = __webpack_require__(68);

var FeaturesActions = _interopRequireWildcard(_actions2);

var _actions3 = __webpack_require__(29);

var EntitiesActions = _interopRequireWildcard(_actions3);

var _selectors2 = __webpack_require__(14);

var _reduxActions = __webpack_require__(9);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _utils = __webpack_require__(341);

var _selectors3 = __webpack_require__(405);

var _selectors4 = __webpack_require__(15);

var _syncCallbacks = __webpack_require__(1841);

var SyncCallbacks = _interopRequireWildcard(_syncCallbacks);

var _actionsGenerator3 = __webpack_require__(763);

var _actionsGenerator4 = _interopRequireDefault(_actionsGenerator3);

var _rpcCalls = __webpack_require__(24);

var _rpcCalls2 = _interopRequireDefault(_rpcCalls);

var _selectors5 = __webpack_require__(97);

var _constants3 = __webpack_require__(23);

var _ExitConfirmationHandlersManager = __webpack_require__(298);

var _ExitConfirmationHandlersManager2 = _interopRequireDefault(_ExitConfirmationHandlersManager);

var _atUtils = __webpack_require__(5);

var _utils2 = __webpack_require__(118);

var _ExceptionsTypes = __webpack_require__(107);

var _utils3 = __webpack_require__(766);

var _constants4 = __webpack_require__(108);

var _actions4 = __webpack_require__(493);

var _ClassicBridge = __webpack_require__(18);

var _ClassicBridge2 = _interopRequireDefault(_ClassicBridge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var setAddedAssignedUserIds = (0, _reduxActions.createAction)(ActionTypes.ADDED_ASSIGNED_USER_IDS_SET);
var setAddedAssignedManagerIds = (0, _reduxActions.createAction)(ActionTypes.ADDED_ASSIGNED_MANAGER_IDS_SET);
var resetCreatePanelState = (0, _reduxActions.createAction)(ActionTypes.CREATE_PANEL_STATE_RESET);
var setDefaultTaskDataProperty = (0, _reduxActions.createAction)(ActionTypes.TASK_DATA_DEFAULT_STATE_PROPERTY_SET);

var taskPanelActions = (0, _actionsGenerator2.default)({
    actionTypes: ActionTypes
});

var assignmentsActions = (0, _actionsGenerator4.default)({
    actionTypes: {
        ASSIGNED_USERS_SET: ActionTypes.ASSIGNED_USERS_SET,
        ASSIGNED_MANAGERS_SET: ActionTypes.ASSIGNED_MANAGERS_SET,
        CAN_MODIFY_ANY_USER_SET: ActionTypes.CAN_MODIFY_ANY_USER_SET,
        CAN_MODIFY_ANY_MANAGER_SET: ActionTypes.CAN_MODIFY_ANY_MANAGER_SET
    }
});

var deleteAssignedUser = exports.deleteAssignedUser = function deleteAssignedUser(userId) {
    return function (dispatch) {
        dispatch(updateAssignedUsers([], [userId]));
    };
};

var updateAssignedUsers = exports.updateAssignedUsers = function updateAssignedUsers(addedUserIds, removedUserIds) {
    return function (dispatch, getState) {
        var state = getState();
        var addedAssignedUserIds = _extends({}, (0, _selectors3.getAddedAssignedUserIds)(state));
        addedUserIds.forEach(function (id) {
            return addedAssignedUserIds[id] = true;
        });
        removedUserIds.forEach(function (id) {
            return delete addedAssignedUserIds[id];
        });

        var users = setTaskAssignments((0, _selectors3.getAssignedUsers)(state), addedAssignedUserIds);

        dispatch(setAddedAssignedUserIds(addedAssignedUserIds));
        dispatch(assignmentsActions.setAssignedUsers(users));
    };
};

var deleteAssignedManager = exports.deleteAssignedManager = function deleteAssignedManager(managerData) {
    return function (dispatch) {
        dispatch(updateAssignedManagers([], [managerData.id]));
    };
};

var updateAssignedManagers = exports.updateAssignedManagers = function updateAssignedManagers(addedUserIds, removedUserIds) {
    return function (dispatch, getState) {
        var state = getState();
        var addedAssignedManagerIds = _extends({}, (0, _selectors3.getAddedAssignedManagerIds)(state));
        addedUserIds.forEach(function (id) {
            return addedAssignedManagerIds[id] = true;
        });
        removedUserIds.forEach(function (id) {
            return delete addedAssignedManagerIds[id];
        });

        var users = setTaskAssignments((0, _selectors3.getAssignedManagers)(state), addedAssignedManagerIds);

        dispatch(setAddedAssignedManagerIds(addedAssignedManagerIds));
        dispatch(assignmentsActions.setAssignedManagers(users));
    };
};

var setTaskAssignments = function setTaskAssignments(users, addedIds) {
    return users.map(function (user) {
        if (user.canBeModified) {
            return _extends({}, user, { hasTaskAssignment: !!addedIds[user.id] });
        } else {
            return user;
        }
    });
};

var openCreateTaskPanel = exports.openCreateTaskPanel = function openCreateTaskPanel() {
    return function (dispatch, getState) {
        setUpExitConfirmation(getState);
        dispatch(resetCreatePanelState());
        dispatch(taskPanelActions.openTaskPanel());
    };
};

var closeCreateTaskPanel = exports.closeCreateTaskPanel = function closeCreateTaskPanel() {
    return function (dispatch) {
        _ExitConfirmationHandlersManager2.default.restoreExitConfirmation();
        dispatch(taskPanelActions.closeTaskPanel());
        dispatch(taskPanelActions.setTaskPanelLoaded(false));
        dispatch(taskPanelActions.setNeedInitializeFocus(false));
    };
};

var cancelTaskCreation = exports.cancelTaskCreation = function cancelTaskCreation() {
    return function (dispatch, getState) {
        var dataChanged = (0, _selectors3.isTaskDataChanged)(getState());

        if (!dataChanged || confirmCancelTaskCreation()) dispatch(closeCreateTaskPanel());

        dispatch(taskPanelActions.setNeedInitializeFocus(false));
    };
};

var confirmCancelTaskCreation = function confirmCancelTaskCreation() {
    return confirm(_messageResource2.default.getMessage('task.add.cancel_confirmation'));
};

var saveTask = (0, _reduxActions.createAction)(ActionTypes.CREATE_TASK);
var saveTaskFailure = (0, _reduxActions.createAction)(ActionTypes.CREATE_TASK_FAILURE);
var saveTaskSuccess = (0, _reduxActions.createAction)(ActionTypes.CREATE_TASK_SUCCESS);

var loadCreateTaskPanelData = exports.loadCreateTaskPanelData = function loadCreateTaskPanelData() {
    return function (dispatch, getState) {
        dispatch(taskPanelActions.setTaskPanelLoading(true));
        dispatch((0, _actions4.loadCustomFields)());

        var selection = (0, _selectors.getSingleCPSelection)(getState());
        (0, _rpcCalls2.default)(_constants.Methods.LOAD_CREATE_TASK_PANEL, [selection.projectId, selection.customerId]).then(function (loadedData) {
            var enabledFeatures = (0, _atUtils.arrayToSet)(loadedData['enabledFeatures']);
            if ((0, _utils2.isEnabled)(enabledFeatures, _constants2.Feature.TWS)) {
                dispatch(EntitiesActions.setWorkflowStatusesList(loadedData['workflowStatuses']));
            }

            dispatch(FeaturesActions.setEnabledFeatures(enabledFeatures));

            var managementAssignments = loadedData['managementAssignments'];
            var cannotManageProject = loadedData['cannotManageProject'];
            TaskManagementActions.setManagementAssignments(managementAssignments);

            if (cannotManageProject) {
                alert(_messageResource2.default.getMessage("task.edit_popup.project_not_available"));
                dispatch(closeCreateTaskPanel());
                window.location.reload();
                return;
            }

            if ((0, _utils2.isEnabled)(enabledFeatures, _constants2.Feature.BTY)) {
                dispatch(EntitiesActions.setTypesOfWorkList(loadedData['billingTypes']['list']));
                dispatch(taskPanelActions.setTaskInfo({ typeOfWorkId: loadedData['defaultBillingTypeId'] }));
                dispatch(setDefaultTaskDataProperty({ typeOfWorkId: loadedData['defaultBillingTypeId'] }));
            }

            dispatch(taskPanelActions.setTaskInfo({
                workflowStatusId: loadedData['firstStatusId'] || _constants3.FAKE_OPEN_WORKFLOW_STATUS_ID
            }));

            dispatch(setDefaultTaskDataProperty({
                workflowStatusId: loadedData['firstStatusId'] || _constants3.FAKE_OPEN_WORKFLOW_STATUS_ID
            }));

            if ((0, _utils2.isEnabled)(enabledFeatures, _constants2.Feature.WAS)) {
                var assignedUsersData = loadedData['assignedUsersData'];
                dispatch(assignmentsActions.setAssignedUsersData(_extends({}, assignedUsersData, {
                    users: assignedUsersData.users.map(function (user) {
                        return _extends({}, user, { canBeModified: !(user.hasAllAssignments || user.hasCustomerAssignment || user.hasProjectAssignment) });
                    })
                })));
            }

            var assignedUsersDataForManagers = loadedData['assignedUsersDataForManagers'];
            dispatch(assignmentsActions.setAssignedManagersData(_extends({}, assignedUsersDataForManagers, {
                users: assignedUsersDataForManagers.users.map(function (user) {
                    return _extends({}, user, { canBeModified: !(user.hasAllAssignments || user.hasCustomerAssignment || user.hasProjectAssignment) });
                })
            })));

            dispatch(setAddedAssignedUserIds({}));
            dispatch(setAddedAssignedManagerIds({}));
            dispatch(taskPanelActions.setTaskPanelLoading(false));
            dispatch(taskPanelActions.setTaskPanelLoaded(true));
            dispatch(taskPanelActions.setTaskPanelErrors([]));
            dispatch(taskPanelActions.setNeedInitializeFocus(true));
        });
    };
};

var createTask = exports.createTask = function createTask() {
    return function (dispatch, getState) {
        dispatch(saveTask());
        var state = getState();
        var selection = (0, _selectors.getSingleCPSelection)(state);
        var newTaskInfo = getNewTaskInfo(state, selection.projectId, selection.customerId);
        var addedAssignedUserIds = Object.keys((0, _selectors3.getAddedAssignedUserIds)(state));
        var addedManagerIds = Object.keys((0, _selectors3.getAddedAssignedManagerIds)(state));

        if (newTaskInfo.name.length === 0) {
            dispatch(taskPanelActions.addTaskPanelErrors([_constants.ValidationErrors.TASK_NAME_EMPTY]));
            return;
        }

        (0, _rpcCalls2.default)(_constants.Methods.CREATE_TASK, [newTaskInfo, addedAssignedUserIds, addedManagerIds], _utils3.createTaskRpcErrorHandler).then(function (rpcResult) {
            return Promise.all([rpcResult, _ClassicBridge2.default.syncChangesFromClassic()]);
        }).then(function (_ref) {
            var _ref2 = _slicedToArray(_ref, 1),
                rpcResult = _ref2[0];

            var taskId = rpcResult.taskId;
            return Promise.all([rpcResult, _ClassicBridge2.default.getTask(taskId, true)]);
        }).then(function (_ref3) {
            var _ref4 = _slicedToArray(_ref3, 2),
                rpcResult = _ref4[0],
                nextTask = _ref4[1];

            var customValues = (0, _selectors3.getCustomFieldsValues)(getState());
            if (Object.keys(customValues).length !== 0) {
                nextTask = _extends({}, nextTask, customValues);
                return Promise.all([rpcResult, nextTask, _ClassicBridge2.default.patchTask(nextTask.id, customValues)]);
            } else {
                return Promise.all([rpcResult, nextTask]);
            }
        }).then(function (_ref5) {
            var _ref6 = _slicedToArray(_ref5, 2),
                result = _ref6[0],
                nextTask = _ref6[1];

            var resultCode = result['resultCode'];

            if (resultCode === _constants.ResultCodes.noRightsToManageProject) {
                alert(_messageResource2.default.getMessage("task.list.error.concurrently_unassigned_ma_project"));
                var managementAssignments = result['managementAssignments'];
                TaskManagementActions.setManagementAssignments(managementAssignments);
                dispatch(saveTaskFailure());
                dispatch(closeCreateTaskPanel());
                return;
            }

            if (resultCode === _constants.ResultCodes.billingTypeNotExists) {
                alert(_messageResource2.default.getMessage("task.edit_popup.billing_type_not_exists"));
                dispatch(saveTaskFailure());
                return;
            }
            if (resultCode === _constants.ResultCodes.billingTypeIsArchived) {
                alert(_messageResource2.default.getMessage("task.edit_popup.billing_type_was_archived"));
                dispatch(saveTaskFailure());
                return;
            }

            var enabledFeatures = (0, _atUtils.arrayToSet)(result['enabledFeatures']);

            if ((0, _utils2.isEnabled)(enabledFeatures, _constants2.Feature.TWS)) {
                dispatch(EntitiesActions.setWorkflowStatusesList(result['workflowStatuses']['list']));
            }

            dispatch(FeaturesActions.setEnabledFeatures(enabledFeatures));

            if (resultCode === _constants.ResultCodes.workflowStatusNotExists) {
                alert(_messageResource2.default.getMessage("change_tasks_workflow_status.no_such_workflow_status_error"));
                dispatch(saveTaskFailure());
                return;
            }
            if (resultCode === _constants.ResultCodes.workflowStatusChanged) {
                alert(_messageResource2.default.getMessage("change_tasks_workflow_status.workflow_status_changed_error"));
                dispatch(saveTaskFailure());
                return;
            }

            var newTask = _extends({}, newTaskInfo, {
                id: result['taskId'],
                typeOfWorkId: result['typeOfWorkId'],
                workflowStatusId: result['workflowStatusId'],
                lastTrackingDate: null,
                spentTime: 0,
                commentsNumber: 0,
                creationDate: Date.parseJSONDate(result["creationTimestamp"]),
                nextId: nextTask.id,
                customFieldsValues: (0, _utils.collectCustomFieldValues)(nextTask)
            });
            delete newTask['workflowStatusName'];

            dispatch(taskPanelActions.removeTaskPanelErrors([_constants.ValidationErrors.TASK_NAME_EMPTY, _constants.ValidationErrors.TASK_NAME_DUPLICATE]));
            dispatch((0, _actions3.addTask)(newTask));
            SyncCallbacks.afterTaskCreatedCb(newTask);
            EntitiesActions.addTask(newTask);
            dispatch((0, _actions.addRecentlyCreatedTasks)([newTask.id]));
            dispatch((0, _actions.setLastCreatedTaskIds)([newTask.id]));
            dispatch(saveTaskSuccess());
            dispatch(closeCreateTaskPanel());
        }).catch(function (error) {
            switch (error.getException()) {
                case _constants.ErrorsExceptions.TASK_NAME_DUPLICATE:
                    dispatch(taskPanelActions.removeTaskPanelErrors([_constants.ValidationErrors.TASK_NAME_EMPTY]));
                    dispatch(taskPanelActions.addTaskPanelErrors([_constants.ValidationErrors.TASK_NAME_DUPLICATE]));
                    break;
                case _ExceptionsTypes.NO_SUCH_PROJECT_EXCEPTION:
                    alert(_messageResource2.default.getMessage("task.list.error.concurrently_delete_project"));
                    window.location.reload();
                    break;
                case _ExceptionsTypes.PROJECT_IS_ARCHIVED_EXCEPTION:
                    alert(_messageResource2.default.getMessage("task.list.error.concurrently_archived_project"));
                    window.location.reload();
                    break;
                case _ExceptionsTypes.PROJECT_IS_NOT_AVAILABLE_EXCEPTION:
                    alert(_messageResource2.default.getMessage("task.list.error.concurrently_unassigned_ma_project"));
                    window.location.reload();
                    break;
                case _ExceptionsTypes.NO_RIGHT_TO_EDIT_HIERARCHY_EXCEPTION:
                    alert(_messageResource2.default.getMessage("task.create.error.no_manage_scope_right"));
                    window.location.reload();
                    return true;
                case _constants4.Exceptions.USER_IS_NOT_ASSIGNED_TO_MANAGER_EXCEPTION:
                    alert(_messageResource2.default.getMessage("task.create.error.user_is_not_assigned_to_manager"));
                    window.location.reload();
                    break;
                case _constants4.Exceptions.USER_IS_DISABLED_EXCEPTION:
                    alert(_messageResource2.default.getMessage("task.create.error.assigned_user_disabled"));
                    window.location.reload();
                    break;
                case _constants4.Exceptions.NO_SUCH_USER_EXCEPTION:
                    alert(_messageResource2.default.getMessage("task.create.error.no_such_user"));
                    window.location.reload();
                    break;
                case _constants4.Exceptions.NO_RIGHTS_TO_SUBMIT_TT_EXCEPTION:
                    alert(_messageResource2.default.getMessage("task.create.error.user_does_not_have_submit_tt_right"));
                    window.location.reload();
                    break;
                case _constants4.Exceptions.USER_HAS_NO_ACCESS_TO_SCOPE_EXCEPTION:
                    alert(_messageResource2.default.getMessage("task.create.error.user_does_not_have_any_scope_rights"));
                    window.location.reload();
                    break;
            }
        });
    };
};

var updateName = exports.updateName = function updateName(name, prevName) {
    return function (dispatch) {
        dispatch(taskPanelActions.setTaskInfo({ name: name }));
        if (name && name !== prevName) {
            dispatch(taskPanelActions.removeTaskPanelErrors([_constants.ValidationErrors.TASK_NAME_EMPTY, _constants.ValidationErrors.TASK_NAME_DUPLICATE]));
        } else if (!name) {
            dispatch(taskPanelActions.addTaskPanelErrors([_constants.ValidationErrors.TASK_NAME_EMPTY]));
            dispatch(taskPanelActions.removeTaskPanelErrors([_constants.ValidationErrors.TASK_NAME_DUPLICATE]));
        }
    };
};

var updateStatus = exports.updateStatus = function updateStatus(workflowStatusId) {
    return function (dispatch, getState) {
        var state = getState();
        var completed = workflowStatusId === _constants3.FAKE_COMPLETED_WORKFLOW_STATUS_ID;
        if ((0, _selectors4.isTWSEnabled)(state)) {
            var workflowStatus = (0, _selectors2.getWorkflowStatus)(state, workflowStatusId);
            completed = workflowStatus.type === _constants3.WorkflowStatusType.COMPLETED;
        }
        dispatch(taskPanelActions.setTaskInfo({
            workflowStatusId: workflowStatusId,
            completed: completed
        }));
    };
};

var updateDeadline = exports.updateDeadline = function updateDeadline(deadline) {
    return function (dispatch) {
        dispatch(taskPanelActions.setTaskInfo({ deadline: deadline }));
    };
};

var updateTypeOfWork = exports.updateTypeOfWork = function updateTypeOfWork(typeOfWorkId) {
    return function (dispatch) {
        dispatch(taskPanelActions.setTaskInfo({ typeOfWorkId: typeOfWorkId }));
    };
};

var updateEstimate = exports.updateEstimate = function updateEstimate(estimatedTime) {
    return function (dispatch) {
        dispatch(taskPanelActions.setTaskInfo({ estimatedTime: estimatedTime }));
    };
};

var updateDescription = exports.updateDescription = function updateDescription(description) {
    return function (dispatch) {
        dispatch(taskPanelActions.setTaskInfo({ description: description }));
    };
};

var updateCustomFieldsValues = (0, _reduxActions.createAction)(ActionTypes.CUSTOM_FIELDS_VALUES_UPDATE);
var updateCustomField = exports.updateCustomField = function updateCustomField(fieldName, value) {
    return function (dispatch) {
        dispatch(updateCustomFieldsValues(_defineProperty({}, fieldName, value)));
    };
};

var setTaskPanelTab = exports.setTaskPanelTab = taskPanelActions.setTaskPanelTab;

var setLastTaskPanelTab = exports.setLastTaskPanelTab = taskPanelActions.setLastTaskPanelTab;

var openLastTaskPanelTab = exports.openLastTaskPanelTab = function openLastTaskPanelTab() {
    return function (dispatch, getState) {
        var state = getState();
        var lastTaskPanelTabKey = (0, _selectors5.getLastTaskPanelTabKey)(state);
        dispatch(setTaskPanelTab(lastTaskPanelTabKey));
    };
};

var getNewTaskInfo = function getNewTaskInfo(state, projectId, customerId) {
    var name = (0, _selectors3.getTaskName)(state);

    var workflowStatusId = null;
    var workflowStatusName = null;
    var completed = (0, _selectors3.getTaskStatusId)(state) === _constants3.FAKE_COMPLETED_WORKFLOW_STATUS_ID;
    if ((0, _selectors4.isTWSEnabled)(state)) {
        workflowStatusId = (0, _selectors3.getTaskStatusId)(state);
        var workflowStatus = (0, _selectors2.getWorkflowStatus)(state, workflowStatusId);
        workflowStatusName = workflowStatus.name;
        completed = workflowStatus.type === _constants3.WorkflowStatusType.COMPLETED;
    }

    var deadline = (0, _selectors3.getTaskDeadline)(state);

    var typeOfWorkId = null;
    if ((0, _selectors4.isBTYEnabled)(state)) {
        typeOfWorkId = (0, _selectors3.getTaskBillableTypeId)(state);
    }

    var estimatedTime = (0, _selectors3.getEstimatedTime)(state);
    var description = (0, _selectors3.getTaskDescription)(state);

    return {
        projectId: projectId,
        customerId: customerId,
        name: name,
        workflowStatusId: workflowStatusId,
        workflowStatusName: workflowStatusName,
        completed: completed,
        deadline: deadline,
        typeOfWorkId: typeOfWorkId,
        estimatedTime: estimatedTime,
        description: description
    };
};

var setUpExitConfirmation = function setUpExitConfirmation(getState) {
    _ExitConfirmationHandlersManager2.default.setUpExitConfirmation(_messageResource2.default.getMessage('task.add.cancel_confirmation'), function () {
        return (0, _selectors3.isTaskDataChanged)(getState());
    }, false);
};

/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = json2csv;

var _utils = __webpack_require__(1846);

/**
 * !!This function without external dependencies, because uses into workers
 *
 * Converts array of arrays of arrays to CSV string.
 * @param tables An array of 2d arrays
 * @param separator Separator string.
 * @param eol End of line string.
 */

// TODO: use this method instead of _json2csv.
function _jsonTables2csv(tables, separator, eol) {
    var str = "";
    for (var tInd = 0; tInd < tables.length; tInd++) {
        var table = tables[tInd];

        for (var i = 0; i < table.length; i++) {
            var line = '';
            var row = table[i];
            for (var j = 0; j < row.length; j++) {
                if (j !== 0) line += separator;

                line += '"' + row[j].replace(/"/g, '""') + '"';
            }
            str += line + eol;
        }
    }

    return str;
}

/**
 * !!This function without external dependencies, because uses into workers
 *
 * Converts array of JSON to CSV string
 * @param jsons An array of objects containing following fields:
 *   columns - array of field to be presented in result csv string e.g. ["field1", "field2", "field3"]
 *   columnNames - map of header names {field1: "Main Field", field2: "Other Field", field3: "etc..."}
 *   table - array of jsons e.g.: [{field1: "hello", field2: "world"}, {field1: "hello", field3: "!"}, {field1: "the only field"}]
 * @param separator Separator string.
 * @param eol End of line string.
 */
function _json2csv(jsons, separator, eol) {
    var str = "";
    for (var jInd = 0; jInd < jsons.length; jInd++) {
        var json = jsons[jInd];
        var columns = json.columns;

        var columnNamesMap = json.columnNames;
        var table = json.table;

        if (columnNamesMap) {
            var columnNames = [];
            for (var cInd = 0; cInd < columns.length; cInd++) {
                columnNames.push('"' + columnNamesMap[columns[cInd]].replace(/"/g, '""') + '"');
            }
            str += columnNames.join(separator) + eol;
        }

        var columnsLength = columns.length;
        for (var i = 0; i < table.length; i++) {
            var line = '';
            var row = table[i];
            for (var j = 0; j < columnsLength; j++) {
                if (j != 0) line += separator;

                var value = row[columns[j]];
                if (value !== undefined) line += '"' + value.toString().replace(/"/g, '""') + '"';
            }

            str += line + eol;
        }
    }
    return str;
}

/**
 * Converts array of JSON to CSV string and returns the result in callback.
 * Depending on browser capabilities, CSV will be generated in separate thread or synchronously.
 * @param jsons See _json2csv() or _jsonTables2csv()
 * @param separator See _json2csv() or _jsonTables2csv()
 * @param eol See _json2csv() or _jsonTables2csv()
 * @param pureTable Used for choosing between _json2csv or _jsonTables2csv (if it false will use _json2csv)
 * @param callback Callback function with single parameter, which is result CSV string.
 */
function json2csv(jsons, separator, eol, pureTable, callback) {
    var converter = pureTable ? _jsonTables2csv : _json2csv;

    if ((0, _utils.isPossibleToUseWorker)()) {
        var worker = (0, _utils.createWorkerFromFunction)(converter);
        worker.onerror = function () {
            // Failed to load the worker, proceed synchronously
            callback(converter(jsons, separator, eol));
        };
        worker.onmessage = function (e) {
            callback(e.data);
            worker.terminate();
        };
        worker.postMessage({
            args: [jsons, separator, eol]
        });
    } else {
        callback(converter(jsons, separator, eol));
    }
}

/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var GC = window.__GENERATED_CONSTANTS__;

var PROJECT_CONSTANTS = exports.PROJECT_CONSTANTS = {
    SELECT_CUSTOMER_OPTION_INDEX: GC.PROJECT_CONSTANTS.SELECT_CUSTOMER_OPTION_INDEX,
    NEW_CUSTOMER_OPTION_INDEX: GC.PROJECT_CONSTANTS.NEW_CUSTOMER_OPTION_INDEX,
    CUSTOMER_WAS_ARCHIVED: GC.PROJECT_CONSTANTS.CUSTOMER_WAS_ARCHIVED,
    CUSTOMER_WAS_DELETED: GC.PROJECT_CONSTANTS.CUSTOMER_WAS_DELETED,
    USERS_WAS_DELETED: GC.PROJECT_CONSTANTS.USERS_WAS_DELETED,
    RESULT_CODE_SUCESS: GC.PROJECT_CONSTANTS.RESULT_CODE_SUCCESS

};

/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.startLoadingDemoData = exports.closeLightbox = exports.sendMessage = exports.openLightbox = exports.setSize = exports.setUrl = exports.setDemoDataStage = exports.setShowExternalContent = exports.setPopupVisible = exports.setLoading = undefined;

var _actionTypes = __webpack_require__(716);

var _reduxActions = __webpack_require__(9);

var _constants = __webpack_require__(226);

var _jquery_rpc = __webpack_require__(26);

var _jquery_rpc2 = _interopRequireDefault(_jquery_rpc);

var _selectors = __webpack_require__(19);

var _selectors2 = __webpack_require__(406);

var _constants2 = __webpack_require__(4);

var _rpcCalls = __webpack_require__(24);

var _rpcCalls2 = _interopRequireDefault(_rpcCalls);

var _atUtils = __webpack_require__(5);

var _emitUserEvent = __webpack_require__(407);

var _emitUserEvent2 = _interopRequireDefault(_emitUserEvent);

var _UserEventsMap = __webpack_require__(99);

var _initIntercom = __webpack_require__(946);

var _ClassicBridge = __webpack_require__(18);

var _ClassicBridge2 = _interopRequireDefault(_ClassicBridge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var setLoading = exports.setLoading = (0, _reduxActions.createAction)(_actionTypes.LOADING_SET);
var setPopupVisible = exports.setPopupVisible = (0, _reduxActions.createAction)(_actionTypes.POPUP_VISIBLE_SET);
var setShowExternalContent = exports.setShowExternalContent = (0, _reduxActions.createAction)(_actionTypes.SHOW_EXTERNAL_CONTENT_SET);
var setDemoDataStage = exports.setDemoDataStage = (0, _reduxActions.createAction)(_actionTypes.DEMO_DATA_STAGE_SET);
var setUrl = exports.setUrl = (0, _reduxActions.createAction)(_actionTypes.URL_SET);
var setSize = exports.setSize = (0, _reduxActions.createAction)(_actionTypes.SIZE_SET);

var openLightbox = exports.openLightbox = function openLightbox() {
    return function (dispatch, getState) {
        dispatch(setLoading(true));
        dispatch(setPopupVisible(true));

        if ((0, _selectors2.getLoadExternalWelcomeScreen)(getState())) {
            dispatch(loadExternalContent());
        } else {
            dispatch(loadInternalContent());
        }
    };
};

var loadInternalContent = function loadInternalContent() {
    return function (dispatch) {
        if (!window.location.origin) {
            window.location.origin = window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
        }
        dispatch(loadContent((0, _atUtils.createAbsoluteLink)('user/w.do')));
    };
};

var loadExternalContent = function loadExternalContent() {
    return function (dispatch) {
        (0, _rpcCalls2.default)('WelcomeScreenService.getExternalContentUrl', [], function () {
            dispatch(setLoading(false));
            dispatch(setPopupVisible(false));
            return true;
        }).then(function (result) {
            return dispatch(loadContent(result));
        }).catch(function (e) {
            if (false) {
                console.log(e);
            } else {
                throw e;
            }
        });
    };
};

var loadContent = function loadContent(url) {
    return function (dispatch, getState) {
        dispatch(setUrl(url));
        var loadTimeout = _constants2.isOlVersion ? 300000 : 10000;
        window.setTimeout(function () {
            if (!(0, _selectors2.getShowExternalContent)(getState()) || (0, _selectors2.getLoading)(getState())) {
                dispatch(setShowExternalContent(false));
                dispatch(setLoading(false));
                dispatch(setPopupVisible(false));
            }
        }, loadTimeout);
    };
};

var sendMessage = exports.sendMessage = function sendMessage(contentKey) {
    return function (dispatch, getState) {
        var win = window.frames[contentKey];
        win.postMessage({ userName: (0, _selectors.getFirstName)(getState()) }, '*');
        window.addEventListener('message', function (event) {
            if (event.data.loaded) {
                dispatch(setSize({
                    width: event.data.width,
                    height: event.data.height
                }));
                dispatch(setLoading(false));
            }
            if (event.data.closeFrame) {
                dispatch(closeLightbox());
            }
        });
    };
};

var closeLightbox = exports.closeLightbox = function closeLightbox() {
    var sendUserEvent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    return function (dispatch, getState) {
        (0, _jquery_rpc2.default)('WelcomeScreenService.setCurrentUserSeenWelcomeScreen', []);
        dispatch(setPopupVisible(false));
        dispatch(setShowExternalContent(false));
        dispatch(setLoading(false));
        dispatch(setUrl(''));
        dispatch(setSize({ width: 0, height: 0 }));
        sendUserEvent && (0, _emitUserEvent2.default)(_UserEventsMap.UserEventsMap.POPUP_CLOSED);
        dispatch(onWelcomeToProductCallback());
    };
};

var startLoadingDemoData = exports.startLoadingDemoData = function startLoadingDemoData() {
    return function (dispatch) {
        var errorHandler = function errorHandler() {
            dispatch(setDemoDataStage(_constants.DemoDataStageType.ERROR));
            return true;
        };
        dispatch(setDemoDataStage(_constants.DemoDataStageType.ACTIVE));
        (0, _rpcCalls2.default)('DemoDataService.isNeedToLoadDemoData', [], errorHandler).then(function (result) {
            if (result === true) {
                (0, _rpcCalls2.default)('DemoDataService.loadDemoData', [], errorHandler).then(function () {
                    _ClassicBridge2.default.sendUserEvent(_UserEventsMap.UserEventsMap.TRIAL_READY);
                    dispatch(setDemoDataStage(_constants.DemoDataStageType.COMPLETED));
                    dispatch(onWelcomeToProductCallback());
                });
            }
        });
    };
};

var onWelcomeToProductCallback = function onWelcomeToProductCallback() {
    return function (dispatch, getState) {
        var isDemoLoaded = (0, _selectors2.getDemoDataStage)(getState()) === _constants.DemoDataStageType.COMPLETED;
        if (isDemoLoaded && !(0, _selectors2.getPopupVisible)(getState())) {
            if ((0, _selectors.isFirstAdmin)(getState()) && (0, _selectors2.isNeedToLoadDemoData)(getState())) {
                if (_constants2.CURRENT_PRODUCT === _constants2.Product.actiTIME) {
                    _ClassicBridge2.default.onDemoDataJustLoaded();
                    if ((0, _initIntercom.isIntercomEnabled)()) {
                        (0, _initIntercom.openIntercom)();
                    } else {
                        window.openHelpAndSupportMenu(document.createEvent("Event"));
                    }
                } else {
                    // reload page
                    window.location.href = _constants2.BASE_PATH;
                }
            } else {
                // for regular user
                (0, _initIntercom.openIntercom)();
            }
        }
    };
};

/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = sendUserEvent;

var _ClassicBridge = __webpack_require__(18);

var _ClassicBridge2 = _interopRequireDefault(_ClassicBridge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function sendUserEvent(event, params) {
    // just an alias to reduce amount of changes
    _ClassicBridge2.default.sendUserEvent(event, params, true);
}

/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var LIGHTBOX_TYPE_SET = exports.LIGHTBOX_TYPE_SET = 'iCalendar/lightbox/LIGHTBOX_TYPE_SET';
var FEED_NAME_SET = exports.FEED_NAME_SET = 'iCalendar/lightbox/FEED_NAME_SET';
var USER_SELECTION_SET = exports.USER_SELECTION_SET = 'iCalendar/lightbox/USER_SELECTION_SET';
var SHARED_USER_SELECTION_SET = exports.SHARED_USER_SELECTION_SET = 'iCalendar/lightbox/SHARED_USER_SELECTION_SET';
var LEAVE_TYPE_SELECTION_SET = exports.LEAVE_TYPE_SELECTION_SET = 'iCalendar/lightbox/LEAVE_TYPE_SELECTION_SET';
var INCLUDE_NOT_APPROVED_SET = exports.INCLUDE_NOT_APPROVED_SET = 'iCalendar/lightbox/INCLUDE_NOT_APPROVED_SET';
var DATE_RANGE_SELECITON_SET = exports.DATE_RANGE_SELECITON_SET = 'iCalendar/lightbox/DATE_RANGE_SELECTION_SET';
var CLOSE_ICAL_LIGHTBOX = exports.CLOSE_ICAL_LIGHTBOX = 'iCalendar/lightbox/CLOSE_ICAL_LIGHTBOX';

var CREATE_FEED_LIGHTBOX_DATA_LOAD = exports.CREATE_FEED_LIGHTBOX_DATA_LOAD = 'iCalendar/lightbox/CREATE_FEED_LIGHTBOX_DATA_LOAD';
var CREATE_FEED_LIGHTBOX_DATA_LOAD_SUCCESS = exports.CREATE_FEED_LIGHTBOX_DATA_LOAD_SUCCESS = 'iCalendar/lightbox/CREATE_FEED_LIGHTBOX_DATA_SUCCESS';
var CREATE_FEED_LIGHTBOX_DATA_LOAD_FAILURE = exports.CREATE_FEED_LIGHTBOX_DATA_LOAD_FAILURE = 'iCalendar/lightbox/CREATE_FEED_LIGHTBOX_DATA_FAILURE';
var EDIT_FEED_LIGHTBOX_DATA_LOAD = exports.EDIT_FEED_LIGHTBOX_DATA_LOAD = 'iCalendar/lightbox/EDIT_FEED_LIGHTBOX_DATA_LOAD';
var EDIT_FEED_LIGHTBOX_DATA_LOAD_SUCCESS = exports.EDIT_FEED_LIGHTBOX_DATA_LOAD_SUCCESS = 'iCalendar/lightbox/EDIT_FEED_LIGHTBOX_DATA_SUCCESS';
var EDIT_FEED_LIGHTBOX_DATA_LOAD_FAILURE = exports.EDIT_FEED_LIGHTBOX_DATA_LOAD_FAILURE = 'iCalendar/lightbox/EDIT_FEED_LIGHTBOX_DATA_FAILURE';
var EXPORT_ICAL_LIGHTBOX_DATA_LOAD = exports.EXPORT_ICAL_LIGHTBOX_DATA_LOAD = 'iCalendar/lightbox/EXPORT_ICAL_LIGHTBOX_DATA_LOAD';
var EXPORT_ICAL_LIGHTBOX_DATA_LOAD_SUCCESS = exports.EXPORT_ICAL_LIGHTBOX_DATA_LOAD_SUCCESS = 'iCalendar/lightbox/EXPORT_ICAL_LIGHTBOX_DATA_SUCCESS';
var EXPORT_ICAL_LIGHTBOX_DATA_LOAD_FAILURE = exports.EXPORT_ICAL_LIGHTBOX_DATA_LOAD_FAILURE = 'iCalendar/lightbox/EXPORT_ICAL_LIGHTBOX_DATA_FAILURE';

var CREATE_FEED_LOAD_DATA = exports.CREATE_FEED_LOAD_DATA = 'iCalendar/lightbox/CREATE_FEED_LOAD_DATA';
var CREATE_FEED_LOAD_DATA_SUCCESS = exports.CREATE_FEED_LOAD_DATA_SUCCESS = 'iCalendar/lightbox/CREATE_FEED_LOAD_DATA_SUCCESS';
var CREATE_FEED_LOAD_DATA_FAILURE = exports.CREATE_FEED_LOAD_DATA_FAILURE = 'iCalendar/lightbox/CREATE_FEED_LOAD_DATA_FAILURE';

var EDIT_FEED_LOAD_DATA = exports.EDIT_FEED_LOAD_DATA = 'iCalendar/lightbox/EDIT_FEED_LOAD_DATA';
var EDIT_FEED_LOAD_DATA_SUCCESS = exports.EDIT_FEED_LOAD_DATA_SUCCESS = 'iCalendar/lightbox/EDIT_FEED_LOAD_DATA_SUCCESS';
var EDIT_FEED_LOAD_DATA_FAILURE = exports.EDIT_FEED_LOAD_DATA_FAILURE = 'iCalendar/lightbox/EDIT_FEED_LOAD_DATA_FAILURE';

var EXPORT_ICAL_LOAD_DATA = exports.EXPORT_ICAL_LOAD_DATA = 'iCalendar/lightbox/EXPORT_ICAL_LOAD_DATA';
var EXPORT_ICAL_LOAD_DATA_SUCCESS = exports.EXPORT_ICAL_LOAD_DATA_SUCCESS = 'iCalendar/lightbox/EXPORT_ICAL_LOAD_DATA_SUCCESS';
var EXPORT_ICAL_LOAD_DATA_FAILURE = exports.EXPORT_ICAL_LOAD_DATA_FAILURE = 'iCalendar/lightbox/EXPORT_ICAL_LOAD_DATA_FAILURE';

/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _BasicLightbox = __webpack_require__(163);

var _BasicLightbox2 = _interopRequireDefault(_BasicLightbox);

var _atUtils = __webpack_require__(5);

var _constants = __webpack_require__(4);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _index = __webpack_require__(48);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function UserDataLightBox() {}

UserDataLightBox.prototype = new _BasicLightbox2.default();

UserDataLightBox.prototype.exist_invalid_fields_message_key = "user.add_edit.js.footer_error.exist_invalid_fields";

UserDataLightBox.prototype.init = function (sectionsBuilder, userManagementData, userId, accountSettings, showOvertime, otherProductStatusEditable) {
    _BasicLightbox2.default.prototype.init.call(this, "userDataLightBox", "closeUserDataLightBoxBtn");

    this._sectionsBuilder = sectionsBuilder;
    this.userManagementData = userManagementData;

    var self = this;

    this.dataChanged = false;
    this._changesCallback = function (notRequireConfirmationOnCopySettings) {
        if (!self.dataChanged) self.changesDetected();
        self.dataChanged = true;
        if (!notRequireConfirmationOnCopySettings && self.setNeedToConfirmWhenCopySettings) self.setNeedToConfirmWhenCopySettings(true);
    };

    this._forceCancelCallback = function () {
        self.dataChanged = false;
        self.cancel();
    };

    this.accountSettings = accountSettings;

    //noinspection JSUnusedLocalSymbols
    var hideBoxBeforeReloadErrorHandler = function hideBoxBeforeReloadErrorHandler(jqXHR, textStatus, errorThrown) {

        if (textStatus == "rpc_sessionExpired" || textStatus == "rpc_noRights") {
            //hide window to prevent confirmation dialog
            self.hide();
        }

        return false; // pass flow to default jquery error handler
    };

    var checkLightBoxIsShown = function checkLightBoxIsShown() {
        return self.isShowed;
    };

    (0, _jquery2.default)(this.lightBoxEl).addClass(_constants.isOlVersion ? "online" : "downloadable");
    (0, _jquery2.default)(this.lightBoxEl).removeClass("createMode");

    this._orderedSectionsList = this._sectionsBuilder.createSections(this._changesCallback, this._validateCallback, this.lightBoxEl, hideBoxBeforeReloadErrorHandler, this._makeSetUpNameCallBack(), this.handlerIfNoSuchUserAfterAjax, showOvertime, otherProductStatusEditable);

    this._sectionsErrorsHandler = this._sectionsBuilder.getSectionsErrorsHandler();
    this._userInputDataFetcher = this._sectionsBuilder.getUserInputDataFetcher();

    this.titlePlaceholder = document.getElementById(this.lightBoxEl.id + "_titlePlaceholder");
    this.userNamePlaceholder = document.getElementById(this.lightBoxEl.id + "_userNamePlaceholder");
    this.commitButtonTitlePlaceholder = (0, _jquery2.default)(document.getElementById(this.lightBoxEl.id + "_commitBtn")).find(".buttonTitle");

    this.deleteButton = document.getElementById(this.lightBoxEl.id + "_deleteBtn");

    this.userId = userId;
    this.defaultWorkSchedule = userManagementData.defaultWorkSchedule;

    return this;
};

UserDataLightBox.prototype.cancelAllServerSideChecks = function () {
    for (var i = 0; i < this._orderedSectionsList.length; i++) {
        var section = this._orderedSectionsList[i];
        section.cancelAllServerSideChecks();
    }
};

UserDataLightBox.prototype.handleSectionError = function (resultCode, errorParams) {
    var self = this;
    this._sectionsErrorsHandler.handleError(resultCode, function (section) {
        self.scrollToSection((0, _jquery2.default)(section.getSectionElement()));
    }, errorParams);
    if (this.hasErrors()) {
        this.printErrorInFooter(_messageResource2.default.getMessage(this.exist_invalid_fields_message_key));
        this._blinkErrorInFooter();
    }
};

UserDataLightBox.prototype.handleDuplicateTimeZoneError = function (timeZoneGroups) {
    this.handleSectionError(this._sectionsErrorsHandler.DUPLICATE_TIME_ZONE_GROUP_ERROR, timeZoneGroups);
};

UserDataLightBox.prototype.updateUI = function () {
    for (var i = 0; i < this._orderedSectionsList.length; i++) {
        this._orderedSectionsList[i].updateUI();
    }
};

UserDataLightBox.prototype.validateAll = function (scrollToInvalidSection) {
    var invalidSection;
    var valid = true;
    for (var i = 0; i < this._orderedSectionsList.length; i++) {
        var section = this._orderedSectionsList[i];
        if (!section.validate()) {
            valid = false;
            if (!invalidSection) {
                invalidSection = section;
            }
        }
    }
    this._validateCallback();
    if (scrollToInvalidSection && invalidSection) {
        this.scrollToSection((0, _jquery2.default)(invalidSection.getSectionElement()));
    }
    return valid;
};

UserDataLightBox.prototype.validate = function () {
    return this.validateAll(true);
};

UserDataLightBox.prototype.scrollToTop = function () {
    this.setScrollPosition(0);
};

UserDataLightBox.prototype.getScrollPosition = function () {
    return (0, _jquery2.default)('#' + this.lightBoxEl.id + ' .innerContent').scrollTop();
};

UserDataLightBox.prototype.setScrollPosition = function (scrollTop) {
    (0, _jquery2.default)('#' + this.lightBoxEl.id + ' .innerContent').scrollTop(scrollTop);
};

UserDataLightBox.prototype.hasErrors = function () {
    for (var i = 0; i < this._orderedSectionsList.length; i++) {
        if (this._orderedSectionsList[i].hasErrors()) return true;
    }return false;
};

UserDataLightBox.prototype.getDataToCommit = function () {
    return this._userInputDataFetcher.getUserInputData(this.userManagementData);
};

UserDataLightBox.prototype.setTitle = function (title) {
    this.titlePlaceholder.innerHTML = (0, _atUtils.escapeHtmlSymbols)(title);
};

UserDataLightBox.prototype.setNameInTitle = function (name) {
    this.userNamePlaceholder.innerHTML = (0, _atUtils.escapeHtmlSymbols)(name);
};

UserDataLightBox.prototype._makeSetUpNameCallBack = function () {
    var self = this;

    return function (firstName, lastName, middleName) {

        var name = self.formatUserName(firstName, lastName, middleName);
        self.setTitle(_messageResource2.default.getMessage("user.add.js.new") + (name.length > 0 ? ": " : ""));
        self.setNameInTitle(name);
    };
};

UserDataLightBox.prototype.formatUserName = function (firstName, lastName, middleName) {
    var result = "";

    var lastNameNoEmpty = (0, _atUtils.isNotEmpty)(lastName);
    if (lastNameNoEmpty) result += lastName;

    if ((0, _atUtils.isNotEmpty)(firstName)) {
        if (lastNameNoEmpty) result += ", ";
        result += firstName;
    }

    if (result.length > 0 && !_underscore2.default.isNull(middleName) && (0, _atUtils.isNotEmpty)(middleName)) result += " " + middleName + ".";

    return result;
};

UserDataLightBox.prototype.restoreOnKeyDownHandler = function () {
    if (this.removeHandler) this.removeHandler();
};

UserDataLightBox.prototype.setupKeyDownHandler = function () {
    var _this = this;

    this.removeHandler = (0, _index.onKeyDown)(function (code) {
        if ((0, _index.isEsc)(code)) {
            _this.cancel();
            return true;
        }
    });
};

exports.default = UserDataLightBox;

/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TableCellRenderer2 = __webpack_require__(63);

var _TableCellRenderer3 = _interopRequireDefault(_TableCellRenderer2);

var _atBrowserUtils = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RemoveRowCellRenderer = function (_TableCellRenderer) {
    _inherits(RemoveRowCellRenderer, _TableCellRenderer);

    function RemoveRowCellRenderer() {
        _classCallCheck(this, RemoveRowCellRenderer);

        return _possibleConstructorReturn(this, (RemoveRowCellRenderer.__proto__ || Object.getPrototypeOf(RemoveRowCellRenderer)).call(this));
    }

    _createClass(RemoveRowCellRenderer, [{
        key: "init",
        value: function init() {
            return this;
        }
    }, {
        key: "generateContent",
        value: function generateContent(cell) {
            var removeBtn = document.createElement("a");
            removeBtn.innerHTML = "&nbsp;";
            var self = this;
            removeBtn.onclick = function (e) {
                (0, _atBrowserUtils.cancelBubble)(e);
                self.onRemoveClick(cell);
            };
            cell.getCellEl().appendChild(removeBtn);
        }
    }, {
        key: "getCellClassName",
        value: function getCellClassName() {
            return ["removeBtn"];
        }
    }, {
        key: "onRemoveClick",
        value: function onRemoveClick(cell) {
            cell.getTable().toggleRemove(cell.getRow().getRowIdx());
        }
    }]);

    return RemoveRowCellRenderer;
}(_TableCellRenderer3.default);

exports.default = RemoveRowCellRenderer;

/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.createApproversSortingProcessor = createApproversSortingProcessor;
exports.formatAssignApproversCellText = formatAssignApproversCellText;
exports.checkReloadNeededAfterGetAssignedUsersRequest = checkReloadNeededAfterGetAssignedUsersRequest;

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _UserNameFormat = __webpack_require__(17);

var _UserNameFormat2 = _interopRequireDefault(_UserNameFormat);

var _atUtils = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createApproversSortingProcessor(allApprovers) {
    var approversMap = {};
    for (var i = 0; i < allApprovers.length; i++) {
        var approver = allApprovers[i];
        approversMap[approver.id] = {
            approver: approver,
            index: i
        };
    }
    return function (approverIds) {
        if (!approverIds) return [];
        var result = [];
        for (var _i = 0; _i < approverIds.length; _i++) {
            var approverEntry = approversMap[approverIds[_i]];
            if (approverEntry !== undefined && approverEntry !== null) {
                result.push(approverEntry.approver);
            }
        }
        result.sort(function (a, b) {
            return approversMap[a.id].index - approversMap[b.id].index;
        });
        return result;
    };
}

function formatAssignApproversCellText(userApprovers) {
    var otherApproversCountText = userApprovers.length > 1 ? "<br/><span class='otherUsersText'> " + _messageResource2.default.getMessage(userApprovers.length - 1 === 1 ? "user_list.and_1_other" : "user_list.and_n_others", [userApprovers.length - 1]) + "  </span>" : "";
    var firstApprover = userApprovers[0];
    return _UserNameFormat2.default.formatLFM((0, _atUtils.escapeHtmlSymbols)(firstApprover.firstName), (0, _atUtils.escapeHtmlSymbols)(firstApprover.lastName), (0, _atUtils.escapeHtmlSymbols)(firstApprover.middleInitial)) + "  " + otherApproversCountText;
}

function checkReloadNeededAfterGetAssignedUsersRequest(assignedUsersData, UGREnabledOnPage, TZGEnabledOnPage, dialog) {
    var needToReload = false;
    if (!assignedUsersData.enabled || !assignedUsersData.approver) {
        var message = _messageResource2.default.getMessage(assignedUsersData.enabled ? EnabledFeatures.APWSD ? 'user_list.users_for_approver_dialog.user_is_not_manager' : 'user_list.users_for_approver_dialog.user_is_not_manager.wsd_feature_on' : 'user_list.users_for_approver_dialog.user_disabled');
        alert(message);
        dialog.close();
        needToReload = true;
    }
    // this means UGR was concurrently disabled
    else if (UGREnabledOnPage && assignedUsersData.userGroups === null) {
            alert(_messageResource2.default.getMessage("userlist.js.error_ugr_disabled"));
            dialog.close();
            needToReload = true;
        } else if (!UGREnabledOnPage && assignedUsersData.userGroups !== null) {
            alert(_messageResource2.default.getMessage("userlist.js.error_ugr_enabled"));
            dialog.close();
            needToReload = true;
        } else if (TZGEnabledOnPage && assignedUsersData.timeZoneGroups === null) {
            alert(_messageResource2.default.getMessage("userlist.js.error_tzg_disabled"));
            dialog.close();
            needToReload = true;
        } else if (!TZGEnabledOnPage && assignedUsersData.timeZoneGroups !== null) {
            alert(_messageResource2.default.getMessage("userlist.js.error_tzg_enabled"));
            dialog.close();
            needToReload = true;
        }
    return needToReload;
}

/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _LeaveReportConfig = __webpack_require__(129);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var LeavesReportUtils = function () {
    function LeavesReportUtils() {
        _classCallCheck(this, LeavesReportUtils);
    }

    _createClass(LeavesReportUtils, null, [{
        key: "reportParamsWithLeaves",
        value: function reportParamsWithLeaves(reportParams) {
            return reportParams.columnsConfig !== _LeaveReportConfig.LeaveTypeColumnConfig.BALANCES_ONLY;
        }
    }, {
        key: "reportParamsWithPTO",
        value: function reportParamsWithPTO(reportParams) {
            return reportParams.columnsConfig !== _LeaveReportConfig.LeaveTypeColumnConfig.LEAVE_TIME_ONLY && reportParams.balanceQualifier !== _LeaveReportConfig.LeaveTypeBalanceQualifier.SICK_DAYS_ONLY;
        }
    }, {
        key: "reportParamsWithSick",
        value: function reportParamsWithSick(reportParams) {
            return reportParams.columnsConfig !== _LeaveReportConfig.LeaveTypeColumnConfig.LEAVE_TIME_ONLY && reportParams.balanceQualifier !== _LeaveReportConfig.LeaveTypeBalanceQualifier.PTO_ONLY;
        }
    }]);

    return LeavesReportUtils;
}();

exports.default = LeavesReportUtils;
;

/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _BaseReportPDFSettingsPreview = __webpack_require__(586);

var _BaseReportPDFSettingsPreview2 = _interopRequireDefault(_BaseReportPDFSettingsPreview);

var _LeavesReportStore = __webpack_require__(199);

var _LeavesReportStore2 = _interopRequireDefault(_LeavesReportStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LeavesReportPDFSettingsPreview = function (_BaseReportPDFSetting) {
    _inherits(LeavesReportPDFSettingsPreview, _BaseReportPDFSetting);

    function LeavesReportPDFSettingsPreview($containerEl, lightboxId, eventNamespace) {
        _classCallCheck(this, LeavesReportPDFSettingsPreview);

        var _this = _possibleConstructorReturn(this, (LeavesReportPDFSettingsPreview.__proto__ || Object.getPrototypeOf(LeavesReportPDFSettingsPreview)).call(this, $containerEl, lightboxId));

        _this.eventNamespace = eventNamespace;
        return _this;
    }

    _createClass(LeavesReportPDFSettingsPreview, [{
        key: "getStore",
        value: function getStore() {
            return _LeavesReportStore2.default;
        }
    }]);

    return LeavesReportPDFSettingsPreview;
}(_BaseReportPDFSettingsPreview2.default);

exports.default = LeavesReportPDFSettingsPreview;

/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _PDFSettingsPreview2 = __webpack_require__(518);

var _PDFSettingsPreview3 = _interopRequireDefault(_PDFSettingsPreview2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BaseReportPDFSettingsPreview = function (_PDFSettingsPreview) {
    _inherits(BaseReportPDFSettingsPreview, _PDFSettingsPreview);

    function BaseReportPDFSettingsPreview($containerEl, lightboxId, eventNamespace) {
        _classCallCheck(this, BaseReportPDFSettingsPreview);

        var _this = _possibleConstructorReturn(this, (BaseReportPDFSettingsPreview.__proto__ || Object.getPrototypeOf(BaseReportPDFSettingsPreview)).call(this, $containerEl, lightboxId));

        _this.eventNamespace = eventNamespace;
        return _this;
    }

    _createClass(BaseReportPDFSettingsPreview, [{
        key: "afterRender",
        value: function afterRender() {
            _PDFSettingsPreview3.default.prototype.afterRender.call(this);
            (0, _jquery2.default)(document.getElementById(this.lightboxId + "_numberOfPages")).hide();
        }
    }, {
        key: "subscribeToEvents",
        value: function subscribeToEvents() {
            _PDFSettingsPreview3.default.prototype.subscribeToEvents.call(this);

            var self = this;
            (0, _jquery2.default)(document).on(this.eventNamespace + ".pdfPreview.lightbox.show", function () {
                self.update();
                var printParametersForGenerate = self.collectPrintParametersForGenerate();
                self.triggerIntermediatePrintParametersChange(printParametersForGenerate);
                self.triggerPrintParametersForGenerateChange(printParametersForGenerate);
            });
        }
    }, {
        key: "unsubscribeFromEvents",
        value: function unsubscribeFromEvents() {
            _PDFSettingsPreview3.default.prototype.unsubscribeFromEvents.call(this);
            (0, _jquery2.default)(document).off(this.eventNamespace + ".pdfPreview.lightbox.show");
        }
    }, {
        key: "updateNumberOfPagesInformation",
        value: function updateNumberOfPagesInformation() {
            // do nothing
        }
    }, {
        key: "triggerPrintParametersForSaveChange",
        value: function triggerPrintParametersForSaveChange(printParametersForSave) {
            (0, _jquery2.default)(document).trigger(this.eventNamespace + ".pdfPreview.printParametersForSaveChange", printParametersForSave);
        }
    }, {
        key: "triggerPrintParametersForGenerateChange",
        value: function triggerPrintParametersForGenerateChange(printParametersForGenerate) {
            (0, _jquery2.default)(document).trigger(this.eventNamespace + ".pdfPreview.printParametersForGenerateChange", printParametersForGenerate);
        }
    }]);

    return BaseReportPDFSettingsPreview;
}(_PDFSettingsPreview3.default);

exports.default = BaseReportPDFSettingsPreview;

/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var BasePDFDefinitionCreator = function () {
    function BasePDFDefinitionCreator() {
        _classCallCheck(this, BasePDFDefinitionCreator);
    }

    _createClass(BasePDFDefinitionCreator, [{
        key: "createDocDefinition",
        value: function createDocDefinition(pdfData, pdfPrintParameters) {}
    }]);

    return BasePDFDefinitionCreator;
}();

exports.default = BasePDFDefinitionCreator;
;

/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.tableLayouts = exports.styles = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _BasePDFDefinitionBuilder = __webpack_require__(541);

var _BasePDFDefinitionBuilder2 = _interopRequireDefault(_BasePDFDefinitionBuilder);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BaseReportPDFDefinitionBuilder = function (_BasePDFDefinitionBui) {
    _inherits(BaseReportPDFDefinitionBuilder, _BasePDFDefinitionBui);

    function BaseReportPDFDefinitionBuilder() {
        _classCallCheck(this, BaseReportPDFDefinitionBuilder);

        var _this = _possibleConstructorReturn(this, (BaseReportPDFDefinitionBuilder.__proto__ || Object.getPrototypeOf(BaseReportPDFDefinitionBuilder)).call(this));

        _this.columnStrategies = [];
        _this.createRowMethodNames = ['makeFirstRow', 'makeSecondRow', 'makeThirdRow', 'makeFourthRow'];
        return _this;
    }

    _createClass(BaseReportPDFDefinitionBuilder, [{
        key: "init",
        value: function init(paperOrientation, paperSize, columnStrategies, headerRowsNumber) {
            _BasePDFDefinitionBuilder2.default.prototype.init.call(this, paperOrientation, paperSize);
            this.columnStrategies = columnStrategies;
            this.headerRowsNumber = headerRowsNumber;

            var params = this.p("reportParams");
            if (!_underscore2.default.isUndefined(params)) {
                var width = [];
                for (var i = 0; i < this.columnStrategies.length; i++) {
                    this.columnStrategies[i].setParams(params);
                }
            }

            return this;
        }
    }, {
        key: "getAdditionalStyles",
        value: function getAdditionalStyles() {
            return styles;
        }
    }, {
        key: "getAdditionalTableLayouts",
        value: function getAdditionalTableLayouts() {
            return tableLayouts;
        }
    }, {
        key: "initDocDefinitionObject",
        value: function initDocDefinitionObject(withSignatureOnEachPage, headerOnEachPage) {
            _BasePDFDefinitionBuilder2.default.prototype.initDocDefinitionObject.call(this, headerOnEachPage);
            var margins = [];
            _underscore2.default.extend(margins, this.dd.pageMargins);

            this.dd.pageMargins = margins;

            var footerMargins = this.p("footerMargins")(this.p("pageMargins"));
            this.dd.footer = function () {
                return function (currentPage, pageCount) {
                    return {
                        style: 'rightFooterPageCount',
                        margin: footerMargins,
                        layout: 'noBordersNoPadding',
                        text: _messageResource2.default.getMessage('report.chart_pdf.rightFooterLabel', [currentPage, pageCount])
                    };
                };
            }();
        }
    }, {
        key: "iterateColumns",
        value: function iterateColumns(method, data) {
            var row = [];
            _underscore2.default.each(this.columnStrategies, function (strategy) {
                var rows = strategy[method](data);
                if (rows.length) _underscore2.default.each(rows, function (newRow) {
                    row.push(newRow);
                });else row.push(rows);
            });

            return row;
        }
    }, {
        key: "createHeaderDataRow",
        value: function createHeaderDataRow(headerData) {
            var header = {
                firstRow: this.iterateColumns('makeHeader', headerData)
            };

            if (this.headerRowsNumber > 1) header.secondRow = this.iterateColumns('makeSubHeader', headerData);

            if (this.headerRowsNumber > 2) header.thirdRow = this.iterateColumns('makeThirdLvlHeader', headerData);

            return header;
        }
    }, {
        key: "createTotalsRow",
        value: function createTotalsRow(data) {
            return this.iterateColumns('makeTotals', data);
        }
    }, {
        key: "createRow",
        value: function createRow(lvl, data) {
            return this.iterateColumns(this.createRowMethodNames[lvl], data);
        }
    }, {
        key: "addDataTable",
        value: function addDataTable(headerRow, dataRows) {
            var tableMargins = {
                top: 20
            };
            var tableStyles = this.p("dataTableStyles");

            var rows = [];
            rows.push(headerRow.firstRow);

            if (headerRow.secondRow) rows.push(headerRow.secondRow);

            if (headerRow.thirdRow) rows.push(headerRow.thirdRow);

            var headerRowsNumber = rows.length;
            rows = rows.concat(dataRows);

            var sizes = this.p("columnWidth");

            var width = [];
            for (var i = 0; i < this.columnStrategies.length; i++) {
                this.columnStrategies[i].pushWidth(width, sizes);
            }

            var table = {
                style: tableStyles.tableStyle,
                layout: 'reportLayout',
                marginTop: tableMargins.top,

                table: {
                    dontBreakRows: true,
                    headerRows: headerRowsNumber,
                    widths: width,
                    body: rows
                }
            };
            this.appendContentElement(table);
        }
    }]);

    return BaseReportPDFDefinitionBuilder;
}(_BasePDFDefinitionBuilder2.default);

exports.default = BaseReportPDFDefinitionBuilder;
var styles = exports.styles = {
    reportTable: {
        fontSize: 8
    },

    reportHeader: {
        fillColor: '#EFEFEF',
        color: '#373737',
        fontSize: 9,
        alignment: 'center',
        border: 1
    },

    reportSubHeader: {
        fillColor: '#F2F2F2',
        color: '#373737',
        fontSize: 9,
        alignment: 'center',
        border: 1
    },

    reportHeaderMargin: {
        margin: [2, 2, 0, 2]
    },

    reportTitleBigMargin: {
        margin: [0, 15, 2, 2]
    },

    reportTitleNormalMargin: {
        margin: [0, 10, 2, 2]
    },

    reportTitleSmallMargin: {
        margin: [0, 5, 2, 2]
    },

    reportRow: {
        fontSize: 9,
        alignment: 'center'
    },

    smallText: {
        fontSize: 8
    },

    tinyText: {
        fontSize: 7
    },

    negativeValue: {
        color: '#ed1c24'
    },

    grayText: {
        color: '#777777'
    },

    reportTotalValue: {
        bold: true,
        alignment: 'center'
    },

    reportFirstGroupingValue: {
        bold: true,
        alignment: 'center',
        fillColor: '#f4f4f4'
    },

    reportSecondGroupingValue: {
        bold: true,
        alignment: 'center',
        fillColor: '#f6f6f6'
    },

    reportThirdGroupingValue: {
        alignment: 'center'
    },

    reportFourthGroupingValue: {
        italics: true,
        alignment: 'center'
    },

    reportLevelsTitle: {
        alignment: 'left',
        margin: [6, 15, 2, 2]
    },

    reportTotalTitle: {
        margin: [0, 5, 2, 2]
    },

    reportTotal: {
        bold: true,
        marginRight: 3,
        alignment: 'right'
    },

    reportFirstGroupingRow: {
        bold: true,
        alignment: 'left',
        fillColor: '#f4f4f4'
    },

    reportFirstGroupingRowMargin: {
        marginLeft: 1
    },

    reportSecondGroupingRow: {
        bold: true,
        alignment: 'left',
        fillColor: '#f6f6f6'
    },

    reportSecondGroupingRowMargin: {
        marginLeft: 10
    },

    reportThirdGroupingRow: {
        alignment: 'left'
    },

    reportThirdGroupingRowMargin: {
        marginLeft: 20
    },

    reportFourthGroupingRow: {
        italics: true,
        alignment: 'left'
    },

    reportFourthGroupingRowMargin: {
        marginLeft: 30
    },

    rightFooterPageCount: {
        alignment: 'right',
        color: '#6A6A6A',
        fontSize: 7
    },

    asterisk: {
        color: '#f58f0a',
        fontSize: 6
    }
};

var tableLayouts = exports.tableLayouts = {

    reportLayout: {
        hLineWidth: function hLineWidth() {
            return 1;
        },
        vLineWidth: function vLineWidth() {
            return 1;
        },
        hLineColor: function hLineColor() {
            return '#cecece';
        },
        vLineColor: function vLineColor() {
            return '#cecece';
        }
    }
};

/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _RowType = __webpack_require__(267);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DataTableCreateDefinitionHelper = function () {
    function DataTableCreateDefinitionHelper(ddBuilder, tableData, config) {
        _classCallCheck(this, DataTableCreateDefinitionHelper);

        this.ddBuilder = ddBuilder;
        this.tableData = tableData;
        this.config = config;

        this.labels = {
            titleMessage: "hello"
        };
    }

    _createClass(DataTableCreateDefinitionHelper, [{
        key: "createTable",
        value: function createTable() {
            var rows = [];
            var rowTypes = _RowType.RowType;

            var rowStrategies = {};
            rowStrategies[rowTypes.HEADER] = _underscore2.default.bind(this.makeHeader, this);
            rowStrategies[rowTypes.TOTALS] = _underscore2.default.bind(this.makeTotals, this);
            rowStrategies[rowTypes.FIRST_LEVEL] = _underscore2.default.bind(this.makeRow, this, 0);
            rowStrategies[rowTypes.SECOND_LEVEL] = _underscore2.default.bind(this.makeRow, this, 1);
            rowStrategies[rowTypes.THIRD_LEVEL] = _underscore2.default.bind(this.makeRow, this, 2);
            rowStrategies[rowTypes.FORTH_LEVEL] = _underscore2.default.bind(this.makeRow, this, 3);

            var headerData = this.tableData[0];
            var headerDefinition = rowStrategies[headerData.type](headerData);

            for (var i = 1; i < this.tableData.length; i++) {
                var rowData = this.tableData[i];
                var rowDefinition = rowStrategies[rowData.type](rowData);
                rows.push(rowDefinition);
            }

            this.ddBuilder.addDataTable(headerDefinition, rows);
        }
    }, {
        key: "makeHeader",
        value: function makeHeader(row) {
            return this.ddBuilder.createHeaderDataRow(row);
        }
    }, {
        key: "makeTotals",
        value: function makeTotals(row) {
            return this.ddBuilder.createTotalsRow(row);
        }
    }, {
        key: "makeRow",
        value: function makeRow(lvl, row) {
            return this.ddBuilder.createRow(lvl, row);
        }
    }]);

    return DataTableCreateDefinitionHelper;
}();

exports.default = DataTableCreateDefinitionHelper;

/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _PDFPreviewLightboxController = __webpack_require__(971);

var _PDFPreviewLightboxController2 = _interopRequireDefault(_PDFPreviewLightboxController);

var _PDFPreviewLightbox = __webpack_require__(591);

var _PDFPreviewLightbox2 = _interopRequireDefault(_PDFPreviewLightbox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PDFPreviewLightbox = function PDFPreviewLightbox() {};

PDFPreviewLightbox.prototype = _.create(_PDFPreviewLightbox2.default.prototype, {

    createPDFLightboxController: function createPDFLightboxController(_ref) {
        var lightBoxEl = _ref.lightBoxEl,
            titleEl = _ref.titleEl,
            popupId = _ref.popupId,
            eventNamespace = _ref.eventNamespace;

        return new _PDFPreviewLightboxController2.default().init({
            lightBoxEl: lightBoxEl,
            titleEl: titleEl,
            popupId: popupId,
            eventNamespace: eventNamespace,
            productSettingsValidator: new ATProductSettingsValidator(),
            reportRightsValidator: new ATReportRightsValidator()
        });
    }
});

exports.default = PDFPreviewLightbox;

/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _BasicLightbox = __webpack_require__(163);

var _BasicLightbox2 = _interopRequireDefault(_BasicLightbox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BaseReportPDFPreviewLightbox = function BaseReportPDFPreviewLightbox() {};

BaseReportPDFPreviewLightbox.prototype = _underscore2.default.create(_BasicLightbox2.default.prototype, {
    exist_invalid_fields_message_key: "",
    close_tab_confirmation_message_key: "",

    init: function init(config) {
        _BasicLightbox2.default.prototype.init.call(this, config.popupId, config.closeBtnId);

        var self = this;
        this.titleEl = (0, _jquery2.default)(this.lightBoxEl).find(".lightBoxTitle");
        this.setCancelCallback(function () {
            self.hide();
        });
        this.eventNamespace = config.eventNamespace;

        this.pdfPreviewViewController = this.createPDFLightboxController({
            lightBoxEl: this.lightBoxEl,
            titleEl: this.titleEl,
            popupId: config.popupId,
            eventNamespace: config.eventNamespace
        });

        return this;
    },

    createPDFLightboxController: function createPDFLightboxController(_ref) {
        //abstract    

        var lightBoxEl = _ref.lightBoxEl,
            titleEl = _ref.titleEl,
            popupId = _ref.popupId,
            eventNamespace = _ref.eventNamespace;
    },

    show: function show() {
        _BasicLightbox2.default.prototype.show.call(this);
        this.pdfPreviewViewController.onShow();
        (0, _jquery2.default)(document).trigger(this.eventNamespace + ".pdfPreview.lightbox.show");
    },

    hide: function hide() {
        (0, _jquery2.default)(document).trigger(this.eventNamespace + ".pdfPreview.lightbox.hide");
        _BasicLightbox2.default.prototype.hide.call(this);
    },

    cancelAllExportingProcesses: function cancelAllExportingProcesses() {
        this.pdfPreviewViewController.cancelAllExportingProcesses();
    }
});

exports.default = BaseReportPDFPreviewLightbox;

/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ParametersFormatter2 = __webpack_require__(246);

var _ParametersFormatter3 = _interopRequireDefault(_ParametersFormatter2);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _date_format = __webpack_require__(16);

var _ATReportParamsStringBuilder = __webpack_require__(52);

var _ATReportParamsStringBuilder2 = _interopRequireDefault(_ATReportParamsStringBuilder);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EVAReportParametersFormatter = function (_ParametersFormatter) {
    _inherits(EVAReportParametersFormatter, _ParametersFormatter);

    function EVAReportParametersFormatter() {
        _classCallCheck(this, EVAReportParametersFormatter);

        return _possibleConstructorReturn(this, (EVAReportParametersFormatter.__proto__ || Object.getPrototypeOf(EVAReportParametersFormatter)).apply(this, arguments));
    }

    _createClass(EVAReportParametersFormatter, [{
        key: "init",
        value: function init(_ref) {
            var _ref$selectorsData = _ref.selectorsData,
                selectorsData = _ref$selectorsData === undefined ? {} : _ref$selectorsData,
                dateFormat = _ref.dateFormat;

            this.reportParamsStringBuilder = new _ATReportParamsStringBuilder2.default({
                data: {
                    users: selectorsData.users,
                    cpList: selectorsData.cpList,
                    projectsWithMaIds: selectorsData.projectsWithMaIds,
                    statuses: selectorsData.statuses
                },
                dateFormat: dateFormat
            });
            return this;
        }
    }, {
        key: "formatTaskSelectionParamsString",
        value: function formatTaskSelectionParamsString(tasksConfig, includeNotEstimated, includeNotStarted, dateSelectionWrap) {
            var dateSelection = dateSelectionWrap.dateSelection;
            var showOpenTasks = tasksConfig === "ALL" || tasksConfig === "OPEN_ONLY";
            var showCompletedTasks = tasksConfig === "ALL" || tasksConfig === "COMPLETED_ONLY";

            var keyPrefix = '';

            if (showOpenTasks) {
                if (showCompletedTasks) keyPrefix = "report.budgeted_vs_actual.filter_view.open_and_completed_tasks";else keyPrefix = "report.budgeted_vs_actual.filter_view.open_tasks";
            } else if (showCompletedTasks) keyPrefix = "report.budgeted_vs_actual.filter_view.completed_tasks";

            var value = _messageResource2.default.getMessage(keyPrefix);

            var addition1 = "",
                addition2 = "",
                separator = "";

            if (!includeNotStarted) {
                var date = dateSelectionWrap.isParsed ? dateSelection.date : dateSelection.date.parseJSONDate();
                addition1 = _messageResource2.default.getMessage("report.budgeted_vs_actual.filter_view.tasks_started_after", [new _date_format.DateFormat(window.SystemSettings.dateFormat).formatDate(date) + ", " + Date.dayNames[date.getDay()]]);
            }

            if (!includeNotEstimated) {
                addition2 = _messageResource2.default.getMessage("report.budgeted_vs_actual.filter_view.not_budgeted_tasks");
            }

            if (addition1 || addition2) {
                if (addition1 && addition2) separator = " & ";
                value += " (" + _messageResource2.default.getMessage("report.budgeted_vs_actual.filter_view.except") + " " + addition1 + separator + addition2 + ")";
            }
            return value;
        }
    }]);

    return EVAReportParametersFormatter;
}(_ParametersFormatter3.default);

exports.default = EVAReportParametersFormatter;

/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _cp_selector_report_config = __webpack_require__(350);

var _cp_selector_report_config2 = _interopRequireDefault(_cp_selector_report_config);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _TableTooltip = __webpack_require__(237);

var _TableTooltip2 = _interopRequireDefault(_TableTooltip);

var _atBrowserUtils = __webpack_require__(8);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _dropdown_list_button = __webpack_require__(482);

var _dropdown_list_button2 = _interopRequireDefault(_dropdown_list_button);

var _constants = __webpack_require__(11);

var _GroupType = __webpack_require__(34);

var _GroupType2 = _interopRequireDefault(_GroupType);

var _features = __webpack_require__(22);

var _constants2 = __webpack_require__(4);

var _ReportTimeTrackStatusFilter = __webpack_require__(980);

var _ReportTimeTrackStatusFilter2 = _interopRequireDefault(_ReportTimeTrackStatusFilter);

var _ReportUserSelectorButton = __webpack_require__(511);

var _ReportUserSelectorButton2 = _interopRequireDefault(_ReportUserSelectorButton);

var _ErrorTooltipsForSectionsController = __webpack_require__(798);

var _ErrorTooltipsForSectionsController2 = _interopRequireDefault(_ErrorTooltipsForSectionsController);

var _View2 = __webpack_require__(20);

var _View3 = _interopRequireDefault(_View2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ReportEditConfigController = function (_View) {
    _inherits(ReportEditConfigController, _View);

    function ReportEditConfigController() {
        _classCallCheck(this, ReportEditConfigController);

        var _this = _possibleConstructorReturn(this, (ReportEditConfigController.__proto__ || Object.getPrototypeOf(ReportEditConfigController)).call(this));

        _this.state = {
            loggedInUserId: null
        };
        return _this;
    }

    _createClass(ReportEditConfigController, [{
        key: 'init',
        value: function init(config) {
            _get(ReportEditConfigController.prototype.__proto__ || Object.getPrototypeOf(ReportEditConfigController.prototype), 'init', this).call(this);
            this.productSettingsValidator = _underscore2.default.isUndefined(config.productSettingsValidator) ? new ATProductSettingsValidator() : config.productSettingsValidator;
            this.reportRightsValidator = _underscore2.default.isUndefined(config.reportRightsValidator) ? new ATReportRightsValidator() : config.reportRightsValidator;
            this.initReportParameters = config.reportParameters;

            this.panelId = config.panelId ? config.panelId : "editReportConfigurationPanel";
            this.panelEl = (0, _jquery2.default)("#" + this.panelId);

            this.errorsToSectionElsMap = this.initErrorsToSectionElsMap();

            var self = this;
            this.errors = [];
            this.errorMessageEl = this.panelEl.find(".errorMessage");
            this.errorTooltipsForSectionsController = new _ErrorTooltipsForSectionsController2.default().init("reportEditConfigErrorTooltip", this.errorsToSectionElsMap, function (error) {
                return self.getErrorMessage(error);
            });

            this._initTimeFormatTooltip();

            this.preloadedState = {
                initCPSelector: function initCPSelector(cpSelector) {
                    cpSelector.initializeData(config.cpList, config.customersWithMaIds, config.projectsWithMaIds);
                },
                initUserSelector: function initUserSelector(userSelector) {
                    userSelector.initializeData(config.userGroups != null, config.timeZoneGroups != null, config.users, config.manageableUsersIds, config.userGroups, config.timeZoneGroups);
                }
            };
        }
    }]);

    return ReportEditConfigController;
}(_View3.default);

exports.default = ReportEditConfigController;


ReportEditConfigController.prototype.possibleErrors = {
    ERROR_EMPTY_USER_SELECTION: "errorEmptyUserSelection",
    ERROR_EMPTY_CP_SELECTION: "errorEmptyCPSelection",
    ERROR_EMPTY_LEAVE_TYPES_SELECTION: "errorEmptyLeaveTypesSelection",
    ERROR_IN_GROUPING_LEVELS_SELECTOR: "errorInGroupingLevelsSelector",
    ADDITIONAL_ERROR: "additionalError"
};

/**
 * Set default values for selectors are dependent on features
 */
ReportEditConfigController.prototype.makeReportParamsAccordingToFeatures = function () {
    // abstract
};

ReportEditConfigController.prototype.makeCPSelector = function (customersProjectsSelection) {
    var self = this;
    var configChanged = function configChanged() {
        self.removeCPSelectionError();
        cpSelector.setInitialValueFromCurrent();
        self.configChanged();
    };

    var cpSelector = new _cp_selector_report_config2.default().init(customersProjectsSelection, "cpSelectorId", configChanged);
    this.preloadedState.initCPSelector(cpSelector);

    cpSelector.panel.on("change", function () {
        cpSelector.setWasChanged();
    });

    return cpSelector;
};

ReportEditConfigController.prototype.adjust = function (groups, groupType, users, showDisabled) {
    var adjustUsers = void 0;
    if (!showDisabled) users = _underscore2.default.filter(users, function (user) {
        return user.active;
    });

    if (groupType === "USER_GROUP") {
        adjustUsers = _underscore2.default.filter(users, function (user) {
            return _underscore2.default.contains(groups, user.userGroupId);
        });
    }
    if (groupType === "TIME_ZONE_GROUP") {
        adjustUsers = _underscore2.default.filter(users, function (user) {
            return _underscore2.default.contains(groups, user.timeZoneGroupId);
        });
    }
    return _underscore2.default.map(adjustUsers, function (user) {
        return user.id;
    });
};

ReportEditConfigController.prototype.makeUserSelector = function (config, specificConstructorPanel) {
    var _this2 = this;

    var self = this;
    var configChanged = function configChanged() {
        self.removeUserSelectionError();self.configChanged();
    };

    var userSelection = config.reportParameters.userSelection;
    var ugrEnabled = this.productSettingsValidator.isUGREnabled();
    var tzgEnabled = this.productSettingsValidator.isTZGEnabled();
    var ugrWithoutFeature = !ugrEnabled && config.reportParameters.userSelection.groupType === _GroupType2.default.USER_GROUP;
    var tzgWithoutFeature = !tzgEnabled && config.reportParameters.userSelection.groupType === _GroupType2.default.TIME_ZONE_GROUP;
    var groupsSelected = config.reportParameters.userSelection.selectedGroups.length > 0;

    if ((ugrWithoutFeature || tzgWithoutFeature) && groupsSelected || userSelection.includeUserTeamOnly && (ugrEnabled || tzgEnabled)) {

        userSelection.selectedUsers = userSelection.selectedUsers.concat(self.adjust(userSelection.selectedGroups, userSelection.groupType, config.users, userSelection.showDisabled));
        userSelection.selectedGroups = [];
    }

    var selectorConfig = {
        selectorId: "userSelectorId",
        userSelection: userSelection,
        changeCallback: function changeCallback() {
            userSelector.setInitialValueFromCurrent();
            configChanged();
        },
        needAdditionalCheckbox: config.needAdditionalCheckbox !== undefined ? config.needAdditionalCheckbox : true,
        additionalCheckboxLabel: config.additionalCheckboxLabel || _messageResource2.default.getMessage("users_selector.reports.include_users_wo_time"),
        allUsersAvailable: config.reportAuthorizationInfo.allUsersAvailable,
        includeUserTeamOnly: userSelection.includeUserTeamOnly
    };

    if (specificConstructorPanel) selectorConfig.specificConstructorPanel = specificConstructorPanel;

    var userSelector = new _ReportUserSelectorButton2.default().init(selectorConfig);

    var sortedUsers = Array.from(config.users).sort(userComparator);

    userSelector.initializeData(config.userGroups != null, config.timeZoneGroups != null, sortedUsers, config.manageableUsersIds, config.userGroups, config.timeZoneGroups, userSelection.includeUserTeamOnly);

    userSelector.panel.on("change", function () {
        userSelector.setWasChanged();
    });

    userSelector.panel.loggedInUserNotInTeam = !!config.manageableUsersIds && config.manageableUsersIds.indexOf(this.state.loggedInUserId) === -1 && config.users.some(function (u) {
        return u.id === _this2.state.loggedInUserId;
    });

    userSelector.updateButton();

    return userSelector;
};

ReportEditConfigController.prototype.getConfig = function () {
    // abstract
};

ReportEditConfigController.prototype.resetConfig = function (config) {
    // abstract
};

ReportEditConfigController.prototype.hasErrors = function () {
    return this.errors.length > 0;
};

ReportEditConfigController.prototype.setConfigButtonHandlers = function (handlers) {
    (0, _jquery2.default)("#applyReportConfiguration").click(function () {
        handlers.onApply();
    });
    (0, _jquery2.default)("#cancelReportConfiguration").click(function () {
        handlers.onCancel();
    });
};

ReportEditConfigController.prototype.initListSelector = function (selectId, initValue, changeCallback, additionalClass) {
    var selector = this.initCustomListSelector(selectId, changeCallback, additionalClass);
    selector.setActiveItemByValue(initValue);

    return selector;
};

ReportEditConfigController.prototype.initTimeFormatSelector = function (timeFormat, changedCallback) {
    return this.initListSelector("timeFormatSelect", timeFormat, changedCallback, "timeFormatMenu");
};

ReportEditConfigController.prototype._initTimeFormatTooltip = function () {
    // init tooltip for time format selector
    var timeFormatTooltip = new _TableTooltip2.default().init("timeFormatTooltip");
    var icon = (0, _jquery2.default)("#timeFormatInfo");
    icon.hover(function (event) {
        timeFormatTooltip.show();timeFormatTooltip.move((0, _atBrowserUtils.calculateTooltipOffset)(timeFormatTooltip, event));
    }, function () {
        timeFormatTooltip.hide();
    });
    icon.mousemove(function (event) {
        timeFormatTooltip.move((0, _atBrowserUtils.calculateTooltipOffset)(timeFormatTooltip, event));
    });
};

ReportEditConfigController.prototype.setSelectorsInitStateFromCurrent = function () {
    this.initReportParameters = this.getConfig();
};

ReportEditConfigController.prototype.setSelectorsFromReportParameters = function (reportParameters) {
    this.initReportParameters = reportParameters;
};

ReportEditConfigController.prototype.addApprovedTTFilter = function (initValue, changeCallback) {
    var isNeedApprovedTTFilter = (0, _features.isEnabled)(_features.Feature.TTA) || initValue && initValue !== _constants2.TimeApprovalStatus.BOTH;
    var selectorRow = (0, _jquery2.default)("#ttStatusFilterRow");
    if (isNeedApprovedTTFilter) {
        selectorRow.show();
        return new _ReportTimeTrackStatusFilter2.default().init("filterByTTStatus", initValue, changeCallback);
    } else {
        selectorRow.hide();
        return this.initEmptyListSelector(initValue);
    }
};

ReportEditConfigController.prototype.initEmptyListSelector = function (initValue) {
    return { getValue: function getValue() {
            return initValue;
        }, setActiveItemByValue: function setActiveItemByValue() {} };
};

ReportEditConfigController.prototype.initRadioGroupSelector = function (radioGroupSelectorId, radioGroupName, initValue, onChangeCallback) {
    var selector = (0, _jquery2.default)("#" + radioGroupSelectorId);
    selector.groupName = radioGroupName;
    selector.setItemByValue = function (value) {
        this.find("[name=" + selector.groupName + "][value=" + value + "]").prop('checked', true);
    };

    selector.getValue = function () {
        return this.find("[name=" + selector.groupName + "]:checked").val();
    };
    selector.setItemByValue(initValue);

    if (onChangeCallback) selector.on("change", onChangeCallback);

    return selector;
};

ReportEditConfigController.prototype.initCustomListSelector = function (selectId, onChangeCallback, additionalCls, initValue) {
    var menuCls = "columns-format-menu";
    menuCls += additionalCls ? " " + additionalCls : "";
    var selector = new _dropdown_list_button2.default({
        applyTo: selectId,
        menuCls: menuCls,
        cls: "report-config-control-button"
    });

    if (initValue) {
        selector.setActiveItemByValue(initValue);
    }

    if (onChangeCallback != null) selector.on("change", onChangeCallback);

    return selector;
};
// method for grouping level selectors (check if selector contains concrete value)
ReportEditConfigController.prototype.checkGroupingLevel = function (levelValue, groupingParams) {
    for (var i = 0; i < groupingParams.length; i++) {
        if (groupingParams[i] === levelValue) {
            return true;
        }
    }
    return false;
};

ReportEditConfigController.prototype.validate = function () {
    return true;
};

ReportEditConfigController.prototype.updateUI = function (blinkError) {
    for (var error in this.possibleErrors) {
        if (this.possibleErrors.hasOwnProperty(error)) this.panelEl.removeClass(this.possibleErrors[error]);
    }

    for (var i = 0; i < this.errors.length; i++) {
        this.panelEl.addClass(this.errors[i]);
    }var errorMsg = "";

    if (this.errors.length === 1) errorMsg = this.getErrorMessage(this.errors[0]);else if (this.errors.length > 1) errorMsg = _messageResource2.default.getMessage("report.js.error.exist_invalid_fields");

    this.errorMessageEl.html(errorMsg);
    if (errorMsg && blinkError) this.blinkErrorInFooter();

    this.errorTooltipsForSectionsController.updateTooltips(this.errors);
};

ReportEditConfigController.prototype.initErrorsToSectionElsMap = function () {
    // abstract
    return {};
};

ReportEditConfigController.prototype.removeGroupingLevelsSelectionError = function () {
    this.errors.remove(this.possibleErrors.ERROR_IN_GROUPING_LEVELS_SELECTOR);
    this.updateUI();
};

ReportEditConfigController.prototype.removeCPSelectionError = function () {
    this.errors.remove(this.possibleErrors.ERROR_EMPTY_CP_SELECTION);
    this.updateUI();
};

ReportEditConfigController.prototype.removeUserSelectionError = function () {
    this.errors.remove(this.possibleErrors.ERROR_EMPTY_USER_SELECTION);
    this.updateUI();
};

ReportEditConfigController.prototype.getErrorMessage = function (error) {
    switch (error) {
        case this.possibleErrors.ERROR_EMPTY_CP_SELECTION:
            return _messageResource2.default.getEscapedMessage("projects_customers_selector.please_select_customer_or_project");
        case this.possibleErrors.ERROR_EMPTY_USER_SELECTION:
            return _messageResource2.default.getMessage("report.js.choose_person");
        case this.possibleErrors.ERROR_IN_GROUPING_LEVELS_SELECTOR:
            return this.groupingSelector.getErrorMessage();
        case this.possibleErrors.ERROR_EMPTY_LEAVE_TYPES_SELECTION:
            return _messageResource2.default.getMessage("report.leaves.js.choose_leave_type");
        case this.possibleErrors.ADDITIONAL_ERROR:
            return _messageResource2.default.getMessage(this.additionalErrorMessageKey);
    }
    return "";
};

ReportEditConfigController.prototype.blinkErrorInFooter = function () {
    this.errorMessageEl.addClass("blinkDisabled");
    var self = this;
    window.setTimeout(function () {
        self.errorMessageEl.removeClass("blinkDisabled");
    }, 250);
};

ReportEditConfigController.prototype.configChanged = function () {
    if (this.configChangedCallback) this.configChangedCallback();
};

/**
 * Disable time format selector (and set decimal format) when configuration for CSV
 * Enable time format selector with previous value on HTML configuration
 * @param isCSV true - on CSV , false - on HTML
 */
ReportEditConfigController.prototype.switchTimeFormatBetweenCSVAndHTML = function (isCSV) {
    if (this.timeFormatSelector) {
        var timeFormatSelector = this.timeFormatSelector;
        if (isCSV) {
            // if previous value has already been set, it means we are on csv preview tab now,
            // so we must not update previous value again, because we will spoil it
            if (!timeFormatSelector.previousValue) timeFormatSelector.previousValue = timeFormatSelector.getValue();
            timeFormatSelector.setActiveItemByValue(_constants2.TimeFormat.DECIMAL, true);
            timeFormatSelector.disable();
        } else {
            if (timeFormatSelector.previousValue) {
                timeFormatSelector.setActiveItemByValue(timeFormatSelector.previousValue, true);
                // delete previous value after it has been used in order not to get back to it anymore
                timeFormatSelector.previousValue = undefined;
            }
            timeFormatSelector.enable();
        }
    }
};

/**
 * Change grouping selection depending on actual features and right
 * If top level value is not available that all under levels will be shifted to top
 * @param notAvailableLevel - level that now not available
 * @param groupings - levels where can be a not available level
 * @param defaultValueForFirstGrouping - default value for first level (set only all levels are NONE)
 * @returns {*}
 */
ReportEditConfigController.prototype.makeGroupingSelectorValuesAccordingToNotAvailableValueLevel = function (notAvailableLevel, groupings, defaultValueForFirstGrouping) {
    for (var i = 0; i < groupings.length; i++) {
        if (groupings[i] === notAvailableLevel) {
            for (var j = i; j < groupings.length - 1; ++j) {
                groupings[j] = groupings[j + 1];
            }
            groupings[groupings.length - 1] = _constants.ReportGroupingLevel.NONE;
        }
    }
    if (defaultValueForFirstGrouping && groupings[0] === _constants.ReportGroupingLevel.NONE) {
        groupings[0] = defaultValueForFirstGrouping;
    }
    return groupings;
};

ReportEditConfigController.prototype.setAdditionalError = function (messageKey) {
    this.errors.push(this.possibleErrors.ADDITIONAL_ERROR);
    this.additionalErrorMessageKey = messageKey;
};
ReportEditConfigController.prototype.removeAdditionalError = function () {
    this.errors.remove(this.possibleErrors.ADDITIONAL_ERROR);
    this.additionalErrorMessageKey = "";
    this.updateUI();
};

/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _ReportEditConfigController = __webpack_require__(593);

var _ReportEditConfigController2 = _interopRequireDefault(_ReportEditConfigController);

var _constants = __webpack_require__(11);

var _LeavesGroupingSelector = __webpack_require__(2021);

var _LeavesGroupingSelector2 = _interopRequireDefault(_LeavesGroupingSelector);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _LeaveReportConfig = __webpack_require__(129);

var _LeaveReportColumnsFormatSelector = __webpack_require__(965);

var _LeaveReportColumnsFormatSelector2 = _interopRequireDefault(_LeaveReportColumnsFormatSelector);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _LeaveTypesSelectorButton = __webpack_require__(512);

var _LeaveTypesSelectorButton2 = _interopRequireDefault(_LeaveTypesSelectorButton);

var _UserNameFormat = __webpack_require__(17);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LeavesReportEditConfigController = function (_ReportEditConfigCont) {
    _inherits(LeavesReportEditConfigController, _ReportEditConfigCont);

    function LeavesReportEditConfigController() {
        _classCallCheck(this, LeavesReportEditConfigController);

        return _possibleConstructorReturn(this, (LeavesReportEditConfigController.__proto__ || Object.getPrototypeOf(LeavesReportEditConfigController)).apply(this, arguments));
    }

    return LeavesReportEditConfigController;
}(_ReportEditConfigController2.default);

exports.default = LeavesReportEditConfigController;


LeavesReportEditConfigController.prototype.init = function (config) {
    _ReportEditConfigController2.default.prototype.init.call(this, config);

    var self = this;
    var reportParameters = this.makeReportParamsAccordingToFeatures(config.reportParameters);
    this.reportAuthorizationInfo = config.reportAuthorizationInfo;

    this.configChangedCallback = config.changeCallback;
    var configChanged = function configChanged() {
        self.configChanged();
    };
    this.timeFormatSelector = this.initTimeFormatSelector(reportParameters.timeFormat, configChanged);

    var groupingLevelsSelection = [reportParameters.firstGroupingLevel, reportParameters.secondGroupingLevel];
    this.groupingSelector = new _LeavesGroupingSelector2.default().init("reportGroupingSelector", groupingLevelsSelection, this.productSettingsValidator.isUGREnabled() || this.checkGroupingLevel(_constants.ReportGroupingLevel.USER_GROUP, groupingLevelsSelection), this.productSettingsValidator.isTZGEnabled() || this.checkGroupingLevel(_constants.ReportGroupingLevel.TIME_ZONE_GROUP, groupingLevelsSelection), function () {
        self.removeGroupingLevelsSelectionError();
        configChanged();
    });

    this.initLeavesSelector(reportParameters.leaveTypeSelection, config.leavesData, configChanged);

    // if feature enabled and user has rights otherwise only if data is not "LeaveTimeOnly" - show selector
    this.columnsDisplayFormat = this.addColumnFormatFilter({
        columnsConfig: reportParameters.columnsConfig,
        balanceQualifier: reportParameters.balanceQualifier,
        onChangeCallback: configChanged,
        reportAuthorizationInfo: config.reportAuthorizationInfo
    });

    config.additionalCheckboxLabel = _messageResource2.default.getMessage("users_selector.reports.include_users_wo_data");

    var $usernameLabel = (0, _jquery2.default)('.usernameLabel');
    $usernameLabel.toggle(!this.reportAuthorizationInfo.anyOtherUsersAvailable);

    if (this.reportAuthorizationInfo.anyOtherUsersAvailable) {
        this.userSelector = this.makeUserSelector(_extends({}, config, {
            allUsersAvailable: this.reportAuthorizationInfo.allUsersAvailable
        }));
    } else {
        (0, _jquery2.default)('#userSelectorId').hide();
        var user = config.users[0];
        var usernameFormatted = (0, _UserNameFormat.formatLFM)(user.firstName, user.lastName, user.middleName, ", ");
        $usernameLabel.text(usernameFormatted);
    }

    return this;
};

/**
 * add column format filter if need
 * @param columnsConfig - leave tyime only or balance + leave time or both
 * @param balanceQualifier - for type of balance sdb or pto or both
 * @param onChangeCallback
 * @param reportAuthorizationInfo - LeavesReportAuthorizationInfo
 * @returns {{getValue, setActiveItemByValue}}
 */
LeavesReportEditConfigController.prototype.addColumnFormatFilter = function (_ref) {
    var columnsConfig = _ref.columnsConfig,
        balanceQualifier = _ref.balanceQualifier,
        onChangeCallback = _ref.onChangeCallback,
        reportAuthorizationInfo = _ref.reportAuthorizationInfo;


    var enabledPTO = this.productSettingsValidator.isPTOEnabled() && reportAuthorizationInfo.ptoBalancesAvailable;
    var enabledSick = this.productSettingsValidator.isSickEnabled() && reportAuthorizationInfo.sickDaysBalancesAvailable;

    var ifNeedColumnFormatSelector = enabledPTO || enabledSick;
    var selectorRow = (0, _jquery2.default)("#columnsFormatFilterRow");

    if (ifNeedColumnFormatSelector) {
        var initValue = {
            columnsConfig: columnsConfig,
            balanceQualifier: balanceQualifier
        };
        selectorRow.show();
        return new _LeaveReportColumnsFormatSelector2.default().init("columnsDisplayFormat", initValue, onChangeCallback, enabledPTO, enabledSick);
    } else {
        var _initValue = {
            columnsConfig: _LeaveReportConfig.LeaveTypeColumnConfig.LEAVE_TIME_ONLY,
            balanceQualifier: balanceQualifier
        };
        selectorRow.hide();
        return this.initEmptyListSelector(_initValue);
    }
};

LeavesReportEditConfigController.prototype.initLeavesSelector = function (leavesSelection, leavesData, changeCallback) {
    var self = this;
    var leavesSelectorChangesCallback = function leavesSelectorChangesCallback() {
        if (!self.leavesSelector.isEmptySelection()) self.errors.remove(self.possibleErrors.ERROR_EMPTY_LEAVE_TYPES_SELECTION);
        self.updateUI();
        if (changeCallback) changeCallback();
    };
    this.leavesSelector = new _LeaveTypesSelectorButton2.default().init({
        renderTo: "leavesButton",
        leavesSelection: leavesSelection,
        leavesData: leavesData,
        ptoFeatureEnabled: this.productSettingsValidator.isPTOEnabled(),
        sickBalanceFeatureEnabled: this.productSettingsValidator.isSickEnabled(),
        showInactiveCheckbox: true,
        changeCallback: leavesSelectorChangesCallback
    });
};

LeavesReportEditConfigController.prototype.getConfig = function () {
    var groupingLevelValues = this.groupingSelector.getValues();
    var columnsDisplayFormatValue = this.columnsDisplayFormat.getValue();
    return {
        timeFormat: this.timeFormatSelector.getValue(),
        leaveTypeSelection: this.leavesSelector.getLeaveTypeSelection(),
        columnsConfig: columnsDisplayFormatValue.columnsConfig,
        balanceQualifier: columnsDisplayFormatValue.balanceQualifier,
        userSelection: this.reportAuthorizationInfo.anyOtherUsersAvailable ? this.userSelector.getSelection() : this.initReportParameters.userSelection,
        firstGroupingLevel: groupingLevelValues[0],
        secondGroupingLevel: groupingLevelValues[1]
    };
};

LeavesReportEditConfigController.prototype.resetConfig = function () {
    this.timeFormatSelector.setActiveItemByValue(this.initReportParameters.timeFormat, true);
    this.columnsDisplayFormat.setActiveItemByValue({
        columnsConfig: this.initReportParameters.columnsConfig,
        balanceQualifier: this.initReportParameters.balanceQualifier
    }, true);
    this.groupingSelector.setValues([this.initReportParameters.firstGroupingLevel, this.initReportParameters.secondGroupingLevel]);
    this.leavesSelector.resetLeavesSelectionFunction();

    if (this.reportAuthorizationInfo.anyOtherUsersAvailable) this.userSelector.setSelection(this.initReportParameters.userSelection);
};

LeavesReportEditConfigController.prototype.setSelectorsInitStateFromCurrent = function () {
    _ReportEditConfigController2.default.prototype.setSelectorsInitStateFromCurrent.call(this);

    if (this.reportAuthorizationInfo.anyOtherUsersAvailable) {
        this.userSelector.setInitialValueFromCurrent();
    }
    if (this.leavesSelector) {
        this.leavesSelector.setInitialValuesFromCurrent();
    }
};

LeavesReportEditConfigController.prototype.validate = function () {
    this.errors = [];

    if (this.leavesSelector.isEmptySelection()) this.errors.push(this.possibleErrors.ERROR_EMPTY_LEAVE_TYPES_SELECTION);

    if (this.reportAuthorizationInfo.anyOtherUsersAvailable && !this.userSelector.validateIsUserSelected()) this.errors.push(this.possibleErrors.ERROR_EMPTY_USER_SELECTION);

    if (!this.groupingSelector.validate()) this.errors.push(this.possibleErrors.ERROR_IN_GROUPING_LEVELS_SELECTOR);

    return this.errors.length === 0;
};

LeavesReportEditConfigController.prototype.initErrorsToSectionElsMap = function () {
    var errorsToSectionElsMap = {};
    errorsToSectionElsMap[this.possibleErrors.ERROR_EMPTY_USER_SELECTION] = this.panelEl.find("#userSelectorId");
    errorsToSectionElsMap[this.possibleErrors.ERROR_EMPTY_LEAVE_TYPES_SELECTION] = this.panelEl.find("#leavesButton");
    errorsToSectionElsMap[this.possibleErrors.ERROR_IN_GROUPING_LEVELS_SELECTOR] = this.panelEl.find(".reportGroupingSelectorContainer");
    return errorsToSectionElsMap;
};

LeavesReportEditConfigController.prototype.makeReportParamsAccordingToFeatures = function (reportParameters) {
    return reportParameters;
};

/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = LeaveHTMLPreviewBaseColumnsStrategy;

var _HTMLColumnsStrategy = __webpack_require__(270);

var _HTMLColumnsStrategy2 = _interopRequireDefault(_HTMLColumnsStrategy);

var _LeaveReportConfig = __webpack_require__(129);

var _LeaveHTMLPreviewBothBalanceColumnsRender = __webpack_require__(2024);

var _LeaveHTMLPreviewBothBalanceColumnsRender2 = _interopRequireDefault(_LeaveHTMLPreviewBothBalanceColumnsRender);

var _LeaveHTMLPreviewSickDaysOnlyBalanceColumnsRender = __webpack_require__(2025);

var _LeaveHTMLPreviewSickDaysOnlyBalanceColumnsRender2 = _interopRequireDefault(_LeaveHTMLPreviewSickDaysOnlyBalanceColumnsRender);

var _LeaveHTMLPreviewPTOOnlyBalanceColumnsRender = __webpack_require__(2026);

var _LeaveHTMLPreviewPTOOnlyBalanceColumnsRender2 = _interopRequireDefault(_LeaveHTMLPreviewPTOOnlyBalanceColumnsRender);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function LeaveHTMLPreviewBaseColumnsStrategy() {} /**
                                                   * Created by filatov on 16.09.2015.
                                                   */


LeaveHTMLPreviewBaseColumnsStrategy.prototype = new _HTMLColumnsStrategy2.default();

LeaveHTMLPreviewBaseColumnsStrategy.prototype.init = function (timeFormat) {
    _HTMLColumnsStrategy2.default.prototype.init.call(this, timeFormat);
    return this;
};

LeaveHTMLPreviewBaseColumnsStrategy.prototype.addFirstHeaderRowCells = function (firstHeaderRow) {
    // abstract
};

LeaveHTMLPreviewBaseColumnsStrategy.prototype.addSecondHeaderRowCells = function (secondHeaderRow) {
    // abstract
};

LeaveHTMLPreviewBaseColumnsStrategy.prototype.addDataCells = function (row) {
    //abstract
};

LeaveHTMLPreviewBaseColumnsStrategy.prototype.getStrategyCssClass = function () {
    //abstract
};

LeaveHTMLPreviewBaseColumnsStrategy.prototype.createLeaveHeaderCell = function () {
    return ReportPreviewUtils.createCell(this.message("report.common.leave_type"), "leaveType", 1, 2);
};

LeaveHTMLPreviewBaseColumnsStrategy.prototype.createTotalLeaveTimeCell = function () {
    return ReportPreviewUtils.createCell(this.message("report.leaves.total.html_csv"), "leaveTypeTotal", 1, 2);
};

LeaveHTMLPreviewBaseColumnsStrategy.prototype._initBalanceColumnsRenderConstructor = function (balanceQualifier, withSpaces) {
    switch (balanceQualifier) {
        case _LeaveReportConfig.LeaveTypeBalanceQualifier.SICK_DAYS_ONLY:
            return new _LeaveHTMLPreviewSickDaysOnlyBalanceColumnsRender2.default(withSpaces);
        case _LeaveReportConfig.LeaveTypeBalanceQualifier.PTO_ONLY:
            return new _LeaveHTMLPreviewPTOOnlyBalanceColumnsRender2.default(withSpaces);
        default:
            return new _LeaveHTMLPreviewBothBalanceColumnsRender2.default(withSpaces);
    }
};

/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var LeaveHTMLPreviewBalanceColumnsRender = function LeaveHTMLPreviewBalanceColumnsRender(withSpaces) {
    var _this = this;

    _classCallCheck(this, LeaveHTMLPreviewBalanceColumnsRender);

    this.addHeaderFirstRowCells = function (fRow) {
        //abstract
    };

    this.addHeaderSecondRowCells = function (sRow) {
        //abstract
    };

    this.addValueCells = function (row) {
        //abstract
    };

    this.getRenderSpecificCssClass = function () {
        //abstract
    };

    this._addPTOFRowCells = function (row) {
        ReportPreviewUtils.addCreatedCell(row, _this._getBalanceTypeCell("report.leaves.pto_column.preview.html.pto_balance"));
    };

    this._addSickDaysFRowCells = function (row) {
        ReportPreviewUtils.addCreatedCell(row, _this._getBalanceTypeCell("report.leaves.pto_column.preview.html.sick_days_balance"));
    };

    this._addRangeSRowCells = function (inHours, row) {
        ReportPreviewUtils.addCreatedCell(row, _this._getRangeCell(inHours, "report.leaves.pto_column.preview.html.beginning"));
        ReportPreviewUtils.addCreatedCell(row, _this._getRangeCell(inHours, "report.leaves.pto_column.preview.html.ending"));
    };

    this._getBalanceTypeCell = function (textKey) {
        return ReportPreviewUtils.createCell(_messageResource2.default.getMessage(textKey), "balanceCell", 2, 1);
    };

    this._getRangeCell = function (inHours, textKey) {
        return ReportPreviewUtils.createCell(_messageResource2.default.getMessage(textKey, [_this._getHoursOrDays(inHours)]), "balanceRangeCell");
    };

    this._getHoursOrDays = function (inHours) {
        if (inHours) {
            return _messageResource2.default.getMessage("common.pto_units.hours");
        }
        return _messageResource2.default.getMessage("common.pto_units.days");
    };

    this._addBalanceValueCell = function (row) {
        ReportPreviewUtils.addCreatedCell(row, ReportPreviewUtils.createCell("12" + SystemSettings.decimalSeparator + "345", "balanceValueCell"));
    };

    this._addEmptyCellIfNeed = function (row) {
        if (_this.withSpaces) {
            ReportPreviewUtils.addCell(row, "", "emptyCell");
        }
    };

    this.withSpaces = withSpaces;
    this.showSickInHours = SystemSettings.showSickInHours;
    this.showPTOInHours = SystemSettings.showPTOInHours;
    return this;
};

exports.default = LeaveHTMLPreviewBalanceColumnsRender;

/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = LeaveCSVPreviewColumnsStrategy;

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function LeaveCSVPreviewColumnsStrategy() {}

LeaveCSVPreviewColumnsStrategy.prototype.init = function () {
    return this;
};

LeaveCSVPreviewColumnsStrategy.prototype.getNumOfDataColumns = function () {
    // abstract
};

LeaveCSVPreviewColumnsStrategy.prototype.addMainHeaderRowCells = function (mainHeaderRow) {
    // abstract
};

LeaveCSVPreviewColumnsStrategy.prototype.addDataCells = function (row) {
    for (var i = 0; i < this.getNumOfDataColumns(); i++) {
        ReportPreviewUtils.addCSVTimeValueCell(row);
    }
};

LeaveCSVPreviewColumnsStrategy.prototype.addLeaveTypeCells = function (row, numOfCells) {
    for (var i = 0; i < numOfCells; i++) {
        this.addLeaveTypeCell(row);
    }
};

LeaveCSVPreviewColumnsStrategy.prototype.addLeaveTypeCell = function (row) {
    ReportPreviewUtils.addCell(row, _messageResource2.default.getMessage("report.common.leave_type"));
};

LeaveCSVPreviewColumnsStrategy.prototype.addLeaveTypeTotalCell = function (row) {
    ReportPreviewUtils.addCell(row, _messageResource2.default.getMessage("report.leaves.total.html_csv"));
};

/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = StaffPerformanceHTMLPreviewBaseColumnsStrategy;

var _HTMLColumnsStrategy = __webpack_require__(270);

var _HTMLColumnsStrategy2 = _interopRequireDefault(_HTMLColumnsStrategy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function StaffPerformanceHTMLPreviewBaseColumnsStrategy() {}

StaffPerformanceHTMLPreviewBaseColumnsStrategy.prototype = new _HTMLColumnsStrategy2.default();

StaffPerformanceHTMLPreviewBaseColumnsStrategy.prototype.init = function (timeFormat, groupNameProvider) {
    _HTMLColumnsStrategy2.default.prototype.init.call(this, timeFormat);
    this.groupNameProvider = groupNameProvider;
    return this;
};

StaffPerformanceHTMLPreviewBaseColumnsStrategy.prototype.addFirstHeaderRowCells = function (firstHeaderRow) {
    // abstract
};

StaffPerformanceHTMLPreviewBaseColumnsStrategy.prototype.addSecondHeaderRowCells = function (secondHeaderRow) {
    // abstract
};

StaffPerformanceHTMLPreviewBaseColumnsStrategy.prototype.addDataCells = function (row) {
    this.addTimeValueCell(row, "spent");
    this.addTimeValueCell(row);
    this.addTimeValueCell(row);
};

StaffPerformanceHTMLPreviewBaseColumnsStrategy.prototype.createUserHeaderCell = function (rowSpan) {
    return ReportPreviewUtils.createCell(this.message("report.common.user"), "user", 1, rowSpan);
};

StaffPerformanceHTMLPreviewBaseColumnsStrategy.prototype.createSpentHeaderCell = function () {
    return ReportPreviewUtils.createCell(this.message("report.staffoutput.overall_spent"), "spent", 1, 2);
};

StaffPerformanceHTMLPreviewBaseColumnsStrategy.prototype.getGroupNameSingular = function () {
    return this.message(this.groupNameProvider.getGroupNameSingularKey());
};

/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = StaffPerformanceHTMLPreviewBaseSection;

var _PreviewSection = __webpack_require__(67);

var _PreviewSection2 = _interopRequireDefault(_PreviewSection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function StaffPerformanceHTMLPreviewBaseSection() {}

StaffPerformanceHTMLPreviewBaseSection.prototype = new _PreviewSection2.default();

StaffPerformanceHTMLPreviewBaseSection.prototype.init = function (columnsStrategy) {
    this.columnsStrategy = columnsStrategy;
    return this;
};

StaffPerformanceHTMLPreviewBaseSection.prototype.createRowWithMainAndDataCells = function (rowClassName, mainCellInnerHtml, mainCellClassName) {
    var row = this.createRow(rowClassName);
    this.addCell(row, mainCellInnerHtml, mainCellClassName);
    this.columnsStrategy.addDataCells(row);
    return row;
};

/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = StaffPerformanceCSVPreviewOnlyGroupsColumnsStrategy;

var _StaffPerformanceCSVPreviewBaseColumnsStrategy = __webpack_require__(412);

var _StaffPerformanceCSVPreviewBaseColumnsStrategy2 = _interopRequireDefault(_StaffPerformanceCSVPreviewBaseColumnsStrategy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function StaffPerformanceCSVPreviewOnlyGroupsColumnsStrategy() {}

StaffPerformanceCSVPreviewOnlyGroupsColumnsStrategy.prototype = Object.create(_StaffPerformanceCSVPreviewBaseColumnsStrategy2.default.prototype);

StaffPerformanceCSVPreviewOnlyGroupsColumnsStrategy.prototype.init = function (includeOtherUsersColumn, groupMessageProvider) {
    _StaffPerformanceCSVPreviewBaseColumnsStrategy2.default.prototype.init.call(this, includeOtherUsersColumn);
    this.groupMessageProvider = groupMessageProvider;
    return this;
};

StaffPerformanceCSVPreviewOnlyGroupsColumnsStrategy.prototype.addMainHeaderRowCells = function (mainHeaderRow) {
    _StaffPerformanceCSVPreviewBaseColumnsStrategy2.default.prototype.addMainHeaderRowCells.call(this, mainHeaderRow);

    var colTitle = this.message(this.groupMessageProvider.getGroupNameSingularKey());

    this.addCell(mainHeaderRow, colTitle);
    this.addCell(mainHeaderRow, colTitle);
    if (this.includeOtherUsersColumn) this.addCell(mainHeaderRow, this.message("report.common.others"));
};

StaffPerformanceCSVPreviewOnlyGroupsColumnsStrategy.prototype.addColumnGropingHeaderRowCells = function (colGroupingRow) {
    //do nothing
};

StaffPerformanceCSVPreviewOnlyGroupsColumnsStrategy.prototype.getNumOfDataColumns = function () {
    return this.includeOtherUsersColumn ? 4 : 3;
};

/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = CostHTMLPreviewBaseSection;

var _PreviewSection = __webpack_require__(67);

var _PreviewSection2 = _interopRequireDefault(_PreviewSection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CostHTMLPreviewBaseSection() {}

CostHTMLPreviewBaseSection.prototype = new _PreviewSection2.default();

CostHTMLPreviewBaseSection.prototype.init = function (columnsStrategy) {
    _PreviewSection2.default.prototype.init.call(this);
    this.columnsStrategy = columnsStrategy;
    return this;
};

CostHTMLPreviewBaseSection.prototype.addRowWithMainCell = function (tBody, mainCellText, mainCellClass, rowClass) {
    var row = this.createRow(rowClass);
    this.addCell(row, mainCellText, mainCellClass);
    this.columnsStrategy.addDataCells(row);
    this.addRow(tBody, row);
};

/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _constants = __webpack_require__(11);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var BillingSummaryCSVPreviewUtils = function BillingSummaryCSVPreviewUtils() {
    _classCallCheck(this, BillingSummaryCSVPreviewUtils);
};

BillingSummaryCSVPreviewUtils.addGroupingLevelsCells = function (row, firstGroupingLevel, secondGroupingLevel, thirdGroupingLevel, useEmptyCommentsCell, needOthers) {
    if (firstGroupingLevel !== _constants.ReportGroupingLevel.NONE) {
        var levelPreviewName = void 0;
        if (firstGroupingLevel === _constants.ReportGroupingLevel.USER && needOthers) {
            levelPreviewName = _messageResource2.default.getMessage("report.common.others");
        } else {
            levelPreviewName = ReportPreviewUtils.getLevelPreviewName(firstGroupingLevel);
        }
        ReportPreviewUtils.addCell(row, levelPreviewName);
    }
    if (secondGroupingLevel !== _constants.ReportGroupingLevel.NONE) {
        var _levelPreviewName = void 0;
        if (secondGroupingLevel === _constants.ReportGroupingLevel.USER && needOthers) {
            _levelPreviewName = _messageResource2.default.getMessage("report.common.others");
        } else {
            _levelPreviewName = ReportPreviewUtils.getLevelPreviewName(secondGroupingLevel);
        }
        ReportPreviewUtils.addCell(row, _levelPreviewName);
    }
    if (thirdGroupingLevel !== _constants.ReportGroupingLevel.NONE) {
        if (thirdGroupingLevel === _constants.ReportGroupingLevel.TASK_AND_TT_COMMENTS || thirdGroupingLevel === _constants.ReportGroupingLevel.PROJECT_AND_TT_COMMENTS || thirdGroupingLevel === _constants.ReportGroupingLevel.CUSTOMER_AND_TT_COMMENTS) {
            if (thirdGroupingLevel === _constants.ReportGroupingLevel.TASK_AND_TT_COMMENTS) ReportPreviewUtils.addCell(row, ReportPreviewUtils.getLevelPreviewName(_constants.ReportGroupingLevel.TASK));
            if (thirdGroupingLevel === _constants.ReportGroupingLevel.PROJECT_AND_TT_COMMENTS) ReportPreviewUtils.addCell(row, ReportPreviewUtils.getLevelPreviewName(_constants.ReportGroupingLevel.PROJECT));
            if (thirdGroupingLevel === _constants.ReportGroupingLevel.CUSTOMER_AND_TT_COMMENTS) ReportPreviewUtils.addCell(row, ReportPreviewUtils.getLevelPreviewName(_constants.ReportGroupingLevel.CUSTOMER));
            ReportPreviewUtils.addCell(row, useEmptyCommentsCell ? "" : ReportPreviewUtils.getLevelPreviewName(_constants.ReportGroupingLevel.TT_COMMENTS));
        } else {
            ReportPreviewUtils.addCell(row, ReportPreviewUtils.getLevelPreviewName(thirdGroupingLevel));
        }
    }
};

BillingSummaryCSVPreviewUtils.getNumberOfGroupingLevelsCells = function (firstGroupingLevel, secondGroupingLevel, thirdGroupingLevel) {
    var numberOfGroupingLevelsCells = ReportPreviewUtils.countNotEmptyLevels([firstGroupingLevel, secondGroupingLevel, thirdGroupingLevel]);
    if (thirdGroupingLevel === _constants.ReportGroupingLevel.TASK_AND_TT_COMMENTS || thirdGroupingLevel === _constants.ReportGroupingLevel.PROJECT_AND_TT_COMMENTS || thirdGroupingLevel === _constants.ReportGroupingLevel.CUSTOMER_AND_TT_COMMENTS) {
        numberOfGroupingLevelsCells++;
    }
    return numberOfGroupingLevelsCells;
};

exports.default = BillingSummaryCSVPreviewUtils;

/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = DisplayedDataSelector;

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _constants = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Created by filatov on 19.08.2015.
 */
function DisplayedDataSelector() {}

DisplayedDataSelector.prototype.init = function (selectorId, billingSummaryReportInfo, configChanged) {
    this.initialBillingSummaryReportInfo = billingSummaryReportInfo;
    this.isNeedBillingTimeSelector = EnabledFeatures.BRA || this.isBillingTimeSelectorOption(this.initialBillingSummaryReportInfo);
    if (this.isNeedBillingTimeSelector) {
        this.billingStatusFilter = new AT.DropdownListButton({
            applyTo: selectorId,
            menuCls: "billingStatusFilterMenu",
            cls: "billingStatusFilterButton"
        });
        this.billingStatusFilter.setDefaultValue(this.billingStatusFilter.getValue());
        var selectShowTimeRadio = function selectShowTimeRadio() {
            document.getElementById('radio_show_time').checked = true;
        };
        this.billingStatusFilter.on("click", function () {
            selectShowTimeRadio();configChanged();
        });
        this.billingStatusFilter.on("change", selectShowTimeRadio);
        this.checkbox_show_average_rates = (0, _jquery2.default)("#checkbox_show_average_rates");
        this.checkbox_radio_show_time = (0, _jquery2.default)("#radio_show_time");

        (0, _jquery2.default)("#billingTimeSelector_showTime").show();
        (0, _jquery2.default)("#billingTimeSelector_billableAmount").show();
        (0, _jquery2.default)("#billingTimeSelector_timeAndAmount").show();
        (0, _jquery2.default)("#billingTimeSelector_rates").show();

        if (configChanged) {
            this.billingStatusFilter.on("change", configChanged);
            this.checkbox_show_average_rates.on("click", configChanged);
            this.checkbox_radio_show_time.on("change", configChanged);
        }
    } else {
        (0, _jquery2.default)("#billingTimeSelector_billable").show();
        (0, _jquery2.default)("#billingTimeSelector_nonBillable").show();
        (0, _jquery2.default)("#billingTimeSelector_anyStatus").show();
    }

    if (configChanged) (0, _jquery2.default)("input[type='radio'][name='infoToShow']").on("change", configChanged);

    this.setValue(this.initialBillingSummaryReportInfo);
    return this;
};

DisplayedDataSelector.prototype.isBillingTimeSelectorOption = function (reportInfo) {
    return reportInfo == _constants.BillingSummaryReportInfo.BILLABLE_AMOUNT || reportInfo == _constants.BillingSummaryReportInfo.BILLABLE_TIME_AND_BILLABLE_AMOUNT || reportInfo == _constants.BillingSummaryReportInfo.BILLABLE_TIME_AND_BILLABLE_AMOUNT_WITH_AVERAGE_RATES;
};

DisplayedDataSelector.prototype.getValue = function () {
    if (this.isNeedBillingTimeSelector) {
        if (this.checkbox_radio_show_time.attr('checked')) return this.billingStatusFilter.getValue();
        if (this.checkbox_show_average_rates.attr('checked') && (0, _jquery2.default)("#radio_show_time_and_amount").attr('checked')) return this.checkbox_show_average_rates.attr("value");
    }
    return (0, _jquery2.default)("input[type='radio'][name='infoToShow']:checked").val();
};

DisplayedDataSelector.prototype.setValue = function (value) {
    if (!value) {
        this.checkbox_radio_show_time.prop('checked', true);
        return;
    }
    if (this.isNeedBillingTimeSelector) {
        if (value == _constants.BillingSummaryReportInfo.TIME_ON_BILLABLE_TASKS || value == _constants.BillingSummaryReportInfo.TIME_ON_NON_BILLABLE_TASKS || value == _constants.BillingSummaryReportInfo.TIME_ON_BOTH_BILLABLE_AND_NON_BILLABLE_TASKS) {
            this.checkbox_radio_show_time.prop('checked', true);
            this.billingStatusFilter.setActiveItemByValue(value);
            return;
        }
        if (value == _constants.BillingSummaryReportInfo.BILLABLE_TIME_AND_BILLABLE_AMOUNT_WITH_AVERAGE_RATES) {
            (0, _jquery2.default)("#checkbox_show_average_rates").prop('checked', true);
            (0, _jquery2.default)("#radio_show_time_and_amount").prop('checked', true);
            return;
        }
    }
    (0, _jquery2.default)("input[name=infoToShow][value=" + this.initialBillingSummaryReportInfo + "]").prop('checked', true);
};

/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = BSHtmlBaseBillableStrategy;

var _BaseHTMLColumnStrategy = __webpack_require__(215);

var _BaseHTMLColumnStrategy2 = _interopRequireDefault(_BaseHTMLColumnStrategy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function BSHtmlBaseBillableStrategy() {}

BSHtmlBaseBillableStrategy.prototype = new _BaseHTMLColumnStrategy2.default();

BSHtmlBaseBillableStrategy.prototype.getLevelsNumber = function () {
    return 1;
};

BSHtmlBaseBillableStrategy.prototype.addSecondHeaderRowCells = function (row, levelsNumber) {
    // do nothing
};

/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(111);
var defined = __webpack_require__(151);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(47) && !__webpack_require__(32)(function () {
  return Object.defineProperty(__webpack_require__(419)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(175);
var descriptor = __webpack_require__(173);
var setToStringTag = __webpack_require__(217);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(87)(IteratorPrototype, __webpack_require__(41)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(46);
var anObject = __webpack_require__(38);
var getKeys = __webpack_require__(176);

module.exports = __webpack_require__(47) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(75);
var toIObject = __webpack_require__(89);
var arrayIndexOf = __webpack_require__(326)(false);
var IE_PROTO = __webpack_require__(420)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(38);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

var aFunction = __webpack_require__(88);
var toObject = __webpack_require__(58);
var IObject = __webpack_require__(273);
var toLength = __webpack_require__(54);

module.exports = function (that, callbackfn, aLen, memo, isRight) {
  aFunction(callbackfn);
  var O = toObject(that);
  var self = IObject(O);
  var length = toLength(O.length);
  var index = isRight ? length - 1 : 0;
  var i = isRight ? -1 : 1;
  if (aLen < 2) for (;;) {
    if (index in self) {
      memo = self[index];
      index += i;
      break;
    }
    index += i;
    if (isRight ? index < 0 : length <= index) {
      throw TypeError('Reduce of empty array with no initial value');
    }
  }
  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
    memo = callbackfn(memo, self[index], index, O);
  }
  return memo;
};


/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)

var toObject = __webpack_require__(58);
var toAbsoluteIndex = __webpack_require__(177);
var toLength = __webpack_require__(54);

module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
  var O = toObject(this);
  var len = toLength(O.length);
  var to = toAbsoluteIndex(target, len);
  var from = toAbsoluteIndex(start, len);
  var end = arguments.length > 2 ? arguments[2] : undefined;
  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
  var inc = 1;
  if (from < to && to < from + count) {
    inc = -1;
    from += count - 1;
    to += count - 1;
  }
  while (count-- > 0) {
    if (from in O) O[to] = O[from];
    else delete O[to];
    to += inc;
    from += inc;
  } return O;
};


/***/ }),
/* 613 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__(38);
var toPrimitive = __webpack_require__(131);
var NUMBER = 'number';

module.exports = function (hint) {
  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
  return toPrimitive(anObject(this), hint != NUMBER);
};


/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aFunction = __webpack_require__(88);
var isObject = __webpack_require__(31);
var invoke = __webpack_require__(616);
var arraySlice = [].slice;
var factories = {};

var construct = function (F, len, args) {
  if (!(len in factories)) {
    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
    // eslint-disable-next-line no-new-func
    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
  } return factories[len](F, args);
};

module.exports = Function.bind || function bind(that /* , ...args */) {
  var fn = aFunction(this);
  var partArgs = arraySlice.call(arguments, 1);
  var bound = function (/* args... */) {
    var args = partArgs.concat(arraySlice.call(arguments));
    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
  };
  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
  return bound;
};


/***/ }),
/* 616 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__(46).f;
var create = __webpack_require__(175);
var redefineAll = __webpack_require__(219);
var ctx = __webpack_require__(112);
var anInstance = __webpack_require__(220);
var forOf = __webpack_require__(332);
var $iterDefine = __webpack_require__(418);
var step = __webpack_require__(613);
var setSpecies = __webpack_require__(218);
var DESCRIPTORS = __webpack_require__(47);
var fastKey = __webpack_require__(154).fastKey;
var validate = __webpack_require__(221);
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),
/* 618 */
/***/ (function(module, exports) {

// 20.2.2.20 Math.log1p(x)
module.exports = Math.log1p || function log1p(x) {
  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
};


/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

var cof = __webpack_require__(132);
module.exports = function (it, msg) {
  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
  return +it;
};


/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toInteger = __webpack_require__(111);
var defined = __webpack_require__(151);

module.exports = function repeat(count) {
  var str = String(defined(this));
  var res = '';
  var n = toInteger(count);
  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
  return res;
};


/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var isObject = __webpack_require__(31);
var floor = Math.floor;
module.exports = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};


/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

var $parseFloat = __webpack_require__(35).parseFloat;
var $trim = __webpack_require__(334).trim;

module.exports = 1 / $parseFloat(__webpack_require__(433) + '-0') !== -Infinity ? function parseFloat(str) {
  var string = $trim(String(str), 3);
  var result = $parseFloat(string);
  return result === 0 && string.charAt(0) == '-' ? -0 : result;
} : $parseFloat;


/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

var $parseInt = __webpack_require__(35).parseInt;
var $trim = __webpack_require__(334).trim;
var ws = __webpack_require__(433);
var hex = /^[-+]?0[xX]/;

module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
  var string = $trim(String(str), 3);
  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
} : $parseInt;


/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(35);
var has = __webpack_require__(75);
var DESCRIPTORS = __webpack_require__(47);
var $export = __webpack_require__(10);
var redefine = __webpack_require__(74);
var META = __webpack_require__(154).KEY;
var $fails = __webpack_require__(32);
var shared = __webpack_require__(421);
var setToStringTag = __webpack_require__(217);
var uid = __webpack_require__(174);
var wks = __webpack_require__(41);
var wksExt = __webpack_require__(625);
var wksDefine = __webpack_require__(1072);
var enumKeys = __webpack_require__(1073);
var isArray = __webpack_require__(327);
var anObject = __webpack_require__(38);
var toIObject = __webpack_require__(89);
var toPrimitive = __webpack_require__(131);
var createDesc = __webpack_require__(173);
var _create = __webpack_require__(175);
var gOPNExt = __webpack_require__(626);
var $GOPD = __webpack_require__(90);
var $DP = __webpack_require__(46);
var $keys = __webpack_require__(176);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(178).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(274).f = $propertyIsEnumerable;
  __webpack_require__(335).f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(172)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    if (it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    replacer = args[1];
    if (typeof replacer == 'function') $replacer = replacer;
    if ($replacer || !isArray(replacer)) replacer = function (key, value) {
      if ($replacer) value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(87)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(41);


/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(89);
var gOPN = __webpack_require__(178).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__(176);
var gOPS = __webpack_require__(335);
var pIE = __webpack_require__(274);
var toObject = __webpack_require__(58);
var IObject = __webpack_require__(273);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(32)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(112);
var invoke = __webpack_require__(616);
var html = __webpack_require__(423);
var cel = __webpack_require__(419);
var global = __webpack_require__(35);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(132)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(88);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

// all object keys, includes non-enumerable and symbols
var gOPN = __webpack_require__(178);
var gOPS = __webpack_require__(335);
var anObject = __webpack_require__(38);
var Reflect = __webpack_require__(35).Reflect;
module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
  var keys = gOPN.f(anObject(it));
  var getSymbols = gOPS.f;
  return getSymbols ? keys.concat(getSymbols(it)) : keys;
};


/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

// 21.2.5.3 get RegExp.prototype.flags()
if (__webpack_require__(47) && /./g.flags != 'g') __webpack_require__(46).f(RegExp.prototype, 'flags', {
  configurable: true,
  get: __webpack_require__(436)
});


/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

// @@match logic
__webpack_require__(336)('match', 1, function (defined, MATCH, $match) {
  // 21.1.3.11 String.prototype.match(regexp)
  return [function match(regexp) {
    'use strict';
    var O = defined(this);
    var fn = regexp == undefined ? undefined : regexp[MATCH];
    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
  }, $match];
});


/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

// @@replace logic
__webpack_require__(336)('replace', 2, function (defined, REPLACE, $replace) {
  // 21.1.3.14 String.prototype.replace(searchValue, replaceValue)
  return [function replace(searchValue, replaceValue) {
    'use strict';
    var O = defined(this);
    var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
    return fn !== undefined
      ? fn.call(searchValue, O, replaceValue)
      : $replace.call(String(O), searchValue, replaceValue);
  }, $replace];
});


/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

// @@search logic
__webpack_require__(336)('search', 1, function (defined, SEARCH, $search) {
  // 21.1.3.15 String.prototype.search(regexp)
  return [function search(regexp) {
    'use strict';
    var O = defined(this);
    var fn = regexp == undefined ? undefined : regexp[SEARCH];
    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
  }, $search];
});


/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

// @@split logic
__webpack_require__(336)('split', 2, function (defined, SPLIT, $split) {
  'use strict';
  var isRegExp = __webpack_require__(435);
  var _split = $split;
  var $push = [].push;
  var $SPLIT = 'split';
  var LENGTH = 'length';
  var LAST_INDEX = 'lastIndex';
  if (
    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
    ''[$SPLIT](/.?/)[LENGTH]
  ) {
    var NPCG = /()??/.exec('')[1] === undefined; // nonparticipating capturing group
    // based on es5-shim implementation, need to rework it
    $split = function (separator, limit) {
      var string = String(this);
      if (separator === undefined && limit === 0) return [];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) return _split.call(string, separator, limit);
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      var splitLimit = limit === undefined ? 4294967295 : limit >>> 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var separator2, match, lastIndex, lastLength, i;
      // Doesn't need flags gy, but they don't hurt
      if (!NPCG) separator2 = new RegExp('^' + separatorCopy.source + '$(?!\\s)', flags);
      while (match = separatorCopy.exec(string)) {
        // `separatorCopy.lastIndex` is not reliable cross-browser
        lastIndex = match.index + match[0][LENGTH];
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          // Fix browsers whose `exec` methods don't consistently return `undefined` for NPCG
          // eslint-disable-next-line no-loop-func
          if (!NPCG && match[LENGTH] > 1) match[0].replace(separator2, function () {
            for (i = 1; i < arguments[LENGTH] - 2; i++) if (arguments[i] === undefined) match[i] = undefined;
          });
          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
          lastLength = match[0][LENGTH];
          lastLastIndex = lastIndex;
          if (output[LENGTH] >= splitLimit) break;
        }
        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
      }
      if (lastLastIndex === string[LENGTH]) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
    };
  // Chakra, V8
  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
    $split = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : _split.call(this, separator, limit);
    };
  }
  // 21.1.3.17 String.prototype.split(separator, limit)
  return [function split(separator, limit) {
    var O = defined(this);
    var fn = separator == undefined ? undefined : separator[SPLIT];
    return fn !== undefined ? fn.call(separator, O, limit) : $split.call(String(O), separator, limit);
  }, $split];
});


/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/ecma262/#sec-toindex
var toInteger = __webpack_require__(111);
var toLength = __webpack_require__(54);
module.exports = function (it) {
  if (it === undefined) return 0;
  var number = toInteger(it);
  var length = toLength(number);
  if (number !== length) throw RangeError('Wrong length!');
  return length;
};


/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var redefineAll = __webpack_require__(219);
var getWeak = __webpack_require__(154).getWeak;
var anObject = __webpack_require__(38);
var isObject = __webpack_require__(31);
var anInstance = __webpack_require__(220);
var forOf = __webpack_require__(332);
var createArrayMethod = __webpack_require__(113);
var $has = __webpack_require__(75);
var validate = __webpack_require__(221);
var arrayFind = createArrayMethod(5);
var arrayFindIndex = createArrayMethod(6);
var id = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function (that) {
  return that._l || (that._l = new UncaughtFrozenStore());
};
var UncaughtFrozenStore = function () {
  this.a = [];
};
var findUncaughtFrozen = function (store, key) {
  return arrayFind(store.a, function (it) {
    return it[0] === key;
  });
};
UncaughtFrozenStore.prototype = {
  get: function (key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function (key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function (key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;
    else this.a.push([key, value]);
  },
  'delete': function (key) {
    var index = arrayFindIndex(this.a, function (it) {
      return it[0] === key;
    });
    if (~index) this.a.splice(index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;      // collection type
      that._i = id++;      // collection id
      that._l = undefined; // leak store for uncaught frozen objects
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.3.3.2 WeakMap.prototype.delete(key)
      // 23.4.3.3 WeakSet.prototype.delete(value)
      'delete': function (key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
        return data && $has(data, this._i) && delete data[this._i];
      },
      // 23.3.3.4 WeakMap.prototype.has(key)
      // 23.4.3.4 WeakSet.prototype.has(value)
      has: function has(key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
        return data && $has(data, this._i);
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var data = getWeak(anObject(key), true);
    if (data === true) uncaughtFrozenStore(that).set(key, value);
    else data[that._i] = value;
    return that;
  },
  ufstore: uncaughtFrozenStore
};


/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

var getKeys = __webpack_require__(176);
var toIObject = __webpack_require__(89);
var isEnum = __webpack_require__(274).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) if (isEnum.call(O, key = keys[i++])) {
      result.push(isEntries ? [key, O[key]] : O[key]);
    } return result;
  };
};


/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
var isArray = __webpack_require__(327);
var isObject = __webpack_require__(31);
var toLength = __webpack_require__(54);
var ctx = __webpack_require__(112);
var IS_CONCAT_SPREADABLE = __webpack_require__(41)('isConcatSpreadable');

function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
  var targetIndex = start;
  var sourceIndex = 0;
  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
  var element, spreadable;

  while (sourceIndex < sourceLen) {
    if (sourceIndex in source) {
      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];

      spreadable = false;
      if (isObject(element)) {
        spreadable = element[IS_CONCAT_SPREADABLE];
        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
      }

      if (spreadable && depth > 0) {
        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
      } else {
        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
        target[targetIndex] = element;
      }

      targetIndex++;
    }
    sourceIndex++;
  }
  return targetIndex;
}

module.exports = flattenIntoArray;


/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, global) {var __WEBPACK_AMD_DEFINE_RESULT__;/*! https://mths.be/punycode v1.4.0 by @mathias */
;(function(root) {

	/** Detect free variables */
	var freeExports = typeof exports == 'object' && exports &&
		!exports.nodeType && exports;
	var freeModule = typeof module == 'object' && module &&
		!module.nodeType && module;
	var freeGlobal = typeof global == 'object' && global;
	if (
		freeGlobal.global === freeGlobal ||
		freeGlobal.window === freeGlobal ||
		freeGlobal.self === freeGlobal
	) {
		root = freeGlobal;
	}

	/**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */
	var punycode,

	/** Highest positive signed 32-bit float value */
	maxInt = 2147483647, // aka. 0x7FFFFFFF or 2^31-1

	/** Bootstring parameters */
	base = 36,
	tMin = 1,
	tMax = 26,
	skew = 38,
	damp = 700,
	initialBias = 72,
	initialN = 128, // 0x80
	delimiter = '-', // '\x2D'

	/** Regular expressions */
	regexPunycode = /^xn--/,
	regexNonASCII = /[^\x20-\x7E]/, // unprintable ASCII chars + non-ASCII chars
	regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, // RFC 3490 separators

	/** Error messages */
	errors = {
		'overflow': 'Overflow: input needs wider integers to process',
		'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
		'invalid-input': 'Invalid input'
	},

	/** Convenience shortcuts */
	baseMinusTMin = base - tMin,
	floor = Math.floor,
	stringFromCharCode = String.fromCharCode,

	/** Temporary variable */
	key;

	/*--------------------------------------------------------------------------*/

	/**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */
	function error(type) {
		throw new RangeError(errors[type]);
	}

	/**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */
	function map(array, fn) {
		var length = array.length;
		var result = [];
		while (length--) {
			result[length] = fn(array[length]);
		}
		return result;
	}

	/**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */
	function mapDomain(string, fn) {
		var parts = string.split('@');
		var result = '';
		if (parts.length > 1) {
			// In email addresses, only the domain name should be punycoded. Leave
			// the local part (i.e. everything up to `@`) intact.
			result = parts[0] + '@';
			string = parts[1];
		}
		// Avoid `split(regex)` for IE8 compatibility. See #17.
		string = string.replace(regexSeparators, '\x2E');
		var labels = string.split('.');
		var encoded = map(labels, fn).join('.');
		return result + encoded;
	}

	/**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */
	function ucs2decode(string) {
		var output = [],
		    counter = 0,
		    length = string.length,
		    value,
		    extra;
		while (counter < length) {
			value = string.charCodeAt(counter++);
			if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
				// high surrogate, and there is a next character
				extra = string.charCodeAt(counter++);
				if ((extra & 0xFC00) == 0xDC00) { // low surrogate
					output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
				} else {
					// unmatched surrogate; only append this code unit, in case the next
					// code unit is the high surrogate of a surrogate pair
					output.push(value);
					counter--;
				}
			} else {
				output.push(value);
			}
		}
		return output;
	}

	/**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */
	function ucs2encode(array) {
		return map(array, function(value) {
			var output = '';
			if (value > 0xFFFF) {
				value -= 0x10000;
				output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
				value = 0xDC00 | value & 0x3FF;
			}
			output += stringFromCharCode(value);
			return output;
		}).join('');
	}

	/**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */
	function basicToDigit(codePoint) {
		if (codePoint - 48 < 10) {
			return codePoint - 22;
		}
		if (codePoint - 65 < 26) {
			return codePoint - 65;
		}
		if (codePoint - 97 < 26) {
			return codePoint - 97;
		}
		return base;
	}

	/**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */
	function digitToBasic(digit, flag) {
		//  0..25 map to ASCII a..z or A..Z
		// 26..35 map to ASCII 0..9
		return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
	}

	/**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * https://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */
	function adapt(delta, numPoints, firstTime) {
		var k = 0;
		delta = firstTime ? floor(delta / damp) : delta >> 1;
		delta += floor(delta / numPoints);
		for (/* no initialization */; delta > baseMinusTMin * tMax >> 1; k += base) {
			delta = floor(delta / baseMinusTMin);
		}
		return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
	}

	/**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */
	function decode(input) {
		// Don't use UCS-2
		var output = [],
		    inputLength = input.length,
		    out,
		    i = 0,
		    n = initialN,
		    bias = initialBias,
		    basic,
		    j,
		    index,
		    oldi,
		    w,
		    k,
		    digit,
		    t,
		    /** Cached calculation results */
		    baseMinusT;

		// Handle the basic code points: let `basic` be the number of input code
		// points before the last delimiter, or `0` if there is none, then copy
		// the first basic code points to the output.

		basic = input.lastIndexOf(delimiter);
		if (basic < 0) {
			basic = 0;
		}

		for (j = 0; j < basic; ++j) {
			// if it's not a basic code point
			if (input.charCodeAt(j) >= 0x80) {
				error('not-basic');
			}
			output.push(input.charCodeAt(j));
		}

		// Main decoding loop: start just after the last delimiter if any basic code
		// points were copied; start at the beginning otherwise.

		for (index = basic > 0 ? basic + 1 : 0; index < inputLength; /* no final expression */) {

			// `index` is the index of the next character to be consumed.
			// Decode a generalized variable-length integer into `delta`,
			// which gets added to `i`. The overflow checking is easier
			// if we increase `i` as we go, then subtract off its starting
			// value at the end to obtain `delta`.
			for (oldi = i, w = 1, k = base; /* no condition */; k += base) {

				if (index >= inputLength) {
					error('invalid-input');
				}

				digit = basicToDigit(input.charCodeAt(index++));

				if (digit >= base || digit > floor((maxInt - i) / w)) {
					error('overflow');
				}

				i += digit * w;
				t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);

				if (digit < t) {
					break;
				}

				baseMinusT = base - t;
				if (w > floor(maxInt / baseMinusT)) {
					error('overflow');
				}

				w *= baseMinusT;

			}

			out = output.length + 1;
			bias = adapt(i - oldi, out, oldi == 0);

			// `i` was supposed to wrap around from `out` to `0`,
			// incrementing `n` each time, so we'll fix that now:
			if (floor(i / out) > maxInt - n) {
				error('overflow');
			}

			n += floor(i / out);
			i %= out;

			// Insert `n` at position `i` of the output
			output.splice(i++, 0, n);

		}

		return ucs2encode(output);
	}

	/**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */
	function encode(input) {
		var n,
		    delta,
		    handledCPCount,
		    basicLength,
		    bias,
		    j,
		    m,
		    q,
		    k,
		    t,
		    currentValue,
		    output = [],
		    /** `inputLength` will hold the number of code points in `input`. */
		    inputLength,
		    /** Cached calculation results */
		    handledCPCountPlusOne,
		    baseMinusT,
		    qMinusT;

		// Convert the input in UCS-2 to Unicode
		input = ucs2decode(input);

		// Cache the length
		inputLength = input.length;

		// Initialize the state
		n = initialN;
		delta = 0;
		bias = initialBias;

		// Handle the basic code points
		for (j = 0; j < inputLength; ++j) {
			currentValue = input[j];
			if (currentValue < 0x80) {
				output.push(stringFromCharCode(currentValue));
			}
		}

		handledCPCount = basicLength = output.length;

		// `handledCPCount` is the number of code points that have been handled;
		// `basicLength` is the number of basic code points.

		// Finish the basic string - if it is not empty - with a delimiter
		if (basicLength) {
			output.push(delimiter);
		}

		// Main encoding loop:
		while (handledCPCount < inputLength) {

			// All non-basic code points < n have been handled already. Find the next
			// larger one:
			for (m = maxInt, j = 0; j < inputLength; ++j) {
				currentValue = input[j];
				if (currentValue >= n && currentValue < m) {
					m = currentValue;
				}
			}

			// Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
			// but guard against overflow
			handledCPCountPlusOne = handledCPCount + 1;
			if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
				error('overflow');
			}

			delta += (m - n) * handledCPCountPlusOne;
			n = m;

			for (j = 0; j < inputLength; ++j) {
				currentValue = input[j];

				if (currentValue < n && ++delta > maxInt) {
					error('overflow');
				}

				if (currentValue == n) {
					// Represent delta as a generalized variable-length integer
					for (q = delta, k = base; /* no condition */; k += base) {
						t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
						if (q < t) {
							break;
						}
						qMinusT = q - t;
						baseMinusT = base - t;
						output.push(
							stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0))
						);
						q = floor(qMinusT / baseMinusT);
					}

					output.push(stringFromCharCode(digitToBasic(q, 0)));
					bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
					delta = 0;
					++handledCPCount;
				}
			}

			++delta;
			++n;

		}
		return output.join('');
	}

	/**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */
	function toUnicode(input) {
		return mapDomain(input, function(string) {
			return regexPunycode.test(string)
				? decode(string.slice(4).toLowerCase())
				: string;
		});
	}

	/**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */
	function toASCII(input) {
		return mapDomain(input, function(string) {
			return regexNonASCII.test(string)
				? 'xn--' + encode(string)
				: string;
		});
	}

	/*--------------------------------------------------------------------------*/

	/** Define the public API */
	punycode = {
		/**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */
		'version': '1.3.2',
		/**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */
		'ucs2': {
			'decode': ucs2decode,
			'encode': ucs2encode
		},
		'decode': decode,
		'encode': encode,
		'toASCII': toASCII,
		'toUnicode': toUnicode
	};

	/** Expose `punycode` */
	// Some AMD build optimizers, like r.js, check for specific condition patterns
	// like the following:
	if (
		true
	) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
			return punycode;
		}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (freeExports && freeModule) {
		if (module.exports == freeExports) {
			// in Node.js, io.js, or RingoJS v0.8.0+
			freeModule.exports = punycode;
		} else {
			// in Narwhal or RingoJS v0.7.0-
			for (key in punycode) {
				punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
			}
		}
	} else {
		// in Rhino or a web browser
		root.punycode = punycode;
	}

}(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(440)(module), __webpack_require__(441)))

/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * URI.js - Mutating URLs
 * IPv6 Support
 *
 * Version: 1.19.1
 *
 * Author: Rodney Rehm
 * Web: http://medialize.github.io/URI.js/
 *
 * Licensed under
 *   MIT License http://www.opensource.org/licenses/mit-license
 *
 */

(function (root, factory) {
  'use strict';
  // https://github.com/umdjs/umd/blob/master/returnExports.js
  if (typeof module === 'object' && module.exports) {
    // Node
    module.exports = factory();
  } else if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {
    // Browser globals (root is window)
    root.IPv6 = factory(root);
  }
}(this, function (root) {
  'use strict';

  /*
  var _in = "fe80:0000:0000:0000:0204:61ff:fe9d:f156";
  var _out = IPv6.best(_in);
  var _expected = "fe80::204:61ff:fe9d:f156";

  console.log(_in, _out, _expected, _out === _expected);
  */

  // save current IPv6 variable, if any
  var _IPv6 = root && root.IPv6;

  function bestPresentation(address) {
    // based on:
    // Javascript to test an IPv6 address for proper format, and to
    // present the "best text representation" according to IETF Draft RFC at
    // http://tools.ietf.org/html/draft-ietf-6man-text-addr-representation-04
    // 8 Feb 2010 Rich Brown, Dartware, LLC
    // Please feel free to use this code as long as you provide a link to
    // http://www.intermapper.com
    // http://intermapper.com/support/tools/IPV6-Validator.aspx
    // http://download.dartware.com/thirdparty/ipv6validator.js

    var _address = address.toLowerCase();
    var segments = _address.split(':');
    var length = segments.length;
    var total = 8;

    // trim colons (:: or ::a:b:c… or …a:b:c::)
    if (segments[0] === '' && segments[1] === '' && segments[2] === '') {
      // must have been ::
      // remove first two items
      segments.shift();
      segments.shift();
    } else if (segments[0] === '' && segments[1] === '') {
      // must have been ::xxxx
      // remove the first item
      segments.shift();
    } else if (segments[length - 1] === '' && segments[length - 2] === '') {
      // must have been xxxx::
      segments.pop();
    }

    length = segments.length;

    // adjust total segments for IPv4 trailer
    if (segments[length - 1].indexOf('.') !== -1) {
      // found a "." which means IPv4
      total = 7;
    }

    // fill empty segments them with "0000"
    var pos;
    for (pos = 0; pos < length; pos++) {
      if (segments[pos] === '') {
        break;
      }
    }

    if (pos < total) {
      segments.splice(pos, 1, '0000');
      while (segments.length < total) {
        segments.splice(pos, 0, '0000');
      }
    }

    // strip leading zeros
    var _segments;
    for (var i = 0; i < total; i++) {
      _segments = segments[i].split('');
      for (var j = 0; j < 3 ; j++) {
        if (_segments[0] === '0' && _segments.length > 1) {
          _segments.splice(0,1);
        } else {
          break;
        }
      }

      segments[i] = _segments.join('');
    }

    // find longest sequence of zeroes and coalesce them into one segment
    var best = -1;
    var _best = 0;
    var _current = 0;
    var current = -1;
    var inzeroes = false;
    // i; already declared

    for (i = 0; i < total; i++) {
      if (inzeroes) {
        if (segments[i] === '0') {
          _current += 1;
        } else {
          inzeroes = false;
          if (_current > _best) {
            best = current;
            _best = _current;
          }
        }
      } else {
        if (segments[i] === '0') {
          inzeroes = true;
          current = i;
          _current = 1;
        }
      }
    }

    if (_current > _best) {
      best = current;
      _best = _current;
    }

    if (_best > 1) {
      segments.splice(best, _best, '');
    }

    length = segments.length;

    // assemble remaining segments
    var result = '';
    if (segments[0] === '')  {
      result = ':';
    }

    for (i = 0; i < length; i++) {
      result += segments[i];
      if (i === length - 1) {
        break;
      }

      result += ':';
    }

    if (segments[length - 1] === '') {
      result += ':';
    }

    return result;
  }

  function noConflict() {
    /*jshint validthis: true */
    if (root.IPv6 === this) {
      root.IPv6 = _IPv6;
    }

    return this;
  }

  return {
    best: bestPresentation,
    noConflict: noConflict
  };
}));


/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * URI.js - Mutating URLs
 * Second Level Domain (SLD) Support
 *
 * Version: 1.19.1
 *
 * Author: Rodney Rehm
 * Web: http://medialize.github.io/URI.js/
 *
 * Licensed under
 *   MIT License http://www.opensource.org/licenses/mit-license
 *
 */

(function (root, factory) {
  'use strict';
  // https://github.com/umdjs/umd/blob/master/returnExports.js
  if (typeof module === 'object' && module.exports) {
    // Node
    module.exports = factory();
  } else if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {
    // Browser globals (root is window)
    root.SecondLevelDomains = factory(root);
  }
}(this, function (root) {
  'use strict';

  // save current SecondLevelDomains variable, if any
  var _SecondLevelDomains = root && root.SecondLevelDomains;

  var SLD = {
    // list of known Second Level Domains
    // converted list of SLDs from https://github.com/gavingmiller/second-level-domains
    // ----
    // publicsuffix.org is more current and actually used by a couple of browsers internally.
    // downside is it also contains domains like "dyndns.org" - which is fine for the security
    // issues browser have to deal with (SOP for cookies, etc) - but is way overboard for URI.js
    // ----
    list: {
      'ac':' com gov mil net org ',
      'ae':' ac co gov mil name net org pro sch ',
      'af':' com edu gov net org ',
      'al':' com edu gov mil net org ',
      'ao':' co ed gv it og pb ',
      'ar':' com edu gob gov int mil net org tur ',
      'at':' ac co gv or ',
      'au':' asn com csiro edu gov id net org ',
      'ba':' co com edu gov mil net org rs unbi unmo unsa untz unze ',
      'bb':' biz co com edu gov info net org store tv ',
      'bh':' biz cc com edu gov info net org ',
      'bn':' com edu gov net org ',
      'bo':' com edu gob gov int mil net org tv ',
      'br':' adm adv agr am arq art ato b bio blog bmd cim cng cnt com coop ecn edu eng esp etc eti far flog fm fnd fot fst g12 ggf gov imb ind inf jor jus lel mat med mil mus net nom not ntr odo org ppg pro psc psi qsl rec slg srv tmp trd tur tv vet vlog wiki zlg ',
      'bs':' com edu gov net org ',
      'bz':' du et om ov rg ',
      'ca':' ab bc mb nb nf nl ns nt nu on pe qc sk yk ',
      'ck':' biz co edu gen gov info net org ',
      'cn':' ac ah bj com cq edu fj gd gov gs gx gz ha hb he hi hl hn jl js jx ln mil net nm nx org qh sc sd sh sn sx tj tw xj xz yn zj ',
      'co':' com edu gov mil net nom org ',
      'cr':' ac c co ed fi go or sa ',
      'cy':' ac biz com ekloges gov ltd name net org parliament press pro tm ',
      'do':' art com edu gob gov mil net org sld web ',
      'dz':' art asso com edu gov net org pol ',
      'ec':' com edu fin gov info med mil net org pro ',
      'eg':' com edu eun gov mil name net org sci ',
      'er':' com edu gov ind mil net org rochest w ',
      'es':' com edu gob nom org ',
      'et':' biz com edu gov info name net org ',
      'fj':' ac biz com info mil name net org pro ',
      'fk':' ac co gov net nom org ',
      'fr':' asso com f gouv nom prd presse tm ',
      'gg':' co net org ',
      'gh':' com edu gov mil org ',
      'gn':' ac com gov net org ',
      'gr':' com edu gov mil net org ',
      'gt':' com edu gob ind mil net org ',
      'gu':' com edu gov net org ',
      'hk':' com edu gov idv net org ',
      'hu':' 2000 agrar bolt casino city co erotica erotika film forum games hotel info ingatlan jogasz konyvelo lakas media news org priv reklam sex shop sport suli szex tm tozsde utazas video ',
      'id':' ac co go mil net or sch web ',
      'il':' ac co gov idf k12 muni net org ',
      'in':' ac co edu ernet firm gen gov i ind mil net nic org res ',
      'iq':' com edu gov i mil net org ',
      'ir':' ac co dnssec gov i id net org sch ',
      'it':' edu gov ',
      'je':' co net org ',
      'jo':' com edu gov mil name net org sch ',
      'jp':' ac ad co ed go gr lg ne or ',
      'ke':' ac co go info me mobi ne or sc ',
      'kh':' com edu gov mil net org per ',
      'ki':' biz com de edu gov info mob net org tel ',
      'km':' asso com coop edu gouv k medecin mil nom notaires pharmaciens presse tm veterinaire ',
      'kn':' edu gov net org ',
      'kr':' ac busan chungbuk chungnam co daegu daejeon es gangwon go gwangju gyeongbuk gyeonggi gyeongnam hs incheon jeju jeonbuk jeonnam k kg mil ms ne or pe re sc seoul ulsan ',
      'kw':' com edu gov net org ',
      'ky':' com edu gov net org ',
      'kz':' com edu gov mil net org ',
      'lb':' com edu gov net org ',
      'lk':' assn com edu gov grp hotel int ltd net ngo org sch soc web ',
      'lr':' com edu gov net org ',
      'lv':' asn com conf edu gov id mil net org ',
      'ly':' com edu gov id med net org plc sch ',
      'ma':' ac co gov m net org press ',
      'mc':' asso tm ',
      'me':' ac co edu gov its net org priv ',
      'mg':' com edu gov mil nom org prd tm ',
      'mk':' com edu gov inf name net org pro ',
      'ml':' com edu gov net org presse ',
      'mn':' edu gov org ',
      'mo':' com edu gov net org ',
      'mt':' com edu gov net org ',
      'mv':' aero biz com coop edu gov info int mil museum name net org pro ',
      'mw':' ac co com coop edu gov int museum net org ',
      'mx':' com edu gob net org ',
      'my':' com edu gov mil name net org sch ',
      'nf':' arts com firm info net other per rec store web ',
      'ng':' biz com edu gov mil mobi name net org sch ',
      'ni':' ac co com edu gob mil net nom org ',
      'np':' com edu gov mil net org ',
      'nr':' biz com edu gov info net org ',
      'om':' ac biz co com edu gov med mil museum net org pro sch ',
      'pe':' com edu gob mil net nom org sld ',
      'ph':' com edu gov i mil net ngo org ',
      'pk':' biz com edu fam gob gok gon gop gos gov net org web ',
      'pl':' art bialystok biz com edu gda gdansk gorzow gov info katowice krakow lodz lublin mil net ngo olsztyn org poznan pwr radom slupsk szczecin torun warszawa waw wroc wroclaw zgora ',
      'pr':' ac biz com edu est gov info isla name net org pro prof ',
      'ps':' com edu gov net org plo sec ',
      'pw':' belau co ed go ne or ',
      'ro':' arts com firm info nom nt org rec store tm www ',
      'rs':' ac co edu gov in org ',
      'sb':' com edu gov net org ',
      'sc':' com edu gov net org ',
      'sh':' co com edu gov net nom org ',
      'sl':' com edu gov net org ',
      'st':' co com consulado edu embaixada gov mil net org principe saotome store ',
      'sv':' com edu gob org red ',
      'sz':' ac co org ',
      'tr':' av bbs bel biz com dr edu gen gov info k12 name net org pol tel tsk tv web ',
      'tt':' aero biz cat co com coop edu gov info int jobs mil mobi museum name net org pro tel travel ',
      'tw':' club com ebiz edu game gov idv mil net org ',
      'mu':' ac co com gov net or org ',
      'mz':' ac co edu gov org ',
      'na':' co com ',
      'nz':' ac co cri geek gen govt health iwi maori mil net org parliament school ',
      'pa':' abo ac com edu gob ing med net nom org sld ',
      'pt':' com edu gov int net nome org publ ',
      'py':' com edu gov mil net org ',
      'qa':' com edu gov mil net org ',
      're':' asso com nom ',
      'ru':' ac adygeya altai amur arkhangelsk astrakhan bashkiria belgorod bir bryansk buryatia cbg chel chelyabinsk chita chukotka chuvashia com dagestan e-burg edu gov grozny int irkutsk ivanovo izhevsk jar joshkar-ola kalmykia kaluga kamchatka karelia kazan kchr kemerovo khabarovsk khakassia khv kirov koenig komi kostroma kranoyarsk kuban kurgan kursk lipetsk magadan mari mari-el marine mil mordovia mosreg msk murmansk nalchik net nnov nov novosibirsk nsk omsk orenburg org oryol penza perm pp pskov ptz rnd ryazan sakhalin samara saratov simbirsk smolensk spb stavropol stv surgut tambov tatarstan tom tomsk tsaritsyn tsk tula tuva tver tyumen udm udmurtia ulan-ude vladikavkaz vladimir vladivostok volgograd vologda voronezh vrn vyatka yakutia yamal yekaterinburg yuzhno-sakhalinsk ',
      'rw':' ac co com edu gouv gov int mil net ',
      'sa':' com edu gov med net org pub sch ',
      'sd':' com edu gov info med net org tv ',
      'se':' a ac b bd c d e f g h i k l m n o org p parti pp press r s t tm u w x y z ',
      'sg':' com edu gov idn net org per ',
      'sn':' art com edu gouv org perso univ ',
      'sy':' com edu gov mil net news org ',
      'th':' ac co go in mi net or ',
      'tj':' ac biz co com edu go gov info int mil name net nic org test web ',
      'tn':' agrinet com defense edunet ens fin gov ind info intl mincom nat net org perso rnrt rns rnu tourism ',
      'tz':' ac co go ne or ',
      'ua':' biz cherkassy chernigov chernovtsy ck cn co com crimea cv dn dnepropetrovsk donetsk dp edu gov if in ivano-frankivsk kh kharkov kherson khmelnitskiy kiev kirovograd km kr ks kv lg lugansk lutsk lviv me mk net nikolaev od odessa org pl poltava pp rovno rv sebastopol sumy te ternopil uzhgorod vinnica vn zaporizhzhe zhitomir zp zt ',
      'ug':' ac co go ne or org sc ',
      'uk':' ac bl british-library co cym gov govt icnet jet lea ltd me mil mod national-library-scotland nel net nhs nic nls org orgn parliament plc police sch scot soc ',
      'us':' dni fed isa kids nsn ',
      'uy':' com edu gub mil net org ',
      've':' co com edu gob info mil net org web ',
      'vi':' co com k12 net org ',
      'vn':' ac biz com edu gov health info int name net org pro ',
      'ye':' co com gov ltd me net org plc ',
      'yu':' ac co edu gov org ',
      'za':' ac agric alt bourse city co cybernet db edu gov grondar iaccess imt inca landesign law mil net ngo nis nom olivetti org pix school tm web ',
      'zm':' ac co com edu gov net org sch ',
      // https://en.wikipedia.org/wiki/CentralNic#Second-level_domains
      'com': 'ar br cn de eu gb gr hu jpn kr no qc ru sa se uk us uy za ',
      'net': 'gb jp se uk ',
      'org': 'ae',
      'de': 'com '
    },
    // gorhill 2013-10-25: Using indexOf() instead Regexp(). Significant boost
    // in both performance and memory footprint. No initialization required.
    // http://jsperf.com/uri-js-sld-regex-vs-binary-search/4
    // Following methods use lastIndexOf() rather than array.split() in order
    // to avoid any memory allocations.
    has: function(domain) {
      var tldOffset = domain.lastIndexOf('.');
      if (tldOffset <= 0 || tldOffset >= (domain.length-1)) {
        return false;
      }
      var sldOffset = domain.lastIndexOf('.', tldOffset-1);
      if (sldOffset <= 0 || sldOffset >= (tldOffset-1)) {
        return false;
      }
      var sldList = SLD.list[domain.slice(tldOffset+1)];
      if (!sldList) {
        return false;
      }
      return sldList.indexOf(' ' + domain.slice(sldOffset+1, tldOffset) + ' ') >= 0;
    },
    is: function(domain) {
      var tldOffset = domain.lastIndexOf('.');
      if (tldOffset <= 0 || tldOffset >= (domain.length-1)) {
        return false;
      }
      var sldOffset = domain.lastIndexOf('.', tldOffset-1);
      if (sldOffset >= 0) {
        return false;
      }
      var sldList = SLD.list[domain.slice(tldOffset+1)];
      if (!sldList) {
        return false;
      }
      return sldList.indexOf(' ' + domain.slice(0, tldOffset) + ' ') >= 0;
    },
    get: function(domain) {
      var tldOffset = domain.lastIndexOf('.');
      if (tldOffset <= 0 || tldOffset >= (domain.length-1)) {
        return null;
      }
      var sldOffset = domain.lastIndexOf('.', tldOffset-1);
      if (sldOffset <= 0 || sldOffset >= (tldOffset-1)) {
        return null;
      }
      var sldList = SLD.list[domain.slice(tldOffset+1)];
      if (!sldList) {
        return null;
      }
      if (sldList.indexOf(' ' + domain.slice(sldOffset+1, tldOffset) + ' ') < 0) {
        return null;
      }
      return domain.slice(sldOffset+1);
    },
    noConflict: function(){
      if (root.SecondLevelDomains === this) {
        root.SecondLevelDomains = _SecondLevelDomains;
      }
      return this;
    }
  };

  return SLD;
}));


/***/ }),
/* 643 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActionTypes; });
/* harmony export (immutable) */ __webpack_exports__["b"] = createStore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_symbol_observable__ = __webpack_require__(1176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_symbol_observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_symbol_observable__);



/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var ActionTypes = {
  INIT: '@@redux/INIT'

  /**
   * Creates a Redux store that holds the state tree.
   * The only way to change the data in the store is to call `dispatch()` on it.
   *
   * There should only be a single store in your app. To specify how different
   * parts of the state tree respond to actions, you may combine several reducers
   * into a single reducer function by using `combineReducers`.
   *
   * @param {Function} reducer A function that returns the next state tree, given
   * the current state tree and the action to handle.
   *
   * @param {any} [preloadedState] The initial state. You may optionally specify it
   * to hydrate the state from the server in universal apps, or to restore a
   * previously serialized user session.
   * If you use `combineReducers` to produce the root reducer function, this must be
   * an object with the same shape as `combineReducers` keys.
   *
   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
   * to enhance the store with third-party capabilities such as middleware,
   * time travel, persistence, etc. The only store enhancer that ships with Redux
   * is `applyMiddleware()`.
   *
   * @returns {Store} A Redux store that lets you read the state, dispatch actions
   * and subscribe to changes.
   */
};function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }

  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */
  function getState() {
    return currentState;
  }

  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */
  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected listener to be a function.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */
  function dispatch(action) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;
    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }

  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */
  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer;
    dispatch({ type: ActionTypes.INIT });
  }

  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */
  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object') {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return { unsubscribe: unsubscribe };
      }
    }, _ref[__WEBPACK_IMPORTED_MODULE_1_symbol_observable___default.a] = function () {
      return this;
    }, _ref;
  }

  // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.
  dispatch({ type: ActionTypes.INIT });

  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[__WEBPACK_IMPORTED_MODULE_1_symbol_observable___default.a] = observable, _ref2;
}

/***/ }),
/* 644 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/* harmony default export */ __webpack_exports__["a"] = (freeGlobal);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(441)))

/***/ }),
/* 645 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (overArg);


/***/ }),
/* 646 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 647 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = compose;
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */

function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(undefined, arguments));
    };
  });
}

/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reduxActions = __webpack_require__(9);

var _actionTypes = __webpack_require__(664);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var createLoggedInUserReducer = function createLoggedInUserReducer(_ref) {
    var _ref$LOGGED_IN_USER = _ref.LOGGED_IN_USER,
        LOGGED_IN_USER = _ref$LOGGED_IN_USER === undefined ? null : _ref$LOGGED_IN_USER;

    var initialState = _extends({}, LOGGED_IN_USER);

    return (0, _reduxActions.handleActions)(_defineProperty({}, _actionTypes.LOGGED_IN_USER_UPDATE, function (state, _ref2) {
        var userInfo = _ref2.payload;
        return _extends({}, state, userInfo);
    }), initialState);
};

exports.default = createLoggedInUserReducer;

/***/ }),
/* 649 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createAction;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_identity__ = __webpack_require__(443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_isFunction__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_es_isNull__ = __webpack_require__(1184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);





function createAction(type) {
  var payloadCreator = arguments.length <= 1 || arguments[1] === undefined ? __WEBPACK_IMPORTED_MODULE_0_lodash_es_identity__["a" /* default */] : arguments[1];
  var metaCreator = arguments[2];

  __WEBPACK_IMPORTED_MODULE_3_invariant___default()(Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es_isFunction__["a" /* default */])(payloadCreator) || Object(__WEBPACK_IMPORTED_MODULE_2_lodash_es_isNull__["a" /* default */])(payloadCreator), 'Expected payloadCreator to be a function, undefined or null');

  var finalPayloadCreator = Object(__WEBPACK_IMPORTED_MODULE_2_lodash_es_isNull__["a" /* default */])(payloadCreator) || payloadCreator === __WEBPACK_IMPORTED_MODULE_0_lodash_es_identity__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0_lodash_es_identity__["a" /* default */] : function (head) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return head instanceof Error ? head : payloadCreator.apply(undefined, [head].concat(args));
  };

  var hasMeta = Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es_isFunction__["a" /* default */])(metaCreator);
  var typeString = type.toString();

  var actionCreator = function actionCreator() {
    var payload = finalPayloadCreator.apply(undefined, arguments);
    var action = { type: type };

    if (payload instanceof Error) {
      action.error = true;
    }

    if (payload !== undefined) {
      action.payload = payload;
    }

    if (hasMeta) {
      action.meta = metaCreator.apply(undefined, arguments);
    }

    return action;
  };

  actionCreator.toString = function () {
    return typeString;
  };

  return actionCreator;
}

/***/ }),
/* 650 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = handleAction;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isFunction__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_es_identity__ = __webpack_require__(443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_es_isNil__ = __webpack_require__(651);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_es_isUndefined__ = __webpack_require__(1185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_es_includes__ = __webpack_require__(1186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_invariant__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__combineActions__ = __webpack_require__(660);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();










function handleAction(type) {
  var reducer = arguments.length <= 1 || arguments[1] === undefined ? __WEBPACK_IMPORTED_MODULE_2_lodash_es_identity__["a" /* default */] : arguments[1];
  var defaultState = arguments[2];

  var types = type.toString().split(__WEBPACK_IMPORTED_MODULE_7__combineActions__["a" /* ACTION_TYPE_DELIMITER */]);
  __WEBPACK_IMPORTED_MODULE_6_invariant___default()(!Object(__WEBPACK_IMPORTED_MODULE_4_lodash_es_isUndefined__["a" /* default */])(defaultState), 'defaultState for reducer handling ' + types.join(', ') + ' should be defined');
  __WEBPACK_IMPORTED_MODULE_6_invariant___default()(Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isFunction__["a" /* default */])(reducer) || Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__["a" /* default */])(reducer), 'Expected reducer to be a function or object with next and throw reducers');

  var _ref = Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isFunction__["a" /* default */])(reducer) ? [reducer, reducer] : [reducer.next, reducer.throw].map(function (aReducer) {
    return Object(__WEBPACK_IMPORTED_MODULE_3_lodash_es_isNil__["a" /* default */])(aReducer) ? __WEBPACK_IMPORTED_MODULE_2_lodash_es_identity__["a" /* default */] : aReducer;
  });

  var _ref2 = _slicedToArray(_ref, 2);

  var nextReducer = _ref2[0];
  var throwReducer = _ref2[1];


  return function () {
    var state = arguments.length <= 0 || arguments[0] === undefined ? defaultState : arguments[0];
    var action = arguments[1];
    var actionType = action.type;

    if (!actionType || !Object(__WEBPACK_IMPORTED_MODULE_5_lodash_es_includes__["a" /* default */])(types, actionType.toString())) {
      return state;
    }

    return (action.error === true ? throwReducer : nextReducer)(state, action);
  };
}

/***/ }),
/* 651 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is `null` or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
 * @example
 *
 * _.isNil(null);
 * // => true
 *
 * _.isNil(void 0);
 * // => true
 *
 * _.isNil(NaN);
 * // => false
 */
function isNil(value) {
  return value == null;
}

/* harmony default export */ __webpack_exports__["a"] = (isNil);


/***/ }),
/* 652 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/* harmony default export */ __webpack_exports__["a"] = (isLength);


/***/ }),
/* 653 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (arrayMap);


/***/ }),
/* 654 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsArguments_js__ = __webpack_require__(1199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__ = __webpack_require__(224);



/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = Object(__WEBPACK_IMPORTED_MODULE_0__baseIsArguments_js__["a" /* default */])(function() { return arguments; }()) ? __WEBPACK_IMPORTED_MODULE_0__baseIsArguments_js__["a" /* default */] : function(value) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

/* harmony default export */ __webpack_exports__["a"] = (isArguments);


/***/ }),
/* 655 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stubFalse_js__ = __webpack_require__(1200);



/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || __WEBPACK_IMPORTED_MODULE_1__stubFalse_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (isBuffer);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(656)(module)))

/***/ }),
/* 656 */
/***/ (function(module, exports) {

module.exports = function(originalModule) {
	if(!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true,
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 657 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsTypedArray_js__ = __webpack_require__(1202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseUnary_js__ = __webpack_require__(1203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__nodeUtil_js__ = __webpack_require__(1204);




/* Node.js helper references. */
var nodeIsTypedArray = __WEBPACK_IMPORTED_MODULE_2__nodeUtil_js__["a" /* default */] && __WEBPACK_IMPORTED_MODULE_2__nodeUtil_js__["a" /* default */].isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? Object(__WEBPACK_IMPORTED_MODULE_1__baseUnary_js__["a" /* default */])(nodeIsTypedArray) : __WEBPACK_IMPORTED_MODULE_0__baseIsTypedArray_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (isTypedArray);


/***/ }),
/* 658 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isPrototype_js__ = __webpack_require__(659);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__nativeKeys_js__ = __webpack_require__(1205);



/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0__isPrototype_js__["a" /* default */])(object)) {
    return Object(__WEBPACK_IMPORTED_MODULE_1__nativeKeys_js__["a" /* default */])(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (baseKeys);


/***/ }),
/* 659 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/* harmony default export */ __webpack_exports__["a"] = (isPrototype);


/***/ }),
/* 660 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ACTION_TYPE_DELIMITER; });
/* harmony export (immutable) */ __webpack_exports__["b"] = combineActions;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isString__ = __webpack_require__(446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_isFunction__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_es_isEmpty__ = __webpack_require__(1206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_es_toString__ = __webpack_require__(1217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_es_isSymbol__ = __webpack_require__(447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_invariant__);







var ACTION_TYPE_DELIMITER = '||';

function isValidActionType(type) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isString__["a" /* default */])(type) || Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es_isFunction__["a" /* default */])(type) || Object(__WEBPACK_IMPORTED_MODULE_4_lodash_es_isSymbol__["a" /* default */])(type);
}

function isValidActionTypes(types) {
  if (Object(__WEBPACK_IMPORTED_MODULE_2_lodash_es_isEmpty__["a" /* default */])(types)) {
    return false;
  }
  return types.every(isValidActionType);
}

function combineActions() {
  for (var _len = arguments.length, actionsTypes = Array(_len), _key = 0; _key < _len; _key++) {
    actionsTypes[_key] = arguments[_key];
  }

  __WEBPACK_IMPORTED_MODULE_5_invariant___default()(isValidActionTypes(actionsTypes), 'Expected action types to be strings, symbols, or action creators');
  var combinedActionType = actionsTypes.map(__WEBPACK_IMPORTED_MODULE_3_lodash_es_toString__["a" /* default */]).join(ACTION_TYPE_DELIMITER);
  return { toString: function toString() {
      return combinedActionType;
    } };
}

/***/ }),
/* 661 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/* harmony default export */ __webpack_exports__["a"] = (toSource);


/***/ }),
/* 662 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return flattenActionMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return flattenReducerMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return unflattenActionCreators; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__camelCase__ = __webpack_require__(663);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ownKeys__ = __webpack_require__(448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hasGeneratorInterface__ = __webpack_require__(1221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_es_isPlainObject__ = __webpack_require__(223);





var defaultNamespace = '/';

var flattenWhenNode = function flattenWhenNode(predicate) {
  return function flatten(map) {
    var namespace = arguments.length <= 1 || arguments[1] === undefined ? defaultNamespace : arguments[1];
    var partialFlatMap = arguments.length <= 2 || arguments[2] === undefined ? {} : arguments[2];
    var partialFlatActionType = arguments.length <= 3 || arguments[3] === undefined ? '' : arguments[3];

    function connectNamespace(type) {
      return partialFlatActionType ? '' + partialFlatActionType + namespace + type : type;
    }

    Object(__WEBPACK_IMPORTED_MODULE_1__ownKeys__["a" /* default */])(map).forEach(function (type) {
      var nextNamespace = connectNamespace(type);
      var mapValue = map[type];

      if (!predicate(mapValue)) {
        partialFlatMap[nextNamespace] = map[type];
      } else {
        flatten(map[type], namespace, partialFlatMap, nextNamespace);
      }
    });

    return partialFlatMap;
  };
};

var flattenActionMap = flattenWhenNode(__WEBPACK_IMPORTED_MODULE_3_lodash_es_isPlainObject__["a" /* default */]);
var flattenReducerMap = flattenWhenNode(function (node) {
  return Object(__WEBPACK_IMPORTED_MODULE_3_lodash_es_isPlainObject__["a" /* default */])(node) && !Object(__WEBPACK_IMPORTED_MODULE_2__hasGeneratorInterface__["a" /* default */])(node);
});

function unflattenActionCreators(flatActionCreators) {
  var namespace = arguments.length <= 1 || arguments[1] === undefined ? defaultNamespace : arguments[1];

  function unflatten(flatActionType) {
    var partialNestedActionCreators = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
    var partialFlatActionTypePath = arguments.length <= 2 || arguments[2] === undefined ? [] : arguments[2];

    var nextNamespace = Object(__WEBPACK_IMPORTED_MODULE_0__camelCase__["a" /* default */])(partialFlatActionTypePath.shift());
    if (partialFlatActionTypePath.length) {
      if (!partialNestedActionCreators[nextNamespace]) {
        partialNestedActionCreators[nextNamespace] = {};
      }
      unflatten(flatActionType, partialNestedActionCreators[nextNamespace], partialFlatActionTypePath);
    } else {
      partialNestedActionCreators[nextNamespace] = flatActionCreators[flatActionType];
    }
  }

  var nestedActionCreators = {};
  Object.getOwnPropertyNames(flatActionCreators).forEach(function (type) {
    return unflatten(type, nestedActionCreators, type.split(namespace));
  });
  return nestedActionCreators;
}



/***/ }),
/* 663 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// based on https://github.com/lodash/lodash/blob/4.17.2/lodash.js#L14100
// eslint-disable-next-line max-len
var wordPattern = /[A-Z\xc0-\xd6\xd8-\xde]?[a-z\xdf-\xf6\xf8-\xff]+(?:['’](?:d|ll|m|re|s|t|ve))?(?=[\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000]|[A-Z\xc0-\xd6\xd8-\xde]|$)|(?:[A-Z\xc0-\xd6\xd8-\xde]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])+(?:['’](?:D|LL|M|RE|S|T|VE))?(?=[\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000]|[A-Z\xc0-\xd6\xd8-\xde](?:[a-z\xdf-\xf6\xf8-\xff]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])|$)|[A-Z\xc0-\xd6\xd8-\xde]?(?:[a-z\xdf-\xf6\xf8-\xff]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])+(?:['’](?:d|ll|m|re|s|t|ve))?|[A-Z\xc0-\xd6\xd8-\xde]+(?:['’](?:D|LL|M|RE|S|T|VE))?|\d*(?:(?:1ST|2ND|3RD|(?![123])\dTH)\b)|\d*(?:(?:1st|2nd|3rd|(?![123])\dth)\b)|\d+|(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe2f\u20d0-\u20ff]|\ud83c[\udffb-\udfff])?(?:\u200d(?:[^\ud800-\udfff]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe2f\u20d0-\u20ff]|\ud83c[\udffb-\udfff])?)*/g;
var namespacer = '/';

function camelCase(string) {
  return string.match(wordPattern).reduce(function (camelCased, word, index) {
    return camelCased + (index === 0 ? word.toLowerCase() : word.charAt(0).toUpperCase() + word.substring(1).toLowerCase());
  }, '');
}

/* harmony default export */ __webpack_exports__["a"] = (function (type) {
  return type.split(namespacer).map(camelCase).join(namespacer);
});

/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var LOGGED_IN_USER_UPDATE = exports.LOGGED_IN_USER_UPDATE = 'at/loggedInUser/LOGGED_IN_USER_UPDATE';

/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reduxActions = __webpack_require__(9);

var _actionTypes = __webpack_require__(102);

var ActionTypes = _interopRequireWildcard(_actionTypes);

var _atUtils = __webpack_require__(5);

var _utils = __webpack_require__(135);

var _actionTypes2 = __webpack_require__(449);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function addEntitiesToMap(map, entities) {
    var upsert = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    var newMap = _extends({}, map);
    if (upsert) {
        entities.forEach(function (entity) {
            newMap[entity.id] = _extends({}, map[entity.id] || {}, entity);
        });
    } else {
        entities.forEach(function (entity) {
            return newMap[entity.id] = entity;
        });
    }
    return newMap;
}

var createEntitiesReducer = function createEntitiesReducer(_ref) {
    var _handleActions;

    var _ref$USERS = _ref.USERS,
        USERS = _ref$USERS === undefined ? [] : _ref$USERS,
        _ref$USER_GROUPS = _ref.USER_GROUPS,
        USER_GROUPS = _ref$USER_GROUPS === undefined ? [] : _ref$USER_GROUPS,
        _ref$TIME_ZONE_GROUPS = _ref.TIME_ZONE_GROUPS,
        TIME_ZONE_GROUPS = _ref$TIME_ZONE_GROUPS === undefined ? [] : _ref$TIME_ZONE_GROUPS,
        _ref$TASKS = _ref.TASKS,
        TASKS = _ref$TASKS === undefined ? [] : _ref$TASKS,
        _ref$PROJECTS = _ref.PROJECTS,
        PROJECTS = _ref$PROJECTS === undefined ? [] : _ref$PROJECTS,
        _ref$CUSTOMERS = _ref.CUSTOMERS,
        CUSTOMERS = _ref$CUSTOMERS === undefined ? [] : _ref$CUSTOMERS,
        _ref$WORKFLOW_STATUSE = _ref.WORKFLOW_STATUSES,
        WORKFLOW_STATUSES = _ref$WORKFLOW_STATUSE === undefined ? [] : _ref$WORKFLOW_STATUSE,
        _ref$TYPES_OF_WORK = _ref.TYPES_OF_WORK,
        TYPES_OF_WORK = _ref$TYPES_OF_WORK === undefined ? [] : _ref$TYPES_OF_WORK,
        _ref$LEAVE_TYPES = _ref.LEAVE_TYPES,
        LEAVE_TYPES = _ref$LEAVE_TYPES === undefined ? [] : _ref$LEAVE_TYPES;

    var initialState = {
        users: (0, _atUtils.arrayToMap)(USERS),
        tasks: (0, _atUtils.arrayToMap)(TASKS),
        projects: (0, _atUtils.arrayToMap)(PROJECTS),
        customers: (0, _atUtils.arrayToMap)(CUSTOMERS),
        typesOfWork: (0, _atUtils.arrayToMap)(TYPES_OF_WORK),
        workflowStatuses: (0, _atUtils.arrayToMap)(WORKFLOW_STATUSES),
        userGroups: (0, _atUtils.arrayToMap)(USER_GROUPS),
        timeZoneGroups: (0, _atUtils.arrayToMap)(TIME_ZONE_GROUPS),
        leaveTypes: (0, _atUtils.arrayToMap)(LEAVE_TYPES)
    };

    return (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, ActionTypes.USERS_ADD, function (state, _ref2) {
        var users = _ref2.payload;
        return _extends({}, state, { users: addEntitiesToMap(state.users, users) });
    }), _defineProperty(_handleActions, ActionTypes.USERS_REMOVE, function (state, _ref3) {
        var ids = _ref3.payload;
        return _extends({}, state, { users: (0, _atUtils.filterMapByKeys)(state.users, ids) });
    }), _defineProperty(_handleActions, ActionTypes.USERS_SET, function (state, _ref4) {
        var users = _ref4.payload;
        return _extends({}, state, { users: users });
    }), _defineProperty(_handleActions, ActionTypes.USER_GROUPS_ADD, function (state, _ref5) {
        var userGroups = _ref5.payload;
        return _extends({}, state, {
            userGroups: addEntitiesToMap(state.userGroups, userGroups)
        });
    }), _defineProperty(_handleActions, ActionTypes.USER_GROUPS_SET, function (state, _ref6) {
        var userGroups = _ref6.payload;
        return _extends({}, state, {
            userGroups: userGroups
        });
    }), _defineProperty(_handleActions, ActionTypes.USER_GROUPS_REMOVE, function (state, _ref7) {
        var ids = _ref7.payload;
        return _extends({}, state, {
            userGroups: (0, _atUtils.filterMapByKeys)(state.userGroups, ids)
        });
    }), _defineProperty(_handleActions, ActionTypes.TIME_ZONE_GROUPS_ADD, function (state, _ref8) {
        var timeZoneGroups = _ref8.payload;
        return _extends({}, state, {
            timeZoneGroups: addEntitiesToMap(state.timeZoneGroups, timeZoneGroups)
        });
    }), _defineProperty(_handleActions, ActionTypes.TIME_ZONE_GROUPS_SET, function (state, _ref9) {
        var timeZoneGroups = _ref9.payload;
        return _extends({}, state, {
            timeZoneGroups: timeZoneGroups
        });
    }), _defineProperty(_handleActions, ActionTypes.TIME_ZONE_GROUPS_REMOVE, function (state, _ref10) {
        var ids = _ref10.payload;
        return _extends({}, state, {
            timeZoneGroups: (0, _atUtils.filterMapByKeys)(state.timeZoneGroups, ids)
        });
    }), _defineProperty(_handleActions, ActionTypes.TASKS_ADD, function (state, _ref11) {
        var tasks = _ref11.payload;
        return _extends({}, state, { tasks: addEntitiesToMap(state.tasks, tasks, true) });
    }), _defineProperty(_handleActions, ActionTypes.TASKS_REMOVE, function (state, _ref12) {
        var ids = _ref12.payload;
        return _extends({}, state, { tasks: (0, _atUtils.filterMapByKeys)(state.tasks, ids) });
    }), _defineProperty(_handleActions, ActionTypes.TASKS_CLEAR, function (state) {
        return _extends({}, state, { tasks: [] });
    }), _defineProperty(_handleActions, ActionTypes.PROJECTS_ADD, function (state, _ref13) {
        var projects = _ref13.payload;
        return _extends({}, state, { projects: addEntitiesToMap(state.projects, projects) });
    }), _defineProperty(_handleActions, ActionTypes.PROJECTS_REMOVE, function (state, _ref14) {
        var ids = _ref14.payload;
        return _extends({}, state, { projects: (0, _atUtils.filterMapByKeys)(state.projects, ids) });
    }), _defineProperty(_handleActions, ActionTypes.CUSTOMERS_ADD, function (state, _ref15) {
        var customers = _ref15.payload;
        return _extends({}, state, { customers: addEntitiesToMap(state.customers, customers) });
    }), _defineProperty(_handleActions, ActionTypes.CUSTOMERS_REMOVE, function (state, _ref16) {
        var ids = _ref16.payload;
        return _extends({}, state, { customers: (0, _atUtils.filterMapByKeys)(state.customers, ids) });
    }), _defineProperty(_handleActions, ActionTypes.WORKFLOW_STATUSES_ADD, function (state, _ref17) {
        var workflowStatuses = _ref17.payload;
        return _extends({}, state, {
            workflowStatuses: addEntitiesToMap(state.workflowStatuses, workflowStatuses)
        });
    }), _defineProperty(_handleActions, ActionTypes.WORKFLOW_STATUSES_SET, function (state, _ref18) {
        var workflowStatuses = _ref18.payload;
        return _extends({}, state, {
            workflowStatuses: (0, _utils.mergePreviousWorkflowStatuses)(state.workflowStatuses, workflowStatuses)
        });
    }), _defineProperty(_handleActions, _actionTypes2.NEXT_WORKFLOW_STATUSES_SET, function (state, _ref19) {
        var nextWorkflowStatuses = _ref19.payload;
        return _extends({}, state, {
            workflowStatuses: (0, _utils.convertNextWorkflowStatusesToClassic)(nextWorkflowStatuses)
        });
    }), _defineProperty(_handleActions, ActionTypes.WORKFLOW_STATUSES_REMOVE, function (state, _ref20) {
        var ids = _ref20.payload;
        return _extends({}, state, { workflowStatuses: (0, _atUtils.filterMapByKeys)(state.workflowStatuses, ids) });
    }), _defineProperty(_handleActions, ActionTypes.TYPES_OF_WORK_SET, function (state, _ref21) {
        var typesOfWork = _ref21.payload;
        return _extends({}, state, { typesOfWork: typesOfWork });
    }), _defineProperty(_handleActions, ActionTypes.LEAVE_TYPES_SET, function (state, _ref22) {
        var leaveTypes = _ref22.payload;
        return _extends({}, state, { leaveTypes: leaveTypes });
    }), _handleActions), initialState);
};

exports.default = createEntitiesReducer;

/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var INITIAL_DATA_SET = exports.INITIAL_DATA_SET = 'at/kanban/INITIAL_DATA_SET';
var COLLAPSED_PROJECTS_CHANGE = exports.COLLAPSED_PROJECTS_CHANGE = 'at/kanban/COLLAPSED_PROJECTS_CHANGE';
var TASKS_ADD = exports.TASKS_ADD = 'at/kanban/TASKS_ADD';
var PROJECT_LOADING_POSITION_SET = exports.PROJECT_LOADING_POSITION_SET = 'at/kanban/PROJECT_LOADING_POSITION_SET';
var PROJECT_LOADING_POSITIONS_RESET = exports.PROJECT_LOADING_POSITIONS_RESET = 'at/kanban/PROJECT_LOADING_POSITIONS_RESET';
var LOADING_INITIAL_DATA_SET = exports.LOADING_INITIAL_DATA_SET = 'at/kanban/LOADING_INITIAL_DATA_SET';
var LOADING_PROJECT_ID_SET = exports.LOADING_PROJECT_ID_SET = 'at/kanban/LOADING_PROJECT_ID_SET';
var IS_LOADED_SET = exports.IS_LOADED_SET = 'at/kanban/IS_LOADED_SET';
var TASKS_COUNT_BY_WORKFLOW_STATUS_SET = exports.TASKS_COUNT_BY_WORKFLOW_STATUS_SET = 'at/kanban/TASKS_COUNT_BY_WORKFLOW_STATUS_SET';
var MINIMIZED_CARDS_SET = exports.MINIMIZED_CARDS_SET = 'at/kanban/MINIMIZED_CARDS_SET';
var TASKS_ORDER_PREPEND = exports.TASKS_ORDER_PREPEND = 'at/kanban/TASKS_ORDER_PREPEND';
var TASKS_ORDER_ADD = exports.TASKS_ORDER_ADD = 'at/kanban/TASKS_ORDER_ADD';
var TASKS_ORDER_SET = exports.TASKS_ORDER_SET = 'at/kanban/TASKS_ORDER_SET';
var UPDATING_TASK_ADD = exports.UPDATING_TASK_ADD = 'at/kanban/UPDATING_TASK_ADD';
var UPDATING_TASK_REMOVE = exports.UPDATING_TASK_REMOVE = 'at/kanban/UPDATING_TASK_REMOVE';
var LOADED_TASKS_NAME_FILTER_SET = exports.LOADED_TASKS_NAME_FILTER_SET = 'at/kanban/LOADED_TASKS_NAME_FILTER_SET';
var PROJECTS_IDS_CONTAINING_TASK_ADD = exports.PROJECTS_IDS_CONTAINING_TASK_ADD = 'at/kanban/PROJECTS_IDS_CONTAINING_TASK_ADD';
var NEED_TO_LOAD_COUNTERS_SET = exports.NEED_TO_LOAD_COUNTERS_SET = 'at/kanban/NEED_TO_LOAD_COUNTERS_SET';

/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var WORKFLOW_STATUS_CHANGED = exports.WORKFLOW_STATUS_CHANGED = 'at/entities/tasks/WORKFLOW_STATUS_CHANGED';

/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var TASKS_SORTING_CHANGE = exports.TASKS_SORTING_CHANGE = 'at/taskManagement/tasksTable/TASKS_SORTING_CHANGE';
var IS_LOADED_SET = exports.IS_LOADED_SET = 'at/taskManagement/tasksTable/IS_LOADED_SET';
var IS_SUMMARY_ROW_LOADED_SET = exports.IS_SUMMARY_ROW_LOADED_SET = 'at/taskManagement/tasksTable/IS_SUMMARY_ROW_LOADED_SET';
var COLUMNS_ORDER_SET = exports.COLUMNS_ORDER_SET = 'at/taskManagement/tasksTable/COLUMNS_ORDER_SET';
var COLUMNS_SHOWN_SET = exports.COLUMNS_SHOWN_SET = 'at/taskManagement/tasksTable/SHOWN_COLUMNS_SET';

var IS_SUMMARY_ROW_SHOWN_SET = exports.IS_SUMMARY_ROW_SHOWN_SET = 'at/taskManagement/tasksTable/IS_SUMMARY_ROW_SHOWN_SET';
var SUMMARY_ROW_SET = exports.SUMMARY_ROW_SET = 'at/taskManagement/tasksTable/SUMMARY_ROW_SET';

var LOADED_TASK_IDS_SET = exports.LOADED_TASK_IDS_SET = 'at/taskManagement/tasksTable/LOADED_TASK_IDS_SET';
var LOADED_TASK_IDS_ADD = exports.LOADED_TASK_IDS_ADD = 'at/taskManagement/tasksTable/LOADED_TASK_IDS_ADD';
var LOADED_TASK_IDS_PREPEND = exports.LOADED_TASK_IDS_PREPEND = 'at/taskManagement/tasksTable/LOADED_TASK_IDS_PREPEND';

/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var SELECTED_TASK_IDS_CHANGE = exports.SELECTED_TASK_IDS_CHANGE = 'at/taskManagement/SELECTED_TASK_IDS_CHANGE';
var LOAD_EXISTING_TASK_IDS = exports.LOAD_EXISTING_TASK_IDS = 'at/taskManagement/LOAD_EXISTING_TASK_IDS';
var LOAD_EXISTING_TASK_IDS_SUCCESS = exports.LOAD_EXISTING_TASK_IDS_SUCCESS = 'at/taskManagement/LOAD_EXISTING_TASK_IDS_SUCCESS';
var LOAD_EXISTING_TASK_IDS_FAILURE = exports.LOAD_EXISTING_TASK_IDS_FAILURE = 'at/taskManagement/LOAD_EXISTING_TASK_IDS_FAILURE';
var PENDING_SELECT_ALL_SET = exports.PENDING_SELECT_ALL_SET = 'at/taskManagement/PENDING_SELECT_ALL_SET';
var PENDING_SELECT_ALL_RESET = exports.PENDING_SELECT_ALL_RESET = 'at/taskManagement/PENDING_SELECT_ALL_RESET';
var EXISTING_TASK_IDS_BY_FILTERS_SET = exports.EXISTING_TASK_IDS_BY_FILTERS_SET = 'at/taskManagement/EXISTING_TASK_IDS_BY_FILTERS_SET';
var EXISTING_TASK_IDS_LOADED_RESET = exports.EXISTING_TASK_IDS_LOADED_RESET = 'at/taskManagement/EXISTING_TASK_IDS_LOADED_RESET';

/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var ORDER_SET = exports.ORDER_SET = 'at/taskManagement/tasksTable/configurationMenu/ORDER_SET';
var SELECTED_SET = exports.SELECTED_SET = 'at/taskManagement/tasksTable/configurationMenu/SELECTED_SET';
var IS_SUMMARY_ROW_SHOWN_SET = exports.IS_SUMMARY_ROW_SHOWN_SET = 'at/taskManagement/tasksTable/configurationMenu/IS_SUMMARY_ROW_SHOWN_SET';

/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var CP_PANEL_MAX_WIDTH_CHANGE = exports.CP_PANEL_MAX_WIDTH_CHANGE = 'at/taskManagement/cpPanel/CP_PANEL_MAX_WIDTH_CHANGE';
var CP_PANEL_WIDTH_CHANGE = exports.CP_PANEL_WIDTH_CHANGE = 'at/taskManagement/cpPanel/CP_PANEL_WIDTH_CHANGE';
var CP_PANEL_COLLAPSED_CUSTOMERS_SET_CHANGE = exports.CP_PANEL_COLLAPSED_CUSTOMERS_SET_CHANGE = 'at/taskManagement/cpPanel/CP_PANEL_COLLAPSED_CUSTOMERS_SET_CHANGE';
var CP_PANEL_VISIBLE_PROJECT_IDS_CHANGE = exports.CP_PANEL_VISIBLE_PROJECT_IDS_CHANGE = 'at/taskManagement/cpPanel/CP_PANEL_VISIBLE_PROJECT_IDS_CHANGE';
var CP_PANEL_VISIBLE_CUSTOMER_IDS_CHANGE = exports.CP_PANEL_VISIBLE_CUSTOMER_IDS_CHANGE = 'at/taskManagement/cpPanel/CP_PANEL_VISIBLE_CUSTOMER_IDS_CHANGE';
var CP_PANEL_IS_CUSTOMERS_ASC_CHANGE = exports.CP_PANEL_IS_CUSTOMERS_ASC_CHANGE = 'at/taskManagement/cpPanel/CP_PANEL_IS_CUSTOMERS_ASC_CHANGE';

/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var START_BULK_TASKS_DELETE_OPERATION = exports.START_BULK_TASKS_DELETE_OPERATION = 'at/taskManagement/bulkOperations/START_BULK_TASKS_DELETE_OPERATION';
var LOAD_BULK_DELETE_DIALOG_DATA = exports.LOAD_BULK_DELETE_DIALOG_DATA = 'at/taskManagement/bulkOperations/LOAD_BULK_DELETE_DIALOG_DATA';
var LOAD_BULK_DELETE_DIALOG_DATA_SUCCESS = exports.LOAD_BULK_DELETE_DIALOG_DATA_SUCCESS = 'at/taskManagement/bulkOperations/LOAD_BULK_DELETE_DIALOG_DATA_SUCCESS';
var LOAD_BULK_DELETE_DIALOG_DATA_FAILURE = exports.LOAD_BULK_DELETE_DIALOG_DATA_FAILURE = 'at/taskManagement/bulkOperations/LOAD_BULK_DELETE_DIALOG_DATA_FAILURE';

var BULK_TASKS_DELETE = exports.BULK_TASKS_DELETE = 'at/taskManagement/bulkOperations/BULK_TASKS_DELETE';
var BULK_TASKS_DELETE_SUCCESS = exports.BULK_TASKS_DELETE_SUCCESS = 'at/taskManagement/bulkOperations/BULK_TASKS_DELETE_SUCCESS';
var BULK_TASKS_DELETE_FAILURE = exports.BULK_TASKS_DELETE_FAILURE = 'at/taskManagement/bulkOperations/BULK_TASKS_DELETE_FAILURE';

var START_BULK_ASSIGN_TASKS_OPERATION = exports.START_BULK_ASSIGN_TASKS_OPERATION = 'at/taskManagement/bulkOperations/START_BULK_ASSIGN_TASKS_OPERATION';
var LOAD_BULK_ASSIGN_DIALOG_DATA = exports.LOAD_BULK_ASSIGN_DIALOG_DATA = 'at/taskManagement/bulkOperations/LOAD_BULK_ASSIGN_DIALOG_DATA';
var LOAD_BULK_ASSIGN_DIALOG_DATA_SUCCESS = exports.LOAD_BULK_ASSIGN_DIALOG_DATA_SUCCESS = 'at/taskManagement/bulkOperations/LOAD_BULK_ASSIGN_DIALOG_DATA_SUCCESS';
var LOAD_BULK_ASSIGN_DIALOG_DATA_FAILURE = exports.LOAD_BULK_ASSIGN_DIALOG_DATA_FAILURE = 'at/taskManagement/bulkOperations/LOAD_BULK_ASSIGN_DIALOG_DATA_FAILURE';
var BULK_ASSIGN_DIALOG_SELECTION_SET = exports.BULK_ASSIGN_DIALOG_SELECTION_SET = 'at/taskManagement/bulkOperations/BULK_ASSIGN_DIALOG_SELECTION_SET';

var BULK_ASSIGN_TASKS = exports.BULK_ASSIGN_TASKS = 'at/taskManagement/bulkOperations/BULK_ASSIGN_TASKS';
var BULK_ASSIGN_TASKS_SUCCESS = exports.BULK_ASSIGN_TASKS_SUCCESS = 'at/taskManagement/bulkOperations/BULK_ASSIGN_TASKS_SUCCESS';
var BULK_ASSIGN_TASKS_FAILURE = exports.BULK_ASSIGN_TASKS_FAILURE = 'at/taskManagement/bulkOperations/BULK_ASSIGN_TASKS_FAILURE';

var START_BULK_CHANGE_TASKS_STATUS_OPERATION = exports.START_BULK_CHANGE_TASKS_STATUS_OPERATION = 'at/taskManagement/bulkOperations/START_BULK_CHANGE_TASKS_STATUS_OPERATION';
var LOAD_BULK_CHANGE_STATUS_DIALOG_DATA = exports.LOAD_BULK_CHANGE_STATUS_DIALOG_DATA = 'at/taskManagement/bulkOperations/LOAD_BULK_CHANGE_STATUS_DIALOG_DATA';
var LOAD_BULK_CHANGE_STATUS_DIALOG_DATA_SUCCESS = exports.LOAD_BULK_CHANGE_STATUS_DIALOG_DATA_SUCCESS = 'at/taskManagement/bulkOperations/LOAD_BULK_CHANGE_STATUS_DIALOG_DATA_SUCCESS';
var LOAD_BULK_CHANGE_STATUS_DIALOG_DATA_FAILURE = exports.LOAD_BULK_CHANGE_STATUS_DIALOG_DATA_FAILURE = 'at/taskManagement/bulkOperations/LOAD_BULK_CHANGE_STATUS_DIALOG_DATA_FAILURE';

var BULK_CHANGE_TASKS_STATUS = exports.BULK_CHANGE_TASKS_STATUS = 'at/taskManagement/bulkOperations/BULK_CHANGE_TASKS_STATUS';
var BULK_CHANGE_TASKS_STATUS_SUCCESS = exports.BULK_CHANGE_TASKS_STATUS_SUCCESS = 'at/taskManagement/bulkOperations/BULK_CHANGE_TASKS_STATUS_SUCCESS';
var BULK_CHANGE_TASKS_STATUS_FAILURE = exports.BULK_CHANGE_TASKS_STATUS_FAILURE = 'at/taskManagement/bulkOperations/BULK_CHANGE_TASKS_STATUS_FAILURE';

var START_BULK_MOVE_OPERATION = exports.START_BULK_MOVE_OPERATION = 'at/taskManagement/bulkOperations/START_BULK_MOVE_OPERATION';
var LOAD_BULK_MOVE_DIALOG_DATA = exports.LOAD_BULK_MOVE_DIALOG_DATA = 'at/taskManagement/bulkOperations/LOAD_BULK_MOVE_DIALOG_DATA';
var LOAD_BULK_MOVE_DIALOG_DATA_SUCCESS = exports.LOAD_BULK_MOVE_DIALOG_DATA_SUCCESS = 'at/taskManagement/bulkOperations/LOAD_BULK_MOVE_DIALOG_DATA_SUCCESS';
var LOAD_BULK_MOVE_DIALOG_DATA_FAILURE = exports.LOAD_BULK_MOVE_DIALOG_DATA_FAILURE = 'at/taskManagement/bulkOperations/LOAD_BULK_MOVE_DIALOG_DATA_FAILURE';

var BULK_TASKS_MOVE = exports.BULK_TASKS_MOVE = 'at/taskManagement/bulkOperations/BULK_TASKS_MOVE';
var BULK_TASKS_MOVE_SUCCESS = exports.BULK_TASKS_MOVE_SUCCESS = 'at/taskManagement/bulkOperations/BULK_TASKS_MOVE_SUCCESS';
var BULK_TASKS_MOVE_FAILURE = exports.BULK_TASKS_MOVE_FAILURE = 'at/taskManagement/bulkOperations/BULK_TASKS_MOVE_FAILURE';

var START_BULK_COPY_OPERATION = exports.START_BULK_COPY_OPERATION = 'at/taskManagement/bulkOperations/START_BULK_COPY_OPERATION';
var BULK_TASKS_COPY = exports.BULK_TASKS_COPY = 'at/taskManagement/bulkOperations/BULK_TASKS_COPY';
var BULK_TASKS_COPY_SUCCESS = exports.BULK_TASKS_COPY_SUCCESS = 'at/taskManagement/bulkOperations/BULK_TASKS_COPY_SUCCESS';
var BULK_TASKS_COPY_FAILURE = exports.BULK_TASKS_COPY_FAILURE = 'at/taskManagement/bulkOperations/BULK_TASKS_COPY_FAILURE';

var BULK_OPERATION_PROGRESS_SET = exports.BULK_OPERATION_PROGRESS_SET = 'at/taskManagement/bulkOperations/BULK_OPERATION_PROGRESS_SET';

var CLEANUP_DIALOGS_DATA = exports.CLEANUP_DIALOGS_DATA = 'at/taskManagement/bulkOperations/CLEANUP_DIALOGS_DATA';

/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var CSV_EXPORT_IN_PROGRESS_SET = exports.CSV_EXPORT_IN_PROGRESS_SET = 'at/taskManagement/export/taskList/csv/IN_PROGRESS';

/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var OPEN_PROJECT_SET = exports.OPEN_PROJECT_SET = 'at/panels/project/OPEN_PROJECT_SET';
var PROJECT_PANEL_OPENED_FROM_URL_SET = exports.PROJECT_PANEL_OPENED_FROM_URL_SET = 'at/panels/project/PROJECT_PANEL_OPENED_FROM_URL_SET';
var ALL_TASKS_ASSIGNED_SET = exports.ALL_TASKS_ASSIGNED_SET = 'at/panels/project/ALL_TASKS_ASSIGNED_SET';
var CAN_MANAGE_SET = exports.CAN_MANAGE_SET = 'at/panels/project/CAN_MANAGE_SET';

var NEW_COMMENTS_ADD = exports.NEW_COMMENTS_ADD = 'at/panels/project/NEW_COMMENTS_ADD';
var OLD_COMMENTS_ADD = exports.OLD_COMMENTS_ADD = 'at/panels/project/OLD_COMMENTS_ADD';
var COMMENTS_INFO_CLEAR = exports.COMMENTS_INFO_CLEAR = 'at/panels/project/COMMENTS_INFO_CLEAR';
var COMMENT_REMOVE = exports.COMMENT_REMOVE = 'at/panels/project/COMMENT_REMOVE';
var CHANGE_COMMENTS_ORDER = exports.CHANGE_COMMENTS_ORDER = 'at/panels/project/CHANGE_COMMENTS_ORDER';
var COMMENTS_LOADED_SET = exports.COMMENTS_LOADED_SET = 'at/panels/project/COMMENTS_LOADED_SET';
var COMMENTS_LOADING_SET = exports.COMMENTS_LOADING_SET = 'at/panels/project/COMMENTS_LOADING_SET';
var SENDING_COMMENT_SET = exports.SENDING_COMMENT_SET = 'at/panels/project/SENDING_COMMENT_SET';
var RECENTLY_ADDED_COMMENTS_ADD = exports.RECENTLY_ADDED_COMMENTS_ADD = 'at/panels/project/RECENTLY_ADDED_COMMENTS_ADD';
var RECENTLY_ADDED_COMMENTS_REMOVE = exports.RECENTLY_ADDED_COMMENTS_REMOVE = 'at/panels/project/RECENTLY_ADDED_COMMENTS_REMOVE';
var COMMENTS_SCROLL_TO_SET = exports.COMMENTS_SCROLL_TO_SET = 'at/panels/project/COMMENTS_SCROLL_TO_SET';
var EDITING_COMMENT_ID_SET = exports.EDITING_COMMENT_ID_SET = 'at/panels/project/EDITING_COMMENT_ID_SET';
var EDITING_COMMENT_TEXT_SET = exports.EDITING_COMMENT_TEXT_SET = 'at/panels/project/EDITING_COMMENT_TEXT_SET';
var UPDATE_COMMENT = exports.UPDATE_COMMENT = 'at/panels/project/UPDATE_COMMENT';
var UPDATING_COMMENT_ID_SET = exports.UPDATING_COMMENT_ID_SET = 'at/panels/project/UPDATING_COMMENT_ID_SET';
var SHOW_NEW_COMMENT_INPUT_SET = exports.SHOW_NEW_COMMENT_INPUT_SET = 'at/panels/project/SHOW_NEW_COMMENT_INPUT_SET';
var NEW_COMMENT_SET = exports.NEW_COMMENT_SET = 'at/panels/project/NEW_COMMENT_SET';
var NEW_COMMENT_REMOVE = exports.NEW_COMMENT_REMOVE = 'at/panels/project/NEW_COMMENT_REMOVE';

/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var OPEN_CUSTOMER_SET = exports.OPEN_CUSTOMER_SET = 'at/panels/customer/OPEN_CUSTOMER_SET';
var CUSTOMER_PANEL_OPENED_FROM_URL_SET = exports.CUSTOMER_PANEL_OPENED_FROM_URL_SET = 'at/panels/customer/CUSTOMER_PANEL_OPENED_FROM_URL_SET';
var ALL_PROJECTS_ASSIGNED_SET = exports.ALL_PROJECTS_ASSIGNED_SET = 'at/panels/customer/ALL_PROJECTS_ASSIGNED_SET';
var CAN_MANAGE_SET = exports.CAN_MANAGE_SET = 'at/panels/customer/CAN_MANAGE_SET';
var NEW_COMMENTS_ADD = exports.NEW_COMMENTS_ADD = 'at/panels/customer/NEW_COMMENTS_ADD';
var OLD_COMMENTS_ADD = exports.OLD_COMMENTS_ADD = 'at/panels/customer/OLD_COMMENTS_ADD';
var COMMENTS_INFO_CLEAR = exports.COMMENTS_INFO_CLEAR = 'at/panels/customer/COMMENTS_INFO_CLEAR';
var COMMENT_REMOVE = exports.COMMENT_REMOVE = 'at/panels/customer/COMMENT_REMOVE';
var CHANGE_COMMENTS_ORDER = exports.CHANGE_COMMENTS_ORDER = 'at/panels/customer/CHANGE_COMMENTS_ORDER';
var COMMENTS_LOADED_SET = exports.COMMENTS_LOADED_SET = 'at/panels/customer/COMMENTS_LOADED_SET';
var COMMENTS_LOADING_SET = exports.COMMENTS_LOADING_SET = 'at/panels/customer/COMMENTS_LOADING_SET';
var SENDING_COMMENT_SET = exports.SENDING_COMMENT_SET = 'at/panels/customer/SENDING_COMMENT_SET';
var RECENTLY_ADDED_COMMENTS_ADD = exports.RECENTLY_ADDED_COMMENTS_ADD = 'at/panels/customer/RECENTLY_ADDED_COMMENTS_ADD';
var RECENTLY_ADDED_COMMENTS_REMOVE = exports.RECENTLY_ADDED_COMMENTS_REMOVE = 'at/panels/customer/RECENTLY_ADDED_COMMENTS_REMOVE';
var COMMENTS_SCROLL_TO_SET = exports.COMMENTS_SCROLL_TO_SET = 'at/panels/customer/COMMENTS_SCROLL_TO_SET';
var EDITING_COMMENT_ID_SET = exports.EDITING_COMMENT_ID_SET = 'at/panels/customer/EDITING_COMMENT_ID_SET';
var EDITING_COMMENT_TEXT_SET = exports.EDITING_COMMENT_TEXT_SET = 'at/panels/customer/EDITING_COMMENT_TEXT_SET';
var UPDATE_COMMENT = exports.UPDATE_COMMENT = 'at/panels/customer/UPDATE_COMMENT';
var UPDATING_COMMENT_ID_SET = exports.UPDATING_COMMENT_ID_SET = 'at/panels/customer/UPDATING_COMMENT_ID_SET';
var SHOW_NEW_COMMENT_INPUT_SET = exports.SHOW_NEW_COMMENT_INPUT_SET = 'at/panels/customer/SHOW_NEW_COMMENT_INPUT_SET';
var NEW_COMMENT_SET = exports.NEW_COMMENT_SET = 'at/panels/customer/NEW_COMMENT_SET';
var NEW_COMMENT_REMOVE = exports.NEW_COMMENT_REMOVE = 'at/panels/customer/NEW_COMMENT_REMOVE';

/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var USER_DATA_SET = exports.USER_DATA_SET = 'at/panels/user/USER_DATA_SET';
var FULL_USER_INFO_SET = exports.FULL_USER_INFO_SET = 'at/panels/user/FULL_USER_INFO_SET';
var EXTENDED_DATA_UPDATE = exports.EXTENDED_DATA_UPDATE = 'at/panels/user/EXTENDED_DATA_UPDATE';
var USER_GROUP_DATA_SET = exports.USER_GROUP_DATA_SET = 'at/panels/user/USER_GROUP_DATA_SET';
var TIME_ZONE_GROUP_DATA_SET = exports.TIME_ZONE_GROUP_DATA_SET = 'at/panels/user/TIME_ZONE_GROUP_DATA_SET';
var USER_MANAGE_ASSIGNMENTS_DATA_SET = exports.USER_MANAGE_ASSIGNMENTS_DATA_SET = 'at/panels/user/USER_MANAGE_ASSIGNMENTS_DATA_SET';
var USER_MANAGEMENT_ASSIGNMENTS_SELECTION_SET = exports.USER_MANAGEMENT_ASSIGNMENTS_SELECTION_SET = 'at/panels/user/USER_MANAGEMENT_ASSIGNMENTS_SELECTION_SET';
var USER_TEAM_ASSIGNMENTS_DATA_SET = exports.USER_TEAM_ASSIGNMENTS_DATA_SET = 'at/panels/user/USER_TEAM_ASSIGNMENTS_DATA_SET';
var USER_PANEL_ERROR_ADD = exports.USER_PANEL_ERROR_ADD = 'at/panels/user/editPanel/USER_PANEL_ERROR_ADD';
var USER_PANEL_PASSWORD_VALIDATION_RESULT_SET = exports.USER_PANEL_PASSWORD_VALIDATION_RESULT_SET = 'at/panels/user/USER_PANEL_PASSWORD_VALIDATION_RESULT_SET';
var USER_PANEL_ERRORS_SET = exports.USER_PANEL_ERRORS_SET = 'at/panels/user/editPanel/USER_PANEL_ERRORS_SET';
var USER_PANEL_ERRORS_CLEAR = exports.USER_PANEL_ERRORS_CLEAR = 'at/panels/user/editPanel/USER_PANEL_ERRORS_CLEAR';
var USER_PANEL_ERRORS_REMOVE = exports.USER_PANEL_ERRORS_REMOVE = 'at/panels/user/editPanel/USER_PANEL_ERRORS_REMOVE';
var USER_PANEL_HAS_LEAVES_OR_TT_BEFORE_NEW_HIRE_DATE_ERROR = exports.USER_PANEL_HAS_LEAVES_OR_TT_BEFORE_NEW_HIRE_DATE_ERROR = 'at/panels/user/editPanel/USER_PANEL_HAS_LEAVES_OR_TT_BEFORE_NEW_HIRE_DATE_ERROR';
var ALL_APPROVERS_SET = exports.ALL_APPROVERS_SET = 'at/panels/user/ALL_APPROVERS_SET';

var MANAGEMENT_ASSIGNMENTS_COUNTS_LOADED_SET = exports.MANAGEMENT_ASSIGNMENTS_COUNTS_LOADED_SET = 'at/panels/user/createPanel/MANAGEMENT_ASSIGNMENTS_COUNTS_LOADED_SET';

var MANAGEMENT_ASSIGNMENTS_COUNTS_LOAD = exports.MANAGEMENT_ASSIGNMENTS_COUNTS_LOAD = 'at/panels/user/createPanel/MANAGEMENT_ASSIGNMENTS_COUNTS_LOAD';
var MANAGEMENT_ASSIGNMENTS_COUNTS_LOAD_SUCCESS = exports.MANAGEMENT_ASSIGNMENTS_COUNTS_LOAD_SUCCESS = 'at/panels/user/createPanel/MANAGEMENT_ASSIGNMENTS_COUNTS_LOAD_SUCCESS';
var MANAGEMENT_ASSIGNMENTS_COUNTS_LOAD_FAILURE = exports.MANAGEMENT_ASSIGNMENTS_COUNTS_LOAD_FAILURE = 'at/panels/user/createPanel/MANAGEMENT_ASSIGNMENTS_COUNTS_LOAD_FAILURE';

/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var LAST_EDITED_USER_RATE_SET = exports.LAST_EDITED_USER_RATE_SET = 'at/panels/user/accountSettings/userRates/LAST_EDITED_USER_RATE_SET';
var ERRORS_SET = exports.ERRORS_SET = 'at/panels/user/accountSettings/userRates/ERRORS_SET';
var ERRORS_CLEAR = exports.ERRORS_CLEAR = 'at/panels/user/accountSettings/userRates/ERRORS_CLEAR';
var UPDATING_SET = exports.UPDATING_SET = 'at/panels/user/accountSettings/userRates/UPDATING_SET';

/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var USER_PANEL_LOADING_SET = exports.USER_PANEL_LOADING_SET = 'at/panels/user/editPanel/USER_PANEL_LOADING_SET';
var EDIT_USER_ID_SET = exports.EDIT_USER_ID_SET = 'at/panels/user/editPanel/EDIT_USER_ID_SET';
var LOADED_SET = exports.LOADED_SET = 'at/panels/user/editPanel/LOADED_SET';
var UPDATING_DATA_SET = exports.UPDATING_DATA_SET = 'at/panels/user/editPanel/UPDATING_DATA_SET';
var USER_PANEL_TAB_SET = exports.USER_PANEL_TAB_SET = 'at/panels/user/editPanel/USER_PANEL_TAB_SET';
var USER_PANEL_STATE_SET = exports.USER_PANEL_STATE_SET = 'at/panels/user/editPanel/USER_PANEL_STATE_SET';
var UPDATING_WORK_SCHEDULE_SET = exports.UPDATING_WORK_SCHEDULE_SET = 'at/panels/user/editPanel/UPDATING_WORK_SCHEDULE_SET';
var ERROR_BACKUP_UPDATE = exports.ERROR_BACKUP_UPDATE = 'at/panels/user/editPanel/ERROR_BACKUP_UPDATE';
var LAST_LICENSE_MANAGER_ON_DELETE_ALERT_SHOWN_SET = exports.LAST_LICENSE_MANAGER_ON_DELETE_ALERT_SHOWN_SET = 'at/panels/user/editPanel/LAST_LICENSE_MANAGER_ON_DELETE_ALERT_SHOWN_SET';
var LAST_LICENSE_MANAGER_ON_DISABLE_AT_ALERT_SHOWN_SET = exports.LAST_LICENSE_MANAGER_ON_DISABLE_AT_ALERT_SHOWN_SET = 'at/panels/user/editPanel/LAST_LICENSE_MANAGER_ON_DISABLE_AT_ALERT_SHOWN_SET';
var LAST_LICENSE_MANAGER_ON_DISABLE_AP_ALERT_SHOWN_SET = exports.LAST_LICENSE_MANAGER_ON_DISABLE_AP_ALERT_SHOWN_SET = 'at/panels/user/editPanel/LAST_LICENSE_MANAGER_ON_DISABLE_AP_ALERT_SHOWN_SET';

/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var WORK_STATUSES_SET = exports.WORK_STATUSES_SET = 'at/userProfile/workStatuses/WORK_STATUSES_SET';
var DEFAULT_WORK_STATUS_PLANNING_DATA_SET = exports.DEFAULT_WORK_STATUS_PLANNING_DATA_SET = 'at/userProfile/workStatuses/DEFAULT_WORK_STATUS_PLANNING_DATA_SET';
var INITIAL_DEFAULT_WORK_STATUS_SET = exports.INITIAL_DEFAULT_WORK_STATUS_SET = 'at/userProfile/workStatuses/INITIAL_DEFAULT_WORK_STATUS_SET';

/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var FIELDS_EDITABILITY_SET = exports.FIELDS_EDITABILITY_SET = 'at/panels/user/authorizationInfo/FIELDS_EDITABILITY_SET';
var CAN_EDIT_ENTIRE_USER_SET = exports.CAN_EDIT_ENTIRE_USER_SET = 'at/panels/user/authorizationInfo/CAN_EDIT_ENTIRE_USER_SET';

/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var TASK_PANEL_LOADING_SET = exports.TASK_PANEL_LOADING_SET = 'at/panels/task/edit/TASK_PANEL_LOADING_SET';
var TASK_PANEL_LOADED_SET = exports.TASK_PANEL_LOADED_SET = 'at/panels/task/edit/TASK_PANEL_LOADED_SET';
var TASK_INFO_SET = exports.TASK_INFO_SET = 'at/panels/task/edit/TASK_INFO_SET';
var OPEN_TASK_SET = exports.OPEN_TASK_SET = 'at/panels/task/edit/OPEN_TASK_SET';
var TASK_PANEL_ERRORS_ADD = exports.TASK_PANEL_ERRORS_ADD = 'at/panels/task/edit/TASK_PANEL_ERRORS_ADD';
var TASK_PANEL_ERRORS_SET = exports.TASK_PANEL_ERRORS_SET = 'at/panels/task/edit/TASK_PANEL_ERRORS_SET';
var TASK_PANEL_ERRORS_REMOVE = exports.TASK_PANEL_ERRORS_REMOVE = 'at/panels/task/edit/TASK_PANEL_ERRORS_REMOVE';
var TASK_PANEL_UPDATING_STATE_SET = exports.TASK_PANEL_UPDATING_STATE_SET = 'at/panels/task/edit/TASK_PANEL_UPDATING_STATE_SET';
var TASK_PANEL_SHOWN_SET = exports.TASK_PANEL_SHOWN_SET = 'at/panels/task/edit/TASK_PANEL_SHOWN_SET';
var TASK_PANEL_EDITABLE_SET = exports.TASK_PANEL_EDITABLE_SET = 'at/panels/task/edit/TASK_PANEL_EDITABLE_SET';
var TASK_PANEL_OPENED_FROM_URL_SET = exports.TASK_PANEL_OPENED_FROM_URL_SET = 'at/panels/task/edit/TASK_PANEL_OPENED_FROM_URL_SET';

var TASK_PANEL_TAB_SET = exports.TASK_PANEL_TAB_SET = 'at/panels/task/edit/TASK_PANEL_TAB_SET';
var TASK_PANEL_LAST_TAB_SET = exports.TASK_PANEL_LAST_TAB_SET = 'at/panels/task/edit/TASK_PANEL_LAST_TAB_SET';

var ASSIGNED_USERS_SET = exports.ASSIGNED_USERS_SET = 'at/panels/task/edit/TASK_PANEL_ASSIGNED_USERS_SET';
var CAN_MODIFY_ANY_MANAGER_SET = exports.CAN_MODIFY_ANY_MANAGER_SET = 'at/panels/task/edit/TASK_PANEL_CAN_MODIFY_ANY_MANAGER_SET';
var CAN_MODIFY_ANY_USER_SET = exports.CAN_MODIFY_ANY_USER_SET = 'at/panels/task/edit/TASK_PANEL_CAN_MODIFY_ANY_USER_SET';
var ASSIGNED_MANAGERS_SET = exports.ASSIGNED_MANAGERS_SET = 'at/panels/task/edit/TASK_PANEL_ASSIGNED_MANAGERS_SET';

var TASK_DETAILS_SET = exports.TASK_DETAILS_SET = 'at/panels/task/edit/TASK_DETAILS_SET';

var TASK_EXECUTORS_SUMMARY_SET = exports.TASK_EXECUTORS_SUMMARY_SET = 'at/panels/task/edit/TASK_EXECUTORS_SUMMARY_SET';
var ALL_TIME_COMMENTS_LOADED_SET = exports.ALL_TIME_COMMENTS_LOADED_SET = 'at/panels/task/edit/ALL_TIME_COMMENTS_LOADED_SET';
var TIME_AND_COMMENTS_LOADING_SET = exports.TIME_AND_COMMENTS_LOADING_SET = 'at/panels/task/edit/TIME_AND_COMMENTS_LOADING_SET';
var REPORTED_TIME_COMMENTS_SET = exports.REPORTED_TIME_COMMENTS_SET = 'at/panels/task/edit/REPORTED_TIME_COMMENTS_SET';
var REPORTED_TIME_COMMENTS_ADD = exports.REPORTED_TIME_COMMENTS_ADD = 'at/panels/task/edit/REPORTED_TIME_COMMENTS_ADD';
var SORTING_SETTINGS_SET = exports.SORTING_SETTINGS_SET = 'at/panels/task/edit/SORTING_SETTINGS_SET';

var TASK_DELETED_SUCCESSFULLY_SET = exports.TASK_DELETED_SUCCESSFULLY_SET = 'at/panels/task/edit/TASK_DELETED_SUCCESSFULLY_SET';
var TASK_DELETED_UNSUCCESSFULLY_SET = exports.TASK_DELETED_UNSUCCESSFULLY_SET = 'at/panels/task/edit/TASK_DELETED_UNSUCCESSFULLY_SET';
var TASK_DELETION_STATUS_RESET = exports.TASK_DELETION_STATUS_RESET = 'at/panels/task/edit/TASK_DELETION_STATUS_RESET';

var TASK_AUDIT_HISTORY_INFO_SET = exports.TASK_AUDIT_HISTORY_INFO_SET = 'at/panels/task/edit/TASK_AUDIT_HISTORY_INFO_SET';
var AUDIT_HISTORY_ADD = exports.AUDIT_HISTORY_ADD = 'at/panels/task/edit/AUDIT_HISTORY_ADD';
var AUDIT_HISTORY_SET = exports.AUDIT_HISTORY_SET = 'at/panels/task/edit/AUDIT_HISTORY_SET';

var TASK_PANEL_STATE_RESET = exports.TASK_PANEL_STATE_RESET = 'at/panels/task/edit/TASK_PANEL_STATE_RESET';

var NEW_COMMENTS_ADD = exports.NEW_COMMENTS_ADD = 'at/panels/task/edit/NEW_COMMENTS_ADD';
var OLD_COMMENTS_ADD = exports.OLD_COMMENTS_ADD = 'at/panels/task/edit/OLD_COMMENTS_ADD';
var COMMENTS_INFO_CLEAR = exports.COMMENTS_INFO_CLEAR = 'at/panels/task/edit/COMMENTS_INFO_CLEAR';
var COMMENT_REMOVE = exports.COMMENT_REMOVE = 'at/panels/task/edit/COMMENT_REMOVE';
var CHANGE_COMMENTS_ORDER = exports.CHANGE_COMMENTS_ORDER = 'at/panels/task/edit/CHANGE_COMMENTS_ORDER';
var COMMENTS_LOADED_SET = exports.COMMENTS_LOADED_SET = 'at/panels/task/edit/COMMENTS_LOADED_SET';
var COMMENTS_LOADING_SET = exports.COMMENTS_LOADING_SET = 'at/panels/task/edit/COMMENTS_LOADING_SET';
var SENDING_COMMENT_SET = exports.SENDING_COMMENT_SET = 'at/panels/task/edit/SENDING_COMMENT_SET';
var RECENTLY_ADDED_COMMENTS_ADD = exports.RECENTLY_ADDED_COMMENTS_ADD = 'at/panels/task/edit/RECENTLY_ADDED_COMMENTS_ADD';
var RECENTLY_ADDED_COMMENTS_REMOVE = exports.RECENTLY_ADDED_COMMENTS_REMOVE = 'at/panels/task/edit/RECENTLY_ADDED_COMMENTS_REMOVE';
var COMMENTS_SCROLL_TO_SET = exports.COMMENTS_SCROLL_TO_SET = 'at/panels/task/edit/COMMENTS_SCROLL_TO_SET';
var EDITING_COMMENT_ID_SET = exports.EDITING_COMMENT_ID_SET = 'at/panels/task/edit/EDITING_COMMENT_ID_SET';
var EDITING_COMMENT_TEXT_SET = exports.EDITING_COMMENT_TEXT_SET = 'at/panels/task/edit/EDITING_COMMENT_TEXT_SET';
var UPDATE_COMMENT = exports.UPDATE_COMMENT = 'at/panels/task/edit/UPDATE_COMMENT';
var UPDATING_COMMENT_ID_SET = exports.UPDATING_COMMENT_ID_SET = 'at/panels/task/edit/UPDATING_COMMENT_ID_SET';
var SHOW_NEW_COMMENT_INPUT_SET = exports.SHOW_NEW_COMMENT_INPUT_SET = 'at/panels/task/edit/SHOW_NEW_COMMENT_INPUT_SET';
var NEW_COMMENT_SET = exports.NEW_COMMENT_SET = 'at/panels/task/edit/NEW_COMMENT_SET';
var NEW_COMMENT_REMOVE = exports.NEW_COMMENT_REMOVE = 'at/panels/task/edit/NEW_COMMENT_REMOVE';

var NEED_INITIALIZE_FOCUS_SET = exports.NEED_INITIALIZE_FOCUS_SET = 'at/panels/task/edit/NEED_INITIALIZE_FOCUS_SET';

var CUSTOM_FIELDS_VALUES_UPDATE = exports.CUSTOM_FIELDS_VALUES_UPDATE = 'at/panels/task/edit/CUSTOM_FIELDS_VALUES_UPDATE';
var CUSTOM_FIELDS_VALUES_SET = exports.CUSTOM_FIELDS_VALUES_SET = 'at/panels/task/edit/CUSTOM_FIELDS_VALUES_SET';

/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = function (_ref) {
    var _handlers;

    var _ref$actionTypes = _ref.actionTypes,
        TASK_PANEL_LOADING_SET = _ref$actionTypes.TASK_PANEL_LOADING_SET,
        OPEN_TASK_SET = _ref$actionTypes.OPEN_TASK_SET,
        TASK_INFO_SET = _ref$actionTypes.TASK_INFO_SET,
        TASK_PANEL_ERRORS_ADD = _ref$actionTypes.TASK_PANEL_ERRORS_ADD,
        TASK_PANEL_ERRORS_SET = _ref$actionTypes.TASK_PANEL_ERRORS_SET,
        TASK_PANEL_ERRORS_REMOVE = _ref$actionTypes.TASK_PANEL_ERRORS_REMOVE,
        TASK_PANEL_SHOWN_SET = _ref$actionTypes.TASK_PANEL_SHOWN_SET,
        TASK_PANEL_LOADED_SET = _ref$actionTypes.TASK_PANEL_LOADED_SET,
        TASK_PANEL_TAB_SET = _ref$actionTypes.TASK_PANEL_TAB_SET,
        TASK_PANEL_LAST_TAB_SET = _ref$actionTypes.TASK_PANEL_LAST_TAB_SET,
        NEED_INITIALIZE_FOCUS_SET = _ref$actionTypes.NEED_INITIALIZE_FOCUS_SET;

    return {
        initialState: {
            panelLoading: false,
            loaded: false,
            shown: false,
            taskInfo: {
                workflowStatusId: 0,
                creationTimestamp: null,
                completed: false,
                name: '',
                deadline: null,
                typeOfWorkId: 0,
                estimatedTime: null,
                spentTime: 0,
                description: ''
            },
            updatingState: {
                nameUpdating: false,
                deadlineUpdating: false,
                typeOfWorkUpdating: false,
                estimateUpdating: false,
                descriptionUpdating: false
            },

            currentTabKey: _constants.TasksTabs.DETAILS_TAB,
            lastSelectedTabKey: _constants.TasksTabs.DETAILS_TAB,
            isNeedInitializeFocus: false,

            errors: {}
        },
        handlers: (_handlers = {}, _defineProperty(_handlers, TASK_PANEL_LOADING_SET, function (state, _ref2) {
            var panelLoading = _ref2.payload;
            return _extends({}, state, { panelLoading: panelLoading });
        }), _defineProperty(_handlers, TASK_PANEL_LOADED_SET, function (state, _ref3) {
            var loaded = _ref3.payload;
            return _extends({}, state, { loaded: loaded });
        }), _defineProperty(_handlers, OPEN_TASK_SET, function (state, _ref4) {
            var openTaskId = _ref4.payload;
            return _extends({}, state, { openTaskId: openTaskId });
        }), _defineProperty(_handlers, TASK_PANEL_TAB_SET, function (state, _ref5) {
            var currentTabKey = _ref5.payload;
            return _extends({}, state, { currentTabKey: currentTabKey });
        }), _defineProperty(_handlers, TASK_PANEL_LAST_TAB_SET, function (state, _ref6) {
            var lastSelectedTabKey = _ref6.payload;
            return _extends({}, state, { lastSelectedTabKey: lastSelectedTabKey });
        }), _defineProperty(_handlers, TASK_INFO_SET, function (state, _ref7) {
            var changedData = _ref7.payload;
            return _extends({}, state, {
                taskInfo: _extends({}, state.taskInfo, changedData)
            });
        }), _defineProperty(_handlers, TASK_PANEL_SHOWN_SET, function (state, _ref8) {
            var shown = _ref8.payload;
            return _extends({}, state, { shown: shown, isNeedInitializeFocus: shown });
        }), _defineProperty(_handlers, NEED_INITIALIZE_FOCUS_SET, function (state, _ref9) {
            var isNeedInitializeFocus = _ref9.payload;
            return _extends({}, state, { isNeedInitializeFocus: isNeedInitializeFocus });
        }), _defineProperty(_handlers, TASK_PANEL_ERRORS_ADD, function (state, _ref10) {
            var errors = _ref10.payload;
            return _extends({}, state, {
                errors: _extends({}, state.errors, (0, _atUtils.arrayToSet)(errors))
            });
        }), _defineProperty(_handlers, TASK_PANEL_ERRORS_SET, function (state, _ref11) {
            var errors = _ref11.payload;
            return _extends({}, state, {
                errors: _extends({}, (0, _atUtils.arrayToSet)(errors))
            });
        }), _defineProperty(_handlers, TASK_PANEL_ERRORS_REMOVE, function (state, _ref12) {
            var deletedErrors = _ref12.payload;

            var deletedErrorsSet = (0, _atUtils.arrayToSet)(deletedErrors);
            var errors = Object.keys(state.errors).filter(function (key) {
                return !deletedErrorsSet[key];
            }).reduce(function (res, key) {
                return res[key] = state.errors[key], res;
            }, {});
            return _extends({}, state, {
                errors: errors
            });
        }), _handlers)
    };
};

var _atUtils = __webpack_require__(5);

var _constants = __webpack_require__(157);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = function (_ref) {
    var _handlers;

    var _ref$actionTypes = _ref.actionTypes,
        ASSIGNED_USERS_SET = _ref$actionTypes.ASSIGNED_USERS_SET,
        ASSIGNED_MANAGERS_SET = _ref$actionTypes.ASSIGNED_MANAGERS_SET,
        CAN_MODIFY_ANY_MANAGER_SET = _ref$actionTypes.CAN_MODIFY_ANY_MANAGER_SET,
        CAN_MODIFY_ANY_USER_SET = _ref$actionTypes.CAN_MODIFY_ANY_USER_SET;

    return {
        initialState: {
            assignedUsers: [],
            assignedManagers: [],
            canModifyAnyManager: false,
            canModifyAnyUser: false
        },

        handlers: (_handlers = {}, _defineProperty(_handlers, ASSIGNED_USERS_SET, function (state, _ref2) {
            var assignedUsers = _ref2.payload;
            return _extends({}, state, { assignedUsers: assignedUsers });
        }), _defineProperty(_handlers, CAN_MODIFY_ANY_USER_SET, function (state, _ref3) {
            var canModifyAnyUser = _ref3.payload;
            return _extends({}, state, { canModifyAnyUser: canModifyAnyUser });
        }), _defineProperty(_handlers, ASSIGNED_MANAGERS_SET, function (state, _ref4) {
            var assignedManagers = _ref4.payload;
            return _extends({}, state, { assignedManagers: assignedManagers });
        }), _defineProperty(_handlers, CAN_MODIFY_ANY_MANAGER_SET, function (state, _ref5) {
            var canModifyAnyManager = _ref5.payload;
            return _extends({}, state, { canModifyAnyManager: canModifyAnyManager });
        }), _handlers)
    };
};

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var TASK_PANEL_LOADING_SET = exports.TASK_PANEL_LOADING_SET = 'at/panels/task/create/TASK_PANEL_LOADING_SET';
var TASK_PANEL_LOADED_SET = exports.TASK_PANEL_LOADED_SET = 'at/panels/task/create/TASK_PANEL_LOADED_SET';
var TASK_INFO_SET = exports.TASK_INFO_SET = 'at/panels/task/create/TASK_INFO_SET';
var OPEN_TASK_SET = exports.OPEN_TASK_SET = 'at/panels/task/create/OPEN_TASK_SET';
var TASK_PANEL_ERRORS_ADD = exports.TASK_PANEL_ERRORS_ADD = 'at/panels/task/create/TASK_PANEL_ERRORS_ADD';
var TASK_PANEL_ERRORS_SET = exports.TASK_PANEL_ERRORS_SET = 'at/panels/task/create/TASK_PANEL_ERRORS_SET';
var TASK_PANEL_ERRORS_REMOVE = exports.TASK_PANEL_ERRORS_REMOVE = 'at/panels/task/create/TASK_PANEL_ERRORS_REMOVE';
var TASK_PANEL_SHOWN_SET = exports.TASK_PANEL_SHOWN_SET = 'at/panels/task/create/TASK_PANEL_SHOWN_SET';

var TASK_PANEL_TAB_SET = exports.TASK_PANEL_TAB_SET = 'at/panels/task/create/TASK_PANEL_TAB_SET';
var TASK_PANEL_LAST_TAB_SET = exports.TASK_PANEL_LAST_TAB_SET = 'at/panels/task/create/TASK_PANEL_LAST_TAB_SET';

var CREATE_TASK = exports.CREATE_TASK = 'at/panels/task/create/CREATE_TASK';
var CREATE_TASK_SUCCESS = exports.CREATE_TASK_SUCCESS = 'at/panels/task/create/CREATE_TASK_SUCCESS';
var CREATE_TASK_FAILURE = exports.CREATE_TASK_FAILURE = 'at/panels/task/create/CREATE_TASK_FAILURE';

var ASSIGNED_USERS_SET = exports.ASSIGNED_USERS_SET = 'at/panels/task/create/TASK_PANEL_ASSIGNED_USERS_SET';
var CAN_MODIFY_ANY_MANAGER_SET = exports.CAN_MODIFY_ANY_MANAGER_SET = 'at/panels/task/create/TASK_PANEL_CAN_MODIFY_ANY_MANAGER_SET';
var CAN_MODIFY_ANY_USER_SET = exports.CAN_MODIFY_ANY_USER_SET = 'at/panels/task/create/TASK_PANEL_CAN_MODIFY_ANY_USER_SET';
var ASSIGNED_MANAGERS_SET = exports.ASSIGNED_MANAGERS_SET = 'at/panels/task/create/TASK_PANEL_ASSIGNED_MANAGERS_SET';

var ADDED_ASSIGNED_USER_IDS_SET = exports.ADDED_ASSIGNED_USER_IDS_SET = 'at/panels/task/create/ADDED_ASSIGNED_USERS_IDS_SET';
var ADDED_ASSIGNED_MANAGER_IDS_SET = exports.ADDED_ASSIGNED_MANAGER_IDS_SET = 'at/panels/task/create/ADDED_ASSIGNED_MANAGERS_IDS_SET';
var CREATE_PANEL_STATE_RESET = exports.CREATE_PANEL_STATE_RESET = 'at/panels/task/create/CREATE_PANEL_STATE_RESET';

var TASK_PANEL_STATE_RESET = exports.TASK_PANEL_STATE_RESET = 'at/panels/task/create/TASK_PANEL_STATE_RESET';

var TASK_DATA_DEFAULT_STATE_PROPERTY_SET = exports.TASK_DATA_DEFAULT_STATE_PROPERTY_SET = 'at/panels/task/create/TASK_DATA_DEFAULT_STATE_PROPERTY_SET';

var NEED_INITIALIZE_FOCUS_SET = exports.NEED_INITIALIZE_FOCUS_SET = 'at/panels/task/create/NEED_INITIALIZE_FOCUS_SET';

var CUSTOM_FIELDS_VALUES_UPDATE = exports.CUSTOM_FIELDS_VALUES_UPDATE = 'at/panels/task/create/CUSTOM_FIELDS_VALUES_UPDATE';

/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var LOAD_DATA = exports.LOAD_DATA = 'at/workflowSettings/LOAD_DATA';
var LOAD_DATA_SUCCESS = exports.LOAD_DATA_SUCCESS = 'at/workflowSettings/LOAD_DATA_SUCCESS';
var LOAD_DATA_FAILURE = exports.LOAD_DATA_FAILURE = 'at/workflowSettings/LOAD_DATA_FAILURE';

var CREATE_NEW_STATUS = exports.CREATE_NEW_STATUS = 'at/workflowSettings/CREATE_NEW_STATUS';
var CREATE_NEW_STATUS_SUCCESS = exports.CREATE_NEW_STATUS_SUCCESS = 'at/workflowSettings/CREATE_NEW_STATUS_SUCCESS';
var CREATE_NEW_STATUS_FAILURE = exports.CREATE_NEW_STATUS_FAILURE = 'at/workflowSettings/CREATE_NEW_STATUS_FAILURE';

var EDIT_STATUS = exports.EDIT_STATUS = 'at/workflowSettings/EDIT_STATUS';
var EDIT_STATUS_SUCCESS = exports.EDIT_STATUS_SUCCESS = 'at/workflowSettings/EDIT_STATUS_SUCCESS';
var EDIT_STATUS_FAILURE = exports.EDIT_STATUS_FAILURE = 'at/workflowSettings/EDIT_STATUS_FAILURE';

var DELETE_STATUS = exports.DELETE_STATUS = 'at/workflowSettings/DELETE_STATUS';
var DELETE_STATUS_SUCCESS = exports.DELETE_STATUS_SUCCESS = 'at/workflowSettings/DELETE_STATUS_SUCCESS';
var DELETE_STATUS_FAILURE = exports.DELETE_STATUS_FAILURE = 'at/workflowSettings/DELETE_STATUS_FAILURE';

var CHANGE_STATUS_POSITION = exports.CHANGE_STATUS_POSITION = 'at/workflowSettings/CHANGE_STATUS_POSITION';
var CHANGE_STATUS_POSITION_SUCCESS = exports.CHANGE_STATUS_POSITION_SUCCESS = 'at/workflowSettings/CHANGE_STATUS_POSITION_SUCCESS';
var CHANGE_STATUS_POSITION_FAILURE = exports.CHANGE_STATUS_POSITION_FAILURE = 'at/workflowSettings/CHANGE_STATUS_POSITION_FAILURE';

var SET_ERRORS = exports.SET_ERRORS = 'at/workflowSettings/SET_ERRORS';
var START_EDIT_STATUS = exports.START_EDIT_STATUS = 'at/workflowSettings/START_EDIT_STATUS';
var UPDATE_EDITING_STATUS = exports.UPDATE_EDITING_STATUS = 'at/workflowSettings/UPDATE_EDITING_STATUS';
var START_CREATE_STATUS = exports.START_CREATE_STATUS = 'at/workflowSettings/START_CREATE_STATUS';
var CANCEL_EDIT_OR_CREATE_STATUS = exports.CANCEL_EDIT_OR_CREATE_STATUS = 'at/workflowSettings/CANCEL_EDIT_OR_CREATE_STATUS';

var TOGGLE_DIALOG_VISIBILITY = exports.TOGGLE_DIALOG_VISIBILITY = 'at/workflowSettings/TOGGLE_DIALOG_VISIBILITY';

/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var CLEAR = exports.CLEAR = 'at/userManagement/createUserManagementAssignmentsEditor/CLEAR';
var CLEAR_CUSTOMERS = exports.CLEAR_CUSTOMERS = 'at/userManagement/createUserManagementAssignmentsEditor/CLEAR_CUSTOMERS';
var CLEAR_PROJECTS = exports.CLEAR_PROJECTS = 'at/userManagement/createUserManagementAssignmentsEditor/CLEAR_PROJECTS';
var CLEAR_TASKS = exports.CLEAR_TASKS = 'at/userManagement/createUserManagementAssignmentsEditor/CLEAR_TASKS';
var SHOW_SET = exports.SHOW_SET = 'at/userManagement/createUserManagementAssignmentsEditor/SHOW_SET';
var EDITING_LEVEL_SET = exports.EDITING_LEVEL_SET = 'at/userManagement/createUserManagementAssignmentsEditor/EDITING_LEVEL_SET';
var LOADED_SET = exports.LOADED_SET = 'at/userManagement/createUserManagementAssignmentsEditor/LOADED_SET';
var CUSTOMERS_LOADED_SET = exports.CUSTOMERS_LOADED_SET = 'at/userManagement/createUserManagementAssignmentsEditor/CUSTOMERS_LOADED_SET';
var PROJECTS_LOADED_SET = exports.PROJECTS_LOADED_SET = 'at/userManagement/createUserManagementAssignmentsEditor/PROJECTS_LOADED_SET';
var TASKS_LOADED_SET = exports.TASKS_LOADED_SET = 'at/userManagement/createUserManagementAssignmentsEditor/TASKS_LOADED_SET';
var ONLY_ACTIVE_ENTITIES_SET = exports.ONLY_ACTIVE_ENTITIES_SET = 'at/userManagement/createUserManagementAssignmentsEditor/ONLY_ACTIVE_ENTITIES_SET';

var LOAD_CUSTOMER_ASSIGNMENTS_EDITOR_DATA = exports.LOAD_CUSTOMER_ASSIGNMENTS_EDITOR_DATA = 'at/userManagement/createUserManagementAssignmentsEditor/LOAD_CUSTOMER_ASSIGNMENTS_EDITOR_DATA';
var LOAD_CUSTOMER_ASSIGNMENTS_EDITOR_DATA_SUCCESS = exports.LOAD_CUSTOMER_ASSIGNMENTS_EDITOR_DATA_SUCCESS = 'at/userManagement/createUserManagementAssignmentsEditor/LOAD_CUSTOMER_ASSIGNMENTS_EDITOR_DATA_SUCCESS';
var LOAD_CUSTOMER_ASSIGNMENTS_EDITOR_DATA_FAILURE = exports.LOAD_CUSTOMER_ASSIGNMENTS_EDITOR_DATA_FAILURE = 'at/userManagement/createUserManagementAssignmentsEditor/LOAD_CUSTOMER_ASSIGNMENTS_EDITOR_DATA_FAILURE';

var LOAD_PROJECT_ASSIGNMENTS_EDITOR_DATA = exports.LOAD_PROJECT_ASSIGNMENTS_EDITOR_DATA = 'at/userManagement/createUserManagementAssignmentsEditor/LOAD_PROJECT_ASSIGNMENTS_EDITOR_DATA';
var LOAD_PROJECT_ASSIGNMENTS_EDITOR_DATA_SUCCESS = exports.LOAD_PROJECT_ASSIGNMENTS_EDITOR_DATA_SUCCESS = 'at/userManagement/createUserManagementAssignmentsEditor/LOAD_PROJECT_ASSIGNMENTS_EDITOR_DATA_SUCCESS';
var LOAD_PROJECT_ASSIGNMENTS_EDITOR_DATA_FAILURE = exports.LOAD_PROJECT_ASSIGNMENTS_EDITOR_DATA_FAILURE = 'at/userManagement/createUserManagementAssignmentsEditor/LOAD_PROJECT_ASSIGNMENTS_EDITOR_DATA_FAILURE';

var LOAD_TASK_ASSIGNMENTS_EDITOR_DATA = exports.LOAD_TASK_ASSIGNMENTS_EDITOR_DATA = 'at/userManagement/createUserManagementAssignmentsEditor/LOAD_TASK_ASSIGNMENTS_EDITOR_DATA';
var LOAD_TASK_ASSIGNMENTS_EDITOR_DATA_SUCCESS = exports.LOAD_TASK_ASSIGNMENTS_EDITOR_DATA_SUCCESS = 'at/userManagement/createUserManagementAssignmentsEditor/LOAD_TASK_ASSIGNMENTS_EDITOR_DATA_SUCCESS';
var LOAD_TASK_ASSIGNMENTS_EDITOR_DATA_FAILURE = exports.LOAD_TASK_ASSIGNMENTS_EDITOR_DATA_FAILURE = 'at/userManagement/createUserManagementAssignmentsEditor/LOAD_TASK_ASSIGNMENTS_EDITOR_DATA_FAILURE';

var CHANGE_CUSTOMER_ASSIGNMENT = exports.CHANGE_CUSTOMER_ASSIGNMENT = 'at/userManagement/createUserManagementAssignmentsEditor/CHANGE_CUSTOMER_ASSIGNMENT';
var CHANGE_CUSTOMER_ASSIGNMENT_SUCCESS = exports.CHANGE_CUSTOMER_ASSIGNMENT_SUCCESS = 'at/userManagement/createUserManagementAssignmentsEditor/CHANGE_CUSTOMER_ASSIGNMENT_SUCCESS';
var CHANGE_CUSTOMER_ASSIGNMENT_FAILURE = exports.CHANGE_CUSTOMER_ASSIGNMENT_FAILURE = 'at/userManagement/createUserManagementAssignmentsEditor/CHANGE_CUSTOMER_ASSIGNMENT_FAILURE';

var CHANGE_PROJECT_ASSIGNMENT = exports.CHANGE_PROJECT_ASSIGNMENT = 'at/userManagement/createUserManagementAssignmentsEditor/CHANGE_PROJECT_ASSIGNMENT';
var CHANGE_PROJECT_ASSIGNMENT_SUCCESS = exports.CHANGE_PROJECT_ASSIGNMENT_SUCCESS = 'at/userManagement/createUserManagementAssignmentsEditor/CHANGE_PROJECT_ASSIGNMENT_SUCCESS';
var CHANGE_PROJECT_ASSIGNMENT_FAILURE = exports.CHANGE_PROJECT_ASSIGNMENT_FAILURE = 'at/userManagement/createUserManagementAssignmentsEditor/CHANGE_PROJECT_ASSIGNMENT_FAILURE';

var CHANGE_TASK_ASSIGNMENT = exports.CHANGE_TASK_ASSIGNMENT = 'at/userManagement/createUserManagementAssignmentsEditor/CHANGE_TASK_ASSIGNMENT';
var CHANGE_TASK_ASSIGNMENT_SUCCESS = exports.CHANGE_TASK_ASSIGNMENT_SUCCESS = 'at/userManagement/createUserManagementAssignmentsEditor/CHANGE_TASK_ASSIGNMENT_SUCCESS';
var CHANGE_TASK_ASSIGNMENT_FAILURE = exports.CHANGE_TASK_ASSIGNMENT_FAILURE = 'at/userManagement/createUserManagementAssignmentsEditor/CHANGE_TASK_ASSIGNMENT_FAILURE';

var ASSIGN_ALL_CUSTOMERS = exports.ASSIGN_ALL_CUSTOMERS = 'at/userManagement/createUserManagementAssignmentsEditor/ASSIGN_ALL_CUSTOMERS';
var ASSIGN_ALL_CUSTOMERS_SUCCESS = exports.ASSIGN_ALL_CUSTOMERS_SUCCESS = 'at/userManagement/createUserManagementAssignmentsEditor/ASSIGN_ALL_CUSTOMERS_SUCCESS';
var ASSIGN_ALL_CUSTOMERS_FAILURE = exports.ASSIGN_ALL_CUSTOMERS_FAILURE = 'at/userManagement/createUserManagementAssignmentsEditor/ASSIGN_ALL_CUSTOMERS_FAILURE';

var UNASSIGN_ALL_CUSTOMERS = exports.UNASSIGN_ALL_CUSTOMERS = 'at/userManagement/createUserManagementAssignmentsEditor/UNASSIGN_ALL_CUSTOMERS';
var UNASSIGN_ALL_CUSTOMERS_SUCCESS = exports.UNASSIGN_ALL_CUSTOMERS_SUCCESS = 'at/userManagement/createUserManagementAssignmentsEditor/UNASSIGN_ALL_CUSTOMERS_SUCCESS';
var UNASSIGN_ALL_CUSTOMERS_FAILURE = exports.UNASSIGN_ALL_CUSTOMERS_FAILURE = 'at/userManagement/createUserManagementAssignmentsEditor/UNASSIGN_ALL_CUSTOMERS_FAILURE';

var ASSIGN_ALL_PROJECTS = exports.ASSIGN_ALL_PROJECTS = 'at/userManagement/createUserManagementAssignmentsEditor/ASSIGN_ALL_PROJECTS';
var ASSIGN_ALL_PROJECTS_SUCCESS = exports.ASSIGN_ALL_PROJECTS_SUCCESS = 'at/userManagement/createUserManagementAssignmentsEditor/ASSIGN_ALL_PROJECTS_SUCCESS';
var ASSIGN_ALL_PROJECTS_FAILURE = exports.ASSIGN_ALL_PROJECTS_FAILURE = 'at/userManagement/createUserManagementAssignmentsEditor/ASSIGN_ALL_PROJECTS_FAILURE';

var UNASSIGN_ALL_PROJECTS = exports.UNASSIGN_ALL_PROJECTS = 'at/userManagement/createUserManagementAssignmentsEditor/UNASSIGN_ALL_PROJECTS';
var UNASSIGN_ALL_PROJECTS_SUCCESS = exports.UNASSIGN_ALL_PROJECTS_SUCCESS = 'at/userManagement/createUserManagementAssignmentsEditor/UNASSIGN_ALL_PROJECTS_SUCCESS';
var UNASSIGN_ALL_PROJECTS_FAILURE = exports.UNASSIGN_ALL_PROJECTS_FAILURE = 'at/userManagement/createUserManagementAssignmentsEditor/UNASSIGN_ALL_PROJECTS_FAILURE';

var ASSIGN_ALL_TASKS = exports.ASSIGN_ALL_TASKS = 'at/userManagement/createUserManagementAssignmentsEditor/ASSIGN_ALL_TASKS';
var ASSIGN_ALL_TASKS_SUCCESS = exports.ASSIGN_ALL_TASKS_SUCCESS = 'at/userManagement/createUserManagementAssignmentsEditor/ASSIGN_ALL_TASKS_SUCCESS';
var ASSIGN_ALL_TASKS_FAILURE = exports.ASSIGN_ALL_TASKS_FAILURE = 'at/userManagement/createUserManagementAssignmentsEditor/ASSIGN_ALL_TASKS_FAILURE';

var UNASSIGN_ALL_TASKS = exports.UNASSIGN_ALL_TASKS = 'at/userManagement/createUserManagementAssignmentsEditor/UNASSIGN_ALL_TASKS';
var UNASSIGN_ALL_TASKS_SUCCESS = exports.UNASSIGN_ALL_TASKS_SUCCESS = 'at/userManagement/createUserManagementAssignmentsEditor/UNASSIGN_ALL_TASKS_SUCCESS';
var UNASSIGN_ALL_TASKS_FAILURE = exports.UNASSIGN_ALL_TASKS_FAILURE = 'at/userManagement/createUserManagementAssignmentsEditor/UNASSIGN_ALL_TASKS_FAILURE';

var CHANGE_ALL_ASSIGNMENTS = exports.CHANGE_ALL_ASSIGNMENTS = 'at/userManagement/managementAssignmentsEditor/CHANGE_ALL_ASSIGNMENTS';
var CHANGE_ALL_ASSIGNMENTS_SUCCESS = exports.CHANGE_ALL_ASSIGNMENTS_SUCCESS = 'at/userManagement/managementAssignmentsEditor/CHANGE_ALL_ASSIGNMENTS_SUCCESS';
var CHANGE_ALL_ASSIGNMENTS_FAILURE = exports.CHANGE_ALL_ASSIGNMENTS_FAILURE = 'at/userManagement/managementAssignmentsEditor/CHANGE_ALL_ASSIGNMENTS_FAILURE';

var CUSTOMERS_SEARCH_TEXT_SET = exports.CUSTOMERS_SEARCH_TEXT_SET = 'at/userManagement/createUserManagementAssignmentsEditor/CUSTOMERS_SEARCH_TEXT_SET';
var CUSTOMERS_SEARCH_OPEN_SET = exports.CUSTOMERS_SEARCH_OPEN_SET = 'at/userManagement/createUserManagementAssignmentsEditor/CUSTOMERS_SEARCH_OPEN_SET';

var PROJECTS_SEARCH_TEXT_SET = exports.PROJECTS_SEARCH_TEXT_SET = 'at/userManagement/createUserManagementAssignmentsEditor/PROJECTS_SEARCH_TEXT_SET';
var PROJECTS_SEARCH_OPEN_SET = exports.PROJECTS_SEARCH_OPEN_SET = 'at/userManagement/createUserManagementAssignmentsEditor/PROJECTS_SEARCH_OPEN_SET';

var TASKS_SEARCH_TEXT_SET = exports.TASKS_SEARCH_TEXT_SET = 'at/userManagement/createUserManagementAssignmentsEditor/TASKS_SEARCH_TEXT_SET';
var TASKS_SEARCH_OPEN_SET = exports.TASKS_SEARCH_OPEN_SET = 'at/userManagement/createUserManagementAssignmentsEditor/TASKS_SEARCH_OPEN_SET';

var PROJECTS_TASKS_COUNT_CLEAR = exports.PROJECTS_TASKS_COUNT_CLEAR = 'at/userManagement/createUserManagementAssignmentsEditor/PROJECTS_TASKS_COUNT_CLEAR';
var CUSTOMERS_TASKS_COUNT_CLEAR = exports.CUSTOMERS_TASKS_COUNT_CLEAR = 'at/userManagement/createUserManagementAssignmentsEditor/CUSTOMERS_TASKS_COUNT_CLEAR';
var CUSTOMERS_PROJECTS_COUNT_CLEAR = exports.CUSTOMERS_PROJECTS_COUNT_CLEAR = 'at/userManagement/createUserManagementAssignmentsEditor/CUSTOMERS_PROJECTS_COUNT_CLEAR';

/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var USER_IDS_ORDER_SET = exports.USER_IDS_ORDER_SET = 'at/userManagement/workAssignments/USER_IDS_ORDER_SET';
var SET_LOADED = exports.SET_LOADED = 'at/userManagement/workAssignments/SET_LOADED';
var LOAD_USERS_DATA = exports.LOAD_USERS_DATA = 'at/userManagement/workAssignments/LOAD_USERS_DATA';
var LOAD_USERS_DATA_SUCCESS = exports.LOAD_USERS_DATA_SUCCESS = 'at/userManagement/workAssignments/LOAD_USERS_DATA_SUCCESS';
var LOAD_USERS_DATA_FAILURE = exports.LOAD_USERS_DATA_FAILURE = 'at/userManagement/workAssignments/LOAD_USERS_DATA_FAILURE';
var SET_SORTING = exports.SET_SORTING = 'at/userManagement/workAssignments/SET_SORTING';
var SET_USERS_FILTER = exports.SET_USERS_FILTER = 'at/userManagement/workAssignments/SET_GROUPS_FILTER';
var SET_WORDS_FILTER = exports.SET_WORDS_FILTER = 'at/userManagement/workAssignments/SET_WORDS_FILTER';
var SET_SUBMITTED_WORDS_FILTER = exports.SET_SUBMITTED_WORDS_FILTER = 'at/userManagement/workAssignments/SET_SUBMITTED_WORDS_FILTER';
var SET_USERS_PER_PAGE = exports.SET_USERS_PER_PAGE = 'at/userManagement/workAssignments/SET_USERS_PER_PAGE';
var SET_PAGE_NUM = exports.SET_PAGE_NUM = 'at/userManagement/workAssignments/SET_PAGE_NUM';
var SET_WORK_ASSIGNMENTS_FILTER = exports.SET_WORK_ASSIGNMENTS_FILTER = 'at/userManagement/workAssignments/SET_WORK_ASSIGNMENTS_FILTER';
var SET_USER_WORK_ASSIGNMENT_COUNTERS = exports.SET_USER_WORK_ASSIGNMENT_COUNTERS = 'at/userManagement/workAssignmnets/SET_USER_WORK_ASSIGNMENTS_COUNTER';
var SET_USERS_WORK_ASSIGNMENTS_COUNTERS = exports.SET_USERS_WORK_ASSIGNMENTS_COUNTERS = 'at/userManagement/workAssignments/SET_USERS_WORK_ASSIGNMENTS_COUNTERS';
var ADD_USER_WORK_ASSIGNMENTS_COUNTERS = exports.ADD_USER_WORK_ASSIGNMENTS_COUNTERS = 'at/userManagement/workAssignments/ADD_USER_WORK_ASSIGNMENTS_COUNTERS';
var SET_LOADING = exports.SET_LOADING = 'at/userManagement/workAssignments/SET_LOADING';

/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var createSettingsJsonData = exports.createSettingsJsonData = function createSettingsJsonData(usersFilter, sorting, workAssignmentsFilter, nUsersPerPage) {
    return {
        usersFilter: usersFilter,
        sorting: sorting,
        workAssignmentsFilter: workAssignmentsFilter,
        nUsersPerPage: nUsersPerPage
    };
};

var convertSettingsJsonData = exports.convertSettingsJsonData = function convertSettingsJsonData(jsonData) {
    var settings = {};
    if (jsonData) {
        if (jsonData.usersFilter !== undefined) settings.usersFilter = jsonData.usersFilter;
        if (jsonData.workAssignmentsFilter !== undefined) settings.workAssignmentsFilter = jsonData.workAssignmentsFilter;
        if (jsonData.sorting !== undefined) settings.sorting = jsonData.sorting;
        if (jsonData.nUsersPerPage !== undefined) settings.nUsersPerPage = jsonData.nUsersPerPage;
    }
    return settings;
};

/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var USER_ID_SET = exports.USER_ID_SET = 'at/userManagement/workAssignmentPanel/USER_ID_SET';
var PANEL_TAB_SET = exports.PANEL_TAB_SET = 'at/userManagement/workAssignmentPanel/PANEL_TAB_SET';
var TASK_IDS_SET = exports.TASK_IDS_SET = 'at/userManagement/workAssignmentPanel/TASK_IDS_SET';
var PROJECT_IDS_SET = exports.PROJECT_IDS_SET = 'at/userManagement/workAssignmentPanel/PROJECT_IDS_SET';
var CUSTOMER_IDS_SET = exports.CUSTOMER_IDS_SET = 'at/userManagement/workAssignmentPanel/CUSTOMER_IDS_SET';
var MANAGE_TASK_IDS_SET = exports.MANAGE_TASK_IDS_SET = 'at/userManagement/workAssignmentPanel/MANAGE_TASK_IDS_SET';
var MANAGE_PROJECT_IDS_SET = exports.MANAGE_PROJECT_IDS_SET = 'at/userManagement/workAssignmentPanel/MANAGE_PROJECT_IDS_SET';
var MANAGE_EXCLUDING_SELF_PROJECT_IDS_SET = exports.MANAGE_EXCLUDING_SELF_PROJECT_IDS_SET = 'at/userManagement/workAssignmentPanel/MANAGE_EXCLUDING_SELF_PROJECT_IDS_SET';
var MANAGE_CUSTOMER_IDS_SET = exports.MANAGE_CUSTOMER_IDS_SET = 'at/userManagement/workAssignmentPanel/MANAGE_CUSTOMER_IDS_SET';
var MANAGE_EXCLUDING_SELF_CUSTOMER_IDS_SET = exports.MANAGE_EXCLUDING_SELF_CUSTOMER_IDS_SET = 'at/userManagement/workAssignmentPanel/MANAGE_EXCLUDING_SELF_CUSTOMER_IDS_SET';
var TASK_TAB_LOADED = exports.TASK_TAB_LOADED = 'at/userManagement/workAssignmentPanel/TASK_TAB_LOADED';
var PROJECT_TAB_LOADED = exports.PROJECT_TAB_LOADED = 'at/userManagement/workAssignmentPanel/PROJECT_TAB_LOADED';
var CUSTOMER_TAB_LOADED = exports.CUSTOMER_TAB_LOADED = 'at/userManagement/workAssignmentPanel/CUSTOMER_TAB_LOADED';
var USER_COUNTERS_SET = exports.USER_COUNTERS_SET = 'at/userManagement/workAssignmentPanel/USER_COUNTERS_SET';
var VIEWER_COUNTERS_SET = exports.VIEWER_COUNTERS_SET = 'at/userManagement/workAssignmentPanel/VIEWER_COUNTERS_SET';
var USER_HAVE_NO_CPT_AT_ALL_SET = exports.USER_HAVE_NO_CPT_AT_ALL_SET = 'at/userManagement/workAssignmentPanel/USER_HAVE_NO_CPT_AT_ALL_SET';
var PANEL_SEARCH_STRING_SET = exports.PANEL_SEARCH_STRING_SET = 'at/userManagement/workAssignmentPanel/PANEL_SEARCH_STRING_SET';
var PANEL_SEARCH_OPEN_SET = exports.PANEL_SEARCH_OPEN_SET = 'at/userManagement/workAssignmentPanel/PANEL_SEARCH_OPEN_SET';

var PANEL_CLOSE = exports.PANEL_CLOSE = 'at/userManagement/workAssignmnetsPanel/PANEL_CLOSE';
var PANEL_OPEN = exports.PANEL_OPEN = 'at/userManagement/workAssignmnetsPanel/PANEL_OPEN';
var LOADED_SET = exports.LOADED_SET = 'at/userManagement/workAssignmnetsPanel/PANEL_LOADED_SET';
var LOADING_SET = exports.LOADING_SET = 'at/userManagement/workAssignmnetsPanel/PANEL_LOADING';
var SHOW_COPY_SET = exports.SHOW_COPY_SET = 'at/userManagement/workAssignmnetsPanel/SHOW_COPY_SET';

var COPY_USER_ID_SET = exports.COPY_USER_ID_SET = 'at/userManagement/workAssignmnetsPanel/copy/COPY_USER_ID_SET';
var COPY_LOADING_SET = exports.COPY_LOADING_SET = 'at/userManagement/workAssignmnetsPanel/copy/COPY_LOADING_SET';
var COPY_ALL_SCOPE_SET = exports.COPY_ALL_SCOPE_SET = 'at/userManagement/workAssignmnetsPanel/copy/COPY_ALL_SCOPE_SET';
var COPY_COUNTERS_SET = exports.COPY_COUNTERS_SET = 'at/userManagement/workAssignmnetsPanel/copy/COPY_COUNTERS_SET';
var COPY_OPTION_SET = exports.COPY_OPTION_SET = 'at/userManagement/workAssignmnetsPanel/copy/COPY_OPTION_SET';
var COPY_USER_IDS_FOR_SELECTOR_SET = exports.COPY_USER_IDS_FOR_SELECTOR_SET = 'at/userManagement/workAssignmnetsPanel/copy/COPY_USER_IDS_FOR_SELECTOR_SET';

var COPY_CONTENT_OPEN = exports.COPY_CONTENT_OPEN = 'at/userManagement/workAssignmnetsPanel/copy/COPY_CONTENT_OPEN';
var COPY_CONTENT_CLOSE = exports.COPY_CONTENT_CLOSE = 'at/userManagement/workAssignmnetsPanel/copy/COPY_CONTENT_CLOSE';

var COPY_VIEWER_HAS_ENTIRE_SCOPE_SET = exports.COPY_VIEWER_HAS_ENTIRE_SCOPE_SET = 'at/userManagement/workAssignmnetsPanel/copy/COPY_VIEWER_HAS_ENTIRE_SCOPE_SET';

var ASSIGN_ALL_SCOPE_CONTENT_OPEN = exports.ASSIGN_ALL_SCOPE_CONTENT_OPEN = 'at/userManagement/workAssignmnetsPanel/copy/ASSIGN_ALL_SCOPE_CONTENT_OPEN';
var ASSIGN_ALL_SCOPE_CONTENT_CLOSE = exports.ASSIGN_ALL_SCOPE_CONTENT_CLOSE = 'at/userManagement/workAssignmnetsPanel/copy/ASSIGN_ALL_SCOPE_CONTENT_CLOSE';

var SET_IS_SHOW_ARCHIVE_ENTITIES = exports.SET_IS_SHOW_ARCHIVE_ENTITIES = 'at/userManagement/workAssignmnetsPanel/SET_IS_SHOW_ARCHIVE_ENTITIES';

/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var CLEAR = exports.CLEAR = 'at/userManagement/workAssignmentsEditor/CLEAR';
var CLEAR_CUSTOMERS = exports.CLEAR_CUSTOMERS = 'at/userManagement/workAssignmentsEditor/CLEAR_CUSTOMERS';
var CLEAR_PROJECTS = exports.CLEAR_PROJECTS = 'at/userManagement/workAssignmentsEditor/CLEAR_PROJECTS';
var CLEAR_TASKS = exports.CLEAR_TASKS = 'at/userManagement/workAssignmentsEditor/CLEAR_TASKS';
var EDITING_USER_ID_SET = exports.EDITING_USER_ID_SET = 'at/userManagement/workAssignmentsEditor/EDITING_USER_ID_SET';
var EDITING_LEVEL_SET = exports.EDITING_LEVEL_SET = 'at/userManagement/workAssignmentsEditor/EDITING_LEVEL_SET';
var LOADED_SET = exports.LOADED_SET = 'at/userManagement/workAssignmentsEditor/LOADED_SET';
var CUSTOMERS_LOADED_SET = exports.CUSTOMERS_LOADED_SET = 'at/userManagement/workAssignmentsEditor/CUSTOMERS_LOADED_SET';
var PROJECTS_LOADED_SET = exports.PROJECTS_LOADED_SET = 'at/userManagement/workAssignmentsEditor/PROJECTS_LOADED_SET';
var TASKS_LOADED_SET = exports.TASKS_LOADED_SET = 'at/userManagement/workAssignmentsEditor/TASKS_LOADED_SET';

var PROJECTS_TASKS_COUNT_CLEAR = exports.PROJECTS_TASKS_COUNT_CLEAR = 'at/userManagement/workAssignmentsEditor/PROJECTS_TASKS_COUNT_CLEAR';
var CUSTOMERS_TASKS_COUNT_CLEAR = exports.CUSTOMERS_TASKS_COUNT_CLEAR = 'at/userManagement/workAssignmentsEditor/CUSTOMERS_TASKS_COUNT_CLEAR';
var CUSTOMERS_PROJECTS_COUNT_CLEAR = exports.CUSTOMERS_PROJECTS_COUNT_CLEAR = 'at/userManagement/workAssignmentsEditor/CUSTOMERS_PROJECTS_COUNT_CLEAR';

var LOAD_CUSTOMER_ASSIGNMENTS_EDITOR_DATA = exports.LOAD_CUSTOMER_ASSIGNMENTS_EDITOR_DATA = 'at/userManagement/workAssignmentsEditor/LOAD_CUSTOMER_ASSIGNMENTS_EDITOR_DATA';
var LOAD_CUSTOMER_ASSIGNMENTS_EDITOR_DATA_SUCCESS = exports.LOAD_CUSTOMER_ASSIGNMENTS_EDITOR_DATA_SUCCESS = 'at/userManagement/workAssignmentsEditor/LOAD_CUSTOMER_ASSIGNMENTS_EDITOR_DATA_SUCCESS';
var LOAD_CUSTOMER_ASSIGNMENTS_EDITOR_DATA_FAILURE = exports.LOAD_CUSTOMER_ASSIGNMENTS_EDITOR_DATA_FAILURE = 'at/userManagement/workAssignmentsEditor/LOAD_CUSTOMER_ASSIGNMENTS_EDITOR_DATA_FAILURE';

var LOAD_PROJECT_ASSIGNMENTS_EDITOR_DATA = exports.LOAD_PROJECT_ASSIGNMENTS_EDITOR_DATA = 'at/userManagement/workAssignmentsEditor/LOAD_PROJECT_ASSIGNMENTS_EDITOR_DATA';
var LOAD_PROJECT_ASSIGNMENTS_EDITOR_DATA_SUCCESS = exports.LOAD_PROJECT_ASSIGNMENTS_EDITOR_DATA_SUCCESS = 'at/userManagement/workAssignmentsEditor/LOAD_PROJECT_ASSIGNMENTS_EDITOR_DATA_SUCCESS';
var LOAD_PROJECT_ASSIGNMENTS_EDITOR_DATA_FAILURE = exports.LOAD_PROJECT_ASSIGNMENTS_EDITOR_DATA_FAILURE = 'at/userManagement/workAssignmentsEditor/LOAD_PROJECT_ASSIGNMENTS_EDITOR_DATA_FAILURE';

var LOAD_TASK_ASSIGNMENTS_EDITOR_DATA = exports.LOAD_TASK_ASSIGNMENTS_EDITOR_DATA = 'at/userManagement/workAssignmentsEditor/LOAD_TASK_ASSIGNMENTS_EDITOR_DATA';
var LOAD_TASK_ASSIGNMENTS_EDITOR_DATA_SUCCESS = exports.LOAD_TASK_ASSIGNMENTS_EDITOR_DATA_SUCCESS = 'at/userManagement/workAssignmentsEditor/LOAD_TASK_ASSIGNMENTS_EDITOR_DATA_SUCCESS';
var LOAD_TASK_ASSIGNMENTS_EDITOR_DATA_FAILURE = exports.LOAD_TASK_ASSIGNMENTS_EDITOR_DATA_FAILURE = 'at/userManagement/workAssignmentsEditor/LOAD_TASK_ASSIGNMENTS_EDITOR_DATA_FAILURE';

var CHANGE_CUSTOMER_ASSIGNMENT = exports.CHANGE_CUSTOMER_ASSIGNMENT = 'at/userManagement/workAssignmentsEditor/CHANGE_CUSTOMER_ASSIGNMENT';
var CHANGE_CUSTOMER_ASSIGNMENT_SUCCESS = exports.CHANGE_CUSTOMER_ASSIGNMENT_SUCCESS = 'at/userManagement/workAssignmentsEditor/CHANGE_CUSTOMER_ASSIGNMENT_SUCCESS';
var CHANGE_CUSTOMER_ASSIGNMENT_FAILURE = exports.CHANGE_CUSTOMER_ASSIGNMENT_FAILURE = 'at/userManagement/workAssignmentsEditor/CHANGE_CUSTOMER_ASSIGNMENT_FAILURE';

var CHANGE_PROJECT_ASSIGNMENT = exports.CHANGE_PROJECT_ASSIGNMENT = 'at/userManagement/workAssignmentsEditor/CHANGE_PROJECT_ASSIGNMENT';
var CHANGE_PROJECT_ASSIGNMENT_SUCCESS = exports.CHANGE_PROJECT_ASSIGNMENT_SUCCESS = 'at/userManagement/workAssignmentsEditor/CHANGE_PROJECT_ASSIGNMENT_SUCCESS';
var CHANGE_PROJECT_ASSIGNMENT_FAILURE = exports.CHANGE_PROJECT_ASSIGNMENT_FAILURE = 'at/userManagement/workAssignmentsEditor/CHANGE_PROJECT_ASSIGNMENT_FAILURE';

var CHANGE_TASK_ASSIGNMENT = exports.CHANGE_TASK_ASSIGNMENT = 'at/userManagement/workAssignmentsEditor/CHANGE_TASK_ASSIGNMENT';
var CHANGE_TASK_ASSIGNMENT_SUCCESS = exports.CHANGE_TASK_ASSIGNMENT_SUCCESS = 'at/userManagement/workAssignmentsEditor/CHANGE_TASK_ASSIGNMENT_SUCCESS';
var CHANGE_TASK_ASSIGNMENT_FAILURE = exports.CHANGE_TASK_ASSIGNMENT_FAILURE = 'at/userManagement/workAssignmentsEditor/CHANGE_TASK_ASSIGNMENT_FAILURE';

var ASSIGN_ALL_CUSTOMERS = exports.ASSIGN_ALL_CUSTOMERS = 'at/userManagement/workAssignmentsEditor/ASSIGN_ALL_CUSTOMERS';
var ASSIGN_ALL_CUSTOMERS_SUCCESS = exports.ASSIGN_ALL_CUSTOMERS_SUCCESS = 'at/userManagement/workAssignmentsEditor/ASSIGN_ALL_CUSTOMERS_SUCCESS';
var ASSIGN_ALL_CUSTOMERS_FAILURE = exports.ASSIGN_ALL_CUSTOMERS_FAILURE = 'at/userManagement/workAssignmentsEditor/ASSIGN_ALL_CUSTOMERS_FAILURE';

var UNASSIGN_ALL_CUSTOMERS = exports.UNASSIGN_ALL_CUSTOMERS = 'at/userManagement/workAssignmentsEditor/UNASSIGN_ALL_CUSTOMERS';
var UNASSIGN_ALL_CUSTOMERS_SUCCESS = exports.UNASSIGN_ALL_CUSTOMERS_SUCCESS = 'at/userManagement/workAssignmentsEditor/UNASSIGN_ALL_CUSTOMERS_SUCCESS';
var UNASSIGN_ALL_CUSTOMERS_FAILURE = exports.UNASSIGN_ALL_CUSTOMERS_FAILURE = 'at/userManagement/workAssignmentsEditor/UNASSIGN_ALL_CUSTOMERS_FAILURE';

var ASSIGN_ALL_PROJECTS = exports.ASSIGN_ALL_PROJECTS = 'at/userManagement/workAssignmentsEditor/ASSIGN_ALL_PROJECTS';
var ASSIGN_ALL_PROJECTS_SUCCESS = exports.ASSIGN_ALL_PROJECTS_SUCCESS = 'at/userManagement/workAssignmentsEditor/ASSIGN_ALL_PROJECTS_SUCCESS';
var ASSIGN_ALL_PROJECTS_FAILURE = exports.ASSIGN_ALL_PROJECTS_FAILURE = 'at/userManagement/workAssignmentsEditor/ASSIGN_ALL_PROJECTS_FAILURE';

var UNASSIGN_ALL_PROJECTS = exports.UNASSIGN_ALL_PROJECTS = 'at/userManagement/workAssignmentsEditor/UNASSIGN_ALL_PROJECTS';
var UNASSIGN_ALL_PROJECTS_SUCCESS = exports.UNASSIGN_ALL_PROJECTS_SUCCESS = 'at/userManagement/workAssignmentsEditor/UNASSIGN_ALL_PROJECTS_SUCCESS';
var UNASSIGN_ALL_PROJECTS_FAILURE = exports.UNASSIGN_ALL_PROJECTS_FAILURE = 'at/userManagement/workAssignmentsEditor/UNASSIGN_ALL_PROJECTS_FAILURE';

var ASSIGN_ALL_TASKS = exports.ASSIGN_ALL_TASKS = 'at/userManagement/workAssignmentsEditor/ASSIGN_ALL_TASKS';
var ASSIGN_ALL_TASKS_SUCCESS = exports.ASSIGN_ALL_TASKS_SUCCESS = 'at/userManagement/workAssignmentsEditor/ASSIGN_ALL_TASKS_SUCCESS';
var ASSIGN_ALL_TASKS_FAILURE = exports.ASSIGN_ALL_TASKS_FAILURE = 'at/userManagement/workAssignmentsEditor/ASSIGN_ALL_TASKS_FAILURE';

var UNASSIGN_ALL_TASKS = exports.UNASSIGN_ALL_TASKS = 'at/userManagement/workAssignmentsEditor/UNASSIGN_ALL_TASKS';
var UNASSIGN_ALL_TASKS_SUCCESS = exports.UNASSIGN_ALL_TASKS_SUCCESS = 'at/userManagement/workAssignmentsEditor/UNASSIGN_ALL_TASKS_SUCCESS';
var UNASSIGN_ALL_TASKS_FAILURE = exports.UNASSIGN_ALL_TASKS_FAILURE = 'at/userManagement/workAssignmentsEditor/UNASSIGN_ALL_TASKS_FAILURE';

var CHANGE_ALL_ASSIGNMENTS = exports.CHANGE_ALL_ASSIGNMENTS = 'at/userManagement/workAssignmentsEditor/CHANGE_ALL_ASSIGNMENTS';
var CHANGE_ALL_ASSIGNMENTS_SUCCESS = exports.CHANGE_ALL_ASSIGNMENTS_SUCCESS = 'at/userManagement/workAssignmentsEditor/CHANGE_ALL_ASSIGNMENTS_SUCCESS';
var CHANGE_ALL_ASSIGNMENTS_FAILURE = exports.CHANGE_ALL_ASSIGNMENTS_FAILURE = 'at/userManagement/workAssignmentsEditor/CHANGE_ALL_ASSIGNMENTS_FAILURE';

var CUSTOMERS_SEARCH_TEXT_SET = exports.CUSTOMERS_SEARCH_TEXT_SET = 'at/userManagement/workAssignmentsEditor/CUSTOMERS_SEARCH_TEXT_SET';
var CUSTOMERS_SEARCH_OPEN_SET = exports.CUSTOMERS_SEARCH_OPEN_SET = 'at/userManagement/workAssignmentsEditor/CUSTOMERS_SEARCH_OPEN_SET';

var PROJECTS_SEARCH_TEXT_SET = exports.PROJECTS_SEARCH_TEXT_SET = 'at/userManagement/workAssignmentsEditor/PROJECTS_SEARCH_TEXT_SET';
var PROJECTS_SEARCH_OPEN_SET = exports.PROJECTS_SEARCH_OPEN_SET = 'at/userManagement/workAssignmentsEditor/PROJECTS_SEARCH_OPEN_SET';

var TASKS_SEARCH_TEXT_SET = exports.TASKS_SEARCH_TEXT_SET = 'at/userManagement/workAssignmentsEditor/TASKS_SEARCH_TEXT_SET';
var TASKS_SEARCH_OPEN_SET = exports.TASKS_SEARCH_OPEN_SET = 'at/userManagement/workAssignmentsEditor/TASKS_SEARCH_OPEN_SET';

/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var USER_ID_SET = exports.USER_ID_SET = 'at/userManagement/managementAssignmentPanel/USER_ID_SET';
var PANEL_TAB_SET = exports.PANEL_TAB_SET = 'at/userManagement/managementAssignmentPanel/PANEL_TAB_SET';
var TASK_IDS_SET = exports.TASK_IDS_SET = 'at/userManagement/managementAssignmentPanel/TASK_IDS_SET';
var PROJECT_IDS_SET = exports.PROJECT_IDS_SET = 'at/userManagement/managementAssignmentPanel/PROJECT_IDS_SET';
var CUSTOMER_IDS_SET = exports.CUSTOMER_IDS_SET = 'at/userManagement/managementAssignmentPanel/CUSTOMER_IDS_SET';
var MANAGE_TASK_IDS_SET = exports.MANAGE_TASK_IDS_SET = 'at/userManagement/managementAssignmentPanel/MANAGE_TASK_IDS_SET';
var MANAGE_PROJECT_IDS_SET = exports.MANAGE_PROJECT_IDS_SET = 'at/userManagement/managementAssignmentPanel/MANAGE_PROJECT_IDS_SET';
var MANAGE_EXCLUDING_SELF_PROJECT_IDS_SET = exports.MANAGE_EXCLUDING_SELF_PROJECT_IDS_SET = 'at/userManagement/managementAssignmentPanel/MANAGE_EXCLUDING_SELF_PROJECT_IDS_SET';
var MANAGE_CUSTOMER_IDS_SET = exports.MANAGE_CUSTOMER_IDS_SET = 'at/userManagement/managementAssignmentPanel/MANAGE_CUSTOMER_IDS_SET';
var MANAGE_EXCLUDING_SELF_CUSTOMER_IDS_SET = exports.MANAGE_EXCLUDING_SELF_CUSTOMER_IDS_SET = 'at/userManagement/managementAssignmentPanel/MANAGE_EXCLUDING_SELF_CUSTOMER_IDS_SET';
var TASK_TAB_LOADED = exports.TASK_TAB_LOADED = 'at/userManagement/managementAssignmentPanel/TASK_TAB_LOADED';
var PROJECT_TAB_LOADED = exports.PROJECT_TAB_LOADED = 'at/userManagement/managementAssignmentPanel/PROJECT_TAB_LOADED';
var CUSTOMER_TAB_LOADED = exports.CUSTOMER_TAB_LOADED = 'at/userManagement/managementAssignmentPanel/CUSTOMER_TAB_LOADED';
var USER_COUNTERS_SET = exports.USER_COUNTERS_SET = 'at/userManagement/managementAssignmentPanel/USER_COUNTERS_SET';
var VIEWER_COUNTERS_SET = exports.VIEWER_COUNTERS_SET = 'at/userManagement/managementAssignmentPanel/VIEWER_COUNTERS_SET';
var PANEL_SEARCH_STRING_SET = exports.PANEL_SEARCH_STRING_SET = 'at/userManagement/managementAssignmentPanel/PANEL_SEARCH_STRING_SET';
var PANEL_SEARCH_OPEN_SET = exports.PANEL_SEARCH_OPEN_SET = 'at/userManagement/managementAssignmentPanel/PANEL_SEARCH_OPEN_SET';

var PANEL_OPEN = exports.PANEL_OPEN = 'at/userManagement/managementAssignmentPanel/PANEL_OPEN';
var PANEL_CLOSE = exports.PANEL_CLOSE = 'at/userManagement/managementAssignmentPanel/PANEL_CLOSE';
var LOADING_SET = exports.LOADING_SET = 'at/userManagement/managementAssignmentPanel/LOADING_SET';
var LOADED_SET = exports.LOADED_SET = 'at/userManagement/managementAssignmentPanel/LOADED_SET';

var SET_IS_SHOW_ARCHIVE_ENTITIES = exports.SET_IS_SHOW_ARCHIVE_ENTITIES = 'at/userManagement/managementAssignmentPanel/SET_IS_SHOW_ARCHIVE_ENTITIES';

var COPY_CONTENT_OPEN = exports.COPY_CONTENT_OPEN = 'at/userManagement/managementAssignmentPanel/COPY_CONTENT_OPEN';
var COPY_CONTENT_CLOSE = exports.COPY_CONTENT_CLOSE = 'at/userManagement/managementAssignmentPanel/COPY_CONTENT_CLOSE';
var COPY_USER_ID_SET = exports.COPY_USER_ID_SET = 'at/userManagement/managementAssignmentPanel/copy/COPY_USER_ID_SET';
var COPY_LOADING_SET = exports.COPY_LOADING_SET = 'at/userManagement/managementAssignmentPanel/copy/COPY_LOADING_SET';
var COPY_COUNTERS_SET = exports.COPY_COUNTERS_SET = 'at/userManagement/managementAssignmentPanel/copy/COPY_COUNTERS_SET';
var COPY_USER_IDS_FOR_SELECTOR_SET = exports.COPY_USER_IDS_FOR_SELECTOR_SET = 'at/userManagement/managementAssignmentPanel/copy/COPY_USER_IDS_FOR_SELECTOR_SET';

/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var USER_ID_SET = exports.USER_ID_SET = 'at/userManagement/createManagementAssignmentPanel/USER_ID_SET';
var PANEL_TAB_SET = exports.PANEL_TAB_SET = 'at/userManagement/createManagementAssignmentPanel/PANEL_TAB_SET';
var TASK_IDS_SET = exports.TASK_IDS_SET = 'at/userManagement/createManagementAssignmentPanel/TASK_IDS_SET';
var PROJECT_IDS_SET = exports.PROJECT_IDS_SET = 'at/userManagement/createManagementAssignmentPanel/PROJECT_IDS_SET';
var CUSTOMER_IDS_SET = exports.CUSTOMER_IDS_SET = 'at/userManagement/createManagementAssignmentPanel/CUSTOMER_IDS_SET';
var MANAGE_TASK_IDS_SET = exports.MANAGE_TASK_IDS_SET = 'at/userManagement/createManagementAssignmentPanel/MANAGE_TASK_IDS_SET';
var MANAGE_PROJECT_IDS_SET = exports.MANAGE_PROJECT_IDS_SET = 'at/userManagement/createManagementAssignmentPanel/MANAGE_PROJECT_IDS_SET';
var MANAGE_EXCLUDING_SELF_PROJECT_IDS_SET = exports.MANAGE_EXCLUDING_SELF_PROJECT_IDS_SET = 'at/userManagement/createManagementAssignmentPanel/MANAGE_EXCLUDING_SELF_PROJECT_IDS_SET';
var MANAGE_CUSTOMER_IDS_SET = exports.MANAGE_CUSTOMER_IDS_SET = 'at/userManagement/createManagementAssignmentPanel/MANAGE_CUSTOMER_IDS_SET';
var MANAGE_EXCLUDING_SELF_CUSTOMER_IDS_SET = exports.MANAGE_EXCLUDING_SELF_CUSTOMER_IDS_SET = 'at/userManagement/createManagementAssignmentPanel/MANAGE_EXCLUDING_SELF_CUSTOMER_IDS_SET';
var TASK_TAB_LOADED = exports.TASK_TAB_LOADED = 'at/userManagement/createManagementAssignmentPanel/TASK_TAB_LOADED';
var PROJECT_TAB_LOADED = exports.PROJECT_TAB_LOADED = 'at/userManagement/createManagementAssignmentPanel/PROJECT_TAB_LOADED';
var CUSTOMER_TAB_LOADED = exports.CUSTOMER_TAB_LOADED = 'at/userManagement/createManagementAssignmentPanel/CUSTOMER_TAB_LOADED';
var USER_COUNTERS_SET = exports.USER_COUNTERS_SET = 'at/userManagement/createManagementAssignmentPanel/USER_COUNTERS_SET';
var VIEWER_COUNTERS_SET = exports.VIEWER_COUNTERS_SET = 'at/userManagement/createManagementAssignmentPanel/VIEWER_COUNTERS_SET';
var PANEL_SEARCH_STRING_SET = exports.PANEL_SEARCH_STRING_SET = 'at/userManagement/createManagementAssignmentPanel/PANEL_SEARCH_STRING_SET';
var PANEL_SEARCH_OPEN_SET = exports.PANEL_SEARCH_OPEN_SET = 'at/userManagement/createManagementAssignmentPanel/PANEL_SEARCH_OPEN_SET';

var PANEL_OPEN = exports.PANEL_OPEN = 'at/userManagement/createManagementAssignmentPanel/PANEL_OPEN';
var PANEL_CLOSE = exports.PANEL_CLOSE = 'at/userManagement/createManagementAssignmentPanel/PANEL_CLOSE';
var LOADING_SET = exports.LOADING_SET = 'at/userManagement/createManagementAssignmentPanel/LOADING_SET';
var LOADED_SET = exports.LOADED_SET = 'at/userManagement/createManagementAssignmentPanel/LOADED_SET';
var SHOWN_SET = exports.SHOWN_SET = 'at/userManagement/createManagementAssignmentPanel/SHOWN_SET';
var ALL_SCOPE_SET = exports.ALL_SCOPE_SET = 'at/userManagement/createManagementAssignmentPanel/ALL_SCOPE_SET';

var SET_IS_SHOW_ARCHIVE_ENTITIES = exports.SET_IS_SHOW_ARCHIVE_ENTITIES = 'at/userManagement/createManagementAssignmentPanel/SET_IS_SHOW_ARCHIVE_ENTITIES';

/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var CLEAR = exports.CLEAR = 'at/userManagement/managementAssignmentsEditor/CLEAR';
var CLEAR_CUSTOMERS = exports.CLEAR_CUSTOMERS = 'at/userManagement/managementAssignmentsEditor/CLEAR_CUSTOMERS';
var CLEAR_PROJECTS = exports.CLEAR_PROJECTS = 'at/userManagement/managementAssignmentsEditor/CLEAR_PROJECTS';
var CLEAR_TASKS = exports.CLEAR_TASKS = 'at/userManagement/managementAssignmentsEditor/CLEAR_TASKS';
var EDITING_USER_ID_SET = exports.EDITING_USER_ID_SET = 'at/userManagement/managementAssignmentsEditor/EDITING_USER_ID_SET';
var EDITING_LEVEL_SET = exports.EDITING_LEVEL_SET = 'at/userManagement/managementAssignmentsEditor/EDITING_LEVEL_SET';
var LOADED_SET = exports.LOADED_SET = 'at/userManagement/managementAssignmentsEditor/LOADED_SET';
var CUSTOMERS_LOADED_SET = exports.CUSTOMERS_LOADED_SET = 'at/userManagement/managementAssignmentsEditor/CUSTOMERS_LOADED_SET';
var PROJECTS_LOADED_SET = exports.PROJECTS_LOADED_SET = 'at/userManagement/managementAssignmentsEditor/PROJECTS_LOADED_SET';
var TASKS_LOADED_SET = exports.TASKS_LOADED_SET = 'at/userManagement/managementAssignmentsEditor/TASKS_LOADED_SET';
var ONLY_ACTIVE_ENTITIES_SET = exports.ONLY_ACTIVE_ENTITIES_SET = 'at/userManagement/managementAssignmentsEditor/ONLY_ACTIVE_ENTITIES_SET';
var ALL_EXISTING_AND_FUTURE_PROJECTS = exports.ALL_EXISTING_AND_FUTURE_PROJECTS = 'at/userManagement/managementAssignmentsEditor/ALL_EXISTING_AND_FUTURE_PROJECTS';
var ALL_EXISTING_AND_FUTURE_TASKS = exports.ALL_EXISTING_AND_FUTURE_TASKS = 'at/userManagement/managementAssignmentsEditor/ALL_EXISTING_AND_FUTURE_TASKS';

var PROJECTS_TASKS_COUNT_CLEAR = exports.PROJECTS_TASKS_COUNT_CLEAR = 'at/userManagement/managementAssignmentsEditor/PROJECTS_TASKS_COUNT_CLEAR';
var CUSTOMERS_TASKS_COUNT_CLEAR = exports.CUSTOMERS_TASKS_COUNT_CLEAR = 'at/userManagement/managementAssignmentsEditor/CUSTOMERS_TASKS_COUNT_CLEAR';
var CUSTOMERS_PROJECTS_COUNT_CLEAR = exports.CUSTOMERS_PROJECTS_COUNT_CLEAR = 'at/userManagement/managementAssignmentsEditor/CUSTOMERS_PROJECTS_COUNT_CLEAR';

var LOAD_CUSTOMER_ASSIGNMENTS_EDITOR_DATA = exports.LOAD_CUSTOMER_ASSIGNMENTS_EDITOR_DATA = 'at/userManagement/managementAssignmentsEditor/LOAD_CUSTOMER_ASSIGNMENTS_EDITOR_DATA';
var LOAD_CUSTOMER_ASSIGNMENTS_EDITOR_DATA_SUCCESS = exports.LOAD_CUSTOMER_ASSIGNMENTS_EDITOR_DATA_SUCCESS = 'at/userManagement/managementAssignmentsEditor/LOAD_CUSTOMER_ASSIGNMENTS_EDITOR_DATA_SUCCESS';
var LOAD_CUSTOMER_ASSIGNMENTS_EDITOR_DATA_FAILURE = exports.LOAD_CUSTOMER_ASSIGNMENTS_EDITOR_DATA_FAILURE = 'at/userManagement/managementAssignmentsEditor/LOAD_CUSTOMER_ASSIGNMENTS_EDITOR_DATA_FAILURE';

var LOAD_PROJECT_ASSIGNMENTS_EDITOR_DATA = exports.LOAD_PROJECT_ASSIGNMENTS_EDITOR_DATA = 'at/userManagement/managementAssignmentsEditor/LOAD_PROJECT_ASSIGNMENTS_EDITOR_DATA';
var LOAD_PROJECT_ASSIGNMENTS_EDITOR_DATA_SUCCESS = exports.LOAD_PROJECT_ASSIGNMENTS_EDITOR_DATA_SUCCESS = 'at/userManagement/managementAssignmentsEditor/LOAD_PROJECT_ASSIGNMENTS_EDITOR_DATA_SUCCESS';
var LOAD_PROJECT_ASSIGNMENTS_EDITOR_DATA_FAILURE = exports.LOAD_PROJECT_ASSIGNMENTS_EDITOR_DATA_FAILURE = 'at/userManagement/managementAssignmentsEditor/LOAD_PROJECT_ASSIGNMENTS_EDITOR_DATA_FAILURE';

var LOAD_TASK_ASSIGNMENTS_EDITOR_DATA = exports.LOAD_TASK_ASSIGNMENTS_EDITOR_DATA = 'at/userManagement/managementAssignmentsEditor/LOAD_TASK_ASSIGNMENTS_EDITOR_DATA';
var LOAD_TASK_ASSIGNMENTS_EDITOR_DATA_SUCCESS = exports.LOAD_TASK_ASSIGNMENTS_EDITOR_DATA_SUCCESS = 'at/userManagement/managementAssignmentsEditor/LOAD_TASK_ASSIGNMENTS_EDITOR_DATA_SUCCESS';
var LOAD_TASK_ASSIGNMENTS_EDITOR_DATA_FAILURE = exports.LOAD_TASK_ASSIGNMENTS_EDITOR_DATA_FAILURE = 'at/userManagement/managementAssignmentsEditor/LOAD_TASK_ASSIGNMENTS_EDITOR_DATA_FAILURE';

var CHANGE_CUSTOMER_ASSIGNMENT = exports.CHANGE_CUSTOMER_ASSIGNMENT = 'at/userManagement/managementAssignmentsEditor/CHANGE_CUSTOMER_ASSIGNMENT';
var CHANGE_CUSTOMER_ASSIGNMENT_SUCCESS = exports.CHANGE_CUSTOMER_ASSIGNMENT_SUCCESS = 'at/userManagement/managementAssignmentsEditor/CHANGE_CUSTOMER_ASSIGNMENT_SUCCESS';
var CHANGE_CUSTOMER_ASSIGNMENT_FAILURE = exports.CHANGE_CUSTOMER_ASSIGNMENT_FAILURE = 'at/userManagement/managementAssignmentsEditor/CHANGE_CUSTOMER_ASSIGNMENT_FAILURE';

var CHANGE_PROJECT_ASSIGNMENT = exports.CHANGE_PROJECT_ASSIGNMENT = 'at/userManagement/managementAssignmentsEditor/CHANGE_PROJECT_ASSIGNMENT';
var CHANGE_PROJECT_ASSIGNMENT_SUCCESS = exports.CHANGE_PROJECT_ASSIGNMENT_SUCCESS = 'at/userManagement/managementAssignmentsEditor/CHANGE_PROJECT_ASSIGNMENT_SUCCESS';
var CHANGE_PROJECT_ASSIGNMENT_FAILURE = exports.CHANGE_PROJECT_ASSIGNMENT_FAILURE = 'at/userManagement/managementAssignmentsEditor/CHANGE_PROJECT_ASSIGNMENT_FAILURE';

var CHANGE_TASK_ASSIGNMENT = exports.CHANGE_TASK_ASSIGNMENT = 'at/userManagement/managementAssignmentsEditor/CHANGE_TASK_ASSIGNMENT';
var CHANGE_TASK_ASSIGNMENT_SUCCESS = exports.CHANGE_TASK_ASSIGNMENT_SUCCESS = 'at/userManagement/managementAssignmentsEditor/CHANGE_TASK_ASSIGNMENT_SUCCESS';
var CHANGE_TASK_ASSIGNMENT_FAILURE = exports.CHANGE_TASK_ASSIGNMENT_FAILURE = 'at/userManagement/managementAssignmentsEditor/CHANGE_TASK_ASSIGNMENT_FAILURE';

var ASSIGN_ALL_CUSTOMERS = exports.ASSIGN_ALL_CUSTOMERS = 'at/userManagement/managementAssignmentsEditor/ASSIGN_ALL_CUSTOMERS';
var ASSIGN_ALL_CUSTOMERS_SUCCESS = exports.ASSIGN_ALL_CUSTOMERS_SUCCESS = 'at/userManagement/managementAssignmentsEditor/ASSIGN_ALL_CUSTOMERS_SUCCESS';
var ASSIGN_ALL_CUSTOMERS_FAILURE = exports.ASSIGN_ALL_CUSTOMERS_FAILURE = 'at/userManagement/managementAssignmentsEditor/ASSIGN_ALL_CUSTOMERS_FAILURE';

var UNASSIGN_ALL_CUSTOMERS = exports.UNASSIGN_ALL_CUSTOMERS = 'at/userManagement/managementAssignmentsEditor/UNASSIGN_ALL_CUSTOMERS';
var UNASSIGN_ALL_CUSTOMERS_SUCCESS = exports.UNASSIGN_ALL_CUSTOMERS_SUCCESS = 'at/userManagement/managementAssignmentsEditor/UNASSIGN_ALL_CUSTOMERS_SUCCESS';
var UNASSIGN_ALL_CUSTOMERS_FAILURE = exports.UNASSIGN_ALL_CUSTOMERS_FAILURE = 'at/userManagement/managementAssignmentsEditor/UNASSIGN_ALL_CUSTOMERS_FAILURE';

var ASSIGN_ALL_PROJECTS = exports.ASSIGN_ALL_PROJECTS = 'at/userManagement/managementAssignmentsEditor/ASSIGN_ALL_PROJECTS';
var ASSIGN_ALL_PROJECTS_SUCCESS = exports.ASSIGN_ALL_PROJECTS_SUCCESS = 'at/userManagement/managementAssignmentsEditor/ASSIGN_ALL_PROJECTS_SUCCESS';
var ASSIGN_ALL_PROJECTS_FAILURE = exports.ASSIGN_ALL_PROJECTS_FAILURE = 'at/userManagement/managementAssignmentsEditor/ASSIGN_ALL_PROJECTS_FAILURE';

var UNASSIGN_ALL_PROJECTS = exports.UNASSIGN_ALL_PROJECTS = 'at/userManagement/managementAssignmentsEditor/UNASSIGN_ALL_PROJECTS';
var UNASSIGN_ALL_PROJECTS_SUCCESS = exports.UNASSIGN_ALL_PROJECTS_SUCCESS = 'at/userManagement/managementAssignmentsEditor/UNASSIGN_ALL_PROJECTS_SUCCESS';
var UNASSIGN_ALL_PROJECTS_FAILURE = exports.UNASSIGN_ALL_PROJECTS_FAILURE = 'at/userManagement/managementAssignmentsEditor/UNASSIGN_ALL_PROJECTS_FAILURE';

var ASSIGN_ALL_TASKS = exports.ASSIGN_ALL_TASKS = 'at/userManagement/managementAssignmentsEditor/ASSIGN_ALL_TASKS';
var ASSIGN_ALL_TASKS_SUCCESS = exports.ASSIGN_ALL_TASKS_SUCCESS = 'at/userManagement/managementAssignmentsEditor/ASSIGN_ALL_TASKS_SUCCESS';
var ASSIGN_ALL_TASKS_FAILURE = exports.ASSIGN_ALL_TASKS_FAILURE = 'at/userManagement/managementAssignmentsEditor/ASSIGN_ALL_TASKS_FAILURE';

var UNASSIGN_ALL_TASKS = exports.UNASSIGN_ALL_TASKS = 'at/userManagement/managementAssignmentsEditor/UNASSIGN_ALL_TASKS';
var UNASSIGN_ALL_TASKS_SUCCESS = exports.UNASSIGN_ALL_TASKS_SUCCESS = 'at/userManagement/managementAssignmentsEditor/UNASSIGN_ALL_TASKS_SUCCESS';
var UNASSIGN_ALL_TASKS_FAILURE = exports.UNASSIGN_ALL_TASKS_FAILURE = 'at/userManagement/managementAssignmentsEditor/UNASSIGN_ALL_TASKS_FAILURE';

var CHANGE_ALL_ASSIGNMENTS = exports.CHANGE_ALL_ASSIGNMENTS = 'at/userManagement/managementAssignmentsEditor/CHANGE_ALL_ASSIGNMENTS';
var CHANGE_ALL_ASSIGNMENTS_SUCCESS = exports.CHANGE_ALL_ASSIGNMENTS_SUCCESS = 'at/userManagement/managementAssignmentsEditor/CHANGE_ALL_ASSIGNMENTS_SUCCESS';
var CHANGE_ALL_ASSIGNMENTS_FAILURE = exports.CHANGE_ALL_ASSIGNMENTS_FAILURE = 'at/userManagement/managementAssignmentsEditor/CHANGE_ALL_ASSIGNMENTS_FAILURE';

var CUSTOMERS_SEARCH_TEXT_SET = exports.CUSTOMERS_SEARCH_TEXT_SET = 'at/userManagement/managementAssignmentsEditor/CUSTOMERS_SEARCH_TEXT_SET';
var CUSTOMERS_SEARCH_OPEN_SET = exports.CUSTOMERS_SEARCH_OPEN_SET = 'at/userManagement/managementAssignmentsEditor/CUSTOMERS_SEARCH_OPEN_SET';

var PROJECTS_SEARCH_TEXT_SET = exports.PROJECTS_SEARCH_TEXT_SET = 'at/userManagement/managementAssignmentsEditor/PROJECTS_SEARCH_TEXT_SET';
var PROJECTS_SEARCH_OPEN_SET = exports.PROJECTS_SEARCH_OPEN_SET = 'at/userManagement/managementAssignmentsEditor/PROJECTS_SEARCH_OPEN_SET';

var TASKS_SEARCH_TEXT_SET = exports.TASKS_SEARCH_TEXT_SET = 'at/userManagement/managementAssignmentsEditor/TASKS_SEARCH_TEXT_SET';
var TASKS_SEARCH_OPEN_SET = exports.TASKS_SEARCH_OPEN_SET = 'at/userManagement/managementAssignmentsEditor/TASKS_SEARCH_OPEN_SET';

/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var TEAM_ASSIGNMENTS_PANEL_USER_ID_SET = exports.TEAM_ASSIGNMENTS_PANEL_USER_ID_SET = 'at/userManagement/editTeamAssignmentPanel/TEAM_ASSIGNMENTS_PANEL_USER_ID_SET';

var COPY_CONTENT_OPEN = exports.COPY_CONTENT_OPEN = 'at/userManagement/editTeamAssignmentPanel/COPY_CONTENT_OPEN';
var COPY_CONTENT_CLOSE = exports.COPY_CONTENT_CLOSE = 'at/userManagement/editTeamAssignmentPanel/COPY_CONTENT_CLOSE';
var COPY_USER_ID_SET = exports.COPY_USER_ID_SET = 'at/userManagement/editTeamAssignmentPanel/copy/COPY_USER_ID_SET';
var COPY_LOADING_SET = exports.COPY_LOADING_SET = 'at/userManagement/editTeamAssignmentPanel/copy/COPY_LOADING_SET';
var USER_FROM_ASSIGNED_USERS_SET = exports.USER_FROM_ASSIGNED_USERS_SET = 'at/userManagement/editTeamAssignmentPanel/copy/USER_FROM_ASSIGNED_USERS_SET';
var COPY_USERS_FOR_SELECTOR_SET = exports.COPY_USERS_FOR_SELECTOR_SET = 'at/userManagement/editTeamAssignmentPanel/copy/COPY_USERS_FOR_SELECTOR_SET';

/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var SHOW_SET = exports.SHOW_SET = 'at/userManagement/createTeamAssignmentPanel/SHOW_SET';

/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reduxActions = __webpack_require__(9);

var _actionTypes = __webpack_require__(697);

var ActionTypes = _interopRequireWildcard(_actionTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var createReducer = function createReducer(_ref) {
    var _handleActions;

    var _ref$FEATURES = _ref.FEATURES,
        FEATURES = _ref$FEATURES === undefined ? {} : _ref$FEATURES;

    var initState = _extends({}, FEATURES);

    return (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, ActionTypes.SET_FEATURES, function (state, _ref2) {
        var features = _ref2.payload;
        return _extends({}, features);
    }), _defineProperty(_handleActions, ActionTypes.UPDATE_FEATURES, function (state, _ref3) {
        var part = _ref3.payload;
        return _extends({}, state, part);
    }), _handleActions), initState);
};

exports.default = createReducer;

/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var SET_FEATURES = exports.SET_FEATURES = 'at/features/SET_FEATURES';
var UPDATE_FEATURES = exports.UPDATE_FEATURES = 'at/features/UPDATE_FEATURES';

/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var USER_ID_SET = exports.USER_ID_SET = 'at/userProfile/cptAssignmentList/USER_ID_SET';
var PANEL_TAB_SET = exports.PANEL_TAB_SET = 'at/userProfile/cptAssignmentList/PANEL_TAB_SET';
var TASK_IDS_SET = exports.TASK_IDS_SET = 'at/userProfile/cptAssignmentList/TASK_IDS_SET';
var PROJECT_IDS_SET = exports.PROJECT_IDS_SET = 'at/userProfile/cptAssignmentList/PROJECT_IDS_SET';
var CUSTOMER_IDS_SET = exports.CUSTOMER_IDS_SET = 'at/userProfile/cptAssignmentList/CUSTOMER_IDS_SET';
var MANAGE_TASK_IDS_SET = exports.MANAGE_TASK_IDS_SET = 'at/userProfile/cptAssignmentList/MANAGE_TASK_IDS_SET';
var MANAGE_PROJECT_IDS_SET = exports.MANAGE_PROJECT_IDS_SET = 'at/userProfile/cptAssignmentList/MANAGE_PROJECT_IDS_SET';
var MANAGE_CUSTOMER_IDS_SET = exports.MANAGE_CUSTOMER_IDS_SET = 'at/userProfile/cptAssignmentList/MANAGE_CUSTOMER_IDS_SET';
var MANAGE_EXCLUDING_SELF_PROJECT_IDS_SET = exports.MANAGE_EXCLUDING_SELF_PROJECT_IDS_SET = 'at/userProfile/cptAssignmentList/MANAGE_EXCLUDING_SELF_PROJECT_IDS_SET';
var MANAGE_EXCLUDING_SELF_CUSTOMER_IDS_SET = exports.MANAGE_EXCLUDING_SELF_CUSTOMER_IDS_SET = 'at/userProfile/cptAssignmentList/MANAGE_EXCLUDING_SELF_CUSTOMER_IDS_SET';
var TASK_TAB_LOADED = exports.TASK_TAB_LOADED = 'at/userProfile/cptAssignmentList/TASK_TAB_LOADED';
var PROJECT_TAB_LOADED = exports.PROJECT_TAB_LOADED = 'at/userProfile/cptAssignmentList/PROJECT_TAB_LOADED';
var CUSTOMER_TAB_LOADED = exports.CUSTOMER_TAB_LOADED = 'at/userProfile/cptAssignmentList/CUSTOMER_TAB_LOADED';
var USER_COUNTERS_SET = exports.USER_COUNTERS_SET = 'at/userProfile/cptAssignmentList/USER_COUNTERS_SET';
var VIEWER_COUNTERS_SET = exports.VIEWER_COUNTERS_SET = 'at/userProfile/cptAssignmentList/VIEWER_COUNTERS_SET';
var PANEL_SEARCH_STRING_SET = exports.PANEL_SEARCH_STRING_SET = 'at/userProfile/cptAssignmentList/PANEL_SEARCH_STRING_SET';
var PANEL_SEARCH_OPEN_SET = exports.PANEL_SEARCH_OPEN_SET = 'at/userProfile/cptAssignmentList/PANEL_SEARCH_OPEN_SET';
var NEED_TO_LOAD_DATA_SET = exports.NEED_TO_LOAD_DATA_SET = 'at/userProfile/cptAssignmentList/NEED_TO_LOAD_DATA_SET';

var PANEL_OPEN = exports.PANEL_OPEN = 'at/userProfile/cptAssignmentList/PANEL_OPEN';
var PANEL_CLOSE = exports.PANEL_CLOSE = 'at/userProfile/cptAssignmentList/PANEL_CLOSE';
var LOADING_SET = exports.LOADING_SET = 'at/userProfile/cptAssignmentList/LOADING_SET';
var LOADED_SET = exports.LOADED_SET = 'at/userProfile/cptAssignmentList/LOADED_SET';

var SET_IS_SHOW_ARCHIVE_ENTITIES = exports.SET_IS_SHOW_ARCHIVE_ENTITIES = 'at/userManagement/cptAssignmentList/SET_IS_SHOW_ARCHIVE_ENTITIES';

/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var LOADING_SET = exports.LOADING_SET = 'at/userProfile/teamList/LOADING_SET';
var TEAM_NAMES_SET = exports.TEAM_NAMES_SET = 'at/userProfile/teamList/TEAM_NAMES_SET';
var NEED_TO_LOAD_DATA_SET = exports.NEED_TO_LOAD_DATA_SET = 'at/userProfile/teamList/NEED_TO_LOAD_DATA_SET';

/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var SELECTED_TAB_SET = exports.SELECTED_TAB_SET = 'at/reports/dashboard/createReportPopup/SELECTED_TAB_SET';

/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = createReducer;

var _reduxActions = __webpack_require__(9);

var _actionTypes = __webpack_require__(1272);

var ActionTypes = _interopRequireWildcard(_actionTypes);

var _constants = __webpack_require__(1273);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function createReducer(_ref) {
    var _handleActions;

    var LOCKOUT_POLICY = _ref.LOCKOUT_POLICY;

    var initialState = {
        useLockoutPolicy: true,
        duration: 30,
        threshold: 6,
        counter: 1,
        unlockAllStatus: _constants.UNLOCK_ALL_STATUS.INITIAL,
        isModified: false
    };

    if (!!LOCKOUT_POLICY) {
        initialState.useLockoutPolicy = LOCKOUT_POLICY.enabled;
        initialState.duration = LOCKOUT_POLICY.durationMinutes;
        initialState.threshold = LOCKOUT_POLICY.threshold;
        initialState.counter = LOCKOUT_POLICY.resetCounterAfter;
    }

    return (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, ActionTypes.USE_LOCKOUT_POLICY_SET, function (state, _ref2) {
        var useLockoutPolicy = _ref2.payload;
        return _extends({}, state, {
            useLockoutPolicy: useLockoutPolicy,
            isModified: true
        });
    }), _defineProperty(_handleActions, ActionTypes.LOCKOUT_DURATION_SET, function (state, _ref3) {
        var duration = _ref3.payload;
        return _extends({}, state, {
            duration: duration,
            isModified: true
        });
    }), _defineProperty(_handleActions, ActionTypes.LOCKOUT_THRESHOLD_SET, function (state, _ref4) {
        var threshold = _ref4.payload;
        return _extends({}, state, {
            threshold: threshold,
            isModified: true
        });
    }), _defineProperty(_handleActions, ActionTypes.LOCKOUT_COUNTER_SET, function (state, _ref5) {
        var counter = _ref5.payload;
        return _extends({}, state, {
            counter: counter,
            isModified: true
        });
    }), _defineProperty(_handleActions, ActionTypes.LOCKOUT_UNLOCK_ALL_STATUS_SET, function (state, _ref6) {
        var status = _ref6.payload;
        return _extends({}, state, {
            unlockAllStatus: status
        });
    }), _handleActions), initialState);
}

/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = createReducer;

var _reduxActions = __webpack_require__(9);

var _actionTypes = __webpack_require__(1274);

var ActionTypes = _interopRequireWildcard(_actionTypes);

var _common = __webpack_require__(1275);

var _PasswordSettings = __webpack_require__(279);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function createReducer() {
    var _handleActions;

    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$PASSWORD_SETTING = _ref.PASSWORD_SETTINGS,
        PASSWORD_SETTINGS = _ref$PASSWORD_SETTING === undefined ? {} : _ref$PASSWORD_SETTING,
        _ref$IS_USER_PASSWORD = _ref.IS_USER_PASSWORD_MATCHES_POLICY,
        IS_USER_PASSWORD_MATCHES_POLICY = _ref$IS_USER_PASSWORD === undefined ? false : _ref$IS_USER_PASSWORD;

    var initState = {
        settings: (0, _PasswordSettings.create)(PASSWORD_SETTINGS),
        initialSettings: (0, _PasswordSettings.create)(PASSWORD_SETTINGS),

        configurableRuleIds: [_PasswordSettings.PasswordValidatorId.UPPERCASE_VALIDATOR, _PasswordSettings.PasswordValidatorId.LOWERCASE_VALIDATOR, _PasswordSettings.PasswordValidatorId.NUMBER_VALIDATOR, _PasswordSettings.PasswordValidatorId.SPECIAL_VALIDATOR],
        minimalLengthError: null,
        settingsGotStronger: false,

        saveStatus: _common.SaveStatus.Initial,
        resetStatus: _common.ResetStatus.Initial,
        passwordNotResetFor: [],
        currentPassword: '',
        newPassword: '',
        currentPasswordInvalid: false,
        newPasswordInvalid: false,

        passwordValidationResult: {},

        isUserPasswordMatchesPolicy: IS_USER_PASSWORD_MATCHES_POLICY
    };

    return (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, ActionTypes.PASSWORD_STRONGER_FLAG_SET, function (state, _ref2) {
        var flag = _ref2.payload;
        return _extends({}, state, {
            settingsGotStronger: flag
        });
    }), _defineProperty(_handleActions, ActionTypes.PASSWORD_REQUIREMENT_SET, function (state, _ref3) {
        var _ref3$payload = _ref3.payload,
            id = _ref3$payload.id,
            value = _ref3$payload.value;
        return _extends({}, state, {
            settings: (0, _PasswordSettings.toggleRuleId)(state.settings, id, value),
            saveStatus: _common.SaveStatus.Modified
        });
    }), _defineProperty(_handleActions, ActionTypes.PASSWORD_MIN_LENGTH_SET, function (state, _ref4) {
        var val = _ref4.payload;
        return _extends({}, state, {
            settings: (0, _PasswordSettings.change)(state.settings, { minimalLength: val }),
            minimalLengthError: null,
            saveStatus: _common.SaveStatus.Modified
        });
    }), _defineProperty(_handleActions, ActionTypes.CURRENT_PASSWORD_SET, function (state, _ref5) {
        var password = _ref5.payload;
        return _extends({}, state, {
            currentPassword: password,
            currentPasswordInvalid: password.length === 0
        });
    }), _defineProperty(_handleActions, ActionTypes.NEW_PASSWORD_SET, function (state, _ref6) {
        var password = _ref6.payload;
        return _extends({}, state, {
            newPassword: password,
            newPasswordInvalid: password.length === 0
        });
    }), _defineProperty(_handleActions, ActionTypes.PASSWORDS_CLEAR, function (state) {
        return _extends({}, state, {
            currentPassword: '',
            newPassword: ''
        });
    }), _defineProperty(_handleActions, ActionTypes.CURRENT_PASSWORD_INVALID_SET, function (state, _ref7) {
        var flag = _ref7.payload;
        return _extends({}, state, {
            currentPasswordInvalid: flag
        });
    }), _defineProperty(_handleActions, ActionTypes.NEW_PASSWORD_INVALID_SET, function (state, _ref8) {
        var flag = _ref8.payload;
        return _extends({}, state, {
            newPasswordInvalid: flag
        });
    }), _defineProperty(_handleActions, ActionTypes.PASSWORD_VALIDATION_RESULT_SET, function (state, _ref9) {
        var result = _ref9.payload;
        return _extends({}, state, {
            passwordValidationResult: result
        });
    }), _defineProperty(_handleActions, ActionTypes.USER_PASSWORD_MATCHES_PASSWORD_POLICY_SET, function (state, _ref10) {
        var flag = _ref10.payload;
        return _extends({}, state, {
            isUserPasswordMatchesPolicy: flag
        });
    }), _defineProperty(_handleActions, ActionTypes.PASSWORD_MIN_LENGTH_ERROR_SET, function (state, _ref11) {
        var error = _ref11.payload;
        return _extends({}, state, {
            minimalLengthError: error
        });
    }), _defineProperty(_handleActions, ActionTypes.RESET_STARTED, function (state) {
        return _extends({}, state, {
            passwordNotResetFor: [],
            resetStatus: state.saveStatus === _common.SaveStatus.Modified ? _common.ResetStatus.ResettingAndSaving : _common.ResetStatus.Resetting
        });
    }), _defineProperty(_handleActions, ActionTypes.RESET_COMPLETED, function (state) {
        return _extends({}, state, {
            saveStatus: _common.SaveStatus.Saved,
            settingsGotStronger: false,
            initialSettings: (0, _PasswordSettings.create)(state.settings),
            resetStatus: state.resetStatus === _common.ResetStatus.ResettingAndSaving ? _common.ResetStatus.ResetAndSaveDone : _common.ResetStatus.ResetDone
        });
    }), _defineProperty(_handleActions, ActionTypes.RESET_FAILED, function (state) {
        return _extends({}, state, {
            resetStatus: _common.ResetStatus.Initial
        });
    }), _defineProperty(_handleActions, ActionTypes.RESET_RESULT_SET_PASSWORD_NOT_RESET_FOR, function (state, _ref12) {
        var passwordNotResetFor = _ref12.payload;
        return _extends({}, state, {
            passwordNotResetFor: passwordNotResetFor
        });
    }), _handleActions), initState);
}

/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _redux = __webpack_require__(7);

var _reducer = __webpack_require__(1276);

var _reducer2 = _interopRequireDefault(_reducer);

var _reducer3 = __webpack_require__(1279);

var _reducer4 = _interopRequireDefault(_reducer3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (initAppData) {
    return (0, _redux.combineReducers)({
        sdbBalance: (0, _reducer2.default)(initAppData),
        ptoBalance: (0, _reducer4.default)(initAppData)
    });
};

/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reduxActions = __webpack_require__(9);

var _constants = __webpack_require__(1277);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var reducerGenerator = function reducerGenerator(_ref) {
    var _handleActions;

    var _ref$actions = _ref.actions,
        ENABLED_SET = _ref$actions.ENABLED_SET,
        MINIMAL_VALUE_SET = _ref$actions.MINIMAL_VALUE_SET,
        USER_EXCEPTION_TYPE_SET = _ref$actions.USER_EXCEPTION_TYPE_SET,
        EXCEPTION_USERS_SET = _ref$actions.EXCEPTION_USERS_SET,
        initialState = _ref.initialState;

    var initState = initialState || {
        enabled: false,
        minimalValue: false,
        userExceptionType: _constants.UserExceptionType.NoException,
        exceptionUsers: {
            all: false,
            userIds: [],
            groupIds: [],
            groupType: null
        }
    };

    return (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, ENABLED_SET, function (state, _ref2) {
        var enabled = _ref2.payload;
        return _extends({}, state, { enabled: enabled });
    }), _defineProperty(_handleActions, MINIMAL_VALUE_SET, function (state, _ref3) {
        var minimalValue = _ref3.payload;
        return _extends({}, state, { minimalValue: minimalValue });
    }), _defineProperty(_handleActions, USER_EXCEPTION_TYPE_SET, function (state, _ref4) {
        var userExceptionType = _ref4.payload;
        return _extends({}, state, { userExceptionType: userExceptionType });
    }), _defineProperty(_handleActions, EXCEPTION_USERS_SET, function (state, _ref5) {
        var exceptionUsers = _ref5.payload;
        return _extends({}, state, { exceptionUsers: exceptionUsers });
    }), _handleActions), initState);
};

exports.default = reducerGenerator;

/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = createReducer;

var _reduxActions = __webpack_require__(9);

function createReducer() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$MAIL_SETTINGS = _ref.MAIL_SETTINGS,
        MAIL_SETTINGS = _ref$MAIL_SETTINGS === undefined ? {} : _ref$MAIL_SETTINGS;

    var initState = {
        mailSettingsSpecified: MAIL_SETTINGS.mailSettingsSpecified || false
    };

    return (0, _reduxActions.handleActions)({}, initState);
}

/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reduxActions = __webpack_require__(9);

var _actionTypes = __webpack_require__(707);

var ActionTypes = _interopRequireWildcard(_actionTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = {
    messages: []
};

var toasts = (0, _reduxActions.handleActions)(_defineProperty({}, ActionTypes.MESSAGES_SET, function (state, _ref) {
    var messages = _ref.payload;
    return _extends({}, state, { messages: messages });
}), initialState);

exports.default = toasts;

/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var MESSAGES_SET = exports.MESSAGES_SET = 'at/toasts/MESSAGES_SET';

/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _redux = __webpack_require__(7);

var _reducer = __webpack_require__(1281);

var _reducer2 = _interopRequireDefault(_reducer);

var _reducer3 = __webpack_require__(1282);

var _reducer4 = _interopRequireDefault(_reducer3);

var _reducer5 = __webpack_require__(1283);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (initAppData) {
    return (0, _redux.combineReducers)({
        page: (0, _reducer5.createWorkScheduleReducer)(initAppData),
        holidayListPanel: _reducer2.default,
        importHolidaysPanel: _reducer4.default
    });
};

/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var CLOSE_PANEL = exports.CLOSE_PANEL = 'at/workSchedule/holidayListPanel/CLOSE_PANEL';
var HOLIDAYS_LIST_PANEL_SHOWN_SET = exports.HOLIDAYS_LIST_PANEL_SHOWN_SET = 'at/workSchedule/holidayListPanel/HOLIDAYS_LIST_PANEL_SHOWN_SET';
var REMOVE_ALL_CONFIRMATION_SHOW = exports.REMOVE_ALL_CONFIRMATION_SHOW = 'at/workSchedule/holidayListPanel/REMOVE_ALL_CONFIRMATION_SHOW';
var REMOVE_ALL_CONFIRMATION_CLOSE = exports.REMOVE_ALL_CONFIRMATION_CLOSE = 'at/workSchedule/holidayListPanel/REMOVE_ALL_CONFIRMATION_CLOSE';
var SELECTED_YEAR_SET = exports.SELECTED_YEAR_SET = 'at/workSchedule/holidayListPanel/SELECTED_YEAR_SET';
var LOAD_DATA = exports.LOAD_DATA = 'at/workSchedule/holidayListPanel/LOAD_DATA';
var LOAD_DATA_SUCCESS = exports.LOAD_DATA_SUCCESS = 'at/workSchedule/holidayListPanel/LOAD_DATA_SUCCESS';
var LOAD_DATA_FAILURE = exports.LOAD_DATA_FAILURE = 'at/workSchedule/holidayListPanel/LOAD_DATA_FAILURE';
var CHANGE_SORT = exports.CHANGE_SORT = 'at/workSchedule/holidayListPanel/CHANGE_SORT';
var LIST_TRANSFORMED_SET = exports.LIST_TRANSFORMED_SET = 'at/workSchedule/holidayListPanel/LIST_TRANSFORMED_SET';
var IMPORTED_HOLIDAYS_ADD = exports.IMPORTED_HOLIDAYS_ADD = 'at/workSchedule/holidayListPanel/IMPORTED_HOLIDAYS_ADD';
var IMPORTED_HOLIDAYS_REMOVE = exports.IMPORTED_HOLIDAYS_REMOVE = 'at/workSchedule/holidayListPanel/IMPORTED_HOLIDAYS_REMOVE';

var LOAD_HOLIDAYS = exports.LOAD_HOLIDAYS = 'at/workSchedule/holidayListPanel/LOAD_HOLIDAYS';
var LOAD_HOLIDAYS_SUCCESS = exports.LOAD_HOLIDAYS_SUCCESS = 'at/workSchedule/holidayListPanel/LOAD_HOLIDAYS_SUCCESS';
var LOAD_HOLIDAYS_FAILURE = exports.LOAD_HOLIDAYS_FAILURE = 'at/workSchedule/holidayListPanel/LOAD_HOLIDAYS_FAILURE';

/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var CLOSE_PANEL = exports.CLOSE_PANEL = 'at/workSchedule/importHolidaysPanel/CLOSE_PANEL';
var OPEN_PANEL = exports.OPEN_PANEL = 'at/workSchedule/importHolidaysPanel/OPEN_PANEL';
var YEAR_SET = exports.YEAR_SET = 'at/workSchedule/importHolidaysPanel/YEAR_SET';
var COUNTRY_SET = exports.COUNTRY_SET = 'at/workSchedule/importHolidaysPanel/COUNTRY_SET';
var HOLIDAYS_SET = exports.HOLIDAYS_SET = 'at/workSchedule/importHolidaysPanel/HOLIDAYS_SET';
var HOLIDAYS_IN_PAST_SET = exports.HOLIDAYS_IN_PAST_SET = 'at/workSchedule/importHolidaysPanel/HOLIDAYS_IN_PAST_SET';
var LOAD_DATA = exports.LOAD_DATA = 'at/workSchedule/importHolidaysPanel/LOAD_DATA';
var LOAD_DATA_SUCCESS = exports.LOAD_DATA_SUCCESS = 'at/workSchedule/importHolidaysPanel/LOAD_DATA_SUCCESS';
var LOAD_DATA_FAILURE = exports.LOAD_DATA_FAILURE = 'at/workSchedule/importHolidaysPanel/LOAD_DATA_FAILURE';
var IMPORT_HOLIDAYS_START = exports.IMPORT_HOLIDAYS_START = 'at/workSchedule/importHolidaysPanel/IMPORT_HOLIDAYS_START';
var IMPORT_HOLIDAYS_COMPLETE = exports.IMPORT_HOLIDAYS_COMPLETE = 'at/workSchedule/importHolidaysPanel/IMPORT_HOLIDAYS_COMPLETE';

/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var LOAD_DATA = exports.LOAD_DATA = 'at/workSchedule/LOAD_DATA';
var LOAD_DATA_SUCCESS = exports.LOAD_DATA_SUCCESS = 'at/workSchedule/LOAD_DATA_SUCCESS';
var LOAD_DATA_FAILURE = exports.LOAD_DATA_FAILURE = 'at/workSchedule/LOAD_DATA_FAILURE';
var LOADED_DATA_SET = exports.LOADED_DATA_SET = 'at/workSchedule/LOADED_DATA_SET';
var LEAVE_BLACKOUT_DAYS_ADD = exports.LEAVE_BLACKOUT_DAYS_ADD = 'at/workSchedule/LEAVE_BLACKOUT_DAYS_ADD';
var LEAVE_BLACKOUT_DAYS_REMOVE = exports.LEAVE_BLACKOUT_DAYS_REMOVE = 'at/workSchedule/LEAVE_BLACKOUT_DAYS_REMOVE';
var EDITING_DAYS_ADD = exports.EDITING_DAYS_ADD = 'at/workSchedule/EDITING_DAYS_ADD';
var EDITING_DAYS_REMOVE = exports.EDITING_DAYS_REMOVE = 'at/workSchedule/EDITING_DAYS_REMOVE';
var YEAR_SELECTED = exports.YEAR_SELECTED = 'at/workSchedule/YEAR_SELECTED';
var CORPORATE_DAYS_SET = exports.CORPORATE_DAYS_SET = 'at/workSchedule/CORPORATE_DAYS_SET';
var DEFAULT_WORK_SCHEDULES_SET = exports.DEFAULT_WORK_SCHEDULES_SET = 'at/workSchedule/DEFAULT_WORK_SCHEDULES_SET';
var CORPORATE_DAYS_REMOVE_BY_YEAR = exports.CORPORATE_DAYS_REMOVE_BY_YEAR = 'at/workSchedule/CORPORATE_DAYS_REMOVE_BY_YEAR';

var CURRENT_COUNTRY_SET = exports.CURRENT_COUNTRY_SET = 'at/workSchedule/CURRENT_COUNTRY_SET';

var LOAD_COUNTRIES = exports.LOAD_COUNTRIES = 'at/workSchedule/LOAD_COUNTRIES';
var LOAD_COUNTRIES_SUCCESS = exports.LOAD_COUNTRIES_SUCCESS = 'at/workSchedule/LOAD_COUNTRIES_SUCCESS';
var LOAD_COUNTRIES_FAILURE = exports.LOAD_COUNTRIES_FAILURE = 'at/workSchedule/LOAD_COUNTRIES_FAILURE';

/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (_ref) {
    var _ref$ACTIVE_LICENSE_I = _ref.ACTIVE_LICENSE_INFO,
        ACTIVE_LICENSE_INFO = _ref$ACTIVE_LICENSE_I === undefined ? {} : _ref$ACTIVE_LICENSE_I;

    var initialState = ACTIVE_LICENSE_INFO || {
        daysToExpiration: -1,
        type: null,
        thereARenewal: false,
        violated: false,
        otherProductExpired: false,
        otherProductViolated: false,
        wasOtherProductEverIntegrated: false,
        userCounters: {
            allowedCount: 0,
            actualCount: 0
        },
        licenseManagerStatus: null
    };

    return (0, _reduxActions.handleActions)({
        // empty for now, no need to update license state without page reload
    }, initialState);
};

var _reduxActions = __webpack_require__(9);

/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reduxActions = __webpack_require__(9);

var _constants = __webpack_require__(181);

var _actionTypes = __webpack_require__(714);

var ActionTypes = _interopRequireWildcard(_actionTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var createSupportReducer = function createSupportReducer(_ref) {
    var _handleActions;

    var _ref$SUPPORT = _ref.SUPPORT,
        SUPPORT = _ref$SUPPORT === undefined ? null : _ref$SUPPORT;

    var popupInfo = _extends({
        isShown: false,
        mode: _constants.supportFormMode.EDITOR,
        text: '',
        attachmentId: 0,
        attachmentName: '',
        email: '',
        position: {
            x: null,
            y: null
        },
        positionStrategy: _constants.supportPopupPositionStrategy.FROM_TOP_LEFT
    }, SUPPORT.POPUP_INFO);

    var initialState = _extends({
        showSupportQuestionButton: SUPPORT.showSupportQuestionButton,
        loading: false
    }, popupInfo);

    return (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, ActionTypes.SUPPORT_FORM_OPEN, function (state) {
        return _extends({}, state, {
            isShown: true
        });
    }), _defineProperty(_handleActions, ActionTypes.SUPPORT_FORM_CLOSE, function (state) {
        return _extends({}, state, {
            isShown: false,
            mode: _constants.supportFormMode.EDITOR,
            position: {
                x: null,
                y: null
            },
            positionStrategy: _constants.supportPopupPositionStrategy.FROM_TOP_LEFT
        });
    }), _defineProperty(_handleActions, ActionTypes.LOADING_START, function (state) {
        return _extends({}, state, {
            loading: true
        });
    }), _defineProperty(_handleActions, ActionTypes.LOADING_STOP, function (state) {
        return _extends({}, state, {
            loading: false
        });
    }), _defineProperty(_handleActions, ActionTypes.SUPPORT_FORM_POSITION_SET, function (state, _ref2) {
        var positionParams = _ref2.payload;
        return _extends({}, state, {
            positionStrategy: positionParams.positionStrategy,
            position: positionParams.position
        });
    }), _defineProperty(_handleActions, ActionTypes.SUPPORT_FORM_MODE_SET, function (state, _ref3) {
        var mode = _ref3.payload;
        return _extends({}, state, {
            mode: mode
        });
    }), _defineProperty(_handleActions, ActionTypes.SUPPORT_FORM_TEXT_SET, function (state, _ref4) {
        var text = _ref4.payload;
        return _extends({}, state, {
            text: text
        });
    }), _defineProperty(_handleActions, ActionTypes.SUPPORT_FORM_ATTACHMENT_ID_SET, function (state, _ref5) {
        var attachmentId = _ref5.payload;
        return _extends({}, state, {
            attachmentId: attachmentId
        });
    }), _defineProperty(_handleActions, ActionTypes.SUPPORT_FORM_ATTACHMENT_NAME_SET, function (state, _ref6) {
        var attachmentName = _ref6.payload;
        return _extends({}, state, {
            attachmentName: attachmentName
        });
    }), _defineProperty(_handleActions, ActionTypes.SUPPORT_FORM_EMAIL_SET, function (state, _ref7) {
        var email = _ref7.payload;
        return _extends({}, state, {
            email: email
        });
    }), _defineProperty(_handleActions, ActionTypes.SUPPORT_FORM_RESET, function (state) {
        return _extends({}, state, {
            loading: false,
            text: '',
            attachmentId: 0,
            attachmentName: '',
            email: ''
        });
    }), _handleActions), initialState);
};

exports.default = createSupportReducer;

/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var SUPPORT_FORM_OPEN = exports.SUPPORT_FORM_OPEN = 'at/support/SUPPORT_FORM_OPEN';
var SUPPORT_FORM_CLOSE = exports.SUPPORT_FORM_CLOSE = 'at/support/SUPPORT_FORM_CLOSE';
var LOADING_START = exports.LOADING_START = 'at/support/LOADING_START';
var LOADING_STOP = exports.LOADING_STOP = 'at/support/LOADING_STOP';
var SUPPORT_FORM_POSITION_SET = exports.SUPPORT_FORM_POSITION_SET = 'at/support/SUPPORT_FORM_POSITION_SET';
var SUPPORT_FORM_MODE_SET = exports.SUPPORT_FORM_MODE_SET = 'at/support/SUPPORT_FORM_MODE_SET';
var SUPPORT_FORM_TEXT_SET = exports.SUPPORT_FORM_TEXT_SET = 'at/support/SUPPORT_FORM_TEXT_SET';
var SUPPORT_FORM_ATTACHMENT_ID_SET = exports.SUPPORT_FORM_ATTACHMENT_ID_SET = 'at/support/SUPPORT_FORM_ATTACHMENT_ID_SET';
var SUPPORT_FORM_ATTACHMENT_NAME_SET = exports.SUPPORT_FORM_ATTACHMENT_NAME_SET = 'at/support/SUPPORT_FORM_ATTACHMENT_NAME_SET';
var SUPPORT_FORM_EMAIL_SET = exports.SUPPORT_FORM_EMAIL_SET = 'at/support/SUPPORT_FORM_EMAIL_SET';
var SUPPORT_FORM_RESET = exports.SUPPORT_FORM_RESET = 'at/support/SUPPORT_FORM_RESET';

/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reduxActions = __webpack_require__(9);

var _actionTypes = __webpack_require__(716);

var ActionTypes = _interopRequireWildcard(_actionTypes);

var _constants = __webpack_require__(226);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var createWelcomeReducer = function createWelcomeReducer(_ref) {
    var _handleActions;

    var _ref$WELCOME = _ref.WELCOME,
        WELCOME = _ref$WELCOME === undefined ? null : _ref$WELCOME;

    var initialState = {
        loading: false,
        showExternalContent: false,
        popupVisible: true,
        demoDataStage: WELCOME.needToLoadDemoData ? _constants.DemoDataStageType.IDLE : _constants.DemoDataStageType.COMPLETED,
        needToLoadDemoData: WELCOME.needToLoadDemoData,
        url: '',
        size: {
            width: 0,
            height: 0
        },
        loadExternalWelcomeScreen: WELCOME.loadExternalWelcomeScreen
    };

    return (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, ActionTypes.LOADING_SET, function (state, _ref2) {
        var loading = _ref2.payload;
        return _extends({}, state, { loading: loading });
    }), _defineProperty(_handleActions, ActionTypes.POPUP_VISIBLE_SET, function (state, _ref3) {
        var popupVisible = _ref3.payload;
        return _extends({}, state, { popupVisible: popupVisible });
    }), _defineProperty(_handleActions, ActionTypes.SHOW_EXTERNAL_CONTENT_SET, function (state, _ref4) {
        var showExternalContent = _ref4.payload;
        return _extends({}, state, { showExternalContent: showExternalContent });
    }), _defineProperty(_handleActions, ActionTypes.DEMO_DATA_STAGE_SET, function (state, _ref5) {
        var demoDataStage = _ref5.payload;
        return _extends({}, state, { demoDataStage: demoDataStage });
    }), _defineProperty(_handleActions, ActionTypes.URL_SET, function (state, _ref6) {
        var url = _ref6.payload;
        return _extends({}, state, { url: url });
    }), _defineProperty(_handleActions, ActionTypes.SIZE_SET, function (state, _ref7) {
        var size = _ref7.payload;
        return _extends({}, state, { size: size });
    }), _handleActions), initialState);
};

exports.default = createWelcomeReducer;

/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var LOADING_SET = exports.LOADING_SET = 'externalContent/welcome/LOADING_SET';
var POPUP_VISIBLE_SET = exports.POPUP_VISIBLE_SET = 'externalContent/welcome/POPUP_VISIBLE_SET';
var SHOW_EXTERNAL_CONTENT_SET = exports.SHOW_EXTERNAL_CONTENT_SET = 'exernalContent/welcome/SHOW_EXTERNAL_CONTENT_SET';
var DEMO_DATA_STAGE_SET = exports.DEMO_DATA_STAGE_SET = 'externalContent/welcome/DEMO_DATA_STAGE_SET';
var URL_SET = exports.URL_SET = 'externalContent/welcome/URL_SET';
var SIZE_SET = exports.SIZE_SET = 'externalContent/welcome/SIZE_SET';

/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var ADDONS_MENU_TOGGLE = exports.ADDONS_MENU_TOGGLE = 'at/addons/ADDONS_MENU_TOGGLE';
var ADDONS_MENU_CLOSE = exports.ADDONS_MENU_CLOSE = 'at/addons/ADDONS_MENU_CLOSE';

/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.HandlersStack = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var createUuidGenerator = function createUuidGenerator() {
    var i = 0;
    return function () {
        return i++;
    };
};

/**
 * Event handlers stack
 */

var HandlersStack = exports.HandlersStack = function () {
    function HandlersStack() {
        _classCallCheck(this, HandlersStack);

        this._stack = [];
        this._uuid = createUuidGenerator();
    }

    /**
     * put handler on event into stack
     * @param event {String}
     * @param handler
     * @return {Function} removes handler from stack
     */


    _createClass(HandlersStack, [{
        key: "addHandler",
        value: function addHandler(event, handler) {
            var _this = this;

            var newId = this._uuid();
            this._stack.push({ id: newId, event: event, handler: handler });
            return function () {
                _this._removeHandler(newId);
            };
        }

        /**
         * delete handler from stack
         * @param id
         */

    }, {
        key: "_removeHandler",
        value: function _removeHandler(id) {
            this._stack = _underscore2.default.filter(this._stack, function (handler) {
                return handler.id !== id;
            });
        }

        /**
         * Get last handler for event
         * @param event
         * @return {Function} last handler for event or null
         */

    }, {
        key: "getLastHandler",
        value: function getLastHandler(event) {
            var lastEventHandlerIndex = _underscore2.default.findLastIndex(this._stack, function (eventHandler) {
                return eventHandler.event === event;
            });
            return lastEventHandlerIndex >= 0 ? this._stack[lastEventHandlerIndex].handler : null;
        }

        /**
         * Get list of event handlers iterator
         * @param event
         * @return {Function} iterator
         */

    }, {
        key: "getHandlersIterator",
        value: function getHandlersIterator(event) {
            var copy = _underscore2.default.filter(this._stack, function (eventHandler) {
                return eventHandler.event === event;
            });

            return function () {
                if (copy.length === 0) {
                    return null;
                }
                var current = _underscore2.default.last(copy);
                copy = _underscore2.default.initial(copy);
                return current.handler;
            };
        }
    }]);

    return HandlersStack;
}();

var handlersStack = new HandlersStack();

exports.default = handlersStack;

/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var EVENTS = exports.EVENTS = {
  KEY_PRESS: 'keypress',
  KEY_DOWN: 'keydown',
  KEY_UP: 'keyup'
};

/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _EntityWithIdStore2 = __webpack_require__(342);

var _EntityWithIdStore3 = _interopRequireDefault(_EntityWithIdStore2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BillingTypeStoreClass = function (_EntityWithIdStore) {
    _inherits(BillingTypeStoreClass, _EntityWithIdStore);

    function BillingTypeStoreClass() {
        _classCallCheck(this, BillingTypeStoreClass);

        var _this = _possibleConstructorReturn(this, (BillingTypeStoreClass.__proto__ || Object.getPrototypeOf(BillingTypeStoreClass)).call(this));

        _this.defaultBillingTypeId = -1;
        return _this;
    }

    _createClass(BillingTypeStoreClass, [{
        key: "getDefaultBillingType",
        value: function getDefaultBillingType() {
            return this.get(this.getDefaultBillingTypeId());
        }
    }, {
        key: "getDefaultBillingTypeId",
        value: function getDefaultBillingTypeId() {
            return this.defaultBillingTypeId;
        }
    }, {
        key: "setDefaultBillingTypeId",
        value: function setDefaultBillingTypeId(defaultBillingTypeId) {
            this.defaultBillingTypeId = defaultBillingTypeId;
        }
    }]);

    return BillingTypeStoreClass;
}(_EntityWithIdStore3.default);

var BillingTypeStore = new BillingTypeStoreClass();
exports.default = BillingTypeStore;

/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var BillingType = function () {
    function BillingType(id, name, active, billable) {
        _classCallCheck(this, BillingType);

        this.id = id;
        this.name = name;
        this.active = active;
        this.billable = billable;
    }

    _createClass(BillingType, null, [{
        key: "fromRPC",
        value: function fromRPC(data) {
            return new BillingType(data["id"], data["name"], data["active"], data["billable"]);
        }
    }]);

    return BillingType;
}();

exports.default = BillingType;

/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _spin = __webpack_require__(93);

var _spin2 = _interopRequireDefault(_spin);

var _BoolTimer = __webpack_require__(459);

var _BoolTimer2 = _interopRequireDefault(_BoolTimer);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _StringIndex = __webpack_require__(115);

var _StringIndex2 = _interopRequireDefault(_StringIndex);

var _key_down_handler = __webpack_require__(184);

var _key_down_handler2 = _interopRequireDefault(_key_down_handler);

var _TokensHighlighter = __webpack_require__(94);

var _TokensHighlighter2 = _interopRequireDefault(_TokensHighlighter);

var _atBrowserUtils = __webpack_require__(8);

var _keyCodes = __webpack_require__(66);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @author kostenko
 *
 * A controller for customers & projects hierarchical selector.
 *
 * Requires:
 *   jQuery
 *   jQuery.scrollintoview
 *   /js/at.js
 *   /js/message_resources.js (using 'submit_tt' prefixes)
 *   /js/spin.min.js
 *
 * @param container - the element which contains all the needed markup (a DOM element, jQuery object or selector)
 *                    (for example of markup see 'customerProjectSelector' element in task_select_control.jsp)
 * @param onCustomerOrProjectSelect - function( customerId, projectId ) executed when the user selects a customer or a project.
 *                    Note: customerId is 0 if a project is selected, and projectId is 0 if a customer is selected.
 * @constructor
 *
 * The following methods are declared:
 *   init
 *   isInitialized
 *   spin
 *   stopSpin
 *   closeDropdown
 * See their declaration in the constructor body for comments.
 */
function CPSelectorController(container, onCustomerOrProjectSelect) {
    var self = this;

    container = (0, _jquery2.default)(container);
    if (!onCustomerOrProjectSelect) onCustomerOrProjectSelect = function onCustomerOrProjectSelect() {};

    var initialized = false;
    var searchField = container.find(".combobox input");
    var cpDropdown = container.find(".cpDropdown");
    var cpDropdownOpenFromButton = false;
    var cpList = cpDropdown.find(".cpList");
    var expandAllButton = cpDropdown.find("button.expandAll");
    var collapseAllButton = cpDropdown.find("button.collapseAll");
    var spinner = new _spin2.default({ length: 3, width: 2, radius: 3, lines: 8, color: '#aaaaaa', trail: 60 });
    var selectedRow = (0, _jquery2.default)();
    var cpIndex = new CPIndex();
    var expandBackup;
    var searchMode = false;
    var hoverEnabled = new _BoolTimer2.default(true, 100);
    var placeholderText = _messageResource2.default.getMessage("submit_tt.cp_selector.placeholder");

    /**
     * Initializes the selector with the given data.
     * @param customersProjectsInfo - customers & projects info, as defined in com.actimind.actitime.util.CustomersProjectsData.
     * @param isActive - whether to load active projects or archived
     */
    this.init = function (customersProjectsInfo, isActive) {
        if (initialized) {
            cpList.children(".row").remove();
            cpList.children(".projectsTrailer").remove();
            selectedRow = (0, _jquery2.default)();
            onCustomerOrProjectSelect(0, 0, {}, {});
            cpIndex = new CPIndex();
            searchMode = false;
        }
        var customerTemplate = cpList.find(".templates .row.customer");
        var projectTemplate = cpList.find(".templates .row.project");
        var projectsTrailerTemplate = cpList.find(".templates .projectsTrailer");

        _jquery2.default.each(customersProjectsInfo.customers, function () {
            var customer = this;
            var customerRow = customerTemplate.clone().appendTo(cpList);

            customerRow.find(".name").text(customer.name);
            customerRow.click(onCustomerRowClick);
            customerRow.find("button.expandCollapse").click(onExpandCollapseClick).mouseover(onExpandCollapseMouseOver);
            customerRow.mouseover(onRowMouseOver);

            var projectRows = [];

            _jquery2.default.each(customersProjectsInfo.projects, function () {
                if (this.customerId === customer.id && this.archived === !isActive) {
                    var projectRow = projectTemplate.clone().appendTo(cpList);

                    projectRow.find(".name").text(this.name);
                    projectRow.click(onProjectRowClick);
                    projectRow.mouseover(onRowMouseOver);

                    projectRow.data({
                        id: this.id,
                        customerRow: customerRow,
                        name: this.name,
                        fullName: customer.name + " / " + this.name,
                        customerId: this.customerId
                    });

                    projectRows.push(projectRow[0]);

                    cpIndex.addProject(projectRow);
                }
            });

            if (customer.archived === !isActive || projectRows.length > 0) {
                var projectsTrailer = projectsTrailerTemplate.clone().appendTo(cpList).hide();

                if (projectRows.length === 0) customerRow.addClass("empty");

                customerRow.data({ id: customer.id,
                    name: customer.name,
                    fullName: customer.name,
                    projectRows: (0, _jquery2.default)(projectRows),
                    projectsTrailer: projectsTrailer
                });

                cpIndex.addCustomer(customerRow);
            } else {
                customerRow.remove();
            }
        });

        if (!isActive) {
            cpList.find(".noEntriesMsg").text(_messageResource2.default.getMessage("submit_tt.cp_selector.empty.archived"));
            cpList.find(".noMatchesMsg").text(_messageResource2.default.getMessage("submit_tt.cp_selector.nothing_found.archived"));
        }

        cpList.toggleClass("empty", cpList.children(".row.customer").length == 0);

        if (!initialized) {
            container.find(".combobox .dropdownButton").click(onDropdownButtonClick);
            searchField.keydown(onSearchFieldKeyDown);
            searchField.focus(onSearchFieldFocus);
            expandAllButton.click(expandAll);
            collapseAllButton.click(collapseAll);
            (0, _atBrowserUtils.setMouseDownOutsideHandler)(container, onMouseDownOutside);
            cpList.scroll(onScroll);
        }

        setComboTextForSelectedRow();

        initialized = true;
    };

    /**
     * @return {Boolean} whether the selector is initialized or not.
     */
    this.isInitialized = function () {
        return initialized;
    };

    /**
     * Hides the selector and shows spinner instead.
     * TODO: since the selector itself doesn't load data from the server (that's when then spinner is shown),
     *       it is reasonable to move the spinning code outside of this module.
     */
    this.spin = function () {
        container.css("visibility", "hidden");
        spinner.spin(container.parent()[0]);
    };

    /**
     * Hides the spinner and shows the selector again.
     * TODO: see TODO in the 'spin' method.
     */
    this.stopSpin = function () {
        container.css("visibility", "visible");
        spinner.stop();
    };

    this.hideSelector = function () {
        var isSelected = selectedRow.length > 0;
        container.hide();
        if (isSelected) {
            selectedRow = (0, _jquery2.default)();
            setComboTextForSelectedRow();
            onCustomerOrProjectSelect(0, 0, {}, {});
        }
        spinner.stop();
    };

    this.showSelector = function () {
        container.show();
        spinner.stop();
    };

    /**
     * Closes the selector dropdown if it's open.
     */
    this.closeDropdown = function () {
        if (cpDropdownOpenFromButton) {
            _key_down_handler2.default.restoreOnKeyDownHandler();
            cpDropdownOpenFromButton = false;
        }

        cpDropdown.addClass('hidden');
        disableSearchMode();
        setComboTextForSelectedRow();
        searchField.blur();
    };

    function CPIndex() {
        var map = {};
        var index = new _StringIndex2.default();

        /**
         * @param row jQuery object
         */
        this.addCustomer = function (row) {
            addRow(row, -row.data().id);
        };

        /**
         * @param row jQuery object
         */
        this.addProject = function (row) {
            addRow(row, row.data().id);
        };

        /**
         * @param string string
         * @return object {row: jQuery object, highlightedName: string}
         */
        this.find = function (string) {
            var tokens = index.getTokenizer().getTokens(string.toLowerCase()); // TODO: tokenizer should use toLowerCase itself?
            var ids = index.search(tokens);
            if (tokens.length != 0) var highlighter = new _TokensHighlighter2.default(tokens, index.getTokenizer().getPunctuators());
            var results = [];

            _jquery2.default.each(ids, function (i) {
                results.push({
                    row: map[i],
                    highlightedName: highlighter.highlightTokens(map[i].data().name)
                });
            });

            return results;
        };

        function addRow(row, id) {
            map[id] = row;
            index.add(row.data().name, id);
        }
    }

    function setComboTextForSelectedRow() {
        if (selectedRow.length == 1) {
            searchField.val(selectedRow.data().fullName);
            searchField.removeClass("placeholder");
        } else {
            searchField.val(placeholderText);
            searchField.addClass("placeholder");
        }
    }

    function search(searchText) {
        if (!searchMode) {
            expandBackup = cpList.children(".row.customer.expanded");
            cpList.addClass("searchMode");
            searchMode = true;
        }

        collapseAll();
        cpList.children(".row.customer").hide();
        cpDropdown.removeClass('hidden');

        _jquery2.default.each(cpIndex.find(searchText), function () {
            this.row.show();
            this.row.find(".name").html(this.highlightedName);
            if (this.row.hasClass("project")) {
                this.row.data().customerRow.show().addClass("expanded");
                this.row.data().customerRow.data().projectsTrailer.show();
            }
        });

        var visibleRows = cpList.children(".row:visible");

        if (visibleRows.length > 0) {
            cpList.removeClass("nothingFound");
            setActiveRow(visibleRows.first());
        } else {
            cpList.addClass("nothingFound");
        }

        disableExpandAllCollapseAllButtons();
    }

    function disableSearchMode() {
        if (searchMode) {
            cpList.removeClass("searchMode");

            cpList.children(".row").find(".name").each(function () {
                (0, _jquery2.default)(this).text((0, _jquery2.default)(this).text()); // remove highlighting
            });

            cpList.children(".row.customer").show();

            collapseAll();

            expandBackup.each(function () {
                expandOrCollapseCustomer((0, _jquery2.default)(this), true);
            });

            searchMode = false;

            updateExpandAllCollapseAllButtonsState();

            setActiveRow(null);
        }
    }

    function setActiveRow(row) {
        getActiveRow().removeClass("active");

        if (row) {
            row.addClass("active");
            row.scrollintoview({ duration: 0 });
        }
    }

    function getActiveRow() {
        return cpList.children(".row.active");
    }

    /**
     * @param customerRow jQuery object
     * @param [isExpand] boolean
     */
    function expandOrCollapseCustomer(customerRow, isExpand) {
        if (customerRow.is(":not(.empty)")) {
            customerRow.toggleClass("expanded", isExpand);
            customerRow.data().projectRows.toggle(isExpand);
            customerRow.data().projectsTrailer.toggle(isExpand);
        }
    }

    function expandAll() {
        cpList.children(".row.customer").each(function () {
            expandOrCollapseCustomer((0, _jquery2.default)(this), true);
        });
        updateExpandAllCollapseAllButtonsState();
    }

    function collapseAll() {
        cpList.children(".row.customer").each(function () {
            expandOrCollapseCustomer((0, _jquery2.default)(this), false);
        });
        updateExpandAllCollapseAllButtonsState();
    }

    function disableExpandAllCollapseAllButtons() {
        expandAllButton.prop("disabled", true);
        collapseAllButton.prop("disabled", true);
    }

    function updateExpandAllCollapseAllButtonsState() {
        expandAllButton.prop("disabled", cpList.children(".row.customer:not(.expanded):not(.empty)").length == 0);
        collapseAllButton.prop("disabled", cpList.children(".row.customer.expanded").length == 0);
    }

    function onDropdownButtonClick() {
        disableSearchMode();
        setComboTextForSelectedRow();
        cpDropdown.toggleClass('hidden');
        if (!cpDropdown.hasClass('hidden')) {
            _key_down_handler2.default.setOnKeyDownHandler(function (event) {
                if (event) event.stopPropagation();onKeyDownDropdown(event);
            });
            cpDropdownOpenFromButton = true;
        } else {
            if (cpDropdownOpenFromButton) {
                _key_down_handler2.default.restoreOnKeyDownHandler();
            }
            cpDropdownOpenFromButton = false;
        }
        if (selectedRow.length == 1) {
            if (selectedRow.is(".project")) {
                expandOrCollapseCustomer(selectedRow.data().customerRow, true);
            }

            setActiveRow(selectedRow);
        }

        updateExpandAllCollapseAllButtonsState();
    }

    function onCustomerRowClick() {
        selectedRow = (0, _jquery2.default)(this);
        self.closeDropdown();
        disableSearchMode();
        onCustomerOrProjectSelect(selectedRow.data().id, 0, selectedRow.data(), {});
    }

    function onProjectRowClick() {
        selectedRow = (0, _jquery2.default)(this);
        self.closeDropdown();
        disableSearchMode();
        onCustomerOrProjectSelect(0, selectedRow.data().id, {}, selectedRow.data());
    }

    function onExpandCollapseClick() {
        var customerRow = (0, _jquery2.default)(this).parents(".row");

        expandOrCollapseCustomer(customerRow);
        updateExpandAllCollapseAllButtonsState();

        if (customerRow.hasClass("expanded")) {
            var trailer = customerRow.data().projectsTrailer;
            var trailerBottom = trailer.position().top + trailer.outerHeight(true);
            var customerTop = customerRow.position().top;
            var viewPortHeight = cpList.height();
            var scrollTop = cpList.scrollTop();

            if (trailerBottom > viewPortHeight) {
                var scrollTopDelta = trailerBottom - customerTop < viewPortHeight ? trailerBottom - viewPortHeight : customerTop;

                if (scrollTopDelta > 0) cpList.animate({ scrollTop: scrollTop + scrollTopDelta }, 300);
            }
        }

        return false;
    }

    function onExpandCollapseMouseOver() {
        setActiveRow(null);
        return false;
    }

    function onRowMouseOver() {
        if (hoverEnabled.isTrue()) setActiveRow((0, _jquery2.default)(this));
    }

    function onSearchFieldKeyDown(event) {
        if (event.keyCode == _keyCodes.KEY_CODE_UP || event.keyCode == _keyCodes.KEY_CODE_DOWN) {
            var curActiveRow = getActiveRow();
            var newActiveRow;

            if (curActiveRow.length == 0) newActiveRow = cpList.children(".row:visible").first();else newActiveRow = event.keyCode == _keyCodes.KEY_CODE_UP ? curActiveRow.prevAll(".row:visible").first() : curActiveRow.nextAll(".row:visible").first();

            if (newActiveRow.length == 1) setActiveRow(newActiveRow);

            hoverEnabled.switchValue(); // don't react to mouse move while changing active row with keyboard

            event.preventDefault();
        } else if (event.keyCode == _keyCodes.KEY_CODE_ENTER) {
            getActiveRow().click();
            event.preventDefault(); // prevent triggering the default button handler
        } else if (event.keyCode == _keyCodes.KEY_CODE_ESC) {
            self.closeDropdown();
            event.preventDefault();
            event.stopPropagation();
        } else {
            var oldSearchText = _jquery2.default.trim(searchField.val());

            setTimeout(function () {
                var searchText = _jquery2.default.trim(searchField.val());

                if (searchText != oldSearchText) {
                    if (searchText != "") search(searchText);else disableSearchMode();
                }
            }, 1);
        }
    }

    function onSearchFieldFocus() {
        if (!searchMode) {
            searchField.val("");
            searchField.removeClass("placeholder");
        }
    }

    function onMouseDownOutside() {
        self.closeDropdown();
    }

    function onScroll() {
        hoverEnabled.switchValue(); // don't react to mouse move while scrolling
    }

    function onKeyDownDropdown(event) {
        event = event || window.event;
        if (event.keyCode == _keyCodes.KEY_CODE_ESC) {
            self.closeDropdown();
        }
    }
}

exports.default = CPSelectorController;

/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _spin = __webpack_require__(93);

var _spin2 = _interopRequireDefault(_spin);

var _BoolTimer = __webpack_require__(459);

var _BoolTimer2 = _interopRequireDefault(_BoolTimer);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _StringTokenizer = __webpack_require__(103);

var _StringTokenizer2 = _interopRequireDefault(_StringTokenizer);

var _jquery_rpc = __webpack_require__(26);

var _jquery_rpc2 = _interopRequireDefault(_jquery_rpc);

var _keyCodes = __webpack_require__(66);

var _atUtils = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @author kostenko
 *
 * A controller for task list and search field attached to it.
 *
 * Requires:
 *   jQuery
 *   jQuery.scrollintoview
 *   /js/util/jquery_rpc.js
 *   /js/constants_js.jsp
 *   /js/at.js
 *   /js/message_resources.js (using 'submit_tt' and 'js_escaped_macros.submit_tt' prefixes)
 *   /js/spin.min.js
 *
 * Note: the params below which accept DOM elements may also accept jQuery objects or selectors.
 *
 * @param container - task list container element, which contains all the needed markup
 *                    (for example of markup see 'taskList' element in task_search_control.jsp or task_select_control.jsp)
 * @param searchField - search text field element
 * @param initialRequestSpinnerPlaceholder - element in which to render spinner when doing an initial task list request
 *                                           (as opposed to the 'Show more' request)
 * @param isOwnTimeTrack - whether it is logged in user's own time-track page
 * @param isRecentTasksMode - in this mode:
 *                            - only those tasks are listed which have time tracked by the specified user,
 *                              ordered by last tracking date, most recent first
 *                            - tasks that are already added are not listed
 *                            - 'Show more tasks' link is not shown
 *                            - desiredPortionSize has no effect, only maxResultsPerPortion matters
 * @param isImportTasksMode - in this mode all tasks (open and completed) are shown
 * @param desiredPortionSize - desired number of tasks in a portion, must be > 0.
 * @param maxResultsPerPortion - maximum number of tasks in a portion, must be >= desiredPortionSize.
 * @param isMultiSelect - whether multiple selection is allowed (with checkboxes)
 * @param isEnableKeyboardNavigation - whether to move cursor with Up/Down keys and simulate click with Enter key
 * @param isHideOnEmptyQuery - whether the list should be hidden when no search query is entered
 * @param onRequestProcessingComplete - function executed when an RPC request is completed and its processing finished
 * @param onRequestError - function(jqXHR, textStatus, errorThrown) executed on RPC error.
 *                         Must return true if suppression of built-in error handler is needed.
 *                         See jquery_rpc.js for details.
 * @param onTaskSelect - executed when the user selects a task in single selection mode
 * @param onSelectionChange - executed after the set of selected tasks changes,
 *                            or after the list is cleared or re-built (regardless of the selection state before that).
 *                            Makes sense only in multi-selection mode.
 *                            Use getSelectedTaskIds method to obtain the actual list of selected tasks.
 * @constructor
 *
 * The following methods are declared:
 *   hide
 *   clearQuery
 *   makeInitialRequest
 *   getSelectedTaskIds
 *   clear
 * See their declaration in the constructor body for comments.
 *
 * The following entities are defined in at.js:
 * @name messageResource
 * @name messageResource.getMessageWithEscapedMacros
 * @name KEY_CODE_UP
 * @name KEY_CODE_DOWN
 * @name KEY_CODE_ESC
 * @name KEY_CODE_ENTER
 * @name BoolTimer
 * @name BoolTimer.switchValue
 * @name BoolTimer.isTrue
 */
var TaskListController = function () {
    function TaskListController(_ref) {
        var _this = this;

        var container = _ref.container,
            searchField = _ref.searchField,
            initialRequestSpinnerPlaceholder = _ref.initialRequestSpinnerPlaceholder,
            _ref$isOwnTimeTrack = _ref.isOwnTimeTrack,
            isOwnTimeTrack = _ref$isOwnTimeTrack === undefined ? false : _ref$isOwnTimeTrack,
            _ref$isRecentTasksMod = _ref.isRecentTasksMode,
            isRecentTasksMode = _ref$isRecentTasksMod === undefined ? false : _ref$isRecentTasksMod,
            _ref$isImportTasksMod = _ref.isImportTasksMode,
            isImportTasksMode = _ref$isImportTasksMod === undefined ? false : _ref$isImportTasksMod,
            _ref$desiredPortionSi = _ref.desiredPortionSize,
            desiredPortionSize = _ref$desiredPortionSi === undefined ? 10 : _ref$desiredPortionSi,
            _ref$maxResultsPerPor = _ref.maxResultsPerPortion,
            maxResultsPerPortion = _ref$maxResultsPerPor === undefined ? 20 : _ref$maxResultsPerPor,
            _ref$isMultiSelect = _ref.isMultiSelect,
            isMultiSelect = _ref$isMultiSelect === undefined ? false : _ref$isMultiSelect,
            _ref$isEnableKeyboard = _ref.isEnableKeyboardNavigation,
            isEnableKeyboardNavigation = _ref$isEnableKeyboard === undefined ? false : _ref$isEnableKeyboard,
            _ref$isHideOnEmptyQue = _ref.isHideOnEmptyQuery,
            isHideOnEmptyQuery = _ref$isHideOnEmptyQue === undefined ? false : _ref$isHideOnEmptyQue,
            onRequestProcessingComplete = _ref.onRequestProcessingComplete,
            onRequestError = _ref.onRequestError,
            onTaskSelect = _ref.onTaskSelect,
            onSelectionChange = _ref.onSelectionChange,
            _ref$needClearButton = _ref.needClearButton,
            needClearButton = _ref$needClearButton === undefined ? false : _ref$needClearButton,
            _ref$disableAlreadyAd = _ref.disableAlreadyAdded,
            disableAlreadyAdded = _ref$disableAlreadyAd === undefined ? false : _ref$disableAlreadyAd,
            _ref$findTasksService = _ref.findTasksService,
            findTasksService = _ref$findTasksService === undefined ? null : _ref$findTasksService;

        _classCallCheck(this, TaskListController);

        this.prepareSearchQueryProcessing = function (delay) {
            _this.abortRequestAndStopTimer();
            _this.searchDelayTimer = setTimeout(function () {
                _this.searchField.updateSearchField();
            }, delay);
        };

        this.processSearchQuery = function (newQuery) {
            _this.query = newQuery;

            var tokenizer = new _StringTokenizer2.default(_StringTokenizer2.default.PUNCTUATORS_FOR_SEARCH);
            _this.query = _this.query.replace(tokenizer.replacePunctuatorsPattern, " ");

            if (_this.query === '' && _this.isHideOnEmptyQuery) {
                _this.hide();
            } else {
                _this.makeInitialRequest_internal();
            }
        };

        this.onRowMouseMove = function (taskRow) {
            if (_this.hoverEnabled.isTrue()) _this.setActiveRow(taskRow);
        };

        this.onMouseLeave = function () {
            if (!_this.isEnableKeyboardNavigation) _this.setActiveRow(null);
        };

        this.onScroll = function () {
            _this.hoverEnabled.switchValue(); // don't react to mouse move while scrolling
        };

        this.onInitialRequestComplete = function (data) {
            _this.stopSpin();

            _this.container.show();
            _this.scrollToTop();
            _this.deleteAllRows();
            _this.hideNoMatchesMessage();

            _this.createRows(data);

            if (_this.getShownTasksCount() === 0) {
                var key = (_this.isImportTasksMode ? 'task_selector' : 'submit_tt') + '.task_list.nothing_found';

                if (_this.projectId !== 0) key += '.project_selected';else if (_this.customerId !== 0) key += '.customer_selected';

                if (_this.query !== '') key += '.name_given';

                if (_this.isRecentTasksMode) key += '.recent';

                // TODO old texts need to change this
                if (_this.projectId === 0 && !_this.isRecentTasksMode) {
                    if (!data.viewerHasAccessToAllProjects) key += '.your';
                    if (!_this.isOwnTimeTrack && data.assignmentsFeatureEnabled) key += '.his';
                }

                _this.showNoMatchesMessage(_messageResource2.default.getMessage(key, [_this.selectedUserName]));
            }

            _this._taskList = data.tasks.list;
            _this.onRequestProcessingComplete();
        };

        this.onShowMoreRequestComplete = function (data) {
            _this.stopSpin();
            _this.createRows(data);

            _this._taskList = _this._taskList.concat(data.tasks.list);
            _this.onRequestProcessingComplete();
        };

        this.onRequestError_internal = function (jqXHR, textStatus, errorThrown) {
            _this.stopSpin();
            _this.showMoreDisabled = false;

            if (_this.onRequestError(jqXHR, textStatus, errorThrown)) return true;

            if (errorThrown.exception === 'com.actimind.actitime.services.NoRightsForRemoteCallException') {
                alert(_messageResource2.default.getMessage("common.no_rights_for_operation_anymore"));
                document.location.reload();
                return true;
            }

            if (errorThrown.exception === 'com.actimind.actitime.administration.NoSuchUserException') {
                document.location.reload();
                return true;
            }

            return false;
        };

        this.onRowClick = function (taskRow) {
            var taskId = _this.getTaskId(taskRow);

            if (taskId > 0) {
                if (_this.isMultiSelect) {
                    (0, _jquery2.default)(taskRow).find("input").click();
                } else {
                    _this.abortRequestAndStopTimer();
                    _this.hide();
                    _this.onTaskSelect(taskId);
                }
            } else {
                _this.makeShowMoreRequest();
            }
        };

        this.onRowCheckboxClick = function (event) {
            _this.fireOnSelectionChange();
            event.stopPropagation(); // if event propagates to parent element (row) we'll stuck in a loop
        };

        this.onRowCheckboxChange = function (input) {
            if ((0, _jquery2.default)(input).prop('checked')) (0, _jquery2.default)(input).parents('.row.task').addClass('selected');else (0, _jquery2.default)(input).parents('.row.task').removeClass('selected');
        };

        this.onSearchFieldKeyDown = function (event) {
            if (event.keyCode === _keyCodes.KEY_CODE_UP && _this.isEnableKeyboardNavigation) {
                _this.moveCursorUp();
                event.preventDefault();
            } else if (event.keyCode === _keyCodes.KEY_CODE_DOWN && _this.isEnableKeyboardNavigation) {
                _this.moveCursorDown();
                event.preventDefault();
            } else if (event.keyCode === _keyCodes.KEY_CODE_ENTER && _this.isEnableKeyboardNavigation) {
                if (_this.isShown()) _this.getActiveRow().click();else _this.searchField.updateSearchField();

                event.preventDefault();
            } else if (event.keyCode === _keyCodes.KEY_CODE_ESC) {
                _this.clearQuery();
                event.preventDefault();
            } else {
                _this.prepareSearchQueryProcessing(200);
            }
        };

        // params
        this.isEnableKeyboardNavigation = isEnableKeyboardNavigation;
        this.isMultiSelect = isMultiSelect;
        this.onTaskSelect = onTaskSelect ? onTaskSelect : function () {};
        this.onRequestError = onRequestError ? onRequestError : function () {};
        this.onRequestProcessingComplete = onRequestProcessingComplete ? onRequestProcessingComplete : function () {};
        this.isImportTasksMode = isImportTasksMode;
        this.isRecentTasksMode = isRecentTasksMode;
        this.isOwnTimeTrack = isOwnTimeTrack;
        this.onSelectionChange = onSelectionChange ? onSelectionChange : function () {};
        this.isHideOnEmptyQuery = isHideOnEmptyQuery;
        this.desiredPortionSize = desiredPortionSize;
        this.maxResultsPerPortion = maxResultsPerPortion;
        this.disableAlreadyAdded = disableAlreadyAdded;

        this.hoverEnabled = new _BoolTimer2.default(true, 100);
        this.spinner = new _spin2.default({ length: 3, width: 2, radius: 3, lines: 8, color: '#aaaaaa', trail: 60 });
        this.query = "";
        this.customerId = 0;
        this.projectId = 0;
        this.rpcRequest = null;
        this.showMoreDisabled = false;
        this.isInActiveProjects = true;
        this.selectAllRows = false;
        this.findTaskService = findTasksService !== null ? findTasksService : isImportTasksMode ? "TaskListControllerService.findTasksToImport" : "TaskListControllerService.findTasksToAdd";

        this.selectedUserId = -1;
        this.selectedUserName = '';
        this.alreadyAddedTaskIdsSet = [];

        this.container = (0, _jquery2.default)(container);
        this.searchField = (0, _jquery2.default)(searchField).searchField(this.processSearchQuery, _jquery2.default.trim, needClearButton);

        this.initialRequestSpinnerPlaceholder = (0, _jquery2.default)(initialRequestSpinnerPlaceholder);

        this.container.scroll(this.onScroll);
        this.container.mouseleave(this.onMouseLeave);
        this.searchField.keydown(this.onSearchFieldKeyDown);

        this.onInitialRequestComplete = this.onInitialRequestComplete.bind(this);

        this._taskList = [];
    }

    /**
     * @param userId - id of the user whose time-track is being viewed/edited now
     * @param userName - display name of the selected user
     * @param addedTaskIds - array of ids of task which are already added to TT
     */


    _createClass(TaskListController, [{
        key: "setData",
        value: function setData(userId, userName, addedTaskIds) {
            this.selectedUserId = userId;
            this.selectedUserName = userName;
            this.alreadyAddedTaskIdsSet = (0, _atUtils.arrayToSet)(addedTaskIds);
        }

        /**
         * Hides the task list, aborting pending request.
         */

    }, {
        key: "hide",
        value: function hide() {
            this.abortRequestAndStopTimer();
            this.container.hide();
            this.query = ''; // clear remembered query, but not the text field,
            // to allow reloading results by pressing enter in the field
        }

        /**
         * Clears the search text box and does the necessary processing.
         */

    }, {
        key: "clearQuery",
        value: function clearQuery(skipUpdate) {
            this.searchField.clearSearchField(skipUpdate);
            if (skipUpdate) {
                this.query = this.searchField.val();
            }
        }

        /**
         * Starts the initial RPC request (as opposed to 'show more' request) using the given customer or project id for
         * filtering. Note: if project id is given, then customer id is ignored by the server.
         * @param newCustomerId
         * @param newProjectId
         */

    }, {
        key: "makeInitialRequest",
        value: function makeInitialRequest(newCustomerId, newProjectId) {
            this.customerId = newCustomerId;
            this.projectId = newProjectId;
            this.selectAllRows = false;

            this.makeInitialRequest_internal();
        }

        /**
         * Returns the ids of the selected tasks (only makes sense in multi-select mode).
         * @return {Array}
         */

    }, {
        key: "getSelectedTaskIds",
        value: function getSelectedTaskIds() {
            var _this2 = this;

            var ids = [];

            this.container.children(".row.task").each(function (i, row) {
                var id = _this2.getTaskId(row);
                if ((0, _jquery2.default)(row).find("input:checked").length > 0 && (!_this2.disableAlreadyAdded || !_this2.alreadyAddedTaskIdsSet[id])) ids.push(id);
            });

            return ids;
        }

        /**
         * Returns the ids of the visible tasks (only makes sense in multi-select mode).
         * @return {Array}
         */

    }, {
        key: "getVisibleTaskIds",
        value: function getVisibleTaskIds() {
            var ids = [];

            this.container.children(".row.task").each(function (i, row) {
                ids.push(this.getTaskId(row));
            });

            return ids;
        }
    }, {
        key: "clear",


        /**
         * Clears the current results, aborting pending request.
         */
        value: function clear() {
            this.abortRequestAndStopTimer();
            this.deleteAllRows();
            this.hideNoMatchesMessage();
        }
    }, {
        key: "isShown",
        value: function isShown() {
            return this.container.is(":visible");
        }
    }, {
        key: "selectAll",
        value: function selectAll() {
            this.container.children(".row.task").each(function () {
                (0, _jquery2.default)(this).find("input").prop("checked", true).prop("disabled", true);
                (0, _jquery2.default)(this).addClass("selected");
            });
            this.selectAllRows = true;
            this.fireOnSelectionChange();
        }
    }, {
        key: "unselectAll",
        value: function unselectAll() {
            this.container.children(".row.task").each(function () {
                (0, _jquery2.default)(this).find("input").prop("checked", false).prop("disabled", false);
                (0, _jquery2.default)(this).removeClass("selected");
            });
            this.selectAllRows = false;
            this.fireOnSelectionChange();
        }
    }, {
        key: "isSelectAllRows",
        value: function isSelectAllRows() {
            return this.selectAllRows;
        }
    }, {
        key: "getCustomerId",
        value: function getCustomerId() {
            return this.customerId;
        }
    }, {
        key: "getProjectId",
        value: function getProjectId() {
            return this.projectId;
        }
    }, {
        key: "setInActiveProjects",
        value: function setInActiveProjects(inActive) {
            this.isInActiveProjects = inActive;
        }
    }, {
        key: "moveCursorUp",
        value: function moveCursorUp() {
            this.moveCursorUpOrDown(true);
        }
    }, {
        key: "moveCursorDown",
        value: function moveCursorDown() {
            this.moveCursorUpOrDown(false);
        }
    }, {
        key: "moveCursorUpOrDown",
        value: function moveCursorUpOrDown(isUp) {
            var activeRow = this.getActiveRow();
            var switchTo = isUp ? this.getPrevRow(activeRow) : this.getNextRow(activeRow);

            if (switchTo.size() === 1) {
                this.setActiveRow(switchTo);
                this.hoverEnabled.switchValue(); // don't react to mouse move while changing active row the other way
                switchTo.scrollintoview({ duration: 0 });
            }
        }
    }, {
        key: "getActiveRow",
        value: function getActiveRow() {
            return this.container.children(".row.active");
        }
    }, {
        key: "setActiveRow",
        value: function setActiveRow(row) {
            this.getActiveRow().removeClass("active");
            (0, _jquery2.default)(row).addClass("active");
        }
    }, {
        key: "getNextRow",
        value: function getNextRow(row) {
            return (0, _jquery2.default)(row).next(".row");
        }
    }, {
        key: "getPrevRow",
        value: function getPrevRow(row) {
            return (0, _jquery2.default)(row).prev(".row");
        }
    }, {
        key: "deleteAllRows",
        value: function deleteAllRows() {
            this.container.children(".row").remove();
            this.fireOnSelectionChange();
        }
    }, {
        key: "getShownTasksCount",
        value: function getShownTasksCount() {
            return this.container.children(".row.task").length;
        }
    }, {
        key: "scrollToTop",
        value: function scrollToTop() {
            this.container.scrollTop(0);
        }
    }, {
        key: "isAlreadyAddedTask",
        value: function isAlreadyAddedTask(task) {
            return !!this.alreadyAddedTaskIdsSet[task.id];
        }
    }, {
        key: "setRowContent",
        value: function setRowContent(taskRow, task) {
            var alreadyAdded = this.isAlreadyAddedTask(task);

            taskRow.find(".taskName").html(this.getNamePresentationWithMatches(task.name, task.nameMatchMap.list));

            if (task.parentTaskName) taskRow.find(".taskName").prepend(this.getNamePresentationWithMatches(task.parentTaskName, task.parentTaskNameMatchMap.list), " / ");

            if (this.projectId === 0) taskRow.find(".details").text((this.customerId === 0 ? task.customerName + " / " : "") + task.projectName);else taskRow.find(".details").text("");

            if (alreadyAdded) {
                taskRow.find(".alreadyAdded").show();
                if (this.disableAlreadyAdded) {
                    taskRow.find("input").prop("checked", true).prop("disabled", true);
                }
            }

            this.setAdditionalRowContent(taskRow, task);
        }
    }, {
        key: "setAdditionalRowContent",
        value: function setAdditionalRowContent(taskRow, task) {}
        // abstract


        /**
         * @param rpcResultData
         * @config tasks
         * @config resultsLeft
         */

    }, {
        key: "createRows",
        value: function createRows(rpcResultData) {
            var _this3 = this;

            var shownTasksCount = this.getShownTasksCount();
            var firstNewRow = null;

            /*
             * @param this
             * @config id
             * @config name
             * @config nameMatchMap
             * @config parentTaskName
             * @config parentTaskNameMatchMap
             * @config projectName
             * @config customerName
             */
            _jquery2.default.each(rpcResultData.tasks.list, function (i, task) {
                // TODO move to function
                var alreadyAdded = _this3.isAlreadyAddedTask(task);

                if (_this3.isRecentTasksMode && alreadyAdded) return;

                var taskRow = _this3.container.find(".templates .row.task").clone().appendTo(_this3.container);
                taskRow.find(".taskId").text(task.id);

                _this3.setRowContent(taskRow, task);

                if (i === rpcResultData.tasks.list.length - 1 && rpcResultData.resultsLeft === 0) taskRow.addClass("last");

                taskRow.mousemove(function () {
                    return _this3.onRowMouseMove(taskRow);
                });
                taskRow.click(function () {
                    return _this3.onRowClick(taskRow);
                });

                if (_this3.isMultiSelect) taskRow.find("input").click(_this3.onRowCheckboxClick).change(function (e) {
                    return _this3.onRowCheckboxChange(taskRow.find("input"));
                });

                shownTasksCount++;

                if (firstNewRow === null) firstNewRow = taskRow;

                if (_this3.selectAllRows) {
                    taskRow.find("input").prop("checked", true).prop("disabled", true);
                    taskRow.addClass("selected");
                }
            });

            this.container.children(".showMore").remove();

            if (!this.isRecentTasksMode && rpcResultData.resultsLeft > 0) {
                var showMoreRow = this.container.find(".templates .row.showMore").clone().appendTo(this.container);
                showMoreRow.find(".resultsContainDiv").html(_messageResource2.default.getMessageWithEscapedMacros("js_escaped_macros.submit_tt.task_search.results_contain_tasks", [shownTasksCount, shownTasksCount + rpcResultData.resultsLeft]));

                showMoreRow.mousemove(function () {
                    return _this3.onRowMouseMove(showMoreRow);
                });
                showMoreRow.click(function () {
                    return _this3.onRowClick(showMoreRow);
                });
            }

            if (firstNewRow !== null) {
                if (this.isEnableKeyboardNavigation) this.setActiveRow(firstNewRow);

                this.container.animate({ scrollTop: this.container.scrollTop() + firstNewRow.position().top });
            }

            this.showMoreDisabled = false;
        }
    }, {
        key: "spinInShowMoreRow",
        value: function spinInShowMoreRow() {
            var showMoreRow = this.container.children(".showMore");
            showMoreRow.find('.panelDiv').css('visibility', 'hidden');
            this.spinner.spin(showMoreRow[0]);
        }
    }, {
        key: "spinForInitialRequest",
        value: function spinForInitialRequest() {
            this.spinner.spin(this.initialRequestSpinnerPlaceholder[0]);
        }
    }, {
        key: "stopSpin",
        value: function stopSpin() {
            this.spinner.stop();
            this.container.children(".showMore").find(".panelDiv").css('visibility', 'visible'); // restore the 'show more' row
            // this will only have effect if 'show more' row was actually present
            // and this is needed only in case of 'show more' request error
            // (in case of success the 'show more' row will be replaced by more search results)
        }
    }, {
        key: "showNoMatchesMessage",
        value: function showNoMatchesMessage(text) {
            this.container.find(".noMatches").text(text).show();
        }
    }, {
        key: "hideNoMatchesMessage",
        value: function hideNoMatchesMessage() {
            this.container.find(".noMatches").hide();
        }
    }, {
        key: "makeShowMoreRequest",
        value: function makeShowMoreRequest() {
            if (this.showMoreDisabled) return;

            this.showMoreDisabled = true; // disable 'show more' to prevent inconsistent results because of double-clicks

            this.rpcRequest = this._findTasksCall({
                query: this.query,
                customerId: this.customerId,
                projectId: this.projectId,
                selectedUserId: this.selectedUserId,
                offset: this.getShownTasksCount(),
                desiredPortionSize: this.desiredPortionSize,
                maxResultsPerPortion: this.maxResultsPerPortion,
                isInActiveProjects: this.isInActiveProjects,
                isInArchivedProjects: !this.isInActiveProjects
            }, this.onShowMoreRequestComplete, this.onRequestError_internal);

            this.spinInShowMoreRow();
        }
    }, {
        key: "getTaskId",
        value: function getTaskId(row) {
            return Number((0, _jquery2.default)(row).find(".taskId").text());
        }
    }, {
        key: "abortRequestAndStopTimer",
        value: function abortRequestAndStopTimer() {
            clearTimeout(this.searchDelayTimer);

            if (this.rpcRequest) this.rpcRequest.abort();
        }
    }, {
        key: "makeInitialRequest_internal",
        value: function makeInitialRequest_internal() {
            this.abortRequestAndStopTimer();

            this.showMoreDisabled = true; // disable 'show more' to prevent inconsistent results

            if (this.isRecentTasksMode) this.rpcRequest = this._findRecentTaskCall([this.selectedUserId, this.maxResultsPerPortion], this.onInitialRequestComplete, this.onRequestError_internal);else this.rpcRequest = this._findTasksCall({
                query: this.query,
                customerId: this.customerId,
                projectId: this.projectId,
                selectedUserId: this.selectedUserId,
                offset: 0,
                desiredPortionSize: this.desiredPortionSize,
                maxResultsPerPortion: this.maxResultsPerPortion,
                isInActiveProjects: this.isInActiveProjects,
                isInArchivedProjects: !this.isInActiveProjects
            }, this.onInitialRequestComplete, this.onRequestError_internal);
            this.spinForInitialRequest();
        }
    }, {
        key: "_findRecentTaskCall",
        value: function _findRecentTaskCall(params, onSuccess, onError) {
            return (0, _jquery_rpc2.default)("TaskListControllerService.findRecentTasksToAdd", params, onSuccess, onError);
        }
    }, {
        key: "_findTasksCall",
        value: function _findTasksCall(params, onSuccess, onError) {
            return (0, _jquery_rpc2.default)(this.findTaskService, [params.query, params.customerId, params.projectId, params.selectedUserId, params.offset, params.desiredPortionSize, params.maxResultsPerPortion, params.isInActiveProjects, params.isInArchivedProjects], onSuccess, onError);
        }
    }, {
        key: "fireOnSelectionChange",
        value: function fireOnSelectionChange() {
            setTimeout(this.onSelectionChange, 0);
        }

        /**
         * TODO: this is a candidate for moving to some common file
         */

    }, {
        key: "getNamePresentationWithMatches",
        value: function getNamePresentationWithMatches(name, matchMap) {
            var result = (0, _jquery2.default)('<span/>');

            // by using 'text' method below we ensure that the strings will be properly escaped

            result.append((0, _jquery2.default)('<span/>').text(name.substr(0, matchMap[0])));

            for (var i = 0; i < matchMap.length; i += 2) {
                result.append((0, _jquery2.default)('<span class="highlightToken"/>').text(name.substring(matchMap[i], matchMap[i + 1])));
                result.append((0, _jquery2.default)('<span/>').text(name.substring(matchMap[i + 1], matchMap[i + 2])));
            }

            return result;
        }

        /**
         * @param data
         * @config assignmentsFeatureEnabled
         * @config viewerHasAccessToAllProjects
         */

    }, {
        key: "getLoadedTaskList",
        value: function getLoadedTaskList() {
            return this._taskList;
        }
    }]);

    return TaskListController;
}();

exports.default = TaskListController;

/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
function Pager(containerEl, prevText, nextText, ellipsisText, callback, locationHashString, ignoreHashChange) {
    this.containerEl = containerEl;
    this.callback = callback;
    this.prevText = prevText;
    this.nextText = nextText;
    this.ellipsisText = ellipsisText;
    this.ignoreHashChange = ignoreHashChange;
    this.locationHashString = !locationHashString ? "page" : locationHashString;
    this.onHashChangeSupported = !ignoreHashChange && "onhashchange" in window;
    if (this.onHashChangeSupported) {
        var oldHandler = window.onhashchange;
        var that = this;
        window.onhashchange = function () {
            if (oldHandler) oldHandler();
            if (that._isMyLocationHashString(window.location.hash)) {
                var pageNumFromHash = that.getPageNumFromHash();
                if (!pageNumFromHash) pageNumFromHash = 1;
                callback(pageNumFromHash);
            }
        };
    }
}

Pager.prototype.loadPage = function (pageNum) {
    var newHash = this._makeHashValue(pageNum);
    if (!this.ignoreHashChange && window.location.hash != newHash) {
        window.location.hash = newHash;
        if (!this.onHashChangeSupported) this.callback(pageNum);
    } else {
        // reload current page
        this.callback(pageNum);
    }
};

Pager.prototype._isMyLocationHashString = function (locationHashString) {
    return locationHashString.search("#" + this.locationHashString + "-[0-9]+") != -1;
};

Pager.getTotalPages = function (totalItems, itemsPerPage) {
    if (totalItems == 0 || itemsPerPage == 0) {
        return 1;
    }
    return Math.max(1, Math.ceil(totalItems / itemsPerPage));
};

Pager.prototype.draw = function (totalItems, itemsPerPage, currentPageNum) {
    var totalPages = Pager.getTotalPages(totalItems, itemsPerPage);
    currentPageNum = currentPageNum ? Math.min(Math.max(1, currentPageNum), totalPages) : 1;
    this._removeAll();
    this._appendBlock("prev", this.prevText, currentPageNum > 1 ? currentPageNum - 1 : null);
    var pageNum = 1;
    var midCount = 0;
    while (pageNum <= totalPages) {
        if (totalPages > 9 && pageNum > 1) {
            if (pageNum == 2 && currentPageNum > 5) {
                this._appendBlock("elli", this.ellipsisText, null);
                pageNum = totalPages - Math.max(6, totalPages - (currentPageNum - 2));
                midCount++;
            } else if (midCount == 6 && pageNum < totalPages - 1) {
                this._appendBlock("elli", this.ellipsisText, null);
                pageNum = totalPages;
            }
            midCount++;
        }
        this._appendBlock("page", pageNum, currentPageNum == pageNum ? null : pageNum);
        pageNum++;
    }

    this._appendBlock("next", this.nextText, currentPageNum < totalPages ? currentPageNum + 1 : null);
};

Pager.prototype._removeAll = function () {
    while (this.containerEl.hasChildNodes()) {
        this.containerEl.removeChild(this.containerEl.lastChild);
    }
};

Pager.prototype._makeHashValue = function (pageNum) {
    return "#" + this.locationHashString + "-" + pageNum;
};

Pager.prototype._appendBlock = function (styleClass, content, pageNum) {
    var block;
    if (pageNum) {
        if (!this.ignoreHashChange) {
            block = document.createElement("a");
            block.href = this._makeHashValue(pageNum);
        } else {
            block = document.createElement("div");
            block.className = "pagerItem ";
        }

        var self = this;
        block.onclick = function () {
            self.loadPage(pageNum);
        };
    } else {
        block = document.createElement("span");
    }
    block.className = block.className + styleClass;
    block.innerHTML = content;
    this.containerEl.appendChild(block);
};

Pager.prototype.getPageNumFromHash = function () {
    if (!window.location.hash) return null;
    var exp = new RegExp('#' + this.locationHashString + '\-*([0-9]+)', 'i');
    var result = exp.exec(window.location.hash);
    return !result || result.length < 2 ? null : result[1];
};

Pager.prototype.remove = function () {
    this._removeAll();
};

exports.default = Pager;

/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TreeFilter = function () {
    function TreeFilter() {
        _classCallCheck(this, TreeFilter);

        this.results = null;
    }

    _createClass(TreeFilter, [{
        key: "filterNodes",
        value: function filterNodes() {
            this.results = this.doFilter();
        }
    }, {
        key: "doFilter",
        value: function doFilter() {
            return null;
        }
    }, {
        key: "getResults",
        value: function getResults() {
            return this.results;
        }
    }, {
        key: "getFilterClasses",
        value: function getFilterClasses() {
            return [];
        }
    }]);

    return TreeFilter;
}();

exports.default = TreeFilter;

/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _SelectionTreeNodeRenderer = __webpack_require__(727);

var _SelectionTreeNodeRenderer2 = _interopRequireDefault(_SelectionTreeNodeRenderer);

var _atBrowserUtils = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TriStateCheckboxTreeNodeRenderer = function (_SelectionTreeNodeRen) {
    _inherits(TriStateCheckboxTreeNodeRenderer, _SelectionTreeNodeRen);

    function TriStateCheckboxTreeNodeRenderer(tree) {
        _classCallCheck(this, TriStateCheckboxTreeNodeRenderer);

        return _possibleConstructorReturn(this, (TriStateCheckboxTreeNodeRenderer.__proto__ || Object.getPrototypeOf(TriStateCheckboxTreeNodeRenderer)).call(this, tree));
    }

    _createClass(TriStateCheckboxTreeNodeRenderer, [{
        key: "generateContent",
        value: function generateContent(treeNode, targetEl) {
            var triStateEl = document.createElement("a");
            triStateEl.hidefocus = "true";
            triStateEl.onfocus = function () {
                this.blur();
            };
            var context = this;
            if (this.tree.selectionController.canSelectNode(treeNode) && this.tree.selectionController.canDeselectNode(treeNode)) {
                triStateEl.onclick = function () {
                    context.tree.getSelectionController().toggle(treeNode);

                    // if some node is selected/deselected inside a collapsed node,
                    // then it would be smart to expand the outer node automatically,
                    // so I can see my changes even after I cancel keyword search.
                    var parentNode = treeNode.getParent();
                    if (parentNode && (context.tree.isRootVisible() || parentNode.getLevel() > 0)) context.tree.getExpandController().expand(parentNode);
                };
            }
            (0, _atBrowserUtils.disableTextSelection)(triStateEl, true);

            var checkbox = document.createElement("span");
            checkbox.className = "checkbox";
            checkbox.innerHTML = "<b></b>"; // for IE to display it correctly

            var labelEl = document.createElement("span");
            labelEl.className = "ellipsisLabel";
            targetEl.appendChild(triStateEl);
            triStateEl.appendChild(checkbox);
            triStateEl.appendChild(labelEl);
            this.generateLabel(treeNode, labelEl);

            this.appendAdditionalElements(targetEl, treeNode);

            this.tree.getUIObjectForNode(treeNode).cbEl = triStateEl;
            this.tree.getUIObjectForNode(treeNode).labelEl = labelEl;
        }
    }, {
        key: "appendAdditionalElements",
        value: function appendAdditionalElements(targetEl, treeNode) {}
        // do nothing by default


        //  abstract

    }, {
        key: "generateLabel",
        value: function generateLabel(treeNode, labelEl) {}
    }, {
        key: "updateLabel",
        value: function updateLabel(treeNode) {
            var uiObject = this.tree.getUIObjectForNode(treeNode);
            if (uiObject.labelEl) {
                this.generateLabel(treeNode, uiObject.labelEl);
            }
        }
    }, {
        key: "updateUI",
        value: function updateUI(treeNode) {
            var uiObject = this.tree.getUIObjectForNode(treeNode);
            if (uiObject.cbEl) {
                var selectionController = this.tree.getSelectionController();

                var className = "triState";
                if (selectionController.isSelected(treeNode)) className += " checked";else if (selectionController.containsSelectedChildren(treeNode)) className += " intermediate";

                if (!this.tree.selectionController.canSelectNode(treeNode) || !this.tree.selectionController.canDeselectNode(treeNode)) {
                    className += " selectionDisabled";
                } else {
                    className += " selectionEnabled";
                }

                uiObject.cbEl.className = className;
            }

            _get(TriStateCheckboxTreeNodeRenderer.prototype.__proto__ || Object.getPrototypeOf(TriStateCheckboxTreeNodeRenderer.prototype), "updateUI", this).call(this, treeNode);
        }
    }]);

    return TriStateCheckboxTreeNodeRenderer;
}(_SelectionTreeNodeRenderer2.default);

exports.default = TriStateCheckboxTreeNodeRenderer;

/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = SelectionTreeNodeRenderer;

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _TreeNodeRenderer = __webpack_require__(463);

var _TreeNodeRenderer2 = _interopRequireDefault(_TreeNodeRenderer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function SelectionTreeNodeRenderer(tree) {
    _TreeNodeRenderer2.default.call(this, tree);
}

SelectionTreeNodeRenderer.prototype = _underscore2.default.create(_TreeNodeRenderer2.default.prototype);

SelectionTreeNodeRenderer.prototype.getNodeClasses = function (treeNode) {
    var classes = _TreeNodeRenderer2.default.prototype.getNodeClasses.call(this, treeNode);
    if (this.tree.getSelectionController().isSelected(treeNode)) classes.push("selected");
    return classes;
};

/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = AtMap;
function AtMap() {
    var keys = [];
    var values = [];
    var size = 0;

    /**
     * @return Integer size of map.
     */
    this.size = function () {
        return size;
    };

    /**
     *@return Array all objects in map
     */
    this.getValues = function () {
        return removeUndefinedElements(values);
    };

    /**
     * If key already present in map object replaced old object
     * associated with this key otherwise object add to map.
     * @param key key associated with object
     * @param object object added to map
     */
    this.put = function (key, object) {
        var realKey = createKey(key);
        var index = values.length;
        if (keys[realKey] != undefined) {
            index = keys[realKey];
        }
        keys[realKey] = index;
        values[index] = object;
        size++;
    };

    /**
     * @param key
     * @return object associated with key or null if key not found in map.
     */
    this.get = function (key) {
        var realKey = createKey(key);
        var index = keys[realKey];
        return values[index];
    };

    /**
     * This method delete object associated with key and return object
     * @param key
     * @return object associated with key or null if key not found.
     */
    this.remove = function (key) {
        var realKey = createKey(key);
        var index = keys[realKey];
        var result = null;
        if (index != undefined) {
            result = values[index];
            delete values[index];
            delete keys[realKey];
            size--;
        }
        return result;
    };

    /**
     *
     * @param objectsArray data to create map.
     * @param keyGenerator keyGenerator for create keys from objects.
     */
    this.addArrayToMap = function (objectsArray, keyGenerator) {
        for (var i = 0; i < objectsArray.length; i++) {
            var object = objectsArray[i];
            this.put(keyGenerator.createKey(object), object);
        }
    };

    //private methods
    function removeUndefinedElements(array) {
        var result = [];
        for (var i = 0; i < array.length; i++) {
            if (array[i] != undefined) {
                result.push(array[i]);
            }
        }
        return result;
    }

    //workaround: if send integer key  when put data to Map Array class create index instead key.
    //That why all keys should be string type.
    function createKey(string) {
        return "key:" + string;
    }
}

/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = BaseFieldsDrawerController;

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Created by filatov on 03.02.2016.
 */

function BaseFieldsDrawerController() {}

BaseFieldsDrawerController.prototype.init = function (config) {
    this.getElementByIdFunction = config.getElementByIdFunction;
    this.drawers = [];
    return this;
};

BaseFieldsDrawerController.prototype.initFields = function (accountSettings) {
    for (var i = 0; i < this.drawers.length; ++i) {
        this.drawers[i].initFields(accountSettings);
    }
};

BaseFieldsDrawerController.prototype.setErrorState = function () {};

BaseFieldsDrawerController.prototype.addDrawer = function (drawer) {
    this.drawers.push(drawer);
};

BaseFieldsDrawerController.prototype.getSpecificValues = function () {
    var values = {};
    for (var i = 0; i < this.drawers.length; ++i) {
        _jquery2.default.extend(values, this.drawers[i].getObjectValues());
    }
    return values;
};

BaseFieldsDrawerController.prototype.validateFields = function (oldErrors) {
    var errors = {};
    for (var i = 0; i < this.drawers.length; ++i) {
        _jquery2.default.extend(errors, this.drawers[i].validateFields(oldErrors));
    }
    return errors;
};

BaseFieldsDrawerController.prototype.getErrors = function () {
    var errors = {};
    for (var i = 0; i < this.drawers.length; ++i) {
        _jquery2.default.extend(errors, this.drawers[i].getErrors());
    }
    return errors;
};

BaseFieldsDrawerController.prototype.getNotCopyValues = function () {};

BaseFieldsDrawerController.prototype.updateAccountSettings = function (accountSettings) {};

/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = InvitationDrawer;

var _BaseFieldsDrawer = __webpack_require__(466);

var _BaseFieldsDrawer2 = _interopRequireDefault(_BaseFieldsDrawer);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _jquery_rpc = __webpack_require__(26);

var _jquery_rpc2 = _interopRequireDefault(_jquery_rpc);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _UserNameFormat = __webpack_require__(17);

var _UserNameFormat2 = _interopRequireDefault(_UserNameFormat);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function InvitationDrawer() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$onDialogContentC = _ref.onDialogContentClick,
        onDialogContentClick = _ref$onDialogContentC === undefined ? function () {} : _ref$onDialogContentC;

    this.onDialogContentClick = onDialogContentClick;
}

InvitationDrawer.prototype = new _BaseFieldsDrawer2.default();

InvitationDrawer.prototype.initFields = function (accountSettings) {
    this.$resetPasswordButton = (0, _jquery2.default)(this.getElementByIdFunction("resetPasswordLink"));
    this.$resendButton = (0, _jquery2.default)(this.getElementByIdFunction("resendInvitation"));
    this.$resetPasswordButton.hide();
    this.$resendButton.hide();
    if (this.isNeedDrawResendButton) this.initResendInvitationButton(accountSettings);
    if (this.isNeedDrawResetButton) this.initResetPasswordButton(accountSettings);
};

InvitationDrawer.prototype.setNeedDrawResetButton = function (isNeed) {
    this.isNeedDrawResetButton = isNeed;
};

InvitationDrawer.prototype.setNeedDrawResendButton = function (isNeed) {
    this.isNeedDrawResendButton = isNeed;
};

InvitationDrawer.prototype.initResetPasswordButton = function (accountSettings) {
    var _this = this;

    this.$resetPasswordButton.off();
    var self = this;

    var onOkDialogClick = function onOkDialogClick() {
        self._invitationDialog.showSpinner();

        (0, _jquery_rpc2.default)("UserManagementService.resetPassword", [accountSettings.id], function () {
            self._invitationDialog.hideSpinner();
            self._invitationDialog.hideAndRemove();
            self._populateAndShowSecondConfirmationDialog("<span class='secondResetPasswordDialog secondConfirmDialog'>" + _messageResource2.default.getEscapedMessage("userlist.user_popup.confirmation.reset_password.has_been_sent", [self._formatName(accountSettings)]) + "</span>", self.$resetPasswordButton);
        }, function (jqXHR, textStatus, errorThrown) {
            self._invitationDialog.hideSpinner();
            self._invitationDialog.hideAndRemove();
            if (errorThrown.exception == 'com.actimind.actitime.administration.NoSuchUserException') {
                alert(_messageResource2.default.getMessage('userlist.js.error_no_such_user.edit_user'));
                if (self.handlerIfNoSuchUserAfterAjax) self.handlerIfNoSuchUserAfterAjax();
                return true;
            }
            if (errorThrown.exception == 'com.actimind.common.administration.LastManagerInOtherProductException') {
                alert(_messageResource2.default.getMessage('userlist.js.error_last_admin_in_other_product'));
                return true;
            }
        });
    };

    this.$resetPasswordButton.click(function () {
        _this._invitationDialog = _this._createConfirmDialog();
        var confirmationText = '';
        if (accountSettings.enabled || accountSettings.enabledInOtherProduct) {
            confirmationText = _messageResource2.default.getEscapedMessage("userlist.user_popup.confirmation.reset_password.enabled_user", [_this._formatName(accountSettings), accountSettings.email]);
        } else {
            confirmationText = _messageResource2.default.getEscapedMessage("userlist.user_popup.confirmation.reset_password.disabled_user", [_this._formatName(accountSettings)]);
        }

        _this._invitationDialog.setWrappedContent(confirmationText);
        _this._invitationDialog.show(self.$resetPasswordButton, { offset: "28px 15px" }, onOkDialogClick);
    });

    this.$resetPasswordButton.show();
};

InvitationDrawer.prototype.initResendInvitationButton = function (accountSettings) {

    this.$resendButton.off();
    var self = this;

    var onOkDialogClick = function onOkDialogClick() {
        self._invitationDialog.showSpinner();

        (0, _jquery_rpc2.default)("UserManagementService.resendInvitation", [accountSettings.id], function () {
            self._invitationDialog.hideSpinner();
            self._invitationDialog.hideAndRemove();
            self._populateAndShowSecondConfirmationDialog("<span class='secondResendInvitationDialog secondConfirmDialog'>" + _messageResource2.default.getEscapedMessage("userlist.user_popup.confirmation.resend.has_been_sent", [accountSettings.email]) + "</span>", self.$resendButton);
        }, function (jqXHR, textStatus, errorThrown) {
            self._invitationDialog.hideSpinner();
            self._invitationDialog.hideAndRemove();
            if (errorThrown.exception == 'com.actimind.actitime.administration.NoSuchUserException') {
                alert(_messageResource2.default.getMessage('userlist.js.error_no_such_user.edit_user'));
                if (self.handlerIfNoSuchUserAfterAjax) self.handlerIfNoSuchUserAfterAjax();
                return true;
            }
        });
    };

    var onResendButtonClick = function onResendButtonClick() {
        self._invitationDialog = self._createConfirmDialog();
        self._invitationDialog.setWrappedContent(_messageResource2.default.getEscapedMessage("userlist.user_popup.confirmation.resend", [self._formatName(accountSettings), accountSettings.email]));
        self._invitationDialog.show(self.$resendButton, { offset: "28px 15px" }, onOkDialogClick);
    };

    var resendInvitationEnabled = accountSettings.enabled || accountSettings.enabledInOtherProduct;
    this.$resendButton.on("mousedown", resendInvitationEnabled ? onResendButtonClick : function () {});
    this.$resendButton.show();
    this.$resendButton.toggleClass('disabled', !resendInvitationEnabled);
    if (resendInvitationEnabled) {
        this.$resendButton.removeAttr('title');
    } else {
        this.$resendButton.attr('title', _messageResource2.default.getEscapedMessage('userlist.user_popup.disabled_resend_invitation_tooltip'));
    }
};

InvitationDrawer.prototype._formatName = function (accountSettings) {
    return _UserNameFormat2.default.formatFML(accountSettings.firstName, accountSettings.lastName, accountSettings.middleInitial);
};

InvitationDrawer.prototype._createConfirmDialog = function () {
    return new InvitationDialog({
        onContentClick: this.onDialogContentClick
    }).init((0, _jquery2.default)(this.lightBoxEl));
};

InvitationDrawer.prototype._populateAndShowSecondConfirmationDialog = function (content, elementShowAt) {
    var timerId = null;
    var secondInvitationDialog = this._createConfirmDialog();

    timerId = setTimeout(function () {
        if (timerId == null) return;
        secondInvitationDialog.hideAndRemove();
    }, 5000);

    secondInvitationDialog.setWrappedContent(content);
    var secondInvitationDialogWrapper = secondInvitationDialog.getWrapperElement();
    secondInvitationDialogWrapper.addClass("onlyCloseButton");
    var lastButton = secondInvitationDialogWrapper.find(".ui-dialog-buttonset button").filter(":last-child");
    lastButton.find("span").text("Close");
    lastButton.addClass("shown");
    secondInvitationDialogWrapper.find(".invitationDialog").css("height", "40px");

    secondInvitationDialog.show(elementShowAt, { offset: "28px 15px" }, null, function () {
        timerId = null;
    });
};

/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _PasswordHintTooltip = __webpack_require__(457);

var _PasswordHintTooltip2 = _interopRequireDefault(_PasswordHintTooltip);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Renders link "password requirements" with icon, click on it shows password requirement tips in popup.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Use options to adjust position of popup
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


var PasswordHintLink = function (_TemplateView) {
    _inherits(PasswordHintLink, _TemplateView);

    function PasswordHintLink() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            passwordPolicy = _ref.passwordPolicy,
            _ref$my = _ref.my,
            my = _ref$my === undefined ? "center top" : _ref$my,
            _ref$at = _ref.at,
            at = _ref$at === undefined ? "center bottom" : _ref$at,
            _ref$top = _ref.top,
            top = _ref$top === undefined ? 15 : _ref$top,
            _ref$left = _ref.left,
            left = _ref$left === undefined ? 0 : _ref$left,
            _ref$$hintContainer = _ref.$hintContainer,
            $hintContainer = _ref$$hintContainer === undefined ? (0, _jquery2.default)("body") : _ref$$hintContainer;

        _classCallCheck(this, PasswordHintLink);

        var _this = _possibleConstructorReturn(this, (PasswordHintLink.__proto__ || Object.getPrototypeOf(PasswordHintLink)).call(this));

        _this.passwordPolicy = passwordPolicy;
        _this.positionOptions = {};
        _this.positionOptions.my = my || "center top";
        _this.positionOptions.at = at || "center bottom";
        _this.dialogOffsets = {};
        _this.dialogOffsets.top = top || 15;
        _this.dialogOffsets.left = left || 0;
        _this.$hintContainer = $hintContainer;
        return _this;
    }

    _createClass(PasswordHintLink, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class="passwordHintLink">\n                           <span class="passwordHintLink_title"><%-title%></span>\n                           <div class="img"/>\n                       </div>';
        }
    }, {
        key: 'templateModel',
        value: function templateModel() {
            return {
                title: _messageResource2.default.getMessage("profile.password_requirements")
            };
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            var hintTooltip = this.hintTooltip = new _PasswordHintTooltip2.default(this.passwordPolicy, { dialogOffsets: this.dialogOffsets }).init(this.$hintContainer);
            var $pointTo = this.$el.find(".img");
            var $txt = this.$el.find(".passwordHintLink_title");
            var positionOptions = this.positionOptions;
            this.$el.click(function () {
                hintTooltip.showAt($txt, positionOptions, $pointTo);
            });
        }
    }]);

    return PasswordHintLink;
}(_TemplateView3.default);

exports.default = PasswordHintLink;

/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _PasswordPolicyManager = __webpack_require__(227);

var _PasswordPolicyManager2 = _interopRequireDefault(_PasswordPolicyManager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PasswordErrorMessage = function (_TemplateView) {
    _inherits(PasswordErrorMessage, _TemplateView);

    function PasswordErrorMessage() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            _ref$additionalClass = _ref.additionalClass,
            additionalClass = _ref$additionalClass === undefined ? "" : _ref$additionalClass,
            _ref$passwordValidati = _ref.passwordValidationResult,
            passwordValidationResult = _ref$passwordValidati === undefined ? "" : _ref$passwordValidati,
            _ref$passwordPolicy = _ref.passwordPolicy,
            passwordPolicy = _ref$passwordPolicy === undefined ? _PasswordPolicyManager2.default : _ref$passwordPolicy;

        _classCallCheck(this, PasswordErrorMessage);

        var _this = _possibleConstructorReturn(this, (PasswordErrorMessage.__proto__ || Object.getPrototypeOf(PasswordErrorMessage)).call(this));

        _this.state = {
            passwordValidationResult: passwordValidationResult
        };
        _this.additionalClass = additionalClass;

        _this.onStatePropertyChanged("passwordValidationResult", function (result) {
            if (!result || result.ok) {
                _this.getEl().hide();
            } else {
                _this.showError(passwordPolicy.getErrorMessage(result));
            }
        });
        return _this;
    }

    _createClass(PasswordErrorMessage, [{
        key: 'hideError',
        value: function hideError() {
            this.setState({ passwordValidationResult: { ok: true } });
        }
    }, {
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class="passwordErrorMessage <%=additionalClass%>"></div>';
        }
    }, {
        key: 'showError',
        value: function showError(text) {
            this.getEl().show();
            this.getEl().text(text);
        }
    }]);

    return PasswordErrorMessage;
}(_TemplateView3.default);

exports.default = PasswordErrorMessage;

/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _Ext = __webpack_require__(12);

var _Ext2 = _interopRequireDefault(_Ext);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _at_customer_project_selector_panel = __webpack_require__(734);

var _at_customer_project_selector_panel2 = _interopRequireDefault(_at_customer_project_selector_panel);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _CoarseSelection = __webpack_require__(284);

var _CoarseSelection2 = _interopRequireDefault(_CoarseSelection);

var _StringIndex = __webpack_require__(115);

var _StringIndex2 = _interopRequireDefault(_StringIndex);

var _TreeRootNode = __webpack_require__(354);

var _TreeRootNode2 = _interopRequireDefault(_TreeRootNode);

var _TreeNodeSet = __webpack_require__(79);

var _TreeNodeSet2 = _interopRequireDefault(_TreeNodeSet);

var _ArchivedCustomersParentNodeRenderer = __webpack_require__(475);

var _ArchivedCustomersParentNodeRenderer2 = _interopRequireDefault(_ArchivedCustomersParentNodeRenderer);

var _TreeNode = __webpack_require__(60);

var _TreeNode2 = _interopRequireDefault(_TreeNode);

var _ArchivedProjectsParentNodeRenderer = __webpack_require__(474);

var _ArchivedProjectsParentNodeRenderer2 = _interopRequireDefault(_ArchivedProjectsParentNodeRenderer);

var _CPSelectorTreeBuilder = __webpack_require__(737);

var _CPSelectorTreeBuilder2 = _interopRequireDefault(_CPSelectorTreeBuilder);

var _SwitcherWithWrapper = __webpack_require__(478);

var _SwitcherWithWrapper2 = _interopRequireDefault(_SwitcherWithWrapper);

var _atUtils = __webpack_require__(5);

var _pluralizeUtils = __webpack_require__(40);

var _ReportsCPSelectorFilter = __webpack_require__(1312);

var _ReportsCPSelectorFilter2 = _interopRequireDefault(_ReportsCPSelectorFilter);

var _ReportsCPSelectorTreeBuilderObserver = __webpack_require__(1313);

var _ReportsCPSelectorTreeBuilderObserver2 = _interopRequireDefault(_ReportsCPSelectorTreeBuilderObserver);

var _two_level_selection = __webpack_require__(70);

var _two_level_selection2 = _interopRequireDefault(_two_level_selection);

var _hierarchy_selector_util = __webpack_require__(95);

var _hierarchy_selector_util2 = _interopRequireDefault(_hierarchy_selector_util);

var _ProjectNodeRenderer = __webpack_require__(473);

var _ProjectNodeRenderer2 = _interopRequireDefault(_ProjectNodeRenderer);

var _CustomerNodeRenderer = __webpack_require__(472);

var _CustomerNodeRenderer2 = _interopRequireDefault(_CustomerNodeRenderer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var CustomerProjectSelectorTwoGenericOptionsPanel = _Ext2.default.extend(_at_customer_project_selector_panel2.default, {

    allActiveItemsOptionValue: "all_active",
    genericCls: "generic twoGenericOptions",

    allActiveItemsOptionLabelKeyNotFiltered: "projects_customers_selector.all_active_projects_customers",
    allActiveItemsOptionLabelKeyFiltered: "projects_customers_selector.all_active_projects_customers_filtered",
    resetOnHide: false,

    createGenericOptions: function createGenericOptions() {
        CustomerProjectSelectorTwoGenericOptionsPanel.superclass.createGenericOptions.call(this);
        this.genericOptions.push(new _Ext2.default.form.Radio({
            boxLabel: this.getAllActiveItemsMessage(),
            name: this.realOptionsName,
            inputValue: this.allActiveItemsOptionValue
        }));
    },

    getCustomOptionSection: function getCustomOptionSection() {
        var customOptionControls = [];
        customOptionControls.push(new _Ext2.default.form.Label({
            cls: "reportsCpSelectorLabel",
            text: _messageResource2.default.getMessage("report.common.cp_selector.header")
        }));
        customOptionControls.push(this.getCustomOptionButtonsSection());
        this.customControlsContainer = new _Ext2.default.Container({
            cls: "cpSelectorCustomControlsContainer",
            autoEl: "div",
            items: customOptionControls
        });

        return [this.customOption, this.customControlsContainer];
    },

    getCustomOptionButtonsSection: function getCustomOptionButtonsSection() {
        return new _Ext2.default.Panel({
            cls: "buttonsPanel ",
            autEl: "div",
            items: this.getCustomOptionButtons()
        });
    },

    getCustomOptionButtons: function getCustomOptionButtons() {
        var buttons = [this.filterButton, this.makeVerticalSeparator(), this.hideNonSelectedButton, this.makeVerticalSeparator(), this.selectAllButton, this.makeVerticalSeparator(), this.clearButton];

        if (this.canExpandCollapseNodes()) {
            buttons.push(this.makeVerticalSeparator(), this.collapseAllButton, this.expandAllButton);
        }

        return buttons.reverse();
    },

    getDescription: function getDescription(selectionHelper, dropdownButtonId) {
        if (this.manageScopeOnly) {
            var nodeSet = this.selectorFilter.getVisibleNodeSet(this.getSelectedNodeSet());
            var mapping = _defineProperty({}, _TreeNode2.default.TYPE_PROJECT, _two_level_selection2.default.SECOND_LEVEL_INDEX);
            var selection = _hierarchy_selector_util2.default.makeSelectionFromNodeSet(nodeSet, true, mapping, 4).getSecondLevel();

            if (selection.length === 0) {
                return _messageResource2.default.getEscapedMessage("projects_customers_selector.no_customers_projects_selected");
            } else if (selection.length === 1) {
                return selectionHelper.getSingleItemText(selection[0], false);
            } else if (selection.length > 1) {
                var itemNoun = (0, _atUtils.escapeHtmlSymbols)((0, _pluralizeUtils.projectNameLower)(selection.length));
                return selection.length + " " + itemNoun;
            }
        }

        return selectionHelper.getDescription(this.getSelection(true), dropdownButtonId, true);
    },

    buildCpTree: function buildCpTree(predefinedState) {
        (0, _jquery2.default)('.customerProjectType .treePanel').empty();

        // TODO: List of projects, returned by the server, should be sorted by customer name than by project name.
        // TODO: This way we can avoid conversion of customers from array to map. See also RetrieveCustomersProjectsServiceImpl
        var data = (0, _atUtils.makeMapAndOrderForEntitiesArray)(this.initData.customers);

        this.rootNode = new _TreeRootNode2.default();
        this.searchIndex = new _StringIndex2.default();
        this.allActiveSet = new _TreeNodeSet2.default();
        new _CPSelectorTreeBuilder2.default(this.rootNode, this.initData.projects, data.map, data.order, this.showEmptyCustomers, this.createCpSelectorTreeBuilderObserver(this.searchIndex, this.allActiveSet)).buildTree();
        this.createSelectorTree();
        this.buildSelectorTree();
        this.fireSelectionChangeAllowed = false;
        var state = !!predefinedState ? predefinedState : this.getPredefinedSelectionCallback();

        this.fireSelectionChangeAllowed = true;
        this.showInactive = state.showInactive;
        this.setInitialOptionValue(this.getOptionValueByStateValue(state.optionValue));
        this.loadPermanentState(state);
        this.setSelection(state.selection);
        this.updateState();

        if (this.showShowInactiveCheckbox) {
            var anyArchived = _underscore2.default.any(this.initData.customers, function (c) {
                return c.archived;
            }) || _underscore2.default.any(this.initData.projects, function (p) {
                return p.archived;
            });
            if (!anyArchived) {
                this.showInactiveCheckbox.hide();
            }
        }
    },

    buildSelectorTree: function buildSelectorTree() {
        this.selectorTree.getSelectionController().resetSelectedNodes();
        this.selectorTree.buildDOM(this.treePanel, this.selectorFilter);
        this.treePanel.className = this.getTreePanelClasses().join(" ");
        this.setAlreadyShown();
        this.updateState();
        this.disableTextSelectionForNeededElements();
        this.fireSelectionChangeAllowed = true;
    },

    initializeSelector: function initializeSelector(initData, predefinedState) {
        var _this = this;

        this.enableControls();
        if (initData) this.initData = initData;

        var needShowAllNodes = initData.entirelyManageable || initData.allProjectsManageable || initData.allCustomersManageable;

        var state = !!predefinedState ? predefinedState : this.getPredefinedSelectionCallback();
        this.buildCpTree(state);
        this.setInitialOptionValue(this.getOptionValueByStateValue(state.optionValue));
        if (this.showInactiveCheckbox && !state.forceHideInactive && this.isCheckShowArchivedCheckboxNeeded(state)) {
            this.showInactiveCheckbox.setChecked(true);
            state.showInactive = true;
        }
        this.manageScopeOnly = state.manageScopeOnly;
        this.setPredefinedParameters(state);
        this.loadState(state);

        if (!needShowAllNodes && initData.manageable) {
            var $container = (0, _jquery2.default)(this.el.dom).find('.custom');
            $container.addClass('withScopeSwitcher');

            var switcherText = _messageResource2.default.getMessage('report.common.cp_selector.scope_switcher');
            this.managementScopeSwitcher = new _SwitcherWithWrapper2.default({
                containerAdditionalClass: 'scopeSwitcherContainer',
                switcherTextAdditionalClass: "scopeSwitcherText",
                switcherAdditionalClass: "scopeSwitcher",
                onSwitchCallback: function onSwitchCallback(show) {
                    return _this.showOnlyManageScope(show);
                },
                switcherText: switcherText
            }).init($container);

            this.showOnlyManageScope(this.manageScopeOnly);
        }
    },

    toggleScopeSwitcher: function toggleScopeSwitcher(show) {
        (0, _jquery2.default)('.scopeSwitcherContainer').toggle(show);
    },


    showOnlyManageScope: function showOnlyManageScope(enabled) {
        var state = this.getState();
        this.manageScopeOnly = enabled;
        if (this.managementScopeSwitcher) this.managementScopeSwitcher.setState({ enabled: enabled });
        this.selectorFilter.setShowOnlyManageable(enabled);
        this.fireChangeEvent();
    },

    isShowOnlyManagementScope: function isShowOnlyManagementScope() {
        return this.manageScopeOnly;
    },

    getAllActiveItemsMessage: function getAllActiveItemsMessage() {
        return _messageResource2.default.getEscapedMessage(this.isCustomersProjectsFiltered ? this.allActiveItemsOptionLabelKeyFiltered : this.allActiveItemsOptionLabelKeyNotFiltered);
    },

    getOptionValueByStateValue: function getOptionValueByStateValue(stateValue) {
        switch (stateValue) {
            case _CoarseSelection2.default.ALL:
                return this.allItemsOptionValue;
            case _CoarseSelection2.default.SPECIFIC:
                return this.customOptionValue;
            default:
                return this.allActiveItemsOptionValue;
        }
    },

    getStateValueByOptionValue: function getStateValueByOptionValue(optionValue) {
        switch (optionValue) {
            case this.allItemsOptionValue:
                return _CoarseSelection2.default.ALL;
            case this.customOptionValue:
                return _CoarseSelection2.default.SPECIFIC;
            default:
                return _CoarseSelection2.default.ALL_ACTIVE;
        }
    },

    getNodeRenderers: function getNodeRenderers() {
        var selectionHelper = this.getSelectionHelper();

        var result = {};
        result[_TreeNode2.default.TYPE_CUSTOMER] = new _CustomerNodeRenderer2.default(this.selectorTree, this.selectorFilter, this.getExpandCollapseCallback(), selectionHelper);
        result[_TreeNode2.default.TYPE_PROJECT] = new _ProjectNodeRenderer2.default(this.selectorTree, this.selectorFilter, selectionHelper);
        result[_TreeNode2.default.TYPE_ARCHIVED_PROJECTS_PARENT] = new _ArchivedProjectsParentNodeRenderer2.default(this.selectorTree, this.selectorFilter, selectionHelper);
        result[_TreeNode2.default.TYPE_ARCHIVED_CUSTOMERS_PARENT] = new _ArchivedCustomersParentNodeRenderer2.default(this.selectorTree, this.selectorFilter, selectionHelper);
        return result;
    },

    setPredefinedParameters: function setPredefinedParameters(state) {
        this.predefinedParameters = state;
    },

    loadState: function loadState(state) {
        if (this.isAlreadyShown()) {
            this.manageScopeOnlyInit = state.manageScopeOnly;
            CustomerProjectSelectorTwoGenericOptionsPanel.superclass.loadState.call(this, state);
        }
    },

    resetState: function resetState() {
        this.showOnlyManageScope(this.manageScopeOnlyInit);
        CustomerProjectSelectorTwoGenericOptionsPanel.superclass.loadState.call(this, this.predefinedParameters);
    },

    createCpSelectorTreeBuilderObserver: function createCpSelectorTreeBuilderObserver(searchIndex, allActiveSet) {
        this.treeBuilderObserver = new _ReportsCPSelectorTreeBuilderObserver2.default({
            searchIndex: searchIndex,
            allActiveSet: allActiveSet,
            searchCustomers: true
        });

        return this.treeBuilderObserver;
    },

    setSelectorFilter: function setSelectorFilter() {
        this.selectorFilter = new _ReportsCPSelectorFilter2.default({
            tree: this.selectorTree,
            searchIndex: this.searchIndex,
            allActiveSet: this.allActiveSet,
            projectsWithMaSet: this.treeBuilderObserver.getProjectsWithMaNodesSet(),
            accessibleCustomersSet: this.treeBuilderObserver.getAccessibleCustomerNodesSet(),
            showOnlyManageable: this.manageScopeOnly
        });
    }
});

exports.default = CustomerProjectSelectorTwoGenericOptionsPanel;

/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Ext = __webpack_require__(12);

var _Ext2 = _interopRequireDefault(_Ext);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _TreeNode = __webpack_require__(60);

var _TreeNode2 = _interopRequireDefault(_TreeNode);

var _at_hierarchical_selector_panel = __webpack_require__(735);

var _at_hierarchical_selector_panel2 = _interopRequireDefault(_at_hierarchical_selector_panel);

var _hierarchy_selector_util = __webpack_require__(95);

var _hierarchy_selector_util2 = _interopRequireDefault(_hierarchy_selector_util);

var _CustomerNodeRenderer = __webpack_require__(472);

var _CustomerNodeRenderer2 = _interopRequireDefault(_CustomerNodeRenderer);

var _ProjectNodeRenderer = __webpack_require__(473);

var _ProjectNodeRenderer2 = _interopRequireDefault(_ProjectNodeRenderer);

var _ArchivedProjectsParentNodeRenderer = __webpack_require__(474);

var _ArchivedProjectsParentNodeRenderer2 = _interopRequireDefault(_ArchivedProjectsParentNodeRenderer);

var _ArchivedCustomersParentNodeRenderer = __webpack_require__(475);

var _ArchivedCustomersParentNodeRenderer2 = _interopRequireDefault(_ArchivedCustomersParentNodeRenderer);

var _two_level_selection = __webpack_require__(70);

var _two_level_selection2 = _interopRequireDefault(_two_level_selection);

var _TreeRootNode = __webpack_require__(354);

var _TreeRootNode2 = _interopRequireDefault(_TreeRootNode);

var _StringIndex = __webpack_require__(115);

var _StringIndex2 = _interopRequireDefault(_StringIndex);

var _TreeNodeSet = __webpack_require__(79);

var _TreeNodeSet2 = _interopRequireDefault(_TreeNodeSet);

var _rpc_control_manager = __webpack_require__(235);

var _rpc_control_manager2 = _interopRequireDefault(_rpc_control_manager);

var _CoarseSelection = __webpack_require__(284);

var _CoarseSelection2 = _interopRequireDefault(_CoarseSelection);

var _CPSelectorTreeBuilder = __webpack_require__(737);

var _CPSelectorTreeBuilder2 = _interopRequireDefault(_CPSelectorTreeBuilder);

var _atUtils = __webpack_require__(5);

var _simple_customers_and_projects_selection_helper = __webpack_require__(1311);

var _simple_customers_and_projects_selection_helper2 = _interopRequireDefault(_simple_customers_and_projects_selection_helper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CustomerProjectSelectorPanel = _Ext2.default.extend(_at_hierarchical_selector_panel2.default, {
    allItemsOptionValue: "all",

    allItemsOptionLabelKeyNotFiltered: "projects_customers_selector.all_projects_customers",
    allItemsOptionLabelKeyFiltered: "projects_customers_selector.all_projects_customers_filtered",
    customOptionLabelKey: "projects_customers_selector.selected_customers_projects",
    showInactiveLabelKey: "projects_customers_selector.show_archived",

    collapsedCookiesKey: "",
    isCustomersProjectsFiltered: false,

    nonStandardAllSelectedString: "",
    rpcManager: null,

    showEmptyCustomers: false,

    getPredefinedSelectionCallback: function getPredefinedSelectionCallback() {
        return CPSelectorServerUtil.getPredefinedState();
    },

    getAllItemsOptionLabelKey: function getAllItemsOptionLabelKey() {
        return this.isCustomersProjectsFiltered ? this.allItemsOptionLabelKeyFiltered : this.allItemsOptionLabelKeyNotFiltered;
    },

    initComponent: function initComponent() {
        this.addClass("customer-project-panel");
        this.addClass("hideCustomOptionField");
        CustomerProjectSelectorPanel.superclass.initComponent.call(this);
        this.collapsedCookiesKey += "CollapsedCustomers";
        this.on("afterlayout", function () {
            var parentNode = this.getEl().findParentNode("div.at-selector-menu", 10, true);
            if (parentNode) parentNode.addClass("customerProjectType");
        }, this);
    },

    saveCollapsedNodesIntoCookies: function saveCollapsedNodesIntoCookies() {
        _hierarchy_selector_util2.default.saveCollapsedNodesIntoCookies(this.selectorTree, this.collapsedCookiesKey, _TreeNode2.default.TYPE_CUSTOMER);
    },

    canExpandCollapseNodes: function canExpandCollapseNodes() {
        return true;
    },

    getNodeRenderers: function getNodeRenderers() {
        var selectionHelper = this.getSelectionHelper();

        var result = {};
        result[_TreeNode2.default.TYPE_CUSTOMER] = new _CustomerNodeRenderer2.default(this.selectorTree, this.selectorFilter, this.getExpandCollapseCallback(), selectionHelper);
        result[_TreeNode2.default.TYPE_PROJECT] = new _ProjectNodeRenderer2.default(this.selectorTree, this.selectorFilter, selectionHelper);
        result[_TreeNode2.default.TYPE_ARCHIVED_PROJECTS_PARENT] = new _ArchivedProjectsParentNodeRenderer2.default(this.selectorTree, this.selectorFilter, selectionHelper);
        result[_TreeNode2.default.TYPE_ARCHIVED_CUSTOMERS_PARENT] = new _ArchivedCustomersParentNodeRenderer2.default(this.selectorTree, this.selectorFilter, selectionHelper);
        return result;
    },

    createTree: function createTree() {
        return new CustomerProjectSelectorTree(this.rootNode, this.createEmptyMessageBuilder(), this.getCollapsedNodeIdsFromCookies());
    },

    makeNodeSet: function makeNodeSet(selection) {
        return _hierarchy_selector_util2.default.makeNodeSetByTwoLevelSelection(selection, this.selectorTree.getRootNode(), "c", "p");
    },

    isTopNodeLevel: function isTopNodeLevel(treeNode) {
        return treeNode.getType() == _TreeNode2.default.TYPE_CUSTOMER;
    },

    isLowNodeLevel: function isLowNodeLevel(treeNode) {
        return treeNode.getType() == _TreeNode2.default.TYPE_PROJECT;
    },

    isHiddenNodeSelected: function isHiddenNodeSelected(treeNode) {
        return this.checkHiddenNodeSelectionTemplate(treeNode, function () {
            return treeNode.getType() == _TreeNode2.default.TYPE_ARCHIVED_PROJECTS_PARENT || treeNode.getValue().archived;
        });
    },

    createEmptyMessageBuilder: function createEmptyMessageBuilder() {
        return new CustomerProjectSelectorEmptyMessageBuilder(this.isCustomersProjectsFiltered);
    },

    makeSelectionHelper: function makeSelectionHelper() {
        this.selectionHelper = new _simple_customers_and_projects_selection_helper2.default({ isCustomersProjectsFiltered: this.isCustomersProjectsFiltered });
    },

    getSelection: function getSelection(isFullFormed, transformFirstLevelToSecond) {
        var mapping = {};
        if (!transformFirstLevelToSecond) mapping[_TreeNode2.default.TYPE_CUSTOMER] = _two_level_selection2.default.FIRST_LEVEL_INDEX;
        mapping[_TreeNode2.default.TYPE_PROJECT] = _two_level_selection2.default.SECOND_LEVEL_INDEX;
        return _hierarchy_selector_util2.default.makeSelectionFromNodeSet(this.getSelectedNodeSet(), isFullFormed, mapping, 4);
    },

    /**
     * Get single selected customer or project if only one item is selected and null otherwise
     */
    getSingleSelectedCustomerOrProject: function getSingleSelectedCustomerOrProject() {
        if (this.isCustomOptionSelected()) {
            var selection = this.getSelection(true);
            var customers = selection.getFirstLevel();
            var projects = selection.getSecondLevel();
            if (customers.length + projects.length == 1) {
                return customers.length == 1 ? customers[0] : projects[0];
            }
        }
        return null;
    },

    initializeSelector: function initializeSelector(initData, predefinedState) {
        this.enableControls();
        // TODO: List of projects, returned by the server, should be sorted by customer name than by project name.
        // TODO: This way we can avoid conversion of customers from array to map. See also RetrieveCustomersProjectsServiceImpl
        var data = (0, _atUtils.makeMapAndOrderForEntitiesArray)(initData.customers);

        this.rootNode = new _TreeRootNode2.default();
        this.searchIndex = new _StringIndex2.default();
        this.allActiveSet = new _TreeNodeSet2.default();
        new _CPSelectorTreeBuilder2.default(this.rootNode, initData.projects, data.map, data.order, this.showEmptyCustomers, this.createCpSelectorTreeBuilderObserver(this.searchIndex, this.allActiveSet)).buildTree();
        this.createSelectorTree();
        this.buildSelectorTree();
        this.fireSelectionChangeAllowed = false;
        var state = !!predefinedState ? predefinedState : this.getPredefinedSelectionCallback();

        if (this.showInactiveCheckbox && !state.forceHideInactive && this.isCheckShowArchivedCheckboxNeeded(state)) {
            this.showInactiveCheckbox.setChecked(true);
            state.showInactive = true;
        }

        this.setPredefinedParameters(state);
        this.loadState(state);

        this.fireSelectionChangeAllowed = true;

        if (this.showShowInactiveCheckbox) {
            var anyArchived = _underscore2.default.any(initData.customers, function (c) {
                return c.archived;
            }) || _underscore2.default.any(initData.projects, function (p) {
                return p.archived;
            });
            if (!anyArchived) this.showInactiveCheckbox.hide();
        }
    },

    createCpSelectorTreeBuilderObserver: function createCpSelectorTreeBuilderObserver(searchIndex, allActiveSet) {
        return new CPSelectorTreeBuilderObserver(searchIndex, allActiveSet, true);
    },

    isCheckShowArchivedCheckboxNeeded: function isCheckShowArchivedCheckboxNeeded(state) {
        var node;
        if (!state.showInactive) {
            var customers = state.selection.getFirstLevel();
            for (var i = 0; i < customers.length; i++) {
                node = this.rootNode.getNodeById(_hierarchy_selector_util2.default.makeTreeNodeId("c", customers[i]));
                if (node) {
                    if (node.getValue().archived) {
                        return true;
                    }
                }
            }
            var projects = state.selection.getSecondLevel();
            for (var j = 0; j < projects.length; j++) {
                node = this.rootNode.getNodeById(_hierarchy_selector_util2.default.makeTreeNodeId("p", projects[j]));
                if (node) {
                    if (node.getValue().archived) {
                        return true;
                    }
                }
            }
        }
        return false;
    },

    setGetPredefinedSelectionCallback: function setGetPredefinedSelectionCallback(callback) {
        this.getPredefinedSelectionCallback = callback;
    },

    getAllCustomers: function getAllCustomers() {
        var result = [];
        var showArchived = this.getShowInactive();
        var customerNodes = this.rootNode.getChildren();
        for (var i = 0; i < customerNodes.length; i++) {
            if (showArchived || customerNodes[i].active) {
                result.push(customerNodes[i]);
            }
        }
        return result;
    },

    getFilterCallback: function getFilterCallback() {
        var context = this;
        return function (entity) {
            return context.getShowInactive() || !entity.archived;
        };
    },

    loadState: function loadState(state) {
        if (this.isAlreadyShown()) {
            CustomerProjectSelectorPanel.superclass.loadState.call(this, state);
        }
    },

    isStateChanged: function isStateChanged() {
        if (this.isAlreadyShown()) {
            return CustomerProjectSelectorPanel.superclass.isStateChanged.call(this);
        } else {
            return false;
        }
    },

    makeSelectionTree: function makeSelectionTree() {
        //do nothing
    },

    processFirstPanelOpen: function processFirstPanelOpen() {
        if (!this.ajaxStarted) {
            CustomerProjectSelectorPanel.superclass.processFirstPanelOpen.call(this);
            this.disableControls();
            var spinner = this.rpcManager.getSpinner();
            if (!spinner) {
                spinner = new Spinner(CPSelectorClientUtil.DEFAULT_SPINNER_OPTS);
                this.rpcManager.setSpinner(spinner);
            }
            spinner.spin(this.treePanel);
            _rpc_control_manager2.default.saveRpcControlBoundData(this.rpcManager, false);
        }
    },

    getControlsForEnabledChange: function getControlsForEnabledChange() {
        return _underscore2.default.compact(_underscore2.default.flatten([this.genericOptions, this.customOption, this.resetButton, this.selectAllButton, this.clearButton, this.expandAllButton, this.collapseAllButton, this.hideNonSelectedButton, this.filterButton]));
    },

    disableControls: function disableControls() {
        this.ajaxStarted = true;
        _underscore2.default.each(this.getControlsForEnabledChange(), function (control) {
            control.disable();
        });
    },

    enableControls: function enableControls() {
        this.ajaxStarted = false;
        _underscore2.default.each(this.getControlsForEnabledChange(), function (control) {
            control.enable();
        });
    },

    isAllItemsOptionSelected: function isAllItemsOptionSelected() {
        return this.currentOption.inputValue == this.allItemsOptionValue;
    },

    getOptionValueByStateValue: function getOptionValueByStateValue(stateValue) {
        return stateValue == _CoarseSelection2.default.ALL ? this.allItemsOptionValue : this.customOptionValue;
    },

    getStateValueByOptionValue: function getStateValueByOptionValue(optionValue) {
        return optionValue == this.allItemsOptionValue ? _CoarseSelection2.default.ALL : _CoarseSelection2.default.SPECIFIC;
    },

    getAllSelectedString: function getAllSelectedString() {
        return this.isAllItemsOptionSelected() && this.nonStandardAllSelectedString ? this.nonStandardAllSelectedString : this.currentOption.boxLabel;
    },

    isInnerTooltipsEnabled: function isInnerTooltipsEnabled() {
        return false;
    },

    isTooltipEnabled: function isTooltipEnabled() {
        return false;
    },

    onGenericOptionSelect: function onGenericOptionSelect(option, checked) {

        if (checked) {
            this.addClass("hideCustomOptionField");
        }
        CustomerProjectSelectorPanel.superclass.onGenericOptionSelect.call(this, option, checked);
    },

    onCustomOptionSelect: function onCustomOptionSelect(option, checked) {
        if (checked) {
            this.removeClass("hideCustomOptionField");
            if (!_jquery2.default.isEmptyObject(this.selectorTree)) {
                this.selectorTree.refreshScroller();
            }
        }
        CustomerProjectSelectorPanel.superclass.onCustomOptionSelect.call(this, option, checked);
    }

});

_Ext2.default.reg("at_customer_project_selector_panel", CustomerProjectSelectorPanel);

exports.default = CustomerProjectSelectorPanel;

/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _Ext = __webpack_require__(12);

var _Ext2 = _interopRequireDefault(_Ext);

var _at_generic_selector_panel = __webpack_require__(736);

var _at_generic_selector_panel2 = _interopRequireDefault(_at_generic_selector_panel);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _atBrowserUtils = __webpack_require__(8);

var _two_level_selection = __webpack_require__(70);

var _two_level_selection2 = _interopRequireDefault(_two_level_selection);

var _key_down_handler = __webpack_require__(184);

var _key_down_handler2 = _interopRequireDefault(_key_down_handler);

var _FilterWordsField = __webpack_require__(348);

var _FilterWordsField2 = _interopRequireDefault(_FilterWordsField);

var _filter_words_popup = __webpack_require__(464);

var _filter_words_popup2 = _interopRequireDefault(_filter_words_popup);

var _SelectorFilter = __webpack_require__(282);

var _SelectorFilter2 = _interopRequireDefault(_SelectorFilter);

var _at_icon_button = __webpack_require__(471);

var _at_icon_button2 = _interopRequireDefault(_at_icon_button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HierarchicalSelectorPanel = _Ext2.default.extend(_at_generic_selector_panel2.default, {

    /**
     * @cfg {TreeRootNode} root node of nodes hierarchy
     */
    rootNode: null,
    /**
     * @cfg {StringIndex} index for words searching
     */
    searchIndex: null,
    /**
     * @cfg {TreeNodeSet} set of all active entities in selector
     */
    allActiveSet: null,

    hasPanel: true,

    collapsedCookiesKey: null,

    /**
     * fire "selectionChange" callback when "show inactive" checkbox changed
     */
    selectionChangedOnShowInactive: true,

    createComponents: function createComponents() {
        HierarchicalSelectorPanel.superclass.createComponents.call(this);

        this.createCustomControlButtons();

        var context = this;

        this.selectAllButton.on("click", function () {
            context.treeActionHandler(function () {
                context.selectorTree.selectAll();
                context.resetHideNotSelectedState();
            }, true, true);
        });

        this.clearButton.on("click", function () {
            context.treeActionHandler(function () {
                context.selectorTree.deselectAll();
                context.resetHideNotSelectedState();
            }, true, true);
        });

        this.expandAllButton.on("click", function () {
            context.treeActionHandler(function () {
                context.expandCollapseHandler(function () {
                    context.selectorTree.expandAll();
                });
            }, true, false);
        });
        this.collapseAllButton.on("click", function () {
            context.treeActionHandler(function () {
                context.expandCollapseHandler(function () {
                    context.selectorTree.collapseAll();
                });
            }, true, false);
        });

        this._toggleHideNonSelected = function () {
            context.treeActionHandler(function () {
                context.toggleHideNonSelectedButton();
            }, true, false);
        };

        this.hideNonSelectedButton.on("click", this._toggleHideNonSelected);

        this.hideNonSelectedButton.on("mouseover", function () {
            (0, _atBrowserUtils.addClass)(context.hideNonSelectedButton.el.dom.childNodes[0], "hovered");
        });
        this.hideNonSelectedButton.on("mouseout", function () {
            (0, _atBrowserUtils.removeClass)(context.hideNonSelectedButton.el.dom.childNodes[0], "hovered");
        });

        this.filterButton.on("click", function () {
            context.treeActionHandler(function () {
                context.showFilterWordsPopup();
            }, true, false);
        });

        this.hideNonSelectedButtonChecked = false;
    },

    createCustomControlButtons: function createCustomControlButtons() {
        this.selectAllButton = this.createIconButton("doubleButton selectAllButton", "selector_panel/toolbar-button-icons-sprite.png");
        this.clearButton = this.createIconButton("doubleButton clearAllButton", "selector_panel/toolbar-button-icons-sprite.png");
        this.expandAllButton = this.createIconButton("doubleButton expandAllButton", "selector_panel/toolbar-button-icons-sprite.png");
        this.collapseAllButton = this.createIconButton("doubleButton collapseAllButton", "selector_panel/toolbar-button-icons-sprite.png");
        this.hideNonSelectedButton = this.createIconButton("hideNonSelectedButton", "selector_panel/toolbar-hide-not-selected.png", "", _messageResource2.default.getMessage("common.hierarchical_selector.hide_non_selected_button"));
        this.filterButton = this.createIconButton("filterButton", "selector_panel/toolbar-filter.png");
    },

    resetState: function resetState(isEnableActiveActions) {
        if (this.hideNonSelectedButtonChecked) {
            this._toggleHideNonSelected();
        }
        HierarchicalSelectorPanel.superclass.resetState.call(this, isEnableActiveActions);
    },

    createSelectionFilters: function createSelectionFilters() {
        HierarchicalSelectorPanel.superclass.createSelectionFilters.call(this);

        var context = this;
        this.showInactiveCheckbox.on("check", function (e, checked) {
            context.treeActionHandler(function () {
                context.selectorFilter.setShowInactiveAndReFilter(checked);
            }, true, context.selectionChangedOnShowInactive);
        });
    },

    toggleHideNonSelectedButton: function toggleHideNonSelectedButton() {
        this.hideNonSelectedButtonChecked = !this.hideNonSelectedButtonChecked;
        //this code was add because IE doesn't recognize double classnames in css selectors
        if (this.hideNonSelectedButton.el) {
            var el = (0, _jquery2.default)(this.hideNonSelectedButton.el.dom);
            el.toggleClass("active", this.hideNonSelectedButtonChecked);
            el.toggleClass("non-active", !this.hideNonSelectedButtonChecked);
        }
        this.selectorFilter.setShowSelectedOnlyAndReFilter(this.hideNonSelectedButtonChecked);
    },

    setHideNonSelectedButtonState: function setHideNonSelectedButtonState(checked) {
        this.hideNonSelectedButtonChecked = !checked;
        this.toggleHideNonSelectedButton();
    },

    resetHideNotSelectedState: function resetHideNotSelectedState() {
        this.selectorFilter.updateSelectedOnlyState();
        if (this.selectorFilter.isShowSelectedOnly()) this.selectorFilter.reFilter();
        this.setHideNonSelectedButtonState(false);
    },

    afterResetAction: function afterResetAction() {
        this.resetHideNotSelectedState();
        if (this.filterWordsPopup && this.filterWordsPopup.isShown()) {
            this.filterWordsField.clearInputValue(true);
            this.filterWordsPopup.hide();
            this.updateState();
        }
    },

    defineSelectorTreeEvents: function defineSelectorTreeEvents() {
        //do nothing
    },

    disableTextSelectionForNeededElements: function disableTextSelectionForNeededElements() {
        (0, _atBrowserUtils.disableTextSelection)(this.customOptionsContainer.el.dom);
    },

    createIconButton: function createIconButton(clazz, iconPath, linkCls, tooltip) {
        return new _at_icon_button2.default({
            cls: clazz,
            icon: (0, _atBrowserUtils.atImgPath)(iconPath),
            linkCls: linkCls ? linkCls : "",
            tooltip: tooltip ? tooltip : ""
        });
    },

    onFilterFieldChanged: function onFilterFieldChanged() {
        var context = this;
        this.treeActionHandler(function () {
            context.selectorFilter.setSearchStringAndReFilter(context.filterWordsField.getSearchString());
        }, true, false);
    },

    showFilterWordsPopup: function showFilterWordsPopup(offset) {
        if (!this.selectorFilter) {
            return;
        }

        var context = this;
        this.selectorTree.expandAll();
        this.saveCollapsedNodesIntoCookies();
        if (!this.filterWordsPopup) {
            this.filterWordsField = new _FilterWordsField2.default().initAndRender(function () {
                context.onFilterFieldChanged();
            }, null, null, function () {
                context.filterWordsField.clearInputValue();context.onFilterFieldChanged();
            });
            this.filterWordsPopup = new _filter_words_popup2.default().initAndRender("filterWordsPopup-" + this.id, this.filterButton.id, this.id, this.hasPanel, this.filterWordsField.getElement(), function () {
                context.filterWordsField.clearInputValue(true);

                // fix for bug 54553 (set focus to some focusable element in selector)
                if (context.customOption) {
                    (0, _jquery2.default)(context.customOption.innerWrap.dom).focus();
                }
            });
        }
        this.onChange(); // call onChange to open panel with filterButton (bug 54534)
        var coordinates = this.getFilterWordsPopupCoordinates();
        this.filterWordsPopup.show(coordinates.x, coordinates.y);
        this.filterWordsField.activateAndFocus();
    },

    getFilterWordsPopupCoordinates: function getFilterWordsPopupCoordinates() {
        return {
            x: 2,
            y: -3
        };
    },

    showCallback: function showCallback() {
        var context = this;

        if (!this.isAlreadyShown()) {
            this.processFirstPanelOpen();
        } else {
            context.setHideNonSelectedButtonState(false);
        }
        if (context.hasPanel) {
            _key_down_handler2.default.setOnKeyDownHandler(function (event) {
                if ((0, _atBrowserUtils.isLetterOrDigitSymbolPressed)(event)) {
                    context.showFilterWordsPopup();
                }
            });
            this.canRemoveKeyHandler = true;
        }
    },

    buildSelectorTree: function buildSelectorTree() {
        this.selectorTree.getSelectionController().resetSelectedNodes();
        this.selectorTree.buildDOM(this.treePanel, this.selectorFilter);
        this.treePanel.className = this.getTreePanelClasses().join(" ");
        this.setAlreadyShown();
        this.updateState();
        this.disableTextSelectionForNeededElements();
        this.fireSelectionChangeAllowed = true;
    },

    getTreePanelClasses: function getTreePanelClasses() {
        var classes = ["treePanel"];
        if (this.customOption && !this.customOption.getValue()) classes.push("inactiveTree");
        return classes;
    },

    processFirstPanelOpen: function processFirstPanelOpen() {
        if (!this.treePanel) {
            this.treePanel = document.createElement("div");
            var treePanelClasses = this.getTreePanelClasses();
            treePanelClasses.push("spinnerPanel"); // spin while panel is not loaded
            this.treePanel.className = treePanelClasses.join(" ");
            var targetEl = this.detailsContainer.el.dom;
            var firstChild = targetEl.childNodes[0];
            if (firstChild) {
                targetEl.insertBefore(this.treePanel, firstChild);
            } else {
                targetEl.appendChild(this.treePanel);
            }
        }
    },

    getCustomOptionSection: function getCustomOptionSection() {
        //from left to right
        var buttons = [];
        buttons.push(this.customOption);
        buttons.push(this.filterButton, this.makeVerticalSeparator());
        buttons.push(this.hideNonSelectedButton, this.makeVerticalSeparator());
        buttons.push(this.selectAllButton, this.makeVerticalSeparator());
        buttons.push(this.clearButton);
        if (this.canExpandCollapseNodes()) {
            buttons.push(this.makeVerticalSeparator(), this.collapseAllButton, this.expandAllButton);
        }
        return buttons.reverse(); // reverse because float:right property are used
    },

    getBaseUserSelectorPanelCustomOptionFields: function getBaseUserSelectorPanelCustomOptionFields() {
        var fields = [this.filterButton, this.hideNonSelectedButton, this.makeVerticalSeparator()];
        if (this.canExpandCollapseNodes()) {
            fields = fields.concat([this.collapseAllButton, this.expandAllButton, this.makeVerticalSeparator()]);
        }
        return fields;
    },

    filterTreeNodes: function filterTreeNodes(showInactive) {
        //do nothing
    },

    saveCollapsedNodesIntoCookies: function saveCollapsedNodesIntoCookies() {
        //abstract
    },

    getCollapsedNodeIdsFromCookies: function getCollapsedNodeIdsFromCookies() {
        return this.canExpandCollapseNodes() ? (0, _atBrowserUtils.getArrayFromCookies)(this.collapsedCookiesKey) : [];
    },

    canExpandCollapseNodes: function canExpandCollapseNodes() {
        //abstract
    },

    getNodeRenderers: function getNodeRenderers() {
        //abstract
    },

    createTree: function createTree() {
        //abstract
    },

    isTopNodeLevel: function isTopNodeLevel(treeNode) {
        //abstract
    },

    isLowNodeLevel: function isLowNodeLevel(treeNode) {
        //abstract
    },

    isHiddenNodeSelected: function isHiddenNodeSelected(treeNode) {
        //abstract
    },

    createEmptyMessageBuilder: function createEmptyMessageBuilder() {
        //abstract
    },

    makeSelectionHelper: function makeSelectionHelper() {
        //abstract
    },

    getSelection: function getSelection(isFullFormed) {
        //abstract
    },

    makeNodeSet: function makeNodeSet(selection) {
        //abstract
    },

    isInnerTooltipsEnabled: function isInnerTooltipsEnabled() {
        if (this.isCustomOptionSelected()) {
            var selection = this.getSelection(false);
            return selection.getFirstLevel().length != 0 && selection.getSecondLevel().length != 0;
        }
        return false;
    },

    isTooltipEnabled: function isTooltipEnabled() {
        if (this.isCustomOptionSelected()) {
            var selection = this.getSelection(false);
            return !selection.isEmpty();
        }
        return false;
    },

    isActiveActionsPermitted: function isActiveActionsPermitted() {
        return this.isAlreadyShown();
    },

    clearSelection: function clearSelection() {
        this.selectorTree.deselectAll();
    },

    checkHiddenNodeSelectionTemplate: function checkHiddenNodeSelectionTemplate(treeNode, checkFunction) {
        return this.isLowNodeLevel(treeNode) && checkFunction(treeNode) && this.selectorTree.hasActiveFilter() && this.selectorTree.getActiveFilter().getResults().contains(treeNode);
    },

    getSelectedNodeSet: function getSelectedNodeSet() {
        return this.isAlreadyShown() ? this.selectorTree.getSelectionController().getSelectedNodeSet() : this.selectorTree.getSelectionController().getInitiallySelectedNodeSet();
    },

    getDescription: function getDescription(selectionHelper, dropdownButtonId) {
        return selectionHelper.getDescription(this.getSelection(true), dropdownButtonId, true);
    },

    getPartialTooltipText: function getPartialTooltipText(isForTopLevelEntity) {
        if (this.currentOption != this.customOption) {
            return this.currentOption.boxLabel;
        } else {
            return this.getTooltipForCustomPartialOption(isForTopLevelEntity);
        }
    },

    getTooltipForCustomOption: function getTooltipForCustomOption() {
        return this.getSelectionHelper().getOneOfEntitiesList(this.getSelection(true));
    },

    getTooltipForCustomPartialOption: function getTooltipForCustomPartialOption(isForTopLevelEntity) {
        return this.getSelectionHelper().getCertainEntityList(this.getSelection(true), isForTopLevelEntity);
    },

    /**
     * Returns the selection which represents Select All custom option
     */
    getLowLevelEntities: function getLowLevelEntities() {
        return this.selectorTree.getLowLevelEntities(this.getFilterCallback());
    },

    getFilterCallback: function getFilterCallback() {
        return function (entity) {
            return true;
        };
    },

    setSelectorFilter: function setSelectorFilter() {
        this.selectorFilter = new _SelectorFilter2.default(this.selectorTree, this.searchIndex, this.allActiveSet);
    },

    createSelectorTree: function createSelectorTree() {
        this.selectorTree = this.createTree();
        this.setSelectorFilter();
        var context = this;
        this.selectorTree.getSelectionController().addListener({
            nodeDeselected: function nodeDeselected() {
                context.treeActionHandler(function () {}, true, true);
            },
            nodeSelected: function nodeSelected(treeNode) {
                context.treeActionHandler(function () {
                    if (context.isTopNodeLevel(treeNode) && context.selectorTree.hasActiveFilter() && context.selectorTree.getActiveFilter().isShowSelectedOnly()) {
                        context.selectorFilter.updateSelectedOnlyState();
                    } else {
                        context.checkAndProcessHiddenNodeSelection(treeNode);
                    }
                }, true, true);
            } });

        this.selectorTree.setNodeRenderers(this.getNodeRenderers());
    },

    checkAndProcessHiddenNodeSelection: function checkAndProcessHiddenNodeSelection(treeNode) {
        if (this.isHiddenNodeSelected(treeNode)) {
            this.showInactiveCheckbox.setChecked(true);
            this.selectorFilter.setShowInactiveAndReFilter(true);
        }
    },

    isSelectionChanged: function isSelectionChanged() {
        return this.showInactive != this.getShowInactive() || this.selectorTree.isSelectionChanged();
    },

    isTruncateStrings: function isTruncateStrings() {
        //all strings truncation is performed in css
        return false;
    },

    onGenericOptionSelect: function onGenericOptionSelect(option, checked) {
        if (checked) {
            var self = this;
            this.treeActionHandler(function () {
                (0, _jquery2.default)(self.treePanel).addClass("inactiveTree");
                // close filter popup if open
                if (self.filterWordsPopup && self.filterWordsPopup.isShown()) {
                    self.filterWordsField.clearInputValue();
                    self.filterWordsPopup.hideWithoutCallback();
                    self.selectorFilter.setSearchStringAndReFilter(self.filterWordsField.getSearchString());
                }
            }, false, true);
        }
    },

    onCustomOptionSelect: function onCustomOptionSelect(option, checked) {
        if (checked) {
            var self = this;
            this.treeActionHandler(function () {
                (0, _jquery2.default)(self.treePanel).removeClass("inactiveTree");
            }, false, true);
        }
    },

    markPredefinedNodesAsSelected: function markPredefinedNodesAsSelected(selection) {
        this.selectorTree.getSelectionController().initializeByNodeSet(this.makeNodeSet(selection));
    },

    selectNodes: function selectNodes(selection) {
        this.selectorTree.resetNodes(this.makeNodeSet(selection));
    },

    setSelection: function setSelection(selection) {
        if (!this.isAlreadyShown()) {
            this.markPredefinedNodesAsSelected(selection);
        } else {
            this.selectNodes(selection);
        }
        this.fireChangeEvent();
    },

    setPredefinedParameters: function setPredefinedParameters(state) {
        this.showInactive = state.showInactive;
        this.setInitialOptionValue(state.optionValue);
        this.markPredefinedNodesAsSelected(state.selection);
    },

    loadState: function loadState(state) {
        this.setInitialOptionValue(this.getOptionValueByStateValue(state.optionValue));
        this.showInactive = state.showInactive;
        this.loadPermanentState(state);
        this.setSelection(state.selection);
        this.updateState();
    },

    getOptionValueByStateValue: function getOptionValueByStateValue(stateValue) {
        return stateValue ? this.allItemsOptionValue : this.customOptionValue;
    },

    getStateValueByOptionValue: function getStateValueByOptionValue(optionValue) {
        return optionValue == this.allItemsOptionValue;
    },

    getState: function getState() {
        return {
            showInactive: this.getShowInactive(),
            optionValue: this.getStateValueByOptionValue(this.getCurrentOptionValue()),
            selection: this.getSelection()
        };
    },

    loadPermanentState: function loadPermanentState(state) {
        if (state.selectionHelper) {
            this.selectionHelper = state.selectionHelper;
        } else {
            this.makeSelectionHelper();
        }
    },

    createDefaultState: function createDefaultState() {
        return {
            showInactive: false,
            optionValue: this.allItemsOptionValue,
            selection: _two_level_selection2.default.emptySelection()
        };
    },

    /**
     * Returns true if panel can be hidden and false otherwise
     */
    processHide: function processHide() {
        var isPermitted = true;
        if (this.filterWordsPopup && this.filterWordsPopup.isShown()) {
            isPermitted = !this.filterWordsPopup.isHideByEscape(window.event);
            this.filterWordsField.clearInputValue(true);
            this.filterWordsPopup.hide();
        }
        if (isPermitted && this.hasPanel && this.canRemoveKeyHandler) {
            this.canRemoveKeyHandler = false;
            _key_down_handler2.default.restoreOnKeyDownHandler();
        }
        return isPermitted;
    },

    treeActionHandler: function treeActionHandler(f, isFirePanelChange, isFireSelectionChange) {
        f();
        if (isFirePanelChange) {
            this.onChange();
        }
        if (this.selectionChangedHandler && isFireSelectionChange && this.fireSelectionChangeAllowed) {
            this.selectionChangedHandler();
        }
    },

    expandCollapseHandler: function expandCollapseHandler(f) {
        f();
        this.saveCollapsedNodesIntoCookies();
    },

    getExpandCollapseCallback: function getExpandCollapseCallback() {
        var context = this;
        return function (f) {
            context.treeActionHandler(function () {
                context.expandCollapseHandler(f);
            }, true, false);
        };
    },

    isEmptySelection: function isEmptySelection() {
        return this.getSelection(false).isEmpty();
    },

    clearPanel: function clearPanel() {
        if (this.treePanel) {
            this.treePanel.remove();
            this.treePanel = undefined;
        }
    }
});

_Ext2.default.reg("at_hierarchical_selector_panel", HierarchicalSelectorPanel);

exports.default = HierarchicalSelectorPanel;

/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Ext = __webpack_require__(12);

var _Ext2 = _interopRequireDefault(_Ext);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _at_selector_panel = __webpack_require__(1304);

var _at_selector_panel2 = _interopRequireDefault(_at_selector_panel);

var _ShowDisabledCheckbox = __webpack_require__(1305);

var _ShowDisabledCheckbox2 = _interopRequireDefault(_ShowDisabledCheckbox);

var _at_icon_button = __webpack_require__(471);

var _at_icon_button2 = _interopRequireDefault(_at_icon_button);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _at_flat_button = __webpack_require__(351);

var _at_flat_button2 = _interopRequireDefault(_at_flat_button);

var _at_gradient_button = __webpack_require__(285);

var _at_gradient_button2 = _interopRequireDefault(_at_gradient_button);

var _atBrowserUtils = __webpack_require__(8);

var _atUtils = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Abstract selector panel with basic set of components.
 *
 * Depends on:
 * <code>/js/controls/selectorControls/at_selector_panel.js</code>
 * <code>/js/controls/selectorControls/selectionHelpers/at_selection_helper.js</code>
 * <code>/js/controls/at_flat_button.js</code>
 * <code>/js/message_resources.js</code> with prefix "common"
 *
 * Defaults styles in:
 * <code>/css/extjs/at-css/at-selector-panel.less</code>
 *
 * @cfg {Array} data data structure with selection items for the selector tree (required).
 * @cfg {String} optionValue selected option's value (required).
 * @cfg {Boolean} showInactive initial value of "show inactive" checkbox.
 */
var GenericSelectorPanel = _Ext2.default.extend(_at_selector_panel2.default, {
    data: [],
    optionsName: "allUsersOpt",

    /**
     * @cfg {String/Number/Boolean} allItemsOptionValue value of the "all items" options.
     */
    allItemsOptionValue: "all",

    /**
     * @cfg {String/Number/Boolean} customOptionValue value of the custom option.
     */
    customOptionValue: "custom",

    /**
     * @cfg {Boolean} true to show, false to hide.
     */
    showResetButton: true,

    /**
     * @cfg {Boolean} whether to show 'Show disabled' checkbox. Note the double 'show' in the name.
     */
    showShowInactiveCheckbox: true,

    /**
     * @cfg {String} resetButtonLabelKey "Reset" button label message key.
     */
    resetButtonLabelKey: "common.reset_filter",

    /**
     * @cfg {String} closeButtonLabelKey "Close" button label message key.
     */
    closeButtonLabelKey: "common.close",

    /**
     * @cfg {String} allUsersOptionLabelKey "All users" option label message key.
     */
    allItemsOptionLabelKey: "",

    /**
     * @cfg {Array} allItemsOptionMessageParams all items option params for message from message resource.
     */
    allItemsOptionMessageParams: [],

    /**
     * @cfg {String} customOptionLabelKey "Custom" option label message key.
     */
    customOptionLabelKey: "",

    /**
     * @cfg {String} showInactiveLabelKey show inactive checkbox label message key.
     */
    showInactiveLabelKey: "",

    /**
     * @cfg {String} labelMaxChars Max label length in characters.
     */
    labelMaxChars: 50,

    /**
     * @cfg {String} labelItemNounSingularKey label item noun singular form message key.
     */
    labelItemNounSingularKey: "",

    /**
     * @cfg {String} labelItemNounPluralKey label item noun plural form message key.
     */
    labelItemNounPluralKey: "",

    /**
     * @cfg {String} labelNoItemsSelectedKey label text no items selected message key.
     */
    labelNoItemsSelectedKey: "",

    /**
     * @cfg {Boolean} labelUseNameForSingleItem true to display item name for single item.
     */
    labelUseNameForSingleItem: true,

    /**
     * @cfg {Function} selectorTreeCtor constructor for a {@link AT.SelectorTree} implementation.
     */
    selectorTreeCtor: null,

    /**
     * @cfg {Array} treeItemTooltipMessageParams specifies message to be show for selectorTree item's tooltips on some
     *              specific conditions.
     */
    treeItemTooltipMessageParams: null,

    /**
     * @cfg {Boolean} is allowed to set 'All selected' if selection is empty (potentially on init and on panel hide)
     */
    isMarkAllSelectedIsEmpty: false,

    /**
     * @cfg {Boolean} determines if panel resets when hidden (unless closeButton is clicked)
     */
    resetOnHide: true,

    /**
     * @cfg {Boolean} determine if there is an obligation to set 'All selected' on initialization if current selection is empty.
     *                Requires 'isMarkAllSelectedIsEmpty' to be true to have an effect.
     */
    isMarkAllSelectedIfEmptyOnInit: true,

    initComponent: function initComponent() {
        GenericSelectorPanel.superclass.initComponent.call(this);
        this.optionValueInit = this.optionValue;
        this.fireSelectionChangeAllowed = false;

        if (this.isMarkAllSelectedIfEmptyOnInit) {
            this.markAllSelectedIfNeeded();
        }
    },

    makeSelectionHelper: function makeSelectionHelper() {
        //abstract
    },

    getSelectionHelper: function getSelectionHelper() {
        if (!this.selectionHelper) {
            this.makeSelectionHelper();
        }
        return this.selectionHelper;
    },

    /**
     * @see AT.SelectorPanel
     */
    createComponents: function createComponents() {

        this.realOptionsName = this.optionsName + "_" + this.id;
        this.createGenericOptions();

        this.createCustomOption();

        this.makeSelectionTree();

        this.selectAllButton = new _at_icon_button2.default({
            icon: (0, _atBrowserUtils.atImgPath)("selector_panel/toolbar-button-icons-sprite.png"),
            cls: "doubleButton selectAllButton"
        });
        this.clearButton = new _at_icon_button2.default({
            cls: "doubleButton deselectAll"
        });

        this.createFooterButtons();
        this.bindFooterButtonsEvents();
        this.createSelectionFilters();
    },

    makeSelectionTree: function makeSelectionTree() {
        this.createSelectorTree();
    },

    createFooterButtons: function createFooterButtons() {
        this.resetButton = new _at_flat_button2.default({
            icon: (0, _atBrowserUtils.atImgPath)("undo.gif"),
            text: _messageResource2.default.getMessage(this.resetButtonLabelKey)
        });
        this.resetButton.addClass("resetButton");
        this.closeButton = new _at_gradient_button2.default({
            text: _messageResource2.default.getMessage(this.closeButtonLabelKey),
            cls: "greyButton close-button"
        });
        this.cancelButton = null;
    },

    bindFooterButtonsEvents: function bindFooterButtonsEvents() {
        if (this.resetButton) this.resetButton.on("click", this.onResetButtonClick, this);
        if (this.closeButton) this.closeButton.on("click", this.onCloseButtonClick, this);
        if (this.cancelButton) this.cancelButton.on("click", this.onCancelButtonClick, this);
    },

    onResetButtonClick: function onResetButtonClick() {
        this.beforeResetAction();
        this.resetState(true);
        this.afterResetAction();
    },

    onCloseButtonClick: function onCloseButtonClick() {
        this.shouldSave = true;
        this.fireEvent("close");
    },

    onCancelButtonClick: function onCancelButtonClick() {
        this.resetState(true);
        this.afterResetAction();
        this.fireEvent("close");
    },

    beforeResetAction: function beforeResetAction() {
        //do nothing
    },

    afterResetAction: function afterResetAction() {
        //do nothing
    },

    createGenericOptions: function createGenericOptions() {
        this.allSelectedOption = new _Ext2.default.form.Radio({
            boxLabel: this.getAllSelectedMessage(),
            name: this.realOptionsName,
            inputValue: this.allItemsOptionValue
        });

        this.genericOptions = [this.allSelectedOption];
    },

    updateAllSelectedLabel: function updateAllSelectedLabel() {
        this.allSelectedOption.boxLabel = this.getAllSelectedMessage();
    },

    getAllSelectedMessage: function getAllSelectedMessage() {
        return _messageResource2.default.getMessageWithEscapedMacros(this.getAllItemsOptionLabelKey(), this.allItemsOptionMessageParams);
    },

    getAllItemsOptionLabelKey: function getAllItemsOptionLabelKey() {
        return this.allItemsOptionLabelKey;
    },

    getCustomOptionLabelKey: function getCustomOptionLabelKey() {
        return this.customOptionLabelKey;
    },

    createCustomOption: function createCustomOption() {
        this.customOption = new _Ext2.default.form.Radio({
            boxLabel: _messageResource2.default.getMessageWithEscapedMacros(this.getCustomOptionLabelKey()),
            name: this.realOptionsName,
            inputValue: this.customOptionValue
        });
    },

    createSelectorTree: function createSelectorTree() {
        this.selectorTree = new this.selectorTreeCtor({
            propertiesController: this.propertiesController,
            data: this.data
        });
    },

    createSelectionFilters: function createSelectionFilters() {
        var panel = this;
        this.showInactiveCheckboxContainer = new _Ext2.default.Container({
            autoEl: "div",
            afterRender: function afterRender() {
                if (panel.showShowInactiveCheckbox) panel.showInactiveCheckbox.init((0, _jquery2.default)(this.el.dom));
            }
        });
        this.showInactiveCheckbox = new _ShowDisabledCheckbox2.default(this.showInactiveLabelKey);
    },

    setSelectionChangedHandler: function setSelectionChangedHandler(selectionChangedHandler) {
        this.selectionChangedHandler = selectionChangedHandler;
    },

    /**
     * @see AT.SelectorPanel
     */
    getGenericOptionsSection: function getGenericOptionsSection() {
        return this.genericOptions;
    },

    /**
     * @see AT.SelectorPanel
     */
    getCustomOptionSection: function getCustomOptionSection() {
        return [this.clearButton, this.makeVerticalSeparator(), this.selectAllButton, this.customOption];
    },

    makeVerticalSeparator: function makeVerticalSeparator() {
        return new _Ext2.default.BoxComponent({
            autoEl: {
                tag: 'div',
                cls: 'vertical-separator'
            }
        });
    },

    /**
     * @see AT.SelectorPanel
     */
    getDetailsSection: function getDetailsSection() {
        var section = [this.selectorTree];
        if (this.showInactiveCheckboxContainer) section.push(this.showInactiveCheckboxContainer);
        return section;
    },

    getPreFooterSection: function getPreFooterSection() {
        return [];
    },

    /**
     * @see AT.SelectorPanel
     */
    getFooterSection: function getFooterSection() {
        var res = [this.closeButton];
        if (this.showResetButton) {
            res.push(this.resetButton);
        }
        return res;
    },

    /**
     * @see AT.SelectorPanel
     */
    updateState: function updateState() {
        if (this.isActiveActionsPermitted() && this.showShowInactiveCheckbox) {
            this.showInactiveCheckbox.setChecked(this.showInactive);
        }
        this.selectOption(this.optionValue);
    },

    /**
     * @see AT.SelectorPanel
     */
    resetState: function resetState(isEnableActiveActions) {
        this.selectOption(this.optionValueInit);
        if (this.isActiveActionsPermitted() && isEnableActiveActions) {
            this.resetNodes();
        }
        this.updateState();
        if (isEnableActiveActions) {
            this.fireChangeEvent();
        }
    },

    resetNodes: function resetNodes() {
        this.selectorTree.resetNodes();
    },

    isActiveActionsPermitted: function isActiveActionsPermitted() {
        return true;
    },

    isStateChanged: function isStateChanged() {
        if (this.getCurrentOptionValue() !== this.optionValueInit) {
            return true;
        }
        return this.isCustomOptionSelected() && this.isSelectionChanged();
    },

    isSelectionChanged: function isSelectionChanged() {
        return this.selectorTree.isSelectionChanged();
    },

    isTruncateStrings: function isTruncateStrings() {
        return true;
    },

    /*
     Do not pass maxlength if you want to not truncate strings by it
     */
    getAllSelectedString: function getAllSelectedString(maxLength) {
        return maxLength && this.isTruncateStrings() ? (0, _atUtils.truncateStringByLength)(this.currentOption.boxLabel, maxLength, true) : this.currentOption.boxLabel;
    },

    getDescription: function getDescription(selectionHelper, dropdownButtonId) {
        //abstract
    },

    //private
    /*
    Do not pass maxlength if you want to not truncate strings by it
     */
    getLabelTextTemplate: function getLabelTextTemplate(customSelectedFunction, maxLength) {
        if (this.currentOption != this.customOption) {
            return this.getAllSelectedString(maxLength);
        } else {
            return customSelectedFunction();
        }
    },

    getTooltipText: function getTooltipText() {
        var context = this;
        return this.getLabelTextTemplate(function () {
            return context.getTooltipForCustomOption();
        });
    },

    getLabelText: function getLabelText(dropdownButtonId, selectionHelper, maxLength) {
        if (!selectionHelper) {
            selectionHelper = this.getSelectionHelper();
        }
        if (!maxLength) {
            maxLength = this.labelMaxChars;
        }
        var context = this;
        return this.getLabelTextTemplate(function () {
            return context.getDescription(selectionHelper, dropdownButtonId);
        }, maxLength);
    },

    isTooltipEnabled: function isTooltipEnabled() {
        //abstract
    },

    getTooltipForCustomOption: function getTooltipForCustomOption() {
        //abstract
    },

    /**
     * @returns the value of the "show inactive" checkbox.
     */
    getShowInactive: function getShowInactive() {
        return this.isActiveActionsPermitted() ? this.showInactiveCheckbox.isChecked() : this.showInactive;
    },

    setCurrentOptionValue: function setCurrentOptionValue(value) {
        this.optionValue = value;
        this.updateState();
    },

    setInitialOptionValue: function setInitialOptionValue(value) {
        this.optionValueInit = value;
        this.setCurrentOptionValue(value);
    },

    /**
     * Sets initial value of Show Disabled Checkbox
     * @param flag value to set
     *
     * TODO: this is confusing.
     *       The comment says about 'initial value', but no 'initials' can be seen in implementation,
     *       and the method name is abstract and fuzzy.
     *       The 'showInactive' field may be treated as 'initial value', as opposed to the 'getShowInactive' method,
     *       which returns the 'current value'. But every time the 'updateState' method is called, the initial value
     *       becomes current value!
     */
    setFilterFlag: function setFilterFlag(flag) {
        this.showInactive = flag;
    },

    /**
     * Replaces stored initial selection and option values with the current ones.
     */
    setInitialValuesFromCurrent: function setInitialValuesFromCurrent() {
        this.setFilterFlag(this.getShowInactive()); // set initial value for 'Show inactive' checkbox
        this.setInitialOptionValue(this.getCurrentOptionValue()); // set initial value for 'All' option
        this.selectorTree.setInitialSelectionFromCurrent(); // set
    },

    isNeedToMarkAllSelected: function isNeedToMarkAllSelected() {
        return this.isMarkAllSelectedIsEmpty && this.isEmptySelection();
    },

    markAllSelectedIfNeeded: function markAllSelectedIfNeeded() {
        if (this.isNeedToMarkAllSelected()) {
            // if nothing selected
            this.setCurrentOptionValue(true); // then force 'All' option to be selected
        }
    },

    isCustomOptionSelected: function isCustomOptionSelected() {
        return this.currentOption.inputValue == this.customOptionValue;
    },

    isEmptySelection: function isEmptySelection() {
        //abstract
    }

});

exports.default = GenericSelectorPanel;

/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TreeBuilder2 = __webpack_require__(476);

var _TreeBuilder3 = _interopRequireDefault(_TreeBuilder2);

var _CustomerTreeNode = __webpack_require__(1307);

var _CustomerTreeNode2 = _interopRequireDefault(_CustomerTreeNode);

var _ProjectTreeNode = __webpack_require__(1308);

var _ProjectTreeNode2 = _interopRequireDefault(_ProjectTreeNode);

var _ArchivedCustomersParentTreeNode = __webpack_require__(1309);

var _ArchivedCustomersParentTreeNode2 = _interopRequireDefault(_ArchivedCustomersParentTreeNode);

var _ArchivedProjectsParentTreeNode = __webpack_require__(1310);

var _ArchivedProjectsParentTreeNode2 = _interopRequireDefault(_ArchivedProjectsParentTreeNode);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CPSelectorTreeBuilder = function (_TreeBuilder) {
    _inherits(CPSelectorTreeBuilder, _TreeBuilder);

    function CPSelectorTreeBuilder(rootNode, projects, customersMap, customersOrder, createEmptyCustomers, observer) {
        _classCallCheck(this, CPSelectorTreeBuilder);

        var _this = _possibleConstructorReturn(this, (CPSelectorTreeBuilder.__proto__ || Object.getPrototypeOf(CPSelectorTreeBuilder)).call(this, rootNode, projects, customersMap, customersOrder));

        _this.createEmptyCustomers = createEmptyCustomers;
        _this.observer = observer;
        return _this;
    }

    _createClass(CPSelectorTreeBuilder, [{
        key: "createEmptyFirstLevelEntityNodes",
        value: function createEmptyFirstLevelEntityNodes() {
            return this.createEmptyCustomers;
        }
    }, {
        key: "createTreeNodeForFirstLevelEntity",
        value: function createTreeNodeForFirstLevelEntity(customer) {
            return new _CustomerTreeNode2.default(customer);
        }
    }, {
        key: "createTreeNodeForSecondLevelEntity",
        value: function createTreeNodeForSecondLevelEntity(project) {
            return new _ProjectTreeNode2.default(project);
        }
    }, {
        key: "createDisabledNodesParentForFirstLevelEntity",
        value: function createDisabledNodesParentForFirstLevelEntity() {
            return new _ArchivedCustomersParentTreeNode2.default();
        }
    }, {
        key: "createDisabledNodesParentForSecondLevelEntity",
        value: function createDisabledNodesParentForSecondLevelEntity(parentId) {
            return new _ArchivedProjectsParentTreeNode2.default(parentId);
        }
    }, {
        key: "getSecondLevelEntityParentId",
        value: function getSecondLevelEntityParentId(project) {
            return project.customerId;
        }
    }, {
        key: "isFirstLevelEntityEnabled",
        value: function isFirstLevelEntityEnabled(customer) {
            return !customer.archived;
        }
    }, {
        key: "isSecondLevelEntityEnabled",
        value: function isSecondLevelEntityEnabled(project) {
            return !project.archived;
        }
    }, {
        key: "onTreeNodeForFirstLevelEntityAdded",
        value: function onTreeNodeForFirstLevelEntityAdded(treeNode) {
            this.observer.customerNodeAdded(treeNode);
        }
    }, {
        key: "onTreeNodeForSecondLevelEntityAdded",
        value: function onTreeNodeForSecondLevelEntityAdded(treeNode) {
            this.observer.projectNodeAdded(treeNode);
        }
    }, {
        key: "onDisabledNodesParentForFirstLevelEntitiesAdded",
        value: function onDisabledNodesParentForFirstLevelEntitiesAdded(treeNode) {
            this.observer.archivedCustomersParentNodeAdded(treeNode);
        }
    }, {
        key: "onDisabledNodesParentForSecondLevelEntitiesAdded",
        value: function onDisabledNodesParentForSecondLevelEntitiesAdded(treeNode) {
            this.observer.archivedProjectsParentNodeAdded(treeNode);
        }
    }]);

    return CPSelectorTreeBuilder;
}(_TreeBuilder3.default);

exports.default = CPSelectorTreeBuilder;


CPSelectorTreeBuilder.CUSTOMER_NODE_LEVEL = 1;
CPSelectorTreeBuilder.PROJECT_NODE_LEVEL = 2;

/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Ext = __webpack_require__(12);

var _Ext2 = _interopRequireDefault(_Ext);

var _at_selection_helper = __webpack_require__(477);

var _at_selection_helper2 = _interopRequireDefault(_at_selection_helper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HierarchySelectorSelectionHelper = _Ext2.default.extend(_at_selection_helper2.default, {

    wrapTextByTitleSpans: function wrapTextByTitleSpans(text, dropdownButtonId, isFirstLevel) {
        var result = '<span onmouseover="Ext.getCmp(\'' + dropdownButtonId + '\').showInnerTooltip(this, ' + isFirstLevel + ')" ' + 'onmouseout="Ext.getCmp(\'' + dropdownButtonId + '\').hideTooltip(this)">';
        result += text;
        result += '</span>';
        return result;
    },

    getOneOfEntitiesList: function getOneOfEntitiesList(selection) {
        var firstLevelPresent = selection.getFirstLevel().length > 0;
        var secondLevelPresent = selection.getSecondLevel().length > 0;

        if (!firstLevelPresent && !secondLevelPresent || firstLevelPresent && secondLevelPresent) {
            //non-usable case of method
            return "";
        }
        return this.getCertainEntityList(selection, firstLevelPresent);
    }
});

exports.default = HierarchySelectorSelectionHelper;

/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var EXPIRATION_TIMEOUT = 600000;

var GooglePlacesSessionTokenStore = function () {
    function GooglePlacesSessionTokenStore() {
        _classCallCheck(this, GooglePlacesSessionTokenStore);
    }

    _createClass(GooglePlacesSessionTokenStore, [{
        key: "getToken",
        value: function getToken() {
            var _this = this;

            if (!this._token) {
                this._token = window.google && new window.google.maps.places.AutocompleteSessionToken();
                this._timeout = setTimeout(function () {
                    return _this.clearToken();
                }, EXPIRATION_TIMEOUT);
            }

            return this._token;
        }
    }, {
        key: "clearToken",
        value: function clearToken() {
            this._token = null;
            clearTimeout(this._timeout);
        }
    }]);

    return GooglePlacesSessionTokenStore;
}();

var store = new GooglePlacesSessionTokenStore();
exports.default = store;

/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = UserSelectorGroupsStrategy;

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _hierarchy_selector_util = __webpack_require__(95);

var _hierarchy_selector_util2 = _interopRequireDefault(_hierarchy_selector_util);

var _two_level_selection = __webpack_require__(70);

var _two_level_selection2 = _interopRequireDefault(_two_level_selection);

var _TreeNode = __webpack_require__(60);

var _TreeNode2 = _interopRequireDefault(_TreeNode);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function UserSelectorGroupsStrategy() {}

UserSelectorGroupsStrategy.prototype.getEmptySelectionTooltipText = function () {
    return _messageResource2.default.getEscapedMessage(this.emptySelectionTooltipTextKey);
};

UserSelectorGroupsStrategy.prototype.getNoNodesMatchingSearchMessage = function () {
    return _messageResource2.default.getEscapedMessage(this.noNodesMatchingSearchMessageKey);
};

UserSelectorGroupsStrategy.prototype.getNoSelectedNodesMessage = function () {
    return _messageResource2.default.getEscapedMessage(this.noSelectedNodesMessageKey);
};

UserSelectorGroupsStrategy.prototype.canExpandCollapseNodes = function () {
    //abstract
};

UserSelectorGroupsStrategy.prototype.createTree = function (rootNode, emptyMessageBuilder, collapsedNodeIds) {
    //abstract
};

UserSelectorGroupsStrategy.prototype.isGroupNodeRendererNeeded = function () {
    //abstract
};

UserSelectorGroupsStrategy.prototype.makeSelectionFromNodeSet = function (nodeSet, isFullFormed, mapFirstLevelToSecond) {
    var mapping = {};
    if (!mapFirstLevelToSecond) mapping[_TreeNode2.default.TYPE_GROUP] = _two_level_selection2.default.FIRST_LEVEL_INDEX;
    mapping[_TreeNode2.default.TYPE_USER] = _two_level_selection2.default.SECOND_LEVEL_INDEX;
    return _hierarchy_selector_util2.default.makeSelectionFromNodeSet(nodeSet, isFullFormed, mapping, 3);
};

UserSelectorGroupsStrategy.prototype.makeOnlyUsersSelection = function (nodeSet) {
    return this.makeSelectionFromNodeSet(nodeSet, true, false).getSecondLevel();
};

UserSelectorGroupsStrategy.prototype.makeAllSelectedUsersSelection = function (nodeSet, tree, includeHiddenNodes) {
    //abstract
};

UserSelectorGroupsStrategy.prototype.isUserGroupNodeLevel = function (treeNode) {
    return treeNode.getType() == _TreeNode2.default.TYPE_GROUP;
};

UserSelectorGroupsStrategy.prototype.isUserNodeLevel = function (treeNode) {
    return treeNode.getType() == _TreeNode2.default.TYPE_USER;
};

UserSelectorGroupsStrategy.prototype.saveCollapsedNodesIntoCookies = function (tree, cookiesKey) {
    //abstract
};

UserSelectorGroupsStrategy.prototype.makeNodeSet = function (selection, rootNode) {
    //abstract
};

UserSelectorGroupsStrategy.prototype.getAdditionalTreePanelClasses = function () {
    return [];
};

UserSelectorGroupsStrategy.prototype.getUserNodeLevel = function () {
    //abstract
};

/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = UsersSelectorTree;

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _TriStateSelectorTree = __webpack_require__(742);

var _TriStateSelectorTree2 = _interopRequireDefault(_TriStateSelectorTree);

var _hierarchy_selector_util = __webpack_require__(95);

var _hierarchy_selector_util2 = _interopRequireDefault(_hierarchy_selector_util);

var _TreeNode = __webpack_require__(60);

var _TreeNode2 = _interopRequireDefault(_TreeNode);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function UsersSelectorTree(rootNode, emptyMessageBuilder, collapsedNodeIds) {
    _TriStateSelectorTree2.default.call(this, rootNode, emptyMessageBuilder, collapsedNodeIds);
}

UsersSelectorTree.prototype = _underscore2.default.create(_TriStateSelectorTree2.default.prototype);

UsersSelectorTree.prototype.getLowLevelEntities = function (filterCallback) {
    var users = [];
    _underscore2.default.each(this.getAllNodes(), function (node) {
        if (node.getType() == _TreeNode2.default.TYPE_USER && filterCallback(node.getValue())) users.push(node.getValue());
    });
    return users;
};

UsersSelectorTree.prototype.isSelectionChanged = function () {
    return _hierarchy_selector_util2.default.isSelectionChanged(this);
};

/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = TriStateSelectorTree;

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _SelectionTree = __webpack_require__(1317);

var _SelectionTree2 = _interopRequireDefault(_SelectionTree);

var _TriStateSelectionController = __webpack_require__(479);

var _TriStateSelectionController2 = _interopRequireDefault(_TriStateSelectionController);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function TriStateSelectorTree(rootNode, emptyMessageBuilder, collapsedNodeIds) {
    _SelectionTree2.default.call(this, rootNode, false, collapsedNodeIds);
    this.emptyMessageBuilder = emptyMessageBuilder;
}

TriStateSelectorTree.prototype = _underscore2.default.create(_SelectionTree2.default.prototype);

TriStateSelectorTree.prototype.createSelectionController = function () {
    return new _TriStateSelectionController2.default(this);
};

TriStateSelectorTree.prototype.createMessagePanel = function (content, styleClass) {
    var table = document.createElement("table");
    table.className = "selectorMessage " + styleClass;
    var tBody = document.createElement("tbody");
    var tr = document.createElement("tr");
    var td = document.createElement("td");

    table.appendChild(tBody);
    tBody.appendChild(tr);
    tr.appendChild(td);
    td.innerHTML = content;
    return table;
};

TriStateSelectorTree.prototype.decorateTreePanel = function (treePanel) {
    _SelectionTree2.default.prototype.decorateTreePanel.call(this);

    var emptyMessages = this.emptyMessageBuilder.processEmptyMessages();

    for (var key in emptyMessages) {
        //noinspection JSUnfilteredForInLoop
        treePanel.appendChild(this.createMessagePanel(emptyMessages[key], key));
    }

    return treePanel;
};

TriStateSelectorTree.prototype.getVisibleNodeSet = function (nodeSet) {
    return this.hasActiveFilter() ? this.getActiveFilter().getVisibleNodeSet(nodeSet) : nodeSet.clone();
};

TriStateSelectorTree.prototype.isSelectionChanged = function () {
    //abstract
};

TriStateSelectorTree.prototype.selectAll = function () {
    if (this.isRootVisible()) this.getSelectionController().selectSubtree(this.getRootNode(), true);else this.getSelectionController().selectChildrenInDepth(this.getRootNode(), true);
};

TriStateSelectorTree.prototype.resetNodes = function (nodeSet) {
    this.deselectAll();
    this.getSelectionController().resetSelectedNodes(nodeSet);
    this.getSelectionController().updateUI();
};

TriStateSelectorTree.prototype.initializeByNodeSet = function (nodeSet) {
    this.deselectAll();
    this.getSelectionController().initializeByNodeSet(nodeSet);
    this.getSelectionController().resetSelectedNodes();
    this.getSelectionController().updateUI();
};

/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _TreeNodeRenderer = __webpack_require__(463);

var _TreeNodeRenderer2 = _interopRequireDefault(_TreeNodeRenderer);

var _ExpandController = __webpack_require__(1318);

var _ExpandController2 = _interopRequireDefault(_ExpandController);

var _ScrollUtils = __webpack_require__(39);

var _ScrollUtils2 = _interopRequireDefault(_ScrollUtils);

var _atBrowserUtils = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Tree = function () {
    function Tree(rootNode, rootVisible, collapsedNodeIds) {
        _classCallCheck(this, Tree);

        this.rootNode = rootNode;
        this.expandController = this.createExpandController(collapsedNodeIds);
        this.nodeRenderers = [];
        this.defaultNodeRenderer = this.createDefaultNodeRenderer();
        this.activeFilter = null;
        this.previousFilterResults = null;
        this.previousFilterResultsRoots = null;
        this.treeContainer = null;
        this.rootVisible = rootVisible;
        this.uiMap = {};
    }

    _createClass(Tree, [{
        key: "getRootNode",
        value: function getRootNode() {
            return this.rootNode;
        }
    }, {
        key: "isRootVisible",
        value: function isRootVisible() {
            return this.rootVisible;
        }
    }, {
        key: "getAllNodes",
        value: function getAllNodes() {
            var nodes = [];

            function collect(node) {
                nodes.push(node);
                _underscore2.default.each(node.getChildren(), function (child) {
                    collect(child);
                });
            }

            collect(this.rootNode);
            return nodes;
        }
    }, {
        key: "createExpandController",
        value: function createExpandController(collapsedNodeIds) {
            return new _ExpandController2.default(this, collapsedNodeIds);
        }
    }, {
        key: "getExpandController",
        value: function getExpandController() {
            return this.expandController;
        }
    }, {
        key: "setNodeRenderers",
        value: function setNodeRenderers(nodeRenderers) {
            this.nodeRenderers = nodeRenderers;
        }
    }, {
        key: "createDefaultNodeRenderer",
        value: function createDefaultNodeRenderer() {
            return new _TreeNodeRenderer2.default(this);
        }
    }, {
        key: "getRenderer",
        value: function getRenderer(treeNode) {
            var renderer = this.nodeRenderers[treeNode.getType()];
            return renderer ? renderer : this.defaultNodeRenderer;
        }
    }, {
        key: "updateTreeContainerClasses",
        value: function updateTreeContainerClasses() {
            var classes = ["treeContainer"];
            if (this.activeFilter) {
                classes.push("filtered");
                var filterClasses = this.activeFilter.getFilterClasses();
                for (var i = 0; i < filterClasses.length; i++) {
                    classes.push(filterClasses[i]);
                }
            } else {
                classes.push("notFiltered");
                if (!this.rootNode.hasChildren()) {
                    classes.push("empty");
                }
            }
            this.treeContainer.className = classes.join(" ");
        }

        //  TODO: Actually adds empty message panels. There should be some messages builder or common messages logic.

    }, {
        key: "decorateTreePanel",
        value: function decorateTreePanel(treePanel) {
            //do nothing
        }
    }, {
        key: "createTreeContainer",
        value: function createTreeContainer() {
            return document.createElement("div");
        }
    }, {
        key: "buildDOM",
        value: function buildDOM(containerEl, initialFilter) {
            if (initialFilter) this.applyFilterNoUpdate(initialFilter);

            this.treeContainer = this.createTreeContainer();

            this.decorateTreePanel(this.treeContainer);
            this.updateTreeContainerClasses();

            if (this.rootVisible) this.buildDOMForNode(this.treeContainer, this.rootNode);else this.buildDOMForChildren(this.treeContainer, this.rootNode);

            containerEl.appendChild(this.treeContainer);

            this.customScroll = _ScrollUtils2.default.addVerticalScroll((0, _jquery2.default)(containerEl), { isFaded: false });
            (0, _atBrowserUtils.fixIScrollInnerWheelEvent)((0, _jquery2.default)(containerEl));
        }
    }, {
        key: "buildDOMForChildren",
        value: function buildDOMForChildren(targetEl, treeNode) {
            var children = treeNode.getChildren();
            var childrenContainer = (treeNode.getParent() || this.rootVisible) && children.length > 0 ? this.createChildrenContainerDiv(targetEl) : targetEl;
            for (var i = 0; i < children.length; i++) {
                this.buildDOMForNode(childrenContainer, children[i]);
            }
        }
    }, {
        key: "createChildrenContainerDiv",
        value: function createChildrenContainerDiv(targetEl) {
            var childrenContainerDiv = document.createElement("div");
            childrenContainerDiv.className = "childrenContainer";
            targetEl.appendChild(childrenContainerDiv);
            return childrenContainerDiv;
        }
    }, {
        key: "buildDOMForNode",
        value: function buildDOMForNode(targetEl, treeNode) {
            var renderer = this.getRenderer(treeNode);

            var nodeDiv = document.createElement("div");
            this.getUIObjectForNode(treeNode).nodeEl = nodeDiv;

            var contentDiv = document.createElement("div");
            contentDiv.className = "content";

            renderer.generateContent(treeNode, contentDiv);
            renderer.updateUI(treeNode);

            nodeDiv.appendChild(contentDiv);

            this.buildDOMForChildren(nodeDiv, treeNode);

            targetEl.appendChild(nodeDiv);
        }
    }, {
        key: "collapseAll",
        value: function collapseAll() {
            if (this.rootVisible) this.expandController.collapseSubtree(this.rootNode);else this.expandController.collapseChildren(this.rootNode);
        }
    }, {
        key: "expandAll",
        value: function expandAll() {
            if (this.rootVisible) this.expandController.expandSubtree(this.rootNode);else this.expandController.expandChildren(this.rootNode);
        }
    }, {
        key: "_updateUIForTreeNode",
        value: function _updateUIForTreeNode(treeNode) {
            if (treeNode.getParent() != null || this.rootVisible) {
                this.getRenderer(treeNode).updateUI(treeNode);
            }
        }
    }, {
        key: "updateUIForSingleTreeNode",
        value: function updateUIForSingleTreeNode(treeNode) {
            this._updateUIForTreeNode(treeNode);
            this.refreshScroller();
        }
    }, {
        key: "updateUIForTreeNodeSet",
        value: function updateUIForTreeNodeSet(treeNodeSet) {
            for (var level in treeNodeSet.map) {
                //noinspection JSUnfilteredForInLoop
                var levelObj = treeNodeSet.map[level];
                for (var id in levelObj) {
                    //noinspection JSUnfilteredForInLoop
                    this._updateUIForTreeNode(levelObj[id]);
                }
            }

            this.refreshScroller();
        }
    }, {
        key: "resetFilter",
        value: function resetFilter() {
            if (this.previousFilterResults) {
                this.activeFilter = null;
                this.updateTreeContainerClasses();
                this.updateUIForTreeNodeSet(this.previousFilterResults.union(this.previousFilterResultsRoots));
                this.previousFilterResults = null;
                this.previousFilterResultsRoots = null;
            }
        }
    }, {
        key: "getActiveFilter",
        value: function getActiveFilter() {
            return this.activeFilter;
        }
    }, {
        key: "hasActiveFilter",
        value: function hasActiveFilter() {
            return this.activeFilter != null;
        }
    }, {
        key: "doesMatchFilterCriteria",
        value: function doesMatchFilterCriteria(treeNode) {
            return this.previousFilterResults.contains(treeNode);
        }
    }, {
        key: "doesContainChildrenMatchingFilterCriteria",
        value: function doesContainChildrenMatchingFilterCriteria(treeNode) {
            return this.previousFilterResultsRoots.contains(treeNode);
        }
    }, {
        key: "applyFilterNoUpdate",
        value: function applyFilterNoUpdate(filter) {
            var newFilterResults = null;
            if (filter) {
                filter.filterNodes();
                newFilterResults = filter.getResults();
            }
            if (newFilterResults) {
                this.activeFilter = filter;
                if (this.previousFilterResults) {
                    var nodesToUpdate = this.previousFilterResults;
                    nodesToUpdate.addAll(newFilterResults);
                    nodesToUpdate.addAll(nodesToUpdate.makePathsNodeSet());
                    this.previousFilterResults = newFilterResults;
                    this.previousFilterResultsRoots = newFilterResults.makePathsNodeSet();
                    return nodesToUpdate;
                } else {
                    this.previousFilterResults = newFilterResults;
                    this.previousFilterResultsRoots = newFilterResults.makePathsNodeSet();
                    return this.previousFilterResults.union(this.previousFilterResultsRoots);
                }
            } else {
                this.resetFilter();
                return null;
            }
        }
    }, {
        key: "applyFilter",
        value: function applyFilter(filter) {
            var nodesToUpdate = this.applyFilterNoUpdate(filter);
            if (nodesToUpdate) {
                this.updateTreeContainerClasses();
                this.updateUIForTreeNodeSet(nodesToUpdate);
            }
        }
    }, {
        key: "getUIObjectForNode",
        value: function getUIObjectForNode(treeNode) {
            var uiObject = this.uiMap[treeNode.id];
            if (!uiObject) {
                uiObject = {};
                this.uiMap[treeNode.id] = uiObject;
            }
            return uiObject;
        }
    }, {
        key: "refreshScroller",
        value: function refreshScroller() {
            _ScrollUtils2.default.refreshCustomScroll(this.customScroll);
        }
    }]);

    return Tree;
}();

exports.default = Tree;

/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = TreeSelectionController;

var _TreeNodeSet = __webpack_require__(79);

var _TreeNodeSet2 = _interopRequireDefault(_TreeNodeSet);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function TreeSelectionController(tree) {
    this.tree = tree;
    this.nodeSet = new _TreeNodeSet2.default();
    this.initiallySelectedNodeSet = new _TreeNodeSet2.default();
}

TreeSelectionController.prototype.markSelected = function (treeNode) {
    this.nodeSet.add(treeNode);
};

TreeSelectionController.prototype.markSelectedAndUpdate = function (treeNode) {
    this.markSelected(treeNode);
    this.tree.updateUIForSingleTreeNode(treeNode);
};

TreeSelectionController.prototype.nodeSelected = function (treeNode) {
    this.markSelectedAndUpdate(treeNode);
};

TreeSelectionController.prototype.initializeByNodeSet = function (nodeSet) {
    this.initiallySelectedNodeSet = nodeSet;
};

TreeSelectionController.prototype.markDeselected = function (treeNode) {
    this.nodeSet.remove(treeNode);
};

TreeSelectionController.prototype.markDeselectedAndUpdate = function (treeNode) {
    this.markDeselected(treeNode);
    this.tree.updateUIForSingleTreeNode(treeNode);
};

TreeSelectionController.prototype.nodeDeselected = function (treeNode) {
    this.markDeselectedAndUpdate(treeNode);
};

TreeSelectionController.prototype.toggle = function (treeNode) {
    if (this.isSelected(treeNode)) this.nodeDeselected(treeNode);else this.nodeSelected(treeNode);
};

TreeSelectionController.prototype.isSelected = function (treeNode) {
    return this.nodeSet.contains(treeNode);
};

TreeSelectionController.prototype.deselectAll = function () {
    var oldSelection = this.nodeSet;
    this.nodeSet = new _TreeNodeSet2.default();
    this.tree.updateUIForTreeNodeSet(oldSelection);
};

TreeSelectionController.prototype.getSelectedNodeSet = function () {
    return this.nodeSet;
};

TreeSelectionController.prototype.getInitiallySelectedNodeSet = function () {
    return this.initiallySelectedNodeSet;
};

TreeSelectionController.prototype.updateUI = function () {
    this.tree.updateUIForTreeNodeSet(this.nodeSet);
};

/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TreeNode2 = __webpack_require__(60);

var _TreeNode3 = _interopRequireDefault(_TreeNode2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UserTreeNode = function (_TreeNode) {
    _inherits(UserTreeNode, _TreeNode);

    function UserTreeNode(user, id) {
        _classCallCheck(this, UserTreeNode);

        return _possibleConstructorReturn(this, (UserTreeNode.__proto__ || Object.getPrototypeOf(UserTreeNode)).call(this, user, id));
    }

    _createClass(UserTreeNode, [{
        key: "getIdPrefix",
        value: function getIdPrefix() {
            return "u";
        }
    }, {
        key: "getType",
        value: function getType() {
            return _TreeNode3.default.TYPE_USER;
        }
    }]);

    return UserTreeNode;
}(_TreeNode3.default);

exports.default = UserTreeNode;

/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = TimeZoneGroupNodeRenderer;

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _ExpandCollapseNodeRenderer = __webpack_require__(352);

var _ExpandCollapseNodeRenderer2 = _interopRequireDefault(_ExpandCollapseNodeRenderer);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function TimeZoneGroupNodeRenderer(tree, selectorFilter, expandCollapseCallback) {
    _ExpandCollapseNodeRenderer2.default.call(this, tree, selectorFilter, expandCollapseCallback);
}

TimeZoneGroupNodeRenderer.prototype = _underscore2.default.create(_ExpandCollapseNodeRenderer2.default.prototype);

TimeZoneGroupNodeRenderer.prototype.getEmptyEntityTooltip = function () {
    return _messageResource2.default.getEscapedMessage("users_selector.expand_collapse_disabled.time_zone_group.tooltip");
};

TimeZoneGroupNodeRenderer.prototype.generateLabel = function (treeNode, labelEl) {
    var entity = treeNode.getValue();
    var name = entity.name;
    if (entity.id == window.DEFAULT_TIME_ZONE_GROUP_ID) {
        labelEl.innerHTML = "<span class='defaultGroupName'>" + this.selectorFilter.highlightTokens(name) + "</span><span class='defaultGroupNote'>&nbsp;" + _messageResource2.default.getMessage("users_selector.default_group") + "</span>";
    } else {
        labelEl.innerHTML = this.selectorFilter.highlightTokens(name);
    }
    labelEl.title = this.getTitle(treeNode.getValue());
};

TimeZoneGroupNodeRenderer.prototype.appendAdditionalElements = function (targetEl, treeNode) {
    var entity = treeNode.getValue();
    if (entity.id == window.DEFAULT_TIME_ZONE_GROUP_ID) {
        (0, _jquery2.default)(targetEl).addClass("defaultGroup");
    }
};

/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = EmailCheckUserNodeRenderer;

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _UserNodeRenderer = __webpack_require__(357);

var _UserNodeRenderer2 = _interopRequireDefault(_UserNodeRenderer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function EmailCheckUserNodeRenderer(tree, selectorFilter, selectionHelper, checkEmail, messageParams) {
    _UserNodeRenderer2.default.call(this, tree, selectorFilter, selectionHelper);
    this.checkEmail = checkEmail;
    this.messageParams = messageParams;
    this.invalidClassName = "invalidNode";
}

EmailCheckUserNodeRenderer.prototype = _underscore2.default.create(_UserNodeRenderer2.default.prototype);

EmailCheckUserNodeRenderer.prototype.isBadEmail = function (user) {
    return this.checkEmail && !user.hasEmail();
};

EmailCheckUserNodeRenderer.prototype.getNodeClasses = function (treeNode) {
    var classes = _UserNodeRenderer2.default.prototype.getNodeClasses.call(this, treeNode);
    if (this.isInvalidUser(treeNode.getValue())) {
        classes.push(this.getInvalidClassName());
    }
    return classes;
};

EmailCheckUserNodeRenderer.prototype.isInvalidUser = function (user) {
    return this.isBadEmail(user);
};

EmailCheckUserNodeRenderer.prototype.getDisabledClassName = function () {
    return this.getInvalidClassName();
};

EmailCheckUserNodeRenderer.prototype.getInvalidClassName = function () {
    return this.checkEmail ? this.invalidClassName : this.disabledClassName;
};

EmailCheckUserNodeRenderer.prototype.getTitle = function (user) {
    if (this.checkEmail) {
        if (!user.isActive()) {
            return this.messageParams.getDisabledMessage(user);
        }
        var additionalTitle = this.getAdditionalTitle(user);
        if (additionalTitle) {
            return additionalTitle;
        }
        if (this.isBadEmail(user)) {
            return this.messageParams.getNoEmailMessage(user);
        }
    }
    return _UserNodeRenderer2.default.prototype.getTitle.call(this, user);
};

EmailCheckUserNodeRenderer.prototype.getAdditionalTitle = function (user) {
    return null;
};

/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = EmptyMessageBuilder;
function EmptyMessageBuilder() {
    this.messages = {};
}

EmptyMessageBuilder.prototype = {
    createMessages: function createMessages() {},

    processEmptyMessages: function processEmptyMessages() {
        this.createMessages();
        return this.messages;
    }
};

/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TreeBuilder2 = __webpack_require__(476);

var _TreeBuilder3 = _interopRequireDefault(_TreeBuilder2);

var _GroupTreeNode = __webpack_require__(1319);

var _GroupTreeNode2 = _interopRequireDefault(_GroupTreeNode);

var _UserTreeNode = __webpack_require__(745);

var _UserTreeNode2 = _interopRequireDefault(_UserTreeNode);

var _DisabledUsersParentTreeNode = __webpack_require__(1320);

var _DisabledUsersParentTreeNode2 = _interopRequireDefault(_DisabledUsersParentTreeNode);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UserSelectorTreeBuilder = function (_TreeBuilder) {
    _inherits(UserSelectorTreeBuilder, _TreeBuilder);

    function UserSelectorTreeBuilder(rootNode, users, groupsMap, groupsOrder, observer, getGroupIdFromUserCallback) {
        _classCallCheck(this, UserSelectorTreeBuilder);

        var _this = _possibleConstructorReturn(this, (UserSelectorTreeBuilder.__proto__ || Object.getPrototypeOf(UserSelectorTreeBuilder)).call(this, rootNode, users, groupsMap, groupsOrder));

        _this.observer = observer;
        _this.getGroupIdFromUserCallback = getGroupIdFromUserCallback;
        return _this;
    }

    _createClass(UserSelectorTreeBuilder, [{
        key: "createTreeNodeForFirstLevelEntity",
        value: function createTreeNodeForFirstLevelEntity(group) {
            return new _GroupTreeNode2.default(group);
        }
    }, {
        key: "createTreeNodeForSecondLevelEntity",
        value: function createTreeNodeForSecondLevelEntity(user) {
            return new _UserTreeNode2.default(user);
        }
    }, {
        key: "createDisabledNodesParentForSecondLevelEntity",
        value: function createDisabledNodesParentForSecondLevelEntity(parentId) {
            return new _DisabledUsersParentTreeNode2.default(parentId);
        }
    }, {
        key: "getSecondLevelEntityParentId",
        value: function getSecondLevelEntityParentId(user) {
            return this.getGroupIdFromUserCallback(user);
        }
    }, {
        key: "isFirstLevelEntityEnabled",
        value: function isFirstLevelEntityEnabled() {
            return true;
        }
    }, {
        key: "isSecondLevelEntityEnabled",
        value: function isSecondLevelEntityEnabled(user) {
            return user.isActive();
        }
    }, {
        key: "onTreeNodeForFirstLevelEntityAdded",
        value: function onTreeNodeForFirstLevelEntityAdded(treeNode) {
            this.observer.groupNodeAdded(treeNode);
        }
    }, {
        key: "onTreeNodeForSecondLevelEntityAdded",
        value: function onTreeNodeForSecondLevelEntityAdded(treeNode) {
            this.observer.userNodeAdded(treeNode);
        }
    }, {
        key: "onDisabledNodesParentForSecondLevelEntitiesAdded",
        value: function onDisabledNodesParentForSecondLevelEntitiesAdded(treeNode) {
            this.observer.disabledUsersParentNodeAdded(treeNode);
        }
    }]);

    return UserSelectorTreeBuilder;
}(_TreeBuilder3.default);

exports.default = UserSelectorTreeBuilder;

/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = GUIControl;
/**
 * An abstract GUI control.
 *  id - control identifier, will be used as HTML element id 
 */
function GUIControl(id) {
    this.id = id;

    this.updateLocked = false;
}

/*
 * Context object if needed
 */

GUIControl.prototype.context = null;

/**
 * Returns the control id (HTML element id).
 */
GUIControl.prototype.getId = function () {
    return this.id;
};

/**
 * Returns the HTML that renders the control.
 * Must be overridden in a subclass.
 */
GUIControl.prototype.getHTML = function () {
    return "";
};

/**
 * Outputs the control's HTML to the document.
 */
GUIControl.prototype.render = function () {
    document.write(this.getHTML());
};

/**
 * Renders the control to the specified container.
 */
GUIControl.prototype.renderTo = function (container) {
    container.innerHTML = this.getHTML();
};

/**
 * Updates the contents of control, if update is not locked.
 */
GUIControl.prototype.updateContents = function () {
    if (!this.updateLocked) {
        var elem = document.getElementById(this.getContentsContainerId());
        if (elem) {
            elem.innerHTML = this.getContentsHTML();
        }
    }
};

/**
 * Returns the HTML for the changeable part of the control. This method is called from the updateContents() method
 * and must be overridden in subclasses.
 */
GUIControl.prototype.getContentsHTML = function () {
    return "";
};

/**
 * Returns the id of the element which innerHTML contains the changeable part of the control.
 * Used in updateContents() method.
 * This method must be queried in subclasses when generating HTML for the static parts of controls. 
 */
GUIControl.prototype.getContentsContainerId = function () {
    return this.id + ".contentsContainer";
};

/**
 * Locks update, so that updateContents() will have no effect.
 */
GUIControl.prototype.lockUpdate = function () {
    this.updateLocked = true;
};

/**
 * Unlocks update and immediately updates contents.
 */
GUIControl.prototype.unlockUpdate = function () {
    this.updateLocked = false;
    this.updateContents();
};

/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _PermissionsTemplatesButtonController = __webpack_require__(752);

var _PermissionsTemplatesButtonController2 = _interopRequireDefault(_PermissionsTemplatesButtonController);

var _PermissionsTemplatesMenuWithoutChoosing = __webpack_require__(1325);

var _PermissionsTemplatesMenuWithoutChoosing2 = _interopRequireDefault(_PermissionsTemplatesMenuWithoutChoosing);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PermissionsTemplateButtonControllerWithoutChoosing = function (_PermissionsTemplates) {
    _inherits(PermissionsTemplateButtonControllerWithoutChoosing, _PermissionsTemplates);

    function PermissionsTemplateButtonControllerWithoutChoosing($containerEl, $button) {
        var onChangeTemplates = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};

        _classCallCheck(this, PermissionsTemplateButtonControllerWithoutChoosing);

        return _possibleConstructorReturn(this, (PermissionsTemplateButtonControllerWithoutChoosing.__proto__ || Object.getPrototypeOf(PermissionsTemplateButtonControllerWithoutChoosing)).call(this, {
            $containerEl: $containerEl,
            $button: $button,
            withoutChoosing: true,
            onChangeTemplates: onChangeTemplates,
            additionalClassName: 'onBulkInvitations rightArrow'
        }));
    }

    _createClass(PermissionsTemplateButtonControllerWithoutChoosing, [{
        key: "createAndInitPermissionTemplatesMenu",
        value: function createAndInitPermissionTemplatesMenu(permissionsTemplates) {
            var _this2 = this;

            var context = this;
            this.permissionTemplatesMenu = new _PermissionsTemplatesMenuWithoutChoosing2.default().init({
                menuId: "permissionTemplatesMenuWithoutChoosingId",
                templatesData: permissionsTemplates,
                onCreateTemplateCallback: this._handleCreateTemplate,
                onEditTemplateCallback: this._handleEditTemplate,
                onSelectTemplateCallback: function onSelectTemplateCallback() {},
                onErrorCallback: function onErrorCallback(data) {
                    return _this2.setState({ templates: data });
                },
                onDeleteCallback: null,
                canShowMenu: function canShowMenu() {
                    return true;
                }
            });

            var showMenuCallback = function showMenuCallback(event) {
                context.permissionTemplatesMenu.showAt(context.$containerEl, context.$permissionTemplatesMenuButton, { left: -50 });
                context.permissionTemplatesMenu.getMenuElement().addClass('rightAlignedArrow');
            };
            this.$permissionTemplatesMenuButton.off("click").on("click", showMenuCallback);
        }
    }]);

    return PermissionsTemplateButtonControllerWithoutChoosing;
}(_PermissionsTemplatesButtonController2.default);

exports.default = PermissionsTemplateButtonControllerWithoutChoosing;

/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _PermissionsTemplatesMenu = __webpack_require__(753);

var _PermissionsTemplatesMenu2 = _interopRequireDefault(_PermissionsTemplatesMenu);

var _CreatePermissionsTemplateView = __webpack_require__(1322);

var _CreatePermissionsTemplateView2 = _interopRequireDefault(_CreatePermissionsTemplateView);

var _EditPermissionsTemplateView = __webpack_require__(1324);

var _EditPermissionsTemplateView2 = _interopRequireDefault(_EditPermissionsTemplateView);

var _AnimatedDialogWrapper = __webpack_require__(286);

var _AnimatedDialogWrapper2 = _interopRequireDefault(_AnimatedDialogWrapper);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _jquery_rpc = __webpack_require__(26);

var _jquery_rpc2 = _interopRequireDefault(_jquery_rpc);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _utils = __webpack_require__(25);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PermissionsTemplatesButtonController = function () {
    function PermissionsTemplatesButtonController(_ref) {
        var _this = this;

        var $containerEl = _ref.$containerEl,
            $button = _ref.$button,
            _ref$withoutChoosing = _ref.withoutChoosing,
            withoutChoosing = _ref$withoutChoosing === undefined ? false : _ref$withoutChoosing,
            _ref$onChangeDialogVi = _ref.onChangeDialogVisibility,
            onChangeDialogVisibility = _ref$onChangeDialogVi === undefined ? function (visible) {} : _ref$onChangeDialogVi,
            _ref$onChangeTemplate = _ref.onChangeTemplates,
            onChangeTemplates = _ref$onChangeTemplate === undefined ? function () {} : _ref$onChangeTemplate,
            _ref$additionalClassN = _ref.additionalClassName,
            additionalClassName = _ref$additionalClassN === undefined ? '' : _ref$additionalClassN;

        _classCallCheck(this, PermissionsTemplatesButtonController);

        this._handleSaveEditTemplate = function (data) {

            _this._saveAndApplyButtonCallback(_this.editTemplateDialogWrapper, _extends({}, data, {
                id: _this.state.editedTemplateId
            }), "PermissionsTemplatesService.updateTemplate", ['id', 'name', 'permissions']);
            _this.permissionTemplatesMenu.hide();
        };

        this._handleSaveNewTemplate = function (data) {
            _this._saveAndApplyButtonCallback(_this.createTemplateDialogWrapper, data, "PermissionsTemplatesService.createTemplate", ['name', 'permissions']);
            _this.permissionTemplatesMenu.hide();
        };

        this._handleResetTemplateChanges = function () {
            var editedTemplate = _this.state.templates.find(function (_ref2) {
                var id = _ref2.id;
                return id === _this.state.editedTemplateId;
            });
            _this.editTemplateView.setState(_extends({}, editedTemplate));
        };

        this._handleEditTemplate = function (templateData) {
            _this.state.editedTemplateId = templateData.id;
            _this.editTemplateDialogWrapper.setState(_extends({}, templateData, {
                duplicateName: false,
                emptyName: false
            }));
            _this.editTemplateDialogWrapper.showAt(_this.$permissionTemplatesMenuButton);
            _this.onChangeDialogVisibility(true);
        };

        this._handleCreateTemplate = function () {
            _this.state.editedTemplateId = null;
            _this.createTemplateDialogWrapper.setState({
                name: '',
                permissions: [],
                duplicateName: false,
                emptyName: false
            });
            _this.createTemplateDialogWrapper.showAt(_this.$permissionTemplatesMenuButton);
            _this.onChangeDialogVisibility(true);
        };

        this._preventHideForNewTemplate = function () {
            var dataChanged = !_this._areTemplateDataEqual({ name: '', permissions: [] }, _this.createTemplateView.getTemplateData());

            return dataChanged && !_this._confirmCloseDialog();
        };

        this._preventHideForEditedTemplate = function () {
            var dataChanged = !_this._areTemplateDataEqual(_this.state.templates.find(function (_ref3) {
                var id = _ref3.id;
                return id === _this.state.editedTemplateId;
            }), _this.editTemplateView.getTemplateData());

            return dataChanged && !_this._confirmCloseDialog();
        };

        this._confirmCloseDialog = function () {
            return confirm(_messageResource2.default.getMessage('userlist.userdata.permissions_templates.discard_changes_confirmation'));
        };

        this._areTemplateDataEqual = function (data, anotherData) {
            return data.name === anotherData.name && _underscore2.default.isEqual(data.permissions, anotherData.permissions);
        };

        this._saveAndApplyButtonCallback = function (dialogWrapper, data, methodName, paramKeys) {
            var self = _this;
            var params = Object.values(_underscore2.default.pick(data, paramKeys));

            if (data.name === '' || data.name === null) {
                dialogWrapper.setState({
                    emptyName: true
                });
                return;
            }

            if (_this.state.templates.find(function (_ref4) {
                var name = _ref4.name,
                    id = _ref4.id;
                return id !== data.id && name === data.name;
            })) {
                dialogWrapper.setState({
                    duplicateName: true
                });
                return;
            }

            dialogWrapper.setState({
                dataUpdating: true
            });

            _this.rpcCall = (0, _jquery_rpc2.default)(methodName, params, function (templates) {
                self.setState({ templates: templates });
                dialogWrapper.setState({ dataUpdating: false });
                self.onChangeTemplates({ templates: templates, permissions: data.permissions, userLoggedIn: self.state.editUserIsLoggedIn });
                dialogWrapper.hide(true);
            }, function (jqXHR, textStatus, errorThrown) {
                if (textStatus === "abort") {
                    return true;
                }
                dialogWrapper.setState({ dataUpdating: false });

                if (errorThrown.exception === 'com.actimind.actitime.services.PermissionsTemplateDuplicateNameException') {
                    dialogWrapper.setState({ duplicateName: true });
                    self.setState({ templates: errorThrown.templates });
                    return true;
                }
                if (errorThrown.exception === 'com.actimind.actitime.services.PermissionsTemplateNotExistException') {
                    self.setState({ templates: errorThrown.templates });
                    if (confirm(_messageResource2.default.getMessage('userlist.userdata.permissions_templates.js.no_such_template_confirmation'))) {
                        self._saveAndApplyButtonCallback(dialogWrapper, "PermissionsTemplatesService.createTemplate", data, ['name', 'permissions']);
                    } else {
                        dialogWrapper.hide();
                    }
                    return true;
                }
                if (errorThrown.exception === 'com.actimind.actitime.services.NoRightsToManageAccountSettings') {
                    alert(_messageResource2.default.getMessage("userlist.js.error_cant_manage_user_account"));
                    document.location.reload();
                    return true;
                }
            });
        };

        this.$containerEl = $containerEl;
        this.$permissionTemplatesMenuButton = $button;
        this.state = {
            templates: [],
            editUserIsLoggedIn: false,
            editedTemplateId: null,
            isURAEnabled: false,
            isBTYEnabled: false,
            isPTOEnabled: false,
            isSDBEnabled: false,
            isLTTEnabled: false
        };
        this.withoutChoosing = withoutChoosing;
        this.onChangeDialogVisibility = onChangeDialogVisibility;
        this.onChangeTemplates = onChangeTemplates;
        this.additionalClassName = additionalClassName;

        this._handleSaveNewTemplate = this._handleSaveNewTemplate.bind(this);
        this._handleResetTemplateChanges = this._handleResetTemplateChanges.bind(this);
        this._handleSaveEditTemplate = this._handleSaveEditTemplate.bind(this);
        this._preventHideForEditedTemplate = this._preventHideForEditedTemplate.bind(this);
        this._preventHideForNewTemplate = this._preventHideForNewTemplate.bind(this);
    }

    _createClass(PermissionsTemplatesButtonController, [{
        key: "init",
        value: function init() {
            var _this2 = this;

            if (!this.$permissionTemplatesMenuButton) {
                this.$permissionTemplatesMenuButton = (0, _jquery2.default)("<div class='templatesButton'>" + "   <div class='icon'/><div class='applyTemplate'>" + _messageResource2.default.getMessage("userlist.userdata.permissions_templates.apply_template") + "</div>" + "</div>");
                this.$containerEl.append(this.$permissionTemplatesMenuButton);
            }

            this.createTemplateView = new _CreatePermissionsTemplateView2.default(this.$containerEl, {
                withoutChoosing: this.withoutChoosing,
                onSaveButtonClick: this._handleSaveNewTemplate,
                onCloseButtonClick: function onCloseButtonClick() {
                    return _this2.createTemplateDialogWrapper.hide();
                }
            });
            this.createTemplateDialogWrapper = new _AnimatedDialogWrapper2.default(this.$containerEl, {
                dialog: this.createTemplateView,
                className: 'user_permissionsTemplatesDialog ' + this.additionalClassName,
                keyFrameClass: 'anim-user-permissions-dialog',
                preventHide: this._preventHideForNewTemplate,
                onHide: function onHide() {
                    _this2.onChangeDialogVisibility(false);
                }
            }).init();

            this.editTemplateView = new _EditPermissionsTemplateView2.default(this.$containerEl, {
                withoutChoosing: this.withoutChoosing,
                onSaveButtonClick: this._handleSaveEditTemplate,
                onResetButtonClick: this._handleResetTemplateChanges,
                onCloseButtonClick: function onCloseButtonClick() {
                    return _this2.editTemplateDialogWrapper.hide();
                }
            });
            this.editTemplateDialogWrapper = new _AnimatedDialogWrapper2.default(this.$containerEl, {
                dialog: this.editTemplateView,
                className: 'user_permissionsTemplatesDialog ' + this.additionalClassName,
                keyFrameClass: 'anim-user-permissions-dialog',
                preventHide: this._preventHideForEditedTemplate,
                onHide: function onHide() {
                    _this2.onChangeDialogVisibility(false);
                }
            }).init();

            return this;
        }
    }, {
        key: "createAndInitPermissionTemplatesMenu",
        value: function createAndInitPermissionTemplatesMenu(permissionsTemplates) {
            var _this3 = this;

            this.permissionTemplatesMenu = new _PermissionsTemplatesMenu2.default().init({
                menuId: "permissionTemplatesMenuId",
                templatesData: permissionsTemplates,
                onCreateTemplateCallback: this._handleCreateTemplate,
                onEditTemplateCallback: this._handleEditTemplate,
                onSelectTemplateCallback: function onSelectTemplateCallback(templateData) {
                    return (0, _jquery2.default)(_this3).trigger('applyTemplate', [templateData.permissions, _this3.state.editUserIsLoggedIn]);
                },
                onDeleteCallback: function onDeleteCallback(data) {
                    return _this3.setState({ templates: data });
                },
                canShowMenu: function canShowMenu() {
                    return true;
                },
                onClickDialogContent: function onClickDialogContent(e) {
                    return (0, _utils.setEventPreventHidingEditUserSlidingPanel)(e);
                }
            });

            var showMenuCallback = function showMenuCallback() {
                _this3.permissionTemplatesMenu.showAt(_this3.$containerEl, _this3.$permissionTemplatesMenuButton, { left: -80 });
                _this3.permissionTemplatesMenu.getMenuElement().addClass('rightAlignedArrow');
            };
            this.$permissionTemplatesMenuButton.off("click").on("click", showMenuCallback);
        }
    }, {
        key: "setState",
        value: function setState(newState) {
            var prevState = _extends({}, this.state);
            this.state = _extends({}, this.state, newState);
            if (!this.permissionTemplatesMenu) this.createAndInitPermissionTemplatesMenu(this.state.templates);else this.permissionTemplatesMenu.updateTemplatesData(this.state.templates);

            if (prevState.isURAEnabled !== this.state.isURAEnabled || prevState.isBTYEnabled !== this.state.isBTYEnabled || prevState.isPTOEnabled !== this.state.isPTOEnabled || prevState.isSDBEnabled !== this.state.isSDBEnabled || prevState.isLTTEnabled !== this.state.isLTTEnabled) {
                this.editTemplateView.setState({
                    isURAEnabled: this.state.isURAEnabled,
                    isBTYEnabled: this.state.isBTYEnabled,
                    isPTOEnabled: this.state.isPTOEnabled,
                    isSDBEnabled: this.state.isSDBEnabled,
                    isLTTEnabled: this.state.isLTTEnabled
                });
                this.createTemplateView.setState({
                    isURAEnabled: this.state.isURAEnabled,
                    isBTYEnabled: this.state.isBTYEnabled,
                    isPTOEnabled: this.state.isPTOEnabled,
                    isSDBEnabled: this.state.isSDBEnabled,
                    isLTTEnabled: this.state.isLTTEnabled
                });
            }
        }
    }]);

    return PermissionsTemplatesButtonController;
}();

exports.default = PermissionsTemplatesButtonController;

/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _SpinnerController = __webpack_require__(69);

var _SpinnerController2 = _interopRequireDefault(_SpinnerController);

var _ScrollUtils = __webpack_require__(39);

var _ScrollUtils2 = _interopRequireDefault(_ScrollUtils);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _jquery_rpc = __webpack_require__(26);

var _jquery_rpc2 = _interopRequireDefault(_jquery_rpc);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _atUtils = __webpack_require__(5);

var _keyCodes = __webpack_require__(66);

var _atBrowserUtils = __webpack_require__(8);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _index = __webpack_require__(48);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PermissionsTemplatesMenu = function () {
    function PermissionsTemplatesMenu() {
        var _this = this;

        _classCallCheck(this, PermissionsTemplatesMenu);

        this._resizeHandler = function () {
            _this.hide();
        };

        this._keyDownHandler = function (event) {
            if (_this.isShow) {
                var activeRow = _this._getActiveRow();
                switch (event.keyCode) {
                    case _keyCodes.KEY_CODE_ESC:
                        if (_this._isRowInDeleteConfirmationState(activeRow)) {
                            activeRow.find("td.cancelBtn").click();
                        } else {
                            _this.hide();
                        }
                        break;
                    case _keyCodes.KEY_CODE_ENTER:
                    case _keyCodes.KEY_CODE_SPACE:
                        if (_this._isRowInDeleteConfirmationState(activeRow)) {
                            activeRow.find("td.confirmBtn").click(); // delete
                        } else {
                            activeRow.find("td.name").click(); // select
                        }
                        break;
                    case _keyCodes.KEY_CODE_DEL:
                        if (!_this._isRowInDeleteConfirmationState(activeRow)) {
                            activeRow.find("td.delBtn").click();
                        }
                        break;
                    case _keyCodes.KEY_CODE_TAB:
                        _this.hide();
                        break;
                    case _keyCodes.KEY_CODE_UP:
                        _this._moveCursorToNextRow(true);
                        break;
                    case _keyCodes.KEY_CODE_DOWN:
                        _this._moveCursorToNextRow(false);
                        break;
                }
                (0, _atBrowserUtils.cancelBubble)(event.originalEvent);
                return false;
            }
        };

        this._mouseDownHandler = function (event) {
            if (_this.isShow) {
                var target = event.target;
                while (target) {
                    if (target == _this.button[0]) {
                        _this.preventNextShowing = true;
                    }
                    if (target.id == _this.menuId) {
                        (0, _atBrowserUtils.cancelBubble)(event);
                        return false;
                    }
                    target = target.parentElement;
                }
                (0, _atBrowserUtils.cancelBubble)(event);
                _this.hide();
            }
        };

        this._toggleListeners = function (toggleOn) {
            if (toggleOn) {
                (0, _jquery2.default)(document).on("mousedown.permissionsTemplatesMenu", _this._mouseDownHandler);
                (0, _jquery2.default)(window).on("resize.permissionsTemplatesMenu", _this._resizeHandler);
                (0, _jquery2.default)("body").on("keydown.permissionsTemplatesMenu", _this._keyDownHandler);
            } else {
                (0, _jquery2.default)(document).off("mousedown.permissionsTemplatesMenu", _this._mouseDownHandler);
                (0, _jquery2.default)(window).off("resize.permissionsTemplatesMenu", _this._resizeHandler);
                (0, _jquery2.default)("body").off("keydown.permissionsTemplatesMenu", _this._keyDownHandler);
            }
        };
    }

    _createClass(PermissionsTemplatesMenu, [{
        key: "init",
        value: function init(_ref) {
            var menuId = _ref.menuId,
                templatesData = _ref.templatesData,
                onCreateTemplateCallback = _ref.onCreateTemplateCallback,
                onEditTemplateCallback = _ref.onEditTemplateCallback,
                onSelectTemplateCallback = _ref.onSelectTemplateCallback,
                _ref$onErrorCallback = _ref.onErrorCallback,
                onErrorCallback = _ref$onErrorCallback === undefined ? function () {} : _ref$onErrorCallback,
                onDeleteCallback = _ref.onDeleteCallback,
                canShowMenu = _ref.canShowMenu,
                _ref$onClickDialogCon = _ref.onClickDialogContent,
                onClickDialogContent = _ref$onClickDialogCon === undefined ? function () {} : _ref$onClickDialogCon;

            this.onCreateTemplateCallback = onCreateTemplateCallback;
            this.onEditTemplateCallback = onEditTemplateCallback;
            this.onSelectTemplateCallback = onSelectTemplateCallback;
            this.onErrorCallback = onErrorCallback;
            this.onDeleteCallback = onDeleteCallback;
            this.onClickDialogContent = onClickDialogContent;
            this.canShowMenu = canShowMenu;

            this.menuId = menuId;
            this.actualTemplatesData = templatesData;

            this.spinnerController = new _SpinnerController2.default();

            this.isShow = false;
            this.isDisabledControls = false;

            return this;
        }
    }, {
        key: "updateTemplatesData",
        value: function updateTemplatesData(newData) {
            this.actualTemplatesData = newData;
        }
    }, {
        key: "_deleteTemplateAction",
        value: function _deleteTemplateAction(row, templateId) {
            var context = this;
            this._spinInRow(row);
            this.isDisabledControls = true;
            this.deletingRpc = (0, _jquery_rpc2.default)("PermissionsTemplatesService.deleteTemplate", [templateId], function (response) {
                context._stopSpin(row);
                context.isDisabledControls = false;

                context.updateTemplatesData(response);
                context._renderContent(context.getMenuElement(), response);
                if (context.onDeleteCallback) {
                    context.onDeleteCallback(response);
                }
            }, function (jqXHR, textStatus, errorThrown) {
                context._stopSpin(row);
                context.isDisabledControls = false;

                if (errorThrown.exception == "com.actimind.actitime.services.NoRightsToManageAccountSettings") {
                    alert(_messageResource2.default.getMessage("userlist.js.error_cant_edit_user_account"));
                    context.hide();
                    context.onErrorCallback();
                    document.location.reload();
                    return true;
                }
            });
        }
    }, {
        key: "_spinInRow",
        value: function _spinInRow(row) {
            row.toggleClass("deletingState", true);
            this.spinnerController.spinInElement(row.find("#spinnerContainer"));
        }
    }, {
        key: "_stopSpin",
        value: function _stopSpin(row) {
            row.toggleClass("deletingState", false);
            this.spinnerController.stop();
        }

        /**
         * Render inner content for menu
         * @param container menu container
         * @param templatesData array of templates
         * @private
         */

    }, {
        key: "_renderContent",
        value: function _renderContent(container, templatesData) {
            container.empty();

            var context = this;
            container.append("<div class='templatesHeader'>" + "<span>" + _messageResource2.default.getMessage("userlist.userdata.permissions_templates.js.menu.header") + "</span></div>");

            var templatesListWrapper = (0, _jquery2.default)("<div class='templatesListWrapper'></div>");
            var templatesListContainer = (0, _jquery2.default)("<table class='templatesListContainer'></table>");
            templatesListWrapper.append(templatesListContainer);
            _underscore2.default.each(templatesData, function (template, index) {
                var newRow = context._renderRowContent(template, template.id == window.DEFAULT_PERMISSIONS_TEMPLATE_ID);
                newRow.on("hover", function () {
                    context._setActiveRow(newRow);
                });

                if (index == 0) {
                    context._setActiveRow(newRow);
                }

                templatesListContainer.append(newRow);
            });
            this.templatesListScroll = _ScrollUtils2.default.addVerticalScroll(templatesListWrapper, { isFaded: false });
            container.append(templatesListWrapper);

            var footer = (0, _jquery2.default)("<div class='templatesFooter'></div>");
            var createNewTemplateButton = (0, _jquery2.default)("<a href='javascript:void(0);' class='createNew'>" + _messageResource2.default.getMessage("userlist.userdata.permissions_templates.js.menu.create_new") + "</a>");
            footer.append(createNewTemplateButton);
            container.append(footer);
            createNewTemplateButton.on("click", function (event) {
                context.onCreateTemplateCallback();
            });
        }

        /**
         * Render content for one row
         * @param templateData of one row
         * @param isDefaultRow if row of default template
         * @returns {*|jQuery|HTMLElement} element (row) - row
         * @private
         */

    }, {
        key: "_renderRowContent",
        value: function _renderRowContent(templateData, isDefaultRow) {
            var context = this;
            var canBeDeleted = !isDefaultRow;
            var row = (0, _jquery2.default)("<tr class='templateRow'></tr>");
            var rowInnerContent = (0, _jquery2.default)("<tr></tr>");

            this._appendInnerRowContent(rowInnerContent, templateData, isDefaultRow);

            var delBtn = (0, _jquery2.default)("<td class='delBtn'><div></div></td>");
            rowInnerContent.append(delBtn);
            if (canBeDeleted) {
                delBtn.on("click", function () {
                    context._switchRowToDeleteConfirmState(row, true);
                });

                var deleteConfirmation = (0, _jquery2.default)("<td class='deleteConfirmation'></td>");

                var confirmationContent = (0, _jquery2.default)("<table></table>");
                deleteConfirmation.append(confirmationContent);

                var confirmationRow = (0, _jquery2.default)("<tr></tr>");
                confirmationContent.append(confirmationRow);

                confirmationRow.append("<td class='question'><div>" + _messageResource2.default.getMessage("userlist.userdata.permissions_templates.js.menu.delete_confirmation") + "</div></td>");
                var confirmBtn = (0, _jquery2.default)("<td class='confirmBtn'><button>" + _messageResource2.default.getMessage("userlist.userdata.permissions_templates.js.menu.delete_confirm") + "</button></td>");
                confirmBtn.on("click", function () {
                    if (context.isDisabledControls) {
                        return;
                    }
                    context._deleteTemplateAction(row, templateData.id);
                });
                confirmationRow.append(confirmBtn);
                var cancelBtn = (0, _jquery2.default)("<td class='cancelBtn'><div>" + _messageResource2.default.getMessage("userlist.userdata.permissions_templates.js.menu.delete_cancel") + "</div></td>");
                cancelBtn.on("click", function () {
                    context._switchRowToDeleteConfirmState(row, false);
                });
                confirmationRow.append(cancelBtn);
                rowInnerContent.append(deleteConfirmation);

                rowInnerContent.append("<td id='spinnerContainer' class='spinnerContainer'></td>");
            } else {
                delBtn.addClass("disabled");
            }

            row.append((0, _jquery2.default)("<table></table>").append(rowInnerContent));
            return row;
        }
    }, {
        key: "_appendInnerRowContent",
        value: function _appendInnerRowContent(rowInnerContent, templateData, isDefaultRow) {
            var context = this;
            var templateName = this._generateTemplateName(templateData, isDefaultRow);
            templateName.on("click", function () {
                if (context.isDisabledControls) {
                    return;
                }
                context.hide();
                context.onSelectTemplateCallback(templateData);
            });

            rowInnerContent.append(templateName);

            var editBtn = (0, _jquery2.default)("<td class='editBtn'><div></div></td>");
            editBtn.on('click', function () {
                if (context.isDisabledControls) {
                    return;
                }
                context.onEditTemplateCallback(templateData);
            });
            rowInnerContent.append(editBtn);
        }
    }, {
        key: "_generateTemplateName",
        value: function _generateTemplateName(templateData, isDefaultRow) {
            return (0, _jquery2.default)("<td class='name'><div>" + (0, _atUtils.escapeHtmlSymbols)(templateData.name) + (isDefaultRow ? " " + _messageResource2.default.getMessage('userlist.userdata.permissions_templates.js.menu.row.default_template') : "") + "</div></td>");
        }
    }, {
        key: "showAt",
        value: function showAt(element, button, offset) {
            if (this.preventNextShowing) {
                this.preventNextShowing = false;
                return;
            }
            if (this.canShowMenu) //Bug #54807
                {
                    if (!this.canShowMenu()) {
                        return;
                    }
                }
            this.isShow = true;
            this.button = button;

            this._removeKeydownHandler = _index2.default.onKeyDown(this._keyDownHandler);
            var menuContainer = this.getMenuElement();
            this._renderContent(menuContainer, this.actualTemplatesData);
            element.append(menuContainer);

            menuContainer.show();
            var buttonOffset = button.offset();
            buttonOffset.top = buttonOffset.top + 30;
            if (offset) {
                buttonOffset.left += offset.left ? offset.left : 0;
                buttonOffset.top += offset.top ? offset.top : 0;
            }
            menuContainer.offset(buttonOffset);
            _ScrollUtils2.default.refreshCustomScroll(this.templatesListScroll);

            this._toggleListeners(true);
        }
    }, {
        key: "hide",
        value: function hide() {
            if (this.isShow) {
                if (this.deletingRpc) {
                    this.deletingRpc.abort();
                }
                this.isShow = false;
                this.getMenuElement().hide();
                if (this._removeKeydownHandler) this._removeKeydownHandler();

                this._toggleListeners(false);
            }
        }
    }, {
        key: "isShown",
        value: function isShown() {
            return this.isShow;
        }
    }, {
        key: "_setActiveRow",
        value: function _setActiveRow(row, byKey) {
            this._getActiveRow().removeClass("active").removeClass("byKey");
            row.addClass("active");
            if (byKey) {
                row.addClass("byKey");
            }
        }
    }, {
        key: "_getActiveRow",
        value: function _getActiveRow() {
            return this.getMenuElement().find(".templateRow.active");
        }
    }, {
        key: "_getRowInDeleteConfirmationState",
        value: function _getRowInDeleteConfirmationState() {
            return this.getMenuElement().find(".templateRow.deleteConfirmState");
        }
    }, {
        key: "_isRowInDeleteConfirmationState",
        value: function _isRowInDeleteConfirmationState(row) {
            return row.hasClass("deleteConfirmState");
        }
    }, {
        key: "_switchRowToDeleteConfirmState",
        value: function _switchRowToDeleteConfirmState(row, isDeletionState) {
            this._getRowInDeleteConfirmationState().removeClass("deleteConfirmState");
            row.toggleClass("deleteConfirmState", isDeletionState == true);
        }
    }, {
        key: "_moveCursorToNextRow",
        value: function _moveCursorToNextRow(toTop) {
            var activeRow = this._getActiveRow();
            var selectNext = toTop ? activeRow.prev(".templateRow") : activeRow.next(".templateRow");

            if (selectNext.length == 1) {
                this._setActiveRow(selectNext, true);

                var position = toTop ? _ScrollUtils2.default.POSITIONS.TOP : _ScrollUtils2.default.POSITIONS.BOTTOM;
                _ScrollUtils2.default.scrollIntoViewVertical(this.templatesListScroll, selectNext[0], position, true, 200);
            }
        }
    }, {
        key: "getMenuElement",
        value: function getMenuElement() {
            var menu = _jquery2.default.find("#" + this.menuId);
            if (menu.length == 0) {
                menu = (0, _jquery2.default)("<div id='" + this.menuId + "' class='permissionTemplatesMenu'></div>");
                this._afterMenuRendering(menu);
            } else {
                menu = (0, _jquery2.default)(menu[0]);
            }
            return menu;
        }
    }, {
        key: "_afterMenuRendering",
        value: function _afterMenuRendering($menu) {
            var _this2 = this;

            $menu.click(function (e) {
                return _this2.onClickDialogContent(e);
            });
        }
    }]);

    return PermissionsTemplatesMenu;
}();

exports.default = PermissionsTemplatesMenu;

/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _constants = __webpack_require__(4);

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _PermissionsUtils = __webpack_require__(359);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DUPLICATE_NAME_ERROR = "duplicateNameError";
var EMPTY_NAME_ERROR = "emptyNameError";

var PermissionTemplatesView = function (_TemplateView) {
    _inherits(PermissionTemplatesView, _TemplateView);

    function PermissionTemplatesView($containerEl, _ref) {
        var _ref$withoutChoosing = _ref.withoutChoosing,
            withoutChoosing = _ref$withoutChoosing === undefined ? false : _ref$withoutChoosing,
            _ref$onSaveButtonClic = _ref.onSaveButtonClick,
            onSaveButtonClick = _ref$onSaveButtonClic === undefined ? function () {} : _ref$onSaveButtonClic,
            _ref$onCloseButtonCli = _ref.onCloseButtonClick,
            onCloseButtonClick = _ref$onCloseButtonCli === undefined ? function () {} : _ref$onCloseButtonCli;

        _classCallCheck(this, PermissionTemplatesView);

        var _this = _possibleConstructorReturn(this, (PermissionTemplatesView.__proto__ || Object.getPrototypeOf(PermissionTemplatesView)).call(this, $containerEl));

        _this._handleInputValueChange = function (val) {
            _this.setState({
                name: val,
                duplicateName: false,
                emptyName: false
            });
        };

        _this._handlePermissionsRowChange = function (id, checked) {
            var newPermissions = _this.state.permissions.filter(function (perm) {
                return perm !== id;
            });
            if (checked) {
                newPermissions.push(id);
            }
            _this.setState({
                permissions: newPermissions
            });
        };

        _this.state = {
            name: '',
            permissions: [],
            dataUpdating: false,
            duplicateName: false,
            emptyName: false,
            templateChanged: false,
            isURAEnabled: false,
            isBTYEnabled: false,
            isPTOEnabled: false,
            isSDBEnabled: false,
            isLTTEnabled: false
        };

        _this.params = {
            withoutChoosing: withoutChoosing,
            onSaveButtonClick: onSaveButtonClick,
            onCloseButtonClick: onCloseButtonClick
        };

        _this.saveButtonTitle = withoutChoosing ? "userlist.userdata.permissions_templates.edit_mode.save" : "userlist.userdata.permissions_templates.edit_mode.save_and_apply";

        _this.onStatePropertyChanged('name', function (name) {
            _this.$nameInput.pVal(name);
        });

        _this.onStatePropertyChanged('permissions', function (permissions) {
            Object.values(_this.permissionRows).map(function (row) {
                return row.setState({ checked: false });
            });

            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = permissions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var permission = _step.value;

                    if (_this.permissionRows[permission]) _this.permissionRows[permission].setState({ checked: true });
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        });

        _this.onStatePropertyChanged('emptyName', function (emptyName) {
            _this.$el.toggleClass(EMPTY_NAME_ERROR, emptyName);
        });

        _this.onStatePropertyChanged('duplicateName', function (duplicateName) {
            _this.$el.toggleClass(DUPLICATE_NAME_ERROR, duplicateName);
        });

        _this.onAnyStatePropertyChanged(['isURAEnabled', 'isBTYEnabled'], function (_ref2) {
            var isURAEnabled = _ref2.isURAEnabled,
                isBTYEnabled = _ref2.isBTYEnabled;

            var needToShowGenerateMoneyReport = isURAEnabled || isBTYEnabled;
            _this.permissionRows[_constants.AccessRights.GENERATE_MONEY_REPORTS].toggle(needToShowGenerateMoneyReport);
            _this.permissionRows[_constants.AccessRights.EDIT_HIERARCHY].setState({ lastRow: !needToShowGenerateMoneyReport });

            var permissionTitle = (0, _PermissionsUtils.getGenerateMoneyReportsRightTitle)(isURAEnabled, isBTYEnabled);
            _this.permissionRows[_constants.AccessRights.GENERATE_MONEY_REPORTS].setState({ name: permissionTitle });
        });

        _this.onAnyStatePropertyChanged(['isPTOEnabled', 'isSDBEnabled'], function (_ref3) {
            var isPTOEnabled = _ref3.isPTOEnabled,
                isSDBEnabled = _ref3.isSDBEnabled;

            _this.permissionRows[_constants.AccessRights.MANAGE_PTO_AND_SICK].toggle(isPTOEnabled || isSDBEnabled);

            _this.permissionRows[_constants.AccessRights.MANAGE_PTO_AND_SICK].setState({
                name: (0, _PermissionsUtils.getManagePtoAndSickDaysRightTitle)(isPTOEnabled, isSDBEnabled)
            });
        });

        _this.onStatePropertyChanged('isLTTEnabled', function (isLTTEnabled) {
            _this.permissionRows[_constants.AccessRights.LOCK_TIME_TRACK].toggle(isLTTEnabled);
        });
        return _this;
    }

    _createClass(PermissionTemplatesView, [{
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='permissionsTemplate'>" + "    <div class='closeButton'></div>" + "    <div class='permissionsTemplateName'>" + "        <input type='text' maxlength='191' placeholder='<%=name_placeholder%>' value=''>" + "        <div class='duplicateNameErrorMessage'><%=duplicate_name%></div>" + "        <div class='emptyNameErrorMessage'><%=empty_name%></div>" + "    </div>" + "    <div class='permissionGroups'>" + "        <div class='firstGroup permissionGroup'/>" + "        <div class='secondGroup permissionGroup'/>" + "    </div>" + "    <div class='templateFooter'>" + "        <div class='saveButton'><%=save_and_apply%></div>" + "        <div class='resetButton'>" + "            <div class='icon'/><div class='label'><%=reset_changes%></div>" + "        </div>" + "    </div>" + "</div>";
        }
    }, {
        key: "messageKeys",
        value: function messageKeys() {
            return {
                name_placeholder: "userlist.userdata.permissions_templates.name_placeholder",
                reset_changes: "userlist.userdata.permissions_templates.edit_mode.reset_changes",
                save_and_apply: this.saveButtonTitle,
                duplicate_name: "userlist.userdata.permissions_templates.edit_mode.duplicate_name",
                empty_name: "userlist.userdata.permissions_templates.edit_mode.empty_name"
            };
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            var _this2 = this;

            this.$nameInput = this.find('.permissionsTemplateName input');
            this.$firstGroup = this.find('.firstGroup');
            this.$secondGroup = this.find('.secondGroup');
            this.$saveButton = this.find('.saveButton');
            this.$resetButton = this.find('.resetButton');
            this.$closeButton = this.find('.closeButton');
            this.permissionRows = (0, _PermissionsUtils.generatePermissionRows)(this.$firstGroup, this.$secondGroup);

            this.permissionRows[_constants.AccessRights.GENERATE_MONEY_REPORTS].setState({ lastRow: true });
            this.permissionRows[_constants.AccessRights.MANAGE_GENERAL_SETTINGS].setState({ lastRow: true });

            Object.values(this.permissionRows).map(function (row) {
                return row.on('changed', function (e, id, checked) {
                    _this2._handlePermissionsRowChange(id, checked);
                });
            });

            this.$saveButton.on('click', function () {
                _this2.params.onSaveButtonClick(_this2.getTemplateData());
            });

            //to prevent error processing by menu handlers
            this.getEl().on('mousedown keydown', function (e) {
                e.stopPropagation();
            });

            this.$closeButton.on('click', function () {
                _this2.params.onCloseButtonClick();
            });

            this.$nameInput.on('change', function (e) {
                _this2._handleInputValueChange(e.target.value);
            });

            this.renderInitialState();
        }
    }, {
        key: "getTemplateData",
        value: function getTemplateData() {
            // need for actualization of state
            this.$nameInput.blur();

            var state = this.getState();
            return {
                name: state.name,
                permissions: state.permissions
            };
        }
    }, {
        key: "update",
        value: function update() {
            Object.values(this.permissionRows).map(function (row) {
                return row.setState({ checked: false });
            });

            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = this.state.permissions[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var permission = _step2.value;

                    if (this.permissionRows[permission]) this.permissionRows[permission].setState({ checked: true });
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }
        }
    }]);

    return PermissionTemplatesView;
}(_TemplateView3.default);

exports.default = PermissionTemplatesView;

/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.PERMISSION_ICON_CLASS = undefined;

var _PERMISSION_ICON_CLAS;

var _constants = __webpack_require__(4);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var PERMISSION_ICON_CLASS = exports.PERMISSION_ICON_CLASS = (_PERMISSION_ICON_CLAS = {}, _defineProperty(_PERMISSION_ICON_CLAS, _constants.AccessRights.MANAGE_USERS, 'manageUsers'), _defineProperty(_PERMISSION_ICON_CLAS, _constants.AccessRights.SUBMIT_OTHER_USER_TIME_TRACK, 'modifyTT'), _defineProperty(_PERMISSION_ICON_CLAS, _constants.AccessRights.EDIT_HIERARCHY, 'manageScope'), _defineProperty(_PERMISSION_ICON_CLAS, _constants.AccessRights.GENERATE_MONEY_REPORTS, 'costReports'), _defineProperty(_PERMISSION_ICON_CLAS, _constants.AccessRights.SUBMIT_TIME_TRACK, 'submitTT'), _defineProperty(_PERMISSION_ICON_CLAS, _constants.AccessRights.LOCK_TIME_TRACK, 'lockTT'), _defineProperty(_PERMISSION_ICON_CLAS, _constants.AccessRights.MANAGE_PTO_AND_SICK, 'managePtoSick'), _defineProperty(_PERMISSION_ICON_CLAS, _constants.AccessRights.MANAGE_GENERAL_SETTINGS, 'manageSettings'), _PERMISSION_ICON_CLAS);

/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reselect = __webpack_require__(13);

var _selectors = __webpack_require__(14);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (getTaskPanelState) {

    var isLoaded = function isLoaded(state) {
        return getTaskPanelState(state).loaded;
    };

    var isLoading = function isLoading(state) {
        return getTaskPanelState(state).panelLoading;
    };

    var isPanelOpened = function isPanelOpened(state) {
        return getTaskPanelState(state).shown;
    };

    var getTaskPanelTabKey = function getTaskPanelTabKey(state) {
        return getTaskPanelState(state).currentTabKey;
    };
    var getLastTaskPanelTabKey = function getLastTaskPanelTabKey(state) {
        return getTaskPanelState(state).lastSelectedTabKey;
    };

    var isNeedToLoadData = (0, _reselect.createSelector)(isLoaded, isPanelOpened, function (loaded, opened) {
        return opened && !loaded;
    });

    var getTaskInfo = function getTaskInfo(state) {
        return getTaskPanelState(state).taskInfo;
    };

    var getTaskPanelErrors = function getTaskPanelErrors(state) {
        return getTaskPanelState(state).errors;
    };

    var getTaskName = function getTaskName(state) {
        return getTaskInfo(state).name;
    };
    var isTaskCompleted = function isTaskCompleted(state) {
        return getTaskInfo(state).completed;
    };
    var getCreationTimestamp = function getCreationTimestamp(state) {
        return getTaskInfo(state).creationTimestamp;
    };
    var getTaskStatusId = function getTaskStatusId(state) {
        return getTaskInfo(state).workflowStatusId;
    };
    var getTaskDeadline = function getTaskDeadline(state) {
        return getTaskInfo(state).deadline;
    };
    var getTaskBillableTypeId = function getTaskBillableTypeId(state) {
        return getTaskInfo(state).typeOfWorkId;
    };
    var getEstimatedTime = function getEstimatedTime(state) {
        return getTaskInfo(state).estimatedTime;
    };
    var getSpentTime = function getSpentTime(state) {
        return getTaskInfo(state).spentTime;
    };
    var getTaskDescription = function getTaskDescription(state) {
        return getTaskInfo(state).description;
    };

    var getBillingType = (0, _reselect.createSelector)(getTaskBillableTypeId, _selectors.getTypesOfWork, function (id, types) {
        return _underscore2.default.pick(types[id], ['id', 'name', 'billable']);
    });
    var getBillableTypeName = function getBillableTypeName(state) {
        return getTaskInfo(state).typeOfWorkName;
    };
    var isWorkTypeBillable = function isWorkTypeBillable(state) {
        return getTaskInfo(state).billable;
    };
    var isTaskDataChanged = function isTaskDataChanged(state) {
        return getTaskPanelState(state).taskDataChanged;
    };

    return {
        isLoaded: isLoaded,
        isLoading: isLoading,
        isPanelOpened: isPanelOpened,
        isNeedToLoadData: isNeedToLoadData,
        getTaskPanelErrors: getTaskPanelErrors,
        getTaskPanelTabKey: getTaskPanelTabKey,
        getLastTaskPanelTabKey: getLastTaskPanelTabKey,

        getTaskInfo: getTaskInfo,
        isTaskCompleted: isTaskCompleted,
        getCreationTimestamp: getCreationTimestamp,
        getTaskStatusId: getTaskStatusId,
        getTaskDeadline: getTaskDeadline,
        getTaskName: getTaskName,
        getEstimatedTime: getEstimatedTime,
        getSpentTime: getSpentTime,
        getTaskDescription: getTaskDescription,
        getBillingType: getBillingType,
        getTaskBillableTypeId: getTaskBillableTypeId,
        getBillableTypeName: getBillableTypeName,
        isWorkTypeBillable: isWorkTypeBillable,
        isTaskDataChanged: isTaskDataChanged
    };
};

/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (getPanelState) {

    var getAssignedUsers = function getAssignedUsers(state) {
        return getPanelState(state).assignedUsers;
    };
    var getAssignedManagers = function getAssignedManagers(state) {
        return getPanelState(state).assignedManagers;
    };
    var canModifyAnyUser = function canModifyAnyUser(state) {
        return getPanelState(state).canModifyAnyUser;
    };
    var canModifyAnyManager = function canModifyAnyManager(state) {
        return getPanelState(state).canModifyAnyManager;
    };

    return {
        getAssignedUsers: getAssignedUsers,
        getAssignedManagers: getAssignedManagers,
        canModifyAnyUser: canModifyAnyUser,
        canModifyAnyManager: canModifyAnyManager
    };
};

/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UserInitialsIcon = function (_TemplateView) {
    _inherits(UserInitialsIcon, _TemplateView);

    function UserInitialsIcon(_ref) {
        var firstName = _ref.firstName,
            lastName = _ref.lastName,
            _ref$color = _ref.color,
            color = _ref$color === undefined ? '' : _ref$color;

        _classCallCheck(this, UserInitialsIcon);

        var _this = _possibleConstructorReturn(this, (UserInitialsIcon.__proto__ || Object.getPrototypeOf(UserInitialsIcon)).call(this));

        _this.params = {
            firstName: firstName,
            lastName: lastName,
            color: color
        };
        return _this;
    }

    _createClass(UserInitialsIcon, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return "<div class='components_userInitialsIcon'><%-fnLetter%><%-lnLetter%></div>";
        }
    }, {
        key: 'templateModel',
        value: function templateModel() {
            return {
                fnLetter: this.params.firstName[0],
                lnLetter: this.params.lastName[0],
                color: this.params.color
            };
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            this.getEl().css('background-color', this.params.color);
        }
    }]);

    return UserInitialsIcon;
}(_TemplateView3.default);

exports.default = UserInitialsIcon;

/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1337).default;


/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.stateify = exports.TokenState = exports.CharacterState = undefined;

var _class = __webpack_require__(361);

function createStateClass() {
	return function (tClass) {
		this.j = [];
		this.T = tClass || null;
	};
}

/**
	A simple state machine that can emit token classes

	The `j` property in this class refers to state jumps. It's a
	multidimensional array where for each element:

	* index [0] is a symbol or class of symbols to transition to.
	* index [1] is a State instance which matches

	The type of symbol will depend on the target implementation for this class.
	In Linkify, we have a two-stage scanner. Each stage uses this state machine
	but with a slighly different (polymorphic) implementation.

	The `T` property refers to the token class.

	TODO: Can the `on` and `next` methods be combined?

	@class BaseState
*/
var BaseState = createStateClass();
BaseState.prototype = {
	defaultTransition: false,

	/**
 	@method constructor
 	@param {Class} tClass Pass in the kind of token to emit if there are
 		no jumps after this state and the state is accepting.
 */

	/**
 	On the given symbol(s), this machine should go to the given state
 		@method on
 	@param {Array|Mixed} symbol
 	@param {BaseState} state Note that the type of this state should be the
 		same as the current instance (i.e., don't pass in a different
 		subclass)
 */
	on: function on(symbol, state) {
		if (symbol instanceof Array) {
			for (var i = 0; i < symbol.length; i++) {
				this.j.push([symbol[i], state]);
			}
			return this;
		}
		this.j.push([symbol, state]);
		return this;
	},


	/**
 	Given the next item, returns next state for that item
 	@method next
 	@param {Mixed} item Should be an instance of the symbols handled by
 		this particular machine.
 	@return {State} state Returns false if no jumps are available
 */
	next: function next(item) {
		for (var i = 0; i < this.j.length; i++) {
			var jump = this.j[i];
			var symbol = jump[0]; // Next item to check for
			var state = jump[1]; // State to jump to if items match

			// compare item with symbol
			if (this.test(item, symbol)) {
				return state;
			}
		}

		// Nowhere left to jump!
		return this.defaultTransition;
	},


	/**
 	Does this state accept?
 	`true` only of `this.T` exists
 		@method accepts
 	@return {Boolean}
 */
	accepts: function accepts() {
		return !!this.T;
	},


	/**
 	Determine whether a given item "symbolizes" the symbol, where symbol is
 	a class of items handled by this state machine.
 		This method should be overriden in extended classes.
 		@method test
 	@param {Mixed} item Does this item match the given symbol?
 	@param {Mixed} symbol
 	@return {Boolean}
 */
	test: function test(item, symbol) {
		return item === symbol;
	},


	/**
 	Emit the token for this State (just return it in this case)
 	If this emits a token, this instance is an accepting state
 	@method emit
 	@return {Class} T
 */
	emit: function emit() {
		return this.T;
	}
};

/**
	State machine for string-based input

	@class CharacterState
	@extends BaseState
*/
var CharacterState = (0, _class.inherits)(BaseState, createStateClass(), {
	/**
 	Does the given character match the given character or regular
 	expression?
 		@method test
 	@param {String} char
 	@param {String|RegExp} charOrRegExp
 	@return {Boolean}
 */
	test: function test(character, charOrRegExp) {
		return character === charOrRegExp || charOrRegExp instanceof RegExp && charOrRegExp.test(character);
	}
});

/**
	State machine for input in the form of TextTokens

	@class TokenState
	@extends BaseState
*/
var TokenState = (0, _class.inherits)(BaseState, createStateClass(), {

	/**
  * Similar to `on`, but returns the state the results in the transition from
  * the given item
  * @method jump
  * @param {Mixed} item
  * @param {Token} [token]
  * @return state
  */
	jump: function jump(token) {
		var tClass = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

		var state = this.next(new token('')); // dummy temp token
		if (state === this.defaultTransition) {
			// Make a new state!
			state = new this.constructor(tClass);
			this.on(token, state);
		} else if (tClass) {
			state.T = tClass;
		}
		return state;
	},


	/**
 	Is the given token an instance of the given token class?
 		@method test
 	@param {TextToken} token
 	@param {Class} tokenClass
 	@return {Boolean}
 */
	test: function test(token, tokenClass) {
		return token instanceof tokenClass;
	}
});

/**
	Given a non-empty target string, generates states (if required) for each
	consecutive substring of characters in str starting from the beginning of
	the string. The final state will have a special value, as specified in
	options. All other "in between" substrings will have a default end state.

	This turns the state machine into a Trie-like data structure (rather than a
	intelligently-designed DFA).

	Note that I haven't really tried these with any strings other than
	DOMAIN.

	@param {String} str
	@param {CharacterState} start State to jump from the first character
	@param {Class} endToken Token class to emit when the given string has been
		matched and no more jumps exist.
	@param {Class} defaultToken "Filler token", or which token type to emit when
		we don't have a full match
	@return {Array} list of newly-created states
*/
function stateify(str, start, endToken, defaultToken) {
	var i = 0,
	    len = str.length,
	    state = start,
	    newStates = [],
	    nextState = void 0;

	// Find the next state without a jump to the next character
	while (i < len && (nextState = state.next(str[i]))) {
		state = nextState;
		i++;
	}

	if (i >= len) {
		return [];
	} // no new tokens were added

	while (i < len - 1) {
		nextState = new CharacterState(defaultToken);
		newStates.push(nextState);
		state.on(str[i], nextState);
		state = nextState;
		i++;
	}

	nextState = new CharacterState(endToken);
	newStates.push(nextState);
	state.on(str[len - 1], nextState);

	return newStates;
}

exports.CharacterState = CharacterState;
exports.TokenState = TokenState;
exports.stateify = stateify;

/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
function createTokenClass() {
	return function (value) {
		if (value) {
			this.v = value;
		}
	};
}

exports.createTokenClass = createTokenClass;

/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (_ref) {
    var _ref$actionTypes = _ref.actionTypes,
        OPEN_TASK_SET = _ref$actionTypes.OPEN_TASK_SET,
        TASK_PANEL_ERRORS_ADD = _ref$actionTypes.TASK_PANEL_ERRORS_ADD,
        TASK_PANEL_ERRORS_SET = _ref$actionTypes.TASK_PANEL_ERRORS_SET,
        TASK_PANEL_ERRORS_REMOVE = _ref$actionTypes.TASK_PANEL_ERRORS_REMOVE,
        TASK_PANEL_LOADING_SET = _ref$actionTypes.TASK_PANEL_LOADING_SET,
        TASK_PANEL_LOADED_SET = _ref$actionTypes.TASK_PANEL_LOADED_SET,
        TASK_INFO_SET = _ref$actionTypes.TASK_INFO_SET,
        TASK_PANEL_SHOWN_SET = _ref$actionTypes.TASK_PANEL_SHOWN_SET,
        TASK_PANEL_TAB_SET = _ref$actionTypes.TASK_PANEL_TAB_SET,
        TASK_PANEL_LAST_TAB_SET = _ref$actionTypes.TASK_PANEL_LAST_TAB_SET,
        NEED_INITIALIZE_FOCUS_SET = _ref$actionTypes.NEED_INITIALIZE_FOCUS_SET;

    var addTaskPanelErrors = (0, _reduxActions.createAction)(TASK_PANEL_ERRORS_ADD);
    var setTaskPanelErrors = (0, _reduxActions.createAction)(TASK_PANEL_ERRORS_SET);
    var removeTaskPanelErrors = (0, _reduxActions.createAction)(TASK_PANEL_ERRORS_REMOVE);

    var setTaskPanelLoading = (0, _reduxActions.createAction)(TASK_PANEL_LOADING_SET);

    var setTaskPanelLoaded = (0, _reduxActions.createAction)(TASK_PANEL_LOADED_SET);

    var setTaskInfo = (0, _reduxActions.createAction)(TASK_INFO_SET);
    var setTaskPanelShown = (0, _reduxActions.createAction)(TASK_PANEL_SHOWN_SET);

    var setTaskPanelTab = (0, _reduxActions.createAction)(TASK_PANEL_TAB_SET);
    var setLastTaskPanelTab = (0, _reduxActions.createAction)(TASK_PANEL_LAST_TAB_SET);

    var openTaskPanel = function openTaskPanel() {
        return function (dispatch) {
            dispatch(setTaskPanelShown(true));
        };
    };

    var closeTaskPanel = function closeTaskPanel() {
        return function (dispatch) {
            dispatch(setTaskPanelShown(false));
        };
    };

    var removeOpenedTask = function removeOpenedTask(taskId) {
        return function (dispatch, getState) {
            // TODO: taskId should be taken from the store, see TaskPanelContainer.js for reasons why it's not the case now
            // const taskId = getOpenTaskId(getState())
            dispatch((0, _actions.removeTask)(taskId));
        };
    };

    var setNeedInitializeFocus = (0, _reduxActions.createAction)(NEED_INITIALIZE_FOCUS_SET);

    return {
        openTaskPanel: openTaskPanel,
        closeTaskPanel: closeTaskPanel,
        setTaskInfo: setTaskInfo,
        addTaskPanelErrors: addTaskPanelErrors,
        setTaskPanelErrors: setTaskPanelErrors,
        removeTaskPanelErrors: removeTaskPanelErrors,
        setTaskPanelLoading: setTaskPanelLoading,
        setTaskPanelLoaded: setTaskPanelLoaded,
        setTaskPanelTab: setTaskPanelTab,
        setLastTaskPanelTab: setLastTaskPanelTab,
        setNeedInitializeFocus: setNeedInitializeFocus
    };
};

var _reduxActions = __webpack_require__(9);

var _actions = __webpack_require__(29);

/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (_ref) {
    var _ref$actionTypes = _ref.actionTypes,
        ASSIGNED_USERS_SET = _ref$actionTypes.ASSIGNED_USERS_SET,
        ASSIGNED_MANAGERS_SET = _ref$actionTypes.ASSIGNED_MANAGERS_SET,
        CAN_MODIFY_ANY_USER_SET = _ref$actionTypes.CAN_MODIFY_ANY_USER_SET,
        CAN_MODIFY_ANY_MANAGER_SET = _ref$actionTypes.CAN_MODIFY_ANY_MANAGER_SET;


    var setAssignedUsers = (0, _reduxActions.createAction)(ASSIGNED_USERS_SET);
    var setCanModifyAnyUser = (0, _reduxActions.createAction)(CAN_MODIFY_ANY_USER_SET);
    var setAssignedManagers = (0, _reduxActions.createAction)(ASSIGNED_MANAGERS_SET);
    var setCanModifyAnyManager = (0, _reduxActions.createAction)(CAN_MODIFY_ANY_MANAGER_SET);

    var setAssignedUsersData = function setAssignedUsersData(_ref2) {
        var users = _ref2.users,
            userGroups = _ref2.userGroups,
            timeZoneGroups = _ref2.timeZoneGroups,
            userGroupsEnabled = _ref2.userGroupsEnabled,
            timeZoneGroupsEnabled = _ref2.timeZoneGroupsEnabled,
            canModifyAny = _ref2.canModifyAny;
        return function (dispatch) {
            dispatch(loadGroupsInfo({
                userGroups: userGroups,
                timeZoneGroups: timeZoneGroups,
                userGroupsEnabled: userGroupsEnabled,
                timeZoneGroupsEnabled: timeZoneGroupsEnabled
            }));
            dispatch(setCanModifyAnyUser(canModifyAny));
            dispatch(setAssignedUsers(users));
        };
    };

    var setAssignedManagersData = function setAssignedManagersData(_ref3) {
        var users = _ref3.users,
            userGroups = _ref3.userGroups,
            timeZoneGroups = _ref3.timeZoneGroups,
            userGroupsEnabled = _ref3.userGroupsEnabled,
            timeZoneGroupsEnabled = _ref3.timeZoneGroupsEnabled,
            canModifyAny = _ref3.canModifyAny;
        return function (dispatch) {
            dispatch(loadGroupsInfo({
                userGroups: userGroups,
                timeZoneGroups: timeZoneGroups,
                userGroupsEnabled: userGroupsEnabled,
                timeZoneGroupsEnabled: timeZoneGroupsEnabled
            }));
            dispatch(setCanModifyAnyManager(canModifyAny));
            dispatch(setAssignedManagers(users));
        };
    };

    var loadGroupsInfo = function loadGroupsInfo(_ref4) {
        var userGroups = _ref4.userGroups,
            timeZoneGroups = _ref4.timeZoneGroups,
            userGroupsEnabled = _ref4.userGroupsEnabled,
            timeZoneGroupsEnabled = _ref4.timeZoneGroupsEnabled;
        return function (dispatch) {
            var userGroupsWithDefault = userGroups ? (0, _groupUtils.addDefaultUserGroup)(userGroups) : userGroups;
            dispatch(EntitiesActions.setUserGroups(userGroupsWithDefault));
            dispatch(EntitiesActions.setTimeZoneGroups(timeZoneGroups));
            dispatch(FeaturesActions.updateFeatures(_defineProperty({}, _constants.Feature.UGR, userGroupsEnabled)));
            dispatch(FeaturesActions.updateFeatures(_defineProperty({}, _constants.Feature.TZG, timeZoneGroupsEnabled)));
        };
    };

    return {
        setAssignedUsersData: setAssignedUsersData,
        setAssignedManagersData: setAssignedManagersData,
        setAssignedUsers: setAssignedUsers,
        setAssignedManagers: setAssignedManagers
    };
};

var _reduxActions = __webpack_require__(9);

var _constants = __webpack_require__(78);

var _actions = __webpack_require__(68);

var FeaturesActions = _interopRequireWildcard(_actions);

var _actions2 = __webpack_require__(29);

var EntitiesActions = _interopRequireWildcard(_actions2);

var _groupUtils = __webpack_require__(71);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var getToastsState = function getToastsState(state) {
  return state.toasts;
};

var getMessages = exports.getMessages = function getMessages(state) {
  return getToastsState(state).messages;
};

/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var TASK_ID_QUERY_KEY = exports.TASK_ID_QUERY_KEY = 'taskId';
var PROJECT_ID_QUERY_KEY = exports.PROJECT_ID_QUERY_KEY = 'projectId';
var CUSTOMER_ID_QUERY_KEY = exports.CUSTOMER_ID_QUERY_KEY = 'customerId';
var PAGE_ACTION_QUERY_KEY = exports.PAGE_ACTION_QUERY_KEY = 'pageAction';
var TASK_NAME_QUERY_KEY = exports.TASK_NAME_QUERY_KEY = 'taskName';

var CREATE_TASK_PAGE_ACTION = exports.CREATE_TASK_PAGE_ACTION = 'create_task';

/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.copyTaskRpcErrorHandler = copyTaskRpcErrorHandler;
exports.createTaskRpcErrorHandler = createTaskRpcErrorHandler;

var _ExceptionsTypes = __webpack_require__(107);

var _constants = __webpack_require__(157);

var _constants2 = __webpack_require__(108);

function copyTaskRpcErrorHandler(rpcError) {
    rpcError.handleOnExceptions([_ExceptionsTypes.NO_RIGHT_TO_EDIT_HIERARCHY_EXCEPTION, _ExceptionsTypes.TASK_IS_NOT_ASSIGNED_TO_USER_EXCEPTION, _ExceptionsTypes.PROJECT_IS_NOT_AVAILABLE_EXCEPTION, _ExceptionsTypes.NO_SUCH_TASK_EXCEPTION, _ExceptionsTypes.NO_SUCH_PROJECT_EXCEPTION, _ExceptionsTypes.PROJECT_IS_ARCHIVED_EXCEPTION]);
}

function createTaskRpcErrorHandler(rpcError) {
    rpcError.handleOnExceptions([_constants.ErrorsExceptions.TASK_NAME_DUPLICATE, _ExceptionsTypes.NO_SUCH_PROJECT_EXCEPTION, _ExceptionsTypes.PROJECT_IS_ARCHIVED_EXCEPTION, _ExceptionsTypes.PROJECT_IS_NOT_AVAILABLE_EXCEPTION, _ExceptionsTypes.NO_RIGHT_TO_EDIT_HIERARCHY_EXCEPTION, _constants2.Exceptions.USER_IS_NOT_ASSIGNED_TO_MANAGER_EXCEPTION, _constants2.Exceptions.USER_IS_DISABLED_EXCEPTION, _constants2.Exceptions.NO_SUCH_USER_EXCEPTION, _constants2.Exceptions.NO_RIGHTS_TO_SUBMIT_TT_EXCEPTION, _constants2.Exceptions.USER_HAS_NO_ACCESS_TO_SCOPE_EXCEPTION]);
}

/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _TemplateView = __webpack_require__(1);

var _TemplateView2 = _interopRequireDefault(_TemplateView);

var _user_time = __webpack_require__(30);

var _user_time2 = _interopRequireDefault(_user_time);

var _keyCodes = __webpack_require__(66);

var _atBrowserUtils = __webpack_require__(8);

var _LoadingControlMixin = __webpack_require__(136);

var _LoadingControlMixin2 = _interopRequireDefault(_LoadingControlMixin);

var _SimpleTooltip = __webpack_require__(36);

var _SimpleTooltip2 = _interopRequireDefault(_SimpleTooltip);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TimeEditor = function TimeEditor($containerEl, editable) {
    var editablePlaceholderText = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'N/A';
    var nonEditablePlaceholderText = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'N/A';
    var onChangeCb = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : function () {};

    _TemplateView2.default.call(this, $containerEl);
    this.editable = editable;
    this.editablePlaceholderText = editablePlaceholderText;
    this.nonEditablePlaceholderText = nonEditablePlaceholderText;
    this.onChangeCb = onChangeCb;
};

TimeEditor.prototype = _underscore2.default.create(_TemplateView2.default.prototype, {
    html: "<div class='timeEditor'>" + "  <div class='value'></div>" + "  <input type='text' placeholder='<%-this.placeholder%>' maxlength='9'/>" + "</div>",

    updateOnInit: false,

    afterRender: function afterRender() {
        var self = this;
        this.time = null;
        this.disabled = false;
        this.$el.toggleClass('editable', this.editable);
        this.updatePlaceholderText(this.editable);
        this.$value = this.find(".value");
        this.$input = this.find("input");

        var tooltip = new _SimpleTooltip2.default({ text: _messageResource2.default.getMessage("task.time_editor.error", [SystemSettings.decimalSeparator]) }).init((0, _jquery2.default)('body'));
        tooltip.setEnabled(false);
        tooltip.subscribeToMouseEvents(this.$el);

        this.$input.placeholder();
        this.bindClick(function () {
            if (!self.editable || self.disabled || this.isLoading()) return;

            self._startEditing();
        });
        this.$input.valueChanged(function () {
            var inputValue = self.$input.pVal();
            if (inputValue === "") {
                self.currentEditingTime = null;
            } else {
                var time = _user_time2.default.parseTimeWithSystemSettings(inputValue, true);
                // max time is 10^6 hours
                if (_underscore2.default.isNumber(time) && time >= 0 && time < 60 * 1000000) {
                    self.hasError = false;
                    tooltip.setEnabled(false);
                    self.$el.removeClass("error");
                    self.currentEditingTime = time;
                } else {
                    self.hasError = true;
                    tooltip.setEnabled(true);
                    self.$el.addClass("error");
                }
            }
        });
        this.$input.blur(function () {
            if (self.editing) {
                var isValidNonEmptyTime = !self.hasError && !_underscore2.default.isUndefined(self.currentEditingTime);
                if (isValidNonEmptyTime) {
                    var newTime = self.currentEditingTime === 0 ? null : self.currentEditingTime;
                    self._triggerChange(newTime);
                }
                tooltip.setEnabled(false);
                self._stopEditing();
            }
        });
        this.$input.keydown(function (e) {
            if (e.which === _keyCodes.KEY_CODE_ENTER) self.$input.blur();
            (0, _atBrowserUtils.handleEscape)(function (e) {
                stopEventPropagation(e);
                self.$input.blur();
            }, e);
        });
    },

    update: function update() {
        var hasTime = _underscore2.default.isNumber(this.time);
        if (hasTime) {
            this.$value.text(_user_time2.default.formatTimeWithDigitSeparator(this.time));
        } else {
            this.$value.text(this.placeholder);
        }
        this.$el.toggleClass("empty", !hasTime);
        this.$el.toggleClass("disabled", this.disabled);
        this.$el.toggleClass('editable', this.editable);
    },

    getTime: function getTime() {
        return this.time;
    },

    setTime: function setTime(time) {
        this.time = time;
        this.update();
    },

    isDisabled: function isDisabled() {
        return this.disabled;
    },

    setDisabled: function setDisabled(disabled) {
        this.disabled = disabled;
        this.update();
    },

    updatePlaceholderText: function updatePlaceholderText(editable) {
        this.placeholder = editable ? this.editablePlaceholderText : this.nonEditablePlaceholderText;
    },


    _startEditing: function _startEditing() {
        if (this.editable && !this.editing) {
            delete this.currentEditingTime;
            this.editing = true;
            this.$el.addClass("editing");
            this._resetInputValue();
            this.$input.focus();
            this.$input.select();
            (0, _jquery2.default)(this).trigger("startEditing");
        }
    },

    _stopEditing: function _stopEditing() {
        if (this.editable && this.editing) {
            this.editing = false;
            this.$el.removeClass("editing");
            (0, _jquery2.default)(this).trigger("stopEditing");
        }
    },

    _triggerChange: function _triggerChange(time) {
        this.time = time;
        this.update();
        this.onChangeCb(time);
        (0, _jquery2.default)(this).trigger("change", time);
    },

    _resetInputValue: function _resetInputValue() {
        this.hasError = false;
        var value = _underscore2.default.isNumber(this.time) ? _user_time2.default.formatTimeWithDigitSeparator(this.time) : "";
        this.$input.pVal(value);
        this.$input[0].prevValue = value;
        this.$el.removeClass("error");
    },

    setEditable: function setEditable(editable) {
        this.editable = editable;
        this.updatePlaceholderText(editable);
        this.update();
    },

    placeholder: 'N/A'
});

_underscore2.default.extend(TimeEditor.prototype, _LoadingControlMixin2.default);

exports.default = TimeEditor;

/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.WorkflowStatusSelector = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _WorkflowStatusList = __webpack_require__(1356);

var _WorkflowStatusList2 = _interopRequireDefault(_WorkflowStatusList);

var _WorkflowStatusNode = __webpack_require__(1357);

var _WorkflowStatusNode2 = _interopRequireDefault(_WorkflowStatusNode);

var _WorkflowStatusTypeNode = __webpack_require__(1358);

var _WorkflowStatusTypeNode2 = _interopRequireDefault(_WorkflowStatusTypeNode);

var _ScrollableContainer = __webpack_require__(49);

var _ScrollableContainer2 = _interopRequireDefault(_ScrollableContainer);

var _utils = __webpack_require__(6);

var _constants = __webpack_require__(23);

var _selectors = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var WorkflowStatusSelector = exports.WorkflowStatusSelector = function (_TemplateView) {
    _inherits(WorkflowStatusSelector, _TemplateView);

    function WorkflowStatusSelector(_ref) {
        var _ref$onSelectStatus = _ref.onSelectStatus,
            onSelectStatus = _ref$onSelectStatus === undefined ? function (id) {} : _ref$onSelectStatus,
            _ref$typeFilter = _ref.typeFilter,
            typeFilter = _ref$typeFilter === undefined ? null : _ref$typeFilter,
            _ref$groupByStatusTyp = _ref.groupByStatusType,
            groupByStatusType = _ref$groupByStatusTyp === undefined ? true : _ref$groupByStatusTyp,
            _ref$showActionNames = _ref.showActionNames,
            showActionNames = _ref$showActionNames === undefined ? false : _ref$showActionNames;

        _classCallCheck(this, WorkflowStatusSelector);

        var _this = _possibleConstructorReturn(this, (WorkflowStatusSelector.__proto__ || Object.getPrototypeOf(WorkflowStatusSelector)).call(this, null));

        _this._handleOnClickStatus = function (id) {
            _this.params.onSelectStatus(id);
        };

        _this.state = {
            statusesMap: {},
            selectedStatusId: -1,
            inactiveOpenStatuses: false,

            showCompletedFirst: false,
            showReopenLabel: false
        };

        _this.params = {
            onSelectStatus: onSelectStatus,
            typeFilter: typeFilter,
            groupByStatusType: groupByStatusType,
            showActionNames: showActionNames
        };

        _this.onAnyStatePropertyDeeplyChanged(['statusesMap', 'selectedStatusId', 'inactiveOpenStatuses', 'showCompletedFirst', 'showReopenLabel'], function () {
            if (_this.rendered) {
                _this._renderList();
            }
        });
        return _this;
    }

    _createClass(WorkflowStatusSelector, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class="workflowStatus_components_workflowStatusSelector"></div>';
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            this._renderList();
        }
    }, {
        key: 'update',
        value: function update() {
            _get(WorkflowStatusSelector.prototype.__proto__ || Object.getPrototypeOf(WorkflowStatusSelector.prototype), 'update', this).call(this);
            if (!!this.scrollableContainer) this.scrollableContainer.forceUpdate();
        }
    }, {
        key: '_renderList',
        value: function _renderList() {
            var _this2 = this;

            this.$el.empty();
            this.scrollableContainer = new _ScrollableContainer2.default(null, new _WorkflowStatusList2.default({
                groupRenderer: function groupRenderer($el, type) {
                    new _WorkflowStatusTypeNode2.default(type).init($el);
                },
                statusRenderer: function statusRenderer($el, status) {
                    new _WorkflowStatusNode2.default({
                        status: status,
                        checked: _this2.state.selectedStatusId === status.id
                    }, _this2._handleOnClickStatus).init($el);
                },
                showGroups: this.params.groupByStatusType
            }));

            var completedSelected = !!this.state.statusesMap[this.state.selectedStatusId] && this.state.statusesMap[this.state.selectedStatusId].type === _constants.WorkflowStatusType.COMPLETED;
            var statusesList = this._getStatusesList();
            var numOfCompleted = statusesList.reduce(function (acc, val) {
                return acc + (val.type === _constants.WorkflowStatusType.COMPLETED ? 1 : 0);
            }, 0);
            var hideCompleted = this.state.showCompletedFirst && completedSelected && numOfCompleted <= 1;
            this.scrollableContainer.init(this.$el).setState({
                statuses: statusesList,
                inactiveOpenStatuses: this.state.inactiveOpenStatuses,
                showGroups: this.params.groupByStatusType && (!this.state.showReopenLabel || !this.params.showActionNames),
                hideCompleted: hideCompleted,
                showCompletedFirst: this.state.showCompletedFirst,
                showReopenLabel: this.params.showActionNames && this.state.showReopenLabel,
                showChangeStatusLabel: !hideCompleted && this.params.showActionNames
            });
        }
    }, {
        key: '_getStatusesList',
        value: function _getStatusesList() {
            var _this3 = this;

            var statusesList = Object.values(this.state.statusesMap);
            if (this.params.typeFilter === null) {
                return statusesList;
            }

            return statusesList.filter(function (st) {
                return st.type === _this3.params.typeFilter;
            });
        }
    }]);

    return WorkflowStatusSelector;
}(_TemplateView3.default);

exports.default = (0, _utils.connect)(function (state) {
    return {
        statusesMap: (0, _selectors.getWorkflowStatuses)(state)
    };
})(WorkflowStatusSelector);

/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ScrollDragHandler = function () {
    function ScrollDragHandler(_ref) {
        var scrollableEl = _ref.scrollableEl,
            scroll = _ref.scroll,
            onUpdateScroll = _ref.onUpdateScroll,
            _ref$scrollDelta = _ref.scrollDelta,
            scrollDelta = _ref$scrollDelta === undefined ? 10 : _ref$scrollDelta,
            _ref$scrollOffset = _ref.scrollOffset,
            scrollOffset = _ref$scrollOffset === undefined ? 100 : _ref$scrollOffset;

        _classCallCheck(this, ScrollDragHandler);

        this.scrollableEl = scrollableEl;
        this.scroll = scroll;
        this.onUpdateScroll = onUpdateScroll;
        this.scrollDelta = scrollDelta;
        this.scrollOffset = scrollOffset;
    }

    _createClass(ScrollDragHandler, [{
        key: "clearAutoScrollTimer",
        value: function clearAutoScrollTimer() {
            clearTimeout(this.autoScrollTimer);
        }
    }, {
        key: "handleEvent",
        value: function handleEvent(event) {}
    }, {
        key: "_autoScroll",
        value: function _autoScroll(x, y) {
            var _this = this;

            this.onUpdateScroll();
            this.clearAutoScrollTimer();

            this.autoScrollTimer = setInterval(function () {
                _this.scroll.scrollBy(x, y);
                _this.onUpdateScroll();
            }, 5);
        }
    }]);

    return ScrollDragHandler;
}();

var VerticalScrollDragHandler = function (_ScrollDragHandler) {
    _inherits(VerticalScrollDragHandler, _ScrollDragHandler);

    function VerticalScrollDragHandler() {
        _classCallCheck(this, VerticalScrollDragHandler);

        return _possibleConstructorReturn(this, (VerticalScrollDragHandler.__proto__ || Object.getPrototypeOf(VerticalScrollDragHandler)).apply(this, arguments));
    }

    _createClass(VerticalScrollDragHandler, [{
        key: "handleEvent",
        value: function handleEvent(event) {
            var top = this.scrollableEl.offset().top;
            var bottom = this.scrollableEl.offset().top + this.scrollableEl.outerHeight();

            if (event.clientY > bottom - this.scrollOffset && this.scroll.y > this.scroll.maxScrollY) {
                this._autoScroll(0, -this.scrollDelta);
            } else if (event.clientY < top + this.scrollOffset && this.scroll.y < 0) {
                this._autoScroll(0, this.scrollDelta);
            } else {
                this.clearAutoScrollTimer();
            }
        }
    }]);

    return VerticalScrollDragHandler;
}(ScrollDragHandler);

var HorizonalScrollDragHandler = function (_ScrollDragHandler2) {
    _inherits(HorizonalScrollDragHandler, _ScrollDragHandler2);

    function HorizonalScrollDragHandler() {
        _classCallCheck(this, HorizonalScrollDragHandler);

        return _possibleConstructorReturn(this, (HorizonalScrollDragHandler.__proto__ || Object.getPrototypeOf(HorizonalScrollDragHandler)).apply(this, arguments));
    }

    _createClass(HorizonalScrollDragHandler, [{
        key: "handleEvent",
        value: function handleEvent(event) {
            var left = this.scrollableEl.offset().left;
            var right = this.scrollableEl.offset().left + this.scrollableEl.outerWidth();

            if (event.pageX < left + this.scrollOffset && this.scroll.x < 0) {
                this._autoScroll(this.scrollDelta, 0);
            } else if (event.pageX > right - this.scrollOffset && this.scroll.x > this.scroll.maxScrollX) {
                this._autoScroll(-this.scrollDelta, 0);
            } else {
                this.clearAutoScrollTimer();
            }
        }
    }]);

    return HorizonalScrollDragHandler;
}(ScrollDragHandler);

exports.VerticalScrollDragHandler = VerticalScrollDragHandler;
exports.HorizonalScrollDragHandler = HorizonalScrollDragHandler;

/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ScrollToTopButton = function (_TemplateView) {
    _inherits(ScrollToTopButton, _TemplateView);

    function ScrollToTopButton() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            _ref$onClickCb = _ref.onClickCb,
            onClickCb = _ref$onClickCb === undefined ? function () {} : _ref$onClickCb,
            _ref$fadingHeight = _ref.fadingHeight,
            fadingHeight = _ref$fadingHeight === undefined ? 0 : _ref$fadingHeight,
            _ref$scrollToTopButto = _ref.scrollToTopButtonAdditionalClass,
            scrollToTopButtonAdditionalClass = _ref$scrollToTopButto === undefined ? '' : _ref$scrollToTopButto;

        _classCallCheck(this, ScrollToTopButton);

        var _this = _possibleConstructorReturn(this, (ScrollToTopButton.__proto__ || Object.getPrototypeOf(ScrollToTopButton)).call(this));

        _this.params = {
            fadingHeight: fadingHeight,
            scrollToTopButtonAdditionalClass: scrollToTopButtonAdditionalClass
        };

        _this.callbacks = {
            onClickCb: onClickCb
        };

        _this.isShown = false;
        return _this;
    }

    _createClass(ScrollToTopButton, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return "<div class='scrollToTopButton <%-scrollToTopButtonAdditionalClass%>'></div>";
        }
    }, {
        key: 'templateModel',
        value: function templateModel() {
            return {
                scrollToTopButtonAdditionalClass: this.params.scrollToTopButtonAdditionalClass
            };
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            this.bindClick(this.callbacks.onClickCb);

            this.hide();
        }
    }, {
        key: 'updateVisibility',
        value: function updateVisibility(verticalScrollPosition) {
            //stops fadeTo
            this.$el.stop(true);

            if (verticalScrollPosition === 0 && this.isShown) this.hide();

            if (verticalScrollPosition !== 0 && !this.isShown) this.show();

            this._updateOpacity(verticalScrollPosition);
        }
    }, {
        key: 'fadeOut',
        value: function fadeOut() {
            var _this2 = this;

            var duration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

            this.$el.fadeTo(duration, 0, function () {
                return _this2.hide();
            });
        }
    }, {
        key: 'hide',
        value: function hide() {
            _get(ScrollToTopButton.prototype.__proto__ || Object.getPrototypeOf(ScrollToTopButton.prototype), 'hide', this).call(this);
            this.isShown = false;
        }
    }, {
        key: 'show',
        value: function show() {
            _get(ScrollToTopButton.prototype.__proto__ || Object.getPrototypeOf(ScrollToTopButton.prototype), 'show', this).call(this);
            this.isShown = true;
        }
    }, {
        key: '_updateOpacity',
        value: function _updateOpacity(y) {
            var opacity = Math.abs(y / this.params.fadingHeight);
            if (opacity > 1) opacity = 1;
            this.$el.css('opacity', opacity);
        }
    }]);

    return ScrollToTopButton;
}(_TemplateView3.default);

exports.default = ScrollToTopButton;

/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ChartGenerator2 = __webpack_require__(291);

var _ChartGenerator3 = _interopRequireDefault(_ChartGenerator2);

var _number_formatter = __webpack_require__(61);

var _number_formatter2 = _interopRequireDefault(_number_formatter);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _atUtils = __webpack_require__(5);

var _user_time = __webpack_require__(30);

var _user_time2 = _interopRequireDefault(_user_time);

var _amcharts = __webpack_require__(772);

var _amcharts2 = _interopRequireDefault(_amcharts);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PieChartGenerator = function (_ChartGenerator) {
    _inherits(PieChartGenerator, _ChartGenerator);

    function PieChartGenerator() {
        _classCallCheck(this, PieChartGenerator);

        return _possibleConstructorReturn(this, (PieChartGenerator.__proto__ || Object.getPrototypeOf(PieChartGenerator)).apply(this, arguments));
    }

    _createClass(PieChartGenerator, [{
        key: "_getDataProvider",
        value: function _getDataProvider(chartData, config) {
            // abstract
        }
    }, {
        key: "_prepareChartSettings",
        value: function _prepareChartSettings(chartData, config) {
            var labelFunction = this._createLabelFunction();
            var balloonFunction = this._createBalloonFunction();

            var dataProvider = this._getDataProvider(chartData, config);

            return {
                "type": "pie",
                "autoResize": false,
                "radius": 104,
                "innerRadius": 40,
                "outlineThickness": 1,
                "outlineAlpha": 1,
                "theme": "light",
                "addClassNames": true,

                "fontSize": 11,
                "labelRadius": 20,
                "maxLabelWidth": 300,
                "hideLabelsPercent": 1.5,
                "labelFunction": labelFunction,

                "autoMargins": false,

                "startDuration": 0,
                "startEffect": "easeOutSine",
                "startRadius": 100,
                "sequencedAnimation": false,

                "balloon": {
                    "maxWidth": 350 // text width limited by balloon inner content
                },
                "balloonFunction": balloonFunction,

                "titleField": "category",
                "valueField": "value",
                "colorField": "sectorColor",
                "dataProvider": dataProvider
            };
        }
    }, {
        key: "updateSettingsForExport",
        value: function updateSettingsForExport(settings, chartData, config) {
            var scales = this._getChartScales(config);
            settings["fontSize"] *= scales.common;
            settings["outlineThickness"] *= scales.common;
            settings["maxLabelWidth"] *= scales.horizontal;
            settings["radius"] *= scales.common;
            settings["innerRadius"] *= scales.common;
        }
    }, {
        key: "_createLabelFunction",
        value: function _createLabelFunction() {
            return function (slice) {
                return slice.dataContext.category.substring(0, 65);
            };
        }
    }, {
        key: "_createBalloonFunction",
        value: function _createBalloonFunction() {
            var numberFormatter = new _number_formatter2.default(window.SystemSettings.decimalSeparator, window.SystemSettings.digitGroupingSymbol, 2, true);
            var balloonTemplate = _underscore2.default.template("<div class='cpChartsBalloon'>" + "   <span class='category'><%=category%></span>" + "   <div class='values'><span class='value'><%=value%></span> <span>(<%=percents%>%)</span></div>" + "</div>");
            return function (item) {
                return balloonTemplate({
                    "category": (0, _atUtils.escapeHtmlSymbols)(item.dataContext.category),
                    "value": _user_time2.default.formatTime(item.dataContext.value),
                    "percents": numberFormatter.format(item.percents)
                });
            };
        }
    }, {
        key: "makeChart",
        value: function makeChart(container, settings) {
            this._chart = _amcharts2.default.makeChart(container, settings, 10);
        }
    }, {
        key: "resizePieChart",
        value: function resizePieChart(marginTop, marginBottom) {
            this._chart.marginTop = marginTop;
            this._chart.marginBottom = marginBottom;
            this._redrawChart();
        }
    }, {
        key: "rescalePieChartForExport",
        value: function rescalePieChartForExport(marginTop, marginBottom, chartSize) {
            var scale = (chartSize["height"] - marginTop - marginBottom) / chartSize["height"];
            this._chart.radius *= scale;
            this._chart.innerRadius *= scale;
            this._chart.fontSize *= scale;
            this._chart.outlineThickness *= scale;
            this._redrawChart();
        }
    }, {
        key: "_redrawChart",
        value: function _redrawChart() {
            this._chart.validateNow(); // redraw chart and force 'onRendered' event
        }
    }, {
        key: "removeReferenceOnChart",
        value: function removeReferenceOnChart() {
            this._chart = null;
        }
    }]);

    return PieChartGenerator;
}(_ChartGenerator3.default);

exports.default = PieChartGenerator;

/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var AmCharts = window.AmCharts;
exports.default = AmCharts;

/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _BlockedList2 = __webpack_require__(1376);

var _BlockedList3 = _interopRequireDefault(_BlockedList2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BlockedTasksList = function (_BlockedList) {
    _inherits(BlockedTasksList, _BlockedList);

    function BlockedTasksList($containerEl, entities, otherBlockedTaskCount) {
        _classCallCheck(this, BlockedTasksList);

        var _this = _possibleConstructorReturn(this, (BlockedTasksList.__proto__ || Object.getPrototypeOf(BlockedTasksList)).call(this, $containerEl, entities));

        _this.otherBlockedTaskCount = otherBlockedTaskCount;
        return _this;
    }

    _createClass(BlockedTasksList, [{
        key: "getEntitySubtitle",
        value: function getEntitySubtitle(entity) {
            return CustomerStore.get(entity.customerId).name + " / " + ProjectStore.get(entity.projectId).name;
        }
    }, {
        key: "getEntityTitle",
        value: function getEntityTitle(entity) {
            return entity.name;
        }
    }, {
        key: "additionListItems",
        value: function additionListItems() {
            if (this.otherBlockedTaskCount == 0) return [];else if (this.otherBlockedTaskCount == 1) return [{ title: messageResource.getMessage("delete.confirm.dialog.can_not_deleted.other_task") }];else return [{ title: messageResource.getMessage("delete.confirm.dialog.can_not_deleted.other_tasks", [this.otherBlockedTaskCount]) }];
        }
    }]);

    return BlockedTasksList;
}(_BlockedList3.default);

exports.default = BlockedTasksList;

/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ItemRow = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView3 = __webpack_require__(1);

var _TemplateView4 = _interopRequireDefault(_TemplateView3);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _TokensHighlighter = __webpack_require__(94);

var _atUtils = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SearchItemList = function (_TemplateView) {
    _inherits(SearchItemList, _TemplateView);

    function SearchItemList(_ref) {
        var _ref$itemRenderer = _ref.itemRenderer,
            itemRenderer = _ref$itemRenderer === undefined ? function (item, tokensHighlighter) {} : _ref$itemRenderer,
            _ref$additionalItemRe = _ref.additionalItemRenderer,
            additionalItemRenderer = _ref$additionalItemRe === undefined ? function (item) {} : _ref$additionalItemRe,
            _ref$notFoundMessageK = _ref.notFoundMessageKey,
            notFoundMessageKey = _ref$notFoundMessageK === undefined ? '' : _ref$notFoundMessageK,
            _ref$hiddenItemsColla = _ref.hiddenItemsCollapsedMessageKey,
            hiddenItemsCollapsedMessageKey = _ref$hiddenItemsColla === undefined ? '' : _ref$hiddenItemsColla,
            _ref$hiddenItemsExpan = _ref.hiddenItemsExpandedMessageKey,
            hiddenItemsExpandedMessageKey = _ref$hiddenItemsExpan === undefined ? '' : _ref$hiddenItemsExpan;

        _classCallCheck(this, SearchItemList);

        var _this = _possibleConstructorReturn(this, (SearchItemList.__proto__ || Object.getPrototypeOf(SearchItemList)).call(this));

        _this.props = {
            itemRenderer: itemRenderer,
            additionalItemRenderer: additionalItemRenderer,
            notFoundMessageKey: notFoundMessageKey,
            hiddenItemsCollapsedMessageKey: hiddenItemsCollapsedMessageKey,
            hiddenItemsExpandedMessageKey: hiddenItemsExpandedMessageKey
        };

        _this.state = {
            items: [],
            hiddenItems: [],
            additionalItems: [],
            searchText: '',
            hiddenItemsCollapsed: true,
            selectedItemId: -1
        };

        _this.onAnyStatePropertyDeeplyChanged(['items', 'additionalItems', 'hiddenItems', 'searchText', 'hiddenItemsCollapsed', 'selectedItemId'], function () {
            _this._renderList(_this.state.items, _this.state.hiddenItems, _this.state.additionalItems, _this.state.searchText);
        });

        return _this;
    }

    _createClass(SearchItemList, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class="searchItemList">' + '</div>';
        }
    }, {
        key: '_renderList',
        value: function _renderList(items, hiddenItems, additionalItems, searchText) {
            var _this2 = this;

            this.getEl().empty();

            var tokensHighlighter = (0, _TokensHighlighter.createTokensHighlighterForSearch)(searchText);

            var renderedItems = [];

            if (!this.state.searchText) {
                renderedItems.push.apply(renderedItems, _toConsumableArray(additionalItems.map(function (i) {
                    return _this2.props.additionalItemRenderer(i);
                })));
            }

            if (items.length + renderedItems.length === 0 && (this.state.hiddenItemsCollapsed || hiddenItems.length === 0)) {
                renderedItems.push(this._createNoItemsFound());
            }

            renderedItems.push.apply(renderedItems, _toConsumableArray(items.map(function (i) {
                return _this2.props.itemRenderer(i, tokensHighlighter);
            })));

            if (hiddenItems.length > 0) {
                renderedItems.push(this._createHiddenItemsButton(hiddenItems.length, this.state.hiddenItemsCollapsed));

                if (!this.state.hiddenItemsCollapsed) {
                    renderedItems.push.apply(renderedItems, _toConsumableArray(hiddenItems.map(function (i) {
                        return _this2.props.itemRenderer(i, tokensHighlighter);
                    })));
                }
            }

            renderedItems.forEach(function (item) {
                return item.init(_this2.getEl());
            });
        }
    }, {
        key: '_createNoItemsFound',
        value: function _createNoItemsFound() {
            return new ItemRow({
                name: _messageResource2.default.getMessage(this.props.notFoundMessageKey),
                additionalClass: 'notFound'
            });
        }
    }, {
        key: '_createHiddenItemsButton',
        value: function _createHiddenItemsButton(hiddenItemsNum, collapsed) {
            var _this3 = this;

            return new ItemRow({
                name: _messageResource2.default.getEscapedMessage(collapsed ? this.props.hiddenItemsCollapsedMessageKey : this.props.hiddenItemsExpandedMessageKey, [hiddenItemsNum]),
                clickCallback: function clickCallback() {
                    (0, _atUtils.defer)(function () {
                        return _this3.setState({
                            hiddenItemsCollapsed: !collapsed
                        });
                    }, _this3);
                },
                mousedownCallback: function mousedownCallback(event) {
                    return event.preventDefault();
                },
                additionalClass: 'collapseHiddenButton'
            });
        }
    }]);

    return SearchItemList;
}(_TemplateView4.default);

exports.default = SearchItemList;

var ItemRow = exports.ItemRow = function (_TemplateView2) {
    _inherits(ItemRow, _TemplateView2);

    function ItemRow(_ref2) {
        var _ref2$name = _ref2.name,
            name = _ref2$name === undefined ? '' : _ref2$name,
            _ref2$clickCallback = _ref2.clickCallback,
            clickCallback = _ref2$clickCallback === undefined ? function () {} : _ref2$clickCallback,
            _ref2$mousedownCallba = _ref2.mousedownCallback,
            mousedownCallback = _ref2$mousedownCallba === undefined ? function (e) {} : _ref2$mousedownCallba,
            _ref2$additionalClass = _ref2.additionalClass,
            additionalClass = _ref2$additionalClass === undefined ? '' : _ref2$additionalClass;

        _classCallCheck(this, ItemRow);

        var _this4 = _possibleConstructorReturn(this, (ItemRow.__proto__ || Object.getPrototypeOf(ItemRow)).call(this));

        _this4.params = {
            name: name,
            clickCallback: clickCallback,
            mousedownCallback: mousedownCallback,
            additionalClass: additionalClass
        };
        return _this4;
    }

    _createClass(ItemRow, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class="itemRow <%-additionalClass%>"><%=name%></div>';
        }
    }, {
        key: 'templateModel',
        value: function templateModel() {
            return {
                additionalClass: this.params.additionalClass,
                name: this.params.name
            };
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            var _this5 = this;

            this.$el.click(function () {
                return _this5.params.clickCallback();
            });
            this.$el.mousedown(function (e) {
                return _this5.params.mousedownCallback(e);
            });
        }
    }]);

    return ItemRow;
}(_TemplateView4.default);

/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _SimpleSingletonTooltip = __webpack_require__(45);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PermissionIcons = function (_TemplateView) {
    _inherits(PermissionIcons, _TemplateView);

    function PermissionIcons(_ref) {
        var _ref$manageUsers = _ref.manageUsers,
            manageUsers = _ref$manageUsers === undefined ? false : _ref$manageUsers,
            _ref$modifyTimeTrack = _ref.modifyTimeTrack,
            modifyTimeTrack = _ref$modifyTimeTrack === undefined ? false : _ref$modifyTimeTrack,
            _ref$manageScope = _ref.manageScope,
            manageScope = _ref$manageScope === undefined ? false : _ref$manageScope,
            _ref$costReports = _ref.costReports,
            costReports = _ref$costReports === undefined ? false : _ref$costReports,
            _ref$showCostReports = _ref.showCostReports,
            showCostReports = _ref$showCostReports === undefined ? false : _ref$showCostReports,
            _ref$modifyTimeTrackT = _ref.modifyTimeTrackTooltipText,
            modifyTimeTrackTooltipText = _ref$modifyTimeTrackT === undefined ? "" : _ref$modifyTimeTrackT,
            _ref$costReportsToolt = _ref.costReportsTooltipText,
            costReportsTooltipText = _ref$costReportsToolt === undefined ? "" : _ref$costReportsToolt;

        _classCallCheck(this, PermissionIcons);

        var _this = _possibleConstructorReturn(this, (PermissionIcons.__proto__ || Object.getPrototypeOf(PermissionIcons)).call(this));

        _this.manageUsers = manageUsers;
        _this.modifyTimeTrack = modifyTimeTrack;
        _this.manageScope = manageScope;
        _this.costReports = costReports;
        _this.showCostReports = showCostReports;
        _this.costReportsTooltipText = costReportsTooltipText;
        _this.modifyTimeTrackTooltipText = modifyTimeTrackTooltipText;
        return _this;
    }

    _createClass(PermissionIcons, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return "<div class='permissionIcons'>" + "  <div class='manageUsers icon'></div>" + "  <div class='modifyTimeTrack icon'></div>" + "  <div class='manageScope icon'></div>" + "  <div class='iconWrapper'>" + "    <div class='costReports icon'></div>" + "  </div>" + "</div>";
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            var _this2 = this;

            this.$el.toggleClass("hasManageUsers", this.manageUsers);
            this.$el.toggleClass("hasModifyTimeTrack", this.modifyTimeTrack);
            this.$el.toggleClass("hasManageScope", this.manageScope);

            this.find(".costReports").toggle(this.showCostReports);

            this.permissionNameTooltip = (0, _SimpleSingletonTooltip.getInstance)();

            this.permissionNameTooltip.subscribeToMouseEvents(this.find('.manageUsers'), function () {
                _this2.permissionNameTooltip.setState({
                    text: _messageResource2.default.getMessage('access_rights.manage_users'),
                    extraClass: ''
                });
            });
            this.permissionNameTooltip.subscribeToMouseEvents(this.find('.modifyTimeTrack'), function () {
                _this2.permissionNameTooltip.setState({
                    text: _this2.modifyTimeTrackTooltipText,
                    extraClass: ''
                });
            });
            this.permissionNameTooltip.subscribeToMouseEvents(this.find('.manageScope'), function () {
                _this2.permissionNameTooltip.setState({
                    text: _messageResource2.default.getMessage('access_rights.edit_hierarchy'),
                    extraClass: ''
                });
            });
            if (this.showCostReports) {
                this.$el.toggleClass("hasCostReports", this.costReports);
                this.permissionNameTooltip.subscribeToMouseEvents(this.find('.costReports'), function () {
                    _this2.permissionNameTooltip.setState({
                        text: _this2.costReportsTooltipText,
                        extraClass: ''
                    });
                });
            }
        }
    }]);

    return PermissionIcons;
}(_TemplateView3.default);

exports.default = PermissionIcons;

/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _DisabledNodesParentNodeRenderer = __webpack_require__(353);

var _DisabledNodesParentNodeRenderer2 = _interopRequireDefault(_DisabledNodesParentNodeRenderer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DisabledUsersParentNodeRenderer = function (_DisabledNodesParentN) {
    _inherits(DisabledUsersParentNodeRenderer, _DisabledNodesParentN);

    function DisabledUsersParentNodeRenderer() {
        _classCallCheck(this, DisabledUsersParentNodeRenderer);

        return _possibleConstructorReturn(this, (DisabledUsersParentNodeRenderer.__proto__ || Object.getPrototypeOf(DisabledUsersParentNodeRenderer)).apply(this, arguments));
    }

    _createClass(DisabledUsersParentNodeRenderer, [{
        key: "labelMessageKey",
        value: function labelMessageKey() {
            return "users_selector.disabled_users_parent_node_label";
        }
    }]);

    return DisabledUsersParentNodeRenderer;
}(_DisabledNodesParentNodeRenderer2.default);

exports.default = DisabledUsersParentNodeRenderer;

/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _DeleteConfirmationDialog = __webpack_require__(499);

var _DeleteConfirmationDialog2 = _interopRequireDefault(_DeleteConfirmationDialog);

var _BlockedTasksList = __webpack_require__(773);

var _BlockedTasksList2 = _interopRequireDefault(_BlockedTasksList);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DeleteTasksConfirmationDialog = function (_DeleteConfirmationDi) {
    _inherits(DeleteTasksConfirmationDialog, _DeleteConfirmationDi);

    function DeleteTasksConfirmationDialog($container, cancelHandler, deleteHandler) {
        _classCallCheck(this, DeleteTasksConfirmationDialog);

        return _possibleConstructorReturn(this, (DeleteTasksConfirmationDialog.__proto__ || Object.getPrototypeOf(DeleteTasksConfirmationDialog)).call(this, $container, cancelHandler, deleteHandler));
    }

    _createClass(DeleteTasksConfirmationDialog, [{
        key: "show",
        value: function show() {
            _get(DeleteTasksConfirmationDialog.prototype.__proto__ || Object.getPrototypeOf(DeleteTasksConfirmationDialog.prototype), "show", this).call(this);
            this.savingState = false;
            this.$el.removeClass("savingState");
        }
    }, {
        key: "createBlockedEntitiesList",
        value: function createBlockedEntitiesList() {
            var otherBlockedTaskCount = this.state.entitiesBlockedCount - this.state.entitiesBlocked.length;
            return new _BlockedTasksList2.default((0, _jquery2.default)("body"), this.state.entitiesBlocked, otherBlockedTaskCount).init();
        }
    }, {
        key: "titleText",
        value: function titleText() {
            if (this.allBlocked()) {
                return _messageResource2.default.getMessage("delete.confirm.dialog.task.all_blocked.title", [_messageResource2.default.getMessage(this.state.entitiesToDeleteCount > 1 ? "common.tasks" : "common.task")]);
            } else {
                if (this.state.entitiesToDeleteCount > 1) return _messageResource2.default.getMessage("delete.confirm.dialog.about_to_delete.more_one", [this.state.entitiesToDeleteCount]);else return _messageResource2.default.getMessage("delete.confirm.dialog.about_to_delete.one_task");
            }
        }
    }, {
        key: "firstOrangeSentence",
        value: function firstOrangeSentence() {
            if (this.allBlocked()) {
                return this.blockedWarningOtherText();
            } else {
                if (this.hasTimeTrack()) {
                    return _messageResource2.default.getMessage("delete.confirm.dialog.about_to_delete.warning");
                } else {
                    return _messageResource2.default.getMessage("delete.confirm.dialog.about_to_delete", [this._getTaskOrTasksText()]);
                }
            }
        }
    }, {
        key: "secondOrangeSentence",
        value: function secondOrangeSentence() {
            if (this.allBlocked()) {
                return "";
            } else {
                if (this.hasTimeTrack()) return _messageResource2.default.getMessage("delete.confirm.dialog.about_to_delete.confirm");else return _messageResource2.default.getMessage("delete.confirm.dialog.about_to_delete.warning");
            }
        }
    }, {
        key: "removeEntitiesPointText",
        value: function removeEntitiesPointText() {
            return _messageResource2.default.getMessage("delete.confirm.dialog.about_remove_task", [this._getTaskOrTasksText()]);
        }
    }, {
        key: "removeTimeTrackPointText",
        value: function removeTimeTrackPointText() {
            return _messageResource2.default.getMessage("delete.confirm.dialog.about_remove_time_track", [this._getTaskOrTasksText()]);
        }
    }, {
        key: "blockedWarningLinkText",
        value: function blockedWarningLinkText() {
            return _messageResource2.default.getMessage("delete.confirm.dialog.task.blocked_warning_link_text");
        }
    }, {
        key: "blockedWarningOtherText",
        value: function blockedWarningOtherText() {
            if (this.state.entitiesBlockedDueToLockedTimeCount > 0 && this.state.entitiesBlockedDueToUnavailableToModifyTimeTrackCount === 0) {
                if (this.state.entitiesBlockedDueToLockedTimeCount === 1) return _messageResource2.default.getMessage("delete.confirm.dialog.task.blocked_warning_other_text.one_locked");
                return _messageResource2.default.getMessage("delete.confirm.dialog.task.blocked_warning_other_text.locked");
            } else if (this.state.entitiesBlockedDueToLockedTimeCount === 0 && this.state.entitiesBlockedDueToUnavailableToModifyTimeTrackCount > 0) {
                if (this.state.entitiesBlockedDueToUnavailableToModifyTimeTrackCount === 1) return _messageResource2.default.getMessage("delete.confirm.dialog.task.blocked_warning_other_text.cannot_modify_one_task");
                return _messageResource2.default.getMessage("delete.confirm.dialog.task.blocked_warning_other_text.cannot_modify");
            } else if (this.state.entitiesBlockedDueToLockedTimeCount > 0 && this.state.entitiesBlockedDueToUnavailableToModifyTimeTrackCount > 0) {
                if (this.state.entitiesBlockedCount === 1) return _messageResource2.default.getMessage("delete.confirm.dialog.task.blocked_warning_other_text.locked_and_cannot_modify_one_task");
                return _messageResource2.default.getMessage("delete.confirm.dialog.task.blocked_warning_other_text.locked_and_cannot_modify");
            }
            return "";
        }
    }, {
        key: "deleteButtonText",
        value: function deleteButtonText() {
            if (this.state.entitiesWithOtherUsersTimeTrackCount > 0 || this.state.entitiesWithManagerTimeTrackCount > 0) {
                return _messageResource2.default.getMessage("delete.confirm.dialog.delete_task_with_entries");
            } else {
                return _messageResource2.default.getMessage("delete.confirm.dialog.delete_task_permanently");
            }
        }
    }, {
        key: "_getTaskOrTasksText",
        value: function _getTaskOrTasksText() {
            return _messageResource2.default.getMessage(this.state.entitiesToDeleteCount - this.state.entitiesBlockedCount === 1 ? "delete.confirm.dialog.this_task" : "delete.confirm.dialog.these_tasks");
        }
    }]);

    return DeleteTasksConfirmationDialog;
}(_DeleteConfirmationDialog2.default);

exports.default = DeleteTasksConfirmationDialog;

/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _Button = __webpack_require__(33);

var _Button2 = _interopRequireDefault(_Button);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CreateFooter = function (_TemplateView) {
    _inherits(CreateFooter, _TemplateView);

    function CreateFooter(_ref) {
        var _ref$additionalClass = _ref.additionalClass,
            additionalClass = _ref$additionalClass === undefined ? '' : _ref$additionalClass,
            _ref$submitBtnLabelMs = _ref.submitBtnLabelMsgKey,
            submitBtnLabelMsgKey = _ref$submitBtnLabelMs === undefined ? '' : _ref$submitBtnLabelMs,
            _ref$withPlusIcon = _ref.withPlusIcon,
            withPlusIcon = _ref$withPlusIcon === undefined ? false : _ref$withPlusIcon,
            _ref$onSubmitCb = _ref.onSubmitCb,
            onSubmitCb = _ref$onSubmitCb === undefined ? function () {} : _ref$onSubmitCb,
            _ref$onCancelCb = _ref.onCancelCb,
            onCancelCb = _ref$onCancelCb === undefined ? function () {} : _ref$onCancelCb;

        _classCallCheck(this, CreateFooter);

        var _this = _possibleConstructorReturn(this, (CreateFooter.__proto__ || Object.getPrototypeOf(CreateFooter)).call(this, null));

        _this.callbacks = {
            onSubmitCb: onSubmitCb,
            onCancelCb: onCancelCb
        };

        _this.params = {
            submitBtnLabelMsgKey: submitBtnLabelMsgKey,
            withPlusIcon: withPlusIcon,
            additionalClass: additionalClass
        };

        _this.state = {
            hasErrors: false,
            saving: false
        };

        _this.onStatePropertyChanged("hasErrors", function (hasErrors) {
            _this.errorMessageBox.toggle(hasErrors);
        });

        _this.onStatePropertyChanged("saving", function (saving) {
            _this.find(".savingMsg").toggleClass('invisible', !saving);
            _this.submitButton.setState({ disabled: saving });
            _this.cancelButton.setState({ disabled: saving });
        });
        return _this;
    }

    _createClass(CreateFooter, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class="createPanel_footer <%=additionalClass%>">' + '    <div class="errorMessageBox">' + '        <div class="errorIcon"/>' + '        <span class="errormsg"><%-errorMsg%></span>' + '    </div>' + '    <div class="changesBox">' + '        <span class="savingMsg invisible"><%-savingMsg%></span>' + '    </div>' + '    <div class="buttonsBox"/>' + '</div>';
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            var _this2 = this;

            this.errorMessageBox = this.find(".errorMessageBox");
            var $buttonsBox = this.find(".buttonsBox");

            this.submitButton = new _Button2.default({
                additionalClass: 'submitBtn',
                withPlusIcon: this.params.withPlusIcon,
                label: _messageResource2.default.getMessage(this.params.submitBtnLabelMsgKey),
                onClickCb: function onClickCb() {
                    if (!_this2.state.saving) _this2.callbacks.onSubmitCb();
                }
            }).init($buttonsBox);

            this.cancelButton = new _Button2.default({
                additionalClass: 'cancelBtn',
                label: _messageResource2.default.getMessage('common.cancel'),
                onClickCb: function onClickCb() {
                    if (!_this2.state.saving) _this2.callbacks.onCancelCb();
                }
            }).init($buttonsBox);

            this.renderInitialState();
        }
    }, {
        key: 'messageKeys',
        value: function messageKeys() {
            return {
                errorMsg: 'user.add_edit.js.footer_error.exist_invalid_fields',
                changesMsg: 'user.add_edit.not_saved',
                savingMsg: 'user.add_edit.saving'
            };
        }
    }, {
        key: 'templateModel',
        value: function templateModel() {
            return {
                additionalClass: this.params.additionalClass
            };
        }
    }]);

    return CreateFooter;
}(_TemplateView3.default);

exports.default = CreateFooter;

/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TaskStatusMenu2 = __webpack_require__(289);

var _TaskStatusMenu3 = _interopRequireDefault(_TaskStatusMenu2);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _WorkflowStatusSelector = __webpack_require__(768);

var _WorkflowStatusSelector2 = _interopRequireDefault(_WorkflowStatusSelector);

var _constants = __webpack_require__(23);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CompletedTaskStatusMenu = function (_TaskStatusMenu) {
    _inherits(CompletedTaskStatusMenu, _TaskStatusMenu);

    function CompletedTaskStatusMenu() {
        _classCallCheck(this, CompletedTaskStatusMenu);

        return _possibleConstructorReturn(this, (CompletedTaskStatusMenu.__proto__ || Object.getPrototypeOf(CompletedTaskStatusMenu)).apply(this, arguments));
    }

    _createClass(CompletedTaskStatusMenu, [{
        key: "afterRender",
        value: function afterRender() {
            var _this2 = this;

            this.statusesSelector = new _WorkflowStatusSelector2.default({
                typeFilter: _constants.WorkflowStatusType.COMPLETED,
                onSelectStatus: function onSelectStatus(id) {
                    _this2._selectStatus(id);
                },
                groupByStatusType: false
            }).init(this.$el);

            this.getEl().on('click', function (e) {
                return e.stopPropagation();
            });
        }
    }]);

    return CompletedTaskStatusMenu;
}(_TaskStatusMenu3.default);

exports.default = CompletedTaskStatusMenu;

/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _MenuButton2 = __webpack_require__(484);

var _MenuButton3 = _interopRequireDefault(_MenuButton2);

var _CustomerStatusMenu = __webpack_require__(1400);

var _CustomerStatusMenu2 = _interopRequireDefault(_CustomerStatusMenu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CustomerStatusButton = function (_MenuButton) {
    _inherits(CustomerStatusButton, _MenuButton);

    function CustomerStatusButton() {
        _classCallCheck(this, CustomerStatusButton);

        return _possibleConstructorReturn(this, (CustomerStatusButton.__proto__ || Object.getPrototypeOf(CustomerStatusButton)).apply(this, arguments));
    }

    _createClass(CustomerStatusButton, [{
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='customerStatusButton'>" + "  <div class='active'>" + "    <%-active%>" + "    <div class='downIcon'>&nbsp;</div>" + "  </div>" + "  <div class='archived'>" + "    <%-archived%>" + "    <div class='downIcon'>&nbsp;</div>" + "  </div>" + "</div>";
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            _MenuButton3.default.prototype.afterRender.call(this);
            this.active = false;
            this.inactiveOpenStatus = false;
        }
    }, {
        key: "update",
        value: function update() {
            _MenuButton3.default.prototype.update.call(this);
            this.$el.toggleClass("active", this.active);
            this.$el.toggleClass("archived", !this.active);
            this.$el.toggleClass("disabled", this.disabled);
        }
    }, {
        key: "messageKeys",
        value: function messageKeys() {
            return {
                active: "customer.edit.status.active",
                archived: "customer.edit.status.archived"
            };
        }
    }, {
        key: "isActive",
        value: function isActive() {
            return this.active;
        }
    }, {
        key: "setActive",
        value: function setActive(isActive) {
            this.active = isActive;
            this.update();
        }
    }, {
        key: "setInactiveOpenStatus",
        value: function setInactiveOpenStatus(inactiveOpenStatus) {
            this.inactiveOpenStatus = inactiveOpenStatus;
        }
    }, {
        key: "getMenu",
        value: function getMenu() {
            var menu = new _CustomerStatusMenu2.default(this._getContainerEl()).init();
            menu.setActive(this.active);
            menu.setInactiveOpenStatus(this.inactiveOpenStatus);
            return menu;
        }
    }, {
        key: "_change",
        value: function _change(active) {
            if (this.active !== active) {
                this.active = active;
                return true;
            }
            return false;
        }
    }]);

    return CustomerStatusButton;
}(_MenuButton3.default);

exports.default = CustomerStatusButton;

/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _TaskStatusButton = __webpack_require__(240);

var _TaskStatusButton2 = _interopRequireDefault(_TaskStatusButton);

var _CompletedTaskStatusMenu = __webpack_require__(779);

var _CompletedTaskStatusMenu2 = _interopRequireDefault(_CompletedTaskStatusMenu);

var _selectors = __webpack_require__(57);

var _utils = __webpack_require__(6);

var _constants = __webpack_require__(23);

var _pluralizeUtils = __webpack_require__(40);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ArchiveDialog = function (_TemplateView) {
    _inherits(ArchiveDialog, _TemplateView);

    function ArchiveDialog($container, typeTitle) {
        _classCallCheck(this, ArchiveDialog);

        var _this = _possibleConstructorReturn(this, (ArchiveDialog.__proto__ || Object.getPrototypeOf(ArchiveDialog)).call(this, $container));

        _this.typeTitle = typeTitle;

        _this.state = {
            openTaskNumber: 0,
            canEditTaskStatus: true,
            statusId: (0, _utils.unsafe_selectWithState)(function (state) {
                return (0, _selectors.selectFirstStatusByType)(state, _constants.WorkflowStatusType.COMPLETED).id;
            })
        };

        _this.onStatePropertyChanged("openTaskNumber", function () {
            return _this.updateMessages();
        });
        _this.onStatePropertyChanged("canEditTaskStatus", function (canEditTaskStatus) {
            if (_this.taskStatusButton && _this.taskStatusButton.setEditable) {
                _this.taskStatusButton.setEditable(canEditTaskStatus);
            }
        });
        _this.onStatePropertyChanged("statusId", function () {
            return _this.taskStatusButton.setState({ statusId: _this.state.statusId });
        });
        return _this;
    }

    _createClass(ArchiveDialog, [{
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='archiveDialog'>" + "  <div class='title'><%-title%></div>" + "  <div class='description'></div>" + "  <div class='statusSelector'></div>" + "  <div class='buttonsContainer'>" + "    <div class='archive button'><%=archive%></div>" + "    <div class='cancel button'><%=cancel%></div>" + "  </div> " + "</div>";
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            var _this2 = this;

            this.$archiveButton = this.find(".archive");
            this.$cancelButton = this.find(".cancel");
            this.$statusSelector = this.find(".statusSelector");
            this.taskStatusButton = new _TaskStatusButton2.default({
                editable: this.state.canEditTaskStatus,
                taskStatusMenu: new _CompletedTaskStatusMenu2.default(this.getEl()).init(),
                showStatusTypePrefix: true,
                positionParams: {
                    within: this.$el,
                    collision: 'fit'
                },
                onStatusChangedCb: function onStatusChangedCb(statusId) {
                    return _this2.setState({
                        statusId: statusId
                    });
                }
            }).init(this.$statusSelector);

            this.taskStatusButton.setState({ statusId: this.state.statusId });
            this.$description = this.find(".description");
            this.$archiveButton.click(function () {
                return _this2.trigger("archived", _this2.getSelectedStatusId());
            });
            this.$cancelButton.click(function () {
                return _this2.trigger("cancel", []);
            });
        }
    }, {
        key: "templateModel",
        value: function templateModel() {
            return {
                title: _messageResource2.default.getMessage("task.list.panel.archive_dialog.title", [this.typeTitle])
            };
        }
    }, {
        key: "getSelectedStatusId",
        value: function getSelectedStatusId() {
            return this.taskStatusButton.state.statusId;
        }
    }, {
        key: "updateMessages",
        value: function updateMessages() {
            this.$description.text(_messageResource2.default.getMessage("task.list.panel.archive_dialog.description", [this.state.openTaskNumber, (0, _pluralizeUtils.taskNameLower)(this.state.openTaskNumber)]));
        }
    }, {
        key: "messageKeys",
        value: function messageKeys() {
            return {
                archive: "common.archive",
                cancel: "common.cancel"
            };
        }
    }]);

    return ArchiveDialog;
}(_TemplateView3.default);

exports.default = ArchiveDialog;

/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.loadEditTaskPanelData = exports.handleFeatureChange = undefined;

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _utils = __webpack_require__(118);

var _actions = __webpack_require__(81);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var handleFeatureChange = exports.handleFeatureChange = function handleFeatureChange(changedFeatures) {
    return function () {
        var message = (0, _utils.getFeaturesChangesMessage)(changedFeatures).concat(_messageResource2.default.getMessage('common.interface_will_reloaded'));
        alert(message);
        window.location.reload();
    };
};

var taskPanelErrorHandler = function taskPanelErrorHandler(taskId, error) {
    if (error.errorThrown.exception === "com.actimind.actitime.task.NoSuchTaskException") {
        alert(_messageResource2.default.getMessage("task.error.concurrently_deleted.cannot_edit"));
        error.handle();
        window.location.reload();
    }

    if (error.errorThrown.exception === "com.actimind.actitime.services.EditTaskService$NoRightsToManageTaskException") {
        alert(_messageResource2.default.getMessage("task.edit_popup.no_rights_to_manage_tasks"));
        error.handle();
        window.location.reload();
    }

    if (error.errorThrown.exception === "com.actimind.actitime.task.TaskIsNotAssignedToUserException") {
        alert(_messageResource2.default.getMessage("task.error.task_not_assigned"));
        error.handle();
        window.location.reload();
    }

    if (error.errorThrown.exception === 'com.actimind.actitime.services.NoRightToEditHierarchyException') {
        alert(_messageResource2.default.getMessage('common.no_rights_for_operation_anymore'));
        error.handle();
        window.location.reload();
    }

    return error.isHandled();
};

var loadEditTaskPanelData = exports.loadEditTaskPanelData = (0, _actions.loadEditTaskPanelDataAction)(taskPanelErrorHandler);

/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _TaskPanelContainer2 = __webpack_require__(784);

var _TaskPanelContainer3 = _interopRequireDefault(_TaskPanelContainer2);

var _EditTaskPanel = __webpack_require__(1407);

var _EditTaskPanel2 = _interopRequireDefault(_EditTaskPanel);

var _constants = __webpack_require__(62);

var _constants2 = __webpack_require__(4);

var _NextBridge = __webpack_require__(376);

var _NextBridge2 = _interopRequireDefault(_NextBridge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EditTaskPanelContainer = function (_TaskPanelContainer) {
    _inherits(EditTaskPanelContainer, _TaskPanelContainer);

    function EditTaskPanelContainer() {
        var parameters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
            scheduleCalculator: null,
            onPanelHide: function onPanelHide() {},
            onTaskDeletedCb: function onTaskDeletedCb() {},
            onTaskMovedCb: function onTaskMovedCb() {},
            datePickerMenu: null,
            needToHideOnOutsideClick: true,
            needShowMoire: false
        };

        _classCallCheck(this, EditTaskPanelContainer);

        var _this = _possibleConstructorReturn(this, (EditTaskPanelContainer.__proto__ || Object.getPrototypeOf(EditTaskPanelContainer)).call(this, _extends({}, parameters, {
            additionalClass: 'edit_task_sliding_panel sliding_panel',
            panelContent: new _EditTaskPanel2.default({
                showComments: true,
                showReportTab: true,
                showActions: true,
                dateFormat: Date.convertSmartToExtDateFormat(window.SystemSettings.dateFormat).replace(/F/, "M"),
                datePickerMenu: parameters.datePickerMenu,
                onTaskDeletedCb: parameters.onTaskDeletedCb,
                onTaskMovedCb: parameters.onTaskMovedCb
            }),
            panelType: _constants.PANEL_TYPES.EDIT_TASK,
            onPanelHideCb: function onPanelHideCb() {
                return parameters.onPanelHide(_this.state.openTaskId);
            }
        })));

        _this.state = _extends({}, _get(EditTaskPanelContainer.prototype.__proto__ || Object.getPrototypeOf(EditTaskPanelContainer.prototype), 'state', _this), {
            openTaskId: null,
            openTaskNextId: null,
            isOpenTaskCompleted: false,
            userRights: [],
            isTSTEnabled: false
        });

        _this.onStatePropertyChanged('openTaskNextId', function () {
            return _this.addTaskToTimesheet.setProps({ taskId: _this.state.openTaskNextId });
        });

        _this.onStatePropertyBecameValue('isShown', false, function () {
            return _NextBridge2.default.listeners.taskPanelClosed.forEach(function (handler) {
                return handler();
            });
        });

        _this.onAnyStatePropertyChanged(['isOpenTaskCompleted', 'userRights', 'isTSTEnabled'], function () {
            var showAddToTimesheet = _this.state.isTSTEnabled && !_this.state.isOpenTaskCompleted && _this.state.userRights[_constants2.AccessRights.SUBMIT_TIME_TRACK];

            showAddToTimesheet ? _this.$addTaskToTimesheet.show() : _this.$addTaskToTimesheet.hide();
        });

        return _this;
    }

    _createClass(EditTaskPanelContainer, [{
        key: 'afterRender',
        value: function afterRender() {
            _get(EditTaskPanelContainer.prototype.__proto__ || Object.getPrototypeOf(EditTaskPanelContainer.prototype), 'afterRender', this).call(this);

            this.$addTaskToTimesheet = $('<div/>').addClass('addTaskToTimesheet_panelContainer atNextMount');
            this.$addTaskToTimesheet.appendTo(this.$headerButtons);

            this.addTaskToTimesheet = window.ClassicBridge.integrateAddTaskToTimesheetButton(this.$addTaskToTimesheet[0], {
                taskNextId: this.state.taskNextId
            });
        }
    }]);

    return EditTaskPanelContainer;
}(_TaskPanelContainer3.default);

exports.default = EditTaskPanelContainer;

/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _View2 = __webpack_require__(20);

var _View3 = _interopRequireDefault(_View2);

var _LoadingContainer = __webpack_require__(28);

var _LoadingContainer2 = _interopRequireDefault(_LoadingContainer);

var _PanelContainer = __webpack_require__(109);

var _PanelContainer2 = _interopRequireDefault(_PanelContainer);

var _constants = __webpack_require__(62);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TaskPanelContainer = function (_View) {
    _inherits(TaskPanelContainer, _View);

    function TaskPanelContainer(_ref) {
        var additionalClass = _ref.additionalClass,
            panelContent = _ref.panelContent,
            _ref$panelType = _ref.panelType,
            panelType = _ref$panelType === undefined ? '' : _ref$panelType,
            _ref$reloadComments = _ref.reloadComments,
            reloadComments = _ref$reloadComments === undefined ? function () {} : _ref$reloadComments,
            _ref$openPanel = _ref.openPanel,
            openPanel = _ref$openPanel === undefined ? function () {} : _ref$openPanel,
            _ref$loadPanelData = _ref.loadPanelData,
            loadPanelData = _ref$loadPanelData === undefined ? function () {} : _ref$loadPanelData,
            _ref$onPanelHideCb = _ref.onPanelHideCb,
            onPanelHideCb = _ref$onPanelHideCb === undefined ? function () {} : _ref$onPanelHideCb,
            _ref$needToHideOnOuts = _ref.needToHideOnOutsideClick,
            needToHideOnOutsideClick = _ref$needToHideOnOuts === undefined ? true : _ref$needToHideOnOuts,
            _ref$showCopyLink = _ref.showCopyLink,
            showCopyLink = _ref$showCopyLink === undefined ? true : _ref$showCopyLink,
            _ref$needShowMoire = _ref.needShowMoire,
            needShowMoire = _ref$needShowMoire === undefined ? false : _ref$needShowMoire,
            _ref$copyLink = _ref.copyLink,
            copyLink = _ref$copyLink === undefined ? function () {} : _ref$copyLink,
            _ref$hideHandler = _ref.hideHandler,
            hideHandler = _ref$hideHandler === undefined ? function () {
            return _this.panelContainer.setState({ isShown: false });
        } : _ref$hideHandler;

        _classCallCheck(this, TaskPanelContainer);

        var _this = _possibleConstructorReturn(this, (TaskPanelContainer.__proto__ || Object.getPrototypeOf(TaskPanelContainer)).call(this));

        _this.actions = {
            reloadComments: reloadComments,
            openPanel: openPanel,
            loadPanelData: loadPanelData
        };

        _this.callbacks = {
            onPanelHideCb: onPanelHideCb,
            copyLink: copyLink,
            hideHandler: hideHandler
        };

        _this.params = {
            panelContent: panelContent,
            panelType: panelType,
            additionalClass: additionalClass,
            needToHideOnOutsideClick: needToHideOnOutsideClick,
            needShowMoire: needShowMoire,
            showCopyLink: showCopyLink
        };

        _this.state = {
            isShown: false,
            loading: false,
            needToLoadData: false
        };

        _this.onStatePropertyChanged('isShown', function (isShown) {
            _this.panelContainer.setState({ isShown: isShown });
        });

        _this.onStatePropertyChanged('loading', function (loading) {
            _this.loadingContainer.setState({ loading: loading });
        });

        _this.onStatePropertyBecameTrue('needToLoadData', function () {
            return _this.actions.loadPanelData();
        });
        return _this;
    }

    _createClass(TaskPanelContainer, [{
        key: 'afterRender',
        value: function afterRender() {
            var _this2 = this;

            this.loadingContainer = new _LoadingContainer2.default({
                contentComponent: this.params.panelContent
            });
            this.$headerButtons = (0, _jquery2.default)('<div/>');

            this.panelContainer = new _PanelContainer2.default({
                component: this.loadingContainer,
                additionalClass: this.params.additionalClass,
                showAnimationClass: _constants.SHOW_ANIMATION_CLASSES.SLIDE_LEFT,
                hideAnimationClass: _constants.HIDE_ANIMATION_CLASSES.SLIDE_LEFT,
                hideOnEsc: true,
                hideOnClickOutside: {
                    hideOnClick: this.params.needToHideOnOutsideClick,
                    panelType: this.params.panelType
                },
                onHideCallback: function onHideCallback() {
                    return _this2.callbacks.onPanelHideCb();
                },
                showMoire: this.params.needShowMoire,
                showCopyLink: this.params.showCopyLink,
                copyLinkTooltipText: _messageResource2.default.getMessage('task.edit_panel.copy_link_tooltip_text'),
                showHideButton: true,
                hideHandler: function hideHandler() {
                    _this2.callbacks.hideHandler();
                    _this2.params.panelContent.onHide();
                },
                onCopyLinkClick: function onCopyLinkClick() {
                    return _this2.callbacks.copyLink();
                },
                onClickCloseButton: function onClickCloseButton() {
                    return _this2.callbacks.hideHandler();
                },
                headerButtons: this.$headerButtons
            }).init((0, _jquery2.default)('body'));
        }
    }]);

    return TaskPanelContainer;
}(_View3.default);

exports.default = TaskPanelContainer;

/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Moire = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Moire = exports.Moire = function (_TemplateView) {
    _inherits(Moire, _TemplateView);

    function Moire() {
        _classCallCheck(this, Moire);

        return _possibleConstructorReturn(this, (Moire.__proto__ || Object.getPrototypeOf(Moire)).apply(this, arguments));
    }

    _createClass(Moire, [{
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='components_moireContainer'/>";
        }
    }], [{
        key: "getInstance",
        value: function getInstance() {
            return _getInstance();
        }
    }]);

    return Moire;
}(_TemplateView3.default);

var instance = null;
var _getInstance = function _getInstance() {
    if (!instance) {
        instance = new Moire().init((0, _jquery2.default)("body"));
    }
    return instance;
};

/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var typeOfWorkComparator = exports.typeOfWorkComparator = function typeOfWorkComparator(t1, t2) {
  return t1.position - t2.position;
};

/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _BaseTaskSelector = __webpack_require__(1414);

var _BaseTaskSelector2 = _interopRequireDefault(_BaseTaskSelector);

var _TaskListController = __webpack_require__(723);

var _TaskListController2 = _interopRequireDefault(_TaskListController);

var _jquery_rpc = __webpack_require__(26);

var _jquery_rpc2 = _interopRequireDefault(_jquery_rpc);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ImportTasksSelector = function (_BaseTasksSelector) {
    _inherits(ImportTasksSelector, _BaseTasksSelector);

    function ImportTasksSelector($containerEl, params) {
        _classCallCheck(this, ImportTasksSelector);

        var _this = _possibleConstructorReturn(this, (ImportTasksSelector.__proto__ || Object.getPrototypeOf(ImportTasksSelector)).call(this, $containerEl, params));

        _this.state = _extends({}, _this.state, {
            importOnlyActiveProjects: true,
            importDescriptions: false
        });

        _this.onStatePropertyChanged("importOnlyActiveProjects", function (importOnlyActiveProjects) {
            _this.$importArchivedCheckbox.attr("checked", !importOnlyActiveProjects);
            _this.taskListController.setInActiveProjects(importOnlyActiveProjects);
            _this.showCpSelectorController(true);
        });
        _this.onStatePropertyChanged("importDescriptions", function (importDescriptions) {
            _this.$importDescriptionsCheckbox.attr("checked", importDescriptions);
        });
        return _this;
    }

    _createClass(ImportTasksSelector, [{
        key: 'createTaskListController',
        value: function createTaskListController(params) {
            return new _TaskListController2.default(params);
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            var _this2 = this;

            _get(ImportTasksSelector.prototype.__proto__ || Object.getPrototypeOf(ImportTasksSelector.prototype), 'afterRender', this).call(this);

            this.$importArchivedCheckbox = this.find(".importArchivedCheckbox").click(function () {
                return _this2.setState({
                    importOnlyActiveProjects: !_this2.state.importOnlyActiveProjects
                });
            });
            this.$importDescriptionsCheckbox = this.find(".importDescriptionsCheckbox").click(function () {
                return _this2.setState({
                    importDescriptions: !_this2.state.importDescriptions
                });
            });

            this.$panel.addClass("importTasksSelector");
        }
    }, {
        key: 'selectCpSectionAdditionalControlsTemplateHtml',
        value: function selectCpSectionAdditionalControlsTemplateHtml() {
            return "<label>" + "  <input type='checkbox' class='importArchivedCheckbox'>" + "  <span class='label'><%-importArchived%></span>" + "</label>";
        }
    }, {
        key: 'bottomPanelTemplateHtml',
        value: function bottomPanelTemplateHtml() {
            return "<div class='bottomPanel'>" + "  <label>" + "    <input type='checkbox' class='importDescriptionsCheckbox'>" + "    <span class='label'><%-importTaskDescriptions%></span>" + "  </label>" + "  <div class='greyButton withIcon importSelectedButton disabled'>" + "    <span class='buttonIcon'>" + "      <span class='buttonImportTitle'><%-importSelected%></span>" + "    </span>" + "  </div>" + "</div>";
        }
    }, {
        key: 'getApplyButtonClass',
        value: function getApplyButtonClass() {
            return "importSelectedButton";
        }
    }, {
        key: 'messageKeys',
        value: function messageKeys() {
            return _extends({}, _get(ImportTasksSelector.prototype.__proto__ || Object.getPrototypeOf(ImportTasksSelector.prototype), 'messageKeys', this).call(this), {
                importArchived: "task_selector.import_archived",
                importTaskDescriptions: "task_selector.import_descriptions",
                importSelected: "task_selector.import_selected"
            });
        }
    }, {
        key: '_getSelection',
        value: function _getSelection() {
            return _extends({}, _get(ImportTasksSelector.prototype.__proto__ || Object.getPrototypeOf(ImportTasksSelector.prototype), '_getSelection', this).call(this), {
                importOnlyActiveProjects: this.state.importOnlyActiveProjects,
                importDescriptions: this.state.importDescriptions
            });
        }
    }, {
        key: '_getCPListRpcCall',
        value: function _getCPListRpcCall(onSuccess, onError) {
            return (0, _jquery_rpc2.default)("RetrieveCustomersProjectsService.getCPListForImportTasksSelector", [this.state.importOnlyActiveProjects], onSuccess, onError);
        }
    }, {
        key: '_selectAllForCustomerMessage',
        value: function _selectAllForCustomerMessage() {
            return this.state.importOnlyActiveProjects ? _messageResource2.default.getMessage("import_tasks_selector.select_all_for_customer.only_active_projects") : _messageResource2.default.getMessage("import_tasks_selector.select_all_for_customer");
        }
    }, {
        key: '_selectAllForProjectMessage',
        value: function _selectAllForProjectMessage() {
            return _messageResource2.default.getMessage("import_tasks_selector.select_all_for_project");
        }
    }, {
        key: 'onCustomersProjectsRequestComplete',
        value: function onCustomersProjectsRequestComplete(data) {
            this.cpSelectorController.init(data, this.state.importOnlyActiveProjects);
            this.cpSelectorController.stopSpin();
        }
    }]);

    return ImportTasksSelector;
}(_BaseTaskSelector2.default);

exports.default = ImportTasksSelector;

/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _Tooltip2 = __webpack_require__(183);

var _Tooltip3 = _interopRequireDefault(_Tooltip2);

var _index = __webpack_require__(22);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InfoTooltip = function (_Tooltip) {
    _inherits(InfoTooltip, _Tooltip);

    function InfoTooltip() {
        _classCallCheck(this, InfoTooltip);

        return _possibleConstructorReturn(this, (InfoTooltip.__proto__ || Object.getPrototypeOf(InfoTooltip)).apply(this, arguments));
    }

    _createClass(InfoTooltip, [{
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='importTasksInfoTooltip'>" + "  <div><%-header%></div>" + "  <ul>" + "    <li><%-taskNames%></li>" + "    <% if (est) {%>" + "    <li><%-estimatedHours%></li>" + "    <%}%>" + "    <% if (bty) {%>" + "    <li><%-billingTypes%></li>" + "    <%}%>" + "    <li><%-descriptions%></li>" + "  </ul>" + "  <div><b><%-footer%></b></div>" + "</div>";
        }
    }, {
        key: "messageKeys",
        value: function messageKeys() {
            return {
                header: 'add_new_tasks.import_tasks_tooltip_info_header',
                taskNames: 'add_new_tasks.import_tasks_tooltip_info_task_names',
                estimatedHours: 'add_new_tasks.import_tasks_tooltip_info_estimated_hours',
                billingTypes: 'add_new_tasks.import_tasks_tooltip_info_billing_types',
                descriptions: 'add_new_tasks.import_tasks_tooltip_info_descriptions',
                footer: 'add_new_tasks.import_tasks_tooltip_info_footer'
            };
        }
    }, {
        key: "templateModel",
        value: function templateModel() {
            return {
                est: (0, _index.isEnabled)(_index.Feature.EST),
                bty: (0, _index.isEnabled)(_index.Feature.BTY)
            };
        }
    }]);

    return InfoTooltip;
}(_Tooltip3.default);

var infoTooltip = null;
function getInfoTooltip() {
    if (!infoTooltip) {
        infoTooltip = new InfoTooltip().init((0, _jquery2.default)("body"));
    }
    return infoTooltip;
}

var ImportTasksSelectorButton = function (_TemplateView) {
    _inherits(ImportTasksSelectorButton, _TemplateView);

    function ImportTasksSelectorButton() {
        var onClick = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};

        _classCallCheck(this, ImportTasksSelectorButton);

        var _this2 = _possibleConstructorReturn(this, (ImportTasksSelectorButton.__proto__ || Object.getPrototypeOf(ImportTasksSelectorButton)).call(this));

        _this2.onClick = onClick;
        return _this2;
    }

    _createClass(ImportTasksSelectorButton, [{
        key: "templateHtml",
        value: function templateHtml() {
            return '<div class="importTasksSelectorButton">' + '  <div class="importIcon"></div>' + '  <div class="title dashedLink"><%-title%></div>' + '  <div class="infoIcon"></div>' + '</div>';
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            var _this3 = this;

            this.$el.click(function () {
                return _this3.onClick();
            });
            getInfoTooltip().subscribeToMouseEvents(this.find(".infoIcon"));
        }
    }, {
        key: "messageKeys",
        value: function messageKeys() {
            return {
                title: 'task_selector.importTasksButton'
            };
        }
    }]);

    return ImportTasksSelectorButton;
}(_TemplateView3.default);

exports.default = ImportTasksSelectorButton;

/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function ScheduleCalculator() {
    this.constructor = ScheduleCalculator;
}

ScheduleCalculator.prototype.init = function (invertedDaysMap, userSchedules) {
    if (!userSchedules || userSchedules.length == 0) throw "ScheduleCalculator: Illegal arguments exception";

    this.userSchedules = userSchedules;

    if (invertedDaysMap) {
        this.invertedDaysYearMap = invertedDaysMap["map"] ? invertedDaysMap["map"] : {};
    } else this.invertedDaysYearMap = {};

    return this;
};

/**
 * @param {Date} fromDate
 * @param {Date} toDate
 * @return {Array} array of boolean; true = working day, false = nonworking day
 */
ScheduleCalculator.prototype.getEffectiveSchedule = function (fromDate, toDate) {
    fromDate = fromDate.truncateTime();
    toDate = toDate.truncateTime();

    var result = [];
    var durations = this.userSchedules[0].durations;
    var nextScheduleIdx = 1;
    var nextSchedule = this.userSchedules[nextScheduleIdx];
    var lastDateTo = fromDate;

    while (nextSchedule) {
        var nextEffectiveDate = nextSchedule.effectiveDate.parseJSONDate();
        if (nextEffectiveDate > toDate) break;

        if (nextEffectiveDate > fromDate) {
            lastDateTo = nextEffectiveDate;
            this._processDurations(result, fromDate, lastDateTo, durations);
            fromDate = lastDateTo;
        }
        durations = nextSchedule.durations;
        nextSchedule = this.userSchedules[++nextScheduleIdx];
    }

    if (lastDateTo < toDate) this._processDurations(result, lastDateTo, toDate.nextDay(), durations);

    return result;
};

ScheduleCalculator.prototype._processDurations = function (scheduleArray, fromDate, toDate, durations) {
    var d;
    var invertedDay;

    for (var i = new window.DatesIterator(fromDate, toDate.prevDay()); i.hasNext();) {
        d = i.next();
        invertedDay = this._getInvertedDay(d);

        if (invertedDay) scheduleArray.push(invertedDay.isWorking);else scheduleArray.push(durations[d.getDay()] > 0);
    }
};

ScheduleCalculator.prototype._getInvertedDay = function (date) {
    // working days and days off
    var invertedDaysYear = this.invertedDaysYearMap[String(date.getFullYear())];
    if ((typeof invertedDaysYear === "undefined" ? "undefined" : _typeof(invertedDaysYear)) != ( true ? "undefined" : _typeof(undefined))) {
        var invertedDaysMonthMap = invertedDaysYear["map"];
        if ((typeof invertedDaysMonthMap === "undefined" ? "undefined" : _typeof(invertedDaysMonthMap)) != ( true ? "undefined" : _typeof(undefined))) {
            var invertedDaysMonthSet = invertedDaysMonthMap[String(date.getMonth())];
            if ((typeof invertedDaysMonthSet === "undefined" ? "undefined" : _typeof(invertedDaysMonthSet)) != ( true ? "undefined" : _typeof(undefined))) {
                var invertedDaysMonth = invertedDaysMonthSet["map"];
                if (_typeof(invertedDaysMonth[date.getDate()]) != ( true ? "undefined" : _typeof(undefined))) {
                    return {
                        isWorking: invertedDaysMonth[date.getDate()] == "WORKING"
                    };
                }
            }
        }
    }

    return false;
};

exports.default = ScheduleCalculator;

/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isProjectIdValid = exports.isCustomerIdValid = undefined;

var _constants = __webpack_require__(507);

var isIdValid = function isIdValid(beans, id) {
    if (_.isNull(id)) return false;

    for (var j = 0; j < beans.length; j++) {
        if (beans[j].id === id) return true;
    }
    return false;
};

var isCustomerIdValid = exports.isCustomerIdValid = function isCustomerIdValid(customers, id) {
    if (id === _constants.CREATE_TASKS_CONSTANTS.ALL_ACTIVE_CUSTOMERS_OPTION_INDEX) return true;
    return isIdValid(customers, id);
};

var isProjectIdValid = exports.isProjectIdValid = function isProjectIdValid(projects, id) {
    if (id === _constants.CREATE_TASKS_CONSTANTS.ALL_ACTIVE_PROJECTS_OPTION_INDEX) return true;
    return isIdValid(projects, id);
};

/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _LightBox2 = __webpack_require__(196);

var _LightBox3 = _interopRequireDefault(_LightBox2);

var _ChooseReportComponent = __webpack_require__(1416);

var _ChooseReportComponent2 = _interopRequireDefault(_ChooseReportComponent);

var _ChooseReportHeader = __webpack_require__(1435);

var _ChooseReportHeader2 = _interopRequireDefault(_ChooseReportHeader);

var _ChooseReportFooter = __webpack_require__(1436);

var _ChooseReportFooter2 = _interopRequireDefault(_ChooseReportFooter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CreateReportPopup = function (_LightBox) {
    _inherits(CreateReportPopup, _LightBox);

    function CreateReportPopup(_ref) {
        var _ref$reportUrls = _ref.reportUrls,
            reportUrls = _ref$reportUrls === undefined ? {} : _ref$reportUrls,
            _ref$reportNameKeys = _ref.reportNameKeys,
            reportNameKeys = _ref$reportNameKeys === undefined ? {} : _ref$reportNameKeys;

        _classCallCheck(this, CreateReportPopup);

        var _this = _possibleConstructorReturn(this, (CreateReportPopup.__proto__ || Object.getPrototypeOf(CreateReportPopup)).call(this));

        _this.params = {
            reportUrls: reportUrls,
            reportNameKeys: reportNameKeys
        };

        _this.close_tab_confirmation_message_key = "project.add.js.close_tab_confirmation";
        _this.exist_invalid_fields_message_key = "project.common.errormsg";
        _this.cancel_confirmation_message_key = "project.add.js.cancel_confirmation";

        _this.cancelCallback = _this.hide;
        return _this;
    }

    _createClass(CreateReportPopup, [{
        key: 'init',
        value: function init() {
            var header = new _ChooseReportHeader2.default({});
            var footer = new _ChooseReportFooter2.default({});
            var content = new _ChooseReportComponent2.default({
                reportUrls: this.params.reportUrls,
                reportNameKeys: this.params.reportNameKeys
            });
            _get(CreateReportPopup.prototype.__proto__ || Object.getPrototypeOf(CreateReportPopup.prototype), 'init', this).call(this, {
                id: 'createReportLightBox', // do not delete
                header: header,
                content: content,
                footer: footer,
                classNames: 'reportDescriptionLightbox lightboxWithWhiteContent',
                correctionOffset: -60 /* offset of the innerContent in the popup content used when scrolling to section with error*/
            });

            return this;
        }
    }]);

    return CreateReportPopup;
}(_LightBox3.default);

exports.default = CreateReportPopup;

/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isReportAvailable = undefined;

var _constants = __webpack_require__(11);

var _constants2 = __webpack_require__(4);

var _constants3 = __webpack_require__(78);

var isReportAvailable = exports.isReportAvailable = function isReportAvailable(type, userRights, features) {
    var billingRights = userRights[_constants2.AccessRights.GENERATE_MONEY_REPORTS];
    var overtimeAndLeaveTimeRights = userRights[_constants2.AccessRights.MANAGE_PTO_AND_SICK] || userRights[_constants2.AccessRights.MANAGE_USERS] || userRights[_constants2.AccessRights.SUBMIT_OTHER_USER_TIME_TRACK] || userRights[_constants2.AccessRights.SUBMIT_TIME_TRACK];
    var managerOrTTUserRights = userRights[_constants2.AccessRights.MANAGE_USERS] || userRights[_constants2.AccessRights.EDIT_HIERARCHY] || userRights[_constants2.AccessRights.GENERATE_MONEY_REPORTS] || userRights[_constants2.AccessRights.SUBMIT_OTHER_USER_TIME_TRACK] || userRights[_constants2.AccessRights.SUBMIT_TIME_TRACK];

    switch (type) {
        case _constants.ReportType.STAFF_PERFORMANCE:
            return !!managerOrTTUserRights;
        case _constants.ReportType.TIME_TRACK_IN_DETAIL:
            return !!managerOrTTUserRights && !!features[_constants3.Feature.TTC];
        case _constants.ReportType.ESTIMATED_VS_ACTUAL:
            return !!managerOrTTUserRights && !!features[_constants3.Feature.EST];
        case _constants.ReportType.OVERTIME:
            return !!overtimeAndLeaveTimeRights;
        case _constants.ReportType.LEAVE_TIME:
            return !!overtimeAndLeaveTimeRights && !!features[_constants3.Feature.LVT] && !!features[_constants3.Feature.CLT];
        case _constants.ReportType.BILLING_SUMMARY:
            return !!billingRights && !!features[_constants3.Feature.BTY];
        case _constants.ReportType.INVOICING:
            return !!billingRights && !!features[_constants3.Feature.BRA];
        case _constants.ReportType.COST_OF_WORK:
            return !!billingRights && !!features[_constants3.Feature.URA];
        case _constants.ReportType.PROFIT_LOSS:
            return !!billingRights && !!features[_constants3.Feature.URA] && !!features[_constants3.Feature.BRA];
        case _constants.ReportType.CUSTOM_FIELDS:
            return !!managerOrTTUserRights && !!features[_constants3.Feature.CFI];
        case _constants.ReportType.WORK_STATUSES:
            return !!features[_constants3.Feature.WSD] && (_constants2.AccessRights.SUBMIT_TIME_TRACK || _constants2.AccessRights.SUBMIT_OTHER_USER_TIME_TRACK || _constants2.AccessRights.MANAGE_USERS);
        case _constants.ReportType.TIME_CARDS:
            return !!managerOrTTUserRights && !!features[_constants3.Feature.FTT];
    }
};

/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var getReportsState = exports.getReportsState = function getReportsState(state) {
  return state.reports;
};

/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _CreateChartLightbox = __webpack_require__(1437);

var _CreateChartLightbox2 = _interopRequireDefault(_CreateChartLightbox);

var _Ext = __webpack_require__(12);

var _Ext2 = _interopRequireDefault(_Ext);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _rpcCalls = __webpack_require__(24);

var _rpcCalls2 = _interopRequireDefault(_rpcCalls);

var _LoadingPopup = __webpack_require__(299);

var _LoadingPopup2 = _interopRequireDefault(_LoadingPopup);

var _at_create_chart_button = __webpack_require__(1485);

var _at_create_chart_button2 = _interopRequireDefault(_at_create_chart_button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ChartMediator = function () {
    function ChartMediator() {
        var _this = this;

        var createButton = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
        var needToReloadPageAfterClose = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

        _classCallCheck(this, ChartMediator);

        if (createButton) {
            var createChartButtonElementId = new _at_create_chart_button2.default({
                renderTo: 'createChartButton',
                buttonText: _messageResource2.default.getMessage('report.create_chart_button.title'),
                hideOnResize: true
            }).id;

            _Ext2.default.apply(_Ext2.default.getCmp(createChartButtonElementId), { clickAction: function clickAction() {
                    return _this.loadNewChartData();
                } });
        }
        this.needToReloadPageAfterClose = needToReloadPageAfterClose;
    }

    _createClass(ChartMediator, [{
        key: 'showCreateChartLightbox',
        value: function showCreateChartLightbox(popupData, chartType, chartDataParameters, chartDisplayParameters, chartPoints, makeChartPointsException, chartId, chartName) {
            new _CreateChartLightbox2.default().init({
                popupId: "createChartLightbox",
                closeBtnId: "closeCreateChartLightboxButton",
                chartContainerId: "chartContainer",
                partsContainerId: "chartPart",
                totalValueContainer: ".grandTotalValue",
                chartPopupData: popupData,
                chartType: chartType,
                chartDataParameters: chartDataParameters,
                chartDisplayParameters: chartDisplayParameters,
                chartPoints: chartPoints,
                makeChartPointsException: makeChartPointsException,
                chartId: chartId,
                chartName: chartName,
                needToReloadPageAfterClose: this.needToReloadPageAfterClose
            }).show();
        }
    }, {
        key: 'loadNewChartData',
        value: function loadNewChartData() {
            var _this2 = this;

            this.showLoadingPopup();
            (0, _rpcCalls2.default)("ReportChartService.getNewChartData", [], function () {
                _this2.hideLoadingPopup();
                return false;
            }).then(function (result) {
                _this2.hideLoadingPopup();
                _this2.showCreateChartLightbox(result.popupData, result.chartType, result.chartDataParameters, result.chartDisplayParameters, result.chartPoints, result.makeChartPointsException, null, null, result.showStackColumnsCheckMark);
            });
        }
    }, {
        key: 'showChart',
        value: function showChart(configId) {
            var _this3 = this;

            this.showLoadingPopup();
            (0, _rpcCalls2.default)("ReportChartService.getChartData", [configId], function (rpcError) {
                if (rpcError.getTextStatus() === "rpc_customException") {
                    _this3.hideLoadingPopup();
                    if (rpcError.getErrorThrown().exception === "com.actimind.actitime.reports.NoSuchReportConfigException" || rpcError.getErrorThrown().exception === "com.actimind.actitime.reports.charts.ReportConfigOfAnotherUserException") {
                        alert(_messageResource2.default.getMessage("saved_reports.load.no_such_chart_config"));
                        document.location.reload();
                        return true;
                    }
                }
                return false;
            }).then(function (result) {
                _this3.hideLoadingPopup();
                _this3.showCreateChartLightbox(result.popupData, result.reportConfig.type, result.reportConfig.configParams.dataParameters, result.reportConfig.configParams.displayParameters, result.chartPoints, result.makeChartPointsException, result.reportConfig.id, result.reportConfig.name);
            });
        }
    }, {
        key: 'showLoadingPopup',
        value: function showLoadingPopup() {
            this.loadingPopup = new _LoadingPopup2.default().init("reportChartLoadingPopup");
            this.loadingPopup.show();
        }
    }, {
        key: 'hideLoadingPopup',
        value: function hideLoadingPopup() {
            this.loadingPopup.hide();
        }
    }]);

    return ChartMediator;
}();

exports.default = ChartMediator;

/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ChartDateRangeSectionStrategy() {}

ChartDateRangeSectionStrategy.prototype.init = function (container, dateRangeSelector, singleDateSelector) {
    this.container = container;
    this.dateRangeSelector = dateRangeSelector;
    this.singleDateSelector = singleDateSelector;

    return this;
};

ChartDateRangeSectionStrategy.prototype.updateSectionUI = function () {
    (0, _jquery2.default)(this.container).removeClass("withDateRangeSelector withSingleDateSelector");
};

ChartDateRangeSectionStrategy.prototype.getSelectedParamsJSON = function () {
    return [];
};

ChartDateRangeSectionStrategy.prototype.getSelectedParams = function () {
    // abstract
};

ChartDateRangeSectionStrategy.prototype.validate = function () {
    return [];
};

exports.default = ChartDateRangeSectionStrategy;

/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _SelectorFilter2 = __webpack_require__(282);

var _SelectorFilter3 = _interopRequireDefault(_SelectorFilter2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ReportsUsersSelectorFilter = function (_SelectorFilter) {
    _inherits(ReportsUsersSelectorFilter, _SelectorFilter);

    function ReportsUsersSelectorFilter(_ref) {
        var tree = _ref.tree,
            searchIndex = _ref.searchIndex,
            allActiveSet = _ref.allActiveSet,
            myTeamNodesSet = _ref.myTeamNodesSet,
            accessibleParentNodes = _ref.accessibleParentNodes,
            _ref$showTeamOnly = _ref.showTeamOnly,
            showTeamOnly = _ref$showTeamOnly === undefined ? false : _ref$showTeamOnly;

        _classCallCheck(this, ReportsUsersSelectorFilter);

        var _this = _possibleConstructorReturn(this, (ReportsUsersSelectorFilter.__proto__ || Object.getPrototypeOf(ReportsUsersSelectorFilter)).call(this, tree, searchIndex, allActiveSet));

        _this.myTeamNodesSet = myTeamNodesSet;
        _this.manageableUsersNodeSet = showTeamOnly ? myTeamNodesSet : null;
        _this.accessibleParentNodes = accessibleParentNodes;
        return _this;
    }

    _createClass(ReportsUsersSelectorFilter, [{
        key: 'hasNoFilter',
        value: function hasNoFilter() {
            return _get(ReportsUsersSelectorFilter.prototype.__proto__ || Object.getPrototypeOf(ReportsUsersSelectorFilter.prototype), 'hasNoFilter', this).call(this) && !this.manageableUsersNodeSet;
        }

        /**
         * Filters nodes of selector according to selected parameters of filter.
         * @returns {TreeNode}
         */

    }, {
        key: 'doFilter',
        value: function doFilter() {
            if (!this.manageableUsersNodeSet) return _get(ReportsUsersSelectorFilter.prototype.__proto__ || Object.getPrototypeOf(ReportsUsersSelectorFilter.prototype), 'doFilter', this).call(this);

            var result = void 0;
            //keywordSet - set of nodes representing result of search by some specified keyword.
            //If keywordSet is presented then we should return result of search in set of manageable users.
            // Set of selected nodes(selectedOnlySet) is not taken into account when searching.
            if (this.keywordSet) {
                result = this.manageableUsersNodeSet.intersection(this.keywordSet);
                var resultWithActiveOnlySet = this.safeIntersection(result, this.activeOnlySet);

                // If there is no active users or groups with a specified keyword found
                // then return result of search in non-active and manageable users
                result = resultWithActiveOnlySet.isEmpty() ? result : resultWithActiveOnlySet;
            } else {
                //If there is no keywordSet then result is intersection of all other sets
                result = this.safeIntersection(this.manageableUsersNodeSet, this.activeOnlySet);
                result = this.safeIntersection(result, this.selectedOnlySet);
            }

            return result;
        }
    }, {
        key: 'getVisibleNodeSet',
        value: function getVisibleNodeSet(selectedNodeSet) {
            var visibleUserNodes = this.safeIntersection(_get(ReportsUsersSelectorFilter.prototype.__proto__ || Object.getPrototypeOf(ReportsUsersSelectorFilter.prototype), 'getVisibleNodeSet', this).call(this, selectedNodeSet), this.manageableUsersNodeSet);
            var visibleGroupNodes = this.accessibleParentNodes.intersection(selectedNodeSet);
            return visibleUserNodes.union(visibleGroupNodes);
        }
    }, {
        key: 'setShowUsersFromMyTeamOnly',
        value: function setShowUsersFromMyTeamOnly(fromMyTeam) {
            if (fromMyTeam) {
                this.manageableUsersNodeSet = this.myTeamNodesSet;
            } else {
                this.manageableUsersNodeSet = null;
            }

            this.reFilter();
        }
    }]);

    return ReportsUsersSelectorFilter;
}(_SelectorFilter3.default);

exports.default = ReportsUsersSelectorFilter;

/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _UserSelectorTreeBuilderObserver = __webpack_require__(481);

var _UserSelectorTreeBuilderObserver2 = _interopRequireDefault(_UserSelectorTreeBuilderObserver);

var _TreeNodeSet = __webpack_require__(79);

var _TreeNodeSet2 = _interopRequireDefault(_TreeNodeSet);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ReportsUserSelectorTreeBuilderObserver = function (_UserSelectorTreeBuil) {
    _inherits(ReportsUserSelectorTreeBuilderObserver, _UserSelectorTreeBuil);

    function ReportsUserSelectorTreeBuilderObserver(_ref) {
        var searchIndex = _ref.searchIndex,
            allActiveSet = _ref.allActiveSet,
            manageableUsersIdsSet = _ref.manageableUsersIdsSet;

        _classCallCheck(this, ReportsUserSelectorTreeBuilderObserver);

        var _this = _possibleConstructorReturn(this, (ReportsUserSelectorTreeBuilderObserver.__proto__ || Object.getPrototypeOf(ReportsUserSelectorTreeBuilderObserver)).call(this, searchIndex, allActiveSet));

        _this.manageableUsersIdsSet = manageableUsersIdsSet;
        _this.manageableUsersNodeSet = new _TreeNodeSet2.default();
        _this.accessibleParentNodes = new _TreeNodeSet2.default();
        return _this;
    }

    _createClass(ReportsUserSelectorTreeBuilderObserver, [{
        key: 'userNodeAdded',
        value: function userNodeAdded(userNode) {
            _get(ReportsUserSelectorTreeBuilderObserver.prototype.__proto__ || Object.getPrototypeOf(ReportsUserSelectorTreeBuilderObserver.prototype), 'userNodeAdded', this).call(this, userNode);

            var user = userNode.getValue();
            //null means all users are manageable
            if (this.manageableUsersIdsSet === null || this.manageableUsersIdsSet.has(user.id)) {
                this.manageableUsersNodeSet.add(userNode);
                this.accessibleParentNodes.add(userNode.getParent());
            }
        }
    }, {
        key: 'getManageableUsersNodeSet',
        value: function getManageableUsersNodeSet() {
            return this.manageableUsersNodeSet;
        }
    }, {
        key: 'getAccessibleParentNodes',
        value: function getAccessibleParentNodes() {
            return this.accessibleParentNodes;
        }
    }]);

    return ReportsUserSelectorTreeBuilderObserver;
}(_UserSelectorTreeBuilderObserver2.default);

exports.default = ReportsUserSelectorTreeBuilderObserver;

/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ErrorTooltipsForSectionsController;

var _SimpleSingletonTooltip = __webpack_require__(45);

function ErrorTooltipsForSectionsController() {}

ErrorTooltipsForSectionsController.prototype.init = function (tooltipId, errorsToSectionElsMap, getErrorMessageFunction) {
    this.errorsToSectionElsMap = errorsToSectionElsMap;
    this.unsubscribeErrorTootipMouseHandlers = {};
    this.getErrorMessageFunction = getErrorMessageFunction;

    return this;
};

ErrorTooltipsForSectionsController.prototype.updateTooltips = function (errors) {
    for (var possibleError in this.errorsToSectionElsMap) {
        if (this.errorsToSectionElsMap.hasOwnProperty(possibleError)) {
            var error = errors.includes(possibleError) ? possibleError : null;
            this.updateTooltipHandlersForSection(possibleError, error);
        }
    }
};

ErrorTooltipsForSectionsController.prototype.updateTooltipHandlersForSection = function (possibleError, error) {
    var _this = this;

    var sectionEl = this.errorsToSectionElsMap[possibleError];
    var unsubscribeErrorTooltipHandler = this.unsubscribeErrorTootipMouseHandlers[possibleError];

    if (!sectionEl) {
        return;
    }

    if (error && !unsubscribeErrorTooltipHandler) {
        this.unsubscribeErrorTootipMouseHandlers[error] = (0, _SimpleSingletonTooltip.getInstance)().subscribeToMouseEvents(sectionEl, function () {
            (0, _SimpleSingletonTooltip.getInstance)().setState({
                html: _this.getErrorMessageFunction(error),
                extraClass: 'reportEditConfigErrorTooltip ' + error + 'Cls'
            });
            sectionEl.click(function () {
                return (0, _SimpleSingletonTooltip.getInstance)().hide();
            });
        });
    } else if (unsubscribeErrorTooltipHandler && !error) {
        (0, _SimpleSingletonTooltip.getInstance)().hide();
        sectionEl.off('click');
        unsubscribeErrorTooltipHandler();
        delete this.unsubscribeErrorTootipMouseHandlers[possibleError];
    }
};

/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Ext = __webpack_require__(12);

var _Ext2 = _interopRequireDefault(_Ext);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _at_dropdown_button = __webpack_require__(469);

var _at_dropdown_button2 = _interopRequireDefault(_at_dropdown_button);

var _atBrowserUtils = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Dropdown button intended for use with selector panels.
 *
 * Depends on:
 * <code>/js/controls/at_dropdown_button.js</code>
 *
 * @cfg {AT.SelectorPanel} selectorPanel selector panel to be displayed in dropdown (required).
 * @constructor
 */
var SelectorDropdownButton = _Ext2.default.extend(_at_dropdown_button2.default, {

    /**
     * @cfg {Number} specifies selector panel height. Is used to adjust menu align properly whether it is drop UP or DOWN
     */
    selectorPanelHeight: 350,
    selectorPanel: null,
    labelCls: "ellipsis",
    cls: "dropdown-button at-selector-button",
    errorCls: "error",

    dropDownMenuAnchor: "td.bottom-left-cell",
    dropUpMenuAnchor: "td.top-left-cell",

    constructor: function constructor(config) {
        var menuCls = "at-selector-menu";
        if (config.additionalMenuCls) menuCls += " " + config.additionalMenuCls;

        this.menu = new _Ext2.default.menu.Menu({
            shadow: config.isNoShadow === true ? false : "sides",
            cls: menuCls,
            items: [config.selectorPanel],
            show: function show(el, pos, parentMenu) {
                _Ext2.default.menu.Menu.prototype.show.call(this, el, pos, parentMenu);
                var diff = this.el.getBottom() - ((0, _atBrowserUtils.getBodyScrollTop)() + document.body.clientHeight);
                if (diff > 0) {
                    _Ext2.default.getBody().scroll("down", diff);
                }
            }
        });

        SelectorDropdownButton.superclass.constructor.call(this, config);
    },

    initComponent: function initComponent() {
        SelectorDropdownButton.superclass.initComponent.call(this);

        this.selectorPanel.on("change", this.updateButton, this);
        this.selectorPanel.on("close", this.menu.hide, this.menu);

        _Ext2.default.EventManager.on(window, "resize", this.menu.hide, this.menu);

        this.on("menuhide", function () {
            this.selectorPanel.markAllSelectedIfNeeded();
        });

        this.updateButton();
    },

    afterRender: function afterRender() {
        SelectorDropdownButton.superclass.afterRender.call(this);
        this.el.child("span:first").addClass(this.labelCls);
    },

    /**
     * Updates text label on the button.
     * @private
     */
    updateButton: function updateButton() {
        this.setText(this.selectorPanel.getLabelText());
        this.setDisplayInputError(false);
        this.setTooltipEnabled(this.selectorPanel.isTooltipEnabled());
    },

    showMenu: function showMenu() {
        var dropDownAnchor = this.el.child(this.dropDownMenuAnchor);
        var dropUpAnchor = this.el.child(this.dropUpMenuAnchor);
        var yShift = dropDownAnchor.getTop() - dropUpAnchor.getTop();
        var enoughTopSpace = dropUpAnchor.getTop() - this.selectorPanelHeight > 0;
        this.menuAnchor = enoughTopSpace ? this.dropDownMenuAnchor : this.dropUpMenuAnchor;

        SelectorDropdownButton.superclass.showMenu.call(this);

        var element = this.menu.el;
        var topLeft = element.getXY();

        if (this.menuAnchor === this.dropUpMenuAnchor && element.getBottom() > dropDownAnchor.getBottom()) topLeft[1] += yShift;
        if (this.menuAnchor === this.dropDownMenuAnchor && element.getTop() < dropUpAnchor.getTop()) topLeft[1] -= yShift;

        var customShifty = (0, _jquery2.default)(this.container.dom).attr("dropdown-menu-shift-y");
        if (customShifty) topLeft[1] += parseInt(customShifty);

        element.setXY(topLeft);
        (0, _atBrowserUtils.scrollWindowIfNeeded)(element.dom);
    }

});

_Ext2.default.namespace("AT");

_Ext2.default.reg("at_selector_dropdown_button", SelectorDropdownButton);

exports.default = SelectorDropdownButton;

/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ChartPDFDefinitionPartsConstructors = __webpack_require__(198);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TableDefinitionBuilder = function () {
    function TableDefinitionBuilder(chartType, valueFormatter, categoryFormatter, grandTotalValue) {
        _classCallCheck(this, TableDefinitionBuilder);

        this._getPercentValue = function (value) {
            var percents = this.grandTotalValue === 0 ? 0 : 100 * value / this.grandTotalValue;
            percents = percents.toFixed(2);
            percents = percents.replace('.', window.SystemSettings.decimalSeparator);
            return percents + " %";
        };

        this.categoryFormatter = categoryFormatter;
        this.valueFormatter = valueFormatter;
        this.chartType = chartType;
        this.templateCtrs = _ChartPDFDefinitionPartsConstructors.ChartPDFTemplateConstructors;
        this.placeholderCtrs = _ChartPDFDefinitionPartsConstructors.ChartPDFPlaceholderConstructors;
        this.grandTotalValue = grandTotalValue;
    }

    _createClass(TableDefinitionBuilder, [{
        key: 'getTable',
        value: function getTable(dataRows, margins, tableStyle) {
            // abstact
        }
    }, {
        key: 'getDataRows',
        value: function getDataRows(pageDataList, showDataList, showPercentsList, tableValueStyles, rowDataMaxLens) {}
        // abstract


        /**
         * Method returns percent of grand total value
         * @param value - current value
         * @return string with percents
         * @private
         */

    }]);

    return TableDefinitionBuilder;
}();

exports.default = TableDefinitionBuilder;

/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _BaseCreateDefinitionObjectStrategy = __webpack_require__(802);

var _BaseCreateDefinitionObjectStrategy2 = _interopRequireDefault(_BaseCreateDefinitionObjectStrategy);

var _ChartPDFDefinitionPartsConstructors = __webpack_require__(198);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BaseBarsChartsStrategy = function (_BaseCreateDefinition) {
    _inherits(BaseBarsChartsStrategy, _BaseCreateDefinition);

    function BaseBarsChartsStrategy(chartType) {
        _classCallCheck(this, BaseBarsChartsStrategy);

        return _possibleConstructorReturn(this, (BaseBarsChartsStrategy.__proto__ || Object.getPrototypeOf(BaseBarsChartsStrategy)).call(this, chartType));
    }

    _createClass(BaseBarsChartsStrategy, [{
        key: 'adjustDataParameters',
        value: function adjustDataParameters(pagesData, pdfPrintParameters) {
            // if need to show data list return original object
            if (this._needToShowTable(pdfPrintParameters)) {
                return pagesData;
            }
            // another create page with two images
            var newPages = [];
            var i = 0;
            while (i < pagesData.length) {
                newPages.push({
                    firstImage: pagesData[i].image,
                    secondImage: pagesData[++i] ? pagesData[i].image : null
                });
                i++;
            }
            return newPages;
        }
    }, {
        key: 'addPageDataWithDataList',
        value: function addPageDataWithDataList(ddBuilder, docDefinition, pageData, pdfPrintParameters, pageIndex) {
            ddBuilder.addImageAndData(docDefinition, pageData.image, pageData.data, pdfPrintParameters.showListOfDataValues, pdfPrintParameters.showListOfPercentValues, pdfPrintParameters.fitDataToOnePage);
        }
    }, {
        key: 'addPageDataWithoutDataList',
        value: function addPageDataWithoutDataList(ddBuilder, docDefinition, pageData, pdfPrintParameters, nPages) {
            ddBuilder.addDoubleImagesVertical(docDefinition, pageData.firstImage, pageData.secondImage);
        }
    }, {
        key: 'getTotalNumberOfPages',
        value: function getTotalNumberOfPages(lengthOfDataList, pdfPrintParameters) {
            if (pdfPrintParameters.fitDataToOnePage) {
                return 1;
            } else {
                return this._needToShowTable(pdfPrintParameters) ? Math.ceil(lengthOfDataList / pdfPrintParameters.barsOnPage) : Math.ceil(lengthOfDataList / (2 * pdfPrintParameters.barsOnPage));
            }
        }
    }, {
        key: 'getChartImageDimensions',
        value: function getChartImageDimensions(lengthOfDataList, pdfPrintParameters) {
            var isDoubleImages = !this._needToShowTable(pdfPrintParameters);
            return (0, _ChartPDFDefinitionPartsConstructors.getNeededImageDimensions)(pdfPrintParameters.paperOrientation, pdfPrintParameters.paperSize, this.chartType, isDoubleImages);
        }
    }]);

    return BaseBarsChartsStrategy;
}(_BaseCreateDefinitionObjectStrategy2.default);

exports.default = BaseBarsChartsStrategy;

/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ChartPDFDefinitionPartsConstructors = __webpack_require__(198);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var BaseCreateDefinitionObjectStrategy = function () {
    function BaseCreateDefinitionObjectStrategy(chartType) {
        _classCallCheck(this, BaseCreateDefinitionObjectStrategy);

        this.chartType = chartType;
    }

    _createClass(BaseCreateDefinitionObjectStrategy, [{
        key: 'createDocDefinitionObject',
        value: function createDocDefinitionObject(ddBuilder, pagesData, pdfPrintParameters, includeOtherUsers) {
            var adjustedPagesData = this.adjustDataParameters(pagesData, pdfPrintParameters);

            var dd = ddBuilder.createNewDocDefinitionWithFooter();

            var needToShowTable = this._needToShowTable(pdfPrintParameters);
            for (var pageIndex = 0; pageIndex < adjustedPagesData.length; pageIndex++) {
                var isFirstPage = pageIndex === 0;
                var currentPage = adjustedPagesData[pageIndex];
                if (!isFirstPage) {
                    ddBuilder.addPageBreaker(dd);
                }
                if (isFirstPage || pdfPrintParameters.showHeaderOnEachPage) {
                    ddBuilder.addHeader(dd, pdfPrintParameters.showLogoInHeader, includeOtherUsers);
                }
                if (needToShowTable) {
                    this.addPageDataWithDataList(ddBuilder, dd, currentPage, pdfPrintParameters, pageIndex);
                } else {
                    this.addPageDataWithoutDataList(ddBuilder, dd, currentPage, pdfPrintParameters, adjustedPagesData.length);
                }
            }
            return dd;
        }
    }, {
        key: '_needToShowTable',
        value: function _needToShowTable(pdfPrintParameters) {
            return pdfPrintParameters.showListOfDataValues || pdfPrintParameters.showListOfPercentValues;
        }

        /**
         * if need to adjust parameters for parameters specific
         * @param pagesData - original data
         * @param pdfPrintParameters - pdf display parameters
         */

    }, {
        key: 'adjustDataParameters',
        value: function adjustDataParameters(pagesData, pdfPrintParameters) {}
        // abstract


        /**
         * Add page to doc definition if need to show data list
         * @param ddBuilder - doc definition builder
         * @param docDefinition - current doc definition
         * @param pageData - current page data (image + data list)
         * @param pdfPrintParameters - pdf display parameters
         * @param pageIndex - index of current page
         */

    }, {
        key: 'addPageDataWithDataList',
        value: function addPageDataWithDataList(ddBuilder, docDefinition, pageData, pdfPrintParameters, pageIndex) {}
        // abstract


        /**
         * Add page to doc definition if no need show data list
         * @param ddBuilder - doc definition builder
         * @param docDefinition - current doc definition
         * @param pageData - current page data (only image(es))
         * @param pdfPrintParameters - current parameters
         * @param nPages - n rendered pages
         */

    }, {
        key: 'addPageDataWithoutDataList',
        value: function addPageDataWithoutDataList(ddBuilder, docDefinition, pageData, pdfPrintParameters, nPages) {
            // abstract
        }
    }, {
        key: 'getMaxValuesOnPage',
        value: function getMaxValuesOnPage(_ref) {
            var paperOrientation = _ref.paperOrientation,
                paperSize = _ref.paperSize,
                showHeaderOnEachPage = _ref.showHeaderOnEachPage;

            return (0, _ChartPDFDefinitionPartsConstructors.getMaxValuesOnPageProperty)({
                paperOrientation: paperOrientation,
                paperSize: paperSize,
                chartType: this.chartType
            });
        }
    }, {
        key: 'getMaxValuesOnPageWithoutTable',
        value: function getMaxValuesOnPageWithoutTable(_ref2) {
            var paperOrientation = _ref2.paperOrientation,
                paperSize = _ref2.paperSize,
                showHeaderOnEachPage = _ref2.showHeaderOnEachPage;

            return 2 * this.getMaxValuesOnPage({ paperOrientation: paperOrientation, paperSize: paperSize, showHeaderOnEachPage: showHeaderOnEachPage });
        }
    }, {
        key: 'getMaxValuesOnFitPage',
        value: function getMaxValuesOnFitPage(_ref3) {
            var paperOrientation = _ref3.paperOrientation,
                paperSize = _ref3.paperSize,
                showHeaderOnEachPage = _ref3.showHeaderOnEachPage;

            return (0, _ChartPDFDefinitionPartsConstructors.getMaxValuesOnFitPageProperty)({
                paperOrientation: paperOrientation,
                paperSize: paperSize,
                chartType: this.chartType
            });
        }
    }, {
        key: 'getTotalNumberOfPages',
        value: function getTotalNumberOfPages(lengthOfDataList, pdfPrintParameters) {
            // abstract
        }
    }, {
        key: 'getChartImageDimensions',
        value: function getChartImageDimensions(lengthOfDataList, pdfPrintParameters) {
            // abstract
        }
    }]);

    return BaseCreateDefinitionObjectStrategy;
}();

exports.default = BaseCreateDefinitionObjectStrategy;

/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _atUtils = __webpack_require__(5);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _GroupType = __webpack_require__(34);

var _GroupType2 = _interopRequireDefault(_GroupType);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _constants = __webpack_require__(4);

var _date_format = __webpack_require__(16);

var _DateRange = __webpack_require__(304);

var _DateRange2 = _interopRequireDefault(_DateRange);

var _pluralizeUtils = __webpack_require__(40);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var BaseReportParamsStringBuilder = function () {
    function BaseReportParamsStringBuilder(_ref) {
        var data = _ref.data,
            dateFormat = _ref.dateFormat,
            userFormatter = _ref.userFormatter;

        _classCallCheck(this, BaseReportParamsStringBuilder);

        this.DATE_FORMAT = window.SystemSettings.dateFormat;

        this.getFilteredLeaveTypes = function (ids) {
            var result = [];

            for (var i = 0; i < ids.length; i++) {
                if (this.getLeaveType(ids[i])) {
                    result.push(this.getLeaveType(ids[i]));
                }
            }

            return result;
        };

        this.users = data.users ? (0, _atUtils.arrayToMap)(data.users) : {};
        this.userGroups = data.userGroups ? (0, _atUtils.arrayToMap)(data.userGroups) : {};
        this.timeZoneGroups = data.timeZoneGroups ? (0, _atUtils.arrayToMap)(data.timeZoneGroups) : {};
        this.leaveTypesMap = data.leaveTypesMap || {};
        this.statuses = data.statuses;

        this.groupFormatter = {
            format: function format(group) {
                return group.name;
            }
        };

        this.userFormatter = userFormatter;
        this.leaveTypesFormatter = { format: function format(leaveType) {
                return leaveType.name;
            } };

        this.dateFormat = !!dateFormat ? dateFormat : this.DATE_FORMAT;
    }

    _createClass(BaseReportParamsStringBuilder, [{
        key: 'getUser',
        value: function getUser(id) {
            return this.users[id] ? this.users[id] : null;
        }
    }, {
        key: 'getFilteredUsers',
        value: function getFilteredUsers(ids) {
            var _this = this;

            var result = [];

            ids.forEach(function (id) {
                return _this.users[id] && result.push(_this.users[id]);
            });

            return result;
        }
    }, {
        key: 'getGroup',
        value: function getGroup(id) {
            return this.userGroups[id] ? this.userGroups[id] : null;
        }
    }, {
        key: 'getTimeZoneGroup',
        value: function getTimeZoneGroup(id) {
            return this.timeZoneGroups[id] ? this.timeZoneGroups[id] : null;
        }
    }, {
        key: 'getFilteredGroups',
        value: function getFilteredGroups(ids) {
            var _this2 = this;

            var result = [];

            ids.forEach(function (id) {
                return id !== _constants.USERS_WITHOUT_GROUP_ID && _this2.userGroups[id] && result.push(_this2.userGroups[id]);
            });

            return result;
        }
    }, {
        key: 'getFilteredTimeZoneGroups',
        value: function getFilteredTimeZoneGroups(ids) {
            var _this3 = this;

            var result = [];

            ids.forEach(function (id) {
                return _this3.timeZoneGroups[id] && result.push(_this3.timeZoneGroups[id]);
            });

            return result;
        }
    }, {
        key: 'getLeaveType',
        value: function getLeaveType(id) {
            return this.leaveTypesMap[id] ? this.leaveTypesMap[id] : null;
        }
    }, {
        key: 'joinStrings',
        value: function joinStrings(col, separator, lastSeparator) {
            if (col == null || col.length === 0) return "";

            var res = col[0];

            for (var i = 1; i < col.length; i++) {
                if (i === col.length - 1) res += lastSeparator;else res += separator;
                res += col[i];
            }

            return res;
        }
    }, {
        key: 'getTitle',
        value: function getTitle(header, entities, formatter) {
            var list = [];
            var MAX_ENTITIES_IN_THE_TITLE = 12;
            var BULLET_STRING = " - ";
            var ELLIPSIS = "...";

            for (var i = 0; i < entities.length; i++) {
                list.push(formatter.format(entities[i]));
            }
            var result = header;

            for (var _i = 0; _i < list.length; _i++) {
                if (_i >= MAX_ENTITIES_IN_THE_TITLE) break;

                result += "\n" + BULLET_STRING + list[_i];
            }

            if (entities.length > MAX_ENTITIES_IN_THE_TITLE) result += "\n" + ELLIPSIS;

            return result;
        }
    }, {
        key: 'convertToJSON',
        value: function convertToJSON(date) {
            if (_underscore2.default.isString(date)) {
                return date.parseJSONDate();
            }
            return date;
        }
    }, {
        key: 'getUserSelectionParamString',
        value: function getUserSelectionParamString(userSelection, getAllUsersMessage) {
            if (userSelection.allUsers) {
                return getAllUsersMessage();
            } else {
                var groupType = userSelection.groupType;
                var selectedUserWithoutUserGroup = false;
                var users = this.getFilteredUsers(userSelection.selectedUsers);
                var groups = [];

                if (userSelection.groupType === _GroupType2.default.USER_GROUP) {
                    groups = this.getFilteredGroups(userSelection.selectedGroups);
                    selectedUserWithoutUserGroup = _jquery2.default.inArray(_constants.USERS_WITHOUT_GROUP_ID, userSelection.selectedGroups) !== -1;
                }
                if (userSelection.groupType === _GroupType2.default.TIME_ZONE_GROUP) groups = this.getFilteredTimeZoneGroups(userSelection.selectedGroups);

                users = this._convertSelectedGroupsToSelectedUsersIfNecessary(users, userSelection);

                if (userSelection.includeUserTeamOnly) {
                    var includeTeamOnlyMessage = this._getIncludeUserTeamOnlyMessage(users);
                    if (includeTeamOnlyMessage) {
                        return includeTeamOnlyMessage;
                    }
                }

                if (users.length === 0) {
                    if (groups.length === 0 && !selectedUserWithoutUserGroup) {
                        return _messageResource2.default.getMessage("usersselector.no_users_selected");
                    }
                    if (groups.length === 1 && !selectedUserWithoutUserGroup) {
                        return _messageResource2.default.getMessage(groupType === _GroupType2.default.USER_GROUP ? "common.User_Group" : "common.Time_Zone_Group") + " \"" + this.groupFormatter.format(groups[0]) + "\"";
                    }
                    if (groups.length === 0 && selectedUserWithoutUserGroup) {
                        return _messageResource2.default.getMessage("common.users_without_group");
                    }
                }
                if (users.length === 1 && groups.length === 0 && !selectedUserWithoutUserGroup) {
                    return this.userFormatter.format(users[0]);
                }

                var res = [];

                if (groups.length > 0) {
                    var groupsText = groupType === _GroupType2.default.USER_GROUP ? (0, _pluralizeUtils.departmentNameLower)(groups.length) : (0, _pluralizeUtils.tzgNameLower)(groups.length);
                    res.push(groups.length + " " + groupsText);
                }

                if (users.length > 0) {
                    res.push(users.length === 1 ? _messageResource2.default.getMessage("saved_reports.user_selector.one_user") : _messageResource2.default.getMessage("saved_reports.user_selector.multiple_users", [users.length.toString()]));
                }

                if (selectedUserWithoutUserGroup && this.userGroupsFeatureEnabled) {
                    res.push(_messageResource2.default.getMessage("common.users_without_group"));
                }

                return this.joinStrings(res, ", ", " " + _messageResource2.default.getMessage("report.common.and_staff_delimiter") + " ");
            }
        }
    }, {
        key: 'getUserSelectionDetailsString',
        value: function getUserSelectionDetailsString(userSelection) {
            var selectedUserWithoutUserGroup = false;
            var users = this.getFilteredUsers(userSelection.selectedUsers);

            var groups = [];
            if (userSelection.groupType === _GroupType2.default.USER_GROUP) {
                selectedUserWithoutUserGroup = _jquery2.default.inArray(_constants.USERS_WITHOUT_GROUP_ID, userSelection.selectedGroups) !== -1;
                groups = this.getFilteredGroups(userSelection.selectedGroups);
            }

            if (userSelection.groupType === _GroupType2.default.TIME_ZONE_GROUP) {
                groups = this.getFilteredTimeZoneGroups(userSelection.selectedGroups);
            }
            users = this._convertSelectedGroupsToSelectedUsersIfNecessary(users, userSelection);
            if (!userSelection.allUsers && (users.length || groups.length) && !(users.length === 1 && groups.length === 0 && !selectedUserWithoutUserGroup)) {
                var res = [];
                if (users.length > 0) {
                    res.push(this.getTitle(_messageResource2.default.getMessage("saved_reports.user_selector.title_header"), users, this.userFormatter));
                }
                if (groups.length > 0) {
                    res.push(this.getTitle(_messageResource2.default.getMessage(userSelection.groupType === _GroupType2.default.USER_GROUP ? "saved_reports.user_selector.title_header.user_groups" : "saved_reports.user_selector.title_header.time_zone_groups"), groups, this.groupFormatter));
                }

                if (selectedUserWithoutUserGroup && this.userGroupsFeatureEnabled) {
                    res.push(_messageResource2.default.getMessage("common.users_without_group"));
                }

                return this.joinStrings(res, "\n", "\n");
            }
        }
    }, {
        key: 'getUserSelectionClass',
        value: function getUserSelectionClass(userSelection) {
            var CLASS_NAME = "users-filter";
            var ERROR_CLASS_NAME = "error-users-filter";

            var users = this.getFilteredUsers(userSelection.selectedUsers);
            var selectedUserWithoutUserGroup = false;
            var groups = [];
            if (userSelection.groupType === _GroupType2.default.USER_GROUP) {
                groups = this.getFilteredGroups(userSelection.selectedGroups);
                selectedUserWithoutUserGroup = _jquery2.default.inArray(_constants.USERS_WITHOUT_GROUP_ID, userSelection.selectedGroups) !== -1;
            }
            if (userSelection.groupType === _GroupType2.default.TIME_ZONE_GROUP) groups = this.getFilteredTimeZoneGroups(userSelection.selectedGroups);

            users = this._convertSelectedGroupsToSelectedUsersIfNecessary(users, userSelection);

            if (!userSelection.allUsers && users.length === 0 && groups.length === 0 && !selectedUserWithoutUserGroup) {
                return CLASS_NAME + " " + ERROR_CLASS_NAME;
            } else {
                return CLASS_NAME;
            }
        }
    }, {
        key: 'getLeaveTypeSelectionClass',
        value: function getLeaveTypeSelectionClass(leaveTypeSelection) {

            var CLASS_NAME = "leaves-filter";
            var ERROR_CLASS_NAME = "error-leaves-filter";

            if (leaveTypeSelection.qualifier === _constants.LeaveTypeSelectionQualifier.SELECTED) {
                var leaveTypes = this.getFilteredLeaveTypes(leaveTypeSelection.leaveTypes);

                if (leaveTypes.length === 0) return CLASS_NAME + " " + ERROR_CLASS_NAME;
            }
            return CLASS_NAME;
        }
    }, {
        key: 'getLeaveTypeSelectionDetailsString',
        value: function getLeaveTypeSelectionDetailsString(leaveTypeSelection) {

            if (leaveTypeSelection.qualifier !== _constants.LeaveTypeSelectionQualifier.ALL) {
                var leaveTypes = this.getFilteredLeaveTypes(leaveTypeSelection.leaveTypes);

                if (leaveTypes.length === 0 || leaveTypes.length === 1) return ""; //error_class

                return this.getTitle(_messageResource2.default.getMessage("saved_reports.leaves_selector.title_header"), leaveTypes, this.leaveTypesFormatter);
            }
        }
    }, {
        key: 'getLeaveTypeSelectionParamString',
        value: function getLeaveTypeSelectionParamString(leaveTypeSelection) {

            if (leaveTypeSelection.qualifier === _constants.LeaveTypeSelectionQualifier.ALL) return _messageResource2.default.getMessage("leaves_selector.options.all_items");else {
                var leaveTypes = this.getFilteredLeaveTypes(leaveTypeSelection.leaveTypes);

                if (leaveTypes.length === 0) return _messageResource2.default.getMessage("report.leaves.no_leave_types"); //error_class

                if (leaveTypes.length === 1) return _messageResource2.default.getMessage("saved_reports.leaves_selector.single_element", [this.leaveTypesFormatter.format(leaveTypes[0])]);

                return _messageResource2.default.getMessage("saved_reports.leaves_selector.multiple_types", [leaveTypes.length.toString()]);
            }
        }
    }, {
        key: 'getStatusesSelectionParamString',
        value: function getStatusesSelectionParamString(weekApprovalStatuses) {
            if (weekApprovalStatuses.length === 0) {
                return _messageResource2.default.getMessage("common.selector.statuses.no_tt_statuses");
            }

            var showApproved = _underscore2.default.contains(weekApprovalStatuses, _constants.WeekApprovalStatus.APPROVED);
            var showReady = _underscore2.default.contains(weekApprovalStatuses, _constants.WeekApprovalStatus.READY);
            var showNotReady = _underscore2.default.contains(weekApprovalStatuses, _constants.WeekApprovalStatus.NOT_READY);
            var showRejected = _underscore2.default.contains(weekApprovalStatuses, _constants.WeekApprovalStatus.REJECTED);

            if (showApproved && showReady && showNotReady && showRejected) return _messageResource2.default.getMessage("common.selector.statuses.all");

            var messages = [];

            if (showApproved) messages.push(_messageResource2.default.getMessage("common.selector.statuses.approved"));

            if (showReady) messages.push(_messageResource2.default.getMessage("common.selector.statuses.ready"));

            if (showNotReady && showRejected) messages.push(_messageResource2.default.getMessage("common.selector.statuses.not_ready_and_rejected"));else if (showNotReady) messages.push(_messageResource2.default.getMessage("common.selector.statuses.not_ready"));else if (showRejected) messages.push(_messageResource2.default.getMessage("common.selector.statuses.rejected"));

            return messages.join(", ") + " " + _messageResource2.default.getMessage("common.selector.statuses.tt_statuses");
        }
    }, {
        key: 'getDateRangeParamString',
        value: function getDateRangeParamString(dateRangeSelection) {
            if (dateRangeSelection.qualifier !== _constants.DateRangeSelectionQualifier.CUSTOM) {
                return _messageResource2.default.getMessage(DateRangeStateUtil[dateRangeSelection.qualifier]);
            }

            var fromDate = dateRangeSelection.fromDate.parseJSONDate();
            var toDate = dateRangeSelection.toDate.parseJSONDate();

            var dateRange = new _DateRange2.default(fromDate, toDate);
            if (dateRange.isOneDay()) return new _date_format.DateFormat(this.dateFormat).formatDate(fromDate) + ", " + Date.dayNames[fromDate.getDay()];

            return _messageResource2.default.getMessage("range.custom.pattern", [new _date_format.DateFormat(this.dateFormat).formatDate(fromDate), new _date_format.DateFormat(this.dateFormat).formatDate(toDate)]);
        }
    }, {
        key: 'getDateRangeCSVString',
        value: function getDateRangeCSVString(dateRangeSelection) {
            var fromDate = this.convertToJSON(dateRangeSelection.fromDate);
            var toDate = this.convertToJSON(dateRangeSelection.toDate);

            var dateRange = new _DateRange2.default(fromDate, toDate);

            if (dateRange.isOneDay()) return new _date_format.DateFormat(this.dateFormat).formatDate(fromDate) + ", " + Date.dayNames[fromDate.getDay()];

            return _messageResource2.default.getMessage("range.custom.detailed_string", [new _date_format.DateFormat(this.dateFormat).formatDate(fromDate) + ", " + Date.dayNames[fromDate.getDay()], new _date_format.DateFormat(this.dateFormat).formatDate(toDate) + ", " + Date.dayNames[toDate.getDay()]]);
        }
    }, {
        key: 'getDateRangeDetailsString',
        value: function getDateRangeDetailsString(dateRangeSelection) {
            if (dateRangeSelection.qualifier === _constants.DateRangeSelectionQualifier.CUSTOM) return "";

            return _messageResource2.default.getMessage("range.custom.pattern", [new _date_format.DateFormat(this.dateFormat).formatDate(dateRangeSelection.fromDate.parseJSONDate()), new _date_format.DateFormat(this.dateFormat).formatDate(dateRangeSelection.toDate.parseJSONDate())]);
        }
    }, {
        key: 'getBalancesParamString',
        value: function getBalancesParamString(enabledPTO, enabledSick) {
            if (enabledPTO && enabledSick) return _messageResource2.default.getMessage("common.leave.reports.pdf.header.balances");

            if (enabledPTO) return _messageResource2.default.getMessage("common.leave.reports.pdf.header.pto");

            if (enabledSick) return _messageResource2.default.getMessage("common.leave.reports.pdf.header.sick");

            return null;
        }
    }, {
        key: '_convertSelectedGroupsToSelectedUsersIfNecessary',
        value: function _convertSelectedGroupsToSelectedUsersIfNecessary(users, userSelection) {
            // abstract
        }
    }, {
        key: '_getIncludeUserTeamOnlyMessage',
        value: function _getIncludeUserTeamOnlyMessage(users) {
            // abstract
        }
    }]);

    return BaseReportParamsStringBuilder;
}();

exports.default = BaseReportParamsStringBuilder;

/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ChartPDFDateFormattingStrategy = function () {
    function ChartPDFDateFormattingStrategy(dateFormat, dateFormatForFileName) {
        _classCallCheck(this, ChartPDFDateFormattingStrategy);

        this.dateFormat = dateFormat;
        this.dateFormatForFileName = dateFormatForFileName;
    }

    _createClass(ChartPDFDateFormattingStrategy, [{
        key: "formatFileNameDate",
        value: function formatFileNameDate(date) {
            return this.dateFormatForFileName.formatDate(date);
        }
    }, {
        key: "formatDateForFileName",
        value: function formatDateForFileName(dateParameters) {
            // abstract
        }
    }, {
        key: "formatDateInformation",
        value: function formatDateInformation(dateParameters) {
            // abstract
        }
    }]);

    return ChartPDFDateFormattingStrategy;
}();

exports.default = ChartPDFDateFormattingStrategy;

/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DateFormattingStrategy = function () {
    function DateFormattingStrategy(dateFormat) {
        _classCallCheck(this, DateFormattingStrategy);

        this.dateFormat = dateFormat;
    }

    _createClass(DateFormattingStrategy, [{
        key: "formatForDateInformation",
        value: function formatForDateInformation(dateParameters) {
            // abstract
        }
    }, {
        key: "formatSpecifyingInformation",
        value: function formatSpecifyingInformation(dateParameters) {
            // abstract
        }
    }, {
        key: "formatDate",
        value: function formatDate(date) {
            return this.dateFormat.formatDate(date);
        }
    }]);

    return DateFormattingStrategy;
}();

exports.default = DateFormattingStrategy;

/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ChartPDFDateFormattingStrategy = __webpack_require__(804);

var _ChartPDFDateFormattingStrategy2 = _interopRequireDefault(_ChartPDFDateFormattingStrategy);

var _SingleDateFormattingStrategy = __webpack_require__(517);

var _SingleDateFormattingStrategy2 = _interopRequireDefault(_SingleDateFormattingStrategy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ChartPDFSingleDateFormattingStrategy = function (_ChartPDFDateFormatti) {
    _inherits(ChartPDFSingleDateFormattingStrategy, _ChartPDFDateFormatti);

    function ChartPDFSingleDateFormattingStrategy(dateFormat, dateFormatForFileName) {
        _classCallCheck(this, ChartPDFSingleDateFormattingStrategy);

        var _this = _possibleConstructorReturn(this, (ChartPDFSingleDateFormattingStrategy.__proto__ || Object.getPrototypeOf(ChartPDFSingleDateFormattingStrategy)).call(this, dateFormat, dateFormatForFileName));

        _this.previewDateFormatStrategy = new _SingleDateFormattingStrategy2.default(dateFormat); // for use methods from lightbox preview header formatter
        return _this;
    }

    _createClass(ChartPDFSingleDateFormattingStrategy, [{
        key: 'formatDateInformation',
        value: function formatDateInformation(dateParameters) {
            return this.previewDateFormatStrategy.formatForDateInformation(dateParameters) + " " + this.previewDateFormatStrategy.formatSpecifyingInformation(dateParameters);
        }
    }, {
        key: 'formatDateForFileName',
        value: function formatDateForFileName(dateParameters) {
            return this.formatFileNameDate(dateParameters.dateSelection.date);
        }
    }]);

    return ChartPDFSingleDateFormattingStrategy;
}(_ChartPDFDateFormattingStrategy2.default);

exports.default = ChartPDFSingleDateFormattingStrategy;

/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DEFAULT_DELAY = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _TableTooltip2 = __webpack_require__(237);

var _TableTooltip3 = _interopRequireDefault(_TableTooltip2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DEFAULT_DELAY = exports.DEFAULT_DELAY = 500; // 0.5 sec

/**
 *
 * @param tooltipId id of tooltip element
 * @param delay delay in ms before tooltip will be showed (0.5 sec by default)
 * @returns {DelayTooltip}
 */

var DelayTooltip = function (_TableTooltip) {
    _inherits(DelayTooltip, _TableTooltip);

    function DelayTooltip() {
        _classCallCheck(this, DelayTooltip);

        return _possibleConstructorReturn(this, (DelayTooltip.__proto__ || Object.getPrototypeOf(DelayTooltip)).apply(this, arguments));
    }

    _createClass(DelayTooltip, [{
        key: "init",
        value: function init(tooltipId, delay) {
            _get(DelayTooltip.prototype.__proto__ || Object.getPrototypeOf(DelayTooltip.prototype), "init", this).call(this, tooltipId);

            if (delay) {
                this.delay = delay;
            } else {
                this.delay = DEFAULT_DELAY;
            }
            this.isDelayed = true;

            this.hide(); // hide tooltip after init

            return this;
        }
    }, {
        key: "showWithDelay",
        value: function showWithDelay() {
            var _this2 = this;

            this.tooltipDelayTimer = setTimeout(function () {
                _this2._setVisible(true); // show tooltip
            }, this.delay);
        }
    }, {
        key: "updateUIAndShow",
        value: function updateUIAndShow(config, offset) {
            _get(DelayTooltip.prototype.__proto__ || Object.getPrototypeOf(DelayTooltip.prototype), "updateUIAndShow", this).call(this, config, offset);
            if (this.isDelayed) {
                this.showWithDelay(); // show after delay
            } else {
                this._setVisible(true);
            }
        }
    }, {
        key: "hide",
        value: function hide() {
            if (this.tooltipDelayTimer && this.isDelayed) {
                clearTimeout(this.tooltipDelayTimer);
            }
            this._setVisible(false); // hide tooltip
            _get(DelayTooltip.prototype.__proto__ || Object.getPrototypeOf(DelayTooltip.prototype), "hide", this).call(this);
        }
    }, {
        key: "_setVisible",
        value: function _setVisible(isVisible) {
            if (isVisible) {
                this._tooltipEl.css("visibility", "visible");
            } else {
                this._tooltipEl.css("visibility", "hidden");
            }
        }

        /**
         * on/off delay
         * @param isDelayed
         */

    }, {
        key: "needDelay",
        value: function needDelay(isDelayed) {
            this.isDelayed = isDelayed;
        }

        /**
         * set value of delay
         * @param newDelay
         */

    }, {
        key: "setDelay",
        value: function setDelay(newDelay) {
            this.delay = newDelay;
        }
    }]);

    return DelayTooltip;
}(_TableTooltip3.default);

exports.default = DelayTooltip;

/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _UserGroup = __webpack_require__(1497);

var _UserGroup2 = _interopRequireDefault(_UserGroup);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _atUtils = __webpack_require__(5);

var _atBrowserUtils = __webpack_require__(8);

var _TableRow = __webpack_require__(250);

var _TableRow2 = _interopRequireDefault(_TableRow);

var _DatesRow = __webpack_require__(1506);

var _DatesRow2 = _interopRequireDefault(_DatesRow);

var _RunnerRow = __webpack_require__(1508);

var _RunnerRow2 = _interopRequireDefault(_RunnerRow);

var _date_format = __webpack_require__(16);

var _lock_table = __webpack_require__(1510);

var _SelectionScrollController = __webpack_require__(1522);

var _SelectionScrollController2 = _interopRequireDefault(_SelectionScrollController);

var _SelectionVeil = __webpack_require__(1523);

var _SelectionVeil2 = _interopRequireDefault(_SelectionVeil);

var _LockEventsHandler = __webpack_require__(1524);

var _LockEventsHandler2 = _interopRequireDefault(_LockEventsHandler);

var _LockTable = __webpack_require__(1527);

var _LockTable2 = _interopRequireDefault(_LockTable);

var _LockTableTooltipController = __webpack_require__(1540);

var _LockTableTooltipController2 = _interopRequireDefault(_LockTableTooltipController);

var _RunnerController = __webpack_require__(1541);

var _RunnerController2 = _interopRequireDefault(_RunnerController);

var _CommentsController = __webpack_require__(1542);

var _CommentsController2 = _interopRequireDefault(_CommentsController);

var _ExpandedUsersStorage = __webpack_require__(1543);

var _ExpandedUsersStorage2 = _interopRequireDefault(_ExpandedUsersStorage);

var _LockTTStore = __webpack_require__(526);

var _LockTTStore2 = _interopRequireDefault(_LockTTStore);

var _TaskRow = __webpack_require__(813);

var _TaskRow2 = _interopRequireDefault(_TaskRow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var LockTTTableController = function () {
    function LockTTTableController() {
        _classCallCheck(this, LockTTTableController);
    }

    _createClass(LockTTTableController, [{
        key: "init",
        value: function init() {
            return this;
        }
    }, {
        key: "createLockTable",
        value: function createLockTable(containerElement, onLockedTillDateChange) {
            var dateFormat = _LockTTStore2.default.getDateFormat();
            var dateParser = {
                parse: function parse(dateStr) {
                    return parseDate(dateStr, TimeUtils.UNIFORM_DATE_FORMAT);
                }
            };

            var userGroupsList = [];
            var table = this._createTableObj(dateFormat, userGroupsList, onLockedTillDateChange);
            table.buildDOM(containerElement);
            for (var i = 0; i < userGroupsList.length; i++) {
                userGroupsList[i].fitHeightOnBuildDomComplete();
            }

            this.userGroupsList = userGroupsList;

            var scrollController = new _SelectionScrollController2.default();
            scrollController.linkTo(table);

            var selectionVeil = new _SelectionVeil2.default(_LockTTStore2.default.getSelectionVeilImages(), (0, _jquery2.default)(".lockTableWrapper")[0]);
            table.addLockEventsListener(new _LockEventsHandler2.default(dateFormat, dateParser, _LockTTStore2.default.getTimestamp(), selectionVeil, table.clearSelection, table, new _date_format.DateFormat("MMM dd")));
            if (!_LockTTStore2.default.isLockTableImagesLoaded()) {
                _LockTTStore2.default.setLockTableImagesLoaded(true);
                setTimeout(preloadLockTableImages, 500);
            }
        }
    }, {
        key: "_createTableObj",
        value: function _createTableObj(dateFormat, userGroupsList, onLockedTillDateChange) {
            var userMap = this._convertBeanArrayToMap(_LockTTStore2.default.getUsers().concat(_LockTTStore2.default.getDeletedUsers()));
            var table = new _LockTable2.default(_LockTTStore2.default.getLoggedInUserToday(), _LockTTStore2.default.getWeekStartDay() - 1);
            var selectionController = table.getSelectionController();
            var hoverController = table.getHoverController();
            var tooltipController = new _LockTableTooltipController2.default(userMap, "lockDayTitle", Date.dayNamesShort);
            var runnerController = new _RunnerController2.default(_LockTTStore2.default.getLockedTillDate(), selectionController, hoverController, _LockTTStore2.default.getAllLockedTillDateBeyondDateRange());
            runnerController.addPositionChangeListener(onLockedTillDateChange);
            table.init(runnerController, tooltipController, new _CommentsController2.default(dateFormat));
            selectionController.setLockTable(table);
            var expandedUsersStorage = new _ExpandedUsersStorage2.default();

            //header rows
            var note = null;
            if (_LockTTStore2.default.getDisabledUsersSelected()) {
                note = {
                    imgPath: (0, _atBrowserUtils.atImgPath)("note_mark.gif"),
                    text: _messageResource2.default.getMessage("lock_tt.table.header.disabled_users_note")
                };
            }
            var order = _LockTTStore2.default.getSortingOrder();
            var topMessageKey = "lock_tt.table.header.users_tasks";
            if (order == UserListSortConstant.ORDER_BY_USER_GROUP) {
                topMessageKey = "lock_tt.table.header.groups_users";
            } else if (order == UserListSortConstant.ORDER_BY_TIME_ZONE_GROUP) {
                topMessageKey = "lock_tt.table.header.time_zone_groups_users";
            }

            var topMessage = _messageResource2.default.getEscapedMessage(topMessageKey);
            var sortByLink = "";
            var isUserGroupEnabled = _LockTTStore2.default.getEnabledFeatures().UGR;
            var isTimeZoneGroupEnabled = _LockTTStore2.default.getEnabledFeatures().TZG;
            var onlyOneFeatureEnabled = isUserGroupEnabled ^ isTimeZoneGroupEnabled;
            var showDetails = !_LockTTStore2.default.isHideDetailsOnLockTT();

            if (isUserGroupEnabled || isTimeZoneGroupEnabled) {
                sortByLink = showDetails ? ' | ' : '';
                var createSortLink = function createSortLink(sortBy, text) {
                    return '<a data-sortBy=' + sortBy + ' href="javascript:void(0);" onclick="changeSortingOrder(this)" class="changeSortingOrder noprint">' + text + "</a>\xA0\xA0";
                };
                if (order != UserListSortConstant.ORDER_BY_USERNAME) {
                    sortByLink += createSortLink(UserListSortConstant.ORDER_BY_USERNAME, _messageResource2.default.getMessage(onlyOneFeatureEnabled ? "lock_tt.table.header.sort_by_user_name" : "lock_tt.table.header.by_user"));
                }
                if (order != UserListSortConstant.ORDER_BY_USER_GROUP && isUserGroupEnabled) {
                    sortByLink += createSortLink(UserListSortConstant.ORDER_BY_USER_GROUP, _messageResource2.default.getMessage(onlyOneFeatureEnabled ? "lock_tt.table.header.sort_by_user_group" : "lock_tt.table.header.by_group"));
                }
                if (order != UserListSortConstant.ORDER_BY_TIME_ZONE_GROUP && isTimeZoneGroupEnabled) {
                    sortByLink += createSortLink(UserListSortConstant.ORDER_BY_TIME_ZONE_GROUP, _messageResource2.default.getMessage(onlyOneFeatureEnabled ? "lock_tt.table.header.sort_by_time_zone" : "lock_tt.table.header.by_time_zone"));
                }
            }

            (0, _lock_table.buildMonthRow)(table, _LockTTStore2.default.getMonths(), true, note, topMessage, sortByLink, showDetails);

            var runner = new _RunnerRow2.default();
            var datesRow = new _DatesRow2.default(Date.dayNamesShort);
            datesRow.addCellObjWithoutAppend(_TableRow2.default.prototype.createCellObj(null));
            runner.addCellObjWithoutAppend(_TableRow2.default.prototype.createCellObj(null));

            _underscore2.default.each(_LockTTStore2.default.getHeaderData(), function (headerDatum) {
                var isRunnerOver = !_underscore2.default.isNull(_LockTTStore2.default.getLockedTillDate()) && headerDatum.date <= _LockTTStore2.default.getLockedTillDate();
                (0, _lock_table.addHeaderCells)(datesRow, runner, headerDatum.date, headerDatum.isHoliday, isRunnerOver, headerDatum.hasLockedInvisibleUser, headerDatum.hasUnlockedInvisibleUser);
            });

            table.addRow(runner);
            table.addDatesRow(datesRow);

            //User rows
            var isFirstGroup = true;
            var previousGroup = void 0;
            var from = _LockTTStore2.default.getDateRangeConfig().fromDate;
            var to = _LockTTStore2.default.getDateRangeConfig().toDate;
            var columnCount = to.offsetInDaysFrom(from) + 1;
            _underscore2.default.each(_LockTTStore2.default.getUserDataGroups(), function (userGroupObj) {
                var label = (0, _atUtils.escapeHtmlSymbols)(userGroupObj.label);
                if (userGroupObj.continued) {
                    label += " " + _messageResource2.default.getMessage("lock_tt.table.user_group.continued_suffix");
                }
                if (_underscore2.default.isNull(userGroupObj.usersData) || userGroupObj.usersData.length == 0) {
                    (0, _lock_table.addSeparateRow)(table, columnCount, isFirstGroup, label);
                    previousGroup = null;
                } else {
                    if (previousGroup) {
                        previousGroup.removeBottomBorder();
                    }
                    var userGroup = new _UserGroup2.default(label);
                    previousGroup = userGroup;
                    userGroupsList.push(userGroup);
                    var _showDetails = !_LockTTStore2.default.isHideDetailsOnLockTT();

                    _underscore2.default.each(userGroupObj.usersData, function (userDatum) {
                        _underscore2.default.each(userDatum.userRowValues, function (userRowValue) {
                            userRowValue.lockDate = !userRowValue.lockDate ? null : _underscore2.default.isString(userRowValue.lockDate) ? Date.parseJSONDate(userRowValue.lockDate) : userRowValue.lockDate;
                        });
                        _underscore2.default.each(userDatum.userRowApproveValues, function (userRowApproveValue) {
                            userRowApproveValue.approvedDate = !userRowApproveValue.approvedDate ? null : _underscore2.default.isString(userRowApproveValue.approvedDate) ? Date.parseJSONDate(userRowApproveValue.approvedDate) : userRowApproveValue.approvedDate;
                        });

                        var userRow = (0, _lock_table.addUserRow)(userGroup, table, userMap[userDatum.userId], userDatum.userRowValues, userDatum.userRowApproveValues, userDatum.workingDays, expandedUsersStorage, Date.parseJSONDate(userDatum.userToday));
                        var leaveTimeText = _messageResource2.default.getMessage("lock_tt.table.leave_time");

                        if (_showDetails) {
                            _underscore2.default.each(userDatum.leaveTypes, function (leaveTypeInfo) {
                                var leaveType = LeaveTypeStore.getLeaveType(leaveTypeInfo.leaveTypeId);
                                (0, _lock_table.addLeaveTypeToUserRow)(userRow, {
                                    name: (0, _atUtils.escapeHtmlSymbols)(leaveType.name),
                                    iconPath: getLeaveTypeIconPath(leaveType.iconId),
                                    printIconPath: getLeaveTypePrintIconPath(leaveType.iconId)
                                }, leaveTypeInfo.leaveRowValues, leaveTimeText);
                            });
                        }

                        if (_showDetails) {
                            _underscore2.default.each(userDatum.tasks, function (userTask) {
                                userTask.task.projectName = (0, _atUtils.escapeHtmlSymbols)(userTask.task.projectName);
                                userTask.task.customerName = (0, _atUtils.escapeHtmlSymbols)(userTask.task.customerName);
                                (0, _lock_table.addTaskRow)(userRow, userTask.task, userTask.taskRowValues);
                            });
                        }

                        if (_showDetails) {
                            if (!_underscore2.default.isNull(userDatum.otherTasksTime)) {
                                var message = _messageResource2.default.getEscapedMessage(userDatum.tasks.length == 0 ? "lock_tt.table.tasks_not_assigned" : "lock_tt.table.other_tasks_not_assigned");
                                (0, _lock_table.addOtherTasksRow)(userRow, message, userDatum.otherTasksTime);
                            }
                        }

                        if (_showDetails) {
                            if (userDatum.showOvertime) {
                                if (!_underscore2.default.isNull(userDatum.reportedOvertime)) {
                                    (0, _lock_table.addOvertimeRow)(userRow, _messageResource2.default.getMessage("lock_tt.table.overtime_row.reported", [_messageResource2.default.getMessage("overtime.overtime")]), userDatum.reportedOvertime);
                                }
                                (0, _lock_table.addOvertimeRow)(userRow, _messageResource2.default.getMessage("lock_tt.table.overtime_row.auto_calculated", [_messageResource2.default.getMessage("overtime.overtime_lower_case")]), userDatum.autocalculatedOvertime);
                            }
                        }
                    });
                    isFirstGroup = false;
                }
            });
            (0, _lock_table.addBottomBorderRow)(table, columnCount);
            return table;
        }
    }, {
        key: "_convertBeanArrayToMap",
        value: function _convertBeanArrayToMap(beans) {
            var map = [];
            for (var i = 0; i < beans.length; i++) {
                var bean = beans[i];
                map[bean.id] = bean;
            }
            return map;
        }
    }, {
        key: "_updateTask",
        value: function _updateTask(task) {
            this.userGroupsList.forEach(function (userGroup) {
                userGroup.userRows.forEach(function (userRow) {
                    userRow.childRows.forEach(function (childRow) {
                        var cell = childRow.cells[0];
                        if (childRow instanceof _TaskRow2.default && cell.value.id === task.id) {
                            cell.value.name = task.name;
                            cell.value.completed = task.completed;
                            cell.value.workflowStatusId = task.workflowStatusId;
                            cell.value.commentsNumber = task.commentsNumber;
                            cell.updateCell();
                        }
                    });
                });
            });
        }
    }]);

    return LockTTTableController;
}();

exports.default = LockTTTableController;

/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _DetailsRow2 = __webpack_require__(520);

var _DetailsRow3 = _interopRequireDefault(_DetailsRow2);

var _OvertimeCellRenderer = __webpack_require__(1500);

var _OvertimeCellRenderer2 = _interopRequireDefault(_OvertimeCellRenderer);

var _OvertimeDayDetailsCellRenderer = __webpack_require__(1501);

var _OvertimeDayDetailsCellRenderer2 = _interopRequireDefault(_OvertimeDayDetailsCellRenderer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OvertimeRow = function (_DetailsRow) {
    _inherits(OvertimeRow, _DetailsRow);

    function OvertimeRow() {
        _classCallCheck(this, OvertimeRow);

        return _possibleConstructorReturn(this, (OvertimeRow.__proto__ || Object.getPrototypeOf(OvertimeRow)).apply(this, arguments));
    }

    _createClass(OvertimeRow, [{
        key: "createRowHeaderRenderer",
        value: function createRowHeaderRenderer() {
            var topBorderClass = "";
            if (this.isFirstChildRow()) topBorderClass = "detailsRowSeparator";else if (this.hasRowSeparator()) topBorderClass = "overtimeTopBorder";
            return new _OvertimeCellRenderer2.default(topBorderClass, this.getAdditionalClass("Header"));
        }
    }, {
        key: "createLockCellRenderer",
        value: function createLockCellRenderer() {
            return new _OvertimeDayDetailsCellRenderer2.default("odd DayDetailsCell", this.getTopBorderClassName(), this.getAdditionalClass(""));
        }
    }, {
        key: "getTopBorderClassName",
        value: function getTopBorderClassName() {
            if (this.isFirstChildRow()) return "detailsRowSeparator";
            if (this.hasRowSeparator()) return "detailsInnerOvertimeRowSeparator";

            return "";
        }
    }, {
        key: "hasRowSeparator",
        value: function hasRowSeparator() {
            var childRows = this.getParentRow().getChildRows();
            for (var i = 0; i < childRows.length; i++) {
                var childRow = childRows[i];
                if (childRow instanceof OvertimeRow) {
                    return childRow.getRowIdx() == this.getRowIdx();
                }
            }
        }
    }, {
        key: "getAdditionalClass",
        value: function getAdditionalClass(postfix) {
            if (!this.hasRowSeparator()) return "secondOvertimeRow" + postfix;else if (this.getParentRow().getLastChildRow().getRowIdx() != this.getRowIdx()) return "firstOvertimeRow" + postfix;

            return "";
        }
    }]);

    return OvertimeRow;
}(_DetailsRow3.default);

exports.default = OvertimeRow;

/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _LockTableCellRenderer = __webpack_require__(123);

var _LockTableCellRenderer2 = _interopRequireDefault(_LockTableCellRenderer);

var _user_time = __webpack_require__(30);

var _user_time2 = _interopRequireDefault(_user_time);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DayCellRenderer = function (_LockTableCellRendere) {
    _inherits(DayCellRenderer, _LockTableCellRendere);

    function DayCellRenderer() {
        _classCallCheck(this, DayCellRenderer);

        return _possibleConstructorReturn(this, (DayCellRenderer.__proto__ || Object.getPrototypeOf(DayCellRenderer)).apply(this, arguments));
    }

    _createClass(DayCellRenderer, [{
        key: "generateContent",
        value: function generateContent(cell) {
            this.buildContent(cell);
            this.addTooltip(cell);
        }
    }, {
        key: "buildContent",
        value: function buildContent(cell) {
            cell.getCellEl().innerHTML = this.parseTime(cell.getValue());
        }
    }, {
        key: "parseTime",
        value: function parseTime(time) {
            return time != 0 ? _user_time2.default.formatTime(time) : "&nbsp;";
        }
    }, {
        key: "addTooltip",
        value: function addTooltip(cell) {
            //Note: should be implemented in inheritor
        }
    }, {
        key: "getLeftBorderSpecificClassName",
        value: function getLeftBorderSpecificClassName(cell) {
            var prevColIdx = cell.getColIdx() - 1;
            if (this.isHovered(cell) || this.isHovered(cell.getRow().getCell(prevColIdx))) {
                return "hoveredDayCellLeftBorder";
            }
            return "";
        }
    }]);

    return DayCellRenderer;
}(_LockTableCellRenderer2.default);

exports.default = DayCellRenderer;

/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _LockTableCellRenderer = __webpack_require__(123);

var _LockTableCellRenderer2 = _interopRequireDefault(_LockTableCellRenderer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EmptyCellRenderer = function (_LockTableCellRendere) {
    _inherits(EmptyCellRenderer, _LockTableCellRendere);

    function EmptyCellRenderer() {
        _classCallCheck(this, EmptyCellRenderer);

        return _possibleConstructorReturn(this, (EmptyCellRenderer.__proto__ || Object.getPrototypeOf(EmptyCellRenderer)).apply(this, arguments));
    }

    _createClass(EmptyCellRenderer, [{
        key: "generateContent",
        value: function generateContent(cell) {}
    }, {
        key: "updateUI",
        value: function updateUI(cell) {}
    }]);

    return EmptyCellRenderer;
}(_LockTableCellRenderer2.default);

exports.default = EmptyCellRenderer;

/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _DetailsRow2 = __webpack_require__(520);

var _DetailsRow3 = _interopRequireDefault(_DetailsRow2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BaseTaskRow = function (_DetailsRow) {
    _inherits(BaseTaskRow, _DetailsRow);

    function BaseTaskRow() {
        _classCallCheck(this, BaseTaskRow);

        return _possibleConstructorReturn(this, (BaseTaskRow.__proto__ || Object.getPrototypeOf(BaseTaskRow)).apply(this, arguments));
    }

    _createClass(BaseTaskRow, [{
        key: "appendOddEvenPrefix",
        value: function appendOddEvenPrefix(baseClass) {
            return (this.isOddRow() ? "odd" : "even") + " " + baseClass;
        }
    }, {
        key: "getTopBorderClass",
        value: function getTopBorderClass() {
            if (this.isFirstChildRow()) return "detailsRowSeparator";

            if (this.hasRowSeparator()) return "detailsInnerRowSeparator";
        }
    }, {
        key: "hasRowSeparator",
        value: function hasRowSeparator() {
            var childRows = this.getParentRow().getChildRows();
            for (var i = 0; i < childRows.length; i++) {
                var childRow = childRows[i];
                if (childRow instanceof BaseTaskRow) {
                    return childRow.getRowIdx() == this.getRowIdx();
                }
            }
        }
    }, {
        key: "isOddRow",
        value: function isOddRow() {
            var childRows = this.getParentRow().getChildRows();
            var firstTaskRow = null;
            for (var i = 0; i < childRows.length; i++) {
                var childRow = childRows[i];
                if (childRow instanceof BaseTaskRow) {
                    if (firstTaskRow == null) firstTaskRow = childRow;

                    if (childRow.getRowIdx() == this.getRowIdx()) return (childRow.getRowIdx() - firstTaskRow.getRowIdx()) % 2;
                }
            }
        }
    }]);

    return BaseTaskRow;
}(_DetailsRow3.default);

exports.default = BaseTaskRow;

/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _BaseTaskRow2 = __webpack_require__(812);

var _BaseTaskRow3 = _interopRequireDefault(_BaseTaskRow2);

var _LockTableTaskNameCellRenderer = __webpack_require__(1517);

var _LockTableTaskNameCellRenderer2 = _interopRequireDefault(_LockTableTaskNameCellRenderer);

var _TaskDayCellRenderer = __webpack_require__(1520);

var _TaskDayCellRenderer2 = _interopRequireDefault(_TaskDayCellRenderer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TaskRow = function (_BaseTaskRow) {
    _inherits(TaskRow, _BaseTaskRow);

    function TaskRow(taskDetailsFunc) {
        _classCallCheck(this, TaskRow);

        var _this = _possibleConstructorReturn(this, (TaskRow.__proto__ || Object.getPrototypeOf(TaskRow)).call(this));

        _this.taskDetailsFunc = taskDetailsFunc;
        return _this;
    }

    _createClass(TaskRow, [{
        key: "createRowHeaderRenderer",
        value: function createRowHeaderRenderer() {
            var cssClasses = "TaskCell";
            if (this.getHeaderCell().getValue().available) {
                cssClasses = this.appendOddEvenPrefix(cssClasses);
            } else {
                cssClasses += " notAvailableTaskCell";
            }

            if (this.isFirstChildRow()) {
                cssClasses += " detailsRowSeparator";
            } else if (this.hasRowSeparator()) {
                cssClasses += " taskNameTopBorder";
            } else if (!this.getHeaderCell().getValue().available) {
                cssClasses += " notAvailableTaskTopBorder";
            }
            return new _LockTableTaskNameCellRenderer2.default(cssClasses, this.taskDetailsFunc);
        }
    }, {
        key: "getTopBorderClass",
        value: function getTopBorderClass(cell) {
            var topBorderClass = _BaseTaskRow3.default.prototype.getTopBorderClass.call(this);
            if (!topBorderClass && this.isFirstNotAvailableChildRow()) {
                return "notAvailableTaskDetailsTopSeparator";
            }
            return topBorderClass;
        }
    }, {
        key: "isFirstNotAvailableChildRow",
        value: function isFirstNotAvailableChildRow() {
            if (this.getHeaderCell().getValue().available) {
                return false;
            }
            var childRows = this.getParentRow().getChildRows();
            for (var i = 0; i < childRows.length; i++) {
                var childRow = childRows[i];
                if (childRow instanceof _BaseTaskRow3.default && !childRow.getHeaderCell().getValue().available) {
                    return childRow.getRowIdx() == this.getRowIdx();
                }
            }
            return false;
        }
    }, {
        key: "createLockCellRenderer",
        value: function createLockCellRenderer() {
            return new _TaskDayCellRenderer2.default(this.getHeaderCell().getValue().available, this.appendOddEvenPrefix("DayDetailsCell"), this.getTopBorderClass(), this.getHeaderCell().getValue().completed);
        }
    }]);

    return TaskRow;
}(_BaseTaskRow3.default);

exports.default = TaskRow;

/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SelectionUpdater = function () {
    function SelectionUpdater(lockTable, selection, veilText, selectionVeil) {
        _classCallCheck(this, SelectionUpdater);

        this.lockTable = lockTable;
        this.selection = selection;
        this.veilText = veilText;
        this.selectionVeil = selectionVeil;

        if (lockTable) this.runnerController = lockTable.getRunnerController();
    }

    _createClass(SelectionUpdater, [{
        key: "beforeRpcCall",
        value: function beforeRpcCall() {
            this.selectionVeil.showOver(this.selection, this.veilText);
            this.lockTable.setIgnoreUserActivity(true);
        }
    }, {
        key: "afterRpcCall",
        value: function afterRpcCall(success) {
            if (!success) this.onUpdateComplete();
        }
    }, {
        key: "handleRpcCallResult",
        value: function handleRpcCallResult(result) {
            this.handleResult(result);
            this.onUpdateComplete();
        }
    }, {
        key: "onUpdateComplete",
        value: function onUpdateComplete() {
            this.selectionVeil.hide();
            this.lockTable.clearSelection();
            this.lockTable.setIgnoreUserActivity(false);
        }
    }, {
        key: "handleResult",
        value: function handleResult(result) {
            //depends on perfoming action (lock/unlock)
            //implemented in inheritors
        }
    }]);

    return SelectionUpdater;
}();

exports.default = SelectionUpdater;

/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _BaseSelectionType2 = __webpack_require__(522);

var _BaseSelectionType3 = _interopRequireDefault(_BaseSelectionType2);

var _SelectedData = __webpack_require__(523);

var _SelectedData2 = _interopRequireDefault(_SelectedData);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DateSelectionType = function (_BaseSelectionType) {
    _inherits(DateSelectionType, _BaseSelectionType);

    function DateSelectionType() {
        _classCallCheck(this, DateSelectionType);

        return _possibleConstructorReturn(this, (DateSelectionType.__proto__ || Object.getPrototypeOf(DateSelectionType)).apply(this, arguments));
    }

    _createClass(DateSelectionType, [{
        key: "accept",
        value: function accept(visitor, selectedRegion) {
            return visitor.visitDateSelection(selectedRegion);
        }
    }, {
        key: "getSelectedData",
        value: function getSelectedData(lockTable, selectedRegion) {
            return new _SelectedData2.default(this.getSelectionDateRange(lockTable.getDatesRow(), selectedRegion), null);
        }
    }, {
        key: "canBeLocked",
        value: function canBeLocked(lockTable, selectedRegion) {
            var datesRow = lockTable.getDatesRow();
            for (var colIdx = selectedRegion.colMin; colIdx <= selectedRegion.colMax; colIdx++) {
                if (datesRow.getCell(colIdx).getValue().hasUnlockedInvisibleUser) return true;
            }

            var userRows = lockTable.getUserRows(selectedRegion.rowMin, selectedRegion.rowMax);
            for (var i = 0; i < userRows.length; i++) {
                var row = userRows[i];
                for (var _colIdx = selectedRegion.colMin; _colIdx <= selectedRegion.colMax; _colIdx++) {
                    if (!row.getCell(_colIdx).getValue().locked) return true;
                }
            }
            return false;
        }
    }, {
        key: "canBeUnlocked",
        value: function canBeUnlocked(lockTable, selectedRegion) {
            var datesRow = lockTable.getDatesRow();
            for (var colIdx = selectedRegion.colMin; colIdx <= selectedRegion.colMax; colIdx++) {
                if (datesRow.getCell(colIdx).getValue().hasLockedInvisibleUser) return true;
            }

            var userRows = lockTable.getUserRows(selectedRegion.rowMin, selectedRegion.rowMax);
            for (var i = 0; i < userRows.length; i++) {
                var row = userRows[i];
                for (var _colIdx2 = selectedRegion.colMin; _colIdx2 <= selectedRegion.colMax; _colIdx2++) {
                    if (row.getCell(_colIdx2).getValue().locked) return true;
                }
            }
            return false;
        }
    }]);

    return DateSelectionType;
}(_BaseSelectionType3.default);

exports.default = DateSelectionType;

/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _NullTableRegion = __webpack_require__(144);

var _NullTableRegion2 = _interopRequireDefault(_NullTableRegion);

var _TableRegion = __webpack_require__(145);

var _TableRegion2 = _interopRequireDefault(_TableRegion);

var _TableRegionChangeEvent = __webpack_require__(524);

var _TableRegionChangeEvent2 = _interopRequireDefault(_TableRegionChangeEvent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SelectionController = function () {
    function SelectionController() {
        _classCallCheck(this, SelectionController);

        this.selectedRegion = _NullTableRegion2.default;
        this.selectionAnchor = null;
        this.listeners = [];
    }

    /**
     * Subscribe specified listener to change selection notification.
     *
     * @param listener listener
     */


    _createClass(SelectionController, [{
        key: "addSelectionChangeListener",
        value: function addSelectionChangeListener(listener) {
            this.listeners.push(listener);
        }
    }, {
        key: "fireSelectionChangeEvent",
        value: function fireSelectionChangeEvent(oldSelection) {
            var selectionChangeEvent = new _TableRegionChangeEvent2.default(oldSelection, this.getSelection());
            for (var i = 0; i < this.listeners.length; i++) {
                this.listeners[i].call(this.listeners[i], selectionChangeEvent);
            }
        }

        /**
         * @return {Boolean} true if selection not null, otherwise false.
         */

    }, {
        key: "hasSelection",
        value: function hasSelection() {
            return this.selectedRegion !== _NullTableRegion2.default;
        }

        /**
         * Gets current selection.
         * Note: selection can be empty (Selection.region == null)
         *
         * @return {Selection} selection
         */

    }, {
        key: "getSelection",
        value: function getSelection() {
            return this.selectedRegion;
        }

        /**
         * Create new selection.
         *
         * @return {TableRegion} selection
         */

    }, {
        key: "createSelection",
        value: function createSelection(cell) {
            return _TableRegion2.default.prototype.createFromCells(this.selectionAnchor, cell);
        }

        /**
         * Sets current selection to null.
         * Sets selection anchor to null.
         */

    }, {
        key: "clearSelection",
        value: function clearSelection() {
            this.selectionAnchor = null;
            if (this.hasSelection()) {
                var oldSelection = this.getSelection();
                this.selectedRegion = _NullTableRegion2.default;
                this.fireSelectionChangeEvent(oldSelection);
            }
        }

        /**
         * Sets selection anchor. Selection calculation performs relatively this cell.
         * Not change current selection.
         * See also changeSelectionTo method.
         *
         * @param {TableCell} cell - table cell
         */

    }, {
        key: "setSelectionAnchor",
        value: function setSelectionAnchor(cell) {
            this.selectionAnchor = cell;
        }

        /**
         * Gets selection anchor. Selection calculation performs relatively this cell.
         *
         * @return {TableCell}
         */

    }, {
        key: "getSelectionAnchor",
        value: function getSelectionAnchor() {
            return this.selectionAnchor;
        }

        /**
         * Selects rectangular region between selection anchor cell and specified cell.
         * Specified cell uses as selection anchor if current selection anchor is null.
         *
         * @param {TableCell} cell - table cell
         */

    }, {
        key: "changeSelectionTo",
        value: function changeSelectionTo(cell) {
            if (this.selectionAnchor == null) this.setSelectionAnchor(cell);
            this.changeSelectionFromAnchorToCell(cell);
        }

        /**
         * Selects rectangular region between specified cells.
         *
         * @param {TableCell} cell1 - table cell
         * @param {TableCell} cell2 - table cell
         */

    }, {
        key: "changeSelection",
        value: function changeSelection(cell1, cell2) {
            if (this.selectionAnchor == null) this.setSelectionAnchor(cell1);
            this.changeSelectionFromAnchorToCell(cell2);
        }
    }, {
        key: "changeSelectionFromAnchorToCell",
        value: function changeSelectionFromAnchorToCell(cell) {
            var oldSelection = this.getSelection();
            this.selectedRegion = this.createSelection(cell);
            this.fireSelectionChangeEvent(oldSelection);
        }

        /**
         * Determines is selection contains cell with specified row and column indexes.
         *
         * @param {Number} rowIdx - row index
         * @param {Number} colIdx - column index
         */

    }, {
        key: "isSelected",
        value: function isSelected(rowIdx, colIdx) {
            return this.selectedRegion.contains(rowIdx, colIdx);
        }

        /**
         * Determines is selection contains cell from specified column.
         *
         * @param {Number} colIdx - column index
         */

    }, {
        key: "isColumnIncludedIntoSelection",
        value: function isColumnIncludedIntoSelection(colIdx) {
            return this.selectedRegion.containsCol(colIdx);
        }

        /**
         * Determines is selection contains cell from specified row.
         *
         * @param {Number} rowIdx - row index
         */

    }, {
        key: "isRowIncludedIntoSelection",
        value: function isRowIncludedIntoSelection(rowIdx) {
            return this.selectedRegion.containsRow(rowIdx);
        }
    }]);

    return SelectionController;
}();

exports.default = SelectionController;

/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _BaseSelectionType2 = __webpack_require__(522);

var _BaseSelectionType3 = _interopRequireDefault(_BaseSelectionType2);

var _SelectedData = __webpack_require__(523);

var _SelectedData2 = _interopRequireDefault(_SelectedData);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RunnerSelectionType = function (_BaseSelectionType) {
    _inherits(RunnerSelectionType, _BaseSelectionType);

    function RunnerSelectionType() {
        _classCallCheck(this, RunnerSelectionType);

        return _possibleConstructorReturn(this, (RunnerSelectionType.__proto__ || Object.getPrototypeOf(RunnerSelectionType)).apply(this, arguments));
    }

    _createClass(RunnerSelectionType, [{
        key: "accept",
        value: function accept(visitor, selectedRegion) {
            return visitor.visitRunnerSelection(selectedRegion);
        }
    }, {
        key: "getSelectedData",
        value: function getSelectedData(lockTable, selectedRegion) {
            return new _SelectedData2.default(lockTable.getRunnerController().getSelectedDateRange(), null);
        }
    }, {
        key: "isLocking",
        value: function isLocking(runnerController) {
            var lastLockedDate = runnerController.getLastLockedDate();
            if (lastLockedDate == null) return true;

            var newLastLockedDate = runnerController.getNewLastLockDate();
            return lastLockedDate.getTime() < newLastLockedDate.getTime();
        }
    }, {
        key: "canBeLocked",
        value: function canBeLocked(lockTable, selectedRegion) {
            return this.isLocking(lockTable.getRunnerController());
        }
    }, {
        key: "canBeUnlocked",
        value: function canBeUnlocked(lockTable, selectedRegion) {
            return !this.isLocking(lockTable.getRunnerController());
        }
    }]);

    return RunnerSelectionType;
}(_BaseSelectionType3.default);

exports.default = RunnerSelectionType;

/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _ProjectPanel = __webpack_require__(503);

var _ProjectPanel2 = _interopRequireDefault(_ProjectPanel);

var _jquery_rpc = __webpack_require__(26);

var _jquery_rpc2 = _interopRequireDefault(_jquery_rpc);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _ProjectStore = __webpack_require__(59);

var _ProjectStore2 = _interopRequireDefault(_ProjectStore);

var _CustomerStore = __webpack_require__(65);

var _CustomerStore2 = _interopRequireDefault(_CustomerStore);

var _AuditHistoryView = __webpack_require__(228);

var _AuditHistoryView2 = _interopRequireDefault(_AuditHistoryView);

var _actionsProviders = __webpack_require__(363);

var _applyAction = __webpack_require__(375);

var _errors = __webpack_require__(193);

var _selectors = __webpack_require__(57);

var _utils = __webpack_require__(6);

var _constants = __webpack_require__(23);

var _PanelContainer = __webpack_require__(109);

var _PanelContainer2 = _interopRequireDefault(_PanelContainer);

var _LoadingContainer = __webpack_require__(28);

var _LoadingContainer2 = _interopRequireDefault(_LoadingContainer);

var _constants2 = __webpack_require__(62);

var _utils2 = __webpack_require__(25);

var _constants3 = __webpack_require__(229);

var _UserNameFormat = __webpack_require__(17);

var _UserNameFormat2 = _interopRequireDefault(_UserNameFormat);

var _features = __webpack_require__(22);

var _atUtils = __webpack_require__(5);

var _StateComponent2 = __webpack_require__(105);

var _StateComponent3 = _interopRequireDefault(_StateComponent2);

var _actions = __webpack_require__(141);

var _redux = __webpack_require__(7);

var _ExceptionsTypes = __webpack_require__(107);

var _actions2 = __webpack_require__(29);

var _actions3 = __webpack_require__(55);

var _selectors2 = __webpack_require__(244);

var _actions4 = __webpack_require__(68);

var _selectors3 = __webpack_require__(15);

var _actions5 = __webpack_require__(56);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ProjectPanelController = function (_StateComponent) {
    _inherits(ProjectPanelController, _StateComponent);

    function ProjectPanelController(_ref) {
        var _ref$updateProject = _ref.updateProject,
            updateProject = _ref$updateProject === undefined ? function () {} : _ref$updateProject,
            _ref$onProjectArchive = _ref.onProjectArchivedCb,
            onProjectArchivedCb = _ref$onProjectArchive === undefined ? function () {} : _ref$onProjectArchive,
            _ref$onProjectDeleted = _ref.onProjectDeletedCb,
            onProjectDeletedCb = _ref$onProjectDeleted === undefined ? function () {} : _ref$onProjectDeleted,
            _ref$onCustomerChange = _ref.onCustomerChangedCb,
            onCustomerChangedCb = _ref$onCustomerChange === undefined ? function () {} : _ref$onCustomerChange,
            _ref$onCustomerDelete = _ref.onCustomerDeletedCb,
            onCustomerDeletedCb = _ref$onCustomerDelete === undefined ? function () {} : _ref$onCustomerDelete,
            _ref$setAllTasksAssig = _ref.setAllTasksAssigned,
            setAllTasksAssigned = _ref$setAllTasksAssig === undefined ? function () {} : _ref$setAllTasksAssig,
            _ref$setCanManageProj = _ref.setCanManageProject,
            setCanManageProject = _ref$setCanManageProj === undefined ? function () {} : _ref$setCanManageProj,
            _ref$updateEnabledFea = _ref.updateEnabledFeatures,
            updateEnabledFeatures = _ref$updateEnabledFea === undefined ? function () {} : _ref$updateEnabledFea,
            _ref$loadComments = _ref.loadComments,
            loadComments = _ref$loadComments === undefined ? function () {} : _ref$loadComments,
            _ref$copyLink = _ref.copyLink,
            copyLink = _ref$copyLink === undefined ? function () {} : _ref$copyLink,
            _ref$toast = _ref.toast,
            toast = _ref$toast === undefined ? function () {} : _ref$toast,
            _ref$warning = _ref.warning,
            warning = _ref$warning === undefined ? function () {} : _ref$warning;

        _classCallCheck(this, ProjectPanelController);

        var _this = _possibleConstructorReturn(this, (ProjectPanelController.__proto__ || Object.getPrototypeOf(ProjectPanelController)).call(this));

        _this.state = {
            projectId: null,
            openedFromUrl: false,

            name: "",
            description: "",
            status: false,
            creationTimestamp: null,
            allAuditHistoryLoaded: false,

            isWASEnabled: false
        };

        _this.actions = {
            updateProject: updateProject,
            onProjectArchivedCb: onProjectArchivedCb,
            onProjectDeletedCb: onProjectDeletedCb,
            onCustomerChangedCb: onCustomerChangedCb,
            onCustomerDeletedCb: onCustomerDeletedCb,
            setAllTasksAssigned: setAllTasksAssigned,
            setCanManageProject: setCanManageProject,
            updateEnabledFeatures: updateEnabledFeatures,
            loadComments: loadComments,
            copyLink: copyLink,
            toast: toast,
            warning: warning
        };

        _this.onStatePropertyChanged('projectId', function (projectId, prevProjectId) {
            _this.panelContainer.setState({ isShown: projectId !== null });
            if (projectId && projectId !== prevProjectId) {
                _this.loadData(projectId);
            }
        });
        return _this;
    }

    _createClass(ProjectPanelController, [{
        key: "init",
        value: function init() {
            var _this2 = this;

            var $taskBlock = (0, _jquery2.default)("#taskListBlock");
            var $page = (0, _jquery2.default)('#taskManagementPage');

            this.panel = new _ProjectPanel2.default({
                updateDescription: function updateDescription(description) {
                    return _this2._updateDescription(description);
                }
            });
            this.loadingContainer = new _LoadingContainer2.default({
                $containerEl: null,
                contentComponent: this.panel,
                containerClass: "",
                proxySetState: false
            });
            this.panelContainer = new _PanelContainer2.default({
                component: this.loadingContainer,
                showCopyLink: true,
                copyLinkTooltipText: _messageResource2.default.getMessage('project.edit_panel.copy_link_tooltip_text'),
                showHideButton: true,
                additionalClass: 'edit_project_sliding_panel sliding_panel',
                showAnimationClass: _constants2.SHOW_ANIMATION_CLASSES.SLIDE_RIGHT,
                hideAnimationClass: _constants2.HIDE_ANIMATION_CLASSES.SLIDE_RIGHT,
                onClickCloseButton: function onClickCloseButton() {
                    return _this2.panelContainer.setState({ isShown: false });
                },
                hideOnEsc: true,
                hideOnClickOutside: {
                    hideOnClick: true,
                    outsideElement: $page,
                    panelType: _constants2.PANEL_TYPES.EDIT_PROJECT
                },
                onShowCallback: function onShowCallback() {
                    _this2.panel.onShow();
                },
                onHideCallback: function onHideCallback() {
                    _this2._abortLoadPanelRequest();
                    _this2.projectId = null;
                    _this2.panel.onHide();
                },
                onCopyLinkClick: function onCopyLinkClick() {
                    return _this2.actions.copyLink();
                },
                hideHandler: function hideHandler() {
                    return _this2.panelContainer.setState({ isShown: false });
                }
            }).init($taskBlock);

            this.subscribeForEvents();
            return this;
        }
    }, {
        key: "subscribeForEvents",
        value: function subscribeForEvents() {
            var _this3 = this;

            var panel = this.panel;

            panel.header.nameInput.on('change', function (e, name) {
                var projectId = _this3.projectId;
                projectId && _this3._makeUpdateRequest("ProjectInfoService.updateProjectName", "name", name, panel.header.nameInput, function () {}, function () {
                    panel.setState({ name: name });
                    _this3._updateProjectInStore(projectId);
                }, function (jqXHR, textStatus, errorThrown) {
                    if (errorThrown.exception === 'com.actimind.actitime.project.ProjectExistsException') {
                        _this3.panel.header.nameInput.setState({
                            invalid: true,
                            focus: true,
                            errorText: _messageResource2.default.getMessage("project.edit.project_name_exists")
                        });
                        return true;
                    }
                    return false;
                });
            });

            panel.on('delete', function (e, revokeStatuses) {
                var projectId = _this3.projectId;
                var customErrorHandler = function customErrorHandler(jqXHR, textStatus, errorThrown) {
                    if (projectId !== _this3.projectId) return false;

                    if (errorThrown.exception === "com.actimind.actitime.task.TaskHasLockedTTException") {
                        alert(_messageResource2.default.getMessage("project.edit.cannot_delete_due_to_lock_time"));
                        panel.header.actions.disableDeleteButton(_messageResource2.default.getMessage("project.edit.cannot_delete_due_to_lock_time"));
                        panel.openLastSelectedTab();
                        return true;
                    }
                    if (errorThrown.exception === "com.actimind.actitime.task.NoPermissionToModifyTTOfSpecifiedUsers") {
                        alert(_messageResource2.default.getMessage("project.edit.cannot_delete_due_to_unavailable_to_modify"));
                        panel.header.actions.disableDeleteButton(_messageResource2.default.getMessage("hierarchy_entity.edit_popup.cannot_delete_due_to_unavailable_modify_time", [_messageResource2.default.getMessage("common.project")]));
                        panel.openLastSelectedTab();
                        return true;
                    }
                    return false;
                };

                (0, _jquery2.default)(_this3).trigger("deleteBegin");
                (0, _jquery_rpc2.default)("ProjectInfoService.deleteProject", [projectId, revokeStatuses], function () {
                    (0, _jquery2.default)(_this3).trigger("deleteEnd");
                    var projectName = _ProjectStore2.default.get(projectId).name;
                    _this3.actions.toast(_messageResource2.default.getMessage("delete.project.toast", [projectName]));
                    _this3.hidePanel();
                    _this3.actions.onProjectDeletedCb(projectId);
                }, function (jqXHR, textStatus, errorThrown) {
                    (0, _jquery2.default)(_this3).trigger("deleteEnd");
                    return _this3._getErrorHandlerWithSelectedProjectDeletedConcurrentlyText(projectId, customErrorHandler)(jqXHR, textStatus, errorThrown);
                });
            });

            panel.on('cancelDelete', function () {
                panel.openLastSelectedTab();
            });

            panel.on('move', function (e, _ref2) {
                var customer = _ref2.customer,
                    forceReopen = _ref2.forceReopen,
                    newWorkflowStatusId = _ref2.newWorkflowStatusId;

                var customerId = customer.id;
                newWorkflowStatusId = forceReopen ? null : newWorkflowStatusId;
                _this3._makeUpdateRequest("ProjectInfoService.moveProject", null, [customerId, forceReopen, newWorkflowStatusId], panel.moveToDialog, function () {}, function (projectId, moveResult) {
                    var project = _ProjectStore2.default.get(projectId);
                    if (project) {
                        var resultProject = moveResult.project;
                        _ProjectStore2.default.addFirst(resultProject);

                        var projectName = resultProject.name;
                        var customerName = _CustomerStore2.default.get(resultProject.customerId).name;
                        panel.setState({ name: projectName, active: !resultProject.archived });
                        panel.header.setState({ projectName: projectName, customerName: customerName });
                        _this3.actions.toast(_messageResource2.default.getMessage("move.project.toast", [projectName, customerName]));

                        if (forceReopen) {
                            _this3.actions((0, _actions5.toast)(_messageResource2.default.getMessage("status.customer.restored.toast", [customerName])));
                        } else if (!!newWorkflowStatusId) {
                            _this3.actions.toast(_messageResource2.default.getMessage("status.project.archived.toast", [projectName]));
                        }

                        if (resultProject.name !== project.name) {
                            _this3.actions.toast(_messageResource2.default.getMessage('move.project.duplicate_name.toast'));
                        }

                        (0, _jquery2.default)(_this3).trigger("projectMoved", [resultProject]);
                        _this3._handleProjectChanged(resultProject);

                        var resultCustomer = moveResult.customer;
                        _this3._handleCustomerChanged({
                            id: resultCustomer.id,
                            name: resultCustomer.name,
                            archived: resultCustomer.archived
                        });

                        if (!!newWorkflowStatusId) {
                            _this3.actions.onProjectArchivedCb(projectId);
                        }
                    }
                    panel.openLastSelectedTab();
                }, function (jqXHR, textStatus, errorThrown) {
                    switch (errorThrown.exception) {
                        case _ExceptionsTypes.NO_RIGHT_TO_EDIT_HIERARCHY_EXCEPTION:
                            alert(_messageResource2.default.getMessage('project.error.move.no_manage_scope_right'));
                            window.location.reload();
                            return true;
                        case _ExceptionsTypes.NO_SUCH_CUSTOMER_EXCEPTION:
                            _CustomerStore2.default.remove(customerId);
                            alert(_messageResource2.default.getMessage('project.error.move.customer_deleted_concurrently'));
                            panel.moveToDialog.updateSelector();
                            _this3.actions.onCustomerDeletedCb(customerId);
                            return true;
                        case _ExceptionsTypes.NO_SUCH_PROJECT_EXCEPTION:
                            alert(_messageResource2.default.getMessage('project.error.move.project_deleted_concurrently'));
                            window.location.reload();
                            return true;
                        case _ExceptionsTypes.CUSTOMER_UNAVAILABLE_EXCEPTION:
                            alert(_messageResource2.default.getMessage('project.error.move.customer_not_available'));
                            window.location.reload();
                            return true;
                        case _ExceptionsTypes.PROJECT_IS_NOT_ASSIGNED_EXCEPTION:
                            alert(_messageResource2.default.getMessage('project.error.move.project_not_assigned'));
                            window.location.reload();
                            return true;
                        case _ExceptionsTypes.PROJECT_EXISTS_EXCEPTION:
                            alert(_messageResource2.default.getMessage('project.error.project_with_same_name_exists'));
                            return true;
                        case _ExceptionsTypes.CUSTOMER_ARCHIVED_EXCEPTION:
                            if (!customer.archived) alert(_messageResource2.default.getMessage("task.error.move.customer_archived"));else alert(_messageResource2.default.getMessage("task.error.move.project_reopened"));
                            window.location.reload();
                            return true;
                    }
                    return false;
                });
            });

            var updateStatusRequest = function updateStatusRequest(active, forceReopenCustomer, forceCompleteTasks, workflowStatusId) {
                var workflowStatusName = null;
                if (workflowStatusId != null) workflowStatusName = (0, _utils.unsafe_selectWithState)(function (state) {
                    return (0, _selectors.selectStatusById)(state, workflowStatusId);
                }).name;

                _this3._makeUpdateRequest("ProjectInfoService.updateProjectStatus", "status", [active, forceReopenCustomer, forceCompleteTasks, workflowStatusId, workflowStatusName], panel.detailsTab.details.statusButton, function () {
                    panel.detailsTab.details.statusButton.setActive(_this3.state.status);
                }, function (projectId, data) {
                    var project = _ProjectStore2.default.get(projectId);
                    if (!active) {
                        panel.setState({ active: active });
                        _this3.actions.onProjectArchivedCb(projectId);
                        _this3.changed = true;
                    } else if (forceReopenCustomer) {
                        var customer = _underscore2.default.clone(_CustomerStore2.default.get(project.customerId));
                        customer.archived = false;
                        _CustomerStore2.default.add(customer);
                        _this3._handleCustomerChanged(customer);
                    }

                    var projectName = project.name;
                    _this3.actions.toast(_messageResource2.default.getMessage("status.project.toast", [projectName]));
                    panel.openLastSelectedTab();
                    panel.setState({
                        active: active,
                        projectSpentTimeValues: data.projectSpentTimeValues
                    });
                    _this3._handleProjectChanged(_extends({}, project, { archived: !active }));
                }, function (jqXHR, textStatus, errorThrown) {
                    if (errorThrown.exception === 'com.actimind.actitime.customer.CustomerArchivedException') {
                        if (confirm(_messageResource2.default.getMessage('project.error.reopen.customer_archived'))) {
                            panel.detailsTab.details.statusButton.setActive(true);
                            updateStatusRequest(active, true, false, null);
                        }
                        return true;
                    }

                    if (errorThrown.exception === 'com.actimind.actitime.customer.TasksNotArchivedException') {
                        if ((0, _features.isEnabled)(_features.Feature.TWS)) {
                            panel.openTabByKey(_ProjectPanel.ProjectPanelDialogs.ARCHIVE_DIALOG);
                            panel.archiveDialog.setState({
                                openTaskNumber: errorThrown.taskCount,
                                statusId: (0, _utils.unsafe_selectWithState)(function (state) {
                                    return (0, _selectors.selectFirstStatusByType)(state, _constants.WorkflowStatusType.COMPLETED);
                                }).id
                            });
                        } else {
                            var message = errorThrown.taskCount > 1 ? _messageResource2.default.getMessage("task.error.complete_tasks.project_archive", [errorThrown.taskCount]) : _messageResource2.default.getMessage("task.error.complete_one_task.project_archive");
                            if (confirm(message)) {
                                panel.detailsTab.details.statusButton.setActive(false);
                                updateStatusRequest(active, false, true, null);
                            }
                        }
                        return true;
                    }

                    if (errorThrown.exception === "com.actimind.actitime.administration.WorkflowStatusChangedExceptions") {
                        alert(_messageResource2.default.getMessage("change_tasks_workflow_status.workflow_status_changed_error"));
                        window.location.reload();
                        return true;
                    }
                    if (errorThrown.exception === "com.actimind.actitime.administration.NoSuchWorkflowStatusException") {
                        alert(_messageResource2.default.getMessage("change_tasks_workflow_status.no_such_workflow_status_error"));
                        window.location.reload();
                        return true;
                    }
                    if (errorThrown.exception === "com.actimind.actitime.project.ProjectIsNotAssignedException") {
                        alert(_messageResource2.default.getMessage("project.error.cant_change_status.project_not_assigned"));
                        window.location.reload();
                        return true;
                    }
                });
            };

            panel.archiveDialog.on("archived", function (e, id) {
                updateStatusRequest(false, false, true, id);
            });

            panel.archiveDialog.on("cancel", function () {
                panel.openLastSelectedTab();
            });

            panel.detailsTab.details.statusButton.on('change', function (e, active) {
                updateStatusRequest(active, false, false, null);
            });

            panel.detailsTab.details.auditHistory.on(_AuditHistoryView2.default.LoadAuditRecrodsEvent, function (event, _ref3) {
                var offset = _ref3.offset;

                if (!_this3.state.allAuditHistoryLoaded || offset === 0) {
                    (0, _jquery_rpc2.default)("ProjectInfoService.getAuditActions", [_this3.projectId, _AuditHistoryView2.default.RECORD_LIMIT, offset], function (result) {
                        _this3.setState({
                            allAuditHistoryLoaded: result['auditActions'].list.length < _AuditHistoryView2.default.RECORD_LIMIT
                        });
                        if (offset > 0) {
                            panel.detailsTab.details.addAuditRecords((0, _utils2.resolveAuditActions)(result['auditActions'].list, result['dependencies'].list, _constants3.AuditEntityTypes['PROJECT']));
                        } else {
                            panel.detailsTab.details.setAuditRecords((0, _utils2.resolveAuditActions)(result['auditActions'].list, result['dependencies'].list, _constants3.AuditEntityTypes['PROJECT']));
                        }
                    });
                }
            });

            if (panel.assignedUserTab) {
                panel.assignedUserTab.on('projectTeamChanged', function (e, projectTeam) {
                    if (_this3.updateProjectTeamRequest) _this3.updateProjectTeamRequest.abort();

                    var projectId = _this3.projectId;

                    var customErrorHandler = function customErrorHandler(jqXHR, textStatus, errorThrown) {
                        if (projectId !== _this3.projectId) return false;

                        if (errorThrown.exception === 'com.actimind.actitime.user.NoSuchUsersException') {
                            alert(_messageResource2.default.getMessage('project.edit.assigned_deleted_users'));
                            _this3.hidePanel();
                            return true;
                        }
                        return false;
                    };

                    _this3.updateProjectTeamRequest = (0, _jquery_rpc2.default)("ProjectInfoService.updateProjectTeam", [projectId, projectTeam], function () {}, _this3._getErrorHandlerWithSelectedProjectDeletedConcurrentlyText(projectId, customErrorHandler));
                });
            }

            var updateAssignedUsersErrorHandler = function updateAssignedUsersErrorHandler(e) {
                if (e instanceof _errors.NotFoundError) alert(_messageResource2.default.getMessage("project.edit.error.concurrently_deleted"));
                if (e instanceof _errors.NoRightsError) alert(_messageResource2.default.getMessage("project.error.project_not_assigned"));
                if (e instanceof _errors.NoEditHierarchyRightError) alert(_messageResource2.default.getMessage("task.list.error.no_manage_scope_right"));
                if (e instanceof _errors.NotAssignedError) alert(_messageResource2.default.getMessage("task.list.error.user_is_not_assigned_to_manager"));
                if (e instanceof _errors.NoSubmitTTRightError) alert(_messageResource2.default.getMessage("task.list.error.user_does_not_have_submit_tt_right"));
                if (e instanceof _errors.NoSuchUserError) alert(_messageResource2.default.getMessage("task.list.error.no_such_user"));
                if (e instanceof _errors.EditingUserDisabled) alert(_messageResource2.default.getMessage("task.list.error.editing_user_disabled"));

                window.location.reload();
            };

            var updateManagersErrorHandler = function updateManagersErrorHandler(e) {
                if (e instanceof _errors.NotFoundError) alert(_messageResource2.default.getMessage("project.edit.error.concurrently_deleted"));
                if (e instanceof _errors.NoManageUsersRightError) alert(_messageResource2.default.getMessage("task.list.error.no_manage_users_right"));
                if (e instanceof _errors.NoRightsError) alert(_messageResource2.default.getMessage("common.no_rights_for_operation_anymore"));
                if (e instanceof _errors.EditingUserDisabled) alert(_messageResource2.default.getMessage("task.list.error.editing_user_disabled"));
                if (e instanceof _errors.NoSuchUserError) alert(_messageResource2.default.getMessage("task.list.error.no_such_user"));
                if (e instanceof _errors.NoAccessToScopeError) alert(_messageResource2.default.getMessage("task.list.error.user_does_not_have_any_scope_rights"));
                window.location.reload();
            };

            var assignedUsersEditor = panel.assignedUsersEditorContainer;
            panel.on('assignedUserDelete', function (e, _ref4) {
                var userId = _ref4.userId;

                (0, _applyAction.applyActionResultToAssignedUsersEditor)(assignedUsersEditor, _actionsProviders.projectActionsProvider.updateAssignedUsers(_this3.projectId, [], [userId])).catch(updateAssignedUsersErrorHandler);
            });
            panel.on('assignedUsersChange', function (e, _ref5) {
                var addedUserIds = _ref5.addedUserIds,
                    removedUserIds = _ref5.removedUserIds;

                (0, _applyAction.applyActionResultToAssignedUsersEditor)(assignedUsersEditor, _actionsProviders.projectActionsProvider.updateAssignedUsers(_this3.projectId, addedUserIds, removedUserIds)).catch(updateAssignedUsersErrorHandler);
            });

            var managersEditor = panel.managersEditorContainer;
            panel.on('managerDelete', function (e, _ref6) {
                var userData = _ref6.userData;

                (0, _applyAction.applyActionResultToAssignedUsersEditor)(managersEditor, _actionsProviders.projectActionsProvider.updateManagers(_this3.projectId, [], [userData.id])).then(function () {
                    (0, _applyAction.applyActionResultToAssignedUsersEditor)(assignedUsersEditor, _actionsProviders.projectActionsProvider.getAssignedUsers(_this3.projectId));
                    var userName = _UserNameFormat2.default.formatFML(userData.firstName, userData.lastName, userData.middleName);
                    _this3.state.isWASEnabled && _this3.actions.toast(_messageResource2.default.getMessage("task.list.toasts.revoke_manage_project_from_user", [userName]));
                }).catch(updateManagersErrorHandler);
            });
            panel.on('managersChange', function (e, _ref7) {
                var addedUserIds = _ref7.addedUserIds,
                    removedUserIds = _ref7.removedUserIds;

                (0, _applyAction.applyActionResultToAssignedUsersEditor)(managersEditor, _actionsProviders.projectActionsProvider.updateManagers(_this3.projectId, addedUserIds, removedUserIds)).then(function () {
                    (0, _applyAction.applyActionResultToAssignedUsersEditor)(assignedUsersEditor, _actionsProviders.projectActionsProvider.getAssignedUsers(_this3.projectId));
                }).catch(updateManagersErrorHandler);

                if (removedUserIds.length === 1) {
                    var user = managersEditor.state.users.find(function (u) {
                        return u.id === removedUserIds[0];
                    });
                    var userName = _UserNameFormat2.default.formatFML(user.firstName, user.lastName, user.middleName);
                    _this3.state.isWASEnabled && _this3.actions.toast(_messageResource2.default.getMessage("task.list.toasts.revoke_manage_project_from_user", [userName]));
                } else if (removedUserIds.length > 1) {
                    _this3.state.isWASEnabled && _this3.actions.toast(_messageResource2.default.getMessage("task.list.toasts.n_users_no_longer_manage_project", [removedUserIds.length]));
                }
            });
        }
    }, {
        key: "_updateProjectInStore",
        value: function _updateProjectInStore(projectId) {
            var project = _ProjectStore2.default.get(projectId);
            if (project) {
                project = {
                    id: projectId,
                    customerId: project.customerId,
                    name: this.panel.header.nameInput.getName(),
                    archived: !this.panel.detailsTab.details.statusButton.isActive()
                };
                _ProjectStore2.default.add(project);
            }
            this._handleProjectChanged(project);
        }
    }, {
        key: "_abortLoadPanelRequest",
        value: function _abortLoadPanelRequest() {
            if (this.loadPanelRequest) this.loadPanelRequest.abort();
        }
    }, {
        key: "loadData",
        value: function loadData(projectId) {
            var _this4 = this;

            this._abortLoadPanelRequest();

            this.projectId = projectId;

            var panel = this.panel;
            this.loadingContainer.setState({ loading: true });
            panel.header.actions.hideMenu();

            panel.header.nameInput.setLoading(false);
            panel.moveToDialog.setLoading(false);
            panel.copyToDialog.setLoading(false);
            panel.detailsTab.details.statusButton.setLoading(false);
            panel.detailsTab.description.setState({ loading: false });

            this.loadPanelRequest = (0, _jquery_rpc2.default)("ProjectInfoService.getProjectData", [projectId], function (data) {
                var projectFromStore = _ProjectStore2.default.get(projectId) ? _underscore2.default.clone(_ProjectStore2.default.get(projectId)) : { id: projectId };
                var customerFromStore = _CustomerStore2.default.get(data.customerId) ? _underscore2.default.clone(_CustomerStore2.default.get(data['customerId'])) : { id: data['customerId'] };
                var receivedProject = _underscore2.default.extend(projectFromStore, { name: data['name'], customerId: data['customerId'], archived: !data['active'] });
                _ProjectStore2.default.add(receivedProject);
                _CustomerStore2.default.add(_underscore2.default.extend(customerFromStore, { name: data['customerName'] }));

                // TODO bakharev: update workflow store

                var deleteData = {
                    blockedDueToLockedTime: data.blockedDueToLockedTime,
                    blockedDueToUnavailableToModifyTimeTrack: data.blockedDueToUnavailableToModifyTimeTrack,
                    canManageAllUsersWithoutAutoApproved: data.canManageAllUsersWithoutAutoApproved,
                    projectHasManagerTimeTrack: data.projectHasManagerTimeTrack,
                    projectHasOtherUsersTimeTrack: data.projectHasOtherUsersTimeTrack,
                    projectHasManagerApprovedTimeTrack: data.projectHasManagerApprovedTimeTrack,
                    projectHasOtherUsersApprovedTimeTrack: data.projectHasOtherUsersApprovedTimeTrack,
                    hasManagerApprover: data.hasManagerApprover
                };

                if (projectId === _this4.projectId) {
                    _this4.loadingContainer.setState({ loading: false });
                    _this4.actions.updateEnabledFeatures((0, _atUtils.arrayToSet)(data.enabledFeatures));
                    panel.setState({
                        id: data.id,
                        name: data.name,

                        active: data.active,
                        readOnly: data.readOnly,
                        description: data.description,
                        customerName: data.customerName,
                        assignedUsersData: data.assignedUsersData,
                        assignedUsersDataForManagers: data.assignedUsersDataForManagers,

                        workflowStatuses: data.workflowStatuses,
                        projectSpentTimeValues: data.projectSpentTimeValues,
                        deleteData: deleteData
                    });
                    _this4.setState({
                        name: data.name,
                        description: data.description,
                        status: data.active,
                        creationTimestamp: data.creationTimestamp,
                        allAuditHistoryLoaded: false
                    });
                    _this4.actions.loadComments();
                    _this4.getAuditInfo();
                }

                _this4.actions.updateProject(receivedProject);
                _this4._onProjectInfoReceivedCb(data);
            }, this._getErrorHandlerWithSelectedProjectDeletedConcurrentlyText(projectId));
        }
    }, {
        key: "_onProjectInfoReceivedCb",
        value: function _onProjectInfoReceivedCb(data) {
            this.actions.setAllTasksAssigned(data.allTasksAssigned);
            this.actions.setCanManageProject(!data.readOnly);
        }
    }, {
        key: "getAuditInfo",
        value: function getAuditInfo() {
            var _this5 = this;

            if (!this.projectId) return;

            var details = this.panel.detailsTab.details;
            details.clearAuditHistory();
            var dateFormat = Date.convertSmartToExtDateFormat(window.SystemSettings.dateFormat).replace(/F/, "M");
            var formatDate = function formatDate(date) {
                return Date.parseJSONTime(date).format(dateFormat);
            };

            (0, _jquery_rpc2.default)("ProjectInfoService.getLastAuditActionsInfo", [this.projectId], function (result) {
                var createAction = result['createAction'];
                if (_underscore2.default.isNull(createAction)) createAction = {
                    timestamp: _this5.state.creationTimestamp,
                    type: window.__GENERATED_CONSTANTS__.AuditActionTypes.CREATED,
                    data: null,
                    subject: null
                };
                var updateAction = result['updateAction'];
                details.setAuditHistory(createAction, updateAction);
            });
        }
    }, {
        key: "hidePanel",
        value: function hidePanel() {
            this.panelContainer.setState({ isShown: false });
        }
    }, {
        key: "showPanel",
        value: function showPanel() {
            this.panelContainer.setState({ isShown: true });
        }
    }, {
        key: "_getErrorHandlerWithSelectedProjectDeletedConcurrentlyText",
        value: function _getErrorHandlerWithSelectedProjectDeletedConcurrentlyText(projectId, customHandler) {
            return this._getErrorHandler(projectId, customHandler);
        }
    }, {
        key: "_getErrorHandler",
        value: function _getErrorHandler(projectId, customHandler) {
            return _underscore2.default.bind(function (jqXHR, textStatus, errorThrown) {
                if (this.state.openedFromUrl && ['com.actimind.actitime.project.NoSuchProjectException', 'com.actimind.actitime.task.ProjectIsNotAvailableException'].includes(errorThrown.exception)) {
                    this.actions.warning(_messageResource2.default.getMessage('project.edit_panel.cannot_viewed_from_url'));
                    this.hidePanel();
                    return true;
                }

                if (errorThrown.exception === 'com.actimind.actitime.project.NoSuchProjectException') {
                    this.hidePanel();
                    alert(_messageResource2.default.getMessage("project.error.project_deleted_concurrently"));
                    window.location.reload();
                    return true;
                }
                if (errorThrown.exception === 'com.actimind.actitime.project.ProjectCannotBeModifiedException') {
                    alert(_messageResource2.default.getMessage("common.no_rights_for_operation_anymore"));
                    this.hidePanel();
                    (0, _jquery2.default)(this).trigger("projectCannotBeModified");
                    return true;
                }
                if (errorThrown.exception === 'com.actimind.actitime.task.ProjectIsNotAvailableException') {
                    alert(_messageResource2.default.getMessage("common.no_rights_for_operation_anymore"));
                    this.hidePanel();
                    this.callbacks.onProjectDeletedCb(projectId);
                    return true;
                }

                if (customHandler) return customHandler(jqXHR, textStatus, errorThrown);

                return false;
            }, this);
        }
    }, {
        key: "_handleProjectChanged",
        value: function _handleProjectChanged(project) {
            this.actions.updateProject(project);
            this.changed = true;
        }
    }, {
        key: "_handleCustomerChanged",
        value: function _handleCustomerChanged(customer) {
            this.actions.onCustomerChangedCb(customer);
            this.changed = true;
        }
    }, {
        key: "updatePanelManagementsAssignmentsState",
        value: function updatePanelManagementsAssignmentsState(viewerSettings, managementAssignments) {
            this.panel.setState({
                viewerSettings: viewerSettings,
                customersManagementAssignments: managementAssignments.customers
            });
        }
    }, {
        key: "_makeUpdateRequest",
        value: function _makeUpdateRequest(service, stateFieldName, args, targetControl, revertValueFn, customSuccessHandler, customErrorHandler) {
            var _this6 = this;

            var projectId = this.projectId;
            var newValue = _underscore2.default.isArray(args) ? args[0] : args;
            targetControl.setLoading(true);
            var setLoadingOfTargetControlToFalseAndCorrectState = function setLoadingOfTargetControlToFalseAndCorrectState(newValue) {
                if (_underscore2.default.isUndefined(newValue)) revertValueFn();else if (stateFieldName && !_underscore2.default.isUndefined(_this6.state[stateFieldName])) _this6.setState(_defineProperty({}, stateFieldName, newValue));

                targetControl.setLoading(false);
            };
            (0, _jquery_rpc2.default)(service, _underscore2.default.flatten([projectId, [args]]), function (data) {
                _this6._updateProjectInStore(projectId);
                if (projectId !== _this6.projectId) return true;
                setLoadingOfTargetControlToFalseAndCorrectState(newValue);
                if (customSuccessHandler) customSuccessHandler(projectId, data);
                _this6.panel.setFakeLastAudit();
            }, function (jqXHR, textStatus, errorThrown) {
                if (projectId !== _this6.projectId) return true;
                setLoadingOfTargetControlToFalseAndCorrectState();
                return _this6._getErrorHandlerWithSelectedProjectDeletedConcurrentlyText(projectId, customErrorHandler)(jqXHR, textStatus, errorThrown);
            });
        }
    }, {
        key: "_updateDescription",
        value: function _updateDescription(description) {
            var _this7 = this;

            this._makeUpdateRequest("ProjectInfoService.updateProjectDescription", "description", description, this.panel.detailsTab.description, function () {
                return _this7.panel.setState({ description: _this7.state.description });
            }, function () {
                return _this7.panel.setState({ description: description });
            }, null);
        }
    }]);

    return ProjectPanelController;
}(_StateComponent3.default);

exports.default = (0, _utils.connect)(function (state) {
    return {
        projectId: (0, _selectors2.getOpenProjectId)(state),
        openedFromUrl: (0, _selectors2.isPanelOpenedFromUrl)(state),

        isWASEnabled: (0, _selectors3.isWASEnabled)(state)
    };
}, function (dispatch) {
    return {
        updateProject: (0, _redux.bindActionCreators)(_actions3.updateProject, dispatch),
        onProjectArchivedCb: (0, _redux.bindActionCreators)(_actions3.archiveProjectAndReloadTasks, dispatch),
        onProjectDeletedCb: (0, _redux.bindActionCreators)(_actions3.removeProject, dispatch),
        onCustomerChanged: (0, _redux.bindActionCreators)(_actions2.addCustomer, dispatch),
        onCustomerDeletedCb: (0, _redux.bindActionCreators)(_actions3.removeCustomer, dispatch),
        setAllTasksAssigned: (0, _redux.bindActionCreators)(_actions.setAllTasksAssigned, dispatch),
        setCanManageProject: (0, _redux.bindActionCreators)(_actions.setCanManageProject, dispatch),
        loadComments: (0, _redux.bindActionCreators)(_actions.reloadComments, dispatch),
        updateEnabledFeatures: (0, _redux.bindActionCreators)(_actions4.setEnabledFeatures, dispatch),
        copyLink: (0, _redux.bindActionCreators)(_actions.copyLinkTo, dispatch),
        toast: (0, _redux.bindActionCreators)(_actions5.toast, dispatch),
        warning: (0, _redux.bindActionCreators)(_actions5.warning, dispatch)
    };
})(ProjectPanelController);

/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _redux = __webpack_require__(7);

var _CustomerPanel = __webpack_require__(382);

var _CustomerPanel2 = _interopRequireDefault(_CustomerPanel);

var _CustomerStore = __webpack_require__(65);

var _CustomerStore2 = _interopRequireDefault(_CustomerStore);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _jquery_rpc = __webpack_require__(26);

var _jquery_rpc2 = _interopRequireDefault(_jquery_rpc);

var _AuditHistoryView = __webpack_require__(228);

var _AuditHistoryView2 = _interopRequireDefault(_AuditHistoryView);

var _actionsProviders = __webpack_require__(363);

var _applyAction = __webpack_require__(375);

var _errors = __webpack_require__(193);

var _selectors = __webpack_require__(57);

var _utils = __webpack_require__(6);

var _constants = __webpack_require__(23);

var _PanelContainer = __webpack_require__(109);

var _PanelContainer2 = _interopRequireDefault(_PanelContainer);

var _LoadingContainer = __webpack_require__(28);

var _LoadingContainer2 = _interopRequireDefault(_LoadingContainer);

var _constants2 = __webpack_require__(62);

var _utils2 = __webpack_require__(25);

var _constants3 = __webpack_require__(229);

var _UserNameFormat = __webpack_require__(17);

var _UserNameFormat2 = _interopRequireDefault(_UserNameFormat);

var _actions = __webpack_require__(308);

var _StateComponent2 = __webpack_require__(105);

var _StateComponent3 = _interopRequireDefault(_StateComponent2);

var _selectors2 = __webpack_require__(249);

var _actions2 = __webpack_require__(55);

var _actions3 = __webpack_require__(29);

var _selectors3 = __webpack_require__(15);

var _actions4 = __webpack_require__(56);

var _syncCallbacks = __webpack_require__(161);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CustomerPanelController = function (_StateComponent) {
    _inherits(CustomerPanelController, _StateComponent);

    function CustomerPanelController(_ref) {
        var _ref$onCustomerArchiv = _ref.onCustomerArchived,
            onCustomerArchived = _ref$onCustomerArchiv === undefined ? function () {} : _ref$onCustomerArchiv,
            _ref$onCustomerChange = _ref.onCustomerChanged,
            onCustomerChanged = _ref$onCustomerChange === undefined ? function () {} : _ref$onCustomerChange,
            _ref$onCustomerDelete = _ref.onCustomerDeleted,
            onCustomerDeleted = _ref$onCustomerDelete === undefined ? function () {} : _ref$onCustomerDelete,
            _ref$loadComments = _ref.loadComments,
            loadComments = _ref$loadComments === undefined ? function () {} : _ref$loadComments,
            _ref$setAllProjectsAs = _ref.setAllProjectsAssigned,
            setAllProjectsAssigned = _ref$setAllProjectsAs === undefined ? function () {} : _ref$setAllProjectsAs,
            _ref$setCanManageCust = _ref.setCanManageCustomer,
            setCanManageCustomer = _ref$setCanManageCust === undefined ? function () {} : _ref$setCanManageCust,
            _ref$copyLink = _ref.copyLink,
            copyLink = _ref$copyLink === undefined ? function () {} : _ref$copyLink,
            _ref$toast = _ref.toast,
            toast = _ref$toast === undefined ? function () {} : _ref$toast,
            _ref$warning = _ref.warning,
            warning = _ref$warning === undefined ? function () {} : _ref$warning;

        _classCallCheck(this, CustomerPanelController);

        var _this = _possibleConstructorReturn(this, (CustomerPanelController.__proto__ || Object.getPrototypeOf(CustomerPanelController)).call(this));

        _this.state = {
            customerId: null,
            openedFromUrl: false,

            assignedUsersData: {},
            assignedUsersDataForManagers: {},
            customerInfo: {},
            customerSpentTimeValues: {},
            enabledFeatures: [],
            allAuditHistoryLoaded: false,

            isWASEnabled: false,
            isTWSEnabled: false
        };

        _this.actions = {
            onCustomerArchived: onCustomerArchived,
            onCustomerChanged: onCustomerChanged,
            onCustomerDeleted: onCustomerDeleted,
            loadComments: loadComments,
            setAllProjectsAssigned: setAllProjectsAssigned,
            setCanManageCustomer: setCanManageCustomer,
            copyLink: copyLink,
            toast: toast,
            warning: warning
        };

        _this.onStatePropertyChanged('customerId', function (customerId, prevCustomerId) {
            _this.panelContainer.setState({ isShown: customerId !== null });
            if (customerId && customerId !== prevCustomerId) _this.loadData(customerId);
        });
        return _this;
    }

    _createClass(CustomerPanelController, [{
        key: "init",
        value: function init() {
            var _this2 = this;

            var $taskBlock = (0, _jquery2.default)("#taskListBlock");
            var $page = (0, _jquery2.default)('#taskManagementPage');

            this.panel = new _CustomerPanel2.default({
                updateDescription: function updateDescription(description) {
                    return _this2._updateDescription(description);
                }
            });
            this.loadingContainer = new _LoadingContainer2.default({
                $containerEl: null,
                contentComponent: this.panel,
                containerClass: "",
                proxySetState: false
            });
            this.panelContainer = new _PanelContainer2.default({
                component: this.loadingContainer,
                showCopyLink: true,
                copyLinkTooltipText: _messageResource2.default.getMessage('customer.edit_panel.copy_link_tooltip_text'),
                showHideButton: true,
                additionalClass: 'edit_customer_sliding_panel sliding_panel',
                showAnimationClass: _constants2.SHOW_ANIMATION_CLASSES.SLIDE_RIGHT,
                hideAnimationClass: _constants2.HIDE_ANIMATION_CLASSES.SLIDE_RIGHT,

                hideOnEsc: true,
                hideOnClickOutside: {
                    hideOnClick: true,
                    outsideElement: $page,
                    panelType: _constants2.PANEL_TYPES.EDIT_CUSTOMER
                },
                onClickCloseButton: function onClickCloseButton() {
                    return _this2.panelContainer.setState({ isShown: false });
                },
                onShowCallback: function onShowCallback() {
                    _this2.panel.onShow();
                },
                onHideCallback: function onHideCallback() {
                    _this2.customerId = null;
                    _this2.panel.onHide();
                },
                onCopyLinkClick: function onCopyLinkClick() {
                    return _this2.actions.copyLink();
                },
                hideHandler: function hideHandler() {
                    return _this2.panelContainer.setState({ isShown: false });
                }
            }).init($taskBlock);

            this.subscribeForEvents();
            return this;
        }
    }, {
        key: "subscribeForEvents",
        value: function subscribeForEvents() {
            var _this3 = this;

            var panel = this.panel;

            panel.archiveDialog.on("archived", function (e, id) {
                _this3._makeUpdateRequest("CustomerInfoService.setCustomerActive", [_this3.customerId, false], panel.detailsTab.details.statusButton, true, id);
            });

            panel.archiveDialog.on("cancel", function () {
                panel.openLastSelectedTab();
                panel.update(_this3.state);
            });

            panel.header.nameInput.on('change', function (e, text) {
                _this3.customerId && _this3._makeUpdateRequest("CustomerInfoService.setCustomerName", [_this3.customerId, text], panel.header.nameInput);
            });

            panel.on('cancelDelete', function () {
                panel.openLastSelectedTab();
            });

            panel.detailsTab.details.statusButton.on('change', function (e, active) {
                _this3._makeUpdateRequest("CustomerInfoService.setCustomerActive", [_this3.customerId, active], panel.detailsTab.details.statusButton, false, null);
            });

            panel.on('delete', function (e, revokeStatuses) {
                (0, _jquery2.default)(_this3).trigger("deleteBegin");

                var customerId = _this3.customerId;
                (0, _jquery_rpc2.default)("CustomerInfoService.deleteCustomer", [customerId, revokeStatuses], function () {
                    (0, _jquery2.default)(_this3).trigger("deleteEnd");
                    var customerName = _CustomerStore2.default.get(customerId).name;
                    _this3.actions.toast(_messageResource2.default.getMessage("delete.customer.toast", [customerName]));
                    _this3.actions.onCustomerDeleted(customerId);
                    _this3.hidePanel();
                }, function (jqXHR, textStatus, errorThrown) {
                    (0, _jquery2.default)(_this3).trigger("deleteEnd");

                    return !!_this3._errorHandler(customerId, jqXHR, textStatus, errorThrown);
                });
            });

            panel.on('hidePanel', function () {
                (0, _jquery2.default)(_this3).trigger("hidePanel", { customerId: _this3.customerId, changed: _this3.changed });
                _this3.customerId = null;
                _this3.changed = false;
            });

            panel.detailsTab.details.auditHistory.on(_AuditHistoryView2.default.LoadAuditRecrodsEvent, function (event, _ref2) {
                var offset = _ref2.offset;

                if (!_this3.state.allAuditHistoryLoaded || offset === 0) {
                    (0, _jquery_rpc2.default)("CustomerInfoService.getAuditActions", [_this3.customerId, _AuditHistoryView2.default.RECORD_LIMIT, offset], function (result) {
                        _this3.setState({
                            allAuditHistoryLoaded: result['auditActions'].list.length < _AuditHistoryView2.default.RECORD_LIMIT
                        });
                        if (offset > 0) {
                            panel.detailsTab.details.addAuditRecords((0, _utils2.resolveAuditActions)(result['auditActions'].list, result['dependencies'].list), _constants3.AuditEntityTypes['CUSTOMER']);
                        } else {
                            panel.detailsTab.details.setAuditRecords((0, _utils2.resolveAuditActions)(result['auditActions'].list, result['dependencies'].list), _constants3.AuditEntityTypes['CUSTOMER']);
                        }
                    });
                }
            });

            var updateAssignedUsersErrorHandler = function updateAssignedUsersErrorHandler(e) {
                if (e instanceof _errors.NotFoundError) alert(_messageResource2.default.getMessage("customer.edit.error.concurrently_deleted"));
                if (e instanceof _errors.NoRightsError) alert(_messageResource2.default.getMessage("customer.error.customer_not_assigned"));
                if (e instanceof _errors.NoEditHierarchyRightError) alert(_messageResource2.default.getMessage("task.list.error.no_manage_scope_right"));
                if (e instanceof _errors.NotAssignedError) alert(_messageResource2.default.getMessage("task.list.error.user_is_not_assigned_to_manager"));
                if (e instanceof _errors.NoSubmitTTRightError) alert(_messageResource2.default.getMessage("task.list.error.user_does_not_have_submit_tt_right"));
                if (e instanceof _errors.NoSuchUserError) alert(_messageResource2.default.getMessage("task.list.error.no_such_user"));
                if (e instanceof _errors.EditingUserDisabled) alert(_messageResource2.default.getMessage("task.list.error.editing_user_disabled"));

                window.location.reload();
            };

            var updateManagersErrorHandler = function updateManagersErrorHandler(e) {
                if (e instanceof _errors.NotFoundError) alert(_messageResource2.default.getMessage("customer.edit.error.concurrently_deleted"));
                if (e instanceof _errors.NoManageUsersRightError) alert(_messageResource2.default.getMessage("task.list.error.no_manage_users_right"));
                if (e instanceof _errors.EditingUserDisabled) alert(_messageResource2.default.getMessage("task.list.error.editing_user_disabled"));
                if (e instanceof _errors.NoSuchUserError) alert(_messageResource2.default.getMessage("task.list.error.no_such_user"));
                if (e instanceof _errors.NoAccessToScopeError) alert(_messageResource2.default.getMessage("task.list.error.user_does_not_have_any_scope_rights"));
                window.location.reload();
            };

            var assignedUsersEditor = panel.assignedUsersEditorContainer;
            panel.on('assignedUserDelete', function (e, _ref3) {
                var userId = _ref3.userId;

                (0, _applyAction.applyActionResultToAssignedUsersEditor)(assignedUsersEditor, _actionsProviders.customerActionsProvider.updateAssignedUsers(_this3.customerId, [], [userId])).catch(updateAssignedUsersErrorHandler);
            });
            panel.on('assignedUsersChange', function (e, _ref4) {
                var addedUserIds = _ref4.addedUserIds,
                    removedUserIds = _ref4.removedUserIds;

                (0, _applyAction.applyActionResultToAssignedUsersEditor)(assignedUsersEditor, _actionsProviders.customerActionsProvider.updateAssignedUsers(_this3.customerId, addedUserIds, removedUserIds)).catch(updateAssignedUsersErrorHandler);
            });

            var managersEditor = panel.managersEditorContainer;
            panel.on('managerDelete', function (e, _ref5) {
                var userData = _ref5.userData;

                (0, _applyAction.applyActionResultToAssignedUsersEditor)(managersEditor, _actionsProviders.customerActionsProvider.updateManagers(_this3.customerId, [], [userData.id])).then(function () {
                    (0, _applyAction.applyActionResultToAssignedUsersEditor)(assignedUsersEditor, _actionsProviders.customerActionsProvider.getAssignedUsers(_this3.customerId));
                    var userName = _UserNameFormat2.default.formatFML(userData.firstName, userData.lastName, userData.middleName);
                    _this3.state.isWASEnabled && _this3.actions.toast(_messageResource2.default.getMessage("task.list.toasts.revoke_manage_customer_from_user", [userName]));
                }).catch(updateManagersErrorHandler);
            });
            panel.on('managersChange', function (e, _ref6) {
                var addedUserIds = _ref6.addedUserIds,
                    removedUserIds = _ref6.removedUserIds;

                (0, _applyAction.applyActionResultToAssignedUsersEditor)(managersEditor, _actionsProviders.customerActionsProvider.updateManagers(_this3.customerId, addedUserIds, removedUserIds)).then(function () {
                    (0, _applyAction.applyActionResultToAssignedUsersEditor)(assignedUsersEditor, _actionsProviders.customerActionsProvider.getAssignedUsers(_this3.customerId));
                }).catch(updateManagersErrorHandler);

                if (removedUserIds.length === 1) {
                    var user = managersEditor.state.users.find(function (u) {
                        return u.id === removedUserIds[0];
                    });
                    var userName = _UserNameFormat2.default.formatFML(user.firstName, user.lastName, user.middleName);
                    _this3.state.isWASEnabled && _this3.actions.toast(_messageResource2.default.getMessage("task.list.toasts.revoke_manage_customer_from_user", [userName]));
                } else if (removedUserIds.length > 1) {
                    _this3.state.isWASEnabled && _this3.actions.toast(_messageResource2.default.getMessage("task.list.toasts.n_users_no_longer_manage_customer", [removedUserIds.length]));
                }
            });
        }
    }, {
        key: "_abortLoadPanelRequest",
        value: function _abortLoadPanelRequest() {
            if (this.loadPanelRequest) this.loadPanelRequest.abort();
        }
    }, {
        key: "loadData",
        value: function loadData(customerId) {
            var _this4 = this;

            this._abortLoadPanelRequest();
            this.customerId = customerId;

            var panel = this.panel;

            panel.header.actions.hideMenu();
            this.loadingContainer.setState({ loading: true });
            var errorHandler = function errorHandler(jqXHR, textStatus, errorThrown) {
                if (_this4.state.openedFromUrl && ['com.actimind.actitime.customer.NoSuchCustomerException', 'com.actimind.actitime.customer.CustomerUnavailableException'].includes(errorThrown.exception)) {
                    _this4.actions.warning(_messageResource2.default.getMessage('customer.edit_panel.cannot_viewed_from_url'));
                    _this4.hidePanel();
                    return true;
                }

                if (errorThrown.exception === "com.actimind.actitime.customer.NoSuchCustomerException") {
                    if (customerId === _this4.customerId) {
                        alert(_messageResource2.default.getMessage("project.edit.customer_deleted_concurrently"));
                    }
                    _this4.actions.onCustomerDeleted(customerId);
                    _this4.hidePanel();
                    return true;
                } else if (errorThrown.exception === "com.actimind.actitime.customer.CustomerCannotBeModifiedException") {
                    alert(_messageResource2.default.getMessage("common.no_rights_for_operation_anymore"));
                    _this4.hidePanel();
                    return true;
                } else if (errorThrown.exception === "com.actimind.actitime.customer.CustomerUnavailableException") {
                    alert(_messageResource2.default.getMessage("common.no_rights_for_operation_anymore"));
                    _CustomerStore2.default.remove(customerId);
                    _this4.hidePanel();
                    return true;
                }
                return false;
            };
            this.loadPanelRequest = (0, _jquery_rpc2.default)("CustomerInfoService.getCustomerInfo", [customerId], function (data) {
                _this4.setState(_extends({}, data, {
                    allAuditHistoryLoaded: false
                }));
                _this4.loadingContainer.setState({ loading: false });
                _this4.panel.update(data);
                _this4._onCustomerInfoReceived(data);
                _this4.getAuditInfo();
                _this4.actions.loadComments();
            }, errorHandler);
        }
    }, {
        key: "_onCustomerInfoReceived",
        value: function _onCustomerInfoReceived(data) {
            this.actions.setAllProjectsAssigned(data.customerInfo.allProjectsAssigned);
            this.actions.setCanManageCustomer(!data.customerInfo.readOnly);
        }
    }, {
        key: "getAuditInfo",
        value: function getAuditInfo() {
            var _this5 = this;

            if (!this.customerId) return;

            var details = this.panel.detailsTab.details;
            details.clearAuditHistory();

            var dateFormat = Date.convertSmartToExtDateFormat(window.SystemSettings.dateFormat).replace(/F/, "M");
            var formatDate = function formatDate(date) {
                return Date.parseJSONTime(date).format(dateFormat);
            };

            (0, _jquery_rpc2.default)("CustomerInfoService.getLastAuditActionsInfo", [this.customerId], function (result) {
                var createAction = result['createAction'];
                if (_underscore2.default.isNull(createAction)) createAction = {
                    timestamp: _this5.state.customerInfo['creationTimestamp'],
                    type: window.__GENERATED_CONSTANTS__.AuditActionTypes.CREATED,
                    data: null,
                    subject: null
                };
                var updateAction = result['updateAction'];
                details.setAuditHistory(createAction, updateAction);
            });
        }
    }, {
        key: "hidePanel",
        value: function hidePanel() {
            this._abortLoadPanelRequest();
            this.panel.setState({ customerId: null });
            this.panelContainer.setState({ isShown: false });
        }
    }, {
        key: "showPanel",
        value: function showPanel(customerId) {
            this.panelContainer.setState({ isShown: true });
            this.panel.setState({ customerId: customerId });
        }
    }, {
        key: "_updateDescription",
        value: function _updateDescription(description) {
            this._makeUpdateRequest("CustomerInfoService.setCustomerDescription", [this.customerId, description], this.panel.detailsTab.description);
        }
    }, {
        key: "_makeUpdateRequest",
        value: function _makeUpdateRequest(service, params, targetControl, forceCompleteTasks, statusId) {
            var _this6 = this;

            var customerId = this.customerId;
            targetControl.setLoading(true);
            var paramsCopy = params.slice();
            if (!_underscore2.default.isUndefined(forceCompleteTasks)) {
                paramsCopy.push(forceCompleteTasks);
                paramsCopy.push(statusId);
                var statusName = null;
                if (statusId != null) statusName = (0, _utils.unsafe_selectWithState)(function (state) {
                    return (0, _selectors.selectStatusById)(state, statusId);
                }).name;

                paramsCopy.push(statusName);
            }

            (0, _jquery_rpc2.default)(service, paramsCopy, function (data) {
                var config = data.customerInfo;
                // customer set archived => update its projects status
                var customer = {
                    id: config.id,
                    name: config.name,
                    archived: !config.active
                };
                if (config.active !== _this6.state.customerInfo.active) {
                    _this6.actions.toast(_messageResource2.default.getMessage("status.customer.toast", [customer.name]));
                }

                if (!config.active && _this6.state.customerInfo.active) {
                    _this6.actions.onCustomerArchived(customer.id);
                }
                _this6.setState(data);
                _CustomerStore2.default.add(customer);
                _this6.actions.onCustomerChanged(customer);
                _this6.changed = true;

                _this6.panel.update(data);
                _this6.panel.setFakeLastAudit();
                targetControl.setLoading(false);
                _this6.panel.openLastSelectedTab();
                (0, _syncCallbacks.afterProjectCustomerStatusChangeCb)();
            }, function (jqXHR, textStatus, errorThrown) {
                targetControl.setLoading(false);
                if (errorThrown.exception === 'com.actimind.actitime.customer.TasksNotArchivedException') {
                    if (_this6.state.isTWSEnabled) {
                        _this6.panel.openTabByKey(_CustomerPanel.CustomerPanelDialogs.ARCHIVE_DIALOG);
                        _this6.panel.archiveDialog.setState({
                            openTaskNumber: errorThrown.taskCount,
                            statusId: (0, _utils.unsafe_selectWithState)(function (state) {
                                return (0, _selectors.selectFirstStatusByType)(state, _constants.WorkflowStatusType.COMPLETED);
                            }).id
                        });
                    } else {
                        var message = errorThrown.taskCount > 1 ? _messageResource2.default.getMessage("task.error.complete_tasks.customer_archive", [errorThrown.taskCount]) : _messageResource2.default.getMessage("task.error.complete_one_task.customer_archive");

                        if (confirm(message)) {
                            _this6._makeUpdateRequest(service, params, targetControl, true, null);
                        } else {
                            _this6.panel.update(_this6.state);
                        }
                    }

                    return true;
                }

                if (errorThrown.exception === "com.actimind.actitime.administration.WorkflowStatusChangedExceptions") {
                    alert(_messageResource2.default.getMessage("change_tasks_workflow_status.workflow_status_changed_error"));
                    window.location.reload();
                    return true;
                }
                if (errorThrown.exception === "com.actimind.actitime.administration.NoSuchWorkflowStatusException") {
                    alert(_messageResource2.default.getMessage("change_tasks_workflow_status.no_such_workflow_status_error"));
                    window.location.reload();
                    return true;
                }

                if (errorThrown.exception === "com.actimind.actitime.services.NoRightToEditHierarchyException") {
                    alert(_messageResource2.default.getMessage("change_tasks_workflow_status.no_manage_scope_right"));
                    window.location.reload();
                    return true;
                }

                return _this6._errorHandler(customerId, jqXHR, textStatus, errorThrown);
            });
        }
    }, {
        key: "_errorHandler",
        value: function _errorHandler(customerId, jqXHR, textStatus, errorThrown) {
            if (errorThrown.exception === "com.actimind.actitime.customer.NoSuchCustomerException") {
                if (customerId === this.customerId) {
                    alert(_messageResource2.default.getMessage("customer.edit.cannot_edit_deleted_concurrently"));
                }
                this.actions.onCustomerDeleted(customerId);
                this.hidePanel();
                return true;
            }

            if (errorThrown.exception === "com.actimind.actitime.customer.CustomerUnavailableException") {
                //TODO change message
                if (customerId === this.customerId) {
                    alert(_messageResource2.default.getMessage("customer.edit.cannot_edit_deleted_concurrently"));
                }
                this.actions.onCustomerDeleted(customerId);
                this.hidePanel();
                return true;
            }

            if (errorThrown.exception === "com.actimind.actitime.customer.CustomerExistsException") {
                if (customerId === this.customerId) {
                    this.panel.header.nameInput.setState({
                        invalid: true,
                        focus: true,
                        errorText: _messageResource2.default.getMessage("customer.edit.error.name_duplicate")
                    });
                }
                return true;
            }
            if (errorThrown.exception === "com.actimind.actitime.task.NoPermissionToModifyTTOfSpecifiedUsers") {
                if (customerId === this.customerId) {
                    var alertText = _messageResource2.default.getMessage(this.state.customerInfo.canManageAllUsersWithoutAutoApproved ? "hierarchy_entity.edit_popup.cannot_delete_due_to_unavailable_modify_time_of_autoapproved_users" : "hierarchy_entity.edit_popup.cannot_delete_due_to_unavailable_modify_time", [_messageResource2.default.getMessage("common.customer")]);
                    alert(alertText);
                    this.panel.header.actions.disableDeleteButton(alertText);
                    this.panel.openLastSelectedTab();
                }
                return true;
            }
            if (errorThrown.exception === "com.actimind.actitime.task.TaskHasLockedTTException") {
                if (customerId === this.customerId) {
                    var _alertText = _messageResource2.default.getMessage("customer.edit.cannot_delete_due_to_lock_time");
                    alert(_alertText);
                    this.panel.header.actions.disableDeleteButton(_alertText);
                    this.panel.openLastSelectedTab();
                }
                return true;
            }
            return false;
        }
    }]);

    return CustomerPanelController;
}(_StateComponent3.default);

exports.default = (0, _utils.connect)(function (state) {
    return {
        customerId: (0, _selectors2.getOpenCustomerId)(state),
        openedFromUrl: (0, _selectors2.isPanelOpenedFromUrl)(state),

        isWASEnabled: (0, _selectors3.isWASEnabled)(state),
        isTWSEnabled: (0, _selectors3.isTWSEnabled)(state)
    };
}, function (dispatch) {
    return {
        onCustomerArchived: (0, _redux.bindActionCreators)(_actions2.archiveProjectsOfCustomerAndReloadTasks, dispatch),
        onCustomerChanged: (0, _redux.bindActionCreators)(_actions3.addCustomer, dispatch),
        onCustomerDeleted: (0, _redux.bindActionCreators)(_actions2.removeCustomer, dispatch),
        loadComments: (0, _redux.bindActionCreators)(_actions.reloadComments, dispatch),
        setAllProjectsAssigned: (0, _redux.bindActionCreators)(_actions.setAllProjectsAssigned, dispatch),
        setCanManageCustomer: (0, _redux.bindActionCreators)(_actions.setCanManageCustomer, dispatch),
        copyLink: (0, _redux.bindActionCreators)(_actions.copyLinkTo, dispatch),
        toast: (0, _redux.bindActionCreators)(_actions4.toast, dispatch),
        warning: (0, _redux.bindActionCreators)(_actions4.warning, dispatch)
    };
})(CustomerPanelController);

/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Ext = __webpack_require__(12);

var _Ext2 = _interopRequireDefault(_Ext);

var _at_users_selector_panel = __webpack_require__(162);

var _at_users_selector_panel2 = _interopRequireDefault(_at_users_selector_panel);

var _AccessRightFilter = __webpack_require__(1546);

var _AccessRightFilter2 = _interopRequireDefault(_AccessRightFilter);

var _AccessRightUserGroupNodeRenderer = __webpack_require__(1547);

var _AccessRightUserGroupNodeRenderer2 = _interopRequireDefault(_AccessRightUserGroupNodeRenderer);

var _AccessRightUserNodeRenderer = __webpack_require__(1548);

var _AccessRightUserNodeRenderer2 = _interopRequireDefault(_AccessRightUserNodeRenderer);

var _AccessRightEmptyMessageBuilder = __webpack_require__(1549);

var _AccessRightEmptyMessageBuilder2 = _interopRequireDefault(_AccessRightEmptyMessageBuilder);

var _complicate_users_and_groups_selection_helper = __webpack_require__(821);

var _complicate_users_and_groups_selection_helper2 = _interopRequireDefault(_complicate_users_and_groups_selection_helper);

var _GroupType = __webpack_require__(34);

var _GroupType2 = _interopRequireDefault(_GroupType);

var _atUtils = __webpack_require__(5);

var _atBrowserUtils = __webpack_require__(8);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Selector panel for the users list.
 *
 * Depends on:
 * <code>/js/selectorControls/at_users_selector_panel.js</code>
 * <code>/js/message_resources.js</code> with prefixes "users_selector", "mail_notifications.users_selector"
 * <code>/js/controls/selectorControls/at_tree_node_helper.js</code>
 * <code>/js/controls/selectorControls/at_user_tree_node_helper.js</code>
 * <code>/js/controls/selectorControls/at_ar_user_tree_node_helper.j</code>
 *
 * @constructor
 */
var AccessRightsUsersSelectorPanel = _Ext2.default.extend(_at_users_selector_panel2.default, {

    /**
     * @cfg {AccessRight} accessRight determines whether item should be shown based on access right property value.
     *
     */
    accessRight: null,

    /**
     * @cfg {Boolean} showWithoutRight true to display items which has no right specified by
     *                @see AccessRightsUsersSelectorPanel.accessRight, false to not.
     */
    showWithoutRight: false,

    /**
     * @cfg {String} message key to be shown if <code>item's</code> rights do not conform
     *                                   <code>accessRight</code>
     */
    insufficientRightsMessageKey: "common.users_selector.access_right.insufficient_rights",

    emptyMessageBuilderCtor: _AccessRightEmptyMessageBuilder2.default,

    /**
     * @cfg {TreeNodeSet} set of all users with specified access right in selector
     */
    allAccessRightGrantedSetForUserGroups: null,
    allAccessRightGrantedSetForTimeZoneGroups: null,

    createGenericOptions: function createGenericOptions() {
        this.genericOptions = [new _Ext2.default.form.Radio({
            boxLabel: (0, _atUtils.escapeHtmlSymbols)(this.accessRight.getSelectAllMessage()),
            name: this.realOptionsName,
            inputValue: this.allItemsOptionValue
        })];
    },

    createSelectionFilters: function createSelectionFilters() {
        AccessRightsUsersSelectorPanel.superclass.createSelectionFilters.call(this);

        this.accessRightFilterCheckBox = new _Ext2.default.form.Checkbox({
            boxLabel: (0, _atUtils.escapeHtmlSymbols)(this.accessRight.getFilterMessage()),
            cls: 'selectionFilter'
        });

        var context = this;
        this.accessRightFilterCheckBox.on("check", function (checkbox, checked) {
            context.applyUsersWithoutGrantedAccessRightFilter(context, checked, true);
        }, this);
    },

    applyUsersWithoutGrantedAccessRightFilter: function applyUsersWithoutGrantedAccessRightFilter(context, showWithoutRight, isFirePanelChange) {
        context.treeActionHandler(function () {
            context.selectorFilter.setShowUsersWithoutGrantedAccessRight(showWithoutRight);
        }, isFirePanelChange, true);
    },

    /**
     * @see AT.SelectorPanel
     */
    initComponent: function initComponent() {
        AccessRightsUsersSelectorPanel.superclass.initComponent.call(this);
        this.updateState();
    },

    /**
     * Sets initial value for filer check boxes
     * @param showInactive value for Show Disabled Checkbox
     * @param showWithoutRight value for Access Right Filter Checkbox
     */
    setFilterFlag: function setFilterFlag(showInactive, showWithoutRight) {
        AccessRightsUsersSelectorPanel.superclass.setFilterFlag.call(this, showInactive);
        this.showWithoutRight = showWithoutRight;
    },

    /**
     * @see AT.GenericSelectorPanel
     */
    updateState: function updateState() {
        AccessRightsUsersSelectorPanel.superclass.updateState.call(this);
        if (this.isAlreadyShown()) {
            // if they don`t equal than on('check',..) event emitted and filter applied
            if (this.getShowWithoutRight() == this.showWithoutRight) this.applyUsersWithoutGrantedAccessRightFilter(this, this.showWithoutRight, false);else this.accessRightFilterCheckBox.setValue(this.showWithoutRight);
        }
    },

    setPredefinedParameters: function setPredefinedParameters(state) {
        this.showWithoutRight = state.showWithoutRight;
        AccessRightsUsersSelectorPanel.superclass.setPredefinedParameters.call(this, state);
    },

    /**
     * @see AT.GenericSelectorPanel
     */
    getDetailsSection: function getDetailsSection() {
        return [this.selectorTree, this.showInactiveCheckboxContainer, this.accessRightFilterCheckBox];
    },

    setSelectorFilter: function setSelectorFilter() {
        var allAccessRightGrantedSet = this.groupType == _GroupType2.default.TIME_ZONE_GROUP ? this.allAccessRightGrantedSetForTimeZoneGroups : this.allAccessRightGrantedSetForUserGroups;
        this.selectorFilter = new _AccessRightFilter2.default(this.selectorTree, this.searchIndex, this.allActiveSet, this.accessRight, allAccessRightGrantedSet);
    },

    getUserGroupNodeRenderer: function getUserGroupNodeRenderer() {
        return new _AccessRightUserGroupNodeRenderer2.default(this.selectorTree, this.selectorFilter, this.getExpandCollapseCallback(), this.accessRight);
    },

    getUserNodeRenderer: function getUserNodeRenderer() {
        return new _AccessRightUserNodeRenderer2.default(this.selectorTree, this.selectorFilter, this.getSelectionHelper(), this.checkEmail, this.treeItemTooltipMessageParams, this.accessRight);
    },

    makeSelectionHelper: function makeSelectionHelper() {
        this.selectionHelper = new _complicate_users_and_groups_selection_helper2.default({
            userSelectorGroupsStrategy: this.userSelectorGroupsStrategy,
            accessRight: this.accessRight,
            maxLength: this.labelMaxChars,
            checkEmail: this.checkEmail
        });
    },

    checkAndProcessHiddenNodeSelection: function checkAndProcessHiddenNodeSelection(treeNode) {
        AccessRightsUsersSelectorPanel.superclass.checkAndProcessHiddenNodeSelection.call(this, treeNode);
        var context = this;
        if (this.checkHiddenNodeSelectionTemplate(treeNode, function () {
            return !context.accessRight.isGranted(treeNode.getValue().accessRight);
        })) {
            this.accessRightFilterCheckBox.setValue(true);
            this.selectorFilter.setShowUsersWithoutGrantedAccessRight(true);
        }
    },

    createEmptyMessageBuilder: function createEmptyMessageBuilder() {
        return new _AccessRightEmptyMessageBuilder2.default(this.userSelectorGroupsStrategy, this.accessRight);
    },

    disableTextSelectionForNeededElements: function disableTextSelectionForNeededElements() {
        AccessRightsUsersSelectorPanel.superclass.disableTextSelectionForNeededElements.call(this);
        (0, _atBrowserUtils.disableTextSelection)(this.accessRightFilterCheckBox.labelEl.dom);
    },

    /**
     * @see AT.SelectorPanel
     */
    getFilterCallback: function getFilterCallback() {
        var context = this;
        return function (user) {
            return context.accessRight.isGranted(user.accessRight);
        };
    },

    getShowWithoutRight: function getShowWithoutRight() {
        return this.accessRightFilterCheckBox.getValue();
    },

    createDefaultState: function createDefaultState() {
        return _Ext2.default.applyIf({ showWithoutRight: false }, AccessRightsUsersSelectorPanel.superclass.createDefaultState.call(this));
    },

    getState: function getState() {
        return _Ext2.default.applyIf({ showWithoutRight: this.getShowWithoutRight() }, AccessRightsUsersSelectorPanel.superclass.getState.call(this));
    },

    loadState: function loadState(state, doNotUpdateGroupType) {
        this.showWithoutRight = state.showWithoutRight;
        AccessRightsUsersSelectorPanel.superclass.loadState.call(this, state, doNotUpdateGroupType);
    },

    collectCurrentSettings: function collectCurrentSettings() {
        var settings = AccessRightsUsersSelectorPanel.superclass.collectCurrentSettings.call(this);
        settings.showWithoutRight = this.getShowWithoutRight();
        return settings;
    },

    getStateFromSettings: function getStateFromSettings(settings) {
        var state = AccessRightsUsersSelectorPanel.superclass.getStateFromSettings.call(this, settings);
        state.showWithoutRight = settings.showWithoutRight;
        return state;
    }

});

_Ext2.default.reg("at_users_selector_panel", AccessRightsUsersSelectorPanel);

exports.default = AccessRightsUsersSelectorPanel;

/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Ext = __webpack_require__(12);

var _Ext2 = _interopRequireDefault(_Ext);

var _simple_users_and_groups_selection_helper = __webpack_require__(374);

var _simple_users_and_groups_selection_helper2 = _interopRequireDefault(_simple_users_and_groups_selection_helper);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _GroupType = __webpack_require__(34);

var _GroupType2 = _interopRequireDefault(_GroupType);

var _GroupValidatorStrategy = __webpack_require__(186);

var _user_group_selector_util = __webpack_require__(98);

var _atUtils = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Is used to generate string representation for item list have been passed to <code>getDescription</code> method
 *
 * @constructor
 * AT.SelectionHelper
 */
var ComplicateUsersAndGroupsSelectionHelper = _Ext2.default.extend(_simple_users_and_groups_selection_helper2.default, {

    /**
     * @see AT.AccessRightsUsersSelectorPanel.accessRight (required)
     */
    accessRight: null,
    userTemplate: '<span class="{0}">{1}</span>{2}',
    defaultUserCls: "selected-user",
    invalidUserCls: "selected-user invalid-user",
    maxLength: 50,
    itemNounSingularKey: "mail_notifications.users_selector.label.singular",
    itemNounPluralKey: "mail_notifications.users_selector.label.plural",
    noEmailMessageKey: "mail_notifications.users_selector.label.without_email",

    itemNoEmailMessageKey: "mail_notifications.users_selector.tooltip.without_email",

    isNeededInformationAboutDisabledUsers: false,

    checkEmail: false,

    getDescription: function getDescription(selection, dropdownButtonId) {
        var result = "";
        var resultText = "";
        var suffix = "";
        var groups = selection.getFirstLevel();
        var users = selection.getSecondLevel();
        var groupType = selection.groupType;
        if (groups.length == 0 && users.length == 0) {
            return this.getMessage(this.pleaseSelectMessageKey);
        } else if (groups.length == 0) {
            var itemClass,
                itemSuffix,
                itemText,
                preparedItem,
                preparedItems = new Array(),
                textLength = 0,
                returnTextLength = this.maxLength;

            users.sort(_user_group_selector_util.userComparator);
            for (var i = 0; i < users.length; i++) {
                preparedItem = {};
                itemClass = this.defaultUserCls;
                if (this.checkEmail && (!users[i].isActive() || !users[i].hasEmail() || this.accessRight && !this.accessRight.isGranted(users[i].accessRight))) {
                    itemClass = this.invalidUserCls;
                }
                itemSuffix = i == users.length - 1 ? "" : "; ";
                itemText = users[i].formatNameLFM();

                preparedItem.text = itemText;
                preparedItem.suffix = itemSuffix;
                preparedItem.cls = itemClass;
                preparedItems.push(preparedItem);

                textLength += itemText.length;
            }
            if (textLength > this.maxLength) {
                var itemNounKey = preparedItems.length > 1 ? this.itemNounPluralKey : this.itemNounSingularKey;
                suffix = "(" + preparedItems.length + " " + this.getMessage(itemNounKey) + ")";

                returnTextLength -= suffix.length;
            }

            for (i = 0; i < preparedItems.length; i++) {
                var isGreaterMaxLength = false;
                if (returnTextLength < preparedItems[i].text.length) {
                    if (resultText.length == 0) {
                        preparedItems[i].text = (0, _atUtils.truncateStringByLength)(preparedItems[i].text, returnTextLength, false);
                        preparedItems[i].suffix = "";
                    }
                    isGreaterMaxLength = true;
                }
                result += _messageResource2.default.applyParamsSubstitutions(this.userTemplate, [preparedItems[i].cls, (0, _atUtils.escapeHtmlSymbols)(preparedItems[i].text), preparedItems[i].suffix], 0);
                if (isGreaterMaxLength) break;
                returnTextLength -= preparedItems[i].text.length;
            }
            return result + (suffix ? " " + suffix : "");
        } else if (users.length == 0 && groups.length == 1) {
            var validatorGroupStrategy = groupType == _GroupType2.default.TIME_ZONE_GROUP ? new _GroupValidatorStrategy.TimeZoneGroupValidatorStrategy() : new _GroupValidatorStrategy.UserGroupValidatorStrategy();
            return this.getSingleItemText(groups[0], true, validatorGroupStrategy);
        } else {
            return this.getShortDescriptionForUsersAndGroups(groups, users, dropdownButtonId, groupType);
        }
    },

    getListDescriptionItemStatus: function getListDescriptionItemStatus(user) {
        var hasAccessRight = this.accessRight && this.accessRight.isGranted(user.accessRight);
        var hasEmail = !this.checkEmail || user.hasEmail();
        var result = "";

        if (this.accessRight && !hasAccessRight && !hasEmail) result = this.accessRight.getUserNoEmailAndRightsMessage();else if (this.accessRight && !hasAccessRight) result = this.accessRight.getUserNoRightsMessage();else if (!hasEmail) result = this.getMessage(this.itemNoEmailMessageKey);
        return (0, _atUtils.concatStr)(ComplicateUsersAndGroupsSelectionHelper.superclass.getListDescriptionItemStatus.call(this, user), result, " ");
    }

});

exports.default = ComplicateUsersAndGroupsSelectionHelper;

/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Created by filatov on 13.05.2015.
 */

function FeatureDiffStateController() {}

FeatureDiffStateController.prototype.init = function (oldEnabledFeatures, newEnabledFeatures) {
    var diff = {
        addedFeatures: {},
        featuresChanged: false
    };

    diff.oldFeatures = _extends({}, oldEnabledFeatures);
    diff.newFeatures = _extends({}, newEnabledFeatures);

    for (var feature in newEnabledFeatures) {
        if (!oldEnabledFeatures.hasOwnProperty(feature)) {
            diff.addedFeatures[feature] = true;
        } else delete oldEnabledFeatures[feature];
    }
    diff.deletedFeatures = oldEnabledFeatures;
    diff.validateFeaturesChanged = function () {
        this.featuresChanged = false;
        for (var f in this.addedFeatures) {
            this.featuresChanged = true;
        }
        for (var f in this.deletedFeatures) {
            this.featuresChanged = true;
        }
    };
    diff.validateFeaturesChanged();
    diff.isFeatureDeleted = function (featureName) {
        return this.deletedFeatures.hasOwnProperty(featureName);
    };
    diff.wasFeatureAdded = function (featureName) {
        return this.addedFeatures.hasOwnProperty(featureName);
    };

    diff.areFeaturesChanged = function () {
        return this.featuresChanged;
    };
    diff.wasFeatureChanged = function (featureName) {
        return diff.isFeatureDeleted(featureName) || diff.wasFeatureAdded(featureName);
    };

    diff.wasFeatureEnabledBefore = function (feature) {
        return !!diff.oldFeatures[feature];
    };
    diff.isFeatureEnabledAfter = function (feature) {
        return !!diff.newFeatures[feature];
    };

    return diff;
};

exports.default = FeatureDiffStateController;

/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _group_renderer = __webpack_require__(824);

var _group_renderer2 = _interopRequireDefault(_group_renderer);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _atBrowserUtils = __webpack_require__(8);

var _date_format = __webpack_require__(16);

var _constants = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TimeZoneGroupRenderer = function (_GroupRenderer) {
    _inherits(TimeZoneGroupRenderer, _GroupRenderer);

    function TimeZoneGroupRenderer() {
        _classCallCheck(this, TimeZoneGroupRenderer);

        return _possibleConstructorReturn(this, (TimeZoneGroupRenderer.__proto__ || Object.getPrototypeOf(TimeZoneGroupRenderer)).apply(this, arguments));
    }

    _createClass(TimeZoneGroupRenderer, [{
        key: "init",

        /**
         * @param config.groupDivClassName class name of user group row
         * @param config.groupTableClassName class name of first table in user group div
         * @param config.folderImgClassName class name of cell with folder image
         * @param config.deleteGroupLinkClassName class name of user group delete button
         * @param config.groupNameCellClassName class name of cell with user group name
         * @param config.counterSpanClassName class name of span with counter of users in user group
         * @param config.waitingAnimationCellClassName class name of cell with waiting ajax animation
         * @param config.editTableCellClassName class name of cell for edited group table
         * @param config.editInputClassName class name of edit user group input field
         * @param config.undoButtonClassName class name of user group undo edit button
         * @param config.acceptButtonClassName class name of user group accept edit button
         * @param config.nullGroupClassName class name of row of bogus 'without user group' user group
         * @param config.confirmDeleteCellClassName class name of cell for confirm delete group
         * @param config.confirmDeleteAcceptButtonClassName class name of accept confirm delete button
         * @param config.confirmDeleteUndoButtonClassName class name of undo confirm delete button
         * @param config.groupDivIdPrefix dom id prefix for user group row
         * @param config.deleteLinkIdPrefix dom id prefix for user group delete button
         * @param config.undoEditIdPrefix dom id prefix for user group undo edit button
         * @param config.acceptEditIdPrefix dom id prefix for user group accept edit button
         * @param config.editInputIdPrefix dom id prefix for user group edit input field
         * @param config.nameCellIdPrefix dom id prefix for cell with user group name
         * @param config.inputCellIdPrefix dom id prefix for cell with edit user group input field
         * @param config.editGroupCellIdPrefix dom id prefix for cell for edited group table
         * @param config.waitingAnimationCellIdPrefix  dom id prefix for cell with waiting ajax animation
         * @param config.confirmDeleteCellIdPrefix dom id prefix for group delete cell
         * @param config.confirmDeleteAcceptButtonIdPrefix dom id prefix for group accept delete button
         * @param config.confirmDeleteUndoButtonIdPrefix dom id prefix for group undo delete button
         * @param config.selectorCellClassName class name for city selector cell
         * @param config.secondRowClassName class name for second row
         * @param config.defaultGroupLabelCellClassName class name for default group label cell
         * @param config.currentTimeCellClassName class name for current time cell
         * @param config.selectorIdPrefix dom id prefix for city selector cell
         */
        value: function init(config) {
            _get(TimeZoneGroupRenderer.prototype.__proto__ || Object.getPrototypeOf(TimeZoneGroupRenderer.prototype), "init", this).call(this, config);
            this.selectorCellClassName = config.selectorCellClassName;
            this.secondRowClassName = config.secondRowClassName;
            this.defaultGroupLabelCellClassName = config.defaultGroupLabelCellClassName;
            this.currentTimeCellClassName = config.currentTimeCellClassName;
            this.selectorIdPrefix = config.selectorIdPrefix;

            return this;
        }
    }, {
        key: "buildFolderImgCell",
        value: function buildFolderImgCell(group) {
            var folderImgTd = document.createElement("td");
            folderImgTd.className = this.folderImgClassName;
            var folderImg = document.createElement("img");
            folderImg.src = (0, _atBrowserUtils.atImgPath)("user_group_lightbox/time-zone.png");
            folderImgTd.appendChild(folderImg);

            return folderImgTd;
        }
    }, {
        key: "buildCitySelectorCell",
        value: function buildCitySelectorCell(group) {
            var selectorTd = document.createElement('td');
            selectorTd.className = this.selectorCellClassName;
            var selectorDiv = document.createElement('div');
            selectorDiv.id = formatId(this.selectorIdPrefix, group.id);
            selectorTd.appendChild(selectorDiv);
            return selectorTd;
        }
    }, {
        key: "buildEmptyCell",
        value: function buildEmptyCell() {
            return document.createElement('td');
        }
    }, {
        key: "buildDefaultGroupLabelCell",
        value: function buildDefaultGroupLabelCell(group) {
            var labelTd = document.createElement('td');
            labelTd.className = this.defaultGroupLabelCellClassName;
            if (this.validatorGroupStrategy.isDefaultGroup(group)) {
                var labelSpan = document.createElement('span');
                labelSpan.innerHTML = _messageResource2.default.getMessage('group_management.default_group');
                labelTd.appendChild(labelSpan);
            }
            return labelTd;
        }
    }, {
        key: "buildCurrentTimeCell",
        value: function buildCurrentTimeCell(group) {
            var currentTimeTd = document.createElement('td');
            currentTimeTd.colSpan = 2; // need more space for current time
            currentTimeTd.className = this.currentTimeCellClassName;
            var currentTimeSpan = document.createElement('span');
            currentTimeSpan.innerHTML = _messageResource2.default.getMessage('group_management.current_time') + ' ' + new _date_format.DateFormat(SystemSettings.dateFormat, SystemSettings.clockFormat).formatDateTime(Date.parseJSONTimeWithoutTimeZone(group.currentTime));
            currentTimeTd.appendChild(currentTimeSpan);
            return currentTimeTd;
        }

        /**
         * Build columns for group row
         */

    }, {
        key: "fillTable",
        value: function fillTable(table, group) {
            var tr = document.createElement('tr');
            tr.appendChild(this.buildFolderImgCell(group));
            tr.appendChild(this.buildNameCell(group));
            tr.appendChild(this.buildCitySelectorCell(group));
            tr.appendChild(this.buildCountCell(group));
            tr.appendChild(this.buildDeleteCell(group));
            tr.appendChild(this.buildConfirmDeleteCell(group));
            tr.appendChild(this.buildWaitingAnimationCell(group));
            table.appendChild(tr);

            tr = document.createElement('tr');
            tr.className = this.secondRowClassName;
            tr.appendChild(this.buildEmptyCell()); // img cell
            tr.appendChild(this.buildDefaultGroupLabelCell(group)); // name cell
            tr.appendChild(this.buildCurrentTimeCell(group)); // citySelector cell (colspan = 2)
            // skip count cell
            tr.appendChild(this.buildEmptyCell()); // delete cell
            tr.appendChild(this.buildEmptyCell()); // confirmDelete cell
            tr.appendChild(this.buildEmptyCell()); // waiting animation cell
            table.appendChild(tr);
        }
    }, {
        key: "generateDeleteConfirmMessage",
        value: function generateDeleteConfirmMessage() {
            return _messageResource2.default.getEscapedMessage("group_management.confirm_delete.message.part_1", [_messageResource2.default.getMessage(this.groupNamingKey)]) + "<br>" + _messageResource2.default.getMessage("group_management.confirm_delete.message.part_2.time_zone_groups");
        }
    }, {
        key: "getItemText",
        value: function getItemText(group) {
            var itemText = _get(TimeZoneGroupRenderer.prototype.__proto__ || Object.getPrototypeOf(TimeZoneGroupRenderer.prototype), "getItemText", this).call(this, group);

            if (group.id === _constants.DEFAULT_TIME_ZONE_GROUP_ID) itemText += ' ' + _messageResource2.default.getMessage("users_selector.default_group");

            return itemText;
        }
    }]);

    return TimeZoneGroupRenderer;
}(_group_renderer2.default);

exports.default = TimeZoneGroupRenderer;

/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _atUtils = __webpack_require__(5);

var _atBrowserUtils = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Abstract class
 * Renders rows with user groups
 */
var GroupRenderer = function () {
    function GroupRenderer() {
        _classCallCheck(this, GroupRenderer);
    }

    _createClass(GroupRenderer, [{
        key: "init",

        /**
         * @param config.groupDivClassName class name of user group row
         * @param config.groupTableClassName class name of first table in user group div
         * @param config.folderImgClassName class name of cell with folder image
         * @param config.deleteGroupLinkClassName class name of user group delete button
         * @param config.groupNameCellClassName class name of cell with user group name
         * @param config.counterSpanClassName class name of span with counter of users in user group
         * @param config.waitingAnimationCellClassName class name of cell with waiting ajax animation
         * @param config.editTableCellClassName class name of cell for edited group table
         * @param config.editInputClassName class name of edit user group input field
         * @param config.undoButtonClassName class name of user group undo edit button
         * @param config.acceptButtonClassName class name of user group accept edit button
         * @param config.nullGroupClassName class name of row of bogus 'without user group' user group
         * @param config.defaultGroupClassName class name of row of default group
         * @param config.confirmDeleteCellClassName class name of cell for confirm delete group
         * @param config.confirmDeleteAcceptButtonClassName class name of accept confirm delete button
         * @param config.confirmDeleteUndoButtonClassName class name of undo confirm delete button
         * @param config.groupDivIdPrefix dom id prefix for user group row
         * @param config.deleteLinkIdPrefix dom id prefix for user group delete button
         * @param config.undoEditIdPrefix dom id prefix for user group undo edit button
         * @param config.acceptEditIdPrefix dom id prefix for user group accept edit button
         * @param config.editInputIdPrefix dom id prefix for user group edit input field
         * @param config.nameCellIdPrefix dom id prefix for cell with user group name
         * @param config.inputCellIdPrefix dom id prefix for cell with edit user group input field
         * @param config.editGroupCellIdPrefix dom id prefix for cell for edited group table
         * @param config.waitingAnimationCellIdPrefix  dom id prefix for cell with waiting ajax animation
         * @param config.spinnerContainerIdPrefix  dom id prefix for spinner container div
         * @param config.confirmDeleteCellIdPrefix dom id prefix for group delete cell
         * @param config.confirmDeleteAcceptButtonIdPrefix dom id prefix for group accept delete button
         * @param config.confirmDeleteUndoButtonIdPrefix dom id prefix for group undo delete button
         */
        value: function init(config) {
            this.groupDivClassName = config.groupDivClassName;
            this.groupTableClassName = config.groupTableClassName;
            this.folderImgClassName = config.folderImgClassName;
            this.deleteGroupLinkClassName = config.deleteGroupLinkClassName;
            this.groupNameCellClassName = config.groupNameCellClassName;
            this.counterSpanClassName = config.counterSpanClassName;
            this.waitingAnimationCellClassName = config.waitingAnimationCellClassName;
            this.editTableCellClassName = config.editTableCellClassName;
            this.editInputClassName = config.editInputClassName;
            this.undoButtonClassName = config.undoButtonClassName;
            this.acceptButtonClassName = config.acceptButtonClassName;
            this.nullGroupClassName = config.nullGroupClassName;
            this.defaultGroupClassName = config.defaultGroupClassName;
            this.confirmDeleteCellClassName = config.confirmDeleteCellClassName;
            this.confirmDeleteAcceptButtonClassName = config.confirmDeleteAcceptButtonClassName;
            this.confirmDeleteUndoButtonClassName = config.confirmDeleteUndoButtonClassName;
            this.groupDivIdPrefix = config.groupDivIdPrefix;
            this.deleteLinkIdPrefix = config.deleteLinkIdPrefix;
            this.undoEditIdPrefix = config.undoEditIdPrefix;
            this.acceptEditIdPrefix = config.acceptEditIdPrefix;
            this.editInputIdPrefix = config.editInputIdPrefix;
            this.nameCellIdPrefix = config.nameCellIdPrefix;
            this.inputCellIdPrefix = config.inputCellIdPrefix;
            this.editGroupCellIdPrefix = config.editGroupCellIdPrefix;
            this.waitingAnimationCellIdPrefix = config.waitingAnimationCellIdPrefix;
            this.spinnerContainerIdPrefix = config.spinnerContainerIdPrefix;
            this.confirmDeleteCellIdPrefix = config.confirmDeleteCellIdPrefix;
            this.confirmDeleteAcceptButtonIdPrefix = config.confirmDeleteAcceptButtonIdPrefix;
            this.confirmDeleteUndoButtonIdPrefix = config.confirmDeleteUndoButtonIdPrefix;
            this.groupNamingKey = config.groupNamingKey;
            this.GroupNamingKey = config.GroupNamingKey;
            this.validatorGroupStrategy = config.validatorGroupStrategy;
            return this;
        }
    }, {
        key: "buildNameCell",
        value: function buildNameCell(group) {
            var nameTd = document.createElement("td");
            nameTd.id = formatId(this.nameCellIdPrefix, group.id);
            nameTd.className = this.groupNameCellClassName;

            var containerDiv = document.createElement("div");
            var overflowDiv = document.createElement("div");
            overflowDiv.className = GroupManagementUtil.ellipsisOverflowClassName;
            var name = this.getNameForNameCell(group);
            overflowDiv.title = name;
            overflowDiv.innerHTML = (0, _atUtils.escapeHtmlSymbols)(name);
            nameTd.appendChild(containerDiv);
            containerDiv.appendChild(overflowDiv);
            (0, _atBrowserUtils.disableTextSelection)(overflowDiv);

            containerDiv.appendChild(this.buildNameEditCell(group));

            return nameTd;
        }
    }, {
        key: "getNameForNameCell",
        value: function getNameForNameCell(group) {
            return group.name;
        }
    }, {
        key: "buildCountCell",
        value: function buildCountCell(group) {
            var count = group.countOfUserWithEnabledAccess();
            var countTd = document.createElement("td");
            countTd.className = this.counterSpanClassName;
            if (count === 0) countTd.className += " zeroCount";
            countTd.innerHTML = '(' + count + ')';
            (0, _atBrowserUtils.disableTextSelection)(countTd);

            return countTd;
        }
    }, {
        key: "buildDeleteCell",
        value: function buildDeleteCell(group) {
            var deleteTd = document.createElement("td");
            deleteTd.className = this.deleteGroupLinkClassName;
            var deleteLink = this.makeBlankLink();

            var deleteSpan = document.createElement("span");
            deleteSpan.id = formatId(this.deleteLinkIdPrefix, group.id);

            deleteTd.appendChild(deleteLink);
            deleteLink.appendChild(deleteSpan);

            return deleteTd;
        }
    }, {
        key: "buildWaitingAnimationCell",
        value: function buildWaitingAnimationCell(group) {
            var waitingAnimationTd = document.createElement("td");
            waitingAnimationTd.className = this.waitingAnimationCellClassName;
            waitingAnimationTd.id = formatId(this.waitingAnimationCellIdPrefix, group.id);

            var spinnerContainer = document.createElement("div");
            spinnerContainer.id = formatId(this.spinnerContainerIdPrefix, group.id);
            waitingAnimationTd.appendChild(spinnerContainer);

            return waitingAnimationTd;
        }
    }, {
        key: "buildConfirmDeleteCell",
        value: function buildConfirmDeleteCell(group) {
            var confirmDeleteTd = document.createElement("td");
            confirmDeleteTd.className = this.confirmDeleteCellClassName;
            confirmDeleteTd.id = formatId(this.confirmDeleteCellIdPrefix, group.id);

            var table = document.createElement("table");
            var tbody = document.createElement("tbody");
            var tr = document.createElement("tr");

            var confirmDeleteTextTd = document.createElement("td");
            var confirmDeleteText = document.createElement('span');
            confirmDeleteText.innerHTML = this.generateDeleteConfirmMessage();
            confirmDeleteTextTd.appendChild(confirmDeleteText);

            var confirmDeleteButtonTd = document.createElement("td");
            var confirmDeleteButton = document.createElement('button');
            confirmDeleteButton.className = this.confirmDeleteAcceptButtonClassName;
            confirmDeleteButton.id = formatId(this.confirmDeleteAcceptButtonIdPrefix, group.id);
            confirmDeleteButton.innerHTML = _messageResource2.default.getMessage('group_management.confirm_delete.confirm');
            confirmDeleteButtonTd.appendChild(confirmDeleteButton);

            var cancelDeleteButtonTd = document.createElement("td");
            var cancelDeleteButton = document.createElement('div');
            cancelDeleteButton.className = this.confirmDeleteUndoButtonClassName;
            cancelDeleteButton.id = formatId(this.confirmDeleteUndoButtonIdPrefix, group.id);
            cancelDeleteButton.innerHTML = _messageResource2.default.getMessage('group_management.confirm_delete.cancel');
            cancelDeleteButtonTd.appendChild(cancelDeleteButton);

            table.appendChild(tbody);
            tbody.appendChild(tr);
            tr.appendChild(confirmDeleteTextTd);
            tr.appendChild(confirmDeleteButtonTd);
            tr.appendChild(cancelDeleteButtonTd);
            confirmDeleteTd.appendChild(table);

            return confirmDeleteTd;
        }

        /**
         * Build table for edited group
         * @param group GroupWithUsers instance
         */

    }, {
        key: "buildNameEditCell",
        value: function buildNameEditCell(group) {
            var editCell = document.createElement("div");
            editCell.className = this.editTableCellClassName;
            editCell.id = formatId(this.editGroupCellIdPrefix, group.id);
            var table = document.createElement("table");
            table.id = formatId(this.inputCellIdPrefix, group.id);
            var tbody = document.createElement("tbody");
            var tr = document.createElement("tr");

            var inputTd = document.createElement("td");
            inputTd.className = this.editInputClassName;
            var editInput = document.createElement("input");
            editInput.type = "text";
            editInput.value = group.name;
            editInput.id = formatId(this.editInputIdPrefix, group.id);
            editInput.maxLength = "40";
            inputTd.appendChild(editInput);

            var undoTd = document.createElement("td");
            undoTd.className = this.undoButtonClassName;
            undoTd.id = formatId(this.undoEditIdPrefix, group.id);

            var undoDiv = document.createElement("div");
            var undoImg = document.createElement("img");
            undoImg.src = (0, _atBrowserUtils.atImgPath)("user_group_lightbox/cancel.png");
            undoDiv.appendChild(undoImg);
            undoTd.appendChild(undoDiv);

            var acceptTd = document.createElement("td");
            acceptTd.className = this.acceptButtonClassName;
            acceptTd.id = formatId(this.acceptEditIdPrefix, group.id);

            var acceptDiv = document.createElement("div");
            var acceptImg = document.createElement("img");
            acceptImg.src = (0, _atBrowserUtils.atImgPath)("user_group_lightbox/green-tick.png");
            acceptDiv.appendChild(acceptImg);
            acceptTd.appendChild(acceptDiv);

            editCell.appendChild(table);
            table.appendChild(tbody);
            tbody.appendChild(tr);
            tr.appendChild(inputTd);
            tr.appendChild(acceptTd);
            tr.appendChild(undoTd);

            return editCell;
        }

        /**
         * Build columns for group row
         */

    }, {
        key: "fillTable",
        value: function fillTable(tableTr, group) {}
        // abstract


        /**
         * Generate one row for group
         * @param group GroupWithUsers instance
         */

    }, {
        key: "generateContent",
        value: function generateContent(group) {
            var div = document.createElement("div");
            div.className = this.groupDivClassName;
            if (this.validatorGroupStrategy.isNullGroup(group)) (0, _atBrowserUtils.addClass)(div, this.nullGroupClassName);
            if (this.validatorGroupStrategy.isDefaultGroup(group)) (0, _atBrowserUtils.addClass)(div, this.defaultGroupClassName);
            div.id = formatId(this.groupDivIdPrefix, group.id);

            var table = document.createElement("table");
            table.className = this.groupTableClassName;

            this.fillTable(table, group);

            div.appendChild(table);

            return div;
        }

        /**
         * Make blank link with killed href
         */

    }, {
        key: "makeBlankLink",
        value: function makeBlankLink() {
            var link = document.createElement("a");
            link.href = "javascript: void(0)";
            return link;
        }
    }, {
        key: "generateDeleteConfirmMessage",
        value: function generateDeleteConfirmMessage() {
            // abstract
        }
    }, {
        key: "getItemText",
        value: function getItemText(group) {
            return (0, _atUtils.escapeHtmlSymbols)(group.name);
        }
    }]);

    return GroupRenderer;
}();

exports.default = GroupRenderer;

/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = GroupDataRetrieveRPCManager;

var _rpc_control_manager = __webpack_require__(235);

var _rpc_control_manager2 = _interopRequireDefault(_rpc_control_manager);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * RPC manager for reading group data
 * @param serviceName name of the RPC java service
 * @param controller group management controller
 * @param afterErrorCallback function that will be call if error on data reading occurs
 * @param afterSavingCallback function that will be call if data reading is success
 *
 *
 * @name PRODUCT_NAME (defined in constants_js.jsp)
 */
function GroupDataRetrieveRPCManager(serviceName, controller, afterErrorCallback, afterSavingCallback) {
    _rpc_control_manager2.default.call(this);
    this.serviceName = serviceName;
    this.controller = controller;
    this.afterErrorCallback = afterErrorCallback;
    this.afterSavingCallback = afterSavingCallback;
}

GroupDataRetrieveRPCManager.prototype = new _rpc_control_manager2.default();

GroupDataRetrieveRPCManager.prototype.getService = function () {
    return jsonrpc[this.serviceName];
};

GroupDataRetrieveRPCManager.prototype.getMethods = function () {
    return [this.serviceName + '.getAllGroupsWithUsers'];
};

GroupDataRetrieveRPCManager.prototype.endSavingData = function (success) {
    if (!success && this.afterErrorCallback) {
        this.afterErrorCallback();
    }
};

GroupDataRetrieveRPCManager.prototype.onDataSavingComplete = function (result) {
    this.controller.dataRetrievingCompleted(result);
    if (this.afterSavingCallback) {
        this.afterSavingCallback();
    }
};

GroupDataRetrieveRPCManager.prototype.handleNoRightsError = function (exception) {
    if (exception.name.indexOf('com.actimind.actitime.services.NoRightsForRemoteCallException') != -1) {
        alert(JQUERY_RPC_ERROR_MESSAGES.NO_RIGHTS);
        document.location.reload();
        return true;
    }
    return false;
};

GroupDataRetrieveRPCManager.prototype.handleSpecificError = function (exception) {
    if (this.afterErrorCallback) {
        this.afterErrorCallback();
    }
    if (exception.name.indexOf('com.actimind.common.services.UserGroupsDisabledException') != -1) {
        if (PRODUCT_NAME == Product.actiPLANS) alert(_messageResource2.default.getMessage('actiplans.user_list.js.error.user_groups_disabled'));else alert(_messageResource2.default.getMessage('userlist.js.error_ugr_disabled'));
        document.location.reload();
        return true;
    }
    if (exception.name.indexOf('com.actimind.common.services.TimeZoneGroupsDisabledException') != -1) {
        if (PRODUCT_NAME == Product.actiPLANS) alert(_messageResource2.default.getMessage('actiplans.user_list.js.error.time_zone_groups_disabled'));else alert(_messageResource2.default.getMessage('userlist.js.error_tzg_disabled'));
        document.location.reload();
        return true;
    }
    if (exception.name.indexOf('com.actimind.actitime.services.NoRightsToManageAccountSettings') != -1) {
        alert(_messageResource2.default.getMessage('group_management.permissions_changed'));
        document.location.reload();
        return true;
    }
    if (exception.msg.indexOf('com.actimind.common.licensing.LicenseViolatedException') !== -1) {
        alert(_messageResource2.default.getMessage('common.license_violated_exception.action_is_not_available'));
        return true;
    }

    if (exception.msg.indexOf('com.actimind.common.licensing.NoActiveLicensesException') !== -1) {
        alert(_messageResource2.default.getMessage('common.license_expired_exception.reload_page'));
        document.location.reload();
        return true;
    }

    alert(_messageResource2.default.getMessage("group_management.data_read_error"));
    return true;
};

GroupDataRetrieveRPCManager.prototype.makeRemoteCall = function (callback) {
    this.getService().getAllGroupsWithUsers(callback);
};

GroupDataRetrieveRPCManager.prototype.getTimeoutMsg = function () {
    return _messageResource2.default.getMessage("common.ajax.timeout.read_data");
};

/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _rpcCalls = __webpack_require__(24);

var _errors = __webpack_require__(528);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ATUserGroupManagementService = function () {
    function ATUserGroupManagementService() {
        _classCallCheck(this, ATUserGroupManagementService);
    }

    _createClass(ATUserGroupManagementService, [{
        key: "createUserGroup",
        value: function createUserGroup(group) {
            return (0, _rpcCalls.rpcCall)("ATUserGroupManagementService.createUserGroup", [group], this._rpcErrorHandler);
        }
    }, {
        key: "_rpcErrorHandler",
        value: function _rpcErrorHandler(rpcError) {
            rpcError.handleOnException('com.actimind.common.services.UserGroupsDisabledException', new _errors.UserGroupsDisabledError());
            rpcError.handleOnException('com.actimind.actitime.services.NoRightsToManageAccountSettings', new _errors.NoRightsToManageAccountSettingsError());
            rpcError.handleOnException('com.actimind.actitime.administration.GroupExistsException', new _errors.GroupExistsError());
        }
    }]);

    return ATUserGroupManagementService;
}();

exports.default = ATUserGroupManagementService;

/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _group_renderer = __webpack_require__(824);

var _group_renderer2 = _interopRequireDefault(_group_renderer);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _atBrowserUtils = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UserGroupRenderer = function (_GroupRenderer) {
    _inherits(UserGroupRenderer, _GroupRenderer);

    function UserGroupRenderer() {
        _classCallCheck(this, UserGroupRenderer);

        return _possibleConstructorReturn(this, (UserGroupRenderer.__proto__ || Object.getPrototypeOf(UserGroupRenderer)).apply(this, arguments));
    }

    _createClass(UserGroupRenderer, [{
        key: "buildFolderImgCell",
        value: function buildFolderImgCell(group) {
            var folderImgTd = document.createElement("td");
            folderImgTd.className = this.folderImgClassName;
            var folderImg = document.createElement("img");
            if (this.validatorGroupStrategy.isNullGroup(group)) {
                folderImg.src = (0, _atBrowserUtils.atImgPath)("user_group_lightbox/no-group-icon.png");
            } else {
                folderImg.src = (0, _atBrowserUtils.atImgPath)("user_group_lightbox/group-folder-icon.png");
            }
            folderImgTd.appendChild(folderImg);

            return folderImgTd;
        }

        /**
         * Build columns for group row
         */

    }, {
        key: "fillTable",
        value: function fillTable(table, group) {
            var tr = document.createElement('tr');
            tr.appendChild(this.buildFolderImgCell(group));
            tr.appendChild(this.buildNameCell(group));
            tr.appendChild(this.buildCountCell(group));
            tr.appendChild(this.buildDeleteCell(group));
            tr.appendChild(this.buildConfirmDeleteCell(group));
            tr.appendChild(this.buildWaitingAnimationCell(group));
            table.appendChild(tr);
        }
    }, {
        key: "generateDeleteConfirmMessage",
        value: function generateDeleteConfirmMessage() {
            return _messageResource2.default.getEscapedMessage("group_management.confirm_delete.message.part_1.user_groups") + " " + _messageResource2.default.getMessage("group_management.confirm_delete.message.part_2.user_groups");
        }
    }]);

    return UserGroupRenderer;
}(_group_renderer2.default);

exports.default = UserGroupRenderer;

/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _GroupWithUsers2 = __webpack_require__(387);

var _GroupWithUsers3 = _interopRequireDefault(_GroupWithUsers2);

var _atBrowserUtils = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Wrapper for GroupWithUsers. Contains all needed dom elements of user group row
 */
var GroupRow = function (_GroupWithUsers) {
    _inherits(GroupRow, _GroupWithUsers);

    function GroupRow() {
        _classCallCheck(this, GroupRow);

        return _possibleConstructorReturn(this, (GroupRow.__proto__ || Object.getPrototypeOf(GroupRow)).apply(this, arguments));
    }

    _createClass(GroupRow, [{
        key: "init",

        /**
         * @param div user group row
         * @param deleteLink user group delete button
         * @param undoDeleteButton group undo delete button
         * @param acceptDeleteButton group accept delete button
         * @param undoEditButton user group undo edit button
         * @param acceptEditButton user group accept edit button
         * @param input user group edit input field
         * @param nameCell cell with user group name
         * @param inputCell cell with edit user group input field
         * @param editGroupCell cell for edited group table
         * @param waitingAnimationCell cell with waiting ajax animation
         * @param group GroupRow to wrap
         * @param validatorGroupStrategy
         * @param controller user group management controller
         */
        value: function init(div, deleteLink, undoDeleteButton, acceptDeleteButton, undoEditButton, acceptEditButton, input, nameCell, inputCell, editGroupCell, waitingAnimationCell, group, validatorGroupStrategy, controller) {
            _GroupWithUsers3.default.call(this, group.id, group.name, validatorGroupStrategy, group.users);
            this.div = div;
            this.deleteLink = deleteLink;
            this.undoEditButton = undoEditButton;
            this.acceptEditButton = acceptEditButton;
            this.undoDeleteButton = undoDeleteButton;
            this.acceptDeleteButton = acceptDeleteButton;
            this.input = input;
            this.nameCell = nameCell;
            this.nameDiv = nameCell.firstChild.firstChild;
            this.inputCell = inputCell;
            this.editGroupCell = editGroupCell;
            this.waitingAnimationCell = waitingAnimationCell;
            this.generateEventHandlers(controller);
            this.enableControls();
            this.enableRow();

            return this;
        }

        /**
         * Generate all needed event handlers with user group row elements
         * @param controller user group management controller
         */

    }, {
        key: "generateEventHandlers",
        value: function generateEventHandlers(controller) {
            var _this2 = this;

            this.normalEditGroupOnClick = function (event) {
                (0, _atBrowserUtils.cancelBubble)(event);
                controller.groupEventHandler(function () {
                    controller.startGroupEditing(_this2);
                    controller.groupSelected(_this2);
                }, false);
            };

            this.normalDeleteGroupOnClick = function (event) {
                (0, _atBrowserUtils.cancelBubble)(event);
                controller.groupEventHandler(function () {
                    return controller.confirmGroupDelete(_this2);
                }, false);
            };

            this.noFunctionWithCancelBubble = function (event) {
                return (0, _atBrowserUtils.cancelBubble)(event);
            };

            this.rowOnClick = function () {
                return controller.groupEventHandler(function () {
                    return controller.groupSelected(_this2);
                }, false);
            };

            this.onClickOutsideEditGroupCell = function () {
                controller.hideErrors();
                controller.endGroupEditing(false);
            };

            this.inputOnClick = function () {
                return (0, _atBrowserUtils.cancelBubble)(event);
            };

            this.undoEditButtonOnClick = function (event) {
                (0, _atBrowserUtils.cancelBubble)(event);
                controller.groupEventHandler(function () {}, false);
            };

            this.acceptEditButtonOnClick = function (event) {
                (0, _atBrowserUtils.cancelBubble)(event);
                controller.getGroupController().startNewGroupNameSaving(controller, _this2);
            };

            this.undoDeleteButtonOnClick = function (event) {
                (0, _atBrowserUtils.cancelBubble)(event);
                controller.groupEventHandler(function () {}, false);
            };

            this.acceptDeleteButtonOnClick = function (event) {
                (0, _atBrowserUtils.cancelBubble)(event);
                controller.groupEventHandler(function () {
                    return controller.deleteGroup(_this2);
                }, false);
            };

            this.inputOnKeyDown = function (event) {
                (0, _atBrowserUtils.cancelBubble)(event);
                GroupManagementUtil.createEnterPressedHandler(event, function () {
                    return controller.getGroupController().startNewGroupNameSaving(controller, _this2);
                });
                GroupManagementUtil.createEscPressedHandler(event, function () {
                    return controller.groupEventHandler(function () {}, false);
                });
            };

            this.divOnMouseOver = function () {
                controller.getHighlightController().highlightHoveredGroup(_this2);
                _this2.hovered = true;
            };

            this.divOnMouseOut = function () {
                controller.getHighlightController().unhighlightHoveredGroup(_this2);
                _this2.hovered = false;
            };

            this.groupButtonControlOnMouseOver = function () {
                controller.getHighlightController().highlightHoveredControl(this);
            };

            this.groupButtonControlOnMouseOut = function () {
                controller.getHighlightController().unhighlightHoveredControl(this);
            };

            this.groupUndoAcceptEditButtonOnMouseOver = function () {
                controller.getHighlightController().highlightHoveredUndoAcceptEditButton(this);
            };

            this.groupUndoAcceptEditButtonOnMouseOut = function () {
                controller.getHighlightController().unhighlightHoveredUndoAcceptEditButton(this);
            };

            this.noFunction = function () {
                return false;
            };
        }

        /**
         * Disable all needed controls when ajax request is processed with this row
         */

    }, {
        key: "disableControlsDueToAjax",
        value: function disableControlsDueToAjax() {
            if (!this.validatorGroupStrategy.isNullGroup(this)) {
                this.nameDiv.onclick = this.noFunction;
                this.deleteLink.onclick = this.noFunctionWithCancelBubble;
                this.deleteLink.onmouseover = this.noFunction;
                this.deleteLink.onmouseout = this.noFunction;
            }
        }

        /**
         * Enable all controls. Used to initialize event handlers
         */

    }, {
        key: "enableControls",
        value: function enableControls() {
            this.div.onmouseover = this.divOnMouseOver;
            this.div.onmouseout = this.divOnMouseOut;
            if (!this.validatorGroupStrategy.isNullGroup(this)) {
                this.nameDiv.onclick = this.normalEditGroupOnClick;
                this.undoEditButton.onclick = this.undoEditButtonOnClick;
                this.acceptEditButton.onclick = this.acceptEditButtonOnClick;
                this.undoEditButton.onmouseover = this.groupUndoAcceptEditButtonOnMouseOver;
                this.undoEditButton.onmouseout = this.groupUndoAcceptEditButtonOnMouseOut;
                this.acceptEditButton.onmouseover = this.groupUndoAcceptEditButtonOnMouseOver;
                this.acceptEditButton.onmouseout = this.groupUndoAcceptEditButtonOnMouseOut;
                this.undoDeleteButton.onclick = this.undoDeleteButtonOnClick;
                this.acceptDeleteButton.onclick = this.acceptDeleteButtonOnClick;
                this.input.onkeydown = this.inputOnKeyDown;
            }
            if (!this.validatorGroupStrategy.isNullGroup(this) && !this.validatorGroupStrategy.isDefaultGroup(this)) {
                this.deleteLink.onclick = this.normalDeleteGroupOnClick;
                this.deleteLink.onmouseover = this.groupButtonControlOnMouseOver;
                this.deleteLink.onmouseout = this.groupButtonControlOnMouseOut;
            }
        }

        /**
         * Disable mouse events when they are not needed
         */

    }, {
        key: "disableMouseEvents",
        value: function disableMouseEvents(saveHover) {
            if (!saveHover) {
                this.div.onmouseover = this.noFunction;
                this.div.onmouseout = this.noFunction;
            }
            if (!this.validatorGroupStrategy.isNullGroup(this) && !this.validatorGroupStrategy.isDefaultGroup(this)) {
                this.deleteLink.onmouseover = this.noFunction;
                this.deleteLink.onmouseout = this.noFunction;
            }
        }

        /**
         * Disable mouse events on edited user group when they are not needed
         */

    }, {
        key: "disableEditedGroupMouseEvents",
        value: function disableEditedGroupMouseEvents() {
            if (!this.validatorGroupStrategy.isNullGroup(this) && !this.validatorGroupStrategy.isDefaultGroup(this)) {
                this.undoEditButton.onmouseover = this.noFunction;
                this.acceptEditButton.onmouseover = this.noFunction;
                this.undoEditButton.onmouseout = this.noFunction;
                this.acceptEditButton.onmouseout = this.noFunction;
            }
        }

        /**
         * Enable mouse events on edited user group
         */

    }, {
        key: "enableEditedGroupMouseEvents",
        value: function enableEditedGroupMouseEvents() {
            if (!this.validatorGroupStrategy.isNullGroup(this) && !this.validatorGroupStrategy.isDefaultGroup(this)) {
                this.undoEditButton.onmouseover = this.groupUndoAcceptEditButtonOnMouseOver;
                this.acceptEditButton.onmouseover = this.groupUndoAcceptEditButtonOnMouseOver;
                this.undoEditButton.onmouseout = this.groupUndoAcceptEditButtonOnMouseOut;
                this.acceptEditButton.onmouseout = this.groupUndoAcceptEditButtonOnMouseOut;
            }
        }

        /**
         * Enable mouse events on user group
         */

    }, {
        key: "enableMouseEvents",
        value: function enableMouseEvents() {
            this.div.onmouseover = this.divOnMouseOver;
            this.div.onmouseout = this.divOnMouseOut;
            if (!this.validatorGroupStrategy.isNullGroup(this) && !this.validatorGroupStrategy.isDefaultGroup(this)) {
                this.deleteLink.onmouseover = this.groupButtonControlOnMouseOver;
                this.deleteLink.onmouseout = this.groupButtonControlOnMouseOut;
            }
        }

        /**
         * Disable mouse events on whole user group row
         */

    }, {
        key: "disableRow",
        value: function disableRow() {
            this.div.onclick = this.noFunction;
        }

        /**
         * Enable mouse events on whole user group row
         */

    }, {
        key: "enableRow",
        value: function enableRow() {
            this.div.onclick = this.rowOnClick;
            this.input.onclick = this.noFunction;
            (0, _jquery2.default)(document).off("mousedown.editGroupCell");
        }

        /**
         * Disable all previous mouse events on whole row while group editing and set handler for cancel editing
         * Set handler on active input for prevent cancel editing while click on input field and handler for cancel editing while clicking outside name input
         */

    }, {
        key: "disableRowForEditing",
        value: function disableRowForEditing() {
            var context = this;
            var editGroupCell = (0, _jquery2.default)(this.editGroupCell);
            (0, _jquery2.default)(document).on("mousedown.editGroupCell", function (event) {
                var target = (0, _jquery2.default)(event.target);
                if (target.parents().index(editGroupCell) == -1) {
                    context.onClickOutsideEditGroupCell();
                }
            });
            this.editGroupCell.onclick = this.inputOnClick;
        }

        /**
         * Pass user group name into text of user group edit input field
         */

    }, {
        key: "revertInputText",
        value: function revertInputText() {
            this.input.value = this.name;
        }

        /**
         * Defines is user group name changed or not
         */

    }, {
        key: "isNameChanged",
        value: function isNameChanged() {
            return this.input.value.trim() != this.name.trim();
        }

        /**
         * Repaint row if ajax request is processed now onto it
         * @param additionalClassName
         */

    }, {
        key: "markAsAjaxProcessedNow",
        value: function markAsAjaxProcessedNow(additionalClassName) {
            this.waitingAnimationCell.style.display = 'table-cell';
            (0, _atBrowserUtils.addClass)(this.div, additionalClassName);
        }
    }, {
        key: "isHovered",
        value: function isHovered() {
            return this.hovered;
        }
    }, {
        key: "focusAcceptDeleteButton",
        value: function focusAcceptDeleteButton() {
            (0, _jquery2.default)(this.acceptDeleteButton).focus();
        }
    }]);

    return GroupRow;
}(_GroupWithUsers3.default);

exports.default = GroupRow;

/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _group_management_util = __webpack_require__(386);

var _group_management_util2 = _interopRequireDefault(_group_management_util);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _rpc_control_manager = __webpack_require__(235);

var _rpc_control_manager2 = _interopRequireDefault(_rpc_control_manager);

var _atBrowserUtils = __webpack_require__(8);

var _atUtils = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Handle all operations with add user group row in lightbox
 */
var AddGroupController = function () {
    function AddGroupController() {
        _classCallCheck(this, AddGroupController);
    }

    _createClass(AddGroupController, [{
        key: "init",

        /**
         * @param config.newGroupInputId input for new group name
         * @param config.newGroupInputCellId cell, where newGroupInputId situates
         * @param config.addGroupButtonId button for accept new group creation
         * @param config.addGroupRowId common element of all controls
         * @param config.rowHighlightedClassName class name for highlighted row
         * @param config.ajaxProcessingClassName class name for paint row as ajax processd
         * @param config.waitingAnimationCellId cell with animation needed for ajax
         * @param config.spinnerController spinner controller
         */
        value: function init(config) {
            this.newGroupInputId = config.newGroupInputId;
            this.newGroupInputCellId = config.newGroupInputCellId;
            this.addGroupButtonId = config.addGroupButtonId;
            this.addGroupRowId = config.addGroupRowId;
            this.rowHighlightedClassName = config.rowHighlightedClassName;
            this.ajaxProcessingClassName = config.ajaxProcessingClassName;
            this.waitingAnimationCellId = config.waitingAnimationCellId;
            this.groupNamingKey = config.groupNamingKey;
            this.GroupNamingKey = config.GroupNamingKey;
            this.spinnerController = config.spinnerController;
            return this;
        }

        /**
         * Init controller
         * @param controller user group management controller
         */

    }, {
        key: "initAfterShowing",
        value: function initAfterShowing(controller) {

            this.newGroupInput = document.getElementById(this.newGroupInputId);
            this.newGroupInputCell = document.getElementById(this.newGroupInputCellId);
            this.addGroupButton = document.getElementById(this.addGroupButtonId);
            this.addGroupRow = document.getElementById(this.addGroupRowId);
            this.waitingAnimationCell = document.getElementById(this.waitingAnimationCellId);

            this.initFieldController(controller);
            var context = this;

            this.changeButtonState(controller, true);

            this.newGroupInput.onkeyup = function (event) {
                _group_management_util2.default.createNoEnterAndEscPressedHandler(event, function () {
                    var isEmpty = context.emptyFieldController.isEmpty();
                    controller.passiveEventHandler(function () {
                        context.changeButtonState(controller, isEmpty);
                    }, false);
                    //Fix for FF bug. If field is empty FF places cursor at the end of the input.
                    if (isEmpty) {
                        context.newGroupInput.blur();
                        context.newGroupInput.focus();
                    }
                });
            };

            this.newGroupInput.onkeydown = function (event) {
                (0, _atBrowserUtils.cancelBubble)(event);
                _group_management_util2.default.createEscPressedHandler(event, function () {
                    context.resetRowIntoDefaultState();
                });
                _group_management_util2.default.createEnterPressedHandler(event, function () {
                    controller.groupEventHandler(function () {
                        context.createUserGroup(controller);
                    }, false);
                });
            };

            this.newGroupInput.onblur = function (event) {
                var isEmpty = context.emptyFieldController.isEmpty();
                controller.passiveEventHandler(function () {
                    context.defineHighlightingState(isEmpty);
                    context.changeButtonState(controller, isEmpty);
                }, false);
            };

            this.newGroupInput.onfocus = function (event) {
                controller.passiveEventHandler(function () {
                    context.highlightRow();
                }, false);
            };
        }

        /**
         * Init field controller needed for paint empty caption
         */

    }, {
        key: "initFieldController",
        value: function initFieldController() {
            this.emptyFieldController = new EnhancedFieldController();
            this.emptyFieldController.emptyCaption = this.getNewGroupFieldEmptyCaption();
            this.emptyFieldController.init(this.newGroupInput.id);
        }
    }, {
        key: "getNewGroupFieldEmptyCaption",
        value: function getNewGroupFieldEmptyCaption() {
            return _messageResource2.default.getMessage("group_management.new_user_group", [_messageResource2.default.getMessage(this.GroupNamingKey)]);
        }

        /**
         * Change state of all row controls in dependence of input field emptiness
         * @param controller user group management controller
         */

    }, {
        key: "changeStateIfNeeded",
        value: function changeStateIfNeeded(controller) {
            var isEmpty = this.emptyFieldController.isEmpty();
            this.changeButtonState(controller, isEmpty);
            this.defineHighlightingState(isEmpty);
        }

        /**
         * Enable or disable add new user group button
         * @param controller user group management controller
         * @param isEmpty is input field empty
         */

    }, {
        key: "changeButtonState",
        value: function changeButtonState(controller, isEmpty) {
            var isDisabledButton = isEmpty || controller.isAJAXRequestProcessedNow;

            (0, _jquery2.default)(this.addGroupButton).toggleClass("disabled", isDisabledButton);

            var context = this;
            this.addGroupButton.onclick = isDisabledButton ? function () {} : function () {
                controller.groupEventHandler(function () {
                    context.createUserGroup(controller);
                }, false);
            };
        }

        /**
         * Paint border of a input as solid
         */

    }, {
        key: "highlightRow",
        value: function highlightRow() {
            (0, _atBrowserUtils.addClass)(this.newGroupInputCell, this.rowHighlightedClassName);
        }
    }, {
        key: "unhighlightRow",
        value: function unhighlightRow() {
            (0, _atBrowserUtils.removeClass)(this.newGroupInputCell, this.rowHighlightedClassName);
        }

        /**
         * Define state of row highlighting in dependence of input field emptiness
         * @param isEmpty is input filed empty
         */

    }, {
        key: "defineHighlightingState",
        value: function defineHighlightingState(isEmpty) {
            var context = this;
            if (isEmpty) {
                this.unhighlightRow();
                (0, _jquery2.default)(this.newGroupInputCell).hover(function (e) {
                    context.highlightRow();
                }, function (e) {
                    context.unhighlightRow();
                });
            } else {
                this.highlightRow();
                (0, _jquery2.default)(this.newGroupInputCell).off("hover");
            }
        }

        /**
         * Create new user group
         * @param controller user group management controller
         */

    }, {
        key: "createUserGroup",
        value: function createUserGroup(controller) {
            var context = this;
            if (this.emptyFieldController.isEmpty()) {
                return;
            }
            if (controller.getGroupController().isDuplicateName(this.newGroupInput.value)) {
                window.setTimeout(function () {
                    var errorMessage = _messageResource2.default.getMessage("group_management.error.duplicate_name.user_group", [_messageResource2.default.getMessage(context.GroupNamingKey)]);
                    _group_management_util2.default.markCellAsInvalid(context.newGroupInputCell, errorMessage);
                    controller.showErrorMessage((0, _atUtils.escapeHtmlSymbols)(errorMessage));
                }, 100);
            } else {
                controller.isChangesMade = true;
                this.createUserGroupRpc(controller);
            }
        }
    }, {
        key: "createUserGroupRpc",
        value: function createUserGroupRpc(controller) {
            var manager = new GroupCreateRPCManager(controller.getServiceName(), controller, this.getNewGroupData(), this.GroupNamingKey);
            _rpc_control_manager2.default.saveRpcControlBoundData(manager, false);
            this.spinnerController.spin(this.waitingAnimationCellId);
        }
    }, {
        key: "getNewGroupData",
        value: function getNewGroupData() {
            return {
                id: -1,
                name: this.newGroupInput.value
            };
        }

        /**
         * Paint row as ajax processed when new user group saving begins
         */

    }, {
        key: "markRowAsAJAXProcessedNow",
        value: function markRowAsAJAXProcessedNow() {
            (0, _atBrowserUtils.addClass)(this.addGroupRow, this.ajaxProcessingClassName);
            this.newGroupInput.disabled = "disabled";
            this.waitingAnimationCell.style.display = "table-cell";
        }

        /**
         * Reset add user group row into default state
         */

    }, {
        key: "resetRowIntoDefaultState",
        value: function resetRowIntoDefaultState() {
            (0, _atBrowserUtils.removeClass)(this.addGroupRow, this.ajaxProcessingClassName);
            this.newGroupInput.disabled = "";
            this.newGroupInput.value = "";
            this.waitingAnimationCell.style.display = "none";
            this.changeStateIfNeeded();
            this.newGroupInput.blur();
            this.emptyFieldController.showGreyTextIfEmpty();
            this.spinnerController.stop();
        }
    }]);

    return AddGroupController;
}();

exports.default = AddGroupController;

/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var BaseReportStore = function () {
    function BaseReportStore() {
        _classCallCheck(this, BaseReportStore);

        this.reportData = null;
        this.reportParams = null;
        this.groupingData = null;
        this.generatedPDF = null;
        this.fileName = "file.pdf";
        this.printParametersForGenerate = null;
        this.printParametersForSave = {
            paperOrientation: "PORTRAIT",
            paperSize: "A4",
            showHeaderOnEachPage: false,
            showLogoInHeader: true
        };
    }

    _createClass(BaseReportStore, [{
        key: "getReportData",
        value: function getReportData() {
            return this.reportData;
        }
    }, {
        key: "setReportData",
        value: function setReportData(reportData, groupingData) {
            this.reportData = reportData;
            this.groupingData = groupingData;
            (0, _jquery2.default)(this).trigger("reportDataChange");
        }
    }, {
        key: "getReportParams",
        value: function getReportParams() {
            return this.reportParams;
        }
    }, {
        key: "setReportParams",
        value: function setReportParams(reportParams) {
            this.reportParams = reportParams;
            (0, _jquery2.default)(this).trigger("reportParamsChange");
        }
    }, {
        key: "getUsers",
        value: function getUsers() {
            return this.groupingData.USER;
        }
    }, {
        key: "getUserGroups",
        value: function getUserGroups() {
            return this.groupingData.USER_GROUP;
        }
    }, {
        key: "getTimeZoneGroups",
        value: function getTimeZoneGroups() {
            return this.groupingData.TIME_ZONE_GROUP;
        }
    }, {
        key: "getUser",
        value: function getUser(id) {
            return this.groupingData.USER[id];
        }
    }, {
        key: "getUserGroup",
        value: function getUserGroup(id) {
            return this.groupingData.USER_GROUP[id];
        }
    }, {
        key: "getTimeZoneGroup",
        value: function getTimeZoneGroup(id) {
            return this.groupingData.TIME_ZONE_GROUP[id];
        }
    }, {
        key: "getDateInfo",
        value: function getDateInfo(id) {
            return this.groupingData.DATE[id];
        }
    }, {
        key: "getMonth",
        value: function getMonth(id) {
            return this.groupingData.MONTH[id];
        }
    }, {
        key: "getWeek",
        value: function getWeek(id) {
            return this.groupingData.WEEK[id];
        }
    }, {
        key: "getGeneratedPDF",
        value: function getGeneratedPDF() {
            return this.generatedPDF;
        }
    }, {
        key: "setGeneratedPDF",
        value: function setGeneratedPDF(generatedPDF) {
            this.generatedPDF = generatedPDF;
            (0, _jquery2.default)(this).trigger("generatedPDFChange");
        }
    }, {
        key: "getPDFFileName",
        value: function getPDFFileName() {
            return this.fileName;
        }
    }, {
        key: "setPDFFileName",
        value: function setPDFFileName(fileName) {
            this.fileName = fileName;
        }
    }, {
        key: "getPrintParametersForSave",
        value: function getPrintParametersForSave() {
            return this.printParametersForSave;
        }
    }, {
        key: "setPrintParametersForSave",
        value: function setPrintParametersForSave(printParametersForSave) {
            this.printParametersForSave = printParametersForSave;
            (0, _jquery2.default)(this).trigger("printParametersForSaveChange");
        }
    }, {
        key: "getPrintParametersForGenerate",
        value: function getPrintParametersForGenerate() {
            return this.printParametersForGenerate;
        }
    }, {
        key: "setPrintParametersForGenerate",
        value: function setPrintParametersForGenerate(printParametersForSave) {
            this.printParametersForGenerate = printParametersForSave;
        }
    }]);

    return BaseReportStore;
}();

exports.default = BaseReportStore;

/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.FeatureDiffController = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _atUtils = __webpack_require__(5);

var _View2 = __webpack_require__(20);

var _View3 = _interopRequireDefault(_View2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FeatureDiffController = exports.FeatureDiffController = function (_View) {
    _inherits(FeatureDiffController, _View);

    function FeatureDiffController(_ref) {
        var _ref$handledFeatures = _ref.handledFeatures,
            handledFeatures = _ref$handledFeatures === undefined ? [] : _ref$handledFeatures,
            _ref$onFeaturesChange = _ref.onFeaturesChanged,
            onFeaturesChanged = _ref$onFeaturesChange === undefined ? function () {} : _ref$onFeaturesChange;

        _classCallCheck(this, FeatureDiffController);

        var _this = _possibleConstructorReturn(this, (FeatureDiffController.__proto__ || Object.getPrototypeOf(FeatureDiffController)).call(this));

        _this.params = {
            handledFeatures: (0, _atUtils.arrayToSet)(handledFeatures),
            onFeaturesChanged: onFeaturesChanged
        };

        _this.state = {
            features: null
        };

        _this.onStatePropertyDeeplyChanged('features', function (features, prevFeatures) {
            if (prevFeatures) {
                _this._handleFeatureChanges(prevFeatures, features);
            }
        });
        return _this;
    }

    _createClass(FeatureDiffController, [{
        key: '_handleFeatureChanges',
        value: function _handleFeatureChanges(prevFeatures, features) {
            var _this2 = this;

            var allFeatures = _extends({}, prevFeatures, features);

            var changedFeatures = {};

            Object.keys(allFeatures).filter(function (feature) {
                return _this2.params.handledFeatures[feature] && !!prevFeatures[feature] !== !!features[feature];
            }).forEach(function (feature) {
                return changedFeatures[feature] = !!features[feature];
            });

            if (Object.keys(changedFeatures).length > 0) {
                this.params.onFeaturesChanged(changedFeatures);
            }
        }
    }]);

    return FeatureDiffController;
}(_View3.default);

/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BalanceRulesEditorContent = function (_TemplateView) {
    _inherits(BalanceRulesEditorContent, _TemplateView);

    function BalanceRulesEditorContent(_ref) {
        var _ref$balanceRulesEdit = _ref.balanceRulesEditorComponent,
            balanceRulesEditorComponent = _ref$balanceRulesEdit === undefined ? null : _ref$balanceRulesEdit,
            _ref$leaveBalanceType = _ref.leaveBalanceTypePrefix,
            leaveBalanceTypePrefix = _ref$leaveBalanceType === undefined ? '' : _ref$leaveBalanceType;

        _classCallCheck(this, BalanceRulesEditorContent);

        var _this = _possibleConstructorReturn(this, (BalanceRulesEditorContent.__proto__ || Object.getPrototypeOf(BalanceRulesEditorContent)).call(this));

        _this.props = {
            balanceRulesEditorComponent: balanceRulesEditorComponent,
            leaveBalanceTypePrefix: leaveBalanceTypePrefix
        };
        return _this;
    }

    _createClass(BalanceRulesEditorContent, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return "<div id='<%=leaveBalanceTypePrefix%>_modifyBalanceAccrualRules' class='modifyBalanceAccrualRules'>" + "    <table cellspacing='0' cellpadding='0' id='<%=leaveBalanceTypePrefix%>_accruaRulesTable' class='accrualRulesTable'>" + "        <tr>" + "            <td class='ruleCheckbox'><input type='checkbox' class='resetRuleCheckbox' id='<%=leaveBalanceTypePrefix%>_resetRuleCheckbox'></td>" + "            <td>" + "                <table cellspacing='0' cellpadding='0' id='<%=leaveBalanceTypePrefix%>_resetRuleTable' class='resetRuleTable ruleTable'>" + "                    <tr>" + "                        <td><label for='<%=leaveBalanceTypePrefix%>_resetRuleCheckbox' id='<%=leaveBalanceTypePrefix%>_resetRuleLabel'><%=resetRule%></label></td>" + "                        <td><input type='text' class='days' id='<%=leaveBalanceTypePrefix%>_resetBalanceField' size='3'> </td>" + "                        <td><span class='days'><%=unitsDaysShort%></span><span class='hours'><%=unitsHoursShort%></span> </td>" + "                        <td>" + "                            <div id='<%=leaveBalanceTypePrefix%>_resetPeriodSelectPlaceholder'></div>" + "                        </td>" + "                        <td id='<%=leaveBalanceTypePrefix%>_resetOn' class='resetOn'><%=editorOn%></td>" + "                        <td></td>" + "                        <td>" + "                            <div id='<%=leaveBalanceTypePrefix%>_resetMonthSelectPlaceholder'></div>" + "                        </td>" + "                        <td>" + "                            <div id='<%=leaveBalanceTypePrefix%>_resetMonthDaySelectPlaceholder'></div>" + "                        </td>" + "                    </tr>" + "                </table>" + "                <span class='readOnly readOnlyResetRule' id='<%=leaveBalanceTypePrefix%>_readOnlyResetRule'></span>" + "            </td>" + "        </tr>" + "        <tr>" + "            <td class='ruleCheckbox'><input type='checkbox' class='accrueRuleCheckbox' id='<%=leaveBalanceTypePrefix%>_accrueRuleCheckbox'></td>" + "            <td>" + "                <table cellspacing='0' cellpadding='0' id='<%=leaveBalanceTypePrefix%>_accrueRuleTable' class='accrueRuleTable ruleTable '>" + "                    <tr>" + "                        <td><label for='<%=leaveBalanceTypePrefix%>_accrueRuleCheckbox' id='<%=leaveBalanceTypePrefix%>_accrualRuleLabel'><%=accrueRule%></label></td>" + "                        <td><input type='text' class='days' id='<%=leaveBalanceTypePrefix%>_accrueBalanceField'></td>" + "                        <td><span class='days'><%=unitsDaysShort%></span><span class='hours'><%=unitsHoursShort%></span></td>" + "                        <td>" + "                            <div id='<%=leaveBalanceTypePrefix%>_accruePeriodSelectPlaceholder'></div>" + "                        </td>" + "                        <td id='<%=leaveBalanceTypePrefix%>_accrueParamsPrefix' class='accrueParamsPrefix'></td>" + "                        <td>" + "                            <div id='<%=leaveBalanceTypePrefix%>_accrueWeekdaySelectPlaceholder'></div>" + "                        </td>" + "                        <td>" + "                            <div id='<%=leaveBalanceTypePrefix%>_accrueMonthSelectPlaceholder'></div>" + "                        </td>" + "                        <td>" + "                            <div id='<%=leaveBalanceTypePrefix%>_accrueMonthDaySelectPlaceholder'></div>" + "                        </td>" + "                        <td>" + "                            <div id='<%=leaveBalanceTypePrefix%>_accrueFromDateSelectorPlaceholder' class='atNextMount'></div>" + "                        </td>" + "                        </td>" + "                    </tr>" + "                </table>" + "                <span class='readOnly readOnlyAccrualRule' id='<%=leaveBalanceTypePrefix%>_readOnlyAccrueRule'></span>" + "            </td>" + "        </tr>" + "        <tr>" + "            <td class='ruleCheckbox'><input type='checkbox' class='capRuleCheckbox' id='<%=leaveBalanceTypePrefix%>_capRuleCheckbox'></td>" + "            <td>" + "                <table cellspacing='0' cellpadding='0' id='<%=leaveBalanceTypePrefix%>_capRuleTable' class='capRuleTable ruleTable'>" + "                    <tr>" + "                        <td><label for='<%=leaveBalanceTypePrefix%>_capRuleCheckbox' id='<%=leaveBalanceTypePrefix%>_capRuleLabel'><%=capRule%></label></td>" + "                        <td><input type='text' class='days' id='<%=leaveBalanceTypePrefix%>_capBalanceField' size='3'> " + "                            <span class='readOnly' id='readOnlyCapValueSelect' ></span>" + "                            <span class='days'><%=unitsDaysShort%></span>" + "                            <span class='hours'><%=unitsHoursShort%></span></td>" + "                    </tr>" + "                </table>" + "                <span class='readOnly readOnlyCapRule' id='<%=leaveBalanceTypePrefix%>_readOnlyCapRule'></span>" + "            </td>" + "        </tr>" + "    </table>" + "</div>";
        }
    }, {
        key: 'templateModel',
        value: function templateModel() {
            return {
                leaveBalanceTypePrefix: this.props.leaveBalanceTypePrefix
            };
        }
    }, {
        key: 'messageKeys',
        value: function messageKeys() {
            return {
                resetRule: 'balance_editor.balance_rules.reset_rule.label',
                accrueRule: 'balance_editor.balance_rules.accrual_rule.label',
                unitsDaysShort: 'common.balance_units.days.short',
                unitsHoursShort: 'common.balance_units.hours.short',
                editorOn: 'balance_editor.on',
                capRule: 'balance_editor.balance_rules.cap_rule.label'
            };
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            if (this.props.balanceRulesEditorComponent !== null) {
                this.props.balanceRulesEditorComponent.init();
            }
        }
    }]);

    return BalanceRulesEditorContent;
}(_TemplateView3.default);

exports.default = BalanceRulesEditorContent;

/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toast = toast;

var _store = __webpack_require__(222);

var _actions = __webpack_require__(56);

/**
 * Puts toast message into redux store.
 * @deprecated This function connects directly to redux, which is discouraged. Dispatch pure redux version from actions instead.
 */
function toast(text) {
  (0, _store.getStore)().dispatch((0, _actions.toast)(text));
}

/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Ext = __webpack_require__(12);

var _Ext2 = _interopRequireDefault(_Ext);

var _at_generic_selector_panel = __webpack_require__(736);

var _at_generic_selector_panel2 = _interopRequireDefault(_at_generic_selector_panel);

var _at_selection_helper = __webpack_require__(477);

var _at_selection_helper2 = _interopRequireDefault(_at_selection_helper);

var _GenericSelectorTreePropertiesController = __webpack_require__(532);

var _GenericSelectorTreePropertiesController2 = _interopRequireDefault(_GenericSelectorTreePropertiesController);

var _at_simple_list_selector_tree = __webpack_require__(533);

var _at_simple_list_selector_tree2 = _interopRequireDefault(_at_simple_list_selector_tree);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Selector panel for simple list.
 *
 * Depends on:
 * <code>/js/controls/selectorControls/at_generic_selection_panel.js</code>
 * <code>/js/controls/selectorControls/at_simple_list_selector_tree.js</code>
 * <code>/js/message_resources.js</code> with prefixes "common"
 *
 * @constructor
 */
var SimpleSelectorPanel = _Ext2.default.extend(_at_generic_selector_panel2.default, {
    allItemsOptionValue: true,
    customOptionValue: false,

    selectorTreeCtor: _at_simple_list_selector_tree2.default,
    isMarkAllSelectedIsEmpty: true,

    /**
     * @cfg {Function} propertiesControllerCtor constructor for a {@link AT.GenericSelectorTreePropertiesController} implementation
     */
    propertiesControllerCtor: _GenericSelectorTreePropertiesController2.default,
    propertiesController: null,

    initComponent: function initComponent() {
        this.propertiesController = new this.propertiesControllerCtor();
        SimpleSelectorPanel.superclass.initComponent.call(this);
    },

    createComponents: function createComponents() {
        SimpleSelectorPanel.superclass.createComponents.call(this);

        this.selectAllButton.on("click", this.selectorTree.selectAll, this.selectorTree);
        this.clearButton.on("click", this.selectorTree.selectNone, this.selectorTree);
    },

    createSelectionFilters: function createSelectionFilters() {
        SimpleSelectorPanel.superclass.createSelectionFilters.call(this);

        var self = this;
        this.showInactiveCheckbox.on("check", function (e, checked) {
            self.filterTreeNodes(checked);
        });
    },

    getSelection: function getSelection() {
        return this.selectorTree.getSelection();
    },

    isTooltipEnabled: function isTooltipEnabled() {
        return this.isCustomOptionSelected() && this.getSelection().length != 0;
    },

    getTooltipForCustomOption: function getTooltipForCustomOption() {
        var context = this;
        return this.selectionHelper.getListDescription(this.getSelection(), function (item) {
            return context.getSelectionHelper().getListDescriptionItem(item);
        });
    },

    getDescription: function getDescription(selectionHelper) {
        this.selectionHelper.itemNounSingularKey = this.labelItemNounSingularKey;
        this.selectionHelper.itemNounPluralKey = this.labelItemNounPluralKey;
        return selectionHelper.getDescription(this.getSelection());
    },

    makeSelectionHelper: function makeSelectionHelper() {
        this.selectionHelper = new _at_selection_helper2.default({
            propertiesController: this.selectorTree.nodeHelper.propertiesController,
            itemNounSingularKey: this.labelItemNounSingularKey,
            itemNounPluralKey: this.labelItemNounPluralKey,
            showInactiveCount: true,
            showSingleItemInactiveText: false,
            noItemsSelectedKey: this.labelNoItemsSelectedKey,
            maxCharacters: this.labelMaxChars,
            useNameForSingleItem: this.labelUseNameForSingleItem
        });
    },

    isEmptySelection: function isEmptySelection() {
        return this.getSelection().length == 0;
    }
});

_Ext2.default.reg("at_simple_selector_panel", SimpleSelectorPanel);

exports.default = SimpleSelectorPanel;

/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Ext = __webpack_require__(12);

var _Ext2 = _interopRequireDefault(_Ext);

var _ScrollUtils = __webpack_require__(39);

var _ScrollUtils2 = _interopRequireDefault(_ScrollUtils);

var _at_tree_node_helper = __webpack_require__(836);

var _at_tree_node_helper2 = _interopRequireDefault(_at_tree_node_helper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Abstract selector tree.
 */
var SelectorTree = _Ext2.default.extend(_Ext2.default.Container, {
    data: [],
    autoEl: "div",
    layout: "table",
    layoutConfig: {
        columns: 1
    },
    cls: "at-selector-tree",
    inactiveCls: "at-selector-tree-inactive",

    /**
     * @cfg {AT.GenericSelectorTreePropertiesController} propertiesController controller used
     * to extract tree item properties
     */
    propertiesController: null,

    /**
     * @cfg {Function} nodeHelperCtor constructor for a {@link AT.TreeNodeHelper} implementation (required).
     */
    nodeHelperCtor: _at_tree_node_helper2.default,

    /**
     * {AT.TreeNodeHelper} nodeHelper {@link AT.TreeNodeHelper} implementation.
     */
    nodeHelper: null,

    /**
     * @cfg {Array} itemTooltipMessageParams specifies message to be show for selectorTree item's tooltips on some
     *              specific conditions.
     */
    itemTooltipMessageParams: null,

    initComponent: function initComponent() {
        SelectorTree.superclass.initComponent.call(this);

        if (!this.nodeHelper) this.nodeHelper = new this.nodeHelperCtor({
            propertiesController: this.propertiesController,
            tooltipMessageParams: this.itemTooltipMessageParams
        });else this.nodeHelper.setPropertiesController(this.propertiesController);

        _Ext2.default.each(this.createNodes(), function (node) {
            this.add(node);
        }, this);
        this.addEvents("change");
    },

    /**
     * Creates the tree nodes based on <code>data</code> property.
     * @type {Array} array of {@link AT.SelectorTreeNode} objects.
     * @private
     */
    createNodes: _Ext2.default.emptyFn,

    /**
     * Resets the nodes' states.
     */
    resetNodes: _Ext2.default.emptyFn,

    /**
     * @param {Boolean} selectHidden determines if the selection should include hidden items.
     * @returns Selected data items.
     */
    getSelection: _Ext2.default.emptyFn,

    /**
     * Set the tree inactive state.
     * @param value true to set inactive, false to set active.
     */
    setInactive: function setInactive(value) {
        value = value !== false;
        if (value) {
            this.addClass(this.inactiveCls);
        } else {
            this.removeClass(this.inactiveCls);
        }
    },

    /**
     * Selects all nodes in the tree.
     */
    selectAll: function selectAll() {
        this.items.each(function (item) {
            item.select();
        });
        this.onChange();
    },

    /**
     * Deselects all nodes in the tree.
     */
    selectNone: function selectNone() {
        this.items.each(function (item) {
            item.select(false);
        });
        this.onChange();
    },

    /**
     * Filters all nodes in the tree.
     * @param {Function} condition condition function.
     * @param {Object} scope condition function scope.
     */
    filter: function filter(condition, scope) {
        if (typeof this.items != 'undefined') this.items.each(function (item) {
            item.filter(condition, scope);
        });
        this.onChange();
    },

    onChange: function onChange() {
        this.fireEvent("change", this);
        _ScrollUtils2.default.refreshCustomScroll(this.customScroller);
    }
});

exports.default = SelectorTree;

/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Ext = __webpack_require__(12);

var _Ext2 = _interopRequireDefault(_Ext);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _atUtils = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//TODO kamenev: TreeNodeHelper and SelectionHelper has similar functionality and cause partial code duplication
var TreeNodeHelper = function TreeNodeHelper(config) {
    _Ext2.default.apply(this, config);
};

TreeNodeHelper.prototype = {
    /**
     * @cfg {String} itemClass specifies item node class.
     */
    itemClass: null,

    /**
     * @cfg {AT.GenericSelectorTreePropertiesController} propertiesController controller used
     * to extract tree item properties
     */
    propertiesController: null,

    /**
     * @cfg {Array} tooltipMessageParams specifies message to be show for selectorTree item's tooltips on some
     *              specific conditions.
     */
    tooltipMessageParams: null,

    /**
     * @see AT.UsersSelectorPanel.checkEmail
     */
    checkEmail: false,

    nameMaxLength: null,

    fullNameMaxLength: null,

    /**
     * Returns item's string representation based on name and status properties values
     * @param item item to get name with the status for
     * @return string item's name with the status
     */
    getNameWithStatus: function getNameWithStatus(item) {
        return this.truncateIfRequired(this.appendStatus(item, this.propertiesController.getName(item)), this.nameMaxLength);
    },

    /**
     * Returns item's string representation based on fullName and status properties values
     * @param item item to get full name with the status for
     * @return string item's full name with the status
     */
    getFullNameWithStatus: function getFullNameWithStatus(item) {
        var name = this.propertiesController.getFullName(item);
        name = this.truncateIfRequired(this.checkEmail ? name : this.appendStatus(item, name), this.fullNameMaxLength);
        var tooltipMessage = this.getTooltipMessage(item);
        return (0, _atUtils.concatStr)(name, tooltipMessage, " ");
    },

    /**
     * Truncates given string to the <code>maxLength</code>. If <code>maxLength</code> is <code>NULL</code> or not
     * specified returns given string as is
     * @param string
     * @param maxLength
     */
    truncateIfRequired: function truncateIfRequired(string, maxLength) {
        return maxLength ? (0, _atUtils.truncateStringByLength)(string, maxLength) : string;
    },

    /**
     * Appends item's status to the given string
     * private
     */
    appendStatus: function appendStatus(item, string) {
        var status = this.getStatusSuffix(item);
        return (0, _atUtils.concatStr)(string, status, " ");
    },

    /**
     * Determines whether node is going to be active or not based on given item
     * @param item
     */
    isActive: function isActive(item) {
        return this.propertiesController.isActive(item);
    },

    /**
     * Returns item's CSS style class name
     * @param item item to get CSS style class for
     * @return string item's CSS style class
     */
    getStyleClass: function getStyleClass(item) {
        if (this.checkEmail && (!this.propertiesController.getEmail(item) || !this.isActive(item))) return " without-email ";
        return "";
    },

    /**
     * protected.
     * Returns value of item's property <code>propertyName</code>
     * @param item
     * @param propertyName
     *
     */
    getPropertyValue: function getPropertyValue(item, propertyName) {
        return item[propertyName];
    },

    /**
     * protected. Should be overwritten by inheritor.
     *
     * Returns null if here is no suffix for the item
     * @param item to get status suffix for
     */
    getStatusSuffix: function getStatusSuffix(item) {
        //Do nothing by default
        return null;
    },

    /**
     * protected. Should be overwritten by inheritor.
     *
     * Returns null if here is no tooltip message for the item
     * @param item to get tooltip message for
     */
    getTooltipMessage: function getTooltipMessage(item) {
        var message = null;
        if (!this.isActive(item) && this.tooltipMessageParams) message = this.getSingleTooltipMessage(item, "disabled");else if (!this.hasEmail(item)) message = this.getEmailTooltipMessage(item);
        return message;
    },

    setPropertiesController: function setPropertiesController(provider) {
        this.propertiesController = provider;
    },

    /**
     * Returns corresponding suffix if item is disabled, null if not.
     * @param item
     */
    getDisabledSuffix: function getDisabledSuffix(item) {
        return this.propertiesController.isActive(item) ? null : " " + this.propertiesController.getInactiveSuffixMessage();
    },

    getSingleTooltipMessage: function getSingleTooltipMessage(item, messageId) {
        return this.tooltipMessageParams[messageId] ? _messageResource2.default.getMessage(this.tooltipMessageParams[messageId].messageKey, this.tooltipMessageParams[messageId].params) : null;
    },

    getEmailTooltipMessage: function getEmailTooltipMessage(item) {
        if (this.tooltipMessageParams && !this.hasEmail(item)) return this.getSingleTooltipMessage(item, "noEmail") + "\n";
        return "";
    },

    hasEmail: function hasEmail(item) {
        return !this.checkEmail || this.propertiesController.getEmail(item);
    }

};

exports.default = TreeNodeHelper;

/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Ext = __webpack_require__(12);

var _Ext2 = _interopRequireDefault(_Ext);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Abstract selector tree node.
 */
var SelectorTreeNode = _Ext2.default.extend(_Ext2.default.Container, {
    /**
     * @cfg {String} selectedCls style class for the "selected" state.
     */
    cls: "at-selector-tree-node",
    selectedCls: "at-selected-item",
    layout: "table",
    autoEl: "div",
    layoutConfig: {
        columns: 1
    },

    selected: false,
    children: [],

    /**
     * @cfg {String} selectedProperty enclosed item's "selected" property name.
     */
    selectedProperty: "selected",

    /**
     * @cfg {String} activeProperty enclosed item's "active" property name.
     */
    activeProperty: "active",

    /**
     * @cfg {String} hiddenProperty enclosed item's "hidden" property name.
     */
    hiddenProperty: "hidden",

    initComponent: function initComponent() {
        SelectorTreeNode.superclass.initComponent.call(this);

        this.nodeBody = this.getNodeBody();
        this.add(this.nodeBody);

        _Ext2.default.each(this.children, function (child) {
            this.add(child);
            child.parent = this;
        }, this);
    },

    /**
     * (De)selects current node.
     * @param {Boolean} value true to select, false to deselect.
     */
    doSelect: function doSelect(value) {
        if (value) {
            this.nodeBody.addClass(this.selectedCls);
        } else {
            this.nodeBody.removeClass(this.selectedCls);
        }
    },

    /**
     * (De)selects current node and propagates the action up (only deselection) and/or down the tree.
     * @param {Boolean} value true to select, false to deselect, defaults to true.
     * @param {Boolean} propagateUp false to not propagate deselection up, defaults to true.
     * @param {Boolean} propagateDown false to not propagate down, defaults to true.
     */
    select: function select(value, propagateUp, propagateDown) {
        value = value !== false;
        propagateUp = propagateUp !== false;
        propagateDown = propagateDown !== false;

        this.doSelect(value);

        if (propagateDown && this.children) {
            _Ext2.default.each(this.children, function (child) {
                child.select(value, false, true);
            }, this);
        }

        if (propagateUp && !value && this.parent) {
            this.parent.select(false, true, false);
        }
    },

    /**
     * Propagates filtering action to the node's children.
     * @param condition filter condition, should return true to keep, false to filter out.
     * @param scope scope to run the filter function in.
     */
    filter: function filter(condition, scope) {
        if (this.children) {
            _Ext2.default.each(this.children, function (child) {
                child.filter(condition, scope);
            });
        }
    },

    /**
     * @returns {Ext.Component} component to render at the node's position in the tree.
     * @private
     */
    getNodeBody: _Ext2.default.emptyFn
});

exports.default = SelectorTreeNode;

/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Ext = __webpack_require__(12);

var _Ext2 = _interopRequireDefault(_Ext);

var _at_base_date_picker = __webpack_require__(536);

var _at_base_date_picker2 = _interopRequireDefault(_at_base_date_picker);

var _at_date_picker = __webpack_require__(389);

var _at_date_picker2 = _interopRequireDefault(_at_date_picker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_Ext2.default.namespace('AT');

var WeekPicker = _Ext2.default.extend(_at_base_date_picker2.default, {
    invertedDaysMap: undefined,

    showToday: false,

    initComponent: function initComponent() {
        WeekPicker.superclass.initComponent.call(this);
        this.selectedWeekTr = null;
        if (Number.NEGATIVE_INFINITY < this.actualMin) {
            var date = this.actualMin.getWeekStartDate(this.startDay);
            if (!date.isSameDate(this.actualMin)) {
                date = date.getNDaysAfter(6);
            }
            this.actualMin = date;
        }
        if (this.actualMax < Number.POSITIVE_INFINITY) {
            this.actualMax = this.actualMax.getWeekStartDate(this.startDay).getNDaysAfter(6);
        }
    },

    setValue: function setValue(value) {
        this.removeSelectedWeekClass();
        value = value.getWeekStartDate(this.startDay);
        WeekPicker.superclass.setValue.call(this, value);
    },

    // override
    update: function update(date) {
        if (date >= this.actualMin && date <= this.actualMax) {
            this.activeDate = date;
        }

        if (this.currentWeerRow) {
            this.currentWeerRow.style.display = this.todayIsDisabled ? "none" : "table-row";
        }
        this.updateCells(date);
    },

    setCellClasses: function setCellClasses(cell, isWeekend, date, today) {
        _at_date_picker2.default.superclass.setCellClasses.call(this, cell, isWeekend, date, today);

        if (date.clearTime(true).getTime() == this.value.clearTime(true).getTime() && !this.selectedWeekTr) {
            this.selectedWeekTr = cell.parentNode;
            _Ext2.default.fly(this.selectedWeekTr).addClass("at-selected-week");
        }

        if (!cell.previousSibling) {
            cell.className += " at-first-day ";
        } else if (!cell.nextSibling) {
            cell.className += " at-last-day ";
        }
    },

    // override
    onRender: function onRender(container, position) {
        WeekPicker.superclass.onRender.call(this, container, position);
        this.currentWeerRow = this.addCurrentWeekButton();
        _Ext2.default.get(this.el).addClass("atap-week-picker");
    },

    addCurrentWeekButton: function addCurrentWeekButton() {
        var tr = document.createElement("tr");
        var td = document.createElement("td");
        td.colSpan = 3;
        td.className = "x-date-bottom";
        td.align = "center";
        tr.appendChild(td);
        var a = document.createElement("a");
        a.innerHTML = "current week";
        td.appendChild(a);
        this.el.dom.firstChild.firstChild.appendChild(tr);

        var self = this;
        a.onclick = function () {
            self.selectToday();
        };

        return tr;
    },

    // override
    showPrevYear: function showPrevYear() {
        var newDate = this.activeDate.add("y", -1);
        this.update(this.fix29februaryIssue(newDate));
    },

    // override
    showNextYear: function showNextYear() {
        var newDate = this.activeDate.add("y", 1);
        this.update(this.fix29februaryIssue(newDate));
    },

    removeSelectedWeekClass: function removeSelectedWeekClass() {
        if (this.selectedWeekTr) {
            _Ext2.default.get(this.selectedWeekTr).removeClass("at-selected-week");
            this.selectedWeekTr = null;
        }
    },

    showPrevMonth: function showPrevMonth() {
        this.removeSelectedWeekClass();
        this.update(this.activeDate.add("mo", -1));
    },

    showNextMonth: function showNextMonth() {
        this.removeSelectedWeekClass();
        this.update(this.activeDate.add("mo", 1));
    },

    monthPickerApply: function monthPickerApply(year, month) {
        var d = new Date(year, month, (this.activeDate || this.value).getDate());
        if (d.getMonth() != month) {
            // "fix" the JS rolling date conversion if needed
            d = new Date(year, month, 1).getLastDateOfMonth();
        }
        this.update(d);
        this.hideMonthPicker();
        this.removeSelectedWeekClass();
    }

});

_Ext2.default.reg('atweekpicker', WeekPicker);

exports.default = WeekPicker;

/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Ext = __webpack_require__(12);

var _Ext2 = _interopRequireDefault(_Ext);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_Ext2.default.namespace("AT");

/**
 * Elastic text area
 *
 * Example of using:
 * <code>
 *  <textarea id="textareaId"></textarea>
 *  <script type="text/javascript">
 *      Ext.onReady(function(){
 *          new AT.ElasticTextArea({textarea: 'textareaId'});
 *      });
 *  </script>
 * </code>
 *
 * Note: if you set textarea text dynamically, you should call fitToHeight() after that.
 * For convenience, a reference to this object is added to the textarea dom node under the name 'elastic',
 * so you may do like this:
 *
 * <code>
 *  elem.value = value;
 *  if (elem.elastic)
 *    elem.elastic.fitToHeight();
 * </code>
 *
 * @constructor
 * @cfg {Element/String} textarea id or dom element of textarea (required).
 * @cfg {int} growBy additional empty space after text in textarea
 * @cfg {int} expandMax max size of textarea
 * @cfg {int} expandMin min size of textarea
 * @cfg {int} heightOfLine height of one line in text area. Applicable only for Chrome or Safari.
 *            Needs for reduce text jumping when press 'Enter' (default value is 16).
 */
var ElasticTextArea = _Ext2.default.extend(Object, {
    textarea: null,

    div: null,

    growBy: 5,

    heightOfLine: 16,

    expandMax: -1,

    expandMin: -1,

    constructor: function constructor(config) {
        _Ext2.default.apply(this, config);
        this.textarea = _Ext2.default.get(this.textarea);
        this.hCheck = !_Ext2.default.isOpera;
        // place textarea to div
        this.div = document.createElement("div");
        this.textarea.dom.parentNode.replaceChild(this.div, this.textarea.dom);
        this.div.appendChild(this.textarea.dom);
        this.div = _Ext2.default.get(this.div);
        // listen all needed events
        this.textarea.on("keyup", this.fitToHeight, this);
        this.textarea.on("focus", this.fitToHeight, this);
        this.textarea.on("paste", this.fitToHeight, this, { delay: 40 });
        this.textarea.on("blur", this.fitToHeight, this);
        this.textarea.on("cut", this.fitToHeight, this, { delay: 40 });
        if (_Ext2.default.isChrome || _Ext2.default.isSafari || _Ext2.default.isOpera || _Ext2.default.isIE) this.textarea.on("keydown", this.fixForChrome, this);
        this.textarea.setStyle('overflow', 'hidden');
        this.div.setStyle('display', 'inline-block');
        this.growBy += this.textarea.getPadding("tb"); // consider paddings when calculate textarea height
        this.fitToHeight();
        this.textarea.dom.elastic = this;
    },

    fixForChrome: function fixForChrome(e) {
        if (e.keyCode == 13 && (this.expandMax < 0 || this.textarea.getHeight() < this.expandMax) && this.textarea.getHeight() > this.expandMin) {
            this.prevHChrome = this.textarea.getHeight();
            this.textarea.dom.style.height = this.textarea.getHeight() + this.heightOfLine + 'px';
            this.div.dom.style.height = this.textarea.dom.style.height;
        }
    },

    fitToHeight: function fitToHeight() {
        // find content length and box width
        var vlen = this.textarea.dom.value.length,
            ewidth = this.textarea.dom.offsetWidth;
        if (vlen != this.valLength || ewidth != this.boxWidth) {
            var prevH = this.prevHChrome ? this.prevHChrome : $(this.textarea.dom).height();
            if (this.hCheck && (vlen < this.valLength || ewidth != this.boxWidth)) this.textarea.dom.style.height = "0px";else this.textarea.dom.style.height = Math.max(0, prevH - this.growBy) + "px"; // for proper calculations with growBy greater than 0
            var h = Math.max(this.expandMin - this.growBy, Math.min(this.textarea.dom.scrollHeight, this.expandMax > 0 ? this.expandMax - this.growBy : this.textarea.dom.scrollHeight));
            this.textarea.dom.style.overflow = this.textarea.dom.scrollHeight > h ? "auto" : "hidden";

            this.div.setHeight(h + this.growBy, false);
            this.textarea.setHeight(h + this.growBy, false);

            this.valLength = vlen;
            this.boxWidth = ewidth;
            this.prevHChrome = false;
        }
    }
});

_Ext2.default.reg("at_elastic_textarea", ElasticTextArea);

exports.default = ElasticTextArea;

/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Ext = __webpack_require__(12);

var _Ext2 = _interopRequireDefault(_Ext);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_Ext2.default.namespace('AT.menu');

var PickerItem = _Ext2.default.extend(_Ext2.default.menu.DateItem, {

    constructor: function constructor(config, picker) {
        this.picker = picker;

        _Ext2.default.menu.DateItem.superclass.constructor.call(this, this.picker, config);

        this.addEvents('select');

        this.picker.on("render", function (picker) {
            picker.getEl().swallowEvent("click");
            picker.container.addClass("x-menu-date-item");
        });

        this.picker.on("select", this.onSelect, this);
    }
});

_Ext2.default.extend(PickerItem, _Ext2.default.menu.Adapter, {
    // private
    onSelect: function onSelect(picker, date) {
        this.fireEvent("select", this, date, picker);
        PickerItem.superclass.handleClick.call(this);
    }
});

exports.default = PickerItem;

/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Ext = __webpack_require__(12);

var _Ext2 = _interopRequireDefault(_Ext);

var _at_picker_menu = __webpack_require__(540);

var _at_picker_menu2 = _interopRequireDefault(_at_picker_menu);

var _at_week_picker = __webpack_require__(838);

var _at_week_picker2 = _interopRequireDefault(_at_week_picker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_Ext2.default.namespace('AT.menu');

var WeekPickerMenu = _Ext2.default.extend(_at_picker_menu2.default, {

    constructor: function constructor(config) {
        var picker = new _at_week_picker2.default(config);
        WeekPickerMenu.superclass.constructor.call(this, config, picker);
    } });

_Ext2.default.extend(WeekPickerMenu, _at_picker_menu2.default);

exports.default = WeekPickerMenu;

/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.PDF_ICON_MAP_BY_TYPE = exports.PDF_COMPLETED_TYPE_COLOR_MAP_BY_COLOR_NAME = exports.PDF_OPEN_TYPE_COLOR_MAP_BY_COLOR_NAME = undefined;

var _PDF_OPEN_TYPE_COLOR_, _PDF_COMPLETED_TYPE_C, _PDF_ICON_MAP_BY_TYPE;

var _constants = __webpack_require__(23);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var PDF_OPEN_TYPE_COLOR_MAP_BY_COLOR_NAME = exports.PDF_OPEN_TYPE_COLOR_MAP_BY_COLOR_NAME = (_PDF_OPEN_TYPE_COLOR_ = {}, _defineProperty(_PDF_OPEN_TYPE_COLOR_, _constants.COLORS.PINK, '#dd326e'), _defineProperty(_PDF_OPEN_TYPE_COLOR_, _constants.COLORS.ORANGE, '#d77606'), _defineProperty(_PDF_OPEN_TYPE_COLOR_, _constants.COLORS.YELLOW, '#d99400'), _defineProperty(_PDF_OPEN_TYPE_COLOR_, _constants.COLORS.LIGHT_GREEN, '#6fb100'), _defineProperty(_PDF_OPEN_TYPE_COLOR_, _constants.COLORS.DARK_GREEN, '#0ea95e'), _defineProperty(_PDF_OPEN_TYPE_COLOR_, _constants.COLORS.AQUAMARINE, '#00b2c1'), _defineProperty(_PDF_OPEN_TYPE_COLOR_, _constants.COLORS.BLUE, '#0066de'), _defineProperty(_PDF_OPEN_TYPE_COLOR_, _constants.COLORS.VIOLET, '#4f3bc5'), _defineProperty(_PDF_OPEN_TYPE_COLOR_, _constants.COLORS.LIGHT_GRAY, '#8585ab'), _defineProperty(_PDF_OPEN_TYPE_COLOR_, _constants.COLORS.DARK_GRAY, '#2c5d86'), _PDF_OPEN_TYPE_COLOR_);

var PDF_COMPLETED_TYPE_COLOR_MAP_BY_COLOR_NAME = exports.PDF_COMPLETED_TYPE_COLOR_MAP_BY_COLOR_NAME = (_PDF_COMPLETED_TYPE_C = {}, _defineProperty(_PDF_COMPLETED_TYPE_C, _constants.COLORS.PINK, '#cb4e7a'), _defineProperty(_PDF_COMPLETED_TYPE_C, _constants.COLORS.ORANGE, '#ed8710'), _defineProperty(_PDF_COMPLETED_TYPE_C, _constants.COLORS.YELLOW, '#e8a70d'), _defineProperty(_PDF_COMPLETED_TYPE_C, _constants.COLORS.LIGHT_GREEN, '#79c428'), _defineProperty(_PDF_COMPLETED_TYPE_C, _constants.COLORS.DARK_GREEN, '#2eb473'), _defineProperty(_PDF_COMPLETED_TYPE_C, _constants.COLORS.AQUAMARINE, '#1bbabf'), _defineProperty(_PDF_COMPLETED_TYPE_C, _constants.COLORS.BLUE, '#4d95ee'), _defineProperty(_PDF_COMPLETED_TYPE_C, _constants.COLORS.VIOLET, '#8465d7'), _defineProperty(_PDF_COMPLETED_TYPE_C, _constants.COLORS.LIGHT_GRAY, '#9f9fbd'), _defineProperty(_PDF_COMPLETED_TYPE_C, _constants.COLORS.DARK_GRAY, '#778b9c'), _PDF_COMPLETED_TYPE_C);

var PDF_ICON_MAP_BY_TYPE = exports.PDF_ICON_MAP_BY_TYPE = (_PDF_ICON_MAP_BY_TYPE = {}, _defineProperty(_PDF_ICON_MAP_BY_TYPE, _constants.WorkflowStatusType.COMPLETED, "completedTask"), _defineProperty(_PDF_ICON_MAP_BY_TYPE, _constants.WorkflowStatusType.OPEN, "openTask"), _PDF_ICON_MAP_BY_TYPE);

/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _ViewTTStore = __webpack_require__(73);

var _ViewTTStore2 = _interopRequireDefault(_ViewTTStore);

var _TaskTooltip = __webpack_require__(1574);

var _TaskTooltip2 = _interopRequireDefault(_TaskTooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TaskRow = function (_TemplateView) {
    _inherits(TaskRow, _TemplateView);

    function TaskRow(_ref) {
        var _ref$taskModel = _ref.taskModel,
            taskModel = _ref$taskModel === undefined ? null : _ref$taskModel,
            _ref$last = _ref.last,
            last = _ref$last === undefined ? false : _ref$last;

        _classCallCheck(this, TaskRow);

        var _this = _possibleConstructorReturn(this, (TaskRow.__proto__ || Object.getPrototypeOf(TaskRow)).call(this));

        _this.params = {
            taskModel: taskModel,
            last: last
        };
        return _this;
    }

    _createClass(TaskRow, [{
        key: "afterRender",
        value: function afterRender() {
            var _this2 = this;

            var task = _ViewTTStore2.default.getTask(this.params.taskModel.taskId);
            this.$el.toggleClass("nonLast", !this.params.last);
            this.$el.addClass("task" + this.params.taskModel.taskId);

            if (task.canViewDetails) {
                this.$el.addClass("available");
                this.$el.click(function (e) {
                    _this2._onClick(e);
                });
            } else {
                this.tooltip = _TaskTooltip2.default.getInstance();
                this.tooltip.subscribeToMouseEvents(this.$el);
            }
        }
    }, {
        key: "_onClick",
        value: function _onClick(e) {
            (0, _jquery2.default)(document).trigger("viewTT.detailsTable.taskClick", [e, this.params.taskModel.taskId]);
        }
    }]);

    return TaskRow;
}(_TemplateView3.default);

exports.default = TaskRow;

/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var OtherSpentRow = function OtherSpentRow($containerEl, otherTTInfo) {
    TemplateView.call(this, $containerEl);
    this.otherTTInfo = otherTTInfo;
};

OtherSpentRow.prototype = _.create(TemplateView.prototype, {
    baseTemplateModel: function baseTemplateModel() {
        return {
            otherLabel: messageResource.getMessage("view_tt.details_table.other_tt"),
            total: UserTime.formatTimeWithDigitSeparator(this.otherTTInfo["spent"])
        };
    }
});

exports.default = OtherSpentRow;

/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TableCell2 = __webpack_require__(166);

var _TableCell3 = _interopRequireDefault(_TableCell2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EditableCell = function (_TableCell) {
    _inherits(EditableCell, _TableCell);

    function EditableCell() {
        _classCallCheck(this, EditableCell);

        return _possibleConstructorReturn(this, (EditableCell.__proto__ || Object.getPrototypeOf(EditableCell)).apply(this, arguments));
    }

    _createClass(EditableCell, [{
        key: "init",
        value: function init(value, rowObj) {
            _TableCell3.default.call(this, value, rowObj);
            return this;
        }
    }, {
        key: "setEditorSelected",
        value: function setEditorSelected() {
            this.renderer.setEditorSelected();
            this.renderer.updateUI(this);
        }
    }, {
        key: "unsetEditorSelected",
        value: function unsetEditorSelected() {
            this.renderer.unsetEditorSelected();
            this.renderer.updateUI(this);
        }
    }]);

    return EditableCell;
}(_TableCell3.default);

exports.default = EditableCell;

/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TypeOfWorkMenu = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _DropdownTemplateView2 = __webpack_require__(42);

var _DropdownTemplateView3 = _interopRequireDefault(_DropdownTemplateView2);

var _TypeOfWorkSelector = __webpack_require__(1590);

var _TypeOfWorkSelector2 = _interopRequireDefault(_TypeOfWorkSelector);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TypeOfWorkMenu = exports.TypeOfWorkMenu = function (_DropdownTemplateView) {
    _inherits(TypeOfWorkMenu, _DropdownTemplateView);

    function TypeOfWorkMenu(_ref) {
        var _ref$additionalClass = _ref.additionalClass,
            additionalClass = _ref$additionalClass === undefined ? '' : _ref$additionalClass,
            _ref$showMenuCb = _ref.showMenuCb,
            showMenuCb = _ref$showMenuCb === undefined ? function () {} : _ref$showMenuCb,
            _ref$hideMenuCb = _ref.hideMenuCb,
            hideMenuCb = _ref$hideMenuCb === undefined ? function () {} : _ref$hideMenuCb;

        _classCallCheck(this, TypeOfWorkMenu);

        var _this = _possibleConstructorReturn(this, (TypeOfWorkMenu.__proto__ || Object.getPrototypeOf(TypeOfWorkMenu)).call(this));

        _this.params = {
            additionalClass: additionalClass,
            showMenuCb: showMenuCb,
            hideMenuCb: hideMenuCb
        };
        return _this;
    }

    _createClass(TypeOfWorkMenu, [{
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='dropdownContainer components_typeOfWorkMenu <%=additionalClass%>'></div>";
        }
    }, {
        key: "templateModel",
        value: function templateModel() {
            return {
                additionalClass: this.params.additionalClass
            };
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            var _this2 = this;

            this.typeOfWorkSelector = new _TypeOfWorkSelector2.default({
                onTypeSelected: function onTypeSelected(id) {
                    _this2._selectTypeOfWork(id);
                },
                onlyActive: true
            }).init(this.$el);

            this.getEl().on('click', function (e) {
                return e.stopPropagation();
            });
        }
    }, {
        key: "update",
        value: function update() {
            this.typeOfWorkSelector.update();
        }
    }, {
        key: "showAt",
        value: function showAt($element, positionParams, callback) {
            _get(TypeOfWorkMenu.prototype.__proto__ || Object.getPrototypeOf(TypeOfWorkMenu.prototype), "showAt", this).call(this, $element, positionParams);
            this.update();
            this.callback = callback;
        }
    }, {
        key: "onHide",
        value: function onHide() {
            _get(TypeOfWorkMenu.prototype.__proto__ || Object.getPrototypeOf(TypeOfWorkMenu.prototype), "onHide", this).call(this);
            this.callback(this.selectedTypeId);
            this.params.hideMenuCb();
        }
    }, {
        key: "onShow",
        value: function onShow() {
            _get(TypeOfWorkMenu.prototype.__proto__ || Object.getPrototypeOf(TypeOfWorkMenu.prototype), "onShow", this).call(this);
            this.params.showMenuCb();
        }
    }, {
        key: "setTypeOfWorkId",
        value: function setTypeOfWorkId(id) {
            this.selectedTypeId = id;
            this.typeOfWorkSelector.setState({
                selectedTypeId: id
            });
        }
    }, {
        key: "_selectTypeOfWork",
        value: function _selectTypeOfWork(id) {
            this.setTypeOfWorkId(id);
            this.hide();
        }
    }, {
        key: "mouseDownTargetElement",
        value: function mouseDownTargetElement() {
            return (0, _jquery2.default)('body');
        }
    }]);

    return TypeOfWorkMenu;
}(_DropdownTemplateView3.default);

/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _atBrowserUtils = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SearchField = function (_TemplateView) {
    _inherits(SearchField, _TemplateView);

    function SearchField(_ref) {
        var _ref$onFieldChange = _ref.onFieldChange,
            onFieldChange = _ref$onFieldChange === undefined ? function (text) {} : _ref$onFieldChange;

        _classCallCheck(this, SearchField);

        var _this = _possibleConstructorReturn(this, (SearchField.__proto__ || Object.getPrototypeOf(SearchField)).call(this));

        _this.params = {
            onFieldChange: onFieldChange
        };
        return _this;
    }

    _createClass(SearchField, [{
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='searchField'>" + "  <table class='containerTable' cellspacing='0' cellpadding='0'>" + "    <tr>" + "      <td class='inputColumn'>" + "        <div class='cellWrapper'><input type='text' placeholder='<%=placeholder%>' maxlength='255'/></div>" + "      </td>" + "      <td class='iconColumn'><div class='icon'>&nbsp;</div></td>" + "    </tr>" + "  </table>" + "</div>";
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            var self = this;
            this.$input = this.find("input");
            this.$icon = this.find(".icon");
            this.$input.placeholder();
            this.$input.valueChanged(function () {
                var text = self.$input.pVal();
                self.$el.toggleClass("hasText", !!text);

                clearTimeout(self.timer);
                self.timer = setTimeout(function () {
                    self.params.onFieldChange(text);
                }, 500);
            });
            this.$input.keyup(function (e) {
                if ((0, _atBrowserUtils.isEscapePressed)(e)) self.clear();
            });
            this.$input.focus(function (e) {
                self.$el.addClass('focusing');
            });

            this.$input.blur(function (e) {
                self.$el.removeClass('focusing');
            });
            this.$icon.click(function () {
                self.clear();
            });
        }
    }, {
        key: "messageKeys",
        value: function messageKeys() {
            return {
                placeholder: "task.list.search_placeholder"
            };
        }
    }, {
        key: "clear",
        value: function clear() {
            var text = this.$input.pVal();
            if (text) {
                this.$input.pVal("");
                this.$input[0].prevValue = "";
                this.$el.removeClass("hasText");
                clearTimeout(this.timer);
                this.params.onFieldChange("");
            }
        }
    }]);

    return SearchField;
}(_TemplateView3.default);

exports.default = SearchField;

/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _MenuButton2 = __webpack_require__(484);

var _MenuButton3 = _interopRequireDefault(_MenuButton2);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _constants = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BILLING_TYPE_NOT_SELECTED_VALUE = -1;

var TypeOfWorkButton = function (_MenuButton) {
    _inherits(TypeOfWorkButton, _MenuButton);

    function TypeOfWorkButton(_ref) {
        var _ref$editable = _ref.editable,
            editable = _ref$editable === undefined ? false : _ref$editable,
            _ref$showCategory = _ref.showCategory,
            showCategory = _ref$showCategory === undefined ? false : _ref$showCategory,
            _ref$onTypeOfWorkChan = _ref.onTypeOfWorkChangedCb,
            onTypeOfWorkChangedCb = _ref$onTypeOfWorkChan === undefined ? function () {} : _ref$onTypeOfWorkChan,
            _ref$typeOfWorkMenu = _ref.typeOfWorkMenu,
            typeOfWorkMenu = _ref$typeOfWorkMenu === undefined ? null : _ref$typeOfWorkMenu,
            _ref$positionParams = _ref.positionParams,
            positionParams = _ref$positionParams === undefined ? { offset: "0px 1px" } : _ref$positionParams,
            _ref$onShowMenu = _ref.onShowMenu,
            onShowMenu = _ref$onShowMenu === undefined ? function () {} : _ref$onShowMenu,
            _ref$onHideMenu = _ref.onHideMenu,
            onHideMenu = _ref$onHideMenu === undefined ? function () {} : _ref$onHideMenu;

        _classCallCheck(this, TypeOfWorkButton);

        var _this = _possibleConstructorReturn(this, (TypeOfWorkButton.__proto__ || Object.getPrototypeOf(TypeOfWorkButton)).call(this, {
            editable: editable,
            positionParams: positionParams,
            onShowMenu: onShowMenu,
            onHideMenu: onHideMenu
        }));

        _this.params = {
            showCategory: showCategory,
            typeOfWorkMenu: typeOfWorkMenu
        };

        _this.state = {
            typeOfWorkId: BILLING_TYPE_NOT_SELECTED_VALUE,
            typeOfWorkName: '',
            billable: false,
            editable: false
        };

        _this.onAnyStatePropertyChanged(['typeOfWorkId', 'typeOfWorkName', 'billable'], function () {
            return _this.update();
        });

        _this.onStatePropertyChanged('editable', function (editable) {
            return _this.setEditable(editable);
        });

        _this.onTypeOfWorkChangedCb = onTypeOfWorkChangedCb;
        return _this;
    }

    _createClass(TypeOfWorkButton, [{
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='typeOfWorkButton'>" + " <div class='value ellipsis'/>" + "</div>";
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            _get(TypeOfWorkButton.prototype.__proto__ || Object.getPrototypeOf(TypeOfWorkButton.prototype), "afterRender", this).call(this);
            this.$typeLabel = this.find('.value');
            this.update();
        }
    }, {
        key: "update",
        value: function update() {
            this.$el.toggleClass('notSelected', this.state.typeOfWorkId === BILLING_TYPE_NOT_SELECTED_VALUE);
            this.$el.toggleClass('disabled', this.disabled);
            this.$el.toggleClass('editable', this.editable);

            this._updateLabelText();
        }
    }, {
        key: "_updateLabelText",
        value: function _updateLabelText() {
            var text = this._makeLabelText();
            this.$typeLabel.text(text);
            this.$el.attr('title', text);
        }
    }, {
        key: "_makeLabelText",
        value: function _makeLabelText() {
            if (this.state.typeOfWorkId === BILLING_TYPE_NOT_SELECTED_VALUE) return _messageResource2.default.getMessage('billing_type.not_selected');
            if (this.state.typeOfWorkId === _constants.NON_BILLABLE_DEFAULT_TYPE_ID) return this.state.typeOfWorkName;

            if (this.params.showCategory) {
                var category = _messageResource2.default.getMessage(this.state.billable ? 'billing_type.billable' : 'billing_type.non_billable');
                return category + ": " + this.state.typeOfWorkName;
            } else {
                return this.state.typeOfWorkName;
            }
        }
    }, {
        key: "getMenu",
        value: function getMenu() {
            this.params.typeOfWorkMenu.setTypeOfWorkId(this.state.typeOfWorkId);
            return this.params.typeOfWorkMenu;
        }
    }, {
        key: "_change",
        value: function _change(newId) {
            if (this.state.typeOfWorkId !== newId) {
                this.onTypeOfWorkChangedCb(newId);
                return true;
            }
            return false;
        }
    }]);

    return TypeOfWorkButton;
}(_MenuButton3.default);

exports.default = TypeOfWorkButton;

/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _TableRow = __webpack_require__(250);

var _TableRow2 = _interopRequireDefault(_TableRow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function UserTableRow() {
    this.constructor = UserTableRow;
    this.permissionsCell = null;
    this.nameCell = null;
    this.teamScopeCell = null;
    this.manageScopeCell = null;
}

UserTableRow.prototype = new _TableRow2.default();

UserTableRow.prototype.init = function (userListUserInfo) {
    _TableRow2.default.call(this);
    this.userListUserInfo = userListUserInfo;
    return this;
};

UserTableRow.prototype.getUserListUserInfo = function () {
    return this.userListUserInfo;
};

// TODO: Need to introduce Column class defining:
// - column number
// - Cell renderer (probably more than one if several row types are possible)
// - Cell factory  (probably more than one if several row types are possible)
UserTableRow.prototype.writeCellsContent = function () {
    var cells = this.getCells();
    for (var i = 0; i < cells.length; i++) {
        cells[i].writeContent();
    }
};

UserTableRow.prototype.addTeamScopeCellObj = function (teamScopeCell) {
    _TableRow2.default.prototype.addCellObj.call(this, teamScopeCell);
    this.teamScopeCell = teamScopeCell;
};

UserTableRow.prototype.addManageScopeCellObj = function (manageScopeCell) {
    _TableRow2.default.prototype.addCellObj.call(this, manageScopeCell);
    this.manageScopeCell = manageScopeCell;
};

UserTableRow.prototype.addPermissionsCellObj = function (permissionsCell) {
    _TableRow2.default.prototype.addCellObj.call(this, permissionsCell);
    this.permissionsCell = permissionsCell;
};

UserTableRow.prototype.getPermissionsCell = function () {
    return this.permissionsCell;
};

UserTableRow.prototype.getTeamScopeCell = function () {
    return this.teamScopeCell;
};

UserTableRow.prototype.getManageScopeCell = function () {
    return this.manageScopeCell;
};

UserTableRow.prototype.addNameCellObj = function (nameCell) {
    _TableRow2.default.prototype.addCellObj.call(this, nameCell);
    this.nameCell = nameCell;
};

UserTableRow.prototype.getNameCell = function () {
    return this.nameCell;
};

exports.default = UserTableRow;

/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _TableCellRenderer = __webpack_require__(63);

var _TableCellRenderer2 = _interopRequireDefault(_TableCellRenderer);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ShowBalanceHistoryCellRenderer() {
    this.constructor = ShowBalanceHistoryCellRenderer;
}

ShowBalanceHistoryCellRenderer.prototype = _underscore2.default.create(_TableCellRenderer2.default.prototype, {

    /**
     @param handlers contains functions-handlers as properties
     */
    init: function init(_ref) {
        var _ref$onClickHandler = _ref.onClickHandler,
            onClickHandler = _ref$onClickHandler === undefined ? function () {} : _ref$onClickHandler,
            _ref$onMouseOverHandl = _ref.onMouseOverHandler,
            onMouseOverHandler = _ref$onMouseOverHandl === undefined ? function () {} : _ref$onMouseOverHandl,
            _ref$onMouseOutHandle = _ref.onMouseOutHandler,
            onMouseOutHandler = _ref$onMouseOutHandle === undefined ? function () {} : _ref$onMouseOutHandle;

        _TableCellRenderer2.default.call(this);

        this.onClickHandler = onClickHandler;
        this.onMouseOverHandler = onMouseOverHandler;
        this.onMouseOutHandler = onMouseOutHandler;

        return this;
    },

    getCellGeneralClassName: function getCellGeneralClassName() {
        //abstract
    },

    getFlagValue: function getFlagValue(value) {
        //abstract
    },

    getCellTooltipText: function getCellTooltipText() {
        //abstract
    },

    getCellClassName: function getCellClassName(cell) {
        var classes = [this.getCellGeneralClassName()];

        if (!this.getFlagValue(cell.getValue())) {
            classes.push("off");
        } else {
            classes.push("on");
        }

        return classes;
    },

    generateContent: function generateContent(cell) {
        var _this = this;

        var value = cell.getValue();
        var cellEl = cell.getCellEl();
        var jQcell = (0, _jquery2.default)(cellEl);
        var title = "";
        var content = "";

        if (this.getFlagValue(value)) {

            if (this.onClickHandler) cellEl.onclick = function () {
                return _this.onClickHandler(cell);
            };

            if (this.onMouseOverHandler) (0, _jquery2.default)(cellEl).hover(function (e) {
                return _this.onMouseOverHandler(e);
            }, this.onMouseOutHandler);

            jQcell.hover(function () {
                jQcell.addClass("hovered");
            }, function () {
                jQcell.removeClass("hovered");
            });

            title = this.getCellTooltipText();

            content += '<div class="ptoHistorySpinnerPlaceholder" style="display: inline-block"></div>';
        }

        cellEl.title = title;
        cellEl.innerHTML = content;
    }
});

exports.default = ShowBalanceHistoryCellRenderer;

/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _BalanceRulesRenderer2 = __webpack_require__(390);

var _BalanceRulesRenderer3 = _interopRequireDefault(_BalanceRulesRenderer2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CapRulesCell = function (_BalanceRulesRenderer) {
    _inherits(CapRulesCell, _BalanceRulesRenderer);

    function CapRulesCell() {
        _classCallCheck(this, CapRulesCell);

        return _possibleConstructorReturn(this, (CapRulesCell.__proto__ || Object.getPrototypeOf(CapRulesCell)).apply(this, arguments));
    }

    _createClass(CapRulesCell, [{
        key: "_getRuleValue",
        value: function _getRuleValue(ptoData) {
            return ptoData.balanceCap !== null ? this.formatter(ptoData.balanceCap) : "&ndash;";
        }
    }, {
        key: "_customClassName",
        value: function _customClassName(ptoData) {
            return "capRule";
        }
    }]);

    return CapRulesCell;
}(_BalanceRulesRenderer3.default);

exports.default = CapRulesCell;

/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _BalanceRulesRenderer = __webpack_require__(390);

var _BalanceRulesRenderer2 = _interopRequireDefault(_BalanceRulesRenderer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DefaultRulesCell = function (_BalanceRuleRenderer) {
    _inherits(DefaultRulesCell, _BalanceRuleRenderer);

    function DefaultRulesCell() {
        _classCallCheck(this, DefaultRulesCell);

        var _this = _possibleConstructorReturn(this, (DefaultRulesCell.__proto__ || Object.getPrototypeOf(DefaultRulesCell)).call(this));

        _this._handleDefaultPTORules = function (ptoData) {
            return true;
        };

        _this.defaultMessage = null;
        return _this;
    }

    _createClass(DefaultRulesCell, [{
        key: "_getRuleValue",
        value: function _getRuleValue(ptoData) {
            return this.defaultMessage;
        }
    }, {
        key: "_customClassName",
        value: function _customClassName(ptoData) {
            return "defaultRule";
        }
    }]);

    return DefaultRulesCell;
}(_BalanceRulesRenderer2.default);

exports.default = DefaultRulesCell;

/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _TableCellRenderer = __webpack_require__(63);

var _TableCellRenderer2 = _interopRequireDefault(_TableCellRenderer);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _Switcher = __webpack_require__(236);

var _Switcher2 = _interopRequireDefault(_Switcher);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function BalanceControlRenderer() {}

BalanceControlRenderer.prototype = _underscore2.default.create(_TableCellRenderer2.default.prototype);

BalanceControlRenderer.prototype.init = function (_ref) {
    var _ref$onClickHandler = _ref.onClickHandler,
        onClickHandler = _ref$onClickHandler === undefined ? function () {} : _ref$onClickHandler,
        _ref$onMouseOverHandl = _ref.onMouseOverHandler,
        onMouseOverHandler = _ref$onMouseOverHandl === undefined ? function () {} : _ref$onMouseOverHandl,
        _ref$onMouseOutHandle = _ref.onMouseOutHandler,
        onMouseOutHandler = _ref$onMouseOutHandle === undefined ? function () {} : _ref$onMouseOutHandle;

    _TableCellRenderer2.default.call(this);
    this.onClickHandler = onClickHandler;
    this.onMouseOverHandler = onMouseOverHandler;
    this.onMouseOutHandler = onMouseOutHandler;
    return this;
};

BalanceControlRenderer.prototype.getCellClassName = function (cell) {
    var value = cell.getValue();
    return this.getFlagValue(value) ? [this.cellGeneralClassName, 'on'] : [this.cellGeneralClassName, 'off'];
};

BalanceControlRenderer.prototype.generateContent = function (cell) {
    var _this = this;

    var value = cell.getValue();
    var cellEl = cell.getCellEl();
    this.switcher = new _Switcher2.default({
        additionalClass: 'small',
        onSwitchCallback: function onSwitchCallback(enabled) {
            _this.onClickHandler(cell, !_this.getFlagValue(value));
        }
    }).init((0, _jquery2.default)(cellEl));
    this.switcher.setState({
        enabled: this.getFlagValue(value)
    });

    if (this.onClickHandler) cellEl.onclick = function () {
        return _this.onClickHandler(cell, !_this.getFlagValue(value));
    };
    if (this.onMouseOverHandler) (0, _jquery2.default)(cellEl).hover(function (e) {
        return _this.onMouseOverHandler(e);
    }, this.onMouseOutHandler);

    this.updateContent(cell);
};

BalanceControlRenderer.prototype.updateContent = function (cell) {
    this.switcher.setState({
        enabled: this.getFlagValue(cell.getValue())
    });
};

exports.default = BalanceControlRenderer;

/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _TableCellRenderer = __webpack_require__(63);

var _TableCellRenderer2 = _interopRequireDefault(_TableCellRenderer);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function BalanceCellRenderer() {
    this.constructor = BalanceCellRenderer;
}

BalanceCellRenderer.prototype = _.create(_TableCellRenderer2.default.prototype, {

    /**
     @param handlers contains functions-handlers as properties
     */
    init: function init(_ref, ptoHoursPerDay) {
        var _ref$onClickHandler = _ref.onClickHandler,
            onClickHandler = _ref$onClickHandler === undefined ? function () {} : _ref$onClickHandler,
            _ref$onMouseOverHandl = _ref.onMouseOverHandler,
            onMouseOverHandler = _ref$onMouseOverHandl === undefined ? function () {} : _ref$onMouseOverHandl,
            _ref$onMouseOutHandle = _ref.onMouseOutHandler,
            onMouseOutHandler = _ref$onMouseOutHandle === undefined ? function () {} : _ref$onMouseOutHandle;

        _TableCellRenderer2.default.call(this);

        this.onClickHandler = onClickHandler;
        this.onMouseOverHandler = onMouseOverHandler;
        this.onMouseOutHandler = onMouseOutHandler;

        this.daysFormatter = new NumberFormatter(window.SystemSettings.decimalSeparator, window.SystemSettings.digitGroupingSymbol, this.roundBalance() ? 0 : 2, true, '', _messageResource2.default.getMessage('common.pto_units.days.short'));
        this.hoursFormatter = new NumberFormatter(window.SystemSettings.decimalSeparator, window.SystemSettings.digitGroupingSymbol, this.roundBalance() ? 0 : 2, true, '', _messageResource2.default.getMessage('common.pto_units.hours.short'));

        this.ptoHoursPerDay = ptoHoursPerDay;

        return this;
    },

    getCellGeneralClassName: function getCellGeneralClassName() {
        return "currentBalanceCell";
    },

    roundBalance: function roundBalance() {
        //abstract
    },

    getFlagValue: function getFlagValue() {
        //abstract
    },

    getCurrentBalanceFromValue: function getCurrentBalanceFromValue(value) {
        //abstract
    },

    showBalanceInHours: function showBalanceInHours() {
        //abstract
    },

    getNotStartedText: function getNotStartedText() {
        //abstract
    },

    getCellClassName: function getCellClassName(cell) {
        var classes = [this.getCellGeneralClassName()],
            value = cell.getValue();

        if (!this.getFlagValue(value)) {
            classes.push("off");
        } else {
            if (this.getCurrentBalanceFromValue(value).notStarted) {
                classes.push("notStarted");
            } else {
                classes.push("on");
            }
            if (this.showBalanceInHours() && this.hoursFormatter.isNegativeValue(this.getCurrentBalanceFromValue(value).balance * this.ptoHoursPerDay) || !this.showBalanceInHours() && this.daysFormatter.isNegativeValue(this.getCurrentBalanceFromValue(value).balance)) {
                classes.push("negative");
            }
        }

        return classes;
    },

    generateContent: function generateContent(cell) {
        var _this = this;

        var value = cell.getValue();
        var cellEl = cell.getCellEl();
        var content;
        var title = "";

        if (this.getFlagValue(value)) {
            if (this.getCurrentBalanceFromValue(value).notStarted) {
                content = _messageResource2.default.getMessage("common.not_available_lower");
                title = this.getNotStartedText();
            } else {
                if (this.showBalanceInHours()) content = this.hoursFormatter.format(this.getCurrentBalanceFromValue(value).balance * this.ptoHoursPerDay);else content = this.daysFormatter.format(this.getCurrentBalanceFromValue(value).balance);

                if (this.onClickHandler) cellEl.onclick = function () {
                    return _this.onClickHandler(cell);
                };

                if (this.onMouseOverHandler) (0, _jquery2.default)(cellEl).hover(function (e) {
                    return _this.onMouseOverHandler(e);
                }, this.onMouseOutHandler);
            }
        } else {
            content = _messageResource2.default.getMessage("userlist.js.table.ptoCell.off");
        }

        cellEl.innerHTML = content;
        cellEl.title = title;
    }
});

exports.default = BalanceCellRenderer;

/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _atUtils = __webpack_require__(5);

var _UserNameFormat = __webpack_require__(17);

var _UserNameFormat2 = _interopRequireDefault(_UserNameFormat);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _EmptyHighlighter = __webpack_require__(137);

var _EmptyHighlighter2 = _interopRequireDefault(_EmptyHighlighter);

var _SimpleSingletonTooltip = __webpack_require__(45);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NameCellContent = function (_TemplateView) {
    _inherits(NameCellContent, _TemplateView);

    function NameCellContent(_ref) {
        var _ref$warningsControll = _ref.warningsController,
            warningsController = _ref$warningsControll === undefined ? null : _ref$warningsControll,
            _ref$onClick = _ref.onClick,
            onClick = _ref$onClick === undefined ? function (e) {} : _ref$onClick,
            _ref$onMouseIn = _ref.onMouseIn,
            onMouseIn = _ref$onMouseIn === undefined ? function (e) {} : _ref$onMouseIn,
            _ref$onMouseOut = _ref.onMouseOut,
            onMouseOut = _ref$onMouseOut === undefined ? function (e) {} : _ref$onMouseOut;

        _classCallCheck(this, NameCellContent);

        var _this = _possibleConstructorReturn(this, (NameCellContent.__proto__ || Object.getPrototypeOf(NameCellContent)).call(this, null));

        _this.state = {
            enabledInAp: false,
            enabled: false,
            firstName: '',
            lastName: '',
            middleInitial: '',
            username: '',
            userGroupName: '',
            timeZoneGroupName: '',
            infos: null,
            errors: null,
            warnings: null,
            withoutApprover: false,
            invalidReleaseDate: false,
            withoutWorkScope: false,
            highlighter: new _EmptyHighlighter2.default(),
            clickable: false,
            locked: false
        };

        _this.params = {
            onClick: onClick,
            warningsController: warningsController,
            onMouseIn: onMouseIn,
            onMouseOut: onMouseOut
        };

        _this.onAnyStatePropertyChanged(['firstName', 'lastName', 'middleInitial', 'highlighter'], function () {
            _this.find('.userNameSpan').html(_UserNameFormat2.default.formatLFM(_this.hl(_this.state.firstName), _this.hl(_this.state.lastName), _this.hl(_this.state.middleInitial)));
        });

        _this.onStatePropertyChanged('infos', function () {
            return _this._updateInfo();
        });

        _this.onStatePropertyChanged('errors', function () {
            return _this._updateErrors();
        });

        _this.onStatePropertyChanged('warnings', function () {
            if (_this.state.warnings && _this.state.warnings.length > 0) {
                _this._createWarningsEl(_this.find('.warningsInRow'), _this.state.warnings);
            }
        });

        _this.onAnyStatePropertyChanged(['userGroupName', 'timeZoneGroupName'], function (state) {
            _this.find('.groupName').text(state.userGroupName);
            _this.find('.timeZoneGroupName').text(state.timeZoneGroupName);

            var isDepartmentTmeZoneDisabled = !state.userGroupName.length && !state.timeZoneGroupName.length;

            _this.find('.userGroups').toggle(!isDepartmentTmeZoneDisabled);
            _this.find('.userNameContainer').toggleClass('nameCellWithoutGroups', isDepartmentTmeZoneDisabled);
        });

        _this.onStatePropertyChanged('withoutApprover', function () {
            _this.$noApproverWarningIcon.toggleClass('hidden', !_this.state.withoutApprover);
        });

        _this.onStatePropertyChanged('invalidReleaseDate', function () {
            _this.$invalidReleaseDateWarning.toggleClass('hidden', !_this.state.invalidReleaseDate);
        });

        _this.onStatePropertyChanged('withoutWorkScope', function () {
            _this.$noWorkScopeWarningIcon.toggleClass('hidden', !_this.state.withoutWorkScope);
        });

        _this.onStatePropertyChanged('enabledInAp', function (enabledInAp) {
            _this.find('userInOtherProduct').toggleClass('hidden', !enabledInAp);
        });

        _this.onStatePropertyChanged('enabled', function (enabled) {
            _this.find('inactive').toggleClass('hidden', !enabled);
        });

        _this.onAnyStatePropertyChanged(['clickable', 'locked'], function (state) {
            _this.$el.toggleClass('clickable', state.clickable && !state.locked);
        });
        return _this;
    }

    _createClass(NameCellContent, [{
        key: "messageKeys",
        value: function messageKeys() {
            return {
                inactiveText: 'userlist.inactive',
                enabledInApText: 'userlist.userdata.enabled_in_ap'
            };
        }
    }, {
        key: "templateHtml",
        value: function templateHtml() {
            return '<div class="userNameContent">' + '    <table class="userNameContainer">' + '        <tr>' + '            <td>' + "                <div class='name'>" + "                    <span class='userInOtherProduct' title='<%=enabledInApText%>'></span>" + "                    <span class='userNameSpan'></span>" + "                    <span class='noApproverWarning'></span>" + "                    <span class='invalidReleaseDateWarning'></span>" + "                    <span class='inactive'><%=inactiveText%></span>" + "                    <span class='noWorkScopeWarning'></span>" + "                </div>" + "                <div class='userGroups'>" + "                    <div class='groupName'></div>" + "                    <div class='timeZoneGroupName'></div>" + "                </div>" + "                <div class='warningsInRow'></div>" + '            </td>' + '        </tr>' + '    </table>' + '</div>';
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            var _this2 = this;

            this.$noApproverWarningIcon = this.find('.noApproverWarning');
            this.$noWorkScopeWarningIcon = this.find('.noWorkScopeWarning');
            this.$invalidReleaseDateWarning = this.find('.invalidReleaseDateWarning');

            var tooltip = (0, _SimpleSingletonTooltip.getInstance)();
            tooltip.subscribeToMouseEvents(this.$noApproverWarningIcon, function () {
                tooltip.setState({
                    html: _messageResource2.default.getMessage('user_list.table.tooltip.no_approver', [(0, _atUtils.escapeHtmlSymbols)(_this2.state.firstName)]),
                    extraClass: "userListNoApproversTooltip"
                });
            });
            tooltip.subscribeToMouseEvents(this.$noWorkScopeWarningIcon, function () {
                tooltip.setState({
                    html: _messageResource2.default.getMessage('userlist.work_assignments.table.tooltip.no_scope', [_this2.state.firstName]),
                    extraClass: "userlist_workAssignmentsTab_noScopeTooltip"
                });
            });
            tooltip.subscribeToMouseEvents(this.$invalidReleaseDateWarning, function () {
                tooltip.setState({
                    html: _messageResource2.default.getMessage('user.add_edit.release_date_before_hire_date'),
                    extraClass: ""
                });
            });

            this.$containerEl.on('click', function (e) {
                return _this2.params.onClick(e);
            });
            this.$containerEl.hover(function (e) {
                return _this2.params.onMouseIn(e);
            }, function (e) {
                return _this2.params.onMouseOut(e);
            });
            this.renderInitialState();
        }
    }, {
        key: "_updateInfo",
        value: function _updateInfo() {
            if (this.$noteEl) this.$noteEl.remove();

            if (this.state.infos && this.state.infos.length > 0) {
                this.$noteEl = this._createNoteEl(this.state.username, 'infoSpan', this.state.infos);
                this.params.warningsController.setInfoHoverEvents(this.$noteEl, this.state.infos);
            }
        }
    }, {
        key: "_updateErrors",
        value: function _updateErrors() {
            if (this.$errorEl) this.$errorEl.remove();

            if (this.state.errors && this.state.errors.length > 0) {
                this.$errorEl = this._createErrorEl(this.state.username, 'errorSpan', this.state.errors);
                this.params.warningsController.setErrorsHoverEvents(this.$errorEl, this.state.errors);
            }
        }
    }, {
        key: "_createWarningsEl",
        value: function _createWarningsEl(warningSection, warnings) {
            if (!warnings) {
                warningSection.hide();
                return;
            }
            this.params.warningsController.setWarnings(warningSection, warnings);
        }
    }, {
        key: "_createNoteEl",
        value: function _createNoteEl(username, className, notes) {
            var noteEl = document.createElement("span");
            noteEl.className = className;
            noteEl.id = (0, _atUtils.escapeHtmlSymbols)(username) + '_className';

            var noteJQEl = (0, _jquery2.default)(noteEl);
            this.params.warningsController.setClickEvents(noteJQEl, notes);
            this.find(".userNameSpan").after(noteJQEl);
            return noteJQEl;
        }
    }, {
        key: "_createErrorEl",
        value: function _createErrorEl(username, className, errors) {
            var errorEl = document.createElement("span");
            errorEl.className = className;
            errorEl.id = (0, _atUtils.escapeHtmlSymbols)(username) + '_className';

            var errorJQEl = (0, _jquery2.default)(errorEl);
            this.params.warningsController.setClickEvents(errorJQEl, errors);
            this.find(".userNameSpan").after(errorJQEl);
            return errorJQEl;
        }
    }, {
        key: "hl",
        value: function hl(str) {
            return this.state.highlighter.highlightTokens(str);
        }
    }]);

    return NameCellContent;
}(_TemplateView3.default);

exports.default = NameCellContent;

/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BaseScopeCellContent = function (_TemplateView) {
    _inherits(BaseScopeCellContent, _TemplateView);

    function BaseScopeCellContent($el, _ref) {
        var className = _ref.className;

        _classCallCheck(this, BaseScopeCellContent);

        var _this = _possibleConstructorReturn(this, (BaseScopeCellContent.__proto__ || Object.getPrototypeOf(BaseScopeCellContent)).call(this, $el));

        _this.params = {
            className: className
        };

        _this.state = {
            allScope: false,
            disabled: false,
            notAvailable: false,
            noAccess: false
        };

        _this.onStateChanged(function () {
            _this._updateLabel();
            _this._updateContainerClass();
        });
        return _this;
    }

    _createClass(BaseScopeCellContent, [{
        key: '_isScopeEmpty',
        value: function _isScopeEmpty() {
            return false;
        }
    }, {
        key: '_getAllScopeMessage',
        value: function _getAllScopeMessage() {
            return '';
        }
    }, {
        key: '_getSelectedScopeMessage',
        value: function _getSelectedScopeMessage() {
            return '';
        }
    }, {
        key: '_getEmptyScopeMessage',
        value: function _getEmptyScopeMessage() {
            return '';
        }
    }, {
        key: '_getNoAccessScopeMessage',
        value: function _getNoAccessScopeMessage() {
            return '';
        }
    }, {
        key: '_getEmptyNotAvailableScopeMessage',
        value: function _getEmptyNotAvailableScopeMessage() {
            return '';
        }
    }, {
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class="manageScopeCellContent <%=className%>">' + '    <span class="label"></span>' + '</div>';
        }
    }, {
        key: 'templateModel',
        value: function templateModel() {
            return {
                className: this.params.className
            };
        }
    }, {
        key: '_updateLabel',
        value: function _updateLabel() {
            this.find('.label').text(this._getLabelText());
        }
    }, {
        key: '_updateContainerClass',
        value: function _updateContainerClass() {
            this.$el.toggleClass('all', this.state.allScope).toggleClass('disabled', this.state.disabled).toggleClass('noAccess', this._hasNoAccess()).toggleClass('empty', this._isScopeEmpty());
        }
    }, {
        key: '_hasNoAccess',
        value: function _hasNoAccess() {
            return !this.state.allScope && this.state.noAccess;
        }
    }, {
        key: '_getLabelText',
        value: function _getLabelText() {
            if (this.state.disabled) {
                return '–';
            }

            if (this.state.allScope) {
                return this._getAllScopeMessage();
            }

            if (this._hasNoAccess()) {
                return this._getNoAccessScopeMessage();
            }

            if (this._isScopeEmpty()) {
                if (this.state.notAvailable) {
                    return this._getEmptyNotAvailableScopeMessage();
                } else {
                    return this._getEmptyScopeMessage();
                }
            }

            return this._getSelectedScopeMessage();
        }
    }]);

    return BaseScopeCellContent;
}(_TemplateView3.default);

exports.default = BaseScopeCellContent;

/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _BalanceRulesEditorContent = __webpack_require__(832);

var _BalanceRulesEditorContent2 = _interopRequireDefault(_BalanceRulesEditorContent);

var _BalanceRulesEditor = __webpack_require__(125);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BalanceRulesEditorDialogContent = function (_TemplateView) {
    _inherits(BalanceRulesEditorDialogContent, _TemplateView);

    function BalanceRulesEditorDialogContent(_ref) {
        var _ref$leaveBalanceType = _ref.leaveBalanceTypePrefix,
            leaveBalanceTypePrefix = _ref$leaveBalanceType === undefined ? '' : _ref$leaveBalanceType,
            balanceDefaults = _ref.balanceDefaults,
            countHoursPerDay = _ref.countHoursPerDay,
            parameters = _ref.parameters;

        _classCallCheck(this, BalanceRulesEditorDialogContent);

        var _this = _possibleConstructorReturn(this, (BalanceRulesEditorDialogContent.__proto__ || Object.getPrototypeOf(BalanceRulesEditorDialogContent)).call(this));

        _this.props = {
            leaveBalanceTypePrefix: leaveBalanceTypePrefix,
            balanceDefaults: balanceDefaults,
            countHoursPerDay: countHoursPerDay,
            parameters: parameters
        };
        return _this;
    }

    _createClass(BalanceRulesEditorDialogContent, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return "<div id='<%=prefix%>_balanceRulesDescriptionTooltip' class='balanceRulesDescriptionTooltip'>" + "    <div>" + "        <span class='defaultRules'></span>" + "        <span class='customRules'></span>" + "    </div>" + "    <div class='rules'>" + "        <div class='readOnlyResetRule'></div>" + "        <div class='readOnlyAccrualRule'></div>" + "        <div class='readOnlyCapRule'></div>" + "    </div>" + "</div>" + "<div id='<%=prefix%>_balanceRulesEditorDialog' class='balanceRulesEditorDialog'>" + "    <div>" + "        <span class='userDefaultRulesSpan'></span>" + "        <div class='switcherPlaceholder'></div>" + "    </div>" + "    <div class='leaveBalanceRulesPlaceholder'></div>" + "    <div>" + "        <span class='defaultBalanceNote'></span>" + "    </div>" + "</div>";
        }
    }, {
        key: 'templateModel',
        value: function templateModel() {
            return {
                prefix: this.props.leaveBalanceTypePrefix
            };
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            this.$balancePlaceholder = this.find('.leaveBalanceRulesPlaceholder');
            this.editor = new _BalanceRulesEditorContent2.default({
                leaveBalanceTypePrefix: this.props.leaveBalanceTypePrefix
            }).init(this.$balancePlaceholder);

            this.balanceRulesManagerActions = new _BalanceRulesEditor.BalanceRulesManager().init(this.props.leaveBalanceTypePrefix, this.props.balanceDefaults, this.props.countHoursPerDay, this.props.parameters);
        }
    }, {
        key: 'getDialogValues',
        value: function getDialogValues() {
            return this.balanceRulesManagerActions.getDialogValues();
        }
    }, {
        key: 'hideDialog',
        value: function hideDialog() {
            this.balanceRulesManagerActions.hideDialog();
        }
    }, {
        key: 'updateDialog',
        value: function updateDialog(balanceData, today) {
            this.balanceRulesManagerActions.updateDialog(balanceData, today);
        }
    }, {
        key: 'setModifyBalanceAccrualRulesOkClick',
        value: function setModifyBalanceAccrualRulesOkClick(onClickCallback) {
            this.balanceRulesManagerActions.setModifyBalanceAccrualRulesOkClick(onClickCallback);
        }
    }, {
        key: 'setOnCloseCallback',
        value: function setOnCloseCallback(callback) {
            this.balanceRulesManagerActions.setOnCloseCallback(callback);
        }
    }, {
        key: 'showDialogAt',
        value: function showDialogAt(targetCell, offset) {
            this.balanceRulesManagerActions.showDialogAt(targetCell, offset);
        }
    }, {
        key: 'reinitAccrualRulesControls',
        value: function reinitAccrualRulesControls(countHoursPerDay) {
            this.balanceRulesManagerActions.reinitAccrualRulesControls(countHoursPerDay);
        }
    }, {
        key: 'showAccrualRulesTooltip',
        value: function showAccrualRulesTooltip(e, data) {
            this.balanceRulesManagerActions.showAccrualRulesTooltip(e, data);
        }
    }, {
        key: 'moveAccrualRulesTooltip',
        value: function moveAccrualRulesTooltip(e) {
            this.balanceRulesManagerActions.moveAccrualRulesTooltip(e);
        }
    }, {
        key: 'hideAccrualRulesTooltip',
        value: function hideAccrualRulesTooltip() {
            this.balanceRulesManagerActions.hideAccrualRulesTooltip();
        }
    }]);

    return BalanceRulesEditorDialogContent;
}(_TemplateView3.default);

exports.default = BalanceRulesEditorDialogContent;

/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.createDelimiterObject = exports.DELIMITER_VALUE = exports.createItemObject = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _AnimatedDialogWrapper = __webpack_require__(286);

var _AnimatedDialogWrapper2 = _interopRequireDefault(_AnimatedDialogWrapper);

var _ItemsList = __webpack_require__(1624);

var _ItemsList2 = _interopRequireDefault(_ItemsList);

var _Item = __webpack_require__(1625);

var _Item2 = _interopRequireDefault(_Item);

var _DelimiterItem = __webpack_require__(1626);

var _DelimiterItem2 = _interopRequireDefault(_DelimiterItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var createItemObject = exports.createItemObject = function createItemObject(value, text) {
    return {
        value: value,
        text: text
    };
};

var DELIMITER_VALUE = exports.DELIMITER_VALUE = -888;

var createDelimiterObject = exports.createDelimiterObject = function createDelimiterObject() {
    return {
        value: DELIMITER_VALUE,
        text: ''
    };
};

var ItemsFilter = function (_TemplateView) {
    _inherits(ItemsFilter, _TemplateView);

    function ItemsFilter(_ref) {
        var _ref$items = _ref.items,
            items = _ref$items === undefined ? [] : _ref$items,
            _ref$defaultValue = _ref.defaultValue,
            defaultValue = _ref$defaultValue === undefined ? null : _ref$defaultValue,
            _ref$onChange = _ref.onChange,
            onChange = _ref$onChange === undefined ? function () {} : _ref$onChange,
            _ref$additionalFilter = _ref.additionalFilterClass,
            additionalFilterClass = _ref$additionalFilter === undefined ? '' : _ref$additionalFilter,
            _ref$additionalListCl = _ref.additionalListClass,
            additionalListClass = _ref$additionalListCl === undefined ? '' : _ref$additionalListCl;

        _classCallCheck(this, ItemsFilter);

        var _this = _possibleConstructorReturn(this, (ItemsFilter.__proto__ || Object.getPrototypeOf(ItemsFilter)).call(this, null));

        _this._handleClickItem = function (val) {
            _this.list.hide();
            if (_this.state.selectedValue !== val) {
                _this.params.onChange(val);
            }
        };

        _this._handleClickFilter = function () {
            _this.list.showAt(_this.getEl(), {
                my: 'right top',
                at: 'right bottom'
            });
            _this.setState({
                menuOpened: true
            });
        };

        _this.state = {
            selectedValue: null,
            menuOpened: false
        };

        _this.params = {
            items: items,
            defaultValue: defaultValue,
            onChange: onChange,
            additionalFilterClass: additionalFilterClass,
            additionalListClass: additionalListClass
        };

        _this.onStatePropertyChanged('selectedValue', function (selectedValue, prevSelectedValue) {
            _this.$el.toggleClass('filtered', selectedValue !== _this.params.defaultValue);

            _this._itemsMap[selectedValue].setState({ selected: true });
            if (prevSelectedValue) _this._itemsMap[prevSelectedValue].setState({ selected: false });
        });

        _this.onStatePropertyChanged('menuOpened', function () {
            _this.$el.toggleClass('pressed', _this.state.menuOpened);
        });

        _this._itemsMap = {};
        return _this;
    }

    _createClass(ItemsFilter, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class="userList_components_itemsFilter commonVisibleFilterButton">' + '    <div class="mainIcon"></div>' + '    <div class="downIcon"></div>' + '</div>';
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            var _this2 = this;

            this.$el.addClass(this.params.additionalFilterClass).on('click', this._handleClickFilter);

            var itemEls = [];
            this.params.items.forEach(function (_ref2) {
                var value = _ref2.value,
                    text = _ref2.text;

                if (value === DELIMITER_VALUE) {
                    itemEls.push(new _DelimiterItem2.default());
                } else {
                    var itemEl = new _Item2.default({
                        value: value,
                        text: text,
                        onClick: _this2._handleClickItem
                    });

                    _this2._itemsMap[value] = itemEl;
                    itemEls.push(itemEl);
                }
            });
            this.list = new _AnimatedDialogWrapper2.default(null, {
                dialog: new _ItemsList2.default({
                    items: itemEls
                }),
                className: 'userList_components_itemsFilter_listWrapper ' + this.params.additionalListClass,
                autoPosition: true,
                toggleMode: true,
                onHide: function onHide() {
                    _this2.setState({ menuOpened: false });
                }
            }).init((0, _jquery2.default)('body'));
        }
    }]);

    return ItemsFilter;
}(_TemplateView3.default);

exports.default = ItemsFilter;

/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _SmartField = __webpack_require__(860);

var _SmartField2 = _interopRequireDefault(_SmartField);

var _number_formatter = __webpack_require__(61);

var _number_formatter2 = _interopRequireDefault(_number_formatter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Smart field for editing decimal numbers.
 *
 * @param fieldElement HTML input element (can be wrapped into jQuery)
 * @param allowEmpty boolean - whether an empty string is treated as a valid value
 * @param maxLength - maximum number of characters that can be entered. If not specified, then there's no limit.
 * @param maxFractionDigits - maximum number of digits in fractional part.
 *        If entered value contains more fractional digits, it will be rounded during re-formatting.
 * @param [decimalSeparator] - symbol to use as decimal separator when formatting and parsing. By default '.' (dot).
 *                             NB! When parsing, '.' and ',' are always allowed as decimal separators, unless one of
 *                             them is set as digit grouping symbol.
 * @param [allowNegative] - whether to allow entering negative values. True by default
 * @param [digitGroupingSymbol] - digit grouping symbol to use when formatting and parsing. Default is empty string.
 * @param [invalidHint] - text to display as tooltip when the field is in 'invalid' state
 * @param [allowZero] - whether to allow entering zero value. True by default
 * @param [maxValue] - maximum value for this field (value should be < than maxValue)
 *
 * TODO: allow/disallow fractions? limit max/min?
 */
function DecimalField(fieldElement, allowEmpty, maxLength, maxFractionDigits, decimalSeparator, allowNegative, digitGroupingSymbol, invalidHint, allowZero, maxValue) {
    /**
     * @return string the current value
     */
    this.getValue = function () {
        return smartField.getValue();
    };

    /**
     * @return Number the current value as number
     */
    this.getValueAsNumber = function () {
        return convertToNumber(this.getValue());
    };

    /**
     * Sets the new value to the field.
     * This method treats the given parameter as a string, as if the user entered the value from keyboard.
     * Note that this will trigger the 'change' event handler which will trim, validate and re-format the given value.
     * @param value string new value to set
     */
    this.setValue = function (value) {
        smartField.setValue(value);
    };

    /**
     * Sets the new value to the field.
     * This method treats the given parameter as a javascript number, and formats it as string using the rules specified
     * in the constructor.
     * Note that the validation will also occur, because the given number may be negative while negatives may be disallowed.
     * @param value number
     */
    this.setValueAsNumber = function (value) {
        this.setValue(formatNumber(value));
    };

    /**
     * Trims, validates and re-formats the current value.
     * This function is invoked automatically on 'change' event, but sometimes it is useful to invoke it manually.
     */
    this.process = function () {
        smartField.process();
    };

    /**
     * @return boolean whether the current value is valid
     */
    this.isValid = function () {
        return smartField.isValid();
    };

    /**
     * @return boolean whether the current value is an empty string
     */
    this.isEmpty = function () {
        return smartField.isEmpty();
    };

    /**
     * Removes the 'invalid' field status, if set, even if the text is still invalid.
     * This effectively removes the CSS 'invalid' class from the field.
     */
    this.clearValidationResult = function () {
        smartField.clearValidationResult();
    };

    this.focus = function () {
        smartField.focus();
    };

    /**
     * Sets decimal separator and then re-formats value if the field is valid
     * @param newDecimalSeparator
     */
    this.setDecimalSeparator = function (newDecimalSeparator) {
        var wasValid = this.isValid();
        var value;
        if (wasValid) value = this.getValueAsNumber();

        decimalSeparator = newDecimalSeparator;
        numberFormatter = new _number_formatter2.default(decimalSeparator, digitGroupingSymbol, maxFractionDigits, true);

        if (wasValid) this.setValueAsNumber(value);
    };

    /**
     * Sets digit grouping symbol and then re-formats value if the field is valid
     * @param newDigitGroupingSymbol
     */
    this.setDigitGroupingSymbol = function (newDigitGroupingSymbol) {
        var wasValid = this.isValid();
        var value;
        if (wasValid) value = this.getValueAsNumber();

        digitGroupingSymbol = newDigitGroupingSymbol;
        numberFormatter = new _number_formatter2.default(decimalSeparator, digitGroupingSymbol, maxFractionDigits, true);

        if (wasValid) this.setValueAsNumber(value);
    };

    /**
     * Sets new invalid hint
     * @param newInvalidHint new hint to set
     */
    this.setInvalidHint = function (newInvalidHint) {
        smartField.setInvalidHint(newInvalidHint);
    };

    // ---------- private ----------

    function charFilter(charCode) {
        var sym = String.fromCharCode(charCode);

        return sym >= '0' && sym <= '9' || sym == '-' && allowNegative || sym == '.' || sym == ',' || sym == decimalSeparator || sym == digitGroupingSymbol;
    }

    function convertToNumber(text) {
        text = numberFormatter.normalize(text);

        return Number(text);
    }

    function formatNumber(number) {
        return numberFormatter.format(number);
    }

    function getValidator() {
        return function (text) {
            var number = convertToNumber(text);
            return !isNaN(number) && (number >= 0 || allowNegative) && (number != 0 || allowZero) && (!maxValue || number < maxValue);
        };
    }

    function getFormatter() {
        return function (text) {
            return formatNumber(convertToNumber(text));
        };
    }

    if (allowNegative == undefined) allowNegative = true;

    if (allowZero == undefined) allowZero = true;

    if (decimalSeparator == undefined) decimalSeparator = '.';

    if (digitGroupingSymbol == undefined) digitGroupingSymbol = '';

    var numberFormatter = new _number_formatter2.default(decimalSeparator, digitGroupingSymbol, maxFractionDigits, true);

    var smartField = new _SmartField2.default(fieldElement, charFilter, getValidator(), getFormatter(), allowEmpty, maxLength, invalidHint, maxValue);
}

exports.default = DecimalField;

/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @author kostenko
 *
 * Contents of this file:
 *  - SmartField - general purpose smart text field
 *  - DecimalField - decimal number editing field (uses SmartField)
 */

/**
 * Smart field functionality consists of 3 parts:
 * 1. Allows only specific characters to be typed (still, any characters can be pasted). Optionally limits max length.
 * 2. On the field 'change' event (usually when the field loses focus), trims the text and validates it.
 *    Applies the 'invalid' CSS class and adds the 'title' attribute with hint if validation fails.
 * 3. Re-formats the entered text if validation succeeds and removes the 'invalid' class and 'title' attribute
 *    if they were applied before.
 *
 * @param fieldElement HTML input element (can be wrapped into jQuery)
 * @param charFilter function(charCode) - returns boolean whether the given character is allowed in this field
 * @param validator function(text) - returns boolean - whether the given text is valid for this field.
 *        (Empty string is never passed through validator; its correctness is determined by allowEmpty param.)
 * @param formatter function(text) - returns string - the formatted text.
 *        (Empty string is never passed through formatter).
 * @param allowEmpty boolean - whether an empty string is treated as a valid value
 * @param maxLength - maximum number of characters that can be entered. If not specified, then there's no limit.
 * @param [invalidHint] - text to display as tooltip when the field is in 'invalid' state
 * @param [maxValue] - maximum value for this field (value should be < than maxValue)
 */
function SmartField(fieldElement, charFilter, validator, formatter, allowEmpty, maxLength, invalidHint, maxValue) {
    /**
     * @return string the current value
     */
    this.getValue = function () {
        return fieldElement.val();
    };

    /**
     * Sets the new value to the field.
     * Note that this will trigger the 'change' event handler which will trim, validate and re-format the given value.
     * @param value new value to set
     */
    this.setValue = function (value) {
        fieldElement.val(value);
        onChange();
    };

    /**
     * Trims, validates and re-formats the current value.
     * This function is invoked automatically on 'change' event, but sometimes it is useful to invoke it manually.
     */
    this.process = function () {
        fieldElement.val(self.getValue().trim());

        if (!self.isValid()) {
            setInvalidStatus();
        } else {
            unsetInvalidStatus();

            if (!self.isEmpty()) fieldElement.val(formatter(self.getValue()));
        }
    };

    /**
     * @return boolean whether the current value is valid
     */
    this.isValid = function () {
        return self.isEmpty() ? Boolean(allowEmpty) : validator(self.getValue());
    };

    /**
     * @return boolean whether the current value is an empty string
     */
    this.isEmpty = function () {
        return self.getValue().length == 0;
    };

    /**
     * Removes the 'invalid' field status, if set, even if the text is still invalid.
     * This effectively removes the CSS 'invalid' class from the field and removes tooltip.
     */
    this.clearValidationResult = function () {
        unsetInvalidStatus();
    };

    this.focus = function () {
        fieldElement.focus();
    };

    /**
     * Sets new invalid hint
     * @param newInvalidHint new hint to set
     */
    this.setInvalidHint = function (newInvalidHint) {
        invalidHint = newInvalidHint;
        if (!self.isValid()) setInvalidStatus();
    };

    // ---------- private ----------

    fieldElement = (0, _jquery2.default)(fieldElement);
    var self = this;

    function setInvalidStatus() {
        fieldElement.addClass('invalid');
        fieldElement.attr('title', invalidHint);
    }

    function unsetInvalidStatus() {
        fieldElement.removeClass('invalid');
        fieldElement.removeAttr('title');
    }

    function onKeyPress(event) {
        // always allow special keys such as arrows, backspace, etc. (fired under FireFox & Opera only)
        if (event.which < 32) return;

        // FireFox, Opera & Safari fire this event even when using modifier keys.
        // In this case we must not prevent the default behavior.
        if (event.ctrlKey || event.altKey || event.metaKey) return;

        // apply filter
        if (!charFilter(event.which)) event.preventDefault();
    }

    function onChange() {
        self.process();
    }

    fieldElement.keypress(onKeyPress);
    fieldElement.change(onChange);

    if (maxLength != null) fieldElement.attr('maxlength', maxLength);
}

exports.default = SmartField;

/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _atBrowserUtils = __webpack_require__(8);

var _atUtils = __webpack_require__(5);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function InviteSeveralUsersRow() {}

InviteSeveralUsersRow.prototype = _underscore2.default.create(Object.prototype, {

    EMPTY_FIRST_NAME_ERROR: "emptyFirstNameError",
    EMPTY_LAST_NAME_ERROR: "emptyLastNameError",
    EMPTY_EMAIL_ERROR: "emptyEmailError",
    INVALID_EMAIL_ERROR: "invalidEmailError",

    init: function init(rowNumber, specialRowClasses, validationCallback, changesCallback, errorTooltip) {
        this.rowNumber = rowNumber;
        this.specialRowClasses = specialRowClasses || "";
        this.validationCallback = validationCallback;
        this.changesCallback = changesCallback;
        this.errorTooltip = errorTooltip;
        this.isIE8 = (0, _atBrowserUtils.isIE8)();

        this.errors = {};
        this.firstNameFieldEmpty = true;
        this.lastNameFieldEmpty = true;
        this.emailFieldEmpty = true;

        this.$row = (0, _jquery2.default)('<tr>');

        if (this.specialRowClasses) {
            this.$row.addClass(this.specialRowClasses);
        }

        var self = this;
        var errorTextsMap = {};

        this.$icon = (0, _jquery2.default)('<div>');
        this._addTdToRow(this.$icon, "rowIcon");

        this.$firstName = this._createInput("First Name", 32, "firstNameCell");
        this._addChangeCallbackToInputField(this.$firstName, function () {
            self.validateFirstName(true);
        });
        errorTextsMap[InviteSeveralUsersRow.prototype.EMPTY_FIRST_NAME_ERROR] = _messageResource2.default.getMessage("user.add_edit.error.first_name_empty");
        this._addErrorTooltipCallbacks(this.$firstName, errorTextsMap);
        this._addTdToRow(this.$firstName);

        this.$lastName = this._createInput("Last Name", 32, "lastNameCell");
        this._addChangeCallbackToInputField(this.$lastName, function () {
            self.validateLastName(true);
        });
        errorTextsMap = {};
        errorTextsMap[InviteSeveralUsersRow.prototype.EMPTY_LAST_NAME_ERROR] = _messageResource2.default.getMessage("user.add_edit.error.last_name_empty");
        this._addErrorTooltipCallbacks(this.$lastName, errorTextsMap);
        this._addTdToRow(this.$lastName);

        this.$email = this._createInput("Email", 191, "emailCell");
        this._addChangeCallbackToInputField(this.$email, function () {
            self.validateEmail(true, true);
        }, function () {
            self.onTextFieldChange(_underscore2.default.bind(self.validateEmail, self, true, false));
        });
        errorTextsMap = {};
        errorTextsMap[InviteSeveralUsersRow.prototype.EMPTY_EMAIL_ERROR] = _messageResource2.default.getMessage("user.add_edit.error.email_empty");
        errorTextsMap[InviteSeveralUsersRow.prototype.INVALID_EMAIL_ERROR] = _messageResource2.default.getMessage("user.add_edit.error.email_invalid");
        this._addErrorTooltipCallbacks(this.$email, errorTextsMap);
        this._addTdToRow(this.$email);

        return this;
    },

    _addErrorTooltipCallbacks: function _addErrorTooltipCallbacks($element, errorTextsMap) {
        var self = this;
        $element.hover(function () {
            for (var p in errorTextsMap) {
                if (self.errors[p]) {
                    self.errorTooltip.updateUIAndShow({ errorText: errorTextsMap[p] });
                    break;
                }
            }
        }, function () {
            self.errorTooltip.hide();
        });
        $element.mousemove(function (event) {
            self.errorTooltip.move((0, _atBrowserUtils.calculateTooltipOffset)(self.errorTooltip, event));
        });
    },

    onTextFieldChange: function onTextFieldChange(validator) {
        validator();
        if (this.hasNoValues()) {
            this.errors = {};
        }
        this.updateUI();
        if (this.isIE8) {
            var sibling = this.$row.next();
            if (sibling.length > 0) {
                sibling.addClass("ie8-fix").removeClass("ie8-fix");
            }
        }
    },

    onTextFieldChangeWithValidationAndChangesCallbacks: function onTextFieldChangeWithValidationAndChangesCallbacks(validator) {
        this.onTextFieldChange(validator);
        if (this.validationCallback) {
            this.validationCallback();
        }
        if (this.changesCallback) {
            this.changesCallback();
        }
    },

    _addChangeCallbackToInputField: function _addChangeCallbackToInputField($field, validator, onBlurCustomCallback) {
        $field.valueChanged(_underscore2.default.bind(this.onTextFieldChangeWithValidationAndChangesCallbacks, this, validator));
        $field.blur(onBlurCustomCallback ? onBlurCustomCallback : _underscore2.default.bind(this.onTextFieldChange, this, validator));
    },

    _addTdToRow: function _addTdToRow($tdContent, classname) {
        var $td = (0, _jquery2.default)('<td>');
        if (classname) {
            $td.addClass(classname);
        }
        $td.append($tdContent);
        this.$row.append($td);
    },

    getElement: function getElement() {
        return this.$row;
    },

    getUserFields: function getUserFields() {
        return {
            rowNumber: this.rowNumber,
            firstName: this.getFirstName(),
            lastName: this.getLastName(),
            email: this.getEmail()
        };
    },

    getFirstName: function getFirstName() {
        return (0, _atUtils.trim)(this.$firstName.pVal());
    },

    getLastName: function getLastName() {
        return (0, _atUtils.trim)(this.$lastName.pVal());
    },

    getEmail: function getEmail() {
        return (0, _atUtils.trim)(this.$email.pVal());
    },

    _createInput: function _createInput(placeholder, maxlength, classname) {
        var $input = (0, _jquery2.default)('<input type="text" placeholder="' + placeholder + '" maxlength="' + maxlength + '" class="' + "inputFieldWithPlaceholder " + classname + '">');
        $input.placeholder();
        return $input;
    },

    validate: function validate() {
        if (this.hasNoValues() && !this.hasErrors()) {
            return true;
        }
        this.validateFirstName();
        this.validateLastName();
        this.validateEmail();
        return !this.hasErrors();
    },

    validateFirstName: function validateFirstName(onlyRemoveEmptyError) {
        this.firstNameFieldEmpty = this.getFirstName().length == 0;
        this._checkInvalid(this.firstNameFieldEmpty, InviteSeveralUsersRow.prototype.EMPTY_FIRST_NAME_ERROR, onlyRemoveEmptyError);
    },

    validateLastName: function validateLastName(onlyRemoveEmptyError) {
        this.lastNameFieldEmpty = this.getLastName().length == 0;
        this._checkInvalid(this.lastNameFieldEmpty, InviteSeveralUsersRow.prototype.EMPTY_LAST_NAME_ERROR, onlyRemoveEmptyError);
    },

    validateEmail: function validateEmail(onlyRemoveEmptyError, onlyRemoveInvalidError) {
        var email = this.getEmail();
        this.emailFieldEmpty = email.length == 0;
        this.errors[InviteSeveralUsersRow.prototype.EMPTY_EMAIL_ERROR] = this.emailFieldEmpty && !onlyRemoveEmptyError;
        this._checkInvalid(this.emailFieldEmpty ? false : !(0, _atUtils.isEmailValid)(email), InviteSeveralUsersRow.prototype.INVALID_EMAIL_ERROR, onlyRemoveInvalidError);
    },

    _checkInvalid: function _checkInvalid(fieldIsInvalid, errorCode, onlyRemoveError) {
        if (fieldIsInvalid) {
            if (!onlyRemoveError) {
                this.errors[errorCode] = true;
            }
        } else {
            this.errors[errorCode] = false;
        }
    },

    updateUI: function updateUI() {
        var classes = [];
        for (var p in this.errors) {
            if (this.errors[p]) {
                classes.push(p);
            }
        }
        this.$row[0].className = this.specialRowClasses + " " + classes.join(" ");
        this.$icon.toggleClass("active", !(this.firstNameFieldEmpty || this.lastNameFieldEmpty || this.emailFieldEmpty || this.hasErrors()));
    },

    hasErrors: function hasErrors() {
        for (var p in this.errors) {
            if (this.errors[p]) {
                return true;
            }
        }
        return false;
    },

    hasNoValues: function hasNoValues() {
        return this.firstNameFieldEmpty && this.lastNameFieldEmpty && this.emailFieldEmpty;
    },

    addServerErrors: function addServerErrors(errors) {
        var self = this;
        _underscore2.default.each(errors, function (error) {
            if (error == "com.actimind.common.services.UserEmailInvalidException") {
                self.errors[InviteSeveralUsersRow.prototype.INVALID_EMAIL_ERROR] = true;
            }
        });
    },

    setFocus: function setFocus() {
        this.$firstName.focus();
    },

    setSpecialRowClasses: function setSpecialRowClasses(specialRowClasses) {
        this.specialRowClasses = specialRowClasses;
    }
});

exports.default = InviteSeveralUsersRow;

/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _keyCodes = __webpack_require__(66);

var _atBrowserUtils = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @deprecated try to use DropdownTemplateView
 * @constructor
 */
function DropdownList() {}

DropdownList.prototype.init = function (dropdownListId, className, rowTemplate, rowsData, placeholderForContainer, callbackHandler) {
    this.isShown = false;
    this.dropdownListId = dropdownListId;
    this.className = className;
    this.rowTemplate = _.template(rowTemplate);
    this.rowsData = rowsData;
    this.placeholderForContainer = placeholderForContainer || "body";
    this.callbackHandler = callbackHandler || {};

    (0, _jquery2.default)(document).off("mousedown.dropdownList").on("mousedown.dropdownList", _jquery2.default.proxy(this._mouseDownHandler, this));
    (0, _jquery2.default)(window).off("resize.dropdownList").on("resize.dropdownList", _jquery2.default.proxy(this._resizeHandler, this));
    (0, _jquery2.default)("body").off("keydown.dropdownList").on("keydown.dropdownList", _jquery2.default.proxy(this._keyDownHandler, this));

    return this;
};

DropdownList.prototype._getContainer = function () {
    var container = (0, _jquery2.default)("#" + this.dropdownListId);
    if (container.length === 0) {
        container = (0, _jquery2.default)("<div id='" + this.dropdownListId + "' class='" + this.className + "'></div>");
        (0, _jquery2.default)(this.placeholderForContainer).append(container);
    } else {
        container = (0, _jquery2.default)(container[0]);
    }
    return container;
};

DropdownList.prototype.updateData = function (data) {
    this.rowsData = data;
};

DropdownList.prototype.setCallbackHandler = function (callbackHandler) {
    this.callbackHandler = callbackHandler || {};
};

DropdownList.prototype.showAt = function ($element, positionParams) {
    if (this.preventNextShowing) {
        this.preventNextShowing = false;
        return;
    }

    this._renderContent();
    var $container = this._getContainer();

    $container.show();
    this.$elementShowAt = $element;

    positionParams = positionParams || {};
    positionParams.of = this.$elementShowAt;
    showElementAt($container, positionParams);

    ScrollUtils.refreshCustomScroll(this.listScroll);
    this.isShown = true;

    if (this.callbackHandler.onShow) {
        this.callbackHandler.onShow();
    }
};

DropdownList.prototype._renderContent = function () {
    var self = this;
    var $container = this._getContainer();
    $container.empty();
    var $listWrapper = (0, _jquery2.default)("<div class='listWrapper'></div>");
    var $listContainer = (0, _jquery2.default)("<table class='listContainer'></table>");

    _.each(this.rowsData, function (rowData) {
        var $row = (0, _jquery2.default)(self.rowTemplate(rowData));
        self._addEventHandlersToRow($row, rowData);
        $listContainer.append($row);
    });

    $listWrapper.append($listContainer);
    $container.append($listWrapper);
    this.listScroll = ScrollUtils.addVerticalScroll($listWrapper, { isFaded: false });
};

DropdownList.prototype._addEventHandlersToRow = function ($row, rowData) {
    var self = this;
    $row.click(function () {
        if (self.callbackHandler.onRowClick) {
            self.callbackHandler.onRowClick(rowData);
        }
        self.hide();
    });
};

DropdownList.prototype.hide = function () {
    if (this.isShown) {
        this.isShown = false;
        this._getContainer().hide();
        if (this.callbackHandler.onHide) {
            this.callbackHandler.onHide();
        }
    }
};

DropdownList.prototype._mouseDownHandler = function (event) {
    if (this.isShown) {
        var target = event.target;
        while (target) {
            if (target == this.$elementShowAt[0]) {
                this.preventNextShowing = true;
            }
            if (target.id == this._getContainer()[0].id) {
                (0, _atBrowserUtils.cancelBubble)(event);
                return false;
            }
            target = target.parentElement;
        }
        (0, _atBrowserUtils.cancelBubble)(event);
        this.hide();
        event.preventDefault();
    }
};

DropdownList.prototype._resizeHandler = function () {
    this.hide();
};

DropdownList.prototype._keyDownHandler = function (event) {
    if (this.isShown) {
        switch (event.keyCode) {
            case _keyCodes.KEY_CODE_ESC:
            case _keyCodes.KEY_CODE_TAB:
                this.hide();
                break;
        }
        (0, _atBrowserUtils.cancelBubble)(event.originalEvent);
        return false;
    }
};

exports.default = DropdownList;

/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _BasicLightbox = __webpack_require__(163);

var _BasicLightbox2 = _interopRequireDefault(_BasicLightbox);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _TableTooltip = __webpack_require__(237);

var _TableTooltip2 = _interopRequireDefault(_TableTooltip);

var _atUtils = __webpack_require__(5);

var _index = __webpack_require__(48);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function InviteSeveralUsersLightBox() {}

InviteSeveralUsersLightBox.prototype = _underscore2.default.create(_BasicLightbox2.default.prototype, {
    exist_invalid_fields_message_key: "user.add_edit.js.footer_error.exist_invalid_fields",
    close_tab_confirmation_message_key: "user.js.invite_several_users.close_tab_confirmation",
    TITLE_TEXT_KEY: "user.js.invite_several_users_popup.title",
    INITIAL_NUMBER_OF_ROWS: 7,

    init: function init(inviteUsersData) {
        _BasicLightbox2.default.prototype.init.call(this, this._getLightBoxId(), "closeInviteSeveralUsersLightBoxBtn");
        (0, _jquery2.default)(this.lightBoxEl).removeClass("usersInvited scrollable");
        this.errors = {};
        this.dataChanged = false;
        this.cancel_confirmation_message_key = "user.js.invite_several_users.cancel_confirmation";

        this.titlePlaceholder = document.getElementById(this.lightBoxEl.id + "_titlePlaceholder");
        this.$accountsInvitedSection = (0, _jquery2.default)("#" + this.lightBoxEl.id + "_accountCreatedSection");
        this.errorTooltip = new _TableTooltip2.default().init(this.lightBoxEl.id + "_inviteSeveralUsersErrorTooltip");
        this.errorTooltip.updateUI = function (config) {
            this._tooltipTextPlaceholder.text(config.errorText);
        };

        this.setTitle(_messageResource2.default.getMessage(this.TITLE_TEXT_KEY));
        this._generateTable();

        this._bindClickToAddRowsLink("addOneRow", 1);
        this._bindClickToAddRowsLink("addFiveRows", 5);
        this._bindClickToAddRowsLink("addTenRows", 10);

        new BeigeButtonClassesController().init((0, _jquery2.default)(this.commitButton)).addListenersIfNeeded();
        new BeigeButtonClassesController().init((0, _jquery2.default)(this.cancelButton)).addListenersIfNeeded();

        return this;
    },

    _bindClickToAddRowsLink: function _bindClickToAddRowsLink(linkClass, number) {
        var self = this;
        this.innerContent.find(".addRowsButtonsContainer ." + linkClass).off("click").on("click", function () {
            self._addEmptyRows(number);
            return false;
        });
    },

    _getLightBoxId: function _getLightBoxId() {
        return "inviteSeveralUsersLightBox";
    },

    _changesCallback: function _changesCallback() {
        this.dataChanged = true;
    },

    setTitle: function setTitle(title) {
        this.titlePlaceholder.innerHTML = (0, _atUtils.escapeHtmlSymbols)(title);
    },

    _generateTable: function _generateTable(config) {
        // abstract
    },

    getDataToCommit: function getDataToCommit() {
        return [this._getUsersFields()];
    },

    _getUsersFields: function _getUsersFields() {
        var accounts = [];
        _underscore2.default.each(this.rows, function (row) {
            if (!row.hasNoValues()) {
                accounts.push(row.getUserFields());
            }
        });
        return accounts;
    },

    updateUI: function updateUI() {
        _underscore2.default.each(this.rows, function (row) {
            row.updateUI();
        });
    },

    validate: function validate() {
        var firstInvalidRow;
        var valid = true;
        _underscore2.default.each(this.rows, function (row) {
            if (!row.validate()) {
                if (_underscore2.default.isUndefined(firstInvalidRow)) {
                    firstInvalidRow = row;
                }
                valid = false;
            }
        });
        if (firstInvalidRow) {
            this.scrollToSection((0, _jquery2.default)(firstInvalidRow.getElement()));
        }
        return valid;
    },

    /*
    Offset to show field with error in center of the popup.
     */
    getContentOffset: function getContentOffset() {
        return -(this.innerContent.height() / 2);
    },

    hasErrors: function hasErrors() {
        var hasErrors = false;
        _jquery2.default.each(this.rows, function (index, row) {
            if (row.hasErrors()) {
                hasErrors = true;
                return false;
            }
        });
        return hasErrors;
    },

    showServerErrors: function showServerErrors(errors) {
        var self = this;
        var minRowNumber = Number.MAX_VALUE;
        _underscore2.default.each(errors, function (error) {
            minRowNumber = Math.min(minRowNumber, error.rowNumber);
            self.rows[error.rowNumber].addServerErrors(error.exceptionNames.list);
        });
        if (errors.length > 0) {
            this.scrollToSection((0, _jquery2.default)(this.rows[minRowNumber].getElement()));
        }
        this.printErrorInFooter(_messageResource2.default.getMessage(this.exist_invalid_fields_message_key));
        this.updateUI();
    },

    switchToUsersInvitedState: function switchToUsersInvitedState(usersInfo) {
        (0, _jquery2.default)(this.lightBoxEl).addClass("usersInvited");
        this._commitEnabled = false;
        this.dataChanged = false;

        this.$accountsInvitedSection.find(".invitationInfoHeader").text(_messageResource2.default.getMessage("user.invite_several_users_popup.invited_users_header"));

        var usersFields = usersInfo;
        var $list = (0, _jquery2.default)("<div class='invitedUsersList'>");
        var indexTo = Math.min(7, usersFields.length);
        for (var i = 0; i < indexTo; i++) {
            var userInfo = usersFields[i];

            if (userInfo.enabled) {
                var listItem = (0, _jquery2.default)("<div>");
                listItem.append('<span class=\'bullet\'>\u2022</span>');
                listItem.append((0, _jquery2.default)("<span>").text(userInfo.firstName + " " + userInfo.lastName + " (" + userInfo.email + ")"));
                $list.append(listItem);
            }
        }
        if (usersFields.length > 7) {
            var andMoreUsersText = usersFields.length - 7 == 1 ? _messageResource2.default.getMessage("user.created.invite.and_one_more_user") : _messageResource2.default.getMessage("user.created.invite.and_more_users", [usersFields.length - 7]);
            $list.append((0, _jquery2.default)("<div class='andMoreUsers'>").text(andMoreUsersText));
        }

        this.$accountsInvitedSection.find(".invitationInfo").empty().append($list);

        this.$accountsInvitedSection.find(".mainContentContainer").css("bottom", 265 - indexTo * 10 + "px");

        this.$accountsInvitedSection.find(".inviteOneMoreButton").css("margin-top", 357 + indexTo * 4 + "px");

        this.$accountsInvitedSection.find(".inviteOneMoreButton span").off("click").click(_underscore2.default.bind(this._switchToInviteUsersState, this));

        this.$accountsInvitedSection.find(".closeLink span").off("click").click(_underscore2.default.bind(this.cancel, this));
    },

    _switchToInviteUsersState: function _switchToInviteUsersState() {
        (0, _jquery2.default)(this.lightBoxEl).removeClass("usersInvited scrollable");
        this.errors = {};
        this._commitEnabled = true;
        this._generateTable();
        this.rows[0].setFocus();
    },

    show: function show() {
        _BasicLightbox2.default.prototype.show.call(this);
        this.rows[0].setFocus();
    },

    _addEmptyRows: function _addEmptyRows(number) {
        //abstract
    },

    restoreOnKeyDownHandler: function restoreOnKeyDownHandler() {
        if (this.removeHandler) this.removeHandler();
    },
    setupKeyDownHandler: function setupKeyDownHandler() {
        var _this = this;

        this.removeHandler = _index2.default.onKeyDown(function (code) {
            if ((0, _index.isEsc)(code)) {
                _this.cancel();
                return true;
            }
        });
    }
});

exports.default = InviteSeveralUsersLightBox;

/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.setCanEditEntireUser = exports.setFieldsEditability = exports.setAuthorizationInfo = undefined;

var _reduxActions = __webpack_require__(9);

var _actionTypes = __webpack_require__(680);

var ActionTypes = _interopRequireWildcard(_actionTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var setAuthorizationInfo = exports.setAuthorizationInfo = function setAuthorizationInfo(authorizationInfo) {
    return function (dispatch) {
        dispatch(setFieldsEditability({
            baseAccountInformationEditable: authorizationInfo['accountInformationEditable'],
            accessToActiTimeEditable: authorizationInfo['accessToActiTimeEditable'],
            accessToActiPlansEditable: authorizationInfo['accessToActiPlansEditable'],
            departmentEditable: authorizationInfo['departmentEditable'],
            timeZoneEditable: authorizationInfo['timeZoneEditable'],
            hireAndReleaseDatesEditable: authorizationInfo['hireAndReleaseDatesEditable'],
            approvalSettingsEditable: authorizationInfo['approvalSettingsEditable'],
            workScheduleEditable: authorizationInfo['workScheduleEditable'],
            overtimeSettingsEditable: authorizationInfo['overtimeSettingsEditable'],
            costOfWorkRatesEditable: authorizationInfo['costOfWorkRatesEditable'],

            permissionsEditable: authorizationInfo['permissionsEditable'],
            teamScopeEditable: authorizationInfo['teamScopeEditable'],
            manageScopeEditable: authorizationInfo['manageScopeEditable'],
            hasRightsToDeleteUser: authorizationInfo['hasRightsToDeleteUser']
        }));
    };
};

var setFieldsEditability = exports.setFieldsEditability = (0, _reduxActions.createAction)(ActionTypes.FIELDS_EDITABILITY_SET);

var setCanEditEntireUser = exports.setCanEditEntireUser = (0, _reduxActions.createAction)(ActionTypes.CAN_EDIT_ENTIRE_USER_SET);

/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isEntireManagementScopeAssigned = undefined;
exports.isManagerScopesAvailable = isManagerScopesAvailable;
exports.isAllManagersScopeAssigned = isAllManagersScopeAssigned;
exports.getTeamScopeState = getTeamScopeState;
exports.getManagerScopeState = getManagerScopeState;

var _constants = __webpack_require__(4);

var _ScopeCell = __webpack_require__(315);

var _constants2 = __webpack_require__(21);

var _constants3 = __webpack_require__(4);

function isManagerScopesAvailable(accessRights, _ref) {
    var isURAEnabled = _ref.isURAEnabled,
        isBTYEnabled = _ref.isBTYEnabled;

    return accessRights.indexOf(_constants.AccessRights.GENERATE_MONEY_REPORTS) !== -1 && (isURAEnabled || isBTYEnabled) || accessRights.indexOf(_constants.AccessRights.EDIT_HIERARCHY) !== -1 || accessRights.indexOf(_constants.AccessRights.SUBMIT_OTHER_USER_TIME_TRACK) !== -1 || accessRights.indexOf(_constants.AccessRights.MANAGE_USERS) !== -1;
}

function isAllManagersScopeAssigned(accessRights) {
    return accessRights.indexOf(_constants.AccessRights.MANAGE_USERS) !== -1;
}

function getTeamScopeState(teamAssignmentsData, accessRights, _ref2) {
    var isURAEnabled = _ref2.isURAEnabled,
        isBTYEnabled = _ref2.isBTYEnabled;

    var status = _ScopeCell.SCOPE_CELL_STATUS.NOT_ALLOWED;
    var disabled = false;
    var assignedUsersCount = 0;

    if (!isManagerScopesAvailable(accessRights, { isURAEnabled: isURAEnabled, isBTYEnabled: isBTYEnabled })) {
        status = _ScopeCell.SCOPE_CELL_STATUS.NOT_ALLOWED;
        disabled = true;
    } else if (isAllManagersScopeAssigned(accessRights)) {
        status = _ScopeCell.SCOPE_CELL_STATUS.ALL;
        disabled = true;
    } else {
        var assignmentsData = teamAssignmentsData;
        assignedUsersCount = assignmentsData.assignedUsersCount;

        if (assignmentsData.teamAssignmentType === _constants2.UserTeamAssignmentType.ALL) {
            status = _ScopeCell.SCOPE_CELL_STATUS.ALL;
        } else if (assignmentsData.teamAssignmentType === _constants2.UserTeamAssignmentType.NO) {
            status = _ScopeCell.SCOPE_CELL_STATUS.NO_ACCESS;
        } else if (assignedUsersCount > 0) {
            status = _ScopeCell.SCOPE_CELL_STATUS.SELECTED;
        } else {
            status = _ScopeCell.SCOPE_CELL_STATUS.NOT_SELECTED;
        }
    }

    return {
        status: status,
        assignedUsersCount: assignedUsersCount,
        disabled: disabled
    };
}

var isEntireManagementScopeAssigned = exports.isEntireManagementScopeAssigned = function isEntireManagementScopeAssigned(managementAssignmentsSelection, accessRights) {
    return isAllManagersScopeAssigned(accessRights) || managementAssignmentsSelection === _constants3.ManagementAssignmentsSelection.ALL;
};

function getManagerScopeState(managementAssignmentsCounts, managementAssignmentsSelection, accessRights, _ref3) {
    var isURAEnabled = _ref3.isURAEnabled,
        isBTYEnabled = _ref3.isBTYEnabled;

    var status = _ScopeCell.SCOPE_CELL_STATUS.NOT_ALLOWED;
    var disabled = false;
    var nCustomers = 0;
    var nProjects = 0;
    var nTasks = 0;
    if (!isManagerScopesAvailable(accessRights, { isURAEnabled: isURAEnabled, isBTYEnabled: isBTYEnabled })) {
        status = _ScopeCell.SCOPE_CELL_STATUS.NOT_ALLOWED;
        disabled = true;
    } else if (isAllManagersScopeAssigned(accessRights)) {
        status = _ScopeCell.SCOPE_CELL_STATUS.ALL;
        disabled = true;
    } else {
        nCustomers = managementAssignmentsCounts.customers;
        nProjects = managementAssignmentsCounts.projects;
        nTasks = managementAssignmentsCounts.tasks;

        if (managementAssignmentsSelection === _constants3.ManagementAssignmentsSelection.ALL) {
            status = _ScopeCell.SCOPE_CELL_STATUS.ALL;
        } else if (managementAssignmentsSelection === _constants3.ManagementAssignmentsSelection.NO) {
            status = _ScopeCell.SCOPE_CELL_STATUS.NO_ACCESS;
        } else if (nCustomers + nProjects + nTasks > 0) {
            status = _ScopeCell.SCOPE_CELL_STATUS.SELECTED;
        } else {
            status = _ScopeCell.SCOPE_CELL_STATUS.NOT_SELECTED;
        }
    }

    return {
        status: status,
        nCustomers: nCustomers,
        nProjects: nProjects,
        nTasks: nTasks,
        disabled: disabled
    };
}

/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.areRatesEqual = exports.getAssignedUsersCount = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.makeDefaultUserAccountSettings = makeDefaultUserAccountSettings;
exports.createManagementAssignmentsData = createManagementAssignmentsData;
exports.convertManageAssignmentsToArrays = convertManageAssignmentsToArrays;
exports.mergeAssignments = mergeAssignments;
exports.getTaskIdsOfCustomersAndProjects = getTaskIdsOfCustomersAndProjects;
exports.calculateProjectsByCustomerIds = calculateProjectsByCustomerIds;

var _constants = __webpack_require__(4);

var _atUtils = __webpack_require__(5);

var _constants2 = __webpack_require__(21);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function makeDefaultUserAccountSettings(userManagementData, showAPStatusControl) {
    var defaultTempl = userManagementData.permissionsTemplates.find(function (template) {
        return template.id === _constants.DEFAULT_PERMISSIONS_TEMPLATE_ID;
    });
    var defaultPermissions = defaultTempl ? defaultTempl.permissions : []; // get default permission from default permissions template

    return {
        id: null,
        firstName: "",
        lastName: "",
        middleInitial: "",
        username: "",
        enabled: true,
        enabledInOtherProduct: showAPStatusControl ? true : null,
        userGroupId: _constants.UserManagementConstants.USER_GROUP_NOT_ASSIGNED_ID,
        timeZoneGroupId: _constants.UserManagementConstants.DEFAULT_TIME_ZONE_GROUP_ID,
        overtimeLevel: window.SystemSettings.defaultOvertimeLevel,
        email: "",
        hireDate: window.currentUserTime().toJSON(),
        releaseDate: null,
        initialSchedule: userManagementData.defaultWorkSchedule.slice(0),
        defaultInitialSchedule: true,
        workSchedule: [],
        rates: userManagementData.viewerSettings.enabledFeatures[_constants.UserManagementConstants.URAFeature] ? [] : null,
        accessRights: defaultPermissions,
        requiresTTApproval: false
    };
}

/**
 * Converts user management assignments data to RPC format
 * @param data with 5 arrays with assignments and all scope flag ids
 * @param customerMap map of tasks
 * @param projectMap map of tasks
 * @param tasksMap map of tasks
 * @return user management assignments
 */
function createManagementAssignmentsData(data, customerMap, projectMap, tasksMap) {
    var customerAssignments = [];
    data.addedCustomerIds.forEach(function (id) {
        return customerAssignments.push({ id: id, includeSelf: true });
    });
    data.addedCustomerIdsExcludingSelf.forEach(function (id) {
        return customerAssignments.push({ id: id, includeSelf: false });
    });
    var projectAssignments = [];
    data.addedProjectIds.forEach(function (id) {
        return projectAssignments.push({ id: id, includeSelf: true });
    });
    data.addedProjectIdsExcludingSelf.forEach(function (id) {
        return projectAssignments.push({ id: id, includeSelf: false });
    });
    var taskAssignments = [];
    data.addedTaskIds.forEach(function (id) {
        return taskAssignments.push({ id: id, includeSelf: true });
    });

    return {
        managementAssignmentsSelection: data.managementAssignmentsSelection,
        customers: customerMap,
        projects: projectMap,
        tasks: tasksMap,
        customerAssignments: customerAssignments,
        projectAssignments: projectAssignments,
        taskAssignments: taskAssignments,
        taskCountsByProjects: data.taskCountsByProjects,
        projectCountsByCustomers: data.projectCountsByCustomers
    };
}

/**
 * Converts user management assignments data from RPC format to
 * @param userManageAssignmentsData user management assignments data from RPC
 * @return {{canManageAllScope: (boolean), addedTaskIds: Array, addedProjectIds: Array, addedProjectIdsExcludingSelf: Array, addedCustomerIds: Array, addedCustomerIdsExcludingSelf: Array}}
 */
function convertManageAssignmentsToArrays(userManageAssignmentsData) {
    var manageAssignments = {
        managementAssignmentsSelection: userManageAssignmentsData.managementAssignmentsSelection,
        addedTaskIds: [],
        addedProjectIds: [],
        addedProjectIdsExcludingSelf: [],
        addedCustomerIds: [],
        addedCustomerIdsExcludingSelf: [],
        taskCountsByProjects: userManageAssignmentsData.taskCountsByProjects.map,
        projectCountsByCustomers: userManageAssignmentsData.projectCountsByCustomers.map
    };
    userManageAssignmentsData.customerAssignments.forEach(function (assignment) {
        if (assignment.includeSelf) manageAssignments.addedCustomerIds.push(assignment.id);else manageAssignments.addedCustomerIdsExcludingSelf.push(assignment.id);
    });
    userManageAssignmentsData.projectAssignments.forEach(function (assignment) {
        if (assignment.includeSelf) manageAssignments.addedProjectIds.push(assignment.id);else manageAssignments.addedProjectIdsExcludingSelf.push(assignment.id);
    });
    userManageAssignmentsData.taskAssignments.forEach(function (assignment) {
        return manageAssignments.addedTaskIds.push(assignment.id);
    });
    return manageAssignments;
}

function mergeAssignments(assignments, _ref) {
    var _ref$added = _ref.added,
        added = _ref$added === undefined ? [] : _ref$added,
        _ref$removed = _ref.removed,
        removed = _ref$removed === undefined ? [] : _ref$removed;

    var processedSet = _extends({}, (0, _atUtils.arrayToSet)(assignments), (0, _atUtils.arrayToSet)(added));
    return Object.keys((0, _atUtils.filterMapByKeys)(processedSet, removed)).map(Number);
}

function getTaskIdsOfCustomersAndProjects() {
    var tasksMap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var customerIds = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var projectIds = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

    var cIdsSet = (0, _atUtils.arrayToSet)(customerIds);
    var pIdsSet = (0, _atUtils.arrayToSet)(projectIds);

    return Object.values(tasksMap).filter(function (task) {
        return !!cIdsSet[task.customerId] || !!pIdsSet[task.projectId];
    }).map(function (task) {
        return task.id;
    });
}

function calculateProjectsByCustomerIds() {
    var customerIds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var projectsMap = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var map = {};
    customerIds.forEach(function (cId) {
        map[cId] = 0;
    });

    Object.values(projectsMap).forEach(function (p) {
        var cId = p.customerId;
        if (map[cId] !== undefined) {
            map[cId] = map[cId] + 1;
        }
    });
    return map;
}

var getAssignedUsersCount = exports.getAssignedUsersCount = function getAssignedUsersCount(_ref2) {
    var userTeamAssignmentsData = _ref2.userTeamAssignmentsData,
        allUsers = _ref2.allUsers,
        isUGREnabled = _ref2.isUGREnabled;

    var ta = userTeamAssignmentsData;
    var userInAssignedGroups = isUGREnabled ? allUsers.filter(function (user) {
        return ta.assignedGroups.includes(user.userGroupId);
    }).length : 0;
    return ta.teamAssignmentType === _constants2.UserTeamAssignmentType.SELECTED ? ta.assignedUsers.length + userInAssignedGroups : 0;
};

var areRatesEqual = exports.areRatesEqual = function areRatesEqual(rates1, rates2) {
    if (rates1 === null && rates2 === null) return true;

    if (rates1.length !== rates2.length) return false;

    for (var i = 0; i < rates1.length; i++) {
        var rate1 = rates1[i];
        var rate2 = rates2[i];

        if (rate1.rateId !== rate2.rateId) return false;
        if (rate1.effectiveDate !== rate2.effectiveDate) return false;

        if ((rate1.regularRate || rate2.regularRate) && rate1.regularRate !== rate2.regularRate) return false;
        if ((rate1.overtimeRate || rate2.overtimeRate) && rate1.overtimeRate !== rate2.overtimeRate) return false;

        var leaveRates1 = rate1.leaveRates.filter(function (v) {
            return v.rate;
        }).sort(function (v1, v2) {
            return v1.leaveTypeId - v2.leaveTypeId;
        });
        var leaveRates2 = rate2.leaveRates.filter(function (v) {
            return v.rate;
        }).sort(function (v1, v2) {
            return v1.leaveTypeId - v2.leaveTypeId;
        });
        if (!_underscore2.default.isEqual(leaveRates1, leaveRates2)) return false;
    }

    return true;
};

/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getInitialDefaultWorkStatus = exports.getDefaultWorkStatusPlanningData = exports.getWorkStatuses = exports.selectWorkStatuses = undefined;

var _selector = __webpack_require__(255);

var _reselect = __webpack_require__(13);

var selectWorkStatuses = exports.selectWorkStatuses = function selectWorkStatuses(state) {
    return (0, _selector.selectUserPanel)(state).workStatuses;
};

var getWorkStatuses = exports.getWorkStatuses = (0, _reselect.createSelector)(selectWorkStatuses, function (workStatuses) {
    return workStatuses.workStatuses;
});

var getDefaultWorkStatusPlanningData = exports.getDefaultWorkStatusPlanningData = (0, _reselect.createSelector)(selectWorkStatuses, function (workStatuses) {
    return workStatuses.defaultWorkStatusPlanningData;
});
var getInitialDefaultWorkStatus = exports.getInitialDefaultWorkStatus = (0, _reselect.createSelector)(selectWorkStatuses, function (workStatuses) {
    return workStatuses.initialDefaultWorkStatus;
});

/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _AccountInformationSection = __webpack_require__(317);

var _AccountInformationSection2 = _interopRequireDefault(_AccountInformationSection);

var _atUtils = __webpack_require__(5);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _constants = __webpack_require__(4);

var _constants2 = __webpack_require__(21);

var _utils = __webpack_require__(25);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Created by filatov on 20.01.2016.
 */
var EditAccountInformationSection = function (_AccountInformationSe) {
    _inherits(EditAccountInformationSection, _AccountInformationSe);

    function EditAccountInformationSection() {
        _classCallCheck(this, EditAccountInformationSection);

        return _possibleConstructorReturn(this, (EditAccountInformationSection.__proto__ || Object.getPrototypeOf(EditAccountInformationSection)).apply(this, arguments));
    }

    return EditAccountInformationSection;
}(_AccountInformationSection2.default);

EditAccountInformationSection.prototype.init = function (_ref) {
    var _ref$lightBoxEl = _ref.lightBoxEl,
        lightBoxEl = _ref$lightBoxEl === undefined ? null : _ref$lightBoxEl,
        _ref$userManagementDa = _ref.userManagementData,
        userManagementData = _ref$userManagementDa === undefined ? null : _ref$userManagementDa,
        _ref$currentTime = _ref.currentTime,
        currentTime = _ref$currentTime === undefined ? null : _ref$currentTime,
        _ref$userId = _ref.userId,
        userId = _ref$userId === undefined ? null : _ref$userId,
        _ref$accountSettings = _ref.accountSettings,
        accountSettings = _ref$accountSettings === undefined ? null : _ref$accountSettings,
        _ref$changesCallback = _ref.changesCallback,
        changesCallback = _ref$changesCallback === undefined ? function () {} : _ref$changesCallback,
        _ref$validateCallback = _ref.validateCallback,
        validateCallback = _ref$validateCallback === undefined ? function () {} : _ref$validateCallback,
        _ref$checkUsernameErr = _ref.checkUsernameErrorHandler,
        checkUsernameErrorHandler = _ref$checkUsernameErr === undefined ? function () {} : _ref$checkUsernameErr,
        _ref$corporateSchedul = _ref.corporateSchedule,
        corporateSchedule = _ref$corporateSchedul === undefined ? null : _ref$corporateSchedul,
        _ref$userGroupsEnable = _ref.userGroupsEnabled,
        userGroupsEnabled = _ref$userGroupsEnable === undefined ? false : _ref$userGroupsEnable,
        _ref$timeZoneGroupsEn = _ref.timeZoneGroupsEnabled,
        timeZoneGroupsEnabled = _ref$timeZoneGroupsEn === undefined ? false : _ref$timeZoneGroupsEn,
        _ref$firstTTDate = _ref.firstTTDate,
        firstTTDate = _ref$firstTTDate === undefined ? null : _ref$firstTTDate,
        _ref$firstLeaveReques = _ref.firstLeaveRequestDate,
        firstLeaveRequestDate = _ref$firstLeaveReques === undefined ? null : _ref$firstLeaveReques,
        _ref$editedUserIsSelf = _ref.editedUserIsSelf,
        editedUserIsSelf = _ref$editedUserIsSelf === undefined ? false : _ref$editedUserIsSelf,
        _ref$handlerIfNoSuchU = _ref.handlerIfNoSuchUserAfterAjax,
        handlerIfNoSuchUserAfterAjax = _ref$handlerIfNoSuchU === undefined ? function () {} : _ref$handlerIfNoSuchU,
        _ref$specificVersionD = _ref.specificVersionDrawerConstructor,
        specificVersionDrawerConstructor = _ref$specificVersionD === undefined ? function () {} : _ref$specificVersionD,
        _ref$disableDuplicate = _ref.disableDuplicateUsernameCheck,
        disableDuplicateUsernameCheck = _ref$disableDuplicate === undefined ? false : _ref$disableDuplicate,
        _ref$disableEmptyUser = _ref.disableEmptyUsernameCheck,
        disableEmptyUsernameCheck = _ref$disableEmptyUser === undefined ? false : _ref$disableEmptyUser,
        _ref$scrollableContai = _ref.scrollableContainerEl,
        scrollableContainerEl = _ref$scrollableContai === undefined ? null : _ref$scrollableContai,
        _ref$showGroupRows = _ref.showGroupRows,
        showGroupRows = _ref$showGroupRows === undefined ? false : _ref$showGroupRows,
        _ref$needValidation = _ref.needValidation,
        needValidation = _ref$needValidation === undefined ? true : _ref$needValidation,
        _ref$releaseDateLabel = _ref.releaseDateLabelEl,
        releaseDateLabelEl = _ref$releaseDateLabel === undefined ? null : _ref$releaseDateLabel,
        _ref$hireDateLabelEl = _ref.hireDateLabelEl,
        hireDateLabelEl = _ref$hireDateLabelEl === undefined ? null : _ref$hireDateLabelEl,
        _ref$hireAndReleaseDa = _ref.hireAndReleaseDatesEditable,
        hireAndReleaseDatesEditable = _ref$hireAndReleaseDa === undefined ? true : _ref$hireAndReleaseDa;

    _AccountInformationSection2.default.prototype.init.call(this, {
        lightBoxEl: lightBoxEl,
        userManagementData: userManagementData,
        currentTime: currentTime,
        userId: userId,
        accountSettings: accountSettings,
        changesCallback: changesCallback,
        validateCallback: validateCallback,
        checkUsernameErrorHandler: checkUsernameErrorHandler,
        corporateSchedule: corporateSchedule,
        userGroupsEnabled: userGroupsEnabled,
        timeZoneGroupsEnabled: timeZoneGroupsEnabled,
        firstTTDate: firstTTDate,
        firstLeaveRequestDate: firstLeaveRequestDate,
        editedUserIsSelf: editedUserIsSelf,
        handlerIfNoSuchUserAfterAjax: handlerIfNoSuchUserAfterAjax,
        specificVersionDrawerConstructor: specificVersionDrawerConstructor,
        disableDuplicateUsernameCheck: disableDuplicateUsernameCheck,
        disableEmptyUsernameCheck: disableEmptyUsernameCheck,
        scrollableContainerEl: scrollableContainerEl,
        showGroupRows: showGroupRows,
        needValidation: needValidation,
        hireDateLabelEl: hireDateLabelEl,
        hireAndReleaseDatesEditable: hireAndReleaseDatesEditable
    });
    this.releaseDateLabelEl = releaseDateLabelEl;
    this.initAndShowReleaseDate(accountSettings.releaseDate, userManagementData, hireAndReleaseDatesEditable);
    (0, _jquery2.default)(lightBoxEl).addClass("editMode");
    (0, _jquery2.default)(lightBoxEl).toggleClass("online", _constants.isOlVersion);
    (0, _jquery2.default)(lightBoxEl).toggleClass("downloadable", !_constants.isOlVersion);
    return this;
};

EditAccountInformationSection.prototype.initAndShowReleaseDate = function (releaseDate, userManagementData) {
    var editable = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

    var self = this;

    this.releaseDatePlaceholderEl = this.getElementBySubId("releaseDatePlaceholder");
    (0, _jquery2.default)(this.releaseDatePlaceholderEl).click(function (e) {
        return (0, _utils.setEventPreventHidingAllPanels)(e);
    });

    var parsedDate = _.isString(releaseDate) ? Date.parseJSONDate(releaseDate) : releaseDate;

    this.releaseDateSelector = this.createDateSelector(userManagementData, "releaseDate", this.releaseDatePlaceholderEl, releaseDate, this.corporateSchedule, function (event, date) {
        self.delReleaseDateBtn.style.display = editable && !!date ? "inline-block" : "none";
        (0, _jquery2.default)(self).trigger('releaseDateChanged', [self.getReleaseDate()]);
    }, editable);

    this.delReleaseDateBtn.style.display = editable && !!releaseDate ? "inline-block" : "none";
    this.delReleaseDateBtn.onclick = function () {
        self.releaseDateSelector.unsetValue();
        self.releaseDateSelector.fireEvent("change", this);
    };
    //hide read-only release date row in edit user panel if there is no release date
    (0, _jquery2.default)(this.getElementBySubId("releaseDate")).toggle(editable || !!releaseDate);

    this._setReleaseDateLabel(parsedDate);
};

EditAccountInformationSection.prototype.getReleaseDate = function () {
    return this.releaseDateSelector.getValue();
};

EditAccountInformationSection.prototype.setReleaseDate = function (date, editable) {
    this.delReleaseDateBtn.style.display = editable && !!date ? "inline-block" : "none";
    if (date === null) {
        return this.releaseDateSelector.unsetValue();
    }
    var parsedDate = _.isString(date) ? Date.parseJSONDate(date) : date;
    this._setReleaseDateLabel(parsedDate);
    return this.releaseDateSelector.setValue(parsedDate);
};

EditAccountInformationSection.prototype._setReleaseDateLabel = function (date) {
    if (!!date) this.releaseDateLabelEl.text(this.releaseDateSelector.formatDate(date));
};

EditAccountInformationSection.prototype._checkReleaseIsBeforeHireDate = function () {

    this.errors[_constants2.ValidationErrors.RELEASE_DATE_IS_BEFORE_HIRE_DATE] = false;

    if (this.getReleaseDate() && (0, _atUtils.compareDates)(this.getHireDate(), this.getReleaseDate()) > 0) {
        this.errors[_constants2.ValidationErrors.RELEASE_DATE_IS_BEFORE_HIRE_DATE] = true;
        return false;
    }

    return true;
};

EditAccountInformationSection.prototype.customValidate = function (oldErrors) {
    _jquery2.default.extend(this.errors, this.specificFieldsDrawerController.validateFields(oldErrors, this.checkEmpty));
    this._checkReleaseIsBeforeHireDate();
};

exports.default = EditAccountInformationSection;

/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _date_format = __webpack_require__(16);

var _key_down_handler = __webpack_require__(184);

var _key_down_handler2 = _interopRequireDefault(_key_down_handler);

var _atBrowserUtils = __webpack_require__(8);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _index = __webpack_require__(22);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _keyCodes = __webpack_require__(66);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var HireDateWarningDlg = function (_TemplateView) {
    _inherits(HireDateWarningDlg, _TemplateView);

    function HireDateWarningDlg($lightBoxEl, $scrollableLightboxContent, onConfirmCallback) {
        _classCallCheck(this, HireDateWarningDlg);

        var _this = _possibleConstructorReturn(this, (HireDateWarningDlg.__proto__ || Object.getPrototypeOf(HireDateWarningDlg)).call(this, $lightBoxEl));

        _this.id = $lightBoxEl.attr('id');
        _this.$lightBoxEl = $lightBoxEl;
        _this.$scrollableLightboxContent = $scrollableLightboxContent;
        _this.onConfirmCallback = onConfirmCallback;
        _this.isIE8 = (0, _atBrowserUtils.isIE8)();
        _this.$overlay = _this._createOverlayIfNeededAndGet($lightBoxEl);
        return _this;
    }

    _createClass(HireDateWarningDlg, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return "<div id='<%=id%>_hireDateChangedWarningId'></div>";
        }
    }, {
        key: '_createOverlayIfNeededAndGet',
        value: function _createOverlayIfNeededAndGet($element) {
            var $overlay = $element.find(".hireDateChangedOverlay");
            if ($overlay.length == 0) {
                $overlay = (0, _jquery2.default)("<div>").addClass("hireDateChangedOverlay");
                $overlay.css({ "display": "none", "position": "absolute", "top": 0, "height": "100%" });
                $overlay.width($element.width());
                $element.append($overlay);
            }
            return $overlay;
        }
    }, {
        key: 'close',
        value: function close(isConfirmed) {
            this.onConfirmCallback(isConfirmed);
            this.hide();
        }
    }, {
        key: 'showAt',
        value: function showAt(selector, warningMsgKey, dateFrom, dateTo) {
            var self = this;
            _key_down_handler2.default.setOnKeyDownHandler(_underscore2.default.bind(this._keydownHandler, this));
            this.$overlay.css("display", "");

            this.$lightBoxEl.off();
            this.$lightBoxEl.on("wheel", function (event) {
                (0, _atBrowserUtils.preventDefault)(event);
            }); // modern standard
            this.$lightBoxEl.on("mousewheel", function (event) {
                (0, _atBrowserUtils.preventDefault)(event);
            }); // older browsers, IE
            this.$lightBoxEl.on("touchmove", function (event) {
                (0, _atBrowserUtils.preventDefault)(event);
            }); // mobile
            this.$lightBoxEl.on("mousedown", function (event) {
                return self._preventMouseMiddleButtonPress(event);
            });

            this._renderWarningContent(this.$el, warningMsgKey, dateFrom, dateTo);

            this.$el.focus();
            this.$el.show();
            (0, _atBrowserUtils.showElementAt)(this.$el, { of: selector, my: "left top", at: "left bottom", offset: "10px 10px " });

            this.$el.toggleClass('pointerAtTop', this.$el.offset().top > selector.offset().top);
            this.$el.toggleClass('pointerAtBottom', this.$el.offset().top < selector.offset().top);

            if (this.isIE8) {
                this.$scrollableLightboxContent.css("overflow-y", "hidden");
            }
        }
    }, {
        key: 'hide',
        value: function hide() {
            _key_down_handler2.default.restoreOnKeyDownHandler();
            this.$overlay.css("display", "none");
            this.$lightBoxEl.off();
            this.$el.hide();

            if (this.isIE8) {
                this.$scrollableLightboxContent.css("overflow-y", "");
            }
        }
    }, {
        key: '_preventMouseMiddleButtonPress',
        value: function _preventMouseMiddleButtonPress(event) {
            if ((0, _atBrowserUtils.whichButtonPressed)(event) == "middle") {
                this.preventDefault(event);
                return false;
            }
            return true;
        }
    }, {
        key: '_renderWarningContent',
        value: function _renderWarningContent(warningDiv, warningMsgKey, fromDate, toDate) {
            warningDiv.empty();

            var balancesChangedMsg = (0, _index.isEnabled)(_index.Feature.PTO) && (0, _index.isEnabled)(_index.Feature.SDB) ? _messageResource2.default.getMessage("userlist.user_popup.hire_date_changed.balances") : "";

            warningDiv.append("<div class='warningMsgContainer'>" + "<div class='msgContent'><span class='warningMsg'>" + _messageResource2.default.getMessage(warningMsgKey, [new _date_format.DateFormat(window.SystemSettings.dateFormat).formatDate(fromDate), new _date_format.DateFormat(window.SystemSettings.dateFormat).formatDate(toDate)]).concat(balancesChangedMsg) + "</span></div> </div>");
            var footer = (0, _jquery2.default)("<div class='warningFooter'></div>");
            var confirmBtn = (0, _jquery2.default)("<button class='hireDateConfirmBtn'>" + _messageResource2.default.getMessage("common.ok") + "</button>");
            var cancelBtn = (0, _jquery2.default)("<button class='hireDateCancelBtn'>" + _messageResource2.default.getMessage("common.cancel") + "</button>");
            footer.append(confirmBtn);
            footer.append(cancelBtn);
            warningDiv.append(footer);

            confirmBtn.click(_underscore2.default.bind(HireDateWarningDlg.prototype.close, this, true));
            cancelBtn.click(_underscore2.default.bind(HireDateWarningDlg.prototype.close, this, false));
        }
    }, {
        key: '_keydownHandler',
        value: function _keydownHandler(event) {
            switch (event.keyCode) {
                case _keyCodes.KEY_CODE_ESC:
                    this.close(false);
                    break;
                case _keyCodes.KEY_CODE_ENTER:
                    this.close(true);
                    break;
            }
            (0, _atBrowserUtils.cancelBubble)(event);
            return false;
        }
    }]);

    return HireDateWarningDlg;
}(_TemplateView3.default);

exports.default = HireDateWarningDlg;
;

/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _AccountInformationSection = __webpack_require__(317);

var _AccountInformationSection2 = _interopRequireDefault(_AccountInformationSection);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _UserPanelContainer = __webpack_require__(149);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/*  CreateAccountInformationSection */
var CreateAccountInformationSection = function (_AccountInformationSe) {
    _inherits(CreateAccountInformationSection, _AccountInformationSe);

    function CreateAccountInformationSection() {
        _classCallCheck(this, CreateAccountInformationSection);

        return _possibleConstructorReturn(this, (CreateAccountInformationSection.__proto__ || Object.getPrototypeOf(CreateAccountInformationSection)).apply(this, arguments));
    }

    return CreateAccountInformationSection;
}(_AccountInformationSection2.default);

CreateAccountInformationSection.prototype.init = function (_ref) {
    var _ref$lightBoxEl = _ref.lightBoxEl,
        lightBoxEl = _ref$lightBoxEl === undefined ? null : _ref$lightBoxEl,
        _ref$userManagementDa = _ref.userManagementData,
        userManagementData = _ref$userManagementDa === undefined ? null : _ref$userManagementDa,
        _ref$currentTime = _ref.currentTime,
        currentTime = _ref$currentTime === undefined ? null : _ref$currentTime,
        _ref$userId = _ref.userId,
        userId = _ref$userId === undefined ? null : _ref$userId,
        _ref$accountSettings = _ref.accountSettings,
        accountSettings = _ref$accountSettings === undefined ? null : _ref$accountSettings,
        _ref$changesCallback = _ref.changesCallback,
        changesCallback = _ref$changesCallback === undefined ? function () {} : _ref$changesCallback,
        _ref$validateCallback = _ref.validateCallback,
        validateCallback = _ref$validateCallback === undefined ? function () {} : _ref$validateCallback,
        _ref$checkUsernameErr = _ref.checkUsernameErrorHandler,
        checkUsernameErrorHandler = _ref$checkUsernameErr === undefined ? function () {} : _ref$checkUsernameErr,
        _ref$corporateSchedul = _ref.corporateSchedule,
        corporateSchedule = _ref$corporateSchedul === undefined ? null : _ref$corporateSchedul,
        _ref$userGroupsEnable = _ref.userGroupsEnabled,
        userGroupsEnabled = _ref$userGroupsEnable === undefined ? false : _ref$userGroupsEnable,
        _ref$timeZoneGroupsEn = _ref.timeZoneGroupsEnabled,
        timeZoneGroupsEnabled = _ref$timeZoneGroupsEn === undefined ? false : _ref$timeZoneGroupsEn,
        _ref$firstTTDate = _ref.firstTTDate,
        firstTTDate = _ref$firstTTDate === undefined ? null : _ref$firstTTDate,
        _ref$firstLeaveReques = _ref.firstLeaveRequestDate,
        firstLeaveRequestDate = _ref$firstLeaveReques === undefined ? null : _ref$firstLeaveReques,
        _ref$editedUserIsSelf = _ref.editedUserIsSelf,
        editedUserIsSelf = _ref$editedUserIsSelf === undefined ? false : _ref$editedUserIsSelf,
        _ref$handlerIfNoSuchU = _ref.handlerIfNoSuchUserAfterAjax,
        handlerIfNoSuchUserAfterAjax = _ref$handlerIfNoSuchU === undefined ? function () {} : _ref$handlerIfNoSuchU,
        _ref$specificVersionD = _ref.specificVersionDrawerConstructor,
        specificVersionDrawerConstructor = _ref$specificVersionD === undefined ? function () {} : _ref$specificVersionD,
        _ref$disableDuplicate = _ref.disableDuplicateUsernameCheck,
        disableDuplicateUsernameCheck = _ref$disableDuplicate === undefined ? false : _ref$disableDuplicate,
        _ref$disableEmptyUser = _ref.disableEmptyUsernameCheck,
        disableEmptyUsernameCheck = _ref$disableEmptyUser === undefined ? false : _ref$disableEmptyUser,
        _ref$scrollableContai = _ref.scrollableContainerEl,
        scrollableContainerEl = _ref$scrollableContai === undefined ? null : _ref$scrollableContai,
        _ref$showGroupRows = _ref.showGroupRows,
        showGroupRows = _ref$showGroupRows === undefined ? false : _ref$showGroupRows,
        _ref$needValidation = _ref.needValidation,
        needValidation = _ref$needValidation === undefined ? true : _ref$needValidation,
        releaseDateLabelEl = _ref.releaseDateLabelEl,
        hireDateLabelEl = _ref.hireDateLabelEl;


    _AccountInformationSection2.default.prototype.init.call(this, {
        lightBoxEl: lightBoxEl,
        userManagementData: userManagementData,
        currentTime: currentTime,
        userId: userId,
        accountSettings: accountSettings,
        changesCallback: changesCallback,
        validateCallback: validateCallback,
        checkUsernameErrorHandler: checkUsernameErrorHandler,
        corporateSchedule: corporateSchedule,
        userGroupsEnabled: userGroupsEnabled,
        timeZoneGroupsEnabled: timeZoneGroupsEnabled,
        firstTTDate: firstTTDate,
        firstLeaveRequestDate: firstLeaveRequestDate,
        editedUserIsSelf: editedUserIsSelf,
        handlerIfNoSuchUserAfterAjax: handlerIfNoSuchUserAfterAjax,
        specificVersionDrawerConstructor: specificVersionDrawerConstructor,
        disableDuplicateUsernameCheck: disableDuplicateUsernameCheck,
        disableEmptyUsernameCheck: disableEmptyUsernameCheck,
        scrollableContainerEl: scrollableContainerEl,
        showGroupRows: showGroupRows,
        needValidation: needValidation,
        hireDateLabelEl: hireDateLabelEl,
        mode: _UserPanelContainer.MODE.CREATE
    });
    (0, _jquery2.default)(this.getElementBySubId("releaseDate")).hide();
    return this;
};

exports.default = CreateAccountInformationSection;

/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _UserPanelModalAlert = __webpack_require__(209);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _constants = __webpack_require__(110);

var _constants2 = __webpack_require__(21);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EffectiveDateCell = function (_TemplateView) {
    _inherits(EffectiveDateCell, _TemplateView);

    function EffectiveDateCell(_ref) {
        var dateFromLabel = _ref.dateFromLabel,
            readOnly = _ref.readOnly,
            scrollTo = _ref.scrollTo,
            _ref$onChangeCb = _ref.onChangeCb,
            onChangeCb = _ref$onChangeCb === undefined ? function () {} : _ref$onChangeCb,
            _ref$rollbackChanges = _ref.rollbackChanges,
            rollbackChanges = _ref$rollbackChanges === undefined ? function () {} : _ref$rollbackChanges,
            _ref$subscribeSelecto = _ref.subscribeSelectorOnScroll,
            subscribeSelectorOnScroll = _ref$subscribeSelecto === undefined ? function () {} : _ref$subscribeSelecto;

        _classCallCheck(this, EffectiveDateCell);

        var _this = _possibleConstructorReturn(this, (EffectiveDateCell.__proto__ || Object.getPrototypeOf(EffectiveDateCell)).call(this));

        _this.params = {
            dateFromLabel: dateFromLabel,
            scrollTo: scrollTo,
            readOnly: readOnly
        };

        _this.callbacks = {
            onChangeCb: onChangeCb,
            rollbackChanges: rollbackChanges,
            subscribeSelectorOnScroll: subscribeSelectorOnScroll
        };

        _this.state = {
            invertedDays: {},
            weekStartDay: 0,
            defaultWorkSchedule: [],
            date: null,
            effective: false,
            needShowWarning: false,
            error: null
        };

        _this.onStateChanged(function () {
            return _this._update();
        });

        _this.onStatePropertyChanged('error', function (error) {
            return _this._updateError(error);
        });
        _this.onStatePropertyBecameTrue('needShowWarning', function () {
            return _this._showDuplicateWarning();
        });
        return _this;
    }

    _createClass(EffectiveDateCell, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class="effectiveDateCellContent">' + '    <div class="dateSelectorPlaceholder">' + '        <div class="dateFromLabel"><%=dateFromLabel%></div>' + '        <div class="dateSelector atNextMount"/>' + '        <div class="dateLabel"></div>' + '    </div>' + '    <div class="currentLabel"><%=currentLabel%></div>' + '</div>';
        }
    }, {
        key: 'templateModel',
        value: function templateModel() {
            return {
                dateFromLabel: this.params.dateFromLabel
            };
        }
    }, {
        key: 'messageKeys',
        value: function messageKeys() {
            return {
                currentLabel: 'user.add_edit.js.wd_editor.working_schedule_current'
            };
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            var _this2 = this;

            this.$dateSelector = this.find('.dateSelector');
            this.$currentLabel = this.find('.currentLabel');
            this.$dateLabel = this.find('.dateLabel');

            var date = this.state.date ? this.state.date.parseJSONDate() : null;

            this.dateSelector = window.ClassicBridge.integrateCalendar(this.$dateSelector[0], {
                onSelect: function onSelect(date) {
                    _this2.callbacks.onChangeCb(Date.parseJSONDate(date).toJSON());
                    _this2.dateSelector.setProps({ selectedDay: date });
                },
                selectedDay: date,
                placeholder: !date && _messageResource2.default.getMessage("common.date_selector.select_date"),
                type: 'day',
                compactDate: true
            });
        }
    }, {
        key: 'hideSelector',
        value: function hideSelector() {}
    }, {
        key: '_update',
        value: function _update() {
            this.$currentLabel.toggle(this.state.effective);
            this.$dateLabel.toggle(this.params.readOnly);

            var date = this.state.date ? this.state.date.parseJSONDate() : null;
            var format = Date.convertSmartToExtDateFormat(window.SystemSettings.dateFormat).replace(/F/, "M");

            this.dateSelector.setProps({
                selectedDay: date,
                placeholder: !date && _messageResource2.default.getMessage("common.date_selector.select_date")
            });

            if (this.params.readOnly) {
                if (!!date) this.$dateLabel.text(date.format(format));
                return;
            }
        }
    }, {
        key: '_updateError',
        value: function _updateError(error) {
            this.getEl().toggleClass('invalid', error !== null);

            if (error) {
                this.dateSelector.setProps({ triggerClassName: "error" });
            } else {
                this.dateSelector.setProps({ triggerClassName: "" });
            }

            if (error === _constants2.ValidationErrors.DUPLICATED_EFFECTIVE_DATE) this.$dateSelector.attr('title', _messageResource2.default.getMessage('rates.errors.duplicate_date'));
        }
    }, {
        key: '_showDuplicateWarning',
        value: function _showDuplicateWarning() {
            var _this3 = this;

            var msg = _messageResource2.default.getMessage('rates.editor.work_schedule.duplicate_date') + '\n' + _messageResource2.default.getMessage('rates.editor.modifications_will_be_discarded');

            this.params.scrollTo(this.$dateSelector);

            (0, _UserPanelModalAlert.getInstance)().setState({
                text: msg,
                pointerPosition: _constants.ModalAlertPointerPosition.LEFT
            }).showAt(this.$dateSelector, function () {
                _this3.callbacks.rollbackChanges();
            });
        }
    }]);

    return EffectiveDateCell;
}(_TemplateView3.default);

exports.default = EffectiveDateCell;

/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DeleteConfirmationCell = function (_TemplateView) {
    _inherits(DeleteConfirmationCell, _TemplateView);

    function DeleteConfirmationCell(_ref) {
        var deleteMessageKey = _ref.deleteMessageKey,
            _ref$onConfirm = _ref.onConfirm,
            onConfirm = _ref$onConfirm === undefined ? function () {} : _ref$onConfirm,
            _ref$onCancel = _ref.onCancel,
            onCancel = _ref$onCancel === undefined ? function () {} : _ref$onCancel;

        _classCallCheck(this, DeleteConfirmationCell);

        var _this = _possibleConstructorReturn(this, (DeleteConfirmationCell.__proto__ || Object.getPrototypeOf(DeleteConfirmationCell)).call(this));

        _this.deleteMessageKey = deleteMessageKey;

        _this.params = {
            onConfirm: onConfirm,
            onCancel: onCancel
        };
        return _this;
    }

    _createClass(DeleteConfirmationCell, [{
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='deleteConfirmationRow'>" + "    <div class='messageWrapper'><span class='message'><%=message%></span></div>" + "    <div class='confirmBtn'><button><%=confirm%></button></div>" + "    <div class='cancelBtn'><%=cancel%></div>" + "</div>";
        }
    }, {
        key: "messageKeys",
        value: function messageKeys() {
            return {
                message: this.deleteMessageKey,
                confirm: "common.delete_confirm",
                cancel: "common.cancel"
            };
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            var _this2 = this;

            this.find('.confirmBtn').click(function (e) {
                e.stopPropagation();
                _this2.params.onConfirm();
            });
            this.find('.cancelBtn').click(function (e) {
                e.stopPropagation();
                _this2.params.onCancel();
            });
        }
    }]);

    return DeleteConfirmationCell;
}(_TemplateView3.default);

exports.default = DeleteConfirmationCell;

/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var getEffectiveDate = exports.getEffectiveDate = function getEffectiveDate(strDates, currentDateStr) {
    var datesSorted = strDates.filter(function (date) {
        return date !== null;
    }).sort(function (d1, d2) {
        return d1.parseJSONDate() - d2.parseJSONDate();
    });

    var effectiveDateIndex = _.findLastIndex(datesSorted, function (d) {
        return d <= currentDateStr;
    });
    return effectiveDateIndex > -1 ? datesSorted[effectiveDateIndex] : null;
};

/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.UserRatesTable = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _TableHeader = __webpack_require__(1656);

var _TableHeader2 = _interopRequireDefault(_TableHeader);

var _UserRatesRow = __webpack_require__(1657);

var _UserRatesRow2 = _interopRequireDefault(_UserRatesRow);

var _constants = __webpack_require__(4);

var _utils = __webpack_require__(873);

var _constants2 = __webpack_require__(206);

var _LeaveRatesMenu = __webpack_require__(1661);

var _LeaveRatesMenu2 = _interopRequireDefault(_LeaveRatesMenu);

var _number_formatter = __webpack_require__(61);

var _number_formatter2 = _interopRequireDefault(_number_formatter);

var _FloatNumberValidator = __webpack_require__(314);

var _FloatNumberValidator2 = _interopRequireDefault(_FloatNumberValidator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UserRatesTable = exports.UserRatesTable = function (_TemplateView) {
    _inherits(UserRatesTable, _TemplateView);

    function UserRatesTable(_ref) {
        var readOnly = _ref.readOnly,
            _ref$editMode = _ref.editMode,
            editMode = _ref$editMode === undefined ? true : _ref$editMode,
            _ref$scrollTo = _ref.scrollTo,
            scrollTo = _ref$scrollTo === undefined ? function () {} : _ref$scrollTo,
            _ref$updateUserRates = _ref.updateUserRates,
            updateUserRates = _ref$updateUserRates === undefined ? function () {} : _ref$updateUserRates,
            _ref$deleteUserRate = _ref.deleteUserRate,
            deleteUserRate = _ref$deleteUserRate === undefined ? function () {} : _ref$deleteUserRate,
            _ref$addNewUserRate = _ref.addNewUserRate,
            addNewUserRate = _ref$addNewUserRate === undefined ? function () {} : _ref$addNewUserRate,
            _ref$rollbackLastEdit = _ref.rollbackLastEditedUserRateChanges,
            rollbackLastEditedUserRateChanges = _ref$rollbackLastEdit === undefined ? function () {} : _ref$rollbackLastEdit,
            _ref$refreshScrollCb = _ref.refreshScrollCb,
            refreshScrollCb = _ref$refreshScrollCb === undefined ? function () {} : _ref$refreshScrollCb,
            _ref$subscribeSelecto = _ref.subscribeSelectorOnScroll,
            subscribeSelectorOnScroll = _ref$subscribeSelecto === undefined ? function () {} : _ref$subscribeSelecto;

        _classCallCheck(this, UserRatesTable);

        var _this = _possibleConstructorReturn(this, (UserRatesTable.__proto__ || Object.getPrototypeOf(UserRatesTable)).call(this));

        _this.params = {
            readOnly: readOnly,
            editMode: editMode,
            scrollTo: scrollTo
        };

        _this.actions = {
            updateUserRates: updateUserRates,
            deleteUserRate: deleteUserRate,
            addNewUserRate: addNewUserRate,
            rollbackLastEditedUserRateChanges: rollbackLastEditedUserRateChanges,
            refreshScrollCb: refreshScrollCb,
            subscribeSelectorOnScroll: subscribeSelectorOnScroll
        };

        _this.state = {
            userManagementData: {
                defaultWorkSchedule: [],
                currentDate: new Date().toJSON(),
                weekStartDay: 0,
                invertedDays: {},
                decimalSeparator: null,
                activeLeaveTypes: [],
                overtimeRateCoefficient: 0
            },

            userRates: [],
            overtimeLevel: 0,
            errors: {},

            ovrFeatureEnabled: false,
            lvtFeatureEnabled: false,

            readOnly: _this.params.readOnly
        };

        _this.onAnyStatePropertyDeeplyChanged(['userManagementData', 'userRates', 'overtimeLevel', 'ovrFeatureEnabled', 'lvtFeatureEnabled', 'readOnly'], function (state, prevState) {
            return _this._update(state, prevState);
        });

        _this.onStatePropertyDeeplyChanged('errors', function (errors) {
            return _this._updateErrors(errors);
        });
        return _this;
    }

    _createClass(UserRatesTable, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class="userRatesTable">' + '    <div class="tableHeader"/>' + '    <div class="userRatesList"/>' + '    <div class="addRecordButtonPlaceholder">' + '        <div class="addRecordButton">' + '            <div class="icon"/>' + '            <span class="label"><%=addRecordButtonLabel%></span>' + '        </div>' + '    </div>' + '    <div class="notDefinedLabel"><%-costOfWorkRatesNotDefined%></div>' + '    <div class="leaveRatesMenuPlaceholder"/>' + '</div>';
        }
    }, {
        key: 'messageKeys',
        value: function messageKeys() {
            return {
                addRecordButtonLabel: 'user.add_edit.js.rates_editor.add_rates',
                costOfWorkRatesNotDefined: 'user.edit.js.rates_editor.cost_of_work_rates_not_defined'
            };
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            var _this2 = this;

            this.tableHeader = new _TableHeader2.default().init(this.find('.tableHeader'));

            this.$userRatesList = this.find('.userRatesList');

            this.find('.addRecordButton').click(function () {
                return _this2.actions.addNewUserRate();
            });

            this.$leaveRatesMenuPlaceholder = this.find('.leaveRatesMenuPlaceholder');
        }
    }, {
        key: '_updateLeaveRatesMenu',
        value: function _updateLeaveRatesMenu(state, prevState) {
            if (this.state.lvtFeatureEnabled && state.userManagementData.activeLeaveTypes.length > 0) {
                if (!_underscore2.default.isEqual(state.userManagementData.activeLeaveTypes, prevState.userManagementData && prevState.userManagementData.activeLeaveTypes)) {
                    this.$leaveRatesMenuPlaceholder.empty();

                    this.leaveRatesMenu = new _LeaveRatesMenu2.default({
                        activeLeaveTypes: this.state.userManagementData.activeLeaveTypes,
                        numberFormatter: new _number_formatter2.default(window.SystemSettings.decimalSeparator, window.SystemSettings.digitGroupingSymbol, 4, false, undefined, undefined, undefined, 2),
                        floatNumberValidator: new _FloatNumberValidator2.default(window.SystemSettings.decimalSeparator),
                        maxRate: _constants.MAX_RATE,
                        parentEl: this.$leaveRatesMenuPlaceholder[0]
                    });
                }
            } else {
                this.$leaveRatesMenuPlaceholder.empty();
            }
        }
    }, {
        key: '_update',
        value: function _update(state, prevState) {
            var _this3 = this;

            this.$el.toggleClass('empty', this.state.userRates.length === 0);

            this.tableHeader.setState({
                showOvertime: this.state.ovrFeatureEnabled && this.state.overtimeLevel !== _constants.UserManagementConstants.OVERTIME_OFF,
                showLeave: this.state.lvtFeatureEnabled && this.state.userManagementData.activeLeaveTypes.length > 0
            });

            this._updateLeaveRatesMenu(state, prevState);

            this.$userRatesList.empty();
            this.find('.addRecordButton').toggle(!this.state.readOnly);
            this.find('.tableHeader').toggle(this.state.userRates.length !== 0);

            if (this.state.userRates.length === 0 && this.params.editMode && this.state.readOnly) {
                this.find('.notDefinedLabel').show();
                return;
            } else {
                this.find('.notDefinedLabel').hide();
            }

            this.rateRows = {};

            this.state.userRates.forEach(function (rate, index) {
                var rateRow = new _UserRatesRow2.default({
                    readOnly: _this3.state.readOnly,
                    scrollTo: _this3.params.scrollTo,
                    activeLeaveTypes: _this3.state.userManagementData.activeLeaveTypes,
                    onChangeCb: function onChangeCb(rate) {
                        return _this3.actions.updateUserRates({ index: index, rate: rate });
                    },
                    onDeleteCb: function onDeleteCb(_ref2) {
                        var removePermanently = _ref2.removePermanently;
                        return _this3.actions.deleteUserRate({ rateId: rate.rateId, index: index, removePermanently: removePermanently });
                    },
                    rollbackLastEditedUserRateChanges: function rollbackLastEditedUserRateChanges() {
                        return _this3.actions.rollbackLastEditedUserRateChanges();
                    },
                    subscribeSelectorOnScroll: _this3.actions.subscribeSelectorOnScroll,
                    leaveRatesMenu: _this3.leaveRatesMenu
                }).init(_this3.$userRatesList);

                rateRow.setState({
                    rate: rate,
                    overtimeEnabled: _this3.state.ovrFeatureEnabled && _this3.state.overtimeLevel !== _constants.UserManagementConstants.OVERTIME_OFF,
                    leavesEnabled: _this3.state.lvtFeatureEnabled,
                    activeLeaveTypes: _this3.state.userManagementData.activeLeaveTypes,
                    overtimeRateCoefficient: _this3.state.userManagementData.overtimeRateCoefficient,
                    defaultWorkSchedule: _this3.state.userManagementData.defaultWorkSchedule,
                    currentDate: _this3.state.userManagementData.currentDate,
                    weekStartDay: _this3.state.userManagementData.weekStartDay,
                    invertedDays: _this3.state.userManagementData.invertedDaysMap,
                    decimalSeparator: _this3.state.userManagementData.decimalSeparator
                });

                _this3.rateRows[index] = rateRow;
            });

            this._updateErrors(this.state.errors);

            this.actions.refreshScrollCb();
        }
    }, {
        key: '_updateErrors',
        value: function _updateErrors(errors) {
            var _this4 = this;

            this.state.userRates.forEach(function (rate, index) {
                _this4.rateRows[index].setState({
                    error: errors[index] ? errors[index] : {}
                });
            });

            this._updateEffectiveRate();
        }
    }, {
        key: '_updateEffectiveRate',
        value: function _updateEffectiveRate() {
            var _this5 = this;

            var errors = this.state.errors;

            var effectiveDate = (0, _utils.getEffectiveDate)(this.state.userRates.map(function (rate) {
                return rate.effectiveDate;
            }), this.state.userManagementData.currentDate);

            this.state.userRates.forEach(function (rate, index) {
                _this5.rateRows[index].setState({
                    effective: rate.effectiveDate !== null && effectiveDate === rate.effectiveDate && (!errors[index] || errors[index].showWarning !== _constants2.ShowWarning.EFFECTIVE_DATE_WARNING)
                });
            });
        }
    }]);

    return UserRatesTable;
}(_TemplateView3.default);

/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DefaultWorkStatusesContainer = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _utils = __webpack_require__(6);

var _selectors = __webpack_require__(867);

var _redux = __webpack_require__(7);

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _ClassicBridge = __webpack_require__(18);

var _ClassicBridge2 = _interopRequireDefault(_ClassicBridge);

var _utils2 = __webpack_require__(25);

var _UserPanelContainer = __webpack_require__(149);

var _actions = __webpack_require__(554);

var _selectors2 = __webpack_require__(64);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DefaultWorkStatusesContainer = exports.DefaultWorkStatusesContainer = function (_TemplateView) {
    _inherits(DefaultWorkStatusesContainer, _TemplateView);

    function DefaultWorkStatusesContainer(_ref) {
        var _ref$additionalClass = _ref.additionalClass,
            additionalClass = _ref$additionalClass === undefined ? '' : _ref$additionalClass,
            _ref$workStatuses = _ref.workStatuses,
            workStatuses = _ref$workStatuses === undefined ? [] : _ref$workStatuses,
            _ref$refreshScrollCb = _ref.refreshScrollCb,
            refreshScrollCb = _ref$refreshScrollCb === undefined ? function () {} : _ref$refreshScrollCb,
            mode = _ref.mode,
            _ref$defaultWorkStatu = _ref.defaultWorkStatusPlanningData,
            defaultWorkStatusPlanningData = _ref$defaultWorkStatu === undefined ? function () {} : _ref$defaultWorkStatu,
            _ref$onSetInitialDefa = _ref.onSetInitialDefaultWorkStatus,
            onSetInitialDefaultWorkStatus = _ref$onSetInitialDefa === undefined ? function () {} : _ref$onSetInitialDefa,
            _ref$onRemoteUpdate = _ref.onRemoteUpdate,
            _onRemoteUpdate = _ref$onRemoteUpdate === undefined ? function () {} : _ref$onRemoteUpdate;

        _classCallCheck(this, DefaultWorkStatusesContainer);

        var _this = _possibleConstructorReturn(this, (DefaultWorkStatusesContainer.__proto__ || Object.getPrototypeOf(DefaultWorkStatusesContainer)).call(this));

        _this.additionalClass = additionalClass;

        _this.isShown = true;
        _this.mode = mode;

        _this.state = {
            workStatuses: workStatuses,
            defaultWorkStatusPlanningData: defaultWorkStatusPlanningData
        };

        _this.onAnyStatePropertyChanged(['defaultWorkStatusPlanningData', 'workStatuses', 'initialDefaultWorkStatus'], function (_ref2) {
            var defaultWorkStatusPlanningData = _ref2.defaultWorkStatusPlanningData,
                initialDefaultWorkStatus = _ref2.initialDefaultWorkStatus,
                workStatuses = _ref2.workStatuses;

            _this.workStatusPlanning.setProps({
                intervals: defaultWorkStatusPlanningData.items,
                actions: defaultWorkStatusPlanningData.actions,
                interval: initialDefaultWorkStatus,
                workStatuses: workStatuses,
                onChange: refreshScrollCb,
                userId: _this.state.userData.userNextId,
                onInitialDefaultStatusChange: function onInitialDefaultStatusChange(newWorkStatusId) {
                    onSetInitialDefaultWorkStatus(_extends({}, initialDefaultWorkStatus, { workStatusId: newWorkStatusId }));
                },
                onRemoteUpdate: function onRemoteUpdate(intervals) {
                    _onRemoteUpdate(intervals);
                }
            });
        });
        return _this;
    }

    _createClass(DefaultWorkStatusesContainer, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return "<div class='workStatus'>" + " <div class='atNextWorkStatusPlanningMountPoint atNextMount'>" + "</div>";
        }
    }, {
        key: 'templateModel',
        value: function templateModel() {
            return {
                additionalClass: this.additionalClass
            };
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            var $defaultWorkStatusPlanningMountPoint = this.find(".atNextWorkStatusPlanningMountPoint");
            var integratedDefaultWorkStatusPlanningEl = this.mode === _UserPanelContainer.MODE.EDIT ? _ClassicBridge2.default.integrateDefaultWorkStatusPlanning($defaultWorkStatusPlanningMountPoint[0]) : _ClassicBridge2.default.integrateInitialDefaultWorkStatus($defaultWorkStatusPlanningMountPoint[0]);
            this.workStatusPlanning = integratedDefaultWorkStatusPlanningEl;
            $defaultWorkStatusPlanningMountPoint.click(function (e) {
                return (0, _utils2.setEventPreventHidingEditUserSlidingPanel)(e);
            });

            this.renderInitialState();
        }
    }, {
        key: 'onShow',
        value: function onShow() {
            _get(DefaultWorkStatusesContainer.prototype.__proto__ || Object.getPrototypeOf(DefaultWorkStatusesContainer.prototype), 'onShow', this).call(this);
            this.onShowCallback();
        }
    }]);

    return DefaultWorkStatusesContainer;
}(_TemplateView3.default);

exports.default = (0, _utils.connect)(function (state) {
    return {
        workStatuses: (0, _selectors.getWorkStatuses)(state),
        defaultWorkStatusPlanningData: (0, _selectors.getDefaultWorkStatusPlanningData)(state),
        initialDefaultWorkStatus: (0, _selectors.getInitialDefaultWorkStatus)(state),
        userData: (0, _selectors2.getUserDataState)(state)
    };
}, function (dispatch) {
    return {
        onShowCallback: (0, _redux.bindActionCreators)(function () {}, dispatch),
        onSetInitialDefaultWorkStatus: (0, _redux.bindActionCreators)(_actions.setInitialDefaultWorkStatus, dispatch)
    };
})(DefaultWorkStatusesContainer);

/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _constants = __webpack_require__(261);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Counter = function (_TemplateView) {
    _inherits(Counter, _TemplateView);

    function Counter(_ref) {
        var _ref$hierarchyLevel = _ref.hierarchyLevel,
            hierarchyLevel = _ref$hierarchyLevel === undefined ? "" : _ref$hierarchyLevel;

        _classCallCheck(this, Counter);

        var _this = _possibleConstructorReturn(this, (Counter.__proto__ || Object.getPrototypeOf(Counter)).call(this));

        _this.props = {
            hierarchyLevel: hierarchyLevel
        };
        _this.state = {
            value: 0,
            pale: false
        };
        _this.onStateChanged(function () {
            return _this._updateCounter();
        });
        return _this;
    }

    _createClass(Counter, [{
        key: "_updateCounter",
        value: function _updateCounter() {
            this.$el.toggleClass("counterWithZeroElements", this.state.value === 0);
            this.$el.toggleClass("nonZeroCounter", this.state.value !== 0);
            this.$counterText.text(this.state.value);
            this.$el.toggleClass("paleCounter", this.state.pale);
        }
    }, {
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='components_cptCounter <%-hierarchyLevelClass%>'>" + "    <div class='counterText'></div>" + "</div>";
        }
    }, {
        key: "templateModel",
        value: function templateModel() {
            return {
                hierarchyLevelClass: _constants.HIERARCHY_LEVEL_CLASSES[this.props.hierarchyLevel]
            };
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            this.$counterText = this.find('.counterText');
        }
    }]);

    return Counter;
}(_TemplateView3.default);

exports.default = Counter;

/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _DropdownDialog = __webpack_require__(185);

var _DropdownDialog2 = _interopRequireDefault(_DropdownDialog);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _SpinnerController = __webpack_require__(69);

var _SpinnerController2 = _interopRequireDefault(_SpinnerController);

var _index = __webpack_require__(48);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function InvitationDialog() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$onContentClick = _ref.onContentClick,
        onContentClick = _ref$onContentClick === undefined ? function () {} : _ref$onContentClick;

    this._id = InvitationDialog._count++;
    this.onContentClick = onContentClick;
}

InvitationDialog._count = 0;

InvitationDialog.prototype.init = function (element, zIndex) {
    var _this = this;

    var self = this;
    this._content = (0, _jquery2.default)("<div>").addClass("invitationDialog");

    this._dialog = new _DropdownDialog2.default({
        wrapperClass: "invitationDialogWrapper invitationDialogWrapperId-" + this._id,
        dialogDiv: this._content,
        hideOnResize: true,
        isWithBeak: true,
        notModal: false,
        showEmptyTitleBar: false,
        closeOnEscape: false,
        zIndex: "number" == typeof zIndex ? zIndex : 1100,
        onOkClick: function onOkClick(event) {
            if (self._onOkClickCallback) self._onOkClickCallback(event);
        },
        onClose: function onClose(event) {
            if (self._onCancelClickCallback) self._onCancelClickCallback(event);
            if (self._removeKeyHandler) {
                self._removeKeyHandler();
            }
            self.hideAndRemove();
        }
    });

    this._wrapperElement = (0, _jquery2.default)(".invitationDialogWrapperId-" + this._id);
    this._wrapperElement.click(function (e) {
        return _this.onContentClick(e);
    });
    this._overlay = this._createOverlayElementIfNotExists(element);
    this._spinnerController = new _SpinnerController2.default();

    this._createSpinnerContainer();

    return this;
};

InvitationDialog.prototype.setContent = function (content) {
    this._content[0].innerHTML = content;
};

InvitationDialog.prototype.setWrappedContent = function (content) {
    this.setContent("<div class='invitationDialogContent'>" + content + "</div>");
};

InvitationDialog.prototype.show = function (element, positionParams, onOkClickCallback, onCancelClickCallback) {
    var _this2 = this;

    this._onOkClickCallback = onOkClickCallback;
    this._onCancelClickCallback = onCancelClickCallback;

    if (this._overlay) this._overlay.css("display", "");

    positionParams.collision = "none";
    this._dialog.showAt(element, positionParams);

    this._removeKeyHandler = _index.KEY_HANDLERS.onKeyDown(function (code) {
        if ((0, _index.isEsc)(code)) {
            _this2._dialog.hide();
            return true;
        }
    });

    var wrapper = this.getWrapperElement();
    wrapper.css("width", "auto");
};

InvitationDialog.prototype.hideAndRemove = function () {
    var _this3 = this;

    if (this._overlay) this._overlay.css("display", "none");
    this._dialog.hide();
    this._onOkClickCallback = null;
    this._onCancelClickCallback = null;
    this._content.remove();
    this._wrapperElement.click(function (e) {
        return _this3.onContentClick(e);
    });
};

InvitationDialog.prototype.getWrapperElement = function () {
    return this._wrapperElement;
};

InvitationDialog.prototype.showSpinner = function () {
    this._setButtonsDisableValue(true);
    this._spinnerController.spinInElement((0, _jquery2.default)("#spinnerContainerId-" + this._id));
};

InvitationDialog.prototype.hideSpinner = function () {
    this._setButtonsDisableValue(false);
    this._spinnerController.stop("spinnerContainerId-" + this._id);
};

InvitationDialog.prototype._setButtonsDisableValue = function (value) {
    this._wrapperElement.find(".ui-dialog-buttonset button").each(function () {
        this.disabled = value;
    });
};

InvitationDialog.prototype._createOverlayElementIfNotExists = function (element) {
    var overlay = element.find(".invitationDialogOverlay");
    if (overlay.length == 0) {
        overlay = (0, _jquery2.default)("<div>").addClass("invitationDialogOverlay");
        overlay.css({ "display": "none", "position": "absolute", "top": 0 });
        overlay.width(element.width());
        overlay.height(element.height());
        element.append(overlay);
    }
    return overlay;
};

InvitationDialog.prototype._createSpinnerContainer = function () {
    this._wrapperElement.find(".ui-dialog-buttonset").prepend((0, _jquery2.default)("<div id='spinnerContainerId-" + this._id + "'>"));
};

exports.default = InvitationDialog;

/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _constants = __webpack_require__(21);

var _AccountInformationSection = __webpack_require__(317);

var _AccountInformationSection2 = _interopRequireDefault(_AccountInformationSection);

var _atUtils = __webpack_require__(5);

var _constants2 = __webpack_require__(4);

var _TimeZonesSelector = __webpack_require__(355);

var _TimeZonesSelector2 = _interopRequireDefault(_TimeZonesSelector);

var _SimpleListMenuButton = __webpack_require__(187);

var _SimpleListMenuButton2 = _interopRequireDefault(_SimpleListMenuButton);

var _atBrowserUtils = __webpack_require__(8);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TimeZoneGroupRow = function (_TemplateView) {
    _inherits(TimeZoneGroupRow, _TemplateView);

    function TimeZoneGroupRow(_ref) {
        var _ref$showSaveButton = _ref.showSaveButton,
            showSaveButton = _ref$showSaveButton === undefined ? true : _ref$showSaveButton,
            _ref$createNewGroup = _ref.createNewGroup,
            createNewGroup = _ref$createNewGroup === undefined ? function () {} : _ref$createNewGroup,
            _ref$updateRowDate = _ref.updateRowDate,
            updateRowDate = _ref$updateRowDate === undefined ? function () {} : _ref$updateRowDate,
            _ref$onGroupChanged = _ref.onGroupChanged,
            onGroupChanged = _ref$onGroupChanged === undefined ? function (id) {} : _ref$onGroupChanged,
            _ref$resetGroup = _ref.resetGroup,
            resetGroup = _ref$resetGroup === undefined ? function () {} : _ref$resetGroup,
            _ref$validateTimeZone = _ref.validateTimeZoneGroup,
            validateTimeZoneGroup = _ref$validateTimeZone === undefined ? function () {} : _ref$validateTimeZone;

        _classCallCheck(this, TimeZoneGroupRow);

        var _this = _possibleConstructorReturn(this, (TimeZoneGroupRow.__proto__ || Object.getPrototypeOf(TimeZoneGroupRow)).call(this));

        _this._handleNewGroupInputKeyDown = function (e) {
            if ((0, _atBrowserUtils.isEscapePressed)(e) || (0, _atBrowserUtils.isEnterPressed)(e)) {
                _this.$newGroupInput.blur();
                e.stopPropagation();
            }
        };

        _this.params = {
            showSaveButton: showSaveButton,
            createNewGroup: createNewGroup,
            onGroupChanged: onGroupChanged,
            updateRowDate: updateRowDate,
            resetGroup: resetGroup,
            validateTimeZoneGroup: validateTimeZoneGroup
        };

        _this.state = {
            groupId: _constants2.USERS_WITHOUT_GROUP_ID,
            newGroupCreating: false,
            timeZoneGroups: [],
            timeZoneGroupsOffset: {},
            editable: false,
            errors: {}
        };

        _this.cityData = null;
        _this.tzSelector = null;
        _this.citySelector = null;

        _this.confirmCreating = false;
        _this.enableCreateButton = false;

        _this.onAnyStatePropertyDeeplyChanged(['timeZoneGroups', 'groupId', 'timeZoneGroupsOffset', 'editable'], function () {
            _this.$tzSelector.empty();
            _this.$tzSelectorContainer.toggle(_this.state.editable);
            _this.$tzLabel.toggle(!_this.state.editable);

            if (_this.state.editable) _this.selector = _this._createTZSelector(_this.state.timeZoneGroups, _this.state.groupId, _this.state.timeZoneGroupsOffset, _this.$tzSelector);
        });

        _this.onStatePropertyBecameValue('newGroupCreating', false, function () {
            if (_this.citySelector) _this.citySelector.resetToInit();

            _this.$newGroupInput.val("");
        });

        _this.onAnyStatePropertyChanged(['groupId', 'newGroupCreating'], function () {
            var id = _this.state.groupId;
            var creating = _this.state.newGroupCreating;

            if (creating && !_this.citySelector) {
                // Late init city selector - only when need to show it.
                // Can't init it on page load, because Google Services might not be loaded yet,
                // and the city selector won't attempt to re-initialize when they are finally loaded.
                _this.citySelector = _this._createCitySelector();
            }

            _this.$el.toggleClass('newGroupRow', creating);
            _this.$newGroupSection.toggle(creating);
            _this._setSelectedTimeZone(_this.state.newGroupCreating ? _constants.GROUP_NEW_OR_NOT_KNOWN : _this.state.groupId);

            //no need to disable the Create button in the newGroupCreating mode if the required fields for creating a new group are filled
            if (!id || creating && (!_this.cityData || _underscore2.default.isEmpty(_this.cityData.name) && !_this.cityData.cityPlaceId)) {
                _this._handleEnableCreateButton(false);

                //Set cityData to null for second group creation. Otherwise last created group data will be used silently
                //Exclude case, when we have DUPLICATE_TIME_ZONE_GROUP exception from server, and need to work with previous data
                if (!_this.state.errors[_constants.ValidationErrors.DUPLICATE_TIME_ZONE_GROUP]) {
                    _this.cityData = null;
                }
                return;
            }

            _this.confirmCreating = false;
        });

        _this.onStatePropertyChanged('errors', function (errors) {
            var duplicate = !!errors[_constants.ValidationErrors.DUPLICATE_TIME_ZONE_GROUP];
            var emptyCity = !!errors[_constants.ValidationErrors.CITY_DATA_EMPTY];
            var emptyName = !!errors[_constants.ValidationErrors.NEW_TIME_ZONE_GROUP_EMPTY];

            _this.$errorDuplicate.toggle(duplicate);
            _this.$tzSelector.toggleClass('invalid', duplicate);

            _this.$error_empty_new_time_zone.toggle(emptyCity || emptyName);

            _this.$citySelector.toggleClass('invalid', emptyCity);
            _this.$newGroupInput.toggleClass('invalid', emptyName || duplicate);

            var haveAnyError = duplicate || emptyCity || emptyName;

            if (haveAnyError) _this._handleEnableCreateButton(false);

            if (haveAnyError) {
                _this.params.updateRowDate({
                    newGroupCreating: true
                });
            } else if (_this.confirmCreating) {
                if (!haveAnyError) {
                    _this.params.updateRowDate({
                        newGroupCreating: false
                    });
                }
            }
        });
        return _this;
    }

    _createClass(TimeZoneGroupRow, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return "<div class='timeZoneGroupRow_userPanel userGroupData'>" + "  <div class='cellLabel'>" + "     <div class='label'>" + "       <%-label%>" + "     </div>:" + "  </div>" + "  <div class='timeZoneLabel'></div>" + "  <div class='timeZoneSelector selector'>" + "    <div class='timeZoneSelectorPlaceholder'/>" + "  </div>" + "  <div class='newGroupSection'>" + "    <div class='timeZoneCitySelector'>" + "      <div class='selector'>" + "    </div>" + "    <div class='newTimeZoneGroupName'>" + "       <input type='text' class='newTimeZoneGroupInput' name='newTimeZoneGroupName' maxlength='40'>" + "    </div>" + "    <div class='emptyError'><%-empty_new_time_zone_error%></div>" + "    <div class='duplicateError'><%-duplicate_error%></div>" + "    <div class='buttons'>" + "      <div class='saveButton'><%-save%></div>" + "      <div class='cancelButton'><%-cancel%></div>" + "    </div>" + "  </div>" + "</div>";
        }
    }, {
        key: 'templateModel',
        value: function templateModel() {
            return {
                label: _messageResource2.default.getMessage('userlist.userdata.account_section.time_zone_group'),
                empty_new_time_zone_error: _messageResource2.default.getMessage('user.add_edit.error.fields_cannot_be_empty'),
                duplicate_error: _messageResource2.default.getMessage('user.add_edit.error.duplicate_time_zone_group_name'),
                save: _messageResource2.default.getMessage('common.create'),
                cancel: _messageResource2.default.getMessage('common.cancel')
            };
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            var _this2 = this;

            this.$tzSelectorContainer = this.find(".selector");
            this.$tzSelector = this.find(".selector .timeZoneSelectorPlaceholder");
            this.$tzLabel = this.find(".timeZoneLabel");
            this.$citySelector = this.find(".timeZoneCitySelector .selector");
            this.$newGroupInput = this.find(".newTimeZoneGroupInput");
            this.$newGroupSection = this.find(".newGroupSection");

            this.$errorDuplicate = this.find(".newGroupSection  .duplicateError");
            this.$error_empty_new_time_zone = this.find(".newGroupSection .emptyError");

            if (this.params.showSaveButton) {
                this.$saveButton = this.find(".saveButton");
                this.$saveButton.click(function () {
                    if (_this2.enableCreateButton) {
                        var name = (0, _atUtils.trim)(_this2.$newGroupInput.pVal());
                        _this2.confirmCreating = true;
                        var newTZG = _this2._getNewTimeZoneGroup(_this2.cityData, name);
                        _this2.params.createNewGroup(newTZG);
                    }
                });

                this.find(".cancelButton").click(function () {
                    _this2.params.updateRowDate({
                        newGroupCreating: false
                    });

                    _this2.params.resetGroup();
                });
            } else {
                this.find(".buttons").hide();
            }

            this.$newGroupInput.blur(function () {
                var name = (0, _atUtils.trim)(_this2.$newGroupInput.pVal());
                var newTZG = _this2._getNewTimeZoneGroup(_this2.cityData, name);
                if (_this2.params.showSaveButton) {
                    _this2._handleEnableCreateButton(!!name);
                    _this2.params.validateTimeZoneGroup(_constants.GROUP_NEW_OR_NOT_KNOWN, newTZG);
                } else {
                    _this2.params.createNewGroup(newTZG);
                }
            });

            this.$newGroupInput.keydown(this._handleNewGroupInputKeyDown);

            this.$newGroupInput.attr("placeholder", _messageResource2.default.getMessage("user.add.js.time_zone_group_selector.new_time_zone_group_placeholder")).placeholder();

            this.renderInitialState();
        }
    }, {
        key: '_handleEnableCreateButton',
        value: function _handleEnableCreateButton(enable) {
            if (this.params.showSaveButton) {
                this.enableCreateButton = enable;
                this.$saveButton.toggleClass('disabled', !enable);
            }
        }
    }, {
        key: '_createTZSelector',
        value: function _createTZSelector(timeZoneGroups, selectedTimeZoneGroupId, offsets, renderTo) {
            var _this3 = this;

            var newTimeZoneGroupGroup = this._createNewOrNotKnownItem();
            var listItems = timeZoneGroups ? timeZoneGroups : [];

            var escapedListItems = listItems.map(function (item) {
                return { id: item.id, name: (0, _atUtils.escapeHtmlSymbols)(item.name), rawOffset: offsets[item.id] };
            });
            escapedListItems = [newTimeZoneGroupGroup].concat(escapedListItems);

            var selector = new _SimpleListMenuButton2.default({
                extraClass: 'components_userPanel_timeZoneGroupSelectorMenu',
                itemHtmlCallback: function itemHtmlCallback(item) {
                    return _this3._appendTimeZoneGroupRow(item);
                },
                onSelect: function onSelect(item) {
                    _this3.cityData = null;
                    _this3.params.updateRowDate({
                        newGroupCreating: item.id === _constants.GROUP_NEW_OR_NOT_KNOWN,
                        groupId: item.id
                    });
                    if (item.id !== _constants.GROUP_NEW_OR_NOT_KNOWN) {
                        _this3.params.onGroupChanged(item.id);
                    }
                },
                itemHeight: 30
            }).init(renderTo);

            var selectedItem = escapedListItems.find(function (item) {
                return item.id === selectedTimeZoneGroupId;
            });
            selector.setItems(escapedListItems, selectedItem || escapedListItems[0]);

            return selector;
        }
    }, {
        key: '_appendTimeZoneGroupRow',
        value: function _appendTimeZoneGroupRow(item) {
            return item.id === _constants.GROUP_NEW_OR_NOT_KNOWN ? '<span class="nameGroup">' + item.name + '</span>' : '<span class="nameGroup">' + item.name + '</span> <span class="offset">\n                                                    ' + _messageResource2.default.getMessage("time_zones_selector.js.gmt", [(0, _atUtils.formatRawSecondsOffset)(item.rawOffset)]) + '</span>';
        }
    }, {
        key: '_createCitySelector',
        value: function _createCitySelector() {
            var _this4 = this;

            return new _TimeZonesSelector2.default().init(this.$citySelector, null, function (data) {
                _this4._cityChanged(data);
            }, _messageResource2.default.getMessage('user.add.js.time_zone_group_selector.select_city_placeholder'), false, "userPopupSearch");
        }
    }, {
        key: '_createNewOrNotKnownItem',
        value: function _createNewOrNotKnownItem() {
            return {
                name: _messageResource2.default.getEscapedMessage("user.add.js.time_zone_group_selector.new_time_zone_group_item_title"),
                id: _AccountInformationSection2.default.GROUP_NEW_OR_NOT_KNOWN,
                rawOffset: undefined
            };
        }
    }, {
        key: '_cityChanged',
        value: function _cityChanged(data) {
            this.cityData = data;
            var name = (0, _atUtils.trim)(this.$newGroupInput.pVal());
            if (!name) {
                this.$newGroupInput.pVal(data.name);
            }

            var newTZG = this._getNewTimeZoneGroup(data, !name ? data.name : name);

            if (!this.params.showSaveButton) {
                this.params.createNewGroup(newTZG);
            } else {
                this._handleEnableCreateButton(true);
                this.params.validateTimeZoneGroup(_constants.GROUP_NEW_OR_NOT_KNOWN, newTZG);
            }
        }
    }, {
        key: '_setSelectedTimeZone',
        value: function _setSelectedTimeZone(id) {
            if (this.state.editable) this._setSelectorItem(id);else this._setSelectedTimeZoneLabel(id);
        }
    }, {
        key: '_setSelectorItem',
        value: function _setSelectorItem(id) {
            var item = void 0;
            if (id === _constants.GROUP_NEW_OR_NOT_KNOWN) {
                item = this._createNewOrNotKnownItem();
            } else {
                item = this.state.timeZoneGroups.find(function (item) {
                    return item.id === id;
                });
            }
            if (item) {
                this.selector.setSelectedItem({ id: item.id, name: (0, _atUtils.escapeHtmlSymbols)(item.name), rawOffset: this.state.timeZoneGroupsOffset[item.id] });
            }
        }
    }, {
        key: '_setSelectedTimeZoneLabel',
        value: function _setSelectedTimeZoneLabel(id) {
            var timeZone = this.state.timeZoneGroups.find(function (item) {
                return item.id === id;
            });
            if (!!timeZone) this.$tzLabel.text(timeZone.name);
        }
    }, {
        key: '_getNewTimeZoneGroup',
        value: function _getNewTimeZoneGroup(cityData, name) {
            return {
                id: _constants.GROUP_NEW_OR_NOT_KNOWN,
                name: name,
                cityPlaceId: cityData && cityData.placeId,
                cityName: cityData && cityData.name,
                timeZoneId: cityData && cityData.timeZoneId
            };
        }
    }]);

    return TimeZoneGroupRow;
}(_TemplateView3.default);

exports.default = TimeZoneGroupRow;

/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _constants = __webpack_require__(21);

var _AccountInformationSection = __webpack_require__(317);

var _AccountInformationSection2 = _interopRequireDefault(_AccountInformationSection);

var _atUtils = __webpack_require__(5);

var _constants2 = __webpack_require__(4);

var _SimpleListMenuButton = __webpack_require__(187);

var _SimpleListMenuButton2 = _interopRequireDefault(_SimpleListMenuButton);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _atBrowserUtils = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UserGroupRow = function (_TemplateView) {
    _inherits(UserGroupRow, _TemplateView);

    function UserGroupRow(_ref) {
        var _ref$showSaveButton = _ref.showSaveButton,
            showSaveButton = _ref$showSaveButton === undefined ? true : _ref$showSaveButton,
            _ref$createNewUserGro = _ref.createNewUserGroup,
            createNewUserGroup = _ref$createNewUserGro === undefined ? function () {} : _ref$createNewUserGro,
            _ref$updateRowDate = _ref.updateRowDate,
            updateRowDate = _ref$updateRowDate === undefined ? function () {} : _ref$updateRowDate,
            _ref$onGroupChanged = _ref.onGroupChanged,
            onGroupChanged = _ref$onGroupChanged === undefined ? function (id) {} : _ref$onGroupChanged,
            _ref$resetGroup = _ref.resetGroup,
            resetGroup = _ref$resetGroup === undefined ? function () {} : _ref$resetGroup;

        _classCallCheck(this, UserGroupRow);

        var _this = _possibleConstructorReturn(this, (UserGroupRow.__proto__ || Object.getPrototypeOf(UserGroupRow)).call(this));

        _this._handleNewGroupInputKeyDown = function (e) {
            if ((0, _atBrowserUtils.isEscapePressed)(e) || (0, _atBrowserUtils.isEnterPressed)(e)) {
                _this.$newGroupInput.blur();
                e.stopPropagation();
            }
        };

        _this.params = {
            showSaveButton: showSaveButton,
            createNewUserGroup: createNewUserGroup,
            onGroupChanged: onGroupChanged,
            resetGroup: resetGroup,
            updateRowDate: updateRowDate
        };

        _this.state = {
            groupId: _constants2.USERS_WITHOUT_GROUP_ID,
            userGroups: [],
            newGroupCreating: false,
            editable: false,
            errors: {}
        };

        _this.selector = null;
        _this.enableCreateButton = false;

        _this.onAnyStatePropertyDeeplyChanged(['userGroups', 'groupId', 'editable'], function () {
            _this.$selector.empty();
            _this.$selectorContainer.toggle(_this.state.editable);
            _this.$departmentLabel.toggle(!_this.state.editable);

            if (_this.state.editable) _this.selector = _this._createSelector(_this.state.userGroups, _this.state.groupId, _this.$selector);
        });

        _this.onStatePropertyBecameValue('newGroupCreating', false, function () {
            _this.$newGroupInput.val("");
        });

        _this.onAnyStatePropertyChanged(['groupId', 'newGroupCreating'], function () {
            var id = _this.state.groupId;
            var creating = _this.state.newGroupCreating;
            _this._setSelectedUserGroup(_this.state.newGroupCreating ? _constants.GROUP_NEW_OR_NOT_KNOWN : _this.state.groupId);

            _this.$newGroupSection.toggle(creating);

            //no need to disable the Create button in the newGroupCreating mode if the required fields for creating a new group are filled
            if (!id || creating && _underscore2.default.isEmpty((0, _atUtils.trim)(_this.$newGroupInput.pVal()))) {
                _this._handleEnableCreateButton(false);
            }
        });

        _this.onStatePropertyChanged('errors', function (errors) {
            var showEmptyError = !!errors[_constants.ValidationErrors.NEW_USER_GROUP_EMPTY];
            _this.$userGroupNameError.toggle(showEmptyError);
            _this.$newGroupInput.toggleClass('invalid', showEmptyError);

            if (showEmptyError) _this._handleEnableCreateButton(false);
        });
        return _this;
    }

    _createClass(UserGroupRow, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return "<div class='userGroupRow_userPanel'>" + "  <div class='cellLabel'>" + "     <div class='label'>" + "       <%-label%>" + "     </div>:" + "  </div>" + "  <div class='selector'>" + "    <div class='selectorPlaceholder'/>" + "  </div>" + "  <div class='departmentLabel'></div>" + "  <div class='newGroupSection'>" + "    <input type='text' class='newGroupInput' name='newUserGroupName' maxlength='40'>" + "    <div class='userGroupNameError'><%-empty_error%></div>" + "    <div class='buttons'>" + "      <div class='saveButton'><%-save%></div>" + "      <div class='cancelButton'><%-cancel%></div>" + "    </div>" + "  </div>" + "</div>";
        }
    }, {
        key: 'templateModel',
        value: function templateModel() {
            return {
                label: _messageResource2.default.getMessage('userlist.userdata.account_section.user_group'),
                empty_error: _messageResource2.default.getMessage('user.add_edit.error.name_empty'),
                save: _messageResource2.default.getMessage('common.create'),
                cancel: _messageResource2.default.getMessage('common.cancel')
            };
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            var _this2 = this;

            this.$selector = this.find(".selectorPlaceholder");
            this.$selectorContainer = this.find(".selector");
            this.$departmentLabel = this.find(".departmentLabel");
            this.$newGroupSection = this.find(".newGroupSection");
            this.$newGroupInput = this.find(".newGroupInput");
            this.$userGroupNameError = this.find('.userGroupNameError');

            if (this.params.showSaveButton) {
                this.$saveButton = this.find(".saveButton");
                this.$saveButton.click(function () {
                    if (_this2.enableCreateButton) {
                        var name = (0, _atUtils.trim)(_this2.$newGroupInput.pVal());
                        _this2.params.updateRowDate({
                            newGroupCreating: false
                        });
                        _this2.params.createNewUserGroup(name);
                    }
                });

                this.find(".cancelButton").click(function () {
                    _this2.params.updateRowDate({
                        newGroupCreating: false
                    });

                    _this2.params.resetGroup();
                });
            } else {
                this.find(".buttons").hide();
            }

            this.$newGroupInput.valueChanged(function () {
                _this2._onNewGroupChangeHandler();
            });

            this.$newGroupInput.keydown(this._handleNewGroupInputKeyDown);

            this.$newGroupInput.attr("placeholder", _messageResource2.default.getMessage("user.add.js.user_group_selector.new_user_group_place_holder")).placeholder();

            this.renderInitialState();
        }
    }, {
        key: '_onNewGroupChangeHandler',
        value: function _onNewGroupChangeHandler() {
            var name = (0, _atUtils.trim)(this.$newGroupInput.pVal());
            if (this.params.showSaveButton) {
                this._handleEnableCreateButton(!!name);
            } else {
                this.params.createNewUserGroup(name);
            }
        }
    }, {
        key: '_handleEnableCreateButton',
        value: function _handleEnableCreateButton(enable) {
            if (this.params.showSaveButton) {
                this.enableCreateButton = enable;
                this.$saveButton.toggleClass('disabled', !enable);
            }
        }
    }, {
        key: '_createSelector',
        value: function _createSelector(userGroups, selectedGroupId, renderTo) {
            var _this3 = this;

            var userGroupNotAssignedGroup = this._createNotAssignedUserGroup();

            var newUserGroupGroup = this._createNewGroupOrNotKnow();
            var listItems = [userGroupNotAssignedGroup, newUserGroupGroup].concat(userGroups ? userGroups : []);

            var escapedListItems = listItems.map(function (item) {
                return { id: item.id, name: (0, _atUtils.escapeHtmlSymbols)(item.name) };
            });

            var selector = new _SimpleListMenuButton2.default({
                extraClass: 'components_userGroupSelectorMenu',
                itemHtmlCallback: function itemHtmlCallback(item) {
                    return item.name;
                },
                onSelect: function onSelect(item) {
                    _this3.params.updateRowDate({
                        newGroupCreating: item.id === _constants.GROUP_NEW_OR_NOT_KNOWN,
                        groupId: item.id
                    });
                    if (item.id !== _constants.GROUP_NEW_OR_NOT_KNOWN) {
                        _this3.params.onGroupChanged(item.id);
                    }
                },
                itemHeight: 30
            }).init(renderTo);

            var selectedItem = escapedListItems.find(function (item) {
                return item.id === selectedGroupId;
            });
            selector.setItems(escapedListItems, selectedItem || escapedListItems[0]);

            return selector;
        }
    }, {
        key: '_createNotAssignedUserGroup',
        value: function _createNotAssignedUserGroup() {
            return {
                name: _messageResource2.default.getMessage("user.add.js.user_group_selector.user_group_not_selected_item_title"),
                id: _constants2.UserManagementConstants.USER_GROUP_NOT_ASSIGNED_ID
            };
        }
    }, {
        key: '_createNewGroupOrNotKnow',
        value: function _createNewGroupOrNotKnow() {
            return {
                name: _messageResource2.default.getMessage("user.add.js.user_group_selector.new_user_group_item_title"),
                id: _AccountInformationSection2.default.GROUP_NEW_OR_NOT_KNOWN
            };
        }
    }, {
        key: '_setSelectedUserGroup',
        value: function _setSelectedUserGroup(id) {
            if (this.state.editable) this._setSelectorItem(id);else this._setSelectedUserGroupLabel(id);
        }
    }, {
        key: '_setSelectorItem',
        value: function _setSelectorItem(id) {
            var item = void 0;
            if (id === _constants2.USERS_WITHOUT_GROUP_ID) {
                item = this._createNotAssignedUserGroup();
            } else if (id === _constants.GROUP_NEW_OR_NOT_KNOWN) {
                item = this._createNewGroupOrNotKnow();
            } else {
                item = this.state.userGroups.find(function (item) {
                    return item.id === id;
                });
            }
            if (item) {
                this.selector.setSelectedItem({ id: item.id, name: (0, _atUtils.escapeHtmlSymbols)(item.name) });
            }
        }
    }, {
        key: '_setSelectedUserGroupLabel',
        value: function _setSelectedUserGroupLabel(id) {
            var groupName = '';
            if (id === _constants2.USERS_WITHOUT_GROUP_ID) {
                groupName = _messageResource2.default.getMessage('user.js.user_group_selector.group_not_selected_label');
            } else {
                var userGroup = this.state.userGroups.find(function (item) {
                    return item.id === id;
                });
                if (!!userGroup) groupName = userGroup.name;
            }
            this.$departmentLabel.text(groupName);
        }
    }]);

    return UserGroupRow;
}(_TemplateView3.default);

exports.default = UserGroupRow;

/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.closeTeamAssignmentsPanel = exports.openTeamAssignmentsPanel = undefined;

var _actionTypes = __webpack_require__(695);

var ActionTypes = _interopRequireWildcard(_actionTypes);

var _utils = __webpack_require__(6);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var openTeamAssignmentsPanel = exports.openTeamAssignmentsPanel = function openTeamAssignmentsPanel() {
    return function (dispatch) {
        dispatch((0, _utils.createActionObject)(ActionTypes.SHOW_SET, true));
    };
};

var closeTeamAssignmentsPanel = exports.closeTeamAssignmentsPanel = function closeTeamAssignmentsPanel() {
    return function (dispatch) {
        dispatch((0, _utils.createActionObject)(ActionTypes.SHOW_SET, false));
    };
};

/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ManagementAssignmentsEditorPanel = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _utils = __webpack_require__(6);

var _selectors = __webpack_require__(552);

var _redux = __webpack_require__(7);

var _actions = __webpack_require__(258);

var _HierarchyAssignmentsEditorPanel = __webpack_require__(882);

var _HierarchyAssignmentsEditorPanel2 = _interopRequireDefault(_HierarchyAssignmentsEditorPanel);

var _ManagementAssignmentsEditor = __webpack_require__(883);

var _ManagementAssignmentsEditor2 = _interopRequireDefault(_ManagementAssignmentsEditor);

var _constants = __webpack_require__(62);

var _utils2 = __webpack_require__(25);

var _actions2 = __webpack_require__(50);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ManagementAssignmentsEditorPanel = exports.ManagementAssignmentsEditorPanel = function (_HierarchyAssignments) {
    _inherits(ManagementAssignmentsEditorPanel, _HierarchyAssignments);

    function ManagementAssignmentsEditorPanel(params) {
        _classCallCheck(this, ManagementAssignmentsEditorPanel);

        return _possibleConstructorReturn(this, (ManagementAssignmentsEditorPanel.__proto__ || Object.getPrototypeOf(ManagementAssignmentsEditorPanel)).call(this, _extends({
            hierarchyAssignmentsEditor: new _ManagementAssignmentsEditor2.default(),
            extraClass: 'userManagement_managementAssignmentsEditorPanel editUserAssignmentPanel',
            panelType: _constants.PANEL_TYPES.MANAGEMENT_ASSIGNMENTS_EDITOR,
            onClickContent: function onClickContent(e) {
                (0, _utils2.setEventPreventHidingEditUserSlidingPanel)(e);
                (0, _utils2.setEventPreventHidingManagementAssignmentsSlidingPanel)(e);
            }
        }, params)));
    }

    return ManagementAssignmentsEditorPanel;
}(_HierarchyAssignmentsEditorPanel2.default);

exports.default = (0, _utils.connect)(function (state) {
    return {
        show: (0, _selectors.showEditor)(state)
    };
}, function (dispatch) {
    return {
        closeEditor: (0, _redux.bindActionCreators)(_actions.closeEditor, dispatch),
        closeAllPanels: (0, _redux.bindActionCreators)(_actions2.closeAllPanels, dispatch)
    };
})(ManagementAssignmentsEditorPanel);

/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _View2 = __webpack_require__(20);

var _View3 = _interopRequireDefault(_View2);

var _PanelContainer = __webpack_require__(109);

var _PanelContainer2 = _interopRequireDefault(_PanelContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var HierarchyAssignmentsEditorPanel = function (_View) {
    _inherits(HierarchyAssignmentsEditorPanel, _View);

    function HierarchyAssignmentsEditorPanel(_ref) {
        var hierarchyAssignmentsEditor = _ref.hierarchyAssignmentsEditor,
            _ref$extraClass = _ref.extraClass,
            extraClass = _ref$extraClass === undefined ? '' : _ref$extraClass,
            _ref$panelType = _ref.panelType,
            panelType = _ref$panelType === undefined ? '' : _ref$panelType,
            _ref$closeEditor = _ref.closeEditor,
            closeEditor = _ref$closeEditor === undefined ? function () {} : _ref$closeEditor,
            _ref$onClickContent = _ref.onClickContent,
            onClickContent = _ref$onClickContent === undefined ? function (e) {} : _ref$onClickContent,
            _ref$closeAllPanels = _ref.closeAllPanels,
            closeAllPanels = _ref$closeAllPanels === undefined ? function () {} : _ref$closeAllPanels;

        _classCallCheck(this, HierarchyAssignmentsEditorPanel);

        var _this = _possibleConstructorReturn(this, (HierarchyAssignmentsEditorPanel.__proto__ || Object.getPrototypeOf(HierarchyAssignmentsEditorPanel)).call(this));

        _this.params = {
            hierarchyAssignmentsEditor: hierarchyAssignmentsEditor,
            extraClass: extraClass,
            panelType: panelType,
            onClickContent: onClickContent
        };

        _this.actions = {
            closeEditor: closeEditor,
            closeAllPanels: closeAllPanels
        };

        _this.state = {
            show: false
        };

        _this.onStatePropertyChanged('show', function (show) {
            _this.panelContainer.setState({
                isShown: show
            });
        });
        return _this;
    }

    _createClass(HierarchyAssignmentsEditorPanel, [{
        key: 'afterRender',
        value: function afterRender() {
            var _this2 = this;

            this.panelContainer = new _PanelContainer2.default({
                component: this.params.hierarchyAssignmentsEditor,
                additionalClass: 'userManagement_slidingPanel ' + this.params.extraClass,
                showAnimationClass: "anim-show-slide-left",
                hideAnimationClass: "anim-hide-slide-left",
                showHideButton: true,
                hideOnEsc: true,
                hideOnClickOutside: {
                    hideOnClick: true,
                    panelType: this.params.panelType
                },
                onShowCallback: function onShowCallback() {
                    _this2.params.hierarchyAssignmentsEditor.show();
                },
                onHideCallback: function onHideCallback() {
                    _this2.params.hierarchyAssignmentsEditor.hide();
                },
                onClickContentCallback: this.params.onClickContent,
                hideHandler: function hideHandler() {
                    return _this2.actions.closeEditor();
                },
                onClickCloseButton: function onClickCloseButton() {
                    return _this2.actions.closeAllPanels();
                }
            }).init(this.$containerEl);
        }
    }]);

    return HierarchyAssignmentsEditorPanel;
}(_View3.default);

exports.default = HierarchyAssignmentsEditorPanel;

/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ManagementAssignmentsEditor = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utils = __webpack_require__(6);

var _redux = __webpack_require__(7);

var _selectors = __webpack_require__(552);

var _actions = __webpack_require__(258);

var _HierarchyAssignmentsEditor = __webpack_require__(884);

var _HierarchyAssignmentsEditor2 = _interopRequireDefault(_HierarchyAssignmentsEditor);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _constants = __webpack_require__(4);

var _selectors2 = __webpack_require__(19);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ManagementAssignmentsEditor = exports.ManagementAssignmentsEditor = function (_HierarchyAssignments) {
    _inherits(ManagementAssignmentsEditor, _HierarchyAssignments);

    function ManagementAssignmentsEditor(params) {
        var _this;

        _classCallCheck(this, ManagementAssignmentsEditor);

        return _this = _possibleConstructorReturn(this, (ManagementAssignmentsEditor.__proto__ || Object.getPrototypeOf(ManagementAssignmentsEditor)).call(this, _extends({
            headerMessageKey: 'userlist.ma_editor.title',
            workAssignmentsVisible: false,
            managementAssignmentsEditable: true,
            showOnlyActiveSwitch: true,
            showAllExistingFuturesSwitcher: true,
            getAssignAllTextsMap: function getAssignAllTextsMap() {
                return _this._getAssignAllTextsMap();
            },
            getRevokeAllTextsMap: function getRevokeAllTextsMap() {
                return _this._getRevokeAllTextsMap();
            },
            getAssignTextsMap: function getAssignTextsMap() {
                return _this._getAssignTextsMap();
            },
            getRevokeTextsMap: function getRevokeTextsMap() {
                return _this._getRevokeTextsMap();
            }
        }, params)));
    }

    _createClass(ManagementAssignmentsEditor, [{
        key: '_getAssignAllTextsMap',
        value: function _getAssignAllTextsMap() {
            var _ref;

            return _ref = {}, _defineProperty(_ref, _constants.HierarchyLevels.CUSTOMER, _messageResource2.default.getMessage('userlist.ma_editor.customers.assign_all')), _defineProperty(_ref, _constants.HierarchyLevels.PROJECT, _messageResource2.default.getMessage('userlist.ma_editor.projects.assign_all')), _defineProperty(_ref, _constants.HierarchyLevels.TASK, _messageResource2.default.getMessage('userlist.ma_editor.tasks.assign_all')), _ref;
        }
    }, {
        key: '_getRevokeAllTextsMap',
        value: function _getRevokeAllTextsMap() {
            var _ref2;

            return _ref2 = {}, _defineProperty(_ref2, _constants.HierarchyLevels.CUSTOMER, _messageResource2.default.getMessage('userlist.ma_editor.customers.unassign_all')), _defineProperty(_ref2, _constants.HierarchyLevels.PROJECT, _messageResource2.default.getMessage('userlist.ma_editor.projects.unassign_all')), _defineProperty(_ref2, _constants.HierarchyLevels.TASK, _messageResource2.default.getMessage('userlist.ma_editor.tasks.unassign_all')), _ref2;
        }
    }, {
        key: '_getAssignTextsMap',
        value: function _getAssignTextsMap() {
            var _ref3;

            return _ref3 = {}, _defineProperty(_ref3, _constants.HierarchyLevels.CUSTOMER, _messageResource2.default.getMessage('userlist.ma_editor.revoke_menu.customer.grant')), _defineProperty(_ref3, _constants.HierarchyLevels.PROJECT, _messageResource2.default.getMessage('userlist.ma_editor.revoke_menu.project.grant')), _defineProperty(_ref3, _constants.HierarchyLevels.TASK, _messageResource2.default.getMessage('userlist.ma_editor.revoke_menu.task.grant')), _ref3;
        }
    }, {
        key: '_getRevokeTextsMap',
        value: function _getRevokeTextsMap() {
            var _ref4;

            return _ref4 = {}, _defineProperty(_ref4, _constants.HierarchyLevels.CUSTOMER, _messageResource2.default.getMessage('userlist.ma_editor.revoke_menu.customer.revoke')), _defineProperty(_ref4, _constants.HierarchyLevels.PROJECT, _messageResource2.default.getMessage('userlist.ma_editor.revoke_menu.project.revoke')), _defineProperty(_ref4, _constants.HierarchyLevels.TASK, _messageResource2.default.getMessage('userlist.ma_editor.revoke_menu.task.revoke')), _ref4;
        }
    }]);

    return ManagementAssignmentsEditor;
}(_HierarchyAssignmentsEditor2.default);

exports.default = (0, _utils.connect)(function (state) {
    return {
        viewerCanManageCustomerIds: (0, _selectors.getViewerCanManageCustomerIds)(state),
        viewerCanManageProjectIds: (0, _selectors.getViewerCanManageProjectIds)(state),
        user: (0, _selectors.getEditingUser)(state),
        customers: (0, _selectors.getCustomers)(state),
        projects: (0, _selectors.getProjects)(state),
        tasks: (0, _selectors.getTasks)(state),
        futureCustomersAssigned: (0, _selectors.areFutureCustomersAssigned)(state),
        futureProjectsAssigned: (0, _selectors.areFutureProjectsAssigned)(state),
        futureTasksAssigned: (0, _selectors.areFutureTasksAssigned)(state),
        someCustomersOrLowerAssigned: (0, _selectors.areSomeCustomersOrLowerAssigned)(state),
        someProjectsOrLowerAssigned: (0, _selectors.areSomeProjectsOrLowerAssigned)(state),
        someTasksAssigned: (0, _selectors.areSomeTasksAssigned)(state),
        allCustomersAssigned: (0, _selectors.areAllCustomersAssigned)(state),
        allProjectsAssigned: (0, _selectors.areAllProjectsAssigned)(state),
        allTasksAssigned: (0, _selectors.areAllTasksAssigned)(state),
        canWorkCustomerIds: (0, _selectors.getCanWorkCustomerIds)(state),
        canManageCustomerIds: (0, _selectors.getCanManageCustomerIds)(state),
        canManageCustomerExcludeSelfIds: (0, _selectors.getCanManageCustomerExcludeSelfIds)(state),
        canWorkProjectIds: (0, _selectors.getCanWorkProjectIds)(state),
        canManageProjectIds: (0, _selectors.getCanManageProjectIds)(state),
        canManageProjectExcludeSelfIds: (0, _selectors.getCanManageProjectExcludeSelfIds)(state),
        canWorkTaskIds: (0, _selectors.getCanWorkTaskIds)(state),
        canManageTaskIds: (0, _selectors.getCanManageTaskIds)(state),
        projectCountsByCustomers: (0, _selectors.getProjectCountsByCustomers)(state),
        taskCountsByCustomers: (0, _selectors.getTaskCountsByCustomers)(state),
        taskCountsByProjects: (0, _selectors.getTaskCountsByProjects)(state),
        selectedCustomer: (0, _selectors.getSelectedCustomer)(state),
        selectedProject: (0, _selectors.getSelectedProject)(state),
        loading: (0, _selectors.isLoading)(state),
        changingCustomerAssignments: (0, _selectors.getChangingCustomerAssignments)(state),
        changingProjectAssignments: (0, _selectors.getChangingProjectAssignments)(state),
        changingTaskAssignments: (0, _selectors.getChangingTaskAssignments)(state),
        changingAllAssignments: (0, _selectors.isChangingAllAssignments)(state),
        onlyActive: (0, _selectors.showOnlyActiveEntities)(state),
        customersSearchOpen: (0, _selectors.getCustomersSearchOpen)(state),
        customersSearchText: (0, _selectors.getCustomersSearchText)(state),
        projectsSearchOpen: (0, _selectors.getProjectsSearchOpen)(state),
        projectsSearchText: (0, _selectors.getProjectsSearchText)(state),
        tasksSearchOpen: (0, _selectors.getTasksSearchOpen)(state),
        tasksSearchText: (0, _selectors.getTasksSearchText)(state),
        canManageParentCustomer: (0, _selectors.canManageParentCustomer)(state),
        canManageParentProject: (0, _selectors.canManageParentProject)(state),
        viewerHasAccessAllManagementScope: (0, _selectors2.hasAccessAllManagementScope)(state)
    };
}, function (dispatch) {
    return (0, _redux.bindActionCreators)({
        changeCustomerAssignment: _actions.changeCustomerAssignment,
        changeProjectAssignment: _actions.changeProjectAssignment,
        changeTaskAssignment: _actions.changeTaskAssignment,
        changeAllCustomersAssignments: _actions.changeAllCustomersAssignments,
        changeAllProjectsAssignments: _actions.changeAllProjectsAssignments,
        changeAllTasksAssignments: _actions.changeAllTasksAssignments,
        deselectCustomer: _actions.deselectCustomer,
        deselectProject: _actions.deselectProject,
        selectCustomer: _actions.selectCustomer,
        selectProject: _actions.selectProject,
        loadMoreEntities: _actions.loadMoreEntities,
        changeOnlyActive: _actions.changeOnlyActive,
        changeCustomersSearchText: _actions.changeCustomersSearchText,
        clearCustomersSearchText: _actions.clearCustomersSearchText,
        changeProjectsSearchText: _actions.changeProjectsSearchText,
        clearProjectsSearchText: _actions.clearProjectsSearchText,
        changeTasksSearchText: _actions.changeTasksSearchText,
        clearTasksSearchText: _actions.clearTasksSearchText,
        changeAllExistingAndFutureTasksAssignment: _actions.changeAllExistingAndFutureTasksAssignment,
        changeAllExistingAndFutureProjectsAssignment: _actions.changeAllExistingAndFutureProjectsAssignment,
        closeEditor: _actions.closeEditor
    }, dispatch);
})(ManagementAssignmentsEditor);

/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _BreadcrumbsPanel = __webpack_require__(1680);

var _BreadcrumbsPanel2 = _interopRequireDefault(_BreadcrumbsPanel);

var _EntitiesListHeader = __webpack_require__(1682);

var _EntitiesListHeader2 = _interopRequireDefault(_EntitiesListHeader);

var _LoadingSpinner = __webpack_require__(191);

var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);

var _Header = __webpack_require__(1686);

var _Header2 = _interopRequireDefault(_Header);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _UserNameFormat = __webpack_require__(17);

var _EntitiesList = __webpack_require__(1687);

var _EntitiesList2 = _interopRequireDefault(_EntitiesList);

var _constants = __webpack_require__(4);

var _AutoScrollableWrapper = __webpack_require__(401);

var _AutoScrollableWrapper2 = _interopRequireDefault(_AutoScrollableWrapper);

var _LoadingSpinnerWrapper = __webpack_require__(1691);

var _LoadingSpinnerWrapper2 = _interopRequireDefault(_LoadingSpinnerWrapper);

var _LoadingContainer = __webpack_require__(28);

var _LoadingContainer2 = _interopRequireDefault(_LoadingContainer);

var _RevokeMenu = __webpack_require__(1692);

var _RevokeMenu2 = _interopRequireDefault(_RevokeMenu);

var _constants2 = __webpack_require__(261);

var _atUtils = __webpack_require__(5);

var _selectors = __webpack_require__(19);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var HierarchyAssignmentsEditor = function (_TemplateView) {
    _inherits(HierarchyAssignmentsEditor, _TemplateView);

    function HierarchyAssignmentsEditor(_ref) {
        var _ref$headerMessageKey = _ref.headerMessageKey,
            headerMessageKey = _ref$headerMessageKey === undefined ? '' : _ref$headerMessageKey,
            _ref$workAssignmentsV = _ref.workAssignmentsVisible,
            workAssignmentsVisible = _ref$workAssignmentsV === undefined ? true : _ref$workAssignmentsV,
            _ref$managementAssign = _ref.managementAssignmentsEditable,
            managementAssignmentsEditable = _ref$managementAssign === undefined ? true : _ref$managementAssign,
            _ref$showOnlyActiveSw = _ref.showOnlyActiveSwitch,
            showOnlyActiveSwitch = _ref$showOnlyActiveSw === undefined ? false : _ref$showOnlyActiveSw,
            _ref$showAllExistingF = _ref.showAllExistingFuturesSwitcher,
            showAllExistingFuturesSwitcher = _ref$showAllExistingF === undefined ? false : _ref$showAllExistingF,
            _ref$changeCustomerAs = _ref.changeCustomerAssignment,
            changeCustomerAssignment = _ref$changeCustomerAs === undefined ? function (customerId, assigned) {} : _ref$changeCustomerAs,
            _ref$changeProjectAss = _ref.changeProjectAssignment,
            changeProjectAssignment = _ref$changeProjectAss === undefined ? function (projectId, assigned) {} : _ref$changeProjectAss,
            _ref$changeTaskAssign = _ref.changeTaskAssignment,
            changeTaskAssignment = _ref$changeTaskAssign === undefined ? function (taskId, assigned) {} : _ref$changeTaskAssign,
            _ref$changeAllCustome = _ref.changeAllCustomersAssignments,
            changeAllCustomersAssignments = _ref$changeAllCustome === undefined ? function (assigned) {} : _ref$changeAllCustome,
            _ref$changeAllProject = _ref.changeAllProjectsAssignments,
            changeAllProjectsAssignments = _ref$changeAllProject === undefined ? function (assigned) {} : _ref$changeAllProject,
            _ref$changeAllTasksAs = _ref.changeAllTasksAssignments,
            changeAllTasksAssignments = _ref$changeAllTasksAs === undefined ? function (assigned) {} : _ref$changeAllTasksAs,
            _ref$changeAllExistin = _ref.changeAllExistingAndFutureTasksAssignment,
            changeAllExistingAndFutureTasksAssignment = _ref$changeAllExistin === undefined ? function (assigned) {} : _ref$changeAllExistin,
            _ref$changeAllExistin2 = _ref.changeAllExistingAndFutureProjectsAssignment,
            changeAllExistingAndFutureProjectsAssignment = _ref$changeAllExistin2 === undefined ? function (assigned) {} : _ref$changeAllExistin2,
            _ref$deselectCustomer = _ref.deselectCustomer,
            deselectCustomer = _ref$deselectCustomer === undefined ? function () {} : _ref$deselectCustomer,
            _ref$deselectProject = _ref.deselectProject,
            deselectProject = _ref$deselectProject === undefined ? function () {} : _ref$deselectProject,
            _ref$selectCustomer = _ref.selectCustomer,
            selectCustomer = _ref$selectCustomer === undefined ? function (customerId) {} : _ref$selectCustomer,
            _ref$selectProject = _ref.selectProject,
            selectProject = _ref$selectProject === undefined ? function (projectId) {} : _ref$selectProject,
            _ref$reloadCustomers = _ref.reloadCustomers,
            reloadCustomers = _ref$reloadCustomers === undefined ? function () {} : _ref$reloadCustomers,
            _ref$loadMoreEntities = _ref.loadMoreEntities,
            loadMoreEntities = _ref$loadMoreEntities === undefined ? function () {} : _ref$loadMoreEntities,
            _ref$changeOnlyActive = _ref.changeOnlyActive,
            changeOnlyActive = _ref$changeOnlyActive === undefined ? function (onlyActive) {} : _ref$changeOnlyActive,
            _ref$changeCustomersS = _ref.changeCustomersSearchText,
            changeCustomersSearchText = _ref$changeCustomersS === undefined ? function (text) {} : _ref$changeCustomersS,
            _ref$clearCustomersSe = _ref.clearCustomersSearchText,
            clearCustomersSearchText = _ref$clearCustomersSe === undefined ? function () {} : _ref$clearCustomersSe,
            _ref$changeProjectsSe = _ref.changeProjectsSearchText,
            changeProjectsSearchText = _ref$changeProjectsSe === undefined ? function (text) {} : _ref$changeProjectsSe,
            _ref$clearProjectsSea = _ref.clearProjectsSearchText,
            clearProjectsSearchText = _ref$clearProjectsSea === undefined ? function () {} : _ref$clearProjectsSea,
            _ref$changeTasksSearc = _ref.changeTasksSearchText,
            changeTasksSearchText = _ref$changeTasksSearc === undefined ? function (text) {} : _ref$changeTasksSearc,
            _ref$clearTasksSearch = _ref.clearTasksSearchText,
            clearTasksSearchText = _ref$clearTasksSearch === undefined ? function () {} : _ref$clearTasksSearch,
            _ref$closeEditor = _ref.closeEditor,
            closeEditor = _ref$closeEditor === undefined ? function () {} : _ref$closeEditor,
            _ref$getAssignAllText = _ref.getAssignAllTextsMap,
            getAssignAllTextsMap = _ref$getAssignAllText === undefined ? function () {} : _ref$getAssignAllText,
            _ref$getRevokeAllText = _ref.getRevokeAllTextsMap,
            getRevokeAllTextsMap = _ref$getRevokeAllText === undefined ? function () {} : _ref$getRevokeAllText,
            _ref$getAssignTextsMa = _ref.getAssignTextsMap,
            getAssignTextsMap = _ref$getAssignTextsMa === undefined ? function () {} : _ref$getAssignTextsMa,
            _ref$getRevokeTextsMa = _ref.getRevokeTextsMap,
            getRevokeTextsMap = _ref$getRevokeTextsMa === undefined ? function () {} : _ref$getRevokeTextsMa;

        _classCallCheck(this, HierarchyAssignmentsEditor);

        var _this = _possibleConstructorReturn(this, (HierarchyAssignmentsEditor.__proto__ || Object.getPrototypeOf(HierarchyAssignmentsEditor)).call(this));

        _this.params = {
            headerMessageKey: headerMessageKey,
            workAssignmentsVisible: workAssignmentsVisible,
            managementAssignmentsEditable: managementAssignmentsEditable,
            showOnlyActiveSwitch: showOnlyActiveSwitch,
            showAllExistingFuturesSwitcher: showAllExistingFuturesSwitcher,
            getAssignAllTextsMap: getAssignAllTextsMap,
            getRevokeAllTextsMap: getRevokeAllTextsMap,
            getAssignTextsMap: getAssignTextsMap,
            getRevokeTextsMap: getRevokeTextsMap
        };

        _this.callbacks = {
            changeCustomerAssignment: changeCustomerAssignment,
            changeProjectAssignment: changeProjectAssignment,
            changeTaskAssignment: changeTaskAssignment,
            changeAllCustomersAssignments: changeAllCustomersAssignments,
            changeAllProjectsAssignments: changeAllProjectsAssignments,
            changeAllTasksAssignments: changeAllTasksAssignments,
            deselectCustomer: deselectCustomer,
            deselectProject: deselectProject,
            selectCustomer: selectCustomer,
            selectProject: selectProject,
            loadMoreEntities: loadMoreEntities,
            changeOnlyActive: changeOnlyActive,
            changeCustomersSearchText: changeCustomersSearchText,
            clearCustomersSearchText: clearCustomersSearchText,
            changeProjectsSearchText: changeProjectsSearchText,
            clearProjectsSearchText: clearProjectsSearchText,
            changeTasksSearchText: changeTasksSearchText,
            clearTasksSearchText: clearTasksSearchText,
            changeAllExistingAndFutureTasksAssignment: changeAllExistingAndFutureTasksAssignment,
            changeAllExistingAndFutureProjectsAssignment: changeAllExistingAndFutureProjectsAssignment,
            closeEditor: closeEditor
        };

        _this.state = {
            viewerCanManageCustomerIds: {},
            viewerCanManageProjectIds: {},
            user: {},
            customers: [],
            projects: [],
            tasks: [],
            canWorkCustomerIds: {},
            canManageCustomerIds: {},
            canManageCustomerExcludeSelfIds: {},
            canWorkProjectIds: {},
            canManageProjectIds: {},
            canManageProjectExcludeSelfIds: {},
            canWorkTaskIds: {},
            canManageTaskIds: {},
            projectCountsByCustomers: {},
            taskCountsByCustomers: {},
            taskCountsByProjects: {},
            futureCustomersAssigned: false,
            someCustomersOrLowerAssigned: false,
            allCustomersAssigned: false,
            futureProjectsAssigned: false,
            someProjectsOrLowerAssigned: false,
            allProjectsAssigned: false,
            futureTasksAssigned: false,
            someTasksAssigned: false,
            allTasksAssigned: false,
            selectedCustomer: null,
            selectedProject: null,
            loading: false,
            changingCustomerAssignments: {},
            changingProjectAssignments: {},
            changingTaskAssignments: {},
            changingAllAssignments: false,
            onlyActive: false,
            customersSearchOpen: false,
            customersSearchText: '',
            projectsSearchOpen: false,
            projectsSearchText: '',
            tasksSearchOpen: false,
            tasksSearchText: '',
            searchOpen: false,
            searchText: '',
            canManageParentCustomer: false,
            canManageParentProject: false,
            viewerHasAccessAllManagementScope: false
        };

        _this.onStateDeeplyChanged(function (state) {
            _this.header.setState({
                name: (0, _UserNameFormat.formatFmlWithCheck)(state.user || {})
            });

            _this.breadcrumbsPanel.setState({
                customerName: state.selectedCustomer ? state.selectedCustomer.name : '',
                projectName: state.selectedProject ? state.selectedProject.name : ''
            });

            _this._setHierarchyBackButtonText(state.selectedCustomer, state.selectedProject);

            var canManageAnyCustomer = state.viewerHasAccessAllManagementScope || (0, _atUtils.anyInSet)(state.viewerCanManageCustomerIds);
            var allCustomersCheckboxTooltipText = canManageAnyCustomer ? '' : _messageResource2.default.getEscapedMessage('work_assignments.tooltip.disabled_all_assign_button_customer');

            _this.customersList.toggle(!state.selectedCustomer && !state.selectedProject);
            _this.customersListHeader.toggle(!state.selectedCustomer && !state.selectedProject);
            _this.customersListHeader.setState({
                allAssigned: state.allCustomersAssigned,
                someAssigned: state.someCustomersOrLowerAssigned,
                onlyActive: state.onlyActive,
                searchOpen: state.customersSearchOpen,
                searchText: state.customersSearchText,
                changingAllAssignments: state.changingAllAssignments,
                futureAssigned: state.futureCustomersAssigned,
                listIsEmpty: state.customers.length === 0,
                disabledCheckboxTooltipText: allCustomersCheckboxTooltipText,
                isAssignAllCheckboxDisabled: !canManageAnyCustomer
            });
            _this.customersList.setState({
                entities: state.customers,
                canWorkIds: state.canWorkCustomerIds,
                canManageIds: state.canManageCustomerIds,
                canManageExcludeSelfIds: state.canManageCustomerExcludeSelfIds,
                projectCounts: state.projectCountsByCustomers,
                taskCounts: state.taskCountsByCustomers,
                changingAssignments: state.changingCustomerAssignments,
                futureAssigned: state.futureCustomersAssigned
            });

            var futureProjectsSwitcherTooltipText = "";
            var allProjectsCheckboxTooltipText = "";
            var projectCheckboxTooltipText = "";
            var isAllProjectsCheckboxDisabled = false;

            if (state.canManageParentCustomer) {
                futureProjectsSwitcherTooltipText = _this._getCannotChangeThisOption({ targetCP: _messageResource2.default.getMessage("common.customer") });
                allProjectsCheckboxTooltipText = futureProjectsSwitcherTooltipText;
                projectCheckboxTooltipText = _this._getCannotUnassign({
                    targetPT: _messageResource2.default.getMessage('common.project'),
                    selectedCP: _messageResource2.default.getMessage('common.customer')
                });
                isAllProjectsCheckboxDisabled = true;
            } else if (!_this.params.workAssignmentsVisible && state.futureProjectsAssigned || !!state.selectedCustomer && state.canManageCustomerExcludeSelfIds[state.selectedCustomer.id]) {
                futureProjectsSwitcherTooltipText = "";
                allProjectsCheckboxTooltipText = _this._getCannotChangeThisOptionExistingAndFuture({
                    existingAndFutures: _messageResource2.default.getMessage('common.projects'),
                    selectedCP: _messageResource2.default.getMessage('common.customer')
                });
                projectCheckboxTooltipText = _this._getCannotUnassignExistingAndFutures({
                    targetPT: _messageResource2.default.getMessage('common.project'),
                    existingAndFutures: _messageResource2.default.getMessage('common.projects'),
                    selectedCP: _messageResource2.default.getMessage('common.customer')
                });
                isAllProjectsCheckboxDisabled = true;
            } else if (_this.params.workAssignmentsVisible && !state.viewerHasAccessAllManagementScope && !(0, _atUtils.anyInSet)(state.viewerCanManageProjectIds)) {
                allProjectsCheckboxTooltipText = _messageResource2.default.getEscapedMessage('work_assignments.tooltip.disabled_all_assign_button_project');
                isAllProjectsCheckboxDisabled = true;
            }

            _this.projectsListHeader.toggle(!!state.selectedCustomer && !state.selectedProject);
            _this.projectsList.toggle(!!state.selectedCustomer && !state.selectedProject);
            _this.projectsListHeader.setState({
                allAssigned: state.allProjectsAssigned || !_this.params.workAssignmentsVisible && state.futureProjectsAssigned,
                someAssigned: state.someProjectsOrLowerAssigned,
                onlyActive: state.onlyActive,
                searchOpen: state.projectsSearchOpen,
                searchText: state.projectsSearchText,
                changingAllAssignments: state.changingAllAssignments,
                futureAssigned: state.futureProjectsAssigned,
                disabledSwitcherTooltipText: futureProjectsSwitcherTooltipText,
                disabledCheckboxTooltipText: allProjectsCheckboxTooltipText,
                listIsEmpty: state.projects.length === 0,
                isAssignAllCheckboxDisabled: isAllProjectsCheckboxDisabled
            });
            _this.projectsList.setState({
                entities: state.projects,
                canWorkIds: state.canWorkProjectIds,
                canManageIds: state.canManageProjectIds,
                canManageExcludeSelfIds: state.canManageProjectExcludeSelfIds,
                taskCounts: state.taskCountsByProjects,
                changingAssignments: state.changingProjectAssignments,
                topLevelAccess: state.canManageParentCustomer,
                readOnlyTooltipText: projectCheckboxTooltipText,
                futureAssigned: state.futureProjectsAssigned
            });

            var futureTasksSwitcherTooltipText = "";
            var allTasksCheckboxTooltipText = "";
            var taskCheckboxTooltipText = "";
            var isAllTaskCheckboxDisabled = false;

            if (state.canManageParentCustomer) {
                futureTasksSwitcherTooltipText = _this._getCannotChangeThisOption({ targetCP: _messageResource2.default.getMessage("common.customer") });
                allTasksCheckboxTooltipText = futureTasksSwitcherTooltipText;
                taskCheckboxTooltipText = _this._getCannotUnassign({
                    targetPT: _messageResource2.default.getMessage('common.task'),
                    selectedCP: _messageResource2.default.getMessage('common.customer')
                });
                isAllTaskCheckboxDisabled = true;
            } else if (!_this.params.workAssignmentsVisible && state.futureProjectsAssigned || !!state.selectedCustomer && state.canManageCustomerExcludeSelfIds[state.selectedCustomer.id]) {
                futureTasksSwitcherTooltipText = _this._getCannotChangeThisOptionExistingAndFuture({
                    existingAndFutures: _messageResource2.default.getMessage("common.projects"),
                    selectedCP: _messageResource2.default.getMessage("common.customer")
                });
                allTasksCheckboxTooltipText = futureTasksSwitcherTooltipText;
                taskCheckboxTooltipText = _this._getCannotUnassignExistingAndFutures({
                    targetPT: _messageResource2.default.getMessage('common.task'),
                    existingAndFutures: _messageResource2.default.getMessage('common.projects'),
                    selectedCP: _messageResource2.default.getMessage('common.customer')
                });
                isAllTaskCheckboxDisabled = true;
            } else if (state.canManageParentProject) {
                futureTasksSwitcherTooltipText = _this._getCannotChangeThisOption({ targetCP: _messageResource2.default.getMessage("common.project") });
                allTasksCheckboxTooltipText = futureTasksSwitcherTooltipText;
                taskCheckboxTooltipText = _this._getCannotUnassign({
                    targetPT: _messageResource2.default.getMessage('common.task'),
                    selectedCP: _messageResource2.default.getMessage('common.project')
                });
                isAllTaskCheckboxDisabled = true;
            } else if (!_this.params.workAssignmentsVisible && state.futureTasksAssigned || !!state.selectedProject && state.canManageProjectExcludeSelfIds[state.selectedProject.id]) {
                futureTasksSwitcherTooltipText = "";
                allTasksCheckboxTooltipText = _this._getCannotChangeThisOptionExistingAndFuture({
                    existingAndFutures: _messageResource2.default.getMessage("common.tasks"),
                    selectedCP: _messageResource2.default.getMessage("common.project")
                });
                taskCheckboxTooltipText = _this._getCannotUnassignExistingAndFutures({
                    targetPT: _messageResource2.default.getMessage('common.task'),
                    existingAndFutures: _messageResource2.default.getMessage('common.tasks'),
                    selectedCP: _messageResource2.default.getMessage('common.project')
                });
                isAllTaskCheckboxDisabled = true;
            }

            _this.tasksListHeader.toggle(!!state.selectedCustomer && !!state.selectedProject);
            _this.tasksList.toggle(!!state.selectedCustomer && !!state.selectedProject);
            _this.tasksListHeader.setState({
                allAssigned: state.allTasksAssigned || !_this.params.workAssignmentsVisible && state.futureTasksAssigned,
                someAssigned: state.someTasksAssigned,
                onlyActive: state.onlyActive,
                searchOpen: state.tasksSearchOpen,
                searchText: state.tasksSearchText,
                changingAllAssignments: state.changingAllAssignments,
                futureAssigned: state.futureTasksAssigned,
                disabledSwitcherTooltipText: futureTasksSwitcherTooltipText,
                disabledCheckboxTooltipText: allTasksCheckboxTooltipText,
                listIsEmpty: state.tasks.length === 0,
                isAssignAllCheckboxDisabled: isAllTaskCheckboxDisabled
            });
            _this.tasksList.setState({
                entities: state.tasks,
                canWorkIds: state.canWorkTaskIds,
                canManageIds: state.canManageTaskIds,
                changingAssignments: state.changingTaskAssignments,
                topLevelAccess: state.canManageParentProject,
                readOnlyTooltipText: taskCheckboxTooltipText,
                futureAssigned: state.futureTasksAssigned
            });

            _this._tryToShowNotFoundMessage();
        });
        _this.onStatePropertyChanged('loading', function (loading) {
            _this.loadingSpinnerWrapper.toggle(loading);
            _this.loadingSpinner.setState({ show: loading });
        });

        _this.onStatePropertyChanged('changingAllAssignments', function (loading) {
            return _this.listsLoadingWrapper.setState({ loading: loading });
        });

        _this.onStateChanged(function () {
            _this.scrollableWrapper.refreshScroll();
        });
        return _this;
    }

    _createClass(HierarchyAssignmentsEditor, [{
        key: "messageKeys",
        value: function messageKeys() {
            return {
                backButtonText: 'user.panel.permissions.team_assignments.back'
            };
        }
    }, {
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='userManagement_components_hierarchyAssignmentsEditor'>" + '   <div class="headerPlaceholder">' + '        <div class="backButton">' + '            <div class="arrow"></div>' + '            <div class="text"></div>' + '        </div>' + '        <div class="headerText"></div>' + '   </div>' + "  <div class='content'>" + "     <div class='headers'></div>" + "     <div class='noFoundMessage'></div>" + "     <div class='lists' style='position: relative'></div>" + "  </div>" + "</div>";
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            var _this2 = this;

            var $content = this.find('.headers');

            this.header = new _Header2.default({
                messageKey: this.params.headerMessageKey
            }).init(this.find('.headerText'));

            this.$backButton = this.find('.backButton');
            this.$backButtonText = this.find('.text');

            this.$noFoundMessage = this.find('.noFoundMessage');
            this.noItemsInLevel = this.find('.noItemsInLevel');

            this.$backButton.click(function () {

                if (!_this2.state.selectedCustomer && !_this2.state.selectedProject) {
                    _this2.callbacks.closeEditor();
                }

                if (!!_this2.state.selectedCustomer && !_this2.state.selectedProject) {
                    _this2.callbacks.deselectCustomer();
                }

                if (!!_this2.state.selectedCustomer && !!_this2.state.selectedProject) {
                    _this2.callbacks.deselectProject();
                }
            });

            this.breadcrumbsPanel = new _BreadcrumbsPanel2.default({
                onCustomerClose: function onCustomerClose() {
                    return _this2.callbacks.deselectCustomer();
                },
                onProjectClose: function onProjectClose() {
                    return _this2.callbacks.deselectProject();
                }
            }).init($content);

            this.revokeMenu = _RevokeMenu2.default.getInstance();

            this.customersListHeader = new _EntitiesListHeader2.default({
                title: _messageResource2.default.getMessage('userlist.ha_editor.customers.title'),
                nameColumnHeaderTitle: _messageResource2.default.getMessage('userlist.ha_editor.customers.name_column_header'),
                countersColumnHeaderTitle: _messageResource2.default.getMessage('userlist.ha_editor.customers.counters_column_header'),
                assignAllLabel: this.params.getAssignAllTextsMap()[_constants.HierarchyLevels.CUSTOMER],
                unassignAllLabel: this.params.getRevokeAllTextsMap()[_constants.HierarchyLevels.CUSTOMER],
                showOnlyActiveSwitch: this.params.showOnlyActiveSwitch,
                onlyActiveSelectedText: _messageResource2.default.getMessage('userlist.ha_editor.hide_archived'),
                allStatusesSelectedText: _messageResource2.default.getMessage('userlist.ha_editor.show_archived'),
                additionalClass: _constants2.HIERARCHY_LEVEL_CLASSES[_constants.HierarchyLevels.CUSTOMER],
                onAssignAll: function onAssignAll() {
                    return _this2.callbacks.changeAllCustomersAssignments(true);
                },
                onUnassignAll: function onUnassignAll() {
                    return _this2.callbacks.changeAllCustomersAssignments(false);
                },
                onOnlyActiveChanged: function onOnlyActiveChanged(onlyActive) {
                    return _this2.callbacks.changeOnlyActive(onlyActive);
                },
                onSearchTextChanged: function onSearchTextChanged(text) {
                    return _this2.callbacks.changeCustomersSearchText(text);
                },
                hideSearch: function hideSearch() {
                    return _this2.callbacks.clearCustomersSearchText();
                },
                workAssignmentsVisible: this.params.workAssignmentsVisible,
                managementAssignmentsEditable: this.params.managementAssignmentsEditable
            }).init($content);

            this.customersList = new _EntitiesList2.default({
                hierarchyLevel: _constants.HierarchyLevels.CUSTOMER,
                showProjectsCount: true,
                showTasksCount: true,
                entitiesClickable: true,
                workAssignmentsVisible: this.params.workAssignmentsVisible,
                managementAssignmentsEditable: this.params.managementAssignmentsEditable,
                revokeMenu: this.revokeMenu,
                revokeMenuTextsMaps: {
                    assignTextsMap: this.params.getAssignTextsMap(),
                    revokeTextsMap: this.params.getRevokeTextsMap()
                },
                onAssignmentChange: function onAssignmentChange(customerId, assigned) {
                    return _this2.callbacks.changeCustomerAssignment(customerId, assigned);
                },
                onEntityClick: function onEntityClick(customerId) {
                    return _this2.callbacks.selectCustomer(customerId);
                },
                checkIfViewerCanManage: function checkIfViewerCanManage(customerId) {
                    return !!_this2.state.viewerCanManageCustomerIds[customerId];
                }
            });

            this.projectsListHeader = new _EntitiesListHeader2.default({
                title: _messageResource2.default.getMessage('userlist.ha_editor.projects.title'),
                nameColumnHeaderTitle: _messageResource2.default.getMessage('userlist.ha_editor.projects.name_column_header'),
                countersColumnHeaderTitle: _messageResource2.default.getMessage('userlist.ha_editor.projects.counters_column_header'),
                assignAllLabel: this.params.getAssignAllTextsMap()[_constants.HierarchyLevels.PROJECT],
                unassignAllLabel: this.params.getRevokeAllTextsMap()[_constants.HierarchyLevels.PROJECT],
                showOnlyActiveSwitch: this.params.showOnlyActiveSwitch,
                onlyActiveSelectedText: _messageResource2.default.getMessage('userlist.ha_editor.hide_archived'),
                allStatusesSelectedText: _messageResource2.default.getMessage('userlist.ha_editor.show_archived'),
                titleMessageSwitcher: this.params.showAllExistingFuturesSwitcher ? _messageResource2.default.getMessage('userlist.ma_editor.all_existin_and_future_project_title') : '',
                additionalClass: _constants2.HIERARCHY_LEVEL_CLASSES[_constants.HierarchyLevels.PROJECT],
                onAssignAll: function onAssignAll() {
                    return _this2.callbacks.changeAllProjectsAssignments(true);
                },
                onUnassignAll: function onUnassignAll() {
                    return _this2.callbacks.changeAllProjectsAssignments(false);
                },
                onOnlyActiveChanged: function onOnlyActiveChanged(onlyActive) {
                    return _this2.callbacks.changeOnlyActive(onlyActive);
                },
                onChangeExistingAndFutureAssignment: function onChangeExistingAndFutureAssignment(assigned) {
                    return _this2.callbacks.changeAllExistingAndFutureProjectsAssignment(assigned);
                },
                onSearchTextChanged: function onSearchTextChanged(text) {
                    return _this2.callbacks.changeProjectsSearchText(text);
                },
                hideSearch: function hideSearch() {
                    return _this2.callbacks.clearProjectsSearchText();
                },
                workAssignmentsVisible: this.params.workAssignmentsVisible,
                managementAssignmentsEditable: this.params.managementAssignmentsEditable
            }).init($content);
            this.projectsList = new _EntitiesList2.default({
                hierarchyLevel: _constants.HierarchyLevels.PROJECT,
                showProjectsCount: false,
                showTasksCount: true,
                entitiesClickable: true,
                workAssignmentsVisible: this.params.workAssignmentsVisible,
                managementAssignmentsEditable: this.params.managementAssignmentsEditable,
                revokeMenu: this.revokeMenu,
                revokeMenuTextsMaps: {
                    assignTextsMap: this.params.getAssignTextsMap(),
                    revokeTextsMap: this.params.getRevokeTextsMap()
                },
                onAssignmentChange: function onAssignmentChange(projectId, assigned) {
                    return _this2.callbacks.changeProjectAssignment(projectId, assigned);
                },
                onEntityClick: function onEntityClick(projectId) {
                    return _this2.callbacks.selectProject(projectId);
                },
                checkIfViewerCanManage: function checkIfViewerCanManage(projectId) {
                    return !!_this2.state.viewerCanManageProjectIds[projectId];
                }
            });

            this.tasksListHeader = new _EntitiesListHeader2.default({
                title: _messageResource2.default.getMessage('userlist.ha_editor.tasks.title'),
                nameColumnHeaderTitle: _messageResource2.default.getMessage('userlist.ha_editor.tasks.name_column_header'),
                assignAllLabel: this.params.getAssignAllTextsMap()[_constants.HierarchyLevels.TASK],
                unassignAllLabel: this.params.getRevokeAllTextsMap()[_constants.HierarchyLevels.TASK],
                showOnlyActiveSwitch: this.params.showOnlyActiveSwitch,
                onlyActiveSelectedText: _messageResource2.default.getMessage('userlist.ha_editor.hide_completed'),
                allStatusesSelectedText: _messageResource2.default.getMessage('userlist.ha_editor.show_completed'),
                titleMessageSwitcher: this.params.showAllExistingFuturesSwitcher ? _messageResource2.default.getMessage('userlist.ma_editor.all_existin_and_future_task_title') : '',
                additionalClass: _constants2.HIERARCHY_LEVEL_CLASSES[_constants.HierarchyLevels.TASK],
                onAssignAll: function onAssignAll() {
                    return _this2.callbacks.changeAllTasksAssignments(true);
                },
                onUnassignAll: function onUnassignAll() {
                    return _this2.callbacks.changeAllTasksAssignments(false);
                },
                onOnlyActiveChanged: function onOnlyActiveChanged(onlyActive) {
                    return _this2.callbacks.changeOnlyActive(onlyActive);
                },
                onSearchTextChanged: function onSearchTextChanged(text) {
                    return _this2.callbacks.changeTasksSearchText(text);
                },
                onChangeExistingAndFutureAssignment: function onChangeExistingAndFutureAssignment(assigned) {
                    return _this2.callbacks.changeAllExistingAndFutureTasksAssignment(assigned);
                },
                hideSearch: function hideSearch() {
                    return _this2.callbacks.clearTasksSearchText();
                },
                workAssignmentsVisible: this.params.workAssignmentsVisible,
                managementAssignmentsEditable: this.params.managementAssignmentsEditable
            }).init($content);
            this.tasksList = new _EntitiesList2.default({
                hierarchyLevel: _constants.HierarchyLevels.TASK,
                showProjectsCount: false,
                showTasksCount: false,
                entitiesClickable: true,
                workAssignmentsVisible: this.params.workAssignmentsVisible,
                managementAssignmentsEditable: this.params.managementAssignmentsEditable,
                revokeMenu: this.revokeMenu,
                revokeMenuTextsMaps: {
                    assignTextsMap: this.params.getAssignTextsMap(),
                    revokeTextsMap: this.params.getRevokeTextsMap()
                },
                onAssignmentChange: function onAssignmentChange(taskId, assigned) {
                    return _this2.callbacks.changeTaskAssignment(taskId, assigned);
                },
                checkIfViewerCanManage: function checkIfViewerCanManage(taskId) {
                    return true;
                },
                onEntityClick: function onEntityClick(taskId) {
                    var disabled = !_this2.params.workAssignmentsVisible && _this2.state.futureTasksAssigned || !_this2.params.managementAssignmentsEditable && !!_this2.state.canManageTaskIds[taskId] || !_this2.params.workAssignmentsVisible && _this2.state.canManageParentProject;
                    if (!disabled) _this2.callbacks.changeTaskAssignment(taskId, _this2.params.workAssignmentsVisible && !_this2.state.canWorkTaskIds[taskId] || !_this2.params.workAssignmentsVisible && !_this2.state.canManageTaskIds[taskId]);
                }
            });

            this.loadingSpinner = new _LoadingSpinner2.default({});
            this.loadingSpinnerWrapper = new _LoadingSpinnerWrapper2.default(this.loadingSpinner);

            this.listsLoadingWrapper = new _LoadingContainer2.default({
                contentComponent: [this.customersList, this.projectsList, this.tasksList, this.loadingSpinnerWrapper],
                containerClass: 'entitiesListLoadingWrapper'
            });

            this.scrollableWrapper = new _AutoScrollableWrapper2.default({
                components: [this.listsLoadingWrapper],
                enableVerticalScroll: true,
                verticalScrollConfig: {
                    probeType: 2
                },
                onScrollToBottom: function onScrollToBottom() {
                    return _this2.callbacks.loadMoreEntities();
                }
            }).init(this.find('.lists'));
        }
    }, {
        key: "show",
        value: function show() {
            _get(HierarchyAssignmentsEditor.prototype.__proto__ || Object.getPrototypeOf(HierarchyAssignmentsEditor.prototype), "show", this).call(this);
            this.scrollableWrapper.show();
        }
    }, {
        key: "_tryToShowNotFoundMessage",
        value: function _tryToShowNotFoundMessage() {
            var currentEntities = void 0;
            var msg = "";
            var isSearching = !!this.state.searchText;
            var onlyActive = this.state.onlyActive;

            if (!this.state.selectedCustomer && !this.state.selectedProject) {
                currentEntities = this.state.customers;
                msg = _messageResource2.default.getMessage('common.customers_not_found_message');
            } else if (!!this.state.selectedCustomer && !this.state.selectedProject) {
                currentEntities = this.state.projects;
                msg = isSearching ? _messageResource2.default.getMessage('common.projects_not_found_message') : onlyActive ? _messageResource2.default.getMessage('assigned_users_editor.disabled_tooltip.no_projects_active') : _messageResource2.default.getMessage('assigned_users_editor.disabled_tooltip.no_projects');
            } else {
                currentEntities = this.state.tasks;
                msg = isSearching ? _messageResource2.default.getMessage('common.tasks_not_found_message') : onlyActive ? _messageResource2.default.getMessage('assigned_users_editor.disabled_tooltip.no_tasks_active') : _messageResource2.default.getMessage('assigned_users_editor.disabled_tooltip.no_tasks');
            }

            this.$noFoundMessage.text(msg);
            this.$noFoundMessage.toggle(currentEntities.length === 0);
        }
    }, {
        key: "_getCannotChangeThisOption",
        value: function _getCannotChangeThisOption(_ref2) {
            var targetCP = _ref2.targetCP;

            return _messageResource2.default.getMessage('user.panel.permissions.team_assignments.cannot_change_this_option', [targetCP]);
        }
    }, {
        key: "_getCannotChangeThisOptionExistingAndFuture",
        value: function _getCannotChangeThisOptionExistingAndFuture(_ref3) {
            var existingAndFutures = _ref3.existingAndFutures,
                selectedCP = _ref3.selectedCP;

            return _messageResource2.default.getMessage('user.panel.permissions.team_assignments.cannot_change_this_option_existing_and_future', [existingAndFutures, selectedCP]);
        }
    }, {
        key: "_getCannotUnassign",
        value: function _getCannotUnassign(_ref4) {
            var targetPT = _ref4.targetPT,
                selectedCP = _ref4.selectedCP;

            return _messageResource2.default.getMessage('user.panel.permissions.team_assignments.cannot_unassign', [targetPT, selectedCP]);
        }
    }, {
        key: "_getCannotUnassignExistingAndFutures",
        value: function _getCannotUnassignExistingAndFutures(_ref5) {
            var targetPT = _ref5.targetPT,
                existingAndFutures = _ref5.existingAndFutures,
                selectedCP = _ref5.selectedCP;

            return _messageResource2.default.getMessage('user.panel.permissions.team_assignments.cannot_unassign_existing_and_future', [targetPT, existingAndFutures, selectedCP]);
        }
    }, {
        key: "_setHierarchyBackButtonText",
        value: function _setHierarchyBackButtonText(selectedCustomer, selectedProject) {

            if (!selectedCustomer && !selectedProject) {
                this.$backButtonText.text(_messageResource2.default.getMessage("user.panel.permissions.team_assignments.back"));
            }

            if (!!selectedCustomer && !selectedProject) {
                this.$backButtonText.text(_messageResource2.default.getMessage("user.panel.permissions.team_assignments.back_to_customer"));
            }

            if (!!selectedCustomer && !!selectedProject) {
                this.$backButtonText.text(_messageResource2.default.getMessage("user.panel.permissions.team_assignments.back_to_project"));
            }

            this.$backButton.toggleClass('wideBackButton', !!selectedCustomer && !selectedProject || !!selectedCustomer && !!selectedProject);
        }
    }]);

    return HierarchyAssignmentsEditor;
}(_TemplateView3.default);

exports.default = HierarchyAssignmentsEditor;

/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CheckboxIcon = function (_TemplateView) {
    _inherits(CheckboxIcon, _TemplateView);

    function CheckboxIcon() {
        _classCallCheck(this, CheckboxIcon);

        var _this = _possibleConstructorReturn(this, (CheckboxIcon.__proto__ || Object.getPrototypeOf(CheckboxIcon)).call(this));

        _this.state = {
            checked: false,
            disabled: false,
            indeterminate: false
        };

        _this.onAnyStatePropertyChanged(['checked', 'disabled', 'indeterminate'], function (_ref) {
            var checked = _ref.checked,
                disabled = _ref.disabled,
                indeterminate = _ref.indeterminate;

            //checkbox can't be checked and indeterminate simultaneously
            _this.$el.toggleClass("checked", !indeterminate && checked);
            _this.$el.toggleClass("disabled", disabled);
            _this.$el.toggleClass("indeterminate", indeterminate);
        });
        return _this;
    }

    _createClass(CheckboxIcon, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class="components_checkboxIcon"/>';
        }
    }]);

    return CheckboxIcon;
}(_TemplateView3.default);

exports.default = CheckboxIcon;

/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _View2 = __webpack_require__(20);

var _View3 = _interopRequireDefault(_View2);

var _LoadingContainer = __webpack_require__(28);

var _LoadingContainer2 = _interopRequireDefault(_LoadingContainer);

var _constants = __webpack_require__(62);

var _PanelContainer = __webpack_require__(109);

var _PanelContainer2 = _interopRequireDefault(_PanelContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ManagementAssignmentsPanel = function (_View) {
    _inherits(ManagementAssignmentsPanel, _View);

    function ManagementAssignmentsPanel(_ref) {
        var _ref$panelContent = _ref.panelContent,
            panelContent = _ref$panelContent === undefined ? null : _ref$panelContent,
            _ref$onPanelHide = _ref.onPanelHide,
            onPanelHide = _ref$onPanelHide === undefined ? function () {} : _ref$onPanelHide,
            _ref$loadData = _ref.loadData,
            loadData = _ref$loadData === undefined ? function () {} : _ref$loadData,
            _ref$additionalClass = _ref.additionalClass,
            additionalClass = _ref$additionalClass === undefined ? '' : _ref$additionalClass;

        _classCallCheck(this, ManagementAssignmentsPanel);

        var _this = _possibleConstructorReturn(this, (ManagementAssignmentsPanel.__proto__ || Object.getPrototypeOf(ManagementAssignmentsPanel)).call(this));

        _this.params = {
            onPanelHide: onPanelHide,
            loadData: loadData,
            panelContent: panelContent,
            additionalClass: additionalClass
        };

        _this.state = {
            isShown: false,
            userPanelOpenedBelow: false,
            needToLoadData: false,
            loading: false
        };

        _this.onStatePropertyChanged('isShown', function (isShown) {
            _this.managementAssignmentsPanelContainer.setState({ isShown: isShown });
        });

        _this.onStatePropertyChanged('userPanelOpenedBelow', function (userPanelOpenedBelow) {
            _this.params.panelContent.setState({
                withBackButton: userPanelOpenedBelow
            });
        });

        _this.onStatePropertyBecameTrue('needToLoadData', function () {
            _this.params.loadData();
        });

        _this.onStatePropertyChanged('loading', function (loading) {
            _this.managementAssigmnentLoadingContainer.setState({
                loading: loading
            });
        });
        return _this;
    }

    _createClass(ManagementAssignmentsPanel, [{
        key: 'afterRender',
        value: function afterRender() {
            var _this2 = this;

            this.managementAssigmnentLoadingContainer = new _LoadingContainer2.default({
                contentComponent: this.params.panelContent,
                containerClass: 'managementAssignmentsPanelLoadingWrapper',
                loadingMoireConfig: {
                    delay: 500
                }
            });

            this.managementAssignmentsPanelContainer = new _PanelContainer2.default({
                component: this.managementAssigmnentLoadingContainer,
                additionalClass: "managementAssignmentsPanelContainer " + this.params.additionalClass,
                showAnimationClass: _constants.SHOW_ANIMATION_CLASSES.SLIDE_LEFT,
                hideAnimationClass: _constants.HIDE_ANIMATION_CLASSES.SLIDE_LEFT,
                showHideButton: false,
                hideOnEsc: true,
                hideOnClickOutside: {
                    hideOnClick: true,
                    panelType: _constants.PANEL_TYPES.MANAGEMENT_ASSIGNMENTS_PANEL
                },
                onShowCallback: function onShowCallback() {
                    return _this2.params.panelContent.update();
                },
                onHideCallback: function onHideCallback() {
                    return _this2.params.onPanelHide();
                },
                hideHandler: function hideHandler() {
                    return _this2.managementAssignmentsPanelContainer.setState({ isShown: false });
                }
            }).init((0, _jquery2.default)('body'));
        }
    }]);

    return ManagementAssignmentsPanel;
}(_View3.default);

exports.default = ManagementAssignmentsPanel;

/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _CounterHeader = __webpack_require__(1696);

var _CounterHeader2 = _interopRequireDefault(_CounterHeader);

var _constants = __webpack_require__(4);

var _DisabledContainer = __webpack_require__(888);

var _DisabledContainer2 = _interopRequireDefault(_DisabledContainer);

var _UserNameFormat = __webpack_require__(17);

var _CopyContent = __webpack_require__(1697);

var _CopyContent2 = _interopRequireDefault(_CopyContent);

var _ScrollableContainer = __webpack_require__(49);

var _ScrollableContainer2 = _interopRequireDefault(_ScrollableContainer);

var _LoadingContainer = __webpack_require__(28);

var _LoadingContainer2 = _interopRequireDefault(_LoadingContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ManagementAssignmentsPanelContent = function (_TemplateView) {
    _inherits(ManagementAssignmentsPanelContent, _TemplateView);

    function ManagementAssignmentsPanelContent(_ref) {
        var _ref$tabContent = _ref.tabContent,
            tabContent = _ref$tabContent === undefined ? null : _ref$tabContent,
            _ref$showCopyButton = _ref.showCopyButton,
            showCopyButton = _ref$showCopyButton === undefined ? true : _ref$showCopyButton,
            _ref$onManagementAssi = _ref.onManagementAssignmentsSelectionChange,
            onManagementAssignmentsSelectionChange = _ref$onManagementAssi === undefined ? function () {} : _ref$onManagementAssi,
            _ref$onBackButtonClic = _ref.onBackButtonClick,
            onBackButtonClick = _ref$onBackButtonClic === undefined ? function () {} : _ref$onBackButtonClic,
            _ref$onTabChanged = _ref.onTabChanged,
            onTabChanged = _ref$onTabChanged === undefined ? function (tab) {} : _ref$onTabChanged,
            _ref$onClickDialogCon = _ref.onClickDialogContent,
            onClickDialogContent = _ref$onClickDialogCon === undefined ? function () {} : _ref$onClickDialogCon,
            _ref$openEditorPanel = _ref.openEditorPanel,
            openEditorPanel = _ref$openEditorPanel === undefined ? function () {} : _ref$openEditorPanel,
            _ref$onCloseButtonCli = _ref.onCloseButtonClick,
            onCloseButtonClick = _ref$onCloseButtonCli === undefined ? function () {} : _ref$onCloseButtonCli,
            _ref$onCopyFromButton = _ref.onCopyFromButtonClick,
            onCopyFromButtonClick = _ref$onCopyFromButton === undefined ? function () {} : _ref$onCopyFromButton;

        _classCallCheck(this, ManagementAssignmentsPanelContent);

        var _this = _possibleConstructorReturn(this, (ManagementAssignmentsPanelContent.__proto__ || Object.getPrototypeOf(ManagementAssignmentsPanelContent)).call(this));

        _this.params = {
            tabContent: tabContent,
            showCopyButton: showCopyButton,
            onManagementAssignmentsSelectionChange: onManagementAssignmentsSelectionChange,
            onBackButtonClick: onBackButtonClick,
            onClickDialogContent: onClickDialogContent,
            onTabChanged: onTabChanged,
            openEditorPanel: openEditorPanel,
            onCloseButtonClick: onCloseButtonClick,
            onCopyFromButtonClick: onCopyFromButtonClick
        };

        _this.state = {
            managementAssignmentsSelection: _constants.ManagementAssignmentsSelection.SELECTED,
            userFML: null,
            withBackButton: true,
            openTab: null,
            showCopyContent: false,
            copyContentLoading: false,

            counters: {
                customers: 0,
                projects: 0,
                tasks: 0
            }
        };

        _this.onAnyStatePropertyChanged(['openTab', 'showCopyContent'], function (_ref2) {
            var openTab = _ref2.openTab,
                showCopyContent = _ref2.showCopyContent;

            _this.counterHeader.setState({ tab: showCopyContent ? null : openTab });
            _this.$tabContent.toggle(!showCopyContent);
            _this.$copyButton.toggleClass('selected', showCopyContent);
            _this.$separator.toggleClass('invisible', showCopyContent);
        });

        _this.onStatePropertyChanged('counters', function (counters) {
            _this.counterHeader.setState({ counters: counters });
        });

        _this.onStatePropertyChanged('managementAssignmentsSelection', function () {
            return _this._updateRadio();
        });

        _this.onStatePropertyChanged('userFML', function (userFML) {
            _this.$headerLabel.text(_messageResource2.default.getMessage('management_assignment.panel.title', [(0, _UserNameFormat.formatFmlWithCheck)(userFML)]));
        });

        _this.onStatePropertyChanged('withBackButton', function (withBackButton) {
            _this.$backButton.toggle(withBackButton);
        });

        _this.onStatePropertyChanged('copyContentLoading', function (loading) {
            return _this.copyContentWrapper.setState({ loading: loading });
        });
        return _this;
    }

    _createClass(ManagementAssignmentsPanelContent, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class="managementAssignmentsPanel">' + '   <div class="header">' + '        <div class="backButton">' + '            <div class="arrow"></div>' + '            <div class="text"><%-backButton%></div>' + '        </div>' + '        <div class="headerText"></div>' + '        <div class="crossButton"></div>' + '   </div>' + '   <div class="managementAssignmentsPanelContent">' + '       <div class="radioSection">' + '           <label>' + '               <div class="noAccessSection sectionRow">' + '                    <input type="radio" class="noAccess"/>' + '                    <div class="icon"></div>' + '                    <span><%-noAccessLabel%></span>' + '                </div>' + '            </label>' + '            <label>' + '                <div class="allSection sectionRow">' + '                    <input type="radio" class="selectAll"/>' + '                    <div class="icon"></div>' + '                    <span><%-selectAllLabel%></span>' + '                </div>' + '            </label>' + '            <label class="customSectionLabel">' + '                <div class="customSection sectionRow">' + '                    <div class="option">' + '                        <input type="radio" class="customSelect"/>' + '                        <div class="icon"></div>' + '                        <span><%-customSelectLabel%></span>' + '                    </div>' + '                    <div class="counterTabPlaceholder"/>' + '                    <div class="buttonsContainer">' + '                        <div class="vertical-separator first"></div>' + '                        <div class="editAssignmentButton"><%-editButtonTitle%></div>' + '                        <div class="vertical-separator last"></div>' + '                        <div class="copyButton">' + '                            <div class="copyButtonImg"/>' + '                            <div class="copyButtonLabel"><%-copyButtonLabel%></div>' + '                        </div>' + '                    </div>' + '                </div>' + '            </label>' + '        </div>' + '        <div class="tabContentPlaceholder"/>' + '        <div class="copyContentPlaceholder"/>' + '    </div>' + '</div>';
        }
    }, {
        key: 'messageKeys',
        value: function messageKeys() {
            return {
                noAccessLabel: 'management_assignment.panel.no_access',
                selectAllLabel: 'management_assignment.panel.entire_scope',
                customSelectLabel: 'management_assignment.panel.custom_scope',
                backButton: 'user.panel.permissions.team_assignments.back_to_permission',
                editButtonTitle: 'common.edit',
                copyButtonLabel: 'management_assignment.panel.copy_button'
            };
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            var _this2 = this;

            this.$headerLabel = this.find('.headerText');
            this.$backButton = this.find('.backButton');
            this.$crossButton = this.find('.crossButton');

            this.$noAccessSection = this.find('.noAccessSection');
            this.$selectAllSection = this.find('.allSection');
            this.$customSection = this.find('.customSection');
            this.$noAccessRadio = this.find('.noAccess');

            this.$selectAllRadio = this.find('.selectAll');
            this.$customSelectRadio = this.find('.customSelect');
            this.$editButton = this.find('.editAssignmentButton');
            this.$separator = this.find('.vertical-separator');
            this.$copyButton = this.find('.copyButton');
            this.$tabContent = this.find('.tabContentPlaceholder');
            this.$copyContent = this.find('.copyContentPlaceholder');
            this.$buttonsContainer = this.find('.buttonsContainer');
            this.$buttonsContainer.toggleClass('withCopyButton', this.params.showCopyButton);

            this.$el.click(function (e) {
                return _this2.params.onClickDialogContent(e);
            });

            this.$backButton.on('click', function () {
                return _this2.params.onBackButtonClick();
            });

            this.$crossButton.on('click', function () {
                return _this2.params.onCloseButtonClick();
            });
            this.$crossButton.addClass('hideButton_panelContainer');

            // Prevent hide Edit Scope panel by click outside, second click event triggering by label with input
            var $customSectionLabel = this.find('.customSectionLabel');
            $customSectionLabel.click(function (e) {
                if (_this2.state.managementAssignmentsSelection === _constants.ManagementAssignmentsSelection.SELECTED) e.stopPropagation();
            });

            this.$noAccessRadio.on('change', function () {
                return _this2.params.onManagementAssignmentsSelectionChange(_constants.ManagementAssignmentsSelection.NO);
            });
            this.$selectAllRadio.on('change', function () {
                return _this2.params.onManagementAssignmentsSelectionChange(_constants.ManagementAssignmentsSelection.ALL);
            });
            this.$customSelectRadio.on('change', function () {
                return _this2.params.onManagementAssignmentsSelectionChange(_constants.ManagementAssignmentsSelection.SELECTED);
            });

            this.$editButton.click(function (e) {
                if (_this2.state.managementAssignmentsSelection === _constants.ManagementAssignmentsSelection.SELECTED) {
                    _this2.params.openEditorPanel();
                    e.stopPropagation();
                }
            });

            if (this.params.showCopyButton) {
                this.$copyButton.click(function (e) {
                    if (_this2.state.managementAssignmentsSelection === _constants.ManagementAssignmentsSelection.SELECTED) {
                        _this2.params.onCopyFromButtonClick();
                        e.stopPropagation();
                    }
                });
            }

            this.counterHeader = new _CounterHeader2.default({
                changeTab: function changeTab(tab) {
                    return _this2.params.onTabChanged(tab);
                }
            });

            this.counterHeaderWrapper = new _DisabledContainer2.default({
                contentComponent: this.counterHeader,
                containerClass: 'counterHeaderWrapper'
            }).init(this.find(".counterTabPlaceholder"));

            this.tabContentWrapper = new _DisabledContainer2.default({
                contentComponent: this.params.tabContent
            }).init(this.$tabContent);

            this.copyContent = new _CopyContent2.default({
                refreshScrollCb: function refreshScrollCb() {
                    return _this2.copyContentScrollableWrapper.forceUpdate();
                }
            });
            this.copyContentScrollableWrapper = new _ScrollableContainer2.default(null, this.copyContent, { triggerScrollEvent: false });
            this.copyContentWrapper = new _DisabledContainer2.default({
                contentComponent: new _LoadingContainer2.default({
                    contentComponent: this.copyContentScrollableWrapper,
                    containerClass: 'copyContentWrapper',
                    loadingMoireConfig: {
                        delay: 500
                    }
                }),
                containerClass: 'copyContentWrapper'
            }).init(this.$copyContent);

            this.renderInitialState();
        }
    }, {
        key: 'update',
        value: function update() {
            this.params.tabContent.update();
        }
    }, {
        key: '_updateRadio',
        value: function _updateRadio() {
            this.$noAccessRadio.prop('checked', this.state.managementAssignmentsSelection === _constants.ManagementAssignmentsSelection.NO);
            this.$selectAllRadio.prop('checked', this.state.managementAssignmentsSelection === _constants.ManagementAssignmentsSelection.ALL);
            this.$customSelectRadio.prop('checked', this.state.managementAssignmentsSelection === _constants.ManagementAssignmentsSelection.SELECTED);

            this.$noAccessSection.toggleClass('selected', this.state.managementAssignmentsSelection === _constants.ManagementAssignmentsSelection.NO);
            this.$selectAllSection.toggleClass('selected', this.state.managementAssignmentsSelection === _constants.ManagementAssignmentsSelection.ALL);
            this.$customSection.toggleClass('selected', this.state.managementAssignmentsSelection === _constants.ManagementAssignmentsSelection.SELECTED);

            this.counterHeaderWrapper.setState({ disabled: this.state.managementAssignmentsSelection !== _constants.ManagementAssignmentsSelection.SELECTED });
            this.tabContentWrapper.setState({ disabled: this.state.managementAssignmentsSelection !== _constants.ManagementAssignmentsSelection.SELECTED });
            this.copyContentWrapper.setState({ disabled: this.state.managementAssignmentsSelection !== _constants.ManagementAssignmentsSelection.SELECTED });

            this.$editButton.toggleClass('notAvailable', this.state.managementAssignmentsSelection !== _constants.ManagementAssignmentsSelection.SELECTED);
            this.$copyButton.toggleClass('notAvailable', this.state.managementAssignmentsSelection !== _constants.ManagementAssignmentsSelection.SELECTED);
        }
    }]);

    return ManagementAssignmentsPanelContent;
}(_TemplateView3.default);

exports.default = ManagementAssignmentsPanelContent;

/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DisabledContainer = function (_TemplateView) {
    _inherits(DisabledContainer, _TemplateView);

    function DisabledContainer(_ref) {
        var $containerEl = _ref.$containerEl,
            contentComponent = _ref.contentComponent,
            containerClass = _ref.containerClass;

        _classCallCheck(this, DisabledContainer);

        var _this = _possibleConstructorReturn(this, (DisabledContainer.__proto__ || Object.getPrototypeOf(DisabledContainer)).call(this, $containerEl));

        _this.state = {
            disabled: false
        };

        _this.contentComponent = contentComponent;
        _this.containerClass = containerClass;

        _this.onStatePropertyChanged("disabled", function (disabled) {
            return _this.$el.toggleClass("disabled", disabled);
        });
        return _this;
    }

    _createClass(DisabledContainer, [{
        key: "afterRender",
        value: function afterRender() {
            this.contentComponent.init(this.find(".content"));
            this.registerChildComponents(this.contentComponent);
        }
    }, {
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='disabledContainer <%=containerClass%>'>" + "  <div class='content'></div>" + "  <div class='moire'></div>" + "</div>";
        }
    }, {
        key: "setState",
        value: function setState(stateChanges) {
            _get(DisabledContainer.prototype.__proto__ || Object.getPrototypeOf(DisabledContainer.prototype), "setState", this).call(this, stateChanges);
            this.applyForChildrenComponents(function (child) {
                return child.setState(stateChanges);
            });
        }
    }]);

    return DisabledContainer;
}(_TemplateView3.default);

exports.default = DisabledContainer;

/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TabContent2 = __webpack_require__(890);

var _TabContent3 = _interopRequireDefault(_TabContent2);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _constants = __webpack_require__(4);

var _constants2 = __webpack_require__(558);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ManagementAssignmentPanelTabContent = function (_TabContent) {
    _inherits(ManagementAssignmentPanelTabContent, _TabContent);

    function ManagementAssignmentPanelTabContent() {
        _classCallCheck(this, ManagementAssignmentPanelTabContent);

        return _possibleConstructorReturn(this, (ManagementAssignmentPanelTabContent.__proto__ || Object.getPrototypeOf(ManagementAssignmentPanelTabContent)).apply(this, arguments));
    }

    _createClass(ManagementAssignmentPanelTabContent, [{
        key: 'tabHeaderTitle',
        value: function tabHeaderTitle() {
            var tab = this.state.openTab;

            switch (tab) {
                case _constants.HierarchyLevels.TASK:
                    return _messageResource2.default.getMessage('management_assignment.panel.access_selected_tasks', [], true);
                case _constants.HierarchyLevels.PROJECT:
                    return _messageResource2.default.getMessage('management_assignment.panel.access_selected_projects', [], true);
                case _constants.HierarchyLevels.CUSTOMER:
                    return _messageResource2.default.getMessage('management_assignment.panel.access_selected_customers', [], true);
            }

            return "";
        }
    }, {
        key: 'getRevokeConfirmationText',
        value: function getRevokeConfirmationText() {
            var tab = this.state.openTab;
            var userName = this.state.userFirstName || _messageResource2.default.getMessage("common.user");
            var hierarchyLevelName = "";

            switch (tab) {
                case _constants.HierarchyLevels.TASK:
                    hierarchyLevelName = _messageResource2.default.getMessage('common.tasks');
                    break;
                case _constants.HierarchyLevels.PROJECT:
                    hierarchyLevelName = _messageResource2.default.getMessage('common.projects');
                    break;
                case _constants.HierarchyLevels.CUSTOMER:
                    hierarchyLevelName = _messageResource2.default.getMessage('common.customers');
                    break;
            }
            var resultMessage = _messageResource2.default.getMessage('management_assignment.panel.revoke_message', [hierarchyLevelName, userName]);
            if (this.state.isWASEnabled) resultMessage += _messageResource2.default.getMessage('management_assignment.panel.revoke_message_note', [hierarchyLevelName]);

            return resultMessage;
        }
    }, {
        key: '_setEmptyListTitles',
        value: function _setEmptyListTitles() {
            var _titlesMap, _noSelectedTitlesMap, _subtitlesAssignItems, _subtitlesAssignMoreI;

            var userName = this.state.userFirstName || _messageResource2.default.getMessage("common.user");
            this.emptyList.setState({
                titlesMap: (_titlesMap = {}, _defineProperty(_titlesMap, _constants.HierarchyLevels.CUSTOMER, _messageResource2.default.getMessage("management_assignment.empty_customer_list", [userName])), _defineProperty(_titlesMap, _constants.HierarchyLevels.PROJECT, _messageResource2.default.getMessage("management_assignment.empty_project_list", [userName])), _defineProperty(_titlesMap, _constants.HierarchyLevels.TASK, _messageResource2.default.getMessage("management_assignment.empty_task_list", [userName])), _defineProperty(_titlesMap, _constants2.ALL_TABS_EMPTY_KEY, _messageResource2.default.getMessage("management_assignment.empty_list.access_to_scope_not_configured", [userName])), _titlesMap),
                noSelectedTitlesMap: (_noSelectedTitlesMap = {}, _defineProperty(_noSelectedTitlesMap, _constants.HierarchyLevels.CUSTOMER, _messageResource2.default.getMessage("management_assignment.empty_customer_list", [userName])), _defineProperty(_noSelectedTitlesMap, _constants.HierarchyLevels.PROJECT, _messageResource2.default.getMessage("management_assignment.no_selected_projects")), _defineProperty(_noSelectedTitlesMap, _constants.HierarchyLevels.TASK, _messageResource2.default.getMessage("management_assignment.no_selected_tasks")), _defineProperty(_noSelectedTitlesMap, _constants2.ALL_TABS_EMPTY_KEY, _messageResource2.default.getMessage("management_assignment.no_selected_tasks", [userName])), _noSelectedTitlesMap),
                subtitlesAssignItemsMap: (_subtitlesAssignItems = {}, _defineProperty(_subtitlesAssignItems, _constants.HierarchyLevels.CUSTOMER, _messageResource2.default.getMessage("management_assignment.empty_customer_list.grand_access")), _defineProperty(_subtitlesAssignItems, _constants.HierarchyLevels.PROJECT, _messageResource2.default.getMessage("management_assignment.empty_project_list.grand_access")), _defineProperty(_subtitlesAssignItems, _constants.HierarchyLevels.TASK, _messageResource2.default.getMessage("management_assignment.empty_task_list.grand_access")), _defineProperty(_subtitlesAssignItems, _constants2.ALL_TABS_EMPTY_KEY, _messageResource2.default.getMessage("management_assignment.empty_list.grant_access_to_cpt")), _subtitlesAssignItems),
                subtitlesAssignMoreItemsMap: (_subtitlesAssignMoreI = {}, _defineProperty(_subtitlesAssignMoreI, _constants.HierarchyLevels.CUSTOMER, _messageResource2.default.getMessage("management_assignment.empty_customer_list.grand_access_to_more")), _defineProperty(_subtitlesAssignMoreI, _constants.HierarchyLevels.PROJECT, _messageResource2.default.getMessage("management_assignment.empty_project_list.grand_access_to_more", [userName])), _defineProperty(_subtitlesAssignMoreI, _constants.HierarchyLevels.TASK, _messageResource2.default.getMessage("management_assignment.empty_task_list.grand_access_to_more", [userName])), _defineProperty(_subtitlesAssignMoreI, _constants2.ALL_TABS_EMPTY_KEY, _messageResource2.default.getMessage("management_assignment.empty_list.grant_access_to_cpt")), _subtitlesAssignMoreI)
            });
        }
    }]);

    return ManagementAssignmentPanelTabContent;
}(_TabContent3.default);

exports.default = ManagementAssignmentPanelTabContent;

/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _utils = __webpack_require__(549);

var _AssignmentsList = __webpack_require__(891);

var _AssignmentsList2 = _interopRequireDefault(_AssignmentsList);

var _constants = __webpack_require__(4);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _ScrollableContainer = __webpack_require__(49);

var _ScrollableContainer2 = _interopRequireDefault(_ScrollableContainer);

var _TabContentHeader = __webpack_require__(1700);

var _TabContentHeader2 = _interopRequireDefault(_TabContentHeader);

var _EmptyList = __webpack_require__(1701);

var _EmptyList2 = _interopRequireDefault(_EmptyList);

var _EntirelyAssignmentsBlock = __webpack_require__(892);

var _EntirelyAssignmentsBlock2 = _interopRequireDefault(_EntirelyAssignmentsBlock);

var _constants2 = __webpack_require__(558);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TabContent = function (_TemplateView) {
    _inherits(TabContent, _TemplateView);

    function TabContent(_ref) {
        var _ref$onEntityRevoked = _ref.onEntityRevoked,
            onEntityRevoked = _ref$onEntityRevoked === undefined ? function () {} : _ref$onEntityRevoked,
            _ref$onAllRevoked = _ref.onAllRevoked,
            onAllRevoked = _ref$onAllRevoked === undefined ? function () {} : _ref$onAllRevoked,
            _ref$onSearchChanged = _ref.onSearchChanged,
            onSearchChanged = _ref$onSearchChanged === undefined ? function () {} : _ref$onSearchChanged,
            _ref$onSearchToggled = _ref.onSearchToggled,
            onSearchToggled = _ref$onSearchToggled === undefined ? function () {} : _ref$onSearchToggled,
            _ref$setIsShowArchive = _ref.setIsShowArchiveEntities,
            setIsShowArchiveEntities = _ref$setIsShowArchive === undefined ? function () {} : _ref$setIsShowArchive,
            _ref$onEditButtonClic = _ref.onEditButtonClick,
            onEditButtonClick = _ref$onEditButtonClic === undefined ? function () {} : _ref$onEditButtonClic;

        _classCallCheck(this, TabContent);

        var _this = _possibleConstructorReturn(this, (TabContent.__proto__ || Object.getPrototypeOf(TabContent)).call(this));

        _this.params = {
            onEntityRevoked: onEntityRevoked,
            onAllRevoked: onAllRevoked,
            onSearchChanged: onSearchChanged,
            onSearchToggled: onSearchToggled,
            setIsShowArchiveEntities: setIsShowArchiveEntities,
            onEditButtonClick: onEditButtonClick
        };

        _this.state = {
            userFirstName: '',
            counters: {
                customers: {
                    curValue: 0,
                    maxValue: 0
                },
                projects: {
                    curValue: 0,
                    maxValue: 0
                },
                tasks: {
                    curValue: 0,
                    maxValue: 0
                }
            },
            noCptAssignedToUserAtAll: false,

            searchString: '',
            searchOpen: false,

            entirelyAssignedTasksCounter: 0,
            entirelyAssignedProjectsCounter: 0,

            taskEntities: [],
            projectEntities: [],
            customerEntities: [],

            isShowArchivedEntities: false,
            showToggleArchivedButton: true,

            openTab: '',

            isWASEnabled: false
        };

        _this.onStatePropertyChanged('showToggleArchivedButton', function (showToggleArchivedButton) {
            _this.header.setState({ showToggleArchivedButton: showToggleArchivedButton });
        });

        _this.onStatePropertyChanged('counters', function (counters) {
            _this.assignmentsLists[_constants.HierarchyLevels.PROJECT].setState({
                entirelyAssignedPrevLevel: counters.customers.curValue
            });
            _this.assignmentsLists[_constants.HierarchyLevels.TASK].setState({
                entirelyAssignedPrevLevel: counters.projects.curValue
            });
        });

        _this.onAnyStatePropertyChanged(['searchString', 'openTab'], function (_ref2) {
            var searchString = _ref2.searchString,
                openTab = _ref2.openTab;

            if (openTab) _this.assignmentsLists[_this.state.openTab].setState({ searchText: searchString });

            _this.header.setState({ searchText: searchString });
        });

        _this.onStatePropertyChanged('searchOpen', function (searchOpen) {
            _this.header.setState({ searchOpen: searchOpen });
        });

        _this.onStatePropertyChanged('taskEntities', function (entities) {
            _this.assignmentsLists[_constants.HierarchyLevels.TASK].setState({ nodeEntities: entities });
            _this.header.setState({ revokeConfirmationText: _this.getRevokeConfirmationText() });
            _this._handleEmptyTab();
        });
        _this.onStatePropertyChanged('projectEntities', function (entities) {
            _this.assignmentsLists[_constants.HierarchyLevels.PROJECT].setState({ nodeEntities: entities });
            _this.header.setState({ revokeConfirmationText: _this.getRevokeConfirmationText() });
            _this._handleEmptyTab();
        });
        _this.onStatePropertyChanged('customerEntities', function (entities) {
            _this.assignmentsLists[_constants.HierarchyLevels.CUSTOMER].setState({ nodeEntities: entities });
            _this.header.setState({ revokeConfirmationText: _this.getRevokeConfirmationText() });
            _this._handleEmptyTab();
        });

        _this.onStatePropertyChanged('entirelyAssignedTasksCounter', function (taskCounter) {
            _this.assignmentsLists[_constants.HierarchyLevels.TASK].setState({
                entirelyAssignedCurrentLevel: taskCounter
            });
        });
        _this.onStatePropertyChanged('entirelyAssignedProjectsCounter', function (projectsCounter) {
            _this.assignmentsLists[_constants.HierarchyLevels.PROJECT].setState({
                entirelyAssignedCurrentLevel: projectsCounter
            });
        });

        _this.onStatePropertyChanged('openTab', function (tab) {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = Object.keys(_this.assignmentsLists)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var tabName = _step.value;

                    _this.assignmentsLists[tabName].toggle(tabName === tab);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            if (tab) {
                _this.assignmentsLists[tab].forceUpdate();
                _this.assignmentsLists[tab].setState({ isShowArchived: false });
            }

            _this.header.setState({
                title: _this.tabHeaderTitle(),
                hideArchivedButtonText: _this._getHideMessage(tab),
                showArchivedButtonText: _this._getShowMessage(tab),
                isShowArchivedEntities: false,
                revokeConfirmationText: _this.getRevokeConfirmationText()
            });

            _this._handleEmptyTab();
        });

        _this.onStatePropertyChanged('userFirstName', function () {
            _this.header.setState({
                title: _this.tabHeaderTitle(),
                revokeConfirmationText: _this.getRevokeConfirmationText()
            });
            _this._setEmptyListTitles();
        });

        _this.onStatePropertyChanged('isShowArchivedEntities', function (value) {
            _this.header.setState({ isShowArchivedEntities: value });

            if (_this.state.openTab) {
                _this.assignmentsLists[_this.state.openTab].setState({ isShowArchived: value });
            }
        });

        _this.onStatePropertyChanged('isWASEnabled', function () {
            _this.header.setState({
                revokeConfirmationText: _this.getRevokeConfirmationText()
            });
        });
        return _this;
    }

    _createClass(TabContent, [{
        key: "templateHtml",
        value: function templateHtml() {
            return '<div class="tabContent_assignments">' + '  <div class="header"/>' + '  <div class="entirelyAssignmentsBlockContainer"/>' + '  <div class="scrollableContentWrapper">' + '        <div class="scrollableContent"/>' + '  </div>' + '  <div class="emptyCptListContainer"></div>' + '</div>';
        }
    }, {
        key: "templateModel",
        value: function templateModel() {
            return {
                editAssignments: _messageResource2.default.getMessage('common.edit')
            };
        }
    }, {
        key: "update",
        value: function update() {
            if (this.state.openTab) {
                this.assignmentsLists[this.state.openTab].forceUpdate();
            }
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            var _this2 = this,
                _revokeMap;

            this.$header = this.find(".header");
            this.header = new _TabContentHeader2.default({
                onClickToggleArchivedButton: this.params.setIsShowArchiveEntities,
                onAllRevoked: this.params.onAllRevoked,
                onSearchChanged: this.params.onSearchChanged,
                onSearchToggled: this.params.onSearchToggled
            }).init(this.$header);

            var revokeMap = (_revokeMap = {}, _defineProperty(_revokeMap, _constants.HierarchyLevels.CUSTOMER, function (id) {
                return _this2.params.onEntityRevoked(_constants.HierarchyLevels.CUSTOMER, id);
            }), _defineProperty(_revokeMap, _constants.HierarchyLevels.PROJECT, function (id) {
                return _this2.params.onEntityRevoked(_constants.HierarchyLevels.PROJECT, id);
            }), _defineProperty(_revokeMap, _constants.HierarchyLevels.TASK, function (id) {
                return _this2.params.onEntityRevoked(_constants.HierarchyLevels.TASK, id);
            }), _revokeMap);

            this.$entirelyAssignmentsBlockContainer = this.find('.entirelyAssignmentsBlockContainer');
            this.entirelyAssignmentsBlock = new _EntirelyAssignmentsBlock2.default().init(this.$entirelyAssignmentsBlockContainer);

            this.$scrollableContent = this.find('.scrollableContent');
            this.$scrollableContentWrapper = this.find('.scrollableContentWrapper');

            this.assignmentsLists = {};

            this.assignmentsLists[_constants.HierarchyLevels.CUSTOMER] = this.createScrollableList({
                revokeMap: revokeMap,
                entirelyAssignedTitle: _utils.entirelyAssignedCustomerTitle,
                entirelyAssignedSubTitle: "",
                createNodesForList: _utils.createNodesForCustomerList,
                hierarchyLevel: _constants.HierarchyLevels.CUSTOMER
            }).init(this.$scrollableContent);

            this.assignmentsLists[_constants.HierarchyLevels.PROJECT] = this.createScrollableList({
                revokeMap: revokeMap,
                entirelyAssignedTitle: _utils.entirelyAssignedProjectTitle,
                entirelyAssignedSubTitle: _messageResource2.default.getMessage('work_assignments.panel.projects.plus_selected'),
                createNodesForList: _utils.createNodesForProjectList,
                hierarchyLevel: _constants.HierarchyLevels.PROJECT
            }).init(this.$scrollableContent);

            this.assignmentsLists[_constants.HierarchyLevels.TASK] = this.createScrollableList({
                revokeMap: revokeMap,
                entirelyAssignedTitle: _utils.entirelyAssignedTaskTitle,
                entirelyAssignedSubTitle: _messageResource2.default.getMessage('work_assignments.panel.tasks.plus_selected'),
                createNodesForList: _utils.createNodesForTaskList,
                hierarchyLevel: _constants.HierarchyLevels.TASK
            }).init(this.$scrollableContent);

            this.$emptyList = this.find('.emptyCptListContainer');
            this.emptyList = new _EmptyList2.default({ actionOnEmptyList: function actionOnEmptyList() {
                    return _this2.params.onEditButtonClick();
                } }).init(this.$emptyList);
            this._setEmptyListTitles();
        }
    }, {
        key: "createScrollableList",
        value: function createScrollableList(_ref3) {
            var revokeMap = _ref3.revokeMap,
                entirelyAssignedTitle = _ref3.entirelyAssignedTitle,
                entirelyAssignedSubTitle = _ref3.entirelyAssignedSubTitle,
                createNodesForList = _ref3.createNodesForList,
                hierarchyLevel = _ref3.hierarchyLevel;

            return new _ScrollableContainer2.default(null, new _AssignmentsList2.default({
                revokeMap: revokeMap,
                entirelyAssignedTitle: entirelyAssignedTitle,
                entirelyAssignedSubTitle: entirelyAssignedSubTitle,
                createNodesForList: createNodesForList,
                hierarchyLevel: hierarchyLevel
            }), {
                containerClass: "scrollableList"
            });
        }
    }, {
        key: "_handleEmptyTab",
        value: function _handleEmptyTab() {
            var openTab = this.state.openTab;
            var listIsEmpty = false;
            var entirelyAssignedText = "";
            var plusSelectedText = "";
            var canRevoke = true;
            if (openTab === _constants.HierarchyLevels.TASK) {
                listIsEmpty = this.state.taskEntities.length === 0;
                entirelyAssignedText = (0, _utils.entirelyAssignedTaskTitle)(this.state.entirelyAssignedTasksCounter, this.state.counters.projects.curValue);
                plusSelectedText = _messageResource2.default.getMessage('work_assignments.panel.tasks.plus_selected');
                canRevoke = this._containsRevokableEntities({ entities: this.state.taskEntities, type: _constants.HierarchyLevels.TASK });
            } else if (openTab === _constants.HierarchyLevels.PROJECT) {
                listIsEmpty = this.state.projectEntities.length === 0;
                entirelyAssignedText = (0, _utils.entirelyAssignedProjectTitle)(this.state.entirelyAssignedProjectsCounter, this.state.counters.customers.curValue);
                plusSelectedText = _messageResource2.default.getMessage('work_assignments.panel.projects.plus_selected');
                canRevoke = this._containsRevokableEntities({ entities: this.state.projectEntities, type: _constants.HierarchyLevels.PROJECT });
            } else if (openTab === _constants.HierarchyLevels.CUSTOMER) {
                listIsEmpty = this.state.customerEntities.length === 0;
                canRevoke = this._containsRevokableEntities({ entities: this.state.customerEntities, type: _constants.HierarchyLevels.CUSTOMER });
            }

            var isSearchResult = this.state.searchOpen;
            var showEmptyListView = listIsEmpty && !isSearchResult;
            var assignmentsFromTopLevel = !!entirelyAssignedText;
            var allCountersZero = this.state.counters.tasks.curValue === 0 && this.state.counters.projects.curValue === 0 && this.state.counters.customers.curValue === 0;

            this.$emptyList.toggle(showEmptyListView);
            var noWorkScopeWarningText = this.state.noCptAssignedToUserAtAll ? _messageResource2.default.getMessage('work_assignments.empty_list.no_work', [this.state.userFirstName]) : "";
            this.emptyList.setState({
                openTabKey: allCountersZero ? _constants2.ALL_TABS_EMPTY_KEY : openTab,
                isNoSelectedTitle: assignmentsFromTopLevel,
                isAssignMoreSubtitle: assignmentsFromTopLevel,
                withBorderAndBackground: !assignmentsFromTopLevel,
                noWorkScopeWarningText: noWorkScopeWarningText
            });
            this.entirelyAssignmentsBlock.setState({
                title: entirelyAssignedText,
                plusSelectedItemsText: plusSelectedText
            });
            this.$entirelyAssignmentsBlockContainer.toggle(showEmptyListView && assignmentsFromTopLevel);
            this.$scrollableContentWrapper.toggle(!showEmptyListView);
            this.$header.toggle(!showEmptyListView || assignmentsFromTopLevel);
            this.header.setState({
                searchDisabled: showEmptyListView,
                revokeDisabled: showEmptyListView || !canRevoke
            });

            this.update();
        }
    }, {
        key: "_containsRevokableEntities",
        value: function _containsRevokableEntities(_ref4) {
            var entities = _ref4.entities,
                type = _ref4.type;

            return entities.some(function (entity) {
                return entity.type === type && entity.revokeEnabled;
            });
        }
    }, {
        key: "_getHideMessage",
        value: function _getHideMessage(tab) {
            if (tab === _constants.HierarchyLevels.TASK) {
                return _messageResource2.default.getMessage("management_assignment.hide_completed");
            }

            return _messageResource2.default.getMessage("management_assignment.hide_archived");
        }
    }, {
        key: "_getShowMessage",
        value: function _getShowMessage(tab) {
            if (tab === _constants.HierarchyLevels.TASK) {
                return _messageResource2.default.getMessage("management_assignment.show_completed");
            }

            return _messageResource2.default.getMessage("management_assignment.show_archived");
        }
    }, {
        key: "tabHeaderTitle",
        value: function tabHeaderTitle() {
            //abstract
        }
    }, {
        key: "getRevokeConfirmationText",
        value: function getRevokeConfirmationText() {
            //abstract
        }
    }, {
        key: "_setEmptyListTitles",
        value: function _setEmptyListTitles() {
            //abstract
        }
    }]);

    return TabContent;
}(_TemplateView3.default);

exports.default = TabContent;

/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _TextNode = __webpack_require__(1699);

var _TextNode2 = _interopRequireDefault(_TextNode);

var _constants = __webpack_require__(4);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _EntirelyAssignmentsBlock = __webpack_require__(892);

var _EntirelyAssignmentsBlock2 = _interopRequireDefault(_EntirelyAssignmentsBlock);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AssignmentsList = function (_TemplateView) {
    _inherits(AssignmentsList, _TemplateView);

    function AssignmentsList(_ref) {
        var _ref$entirelyAssigned = _ref.entirelyAssignedTitle,
            entirelyAssignedTitle = _ref$entirelyAssigned === undefined ? function (currentCount, prevCount) {} : _ref$entirelyAssigned,
            _ref$entirelyAssigned2 = _ref.entirelyAssignedSubTitle,
            entirelyAssignedSubTitle = _ref$entirelyAssigned2 === undefined ? "" : _ref$entirelyAssigned2,
            _ref$createNodesForLi = _ref.createNodesForList,
            createNodesForList = _ref$createNodesForLi === undefined ? function (nodeEntities, searchText, revokeMap) {} : _ref$createNodesForLi,
            _ref$revokeMap = _ref.revokeMap,
            revokeMap = _ref$revokeMap === undefined ? {} : _ref$revokeMap,
            _ref$actionOnEmptyLis = _ref.actionOnEmptyList,
            actionOnEmptyList = _ref$actionOnEmptyLis === undefined ? function () {} : _ref$actionOnEmptyLis,
            _ref$hierarchyLevel = _ref.hierarchyLevel,
            hierarchyLevel = _ref$hierarchyLevel === undefined ? null : _ref$hierarchyLevel;

        _classCallCheck(this, AssignmentsList);

        var _this = _possibleConstructorReturn(this, (AssignmentsList.__proto__ || Object.getPrototypeOf(AssignmentsList)).call(this));

        _this.params = {
            entirelyAssignedTitle: entirelyAssignedTitle,
            entirelyAssignedSubTitle: entirelyAssignedSubTitle,
            createNodesForList: createNodesForList,
            revokeMap: revokeMap,
            actionOnEmptyList: actionOnEmptyList,
            hierarchyLevel: hierarchyLevel
        };

        _this.state = {
            searchText: "",
            nodeEntities: [],

            entirelyAssignedCurrentLevel: 0,
            entirelyAssignedPrevLevel: 0,

            title: null,
            assignmentsNodes: [],
            isShowArchived: false
        };

        _this.onAnyStatePropertyChanged(['nodeEntities', 'isShowArchived'], function () {
            _this._createNodeList();
        });

        _this.onStateChanged(function () {
            var title = _this.params.entirelyAssignedTitle(_this.state.entirelyAssignedCurrentLevel, _this.state.entirelyAssignedPrevLevel);
            if (title) {
                _this.entireAssignmentsBlock.setState({
                    title: title,
                    plusSelectedItemsText: _this.params.entirelyAssignedSubTitle
                });
            }

            _this.$entireAssignmentsBlockContainer.toggle(!!title);

            _this.$notFoundMessage.toggle(!_underscore2.default.isEmpty(_this.state.searchText) && _underscore2.default.isEmpty(title) && _this.state.nodeEntities.length === 0);

            _this.$notFoundMessage.text(_this._getTaskNotFoundMessage());
        });
        return _this;
    }

    _createClass(AssignmentsList, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return "<div class='workAssignments_list'>" + " <div class='entireAssignmentsBlockContainer'></div>" + " <div class='list'></div>" + " <div class='notFoundMessage'></div>" + "</div>";
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            this.$entireAssignmentsBlockContainer = this.find(".entireAssignmentsBlockContainer");
            this.entireAssignmentsBlock = new _EntirelyAssignmentsBlock2.default().init(this.$entireAssignmentsBlockContainer);
            this.$list = this.find(".list");
            this.$notFoundMessage = this.find('.notFoundMessage');

            this._createNodeList();
        }
    }, {
        key: '_createNodeList',
        value: function _createNodeList() {
            this.$list.empty();

            if (this.state.nodeEntities.length) {
                var nodes = this.params.createNodesForList(this.state.nodeEntities, this.state.searchText, this.params.revokeMap, this.state.isShowArchived);

                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = nodes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var prop = _step.value;

                        var deepestLevel = this.params.hierarchyLevel === prop.type;
                        new _TextNode2.default({
                            id: prop.id,
                            type: prop.type,
                            additionalClass: prop.additionalClass,
                            needRevokeButton: deepestLevel
                        }).init(this.$list).setState(prop);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        }
    }, {
        key: '_getTaskNotFoundMessage',
        value: function _getTaskNotFoundMessage() {

            switch (this.params.hierarchyLevel) {
                case _constants.HierarchyLevels.CUSTOMER:
                    return _messageResource2.default.getMessage('common.customers_not_found_message');
                case _constants.HierarchyLevels.PROJECT:
                    return _messageResource2.default.getMessage('common.projects_not_found_message');
                case _constants.HierarchyLevels.TASK:
                    return _messageResource2.default.getMessage('common.tasks_not_found_message');
            }
        }
    }]);

    return AssignmentsList;
}(_TemplateView3.default);

exports.default = AssignmentsList;

/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EntirelyAssignmentsBlock = function (_TemplateView) {
    _inherits(EntirelyAssignmentsBlock, _TemplateView);

    function EntirelyAssignmentsBlock() {
        _classCallCheck(this, EntirelyAssignmentsBlock);

        var _this = _possibleConstructorReturn(this, (EntirelyAssignmentsBlock.__proto__ || Object.getPrototypeOf(EntirelyAssignmentsBlock)).call(this));

        _this.state = {
            title: "",
            plusSelectedItemsText: ""
        };

        _this.onStatePropertyChanged("title", function (title) {
            _this.$entireTitle.text(title);
        });

        _this.onStatePropertyChanged("plusSelectedItemsText", function (text) {
            _this.$plusSelectedItems.text(text);
        });
        return _this;
    }

    _createClass(EntirelyAssignmentsBlock, [{
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='entirelyAssignmentsBlock'>" + "    <div class='entireTitle'></div>" + "    <div class='plusSelectedItems'></div>" + "</div>";
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            this.$entireTitle = this.find('.entireTitle');
            this.$plusSelectedItems = this.find('.plusSelectedItems');
        }
    }]);

    return EntirelyAssignmentsBlock;
}(_TemplateView3.default);

exports.default = EntirelyAssignmentsBlock;

/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _View2 = __webpack_require__(20);

var _View3 = _interopRequireDefault(_View2);

var _TeamAssignmentsPanelContent = __webpack_require__(1703);

var _TeamAssignmentsPanelContent2 = _interopRequireDefault(_TeamAssignmentsPanelContent);

var _utils = __webpack_require__(25);

var _constants = __webpack_require__(62);

var _PanelContainer = __webpack_require__(109);

var _PanelContainer2 = _interopRequireDefault(_PanelContainer);

var _LoadingContainer = __webpack_require__(28);

var _LoadingContainer2 = _interopRequireDefault(_LoadingContainer);

var _constants2 = __webpack_require__(21);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TeamAssignmentsPanelContainer = function (_View) {
    _inherits(TeamAssignmentsPanelContainer, _View);

    function TeamAssignmentsPanelContainer(_ref) {
        var _ref$showCopyButton = _ref.showCopyButton,
            showCopyButton = _ref$showCopyButton === undefined ? true : _ref$showCopyButton,
            _ref$additionalClass = _ref.additionalClass,
            additionalClass = _ref$additionalClass === undefined ? '' : _ref$additionalClass,
            _ref$onPanelHide = _ref.onPanelHide,
            onPanelHide = _ref$onPanelHide === undefined ? function () {} : _ref$onPanelHide,
            _ref$onCloseButtonCli = _ref.onCloseButtonClick,
            onCloseButtonClick = _ref$onCloseButtonCli === undefined ? function () {} : _ref$onCloseButtonCli,
            _ref$changeTeamAssign = _ref.changeTeamAssignments,
            changeTeamAssignments = _ref$changeTeamAssign === undefined ? function () {} : _ref$changeTeamAssign,
            _ref$loadTeamAssignme = _ref.loadTeamAssignmentsData,
            loadTeamAssignmentsData = _ref$loadTeamAssignme === undefined ? function () {} : _ref$loadTeamAssignme,
            _ref$showCopyContent = _ref.showCopyContent,
            showCopyContent = _ref$showCopyContent === undefined ? function () {} : _ref$showCopyContent;

        _classCallCheck(this, TeamAssignmentsPanelContainer);

        var _this = _possibleConstructorReturn(this, (TeamAssignmentsPanelContainer.__proto__ || Object.getPrototypeOf(TeamAssignmentsPanelContainer)).call(this));

        _this.params = {
            additionalClass: additionalClass,
            showCopyButton: showCopyButton
        };

        _this.callbacks = {
            onPanelHide: onPanelHide,
            onCloseButtonClick: onCloseButtonClick,
            changeTeamAssignments: changeTeamAssignments,
            loadTeamAssignmentsData: loadTeamAssignmentsData,
            showCopyContent: showCopyContent
        };

        _this.state = {
            isShown: false,
            userPanelOpenedBelow: false,
            needToLoadData: false,
            loading: false,
            disabled: false,

            assignedGroupIds: [],
            assignedUserIds: [],
            users: [],
            userGroups: [],
            isUGREnabled: false,
            teamAssignmentType: _constants2.UserTeamAssignmentType.SELECTED,
            userFML: {},
            userId: '',

            showCopyContent: false,
            copyContentLoading: false
        };

        _this.onStatePropertyChanged('isShown', function (isShown) {
            _this.teamAssignmentsPanelContainer.setState({ isShown: isShown });
            if (isShown) _this.teamAssignmentsPanel.update();
        });

        _this.onStatePropertyChanged('userPanelOpenedBelow', function (userPanelOpenedBelow) {
            _this.teamAssignmentsPanel.setState({
                withBackButton: userPanelOpenedBelow
            });
        });

        _this.onStatePropertyBecameTrue('needToLoadData', function () {
            _this.callbacks.loadTeamAssignmentsData();
        });

        _this.onStatePropertyChanged('loading', function (loading) {
            _this.teamAssignmentsLoadingContainer.setState({
                loading: loading
            });
        });

        _this.onStatePropertyChanged('disabled', function (disabled) {
            return _this.teamAssignmentsPanel.setState({ disabled: disabled });
        });

        _this.onAnyStatePropertyChanged(['users', 'userGroups', 'teamAssignmentType', 'assignedGroupIds', 'assignedUserIds', 'isUGREnabled'], function () {
            _this.teamAssignmentsPanel.setState({
                teamAssignmentType: _this.state.teamAssignmentType,
                assignedGroupIds: _this.state.assignedGroupIds,
                assignedUserIds: _this.state.assignedUserIds,
                users: _this.state.users,
                userGroups: _this.state.userGroups,
                isUGREnabled: _this.state.isUGREnabled
            });
        });

        _this.onStatePropertyChanged('userFML', function (userFML) {
            _this.teamAssignmentsPanel.setState({
                userFML: userFML
            });
        });

        _this.onStatePropertyChanged('userId', function (userId) {
            _this.teamAssignmentsPanel.setState({
                userId: userId
            });
        });

        _this.onStatePropertyChanged('showCopyContent', function (showCopyContent) {
            return _this.teamAssignmentsPanel.setState({ showCopyContent: showCopyContent });
        });
        _this.onStatePropertyChanged('copyContentLoading', function (copyContentLoading) {
            return _this.teamAssignmentsPanel.setState({ copyContentLoading: copyContentLoading });
        });
        return _this;
    }

    _createClass(TeamAssignmentsPanelContainer, [{
        key: "afterRender",
        value: function afterRender() {
            var _this2 = this;

            this.teamAssignmentsPanel = new _TeamAssignmentsPanelContent2.default({
                showCopyButton: this.params.showCopyButton,
                onChangeDialogData: function onChangeDialogData(data) {
                    _this2.callbacks.changeTeamAssignments({
                        teamAssignmentType: data.teamAssignmentType,
                        assignedGroupIds: data.assignedGroupIds,
                        assignedUserIds: data.assignedUserIds
                    });
                },
                onCopyFromButtonClick: this.callbacks.showCopyContent,
                onBackButtonClick: function onBackButtonClick() {
                    return _this2.callbacks.onPanelHide();
                },
                onClickDialogContent: function onClickDialogContent(e) {
                    return (0, _utils.setEventPreventHidingEditUserSlidingPanel)(e);
                }
            });

            this.teamAssignmentsLoadingContainer = new _LoadingContainer2.default({
                contentComponent: this.teamAssignmentsPanel,
                containerClass: 'teamAssignmentPanelLoadingWrapper',
                loadingMoireConfig: {
                    delay: 500
                }
            });

            this.teamAssignmentsPanelContainer = new _PanelContainer2.default({
                component: this.teamAssignmentsLoadingContainer,
                additionalClass: "team_assignment_panel " + this.params.additionalClass,
                showAnimationClass: _constants.SHOW_ANIMATION_CLASSES.SLIDE_LEFT,
                hideAnimationClass: _constants.HIDE_ANIMATION_CLASSES.SLIDE_LEFT,
                showHideButton: true,
                hideOnEsc: true,
                hideOnClickOutside: {
                    hideOnClick: true,
                    panelType: _constants.PANEL_TYPES.TEAM_ASSIGNMENT
                },
                onHideCallback: function onHideCallback() {
                    return _this2.callbacks.onPanelHide();
                },
                onClickCloseButton: function onClickCloseButton() {
                    return _this2.callbacks.onCloseButtonClick();
                },
                hideHandler: function hideHandler() {
                    return _this2.teamAssignmentsPanelContainer.setState({ isShown: false });
                }
            }).init(this.$containerEl);
        }
    }]);

    return TeamAssignmentsPanelContainer;
}(_View3.default);

exports.default = TeamAssignmentsPanelContainer;

/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ListItem = function (_TemplateView) {
    _inherits(ListItem, _TemplateView);

    function ListItem(_ref) {
        var _ref$text = _ref.text,
            text = _ref$text === undefined ? '' : _ref$text,
            _ref$additionalClass = _ref.additionalClass,
            additionalClass = _ref$additionalClass === undefined ? '' : _ref$additionalClass,
            _ref$onClick = _ref.onClick,
            onClick = _ref$onClick === undefined ? function () {} : _ref$onClick;

        _classCallCheck(this, ListItem);

        var _this = _possibleConstructorReturn(this, (ListItem.__proto__ || Object.getPrototypeOf(ListItem)).call(this));

        _this.params = {
            text: text,
            additionalClass: additionalClass,
            onClick: onClick
        };
        return _this;
    }

    _createClass(ListItem, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class="item <%=additionalClass%>"><%-text%></div>';
        }
    }, {
        key: 'templateModel',
        value: function templateModel() {
            return {
                text: this.params.text,
                additionalClass: this.params.additionalClass
            };
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            var _this2 = this;

            this.$el.click(function () {
                return _this2.params.onClick();
            });
        }
    }]);

    return ListItem;
}(_TemplateView3.default);

exports.default = ListItem;

/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getUserFML = exports.getUsers = exports.getUserGroups = exports.getTeamAssignmentType = exports.getAssignedGroupIds = exports.getAssignedUserIds = exports.isUpdatingData = exports.isLoading = exports.isEditUserPanelOpened = exports.selectUserData = undefined;

var _reselect = __webpack_require__(13);

var _selector = __webpack_require__(255);

var _groupUtils = __webpack_require__(71);

var _selectors = __webpack_require__(14);

var _GroupType = __webpack_require__(34);

var _GroupType2 = _interopRequireDefault(_GroupType);

var _selectors2 = __webpack_require__(146);

var _selectors3 = __webpack_require__(64);

var _User = __webpack_require__(119);

var _User2 = _interopRequireDefault(_User);

var _user_group_selector_util = __webpack_require__(98);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getUserManagementCommonState = function getUserManagementCommonState(state) {
    return state.userManagement.common;
};

//TODO better use selector getUsersList from userManagement/common, but this module imported in it, think about better way for getEditingUserId selector
var getUsersMap = (0, _reselect.createSelector)(getUserManagementCommonState, function (commonState) {
    return commonState.usersList;
});

var selectUserData = exports.selectUserData = (0, _reselect.createSelector)(_selector.selectUserPanel, function (userPanel) {
    return userPanel.userData;
});

var isEditUserPanelOpened = exports.isEditUserPanelOpened = function isEditUserPanelOpened(state) {
    return (0, _selectors2.isPanelOpened)(state);
};
var isLoading = exports.isLoading = function isLoading(state) {
    return (0, _selectors2.isLoading)(state);
};
var isUpdatingData = exports.isUpdatingData = function isUpdatingData(state) {
    return (0, _selectors2.isUpdatingData)(state);
};

var getTeamAssignmentsData = (0, _reselect.createSelector)(selectUserData, function (userData) {
    return userData.userTeamAssignmentsData;
});

var getAssignedUserIds = exports.getAssignedUserIds = (0, _reselect.createSelector)(getTeamAssignmentsData, function (teamAssignmentsData) {
    return teamAssignmentsData.assignedUsers;
});

var getAssignedGroupIds = exports.getAssignedGroupIds = (0, _reselect.createSelector)(getTeamAssignmentsData, function (teamAssignmentsData) {
    return teamAssignmentsData.assignedGroups;
});

var getTeamAssignmentType = exports.getTeamAssignmentType = (0, _reselect.createSelector)(getTeamAssignmentsData, function (teamAssignmentsData) {
    return teamAssignmentsData.teamAssignmentType;
});

var getUserGroups = exports.getUserGroups = (0, _reselect.createSelector)(_selectors.getUserGroupsWithDefault, function (userGroupsWithDefault) {
    return Object.values(userGroupsWithDefault).sort((0, _groupUtils.createGroupComparator)(_GroupType2.default.USER_GROUP));
});

var getUsers = exports.getUsers = (0, _reselect.createSelector)(getUsersMap, function (users) {
    return Object.values(users).map(function (user) {
        return new _User2.default(user["id"], user["firstName"], user["lastName"], user["middleInitial"], user["username"], user["activeInAT"] || user["enabled"], false, user["userGroupId"], user["timeZoneGroupId"]);
    }).sort(_user_group_selector_util.userComparator);
});

var getUserFML = exports.getUserFML = (0, _reselect.createSelector)(_selectors3.getFullUserInfo, function (fullUserInfo) {
    return fullUserInfo ? {
        firstName: fullUserInfo.firstName,
        middleInitial: fullUserInfo.middleInitial,
        lastName: fullUserInfo.lastName
    } : {};
});

/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _GroupItem = __webpack_require__(897);

var _GroupItem2 = _interopRequireDefault(_GroupItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ManageGroupsDropdownDialog = function (_TemplateView) {
    _inherits(ManageGroupsDropdownDialog, _TemplateView);

    function ManageGroupsDropdownDialog(_ref) {
        var _ref$timeZoneOnClick = _ref.timeZoneOnClick,
            timeZoneOnClick = _ref$timeZoneOnClick === undefined ? function () {} : _ref$timeZoneOnClick,
            _ref$departmentsOnCli = _ref.departmentsOnClick,
            departmentsOnClick = _ref$departmentsOnCli === undefined ? function () {} : _ref$departmentsOnCli;

        _classCallCheck(this, ManageGroupsDropdownDialog);

        var _this = _possibleConstructorReturn(this, (ManageGroupsDropdownDialog.__proto__ || Object.getPrototypeOf(ManageGroupsDropdownDialog)).call(this));

        _this.timeZoneOnClick = timeZoneOnClick;
        _this.departmentOnClick = departmentsOnClick;
        return _this;
    }

    _createClass(ManageGroupsDropdownDialog, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return "<div></div>";
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            new _GroupItem2.default({
                type: _GroupItem.Type.TIME_ZONE_GROUP,
                additionalClass: 'option',
                onClick: this.timeZoneOnClick
            }).init(this.$el);

            new _GroupItem2.default({
                type: _GroupItem.Type.DEPARTMENT,
                additionalClass: 'option',
                onClick: this.departmentOnClick
            }).init(this.$el);
        }
    }]);

    return ManageGroupsDropdownDialog;
}(_TemplateView3.default);

exports.default = ManageGroupsDropdownDialog;

/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Type = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Type = exports.Type = {
    DEPARTMENT: 'department',
    TIME_ZONE_GROUP: 'timeZoneGroup'
};

var GroupItem = function (_TemplateView) {
    _inherits(GroupItem, _TemplateView);

    function GroupItem(_ref) {
        var _ref$type = _ref.type,
            type = _ref$type === undefined ? Type.DEPARTMENT : _ref$type,
            _ref$additionalClass = _ref.additionalClass,
            additionalClass = _ref$additionalClass === undefined ? '' : _ref$additionalClass,
            _ref$onClick = _ref.onClick,
            onClick = _ref$onClick === undefined ? function (type) {} : _ref$onClick;

        _classCallCheck(this, GroupItem);

        var _this = _possibleConstructorReturn(this, (GroupItem.__proto__ || Object.getPrototypeOf(GroupItem)).call(this, null));

        _this.type = type;
        _this.additionalClass = additionalClass;
        _this.onClick = onClick;

        _this.text = type === Type.DEPARTMENT ? _messageResource2.default.getMessage('userlist.manage_user_groups') : _messageResource2.default.getMessage('userlist.manage_time_zone_groups');
        return _this;
    }

    _createClass(GroupItem, [{
        key: 'afterRender',
        value: function afterRender() {
            var _this2 = this;

            this.$el.on('click', function () {
                _this2.onClick(_this2.type);
            });
        }
    }, {
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class="userList_manageButtons_component_groupItem <%=type%> <%=additionalClass%>">' + '  <%-text%>' + '</div>';
        }
    }]);

    return GroupItem;
}(_TemplateView3.default);

exports.default = GroupItem;

/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _GroupItem = __webpack_require__(897);

var _GroupItem2 = _interopRequireDefault(_GroupItem);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ManageGroupsButton = function (_TemplateView) {
    _inherits(ManageGroupsButton, _TemplateView);

    function ManageGroupsButton(_ref) {
        var _ref$onButtonClick = _ref.onButtonClick,
            onButtonClick = _ref$onButtonClick === undefined ? function () {} : _ref$onButtonClick;

        _classCallCheck(this, ManageGroupsButton);

        var _this = _possibleConstructorReturn(this, (ManageGroupsButton.__proto__ || Object.getPrototypeOf(ManageGroupsButton)).call(this));

        _this.onButtonClick = onButtonClick;

        _this.state = {
            isUGREnabled: false,
            isTZGEnabled: false,
            disabled: false
        };

        _this.onAnyStatePropertyChanged(['isUGREnabled', 'isTZGEnabled'], function () {
            var bothGroupsEnabled = _this.state.isTZGEnabled && _this.state.isUGREnabled;
            _this.$el.empty();
            _this.$el.toggleClass('bothGroups', bothGroupsEnabled);
            if (bothGroupsEnabled) {
                _this.$el.text(_messageResource2.default.getMessage('userlist.manage_groups'));
            } else if (_this.state.isUGREnabled) {
                new _GroupItem2.default({
                    type: _GroupItem.Type.DEPARTMENT
                }).init(_this.$el);
            } else {
                new _GroupItem2.default({
                    type: _GroupItem.Type.TIME_ZONE_GROUP
                }).init(_this.$el);
            }
        });

        _this.onStatePropertyChanged('disabled', function (disabled) {
            return _this.$el.toggleClass('disabled', disabled);
        });
        return _this;
    }

    _createClass(ManageGroupsButton, [{
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='userList_manageButtons_component_manageGroupsButton'></div>";
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            var _this2 = this;

            this.$el.on('click', function () {
                if (!_this2.state.disabled) {
                    _this2.onButtonClick();
                }
            });
        }
    }]);

    return ManageGroupsButton;
}(_TemplateView3.default);

exports.default = ManageGroupsButton;

/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _SortLink = __webpack_require__(1724);

var _SortLink2 = _interopRequireDefault(_SortLink);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _constants = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TableControls = function (_TemplateView) {
    _inherits(TableControls, _TemplateView);

    function TableControls(_ref) {
        var _ref$usersFilterCompo = _ref.usersFilterComponent,
            usersFilterComponent = _ref$usersFilterCompo === undefined ? null : _ref$usersFilterCompo,
            _ref$wordsFilterCompo = _ref.wordsFilterComponent,
            wordsFilterComponent = _ref$wordsFilterCompo === undefined ? null : _ref$wordsFilterCompo,
            _ref$onUserSortClick = _ref.onUserSortClick,
            onUserSortClick = _ref$onUserSortClick === undefined ? function () {} : _ref$onUserSortClick,
            _ref$onUserGroupSortC = _ref.onUserGroupSortClick,
            onUserGroupSortClick = _ref$onUserGroupSortC === undefined ? function () {} : _ref$onUserGroupSortC,
            _ref$onTimeZoneSortCl = _ref.onTimeZoneSortClick,
            onTimeZoneSortClick = _ref$onTimeZoneSortCl === undefined ? function () {} : _ref$onTimeZoneSortCl;

        _classCallCheck(this, TableControls);

        var _this = _possibleConstructorReturn(this, (TableControls.__proto__ || Object.getPrototypeOf(TableControls)).call(this, null));

        _this.params = {
            usersFilterComponent: usersFilterComponent,
            wordsFilterComponent: wordsFilterComponent,
            onUserSortClick: onUserSortClick,
            onUserGroupSortClick: onUserGroupSortClick,
            onTimeZoneSortClick: onTimeZoneSortClick
        };

        _this.state = {
            showUserGroups: false,
            showTimeZoneGroups: false,
            sorting: {
                order: -1,
                asc: false
            }
        };

        _this.onStateChanged(function () {
            _this.userGroupSortLink.getEl().toggleClass('hidden', !_this.state.showUserGroups);
            _this.timeZoneSortLink.getEl().toggleClass('hidden', !_this.state.showTimeZoneGroups);

            var _this$state$sorting = _this.state.sorting,
                order = _this$state$sorting.order,
                asc = _this$state$sorting.asc;

            _this.userSortLink.setState({
                asc: asc,
                active: order === _constants.UserManagementConstants.USER_LIST_ORDER_BY_NAME
            });
            _this.userGroupSortLink.setState({
                asc: asc,
                active: order === _constants.UserManagementConstants.USER_LIST_ORDER_BY_GROUP_NAME
            });
            _this.timeZoneSortLink.setState({
                asc: asc,
                active: order === _constants.UserManagementConstants.USER_LIST_ORDER_BY_TIME_ZONE_GROUP_NAME
            });
        });
        return _this;
    }

    _createClass(TableControls, [{
        key: "templateHtml",
        value: function templateHtml() {
            return '<div class="userList_tableControlsContainer">' + '  <div class="usersFilter"></div>' + '  <div class="sortLinks"></div>' + '  <div class="wordsFilter"></div>' + '</div>';
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            if (this.params.usersFilterComponent) {
                this.params.usersFilterComponent.init(this.find('.usersFilter'));
            }
            if (this.params.wordsFilterComponent) {
                this.params.wordsFilterComponent.init(this.find('.wordsFilter'));
            }

            var sortLinksContainer = this.find('.sortLinks');
            this.userSortLink = new _SortLink2.default({
                title: _messageResource2.default.getMessage('userlist.head.name')
            }).init(sortLinksContainer);
            this.userSortLink.getEl().on('click', this.params.onUserSortClick);
            this.userGroupSortLink = new _SortLink2.default({
                title: _messageResource2.default.getMessage('userlist.usertable.group'),
                clazz: 'userGroup'
            }).init(sortLinksContainer);
            this.userGroupSortLink.getEl().on('click', this.params.onUserGroupSortClick);
            this.timeZoneSortLink = new _SortLink2.default({
                title: _messageResource2.default.getMessage('userlist.usertable.time_zone'),
                clazz: 'timeZoneGroup'
            }).init(sortLinksContainer);
            this.timeZoneSortLink.getEl().on('click', this.params.onTimeZoneSortClick);
        }
    }]);

    return TableControls;
}(_TemplateView3.default);

exports.default = TableControls;

/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @author makovchik.
 * @since 16.08.2018.
 */
var ActionButton = function (_TemplateView) {
    _inherits(ActionButton, _TemplateView);

    function ActionButton(_ref) {
        var _ref$title = _ref.title,
            title = _ref$title === undefined ? '' : _ref$title,
            _ref$extraClass = _ref.extraClass,
            extraClass = _ref$extraClass === undefined ? '' : _ref$extraClass,
            _ref$actionClick = _ref.actionClick,
            actionClick = _ref$actionClick === undefined ? function () {} : _ref$actionClick,
            _ref$hideMenu = _ref.hideMenu,
            hideMenu = _ref$hideMenu === undefined ? {} : _ref$hideMenu;

        _classCallCheck(this, ActionButton);

        var _this = _possibleConstructorReturn(this, (ActionButton.__proto__ || Object.getPrototypeOf(ActionButton)).call(this));

        _this.params = {
            title: title,
            extraClass: extraClass
        };

        _this.callbacks = {
            actionClick: actionClick,
            hideMenu: hideMenu
        };
        return _this;
    }

    _createClass(ActionButton, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return "  <div class='item <%-extraClass%>'>" + "    <div class='img'></div>" + "    <div class='action'><%-title%></div>" + "  </div>";
        }
    }, {
        key: 'templateModel',
        value: function templateModel() {
            return {
                title: this.params.title,
                extraClass: this.params.extraClass
            };
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            this.bindClick(this.releaseActions);
        }
    }, {
        key: 'releaseActions',
        value: function releaseActions(e) {
            e.stopPropagation();
            this.callbacks.actionClick();
            this.callbacks.hideMenu(true);
        }
    }]);

    return ActionButton;
}(_TemplateView3.default);

exports.default = ActionButton;

/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _LeaveBalanceEditor = __webpack_require__(547);

var _LeaveBalanceEditor2 = _interopRequireDefault(_LeaveBalanceEditor);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LeaveBalanceEditorContent = function (_TemplateView) {
    _inherits(LeaveBalanceEditorContent, _TemplateView);

    function LeaveBalanceEditorContent() {
        _classCallCheck(this, LeaveBalanceEditorContent);

        return _possibleConstructorReturn(this, (LeaveBalanceEditorContent.__proto__ || Object.getPrototypeOf(LeaveBalanceEditorContent)).apply(this, arguments));
    }

    _createClass(LeaveBalanceEditorContent, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return "<div id='leaveBalanceEditor' class='daysMode'>" + "    <div class='title'></div>" + "    <table>" + "        <tr>" + "            <td class='correctionTypeSwitcherCell'>" + "                <button class='correctionTypeButton'></button>" + "            </td>" + "            <td class='valuesCell'>" + "                <div>" + "                    <span class='inHardValueMode'>" + "                        <input class='hardValueField' type='text'>" + "                        <span class='inDaysMode'><%=unitsDaysShort%></span>" + "                        <span class='inHoursMode'><%=unitsHoursShort%></span>" + "                    </span>" + "                    <span class='inIncreaseValueMode inDecreaseValueMode'>" + "                        <span class='inDaysMode'><span class='baseValue'>#</span> <%=unitsDaysShort%></span>" + "                        <span class='inHoursMode'><span class='baseValue'>#</span> <%=unitsHoursShort%></span>" + "                        <span class='inIncreaseValueMode'>+</span>" + "                        <span class='inDecreaseValueMode'>&minus;</span>" + "                        <input class='relativeValueField' type='text'>" + "                        <span class='inDaysMode'><%=unitsDaysShort%></span>" + "                        <span class='inHoursMode'><%=unitsHoursShort%></span>" + "                    </span>" + "                </div>" + "                <div class='unitsSwitcher'>" + "                    <button class='daysButton'><%=unitsDays%></button> " + "                    <div class='separator'></div>" + "                    <button class='hoursButton'><%=unitsHours%></button>" + "                </div>" + "            </td>" + "            <td class='applyButtonCell'>" + "                <button class='applyButton'>" + "                    <span class='defaultText'><%=applyButtonDefaultText%></span>" + "                    <span class='savingText'><%=applyButtonSavingText%></span>" + "                </button>" + "            </td>" + "        </tr>" + "        <tr class='errorMessageRow'>" + "            <td></td>" + "            <td colspan='2'>" + "                <table>" + "                    <tr>" + "                        <td class='errorIconCell'>" + "                            <div class='iconImg'></div>" + "                        </td>" + "                        <td class='errorTextCell'>#</td>" + "                    </tr>" + "                </table>" + "            </td>\n" + "        </tr>" + "        <tr>" + "            <td colspan='3'>" + "                <textarea class='comments' placeholder='<%=addComments%>'></textarea>" + "            </td>" + "        </tr>" + "    </table>" + "</div>";
        }
    }, {
        key: 'messageKeys',
        value: function messageKeys() {
            return {
                unitsDaysShort: 'common.pto_units.days.short',
                unitsHoursShort: 'common.pto_units.hours.short',
                unitsDays: 'common.pto_units.days',
                unitsHours: 'common.pto_units.hours',
                applyButtonDefaultText: 'common.apply',
                applyButtonSavingText: 'common.saving.ellipsis',
                addComments: 'common.add_comments'
            };
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            this.leaveBalanceEditorActions = new _LeaveBalanceEditor2.default(this.$el);
        }
    }, {
        key: 'show',
        value: function show(element, baseValueInDays, userName, ptoHoursPerDay, balanceType, titleMessageKey) {
            this.find(".title").text(_messageResource2.default.getMessage(titleMessageKey));
            this.leaveBalanceEditorActions.show(element, baseValueInDays, userName, ptoHoursPerDay, balanceType);
        }
    }, {
        key: 'setOnCloseCallback',
        value: function setOnCloseCallback(callback) {
            this.leaveBalanceEditorActions.setOnCloseCallback(callback);
        }
    }, {
        key: 'setOnApplyCallback',
        value: function setOnApplyCallback(callback) {
            this.leaveBalanceEditorActions.setOnApplyCallback(callback);
        }
    }, {
        key: 'busyModeOff',
        value: function busyModeOff() {
            this.leaveBalanceEditorActions.busyModeOff();
        }
    }, {
        key: 'hide',
        value: function hide() {
            this.leaveBalanceEditorActions.hide();
        }
    }, {
        key: 'showCapExceededError',
        value: function showCapExceededError(capInDays) {
            this.leaveBalanceEditorActions.showCapExceededError(capInDays);
        }
    }]);

    return LeaveBalanceEditorContent;
}(_TemplateView3.default);

exports.default = LeaveBalanceEditorContent;

/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BalanceHistoryPanelContent = function (_TemplateView) {
    _inherits(BalanceHistoryPanelContent, _TemplateView);

    function BalanceHistoryPanelContent(_ref) {
        var exportBalanceHistoryUrl = _ref.exportBalanceHistoryUrl;

        _classCallCheck(this, BalanceHistoryPanelContent);

        var _this = _possibleConstructorReturn(this, (BalanceHistoryPanelContent.__proto__ || Object.getPrototypeOf(BalanceHistoryPanelContent)).call(this));

        _this.params = {
            exportBalanceHistoryUrl: exportBalanceHistoryUrl
        };
        return _this;
    }

    _createClass(BalanceHistoryPanelContent, [{
        key: "templateHtml",
        value: function templateHtml() {
            return "<div id='userBalanceHistoryDiv'>" + "    <div class='userBalanceHistoryTitleDiv'>" + "        <div class='userBalanceHistoryTitle'><%=panelTitle%></div>" + "        <div class='closeButton'></div>" + "    </div>" + "    <div>" + "        <div>" + "            <table id='balanceHistoryTableThead'  class='balanceHistoryTableThead dataTable'>" + "                <thead>" + "                <tr>" + "                    <th class='effectiveDateCell'><%=effectiveDateTitle%></th>" + "                    <th class='descriptionCell'><%=descriptionTitle%></th>" + "                    <th class='valueCell'><%=valueTitle%></th>" + "                    <th class='endingBalanceCell'><%=endingBalanceTitle%></th>" + "                </tr>" + "                </thead>" + "            </table>" + "        </div>" + "        <div id='balanceHistoryTableBodyDiv' class='balanceHistoryTableBodyDiv'></div>" + "    </div>" + "    <div id='exportToPDFLinkDiv'>" + "        <form id='BalanceHistoryForm' class='balanceHistoryForm' method='post' action='<%=actionUrl%>'>" + "            <input type='hidden' name='userId' value=''/>" + "            <input type='hidden' name='balanceType' value=''/>" + "            <div class='exportImg'></div>" + "            <span class='exportToPDFLinkTitle'><%=exportText%></span>" + "        </form>" + "    </div>" + "</div>";
        }
    }, {
        key: "messageKeys",
        value: function messageKeys() {
            return {
                panelTitle: 'common.balance_history.balance_history_panel.title',
                effectiveDateTitle: 'common.balance_history.table.date_cell.title',
                descriptionTitle: 'common.balance_history.table.description_cell.title',
                valueTitle: 'common.balance_history.table.value_cell.title',
                endingBalanceTitle: 'common.balance_history.table.balance_cell.title',
                exportText: 'common.pto_history.export_link.text'
            };
        }
    }, {
        key: "templateModel",
        value: function templateModel() {
            return {
                actionUrl: this.params.exportBalanceHistoryUrl
            };
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            var _this2 = this;

            this.balanceHistoryPanelActions = new BalanceHistoryPanel().init(this.$el);

            this.find('#exportToPDFLinkDiv').on('click', function () {
                _this2.find('.balanceHistoryForm').submit();
            });
        }
    }, {
        key: "updateTitle",
        value: function updateTitle(message) {
            this.balanceHistoryPanelActions.updateTitle(message);
        }
    }, {
        key: "setOnCloseCallback",
        value: function setOnCloseCallback(callback) {
            this.balanceHistoryPanelActions.setOnCloseCallback(callback);
        }
    }, {
        key: "updateLinkState",
        value: function updateLinkState(recordsLength, userId, balanceType) {
            this.balanceHistoryPanelActions.updateLinkState(recordsLength, userId, balanceType);
        }
    }, {
        key: "showAt",
        value: function showAt(element, params) {
            this.balanceHistoryPanelActions.showAt(element, params);
        }
    }]);

    return BalanceHistoryPanelContent;
}(_TemplateView3.default);

exports.default = BalanceHistoryPanelContent;

/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _BasicLightbox = __webpack_require__(163);

var _BasicLightbox2 = _interopRequireDefault(_BasicLightbox);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _UserProfileSection = __webpack_require__(564);

var _UserProfileSection2 = _interopRequireDefault(_UserProfileSection);

var _index = __webpack_require__(48);

var _jquery_rpc = __webpack_require__(26);

var _jquery_rpc2 = _interopRequireDefault(_jquery_rpc);

var _PasswordSettings = __webpack_require__(279);

var _constants = __webpack_require__(21);

var _ClassicBridge = __webpack_require__(18);

var _ClassicBridge2 = _interopRequireDefault(_ClassicBridge);

var _constants2 = __webpack_require__(77);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function UserProfilePopup() {}

UserProfilePopup.JQUERY_RPC_TIMEOUT = 120000; // 2 minutes

UserProfilePopup.prototype = new _BasicLightbox2.default();

UserProfilePopup.prototype.cancel_confirmation_message_key = "profile.js.cancel_confirmation";
UserProfilePopup.prototype.close_tab_confirmation_message_key = "profile.js.close_tab_confirmation";
UserProfilePopup.prototype.exist_invalid_fields_message_key = "profile.js.footer_error.exist_invalid_fields";
UserProfilePopup.prototype.invalid_fields_sent_to_server_message_key = "profile.js.footer_error.invalid_fields_sent_to_server";
UserProfilePopup.prototype.incorrect_password_message_key = "profile.js.footer_error.incorrect_password";
UserProfilePopup.prototype.no_such_user_message_key = "profile.js.error.user_deleted";
UserProfilePopup.prototype.user_is_locked_message_key = "profile.js.error.user_is_locked";

UserProfilePopup.prototype.init = function (data, isLocked, successCallback, isPTOEnabled, isSickEnabled, isWSDEnabled, isDefaultWorkdaySectionShown) {
    var self = this;

    _ClassicBridge2.default.getUsersByClassicIds([data.userId]).then(function (result) {
        var nextUser = result.items[0];
        data.defaultDayStart = nextUser.defaultDayStart;
        data.defaultDayEnd = nextUser.defaultDayEnd;
        data.initialDefaultDayStart = nextUser.defaultDayStart;
        data.initialDefaultDayEnd = nextUser.defaultDayEnd;

        if (isWSDEnabled) {
            _ClassicBridge2.default.getWorkStatusesForUserProfile().then(function (workStatuses) {
                data.workStatuses = workStatuses.items;
                _ClassicBridge2.default.getDefaultWorkStatusPlanningByUserId('me').then(function (result) {
                    data.defaultWorkStatusPlanning = result.items;
                    data.defaultWorkStatusPlanningActions = result.actions;
                    self.initDataAndShow(data, isLocked, successCallback, isPTOEnabled, isSickEnabled, isWSDEnabled, isDefaultWorkdaySectionShown);
                });
            });
        } else {
            self.initDataAndShow(data, isLocked, successCallback, isPTOEnabled, isSickEnabled, isWSDEnabled, isDefaultWorkdaySectionShown);
        }
    });
};

UserProfilePopup.prototype.initDataAndShow = function (data, isLocked, successCallback, isPTOEnabled, isSickEnabled, isWSDEnabled, isDefaultWorkdaySectionShown) {
    this._popupId = "userProfilePopup";
    this._popupEl = (0, _jquery2.default)("#userProfilePopup");

    _BasicLightbox2.default.prototype.init.call(this, this._popupId, "closeUserProfilePopupButton");

    var self = this;

    this._locked = isLocked;
    if (isLocked) {
        this._commitEnabled = false;
        (0, _jquery2.default)(this.commitButton).attr("title", _messageResource2.default.getMessage("profile.js.user_is_locked"));
    }

    this.dataChanged = false;
    this._changesCallback = function () {
        if (!self.dataChanged) self.changesDetected();
        self.dataChanged = true;
    };

    this._isPTOEnabled = isPTOEnabled;
    this._isSickEnabled = isSickEnabled;
    this._isWSDEnabled = isWSDEnabled;
    this._isDefaultWorkdaySectionShown = isDefaultWorkdaySectionShown;

    data.currentTime = data.currentTimeInUserTimeZone;
    this._userProfileSection = this.createUserProfileSection(data);

    this.validate();

    this.setCancelCallback(function () {
        self.hide();
    });

    this.setSuccessCallback(function (profileInfo) {
        new Promise(function (res) {
            self._makeUpdateProfileNextRequest(data, res);
        }).then(function () {
            return new Promise(function (res) {
                self._makeUpdateProfileClassicRequest(profileInfo, res);
            });
        }).then(function (result) {
            return successCallback(result);
        });
    });

    if (navigator.userAgent.toLowerCase().indexOf("msie 8") > -1) {
        this._popupEl.addClass("ie8");
    }

    this.updateUI();

    this.show();
    return this;
};

UserProfilePopup.prototype.createUserProfileSection = function (data) {
    return new _UserProfileSection2.default().init(this._popupEl[0], data, this._changesCallback, this._validateCallback, true, this._isPTOEnabled, this._isSickEnabled, true, this._isWSDEnabled, this._isDefaultWorkdaySectionShown);
};

UserProfilePopup.prototype.changesDetected = function () {
    if (this._locked) return;
    this.getFooterEl().className = this.footerClassName + ' changesDetected';
};

UserProfilePopup.prototype.validate = function () {
    return this._userProfileSection.validate();
};

UserProfilePopup.prototype.updateUI = function () {
    this._userProfileSection.updateUI();
    if (this._locked) (0, _jquery2.default)(this.commitButton).addClass("disabled");
};

UserProfilePopup.prototype.hasErrors = function () {
    return this._userProfileSection.hasErrors();
};

UserProfilePopup.prototype._makeUpdateProfileNextRequest = function (data, successCallback) {
    this.disableUserInputWhileSaving();
    var self = this;

    var callbacks = [self._isWSDEnabled && data.defaultWorkStatusesChanged && _ClassicBridge2.default.putUserDefaultWorkStatuses('me', { items: data.defaultWorkStatusPlanning }), self._isDefaultWorkdaySectionShown && (data.defaultDayStart !== data.initialDefaultDayStart || data.defaultDayEnd !== data.initialDefaultDayEnd) && _ClassicBridge2.default.patchUser('me', {
        defaultDayStart: data.defaultDayStart,
        defaultDayEnd: data.defaultDayEnd
    })];

    return Promise.all(callbacks).then(successCallback).catch(function (e) {
        if (e.body && (e.body.errorKey === _constants2.ApiErrorKeys.Unauthenticated || e.body.errorKey === _constants2.ApiErrorKeys.NotFoundEntity)) {
            self.hide();
            var messageKey = e.body.errorKey === _constants2.ApiErrorKeys.Unauthenticated ? 'error.js.json_rpc.session_expired' : 'userlist.js.error_no_such_work_status.edit_user';
            alert(_messageResource2.default.getMessage(messageKey));
            return document.location.reload();
        }
        alert(_messageResource2.default.getMessage('error.js.lightbox_loader.unexpected_error', [PRODUCT_NAME]));
        self.enableUserInputWhileSaving();
        return true;
    });
};

UserProfilePopup.prototype._makeUpdateProfileClassicRequest = function (profileInfo, successCallback) {
    this.disableUserInputWhileSaving();
    var self = this;
    var successHandler = function successHandler() {
        self.enableUserInputWhileSaving();
        if (successCallback) {
            successCallback();
        }
        (0, _jquery2.default)(document).trigger('close_user_profile_event');
        self.hide();
    };

    var failCallback = function failCallback(jqXHR, textStatus, errorThrown) {

        if (!errorThrown || !errorThrown.exception) {
            self.hide();
            return false;
        }

        if (errorThrown.exception.indexOf('com.actimind.common.services.UserEmailInvalidException') != -1) {
            self._userProfileSection.setEmailInvalid();
            self.enableUserInputWhileSaving();
            return true;
        }

        if (errorThrown.exception.indexOf('com.actimind.actitime.administration.UserExistsException') != -1) {
            self._userProfileSection.setUsernameDuplicateError();
            self.enableUserInputWhileSaving();
            return true;
        }

        if (errorThrown.exception.indexOf('com.actimind.common.administration.passwords.service.PasswordPolicyViolatedException') !== -1) {
            self._userProfileSection.setPasswordError(_constants.ValidationErrors.PASSWORD_RESTRICTIONS_VIOLATED, errorThrown[_PasswordSettings.PasswordValidators.PASSWORD_VALIDATION_RESULT_JSON]);
            self.enableUserInputWhileSaving();
            return true;
        }

        if (errorThrown.exception.indexOf('com.actimind.common.services.EditProfileService$IncorrectPasswordException') != -1) {
            self._userProfileSection.setOldPasswordIncorrectError();
            self.enableUserInputWhileSaving();
            return true;
        }

        if (errorThrown.exception.indexOf('com.actimind.actitime.administration.NoSuchUserException') != -1) {
            alert(_messageResource2.default.getMessage(self.no_such_user_message_key));
            self.hide();
            document.location.reload();
            return true;
        }

        if (errorThrown.exception.indexOf('com.actimind.actitime.administration.UserIsLockedException') != -1) {
            alert(_messageResource2.default.getMessage(self.user_is_locked_message_key));
            self.enableUserInputWhileSaving();
            self.hide();
            return true;
        }

        if (errorThrown.exception.indexOf('java.lang.IllegalArgumentException') != -1) {
            alert(_messageResource2.default.getMessage(self.invalid_fields_sent_to_server_message_key));
            self.enableUserInputWhileSaving();
            return true;
        }

        self.hide();
        return false;
    };

    return (0, _jquery_rpc2.default)(this.getServiceAndMethod(), [profileInfo], successHandler, failCallback);
};

UserProfilePopup.prototype.restoreOnKeyDownHandler = function () {
    if (this.unregKeyDown) this.unregKeyDown();
};

UserProfilePopup.prototype.setupKeyDownHandler = function () {
    var _this = this;

    this.unregKeyDown = _index.KEY_HANDLERS.onKeyDown(function (code) {
        if ((0, _index.isEsc)(code)) {
            _this.cancel();
            return true;
        }
    });
};

UserProfilePopup.prototype.getServiceAndMethod = function () {};

exports.default = UserProfilePopup;

/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var selectUserProfile = exports.selectUserProfile = function selectUserProfile(state) {
  return state.userProfile;
};

/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getAllAssignedProjectCounter = exports.getAllAssignedCustomerCounter = exports.getEntirelyAssignedProjectCounter = exports.getEntirelyAssignedTasksCounter = exports.getCounters = exports.isNeedToLoadCustomerData = exports.isNeedToLoadProjectData = exports.isNeedToLoadTaskData = exports.isLoading = exports.selectCustomerEntities = exports.selectProjectEntities = exports.selectTaskEntities = exports.getUsersCounters = exports.getProjectIds = exports.getTaskIds = exports.getTab = undefined;

var _reselect = __webpack_require__(13);

var _selectorsGenerator = __webpack_require__(394);

var _selectorsGenerator2 = _interopRequireDefault(_selectorsGenerator);

var _selectors = __webpack_require__(904);

var _constants = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getCPTAssignmentsList = function getCPTAssignmentsList(state) {
    return (0, _selectors.selectUserProfile)(state).cptLists;
};

var hierarchyAssignmentsPanelTabSelectors = (0, _selectorsGenerator2.default)(getCPTAssignmentsList);

var getTab = exports.getTab = hierarchyAssignmentsPanelTabSelectors.getTab;

var getTaskIds = exports.getTaskIds = hierarchyAssignmentsPanelTabSelectors.getTaskIds;

var getProjectIds = exports.getProjectIds = hierarchyAssignmentsPanelTabSelectors.getProjectIds;

var getUsersCounters = exports.getUsersCounters = hierarchyAssignmentsPanelTabSelectors.getUsersCounters;

var selectTaskEntities = exports.selectTaskEntities = hierarchyAssignmentsPanelTabSelectors.selectTaskWaEntities;

var selectProjectEntities = exports.selectProjectEntities = hierarchyAssignmentsPanelTabSelectors.selectProjectWaEntities;

var selectCustomerEntities = exports.selectCustomerEntities = hierarchyAssignmentsPanelTabSelectors.selectCustomerMaEntities;

var isLoading = exports.isLoading = hierarchyAssignmentsPanelTabSelectors.isLoading;

var isNeedToLoadTaskData = exports.isNeedToLoadTaskData = (0, _reselect.createSelector)(getTab, function (tab) {
    return tab === _constants.HierarchyLevels.TASK;
});

var isNeedToLoadProjectData = exports.isNeedToLoadProjectData = (0, _reselect.createSelector)(getTab, function (tab) {
    return tab === _constants.HierarchyLevels.PROJECT;
});

var isNeedToLoadCustomerData = exports.isNeedToLoadCustomerData = (0, _reselect.createSelector)(getTab, function (tab) {
    return tab === _constants.HierarchyLevels.CUSTOMER;
});

var getCounters = exports.getCounters = (0, _reselect.createSelector)(getUsersCounters, function (counters) {
    return {
        customers: {
            curValue: counters.customers,
            maxValue: counters.customers
        },
        projects: {
            curValue: counters.projects,
            maxValue: counters.projects
        },
        tasks: {
            curValue: counters.tasks,
            maxValue: counters.tasks
        }
    };
});

var getEntirelyAssignedTasksCounter = exports.getEntirelyAssignedTasksCounter = (0, _reselect.createSelector)(getTaskIds, getCounters, function (ids, counters) {
    return counters.tasks.curValue - ids.length;
});

var getEntirelyAssignedProjectCounter = exports.getEntirelyAssignedProjectCounter = (0, _reselect.createSelector)(getProjectIds, getCounters, function (ids, counters) {
    return counters.projects.curValue - ids.length;
});

var getAllAssignedCustomerCounter = exports.getAllAssignedCustomerCounter = (0, _reselect.createSelector)(getCounters, function (counters) {
    return counters.customers.curValue;
});

var getAllAssignedProjectCounter = exports.getAllAssignedProjectCounter = (0, _reselect.createSelector)(getCounters, function (counters) {
    return counters.projects.curValue;
});

/***/ }),
/* 906 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _User = __webpack_require__(119);

var _User2 = _interopRequireDefault(_User);

var _Group = __webpack_require__(158);

var _Group2 = _interopRequireDefault(_Group);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _BaseUsersSelector = __webpack_require__(907);

var _BaseUsersSelector2 = _interopRequireDefault(_BaseUsersSelector);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CopyUserSettingsSelector() {}

CopyUserSettingsSelector.prototype = new _BaseUsersSelector2.default();

/**
 * Initializes users selector
 * @param allGroups
 * @param allUsers
 * @param onSelectCallback - function( selectedUserId )
 * @param selectedUserId
 */
CopyUserSettingsSelector.prototype.init = function (allGroups, allUsers, onSelectCallback, selectedUserId, ugrEnabled, tzgEnabled) {
    this.onSelectCallback = onSelectCallback;
    var self = this;
    this.clean();
    var users = [];
    var groups;

    _jquery2.default.each(allUsers, function () {
        users.push(new _User2.default(this.id, this.firstName, this.lastName, this.middleInitial, this.username, this.enabled, this.emailExists, this.userGroupId, this.timeZoneGroupId));
    });

    if (allGroups) {
        groups = [];

        _jquery2.default.each(allGroups, function () {
            groups.push(new _Group2.default(this.id, this.name));
        });
    }

    this.onUserSelect = function (selectedUserId) {
        self.disableInput();
        if (self.onSelectCallback) self.onSelectCallback(selectedUserId);
    };

    var emptyValue = '';
    var initialValue = selectedUserId ? selectedUserId : emptyValue;

    var baseInit = function baseInit() {
        _BaseUsersSelector2.default.prototype.init.call(self, users, groups, initialValue, emptyValue, null, 158, "copy-user-settings-from-list", ugrEnabled, tzgEnabled);
        self.input = (0, _jquery2.default)("#" + self.elementId + " input");
        self.input.attr("maxlength", "400");
        self.input.attr("placeholder", _messageResource2.default.getMessage("user.add.js.copy_settings_from")).placeholder();
        self.input.addClass("inputFieldWithPlaceholder");

        self.usersCombo.on("blur", function () {
            if (self.input.pVal() == '') self.usersCombo.setValue(self.initialValue);

            self.input.pVal(self.input.pVal());
        });
    };

    this.removeUser = function (userId) {
        this.clean();

        var newUsers = [];
        _jquery2.default.each(users, function () {
            if (this.id != userId) newUsers.push(this);
        });
        users = newUsers;

        baseInit();
    };

    baseInit();

    this.disableInput = function () {
        self.input.focus(function () {
            this.blur();
        });
    };

    this.enableInput = function () {
        self.input.off("focus");
    };
};

CopyUserSettingsSelector.prototype.clean = function () {
    (0, _jquery2.default)("#" + this.elementId).empty();
};

exports.default = CopyUserSettingsSelector;

/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _Ext = __webpack_require__(12);

var _Ext2 = _interopRequireDefault(_Ext);

var _StringIndex = __webpack_require__(115);

var _StringIndex2 = _interopRequireDefault(_StringIndex);

var _TokensHighlighter = __webpack_require__(94);

var _TokensHighlighter2 = _interopRequireDefault(_TokensHighlighter);

var _EmptyHighlighter = __webpack_require__(137);

var _EmptyHighlighter2 = _interopRequireDefault(_EmptyHighlighter);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _constants = __webpack_require__(4);

var _Group = __webpack_require__(158);

var _Group2 = _interopRequireDefault(_Group);

var _atUtils = __webpack_require__(5);

var _UserNameFormat = __webpack_require__(17);

var _UserNameFormat2 = _interopRequireDefault(_UserNameFormat);

var _RemoteComboWithouLoadingState = __webpack_require__(1764);

var _RemoteComboWithouLoadingState2 = _interopRequireDefault(_RemoteComboWithouLoadingState);

var _StringIndexDataProxy = __webpack_require__(1765);

var _StringIndexDataProxy2 = _interopRequireDefault(_StringIndexDataProxy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// TODO strange thing
window.usersSelector;

function BaseUsersSelector() {
    var usersIndex;
    var users;
    var usersMap;
    var maxUserNameLength;
    var maxGroupNameLength;
    var groupsMap;
    var userNameLength;

    this.elementId = "singleUserSelector";

    this.usersCombo = null;

    this.initUsersGroupsStructures = function (allUsers, allGroups) {
        usersIndex = new _StringIndex2.default();
        users = allUsers;
        usersMap = {};
        maxUserNameLength = 0;
        maxGroupNameLength = 0;
        groupsMap = null;

        _jquery2.default.each(allUsers, function () {
            usersMap[this.id] = this;
            usersIndex.add(this.lastName, this.id);
            usersIndex.add(this.firstName, this.id);
            if (!_underscore2.default.isNull(this.middleName)) usersIndex.add(this.middleName, this.id);
            userNameLength = this.formatNameLFM().length;
            if (!this.active) userNameLength += _messageResource2.default.getMessage("users_selector.disabled").length + 2;
            maxUserNameLength = Math.max(maxUserNameLength, userNameLength);
        });

        var addGroup = this.ugrEnabled ? function (group) {
            groupsMap[group.getId()] = group;
            maxGroupNameLength = Math.max(maxGroupNameLength, group.getName().length);
        } : function (group) {
            var len = group.getName().length;
            if (group.id == _constants.DEFAULT_TIME_ZONE_GROUP_ID) len += _messageResource2.default.getMessage("users_selector.default_group").length + 1;
            groupsMap[group.getId()] = group;
            if (len > maxGroupNameLength) maxGroupNameLength = len;
        };

        if (allGroups) {
            groupsMap = {};
            if (this.ugrEnabled) {
                var usersWithoutGroupUserGroup = new _Group2.default(window.SystemSettings.usersWithoutGroupId, _messageResource2.default.getMessage('common.users_without_group'));
                addGroup(usersWithoutGroupUserGroup);
            }

            _jquery2.default.each(allGroups, function () {
                addGroup(this);
            });
            var self = this;
            this.nameGroupFieldUser = this.ugrEnabled ? "userGroupId" : "timeZoneGroupId";
            // requires sorting by groupName.
            users.sort(function (user1, user2) {
                if (user1[self.nameGroupFieldUser] == user2[self.nameGroupFieldUser]) return (0, _atUtils.stringComparatorCaseSensitive)(user1.formatNameLFMU(), user2.formatNameLFMU());
                if (user1[self.nameGroupFieldUser] == window.SystemSettings.usersWithoutGroupId) return -1;
                if (user2[self.nameGroupFieldUser] == window.SystemSettings.usersWithoutGroupId) return 1;

                var groupName1 = groupsMap[user1[self.nameGroupFieldUser]].getName();
                var groupName2 = groupsMap[user2[self.nameGroupFieldUser]].getName();

                var result = (0, _atUtils.stringComparatorCaseSensitive)(groupName1, groupName2);
                // unexpectable result since group ids is differ.
                if (result == 0) return (0, _atUtils.stringComparatorCaseSensitive)(user1.formatNameLFMU(), user2.formatNameLFMU());

                return result;
            });

            maxUserNameLength += 4;
        }

        //TODO: remove usage of the global variable
        window.usersSelector = this;
    };

    this.initSelector = function (emptyText, hiddenName, width, comboListClass) {
        if (_underscore2.default.isNull(width) || _underscore2.default.isUndefined(width)) width = 238;

        var userRecordType = _Ext2.default.data.Record.create(this.getData());

        var usersProxy = new _StringIndexDataProxy2.default(usersIndex, "id", users);

        var store = new _Ext2.default.data.Store({
            proxy: usersProxy,
            reader: new _Ext2.default.data.ArrayReader({}, userRecordType)
        });

        var listWidth = Math.max(width, Math.min(400, Math.max(maxGroupNameLength * 6.7 + 6, maxUserNameLength * 6)));
        var paddingLeft = groupsMap ? 20 : 3;

        var userRowTemplate = '<div class="x-combo-list-item" style="' + (_Ext2.default.isIE ? 'width:' + listWidth - paddingLeft + 'px;' : '') + 'padding:3px 0 3px ' + paddingLeft + 'px">{[usersSelector.formatHighlightedUserName( values ) ]}</div>';

        var template;

        if (groupsMap) {
            var defaultGroupRenderer = function defaultGroupRenderer(groupId) {
                return (0, _atUtils.escapeHtmlSymbols)(window.usersSelector.getGroupName(groupId));
            };

            var groupRenderer = this.ugrEnabled ? defaultGroupRenderer : function (groupId) {
                var ret = defaultGroupRenderer(groupId);
                if (groupId == _constants.DEFAULT_TIME_ZONE_GROUP_ID) {
                    var groupName = ret;
                    var note = _messageResource2.default.getMessage("users_selector.default_group");

                    // if there is no scrollbar, then 7.5 is ok
                    var correction = -19.5;

                    ret = '<span class="defaultGroupName" title="' + groupName + '" style="width:' + (listWidth - note.length * 6.7 + correction) + 'px">' + groupName + '&nbsp;</span>' + '<span class="defaultGroupNote" title="' + groupName + '">' + note + '</span>';
                }
                return ret;
            };

            template = new _Ext2.default.XTemplate('<div>' + '   <tpl for="arguments[0]">' + '       <tpl if="xindex == 1 || parent[xindex - 2].groupId != values.groupId">' + '           <div class="users-selector-group-item" ' + (_Ext2.default.isIE ? 'style="width:' + listWidth + 'px"' : '') + '>{[this.renderGroup(values.groupId)]}</div>' + '       </tpl>' + userRowTemplate + '   </tpl>' + '</div>', {
                renderGroup: groupRenderer
            });
        } else {
            template = new _Ext2.default.XTemplate('<div>' + '   <tpl for=".">' + userRowTemplate + '   </tpl>' + '</div>');
        }

        if (_Ext2.default.isIE) listWidth += 18;

        var listClass = "singleUserSelector_list";
        if (_Ext2.default.isIE) listClass += " showVerticalScrollbar";
        if (comboListClass) listClass += " " + comboListClass;
        var self = this;
        this.usersCombo = new _RemoteComboWithouLoadingState2.default({
            selectorObject: self,
            width: width,
            minChars: 0,
            store: store,
            listClass: listClass,
            forceSelection: true,
            valueField: "id",
            triggerAction: "all",
            selectOnFocus: true,
            listWidth: listWidth,
            tokensHighlighter: new _EmptyHighlighter2.default(),
            emptyText: emptyText,
            hiddenName: hiddenName,
            tpl: template,

            setValue: function setValue(v) {
                var text = v;
                var user = usersMap[v];
                if (user) {
                    text = self.formatUserName(v, user);
                } else if (this.valueNotFoundText !== undefined) {
                    text = this.valueNotFoundText;
                }
                this.lastSelectionText = text;
                _RemoteComboWithouLoadingState2.default.superclass.setValue.call(this, text);
                if (this.hiddenField) {
                    // we do it after calling super,
                    // because super sets hidden value the same as visible text
                    // and that's not what we want
                    this.hiddenField.value = v;
                }
                this.value = v;
            }
        });

        this.usersCombo.on("beforequery", function (qObj) {

            var searchTokens = usersIndex.getTokenizer().getTokens(qObj.query.toLowerCase());

            if (searchTokens.length == 0) {
                delete qObj.combo.store.baseParams.searchTokens;
                qObj.combo.tokensHighlighter = new _EmptyHighlighter2.default();
            } else {
                qObj.combo.store.baseParams.searchTokens = searchTokens;
                qObj.combo.tokensHighlighter = new _TokensHighlighter2.default(searchTokens, usersIndex.getTokenizer().getPunctuators());
            }
        });

        var self = this;
        this.usersCombo.on("select", function () {
            self.onUserSelect(self.usersCombo.getValue());
        });

        this.usersCombo.on("render", function () {
            self.onUsersComboRender();
        });
    };

    this.onUsersComboRender = function () {};

    this.getGroupName = function (groupId) {
        return groupsMap[groupId].getName();
    };

    this.hl = function (value) {
        return this.usersCombo.tokensHighlighter.highlightTokens(value);
    };
}

BaseUsersSelector.prototype.formatHighlightedUserName = function (value) {
    var formattedUserName = _UserNameFormat2.default.formatLFM(this.hl(value.firstName), this.hl(value.lastName), (0, _atUtils.escapeHtmlSymbols)(value.middleName));
    if (!value.active) formattedUserName = "<span class='disabledUser'>" + formattedUserName + " " + _messageResource2.default.getMessage("users_selector.disabled") + "</span>";
    return formattedUserName;
};
/**
 * Initializes users selector
 * @param users array of User elements
 * @param groups array of Group elements ( null if user groups are off )
 * @param initialValue id of selected user
 * @param emptyText text which will be shown if nothing is selected
 * @param hiddenFieldName name of a hidden input
 * @param width width of the selector
 * @return {*}
 */
BaseUsersSelector.prototype.init = function (users, groups, initialValue, emptyText, hiddenFieldName, width, comboListClass, ugrEnabled, tzgEnabled) {
    this.ugrEnabled = ugrEnabled;
    this.tzgEnabled = tzgEnabled;

    this.initUsersGroupsStructures(users, groups);
    this.initSelector(emptyText, hiddenFieldName, width, comboListClass);
    this.initialValue = initialValue;

    if (initialValue) this.usersCombo.setValue(initialValue);
    this.usersCombo.render(this.elementId);
    this.usersCombo.queryDelay = 1;

    return this;
};
BaseUsersSelector.prototype.getData = function () {
    var self = this;
    return [{ name: 'id', mapping: "id" }, { name: 'firstName', mapping: "firstName" }, { name: 'lastName', mapping: "lastName" }, { name: 'middleName', mapping: "middleName" }, { name: 'username', mapping: "username" }, { name: 'active', mapping: "active" }, { name: 'groupId', mapping: self.nameGroupFieldUser }];
};

BaseUsersSelector.prototype.rollbackSelection = function () {
    this.usersCombo.setValue(this.initialValue);
    this.usersCombo.blur();
};

BaseUsersSelector.prototype.formatUserName = function (v, user) {
    return user.formatNameLFM();
};

BaseUsersSelector.prototype.disable = function () {
    this.rollbackSelection();
    this.usersCombo.setEditable(false);
    this.usersCombo.disabled = true;
    this.usersCombo.blur();
};

BaseUsersSelector.prototype.enable = function () {
    this.usersCombo.setEditable(true);
    this.usersCombo.disabled = false;
};

BaseUsersSelector.prototype.onUserSelect = function (selectedUserId) {
    // abstract
};

exports.default = BaseUsersSelector;

/***/ }),
/* 908 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _TableCell = __webpack_require__(166);

var _TableCell2 = _interopRequireDefault(_TableCell);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function TabularDataTableCell() {}

TabularDataTableCell.VALUE_VALID = 0;
TabularDataTableCell.VALUE_EMPTY = 1;
TabularDataTableCell.VALUE_INVALID = 2;

TabularDataTableCell.prototype = _underscore2.default.create(_TableCell2.default.prototype);

TabularDataTableCell.prototype.init = function (value, validator, rowObj) {
    _TableCell2.default.call(this, value, rowObj);
    this.validator = validator;
    this.validationResult = TabularDataTableCell.VALUE_VALID;
    this.empty = validator.isEmpty(this);
    return this;
};

TabularDataTableCell.prototype.isValid = function () {
    return this.validationResult == TabularDataTableCell.VALUE_VALID;
};

TabularDataTableCell.prototype.getValidationResult = function () {
    return this.validationResult;
};

TabularDataTableCell.prototype.setValid = function () {
    this.validationResult = TabularDataTableCell.VALUE_VALID;
};

TabularDataTableCell.prototype.setInvalid = function () {
    this.validationResult = TabularDataTableCell.VALUE_INVALID;
};

TabularDataTableCell.prototype.isEmpty = function () {
    return this.empty;
};

TabularDataTableCell.prototype.setValueNoValidate = function (value) {
    _TableCell2.default.prototype.setValue.call(this, value);
};

TabularDataTableCell.prototype.setValue = function (value) {
    this.setValueNoValidate(value);
    this.validate(true);
    if (this.onValueChangeCallBack) this.onValueChangeCallBack(this);
    this.getTable()._validationDetected();
};

TabularDataTableCell.prototype.validate = function (isEmptyValid) {
    this.empty = this.validator.isEmpty(this);
    if (this.empty) this.validationResult = isEmptyValid ? TabularDataTableCell.VALUE_VALID : TabularDataTableCell.VALUE_EMPTY;else this.validationResult = this.validator.isValid(this) ? TabularDataTableCell.VALUE_VALID : TabularDataTableCell.VALUE_INVALID;

    return this.isValid();
};

TabularDataTableCell.prototype.onChange = function (onValueChangeCallBack) {
    this.onValueChangeCallBack = onValueChangeCallBack;
};

exports.default = TabularDataTableCell;

/***/ }),
/* 909 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _TableRow = __webpack_require__(250);

var _TableRow2 = _interopRequireDefault(_TableRow);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function TabularDataTableRow() {}

TabularDataTableRow.prototype = _underscore2.default.create(_TableRow2.default.prototype);

TabularDataTableRow.prototype.init = function () {
    _TableRow2.default.call(this);
    return this;
};

TabularDataTableRow.prototype.canBeDeletedPermanently = function () {
    return true;
};

TabularDataTableRow.prototype.validate = function () {
    return true;
};

TabularDataTableRow.prototype.isMarkedToRemove = function () {
    return this.markedToRemove;
};

TabularDataTableRow.prototype.markToRemove = function () {
    this.markedToRemove = true;
    this.updateUI();
};

TabularDataTableRow.prototype.unMarkToRemove = function () {
    this.markedToRemove = false;
    this.updateUI();
};

TabularDataTableRow.prototype.getRowClasses = function () {
    var classes = _TableRow2.default.prototype.getRowClasses.call(this);
    if (this.markedToRemove) classes.push("markedToRemove");
    return classes;
};

TabularDataTableRow.prototype.updateRowClasses = function () {
    this.getRowEl().className = this.getRowClasses().join(" ");
};

TabularDataTableRow.prototype.updateUI = function () {
    this.updateRowClasses();
    for (var i = 0; i < this.cells.length; i++) {
        this.updateCellUI(i);
    }
};

TabularDataTableRow.prototype.hasErrors = function () {
    return false;
};

exports.default = TabularDataTableRow;

/***/ }),
/* 910 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _TabularDataTableRow = __webpack_require__(909);

var _TabularDataTableRow2 = _interopRequireDefault(_TabularDataTableRow);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function TabularDataWithEffectiveDatesTableRow() {}

TabularDataWithEffectiveDatesTableRow.prototype = _underscore2.default.create(_TabularDataTableRow2.default.prototype);

TabularDataWithEffectiveDatesTableRow.prototype.init = function () {
    _TabularDataTableRow2.default.prototype.init.call(this);
    this.effective = false;
    this.inPast = false;
    return this;
};

TabularDataWithEffectiveDatesTableRow.prototype.setEffective = function (effective) {
    this.effective = effective;
};

TabularDataWithEffectiveDatesTableRow.prototype.isEffective = function () {
    return this.effective;
};

TabularDataWithEffectiveDatesTableRow.prototype.setInPast = function (inPast) {
    this.inPast = inPast;
};

TabularDataWithEffectiveDatesTableRow.prototype.isInPast = function () {
    return this.inPast;
};

TabularDataWithEffectiveDatesTableRow.prototype.getRowClasses = function () {
    var classes = _TabularDataTableRow2.default.prototype.getRowClasses.call(this);
    if (!this.markedToRemove && this.effective) classes.push("effective");
    if (this.inPast) classes.push("past");
    return classes;
};

TabularDataWithEffectiveDatesTableRow.prototype.setDeleteConfirmation = function (isShown) {
    this.deleteConfirmationShown = isShown;
};

TabularDataWithEffectiveDatesTableRow.prototype.updateUI = function () {
    _TabularDataTableRow2.default.prototype.updateUI.call(this);
    (0, _jquery2.default)(this.getRowEl()).toggleClass("deleteConfirmation", !!this.deleteConfirmationShown);
};

TabularDataWithEffectiveDatesTableRow.prototype.hasErrors = function () {
    return !_underscore2.default.every(this.cells, function (cell) {
        return !cell.isValid || cell.isValid();
    });
};

exports.default = TabularDataWithEffectiveDatesTableRow;

/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
function TabularDataTableCellValidator() {}

TabularDataTableCellValidator.prototype.init = function () {
    return this;
};

TabularDataTableCellValidator.prototype.isEmptyOrValid = function (cell) {
    return this.isEmpty(cell) || this.isValid(cell);
};

TabularDataTableCellValidator.prototype.isValid = function (cell) {
    return true;
};

TabularDataTableCellValidator.prototype.isEmpty = function (cell) {
    return true;
};

exports.default = TabularDataTableCellValidator;

/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.updateEditingStatusNameAction = exports.updateEditingStatusColorIdAction = exports.cancelEditOrCreateStatusAction = exports.toggleDialogVisibility = exports.startEditStatusAction = exports.addNewStatusAction = exports.changeWorkflowStatusPosition = exports.deleteWorkflowStatus = exports.createOrEditWorkflowStatus = exports.loadData = undefined;

var _constants = __webpack_require__(180);

var _selectors = __webpack_require__(566);

var _apiCalls = __webpack_require__(1776);

var api = _interopRequireWildcard(_apiCalls);

var _actions = __webpack_require__(29);

var _selectors2 = __webpack_require__(14);

var _reduxActions = __webpack_require__(9);

var _actionTypes = __webpack_require__(685);

var ActionTypes = _interopRequireWildcard(_actionTypes);

var _utils = __webpack_require__(6);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var loadData = exports.loadData = function loadData() {
    return function (dispatch) {
        dispatch((0, _utils.createActionObject)(ActionTypes.LOAD_DATA));
        api.getPageData().then(function (data) {
            dispatch((0, _utils.createActionObject)(ActionTypes.LOAD_DATA_SUCCESS, data.idsOfUsedWorkflowStatuses));
            dispatch((0, _actions.setWorkflowStatusesList)(data.workflowStatuses));
        }).catch(function (_ref) {
            var error = _ref.error;

            dispatch((0, _utils.createActionObject)(ActionTypes.LOAD_DATA_FAILURE, [error]));
        });
    };
};

var createOrEditWorkflowStatus = exports.createOrEditWorkflowStatus = function createOrEditWorkflowStatus() {
    return function (dispatch, getState) {
        var errors = validateName((0, _selectors.getEditDialogData)(getState()), Object.values((0, _selectors2.getWorkflowStatuses)(getState())));
        if (errors.length > 0) {
            dispatch((0, _utils.createActionObject)(ActionTypes.SET_ERRORS, errors));
            return;
        }

        var isCreate = (0, _selectors.getEditDialogData)(getState()).id === _constants.NEW_STATUS_ID;
        if (isCreate) {
            dispatch(createWorkflowStatus());
        } else {
            dispatch(editWorkflowStatus());
        }
    };
};

var createWorkflowStatus = function createWorkflowStatus() {
    return function (dispatch, getState) {
        dispatch((0, _utils.createActionObject)(ActionTypes.CREATE_NEW_STATUS));
        api.addNewWorkflowStatus((0, _selectors.getEditDialogData)(getState())).then(function (data) {
            dispatch((0, _utils.createActionObject)(ActionTypes.CREATE_NEW_STATUS_SUCCESS, data.idsOfUsedWorkflowStatuses));
            dispatch((0, _actions.setWorkflowStatusesList)(data.workflowStatuses));
            dispatch(toggleDialogVisibility(false));
        }).catch(function (_ref2) {
            var error = _ref2.error,
                data = _ref2.data;

            dispatch(createRequestErrorActionObject(ActionTypes.CREATE_NEW_STATUS_FAILURE, error, data));
            dispatch((0, _actions.setWorkflowStatusesList)(data.workflowStatuses));
        });
    };
};

var editWorkflowStatus = function editWorkflowStatus() {
    return function (dispatch, getState) {
        dispatch((0, _utils.createActionObject)(ActionTypes.EDIT_STATUS));
        var editDialogData = (0, _selectors.getEditDialogData)(getState());
        api.updateWorkflowStatus(editDialogData).then(function (data) {
            dispatch((0, _utils.createActionObject)(ActionTypes.EDIT_STATUS_SUCCESS, data.idsOfUsedWorkflowStatuses));
            dispatch((0, _actions.setWorkflowStatusesList)(data.workflowStatuses));
            dispatch(toggleDialogVisibility(false));
        }).catch(function (_ref3) {
            var error = _ref3.error,
                data = _ref3.data;

            dispatch(createRequestErrorActionObject(ActionTypes.EDIT_STATUS_FAILURE, error, data));
            dispatch((0, _actions.setWorkflowStatusesList)(data.workflowStatuses));

            // call after errors for correct handling
            if (error === _constants.ValidationErrors.STATUS_DELETED) {
                // need to close dialog
                dispatch(toggleDialogVisibility(false));
            }
        });
    };
};

var deleteWorkflowStatus = exports.deleteWorkflowStatus = function deleteWorkflowStatus(id) {
    return function (dispatch) {
        dispatch((0, _utils.createActionObject)(ActionTypes.DELETE_STATUS));
        api.deleteWorkflowStatus(id).then(function (data) {
            dispatch((0, _utils.createActionObject)(ActionTypes.DELETE_STATUS_SUCCESS, data.idsOfUsedWorkflowStatuses));
            dispatch((0, _actions.setWorkflowStatusesList)(data.workflowStatuses));
        }).catch(function (_ref4) {
            var error = _ref4.error,
                data = _ref4.data;

            dispatch(createRequestErrorActionObject(ActionTypes.DELETE_STATUS_FAILURE, error, data));
            dispatch((0, _actions.setWorkflowStatusesList)(data.workflowStatuses));
        });
    };
};

var changeWorkflowStatusPosition = exports.changeWorkflowStatusPosition = function changeWorkflowStatusPosition(_ref5) {
    var id = _ref5.id,
        newPosition = _ref5.newPosition;
    return function (dispatch) {
        dispatch((0, _utils.createActionObject)(ActionTypes.CHANGE_STATUS_POSITION));
        api.updateWorkflowStatusPosition({ id: id, newPosition: newPosition }).then(function (data) {
            dispatch((0, _utils.createActionObject)(ActionTypes.CHANGE_STATUS_POSITION_SUCCESS, data.idsOfUsedWorkflowStatuses));
            dispatch((0, _actions.setWorkflowStatusesList)(data.workflowStatuses));
        }).catch(function (_ref6) {
            var error = _ref6.error,
                data = _ref6.data;

            dispatch(createRequestErrorActionObject(ActionTypes.CHANGE_STATUS_POSITION_FAILURE, error, data));
            dispatch((0, _actions.setWorkflowStatusesList)(data.workflowStatuses));
        });
    };
};

var addNewStatusAction = exports.addNewStatusAction = function addNewStatusAction(type) {
    return function (dispatch) {
        dispatch((0, _utils.createActionObject)(ActionTypes.START_CREATE_STATUS, type));
        dispatch(toggleDialogVisibility(true));
    };
};

var startEditStatusAction = exports.startEditStatusAction = function startEditStatusAction(id) {
    return function (dispatch, getState) {
        dispatch((0, _utils.createActionObject)(ActionTypes.START_EDIT_STATUS, (0, _selectors2.getWorkflowStatuses)(getState())[id]));
        dispatch(toggleDialogVisibility(true));
    };
};

var toggleDialogVisibility = exports.toggleDialogVisibility = (0, _reduxActions.createAction)(ActionTypes.TOGGLE_DIALOG_VISIBILITY);

var cancelEditOrCreateStatusAction = exports.cancelEditOrCreateStatusAction = function cancelEditOrCreateStatusAction() {
    return function (dispatch) {
        dispatch((0, _utils.createActionObject)(ActionTypes.CANCEL_EDIT_OR_CREATE_STATUS));
        dispatch(toggleDialogVisibility(false));
    };
};

var updateEditingStatusColorIdAction = exports.updateEditingStatusColorIdAction = function updateEditingStatusColorIdAction(colorId) {
    return function (dispatch) {
        dispatch((0, _utils.createActionObject)(ActionTypes.UPDATE_EDITING_STATUS, { colorId: colorId }));
    };
};

var updateEditingStatusNameAction = exports.updateEditingStatusNameAction = function updateEditingStatusNameAction(name) {
    return function (dispatch) {
        dispatch((0, _utils.createActionObject)(ActionTypes.UPDATE_EDITING_STATUS, { name: name }));
        dispatch((0, _utils.createActionObject)(ActionTypes.SET_ERRORS, []));
    };
};

function validateName(editingStatusData, allWorkflowStatuses) {
    var errors = [];
    var editingStatus = editingStatusData;

    if (editingStatus.name === '') {
        errors.push(_constants.ValidationErrors.EMPTY_NAME_ERROR);
    }

    if (allWorkflowStatuses.find(function (s) {
        return s.name.toLowerCase() === editingStatus.name.toLowerCase() && s.id !== editingStatus.id;
    })) {
        errors.push(_constants.ValidationErrors.DUPLICATE_NAME_ERROR);
    }
    return errors;
}

function createRequestErrorActionObject(type, error, data) {
    return (0, _utils.createActionObject)(ActionTypes.DELETE_STATUS_FAILURE, {
        errors: [error],
        statusesInUseIds: data.idsOfUsedWorkflowStatuses
    });
}

/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.getEnabledStatusMessageKeyByStatus = getEnabledStatusMessageKeyByStatus;
exports.prepareWorkflowStatusesForPage = prepareWorkflowStatusesForPage;

var _constants = __webpack_require__(180);

var _atUtils = __webpack_require__(5);

var _constants2 = __webpack_require__(23);

var _utils = __webpack_require__(80);

function getEnabledStatusMessageKeyByStatus(status) {
    return _constants.ENABLED_STATUS_MESSAGE_KEY_BY_STATUS[status];
}

function prepareWorkflowStatusesForPage() {
    var statusesInUseIds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var allStatusesMap = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var usedStatusesIdsSet = (0, _atUtils.arrayToSet)(statusesInUseIds);
    var statuses = Object.values(allStatusesMap).sort(_utils.workflowStatusComparator);

    var openStatusesCount = 0;
    var completedStatusesCount = 0;
    var statusesForReturn = [];
    statuses.forEach(function (status) {
        if (status.type === _constants2.WorkflowStatusType.OPEN) {
            openStatusesCount++;
        } else {
            completedStatusesCount++;
        }

        statusesForReturn.push(_extends({}, status, {
            enabledStatus: usedStatusesIdsSet[status.id] === true ? _constants.enabledStatus.IN_USE : _constants.enabledStatus.ENABLED
        }));
    });

    var updateLastItemEnabledStatus = function updateLastItemEnabledStatus(statusType) {
        var ind = statusesForReturn.findIndex(function (_ref) {
            var type = _ref.type;
            return type === statusType;
        });
        statusesForReturn[ind] = _extends({}, statusesForReturn[ind], {
            enabledStatus: _constants.enabledStatus.LAST
        });
    };
    if (openStatusesCount === 1) {
        updateLastItemEnabledStatus(_constants2.WorkflowStatusType.OPEN);
    }
    if (completedStatusesCount === 1) {
        updateLastItemEnabledStatus(_constants2.WorkflowStatusType.COMPLETED);
    }
    return statusesForReturn;
}

/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _atUtils = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/*
* Constants for interactions jquery Sortable plugin. Do not use for styling
* */
var DRAG_ELEMENT_CLASS = 'draggableElement';
var CONNECT_WITH_PREFIX = 'connectWith_';
var DRAGGABLE_ITEM_CONTAINER_ID = '#draggableItemContainer';
var DRAGGABLE_ITEM_Z_INDEX = 9999;

/*
* Constants for styling elements
* */
var ON_DRAG_CLASS = 'onDrag';

var defaultSortableConfig = {
    axis: false,
    cloneItem: false,
    tolerance: 'pointer',
    containmentEl: false,
    connectWithClass: false,
    restrictDragElement: false,
    placeholderClass: 'sortablePlaceholder'
};

var SortableListContainer = function (_TemplateView) {
    _inherits(SortableListContainer, _TemplateView);

    function SortableListContainer(_ref) {
        var itemRenderer = _ref.itemRenderer,
            _ref$canDragItemPredi = _ref.canDragItemPredicate,
            canDragItemPredicate = _ref$canDragItemPredi === undefined ? function () {
            return true;
        } : _ref$canDragItemPredi,
            _ref$placeholderText = _ref.placeholderText,
            placeholderText = _ref$placeholderText === undefined ? null : _ref$placeholderText,
            _ref$sortableConfig = _ref.sortableConfig,
            sortableConfig = _ref$sortableConfig === undefined ? {} : _ref$sortableConfig,
            _ref$onItemDragging = _ref.onItemDragging,
            onItemDragging = _ref$onItemDragging === undefined ? function () {} : _ref$onItemDragging,
            _ref$onItemDragStart = _ref.onItemDragStart,
            onItemDragStart = _ref$onItemDragStart === undefined ? function () {} : _ref$onItemDragStart,
            _ref$onItemDragStop = _ref.onItemDragStop,
            onItemDragStop = _ref$onItemDragStop === undefined ? function () {} : _ref$onItemDragStop,
            _ref$onDragOver = _ref.onDragOver,
            onDragOver = _ref$onDragOver === undefined ? function () {} : _ref$onDragOver,
            _ref$onDragOut = _ref.onDragOut,
            onDragOut = _ref$onDragOut === undefined ? function () {} : _ref$onDragOut,
            _ref$onPositionChange = _ref.onPositionChangedCb,
            onPositionChangedCb = _ref$onPositionChange === undefined ? function () {} : _ref$onPositionChange,
            _ref$onItemReceiveCb = _ref.onItemReceiveCb,
            onItemReceiveCb = _ref$onItemReceiveCb === undefined ? function () {} : _ref$onItemReceiveCb,
            _ref$onItemRemoveCb = _ref.onItemRemoveCb,
            onItemRemoveCb = _ref$onItemRemoveCb === undefined ? function () {} : _ref$onItemRemoveCb;

        _classCallCheck(this, SortableListContainer);

        var _this = _possibleConstructorReturn(this, (SortableListContainer.__proto__ || Object.getPrototypeOf(SortableListContainer)).call(this, null));

        _this.state = {
            items: [],
            draggableItemPosition: null,
            preventPositionChangedCb: false,
            canDrop: false,
            previousCanDrop: false,
            itemDraggedOutOfContainer: false,
            additionalPlaceholderClass: "",
            needRefreshSortable: false
        };

        _this.params = {
            itemRenderer: itemRenderer,
            canDragItemPredicate: canDragItemPredicate,
            placeholderText: placeholderText
        };

        _this.sortableConfig = _extends({}, defaultSortableConfig, sortableConfig);

        _this.callbacks = {
            onItemDragging: onItemDragging,
            onItemDragStart: onItemDragStart,
            onItemDragStop: onItemDragStop,
            onDragOver: onDragOver,
            onDragOut: onDragOut,
            onPositionChangedCb: onPositionChangedCb,
            onItemReceiveCb: onItemReceiveCb,
            onItemRemoveCb: onItemRemoveCb
        };

        _this.onStatePropertyChanged('items', function (items, prevStateItems) {
            return _this._updateRows(items, prevStateItems);
        });
        _this.onStatePropertyChanged('additionalPlaceholderClass', function (additionalClass) {
            _this.getEl().sortable('option', 'placeholder', _this.sortableConfig.placeholderClass + ' ' + additionalClass);
        });

        _this.onStatePropertyBecameTrue("needRefreshSortable", function () {
            return _this._refreshSortable();
        });
        return _this;
    }

    _createClass(SortableListContainer, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class="draggableListContainer"\>';
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            var _this2 = this;

            if ((0, _jquery2.default)(DRAGGABLE_ITEM_CONTAINER_ID).length === 0) {
                (0, _jquery2.default)('body').append('<div id="' + DRAGGABLE_ITEM_CONTAINER_ID.substring(1) + '"/>');
            }

            if (this.sortableConfig.connectWithClass) {
                this.getEl().addClass(CONNECT_WITH_PREFIX + this.sortableConfig.connectWithClass);
            }

            this.getEl().sortable({
                appendTo: DRAGGABLE_ITEM_CONTAINER_ID,
                zIndex: DRAGGABLE_ITEM_Z_INDEX,
                helper: this.sortableConfig.cloneItem ? "clone" : "original",
                placeholder: this.sortableConfig.placeholderClass,
                cancel: ".disabled",
                axis: this.sortableConfig.axis,
                distance: 15,
                containment: this.sortableConfig.containmentEl || false,
                tolerance: this.sortableConfig.tolerance,
                handle: this.sortableConfig.restrictDragElement && '.' + DRAG_ELEMENT_CLASS,
                connectWith: this.sortableConfig.connectWithClass && '.' + CONNECT_WITH_PREFIX + this.sortableConfig.connectWithClass,
                scroll: false,
                cursor: "move",
                cursorAt: this.sortableConfig.cursorAt ? this.sortableConfig.cursorAt : false
            });

            this.getEl().on('sortstart', function (e, ui) {
                (0, _jquery2.default)(DRAGGABLE_ITEM_CONTAINER_ID).show();

                ui.helper.addClass(ON_DRAG_CLASS);

                /* add tabindex to dragging element to focus on it and unfocus all available page inputs
                and add on blur event to disallow change focus on TAB key */
                ui.helper.attr('tabindex', 1).focus();
                ui.helper.blur(function () {
                    return ui.helper.focus();
                });

                if (_this2.sortableConfig.cloneItem) {
                    ui.item.addClass('clone');
                }
                _this2.setStateInternal({
                    previousCanDrop: _this2.state.canDrop,
                    canDrop: true,
                    itemDraggedOutOfContainer: false,
                    preventPositionChangedCb: false,
                    draggableItemPosition: ui.item.index()
                });
                _this2.callbacks.onItemDragStart({
                    id: _this2.state.items[_this2.state.draggableItemPosition].id,
                    currentPrecedingId: _this2.state.draggableItemPosition === 0 ? null : _this2.state.items[_this2.state.draggableItemPosition - 1].id
                });
            });

            this.getEl().on('sortstop', function (e, ui) {
                ui.item.removeClass(ON_DRAG_CLASS).removeAttr('tabindex');

                (0, _jquery2.default)(DRAGGABLE_ITEM_CONTAINER_ID).hide();

                _this2.callbacks.onItemDragStop();

                if (_this2.sortableConfig.cloneItem) {
                    ui.item.removeClass('clone');
                }

                var itemIndex = ui.item.index();

                if (!_this2.state.preventPositionChangedCb && _this2.state.draggableItemPosition !== itemIndex) {
                    var precedingId = itemIndex === 0 ? null : _this2.state.draggableItemPosition > itemIndex ? _this2.state.items[itemIndex - 1].id : _this2.state.items[itemIndex].id;
                    _this2.callbacks.onPositionChangedCb({
                        id: _this2.state.items[_this2.state.draggableItemPosition].id,
                        itemIndex: ui.item.index(),
                        precedingId: precedingId
                    });
                }

                _this2.setStateInternal({
                    draggableItemPosition: null,
                    canDrop: _this2.state.previousCanDrop
                });
            });

            this.getEl().on('sortreceive', function (e, ui) {
                if (_this2.state.itemDraggedOutOfContainer || !_this2.state.canDrop) {
                    ui.sender.sortable('cancel');
                } else {
                    var itemIndex = ui.item.index();
                    ui.item.remove();
                    (0, _atUtils.defer)(function () {
                        return _this2.callbacks.onItemReceiveCb({ itemIndex: itemIndex });
                    });
                }
            });

            this.getEl().on('sortremove', function (e, ui) {
                _this2.setStateInternal({ preventPositionChangedCb: true });
                _this2.callbacks.onItemRemoveCb();
            });

            this.getEl().on('sortover', function (e, ui) {
                if (_this2.state.canDrop) {
                    ui.helper.removeClass('undroppable');
                    if (_this2.sortableConfig.cloneItem) {
                        _this2.state.draggableItemPosition !== null ? ui.item.hide() : ui.item.show();
                    }
                    if (_this2.params.placeholderText) {
                        ui.placeholder.text(_this2.params.placeholderText);
                    }
                    ui.placeholder.show();
                    _this2.setStateInternal({ itemDraggedOutOfContainer: false });
                }
                _this2.callbacks.onDragOver();
            });

            this.getEl().on('sortout', function (e, ui) {
                if (ui.helper) {
                    ui.helper.addClass('undroppable');
                }
                ui.placeholder.hide();
                ui.item.show();
                _this2.setStateInternal({ itemDraggedOutOfContainer: true });
                _this2.callbacks.onDragOut();
            });

            this.getEl().on('sort', function (e, ui) {
                _this2.$containerEl.trigger('sortableList_itemDrag', e);
            });
        }
    }, {
        key: 'cancelDrag',
        value: function cancelDrag() {
            this.getEl().sortable("cancel");
        }
    }, {
        key: '_updateRows',
        value: function _updateRows(items, prevStateItems) {
            if (!(0, _atUtils.isOrderFullyExistsAtTheBeginningOf)(prevStateItems, items) || prevStateItems.length === 0) {
                this.$el.empty();
                this._appendRows(items);
            } else {
                this._appendRows(items.slice(prevStateItems.length));
            }
        }
    }, {
        key: '_appendRows',
        value: function _appendRows(items) {
            var _this3 = this;

            items.forEach(function (item) {
                var node = _this3.params.itemRenderer(item).init(_this3.getEl());

                if (!_this3.params.canDragItemPredicate(item)) {
                    node.getEl().on('mousedown', function (e) {
                        return e.stopPropagation();
                    });
                }

                if (_this3.sortableConfig.restrictDragElement) {
                    if (node.getDraggableEl) {
                        node.getDraggableEl().toggleClass(DRAG_ELEMENT_CLASS, true);
                    } else {
                        console.error('need to implement `getDraggableEl` into item element');
                    }
                }
            });
        }
    }, {
        key: '_refreshSortable',
        value: function _refreshSortable() {
            this.getEl().sortable('refresh');
            this.setStateInternal({ needRefreshSortable: false });
        }
    }]);

    return SortableListContainer;
}(_TemplateView3.default);

exports.default = SortableListContainer;

/***/ }),
/* 915 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var Exceptions = exports.Exceptions = {
    EMPTY_COMPONENTS_EXCEPTION: 'com.actimind.common.icalendar.builder.EmptyComponentsException'
};

/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getInstance = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _DropdownTemplateView2 = __webpack_require__(42);

var _DropdownTemplateView3 = _interopRequireDefault(_DropdownTemplateView2);

var _ScrollableContainer = __webpack_require__(49);

var _ScrollableContainer2 = _interopRequireDefault(_ScrollableContainer);

var _utils = __webpack_require__(6);

var _redux = __webpack_require__(7);

var _selectors = __webpack_require__(212);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _actions = __webpack_require__(568);

var _CountriesList = __webpack_require__(1788);

var _utils2 = __webpack_require__(85);

var _LoadingContainer = __webpack_require__(28);

var _LoadingContainer2 = _interopRequireDefault(_LoadingContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ImportHolidaysDialog = function (_DropdownTemplateView) {
    _inherits(ImportHolidaysDialog, _DropdownTemplateView);

    function ImportHolidaysDialog(_ref) {
        var _ref$onCountrySelecte = _ref.onCountrySelected,
            onCountrySelected = _ref$onCountrySelecte === undefined ? function (countryId) {} : _ref$onCountrySelecte,
            _ref$importFromFile = _ref.importFromFile,
            importFromFile = _ref$importFromFile === undefined ? function () {} : _ref$importFromFile,
            _ref$onHide = _ref.onHide,
            onHide = _ref$onHide === undefined ? function () {} : _ref$onHide;

        _classCallCheck(this, ImportHolidaysDialog);

        var _this = _possibleConstructorReturn(this, (ImportHolidaysDialog.__proto__ || Object.getPrototypeOf(ImportHolidaysDialog)).call(this, null, {
            onHide: onHide
        }));

        _this.actions = {
            onCountrySelected: onCountrySelected,
            importFromFile: importFromFile
        };

        _this.state = {
            defaultTimeZoneCountry: null,
            countries: []
        };

        _this.onStateChanged(function (state) {
            _this.countriesList.setState(_extends({}, state, {
                loading: state.countries.length <= 0
            }));
        });
        return _this;
    }

    _createClass(ImportHolidaysDialog, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class="components_importHolidaysDialog">' + '    <div class="title">' + '        <div class="text"><%=title%></div>' + '    </div>' + '    <div class="countriesContainer"/>' + '    <div class="importLinkContainer">' + '        <input type="file" class="importFileInput" hidden>' + '        <div class="importFileLink"><%=importFileLink%></div>' + '    </div>' + '</div>';
        }
    }, {
        key: 'messageKeys',
        value: function messageKeys() {
            return {
                title: 'work_schedule.import_holidays_dialog.title',
                importFileLink: 'work_schedule.import_holidays_dialog.import_file_link'
            };
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            var _this2 = this;

            this.countriesList = new _LoadingContainer2.default({
                contentComponent: new _ScrollableContainer2.default(null, new _CountriesList.CountriesList({
                    onCountrySelected: function onCountrySelected(country) {
                        _this2.hide();
                        _this2.actions.onCountrySelected(country);
                    }
                }), {
                    containerClass: 'countriesContainerScrollableWrapper'
                }),
                containerClass: "loading_importHolidaysDialog"
            }).init(this.find('.countriesContainer'));

            this.$fileInput = this.find('.importFileInput').on('change', function () {
                if (_this2.$fileInput[0].files.length !== 0) {
                    var file = _this2.$fileInput[0].files[0];
                    var error = (0, _utils2.validateFile)(file);
                    if (error) {
                        alert(error);
                        _this2.$fileInput.val('');
                    } else {
                        _this2.actions.importFromFile(_this2.$fileInput[0].files[0]);
                        _this2.$fileInput.val('');
                    }
                }
            });

            this.find('.importFileLink').on('click', function () {
                _this2.hide();
                _this2.$fileInput.click();
            });

            this.renderInitialState();
            this.getEl().on('click', function (e) {
                return e.stopPropagation();
            });
        }
    }]);

    return ImportHolidaysDialog;
}(_DropdownTemplateView3.default);

var ImportHolidaysDialogConnected = (0, _utils.connect)(function (state) {
    return {
        defaultTimeZoneCountry: (0, _selectors.getDefaultTimeZoneCountry)(state),
        countries: (0, _selectors.getCountries)(state)
    };
}, function (dispatch) {
    return {
        onCountrySelected: (0, _redux.bindActionCreators)(_actions.openPreviewHolidaysPanelBySelectedCountry, dispatch),
        importFromFile: (0, _redux.bindActionCreators)(_actions.openPreviewHolidaysPanelByFileImport, dispatch)
    };
})(ImportHolidaysDialog);

var instance = null;

var getInstance = exports.getInstance = function getInstance() {
    if (!instance) {
        instance = new ImportHolidaysDialogConnected().init((0, _jquery2.default)('body'));
    }
    return instance;
};

/***/ }),
/* 917 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EmptyList = function (_TemplateView) {
    _inherits(EmptyList, _TemplateView);

    function EmptyList() {
        _classCallCheck(this, EmptyList);

        var _this = _possibleConstructorReturn(this, (EmptyList.__proto__ || Object.getPrototypeOf(EmptyList)).call(this));

        _this.state = {
            title: ''
        };

        _this.onStatePropertyChanged('title', function (title) {
            _this.$title.text(title);
        });
        return _this;
    }

    _createClass(EmptyList, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '    <div class="holidayPanelsEmptyList">' + '        <div class="img"/>' + '        <div class="title"/>' + '    </div>';
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            this.$title = this.find('.title');
        }
    }]);

    return EmptyList;
}(_TemplateView3.default);

exports.default = EmptyList;

/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CreateTaskDescriptionUtil = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ENTITIES;

exports.DescriptionUtil = DescriptionUtil;

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*
 * Names of entites those are used for JSON requests.
 */
/*
  Class Messages.
    contains messages about save/load description status for the given entity.

  Methods:
    - contructor: Builds messages from templates using the given entity.

  Properties:
    All the properties are text messages built from templates.
    See the constructor implementation for more details.

  For detailed information about method parameters see the corresponding method description.

  Requires:
    js/description_util_entities_init_js.jsp
 */

/*
    Constructor.
      Builds messages from templates using the given parameters.
    Parameters:
      - entityType : an index from ENTITIES array to get string that is inserted into the message templates.
        Can be PROJECT_ENTITY, CUSTOMER_ENTITY, TASK_ENTITY and possibly other entities.
*/
var PROJECT_ENTITY = "Project";
var PROJECTS_ENTITY = "Projects";
var CUSTOMER_ENTITY = "Customer";
var CUSTOMERS_ENTITY = "Customers";
var TASK_ENTITY = "Task";
var TASKS_ENTITY = "Tasks";
/*
 * Entities indexes are names of entites those are used for JSON requests, and values are strings that associated with
 * those entities and displayed in the user interface.
 * This array is initialized by description_util_entities_init_js.jsp on every page where description_util.js is needed.
 */
var ENTITIES = (_ENTITIES = {}, _defineProperty(_ENTITIES, CUSTOMER_ENTITY, 'description_util.entity.customer'), _defineProperty(_ENTITIES, CUSTOMERS_ENTITY, 'description_util.entity.customers'), _defineProperty(_ENTITIES, PROJECT_ENTITY, 'description_util.entity.project'), _defineProperty(_ENTITIES, PROJECTS_ENTITY, 'description_util.entity.projects'), _defineProperty(_ENTITIES, TASK_ENTITY, 'description_util.entity.task'), _defineProperty(_ENTITIES, TASKS_ENTITY, 'description_util.entity.tasks'), _ENTITIES);

function Messages(entityType) {
    this.entityType = entityType;
    var entityMsg = _messageResource2.default.getMessage(ENTITIES[this.entityType]);
    var entityMsgLower = entityMsg.toLowerCase();
    this.MODIFICATIONS_NOT_SAVED = _messageResource2.default.getMessage("description_util.modifications_not_saved", [entityMsgLower]);
    this.TIMEOUT_DESCRIPTION_SAVING = _messageResource2.default.getMessage("description_util.timeout_description_saving", [entityMsgLower]);
    this.TIMEOUT_DESCRIPTION_LOADING = _messageResource2.default.getMessage("description_util.timeout_description_loading", [entityMsgLower]);
    this.ERROR_DESCRIPTION_SAVING = _messageResource2.default.getMessage("description_util.error_description_saving", [entityMsgLower]);
    this.ERROR_DESCRIPTION_LOADING = _messageResource2.default.getMessage("description_util.error_description_loading", [entityMsgLower]);
    this.TEXT_AREA_NOTE_NAME = _messageResource2.default.getMessage('description_util.text_area_note_name');
    this.TOO_LONG_DESCRIPTION = function (len) {
        return _messageResource2.default.getMessage("description_util.too_long_description", [entityMsg, entityMsgLower, entityMsgLower, len]);
    };
}

/*
  Class DescriptionUtil
    used for loading and saving description about tasks, customer, projects and possibly
    other entities using jsonrpc.

  Methods:
    - contructor: Creates a DescriptionUtil object for the given entity type
    - checkServiceAvailable : Checks if jsonrpc is available
    - doLoadDescription : Loads description using jsonrpc
    - doSaveDescription : SAVEs description using jsonrpc

  Properties:
    - Messages: instance of class Messages. See the corresponding description for details.

  For detailed information about method parameters see the corresponding method description.
*/

/*
  Creates a DescriptionUtil object for the given entity type
  Parameters:
    - entityType : Uses for creation jsonrpc calls and different information messages.
      Can be PROJECT_ENTITY, CUSTOMER_ENTITY, TASK_ENTITY and possibly other entities.
*/
function DescriptionUtil(entityType, rcpEntityType) {
    this.entityType = rcpEntityType ? rcpEntityType : entityType;
    var entityMsg = _messageResource2.default.getMessage(ENTITIES[entityType]);
    this.EDIT_DESCRIPTION_POPUP_CAPTION = _messageResource2.default.getMessage('description_util.edit_description_popup_caption', [entityMsg]);
    this.VIEW_DESCRIPTION_POPUP_CAPTION = _messageResource2.default.getMessage('description_util.view_description_popup_caption', [entityMsg]);

    this.Messages = new Messages(entityType);

    this.loadTimerId = null; // timer id for loading process;
}

function createCheckRemoteServiceAvailableFunc(entityType) {
    return new Function("", "return jsonrpc." + entityType + "InfoService;");
}

/*
    Check if jsonrpc is available, if not - reload the page.
*/
DescriptionUtil.prototype.checkServiceAvailable = function () {
    var checkRemoteServiceAvailable = createCheckRemoteServiceAvailableFunc(this.entityType);
    if (!checkRemoteServiceAvailable()) {
        /* service is unavailable, most likely we've been logged out */
        document.location.reload();
        return false;
    }

    return true;
};

function createGetDescriptionFunc(entityType) {
    var method = getDescriptionMethod(entityType) + "(descriptionLoadedHandler, id)";
    return new Function("descriptionLoadedHandler", "id", "return jsonrpc." + getDescriptionMethod(entityType) + "(descriptionLoadedHandler, id)" + ";");
}

function getDescriptionMethod(entityType) {
    var service = entityType + "InfoService";
    var method = "get" + entityType + "Description";
    return service + '.' + method;
}

/*
    Load description using jsonrpc.
    Parameters:
    - id : id of entity for load description.
    - descriptionLoadedHandler : function will call after script receive data from jsonrpc.
    - errorHandler - function for process errors.
    - saveRequestIdHandler - function to store current request ID (Optional)
*/
DescriptionUtil.prototype.doLoadDescription = function (id, descriptionLoadedHandler, errorHandler, saveRequestIdHandler) {
    try {
        var descriptionUtil = this;
        if (!isRpcReady([getDescriptionMethod(this.entityType)])) {
            var func = function func() {
                descriptionUtil.doLoadDescription(id, descriptionLoadedHandler, errorHandler, saveRequestIdHandler);
            };
            this.loadTimerId = window.setTimeout(func, 200);
            return;
        }
        if (!this.checkServiceAvailable()) return;
        var getDescription = createGetDescriptionFunc(this.entityType);
        var reqId = getDescription(descriptionLoadedHandler, id);
        if (saveRequestIdHandler) saveRequestIdHandler(reqId);
    } catch (e) {
        errorHandler(e);
    }
};

function createUpdateDescriptionFunc(entityType) {
    return new Function("descriptionSavedHandler", "id", "description", "return jsonrpc." + updateDescriptionMethod(entityType) + "(descriptionSavedHandler, id, description)" + ";");
}

function updateDescriptionMethod(entityType) {
    var service = entityType + "InfoService";
    var method = "update" + entityType + "Description";
    return service + '.' + method;
}

/*
    SAVE description using jsonrpc.
    Parameters:
    - id : id of entity for save description.
    - description : description for saving.
    - descriptionSavedHandler : function will call after script will save data using jsonrpc.
    - errorHandler - function for process errors.
    - saveRequestIdHandler - function to store current request ID (Optional)
*/
DescriptionUtil.prototype.doSaveDescription = function (id, description, descriptionSavedHandler, errorHandler, saveRequestIdHandler) {
    try {
        var descriptionUtil = this;
        if (!isRpcReady([updateDescriptionMethod(this.entityType)])) {
            var func = function func() {
                descriptionUtil.doSaveDescription(id, description, descriptionSavedHandler, errorHandler, saveRequestIdHandler);
            };
            DescriptionUtil.prototype.tid = window.setTimeout(func, 200);
            return;
        }

        if (!this.checkServiceAvailable()) return;

        var updateDescription = createUpdateDescriptionFunc(this.entityType);
        var reqId = updateDescription(descriptionSavedHandler, id, description);
        if (saveRequestIdHandler) saveRequestIdHandler(reqId);
    } catch (e) {
        errorHandler(e);
    }
};

var CreateTaskDescriptionUtil = exports.CreateTaskDescriptionUtil = function (_DescriptionUtil) {
    _inherits(CreateTaskDescriptionUtil, _DescriptionUtil);

    function CreateTaskDescriptionUtil(description, descriptionChangedCallback) {
        _classCallCheck(this, CreateTaskDescriptionUtil);

        var _this = _possibleConstructorReturn(this, (CreateTaskDescriptionUtil.__proto__ || Object.getPrototypeOf(CreateTaskDescriptionUtil)).call(this, TASK_ENTITY));

        _this.descriptionChangedCallback = descriptionChangedCallback;

        window.getOnPageDescription = function (idx) {
            return _.isEmpty(description) ? '' : description;
        };
        return _this;
    }

    _createClass(CreateTaskDescriptionUtil, [{
        key: "doSaveDescription",
        value: function doSaveDescription(idx, description, descriptionSavedHandler, errorHandler) {
            this.descriptionChangedCallback(description);

            if (descriptionSavedHandler !== undefined) descriptionSavedHandler();
        }
    }]);

    return CreateTaskDescriptionUtil;
}(DescriptionUtil);

/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _View2 = __webpack_require__(20);

var _View3 = _interopRequireDefault(_View2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PageMediator = function (_View) {
    _inherits(PageMediator, _View);

    function PageMediator() {
        _classCallCheck(this, PageMediator);

        return _possibleConstructorReturn(this, (PageMediator.__proto__ || Object.getPrototypeOf(PageMediator)).call(this));
    }

    _createClass(PageMediator, [{
        key: "getPage",
        value: function getPage() {
            // Abstract
        }
    }, {
        key: "openPage",
        value: function openPage() {
            if (!this._openedPageBefore) {
                this.beforeOpenPageFirstTime();
                this._openedPageBefore = true;
            }
            this.beforeOpenPage();

            this.getPage().show();
            this.getPage().$el.atAnimation().fadeIn();
        }
    }, {
        key: "leavePage",
        value: function leavePage() {
            if (this._openedPageBefore) {
                this.beforeLeavePage();
                this.getPage().hide();
                this.getPage().$el.atAnimation().fadeOut();
            }
        }
    }, {
        key: "beforeOpenPageFirstTime",
        value: function beforeOpenPageFirstTime() {
            // Abstract
        }
    }, {
        key: "beforeOpenPage",
        value: function beforeOpenPage() {
            // Abstract
        }
    }, {
        key: "beforeLeavePage",
        value: function beforeLeavePage() {
            // Abstract
        }
    }, {
        key: "showAlertAndReloadPage",
        value: function showAlertAndReloadPage(msgKey) {
            alert(_messageResource2.default.getMessage(msgKey));
            window.location.reload();
            return true;
        }
    }, {
        key: "abortRpcCall",
        value: function abortRpcCall(rpc) {
            if (!_underscore2.default.isUndefined(rpc)) {
                rpc.abort();
            }
        }
    }]);

    return PageMediator;
}(_View3.default);

exports.default = PageMediator;

/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TaskSelectionLabel = function (_TemplateView) {
    _inherits(TaskSelectionLabel, _TemplateView);

    function TaskSelectionLabel($containerEl, editable) {
        _classCallCheck(this, TaskSelectionLabel);

        var _this = _possibleConstructorReturn(this, (TaskSelectionLabel.__proto__ || Object.getPrototypeOf(TaskSelectionLabel)).call(this, $containerEl));

        _this.isSelected = false;
        _this.isDisabled = !editable;
        _this.ediatable = editable;
        _this.$containerEl = $containerEl;
        return _this;
    }

    _createClass(TaskSelectionLabel, [{
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='checkbox'>" + "  <div class='img'></div>" + "</div>";
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            var self = this;
            self.$el = self.$containerEl.find(".checkbox");
            this.bindClick(function () {
                if (!self.isDisabled) {
                    self.setSelection(!self.isSelected);
                    (0, _jquery2.default)(self).trigger("change", self.isSelected);
                }
            });
        }
    }, {
        key: "setSelection",
        value: function setSelection(isSelected) {
            if (isSelected !== this.isSelected) {
                this.isSelected = isSelected;
                this.update();
            }
        }
    }, {
        key: "setDisabled",
        value: function setDisabled(isDisabled) {
            if (this.ediatable && isDisabled !== this.isDisabled) {
                this.isDisabled = isDisabled;
                this.update();
            }
        }
    }, {
        key: "setEditable",
        value: function setEditable(editable) {
            this.ediatable = editable;
            if (!editable) this.isDisabled = true;
        }
    }, {
        key: "update",
        value: function update() {
            this.$el.toggleClass("disabled", this.isDisabled);
            this.$el.toggleClass("active", this.isSelected);
            this.$el.toggleClass("inactive", !this.isSelected);
        }
    }]);

    return TaskSelectionLabel;
}(_TemplateView3.default);

exports.default = TaskSelectionLabel;

/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _index = __webpack_require__(48);

var _index2 = _interopRequireDefault(_index);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _at_date_picker_menu = __webpack_require__(539);

var AT = _interopRequireWildcard(_at_date_picker_menu);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DatePickerMenu = function () {
    function DatePickerMenu(_ref) {
        var _ref$scheduleCalculat = _ref.scheduleCalculator,
            scheduleCalculator = _ref$scheduleCalculat === undefined ? null : _ref$scheduleCalculat,
            _ref$addClassesStr = _ref.addClassesStr,
            addClassesStr = _ref$addClassesStr === undefined ? '' : _ref$addClassesStr,
            _ref$needShadow = _ref.needShadow,
            needShadow = _ref$needShadow === undefined ? undefined : _ref$needShadow,
            _ref$parentEl = _ref.parentEl,
            parentEl = _ref$parentEl === undefined ? null : _ref$parentEl,
            _ref$showClearButton = _ref.showClearButton,
            showClearButton = _ref$showClearButton === undefined ? true : _ref$showClearButton,
            _ref$showOkCancelButt = _ref.showOkCancelButtons,
            showOkCancelButtons = _ref$showOkCancelButt === undefined ? true : _ref$showOkCancelButt,
            _ref$showMenuCb = _ref.showMenuCb,
            showMenuCb = _ref$showMenuCb === undefined ? function () {} : _ref$showMenuCb,
            _ref$hideMenuCb = _ref.hideMenuCb,
            hideMenuCb = _ref$hideMenuCb === undefined ? function () {} : _ref$hideMenuCb;

        _classCallCheck(this, DatePickerMenu);

        this.scheduleCalculator = scheduleCalculator;
        this.addClassesStr = addClassesStr;
        this.needShadow = _underscore2.default.isUndefined(needShadow) ? true : needShadow;
        this.parentEl = parentEl;
        this.showClearButton = showClearButton;
        this.showOkCancelButtons = showOkCancelButtons;
        this.showMenuCb = showMenuCb;
        this.hideMenuCb = hideMenuCb;
    }

    _createClass(DatePickerMenu, [{
        key: "init",
        value: function init() {
            var self = this;

            this.menu = new window.AT.menu.DatePickerMenu({
                mode: "dynamic",
                minDate: new Date(0),
                format: Date.convertSmartToExtDateFormat(window.SystemSettings.dateFormat).replace(/F/, "M"),
                showToday: true,
                showClearButton: this.showClearButton,
                showOkCancelButtons: this.showOkCancelButtons,
                scheduleCalculator: this.scheduleCalculator,
                startDay: window.SystemSettings.weekStartDay - 1,
                value: new Date(),
                cancelOnHide: true,
                shadow: self.needShadow,
                parentEl: this.parentEl
            });
            this.addClass(self.addClassesStr);

            this.menu.on("select", function () {
                self.selectCallback(self.getValue());
            });
            this.menu.on("datePickerClear", function () {
                self.selectCallback(null);
            });
            this.menu.on("datePickerCancel", function () {
                self.cancelCallback();
            });

            this.menu.on('beforeshow', function () {
                self.showMenuCb();
                (0, _jquery2.default)(window).on("resize.datePickerMenu", _underscore2.default.bind(self._onResize, self));
                this._removeKeydownHandler = _index2.default.onKeyDown(function (keycode, e) {
                    // ignore old event handler (ex: hide panel on escape keypressed)
                    return true;
                });
            });

            this.menu.on('beforehide', function () {
                self.hideMenuCb();
                (0, _jquery2.default)(window).off("resize.datePickerMenu");
                if (this._removeKeydownHandler) this._removeKeydownHandler();
            });

            return this;
        }
    }, {
        key: "_onResize",
        value: function _onResize() {
            this.hide();
        }
    }, {
        key: "_onScroll",
        value: function _onScroll() {
            this.hide();
        }
    }, {
        key: "hideMenu",
        value: function hideMenu() {
            this.menu.hide();
        }
    }, {
        key: "hide",
        value: function hide() {
            this.menu.hide();
        }
    }, {
        key: "getValue",
        value: function getValue() {
            return this.menu.picker.getValue();
        }
    }, {
        key: "setValue",
        value: function setValue(value) {
            this.menu.picker.setValue(value);
        }
    }, {
        key: "showAt",
        value: function showAt($el, selectCallback, cancelCallback) {
            this.selectCallback = selectCallback;
            this.cancelCallback = cancelCallback;
            this.menu.show($el[0]);
        }
    }, {
        key: "addClass",
        value: function addClass(classToAdd) {
            this.menu.cls += " " + classToAdd;
        }
    }]);

    return DatePickerMenu;
}();

exports.default = DatePickerMenu;

/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var CustomFieldType = exports.CustomFieldType = {
    String: 'String',
    Dropdown: 'Dropdown'
};

/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @author makovchik.
 * @since 15.10.2018.
 */

var TasksNotFoundMessage = function (_TemplateView) {
    _inherits(TasksNotFoundMessage, _TemplateView);

    function TasksNotFoundMessage() {
        _classCallCheck(this, TasksNotFoundMessage);

        var _this = _possibleConstructorReturn(this, (TasksNotFoundMessage.__proto__ || Object.getPrototypeOf(TasksNotFoundMessage)).call(this));

        _this.state = {
            showLinkToAllTasks: false
        };

        _this.onStatePropertyChanged('showLinkToAllTasks', function (show) {
            _this.$secondSentence.toggle(show);
        });
        return _this;
    }

    _createClass(TasksNotFoundMessage, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return "  <div class='tasksNotFoundMessage'>" + "    <p class='firstSentence'><%-notFoundFirstSentence%></p>" + "    <p class='secondSentence'><%-notFoundSecondSentence%> <a class='allTasksLink' href='#'><%-notFoundSecondSentenceAllTasks%></a></p>" + "  </div>";
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            this.find(".allTasksLink").click(function () {
                return (0, _jquery2.default)(document).trigger("taskManagement_tasksTable_allTasksClick");
            });

            this.$secondSentence = this.find(".secondSentence");
        }
    }, {
        key: 'messageKeys',
        value: function messageKeys() {
            return {
                notFoundFirstSentence: "task.list.tasks_not_found_first_sentence",
                notFoundSecondSentence: "task.list.tasks_not_found_second_sentence",
                notFoundSecondSentenceAllTasks: "task.list.tasks_not_found_second_sentence_all_tasks"
            };
        }
    }]);

    return TasksNotFoundMessage;
}(_TemplateView3.default);

exports.default = TasksNotFoundMessage;

/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _EntityNode2 = __webpack_require__(925);

var _EntityNode3 = _interopRequireDefault(_EntityNode2);

var _SimpleTooltip = __webpack_require__(36);

var _SimpleTooltip2 = _interopRequireDefault(_SimpleTooltip);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _EditButton = __webpack_require__(573);

var _EditButton2 = _interopRequireDefault(_EditButton);

var _utils = __webpack_require__(25);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CustomerNode = function (_EntityNode) {
    _inherits(CustomerNode, _EntityNode);

    function CustomerNode(_ref) {
        var tokensHighlighter = _ref.tokensHighlighter,
            customer = _ref.customer,
            collapsed = _ref.collapsed,
            _ref$onClick = _ref.onClick,
            onClick = _ref$onClick === undefined ? function () {} : _ref$onClick;

        _classCallCheck(this, CustomerNode);

        var _this = _possibleConstructorReturn(this, (CustomerNode.__proto__ || Object.getPrototypeOf(CustomerNode)).call(this, { tokensHighlighter: tokensHighlighter, onClick: onClick }));

        _this.customer = customer;
        _this.collapsed = collapsed;
        return _this;
    }

    _createClass(CustomerNode, [{
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='node customerNode'>" + "  <div class='collapseButton'></div>" + "  <div class='icon'></div>" + "  <div class='title'>" + "    <div class='text'><%=title%></div>" + "    <div class='archivedLabel'><%=archivedLabel%></div>" + "  </div>" + "</div>";
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            var _this2 = this;

            _get(CustomerNode.prototype.__proto__ || Object.getPrototypeOf(CustomerNode.prototype), "afterRender", this).call(this);

            var self = this;
            this.$collapseButton = this.find(".collapseButton");
            this.$collapseButton.click(function () {
                var newCollapsedValue = !self.collapsed;
                self.setCollapsed(newCollapsedValue);
                (0, _jquery2.default)(self).trigger("collapse", newCollapsedValue);
            });

            if (!this.editButton) {
                this.editButton = new _EditButton2.default(this.$el).init();
            }
            this.editButton.setClickHandler(function (e) {
                _this2._editButtonClickHandler(e);
            });

            var editTooltip = this.editTooltip();
            editTooltip.subscribeToMouseEvents(this.editButton.$el);
            (0, _jquery2.default)(this).on("hide_tooltip", function () {
                editTooltip.hide();
            });

            this.renderInitialState();
        }
    }, {
        key: "_editButtonClickHandler",
        value: function _editButtonClickHandler(e) {
            (0, _utils.setEventPreventHidingEditCustomerSlidingPanel)(e);
            (0, _jquery2.default)(document).trigger("taskManagement_viewCustomer", this.customer.id);
            (0, _jquery2.default)(this).trigger("hide_tooltip");
            this.preventNextClick = true;
        }
    }, {
        key: "update",
        value: function update() {
            if (this.rendered) {
                _get(CustomerNode.prototype.__proto__ || Object.getPrototypeOf(CustomerNode.prototype), "update", this).call(this);
                this.$el.toggleClass("collapsed", this.collapsed);
                this.$el.toggleClass("archived", this.customer.archived);
            }
        }
    }, {
        key: "messageKeys",
        value: function messageKeys() {
            return {
                archivedLabel: "common.archived"
            };
        }
    }, {
        key: "title",
        value: function title() {
            return this.customer.name;
        }
    }, {
        key: "isCollapsed",
        value: function isCollapsed() {
            return this.collapsed;
        }
    }, {
        key: "setCollapsed",
        value: function setCollapsed(collapsed) {
            this.collapsed = collapsed;
            this.update();
        }
    }, {
        key: "getId",
        value: function getId() {
            return this.customer.id;
        }
    }, {
        key: "editTooltip",
        value: function editTooltip() {
            if (!CustomerNode.tooltip) {
                CustomerNode.tooltip = new _SimpleTooltip2.default({
                    text: _messageResource2.default.getMessage('task.list.tooltip.customer_edit')
                }).init((0, _jquery2.default)('body'));
            }
            return CustomerNode.tooltip;
        }
    }]);

    return CustomerNode;
}(_EntityNode3.default);

exports.default = CustomerNode;

/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Node2 = __webpack_require__(572);

var _Node3 = _interopRequireDefault(_Node2);

var _atUtils = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EntityNode = function (_Node) {
    _inherits(EntityNode, _Node);

    function EntityNode(_ref) {
        var tokensHighlighter = _ref.tokensHighlighter,
            _ref$onClick = _ref.onClick,
            onClick = _ref$onClick === undefined ? function () {} : _ref$onClick;

        _classCallCheck(this, EntityNode);

        var _this = _possibleConstructorReturn(this, (EntityNode.__proto__ || Object.getPrototypeOf(EntityNode)).call(this, onClick));

        _this.tokensHighlighter = tokensHighlighter;

        _this.state = _extends({}, _this.state, {
            editing: false,
            editable: false
        });

        _this.onStatePropertyChanged('editing', function (editing) {
            return _this.$el.toggleClass("editing", editing);
        });
        _this.onStatePropertyChanged('editable', function (editable) {
            return _this.$el.toggleClass("editable", editable);
        });
        return _this;
    }

    _createClass(EntityNode, [{
        key: "templateModel",
        value: function templateModel() {
            return { title: this.tokensHighlighter ? this.tokensHighlighter.highlightTokens(this.title()) : (0, _atUtils.escapeHtmlSymbols)(this.title()) };
        }
    }, {
        key: "title",
        value: function title() {}
        // Abstract


        /**
         * @return {Tooltip}
         */

    }, {
        key: "editTooltip",
        value: function editTooltip() {
            // Abstract
        }
    }]);

    return EntityNode;
}(_Node3.default);

exports.default = EntityNode;

/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _EntityNode2 = __webpack_require__(925);

var _EntityNode3 = _interopRequireDefault(_EntityNode2);

var _SimpleTooltip = __webpack_require__(36);

var _SimpleTooltip2 = _interopRequireDefault(_SimpleTooltip);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _EditButton = __webpack_require__(573);

var _EditButton2 = _interopRequireDefault(_EditButton);

var _utils = __webpack_require__(25);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ProjectNode = function (_EntityNode) {
    _inherits(ProjectNode, _EntityNode);

    function ProjectNode(_ref) {
        var tokensHighlighter = _ref.tokensHighlighter,
            project = _ref.project,
            _ref$onClick = _ref.onClick,
            onClick = _ref$onClick === undefined ? function () {} : _ref$onClick;

        _classCallCheck(this, ProjectNode);

        var _this = _possibleConstructorReturn(this, (ProjectNode.__proto__ || Object.getPrototypeOf(ProjectNode)).call(this, { tokensHighlighter: tokensHighlighter, onClick: onClick }));

        _this.project = project;
        return _this;
    }

    _createClass(ProjectNode, [{
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='node projectNode'>" + "  <div class='icon'></div>" + "  <div class='title'>" + "    <div class='text'><%=title%></div>" + "    <div class='archivedLabel'><%=archivedLabel%></div>" + "  </div>" + "</div>";
        }
    }, {
        key: "messageKeys",
        value: function messageKeys() {
            return {
                archivedLabel: "common.archived"
            };
        }
    }, {
        key: "title",
        value: function title() {
            return this.project.name;
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            var _this2 = this;

            _get(ProjectNode.prototype.__proto__ || Object.getPrototypeOf(ProjectNode.prototype), "afterRender", this).call(this);

            if (!this.editButton) {
                this.editButton = new _EditButton2.default(this.$el).init();
            }
            this.editButton.setClickHandler(function (e) {
                _this2._editButtonClickHandler(e);
            });

            var editTooltip = this.editTooltip();
            editTooltip.subscribeToMouseEvents(this.editButton.$el);

            (0, _jquery2.default)(this).on("hide_tooltip", function () {
                editTooltip.hide();
            });

            this.$el.toggleClass("archived", this.project.archived);
            this.renderInitialState();
        }
    }, {
        key: "_editButtonClickHandler",
        value: function _editButtonClickHandler(e) {
            (0, _utils.setEventPreventHidingEditProjectSlidingPanel)(e);
            (0, _jquery2.default)(document).trigger("taskManagement_customersProjectsPanel_viewProject", this.project.id);
            (0, _jquery2.default)(this).trigger("hide_tooltip");
            this.preventNextClick = true;
        }
    }, {
        key: "getId",
        value: function getId() {
            return this.project.id;
        }
    }, {
        key: "editTooltip",
        value: function editTooltip() {
            if (!ProjectNode.tooltip) {
                ProjectNode.tooltip = new _SimpleTooltip2.default({
                    text: _messageResource2.default.getMessage('task.list.tooltip.project_edit')
                }).init((0, _jquery2.default)('body'));
            }
            return ProjectNode.tooltip;
        }
    }]);

    return ProjectNode;
}(_EntityNode3.default);

exports.default = ProjectNode;

/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _Node2 = __webpack_require__(572);

var _Node3 = _interopRequireDefault(_Node2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OtherProjectsNode = function (_Node) {
    _inherits(OtherProjectsNode, _Node);

    function OtherProjectsNode(_ref) {
        var _ref$onClick = _ref.onClick,
            onClick = _ref$onClick === undefined ? function () {} : _ref$onClick;

        _classCallCheck(this, OtherProjectsNode);

        var _this = _possibleConstructorReturn(this, (OtherProjectsNode.__proto__ || Object.getPrototypeOf(OtherProjectsNode)).call(this));

        _this.onClick = onClick;

        _this.state = _extends({}, _this.state, {
            collapsed: true,
            onlyOtherProjectsInCustomer: false
        });

        _this.onStatePropertyChanged('collapsed', function (collapsed) {
            _this.getEl().toggleClass('onlySeparator', !collapsed);
            _this.$nodeContent.toggle(collapsed);
        });

        _this.onStatePropertyChanged('onlyOtherProjectsInCustomer', function (onlyOtherProjectsInCustomer) {
            _this.find('.separator').toggle(!onlyOtherProjectsInCustomer);
            _this.$title.text(onlyOtherProjectsInCustomer ? _messageResource2.default.getMessage('customers_projects.view_customer_projects') : _messageResource2.default.getMessage('customers_projects.view_other_customer_projects'));
        });
        return _this;
    }

    _createClass(OtherProjectsNode, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return "<div class='node projectNode otherProjectsNode'>" + "  <div class='separator'/>" + "  <div class='nodeContent'>" + "    <div class='icon'></div>" + "    <div class='title'></div>" + "  </div>" + "</div>";
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            var _this2 = this;

            this.$nodeContent = this.find('.nodeContent');
            this.$title = this.find('.title');
            this.getEl().click(function () {
                _this2.setState({ collapsed: !_this2.state.collapsed });
                _this2.onClick();
            });
            this.renderInitialState();
        }
    }, {
        key: 'isCollapsed',
        value: function isCollapsed() {
            return this.state.collapsed;
        }
    }]);

    return OtherProjectsNode;
}(_Node3.default);

exports.default = OtherProjectsNode;

/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.changeIsCustomersAsc = exports.changeVisibleProjectIds = exports.changeVisibleCustomerIds = exports.removeCollapsedCustomers = exports.addCollapsedCustomers = exports.setCpPanelWidth = exports.setCpPanelMaxWidth = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _utils = __webpack_require__(6);

var _actionTypes = __webpack_require__(671);

var ActionTypes = _interopRequireWildcard(_actionTypes);

var _constants = __webpack_require__(344);

var _utils2 = __webpack_require__(929);

var _selectors = __webpack_require__(574);

var _atUtils = __webpack_require__(5);

var _selectors2 = __webpack_require__(14);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var setCpPanelMaxWidth = exports.setCpPanelMaxWidth = function setCpPanelMaxWidth(windowWidth) {
    return function (dispatch) {
        var maxWidth = windowWidth - _constants.RIGHT_MIN_WIDTH;
        if (maxWidth < _constants.LEFT_MIN_WIDTH) maxWidth = _constants.LEFT_MIN_WIDTH;
        dispatch((0, _utils.createActionObject)(ActionTypes.CP_PANEL_MAX_WIDTH_CHANGE, maxWidth));
    };
};

var setCpPanelWidth = exports.setCpPanelWidth = function setCpPanelWidth(width) {
    return function (dispatch) {
        dispatch((0, _utils.createActionObject)(ActionTypes.CP_PANEL_WIDTH_CHANGE, width));
        (0, _utils2.saveCPPanelWidthToLocalStorage)(width);
    };
};

var changeCollapsedCustomersSet = function changeCollapsedCustomersSet(newSet) {
    return function (dispatch, getState) {
        var customers = (0, _selectors2.getCustomers)(getState());
        var filteredNewSet = removeNotAvailableCustomersFromCollapsedSet(newSet, customers);
        (0, _utils2.saveCPPanelCollapsedCustomersToLocalStorage)(filteredNewSet);
        dispatch((0, _utils.createActionObject)(ActionTypes.CP_PANEL_COLLAPSED_CUSTOMERS_SET_CHANGE, newSet));
    };
};

var addCollapsedCustomers = exports.addCollapsedCustomers = function addCollapsedCustomers(collapsedCustomers) {
    return function (dispatch, getState) {
        var currentSet = (0, _selectors.getCollapsedCustomersSet)(getState());
        dispatch(changeCollapsedCustomersSet(_extends({}, currentSet, (0, _atUtils.arrayToSet)(collapsedCustomers))));
    };
};

var removeCollapsedCustomers = exports.removeCollapsedCustomers = function removeCollapsedCustomers(customersToRemove) {
    return function (dispatch, getState) {
        var currentSet = (0, _selectors.getCollapsedCustomersSet)(getState());
        var customersToRemoveSet = (0, _atUtils.arrayToSet)(customersToRemove);
        dispatch(changeCollapsedCustomersSet((0, _atUtils.arrayToSet)(Object.keys(currentSet).filter(function (cId) {
            return !customersToRemoveSet[cId];
        }))));
    };
};

var removeNotAvailableCustomersFromCollapsedSet = function removeNotAvailableCustomersFromCollapsedSet(collapsedSet, customers) {
    return (0, _atUtils.arrayToSet)(Object.keys(collapsedSet).filter(function (cId) {
        return !!customers[cId];
    }));
};

var changeVisibleCustomerIds = exports.changeVisibleCustomerIds = function changeVisibleCustomerIds(customerIds) {
    return function (dispatch) {
        dispatch((0, _utils.createActionObject)(ActionTypes.CP_PANEL_VISIBLE_CUSTOMER_IDS_CHANGE, customerIds));
    };
};

var changeVisibleProjectIds = exports.changeVisibleProjectIds = function changeVisibleProjectIds(projectIds) {
    return function (dispatch) {
        dispatch((0, _utils.createActionObject)(ActionTypes.CP_PANEL_VISIBLE_PROJECT_IDS_CHANGE, projectIds));
    };
};

var changeIsCustomersAsc = exports.changeIsCustomersAsc = function changeIsCustomersAsc(order) {
    return function (dispatch) {
        dispatch((0, _utils.createActionObject)(ActionTypes.CP_PANEL_IS_CUSTOMERS_ASC_CHANGE, order));
    };
};

/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.loadCPPanelCollapsedCustomersFromLocalStorage = exports.saveCPPanelCollapsedCustomersToLocalStorage = exports.loadCpPanelWidthFromLocalStorage = exports.saveCPPanelWidthToLocalStorage = undefined;

var _LocalStorage = __webpack_require__(72);

var _constants = __webpack_require__(344);

var saveCPPanelWidthToLocalStorage = exports.saveCPPanelWidthToLocalStorage = function saveCPPanelWidthToLocalStorage(width) {
    (0, _LocalStorage.getLocalStorage)().setItem(_constants.TM_CP_PANEL_WIDTH_LS_KEY, width);
};

var loadCpPanelWidthFromLocalStorage = exports.loadCpPanelWidthFromLocalStorage = function loadCpPanelWidthFromLocalStorage() {
    var cpBlockWidth = (0, _LocalStorage.getLocalStorage)().getItem(_constants.TM_CP_PANEL_WIDTH_LS_KEY);
    return cpBlockWidth ? cpBlockWidth : _constants.CP_PANEL_INITIAL_WIDTH;
};

var saveCPPanelCollapsedCustomersToLocalStorage = exports.saveCPPanelCollapsedCustomersToLocalStorage = function saveCPPanelCollapsedCustomersToLocalStorage(collapsedCustomersSet) {
    (0, _LocalStorage.getLocalStorage)().setItem(_constants.TM_CP_PANEL_COLLAPSED_CUSTOMERS_SET_LS_KEY, collapsedCustomersSet);
};

var loadCPPanelCollapsedCustomersFromLocalStorage = exports.loadCPPanelCollapsedCustomersFromLocalStorage = function loadCPPanelCollapsedCustomersFromLocalStorage() {
    return (0, _LocalStorage.getLocalStorage)().getItem(_constants.TM_CP_PANEL_COLLAPSED_CUSTOMERS_SET_LS_KEY);
};

/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getIsSummaryRowShown = exports.getExportState = undefined;

var _reselect = __webpack_require__(13);

var _constants = __webpack_require__(44);

var _selectors = __webpack_require__(189);

var _selectors2 = __webpack_require__(82);

var getExportState = exports.getExportState = function getExportState(state) {
    return (0, _selectors.selectTaskManagement)(state).exportCsvTaskList;
};
var getIsSummaryRowShown = exports.getIsSummaryRowShown = (0, _reselect.createSelector)(_selectors2.getIsSummaryRowShown, _selectors2.getSummaryRow, _selectors2.getShownColumns, function (isShown, summaryRow, shownColumns) {
    var summaryColumnsShown = shownColumns.includes(_constants.TaskSortBy.ESTIMATE) || shownColumns.includes(_constants.TaskSortBy.SPENT_TIME);
    var areSummaryColumnsNotEmpty = [summaryRow.spentTime, summaryRow.estimate].some(function (column) {
        return column !== undefined;
    });

    return isShown && areSummaryColumnsNotEmpty && summaryColumnsShown;
});

/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.columnValue = columnValue;
exports.columnValueOrHyphen = columnValueOrHyphen;
exports.formatDate = formatDate;
exports.formatTimeDecimal = formatTimeDecimal;
exports.formatNumber = formatNumber;
exports.formatPercent = formatPercent;
exports.nameWithArchivedMark = nameWithArchivedMark;

var _date_format = __webpack_require__(16);

var _number_formatter = __webpack_require__(61);

var _number_formatter2 = _interopRequireDefault(_number_formatter);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var dateFormat = new _date_format.DateFormat(window.SystemSettings.dateFormat);
var numberFormat = new _number_formatter2.default(window.SystemSettings.decimalSeparator, window.SystemSettings.digitGroupingSymbol, 2, false);

function columnValue(val) {
    var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (val) {
        return val;
    };

    return val ? format(val) : '';
}

function columnValueOrHyphen(val) {
    var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (val) {
        return val;
    };

    return val !== undefined && val !== null ? format(val) : '-';
}

function formatDate(val) {
    return dateFormat.formatDate(Date.parseJSONDate(val));
}

function formatTimeDecimal(val) {
    return numberFormat.format(val / 60);
}

function formatNumber(val) {
    return numberFormat.format(val);
}

function formatPercent(val) {
    return formatNumber(val) + '%';
}

function nameWithArchivedMark(entity) {
    return entity.archived ? entity.name + ' ' + _messageResource2.default.getMessage('common.archived') : entity.name;
}

/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _LoadingSpinner = __webpack_require__(191);

var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ExportCSVButton = function (_TemplateView) {
    _inherits(ExportCSVButton, _TemplateView);

    function ExportCSVButton(_ref) {
        var _ref$labelMessageKey = _ref.labelMessageKey,
            labelMessageKey = _ref$labelMessageKey === undefined ? "" : _ref$labelMessageKey,
            _ref$noDataMessageKey = _ref.noDataMessageKey,
            noDataMessageKey = _ref$noDataMessageKey === undefined ? "" : _ref$noDataMessageKey,
            _ref$exportAction = _ref.exportAction,
            exportAction = _ref$exportAction === undefined ? function () {} : _ref$exportAction;

        _classCallCheck(this, ExportCSVButton);

        var _this = _possibleConstructorReturn(this, (ExportCSVButton.__proto__ || Object.getPrototypeOf(ExportCSVButton)).call(this));

        _this.params = { labelMessageKey: labelMessageKey, noDataMessageKey: noDataMessageKey };
        _this.state = {
            disabled: false,
            inProgress: false
        };
        _this.callbacks = {
            exportAction: exportAction
        };
        _this.onStatePropertyChanged('disabled', function (disabled) {
            _this.getEl().toggleClass('disabled', disabled);
            _this.getEl().prop('title', disabled ? _messageResource2.default.getMessage(noDataMessageKey) : '');
        });
        _this.onStatePropertyChanged('inProgress', function (inProgress) {
            _this.getEl().toggleClass('inProgress', inProgress);
            _this.spinner.setState({ show: inProgress });
        });
        return _this;
    }

    _createClass(ExportCSVButton, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return " <div class='linkButton'>" + "    <div class='icon'/>" + "    <div class='exportSpinner'/>" + "    <div class='linkButtonLabel'><%=label%></div>" + " </div>";
        }
    }, {
        key: 'messageKeys',
        value: function messageKeys() {
            return {
                label: this.params.labelMessageKey
            };
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            var _this2 = this;

            this.spinner = new _LoadingSpinner2.default().init(this.find(".exportSpinner"));
            this.bindClick(function () {
                if (_this2.state.disabled || _this2.state.inProgress) return;
                _this2.callbacks.exportAction();
            });
        }
    }]);

    return ExportCSVButton;
}(_TemplateView3.default);

exports.default = ExportCSVButton;

/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getColumnsForConfigMenu = exports.getIsSummaryRowShown = exports.getSelectedColumns = exports.getColumnsOrder = exports.getColumnsConfiguratorMenuState = undefined;

var _selectors = __webpack_require__(189);

var _reselect = __webpack_require__(13);

var _constants = __webpack_require__(571);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _selectors2 = __webpack_require__(27);

var _utils = __webpack_require__(570);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getColumnsConfiguratorMenuState = exports.getColumnsConfiguratorMenuState = function getColumnsConfiguratorMenuState(state) {
    return (0, _selectors.selectTaskManagement)(state).columnConfiguratorMenu;
};

var getColumnsOrder = exports.getColumnsOrder = function getColumnsOrder(state) {
    return getColumnsConfiguratorMenuState(state).columnsOrder;
};

var getSelectedColumns = exports.getSelectedColumns = function getSelectedColumns(state) {
    return getColumnsConfiguratorMenuState(state).columnsSelected;
};

var getIsSummaryRowShown = exports.getIsSummaryRowShown = function getIsSummaryRowShown(state) {
    return getColumnsConfiguratorMenuState(state).isSummaryRowShown;
};

var getColumnsForConfigMenu = exports.getColumnsForConfigMenu = (0, _reselect.createSelector)(getColumnsOrder, getSelectedColumns, _selectors2.getTaskCustomFieldsMap, function (columns, shown, customFieldsMap) {
    return columns.map(function (column) {
        var name = !!customFieldsMap[column] ? customFieldsMap[column].title : _messageResource2.default.getMessage(_constants.ColumnTitlesKeys[column]);
        return {
            id: column,
            name: name,
            selected: !!shown[column],
            fixed: (0, _utils.isColumnFixed)(column)
        };
    });
});

/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _index = __webpack_require__(48);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BaseTasksChangeDialog = function (_TemplateView) {
    _inherits(BaseTasksChangeDialog, _TemplateView);

    function BaseTasksChangeDialog(_ref) {
        var $containerElement = _ref.$containerElement,
            _ref$cancelHandler = _ref.cancelHandler,
            cancelHandler = _ref$cancelHandler === undefined ? function () {} : _ref$cancelHandler,
            submitHandler = _ref.submitHandler;

        _classCallCheck(this, BaseTasksChangeDialog);

        var _this = _possibleConstructorReturn(this, (BaseTasksChangeDialog.__proto__ || Object.getPrototypeOf(BaseTasksChangeDialog)).call(this, $containerElement));

        _this.cancelHandler = cancelHandler;
        _this.submitHandler = submitHandler;

        _this.state = {
            numberOfTasks: -1,
            saving: false
        };

        _this.onStatePropertyChanged('numberOfTasks', function () {
            _this._updateTitleText();
        });

        _this.onStatePropertyChanged('saving', function (saving) {
            _this.$el.toggleClass("savingState", saving);
        });
        return _this;
    }

    _createClass(BaseTasksChangeDialog, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div>' + '  <div class="assignToDialogInnerContainer">' + '    ' + '    <div class="title"><%-titleText%></div>' + '    <div class="mainContainer">' + '      <div class="label"><%-labelText%></div>' + '      <div class="selectorContainer"></div>' + '    </div>' + '    <div class="buttonsContainer">' + '      <div class="withIcon submitBtn greyButton" tabindex="-1">' + '        <div class="buttonIcon">' + '          <span class="buttonTitle"><%-submitButtonText%></span>' + '        </div>' + '      </div>' + '      <div class="cancelBtn greyButton"><%=cancelButtonText%></div>' + '    </div>' + '  </div>' + '</div>';
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            this._setHandlers();
            this.$submitBtn = this.$el.find(".submitBtn");
        }
    }, {
        key: 'show',
        value: function show() {
            var _this2 = this;

            _get(BaseTasksChangeDialog.prototype.__proto__ || Object.getPrototypeOf(BaseTasksChangeDialog.prototype), 'show', this).call(this);
            this._removeKeyDown = _index.KEY_HANDLERS.onKeyDown(function (code) {
                if ((0, _index.isEnter)(code) || (0, _index.isSpace)(code)) {
                    _this2.onSubmit();
                    return true;
                }
            });

            this.$submitBtn.focus();
        }
    }, {
        key: 'hide',
        value: function hide() {
            _get(BaseTasksChangeDialog.prototype.__proto__ || Object.getPrototypeOf(BaseTasksChangeDialog.prototype), 'hide', this).call(this);
            if (this._removeKeyDown) this._removeKeyDown();
        }
    }, {
        key: '_setHandlers',
        value: function _setHandlers() {
            var _this3 = this;

            this.$el.find(".cancelBtn").unbind().click(function () {
                _this3._onCancel();
            });
            this.$el.find(".submitBtn").unbind().click(function () {
                _this3.onSubmit();
            });
        }
    }, {
        key: '_onCancel',
        value: function _onCancel() {
            if (this.state.saving) return;

            this.cancelHandler();
        }
    }, {
        key: 'onSubmit',
        value: function onSubmit() {
            console.error('function _onSubmit not implemented');
        }
    }, {
        key: 'templateModel',
        value: function templateModel() {
            return {
                titleText: this.titleText()
            };
        }
    }, {
        key: '_updateTitleText',
        value: function _updateTitleText() {
            this.getTitleEl().text(this.titleText());
        }
    }, {
        key: 'getTitleEl',
        value: function getTitleEl() {
            return this.find('.title');
        }
    }, {
        key: 'titleText',
        value: function titleText() {
            return '';
        }
    }]);

    return BaseTasksChangeDialog;
}(_TemplateView3.default);

exports.default = BaseTasksChangeDialog;

/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AssignedUsersEditorChangesHandler = function () {
    function AssignedUsersEditorChangesHandler(_ref) {
        var editor = _ref.editor,
            _ref$assignedUserMode = _ref.assignedUserModelExtender,
            assignedUserModelExtender = _ref$assignedUserMode === undefined ? function (assigned) {
            return {};
        } : _ref$assignedUserMode,
            _ref$changeCallback = _ref.changeCallback,
            changeCallback = _ref$changeCallback === undefined ? function () {} : _ref$changeCallback;

        _classCallCheck(this, AssignedUsersEditorChangesHandler);

        this.editor = editor;
        this.assignedUserModelExtender = assignedUserModelExtender;
        this.changeCallback = changeCallback;
        this.addedIds = {};
    }

    _createClass(AssignedUsersEditorChangesHandler, [{
        key: "handleUserDelete",
        value: function handleUserDelete(userId) {
            delete this.addedIds[userId];
            this._updateEditorState();
            this.changeCallback();
        }
    }, {
        key: "handleAssignedUsersChange",
        value: function handleAssignedUsersChange(addedUserIds, removedUserIds) {
            var _this = this;

            addedUserIds.forEach(function (id) {
                return _this.addedIds[id] = true;
            });
            removedUserIds.forEach(function (id) {
                return delete _this.addedIds[id];
            });
            this._updateEditorState();
            this.changeCallback();
        }
    }, {
        key: "getAddedUserIds",
        value: function getAddedUserIds() {
            return Object.keys(this.addedIds);
        }
    }, {
        key: "extendEditorState",
        value: function extendEditorState(state) {
            var _this2 = this;

            return _extends({}, state, {
                users: state.users.map(function (user) {
                    if (user.canBeModified) {
                        return _extends({}, user, _this2.assignedUserModelExtender(!!_this2.addedIds[user.id]));
                    } else {
                        return user;
                    }
                })
            });
        }
    }, {
        key: "_updateEditorState",
        value: function _updateEditorState() {
            var editor = this.editor;
            editor.setState(this.extendEditorState(editor.state));
        }
    }]);

    return AssignedUsersEditorChangesHandler;
}();

exports.default = AssignedUsersEditorChangesHandler;

/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _View2 = __webpack_require__(20);

var _View3 = _interopRequireDefault(_View2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ProxyView = function (_View) {
    _inherits(ProxyView, _View);

    function ProxyView($el) {
        _classCallCheck(this, ProxyView);

        var _this = _possibleConstructorReturn(this, (ProxyView.__proto__ || Object.getPrototypeOf(ProxyView)).call(this));

        _this.$el = $el;
        return _this;
    }

    return ProxyView;
}(_View3.default);

exports.default = ProxyView;

/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TabHeaders = function (_TemplateView) {
    _inherits(TabHeaders, _TemplateView);

    function TabHeaders() {
        _classCallCheck(this, TabHeaders);

        return _possibleConstructorReturn(this, (TabHeaders.__proto__ || Object.getPrototypeOf(TabHeaders)).apply(this, arguments));
    }

    _createClass(TabHeaders, [{
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='tabs'>" + "  <div class='details'><span class='tabText'><%=detailsTab%></span></div>" + "  <div class='assignedUsers'><span class='tabText'><%=assignedUsersTab%></span></div>" + "  <div class='managers'><span class='tabText'><%=managersTab%></span></div>" + "</div>";
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            this.$detailsTabHeader = this.find(".details");
            this.$assignedUsersTabHeader = this.find(".assignedUsers");
            this.$managersTabHeader = this.find(".managers");
            this.$assignedUsersTabTitle = this.$assignedUsersTabHeader.find(".tabText");
            this.$managersTabTitle = this.$managersTabHeader.find(".tabText");
        }
    }, {
        key: "messageKeys",
        value: function messageKeys() {
            return {
                detailsTab: "project.edit_panel.tabs.details",
                assignedUsersTab: 'project.edit_panel.tabs.assigned_users',
                managersTab: 'project.edit_panel.tabs.managers'
            };
        }
    }]);

    return TabHeaders;
}(_TemplateView3.default);

exports.default = TabHeaders;

/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ToastsContainer = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _Toast = __webpack_require__(1883);

var _Toast2 = _interopRequireDefault(_Toast);

var _atUtils = __webpack_require__(5);

var _utils = __webpack_require__(6);

var _selectors = __webpack_require__(764);

var _redux = __webpack_require__(7);

var _actions = __webpack_require__(56);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ToastsContainer = exports.ToastsContainer = function (_TemplateView) {
    _inherits(ToastsContainer, _TemplateView);

    function ToastsContainer(_ref) {
        var closeToast = _ref.closeToast;

        _classCallCheck(this, ToastsContainer);

        var _this = _possibleConstructorReturn(this, (ToastsContainer.__proto__ || Object.getPrototypeOf(ToastsContainer)).call(this));

        _this.actions = {
            closeToast: closeToast
        };

        _this.state = {
            messages: []
        };

        _this.toasts = {};

        _this.onStatePropertyDeeplyChanged('messages', function (newMessages) {
            var oldMessages = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

            var newMessagesIds = (0, _atUtils.arrayToSet)(newMessages.map(function (m) {
                return m.id;
            }));
            var oldMessagesIds = (0, _atUtils.arrayToSet)(oldMessages.map(function (m) {
                return m.id;
            }));

            newMessages.forEach(function (newMessage) {
                if (!oldMessagesIds[newMessage.id]) {
                    _this.toasts[newMessage.id] = new _Toast2.default({
                        innerHtml: newMessage.html,
                        additionalClass: newMessage.isWarning ? 'warning' : '',
                        withCloseIcon: newMessage.isWarning,
                        onClose: function onClose() {
                            return _this.actions.closeToast(newMessage.id);
                        }
                    }).init(_this.$el);
                }
            });

            oldMessages.forEach(function (oldMessage) {
                if (!newMessagesIds[oldMessage.id]) {
                    _this.toasts[oldMessage.id].hide();
                    delete _this.toasts[oldMessage.id];
                }
            });
        });
        return _this;
    }

    _createClass(ToastsContainer, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return "<div class='toastsContainer'></div>";
        }
    }]);

    return ToastsContainer;
}(_TemplateView3.default);

exports.default = (0, _utils.connect)(function (state) {
    return {
        messages: (0, _selectors.getMessages)(state)
    };
}, function (dispatch) {
    return {
        closeToast: (0, _redux.bindActionCreators)(_actions.closeToast, dispatch)
    };
})(ToastsContainer);

/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _utils = __webpack_require__(6);

var _selectors = __webpack_require__(143);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _pluralizeUtils = __webpack_require__(40);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LicenseCountDownTip = function (_TemplateView) {
    _inherits(LicenseCountDownTip, _TemplateView);

    function LicenseCountDownTip() {
        _classCallCheck(this, LicenseCountDownTip);

        var _this = _possibleConstructorReturn(this, (LicenseCountDownTip.__proto__ || Object.getPrototypeOf(LicenseCountDownTip)).call(this));

        _this.state = {
            isShowLicenseCountDownTip: false,
            licenseCountDaysToExpiration: 0
        };

        _this.onAnyStatePropertyDeeplyChanged(['isShowLicenseCountDownTip', 'licenseCountDaysToExpiration'], function () {
            _this.$count.text(_this.state.licenseCountDaysToExpiration);
            _this.$daysLeftText.text(_messageResource2.default.getMessage('licenses.count_dawn_tip.days_left', [(0, _pluralizeUtils.daysNameLower)(_this.state.licenseCountDaysToExpiration)]));
            _this.getEl().toggle(_this.state.isShowLicenseCountDownTip);
        });
        return _this;
    }

    _createClass(LicenseCountDownTip, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class="licenseCountDownTip">\n                    <div class="count"/>\n                    <div class="daysLeftText"/>\n                    <div class="getLicensesButton"><span><%=buttonText%></span></div>\n                </div>';
        }
    }, {
        key: 'messageKeys',
        value: function messageKeys() {
            return {
                buttonText: 'licenses.count_dawn_tip.button_text'
            };
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            var _this2 = this;

            this.$count = this.find('.count');
            this.$daysLeftText = this.find('.daysLeftText');

            this.getEl().click(function () {
                return window.location = window.BASE_PATH + 'administration/manage_licenses.do';
            });

            if (window.NAVIGATION_COLLAPSED) this.getEl().addClass('collapsedNav');

            $(document).on('navigation_resize_event', function (e, _ref) {
                var navigationCollapsed = _ref.navigationCollapsed;

                _this2.getEl().toggleClass('collapsedNav', navigationCollapsed);
            });

            this.renderInitialState();
        }
    }]);

    return LicenseCountDownTip;
}(_TemplateView3.default);

exports.default = (0, _utils.connect)(function (state) {
    return {
        isShowLicenseCountDownTip: (0, _selectors.isShowLicenseCountDownTip)(state),
        licenseCountDaysToExpiration: (0, _selectors.getLicenseCountDaysToExpiration)(state)
    };
})(LicenseCountDownTip);

/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _utils = __webpack_require__(6);

var _selectors = __webpack_require__(307);

var _actions = __webpack_require__(306);

var _redux = __webpack_require__(7);

var _atBrowserUtils = __webpack_require__(8);

var _constants = __webpack_require__(181);

var _SimpleTooltip = __webpack_require__(36);

var _SimpleTooltip2 = _interopRequireDefault(_SimpleTooltip);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SupportQuestionButton = function (_TemplateView) {
    _inherits(SupportQuestionButton, _TemplateView);

    function SupportQuestionButton(_ref) {
        var _ref$openSupportForm = _ref.openSupportForm,
            openSupportForm = _ref$openSupportForm === undefined ? function () {} : _ref$openSupportForm;

        _classCallCheck(this, SupportQuestionButton);

        var _this = _possibleConstructorReturn(this, (SupportQuestionButton.__proto__ || Object.getPrototypeOf(SupportQuestionButton)).call(this));

        _this.state = {
            shown: false,
            active: false
        };

        _this.actions = {
            openSupportForm: openSupportForm
        };

        _this.onStatePropertyChanged('active', function (active) {
            _this.getEl().toggleClass('active', active);
        });

        _this.onStatePropertyChanged('shown', function (shown) {
            _this.getEl().toggle(shown);
        });
        return _this;
    }

    _createClass(SupportQuestionButton, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class="supportQuestionButton"/>';
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            var _this2 = this;

            this.getEl().click(function () {
                if (_this2.state.shown) {
                    var position = (0, _atBrowserUtils.calculateObjectCoords)(_this2.getEl()[0]);
                    _this2.actions.openSupportForm({
                        positionStrategy: _constants.supportPopupPositionStrategy.FROM_BOTTOM_RIGHT,
                        position: position
                    });
                }
            });
            this.tooltip = new _SimpleTooltip2.default({
                text: _messageResource2.default.getMessage('contact_support.got_a_question'),
                extraClass: 'supportQuestionButtonTooltip'
            }).init((0, _jquery2.default)('body'));
            this.tooltip.subscribeToMouseEvents(this.getEl());
        }
    }]);

    return SupportQuestionButton;
}(_TemplateView3.default);

exports.default = (0, _utils.connect)(function (state) {
    return {
        shown: (0, _selectors.showSupportQuestionButton)(state),
        active: (0, _selectors.isSupportFormShown)(state)
    };
}, function (dispatch) {
    return {
        openSupportForm: (0, _redux.bindActionCreators)(_actions.openSupportForm, dispatch)
    };
})(SupportQuestionButton);

/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _DraggablePopup = __webpack_require__(1885);

var _DraggablePopup2 = _interopRequireDefault(_DraggablePopup);

var _ContactSupportForm = __webpack_require__(1886);

var _ContactSupportForm2 = _interopRequireDefault(_ContactSupportForm);

var _constants = __webpack_require__(181);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _View2 = __webpack_require__(20);

var _View3 = _interopRequireDefault(_View2);

var _utils = __webpack_require__(6);

var _selectors = __webpack_require__(307);

var _actions = __webpack_require__(306);

var _redux = __webpack_require__(7);

var _LoadingContainer = __webpack_require__(28);

var _LoadingContainer2 = _interopRequireDefault(_LoadingContainer);

var _atBrowserUtils = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ContactSupportDraggablePopupContainer = function (_View) {
    _inherits(ContactSupportDraggablePopupContainer, _View);

    function ContactSupportDraggablePopupContainer() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            _ref$closeSupportForm = _ref.closeSupportForm,
            closeSupportForm = _ref$closeSupportForm === undefined ? function () {} : _ref$closeSupportForm,
            _ref$setSupportFormPo = _ref.setSupportFormPosition,
            setSupportFormPosition = _ref$setSupportFormPo === undefined ? function () {} : _ref$setSupportFormPo;

        _classCallCheck(this, ContactSupportDraggablePopupContainer);

        var _this = _possibleConstructorReturn(this, (ContactSupportDraggablePopupContainer.__proto__ || Object.getPrototypeOf(ContactSupportDraggablePopupContainer)).call(this));

        _this.actions = {
            closeSupportForm: closeSupportForm,
            setSupportFormPosition: setSupportFormPosition
        };

        _this.state = {
            shown: false,
            position: {
                x: null,
                y: null
            },
            positionStrategy: _constants.supportPopupPositionStrategy.FROM_TOP_LEFT,
            loading: false
        };

        _this.onAnyStatePropertyChanged(['position', 'positionStrategy'], function () {
            var position = _this._getPopupPosition();
            (0, _atBrowserUtils.shiftTo)(_this.draggablePopup.getEl()[0], position.x, position.y);
        });

        _this.onStatePropertyChanged('shown', function (shown) {
            _this.draggablePopup.toggle(shown);
        });

        _this.onStatePropertyChanged('loading', function (loading) {
            _this.loadingContainer.setState({ loading: loading });
        });
        return _this;
    }

    _createClass(ContactSupportDraggablePopupContainer, [{
        key: 'afterRender',
        value: function afterRender() {
            var _this2 = this;

            this.supportForm = new _ContactSupportForm2.default();
            this.loadingContainer = new _LoadingContainer2.default({
                contentComponent: this.supportForm
            });
            this.draggablePopup = new _DraggablePopup2.default({
                contentComponent: this.loadingContainer,
                additionalClass: 'supportDraggablePopup',
                additionalId: 'supportDraggablePopupId',
                noDragClass: _constants.NO_DRAG_CLASS,
                onShow: function onShow() {
                    return _this2.supportForm.onShow();
                },
                onHide: this.actions.closeSupportForm,
                onDragStop: function onDragStop() {
                    _this2.actions.setSupportFormPosition({
                        positionStrategy: _constants.supportPopupPositionStrategy.FROM_TOP_LEFT,
                        position: {
                            x: _this2.draggablePopup.getEl()[0].offsetLeft,
                            y: _this2.draggablePopup.getEl()[0].offsetTop
                        }
                    });
                }
            }).init((0, _jquery2.default)('body'));
        }
    }, {
        key: '_getPopupPosition',
        value: function _getPopupPosition() {
            switch (this.state.positionStrategy) {
                case _constants.supportPopupPositionStrategy.CENTER:
                    {
                        return {
                            x: ((0, _atBrowserUtils.getInsideWindowWidth)() - this.draggablePopup.getEl().width()) / 2,
                            y: ((0, _atBrowserUtils.getInsideWindowHeight)() - this.draggablePopup.getEl().height()) / 2
                        };
                    }
                case _constants.supportPopupPositionStrategy.FROM_BOTTOM_RIGHT:
                    {
                        return {
                            x: this.state.position.x - this.draggablePopup.getEl().width() + _constants.supportPopupOffsets.LEFT,
                            y: this.state.position.y - this.draggablePopup.getEl().height() + _constants.supportPopupOffsets.TOP
                        };
                    }
                default:
                    {
                        return {
                            x: this.state.position.x,
                            y: this.state.position.y
                        };
                    }
            }
        }
    }]);

    return ContactSupportDraggablePopupContainer;
}(_View3.default);

exports.default = (0, _utils.connect)(function (state) {
    return {
        shown: (0, _selectors.isSupportFormShown)(state),
        loading: (0, _selectors.isLoading)(state),
        position: (0, _selectors.getSupportFormPosition)(state),
        positionStrategy: (0, _selectors.getSupportFormPositionStrategy)(state)
    };
}, function (dispatch) {
    return {
        closeSupportForm: (0, _redux.bindActionCreators)(_actions.closeSupportForm, dispatch),
        setSupportFormPosition: (0, _redux.bindActionCreators)(_actions.setSupportFormPosition, dispatch)
    };
})(ContactSupportDraggablePopupContainer);

/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _utils = __webpack_require__(1887);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InputField = function (_TemplateView) {
    _inherits(InputField, _TemplateView);

    function InputField(_ref) {
        var _ref$placeholder = _ref.placeholder,
            placeholder = _ref$placeholder === undefined ? "" : _ref$placeholder,
            _ref$type = _ref.type,
            type = _ref$type === undefined ? "text" : _ref$type,
            _ref$onChange = _ref.onChange,
            onChange = _ref$onChange === undefined ? function () {} : _ref$onChange,
            _ref$onBlur = _ref.onBlur,
            onBlur = _ref$onBlur === undefined ? function () {} : _ref$onBlur,
            _ref$onKeyDown = _ref.onKeyDown,
            onKeyDown = _ref$onKeyDown === undefined ? function () {} : _ref$onKeyDown,
            _ref$onKeyPress = _ref.onKeyPress,
            onKeyPress = _ref$onKeyPress === undefined ? function () {} : _ref$onKeyPress,
            _ref$tabindex = _ref.tabindex,
            tabindex = _ref$tabindex === undefined ? 0 : _ref$tabindex,
            _ref$value = _ref.value,
            value = _ref$value === undefined ? "" : _ref$value,
            _ref$additionalClass = _ref.additionalClass,
            additionalClass = _ref$additionalClass === undefined ? "" : _ref$additionalClass,
            _ref$errorMessage = _ref.errorMessage,
            errorMessage = _ref$errorMessage === undefined ? "" : _ref$errorMessage,
            _ref$maxLength = _ref.maxLength,
            maxLength = _ref$maxLength === undefined ? undefined : _ref$maxLength,
            _ref$autocomplete = _ref.autocomplete,
            autocomplete = _ref$autocomplete === undefined ? 'off' : _ref$autocomplete,
            _ref$name = _ref.name,
            name = _ref$name === undefined ? '' : _ref$name,
            _ref$disabled = _ref.disabled,
            disabled = _ref$disabled === undefined ? false : _ref$disabled;

        _classCallCheck(this, InputField);

        var _this = _possibleConstructorReturn(this, (InputField.__proto__ || Object.getPrototypeOf(InputField)).call(this));

        _this.placeholder = placeholder;
        _this.additionalClass = additionalClass;
        _this.type = type;
        _this.tabindex = tabindex;
        _this.maxLength = maxLength;
        _this.state = {
            value: value,
            errorMessage: errorMessage,
            disabled: disabled
        };
        _this.value = value;
        _this.autocomplete = autocomplete;
        _this.name = name;
        _this.onChange = onChange;
        _this.onBlur = onBlur;
        _this.onKeyDown = onKeyDown;
        _this.onKeyPress = onKeyPress;

        _this.onStatePropertyChanged("value", function (value) {
            return _this.getEl().val(value + "");
        });
        (0, _utils.reactOnErrorMessage)(_this);
        _this.onStatePropertyChanged('disabled', function (disabled) {
            _this.getEl().toggleClass('disabled', disabled);
            _this.getEl().attr("disabled", disabled);
        });
        return _this;
    }

    _createClass(InputField, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '\n            <input \n                type="<%=type%>" \n                value="<%=value%>" \n                placeholder="<%=placeholder%>"\n                class="components_input <%=additionalClass%>" \n                autocomplete="<%=autocomplete%>"\n                name="<%=name%>"\n                tabindex="<%=tabindex%>"/>';
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            var _this2 = this;

            this.getEl().on('input', function () {
                if (!_this2.state.disabled) {
                    var value = _this2.getEl().val();
                    _this2.setStateInternal({ value: value });
                    _this2.onChange(value);
                }
            });
            this.getEl().on('blur', function () {
                if (!_this2.state.disabled) {
                    _this2.onBlur(_this2.getEl().val());
                }
            });
            this.getEl().keydown(function (e) {
                _this2.onKeyDown(e);
            });
            this.getEl().keypress(function (e) {
                _this2.onKeyPress(e);
            });

            if (this.maxLength) {
                this.getEl().attr("maxlength", this.maxLength);
            }

            this.renderInitialState();
        }
    }, {
        key: 'getValue',
        value: function getValue() {
            return this.getEl().val();
        }
    }, {
        key: 'setValue',
        value: function setValue(value) {
            this.getEl().val(value);
        }
    }, {
        key: 'focus',
        value: function focus() {
            this.getEl().focus();
            //for browsers that position the caret at the begin of input
            var caretPosition = this.getValue().length;
            this.getEl()[0].setSelectionRange(caretPosition, caretPosition);
        }
    }]);

    return InputField;
}(_TemplateView3.default);

exports.default = InputField;

/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _WelcomeScreenLightbox = __webpack_require__(944);

var _WelcomeScreenLightbox2 = _interopRequireDefault(_WelcomeScreenLightbox);

var _redux = __webpack_require__(7);

var _utils = __webpack_require__(6);

var _selectors = __webpack_require__(406);

var _actions = __webpack_require__(578);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _constants = __webpack_require__(226);

var _StateComponent2 = __webpack_require__(105);

var _StateComponent3 = _interopRequireDefault(_StateComponent2);

var _emitUserEvent = __webpack_require__(407);

var _emitUserEvent2 = _interopRequireDefault(_emitUserEvent);

var _UserEventsMap = __webpack_require__(99);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var WelcomeScreenContainer = function (_StateComponent) {
    _inherits(WelcomeScreenContainer, _StateComponent);

    function WelcomeScreenContainer(_ref) {
        var _ref$$containerEl = _ref.$containerEl,
            $containerEl = _ref$$containerEl === undefined ? (0, _jquery2.default)('body') : _ref$$containerEl,
            openLightbox = _ref.openLightbox,
            closeLightbox = _ref.closeLightbox,
            sendMessage = _ref.sendMessage,
            setShowExternalContent = _ref.setShowExternalContent;

        _classCallCheck(this, WelcomeScreenContainer);

        var _this = _possibleConstructorReturn(this, (WelcomeScreenContainer.__proto__ || Object.getPrototypeOf(WelcomeScreenContainer)).call(this, $containerEl));

        _this.state = {
            loading: false,
            showExternalContent: false,
            loadExternalWelcomeScreen: false,
            demoDataStage: _constants.DemoDataStageType.IDLE,
            url: '',
            width: 0,
            height: 0,
            isLightboxShown: false
        };

        _this.params = {
            openLightbox: openLightbox,
            closeLightbox: closeLightbox,
            sendMessage: sendMessage,
            setShowExternalContent: setShowExternalContent

            //This reaction is emitted event if previous `showExternalContent` state was the same
            //Therefore we need flag `isLightboxShown` to prevent double call of `lightbox.show()`
        };_this.onStatePropertyChanged('showExternalContent', function (showExternalContent) {
            if (showExternalContent && !_this.state.isLightboxShown) {
                _this.setState({ isLightboxShown: true });
                _this.lightbox.show();
            } else if (!showExternalContent) {
                _this.setState({ isLightboxShown: false });
                _this.lightbox.hide();
                //remove all loadings and event listeners for iframe
                var iframeEl = (0, _jquery2.default)('#' + _constants.WelcomeScreenFrameId)[0];
                if (iframeEl) iframeEl.remove();
            }
        });

        _this.onStatePropertyChanged('url', function (url) {
            _this.lightbox.changeUrl(url);
        });

        _this.onAnyStatePropertyChanged(['width', 'height'], function () {
            _this.lightbox.changeSize({
                width: _this.state.width,
                height: _this.state.height
            });
        });
        return _this;
    }

    _createClass(WelcomeScreenContainer, [{
        key: 'init',
        value: function init() {
            this.lightbox = new _WelcomeScreenLightbox2.default({
                onCloseCallback: this.params.closeLightbox,
                iframeLoadCallback: this.params.sendMessage,
                frameName: _constants.WelcomeScreenFrameId,
                loadExternalWelcomeScreen: this.state.loadExternalWelcomeScreen
            });
            this.lightbox.init();

            this.params.openLightbox();
            this.params.setShowExternalContent(true);
            (0, _emitUserEvent2.default)(_UserEventsMap.UserEventsMap.POPUP_OPENED);
        }
    }]);

    return WelcomeScreenContainer;
}(_StateComponent3.default);

exports.default = (0, _utils.connect)(function (state) {
    return {
        loading: (0, _selectors.getLoading)(state),
        showExternalContent: (0, _selectors.getShowExternalContent)(state),
        demoDataStage: (0, _selectors.getDemoDataStage)(state),
        url: (0, _selectors.getUrl)(state),
        width: (0, _selectors.getWidth)(state),
        height: (0, _selectors.getHeight)(state),
        loadExternalWelcomeScreen: (0, _selectors.getLoadExternalWelcomeScreen)(state)
    };
}, function (dispatch) {
    return (0, _redux.bindActionCreators)({
        openLightbox: _actions.openLightbox,
        closeLightbox: _actions.closeLightbox,
        setShowExternalContent: _actions.setShowExternalContent,
        sendMessage: _actions.sendMessage
    }, dispatch);
})(WelcomeScreenContainer);

/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _IframeContent = __webpack_require__(1888);

var _IframeContent2 = _interopRequireDefault(_IframeContent);

var _WelcomeScreenLightboxHeader = __webpack_require__(1889);

var _WelcomeScreenLightboxHeader2 = _interopRequireDefault(_WelcomeScreenLightboxHeader);

var _WelcomeScreenLightboxFooter = __webpack_require__(1890);

var _WelcomeScreenLightboxFooter2 = _interopRequireDefault(_WelcomeScreenLightboxFooter);

var _LightBox2 = __webpack_require__(196);

var _LightBox3 = _interopRequireDefault(_LightBox2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var WelcomeScreenLightbox = function (_LightBox) {
    _inherits(WelcomeScreenLightbox, _LightBox);

    function WelcomeScreenLightbox(_ref) {
        var onCloseCallback = _ref.onCloseCallback,
            iframeLoadCallback = _ref.iframeLoadCallback,
            frameName = _ref.frameName,
            loadExternalWelcomeScreen = _ref.loadExternalWelcomeScreen,
            _ref$showCloseButton = _ref.showCloseButton,
            showCloseButton = _ref$showCloseButton === undefined ? true : _ref$showCloseButton,
            _ref$className = _ref.className,
            className = _ref$className === undefined ? '' : _ref$className;

        _classCallCheck(this, WelcomeScreenLightbox);

        var _this = _possibleConstructorReturn(this, (WelcomeScreenLightbox.__proto__ || Object.getPrototypeOf(WelcomeScreenLightbox)).call(this));

        _this.callbacks = {
            onCloseCallback: onCloseCallback,
            iframeLoadCallback: iframeLoadCallback
        };

        _this.params = {
            frameName: frameName,
            loadExternalWelcomeScreen: loadExternalWelcomeScreen,
            showCloseButton: showCloseButton,
            className: className
        };
        return _this;
    }

    _createClass(WelcomeScreenLightbox, [{
        key: 'changeUrl',
        value: function changeUrl(url) {
            this.content.setState({ url: url });
        }
    }, {
        key: 'changeSize',
        value: function changeSize(size) {
            this.content.setState({ size: size });
            this.centrePopup();
        }
    }, {
        key: 'lightBoxHideHandle',
        value: function lightBoxHideHandle() {}
    }, {
        key: 'init',
        value: function init() {
            var _params = this.params,
                loadExternalWelcomeScreen = _params.loadExternalWelcomeScreen,
                showCloseButton = _params.showCloseButton;

            var header = new _WelcomeScreenLightboxHeader2.default({ loadExternalWelcomeScreen: loadExternalWelcomeScreen, showCloseButton: showCloseButton });
            var footer = new _WelcomeScreenLightboxFooter2.default({ loadExternalWelcomeScreen: loadExternalWelcomeScreen });
            this.content = new _IframeContent2.default({
                iframeLoadCallback: this.callbacks.iframeLoadCallback,
                frameName: this.params.frameName
            });

            _get(WelcomeScreenLightbox.prototype.__proto__ || Object.getPrototypeOf(WelcomeScreenLightbox.prototype), 'init', this).call(this, {
                id: 'welcomeScreenLightbox',
                header: header,
                content: this.content,
                footer: footer,
                classNames: 'externalContentLightbox ' + this.params.className,
                correctionOffset: 60,
                moireDivId: 'blueMoireDiv',
                cancelCallback: this.callbacks.onCloseCallback
            });
            return this;
        }
    }]);

    return WelcomeScreenLightbox;
}(_LightBox3.default);

exports.default = WelcomeScreenLightbox;

/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = isNeedToSendUserEvents;

var _constants = __webpack_require__(4);

function isNeedToSendUserEvents() {
    return _constants.isOlVersion;
}

/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isIntercomEnabled = isIntercomEnabled;
exports.openIntercom = openIntercom;
exports.default = initIntercomIfNeeded;

var _UserEventsMap = __webpack_require__(99);

var _sendUserEvent = __webpack_require__(579);

var _sendUserEvent2 = _interopRequireDefault(_sendUserEvent);

var _UserNameFormat = __webpack_require__(17);

var _UserNameFormat2 = _interopRequireDefault(_UserNameFormat);

var _isTrialWithoutRenewal = __webpack_require__(1891);

var _isTrialWithoutRenewal2 = _interopRequireDefault(_isTrialWithoutRenewal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var INTERCOM_WIDGET_API_URL = 'https://widget.intercom.io/widget/';
var INTERCOM_API_BASE = "https://api-iam.intercom.io";
var WATCH_ARTICLES_INTERVAL_MS = 500;

function initIntercom(_ref) {
    var appId = _ref.appId,
        userEmail = _ref.userEmail,
        userName = _ref.userName,
        userId = _ref.userId,
        context = _ref.context;

    if (window.intercomSettings) return;

    window.intercomSettings = {
        api_base: INTERCOM_API_BASE,
        user_id: 'c' + userId + '@' + context,
        app_id: appId,
        name: userName,
        email: userEmail,
        company: {
            id: context,
            name: context
        }
    };

    var widgetUrl = INTERCOM_WIDGET_API_URL + appId;
    //Provided by Intercom: https://developers.intercom.com/installing-intercom/web/installation/#website-visitors-v-logged-in
    (function () {
        var w = window;var ic = w.Intercom;if (typeof ic === "function") {
            ic('reattach_activator');ic('update', w.intercomSettings);
        } else {
            var d = document;var i = function i() {
                i.c(arguments);
            };i.q = [];i.c = function (args) {
                i.q.push(args);
            };w.Intercom = i;var l = function l() {
                var s = d.createElement('script');s.type = 'text/javascript';s.async = true;s.src = widgetUrl;var x = d.getElementsByTagName('script')[0];x.parentNode.insertBefore(s, x);
            };if (document.readyState === 'complete') {
                l();
            } else if (w.attachEvent) {
                w.attachEvent('onload', l);
            } else {
                w.addEventListener('load', l, false);
            }
        }
    })();

    var lastDetectedArticle = null;
    function watchArticle() {
        var mainFrame = document.getElementsByName("intercom-messenger-frame")[0];
        if (mainFrame) {
            var proxyFrame = mainFrame.contentDocument.getElementsByTagName("iframe")[0];
            if (proxyFrame) {
                var articleTitle = proxyFrame["title"];
                if (lastDetectedArticle !== articleTitle) {
                    lastDetectedArticle = articleTitle;
                    (0, _sendUserEvent2.default)(_UserEventsMap.UserEventsMap.ARTICLE_VISITED, { title: articleTitle });
                }
            } else {
                lastDetectedArticle = null;
            }
        }
    }

    var watchArticleTimeId = 0;
    window.Intercom('onShow', function () {
        watchArticleTimeId = setInterval(watchArticle, WATCH_ARTICLES_INTERVAL_MS);
    });

    window.Intercom('onHide', function () {
        lastDetectedArticle = null;
        clearInterval(watchArticleTimeId);
    });
}

function isIntercomEnabled() {
    return window.__GENERATED_CONSTANTS__.INTERCOM_APP_ID && (0, _isTrialWithoutRenewal2.default)();
}

function openIntercom() {
    var count = 500 * 60; // 30 sec
    var intId = setInterval(function () {
        if (count-- <= 0) {
            clearInterval(intId);
        }
        if (window.Intercom) {
            clearInterval(intId);
            window.Intercom('show');
        }
    }, 500);
}

function initIntercomIfNeeded() {
    var appId = window.__GENERATED_CONSTANTS__.INTERCOM_APP_ID;
    var loggedInUserId = window.__INIT_APP_DATA__.LOGGED_IN_USER;
    var context = window.__GENERATED_CONSTANTS__.CLIENT_CODE;

    var enabled = false;
    if (appId && (0, _isTrialWithoutRenewal2.default)()) {
        initIntercom({
            appId: appId,
            userEmail: loggedInUserId.email || 'devnull@actitime.com', // fallback
            userName: _UserNameFormat2.default.formatFML(loggedInUserId.firstName, loggedInUserId.lastName, loggedInUserId.middleName),
            userId: loggedInUserId.id,
            context: context
        });
        enabled = true;
    }

    return enabled;
}

/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _Button = __webpack_require__(33);

var _Button2 = _interopRequireDefault(_Button);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AddonsMenu = function (_TemplateView) {
    _inherits(AddonsMenu, _TemplateView);

    function AddonsMenu() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            _ref$additionalClass = _ref.additionalClass,
            additionalClass = _ref$additionalClass === undefined ? '' : _ref$additionalClass,
            _ref$integrationCompo = _ref.integrationComponents,
            integrationComponents = _ref$integrationCompo === undefined ? [] : _ref$integrationCompo,
            _ref$addonsComponents = _ref.addonsComponents,
            addonsComponents = _ref$addonsComponents === undefined ? [] : _ref$addonsComponents,
            _ref$mobileComponents = _ref.mobileComponents,
            mobileComponents = _ref$mobileComponents === undefined ? [] : _ref$mobileComponents,
            _ref$onUpgradeButtonC = _ref.onUpgradeButtonClick,
            onUpgradeButtonClick = _ref$onUpgradeButtonC === undefined ? function () {} : _ref$onUpgradeButtonC;

        _classCallCheck(this, AddonsMenu);

        var _this = _possibleConstructorReturn(this, (AddonsMenu.__proto__ || Object.getPrototypeOf(AddonsMenu)).call(this));

        _this.params = {
            additionalClass: additionalClass
        };

        _this.callbacks = {
            onUpgradeButtonClick: onUpgradeButtonClick
        };

        _this.state = {
            showUpgradeSection: false,
            addonsComponents: addonsComponents,
            integrationComponents: integrationComponents,
            mobileComponents: mobileComponents
        };

        _this.onStatePropertyChanged('showUpgradeSection', function (showUpgradeSection) {
            _this.$upgradeSection.toggle(showUpgradeSection);
        });

        _this.onStatePropertyChanged('addonsComponents', function () {
            if (_this.state.addonsComponents.length === 0) _this.find('.addons').hide();
        });
        return _this;
    }

    _createClass(AddonsMenu, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class=\'addonsMenu <%-additionalClass%>\'>\n                    <div class=\'addons\'>\n                        <div class=\'title\'><%=addonsTitle%></div>\n                        <div class=\'content\'/>\n                    </div>\n                    <div class=\'mobile\'>\n                        <div class=\'title\'><%=mobileTitle%></div>\n                        <div class=\'content\'/>\n                    </div>\n                    <div class=\'integrations\'>\n                        <div class=\'title\'><%=integrationsTitle%></div>\n                        <div class=\'content\'/>\n                    </div>\n                    <div class=\'upgradeSection\'>\n                        <div class=\'note\'>\n                            <div class=\'icon\'/>\n                            <div class=\'text\'><%=switchToPaid%></div>\n                        </div>\n                        <div class=\'button\'/>\n                    </div>\n                </div>';
        }
    }, {
        key: 'templateModel',
        value: function templateModel() {
            return {
                additionalClass: this.params.additionalClass
            };
        }
    }, {
        key: 'messageKeys',
        value: function messageKeys() {
            return {
                integrationsTitle: 'navigator.integrations_menu_title',
                addonsTitle: 'navigator.addons_menu_title',
                mobileTitle: 'navigator.mobile_menu_title',
                switchToPaid: 'menu.addons.switch_to_paid.note'
            };
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            var $integrationsContent = this.find('.integrations .content');
            this.state.integrationComponents.forEach(function (component) {
                return component.init($integrationsContent);
            });

            var $addonsContent = this.find('.addons .content');
            this.state.addonsComponents.forEach(function (component) {
                return component.init($addonsContent);
            });

            var $mobileContent = this.find('.mobile .content');
            this.state.mobileComponents.forEach(function (component) {
                return component.init($mobileContent);
            });

            this.$upgradeSection = this.find('.upgradeSection');
            new _Button2.default({
                additionalClass: 'upgrade',
                label: _messageResource2.default.getMessage('menu.addons.switch_to_paid.button'),
                onClickCb: this.callbacks.onUpgradeButtonClick
            }).init(this.find('.upgradeSection .button'));

            this.renderInitialState();
        }
    }]);

    return AddonsMenu;
}(_TemplateView3.default);

exports.default = AddonsMenu;

/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _Link = __webpack_require__(530);

var _Link2 = _interopRequireDefault(_Link);

var _Button = __webpack_require__(33);

var _Button2 = _interopRequireDefault(_Button);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AddonCard = function (_TemplateView) {
    _inherits(AddonCard, _TemplateView);

    function AddonCard() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            _ref$additionalClass = _ref.additionalClass,
            additionalClass = _ref$additionalClass === undefined ? '' : _ref$additionalClass,
            _ref$additionalIconCl = _ref.additionalIconClass,
            additionalIconClass = _ref$additionalIconCl === undefined ? '' : _ref$additionalIconCl,
            _ref$titleTextKey = _ref.titleTextKey,
            titleTextKey = _ref$titleTextKey === undefined ? '' : _ref$titleTextKey,
            _ref$titleLink = _ref.titleLink,
            titleLink = _ref$titleLink === undefined ? '' : _ref$titleLink,
            _ref$descriptionTextK = _ref.descriptionTextKey,
            descriptionTextKey = _ref$descriptionTextK === undefined ? '' : _ref$descriptionTextK,
            _ref$showActionButton = _ref.showActionButton,
            showActionButton = _ref$showActionButton === undefined ? true : _ref$showActionButton,
            _ref$actionButtonText = _ref.actionButtonTextKey,
            actionButtonTextKey = _ref$actionButtonText === undefined ? '' : _ref$actionButtonText,
            _ref$actionNotAvailab = _ref.actionNotAvailable,
            actionNotAvailable = _ref$actionNotAvailab === undefined ? false : _ref$actionNotAvailab,
            _ref$onActionButtonCl = _ref.onActionButtonClick,
            onActionButtonClick = _ref$onActionButtonCl === undefined ? function () {} : _ref$onActionButtonCl,
            _ref$onDetailsButtonC = _ref.onDetailsButtonClick,
            onDetailsButtonClick = _ref$onDetailsButtonC === undefined ? function () {} : _ref$onDetailsButtonC,
            _ref$notAvailableButt = _ref.notAvailableButtonTextKey,
            notAvailableButtonTextKey = _ref$notAvailableButt === undefined ? '' : _ref$notAvailableButt,
            _ref$customButtonComp = _ref.customButtonComponent,
            customButtonComponent = _ref$customButtonComp === undefined ? null : _ref$customButtonComp,
            _ref$onLinkClickCallb = _ref.onLinkClickCallback,
            onLinkClickCallback = _ref$onLinkClickCallb === undefined ? function () {} : _ref$onLinkClickCallb,
            _ref$dark = _ref.dark,
            dark = _ref$dark === undefined ? false : _ref$dark;

        _classCallCheck(this, AddonCard);

        var _this = _possibleConstructorReturn(this, (AddonCard.__proto__ || Object.getPrototypeOf(AddonCard)).call(this));

        _this.params = {
            additionalClass: additionalClass,
            additionalIconClass: additionalIconClass,
            titleTextKey: titleTextKey,
            titleLink: titleLink,
            descriptionTextKey: descriptionTextKey,
            notAvailableButtonTextKey: notAvailableButtonTextKey,
            customButtonComponent: customButtonComponent || new _Button2.default({
                label: _messageResource2.default.getMessage(actionButtonTextKey),
                onClickCb: onActionButtonClick
            }),
            dark: dark
        };

        _this.callbacks = {
            onDetailsButtonClick: onDetailsButtonClick,
            onLinkClickCallback: onLinkClickCallback
        };

        _this.state = {
            showWarning: false,
            isExpired: false,

            showActionButton: showActionButton,
            actionNotAvailable: actionNotAvailable
        };

        _this.onStatePropertyChanged('showWarning', function (showWarning) {
            return _this.$warning.toggle(showWarning);
        });
        _this.onStatePropertyChanged('isExpired', function (isExpired) {
            _this.$expiredNote.toggle(isExpired);
            _this.$violatedNote.toggle(!isExpired);
            _this.$warningDetailsButton.toggle(isExpired);
        });

        _this.onAnyStatePropertyChanged(['showActionButton', 'actionNotAvailable'], function () {
            _this.$actionButton.toggle(_this.state.showActionButton && !_this.state.actionNotAvailable);
            _this.$notAvailableButton.toggle(_this.state.actionNotAvailable);
        });
        return _this;
    }

    _createClass(AddonCard, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class=\'addonCard  <%-additionalClass%>\'>\n                    <div class=\'firstColumn\'>\n                        <div class=\'cardIcon <%-additionalIconClass%>\'/>\n                        <div class=\'warning\'>\n                            <div class=\'icon\'/>\n                            <div class=\'expiredNote\'><%=expiredNote%></div>\n                            <div class=\'violatedNote\'><%=violatedNote%></div>\n                            <div class=\'detailsButton\'><%=detailsButton%></div>\n                        </div>\n                    </div>\n                    <div class=\'secondColumn\'>\n                        <div class=\'content\'>\n                            <div class=\'header\'/>\n                            <div class=\'description\'><%-descriptionText%></div>\n                        </div>\n                        <div class=\'footer\'>\n                            <div class=\'actionButton\'/>\n                            <div class=\'notAvailableButton\'/>\n                        </div>\n                    </div>\n                </div>';
        }
    }, {
        key: 'templateModel',
        value: function templateModel() {
            return {
                additionalClass: this.params.additionalClass,
                additionalIconClass: this.params.additionalIconClass
            };
        }
    }, {
        key: 'messageKeys',
        value: function messageKeys() {
            return {
                expiredNote: 'menu.addons.license_expired_warning',
                violatedNote: 'menu.addons.license_violated_warning',
                detailsButton: 'menu.addons.view_warning_details.button',
                descriptionText: this.params.descriptionTextKey
            };
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            this.$warning = this.find('.warning');
            this.$expiredNote = this.find('.expiredNote');
            this.$violatedNote = this.find('.violatedNote');
            this.$warningDetailsButton = this.find('.detailsButton');
            this.$warningDetailsButton.on('click', this.callbacks.onDetailsButtonClick);
            new _Link2.default({
                text: _messageResource2.default.getMessage(this.params.titleTextKey),
                reference: this.params.titleLink,
                onClickCallback: this.callbacks.onLinkClickCallback,
                dark: this.params.dark
            }).init(this.find('.header'));

            this.$actionButton = this.find('.actionButton');
            this.$notAvailableButton = this.find('.notAvailableButton');
            this.params.customButtonComponent.init(this.$actionButton);
            this.$notAvailableButton.text(this.params.notAvailableButtonTextKey ? _messageResource2.default.getMessage(this.params.notAvailableButtonTextKey) : '');

            this.renderInitialState();
        }
    }]);

    return AddonCard;
}(_TemplateView3.default);

exports.default = AddonCard;

/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.AddonsCardsModels = exports.AddonsMenuActionUrls = exports.AddonsMenuGuideURLs = exports.ManageLicensesUrl = undefined;

var _constants = __webpack_require__(4);

var _urijs = __webpack_require__(340);

var _urijs2 = _interopRequireDefault(_urijs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ManageLicensesUrl = exports.ManageLicensesUrl = _urijs2.default.joinPaths(_constants.BASE_PATH, 'administration/manage_licenses.do');

var AddonsMenuGuideURLs = exports.AddonsMenuGuideURLs = {
    ZAPIER_GUIDE_URL: _constants.ProductWebSiteURLs.CURRENT_PRODUCT_SITE_URL + 'actitime-zapier',
    API_GUIDE_URL: _constants.ProductWebSiteURLs.CURRENT_PRODUCT_SITE_URL + 'actitime-api',
    ASSISTANT_GUIDE_URL: _constants.ProductWebSiteURLs.CURRENT_PRODUCT_SITE_URL + 'time-management-assistant',
    MOBILE_GUIDE_URL: _constants.ProductWebSiteURLs.CURRENT_PRODUCT_SITE_URL + (_constants.CURRENT_PRODUCT === _constants.Product.actiTIME ? 'actitime-mobile-app' : 'mobile')
};

var AddonsMenuActionUrls = exports.AddonsMenuActionUrls = {
    QBI_ACTION_URL: _urijs2.default.joinPaths(_constants.BASE_PATH, 'switch-to-integrator.do'),
    ZAPIER_ACTION_URL: 'https://zapier.com/apps/actitime/integrations',
    API_ACTION_URL: _urijs2.default.joinPaths(_constants.BASE_PATH, 'api/v1/swagger'),
    EXTENSION_ACTION_URL: 'https://chrome.google.com/webstore/detail/actitime-time-tracking-pr/oogddkbohgikljeadnkcepdmekigegck?hl=en',
    ASSISTANT_ACTION_URL: 'https://chrome.google.com/webstore/detail/fhmmdobpcofodcpkehjaiodhahbfkkgn',
    AT_MOBILE_IOS_ACTION_URL: 'https://apps.apple.com/us/app/actitime-time-tracker/id6470903011',
    AT_MOBILE_ANDROID_ACTION_URL: 'https://play.google.com/store/apps/details?id=com.actitime.mobile',
    AP_MOBILE_IOS_ACTION_URL: 'https://apps.apple.com/app/actiplans-absence-notes/id1049307705',
    AP_MOBILE_ANDROID_ACTION_URL: 'https://play.google.com/store/apps/details?id=com.actimind.actiplans.android'
};

var AddonsCardsModels = exports.AddonsCardsModels = {
    AP_INTEGRATION: {
        additionalIconClass: 'apIcon',
        titleTextKey: 'menu.addons.item.actiplans.title',
        titleLink: _constants.ProductWebSiteURLs.OTHER_PRODUCT_INTEGRATION_URL,
        descriptionTextKey: 'menu.addons.item.actiplans.description',
        notAvailableButtonTextKey: 'menu.addons.item.not_available_button'
    },
    AT_INTEGRATION: {
        additionalIconClass: 'atIcon',
        titleTextKey: 'menu.addons.item.actitime.title',
        titleLink: _constants.ProductWebSiteURLs.OTHER_PRODUCT_INTEGRATION_URL,
        descriptionTextKey: 'menu.addons.item.actitime.description'
    },
    QBI: {
        additionalIconClass: 'qbiIcon',
        titleTextKey: 'menu.addons.item.qbi.title',
        titleLink: _constants.ProductWebSiteURLs.QBI_INTEGRATOR_GUIDE_URL,
        descriptionTextKey: 'menu.addons.item.qbi.description',
        actionButtonTextKey: 'menu.addons.item.qbi.button',
        notAvailableButtonTextKey: 'menu.addons.item.not_available_button'
    },
    ZAPIER: {
        additionalIconClass: 'zapierIcon',
        titleTextKey: 'menu.addons.item.zapier.title',
        titleLink: AddonsMenuGuideURLs.ZAPIER_GUIDE_URL,
        descriptionTextKey: 'menu.addons.item.zapier.description',
        actionButtonTextKey: 'menu.addons.item.zapier.button',
        notAvailableButtonTextKey: 'menu.addons.item.not_available_button'
    },
    API: {
        additionalIconClass: 'apiIcon',
        titleTextKey: 'menu.addons.item.api.title',
        titleLink: AddonsMenuGuideURLs.API_GUIDE_URL,
        descriptionTextKey: 'menu.addons.item.api.description',
        actionButtonTextKey: 'menu.addons.item.api.button',
        notAvailableButtonTextKey: 'menu.addons.item.not_available_button'
    },
    ASSISTANT: {
        additionalIconClass: 'assistantIcon',
        titleTextKey: 'menu.addons.item.assistant.title',
        titleLink: AddonsMenuGuideURLs.ASSISTANT_GUIDE_URL,
        descriptionTextKey: _constants.isOlVersion ? 'menu.addons.item.assistant.description' : 'menu.addons.item.assistant.description.offline',
        actionButtonTextKey: 'menu.addons.item.assistant.button',
        notAvailableButtonTextKey: 'menu.addons.item.not_available_button',
        dark: true,
        linkOpenedSessionStorageKey: 'assistantLinkOpened'
    },
    MOBILE: {
        titleTextKey: 'menu.addons.item.mobile.title',
        titleLink: AddonsMenuGuideURLs.MOBILE_GUIDE_URL,
        descriptionTextKey: 'menu.addons.item.mobile.description'
    }
};

/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _Button = __webpack_require__(33);

var _Button2 = _interopRequireDefault(_Button);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MobileAppButtons = function (_TemplateView) {
    _inherits(MobileAppButtons, _TemplateView);

    function MobileAppButtons(_ref) {
        var _ref$onIosButtonClick = _ref.onIosButtonClick,
            onIosButtonClick = _ref$onIosButtonClick === undefined ? function () {} : _ref$onIosButtonClick,
            _ref$onAndroidButtonC = _ref.onAndroidButtonClick,
            onAndroidButtonClick = _ref$onAndroidButtonC === undefined ? function () {} : _ref$onAndroidButtonC;

        _classCallCheck(this, MobileAppButtons);

        var _this = _possibleConstructorReturn(this, (MobileAppButtons.__proto__ || Object.getPrototypeOf(MobileAppButtons)).call(this));

        _this.callbacks = {
            onIosButtonClick: onIosButtonClick,
            onAndroidButtonClick: onAndroidButtonClick
        };
        return _this;
    }

    _createClass(MobileAppButtons, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class=\'mobileAppButtons\'/>';
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            new _Button2.default({
                additionalClass: 'iosButton',
                label: _messageResource2.default.getMessage('menu.addons.item.mobile.button.ios'),
                onClickCb: this.callbacks.onIosButtonClick
            }).init(this.getEl());
            new _Button2.default({
                additionalClass: 'androidButton',
                label: _messageResource2.default.getMessage('menu.addons.item.mobile.button.android'),
                onClickCb: this.callbacks.onAndroidButtonClick
            }).init(this.getEl());
        }
    }]);

    return MobileAppButtons;
}(_TemplateView3.default);

exports.default = MobileAppButtons;

/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = initUserEventListeners;

var _emitUserEvent = __webpack_require__(407);

var _emitUserEvent2 = _interopRequireDefault(_emitUserEvent);

var _UserEventsMap = __webpack_require__(99);

var _isNeedToSendUserEvents = __webpack_require__(945);

var _isNeedToSendUserEvents2 = _interopRequireDefault(_isNeedToSendUserEvents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialized = false;
var AT_EVENT_USER_NAME = 'atevent';

function initUserEventListeners() {
    if (!(0, _isNeedToSendUserEvents2.default)()) return;
    if (initialized) return;

    document.addEventListener("visibilitychange", function (event) {
        if (document.visibilityState === "visible") {
            (0, _emitUserEvent2.default)(_UserEventsMap.UserEventsMap.PAGE_VISIBLE);
        } else if (document.visibilityState === "hidden") {
            (0, _emitUserEvent2.default)(_UserEventsMap.UserEventsMap.PAGE_HIDDEN);
        }
    });

    window.addEventListener("message", function (event) {
        if (event.data[AT_EVENT_USER_NAME]) {
            (0, _emitUserEvent2.default)(event.data[AT_EVENT_USER_NAME].event, event.data[AT_EVENT_USER_NAME].params);
        }
    });

    initialized = true;
}

/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utils = __webpack_require__(6);

var _actions = __webpack_require__(578);

var _View2 = __webpack_require__(20);

var _View3 = _interopRequireDefault(_View2);

var _redux = __webpack_require__(7);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _DemoDataComponent = __webpack_require__(1897);

var _DemoDataComponent2 = _interopRequireDefault(_DemoDataComponent);

var _constants = __webpack_require__(226);

var _selectors = __webpack_require__(406);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DemoDataLoaderContainer = function (_View) {
    _inherits(DemoDataLoaderContainer, _View);

    function DemoDataLoaderContainer(_ref) {
        var startLoadingDemoData = _ref.startLoadingDemoData;

        _classCallCheck(this, DemoDataLoaderContainer);

        var _this = _possibleConstructorReturn(this, (DemoDataLoaderContainer.__proto__ || Object.getPrototypeOf(DemoDataLoaderContainer)).call(this, (0, _jquery2.default)('body')));

        _this.state = {
            demoDataStage: _constants.DemoDataStageType.IDLE,
            popupVisible: false
        };
        _this.onStatePropertyBecameValue('popupVisible', false, function () {
            if (_this.state.demoDataStage !== _constants.DemoDataStageType.ERROR && _this.state.demoDataStage !== _constants.DemoDataStageType.COMPLETED) {
                _this.demoDataLoader.show();
                _this.demoDataLoader.refreshStage(_this.state.demoDataStage);
            }
        });

        _this.onStatePropertyChanged('demoDataStage', function (demoDataStage) {
            _this.demoDataLoader.setState({ stage: demoDataStage });
            if (demoDataStage === _constants.DemoDataStageType.ERROR || demoDataStage === _constants.DemoDataStageType.COMPLETED) {
                _this.demoDataLoader.hide();
            }
        });

        _this.loadDemoDataCb = startLoadingDemoData;
        return _this;
    }

    _createClass(DemoDataLoaderContainer, [{
        key: "afterRender",
        value: function afterRender() {
            this.demoDataLoader = new _DemoDataComponent2.default({}).init((0, _jquery2.default)('body'));
            this.loadDemoDataCb();
        }
    }]);

    return DemoDataLoaderContainer;
}(_View3.default);

exports.default = (0, _utils.connect)(function (state) {
    return {
        demoDataStage: (0, _selectors.getDemoDataStage)(state),
        popupVisible: (0, _selectors.getPopupVisible)(state)
    };
}, function (dispatch) {
    return (0, _redux.bindActionCreators)({
        startLoadingDemoData: _actions.startLoadingDemoData
    }, dispatch);
})(DemoDataLoaderContainer);

/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var ACTIVE_TAB_SET = exports.ACTIVE_TAB_SET = 'iCalendar/feeds/ACTIVE_TAB_SET';
var ALL_FEEDS_LIST_SET = exports.ALL_FEEDS_LIST_SET = 'iCalendar/feeds/ALL_FEEDS_LIST_SET';
var FEED_ADD = exports.FEED_ADD = 'iCalendar/feeds/FEEDS_ADD';
var SHARED_FEEDS_LIST_SET = exports.SHARED_FEEDS_LIST_SET = 'iCalendar/feeds/SHARED_FEEDS_LIST_SET';
var FEED_REMOVE = exports.FEED_REMOVE = 'iCalendar/feeds/FEED_REMOVE';
var LOADING_SET = exports.LOADING_SET = 'iCalendar/feeds/LOADING_SET';
var ALL_SORTING_SET = exports.ALL_SORTING_SET = 'iCalendar/feeds/ALL_SORTING_SET';
var SHARED_SORTING_SET = exports.SHARED_SORTING_SET = 'iCalendar/feeds/SHARED_SORTING_SET';
var RECENTLY_CONFIGURED_FEED_ID_SET = exports.RECENTLY_CONFIGURED_FEED_ID_SET = 'iCalendar/feeds/RECENTLY_CONFIGURED_FEED_ID';
var FEEDS_CONTENT_LOADING_SET = exports.FEEDS_CONTENT_LOADING_SET = 'iCalendar/feeds/FEEDS_CONTENT_LOADING_SET';

var RENGERATE_FEED_LINK_DATA_LOAD = exports.RENGERATE_FEED_LINK_DATA_LOAD = 'iCalendar/feeds/REGENERATE_FEED_LINK_DATA_LOAD';
var RENGERATE_FEED_LINK_DATA_LOAD_SUCCESS = exports.RENGERATE_FEED_LINK_DATA_LOAD_SUCCESS = 'iCalendar/feeds/REGENERATE_FEED_LINK_DATA_LOAD_SUCCESS';
var RENGERATE_FEED_LINK_DATA_LOAD_FAILURE = exports.RENGERATE_FEED_LINK_DATA_LOAD_FAILURE = 'iCalendar/feeds/REGENERATE_FEED_LINK_DATA_LOAD_FAILURE';

var DELETE_FEED_DATA_LOAD = exports.DELETE_FEED_DATA_LOAD = 'iCalendar/feeds/DELETE_FEED_DATA_LOAD';
var DELETE_FEED_DATA_LOAD_SUCCESS = exports.DELETE_FEED_DATA_LOAD_SUCCESS = 'iCalendar/feeds/DELETE_FEED_DATA_LOAD_SUCCESS';
var DELETE_FEED_DATA_LOAD_FAILURE = exports.DELETE_FEED_DATA_LOAD_FAILURE = 'iCalendar/feeds/DELETE_FEED_DATA_LOAD_FAILURE';

/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var ADDONS_MENU_TOGGLE = exports.ADDONS_MENU_TOGGLE = 'at/addons/ADDONS_MENU_TOGGLE';
var ADDONS_MENU_CLOSE = exports.ADDONS_MENU_CLOSE = 'at/addons/ADDONS_MENU_CLOSE';

/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DROPZONE_REPORT_PARAMETERS = exports.DROPZONE_PARAMETERS = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _constants = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DROPZONE_PARAMETERS = exports.DROPZONE_PARAMETERS = {
    url: '#',
    maxFilesize: 5, //MB
    dictResponseError: _messageResource2.default.getMessage('error.js.json_rpc.network_error', [_constants.CURRENT_PRODUCT]),
    dictMaxFilesExceeded: _messageResource2.default.getMessage('common.multiple_upload_error'),
    dictFileTooBig: _messageResource2.default.getMessage('logo_settings.dropzone.file_too_big_error'),
    acceptedFiles: '.gif, .png, .jpeg, .jpg'
};

var DROPZONE_REPORT_PARAMETERS = exports.DROPZONE_REPORT_PARAMETERS = _extends({}, DROPZONE_PARAMETERS, {
    acceptedFiles: '.png, .jpeg, .jpg'
});

/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _OverlayTips = __webpack_require__(86);

var _OverlayTips2 = _interopRequireDefault(_OverlayTips);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    /**
     * Collect indexes of matched elements
     * @param $el
     * @param testF
     * @returns {*} jquery object with matched elements and tipData property
     */
    indexFilter: function indexFilter($el, testF) {
        var tipData = {
            length: $el.length,
            indexes: []
        };

        var $ret = $el.filter(function (index) {
            if (testF(this)) {
                tipData.indexes.push(index);
                return true;
            }
            return false;
        });
        $ret.tipData = tipData;
        return $ret;
    },

    /**
     * Find tips positions in table
     * @param tips - array of objects which provides:
     * gapLength - length in cells
     * setVal($el) - store result,
     * test(el) - boolean function to check if cell suitable
     * @param rowSource
     */
    setTipsForTable: function setTipsForTable(tips, rowSource) {
        _.each(tips, function (tip) {
            tip.setVal($());
        });
        for (var idx = 0; tips.length > 0 && idx < rowSource.length; idx++) {
            var $row = rowSource.getRow(idx);

            for (var tipIdx = 0; tipIdx < tips.length; tipIdx++) {
                var tip = tips[tipIdx];
                var $matched = this.indexFilter($row, tip.test);
                if ($matched.length > 0) {
                    var resultIdx = $matched.tipData.indexes[$matched.length >> 1];

                    var leftLen = this._testLeftGap(tip, $row, resultIdx);
                    var rightLen = this._testRightGap(tip, $row, resultIdx);
                    var direction;

                    if (leftLen === -1) {
                        if (rightLen === -1) continue;

                        direction = _OverlayTips2.default.DIRECTION_TOP_RIGHT;
                        resultIdx += rightLen;
                    } else if (rightLen === -1) {
                        direction = _OverlayTips2.default.DIRECTION_TOP_LEFT;
                        resultIdx -= leftLen;
                    } else if (leftLen === 0 && rightLen === 0) {
                        direction = resultIdx < $row.length >> 1 ? _OverlayTips2.default.DIRECTION_TOP_RIGHT : _OverlayTips2.default.DIRECTION_TOP_LEFT;
                    } else if (leftLen < rightLen) {
                        direction = _OverlayTips2.default.DIRECTION_TOP_LEFT;
                        resultIdx -= leftLen;
                    } else {
                        direction = _OverlayTips2.default.DIRECTION_TOP_RIGHT;
                        resultIdx += rightLen;
                    }

                    var $result = $($row[resultIdx]);
                    $result.config = { direction: direction };
                    tip.setVal($result);
                    tips.splice(tipIdx, 1);

                    // skip next row
                    idx++;
                    break;
                }
            }
        }
    },

    _testLeftGap: function _testLeftGap(tip, $row, resultIdx) {
        var ret = -1;
        for (var i = resultIdx; i >= tip.gapLength && tip.test($row[i]); i--, ret++) {}
        return ret;
    },

    _testRightGap: function _testRightGap(tip, $row, resultIdx) {
        var ret = -1;
        for (var i = resultIdx; i < $row.length - tip.gapLength && tip.test($row[i]); i++, ret++) {}
        return ret;
    },

    setLeaveChartTableTips: function setLeaveChartTableTips(manager, $table) {
        var afterFirstRow = false;
        // find places for tips in Schedule of Colleagues
        var $recordsAfterFirst = $table.find('tr').filter(function () {
            if (afterFirstRow) return true;else if (this.className.indexOf('firstRow') > -1) afterFirstRow = true;
            return false;
        });

        // no splitting to words, need to be used carefully
        function testClass(el, className) {
            return el.className.indexOf(className) > -1;
        }

        var tips = [{
            gapLength: 17,
            setVal: function setVal($el) {
                manager.$tipNotApproved = $el;
            },
            test: function test(el) {
                return testClass(el, 'leaveType') && !testClass(el, 'approved');
            }
        }, {
            gapLength: 12,
            setVal: function setVal($el) {
                manager.$tipApproved = $el;
            },
            test: function test(el) {
                return testClass(el, 'approved');
            }
        }, {
            gapLength: 12,
            setVal: function setVal($el) {
                manager.$tipLeaveStatus = $el;
            },
            test: function test(el) {
                return testClass(el, 'leaveStatus');
            }
        }];

        var rowSource = {
            length: $recordsAfterFirst.length,
            getRow: function getRow(idx) {
                return $($recordsAfterFirst[idx]).find('.dayCell');
            }
        };

        this.setTipsForTable(tips, rowSource);
    }
};

/***/ }),
/* 957 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.BalanceHistory = undefined;

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _TemplateView = __webpack_require__(1);

var _TemplateView2 = _interopRequireDefault(_TemplateView);

var _BalanceFormatter = __webpack_require__(230);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BalanceHistory = exports.BalanceHistory = {
    TableRows: {
        AUTOMATIC_BALANCE_LIMIT_RECORD: 'AUTOMATIC_BALANCE_LIMIT_RECORD',
        AUTOMATIC_BALANCE_RESET_RECORD: 'AUTOMATIC_BALANCE_RESET_RECORD',
        AUTOMATIC_BALANCE_ACCRUE_RECORD: 'AUTOMATIC_BALANCE_ACCRUE_RECORD',
        MANUAL_INCREASE_RECORD: 'MANUAL_INCREASE_RECORD',
        MANUAL_DECREASE_RECORD: 'MANUAL_DECREASE_RECORD',
        MANUAL_SET_RECORD: 'MANUAL_SET_RECORD',
        LEAVE_TIME_COMPLETED_RECORD: 'LEAVE_TIME_COMPLETED_RECORD'
    },

    BalanceTypes: {
        SICK: "sick",
        PTO: "pto"
    }
};

BalanceHistory.Table = function ($containerEl, countWorkHoursPerDay, showBalanceInHours) {
    _TemplateView2.default.call(this, $containerEl);
    this.balanceFormatter = new _BalanceFormatter.BalanceFormatter().init(countWorkHoursPerDay, showBalanceInHours);
};

BalanceHistory.Table.prototype = _underscore2.default.create(_TemplateView2.default.prototype, {

    html: "<div class='balanceHistoryTableContainer <%=balanceTypeClass%>'>" + "  <table class='balanceHistoryTable display-for-print dataTable' cellspacing='0' cellpadding='0'><thead></thead><tbody class='rows'></tbody></table>" + "</div>",

    updateOnInit: false,

    afterRender: function afterRender() {
        this.$balanceRows = this.find(".balanceHistoryTable tbody");
        this.renderTHead();
        this._createRows(this.$balanceRows, this.getBalanceModels());
    },

    renderTHead: function renderTHead() {
        new BalanceHistory.Table.HeadRow(this.find(".balanceHistoryTable thead")).init();
    },

    update: function update() {
        this.$balanceRows.empty();

        this._createRows(this.$balanceRows, this.getBalanceModels());
    },

    _createRows: function _createRows($containerEl, models) {
        var balanceType = this.getBalanceType();
        var balanceFormatter = this.balanceFormatter;

        if (_underscore2.default.isEmpty(models)) {
            new BalanceHistory.Table.NoLeaveTimeRow($containerEl, balanceType).init();
            return;
        }

        _underscore2.default.each(models, function (model) {
            switch (model.type) {
                case BalanceHistory.TableRows.AUTOMATIC_BALANCE_ACCRUE_RECORD:
                    new BalanceHistory.Table.AutoAdjustmentRow.Accrue($containerEl, balanceType, model, balanceFormatter).init();
                    break;
                case BalanceHistory.TableRows.AUTOMATIC_BALANCE_LIMIT_RECORD:
                    new BalanceHistory.Table.AutoAdjustmentRow.Limit($containerEl, balanceType, model, balanceFormatter).init();
                    break;
                case BalanceHistory.TableRows.AUTOMATIC_BALANCE_RESET_RECORD:
                    new BalanceHistory.Table.AutoAdjustmentRow.Reset($containerEl, balanceType, model, balanceFormatter).init();
                    break;
                case BalanceHistory.TableRows.LEAVE_TIME_COMPLETED_RECORD:
                    new BalanceHistory.Table.LeaveTimeCompletedRow($containerEl, balanceType, model, balanceFormatter).init();
                    break;
                case BalanceHistory.TableRows.MANUAL_INCREASE_RECORD:
                    new BalanceHistory.Table.ManualAdjustmentRow.Increase($containerEl, balanceType, model, balanceFormatter).init();
                    break;
                case BalanceHistory.TableRows.MANUAL_DECREASE_RECORD:
                    new BalanceHistory.Table.ManualAdjustmentRow.Decrease($containerEl, balanceType, model, balanceFormatter).init();
                    break;
                case BalanceHistory.TableRows.MANUAL_SET_RECORD:
                    new BalanceHistory.Table.ManualAdjustmentRow.ManualSet($containerEl, balanceType, model, balanceFormatter).init();
                    break;
            }
        });
    },

    getBalanceModels: function getBalanceModels() {
        //    abstract
    },

    getBalanceType: function getBalanceType() {
        //    abstract
    }
});

/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _SimpleListMenuButton = __webpack_require__(187);

var _SimpleListMenuButton2 = _interopRequireDefault(_SimpleListMenuButton);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _constants = __webpack_require__(51);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FeedsTableSortingMenu = function (_TemplateView) {
    _inherits(FeedsTableSortingMenu, _TemplateView);

    function FeedsTableSortingMenu(_ref) {
        var changeSorting = _ref.changeSorting,
            _ref$isLastSyncSortin = _ref.isLastSyncSortingIncluded,
            isLastSyncSortingIncluded = _ref$isLastSyncSortin === undefined ? false : _ref$isLastSyncSortin;

        _classCallCheck(this, FeedsTableSortingMenu);

        var _this = _possibleConstructorReturn(this, (FeedsTableSortingMenu.__proto__ || Object.getPrototypeOf(FeedsTableSortingMenu)).call(this));

        _this.params = {
            isLastSyncSortingIncluded: isLastSyncSortingIncluded
        };

        _this.state = {
            sorting: _constants.DEFAULT_SORTING
        };

        _this.callbacks = {
            changeSorting: changeSorting
        };

        _this.onStatePropertyDeeplyChanged('sorting', function (sorting) {
            _this.sortingListMenuSelector.setActiveItemByPredicate(function (item) {
                return item.value === sorting.property;
            });
            _this.$sortingOrderButton.toggleClass('descOrder', !sorting.isAsc);
        });
        return _this;
    }

    _createClass(FeedsTableSortingMenu, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class=\'feedsSort\'>\n                    <div class=\'sortedByText\'>\n                        <%=sortedBy%>\n                    </div>\n                    <div class=\'listSelector\'/>\n                    <div class=\'sortingOrderButton\'/>\n                </div>';
        }
    }, {
        key: 'messageKeys',
        value: function messageKeys() {
            return {
                sortedBy: 'icalendar.page.table.sorting.sorted_by'
            };
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            var _this2 = this;

            var sortingItems = [{
                title: _messageResource2.default.getMessage('icalendar.page.table.sorting.feed'),
                value: _constants.SortingProperty.FEED_NAME
            }, {
                title: _messageResource2.default.getMessage('icalendar.page.table.sorting.creator'),
                value: _constants.SortingProperty.CREATOR_NAME
            }, {
                title: _messageResource2.default.getMessage('icalendar.page.table.sorting.editor'),
                value: _constants.SortingProperty.EDITOR_NAME
            }, {
                title: _messageResource2.default.getMessage('icalendar.page.table.sorting.date.created'),
                value: _constants.SortingProperty.CREATED_DATE
            }, {
                title: _messageResource2.default.getMessage('icalendar.page.table.sorting.date.edited'),
                value: _constants.SortingProperty.EDITED_DATE
            }];

            if (this.params.isLastSyncSortingIncluded) {
                sortingItems.push({
                    title: _messageResource2.default.getMessage('icalendar.page.table.columns.sync'),
                    value: _constants.SortingProperty.LAST_SYNC
                });
            }

            this.sortingListMenuSelector = new _SimpleListMenuButton2.default({
                itemHeight: 33,
                emptySelectionMessageKey: 'icalendar.page.table.sorting.feed',
                itemHtmlCallback: function itemHtmlCallback(sortingItem) {
                    return sortingItem.title;
                },
                onSelect: function onSelect(sortingItem) {
                    return _this2.callbacks.changeSorting({
                        property: sortingItem.value,
                        isAsc: _this2.state.sorting.isAsc
                    });
                },
                autoMenuWidth: false
            }).init(this.find('.listSelector'));
            this.sortingListMenuSelector.setItems(sortingItems);

            this.$sortingOrderButton = this.find('.sortingOrderButton');
            this.$sortingOrderButton.on('click', function () {
                return _this2.callbacks.changeSorting({
                    property: _this2.state.sorting.property,
                    isAsc: !_this2.state.sorting.isAsc
                });
            });
            this.renderInitialState();
        }
    }]);

    return FeedsTableSortingMenu;
}(_TemplateView3.default);

exports.default = FeedsTableSortingMenu;

/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _date_format = __webpack_require__(16);

var _constants = __webpack_require__(51);

var _utils = __webpack_require__(168);

var _SimpleSingletonTooltip = __webpack_require__(45);

var _SimpleSingletonTooltip2 = _interopRequireDefault(_SimpleSingletonTooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FeedNameCell = function (_TemplateView) {
    _inherits(FeedNameCell, _TemplateView);

    function FeedNameCell(_ref) {
        var name = _ref.name,
            createdDate = _ref.createdDate,
            creator = _ref.creator,
            _ref$editedDate = _ref.editedDate,
            editedDate = _ref$editedDate === undefined ? null : _ref$editedDate,
            _ref$editor = _ref.editor,
            editor = _ref$editor === undefined ? null : _ref$editor,
            _ref$onNameClick = _ref.onNameClick,
            onNameClick = _ref$onNameClick === undefined ? function () {} : _ref$onNameClick;

        _classCallCheck(this, FeedNameCell);

        var _this = _possibleConstructorReturn(this, (FeedNameCell.__proto__ || Object.getPrototypeOf(FeedNameCell)).call(this));

        _this.params = {
            name: name,
            createdDate: createdDate,
            creator: creator,
            editedDate: editedDate,
            editor: editor
        };

        _this.callbacks = {
            onNameClick: onNameClick
        };
        return _this;
    }

    _createClass(FeedNameCell, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class=\'feedNameCell\'>\n                    <span class=\'feedName\'/>\n                    <div class=\'createdBy\'>\n                        <div class=\'creationText\'>\n                            <div class=\'createdPrefix\'>\n                                <%=createdPrefix%>\n                            </div>                      \n                            <div class=\'creatorName\'/>\n                            <div class=\'createdDate\'/> \n                            <div class=\'editedMark\'>\n                                <%=edited%>\n                            </div>     \n                        </div>\n                    </div>\n                </div>';
        }
    }, {
        key: 'messageKeys',
        value: function messageKeys() {
            return {
                createdPrefix: 'icalendar.page.table.created',
                edited: 'icalendar.page.table.edited'
            };
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            var dateFormat = new _date_format.DateFormat(window.SystemSettings.dateFormat);
            var $creationText = this.find('.creationText');
            var $creatorNameEl = $creationText.find('.creatorName');
            var creatorName = (0, _utils.formatUserName)(this.params.creator);
            $creatorNameEl.text(creatorName);
            $creatorNameEl.prop('title', creatorName);
            $creationText.find('.createdDate').text(_messageResource2.default.getMessage('common.on.preposition') + ' ' + dateFormat.formatDate(this.params.createdDate));

            var $feedName = this.find('.feedName');
            $feedName.text(this.params.name);
            $feedName.prop('title', this.params.name);
            $feedName.on('click', this.callbacks.onNameClick);

            var $editedMark = this.find('.editedMark');

            if (this.params.editedDate && this.params.editor) {
                var tooltipText = _messageResource2.default.getMessage('icalendar.page.table.edited_by', [(0, _utils.formatUserName)(this.params.editor), dateFormat.formatDate(this.params.editedDate)]);

                (0, _SimpleSingletonTooltip2.default)($editedMark, {
                    extraClass: _constants.FEEDS_TOOLTIP_EXTRA_CLASS,
                    text: tooltipText
                });
            }

            $editedMark.toggle(!!this.params.editedDate && !!this.params.editor);
        }
    }]);

    return FeedNameCell;
}(_TemplateView3.default);

exports.default = FeedNameCell;

/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _FeedUserSelection = __webpack_require__(961);

var _FeedUserSelection2 = _interopRequireDefault(_FeedUserSelection);

var _FeedLeaveTypesSelection = __webpack_require__(1947);

var _FeedLeaveTypesSelection2 = _interopRequireDefault(_FeedLeaveTypesSelection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FeedDetailsCell = function (_TemplateView) {
    _inherits(FeedDetailsCell, _TemplateView);

    function FeedDetailsCell(_ref) {
        var leaveTypes = _ref.leaveTypes,
            userSelection = _ref.userSelection;

        _classCallCheck(this, FeedDetailsCell);

        var _this = _possibleConstructorReturn(this, (FeedDetailsCell.__proto__ || Object.getPrototypeOf(FeedDetailsCell)).call(this));

        _this.params = {
            leaveTypes: leaveTypes,
            userSelection: userSelection
        };
        return _this;
    }

    _createClass(FeedDetailsCell, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class="feedDetailsCell"/>';
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            new _FeedLeaveTypesSelection2.default({
                leaveTypes: this.params.leaveTypes
            }).init(this.getEl());

            new _FeedUserSelection2.default({
                userSelection: this.params.userSelection,
                shared: false
            }).init(this.getEl());
        }
    }]);

    return FeedDetailsCell;
}(_TemplateView3.default);

exports.default = FeedDetailsCell;

/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _utils = __webpack_require__(168);

var _UsersSelectionDetailedInfo = __webpack_require__(1944);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FeedUserSelection = function (_TemplateView) {
    _inherits(FeedUserSelection, _TemplateView);

    function FeedUserSelection(_ref) {
        var _ref$extraClass = _ref.extraClass,
            extraClass = _ref$extraClass === undefined ? '' : _ref$extraClass,
            _ref$userSelection = _ref.userSelection,
            all = _ref$userSelection.all,
            groups = _ref$userSelection.groups,
            users = _ref$userSelection.users,
            groupType = _ref$userSelection.groupType,
            _ref$shared = _ref.shared,
            shared = _ref$shared === undefined ? false : _ref$shared;

        _classCallCheck(this, FeedUserSelection);

        var _this = _possibleConstructorReturn(this, (FeedUserSelection.__proto__ || Object.getPrototypeOf(FeedUserSelection)).call(this));

        _this.params = {
            extraClass: extraClass,
            all: all,
            groups: groups,
            users: users,
            groupType: groupType,
            shared: shared
        };
        return _this;
    }

    _createClass(FeedUserSelection, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class=\'<%=extraClass%> userSelectionList\'>\n                        <div class=\'sharedIcon\'/>\n                        <div class=\'usersButton\'>\n                            <span class=\'text\'/>\n                        </div>\n                </div>';
        }
    }, {
        key: 'templateModel',
        value: function templateModel() {
            return {
                extraClass: this.params.extraClass
            };
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            var _this2 = this;

            var $usersArea = this.find('.usersButton');
            var $usersText = $usersArea.find('.text');

            if ((0, _utils.isUserSelectionEmpty)(this.params)) {
                $usersText.toggleClass('emptySelection', true);
            }

            var userSelectionText = (0, _utils.getTextForUserSelectionDescription)({
                all: this.params.all,
                groups: this.params.groups,
                users: this.params.users,
                groupType: this.params.groupType
            }, this.params.shared ? 'icalendar.page.table.user_selection.shared.none' : 'icalendar.page.table.user_selection.none');
            $usersText.text(userSelectionText);

            if (!this.params.all && this.params.groups.length + this.params.users.length > 1) {
                this.getEl().toggleClass('active', true);

                $usersText.on('click', function () {
                    (0, _UsersSelectionDetailedInfo.getInstance)().setState({
                        titleKey: _this2.params.shared ? 'icalendar.page.table.users.shared.detailedInfo.title' : 'icalendar.page.table.users.detailedInfo.title',
                        groups: _this2.params.groups,
                        users: _this2.params.users,
                        groupType: _this2.params.groupType
                    });
                    (0, _UsersSelectionDetailedInfo.getInstance)().showAt($usersText);
                });
            } else if (!this.params.all && this.params.groups.length + this.params.users.length === 1) {
                $usersText.prop('title', userSelectionText);
            }
        }
    }]);

    return FeedUserSelection;
}(_TemplateView3.default);

exports.default = FeedUserSelection;

/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _CustomCheckbox = __webpack_require__(83);

var _CustomCheckbox2 = _interopRequireDefault(_CustomCheckbox);

var _LeaveTypesSelectorButton = __webpack_require__(512);

var _LeaveTypesSelectorButton2 = _interopRequireDefault(_LeaveTypesSelectorButton);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _constants = __webpack_require__(264);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ICalFeedLeaveTypesSelector = function (_TemplateView) {
    _inherits(ICalFeedLeaveTypesSelector, _TemplateView);

    function ICalFeedLeaveTypesSelector(_ref) {
        var selectorId = _ref.selectorId,
            onLeaveTypeSelectionChanged = _ref.onLeaveTypeSelectionChanged,
            onCheckboxClick = _ref.onCheckboxClick;

        _classCallCheck(this, ICalFeedLeaveTypesSelector);

        var _this = _possibleConstructorReturn(this, (ICalFeedLeaveTypesSelector.__proto__ || Object.getPrototypeOf(ICalFeedLeaveTypesSelector)).call(this));

        _this.state = {
            leaveTypes: [],
            leaveTypeSelection: _constants.DEFAULT_LEAVE_TYPE_SELECTION,
            includeNotApproved: false
        };

        _this.params = {
            selectorId: selectorId
        };

        _this.callbacks = {
            onLeaveTypeSelectionChanged: onLeaveTypeSelectionChanged,
            onCheckboxClick: onCheckboxClick
        };
        _this.onAnyStatePropertyDeeplyChanged(['leaveTypes', 'leaveTypeSelection'], function () {
            return _this._refresh();
        });

        _this.onStatePropertyChanged('includeNotApproved', function (includeNotApproved) {
            return _this.includeNotApprovedCheckbox.setState({ checked: includeNotApproved });
        });
        return _this;
    }

    _createClass(ICalFeedLeaveTypesSelector, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class=\'field\'>\n                    <div class=\'fieldTitle\'>\n                        <%=userSelectorTitle%>\n                    </div>\n                    <div id=\'<%=selectorId%>\' class=\'fieldInput leavesSelectorWrapper x-btn-no-border\'/>\n                    <div class=\'fieldInput includeWaitingRequests\'>\n                        <div class=\'checkboxWrapper\'/>\n                    </div>\n                </div>';
        }
    }, {
        key: 'templateModel',
        value: function templateModel() {
            return {
                selectorId: this.params.selectorId
            };
        }
    }, {
        key: 'messageKeys',
        value: function messageKeys() {
            return {
                userSelectorTitle: 'icalendar.page.lightbox.leavetypes.description'
            };
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            var _this2 = this;

            this.$leavesButton = this.find('#' + this.params.selectorId);
            this._refresh();

            this.includeNotApprovedCheckbox = new _CustomCheckbox2.default({
                label: _messageResource2.default.getMessage('icalendar.page.lightbox.leavetypes.include_waiting_for_approval'),
                checked: this.state.includeNotApproved,
                onChange: function onChange() {
                    return _this2.callbacks.onCheckboxClick(!_this2.state.includeNotApproved);
                },
                containerAdditionalClass: 'includeCheckbox',
                checkboxTitleAdditionalClass: 'checkboxTitle'
            }).init(this.find('.checkboxWrapper'));
        }
    }, {
        key: '_refresh',
        value: function _refresh() {
            var _this3 = this;

            this.$leavesButton.empty();
            if (!this.state.leaveTypeSelection) {
                return;
            }

            this.leavesSelector = new _LeaveTypesSelectorButton2.default().init({
                renderTo: this.params.selectorId,
                leavesSelection: {
                    qualifier: this.state.leaveTypeSelection.qualifier === window.LeaveTypeSelectionQualifier.ALL,
                    showArchived: this.state.leaveTypeSelection.showArchived,
                    leaveTypes: this.state.leaveTypeSelection.leaveTypes
                },
                leavesData: _jquery2.default.extend(true, [], this.state.leaveTypes),
                ptoFeatureEnabled: window.SystemSettings.apPtoBalanceCalculationEnabled,
                sickBalanceFeatureEnabled: window.SystemSettings.apSickBalanceCalculationEnabled,
                changeCallback: function changeCallback() {
                    var currentSelection = _this3.leavesSelector.getLeaveTypeSelection();
                    _this3.callbacks.onLeaveTypeSelectionChanged({
                        qualifier: currentSelection.qualifier ? window.LeaveTypeSelectionQualifier.ALL : window.LeaveTypeSelectionQualifier.SELECTED,
                        showArchived: currentSelection.showArchived,
                        leaveTypes: currentSelection.leaveTypes
                    });
                },
                withApplyButton: true,
                extraClass: 'iCalLeaveTypeSelector',
                isMarkAllSelectedIfEmpty: true,
                showInactiveCheckbox: true,
                isMarkAllSelectedIfEmptyOnInit: false,
                labelNoItemsSelectedKey: 'icalendar.page.table.leave_types.none'
            });
        }
    }]);

    return ICalFeedLeaveTypesSelector;
}(_TemplateView3.default);

exports.default = ICalFeedLeaveTypesSelector;

/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _UsersFilter = __webpack_require__(562);

var _UsersFilter2 = _interopRequireDefault(_UsersFilter);

var _User = __webpack_require__(119);

var _User2 = _interopRequireDefault(_User);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _constants = __webpack_require__(264);

var _utils = __webpack_require__(168);

var _atUtils = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ICalFeedUserSelector = function (_TemplateView) {
    _inherits(ICalFeedUserSelector, _TemplateView);

    function ICalFeedUserSelector(_ref) {
        var title = _ref.title,
            onSelectionChanged = _ref.onSelectionChanged,
            _ref$shared = _ref.shared,
            shared = _ref$shared === undefined ? false : _ref$shared,
            _ref$setAllUsersIfNon = _ref.setAllUsersIfNoneSelected,
            setAllUsersIfNoneSelected = _ref$setAllUsersIfNon === undefined ? true : _ref$setAllUsersIfNon;

        _classCallCheck(this, ICalFeedUserSelector);

        var _this = _possibleConstructorReturn(this, (ICalFeedUserSelector.__proto__ || Object.getPrototypeOf(ICalFeedUserSelector)).call(this));

        _this.params = {
            title: title,
            shared: shared,
            setAllUsersIfNoneSelected: setAllUsersIfNoneSelected
        };

        _this.state = {
            users: [],
            userGroups: [],
            timeZoneGroups: [],
            userSelection: _constants.DEFAULT_USER_SELECTION
        };

        _this.callbacks = {
            onSelectionChanged: onSelectionChanged
        };

        _this.onStateDeeplyChanged(function () {
            return _this._refresh();
        });
        return _this;
    }

    _createClass(ICalFeedUserSelector, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class=\'field\'>\n                    <div class=\'titleArea\'>\n                        <div class=\'sharedIcon\'/>\n                        <div class=\'fieldTitle\'/>\n                    </div>\n                    <div class=\'fieldInput userSelectorWrapper x-btn-no-border\'/>\n                    <div class=\'sharedUserSelectorTip\'/>\n                </div>';
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            this.find('.sharedIcon').toggle(this.params.shared);
            this.find('.fieldTitle').text(this.params.title);

            this.$userSelectorWrapper = this.find('.userSelectorWrapper');
            this._initUsersFilter();
            if (this.params.shared) {
                this.find('.sharedUserSelectorTip').text(_messageResource2.default.getMessage('icalendar.page.lightbox.url.tip'));
            }
        }
    }, {
        key: '_initUsersFilter',
        value: function _initUsersFilter() {
            var _this2 = this;

            this.$userSelectorWrapper.empty();

            this.usersFilter = new _UsersFilter2.default({
                onChange: function onChange(selection) {
                    _this2.callbacks.onSelectionChanged({
                        all: selection.allSelected,
                        userIds: selection.userIds,
                        groupIds: selection.groupIds,
                        groupType: selection.groupType
                    });
                },
                createSelectionDescription: function createSelectionDescription(selection) {
                    return _this2._getSelectionDescription(selection);
                },
                showInactiveCheckbox: false,
                setAllUsersIfNoneSelected: this.params.setAllUsersIfNoneSelected
            }).init(this.$userSelectorWrapper);
        }
    }, {
        key: '_refresh',
        value: function _refresh() {
            if (this.state.userSelection) {
                this.usersFilter.setState({
                    users: this.state.users.map(function (user) {
                        return new _User2.default(user.id, user.firstName, user.lastName, user.middleName, user.username, user.active, user.emailExists, user.userGroupId, user.timeZoneGroupId);
                    }),
                    userIds: this.state.userSelection.userIds,
                    groupIds: this.state.userSelection.groupIds,
                    groupType: this.state.userSelection.groupType,
                    userGroups: window.SystemSettings.apUGREnabled ? this.state.userGroups : null,
                    timeZoneGroups: window.SystemSettings.apTZGEnabled ? this.state.timeZoneGroups : null,
                    allSelected: this.state.userSelection.all
                });
            } else {
                this._initUsersFilter();
            }
        }
    }, {
        key: '_getSelectionDescription',
        value: function _getSelectionDescription(selection) {
            return (0, _atUtils.escapeHtmlSymbols)((0, _utils.getTextForUserSelectionDescription)({
                all: false,
                users: selection.getSecondLevel(),
                groups: selection.getFirstLevel(),
                groupType: selection.groupType
            }, this.params.shared ? 'icalendar.page.table.user_selection.shared.none' : 'icalendar.page.table.user_selection.none'));
        }
    }]);

    return ICalFeedUserSelector;
}(_TemplateView3.default);

exports.default = ICalFeedUserSelector;

/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Table = __webpack_require__(385);

var _Table2 = _interopRequireDefault(_Table);

var _TableRow = __webpack_require__(250);

var _TableRow2 = _interopRequireDefault(_TableRow);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function TabularDataTable() {}

TabularDataTable.prototype = _underscore2.default.create(_Table2.default.prototype);

TabularDataTable.prototype.init = function (tHeadEl, changesCallback, validateCallback) {
    _Table2.default.call(this, tHeadEl);

    this._validateCallback = validateCallback;
    this._validationDetected = function () {
        if (this._validateCallback) this._validateCallback();
    };

    this._changesCallback = changesCallback;
    this._changesDetected = function () {
        if (this._changesCallback) this._changesCallback();
    };

    return this;
};

TabularDataTable.prototype.addRow = function (row) {
    _Table2.default.prototype.addRow.call(this, row);
    row.validate();
};

TabularDataTable.prototype.updateRow = function (rowIndex, row) {
    _Table2.default.prototype.replaceRowAndUpdateDOM.call(this, rowIndex, row);
    row.validate();
};

// abstract
TabularDataTable.prototype.createEmptyRow = function () {
    return new _TableRow2.default();
};

TabularDataTable.prototype.addEmptyRow = function () {
    var row = this.createEmptyRow();
    _Table2.default.prototype.addRow.call(this, row);
    row.buildDOM(this.getTBody());
    row.writeCellsContent();
    row.getRowEl().className = this.getRowElClasses(row.getRowIdx()).join(" ");
    this.updateTableClasses();
};

TabularDataTable.prototype.buildDOM = function (containerEl) {
    _Table2.default.prototype.buildDOM.call(this, containerEl);
    this.updateTableClasses();
};

TabularDataTable.prototype.getBaseTableClasses = function () {
    return ["tabularDataTable"];
};

TabularDataTable.prototype.updateTableClasses = function () {
    var classes = this.getBaseTableClasses();
    if (this.rows.length == 0) classes.push("noRows");
    this.tableEl.className = classes.join(" ");
};

TabularDataTable.prototype.updateUI = function () {
    this.updateTableClasses();
    for (var i = 0; i < this.rows.length; i++) {
        this.rows[i].updateUI();
    }
};

TabularDataTable.prototype.validate = function () {
    var valid = true;
    for (var i = 0; i < this.rows.length; i++) {
        var row = this.rows[i];
        var rowValid = row.isMarkedToRemove() || row.validate();
        valid = valid && rowValid;
    }
    return valid;
};

TabularDataTable.prototype.doToggleRemove = function (rowIdx) {
    var row = this.getRow(rowIdx);
    if (row.isMarkedToRemove()) {
        row.unMarkToRemove();
    } else if (row.canBeDeletedPermanently()) {
        this.removeRow(rowIdx);
        this.updateTableClasses();
        this.onRowAmountChange();
    } else {
        row.markToRemove();
    }
};

TabularDataTable.prototype.toggleRemove = function (rowIdx) {
    this.doToggleRemove(rowIdx);
    this._validationDetected();
    this._changesDetected();
};

TabularDataTable.prototype.hasErrors = function () {
    for (var i = 0; i < this.rows.length; i++) {
        if (this.rows[i].hasErrors()) return true;
    }return false;
};

TabularDataTable.prototype.disableTextSelection = function () {
    // do not disable selection;
};

TabularDataTable.prototype.onRowAmountChange = function () {
    (0, _jquery2.default)(this).trigger("rowAmountChanged");
};

exports.default = TabularDataTable;

/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _LeaveReportConfig = __webpack_require__(129);

var _ListSelector = __webpack_require__(96);

var _ListSelector2 = _interopRequireDefault(_ListSelector);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function LeaveReportColumnsFormatSelector() {}

LeaveReportColumnsFormatSelector.prototype.init = function (id, initValue, onChangeCallback, enabledPTO, enabledSick) {
    this.containerId = id;
    this.containerEl = (0, _jquery2.default)("#" + id);
    this.containerEl.addClass("i");

    var columnsConfig = initValue.columnsConfig;

    if (enabledSick && !enabledPTO) initValue.balanceQualifier = _LeaveReportConfig.LeaveTypeBalanceQualifier.SICK_DAYS_ONLY;

    if (!enabledSick && enabledPTO) initValue.balanceQualifier = _LeaveReportConfig.LeaveTypeBalanceQualifier.PTO_ONLY;

    var balanceQualifier = initValue.balanceQualifier;

    var needPTOOption = enabledPTO || balanceQualifier != _LeaveReportConfig.LeaveTypeBalanceQualifier.SICK_DAYS_ONLY && columnsConfig != _LeaveReportConfig.LeaveTypeColumnConfig.LEAVE_TIME_ONLY;
    var needSDBOption = enabledSick || balanceQualifier != _LeaveReportConfig.LeaveTypeBalanceQualifier.PTO_ONLY && columnsConfig != _LeaveReportConfig.LeaveTypeColumnConfig.LEAVE_TIME_ONLY;

    this.columnsConfigSelector = this._createColumnsConfigSelector(this.containerEl, needPTOOption, needSDBOption, onChangeCallback);

    this.initBalanceQualifier = initValue.balanceQualifier;

    this.balanceTypeSelectorEnabled = needPTOOption && needSDBOption;

    if (this.balanceTypeSelectorEnabled) {
        this.balanceTypeSelectorEl = this._createBalanceTypeSelector(this.containerEl, onChangeCallback);
        this._selectBalanceTypeSelectorValue(initValue.balanceQualifier);
    } else {
        this.containerEl.addClass("withoutBalances");
    }

    this._setColumnsConfigSelectorValue(initValue.columnsConfig, true);

    return this;
};

LeaveReportColumnsFormatSelector.prototype.getValue = function () {
    var columnsConfig = this._getColumnsConfigSelectorValue();
    var balanceTypeValue;
    if (this.balanceTypeSelectorEnabled) {
        balanceTypeValue = this._getBalanceTypeSelectorValue();
    } else {
        balanceTypeValue = this.initBalanceQualifier;
    }
    return {
        columnsConfig: columnsConfig,
        balanceQualifier: balanceTypeValue
    };
};

LeaveReportColumnsFormatSelector.prototype.setActiveItemByValue = function (value, suppressChangeEvent) {
    this._setColumnsConfigSelectorValue(value.columnsConfig, suppressChangeEvent);
    if (this.balanceTypeSelectorEnabled) {
        this._selectBalanceTypeSelectorValue(value.balanceQualifier);
    }
};

LeaveReportColumnsFormatSelector.prototype._createBalanceTypeSelector = function (containerEl, onChangeCallback) {

    var balanceTypeSelectorEl = (0, _jquery2.default)(document.createElement("div"));
    var options = [];

    options.push({
        value: _LeaveReportConfig.LeaveTypeBalanceQualifier.PTO_AND_SICK_DAYS,
        label: _messageResource2.default.getMessage("report.leaves.configure_columns.balance_type_label.pto_and_sick_days")
    });
    options.push({
        value: _LeaveReportConfig.LeaveTypeBalanceQualifier.PTO_ONLY,
        label: _messageResource2.default.getMessage("report.leaves.configure_columns.balance_type_label.pto")
    });
    options.push({
        value: _LeaveReportConfig.LeaveTypeBalanceQualifier.SICK_DAYS_ONLY,
        label: _messageResource2.default.getMessage("report.leaves.configure_columns.balance_type_label.sick_days")
    });

    _jquery2.default.each(options, function (id, option) {
        var optionDiv = (0, _jquery2.default)("<div></div>");
        optionDiv.addClass("option");
        var input = (0, _jquery2.default)("<input type='radio' name='balanceType'/>");
        input.attr("id", id);
        input.attr("value", option.value);
        input.on("change", function (event) {
            onChangeCallback();
        });

        optionDiv.append(input);
        var label = (0, _jquery2.default)("<label></label>");
        label.text(option.label);
        label.attr("for", id);
        optionDiv.append(label);
        balanceTypeSelectorEl.append(optionDiv);
    });

    balanceTypeSelectorEl.attr("id", "balanceTypeSelector");
    balanceTypeSelectorEl.addClass("balanceTypeSelector");
    containerEl.append(balanceTypeSelectorEl);

    return balanceTypeSelectorEl;
};

LeaveReportColumnsFormatSelector.prototype._selectBalanceTypeSelectorValue = function (value) {
    this.balanceTypeSelectorEl.find("input[value=" + value + "]").prop("checked", true);
};
LeaveReportColumnsFormatSelector.prototype._getBalanceTypeSelectorValue = function () {
    return this.balanceTypeSelectorEl.find("input:checked").attr("value");
};

LeaveReportColumnsFormatSelector.prototype._disableBalanceTypeSelector = function (isDisable) {
    this.balanceTypeSelectorEl.toggleClass("disable", isDisable);
    this.balanceTypeSelectorEl.find("input").prop("disabled", isDisable);
};

LeaveReportColumnsFormatSelector.prototype._createColumnsConfigSelector = function (containerEl, needPTOOption, needSDBOption, onChangeCallback) {
    var columnsTypeSelectorContainerEl = (0, _jquery2.default)(document.createElement("div"));
    columnsTypeSelectorContainerEl.attr("id", "columnsTypeSelector");
    columnsTypeSelectorContainerEl.addClass("columnsTypeSelector");
    containerEl.append(columnsTypeSelectorContainerEl);

    columnsTypeSelectorContainerEl.append("<div class='title'>" + _messageResource2.default.getMessage("report.leaves.configure_columns.show") + "</div>");

    var columnsConfigSelector = new _ListSelector2.default({
        renderTo: "columnsTypeSelector",
        menuCls: "columnsFormatMenu"
    });

    var balancesTextKey;
    if (needPTOOption && needSDBOption) {
        balancesTextKey = "report.leaves.configure_columns.both_balances";
    } else if (needPTOOption) {
        balancesTextKey = "report.leaves.configure_columns.pto_balance";
    } else {
        balancesTextKey = "report.leaves.configure_columns.sick_days_balance";
    }

    var balancesText = _messageResource2.default.getMessage(balancesTextKey);

    columnsConfigSelector.addItems([{
        text: _messageResource2.default.getEscapedMessage("report.leaves.configure_columns.leave_time_and", [balancesText]),
        value: _LeaveReportConfig.LeaveTypeColumnConfig.LEAVE_TIME_AND_BALANCES
    }, {
        text: _messageResource2.default.getEscapedMessage("report.leaves.configure_columns.leave_time_only"),
        value: _LeaveReportConfig.LeaveTypeColumnConfig.LEAVE_TIME_ONLY
    }, {
        text: _messageResource2.default.getEscapedMessage("report.leaves.configure_columns.balances_only", [balancesText]),
        value: _LeaveReportConfig.LeaveTypeColumnConfig.BALANCES_ONLY
    }]);

    var self = this;
    columnsConfigSelector.on("change", function () {
        if (self.balanceTypeSelectorEnabled) {
            self._disableBalanceTypeSelector(columnsConfigSelector.getSelectedItem().value == _LeaveReportConfig.LeaveTypeColumnConfig.LEAVE_TIME_ONLY);
        }

        onChangeCallback();
    });

    return columnsConfigSelector;
};

LeaveReportColumnsFormatSelector.prototype._setColumnsConfigSelectorValue = function (value, suppressChangeEvent) {
    if (this.balanceTypeSelectorEnabled) {
        this._disableBalanceTypeSelector(value == _LeaveReportConfig.LeaveTypeColumnConfig.LEAVE_TIME_ONLY);
    }
    this.columnsConfigSelector.setActiveItemByValue(value, suppressChangeEvent);
};

LeaveReportColumnsFormatSelector.prototype._getColumnsConfigSelectorValue = function () {
    return this.columnsConfigSelector.getSelectedItem().value;
};

exports.default = LeaveReportColumnsFormatSelector;

/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _ParametersFormatter = __webpack_require__(246);

var _ParametersFormatter2 = _interopRequireDefault(_ParametersFormatter);

var _BaseParametersFormattingStrategy = __webpack_require__(248);

var _BaseParametersFormattingStrategy2 = _interopRequireDefault(_BaseParametersFormattingStrategy);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _DateRangeFormattingStrategy = __webpack_require__(165);

var _DateRangeFormattingStrategy2 = _interopRequireDefault(_DateRangeFormattingStrategy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ParametersFormattingStrategy = function ParametersFormattingStrategy() {};

ParametersFormattingStrategy.prototype = _underscore2.default.create(_BaseParametersFormattingStrategy2.default.prototype, {

    init: function init(_ref) {
        var selectorsData = _ref.selectorsData,
            dateFormat = _ref.dateFormat,
            productSettingsValidator = _ref.productSettingsValidator,
            reportRightsValidator = _ref.reportRightsValidator,
            reportAuthorizationInfo = _ref.reportAuthorizationInfo,
            reportParamsStringBuilderConstructor = _ref.reportParamsStringBuilderConstructor;

        _BaseParametersFormattingStrategy2.default.prototype.init.call(this, { selectorsData: selectorsData, dateFormat: dateFormat, reportAuthorizationInfo: reportAuthorizationInfo, reportParamsStringBuilderConstructor: reportParamsStringBuilderConstructor });
        this.productSettingsValidator = productSettingsValidator;
        this.reportRightsValidator = reportRightsValidator;
        this.assignedInfo = selectorsData.assignedInfo;
        this.reportAuthorizationInfo = reportAuthorizationInfo;

        return this;
    },

    createParametersFormatter: function createParametersFormatter(_ref2) {
        var selectorsData = _ref2.selectorsData,
            dateFormat = _ref2.dateFormat,
            reportAuthorizationInfo = _ref2.reportAuthorizationInfo,
            reportParamsStringBuilderConstructor = _ref2.reportParamsStringBuilderConstructor;

        return new _ParametersFormatter2.default().init({
            selectorsData: selectorsData,
            dateFormat: dateFormat,
            ugrFeatureEnabled: selectorsData.userGroupsEnabled,
            tzgFeatureEnabled: selectorsData.timeZoneGroupsEnabled,
            reportAuthorizationInfo: reportAuthorizationInfo,
            reportParamsStringBuilderConstructor: reportParamsStringBuilderConstructor
        });
    },

    createDateParametersFormattingStrategy: function createDateParametersFormattingStrategy(config) {
        return new _DateRangeFormattingStrategy2.default(config.dateFormat);
    },

    formatMainPartOfLightboxTitle: function formatMainPartOfLightboxTitle(selectedParameters) {
        var enabledPTO = this.reportAuthorizationInfo.ptoBalancesAvailable;
        var enabledSick = this.reportAuthorizationInfo.sickDaysBalancesAvailable;

        var reportTypeText = "";
        if (!enabledPTO && !enabledSick) {
            reportTypeText = _messageResource2.default.getMessage('leave_and_balances_report.title.leave_time');
        } else {
            var balanceMessage = "";

            if (enabledPTO && enabledSick) balanceMessage = _messageResource2.default.getMessage("leave_and_balances_report.title.balances");else if (enabledPTO) balanceMessage = _messageResource2.default.getMessage("leave_and_balances_report.title.pto");else if (enabledSick) balanceMessage = _messageResource2.default.getMessage("leave_and_balances_report.title.sick");

            reportTypeText = _messageResource2.default.getMessage('leave_and_balances_report.title.leave_time_and_balances', [balanceMessage]);
        }

        var dateParameters = this.dateParametersFormattingStrategy.formatForDateInformation(selectedParameters.dateParameters);
        var grouping = LeavesReportFormatUtils.formatGroupingLevel(selectedParameters.firstGroupingLevel);
        return _messageResource2.default.getMessage("leave_and_balances_report.title", [reportTypeText, grouping, dateParameters]);
    },

    formatParametersText: function formatParametersText(selectedParameters) {
        return this.parametersFormatter.formatUsersSelection(selectedParameters.userSelection, this.assignedInfo) + "; " + this.parametersFormatter.formatLeaveTypesSelection(selectedParameters.leaveTypeSelection);
    }
});

exports.default = ParametersFormattingStrategy;

/***/ }),
/* 967 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _FormatUtils = __webpack_require__(142);

var _FormatUtils2 = _interopRequireDefault(_FormatUtils);

var _constants = __webpack_require__(11);

var _BalanceType = __webpack_require__(253);

var _BalanceType2 = _interopRequireDefault(_BalanceType);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LeavesReportFormatUtils = function (_BaseReportFormatUtil) {
    _inherits(LeavesReportFormatUtils, _BaseReportFormatUtil);

    function LeavesReportFormatUtils() {
        _classCallCheck(this, LeavesReportFormatUtils);

        return _possibleConstructorReturn(this, (LeavesReportFormatUtils.__proto__ || Object.getPrototypeOf(LeavesReportFormatUtils)).apply(this, arguments));
    }

    _createClass(LeavesReportFormatUtils, null, [{
        key: "formatBalance",
        value: function formatBalance(balance, balanceType, defaultWorkDayDuration) {
            if (_.isNumber(balance)) {
                if (balanceType == _BalanceType2.default.PTO && window.SystemSettings.showPTOInHours || balanceType == _BalanceType2.default.SICK && window.SystemSettings.showSickInHours) balance *= defaultWorkDayDuration / 60;
                return this._balanceNumberFormatter.format(balance);
            } else return "-";
        }
    }, {
        key: "formatChartType",
        value: function formatChartType(chartType) {
            var chartTypeMessageKey;
            switch (chartType) {
                case APReportChartType.LEAVE_TIME:
                    chartTypeMessageKey = "common.reports.chart_type_selector.leave_time";
                    break;
                case APReportChartType.PTO_BALANCE:
                    chartTypeMessageKey = "common.reports.chart_type_selector.pto_balance";
                    break;
                case APReportChartType.SICK_BALANCE:
                    chartTypeMessageKey = "common.reports.chart_type_selector.sick_balance";
                    break;
            }

            return _messageResource2.default.getMessage(chartTypeMessageKey);
        }
    }, {
        key: "makeBalanceTemplateModel",
        value: function makeBalanceTemplateModel(balanceType, firstGroupingLevel, secondGroupingLevel, startDate, endDate) {
            var titleKey = balanceType == _BalanceType2.default.PTO ? "report.leaves.balance_column_name.pto" : "report.leaves.balance_column_name.sick_days";
            var unitKey = balanceType == _BalanceType2.default.PTO && window.SystemSettings.showPTOInHours || balanceType == _BalanceType2.default.SICK && window.SystemSettings.showSickInHours ? "common.pto_units.hours" : "common.pto_units.days";
            var firstLevelStartDateKey, firstLevelEndDateKey, secondLevelStartDateKey, secondLevelEndDateKey;
            switch (firstGroupingLevel) {
                case _constants.ReportGroupingLevel.DATE:
                    firstLevelStartDateKey = "report.leaves.first_balance_subcolumn.dates";
                    firstLevelEndDateKey = "report.leaves.second_balance_subcolumn.dates";
                    break;
                case _constants.ReportGroupingLevel.WEEK:
                    firstLevelStartDateKey = "report.leaves.first_balance_subcolumn.weeks";
                    firstLevelEndDateKey = "report.leaves.second_balance_subcolumn.weeks";
                    break;
                case _constants.ReportGroupingLevel.MONTH:
                    firstLevelStartDateKey = "report.leaves.first_balance_subcolumn.months";
                    firstLevelEndDateKey = "report.leaves.second_balance_subcolumn.months";
                    break;
            }
            switch (secondGroupingLevel) {
                case _constants.ReportGroupingLevel.DATE:
                    secondLevelStartDateKey = "report.leaves.start_of_the_day";
                    secondLevelEndDateKey = "report.leaves.end_of_the_day";
                    break;
                case _constants.ReportGroupingLevel.WEEK:
                    secondLevelStartDateKey = "report.leaves.start_of_the_week";
                    secondLevelEndDateKey = "report.leaves.end_of_the_week";
                    break;
                case _constants.ReportGroupingLevel.MONTH:
                    secondLevelStartDateKey = "report.leaves.start_of_the_month";
                    secondLevelEndDateKey = "report.leaves.end_of_the_month";
                    break;
            }

            return {
                title: _messageResource2.default.getMessage(titleKey),
                startDate: firstLevelStartDateKey ? _messageResource2.default.getMessage(firstLevelStartDateKey) : _get(LeavesReportFormatUtils.__proto__ || Object.getPrototypeOf(LeavesReportFormatUtils), "formatDateForHeader", this).call(this, startDate),
                endDate: firstLevelEndDateKey ? _messageResource2.default.getMessage(firstLevelEndDateKey) : _get(LeavesReportFormatUtils.__proto__ || Object.getPrototypeOf(LeavesReportFormatUtils), "formatDateForHeader", this).call(this, endDate),
                startDateDetails: secondLevelStartDateKey ? _messageResource2.default.getMessage(secondLevelStartDateKey) : "",
                endDateDetails: secondLevelEndDateKey ? _messageResource2.default.getMessage(secondLevelEndDateKey) : "",
                unit: _messageResource2.default.getMessage(unitKey)
            };
        }
    }]);

    return LeavesReportFormatUtils;
}(_FormatUtils2.default);

exports.default = LeavesReportFormatUtils;

/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _PDFDefinitionCreator = __webpack_require__(1980);

var _PDFDefinitionCreator2 = _interopRequireDefault(_PDFDefinitionCreator);

var _date_format = __webpack_require__(16);

var _PDFParametersFormattingStrategy = __webpack_require__(1982);

var _PDFParametersFormattingStrategy2 = _interopRequireDefault(_PDFParametersFormattingStrategy);

var _TableDataConverter = __webpack_require__(970);

var _TableDataConverter2 = _interopRequireDefault(_TableDataConverter);

var _utils = __webpack_require__(164);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var LeavesReportPDFGenerator = function () {
    function LeavesReportPDFGenerator() {
        _classCallCheck(this, LeavesReportPDFGenerator);
    }

    _createClass(LeavesReportPDFGenerator, [{
        key: "init",
        value: function init(_ref) {
            var store = _ref.store,
                generalStore = _ref.generalStore,
                productSettingsValidator = _ref.productSettingsValidator,
                reportRightsValidator = _ref.reportRightsValidator,
                manageableUserIds = _ref.manageableUserIds,
                projectsWithMaIds = _ref.projectsWithMaIds,
                reportAuthorizationInfo = _ref.reportAuthorizationInfo,
                reportParamsStringBuilderConstructor = _ref.reportParamsStringBuilderConstructor;

            this.docDefinitionCreator = new _PDFDefinitionCreator2.default();
            this.onGenerateBreaker = { needBreak: false };
            this.store = store;
            this.generalStore = generalStore;
            this.productSettingsValidator = productSettingsValidator;
            this.reportRightsValidator = reportRightsValidator;
            this.manageableUserIds = manageableUserIds;
            this.projectsWithMaIds = projectsWithMaIds;
            this.reportAuthorizationInfo = reportAuthorizationInfo;
            this.reportParamsStringBuilderConstructor = reportParamsStringBuilderConstructor;

            return this;
        }
    }, {
        key: "interruptGeneration",
        value: function interruptGeneration() {
            this.onGenerateBreaker.needBreak = true;
        }
    }, {
        key: "_getCreatePDFDefinitionStrategy",
        value: function _getCreatePDFDefinitionStrategy() {
            return null;
        }
    }, {
        key: "_getParametersFormattingStrategy",
        value: function _getParametersFormattingStrategy(config) {
            var dateFormatForFileName = new _date_format.DateFormat('yyyy-MM-dd');
            return new _PDFParametersFormattingStrategy2.default().init({
                users: this.generalStore.getVisibleUsers(),
                userGroups: this.generalStore.getUserGroups(),
                timeZoneGroups: this.generalStore.getTimeZoneGroups(),
                leaveTypesMap: LeaveTypeStore.getLeaveTypes(),
                dateFormat: config.dateFormat,
                dateFormatForFile: dateFormatForFileName,
                productSettingsValidator: this.productSettingsValidator,
                reportRightsValidator: this.reportRightsValidator,
                manageableUserIds: this.manageableUserIds,
                projectsWithMaIds: this.projectsWithMaIds,
                reportAuthorizationInfo: this.reportAuthorizationInfo,
                reportParamsStringBuilderConstructor: this.reportParamsStringBuilderConstructor
            });
        }
    }, {
        key: "calculateTotalNumberOfPages",
        value: function calculateTotalNumberOfPages(params) {
            return 0;
        }
    }, {
        key: "generatePDF",
        value: function generatePDF(additionalDataProvider) {
            var newBreaker = {
                needBreak: false
            };
            this.onGenerateBreaker = newBreaker;

            var pdfPrintParameters = this.store.getPrintParametersForSave();
            var chartSectionConfig = this.store.getChartSectionConfig();
            var reportParams = this.store.getReportParams();

            var showAssignedOnly = this.store.isShowAssignedOnlyEnabled() && this.store.isShowAssignedOnly();
            var viewerInfo = this.store.getViewerInfo();
            var assignedInfo = { isShowOnlyAssigned: showAssignedOnly, viewerInfo: viewerInfo };

            reportParams.showAssignedOnly = showAssignedOnly;

            var reportData = this.store.getReportData();
            var defaultWorkDayDuration = this.store.getDefaultWorkDayDuration();

            var totals = {
                totalValue: reportData.totalLeaveSpent,
                totalsMap: _underscore2.default.object(_underscore2.default.map(reportData.leaveSpent, function (item) {
                    return [item.leaveTypeId, item.leaveSpent];
                })),
                ptoBalance: reportData.ptoBalance,
                sickBalance: reportData.sickBalance
            };
            var rows = new _TableDataConverter2.default(reportData, reportParams).convert();
            var leaveTypeIds = _underscore2.default.pluck(reportData["leaveSpent"], "leaveTypeId");

            var pdfConfig = {
                pdfPrintParameters: pdfPrintParameters,
                chartSectionConfig: chartSectionConfig,
                pdfData: {
                    tableData: rows,
                    leaveTypeIds: leaveTypeIds,
                    chartImage: null,
                    totals: totals,
                    defaultWorkDayDuration: defaultWorkDayDuration
                },
                reportParams: reportParams,
                assignedInfo: assignedInfo,
                dateFormat: new _date_format.DateFormat(window.SystemSettings.dateFormat)
            };

            var s = this;
            return new Promise(function (onComplete) {
                if (s.isNeedRetrieveAdditionalData(pdfConfig)) {
                    additionalDataProvider(s.getAdditionalDataConfig(pdfConfig), function (additionalData) {
                        s.updateConfigWithAdditionalData(pdfConfig, additionalData);
                        onComplete(pdfConfig);
                    });
                } else {
                    onComplete(pdfConfig);
                }
            }).then(function (pdfConfig) {
                return new Promise(function (onComplete, onError) {
                    defer(_underscore2.default.bind(onComplete, this, pdfConfig));
                });
            }).then(function (pdfConfig) {
                if (newBreaker["needBreak"]) {
                    return Promise.reject(new Error("abort"));
                }
                return s._generatePDF(pdfConfig, newBreaker);
            });
        }
    }, {
        key: "isNeedRetrieveAdditionalData",
        value: function isNeedRetrieveAdditionalData(pdfConfig) {
            return this.store.getChartSectionConfig()["showChart"];
        }
    }, {
        key: "getAdditionalDataConfig",
        value: function getAdditionalDataConfig(pdfConfig) {
            return {
                chartImageSizes: this.docDefinitionCreator.getChartImageSizes(pdfConfig.pdfPrintParameters)
            };
        }
    }, {
        key: "updateConfigWithAdditionalData",
        value: function updateConfigWithAdditionalData(pdfConfig, additionalData) {
            pdfConfig.pdfData.chartImage = additionalData["chartImage"];
        }
    }, {
        key: "_generatePDF",
        value: function _generatePDF(config, breaker) {
            var paramFormattingStrategy = this._getParametersFormattingStrategy(config);

            return this.docDefinitionCreator.createDocDefinition(config, paramFormattingStrategy, this.store).then(function (ddObject) {
                var doc = (0, _utils.createPdf)(ddObject["docDefinition"]);
                var currentFileName = paramFormattingStrategy.formatChartPDFFileName(config.reportParams);

                return new Promise(function (onComplete, onError) {
                    try {
                        doc._createDoc({
                            tableLayouts: ddObject["tableLayouts"]
                        }, function (result, pages) {
                            if (breaker.needBreak) {
                                return onError(new Error("abort"));
                            }

                            onComplete({
                                encodedPDF: result,
                                fileName: currentFileName,
                                pageCount: pages.length
                            });
                        });
                    } catch (e) {
                        onError(e);
                    }
                });
            });
        }
    }]);

    return LeavesReportPDFGenerator;
}();

exports.default = LeavesReportPDFGenerator;

/***/ }),
/* 969 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.styles = exports.parameters = undefined;

var _Object$assign;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _StringUtils = __webpack_require__(121);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _BaseReportPDFDefinitionBuilder = __webpack_require__(588);

var _BaseReportPDFDefinitionBuilder2 = _interopRequireDefault(_BaseReportPDFDefinitionBuilder);

var _BasePDFDefinitionBuilder = __webpack_require__(541);

var _BasePDFDefinitionBuilder2 = _interopRequireDefault(_BasePDFDefinitionBuilder);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PDFDefinitionBuilder = function (_BaseReportPDFDefinit) {
    _inherits(PDFDefinitionBuilder, _BaseReportPDFDefinit);

    function PDFDefinitionBuilder() {
        _classCallCheck(this, PDFDefinitionBuilder);

        return _possibleConstructorReturn(this, (PDFDefinitionBuilder.__proto__ || Object.getPrototypeOf(PDFDefinitionBuilder)).apply(this, arguments));
    }

    _createClass(PDFDefinitionBuilder, [{
        key: "getAdditionalStyles",
        value: function getAdditionalStyles() {
            return styles;
        }
    }, {
        key: "getAdditionalParameters",
        value: function getAdditionalParameters() {
            return parameters;
        }
    }, {
        key: "initDocDefinitionObject",
        value: function initDocDefinitionObject(withSignatureOnEachPage, headerOnEachPage) {
            _BasePDFDefinitionBuilder2.default.prototype.initDocDefinitionObject.call(this, headerOnEachPage);
            var margins = [];
            _underscore2.default.extend(margins, this.dd.pageMargins);

            this.dd.pageMargins = margins;

            var footerMargins = this.p("footerMargins")(this.p("pageMargins"));
            this.dd.footer = function () {
                return function (currentPage, pageCount) {
                    return {
                        style: 'rightFooterPageCount',
                        margin: footerMargins,
                        layout: 'noBordersNoPadding',
                        text: _messageResource2.default.getMessage('report.chart_pdf.rightFooterLabel', [currentPage, pageCount])
                    };
                };
            }();
        }
    }, {
        key: "makeLegendTotalRow",
        value: function makeLegendTotalRow(title, totalSpent) {
            return [{ text: title, style: 'chartLegendTotal', colSpan: 2 }, { text: '' }, { text: totalSpent, style: 'chartLegendTotalValue' }];
        }
    }, {
        key: "makeLegendItemRow",
        value: function makeLegendItemRow(item) {
            var style = item.originalValue < 0 ? ['chartLegendValue', 'negativeValue'] : 'chartLegendValue';
            return [{
                canvas: [{
                    type: 'rect',
                    x: 0,
                    y: 0,
                    w: 6,
                    h: 14,
                    color: item.color
                }]
            }, { text: (0, _StringUtils.cutLongText)(item.name, this.p("itemTextLen")), style: 'chartLegendItem' }, { text: item.value, style: style }];
        }
    }, {
        key: "addChartLegend",
        value: function addChartLegend(title, items, total) {
            var tableStyles = this.p("dataTableStyles");
            var tableMargins = {
                top: 2
            };

            var rows = [];
            rows.push(this.makeLegendTotalRow(title, total));

            _underscore2.default.each(items, function (item) {
                rows.push(this.makeLegendItemRow(item));
            }, this);

            var table = {
                style: tableStyles.legendStyle,
                layout: 'headerBorderSeparatedRows',
                marginTop: tableMargins.top,

                table: {
                    dontBreakRows: true,
                    widths: ['auto', "auto", 'auto'],
                    body: rows
                }
            };
            this.appendContentElement(table);
        }
    }, {
        key: "addChartImage",
        value: function addChartImage(viewByText, image) {
            var sizes = this.p("chartImageSize");

            this.appendContentElement({
                marginTop: 30,
                marginBottom: 0,
                text: viewByText,
                style: 'viewChartBy',
                headlineLevel: 1
            });

            this.appendContentElement({
                layout: 'noBordersNoPadding',
                headlineLevel: 2,
                marginTop: 5,
                marginBottom: 0,
                table: {
                    width: ['100%'],
                    body: [[{
                        height: sizes.height,
                        width: sizes.width,
                        image: image
                    }]]
                }
            });
        }
    }, {
        key: "createHeaderDataRow",
        value: function createHeaderDataRow(headerData) {
            return {
                firstRow: this.iterateColumns('makeHeader', headerData),
                secondRow: this.iterateColumns('makeSubHeader', headerData)
            };
        }
    }]);

    return PDFDefinitionBuilder;
}(_BaseReportPDFDefinitionBuilder2.default);

exports.default = PDFDefinitionBuilder;
var parameters = exports.parameters = {

    dataTableStyles: {
        tableStyle: 'reportRow',
        legendStyle: 'chartLegend'
    },

    Portrait: {
        columnWidth: {
            levels: 23,
            totals: 10,
            leave: 9,
            balance: 12
        },

        A4: {
            limitOfLinesInTextCell: 62,
            chartImageSize: {
                height: 238,
                width: 515
            }
        },
        Letter: {
            limitOfLinesInTextCell: 56,
            chartImageSize: {
                height: 245,
                width: 530
            }
        }
    },
    Landscape: {
        columnWidth: {
            levels: 15,
            totals: 7,
            leave: 6,
            balance: 9
        },

        A4: {
            limitOfLinesInTextCell: 40,
            chartImageSize: {
                height: 290,
                width: 730
            }
        },
        Letter: {
            limitOfLinesInTextCell: 42,
            chartImageSize: {
                height: 310,
                width: 680
            }
        }
    }
};

var styles = exports.styles = Object.assign({}, _BaseReportPDFDefinitionBuilder.styles, (_Object$assign = {
    reportSecondGroupingRow: {
        marginLeft: 10,
        alignment: 'left'
    },

    reportTotalTitle: {
        margin: [0, 5, 2, 2]
    },

    reportLevelsTitle: {
        alignment: 'left',
        margin: [6, 15, 2, 2]
    }

}, _defineProperty(_Object$assign, "reportTotalTitle", {
    margin: [0, 5, 2, 2]
}), _defineProperty(_Object$assign, "reportLeaveTitle", {
    margin: [0, 5, 0, 0]
}), _defineProperty(_Object$assign, "reportFirstGroupingRow", {
    bold: true,
    alignment: 'left',
    fillColor: '#f4f4f4',
    marginLeft: 1
}), _defineProperty(_Object$assign, "reportSecondGroupingRow", {
    marginLeft: 10,
    bold: true,
    alignment: 'left',
    fillColor: '#f6f6f6'
}), _defineProperty(_Object$assign, "chartLegendTotal", {
    alignment: 'left',
    fontSize: 11,
    bold: true
}), _defineProperty(_Object$assign, "chartLegendTotalValue", {
    alignment: 'right',
    fontSize: 11,
    bold: true
}), _defineProperty(_Object$assign, "chartLegendItem", {
    alignment: 'left',
    fontSize: 10
}), _defineProperty(_Object$assign, "chartLegendValue", {
    alignment: 'right',
    fontSize: 10
}), _Object$assign));

/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _BaseTableDataConverter = __webpack_require__(409);

var _BaseTableDataConverter2 = _interopRequireDefault(_BaseTableDataConverter);

var _LeavesReportUtils = __webpack_require__(584);

var _LeavesReportUtils2 = _interopRequireDefault(_LeavesReportUtils);

var _RowType = __webpack_require__(267);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TableDataConverter = function (_BaseTableDataConvert) {
    _inherits(TableDataConverter, _BaseTableDataConvert);

    function TableDataConverter(reportData, reportParams) {
        _classCallCheck(this, TableDataConverter);

        var _this = _possibleConstructorReturn(this, (TableDataConverter.__proto__ || Object.getPrototypeOf(TableDataConverter)).call(this, reportData, reportParams));

        _this.hasPto = _LeavesReportUtils2.default.reportParamsWithPTO(_this.reportParams);
        _this.hasSick = _LeavesReportUtils2.default.reportParamsWithSick(_this.reportParams);
        return _this;
    }

    _createClass(TableDataConverter, [{
        key: "_createHeader",
        value: function _createHeader() {
            return {
                type: _RowType.RowType.HEADER,
                leaveTypeIds: _underscore2.default.pluck(this.reportData["leaveSpent"], "leaveTypeId"),
                // TODO: aT and aP have different format of dates from some reason
                balancesRange: { startDate: this.reportParams.dateRangeSelection.fromDate, endDate: this.reportParams.dateRangeSelection.toDate },
                hasPto: this.hasPto,
                hasSick: this.hasSick
            };
        }
    }, {
        key: "_createDataRow",
        value: function _createDataRow(level, type, groupingType, leavesReportItem) {
            var dataRow = {
                id: leavesReportItem["id"],
                type: type,
                total: leavesReportItem["totalLeaveSpent"],
                leaveTypeTotals: _underscore2.default.pluck(leavesReportItem["leaveSpent"], "leaveSpent")
            };

            var date = leavesReportItem["date"];
            var dateRange = leavesReportItem["dateRange"];
            var ptoBalance = leavesReportItem["ptoBalance"];
            var sickBalance = leavesReportItem["sickBalance"];

            if (this.hasPto) dataRow.ptoBalances = {
                start: ptoBalance ? ptoBalance["balanceForFirstColumn"] : null,
                end: ptoBalance ? ptoBalance["balanceForSecondColumn"] : null
            };
            if (this.hasSick) dataRow.sickBalances = {
                start: sickBalance ? sickBalance["balanceForFirstColumn"] : null,
                end: sickBalance ? sickBalance["balanceForSecondColumn"] : null
            };

            return dataRow;
        }
    }]);

    return TableDataConverter;
}(_BaseTableDataConverter2.default);

exports.default = TableDataConverter;

/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _PDFSettingsPreview = __webpack_require__(585);

var _PDFSettingsPreview2 = _interopRequireDefault(_PDFSettingsPreview);

var _ParametersFormattingStrategy = __webpack_require__(966);

var _ParametersFormattingStrategy2 = _interopRequireDefault(_ParametersFormattingStrategy);

var _PDFPreviewController = __webpack_require__(380);

var _PDFPreviewController2 = _interopRequireDefault(_PDFPreviewController);

var _LeavesReportStore = __webpack_require__(199);

var _LeavesReportStore2 = _interopRequireDefault(_LeavesReportStore);

var _LeaveTypeStore = __webpack_require__(124);

var _LeaveTypeStore2 = _interopRequireDefault(_LeaveTypeStore);

var _ATReportParamsStringBuilder = __webpack_require__(52);

var _ATReportParamsStringBuilder2 = _interopRequireDefault(_ATReportParamsStringBuilder);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PDFPreviewLightboxController = function PDFPreviewLightboxController() {};

PDFPreviewLightboxController.prototype = _.create(_PDFPreviewController2.default.prototype, {

    init: function init(_ref) {
        var lightBoxEl = _ref.lightBoxEl,
            titleEl = _ref.titleEl,
            popupId = _ref.popupId,
            eventNamespace = _ref.eventNamespace,
            productSettingsValidator = _ref.productSettingsValidator,
            reportRightsValidator = _ref.reportRightsValidator;

        this.eventNamespace = eventNamespace;
        _PDFPreviewController2.default.prototype.init.call(this, lightBoxEl, titleEl, popupId);

        this.productSettingsValidator = productSettingsValidator;
        this.reportRightsValidator = reportRightsValidator;

        return this;
    },

    _initPdfSettingsPreview: function _initPdfSettingsPreview(elementsIdPrefix) {
        this.pdfSettingsPreview = new _PDFSettingsPreview2.default((0, _jquery2.default)(this.lightBoxEl).find(".pdfPreviewContainer"), elementsIdPrefix, this.eventNamespace).init();
    },

    _subscribeForEvents: function _subscribeForEvents() {
        var self = this;
        (0, _jquery2.default)(document).on(this.eventNamespace + ".pdfGenerator.start", function () {
            self.onGeneratorStart();
        });
        (0, _jquery2.default)(this.getStore()).on("generatedPDFChange", function () {
            self.onGeneratePDFCompleted();
        });
    },

    cancelAllExportingProcesses: function cancelAllExportingProcesses() {
        this.pdfViewer.interruptPreview();
    },

    onShow: function onShow() {
        this._setTitle(this.createFormattingStrategy(), this._getSelectedParameters());
    },

    createFormattingStrategy: function createFormattingStrategy() {
        return new _ParametersFormattingStrategy2.default().init({
            selectorsData: this._getSelectorsData(),
            dateFormat: this.dateFormat,
            productSettingsValidator: this.productSettingsValidator,
            reportRightsValidator: this.reportRightsValidator,
            reportAuthorizationInfo: ATReportsStore.getReportAuthorizationInfo(),
            reportParamsStringBuilderConstructor: _ATReportParamsStringBuilder2.default
        });
    },

    onGeneratorStart: function onGeneratorStart() {
        this.disableDownloadPDFButton();
        this.pdfSettingsPreview.beforePreviewUpdate();
        this.pdfViewer.showMoire();
    },

    onDownloadPDFBtnClicked: function onDownloadPDFBtnClicked() {
        if (!this.downloadPDFBtnEnabled) return;

        (0, _jquery2.default)(document).trigger(this.eventNamespace + ".downloadPDF");
    },

    onGeneratePDFCompleted: function onGeneratePDFCompleted() {
        this.pdfViewer.showPDF(this.getStore().getGeneratedPDF());
        this.enableDownloadPDFButton();
    },

    getStore: function getStore() {
        return _LeavesReportStore2.default;
    },

    getGeneralStore: function getGeneralStore() {
        return ATReportsStore;
    },

    _getSelectedParameters: function _getSelectedParameters() {
        var reportParams = this.getStore().getReportParams();
        return {
            balanceQualifier: reportParams.balanceQualifier,
            columnsConfig: reportParams.columnsConfig,
            firstGroupingLevel: reportParams.firstGroupingLevel,
            dateParameters: {
                dateRangeSelection: reportParams.dateRangeSelection
            },
            userSelection: reportParams.userSelection,
            leaveTypeSelection: reportParams.leaveTypeSelection
        };
    },

    _getSelectorsData: function _getSelectorsData() {
        var store = this.getGeneralStore();
        return {
            users: store.getVisibleUsers(),
            userGroupsEnabled: store.getUserGroupsEnabled(),
            timeZoneGroupsEnabled: store.getTimeZoneGroupsEnabled(),
            userGroups: store.getUserGroups(),
            timeZoneGroups: store.getTimeZoneGroups(),
            leaveTypesMap: _LeaveTypeStore2.default.getLeaveTypes(),
            manageableUserIds: ATReportsStore.getManageableUserIds()
        };
    }
});

exports.default = PDFPreviewLightboxController;

/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _PDFPreviewLightbox = __webpack_require__(591);

var _PDFPreviewLightbox2 = _interopRequireDefault(_PDFPreviewLightbox);

var _PDFPreviewLightboxController = __webpack_require__(1988);

var _PDFPreviewLightboxController2 = _interopRequireDefault(_PDFPreviewLightboxController);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PDFPreviewLightbox = function PDFPreviewLightbox() {};

PDFPreviewLightbox.prototype = _.create(_PDFPreviewLightbox2.default.prototype, {

    createPDFLightboxController: function createPDFLightboxController(_ref) {
        var lightBoxEl = _ref.lightBoxEl,
            titleEl = _ref.titleEl,
            popupId = _ref.popupId,
            eventNamespace = _ref.eventNamespace;

        return new _PDFPreviewLightboxController2.default().init({
            lightBoxEl: lightBoxEl,
            titleEl: titleEl,
            popupId: popupId,
            eventNamespace: eventNamespace,
            productSettingsValidator: new ATProductSettingsValidator(),
            reportRightsValidator: new ATReportRightsValidator()
        });
    }
});

exports.default = PDFPreviewLightbox;

/***/ }),
/* 973 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _PDFPreviewController = __webpack_require__(380);

var _PDFPreviewController2 = _interopRequireDefault(_PDFPreviewController);

var _PDFSettingsPreview = __webpack_require__(585);

var _PDFSettingsPreview2 = _interopRequireDefault(_PDFSettingsPreview);

var _LeavesReportStore = __webpack_require__(199);

var _LeaveTypeStore = __webpack_require__(124);

var _LeaveTypeStore2 = _interopRequireDefault(_LeaveTypeStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BaseReportPDFPreviewLightboxController = function BaseReportPDFPreviewLightboxController() {};

BaseReportPDFPreviewLightboxController.prototype = _.create(_PDFPreviewController2.default.prototype, {

    init: function init(_ref) {
        var lightBoxEl = _ref.lightBoxEl,
            titleEl = _ref.titleEl,
            popupId = _ref.popupId,
            eventNamespace = _ref.eventNamespace,
            productSettingsValidator = _ref.productSettingsValidator,
            reportRightsValidator = _ref.reportRightsValidator;

        this.eventNamespace = eventNamespace;
        _PDFPreviewController2.default.prototype.init.call(this, lightBoxEl, titleEl, popupId);

        this.productSettingsValidator = productSettingsValidator;
        this.reportRightsValidator = reportRightsValidator;
        return this;
    },

    _initPdfSettingsPreview: function _initPdfSettingsPreview(elementsIdPrefix) {
        this.pdfSettingsPreview = new _PDFSettingsPreview2.default((0, _jquery2.default)(this.lightBoxEl).find(".pdfPreviewContainer"), elementsIdPrefix, this.eventNamespace).init();
    },

    _subscribeForEvents: function _subscribeForEvents() {
        var self = this;
        (0, _jquery2.default)(document).on(this.eventNamespace + ".pdfGenerator.start", function () {
            self.onGeneratorStart();
        });
        (0, _jquery2.default)(this.getStore()).on("generatedPDFChange", function () {
            self.onGeneratePDFCompleted();
        });
    },

    cancelAllExportingProcesses: function cancelAllExportingProcesses() {
        this.pdfViewer.interruptPreview();
    },

    onShow: function onShow() {
        this._setTitle(this.createFormattingStrategy(), this._getSelectedParameters());
    },

    createFormattingStrategy: function createFormattingStrategy() {
        // abstrat
    },

    onGeneratorStart: function onGeneratorStart() {
        this.disableDownloadPDFButton();
        this.pdfSettingsPreview.beforePreviewUpdate();
        this.pdfViewer.showMoire();
    },

    onDownloadPDFBtnClicked: function onDownloadPDFBtnClicked() {
        if (!this.downloadPDFBtnEnabled) return;

        (0, _jquery2.default)(document).trigger(this.eventNamespace + ".downloadPDF");
    },

    onGeneratePDFCompleted: function onGeneratePDFCompleted() {
        this.pdfViewer.showPDF(this.getStore().getGeneratedPDF());
        this.enableDownloadPDFButton();
    },

    getStore: function getStore() {
        return _LeavesReportStore.LeavesReportStore;
    },

    getGeneralStore: function getGeneralStore() {
        return ATReportsStore;
    },

    _getSelectedParameters: function _getSelectedParameters() {
        var reportParams = this.getStore().getReportParams();
        return {
            balanceQualifier: reportParams.balanceQualifier,
            columnsConfig: reportParams.columnsConfig,
            firstGroupingLevel: reportParams.firstGroupingLevel,
            dateParameters: {
                dateRangeSelection: reportParams.dateRangeSelection
            },
            userSelection: reportParams.userSelection,
            leaveTypeSelection: reportParams.leaveTypeSelection
        };
    },

    _getSelectorsData: function _getSelectorsData() {
        var store = this.getGeneralStore();
        return {
            users: store.getVisibleUsers(),
            userGroupsEnabled: store.getUserGroupsEnabled(),
            timeZoneGroupsEnabled: store.getTimeZoneGroupsEnabled(),
            userGroups: store.getUserGroups(),
            timeZoneGroups: store.getTimeZoneGroups(),
            leaveTypesMap: _LeaveTypeStore2.default.getLeaveTypes()
        };
    }
});

exports.default = BaseReportPDFPreviewLightboxController;

/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _BaseReportPDFGenerator = __webpack_require__(975);

var _BaseReportPDFGenerator2 = _interopRequireDefault(_BaseReportPDFGenerator);

var _PDFDefinitionCreator = __webpack_require__(1991);

var _PDFDefinitionCreator2 = _interopRequireDefault(_PDFDefinitionCreator);

var _date_format = __webpack_require__(16);

var _PDFParametersFormattingStrategy = __webpack_require__(1994);

var _PDFParametersFormattingStrategy2 = _interopRequireDefault(_PDFParametersFormattingStrategy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PDFGenerator = function (_BaseReportPDFGenerat) {
    _inherits(PDFGenerator, _BaseReportPDFGenerat);

    function PDFGenerator() {
        _classCallCheck(this, PDFGenerator);

        return _possibleConstructorReturn(this, (PDFGenerator.__proto__ || Object.getPrototypeOf(PDFGenerator)).apply(this, arguments));
    }

    _createClass(PDFGenerator, [{
        key: "init",
        value: function init(store, generalStore, productSettingsValidator, reportRightsValidator) {
            _get(PDFGenerator.prototype.__proto__ || Object.getPrototypeOf(PDFGenerator.prototype), "init", this).call(this, store, generalStore, productSettingsValidator, reportRightsValidator);

            this.docDefinitionCreator = new _PDFDefinitionCreator2.default();
            this.generalStore = generalStore;

            return this;
        }
    }, {
        key: "_getParametersFormattingStrategy",
        value: function _getParametersFormattingStrategy(config) {
            var dateFormatForFileName = new _date_format.DateFormat('yyyy-MM-dd');
            return new _PDFParametersFormattingStrategy2.default().init({
                users: this.generalStore.getVisibleUsers(),
                userGroups: this.generalStore.getUserGroups(),
                timeZoneGroups: this.generalStore.getTimeZoneGroups(),
                dateFormat: config.dateFormat,
                dateFormatForFile: dateFormatForFileName,
                manageableUserIds: ATReportsStore.getManageableUserIds(),
                projectsWithMaIds: ATReportsStore.getProjectsWithMaIds()
            });
        }
    }]);

    return PDFGenerator;
}(_BaseReportPDFGenerator2.default);

exports.default = PDFGenerator;

/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _date_format = __webpack_require__(16);

var _utils = __webpack_require__(164);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var BaseReportPDFGenerator = function () {
    function BaseReportPDFGenerator() {
        _classCallCheck(this, BaseReportPDFGenerator);
    }

    _createClass(BaseReportPDFGenerator, [{
        key: "init",
        value: function init(store, generalStore, productSettingsValidator, reportRightsValidator) {
            this.onGenerateBreaker = { needBreak: false };
            this.store = store;
            this.generalStore = generalStore;
            this.productSettingsValidator = productSettingsValidator;
            this.reportRightsValidator = reportRightsValidator;

            return this;
        }
    }, {
        key: "interruptGeneration",
        value: function interruptGeneration() {
            this.onGenerateBreaker.needBreak = true;
        }
    }, {
        key: "_getCreatePDFDefinitionStrategy",
        value: function _getCreatePDFDefinitionStrategy() {
            return null;
        }
    }, {
        key: "calculateTotalNumberOfPages",
        value: function calculateTotalNumberOfPages(params) {
            return 0;
        }
    }, {
        key: "generatePDF",
        value: function generatePDF() {
            var newBreaker = {
                needBreak: false
            };
            this.onGenerateBreaker = newBreaker;

            var pdfPrintParameters = this.store.getPrintParametersForSave();
            var reportParams = this.store.getReportParams();

            var rows = this.store.getConvertedData();

            var pdfConfig = {
                pdfPrintParameters: pdfPrintParameters,
                pdfData: {
                    tableData: rows
                },
                reportParams: reportParams,
                dateFormat: new _date_format.DateFormat(window.SystemSettings.dateFormat)
            };

            var s = this;
            return new Promise(function (onComplete) {
                onComplete(pdfConfig);
            }).then(function (pdfConfig) {
                return new Promise(function (onComplete, onError) {
                    defer(_.bind(onComplete, this, pdfConfig));
                });
            }).then(function (pdfConfig) {
                if (newBreaker["needBreak"]) {
                    return Promise.reject(new Error("abort"));
                }
                return s._generatePDF(pdfConfig, newBreaker);
            });
        }
    }, {
        key: "_generatePDF",
        value: function _generatePDF(config, breaker) {
            var paramFormattingStrategy = this._getParametersFormattingStrategy(config);

            return this.docDefinitionCreator.createDocDefinition(config, paramFormattingStrategy, this.store).then(function (ddObject) {
                var doc = (0, _utils.createPdf)(ddObject["docDefinition"]);
                var currentFileName = paramFormattingStrategy.formatChartPDFFileName(config.reportParams);

                return new Promise(function (onComplete, onError) {
                    try {
                        doc._createDoc({
                            tableLayouts: ddObject["tableLayouts"]
                        }, function (result, pages) {
                            if (breaker.needBreak) {
                                return onError(new Error("abort"));
                            }

                            onComplete({
                                encodedPDF: result,
                                fileName: currentFileName,
                                pageCount: pages.length
                            });
                        });
                    } catch (e) {
                        onError(e);
                    }
                });
            });
        }
    }]);

    return BaseReportPDFGenerator;
}();

exports.default = BaseReportPDFGenerator;

/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _PDFPreviewLightbox = __webpack_require__(591);

var _PDFPreviewLightbox2 = _interopRequireDefault(_PDFPreviewLightbox);

var _PDFPreviewLightboxController = __webpack_require__(1997);

var _PDFPreviewLightboxController2 = _interopRequireDefault(_PDFPreviewLightboxController);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PDFPreviewLightbox = function (_BaseReportPDFPreview) {
    _inherits(PDFPreviewLightbox, _BaseReportPDFPreview);

    function PDFPreviewLightbox() {
        _classCallCheck(this, PDFPreviewLightbox);

        return _possibleConstructorReturn(this, (PDFPreviewLightbox.__proto__ || Object.getPrototypeOf(PDFPreviewLightbox)).apply(this, arguments));
    }

    _createClass(PDFPreviewLightbox, [{
        key: "createPDFLightboxController",
        value: function createPDFLightboxController(_ref) {
            var lightBoxEl = _ref.lightBoxEl,
                titleEl = _ref.titleEl,
                popupId = _ref.popupId,
                eventNamespace = _ref.eventNamespace;

            return new _PDFPreviewLightboxController2.default().init({
                lightBoxEl: lightBoxEl,
                titleEl: titleEl,
                popupId: popupId,
                eventNamespace: eventNamespace,
                productSettingsValidator: new ATProductSettingsValidator(),
                reportRightsValidator: new ATReportRightsValidator()
            });
        }
    }]);

    return PDFPreviewLightbox;
}(_PDFPreviewLightbox2.default);

exports.default = PDFPreviewLightbox;

/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _BaseReportPDFGenerator = __webpack_require__(975);

var _BaseReportPDFGenerator2 = _interopRequireDefault(_BaseReportPDFGenerator);

var _PDFDefinitionCreator = __webpack_require__(2000);

var _PDFDefinitionCreator2 = _interopRequireDefault(_PDFDefinitionCreator);

var _date_format = __webpack_require__(16);

var _PDFParametersFormattingStrategy = __webpack_require__(2003);

var _PDFParametersFormattingStrategy2 = _interopRequireDefault(_PDFParametersFormattingStrategy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PDFGenerator = function (_BaseReportPDFGenerat) {
    _inherits(PDFGenerator, _BaseReportPDFGenerat);

    function PDFGenerator() {
        _classCallCheck(this, PDFGenerator);

        return _possibleConstructorReturn(this, (PDFGenerator.__proto__ || Object.getPrototypeOf(PDFGenerator)).apply(this, arguments));
    }

    _createClass(PDFGenerator, [{
        key: "init",
        value: function init(store, generalStore, productSettingsValidator, reportRightsValidator) {
            _get(PDFGenerator.prototype.__proto__ || Object.getPrototypeOf(PDFGenerator.prototype), "init", this).call(this, store, generalStore, productSettingsValidator, reportRightsValidator);

            this.docDefinitionCreator = new _PDFDefinitionCreator2.default();

            return this;
        }
    }, {
        key: "_getParametersFormattingStrategy",
        value: function _getParametersFormattingStrategy(config) {
            var dateFormatForFileName = new _date_format.DateFormat('yyyy-MM-dd');
            return new _PDFParametersFormattingStrategy2.default().init({
                cpList: this.generalStore.getCPList(),
                projectsWithMaIds: this.generalStore.getProjectsWithMaIds(),
                dateFormat: config.dateFormat,
                dateFormatForFile: dateFormatForFileName,
                productSettingsValidator: this.productSettingsValidator,
                reportRightsValidator: this.reportRightsValidator
            });
        }
    }]);

    return PDFGenerator;
}(_BaseReportPDFGenerator2.default);

exports.default = PDFGenerator;

/***/ }),
/* 978 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _SpinnerController = __webpack_require__(69);

var _SpinnerController2 = _interopRequireDefault(_SpinnerController);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _ClassicBridge = __webpack_require__(18);

var _ClassicBridge2 = _interopRequireDefault(_ClassicBridge);

var _spin = __webpack_require__(93);

var _spin2 = _interopRequireDefault(_spin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var INDICATION_DELAY_MS = 3000;

function indicateExportingOnButton(button) {
    var content = button.html();
    var spinner = new _spin2.default(_extends({}, _SpinnerController2.default.getDefaultSettings(), { scale: 0.5 }));
    spinner.spin();

    button.addClass("exportInProgress");
    button.empty();
    button.append("<span class='exportSpinner'></span>");
    button.append("<span class='exportProcessingLabel'></span>");
    button.find(".exportSpinner").append(spinner.el);
    button.find(".exportProcessingLabel").append(_messageResource2.default.getMessage("report.config.export.exporting"));
    _ClassicBridge2.default.showSuccessToast(_messageResource2.default.getMessage("report.config.export.toast"));

    setTimeout(function () {
        button.empty();
        button.removeClass("exportInProgress");
        button.append(content);
    }, INDICATION_DELAY_MS);
}

exports.default = indicateExportingOnButton;

/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _ATReportEditConfigController = __webpack_require__(169);

var _ATReportEditConfigController2 = _interopRequireDefault(_ATReportEditConfigController);

var _constants = __webpack_require__(11);

var _features = __webpack_require__(22);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _ColumnsConfig = __webpack_require__(130);

var _OvertimeReportColumnsFormatSelector = __webpack_require__(2008);

var _OvertimeReportColumnsFormatSelector2 = _interopRequireDefault(_OvertimeReportColumnsFormatSelector);

var _OvertimeGroupingSelector = __webpack_require__(2009);

var _OvertimeGroupingSelector2 = _interopRequireDefault(_OvertimeGroupingSelector);

var _CustomCheckbox = __webpack_require__(83);

var _CustomCheckbox2 = _interopRequireDefault(_CustomCheckbox);

var _UserNameFormat = __webpack_require__(17);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OvertimeReportEditConfigController = function (_ReportEditConfigCont) {
    _inherits(OvertimeReportEditConfigController, _ReportEditConfigCont);

    function OvertimeReportEditConfigController() {
        _classCallCheck(this, OvertimeReportEditConfigController);

        return _possibleConstructorReturn(this, (OvertimeReportEditConfigController.__proto__ || Object.getPrototypeOf(OvertimeReportEditConfigController)).apply(this, arguments));
    }

    return OvertimeReportEditConfigController;
}(_ATReportEditConfigController2.default);

exports.default = OvertimeReportEditConfigController;


OvertimeReportEditConfigController.prototype.init = function (config) {
    _ATReportEditConfigController2.default.prototype.init.call(this, config);

    var self = this;
    this.reportAuthorizationInfo = config.reportAuthorizationInfo;
    this.reportParameters = this.makeReportParamsAccordingToFeatures(config.reportParameters);
    this.configChangedCallback = config.changeCallback;
    var configChanged = function configChanged() {
        self.configChanged();
    };

    this.timeFormatSelector = this.initTimeFormatSelector(this.reportParameters.timeFormat, configChanged);

    var groupingLevelsSelection = [this.reportParameters.firstGroupingLevel, this.reportParameters.secondGroupingLevel];
    var ugrEnabled = (0, _features.isEnabled)(_features.Feature.UGR) || this.checkGroupingLevel(_constants.ReportGroupingLevel.USER_GROUP, groupingLevelsSelection);
    var tzgEnabled = (0, _features.isEnabled)(_features.Feature.TZG) || this.checkGroupingLevel(_constants.ReportGroupingLevel.TIME_ZONE_GROUP, groupingLevelsSelection);
    this.groupingSelector = new _OvertimeGroupingSelector2.default().init("reportGroupingSelector", groupingLevelsSelection, ugrEnabled, tzgEnabled, function () {
        self.removeGroupingLevelsSelectionError();
        configChanged();
    });
    (0, _jquery2.default)("#reportConfigDataGroupingRow").show();

    config.additionalCheckboxLabel = _messageResource2.default.getMessage("users_selector.reports.include_users_wo_data");

    var $usernameLabel = (0, _jquery2.default)('.usernameLabel');
    $usernameLabel.toggle(!this.reportAuthorizationInfo.anyOtherUsersAvailable);

    if (this.reportAuthorizationInfo.anyOtherUsersAvailable) {
        this.userSelector = this.makeUserSelector(_extends({}, config, {
            allUsersAvailable: this.reportAuthorizationInfo.allUsersAvailable
        }));
    } else {
        (0, _jquery2.default)('#userSelectorId').hide();
        var user = config.users[0];
        var usernameFormatted = (0, _UserNameFormat.formatLFM)(user.firstName, user.lastName, user.middleName, ", ");
        $usernameLabel.text(usernameFormatted);
    }

    if (!((0, _features.isEnabled)(_features.Feature.OVR) && this.reportAuthorizationInfo.overtimeAvailable || (0, _features.isEnabled)(_features.Feature.LVT))) {
        (0, _jquery2.default)("#columnsFormatFilterRow").hide();
    }

    if ((0, _features.isEnabled)(_features.Feature.OVR) && this.reportAuthorizationInfo.overtimeAvailable) {
        this.makeColumnsConfigSelector(config);
    }

    if ((0, _features.isEnabled)(_features.Feature.LVT)) {
        this.makeShowWorkingAndLeaveTimeCheckbox(config);
        this.showWorkingAndLeaveTimeCheckbox.setState({ checked: this.reportParameters.showWorkingAndLeaveTime });
    }

    return this;
};

OvertimeReportEditConfigController.prototype.getConfig = function () {
    var groupingLevelValues = this.groupingSelector ? this.groupingSelector.getValues() : [_constants.ReportGroupingLevel.USER, _constants.ReportGroupingLevel.NONE];
    return {
        timeFormat: this.timeFormatSelector.getValue(),
        userSelection: this.reportAuthorizationInfo.anyOtherUsersAvailable ? this.userSelector.getSelection() : this.initReportParameters.userSelection,
        firstGroupingLevel: groupingLevelValues[0],
        secondGroupingLevel: groupingLevelValues[1],
        columnsConfig: this.columnsConfigSelector ? this.columnsConfigSelector.getSelectedItem().value : _ColumnsConfig.ColumnsConfig.TIME_BALANCE_ONLY,
        showWorkingAndLeaveTime: this.showWorkingAndLeaveTimeCheckbox ? this.showWorkingAndLeaveTimeCheckbox.isChecked() : false
    };
};

OvertimeReportEditConfigController.prototype.resetConfig = function () {
    this.timeFormatSelector.setActiveItemByValue(this.initReportParameters.timeFormat, true);

    if (this.reportAuthorizationInfo.anyOtherUsersAvailable) this.userSelector.setSelection(this.initReportParameters.userSelection);

    if (this.columnsConfigSelector) {
        this.columnsConfigSelector.setActiveItemByValue(this.initReportParameters.columnsConfig);
    }
    if (this.showWorkingAndLeaveTimeCheckbox) {
        this.showWorkingAndLeaveTimeCheckbox.setState({ checked: this.initReportParameters.showWorkingAndLeaveTime });
    }
    if (this.groupingSelector) this.groupingSelector.setValues([this.initReportParameters.firstGroupingLevel, this.initReportParameters.secondGroupingLevel]);
};

OvertimeReportEditConfigController.prototype.validate = function () {
    this.errors = [];

    if (this.reportAuthorizationInfo.anyOtherUsersAvailable && !this.userSelector.validateIsUserSelected()) this.errors.push(this.possibleErrors.ERROR_EMPTY_USER_SELECTION);

    if (this.groupingSelector && !this.groupingSelector.validate()) this.errors.push(this.possibleErrors.ERROR_IN_GROUPING_LEVELS_SELECTOR);

    return this.errors.length === 0;
};

OvertimeReportEditConfigController.prototype.initErrorsToSectionElsMap = function () {
    var errorsToSectionElsMap = {};
    errorsToSectionElsMap[this.possibleErrors.ERROR_EMPTY_USER_SELECTION] = this.panelEl.find("#userSelectorId");
    errorsToSectionElsMap[this.possibleErrors.ERROR_IN_GROUPING_LEVELS_SELECTOR] = this.panelEl.find(".reportGroupingSelectorContainer");
    return errorsToSectionElsMap;
};

OvertimeReportEditConfigController.prototype.setSelectorsInitStateFromCurrent = function () {
    _ATReportEditConfigController2.default.prototype.setSelectorsInitStateFromCurrent.call(this);

    if (this.reportAuthorizationInfo.anyOtherUsersAvailable) {
        this.userSelector.setInitialValueFromCurrent();
    }
};

OvertimeReportEditConfigController.prototype.makeReportParamsAccordingToFeatures = function (reportParameters) {
    return reportParameters;
};

OvertimeReportEditConfigController.prototype.makeColumnsConfigSelector = function () {
    var _this2 = this;

    this.columnsConfigSelector = new _OvertimeReportColumnsFormatSelector2.default().init(this.reportParameters.columnsConfig, function () {
        var columnsConfig = _this2.columnsConfigSelector.getSelectedItem().value;

        if (_this2.showWorkingAndLeaveTimeCheckbox) {
            _this2.showWorkingAndLeaveTimeCheckbox.setState({
                checked: columnsConfig !== _ColumnsConfig.ColumnsConfig.OVERTIME_ONLY && _this2.showWorkingAndLeaveTimeCheckbox.isChecked(),
                disabled: (0, _features.isEnabled)(_features.Feature.OVR) && columnsConfig === _ColumnsConfig.ColumnsConfig.OVERTIME_ONLY
            });
        }

        _this2.configChanged();
    });

    (0, _jquery2.default)("#columnsFormatFilterTable").show();
};

OvertimeReportEditConfigController.prototype.makeShowWorkingAndLeaveTimeCheckbox = function () {
    var _this3 = this;

    var $checkboxContainer = (0, _jquery2.default)('.showWorkingAndLeaveTimeSection');

    this.showWorkingAndLeaveTimeCheckbox = new _CustomCheckbox2.default({
        label: _messageResource2.default.getMessage('report.overtime.columns_config.show_working_and_leave_time_columns'),
        checkboxAdditionalClass: 'checkboxInput',
        checkmarkAdditionalClass: 'hiddenCheckmark',
        onChange: function onChange() {
            _this3.configChanged();
        }
    }).init($checkboxContainer);

    this.showWorkingAndLeaveTimeCheckbox.setState({
        checked: this.reportParameters.columnsConfig !== _ColumnsConfig.ColumnsConfig.OVERTIME_ONLY && this.showWorkingAndLeaveTimeCheckbox.isChecked(),
        disabled: (0, _features.isEnabled)(_features.Feature.OVR) && this.reportAuthorizationInfo.overtimeAvailable && this.reportParameters.columnsConfig === _ColumnsConfig.ColumnsConfig.OVERTIME_ONLY
    });

    $checkboxContainer.toggleClass('withoutColumnsConfig', !((0, _features.isEnabled)(_features.Feature.OVR) && this.reportAuthorizationInfo.overtimeAvailable && (0, _features.isEnabled)(_features.Feature.LVT)));

    $checkboxContainer.show();
};

/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ReportTimeTrackStatusFilter;

var _ListSelector = __webpack_require__(96);

var _ListSelector2 = _interopRequireDefault(_ListSelector);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _constants = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ReportTimeTrackStatusFilter() {}

ReportTimeTrackStatusFilter.prototype.init = function (id, initValue, onChangeCallback) {
    this.selector = new _ListSelector2.default({
        renderTo: _jquery2.default.find("#" + id)[0],
        menuCls: "ttFilterMenu",
        ctCls: "i"
    });
    var preText = _messageResource2.default.getMessage("report.show") + "&nbsp";
    this.selector.addItems([{
        text: preText + _messageResource2.default.getMessage("report.form.show_both_approved_and_not").toLowerCase(),
        value: _constants.TimeApprovalStatus.BOTH
    }, {
        text: preText + _messageResource2.default.getMessage("report.form.show_only_approved").toLowerCase(),
        value: _constants.TimeApprovalStatus.APPROVED
    }, {
        text: preText + _messageResource2.default.getMessage("report.form.show_only_not_approved").toLowerCase(),
        value: _constants.TimeApprovalStatus.NOT_APPROVED
    }]);

    this.selector.on("change", onChangeCallback);
    this.selector.setActiveItemByValue(initValue, true);
    return this;
};

ReportTimeTrackStatusFilter.prototype.getValue = function () {
    return this.selector.getSelectedItem().value;
};

ReportTimeTrackStatusFilter.prototype.setActiveItemByValue = function (value, suppressChangeEvent) {
    this.selector.setActiveItemByValue(value, suppressChangeEvent);
};

/***/ }),
/* 981 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _ATReportEditConfigController = __webpack_require__(169);

var _ATReportEditConfigController2 = _interopRequireDefault(_ATReportEditConfigController);

var _BudgetGroupingSelector = __webpack_require__(2019);

var _BudgetGroupingSelector2 = _interopRequireDefault(_BudgetGroupingSelector);

var _constants = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BudgetedVsActualReportEditConfigController = function (_ReportEditConfigCont) {
    _inherits(BudgetedVsActualReportEditConfigController, _ReportEditConfigCont);

    function BudgetedVsActualReportEditConfigController() {
        _classCallCheck(this, BudgetedVsActualReportEditConfigController);

        return _possibleConstructorReturn(this, (BudgetedVsActualReportEditConfigController.__proto__ || Object.getPrototypeOf(BudgetedVsActualReportEditConfigController)).apply(this, arguments));
    }

    return BudgetedVsActualReportEditConfigController;
}(_ATReportEditConfigController2.default);

exports.default = BudgetedVsActualReportEditConfigController;


BudgetedVsActualReportEditConfigController.prototype.init = function (config) {
    var _this2 = this;

    _ATReportEditConfigController2.default.prototype.init.call(this, config);

    var reportParameters = this.makeReportParamsAccordingToFeatures(config.reportParameters);
    this.configChangedCallback = config.changeCallback;
    var configChanged = function configChanged() {
        return _this2.configChanged();
    };

    this.timeFormatSelector = this.initTimeFormatSelector(reportParameters.timeFormat, configChanged);

    var groupingLevelsSelection = [reportParameters.firstGroupingLevel, reportParameters.secondGroupingLevel, reportParameters.thirdGroupingLevel, reportParameters.fourthGroupingLevel];

    this.groupingSelector = new _BudgetGroupingSelector2.default().init("reportGroupingSelector", groupingLevelsSelection, EnabledFeatures.BTY || this.checkGroupingLevel(_constants.ReportGroupingLevel.BILLING_TYPE, groupingLevelsSelection), function () {
        _this2.removeGroupingLevelsSelectionError();
        configChanged();
    });

    this.cpSelector = this.makeCPSelector(reportParameters.customersProjectsSelection);

    this.reportAuthorizationInfo = config.reportAuthorizationInfo;

    this.taskRadioGroupSelector = this.initRadioGroupSelector("taskBudgetActualRadioGroupsSelector", "tasksOption", reportParameters.tasksConfig, configChanged);
    this.includeNotStartedTasks_checkbox = (0, _jquery2.default)("#includeNotStartedTasks_checkbox").prop("checked", reportParameters.includeNotStarted).on("change", configChanged);
    this.includeNotBudgetedTasks_checkbox = (0, _jquery2.default)("#includeNotBudgetedTasks_checkbox").prop("checked", reportParameters.includeNotEstimated).on("change", configChanged);
    return this;
};

BudgetedVsActualReportEditConfigController.prototype.getConfig = function () {
    var groupingLevelValues = this.groupingSelector.getValues();
    return {
        timeFormat: this.timeFormatSelector.getValue(),
        tasksConfig: this.taskRadioGroupSelector.getValue(),
        includeNotStarted: this.includeNotStartedTasks_checkbox.is(":checked"),
        includeNotEstimated: this.includeNotBudgetedTasks_checkbox.is(":checked"),
        customersProjectsSelection: this.cpSelector.getCpSelection(),
        firstGroupingLevel: groupingLevelValues[0],
        secondGroupingLevel: groupingLevelValues[1],
        thirdGroupingLevel: groupingLevelValues[2],
        fourthGroupingLevel: groupingLevelValues[3],
        reportAuthorizationInfo: this.reportAuthorizationInfo
    };
};

BudgetedVsActualReportEditConfigController.prototype.resetConfig = function () {
    this.timeFormatSelector.setActiveItemByValue(this.initReportParameters.timeFormat, true);
    this.taskRadioGroupSelector.setItemByValue(this.initReportParameters.tasksConfig);
    this.includeNotStartedTasks_checkbox.prop("checked", this.initReportParameters.includeNotStarted);
    this.includeNotBudgetedTasks_checkbox.prop("checked", this.initReportParameters.includeNotEstimated);
    this.groupingSelector.setValues([this.initReportParameters.firstGroupingLevel, this.initReportParameters.secondGroupingLevel, this.initReportParameters.thirdGroupingLevel, this.initReportParameters.fourthGroupingLevel]);
    this.cpSelector.setSelection(this.initReportParameters.customersProjectsSelection);
};

BudgetedVsActualReportEditConfigController.prototype.setSelectorsInitStateFromCurrent = function () {
    _ATReportEditConfigController2.default.prototype.setSelectorsInitStateFromCurrent.call(this);

    if (this.cpSelector) {
        this.cpSelector.setInitialValueFromCurrent();
    }
};

BudgetedVsActualReportEditConfigController.prototype.validate = function () {
    this.errors = [];

    if (!this.cpSelector.checkSelected()) this.errors.push(this.possibleErrors.ERROR_EMPTY_CP_SELECTION);

    if (!this.groupingSelector.validate()) this.errors.push(this.possibleErrors.ERROR_IN_GROUPING_LEVELS_SELECTOR);

    return this.errors.length === 0;
};

BudgetedVsActualReportEditConfigController.prototype.initErrorsToSectionElsMap = function () {
    var errorsToSectionElsMap = {};
    errorsToSectionElsMap[this.possibleErrors.ERROR_EMPTY_CP_SELECTION] = this.panelEl.find("#cpSelectorId");
    errorsToSectionElsMap[this.possibleErrors.ERROR_IN_GROUPING_LEVELS_SELECTOR] = this.panelEl.find(".reportGroupingSelectorContainer");
    return errorsToSectionElsMap;
};

/***/ }),
/* 982 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = GroupingSelectorWithDetailsLevel;

var _GroupingSelector = __webpack_require__(322);

var _GroupingSelector2 = _interopRequireDefault(_GroupingSelector);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function GroupingSelectorWithDetailsLevel() {
    this.constructor = GroupingSelectorWithDetailsLevel;
}

GroupingSelectorWithDetailsLevel.prototype = _underscore2.default.create(_GroupingSelector2.default.prototype);

/**
 * Initializes selector
 * @param selectorId
 * @param numberOfLevels - a number of grouping levels (details level must not be counted), 3 levels max
 * @param initialValues - an array containing initial values
 * @param changesCallback
 */
GroupingSelectorWithDetailsLevel.prototype.init = function (selectorId, numberOfLevels, initialValues, changesCallback) {
    _GroupingSelector2.default.prototype.init.call(this, selectorId, numberOfLevels, initialValues, changesCallback);

    this.updateDetailsOptions();
};

GroupingSelectorWithDetailsLevel.prototype.initListSelectors = function (numberOfLevels, initialValues, changesCallback) {
    _GroupingSelector2.default.prototype.initListSelectors.call(this, numberOfLevels, initialValues, changesCallback);

    var self = this;
    this.detailsListSelector = this.initListSelector(numberOfLevels, initialValues[numberOfLevels], function () {
        self.onDetailsChange();
        if (changesCallback) changesCallback();
    });
};

GroupingSelectorWithDetailsLevel.prototype.onGroupingChange = function () {
    this.updateDetailsOptions();
    _GroupingSelector2.default.prototype.onGroupingChange.call(this);
};

GroupingSelectorWithDetailsLevel.prototype.onDetailsChange = function () {
    this.updateTree();
};

GroupingSelectorWithDetailsLevel.prototype.getDetailsListSelectorValue = function () {
    return this.detailsListSelector.getSelectedItem().value;
};

GroupingSelectorWithDetailsLevel.prototype.updateDetailsOptions = function () {
    // do nothing
};

GroupingSelectorWithDetailsLevel.prototype.getValues = function () {
    var selection = _GroupingSelector2.default.prototype.getValues.call(this);
    selection.push(this.getDetailsListSelectorValue());
    return selection;
};

GroupingSelectorWithDetailsLevel.prototype.setValues = function (values) {
    var valuesCopy = values.slice();
    var detailsValue = valuesCopy.pop();
    _GroupingSelector2.default.prototype.setValues.call(this, valuesCopy);
    this.detailsListSelector.setActiveItemByValue(detailsValue);
};

/***/ }),
/* 983 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _constants = __webpack_require__(11);

var _LeaveReportConfig = __webpack_require__(129);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _LeavesReportEditConfigController = __webpack_require__(594);

var _LeavesReportEditConfigController2 = _interopRequireDefault(_LeavesReportEditConfigController);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LeavesEditFormConfigController = function (_LeavesReportEditConf) {
    _inherits(LeavesEditFormConfigController, _LeavesReportEditConf);

    function LeavesEditFormConfigController() {
        _classCallCheck(this, LeavesEditFormConfigController);

        return _possibleConstructorReturn(this, (LeavesEditFormConfigController.__proto__ || Object.getPrototypeOf(LeavesEditFormConfigController)).apply(this, arguments));
    }

    return LeavesEditFormConfigController;
}(_LeavesReportEditConfigController2.default);

exports.default = LeavesEditFormConfigController;


LeavesEditFormConfigController.prototype.makeReportParamsAccordingToFeatures = function (reportParameters) {
    var result = _jquery2.default.extend({}, reportParameters);

    var isEnabledPTO = this.productSettingsValidator.isPTOEnabled();
    var isEnabledSick = this.productSettingsValidator.isSickEnabled();

    if (!isEnabledPTO && reportParameters.balanceQualifier !== _LeaveReportConfig.LeaveTypeBalanceQualifier.SICK_DAYS_ONLY) {
        result.balanceQualifier = _LeaveReportConfig.LeaveTypeBalanceQualifier.SICK_DAYS_ONLY;
    }
    if (!isEnabledSick && reportParameters.balanceQualifier !== _LeaveReportConfig.LeaveTypeBalanceQualifier.PTO_ONLY) {
        result.balanceQualifier = _LeaveReportConfig.LeaveTypeBalanceQualifier.PTO_ONLY;
    }

    if (!isEnabledPTO && !isEnabledSick || !result.balanceQualifier) {
        result.columnsConfig = _LeaveReportConfig.LeaveTypeColumnConfig.LEAVE_TIME_ONLY;
    }
    if (!this.productSettingsValidator.isUGREnabled()) {
        var groupings = this.makeGroupingSelectorValuesAccordingToNotAvailableValueLevel(_constants.ReportGroupingLevel.USER_GROUP, [result.firstGroupingLevel, result.secondGroupingLevel], _constants.ReportGroupingLevel.USER);
        result.firstGroupingLevel = groupings[0];
        result.secondGroupingLevel = groupings[1];
    }
    return result;
};

/***/ }),
/* 984 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = BaseColumnsStrategy;

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function BaseColumnsStrategy() {}

BaseColumnsStrategy.prototype.init = function () {
    return this;
};

BaseColumnsStrategy.prototype.addCell = function (row, notEscapedContent, className, colSpan, rowSpan) {
    ReportPreviewUtils.addCell(row, notEscapedContent, className, colSpan, rowSpan);
};

BaseColumnsStrategy.prototype.addCreatedCell = function (row, cell) {
    ReportPreviewUtils.addCreatedCell(row, cell);
};

BaseColumnsStrategy.prototype.message = function (key, params) {
    return _messageResource2.default.getMessage(key, params);
};

BaseColumnsStrategy.prototype.addTimeValueCell = function (row, className) {
    row.appendChild(this.createTimeValueCell(className));
};

BaseColumnsStrategy.prototype.addMoneyValueCell = function (row, className) {
    this.addCell(row, SystemSettings.currencySign, "moneyValueCell " + (className ? className : ""));
};

BaseColumnsStrategy.prototype.createTimeValueCell = function (className) {
    // abstract
};

BaseColumnsStrategy.prototype.makeTimeValue = function () {
    // abstract
};

/***/ }),
/* 985 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = LeaveHTMLPreviewBaseSection;

var _PreviewSection = __webpack_require__(67);

var _PreviewSection2 = _interopRequireDefault(_PreviewSection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function LeaveHTMLPreviewBaseSection() {}

LeaveHTMLPreviewBaseSection.prototype = new _PreviewSection2.default();

LeaveHTMLPreviewBaseSection.prototype.init = function (columnsStrategy) {
    _PreviewSection2.default.prototype.init.call(this);
    this.columnsStrategy = columnsStrategy;
    return this;
};

LeaveHTMLPreviewBaseSection.prototype.createRowWithMainAndDataCells = function (rowClassName, mainCellInnerHtml, mainCellClassName) {
    var row = this.createRow(rowClassName);
    this.addCell(row, mainCellInnerHtml, mainCellClassName);
    this.columnsStrategy.addDataCells(row);
    return row;
};

/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = LeaveCSVPreviewBalanceColumnsRender;

var _LeaveReportConfig = __webpack_require__(129);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function LeaveCSVPreviewBalanceColumnsRender() {}

LeaveCSVPreviewBalanceColumnsRender.prototype.init = function (balanceQualifier) {

    this.isNeedSickDays = balanceQualifier === _LeaveReportConfig.LeaveTypeBalanceQualifier.SICK_DAYS_ONLY || balanceQualifier === _LeaveReportConfig.LeaveTypeBalanceQualifier.PTO_AND_SICK_DAYS;
    this.isNeedPTODays = balanceQualifier === _LeaveReportConfig.LeaveTypeBalanceQualifier.PTO_ONLY || balanceQualifier === _LeaveReportConfig.LeaveTypeBalanceQualifier.PTO_AND_SICK_DAYS;
    return this;
};

LeaveCSVPreviewBalanceColumnsRender.prototype.addHeaderBalancesCells = function (row) {
    if (this.isNeedPTODays) {
        this._addBalanceCells("report.leaves.pto_column.preview.csv.date_range.pto", SystemSettings.showPTOInHours, row);
    }
    if (this.isNeedSickDays) {
        this._addBalanceCells("report.leaves.pto_column.preview.csv.date_range.sick_days", SystemSettings.showSickInHours, row);
    }
};

LeaveCSVPreviewBalanceColumnsRender.prototype.getNumberOfDataBalancesCells = function () {
    var num = 0;
    if (this.isNeedPTODays) {
        num += 2;
    }
    if (this.isNeedSickDays) {
        num += 2;
    }
    return num;
};

LeaveCSVPreviewBalanceColumnsRender.prototype._addBalanceCells = function (balanceLabelKey, inHours, row) {
    ReportPreviewUtils.addCreatedCell(row, ReportPreviewUtils.createCell(_messageResource2.default.getMessage(balanceLabelKey, [_messageResource2.default.getMessage("report.leaves.pto_column.beginning_date"), this._getHoursOrDaysMessage(inHours)])));

    ReportPreviewUtils.addCreatedCell(row, ReportPreviewUtils.createCell(_messageResource2.default.getMessage(balanceLabelKey, [_messageResource2.default.getMessage("report.leaves.pto_column.ending_date"), this._getHoursOrDaysMessage(inHours)])));
};

LeaveCSVPreviewBalanceColumnsRender.prototype._getHoursOrDaysMessage = function (inHours) {
    if (inHours) {
        return _messageResource2.default.getMessage("common.pto_units.hours");
    } else {
        return _messageResource2.default.getMessage("common.pto_units.days");
    }
};

/***/ }),
/* 987 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = BaseTasksEvAHTMLPreviewStrategy;

var _HTMLColumnsStrategy = __webpack_require__(270);

var _HTMLColumnsStrategy2 = _interopRequireDefault(_HTMLColumnsStrategy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function BaseTasksEvAHTMLPreviewStrategy() {}

BaseTasksEvAHTMLPreviewStrategy.prototype = new _HTMLColumnsStrategy2.default();

BaseTasksEvAHTMLPreviewStrategy.prototype.init = function (timeFormat) {
    _HTMLColumnsStrategy2.default.prototype.init.call(this, timeFormat);
    return this;
};

BaseTasksEvAHTMLPreviewStrategy.prototype.getLevelsNumber = function () {
    // abstract
};

BaseTasksEvAHTMLPreviewStrategy.prototype.getColumnsNumber = function () {
    // abstract
};

BaseTasksEvAHTMLPreviewStrategy.prototype.addFirstHeaderRowCells = function (row) {
    // abstract
};

BaseTasksEvAHTMLPreviewStrategy.prototype.addSecondHeaderRowCells = function (row) {
    // abstract
};

BaseTasksEvAHTMLPreviewStrategy.prototype.addThirdHeaderRowCells = function (row) {
    // abstract
};

BaseTasksEvAHTMLPreviewStrategy.prototype.addColumnValues = function (row) {
    for (var i = 0; i < this.getColumnsNumber() - 1; i++) {
        this.addTimeValueCell(row);
    }this.addPercentValueCell(row);
};

BaseTasksEvAHTMLPreviewStrategy.prototype.addEmptyColumns = function (row) {
    for (var i = 0; i < this.getColumnsNumber(); i++) {
        ReportPreviewUtils.addEmptyCell(row);
    }
};

BaseTasksEvAHTMLPreviewStrategy.prototype.addPercentValueCell = function (row) {
    ReportPreviewUtils.addCell(row, "%", "percent");
};

/***/ }),
/* 988 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _ATReportEditConfigController = __webpack_require__(169);

var _ATReportEditConfigController2 = _interopRequireDefault(_ATReportEditConfigController);

var _features = __webpack_require__(22);

var _constants = __webpack_require__(11);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _constants2 = __webpack_require__(4);

var _StaffoutputColumnsFormatSelector = __webpack_require__(2052);

var _StaffoutputColumnsFormatSelector2 = _interopRequireDefault(_StaffoutputColumnsFormatSelector);

var _ThreeLevelReportGroupingSelector = __webpack_require__(323);

var _ThreeLevelReportGroupingSelector2 = _interopRequireDefault(_ThreeLevelReportGroupingSelector);

var _SimpleTooltip = __webpack_require__(36);

var _SimpleTooltip2 = _interopRequireDefault(_SimpleTooltip);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _CustomCheckbox = __webpack_require__(83);

var _CustomCheckbox2 = _interopRequireDefault(_CustomCheckbox);

var _UserNameFormat = __webpack_require__(17);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var StaffOutputReportEditConfigController = function (_ReportEditConfigCont) {
    _inherits(StaffOutputReportEditConfigController, _ReportEditConfigCont);

    function StaffOutputReportEditConfigController() {
        _classCallCheck(this, StaffOutputReportEditConfigController);

        return _possibleConstructorReturn(this, (StaffOutputReportEditConfigController.__proto__ || Object.getPrototypeOf(StaffOutputReportEditConfigController)).apply(this, arguments));
    }

    return StaffOutputReportEditConfigController;
}(_ATReportEditConfigController2.default);

exports.default = StaffOutputReportEditConfigController;


StaffOutputReportEditConfigController.prototype.init = function (config) {
    _ATReportEditConfigController2.default.prototype.init.call(this, config);

    var self = this;
    this.reportAuthorizationInfo = config.reportAuthorizationInfo;
    this.showUserSelector = this.reportAuthorizationInfo.anyOtherUsersAvailable || this.reportAuthorizationInfo.allUsersAvailable;

    var reportParameters = this.makeReportParamsAccordingToFeatures(config.reportParameters);

    this.configChangedCallback = config.changeCallback;
    var configChanged = function configChanged() {
        self.configChanged();
    };

    // if feature enabled otherwise only if value is not "users only" - show selector
    this.columnFormatSelector = this.addColumnFormatFilter(reportParameters.columnsConfig, configChanged);

    // if feature enabled otherwise only if value is not "both" - show selector
    this.approvedTTFilter = this.addApprovedTTFilter(reportParameters.timeApprovalStatus, configChanged);

    this.timeFormatSelector = this.initTimeFormatSelector(reportParameters.timeFormat, configChanged);

    this.cpSelector = this.makeCPSelector(reportParameters.customersProjectsSelection);

    var groupingLevelsSelection = [reportParameters.firstGroupingLevel, reportParameters.secondGroupingLevel, reportParameters.thirdGroupingLevel];
    this.groupingSelector = new _ThreeLevelReportGroupingSelector2.default().init({
        selectorId: "reportGroupingSelector",
        enableNoneFirstGrouping: false,
        enableGroupByBillingType: (0, _features.isEnabled)(_features.Feature.BTY) || this.checkGroupingLevel(_constants.ReportGroupingLevel.BILLING_TYPE, groupingLevelsSelection),
        enableGroupByUsers: false,
        enableGroupByUserGroups: false,
        includeTTCommentsInDetailsLevel: false,
        groupingLevelsSelection: groupingLevelsSelection,
        changesCallback: function changesCallback() {
            self.removeGroupingLevelsSelectionError();
            configChanged();
        }
    });

    // if feature enabled or checkbox is selected
    if (this.verifyIsShowLeavesCheckbox(reportParameters)) {
        (0, _jquery2.default)("#leavesCheckbox").show();
        this.showLeaveTimeChexbox = (0, _jquery2.default)("#showLeavesCheckbox");
        this.showLeaveTimeChexbox.prop("checked", reportParameters.showLeaveTime);
        this.showLeaveTimeChexbox.on("change", configChanged);
    }

    var $usernameLabel = (0, _jquery2.default)('.usernameLabel');
    $usernameLabel.toggle(!this.showUserSelector);

    if (this.showUserSelector) this.userSelector = this.makeUserSelector(_extends({}, config, {
        allUsersAvailable: config.reportAuthorizationInfo.allUsersAvailable
    }));else {
        (0, _jquery2.default)('#userSelectorId').hide();
        var user = config.users[0];
        var usernameFormatted = (0, _UserNameFormat.formatLFM)(user.firstName, user.lastName, user.middleName, ", ");
        $usernameLabel.text(usernameFormatted);
    }

    this.makeShowOtherUsersCheckbox(reportParameters.includeOtherUsersColumn, configChanged);

    return this;
};

/**
 * add column format filter if need
 * @param initValue
 * @param onChangeCallback
 * @returns {{getValue, setActiveItemByValue}}
 */
StaffOutputReportEditConfigController.prototype.addColumnFormatFilter = function (initValue, onChangeCallback) {
    var ifNeedColumnFormatSelector = (0, _features.isEnabled)(_features.Feature.UGR) || (0, _features.isEnabled)(_features.Feature.TZG) || initValue !== _constants2.StaffPerformanceColumnsConfig.USERS_ONLY;
    var $columnsFormatFilter = (0, _jquery2.default)("#columnsFormatFilterRow");
    if (ifNeedColumnFormatSelector) {
        $columnsFormatFilter.show();
        return new _StaffoutputColumnsFormatSelector2.default().init("columnsDisplayFormat", initValue, onChangeCallback);
    } else {
        $columnsFormatFilter.hide();
        return this.initEmptyListSelector(initValue);
    }
};

StaffOutputReportEditConfigController.prototype.makeShowOtherUsersCheckbox = function (includeOtherUsersColumn, onChangeCallback) {
    var $checkboxContainer = (0, _jquery2.default)(".showOtherUsersCheckboxRow");
    $checkboxContainer.toggle(!this.reportAuthorizationInfo.allUsersAvailable);

    if (!this.reportAuthorizationInfo.allUsersAvailable) {
        var labelText = this.reportAuthorizationInfo.anyOtherUsersAvailable ? _messageResource2.default.getMessage('report.common.include_not_assigned_users') : _messageResource2.default.getMessage('report.common.include_other_users');

        this.showOtherUsersCheckbox = new _CustomCheckbox2.default({
            label: labelText,
            checkboxAdditionalClass: 'checkboxInput',
            checkmarkAdditionalClass: 'hiddenCheckmark',
            onChange: function onChange() {
                return onChangeCallback();
            }
        }).init($checkboxContainer);

        this.showOtherUsersCheckbox.setState({ checked: includeOtherUsersColumn });

        this.showOtherUsersCheckboxTooltip = new _SimpleTooltip2.default({
            text: _messageResource2.default.getMessage('report.common.show_other_users_checkbox_tooltip_text')
        }).init((0, _jquery2.default)('body'));
        this.showOtherUsersCheckboxTooltip.subscribeToMouseEvents(this.showOtherUsersCheckbox.getEl());

        this._updateIncludeOtherUsersCheckbox();
    }
};

StaffOutputReportEditConfigController.prototype._updateIncludeOtherUsersCheckbox = function () {
    if (this.showOtherUsersCheckbox) {
        var disabled = !!this.userSelector && this.userSelector.getSelection().allUsers !== true;
        this.showOtherUsersCheckbox.setState({
            checked: !disabled && this.showOtherUsersCheckbox.isChecked(),
            disabled: disabled
        });

        this.showOtherUsersCheckboxTooltip.setEnabled(disabled);
    }
};

StaffOutputReportEditConfigController.prototype.updateUI = function (blinkError) {
    _ATReportEditConfigController2.default.prototype.updateUI.call(this, blinkError);
    this._updateIncludeOtherUsersCheckbox();
};

StaffOutputReportEditConfigController.prototype.verifyIsShowLeavesCheckbox = function (reportParameters) {
    return this.reportAuthorizationInfo.leavesAvailable && ((0, _features.isEnabled)(_features.Feature.LVT) || reportParameters.showLeaveTime);
};

StaffOutputReportEditConfigController.prototype.getConfig = function () {
    var groupingLevelValues = this.groupingSelector.getValues();
    var needSwitchToMe = !this.showUserSelector;
    return {
        columnsConfig: this.columnFormatSelector.getValue(),
        timeFormat: this.timeFormatSelector.getValue(),
        timeApprovalStatus: this.approvedTTFilter.getValue(),
        userSelection: this.showUserSelector ? this.userSelector.getSelection() : this.initReportParameters.userSelection,
        firstGroupingLevel: groupingLevelValues[0],
        secondGroupingLevel: groupingLevelValues[1],
        thirdGroupingLevel: groupingLevelValues[2],
        customersProjectsSelection: this.cpSelector.getCpSelection(),
        showLeaveTime: !!this.showLeaveTimeChexbox && this.showLeaveTimeChexbox.is(":checked"),
        includeOtherUsersColumn: !!this.showOtherUsersCheckbox && this.showOtherUsersCheckbox.isChecked(),
        needSwitchToMe: needSwitchToMe
    };
};

StaffOutputReportEditConfigController.prototype.resetConfig = function () {
    this.columnFormatSelector.setActiveItemByValue(this.initReportParameters.columnsConfig, true);
    this.timeFormatSelector.setActiveItemByValue(this.initReportParameters.timeFormat, true);
    this.approvedTTFilter.setActiveItemByValue(this.initReportParameters.timeApprovalStatus, true);

    if (this.showUserSelector) this.userSelector.setSelection(this.initReportParameters.userSelection);

    this.groupingSelector.setValues([this.initReportParameters.firstGroupingLevel, this.initReportParameters.secondGroupingLevel, this.initReportParameters.thirdGroupingLevel]);
    this.cpSelector.setSelection(this.initReportParameters.customersProjectsSelection);
    if (this.showLeaveTimeChexbox) {
        this.showLeaveTimeChexbox.prop("checked", this.initReportParameters.showLeaveTime);
    }
    if (this.showOtherUsersCheckbox) {
        this.showOtherUsersCheckbox.setState({ checked: this.initReportParameters.includeOtherUsersColumn });
    }
};

StaffOutputReportEditConfigController.prototype.setSelectorsInitStateFromCurrent = function () {
    _ATReportEditConfigController2.default.prototype.setSelectorsInitStateFromCurrent.call(this);

    if (this.showUserSelector) {
        this.userSelector.setInitialValueFromCurrent();
    }
    if (this.cpSelector) {
        this.cpSelector.setInitialValueFromCurrent();
    }
};

StaffOutputReportEditConfigController.prototype.validate = function () {
    this.errors = [];

    if (this.showUserSelector && !this.userSelector.validateIsUserSelected()) this.errors.push(this.possibleErrors.ERROR_EMPTY_USER_SELECTION);

    if (!this.cpSelector.checkSelected()) this.errors.push(this.possibleErrors.ERROR_EMPTY_CP_SELECTION);

    if (!this.groupingSelector.validate()) this.errors.push(this.possibleErrors.ERROR_IN_GROUPING_LEVELS_SELECTOR);

    return this.errors.length === 0;
};

StaffOutputReportEditConfigController.prototype.initErrorsToSectionElsMap = function () {
    var errorsToSectionElsMap = {};
    errorsToSectionElsMap[this.possibleErrors.ERROR_EMPTY_USER_SELECTION] = this.panelEl.find("#userSelectorId");
    errorsToSectionElsMap[this.possibleErrors.ERROR_EMPTY_CP_SELECTION] = this.panelEl.find("#cpSelectorId");
    errorsToSectionElsMap[this.possibleErrors.ERROR_IN_GROUPING_LEVELS_SELECTOR] = this.panelEl.find(".reportGroupingSelectorContainer");
    return errorsToSectionElsMap;
};

StaffOutputReportEditConfigController.prototype.makeReportParamsAccordingToFeatures = function (reportParameters) {
    return reportParameters;
};

/***/ }),
/* 989 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = StaffPerformanceHTMLPreviewUsersByGroupsBaseColumnsStrategy;

var _StaffPerformanceHTMLPreviewBaseColumnsStrategy = __webpack_require__(598);

var _StaffPerformanceHTMLPreviewBaseColumnsStrategy2 = _interopRequireDefault(_StaffPerformanceHTMLPreviewBaseColumnsStrategy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function StaffPerformanceHTMLPreviewUsersByGroupsBaseColumnsStrategy() {}

StaffPerformanceHTMLPreviewUsersByGroupsBaseColumnsStrategy.prototype = new _StaffPerformanceHTMLPreviewBaseColumnsStrategy2.default();

StaffPerformanceHTMLPreviewUsersByGroupsBaseColumnsStrategy.prototype.init = function (timeFormat, groupNameProvider, includeOtherUsersColumn) {
    _StaffPerformanceHTMLPreviewBaseColumnsStrategy2.default.prototype.init.call(this, timeFormat, groupNameProvider);
    this.includeOtherUsersColumn = includeOtherUsersColumn;
    return this;
};

StaffPerformanceHTMLPreviewUsersByGroupsBaseColumnsStrategy.prototype.addFirstHeaderRowCells = function (firstHeaderRow) {
    this.addCreatedCell(firstHeaderRow, this.createSpentHeaderCell());
    this.addCell(firstHeaderRow, this.getGroupNameSingular(), "userGroup", this.getDepartmentHeaderColumnWidth(), 1);
    if (this.includeOtherUsersColumn) {
        this.addCreatedCell(firstHeaderRow, this.createOthersHeaderCell(2));
    }
};

StaffPerformanceHTMLPreviewUsersByGroupsBaseColumnsStrategy.prototype.getDepartmentHeaderColumnWidth = function () {
    // abstract
};

/***/ }),
/* 990 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _GroupMessageProvider2 = __webpack_require__(991);

var _GroupMessageProvider3 = _interopRequireDefault(_GroupMessageProvider2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UserGroupMessageProvider = function (_GroupMessageProvider) {
    _inherits(UserGroupMessageProvider, _GroupMessageProvider);

    function UserGroupMessageProvider() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, UserGroupMessageProvider);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = UserGroupMessageProvider.__proto__ || Object.getPrototypeOf(UserGroupMessageProvider)).call.apply(_ref, [this].concat(args))), _this), _this.getGroupNameSingularKey = function () {
            return "common.User_Group";
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    return UserGroupMessageProvider;
}(_GroupMessageProvider3.default);

exports.default = UserGroupMessageProvider;

/***/ }),
/* 991 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var GroupMessageProvider = function GroupMessageProvider() {
    _classCallCheck(this, GroupMessageProvider);

    this.getGroupNameSingularKey = function () {
        //abstract
    };
};

exports.default = GroupMessageProvider;

/***/ }),
/* 992 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _GroupMessageProvider2 = __webpack_require__(991);

var _GroupMessageProvider3 = _interopRequireDefault(_GroupMessageProvider2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TimeZoneGroupMessageProvider = function (_GroupMessageProvider) {
    _inherits(TimeZoneGroupMessageProvider, _GroupMessageProvider);

    function TimeZoneGroupMessageProvider() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, TimeZoneGroupMessageProvider);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TimeZoneGroupMessageProvider.__proto__ || Object.getPrototypeOf(TimeZoneGroupMessageProvider)).call.apply(_ref, [this].concat(args))), _this), _this.getGroupNameSingularKey = function () {
            return "common.Time_Zone_Group";
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    return TimeZoneGroupMessageProvider;
}(_GroupMessageProvider3.default);

exports.default = TimeZoneGroupMessageProvider;

/***/ }),
/* 993 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _ATReportEditConfigController = __webpack_require__(169);

var _ATReportEditConfigController2 = _interopRequireDefault(_ATReportEditConfigController);

var _TTDetailsReportGroupingSelector = __webpack_require__(2071);

var _TTDetailsReportGroupingSelector2 = _interopRequireDefault(_TTDetailsReportGroupingSelector);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _constants = __webpack_require__(11);

var _ListSelector = __webpack_require__(96);

var _ListSelector2 = _interopRequireDefault(_ListSelector);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _UserNameFormat = __webpack_require__(17);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TTDetailReportEditConfigController = function (_ReportEditConfigCont) {
    _inherits(TTDetailReportEditConfigController, _ReportEditConfigCont);

    function TTDetailReportEditConfigController() {
        _classCallCheck(this, TTDetailReportEditConfigController);

        return _possibleConstructorReturn(this, (TTDetailReportEditConfigController.__proto__ || Object.getPrototypeOf(TTDetailReportEditConfigController)).apply(this, arguments));
    }

    return TTDetailReportEditConfigController;
}(_ATReportEditConfigController2.default);

exports.default = TTDetailReportEditConfigController;


TTDetailReportEditConfigController.groupingLevels = {
    NO_GROUPING: 0,
    ONE_LEVEL: 1,
    TWO_LEVELS: 2,
    THREE_LEVELS: 3
};

TTDetailReportEditConfigController.prototype.init = function (config) {
    _ATReportEditConfigController2.default.prototype.init.call(this, config);

    this.reportAuthorizationInfo = config.reportAuthorizationInfo;
    var reportParameters = this.makeReportParamsAccordingToFeatures(config.reportParameters);

    var self = this;
    this.configChangedCallback = config.changeCallback;
    var configChanged = function configChanged() {
        self.configChanged();
    };

    this.timeFormatSelector = this.initListSelector("timeFormatSelect", reportParameters.timeFormat, configChanged);

    var groupingSelection = [reportParameters.firstGroupingLevel, reportParameters.secondGroupingLevel, reportParameters.thirdGroupingLevel];

    this.groupingSelector = new _TTDetailsReportGroupingSelector2.default().init("reportGroupingSelector", groupingSelection, function () {
        self.removeGroupingLevelsSelectionError();
        self.joinCommentsCheckbox.activate(self._checkIfNeedDisableJoinCommentsCheckbox());
        configChanged();
    });

    // init list selector
    this.numberOfGroupingLevelsSelector = this._initNumberOfGroupingLevelsListSelector("numberOfGroupingLevelsSelect", this.groupingSelector.calculateNumberOfVisibleLevels(groupingSelection), function () {
        var numberOfGroupingLevels = self.numberOfGroupingLevelsSelector.getSelectedItem().value;
        self.groupingSelector.setNumberOfVisibleLevels(numberOfGroupingLevels);

        self.removeGroupingLevelsSelectionError();
        // change state of checkbox
        self.joinCommentsCheckbox.activate(self._checkIfNeedDisableJoinCommentsCheckbox());
        configChanged();
    });

    this.joinCommentsCheckbox = (0, _jquery2.default)("#joinComments");
    // disable checkbox or activate with previous value
    this.joinCommentsCheckbox.activate = function (isDisable) {
        if (isDisable) {
            if (!this.prop("disabled")) {
                this.prevValue = this.prop("checked");
                this.prop("checked", false);
                this.prop("disabled", true);
            }
        } else {
            if (this.prop("disabled")) {
                this.prop("checked", this.prevValue);
            }
            this.prop("disabled", false);
        }
    };
    this.joinCommentsCheckbox.on("change", function () {
        configChanged();
    });
    // set value
    this.joinCommentsCheckbox.prop("checked", reportParameters.joinCommentsByTask);
    // than activate checkbox
    this.joinCommentsCheckbox.activate(this._checkIfNeedDisableJoinCommentsCheckbox());

    config.needAdditionalCheckbox = false;

    var $usernameLabel = (0, _jquery2.default)('.usernameLabel');
    var showUserSelector = this.reportAuthorizationInfo.anyOtherUsersAvailable || this.reportAuthorizationInfo.allUsersAvailable;
    $usernameLabel.toggle(!showUserSelector);

    if (showUserSelector) this.userSelector = this.makeUserSelector(_extends({}, config, {
        allUsersAvailable: this.reportAuthorizationInfo.allUsersAvailable
    }));else {
        (0, _jquery2.default)('#userSelectorId').hide();
        var user = config.users[0];
        var usernameFormatted = (0, _UserNameFormat.formatLFM)(user.firstName, user.lastName, user.middleName, ", ");
        $usernameLabel.text(usernameFormatted);
    }

    this.approvedTTFilter = this.addApprovedTTFilter(reportParameters.timeApprovalStatus, configChanged);

    this.cpSelector = this.makeCPSelector(reportParameters.customersProjectsSelection);

    return this;
};

/**
 * Return true if need disable join comments checkbox (if DAY && USER (disable  joinComments checkbox) or if n grouping levels = 0)
 * return  true if need disable or false otherwise
 * @returns {boolean|*}
 * @private
 */
TTDetailReportEditConfigController.prototype._checkIfNeedDisableJoinCommentsCheckbox = function () {
    var numberOfGroupingLevels = this.numberOfGroupingLevelsSelector.getValue();
    var values = this.groupingSelector.getValues(); // get grouping selection

    return numberOfGroupingLevels === TTDetailReportEditConfigController.groupingLevels.NO_GROUPING || this.checkGroupingLevel(_constants.ReportGroupingLevel.USER, values) && this.checkGroupingLevel(_constants.ReportGroupingLevel.DATE, values);
};

TTDetailReportEditConfigController.prototype._initNumberOfGroupingLevelsListSelector = function (id, selectedValue, onChangeCallback) {
    var numberOfGroupingLevelsSelector = new _ListSelector2.default({
        renderTo: _jquery2.default.find("#" + id)[0]
    });
    numberOfGroupingLevelsSelector.addItems([{
        text: _messageResource2.default.getEscapedMessage("reports.comments_report.form.format.no_grouping"),
        value: TTDetailReportEditConfigController.groupingLevels.NO_GROUPING
    }, {
        text: _messageResource2.default.getEscapedMessage("reports.comments_report.form.format.1_level"),
        value: TTDetailReportEditConfigController.groupingLevels.ONE_LEVEL
    }, {
        text: _messageResource2.default.getEscapedMessage("reports.comments_report.form.format.2_levels"),
        value: TTDetailReportEditConfigController.groupingLevels.TWO_LEVELS
    }, {
        text: _messageResource2.default.getEscapedMessage("reports.comments_report.form.format.3_levels"),
        value: TTDetailReportEditConfigController.groupingLevels.THREE_LEVELS
    }]);

    numberOfGroupingLevelsSelector.on("change", onChangeCallback);

    numberOfGroupingLevelsSelector.setActiveItemByValue(selectedValue, true);

    return numberOfGroupingLevelsSelector;
};

TTDetailReportEditConfigController.prototype.getConfig = function () {
    var groupingLevelValues = this.groupingSelector.getValues();
    var needSwitchToMe = !this.reportAuthorizationInfo.anyOtherUsersAvailable && !this.reportAuthorizationInfo.allUsersAvailable;
    return {
        timeFormat: this.timeFormatSelector.getValue(),
        joinCommentsByTask: this.joinCommentsCheckbox.prop("checked"),
        userSelection: this.userSelector ? this.userSelector.getSelection() : this.initReportParameters.userSelection,
        timeApprovalStatus: this.approvedTTFilter.getValue(),
        customersProjectsSelection: this.cpSelector.getCpSelection(),
        firstGroupingLevel: groupingLevelValues[0],
        secondGroupingLevel: groupingLevelValues[1],
        thirdGroupingLevel: groupingLevelValues[2],
        needSwitchToMe: needSwitchToMe
    };
};

TTDetailReportEditConfigController.prototype.resetConfig = function () {
    var groupingSelection = [this.initReportParameters.firstGroupingLevel, this.initReportParameters.secondGroupingLevel, this.initReportParameters.thirdGroupingLevel];

    this.timeFormatSelector.setActiveItemByValue(this.initReportParameters.timeFormat, true);
    this.numberOfGroupingLevelsSelector.setActiveItemByValue(this.groupingSelector.calculateNumberOfVisibleLevels(groupingSelection), false);
    this.joinCommentsCheckbox.prop("checked", this.initReportParameters.joinCommentsByTask);

    if (this.userSelector) this.userSelector.setSelection(this.initReportParameters.userSelection);

    this.approvedTTFilter.setActiveItemByValue(this.initReportParameters.timeApprovalStatus, true);
    this.cpSelector.setSelection(this.initReportParameters.customersProjectsSelection);
    this.groupingSelector.setValues(groupingSelection);
};

TTDetailReportEditConfigController.prototype.validate = function () {
    this.errors = [];

    if (this.userSelector && !this.userSelector.validateIsUserSelected()) this.errors.push(this.possibleErrors.ERROR_EMPTY_USER_SELECTION);

    if (!this.cpSelector.checkSelected()) this.errors.push(this.possibleErrors.ERROR_EMPTY_CP_SELECTION);

    if (!this.groupingSelector.validate()) this.errors.push(this.possibleErrors.ERROR_IN_GROUPING_LEVELS_SELECTOR);

    return this.errors.length === 0;
};

TTDetailReportEditConfigController.prototype.initErrorsToSectionElsMap = function () {
    var errorsToSectionElsMap = {};
    errorsToSectionElsMap[this.possibleErrors.ERROR_EMPTY_USER_SELECTION] = this.panelEl.find("#userSelectorId");
    errorsToSectionElsMap[this.possibleErrors.ERROR_EMPTY_CP_SELECTION] = this.panelEl.find("#cpSelectorId");
    errorsToSectionElsMap[this.possibleErrors.ERROR_IN_GROUPING_LEVELS_SELECTOR] = this.panelEl.find(".dataGroupingControlContainer");
    return errorsToSectionElsMap;
};

TTDetailReportEditConfigController.prototype.setSelectorsInitStateFromCurrent = function () {
    _ATReportEditConfigController2.default.prototype.setSelectorsInitStateFromCurrent.call(this);

    if (this.userSelector) {
        this.userSelector.setInitialValueFromCurrent();
    }
    if (this.cpSelector) {
        this.cpSelector.setInitialValueFromCurrent();
    }
};

/***/ }),
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _ATReportEditConfigController = __webpack_require__(169);

var _ATReportEditConfigController2 = _interopRequireDefault(_ATReportEditConfigController);

var _ThreeLevelReportGroupingSelector = __webpack_require__(323);

var _ThreeLevelReportGroupingSelector2 = _interopRequireDefault(_ThreeLevelReportGroupingSelector);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _features = __webpack_require__(22);

var _constants = __webpack_require__(4);

var _constants2 = __webpack_require__(11);

var _ReportColumnsSelectorButtonsCostOfWork = __webpack_require__(2084);

var _ReportColumnsSelectorButtonsCostOfWork2 = _interopRequireDefault(_ReportColumnsSelectorButtonsCostOfWork);

var _SimpleTooltip = __webpack_require__(36);

var _SimpleTooltip2 = _interopRequireDefault(_SimpleTooltip);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _CustomCheckbox = __webpack_require__(83);

var _CustomCheckbox2 = _interopRequireDefault(_CustomCheckbox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CostReportEditConfigController = function (_ReportEditConfigCont) {
    _inherits(CostReportEditConfigController, _ReportEditConfigCont);

    function CostReportEditConfigController() {
        _classCallCheck(this, CostReportEditConfigController);

        return _possibleConstructorReturn(this, (CostReportEditConfigController.__proto__ || Object.getPrototypeOf(CostReportEditConfigController)).apply(this, arguments));
    }

    return CostReportEditConfigController;
}(_ATReportEditConfigController2.default);

exports.default = CostReportEditConfigController;


CostReportEditConfigController.prototype.init = function (config) {
    _ATReportEditConfigController2.default.prototype.init.call(this, config);

    var self = this;
    this.reportAuthorizationInfo = config.reportAuthorizationInfo;
    var reportParameters = this.makeReportParamsAccordingToFeatures(config.reportParameters);
    this.configChangedCallback = config.changeCallback;
    var configChanged = function configChanged() {
        self.configChanged();
    };

    this.timeFormatSelector = this.initTimeFormatSelector(reportParameters.timeFormat, configChanged);
    var groupingLevelsSelection = [reportParameters.firstGroupingLevel, reportParameters.secondGroupingLevel, reportParameters.thirdGroupingLevel];
    this.groupingSelector = new _ThreeLevelReportGroupingSelector2.default().init({
        selectorId: "reportGroupingSelector",
        enableNoneFirstGrouping: false,
        enableGroupByBillingType: (0, _features.isEnabled)(_features.Feature.BTY) || this.checkGroupingLevel(_constants2.ReportGroupingLevel.BILLING_TYPE, groupingLevelsSelection),
        enableGroupByUsers: false,
        enableGroupByUserGroups: false,
        includeTTCommentsInDetailsLevel: false,
        groupingLevelsSelection: groupingLevelsSelection,
        changesCallback: function changesCallback() {
            self.removeGroupingLevelsSelectionError();configChanged();
        }
    });

    var isShowUGR = (0, _features.isEnabled)(_features.Feature.UGR) || reportParameters.columnsConfig !== _constants.ReportColumnsFormatCostOfWork.USERS_ONLY;
    if (isShowUGR) this.columnsFormatSelector = this.initListSelector("columnsDisplayFormat", reportParameters.columnsConfig, configChanged);

    this.columnsFormat = new _ReportColumnsSelectorButtonsCostOfWork2.default().init({ containerId: "columnsFormatCheckboxesTable",
        selector: self.columnsFormatSelector,
        columnsFormat: reportParameters.columnsConfig,
        showSpentTime: reportParameters.showSpentTime,
        showAverageRates: reportParameters.showAverageRates,
        showUserRates: reportParameters.showUserRates,
        showSubtotalsByDepartments: reportParameters.showSubtotalsByDepartments,
        changeCallback: configChanged });

    this.cpSelector = this.makeCPSelector(reportParameters.customersProjectsSelection);
    this.userSelector = this.makeUserSelector(_extends({}, config, {
        allUsersAvailable: config.reportAuthorizationInfo.allUsersAvailable
    }));

    if ((0, _features.isEnabled)(_features.Feature.LVT) || reportParameters.showLeaveTimeCosts) {
        (0, _jquery2.default)("#leaveTimeCosts").show();
        (0, _jquery2.default)("#generalCostsConfigSection").show();
        this.showLeaveTimeCostsChexbox = (0, _jquery2.default)("#showLeaves");
        this.showLeaveTimeCostsChexbox.prop("checked", reportParameters.showLeaveTimeCosts);
        this.showLeaveTimeCostsChexbox.on("change", configChanged);
    }

    if ((0, _features.isEnabled)(_features.Feature.OVR) || reportParameters.showOvertimeAddition) {
        (0, _jquery2.default)("#overtimeAddition").show();
        (0, _jquery2.default)("#generalCostsConfigSection").show();
        this.showOvertimeChexbox = (0, _jquery2.default)("#showOvertime");
        this.showOvertimeChexbox.prop("checked", reportParameters.showOvertimeAddition);
        this.showOvertimeChexbox.on("change", configChanged);
    }

    this.makeShowOtherUsersCheckbox(reportParameters.includeOtherUsersColumn, configChanged);

    return this;
};

CostReportEditConfigController.prototype.makeShowOtherUsersCheckbox = function (includeOtherUsersColumn, onChangeCallback) {
    var $checkboxContainer = (0, _jquery2.default)(".showOtherUsersCheckboxRow");
    $checkboxContainer.toggle(!this.reportAuthorizationInfo.allUsersAvailable);

    if (!this.reportAuthorizationInfo.allUsersAvailable) {
        var labelText = this.reportAuthorizationInfo.anyOtherUsersAvailable ? _messageResource2.default.getMessage('report.common.include_not_assigned_users') : _messageResource2.default.getMessage('report.common.include_other_users');
        this.showOtherUsersCheckbox = new _CustomCheckbox2.default({
            label: labelText,
            checkboxAdditionalClass: 'checkboxInput',
            checkmarkAdditionalClass: 'hiddenCheckmark',
            onChange: function onChange() {
                return onChangeCallback();
            }
        }).init($checkboxContainer);

        this.showOtherUsersCheckbox.setState({
            checked: includeOtherUsersColumn
        });

        this.showOtherUsersCheckboxTooltip = new _SimpleTooltip2.default({
            text: _messageResource2.default.getMessage('report.common.show_other_users_checkbox_tooltip_text')
        }).init((0, _jquery2.default)('body'));
        this.showOtherUsersCheckboxTooltip.subscribeToMouseEvents(this.showOtherUsersCheckbox.getEl());

        this._updateIncludeOtherUsersCheckbox();
    }
};

CostReportEditConfigController.prototype._updateIncludeOtherUsersCheckbox = function () {
    if (this.showOtherUsersCheckbox) {
        var disabled = this.userSelector && this.userSelector.getSelection().allUsers !== true;
        this.showOtherUsersCheckbox.setState({
            checked: !disabled && this.showOtherUsersCheckbox.isChecked(),
            disabled: disabled
        });

        this.showOtherUsersCheckboxTooltip.setEnabled(disabled);
    }
};

CostReportEditConfigController.prototype.updateUI = function (blinkError) {
    _ATReportEditConfigController2.default.prototype.updateUI.call(this, blinkError);
    this._updateIncludeOtherUsersCheckbox();
};

CostReportEditConfigController.prototype.getConfig = function () {
    var reportColumnsResult = this.columnsFormat.getSelection();
    var groupingLevelValues = this.groupingSelector.getValues();
    return {
        timeFormat: this.timeFormatSelector.getValue(),
        userSelection: this.userSelector.getSelection(),
        showLeaveTimeCosts: !!this.showLeaveTimeCostsChexbox && this.showLeaveTimeCostsChexbox.is(":checked"),
        showOvertimeAddition: !!this.showOvertimeChexbox && this.showOvertimeChexbox.is(":checked"),
        columnsConfig: reportColumnsResult.columnsConfig,
        showSpentTime: reportColumnsResult.showSpentTime,
        showAverageRates: reportColumnsResult.showAverageRates,
        showUserRates: reportColumnsResult.showUserRates,
        showSubtotalsByDepartments: reportColumnsResult.showSubtotalsByDepartments,
        customersProjectsSelection: this.cpSelector.getCpSelection(),
        firstGroupingLevel: groupingLevelValues[0],
        secondGroupingLevel: groupingLevelValues[1],
        thirdGroupingLevel: groupingLevelValues[2],
        includeOtherUsersColumn: !!this.showOtherUsersCheckbox && this.showOtherUsersCheckbox.isChecked()
    };
};

CostReportEditConfigController.prototype.resetConfig = function () {
    this.timeFormatSelector.setActiveItemByValue(this.initReportParameters.timeFormat, true);
    this.userSelector.setSelection(this.initReportParameters.userSelection);
    if (this.showLeaveTimeCostsChexbox) this.showLeaveTimeCostsChexbox.prop("checked", this.initReportParameters.showLeaveTimeCosts);
    if (this.showOvertimeChexbox) this.showOvertimeChexbox.prop("checked", this.initReportParameters.showOvertimeAddition);
    this.cpSelector.setSelection(this.initReportParameters.customersProjectsSelection);
    this.columnsFormat.setValue(this.initReportParameters.columnsConfig, this.initReportParameters.showSpentTime, this.initReportParameters.showAverageRates, this.initReportParameters.showUserRates, this.initReportParameters.showSubtotalsByDepartments);
    this.groupingSelector.setValues([this.initReportParameters.firstGroupingLevel, this.initReportParameters.secondGroupingLevel, this.initReportParameters.thirdGroupingLevel]);
};

CostReportEditConfigController.prototype.validate = function () {
    this.errors = [];

    if (!this.userSelector.validateIsUserSelected()) this.errors.push(this.possibleErrors.ERROR_EMPTY_USER_SELECTION);

    if (!this.cpSelector.checkSelected()) this.errors.push(this.possibleErrors.ERROR_EMPTY_CP_SELECTION);

    if (!this.groupingSelector.validate()) this.errors.push(this.possibleErrors.ERROR_IN_GROUPING_LEVELS_SELECTOR);

    return this.errors.length === 0;
};

CostReportEditConfigController.prototype.initErrorsToSectionElsMap = function () {
    var errorsToSectionElsMap = {};
    errorsToSectionElsMap[this.possibleErrors.ERROR_EMPTY_USER_SELECTION] = this.panelEl.find("#userSelectorId");
    errorsToSectionElsMap[this.possibleErrors.ERROR_EMPTY_CP_SELECTION] = this.panelEl.find("#cpSelectorId");
    errorsToSectionElsMap[this.possibleErrors.ERROR_IN_GROUPING_LEVELS_SELECTOR] = this.panelEl.find(".reportGroupingSelectorContainer");
    return errorsToSectionElsMap;
};

CostReportEditConfigController.prototype.setSelectorsInitStateFromCurrent = function () {
    _ATReportEditConfigController2.default.prototype.setSelectorsInitStateFromCurrent.call(this);

    if (this.userSelector) {
        this.userSelector.setInitialValueFromCurrent();
    }
    if (this.cpSelector) {
        this.cpSelector.setInitialValueFromCurrent();
    }
};

CostReportEditConfigController.prototype.makeReportParamsAccordingToFeatures = function (reportParameters) {
    return reportParameters;
};

/***/ }),
/* 995 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = CSVPreviewCostProfitLossAdditionalSection;

var _CSVPreviewSection = __webpack_require__(43);

var _CSVPreviewSection2 = _interopRequireDefault(_CSVPreviewSection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CSVPreviewCostProfitLossAdditionalSection() {}

CSVPreviewCostProfitLossAdditionalSection.prototype = new _CSVPreviewSection2.default();

CSVPreviewCostProfitLossAdditionalSection.prototype.init = function (countDataColumns, countGroupingColumns, showOvertimeAddition, showLeaveTimeCosts) {
    _CSVPreviewSection2.default.prototype.init.call(this);
    this.countGroupingColumns = countGroupingColumns;
    this.showOvertimeAddition = showOvertimeAddition;
    this.showLeaveTimeCosts = showLeaveTimeCosts;
    this.countDataColumns = countDataColumns;
    return this;
};

CSVPreviewCostProfitLossAdditionalSection.prototype.addRows = function (tBody) {
    if (this.showLeaveTimeCosts) {
        for (var i = 0; i < 2; ++i) {
            var row = this.createRow();
            this.addCell(row, this.message("report.common.leave_type"));
            for (var k = 0; k < this.countGroupingColumns - 1; ++k) {
                ReportPreviewUtils.addEmptyCell(row);
            }
            for (k = 0; k < this.countDataColumns; ++k) {
                this.addTimeValueCell(row);
            }
            this.addRow(tBody, row);
        }
    }
    if (this.showOvertimeAddition) {
        row = this.createRow();
        this.addCell(row, this.message("report.common.overtime_bonus"), "overtimeBonus");
        for (k = 0; k < this.countGroupingColumns - 1; ++k) {
            ReportPreviewUtils.addEmptyCell(row);
        }for (k = 0; k < this.countDataColumns; ++k) {
            this.addTimeValueCell(row);
        }this.addRow(tBody, row);
    }
};

CSVPreviewCostProfitLossAdditionalSection.prototype.addGroupingLevel = function (row, groupingLevel) {
    ReportPreviewUtils.addCell(row, ReportPreviewUtils.getLevelPreviewName(groupingLevel));
};

/***/ }),
/* 996 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = CostCSVPreviewTwoLevelsColumnsStrategy;

var _CostCSVPreviewBaseColumnsStrategy = __webpack_require__(414);

var _CostCSVPreviewBaseColumnsStrategy2 = _interopRequireDefault(_CostCSVPreviewBaseColumnsStrategy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CostCSVPreviewTwoLevelsColumnsStrategy() {} /**
                                                      * Created by filatov on 17.09.2015.
                                                      */


CostCSVPreviewTwoLevelsColumnsStrategy.prototype = new _CostCSVPreviewBaseColumnsStrategy2.default();

CostCSVPreviewTwoLevelsColumnsStrategy.prototype.init = function (_ref) {
    var showSpentTime = _ref.showSpentTime,
        showAverageRates = _ref.showAverageRates,
        showOthers = _ref.showOthers;

    _CostCSVPreviewBaseColumnsStrategy2.default.prototype.init.call(this, showSpentTime, showAverageRates);
    this.showOthers = showOthers;
    return this;
};

CostCSVPreviewTwoLevelsColumnsStrategy.prototype.getCountGroupingRows = function () {
    return 2;
};

CostCSVPreviewTwoLevelsColumnsStrategy.prototype._getNumOfDetailsSubColumns = function () {
    var countText = 1;
    if (this.showSpentTime) countText++;
    if (this.isShowRatesForTopLevel()) countText++;
    return countText;
};

CostCSVPreviewTwoLevelsColumnsStrategy.prototype.getNumOfDetailsColumns = function () {
    var countText = this._getNumOfDetailsSubColumns();
    if (this.showOthers) countText *= 2;
    return countText;
};

CostCSVPreviewTwoLevelsColumnsStrategy.prototype.addSecondHeaderRowDataCells = function (row) {
    ReportPreviewUtils.addEmptyCells(row, this.getOverallColumnsCount());
    var countColumns = this._getNumOfDetailsSubColumns();
    for (var i = 0; i < countColumns; i++) {
        this.addCell(row, this.message(this.getLevelNameKey()));
    }
    if (this.showOthers) {
        for (var _i = 0; _i < countColumns; _i++) {
            this.addCell(row, this.message("report.common.others"));
        }
    }
};

CostCSVPreviewTwoLevelsColumnsStrategy.prototype._addFirstHeaderRowDataCells = function (row) {
    if (this.showSpentTime) this.addCell(row, this.message("report.cost.spent"));
    if (this.isShowRatesForTopLevel()) this.addCell(row, this.message("report.cost.rate"));
    this.addCell(row, this.message("report.cost.cost"));
};

CostCSVPreviewTwoLevelsColumnsStrategy.prototype.addFirstHeaderRowDataCells = function (row) {
    this.addOverallHeaderCells(row);
    this._addFirstHeaderRowDataCells(row);
    if (this.showOthers) this._addFirstHeaderRowDataCells(row);
};

/***/ }),
/* 997 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = CostHTMLPreviewTwoLevelsHeaderBaseColumnsStrategy;

var _CostHTMLPreviewBaseColumnsStrategy = __webpack_require__(415);

var _CostHTMLPreviewBaseColumnsStrategy2 = _interopRequireDefault(_CostHTMLPreviewBaseColumnsStrategy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CostHTMLPreviewTwoLevelsHeaderBaseColumnsStrategy() {}

CostHTMLPreviewTwoLevelsHeaderBaseColumnsStrategy.prototype = new _CostHTMLPreviewBaseColumnsStrategy2.default();

CostHTMLPreviewTwoLevelsHeaderBaseColumnsStrategy.prototype.init = function (_ref) {
    var timeFormat = _ref.timeFormat,
        showSpentTime = _ref.showSpentTime,
        showAverageRates = _ref.showAverageRates,
        showOthers = _ref.showOthers;

    _CostHTMLPreviewBaseColumnsStrategy2.default.prototype.init.call(this, timeFormat, showSpentTime, showAverageRates);
    this.showOthers = showOthers;
    return this;
};

CostHTMLPreviewTwoLevelsHeaderBaseColumnsStrategy.prototype.isShowRatesForTopLevel = function () {
    // abstract
};

CostHTMLPreviewTwoLevelsHeaderBaseColumnsStrategy.prototype.getTopLevelNameKey = function () {
    // abstract
};

CostHTMLPreviewTwoLevelsHeaderBaseColumnsStrategy.prototype.getTopLevelHeaderCellClassName = function () {
    // abstract
};

CostHTMLPreviewTwoLevelsHeaderBaseColumnsStrategy.prototype.addFirstHeaderRowDataCells = function (row) {
    this.addOverallHeaderCells(row);
    var colSpan = 1;
    if (this.showSpentTime) colSpan++;
    if (this.isShowRatesForTopLevel()) colSpan++;

    this.addCell(row, this.message(this.getTopLevelNameKey()), this.getTopLevelHeaderCellClassName(), colSpan, 2);

    var topLevelName = this.showOthers ? this.message("report.common.others") : this.message(this.getTopLevelNameKey());
    this.addCell(row, topLevelName, this.getTopLevelHeaderCellClassName(), colSpan, 2);
};

CostHTMLPreviewTwoLevelsHeaderBaseColumnsStrategy.prototype.addSecondHeaderRowDataCells = function (row) {
    // do nothing
};

CostHTMLPreviewTwoLevelsHeaderBaseColumnsStrategy.prototype.addThirdHeaderRowDataCells = function (row) {
    for (var i = 0; i < 2; i++) {
        if (this.showSpentTime) this.addCell(row, this.message("report.cost.spent"), "spent");
        if (this.isShowRatesForTopLevel()) this.addCell(row, this.message("report.cost.rate"), "rate");
        this.addCell(row, this.message("report.cost.cost"), "cost");
    }
};

CostHTMLPreviewTwoLevelsHeaderBaseColumnsStrategy.prototype.addDataCells = function (row) {
    this.addOverallDataCells(row);
    for (var i = 0; i < 2; i++) {
        if (this.showSpentTime) this.addTimeValueCell(row);
        if (this.isShowRatesForTopLevel()) this.addMoneyValueCell(row);
        this.addCostDataCell(row);
    }
};

CostHTMLPreviewTwoLevelsHeaderBaseColumnsStrategy.prototype.getDataColumnsCount = function () {
    var oneGroupCount = 1;
    if (this.showSpentTime) oneGroupCount++;
    if (this.isShowRatesForTopLevel()) oneGroupCount++;
    return this.getOverallColumnsCount() + oneGroupCount * 2;
};

CostHTMLPreviewTwoLevelsHeaderBaseColumnsStrategy.prototype.areThereTwoRowsInHeader = function () {
    return true;
};

/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = CostHTMLPreviewOneLevelHeaderBaseColumnsStrategy;

var _CostHTMLPreviewBaseColumnsStrategy = __webpack_require__(415);

var _CostHTMLPreviewBaseColumnsStrategy2 = _interopRequireDefault(_CostHTMLPreviewBaseColumnsStrategy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CostHTMLPreviewOneLevelHeaderBaseColumnsStrategy() {}

CostHTMLPreviewOneLevelHeaderBaseColumnsStrategy.prototype = new _CostHTMLPreviewBaseColumnsStrategy2.default();

CostHTMLPreviewOneLevelHeaderBaseColumnsStrategy.prototype.init = function (_ref) {
    var timeFormat = _ref.timeFormat,
        showAverageRates = _ref.showAverageRates,
        showOthers = _ref.showOthers;

    _CostHTMLPreviewBaseColumnsStrategy2.default.prototype.init.call(this, timeFormat, false, showAverageRates);
    this.showOthers = showOthers;
    return this;
};

CostHTMLPreviewOneLevelHeaderBaseColumnsStrategy.prototype.getLevelNameKey = function () {
    // abstract
};

CostHTMLPreviewOneLevelHeaderBaseColumnsStrategy.prototype.getLevelCellsClassName = function () {
    // abstract
};

CostHTMLPreviewOneLevelHeaderBaseColumnsStrategy.prototype.addFirstHeaderRowDataCells = function (row) {
    this.addOverallHeaderCells(row);
    for (var i = 0; i < (this.showOthers ? 2 : 3); i++) {
        this.addCell(row, this.message(this.getLevelNameKey()), this.getLevelCellsClassName(), 1, 3);
    }
    if (this.showOthers) this.addCell(row, this.message("report.common.others"), this.getLevelCellsClassName(), 1, 3);
};

CostHTMLPreviewOneLevelHeaderBaseColumnsStrategy.prototype.addSecondHeaderRowDataCells = function (row) {
    // do nothing
};

CostHTMLPreviewOneLevelHeaderBaseColumnsStrategy.prototype.addThirdHeaderRowDataCells = function (row) {
    // do nothing
};

CostHTMLPreviewOneLevelHeaderBaseColumnsStrategy.prototype.addDataCells = function (row) {
    this.addOverallDataCells(row);
    this.addMoneyValueCell(row);
    this.addMoneyValueCell(row);
    this.addMoneyValueCell(row);
};

CostHTMLPreviewOneLevelHeaderBaseColumnsStrategy.prototype.getDataColumnsCount = function () {
    return this.getOverallColumnsCount() + 3;
};

/***/ }),
/* 999 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ATReportEditConfigController = __webpack_require__(169);

var _ATReportEditConfigController2 = _interopRequireDefault(_ATReportEditConfigController);

var _ThreeLevelReportGroupingSelector = __webpack_require__(323);

var _ThreeLevelReportGroupingSelector2 = _interopRequireDefault(_ThreeLevelReportGroupingSelector);

var _constants = __webpack_require__(11);

var _displayed_data_radiogroup_controls_bs_report = __webpack_require__(603);

var _displayed_data_radiogroup_controls_bs_report2 = _interopRequireDefault(_displayed_data_radiogroup_controls_bs_report);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BillingSummaryReportEditConfigController = function (_ReportEditConfigCont) {
    _inherits(BillingSummaryReportEditConfigController, _ReportEditConfigCont);

    function BillingSummaryReportEditConfigController() {
        _classCallCheck(this, BillingSummaryReportEditConfigController);

        return _possibleConstructorReturn(this, (BillingSummaryReportEditConfigController.__proto__ || Object.getPrototypeOf(BillingSummaryReportEditConfigController)).apply(this, arguments));
    }

    return BillingSummaryReportEditConfigController;
}(_ATReportEditConfigController2.default);

exports.default = BillingSummaryReportEditConfigController;


BillingSummaryReportEditConfigController.prototype.init = function (config) {
    _ATReportEditConfigController2.default.prototype.init.call(this, config);

    var self = this;
    var reportParameters = this.makeReportParamsAccordingToFeatures(config.reportParameters);

    this.configChangedCallback = config.changeCallback;
    var configChanged = function configChanged() {
        self.configChanged();
    };

    this.reportAuthorizationInfo = config.reportAuthorizationInfo;

    this.approvedTTFilter = this.addApprovedTTFilter(reportParameters.timeApprovalStatus, configChanged);

    this.timeFormatSelector = this.initTimeFormatSelector(reportParameters.timeFormat, configChanged);
    var groupingLevelsSelection = [reportParameters.firstGroupingLevel, reportParameters.secondGroupingLevel, reportParameters.thirdGroupingLevel];
    this.groupingSelector = new _ThreeLevelReportGroupingSelector2.default().init({
        selectorId: "reportGroupingSelector",
        enableNoneFirstGrouping: true,
        enableGroupByBillingType: false,
        enableGroupByUsers: true,
        enableGroupByUserGroups: EnabledFeatures.UGR || this.checkGroupingLevel(_constants.ReportGroupingLevel.USER_GROUP, groupingLevelsSelection),
        includeTTCommentsInDetailsLevel: true,
        groupingLevelsSelection: groupingLevelsSelection,
        changesCallback: function changesCallback() {
            self.removeGroupingLevelsSelectionError();configChanged();
        }
    });
    this.cpSelector = this.makeCPSelector(reportParameters.customersProjectsSelection);

    this.displayedDataSelector = new _displayed_data_radiogroup_controls_bs_report2.default().init("billingStatusFilter", reportParameters.reportInfo, configChanged);
    this.chooseTypeSelector = new ChooseTypeSelector().init(reportParameters.reportType, configChanged);
    return this;
};

BillingSummaryReportEditConfigController.prototype.getConfig = function () {
    var groupingLevelValues = this.groupingSelector.getValues();
    return {
        timeFormat: this.timeFormatSelector.getValue(),
        timeApprovalStatus: this.approvedTTFilter.getValue(),
        reportType: this.chooseTypeSelector.getValue(),
        reportInfo: this.displayedDataSelector.getValue(),
        firstGroupingLevel: groupingLevelValues[0],
        secondGroupingLevel: groupingLevelValues[1],
        thirdGroupingLevel: groupingLevelValues[2],
        customersProjectsSelection: this.cpSelector.getCpSelection(),
        reportAuthorizationInfo: this.reportAuthorizationInfo
    };
};

BillingSummaryReportEditConfigController.prototype.resetConfig = function () {
    this.timeFormatSelector.setActiveItemByValue(this.initReportParameters.timeFormat, true);
    this.approvedTTFilter.setActiveItemByValue(this.initReportParameters.timeApprovalStatus, true);
    this.chooseTypeSelector.setValue(this.initReportParameters.reportType);
    this.displayedDataSelector.setValue(this.initReportParameters.reportInfo);
    this.groupingSelector.setValues([this.initReportParameters.firstGroupingLevel, this.initReportParameters.secondGroupingLevel, this.initReportParameters.thirdGroupingLevel]);
    this.cpSelector.setSelection(this.initReportParameters.customersProjectsSelection);
};

BillingSummaryReportEditConfigController.prototype.validate = function () {
    this.errors = [];

    if (!this.cpSelector.checkSelected()) this.errors.push(this.possibleErrors.ERROR_EMPTY_CP_SELECTION);

    if (!this.groupingSelector.validate()) this.errors.push(this.possibleErrors.ERROR_IN_GROUPING_LEVELS_SELECTOR);

    return this.errors.length == 0;
};

BillingSummaryReportEditConfigController.prototype.initErrorsToSectionElsMap = function () {
    var errorsToSectionElsMap = {};
    errorsToSectionElsMap[this.possibleErrors.ERROR_EMPTY_CP_SELECTION] = this.panelEl.find("#cpSelectorId");
    errorsToSectionElsMap[this.possibleErrors.ERROR_IN_GROUPING_LEVELS_SELECTOR] = this.panelEl.find(".reportGroupingSelectorContainer");
    return errorsToSectionElsMap;
};

BillingSummaryReportEditConfigController.prototype.setSelectorsInitStateFromCurrent = function () {
    _ATReportEditConfigController2.default.prototype.setSelectorsInitStateFromCurrent.call(this);

    if (this.cpSelector) {
        this.cpSelector.setInitialValueFromCurrent();
    }
};

/***/ }),
/* 1000 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ATReportEditConfigController = __webpack_require__(169);

var _ATReportEditConfigController2 = _interopRequireDefault(_ATReportEditConfigController);

var _ThreeLevelReportGroupingSelector = __webpack_require__(323);

var _ThreeLevelReportGroupingSelector2 = _interopRequireDefault(_ThreeLevelReportGroupingSelector);

var _constants = __webpack_require__(11);

var _invoice_billing_summary_choose_type = __webpack_require__(1001);

var _invoice_billing_summary_choose_type2 = _interopRequireDefault(_invoice_billing_summary_choose_type);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InvoiceReportEditConfigController = function (_ReportEditConfigCont) {
    _inherits(InvoiceReportEditConfigController, _ReportEditConfigCont);

    function InvoiceReportEditConfigController() {
        _classCallCheck(this, InvoiceReportEditConfigController);

        return _possibleConstructorReturn(this, (InvoiceReportEditConfigController.__proto__ || Object.getPrototypeOf(InvoiceReportEditConfigController)).apply(this, arguments));
    }

    return InvoiceReportEditConfigController;
}(_ATReportEditConfigController2.default);

exports.default = InvoiceReportEditConfigController;


InvoiceReportEditConfigController.prototype.init = function (config) {
    var _this2 = this;

    _ATReportEditConfigController2.default.prototype.init.call(this, config);

    this.configChangedCallback = config.changeCallback;
    var configChanged = function configChanged() {
        return _this2.configChanged();
    };
    this.reportAuthorizationInfo = config.reportAuthorizationInfo;
    var reportParameters = this.makeReportParamsAccordingToFeatures(config.reportParameters);
    this.groupingSelector = new _ThreeLevelReportGroupingSelector2.default().init({
        selectorId: "reportGroupingSelector",
        enableNoneFirstGrouping: true,
        enableGroupByBillingType: false,
        enableGroupByUsers: true,
        enableGroupByUserGroups: EnabledFeatures.UGR || reportParameters.firstGroupingLevel === _constants.ReportGroupingLevel.USER_GROUP || reportParameters.secondGroupingLevel === _constants.ReportGroupingLevel.USER_GROUP,
        includeTTCommentsInDetailsLevel: true,
        groupingLevelsSelection: [reportParameters.firstGroupingLevel, reportParameters.secondGroupingLevel, reportParameters.thirdGroupingLevel],
        changesCallback: function changesCallback() {
            _this2.removeGroupingLevelsSelectionError();
            configChanged();
        }
    });
    this.cpSelector = this.makeCPSelector(reportParameters.customersProjectsSelection);

    this.chooseTypeSelector = new _invoice_billing_summary_choose_type2.default().init(reportParameters.reportType, configChanged);

    return this;
};

InvoiceReportEditConfigController.prototype.setSelectorsInitStateFromCurrent = function () {
    _ATReportEditConfigController2.default.prototype.setSelectorsInitStateFromCurrent.call(this);

    if (this.cpSelector) {
        this.cpSelector.setInitialValueFromCurrent();
    }
};

InvoiceReportEditConfigController.prototype.getConfig = function () {
    var groupingLevelValues = this.groupingSelector.getValues();
    return {
        reportType: this.chooseTypeSelector.getValue(),
        customersProjectsSelection: this.cpSelector.getCpSelection(),
        firstGroupingLevel: groupingLevelValues[0],
        secondGroupingLevel: groupingLevelValues[1],
        thirdGroupingLevel: groupingLevelValues[2],
        reportAuthorizationInfo: this.reportAuthorizationInfo
    };
};

InvoiceReportEditConfigController.prototype.resetConfig = function () {
    this.chooseTypeSelector.setValue(this.initReportParameters.reportType);
    this.cpSelector.setSelection(this.initReportParameters.customersProjectsSelection);
    this.groupingSelector.setValues([this.initReportParameters.firstGroupingLevel, this.initReportParameters.secondGroupingLevel, this.initReportParameters.thirdGroupingLevel]);
};

InvoiceReportEditConfigController.prototype.validate = function () {
    this.errors = [];

    if (!this.cpSelector.checkSelected()) this.errors.push(this.possibleErrors.ERROR_EMPTY_CP_SELECTION);

    if (!this.groupingSelector.validate()) this.errors.push(this.possibleErrors.ERROR_IN_GROUPING_LEVELS_SELECTOR);

    return this.errors.length == 0;
};

InvoiceReportEditConfigController.prototype.initErrorsToSectionElsMap = function () {
    var errorsToSectionElsMap = {};
    errorsToSectionElsMap[this.possibleErrors.ERROR_EMPTY_CP_SELECTION] = this.panelEl.find("#cpSelectorId");
    errorsToSectionElsMap[this.possibleErrors.ERROR_IN_GROUPING_LEVELS_SELECTOR] = this.panelEl.find(".reportGroupingSelectorContainer");
    return errorsToSectionElsMap;
};

/***/ }),
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ChooseTypeSelector;

var _TableTooltip = __webpack_require__(237);

var _TableTooltip2 = _interopRequireDefault(_TableTooltip);

var _atBrowserUtils = __webpack_require__(8);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ChooseTypeSelector() {} /**
                                  * Created by filatov on 19.08.2015.
                                  */


ChooseTypeSelector.prototype.init = function (dateRangeType, changeCallback) {
    var self = this;
    this.checkBoxTypeComletedTasks = (0, _jquery2.default)("#type_completed_tasks");
    this.checkBoxTypeTimeReported = (0, _jquery2.default)("#type_time_reported");
    this.checkBoxTypeComletedTasks.on("click", function () {
        self.updateReportTypeSection();
    });
    this.checkBoxTypeTimeReported.on("click", function () {
        self.updateReportTypeSection();
    });
    this.checkBoxTypeComletedTasks.on("change", changeCallback);
    this.checkBoxTypeTimeReported.on("change", changeCallback);

    this.timeReportedSection = (0, _jquery2.default)("#type_time_reported_section");
    this.timeCompletedSection = (0, _jquery2.default)("#type_completed_tasks_section");
    this.allTimeReportedTooltip = new _TableTooltip2.default().init("all_time_reported_tooltip");
    this.completedTaskReportedTooltip = new _TableTooltip2.default().init("completed_tasks_tooltip");

    this.timeReportedSection.hover(function (event) {
        /*do nothing on hover only on mousemove see bug 52931, 
        also hooking "show tooltip" function on different events is not a good idea*/
    }, function () {
        self.hideTooltip(self.allTimeReportedTooltip);
    });
    this.timeReportedSection.mousemove(function (event) {
        self.moveTooltip(self.allTimeReportedTooltip, event);
    });

    this.timeCompletedSection.hover(function (event) {/*do nothing on hover only on mousemove*/}, function () {
        self.hideTooltip(self.completedTaskReportedTooltip);
    });
    this.timeCompletedSection.mousemove(function (event) {
        self.moveTooltip(self.completedTaskReportedTooltip, event);
    });

    this.setValue(dateRangeType);
    this.updateReportTypeSection();

    return this;
};

ChooseTypeSelector.prototype.updateReportTypeSection = function () {
    if (this.checkBoxTypeTimeReported.is(":checked")) {
        this.turnOnSection(this.timeReportedSection);
        this.turnOffSection(this.timeCompletedSection);
    }

    if (this.checkBoxTypeComletedTasks.is(":checked")) {
        this.turnOnSection(this.timeCompletedSection);
        this.turnOffSection(this.timeReportedSection);
    }
};

ChooseTypeSelector.prototype.setValue = function (value) {
    (0, _jquery2.default)("input[name=dateRangeType][value=" + value + "]").prop('checked', true);
    this.updateReportTypeSection();
};

ChooseTypeSelector.prototype.getValue = function () {
    return (0, _jquery2.default)("input[type='radio'][name='dateRangeType']:checked").val();
};

ChooseTypeSelector.prototype.turnOnSection = function (section) {
    section.removeClass("sectionedRadio_unchecked");
    section.addClass("sectionedRadio_checked");
};

ChooseTypeSelector.prototype.turnOffSection = function (section) {
    section.removeClass("sectionedRadio_checked");
    section.addClass("sectionedRadio_unchecked");
};

ChooseTypeSelector.prototype.showTooltip = function (tooltip, event) {
    tooltip.timeout = setTimeout(function () {
        tooltip.isShow = true;tooltip.show();tooltip.move((0, _atBrowserUtils.calculateTooltipOffset)(tooltip, event));
    }, 1000);
};

ChooseTypeSelector.prototype.moveTooltip = function (tooltip, event) {
    if (tooltip.timeout) clearTimeout(tooltip.timeout);
    if (!tooltip.isShow) {
        this.showTooltip(tooltip, event);
    }
    tooltip.move((0, _atBrowserUtils.calculateTooltipOffset)(tooltip, event));
};

ChooseTypeSelector.prototype.hideTooltip = function (tooltip) {
    if (tooltip.timeout) clearTimeout(tooltip.timeout);
    tooltip.isShow = false;
    tooltip.hide();
};

/***/ }),
/* 1002 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _ATReportEditConfigController = __webpack_require__(169);

var _ATReportEditConfigController2 = _interopRequireDefault(_ATReportEditConfigController);

var _ProfitLossDisplayedDataSelector = __webpack_require__(2139);

var _ProfitLossDisplayedDataSelector2 = _interopRequireDefault(_ProfitLossDisplayedDataSelector);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ProfitLossReportEditConfigController = function (_ReportEditConfigCont) {
    _inherits(ProfitLossReportEditConfigController, _ReportEditConfigCont);

    function ProfitLossReportEditConfigController() {
        _classCallCheck(this, ProfitLossReportEditConfigController);

        return _possibleConstructorReturn(this, (ProfitLossReportEditConfigController.__proto__ || Object.getPrototypeOf(ProfitLossReportEditConfigController)).apply(this, arguments));
    }

    return ProfitLossReportEditConfigController;
}(_ATReportEditConfigController2.default);

exports.default = ProfitLossReportEditConfigController;


ProfitLossReportEditConfigController.prototype.init = function (config) {
    _ATReportEditConfigController2.default.prototype.init.call(this, config);

    var self = this;
    var reportParameters = this.makeReportParamsAccordingToFeatures(config.reportParameters);

    this.configChangedCallback = config.changeCallback;
    var configChanged = function configChanged() {
        self.configChanged();
    };
    this.timeFormatSelector = this.initTimeFormatSelector(reportParameters.timeFormat, configChanged);
    this.cpSelector = this.makeCPSelector(reportParameters.customersProjectsSelection);

    this.showSpentTimeCheckbox = (0, _jquery2.default)("#showSpentTime");
    this.showSpentTimeCheckbox.prop("checked", reportParameters.showSpentTime);
    this.showSpentTimeCheckbox.on("change", configChanged);
    this.showAverageRatesCheckbox = (0, _jquery2.default)("#showAverageRates");
    this.showAverageRatesCheckbox.prop("checked", reportParameters.showAverageRates);
    this.showAverageRatesCheckbox.on("change", configChanged);

    if (EnabledFeatures.LVT || reportParameters.showLeaveTimeCosts) {
        (0, _jquery2.default)("#leaveTimeCosts").show();
        (0, _jquery2.default)("#generalCostsConfigSection").show();
        this.showLeaveTimeCostsChexbox = (0, _jquery2.default)("#showLeaves");
        this.showLeaveTimeCostsChexbox.prop("checked", reportParameters.showLeaveTimeCosts);
        this.showLeaveTimeCostsChexbox.on("change", configChanged);
    }

    if (EnabledFeatures.OVR || reportParameters.showOvertimeAddition) {
        (0, _jquery2.default)("#overtimeAddition").show();
        (0, _jquery2.default)("#generalCostsConfigSection").show();
        this.showOvertimeChexbox = (0, _jquery2.default)("#showOvertime");
        this.showOvertimeChexbox.prop("checked", reportParameters.showOvertimeAddition);
        this.showOvertimeChexbox.on("change", configChanged);
    }

    this.displayedDataSelector = new _ProfitLossDisplayedDataSelector2.default().init("profitLossReportColumnsButton", reportParameters.firstGroupingLevel, reportParameters.secondGroupingLevel, reportParameters.thirdGroupingLevel, configChanged);
    return this;
};

ProfitLossReportEditConfigController.prototype.getConfig = function () {
    var groupingLevels = this.displayedDataSelector.getValue();
    return {
        timeFormat: this.timeFormatSelector.getValue(),
        showSpentTime: this.showSpentTimeCheckbox.is(":checked"),
        showAverageRates: this.showAverageRatesCheckbox.is(":checked"),
        showLeaveTimeCosts: !!this.showLeaveTimeCostsChexbox && this.showLeaveTimeCostsChexbox.is(":checked"),
        showOvertimeAddition: !!this.showOvertimeChexbox && this.showOvertimeChexbox.is(":checked"),
        firstGroupingLevel: groupingLevels.firstGroupingLevel,
        secondGroupingLevel: groupingLevels.secondGroupingLevel,
        thirdGroupingLevel: groupingLevels.thirdGroupingLevel,
        customersProjectsSelection: this.cpSelector.getCpSelection()
    };
};

ProfitLossReportEditConfigController.prototype.resetConfig = function () {
    this.timeFormatSelector.setActiveItemByValue(this.initReportParameters.timeFormat, true);
    this.showSpentTimeCheckbox.prop("checked", this.initReportParameters.showSpentTime);
    this.showAverageRatesCheckbox.prop("checked", this.initReportParameters.showAverageRates);
    if (this.showLeaveTimeCostsChexbox) this.showLeaveTimeCostsChexbox.prop("checked", this.initReportParameters.showLeaveTimeCosts);
    if (this.showOvertimeChexbox) this.showOvertimeChexbox.prop("checked", this.initReportParameters.showOvertimeAddition);
    this.displayedDataSelector.setValue(this.initReportParameters.firstGroupingLevel, this.initReportParameters.secondGroupingLevel, this.initReportParameters.thirdGroupingLevel);
    this.cpSelector.setSelection(this.initReportParameters.customersProjectsSelection);
};

ProfitLossReportEditConfigController.prototype.validate = function () {
    this.errors = [];

    if (!this.cpSelector.checkSelected()) this.errors.push(this.possibleErrors.ERROR_EMPTY_CP_SELECTION);

    return this.errors.length == 0;
};

ProfitLossReportEditConfigController.prototype.initErrorsToSectionElsMap = function () {
    var errorsToSectionElsMap = {};
    errorsToSectionElsMap[this.possibleErrors.ERROR_EMPTY_CP_SELECTION] = this.panelEl.find("#cpSelectorId");
    return errorsToSectionElsMap;
};

ProfitLossReportEditConfigController.prototype.setSelectorsInitStateFromCurrent = function () {
    _ATReportEditConfigController2.default.prototype.setSelectorsInitStateFromCurrent.call(this);

    if (this.cpSelector) {
        this.cpSelector.setInitialValueFromCurrent();
    }
};

/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ProfitLossHTMLPreviewBaseStrategy;

var _HTMLColumnsStrategy = __webpack_require__(270);

var _HTMLColumnsStrategy2 = _interopRequireDefault(_HTMLColumnsStrategy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ProfitLossHTMLPreviewBaseStrategy() {}

ProfitLossHTMLPreviewBaseStrategy.prototype = new _HTMLColumnsStrategy2.default();

ProfitLossHTMLPreviewBaseStrategy.prototype.init = function (timeFormat, showSpentTime) {
    _HTMLColumnsStrategy2.default.prototype.init.call(this, timeFormat);
    this.showSpentTime = showSpentTime;
    return this;
};

ProfitLossHTMLPreviewBaseStrategy.prototype.addFirstHeaderRowCells = function (firstHeaderRow) {
    if (this.showSpentTime) {
        this.addCell(firstHeaderRow, this.message("report.profit_loss.spent.header") + " " + this.message("report.common.unit_work"), "spent", 1, 2);
    }

    this.addCell(firstHeaderRow, this.getBillableAmountColHeaderText(), "billableAmount", this.getBillableAmountColSpan(), this.getBillableAmountRowSpan());

    this.addCell(firstHeaderRow, this.getCostOfWorkColHeaderText(), "costOfWork", this.getCostOfWorkColSpan(), this.getCostOfWorkRowSpan());

    this.addCell(firstHeaderRow, this.message("report.profit_loss.pl.header") + " (" + SystemSettings.currencySign + ")", "pL", 1, 2);
};

ProfitLossHTMLPreviewBaseStrategy.prototype.addSecondHeaderRowCells = function (secondHeaderRow) {
    // abstract
};

ProfitLossHTMLPreviewBaseStrategy.prototype.getBillableAmountColHeaderText = function () {
    // abstract
};

ProfitLossHTMLPreviewBaseStrategy.prototype.getCostOfWorkColHeaderText = function () {
    // abstract
};

ProfitLossHTMLPreviewBaseStrategy.prototype.getBillableAmountColSpan = function () {
    // abstract
};

ProfitLossHTMLPreviewBaseStrategy.prototype.getBillableAmountRowSpan = function () {
    // abstract
};

ProfitLossHTMLPreviewBaseStrategy.prototype.getCostOfWorkColSpan = function () {
    // abstract
};

ProfitLossHTMLPreviewBaseStrategy.prototype.getCostOfWorkRowSpan = function () {
    // abstract
};

ProfitLossHTMLPreviewBaseStrategy.prototype.addDataCells = function (row) {
    // abstract
};

ProfitLossHTMLPreviewBaseStrategy.prototype.getDataColumnsCount = function () {
    // abstract
};

/***/ }),
/* 1004 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1005);
__webpack_require__(1027);
__webpack_require__(1029);
__webpack_require__(1031);
__webpack_require__(1033);
__webpack_require__(1037);
__webpack_require__(1039);
__webpack_require__(1058);
__webpack_require__(1071);
__webpack_require__(1091);
__webpack_require__(1093);
__webpack_require__(1095);
__webpack_require__(1100);
__webpack_require__(1115);
__webpack_require__(1118);
__webpack_require__(1120);
__webpack_require__(1142);
__webpack_require__(1143);
__webpack_require__(1155);
__webpack_require__(1157);
__webpack_require__(1159);
__webpack_require__(1167);
module.exports = __webpack_require__(1171);


/***/ }),
/* 1005 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(272);
__webpack_require__(1006);
__webpack_require__(1007);
__webpack_require__(1008);
__webpack_require__(1009);
__webpack_require__(1010);
__webpack_require__(1011);
__webpack_require__(1012);
__webpack_require__(1014);
__webpack_require__(1015);
__webpack_require__(1016);
__webpack_require__(1017);
__webpack_require__(1018);
__webpack_require__(1019);
__webpack_require__(1020);
__webpack_require__(1021);
__webpack_require__(1022);
__webpack_require__(1023);
__webpack_require__(1024);
__webpack_require__(1025);
__webpack_require__(1026);
__webpack_require__(330);
module.exports = __webpack_require__(37).Array;


/***/ }),
/* 1006 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
var $export = __webpack_require__(10);

$export($export.S, 'Array', { isArray: __webpack_require__(327) });


/***/ }),
/* 1007 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(112);
var $export = __webpack_require__(10);
var toObject = __webpack_require__(58);
var call = __webpack_require__(610);
var isArrayIter = __webpack_require__(424);
var toLength = __webpack_require__(54);
var createProperty = __webpack_require__(425);
var getIterFn = __webpack_require__(426);

$export($export.S + $export.F * !__webpack_require__(329)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 1008 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(10);
var createProperty = __webpack_require__(425);

// WebKit Array.of isn't generic
$export($export.S + $export.F * __webpack_require__(32)(function () {
  function F() { /* empty */ }
  return !(Array.of.call(F) instanceof F);
}), 'Array', {
  // 22.1.2.3 Array.of( ...items)
  of: function of(/* ...args */) {
    var index = 0;
    var aLen = arguments.length;
    var result = new (typeof this == 'function' ? this : Array)(aLen);
    while (aLen > index) createProperty(result, index, arguments[index++]);
    result.length = aLen;
    return result;
  }
});


/***/ }),
/* 1009 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.13 Array.prototype.join(separator)
var $export = __webpack_require__(10);
var toIObject = __webpack_require__(89);
var arrayJoin = [].join;

// fallback for not array-like strings
$export($export.P + $export.F * (__webpack_require__(273) != Object || !__webpack_require__(101)(arrayJoin)), 'Array', {
  join: function join(separator) {
    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
  }
});


/***/ }),
/* 1010 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(10);
var html = __webpack_require__(423);
var cof = __webpack_require__(132);
var toAbsoluteIndex = __webpack_require__(177);
var toLength = __webpack_require__(54);
var arraySlice = [].slice;

// fallback for not array-like ES3 strings and DOM objects
$export($export.P + $export.F * __webpack_require__(32)(function () {
  if (html) arraySlice.call(html);
}), 'Array', {
  slice: function slice(begin, end) {
    var len = toLength(this.length);
    var klass = cof(this);
    end = end === undefined ? len : end;
    if (klass == 'Array') return arraySlice.call(this, begin, end);
    var start = toAbsoluteIndex(begin, len);
    var upTo = toAbsoluteIndex(end, len);
    var size = toLength(upTo - start);
    var cloned = Array(size);
    var i = 0;
    for (; i < size; i++) cloned[i] = klass == 'String'
      ? this.charAt(start + i)
      : this[start + i];
    return cloned;
  }
});


/***/ }),
/* 1011 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(10);
var aFunction = __webpack_require__(88);
var toObject = __webpack_require__(58);
var fails = __webpack_require__(32);
var $sort = [].sort;
var test = [1, 2, 3];

$export($export.P + $export.F * (fails(function () {
  // IE8-
  test.sort(undefined);
}) || !fails(function () {
  // V8 bug
  test.sort(null);
  // Old WebKit
}) || !__webpack_require__(101)($sort)), 'Array', {
  // 22.1.3.25 Array.prototype.sort(comparefn)
  sort: function sort(comparefn) {
    return comparefn === undefined
      ? $sort.call(toObject(this))
      : $sort.call(toObject(this), aFunction(comparefn));
  }
});


/***/ }),
/* 1012 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(10);
var $forEach = __webpack_require__(113)(0);
var STRICT = __webpack_require__(101)([].forEach, true);

$export($export.P + $export.F * !STRICT, 'Array', {
  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
  forEach: function forEach(callbackfn /* , thisArg */) {
    return $forEach(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 1013 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(31);
var isArray = __webpack_require__(327);
var SPECIES = __webpack_require__(41)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),
/* 1014 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(10);
var $map = __webpack_require__(113)(1);

$export($export.P + $export.F * !__webpack_require__(101)([].map, true), 'Array', {
  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 1015 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(10);
var $filter = __webpack_require__(113)(2);

$export($export.P + $export.F * !__webpack_require__(101)([].filter, true), 'Array', {
  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 1016 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(10);
var $some = __webpack_require__(113)(3);

$export($export.P + $export.F * !__webpack_require__(101)([].some, true), 'Array', {
  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
  some: function some(callbackfn /* , thisArg */) {
    return $some(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 1017 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(10);
var $every = __webpack_require__(113)(4);

$export($export.P + $export.F * !__webpack_require__(101)([].every, true), 'Array', {
  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
  every: function every(callbackfn /* , thisArg */) {
    return $every(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 1018 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(10);
var $reduce = __webpack_require__(611);

$export($export.P + $export.F * !__webpack_require__(101)([].reduce, true), 'Array', {
  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
  reduce: function reduce(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
  }
});


/***/ }),
/* 1019 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(10);
var $reduce = __webpack_require__(611);

$export($export.P + $export.F * !__webpack_require__(101)([].reduceRight, true), 'Array', {
  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
  }
});


/***/ }),
/* 1020 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(10);
var $indexOf = __webpack_require__(326)(false);
var $native = [].indexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(101)($native)), 'Array', {
  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    return NEGATIVE_ZERO
      // convert -0 to +0
      ? $native.apply(this, arguments) || 0
      : $indexOf(this, searchElement, arguments[1]);
  }
});


/***/ }),
/* 1021 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(10);
var toIObject = __webpack_require__(89);
var toInteger = __webpack_require__(111);
var toLength = __webpack_require__(54);
var $native = [].lastIndexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(101)($native)), 'Array', {
  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
    // convert -0 to +0
    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
    var O = toIObject(this);
    var length = toLength(O.length);
    var index = length - 1;
    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
    if (index < 0) index = length + index;
    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
    return -1;
  }
});


/***/ }),
/* 1022 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
var $export = __webpack_require__(10);

$export($export.P, 'Array', { copyWithin: __webpack_require__(612) });

__webpack_require__(152)('copyWithin');


/***/ }),
/* 1023 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
var $export = __webpack_require__(10);

$export($export.P, 'Array', { fill: __webpack_require__(428) });

__webpack_require__(152)('fill');


/***/ }),
/* 1024 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
var $export = __webpack_require__(10);
var $find = __webpack_require__(113)(5);
var KEY = 'find';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(152)(KEY);


/***/ }),
/* 1025 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
var $export = __webpack_require__(10);
var $find = __webpack_require__(113)(6);
var KEY = 'findIndex';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(152)(KEY);


/***/ }),
/* 1026 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(218)('Array');


/***/ }),
/* 1027 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1028);
module.exports = __webpack_require__(37).Date.now;


/***/ }),
/* 1028 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.3.1 / 15.9.4.4 Date.now()
var $export = __webpack_require__(10);

$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });


/***/ }),
/* 1029 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1030);
var toPrimitive = __webpack_require__(614);
module.exports = function (it, hint) {
  return toPrimitive.call(it, hint);
};


/***/ }),
/* 1030 */
/***/ (function(module, exports, __webpack_require__) {

var TO_PRIMITIVE = __webpack_require__(41)('toPrimitive');
var proto = Date.prototype;

if (!(TO_PRIMITIVE in proto)) __webpack_require__(87)(proto, TO_PRIMITIVE, __webpack_require__(614));


/***/ }),
/* 1031 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1032);
var $toString = Date.prototype.toString;
module.exports = function toString(it) {
  return $toString.call(it);
};


/***/ }),
/* 1032 */
/***/ (function(module, exports, __webpack_require__) {

var DateProto = Date.prototype;
var INVALID_DATE = 'Invalid Date';
var TO_STRING = 'toString';
var $toString = DateProto[TO_STRING];
var getTime = DateProto.getTime;
if (new Date(NaN) + '' != INVALID_DATE) {
  __webpack_require__(74)(DateProto, TO_STRING, function toString() {
    var value = getTime.call(this);
    // eslint-disable-next-line no-self-compare
    return value === value ? $toString.call(this) : INVALID_DATE;
  });
}


/***/ }),
/* 1033 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1034);
__webpack_require__(1035);
__webpack_require__(1036);
module.exports = __webpack_require__(37).Function;


/***/ }),
/* 1034 */
/***/ (function(module, exports, __webpack_require__) {

// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
var $export = __webpack_require__(10);

$export($export.P, 'Function', { bind: __webpack_require__(615) });


/***/ }),
/* 1035 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(46).f;
var FProto = Function.prototype;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// 19.2.4.2 name
NAME in FProto || __webpack_require__(47) && dP(FProto, NAME, {
  configurable: true,
  get: function () {
    try {
      return ('' + this).match(nameRE)[1];
    } catch (e) {
      return '';
    }
  }
});


/***/ }),
/* 1036 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isObject = __webpack_require__(31);
var getPrototypeOf = __webpack_require__(133);
var HAS_INSTANCE = __webpack_require__(41)('hasInstance');
var FunctionProto = Function.prototype;
// 19.2.3.6 Function.prototype[@@hasInstance](V)
if (!(HAS_INSTANCE in FunctionProto)) __webpack_require__(46).f(FunctionProto, HAS_INSTANCE, { value: function (O) {
  if (typeof this != 'function' || !isObject(O)) return false;
  if (!isObject(this.prototype)) return O instanceof this;
  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
  while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
  return false;
} });


/***/ }),
/* 1037 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(153);
__webpack_require__(272);
__webpack_require__(331);
__webpack_require__(1038);
module.exports = __webpack_require__(37).Map;


/***/ }),
/* 1038 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(617);
var validate = __webpack_require__(221);
var MAP = 'Map';

// 23.1 Map Objects
module.exports = __webpack_require__(333)(MAP, function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(validate(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
  }
}, strong, true);


/***/ }),
/* 1039 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1040);
__webpack_require__(1041);
__webpack_require__(1042);
__webpack_require__(1043);
__webpack_require__(1044);
__webpack_require__(1045);
__webpack_require__(1046);
__webpack_require__(1047);
__webpack_require__(1049);
__webpack_require__(1050);
__webpack_require__(1051);
__webpack_require__(1052);
__webpack_require__(1053);
__webpack_require__(1054);
__webpack_require__(1055);
__webpack_require__(1056);
__webpack_require__(1057);
module.exports = __webpack_require__(37).Math;


/***/ }),
/* 1040 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.3 Math.acosh(x)
var $export = __webpack_require__(10);
var log1p = __webpack_require__(618);
var sqrt = Math.sqrt;
var $acosh = Math.acosh;

$export($export.S + $export.F * !($acosh
  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
  && Math.floor($acosh(Number.MAX_VALUE)) == 710
  // Tor Browser bug: Math.acosh(Infinity) -> NaN
  && $acosh(Infinity) == Infinity
), 'Math', {
  acosh: function acosh(x) {
    return (x = +x) < 1 ? NaN : x > 94906265.62425156
      ? Math.log(x) + Math.LN2
      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
  }
});


/***/ }),
/* 1041 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.5 Math.asinh(x)
var $export = __webpack_require__(10);
var $asinh = Math.asinh;

function asinh(x) {
  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
}

// Tor Browser bug: Math.asinh(0) -> -0
$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });


/***/ }),
/* 1042 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.7 Math.atanh(x)
var $export = __webpack_require__(10);
var $atanh = Math.atanh;

// Tor Browser bug: Math.atanh(-0) -> 0
$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
  atanh: function atanh(x) {
    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
  }
});


/***/ }),
/* 1043 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.9 Math.cbrt(x)
var $export = __webpack_require__(10);
var sign = __webpack_require__(431);

$export($export.S, 'Math', {
  cbrt: function cbrt(x) {
    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
  }
});


/***/ }),
/* 1044 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.11 Math.clz32(x)
var $export = __webpack_require__(10);

$export($export.S, 'Math', {
  clz32: function clz32(x) {
    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
  }
});


/***/ }),
/* 1045 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.12 Math.cosh(x)
var $export = __webpack_require__(10);
var exp = Math.exp;

$export($export.S, 'Math', {
  cosh: function cosh(x) {
    return (exp(x = +x) + exp(-x)) / 2;
  }
});


/***/ }),
/* 1046 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.14 Math.expm1(x)
var $export = __webpack_require__(10);
var $expm1 = __webpack_require__(432);

$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });


/***/ }),
/* 1047 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var $export = __webpack_require__(10);

$export($export.S, 'Math', { fround: __webpack_require__(1048) });


/***/ }),
/* 1048 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var sign = __webpack_require__(431);
var pow = Math.pow;
var EPSILON = pow(2, -52);
var EPSILON32 = pow(2, -23);
var MAX32 = pow(2, 127) * (2 - EPSILON32);
var MIN32 = pow(2, -126);

var roundTiesToEven = function (n) {
  return n + 1 / EPSILON - 1 / EPSILON;
};

module.exports = Math.fround || function fround(x) {
  var $abs = Math.abs(x);
  var $sign = sign(x);
  var a, result;
  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
  a = (1 + EPSILON32 / EPSILON) * $abs;
  result = a - (a - $abs);
  // eslint-disable-next-line no-self-compare
  if (result > MAX32 || result != result) return $sign * Infinity;
  return $sign * result;
};


/***/ }),
/* 1049 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
var $export = __webpack_require__(10);
var abs = Math.abs;

$export($export.S, 'Math', {
  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
    var sum = 0;
    var i = 0;
    var aLen = arguments.length;
    var larg = 0;
    var arg, div;
    while (i < aLen) {
      arg = abs(arguments[i++]);
      if (larg < arg) {
        div = larg / arg;
        sum = sum * div * div + 1;
        larg = arg;
      } else if (arg > 0) {
        div = arg / larg;
        sum += div * div;
      } else sum += arg;
    }
    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
  }
});


/***/ }),
/* 1050 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.18 Math.imul(x, y)
var $export = __webpack_require__(10);
var $imul = Math.imul;

// some WebKit versions fails with big numbers, some has wrong arity
$export($export.S + $export.F * __webpack_require__(32)(function () {
  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
}), 'Math', {
  imul: function imul(x, y) {
    var UINT16 = 0xffff;
    var xn = +x;
    var yn = +y;
    var xl = UINT16 & xn;
    var yl = UINT16 & yn;
    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
  }
});


/***/ }),
/* 1051 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.21 Math.log10(x)
var $export = __webpack_require__(10);

$export($export.S, 'Math', {
  log10: function log10(x) {
    return Math.log(x) * Math.LOG10E;
  }
});


/***/ }),
/* 1052 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.20 Math.log1p(x)
var $export = __webpack_require__(10);

$export($export.S, 'Math', { log1p: __webpack_require__(618) });


/***/ }),
/* 1053 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.22 Math.log2(x)
var $export = __webpack_require__(10);

$export($export.S, 'Math', {
  log2: function log2(x) {
    return Math.log(x) / Math.LN2;
  }
});


/***/ }),
/* 1054 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.28 Math.sign(x)
var $export = __webpack_require__(10);

$export($export.S, 'Math', { sign: __webpack_require__(431) });


/***/ }),
/* 1055 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.30 Math.sinh(x)
var $export = __webpack_require__(10);
var expm1 = __webpack_require__(432);
var exp = Math.exp;

// V8 near Chromium 38 has a problem with very small numbers
$export($export.S + $export.F * __webpack_require__(32)(function () {
  return !Math.sinh(-2e-17) != -2e-17;
}), 'Math', {
  sinh: function sinh(x) {
    return Math.abs(x = +x) < 1
      ? (expm1(x) - expm1(-x)) / 2
      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
  }
});


/***/ }),
/* 1056 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.33 Math.tanh(x)
var $export = __webpack_require__(10);
var expm1 = __webpack_require__(432);
var exp = Math.exp;

$export($export.S, 'Math', {
  tanh: function tanh(x) {
    var a = expm1(x = +x);
    var b = expm1(-x);
    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
  }
});


/***/ }),
/* 1057 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.34 Math.trunc(x)
var $export = __webpack_require__(10);

$export($export.S, 'Math', {
  trunc: function trunc(it) {
    return (it > 0 ? Math.floor : Math.ceil)(it);
  }
});


/***/ }),
/* 1058 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1059);
__webpack_require__(1060);
__webpack_require__(1061);
__webpack_require__(1062);
__webpack_require__(1063);
__webpack_require__(1064);
__webpack_require__(1065);
__webpack_require__(1066);
__webpack_require__(1067);
__webpack_require__(1068);
__webpack_require__(1069);
__webpack_require__(1070);
module.exports = __webpack_require__(37).Number;


/***/ }),
/* 1059 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(35);
var has = __webpack_require__(75);
var cof = __webpack_require__(132);
var inheritIfRequired = __webpack_require__(429);
var toPrimitive = __webpack_require__(131);
var fails = __webpack_require__(32);
var gOPN = __webpack_require__(178).f;
var gOPD = __webpack_require__(90).f;
var dP = __webpack_require__(46).f;
var $trim = __webpack_require__(334).trim;
var NUMBER = 'Number';
var $Number = global[NUMBER];
var Base = $Number;
var proto = $Number.prototype;
// Opera ~12 has broken Object#toString
var BROKEN_COF = cof(__webpack_require__(175)(proto)) == NUMBER;
var TRIM = 'trim' in String.prototype;

// 7.1.3 ToNumber(argument)
var toNumber = function (argument) {
  var it = toPrimitive(argument, false);
  if (typeof it == 'string' && it.length > 2) {
    it = TRIM ? it.trim() : $trim(it, 3);
    var first = it.charCodeAt(0);
    var third, radix, maxCode;
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
        default: return +it;
      }
      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
        code = digits.charCodeAt(i);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
  $Number = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var that = this;
    return that instanceof $Number
      // check on 1..constructor(foo) case
      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
  };
  for (var keys = __webpack_require__(47) ? gOPN(Base) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES6 (in case, if modules with ES6 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (has(Base, key = keys[j]) && !has($Number, key)) {
      dP($Number, key, gOPD(Base, key));
    }
  }
  $Number.prototype = proto;
  proto.constructor = $Number;
  __webpack_require__(74)(global, NUMBER, $Number);
}


/***/ }),
/* 1060 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(10);
var toInteger = __webpack_require__(111);
var aNumberValue = __webpack_require__(619);
var repeat = __webpack_require__(620);
var $toFixed = 1.0.toFixed;
var floor = Math.floor;
var data = [0, 0, 0, 0, 0, 0];
var ERROR = 'Number.toFixed: incorrect invocation!';
var ZERO = '0';

var multiply = function (n, c) {
  var i = -1;
  var c2 = c;
  while (++i < 6) {
    c2 += n * data[i];
    data[i] = c2 % 1e7;
    c2 = floor(c2 / 1e7);
  }
};
var divide = function (n) {
  var i = 6;
  var c = 0;
  while (--i >= 0) {
    c += data[i];
    data[i] = floor(c / n);
    c = (c % n) * 1e7;
  }
};
var numToString = function () {
  var i = 6;
  var s = '';
  while (--i >= 0) {
    if (s !== '' || i === 0 || data[i] !== 0) {
      var t = String(data[i]);
      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
    }
  } return s;
};
var pow = function (x, n, acc) {
  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
};
var log = function (x) {
  var n = 0;
  var x2 = x;
  while (x2 >= 4096) {
    n += 12;
    x2 /= 4096;
  }
  while (x2 >= 2) {
    n += 1;
    x2 /= 2;
  } return n;
};

$export($export.P + $export.F * (!!$toFixed && (
  0.00008.toFixed(3) !== '0.000' ||
  0.9.toFixed(0) !== '1' ||
  1.255.toFixed(2) !== '1.25' ||
  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
) || !__webpack_require__(32)(function () {
  // V8 ~ Android 4.3-
  $toFixed.call({});
})), 'Number', {
  toFixed: function toFixed(fractionDigits) {
    var x = aNumberValue(this, ERROR);
    var f = toInteger(fractionDigits);
    var s = '';
    var m = ZERO;
    var e, z, j, k;
    if (f < 0 || f > 20) throw RangeError(ERROR);
    // eslint-disable-next-line no-self-compare
    if (x != x) return 'NaN';
    if (x <= -1e21 || x >= 1e21) return String(x);
    if (x < 0) {
      s = '-';
      x = -x;
    }
    if (x > 1e-21) {
      e = log(x * pow(2, 69, 1)) - 69;
      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
      z *= 0x10000000000000;
      e = 52 - e;
      if (e > 0) {
        multiply(0, z);
        j = f;
        while (j >= 7) {
          multiply(1e7, 0);
          j -= 7;
        }
        multiply(pow(10, j, 1), 0);
        j = e - 1;
        while (j >= 23) {
          divide(1 << 23);
          j -= 23;
        }
        divide(1 << j);
        multiply(1, 1);
        divide(2);
        m = numToString();
      } else {
        multiply(0, z);
        multiply(1 << -e, 0);
        m = numToString() + repeat.call(ZERO, f);
      }
    }
    if (f > 0) {
      k = m.length;
      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
    } else {
      m = s + m;
    } return m;
  }
});


/***/ }),
/* 1061 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(10);
var $fails = __webpack_require__(32);
var aNumberValue = __webpack_require__(619);
var $toPrecision = 1.0.toPrecision;

$export($export.P + $export.F * ($fails(function () {
  // IE7-
  return $toPrecision.call(1, undefined) !== '1';
}) || !$fails(function () {
  // V8 ~ Android 4.3-
  $toPrecision.call({});
})), 'Number', {
  toPrecision: function toPrecision(precision) {
    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
  }
});


/***/ }),
/* 1062 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.1 Number.EPSILON
var $export = __webpack_require__(10);

$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ }),
/* 1063 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.2 Number.isFinite(number)
var $export = __webpack_require__(10);
var _isFinite = __webpack_require__(35).isFinite;

$export($export.S, 'Number', {
  isFinite: function isFinite(it) {
    return typeof it == 'number' && _isFinite(it);
  }
});


/***/ }),
/* 1064 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var $export = __webpack_require__(10);

$export($export.S, 'Number', { isInteger: __webpack_require__(621) });


/***/ }),
/* 1065 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.4 Number.isNaN(number)
var $export = __webpack_require__(10);

$export($export.S, 'Number', {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare
    return number != number;
  }
});


/***/ }),
/* 1066 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.5 Number.isSafeInteger(number)
var $export = __webpack_require__(10);
var isInteger = __webpack_require__(621);
var abs = Math.abs;

$export($export.S, 'Number', {
  isSafeInteger: function isSafeInteger(number) {
    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
  }
});


/***/ }),
/* 1067 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.6 Number.MAX_SAFE_INTEGER
var $export = __webpack_require__(10);

$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ }),
/* 1068 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.10 Number.MIN_SAFE_INTEGER
var $export = __webpack_require__(10);

$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ }),
/* 1069 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(10);
var $parseFloat = __webpack_require__(622);
// 20.1.2.12 Number.parseFloat(string)
$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });


/***/ }),
/* 1070 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(10);
var $parseInt = __webpack_require__(623);
// 20.1.2.13 Number.parseInt(string, radix)
$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });


/***/ }),
/* 1071 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(624);
__webpack_require__(1074);
__webpack_require__(1075);
__webpack_require__(1076);
__webpack_require__(1077);
__webpack_require__(1078);
__webpack_require__(1079);
__webpack_require__(1080);
__webpack_require__(1081);
__webpack_require__(1082);
__webpack_require__(1083);
__webpack_require__(1084);
__webpack_require__(1085);
__webpack_require__(1086);
__webpack_require__(1087);
__webpack_require__(1088);
__webpack_require__(1090);
__webpack_require__(153);

module.exports = __webpack_require__(37).Object;


/***/ }),
/* 1072 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(35);
var core = __webpack_require__(37);
var LIBRARY = __webpack_require__(172);
var wksExt = __webpack_require__(625);
var defineProperty = __webpack_require__(46).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 1073 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(176);
var gOPS = __webpack_require__(335);
var pIE = __webpack_require__(274);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 1074 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(10);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(175) });


/***/ }),
/* 1075 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(10);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(47), 'Object', { defineProperty: __webpack_require__(46).f });


/***/ }),
/* 1076 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(10);
// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
$export($export.S + $export.F * !__webpack_require__(47), 'Object', { defineProperties: __webpack_require__(608) });


/***/ }),
/* 1077 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__(89);
var $getOwnPropertyDescriptor = __webpack_require__(90).f;

__webpack_require__(114)('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});


/***/ }),
/* 1078 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(58);
var $getPrototypeOf = __webpack_require__(133);

__webpack_require__(114)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 1079 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(58);
var $keys = __webpack_require__(176);

__webpack_require__(114)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 1080 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 Object.getOwnPropertyNames(O)
__webpack_require__(114)('getOwnPropertyNames', function () {
  return __webpack_require__(626).f;
});


/***/ }),
/* 1081 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.5 Object.freeze(O)
var isObject = __webpack_require__(31);
var meta = __webpack_require__(154).onFreeze;

__webpack_require__(114)('freeze', function ($freeze) {
  return function freeze(it) {
    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
  };
});


/***/ }),
/* 1082 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.17 Object.seal(O)
var isObject = __webpack_require__(31);
var meta = __webpack_require__(154).onFreeze;

__webpack_require__(114)('seal', function ($seal) {
  return function seal(it) {
    return $seal && isObject(it) ? $seal(meta(it)) : it;
  };
});


/***/ }),
/* 1083 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.15 Object.preventExtensions(O)
var isObject = __webpack_require__(31);
var meta = __webpack_require__(154).onFreeze;

__webpack_require__(114)('preventExtensions', function ($preventExtensions) {
  return function preventExtensions(it) {
    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
  };
});


/***/ }),
/* 1084 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.12 Object.isFrozen(O)
var isObject = __webpack_require__(31);

__webpack_require__(114)('isFrozen', function ($isFrozen) {
  return function isFrozen(it) {
    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
  };
});


/***/ }),
/* 1085 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.13 Object.isSealed(O)
var isObject = __webpack_require__(31);

__webpack_require__(114)('isSealed', function ($isSealed) {
  return function isSealed(it) {
    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
  };
});


/***/ }),
/* 1086 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.11 Object.isExtensible(O)
var isObject = __webpack_require__(31);

__webpack_require__(114)('isExtensible', function ($isExtensible) {
  return function isExtensible(it) {
    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
  };
});


/***/ }),
/* 1087 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(10);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(627) });


/***/ }),
/* 1088 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.10 Object.is(value1, value2)
var $export = __webpack_require__(10);
$export($export.S, 'Object', { is: __webpack_require__(1089) });


/***/ }),
/* 1089 */
/***/ (function(module, exports) {

// 7.2.9 SameValue(x, y)
module.exports = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};


/***/ }),
/* 1090 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(10);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(430).set });


/***/ }),
/* 1091 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1092);
module.exports = __webpack_require__(37).parseFloat;


/***/ }),
/* 1092 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(10);
var $parseFloat = __webpack_require__(622);
// 18.2.4 parseFloat(string)
$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });


/***/ }),
/* 1093 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1094);
module.exports = __webpack_require__(37).parseInt;


/***/ }),
/* 1094 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(10);
var $parseInt = __webpack_require__(623);
// 18.2.5 parseInt(string, radix)
$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });


/***/ }),
/* 1095 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(153);
__webpack_require__(272);
__webpack_require__(331);
__webpack_require__(1096);
module.exports = __webpack_require__(37).Promise;


/***/ }),
/* 1096 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(172);
var global = __webpack_require__(35);
var ctx = __webpack_require__(112);
var classof = __webpack_require__(328);
var $export = __webpack_require__(10);
var isObject = __webpack_require__(31);
var aFunction = __webpack_require__(88);
var anInstance = __webpack_require__(220);
var forOf = __webpack_require__(332);
var speciesConstructor = __webpack_require__(434);
var task = __webpack_require__(628).set;
var microtask = __webpack_require__(1097)();
var newPromiseCapabilityModule = __webpack_require__(629);
var perform = __webpack_require__(1098);
var promiseResolve = __webpack_require__(1099);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(41)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value);
            if (domain) domain.exit();
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  if (promise._h == 1) return false;
  var chain = promise._a || promise._c;
  var i = 0;
  var reaction;
  while (chain.length > i) {
    reaction = chain[i++];
    if (reaction.fail || !isUnhandled(reaction.promise)) return false;
  } return true;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(219)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(217)($Promise, PROMISE);
__webpack_require__(218)(PROMISE);
Wrapper = __webpack_require__(37)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(329)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 1097 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(35);
var macrotask = __webpack_require__(628).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(132)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver
  } else if (Observer) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    var promise = Promise.resolve();
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 1098 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 1099 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(38);
var isObject = __webpack_require__(31);
var newPromiseCapability = __webpack_require__(629);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 1100 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1101);
__webpack_require__(1102);
__webpack_require__(1103);
__webpack_require__(1104);
__webpack_require__(1105);
__webpack_require__(1106);
__webpack_require__(1107);
__webpack_require__(1108);
__webpack_require__(1109);
__webpack_require__(1110);
__webpack_require__(1111);
__webpack_require__(1112);
__webpack_require__(1113);
__webpack_require__(1114);
module.exports = __webpack_require__(37).Reflect;


/***/ }),
/* 1101 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
var $export = __webpack_require__(10);
var aFunction = __webpack_require__(88);
var anObject = __webpack_require__(38);
var rApply = (__webpack_require__(35).Reflect || {}).apply;
var fApply = Function.apply;
// MS Edge argumentsList argument is optional
$export($export.S + $export.F * !__webpack_require__(32)(function () {
  rApply(function () { /* empty */ });
}), 'Reflect', {
  apply: function apply(target, thisArgument, argumentsList) {
    var T = aFunction(target);
    var L = anObject(argumentsList);
    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
  }
});


/***/ }),
/* 1102 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
var $export = __webpack_require__(10);
var create = __webpack_require__(175);
var aFunction = __webpack_require__(88);
var anObject = __webpack_require__(38);
var isObject = __webpack_require__(31);
var fails = __webpack_require__(32);
var bind = __webpack_require__(615);
var rConstruct = (__webpack_require__(35).Reflect || {}).construct;

// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function () {
  function F() { /* empty */ }
  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
});
var ARGS_BUG = !fails(function () {
  rConstruct(function () { /* empty */ });
});

$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
  construct: function construct(Target, args /* , newTarget */) {
    aFunction(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
    if (Target == newTarget) {
      // w/o altered newTarget, optimization for 0-4 arguments
      switch (args.length) {
        case 0: return new Target();
        case 1: return new Target(args[0]);
        case 2: return new Target(args[0], args[1]);
        case 3: return new Target(args[0], args[1], args[2]);
        case 4: return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      $args.push.apply($args, args);
      return new (bind.apply(Target, $args))();
    }
    // with altered newTarget, not support built-in constructors
    var proto = newTarget.prototype;
    var instance = create(isObject(proto) ? proto : Object.prototype);
    var result = Function.apply.call(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});


/***/ }),
/* 1103 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
var dP = __webpack_require__(46);
var $export = __webpack_require__(10);
var anObject = __webpack_require__(38);
var toPrimitive = __webpack_require__(131);

// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
$export($export.S + $export.F * __webpack_require__(32)(function () {
  // eslint-disable-next-line no-undef
  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
}), 'Reflect', {
  defineProperty: function defineProperty(target, propertyKey, attributes) {
    anObject(target);
    propertyKey = toPrimitive(propertyKey, true);
    anObject(attributes);
    try {
      dP.f(target, propertyKey, attributes);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 1104 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.4 Reflect.deleteProperty(target, propertyKey)
var $export = __webpack_require__(10);
var gOPD = __webpack_require__(90).f;
var anObject = __webpack_require__(38);

$export($export.S, 'Reflect', {
  deleteProperty: function deleteProperty(target, propertyKey) {
    var desc = gOPD(anObject(target), propertyKey);
    return desc && !desc.configurable ? false : delete target[propertyKey];
  }
});


/***/ }),
/* 1105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 26.1.5 Reflect.enumerate(target)
var $export = __webpack_require__(10);
var anObject = __webpack_require__(38);
var Enumerate = function (iterated) {
  this._t = anObject(iterated); // target
  this._i = 0;                  // next index
  var keys = this._k = [];      // keys
  var key;
  for (key in iterated) keys.push(key);
};
__webpack_require__(607)(Enumerate, 'Object', function () {
  var that = this;
  var keys = that._k;
  var key;
  do {
    if (that._i >= keys.length) return { value: undefined, done: true };
  } while (!((key = keys[that._i++]) in that._t));
  return { value: key, done: false };
});

$export($export.S, 'Reflect', {
  enumerate: function enumerate(target) {
    return new Enumerate(target);
  }
});


/***/ }),
/* 1106 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.6 Reflect.get(target, propertyKey [, receiver])
var gOPD = __webpack_require__(90);
var getPrototypeOf = __webpack_require__(133);
var has = __webpack_require__(75);
var $export = __webpack_require__(10);
var isObject = __webpack_require__(31);
var anObject = __webpack_require__(38);

function get(target, propertyKey /* , receiver */) {
  var receiver = arguments.length < 3 ? target : arguments[2];
  var desc, proto;
  if (anObject(target) === receiver) return target[propertyKey];
  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
    ? desc.value
    : desc.get !== undefined
      ? desc.get.call(receiver)
      : undefined;
  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
}

$export($export.S, 'Reflect', { get: get });


/***/ }),
/* 1107 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
var gOPD = __webpack_require__(90);
var $export = __webpack_require__(10);
var anObject = __webpack_require__(38);

$export($export.S, 'Reflect', {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
    return gOPD.f(anObject(target), propertyKey);
  }
});


/***/ }),
/* 1108 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.8 Reflect.getPrototypeOf(target)
var $export = __webpack_require__(10);
var getProto = __webpack_require__(133);
var anObject = __webpack_require__(38);

$export($export.S, 'Reflect', {
  getPrototypeOf: function getPrototypeOf(target) {
    return getProto(anObject(target));
  }
});


/***/ }),
/* 1109 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.9 Reflect.has(target, propertyKey)
var $export = __webpack_require__(10);

$export($export.S, 'Reflect', {
  has: function has(target, propertyKey) {
    return propertyKey in target;
  }
});


/***/ }),
/* 1110 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.10 Reflect.isExtensible(target)
var $export = __webpack_require__(10);
var anObject = __webpack_require__(38);
var $isExtensible = Object.isExtensible;

$export($export.S, 'Reflect', {
  isExtensible: function isExtensible(target) {
    anObject(target);
    return $isExtensible ? $isExtensible(target) : true;
  }
});


/***/ }),
/* 1111 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.11 Reflect.ownKeys(target)
var $export = __webpack_require__(10);

$export($export.S, 'Reflect', { ownKeys: __webpack_require__(630) });


/***/ }),
/* 1112 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.12 Reflect.preventExtensions(target)
var $export = __webpack_require__(10);
var anObject = __webpack_require__(38);
var $preventExtensions = Object.preventExtensions;

$export($export.S, 'Reflect', {
  preventExtensions: function preventExtensions(target) {
    anObject(target);
    try {
      if ($preventExtensions) $preventExtensions(target);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 1113 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
var dP = __webpack_require__(46);
var gOPD = __webpack_require__(90);
var getPrototypeOf = __webpack_require__(133);
var has = __webpack_require__(75);
var $export = __webpack_require__(10);
var createDesc = __webpack_require__(173);
var anObject = __webpack_require__(38);
var isObject = __webpack_require__(31);

function set(target, propertyKey, V /* , receiver */) {
  var receiver = arguments.length < 4 ? target : arguments[3];
  var ownDesc = gOPD.f(anObject(target), propertyKey);
  var existingDescriptor, proto;
  if (!ownDesc) {
    if (isObject(proto = getPrototypeOf(target))) {
      return set(proto, propertyKey, V, receiver);
    }
    ownDesc = createDesc(0);
  }
  if (has(ownDesc, 'value')) {
    if (ownDesc.writable === false || !isObject(receiver)) return false;
    existingDescriptor = gOPD.f(receiver, propertyKey) || createDesc(0);
    existingDescriptor.value = V;
    dP.f(receiver, propertyKey, existingDescriptor);
    return true;
  }
  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
}

$export($export.S, 'Reflect', { set: set });


/***/ }),
/* 1114 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.14 Reflect.setPrototypeOf(target, proto)
var $export = __webpack_require__(10);
var setProto = __webpack_require__(430);

if (setProto) $export($export.S, 'Reflect', {
  setPrototypeOf: function setPrototypeOf(target, proto) {
    setProto.check(target, proto);
    try {
      setProto.set(target, proto);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 1115 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1116);
__webpack_require__(1117);
__webpack_require__(631);
__webpack_require__(632);
__webpack_require__(633);
__webpack_require__(634);
__webpack_require__(635);
module.exports = __webpack_require__(37).RegExp;


/***/ }),
/* 1116 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(35);
var inheritIfRequired = __webpack_require__(429);
var dP = __webpack_require__(46).f;
var gOPN = __webpack_require__(178).f;
var isRegExp = __webpack_require__(435);
var $flags = __webpack_require__(436);
var $RegExp = global.RegExp;
var Base = $RegExp;
var proto = $RegExp.prototype;
var re1 = /a/g;
var re2 = /a/g;
// "new" creates a new object, old webkit buggy here
var CORRECT_NEW = new $RegExp(re1) !== re1;

if (__webpack_require__(47) && (!CORRECT_NEW || __webpack_require__(32)(function () {
  re2[__webpack_require__(41)('match')] = false;
  // RegExp constructor can alter flags and IsRegExp works correct with @@match
  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
}))) {
  $RegExp = function RegExp(p, f) {
    var tiRE = this instanceof $RegExp;
    var piRE = isRegExp(p);
    var fiU = f === undefined;
    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
      : inheritIfRequired(CORRECT_NEW
        ? new Base(piRE && !fiU ? p.source : p, f)
        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
      , tiRE ? this : proto, $RegExp);
  };
  var proxy = function (key) {
    key in $RegExp || dP($RegExp, key, {
      configurable: true,
      get: function () { return Base[key]; },
      set: function (it) { Base[key] = it; }
    });
  };
  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
  proto.constructor = $RegExp;
  $RegExp.prototype = proto;
  __webpack_require__(74)(global, 'RegExp', $RegExp);
}

__webpack_require__(218)('RegExp');


/***/ }),
/* 1117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(631);
var anObject = __webpack_require__(38);
var $flags = __webpack_require__(436);
var DESCRIPTORS = __webpack_require__(47);
var TO_STRING = 'toString';
var $toString = /./[TO_STRING];

var define = function (fn) {
  __webpack_require__(74)(RegExp.prototype, TO_STRING, fn, true);
};

// 21.2.5.14 RegExp.prototype.toString()
if (__webpack_require__(32)(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
  define(function toString() {
    var R = anObject(this);
    return '/'.concat(R.source, '/',
      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
  });
// FF44- RegExp#toString has a wrong name
} else if ($toString.name != TO_STRING) {
  define(function toString() {
    return $toString.call(this);
  });
}


/***/ }),
/* 1118 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(153);
__webpack_require__(272);
__webpack_require__(331);
__webpack_require__(1119);
module.exports = __webpack_require__(37).Set;


/***/ }),
/* 1119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(617);
var validate = __webpack_require__(221);
var SET = 'Set';

// 23.2 Set Objects
module.exports = __webpack_require__(333)(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);


/***/ }),
/* 1120 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1121);
__webpack_require__(1122);
__webpack_require__(1123);
__webpack_require__(272);
__webpack_require__(1124);
__webpack_require__(1125);
__webpack_require__(1126);
__webpack_require__(1127);
__webpack_require__(1128);
__webpack_require__(1129);
__webpack_require__(1130);
__webpack_require__(1131);
__webpack_require__(1132);
__webpack_require__(1133);
__webpack_require__(1134);
__webpack_require__(1135);
__webpack_require__(1136);
__webpack_require__(1137);
__webpack_require__(1138);
__webpack_require__(1139);
__webpack_require__(1140);
__webpack_require__(1141);
__webpack_require__(632);
__webpack_require__(633);
__webpack_require__(634);
__webpack_require__(635);
module.exports = __webpack_require__(37).String;


/***/ }),
/* 1121 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(10);
var toAbsoluteIndex = __webpack_require__(177);
var fromCharCode = String.fromCharCode;
var $fromCodePoint = String.fromCodePoint;

// length should be 1, old FF problem
$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
  // 21.1.2.2 String.fromCodePoint(...codePoints)
  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
    var res = [];
    var aLen = arguments.length;
    var i = 0;
    var code;
    while (aLen > i) {
      code = +arguments[i++];
      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
      res.push(code < 0x10000
        ? fromCharCode(code)
        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
      );
    } return res.join('');
  }
});


/***/ }),
/* 1122 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(10);
var toIObject = __webpack_require__(89);
var toLength = __webpack_require__(54);

$export($export.S, 'String', {
  // 21.1.2.4 String.raw(callSite, ...substitutions)
  raw: function raw(callSite) {
    var tpl = toIObject(callSite.raw);
    var len = toLength(tpl.length);
    var aLen = arguments.length;
    var res = [];
    var i = 0;
    while (len > i) {
      res.push(String(tpl[i++]));
      if (i < aLen) res.push(String(arguments[i]));
    } return res.join('');
  }
});


/***/ }),
/* 1123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.1.3.25 String.prototype.trim()
__webpack_require__(334)('trim', function ($trim) {
  return function trim() {
    return $trim(this, 3);
  };
});


/***/ }),
/* 1124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(10);
var $at = __webpack_require__(605)(false);
$export($export.P, 'String', {
  // 21.1.3.3 String.prototype.codePointAt(pos)
  codePointAt: function codePointAt(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 1125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])

var $export = __webpack_require__(10);
var toLength = __webpack_require__(54);
var context = __webpack_require__(437);
var ENDS_WITH = 'endsWith';
var $endsWith = ''[ENDS_WITH];

$export($export.P + $export.F * __webpack_require__(438)(ENDS_WITH), 'String', {
  endsWith: function endsWith(searchString /* , endPosition = @length */) {
    var that = context(this, searchString, ENDS_WITH);
    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
    var len = toLength(that.length);
    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
    var search = String(searchString);
    return $endsWith
      ? $endsWith.call(that, search, end)
      : that.slice(end - search.length, end) === search;
  }
});


/***/ }),
/* 1126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.7 String.prototype.includes(searchString, position = 0)

var $export = __webpack_require__(10);
var context = __webpack_require__(437);
var INCLUDES = 'includes';

$export($export.P + $export.F * __webpack_require__(438)(INCLUDES), 'String', {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~context(this, searchString, INCLUDES)
      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),
/* 1127 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(10);

$export($export.P, 'String', {
  // 21.1.3.13 String.prototype.repeat(count)
  repeat: __webpack_require__(620)
});


/***/ }),
/* 1128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.18 String.prototype.startsWith(searchString [, position ])

var $export = __webpack_require__(10);
var toLength = __webpack_require__(54);
var context = __webpack_require__(437);
var STARTS_WITH = 'startsWith';
var $startsWith = ''[STARTS_WITH];

$export($export.P + $export.F * __webpack_require__(438)(STARTS_WITH), 'String', {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = context(this, searchString, STARTS_WITH);
    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return $startsWith
      ? $startsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});


/***/ }),
/* 1129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.2 String.prototype.anchor(name)
__webpack_require__(76)('anchor', function (createHTML) {
  return function anchor(name) {
    return createHTML(this, 'a', 'name', name);
  };
});


/***/ }),
/* 1130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.3 String.prototype.big()
__webpack_require__(76)('big', function (createHTML) {
  return function big() {
    return createHTML(this, 'big', '', '');
  };
});


/***/ }),
/* 1131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.4 String.prototype.blink()
__webpack_require__(76)('blink', function (createHTML) {
  return function blink() {
    return createHTML(this, 'blink', '', '');
  };
});


/***/ }),
/* 1132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.5 String.prototype.bold()
__webpack_require__(76)('bold', function (createHTML) {
  return function bold() {
    return createHTML(this, 'b', '', '');
  };
});


/***/ }),
/* 1133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.6 String.prototype.fixed()
__webpack_require__(76)('fixed', function (createHTML) {
  return function fixed() {
    return createHTML(this, 'tt', '', '');
  };
});


/***/ }),
/* 1134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.7 String.prototype.fontcolor(color)
__webpack_require__(76)('fontcolor', function (createHTML) {
  return function fontcolor(color) {
    return createHTML(this, 'font', 'color', color);
  };
});


/***/ }),
/* 1135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.8 String.prototype.fontsize(size)
__webpack_require__(76)('fontsize', function (createHTML) {
  return function fontsize(size) {
    return createHTML(this, 'font', 'size', size);
  };
});


/***/ }),
/* 1136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.9 String.prototype.italics()
__webpack_require__(76)('italics', function (createHTML) {
  return function italics() {
    return createHTML(this, 'i', '', '');
  };
});


/***/ }),
/* 1137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.10 String.prototype.link(url)
__webpack_require__(76)('link', function (createHTML) {
  return function link(url) {
    return createHTML(this, 'a', 'href', url);
  };
});


/***/ }),
/* 1138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.11 String.prototype.small()
__webpack_require__(76)('small', function (createHTML) {
  return function small() {
    return createHTML(this, 'small', '', '');
  };
});


/***/ }),
/* 1139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.12 String.prototype.strike()
__webpack_require__(76)('strike', function (createHTML) {
  return function strike() {
    return createHTML(this, 'strike', '', '');
  };
});


/***/ }),
/* 1140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.13 String.prototype.sub()
__webpack_require__(76)('sub', function (createHTML) {
  return function sub() {
    return createHTML(this, 'sub', '', '');
  };
});


/***/ }),
/* 1141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.14 String.prototype.sup()
__webpack_require__(76)('sup', function (createHTML) {
  return function sup() {
    return createHTML(this, 'sup', '', '');
  };
});


/***/ }),
/* 1142 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(624);
__webpack_require__(153);
module.exports = __webpack_require__(37).Symbol;


/***/ }),
/* 1143 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1144);
__webpack_require__(1145);
__webpack_require__(1146);
__webpack_require__(1147);
__webpack_require__(1148);
__webpack_require__(1149);
__webpack_require__(1150);
__webpack_require__(1151);
__webpack_require__(1152);
__webpack_require__(1153);
__webpack_require__(1154);
__webpack_require__(153);
module.exports = __webpack_require__(37);


/***/ }),
/* 1144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(10);
var $typed = __webpack_require__(337);
var buffer = __webpack_require__(439);
var anObject = __webpack_require__(38);
var toAbsoluteIndex = __webpack_require__(177);
var toLength = __webpack_require__(54);
var isObject = __webpack_require__(31);
var ArrayBuffer = __webpack_require__(35).ArrayBuffer;
var speciesConstructor = __webpack_require__(434);
var $ArrayBuffer = buffer.ArrayBuffer;
var $DataView = buffer.DataView;
var $isView = $typed.ABV && ArrayBuffer.isView;
var $slice = $ArrayBuffer.prototype.slice;
var VIEW = $typed.VIEW;
var ARRAY_BUFFER = 'ArrayBuffer';

$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });

$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
  // 24.1.3.1 ArrayBuffer.isView(arg)
  isView: function isView(it) {
    return $isView && $isView(it) || isObject(it) && VIEW in it;
  }
});

$export($export.P + $export.U + $export.F * __webpack_require__(32)(function () {
  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
}), ARRAY_BUFFER, {
  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
  slice: function slice(start, end) {
    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
    var len = anObject(this).byteLength;
    var first = toAbsoluteIndex(start, len);
    var final = toAbsoluteIndex(end === undefined ? len : end, len);
    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(final - first));
    var viewS = new $DataView(this);
    var viewT = new $DataView(result);
    var index = 0;
    while (first < final) {
      viewT.setUint8(index++, viewS.getUint8(first++));
    } return result;
  }
});

__webpack_require__(218)(ARRAY_BUFFER);


/***/ }),
/* 1145 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(10);
$export($export.G + $export.W + $export.F * !__webpack_require__(337).ABV, {
  DataView: __webpack_require__(439).DataView
});


/***/ }),
/* 1146 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(134)('Int8', 1, function (init) {
  return function Int8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 1147 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(134)('Uint8', 1, function (init) {
  return function Uint8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 1148 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(134)('Uint8', 1, function (init) {
  return function Uint8ClampedArray(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
}, true);


/***/ }),
/* 1149 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(134)('Int16', 2, function (init) {
  return function Int16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 1150 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(134)('Uint16', 2, function (init) {
  return function Uint16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 1151 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(134)('Int32', 4, function (init) {
  return function Int32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 1152 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(134)('Uint32', 4, function (init) {
  return function Uint32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 1153 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(134)('Float32', 4, function (init) {
  return function Float32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 1154 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(134)('Float64', 8, function (init) {
  return function Float64Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 1155 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(153);
__webpack_require__(330);
__webpack_require__(1156);
module.exports = __webpack_require__(37).WeakMap;


/***/ }),
/* 1156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var each = __webpack_require__(113)(0);
var redefine = __webpack_require__(74);
var meta = __webpack_require__(154);
var assign = __webpack_require__(627);
var weak = __webpack_require__(637);
var isObject = __webpack_require__(31);
var fails = __webpack_require__(32);
var validate = __webpack_require__(221);
var WEAK_MAP = 'WeakMap';
var getWeak = meta.getWeak;
var isExtensible = Object.isExtensible;
var uncaughtFrozenStore = weak.ufstore;
var tmp = {};
var InternalMap;

var wrapper = function (get) {
  return function WeakMap() {
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
};

var methods = {
  // 23.3.3.3 WeakMap.prototype.get(key)
  get: function get(key) {
    if (isObject(key)) {
      var data = getWeak(key);
      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
      return data ? data[this._i] : undefined;
    }
  },
  // 23.3.3.5 WeakMap.prototype.set(key, value)
  set: function set(key, value) {
    return weak.def(validate(this, WEAK_MAP), key, value);
  }
};

// 23.3 WeakMap Objects
var $WeakMap = module.exports = __webpack_require__(333)(WEAK_MAP, wrapper, methods, weak, true, true);

// IE11 WeakMap frozen keys fix
if (fails(function () { return new $WeakMap().set((Object.freeze || Object)(tmp), 7).get(tmp) != 7; })) {
  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
  assign(InternalMap.prototype, methods);
  meta.NEED = true;
  each(['delete', 'has', 'get', 'set'], function (key) {
    var proto = $WeakMap.prototype;
    var method = proto[key];
    redefine(proto, key, function (a, b) {
      // store frozen objects on internal weakmap shim
      if (isObject(a) && !isExtensible(a)) {
        if (!this._f) this._f = new InternalMap();
        var result = this._f[key](a, b);
        return key == 'set' ? this : result;
      // store all the rest on native weakmap
      } return method.call(this, a, b);
    });
  });
}


/***/ }),
/* 1157 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(153);
__webpack_require__(331);
__webpack_require__(1158);
module.exports = __webpack_require__(37).WeakSet;


/***/ }),
/* 1158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var weak = __webpack_require__(637);
var validate = __webpack_require__(221);
var WEAK_SET = 'WeakSet';

// 23.4 WeakSet Objects
__webpack_require__(333)(WEAK_SET, function (get) {
  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.4.3.1 WeakSet.prototype.add(value)
  add: function add(value) {
    return weak.def(validate(this, WEAK_SET), value, true);
  }
}, weak, false, true);


/***/ }),
/* 1159 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1160);
__webpack_require__(1161);
__webpack_require__(1162);
__webpack_require__(1163);
__webpack_require__(1164);
__webpack_require__(1165);
__webpack_require__(1166);
module.exports = __webpack_require__(37).Object;


/***/ }),
/* 1160 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-getownpropertydescriptors
var $export = __webpack_require__(10);
var ownKeys = __webpack_require__(630);
var toIObject = __webpack_require__(89);
var gOPD = __webpack_require__(90);
var createProperty = __webpack_require__(425);

$export($export.S, 'Object', {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIObject(object);
    var getDesc = gOPD.f;
    var keys = ownKeys(O);
    var result = {};
    var i = 0;
    var key, desc;
    while (keys.length > i) {
      desc = getDesc(O, key = keys[i++]);
      if (desc !== undefined) createProperty(result, key, desc);
    }
    return result;
  }
});


/***/ }),
/* 1161 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(10);
var $values = __webpack_require__(638)(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),
/* 1162 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(10);
var $entries = __webpack_require__(638)(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});


/***/ }),
/* 1163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(10);
var toObject = __webpack_require__(58);
var aFunction = __webpack_require__(88);
var $defineProperty = __webpack_require__(46);

// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
__webpack_require__(47) && $export($export.P + __webpack_require__(338), 'Object', {
  __defineGetter__: function __defineGetter__(P, getter) {
    $defineProperty.f(toObject(this), P, { get: aFunction(getter), enumerable: true, configurable: true });
  }
});


/***/ }),
/* 1164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(10);
var toObject = __webpack_require__(58);
var aFunction = __webpack_require__(88);
var $defineProperty = __webpack_require__(46);

// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
__webpack_require__(47) && $export($export.P + __webpack_require__(338), 'Object', {
  __defineSetter__: function __defineSetter__(P, setter) {
    $defineProperty.f(toObject(this), P, { set: aFunction(setter), enumerable: true, configurable: true });
  }
});


/***/ }),
/* 1165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(10);
var toObject = __webpack_require__(58);
var toPrimitive = __webpack_require__(131);
var getPrototypeOf = __webpack_require__(133);
var getOwnPropertyDescriptor = __webpack_require__(90).f;

// B.2.2.4 Object.prototype.__lookupGetter__(P)
__webpack_require__(47) && $export($export.P + __webpack_require__(338), 'Object', {
  __lookupGetter__: function __lookupGetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.get;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),
/* 1166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(10);
var toObject = __webpack_require__(58);
var toPrimitive = __webpack_require__(131);
var getPrototypeOf = __webpack_require__(133);
var getOwnPropertyDescriptor = __webpack_require__(90).f;

// B.2.2.5 Object.prototype.__lookupSetter__(P)
__webpack_require__(47) && $export($export.P + __webpack_require__(338), 'Object', {
  __lookupSetter__: function __lookupSetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.set;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),
/* 1167 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1168);
__webpack_require__(1169);
__webpack_require__(1170);
module.exports = __webpack_require__(37).Array;


/***/ }),
/* 1168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/Array.prototype.includes
var $export = __webpack_require__(10);
var $includes = __webpack_require__(326)(true);

$export($export.P, 'Array', {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

__webpack_require__(152)('includes');


/***/ }),
/* 1169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
var $export = __webpack_require__(10);
var flattenIntoArray = __webpack_require__(639);
var toObject = __webpack_require__(58);
var toLength = __webpack_require__(54);
var aFunction = __webpack_require__(88);
var arraySpeciesCreate = __webpack_require__(427);

$export($export.P, 'Array', {
  flatMap: function flatMap(callbackfn /* , thisArg */) {
    var O = toObject(this);
    var sourceLen, A;
    aFunction(callbackfn);
    sourceLen = toLength(O.length);
    A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
    return A;
  }
});

__webpack_require__(152)('flatMap');


/***/ }),
/* 1170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatten
var $export = __webpack_require__(10);
var flattenIntoArray = __webpack_require__(639);
var toObject = __webpack_require__(58);
var toLength = __webpack_require__(54);
var toInteger = __webpack_require__(111);
var arraySpeciesCreate = __webpack_require__(427);

$export($export.P, 'Array', {
  flatten: function flatten(/* depthArg = 1 */) {
    var depthArg = arguments[0];
    var O = toObject(this);
    var sourceLen = toLength(O.length);
    var A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
    return A;
  }
});

__webpack_require__(152)('flatten');


/***/ }),
/* 1171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


window._ = __webpack_require__(3);
window.Dropzone = __webpack_require__(339);
window.messageResource = __webpack_require__(0).default;

window.FeaturesPage = __webpack_require__(1172).default;

var loginModule = __webpack_require__(1286);
window.BaseLoginPageState = loginModule.BaseLoginPageState;
window.LoginState = loginModule.LoginState;
window.ForgetPasswordState = loginModule.ForgetPasswordState;
window.ResetPasswordState = loginModule.ResetPasswordState;
window.ErrorState = loginModule.ErrorState;

window.LoginPageController = __webpack_require__(1287).LoginPageController;
window.ActivationPageController = __webpack_require__(1288).default;

window.ClientSideErrors = __webpack_require__(1295).default;
__webpack_require__(1296);

window.RegExpSpecialSymbols = __webpack_require__(343).default;
window.DiacriticsUtil = __webpack_require__(451).default;
window.StringTokenizer = __webpack_require__(103).default;
window.StringIndex = __webpack_require__(115).default;
window.EntityStore = __webpack_require__(450).default;
window.CustomerStore = __webpack_require__(65).default;
window.ProjectStore = __webpack_require__(59).default;
window.TaskStore = __webpack_require__(91).default;
window.BillingTypeStore = __webpack_require__(720).default;
window.BillingType = __webpack_require__(721).default;
window.CustomerProjectSelection = __webpack_require__(156).default;
window.KEY_HANDLERS = __webpack_require__(48).default;
window.View = __webpack_require__(20).default;
window.TemplateView = __webpack_require__(1).default;
window.Tooltip = __webpack_require__(183).default;
window.SimpleTooltip = __webpack_require__(36).default;
window.ScrollView = __webpack_require__(346).default;
window.DropdownTemplateView = __webpack_require__(42).default;
window.AuditHistoryView = __webpack_require__(228).default;
window.LoadingControlMixin = __webpack_require__(136).default;
window.WindowSizeDependedView = __webpack_require__(458).default;
window.CPSelectorController = __webpack_require__(722).default;
window.TaskListController = __webpack_require__(723).default;
window.userStore = __webpack_require__(460).default;
window.User = __webpack_require__(119).default;
window.UserWithAccessRights = __webpack_require__(138).default;
window.Group = __webpack_require__(158).default;
window.Pager = __webpack_require__(724).default;
window.PagerController = __webpack_require__(461).default;
window.TreeNode = __webpack_require__(60).default;
window.TreeNodeSet = __webpack_require__(79).default;
window.TreeFilter = __webpack_require__(725).default;
window.SelectorFilter = __webpack_require__(282).default;
window.SimpleCheckboxNodeRenderer = __webpack_require__(347).default;
window.HierarchySelectorNodeRenderer = __webpack_require__(462).default;
window.TriStateCheckboxTreeNodeRenderer = __webpack_require__(726).default;
window.SelectionTreeNodeRenderer = __webpack_require__(727).default;
window.TreeNodeRenderer = __webpack_require__(463).default;
window.DisabledNodesParentTreeNode = __webpack_require__(283).default;
window.HierarchySelectorUtil = __webpack_require__(95).default;
window.TwoLevelSelection = __webpack_require__(70).default;
window.CoarseSelection = __webpack_require__(284).default;
window.FilterWordsField = __webpack_require__(348).default;
window.FilterWordsPopup = __webpack_require__(464).default;
window.KeyDownHandler = __webpack_require__(184).default;
window.TokensHighlighter = __webpack_require__(94).default;
window.EmptyHighlighter = __webpack_require__(137).default;
window.AtMap = __webpack_require__(728).default;
window.DhtmlPopup = __webpack_require__(139).default;
window.RelativePositioning = __webpack_require__(139).RelativePositioning;
window.ElementRelativePositioning = __webpack_require__(139).ElementRelativePositioning;
window.ElementRelativeOnTheRightEdgePositioning = __webpack_require__(139).ElementRelativeOnTheRightEdgePositioning;
window.ElementRelativeInTheContainerPositioning = __webpack_require__(139).ElementRelativeInTheContainerPositioning;
window.ShowHideByDisplayPropertyStrategy = __webpack_require__(139).ShowHideByDisplayPropertyStrategy;
window.ShowHideByVisibilityPropertyStrategy = __webpack_require__(139).ShowHideByVisibilityPropertyStrategy;
window.ScrollUtils = __webpack_require__(39).default;
window.UserNameFormat = __webpack_require__(17).default;
window.BalanceFormatter = __webpack_require__(230).BalanceFormatter;
window.SickFormatter = __webpack_require__(230).SickFormatter;
window.PTOFormatter = __webpack_require__(230).PTOFormatter;
window.AccrualRuleFromDateSelector = __webpack_require__(1303).default;
window.LoadingMoire = __webpack_require__(92).default;
window.OnlineAccountFieldsEditUserPopupDrawer = __webpack_require__(465).OnlineAccountFieldsEditUserPopupDrawer;
window.OnlineAccountFieldsCreateUserPopupDrawer = __webpack_require__(465).OnlineAccountFieldsCreateUserPopupDrawer;
window.DownloadableAccountFieldsCreateUserPopupDrawer = __webpack_require__(467).DownloadableAccountFieldsCreateUserPopupDrawer;
window.DownloadableAccountFieldsEditUserPopupDrawer = __webpack_require__(467).DownloadableAccountFieldsEditUserPopupDrawer;
window.UserNameDrawer = __webpack_require__(349).default;
window.InvitationDrawer = __webpack_require__(730).default;
window.PasswordFieldsDrawer = __webpack_require__(468).default;
window.CPReportSelector = __webpack_require__(350).default;
window.DropdownDialog = __webpack_require__(185).default;
window.DropdownDialogWithPointerWrapper = __webpack_require__(182).default;
window.SpinnerController = __webpack_require__(69).default;
window.TimeZonesSelector = __webpack_require__(355).default;
window.GroupType = __webpack_require__(34).default;
window.ShowUserGroupsStrategy = __webpack_require__(356).default;
window.HideUserGroupsStrategy = __webpack_require__(480).default;
window.TriStateSelectorTree = __webpack_require__(742).default;
window.Tree = __webpack_require__(743).default;
window.TreeRootNode = __webpack_require__(354).default;
window.UserTreeNode = __webpack_require__(745).default;
window.DisabledNodesParentNodeRenderer = __webpack_require__(353).default;
window.UserNodeRenderer = __webpack_require__(357).default;
window.UserGroupNodeRenderer = __webpack_require__(238).default;
window.TimeZoneGroupNodeRenderer = __webpack_require__(746).default;
window.EmailCheckUserNodeRenderer = __webpack_require__(747).default;
window.EmptyMessageBuilder = __webpack_require__(748).default;
window.UserSelectorEmptyMessageBuilder = __webpack_require__(358).default;
window.TriStateSelectionController = __webpack_require__(479).default;
window.ExpandCollapseNodeRenderer = __webpack_require__(352).default;
window.CustomerNodeRenderer = __webpack_require__(472).default;
window.ProjectNodeRenderer = __webpack_require__(473).default;
window.ArchivedCustomersParentNodeRenderer = __webpack_require__(475).default;
window.ArchivedProjectsParentNodeRenderer = __webpack_require__(474).default;
window.TreeBuilder = __webpack_require__(476).default;
window.UserSelectorTreeBuilder = __webpack_require__(749).default;
window.UserSelectorTreeBuilderObserver = __webpack_require__(481).default;
window.TimeZoneGroupValidatorStrategy = __webpack_require__(186).TimeZoneGroupValidatorStrategy;
window.UserGroupValidatorStrategy = __webpack_require__(186).UserGroupValidatorStrategy;
window.SelectorPanelWithApplyButtonHelper = __webpack_require__(231).default;
window.GUIControl = __webpack_require__(750).default;
window.DropdownButton = __webpack_require__(1321).default;
window.DhtmlTitle = __webpack_require__(470).default;
window.AncestorEventsListenerMixin = __webpack_require__(234).AncestorEventsListenerMixin;
window.AncestorEventsEmitterMixin = __webpack_require__(234).AncestorEventsEmitterMixin;
window.DescendantEventsListenerMixin = __webpack_require__(234).DescendantEventsListenerMixin;
window.DescendantEventsEmitterMixin = __webpack_require__(234).DescendantEventsEmitterMixin;
window.PermissionsTemplateButtonControllerWithoutChoosing = __webpack_require__(751).default;
window.ListSelector = __webpack_require__(96).default;
window.SimpleListMenuButton = __webpack_require__(187).default;
window.TaskPanel = __webpack_require__(483).default;
window.ProjectPanel = __webpack_require__(503).default;
window.CustomerPanel = __webpack_require__(382).default;
window.MoveToDialog = __webpack_require__(371).default;
window.DateRange = __webpack_require__(304).default;
window.LockTTTableController = __webpack_require__(808).default;
window.LockTTStore = __webpack_require__(526).default;
window.ProjectPanelController = __webpack_require__(818).default;
window.CustomerPanelController = __webpack_require__(819).default;
window.DHTMLPopupWithMoire = __webpack_require__(506).default;
window.LoadingPopup = __webpack_require__(299).default;
window.BasicLightbox = __webpack_require__(163).default;
window.CreateReportPopup = __webpack_require__(791).default;
window.BaseFormatterCreator = __webpack_require__(379).default;
window.ReportChartUtils = __webpack_require__(303).default;
window.CreateTasksLightboxUtils = __webpack_require__(790); // TODO temporary
window.NoNotificationMessageParams = __webpack_require__(1544).default;
window.MailNotificationsUserSelectorCache = __webpack_require__(1545).default;
window.FeatureDiffStateController = __webpack_require__(822).default;
window.RpcControlManager = __webpack_require__(235).default;
window.BaseGroupManagementController = __webpack_require__(310).BaseGroupManagementController;
window.TimeZoneGroupManagementController = __webpack_require__(310).TimeZoneGroupManagementController;
window.UserGroupRenderer = __webpack_require__(827).default;
window.TimeZoneGroupRenderer = __webpack_require__(823).default;
window.GroupDataRetrieveRPCManager = __webpack_require__(825).default;
window.GroupManagementUtil = __webpack_require__(386).default;
window.GroupRow = __webpack_require__(828).default;
window.GroupWithUsers = __webpack_require__(387).default;
window.TimeZoneGroupRow = __webpack_require__(1551).default;
window.UserInGroup = __webpack_require__(388).default;
window.UserInGroupRow = __webpack_require__(1552).default;
window.AddGroupController = __webpack_require__(829).default;
window.LeaveTypeStore = __webpack_require__(124).default;
window.LeavesReportStore = __webpack_require__(199).default;
window.LockTTMediator = __webpack_require__(1553).default;
window.BalanceRulesEditorContent = __webpack_require__(832).default;
window.ExitConfirmationHandlersManager = __webpack_require__(298).default;
window.Link = __webpack_require__(530).default;
window.ProductWebSiteURLs = __webpack_require__(4).ProductWebSiteURLs;

var notificationsAccessRightsStrategy = __webpack_require__(1554);
window.SubmitTTRightStrategy = notificationsAccessRightsStrategy.SubmitTTRightStrategy;
window.GenerateMoneyReportRightStrategy = notificationsAccessRightsStrategy.GenerateMoneyReportRightStrategy;
window.AccessToManagerScopesStrategy = notificationsAccessRightsStrategy.AccessToManagerScopesStrategy;
window.EditHierarchyRightStrategy = notificationsAccessRightsStrategy.EditHierarchyRightStrategy;

var ruleState = __webpack_require__(1555);
window.PersonalTTRuleState = ruleState.PersonalTTRuleState;
window.UnsubmittedTTRuleState = ruleState.UnsubmittedTTRuleState;
window.DeadlineRuleState = ruleState.DeadlineRuleState;
window.EstimateRuleState = ruleState.EstimateRuleState;
window.ProjectBudgetRuleState = ruleState.ProjectBudgetRuleState;
window.PersonalEarningsRuleState = ruleState.PersonalEarningsRuleState;

window.EnterTTMediator = __webpack_require__(1556).default;

var atUtils = __webpack_require__(5);
window.escapeHtmlSymbols = atUtils.escapeHtmlSymbols;
window.unescapeHtmlSymbols = atUtils.unescapeHtmlSymbols;
window.concatStr = atUtils.concatStr;
window.truncateStringByLength = atUtils.truncateStringByLength;
window.stringComparator = atUtils.stringComparator;
window.stringComparatorCaseSensitive = atUtils.stringComparatorCaseSensitive;
window.nameComparator = atUtils.nameComparator;
window.numberComparator = atUtils.numberComparator;
window.trim = atUtils.trim;
window.leadZero = atUtils.leadZero;
window.formatRawSecondsOffset = atUtils.formatRawSecondsOffset;
window.makeMapAndOrderForEntitiesArray = atUtils.makeMapAndOrderForEntitiesArray;
window.makeMapForEntitiesArray = atUtils.makeMapForEntitiesArray;
window.isEmailValid = atUtils.isEmailValid;
window.compareDates = atUtils.compareDates;
window.compareNullableStrDates = atUtils.compareNullableStrDates;
window.areDatesEqual = atUtils.areDatesEqual;
window.makeHandler = atUtils.makeHandler;
window.getStringWithUnifiedNewLineSymbol = atUtils.getStringWithUnifiedNewLineSymbol;
window.isNotEmpty = atUtils.isNotEmpty;
window.removeContextFromProductUrl = atUtils.removeContextFromProductUrl;
window.defer = atUtils.defer;
window.filterArrayByArrayOfIds = atUtils.filterArrayByArrayOfIds;

window.makeRpcCall = __webpack_require__(26).default;
window.makeToast = __webpack_require__(833).toast;
window.UserTime = __webpack_require__(30).default;

var atBrowserUtils = __webpack_require__(8);
window.getBodyScrollLeft = atBrowserUtils.getBodyScrollLeft;
window.getBodyScrollTop = atBrowserUtils.getBodyScrollTop;
window.disableTextSelection = atBrowserUtils.disableTextSelection;
window.getCookie = atBrowserUtils.getCookie;
window.setCookie = atBrowserUtils.setCookie;
window.getArrayFromCookies = atBrowserUtils.getArrayFromCookies;
window.saveArrayIntoCookies = atBrowserUtils.saveArrayIntoCookies;
window.isLetterOrDigitSymbolPressed = atBrowserUtils.isLetterOrDigitSymbolPressed;
window.addClass = atBrowserUtils.addClass;
window.hasClass = atBrowserUtils.hasClass;
window.removeClass = atBrowserUtils.removeClass;
window.replaceClass = atBrowserUtils.replaceClass;
window.getEventObj = atBrowserUtils.getEventObj;
window.isKeyPressed = atBrowserUtils.isKeyPressed;
window.isTabPressed = atBrowserUtils.isTabPressed;
window.handleTab = atBrowserUtils.handleTab;
window.isEscapePressed = atBrowserUtils.isEscapePressed;
window.handleEscape = atBrowserUtils.handleEscape;
window.isEnterPressed = atBrowserUtils.isEnterPressed;
window.handleEnter = atBrowserUtils.handleEnter;
window.cancelBubble = atBrowserUtils.cancelBubble;
window.atImgPath = atBrowserUtils.atImgPath;
window.imgPath = atBrowserUtils.imgPath;
window.calculateCoords = atBrowserUtils.calculateCoords;
window.calculateObjectCoords = atBrowserUtils.calculateObjectCoords;
window.findPosX = atBrowserUtils.findPosX;
window.findPosY = atBrowserUtils.findPosY;
window.shiftTo = atBrowserUtils.shiftTo;
window.getClientSize = atBrowserUtils.getClientSize;
window.getObjectWidth = atBrowserUtils.getObjectWidth;
window.getObjectHeight = atBrowserUtils.getObjectHeight;
window.getInsideWindowWidth = atBrowserUtils.getInsideWindowWidth;
window.getInsideWindowHeight = atBrowserUtils.getInsideWindowHeight;
window.getViewport = atBrowserUtils.getViewport;
window.scrollToElementIfNeeded = atBrowserUtils.scrollToElementIfNeeded;
window.scrollWindowIfNeeded = atBrowserUtils.scrollWindowIfNeeded;
window.smoothlyScrollDownToElement = atBrowserUtils.smoothlyScrollDownToElement;
window.isMSIE = atBrowserUtils.isMSIE;
window.isIE8 = atBrowserUtils.isIE8;
window.showElementAt = atBrowserUtils.showElementAt;
window.onOutsideClick = atBrowserUtils.onOutsideClick;
window.fixIScrollInnerWheelEvent = atBrowserUtils.fixIScrollInnerWheelEvent;
window.setMouseDownOutsideHandler = atBrowserUtils.setMouseDownOutsideHandler;
window.calculateTooltipOffset = atBrowserUtils.calculateTooltipOffset;
window.calculateElementOffset = atBrowserUtils.calculateElementOffset;
window.calculateTooltipOffsetByItParameters = atBrowserUtils.calculateTooltipOffsetByItParameters;
window.doOnceOn = atBrowserUtils.doOnceOn;
window.doOnceOnWindowResize = atBrowserUtils.doOnceOnWindowResize;
window.whichButtonPressed = atBrowserUtils.whichButtonPressed;
window.preventDefault = atBrowserUtils.preventDefault;
window.setFocusIntoFieldWithPlaceholder = atBrowserUtils.setFocusIntoFieldWithPlaceholder;
window.scrollToElementInPopup = atBrowserUtils.scrollToElementInPopup;
window.enableTextSelectionBack = atBrowserUtils.enableTextSelectionBack;
window.createElement = atBrowserUtils.createElement;
window.createElementWithProperties = atBrowserUtils.createElementWithProperties;
window.assign = atBrowserUtils.assign;
window.px = atBrowserUtils.px;

var stringUtils = __webpack_require__(121);
window.StringUtils = {
    insertBrakes: stringUtils.insertBrakes,
    cutLongText: stringUtils.cutLongText,
    cutNumberOfTextLines: stringUtils.cutNumberOfTextLines
};

var storeUtils = __webpack_require__(531);
window.StoreUtils = {
    mergeCustomersProjectsFromRPC: storeUtils.mergeCustomersProjectsFromRPC,
    mergeCustomersProjectsFromJSP: storeUtils.mergeCustomersProjectsFromJSP,
    replaceUsersFromJSP: storeUtils.replaceUsersFromJSP,
    replaceUserGroupsFromJSP: storeUtils.replaceUserGroupsFromJSP,
    replaceTimeZoneGroupsFromJSP: storeUtils.replaceTimeZoneGroupsFromJSP
};

var userGroupSelectorUtil = __webpack_require__(98);
window.userComparator = userGroupSelectorUtil.userComparator;
window.buildUserSelectorTreeWithUserGroupsData = userGroupSelectorUtil.buildUserSelectorTreeWithUserGroupsData;
window.buildUserSelectorTreeWithTimeZoneGroupsData = userGroupSelectorUtil.buildUserSelectorTreeWithTimeZoneGroupsData;
window.getUserSelectorFeatureStrategy = userGroupSelectorUtil.getUserSelectorFeatureStrategy;

var keyCodes = __webpack_require__(66);
window.KEY_CODE_UP = keyCodes.KEY_CODE_UP;
window.KEY_CODE_DOWN = keyCodes.KEY_CODE_DOWN;
window.KEY_CODE_ESC = keyCodes.KEY_CODE_ESC;
window.KEY_CODE_ENTER = keyCodes.KEY_CODE_ENTER;
window.KEY_CODE_TAB = keyCodes.KEY_CODE_TAB;
window.KEY_CODE_DEL = keyCodes.KEY_CODE_DEL;
window.KEY_CODE_SPACE = keyCodes.KEY_CODE_SPACE;
window.KEY_CODE_PAGE_UP = keyCodes.KEY_CODE_PAGE_UP;
window.KEY_CODE_PAGE_DOWN = keyCodes.KEY_CODE_PAGE_DOWN;

window.AT = {};
window.AT.SimpleSelectorPanel = __webpack_require__(834).default;
window.AT.CustomerProjectSelectorPanel = __webpack_require__(734).default;
window.AT.UsersSelectorPanel = __webpack_require__(162).default;
window.AT.ReportsSelectorUsersPanel = __webpack_require__(302).default;
window.AT.AccessRightsUsersSelectorPanel = __webpack_require__(820).default;
window.AT.SharedUserButtonMenu = __webpack_require__(159).default;
window.AT.IconButton = __webpack_require__(471).default;
window.AT.FlatButton = __webpack_require__(351).default;
window.AT.GradientButton = __webpack_require__(285).default;
window.AT.SelectionHelper = __webpack_require__(477).default;
window.AT.GenericSelectorTreePropertiesController = __webpack_require__(532).default;
window.AT.SelectorTree = __webpack_require__(835).default;
window.AT.SimpleListSelectorTree = __webpack_require__(533).default;
window.AT.SelectorTreeNode = __webpack_require__(837).default;
window.AT.SelectorTreeCheckbox = __webpack_require__(534).default;
window.AT.TreeNodeHelper = __webpack_require__(836).default;
window.AT.GroupSelectorSwitcher = __webpack_require__(373).default;
window.AT.ExtendedGroupSelectorSwitcher = __webpack_require__(1561).default;
window.AT.SimpleUsersAndGroupsSelectionHelper = __webpack_require__(374).default;
window.AT.ComplicateUsersAndGroupsSelectionHelper = __webpack_require__(821).default;
window.AT.HierarchySelectorDropdownButton = __webpack_require__(232).default;
window.AT.CustomerProjectSelectorTwoGenericOptionsPanel = __webpack_require__(733).default;
window.AT.AbstractDropdownButton = __webpack_require__(233).default;
window.AT.DropdownButton = __webpack_require__(469).default;
window.AT.DropdownListButton = __webpack_require__(482).default;
window.AT.AbstractPickerButton = __webpack_require__(535).default;
window.AT.BaseDatePicker = __webpack_require__(536).default;
window.AT.DatePicker = __webpack_require__(389).default;
window.AT.WeekPicker = __webpack_require__(838).default;
window.AT.SelectorDropdownButton = __webpack_require__(799).default;
window.AT.ElasticTextArea = __webpack_require__(839).default;
window.AT.ExtendedGroupsSelectorPanel = __webpack_require__(1562).default;
window.AT.GroupsSelectorPanel = __webpack_require__(537).GroupsSelectorPanel;
window.AT.SmartGroupsSelectorPanel = __webpack_require__(537).SmartGroupsSelectorPanel;
window.AT.ReportsSelectorUsersPanel = __webpack_require__(302).default;

window.AT.menu = {};
window.AT.menu.SpecialMenuMgr = __webpack_require__(538).default;
window.AT.menu.DatePickerMenu = __webpack_require__(539).default;
window.AT.menu.PickerMenu = __webpack_require__(540).default;
window.AT.menu.PickerItem = __webpack_require__(840).default;
window.AT.menu.WeekPickerMenu = __webpack_require__(841).default;
window.AT.menu.WeekPickerItem = __webpack_require__(1563).default;

window.CustomCheckbox = __webpack_require__(83).default;
window.CircleSpinner = __webpack_require__(1564).default;

window.ViewTTMediator = __webpack_require__(1565).default;

window.EditableCell = __webpack_require__(845).default;
window.EditableCellRenderer = __webpack_require__(1588).default;
window.TaskBillingTypeCellRenderer = __webpack_require__(1589).default;
window.TableTooltip = __webpack_require__(237).default;
window.SimpleTooltip = __webpack_require__(36).default;

window.DelayTooltip = __webpack_require__(807).default;

window.ATUserManagementMediator = __webpack_require__(1594).default;

window.UserTableRow = __webpack_require__(849).default;

window.TaskManagementStore = __webpack_require__(140).default;

var date_format = __webpack_require__(16);
window.DateFormat = date_format.DateFormat;

window.UserATProfilePopup = __webpack_require__(1751).default;
window.ViewTTPageColumnChartGenerator = __webpack_require__(1763).default;
window.CopyUserSettingsSelector = __webpack_require__(906).default;
window.ViewTTStore = __webpack_require__(73).default;
window.TabularDataTableCell = __webpack_require__(908).default;
window.TabularDataTableRow = __webpack_require__(909).default;
window.TabularDataWithEffectiveDatesTableRow = __webpack_require__(910).default;
window.TabularDataTableCellValidator = __webpack_require__(911).default;
window.WorkdayDurationsTableRow = __webpack_require__(1766).default;
window.LoadingCell = __webpack_require__(1767).default;

var constants = __webpack_require__(4);
window.CustomersProjectsSelectionQualifier = constants.CustomersProjectsSelectionQualifier;
window.startWorkFlowSettings = __webpack_require__(1768).default;
window.startWorkSchedule = __webpack_require__(1781).default;
window.DescriptionUtil = __webpack_require__(918).DescriptionUtil;
window.CreateTaskDescriptionUtil = __webpack_require__(918).CreateTaskDescriptionUtil;
window.TaskManagementMediator = __webpack_require__(1808).default;
window.SessionTokenStore = __webpack_require__(739).default;

window.initApplication = __webpack_require__(1882).default;
window.initApplicationAP = __webpack_require__(1898).default;

window.openSupportForm = __webpack_require__(381).openSupportForm;
window.EnterTTUrlUtils = __webpack_require__(1907).default;
window.LogoDropzone = __webpack_require__(1908).default;
window.ReportLogoDropzone = __webpack_require__(1909).default;
window.ImageRequirementsPopup = __webpack_require__(1910).default;
window.CookiesDisabledLoginPlug = __webpack_require__(1911).default;

// actiPlans objects ******************************************************************
window.PageOverlayTipsManager = __webpack_require__(408).default;
window.UserListPage = __webpack_require__(1914).default;
window.EmailNotificationsPageOverlayTipsManager = __webpack_require__(1916).default;
window.LeaveTimePlanningPageOverlayTipsManager = __webpack_require__(1917).default;
window.LeaveTimeRequestPageOverlayTipsManager = __webpack_require__(1918).default;
window.APLeaveTypesPageOverlayTipsManager = __webpack_require__(1919).default;
window.MySchedulePageOverlayTipsManager = __webpack_require__(1920).default;
window.APSettingsPageOverlayTipsManager = __webpack_require__(1921).default;
window.APUserListPageOverlayTipsManager = __webpack_require__(1922).default;

window.LeaveTimeBalancesPageOverlayTipsManager = __webpack_require__(1923).default;
window.BalanceHistoryPageOverlayTipsManager = __webpack_require__(1924).default;
window.PastLeavesPageOverlayTipsManager = __webpack_require__(1925).default;
window.APInviteSeveralUsersLightBox = __webpack_require__(1926).default;
window.LeaveRequestsExportToCSVPanel = __webpack_require__(1927).default;
window.downloadLeaveRequestsListCsv = __webpack_require__(1928).downloadLeaveRequestsListCsv;

window.APReportsPage = __webpack_require__(1930).default;
window.APReportsPage.BalancesChartGenerator = __webpack_require__(1931).default;
window.APReportsPage.LeaveTimeChartGenerator = __webpack_require__(1932).default;
window.APReportsPage.BalanceHistoryCSVConverter = __webpack_require__(1933).default;
window.APReportsPage.PastLeavesCSVConverter = __webpack_require__(1934).default;
window.LeaveTimeDetailsTable = __webpack_require__(1935).LeaveTimeDetailsTable;

window.startICalendarFeeds = __webpack_require__(1936).default;
// end of actiPlans objects  **********************************************************

// common objects *********************************************************************
window.InvitationDialog = __webpack_require__(877).default;
window.DropdownList = __webpack_require__(862).default;
window.WorkdayDurationsEditor = __webpack_require__(260).default;
window.UserProfilePopup = __webpack_require__(903).default;
window.UserProfileSection = __webpack_require__(564).default;
window.BaseUserInformationSection = __webpack_require__(555).default;
window.BaseUserDataSection = __webpack_require__(396).default;
window.AccountInformationSection = __webpack_require__(317).default;
window.CreateAccountInformationSection = __webpack_require__(870).default;
window.EditAccountInformationSection = __webpack_require__(868).default;
window.CorporateScheduleCalculator = __webpack_require__(378).default;
window.ScheduleCalculator = __webpack_require__(789).default;
window.DateSelector = __webpack_require__(1969).default;
window.WeekSelector = __webpack_require__(1970).default;
window.HireDateWarningDlg = __webpack_require__(869).default;
window.TimeZoneGroupsListSelector = __webpack_require__(1971).default;
window.TumblerSwitch = __webpack_require__(1972).default;
window.Table = __webpack_require__(385).default;
window.TaskTableTemplate = __webpack_require__(509).default;
window.TableCell = __webpack_require__(166).default;
window.TableCellRenderer = __webpack_require__(63).default;
window.TableMouseEventsHandler = __webpack_require__(525).default;
window.TableRegion = __webpack_require__(145).default;
window.NullTableRegion = __webpack_require__(144).default;
window.TableRow = __webpack_require__(250).default;
window.TabularDataWithEffectiveDatesTable = __webpack_require__(1973).default;
window.DefaultWorkStatusesContainer = __webpack_require__(875).DefaultWorkStatusesContainer;
window.TabularDataTable = __webpack_require__(964).default;
window.EffectiveDateCellRenderer = __webpack_require__(1974).default;
window.RemoveRowCellRenderer = __webpack_require__(582).default;
window.EmptyRemoveRowCellRenderer = __webpack_require__(1975).default;
window.RemoveRowWithConfirmationCellRenderer = __webpack_require__(1976).default;
window.DatePickerMenu = __webpack_require__(921).default;
window.PageMediator = __webpack_require__(919).default;
window.WarningsController = __webpack_require__(542).default;
window.NumberFormatter = __webpack_require__(61).default;
window.ChartGenerator = __webpack_require__(291).default;
window.PieChartGenerator = __webpack_require__(771).default;
window.ExitConfirmationHandlersManager = __webpack_require__(298).default;

window.BaseBalanceRulesControl = __webpack_require__(125).BaseBalanceRulesControl;
window.BalanceRulesEditor = __webpack_require__(125).BalanceRulesEditor;
window.AdvancedBalanceRulesEditor = __webpack_require__(125).AdvancedBalanceRulesEditor;
window.BalanceRulesTooltip = __webpack_require__(125).BalanceRulesTooltip;
window.BalanceRulesViewer = __webpack_require__(125).BalanceRulesViewer;
window.BalanceRulesEditorDialog = __webpack_require__(125).BalanceRulesEditorDialog;
window.BalanceRulesManager = __webpack_require__(125).BalanceRulesManager;
window.BALANCE_RULES_VALUES = __webpack_require__(125).BALANCE_RULES_VALUES;

window.BalanceHistory = __webpack_require__(957).BalanceHistory;

window.checkReloadNeededAfterGetAssignedUsersRequest = __webpack_require__(583).checkReloadNeededAfterGetAssignedUsersRequest;
window.formatAssignApproversCellText = __webpack_require__(583).formatAssignApproversCellText;
window.createApproversSortingProcessor = __webpack_require__(583).createApproversSortingProcessor;
window.UserListConfirmation = __webpack_require__(545).default;

window.CreateUserLightBox = __webpack_require__(1978).default;
window.UserDataLightBox = __webpack_require__(581).default;
window.LeaveBalanceEditor = __webpack_require__(547).default;
window.SmartField = __webpack_require__(860).default;
window.DecimalField = __webpack_require__(859).default;
window.BaseUsersSelector = __webpack_require__(907).default;
window.json2csv = __webpack_require__(576).default;

//TODO temporary added
window.LeaveReportColumnsFormatSelector = __webpack_require__(965).default;
window.BaseTableDataConverter = __webpack_require__(409);
window.PDFDefinitionColumnBuilder = __webpack_require__(410).default;
window.BaseParametersFormattingStrategy = __webpack_require__(248).default;
window.DateRangeFormattingStrategy = __webpack_require__(165).default;
window.ChartParametersFormattingStrategy = __webpack_require__(305).default;
window.LeavesChartParametersFormatter = __webpack_require__(966).default;
window.ChartParametersFormatter = __webpack_require__(516).default;
window.LeavesReportUtils = __webpack_require__(584).default;

window.RowType = __webpack_require__(267).RowType;
window.ColumnsConfig = __webpack_require__(130).ColumnsConfig;

window.BaseReportFormatUtils = __webpack_require__(142).default;
window.OvertimeReportFormatUtils = __webpack_require__(1979).default;
window.LeavesReportFormatUtils = __webpack_require__(967).default;

window.LeavesReportPDFSettingsPreview = __webpack_require__(585).default;
window.LeavesReportPDFGenerator = __webpack_require__(968).default;
window.LeavesReportPDFPreviewLightbox = __webpack_require__(590).default;
window.APReportsPagePDFPreviewLightbox = __webpack_require__(1983).default;
window.LeavesReportTableDataConverter = __webpack_require__(970).default;
window.LeavesReportPDFPreviewLightboxController = __webpack_require__(971).default;

window.ViewTTPDFPreviewLightboxController = __webpack_require__(1984).default;

window.OvertimeReportPDFPreviewLightbox = __webpack_require__(972).default;
window.OvertimeReportPDFGenerator = __webpack_require__(974).default;
window.OvertimeReportTableDataConverter = __webpack_require__(1996).default;

window.EVAReportPDFPreviewLightbox = __webpack_require__(976).default;
window.EVAReportPDFGenerator = __webpack_require__(977).default;
window.EVAReportTableDataConverter = __webpack_require__(2004).default;

window.PDFImageCache = __webpack_require__(122).default;

window.ChartMediator = __webpack_require__(794).default;

window.OldReportMediator = __webpack_require__(268).default;
// window.OldBaseFormMediator = require('./reports/OldBaseFormMediator').default

window.ReportConfigs = __webpack_require__(2005).default;
window.BaseFormMediator = __webpack_require__(269).default;
window.ReportMediator = __webpack_require__(321).default;
window.OvertimeFormMediator = __webpack_require__(2006).default;
window.OvertimeReportMediator = __webpack_require__(2016).default;
window.BudgetedVsActualReportMediator = __webpack_require__(2017).default;
window.LeaveTimeFormMediator = __webpack_require__(2020).default;
window.EstimatedVsActualFormMediator = __webpack_require__(2037).default;
window.LeavesReportMediator = __webpack_require__(2049).default;
window.StaffOutputFormMediator = __webpack_require__(2050).default;
window.StaffOutputReportMediator = __webpack_require__(2068).default;
window.TTDetailReportMediator = __webpack_require__(2069).default;
window.TTDetailFormMediator = __webpack_require__(2072).default;
window.CostReportMediator = __webpack_require__(2083).default;
window.CostFormMediator = __webpack_require__(2085).default;
window.BillingSummaryFormMediator = __webpack_require__(2106).default;
window.BillingSummaryReportMediator = __webpack_require__(2132).default;
window.InvoiceFormMediator = __webpack_require__(2134).default;
window.ProfitLossFormMediator = __webpack_require__(2137).default;
window.ProfitLossReportMediator = __webpack_require__(2150).default;

window.ReportEditConfigController = __webpack_require__(593).default;
window.LeavesReportEditConfigController = __webpack_require__(594).default;
window.ReportUserSelectorButton = __webpack_require__(511).default;
window.ReportTimeTrackStatusFilter = __webpack_require__(980).default;
window.ChooseTypeSelector = __webpack_require__(1001).default;
window.DisplayedDataSelector = __webpack_require__(603).default;
window.InvoiceEditResultConfigController = __webpack_require__(2152).default;
window.ReportConfig = __webpack_require__(2153).default;

window.CSVParametersBuilder = __webpack_require__(150).default;

window.GroupingSelector = __webpack_require__(322).default;
window.ThreeLevelReportGroupingSelector = __webpack_require__(323).default;
window.LeavesEditFormConfigController = __webpack_require__(983).default;

window.ATReportParamsStringBuilder = __webpack_require__(52).default;
window.APReportParamsStringBuilder = __webpack_require__(2157).default;

window.APReportsPageLeaveTimeBalancesReportPageStore = __webpack_require__(199).default;

window.downloadJsonAsCSV = __webpack_require__(127).downloadJsonAsCSV;
window.downloadPDF = __webpack_require__(164).downloadPDF;
window.PasswordPolicyManager = __webpack_require__(227).default;
window.PasswordAsyncValidator = __webpack_require__(280).default;
window.getPasswordValidator = __webpack_require__(280).getPasswordValidator;
window.PasswordHintTooltip = __webpack_require__(457).default;

window.DatesIterator = __webpack_require__(85).DatesIterator;
window.MonthIterator = __webpack_require__(85).MonthIterator;

window.emitUserEvent = __webpack_require__(407).default;
window.UserEventsMap = __webpack_require__(99).UserEventsMap;

window.NextBridge = __webpack_require__(376).default;
// end of common object ***************************************************************

/***/ }),
/* 1172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _utils = __webpack_require__(6);

var _redux = __webpack_require__(7);

var _actions = __webpack_require__(68);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function FeaturesPage() {};

FeaturesPage.features = {};
FeaturesPage.handlers = {};

FeaturesPage.sentAjaxRequests = {};

FeaturesPage.featureMenuItemIds = {};

FeaturesPage.FeatureBlock = function (featureCode, enabled, switchCallback) {
    if (!featureCode) return;

    var me = this;

    this.featureCode = featureCode;
    this.switcher = enabled != null ? new TumblerSwitch(enabled, function () {
        me.callback();
    }) : null;
    this.mainDiv = null;
    this.switchCallback = switchCallback;
    this.subFeatureCodes = [];
    this.atLeastOneOnFeatureGroupCodes = [];
};

FeaturesPage.FeatureBlock.prototype.getFeatureCode = function () {
    return this.featureCode;
};

FeaturesPage.FeatureBlock.prototype.render = function (featureElId) {
    this.mainDiv = document.getElementById(featureElId);
    this.updateMainDivClass();

    var nameDiv = document.createElement("DIV");
    nameDiv.className = "name";

    this.nameContainer = document.createElement("span");
    this.nameContainer.className = "nameContainer";

    var nameSpan = document.createElement("span");
    nameSpan.innerHTML = escapeHtmlSymbols(messageResource.getMessage("features." + this.featureCode + ".title"));
    nameSpan.className = "nameSpan";

    this.mainDiv.appendChild(nameDiv);
    nameDiv.appendChild(this.nameContainer);
    this.nameContainer.appendChild(nameSpan);
    if (this.switcher) this.switcher.appendAsChildTo(this.mainDiv);else {
        var availableInProSpan = document.createElement("span");
        if (isOlVersion) {
            availableInProSpan.innerHTML = messageResource.getMessage("features.available_in_paid");
        } else {
            availableInProSpan.innerHTML = messageResource.getMessage("features.available_in_pro");
        }
        availableInProSpan.className = "availableInPro";
        this.mainDiv.appendChild(availableInProSpan);
    }

    this.addNameClickHandler();
};

FeaturesPage.FeatureBlock.prototype.getBaseCssClassName = function () {
    return "feature";
};

FeaturesPage.FeatureBlock.prototype.updateMainDivClass = function () {
    this.mainDiv.className = this.getBaseCssClassName() + " " + (this.switcher ? this.switcher.isEnabled() ? "on" : "off" : "off notAvailable");
};

FeaturesPage.FeatureBlock.prototype.addNameClickHandler = function () {
    var featureBlock = this;
    $(this.nameContainer).on("mouseover", function () {
        $(featureBlock.nameContainer).addClass('hovered');
    });
    $(this.nameContainer).on("mouseout", function () {
        $(featureBlock.nameContainer).removeClass('hovered');
    });
    $(this.nameContainer).click(function () {
        $(featureBlock.nameContainer).addClass('selected');
    });
    var onCloseCallback = function onCloseCallback() {
        $(featureBlock.nameContainer).removeClass('selected');
    };
    $(this.nameContainer).click(function () {
        featureBlock.showDescriptionPopup(onCloseCallback);
    });
};

FeaturesPage.FeatureBlock.prototype.updateSettingsMenu = function () {
    var menuItemId = FeaturesPage.featureMenuItemIds[this.getFeatureCode()];
    if (menuItemId) {
        var menuItem = document.getElementById(menuItemId);
        if (this.isEnabled()) {
            showElement(menuItem);
        } else {
            hideElement(menuItem);
        }
    }
};

FeaturesPage.FeatureBlock.prototype.isEnabled = function () {
    return this.switcher == null ? null : this.switcher.isEnabled();
};

FeaturesPage.FeatureBlock.prototype.setEnabled = function () {
    this.switcher.setEnabled();
    this.updateMainDivClass();
    this.updateSettingsMenu();
};

FeaturesPage.FeatureBlock.prototype.setDisabled = function () {
    this.switcher.setDisabled();
    this.updateMainDivClass();
    this.updateSettingsMenu();
};

FeaturesPage.FeatureBlock.prototype.callback = function () {
    this.updateMainDivClass();
    this.updateSettingsMenu();
    this.switchCallback(this);
    FeaturesPage.actions.updateFeatures(_defineProperty({}, this.getFeatureCode(), this.isEnabled()));
};

FeaturesPage.FeatureBlock.prototype.getParentFeatureCode = function () {
    return null;
};

FeaturesPage.FeatureBlock.prototype.getSubFeatureCodes = function () {
    return this.subFeatureCodes;
};

FeaturesPage.FeatureBlock.prototype.getAtLeastOneOnFeatureGroupCodes = function () {
    return this.atLeastOneOnFeatureGroupCodes;
};

FeaturesPage.FeatureBlock.prototype.addSubFeatureCode = function (subFeatureCode) {
    this.subFeatureCodes.push(subFeatureCode);
};

FeaturesPage.FeatureBlock.prototype.addAtLeastOneOnFeatureGroupCodes = function (alwaysOnGroupCodes) {
    this.atLeastOneOnFeatureGroupCodes = this.atLeastOneOnFeatureGroupCodes.concat(alwaysOnGroupCodes);
};

FeaturesPage.FeatureBlock.prototype.showDescriptionPopup = function (onCloseCallback) {
    FeaturesPage.descriptionPopup.setTitle(escapeHtmlSymbols(messageResource.getMessage("features." + this.featureCode + ".title")));
    FeaturesPage.descriptionPopup.setContent("FEATURE_" + this.featureCode + "_description");
    FeaturesPage.descriptionPopup.setOnCloseCallback(onCloseCallback);
    FeaturesPage.descriptionPopup.showAt(this.nameContainer);
};

FeaturesPage.SubFeatureBlock = function (featureCode, enabled, switchCallback, subfeatureInfo) {
    FeaturesPage.FeatureBlock.call(this, featureCode, enabled, switchCallback);
    this.parentFeatureCode = subfeatureInfo.parentFeatureCode;
    this.isLastInList = subfeatureInfo.isLast;
};

FeaturesPage.SubFeatureBlock.prototype = new FeaturesPage.FeatureBlock();

FeaturesPage.SubFeatureBlock.prototype.getBaseCssClassName = function () {
    return "feature subfeature" + (this.isLastInList ? "" : " notLast");
};

FeaturesPage.SubFeatureBlock.prototype.getParentFeatureCode = function () {
    return this.parentFeatureCode;
};

FeaturesPage.featureSwitchCallback = function (featureBlock) {
    var handler = FeaturesPage.handlers[featureBlock.getFeatureCode()];

    if (featureBlock.isEnabled()) {
        if (handler && !handler.featureTurnedOn(featureBlock)) {
            return;
        }

        var parentFeatureCode = featureBlock.getParentFeatureCode();
        if (parentFeatureCode) {
            var parentFeature = FeaturesPage.features[parentFeatureCode];
            if (!parentFeature.isEnabled()) parentFeature.setEnabled();
        }
    } else {
        if (handler && !handler.featureTurnedOff(featureBlock)) {
            return;
        }

        var subFeatureCodes = featureBlock.getSubFeatureCodes();
        for (var f = 0; f < subFeatureCodes.length; f++) {
            var subFeature = FeaturesPage.features[subFeatureCodes[f]];
            if (subFeature.isEnabled()) subFeature.setDisabled();
        }

        var atLestOneOnFeatureGroupCodes = featureBlock.getAtLeastOneOnFeatureGroupCodes();
        if (atLestOneOnFeatureGroupCodes.length !== 0) {
            var isAllGroupDisabled = true;
            for (var i = 0; i < atLestOneOnFeatureGroupCodes.length; i++) {
                var feature = FeaturesPage.features[atLestOneOnFeatureGroupCodes[i]];
                if (feature.isEnabled()) {
                    isAllGroupDisabled = false;
                    break;
                }
            }

            if (isAllGroupDisabled) {
                // enable first from group
                var groupFeature = FeaturesPage.features[atLestOneOnFeatureGroupCodes[0]];
                groupFeature.setEnabled(); // will be enabled by backend as well
            }
        }
    }

    FeaturesPage.sendFeatureAjaxRequest(featureBlock);
};

FeaturesPage.sendFeatureAjaxRequest = function (featureBlock, serviceMethodConfig, timeout) {
    var featureCode = featureBlock.getFeatureCode();
    var featureState = featureBlock.isEnabled();
    if (FeaturesPage.sentAjaxRequests[featureCode]) {
        FeaturesPage.sentAjaxRequests[featureCode].request.abort();
        featureState = FeaturesPage.sentAjaxRequests[featureCode].state;
    }

    var featureName = messageResource.getMessage("features." + featureCode + ".title");
    var alertMessagePrefix;
    if (featureState) alertMessagePrefix = messageResource.getMessage("features.subtasks_turn_off_warning.error_enabling", [featureName]);else alertMessagePrefix = messageResource.getMessage("features.subtasks_turn_off_warning.error_disabling", [featureName]);

    var methodName = !serviceMethodConfig ? "FeaturesService.setEnabled" : serviceMethodConfig.methodName;
    var methodParams = !serviceMethodConfig ? [featureCode, featureBlock.isEnabled()] : serviceMethodConfig.methodParams;

    var ajaxRequest = makeRpcCall(methodName, methodParams, function () {
        FeaturesPage.sentAjaxRequests[featureCode] = undefined;
        if (serviceMethodConfig && serviceMethodConfig.callback) serviceMethodConfig.callback();
    }, function (jqXHR, textStatus, errorThrown) {
        if (serviceMethodConfig && serviceMethodConfig.callback) serviceMethodConfig.callback();

        if (textStatus != 'abort') {
            FeaturesPage.sentAjaxRequests[featureCode] = undefined;
            if (featureState) {
                featureBlock.setDisabled();
                var parentFeatureCode = featureBlock.getParentFeatureCode();
                if (parentFeatureCode) {
                    var parentFeature = FeaturesPage.features[parentFeatureCode];
                    if (parentFeature.isEnabled()) parentFeature.setDisabled();
                }
            } else {
                featureBlock.setEnabled();
                var subFeatureCodes = featureBlock.getSubFeatureCodes();
                for (var f = 0; f < subFeatureCodes.length; f++) {
                    var subFeature = FeaturesPage.features[subFeatureCodes[f]];
                    if (!subFeature.isEnabled()) subFeature.setEnabled();
                }
            }
            return false;
        }
    }, alertMessagePrefix, timeout);

    FeaturesPage.sentAjaxRequests[featureBlock.getFeatureCode()] = { "state": featureState, "request": ajaxRequest };
};

FeaturesPage.FeatureStateChangeHandler = function () {};

FeaturesPage.FeatureStateChangeHandler.prototype.featureTurnedOn = function () {
    return true;
};

FeaturesPage.FeatureStateChangeHandler.prototype.featureTurnedOff = function () {
    return true;
};

FeaturesPage.TTApprovalHandler = function (showDialogOnTTAEnabling, ttApprovalLastDisablingTimestamp) {
    FeaturesPage.FeatureStateChangeHandler.call(this);
    this.showDialog = showDialogOnTTAEnabling;
    this.ttApprovalLastDisablingTimestamp = ttApprovalLastDisablingTimestamp;
};

FeaturesPage.TTApprovalHandler.prototype = new FeaturesPage.FeatureStateChangeHandler();

FeaturesPage.TTApprovalHandler.prototype.onConfirmFunction = function (featureBlock, approveAllWeeks, weekDate, callback) {
    featureBlock.setEnabled();
    FeaturesPage.sendFeatureAjaxRequest(featureBlock, {
        methodName: "FeaturesService.setEnabledTTA",
        methodParams: [true, approveAllWeeks, weekDate],
        callback: callback
    }, LONG_RPC_TIMEOUT);
};

FeaturesPage.TTApprovalHandler.prototype.disableFeature = function (featureBlock) {
    //featureBlock.setDisabled();
    FeaturesPage.sendFeatureAjaxRequest(featureBlock, {
        methodName: "FeaturesService.setEnabledTTA",
        methodParams: [false, false, null]
    });
};

FeaturesPage.TTApprovalHandler.prototype.featureTurnedOn = function (featureBlock) {
    if (!this.showDialog) return true;

    var self = this;
    featureBlock.setDisabled();

    if (!this.ttaConfirmDialog) this.ttaConfirmDialog = new TTAConfirmDialog().init({
        popupId: "ttaConfirmDialog",
        lastDisablingTimestamp: self.ttApprovalLastDisablingTimestamp,
        submitFunction: function submitFunction(approveTT, weekDate, callback) {
            self.onConfirmFunction(featureBlock, approveTT, weekDate, callback);
        },
        cancelFunction: function cancelFunction() {/*do nothing*/}
    });

    this.ttaConfirmDialog.show();

    return false;
};

FeaturesPage.TTApprovalHandler.prototype.featureTurnedOff = function (featureBlock) {
    this.disableFeature(featureBlock);
    return false;
};

FeaturesPage.init = function (features, featureDependencies, handlers) {
    var featureBlock, parentFeatureCode;

    for (var featureCode in features) {
        parentFeatureCode = featureDependencies.subsections[featureCode];
        if (parentFeatureCode) featureBlock = new FeaturesPage.SubFeatureBlock(featureCode, features[featureCode], FeaturesPage.featureSwitchCallback, parentFeatureCode);else featureBlock = new FeaturesPage.FeatureBlock(featureCode, features[featureCode], FeaturesPage.featureSwitchCallback);

        FeaturesPage.features[featureCode] = featureBlock;
    }

    for (var subFeatureCode in featureDependencies.subsections) {
        parentFeatureCode = featureDependencies.subsections[subFeatureCode].parentFeatureCode;
        var parentFeatureBlock = FeaturesPage.features[parentFeatureCode];
        if (parentFeatureBlock) parentFeatureBlock.addSubFeatureCode(subFeatureCode);
    }

    for (featureCode in featureDependencies.atLeastOneEnabledGroups) {
        featureBlock = FeaturesPage.features[featureCode];
        if (featureBlock) featureBlock.addAtLeastOneOnFeatureGroupCodes(featureDependencies.atLeastOneEnabledGroups[featureCode]);
    }

    for (featureCode in FeaturesPage.features) {
        FeaturesPage.features[featureCode].render("FEATURE_" + featureCode);
    }FeaturesPage.handlers = handlers;

    FeaturesPage.descriptionPopup = new FeaturesPage.DescriptionPopup();
    FeaturesPage.descriptionPopup.init();

    FeaturesPage.actions = (0, _utils.unsafe_bindActions)(function (dispatch) {
        return {
            updateFeatures: (0, _redux.bindActionCreators)(_actions.updateFeatures, dispatch)
        };
    });
};

FeaturesPage.DescriptionPopup = function () {};

FeaturesPage.DescriptionPopup.prototype = {};

FeaturesPage.DescriptionPopup.prototype.init = function () {
    var self = this;
    this.descriptionPopupClass = "featureDescriptionPopup";
    this.descriptionPopup = new DropdownDialog({
        dialogDiv: "#featureDescriptionPopupContent",
        wrapperClass: this.descriptionPopupClass + " customPopup",
        hideButtons: true,
        hideOnResize: true,
        isWithBeak: true,
        notModal: true,
        onClose: function onClose() {
            if (self.onCloseCallback) self.onCloseCallback();
        }
    });
    this.featureDescriptionTitle = $("#featureDescriptionTitle");
    this.featureDescriptionContent = $("#featureDescriptionContent");

    this.featureDescriptionTemplates = $("#featureDescriptionTemplates");

    $("#closeFeatureDescription").click(function () {
        self.descriptionPopup.hide();
    });
};

FeaturesPage.DescriptionPopup.prototype.setOnCloseCallback = function (callback) {
    var self = this;
    this.onCloseCallback = callback;

    var element = $("." + this.descriptionPopupClass)[0];
    // set mouse down outside handler, so that clicks on scroll bar are not handled
    $(document.body).mousedown(function (event) {
        if ($(event.target).parents().index(element) == -1) {
            callback();
            self.descriptionPopup.hide();
        }
    });
};

FeaturesPage.DescriptionPopup.prototype.showAt = function (element) {
    var popupOffsetX = 12;
    var minOffsetX = 95;
    var dx = $(window).width() + getBodyScrollLeft() - $(element).offset().left - $(element).outerWidth() - popupOffsetX - $("." + this.descriptionPopupClass).width();
    if (dx < 0) popupOffsetX = dx;
    var offsetX = popupOffsetX + $(element).outerWidth();
    if (offsetX < minOffsetX) offsetX = minOffsetX;

    this.descriptionPopup.showAt(element, { my: "left center", at: "left center", collision: "none", offset: offsetX + "px 0" });
    this.scrollToTop();
};

FeaturesPage.DescriptionPopup.prototype.setTitle = function (title) {
    this.featureDescriptionTitle.html(title);
};

FeaturesPage.DescriptionPopup.prototype.setContent = function (contentDivId) {
    this.featureDescriptionContent.find("div").remove();
    this.featureDescriptionTemplates.find("#" + contentDivId).clone().appendTo(this.featureDescriptionContent);
};

FeaturesPage.DescriptionPopup.prototype.scrollToTop = function () {
    this.featureDescriptionContent.scrollTop(0);
};

exports.default = FeaturesPage;

/***/ }),
/* 1173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(442);


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (getRawTag);


/***/ }),
/* 1174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/* harmony default export */ __webpack_exports__["a"] = (objectToString);


/***/ }),
/* 1175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overArg_js__ = __webpack_require__(645);


/** Built-in value references. */
var getPrototype = Object(__WEBPACK_IMPORTED_MODULE_0__overArg_js__["a" /* default */])(Object.getPrototypeOf, Object);

/* harmony default export */ __webpack_exports__["a"] = (getPrototype);


/***/ }),
/* 1176 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1177);


/***/ }),
/* 1177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, module) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ponyfill = __webpack_require__(1178);

var _ponyfill2 = _interopRequireDefault(_ponyfill);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var root; /* global window */


if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = (0, _ponyfill2['default'])(root);
exports['default'] = result;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(441), __webpack_require__(440)(module)))

/***/ }),
/* 1178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports['default'] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var _Symbol = root.Symbol;

	if (typeof _Symbol === 'function') {
		if (_Symbol.observable) {
			result = _Symbol.observable;
		} else {
			result = _Symbol('observable');
			_Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};

/***/ }),
/* 1179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = combineReducers;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(643);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_warning__ = __webpack_require__(646);




function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';

  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__["a" /* default */])(inputState)) {
    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });

  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });

  if (unexpectedKeys.length > 0) {
    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, { type: __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT });

    if (typeof initialState === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
    }

    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
    if (typeof reducer(undefined, { type: type }) === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
    }
  });
}

/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */
function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};
  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning('No reducer provided for key "' + key + '"');
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }
  var finalReducerKeys = Object.keys(finalReducers);

  var unexpectedKeyCache = void 0;
  if (false) {
    unexpectedKeyCache = {};
  }

  var shapeAssertionError = void 0;
  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};
    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);
      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(_key, action);
        throw new Error(errorMessage);
      }
      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }
    return hasChanged ? nextState : state;
  };
}

/***/ }),
/* 1180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = bindActionCreators;
function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(undefined, arguments));
  };
}

/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass a single function as the first argument,
 * and get a function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */
function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
  }

  var keys = Object.keys(actionCreators);
  var boundActionCreators = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var actionCreator = actionCreators[key];
    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }
  return boundActionCreators;
}

/***/ }),
/* 1181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = applyMiddleware;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__compose__ = __webpack_require__(647);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */
function applyMiddleware() {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function (reducer, preloadedState, enhancer) {
      var store = createStore(reducer, preloadedState, enhancer);
      var _dispatch = store.dispatch;
      var chain = [];

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch(action) {
          return _dispatch(action);
        }
      };
      chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = __WEBPACK_IMPORTED_MODULE_0__compose__["a" /* default */].apply(undefined, chain)(store.dispatch);

      return _extends({}, store, {
        dispatch: _dispatch
      });
    };
  };
}

/***/ }),
/* 1182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
function createThunkMiddleware(extraArgument) {
  return function (_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;
    return function (next) {
      return function (action) {
        if (typeof action === 'function') {
          return action(dispatch, getState, extraArgument);
        }

        return next(action);
      };
    };
  };
}

var thunk = createThunkMiddleware();
thunk.withExtraArgument = createThunkMiddleware;

exports['default'] = thunk;

/***/ }),
/* 1183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _redux = __webpack_require__(7);

var _reducer = __webpack_require__(648);

var _reducer2 = _interopRequireDefault(_reducer);

var _reducer3 = __webpack_require__(665);

var _reducer4 = _interopRequireDefault(_reducer3);

var _reducer5 = __webpack_require__(1225);

var _reducer6 = _interopRequireDefault(_reducer5);

var _reducer7 = __webpack_require__(1227);

var _reducer8 = _interopRequireDefault(_reducer7);

var _reducer9 = __webpack_require__(1238);

var _reducer10 = _interopRequireDefault(_reducer9);

var _reducer11 = __webpack_require__(1251);

var _reducer12 = _interopRequireDefault(_reducer11);

var _reducer13 = __webpack_require__(1252);

var _reducer14 = _interopRequireDefault(_reducer13);

var _reducer15 = __webpack_require__(1254);

var _reducer16 = _interopRequireDefault(_reducer15);

var _reducer17 = __webpack_require__(696);

var _reducer18 = _interopRequireDefault(_reducer17);

var _reducer19 = __webpack_require__(1265);

var _reducer20 = _interopRequireDefault(_reducer19);

var _reducer21 = __webpack_require__(1268);

var _reducer22 = _interopRequireDefault(_reducer21);

var _reducer23 = __webpack_require__(701);

var _reducer24 = _interopRequireDefault(_reducer23);

var _reducer25 = __webpack_require__(702);

var _reducer26 = _interopRequireDefault(_reducer25);

var _commonReducer = __webpack_require__(703);

var _commonReducer2 = _interopRequireDefault(_commonReducer);

var _reducer27 = __webpack_require__(705);

var _reducer28 = _interopRequireDefault(_reducer27);

var _reducer29 = __webpack_require__(706);

var _reducer30 = _interopRequireDefault(_reducer29);

var _workScheduleReducer = __webpack_require__(708);

var _workScheduleReducer2 = _interopRequireDefault(_workScheduleReducer);

var _reducer31 = __webpack_require__(712);

var _reducer32 = _interopRequireDefault(_reducer31);

var _reducer33 = __webpack_require__(713);

var _reducer34 = _interopRequireDefault(_reducer33);

var _reducer35 = __webpack_require__(715);

var _reducer36 = _interopRequireDefault(_reducer35);

var _reducer37 = __webpack_require__(1284);

var _reducer38 = _interopRequireDefault(_reducer37);

var _reducer39 = __webpack_require__(1285);

var _reducer40 = _interopRequireDefault(_reducer39);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (initAppData) {
    return (0, _redux.combineReducers)({
        loggedInUser: (0, _reducer2.default)(initAppData),
        entities: (0, _reducer4.default)(initAppData),
        assignments: (0, _reducer6.default)(initAppData),
        taskManagement: (0, _reducer8.default)(initAppData),
        panels: (0, _reducer10.default)(initAppData),
        userProfile: (0, _reducer20.default)(initAppData),
        workflowSettings: _reducer12.default,
        darSettings: (0, _reducer14.default)(initAppData),
        lockoutPolicy: (0, _reducer24.default)(initAppData),
        passwordSettings: (0, _reducer26.default)(initAppData),
        lowBalanceSettings: (0, _commonReducer2.default)(initAppData),
        mailSettings: (0, _reducer28.default)(initAppData),
        userManagement: (0, _reducer16.default)(initAppData),
        features: (0, _reducer18.default)(initAppData),
        reports: (0, _reducer22.default)(initAppData),
        workSchedule: (0, _workScheduleReducer2.default)(initAppData),
        toasts: _reducer30.default,
        activeLicenseInfo: (0, _reducer32.default)(initAppData),
        support: (0, _reducer34.default)(initAppData),
        addons: (0, _reducer38.default)(initAppData),
        welcome: (0, _reducer36.default)(initAppData),
        customFields: (0, _reducer40.default)(initAppData)
    });
};

/***/ }),
/* 1184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is `null`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
 * @example
 *
 * _.isNull(null);
 * // => true
 *
 * _.isNull(void 0);
 * // => false
 */
function isNull(value) {
  return value === null;
}

/* harmony default export */ __webpack_exports__["a"] = (isNull);


/***/ }),
/* 1185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is `undefined`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
 * @example
 *
 * _.isUndefined(void 0);
 * // => true
 *
 * _.isUndefined(null);
 * // => false
 */
function isUndefined(value) {
  return value === undefined;
}

/* harmony default export */ __webpack_exports__["a"] = (isUndefined);


/***/ }),
/* 1186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIndexOf_js__ = __webpack_require__(1187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isArrayLike_js__ = __webpack_require__(445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isString_js__ = __webpack_require__(446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__toInteger_js__ = __webpack_require__(1191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__values_js__ = __webpack_require__(1194);






/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Checks if `value` is in `collection`. If `collection` is a string, it's
 * checked for a substring of `value`, otherwise
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * is used for equality comparisons. If `fromIndex` is negative, it's used as
 * the offset from the end of `collection`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @param {*} value The value to search for.
 * @param {number} [fromIndex=0] The index to search from.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 * @example
 *
 * _.includes([1, 2, 3], 1);
 * // => true
 *
 * _.includes([1, 2, 3], 1, 2);
 * // => false
 *
 * _.includes({ 'a': 1, 'b': 2 }, 1);
 * // => true
 *
 * _.includes('abcd', 'bc');
 * // => true
 */
function includes(collection, value, fromIndex, guard) {
  collection = Object(__WEBPACK_IMPORTED_MODULE_1__isArrayLike_js__["a" /* default */])(collection) ? collection : Object(__WEBPACK_IMPORTED_MODULE_4__values_js__["a" /* default */])(collection);
  fromIndex = (fromIndex && !guard) ? Object(__WEBPACK_IMPORTED_MODULE_3__toInteger_js__["a" /* default */])(fromIndex) : 0;

  var length = collection.length;
  if (fromIndex < 0) {
    fromIndex = nativeMax(length + fromIndex, 0);
  }
  return Object(__WEBPACK_IMPORTED_MODULE_2__isString_js__["a" /* default */])(collection)
    ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
    : (!!length && Object(__WEBPACK_IMPORTED_MODULE_0__baseIndexOf_js__["a" /* default */])(collection, value, fromIndex) > -1);
}

/* harmony default export */ __webpack_exports__["a"] = (includes);


/***/ }),
/* 1187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseFindIndex_js__ = __webpack_require__(1188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseIsNaN_js__ = __webpack_require__(1189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__strictIndexOf_js__ = __webpack_require__(1190);




/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value
    ? Object(__WEBPACK_IMPORTED_MODULE_2__strictIndexOf_js__["a" /* default */])(array, value, fromIndex)
    : Object(__WEBPACK_IMPORTED_MODULE_0__baseFindIndex_js__["a" /* default */])(array, __WEBPACK_IMPORTED_MODULE_1__baseIsNaN_js__["a" /* default */], fromIndex);
}

/* harmony default export */ __webpack_exports__["a"] = (baseIndexOf);


/***/ }),
/* 1188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

/* harmony default export */ __webpack_exports__["a"] = (baseFindIndex);


/***/ }),
/* 1189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

/* harmony default export */ __webpack_exports__["a"] = (baseIsNaN);


/***/ }),
/* 1190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

/* harmony default export */ __webpack_exports__["a"] = (strictIndexOf);


/***/ }),
/* 1191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toFinite_js__ = __webpack_require__(1192);


/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = Object(__WEBPACK_IMPORTED_MODULE_0__toFinite_js__["a" /* default */])(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

/* harmony default export */ __webpack_exports__["a"] = (toInteger);


/***/ }),
/* 1192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toNumber_js__ = __webpack_require__(1193);


/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = Object(__WEBPACK_IMPORTED_MODULE_0__toNumber_js__["a" /* default */])(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

/* harmony default export */ __webpack_exports__["a"] = (toFinite);


/***/ }),
/* 1193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isObject_js__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isSymbol_js__ = __webpack_require__(447);



/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_1__isSymbol_js__["a" /* default */])(value)) {
    return NAN;
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_0__isObject_js__["a" /* default */])(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = Object(__WEBPACK_IMPORTED_MODULE_0__isObject_js__["a" /* default */])(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

/* harmony default export */ __webpack_exports__["a"] = (toNumber);


/***/ }),
/* 1194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseValues_js__ = __webpack_require__(1195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__keys_js__ = __webpack_require__(1196);



/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */
function values(object) {
  return object == null ? [] : Object(__WEBPACK_IMPORTED_MODULE_0__baseValues_js__["a" /* default */])(object, Object(__WEBPACK_IMPORTED_MODULE_1__keys_js__["a" /* default */])(object));
}

/* harmony default export */ __webpack_exports__["a"] = (values);


/***/ }),
/* 1195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayMap_js__ = __webpack_require__(653);


/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */
function baseValues(object, props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__arrayMap_js__["a" /* default */])(props, function(key) {
    return object[key];
  });
}

/* harmony default export */ __webpack_exports__["a"] = (baseValues);


/***/ }),
/* 1196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayLikeKeys_js__ = __webpack_require__(1197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseKeys_js__ = __webpack_require__(658);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArrayLike_js__ = __webpack_require__(445);




/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__isArrayLike_js__["a" /* default */])(object) ? Object(__WEBPACK_IMPORTED_MODULE_0__arrayLikeKeys_js__["a" /* default */])(object) : Object(__WEBPACK_IMPORTED_MODULE_1__baseKeys_js__["a" /* default */])(object);
}

/* harmony default export */ __webpack_exports__["a"] = (keys);


/***/ }),
/* 1197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseTimes_js__ = __webpack_require__(1198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isArguments_js__ = __webpack_require__(654);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArray_js__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isBuffer_js__ = __webpack_require__(655);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__isIndex_js__ = __webpack_require__(1201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__isTypedArray_js__ = __webpack_require__(657);







/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = Object(__WEBPACK_IMPORTED_MODULE_2__isArray_js__["a" /* default */])(value),
      isArg = !isArr && Object(__WEBPACK_IMPORTED_MODULE_1__isArguments_js__["a" /* default */])(value),
      isBuff = !isArr && !isArg && Object(__WEBPACK_IMPORTED_MODULE_3__isBuffer_js__["a" /* default */])(value),
      isType = !isArr && !isArg && !isBuff && Object(__WEBPACK_IMPORTED_MODULE_5__isTypedArray_js__["a" /* default */])(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? Object(__WEBPACK_IMPORTED_MODULE_0__baseTimes_js__["a" /* default */])(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           Object(__WEBPACK_IMPORTED_MODULE_4__isIndex_js__["a" /* default */])(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (arrayLikeKeys);


/***/ }),
/* 1198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (baseTimes);


/***/ }),
/* 1199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__ = __webpack_require__(224);



/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(value) && Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) == argsTag;
}

/* harmony default export */ __webpack_exports__["a"] = (baseIsArguments);


/***/ }),
/* 1200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (stubFalse);


/***/ }),
/* 1201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/* harmony default export */ __webpack_exports__["a"] = (isIndex);


/***/ }),
/* 1202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isLength_js__ = __webpack_require__(652);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__(224);




/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["a" /* default */])(value) &&
    Object(__WEBPACK_IMPORTED_MODULE_1__isLength_js__["a" /* default */])(value.length) && !!typedArrayTags[Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value)];
}

/* harmony default export */ __webpack_exports__["a"] = (baseIsTypedArray);


/***/ }),
/* 1203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (baseUnary);


/***/ }),
/* 1204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__(644);


/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */].process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

/* harmony default export */ __webpack_exports__["a"] = (nodeUtil);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(656)(module)))

/***/ }),
/* 1205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overArg_js__ = __webpack_require__(645);


/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = Object(__WEBPACK_IMPORTED_MODULE_0__overArg_js__["a" /* default */])(Object.keys, Object);

/* harmony default export */ __webpack_exports__["a"] = (nativeKeys);


/***/ }),
/* 1206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseKeys_js__ = __webpack_require__(658);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getTag_js__ = __webpack_require__(1207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArguments_js__ = __webpack_require__(654);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isArray_js__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__isArrayLike_js__ = __webpack_require__(445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__isBuffer_js__ = __webpack_require__(655);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__isPrototype_js__ = __webpack_require__(659);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__isTypedArray_js__ = __webpack_require__(657);









/** `Object#toString` result references. */
var mapTag = '[object Map]',
    setTag = '[object Set]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */
function isEmpty(value) {
  if (value == null) {
    return true;
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_4__isArrayLike_js__["a" /* default */])(value) &&
      (Object(__WEBPACK_IMPORTED_MODULE_3__isArray_js__["a" /* default */])(value) || typeof value == 'string' || typeof value.splice == 'function' ||
        Object(__WEBPACK_IMPORTED_MODULE_5__isBuffer_js__["a" /* default */])(value) || Object(__WEBPACK_IMPORTED_MODULE_7__isTypedArray_js__["a" /* default */])(value) || Object(__WEBPACK_IMPORTED_MODULE_2__isArguments_js__["a" /* default */])(value))) {
    return !value.length;
  }
  var tag = Object(__WEBPACK_IMPORTED_MODULE_1__getTag_js__["a" /* default */])(value);
  if (tag == mapTag || tag == setTag) {
    return !value.size;
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_6__isPrototype_js__["a" /* default */])(value)) {
    return !Object(__WEBPACK_IMPORTED_MODULE_0__baseKeys_js__["a" /* default */])(value).length;
  }
  for (var key in value) {
    if (hasOwnProperty.call(value, key)) {
      return false;
    }
  }
  return true;
}

/* harmony default export */ __webpack_exports__["a"] = (isEmpty);


/***/ }),
/* 1207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DataView_js__ = __webpack_require__(1208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Map_js__ = __webpack_require__(1213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Promise_js__ = __webpack_require__(1214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Set_js__ = __webpack_require__(1215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__WeakMap_js__ = __webpack_require__(1216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__baseGetTag_js__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__toSource_js__ = __webpack_require__(661);








/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = Object(__WEBPACK_IMPORTED_MODULE_6__toSource_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__DataView_js__["a" /* default */]),
    mapCtorString = Object(__WEBPACK_IMPORTED_MODULE_6__toSource_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__Map_js__["a" /* default */]),
    promiseCtorString = Object(__WEBPACK_IMPORTED_MODULE_6__toSource_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2__Promise_js__["a" /* default */]),
    setCtorString = Object(__WEBPACK_IMPORTED_MODULE_6__toSource_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_3__Set_js__["a" /* default */]),
    weakMapCtorString = Object(__WEBPACK_IMPORTED_MODULE_6__toSource_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_4__WeakMap_js__["a" /* default */]);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = __WEBPACK_IMPORTED_MODULE_5__baseGetTag_js__["a" /* default */];

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((__WEBPACK_IMPORTED_MODULE_0__DataView_js__["a" /* default */] && getTag(new __WEBPACK_IMPORTED_MODULE_0__DataView_js__["a" /* default */](new ArrayBuffer(1))) != dataViewTag) ||
    (__WEBPACK_IMPORTED_MODULE_1__Map_js__["a" /* default */] && getTag(new __WEBPACK_IMPORTED_MODULE_1__Map_js__["a" /* default */]) != mapTag) ||
    (__WEBPACK_IMPORTED_MODULE_2__Promise_js__["a" /* default */] && getTag(__WEBPACK_IMPORTED_MODULE_2__Promise_js__["a" /* default */].resolve()) != promiseTag) ||
    (__WEBPACK_IMPORTED_MODULE_3__Set_js__["a" /* default */] && getTag(new __WEBPACK_IMPORTED_MODULE_3__Set_js__["a" /* default */]) != setTag) ||
    (__WEBPACK_IMPORTED_MODULE_4__WeakMap_js__["a" /* default */] && getTag(new __WEBPACK_IMPORTED_MODULE_4__WeakMap_js__["a" /* default */]) != weakMapTag)) {
  getTag = function(value) {
    var result = Object(__WEBPACK_IMPORTED_MODULE_5__baseGetTag_js__["a" /* default */])(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? Object(__WEBPACK_IMPORTED_MODULE_6__toSource_js__["a" /* default */])(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (getTag);


/***/ }),
/* 1208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__root_js__ = __webpack_require__(155);



/* Built-in method references that are verified to be native. */
var DataView = Object(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__root_js__["a" /* default */], 'DataView');

/* harmony default export */ __webpack_exports__["a"] = (DataView);


/***/ }),
/* 1209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isFunction_js__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isMasked_js__ = __webpack_require__(1210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObject_js__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__toSource_js__ = __webpack_require__(661);





/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_2__isObject_js__["a" /* default */])(value) || Object(__WEBPACK_IMPORTED_MODULE_1__isMasked_js__["a" /* default */])(value)) {
    return false;
  }
  var pattern = Object(__WEBPACK_IMPORTED_MODULE_0__isFunction_js__["a" /* default */])(value) ? reIsNative : reIsHostCtor;
  return pattern.test(Object(__WEBPACK_IMPORTED_MODULE_3__toSource_js__["a" /* default */])(value));
}

/* harmony default export */ __webpack_exports__["a"] = (baseIsNative);


/***/ }),
/* 1210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__coreJsData_js__ = __webpack_require__(1211);


/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(__WEBPACK_IMPORTED_MODULE_0__coreJsData_js__["a" /* default */] && __WEBPACK_IMPORTED_MODULE_0__coreJsData_js__["a" /* default */].keys && __WEBPACK_IMPORTED_MODULE_0__coreJsData_js__["a" /* default */].keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/* harmony default export */ __webpack_exports__["a"] = (isMasked);


/***/ }),
/* 1211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(155);


/** Used to detect overreaching core-js shims. */
var coreJsData = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */]['__core-js_shared__'];

/* harmony default export */ __webpack_exports__["a"] = (coreJsData);


/***/ }),
/* 1212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/* harmony default export */ __webpack_exports__["a"] = (getValue);


/***/ }),
/* 1213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__root_js__ = __webpack_require__(155);



/* Built-in method references that are verified to be native. */
var Map = Object(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__root_js__["a" /* default */], 'Map');

/* harmony default export */ __webpack_exports__["a"] = (Map);


/***/ }),
/* 1214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__root_js__ = __webpack_require__(155);



/* Built-in method references that are verified to be native. */
var Promise = Object(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__root_js__["a" /* default */], 'Promise');

/* harmony default export */ __webpack_exports__["a"] = (Promise);


/***/ }),
/* 1215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__root_js__ = __webpack_require__(155);



/* Built-in method references that are verified to be native. */
var Set = Object(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__root_js__["a" /* default */], 'Set');

/* harmony default export */ __webpack_exports__["a"] = (Set);


/***/ }),
/* 1216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__root_js__ = __webpack_require__(155);



/* Built-in method references that are verified to be native. */
var WeakMap = Object(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__root_js__["a" /* default */], 'WeakMap');

/* harmony default export */ __webpack_exports__["a"] = (WeakMap);


/***/ }),
/* 1217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseToString_js__ = __webpack_require__(1218);


/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : Object(__WEBPACK_IMPORTED_MODULE_0__baseToString_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (toString);


/***/ }),
/* 1218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__arrayMap_js__ = __webpack_require__(653);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArray_js__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isSymbol_js__ = __webpack_require__(447);





/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_2__isArray_js__["a" /* default */])(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return Object(__WEBPACK_IMPORTED_MODULE_1__arrayMap_js__["a" /* default */])(value, baseToString) + '';
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_3__isSymbol_js__["a" /* default */])(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/* harmony default export */ __webpack_exports__["a"] = (baseToString);


/***/ }),
/* 1219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = handleActions;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reduce_reducers__ = __webpack_require__(1220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reduce_reducers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_reduce_reducers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__handleAction__ = __webpack_require__(650);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ownKeys__ = __webpack_require__(448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__flattenUtils__ = __webpack_require__(662);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }








function handleActions(handlers, defaultState) {
  var _ref = arguments.length <= 2 || arguments[2] === undefined ? {} : arguments[2];

  var namespace = _ref.namespace;

  __WEBPACK_IMPORTED_MODULE_2_invariant___default()(Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(handlers), 'Expected handlers to be an plain object.');
  var flattenedReducerMap = Object(__WEBPACK_IMPORTED_MODULE_5__flattenUtils__["b" /* flattenReducerMap */])(handlers, namespace);
  var reducers = Object(__WEBPACK_IMPORTED_MODULE_4__ownKeys__["a" /* default */])(flattenedReducerMap).map(function (type) {
    return Object(__WEBPACK_IMPORTED_MODULE_3__handleAction__["a" /* default */])(type, flattenedReducerMap[type], defaultState);
  });
  var reducer = __WEBPACK_IMPORTED_MODULE_1_reduce_reducers___default.a.apply(undefined, _toConsumableArray(reducers));
  return function () {
    var state = arguments.length <= 0 || arguments[0] === undefined ? defaultState : arguments[0];
    var action = arguments[1];
    return reducer(state, action);
  };
}

/***/ }),
/* 1220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports["default"] = reduceReducers;

function reduceReducers() {
  for (var _len = arguments.length, reducers = Array(_len), _key = 0; _key < _len; _key++) {
    reducers[_key] = arguments[_key];
  }

  return function (previous, current) {
    return reducers.reduce(function (p, r) {
      return r(p, current);
    }, previous);
  };
}

module.exports = exports["default"];

/***/ }),
/* 1221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = hasGeneratorInterface;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ownKeys__ = __webpack_require__(448);


function hasGeneratorInterface(handler) {
  var keys = Object(__WEBPACK_IMPORTED_MODULE_0__ownKeys__["a" /* default */])(handler);
  var hasOnlyInterfaceNames = keys.every(function (ownKey) {
    return ownKey === 'next' || ownKey === 'throw';
  });
  return keys.length && keys.length <= 2 && hasOnlyInterfaceNames;
}

/***/ }),
/* 1222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createActions;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__camelCase__ = __webpack_require__(663);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_identity__ = __webpack_require__(443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_es_isPlainObject__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_es_isArray__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_es_last__ = __webpack_require__(1223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_es_isString__ = __webpack_require__(446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_es_isFunction__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_es_isNil__ = __webpack_require__(651);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__createAction__ = __webpack_require__(649);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_invariant__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__arrayToObject__ = __webpack_require__(1224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__flattenUtils__ = __webpack_require__(662);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }














function createActions(actionMap) {
  for (var _len = arguments.length, identityActions = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    identityActions[_key - 1] = arguments[_key];
  }

  var _ref = Object(__WEBPACK_IMPORTED_MODULE_2_lodash_es_isPlainObject__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4_lodash_es_last__["a" /* default */])(identityActions)) ? identityActions.pop() : {};

  var namespace = _ref.namespace;

  __WEBPACK_IMPORTED_MODULE_9_invariant___default()(identityActions.every(__WEBPACK_IMPORTED_MODULE_5_lodash_es_isString__["a" /* default */]) && (Object(__WEBPACK_IMPORTED_MODULE_5_lodash_es_isString__["a" /* default */])(actionMap) || Object(__WEBPACK_IMPORTED_MODULE_2_lodash_es_isPlainObject__["a" /* default */])(actionMap)), 'Expected optional object followed by string action types');
  if (Object(__WEBPACK_IMPORTED_MODULE_5_lodash_es_isString__["a" /* default */])(actionMap)) {
    return actionCreatorsFromIdentityActions([actionMap].concat(identityActions));
  }
  return _extends({}, actionCreatorsFromActionMap(actionMap, namespace), actionCreatorsFromIdentityActions(identityActions));
}

function actionCreatorsFromActionMap(actionMap, namespace) {
  var flatActionMap = Object(__WEBPACK_IMPORTED_MODULE_11__flattenUtils__["a" /* flattenActionMap */])(actionMap, namespace);
  var flatActionCreators = actionMapToActionCreators(flatActionMap);
  return Object(__WEBPACK_IMPORTED_MODULE_11__flattenUtils__["c" /* unflattenActionCreators */])(flatActionCreators, namespace);
}

function actionMapToActionCreators(actionMap) {
  function isValidActionMapValue(actionMapValue) {
    if (Object(__WEBPACK_IMPORTED_MODULE_6_lodash_es_isFunction__["a" /* default */])(actionMapValue) || Object(__WEBPACK_IMPORTED_MODULE_7_lodash_es_isNil__["a" /* default */])(actionMapValue)) {
      return true;
    } else if (Object(__WEBPACK_IMPORTED_MODULE_3_lodash_es_isArray__["a" /* default */])(actionMapValue)) {
      var _actionMapValue = _slicedToArray(actionMapValue, 2);

      var _actionMapValue$ = _actionMapValue[0];
      var payload = _actionMapValue$ === undefined ? __WEBPACK_IMPORTED_MODULE_1_lodash_es_identity__["a" /* default */] : _actionMapValue$;
      var meta = _actionMapValue[1];

      return Object(__WEBPACK_IMPORTED_MODULE_6_lodash_es_isFunction__["a" /* default */])(payload) && Object(__WEBPACK_IMPORTED_MODULE_6_lodash_es_isFunction__["a" /* default */])(meta);
    }
    return false;
  }

  return Object(__WEBPACK_IMPORTED_MODULE_10__arrayToObject__["a" /* default */])(Object.keys(actionMap), function (partialActionCreators, type) {
    var actionMapValue = actionMap[type];
    __WEBPACK_IMPORTED_MODULE_9_invariant___default()(isValidActionMapValue(actionMapValue), 'Expected function, undefined, null, or array with payload and meta ' + ('functions for ' + type));
    var actionCreator = Object(__WEBPACK_IMPORTED_MODULE_3_lodash_es_isArray__["a" /* default */])(actionMapValue) ? __WEBPACK_IMPORTED_MODULE_8__createAction__["a" /* default */].apply(undefined, [type].concat(_toConsumableArray(actionMapValue))) : Object(__WEBPACK_IMPORTED_MODULE_8__createAction__["a" /* default */])(type, actionMapValue);
    return _extends({}, partialActionCreators, _defineProperty({}, type, actionCreator));
  });
}

function actionCreatorsFromIdentityActions(identityActions) {
  var actionMap = Object(__WEBPACK_IMPORTED_MODULE_10__arrayToObject__["a" /* default */])(identityActions, function (partialActionMap, type) {
    return _extends({}, partialActionMap, _defineProperty({}, type, __WEBPACK_IMPORTED_MODULE_1_lodash_es_identity__["a" /* default */]));
  });
  var actionCreators = actionMapToActionCreators(actionMap);
  return Object(__WEBPACK_IMPORTED_MODULE_10__arrayToObject__["a" /* default */])(Object.keys(actionCreators), function (partialActionCreators, type) {
    return _extends({}, partialActionCreators, _defineProperty({}, Object(__WEBPACK_IMPORTED_MODULE_0__camelCase__["a" /* default */])(type), actionCreators[type]));
  });
}

/***/ }),
/* 1223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */
function last(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = (last);


/***/ }),
/* 1224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (array, callback) {
  return array.reduce(function (partialObject, element) {
    return callback(partialObject, element);
  }, {});
});

/***/ }),
/* 1225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reduxActions = __webpack_require__(9);

var _actionTypes = __webpack_require__(1226);

var ActionTypes = _interopRequireWildcard(_actionTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var createAssignmentsReducer = function createAssignmentsReducer(_ref) {
    var _handleActions;

    var _ref$USER_WORK_ASSIGN = _ref.USER_WORK_ASSIGNMENTS,
        USER_WORK_ASSIGNMENTS = _ref$USER_WORK_ASSIGN === undefined ? {} : _ref$USER_WORK_ASSIGN,
        _ref$USER_MANAGEMENT_ = _ref.USER_MANAGEMENT_ASSIGNMENTS,
        USER_MANAGEMENT_ASSIGNMENTS = _ref$USER_MANAGEMENT_ === undefined ? {} : _ref$USER_MANAGEMENT_,
        _ref$USER_TEAM_ASSIGN = _ref.USER_TEAM_ASSIGNMENTS,
        USER_TEAM_ASSIGNMENTS = _ref$USER_TEAM_ASSIGN === undefined ? {} : _ref$USER_TEAM_ASSIGN;

    var initialState = {
        userWorkAssignments: USER_WORK_ASSIGNMENTS,
        userManagementAssignments: USER_MANAGEMENT_ASSIGNMENTS,
        userTeamAssignments: USER_TEAM_ASSIGNMENTS
    };

    return (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, ActionTypes.USER_WORK_ASSIGNMENTS_ADD, function (state, _ref2) {
        var _ref2$payload = _ref2.payload,
            userId = _ref2$payload.userId,
            all = _ref2$payload.all,
            customers = _ref2$payload.customers,
            projects = _ref2$payload.projects,
            tasks = _ref2$payload.tasks;
        return _extends({}, state, {
            userWorkAssignments: _extends({}, state.userWorkAssignments, _defineProperty({}, userId, {
                all: all,
                customers: customers,
                projects: projects,
                tasks: tasks
            }))
        });
    }), _defineProperty(_handleActions, ActionTypes.USER_MANAGEMENT_ASSIGNMENTS_ADD, function (state, _ref3) {
        var _ref3$payload = _ref3.payload,
            userId = _ref3$payload.userId,
            all = _ref3$payload.all,
            customers = _ref3$payload.customers,
            projects = _ref3$payload.projects,
            tasks = _ref3$payload.tasks;
        return _extends({}, state, {
            userManagementAssignments: _extends({}, state.userManagementAssignments, _defineProperty({}, userId, {
                all: all,
                customers: customers,
                projects: projects,
                tasks: tasks
            }))
        });
    }), _defineProperty(_handleActions, ActionTypes.USER_TEAM_ASSIGNMENTS_ADD, function (state, _ref4) {
        var _ref4$payload = _ref4.payload,
            userId = _ref4$payload.userId,
            all = _ref4$payload.all,
            groupIds = _ref4$payload.groupIds;
        return _extends({}, state, {
            userTeamAssignments: _extends({}, state.userTeamAssignments, _defineProperty({}, userId, {
                all: all,
                groupIds: groupIds
            }))
        });
    }), _handleActions), initialState);
};

exports.default = createAssignmentsReducer;

/***/ }),
/* 1226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var USER_WORK_ASSIGNMENTS_ADD = exports.USER_WORK_ASSIGNMENTS_ADD = 'at/assignments/USER_WORK_ASSIGNMENTS_ADD';
var USER_MANAGEMENT_ASSIGNMENTS_ADD = exports.USER_MANAGEMENT_ASSIGNMENTS_ADD = 'at/assignments/USER_MANAGEMENT_ASSIGNMENTS_ADD';
var USER_TEAM_ASSIGNMENTS_ADD = exports.USER_TEAM_ASSIGNMENTS_ADD = 'at/assignments/USER_TEAM_ASSIGNMENTS_ADD';

/***/ }),
/* 1227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _redux = __webpack_require__(7);

var _reducer = __webpack_require__(1228);

var _reducer2 = _interopRequireDefault(_reducer);

var _reducer3 = __webpack_require__(1229);

var _reducer4 = _interopRequireDefault(_reducer3);

var _reducer5 = __webpack_require__(1230);

var _reducer6 = _interopRequireDefault(_reducer5);

var _reducer7 = __webpack_require__(1231);

var _reducer8 = _interopRequireDefault(_reducer7);

var _reducer9 = __webpack_require__(1232);

var _reducer10 = _interopRequireDefault(_reducer9);

var _reducer11 = __webpack_require__(1233);

var _reducer12 = _interopRequireDefault(_reducer11);

var _reducer13 = __webpack_require__(1234);

var _reducer14 = _interopRequireDefault(_reducer13);

var _reducer15 = __webpack_require__(1235);

var _reducer16 = _interopRequireDefault(_reducer15);

var _reducer17 = __webpack_require__(1237);

var _reducer18 = _interopRequireDefault(_reducer17);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createTaskManagementReducer = function createTaskManagementReducer(initAppData) {
    return (0, _redux.combineReducers)({
        common: (0, _reducer2.default)(initAppData),
        kanban: (0, _reducer4.default)(initAppData),
        taskTable: (0, _reducer6.default)(initAppData),
        taskSelection: _reducer8.default,
        columnConfiguratorMenu: (0, _reducer10.default)(initAppData),
        statusFilter: (0, _reducer16.default)(initAppData),
        cpPanel: (0, _reducer12.default)(initAppData),
        bulkOperationsPanel: _reducer14.default,
        exportCsvTaskList: _reducer18.default
    });
};

exports.default = createTaskManagementReducer;

/***/ }),
/* 1228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reduxActions = __webpack_require__(9);

var _actionTypes = __webpack_require__(449);

var ActionTypes = _interopRequireWildcard(_actionTypes);

var _actionTypes2 = __webpack_require__(102);

var EntitiesActionTypes = _interopRequireWildcard(_actionTypes2);

var _constants = __webpack_require__(44);

var _atUtils = __webpack_require__(5);

var _CustomerProjectSelection = __webpack_require__(156);

var _CustomerProjectSelection2 = _interopRequireDefault(_CustomerProjectSelection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var createReducer = function createReducer(_ref) {
    var _handleActions;

    var _ref$TASK_MANAGEMENT = _ref.TASK_MANAGEMENT,
        TASK_MANAGEMENT = _ref$TASK_MANAGEMENT === undefined ? {} : _ref$TASK_MANAGEMENT,
        _ref$CUSTOMERS = _ref.CUSTOMERS,
        CUSTOMERS = _ref$CUSTOMERS === undefined ? [] : _ref$CUSTOMERS,
        _ref$PROJECTS = _ref.PROJECTS,
        PROJECTS = _ref$PROJECTS === undefined ? [] : _ref$PROJECTS;

    var pageSettings = TASK_MANAGEMENT.PAGE_SETTINGS || {};

    var viewerSettings = TASK_MANAGEMENT.VIEWER_SETTINGS || {
        hasEditHierarchyRight: false,
        hasAccessToAllManagementScope: false,
        canAccessCompleteTaskInformation: false,
        noTeamAccess: false
    };

    var cpPanelClosed = TASK_MANAGEMENT.CP_PANEL_CLOSED || false;

    var cpSelectionDefaultState = {
        qualifier: _CustomerProjectSelection2.default.Qualifier.ALL,
        customers: [],
        projects: []
    };

    var taskStatusFilterDefaultState = {
        allSelected: false,
        statusIds: [],
        statusTypes: []
    };

    var singleCPSelectionDefaultState = {
        projectId: null,
        customerId: null
    };

    var singleCPSelection = TASK_MANAGEMENT.SINGLE_CP_SELECTION || singleCPSelectionDefaultState;

    var selectedCustomer = CUSTOMERS.find(function (customer) {
        return customer.id === singleCPSelection.customerId;
    });
    var selectedProject = PROJECTS.find(function (project) {
        return project.id === singleCPSelection.projectId;
    });
    var showActiveOnly = pageSettings.customersProjectsSelection && pageSettings.customersProjectsSelection.activeOnly;
    var selectedFilterKeys = pageSettings.selectedFilterKeys ? JSON.parse(pageSettings.selectedFilterKeys) : [_constants.TaskFieldFilterKey.STATUS];
    var customFieldsFilters = pageSettings.customFieldsFilters ? JSON.parse(pageSettings.customFieldsFilters) : {};

    if (showActiveOnly && (selectedCustomer && selectedCustomer.archived || selectedProject && selectedProject.archived)) {
        singleCPSelection = singleCPSelectionDefaultState;
    }

    var initialState = {
        viewMode: pageSettings.viewMode || _constants.TaskManagementViewMode.TABLE,

        filterCustomerProjectSelection: pageSettings.customersProjectsSelection || cpSelectionDefaultState,
        singleCustomerProjectSelection: _extends({
            customerId: null,
            projectId: null
        }, singleCPSelection),
        customerProjectNameFilter: '',
        taskStatusFilter: pageSettings.taskStatusFilter || taskStatusFilterDefaultState,
        customFieldsFilters: customFieldsFilters,
        taskNameFilter: '',
        selectedFilterKeys: selectedFilterKeys,
        lastCreatedTaskIds: {},
        recentlyCreatedTaskIds: {},
        viewerSettings: viewerSettings,
        managementAssignments: {
            customers: {},
            projects: {},
            tasks: {}
        },
        showOnlyManageableTasks: false,
        hasManageableTasks: false,
        cpPanelClosed: cpPanelClosed,
        bulkOperationsPanelShown: false,
        recentlyCreatedCustomerIds: [],
        recentlyCreatedProjectIds: [],
        isNextWorkflowStatusesLoaded: false,
        showLoadingMoire: false,

        taskCustomFields: []
    };

    return (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, ActionTypes.SHOW_ONLY_MANAGEABLE_TASKS_SET, function (state, _ref2) {
        var showOnlyManageableTasks = _ref2.payload;
        return _extends({}, state, {
            showOnlyManageableTasks: showOnlyManageableTasks
        });
    }), _defineProperty(_handleActions, ActionTypes.VIEW_MODE_SET, function (state, _ref3) {
        var viewMode = _ref3.payload;
        return _extends({}, state, {
            viewMode: viewMode
        });
    }), _defineProperty(_handleActions, ActionTypes.SINGLE_CP_SELECTION_CHANGE, function (state, _ref4) {
        var selection = _ref4.payload;
        return _extends({}, state, {
            singleCustomerProjectSelection: selection
        });
    }), _defineProperty(_handleActions, ActionTypes.FILTER_CP_SELECTION_CHANGE, function (state, _ref5) {
        var selection = _ref5.payload;
        return _extends({}, state, {
            filterCustomerProjectSelection: selection
        });
    }), _defineProperty(_handleActions, ActionTypes.CP_NAME_FILTER_SET, function (state, _ref6) {
        var customerProjectNameFilter = _ref6.payload;
        return _extends({}, state, {
            customerProjectNameFilter: customerProjectNameFilter
        });
    }), _defineProperty(_handleActions, ActionTypes.TASK_STATUS_FILTER_CHANGE, function (state, _ref7) {
        var taskStatusFilter = _ref7.payload;
        return _extends({}, state, {
            taskStatusFilter: taskStatusFilter
        });
    }), _defineProperty(_handleActions, ActionTypes.SELECTED_FILTER_KEYS_SET, function (state, _ref8) {
        var selectedFilterKeys = _ref8.payload;
        return _extends({}, state, {
            selectedFilterKeys: selectedFilterKeys
        });
    }), _defineProperty(_handleActions, ActionTypes.CUSTOM_FIELDS_FILTERS_SET, function (state, _ref9) {
        var customFieldsFilters = _ref9.payload;
        return _extends({}, state, {
            customFieldsFilters: customFieldsFilters
        });
    }), _defineProperty(_handleActions, ActionTypes.TASK_NAME_FILTER_CHANGE, function (state, _ref10) {
        var taskNameFilter = _ref10.payload;
        return _extends({}, state, {
            taskNameFilter: taskNameFilter
        });
    }), _defineProperty(_handleActions, ActionTypes.RECENTLY_CREATED_TASKS_ADD, function (state, _ref11) {
        var taskIds = _ref11.payload;
        return _extends({}, state, {
            recentlyCreatedTaskIds: _extends({}, state.recentlyCreatedTaskIds, (0, _atUtils.arrayToSet)(taskIds))
        });
    }), _defineProperty(_handleActions, ActionTypes.LAST_CREATED_TASK_IDS_SET, function (state, _ref12) {
        var lastCreatedTaskIds = _ref12.payload;
        return _extends({}, state, {
            lastCreatedTaskIds: _extends({}, state.lastCreatedTaskIds, (0, _atUtils.arrayToSet)(lastCreatedTaskIds))
        });
    }), _defineProperty(_handleActions, ActionTypes.LAST_CREATED_TASK_IDS_REMOVE, function (state, _ref13) {
        var lastCreatedTaskId = _ref13.payload;
        return _extends({}, state, {
            lastCreatedTaskIds: (0, _atUtils.filterMapByKey)(state.lastCreatedTaskIds, lastCreatedTaskId)
        });
    }), _defineProperty(_handleActions, ActionTypes.VIEWER_SETTINGS_SET, function (state, _ref14) {
        var viewerSettings = _ref14.payload;
        return _extends({}, state, {
            viewerSettings: viewerSettings
        });
    }), _defineProperty(_handleActions, ActionTypes.MANAGEMENT_ASSIGNMENTS_SET, function (state, _ref15) {
        var managementAssignments = _ref15.payload;
        return _extends({}, state, {
            managementAssignments: managementAssignments
        });
    }), _defineProperty(_handleActions, ActionTypes.HAS_MANAGEABLE_TASKS_SET, function (state, _ref16) {
        var hasManageableTasks = _ref16.payload;
        return _extends({}, state, {
            hasManageableTasks: hasManageableTasks
        });
    }), _defineProperty(_handleActions, EntitiesActionTypes.TASKS_REMOVE, function (state, _ref17) {
        var taskIds = _ref17.payload;

        return _extends({}, state, {
            recentlyCreatedTaskIds: (0, _atUtils.filterMapByKeys)(state.recentlyCreatedTaskIds, taskIds)
        });
    }), _defineProperty(_handleActions, EntitiesActionTypes.TASKS_CLEAR, function (state) {
        return _extends({}, state, {
            recentlyCreatedTaskIds: {}
        });
    }), _defineProperty(_handleActions, ActionTypes.CP_PANEL_CLOSED_STATE_CHANGE, function (state, _ref18) {
        var panelClosed = _ref18.payload;
        return _extends({}, state, {
            cpPanelClosed: panelClosed
        });
    }), _defineProperty(_handleActions, ActionTypes.BULK_OPERATIONS_PANEL_SHOWN_SET, function (state, _ref19) {
        var showed = _ref19.payload;

        return _extends({}, state, {
            bulkOperationsPanelShown: showed
        });
    }), _defineProperty(_handleActions, ActionTypes.RECENTLY_CREATED_CUSTOMER_IDS_SET, function (state, _ref20) {
        var recentlyCreatedCustomerIds = _ref20.payload;
        return _extends({}, state, {
            recentlyCreatedCustomerIds: recentlyCreatedCustomerIds
        });
    }), _defineProperty(_handleActions, ActionTypes.RECENTLY_CREATED_PROJECT_IDS_SET, function (state, _ref21) {
        var recentlyCreatedProjectIds = _ref21.payload;
        return _extends({}, state, {
            recentlyCreatedProjectIds: recentlyCreatedProjectIds
        });
    }), _defineProperty(_handleActions, ActionTypes.RECENTLY_CREATED_CUSTOMERS_PROJECTS_CLEAR, function (state) {
        return _extends({}, state, {
            recentlyCreatedCustomerIds: [],
            recentlyCreatedProjectIds: []
        });
    }), _defineProperty(_handleActions, ActionTypes.TOGGLE_LOADING_MOIRE, function (state, _ref22) {
        var show = _ref22.payload;
        return _extends({}, state, {
            showLoadingMoire: show
        });
    }), _defineProperty(_handleActions, ActionTypes.TASK_CUSTOM_FIELDS_SET, function (state, _ref23) {
        var taskCustomFields = _ref23.payload;
        return _extends({}, state, {
            taskCustomFields: taskCustomFields
        });
    }), _defineProperty(_handleActions, ActionTypes.NEXT_WORKFLOW_STATUSES_SET, function (state) {
        return _extends({}, state, {
            isNextWorkflowStatusesLoaded: true
        });
    }), _handleActions), initialState);
};

exports.default = createReducer;

/***/ }),
/* 1229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _reduxActions = __webpack_require__(9);

var _actionTypes = __webpack_require__(666);

var ActionTypes = _interopRequireWildcard(_actionTypes);

var _atUtils = __webpack_require__(5);

var _actionTypes2 = __webpack_require__(102);

var EntitiesActionTypes = _interopRequireWildcard(_actionTypes2);

var _actionTypes3 = __webpack_require__(667);

var TaskEntitiesActionTypes = _interopRequireWildcard(_actionTypes3);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var createReducer = function createReducer(_ref) {
    var _handleActions;

    var _ref$TASK_MANAGEMENT = _ref.TASK_MANAGEMENT,
        TASK_MANAGEMENT = _ref$TASK_MANAGEMENT === undefined ? {} : _ref$TASK_MANAGEMENT;

    var pageSettings = TASK_MANAGEMENT.PAGE_SETTINGS || {};
    var collapsedProjectsState = TASK_MANAGEMENT.KANBAN_COLLAPSED_PROJECTS_STATE || {};

    var initialState = {
        workflowStatusIds: [],
        taskCountsByWorkflowStatus: {},
        projectIds: [],
        loadingInitialData: false,
        loadingProjectId: null,
        projectLoadingPositions: {},
        projectIdsContainingTasks: {},
        taskIdsOrder: [],
        updatingTaskIds: {},
        isLoaded: false,
        minimizedCards: pageSettings.kanbanCardsMinimized || false,
        loadedTasksNameFilter: '',
        collapsedProjects: _extends({
            all: false,
            ids: []
        }, collapsedProjectsState),
        needToLoadCounters: false
    };

    return (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, ActionTypes.INITIAL_DATA_SET, function (state, _ref2) {
        var _ref2$payload = _ref2.payload,
            workflowStatusIds = _ref2$payload.workflowStatusIds,
            taskCountsByWorkflowStatus = _ref2$payload.taskCountsByWorkflowStatus,
            projectIds = _ref2$payload.projectIds;
        return _extends({}, state, {
            projectLoadingPositions: {},
            workflowStatusIds: workflowStatusIds,
            taskCountsByWorkflowStatus: taskCountsByWorkflowStatus,
            projectIds: projectIds,
            needToLoadCounters: false
        });
    }), _defineProperty(_handleActions, ActionTypes.COLLAPSED_PROJECTS_CHANGE, function (state, _ref3) {
        var collapsedProjects = _ref3.payload;
        return _extends({}, state, {
            collapsedProjects: collapsedProjects
        });
    }), _defineProperty(_handleActions, ActionTypes.PROJECTS_IDS_CONTAINING_TASK_ADD, function (state, _ref4) {
        var projectIdsContainingTasks = _ref4.payload;
        return _extends({}, state, {
            projectIdsContainingTasks: (0, _atUtils.arrayToSet)(projectIdsContainingTasks)
        });
    }), _defineProperty(_handleActions, ActionTypes.LOADING_INITIAL_DATA_SET, function (state, _ref5) {
        var loadingInitialData = _ref5.payload;
        return _extends({}, state, { loadingInitialData: loadingInitialData });
    }), _defineProperty(_handleActions, ActionTypes.LOADING_PROJECT_ID_SET, function (state, _ref6) {
        var loadingProjectId = _ref6.payload;
        return _extends({}, state, { loadingProjectId: loadingProjectId });
    }), _defineProperty(_handleActions, ActionTypes.IS_LOADED_SET, function (state, _ref7) {
        var isLoaded = _ref7.payload;
        return _extends({}, state, { isLoaded: isLoaded });
    }), _defineProperty(_handleActions, ActionTypes.PROJECT_LOADING_POSITION_SET, function (state, _ref8) {
        var _ref8$payload = _ref8.payload,
            id = _ref8$payload.id,
            count = _ref8$payload.count,
            fullyLoaded = _ref8$payload.fullyLoaded;

        return _extends({}, state, {
            projectLoadingPositions: _extends({}, state.projectLoadingPositions, _defineProperty({}, id, {
                count: count,
                fullyLoaded: fullyLoaded
            }))
        });
    }), _defineProperty(_handleActions, ActionTypes.PROJECT_LOADING_POSITIONS_RESET, function (state, _ref9) {
        var projectIds = _ref9.payload;
        return _extends({}, state, {
            projectLoadingPositions: (0, _atUtils.filterMapByKeys)(state.projectLoadingPositions, projectIds)
        });
    }), _defineProperty(_handleActions, ActionTypes.MINIMIZED_CARDS_SET, function (state, _ref10) {
        var minimizedCards = _ref10.payload;
        return _extends({}, state, {
            minimizedCards: minimizedCards
        });
    }), _defineProperty(_handleActions, ActionTypes.TASKS_COUNT_BY_WORKFLOW_STATUS_SET, function (state, _ref11) {
        var taskCountsByWorkflowStatus = _ref11.payload;

        return _extends({}, state, {
            taskCountsByWorkflowStatus: taskCountsByWorkflowStatus
        });
    }), _defineProperty(_handleActions, ActionTypes.TASKS_ORDER_ADD, function (state, _ref12) {
        var taskIdsOrder = _ref12.payload;
        return _extends({}, state, {
            taskIdsOrder: _underscore2.default.union(state.taskIdsOrder, taskIdsOrder)
        });
    }), _defineProperty(_handleActions, ActionTypes.TASKS_ORDER_PREPEND, function (state, _ref13) {
        var taskIdsOrder = _ref13.payload;
        return _extends({}, state, {
            taskIdsOrder: _underscore2.default.union(taskIdsOrder, state.taskIdsOrder)
        });
    }), _defineProperty(_handleActions, ActionTypes.TASKS_ORDER_SET, function (state, _ref14) {
        var taskIdsOrder = _ref14.payload;
        return _extends({}, state, {
            taskIdsOrder: taskIdsOrder
        });
    }), _defineProperty(_handleActions, EntitiesActionTypes.TASKS_REMOVE, function (state, _ref15) {
        var taskIds = _ref15.payload;

        var taskIdsSet = (0, _atUtils.arrayToSet)(taskIds);
        return _extends({}, state, {
            taskIdsOrder: state.taskIdsOrder.filter(function (id) {
                return !taskIdsSet[id];
            }),
            needToLoadCounters: true
        });
    }), _defineProperty(_handleActions, ActionTypes.UPDATING_TASK_ADD, function (state, _ref16) {
        var taskId = _ref16.payload;
        return _extends({}, state, {
            updatingTaskIds: _extends({}, state.updatingTaskIds, _defineProperty({}, taskId, true))
        });
    }), _defineProperty(_handleActions, ActionTypes.UPDATING_TASK_REMOVE, function (state, _ref17) {
        var taskId = _ref17.payload;
        return _extends({}, state, {
            updatingTaskIds: (0, _atUtils.filterMapByKey)(state.updatingTaskIds, taskId)
        });
    }), _defineProperty(_handleActions, ActionTypes.LOADED_TASKS_NAME_FILTER_SET, function (state, _ref18) {
        var loadedTasksNameFilter = _ref18.payload;
        return _extends({}, state, {
            loadedTasksNameFilter: loadedTasksNameFilter
        });
    }), _defineProperty(_handleActions, ActionTypes.NEED_TO_LOAD_COUNTERS_SET, function (state, _ref19) {
        var needToLoadCounters = _ref19.payload;
        return _extends({}, state, {
            needToLoadCounters: needToLoadCounters
        });
    }), _defineProperty(_handleActions, EntitiesActionTypes.PROJECTS_REMOVE, function (state, _ref20) {
        var projectIds = _ref20.payload;

        var projectIdsSet = (0, _atUtils.arrayToSet)(projectIds);
        return _extends({}, state, {
            projectIds: state.projectIds.filter(function (id) {
                return !projectIdsSet[id];
            })
        });
    }), _defineProperty(_handleActions, TaskEntitiesActionTypes.WORKFLOW_STATUS_CHANGED, function (state, _ref21) {
        var _ref21$payload = _ref21.payload,
            taskId = _ref21$payload.taskId,
            workflowStatusId = _ref21$payload.workflowStatusId,
            prevWorkflowStatusId = _ref21$payload.prevWorkflowStatusId;

        var tasksCountByWorkflowStatuses = state.taskCountsByWorkflowStatus;
        var counters = _extends({}, tasksCountByWorkflowStatuses);

        if (counters[prevWorkflowStatusId] !== undefined) counters[prevWorkflowStatusId] = tasksCountByWorkflowStatuses[prevWorkflowStatusId] - 1;

        if (counters[workflowStatusId] !== undefined) counters[workflowStatusId] = tasksCountByWorkflowStatuses[workflowStatusId] + 1;

        return _extends({}, state, {
            taskCountsByWorkflowStatus: counters
        });
    }), _handleActions), initialState);
};

exports.default = createReducer;

/***/ }),
/* 1230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _reduxActions = __webpack_require__(9);

var _actionTypes = __webpack_require__(668);

var ActionTypes = _interopRequireWildcard(_actionTypes);

var _actionTypes2 = __webpack_require__(102);

var EntitiesActionTypes = _interopRequireWildcard(_actionTypes2);

var _constants = __webpack_require__(44);

var _atUtils = __webpack_require__(5);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var checkDefaultsForVarianceColumnsAndProcess = function checkDefaultsForVarianceColumnsAndProcess(order, shown) {
    var newOrder = [].concat(_toConsumableArray(order));
    var newShown = [].concat(_toConsumableArray(shown));

    var shouldProcess = !newOrder.includes(_constants.TaskSortBy.VARIANCE_MAN_HOURS);
    if (shouldProcess) {
        var shouldProcessShown = newShown.includes(_constants.TaskSortBy.ESTIMATE) && !newShown.includes(_constants.TaskSortBy.VARIANCE_MAN_HOURS);
        if (shouldProcessShown) {
            newShown = [].concat(_toConsumableArray(newShown), [_constants.TaskSortBy.VARIANCE_MAN_HOURS]);
        }

        var estimateIndex = newOrder.indexOf(_constants.TaskSortBy.ESTIMATE);
        var shouldProcessOrder = estimateIndex >= 0;
        if (shouldProcessOrder) {
            var indexToInsert = estimateIndex + 1;
            newOrder = [].concat(_toConsumableArray(newOrder.slice(0, indexToInsert)), [_constants.TaskSortBy.VARIANCE_MAN_HOURS, _constants.TaskSortBy.VARIANCE_PERCENTS, _constants.TaskSortBy.VARIANCE_PROGRESS_BAR], _toConsumableArray(newOrder.slice(indexToInsert)));
        }
    }

    return [newOrder, newShown];
};

var checkDeafultsForIsSummaryRowShownAndProcess = function checkDeafultsForIsSummaryRowShownAndProcess(isSummaryRowShown) {
    if (isSummaryRowShown === undefined) return true;
    return isSummaryRowShown;
};

var createReducer = function createReducer(_ref) {
    var _handleActions;

    var _ref$TASK_MANAGEMENT = _ref.TASK_MANAGEMENT,
        TASK_MANAGEMENT = _ref$TASK_MANAGEMENT === undefined ? {} : _ref$TASK_MANAGEMENT;

    var pageSettings = TASK_MANAGEMENT.PAGE_SETTINGS || {};

    var columnsOrder = pageSettings.columnsOrder ? JSON.parse(pageSettings.columnsOrder) : [];
    var columnsShown = pageSettings.columnsDisplay ? JSON.parse(pageSettings.columnsDisplay) : [];

    var _checkDefaultsForVari = checkDefaultsForVarianceColumnsAndProcess(columnsOrder, columnsShown),
        _checkDefaultsForVari2 = _slicedToArray(_checkDefaultsForVari, 2),
        newColumnsOrder = _checkDefaultsForVari2[0],
        newColumnsShown = _checkDefaultsForVari2[1];

    var isSummaryRowShown = checkDeafultsForIsSummaryRowShownAndProcess(pageSettings.summaryRowShown);

    var initialState = {
        sorting: {
            by: pageSettings.sortBy || _constants.TaskSortBy.TASK,
            asc: pageSettings.ascSort || false
        },
        isLoaded: false,
        columnsOrder: newColumnsOrder,
        columnsShown: newColumnsShown,
        isSummaryRowShown: isSummaryRowShown,
        summaryRow: {},

        loadedTaskIds: []
    };

    return (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, ActionTypes.TASKS_SORTING_CHANGE, function (state, _ref2) {
        var sorting = _ref2.payload;
        return _extends({}, state, {
            sorting: sorting
        });
    }), _defineProperty(_handleActions, ActionTypes.COLUMNS_ORDER_SET, function (state, _ref3) {
        var columnsOrder = _ref3.payload;
        return _extends({}, state, {
            columnsOrder: columnsOrder
        });
    }), _defineProperty(_handleActions, ActionTypes.COLUMNS_SHOWN_SET, function (state, _ref4) {
        var columnsShown = _ref4.payload;
        return _extends({}, state, {
            columnsShown: columnsShown
        });
    }), _defineProperty(_handleActions, ActionTypes.IS_SUMMARY_ROW_SHOWN_SET, function (state, _ref5) {
        var isSummaryRowShown = _ref5.payload;
        return _extends({}, state, {
            isSummaryRowShown: isSummaryRowShown
        });
    }), _defineProperty(_handleActions, ActionTypes.IS_LOADED_SET, function (state, _ref6) {
        var isLoaded = _ref6.payload;
        return _extends({}, state, {
            isLoaded: isLoaded
        });
    }), _defineProperty(_handleActions, ActionTypes.SUMMARY_ROW_SET, function (state, _ref7) {
        var summaryRow = _ref7.payload;
        return _extends({}, state, {
            summaryRow: summaryRow
        });
    }), _defineProperty(_handleActions, ActionTypes.IS_SUMMARY_ROW_LOADED_SET, function (state, _ref8) {
        var isLoaded = _ref8.payload;
        return _extends({}, state, {
            isSummaryRowLoaded: isLoaded
        });
    }), _defineProperty(_handleActions, ActionTypes.LOADED_TASK_IDS_SET, function (state, _ref9) {
        var loadedTaskIds = _ref9.payload;
        return _extends({}, state, {
            loadedTaskIds: loadedTaskIds
        });
    }), _defineProperty(_handleActions, ActionTypes.LOADED_TASK_IDS_ADD, function (state, _ref10) {
        var ids = _ref10.payload;
        return _extends({}, state, {
            loadedTaskIds: state.loadedTaskIds.concat(ids)
        });
    }), _defineProperty(_handleActions, ActionTypes.LOADED_TASK_IDS_PREPEND, function (state, _ref11) {
        var ids = _ref11.payload;
        return _extends({}, state, {
            loadedTaskIds: ids.concat(state.loadedTaskIds)
        });
    }), _defineProperty(_handleActions, EntitiesActionTypes.TASKS_REMOVE, function (state, _ref12) {
        var ids = _ref12.payload;

        var taskIdsSet = (0, _atUtils.arrayToSet)(ids);
        return _extends({}, state, {
            loadedTaskIds: state.loadedTaskIds.filter(function (id) {
                return !taskIdsSet[id];
            })
        });
    }), _handleActions), initialState);
};

exports.default = createReducer;

/***/ }),
/* 1231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _handleActions;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reduxActions = __webpack_require__(9);

var _actionTypes = __webpack_require__(669);

var ActionTypes = _interopRequireWildcard(_actionTypes);

var _actionTypes2 = __webpack_require__(102);

var EntitiesActionTypes = _interopRequireWildcard(_actionTypes2);

var _atUtils = __webpack_require__(5);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = {
    existingTaskIdsByFilters: {},
    existingTaskIdsLoading: false,
    existingTaskIdsLoaded: false,
    selectedTaskIds: {},
    pendingSelectAll: false
};

exports.default = (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, ActionTypes.SELECTED_TASK_IDS_CHANGE, function (state, _ref) {
    var selectedTaskIds = _ref.payload;
    return _extends({}, state, {
        selectedTaskIds: selectedTaskIds
    });
}), _defineProperty(_handleActions, ActionTypes.LOAD_EXISTING_TASK_IDS, function (state) {
    return _extends({}, state, {
        existingTaskIdsLoading: true
    });
}), _defineProperty(_handleActions, ActionTypes.LOAD_EXISTING_TASK_IDS_SUCCESS, function (state, _ref2) {
    var ids = _ref2.payload;
    return _extends({}, state, {
        existingTaskIdsByFilters: ids,
        existingTaskIdsLoading: false,
        existingTaskIdsLoaded: true
    });
}), _defineProperty(_handleActions, ActionTypes.LOAD_EXISTING_TASK_IDS_FAILURE, function (state) {
    return _extends({}, state, {
        existingTaskIdsLoading: false
    });
}), _defineProperty(_handleActions, ActionTypes.PENDING_SELECT_ALL_SET, function (state, _ref3) {
    var preselectedIds = _ref3.payload;
    return _extends({}, state, {
        pendingSelectAll: true,
        selectedTaskIds: preselectedIds
    });
}), _defineProperty(_handleActions, ActionTypes.PENDING_SELECT_ALL_RESET, function (state) {
    return _extends({}, state, {
        pendingSelectAll: false
    });
}), _defineProperty(_handleActions, ActionTypes.EXISTING_TASK_IDS_BY_FILTERS_SET, function (state, _ref4) {
    var ids = _ref4.payload;
    return _extends({}, state, {
        existingTaskIdsByFilters: ids
    });
}), _defineProperty(_handleActions, ActionTypes.EXISTING_TASK_IDS_LOADED_RESET, function (state) {
    return _extends({}, state, {
        existingTaskIdsLoaded: false,
        existingTaskIdsLoading: false
    });
}), _defineProperty(_handleActions, EntitiesActionTypes.TASKS_REMOVE, function (state, _ref5) {
    var ids = _ref5.payload;

    return _extends({}, state, {
        existingTaskIdsByFilters: (0, _atUtils.filterMapByKeys)(state.existingTaskIdsByFilters, ids),
        selectedTaskIds: (0, _atUtils.filterMapByKeys)(state.selectedTaskIds, ids)
    });
}), _handleActions), initialState);

/***/ }),
/* 1232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reduxActions = __webpack_require__(9);

var _actionTypes = __webpack_require__(670);

var ActionTypes = _interopRequireWildcard(_actionTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var createReducer = function createReducer() {
    var _handleActions;

    var initialState = {
        columnsOrder: [],
        columnsSelected: {},
        isSummaryRowShown: false
    };

    return (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, ActionTypes.ORDER_SET, function (state, _ref) {
        var columnsOrder = _ref.payload;
        return _extends({}, state, {
            columnsOrder: columnsOrder
        });
    }), _defineProperty(_handleActions, ActionTypes.SELECTED_SET, function (state, _ref2) {
        var columnsShown = _ref2.payload;
        return _extends({}, state, {
            columnsSelected: columnsShown
        });
    }), _defineProperty(_handleActions, ActionTypes.IS_SUMMARY_ROW_SHOWN_SET, function (state, _ref3) {
        var isSummaryRowShown = _ref3.payload;
        return _extends({}, state, {
            isSummaryRowShown: isSummaryRowShown
        });
    }), _handleActions), initialState);
};

exports.default = createReducer;

/***/ }),
/* 1233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reduxActions = __webpack_require__(9);

var _actionTypes = __webpack_require__(671);

var ActionTypes = _interopRequireWildcard(_actionTypes);

var _constants = __webpack_require__(344);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var createReducer = function createReducer(_ref) {
    var _handleActions;

    var _ref$TASK_MANAGEMENT = _ref.TASK_MANAGEMENT,
        TASK_MANAGEMENT = _ref$TASK_MANAGEMENT === undefined ? {} : _ref$TASK_MANAGEMENT;


    var cpPanelWidth = TASK_MANAGEMENT.CP_PANEL_WIDTH || _constants.CP_PANEL_INITIAL_WIDTH;

    var collapsedCustomersSet = TASK_MANAGEMENT.CP_PANEL_COLLAPSED_CUSTOMERS || {};

    var initialState = {
        resizableMaxWidth: 0,
        width: cpPanelWidth,
        collapsedCustomersSet: collapsedCustomersSet,
        isCustomersAsc: true,
        visibleCustomerIds: [],
        visibleProjectIds: []
    };

    return (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, ActionTypes.CP_PANEL_MAX_WIDTH_CHANGE, function (state, _ref2) {
        var maxWidth = _ref2.payload;
        return _extends({}, state, {
            resizableMaxWidth: maxWidth
        });
    }), _defineProperty(_handleActions, ActionTypes.CP_PANEL_WIDTH_CHANGE, function (state, _ref3) {
        var width = _ref3.payload;
        return _extends({}, state, {
            width: width
        });
    }), _defineProperty(_handleActions, ActionTypes.CP_PANEL_COLLAPSED_CUSTOMERS_SET_CHANGE, function (state, _ref4) {
        var collapsedCustomers = _ref4.payload;
        return _extends({}, state, {
            collapsedCustomersSet: collapsedCustomers
        });
    }), _defineProperty(_handleActions, ActionTypes.CP_PANEL_VISIBLE_CUSTOMER_IDS_CHANGE, function (state, _ref5) {
        var visibleCustomerIds = _ref5.payload;
        return _extends({}, state, {
            visibleCustomerIds: visibleCustomerIds
        });
    }), _defineProperty(_handleActions, ActionTypes.CP_PANEL_VISIBLE_PROJECT_IDS_CHANGE, function (state, _ref6) {
        var visibleProjectIds = _ref6.payload;
        return _extends({}, state, {
            visibleProjectIds: visibleProjectIds
        });
    }), _defineProperty(_handleActions, ActionTypes.CP_PANEL_IS_CUSTOMERS_ASC_CHANGE, function (state, _ref7) {
        var isCustomersAsc = _ref7.payload;
        return _extends({}, state, {
            isCustomersAsc: isCustomersAsc
        });
    }), _handleActions), initialState);
};

exports.default = createReducer;

/***/ }),
/* 1234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _handleActions;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reduxActions = __webpack_require__(9);

var _actionTypes = __webpack_require__(672);

var ActionTypes = _interopRequireWildcard(_actionTypes);

var _constants = __webpack_require__(452);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initState = {
    operationProcessing: false,
    operationProgress: null,
    currentOperation: null,
    deleteDialogData: {
        loading: false,
        taskIds: [],
        entitiesBlockedCount: [],
        entitiesBlocked: []
    },
    assignToDialogData: {
        loading: false,
        numberOfTasks: 0,
        canModifyAny: true,
        timeZoneGroups: [],
        timeZoneGroupsEnabled: false,
        userGroups: [],
        userGroupsEnabled: false,
        users: [],
        selectedUserIds: [],
        userRatesEnabled: false,
        billingTypesEnabled: false
    },
    changeStatusDialogData: {
        loading: false,
        taskIds: []
    },
    moveDialogData: {
        loading: false,
        taskIds: [],
        notAvailableToMoveTasks: [],
        includeOpenTasks: true
    }
};

exports.default = (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, ActionTypes.START_BULK_TASKS_DELETE_OPERATION, function (state) {
    return _extends({}, state, {
        currentOperation: _constants.BulkOperationType.DELETE
    });
}), _defineProperty(_handleActions, ActionTypes.LOAD_BULK_DELETE_DIALOG_DATA, function (state) {
    return _extends({}, state, {
        deleteDialogData: _extends({}, state.deleteDialogData, {
            loading: true
        })
    });
}), _defineProperty(_handleActions, ActionTypes.LOAD_BULK_DELETE_DIALOG_DATA_SUCCESS, function (state, _ref) {
    var data = _ref.payload;
    return _extends({}, state, {
        deleteDialogData: _extends({}, state.deleteDialogData, data, {
            loading: false
        })
    });
}), _defineProperty(_handleActions, ActionTypes.LOAD_BULK_DELETE_DIALOG_DATA_FAILURE, function (state) {
    return _extends({}, state, {
        deleteDialogData: _extends({}, state.deleteDialogData, {
            loading: false
        })
    });
}), _defineProperty(_handleActions, ActionTypes.BULK_TASKS_DELETE, function (state) {
    return _extends({}, state, {
        operationProcessing: true,
        operationProgress: 0
    });
}), _defineProperty(_handleActions, ActionTypes.BULK_TASKS_DELETE_SUCCESS, function (state) {
    return _extends({}, state, {
        operationProcessing: false,
        currentOperation: null,
        operationProgress: null
    });
}), _defineProperty(_handleActions, ActionTypes.BULK_TASKS_DELETE_FAILURE, function (state) {
    return _extends({}, state, {
        operationProcessing: false,
        operationProgress: null
    });
}), _defineProperty(_handleActions, ActionTypes.START_BULK_ASSIGN_TASKS_OPERATION, function (state) {
    return _extends({}, state, {
        currentOperation: _constants.BulkOperationType.CHANGE_ASSIGNMENTS
    });
}), _defineProperty(_handleActions, ActionTypes.LOAD_BULK_ASSIGN_DIALOG_DATA, function (state) {
    return _extends({}, state, {
        assignToDialogData: _extends({}, state.assignToDialogData, {
            loading: true
        })
    });
}), _defineProperty(_handleActions, ActionTypes.LOAD_BULK_ASSIGN_DIALOG_DATA_SUCCESS, function (state, _ref2) {
    var data = _ref2.payload;
    return _extends({}, state, {
        assignToDialogData: _extends({}, state.assignToDialogData, data, {
            loading: false
        })
    });
}), _defineProperty(_handleActions, ActionTypes.LOAD_BULK_ASSIGN_DIALOG_DATA_FAILURE, function (state) {
    return _extends({}, state, {
        assignToDialogData: _extends({}, state.assignToDialogData, {
            loading: false
        })
    });
}), _defineProperty(_handleActions, ActionTypes.BULK_ASSIGN_DIALOG_SELECTION_SET, function (state, _ref3) {
    var selectedUserIds = _ref3.payload;
    return _extends({}, state, {
        assignToDialogData: _extends({}, state.assignToDialogData, {
            selectedUserIds: selectedUserIds,
            loading: false
        })
    });
}), _defineProperty(_handleActions, ActionTypes.BULK_ASSIGN_TASKS, function (state) {
    return _extends({}, state, {
        operationProcessing: true,
        operationProgress: 0
    });
}), _defineProperty(_handleActions, ActionTypes.BULK_ASSIGN_TASKS_SUCCESS, function (state) {
    return _extends({}, state, {
        operationProcessing: false,
        currentOperation: null,
        operationProgress: null
    });
}), _defineProperty(_handleActions, ActionTypes.BULK_ASSIGN_TASKS_FAILURE, function (state) {
    return _extends({}, state, {
        operationProcessing: false,
        operationProgress: null
    });
}), _defineProperty(_handleActions, ActionTypes.START_BULK_CHANGE_TASKS_STATUS_OPERATION, function (state) {
    return _extends({}, state, {
        currentOperation: _constants.BulkOperationType.CHANGE_STATUS
    });
}), _defineProperty(_handleActions, ActionTypes.LOAD_BULK_CHANGE_STATUS_DIALOG_DATA, function (state) {
    return _extends({}, state, {
        changeStatusDialogData: _extends({}, state.changeStatusDialogData, {
            loading: true
        })
    });
}), _defineProperty(_handleActions, ActionTypes.LOAD_BULK_CHANGE_STATUS_DIALOG_DATA_SUCCESS, function (state, _ref4) {
    var data = _ref4.payload;
    return _extends({}, state, {
        changeStatusDialogData: _extends({}, state.changeStatusDialogData, data, {
            loading: false
        })
    });
}), _defineProperty(_handleActions, ActionTypes.LOAD_BULK_CHANGE_STATUS_DIALOG_DATA_FAILURE, function (state) {
    return _extends({}, state, {
        changeStatusDialogData: _extends({}, state.changeStatusDialogData, {
            loading: false
        })
    });
}), _defineProperty(_handleActions, ActionTypes.BULK_CHANGE_TASKS_STATUS, function (state) {
    return _extends({}, state, {
        operationProcessing: true,
        operationProgress: 0
    });
}), _defineProperty(_handleActions, ActionTypes.BULK_CHANGE_TASKS_STATUS_SUCCESS, function (state) {
    return _extends({}, state, {
        operationProcessing: false,
        currentOperation: null,
        operationProgress: null
    });
}), _defineProperty(_handleActions, ActionTypes.BULK_CHANGE_TASKS_STATUS_FAILURE, function (state) {
    return _extends({}, state, {
        operationProcessing: false,
        operationProgress: null
    });
}), _defineProperty(_handleActions, ActionTypes.START_BULK_MOVE_OPERATION, function (state) {
    return _extends({}, state, {
        currentOperation: _constants.BulkOperationType.MOVE
    });
}), _defineProperty(_handleActions, ActionTypes.LOAD_BULK_MOVE_DIALOG_DATA, function (state) {
    return _extends({}, state, {
        moveDialogData: _extends({}, state.moveDialogData, {
            loading: true
        })
    });
}), _defineProperty(_handleActions, ActionTypes.LOAD_BULK_MOVE_DIALOG_DATA_SUCCESS, function (state, _ref5) {
    var data = _ref5.payload;
    return _extends({}, state, {
        moveDialogData: _extends({}, state.moveDialogData, data, {
            loading: false
        })
    });
}), _defineProperty(_handleActions, ActionTypes.LOAD_BULK_MOVE_DIALOG_DATA_FAILURE, function (state) {
    return _extends({}, state, {
        moveDialogData: _extends({}, state.moveDialogData, {
            loading: false
        })
    });
}), _defineProperty(_handleActions, ActionTypes.BULK_TASKS_MOVE, function (state) {
    return _extends({}, state, {
        operationProcessing: true,
        operationProgress: 0
    });
}), _defineProperty(_handleActions, ActionTypes.BULK_TASKS_MOVE_SUCCESS, function (state) {
    return _extends({}, state, {
        operationProcessing: false,
        currentOperation: null,
        operationProgress: null
    });
}), _defineProperty(_handleActions, ActionTypes.BULK_TASKS_MOVE_FAILURE, function (state) {
    return _extends({}, state, {
        operationProcessing: false,
        operationProgress: null
    });
}), _defineProperty(_handleActions, ActionTypes.START_BULK_COPY_OPERATION, function (state) {
    return _extends({}, state, {
        currentOperation: _constants.BulkOperationType.COPY
    });
}), _defineProperty(_handleActions, ActionTypes.BULK_TASKS_COPY, function (state) {
    return _extends({}, state, {
        operationProcessing: true,
        operationProgress: 0
    });
}), _defineProperty(_handleActions, ActionTypes.BULK_TASKS_COPY_SUCCESS, function (state) {
    return _extends({}, state, {
        operationProcessing: false,
        currentOperation: null,
        operationProgress: null
    });
}), _defineProperty(_handleActions, ActionTypes.BULK_TASKS_COPY_FAILURE, function (state) {
    return _extends({}, state, {
        operationProcessing: false,
        operationProgress: null
    });
}), _defineProperty(_handleActions, ActionTypes.BULK_OPERATION_PROGRESS_SET, function (state, _ref6) {
    var operationProgress = _ref6.payload;
    return _extends({}, state, {
        operationProgress: operationProgress
    });
}), _defineProperty(_handleActions, ActionTypes.CLEANUP_DIALOGS_DATA, function (state) {
    return _extends({}, state, {
        operationProcessing: false,
        operationProgress: null,
        currentOperation: null,
        deleteDialogData: {
            loading: false,
            entitiesBlockedCount: [],
            entitiesBlocked: []
        },
        changeStatusDialogData: {
            loading: false,
            taskIds: []
        },
        assignToDialogData: {
            loading: false,
            numberOfTasks: 0,
            canModifyAny: true,
            timeZoneGroups: [],
            timeZoneGroupsEnabled: false,
            userGroups: [],
            userGroupsEnabled: false,
            users: []
        }
    });
}), _handleActions), initState);

/***/ }),
/* 1235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reduxActions = __webpack_require__(9);

var _actionTypes = __webpack_require__(1236);

var ActionTypes = _interopRequireWildcard(_actionTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var createReducer = function createReducer() {
    var initialState = {
        filter: {
            allSelected: true,
            statusIds: [],
            statusTypes: []
        }
    };

    return (0, _reduxActions.handleActions)(_defineProperty({}, ActionTypes.STATUS_FILTER_SET, function (state, _ref) {
        var filter = _ref.payload;
        return _extends({}, state, {
            filter: filter
        });
    }), initialState);
};

exports.default = createReducer;

/***/ }),
/* 1236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var STATUS_FILTER_SET = exports.STATUS_FILTER_SET = 'at/taskManagement/STATUS_FILTER_SET';

/***/ }),
/* 1237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reduxActions = __webpack_require__(9);

var _actionTypes = __webpack_require__(673);

var ActionTypes = _interopRequireWildcard(_actionTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = {
    inProgress: false
};

exports.default = (0, _reduxActions.handleActions)(_defineProperty({}, ActionTypes.CSV_EXPORT_IN_PROGRESS_SET, function (state, _ref) {
    var inProgress = _ref.payload;
    return _extends({}, state, {
        inProgress: inProgress
    });
}), initialState);

/***/ }),
/* 1238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _redux = __webpack_require__(7);

var _reducer = __webpack_require__(1239);

var _reducer2 = _interopRequireDefault(_reducer);

var _reducer3 = __webpack_require__(1240);

var _reducer4 = _interopRequireDefault(_reducer3);

var _reducer5 = __webpack_require__(1241);

var _reducer6 = _interopRequireDefault(_reducer5);

var _reducer7 = __webpack_require__(1248);

var _reducer8 = _interopRequireDefault(_reducer7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (initAppData) {
    return (0, _redux.combineReducers)({
        task: (0, _reducer8.default)(initAppData),
        project: (0, _reducer2.default)(initAppData),
        customer: (0, _reducer4.default)(initAppData),
        user: _reducer6.default
    });
};

/***/ }),
/* 1239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reduxActions = __webpack_require__(9);

var _reducerGenerator = __webpack_require__(453);

var _reducerGenerator2 = _interopRequireDefault(_reducerGenerator);

var _actionTypes = __webpack_require__(674);

var ActionTypes = _interopRequireWildcard(_actionTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

exports.default = function (initAppData) {
    var _extends2;

    var commentsReducer = (0, _reducerGenerator2.default)({
        actionTypes: ActionTypes,
        initAppData: _extends({}, initAppData, {
            newCommentsTexts: initAppData.COMMENTS.PROJECT_NEW_COMMENTS
        })
    });

    var initialState = _extends({
        openProjectId: null,
        openedFromUrl: false,
        allTasksAssigned: false,
        canManage: false
    }, commentsReducer.initialState);

    return (0, _reduxActions.handleActions)(_extends((_extends2 = {}, _defineProperty(_extends2, ActionTypes.OPEN_PROJECT_SET, function (state, _ref) {
        var openProjectId = _ref.payload;
        return _extends({}, state, { openProjectId: openProjectId });
    }), _defineProperty(_extends2, ActionTypes.PROJECT_PANEL_OPENED_FROM_URL_SET, function (state, _ref2) {
        var openedFromUrl = _ref2.payload;
        return _extends({}, state, { openedFromUrl: openedFromUrl });
    }), _defineProperty(_extends2, ActionTypes.ALL_TASKS_ASSIGNED_SET, function (state, _ref3) {
        var allTasksAssigned = _ref3.payload;
        return _extends({}, state, { allTasksAssigned: allTasksAssigned });
    }), _defineProperty(_extends2, ActionTypes.CAN_MANAGE_SET, function (state, _ref4) {
        var canManage = _ref4.payload;
        return _extends({}, state, { canManage: canManage });
    }), _extends2), commentsReducer.handlers), initialState);
};

/***/ }),
/* 1240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reducerGenerator = __webpack_require__(453);

var _reducerGenerator2 = _interopRequireDefault(_reducerGenerator);

var _actionTypes = __webpack_require__(675);

var ActionTypes = _interopRequireWildcard(_actionTypes);

var _reduxActions = __webpack_require__(9);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

exports.default = function (initAppData) {
    var _extends2;

    var commentsReducer = (0, _reducerGenerator2.default)({
        actionTypes: ActionTypes,
        initAppData: _extends({}, initAppData, {
            newCommentsTexts: initAppData.COMMENTS.CUSTOMER_NEW_COMMENTS
        })
    });

    var initialState = _extends({
        openCustomerId: null,
        openedFromUrl: false,
        allProjectsAssigned: false,
        canManage: false
    }, commentsReducer.initialState);

    return (0, _reduxActions.handleActions)(_extends((_extends2 = {}, _defineProperty(_extends2, ActionTypes.OPEN_CUSTOMER_SET, function (state, _ref) {
        var openCustomerId = _ref.payload;
        return _extends({}, state, { openCustomerId: openCustomerId });
    }), _defineProperty(_extends2, ActionTypes.CUSTOMER_PANEL_OPENED_FROM_URL_SET, function (state, _ref2) {
        var openedFromUrl = _ref2.payload;
        return _extends({}, state, { openedFromUrl: openedFromUrl });
    }), _defineProperty(_extends2, ActionTypes.ALL_PROJECTS_ASSIGNED_SET, function (state, _ref3) {
        var allProjectsAssigned = _ref3.payload;
        return _extends({}, state, { allProjectsAssigned: allProjectsAssigned });
    }), _defineProperty(_extends2, ActionTypes.CAN_MANAGE_SET, function (state, _ref4) {
        var canManage = _ref4.payload;
        return _extends({}, state, { canManage: canManage });
    }), _extends2), commentsReducer.handlers), initialState);
};

/***/ }),
/* 1241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _redux = __webpack_require__(7);

var _reducer = __webpack_require__(1242);

var _reducer2 = _interopRequireDefault(_reducer);

var _reducer3 = __webpack_require__(1243);

var _reducer4 = _interopRequireDefault(_reducer3);

var _reducer5 = __webpack_require__(1244);

var _reducer6 = _interopRequireDefault(_reducer5);

var _reducer7 = __webpack_require__(1245);

var _reducer8 = _interopRequireDefault(_reducer7);

var _reducer9 = __webpack_require__(1246);

var _reducer10 = _interopRequireDefault(_reducer9);

var _reducer11 = __webpack_require__(1247);

var _reducer12 = _interopRequireDefault(_reducer11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _redux.combineReducers)({
    userData: _reducer2.default,
    userRates: _reducer4.default,
    workStatuses: _reducer10.default,
    editPanel: _reducer6.default,
    createPanel: _reducer8.default,
    authorizationInfo: _reducer12.default
});

/***/ }),
/* 1242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _handleActions;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reduxActions = __webpack_require__(9);

var _actionTypes = __webpack_require__(676);

var ActionTypes = _interopRequireWildcard(_actionTypes);

var _atUtils = __webpack_require__(5);

var _constants = __webpack_require__(21);

var _constants2 = __webpack_require__(4);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = {
    fullUserInfo: {
        firstName: null,
        lastName: null,
        middleInitial: null,
        username: null,
        email: null,
        password: null,
        retypedPassword: null,
        userGroupId: null,
        timeZoneGroupId: null,
        hireDate: new Date().toJSON(),
        releaseDate: null,
        enabled: false,
        enabledInOtherProduct: false,
        overtimeLevel: 3,
        accessRights: [],
        rates: [],
        requiresTTApproval: false,
        initialSchedule: [],
        defaultInitialSchedule: true,
        workSchedule: []
    },
    userGroupRowData: {
        groupId: null,
        newGroupCreating: false,
        newUserGroupName: ''
    },
    timeZoneGroupRowData: {
        groupId: null,
        newGroupCreating: false,
        timeZoneGroupsOffset: {},
        newTimeZoneGroup: null
    },
    userTeamAssignmentsData: {
        teamAssignmentType: _constants.UserTeamAssignmentType.NO,
        assignedGroups: [],
        assignedUsers: [],
        assignedUsersCount: 0
    },
    userManageAssignmentsData: {
        managementAssignmentsSelection: _constants2.ManagementAssignmentsSelection.SELECTED,
        customers: {},
        projects: {},
        tasks: {},
        customerAssignments: [],
        projectAssignments: [],
        taskAssignments: [],
        taskCountsByProjects: {},
        projectCountsByCustomers: {}
    },
    managementAssignmentsCounters: {
        loading: false,
        loaded: true,
        customers: 0,
        projects: 0,
        tasks: 0
    },
    allApprovers: {},
    extendedData: {
        lastLoginTime: null,
        firstTTDate: null,
        firstRequestDate: null,
        hasTimeTrack: false,
        lastOtherProductAdmin: false,
        lastLicensesManager: false,
        currentTime: new Date().toJSON(),
        isAllowedToSeeAllUsersTT: false
    },
    providerErrors: {},
    passwordValidationResult: null,
    hasLeavesOrTTBeforeNewHireDateError: false
};

exports.default = (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, ActionTypes.FULL_USER_INFO_SET, function (state, _ref) {
    var userInfoChanges = _ref.payload;
    return _extends({}, state, {
        fullUserInfo: _extends({}, state.fullUserInfo, userInfoChanges)
    });
}), _defineProperty(_handleActions, ActionTypes.EXTENDED_DATA_UPDATE, function (state, _ref2) {
    var extendedData = _ref2.payload;
    return _extends({}, state, {
        extendedData: _extends({}, state.extendedData, extendedData)
    });
}), _defineProperty(_handleActions, ActionTypes.USER_PANEL_PASSWORD_VALIDATION_RESULT_SET, function (state, _ref3) {
    var passwordValidationResult = _ref3.payload;
    return _extends({}, state, {
        passwordValidationResult: passwordValidationResult
    });
}), _defineProperty(_handleActions, ActionTypes.USER_GROUP_DATA_SET, function (state, _ref4) {
    var data = _ref4.payload;
    return _extends({}, state, {
        userGroupRowData: _extends({}, state.userGroupRowData, data)
    });
}), _defineProperty(_handleActions, ActionTypes.TIME_ZONE_GROUP_DATA_SET, function (state, _ref5) {
    var data = _ref5.payload;
    return _extends({}, state, {
        timeZoneGroupRowData: _extends({}, state.timeZoneGroupRowData, data)
    });
}), _defineProperty(_handleActions, ActionTypes.USER_MANAGE_ASSIGNMENTS_DATA_SET, function (state, _ref6) {
    var userManageAssignmentsData = _ref6.payload;
    return _extends({}, state, {
        userManageAssignmentsData: _extends({}, state.userManageAssignmentsData, userManageAssignmentsData)
    });
}), _defineProperty(_handleActions, ActionTypes.USER_MANAGEMENT_ASSIGNMENTS_SELECTION_SET, function (state, _ref7) {
    var managementAssignmentsSelection = _ref7.payload;
    return _extends({}, state, {
        userManageAssignmentsData: _extends({}, state.userManageAssignmentsData, {
            managementAssignmentsSelection: managementAssignmentsSelection
        })
    });
}), _defineProperty(_handleActions, ActionTypes.USER_TEAM_ASSIGNMENTS_DATA_SET, function (state, _ref8) {
    var userTeamAssignmentsData = _ref8.payload;
    return _extends({}, state, {
        userTeamAssignmentsData: _extends({}, state.userTeamAssignmentsData, userTeamAssignmentsData)
    });
}), _defineProperty(_handleActions, ActionTypes.USER_DATA_SET, function (state, _ref9) {
    var data = _ref9.payload;
    return _extends({}, state, data);
}), _defineProperty(_handleActions, ActionTypes.ALL_APPROVERS_SET, function (state, _ref10) {
    var allApprovers = _ref10.payload;
    return _extends({}, state, {
        allApprovers: allApprovers
    });
}), _defineProperty(_handleActions, ActionTypes.USER_PANEL_ERROR_ADD, function (state, _ref11) {
    var providerErrors = _ref11.payload;
    return _extends({}, state, {
        providerErrors: _extends({}, state.providerErrors, (0, _atUtils.arrayToSet)(providerErrors))
    });
}), _defineProperty(_handleActions, ActionTypes.USER_PANEL_ERRORS_SET, function (state, _ref12) {
    var providerErrors = _ref12.payload;
    return _extends({}, state, {
        providerErrors: providerErrors
    });
}), _defineProperty(_handleActions, ActionTypes.USER_PANEL_ERRORS_CLEAR, function (state) {
    return _extends({}, state, {
        providerErrors: {},
        hasLeavesOrTTBeforeNewHireDateError: false
    });
}), _defineProperty(_handleActions, ActionTypes.USER_PANEL_ERRORS_REMOVE, function (state, _ref13) {
    var errors = _ref13.payload;
    return _extends({}, state, {
        providerErrors: (0, _atUtils.filterMapByKeys)(state.providerErrors, errors)
    });
}), _defineProperty(_handleActions, ActionTypes.USER_PANEL_HAS_LEAVES_OR_TT_BEFORE_NEW_HIRE_DATE_ERROR, function (state, _ref14) {
    var hasLeavesOrTTBeforeNewHireDateError = _ref14.payload;
    return _extends({}, state, {
        hasLeavesOrTTBeforeNewHireDateError: hasLeavesOrTTBeforeNewHireDateError
    });
}), _defineProperty(_handleActions, ActionTypes.MANAGEMENT_ASSIGNMENTS_COUNTS_LOADED_SET, function (state, _ref15) {
    var loaded = _ref15.payload;
    return _extends({}, state, {
        managementAssignmentsCounters: _extends({}, state.managementAssignmentsCounters, {
            loaded: loaded
        })
    });
}), _defineProperty(_handleActions, ActionTypes.MANAGEMENT_ASSIGNMENTS_COUNTS_LOAD, function (state) {
    return _extends({}, state, {
        managementAssignmentsCounters: _extends({}, state.managementAssignmentsCounters, {
            loading: true
        })
    });
}), _defineProperty(_handleActions, ActionTypes.MANAGEMENT_ASSIGNMENTS_COUNTS_LOAD_SUCCESS, function (state, _ref16) {
    var _ref16$payload = _ref16.payload,
        customers = _ref16$payload.customers,
        projects = _ref16$payload.projects,
        tasks = _ref16$payload.tasks;
    return _extends({}, state, {
        managementAssignmentsCounters: {
            loading: false,
            loaded: true,
            customers: customers,
            projects: projects,
            tasks: tasks
        }
    });
}), _defineProperty(_handleActions, ActionTypes.MANAGEMENT_ASSIGNMENTS_COUNTS_LOAD_FAILURE, function (state, _ref17) {
    var error = _ref17.payload;
    return _extends({}, state, {
        managementAssignmentsCounters: _extends({}, state.managementAssignmentsCounters, {
            loading: false,
            loaded: true
        })
    });
}), _handleActions), initialState);

/***/ }),
/* 1243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _handleActions;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reduxActions = __webpack_require__(9);

var _actionTypes = __webpack_require__(677);

var ActionTypes = _interopRequireWildcard(_actionTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = {
    lastEditedUserRate: null,
    errors: {},
    updating: false
};

exports.default = (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, ActionTypes.LAST_EDITED_USER_RATE_SET, function (state, _ref) {
    var lastEditedUserRate = _ref.payload;
    return _extends({}, state, { lastEditedUserRate: lastEditedUserRate });
}), _defineProperty(_handleActions, ActionTypes.ERRORS_SET, function (state, _ref2) {
    var errors = _ref2.payload;
    return _extends({}, state, { errors: errors });
}), _defineProperty(_handleActions, ActionTypes.ERRORS_CLEAR, function (state) {
    return _extends({}, state, { errors: {} });
}), _defineProperty(_handleActions, ActionTypes.UPDATING_SET, function (state, _ref3) {
    var updating = _ref3.payload;
    return _extends({}, state, { updating: updating });
}), _handleActions), initialState);

/***/ }),
/* 1244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _handleActions;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reduxActions = __webpack_require__(9);

var _actionTypes = __webpack_require__(678);

var ActionTypes = _interopRequireWildcard(_actionTypes);

var _actionTypes2 = __webpack_require__(104);

var _constants = __webpack_require__(21);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = {
    loading: false,
    loaded: true,
    updatingData: false,
    userId: null,
    selectedTab: _constants.TabKeys.ACCOUNT_SETTINGS,
    updatingWorkSchedule: false,
    errorBackup: null,
    isLastLicenseManagerOnDeleteAlertShown: false,
    isLastLicenseManagerOnDisableAtAlertShown: false,
    isLastLicenseManagerOnDisableApAlertShown: false
};

exports.default = (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, ActionTypes.USER_PANEL_LOADING_SET, function (state, _ref) {
    var loading = _ref.payload;
    return _extends({}, state, { loading: loading });
}), _defineProperty(_handleActions, ActionTypes.EDIT_USER_ID_SET, function (state, _ref2) {
    var userId = _ref2.payload;
    return _extends({}, state, { userId: userId });
}), _defineProperty(_handleActions, ActionTypes.USER_PANEL_TAB_SET, function (state, _ref3) {
    var tabKey = _ref3.payload;
    return _extends({}, state, { selectedTab: tabKey });
}), _defineProperty(_handleActions, ActionTypes.USER_PANEL_STATE_SET, function (state, _ref4) {
    var allState = _ref4.payload;
    return _extends({}, state, allState);
}), _defineProperty(_handleActions, ActionTypes.LOADED_SET, function (state, _ref5) {
    var loaded = _ref5.payload;
    return _extends({}, state, { loaded: loaded });
}), _defineProperty(_handleActions, ActionTypes.UPDATING_DATA_SET, function (state, _ref6) {
    var updatingData = _ref6.payload;
    return _extends({}, state, { updatingData: updatingData });
}), _defineProperty(_handleActions, ActionTypes.UPDATING_WORK_SCHEDULE_SET, function (state, _ref7) {
    var updatingWorkSchedule = _ref7.payload;
    return _extends({}, state, { updatingWorkSchedule: updatingWorkSchedule });
}), _defineProperty(_handleActions, ActionTypes.ERROR_BACKUP_UPDATE, function (state, _ref8) {
    var errorBackup = _ref8.payload;
    return _extends({}, state, { errorBackup: errorBackup });
}), _defineProperty(_handleActions, ActionTypes.LAST_LICENSE_MANAGER_ON_DELETE_ALERT_SHOWN_SET, function (state, _ref9) {
    var isLastLicenseManagerOnDeleteAlertShown = _ref9.payload;
    return _extends({}, state, {
        isLastLicenseManagerOnDeleteAlertShown: isLastLicenseManagerOnDeleteAlertShown
    });
}), _defineProperty(_handleActions, ActionTypes.LAST_LICENSE_MANAGER_ON_DISABLE_AT_ALERT_SHOWN_SET, function (state, _ref10) {
    var isLastLicenseManagerOnDisableAtAlertShown = _ref10.payload;
    return _extends({}, state, {
        isLastLicenseManagerOnDisableAtAlertShown: isLastLicenseManagerOnDisableAtAlertShown
    });
}), _defineProperty(_handleActions, ActionTypes.LAST_LICENSE_MANAGER_ON_DISABLE_AP_ALERT_SHOWN_SET, function (state, _ref11) {
    var isLastLicenseManagerOnDisableApAlertShown = _ref11.payload;
    return _extends({}, state, {
        isLastLicenseManagerOnDisableApAlertShown: isLastLicenseManagerOnDisableApAlertShown
    });
}), _defineProperty(_handleActions, _actionTypes2.CLOSE_ALL_PANELS, function (state) {
    return _extends({}, state, {
        loading: false,
        loaded: true,
        updatingData: false,
        userId: null,
        updatingWorkSchedule: false,
        errorBackup: null
    });
}), _handleActions), initialState);

/***/ }),
/* 1245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _handleActions;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reduxActions = __webpack_require__(9);

var _actionTypes = __webpack_require__(454);

var ActionTypes = _interopRequireWildcard(_actionTypes);

var _atUtils = __webpack_require__(5);

var _constants = __webpack_require__(4);

var _constants2 = __webpack_require__(21);

var _actionTypes2 = __webpack_require__(104);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = {
    show: false,
    loaded: false,
    loading: false,
    selectedTab: _constants2.TabKeys.ACCOUNT_SETTINGS,
    saving: false,
    userCreated: false,
    invitationSent: false,
    showFutureInvitation: false,
    manageAssignments: {
        managementAssignmentsSelection: _constants.ManagementAssignmentsSelection.SELECTED,
        addedTaskIds: [],
        addedProjectIds: [],
        addedProjectIdsExcludingSelf: [],
        addedCustomerIds: [],
        addedCustomerIdsExcludingSelf: [],
        taskCountsByProjects: {},
        projectCountsByCustomers: {},
        customersCount: 0,
        projectsOfCustomerCount: 0,
        tasksOfProjectCount: 0
    },
    tasksMap: {},
    copyUserId: null,
    approversByGroupIds: {},
    passwordValidationRequired: false,

    defaultUserInfo: {
        firstName: null,
        lastName: null,
        middleInitial: null,
        username: null,
        email: null,
        password: null,
        retypedPassword: null,
        userGroupId: null,
        timeZoneGroupId: null,
        hireDate: new Date().toJSON(),
        releaseDate: null,
        enabled: false,
        enabledInOtherProduct: false,
        overtimeLevel: _constants.UserManagementConstants.OVERTIME_OFF,
        accessRights: [],
        rates: [],
        requiresTTApproval: false,
        initialSchedule: [],
        defaultInitialSchedule: true,
        workSchedule: []
    },
    defaultTeamAssignments: {
        teamAssignmentType: _constants2.UserTeamAssignmentType.NO,
        assignedGroups: [],
        assignedUsers: [],
        assignedUsersCount: 0
    },
    defaultManageAssignments: {
        managementAssignmentsSelection: _constants.ManagementAssignmentsSelection.SELECTED,
        addedTaskIds: [],
        addedProjectIds: [],
        addedCustomerIds: [],
        addedProjectIdsExcludingSelf: [],
        addedCustomerIdsExcludingSelf: [],
        taskCountsByProjects: {},
        projectCountsByCustomers: {}
    }
};

exports.default = (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, ActionTypes.CREATE_USER_PANEL_TAB_SET, function (state, _ref) {
    var tabKey = _ref.payload;
    return _extends({}, state, { selectedTab: tabKey });
}), _defineProperty(_handleActions, ActionTypes.LOADING_SET, function (state, _ref2) {
    var loading = _ref2.payload;
    return _extends({}, state, { loading: loading });
}), _defineProperty(_handleActions, ActionTypes.SHOW_FUTURE_INVITATION_SET, function (state, _ref3) {
    var showFutureInvitation = _ref3.payload;
    return _extends({}, state, { showFutureInvitation: showFutureInvitation });
}), _defineProperty(_handleActions, ActionTypes.MANAGE_ASSIGNMENTS_SET, function (state, _ref4) {
    var manageAssignments = _ref4.payload;
    return _extends({}, state, { manageAssignments: manageAssignments });
}), _defineProperty(_handleActions, ActionTypes.PASSWORD_VALIDATION_REQUESTED, function (state) {
    return _extends({}, state, {
        passwordValidationRequired: true
    });
}), _defineProperty(_handleActions, ActionTypes.PASSWORD_VALIDATION_DONE, function (state) {
    return _extends({}, state, {
        passwordValidationRequired: false
    });
}), _defineProperty(_handleActions, ActionTypes.CUSTOMERS_COUNT_SET, function (state, _ref5) {
    var customersCount = _ref5.payload;
    return _extends({}, state, {
        manageAssignments: _extends({}, state.manageAssignments, {
            customersCount: customersCount
        })
    });
}), _defineProperty(_handleActions, ActionTypes.PROJECTS_COUNT_SET, function (state, _ref6) {
    var projectsOfCustomerCount = _ref6.payload;
    return _extends({}, state, {
        manageAssignments: _extends({}, state.manageAssignments, {
            projectsOfCustomerCount: projectsOfCustomerCount
        })
    });
}), _defineProperty(_handleActions, ActionTypes.TASKS_COUNT_SET, function (state, _ref7) {
    var tasksOfProjectCount = _ref7.payload;
    return _extends({}, state, {
        manageAssignments: _extends({}, state.manageAssignments, {
            tasksOfProjectCount: tasksOfProjectCount
        })
    });
}), _defineProperty(_handleActions, ActionTypes.RESET_CREATE_USER_PANEL_STATE, function (state) {
    return _extends({}, state, {
        selectedTab: _constants2.TabKeys.ACCOUNT_SETTINGS,
        saving: false,
        userCreated: false,
        invitationSent: false,
        showFutureInvitation: false,
        manageAssignments: {
            managementAssignmentsSelection: _constants.ManagementAssignmentsSelection.SELECTED,
            addedTaskIds: [],
            addedProjectIds: [],
            addedProjectIdsExcludingSelf: [],
            addedCustomerIds: [],
            addedCustomerIdsExcludingSelf: [],
            taskCountsByProjects: {},
            projectCountsByCustomers: {},
            customersCount: 0,
            projectsOfCustomerCount: 0,
            tasksOfProjectCount: 0
        },
        tasksMap: {},
        copyUserId: null,
        approversByGroups: {}
    });
}), _defineProperty(_handleActions, ActionTypes.MANAGE_ASSIGNMENTS_TASKS_ADD, function (state, _ref8) {
    var tasks = _ref8.payload;
    return _extends({}, state, {
        tasksMap: _extends({}, state.tasksMap, (0, _atUtils.arrayToMap)(tasks))
    });
}), _defineProperty(_handleActions, ActionTypes.SAVE_USER, function (state) {
    return _extends({}, state, {
        saving: true
    });
}), _defineProperty(_handleActions, ActionTypes.SAVE_USER_SUCCESS, function (state, _ref9) {
    var _ref9$payload$invitat = _ref9.payload.invitationSent,
        invitationSent = _ref9$payload$invitat === undefined ? false : _ref9$payload$invitat;
    return _extends({}, state, {
        userCreated: true,
        saving: false,
        invitationSent: invitationSent
    });
}), _defineProperty(_handleActions, ActionTypes.SAVE_USER_FAILURE, function (state) {
    return _extends({}, state, {
        saving: false
    });
}), _defineProperty(_handleActions, ActionTypes.TOGGLE_CREATE_USER_PANEL, function (state, _ref10) {
    var isShow = _ref10.payload;
    return _extends({}, state, {
        show: isShow
    });
}), _defineProperty(_handleActions, ActionTypes.LOADED_SET, function (state, _ref11) {
    var loaded = _ref11.payload;
    return _extends({}, state, {
        loaded: loaded
    });
}), _defineProperty(_handleActions, ActionTypes.DEFAULT_USER_INFO_SET, function (state, _ref12) {
    var changedProperties = _ref12.payload;
    return _extends({}, state, {
        defaultUserInfo: _extends({}, state.defaultUserInfo, changedProperties)
    });
}), _defineProperty(_handleActions, ActionTypes.DEFAULT_TEAM_ASSIGNMENTS_SET, function (state, _ref13) {
    var changedProperties = _ref13.payload;
    return _extends({}, state, {
        defaultTeamAssignments: _extends({}, state.defaultTeamAssignments, changedProperties)
    });
}), _defineProperty(_handleActions, ActionTypes.DEFAULT_MANAGE_ASSIGNMENTS_SET, function (state, _ref14) {
    var changedProperties = _ref14.payload;
    return _extends({}, state, {
        defaultManageAssignments: _extends({}, state.defaultManageAssignments, changedProperties)
    });
}), _defineProperty(_handleActions, ActionTypes.COPY_USER_CHANGED, function (state, _ref15) {
    var copyUserId = _ref15.payload;
    return _extends({}, state, {
        copyUserId: copyUserId
    });
}), _defineProperty(_handleActions, ActionTypes.APPROVERS_BY_GROUPS_SET, function (state, _ref16) {
    var approversByGroupIds = _ref16.payload;
    return _extends({}, state, {
        approversByGroupIds: approversByGroupIds
    });
}), _defineProperty(_handleActions, _actionTypes2.CLOSE_ALL_PANELS, function (state) {
    return _extends({}, state, {
        show: false,
        loaded: false,
        loading: false,
        saving: false,
        userCreated: false,
        invitationSent: false,
        showFutureInvitation: false
    });
}), _handleActions), initialState);

/***/ }),
/* 1246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _handleActions;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reduxActions = __webpack_require__(9);

var _actionTypes = __webpack_require__(679);

var ActionTypes = _interopRequireWildcard(_actionTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = {
    workStatuses: [],
    initialDefaultWorkStatus: {},
    defaultWorkStatusPlanningData: {}
};

exports.default = (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, ActionTypes.WORK_STATUSES_SET, function (state, _ref) {
    var workStatuses = _ref.payload;
    return _extends({}, state, {
        workStatuses: workStatuses
    });
}), _defineProperty(_handleActions, ActionTypes.DEFAULT_WORK_STATUS_PLANNING_DATA_SET, function (state, _ref2) {
    var defaultWorkStatusPlanningData = _ref2.payload;
    return _extends({}, state, {
        defaultWorkStatusPlanningData: defaultWorkStatusPlanningData
    });
}), _defineProperty(_handleActions, ActionTypes.INITIAL_DEFAULT_WORK_STATUS_SET, function (state, _ref3) {
    var initialDefaultWorkStatus = _ref3.payload;
    return _extends({}, state, {
        initialDefaultWorkStatus: initialDefaultWorkStatus
    });
}), _handleActions), initialState);

/***/ }),
/* 1247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _handleActions;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reduxActions = __webpack_require__(9);

var _actionTypes = __webpack_require__(680);

var ActionTypes = _interopRequireWildcard(_actionTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = {
    baseAccountInformationEditable: false,
    accessToActiTimeEditable: false,
    accessToActiPlansEditable: false,
    departmentEditable: false,
    timeZoneEditable: false,
    hireAndReleaseDatesEditable: false,
    approvalSettingsEditable: false,
    workScheduleEditable: false,
    overtimeSettingsEditable: false,
    costOfWorkRatesEditable: false,

    permissionsEditable: false,
    teamScopeEditable: false,
    manageScopeEditable: false,

    hasRightsToDeleteUser: false
};

exports.default = (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, ActionTypes.FIELDS_EDITABILITY_SET, function (state, _ref) {
    var changedFields = _ref.payload;
    return _extends({}, state, changedFields);
}), _defineProperty(_handleActions, ActionTypes.CAN_EDIT_ENTIRE_USER_SET, function (state) {
    return _extends({}, state, {
        baseAccountInformationEditable: true,
        accessToActiTimeEditable: true,
        accessToActiPlansEditable: true,
        departmentEditable: true,
        timeZoneEditable: true,
        hireAndReleaseDatesEditable: true,
        approvalSettingsEditable: true,
        workScheduleEditable: true,
        overtimeSettingsEditable: true,
        costOfWorkRatesEditable: true,

        permissionsEditable: true,
        teamScopeEditable: true,
        manageScopeEditable: true,

        hasRightsToDeleteUser: true
    });
}), _handleActions), initialState);

/***/ }),
/* 1248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reducer = __webpack_require__(1249);

var _reducer2 = _interopRequireDefault(_reducer);

var _redux = __webpack_require__(7);

var _reducer3 = __webpack_require__(1250);

var _reducer4 = _interopRequireDefault(_reducer3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (initAppData) {
    return (0, _redux.combineReducers)({
        edit: (0, _reducer2.default)(initAppData),
        create: (0, _reducer4.default)(initAppData)
    });
};

/***/ }),
/* 1249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reduxActions = __webpack_require__(9);

var _actionTypes = __webpack_require__(681);

var ActionTypes = _interopRequireWildcard(_actionTypes);

var _reducerGenerator = __webpack_require__(453);

var _reducerGenerator2 = _interopRequireDefault(_reducerGenerator);

var _reducerGenerator3 = __webpack_require__(682);

var _reducerGenerator4 = _interopRequireDefault(_reducerGenerator3);

var _reducerGenerator5 = __webpack_require__(683);

var _reducerGenerator6 = _interopRequireDefault(_reducerGenerator5);

var _constants = __webpack_require__(157);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var createEditTaskPanelReducer = function createEditTaskPanelReducer(initAppData) {
    var _extends2;

    var commentsReducer = (0, _reducerGenerator2.default)({
        actionTypes: ActionTypes,
        initAppData: _extends({}, initAppData, {
            newCommentsTexts: initAppData.COMMENTS.TASK_NEW_COMMENTS
        })
    });

    var panelReducer = (0, _reducerGenerator4.default)({
        actionTypes: ActionTypes
    });

    var assignmentsReducer = (0, _reducerGenerator6.default)({
        actionTypes: {
            ASSIGNED_USERS_SET: ActionTypes.ASSIGNED_USERS_SET,
            ASSIGNED_MANAGERS_SET: ActionTypes.ASSIGNED_MANAGERS_SET,
            CAN_MODIFY_ANY_MANAGER_SET: ActionTypes.CAN_MODIFY_ANY_MANAGER_SET,
            CAN_MODIFY_ANY_USER_SET: ActionTypes.CAN_MODIFY_ANY_USER_SET
        }
    });

    var initialState = _extends({}, commentsReducer.initialState, panelReducer.initialState, assignmentsReducer.initialState, {

        openTaskId: null,
        openedFromUrl: false,
        canEdit: false,
        updatingState: {
            name: false,
            deadline: false,
            typeOfWork: false,
            estimate: false,
            description: false,
            moveToDialog: false
        },
        taskDetails: {
            blockedDueToLockedTime: false,
            blockedDueToUnavailableToModifyTimeTrack: false,
            taskHasOtherUsersTimeTrack: false,
            taskHasManagerTimeTrack: false,
            taskHasOtherUsersApprovedTimeTrack: false,
            taskHasManagerApprovedTimeTrack: false,
            hasManagerApprover: false,
            canManageAllUsersWithoutAutoApproved: false
        },
        taskDeletedSuccessfully: false,
        taskDeletedUnsuccessfully: false,

        auditInfo: {
            lastAuditActions: {
                createAction: null,
                updateAction: null
            },
            allAuditHistoryLoaded: false,
            auditHistoryLoading: false,
            auditActions: []
        },

        executorsSummary: {
            total: null,
            myRecord: null,
            myTeamRecords: [],
            othersRecords: [],
            myTeamTotal: 0,
            othersTotal: 0
        },
        reportedTimeComments: [],
        allTimeCommentsLoaded: false,
        timeAndCommentsLoading: false,
        sortingSettings: {
            sortBy: _constants.ReportedTimeSortConstants.BY_DATE,
            sortOrder: _constants.ReportedTimeSortConstants.DESC
        },
        customFieldsValues: {}
    });

    return (0, _reduxActions.handleActions)(_extends({}, commentsReducer.handlers, panelReducer.handlers, assignmentsReducer.handlers, (_extends2 = {}, _defineProperty(_extends2, ActionTypes.OPEN_TASK_SET, function (state, _ref) {
        var openTaskId = _ref.payload;
        return _extends({}, state, { openTaskId: openTaskId });
    }), _defineProperty(_extends2, ActionTypes.TASK_PANEL_UPDATING_STATE_SET, function (state, _ref2) {
        var changedData = _ref2.payload;
        return _extends({}, state, {
            updatingState: _extends({}, state.updatingState, changedData)
        });
    }), _defineProperty(_extends2, ActionTypes.TASK_PANEL_EDITABLE_SET, function (state, _ref3) {
        var canEdit = _ref3.payload;
        return _extends({}, state, { canEdit: canEdit });
    }), _defineProperty(_extends2, ActionTypes.TASK_PANEL_OPENED_FROM_URL_SET, function (state, _ref4) {
        var openedFromUrl = _ref4.payload;
        return _extends({}, state, { openedFromUrl: openedFromUrl });
    }), _defineProperty(_extends2, ActionTypes.TASK_DETAILS_SET, function (state, _ref5) {
        var taskDetails = _ref5.payload;
        return _extends({}, state, { taskDetails: taskDetails });
    }), _defineProperty(_extends2, ActionTypes.TASK_EXECUTORS_SUMMARY_SET, function (state, _ref6) {
        var executorsSummary = _ref6.payload;
        return _extends({}, state, { executorsSummary: executorsSummary });
    }), _defineProperty(_extends2, ActionTypes.ALL_TIME_COMMENTS_LOADED_SET, function (state, _ref7) {
        var allTimeCommentsLoaded = _ref7.payload;
        return _extends({}, state, { allTimeCommentsLoaded: allTimeCommentsLoaded });
    }), _defineProperty(_extends2, ActionTypes.TIME_AND_COMMENTS_LOADING_SET, function (state, _ref8) {
        var timeAndCommentsLoading = _ref8.payload;
        return _extends({}, state, { timeAndCommentsLoading: timeAndCommentsLoading });
    }), _defineProperty(_extends2, ActionTypes.REPORTED_TIME_COMMENTS_SET, function (state, _ref9) {
        var reportedTimeComments = _ref9.payload;
        return _extends({}, state, { reportedTimeComments: reportedTimeComments });
    }), _defineProperty(_extends2, ActionTypes.REPORTED_TIME_COMMENTS_ADD, function (state, _ref10) {
        var reportedTimeComments = _ref10.payload;
        return _extends({}, state, {
            reportedTimeComments: [].concat(_toConsumableArray(state.reportedTimeComments), _toConsumableArray(reportedTimeComments))
        });
    }), _defineProperty(_extends2, ActionTypes.SORTING_SETTINGS_SET, function (state, _ref11) {
        var sortingSettings = _ref11.payload;
        return _extends({}, state, { sortingSettings: sortingSettings });
    }), _defineProperty(_extends2, ActionTypes.TASK_DELETED_SUCCESSFULLY_SET, function (state) {
        return _extends({}, state, { taskDeletedSuccessfully: true });
    }), _defineProperty(_extends2, ActionTypes.TASK_DELETED_UNSUCCESSFULLY_SET, function (state) {
        return _extends({}, state, { taskDeletedUnsuccessfully: true });
    }), _defineProperty(_extends2, ActionTypes.TASK_DELETION_STATUS_RESET, function (state) {
        return _extends({}, state, {
            taskDeletedSuccessfully: false,
            taskDeletedUnsuccessfully: false
        });
    }), _defineProperty(_extends2, ActionTypes.TASK_AUDIT_HISTORY_INFO_SET, function (state, _ref12) {
        var changedData = _ref12.payload;
        return _extends({}, state, {
            auditInfo: _extends({}, state.auditInfo, changedData)
        });
    }), _defineProperty(_extends2, ActionTypes.AUDIT_HISTORY_ADD, function (state, _ref13) {
        var newItems = _ref13.payload;
        return _extends({}, state, {
            auditInfo: _extends({}, state.auditInfo, {
                auditActions: state.auditInfo.auditActions.concat(newItems)
            })
        });
    }), _defineProperty(_extends2, ActionTypes.AUDIT_HISTORY_SET, function (state, _ref14) {
        var auditActions = _ref14.payload;
        return _extends({}, state, {
            auditInfo: _extends({}, state.auditInfo, {
                auditActions: auditActions
            })
        });
    }), _defineProperty(_extends2, ActionTypes.TASK_PANEL_STATE_RESET, function (state) {
        return _extends({}, state, {
            auditInfo: initialState.auditInfo
        });
    }), _defineProperty(_extends2, ActionTypes.CUSTOM_FIELDS_VALUES_UPDATE, function (state, _ref15) {
        var customFieldsValues = _ref15.payload;
        return _extends({}, state, {
            customFieldsValues: _extends({}, state.customFieldsValues, customFieldsValues)
        });
    }), _defineProperty(_extends2, ActionTypes.CUSTOM_FIELDS_VALUES_SET, function (state, _ref16) {
        var customFieldsValues = _ref16.payload;
        return _extends({}, state, {
            customFieldsValues: customFieldsValues
        });
    }), _extends2)), initialState);
};

exports.default = createEditTaskPanelReducer;

/***/ }),
/* 1250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reduxActions = __webpack_require__(9);

var _actionTypes = __webpack_require__(684);

var ActionTypes = _interopRequireWildcard(_actionTypes);

var _reducerGenerator = __webpack_require__(682);

var _reducerGenerator2 = _interopRequireDefault(_reducerGenerator);

var _reducerGenerator3 = __webpack_require__(683);

var _reducerGenerator4 = _interopRequireDefault(_reducerGenerator3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var createNewTaskPanelReducer = function createNewTaskPanelReducer(initAppData) {
    var _extends2;

    var panelReducer = (0, _reducerGenerator2.default)({
        actionTypes: ActionTypes
    });

    var assignmentsReducer = (0, _reducerGenerator4.default)({
        actionTypes: {
            ASSIGNED_USERS_SET: ActionTypes.ASSIGNED_USERS_SET,
            ASSIGNED_MANAGERS_SET: ActionTypes.ASSIGNED_MANAGERS_SET,
            CAN_MODIFY_ANY_MANAGER_SET: ActionTypes.CAN_MODIFY_ANY_MANAGER_SET,
            CAN_MODIFY_ANY_USER_SET: ActionTypes.CAN_MODIFY_ANY_USER_SET
        }
    });

    var initialState = _extends({}, panelReducer.initialState, assignmentsReducer.initialState, {
        addedAssignedUserIds: {},
        addedAssignedManagerIds: {},

        taskInfoDefaultState: {
            workflowStatusId: 0,
            creationTimestamp: null,
            completed: false,
            name: '',
            deadline: null,
            typeOfWorkId: 0,
            estimatedTime: null,
            spentTime: 0,
            description: ''
        },

        customFieldsValues: {}
    });

    return (0, _reduxActions.handleActions)(_extends({}, panelReducer.handlers, assignmentsReducer.handlers, (_extends2 = {}, _defineProperty(_extends2, ActionTypes.ADDED_ASSIGNED_USER_IDS_SET, function (state, _ref) {
        var addedAssignedUserIds = _ref.payload;
        return _extends({}, state, { addedAssignedUserIds: addedAssignedUserIds });
    }), _defineProperty(_extends2, ActionTypes.ADDED_ASSIGNED_MANAGER_IDS_SET, function (state, _ref2) {
        var addedAssignedManagerIds = _ref2.payload;
        return _extends({}, state, { addedAssignedManagerIds: addedAssignedManagerIds });
    }), _defineProperty(_extends2, ActionTypes.CREATE_PANEL_STATE_RESET, function (state) {
        return _extends({}, state, panelReducer.initialState, {
            customFieldsValues: {}
        });
    }), _defineProperty(_extends2, ActionTypes.TASK_DATA_DEFAULT_STATE_PROPERTY_SET, function (state, _ref3) {
        var changedProperties = _ref3.payload;
        return _extends({}, state, {
            taskInfoDefaultState: _extends({}, state.taskInfoDefaultState, changedProperties)
        });
    }), _defineProperty(_extends2, ActionTypes.CUSTOM_FIELDS_VALUES_UPDATE, function (state, _ref4) {
        var customValuesDiff = _ref4.payload;
        return _extends({}, state, {
            customFieldsValues: _extends({}, state.customFieldsValues, customValuesDiff)
        });
    }), _extends2)), initialState);
};

exports.default = createNewTaskPanelReducer;

/***/ }),
/* 1251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _handleActions;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reduxActions = __webpack_require__(9);

var _actionTypes = __webpack_require__(685);

var ActionTypes = _interopRequireWildcard(_actionTypes);

var _constants = __webpack_require__(23);

var _constants2 = __webpack_require__(180);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = {
    firstLoading: true,
    statuses: [],
    statusesInUseIds: [],
    loading: false,
    editingStatus: {
        id: null,
        name: '',
        type: '',
        position: -1,
        colorId: _constants.DEFAULT_COLOR_ID
    },
    showEditStatusDialog: false,
    errors: []
};

exports.default = (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, ActionTypes.LOAD_DATA, function (state) {
    return _extends({}, state, {
        firstLoading: true
    });
}), _defineProperty(_handleActions, ActionTypes.LOAD_DATA_SUCCESS, function (state, _ref) {
    var statusesInUseIds = _ref.payload;
    return _extends({}, state, {
        statusesInUseIds: statusesInUseIds,
        errors: [],
        firstLoading: false
    });
}), _defineProperty(_handleActions, ActionTypes.LOAD_DATA_FAILURE, function (state, _ref2) {
    var errors = _ref2.payload;
    return _extends({}, state, {
        errors: errors,
        firstLoading: false
    });
}), _defineProperty(_handleActions, (0, _reduxActions.combineActions)(ActionTypes.CREATE_NEW_STATUS, ActionTypes.EDIT_STATUS, ActionTypes.DELETE_STATUS, ActionTypes.CHANGE_STATUS_POSITION), function (state) {
    return _extends({}, state, {
        loading: true
    });
}), _defineProperty(_handleActions, (0, _reduxActions.combineActions)(ActionTypes.CREATE_NEW_STATUS_SUCCESS, ActionTypes.EDIT_STATUS_SUCCESS, ActionTypes.DELETE_STATUS_SUCCESS, ActionTypes.CHANGE_STATUS_POSITION_SUCCESS), function (state, _ref3) {
    var statusesInUseIds = _ref3.payload;
    return _extends({}, state, {
        loading: false,
        errors: [],
        statusesInUseIds: statusesInUseIds
    });
}), _defineProperty(_handleActions, (0, _reduxActions.combineActions)(ActionTypes.CREATE_NEW_STATUS_FAILURE, ActionTypes.EDIT_STATUS_FAILURE, ActionTypes.DELETE_STATUS_FAILURE, ActionTypes.CHANGE_STATUS_POSITION_FAILURE), function (state, _ref4) {
    var data = _ref4.payload;
    return _extends({}, state, {
        loading: false,
        errors: data.errors,
        statusesInUseIds: data.statusesInUseIds
    });
}), _defineProperty(_handleActions, ActionTypes.SET_ERRORS, function (state, _ref5) {
    var errors = _ref5.payload;
    return _extends({}, state, {
        errors: errors
    });
}), _defineProperty(_handleActions, ActionTypes.START_EDIT_STATUS, function (state, _ref6) {
    var editingStatus = _ref6.payload;
    return _extends({}, state, {
        editingStatus: editingStatus,
        errors: []
    });
}), _defineProperty(_handleActions, ActionTypes.CANCEL_EDIT_OR_CREATE_STATUS, function (state) {
    return _extends({}, state, {
        editingStatus: {
            id: null,
            name: '',
            type: '',
            position: -1,
            colorId: _constants.DEFAULT_COLOR_ID
        }
    });
}), _defineProperty(_handleActions, ActionTypes.START_CREATE_STATUS, function (state, _ref7) {
    var type = _ref7.payload;
    return _extends({}, state, {
        editingStatus: {
            id: _constants2.NEW_STATUS_ID,
            type: type,
            name: '',
            colorId: _constants2.NEW_STATUS_COLOR_ID,
            errors: {}
        },
        errors: []
    });
}), _defineProperty(_handleActions, ActionTypes.UPDATE_EDITING_STATUS, function (state, _ref8) {
    var newPart = _ref8.payload;
    return _extends({}, state, {
        editingStatus: _extends({}, state.editingStatus, newPart)
    });
}), _defineProperty(_handleActions, ActionTypes.TOGGLE_DIALOG_VISIBILITY, function (state, _ref9) {
    var show = _ref9.payload;
    return _extends({}, state, {
        showEditStatusDialog: show
    });
}), _handleActions), initialState);

/***/ }),
/* 1252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reduxActions = __webpack_require__(9);

var _actionTypes = __webpack_require__(1253);

var ActionTypes = _interopRequireWildcard(_actionTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var createReducer = function createReducer(_ref) {
    var _handleActions;

    var _ref$DAR_SETTINGS = _ref.DAR_SETTINGS,
        DAR_SETTINGS = _ref$DAR_SETTINGS === undefined ? {} : _ref$DAR_SETTINGS,
        _ref$GENERAL_SETTINGS = _ref.GENERAL_SETTINGS,
        GENERAL_SETTINGS = _ref$GENERAL_SETTINGS === undefined ? {} : _ref$GENERAL_SETTINGS;

    var darSettings = DAR_SETTINGS || {
        allowUsersToSeeAllTT: false,
        allowRegularUsersToEditTasksStatuses: false,

        usersForSeeAllTTFilter: {
            all: false,
            userIds: [],
            groupIds: [],
            groupType: null
        },

        showUsernameInReports: false,
        hideNotAssignedTTDetails: false,
        hideDetailsOnLockTT: false,
        hideAccountSettingsWhenDisabled: false,
        ttmCanSeeAutoApproved: false
    };

    var darSettingsCollapsedState = _extends({
        allowUsersToSeeAllTTCollapsed: true,
        showUsernameInReportsCollapsed: true,
        hideNotAssignedTTDetailsCollapsed: true,
        hideDetailsOnLockTTCollapsed: true,
        hideAccountSettingsCollapsed: true,
        ttmCanSeeAutoApprovedCollapsed: true
    }, GENERAL_SETTINGS.DAR_SETTINGS_COLLAPSED_STATE);

    var initState = _extends({}, darSettings, darSettingsCollapsedState);

    return (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, ActionTypes.ALLOW_USERS_TO_SEE_ALL_TT_SET, function (state, _ref2) {
        var val = _ref2.payload;
        return _extends({}, state, {
            allowUsersToSeeAllTT: val
        });
    }), _defineProperty(_handleActions, ActionTypes.ALLOW_REGULAR_USERS_TO_EDIT_TASKS_STATUSES, function (state, _ref3) {
        var val = _ref3.payload;
        return _extends({}, state, {
            allowRegularUsersToEditTasksStatuses: val
        });
    }), _defineProperty(_handleActions, ActionTypes.USERS_FOR_SEE_ALL_TT_FILTER_SET, function (state, _ref4) {
        var val = _ref4.payload;
        return _extends({}, state, {
            usersForSeeAllTTFilter: val
        });
    }), _defineProperty(_handleActions, ActionTypes.SHOW_USERNAME_IN_REPORTS_SET, function (state, _ref5) {
        var val = _ref5.payload;
        return _extends({}, state, {
            showUsernameInReports: val
        });
    }), _defineProperty(_handleActions, ActionTypes.HIDE_NOT_ASSIGNED_TT_DETAILS_SET, function (state, _ref6) {
        var val = _ref6.payload;
        return _extends({}, state, {
            hideNotAssignedTTDetails: val
        });
    }), _defineProperty(_handleActions, ActionTypes.HIDE_DETAILS_ON_LOCK_TT_SET, function (state, _ref7) {
        var val = _ref7.payload;
        return _extends({}, state, {
            hideDetailsOnLockTT: val
        });
    }), _defineProperty(_handleActions, ActionTypes.HIDE_ACCOUNT_SETTINGS_WHEN_DISABLED_SET, function (state, _ref8) {
        var val = _ref8.payload;
        return _extends({}, state, {
            hideAccountSettingsWhenDisabled: val
        });
    }), _defineProperty(_handleActions, ActionTypes.TTM_CAN_SEE_AUTO_APPROVED_SET, function (state, _ref9) {
        var val = _ref9.payload;
        return _extends({}, state, {
            ttmCanSeeAutoApproved: val
        });
    }), _defineProperty(_handleActions, ActionTypes.ALLOW_USERS_TO_SEE_ALL_TT_COLLAPSE, function (state, _ref10) {
        var val = _ref10.payload;
        return _extends({}, state, {
            allowUsersToSeeAllTTCollapsed: val
        });
    }), _defineProperty(_handleActions, ActionTypes.ALLOW_REGULAR_USERS_TO_EDIT_TASKS_STATUSES_COLLAPSE, function (state, _ref11) {
        var val = _ref11.payload;
        return _extends({}, state, {
            allowRegularUsersToEditTasksStatusesCollapsed: val
        });
    }), _defineProperty(_handleActions, ActionTypes.SHOW_USERNAME_IN_REPORTS_COLLAPSE, function (state, _ref12) {
        var val = _ref12.payload;
        return _extends({}, state, {
            showUsernameInReportsCollapsed: val
        });
    }), _defineProperty(_handleActions, ActionTypes.HIDE_NOT_ASSIGNED_TT_DETAILS_COLLAPSE, function (state, _ref13) {
        var val = _ref13.payload;
        return _extends({}, state, {
            hideNotAssignedTTDetailsCollapsed: val
        });
    }), _defineProperty(_handleActions, ActionTypes.HIDE_DETAILS_ON_LOCK_TT_COLLAPSE, function (state, _ref14) {
        var val = _ref14.payload;
        return _extends({}, state, {
            hideDetailsOnLockTTCollapsed: val
        });
    }), _defineProperty(_handleActions, ActionTypes.HIDE_ACCOUNT_SETTINGS_COLLAPSE, function (state, _ref15) {
        var val = _ref15.payload;
        return _extends({}, state, {
            hideAccountSettingsCollapsed: val
        });
    }), _defineProperty(_handleActions, ActionTypes.TTM_CAN_SEE_AUTO_APPROVED_COLLAPSE, function (state, _ref16) {
        var val = _ref16.payload;
        return _extends({}, state, {
            ttmCanSeeAutoApprovedCollapsed: val
        });
    }), _handleActions), initState);
};

exports.default = createReducer;

/***/ }),
/* 1253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var USERS_FOR_SEE_ALL_TT_FILTER_SET = exports.USERS_FOR_SEE_ALL_TT_FILTER_SET = 'at/systemSettings/USERS_FOR_SEE_ALL_TT_FILTER_SET';
var ALLOW_USERS_TO_SEE_ALL_TT_SET = exports.ALLOW_USERS_TO_SEE_ALL_TT_SET = 'at/systemSettings/ALLOW_USERS_TO_SEE_ALL_TT_SET';
var ALLOW_REGULAR_USERS_TO_EDIT_TASKS_STATUSES = exports.ALLOW_REGULAR_USERS_TO_EDIT_TASKS_STATUSES = 'at/systemSettings/ALLOW_REGULAR_USERS_TO_EDIT_TASKS_STATUSES';
var SHOW_USERNAME_IN_REPORTS_SET = exports.SHOW_USERNAME_IN_REPORTS_SET = 'at/systemSettings/SHOW_USERNAME_IN_REPORTS_SET';
var HIDE_NOT_ASSIGNED_TT_DETAILS_SET = exports.HIDE_NOT_ASSIGNED_TT_DETAILS_SET = 'at/systemSettings/HIDE_NOT_ASSIGNED_TT_DETAILS_SET';
var HIDE_DETAILS_ON_LOCK_TT_SET = exports.HIDE_DETAILS_ON_LOCK_TT_SET = 'at/systemSettings/HIDE_DETAILS_ON_LOCK_TT_SET';
var HIDE_ACCOUNT_SETTINGS_WHEN_DISABLED_SET = exports.HIDE_ACCOUNT_SETTINGS_WHEN_DISABLED_SET = 'at/systemSettings/HIDE_ACCOUNT_SETTINGS_WHEN_DISABLED_SET';
var TTM_CAN_SEE_AUTO_APPROVED_SET = exports.TTM_CAN_SEE_AUTO_APPROVED_SET = 'at/systemSettings/TTM_CAN_SEE_AUTO_APPROVED_SET';

var ALLOW_USERS_TO_SEE_ALL_TT_COLLAPSE = exports.ALLOW_USERS_TO_SEE_ALL_TT_COLLAPSE = 'at/systemSettings/ALLOW_USERS_TO_SEE_ALL_TT_COLLAPSE';
var ALLOW_REGULAR_USERS_TO_EDIT_TASKS_STATUSES_COLLAPSE = exports.ALLOW_REGULAR_USERS_TO_EDIT_TASKS_STATUSES_COLLAPSE = 'at/systemSettings/ALLOW_REGULAR_USERS_TO_EDIT_TASKS_STATUSES_COLLAPSE';
var SHOW_USERNAME_IN_REPORTS_COLLAPSE = exports.SHOW_USERNAME_IN_REPORTS_COLLAPSE = 'at/systemSettings/SHOW_USERNAME_IN_REPORTS_COLLAPSE';
var HIDE_NOT_ASSIGNED_TT_DETAILS_COLLAPSE = exports.HIDE_NOT_ASSIGNED_TT_DETAILS_COLLAPSE = 'at/systemSettings/HIDE_NOT_ASSIGNED_TT_DETAILS_COLLAPSE';
var HIDE_DETAILS_ON_LOCK_TT_COLLAPSE = exports.HIDE_DETAILS_ON_LOCK_TT_COLLAPSE = 'at/systemSettings/HIDE_DETAILS_ON_LOCK_TT_COLLAPSE';
var HIDE_ACCOUNT_SETTINGS_COLLAPSE = exports.HIDE_ACCOUNT_SETTINGS_COLLAPSE = 'at/systemSettings/HIDE_ACCOUNT_SETTINGS_COLLAPSE';
var TTM_CAN_SEE_AUTO_APPROVED_COLLAPSE = exports.TTM_CAN_SEE_AUTO_APPROVED_COLLAPSE = 'at/systemSettings/TTM_CAN_SEE_AUTO_APPROVED_COLLAPSE';

/***/ }),
/* 1254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _redux = __webpack_require__(7);

var _reducer = __webpack_require__(1255);

var _reducer2 = _interopRequireDefault(_reducer);

var _reducer3 = __webpack_require__(1256);

var _reducer4 = _interopRequireDefault(_reducer3);

var _reducer5 = __webpack_require__(1257);

var _reducer6 = _interopRequireDefault(_reducer5);

var _reducer7 = __webpack_require__(1258);

var _reducer8 = _interopRequireDefault(_reducer7);

var _reducer9 = __webpack_require__(1259);

var _reducer10 = _interopRequireDefault(_reducer9);

var _reducer11 = __webpack_require__(1260);

var _reducer12 = _interopRequireDefault(_reducer11);

var _reducer13 = __webpack_require__(1261);

var _reducer14 = _interopRequireDefault(_reducer13);

var _reducer15 = __webpack_require__(1262);

var _reducer16 = _interopRequireDefault(_reducer15);

var _reducer17 = __webpack_require__(1263);

var _reducer18 = _interopRequireDefault(_reducer17);

var _reducer19 = __webpack_require__(1264);

var _reducer20 = _interopRequireDefault(_reducer19);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var userManagement = function userManagement(initAppData) {
    return (0, _redux.combineReducers)({
        common: (0, _reducer4.default)(initAppData),
        workAssignmentsPanel: _reducer8.default,
        workAssignmentsEditor: _reducer10.default,
        editManagementAssignmentsPanel: _reducer12.default,
        createManagementAssignmentsPanel: _reducer14.default,
        editManagementAssignmentsEditor: _reducer16.default,
        createManagementAssignmentsEditor: _reducer2.default,
        editTeamAssignmentsPanel: _reducer18.default,
        createTeamAssignmentsPanel: _reducer20.default,
        workAssignmentsTab: (0, _reducer6.default)(initAppData)
    });
};

exports.default = userManagement;

/***/ }),
/* 1255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reduxActions = __webpack_require__(9);

var _actionTypes = __webpack_require__(686);

var ActionTypes = _interopRequireWildcard(_actionTypes);

var _reducerGenerator = __webpack_require__(455);

var _reducerGenerator2 = _interopRequireDefault(_reducerGenerator);

var _actionTypes2 = __webpack_require__(104);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var hierarchyAssignmentsEditorReducer = (0, _reducerGenerator2.default)({
    actionTypes: ActionTypes
});

var initialState = _extends({}, hierarchyAssignmentsEditorReducer.initialState, {
    show: false,
    onlyActiveEntities: false
});

var createManagementAssignmentsEditor = (0, _reduxActions.handleActions)(_extends({}, hierarchyAssignmentsEditorReducer.handlers, (_extends2 = {}, _defineProperty(_extends2, ActionTypes.SHOW_SET, function (state, _ref) {
    var show = _ref.payload;
    return _extends({}, state, {
        show: show
    });
}), _defineProperty(_extends2, ActionTypes.ONLY_ACTIVE_ENTITIES_SET, function (state, _ref2) {
    var onlyActiveEntities = _ref2.payload;
    return _extends({}, state, {
        onlyActiveEntities: onlyActiveEntities
    });
}), _defineProperty(_extends2, _actionTypes2.CLOSE_ALL_PANELS, function (state) {
    return _extends({}, state, {
        show: false,
        loading: false,
        loaded: false,
        customersLoaded: false,
        projectsLoaded: false,
        tasksLoaded: false,
        editingUserId: null,
        editingLevel: {
            customerId: null,
            projectId: null
        },
        customerIdsOrder: [],
        projectIdsOrder: [],
        taskIdsOrder: [],
        canManageParentCustomer: false,
        canManageParentProject: false,
        canWorkCustomerIds: {},
        canManageCustomerIds: {},
        canWorkProjectIds: {},
        canManageProjectIds: {},
        canWorkTaskIds: {},
        canManageTaskIds: {},
        projectCountsByCustomers: {},
        taskCountsByCustomers: {},
        taskCountsByProjects: {},
        futureCustomersAssigned: false,
        someCustomersOrLowerAssigned: false,
        allCustomersAssigned: false,
        futureProjectsAssigned: false,
        someProjectsOrLowerAssigned: false,
        allProjectsAssigned: false,
        futureTasksAssigned: false,
        someTasksAssigned: false,
        allTasksAssigned: false,
        changingCustomerAssignments: {},
        changingProjectAssignments: {},
        changingTaskAssignments: {},
        customersSearchOpen: false,
        customersSearchText: '',
        projectsSearchOpen: false,
        projectsSearchText: '',
        tasksSearchOpen: false,
        tasksSearchText: '',
        changingAllAssignments: false,
        viewerCanManageCustomerIds: {},
        viewerCanManageProjectIds: {}
    });
}), _extends2)), initialState);
exports.default = createManagementAssignmentsEditor;

/***/ }),
/* 1256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reduxActions = __webpack_require__(9);

var _actionTypes = __webpack_require__(104);

var ActionTypes = _interopRequireWildcard(_actionTypes);

var _actionTypes2 = __webpack_require__(102);

var EntitiesActionTypes = _interopRequireWildcard(_actionTypes2);

var _atUtils = __webpack_require__(5);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var createReducer = function createReducer(initAppData) {
    var _handleActions;

    var tab = initAppData.USER_MANAGEMENT.ACTIVE_TAB_NUM;
    var initState = {
        activeTab: tab,
        viewerSettings: {
            allowedToManageAccountSettings: false,
            allowedToManageLeaveBalanceSettings: false,
            allowedToManageScope: false,
            assignedUserIds: null,
            hasAccessToScopeOfWork: false,
            hasAccessToUsers: false,
            showAccountSettings: true
        }, // TODO move to global user settings
        licenseCounters: {
            actualCount: 0,
            allowedCount: 0,
            extraUsersCount: 0,
            licenseViolated: false,
            remainingCount: 1
        },
        viewerManagementAssignmentsCounters: {
            customers: 0,
            projects: 0,
            tasks: 0
        },
        usersWithoutApprovers: [],
        userManagementData: {
            activeLeaveTypes: [],
            allUserGroups: [],
            overtimeRateCoefficient: 0,
            decimalSeparator: '.',
            dateFormat: '',
            defaultWorkSchedule: [],
            invertedDaysMap: {},
            weekStartDay: 1,
            permissionsTemplates: [],
            viewerSettings: {
                enabledFeatures: {},
                allowedToManageLeaveBalanceSettings: false,
                allowedToManageScope: false,
                hasAccessToScopeOfWork: false,
                hasAccessToUsers: false,
                allowedToManageAccountSettings: false,
                assignedUserIds: null,
                showAccountSettings: false
            },
            todayInViewerTimeZone: new Date().toJSON(),
            allTimeZoneGroups: [],
            allTimeZoneGroupOffsets: {}
        },
        groupsWithoutApprovers: [],
        usersList: initAppData.USER_MANAGEMENT.USERS_LIST ? (0, _atUtils.arrayToMap)(initAppData.USER_MANAGEMENT.USERS_LIST.list) : {},
        newUsersIdSet: {}
    };

    return (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, ActionTypes.SET_ACTIVE_TAB, function (state, _ref) {
        var tab = _ref.payload;
        return _extends({}, state, {
            activeTab: tab
        });
    }), _defineProperty(_handleActions, ActionTypes.SET_USERS_WITHOUT_APPROVERS, function (state, _ref2) {
        var usersWithoutApprovers = _ref2.payload;
        return _extends({}, state, {
            usersWithoutApprovers: usersWithoutApprovers
        });
    }), _defineProperty(_handleActions, ActionTypes.SET_VIEWER_SETTINGS, function (state, _ref3) {
        var viewerSettings = _ref3.payload;
        return _extends({}, state, {
            viewerSettings: viewerSettings
        });
    }), _defineProperty(_handleActions, ActionTypes.SET_LICENSE_COUNTERS, function (state, _ref4) {
        var licenseCounters = _ref4.payload;
        return _extends({}, state, {
            licenseCounters: licenseCounters
        });
    }), _defineProperty(_handleActions, ActionTypes.SET_NEW_USER_IDS, function (state, _ref5) {
        var newUsersIdSet = _ref5.payload;
        return _extends({}, state, {
            newUsersIdSet: newUsersIdSet
        });
    }), _defineProperty(_handleActions, ActionTypes.ADD_NEW_USER_IDS, function (state, _ref6) {
        var ids = _ref6.payload;
        return _extends({}, state, {
            newUsersIdSet: _extends({}, state.newUsersIdSet, (0, _atUtils.arrayToSet)(ids))
        });
    }), _defineProperty(_handleActions, ActionTypes.SET_VIEWER_MANAGEMENT_ASSIGNMENTS_COUNTERS, function (state, _ref7) {
        var counters = _ref7.payload;
        return _extends({}, state, {
            viewerManagementAssignmentsCounters: counters
        });
    }), _defineProperty(_handleActions, ActionTypes.USERS_LIST_ADD, function (state, _ref8) {
        var users = _ref8.payload;
        return _extends({}, state, {
            usersList: _extends({}, state.usersList, (0, _atUtils.arrayToMap)(users))
        });
    }), _defineProperty(_handleActions, ActionTypes.USERS_LIST_REMOVE, function (state, _ref9) {
        var id = _ref9.payload;
        return _extends({}, state, {
            usersList: (0, _atUtils.filterMapByKey)(state.usersList, id)
        });
    }), _defineProperty(_handleActions, ActionTypes.USERS_LIST_SET, function (state, _ref10) {
        var users = _ref10.payload;
        return _extends({}, state, {
            usersList: (0, _atUtils.arrayToMap)(users)
        });
    }), _defineProperty(_handleActions, ActionTypes.USER_MANAGEMENT_DATA_SET, function (state, _ref11) {
        var userManagementData = _ref11.payload;
        return _extends({}, state, {
            userManagementData: _extends({}, state.userManagementData, userManagementData)
        });
    }), _defineProperty(_handleActions, ActionTypes.USERS_LIST_USER_GROUP_ID_UPDATE, function (state, _ref12) {
        var _ref12$payload = _ref12.payload,
            userId = _ref12$payload.userId,
            userGroupId = _ref12$payload.userGroupId;
        return _extends({}, state, {
            usersList: _extends({}, state.usersList, _defineProperty({}, userId, _extends({}, state.usersList[userId], {
                userGroupId: userGroupId
            })))
        });
    }), _defineProperty(_handleActions, EntitiesActionTypes.USERS_REMOVE, function (state, _ref13) {
        var ids = _ref13.payload;
        return _extends({}, state, {
            newUsersIdSet: (0, _atUtils.filterMapByKeys)(state.newUsersIdSet, ids)
        });
    }), _handleActions), initState);
};

exports.default = createReducer;

/***/ }),
/* 1257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reduxActions = __webpack_require__(9);

var _actionTypes = __webpack_require__(687);

var ActionTypes = _interopRequireWildcard(_actionTypes);

var _constants = __webpack_require__(4);

var _utils = __webpack_require__(688);

var _actionTypes2 = __webpack_require__(102);

var EntitiesActionTypes = _interopRequireWildcard(_actionTypes2);

var _atUtils = __webpack_require__(5);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var WorkAssignmentsFilterValues = _constants.UserManagementConstants.WorkAssignmentsFilter;

var createReducer = function createReducer(_ref) {
    var _handleActions;

    var _ref$USER_MANAGEMENT = _ref.USER_MANAGEMENT,
        USER_MANAGEMENT = _ref$USER_MANAGEMENT === undefined ? {} : _ref$USER_MANAGEMENT;

    var initialSettings = _extends({
        usersFilter: {
            userIds: [],
            groupIds: [],
            groupType: null,
            allSelected: true
        },
        workAssignmentsFilter: WorkAssignmentsFilterValues.ALL,
        sorting: {
            order: _constants.UserManagementConstants.USER_LIST_ORDER_BY_NAME,
            asc: true
        },
        nUsersPerPage: 25
    }, (0, _utils.convertSettingsJsonData)(USER_MANAGEMENT.WA_TAB_SETTINGS));

    var initialState = _extends({
        userIdsOrder: [],
        loaded: false,
        loading: false,
        usersWorkAssignmentsCounters: {},
        newUsersIdSet: {},
        wordsFilter: '',
        submittedWordsFilter: '',
        currentPageNum: 1,
        nTotalUsers: 0
    }, initialSettings);

    return (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, ActionTypes.USER_IDS_ORDER_SET, function (state, _ref2) {
        var userIdsOrder = _ref2.payload;
        return _extends({}, state, {
            userIdsOrder: userIdsOrder
        });
    }), _defineProperty(_handleActions, ActionTypes.LOAD_USERS_DATA, function (state) {
        return _extends({}, state, {
            loading: true
        });
    }), _defineProperty(_handleActions, ActionTypes.SET_LOADING, function (state, _ref3) {
        var isLoading = _ref3.payload;
        return _extends({}, state, {
            loading: isLoading
        });
    }), _defineProperty(_handleActions, ActionTypes.LOAD_USERS_DATA_SUCCESS, function (state, _ref4) {
        var data = _ref4.payload;
        return _extends({}, state, {
            currentPageNum: data.currentPage,
            nTotalUsers: data.nTotalUsers
        });
    }), _defineProperty(_handleActions, ActionTypes.LOAD_USERS_DATA_FAILURE, function (state) {
        return _extends({}, state, {
            loading: false
        });
    }), _defineProperty(_handleActions, ActionTypes.SET_LOADED, function (state, _ref5) {
        var loaded = _ref5.payload;
        return _extends({}, state, {
            loaded: loaded
        });
    }), _defineProperty(_handleActions, ActionTypes.SET_SORTING, function (state, _ref6) {
        var sorting = _ref6.payload;
        return _extends({}, state, {
            sorting: sorting
        });
    }), _defineProperty(_handleActions, ActionTypes.SET_USERS_FILTER, function (state, _ref7) {
        var usersFilter = _ref7.payload;
        return _extends({}, state, {
            usersFilter: usersFilter
        });
    }), _defineProperty(_handleActions, ActionTypes.SET_WORDS_FILTER, function (state, _ref8) {
        var wordsFilter = _ref8.payload;
        return _extends({}, state, {
            wordsFilter: wordsFilter
        });
    }), _defineProperty(_handleActions, ActionTypes.SET_USERS_PER_PAGE, function (state, _ref9) {
        var usersPerPage = _ref9.payload;
        return _extends({}, state, {
            nUsersPerPage: usersPerPage
        });
    }), _defineProperty(_handleActions, ActionTypes.SET_PAGE_NUM, function (state, _ref10) {
        var pageNum = _ref10.payload;
        return _extends({}, state, {
            currentPageNum: pageNum
        });
    }), _defineProperty(_handleActions, ActionTypes.SET_SUBMITTED_WORDS_FILTER, function (state, _ref11) {
        var submittedWordsFilter = _ref11.payload;
        return _extends({}, state, {
            submittedWordsFilter: submittedWordsFilter
        });
    }), _defineProperty(_handleActions, ActionTypes.SET_WORK_ASSIGNMENTS_FILTER, function (state, _ref12) {
        var workAssignmentsFilter = _ref12.payload;
        return _extends({}, state, {
            workAssignmentsFilter: workAssignmentsFilter
        });
    }), _defineProperty(_handleActions, ActionTypes.SET_USER_WORK_ASSIGNMENT_COUNTERS, function (state, _ref13) {
        var userCounters = _ref13.payload;

        var workCounters = state.userWorkAssignmentsCounters;

        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            for (var _iterator = userCounters[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var userCounter = _step.value;

                workCounters[userCounter.id] = userCounter.counters;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }

        return _extends({}, state, {
            userWorkAssignmentsCounters: workCounters
        });
    }), _defineProperty(_handleActions, ActionTypes.SET_USERS_WORK_ASSIGNMENTS_COUNTERS, function (state, _ref14) {
        var usersWorkAssignmentsCounters = _ref14.payload;
        return _extends({}, state, {
            usersWorkAssignmentsCounters: usersWorkAssignmentsCounters
        });
    }), _defineProperty(_handleActions, ActionTypes.ADD_USER_WORK_ASSIGNMENTS_COUNTERS, function (state, _ref15) {
        var additionalAssignments = _ref15.payload;
        return _extends({}, state, {
            usersWorkAssignmentsCounters: _extends({}, state.usersWorkAssignmentsCounters, additionalAssignments)
        });
    }), _defineProperty(_handleActions, EntitiesActionTypes.USERS_REMOVE, function (state, _ref16) {
        var ids = _ref16.payload;
        return _extends({}, state, {
            userIdsOrder: (0, _atUtils.filterArrayByKeys)(state.userIdsOrder, ids)
        });
    }), _handleActions), initialState);
};

exports.default = createReducer;

/***/ }),
/* 1258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reduxActions = __webpack_require__(9);

var _actionTypes = __webpack_require__(689);

var ActionTypes = _interopRequireWildcard(_actionTypes);

var _reducerGenerator = __webpack_require__(345);

var _reducerGenerator2 = _interopRequireDefault(_reducerGenerator);

var _actionTypes2 = __webpack_require__(104);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var hierarchyAssignmentsPanelReducer = (0, _reducerGenerator2.default)({
    actionTypes: ActionTypes
});

var initialState = _extends({}, hierarchyAssignmentsPanelReducer.initialState, {
    copyContent: {
        userId: null,
        loading: false,
        counters: {
            task: 0,
            project: 0,
            customer: 0
        },
        isAllScopeToCopyUserFrom: false,
        selectedOption: null,
        viewerHasEntireScope: true,

        usersForSelector: []
    },
    showCopyContent: false,
    assignAllScopeContent: {
        loading: false,
        show: false
    },
    noCptAssignedToUserAtAll: false
});

var workAssignmentsPanel = (0, _reduxActions.handleActions)(_extends({}, hierarchyAssignmentsPanelReducer.handlers, (_extends2 = {}, _defineProperty(_extends2, ActionTypes.SHOW_COPY_SET, function (state, _ref) {
    var show = _ref.payload;
    return _extends({}, state, {
        showCopyContent: show
    });
}), _defineProperty(_extends2, ActionTypes.COPY_USER_ID_SET, function (state, _ref2) {
    var userId = _ref2.payload;
    return _extends({}, state, {
        copyContent: _extends({}, state.copyContent, {
            userId: userId
        })
    });
}), _defineProperty(_extends2, ActionTypes.COPY_VIEWER_HAS_ENTIRE_SCOPE_SET, function (state, _ref3) {
    var viewerHasEntireScope = _ref3.payload;
    return _extends({}, state, {
        copyContent: _extends({}, state.copyContent, {
            viewerHasEntireScope: viewerHasEntireScope
        })
    });
}), _defineProperty(_extends2, ActionTypes.COPY_LOADING_SET, function (state, _ref4) {
    var loading = _ref4.payload;
    return _extends({}, state, {
        copyContent: _extends({}, state.copyContent, {
            loading: loading
        })
    });
}), _defineProperty(_extends2, ActionTypes.COPY_ALL_SCOPE_SET, function (state, _ref5) {
    var isAllScopeToCopyUserFrom = _ref5.payload;
    return _extends({}, state, {
        copyContent: _extends({}, state.copyContent, {
            isAllScopeToCopyUserFrom: isAllScopeToCopyUserFrom
        })
    });
}), _defineProperty(_extends2, ActionTypes.COPY_COUNTERS_SET, function (state, _ref6) {
    var counters = _ref6.payload;
    return _extends({}, state, {
        copyContent: _extends({}, state.copyContent, {
            counters: counters
        })
    });
}), _defineProperty(_extends2, ActionTypes.COPY_OPTION_SET, function (state, _ref7) {
    var option = _ref7.payload;
    return _extends({}, state, {
        copyContent: _extends({}, state.copyContent, {
            selectedOption: option
        })
    });
}), _defineProperty(_extends2, ActionTypes.COPY_USER_IDS_FOR_SELECTOR_SET, function (state, _ref8) {
    var usersForSelector = _ref8.payload;
    return _extends({}, state, {
        copyContent: _extends({}, state.copyContent, {
            usersForSelector: usersForSelector
        })
    });
}), _defineProperty(_extends2, ActionTypes.COPY_CONTENT_OPEN, function (state) {
    return _extends({}, state, {
        copyContent: {
            userId: null,
            loading: false,
            counters: {
                tasks: 0,
                projects: 0,
                customers: 0
            },
            usersForSelector: [],
            selectedOption: null,
            isAllScopeToCopyUserFrom: false,
            viewerHasEntireScope: true
        },
        showCopyContent: true
    });
}), _defineProperty(_extends2, ActionTypes.COPY_CONTENT_CLOSE, function (state) {
    return _extends({}, state, {
        copyContent: _extends({}, state.copyContent, {
            userId: null,
            selectedOption: null
        }),
        showCopyContent: false
    });
}), _defineProperty(_extends2, ActionTypes.ASSIGN_ALL_SCOPE_CONTENT_OPEN, function (state) {
    return _extends({}, state, {
        assignAllScopeContent: {
            loading: false,
            show: true
        }
    });
}), _defineProperty(_extends2, ActionTypes.ASSIGN_ALL_SCOPE_CONTENT_CLOSE, function (state) {
    return _extends({}, state, {
        assignAllScopeContent: _extends({}, state.assignAllScopeContent, {
            show: false
        })
    });
}), _defineProperty(_extends2, ActionTypes.USER_HAVE_NO_CPT_AT_ALL_SET, function (state, _ref9) {
    var noCptAssignedToUserAtAll = _ref9.payload;
    return _extends({}, state, {
        noCptAssignedToUserAtAll: noCptAssignedToUserAtAll
    });
}), _defineProperty(_extends2, _actionTypes2.CLOSE_ALL_PANELS, function (state) {
    return _extends({}, state, {
        userId: null,
        tab: null,
        copyContent: {
            userId: null,
            loading: false,
            counters: {
                task: 0,
                project: 0,
                customer: 0
            },
            isAllScopeToCopyUserFrom: false,
            selectedOption: null,
            viewerHasEntireScope: true,

            usersForSelector: []
        },
        showCopyContent: false,
        assignAllScopeContent: {
            loading: false,
            show: false
        },
        noCptAssignedToUserAtAll: false
    });
}), _extends2)), initialState);
exports.default = workAssignmentsPanel;

/***/ }),
/* 1259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reduxActions = __webpack_require__(9);

var _actionTypes = __webpack_require__(690);

var ActionTypes = _interopRequireWildcard(_actionTypes);

var _reducerGenerator = __webpack_require__(455);

var _reducerGenerator2 = _interopRequireDefault(_reducerGenerator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var hierarchyAssignmentsEditorReducer = (0, _reducerGenerator2.default)({
    actionTypes: ActionTypes
});

var workAssignmentsEditor = (0, _reduxActions.handleActions)(hierarchyAssignmentsEditorReducer.handlers, hierarchyAssignmentsEditorReducer.initialState);
exports.default = workAssignmentsEditor;

/***/ }),
/* 1260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reduxActions = __webpack_require__(9);

var _actionTypes = __webpack_require__(691);

var ActionTypes = _interopRequireWildcard(_actionTypes);

var _reducerGenerator = __webpack_require__(345);

var _reducerGenerator2 = _interopRequireDefault(_reducerGenerator);

var _actionTypes2 = __webpack_require__(102);

var EntitiesActionTypes = _interopRequireWildcard(_actionTypes2);

var _atUtils = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var hierarchyAssignmentsPanelReducer = (0, _reducerGenerator2.default)({
    actionTypes: ActionTypes
});

var initialState = _extends({}, hierarchyAssignmentsPanelReducer.initialState, {
    showCopyContent: false,
    copyContent: {
        userId: null,
        loading: false,
        counters: {
            task: 0,
            project: 0,
            customer: 0
        },
        usersForSelector: []
    }
});

var managementAssignmentsPanel = (0, _reduxActions.handleActions)(_extends({}, hierarchyAssignmentsPanelReducer.handlers, (_extends2 = {}, _defineProperty(_extends2, ActionTypes.COPY_CONTENT_OPEN, function (state) {
    return _extends({}, state, {
        showCopyContent: true,
        copyContent: _extends({}, state.copyContent, {
            userId: null,
            loading: false,
            counters: {
                tasks: 0,
                projects: 0,
                customers: 0
            }
        })
    });
}), _defineProperty(_extends2, ActionTypes.COPY_CONTENT_CLOSE, function (state) {
    return _extends({}, state, {
        showCopyContent: false
    });
}), _defineProperty(_extends2, ActionTypes.COPY_USER_ID_SET, function (state, _ref) {
    var userId = _ref.payload;
    return _extends({}, state, {
        copyContent: _extends({}, state.copyContent, {
            userId: userId
        })
    });
}), _defineProperty(_extends2, ActionTypes.COPY_LOADING_SET, function (state, _ref2) {
    var loading = _ref2.payload;
    return _extends({}, state, {
        copyContent: _extends({}, state.copyContent, {
            loading: loading
        })
    });
}), _defineProperty(_extends2, ActionTypes.COPY_COUNTERS_SET, function (state, _ref3) {
    var counters = _ref3.payload;
    return _extends({}, state, {
        copyContent: _extends({}, state.copyContent, {
            counters: counters
        })
    });
}), _defineProperty(_extends2, ActionTypes.COPY_USER_IDS_FOR_SELECTOR_SET, function (state, _ref4) {
    var usersForSelector = _ref4.payload;
    return _extends({}, state, {
        copyContent: _extends({}, state.copyContent, {
            usersForSelector: usersForSelector
        })
    });
}), _defineProperty(_extends2, EntitiesActionTypes.USERS_REMOVE, function (state, _ref5) {
    var ids = _ref5.payload;
    return _extends({}, state, {
        copyContent: _extends({}, state.copyContent, {
            usersForSelector: (0, _atUtils.filterArrayByKeys)(state.copyContent.usersForSelector, ids, function (u) {
                return u.id;
            })
        })
    });
}), _extends2)), initialState);

exports.default = managementAssignmentsPanel;

/***/ }),
/* 1261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reduxActions = __webpack_require__(9);

var _actionTypes = __webpack_require__(692);

var ActionTypes = _interopRequireWildcard(_actionTypes);

var _reducerGenerator = __webpack_require__(345);

var _reducerGenerator2 = _interopRequireDefault(_reducerGenerator);

var _actionTypes2 = __webpack_require__(104);

var _actionTypes3 = __webpack_require__(454);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var hierarchyAssignmentsPanelReducer = (0, _reducerGenerator2.default)({
    actionTypes: ActionTypes
});

var initialState = _extends({}, hierarchyAssignmentsPanelReducer.initialState, {
    loaded: true,
    isShown: false,
    allScopeSelected: false
});

var managementAssignmentsPanel = (0, _reduxActions.handleActions)(_extends({}, hierarchyAssignmentsPanelReducer.handlers, (_extends2 = {}, _defineProperty(_extends2, ActionTypes.SHOWN_SET, function (state, _ref) {
    var isShown = _ref.payload;
    return _extends({}, state, { isShown: isShown });
}), _defineProperty(_extends2, ActionTypes.ALL_SCOPE_SET, function (state, _ref2) {
    var allScopeSelected = _ref2.payload;
    return _extends({}, state, { allScopeSelected: allScopeSelected });
}), _defineProperty(_extends2, _actionTypes3.RESET_CREATE_USER_PANEL_STATE, function (state) {
    return _extends({}, state, initialState);
}), _defineProperty(_extends2, _actionTypes2.CLOSE_ALL_PANELS, function (state) {
    return _extends({}, state, {
        isShown: false,
        userId: null,
        tab: null,

        taskIds: [],
        projectIds: [],
        customerIds: [],
        manageTaskIds: {},
        manageProjectIds: {},
        manageCustomerIds: {},

        userCounters: {
            customers: 0,
            projects: 0,
            tasks: 0
        },

        searchString: '',
        isShowArchivedEntities: false
    });
}), _extends2)), initialState);

exports.default = managementAssignmentsPanel;

/***/ }),
/* 1262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reduxActions = __webpack_require__(9);

var _actionTypes = __webpack_require__(693);

var ActionTypes = _interopRequireWildcard(_actionTypes);

var _reducerGenerator = __webpack_require__(455);

var _reducerGenerator2 = _interopRequireDefault(_reducerGenerator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var hierarchyAssignmentsEditorReducer = (0, _reducerGenerator2.default)({
    actionTypes: ActionTypes
});

var initialState = _extends({}, hierarchyAssignmentsEditorReducer.initialState, {
    onlyActiveEntities: true
});

var editManagementAssignmentsEditor = (0, _reduxActions.handleActions)(_extends({}, hierarchyAssignmentsEditorReducer.handlers, (_extends2 = {}, _defineProperty(_extends2, ActionTypes.ONLY_ACTIVE_ENTITIES_SET, function (state, _ref) {
    var onlyActiveEntities = _ref.payload;
    return _extends({}, state, {
        onlyActiveEntities: onlyActiveEntities
    });
}), _defineProperty(_extends2, ActionTypes.ALL_EXISTING_AND_FUTURE_PROJECTS, function (state, _ref2) {
    var futureProjectsAssigned = _ref2.payload;
    return _extends({}, state, {
        futureProjectsAssigned: futureProjectsAssigned
    });
}), _defineProperty(_extends2, ActionTypes.ALL_EXISTING_AND_FUTURE_TASKS, function (state, _ref3) {
    var futureTasksAssigned = _ref3.payload;
    return _extends({}, state, {
        futureTasksAssigned: futureTasksAssigned
    });
}), _extends2)), initialState);
exports.default = editManagementAssignmentsEditor;

/***/ }),
/* 1263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _handleActions;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reduxActions = __webpack_require__(9);

var _actionTypes = __webpack_require__(694);

var ActionTypes = _interopRequireWildcard(_actionTypes);

var _actionTypes2 = __webpack_require__(104);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = {
    userId: null,
    showCopyContent: false,
    copyContent: {
        userId: null,
        loading: false,
        usersForSelector: [],
        userFromAssignedUsers: []
    }
};

exports.default = (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, ActionTypes.TEAM_ASSIGNMENTS_PANEL_USER_ID_SET, function (state, _ref) {
    var userId = _ref.payload;
    return _extends({}, state, {
        userId: userId,
        showCopyContent: false,
        copyContent: {
            userId: null,
            loading: false,
            usersForSelector: [],
            userFromAssignedUsers: []
        }
    });
}), _defineProperty(_handleActions, ActionTypes.COPY_CONTENT_OPEN, function (state) {
    return _extends({}, state, {
        showCopyContent: true,
        copyContent: _extends({}, state.copyContent, {
            userId: null,
            loading: false
        })
    });
}), _defineProperty(_handleActions, ActionTypes.COPY_CONTENT_CLOSE, function (state) {
    return _extends({}, state, {
        showCopyContent: false
    });
}), _defineProperty(_handleActions, ActionTypes.COPY_USER_ID_SET, function (state, _ref2) {
    var userId = _ref2.payload;
    return _extends({}, state, {
        copyContent: _extends({}, state.copyContent, {
            userId: userId
        })
    });
}), _defineProperty(_handleActions, ActionTypes.COPY_LOADING_SET, function (state, _ref3) {
    var loading = _ref3.payload;
    return _extends({}, state, {
        copyContent: _extends({}, state.copyContent, {
            loading: loading
        })
    });
}), _defineProperty(_handleActions, ActionTypes.USER_FROM_ASSIGNED_USERS_SET, function (state, _ref4) {
    var userFromAssignedUsers = _ref4.payload;
    return _extends({}, state, {
        copyContent: _extends({}, state.copyContent, {
            userFromAssignedUsers: userFromAssignedUsers
        })
    });
}), _defineProperty(_handleActions, ActionTypes.COPY_USERS_FOR_SELECTOR_SET, function (state, _ref5) {
    var usersForSelector = _ref5.payload;
    return _extends({}, state, {
        copyContent: _extends({}, state.copyContent, {
            usersForSelector: usersForSelector
        })
    });
}), _defineProperty(_handleActions, _actionTypes2.CLOSE_ALL_PANELS, function (state) {
    return _extends({}, state, {
        userId: null,
        showCopyContent: false,
        copyContent: {
            userId: null,
            loading: false,
            usersForSelector: [],
            userFromAssignedUsers: []
        }
    });
}), _handleActions), initialState);

/***/ }),
/* 1264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _handleActions;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reduxActions = __webpack_require__(9);

var _actionTypes = __webpack_require__(695);

var ActionTypes = _interopRequireWildcard(_actionTypes);

var _actionTypes2 = __webpack_require__(104);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = {
    show: false
};

exports.default = (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, ActionTypes.SHOW_SET, function (state, _ref) {
    var show = _ref.payload;
    return _extends({}, state, {
        show: show
    });
}), _defineProperty(_handleActions, _actionTypes2.CLOSE_ALL_PANELS, function (state) {
    return _extends({}, state, {
        show: false
    });
}), _handleActions), initialState);

/***/ }),
/* 1265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _redux = __webpack_require__(7);

var _reducer = __webpack_require__(1266);

var _reducer2 = _interopRequireDefault(_reducer);

var _reducer3 = __webpack_require__(1267);

var _reducer4 = _interopRequireDefault(_reducer3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
    return (0, _redux.combineReducers)({
        teamList: _reducer4.default,
        cptLists: _reducer2.default
    });
};

/***/ }),
/* 1266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reduxActions = __webpack_require__(9);

var _actionTypes = __webpack_require__(698);

var ActionTypes = _interopRequireWildcard(_actionTypes);

var _reducerGenerator = __webpack_require__(345);

var _reducerGenerator2 = _interopRequireDefault(_reducerGenerator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var hierarchyAssignmentsPanelReducer = (0, _reducerGenerator2.default)({
    actionTypes: ActionTypes
});

var initialState = _extends({}, hierarchyAssignmentsPanelReducer.initialState);

var cptAssignmentsList = (0, _reduxActions.handleActions)(_extends({}, hierarchyAssignmentsPanelReducer.handlers), initialState);

exports.default = cptAssignmentsList;

/***/ }),
/* 1267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _handleActions;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reduxActions = __webpack_require__(9);

var _actionTypes = __webpack_require__(699);

var ActionTypes = _interopRequireWildcard(_actionTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = {
    loading: false,
    needToLoadData: false,
    teamNames: []
};

exports.default = (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, ActionTypes.LOADING_SET, function (state, _ref) {
    var loading = _ref.payload;
    return _extends({}, state, {
        loading: loading
    });
}), _defineProperty(_handleActions, ActionTypes.NEED_TO_LOAD_DATA_SET, function (state, _ref2) {
    var needToLoadData = _ref2.payload;
    return _extends({}, state, {
        needToLoadData: needToLoadData
    });
}), _defineProperty(_handleActions, ActionTypes.TEAM_NAMES_SET, function (state, _ref3) {
    var teamNames = _ref3.payload;
    return _extends({}, state, {
        teamNames: teamNames
    });
}), _handleActions), initialState);

/***/ }),
/* 1268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _redux = __webpack_require__(7);

var _reducer = __webpack_require__(1269);

var _reducer2 = _interopRequireDefault(_reducer);

var _reducer3 = __webpack_require__(1271);

var _reducer4 = _interopRequireDefault(_reducer3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (initAppData) {
    return (0, _redux.combineReducers)({
        dashboard: _reducer2.default,
        authorizationInfo: (0, _reducer4.default)(initAppData)
    });
};

/***/ }),
/* 1269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _redux = __webpack_require__(7);

var _reducer = __webpack_require__(1270);

var _reducer2 = _interopRequireDefault(_reducer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _redux.combineReducers)({
    createReportPopup: _reducer2.default
});

/***/ }),
/* 1270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reduxActions = __webpack_require__(9);

var _actionTypes = __webpack_require__(700);

var ActionTypes = _interopRequireWildcard(_actionTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = {
    tab: null
};

exports.default = (0, _reduxActions.handleActions)(_defineProperty({}, ActionTypes.SELECTED_TAB_SET, function (state, _ref) {
    var tab = _ref.payload;
    return _extends({}, state, {
        tab: tab
    });
}), initialState);

/***/ }),
/* 1271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = createReducer;

var _reduxActions = __webpack_require__(9);

function createReducer(_ref) {
    var _ref$REPORTS = _ref.REPORTS,
        REPORTS = _ref$REPORTS === undefined ? {} : _ref$REPORTS;

    var authorizationInfo = REPORTS.AUTHORIZATION_INFO ? REPORTS.AUTHORIZATION_INFO : {};

    var initialState = {
        allUsersTimeTrackAvailable: !!authorizationInfo.allUsersTimeTrackAvailable,
        overtimeAvailable: !!authorizationInfo.overtimeAvailable
    };

    return (0, _reduxActions.handleActions)({}, initialState);
}

/***/ }),
/* 1272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var USE_LOCKOUT_POLICY_SET = exports.USE_LOCKOUT_POLICY_SET = 'common/systemSettings/USE_LOCKOUT_POLICY_SET';
var LOCKOUT_DURATION_SET = exports.LOCKOUT_DURATION_SET = 'common/systemSettings/LOCKOUT_DURATION_SET';
var LOCKOUT_THRESHOLD_SET = exports.LOCKOUT_THRESHOLD_SET = 'common/systemSettings/LOCKOUT_THRESHOLD_SET';
var LOCKOUT_COUNTER_SET = exports.LOCKOUT_COUNTER_SET = 'common/systemSettings/LOCKOUT_COUNTER_SET';
var LOCKOUT_UNLOCK_ALL_STATUS_SET = exports.LOCKOUT_UNLOCK_ALL_STATUS_SET = 'common/systemSettings/LOCKOUT_UNLOCK_ALL_STATUS_SET';

/***/ }),
/* 1273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var DURATION = exports.DURATION = {
    min: 1,
    max: 1440
};

var THRESHOLD = exports.THRESHOLD = {
    min: 0,
    max: 999
};

var COUNTER = exports.COUNTER = {
    min: 1,
    max: 1440
};

var UNLOCK_ALL_STATUS = exports.UNLOCK_ALL_STATUS = {
    INITIAL: 0,
    IN_PROGRESS: 1,
    SUCCESS: 2
};

/***/ }),
/* 1274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var PASSWORD_MIN_LENGTH_SET = exports.PASSWORD_MIN_LENGTH_SET = 'common/systemSettings/PASSWORD_MIN_LENGTH_SET';
var PASSWORD_MIN_LENGTH_ERROR_SET = exports.PASSWORD_MIN_LENGTH_ERROR_SET = 'common/systemSettings/PASSWORD_MIN_LENGTH_ERROR_SET';
var PASSWORD_STRONGER_FLAG_SET = exports.PASSWORD_STRONGER_FLAG_SET = 'common/systemSettings/PASSWORD_STRONGER_FLAG_SET';
var PASSWORD_REQUIREMENT_SET = exports.PASSWORD_REQUIREMENT_SET = 'common/systemSettings/PASSWORD_REQUIREMENT_SET';

var RESET_STARTED = exports.RESET_STARTED = 'common/systemSettings/RESET_STARTED';
var RESET_COMPLETED = exports.RESET_COMPLETED = 'common/systemSettings/RESET_COMPLETED';
var RESET_FAILED = exports.RESET_FAILED = 'common/systemSettings/RESET_FAILED';

var RESET_RESULT_SET_PASSWORD_NOT_RESET_FOR = exports.RESET_RESULT_SET_PASSWORD_NOT_RESET_FOR = 'common/systemSettings/RESET_RESULT_SET_PASSWORD_NOT_RESET_FOR';

var CURRENT_PASSWORD_SET = exports.CURRENT_PASSWORD_SET = 'common/systemSettings/CURRENT_PASSWORD_SET';
var NEW_PASSWORD_SET = exports.NEW_PASSWORD_SET = 'common/systemSettings/NEW_PASSWORD_SET';
var PASSWORDS_CLEAR = exports.PASSWORDS_CLEAR = 'common/systemSettings/PASSWORDS_CLEAR';
var CURRENT_PASSWORD_INVALID_SET = exports.CURRENT_PASSWORD_INVALID_SET = 'common/systemSettings/CURRENT_PASSWORD_INVALID_SET';
var NEW_PASSWORD_INVALID_SET = exports.NEW_PASSWORD_INVALID_SET = 'common/systemSettings/NEW_PASSWORD_INVALID_SET';
var PASSWORD_VALIDATION_RESULT_SET = exports.PASSWORD_VALIDATION_RESULT_SET = 'common/systemSettings/PASSWORD_VALIDATION_RESULT_SET';

var USER_PASSWORD_MATCHES_PASSWORD_POLICY_SET = exports.USER_PASSWORD_MATCHES_PASSWORD_POLICY_SET = 'common/systemSettings/USER_PASSWORD_MATCHES_PASSWORD_POLICY_SET';

/***/ }),
/* 1275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var SettingsManagement = window.__GENERATED_CONSTANTS__.SettingsManagement;
var NotResetPasswordReason = exports.NotResetPasswordReason = {
    LAST_ADMIN_IN_ACTITIME: SettingsManagement.LAST_ADMIN_IN_ACTITIME,
    LAST_ADMIN_IN_ACTIPLANS: SettingsManagement.LAST_ADMIN_IN_ACTIPLANS
};

var ResetStatus = exports.ResetStatus = {
    Initial: "initial",
    Resetting: "resetting",
    ResettingAndSaving: "resettingAndSaving",
    ResetDone: "resetDone",
    ResetAndSaveDone: "resetAndSaveDone",

    isInProgress: function isInProgress(status) {
        return status === ResetStatus.ResettingAndSaving || status === ResetStatus.Resetting;
    }
};

var SaveStatus = exports.SaveStatus = {
    Initial: "initial",
    Modified: "modified",
    Saved: "saved"
};

/***/ }),
/* 1276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reducerGenerator = __webpack_require__(704);

var _reducerGenerator2 = _interopRequireDefault(_reducerGenerator);

var _actionTypes = __webpack_require__(1278);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createReducer = function createReducer(_ref) {
    var _ref$LOW_BALANCE_SETT = _ref.LOW_BALANCE_SETTINGS,
        LOW_BALANCE_SETTINGS = _ref$LOW_BALANCE_SETT === undefined ? { PTO: {}, SDB: {} } : _ref$LOW_BALANCE_SETT;

    return (0, _reducerGenerator2.default)({
        actions: {
            ENABLED_SET: _actionTypes.SDB_ENABLED_SET,
            MINIMAL_VALUE_SET: _actionTypes.SDB_MINIMAL_VALUE_SET,
            EXCEPTION_USERS_SET: _actionTypes.SDB_EXCEPTION_USERS_SET,
            USER_EXCEPTION_TYPE_SET: _actionTypes.SDB_USER_EXCEPTION_TYPE_SET
        }, initialState: LOW_BALANCE_SETTINGS.SDB
    });
};

exports.default = createReducer;

/***/ }),
/* 1277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var UserExceptionType = exports.UserExceptionType = {
    NoException: "NoException",
    Managers: "Managers",
    SelectedUsers: "SelectedUsers"
};

/***/ }),
/* 1278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var SDB_ENABLED_SET = exports.SDB_ENABLED_SET = "systemSettings/SDB_ENABLED_SET";
var SDB_MINIMAL_VALUE_SET = exports.SDB_MINIMAL_VALUE_SET = "systemSettings/SDB_MINIMAL_VALUE_SET";
var SDB_USER_EXCEPTION_TYPE_SET = exports.SDB_USER_EXCEPTION_TYPE_SET = "systemSettings/SDB_USER_EXCEPTION_TYPE_SET";
var SDB_EXCEPTION_USERS_SET = exports.SDB_EXCEPTION_USERS_SET = "systemSettings/SDB_EXCEPTION_USERS_SET";

/***/ }),
/* 1279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reducerGenerator = __webpack_require__(704);

var _reducerGenerator2 = _interopRequireDefault(_reducerGenerator);

var _actionTypes = __webpack_require__(1280);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createReducer = function createReducer(_ref) {
    var _ref$LOW_BALANCE_SETT = _ref.LOW_BALANCE_SETTINGS,
        LOW_BALANCE_SETTINGS = _ref$LOW_BALANCE_SETT === undefined ? { PTO: {}, SDB: {} } : _ref$LOW_BALANCE_SETT;

    return (0, _reducerGenerator2.default)({
        actions: {
            ENABLED_SET: _actionTypes.PTO_ENABLED_SET,
            MINIMAL_VALUE_SET: _actionTypes.PTO_MINIMAL_VALUE_SET,
            EXCEPTION_USERS_SET: _actionTypes.PTO_EXCEPTION_USERS_SET,
            USER_EXCEPTION_TYPE_SET: _actionTypes.PTO_USER_EXCEPTION_TYPE_SET
        },
        initialState: LOW_BALANCE_SETTINGS.PTO
    });
};

exports.default = createReducer;

/***/ }),
/* 1280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var PTO_ENABLED_SET = exports.PTO_ENABLED_SET = "systemSettings/PTO_ENABLED_SET";
var PTO_MINIMAL_VALUE_SET = exports.PTO_MINIMAL_VALUE_SET = "systemSettings/PTO_MINIMAL_VALUE_SET";
var PTO_USER_EXCEPTION_TYPE_SET = exports.PTO_USER_EXCEPTION_TYPE_SET = "systemSettings/PTO_USER_EXCEPTION_TYPE_SET";
var PTO_EXCEPTION_USERS_SET = exports.PTO_EXCEPTION_USERS_SET = "systemSettings/PTO_EXCEPTION_USERS_SET";

/***/ }),
/* 1281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _handleActions;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reduxActions = __webpack_require__(9);

var _actionTypes = __webpack_require__(709);

var ActionTypes = _interopRequireWildcard(_actionTypes);

var _constants = __webpack_require__(116);

var _atUtils = __webpack_require__(5);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = {
    isShow: false,
    loading: false,
    isShownRemoveAllConfirm: false,
    selectedYear: '',
    sorting: {
        by: _constants.sortBy.DATE,
        asc: false
    },
    isListTransformed: false,
    importedHolidayDates: {},
    hasHolidaysInPast: false,
    loadingHolidays: false
};

exports.default = (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, ActionTypes.HOLIDAYS_LIST_PANEL_SHOWN_SET, function (state) {
    return _extends({}, state, {
        isShow: true
    });
}), _defineProperty(_handleActions, ActionTypes.CLOSE_PANEL, function (state) {
    return _extends({}, state, {
        isShow: false,
        isShownRemoveAllConfirm: false
    });
}), _defineProperty(_handleActions, ActionTypes.REMOVE_ALL_CONFIRMATION_SHOW, function (state) {
    return _extends({}, state, {
        isShownRemoveAllConfirm: true
    });
}), _defineProperty(_handleActions, ActionTypes.REMOVE_ALL_CONFIRMATION_CLOSE, function (state) {
    return _extends({}, state, {
        isShownRemoveAllConfirm: false
    });
}), _defineProperty(_handleActions, ActionTypes.SELECTED_YEAR_SET, function (state, _ref) {
    var selectedYear = _ref.payload;
    return _extends({}, state, {
        selectedYear: selectedYear
    });
}), _defineProperty(_handleActions, ActionTypes.LOAD_DATA, function (state) {
    return _extends({}, state, {
        loading: true
    });
}), _defineProperty(_handleActions, ActionTypes.LOAD_DATA_SUCCESS, function (state) {
    return _extends({}, state, {
        loading: false
    });
}), _defineProperty(_handleActions, ActionTypes.LOAD_DATA_FAILURE, function (state) {
    return _extends({}, state, {
        loading: false
    });
}), _defineProperty(_handleActions, ActionTypes.CHANGE_SORT, function (state, _ref2) {
    var sorting = _ref2.payload;
    return _extends({}, state, {
        sorting: sorting
    });
}), _defineProperty(_handleActions, ActionTypes.LIST_TRANSFORMED_SET, function (state, _ref3) {
    var isListTransformed = _ref3.payload;
    return _extends({}, state, {
        isListTransformed: isListTransformed
    });
}), _defineProperty(_handleActions, ActionTypes.IMPORTED_HOLIDAYS_ADD, function (state, _ref4) {
    var dates = _ref4.payload;
    return _extends({}, state, {
        importedHolidayDates: _extends({}, state.importedHolidayDates, (0, _atUtils.arrayToSet)(dates))
    });
}), _defineProperty(_handleActions, ActionTypes.IMPORTED_HOLIDAYS_REMOVE, function (state, _ref5) {
    var dates = _ref5.payload;
    return _extends({}, state, {
        importedHolidayDates: (0, _atUtils.filterMapByKeys)(state.importedHolidayDates, dates)
    });
}), _defineProperty(_handleActions, ActionTypes.LOAD_HOLIDAYS, function (state) {
    return _extends({}, state, {
        loadingHolidays: true
    });
}), _defineProperty(_handleActions, ActionTypes.LOAD_HOLIDAYS_SUCCESS, function (state, _ref6) {
    var _ref6$payload = _ref6.payload,
        holidays = _ref6$payload.holidays,
        hasHolidaysInPast = _ref6$payload.hasHolidaysInPast;
    return _extends({}, state, {
        holidays: holidays,
        hasHolidaysInPast: hasHolidaysInPast,
        loadingHolidays: true
    });
}), _defineProperty(_handleActions, ActionTypes.LOAD_HOLIDAYS_FAILURE, function (state) {
    return _extends({}, state, {
        loadingHolidays: false
    });
}), _handleActions), initialState);

/***/ }),
/* 1282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _handleActions;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reduxActions = __webpack_require__(9);

var _actionTypes = __webpack_require__(710);

var ActionTypes = _interopRequireWildcard(_actionTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = {
    isShown: false,
    loading: false,
    importProcess: false,
    holidays: [],
    hasHolidaysInPast: false,
    year: '',
    country: '',
    fileName: ''
};

exports.default = (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, ActionTypes.OPEN_PANEL, function (state) {
    return _extends({}, state, {
        isShown: true
    });
}), _defineProperty(_handleActions, ActionTypes.CLOSE_PANEL, function (state) {
    return _extends({}, state, {
        isShown: false
    });
}), _defineProperty(_handleActions, ActionTypes.YEAR_SET, function (state, _ref) {
    var year = _ref.payload;
    return _extends({}, state, {
        year: year
    });
}), _defineProperty(_handleActions, ActionTypes.COUNTRY_SET, function (state, _ref2) {
    var country = _ref2.payload;
    return _extends({}, state, {
        country: country
    });
}), _defineProperty(_handleActions, ActionTypes.HOLIDAYS_SET, function (state, _ref3) {
    var holidays = _ref3.payload;
    return _extends({}, state, {
        holidays: holidays
    });
}), _defineProperty(_handleActions, ActionTypes.HOLIDAYS_IN_PAST_SET, function (state, _ref4) {
    var hasHolidaysInPast = _ref4.payload;
    return _extends({}, state, {
        hasHolidaysInPast: hasHolidaysInPast
    });
}), _defineProperty(_handleActions, ActionTypes.LOAD_DATA, function (state) {
    return _extends({}, state, {
        loading: true
    });
}), _defineProperty(_handleActions, ActionTypes.LOAD_DATA_SUCCESS, function (state, _ref5) {
    var _ref5$payload = _ref5.payload,
        holidays = _ref5$payload.holidays,
        hasHolidaysInPast = _ref5$payload.hasHolidaysInPast,
        _ref5$payload$country = _ref5$payload.country,
        country = _ref5$payload$country === undefined ? null : _ref5$payload$country,
        _ref5$payload$fileNam = _ref5$payload.fileName,
        fileName = _ref5$payload$fileNam === undefined ? null : _ref5$payload$fileNam;
    return _extends({}, state, {
        loading: false,
        holidays: holidays,
        hasHolidaysInPast: hasHolidaysInPast,
        country: country,
        fileName: fileName
    });
}), _defineProperty(_handleActions, ActionTypes.LOAD_DATA_FAILURE, function (state) {
    return _extends({}, state, {
        loading: false,
        isShown: false,
        country: null,
        fileName: null
    });
}), _defineProperty(_handleActions, ActionTypes.IMPORT_HOLIDAYS_START, function (state) {
    return _extends({}, state, {
        importProcess: true
    });
}), _defineProperty(_handleActions, ActionTypes.IMPORT_HOLIDAYS_COMPLETE, function (state) {
    return _extends({}, state, {
        importProcess: false,
        isShown: false
    });
}), _handleActions), initialState);

/***/ }),
/* 1283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.createWorkScheduleReducer = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reduxActions = __webpack_require__(9);

var _actionTypes = __webpack_require__(711);

var ActionTypes = _interopRequireWildcard(_actionTypes);

var _atUtils = __webpack_require__(5);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var createWorkScheduleReducer = exports.createWorkScheduleReducer = function createWorkScheduleReducer() {
    var _handleActions;

    var initialState = {
        firstLoading: true,
        loading: false,
        selectedYear: new Date().getFullYear(),
        defaultWorkSchedules: [],
        corporateDays: {},
        leaveBlackoutDays: {},
        editingDays: {},

        defaultTimeZoneCountry: null,
        countries: [],
        loadingCountries: false
    };

    return (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, ActionTypes.LOAD_DATA, function (state) {
        return _extends({}, state, {
            loading: true
        });
    }), _defineProperty(_handleActions, ActionTypes.LOAD_DATA_SUCCESS, function (state) {
        return _extends({}, state, {
            firstLoading: false,
            loading: false
        });
    }), _defineProperty(_handleActions, ActionTypes.LOADED_DATA_SET, function (state, _ref) {
        var loadedData = _ref.payload;
        return _extends({}, state, {
            defaultWorkSchedules: [].concat(_toConsumableArray(state.defaultWorkSchedules), _toConsumableArray(loadedData.defaultWorkSchedules)),
            corporateDays: _extends({}, state.corporateDays, loadedData.corporateDays),
            leaveBlackoutDays: _extends({}, state.leaveBlackoutDays, loadedData.leaveBlackoutDays)
        });
    }), _defineProperty(_handleActions, ActionTypes.LOAD_DATA_FAILURE, function (state) {
        return _extends({}, state, {
            firstLoading: false
        });
    }), _defineProperty(_handleActions, ActionTypes.EDITING_DAYS_ADD, function (state, _ref2) {
        var day = _ref2.payload;
        return _extends({}, state, {
            editingDays: _extends({}, state.editingDays, _defineProperty({}, day, true))
        });
    }), _defineProperty(_handleActions, ActionTypes.EDITING_DAYS_REMOVE, function (state, _ref3) {
        var day = _ref3.payload;
        return _extends({}, state, {
            editingDays: (0, _atUtils.filterMapByKey)(state.editingDays, day)
        });
    }), _defineProperty(_handleActions, ActionTypes.YEAR_SELECTED, function (state, _ref4) {
        var selectedYear = _ref4.payload;
        return _extends({}, state, {
            selectedYear: selectedYear
        });
    }), _defineProperty(_handleActions, ActionTypes.CORPORATE_DAYS_SET, function (state, _ref5) {
        var corporateDays = _ref5.payload;
        return _extends({}, state, {
            corporateDays: _extends({}, state.corporateDays, corporateDays)
        });
    }), _defineProperty(_handleActions, ActionTypes.LEAVE_BLACKOUT_DAYS_ADD, function (state, _ref6) {
        var blackoutDate = _ref6.payload;

        var year = blackoutDate.getFullYear();
        var month = blackoutDate.getMonth();
        var date = blackoutDate.getDate();
        return _extends({}, state, {
            leaveBlackoutDays: _extends({}, state.leaveBlackoutDays, _defineProperty({}, year, _extends({}, state.leaveBlackoutDays[year], _defineProperty({}, month, _extends({}, state.leaveBlackoutDays[year] ? state.leaveBlackoutDays[year][month] : {}, _defineProperty({}, date, true))))))
        });
    }), _defineProperty(_handleActions, ActionTypes.LEAVE_BLACKOUT_DAYS_REMOVE, function (state, _ref7) {
        var dateToRemove = _ref7.payload;

        var year = dateToRemove.getFullYear();
        var month = dateToRemove.getMonth();
        var date = dateToRemove.getDate();
        return _extends({}, state, {
            leaveBlackoutDays: _extends({}, state.leaveBlackoutDays, _defineProperty({}, year, _extends({}, state.leaveBlackoutDays[year], _defineProperty({}, month, _extends({}, state.leaveBlackoutDays[year][month], _defineProperty({}, date, false))))))
        });
    }), _defineProperty(_handleActions, ActionTypes.DEFAULT_WORK_SCHEDULES_SET, function (state, _ref8) {
        var defaultWorkSchedules = _ref8.payload;
        return _extends({}, state, {
            defaultWorkSchedules: defaultWorkSchedules
        });
    }), _defineProperty(_handleActions, ActionTypes.CORPORATE_DAYS_REMOVE_BY_YEAR, function (state, _ref9) {
        var year = _ref9.payload;
        return _extends({}, state, {
            corporateDays: (0, _atUtils.filterMapByKey)(state.corporateDays, year)
        });
    }), _defineProperty(_handleActions, ActionTypes.CURRENT_COUNTRY_SET, function (state, _ref10) {
        var defaultTimeZoneCountry = _ref10.payload;
        return _extends({}, state, {
            defaultTimeZoneCountry: defaultTimeZoneCountry
        });
    }), _defineProperty(_handleActions, ActionTypes.LOAD_COUNTRIES, function (state) {
        return _extends({}, state, {
            loadingCountries: true
        });
    }), _defineProperty(_handleActions, ActionTypes.LOAD_COUNTRIES_SUCCESS, function (state, _ref11) {
        var _ref11$payload = _ref11.payload,
            defaultTimeZoneCountry = _ref11$payload.defaultTimeZoneCountry,
            countries = _ref11$payload.countries;
        return _extends({}, state, {
            defaultTimeZoneCountry: defaultTimeZoneCountry,
            countries: countries,
            loadingCountries: true
        });
    }), _defineProperty(_handleActions, ActionTypes.LOAD_COUNTRIES_FAILURE, function (state) {
        return _extends({}, state, {
            loadingCountries: false
        });
    }), _handleActions), initialState);
};

/***/ }),
/* 1284 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reduxActions = __webpack_require__(9);

var _actionTypes = __webpack_require__(717);

var ActionTypes = _interopRequireWildcard(_actionTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var createAddonsReducer = function createAddonsReducer(_ref) {
    var _handleActions;

    var _ref$AP_INTEGRATION_A = _ref.AP_INTEGRATION_ACCESS_ENABLED,
        AP_INTEGRATION_ACCESS_ENABLED = _ref$AP_INTEGRATION_A === undefined ? true : _ref$AP_INTEGRATION_A;

    var initialState = {
        isShown: false,
        apIntegrationAccessEnabled: AP_INTEGRATION_ACCESS_ENABLED
    };

    return (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, ActionTypes.ADDONS_MENU_TOGGLE, function (state) {
        return _extends({}, state, {
            isShown: !state.isShown
        });
    }), _defineProperty(_handleActions, ActionTypes.ADDONS_MENU_CLOSE, function (state) {
        return _extends({}, state, {
            isShown: false
        });
    }), _handleActions), initialState);
};

exports.default = createAddonsReducer;

/***/ }),
/* 1285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reduxActions = __webpack_require__(9);

var _actionTypes = __webpack_require__(456);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var createCustomFieldsSelector = function createCustomFieldsSelector() {
    var initialState = {
        items: [],
        isLoaded: false
    };
    return (0, _reduxActions.handleActions)(_defineProperty({}, _actionTypes.CUSTOM_FIELDS_SET, function (state, _ref) {
        var customFields = _ref.payload;
        return _extends({}, state, {
            items: customFields.sort(function (item) {
                return item.builtin ? -1 : 1;
            }),
            isLoaded: true
        });
    }), initialState);
};

exports.default = createCustomFieldsSelector;

/***/ }),
/* 1286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.BaseLoginPageState = BaseLoginPageState;
exports.LoginState = LoginState;
exports.ForgetPasswordState = ForgetPasswordState;
exports.ResetPasswordState = ResetPasswordState;
exports.ErrorState = ErrorState;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*------------------------------------------------- FUNCTIONS -------------------------------------------------*/
/*-------------------------------------------------  PUBLIC  -------------------------------------------------*/

function BaseLoginPageState(config) {
    if (config) {
        this.buttonId = config.buttonId;
        this.progressTextId = config.progressTextId;
        this.inputElementNames = config.inputElementNames;
        this.focusElementName = config.focusElementName;
        this.formId = config.formId;
        this.formContainerId = config.formContainerId;
        this.changeStateLinkId = config.changeStateLinkId;
        this.controller = null;
        this.changeStateLinkContainerId = config.changeStateLinkContainerId;
        this.titleKey = config.titleKey;
    }

    // Protected
    this.timerId = null;
    this.toSubmit = true;
}

BaseLoginPageState.prototype.setController = function (controller) {
    this.controller = controller;
};

BaseLoginPageState.prototype.getDemoTooltip = function () {
    return LoginPage.DEMO_TOOLTIP;
};

BaseLoginPageState.prototype.getNote = function () {
    return null;
};

BaseLoginPageState.prototype.submitForm = function () {
    var controller = this.controller;
    var state = this;
    var form = controller.getForm();
    if (controller.isInProgress()) return;
    controller.toInProgressState();
    this.prepareForSubmit();
    this.doSubmit(form);
    this.timerId = window.setTimeout(function () {
        TransformedScreenMoire.hide();
        state.processError(state.getTimeoutMessage());
    }, LoginPage.BROWSER_TIMEOUT_MINUTES * 60000);
};

/*
 * Performs actions need to be done on page submition
 * NOTE: method need to be overridden be inheritors
 */
BaseLoginPageState.prototype.doSubmit = function (form) {
    // Do nothing by default
};

/*
 * Performs server remote procedure call.
 */
BaseLoginPageState.prototype.makeRemoteCall = function (form, serviceMethodName, processSuccessFunc, processErrorFunc, remoteCall) {
    var state = this;
    try {
        if (!isRpcReady([serviceMethodName])) {
            var func = function func() {
                state.makeRemoteCall(form, serviceMethodName, processSuccessFunc, processErrorFunc, remoteCall);
            };
            window.setTimeout(func, 200);
            return;
        }

        var callback = function callback(result, exception) {
            if (!exception && state.toSubmit) processSuccessFunc.call(state, form, result);else processErrorFunc.call(state, exception);
        };

        remoteCall(callback);
    } catch (e) {
        processErrorFunc.call(state, e);
    }
};

/*
 * Clears form's inputs
 * NOTE: method need to be overridden be inheritors
 */
BaseLoginPageState.prototype.clearInputs = function (form) {
    // Do nothing by default
};

/*
 * Returns page to initial state and shows the error message.
 */
BaseLoginPageState.prototype.processError = function (errorMessage) {
    this.clearServerRequest();
    this.controller.hideServerSideMessages();
    this.controller.printError(errorMessage);
    ClientSideErrors.showClientSideErrorMessage();
};

BaseLoginPageState.prototype.clearServerRequest = function () {
    this.toSubmit = false;
    this.controller.toInitialState();
    window.clearTimeout(this.timerId);
    this.timerId = null;
    this.stopLoad();
};

/*
 * Do some initializations and functions callings to prepare for form submission.
 */
BaseLoginPageState.prototype.prepareForSubmit = function () {
    this.toSubmit = true;
    ClientSideErrors.hideClientSideErrorMessage();
    ClientSideErrors.errorMessageWasShown = false;
};

/*
 * Stops page loading (login action).
 */
BaseLoginPageState.prototype.stopLoad = function () {
    try {
        window.stop();
    } catch (e) {
        // Can be thrown in IE because of window.stop(); statement.
        window.document.execCommand('Stop');
    }
};

//  LoginState section of Login Page Interface
function LoginState(config) {
    BaseLoginPageState.call(this, config);
    this.showAdminManagerTooltip = config.showAdminManagerTooltip;
    this.showPasswordResetTooltip = config.showPasswordResetTooltip;
    this.isDemoMode = config.showPasswordResetTooltip;

    // Private
    this.userPassword = null;
}

LoginState.prototype = new BaseLoginPageState();

LoginState.prototype.getTitle = function () {
    return messageResource.getMessage("login.form.title", [], true);
};

LoginState.prototype.getTooltip = function () {
    var tooltip = "";
    if (this.showPasswordResetTooltip) tooltip += this.getPasswordSuccessfullyResetTooltip();
    if (this.showAdminManagerTooltip) tooltip += this.getAdminManagerTooltip();

    return tooltip;
};

LoginState.prototype.getAdminManagerTooltip = function () {
    return LoginPage.ADMIN_MANAGER_TOOLTIP;
};

LoginState.prototype.getPasswordSuccessfullyResetTooltip = function () {
    this.showPasswordResetTooltip = false;
    return LoginPage.PASSWORD_SUCCESSFULLY_RESET_TOOLTIP;
};

LoginState.prototype.doSubmit = function (form) {
    BaseLoginPageState.prototype.doSubmit.call(this, form);
    this.rememberPassword(form);
    this.doGetChallenge(form);
};

LoginState.prototype.clearInputs = function (form) {
    $(form.elements['pwd']).pVal("");
    $(form.elements['username']).pVal("");
};

//--  PRIVATE methods --
/*
 * Remembers typed by user password and cleans appropriate field.
 */
LoginState.prototype.rememberPassword = function (form) {
    //placeholder IE8 bug workaround
    var pwdInput = form.elements['pwd'][1] || form.elements['pwd'];
    this.userPassword = pwdInput.value;
    form.elements['pwd'].value = "";
};

/*
 * Do GET-request to get challenge anf if challenge has been got calls doLogin() function.
 */
LoginState.prototype.doGetChallenge = function (form) {
    var state = this;
    this.makeRemoteCall(form, 'LoginService.getChallenge', state.doLogin, state.processGetChallengeError, function (callback) {
        jsonrpc.LoginService.getChallenge(callback);
    });
};

LoginState.prototype.processGetChallengeError = function (exception) {
    this.processError(this.getErrorMessage());
};

/*
 * Gets message informing about login failure.
 */
LoginState.prototype.getErrorMessage = function () {
    return messageResource.getMessage("login.failed_to_login", [], true);
};

/*
 * Gets message informing about timeout exceeding.
 */
LoginState.prototype.getTimeoutMessage = function () {
    return messageResource.getMessage("login.timeout_login", [LoginPage.BROWSER_TIMEOUT_MINUTES], true);
};

/*
 * Posts form to login.
 */
LoginState.prototype.doLogin = function (form, result) {
    form.elements['submitted'].value = 1;
    form.elements['password'].value = MD5(MD5(this.userPassword) + result.challengeValue + trim(form.elements['username'].value).toLowerCase());

    this.rewriteJsessionidIfNeeded(form, result.sessionId);

    // hide screen with moire after start login
    TransformedScreenMoire.showAndTransformTo("loginMoire", 1, "1s", "ease-in-out");

    form.submit();
};

/*
 * Rewrites URL jsessionid parameter if URL rewriting is used to keep session. It is needed when session has expired on
 * the server and to login form action should contain right jsessionid parameter.
 */
LoginState.prototype.rewriteJsessionidIfNeeded = function (form, newSessionId) {
    var jsessionidPos = form.action.indexOf("jsessionid");
    if (jsessionidPos >= 0) {
        var formAction = form.action;
        var currentSessionId = formAction.substring(formAction.indexOf("=", jsessionidPos) + 1);

        form.action = formAction.replace(currentSessionId, newSessionId);
    }
};

// --  ForgetPasswordState section of Login Page Interface  --
function ForgetPasswordState(config) {
    BaseLoginPageState.call(this, config);
}

ForgetPasswordState.prototype = new BaseLoginPageState();

ForgetPasswordState.prototype.doSubmit = function (form) {
    BaseLoginPageState.prototype.doSubmit.call(this, form);
    this.doRequestLoginInfo(form);
};

ForgetPasswordState.prototype.clearInputs = function (form) {
    $('#forgetPasswordEmailOrUsername').val("");
    //IE8 jquery.placeholder bug
    $('#forgetPasswordEmailOrUsername').removeClass('placeholder');
};

/*
 * Do request login information to be sent to the user with given username or email address.
 */
ForgetPasswordState.prototype.doRequestLoginInfo = function (form) {
    var state = this;
    if (isAT) {
        this.makeRemoteCall(form, 'ATPasswordRecoveryService.sendLoginInfo', state.doProcessResponse, state.processRequestLoginInfoError, function (callback) {
            var userNameOrEmail = form.elements['forgetPasswordEmailOrUsername'].value;
            jsonrpc.ATPasswordRecoveryService.sendLoginInfo(callback, userNameOrEmail);
        });
    } else {
        this.makeRemoteCall(form, 'APPasswordRecoveryService.sendLoginInfo', state.doProcessResponse, state.processRequestLoginInfoError, function (callback) {
            var userNameOrEmail = form.elements['forgetPasswordEmailOrUsername'].value;
            jsonrpc.APPasswordRecoveryService.sendLoginInfo(callback, userNameOrEmail);
        });
    }
};

ForgetPasswordState.prototype.doProcessResponse = function (form, response) {
    if (response.success) {
        this.clearServerRequest();
        this.controller.hideAllMessages();
        this.controller.printTooltip(this.getSuccessTooltip(response.message));
        this.controller.printNote(response.note);
        this.controller.hideForm();
    } else {
        this.processRequestLoginInfoError(null, response);
    }
};

ForgetPasswordState.prototype.processRequestLoginInfoError = function (exception, response) {
    var controller = this.controller;
    var state = this;
    var errorNote = response === undefined ? state.getErrorNote() : response.note;
    var errorMessage = response === undefined ? state.getErrorMessage() : response.message;
    this.processError(errorMessage);
    window.setTimeout(function () {
        controller.printNote(errorNote);
        controller.printTooltip(null);
    }, 200);
};

ForgetPasswordState.prototype.getTitle = function () {
    return messageResource.getMessage("password_recovery.forgot_your_password", [], true);
};

ForgetPasswordState.prototype.getTooltip = function () {
    return '<div class="plainTextTooltip">' + messageResource.getMessage("password_recovery.forgot_your_password.tooltip", [], true) + '</div>';
};

ForgetPasswordState.prototype.getErrorMessage = function () {
    return messageResource.getMessage("password_recovery.forgot_your_password.send_info.failed", [], true);
};

ForgetPasswordState.prototype.getTimeoutMessage = function () {
    return messageResource.getMessage("password_recovery.forgot_your_password.send_info.timeout", [LoginPage.BROWSER_TIMEOUT_MINUTES], true);
};

ForgetPasswordState.prototype.getErrorNote = function () {
    return messageResource.getMessage("password_recovery.forgot_your_password.send_info.failed.note.without_email");
};

ForgetPasswordState.prototype.getSuccessTooltip = function (message) {
    var noteTemplate = LoginPage.LOGIN_INFO_SUCCESSFULLY_SENT_TOOLTIP;
    return messageResource.applyParamsSubstitutions(noteTemplate, [message], 0);
};

// --  ResetPasswordState section of Login Page Interface  --
function ResetPasswordState(config) {
    BaseLoginPageState.call(this, config);
    this.tooltipText = config.tooltipText;

    if (PASSWORD_ERROR_JSON) {
        this.postponedError = PasswordPolicyManager.getErrorMessage(PASSWORD_ERROR_JSON);
    }

    this.newPassword = null;
    this.newPasswordConfirm = null;
    this.newPasswordText = null;
    this.newPasswordConfirmText = null;
    this.passwordPolicy = PasswordPolicyManager;
}

ResetPasswordState.prototype = new BaseLoginPageState();

ResetPasswordState.prototype.initFieldControllers = function () {
    if (this.newPassword) return;
    this.newPassword = document.getElementById("newPassword");
    this.newPasswordConfirm = document.getElementById("newPasswordConfirm");
    //placeholder IE8 bug workaround
    this.newPasswordText = resetPasswordForm.elements['newPwd'][1] || resetPasswordForm.elements['newPwd'];
    this.newPasswordConfirmText = resetPasswordForm.elements['newPwdConfirm'][1] || resetPasswordForm.elements['newPwdConfirm'];document.getElementById("newPwdConfirm");
};

ResetPasswordState.prototype.doSubmit = function (form) {
    BaseLoginPageState.prototype.doSubmit.call(this, form);
    this.doResetPassword(form);
};

ResetPasswordState.prototype.doResetPassword = function (form) {
    var state = this;

    var submitFunc = function submitFunc() {
        state.initFieldControllers();
        state.verifyPasswords().then(function () {
            state.newPassword.value = state.newPasswordText.value;
            state.newPasswordConfirm.value = state.newPasswordConfirmText.value;
            state.clearInputs(form);
            state.clearServerRequest();
            form.submit();
        }).catch(function (errorMessage) {
            state.processError(errorMessage);
        });
    };
    window.setTimeout(submitFunc, 200);
};

ResetPasswordState.prototype.clearInputs = function (form) {
    form.elements['newPwd'].value = "";
    form.elements['newPwdConfirm'].value = "";
};

ResetPasswordState.prototype.verifyPasswords = function () {
    var _ErrorMessagesMap;

    var password = this.newPasswordText.value;
    var passwordCopy = this.newPasswordConfirmText.value;
    if (!(password.length > 0)) return Promise.reject(messageResource.getMessage("password_recovery.reset_password.password_empty", [], true));

    var ErrorMessagesMap = (_ErrorMessagesMap = {}, _defineProperty(_ErrorMessagesMap, PasswordAsyncValidator.ValidationErrors.PASSWORD_EMPTY, function () {
        return messageResource.getMessage("password_recovery.reset_password.password_empty");
    }), _defineProperty(_ErrorMessagesMap, PasswordAsyncValidator.ValidationErrors.PASSWORD_COPY_EMPTY, function () {
        return messageResource.getMessage("password_recovery.reset_password.password_empty");
    }), _defineProperty(_ErrorMessagesMap, PasswordAsyncValidator.ValidationErrors.PASSWORDS_DO_NOT_MATCH, function () {
        return messageResource.getMessage("password_recovery.reset_password.passwords_do_not_match");
    }), _defineProperty(_ErrorMessagesMap, PasswordAsyncValidator.ValidationErrors.PASSWORD_RESTRICTIONS_VIOLATED, function (json) {
        return PasswordPolicyManager.getErrorMessage(json);
    }), _ErrorMessagesMap);

    return new Promise(function (resolve, reject) {
        getPasswordValidator({
            onValidationEnd: function onValidationEnd(errorCode, json) {
                if (!errorCode) {
                    resolve();
                } else {
                    reject(ErrorMessagesMap[errorCode](json));
                }
            }
        }).setState({ password: password, passwordCopy: passwordCopy });
    });
};

ResetPasswordState.prototype.getTitle = function () {
    return isAT ? messageResource.getMessage("password_recovery.reset_password", [], true) : messageResource.getMessage("actiplans.password_recovery.reset_password", [], true);
};

ResetPasswordState.prototype.newClickTooltip = function () {
    return new PasswordHintTooltip(this.passwordPolicy, { dialogOffsets: { left: 15, top: 0 } });
};

ResetPasswordState.prototype.getTooltip = function () {
    return '<div class="plainTextTooltip">' + this.tooltipText + (this.passwordPolicy.hasPasswordRequirements() ? '<span class="passwordHintLink" id="hover_tooltip">' + messageResource.getMessage('password_recovery.reset_password.password_requirements') + '<span class="img"></span>' + '</span>' : '') + '</div>';
};

ResetPasswordState.prototype.getTimeoutMessage = function () {
    return messageResource.getMessage("password_recovery.reset_password.timeout", [LoginPage.BROWSER_TIMEOUT_MINUTES], true);
};

// --  ErrorState section of Login Page Interface  --
function ErrorState(config) {
    BaseLoginPageState.call(this, config);
    this.message = config.message;
}

ErrorState.prototype = new BaseLoginPageState();

ErrorState.prototype.getTitle = function () {
    return null;
};

ErrorState.prototype.getTooltip = function () {
    return '<div class="errorTooltip">' + this.message + '</div>';
};

ErrorState.prototype.getErrorMessage = function () {
    return message;
};

/***/ }),
/* 1287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.LoginPageController = LoginPageController;
/*------------------------------------------------- CONSTANTS -------------------------------------------------*/
/*
 * Cursor styles constants.
 */
var CURSOR_STYLE_WAIT = "progress";
var CURSOR_STYLE_AUTO = "auto";

/*
 * Page section IDs. It is assumed that login page interface have the following layout:
 * [HEADER]
 * [TOOLTIP]
 * [ERROR MESSAGES]
 * [FORM]
 * [NOTE] (usually a comment for an error a success message on the page)
 * [BACK TO LOGIN PAGE LINK]
 */
var HEADER_CONTAINER_ID = "headerContainer";
var FORM_CONTAINER_ID = "formContainer";
var TOOLTIP_CONTAINER_ID = "tooltipContainer";
var DEMO_TOOLTIP_CONTAINER_ID = "demoTooltipContainer";
var ERROR_MESSAGE_CONTAINER_ID = "errorSpan";
var ERROR_MESSAGES_AREA_ID = "errorMessagesArea";
var NOTE_CONTAINER_ID = "noteContainer";
var CHANGE_STATE_LINK_CONTAINER_ID = "changeStateLinkContainer";
var CLICK_TOOLTIP_ID = "hover_tooltip";

function LoginPageController(state) {
    this.inProgress = false;
    this.pageState = state;
    this.pageState.setController(this);
    this.lastFormContainerId = null;
    this.adminEmailAddress = null;
    this.printTitleDocument();
}

LoginPageController.prototype.changeState = function (state) {
    if (this.isInProgress()) return;
    this.hideAllMessages();
    this.hideForm();
    this.hideChangeStateLink();
    this.pageState = state;
    this.pageState.setController(this);
    this.pageState.clearInputs(this.getForm());
    this.printTitleDocument();
    this.showPageContent();
};

LoginPageController.prototype.toInProgressState = function () {
    this.inProgress = true;
    this.getButton().className = "inProgress";
    this.getProgressText().style.visibility = "visible";
    this.setChangeStateLinkDisabled(true);
    this.setCursorStyle(CURSOR_STYLE_WAIT);
};

LoginPageController.prototype.toInitialState = function () {
    this.getProgressText().style.display = "none";
    this.getButton().className = "initial";
    this.setChangeStateLinkDisabled(false);
    this.inProgress = false;
    this.setCursorStyle(CURSOR_STYLE_AUTO);
};

LoginPageController.prototype.showPageContent = function () {
    this.printTitle();
    this.printTooltip();
    this.printDemoTooltip();
    this.showForm();
    this.printNote();
    this.initInputs();
    this.showChangeStateLink();
    if (this.pageState.postponedError) {
        this.pageState.processError(this.pageState.postponedError);
    }
};

LoginPageController.prototype.printTitleDocument = function () {
    if (this.pageState.titleKey) document.title = messageResource.getMessage(this.pageState.titleKey);else {
        document.title = messageResource.getMessage("login.page.title.login");
    }
};

LoginPageController.prototype.setAdminEmailAddress = function (email) {
    this.adminEmailAddress = email;
};

LoginPageController.prototype.getAdminEmailAddress = function () {
    return this.adminEmailAddress;
};

/*
 * Disables form autocompletion and focuses username field.
 */
LoginPageController.prototype.initInputs = function () {
    var form = this.getForm();
    if (!form) return;
    var controller = this;
    form.autocompletion = "off";
    var enterKeyHandler = function enterKeyHandler(evt) {
        if (window.event) evt = window.event;
        if (evt.keyCode == 13) {
            controller.submitForm(form);
            return false;
        }
    };

    var inputNames = this.getInputNames();

    for (var i = 0; i < inputNames.length; i++) {
        form[inputNames[i]].onkeypress = enterKeyHandler;
    }form[this.getFocusElementName()].focus();
};

LoginPageController.prototype.isInProgress = function () {
    return this.inProgress;
};

LoginPageController.prototype.printTitle = function (title) {
    this.printSection(HEADER_CONTAINER_ID, title === undefined ? this.pageState.getTitle() : title);
};

LoginPageController.prototype.printError = function (errorText) {
    this.printSection(ERROR_MESSAGE_CONTAINER_ID, errorText);
    var messagesArea = document.getElementById(ERROR_MESSAGES_AREA_ID);
    if (errorText) this.showErrorsArea();else this.hideErrorsArea();
};

LoginPageController.prototype.printTooltip = function (message) {
    var _this = this;

    this.printSection(TOOLTIP_CONTAINER_ID, message === undefined ? this.pageState.getTooltip() : message);
    var clickTooltipEl = document.getElementById(CLICK_TOOLTIP_ID);
    if (clickTooltipEl) {
        $(clickTooltipEl).click(function () {
            _this.pageState.newClickTooltip().init($("#" + TOOLTIP_CONTAINER_ID)).showAt($(clickTooltipEl), { my: "left center", at: "right center" });
        });
    }
};

LoginPageController.prototype.printDemoTooltip = function () {
    this.printSection(DEMO_TOOLTIP_CONTAINER_ID, this.pageState.getDemoTooltip());
};

LoginPageController.prototype.printNote = function (message) {
    var note = message === undefined ? this.pageState.getNote() : message;
    this.printSection(NOTE_CONTAINER_ID, note);
};

LoginPageController.prototype.getForm = function () {
    return this.pageState.formId ? document.getElementById(this.pageState.formId) : null;
};

LoginPageController.prototype.showChangeStateLink = function () {
    if (this.pageState.changeStateLinkContainerId) document.getElementById(this.pageState.changeStateLinkContainerId).style.display = "";
};

LoginPageController.prototype.hideChangeStateLink = function () {
    if (this.pageState.changeStateLinkContainerId) document.getElementById(this.pageState.changeStateLinkContainerId).style.display = "none";
};

LoginPageController.prototype.showForm = function () {
    if (this.pageState.formContainerId) document.getElementById(this.pageState.formContainerId).style.display = "";
};

LoginPageController.prototype.hideForm = function () {
    this.lastFormContainerId = this.pageState.formContainerId;
    if (this.pageState.formContainerId) document.getElementById(this.pageState.formContainerId).style.display = "none";
};

LoginPageController.prototype.printSection = function (containerId, innerHTML) {
    var container = document.getElementById(containerId);
    if (container && innerHTML) {
        container.innerHTML = innerHTML;
        container.style.display = "";
    } else if (container) container.style.display = "none";
};

LoginPageController.prototype.submitForm = function (form) {
    this.pageState.submitForm(form);
};

LoginPageController.prototype.getButton = function () {
    return document.getElementById(this.pageState.buttonId);
};

LoginPageController.prototype.getProgressText = function () {
    return document.getElementById(this.pageState.progressTextId);
};

LoginPageController.prototype.getChangeStateLink = function () {
    return document.getElementById(this.pageState.changeStateLinkId);
};

LoginPageController.prototype.getInputNames = function () {
    return this.pageState.inputElementNames;
};

LoginPageController.prototype.getFocusElementName = function () {
    return this.pageState.focusElementName;
};

/*
 * Hides server side messages. Called before client side messages showing.
 */
LoginPageController.prototype.hideServerSideMessages = function () {
    var serverSideMessages = document.getElementById("MessagesTable");
    var serverSideErrorMessages = document.getElementById("ErrorsTable");

    if (serverSideMessages != null) {
        serverSideMessages.style.display = "none";
    }
    if (serverSideErrorMessages != null) {
        serverSideErrorMessages.style.display = "none";
    }
};

LoginPageController.prototype.hideClientSideMessages = function () {
    var clientSideErrorMessages = document.getElementById("ClientSideErrorMessage");

    if (clientSideErrorMessages != null) {
        clientSideErrorMessages.style.display = "none";
    }
};

LoginPageController.prototype.showErrorsArea = function () {
    document.getElementById(ERROR_MESSAGES_AREA_ID).style.display = "";
};

LoginPageController.prototype.hideErrorsArea = function (errorText) {
    document.getElementById(ERROR_MESSAGES_AREA_ID).style.display = "none";
};

LoginPageController.prototype.hideAllMessages = function () {
    this.hideServerSideMessages();
    this.hideClientSideMessages();
    this.hideErrorsArea();
};

/*
 * Sets cursor style (see corresponding constants).
 */
LoginPageController.prototype.setCursorStyle = function (cursorStyle) {
    document.body.style.cursor = cursorStyle;
};

LoginPageController.prototype.setChangeStateLinkDisabled = function (isDisabled) {
    var link = this.getChangeStateLink();
    if (!link) return;

    var linkDisabledClass = "disabledLink";
    if (isDisabled) addClass(link, linkDisabledClass);else removeClass(link, linkDisabledClass);
};

/***/ }),
/* 1288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ActivationPageController;

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _PasswordHintTooltip = __webpack_require__(457);

var _PasswordHintTooltip2 = _interopRequireDefault(_PasswordHintTooltip);

var _PasswordPolicyManager = __webpack_require__(227);

var _PasswordPolicyManager2 = _interopRequireDefault(_PasswordPolicyManager);

var _PasswordAsyncValidator = __webpack_require__(280);

var _PasswordAsyncValidator2 = _interopRequireDefault(_PasswordAsyncValidator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ActivationPageController() {}

ActivationPageController.prototype.init = function () {
    var _this = this;

    this.form = document.getElementById("activationForm");

    this.newPasswordText = document.getElementById("newPwd");
    this.newPasswordConfirmText = document.getElementById("newPwdConfirm");
    this.newPasswordField = document.getElementById("newPassword");

    this.errorMessagesArea = (0, _jquery2.default)("#errorMessagesArea");
    this.whiteBoxBody = (0, _jquery2.default)("#whiteBoxWithLogoBody");

    (0, _jquery2.default)(this.newPasswordText).attr('placeholder', _messageResource2.default.getMessage("activation_page.password_field.placeholder")).placeholder();
    (0, _jquery2.default)(this.newPasswordConfirmText).attr('placeholder', _messageResource2.default.getMessage("activation_page.confirm_password_field.placeholder")).placeholder();

    this.activationButton = (0, _jquery2.default)("#activationButton");
    this.activationButton.click(function () {
        return _this.submitForm();
    });

    (0, _jquery2.default)(this.newPasswordText).keyup(function () {
        return _this.hideError();
    });
    (0, _jquery2.default)(this.newPasswordConfirmText).keyup(function () {
        return _this.hideError();
    });

    var passwordHint = new _PasswordHintTooltip2.default(_PasswordPolicyManager2.default, { dialogOffsets: { left: 15, top: 0 } }).init((0, _jquery2.default)("#tooltipContainer"));
    var passwordHintLink = (0, _jquery2.default)(".passwordHintLink");
    passwordHintLink.click(function () {
        passwordHint.showAt(passwordHintLink, { my: "left center", at: "right center" });
    });
    this.passwordValidator = (0, _PasswordAsyncValidator.getPasswordValidator)({
        onValidationStart: this.onValidationStart.bind(this),
        onValidationEnd: this.onValidationEnd.bind(this)
    });

    return this;
};

ActivationPageController.prototype.setPasswordErrorJson = function (json) {
    if (json) {
        this.showError(_PasswordPolicyManager2.default.getErrorMessage(json));
    }
};

ActivationPageController.prototype.submitForm = function () {
    if (this.inProgress) return;
    this.validate();
};

ActivationPageController.prototype.clearInputs = function () {
    (0, _jquery2.default)(this.newPasswordText).pVal("");
    (0, _jquery2.default)(this.newPasswordConfirmText).pVal("");
};

ActivationPageController.prototype.onValidationStart = function () {
    this.setInProgressState();
};

ActivationPageController.prototype.onValidationEnd = function (errorCode, validationResultJson) {
    if (errorCode) {
        this.setNormalState();
        switch (errorCode) {
            case _PasswordAsyncValidator2.default.ValidationErrors.PASSWORD_EMPTY:
                this.showError(_messageResource2.default.getMessage("activation_page.error.password_empty", [], true));
                break;
            case _PasswordAsyncValidator2.default.ValidationErrors.PASSWORD_COPY_EMPTY:
            case _PasswordAsyncValidator2.default.ValidationErrors.PASSWORDS_DO_NOT_MATCH:
                this.showError(_messageResource2.default.getMessage("activation_page.error.passwords_do_not_match", [], true));
                break;
            case _PasswordAsyncValidator2.default.ValidationErrors.PASSWORD_RESTRICTIONS_VIOLATED:
                this.setPasswordErrorJson(validationResultJson);
                break;
            default:
                console.error("Unprocessed error code:", errorCode);
        }
    } else {
        this.newPasswordField.value = (0, _jquery2.default)(this.newPasswordText).pVal();
        this.clearInputs();
        this.form.submit();
    }
};

ActivationPageController.prototype.validate = function () {
    var password = (0, _jquery2.default)(this.newPasswordText).pVal();
    var passwordCopy = (0, _jquery2.default)(this.newPasswordConfirmText).pVal();
    this.hideError();
    this.passwordValidator.setState({
        password: password, passwordCopy: passwordCopy, forcePasswordCheck: true
    });
};

ActivationPageController.prototype.showError = function (errorMessage) {
    this.errorMessagesArea.find("#errorSpan").html(errorMessage);
    this.errorMessagesArea.show();
};

ActivationPageController.prototype.hideError = function () {
    this.errorMessagesArea.hide();
};

ActivationPageController.prototype.setInProgressState = function () {
    this.inProgress = true;
    this.whiteBoxBody.addClass("inProgress");
};

ActivationPageController.prototype.setNormalState = function () {
    this.inProgress = false;
    this.whiteBoxBody.removeClass("inProgress");
};

/***/ }),
/* 1289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isNumber = exports.isChar = exports.isPageDown = exports.isPageUp = exports.isDel = exports.isSpace = exports.isTab = exports.isDown = exports.isUp = exports.isEnter = exports.isEsc = undefined;

var _keyCodes = __webpack_require__(66);

var KeyCodes = _interopRequireWildcard(_keyCodes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var isEsc = exports.isEsc = function isEsc(code) {
  return code === KeyCodes.KEY_CODE_ESC;
};
var isEnter = exports.isEnter = function isEnter(code) {
  return code === KeyCodes.KEY_CODE_ENTER;
};
var isUp = exports.isUp = function isUp(code) {
  return code === KeyCodes.KEY_CODE_UP;
};
var isDown = exports.isDown = function isDown(code) {
  return code === KeyCodes.KEY_CODE_DOWN;
};
var isTab = exports.isTab = function isTab(code) {
  return code === KeyCodes.KEY_CODE_TAB;
};
var isSpace = exports.isSpace = function isSpace(code) {
  return code === KeyCodes.KEY_CODE_SPACE;
};
var isDel = exports.isDel = function isDel(code) {
  return code === KeyCodes.KEY_CODE_DEL;
};
var isPageUp = exports.isPageUp = function isPageUp(code) {
  return KeyCodes.KEY_CODE_PAGE_UP;
};
var isPageDown = exports.isPageDown = function isPageDown(code) {
  return KeyCodes.KEY_CODE_PAGE_DOWN;
};

var isChar = exports.isChar = function isChar(code) {
  return code >= 65 && code < 91;
};

var isNumber = exports.isNumber = function isNumber(code) {
  return code >= 48 && code < 58;
};

exports.default = {
  isEsc: isEsc,
  isUp: isUp,
  isDown: isDown,
  isTab: isTab,
  isEnter: isEnter,
  isSpace: isSpace,
  isDel: isDel,
  isPageUp: isPageUp,
  isPageDown: isPageDown,
  isChar: isChar,
  isNumber: isNumber
};

/***/ }),
/* 1290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var isCtrlPressed = exports.isCtrlPressed = function isCtrlPressed(e) {
  return e.ctrlKey === true;
};
var isShiftPressed = exports.isShiftPressed = function isShiftPressed(e) {
  return e.shiftKey === true;
};
var isAltPressed = exports.isAltPressed = function isAltPressed(e) {
  return e.altKey === true;
};
var isMetaPressed = exports.isMetaPressed = function isMetaPressed(e) {
  return e.metaKey === true;
};

/***/ }),
/* 1291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _HandlersStack = __webpack_require__(718);

var _HandlersStack2 = _interopRequireDefault(_HandlersStack);

var _constants = __webpack_require__(719);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _addEventHandler = function _addEventHandler(event) {
  document.addEventListener(event, function (e) {
    var nextHandler = _HandlersStack2.default.getHandlersIterator(event);
    var next = nextHandler();
    while (next !== null) {
      var handled = next(e.keyCode, e);
      if (handled === true) {
        break;
      }
      next = nextHandler();
    }
  });
};

var initDomHelper = function initDomHelper() {
  _addEventHandler(_constants.EVENTS.KEY_PRESS);
  _addEventHandler(_constants.EVENTS.KEY_UP);
  _addEventHandler(_constants.EVENTS.KEY_DOWN);
};

var initialized = false;

exports.default = function () {
  if (!initialized) {
    initDomHelper();
  }
};

/***/ }),
/* 1292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _SimpleSingletonTooltip = __webpack_require__(45);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Renders list of password requirements
 */
var PasswordHint = function (_TemplateView) {
    _inherits(PasswordHint, _TemplateView);

    function PasswordHint(_ref) {
        var policyManager = _ref.policyManager,
            _ref$validatorId = _ref.validatorId,
            validatorId = _ref$validatorId === undefined ? undefined : _ref$validatorId;

        _classCallCheck(this, PasswordHint);

        var _this = _possibleConstructorReturn(this, (PasswordHint.__proto__ || Object.getPrototypeOf(PasswordHint)).call(this));

        _this.policyManager = policyManager;
        if (validatorId === undefined) {
            _this.getTipsArray = policyManager.getPasswordTips.bind(policyManager);
        } else {
            _this.getTipsArray = policyManager.getPasswordTipsFor.bind(policyManager, validatorId);
        }
        return _this;
    }

    _createClass(PasswordHint, [{
        key: 'useUnderscoreTemplate',
        value: function useUnderscoreTemplate() {
            return false;
        }
    }, {
        key: 'templateHtml',
        value: function templateHtml() {
            //grishin: I do not think that usage of underscore template's <% _.forEach ... %> is better than string concat.
            return "<ul class='passwordHint'>" + this.getTipsArray().map(function (tip) {
                return "<li>" + tip + "</li>";
            }).join("") + "</ul>";
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            if (this.policyManager.hasSpecialCharacter()) {
                var $specialCharacter = this.find('.specialCharacter');
                (0, _SimpleSingletonTooltip.getInstance)().subscribeToMouseEvents($specialCharacter, function () {
                    (0, _SimpleSingletonTooltip.getInstance)().setState({
                        text: _messageResource2.default.getMessage('password_validation.characters.special.hint.tooltip'),
                        extraClass: 'specialCharacterTooltip'
                    });
                });
            }
        }
    }]);

    return PasswordHint;
}(_TemplateView3.default);

exports.default = PasswordHint;

/***/ }),
/* 1293 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
            value: true
});

exports.default = function (cb) {
            return raf.call(window, cb);
};

var raf = window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || function (callback) {
            window.setTimeout(callback, 1000 / 60);
};

/***/ }),
/* 1294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CharsValidator = exports.LengthValidator = undefined;

var _CharsValidator$RuleT;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _PasswordSettings = __webpack_require__(279);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _toArray(arr) { return Array.isArray(arr) ? arr : Array.from(arr); }

function _addTips(tips, settings, rule, tipFn) {
    if ((0, _PasswordSettings.hasRuleId)(settings, rule)) {
        var _tipFn = tipFn(),
            _tipFn2 = _toArray(_tipFn),
            key = _tipFn2[0],
            params = _tipFn2.slice(1);

        tips.push(_messageResource2.default.getMessage(key, params));
    }
}

var LengthValidator = exports.LengthValidator = function () {
    function LengthValidator() {
        _classCallCheck(this, LengthValidator);
    }

    _createClass(LengthValidator, null, [{
        key: 'addTips',
        value: function addTips(tips, settings) {
            _addTips(tips, settings, _PasswordSettings.PasswordValidatorId.LENGTH_VALIDATOR, function () {
                return ["password_validation.length.hint", settings.minimalLength];
            });
        }
    }, {
        key: 'addMessage',
        value: function addMessage(messages, violatedRules, settings) {
            if (violatedRules.has(_PasswordSettings.PasswordValidatorId.LENGTH_VALIDATOR)) {
                messages.push(_messageResource2.default.getMessage("password_validation.length", [settings.minimalLength]));
            }
        }
    }]);

    return LengthValidator;
}();

var CharsValidator = exports.CharsValidator = function () {
    function CharsValidator() {
        _classCallCheck(this, CharsValidator);
    }

    _createClass(CharsValidator, null, [{
        key: 'addTips',
        value: function addTips(tips, settings) {
            _addTips(tips, settings, _PasswordSettings.PasswordValidatorId.UPPERCASE_VALIDATOR, function () {
                return ["password_validation.characters.uppercase.hint"];
            });
            _addTips(tips, settings, _PasswordSettings.PasswordValidatorId.LOWERCASE_VALIDATOR, function () {
                return ["password_validation.characters.lowercase.hint"];
            });
            _addTips(tips, settings, _PasswordSettings.PasswordValidatorId.NUMBER_VALIDATOR, function () {
                return ["password_validation.characters.number.hint"];
            });
            _addTips(tips, settings, _PasswordSettings.PasswordValidatorId.SPECIAL_VALIDATOR, function () {
                return ["password_validation.characters.special.hint"];
            });
        }
    }, {
        key: 'addMessage',
        value: function addMessage(messages, violatedRules, settings) {
            var _this = this;

            var reallyViolated = new Set();
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = this.MyRules[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var rule = _step.value;

                    if (violatedRules.has(rule)) {
                        reallyViolated.add(rule);
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            if (reallyViolated.size) {
                var template = CharsValidator.MessageTemplates[reallyViolated.size];
                var params = [].concat(_toConsumableArray(reallyViolated)).map(function (rule) {
                    return _this.RuleToName[rule];
                }).map(function (name) {
                    return _messageResource2.default.getMessage(name);
                });
                messages.push(_messageResource2.default.getMessage(template, params));
            }
        }
    }]);

    return CharsValidator;
}();

CharsValidator.RuleToName = (_CharsValidator$RuleT = {}, _defineProperty(_CharsValidator$RuleT, _PasswordSettings.PasswordValidatorId.UPPERCASE_VALIDATOR, "password_validation.characters.uppercase"), _defineProperty(_CharsValidator$RuleT, _PasswordSettings.PasswordValidatorId.LOWERCASE_VALIDATOR, "password_validation.characters.lowercase"), _defineProperty(_CharsValidator$RuleT, _PasswordSettings.PasswordValidatorId.NUMBER_VALIDATOR, "password_validation.characters.number"), _defineProperty(_CharsValidator$RuleT, _PasswordSettings.PasswordValidatorId.SPECIAL_VALIDATOR, "password_validation.characters.special"), _CharsValidator$RuleT);
CharsValidator.MyRules = new Set(Object.keys(CharsValidator.RuleToName));
CharsValidator.MessageTemplates = {
    1: "password_validation.characters.1",
    2: "password_validation.characters.2",
    3: "password_validation.characters.3",
    4: "password_validation.characters.4"
};
exports.default = [LengthValidator, CharsValidator];

/***/ }),
/* 1295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _atBrowserUtils = __webpack_require__(8);

function ClientSideErrors() {}

ClientSideErrors.errorHighlightColor = "#ff2000";
ClientSideErrors.errorMessageWasShown = false;
ClientSideErrors.canSetInvalidFieldInFocus = true;
ClientSideErrors.isFocusingFirstFieldOnErrorEnabled = false;

ClientSideErrors.markTextFieldAsInvalid = function (field, errorTitle, errorClass) {
    ClientSideErrors.paintElementAsInvalid(field, errorTitle, errorClass);
    ClientSideErrors.registerFieldError(field.name);
    ClientSideErrors.setInvalidFieldInFocus(field);
};

/*
 * Marks the specified select control as invalid. To do it the select should be nested in SPAN tag. Function adds red
 * border to this SPAN and adds error tooltip to the select control.
 */
ClientSideErrors.markSelectFieldAsInvalid = function (field, errorTitle, dontChangeParentWidth) {
    if (!dontChangeParentWidth) field.parentNode.style.width = field.clientWidth + 4;

    ClientSideErrors.paintElementAsInvalid(field.parentNode, errorTitle);
    ClientSideErrors.registerFieldError(field.name);
    ClientSideErrors.setInvalidFieldInFocus(field);
};

ClientSideErrors.paintElementAsInvalid = function (field, errorTitle, errorClass) {
    if (field) {
        field.style.borderColor = ClientSideErrors.errorHighlightColor;
        field.style.borderStyle = "solid";
        field.style.borderWidth = "2px";
        field.title = errorTitle;
        field.style.color = '';
        if (errorClass) (0, _atBrowserUtils.addClass)(field, errorClass);
    }
};

/**
 * @param keepBorderColor - specifies color to set at element border.
 */
ClientSideErrors.paintElementAsValid = function (field, keepBorderColor, errorClass) {
    if (field) {
        if (keepBorderColor != undefined) {
            field.style.borderColor = keepBorderColor;
        } else {
            field.style.borderColor = "";
            field.style.borderStyle = "";
            field.style.borderWidth = "";
        }
        field.title = '';
        if (errorClass) (0, _atBrowserUtils.removeClass)(field, errorClass);
    }
};

ClientSideErrors.markTextFieldAsValid = function (field, errorClass) {
    if (field) {
        if (!fieldErrors[field.name]) return;
        ClientSideErrors.paintElementAsValid(field, null, errorClass);
        ClientSideErrors.unregisterFieldError(field.name);
    }
};

/*
 * Marks the specified select control as valid. For additional information see ClientSideErrors.markSelectFieldAsInvalid.
 *
 * @param keepBorder - specifies color to set at element border.
 */
ClientSideErrors.markSelectFieldAsValid = function (field, keepBorderColor) {
    if (field) {
        if (!fieldErrors[field.name]) return;
        ClientSideErrors.paintElementAsValid(field.parentNode, keepBorderColor);
        ClientSideErrors.unregisterFieldError(field.name);
    }
};

ClientSideErrors.registerFieldError = function (fieldName) {
    fieldErrors[fieldName] = true;
};

ClientSideErrors.unregisterFieldError = function (fieldName) {
    if (fieldErrors[fieldName]) delete fieldErrors[fieldName];
};

ClientSideErrors.showClientSideErrorMessage = function (useDisplayNoneStyle) {
    ClientSideErrors.hideClientSideErrorMessage(useDisplayNoneStyle);
    window.setTimeout(function () {
        ClientSideErrors.displayClientSideErrorMessage(useDisplayNoneStyle);
    }, 200);
    window.scrollTo(0, 0);
};

ClientSideErrors.getElement = function () {
    return document.getElementById("ClientSideErrorMessage");
};

ClientSideErrors.displayClientSideErrorMessage = function (useDisplayNoneStyle) {
    if (ClientSideErrors.errorMessageWasShown) {
        ClientSideErrors.getElement().style.visibility = "visible";
        if (useDisplayNoneStyle) ClientSideErrors.getElement().style.display = "block";
    } else {
        ClientSideErrors.getElement().style.display = "block";
        ClientSideErrors.getElement().style.visibility = "visible";
        ClientSideErrors.errorMessageWasShown = true;
    }
    if (ClientSideErrors.onDisplay) {
        ClientSideErrors.onDisplay();
    }
};

ClientSideErrors.hideClientSideErrorMessage = function (useDisplayNoneStyle) {
    if (ClientSideErrors.errorMessageWasShown) {
        ClientSideErrors.getElement().style.visibility = "hidden";
        if (useDisplayNoneStyle) ClientSideErrors.getElement().style.display = "none";
    }
    ClientSideErrors.canSetInvalidFieldInFocus = true;
};

ClientSideErrors.hideClientSideErrorMessageIfNoErrors = function (useDisplayNoneStyle) {
    if (!ClientSideErrors.hasErrors()) ClientSideErrors.hideClientSideErrorMessage(useDisplayNoneStyle);
};

ClientSideErrors.hasErrors = function () {
    var count = 0;
    for (var i in fieldErrors) {
        count++;
    }return count > 0;
};

/*
 * Marks the specified fieldLabelNode as invalid. It means that label will has red bold font (as determined in errorFieldLabel
 * style) and it will has errorTitle title.
 */
ClientSideErrors.markFieldLabelsAsInvalid = function (fieldLabelNode, errorTitle, errorClass, saveOriginalClass) {
    if (fieldLabelNode != null && (typeof fieldLabelNode === "undefined" ? "undefined" : _typeof(fieldLabelNode)) != ( true ? "undefined" : _typeof(undefined))) {
        if (!saveOriginalClass) {
            fieldLabelNode.className = "errorFieldLabel";
        } else {
            (0, _atBrowserUtils.addClass)(fieldLabelNode, "errorFieldLabel");
        }
        fieldLabelNode.title = errorTitle;
        if (errorClass) (0, _atBrowserUtils.addClass)(fieldLabelNode, errorClass);
    }
};

/*
 * Marks the specified fieldLabelNode as valid.
 */
ClientSideErrors.markFieldLabelsAsValid = function (fieldLabelNode, errorClass, saveOriginalClass) {
    if (fieldLabelNode != null && (typeof fieldLabelNode === "undefined" ? "undefined" : _typeof(fieldLabelNode)) != ( true ? "undefined" : _typeof(undefined))) {
        if (!saveOriginalClass) {
            fieldLabelNode.className = "";
        } else {
            (0, _atBrowserUtils.removeClass)(fieldLabelNode, "errorFieldLabel");
        }
        fieldLabelNode.title = "";
        if (errorClass) (0, _atBrowserUtils.removeClass)(fieldLabelNode, errorClass);
    }
};

ClientSideErrors.setInvalidFieldInFocus = function (field) {
    if (!ClientSideErrors.isFocusingFirstFieldOnErrorEnabled) {
        return;
    }

    if (ClientSideErrors.canSetInvalidFieldInFocus) {
        field.focus();
        ClientSideErrors.canSetInvalidFieldInFocus = false;
    }
};

exports.default = ClientSideErrors;

/***/ }),
/* 1296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _rpcCalls = __webpack_require__(24);

var _rpcCalls2 = _interopRequireDefault(_rpcCalls);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _jquery2.default)(document).ready(function () {
    var $navTable = (0, _jquery2.default)('.navTable');
    var toggleNavSubmenuDropdownListeners = function toggleNavSubmenuDropdownListeners(navigationCollapsed) {
        var $containers = $navTable.find('.popup_submenu_container');

        if (navigationCollapsed) {
            $containers.each(function (_, element) {
                var $el = (0, _jquery2.default)(element);
                var $menuBody = $el.find('.popup_menu_body');
                $el.click(function (event) {
                    event.stopPropagation();
                });
                $el.mouseenter(function (event) {
                    window.PopupMenu.show(event, $menuBody);
                });
                $el.mouseleave(function () {
                    window.PopupMenu.hide_all();
                });
            });
        } else {
            $containers.each(function (_, element) {
                (0, _jquery2.default)(element).unbind("click").unbind("mouseenter").unbind("mouseleave");
            });
        }
    };

    (0, _jquery2.default)('.collapsCell').on('click', function () {
        $navTable.toggleClass('collapsed');
        window.NAVIGATION_COLLAPSED = !window.NAVIGATION_COLLAPSED;
        var newNavigationCollapsed = window.NAVIGATION_COLLAPSED;

        toggleNavSubmenuDropdownListeners(newNavigationCollapsed);

        (0, _jquery2.default)(document).trigger("navigation_resize_event", { navigationCollapsed: newNavigationCollapsed });

        (0, _rpcCalls2.default)("UserGlobalSettingsService.saveNavigationCollapsed", [newNavigationCollapsed], function () {
            return true;
        });
    });

    toggleNavSubmenuDropdownListeners(window.NAVIGATION_COLLAPSED);
});

/***/ }),
/* 1297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var IScroll = window.IScroll;
exports.default = IScroll;

/***/ }),
/* 1298 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.AuditHistoryScrollView = undefined;

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _constants = __webpack_require__(229);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _DropdownTemplateView2 = __webpack_require__(42);

var _DropdownTemplateView3 = _interopRequireDefault(_DropdownTemplateView2);

var _UpdateAuditRecord = __webpack_require__(1299);

var _SimpleViewTooltip = __webpack_require__(1301);

var _SimpleViewTooltip2 = _interopRequireDefault(_SimpleViewTooltip);

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _ScrollUtils = __webpack_require__(39);

var _ScrollUtils2 = _interopRequireDefault(_ScrollUtils);

var _atBrowserUtils = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MAX_SCROLL_HEIGHT = 300;

var AuditHistoryScrollView = exports.AuditHistoryScrollView = function (_TemplateView) {
    _inherits(AuditHistoryScrollView, _TemplateView);

    function AuditHistoryScrollView($containerEl) {
        _classCallCheck(this, AuditHistoryScrollView);

        var _this = _possibleConstructorReturn(this, (AuditHistoryScrollView.__proto__ || Object.getPrototypeOf(AuditHistoryScrollView)).call(this, $containerEl));

        _this.state = {
            allAuditHistoryLoaded: false
        };
        return _this;
    }

    _createClass(AuditHistoryScrollView, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return "<div class='scrollView scrollableContainer'>" + "  <div class='innerContainer'>" + "    <div class='placeholder top'></div>" + "    <div class='itemsContainer'></div>" + "    <div class='placeholder bottom'></div>" + "  </div>" + "</div>";
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            var _this2 = this;

            this.items = [];
            this.$topPlaceholder = this.find(".placeholder.top");
            this.$bottomPlaceholder = this.find(".placeholder.bottom");
            this.$itemsContainer = this.find(".itemsContainer");

            this.verticalScroll = _ScrollUtils2.default.addVerticalScroll(this.$el, { probeType: 2 });
            if (!(0, _atBrowserUtils.isIE8)()) {
                this.verticalScroll.on("scroll", function () {
                    return _this2.onScroll();
                });
            }
        }
    }, {
        key: 'addItems',
        value: function addItems(items) {
            this.items = this.items.concat(items);
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = items[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var item = _step.value;

                    item.init(this.$itemsContainer);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            this.refreshScroll();
        }
    }, {
        key: 'setItems',
        value: function setItems(items) {
            this.items = [];
            this.$itemsContainer.empty();
            this.addItems(items);
        }
    }, {
        key: 'refreshScroll',
        value: function refreshScroll() {
            var height = this.$itemsContainer.height();
            this.$el.height(height < MAX_SCROLL_HEIGHT ? height : MAX_SCROLL_HEIGHT);
            _ScrollUtils2.default.refreshCustomScroll(this.verticalScroll);
            this._checkIfScrolledToEnd();
        }
    }, {
        key: '_checkIfScrolledToEnd',
        value: function _checkIfScrolledToEnd() {
            var _this3 = this;

            if (!this._suppressScrollCheck && !this.state.allAuditHistoryLoaded) {
                _ScrollUtils2.default.performIfScrollToBottom(this.verticalScroll, 100, function () {
                    _this3.trigger("scrollToEnd");
                });
            }
        }
    }, {
        key: 'onScroll',
        value: function onScroll() {
            this._checkIfScrolledToEnd();
        }
    }, {
        key: 'suppressScrollCheck',
        value: function suppressScrollCheck(suppress) {
            this._suppressScrollCheck = suppress;
        }
    }]);

    return AuditHistoryScrollView;
}(_TemplateView3.default);

var AuditHistoryMenu = function (_DropdownTemplateView) {
    _inherits(AuditHistoryMenu, _DropdownTemplateView);

    _createClass(AuditHistoryMenu, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return "<div class='auditHistoryMenu dropdownContainer'/>";
        }
    }]);

    function AuditHistoryMenu($containerEl, extraClass) {
        var onContentClickCb = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};

        _classCallCheck(this, AuditHistoryMenu);

        var _this4 = _possibleConstructorReturn(this, (AuditHistoryMenu.__proto__ || Object.getPrototypeOf(AuditHistoryMenu)).call(this, $containerEl, extraClass));

        _this4.items = [];
        _this4.extraClass = extraClass;

        _this4.state = {
            allAuditHistoryLoaded: false
        };

        _this4.callbacks = {
            onContentClickCb: onContentClickCb
        };

        _this4.onStatePropertyChanged('allAuditHistoryLoaded', function (allAuditHistoryLoaded) {
            _this4.scrollView.setState({ allAuditHistoryLoaded: allAuditHistoryLoaded });
        });
        return _this4;
    }

    _createClass(AuditHistoryMenu, [{
        key: 'setDateFormat',
        value: function setDateFormat(dateFormat) {
            this.dateFormat = dateFormat;
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            var _this5 = this;

            if (this.extraClass) this.$el.addClass(this.extraClass);
            this.scrollView = new AuditHistoryScrollView(this.$el).init();
            this.scrollView.suppressScrollCheck(true);
            this.tooltip = new _SimpleViewTooltip2.default((0, _jquery2.default)("body"), 'auditRecordTooltip ' + this.extraClass + 'Tooltip').init();

            this.$el.click(function (e) {
                return _this5.callbacks.onContentClickCb(e);
            });
        }
    }, {
        key: 'addItems',
        value: function addItems(auditRecords) {
            var _this6 = this;

            this.items = this.items.concat(auditRecords);
            this.scrollView.setItems(this.items.map(function (record) {
                return _this6.getAuditRecord(record);
            }));
        }
    }, {
        key: 'getItems',
        value: function getItems() {
            return this.items;
        }
    }, {
        key: 'setItems',
        value: function setItems(auditRecords) {
            var _this7 = this;

            this.items = auditRecords;
            this.scrollView.setItems(auditRecords.map(function (record) {
                return _this7.getAuditRecord(record);
            }));
        }
    }, {
        key: 'onShow',
        value: function onShow() {
            _get(AuditHistoryMenu.prototype.__proto__ || Object.getPrototypeOf(AuditHistoryMenu.prototype), 'onShow', this).call(this);
            this.scrollView.refreshScroll();
            this.scrollView.suppressScrollCheck(false);
        }
    }, {
        key: 'onHide',
        value: function onHide() {
            _get(AuditHistoryMenu.prototype.__proto__ || Object.getPrototypeOf(AuditHistoryMenu.prototype), 'onHide', this).call(this);
            this.scrollView.suppressScrollCheck(true);
        }
    }, {
        key: 'getAuditRecord',
        value: function getAuditRecord(record) {
            switch (record.type) {
                case _constants.AuditActionTypes.RENAMED:
                    return new _UpdateAuditRecord.RenamedAuditRecord(record, this.dateFormat, this.tooltip);
                    break;
                case _constants.AuditActionTypes.REOPENED:
                case _constants.AuditActionTypes.COMPLETED:
                    return new _UpdateAuditRecord.StatusAuditRecord(record, this.dateFormat);
                    break;
                case _constants.AuditActionTypes.ARCHIVED:
                case _constants.AuditActionTypes.RESTORED:
                    return new _UpdateAuditRecord.ArchiveStatusAuditRecord(record, this.dateFormat);
                    break;
                case _constants.AuditActionTypes.BILLING_TYPE_CHANGED:
                    return new _UpdateAuditRecord.TypeOfWorkAuditRecord(record, this.dateFormat, this.tooltip);
                    break;
                case _constants.AuditActionTypes.DEADLINE_CHANGED:
                    return new _UpdateAuditRecord.DeadlineAuditRecord(record, this.dateFormat);
                    break;
                case _constants.AuditActionTypes.ESTIMATE_CHANGED:
                    return new _UpdateAuditRecord.EstimateAuditRecord(record, this.dateFormat);
                    break;
                case _constants.AuditActionTypes.DESCRIPTION_CHANGED:
                    return new _UpdateAuditRecord.DescriptionAuditRecord(record, this.dateFormat, this.tooltip);
                    break;
                case _constants.AuditActionTypes.MOVED:
                    return record.object['type'] === _constants.AuditEntityTypes['TASK'] ? new _UpdateAuditRecord.MoveTaskToAuditRecord(record, this.dateFormat, this.tooltip) : new _UpdateAuditRecord.MoveProjectToAuditRecord(record, this.dateFormat, this.tooltip);
                    break;
                case _constants.AuditActionTypes.WORKFLOW_STATUS_AND_TYPE_CHANGED:
                case _constants.AuditActionTypes.WORKFLOW_STATUS_ONLY_CHANGED:
                    return new _UpdateAuditRecord.WorkflowStatusAuditRecord(record, this.dateFormat);
                    break;
            }
        }
    }]);

    return AuditHistoryMenu;
}(_DropdownTemplateView3.default);

exports.default = AuditHistoryMenu;

/***/ }),
/* 1299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ArchiveStatusAuditRecord = exports.MoveProjectToAuditRecord = exports.MoveTaskToAuditRecord = exports.DescriptionAuditRecord = exports.TypeOfWorkAuditRecord = exports.WorkflowStatusAuditRecord = exports.StatusAuditRecord = exports.EstimateAuditRecord = exports.DeadlineAuditRecord = exports.RenamedAuditRecord = undefined;

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView4 = __webpack_require__(1);

var _TemplateView5 = _interopRequireDefault(_TemplateView4);

var _constants = __webpack_require__(229);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _user_time = __webpack_require__(30);

var _user_time2 = _interopRequireDefault(_user_time);

var _date_format = __webpack_require__(16);

var _constants2 = __webpack_require__(23);

var _index = __webpack_require__(22);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MAX_VALUE_LENGTH = 50;
var formatValue = function formatValue(value) {
    if (value.length > MAX_VALUE_LENGTH) return value.substring(0, MAX_VALUE_LENGTH) + "...";
    return value;
};

var ChangedValuesRow = function (_TemplateView) {
    _inherits(ChangedValuesRow, _TemplateView);

    _createClass(ChangedValuesRow, [{
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='changedValueRow'><span class='oldValue'/><span class='separator'>&#10230;</span><span class='newValue'/></div>";
        }
    }]);

    function ChangedValuesRow(oldValueText, newValueText) {
        _classCallCheck(this, ChangedValuesRow);

        var _this = _possibleConstructorReturn(this, (ChangedValuesRow.__proto__ || Object.getPrototypeOf(ChangedValuesRow)).call(this));

        _this.oldValueText = oldValueText;
        _this.newValueText = newValueText;
        return _this;
    }

    _createClass(ChangedValuesRow, [{
        key: "afterRender",
        value: function afterRender() {
            this.find('.oldValue').text(formatValue(this.oldValueText));
            this.find('.newValue').text(formatValue(this.newValueText));
        }
    }]);

    return ChangedValuesRow;
}(_TemplateView5.default);

var ChangedCustomerAndProjectValuesRow = function (_TemplateView2) {
    _inherits(ChangedCustomerAndProjectValuesRow, _TemplateView2);

    _createClass(ChangedCustomerAndProjectValuesRow, [{
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='changedValueRow'>" + "    <span class='oldValue'>" + "        <span class='customer'/>&nbsp;<span class='customerProjectSeparator'>></span>&nbsp;<span class='project'/>" + "    </span>" + "    <span class='separator'>&#10230;</span>" + "    <br>" + "    <span class='newValue'>" + "        <span class='customer'/>&nbsp;<span class='customerProjectSeparator'>></span>&nbsp;<span class='project'/>" + "    </span>" + "</div>";
        }
    }]);

    function ChangedCustomerAndProjectValuesRow(oldCustomerText, oldProjectText, newCustomerText, newProjectText) {
        _classCallCheck(this, ChangedCustomerAndProjectValuesRow);

        var _this2 = _possibleConstructorReturn(this, (ChangedCustomerAndProjectValuesRow.__proto__ || Object.getPrototypeOf(ChangedCustomerAndProjectValuesRow)).call(this));

        _this2.oldCustomerText = oldCustomerText;
        _this2.oldProjectText = oldProjectText;
        _this2.newCustomerText = newCustomerText;
        _this2.newProjectText = newProjectText;
        return _this2;
    }

    _createClass(ChangedCustomerAndProjectValuesRow, [{
        key: "afterRender",
        value: function afterRender() {
            this.find('.oldValue > .customer').text(formatValue(this.oldCustomerText));
            this.find('.oldValue > .project').text(formatValue(this.oldProjectText));
            this.find('.newValue > .customer').text(formatValue(this.newCustomerText));
            this.find('.newValue > .project').text(formatValue(this.newProjectText));
        }
    }]);

    return ChangedCustomerAndProjectValuesRow;
}(_TemplateView5.default);

var UpdateAuditRecord = function (_TemplateView3) {
    _inherits(UpdateAuditRecord, _TemplateView3);

    _createClass(UpdateAuditRecord, [{
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='updateAuditRecord'><div class='auditRecordRow'>" + "  <div class='timestamp'/>" + "  <div class='changeInfo'>" + "      <div class='info'><div class='subjectName ellipsis'><%-subjectName%></div><span class='changeLabel'/></div>" + "      <div class='values'/>" + "  </div>" + "</div></div>";
        }
    }]);

    function UpdateAuditRecord(audit, dateFormat) {
        _classCallCheck(this, UpdateAuditRecord);

        var _this3 = _possibleConstructorReturn(this, (UpdateAuditRecord.__proto__ || Object.getPrototypeOf(UpdateAuditRecord)).call(this));

        _this3.timestamp = audit.timestamp;
        _this3.subject = audit.subject;
        _this3.data = audit.data;
        _this3.type = audit.type;
        _this3.dateFormat = dateFormat;
        _this3.initialized = false;
        _this3.dependencies = audit.dependencies;
        return _this3;
    }

    _createClass(UpdateAuditRecord, [{
        key: "templateModel",
        value: function templateModel() {
            return {
                subjectName: this.subject['data']['name']
            };
        }
    }, {
        key: "beforeRender",
        value: function beforeRender() {
            if (this.$values) this.$values.empty();
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            this.$changeLabel = this.find('.changeLabel');
            this.$values = this.find('.values');
            var timestamp = new _date_format.DateFormat(window.SystemSettings.dateFormat, window.SystemSettings.clockFormat).formatDateTime(Date.parseJSONTimeWithoutTimeZone(this.timestamp));
            this.find('.timestamp').text(timestamp);
        }
    }, {
        key: "formatDate",
        value: function formatDate(date) {
            return Date.parseJSONDate(date).format(this.dateFormat);
        }
    }, {
        key: "findEntityInDependencies",
        value: function findEntityInDependencies(type, id) {
            return this.dependencies.find(function (entity) {
                return entity.type === type && entity.id === id;
            })['data'];
        }
    }]);

    return UpdateAuditRecord;
}(_TemplateView5.default);

var RenamedAuditRecord = exports.RenamedAuditRecord = function (_UpdateAuditRecord) {
    _inherits(RenamedAuditRecord, _UpdateAuditRecord);

    function RenamedAuditRecord(audit, dateFormat, tooltip) {
        _classCallCheck(this, RenamedAuditRecord);

        var _this4 = _possibleConstructorReturn(this, (RenamedAuditRecord.__proto__ || Object.getPrototypeOf(RenamedAuditRecord)).call(this, audit, dateFormat));

        _this4.tooltip = tooltip;
        return _this4;
    }

    _createClass(RenamedAuditRecord, [{
        key: "afterRender",
        value: function afterRender() {
            var _this5 = this;

            _get(RenamedAuditRecord.prototype.__proto__ || Object.getPrototypeOf(RenamedAuditRecord.prototype), "afterRender", this).call(this);
            var $nameLabel = (0, _jquery2.default)("<span class='dashedLink'>" + _messageResource2.default.getMessage('audit.audit_history.name') + " </span>");
            this.$changeLabel.html(_messageResource2.default.getMessage('audit.audit_history.change_record', ['']));
            this.$changeLabel.append($nameLabel);
            this.tooltip.subscribeToMouseEvents($nameLabel, function () {
                return _this5.tooltip.setView(new ChangedValuesRow(_this5.data['oldName'], _this5.data['newName']));
            });
        }
    }]);

    return RenamedAuditRecord;
}(UpdateAuditRecord);

var DeadlineAuditRecord = exports.DeadlineAuditRecord = function (_UpdateAuditRecord2) {
    _inherits(DeadlineAuditRecord, _UpdateAuditRecord2);

    function DeadlineAuditRecord(audit, dateFormat) {
        _classCallCheck(this, DeadlineAuditRecord);

        return _possibleConstructorReturn(this, (DeadlineAuditRecord.__proto__ || Object.getPrototypeOf(DeadlineAuditRecord)).call(this, audit, dateFormat));
    }

    _createClass(DeadlineAuditRecord, [{
        key: "afterRender",
        value: function afterRender() {
            _get(DeadlineAuditRecord.prototype.__proto__ || Object.getPrototypeOf(DeadlineAuditRecord.prototype), "afterRender", this).call(this);
            this.$changeLabel.html(_messageResource2.default.getMessage('audit.audit_history.change_record', [_messageResource2.default.getMessage('audit.audit_history.deadline')]));
            var notDefinedLabel = _messageResource2.default.getMessage('audit.audit_history.deadline_not_defined');
            var oldValue = this.data['oldDeadline'] ? this.formatDate(this.data['oldDeadline']) : notDefinedLabel;
            var newValue = this.data['newDeadline'] ? this.formatDate(this.data['newDeadline']) : notDefinedLabel;
            new ChangedValuesRow(oldValue, newValue).init(this.$values);
        }
    }]);

    return DeadlineAuditRecord;
}(UpdateAuditRecord);

var EstimateAuditRecord = exports.EstimateAuditRecord = function (_UpdateAuditRecord3) {
    _inherits(EstimateAuditRecord, _UpdateAuditRecord3);

    function EstimateAuditRecord(audit, dateFormat) {
        _classCallCheck(this, EstimateAuditRecord);

        return _possibleConstructorReturn(this, (EstimateAuditRecord.__proto__ || Object.getPrototypeOf(EstimateAuditRecord)).call(this, audit, dateFormat));
    }

    _createClass(EstimateAuditRecord, [{
        key: "afterRender",
        value: function afterRender() {
            _get(EstimateAuditRecord.prototype.__proto__ || Object.getPrototypeOf(EstimateAuditRecord.prototype), "afterRender", this).call(this);
            var notDefinedLabel = _messageResource2.default.getMessage('audit.audit_history.estimate_not_defined');
            this.$changeLabel.html(_messageResource2.default.getMessage('audit.audit_history.change_record', [_messageResource2.default.getMessage('audit.audit_history.estimate')]));
            var oldValue = this.data['oldEstimateTime'] ? _user_time2.default.formatTimeWithDigitSeparator(parseInt(this.data['oldEstimateTime'])) : notDefinedLabel;
            var newValue = this.data['newEstimateTime'] ? _user_time2.default.formatTimeWithDigitSeparator(parseInt(this.data['newEstimateTime'])) : notDefinedLabel;
            new ChangedValuesRow(oldValue, newValue).init(this.$values);
        }
    }]);

    return EstimateAuditRecord;
}(UpdateAuditRecord);

var StatusAuditRecord = exports.StatusAuditRecord = function (_UpdateAuditRecord4) {
    _inherits(StatusAuditRecord, _UpdateAuditRecord4);

    function StatusAuditRecord(audit, dateFormat) {
        _classCallCheck(this, StatusAuditRecord);

        return _possibleConstructorReturn(this, (StatusAuditRecord.__proto__ || Object.getPrototypeOf(StatusAuditRecord)).call(this, audit, dateFormat));
    }

    _createClass(StatusAuditRecord, [{
        key: "afterRender",
        value: function afterRender() {
            _get(StatusAuditRecord.prototype.__proto__ || Object.getPrototypeOf(StatusAuditRecord.prototype), "afterRender", this).call(this);
            this.$changeLabel.html(_messageResource2.default.getMessage('audit.audit_history.change_record', [_messageResource2.default.getMessage('audit.audit_history.status')]));
            var openTaskLabel = _messageResource2.default.getMessage('task.status.open');
            var completeTaskLabel = _messageResource2.default.getMessage('task.status.completed');
            var oldValue = this.type === _constants.AuditActionTypes.COMPLETED ? openTaskLabel : completeTaskLabel;
            var newValue = this.type === _constants.AuditActionTypes.COMPLETED ? completeTaskLabel : openTaskLabel;
            new ChangedValuesRow(oldValue, newValue).init(this.$values);
        }
    }]);

    return StatusAuditRecord;
}(UpdateAuditRecord);

var WorkflowStatusAuditRecord = exports.WorkflowStatusAuditRecord = function (_UpdateAuditRecord5) {
    _inherits(WorkflowStatusAuditRecord, _UpdateAuditRecord5);

    function WorkflowStatusAuditRecord(audit, dateFormat) {
        _classCallCheck(this, WorkflowStatusAuditRecord);

        return _possibleConstructorReturn(this, (WorkflowStatusAuditRecord.__proto__ || Object.getPrototypeOf(WorkflowStatusAuditRecord)).call(this, audit, dateFormat));
    }

    _createClass(WorkflowStatusAuditRecord, [{
        key: "afterRender",
        value: function afterRender() {
            _get(WorkflowStatusAuditRecord.prototype.__proto__ || Object.getPrototypeOf(WorkflowStatusAuditRecord.prototype), "afterRender", this).call(this);

            this.$changeLabel.html(_messageResource2.default.getMessage('audit.audit_history.change_record', [_messageResource2.default.getMessage('audit.audit_history.status')]));
            var oldWorkflowStatusId = parseInt(this.data['oldWorkflowStatusId']);
            var newWorkflowStatusId = parseInt(this.data['newWorkflowStatusId']);
            var oldValue = this.formatWorkflowStatusName(oldWorkflowStatusId);
            var newValue = this.formatWorkflowStatusName(newWorkflowStatusId);
            new ChangedValuesRow(oldValue, newValue).init(this.$values);
        }
    }, {
        key: "formatWorkflowStatusName",
        value: function formatWorkflowStatusName(workflowStatusId) {
            var workflowStatusesEnabled = (0, _index.isEnabled)(_index.Feature.TWS);

            var workflowStatusBean = this.findEntityInDependencies(_constants.AuditEntityTypes['WORKFLOW_STATUS'], workflowStatusId);
            var typeName = workflowStatusBean.type === _constants2.WorkflowStatusType.COMPLETED ? _messageResource2.default.getMessage('task.status.completed') : _messageResource2.default.getMessage('task.status.open');
            return workflowStatusesEnabled ? typeName + ": " + workflowStatusBean['name'] : typeName;
        }
    }]);

    return WorkflowStatusAuditRecord;
}(UpdateAuditRecord);

var TypeOfWorkAuditRecord = exports.TypeOfWorkAuditRecord = function (_UpdateAuditRecord6) {
    _inherits(TypeOfWorkAuditRecord, _UpdateAuditRecord6);

    function TypeOfWorkAuditRecord(audit, dateFormat, tooltip) {
        _classCallCheck(this, TypeOfWorkAuditRecord);

        var _this10 = _possibleConstructorReturn(this, (TypeOfWorkAuditRecord.__proto__ || Object.getPrototypeOf(TypeOfWorkAuditRecord)).call(this, audit, dateFormat));

        _this10.tooltip = tooltip;
        return _this10;
    }

    _createClass(TypeOfWorkAuditRecord, [{
        key: "afterRender",
        value: function afterRender() {
            var _this11 = this;

            _get(TypeOfWorkAuditRecord.prototype.__proto__ || Object.getPrototypeOf(TypeOfWorkAuditRecord.prototype), "afterRender", this).call(this);
            var $typeOfWork = (0, _jquery2.default)("<span class='dashedLink'>" + _messageResource2.default.getMessage('audit.audit_history.type_of_work') + " </span>");
            this.$changeLabel.html(_messageResource2.default.getMessage('audit.audit_history.change_record', ['']));
            this.$changeLabel.append($typeOfWork);
            var oldValue = this.findEntityInDependencies(_constants.AuditEntityTypes['TYPE_OF_WORK'], parseInt(this.data['oldBillingTypeId']))['name'];
            var newValue = this.findEntityInDependencies(_constants.AuditEntityTypes['TYPE_OF_WORK'], parseInt(this.data['newBillingTypeId']))['name'];
            this.tooltip.subscribeToMouseEvents($typeOfWork, function () {
                return _this11.tooltip.setView(new ChangedValuesRow(oldValue, newValue));
            });
        }
    }]);

    return TypeOfWorkAuditRecord;
}(UpdateAuditRecord);

var DescriptionAuditRecord = exports.DescriptionAuditRecord = function (_UpdateAuditRecord7) {
    _inherits(DescriptionAuditRecord, _UpdateAuditRecord7);

    function DescriptionAuditRecord(audit, dateFormat) {
        _classCallCheck(this, DescriptionAuditRecord);

        return _possibleConstructorReturn(this, (DescriptionAuditRecord.__proto__ || Object.getPrototypeOf(DescriptionAuditRecord)).call(this, audit, dateFormat));
    }

    _createClass(DescriptionAuditRecord, [{
        key: "afterRender",
        value: function afterRender() {
            _get(DescriptionAuditRecord.prototype.__proto__ || Object.getPrototypeOf(DescriptionAuditRecord.prototype), "afterRender", this).call(this);
            this.$changeLabel.html(_messageResource2.default.getMessage('audit.audit_history.change_record', [_messageResource2.default.getMessage('audit.audit_history.description')]));
        }
    }]);

    return DescriptionAuditRecord;
}(UpdateAuditRecord);

var MoveTaskToAuditRecord = exports.MoveTaskToAuditRecord = function (_UpdateAuditRecord8) {
    _inherits(MoveTaskToAuditRecord, _UpdateAuditRecord8);

    function MoveTaskToAuditRecord(audit, dateFormat, tooltip) {
        _classCallCheck(this, MoveTaskToAuditRecord);

        var _this13 = _possibleConstructorReturn(this, (MoveTaskToAuditRecord.__proto__ || Object.getPrototypeOf(MoveTaskToAuditRecord)).call(this, audit, dateFormat));

        _this13.tooltip = tooltip;
        return _this13;
    }

    _createClass(MoveTaskToAuditRecord, [{
        key: "afterRender",
        value: function afterRender() {
            var _this14 = this;

            _get(MoveTaskToAuditRecord.prototype.__proto__ || Object.getPrototypeOf(MoveTaskToAuditRecord.prototype), "afterRender", this).call(this);
            var $anotherProject = (0, _jquery2.default)("<span class='dashedLink'>" + _messageResource2.default.getEscapedMessage('audit.audit_history.another_project') + " </span>");
            this.$changeLabel.html(_messageResource2.default.getEscapedMessage('audit.audit_history.move_task') + ' ');
            this.$changeLabel.append($anotherProject);

            var $tooltipDiv = (0, _jquery2.default)("<div class='moveTaskTooltipDiv'/>");
            var oldProject = this.findEntityInDependencies(_constants.AuditEntityTypes['PROJECT'], parseInt(this.data['oldProjectId']))['name'];
            var newProject = this.findEntityInDependencies(_constants.AuditEntityTypes['PROJECT'], parseInt(this.data['newProjectId']))['name'];

            if (this.data['oldCustomerId'] !== this.data['newCustomerId']) {
                var oldCustomer = this.findEntityInDependencies(_constants.AuditEntityTypes['CUSTOMER'], parseInt(this.data['oldCustomerId']))['name'];
                var newCustomer = this.findEntityInDependencies(_constants.AuditEntityTypes['CUSTOMER'], parseInt(this.data['newCustomerId']))['name'];
                new ChangedCustomerAndProjectValuesRow(oldCustomer, oldProject, newCustomer, newProject).init($tooltipDiv);
            } else {
                new ChangedValuesRow(oldProject, newProject).init($tooltipDiv);
            }

            this.tooltip.subscribeToMouseEvents($anotherProject, function () {
                _this14.tooltip.setView(null);
                _this14.tooltip.$el.append($tooltipDiv);
            });
        }
    }]);

    return MoveTaskToAuditRecord;
}(UpdateAuditRecord);

var MoveProjectToAuditRecord = exports.MoveProjectToAuditRecord = function (_UpdateAuditRecord9) {
    _inherits(MoveProjectToAuditRecord, _UpdateAuditRecord9);

    function MoveProjectToAuditRecord(audit, dateFormat, tooltip) {
        _classCallCheck(this, MoveProjectToAuditRecord);

        var _this15 = _possibleConstructorReturn(this, (MoveProjectToAuditRecord.__proto__ || Object.getPrototypeOf(MoveProjectToAuditRecord)).call(this, audit, dateFormat));

        _this15.tooltip = tooltip;
        return _this15;
    }

    _createClass(MoveProjectToAuditRecord, [{
        key: "afterRender",
        value: function afterRender() {
            var _this16 = this;

            _get(MoveProjectToAuditRecord.prototype.__proto__ || Object.getPrototypeOf(MoveProjectToAuditRecord.prototype), "afterRender", this).call(this);
            var $anotherCustomer = (0, _jquery2.default)("<span class='dashedLink'>" + _messageResource2.default.getEscapedMessage('audit.audit_history.another_customer') + " </span>");
            this.$changeLabel.html(_messageResource2.default.getEscapedMessage('audit.audit_history.move_project') + ' ');
            this.$changeLabel.append($anotherCustomer);
            var oldValue = this.findEntityInDependencies(_constants.AuditEntityTypes['CUSTOMER'], parseInt(this.data['oldCustomerId']))['name'];
            var newValue = this.findEntityInDependencies(_constants.AuditEntityTypes['CUSTOMER'], parseInt(this.data['newCustomerId']))['name'];
            this.tooltip.subscribeToMouseEvents($anotherCustomer, function () {
                _this16.tooltip.setView(new ChangedValuesRow(oldValue, newValue));
            });
        }
    }]);

    return MoveProjectToAuditRecord;
}(UpdateAuditRecord);

var ArchiveStatusAuditRecord = exports.ArchiveStatusAuditRecord = function (_UpdateAuditRecord10) {
    _inherits(ArchiveStatusAuditRecord, _UpdateAuditRecord10);

    function ArchiveStatusAuditRecord(audit, dateFormat) {
        _classCallCheck(this, ArchiveStatusAuditRecord);

        return _possibleConstructorReturn(this, (ArchiveStatusAuditRecord.__proto__ || Object.getPrototypeOf(ArchiveStatusAuditRecord)).call(this, audit, dateFormat));
    }

    _createClass(ArchiveStatusAuditRecord, [{
        key: "afterRender",
        value: function afterRender() {
            _get(ArchiveStatusAuditRecord.prototype.__proto__ || Object.getPrototypeOf(ArchiveStatusAuditRecord.prototype), "afterRender", this).call(this);
            this.$changeLabel.html(_messageResource2.default.getMessage('audit.audit_history.change_record', [_messageResource2.default.getMessage('audit.audit_history.status')]));
            var activeCPLabel = _messageResource2.default.getMessage('customer.edit.status.active');
            var archiveCPLabel = _messageResource2.default.getMessage('customer.edit.status.archived');
            var oldValue = this.type === _constants.AuditActionTypes.ARCHIVED ? activeCPLabel : archiveCPLabel;
            var newValue = this.type === _constants.AuditActionTypes.ARCHIVED ? archiveCPLabel : activeCPLabel;
            new ChangedValuesRow(oldValue, newValue).init(this.$values);
        }
    }]);

    return ArchiveStatusAuditRecord;
}(UpdateAuditRecord);

/***/ }),
/* 1300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isEnabled = isEnabled;
exports.getEnabledFeaturesMap = getEnabledFeaturesMap;
exports.setEnabledFeaturesMap = setEnabledFeaturesMap;
var enabledFeaturesMap = window.__GENERATED_CONSTANTS__.EnabledFeatures;

/**
 * @deprecated use instade unsafe_selectWithStore(isFeatureEnabledSelector)
 * @param feature
 * @returns {boolean}
 */
function isEnabled(feature) {
    return !!enabledFeaturesMap[feature];
}

function getEnabledFeaturesMap() {
    return enabledFeaturesMap;
}

function setEnabledFeaturesMap(featuresMap) {
    enabledFeaturesMap = featuresMap;
}

/***/ }),
/* 1301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SimpleViewTooltip = undefined;

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Tooltip2 = __webpack_require__(183);

var _Tooltip3 = _interopRequireDefault(_Tooltip2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SimpleViewTooltip = exports.SimpleViewTooltip = function (_Tooltip) {
    _inherits(SimpleViewTooltip, _Tooltip);

    _createClass(SimpleViewTooltip, [{
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='simpleViewTooltip'></div>";
        }
    }]);

    function SimpleViewTooltip($containerEl, extraClass) {
        _classCallCheck(this, SimpleViewTooltip);

        var _this = _possibleConstructorReturn(this, (SimpleViewTooltip.__proto__ || Object.getPrototypeOf(SimpleViewTooltip)).call(this, $containerEl));

        _this.extraClass = extraClass;
        return _this;
    }

    _createClass(SimpleViewTooltip, [{
        key: "afterRender",
        value: function afterRender() {
            _get(SimpleViewTooltip.prototype.__proto__ || Object.getPrototypeOf(SimpleViewTooltip.prototype), "afterRender", this).call(this);
            if (this.extraClass) this.$el.addClass(this.extraClass);
        }
    }, {
        key: "setView",
        value: function setView(view) {
            this.view = view;
            this.update();
        }
    }, {
        key: "shouldUpdateOnInit",
        value: function shouldUpdateOnInit() {
            return false;
        }
    }, {
        key: "update",
        value: function update() {
            this.$el.empty();
            if (this.view) this.view.init(this.$el);
        }
    }]);

    return SimpleViewTooltip;
}(_Tooltip3.default);

exports.default = SimpleViewTooltip;

/***/ }),
/* 1302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.AuditInfoRecord = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _constants = __webpack_require__(229);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _date_format = __webpack_require__(16);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AuditInfoRecord = exports.AuditInfoRecord = function (_TemplateView) {
    _inherits(AuditInfoRecord, _TemplateView);

    function AuditInfoRecord(audit) {
        _classCallCheck(this, AuditInfoRecord);

        var _this = _possibleConstructorReturn(this, (AuditInfoRecord.__proto__ || Object.getPrototypeOf(AuditInfoRecord)).call(this));

        _this.timestamp = audit.timestamp;
        _this.subject = audit.subject;
        _this.type = audit.type;
        return _this;
    }

    _createClass(AuditInfoRecord, [{
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='auditInfoRecord ellipsis'><%-action%> <%-by%></div>";
        }
    }, {
        key: "templateModel",
        value: function templateModel() {
            return {
                action: this._actionTitle(),
                by: this._actionBy()
            };
        }
    }, {
        key: "_actionTitle",
        value: function _actionTitle() {
            var actionTime = Date.parseJSONTimeWithoutTimeZone(this.timestamp);
            var timeLabel = new _date_format.DateFormat(window.SystemSettings.dateFormat).formatDate(actionTime);
            var message = this.type === _constants.AuditActionTypes.CREATED ? "audit.audit_history.create_info_record" : "audit.audit_history.update_info_record";
            return _messageResource2.default.getMessage(message, [timeLabel]);
        }
    }, {
        key: "_actionBy",
        value: function _actionBy() {
            if (this.subject) return _messageResource2.default.getMessage('audit.audit_history.by', [JSON.parse(this.subject['data'])['name']]);
            return "";
        }
    }]);

    return AuditInfoRecord;
}(_TemplateView3.default);

/***/ }),
/* 1303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ClassicBridge = __webpack_require__(18);

var _ClassicBridge2 = _interopRequireDefault(_ClassicBridge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AccrualRuleFromDateSelector = function () {
    function AccrualRuleFromDateSelector(placeholder, dateFormat, onChangeCallback) {
        var _this = this;

        _classCallCheck(this, AccrualRuleFromDateSelector);

        this.placeholder = placeholder;

        this.selector = _ClassicBridge2.default.integrateFromDateSelector(this.placeholder, {
            dateFormat: dateFormat,
            onSelect: function onSelect(date) {
                _this.date = date;
                _this.selector.setProps({ date: _this.date });
                onChangeCallback();
            }
        });
    }

    _createClass(AccrualRuleFromDateSelector, [{
        key: 'show',
        value: function show() {
            $(this.placeholder).show();
        }
    }, {
        key: 'hide',
        value: function hide() {
            $(this.placeholder).hide();
        }
    }, {
        key: 'getValue',
        value: function getValue() {
            return this.date;
        }
    }, {
        key: 'enable',
        value: function enable() {
            this.selector.setProps({ isDisabled: false });
        }
    }, {
        key: 'disable',
        value: function disable() {
            this.selector.setProps({ isDisabled: true });
        }
    }, {
        key: 'setDates',
        value: function setDates(date, today) {
            this.date = date;
            this.selector.setProps({ date: this.date, today: today });
        }
    }, {
        key: 'setPlaceholderDateValue',
        value: function setPlaceholderDateValue(today) {
            this.date = _ClassicBridge2.default.getNextFridayDate(today);
            this.selector.setProps({ date: this.date, today: today });
        }
    }]);

    return AccrualRuleFromDateSelector;
}();

exports.default = AccrualRuleFromDateSelector;

/***/ }),
/* 1304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Ext = __webpack_require__(12);

var _Ext2 = _interopRequireDefault(_Ext);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Abstract selector panel.
 */
var SelectorPanel = _Ext2.default.extend(_Ext2.default.Container, {
    cls: "selector-panel",

    optionValue: false,
    /**
     * @cfg {String} genericCls style class for the generic options section container.
     */
    genericCls: "generic",

    /**
     * @cfg {String} customCls style class for the custom option section container.
     */
    customCls: "custom",

    /**
     * @cfg {String} detailsCls style class for the details section container.
     */
    detailsCls: "details",

    /**
     * @cfg {String} preFooterCls style class for the pre-footer section container.
     */
    preFooterCls: "preFooter",

    /**
     * @cfg {String} footerCls style class for the footer section container.
     */
    footerCls: "footer",
    autoEl: "div",
    layout: "table",
    layoutConfig: {
        columns: 1
    },

    /**
     * @cfg {AT.SelectorTree} selectorTree selection tree component.
     */
    selectorTree: {},

    /**
     * @cfg {Array} genericOptions array of {@link Ext.form.Radio} components.
     */
    genericOptions: null,

    /**
     * @cfg {Ext.form.Radio} customOption custom option component.
     */
    customOption: null,

    /**
     * @cfg {Boolean} showInactive true to display inactive items, false to not.
     * @see AT.SelectorPanel#filterTreeNodes
     */
    showInactive: false,

    initComponent: function initComponent() {
        SelectorPanel.superclass.initComponent.call(this);

        this.alreadyShown = false;

        this.createComponents();

        _Ext2.default.each(this.genericOptions, function (option) {
            option.on("check", this.onGenericOptionSelect, this);
        }, this);
        this.options = [];
        if (this.customOption) {
            this.customOption.on("check", this.onCustomOptionSelect, this);
            this.options = this.genericOptions.concat(this.customOption);
        }
        _Ext2.default.each(this.options, function (option) {
            option.on("check", this.onOptionSelect, this);
        }, this);
        this.updateState();
        this.filterTreeNodes(this.showInactive);

        this.addEvents("change", "close");
        this.defineSelectorTreeEvents();
    },

    defineSelectorTreeEvents: function defineSelectorTreeEvents() {
        this.selectorTree.on("change", this.onChange, this);
    },

    isAlreadyShown: function isAlreadyShown() {
        return this.alreadyShown;
    },

    setAlreadyShown: function setAlreadyShown() {
        this.alreadyShown = true;
    },

    render: function render(ct, pos) {

        this.addSection(this.genericCls, this.getGenericOptionsSection());
        this.customOptionsContainer = this.addSection(this.customCls, this.getCustomOptionSection());
        this.detailsContainer = this.addSection(this.detailsCls, this.getDetailsSection());
        this.addSection(this.preFooterCls, this.getPreFooterSection());
        this.addSection(this.footerCls, this.getFooterSection());

        SelectorPanel.superclass.render.call(this, ct, null); // Ext.menu.Menu bug workaround
    },

    /**
     * Renders a container with all section items and adds it to this container's children.
     * @param {String} cls section container style class.
     * @param {Array} items section components.
     * @param {Function} [afterRenderCallback] Function, which gets called after section is rendered with section DOM element as param
     * @return created container
     * @private
     */
    addSection: function addSection(cls, items) {
        //add section only there are items in given section
        if (items.length > 0) {
            var container = new _Ext2.default.Container({
                autoEl: "div",
                parentCls: cls,
                items: items,
                afterRender: function afterRender(ct) {
                    _Ext2.default.get(this.el.dom.parentNode).addClass(this.parentCls);
                }
            });
            this.add(container);
            return container;
        }
        return null;
    },

    /**
     * Creates all components used in the panel.
     * Must assign properties <code>selectorTree</code>, <code>genericOptions</code> and <code>customOption</code>.
     * @private
     */
    createComponents: _Ext2.default.emptyFn,

    /**
     * @returns {Array} array of components to render in the generic options section.
     * @private
     */
    getGenericOptionsSection: _Ext2.default.emptyFn,

    /**
     * @returns {Array} array of components to render in the custom options section.
     * @private
     */
    getCustomOptionSection: _Ext2.default.emptyFn,

    /**
     * @returns {Array} array of components to render in the details section.
     * @private
     */
    getDetailsSection: _Ext2.default.emptyFn,

    /**
     * @returns {Array} array of components in render in the pre-footer section.
     * @private
     */
    getPreFooterSection: _Ext2.default.emptyFn,

    /**
     * @returns {Array} array of components in render in the footer section.
     * @private
     */
    getFooterSection: _Ext2.default.emptyFn,

    /**
     * Sets all components to the state defined by the configuration values.
     * @private
     */
    updateState: _Ext2.default.emptyFn,

    /**
     * Rolls back the state of all components.
     * @private
     */
    resetState: _Ext2.default.emptyFn,

    /**
     * @returns {String} description text for the current selection and option choice.
     */
    getLabelText: _Ext2.default.emptyFn,

    /**
     * Selection change event handler.
     * @private
     */
    onChange: function onChange() {
        if (this.customOption) this.selectOption(this.customOption.inputValue);
        this.fireChangeEvent();
    },

    /**
     * Selects the option corresponding to the passed value.
     * @param value option value.
     * @private
     */
    selectOption: function selectOption(value) {
        _Ext2.default.each(this.options, function (option) {
            option.setValue(option.inputValue == value);
        });
    },

    /**
     * Generic option select handler.
     * @param option component.
     * @param checked state.
     * @private
     */
    onGenericOptionSelect: function onGenericOptionSelect(option, checked) {
        if (checked) {
            this.selectorTree.setInactive();
        }
    },

    /**
     * Custom option select handler.
     * @param option component.
     * @param checked state.
     * @private
     */
    onCustomOptionSelect: function onCustomOptionSelect(option, checked) {
        if (checked) {
            this.selectorTree.setInactive(false);
        }
    },

    /**
     * Option select handler.
     * @param option component.
     * @param checked state.
     * @private
     */
    onOptionSelect: function onOptionSelect(option, checked) {
        if (checked) {
            this.currentOption = option;
            this.fireChangeEvent();
        }
    },

    /**
     * Hides or shows "inactive" nodes in the selector tree.
     * @param showInactive true to show, false to hide.
     * @see AT.SelectorTree#activeProperty
     * @private
     */
    filterTreeNodes: function filterTreeNodes(showInactive) {
        this.selectorTree.filter(function (item) {
            return showInactive || this.propertiesController.isActive(item);
        }, this.selectorTree);
    },

    /**
     * Fires "change" event.
     * @private
     */
    fireChangeEvent: function fireChangeEvent() {
        this.fireEvent("change", this);
    },

    /**
     * Returns the value of current selected option.
     */
    getCurrentOptionValue: function getCurrentOptionValue() {
        return this.currentOption.inputValue;
    },

    /**
     * Returns true if panel can be hidden and false otherwise
     */
    processHide: function processHide() {
        return true;
    }
});

exports.default = SelectorPanel;

/***/ }),
/* 1305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _CustomCheckbox2 = __webpack_require__(1306);

var _CustomCheckbox3 = _interopRequireDefault(_CustomCheckbox2);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ShowDisabledCheckbox = function (_CustomCheckbox) {
    _inherits(ShowDisabledCheckbox, _CustomCheckbox);

    function ShowDisabledCheckbox(messageKey) {
        _classCallCheck(this, ShowDisabledCheckbox);

        var _this = _possibleConstructorReturn(this, (ShowDisabledCheckbox.__proto__ || Object.getPrototypeOf(ShowDisabledCheckbox)).call(this));

        _this.messageKey = messageKey;
        return _this;
    }

    _createClass(ShowDisabledCheckbox, [{
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='showDisabledCheckbox'>" + "  <div class='labelWrapper'>" + "    <span class='label'></span>" + "  </div>" + "</div>";
        }
    }, {
        key: "useUnderscoreTemplate",
        value: function useUnderscoreTemplate() {
            return false;
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            _get(ShowDisabledCheckbox.prototype.__proto__ || Object.getPrototypeOf(ShowDisabledCheckbox.prototype), "afterRender", this).call(this);

            if (this.showLater) this.show();else if (this.hideLater) this.hide();

            this.$label = this.find(".label");
            disableTextSelection(this.$label[0], true);
        }
    }, {
        key: "update",
        value: function update() {
            if (this.rendered) {
                _get(ShowDisabledCheckbox.prototype.__proto__ || Object.getPrototypeOf(ShowDisabledCheckbox.prototype), "update", this).call(this);
                var showOrHide = _messageResource2.default.getMessage(this.checked ? "common.hide" : "common.show");
                this.$label.html(_messageResource2.default.getEscapedMessage(this.messageKey, [showOrHide]));
            }
        }
    }, {
        key: "show",
        value: function show() {
            if (this.rendered) {
                _get(ShowDisabledCheckbox.prototype.__proto__ || Object.getPrototypeOf(ShowDisabledCheckbox.prototype), "show", this).call(this);
            } else {
                this.showLater = true;
                this.hideLater = false;
            }
        }
    }, {
        key: "hide",
        value: function hide() {
            if (this.rendered) {
                _get(ShowDisabledCheckbox.prototype.__proto__ || Object.getPrototypeOf(ShowDisabledCheckbox.prototype), "hide", this).call(this);
            } else {
                this.hideLater = true;
                this.showLater = false;
            }
        }
    }]);

    return ShowDisabledCheckbox;
}(_CustomCheckbox3.default);

exports.default = ShowDisabledCheckbox;

/***/ }),
/* 1306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CustomCheckbox = function (_TemplateView) {
    _inherits(CustomCheckbox, _TemplateView);

    function CustomCheckbox($containerEl) {
        _classCallCheck(this, CustomCheckbox);

        var _this = _possibleConstructorReturn(this, (CustomCheckbox.__proto__ || Object.getPrototypeOf(CustomCheckbox)).call(this, $containerEl));

        _this.checked = false;
        return _this;
    }

    _createClass(CustomCheckbox, [{
        key: "afterRender",
        value: function afterRender() {
            var _this2 = this;

            this.bindClick(function () {
                return _this2.setChecked(!_this2.checked);
            });
        }
    }, {
        key: "update",
        value: function update() {
            this.$el.toggleClass("checked", this.checked);
        }
    }, {
        key: "isChecked",
        value: function isChecked() {
            return this.checked;
        }
    }, {
        key: "setChecked",
        value: function setChecked(checked) {
            if (this.checked !== checked) {
                this.checked = checked;
                this.update();
                this.trigger("check", this.checked);
            }
        }
    }]);

    return CustomCheckbox;
}(_TemplateView3.default);

exports.default = CustomCheckbox;

/***/ }),
/* 1307 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TreeNode2 = __webpack_require__(60);

var _TreeNode3 = _interopRequireDefault(_TreeNode2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CustomerTreeNode = function (_TreeNode) {
    _inherits(CustomerTreeNode, _TreeNode);

    function CustomerTreeNode(customer, id) {
        _classCallCheck(this, CustomerTreeNode);

        return _possibleConstructorReturn(this, (CustomerTreeNode.__proto__ || Object.getPrototypeOf(CustomerTreeNode)).call(this, customer, id));
    }

    _createClass(CustomerTreeNode, [{
        key: "getIdPrefix",
        value: function getIdPrefix() {
            return "c";
        }
    }, {
        key: "getType",
        value: function getType() {
            return _TreeNode3.default.TYPE_CUSTOMER;
        }
    }]);

    return CustomerTreeNode;
}(_TreeNode3.default);

exports.default = CustomerTreeNode;

/***/ }),
/* 1308 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TreeNode2 = __webpack_require__(60);

var _TreeNode3 = _interopRequireDefault(_TreeNode2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ProjectTreeNode = function (_TreeNode) {
    _inherits(ProjectTreeNode, _TreeNode);

    function ProjectTreeNode(project, id) {
        _classCallCheck(this, ProjectTreeNode);

        return _possibleConstructorReturn(this, (ProjectTreeNode.__proto__ || Object.getPrototypeOf(ProjectTreeNode)).call(this, project, id));
    }

    _createClass(ProjectTreeNode, [{
        key: "getIdPrefix",
        value: function getIdPrefix() {
            return "p";
        }
    }, {
        key: "getType",
        value: function getType() {
            return _TreeNode3.default.TYPE_PROJECT;
        }
    }]);

    return ProjectTreeNode;
}(_TreeNode3.default);

exports.default = ProjectTreeNode;

/***/ }),
/* 1309 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _DisabledNodesParentTreeNode = __webpack_require__(283);

var _DisabledNodesParentTreeNode2 = _interopRequireDefault(_DisabledNodesParentTreeNode);

var _TreeNode = __webpack_require__(60);

var _TreeNode2 = _interopRequireDefault(_TreeNode);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ArchivedCustomersParentTreeNode = function (_DisabledNodesParentT) {
    _inherits(ArchivedCustomersParentTreeNode, _DisabledNodesParentT);

    function ArchivedCustomersParentTreeNode() {
        _classCallCheck(this, ArchivedCustomersParentTreeNode);

        return _possibleConstructorReturn(this, (ArchivedCustomersParentTreeNode.__proto__ || Object.getPrototypeOf(ArchivedCustomersParentTreeNode)).call(this, "ac", 0));
    }

    _createClass(ArchivedCustomersParentTreeNode, [{
        key: "getType",
        value: function getType() {
            return _TreeNode2.default.TYPE_ARCHIVED_CUSTOMERS_PARENT;
        }
    }]);

    return ArchivedCustomersParentTreeNode;
}(_DisabledNodesParentTreeNode2.default);

exports.default = ArchivedCustomersParentTreeNode;

/***/ }),
/* 1310 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _DisabledNodesParentTreeNode = __webpack_require__(283);

var _DisabledNodesParentTreeNode2 = _interopRequireDefault(_DisabledNodesParentTreeNode);

var _TreeNode = __webpack_require__(60);

var _TreeNode2 = _interopRequireDefault(_TreeNode);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ArchivedProjectsParentTreeNode = function (_DisabledNodesParentT) {
    _inherits(ArchivedProjectsParentTreeNode, _DisabledNodesParentT);

    function ArchivedProjectsParentTreeNode(parentId) {
        _classCallCheck(this, ArchivedProjectsParentTreeNode);

        return _possibleConstructorReturn(this, (ArchivedProjectsParentTreeNode.__proto__ || Object.getPrototypeOf(ArchivedProjectsParentTreeNode)).call(this, "ap", parentId));
    }

    _createClass(ArchivedProjectsParentTreeNode, [{
        key: "getType",
        value: function getType() {
            return _TreeNode2.default.TYPE_ARCHIVED_PROJECTS_PARENT;
        }
    }]);

    return ArchivedProjectsParentTreeNode;
}(_DisabledNodesParentTreeNode2.default);

exports.default = ArchivedProjectsParentTreeNode;

/***/ }),
/* 1311 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _pluralizeUtils = __webpack_require__(40);

var _atUtils = __webpack_require__(5);

var _at_hierarchy_selector_selection_helper = __webpack_require__(738);

var _at_hierarchy_selector_selection_helper2 = _interopRequireDefault(_at_hierarchy_selector_selection_helper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SimpleCustomersAndProjectsSelectionHelper = Ext.extend(_at_hierarchy_selector_selection_helper2.default, {
    pleaseSelectMessageKey: "projects_customers_selector.no_customers_projects_selected",
    withArchivedProjectsKey: "projects_customers_selector.with_all_archived_projects",
    withAllProjectsKey: "projects_customers_selector.with_all_projects",
    withActiveProjectsKey: "projects_customers_selector.with_all_active_projects",
    filteredPrefix: "_filtered",

    isCustomersProjectsFiltered: false,

    getPossibleFilteredKey: function getPossibleFilteredKey(key) {
        return this.isCustomersProjectsFiltered ? key + this.filteredPrefix : key;
    },

    getDescription: function getDescription(selection, dropdownButtonId) {
        var customers = selection.getFirstLevel();
        var projects = selection.getSecondLevel();
        if (customers.length == 0 && projects.length == 0) {
            return this.getMessage(this.pleaseSelectMessageKey);
        } else if (customers.length + projects.length == 1) {
            var isSingleCustomerSelected = customers.length == 1;
            return this.getSingleItemText((isSingleCustomerSelected ? customers : projects)[0], isSingleCustomerSelected);
        } else {
            return this.getShortDescriptionForCustomersAndProjects(customers, projects, dropdownButtonId);
        }
    },

    getSingleItemText: function getSingleItemText(item, isCustomer) {
        var text = isCustomer ? (0, _atUtils.escapeHtmlSymbols)(SystemSettings.firstLevelNamingSingular.toLowerCase()) : (0, _atUtils.escapeHtmlSymbols)(SystemSettings.secondLevelNamingSingular.toLowerCase());
        text += " ";
        text += (0, _atUtils.escapeHtmlSymbols)(item.name);

        if (item.archived) {
            text += " " + this.getMessage(this.inactiveSingleItemTextKey);
        }

        return text;
    },

    getShortDescriptionForCustomersAndProjects: function getShortDescriptionForCustomersAndProjects(customers, projects, dropdownButtonId) {
        var result = "";
        var isCustomersPresent = customers.length != 0;
        var isProjectsPresent = projects.length != 0;

        if (!isCustomersPresent && !isProjectsPresent) {
            return this.getMessage(this.pleaseSelectMessageKey);
        }

        if (isCustomersPresent) {
            result += customers.length + " ";
            result += customers.length == 1 ? (0, _atUtils.escapeHtmlSymbols)(SystemSettings.firstLevelNamingSingular.toLowerCase()) : (0, _atUtils.escapeHtmlSymbols)(SystemSettings.firstLevelNamingPlural.toLowerCase());
            result += " ";
            result += this.getMessage(this.getPossibleFilteredKey(this.withAllProjectsKey));
            if (isProjectsPresent) {
                if (dropdownButtonId) {
                    result = this.wrapTextByTitleSpans(result, dropdownButtonId, true);
                }
                result += " & ";
            }
        }
        if (isProjectsPresent) {
            var subResult = projects.length + " " + (0, _atUtils.escapeHtmlSymbols)((0, _pluralizeUtils.projectNameLower)(projects.length));

            if (dropdownButtonId && isCustomersPresent) {
                subResult = this.wrapTextByTitleSpans(subResult, dropdownButtonId, false);
            }
            result += subResult;
        }
        return result;
    },

    getCertainEntityList: function getCertainEntityList(selection, isForCustomer) {
        var context = this;
        if (isForCustomer) {
            return this.getListDescription(selection.getFirstLevel(), function (item) {
                return context.getListDescriptionItemForEntity(item);
            }, function (a, b) {
                return (0, _atUtils.stringComparator)(a.name, b.name);
            }, SystemSettings.firstLevelNamingPlural.toLowerCase());
        } else {
            return this.getListDescription(selection.getSecondLevel(), function (item) {
                return context.getListDescriptionItemForEntity(item);
            }, function (a, b) {
                return (0, _atUtils.stringComparator)(a.name, b.name);
            }, SystemSettings.secondLevelNamingPlural.toLowerCase());
        }
    },

    getListDescriptionItemForEntity: function getListDescriptionItemForEntity(entity) {
        return (0, _atUtils.concatStr)(entity.name, this.getListDescriptionItemStatus(entity), " ");
    },

    getListDescriptionItemStatus: function getListDescriptionItemStatus(entity) {
        if (entity.archived) {
            return this.getMessage(this.inactiveSingleItemTextKey);
        }
    }
});

exports.default = SimpleCustomersAndProjectsSelectionHelper;

/***/ }),
/* 1312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _SelectorFilter2 = __webpack_require__(282);

var _SelectorFilter3 = _interopRequireDefault(_SelectorFilter2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ReportsCPSelectorFilter = function (_SelectorFilter) {
    _inherits(ReportsCPSelectorFilter, _SelectorFilter);

    function ReportsCPSelectorFilter(_ref) {
        var tree = _ref.tree,
            searchIndex = _ref.searchIndex,
            allActiveSet = _ref.allActiveSet,
            projectsWithMaSet = _ref.projectsWithMaSet,
            accessibleCustomersSet = _ref.accessibleCustomersSet,
            _ref$showOnlyManageab = _ref.showOnlyManageable,
            showOnlyManageable = _ref$showOnlyManageab === undefined ? false : _ref$showOnlyManageab;

        _classCallCheck(this, ReportsCPSelectorFilter);

        var _this = _possibleConstructorReturn(this, (ReportsCPSelectorFilter.__proto__ || Object.getPrototypeOf(ReportsCPSelectorFilter)).call(this, tree, searchIndex, allActiveSet));

        _this.savedProjectsWithMaSet = projectsWithMaSet;
        _this.projectsWithMaSet = showOnlyManageable ? projectsWithMaSet : null;
        //set of customers containing manageable projects
        _this.accessibleCustomersSet = accessibleCustomersSet;
        return _this;
    }

    _createClass(ReportsCPSelectorFilter, [{
        key: 'hasNoFilter',
        value: function hasNoFilter() {
            return _get(ReportsCPSelectorFilter.prototype.__proto__ || Object.getPrototypeOf(ReportsCPSelectorFilter.prototype), 'hasNoFilter', this).call(this) && !this.projectsWithMaSet;
        }
    }, {
        key: 'doFilter',
        value: function doFilter() {
            if (!this.projectsWithMaSet) return _get(ReportsCPSelectorFilter.prototype.__proto__ || Object.getPrototypeOf(ReportsCPSelectorFilter.prototype), 'doFilter', this).call(this);

            var result = void 0;
            //keywordSet - set of nodes representing result of search by some specified keyword.
            //If keywordSet is presented then we should return result of search in set of manageable projects.
            // Set of selected nodes(selectedOnlySet) is not taken into account when searching.
            if (this.keywordSet) {
                result = this.projectsWithMaSet.intersection(this.keywordSet);
                var resultWithActiveOnlySet = this.safeIntersection(result, this.activeOnlySet);

                // If there is no active projects or customers with a specified keyword found
                // then return result of search in archived and manageable projects
                result = resultWithActiveOnlySet.isEmpty() ? result : resultWithActiveOnlySet;
            } else {
                //If there is no keywordSet then result is intersection of all other sets
                result = this.safeIntersection(this.projectsWithMaSet, this.activeOnlySet);
                result = this.safeIntersection(result, this.selectedOnlySet);
            }

            return result;
        }
    }, {
        key: 'getVisibleNodeSet',
        value: function getVisibleNodeSet(selectedNodeSet) {
            var visibleProjectNodes = this.safeIntersection(_get(ReportsCPSelectorFilter.prototype.__proto__ || Object.getPrototypeOf(ReportsCPSelectorFilter.prototype), 'getVisibleNodeSet', this).call(this, selectedNodeSet), this.projectsWithMaSet);
            var visibleCustomerNodes = this.accessibleCustomersSet.intersection(selectedNodeSet);
            return visibleProjectNodes.union(visibleCustomerNodes);
        }
    }, {
        key: 'setShowOnlyManageable',
        value: function setShowOnlyManageable(onlyManageable) {
            if (onlyManageable) {
                this.projectsWithMaSet = this.savedProjectsWithMaSet;
            } else {
                this.projectsWithMaSet = null;
            }

            this.reFilter();
        }
    }]);

    return ReportsCPSelectorFilter;
}(_SelectorFilter3.default);

exports.default = ReportsCPSelectorFilter;

/***/ }),
/* 1313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _CPSelectorTreeBuilderObserver = __webpack_require__(1314);

var _CPSelectorTreeBuilderObserver2 = _interopRequireDefault(_CPSelectorTreeBuilderObserver);

var _TreeNodeSet = __webpack_require__(79);

var _TreeNodeSet2 = _interopRequireDefault(_TreeNodeSet);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ReportsCPSelectorTreeBuilderObserver = function (_CPSelectorTreeBuilde) {
    _inherits(ReportsCPSelectorTreeBuilderObserver, _CPSelectorTreeBuilde);

    function ReportsCPSelectorTreeBuilderObserver(_ref) {
        var searchIndex = _ref.searchIndex,
            allActiveSet = _ref.allActiveSet,
            searchCustomers = _ref.searchCustomers;

        _classCallCheck(this, ReportsCPSelectorTreeBuilderObserver);

        var _this = _possibleConstructorReturn(this, (ReportsCPSelectorTreeBuilderObserver.__proto__ || Object.getPrototypeOf(ReportsCPSelectorTreeBuilderObserver)).call(this, searchIndex, allActiveSet, searchCustomers));

        _this.projectsWithMaNodesSet = new _TreeNodeSet2.default();
        _this.accessibleCustomerNodesSet = new _TreeNodeSet2.default();
        return _this;
    }

    _createClass(ReportsCPSelectorTreeBuilderObserver, [{
        key: 'projectNodeAdded',
        value: function projectNodeAdded(projectNode) {
            _get(ReportsCPSelectorTreeBuilderObserver.prototype.__proto__ || Object.getPrototypeOf(ReportsCPSelectorTreeBuilderObserver.prototype), 'projectNodeAdded', this).call(this, projectNode);

            var project = projectNode.getValue();

            if (project.fromManagementScope) {
                this.projectsWithMaNodesSet.add(projectNode);
                this.accessibleCustomerNodesSet.add(projectNode.getParent());
            }
        }
    }, {
        key: 'getProjectsWithMaNodesSet',
        value: function getProjectsWithMaNodesSet() {
            return this.projectsWithMaNodesSet;
        }

        /**
         *
         * @returns {TreeNodeSet} of customers containing manageable projects
         */

    }, {
        key: 'getAccessibleCustomerNodesSet',
        value: function getAccessibleCustomerNodesSet() {
            return this.accessibleCustomerNodesSet;
        }
    }]);

    return ReportsCPSelectorTreeBuilderObserver;
}(_CPSelectorTreeBuilderObserver2.default);

exports.default = ReportsCPSelectorTreeBuilderObserver;

/***/ }),
/* 1314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = CPSelectorTreeBuilderObserver;
function CPSelectorTreeBuilderObserver(searchIndex, allActiveSet, searchCustomers) {
    this.searchIndex = searchIndex;
    this.allActiveSet = allActiveSet;
    this.searchCustomers = searchCustomers;
}

CPSelectorTreeBuilderObserver.prototype.customerNodeAdded = function (customerNode) {
    if (this.searchCustomers) this.searchIndex.add(customerNode.getValue().name, customerNode.id);
    this.allActiveSet.add(customerNode);
};

CPSelectorTreeBuilderObserver.prototype.projectNodeAdded = function (projectNode) {
    this.searchIndex.add(projectNode.getValue().name, projectNode.id);
    this.allActiveSet.add(projectNode);
};

CPSelectorTreeBuilderObserver.prototype.archivedProjectsParentNodeAdded = function (node) {
    this.allActiveSet.add(node);
};

CPSelectorTreeBuilderObserver.prototype.archivedCustomersParentNodeAdded = function (node) {
    this.allActiveSet.add(node);
};

/***/ }),
/* 1315 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = CitiesSearchController;

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _BoolTimer = __webpack_require__(459);

var _BoolTimer2 = _interopRequireDefault(_BoolTimer);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _keyCodes = __webpack_require__(66);

var _GooglePlacesSessionTokenStore = __webpack_require__(739);

var _GooglePlacesSessionTokenStore2 = _interopRequireDefault(_GooglePlacesSessionTokenStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CitiesSearchController() {}

CitiesSearchController.prototype.init = function (searchField, onSelectedRowAction, onStartSearchCallback, onRequestSuccessCallback, onRequestErrorCallback, isShowToTop, additionalClasses, preventDefaultTabMoving) {
    this.onRequestErrorCallback = onRequestErrorCallback;
    this.onRequestSuccessCallback = onRequestSuccessCallback;
    this.onStartSearchCallback = onStartSearchCallback;
    this.onSelectedRowAction = onSelectedRowAction;

    this.isShowToTop = isShowToTop; // determines that need to show panel from search field to top or bot
    this.additionalClasses = additionalClasses;

    this.searchField = searchField;
    this.searchField.on("keydown", _jquery2.default.proxy(this._onSearchFieldKeyDownEvent, this)); // add events to search field
    this.preventDefaultTabMoving = preventDefaultTabMoving;
    this.containerElementId = "citiesSearchContainerElementId";

    this.hide();

    // google service for auto complete user search
    this.autocompliteService = new window.google.maps.places.AutocompleteService();

    var emptyContainer = (0, _jquery2.default)("<div></div>").hide();
    this.searchField.after(emptyContainer);
    // google service for get detailed information about city
    this.placesService = new window.google.maps.places.PlacesService(emptyContainer[0]);

    this.hoverEnabled = new _BoolTimer2.default(true, 500);

    return this;
};

CitiesSearchController.prototype.show = function () {
    var searchFieldOffset = this.searchField.offset(); // get left top offset of search field
    var searchFHeightWithBorders = this.searchField.outerHeight();
    var searchFBorders = (searchFHeightWithBorders - this.searchField.innerHeight()) / 2;

    var containerOffset = searchFieldOffset;

    var container = this._getContainer();

    if (this.additionalClasses) {
        container.toggleClass(this.additionalClasses, true);
    }

    container.show(); // show (now we can calculate panel height)

    var heightOfContainer = container.innerHeight(); // get height og container

    var containerOffsetForShowToTop = containerOffset.top - searchFBorders - heightOfContainer; // move on the width of border of search field to top, move on the height of container
    var containerOffsetForShowToBottom = containerOffset.top + searchFHeightWithBorders; // // move panel on the height of search field height to bot

    var windowHeight = (0, _jquery2.default)(window).height();
    var windowScrollTop = (0, _jquery2.default)(window).scrollTop();

    // check that there is enough place for show panel
    var isEnoughPlaceForShowToTop = containerOffsetForShowToTop >= windowScrollTop;
    var isEnoughPlaceForShowToBottom = containerOffsetForShowToBottom + heightOfContainer <= windowHeight + windowScrollTop;

    var showToTop = this.isShowToTop; // set recommended value
    if (this.isShowToTop) {
        // show to top if possible otherwise to bot if possible
        showToTop = isEnoughPlaceForShowToTop || !isEnoughPlaceForShowToBottom && !isEnoughPlaceForShowToTop;
    } else {
        // show to bottom if possible otherwise to top if possible
        showToTop = !isEnoughPlaceForShowToBottom && (isEnoughPlaceForShowToBottom || isEnoughPlaceForShowToTop);
    }

    containerOffset.top = showToTop ? containerOffsetForShowToTop : containerOffsetForShowToBottom;
    container.offset(containerOffset); // move to needed position
    this.isShown = true;
    this.userActivitiesEnabled = true;
};

CitiesSearchController.prototype.hide = function () {
    var container = this._getContainer();
    if (this.additionalClasses) {
        container.toggleClass(this.additionalClasses, false);
    }
    container.hide();

    this.isShown = false;
    this.userActivitiesEnabled = false;
};

CitiesSearchController.prototype.getSearchPanelElement = function () {
    return this._getContainer();
};

CitiesSearchController.prototype.isShow = function () {
    return this.isShown;
};

/**
 * return container that will be inserted to dom
 * if element not founded - create new (lazy init)
 *
 * @returns {*|jQuery|HTMLElement}
 * @private
 */
CitiesSearchController.prototype._getContainer = function () {
    var container = _jquery2.default.find("#" + this.containerElementId);
    if (container.length == 0) {
        var containerCls = "searchResultContainer" + " " + (this.isShowToTop ? "toTop" : "toBottom");
        container = (0, _jquery2.default)("<div id='" + this.containerElementId + "' class='" + containerCls + "'></div>");
        (0, _jquery2.default)("body").append(container); //append to body
    } else {
        container = (0, _jquery2.default)(container[0]);
    }
    return container;
};

/**
 * append formatted implementation of result data
 * @param citiesData data with cities from auto complete service
 * @param container
 * @private
 */
CitiesSearchController.prototype._appendCitiesRows = function (citiesData, container) {
    var self = this;
    var citiesList = citiesData;

    for (var i = 0; i < citiesList.length; i++) {
        var data = citiesList[i];
        var row = this._createCityRow(data);

        row.on("click", function (rData) {
            return function (ev) {
                self._onRowClick(rData);
                ev.stopPropagation();
            };
        }(data));
        row.on("mousemove", function (r) {
            return function (ev) {
                self._onRowMouseMove(r);
                ev.preventDefault();
            };
        }(row));
        container.append(row);

        if (i == 0) {
            this._setActiveRow(row);
        }
    }
};

CitiesSearchController.prototype._onRowClick = function (cityData) {
    this._stopTimer();
    this.userActivitiesEnabled = false;
    this.processGetDetailedCityInformation(cityData);
};

CitiesSearchController.prototype._onRowMouseMove = function (row) {
    if (this.hoverEnabled.isTrue() && this.userActivitiesEnabled) this._setActiveRow(row);
};

CitiesSearchController.prototype._createCityRow = function (cityData) {
    var row = (0, _jquery2.default)("<div class='row'></div>");
    var matchedSubstrings = cityData.matched_substrings;

    var cityName = (0, _jquery2.default)("<div class='cityName'></div>");
    cityName.append(this._highlightText(cityData.terms[0], matchedSubstrings)); // call highlighting for city name

    var descriptionEl = (0, _jquery2.default)("<div class='divisionName'></div>");
    var country = cityData.terms[2];
    if (country) {
        descriptionEl.append(this._highlightText(country, matchedSubstrings));
    }
    if (cityData.terms[2] && cityData.terms[1]) {
        descriptionEl.append(" / ");
    }
    var firstAdmin = cityData.terms[1];
    if (firstAdmin) {
        descriptionEl.append(this._highlightText(firstAdmin, matchedSubstrings));
    }

    row.append(cityName).append(descriptionEl);
    return row;
};

/**
 * For more information see google.maps.places.AutocompletePrediction object specification
 * @param term current term (part of founded description)
 * @param matchedSubStrings (array of all matches elements offset in description + length)
 * @returns {*|jQuery|HTMLElement} span with result
 * @private
 */
CitiesSearchController.prototype._highlightText = function (term, matchedSubStrings) {
    var termOffset = term.offset;
    var termValue = term.value;

    // find substring for term
    var matchedSubstring;
    for (var i = 0; i < matchedSubStrings.length; i++) {
        var subOffset = matchedSubStrings[i].offset;
        if (termOffset <= subOffset && subOffset < termOffset + termValue.length) {
            matchedSubstring = matchedSubStrings[i];
        }
    }

    var result = (0, _jquery2.default)("<span></span>");
    var highResult = (0, _jquery2.default)("<span class='highlighted'></span>");
    // if matched substring founded - to highlight otherwise append simple value
    if (matchedSubstring) {
        var offsetFromTerm = matchedSubstring.offset - termOffset;
        result.append(termValue.substring(0, offsetFromTerm));
        result.append(highResult.append(termValue.substring(offsetFromTerm, offsetFromTerm + matchedSubstring.length)));
        result.append(termValue.substring(offsetFromTerm + matchedSubstring.length));
    } else {
        result.append(termValue);
    }

    return result;
};

CitiesSearchController.prototype._getEmptyResultRow = function () {
    return (0, _jquery2.default)("<div class='emptyResultRow'>" + _messageResource2.default.getMessage("cities_search_panel.js.there_are_no_results") + "</div>");
};

CitiesSearchController.prototype._getPanelFooter = function () {
    return (0, _jquery2.default)("<div class='footer'></div>");
};

CitiesSearchController.prototype._onSearchFieldKeyDownEvent = function (event) {
    if (event.keyCode == _keyCodes.KEY_CODE_UP) {
        this._moveCursorUpOrDown(true);
        event.preventDefault();
    } else if (event.keyCode == _keyCodes.KEY_CODE_DOWN) {
        this._moveCursorUpOrDown(false);
        event.preventDefault();
    } else if (event.keyCode == _keyCodes.KEY_CODE_ENTER) {
        if (this.isShown) {
            this._getActiveRow().click();
        } else {
            this.processSearchQuery();
        }

        event.preventDefault();
    } else if (event.keyCode == _keyCodes.KEY_CODE_TAB) {
        if (this.preventDefaultTabMoving) {
            event.preventDefault();
            return false;
        } else if (this.isShown) {
            this._getActiveRow().click();
        }
    } else {
        this._processSearchQueryWithDelay(200);
    }
};

CitiesSearchController.prototype._moveCursorUpOrDown = function (isUp) {
    if (!this.userActivitiesEnabled) {
        return;
    }

    var activeRow = this._getActiveRow();
    var switchTo = isUp ? activeRow.prev(".row") : activeRow.next(".row");

    if (switchTo.length == 1) {
        this._setActiveRow(switchTo);
        this.hoverEnabled.switchValue(); // don't react to mouse move while changing active row the other way
    }
};

CitiesSearchController.prototype._setActiveRow = function (row) {
    this._getActiveRow().removeClass("active");
    row.addClass("active");
};

CitiesSearchController.prototype._getActiveRow = function () {
    return this._getContainer().find(".row.active");
};

CitiesSearchController.prototype._processSearchQueryWithDelay = function (delay) {
    this._stopTimer();
    this.searchDelayTimer = setTimeout(_jquery2.default.proxy(this.processSearchQuery, this), delay);
};

/**
 * Start search request
 */
CitiesSearchController.prototype.processSearchQuery = function () {
    var newQuery = _jquery2.default.trim(this.searchField.val());

    if (newQuery == '') {
        this.hide();
    } else {
        this.onStartSearchCallback();
        this.autocompliteService.getPlacePredictions({
            input: newQuery,
            types: ['(cities)'], // get only cities
            sessionToken: _GooglePlacesSessionTokenStore2.default.getToken()
        }, _jquery2.default.proxy(this._onSearchRequestCompleted, this));
    }
};

/**
 * Process request to get detailed information about city
 * @param city
 */
CitiesSearchController.prototype.processGetDetailedCityInformation = function (city) {
    var self = this;
    this.placesService.getDetails({
        placeId: city.place_id,
        fields: ['place_id', 'geometry'],
        sessionToken: _GooglePlacesSessionTokenStore2.default.getToken()
    }, function (detailedCity, status) {
        if (status == window.google.maps.places.PlacesServiceStatus.OK) {
            self.onSelectedRowAction({
                name: city.terms[0].value, // set original searched name (detailedCity contains localed city name)
                place_id: detailedCity['place_id'],
                geometry: detailedCity['geometry']
            });
        } else {
            self._onErrorRequest(status);
        }
        self.hide();
    });

    // Session is invalid as soon as we get details
    _GooglePlacesSessionTokenStore2.default.clearToken();
};

/**
 * callback on request completed
 * @param data search result
 * @param status status of request
 * @private
 */
CitiesSearchController.prototype._onSearchRequestCompleted = function (data, status) {
    var container = this._getContainer();
    container.empty();

    var isNormalResult = false;
    if (status == window.google.maps.places.PlacesServiceStatus.OK) {
        this._appendCitiesRows(data, container);
        isNormalResult = true;
    }
    if (status == window.google.maps.places.PlacesServiceStatus.ZERO_RESULTS) {
        container.append(this._getEmptyResultRow());
        isNormalResult = true;
    }

    if (isNormalResult) {
        this.onRequestSuccessCallback();
        container.append(this._getPanelFooter()); // add footer for (powered by google)
        this.show();
    } else {
        this._onErrorRequest(status);
        this.hide();
    }
};

CitiesSearchController.prototype._onErrorRequest = function (status) {
    console.error("Google places api response status: " + status);
    this.onRequestErrorCallback();
};

CitiesSearchController.prototype._stopTimer = function () {
    clearTimeout(this.searchDelayTimer);
};

/***/ }),
/* 1316 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = UserGroupSelectorTree;

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _UsersSelectorTree = __webpack_require__(741);

var _UsersSelectorTree2 = _interopRequireDefault(_UsersSelectorTree);

var _hierarchy_selector_util = __webpack_require__(95);

var _hierarchy_selector_util2 = _interopRequireDefault(_hierarchy_selector_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function UserGroupSelectorTree(rootNode, emptyMessageBuilder, collapsedNodeIds, getGroupIdFromUserCallback) {
    _UsersSelectorTree2.default.call(this, rootNode, emptyMessageBuilder, collapsedNodeIds);
    this.getGroupIdFromUserCallback = getGroupIdFromUserCallback;
}

UserGroupSelectorTree.prototype = _underscore2.default.create(_UsersSelectorTree2.default.prototype);

UserGroupSelectorTree.prototype.isSelectionChanged = function () {
    return _hierarchy_selector_util2.default.isSelectionChanged(this);
};

/***/ }),
/* 1317 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = SelectionTree;

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _Tree = __webpack_require__(743);

var _Tree2 = _interopRequireDefault(_Tree);

var _TreeSelectionController = __webpack_require__(744);

var _TreeSelectionController2 = _interopRequireDefault(_TreeSelectionController);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function SelectionTree(rootNode, rootVisible, collapsedNodeIds) {
    _Tree2.default.call(this, rootNode, rootVisible, collapsedNodeIds);
    this.selectionController = this.createSelectionController();
}

SelectionTree.prototype = _underscore2.default.create(_Tree2.default.prototype);

/*
todo : radzivillovich : need to refactor
type of selection controller shouldn't be strictly associated with type of selection tree.
so we, probably, should set selection controller to tree after tree creating
*/
SelectionTree.prototype.createSelectionController = function () {
    return new _TreeSelectionController2.default(this);
};

SelectionTree.prototype.setSelectionController = function (selectionController) {
    this.selectionController = selectionController;
};

SelectionTree.prototype.getSelectionController = function () {
    return this.selectionController;
};

SelectionTree.prototype.deselectAll = function () {
    this.selectionController.deselectAll();
};

/***/ }),
/* 1318 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TreeNodeSet = __webpack_require__(79);

var _TreeNodeSet2 = _interopRequireDefault(_TreeNodeSet);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// TODO: This class shall not do any scrolling
// TODO: Table shall subscribe to expand / collapse events and update UI itself
var ExpandController = function () {
    function ExpandController(tree, collapsedNodeIds) {
        _classCallCheck(this, ExpandController);

        this.tree = tree;
        this.nodeSet = new _TreeNodeSet2.default();
        if (collapsedNodeIds) {
            var rootNode = this.tree.getRootNode();
            for (var i = 0; i < collapsedNodeIds.length; i++) {
                var treeNode = rootNode.getNodeById(collapsedNodeIds[i]);
                if (treeNode) this.nodeSet.add(treeNode);
            }
        }
    }

    _createClass(ExpandController, [{
        key: 'expand',
        value: function expand(treeNode) {
            this.nodeSet.remove(treeNode);
            this.tree.updateUIForSingleTreeNode(treeNode);
        }
    }, {
        key: 'getElementHeight',
        value: function getElementHeight(elm) {
            var elmHeight = elm.offsetHeight;
            var elmMargin = void 0;
            if (document.all) {
                // IE
                var marginTop = parseInt(elm.currentStyle.marginTop, 10);
                var marginBottom = parseInt(elm.currentStyle.marginBottom, 10);
                elmMargin = (isNaN(marginTop) ? 0 : marginTop) + (isNaN(marginBottom) ? 0 : marginBottom);
            } else {
                // Mozilla
                elmMargin = parseInt(document.defaultView.getComputedStyle(elm, '').getPropertyValue('margin-top')) + parseInt(document.defaultView.getComputedStyle(elm, '').getPropertyValue('margin-bottom'));
            }
            return elmHeight + elmMargin;
        }
    }, {
        key: 'expandAndScrollIfNeeded',
        value: function expandAndScrollIfNeeded(treeNode) {
            this.expand(treeNode);
            this.scrollToIfNeeded(treeNode);
        }
    }, {
        key: 'scrollToIfNeeded',
        value: function scrollToIfNeeded(treeNode) {
            var nodeEl = this.tree.getUIObjectForNode(treeNode).nodeEl;
            var treePanel = this.tree.treeContainer.parentNode;

            var nodeElHeight = this.getElementHeight(nodeEl) + 2;

            var customScroll = this.tree.customScroll;
            if (customScroll) {
                // if there is custom scroll - use scroll own functions
                var expandedNodeBottomPosition = nodeEl.offsetTop + nodeElHeight - treePanel.offsetHeight;
                if (Math.min(nodeEl.offsetTop, expandedNodeBottomPosition) > Math.abs(customScroll.y)) // scroll only if top of nodEl will be in visible area
                    {
                        customScroll.scrollToElement(nodeEl, 200, null, -(customScroll.wrapperHeight - nodeElHeight));
                    }
            } else {
                var to = Math.min(nodeEl.offsetTop, nodeEl.offsetTop + nodeElHeight - treePanel.offsetHeight);

                if (to > treePanel.scrollTop) {
                    var scrollerCtor = function scrollerCtor(panel, to) {
                        this.panel = panel;
                        this.to = to;
                        this.scroll = function () {
                            if (this.panel.scrollTop < this.to) {
                                var lastScrollTop = this.panel.scrollTop;
                                this.panel.scrollTop += (this.to - this.panel.scrollTop) / 10 + 1;
                                if (this.panel.scrollTop <= lastScrollTop) // prevent indefinite updates
                                    return;
                                var me = this;
                                setTimeout(function () {
                                    me.scroll();
                                }, 7);
                            } else {
                                this.panel.scrollTop = this.to;
                            }
                        };
                    };

                    new scrollerCtor(treePanel, to).scroll();
                }
            }
        }
    }, {
        key: 'collapse',
        value: function collapse(treeNode) {
            if (!treeNode.isCollapsible()) return;
            this.nodeSet.add(treeNode);
            this.tree.updateUIForSingleTreeNode(treeNode);
        }
    }, {
        key: 'toggle',
        value: function toggle(treeNode) {
            if (this.isCollapsed(treeNode)) this.expand(treeNode);else this.collapse(treeNode);
        }
    }, {
        key: 'isExpanded',
        value: function isExpanded(treeNode) {
            return !this.isCollapsed(treeNode);
        }
    }, {
        key: 'isCollapsed',
        value: function isCollapsed(treeNode) {
            return treeNode.isCollapsible() ? this.nodeSet.contains(treeNode) : false;
        }
    }, {
        key: 'getCollapsedNodeSet',
        value: function getCollapsedNodeSet() {
            return this.nodeSet;
        }
    }, {
        key: 'expandSubtree',
        value: function expandSubtree(treeNode) {
            if (!treeNode.hasChildren()) return;
            this.expandChildren(treeNode);
            this.expand(treeNode);
        }
    }, {
        key: 'expandChildren',
        value: function expandChildren(treeNode) {
            var children = treeNode.getChildren();
            for (var i = 0; i < children.length; i++) {
                this.expandSubtree(children[i]);
            }
        }
    }, {
        key: 'collapseSubtree',
        value: function collapseSubtree(treeNode) {
            if (!treeNode.hasChildren()) return;
            this.collapseChildren(treeNode);
            this.collapse(treeNode);
        }
    }, {
        key: 'collapseChildren',
        value: function collapseChildren(treeNode) {
            var children = treeNode.getChildren();
            for (var i = 0; i < children.length; i++) {
                this.collapseSubtree(children[i]);
            }
        }
    }]);

    return ExpandController;
}();

exports.default = ExpandController;

/***/ }),
/* 1319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TreeNode2 = __webpack_require__(60);

var _TreeNode3 = _interopRequireDefault(_TreeNode2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GroupTreeNode = function (_TreeNode) {
    _inherits(GroupTreeNode, _TreeNode);

    function GroupTreeNode(group, id) {
        _classCallCheck(this, GroupTreeNode);

        return _possibleConstructorReturn(this, (GroupTreeNode.__proto__ || Object.getPrototypeOf(GroupTreeNode)).call(this, group, id));
    }

    _createClass(GroupTreeNode, [{
        key: "getIdPrefix",
        value: function getIdPrefix() {
            return "g";
        }
    }, {
        key: "getType",
        value: function getType() {
            return _TreeNode3.default.TYPE_GROUP;
        }
    }]);

    return GroupTreeNode;
}(_TreeNode3.default);

exports.default = GroupTreeNode;

/***/ }),
/* 1320 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _DisabledNodesParentTreeNode = __webpack_require__(283);

var _DisabledNodesParentTreeNode2 = _interopRequireDefault(_DisabledNodesParentTreeNode);

var _TreeNode = __webpack_require__(60);

var _TreeNode2 = _interopRequireDefault(_TreeNode);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DisabledUsersParentTreeNode = function (_DisabledNodesParentT) {
    _inherits(DisabledUsersParentTreeNode, _DisabledNodesParentT);

    function DisabledUsersParentTreeNode(parentId) {
        _classCallCheck(this, DisabledUsersParentTreeNode);

        return _possibleConstructorReturn(this, (DisabledUsersParentTreeNode.__proto__ || Object.getPrototypeOf(DisabledUsersParentTreeNode)).call(this, "du", parentId));
    }

    _createClass(DisabledUsersParentTreeNode, [{
        key: "getType",
        value: function getType() {
            return _TreeNode2.default.TYPE_DISABLED_USERS_PARENT;
        }
    }]);

    return DisabledUsersParentTreeNode;
}(_DisabledNodesParentTreeNode2.default);

exports.default = DisabledUsersParentTreeNode;

/***/ }),
/* 1321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = DropdownButton;

var _gui_control = __webpack_require__(750);

var _gui_control2 = _interopRequireDefault(_gui_control);

var _dhtml_popup = __webpack_require__(139);

var _atBrowserUtils = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Dropdown button constructor.
 * @param id - button identifier, will be used as dropdown element id
 * @param caption - initial dropdown caption
 * @param dhtmlPopup - DhtmlPopup that will be shown on button press
 * @param isDropUp - if true then the dropdown will really be a drop-up :)
 * @param popupWidth - width of the popup. If null, then it will be as wide as the button (a bit narrower, really).
 * @param isOriginAtRight - if true then the popup's right side will be linked to the right side of the button.
 *                          Otherwise - popup's left side will be linked to the left side of the button.
 *                          This parameter has effect only if popupWidth is not null.
 *
 * Note: you should not set afterHide event handler for the dhtmlPopup, because it is used by the button.
 * Instead, you should use DropdownButton.setAfterPopupHideHandler().
 */
function DropdownButton(id, caption, dhtmlPopup, isDropUp, popupWidth, isOriginAtRight) {
    this.base = _gui_control2.default;
    this.base(id);

    this.caption = caption;
    this.dhtmlPopup = dhtmlPopup;
    this.isDropUp = isDropUp;
    this.popupWidth = popupWidth;
    this.isOriginAtRight = isOriginAtRight;

    this.pressed = false;

    if (this.dhtmlPopup) {
        this.dhtmlPopup.setPositioningStrategy(new _dhtml_popup.ElementRelativePositioning(this.getId()));
        this.dhtmlPopup.setCallerElement(this);
        this.dhtmlPopup.setAfterHideHandler(function () {
            this.getCallerElement().unpress();
        });
    }

    this.normalClassName = "dropdown-button";
    this.activeClassName = "dropdown-button active";
    this.hoverClassName = "hover";
    this.disabledClassName = "dropdown-button disabled";
    this.savingClassName = "dropdown-button saving";
    this.errorClassName = "error";
    this.displayErrorClass = false;

    this.beforePopupShowHandler = null;
    this.afterPopupHideHandler = null;

    this.enabled = true;
}

DropdownButton.prototype = new _gui_control2.default();

/**
 * Sets the button caption, i.e. the text that is displayed in it.
 */
DropdownButton.prototype.setCaption = function (caption) {
    this.caption = caption;
    this.updateContents();
};

/**
 * Returns the button caption, i.e. the text that is displayed in it.
 */
DropdownButton.prototype.getCaption = function () {
    return this.caption;
};

/**
 * Overridden.
 */
DropdownButton.prototype.getContentsHTML = function () {
    return this.getCaption();
};

/**
 * Overridden.
 */
DropdownButton.prototype.getHTML = function () {
    return "<table id =  '" + this.getId() + "' " + "onmousedown='" + this.getId() + ".onMouseDown()' " + "onmouseover='" + this.getId() + ".onMouseOver()' " + "onmouseout='" + this.getId() + ".onMouseOut()' " + "class='" + this.normalClassName + "' " + "cellspacing='0' cellpadding='0' border='0' width='100%'>" + "<tr>" + "<td class='top-left-border' colspan='2'></td>" + "<td class='top-left-cell'></td>" + "<td class='top-separator'></td>" + "<td class='top-right-cell'></td>" + "<td class='top-right-border' colspan='2'></td>" + "</tr>" + "<tr>" + "<td class='middle-left-border'></td>" + "<td class='middle-left-subborder'></td>" + "<td class='middle-left-cell dropdown-button-contents text' id='" + this.getContentsContainerId() + "'>" + this.getContentsHTML() + "</td>" + "<td id='" + this.getId() + "_middleSeparator' class='middle-separator'></td>" + "<td id='" + this.getId() + "_middleRightCell' class='middle-right-cell'><div class='arrow'></div></td>" + "<td class='middle-right-subborder'></td>" + "<td id='" + this.getId() + "_middleRightBorder' class='middle-right-border'></td>" + "</tr>" + "<tr>" + "<td class='bottom-left-border' colspan='2'></td>" + "<td class='bottom-left-cell'></td>" + "<td class='bottom-separator'></td>" + "<td class='bottom-right-cell'></td>" + "<td class='bottom-right-border' colspan='2'></td>" + "</tr>" + "</table>";
};

DropdownButton.prototype.getButtonTable = function () {
    return document.getElementById(this.getId());
};

/**
 * Overridden.
 * After rendering, disables text selection in the control and sets cursor to 'pointer'.
 */
DropdownButton.prototype.render = function () {
    this.base.prototype.render.call(this);

    var element = document.getElementById(this.getId());
    (0, _atBrowserUtils.disableTextSelection)(element);

    // although the cursor is set in CSS, it will be reset to default in disableTextSelection(),
    // so we set it here explicitly
    element.style.cursor = "pointer";
};

/**
 * Changes the CSS class of the topmost element of the button.
 * Used by default mouse events handlers.
 */
DropdownButton.prototype.setClassName = function (className) {
    var elem = document.getElementById(this.getId());
    if (!elem) return;
    elem.className = className;

    //a workaround for IE issue with multiple CSS classes processing
    var errorElem = elem.parentNode ? elem.parentNode : elem;
    if (this.displayErrorClass) (0, _atBrowserUtils.addClass)(errorElem, this.errorClassName);else (0, _atBrowserUtils.removeClass)(errorElem, this.errorClassName);
};

/**
 * Sets handler for the event that is fired just before the dropdown popup is shown.
 * @param handler is function(), that returns 'true' if we must not show popup, 'false' or 'undefined' otherwise.
 */
DropdownButton.prototype.setBeforePopupShowHandler = function (handler) {
    this.beforePopupShowHandler = handler;
};

/**
 * Sets handler for the event that is fired just after the dropdown popup is hidden,
 * and the button state is updated. 
 */
DropdownButton.prototype.setAfterPopupHideHandler = function (handler) {
    this.afterPopupHideHandler = handler;
};

/**
 * Default onMouseDown handler.
 * Shows or hides the DhtmlPanel and changes button CSS class accordingly.
 */
DropdownButton.prototype.onMouseDown = function () {
    if (!this.enabled || this.isEventProhibited()) return;

    if ((0, _atBrowserUtils.whichButtonPressed)(event) != 'left') {
        return;
    }

    if (this.pressed) {
        this.dhtmlPopup.setOwner(null);
        this.dhtmlPopup.hide(); // this will call unpress()
        (0, _atBrowserUtils.addClass)(this.getButtonTable(), this.hoverClassName);
        //this.setClassName(this.hoverClassName);
    } else {
        if (this.beforePopupShowHandler) {
            var handled = this.beforePopupShowHandler();

            if (handled) return;
        }

        this.pressed = true;
        this.setClassName(this.activeClassName);

        // here is a workaround for additional offset on the right under IE, which is caused by border
        // width of inner element
        // TODO research an opportunity for common solution, in case of need to have border width more than 1px
        var borderOffsetX = navigator.appName == 'Microsoft Internet Explorer' ? 2 : 0;
        var offsetX = this.popupWidth && this.isOriginAtRight ? -this.popupWidth + (0, _atBrowserUtils.getObjectWidth)(this.getId()) - borderOffsetX : 2;
        var offsetY = this.isDropUp ? 1 : (0, _atBrowserUtils.getObjectHeight)(this.getId()) - 1;
        var width = this.popupWidth ? this.popupWidth : (0, _atBrowserUtils.getObjectWidth)(this.getId()) - 4;

        var target = event.target || event.srcElement;
        this.dhtmlPopup.setOwner(target);
        this.dhtmlPopup.show(offsetX, offsetY, width, null, this.isDropUp);
    }
};

/**
 * Default onMouseOver handler.
 * Changes button CSS class accordingly.
 */
DropdownButton.prototype.onMouseOver = function () {
    if (!this.enabled || this.isEventProhibited()) return;

    if (!this.pressed) {
        (0, _atBrowserUtils.addClass)(this.getButtonTable(), this.hoverClassName);
        //this.setClassName(this.hoverClassName);
    }
};

/**
 * Default onMouseOut handler.
 * Changes button CSS class accordingly.
 */
DropdownButton.prototype.onMouseOut = function () {
    if (!this.enabled || this.isEventProhibited()) return;

    if (!this.pressed) {
        (0, _atBrowserUtils.removeClass)(this.getButtonTable(), this.hoverClassName);
        //this.setClassName(this.normalClassName);
    }
};

/**
 * Unpresses the button, changing its state and CSS class.
 * Used as a handler for the DhtmlPanel afterHide event.
 */
DropdownButton.prototype.unpress = function () {
    if (!this.enabled || this.isEventProhibited()) return;

    this.pressed = false;
    this.setClassName(this.normalClassName);
    if (this.afterPopupHideHandler) this.afterPopupHideHandler();
};

/**
 * Enables or disables listbox
 */
DropdownButton.prototype.setEnabled = function (enable) {
    this.enabled = enable;

    var element = document.getElementById(this.getId());

    if (enable) {
        this.setClassName(this.normalClassName);
        element.style.cursor = "pointer";
    } else {
        this.setClassName(this.disabledClassName);
        element.style.cursor = "default";
    }
};

/**
 * Sets listbox in rpc saving state
 */
DropdownButton.prototype.setSaving = function (saving) {
    var table = document.getElementById(this.getId());
    var middleSeparator = document.getElementById(this.getId() + "_middleSeparator");
    var middleRightCell = document.getElementById(this.getId() + "_middleRightCell");
    var middleRightBorder = document.getElementById(this.getId() + "_middleRightBorder");

    if (saving) {
        this.setClassName(this.savingClassName);
        table.style.cursor = "default";
        middleSeparator.style.display = "none";
        middleRightCell.style.display = "none";
        middleRightBorder.colSpan = 3;
    } else {
        this.setClassName(this.normalClassName);
        table.style.cursor = "pointer";
        middleSeparator.style.display = "";
        middleRightCell.style.display = "";
        middleRightBorder.colSpan = 1;
    }
};

DropdownButton.prototype.setDisplayError = function (display) {
    this.displayErrorClass = display;
};

DropdownButton.prototype.isEventProhibited = function () {
    return false;
};

/***/ }),
/* 1322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _PermissionsTemplateView = __webpack_require__(754);

var _PermissionsTemplateView2 = _interopRequireDefault(_PermissionsTemplateView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CreatePermissionsTemplateView = function (_PermissionTemplatesV) {
    _inherits(CreatePermissionsTemplateView, _PermissionTemplatesV);

    function CreatePermissionsTemplateView($containerEl, params) {
        _classCallCheck(this, CreatePermissionsTemplateView);

        var _this = _possibleConstructorReturn(this, (CreatePermissionsTemplateView.__proto__ || Object.getPrototypeOf(CreatePermissionsTemplateView)).call(this, $containerEl, params));

        _this.state.id = null;
        return _this;
    }

    _createClass(CreatePermissionsTemplateView, [{
        key: "afterRender",
        value: function afterRender() {
            _get(CreatePermissionsTemplateView.prototype.__proto__ || Object.getPrototypeOf(CreatePermissionsTemplateView.prototype), "afterRender", this).call(this);
            this.$el.addClass("createTemplateView");
            this.$resetButton.hide();
        }
    }]);

    return CreatePermissionsTemplateView;
}(_PermissionsTemplateView2.default);

exports.default = CreatePermissionsTemplateView;

/***/ }),
/* 1323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _constants = __webpack_require__(755);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PermissionRow = function (_TemplateView) {
    _inherits(PermissionRow, _TemplateView);

    function PermissionRow($containerEl, permissionId, permissionResources) {
        _classCallCheck(this, PermissionRow);

        var _this = _possibleConstructorReturn(this, (PermissionRow.__proto__ || Object.getPrototypeOf(PermissionRow)).call(this, $containerEl));

        _this.id = permissionId;

        _this.state = {
            checked: false,
            disabled: false,
            lastRow: false,
            name: permissionResources.name
        };

        _this.onStatePropertyChanged('checked', function (checked) {
            _this.$el.toggleClass('active', checked);
            _this.$el.toggleClass('inactive', !checked);
            _this.icon.toggleClass('inactive', !checked);
        });

        _this.onStatePropertyChanged('disabled', function (disabled) {
            _this.$el.toggleClass('disabled', disabled);
        });
        _this.onStatePropertyChanged('lastRow', function (lastRow) {
            _this.$el.toggleClass('lastRow', lastRow);
        });

        _this.onStatePropertyChanged('name', function (name) {
            _this.$name.text(name);
        });
        return _this;
    }

    _createClass(PermissionRow, [{
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='userPanel_permissionRow'>" + "    <div class='checkbox'><div class='img'/></div>" + "    <div class='icon <%-iconClass%>'/>" + "    <div class='name'></div>" + "</div>";
        }
    }, {
        key: "templateModel",
        value: function templateModel() {
            return {
                iconClass: _constants.PERMISSION_ICON_CLASS[this.id]
            };
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            var _this2 = this;

            this.icon = this.find('.icon');
            this.bindClick(function () {
                if (!_this2.state.disabled) {
                    _this2.trigger('changed', [_this2.id, !_this2.state.checked]);
                }
            });

            this.$name = this.find('.name');

            this.renderInitialState();
        }
    }, {
        key: "update",
        value: function update() {
            this.$el.toggleClass('active', this.state.checked);
            this.$el.toggleClass('inactive', !this.state.checked);
            this.icon.toggleClass('inactive', !this.state.checked);
        }
    }, {
        key: "toggle",
        value: function toggle(needToDisplay) {
            this.$el.toggle(needToDisplay);
        }
    }, {
        key: "getId",
        value: function getId() {
            return this.id;
        }
    }]);

    return PermissionRow;
}(_TemplateView3.default);

exports.default = PermissionRow;

/***/ }),
/* 1324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _PermissionsTemplateView = __webpack_require__(754);

var _PermissionsTemplateView2 = _interopRequireDefault(_PermissionsTemplateView);

var _constants = __webpack_require__(4);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EditPermissionsTemplateView = function (_PermissionTemplatesV) {
    _inherits(EditPermissionsTemplateView, _PermissionTemplatesV);

    function EditPermissionsTemplateView($containerEl, params) {
        _classCallCheck(this, EditPermissionsTemplateView);

        var _this = _possibleConstructorReturn(this, (EditPermissionsTemplateView.__proto__ || Object.getPrototypeOf(EditPermissionsTemplateView)).call(this, $containerEl, params));

        _this.state = _extends({}, _this.state, {
            id: null
        });
        _this.onResetButtonClick = params.onResetButtonClick;

        _this.onStatePropertyChanged('id', function () {
            _this._updateInput();
        });
        return _this;
    }

    _createClass(EditPermissionsTemplateView, [{
        key: 'afterRender',
        value: function afterRender() {
            _get(EditPermissionsTemplateView.prototype.__proto__ || Object.getPrototypeOf(EditPermissionsTemplateView.prototype), 'afterRender', this).call(this);
            this.$el.addClass("editTemplateView");
            this.$resetButton.click(this.onResetButtonClick);

            this._updateInput();
        }
    }, {
        key: '_updateInput',
        value: function _updateInput() {
            var isDefaultTemplate = this.state.id === _constants.DEFAULT_PERMISSIONS_TEMPLATE_ID;
            this.find('.permissionsTemplateName').toggleClass('disabled', isDefaultTemplate);
            this.$nameInput.attr('disabled', isDefaultTemplate);
            if (isDefaultTemplate) {
                this._updateDefaultTemplateName();
            }
        }
    }, {
        key: '_updateDefaultTemplateName',
        value: function _updateDefaultTemplateName() {
            this.$nameInput.pVal(this.state.name + ' ' + _messageResource2.default.getMessage('userlist.userdata.permissions_templates.js.menu.row.default_template'));
        }
    }]);

    return EditPermissionsTemplateView;
}(_PermissionsTemplateView2.default);

exports.default = EditPermissionsTemplateView;

/***/ }),
/* 1325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _PermissionsTemplatesMenu = __webpack_require__(753);

var _PermissionsTemplatesMenu2 = _interopRequireDefault(_PermissionsTemplatesMenu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PermissionsTemplatesMenuWithoutChoosing = function (_PermissionsTemplates) {
    _inherits(PermissionsTemplatesMenuWithoutChoosing, _PermissionsTemplates);

    function PermissionsTemplatesMenuWithoutChoosing() {
        _classCallCheck(this, PermissionsTemplatesMenuWithoutChoosing);

        return _possibleConstructorReturn(this, (PermissionsTemplatesMenuWithoutChoosing.__proto__ || Object.getPrototypeOf(PermissionsTemplatesMenuWithoutChoosing)).apply(this, arguments));
    }

    _createClass(PermissionsTemplatesMenuWithoutChoosing, [{
        key: "_appendInnerRowContent",
        value: function _appendInnerRowContent(rowInnerContent, templateData, isDefaultRow) {
            var context = this;
            var templateName = this._generateTemplateName(templateData, isDefaultRow);
            templateName.on('click', function () {
                if (context.isDisabledControls) {
                    return;
                }
                context.onEditTemplateCallback(templateData);
            });
            rowInnerContent.append(templateName);
        }
    }]);

    return PermissionsTemplatesMenuWithoutChoosing;
}(_PermissionsTemplatesMenu2.default);

exports.default = PermissionsTemplatesMenuWithoutChoosing;

/***/ }),
/* 1326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _DropdownTemplateView2 = __webpack_require__(42);

var _DropdownTemplateView3 = _interopRequireDefault(_DropdownTemplateView2);

var _ScrollView = __webpack_require__(346);

var _ScrollView2 = _interopRequireDefault(_ScrollView);

var _atUtils = __webpack_require__(5);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SimpleListMenu = function (_DropdownTemplateView) {
    _inherits(SimpleListMenu, _DropdownTemplateView);

    function SimpleListMenu(_ref) {
        var _ref$onItemClick = _ref.onItemClick,
            onItemClick = _ref$onItemClick === undefined ? function (item) {} : _ref$onItemClick,
            _ref$itemHtmlCallback = _ref.itemHtmlCallback,
            itemHtmlCallback = _ref$itemHtmlCallback === undefined ? defaultItemHtmlCallback : _ref$itemHtmlCallback,
            extraClass = _ref.extraClass,
            _ref$itemHeight = _ref.itemHeight,
            itemHeight = _ref$itemHeight === undefined ? 20 : _ref$itemHeight,
            _ref$onHide = _ref.onHide,
            onHide = _ref$onHide === undefined ? function () {} : _ref$onHide,
            _ref$onShow = _ref.onShow,
            onShow = _ref$onShow === undefined ? function () {} : _ref$onShow;

        _classCallCheck(this, SimpleListMenu);

        var _this = _possibleConstructorReturn(this, (SimpleListMenu.__proto__ || Object.getPrototypeOf(SimpleListMenu)).call(this, null, {
            onHide: onHide,
            onShow: onShow
        }));

        _this._itemClickHandler = function (item) {
            _this.onItemClick(item);
            _this.hide();
        };

        _this.onItemClick = onItemClick;
        _this.itemHtmlCallback = itemHtmlCallback;
        _this.extraClass = extraClass;
        _this.items = [];
        _this.itemHeight = itemHeight;
        return _this;
    }

    _createClass(SimpleListMenu, [{
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='dropdownContainer simpleListMenu <%=extraClass%>'></div>";
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            this.scrollView = new _ScrollView2.default(this.getEl(), this.itemHeight).init();
            var self = this;
            this.bindClick(function (clickEvent) {
                self.trigger('click', clickEvent.originalEvent);
            });
        }
    }, {
        key: "getItems",
        value: function getItems() {
            return this.items;
        }
    }, {
        key: "getItem",
        value: function getItem(item) {
            return this.scrollView.getItems().find(function (itemContainer) {
                return _underscore2.default.isEqual(itemContainer.getItemInformation(), item);
            });
        }
    }, {
        key: "unselectAll",
        value: function unselectAll() {
            this.selectItem(null);
        }
    }, {
        key: "selectItem",
        value: function selectItem(item) {
            this.scrollView.getItems().forEach(function (itemContainer) {
                itemContainer.setState({
                    selected: _underscore2.default.isEqual(itemContainer.getItemInformation(), item)
                });
            });
        }
    }, {
        key: "setItems",
        value: function setItems(items) {
            var _this2 = this;

            this.items = items;

            this.scrollView.setItems(items.map(function (item) {
                return new Item(item, _this2.itemHtmlCallback, _this2._itemClickHandler);
            }));
        }
    }, {
        key: "onShow",
        value: function onShow() {
            _get(SimpleListMenu.prototype.__proto__ || Object.getPrototypeOf(SimpleListMenu.prototype), "onShow", this).call(this);
            this.scrollView.refreshScroll();
        }
    }, {
        key: "mouseDownTargetElement",
        value: function mouseDownTargetElement() {
            return (0, _jquery2.default)('body');
        }
    }]);

    return SimpleListMenu;
}(_DropdownTemplateView3.default);

exports.default = SimpleListMenu;

var Item = function (_TemplateView) {
    _inherits(Item, _TemplateView);

    function Item(item, itemHtmlCallback, clickHandler) {
        _classCallCheck(this, Item);

        var _this3 = _possibleConstructorReturn(this, (Item.__proto__ || Object.getPrototypeOf(Item)).call(this));

        _this3._handleSelection = function () {
            _this3.getEl() && _this3.getEl().toggleClass('selected', _this3.state.selected);
        };

        _this3.item = item;
        _this3.itemHtmlCallback = itemHtmlCallback;
        _this3.clickHandler = clickHandler;

        _this3.state = {
            selected: false
        };

        _this3.onStatePropertyChanged('selected', _this3._handleSelection);
        return _this3;
    }

    _createClass(Item, [{
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='item'></div>";
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            var _this4 = this;

            this.$el.html(this.itemHtmlCallback(this.item));
            this.$el.click(function (e) {
                _this4.clickHandler(_this4.item);
                e.stopPropagation();
            });
            this._handleSelection();
        }
    }, {
        key: "getItemInformation",
        value: function getItemInformation() {
            return this.item;
        }
    }]);

    return Item;
}(_TemplateView3.default);

var defaultItemHtmlCallback = function defaultItemHtmlCallback(item) {
    return (0, _atUtils.escapeHtmlSymbols)(item.name);
};

/***/ }),
/* 1327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _AuditHistoryView = __webpack_require__(228);

var _AuditHistoryView2 = _interopRequireDefault(_AuditHistoryView);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _ResizableInput = __webpack_require__(287);

var _ResizableInput2 = _interopRequireDefault(_ResizableInput);

var _TaskStore = __webpack_require__(91);

var _TaskStore2 = _interopRequireDefault(_TaskStore);

var _ProgressBar = __webpack_require__(1328);

var _ProgressBar2 = _interopRequireDefault(_ProgressBar);

var _TaskStatusButton = __webpack_require__(240);

var _TaskStatusButton2 = _interopRequireDefault(_TaskStatusButton);

var _index = __webpack_require__(22);

var _selectors = __webpack_require__(57);

var _CommentsSection = __webpack_require__(1329);

var _CommentsSection2 = _interopRequireDefault(_CommentsSection);

var _TimeEditor = __webpack_require__(767);

var _TimeEditor2 = _interopRequireDefault(_TimeEditor);

var _TaskStatusMenu = __webpack_require__(289);

var _TaskStatusMenu2 = _interopRequireDefault(_TaskStatusMenu);

var _Description = __webpack_require__(290);

var _ClassicBridge = __webpack_require__(18);

var _ClassicBridge2 = _interopRequireDefault(_ClassicBridge);

var _utils = __webpack_require__(25);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TaskPanelDetails = function (_TemplateView) {
    _inherits(TaskPanelDetails, _TemplateView);

    function TaskPanelDetails(_ref) {
        var editable = _ref.editable,
            _ref$showComments = _ref.showComments,
            showComments = _ref$showComments === undefined ? false : _ref$showComments,
            dateFormat = _ref.dateFormat,
            _ref$scrollToElementC = _ref.scrollToElementCb,
            scrollToElementCb = _ref$scrollToElementC === undefined ? function () {} : _ref$scrollToElementC,
            _ref$refreshScrollCb = _ref.refreshScrollCb,
            refreshScrollCb = _ref$refreshScrollCb === undefined ? function () {} : _ref$refreshScrollCb,
            _ref$onStatusChangedC = _ref.onStatusChangedCb,
            onStatusChangedCb = _ref$onStatusChangedC === undefined ? function () {} : _ref$onStatusChangedC,
            _ref$onDeadlineChange = _ref.onDeadlineChangedCb,
            onDeadlineChangedCb = _ref$onDeadlineChange === undefined ? function () {} : _ref$onDeadlineChange,
            _ref$onTypeOfWorkChan = _ref.onTypeOfWorkChangedCb,
            onTypeOfWorkChangedCb = _ref$onTypeOfWorkChan === undefined ? function () {} : _ref$onTypeOfWorkChan,
            _ref$onEstimateChange = _ref.onEstimateChangedCb,
            onEstimateChangedCb = _ref$onEstimateChange === undefined ? function () {} : _ref$onEstimateChange,
            _ref$onDescriptionCha = _ref.onDescriptionChangeCb,
            onDescriptionChangeCb = _ref$onDescriptionCha === undefined ? function () {} : _ref$onDescriptionCha,
            _ref$onCustomFieldCha = _ref.onCustomFieldChangeCb,
            onCustomFieldChangeCb = _ref$onCustomFieldCha === undefined ? function () {} : _ref$onCustomFieldCha,
            _ref$loadAuditHistory = _ref.loadAuditHistoryCb,
            loadAuditHistoryCb = _ref$loadAuditHistory === undefined ? function () {} : _ref$loadAuditHistory,
            _ref$onHistoryClickCb = _ref.onHistoryClickCb,
            onHistoryClickCb = _ref$onHistoryClickCb === undefined ? function () {} : _ref$onHistoryClickCb;

        _classCallCheck(this, TaskPanelDetails);

        var _this = _possibleConstructorReturn(this, (TaskPanelDetails.__proto__ || Object.getPrototypeOf(TaskPanelDetails)).call(this));

        _this.params = {
            dateFormat: dateFormat,
            showComments: showComments
        };

        _this.state = {
            id: 0,
            canReopenProject: false,
            canEditTaskStatus: true,
            taskEstimatedTime: 0,
            taskSpentTime: 0,
            taskDescription: '',
            typeOfWork: {
                id: 0,
                name: '',
                billable: false
            },
            typesOfWork: [],
            completed: false,
            workflowStatusId: 0,
            deadline: null,

            taskDescriptionLoading: false,
            deadlineLoading: false,
            typeOfWorkLoading: false,
            estimateLoading: false,
            statusLoading: false,

            editable: editable,

            isBTYEnabled: false,
            isTWSEnabled: false,
            isESTEnabled: false,

            auditActions: [],
            auditDependencies: [],
            lastAuditActions: {
                createAction: null,
                updateAction: null
            },
            allAuditHistoryLoaded: false,

            customFields: [],
            customFieldsValues: {},
            readonlyFields: []
        };

        _this.callbacks = {
            scrollToElementCb: scrollToElementCb,
            refreshScrollCb: refreshScrollCb,
            onStatusChangedCb: onStatusChangedCb,
            onDeadlineChangedCb: onDeadlineChangedCb,
            onEstimateChangedCb: onEstimateChangedCb,
            onTypeOfWorkChangedCb: onTypeOfWorkChangedCb,
            onDescriptionChangeCb: onDescriptionChangeCb,
            onCustomFieldChangeCb: onCustomFieldChangeCb,
            loadAuditHistoryCb: loadAuditHistoryCb,
            onHistoryClickCb: onHistoryClickCb
        };

        _this.onStatePropertyChanged('editable', function (editable) {
            _this.description.setState({
                editable: editable,
                placeholder: !editable ? _messageResource2.default.getMessage('panel.common.description.no_description') : _messageResource2.default.getMessage('task.edit_panel.description.empty')
            });
            _this.estimatedTimeEditor.setEditable(editable);
        });

        _this.onStatePropertyChanged('canEditTaskStatus', function (canEditTaskStatus) {
            if (_this.taskStatusButton && _this.taskStatusButton.setEditable) {
                _this.taskStatusButton.setEditable(canEditTaskStatus);
            }
        });

        _this.onStatePropertyChanged('canReopenProject', function (canReopenProject) {
            _this.taskStatusButton.setState({
                canReopenProject: canReopenProject
            });
        });

        _this.onAnyStatePropertyChanged(['taskEstimatedTime', 'isESTEnabled'], function (_ref2) {
            var taskEstimatedTime = _ref2.taskEstimatedTime,
                isESTEnabled = _ref2.isESTEnabled;

            _this.estimatedTimeEditor.setTime(isESTEnabled ? taskEstimatedTime : null);
            _this.progressBar.setEstimatedTime(taskEstimatedTime);
            _this.progressBar.update();
        });

        _this.onStatePropertyChanged('taskSpentTime', function (time) {
            _this.progressBar.setSpentTime(time);
            _this.progressBar.update();
        });

        _this.onStatePropertyChanged('taskDescription', function (description) {
            _this.description.setState({ text: description });
        });

        _this.onStatePropertyChanged('typesOfWork', function (typesOfWork) {
            _this.integratedDetails.setProps({
                typesOfWork: typesOfWork
            });
        });

        _this.onStatePropertyChanged('typeOfWork', function (typeOfWork) {
            _this.integratedDetails.setProps({
                typeOfWorkId: typeOfWork.id
            });
        });

        _this.onAnyStatePropertyChanged(['completed', 'workflowStatusId', 'isTWSEnabled'], function (state) {
            var isTWSEnabled = state.isTWSEnabled;
            _this.taskStatusButton.setState({
                statusId: isTWSEnabled ? state.workflowStatusId : (0, _selectors.selectFakeStatusIdByTaskComplete)(state.completed)
            });
        });

        _this.onStatePropertyChanged('deadline', function (date) {
            _this.integratedDetails.setProps({
                deadlineDate: date
            });
        });

        _this.onStatePropertyChanged('taskDescriptionLoading', function (loading) {
            return _this.description.setState({ loading: loading });
        });
        _this.onStatePropertyChanged('deadlineLoading', function (loading) {});
        _this.onStatePropertyChanged('typeOfWorkLoading', function (loading) {});
        _this.onStatePropertyChanged('estimateLoading', function (loading) {
            return _this.estimatedTimeEditor.setLoading(loading);
        });
        _this.onStatePropertyChanged('statusLoading', function (loading) {
            return _this.taskStatusButton.setLoading(loading);
        });

        _this.onStatePropertyChanged('isBTYEnabled', function (enabled) {
            _this.integratedDetails.setProps({
                typeOfWorkEditorAvailable: enabled
            });
        });

        _this.onStatePropertyChanged('isESTEnabled', function (enabled) {
            _this.$estimateSection.toggle(enabled);
        });

        _this.onStatePropertyChanged('lastAuditActions', function (actions) {
            _this.setAuditHistory(actions.createAction, actions.updateAction);
        });

        _this.onStatePropertyChanged('auditActions', function (actions, oldActions) {
            _this.setAuditRecords(actions);
            //            this.addAuditRecords(actions.slice(actions.length - oldActions.length, actions.length))
        });

        _this.onStatePropertyChanged('allAuditHistoryLoaded', function (allAuditHistoryLoaded) {
            _this.auditHistory.setState({ allAuditHistoryLoaded: allAuditHistoryLoaded });
        });

        _this.onAnyStatePropertyChanged(['customFields', 'customFieldsValues'], function (state) {
            _this.integratedDetails.setProps({
                customFields: state.customFields,
                customFieldsValues: state.customFieldsValues
            });
        });

        _this.onStatePropertyChanged('readonlyFields', function (readonlyFields) {
            _this.integratedDetails.setProps({
                readonlyFields: readonlyFields
            });
        });
        return _this;
    }

    _createClass(TaskPanelDetails, [{
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='detailsTab panelTab'>" + " <div class='detailsSection section'>" + "     <div class='auditHistoryPlaceholder'/>" + "     <div class='detailsHeader sectionHeader'><%=details%></div>" + "     <div class='detailsRow'>" + "         <div class='statusCell'><div class='cellHeader'><%=status%></div><div class='cellButton'/></div>" + "         <div class='atNextTaskTableDetailsMountPoint atNextMount'></div>" + "     </div>" + " </div>" + " <div class='estimateSection section'>" + "     <div class='estimateHeader sectionHeader'><%=estimate%></div>" + "     <div class='collapseButton'/>" + "     <div class='estimateRow'>" + "         <div class='estimatedHours'><%=estimatedHours%>:</div>" + "         <div class='estimatedTimeWrapper'/>" + "         <div class='progress'/>" + "     </div>" + " </div>" + " <div class='descriptionSection section'>" + "  <div class='title sectionHeader'><%=description%></div>" + "  <div class='description'></div>" + " </div>" + " <div class='commentsSectionPlaceholder'/>" + "</div>";
        }
    }, {
        key: "shouldUpdateOnInit",
        value: function shouldUpdateOnInit() {
            return false;
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            var _this2 = this;

            this.$detailsRow = this.find(".detailsRow");

            this.auditHistory = new _AuditHistoryView2.default({
                extraClass: 'taskAudit',
                loadAuditRecordsCb: this.callbacks.loadAuditHistoryCb,
                onHistoryClickCb: this.callbacks.onHistoryClickCb
            }).init(this.find('.auditHistoryPlaceholder'));
            var $statusCellButton = this.find('.statusCell .cellButton');
            this.taskStatusButton = new _TaskStatusButton2.default({
                editable: true,
                showStatusTypePrefix: (0, _index.isEnabled)(_index.Feature.TWS),
                positionParams: {
                    offset: "0px 1px",
                    within: this.$el,
                    collision: 'fit'
                },
                onStatusChangedCb: this.callbacks.onStatusChangedCb,
                taskStatusMenu: new _TaskStatusMenu2.default($statusCellButton).init()
            }).init($statusCellButton);
            this.auditHistory.setDateFormat(this.params.dateFormat);

            this.$descriptionSection = this.find('.descriptionSection');
            this.$description = this.find(".description");
            this.description = new _Description.Description({
                onChange: this.callbacks.onDescriptionChangeCb
            }).init(this.$description);
            this.description.setState({
                placeholder: _messageResource2.default.getMessage('task.edit_panel.description.empty'),
                editable: this.state.editable
            });

            this.$estimateSection = this.find(".estimateSection");
            this.estimatedTimeEditor = new _TimeEditor2.default(this.find('.estimatedTimeWrapper'), this.state.editable, _messageResource2.default.getMessage('task.time_editor_placeholder.enter_hours'), _messageResource2.default.getMessage('task.time_editor_placeholder.not_defined'), this.callbacks.onEstimateChangedCb).init();

            var $clearButton = (0, _jquery2.default)("<div class='clearButton'/>");
            this.estimatedTimeEditor.$el.append($clearButton);
            $clearButton.click(function () {
                _this2.estimatedTimeEditor._triggerChange(null);
            });

            this.progressBar = new _ProgressBar2.default(this.find('.progress')).init();
            this.estimatedTimeEditor.on('change', function (e, time) {
                _this2.progressBar.setEstimatedTime(time);
                _this2.progressBar.update();
            });

            var commentsSection = new _CommentsSection2.default({
                refreshScrollCb: this.callbacks.refreshScrollCb,
                scrollToElementCb: this.callbacks.scrollToElementCb
            }).init(this.find('.commentsSectionPlaceholder'));
            commentsSection.toggle(this.params.showComments);

            var $detailsMountPoint = this.find('.atNextTaskTableDetailsMountPoint');
            this.integratedDetails = _ClassicBridge2.default.integrateTaskPanelDetails($detailsMountPoint[0]);
            this.integratedDetails.setProps({
                onChangeDeadlineDate: function onChangeDeadlineDate(date) {
                    return _this2.callbacks.onDeadlineChangedCb(date);
                },
                onChangeTypeOfWork: function onChangeTypeOfWork(towId) {
                    return _this2.callbacks.onTypeOfWorkChangedCb(towId);
                },
                onChangeCustomField: function onChangeCustomField(field, value) {
                    return _this2.callbacks.onCustomFieldChangeCb(field, value);
                }
            });
            $detailsMountPoint.click(function (e) {
                return (0, _utils.setEventPreventHidingAllPanels)(e);
            });

            this.renderInitialState();
        }
    }, {
        key: "messageKeys",
        value: function messageKeys() {
            return {
                description: "task.edit_popup.task_description",
                details: 'task.edit_panel.sections.details',
                status: 'common.status',
                workType: 'task.edit_popup.task_billing_type',
                estimate: 'task.edit_panel.sections.estimate',
                estimatedHours: 'task.edit_popup.task_estimated_hours'
            };
        }
    }, {
        key: "update",
        value: function update() {
            var task = _TaskStore2.default.get(this.state.id);
            this.taskStatusButton.setState({
                statusId: (0, _selectors.selectStatusIdByTask)(task)
            });
            this.taskStatusButton.setEditable(this.state.editable);
            this.$estimateSection.toggle(this.state.isESTEnabled);
            this.estimatedTimeEditor.setTime(this.state.isESTEnabled ? task['estimatedTime'] : null);
            this.progressBar.setEstimatedTime(task['estimatedTime']);
            this.progressBar.update();
            this.description.setState({
                editable: this.state.editable,
                placeholder: !this.state.editable ? _messageResource2.default.getMessage('panel.common.description.no_description') : _messageResource2.default.getMessage('task.edit_panel.description.empty')
            });
        }
    }, {
        key: "hideSelectors",
        value: function hideSelectors() {
            // empty
        }
    }, {
        key: "clearAuditHistory",
        value: function clearAuditHistory() {
            this.auditHistory.hide();
        }
    }, {
        key: "setAuditHistory",
        value: function setAuditHistory(createAction, lastUpdateAction) {
            this.auditHistory.setAuditActions(createAction, lastUpdateAction, []);
        }
    }, {
        key: "addAuditRecords",
        value: function addAuditRecords(auditRecords, dependencies) {
            this.auditHistory.addRecords(auditRecords, dependencies);
        }
    }, {
        key: "setAuditRecords",
        value: function setAuditRecords(auditRecords) {
            this.auditHistory.setRecords(auditRecords);
        }
    }, {
        key: "hideAuditHistoryMenu",
        value: function hideAuditHistoryMenu() {
            this.auditHistory.auditHistoryMenu.hide();
        }
    }, {
        key: "setSelectorsDisabled",
        value: function setSelectorsDisabled(disabled) {
            this.taskStatusButton.setDisabled(disabled);
        }
    }, {
        key: "setDescription",
        value: function setDescription(description) {
            this.description.setState({ text: description });
        }
    }]);

    return TaskPanelDetails;
}(_TemplateView3.default);

exports.default = TaskPanelDetails;

/***/ }),
/* 1328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _user_time = __webpack_require__(30);

var _user_time2 = _interopRequireDefault(_user_time);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ProgressBar = function (_TemplateView) {
    _inherits(ProgressBar, _TemplateView);

    function ProgressBar($containerEl) {
        _classCallCheck(this, ProgressBar);

        return _possibleConstructorReturn(this, (ProgressBar.__proto__ || Object.getPrototypeOf(ProgressBar)).call(this, $containerEl));
    }

    _createClass(ProgressBar, [{
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='estimateBar'><div class='spentBar'/></div>" + "<div class='spent'><%=spent%>: <span class='spentValue'/>" + "</div>" + "<div class='ofEstimated'><%=of%> <span class='estimatedValue'/></div>";
        }
    }, {
        key: "messageKeys",
        value: function messageKeys() {
            return {
                spent: "task.edit_panel.spent",
                of: "common.of"
            };
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            this.spentTime = null;
            this.estimatedTime = null;
            this.$spent = this.$containerEl.find('.spent');
            this.$spentValue = this.find('.spentValue');
            this.$ofEsimated = this.$containerEl.find('.ofEstimated');
            this.$estimatedValue = this.find('.estimatedValue');
            this.$percent = this.find('.percent');
            this.$exceeded = this.find('.exceeded');
            this.$percentValue = this.find('.percentValue');
            this.$exceededValue = this.find('.exceededValue');
            this.$spentBar = this.find('.spentBar');
            this.$estimateBar = this.$containerEl.find('.estimateBar');
        }
    }, {
        key: "update",
        value: function update() {
            if (_underscore2.default.isNull(this.spentTime)) return;
            var estimated = _underscore2.default.isNumber(this.estimatedTime);
            var exceeded = estimated && this.spentTime > this.estimatedTime;
            this.$containerEl.toggleClass('withEstimate', estimated);
            this.$containerEl.toggleClass('exceeded', exceeded);
            var spentValString = _user_time2.default.formatTimeWithDigitSeparator(this.spentTime);
            if (estimated) {
                this.$estimatedValue.text(_user_time2.default.formatTimeWithDigitSeparator(this.estimatedTime));
                var ratio = this._calcRatio();
                var barWidth = this.$estimateBar.width();
                this.$spentBar.width((ratio <= 1 ? ratio : 1) * barWidth);
                if (this.spentTime > 0) {
                    spentValString += ' (' + (this.estimatedTime > 0 ? Math.round(ratio * 100) + '%' : '');
                }
                if (exceeded) {
                    spentValString += this.estimatedTime > 0 ? ', ' : '';
                    spentValString += _messageResource2.default.getMessage("task.edit_panel.exceeded") + ' ' + _user_time2.default.formatTimeWithDigitSeparator(this.spentTime - this.estimatedTime);
                }
                if (this.spentTime > 0) {
                    spentValString += ')';
                }
            }
            this.$spentValue.text(spentValString);
        }
    }, {
        key: "setEstimatedTime",
        value: function setEstimatedTime(estimatedTime) {
            this.estimatedTime = estimatedTime;
        }
    }, {
        key: "setSpentTime",
        value: function setSpentTime(spentTime) {
            this.spentTime = spentTime;
        }
    }, {
        key: "_calcRatio",
        value: function _calcRatio() {
            return this.spentTime / this.estimatedTime;
        }
    }]);

    return ProgressBar;
}(_TemplateView3.default);

exports.default = ProgressBar;

/***/ }),
/* 1329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _redux = __webpack_require__(7);

var _utils = __webpack_require__(6);

var _selectors = __webpack_require__(97);

var _selectors2 = __webpack_require__(19);

var _CommentsSection = __webpack_require__(487);

var _CommentsSection2 = _interopRequireDefault(_CommentsSection);

var _actions = __webpack_require__(81);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _utils.connect)(function (state) {
    return {
        comments: (0, _selectors.getComments)(state),
        users: (0, _selectors.getUsers)(state),
        commentsCount: (0, _selectors.getCommentsCount)(state),
        allCommentsUserIds: (0, _selectors.getAllCommentsUserIds)(state),
        loggedInUser: (0, _selectors2.getLoggedInUser)(state),
        isNewCommentsOnTop: (0, _selectors.isNewCommentsOnTop)(state),
        recentlyAddedCommentsIds: (0, _selectors.getRecentlyAddedCommentsIds)(state),
        commentsScrollTo: (0, _selectors.getCommentsScrollTo)(state),
        editingCommentId: (0, _selectors.getEditingCommentId)(state),
        editingCommentText: (0, _selectors.getEditingCommentText)(state),
        loading: (0, _selectors.isCommentsLoading)(state),
        sendingComment: (0, _selectors.isSendingComment)(state),
        updatingCommentId: (0, _selectors.getUpdatingCommentId)(state),
        canManage: (0, _selectors.isEditTaskPanelEditable)(state)
    };
}, function (dispatch) {
    return {
        loadMoreComments: (0, _redux.bindActionCreators)(_actions.loadMoreComments, dispatch),
        saveComment: (0, _redux.bindActionCreators)(_actions.saveComment, dispatch),
        deleteComment: (0, _redux.bindActionCreators)(_actions.deleteComment, dispatch),
        changeCommentsOrder: (0, _redux.bindActionCreators)(_actions.commentsActions.changeCommentsOrder, dispatch),
        resetCommentsScrollTo: (0, _redux.bindActionCreators)(_actions.commentsActions.resetCommentsScrollTo, dispatch),
        startEditComment: (0, _redux.bindActionCreators)(_actions.startEditComment, dispatch),
        cancelEditComment: (0, _redux.bindActionCreators)(_actions.commentsActions.cancelEditComment, dispatch),
        updateEditingCommentText: (0, _redux.bindActionCreators)(_actions.commentsActions.updateEditingCommentText, dispatch),
        saveEditingComment: (0, _redux.bindActionCreators)(_actions.saveEditingComment, dispatch)
    };
})(_CommentsSection2.default);

/***/ }),
/* 1330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getInstance = undefined;

var _constants = __webpack_require__(4);

var _utils = __webpack_require__(6);

var _selectors = __webpack_require__(15);

var _ATAccessRightsChecker = __webpack_require__(1331);

var _ATAccessRightsChecker2 = _interopRequireDefault(_ATAccessRightsChecker);

var _APAccessRightsChecker = __webpack_require__(1332);

var _APAccessRightsChecker2 = _interopRequireDefault(_APAccessRightsChecker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ATAccessRightsCheckerConnected = (0, _utils.connect)(function (state) {
    return {
        isBTYEnabled: (0, _selectors.isBTYEnabled)(state),
        isURAEnabled: (0, _selectors.isURAEnabled)(state),
        isLTTEnabled: (0, _selectors.isLTTEnabled)(state),
        isPTOEnabled: (0, _selectors.isPTOEnabled)(state),
        isSDBEnabled: (0, _selectors.isSDBEnabled)(state)
    };
})(_ATAccessRightsChecker2.default);

var APAccessRightsCheckerConnected = (0, _utils.connect)(function (state) {
    return {};
})(_APAccessRightsChecker2.default);

var instance = null;

var getInstance = exports.getInstance = function getInstance() {
    if (!instance) {
        if (_constants.CURRENT_PRODUCT === _constants.Product.actiTIME) {
            instance = new ATAccessRightsCheckerConnected().init();
        } else {
            instance = new APAccessRightsCheckerConnected().init();
        }
    }
    return instance;
};

/***/ }),
/* 1331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _View2 = __webpack_require__(20);

var _View3 = _interopRequireDefault(_View2);

var _constants = __webpack_require__(4);

var _constants2 = __webpack_require__(21);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ATAccessRightsChecker = function (_View) {
    _inherits(ATAccessRightsChecker, _View);

    function ATAccessRightsChecker() {
        _classCallCheck(this, ATAccessRightsChecker);

        var _this = _possibleConstructorReturn(this, (ATAccessRightsChecker.__proto__ || Object.getPrototypeOf(ATAccessRightsChecker)).call(this));

        _this.state = {
            isBTYEnabled: false,
            isURAEnabled: false,
            isLTTEnabled: false,
            isPTOEnabled: false,
            isSDBEnabled: false
        };
        return _this;
    }

    _createClass(ATAccessRightsChecker, [{
        key: 'hasManageUsersRight',
        value: function hasManageUsersRight(user) {
            return this._hasRightRegardlessFeature(user, _constants.AccessRights.MANAGE_USERS);
        }
    }, {
        key: 'hasSubmitOtherUsersTTRight',
        value: function hasSubmitOtherUsersTTRight(user) {
            return this._hasRightRegardlessFeature(user, _constants.AccessRights.SUBMIT_OTHER_USER_TIME_TRACK);
        }
    }, {
        key: 'hasEditHierarchyRight',
        value: function hasEditHierarchyRight(user) {
            return this._hasRightRegardlessFeature(user, _constants.AccessRights.EDIT_HIERARCHY);
        }
    }, {
        key: 'hasGenerateMoneyReportsRight',
        value: function hasGenerateMoneyReportsRight(user) {
            return (this.state.isBTYEnabled || this.state.isURAEnabled) && this._hasRightRegardlessFeature(user, _constants.AccessRights.GENERATE_MONEY_REPORTS);
        }
    }, {
        key: 'hasSubmitTTRight',
        value: function hasSubmitTTRight(user) {
            return this._hasRightRegardlessFeature(user, _constants.AccessRights.SUBMIT_TIME_TRACK);
        }
    }, {
        key: 'hasLockTTRight',
        value: function hasLockTTRight(user) {
            return this.state.isLTTEnabled && this._hasRightRegardlessFeature(user, _constants.AccessRights.LOCK_TIME_TRACK);
        }
    }, {
        key: 'hasManagePtoAndSickDays',
        value: function hasManagePtoAndSickDays(user) {
            return (this.state.isPTOEnabled || this.state.isSDBEnabled) && this._hasRightRegardlessFeature(user, _constants.AccessRights.MANAGE_PTO_AND_SICK);
        }
    }, {
        key: 'hasManageSystemSettingsRight',
        value: function hasManageSystemSettingsRight(user) {
            return this._hasRightRegardlessFeature(user, _constants.AccessRights.MANAGE_GENERAL_SETTINGS);
        }
    }, {
        key: 'canAccessManagersScope',
        value: function canAccessManagersScope(user) {
            return this.hasEditHierarchyRight(user) || this.hasManageUsersRight(user) || this.hasSubmitOtherUsersTTRight(user) || this.hasGenerateMoneyReportsRight(user);
        }
    }, {
        key: 'canAccessAllManagementScope',
        value: function canAccessAllManagementScope(user) {
            return this.canAccessManagersScope(user) && (this.hasManageUsersRight(user) || user.managementAssignmentsSelection === _constants.ManagementAssignmentsSelection.ALL);
        }
    }, {
        key: 'canAccessAllTeamScope',
        value: function canAccessAllTeamScope(user) {
            return this.canAccessManagersScope(user) && (this.hasManageUsersRight(user) || user.teamAssignmentType === _constants2.UserTeamAssignmentType.ALL);
        }
    }, {
        key: 'hasSomeTeamAssignment',
        value: function hasSomeTeamAssignment(user) {
            return this.canAccessManagersScope(user) && (this.hasManageUsersRight(user) || user.teamAssignmentType !== _constants2.UserTeamAssignmentType.NO);
        }
    }, {
        key: '_hasRightRegardlessFeature',
        value: function _hasRightRegardlessFeature(user, accessRight) {
            return user.accessRights.indexOf(accessRight) !== -1;
        }
    }]);

    return ATAccessRightsChecker;
}(_View3.default);

exports.default = ATAccessRightsChecker;

/***/ }),
/* 1332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _View2 = __webpack_require__(20);

var _View3 = _interopRequireDefault(_View2);

var _constants = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var APAccessRightsChecker = function (_View) {
    _inherits(APAccessRightsChecker, _View);

    function APAccessRightsChecker() {
        _classCallCheck(this, APAccessRightsChecker);

        var _this = _possibleConstructorReturn(this, (APAccessRightsChecker.__proto__ || Object.getPrototypeOf(APAccessRightsChecker)).call(this));

        _this.state = {};
        return _this;
    }

    _createClass(APAccessRightsChecker, [{
        key: '_hasRightRegardlessFeature',
        value: function _hasRightRegardlessFeature(user, accessRight) {
            return user.accessRights.indexOf(accessRight) !== -1;
        }
    }, {
        key: 'hasManageUsersRight',
        value: function hasManageUsersRight(user) {
            return this._hasRightRegardlessFeature(user, _constants.AccessRights.AP_MANAGE_GENERAL_SETTINGS);
        }
    }, {
        key: 'hasManageSystemSettingsRight',
        value: function hasManageSystemSettingsRight(user) {
            return this._hasRightRegardlessFeature(user, _constants.AccessRights.AP_MANAGE_GENERAL_SETTINGS);
        }
    }]);

    return APAccessRightsChecker;
}(_View3.default);

exports.default = APAccessRightsChecker;

/***/ }),
/* 1333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _atUtils = __webpack_require__(5);

var _CommentRow = __webpack_require__(1334);

var _CommentRow2 = _interopRequireDefault(_CommentRow);

var _UserInitialsIconColorPalette = __webpack_require__(1343);

var _constants = __webpack_require__(120);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CommentsList = function (_TemplateView) {
    _inherits(CommentsList, _TemplateView);

    function CommentsList(_ref) {
        var _ref$startEditComment = _ref.startEditComment,
            startEditComment = _ref$startEditComment === undefined ? function (id) {} : _ref$startEditComment,
            _ref$cancelEditCommen = _ref.cancelEditComment,
            cancelEditComment = _ref$cancelEditCommen === undefined ? function () {} : _ref$cancelEditCommen,
            _ref$updateEditingCom = _ref.updateEditingCommentText,
            updateEditingCommentText = _ref$updateEditingCom === undefined ? function (text) {} : _ref$updateEditingCom,
            _ref$saveEditingComme = _ref.saveEditingComment,
            saveEditingComment = _ref$saveEditingComme === undefined ? function () {} : _ref$saveEditingComme,
            _ref$onCommentDeleted = _ref.onCommentDeleted,
            onCommentDeleted = _ref$onCommentDeleted === undefined ? function (commentId) {} : _ref$onCommentDeleted,
            _ref$refreshScrollCb = _ref.refreshScrollCb,
            refreshScrollCb = _ref$refreshScrollCb === undefined ? function () {} : _ref$refreshScrollCb;

        _classCallCheck(this, CommentsList);

        var _this = _possibleConstructorReturn(this, (CommentsList.__proto__ || Object.getPrototypeOf(CommentsList)).call(this));

        _this.callbacks = {
            startEditComment: startEditComment,
            cancelEditComment: cancelEditComment,
            updateEditingCommentText: updateEditingCommentText,
            saveEditingComment: saveEditingComment,
            onCommentDeleted: onCommentDeleted,
            refreshScrollCb: refreshScrollCb
        };

        _this.state = {
            loggedInUser: null,
            users: {},
            comments: [],
            commentsCount: 0,
            allCommentsUserIds: [],
            isNewCommentsOnTop: true,
            recentlyAddedCommentsIds: {},
            editingCommentId: null,
            editingCommentText: '',
            updatingCommentId: null,
            readOnly: false,
            canManage: false
        };

        _this.colorPalette = new _UserInitialsIconColorPalette.UserInitialsIconColorPalette();
        _this.userIdColorsMap = {};
        _this.commentRows = {};

        _this.onStatePropertyChanged('loggedInUser', function (loggedInUser) {
            _this.userIdColorsMap[loggedInUser.id] = _constants.LOGGED_IN_USER_ICON_COLOR;
        });

        _this.onAnyStatePropertyChanged(['users', 'comments', 'allCommentsUserIds'], function (state, prevState) {
            if (!(0, _atUtils.isOrderFullyExistsAtTheBeginningOf)(prevState.comments, state.comments)) {
                _this.getEl().empty();
                _this.commentRows = {};
            }
            _this._updateCommentRows();
        });
        _this.onStatePropertyChanged('editingCommentId', function (id, prevId) {
            return _this._updateEditingComment(id, prevId);
        });
        _this.onStatePropertyChanged('updatingCommentId', function (id, prevId) {
            return _this._updateUpdatingComment(id, prevId);
        });
        _this.onAnyStatePropertyChanged(['recentlyAddedCommentsIds', 'readOnly', 'canManage'], function () {
            return _this._updateCommentRows();
        });
        return _this;
    }

    _createClass(CommentsList, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return "<div class='commentsList'/>";
        }
    }, {
        key: '_updateUsersColors',
        value: function _updateUsersColors() {
            var _this2 = this;

            this.state.allCommentsUserIds.filter(function (id) {
                return !_this2.userIdColorsMap[id];
            }).forEach(function (id) {
                return _this2.userIdColorsMap[id] = _this2.colorPalette.getNextColor();
            });
        }
    }, {
        key: '_updateCommentRows',
        value: function _updateCommentRows() {
            var _this3 = this;

            this._updateUsersColors();

            this.state.comments.forEach(function (comment) {
                if (!_this3.commentRows[comment.id]) {
                    _this3.commentRows[comment.id] = new _CommentRow2.default({
                        id: comment.id,
                        userInfo: _this3.state.users[comment.userId],
                        color: _this3.userIdColorsMap[comment.userId],
                        onDeleteIconClickCb: function onDeleteIconClickCb(id) {
                            return _this3._handleCommentDeleteClick(id);
                        },
                        onCommentDeleted: _this3.callbacks.onCommentDeleted,
                        onCommentEditStart: _this3.callbacks.startEditComment,
                        onCancelEdit: _this3.callbacks.cancelEditComment,
                        onCommentSave: _this3.callbacks.saveEditingComment,
                        onEditingTextChanged: _this3.callbacks.updateEditingCommentText,
                        refreshScrollCb: _this3.callbacks.refreshScrollCb
                    }).init(_this3.getEl());
                }

                _this3._updateRowState(comment);
            });
        }
    }, {
        key: '_updateRowState',
        value: function _updateRowState(comment) {
            this.commentRows[comment.id].setState({
                creationTimestamp: comment.creationTimestamp,
                updatingUser: this.state.users[comment.updatingUserId],
                updatingTimestamp: comment.updatingTimestamp,
                text: comment.text,
                canEdit: !this.state.readOnly && (this.state.canManage || comment.userId === this.state.loggedInUser.id),
                recentlyAdded: this.state.recentlyAddedCommentsIds[comment.id] === true,
                updating: this.state.updatingCommentId === comment.id
            });
        }
    }, {
        key: '_updateEditingComment',
        value: function _updateEditingComment(id, prevId) {
            if (prevId !== null) this.commentRows[prevId].setState({ inEdit: false });

            if (id !== null) {
                this.commentRows[id].setState({ inEdit: true });
            }
        }
    }, {
        key: '_updateUpdatingComment',
        value: function _updateUpdatingComment(id, prevId) {
            if (prevId !== null) this.commentRows[prevId].setState({ updating: false });

            if (id !== null) {
                this.commentRows[id].setState({ updating: true });
            }
        }
    }, {
        key: '_handleCommentDeleteClick',
        value: function _handleCommentDeleteClick(id) {
            if (this.state.editingCommentId !== null && this.state.editingCommentId !== id && this.state.updatingCommentId === null) {
                this.callbacks.saveEditingComment();
            }
        }
    }]);

    return CommentsList;
}(_TemplateView3.default);

exports.default = CommentsList;

/***/ }),
/* 1334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _UserInitialsIcon = __webpack_require__(758);

var _UserInitialsIcon2 = _interopRequireDefault(_UserInitialsIcon);

var _UserNameFormat = __webpack_require__(17);

var _UserNameFormat2 = _interopRequireDefault(_UserNameFormat);

var _date_format = __webpack_require__(16);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _EditCommentInput = __webpack_require__(1335);

var _EditCommentInput2 = _interopRequireDefault(_EditCommentInput);

var _Button = __webpack_require__(33);

var _Button2 = _interopRequireDefault(_Button);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _SimpleTooltip = __webpack_require__(36);

var _SimpleTooltip2 = _interopRequireDefault(_SimpleTooltip);

var _LoadingContainer = __webpack_require__(28);

var _LoadingContainer2 = _interopRequireDefault(_LoadingContainer);

var _string = __webpack_require__(759);

var _string2 = _interopRequireDefault(_string);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CommentRow = function (_TemplateView) {
    _inherits(CommentRow, _TemplateView);

    function CommentRow(_ref) {
        var id = _ref.id,
            userInfo = _ref.userInfo,
            _ref$color = _ref.color,
            color = _ref$color === undefined ? '' : _ref$color,
            _ref$onCommentEditSta = _ref.onCommentEditStart,
            onCommentEditStart = _ref$onCommentEditSta === undefined ? function () {} : _ref$onCommentEditSta,
            _ref$onCommentSave = _ref.onCommentSave,
            onCommentSave = _ref$onCommentSave === undefined ? function () {} : _ref$onCommentSave,
            _ref$onCancelEdit = _ref.onCancelEdit,
            onCancelEdit = _ref$onCancelEdit === undefined ? function () {} : _ref$onCancelEdit,
            _ref$onEditingTextCha = _ref.onEditingTextChanged,
            onEditingTextChanged = _ref$onEditingTextCha === undefined ? function () {} : _ref$onEditingTextCha,
            _ref$onDeleteIconClic = _ref.onDeleteIconClickCb,
            onDeleteIconClickCb = _ref$onDeleteIconClic === undefined ? function () {} : _ref$onDeleteIconClic,
            _ref$onCommentDeleted = _ref.onCommentDeleted,
            onCommentDeleted = _ref$onCommentDeleted === undefined ? function () {} : _ref$onCommentDeleted,
            _ref$refreshScrollCb = _ref.refreshScrollCb,
            refreshScrollCb = _ref$refreshScrollCb === undefined ? function () {} : _ref$refreshScrollCb;

        _classCallCheck(this, CommentRow);

        var _this = _possibleConstructorReturn(this, (CommentRow.__proto__ || Object.getPrototypeOf(CommentRow)).call(this));

        _this.params = {
            id: id,
            userInfo: userInfo,
            color: color
        };

        _this.callbacks = {
            onCommentEditStart: onCommentEditStart,
            onCommentSave: onCommentSave,
            onCancelEdit: onCancelEdit,
            onEditingTextChanged: onEditingTextChanged,
            onDeleteIconClickCb: onDeleteIconClickCb,
            onCommentDeleted: onCommentDeleted,
            refreshScrollCb: refreshScrollCb
        };

        _this.state = {
            creationTimestamp: null,
            updatingUser: null,
            updatingTimestamp: null,
            text: '',
            recentlyAdded: false,
            inEdit: false,
            editingText: '',
            canEdit: false,
            updating: false
        };

        _this.onStatePropertyChanged('creationTimestamp', function (creationTimestamp) {
            var timeLabel = new _date_format.DateFormat(window.SystemSettings.dateFormat, window.SystemSettings.clockFormat).formatDateTime(Date.parseJSONTimeWithoutTimeZone(creationTimestamp));
            _this.$creationTimestamp.text(timeLabel);
        });

        _this.onStatePropertyChanged('updatingUser', function () {
            return _this._updateEditedInfo();
        });

        _this.onStatePropertyChanged('text', function (text) {
            _this.$text.html((0, _string2.default)(text));
        });

        _this.onStatePropertyChanged('recentlyAdded', function (recentlyAdded) {
            return _this.$el.toggleClass('new', recentlyAdded);
        });

        _this.onStatePropertyChanged('inEdit', function () {
            return _this._toggleEditInput();
        });
        _this.onStatePropertyChanged('editingText', function (editingText) {
            return _this.editCommentInput.setState({ text: editingText });
        });

        _this.onStatePropertyChanged('canEdit', function (canEdit) {
            return _this.getEl().toggleClass('canEdit', canEdit);
        });

        _this.onStatePropertyChanged('updating', function (updating) {
            return _this.editCommentInputWrapper.setState({ loading: updating });
        });
        return _this;
    }

    _createClass(CommentRow, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return "<div class='commentRow'>" + "    <div class='userInitialsIconPlaceholder'></div>" + "    <div class='rightContainer'>" + "        <div class='commentHeader'>" + "            <div class='info'>" + "                <div class='username'><%-username%></div>" + "                <div class='creationTimestamp'/>" + "                <div class='updatingInfo'></div>" + "            </div>" + "            <div class='buttonsContainer'>" + "                <div class='editButton'/>" + "                <div class='separator'/>" + "                <div class='deleteButton'/>" + "            </div>" + "        </div>" + "        <div class='deleteConfirmationContainer'>" + "            <div class='deleteConfirmationTitle'><%=deleteConfirmationTitle%></div>" + "            <div class='deleteConfirmationButtons'/>" + "        </div>" + "        <div class='text'/>" + "        <div class='editCommentInputPlaceholder'/>" + "    </div>" + "</div>";
        }
    }, {
        key: 'messageKeys',
        value: function messageKeys() {
            return {
                deleteConfirmationTitle: 'panel.common.comments.delete_confirmation_title'
            };
        }
    }, {
        key: 'templateModel',
        value: function templateModel() {
            return {
                username: this._getUserName(this.params.userInfo)
            };
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            var _this2 = this;

            new _UserInitialsIcon2.default({
                firstName: this.params.userInfo.firstName,
                lastName: this.params.userInfo.lastName,
                color: this.params.color
            }).init(this.find('.userInitialsIconPlaceholder'));

            this.$commentHeader = this.find('.commentHeader');
            this.$buttonsContainer = this.find('.buttonsContainer');
            this.$deleteConfirmationContainer = this.find('.deleteConfirmationContainer');

            this.$creationTimestamp = this.find('.creationTimestamp');
            this.$updatingInfo = this.find('.updatingInfo');

            this.find('.deleteButton').click(function () {
                return _this2._handleDeleteBtnClick();
            });

            this.find('.editButton').click(function () {
                if (_this2.state.canEdit) _this2.callbacks.onCommentEditStart(_this2.params.id);
            });

            this.$text = this.find('.text');
            this.$editCommentInputPlaceholder = this.find('.editCommentInputPlaceholder');

            this.$deleteConfirmationContainer.hide();
        }
    }, {
        key: '_getUserName',
        value: function _getUserName(userInfo) {
            return _UserNameFormat2.default.formatFML(userInfo.firstName, userInfo.lastName, userInfo.middleName);
        }
    }, {
        key: '_toggleEditInput',
        value: function _toggleEditInput() {
            var _this3 = this;

            this.$text.toggle(!this.state.inEdit);

            if (this.state.inEdit) {
                this.editCommentInput = new _EditCommentInput2.default({
                    onCommentEditedCb: function onCommentEditedCb(text) {
                        return _this3._handleSaveChangesClick(text);
                    },
                    onCancelCb: this.callbacks.onCancelEdit,
                    onEditingTextChanged: this.callbacks.onEditingTextChanged,
                    refreshScrollCb: this.callbacks.refreshScrollCb
                });
                this.editCommentInput.setState({ text: this.state.text });

                this.editCommentInputWrapper = new _LoadingContainer2.default({
                    contentComponent: this.editCommentInput,
                    containerClass: 'editCommentInputLoadingWrapper'
                }).init(this.$editCommentInputPlaceholder);
            } else {
                this.$editCommentInputPlaceholder.empty();
                delete this.editCommentInput;
            }

            this.callbacks.refreshScrollCb();
        }
    }, {
        key: '_toggleDeleteConfirmation',
        value: function _toggleDeleteConfirmation(show) {
            var _this4 = this;

            this.getEl().toggleClass('confirmDelete', show);
            this.$deleteConfirmationContainer.toggle(show);
            this.$commentHeader.toggle(!show);

            if (show) {
                this.$deleteConfirmationButtons = this.find('.deleteConfirmationButtons');

                new _Button2.default({
                    additionalClass: 'confirmDeleteBtn',
                    label: _messageResource2.default.getMessage('panel.common.comments.delete_confirmation_button_text'),
                    onClickCb: function onClickCb() {
                        return _this4.callbacks.onCommentDeleted(_this4.params.id);
                    }
                }).init(this.$deleteConfirmationButtons);

                new _Button2.default({
                    additionalClass: 'cancelBtn',
                    label: _messageResource2.default.getMessage('common.cancel'),
                    onClickCb: function onClickCb() {
                        _this4._toggleDeleteConfirmation(false);
                    }
                }).init(this.$deleteConfirmationButtons);
            } else {
                this.$deleteConfirmationButtons.empty();
            }
        }
    }, {
        key: '_updateEditedInfo',
        value: function _updateEditedInfo() {
            var _this5 = this;

            if (this.state.updatingUser) {
                var timeLabel = new _date_format.DateFormat(window.SystemSettings.dateFormat, window.SystemSettings.clockFormat).formatDateTime(Date.parseJSONTimeWithoutTimeZone(this.state.updatingTimestamp));

                this.$updatingInfo.text(_messageResource2.default.getMessage('panel.common.comments.edited', [timeLabel])).show();

                var _tooltip = _getTooltip();
                _tooltip.subscribeToMouseEvents(this.$updatingInfo, function () {
                    var username = _this5._getUserName(_this5.state.updatingUser);
                    _tooltip.setText(_messageResource2.default.getMessage('panel.common.comments.edited_by_text', [username, timeLabel]));
                });
            }
        }
    }, {
        key: '_handleSaveChangesClick',
        value: function _handleSaveChangesClick(text) {
            if (this.state.text !== text) {
                this.callbacks.onCommentSave();
            } else {
                this.callbacks.onCancelEdit();
            }
        }
    }, {
        key: '_handleDeleteBtnClick',
        value: function _handleDeleteBtnClick() {
            if (this.state.canEdit) {
                this.callbacks.onDeleteIconClickCb(this.params.id);
                if (this.state.inEdit) {
                    this.callbacks.onCancelEdit();
                }
                this._toggleDeleteConfirmation(true);
            }
        }
    }], [{
        key: 'getTooltip',
        value: function getTooltip() {
            return _getTooltip();
        }
    }]);

    return CommentRow;
}(_TemplateView3.default);

exports.default = CommentRow;


var tooltip = void 0;

var _getTooltip = function _getTooltip() {
    if (!tooltip) tooltip = new _SimpleTooltip2.default({
        extraClass: 'commentEditedByTooltip'
    }).init((0, _jquery2.default)('body'));
    return tooltip;
};

/***/ }),
/* 1335 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _ResizableInput = __webpack_require__(287);

var _ResizableInput2 = _interopRequireDefault(_ResizableInput);

var _keyHandlers = __webpack_require__(48);

var _Button = __webpack_require__(33);

var _Button2 = _interopRequireDefault(_Button);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _constants = __webpack_require__(120);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EditCommentInput = function (_TemplateView) {
    _inherits(EditCommentInput, _TemplateView);

    function EditCommentInput(_ref) {
        var _ref$onCommentEditedC = _ref.onCommentEditedCb,
            onCommentEditedCb = _ref$onCommentEditedC === undefined ? function () {} : _ref$onCommentEditedC,
            _ref$onCancelCb = _ref.onCancelCb,
            onCancelCb = _ref$onCancelCb === undefined ? function () {} : _ref$onCancelCb,
            _ref$onEditingTextCha = _ref.onEditingTextChanged,
            onEditingTextChanged = _ref$onEditingTextCha === undefined ? function () {} : _ref$onEditingTextCha,
            _ref$refreshScrollCb = _ref.refreshScrollCb,
            refreshScrollCb = _ref$refreshScrollCb === undefined ? function () {} : _ref$refreshScrollCb;

        _classCallCheck(this, EditCommentInput);

        var _this = _possibleConstructorReturn(this, (EditCommentInput.__proto__ || Object.getPrototypeOf(EditCommentInput)).call(this));

        _this.callbacks = {
            onCommentEditedCb: onCommentEditedCb,
            onCancelCb: onCancelCb,
            onEditingTextChanged: onEditingTextChanged,
            refreshScrollCb: refreshScrollCb
        };

        _this.state = {
            text: ''
        };

        _this.onStatePropertyChanged('text', function (text) {
            _this.input.setState({ text: text });
            _this._update();
        });
        return _this;
    }

    _createClass(EditCommentInput, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return "<div class='components_commentInput'>" + "        <div class='inputArea'/>" + "        <div class='sendCommentLine'>" + "            <div class='errorText'/>" + "            <div class='buttonsContainer'/>" + "        </div>" + "</div>";
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            var _this2 = this;

            this.input = new _ResizableInput2.default({
                showCounter: false,
                heightLimit: 300,
                minHeight: 75,
                maxLength: _constants.NUMBER_ALLOWED_CHARACTERS,
                allowInputOverMaxLength: true,
                onBlur: function onBlur(text) {
                    if (text !== '') {
                        _this2.callbacks.onEditingTextChanged(text);
                    }
                },
                onKeyDown: function onKeyDown(e) {
                    return _this2._handleKeyDown(e);
                },
                onChange: function onChange(text) {
                    _this2.setState({ text: text });
                    _this2.callbacks.refreshScrollCb();
                }
            }).init(this.find('.inputArea'));
            this.input.focus();

            this.saveButton = new _Button2.default({
                additionalClass: 'saveChangesBtn',
                label: _messageResource2.default.getMessage('panel.common.comments.edit.save_changes'),
                onClickCb: function onClickCb() {
                    return _this2._handleSaveClick();
                }
            }).init(this.find('.buttonsContainer'));

            new _Button2.default({
                additionalClass: 'cancelBtn',
                label: _messageResource2.default.getMessage('common.cancel'),
                onClickCb: this.callbacks.onCancelCb
            }).init(this.find('.buttonsContainer'));

            this.$errorText = this.find('.errorText');

            this.renderInitialState();
        }
    }, {
        key: '_update',
        value: function _update() {
            var characterCount = this.state.text.length;
            var allowSend = this.state.text !== '' && characterCount <= _constants.NUMBER_ALLOWED_CHARACTERS;
            this.saveButton.setState({ disabled: !allowSend });
            this.$errorText.toggle(characterCount > _constants.NUMBER_ALLOWED_CHARACTERS);

            if (characterCount > _constants.NUMBER_ALLOWED_CHARACTERS) {
                var exceededCharacters = characterCount - _constants.NUMBER_ALLOWED_CHARACTERS;
                this.$errorText.text(_messageResource2.default.getMessage('panel.common.comments.number_characters_exceeded', [_constants.NUMBER_ALLOWED_CHARACTERS, exceededCharacters]));
            }
        }
    }, {
        key: '_handleSaveClick',
        value: function _handleSaveClick() {
            var text = this.input.getText();
            if (text !== '') {
                this.callbacks.onEditingTextChanged(text);
                this.callbacks.onCommentEditedCb();
            }
        }
    }, {
        key: '_handleKeyDown',
        value: function _handleKeyDown(e) {
            if ((0, _keyHandlers.isEnter)(e.keyCode) && ((0, _keyHandlers.isCtrlPressed)(e) || (0, _keyHandlers.isShiftPressed)(e))) {
                this._handleSaveClick();
            }
        }
    }]);

    return EditCommentInput;
}(_TemplateView3.default);

exports.default = EditCommentInput;

/***/ }),
/* 1336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DotsLoadingIndicator = function (_TemplateView) {
    _inherits(DotsLoadingIndicator, _TemplateView);

    function DotsLoadingIndicator() {
        _classCallCheck(this, DotsLoadingIndicator);

        return _possibleConstructorReturn(this, (DotsLoadingIndicator.__proto__ || Object.getPrototypeOf(DotsLoadingIndicator)).apply(this, arguments));
    }

    _createClass(DotsLoadingIndicator, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class=\'components_dotsLoadingIndicator\'>\n                    <span class=\'dot dot1\'/>\n                    <span class=\'dot dot2\'/>\n                    <span class=\'dot dot3\'/>\n                </div>';
        }
    }]);

    return DotsLoadingIndicator;
}(_TemplateView3.default);

exports.default = DotsLoadingIndicator;

/***/ }),
/* 1337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _linkify = __webpack_require__(1338);

var linkify = _interopRequireWildcard(_linkify);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var tokenize = linkify.tokenize,
    options = linkify.options; /**
                               	Convert strings of text into linkable HTML text
                               */

var Options = options.Options;


function escapeText(text) {
	return text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}

function escapeAttr(href) {
	return href.replace(/"/g, '&quot;');
}

function attributesToString(attributes) {
	if (!attributes) {
		return '';
	}
	var result = [];

	for (var attr in attributes) {
		var val = attributes[attr] + '';
		result.push(attr + '="' + escapeAttr(val) + '"');
	}
	return result.join(' ');
}

function linkifyStr(str) {
	var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

	opts = new Options(opts);

	var tokens = tokenize(str);
	var result = [];

	for (var i = 0; i < tokens.length; i++) {
		var token = tokens[i];

		if (token.type === 'nl' && opts.nl2br) {
			result.push('<br>\n');
			continue;
		} else if (!token.isLink || !opts.check(token)) {
			result.push(escapeText(token.toString()));
			continue;
		}

		var _opts$resolve = opts.resolve(token),
		    formatted = _opts$resolve.formatted,
		    formattedHref = _opts$resolve.formattedHref,
		    tagName = _opts$resolve.tagName,
		    className = _opts$resolve.className,
		    target = _opts$resolve.target,
		    attributes = _opts$resolve.attributes;

		var link = '<' + tagName + ' href="' + escapeAttr(formattedHref) + '"';

		if (className) {
			link += ' class="' + escapeAttr(className) + '"';
		}

		if (target) {
			link += ' target="' + escapeAttr(target) + '"';
		}

		if (attributes) {
			link += ' ' + attributesToString(attributes);
		}

		link += '>' + escapeText(formatted) + '</' + tagName + '>';
		result.push(link);
	}

	return result.join('');
}

if (!String.prototype.linkify) {
	try {
		Object.defineProperty(String.prototype, 'linkify', {
			set: function set() {},
			get: function get() {
				return function linkify(opts) {
					return linkifyStr(this, opts);
				};
			}
		});
	} catch (e) {
		// IE 8 doesn't like Object.defineProperty on non-DOM objects
		if (!String.prototype.linkify) {
			String.prototype.linkify = function (opts) {
				return linkifyStr(this, opts);
			};
		}
	}
}

exports.default = linkifyStr;

/***/ }),
/* 1338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.tokenize = exports.test = exports.scanner = exports.parser = exports.options = exports.inherits = exports.find = undefined;

var _class = __webpack_require__(361);

var _options = __webpack_require__(1339);

var options = _interopRequireWildcard(_options);

var _scanner = __webpack_require__(1340);

var scanner = _interopRequireWildcard(_scanner);

var _parser = __webpack_require__(1341);

var parser = _interopRequireWildcard(_parser);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

if (!Array.isArray) {
	Array.isArray = function (arg) {
		return Object.prototype.toString.call(arg) === '[object Array]';
	};
}

/**
	Converts a string into tokens that represent linkable and non-linkable bits
	@method tokenize
	@param {String} str
	@return {Array} tokens
*/
var tokenize = function tokenize(str) {
	return parser.run(scanner.run(str));
};

/**
	Returns a list of linkable items in the given string.
*/
var find = function find(str) {
	var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

	var tokens = tokenize(str);
	var filtered = [];

	for (var i = 0; i < tokens.length; i++) {
		var token = tokens[i];
		if (token.isLink && (!type || token.type === type)) {
			filtered.push(token.toObject());
		}
	}

	return filtered;
};

/**
	Is the given string valid linkable text of some sort
	Note that this does not trim the text for you.

	Optionally pass in a second `type` param, which is the type of link to test
	for.

	For example,

		test(str, 'email');

	Will return `true` if str is a valid email.
*/
var test = function test(str) {
	var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

	var tokens = tokenize(str);
	return tokens.length === 1 && tokens[0].isLink && (!type || tokens[0].type === type);
};

// Scanner and parser provide states and tokens for the lexicographic stage
// (will be used to add additional link types)
exports.find = find;
exports.inherits = _class.inherits;
exports.options = options;
exports.parser = parser;
exports.scanner = scanner;
exports.test = test;
exports.tokenize = tokenize;

/***/ }),
/* 1339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var defaults = {
	defaultProtocol: 'http',
	events: null,
	format: noop,
	formatHref: noop,
	nl2br: false,
	tagName: 'a',
	target: typeToTarget,
	validate: true,
	ignoreTags: [],
	attributes: null,
	className: 'linkified' // Deprecated value - no default class will be provided in the future
};

exports.defaults = defaults;
exports.Options = Options;
exports.contains = contains;


function Options(opts) {
	opts = opts || {};

	this.defaultProtocol = opts.hasOwnProperty('defaultProtocol') ? opts.defaultProtocol : defaults.defaultProtocol;
	this.events = opts.hasOwnProperty('events') ? opts.events : defaults.events;
	this.format = opts.hasOwnProperty('format') ? opts.format : defaults.format;
	this.formatHref = opts.hasOwnProperty('formatHref') ? opts.formatHref : defaults.formatHref;
	this.nl2br = opts.hasOwnProperty('nl2br') ? opts.nl2br : defaults.nl2br;
	this.tagName = opts.hasOwnProperty('tagName') ? opts.tagName : defaults.tagName;
	this.target = opts.hasOwnProperty('target') ? opts.target : defaults.target;
	this.validate = opts.hasOwnProperty('validate') ? opts.validate : defaults.validate;
	this.ignoreTags = [];

	// linkAttributes and linkClass is deprecated
	this.attributes = opts.attributes || opts.linkAttributes || defaults.attributes;
	this.className = opts.hasOwnProperty('className') ? opts.className : opts.linkClass || defaults.className;

	// Make all tags names upper case
	var ignoredTags = opts.hasOwnProperty('ignoreTags') ? opts.ignoreTags : defaults.ignoreTags;
	for (var i = 0; i < ignoredTags.length; i++) {
		this.ignoreTags.push(ignoredTags[i].toUpperCase());
	}
}

Options.prototype = {
	/**
  * Given the token, return all options for how it should be displayed
  */
	resolve: function resolve(token) {
		var href = token.toHref(this.defaultProtocol);
		return {
			formatted: this.get('format', token.toString(), token),
			formattedHref: this.get('formatHref', href, token),
			tagName: this.get('tagName', href, token),
			className: this.get('className', href, token),
			target: this.get('target', href, token),
			events: this.getObject('events', href, token),
			attributes: this.getObject('attributes', href, token)
		};
	},


	/**
  * Returns true or false based on whether a token should be displayed as a
  * link based on the user options. By default,
  */
	check: function check(token) {
		return this.get('validate', token.toString(), token);
	},


	// Private methods

	/**
  * Resolve an option's value based on the value of the option and the given
  * params.
  * @param {String} key Name of option to use
  * @param operator will be passed to the target option if it's method
  * @param {MultiToken} token The token from linkify.tokenize
  */
	get: function get(key, operator, token) {
		var optionValue = void 0,
		    option = this[key];
		if (!option) {
			return option;
		}

		switch (typeof option === 'undefined' ? 'undefined' : _typeof(option)) {
			case 'function':
				return option(operator, token.type);
			case 'object':
				optionValue = option.hasOwnProperty(token.type) ? option[token.type] : defaults[key];
				return typeof optionValue === 'function' ? optionValue(operator, token.type) : optionValue;
		}

		return option;
	},
	getObject: function getObject(key, operator, token) {
		var option = this[key];
		return typeof option === 'function' ? option(operator, token.type) : option;
	}
};

/**
 * Quick indexOf replacement for checking the ignoreTags option
 */
function contains(arr, value) {
	for (var i = 0; i < arr.length; i++) {
		if (arr[i] === value) {
			return true;
		}
	}
	return false;
}

function noop(val) {
	return val;
}

function typeToTarget(href, type) {
	return type === 'url' ? '_blank' : null;
}

/***/ }),
/* 1340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.start = exports.run = exports.TOKENS = exports.State = undefined;

var _state = __webpack_require__(760);

var _text = __webpack_require__(488);

var TOKENS = _interopRequireWildcard(_text);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var tlds = 'aaa|aarp|abarth|abb|abbott|abbvie|abc|able|abogado|abudhabi|ac|academy|accenture|accountant|accountants|aco|active|actor|ad|adac|ads|adult|ae|aeg|aero|aetna|af|afamilycompany|afl|africa|ag|agakhan|agency|ai|aig|aigo|airbus|airforce|airtel|akdn|al|alfaromeo|alibaba|alipay|allfinanz|allstate|ally|alsace|alstom|am|americanexpress|americanfamily|amex|amfam|amica|amsterdam|analytics|android|anquan|anz|ao|aol|apartments|app|apple|aq|aquarelle|ar|arab|aramco|archi|army|arpa|art|arte|as|asda|asia|associates|at|athleta|attorney|au|auction|audi|audible|audio|auspost|author|auto|autos|avianca|aw|aws|ax|axa|az|azure|ba|baby|baidu|banamex|bananarepublic|band|bank|bar|barcelona|barclaycard|barclays|barefoot|bargains|baseball|basketball|bauhaus|bayern|bb|bbc|bbt|bbva|bcg|bcn|bd|be|beats|beauty|beer|bentley|berlin|best|bestbuy|bet|bf|bg|bh|bharti|bi|bible|bid|bike|bing|bingo|bio|biz|bj|black|blackfriday|blanco|blockbuster|blog|bloomberg|blue|bm|bms|bmw|bn|bnl|bnpparibas|bo|boats|boehringer|bofa|bom|bond|boo|book|booking|boots|bosch|bostik|boston|bot|boutique|box|br|bradesco|bridgestone|broadway|broker|brother|brussels|bs|bt|budapest|bugatti|build|builders|business|buy|buzz|bv|bw|by|bz|bzh|ca|cab|cafe|cal|call|calvinklein|cam|camera|camp|cancerresearch|canon|capetown|capital|capitalone|car|caravan|cards|care|career|careers|cars|cartier|casa|case|caseih|cash|casino|cat|catering|catholic|cba|cbn|cbre|cbs|cc|cd|ceb|center|ceo|cern|cf|cfa|cfd|cg|ch|chanel|channel|chase|chat|cheap|chintai|chloe|christmas|chrome|chrysler|church|ci|cipriani|circle|cisco|citadel|citi|citic|city|cityeats|ck|cl|claims|cleaning|click|clinic|clinique|clothing|cloud|club|clubmed|cm|cn|co|coach|codes|coffee|college|cologne|com|comcast|commbank|community|company|compare|computer|comsec|condos|construction|consulting|contact|contractors|cooking|cookingchannel|cool|coop|corsica|country|coupon|coupons|courses|cr|credit|creditcard|creditunion|cricket|crown|crs|cruise|cruises|csc|cu|cuisinella|cv|cw|cx|cy|cymru|cyou|cz|dabur|dad|dance|data|date|dating|datsun|day|dclk|dds|de|deal|dealer|deals|degree|delivery|dell|deloitte|delta|democrat|dental|dentist|desi|design|dev|dhl|diamonds|diet|digital|direct|directory|discount|discover|dish|diy|dj|dk|dm|dnp|do|docs|doctor|dodge|dog|doha|domains|dot|download|drive|dtv|dubai|duck|dunlop|duns|dupont|durban|dvag|dvr|dz|earth|eat|ec|eco|edeka|edu|education|ee|eg|email|emerck|energy|engineer|engineering|enterprises|epost|epson|equipment|er|ericsson|erni|es|esq|estate|esurance|et|etisalat|eu|eurovision|eus|events|everbank|exchange|expert|exposed|express|extraspace|fage|fail|fairwinds|faith|family|fan|fans|farm|farmers|fashion|fast|fedex|feedback|ferrari|ferrero|fi|fiat|fidelity|fido|film|final|finance|financial|fire|firestone|firmdale|fish|fishing|fit|fitness|fj|fk|flickr|flights|flir|florist|flowers|fly|fm|fo|foo|food|foodnetwork|football|ford|forex|forsale|forum|foundation|fox|fr|free|fresenius|frl|frogans|frontdoor|frontier|ftr|fujitsu|fujixerox|fun|fund|furniture|futbol|fyi|ga|gal|gallery|gallo|gallup|game|games|gap|garden|gb|gbiz|gd|gdn|ge|gea|gent|genting|george|gf|gg|ggee|gh|gi|gift|gifts|gives|giving|gl|glade|glass|gle|global|globo|gm|gmail|gmbh|gmo|gmx|gn|godaddy|gold|goldpoint|golf|goo|goodhands|goodyear|goog|google|gop|got|gov|gp|gq|gr|grainger|graphics|gratis|green|gripe|grocery|group|gs|gt|gu|guardian|gucci|guge|guide|guitars|guru|gw|gy|hair|hamburg|hangout|haus|hbo|hdfc|hdfcbank|health|healthcare|help|helsinki|here|hermes|hgtv|hiphop|hisamitsu|hitachi|hiv|hk|hkt|hm|hn|hockey|holdings|holiday|homedepot|homegoods|homes|homesense|honda|honeywell|horse|hospital|host|hosting|hot|hoteles|hotels|hotmail|house|how|hr|hsbc|ht|htc|hu|hughes|hyatt|hyundai|ibm|icbc|ice|icu|id|ie|ieee|ifm|ikano|il|im|imamat|imdb|immo|immobilien|in|industries|infiniti|info|ing|ink|institute|insurance|insure|int|intel|international|intuit|investments|io|ipiranga|iq|ir|irish|is|iselect|ismaili|ist|istanbul|it|itau|itv|iveco|iwc|jaguar|java|jcb|jcp|je|jeep|jetzt|jewelry|jio|jlc|jll|jm|jmp|jnj|jo|jobs|joburg|jot|joy|jp|jpmorgan|jprs|juegos|juniper|kaufen|kddi|ke|kerryhotels|kerrylogistics|kerryproperties|kfh|kg|kh|ki|kia|kim|kinder|kindle|kitchen|kiwi|km|kn|koeln|komatsu|kosher|kp|kpmg|kpn|kr|krd|kred|kuokgroup|kw|ky|kyoto|kz|la|lacaixa|ladbrokes|lamborghini|lamer|lancaster|lancia|lancome|land|landrover|lanxess|lasalle|lat|latino|latrobe|law|lawyer|lb|lc|lds|lease|leclerc|lefrak|legal|lego|lexus|lgbt|li|liaison|lidl|life|lifeinsurance|lifestyle|lighting|like|lilly|limited|limo|lincoln|linde|link|lipsy|live|living|lixil|lk|loan|loans|locker|locus|loft|lol|london|lotte|lotto|love|lpl|lplfinancial|lr|ls|lt|ltd|ltda|lu|lundbeck|lupin|luxe|luxury|lv|ly|ma|macys|madrid|maif|maison|makeup|man|management|mango|map|market|marketing|markets|marriott|marshalls|maserati|mattel|mba|mc|mckinsey|md|me|med|media|meet|melbourne|meme|memorial|men|menu|meo|merckmsd|metlife|mg|mh|miami|microsoft|mil|mini|mint|mit|mitsubishi|mk|ml|mlb|mls|mm|mma|mn|mo|mobi|mobile|mobily|moda|moe|moi|mom|monash|money|monster|mopar|mormon|mortgage|moscow|moto|motorcycles|mov|movie|movistar|mp|mq|mr|ms|msd|mt|mtn|mtr|mu|museum|mutual|mv|mw|mx|my|mz|na|nab|nadex|nagoya|name|nationwide|natura|navy|nba|nc|ne|nec|net|netbank|netflix|network|neustar|new|newholland|news|next|nextdirect|nexus|nf|nfl|ng|ngo|nhk|ni|nico|nike|nikon|ninja|nissan|nissay|nl|no|nokia|northwesternmutual|norton|now|nowruz|nowtv|np|nr|nra|nrw|ntt|nu|nyc|nz|obi|observer|off|office|okinawa|olayan|olayangroup|oldnavy|ollo|om|omega|one|ong|onl|online|onyourside|ooo|open|oracle|orange|org|organic|origins|osaka|otsuka|ott|ovh|pa|page|panasonic|panerai|paris|pars|partners|parts|party|passagens|pay|pccw|pe|pet|pf|pfizer|pg|ph|pharmacy|phd|philips|phone|photo|photography|photos|physio|piaget|pics|pictet|pictures|pid|pin|ping|pink|pioneer|pizza|pk|pl|place|play|playstation|plumbing|plus|pm|pn|pnc|pohl|poker|politie|porn|post|pr|pramerica|praxi|press|prime|pro|prod|productions|prof|progressive|promo|properties|property|protection|pru|prudential|ps|pt|pub|pw|pwc|py|qa|qpon|quebec|quest|qvc|racing|radio|raid|re|read|realestate|realtor|realty|recipes|red|redstone|redumbrella|rehab|reise|reisen|reit|reliance|ren|rent|rentals|repair|report|republican|rest|restaurant|review|reviews|rexroth|rich|richardli|ricoh|rightathome|ril|rio|rip|rmit|ro|rocher|rocks|rodeo|rogers|room|rs|rsvp|ru|rugby|ruhr|run|rw|rwe|ryukyu|sa|saarland|safe|safety|sakura|sale|salon|samsclub|samsung|sandvik|sandvikcoromant|sanofi|sap|sapo|sarl|sas|save|saxo|sb|sbi|sbs|sc|sca|scb|schaeffler|schmidt|scholarships|school|schule|schwarz|science|scjohnson|scor|scot|sd|se|search|seat|secure|security|seek|select|sener|services|ses|seven|sew|sex|sexy|sfr|sg|sh|shangrila|sharp|shaw|shell|shia|shiksha|shoes|shop|shopping|shouji|show|showtime|shriram|si|silk|sina|singles|site|sj|sk|ski|skin|sky|skype|sl|sling|sm|smart|smile|sn|sncf|so|soccer|social|softbank|software|sohu|solar|solutions|song|sony|soy|space|spiegel|spot|spreadbetting|sr|srl|srt|st|stada|staples|star|starhub|statebank|statefarm|statoil|stc|stcgroup|stockholm|storage|store|stream|studio|study|style|su|sucks|supplies|supply|support|surf|surgery|suzuki|sv|swatch|swiftcover|swiss|sx|sy|sydney|symantec|systems|sz|tab|taipei|talk|taobao|target|tatamotors|tatar|tattoo|tax|taxi|tc|tci|td|tdk|team|tech|technology|tel|telecity|telefonica|temasek|tennis|teva|tf|tg|th|thd|theater|theatre|tiaa|tickets|tienda|tiffany|tips|tires|tirol|tj|tjmaxx|tjx|tk|tkmaxx|tl|tm|tmall|tn|to|today|tokyo|tools|top|toray|toshiba|total|tours|town|toyota|toys|tr|trade|trading|training|travel|travelchannel|travelers|travelersinsurance|trust|trv|tt|tube|tui|tunes|tushu|tv|tvs|tw|tz|ua|ubank|ubs|uconnect|ug|uk|unicom|university|uno|uol|ups|us|uy|uz|va|vacations|vana|vanguard|vc|ve|vegas|ventures|verisign|versicherung|vet|vg|vi|viajes|video|vig|viking|villas|vin|vip|virgin|visa|vision|vista|vistaprint|viva|vivo|vlaanderen|vn|vodka|volkswagen|volvo|vote|voting|voto|voyage|vu|vuelos|wales|walmart|walter|wang|wanggou|warman|watch|watches|weather|weatherchannel|webcam|weber|website|wed|wedding|weibo|weir|wf|whoswho|wien|wiki|williamhill|win|windows|wine|winners|wme|wolterskluwer|woodside|work|works|world|wow|ws|wtc|wtf|xbox|xerox|xfinity|xihuan|xin|xn--11b4c3d|xn--1ck2e1b|xn--1qqw23a|xn--2scrj9c|xn--30rr7y|xn--3bst00m|xn--3ds443g|xn--3e0b707e|xn--3hcrj9c|xn--3oq18vl8pn36a|xn--3pxu8k|xn--42c2d9a|xn--45br5cyl|xn--45brj9c|xn--45q11c|xn--4gbrim|xn--54b7fta0cc|xn--55qw42g|xn--55qx5d|xn--5su34j936bgsg|xn--5tzm5g|xn--6frz82g|xn--6qq986b3xl|xn--80adxhks|xn--80ao21a|xn--80aqecdr1a|xn--80asehdb|xn--80aswg|xn--8y0a063a|xn--90a3ac|xn--90ae|xn--90ais|xn--9dbq2a|xn--9et52u|xn--9krt00a|xn--b4w605ferd|xn--bck1b9a5dre4c|xn--c1avg|xn--c2br7g|xn--cck2b3b|xn--cg4bki|xn--clchc0ea0b2g2a9gcd|xn--czr694b|xn--czrs0t|xn--czru2d|xn--d1acj3b|xn--d1alf|xn--e1a4c|xn--eckvdtc9d|xn--efvy88h|xn--estv75g|xn--fct429k|xn--fhbei|xn--fiq228c5hs|xn--fiq64b|xn--fiqs8s|xn--fiqz9s|xn--fjq720a|xn--flw351e|xn--fpcrj9c3d|xn--fzc2c9e2c|xn--fzys8d69uvgm|xn--g2xx48c|xn--gckr3f0f|xn--gecrj9c|xn--gk3at1e|xn--h2breg3eve|xn--h2brj9c|xn--h2brj9c8c|xn--hxt814e|xn--i1b6b1a6a2e|xn--imr513n|xn--io0a7i|xn--j1aef|xn--j1amh|xn--j6w193g|xn--jlq61u9w7b|xn--jvr189m|xn--kcrx77d1x4a|xn--kprw13d|xn--kpry57d|xn--kpu716f|xn--kput3i|xn--l1acc|xn--lgbbat1ad8j|xn--mgb9awbf|xn--mgba3a3ejt|xn--mgba3a4f16a|xn--mgba7c0bbn0a|xn--mgbaakc7dvf|xn--mgbaam7a8h|xn--mgbab2bd|xn--mgbai9azgqp6j|xn--mgbayh7gpa|xn--mgbb9fbpob|xn--mgbbh1a|xn--mgbbh1a71e|xn--mgbc0a9azcg|xn--mgbca7dzdo|xn--mgberp4a5d4ar|xn--mgbgu82a|xn--mgbi4ecexp|xn--mgbpl2fh|xn--mgbt3dhd|xn--mgbtx2b|xn--mgbx4cd0ab|xn--mix891f|xn--mk1bu44c|xn--mxtq1m|xn--ngbc5azd|xn--ngbe9e0a|xn--ngbrx|xn--node|xn--nqv7f|xn--nqv7fs00ema|xn--nyqy26a|xn--o3cw4h|xn--ogbpf8fl|xn--p1acf|xn--p1ai|xn--pbt977c|xn--pgbs0dh|xn--pssy2u|xn--q9jyb4c|xn--qcka1pmc|xn--qxam|xn--rhqv96g|xn--rovu88b|xn--rvc1e0am3e|xn--s9brj9c|xn--ses554g|xn--t60b56a|xn--tckwe|xn--tiq49xqyj|xn--unup4y|xn--vermgensberater-ctb|xn--vermgensberatung-pwb|xn--vhquv|xn--vuq861b|xn--w4r85el8fhu5dnra|xn--w4rs40l|xn--wgbh1c|xn--wgbl6a|xn--xhq521b|xn--xkc2al3hye2a|xn--xkc2dl3a5ee0h|xn--y9a3aq|xn--yfro4i67o|xn--ygbi2ammx|xn--zfr164b|xperia|xxx|xyz|yachts|yahoo|yamaxun|yandex|ye|yodobashi|yoga|yokohama|you|youtube|yt|yun|za|zappos|zara|zero|zip|zippo|zm|zone|zuerich|zw'.split('|'); // macro, see gulpfile.js

/**
	The scanner provides an interface that takes a string of text as input, and
	outputs an array of tokens instances that can be used for easy URL parsing.

	@module linkify
	@submodule scanner
	@main scanner
*/

var NUMBERS = '0123456789'.split('');
var ALPHANUM = '0123456789abcdefghijklmnopqrstuvwxyz'.split('');
var WHITESPACE = [' ', '\f', '\r', '\t', '\v', '\xA0', '\u1680', '\u180E']; // excluding line breaks

var domainStates = []; // states that jump to DOMAIN on /[a-z0-9]/
var makeState = function makeState(tokenClass) {
	return new _state.CharacterState(tokenClass);
};

// Frequently used states
var S_START = makeState();
var S_NUM = makeState(_text.NUM);
var S_DOMAIN = makeState(_text.DOMAIN);
var S_DOMAIN_HYPHEN = makeState(); // domain followed by 1 or more hyphen characters
var S_WS = makeState(_text.WS);

// States for special URL symbols
S_START.on('@', makeState(_text.AT)).on('.', makeState(_text.DOT)).on('+', makeState(_text.PLUS)).on('#', makeState(_text.POUND)).on('?', makeState(_text.QUERY)).on('/', makeState(_text.SLASH)).on('_', makeState(_text.UNDERSCORE)).on(':', makeState(_text.COLON)).on('{', makeState(_text.OPENBRACE)).on('[', makeState(_text.OPENBRACKET)).on('<', makeState(_text.OPENANGLEBRACKET)).on('(', makeState(_text.OPENPAREN)).on('}', makeState(_text.CLOSEBRACE)).on(']', makeState(_text.CLOSEBRACKET)).on('>', makeState(_text.CLOSEANGLEBRACKET)).on(')', makeState(_text.CLOSEPAREN)).on('&', makeState(_text.AMPERSAND)).on([',', ';', '!', '"', '\''], makeState(_text.PUNCTUATION));

// Whitespace jumps
// Tokens of only non-newline whitespace are arbitrarily long
S_START.on('\n', makeState(_text.NL)).on(WHITESPACE, S_WS);

// If any whitespace except newline, more whitespace!
S_WS.on(WHITESPACE, S_WS);

// Generates states for top-level domains
// Note that this is most accurate when tlds are in alphabetical order
for (var i = 0; i < tlds.length; i++) {
	var newStates = (0, _state.stateify)(tlds[i], S_START, _text.TLD, _text.DOMAIN);
	domainStates.push.apply(domainStates, newStates);
}

// Collect the states generated by different protocls
var partialProtocolFileStates = (0, _state.stateify)('file', S_START, _text.DOMAIN, _text.DOMAIN);
var partialProtocolFtpStates = (0, _state.stateify)('ftp', S_START, _text.DOMAIN, _text.DOMAIN);
var partialProtocolHttpStates = (0, _state.stateify)('http', S_START, _text.DOMAIN, _text.DOMAIN);
var partialProtocolMailtoStates = (0, _state.stateify)('mailto', S_START, _text.DOMAIN, _text.DOMAIN);

// Add the states to the array of DOMAINeric states
domainStates.push.apply(domainStates, partialProtocolFileStates);
domainStates.push.apply(domainStates, partialProtocolFtpStates);
domainStates.push.apply(domainStates, partialProtocolHttpStates);
domainStates.push.apply(domainStates, partialProtocolMailtoStates);

// Protocol states
var S_PROTOCOL_FILE = partialProtocolFileStates.pop();
var S_PROTOCOL_FTP = partialProtocolFtpStates.pop();
var S_PROTOCOL_HTTP = partialProtocolHttpStates.pop();
var S_MAILTO = partialProtocolMailtoStates.pop();
var S_PROTOCOL_SECURE = makeState(_text.DOMAIN);
var S_FULL_PROTOCOL = makeState(_text.PROTOCOL); // Full protocol ends with COLON
var S_FULL_MAILTO = makeState(_text.MAILTO); // Mailto ends with COLON

// Secure protocols (end with 's')
S_PROTOCOL_FTP.on('s', S_PROTOCOL_SECURE).on(':', S_FULL_PROTOCOL);

S_PROTOCOL_HTTP.on('s', S_PROTOCOL_SECURE).on(':', S_FULL_PROTOCOL);

domainStates.push(S_PROTOCOL_SECURE);

// Become protocol tokens after a COLON
S_PROTOCOL_FILE.on(':', S_FULL_PROTOCOL);
S_PROTOCOL_SECURE.on(':', S_FULL_PROTOCOL);
S_MAILTO.on(':', S_FULL_MAILTO);

// Localhost
var partialLocalhostStates = (0, _state.stateify)('localhost', S_START, _text.LOCALHOST, _text.DOMAIN);
domainStates.push.apply(domainStates, partialLocalhostStates);

// Everything else
// DOMAINs make more DOMAINs
// Number and character transitions
S_START.on(NUMBERS, S_NUM);
S_NUM.on('-', S_DOMAIN_HYPHEN).on(NUMBERS, S_NUM).on(ALPHANUM, S_DOMAIN); // number becomes DOMAIN

S_DOMAIN.on('-', S_DOMAIN_HYPHEN).on(ALPHANUM, S_DOMAIN);

// All the generated states should have a jump to DOMAIN
for (var _i = 0; _i < domainStates.length; _i++) {
	domainStates[_i].on('-', S_DOMAIN_HYPHEN).on(ALPHANUM, S_DOMAIN);
}

S_DOMAIN_HYPHEN.on('-', S_DOMAIN_HYPHEN).on(NUMBERS, S_DOMAIN).on(ALPHANUM, S_DOMAIN);

// Set default transition
S_START.defaultTransition = makeState(_text.SYM);

/**
	Given a string, returns an array of TOKEN instances representing the
	composition of that string.

	@method run
	@param {String} str Input string to scan
	@return {Array} Array of TOKEN instances
*/
var run = function run(str) {

	// The state machine only looks at lowercase strings.
	// This selective `toLowerCase` is used because lowercasing the entire
	// string causes the length and character position to vary in some in some
	// non-English strings. This happens only on V8-based runtimes.
	var lowerStr = str.replace(/[A-Z]/g, function (c) {
		return c.toLowerCase();
	});
	var len = str.length;
	var tokens = []; // return value

	var cursor = 0;

	// Tokenize the string
	while (cursor < len) {
		var state = S_START;
		var nextState = null;
		var tokenLength = 0;
		var latestAccepting = null;
		var sinceAccepts = -1;

		while (cursor < len && (nextState = state.next(lowerStr[cursor]))) {
			state = nextState;

			// Keep track of the latest accepting state
			if (state.accepts()) {
				sinceAccepts = 0;
				latestAccepting = state;
			} else if (sinceAccepts >= 0) {
				sinceAccepts++;
			}

			tokenLength++;
			cursor++;
		}

		if (sinceAccepts < 0) {
			continue;
		} // Should never happen

		// Roll back to the latest accepting state
		cursor -= sinceAccepts;
		tokenLength -= sinceAccepts;

		// Get the class for the new token
		var TOKEN = latestAccepting.emit(); // Current token class

		// No more jumps, just make a new token
		tokens.push(new TOKEN(str.substr(cursor - tokenLength, tokenLength)));
	}

	return tokens;
};

var start = S_START;
exports.State = _state.CharacterState;
exports.TOKENS = TOKENS;
exports.run = run;
exports.start = start;

/***/ }),
/* 1341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.start = exports.run = exports.TOKENS = exports.State = undefined;

var _state = __webpack_require__(760);

var _multi = __webpack_require__(1342);

var MULTI_TOKENS = _interopRequireWildcard(_multi);

var _text = __webpack_require__(488);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/**
	Not exactly parser, more like the second-stage scanner (although we can
	theoretically hotswap the code here with a real parser in the future... but
	for a little URL-finding utility abstract syntax trees may be a little
	overkill).

	URL format: http://en.wikipedia.org/wiki/URI_scheme
	Email format: http://en.wikipedia.org/wiki/Email_address (links to RFC in
	reference)

	@module linkify
	@submodule parser
	@main parser
*/

var makeState = function makeState(tokenClass) {
	return new _state.TokenState(tokenClass);
};

// The universal starting state.
var S_START = makeState();

// Intermediate states for URLs. Note that domains that begin with a protocol
// are treated slighly differently from those that don't.
var S_PROTOCOL = makeState(); // e.g., 'http:'
var S_MAILTO = makeState(); // 'mailto:'
var S_PROTOCOL_SLASH = makeState(); // e.g., '/', 'http:/''
var S_PROTOCOL_SLASH_SLASH = makeState(); // e.g., '//', 'http://'
var S_DOMAIN = makeState(); // parsed string ends with a potential domain name (A)
var S_DOMAIN_DOT = makeState(); // (A) domain followed by DOT
var S_TLD = makeState(_multi.URL); // (A) Simplest possible URL with no query string
var S_TLD_COLON = makeState(); // (A) URL followed by colon (potential port number here)
var S_TLD_PORT = makeState(_multi.URL); // TLD followed by a port number
var S_URL = makeState(_multi.URL); // Long URL with optional port and maybe query string
var S_URL_NON_ACCEPTING = makeState(); // URL followed by some symbols (will not be part of the final URL)
var S_URL_OPENBRACE = makeState(); // URL followed by {
var S_URL_OPENBRACKET = makeState(); // URL followed by [
var S_URL_OPENANGLEBRACKET = makeState(); // URL followed by <
var S_URL_OPENPAREN = makeState(); // URL followed by (
var S_URL_OPENBRACE_Q = makeState(_multi.URL); // URL followed by { and some symbols that the URL can end it
var S_URL_OPENBRACKET_Q = makeState(_multi.URL); // URL followed by [ and some symbols that the URL can end it
var S_URL_OPENANGLEBRACKET_Q = makeState(_multi.URL); // URL followed by < and some symbols that the URL can end it
var S_URL_OPENPAREN_Q = makeState(_multi.URL); // URL followed by ( and some symbols that the URL can end it
var S_URL_OPENBRACE_SYMS = makeState(); // S_URL_OPENBRACE_Q followed by some symbols it cannot end it
var S_URL_OPENBRACKET_SYMS = makeState(); // S_URL_OPENBRACKET_Q followed by some symbols it cannot end it
var S_URL_OPENANGLEBRACKET_SYMS = makeState(); // S_URL_OPENANGLEBRACKET_Q followed by some symbols it cannot end it
var S_URL_OPENPAREN_SYMS = makeState(); // S_URL_OPENPAREN_Q followed by some symbols it cannot end it
var S_EMAIL_DOMAIN = makeState(); // parsed string starts with local email info + @ with a potential domain name (C)
var S_EMAIL_DOMAIN_DOT = makeState(); // (C) domain followed by DOT
var S_EMAIL = makeState(_multi.EMAIL); // (C) Possible email address (could have more tlds)
var S_EMAIL_COLON = makeState(); // (C) URL followed by colon (potential port number here)
var S_EMAIL_PORT = makeState(_multi.EMAIL); // (C) Email address with a port
var S_MAILTO_EMAIL = makeState(_multi.MAILTOEMAIL); // Email that begins with the mailto prefix (D)
var S_MAILTO_EMAIL_NON_ACCEPTING = makeState(); // (D) Followed by some non-query string chars
var S_LOCALPART = makeState(); // Local part of the email address
var S_LOCALPART_AT = makeState(); // Local part of the email address plus @
var S_LOCALPART_DOT = makeState(); // Local part of the email address plus '.' (localpart cannot end in .)
var S_NL = makeState(_multi.NL); // single new line

// Make path from start to protocol (with '//')
S_START.on(_text.NL, S_NL).on(_text.PROTOCOL, S_PROTOCOL).on(_text.MAILTO, S_MAILTO).on(_text.SLASH, S_PROTOCOL_SLASH);

S_PROTOCOL.on(_text.SLASH, S_PROTOCOL_SLASH);
S_PROTOCOL_SLASH.on(_text.SLASH, S_PROTOCOL_SLASH_SLASH);

// The very first potential domain name
S_START.on(_text.TLD, S_DOMAIN).on(_text.DOMAIN, S_DOMAIN).on(_text.LOCALHOST, S_TLD).on(_text.NUM, S_DOMAIN);

// Force URL for protocol followed by anything sane
S_PROTOCOL_SLASH_SLASH.on(_text.TLD, S_URL).on(_text.DOMAIN, S_URL).on(_text.NUM, S_URL).on(_text.LOCALHOST, S_URL);

// Account for dots and hyphens
// hyphens are usually parts of domain names
S_DOMAIN.on(_text.DOT, S_DOMAIN_DOT);
S_EMAIL_DOMAIN.on(_text.DOT, S_EMAIL_DOMAIN_DOT);

// Hyphen can jump back to a domain name

// After the first domain and a dot, we can find either a URL or another domain
S_DOMAIN_DOT.on(_text.TLD, S_TLD).on(_text.DOMAIN, S_DOMAIN).on(_text.NUM, S_DOMAIN).on(_text.LOCALHOST, S_DOMAIN);

S_EMAIL_DOMAIN_DOT.on(_text.TLD, S_EMAIL).on(_text.DOMAIN, S_EMAIL_DOMAIN).on(_text.NUM, S_EMAIL_DOMAIN).on(_text.LOCALHOST, S_EMAIL_DOMAIN);

// S_TLD accepts! But the URL could be longer, try to find a match greedily
// The `run` function should be able to "rollback" to the accepting state
S_TLD.on(_text.DOT, S_DOMAIN_DOT);
S_EMAIL.on(_text.DOT, S_EMAIL_DOMAIN_DOT);

// Become real URLs after `SLASH` or `COLON NUM SLASH`
// Here PSS and non-PSS converge
S_TLD.on(_text.COLON, S_TLD_COLON).on(_text.SLASH, S_URL);
S_TLD_COLON.on(_text.NUM, S_TLD_PORT);
S_TLD_PORT.on(_text.SLASH, S_URL);
S_EMAIL.on(_text.COLON, S_EMAIL_COLON);
S_EMAIL_COLON.on(_text.NUM, S_EMAIL_PORT);

// Types of characters the URL can definitely end in
var qsAccepting = [_text.DOMAIN, _text.AT, _text.LOCALHOST, _text.NUM, _text.PLUS, _text.POUND, _text.PROTOCOL, _text.SLASH, _text.TLD, _text.UNDERSCORE, _text.SYM, _text.AMPERSAND];

// Types of tokens that can follow a URL and be part of the query string
// but cannot be the very last characters
// Characters that cannot appear in the URL at all should be excluded
var qsNonAccepting = [_text.COLON, _text.DOT, _text.QUERY, _text.PUNCTUATION, _text.CLOSEBRACE, _text.CLOSEBRACKET, _text.CLOSEANGLEBRACKET, _text.CLOSEPAREN, _text.OPENBRACE, _text.OPENBRACKET, _text.OPENANGLEBRACKET, _text.OPENPAREN];

// These states are responsible primarily for determining whether or not to
// include the final round bracket.

// URL, followed by an opening bracket
S_URL.on(_text.OPENBRACE, S_URL_OPENBRACE).on(_text.OPENBRACKET, S_URL_OPENBRACKET).on(_text.OPENANGLEBRACKET, S_URL_OPENANGLEBRACKET).on(_text.OPENPAREN, S_URL_OPENPAREN);

// URL with extra symbols at the end, followed by an opening bracket
S_URL_NON_ACCEPTING.on(_text.OPENBRACE, S_URL_OPENBRACE).on(_text.OPENBRACKET, S_URL_OPENBRACKET).on(_text.OPENANGLEBRACKET, S_URL_OPENANGLEBRACKET).on(_text.OPENPAREN, S_URL_OPENPAREN);

// Closing bracket component. This character WILL be included in the URL
S_URL_OPENBRACE.on(_text.CLOSEBRACE, S_URL);
S_URL_OPENBRACKET.on(_text.CLOSEBRACKET, S_URL);
S_URL_OPENANGLEBRACKET.on(_text.CLOSEANGLEBRACKET, S_URL);
S_URL_OPENPAREN.on(_text.CLOSEPAREN, S_URL);
S_URL_OPENBRACE_Q.on(_text.CLOSEBRACE, S_URL);
S_URL_OPENBRACKET_Q.on(_text.CLOSEBRACKET, S_URL);
S_URL_OPENANGLEBRACKET_Q.on(_text.CLOSEANGLEBRACKET, S_URL);
S_URL_OPENPAREN_Q.on(_text.CLOSEPAREN, S_URL);
S_URL_OPENBRACE_SYMS.on(_text.CLOSEBRACE, S_URL);
S_URL_OPENBRACKET_SYMS.on(_text.CLOSEBRACKET, S_URL);
S_URL_OPENANGLEBRACKET_SYMS.on(_text.CLOSEANGLEBRACKET, S_URL);
S_URL_OPENPAREN_SYMS.on(_text.CLOSEPAREN, S_URL);

// URL that beings with an opening bracket, followed by a symbols.
// Note that the final state can still be `S_URL_OPENBRACE_Q` (if the URL only
// has a single opening bracket for some reason).
S_URL_OPENBRACE.on(qsAccepting, S_URL_OPENBRACE_Q);
S_URL_OPENBRACKET.on(qsAccepting, S_URL_OPENBRACKET_Q);
S_URL_OPENANGLEBRACKET.on(qsAccepting, S_URL_OPENANGLEBRACKET_Q);
S_URL_OPENPAREN.on(qsAccepting, S_URL_OPENPAREN_Q);
S_URL_OPENBRACE.on(qsNonAccepting, S_URL_OPENBRACE_SYMS);
S_URL_OPENBRACKET.on(qsNonAccepting, S_URL_OPENBRACKET_SYMS);
S_URL_OPENANGLEBRACKET.on(qsNonAccepting, S_URL_OPENANGLEBRACKET_SYMS);
S_URL_OPENPAREN.on(qsNonAccepting, S_URL_OPENPAREN_SYMS);

// URL that begins with an opening bracket, followed by some symbols
S_URL_OPENBRACE_Q.on(qsAccepting, S_URL_OPENBRACE_Q);
S_URL_OPENBRACKET_Q.on(qsAccepting, S_URL_OPENBRACKET_Q);
S_URL_OPENANGLEBRACKET_Q.on(qsAccepting, S_URL_OPENANGLEBRACKET_Q);
S_URL_OPENPAREN_Q.on(qsAccepting, S_URL_OPENPAREN_Q);
S_URL_OPENBRACE_Q.on(qsNonAccepting, S_URL_OPENBRACE_Q);
S_URL_OPENBRACKET_Q.on(qsNonAccepting, S_URL_OPENBRACKET_Q);
S_URL_OPENANGLEBRACKET_Q.on(qsNonAccepting, S_URL_OPENANGLEBRACKET_Q);
S_URL_OPENPAREN_Q.on(qsNonAccepting, S_URL_OPENPAREN_Q);

S_URL_OPENBRACE_SYMS.on(qsAccepting, S_URL_OPENBRACE_Q);
S_URL_OPENBRACKET_SYMS.on(qsAccepting, S_URL_OPENBRACKET_Q);
S_URL_OPENANGLEBRACKET_SYMS.on(qsAccepting, S_URL_OPENANGLEBRACKET_Q);
S_URL_OPENPAREN_SYMS.on(qsAccepting, S_URL_OPENPAREN_Q);
S_URL_OPENBRACE_SYMS.on(qsNonAccepting, S_URL_OPENBRACE_SYMS);
S_URL_OPENBRACKET_SYMS.on(qsNonAccepting, S_URL_OPENBRACKET_SYMS);
S_URL_OPENANGLEBRACKET_SYMS.on(qsNonAccepting, S_URL_OPENANGLEBRACKET_SYMS);
S_URL_OPENPAREN_SYMS.on(qsNonAccepting, S_URL_OPENPAREN_SYMS);

// Account for the query string
S_URL.on(qsAccepting, S_URL);
S_URL_NON_ACCEPTING.on(qsAccepting, S_URL);

S_URL.on(qsNonAccepting, S_URL_NON_ACCEPTING);
S_URL_NON_ACCEPTING.on(qsNonAccepting, S_URL_NON_ACCEPTING);

// Email address-specific state definitions
// Note: We are not allowing '/' in email addresses since this would interfere
// with real URLs

// For addresses with the mailto prefix
// 'mailto:' followed by anything sane is a valid email
S_MAILTO.on(_text.TLD, S_MAILTO_EMAIL).on(_text.DOMAIN, S_MAILTO_EMAIL).on(_text.NUM, S_MAILTO_EMAIL).on(_text.LOCALHOST, S_MAILTO_EMAIL);

// Greedily get more potential valid email values
S_MAILTO_EMAIL.on(qsAccepting, S_MAILTO_EMAIL).on(qsNonAccepting, S_MAILTO_EMAIL_NON_ACCEPTING);
S_MAILTO_EMAIL_NON_ACCEPTING.on(qsAccepting, S_MAILTO_EMAIL).on(qsNonAccepting, S_MAILTO_EMAIL_NON_ACCEPTING);

// For addresses without the mailto prefix
// Tokens allowed in the localpart of the email
var localpartAccepting = [_text.DOMAIN, _text.NUM, _text.PLUS, _text.POUND, _text.QUERY, _text.UNDERSCORE, _text.SYM, _text.AMPERSAND, _text.TLD];

// Some of the tokens in `localpartAccepting` are already accounted for here and
// will not be overwritten (don't worry)
S_DOMAIN.on(localpartAccepting, S_LOCALPART).on(_text.AT, S_LOCALPART_AT);
S_TLD.on(localpartAccepting, S_LOCALPART).on(_text.AT, S_LOCALPART_AT);
S_DOMAIN_DOT.on(localpartAccepting, S_LOCALPART);

// Okay we're on a localpart. Now what?
// TODO: IP addresses and what if the email starts with numbers?
S_LOCALPART.on(localpartAccepting, S_LOCALPART).on(_text.AT, S_LOCALPART_AT) // close to an email address now
.on(_text.DOT, S_LOCALPART_DOT);
S_LOCALPART_DOT.on(localpartAccepting, S_LOCALPART);
S_LOCALPART_AT.on(_text.TLD, S_EMAIL_DOMAIN).on(_text.DOMAIN, S_EMAIL_DOMAIN).on(_text.LOCALHOST, S_EMAIL);
// States following `@` defined above

var run = function run(tokens) {
	var len = tokens.length;
	var cursor = 0;
	var multis = [];
	var textTokens = [];

	while (cursor < len) {
		var state = S_START;
		var secondState = null;
		var nextState = null;
		var multiLength = 0;
		var latestAccepting = null;
		var sinceAccepts = -1;

		while (cursor < len && !(secondState = state.next(tokens[cursor]))) {
			// Starting tokens with nowhere to jump to.
			// Consider these to be just plain text
			textTokens.push(tokens[cursor++]);
		}

		while (cursor < len && (nextState = secondState || state.next(tokens[cursor]))) {

			// Get the next state
			secondState = null;
			state = nextState;

			// Keep track of the latest accepting state
			if (state.accepts()) {
				sinceAccepts = 0;
				latestAccepting = state;
			} else if (sinceAccepts >= 0) {
				sinceAccepts++;
			}

			cursor++;
			multiLength++;
		}

		if (sinceAccepts < 0) {

			// No accepting state was found, part of a regular text token
			// Add all the tokens we looked at to the text tokens array
			for (var i = cursor - multiLength; i < cursor; i++) {
				textTokens.push(tokens[i]);
			}
		} else {

			// Accepting state!

			// First close off the textTokens (if available)
			if (textTokens.length > 0) {
				multis.push(new _multi.TEXT(textTokens));
				textTokens = [];
			}

			// Roll back to the latest accepting state
			cursor -= sinceAccepts;
			multiLength -= sinceAccepts;

			// Create a new multitoken
			var MULTI = latestAccepting.emit();
			multis.push(new MULTI(tokens.slice(cursor - multiLength, cursor)));
		}
	}

	// Finally close off the textTokens (if available)
	if (textTokens.length > 0) {
		multis.push(new _multi.TEXT(textTokens));
	}

	return multis;
};

exports.State = _state.TokenState;
exports.TOKENS = MULTI_TOKENS;
exports.run = run;
exports.start = S_START;

/***/ }),
/* 1342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.URL = exports.TEXT = exports.NL = exports.EMAIL = exports.MAILTOEMAIL = exports.Base = undefined;

var _createTokenClass = __webpack_require__(761);

var _class = __webpack_require__(361);

var _text = __webpack_require__(488);

/******************************************************************************
	Multi-Tokens
	Tokens composed of arrays of TextTokens
******************************************************************************/

// Is the given token a valid domain token?
// Should nums be included here?
function isDomainToken(token) {
	return token instanceof _text.DOMAIN || token instanceof _text.TLD;
}

/**
	Abstract class used for manufacturing tokens of text tokens. That is rather
	than the value for a token being a small string of text, it's value an array
	of text tokens.

	Used for grouping together URLs, emails, hashtags, and other potential
	creations.

	@class MultiToken
	@abstract
*/
var MultiToken = (0, _createTokenClass.createTokenClass)();

MultiToken.prototype = {
	/**
 	String representing the type for this token
 	@property type
 	@default 'TOKEN'
 */
	type: 'token',

	/**
 	Is this multitoken a link?
 	@property isLink
 	@default false
 */
	isLink: false,

	/**
 	Return the string this token represents.
 	@method toString
 	@return {String}
 */
	toString: function toString() {
		var result = [];
		for (var i = 0; i < this.v.length; i++) {
			result.push(this.v[i].toString());
		}
		return result.join('');
	},


	/**
 	What should the value for this token be in the `href` HTML attribute?
 	Returns the `.toString` value by default.
 		@method toHref
 	@return {String}
 */
	toHref: function toHref() {
		return this.toString();
	},


	/**
 	Returns a hash of relevant values for this token, which includes keys
 	* type - Kind of token ('url', 'email', etc.)
 	* value - Original text
 	* href - The value that should be added to the anchor tag's href
 		attribute
 		@method toObject
 	@param {String} [protocol] `'http'` by default
 	@return {Object}
 */
	toObject: function toObject() {
		var protocol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'http';

		return {
			type: this.type,
			value: this.toString(),
			href: this.toHref(protocol)
		};
	}
};

/**
	Represents an arbitrarily mailto email address with the prefix included
	@class MAILTO
	@extends MultiToken
*/
var MAILTOEMAIL = (0, _class.inherits)(MultiToken, (0, _createTokenClass.createTokenClass)(), {
	type: 'email',
	isLink: true
});

/**
	Represents a list of tokens making up a valid email address
	@class EMAIL
	@extends MultiToken
*/
var EMAIL = (0, _class.inherits)(MultiToken, (0, _createTokenClass.createTokenClass)(), {
	type: 'email',
	isLink: true,
	toHref: function toHref() {
		return 'mailto:' + this.toString();
	}
});

/**
	Represents some plain text
	@class TEXT
	@extends MultiToken
*/
var TEXT = (0, _class.inherits)(MultiToken, (0, _createTokenClass.createTokenClass)(), { type: 'text' });

/**
	Multi-linebreak token - represents a line break
	@class NL
	@extends MultiToken
*/
var NL = (0, _class.inherits)(MultiToken, (0, _createTokenClass.createTokenClass)(), { type: 'nl' });

/**
	Represents a list of tokens making up a valid URL
	@class URL
	@extends MultiToken
*/
var URL = (0, _class.inherits)(MultiToken, (0, _createTokenClass.createTokenClass)(), {
	type: 'url',
	isLink: true,

	/**
 	Lowercases relevant parts of the domain and adds the protocol if
 	required. Note that this will not escape unsafe HTML characters in the
 	URL.
 		@method href
 	@param {String} protocol
 	@return {String}
 */
	toHref: function toHref() {
		var protocol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'http';

		var hasProtocol = false;
		var hasSlashSlash = false;
		var tokens = this.v;
		var result = [];
		var i = 0;

		// Make the first part of the domain lowercase
		// Lowercase protocol
		while (tokens[i] instanceof _text.PROTOCOL) {
			hasProtocol = true;
			result.push(tokens[i].toString().toLowerCase());
			i++;
		}

		// Skip slash-slash
		while (tokens[i] instanceof _text.SLASH) {
			hasSlashSlash = true;
			result.push(tokens[i].toString());
			i++;
		}

		// Lowercase all other characters in the domain
		while (isDomainToken(tokens[i])) {
			result.push(tokens[i].toString().toLowerCase());
			i++;
		}

		// Leave all other characters as they were written
		for (; i < tokens.length; i++) {
			result.push(tokens[i].toString());
		}

		result = result.join('');

		if (!(hasProtocol || hasSlashSlash)) {
			result = protocol + '://' + result;
		}

		return result;
	},
	hasProtocol: function hasProtocol() {
		return this.v[0] instanceof _text.PROTOCOL;
	}
});

exports.Base = MultiToken;
exports.MAILTOEMAIL = MAILTOEMAIL;
exports.EMAIL = EMAIL;
exports.NL = NL;
exports.TEXT = TEXT;
exports.URL = URL;

/***/ }),
/* 1343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.UserInitialsIconColorPalette = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _constants = __webpack_require__(120);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UserInitialsIconColorPalette = exports.UserInitialsIconColorPalette = function () {
    function UserInitialsIconColorPalette() {
        _classCallCheck(this, UserInitialsIconColorPalette);

        this.nextColorIndex = -1;
    }

    _createClass(UserInitialsIconColorPalette, [{
        key: 'getNextColor',
        value: function getNextColor() {
            this.nextColorIndex = this.nextColorIndex < _constants.USER_INITIALS_ICON_COLORS.length - 1 ? this.nextColorIndex + 1 : 0;
            return _constants.USER_INITIALS_ICON_COLORS[this.nextColorIndex];
        }
    }]);

    return UserInitialsIconColorPalette;
}();

/***/ }),
/* 1344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _LoadingSpinner = __webpack_require__(191);

var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);

var _constants = __webpack_require__(120);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LoadMoreCommentsButton = function (_TemplateView) {
    _inherits(LoadMoreCommentsButton, _TemplateView);

    function LoadMoreCommentsButton(_ref) {
        var _ref$onClickCb = _ref.onClickCb,
            onClickCb = _ref$onClickCb === undefined ? function () {} : _ref$onClickCb;

        _classCallCheck(this, LoadMoreCommentsButton);

        var _this = _possibleConstructorReturn(this, (LoadMoreCommentsButton.__proto__ || Object.getPrototypeOf(LoadMoreCommentsButton)).call(this));

        _this.onClickCb = onClickCb;

        _this.state = {
            loading: false
        };

        _this.onStatePropertyChanged('loading', function (loading) {
            return _this._updateLoading(loading);
        });
        return _this;
    }

    _createClass(LoadMoreCommentsButton, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class="loadMoreCommentsButton">' + '    <div class="loadMoreBtnTitle"><%=loadMoreBtnTitle%></div>' + '    <div class="loadingSpinner"></div>' + '</div>';
        }
    }, {
        key: 'templateModel',
        value: function templateModel() {
            return {
                loadMoreBtnTitle: _messageResource2.default.getMessage('panel.common.comments.load_more_comments')
            };
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            var _this2 = this;

            this.title = this.find('.loadMoreBtnTitle');
            this.loadingSpinner = new _LoadingSpinner2.default({}).init(this.find('.loadingSpinner'));

            this.getEl().click(function () {
                if (!_this2.state.loading) _this2.onClickCb();
            });
        }
    }, {
        key: '_updateLoading',
        value: function _updateLoading(loading) {
            this.getEl().toggleClass('disabled', loading);
            this.title.toggle(!loading);
            this.loadingSpinner.setState({ show: loading });
        }
    }]);

    return LoadMoreCommentsButton;
}(_TemplateView3.default);

exports.default = LoadMoreCommentsButton;

/***/ }),
/* 1345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.afterTaskMovedCb = exports.updateCommentsCount = exports.updateProjects = exports.updateCustomers = exports.onProjectDeleted = exports.afterTaskDeleted = exports.afterTaskLoadedCb = exports.afterTaskUpdateCb = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _TaskStore = __webpack_require__(91);

var _TaskStore2 = _interopRequireDefault(_TaskStore);

var _CustomerStore = __webpack_require__(65);

var _CustomerStore2 = _interopRequireDefault(_CustomerStore);

var _ProjectStore = __webpack_require__(59);

var _ProjectStore2 = _interopRequireDefault(_ProjectStore);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _ViewTTStore = __webpack_require__(73);

var _ViewTTStore2 = _interopRequireDefault(_ViewTTStore);

var _utils = __webpack_require__(192);

var _TaskManagementStore = __webpack_require__(140);

var _TaskManagementStore2 = _interopRequireDefault(_TaskManagementStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var afterTaskUpdateCb = exports.afterTaskUpdateCb = function afterTaskUpdateCb(taskId, newData) {
    var taskFromStore = _TaskStore2.default.get(taskId);
    var task = _extends({}, taskFromStore, newData);
    _TaskStore2.default.add(task);
    (0, _jquery2.default)(document).trigger("editTaskPanel_updateTask", [{ taskId: taskId, prevTaskState: taskFromStore }]);
};

var afterTaskLoadedCb = exports.afterTaskLoadedCb = function afterTaskLoadedCb(task) {
    _TaskStore2.default.add(task);
};

var afterTaskDeleted = exports.afterTaskDeleted = function afterTaskDeleted(taskId) {
    (0, _jquery2.default)(document).trigger("taskManagement_removeTasks", [[taskId]]);
    _TaskStore2.default.remove(taskId);
    _TaskManagementStore2.default.removeTasks([taskId]);
};

var onProjectDeleted = exports.onProjectDeleted = function onProjectDeleted(projectId) {
    _ProjectStore2.default.remove(projectId);
    (0, _jquery2.default)(document).trigger("editTaskPanel_projectDeleted", [{ projectId: projectId }]);
};

var updateCustomers = exports.updateCustomers = function updateCustomers(customers) {
    // TODO: can use CustomerStore.mergeAll
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = customers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var customer = _step.value;

            _CustomerStore2.default.add((0, _utils.customerFromRpc)(customer));
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
};

var updateProjects = exports.updateProjects = function updateProjects(projects) {
    // TODO: can use ProjectStore.mergeAll
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
        for (var _iterator2 = projects[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var project = _step2.value;

            _ProjectStore2.default.add((0, _utils.projectFromRpc)(project));
        }
    } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
            }
        } finally {
            if (_didIteratorError2) {
                throw _iteratorError2;
            }
        }
    }
};

var updateCommentsCount = exports.updateCommentsCount = function updateCommentsCount(taskId, commentsCount) {
    var taskFromStore = _TaskStore2.default.get(taskId);
    var task = _extends({}, taskFromStore, {
        commentsNumber: commentsCount
    });
    _TaskStore2.default.add(task);
};

var afterTaskMovedCb = exports.afterTaskMovedCb = function afterTaskMovedCb(project, customer) {
    _ViewTTStore2.default.setProject(project);
    _ViewTTStore2.default.setCustomer(customer);
};

/***/ }),
/* 1346 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _rpcCalls = __webpack_require__(24);

var _errors = __webpack_require__(193);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var EditTaskService = function () {
    function EditTaskService() {
        _classCallCheck(this, EditTaskService);
    }

    _createClass(EditTaskService, [{
        key: "getAssignedUsers",
        value: function getAssignedUsers(taskId) {
            return (0, _rpcCalls.rpcCall)("EditTaskService.getAssignedUsers", [taskId], this._rpcErrorHandler);
        }
    }, {
        key: "updateAssignedUsers",
        value: function updateAssignedUsers(taskId, addedUserIds, removeUserIds) {
            return (0, _rpcCalls.rpcCall)("EditTaskService.updateAssignedUsers", [taskId, addedUserIds, removeUserIds], this._rpcErrorHandler);
        }
    }, {
        key: "updateManagers",
        value: function updateManagers(taskId, addedUserIds, removeUserIds) {
            return (0, _rpcCalls.rpcCall)("EditTaskService.updateManagers", [taskId, addedUserIds, removeUserIds], this._rpcErrorHandler);
        }
    }, {
        key: "_rpcErrorHandler",
        value: function _rpcErrorHandler(rpcError) {
            rpcError.handleOnException('com.actimind.actitime.task.NoSuchTaskException', new _errors.NotFoundError());
            rpcError.handleOnException('com.actimind.actitime.services.EditTaskService$NoRightsToManageTaskException', new _errors.NoRightsError());
            rpcError.handleOnException('com.actimind.actitime.task.TaskIsNotAssignedToUserException', new _errors.NoRightsError());
            rpcError.handleOnException('com.actimind.actitime.services.NoRightToEditHierarchyException', new _errors.NoEditHierarchyRightError());
            rpcError.handleOnException('com.actimind.actitime.services.NoRightsToManageAccountSettings', new _errors.NoManageUsersRightError());
            rpcError.handleOnException('com.actimind.actitime.services.UserIsNotAssignedToManagerException', new _errors.NotAssignedError());
            rpcError.handleOnException('com.actimind.actitime.services.NoRightsToSubmitTTException', new _errors.NoSubmitTTRightError());
            rpcError.handleOnException('com.actimind.actitime.services.UserHasNoAccessToScopeException', new _errors.NoAccessToScopeError());
            rpcError.handleOnException('com.actimind.actitime.administration.NoSuchUserException', new _errors.NoSuchUserError());
            rpcError.handleOnException('com.actimind.actitime.administration.UserIsDisabledException', new _errors.EditingUserDisabled());
        }
    }]);

    return EditTaskService;
}();

exports.default = EditTaskService;

/***/ }),
/* 1347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _rpcCalls = __webpack_require__(24);

var _errors = __webpack_require__(193);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ProjectInfoService = function () {
    function ProjectInfoService() {
        _classCallCheck(this, ProjectInfoService);
    }

    _createClass(ProjectInfoService, [{
        key: "getAssignedUsers",
        value: function getAssignedUsers(projectId) {
            return (0, _rpcCalls.rpcCall)("ProjectInfoService.getAssignedUsers", [projectId], this._rpcErrorHandler);
        }
    }, {
        key: "updateAssignedUsers",
        value: function updateAssignedUsers(projectId, addedUserIds, removeUserIds) {
            return (0, _rpcCalls.rpcCall)("ProjectInfoService.updateAssignedUsers", [projectId, addedUserIds, removeUserIds], this._rpcErrorHandler);
        }
    }, {
        key: "updateManagers",
        value: function updateManagers(projectId, addedUserIds, removeUserIds) {
            return (0, _rpcCalls.rpcCall)("ProjectInfoService.updateManagers", [projectId, addedUserIds, removeUserIds], this._rpcErrorHandler);
        }
    }, {
        key: "_rpcErrorHandler",
        value: function _rpcErrorHandler(rpcError) {
            rpcError.handleOnException('com.actimind.actitime.project.NoSuchProjectException', new _errors.NotFoundError());
            rpcError.handleOnException('com.actimind.actitime.services.NoRightsForRemoteCallException', new _errors.NoRightsError());
            rpcError.handleOnException('com.actimind.actitime.services.NoRightToEditHierarchyException', new _errors.NoEditHierarchyRightError());
            rpcError.handleOnException('com.actimind.actitime.services.NoRightsToManageAccountSettings', new _errors.NoManageUsersRightError());
            rpcError.handleOnException('com.actimind.actitime.services.UserIsNotAssignedToManagerException', new _errors.NotAssignedError());
            rpcError.handleOnException('com.actimind.actitime.services.NoRightsToSubmitTTException', new _errors.NoSubmitTTRightError());
            rpcError.handleOnException('com.actimind.actitime.services.UserHasNoAccessToScopeException', new _errors.NoAccessToScopeError());
            rpcError.handleOnException('com.actimind.actitime.administration.NoSuchUserException', new _errors.NoSuchUserError());
            rpcError.handleOnException('com.actimind.actitime.administration.UserIsDisabledException', new _errors.EditingUserDisabled());
        }
    }]);

    return ProjectInfoService;
}();

exports.default = ProjectInfoService;

/***/ }),
/* 1348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _rpcCalls = __webpack_require__(24);

var _errors = __webpack_require__(193);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CustomerInfoService = function () {
    function CustomerInfoService() {
        _classCallCheck(this, CustomerInfoService);
    }

    _createClass(CustomerInfoService, [{
        key: "getAssignedUsers",
        value: function getAssignedUsers(customerId) {
            return (0, _rpcCalls.rpcCall)("CustomerInfoService.getAssignedUsers", [customerId], this._rpcErrorHandler);
        }
    }, {
        key: "updateAssignedUsers",
        value: function updateAssignedUsers(customerId, addedUserIds, removeUserIds) {
            return (0, _rpcCalls.rpcCall)("CustomerInfoService.updateAssignedUsers", [customerId, addedUserIds, removeUserIds], this._rpcErrorHandler);
        }
    }, {
        key: "getManagers",
        value: function getManagers(customerId) {
            return (0, _rpcCalls.rpcCall)("CustomerInfoService.getManagers", [customerId], this._rpcErrorHandler);
        }
    }, {
        key: "updateManagers",
        value: function updateManagers(customerId, addedUserIds, removeUserIds) {
            return (0, _rpcCalls.rpcCall)("CustomerInfoService.updateManagers", [customerId, addedUserIds, removeUserIds], this._rpcErrorHandler);
        }
    }, {
        key: "getAssignedUsersForAll",
        value: function getAssignedUsersForAll() {
            return (0, _rpcCalls.rpcCall)("CustomerInfoService.getAssignedUsersForAll", [], this._rpcErrorHandler);
        }
    }, {
        key: "getManagersForAll",
        value: function getManagersForAll() {
            return (0, _rpcCalls.rpcCall)("CustomerInfoService.getManagersForAll", [], this._rpcErrorHandler);
        }
    }, {
        key: "_rpcErrorHandler",
        value: function _rpcErrorHandler(rpcError) {
            rpcError.handleOnException('com.actimind.actitime.customer.NoSuchCustomerException', new _errors.NotFoundError());
            rpcError.handleOnException('com.actimind.actitime.services.NoRightsForRemoteCallException', new _errors.NoRightsError());
            rpcError.handleOnException('com.actimind.actitime.services.NoRightToEditHierarchyException', new _errors.NoEditHierarchyRightError());
            rpcError.handleOnException('com.actimind.actitime.services.NoRightsToManageAccountSettings', new _errors.NoManageUsersRightError());
            rpcError.handleOnException('com.actimind.actitime.services.UserIsNotAssignedToManagerException', new _errors.NotAssignedError());
            rpcError.handleOnException('com.actimind.actitime.services.NoRightsToSubmitTTException', new _errors.NoSubmitTTRightError());
            rpcError.handleOnException('com.actimind.actitime.services.UserHasNoAccessToScopeException', new _errors.NoAccessToScopeError());
            rpcError.handleOnException('com.actimind.actitime.administration.NoSuchUserException', new _errors.NoSuchUserError());
            rpcError.handleOnException('com.actimind.actitime.administration.UserIsDisabledException', new _errors.EditingUserDisabled());
        }
    }]);

    return CustomerInfoService;
}();

exports.default = CustomerInfoService;

/***/ }),
/* 1349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ClassicBridge = __webpack_require__(18);

var _ClassicBridge2 = _interopRequireDefault(_ClassicBridge);

var _utils = __webpack_require__(135);

var _connector = __webpack_require__(288);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TaskManagementService = function () {
    function TaskManagementService() {
        _classCallCheck(this, TaskManagementService);
    }

    _createClass(TaskManagementService, [{
        key: "loadKanbanInitial",
        value: function loadKanbanInitial(cpSelection, workflowStatusFilter, customFieldsFilters, taskWorkflowStatuses, wordFilter, onlyManageableTasks) {
            var params = {
                customFieldsFilters: customFieldsFilters
            };

            (0, _connector.fillNextDataParams)({
                intersectedCPSelection: cpSelection,
                taskStatusFilter: workflowStatusFilter,
                taskNameFilter: wordFilter,
                showOnlyManageableTasks: onlyManageableTasks
            }, {
                taskWorkflowStatuses: taskWorkflowStatuses
            })(params);

            return _ClassicBridge2.default.getKanbanSummary(params).then(function (nextData) {
                return (0, _utils.convertNextKanbanSummaryToClassicKanbanInitial)(nextData);
            });
        }
    }, {
        key: "loadKanbanTasks",
        value: function loadKanbanTasks(projectId, intersectedCPSelection, filteredWorkflowStatusIds, customFieldsFilters, taskWorkflowStatuses, wordFilter, onlyManageableTasks, offset, limit) {
            var params = {
                projectIds: [projectId],
                customFieldsFilters: customFieldsFilters,
                offset: offset,
                limit: limit,
                sortField: _connector.NEXT_SORTING_FIELDS.KANBAN_POSITION,
                ascSort: false
            };

            (0, _connector.fillNextParamsWithOnlyManageableTasks)(params, onlyManageableTasks);
            (0, _connector.fillNextParamsWithTaskNameFilter)(params, wordFilter);

            return Promise.all(filteredWorkflowStatusIds.map(function (workflowStatusId) {
                return _ClassicBridge2.default.getTasksForTaskList(_extends({
                    workflowStatusIds: [workflowStatusId]
                }, params));
            })).then(function (result) {
                var tasks = result.map(function (data) {
                    return data.items;
                }).flat();

                return (0, _connector.loadAndMergeRpcAndNextData)({ items: tasks }, intersectedCPSelection);
            });
        }
    }]);

    return TaskManagementService;
}();

exports.default = TaskManagementService;

/***/ }),
/* 1350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.afterTaskUpdated = undefined;

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var afterTaskUpdated = exports.afterTaskUpdated = function afterTaskUpdated(taskId) {
    (0, _jquery2.default)(document).trigger("taskManagement_taskUpdated", taskId);
};

/***/ }),
/* 1351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _BulkOperationsController = __webpack_require__(368);

var _BulkOperationsController2 = _interopRequireDefault(_BulkOperationsController);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BulkDeleteTasksController = function (_BulkOperationsContro) {
    _inherits(BulkDeleteTasksController, _BulkOperationsContro);

    function BulkDeleteTasksController(_ref) {
        var _ref$onSuccess = _ref.onSuccess,
            onSuccess = _ref$onSuccess === undefined ? function () {} : _ref$onSuccess,
            _ref$onProgress = _ref.onProgress,
            onProgress = _ref$onProgress === undefined ? function () {} : _ref$onProgress,
            _ref$onFailure = _ref.onFailure,
            onFailure = _ref$onFailure === undefined ? function () {} : _ref$onFailure;

        _classCallCheck(this, BulkDeleteTasksController);

        return _possibleConstructorReturn(this, (BulkDeleteTasksController.__proto__ || Object.getPrototypeOf(BulkDeleteTasksController)).call(this, {
            method: 'TaskManagementService.deleteTasks',
            initialResult: {
                deletedTaskIds: [],
                notAvailableTaskIds: [],
                successTaskIds: []
            },
            combineFn: function combineFn(result, chunkResult) {
                return {
                    deletedTaskIds: [].concat(_toConsumableArray(result.deletedTaskIds), _toConsumableArray(chunkResult.deletedTaskIds)),
                    notAvailableTaskIds: [].concat(_toConsumableArray(result.notAvailableTaskIds), _toConsumableArray(chunkResult.notAvailableTaskIds)),
                    successTaskIds: [].concat(_toConsumableArray(result.successTaskIds), _toConsumableArray(chunkResult.successTaskIds))
                };
            },
            onSuccess: onSuccess,
            onProgress: onProgress,
            onFailure: onFailure
        }));
    }

    return BulkDeleteTasksController;
}(_BulkOperationsController2.default);

exports.default = BulkDeleteTasksController;

/***/ }),
/* 1352 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _BulkOperationsController = __webpack_require__(368);

var _BulkOperationsController2 = _interopRequireDefault(_BulkOperationsController);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BulkMoveCopyTasksController = function (_BulkOperationsContro) {
    _inherits(BulkMoveCopyTasksController, _BulkOperationsContro);

    function BulkMoveCopyTasksController(_ref) {
        var method = _ref.method,
            _ref$onSuccess = _ref.onSuccess,
            onSuccess = _ref$onSuccess === undefined ? function () {} : _ref$onSuccess,
            _ref$onProgress = _ref.onProgress,
            onProgress = _ref$onProgress === undefined ? function () {} : _ref$onProgress,
            _ref$onFailure = _ref.onFailure,
            onFailure = _ref$onFailure === undefined ? function () {} : _ref$onFailure;

        _classCallCheck(this, BulkMoveCopyTasksController);

        return _possibleConstructorReturn(this, (BulkMoveCopyTasksController.__proto__ || Object.getPrototypeOf(BulkMoveCopyTasksController)).call(this, {
            method: method,
            initialResult: {
                successTasksCount: 0,
                deletedTasksCount: 0,
                notAvailableTasksCount: 0,
                duplicateNameTasksCount: 0,
                invalidTaskStatusCount: 0
            },
            combineFn: function combineFn(result, chunkResult) {
                return {
                    successTasksCount: result.successTasksCount + chunkResult.successTasksCount,
                    deletedTasksCount: result.deletedTasksCount + chunkResult.deletedTasksCount,
                    notAvailableTasksCount: result.notAvailableTasksCount + chunkResult.notAvailableTasksCount,
                    duplicateNameTasksCount: result.duplicateNameTasksCount + chunkResult.duplicateNameTasksCount,
                    invalidTaskStatusCount: result.invalidTaskStatusCount + chunkResult.invalidTaskStatusCount
                };
            },
            onSuccess: onSuccess,
            onProgress: onProgress,
            onFailure: onFailure
        }));
    }

    return BulkMoveCopyTasksController;
}(_BulkOperationsController2.default);

exports.default = BulkMoveCopyTasksController;

/***/ }),
/* 1353 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _BulkOperationsController = __webpack_require__(368);

var _BulkOperationsController2 = _interopRequireDefault(_BulkOperationsController);

var _atUtils = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BulkChangeStatusTasksController = function (_BulkOperationsContro) {
    _inherits(BulkChangeStatusTasksController, _BulkOperationsContro);

    function BulkChangeStatusTasksController(_ref) {
        var method = _ref.method,
            _ref$onSuccess = _ref.onSuccess,
            onSuccess = _ref$onSuccess === undefined ? function () {} : _ref$onSuccess,
            _ref$onProgress = _ref.onProgress,
            onProgress = _ref$onProgress === undefined ? function () {} : _ref$onProgress,
            _ref$onFailure = _ref.onFailure,
            onFailure = _ref$onFailure === undefined ? function () {} : _ref$onFailure;

        _classCallCheck(this, BulkChangeStatusTasksController);

        return _possibleConstructorReturn(this, (BulkChangeStatusTasksController.__proto__ || Object.getPrototypeOf(BulkChangeStatusTasksController)).call(this, {
            method: method,
            initialResult: {
                taskIds: [],
                restoredProjects: {},
                restoredCustomers: {}
            },
            combineFn: function combineFn(result, chunkResult) {
                return {
                    taskIds: [].concat(_toConsumableArray(result.taskIds), _toConsumableArray(chunkResult.taskIds)),
                    restoredProjects: _extends({}, result.restoredProjects, (0, _atUtils.arrayToMap)(chunkResult.restoredProjects)),
                    restoredCustomers: _extends({}, result.restoredCustomers, (0, _atUtils.arrayToMap)(chunkResult.restoredCustomers))
                };
            },
            onSuccess: onSuccess,
            onProgress: onProgress,
            onFailure: onFailure
        }));
    }

    return BulkChangeStatusTasksController;
}(_BulkOperationsController2.default);

exports.default = BulkChangeStatusTasksController;

/***/ }),
/* 1354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _BulkOperationsController = __webpack_require__(368);

var _BulkOperationsController2 = _interopRequireDefault(_BulkOperationsController);

var _atUtils = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BulkChangeAssignmentsTasksController = function (_BulkOperationsContro) {
    _inherits(BulkChangeAssignmentsTasksController, _BulkOperationsContro);

    function BulkChangeAssignmentsTasksController(_ref) {
        var _ref$onSuccess = _ref.onSuccess,
            onSuccess = _ref$onSuccess === undefined ? function () {} : _ref$onSuccess,
            _ref$onProgress = _ref.onProgress,
            onProgress = _ref$onProgress === undefined ? function () {} : _ref$onProgress,
            _ref$onFailure = _ref.onFailure,
            onFailure = _ref$onFailure === undefined ? function () {} : _ref$onFailure;

        _classCallCheck(this, BulkChangeAssignmentsTasksController);

        return _possibleConstructorReturn(this, (BulkChangeAssignmentsTasksController.__proto__ || Object.getPrototypeOf(BulkChangeAssignmentsTasksController)).call(this, {
            method: 'TaskManagementService.assignTasksToUsers',
            initialResult: {
                taskIds: [],
                userIds: {},
                managementAssignments: {},
                viewerSettings: {}
            },
            combineFn: function combineFn(result, chunkResult) {
                return {
                    taskIds: [].concat(_toConsumableArray(result.taskIds), _toConsumableArray(chunkResult.taskIds)),
                    userIds: _extends({}, result.userIds, (0, _atUtils.arrayToSet)(chunkResult.userIds)),
                    managementAssignments: chunkResult.managementAssignments,
                    viewerSettings: chunkResult.viewerSettings
                };
            },
            onSuccess: onSuccess,
            onProgress: onProgress,
            onFailure: onFailure
        }));
    }

    return BulkChangeAssignmentsTasksController;
}(_BulkOperationsController2.default);

exports.default = BulkChangeAssignmentsTasksController;

/***/ }),
/* 1355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getCopyTasksToastText = exports.getMoveTasksToastText = exports.getStatusChangedTaskToastText = exports.getAssignedTaskToastText = exports.getDeletedTasksToastText = undefined;

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getDeletedTasksToastText = exports.getDeletedTasksToastText = function getDeletedTasksToastText(deletedTaskIds, task) {
    if (deletedTaskIds.length === 0) {
        return _messageResource2.default.getMessage("delete.tasks.toast.none");
    }

    if (deletedTaskIds.length === 1 && task) {
        return _messageResource2.default.getMessage("delete.tasks.toast.singular", [task.name]);
    }

    if (deletedTaskIds.length === 1) {
        return _messageResource2.default.getMessage("delete.unknown_task.toast");
    }

    return _messageResource2.default.getMessage("delete.tasks.toast", [deletedTaskIds.length]);
};

var getAssignedTaskToastText = exports.getAssignedTaskToastText = function getAssignedTaskToastText(tasksCount, usersCount, task) {
    if (tasksCount === 0 || usersCount === 0) {
        return _messageResource2.default.getMessage("assign_to.tasks.toast.none");
    }

    if (tasksCount === 1 && usersCount === 1) {
        return _messageResource2.default.getMessage("assign_to.tasks.toast.one_task_one_user", [task.name]);
    }

    if (tasksCount === 1 && usersCount > 1) {
        return _messageResource2.default.getMessage("assign_to.tasks.toast.one_task", [task.name, usersCount]);
    }

    if (tasksCount > 1 && usersCount === 1) {
        return _messageResource2.default.getMessage("assign_to.tasks.toast.one_user", [tasksCount]);
    }

    return _messageResource2.default.getMessage("assign_to.tasks.toast", [tasksCount, usersCount]);
};

var getStatusChangedTaskToastText = exports.getStatusChangedTaskToastText = function getStatusChangedTaskToastText(taskCount, task) {
    if (taskCount === 0) {
        return _messageResource2.default.getMessage("status.tasks.toast.none");
    }

    if (taskCount === 1) {
        return _messageResource2.default.getMessage("status.tasks.toast.singular", [task.name]);
    }

    return _messageResource2.default.getMessage("status.tasks.toast", [taskCount]);
};

var getMoveTasksToastText = exports.getMoveTasksToastText = function getMoveTasksToastText(tasksCount, project, task) {
    if (tasksCount === 1) {
        return _messageResource2.default.getMessage('move.task.toast', [task.name, project.name]);
    }

    return _messageResource2.default.getMessage("move.tasks.toast", [tasksCount, project.name]);
};

var getCopyTasksToastText = exports.getCopyTasksToastText = function getCopyTasksToastText(tasksCount, project, task) {
    if (tasksCount === 1) {
        return _messageResource2.default.getMessage('copy.task.toast', [task.name, project.name]);
    }

    return _messageResource2.default.getMessage("copy.tasks.toast", [tasksCount, project.name]);
};

/***/ }),
/* 1356 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.WorkflowStatusList = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _constants = __webpack_require__(23);

var _utils = __webpack_require__(80);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _SimpleSingletonTooltip = __webpack_require__(45);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var WorkflowStatusList = exports.WorkflowStatusList = function (_TemplateView) {
    _inherits(WorkflowStatusList, _TemplateView);

    function WorkflowStatusList(_ref) {
        var _ref$groupRenderer = _ref.groupRenderer,
            groupRenderer = _ref$groupRenderer === undefined ? null : _ref$groupRenderer,
            _ref$statusRenderer = _ref.statusRenderer,
            statusRenderer = _ref$statusRenderer === undefined ? null : _ref$statusRenderer,
            _ref$additionalClass = _ref.additionalClass,
            additionalClass = _ref$additionalClass === undefined ? '' : _ref$additionalClass,
            _ref$showGroups = _ref.showGroups,
            showGroups = _ref$showGroups === undefined ? true : _ref$showGroups;

        _classCallCheck(this, WorkflowStatusList);

        var _this = _possibleConstructorReturn(this, (WorkflowStatusList.__proto__ || Object.getPrototypeOf(WorkflowStatusList)).call(this, null));

        _this.state = {
            statuses: [],
            inactiveOpenStatuses: false,
            showCompletedFirst: false,
            hideCompleted: false,
            showChangeStatusLabel: false,
            showReopenLabel: false,
            showGroups: showGroups
        };

        _this.params = {
            groupRenderer: groupRenderer,
            statusRenderer: statusRenderer,
            additionalClass: additionalClass,
            showGroups: showGroups
        };

        _this.onAnyStatePropertyChanged(['statuses', 'hideCompleted', 'showGroups'], function () {
            if (_this.rendered) {
                _this._renderStatuses();
            }

            _this.$el.toggleClass('grouped', _this.state.showGroups);
        });

        _this.onStatePropertyChanged('inactiveOpenStatuses', function (inactiveOpenStatus) {
            _this.$openStatuses.toggleClass('inactive', inactiveOpenStatus);
            if (inactiveOpenStatus) {
                (0, _SimpleSingletonTooltip.getInstance)().subscribeToMouseEvents(_this.$openStatuses, function () {
                    (0, _SimpleSingletonTooltip.getInstance)().setState({
                        text: _messageResource2.default.getMessage('task.list.tooltip.task.inactive_open_statuses'),
                        extraClass: 'workflowStatusList_inactiveOpenStatusesTooltip'
                    });
                });
            }
        });

        _this.onStatePropertyChanged('showCompletedFirst', function (showCompletedFirst) {
            _this.$statusesListContainer.toggleClass('showCompletedFirst', showCompletedFirst);
        });

        _this.onStatePropertyChanged('showChangeStatusLabel', function (show) {
            _this.$changeStatusLabel.toggle(show);
        });

        _this.onStatePropertyChanged('showReopenLabel', function (show) {
            _this.$reopenLabel.toggle(show);
        });

        _this.onAnyStatePropertyChanged(['showCompletedFirst', 'showReopenLabel', 'hideCompleted'], function () {
            _this.$completedStatuses.toggleClass("withBottomBorder", _this.state.showCompletedFirst && _this.state.showReopenLabel && !_this.state.hideCompleted);
        });
        return _this;
    }

    _createClass(WorkflowStatusList, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class="workflowStatus_components_workflowStatusList <%=additionalClass%>">' + '    <div class="changeStatusLabel actionName"><%-changeStatusLabel%></div>' + '    <div class="statusesListContainer">' + '      <div class="openStatuses">' + '          <div class="cover"></div>' + '          <div class="reopenLabel actionName"><%-reopenLabel%></div>' + '          <div class="openStatusesContainer"></div>' + '      </div>' + '      <div class="completedStatuses">' + '          <div class="completedStatusesContainer"></div>' + '      </div>' + '    </div>' + '</div>';
        }
    }, {
        key: 'templateModel',
        value: function templateModel() {
            return {
                additionalClass: this.params.additionalClass,
                changeStatusLabel: _messageResource2.default.getMessage('workflow_list.change_status'),
                reopenLabel: _messageResource2.default.getMessage('workflow_list.reopen')
            };
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            this.$openStatusesContainer = this.$el.find('.openStatusesContainer');
            this.$openStatuses = this.$el.find('.openStatuses');
            this.$completedStatuses = this.$el.find('.completedStatuses');
            this.$completedStatusesContainer = this.$el.find('.completedStatusesContainer');
            this.$statusesListContainer = this.find('.statusesListContainer');
            this.$reopenLabel = this.find('.reopenLabel');
            this.$changeStatusLabel = this.find('.changeStatusLabel');
        }
    }, {
        key: '_renderStatuses',
        value: function _renderStatuses() {
            var _this2 = this;

            this.$openStatusesContainer.empty();
            this.$completedStatusesContainer.empty();

            var openStatuses = [];
            var completedStatuses = [];

            var sorted = this.state.statuses.sort(_utils.workflowStatusComparator);
            sorted.forEach(function (status) {
                if (status.type === _constants.WorkflowStatusType.OPEN) {
                    openStatuses.push(status);
                } else {
                    completedStatuses.push(status);
                }
            });

            if (openStatuses.length !== 0) {
                if (this.state.showGroups) {
                    this.params.groupRenderer(this.$openStatusesContainer, _constants.WorkflowStatusType.OPEN);
                }

                openStatuses.forEach(function (status) {
                    _this2.params.statusRenderer(_this2.$openStatusesContainer, status);
                });
            }

            if (completedStatuses.length !== 0 && !this.state.hideCompleted) {
                if (this.state.showGroups) {
                    this.params.groupRenderer(this.$completedStatusesContainer, _constants.WorkflowStatusType.COMPLETED);
                }

                completedStatuses.forEach(function (status) {
                    _this2.params.statusRenderer(_this2.$completedStatusesContainer, status);
                });
            }
        }
    }]);

    return WorkflowStatusList;
}(_TemplateView3.default);

exports.default = WorkflowStatusList;

/***/ }),
/* 1357 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.WorkflowStatusNode = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _WorkflowStatus = __webpack_require__(360);

var _WorkflowStatus2 = _interopRequireDefault(_WorkflowStatus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var WorkflowStatusNode = exports.WorkflowStatusNode = function (_TemplateView) {
    _inherits(WorkflowStatusNode, _TemplateView);

    function WorkflowStatusNode(_ref, onClickStatus) {
        var status = _ref.status,
            checked = _ref.checked;

        _classCallCheck(this, WorkflowStatusNode);

        var _this = _possibleConstructorReturn(this, (WorkflowStatusNode.__proto__ || Object.getPrototypeOf(WorkflowStatusNode)).call(this, null));

        _this._handleClickStatus = function () {
            _this.params.onClickStatus(_this.params.status.id);
        };

        _this.params = {
            status: status,
            onClickStatus: onClickStatus,
            checked: checked
        };
        return _this;
    }

    _createClass(WorkflowStatusNode, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class="workflowStatusNode"></div>';
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            new _WorkflowStatus2.default(_extends({}, this.params.status)).init(this.$el);

            this.$el.toggleClass('checked', this.params.checked).click(this._handleClickStatus);
        }
    }]);

    return WorkflowStatusNode;
}(_TemplateView3.default);

exports.default = WorkflowStatusNode;

/***/ }),
/* 1358 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.WorkflowStatusTypeNode = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _constants = __webpack_require__(23);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var WorkflowStatusTypeNode = exports.WorkflowStatusTypeNode = function (_TemplateView) {
    _inherits(WorkflowStatusTypeNode, _TemplateView);

    function WorkflowStatusTypeNode(type) {
        _classCallCheck(this, WorkflowStatusTypeNode);

        var _this = _possibleConstructorReturn(this, (WorkflowStatusTypeNode.__proto__ || Object.getPrototypeOf(WorkflowStatusTypeNode)).call(this, null));

        _this.type = type;
        return _this;
    }

    _createClass(WorkflowStatusTypeNode, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class="workflowStatusTypeNode"><%-text%></div>';
        }
    }, {
        key: 'templateModel',
        value: function templateModel() {
            return {
                text: _messageResource2.default.getMessage(this.type === _constants.WorkflowStatusType.OPEN ? 'workflow_list.open_tasks' : 'workflow_list.completed_tasks')
            };
        }
    }]);

    return WorkflowStatusTypeNode;
}(_TemplateView3.default);

exports.default = WorkflowStatusTypeNode;

/***/ }),
/* 1359 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.LinkifiedText = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _string = __webpack_require__(759);

var _string2 = _interopRequireDefault(_string);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LinkifiedText = exports.LinkifiedText = function (_TemplateView) {
    _inherits(LinkifiedText, _TemplateView);

    function LinkifiedText() {
        _classCallCheck(this, LinkifiedText);

        var _this = _possibleConstructorReturn(this, (LinkifiedText.__proto__ || Object.getPrototypeOf(LinkifiedText)).call(this));

        _this.state = {
            text: ''
        };

        _this.onStatePropertyChanged('text', function (text) {
            if (!!text) _this.$el.html((0, _string2.default)(text)).find('a').click(function (e) {
                return e.stopPropagation();
            });
        });
        return _this;
    }

    _createClass(LinkifiedText, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class="components_linkifiedText"/>';
        }
    }]);

    return LinkifiedText;
}(_TemplateView3.default);

/***/ }),
/* 1360 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _constants = __webpack_require__(157);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _user_time = __webpack_require__(30);

var _user_time2 = _interopRequireDefault(_user_time);

var _NameInput = __webpack_require__(370);

var _NameInput2 = _interopRequireDefault(_NameInput);

var _atBrowserUtils = __webpack_require__(8);

var _EditActionButton = __webpack_require__(494);

var _EditActionButton2 = _interopRequireDefault(_EditActionButton);

var _constants2 = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Header = function (_TemplateView) {
    _inherits(Header, _TemplateView);

    function Header($containerEl, $panel, _ref) {
        var _ref$editable = _ref.editable,
            editable = _ref$editable === undefined ? false : _ref$editable,
            _ref$showActions = _ref.showActions,
            showActions = _ref$showActions === undefined ? false : _ref$showActions,
            _ref$showReportTab = _ref.showReportTab,
            showReportTab = _ref$showReportTab === undefined ? false : _ref$showReportTab,
            _ref$showEmptyNameInp = _ref.showEmptyNameInput,
            showEmptyNameInput = _ref$showEmptyNameInp === undefined ? false : _ref$showEmptyNameInp,
            _ref$onChangeNameCb = _ref.onChangeNameCb,
            onChangeNameCb = _ref$onChangeNameCb === undefined ? function () {} : _ref$onChangeNameCb,
            _ref$onTabSwitchedCb = _ref.onTabSwitchedCb,
            onTabSwitchedCb = _ref$onTabSwitchedCb === undefined ? function () {} : _ref$onTabSwitchedCb;

        _classCallCheck(this, Header);

        var _this = _possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).call(this, $containerEl));

        _this.$panel = $panel;
        _this.params = {
            showActions: showActions,
            showReportTab: showReportTab,
            editable: editable,
            showEmptyNameInput: showEmptyNameInput
        };

        _this.callbacks = {
            onChangeNameCb: onChangeNameCb,
            onTabSwitchedCb: onTabSwitchedCb
        };

        _this.state = {
            name: '',
            projectName: '',
            customerName: '',
            nameLoading: false,
            errors: {},
            editable: _this.params.editable,
            isNeedInitializeFocus: false
        };

        _this.onStatePropertyChanged('isNeedInitializeFocus', function (isNeedInitializeFocus) {
            _this.taskNameInput.setState({ isNeedInitializeFocus: isNeedInitializeFocus });
        });

        _this.onStatePropertyChanged('errors', function (errors) {
            if (!!errors[_constants.ValidationErrors.TASK_NAME_DUPLICATE]) {
                _this.taskNameInput.setState({
                    invalid: true,
                    focus: true,
                    errorText: _messageResource2.default.getMessage("task.edit_popup.duplicate")
                });
            } else if (!!errors[_constants.ValidationErrors.TASK_NAME_EMPTY]) {
                _this.taskNameInput.setState({
                    invalid: true,
                    focus: true,
                    errorText: _messageResource2.default.getMessage('task.edit_popup.empty')
                });
            } else {
                _this.taskNameInput.setState({
                    invalid: false
                });
            }
        });

        _this.onStatePropertyChanged('name', function (name) {
            _this.taskNameInput.setState({
                name: name,
                focus: !name
            });
        });

        _this.onStatePropertyChanged('nameLoading', function (loading) {
            _this.taskNameInput.setLoading(loading);
        });

        _this.onStatePropertyChanged('projectName', function (name) {
            _this.$projectName.text(name);
        });

        _this.onStatePropertyChanged('customerName', function (name) {
            _this.$customerName.text(name);
        });

        _this.onStatePropertyChanged('editable', function (editable) {
            _this.actions.toggle(editable && _this.params.showActions);
            _this.taskNameInput.setState({ editable: editable });
        });
        return _this;
    }

    _createClass(Header, [{
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='header'>" + "  <div class='cpInfo'>" + "   <span class='customerName ellipsis'/><img src='<%=separatorArrow%>' class='separator'/><span class='projectName ellipsis'/>" + "  </div>" + "  <div class='taskNamePlaceholder'/>" + "  <div class='actions'></div>" + "  <div class='tabs'>" + "    <div class='details'><span class='tabText'><%=detailsTab%></span></div>" + "    <div class='reportedTime'><span class='tabText'><%=reportedTimeTab%></span></div>" + "    <div class='assignedUsers'><span class='tabText'><%=assignedUsersTab%></span></div>" + "    <div class='managers'><span class='tabText'><%=managersTab%></span></div>" + "    <div class='budgets'><span class='tabText'><%=budgetsTab%></span></div>" + "  </div>" + "</div>";
        }
    }, {
        key: "shouldUpdateOnInit",
        value: function shouldUpdateOnInit() {
            return false;
        }
    }, {
        key: "messageKeys",
        value: function messageKeys() {
            return {
                detailsTab: 'task.edit_panel.tabs.details',
                reportedTimeTab: 'task.edit_panel.tabs.reportedTime',
                assignedUsersTab: 'task.edit_panel.tabs.assigned_users',
                managersTab: 'task.edit_panel.tabs.managers',
                budgetsTab: 'task.edit_panel.tabs.budgets'
            };
        }
    }, {
        key: "templateModel",
        value: function templateModel() {
            return { separatorArrow: (0, _atBrowserUtils.atImgPath)('taskManagement/arrow.png') };
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            var _this2 = this;

            this.$projectName = this.find('.projectName');
            this.$customerName = this.find('.customerName');
            this.$tabs = [];
            this.$tabs[_constants.TasksTabs.DETAILS_TAB] = this.find('.details');
            this.$tabs[_constants.TasksTabs.REPORTED_TAB] = this.find('.reportedTime');
            this.$tabs[_constants.TasksTabs.ASSIGNED_USERS_TAB] = this.find('.assignedUsers');
            this.$tabs[_constants.TasksTabs.MANAGERS_TAB] = this.find('.managers');
            this.$tabs[_constants.TasksTabs.BUDGETS] = this.find('.budgets');
            this.$assignedUsersTabTitle = this.find(".assignedUsers .tabText");
            this.$managersTabTitle = this.find(".managers .tabText");
            this.taskNameInput = new _NameInput2.default({
                editable: this.params.editable,
                placeholder: _messageResource2.default.getMessage('task.edit_popup.name_placeholder'),
                maxLength: _constants2.EntityTextLimits.MAX_CPT_NAME,
                showEmptyInput: this.params.showEmptyNameInput,
                onChangeCb: this.callbacks.onChangeNameCb
            }).init(this.$containerEl.find('.taskNamePlaceholder'));

            this.actions = new _EditActionButton2.default({
                panelEl: this.$panel,
                headerEl: this.$containerEl,
                needMove: true,
                needCopy: true,
                needDelete: true,
                onDeleteCb: function onDeleteCb() {
                    return _this2.callbacks.onTabSwitchedCb(_constants.TaskDialogs.DELETE_DIALOG);
                },
                onMoveCb: function onMoveCb() {
                    return _this2.callbacks.onTabSwitchedCb(_constants.TaskDialogs.MOVE_DIALOG);
                },
                onCopyCb: function onCopyCb() {
                    return _this2.callbacks.onTabSwitchedCb(_constants.TaskDialogs.COPY_DIALOG);
                }
            }).init(this.$containerEl.find('.actions'));

            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                var _loop = function _loop() {
                    var tabKey = _step.value;

                    _this2.$tabs[tabKey].click(function () {
                        return _this2.callbacks.onTabSwitchedCb(tabKey);
                    });
                };

                for (var _iterator = Object.values(_constants.TasksTabs)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    _loop();
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            this.$tabs[_constants.TasksTabs.REPORTED_TAB].toggle(this.params.showReportTab);

            this.renderInitialState();
        }
    }, {
        key: "updateActions",
        value: function updateActions(config) {
            this.actions.disableDeleteButton(this.disableDeleteButtonText(config));
        }
    }, {
        key: "disableDeleteButtonText",
        value: function disableDeleteButtonText(config) {
            var disableText = null;
            if (config.blockedDueToLockedTime) {
                disableText = _messageResource2.default.getMessage('task.edit_popup.cannot_delete_due_to_lock_time');
            } else if (config.blockedDueToUnavailableToModifyTimeTrack) {
                var text = _messageResource2.default.getMessage('common.task');
                disableText = _messageResource2.default.getMessage(config.canManageAllUsersWithoutAutoApproved ? 'hierarchy_entity.edit_popup.cannot_delete_due_to_unavailable_modify_time_of_autoapproved_users' : 'hierarchy_entity.edit_popup.cannot_delete_due_to_unavailable_modify_time', [text]);
            }
            return disableText;
        }
    }]);

    return Header;
}(_TemplateView3.default);

exports.default = Header;

/***/ }),
/* 1361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _DropdownTemplateView = __webpack_require__(42);

var _DropdownTemplateView2 = _interopRequireDefault(_DropdownTemplateView);

var _SimpleTooltip = __webpack_require__(36);

var _SimpleTooltip2 = _interopRequireDefault(_SimpleTooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function EditActionMenu(_ref) {
    var buttonEl = _ref.buttonEl,
        _ref$onDeleteCb = _ref.onDeleteCb,
        onDeleteCb = _ref$onDeleteCb === undefined ? function () {} : _ref$onDeleteCb,
        _ref$onMoveCb = _ref.onMoveCb,
        onMoveCb = _ref$onMoveCb === undefined ? function () {} : _ref$onMoveCb,
        _ref$onCopyCb = _ref.onCopyCb,
        onCopyCb = _ref$onCopyCb === undefined ? function () {} : _ref$onCopyCb,
        copyButtonMessageKey = _ref.copyButtonMessageKey;

    _DropdownTemplateView2.default.call(this);
    this.needCopy = false;
    this.needMove = false;
    this.needDelete = false;
    this.deleteDisable = false;
    this.$button = buttonEl;

    this.copyButtonMessageKey = copyButtonMessageKey;

    this.callbacks = {
        onDeleteCb: onDeleteCb,
        onMoveCb: onMoveCb,
        onCopyCb: onCopyCb
    };
}

EditActionMenu.prototype = _underscore2.default.create(_DropdownTemplateView2.default.prototype, {
    html: "<div class='dropdownContainer actionsMenu'>" + "  <div class='buttonsWrapper'>" + "    <div class='copyButton'>" + "      <div class='title'><%=copyTitle%></div>" + "    </div>" + "    <div class='moveButton'>" + "      <div class='title'><%=moveTitle%></div>" + "    </div>" + "    <div class='deleteButton'>" + "      <div class='title'><%=deleteTitle%></div>" + "    </div>" + "  </div>" + "</div>",

    afterRender: function afterRender() {
        var self = this;
        this.$wrapper = this.find(".buttonsWrapper");
        this.$copy = this.find(".copyButton");
        this.$move = this.find(".moveButton");
        this.$delete = this.find(".deleteButton");
        this.$copy.hide();
        this.$move.hide();
        this.$delete.hide();

        this.findAndBindClick(".moveButton", function () {
            if (!self.moveDisable) {
                self.triggerAction("move");
                self.callbacks.onMoveCb();
            }
        });
        this.findAndBindClick(".copyButton", function () {
            self.triggerAction("copy");
            self.callbacks.onCopyCb();
        });
        this.findAndBindClick(".deleteButton", function () {
            if (!self.deleteDisable) {
                self.triggerAction("delete");
                self.callbacks.onDeleteCb();
            }
        });

        this.disableDeleteTooltip().subscribeToMouseEvents(this.$delete);
        this.disableDeleteTooltip().disable();

        this.disableMoveTooltip().subscribeToMouseEvents(this.$move);
        this.disableMoveTooltip().disable();
    },

    update: function update() {
        var widthWrapper = 0;
        if (this.needCopy) {
            widthWrapper += 113;
            this.$copy.show();
        }
        if (this.needMove) {
            widthWrapper += 112;
            this.$move.show();
        }
        if (this.needDelete) {
            widthWrapper += 112;
            this.$delete.show();
        }
        this.$wrapper.width(widthWrapper);
    },

    triggerAction: function triggerAction(eventName) {
        (0, _jquery2.default)(this).trigger(eventName);
        this.hide();
    },

    selectMove: function selectMove(isSelected) {
        this.$copy.toggleClass("selected", false);
        this.$delete.toggleClass("selected", false);

        this.$move.toggleClass("selected", isSelected);
    },

    selectDelete: function selectDelete(isSelected) {

        this.$move.toggleClass("selected", false);
        this.$copy.toggleClass("selected", false);

        this.$delete.toggleClass("selected", isSelected);
    },

    selectCopy: function selectCopy(isSelected) {
        this.$move.toggleClass("selected", false);
        this.$delete.toggleClass("selected", false);

        this.$copy.toggleClass("selected", isSelected);
    },

    showAt: function showAt($button, $header, positionParams, callback) {
        _DropdownTemplateView2.default.prototype.showAt.call(this, $button, positionParams, $header);
        this.update();
        this.callback = callback;
    },

    messageKeys: function messageKeys() {
        return {
            moveTitle: "edit_panel.actions.move",
            copyTitle: this.copyButtonMessageKey,
            deleteTitle: "edit_panel.actions.delete"
        };
    },

    setMove: function setMove(needMove) {
        this.needMove = needMove;
    },

    setCopy: function setCopy(needCopy) {
        this.needCopy = needCopy;
    },

    setDelete: function setDelete(needDelete) {
        this.needDelete = needDelete;
    },

    onHide: function onHide() {
        _DropdownTemplateView2.default.prototype.onHide.call(this);
        this.callback(this.active);
    },

    setDisableDeleteButton: function setDisableDeleteButton(text) {
        this.deleteDisable = true;

        this.disableDeleteTooltip().$el.text(text);
        this.disableDeleteTooltip().enable();

        this.$delete.addClass("disable");
    },

    setEnableDeleteButton: function setEnableDeleteButton() {
        this.deleteDisable = false;

        this.disableDeleteTooltip().disable();

        this.$delete.removeClass("disable");
    },

    setDisableMoveButton: function setDisableMoveButton(text) {
        this.moveDisable = true;

        this.disableMoveTooltip().$el.text(text);
        this.disableMoveTooltip().enable();

        this.$move.addClass("disable");
    },

    setEnableMoveButton: function setEnableMoveButton() {
        this.moveDisable = false;

        this.disableMoveTooltip().disable();

        this.$move.removeClass("disable");
    },

    disableDeleteTooltip: function disableDeleteTooltip() {
        if (!EditActionMenu.deleteTooltip) {
            EditActionMenu.deleteTooltip = new _SimpleTooltip2.default({
                extraClass: 'disableDeleteTooltip'
            }).init((0, _jquery2.default)('body'));
        }
        return EditActionMenu.deleteTooltip;
    },
    disableMoveTooltip: function disableMoveTooltip() {
        if (!EditActionMenu.moveTooltip) {
            EditActionMenu.moveTooltip = new _SimpleTooltip2.default({
                extraClass: 'disableMoveTooltip'
            }).init((0, _jquery2.default)('body'));
        }
        return EditActionMenu.moveTooltip;
    }
});

exports.default = EditActionMenu;

/***/ }),
/* 1362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _SortableTableHeader = __webpack_require__(495);

var _SortableTableHeader2 = _interopRequireDefault(_SortableTableHeader);

var _LoadingMoire = __webpack_require__(92);

var _LoadingMoire2 = _interopRequireDefault(_LoadingMoire);

var _ReportedTimeRow = __webpack_require__(1363);

var _ReportedTimeRow2 = _interopRequireDefault(_ReportedTimeRow);

var _Totals = __webpack_require__(1365);

var _Totals2 = _interopRequireDefault(_Totals);

var _constants = __webpack_require__(157);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ReportedTime = function (_TemplateView) {
    _inherits(ReportedTime, _TemplateView);

    function ReportedTime($containerEl) {
        _classCallCheck(this, ReportedTime);

        return _possibleConstructorReturn(this, (ReportedTime.__proto__ || Object.getPrototypeOf(ReportedTime)).call(this, $containerEl));
    }

    _createClass(ReportedTime, [{
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='reportedTimeTab panelTab'>" + " <div class='summarySection section'/>" + " <div class='reportedTimeSection section'>" + "     <div class='reportedTimeHeader sectionHeader'><%=reportedTimeComments%>:</div>" + "     <table class='reportedTimeTable' cellpadding='0' cellspacing='0'><thead>" + "         <tr><th class='dateColumn'><span class='dateCell dateHeader'/></th>" + "         <th class='userColumn'><span class='shortSeparator'>&nbsp;</span><span class='userCell userHeader'/></th>" + "         <th class='timeColumn'><span class='shortSeparator'>&nbsp;</span><span class='timeCell timeHeader'><%=time%></span></th>" + "         <th class='commentColumn'><span class='shortSeparator'>&nbsp;</span><span class='commentCell commentHeader'><%=comment%></span></th></th>" + "     </thead><tbody class='timeRows'/></table>" + "     <div class='tasksNotFoundMessage'><%-noTimeComments%></div>" + "     <div class='loadingIndicatorContainer'></div>" + " </div>" + "</div>";
        }
    }, {
        key: "shouldUpdateOnInit",
        value: function shouldUpdateOnInit() {
            return false;
        }
    }, {
        key: "messageKeys",
        value: function messageKeys() {
            return {
                time: 'common.time',
                comment: 'common.comment',
                of: 'common.of',
                reportedTimeComments: 'task.edit_panel.reported_time',
                noTimeComments: 'task.edit_popup.no_time_reported_by_you_for_task'
            };
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            this.timeRows = {};
            this.timeRowsCount = 0;
            this.$timeRows = this.find('.timeRows');

            this.totals = new _Totals2.default(this.find(".summarySection"), { chartContainerId: "reportedTimeChart" }).init();
            this.dateHeader = new _SortableTableHeader2.default(this.find('.dateHeader'), this.sortBy === _constants.ReportedTimeSortConstants.BY_DATE, this.sortOrder === _constants.ReportedTimeSortConstants.ASC, 'common.date').init();
            this.dateHeader.sortBy = _constants.ReportedTimeSortConstants.BY_DATE;
            this.userHeader = new _SortableTableHeader2.default(this.find('.userHeader'), this.sortBy === _constants.ReportedTimeSortConstants.BY_USER, this.sortOrder === _constants.ReportedTimeSortConstants.ASC, 'common.User').init();
            this.userHeader.sortBy = _constants.ReportedTimeSortConstants.BY_USER;
            this.$loadingIndicatorContainer = this.find(".loadingIndicatorContainer");

            this.appendLoadingMoire = new _LoadingMoire2.default({
                additionalSpinnerSettings: {},
                showAnimated: false,
                hideAnimated: false
            }).init(this.find(this.$loadingIndicatorContainer));
        }
    }, {
        key: "setTableSettings",
        value: function setTableSettings(settings) {
            this.sortBy = settings['sortBy'];
            this.sortOrder = settings['sortOrder'];
            this.dateHeader.setActive(this.sortBy === _constants.ReportedTimeSortConstants.BY_DATE);
            this.userHeader.setActive(this.sortBy === _constants.ReportedTimeSortConstants.BY_USER);
            if (this.dateHeader.isActive()) this.dateHeader.setAsc(this.sortOrder === _constants.ReportedTimeSortConstants.ASC);
            if (this.userHeader.isActive()) this.userHeader.setAsc(this.sortOrder === _constants.ReportedTimeSortConstants.ASC);
        }
    }, {
        key: "updateTimeRows",
        value: function updateTimeRows(timeRows) {
            if (timeRows.length === 0) {
                this.find('.tasksNotFoundMessage').show();
            }
            this.addTimeRows(timeRows);
        }
    }, {
        key: "updateEstimated",
        value: function updateEstimated(estimatedTime) {
            this.totals.header.setState({ estimatedTime: estimatedTime });
        }
    }, {
        key: "updateSummaryRecords",
        value: function updateSummaryRecords() {
            var executorsSummary = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            this.totals.setState({
                sorted: false,
                totalTime: executorsSummary.total,
                myRecord: executorsSummary.myRecord,
                myTeamRecords: executorsSummary.myTeamRecords,
                othersRecords: executorsSummary.othersRecords,
                myTeamTotal: executorsSummary.myTeamTotal,
                othersTotal: executorsSummary.othersTotal
            });
        }
    }, {
        key: "addTimeRows",
        value: function addTimeRows(timeRows) {
            var self = this;
            _underscore2.default.forEach(timeRows, function (rowData) {
                var newRow = new _ReportedTimeRow2.default(self.$timeRows).init();
                newRow.setRowData(rowData.eventDate.parseJSONDate(), rowData.formattedName, rowData.actuals, rowData.commentsPresent ? rowData.comments : null);
                self.timeRows[self.timeRowsCount++] = newRow;
            });
        }
    }, {
        key: "clearTimeRows",
        value: function clearTimeRows() {
            this.$timeRows.empty();
            this.find('.tasksNotFoundMessage').hide();
            this.timeRowsCount = 0;
            this.timeRows = {};
        }
    }, {
        key: "setTimeAndCommentsLoading",
        value: function setTimeAndCommentsLoading(isLoading) {
            this.$loadingIndicatorContainer.toggle(isLoading);
            this.appendLoadingMoire.toggle(isLoading);
        }
    }]);

    return ReportedTime;
}(_TemplateView3.default);

exports.default = ReportedTime;

/***/ }),
/* 1363 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _SimpleTooltip = __webpack_require__(36);

var _SimpleTooltip2 = _interopRequireDefault(_SimpleTooltip);

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _user_time = __webpack_require__(30);

var _user_time2 = _interopRequireDefault(_user_time);

var _TruncatedTextView = __webpack_require__(496);

var _TruncatedTextView2 = _interopRequireDefault(_TruncatedTextView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ReportedTimeRow = function (_TemplateView) {
    _inherits(ReportedTimeRow, _TemplateView);

    function ReportedTimeRow($containerEl) {
        _classCallCheck(this, ReportedTimeRow);

        return _possibleConstructorReturn(this, (ReportedTimeRow.__proto__ || Object.getPrototypeOf(ReportedTimeRow)).call(this, $containerEl));
    }

    _createClass(ReportedTimeRow, [{
        key: "templateHtml",
        value: function templateHtml() {
            return "<tr class='timeRow'>" + " <td class='dateColumn'><span class='dateCell'/></td>" + " <td class='userColumn'><div class='userCell'/></td>" + " <td class='timeColumn'><span class='timeCell'/></td>" + " <td class='commentColumn'><div class='commentCell'/></td>" + "</tr>";
        }
    }, {
        key: "shouldUpdateOnInit",
        value: function shouldUpdateOnInit() {
            return false;
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            this.date = null;
            this.user = null;
            this.time = null;
            this.comment = null;
            this.dateFormat = ReportedTimeRow.dateFormat;

            this.$dateCell = this.find('.dateCell');
            this.$userCell = this.find('.userCell');
            this.$timeCell = this.find('.timeCell');
            this.commentCell = new _TruncatedTextView2.default({ lineCount: 3 }).init(this.find('.commentCell'));
        }
    }, {
        key: "setRowData",
        value: function setRowData(date, user, time, comment) {
            this.date = date;
            this.user = user;
            this.time = time;
            this.comment = comment;
            this.update();
        }
    }, {
        key: "update",
        value: function update() {
            this.$dateCell.text(this.date.format(this.dateFormat));
            this.$userCell.text(this.user);
            this.$timeCell.text(_user_time2.default.formatTimeWithDigitSeparator(this.time));
            this.commentCell.setText(this.comment);
        }
    }, {
        key: "setDateFormat",
        value: function setDateFormat(dateFormat) {
            this.dateFormat = dateFormat;
        }
    }]);

    return ReportedTimeRow;
}(_TemplateView3.default);

exports.default = ReportedTimeRow;


ReportedTimeRow.dateFormat = Date.convertSmartToExtDateFormat(window.SystemSettings.dateFormat).replace(/F/, "M");

/***/ }),
/* 1364 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.clamp = clamp;
var ELLIPSIS = '\u2026';
var WHITESPACE_REGEX = /(?=\s)/;
var TRAILING_WHITESPACE_REGEX = /\s+$/;

function clamp(element) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        lineCount = _ref.lineCount,
        _ref$ellipsis = _ref.ellipsis,
        ellipsis = _ref$ellipsis === undefined ? ELLIPSIS : _ref$ellipsis;

    // Read the `line-height` of `element`, and use it to compute the height of
    // `element` required to fit the given `lineCount`.
    var lineHeight = parseInt(window.getComputedStyle(element).lineHeight, 10);
    var maximumHeight = lineCount * lineHeight;

    // Exit if text does not overflow the `element`.
    if (element.scrollHeight <= maximumHeight) {
        return false;
    }

    var innerHTML = element.innerHTML;

    // Split the text of `element` by whitespace.
    var chunks = innerHTML.split(WHITESPACE_REGEX);

    // The text does not contain whitespace; we need to attempt to truncate
    // by character.
    if (chunks.length > 1) truncateByWord(element, chunks, maximumHeight);

    return truncateByCharacter(element, maximumHeight, ellipsis);
}

// Truncate the text of `element` such that it does not exceed the
// `maximumHeight`. Return `true` if we need to truncate by character, else
// return `false`.
function truncateByWord(element, chunks, maximumHeight) {

    // Loop over the chunks, and try to fit more chunks into the `element`.
    var length = chunks.length;
    var i = -1;
    var newInnerHTML = '';

    while (++i < length) {
        newInnerHTML += chunks[i];
        element.innerHTML = newInnerHTML;

        // If the new height now exceeds the `maximumHeight` (where it did not
        // in the previous iteration), we know that we are at most one line
        // over the optimal text length.
        if (element.offsetHeight > maximumHeight) {
            return;
        }
    }
}

// Append `ellipsisCharacter` to `element`, trimming off trailing characters
// in `element` such that `element` will not exceed the `maximumHeight`.
function truncateByCharacter(element, maximumHeight, ellipsisCharacter) {
    var innerHTML = element.innerHTML;
    var length = innerHTML.length;

    // In each iteration, we trim off one trailing character . Also trim
    // off any trailing punctuation before appending the `ellipsisCharacter`.
    while (length > 0) {
        element.innerHTML = innerHTML.substring(0, length).replace(TRAILING_WHITESPACE_REGEX, '') + ellipsisCharacter;
        if (element.offsetHeight <= maximumHeight) {
            return true;
        }
        length--;
    }
    return false;
}

/***/ }),
/* 1365 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _ChartSection2 = __webpack_require__(1366);

var _ChartSection3 = _interopRequireDefault(_ChartSection2);

var _Header = __webpack_require__(1367);

var _Header2 = _interopRequireDefault(_Header);

var _Chart = __webpack_require__(1368);

var _Chart2 = _interopRequireDefault(_Chart);

var _atUtils = __webpack_require__(5);

var _SortButton = __webpack_require__(1370);

var _SortButton2 = _interopRequireDefault(_SortButton);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _SortButtons = __webpack_require__(1371);

var _SortButtons2 = _interopRequireDefault(_SortButtons);

var _TableChartButtons = __webpack_require__(1373);

var _TableChartButtons2 = _interopRequireDefault(_TableChartButtons);

var _ReportedTimeSummaryRecords = __webpack_require__(1374);

var _ReportedTimeSummaryRecords2 = _interopRequireDefault(_ReportedTimeSummaryRecords);

var _constants = __webpack_require__(4);

var _LocalStorage = __webpack_require__(72);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TASK_PANEL_REPORTED_TIME_LOCAL_STORAGE_KEY = 'taskPanelReportedTimeSettings';

var Totals = function (_ChartSection) {
    _inherits(Totals, _ChartSection);

    function Totals($containerEl, _ref) {
        var chartContainerId = _ref.chartContainerId,
            _ref$triggerScrollUpd = _ref.triggerScrollUpdate,
            triggerScrollUpdate = _ref$triggerScrollUpd === undefined ? function () {} : _ref$triggerScrollUpd;

        _classCallCheck(this, Totals);

        var _this = _possibleConstructorReturn(this, (Totals.__proto__ || Object.getPrototypeOf(Totals)).call(this, $containerEl, { chartContainerId: chartContainerId, needPdf: false }));

        _this.params = _extends({}, _this.params, {
            triggerScrollUpdate: triggerScrollUpdate
        });

        _this.state = _extends({}, _this.state, {
            totalTime: null,
            myRecord: null,
            myTeamRecords: [],
            othersRecords: [],
            myTeamTotal: 0,
            othersTotal: 0,
            sorted: false,
            sorting: {
                by: null,
                order: null
            },
            showIn: _TableChartButtons.SHOW_IN.TABLE
        });

        _this.onStatePropertyChanged("totalTime", function (totalTime) {
            _this.$el.toggle(totalTime !== null);
            _this.header.setState({ totalTime: totalTime });
            _this.$el.toggleClass("emptySummary", _this.state.totalTime === 0);
        });

        _this.onAnyStatePropertyChanged(['myTeamRecords', 'othersRecords'], function () {
            if (!_this.state.sorted) {
                _this.sortSummaryRecords();
            }
        });

        _this.onStatePropertyChanged("sorting", function (sorting) {
            _this.alphabetB.setState({
                active: sorting.by === _SortButtons.SORT_BY.USER,
                order: sorting.order
            });
            _this.valueB.setState({
                active: sorting.by === _SortButtons.SORT_BY.TIME,
                order: sorting.order
            });
            _this.saveSettingsInLocalStorage();
        });

        _this.onStatePropertyChanged("sorted", function (sorted) {
            if (sorted) {
                _this.setState({ rendering: true });
                _this.table.setState({
                    myRecord: _this.state.myRecord,
                    myTeamRecords: _this.state.myTeamRecords,
                    othersRecords: _this.state.othersRecords,
                    myTeamTotal: _this.state.myTeamTotal,
                    othersTotal: _this.state.othersTotal
                });
                _this.chart.setState({ summaryRecords: _this._getRecordsForChart() });
            }
        });

        _this.onStatePropertyChanged("showIn", function () {
            _this._updateTotalsShowIn();
        });
        return _this;
    }

    _createClass(Totals, [{
        key: "_updateTotalsShowIn",
        value: function _updateTotalsShowIn() {
            this.tableChartControl.setState({
                showIn: this.state.showIn
            });
            this._toggleChartHandlingChanges();
            this.$el.toggleClass("showChart", this.state.showIn === _TableChartButtons.SHOW_IN.CHART);
            this.$el.toggleClass("showTable", this.state.showIn === _TableChartButtons.SHOW_IN.TABLE);
            this.params.triggerScrollUpdate();
            this.saveSettingsInLocalStorage();
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            var _this2 = this;

            _get(Totals.prototype.__proto__ || Object.getPrototypeOf(Totals.prototype), "afterRender", this).call(this);
            this.header = new _Header2.default(this.$header).init();

            this.chart = new _Chart2.default(this.$chartContainer, {
                onRendered: function onRendered() {
                    _this2.setState({ rendering: false });
                    _this2.params.triggerScrollUpdate();
                }
            }).init();
            this.table = new _ReportedTimeSummaryRecords2.default().init(this.$el);

            this.alphabetB = new _SortButton2.default(null, {
                titleLabel: _messageResource2.default.getMessage("report.create_chart.sort.alphabetically"),
                onClick: function onClick(order) {
                    _this2.setState({
                        sorting: {
                            by: _SortButtons.SORT_BY.USER,
                            order: order
                        },
                        sorted: false
                    });
                    _this2.sortSummaryRecords();
                }
            });

            this.valueB = new _SortButton2.default(null, {
                titleLabel: _messageResource2.default.getMessage("report.create_chart.sort.value"),
                onClick: function onClick(order) {
                    _this2.setState({
                        sorting: {
                            by: _SortButtons.SORT_BY.TIME,
                            order: order
                        },
                        sorted: false
                    });
                    _this2.sortSummaryRecords();
                }
            });
            this.sortButtons = new _SortButtons2.default(this.$header, [this.alphabetB, this.valueB]).init();

            this.tableChartControl = new _TableChartButtons2.default(this.$header, {
                onClick: function onClick(showIn) {
                    _this2.setState({ showIn: showIn });
                }
            }).init();

            this.rendered = true; // ugly hack for ugly code
            if (!(0, _LocalStorage.getLocalStorage)().getItem(TASK_PANEL_REPORTED_TIME_LOCAL_STORAGE_KEY)) {
                this.setState({
                    sorting: { by: _SortButtons.SORT_BY.USER, order: _atUtils.SORT_ORDER.DESC },
                    showIn: _TableChartButtons.SHOW_IN.TABLE,
                    collapsed: false
                });
                this.saveSettingsInLocalStorage();
            } else {
                this.setState((0, _LocalStorage.getLocalStorage)().getItem(TASK_PANEL_REPORTED_TIME_LOCAL_STORAGE_KEY));
            }
            this._updateTotalsShowIn();
        }
    }, {
        key: "sortSummaryRecords",
        value: function sortSummaryRecords() {
            var myTeamRecordsSorted = this.state.myTeamRecords ? this.state.myTeamRecords.slice().sort((0, _atUtils.comparator)(this.state.sorting.by, this.state.sorting.order)) : this.state.myTeamRecords;
            var othersRecordsCopy = this.state.othersRecords.slice();
            othersRecordsCopy.sort((0, _atUtils.comparator)(this.state.sorting.by, this.state.sorting.order));
            this.setState({
                sorted: true,
                myTeamRecords: myTeamRecordsSorted,
                othersRecords: othersRecordsCopy
            });
        }
    }, {
        key: "setScrollUpdateCallback",
        value: function setScrollUpdateCallback() {
            var updateScroll = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};

            this.params.triggerScrollUpdate = updateScroll;
        }
    }, {
        key: "onCollapsed",
        value: function onCollapsed(collapsed) {
            _get(Totals.prototype.__proto__ || Object.getPrototypeOf(Totals.prototype), "onCollapsed", this).call(this, collapsed);
            this._toggleChartHandlingChanges();
            this.saveSettingsInLocalStorage();
        }
    }, {
        key: "saveSettingsInLocalStorage",
        value: function saveSettingsInLocalStorage() {
            (0, _LocalStorage.getLocalStorage)().setItem(TASK_PANEL_REPORTED_TIME_LOCAL_STORAGE_KEY, {
                sorting: this.state.sorting,
                showIn: this.state.showIn,
                collapsed: this.state.collapsed
            });
        }
    }, {
        key: "_toggleChartHandlingChanges",
        value: function _toggleChartHandlingChanges() {
            this.chart.toggleHandlingChanges(!this.state.collapsed && this.state.showIn === _TableChartButtons.SHOW_IN.CHART);
        }
    }, {
        key: "_getRecordsForChart",
        value: function _getRecordsForChart() {
            var summaryRecords = [];
            summaryRecords = summaryRecords.concat(this.state.myTeamRecords || []);
            summaryRecords = summaryRecords.concat(this.state.myRecord || []);
            summaryRecords = summaryRecords.concat(this.state.othersRecords.length !== 0 ? this.state.othersRecords : {
                "spentTime": this.state.othersTotal,
                "userId": _constants.OTHER_USERS_ENTITY_ID,
                "commentsAvailable": false,
                "firstName": "",
                "lastName": "",
                "formattedName": "",
                "middleName": "",
                "username": ""
            });
            return summaryRecords;
        }
    }]);

    return Totals;
}(_ChartSection3.default);

exports.default = Totals;

/***/ }),
/* 1366 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _LoadingMoire = __webpack_require__(92);

var _LoadingMoire2 = _interopRequireDefault(_LoadingMoire);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ChartSection = function (_TemplateView) {
    _inherits(ChartSection, _TemplateView);

    function ChartSection($containerEl, _ref) {
        var chartContainerId = _ref.chartContainerId,
            _ref$needHiddenContai = _ref.needHiddenContainer,
            needHiddenContainer = _ref$needHiddenContai === undefined ? false : _ref$needHiddenContai;

        _classCallCheck(this, ChartSection);

        var _this = _possibleConstructorReturn(this, (ChartSection.__proto__ || Object.getPrototypeOf(ChartSection)).call(this, $containerEl));

        _this.params = {
            chartContainerId: chartContainerId,
            needHiddenContainer: needHiddenContainer
        };

        _this.state = {
            collapsed: null,
            containerSize: {
                height: 0,
                width: 0
            },
            rendering: false
        };

        _this.onStatePropertyChanged("collapsed", function (collapsed) {
            return _this.onCollapsed(collapsed);
        });

        _this.onStatePropertyChanged("containerSize", function (size) {
            _this.$chartContainer.css("width", size.width);
            _this.$chartContainer.css("height", size.height);
        });

        _this.onStatePropertyChanged("rendering", function (rendering) {
            return _this._renderChartMoire.toggle(rendering);
        });
        return _this;
    }

    _createClass(ChartSection, [{
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='chartSection'>" + "    <div class='containerHeader'>" + "        <div class='header'/>" + "        <div class='collapseButton noprint'/>" + "    </div>" + "    <div class='chartContainerWrapper'>" + "        <div id='<%=params.chartContainerId%>' class='chartContainer'></div>" + "        <% if (params.needHiddenContainer) { %>" + "        <div id='<%=chartContainerId%>Hidden' class='hiddenChartContainer'></div>" + "        <% } %>" + "    </div>" + "</div>";
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            var _this2 = this;

            this.$header = this.find(".header");
            this.$collapseBtn = this.find(".collapseButton");
            this.$chartContainer = this.find(".chartContainer");
            this.$hiddenChartContainer = this.find(".hiddenChartContainer");
            this.$chartContainerWrapper = this.find(".chartContainerWrapper");

            this.$collapseBtn.click(function () {
                return _this2.setState({ collapsed: !_this2.state.collapsed });
            });
            this._renderChartMoire = new _LoadingMoire2.default().init(this.$chartContainerWrapper);
        }
    }, {
        key: "onCollapsed",
        value: function onCollapsed(collapsed) {
            this.$el.toggleClass("collapsed", collapsed);
        }
    }]);

    return ChartSection;
}(_TemplateView3.default);

exports.default = ChartSection;

/***/ }),
/* 1367 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _user_time = __webpack_require__(30);

var _user_time2 = _interopRequireDefault(_user_time);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _index = __webpack_require__(22);

var _SummaryRecord = __webpack_require__(497);

var _SummaryRecord2 = _interopRequireDefault(_SummaryRecord);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Header = function (_TemplateView) {
    _inherits(Header, _TemplateView);

    function Header($containerEl) {
        _classCallCheck(this, Header);

        var _this = _possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).call(this, $containerEl));

        _this.state = {
            totalTime: null,
            estimatedTime: null
        };

        _this.onStatePropertyChanged("totalTime", function (totalTime) {
            _this.totalRecord.setValue(totalTime);
        });

        _this.onStatePropertyChanged("estimatedTime", function (estimatedTime) {
            var showEst = _underscore2.default.isNumber(estimatedTime) && (0, _index.isEnabled)(_index.Feature.EST);
            if (showEst) {
                _this.$estimatedValue.text(_user_time2.default.formatTimeWithDigitSeparator(estimatedTime));
            }
            _this.$ofEstimated.toggleClass('displayed', showEst);
        });
        return _this;
    }

    _createClass(Header, [{
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='totalSpentHeader sectionHeader'/>" + "<span class='ofEstimated'><%=of%>  <span class='estimatedValue'/></span>";
        }
    }, {
        key: "messageKeys",
        value: function messageKeys() {
            return {
                of: 'common.of'
            };
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            this.totalRecord = new _SummaryRecord2.default(this.$containerEl.find('.totalSpentHeader'), _messageResource2.default.getMessage('task.edit_panel.total_spent') + ':', false).init();
            this.$estimatedValue = this.find(".estimatedValue");
            this.$ofEstimated = this.$containerEl.find(".ofEstimated");
        }
    }]);

    return Header;
}(_TemplateView3.default);

exports.default = Header;

/***/ }),
/* 1368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _View2 = __webpack_require__(20);

var _View3 = _interopRequireDefault(_View2);

var _Generator = __webpack_require__(1369);

var _Generator2 = _interopRequireDefault(_Generator);

var _atUtils = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CHART_SIZE = {
    "height": 250,
    "width": 596
};

var Chart = function (_View) {
    _inherits(Chart, _View);

    function Chart($container, _ref) {
        var _ref$onRendered = _ref.onRendered,
            onRendered = _ref$onRendered === undefined ? function () {} : _ref$onRendered;

        _classCallCheck(this, Chart);

        var _this = _possibleConstructorReturn(this, (Chart.__proto__ || Object.getPrototypeOf(Chart)).call(this, $container));

        _this.params = {
            onRendered: onRendered
        };

        _this.state = {
            summaryRecords: []
        };

        _this.onStatePropertyChanged('summaryRecords', function (summaryRecords) {
            var $container = _this.$containerEl;
            if (summaryRecords.length === 0) {
                $container.empty();
            }
            (0, _atUtils.defer)(function () {
                _this.chartGenerator.renderChart($container[0].id, summaryRecords, {
                    "onRendered": function onRendered() {
                        return _this.params.onRendered();
                    }
                });
            });
        });
        return _this;
    }

    _createClass(Chart, [{
        key: "afterRender",
        value: function afterRender() {
            this.chartGenerator = new _Generator2.default().init(CHART_SIZE);
            this.$containerEl.css("height", CHART_SIZE.height);
            this.$containerEl.css("width", CHART_SIZE.width);
        }
    }]);

    return Chart;
}(_View3.default);

exports.default = Chart;

/***/ }),
/* 1369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _PieChartGenerator2 = __webpack_require__(771);

var _PieChartGenerator3 = _interopRequireDefault(_PieChartGenerator2);

var _constants = __webpack_require__(4);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Generator = function (_PieChartGenerator) {
    _inherits(Generator, _PieChartGenerator);

    function Generator() {
        _classCallCheck(this, Generator);

        return _possibleConstructorReturn(this, (Generator.__proto__ || Object.getPrototypeOf(Generator)).apply(this, arguments));
    }

    _createClass(Generator, [{
        key: "_prepareChartSettings",
        value: function _prepareChartSettings(chartData, config) {
            return _extends({}, _get(Generator.prototype.__proto__ || Object.getPrototypeOf(Generator.prototype), "_prepareChartSettings", this).call(this, chartData, config), {
                radius: 80,
                innerRadius: 30,
                mouseWheelScrollEnabled: true
            });
        }
    }, {
        key: "_getDataProvider",
        value: function _getDataProvider(chartData, config) {
            var dataProvider = [];

            var otherUsersItem = null;

            for (var i = 0; i < chartData.length; i++) {
                var currentItem = chartData[i];
                if (currentItem["userId"] === _constants.OTHER_USERS_ENTITY_ID) {
                    otherUsersItem = currentItem;
                    continue;
                }
                dataProvider.push({
                    "category": currentItem["formattedName"],
                    "value": currentItem["spentTime"]
                });
            }

            if (otherUsersItem) {
                dataProvider.push({
                    "category": _messageResource2.default.getMessage("report.other_users"),
                    "value": otherUsersItem["spentTime"],
                    "sectorColor": "#dbdbdb"
                });
            }
            return dataProvider;
        }
    }]);

    return Generator;
}(_PieChartGenerator3.default);

exports.default = Generator;

/***/ }),
/* 1370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _atUtils = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SortButton = function (_TemplateView) {
    _inherits(SortButton, _TemplateView);

    function SortButton($containerEl, _ref) {
        var titleLabel = _ref.titleLabel,
            _ref$printable = _ref.printable,
            printable = _ref$printable === undefined ? false : _ref$printable,
            _ref$onClick = _ref.onClick,
            onClick = _ref$onClick === undefined ? function (order) {} : _ref$onClick,
            _ref$throttleDelay = _ref.throttleDelay,
            throttleDelay = _ref$throttleDelay === undefined ? 300 : _ref$throttleDelay;

        _classCallCheck(this, SortButton);

        var _this = _possibleConstructorReturn(this, (SortButton.__proto__ || Object.getPrototypeOf(SortButton)).call(this, $containerEl));

        _this.params = {
            printable: printable,
            titleLabel: titleLabel,
            onClick: onClick,
            throttleDelay: throttleDelay
        };

        _this.state = {
            order: null,
            active: null
        };

        _this.onStatePropertyChanged('active', function (active) {
            _this.$el.toggleClass('active', active);
        });

        _this.onStatePropertyChanged('order', function (order) {
            _this.$el.toggleClass('asc', order === _atUtils.SORT_ORDER.ASC);
            _this.$el.toggleClass('desc', order === _atUtils.SORT_ORDER.DESC);
        });
        return _this;
    }

    _createClass(SortButton, [{
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='sortButton'>" + "    <div class='titleLabel'><%-params.titleLabel%></div>" + "    <div class='arrowContainer'><% if (params.printable) { %><div class='printArrows for-print-only'><span class='asc'>&darr;</span><span class='desc'>&uarr;</span></div><% } %></div>" + // without spaces
            "</div>";
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            var _this2 = this;

            this.$titleLabel = this.find(".titleLabel");
            this.$titleLabel.text(this.params.titleLabel);
            this.$el.click(function () {
                if (_this2.state.order === null) {
                    _this2.setState({
                        order: _atUtils.SORT_ORDER.DESC
                    });
                }

                if (_this2.state.active) {
                    _this2.setState({
                        order: _this2.state.order === _atUtils.SORT_ORDER.DESC ? _atUtils.SORT_ORDER.ASC : _atUtils.SORT_ORDER.DESC
                    });
                } else {
                    _this2.setState({
                        active: true
                    });
                }
                var throttledOnClick = (0, _atUtils.throttle)(_this2.params.onClick, _this2.params.throttleDelay);
                throttledOnClick(_this2.state.order);
            });
        }
    }]);

    return SortButton;
}(_TemplateView3.default);

exports.default = SortButton;

/***/ }),
/* 1371 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SORT_BY = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _ButtonSeparator = __webpack_require__(1372);

var _ButtonSeparator2 = _interopRequireDefault(_ButtonSeparator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SORT_BY = exports.SORT_BY = {
    TIME: "spentTime",
    USER: "formattedName"
};

var SortButtons = function (_TemplateView) {
    _inherits(SortButtons, _TemplateView);

    function SortButtons($containerEl, buttons) {
        _classCallCheck(this, SortButtons);

        var _this = _possibleConstructorReturn(this, (SortButtons.__proto__ || Object.getPrototypeOf(SortButtons)).call(this, $containerEl));

        _this.buttons = buttons;
        return _this;
    }

    _createClass(SortButtons, [{
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='chartSortContainer'>" + "    <div><%=sortLabel%></div>" + "</div>";
        }
    }, {
        key: "messageKeys",
        value: function messageKeys() {
            return {
                sortLabel: "report.create_chart.sort"
            };
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            var bLength = this.buttons.length;
            if (bLength === 0) return;
            for (var i = 0; i < bLength - 1; i++) {
                this.buttons[i].init(this.$el);
                new _ButtonSeparator2.default(this.$el).init();
            }
            this.buttons[bLength - 1].init(this.$el);
        }
    }]);

    return SortButtons;
}(_TemplateView3.default);

exports.default = SortButtons;

/***/ }),
/* 1372 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ButtonSeparator = function (_TemplateView) {
    _inherits(ButtonSeparator, _TemplateView);

    function ButtonSeparator() {
        _classCallCheck(this, ButtonSeparator);

        return _possibleConstructorReturn(this, (ButtonSeparator.__proto__ || Object.getPrototypeOf(ButtonSeparator)).apply(this, arguments));
    }

    _createClass(ButtonSeparator, [{
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='buttonSeparator'></div>";
        }
    }]);

    return ButtonSeparator;
}(_TemplateView3.default);

exports.default = ButtonSeparator;

/***/ }),
/* 1373 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SHOW_IN = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SHOW_IN = exports.SHOW_IN = {
    CHART: "chart",
    TABLE: "table"
};

var TableChartButtons = function (_TemplateView) {
    _inherits(TableChartButtons, _TemplateView);

    function TableChartButtons($containerEl, _ref) {
        var _ref$onClick = _ref.onClick,
            onClick = _ref$onClick === undefined ? function (showIn) {} : _ref$onClick;

        _classCallCheck(this, TableChartButtons);

        var _this = _possibleConstructorReturn(this, (TableChartButtons.__proto__ || Object.getPrototypeOf(TableChartButtons)).call(this, $containerEl));

        _this.params = { onClick: onClick };

        _this.state = {
            showIn: null
        };

        _this.onStatePropertyChanged('showIn', function (showIn) {
            _this.$chartButton.toggleClass("active", showIn === SHOW_IN.CHART);
            _this.$tableButton.toggleClass("active", showIn === SHOW_IN.TABLE);
        });
        return _this;
    }

    _createClass(TableChartButtons, [{
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='tableChartButtons'>" + "    <div class='tableButton typeButton left'/>" + "    <div class='chartButton typeButton right'/> " + "</div>";
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            var _this2 = this;

            this.$chartButton = this.find('.chartButton');
            this.$tableButton = this.find('.tableButton');
            var onBtnClick = function onBtnClick(showIn) {
                _this2.setState({ showIn: showIn });
                _this2.params.onClick(showIn);
            };
            this.$chartButton.click(function () {
                return onBtnClick(SHOW_IN.CHART);
            });
            this.$tableButton.click(function () {
                return onBtnClick(SHOW_IN.TABLE);
            });
        }
    }]);

    return TableChartButtons;
}(_TemplateView3.default);

exports.default = TableChartButtons;

/***/ }),
/* 1374 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _SummaryRecord = __webpack_require__(497);

var _SummaryRecord2 = _interopRequireDefault(_SummaryRecord);

var _SummaryRecords = __webpack_require__(1375);

var _SummaryRecords2 = _interopRequireDefault(_SummaryRecords);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ReportedTimeSummaryRecords = function (_TemplateView) {
    _inherits(ReportedTimeSummaryRecords, _TemplateView);

    function ReportedTimeSummaryRecords() {
        _classCallCheck(this, ReportedTimeSummaryRecords);

        var _this = _possibleConstructorReturn(this, (ReportedTimeSummaryRecords.__proto__ || Object.getPrototypeOf(ReportedTimeSummaryRecords)).call(this));

        _this.state = {
            myRecord: null,
            myTeamRecords: [],
            othersRecords: [],
            myTeamTotal: 0,
            othersTotal: 0,
            myTeamCollapsed: true,
            othersCollapsed: true
        };

        _this.onStatePropertyChanged('myRecord', function (myRecord) {
            _this.$mySection.empty();
            if (myRecord !== null) {
                new _SummaryRecord2.default(_this.$mySection, myRecord['formattedName'], false).init().setValue(myRecord['spentTime']);
                _this.$mySection.show();
            } else {
                _this.$mySection.hide();
            }
        });

        _this.onStatePropertyChanged('myTeamTotal', function (myTeamTotal) {
            _this.$myTeamTotalText.empty();
            new _SummaryRecord2.default(_this.$myTeamTotalText, _messageResource2.default.getMessage('task.edit_panel.my_team_spent'), false).init().setValue(myTeamTotal !== null ? myTeamTotal : 0);
            _this.find('.noAssignedUsersMsg').toggle(myTeamTotal === null);
        });

        _this.onStatePropertyChanged('myTeamRecords', function (myTeamRecords) {
            _this.$myTeamSection.toggle(myTeamRecords !== null);
            if (myTeamRecords !== null) {
                _this.myTeamSummaryRecords.setState({
                    summaryRecords: myTeamRecords
                });
                var hasRecords = myTeamRecords.length !== 0;
                _this.myTeamSummaryRecords.toggle(hasRecords);
                _this.$myTeamTotalIcon.toggle(hasRecords);
                _this.$myTeamTotal.toggleClass('hasIcon', hasRecords);
            }
        });

        _this.onStatePropertyChanged('othersTotal', function (othersTotal) {
            _this.$othersTotalText.empty();
            var hasOthersTotal = othersTotal !== null;
            if (hasOthersTotal) {
                new _SummaryRecord2.default(_this.$othersTotalText, _messageResource2.default.getMessage('task.edit_panel.others_spent'), false).init().setValue(othersTotal);
                _this.$othersTotalText.show();
            } else {
                _this.setState({
                    myTeamCollapsed: false
                });
                _this.$othersTotalText.hide();
            }
            _this.$myTeamTotal.toggleClass('showTotal', hasOthersTotal);
        });

        _this.onStatePropertyChanged('othersRecords', function (othersRecords) {
            _this.othersSummaryRecords.setState({
                summaryRecords: othersRecords
            });
            var hasRecords = othersRecords.length !== 0;
            _this.othersSummaryRecords.toggle(hasRecords);
            _this.$othersTotalIcon.toggle(hasRecords);
            _this.$othersTotal.toggleClass('hasIcon', hasRecords);
        });

        _this.onStatePropertyChanged('myTeamCollapsed', function (myTeamCollapsed) {
            _this.$myTeamRecords.toggle(!myTeamCollapsed);
            _this.$myTeamSection.toggleClass('collapsed', myTeamCollapsed);
        });

        _this.onStatePropertyChanged('othersCollapsed', function (othersCollapsed) {
            _this.$othersRecords.toggle(!othersCollapsed);
            _this.$othersSection.toggleClass('collapsed', othersCollapsed);
        });
        return _this;
    }

    _createClass(ReportedTimeSummaryRecords, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return "<div class='reportedTimeSummary'>" + "    <div class='mySection'/>" + "    <div class='myTeamSection'>" + "        <div class='myTeamTotal'>" + "            <div class='icon'/>" + "            <div class='text'></div>" + "        </div>" + "        <div class='myTeamRecords'></div>" + "        <div class='noAssignedUsersMsg'><%=noAssignedUsers%></div>" + "    </div>" + "    <div class='othersSection'>" + "        <div class='othersTotal'>" + "            <div class='icon'/>" + "            <div class='text'></div>" + "        </div>" + "        <div class='othersRecords'></div>" + "    </div>" + "</div>";
        }
    }, {
        key: 'messageKeys',
        value: function messageKeys() {
            return {
                noAssignedUsers: 'task.edit_panel.no_assigned_users'
            };
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            var _this2 = this;

            this.$mySection = this.find('.mySection');

            this.$myTeamSection = this.find('.myTeamSection');
            this.$myTeamTotalText = this.find('.myTeamTotal .text');
            this.$myTeamTotalIcon = this.find('.myTeamTotal .icon');
            this.$myTeamTotal = this.find('.myTeamTotal');
            this.$myTeamRecords = this.find('.myTeamRecords');
            this.myTeamSummaryRecords = new _SummaryRecords2.default(this.$myTeamRecords).init();

            this.$othersSection = this.find('.othersSection');
            this.$othersTotalText = this.find('.othersTotal .text');
            this.$othersTotalIcon = this.find('.othersTotal .icon');
            this.$othersTotal = this.find('.othersTotal');
            this.$othersRecords = this.find('.othersRecords');
            this.othersSummaryRecords = new _SummaryRecords2.default(this.$othersRecords).init();

            this.$myTeamTotal.on('click', function () {
                if (_this2.state.myTeamRecords.length !== 0) _this2.setState({
                    myTeamCollapsed: !_this2.state.myTeamCollapsed
                });
            });
            this.$othersTotal.on('click', function () {
                if (_this2.state.othersRecords.length !== 0) _this2.setState({
                    othersCollapsed: !_this2.state.othersCollapsed
                });
            });

            this.renderInitialState();
        }
    }]);

    return ReportedTimeSummaryRecords;
}(_TemplateView3.default);

exports.default = ReportedTimeSummaryRecords;

/***/ }),
/* 1375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _constants = __webpack_require__(4);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _SummaryRecord = __webpack_require__(497);

var _SummaryRecord2 = _interopRequireDefault(_SummaryRecord);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SummaryRecords = function (_TemplateView) {
    _inherits(SummaryRecords, _TemplateView);

    function SummaryRecords($containerEl) {
        _classCallCheck(this, SummaryRecords);

        var _this = _possibleConstructorReturn(this, (SummaryRecords.__proto__ || Object.getPrototypeOf(SummaryRecords)).call(this, $containerEl));

        _this.state = {
            summaryRecords: []
        };
        _this.onStatePropertyChanged("summaryRecords", function (summaryRecords) {
            _this.$el.empty();
            var self = _this;
            _underscore2.default.each(summaryRecords, function (record) {
                var isOtherUsersEntity = record["userId"] === _constants.OTHER_USERS_ENTITY_ID;
                var formattedName = isOtherUsersEntity ? _messageResource2.default.getMessage("report.other_users") : record['formattedName'];
                new _SummaryRecord2.default(self.$el, formattedName, isOtherUsersEntity).init().setValue(record['spentTime']);
            });
        });
        return _this;
    }

    _createClass(SummaryRecords, [{
        key: "useUnderscoreTemplate",
        value: function useUnderscoreTemplate() {
            return false;
        }
    }, {
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='summaryRecords'/>";
        }
    }]);

    return SummaryRecords;
}(_TemplateView3.default);

exports.default = SummaryRecords;

/***/ }),
/* 1376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _DropdownTemplateView2 = __webpack_require__(42);

var _DropdownTemplateView3 = _interopRequireDefault(_DropdownTemplateView2);

var _BlockedListItem = __webpack_require__(1377);

var _BlockedListItem2 = _interopRequireDefault(_BlockedListItem);

var _MoreElementsBlockedListItem = __webpack_require__(1378);

var _MoreElementsBlockedListItem2 = _interopRequireDefault(_MoreElementsBlockedListItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BlockedList = function (_DropdownTemplateView) {
    _inherits(BlockedList, _DropdownTemplateView);

    function BlockedList($containerEl, entities) {
        _classCallCheck(this, BlockedList);

        var _this = _possibleConstructorReturn(this, (BlockedList.__proto__ || Object.getPrototypeOf(BlockedList)).call(this, $containerEl));

        _this.entities = entities;
        return _this;
    }

    _createClass(BlockedList, [{
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='pointerWrapper'>" + "  <div class='deleteConfirmationDialogBlockedListScrollWrapper'>" + "    <div class='deleteConfirmationDialogBlockedList'></div>" + "  </div>" + "</div>";
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            this.$itemsContainer = this.find(".deleteConfirmationDialogBlockedList");
            _.each(this.entities, function (entity) {
                new _BlockedListItem2.default(this.$itemsContainer, this.getEntitySubtitle(entity), this.getEntityTitle(entity)).init();
            }, this);

            _.each(this.additionListItems(), function (entity) {
                new _MoreElementsBlockedListItem2.default(this.$itemsContainer, entity.title).init();
            }, this);

            this.verticalScroll = ScrollUtils.addVerticalScroll(this.find(".deleteConfirmationDialogBlockedListScrollWrapper"), { isFaded: false });
        }
    }, {
        key: "setDisabled",
        value: function setDisabled(disabled) {
            this.disabled = disabled;
        }
    }, {
        key: "isDisabled",
        value: function isDisabled() {
            return this.disabled;
        }
    }, {
        key: "onShow",
        value: function onShow() {
            _get(BlockedList.prototype.__proto__ || Object.getPrototypeOf(BlockedList.prototype), "onShow", this).call(this);
            ScrollUtils.refreshCustomScroll(this.verticalScroll);
        }
    }, {
        key: "additionListItems",
        value: function additionListItems() {
            return [];
        }
    }, {
        key: "getEntitySubtitle",
        value: function getEntitySubtitle(entity) {
            // Abstract
        }
    }, {
        key: "getEntityTitle",
        value: function getEntityTitle(entity) {
            // Abstract
        }
    }]);

    return BlockedList;
}(_DropdownTemplateView3.default);

exports.default = BlockedList;

/***/ }),
/* 1377 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BlockedListItem = function (_TemplateView) {
    _inherits(BlockedListItem, _TemplateView);

    function BlockedListItem($containerEl, subtitle, title) {
        _classCallCheck(this, BlockedListItem);

        var _this = _possibleConstructorReturn(this, (BlockedListItem.__proto__ || Object.getPrototypeOf(BlockedListItem)).call(this, $containerEl));

        _this.subtitle = subtitle;
        _this.title = title;
        return _this;
    }

    _createClass(BlockedListItem, [{
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='blockedListItem'>" + "  <div class='subtitle'><%-subtitle%></div>" + "  <div class='title'><%-title%></div>" + "</div>";
        }
    }]);

    return BlockedListItem;
}(_TemplateView3.default);

exports.default = BlockedListItem;

/***/ }),
/* 1378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MoreElementsBlockedListItem = function (_TemplateView) {
    _inherits(MoreElementsBlockedListItem, _TemplateView);

    function MoreElementsBlockedListItem($containerEl, title) {
        _classCallCheck(this, MoreElementsBlockedListItem);

        var _this = _possibleConstructorReturn(this, (MoreElementsBlockedListItem.__proto__ || Object.getPrototypeOf(MoreElementsBlockedListItem)).call(this, $containerEl));

        _this.title = title;
        return _this;
    }

    _createClass(MoreElementsBlockedListItem, [{
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='blockedListItem moreElements'>" + "  <div class='title'><i><%-title%></i></div>" + "</div>";
        }
    }]);

    return MoreElementsBlockedListItem;
}(_TemplateView3.default);

exports.default = MoreElementsBlockedListItem;

/***/ }),
/* 1379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _SearchWithDropdownButton = __webpack_require__(1380);

var _SearchWithDropdownButton2 = _interopRequireDefault(_SearchWithDropdownButton);

var _SearchItemList = __webpack_require__(774);

var _SearchItemList2 = _interopRequireDefault(_SearchItemList);

var _utils = __webpack_require__(242);

var _ScrollableDropdownView = __webpack_require__(1382);

var _ScrollableDropdownView2 = _interopRequireDefault(_ScrollableDropdownView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Combobox = function (_TemplateView) {
    _inherits(Combobox, _TemplateView);

    function Combobox(_ref) {
        var _ref$emptySelectionMe = _ref.emptySelectionMessageKey,
            emptySelectionMessageKey = _ref$emptySelectionMe === undefined ? '' : _ref$emptySelectionMe,
            _ref$notFoundMessageK = _ref.notFoundMessageKey,
            notFoundMessageKey = _ref$notFoundMessageK === undefined ? '' : _ref$notFoundMessageK,
            _ref$hiddenItemsColla = _ref.hiddenItemsCollapsedMessageKey,
            hiddenItemsCollapsedMessageKey = _ref$hiddenItemsColla === undefined ? '' : _ref$hiddenItemsColla,
            _ref$hiddenItemsExpan = _ref.hiddenItemsExpandedMessageKey,
            hiddenItemsExpandedMessageKey = _ref$hiddenItemsExpan === undefined ? '' : _ref$hiddenItemsExpan,
            _ref$emptyListMessage = _ref.emptyListMessageKey,
            emptyListMessageKey = _ref$emptyListMessage === undefined ? '' : _ref$emptyListMessage,
            _ref$emptySelectionId = _ref.emptySelectionId,
            emptySelectionId = _ref$emptySelectionId === undefined ? -1 : _ref$emptySelectionId,
            _ref$additionalClass = _ref.additionalClass,
            additionalClass = _ref$additionalClass === undefined ? '' : _ref$additionalClass,
            _ref$positionParams = _ref.positionParams,
            positionParams = _ref$positionParams === undefined ? null : _ref$positionParams,
            _ref$hideItemPredicat = _ref.hideItemPredicate,
            hideItemPredicate = _ref$hideItemPredicat === undefined ? function () {} : _ref$hideItemPredicat,
            _ref$onItemSelectedCb = _ref.onItemSelectedCb,
            onItemSelectedCb = _ref$onItemSelectedCb === undefined ? function (item) {} : _ref$onItemSelectedCb,
            _ref$onListShowCb = _ref.onListShowCb,
            onListShowCb = _ref$onListShowCb === undefined ? function () {} : _ref$onListShowCb,
            _ref$onListHideCb = _ref.onListHideCb,
            onListHideCb = _ref$onListHideCb === undefined ? function () {} : _ref$onListHideCb,
            inputMaxLength = _ref.inputMaxLength;

        _classCallCheck(this, Combobox);

        var _this = _possibleConstructorReturn(this, (Combobox.__proto__ || Object.getPrototypeOf(Combobox)).call(this));

        _this.state = {
            items: [],
            additionalItems: [],
            selectedItemId: emptySelectionId,
            searchText: '',
            emptyListMessageKey: emptyListMessageKey
        };

        _this.params = {
            emptySelectionMessageKey: emptySelectionMessageKey,
            notFoundMessageKey: notFoundMessageKey,
            hiddenItemsCollapsedMessageKey: hiddenItemsCollapsedMessageKey,
            hiddenItemsExpandedMessageKey: hiddenItemsExpandedMessageKey,
            additionalClass: additionalClass,
            emptySelectionId: emptySelectionId,
            positionParams: positionParams,
            hideItemPredicate: hideItemPredicate,
            onItemSelectedCb: onItemSelectedCb,
            onListShowCb: onListShowCb,
            onListHideCb: onListHideCb,
            inputMaxLength: inputMaxLength
        };

        _this.onAnyStatePropertyChanged(['selectedItemId', 'items', 'additionalItems', 'emptyListMessageKey', 'searchText'], function () {
            _this._updateSearchButton();
            _this._updateMenu();
        });
        return _this;
    }

    _createClass(Combobox, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class="components_combobox <%-additionalClass%>"></div>';
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            var _this2 = this;

            this.searchButton = new _SearchWithDropdownButton2.default({
                emptySelectionMessageKey: this.params.emptySelectionMessageKey,
                dropdownButtonClick: function dropdownButtonClick() {
                    if (_this2.menu.isShown) _this2.menu.hide();else _this2.searchButton.setState({
                        focused: true,
                        searchText: ''
                    });
                },
                onSearchChangedCallback: function onSearchChangedCallback(text) {
                    _this2.setState({
                        searchText: text
                    });
                },
                onSearchFocusedCallback: function onSearchFocusedCallback() {
                    _this2.menu.showAt(_this2.searchButton.getEl(), _this2.params.positionParams);
                    var selectedItem = _this2.state.items.find(function (el) {
                        return el.id === _this2.state.selectedItemId;
                    });
                    if (!!selectedItem && _this2.params.hideItemPredicate(selectedItem)) _this2.menu.setState({
                        hiddenElementsCollapsed: false
                    });
                    _this2.menu.scrollTo(".selected");
                },
                onSelectedItemClickCallback: function onSelectedItemClickCallback() {
                    var selectedItem = _this2.state.items.find(function (el) {
                        return el.id === _this2.state.selectedItemId;
                    });
                    _this2.searchButton.setState({
                        focused: true,
                        searchText: ''
                    });
                },
                renderSelectedItemHtml: function renderSelectedItemHtml(item) {
                    return _this2.renderSelectedItemHtml(item);
                },
                inputMaxLength: this.params.inputMaxLength
            }).init(this.$el);

            this.menu = new _ScrollableDropdownView2.default({
                disableFlip: true,
                onHide: function onHide() {
                    _this2.searchButton.setState({
                        focused: false
                    });
                    _this2.params.onListHideCb();
                },
                onShow: function onShow() {
                    _this2.params.onListShowCb();
                },
                component: new _SearchItemList2.default({
                    itemRenderer: function itemRenderer(item, tokensHighlighter) {
                        return _this2.renderMenuItem(item, tokensHighlighter, _this2.state.selectedItemId);
                    },
                    additionalItemRenderer: function additionalItemRenderer(item) {
                        return _this2.renderAdditionalMenuItem(item, _this2.state.selectedItemId);
                    },
                    notFoundMessageKey: this.params.notFoundMessageKey,
                    hiddenItemsCollapsedMessageKey: this.params.hiddenItemsCollapsedMessageKey,
                    hiddenItemsExpandedMessageKey: this.params.hiddenItemsExpandedMessageKey
                })
            }).init(this.$el);

            this.renderInitialState();
        }
    }, {
        key: 'templateModel',
        value: function templateModel() {
            return {
                additionalClass: this.params.additionalClass
            };
        }
    }, {
        key: 'renderMenuItem',
        value: function renderMenuItem(item, tokensHighlighter, selectedItemId) {}
    }, {
        key: 'renderAdditionalMenuItem',
        value: function renderAdditionalMenuItem(item, selectedItemId) {}
    }, {
        key: 'renderSelectedItemHtml',
        value: function renderSelectedItemHtml(item) {
            //abstract
        }
    }, {
        key: 'getMenuEl',
        value: function getMenuEl() {
            return this.menu.getEl();
        }
    }, {
        key: '_onItemSelected',
        value: function _onItemSelected(item) {
            this.menu.hide();
            this.params.onItemSelectedCb(item);
        }
    }, {
        key: '_updateSearchButton',
        value: function _updateSearchButton() {
            var _this3 = this;

            this.searchButton.setState({
                disabled: this.state.items.length + this.state.additionalItems.length === 0,
                emptySetMessageKey: this.state.emptyListMessageKey,
                emptySelection: this.state.selectedItemId === this.params.emptySelectionId,
                emptySelectionSet: this.state.items.length + this.state.additionalItems.length === 0,
                selectedItem: this.state.items.find(function (el) {
                    return el.id === _this3.state.selectedItemId;
                }) || this.state.additionalItems.find(function (el) {
                    return el.id === _this3.state.selectedItemId;
                })
            });
        }
    }, {
        key: '_updateMenu',
        value: function _updateMenu() {
            var _this4 = this;

            var foundItems = (0, _utils.filterEntitiesBySearch)(this.state.items.filter(function (item) {
                return !_this4.params.hideItemPredicate(item);
            }), this.state.searchText);
            var foundHiddenItems = (0, _utils.filterEntitiesBySearch)(this.state.items.filter(function (item) {
                return _this4.params.hideItemPredicate(item);
            }), this.state.searchText);
            this.menu.setState({
                searchText: this.state.searchText,
                items: foundItems,
                hiddenItems: foundHiddenItems,
                additionalItems: this.state.additionalItems,
                selectedItemId: this.state.selectedItemId
            });
            if (!!this.state.searchText && foundHiddenItems.length > 0) this.menu.setState({
                hiddenElementsCollapsed: false
            });
        }
    }]);

    return Combobox;
}(_TemplateView3.default);

exports.default = Combobox;

/***/ }),
/* 1380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _SearchFilter = __webpack_require__(1381);

var _SearchFilter2 = _interopRequireDefault(_SearchFilter);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SearchWithDropdownButton = function (_TemplateView) {
    _inherits(SearchWithDropdownButton, _TemplateView);

    function SearchWithDropdownButton(_ref) {
        var _ref$emptySelectionMe = _ref.emptySelectionMessageKey,
            emptySelectionMessageKey = _ref$emptySelectionMe === undefined ? '' : _ref$emptySelectionMe,
            _ref$dropdownButtonCl = _ref.dropdownButtonClick,
            dropdownButtonClick = _ref$dropdownButtonCl === undefined ? function () {} : _ref$dropdownButtonCl,
            _ref$onSearchChangedC = _ref.onSearchChangedCallback,
            onSearchChangedCallback = _ref$onSearchChangedC === undefined ? function (text) {} : _ref$onSearchChangedC,
            _ref$onSearchFocusedC = _ref.onSearchFocusedCallback,
            onSearchFocusedCallback = _ref$onSearchFocusedC === undefined ? function () {} : _ref$onSearchFocusedC,
            _ref$onSelectedItemCl = _ref.onSelectedItemClickCallback,
            onSelectedItemClickCallback = _ref$onSelectedItemCl === undefined ? function () {} : _ref$onSelectedItemCl,
            _ref$renderSelectedIt = _ref.renderSelectedItemHtml,
            renderSelectedItemHtml = _ref$renderSelectedIt === undefined ? function (item) {} : _ref$renderSelectedIt,
            inputMaxLength = _ref.inputMaxLength;

        _classCallCheck(this, SearchWithDropdownButton);

        var _this = _possibleConstructorReturn(this, (SearchWithDropdownButton.__proto__ || Object.getPrototypeOf(SearchWithDropdownButton)).call(this));

        _this.params = {
            emptySelectionMessageKey: emptySelectionMessageKey,
            dropdownButtonClick: dropdownButtonClick,
            onSearchChangedCallback: onSearchChangedCallback,
            onSearchFocusedCallback: onSearchFocusedCallback,
            onSelectedItemClickCallback: onSelectedItemClickCallback,
            renderSelectedItemHtml: renderSelectedItemHtml,
            inputMaxLength: inputMaxLength
        };

        _this.state = {
            searchText: '',
            selectedItem: '',
            focused: false,
            disabled: false,
            emptySelection: false,
            emptySelectionSet: false,
            emptySetMessageKey: ''
        };

        _this.onAnyStatePropertyChanged(['selectedItem', 'emptySelection', 'emptySelectionSet'], function () {
            if (_this.state.emptySelectionSet) _this.$selectedItem.html('<div class="emptySet">' + _messageResource2.default.getEscapedMessage(_this.state.emptySetMessageKey) + '</div>');else if (_this.state.emptySelection) _this.$selectedItem.html('<div class="emptySelection">' + _messageResource2.default.getEscapedMessage(_this.params.emptySelectionMessageKey) + '</div>');else if (_this.state.selectedItem) _this.$selectedItem.html(_this.params.renderSelectedItemHtml(_this.state.selectedItem));
        });

        _this.onStatePropertyChanged('focused', function (focused) {
            _this.$selectedItem.toggle(!focused);
            _this.$searchInputPlaceholder.toggle(focused);
            _this.$el.toggleClass('focused', focused);
        });

        _this.onStatePropertyBecameTrue('focused', function () {
            _this.search.setState({
                text: _this.state.searchText
            });
            _this.params.onSearchChangedCallback(_this.state.searchText);
            _this.search.focus();
            _this.params.onSearchFocusedCallback();
        });

        _this.onStatePropertyChanged('disabled', function (disabled) {
            _this.$el.toggleClass('disabled', disabled);
        });
        return _this;
    }

    _createClass(SearchWithDropdownButton, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class="comboboxButton">' + '  <div class="selectedItem"></div>' + '  <div class="searchInputPlaceholder"></div>' + '  <div class="dropdownButton"></div>' + '</div>';
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            var _this2 = this;

            this.$selectedItem = this.find('.selectedItem');
            this.$searchInputPlaceholder = this.find('.searchInputPlaceholder');
            this.$dropdownButton = this.find('.dropdownButton');

            this.search = new _SearchFilter2.default({
                placeholder: '',
                additionalClass: '',
                onChange: function onChange(text) {
                    _this2.params.onSearchChangedCallback(text);
                },
                onClear: function onClear() {
                    _this2.search.setState({ text: '' });
                    _this2.setState({ searchText: '' });
                    _this2.params.onSearchChangedCallback('');
                },
                maxLength: this.params.inputMaxLength
            }).init(this.find('.searchInputPlaceholder'));

            this.$dropdownButton.click(function () {
                if (!_this2.state.disabled) _this2.params.dropdownButtonClick();
            });

            this.$selectedItem.click(function () {
                if (!_this2.state.disabled) {
                    _this2.params.onSelectedItemClickCallback();
                }
            });
        }
    }]);

    return SearchWithDropdownButton;
}(_TemplateView3.default);

exports.default = SearchWithDropdownButton;

/***/ }),
/* 1381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _keyHandlers = __webpack_require__(48);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SearchFilter = function (_TemplateView) {
    _inherits(SearchFilter, _TemplateView);

    function SearchFilter(_ref) {
        var _ref$placeholder = _ref.placeholder,
            placeholder = _ref$placeholder === undefined ? '' : _ref$placeholder,
            _ref$additionalClass = _ref.additionalClass,
            additionalClass = _ref$additionalClass === undefined ? '' : _ref$additionalClass,
            _ref$onChange = _ref.onChange,
            onChange = _ref$onChange === undefined ? function (text) {
            _this.setState({ text: text });
        } : _ref$onChange,
            _ref$onClear = _ref.onClear,
            onClear = _ref$onClear === undefined ? function () {
            _this.setState({
                text: ''
            });
        } : _ref$onClear,
            _ref$onBlur = _ref.onBlur,
            onBlur = _ref$onBlur === undefined ? function () {} : _ref$onBlur,
            _ref$maxLength = _ref.maxLength,
            maxLength = _ref$maxLength === undefined ? '' : _ref$maxLength;

        _classCallCheck(this, SearchFilter);

        var _this = _possibleConstructorReturn(this, (SearchFilter.__proto__ || Object.getPrototypeOf(SearchFilter)).call(this));

        _this._handleCloseClick = function () {
            _this.params.onChange('');
            _this.params.onClear();
        };

        _this._handleOnInputFocus = function () {
            _this.$inputPlaceholder.addClass('active');
            _this._keyPressHandlerRemover = (0, _keyHandlers.onKeyDown)(function (keyCode) {
                if ((0, _keyHandlers.isEsc)(keyCode)) {
                    _this._handleCloseClick();
                    return true;
                }
            });
        };

        _this._handleOnInputBlur = function () {
            _this.$inputPlaceholder.removeClass('active');
            _this._keyPressHandlerRemover();
            _this.params.onBlur();
        };

        _this._handleOnInputChange = function (e) {
            var text = e.target.value.trim();
            if (text !== _this.state.text) {
                _this.setStateInternal({ text: text });
                _this.$close.toggle(!!_this.state.text);
                _this._onChangeThrottled(text);
            }
        };

        _this.state = {
            text: null
        };

        _this.params = {
            placeholder: placeholder,
            additionalClass: additionalClass,
            onChange: onChange,
            onClear: onClear,
            onBlur: onBlur,
            maxLength: maxLength
        };

        _this.onStatePropertyChanged('text', function () {
            _this.$input.attr('value', _this.state.text);
            _this.$close.toggle(!!_this.state.text);
        });

        _this._onChangeThrottled = _underscore2.default.debounce(_this.params.onChange, 500);
        _this._keyPressHandlerRemover = null;
        return _this;
    }

    _createClass(SearchFilter, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class="searchFilterPlaceholder <%=additionalClass%>">' + '    <div class="inputPlaceholder">' + '      <input type="text" placeholder="<%=placeholder%>" maxlength="<%=maxLength%>"/>' + '    </div>' + '    <div class="close"></div>' + '</div>';
        }
    }, {
        key: 'templateModel',
        value: function templateModel() {
            return {
                additionalClass: this.params.additionalClass,
                placeholder: this.params.placeholder,
                maxLength: this.params.maxLength
            };
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            var _this2 = this;

            this.$inputPlaceholder = this.find('.searchFilterPlaceholder');
            this.$close = this.find('.close');
            this.$close.on('click', function () {
                _this2._handleCloseClick();
                _this2.focus();
            });
            this.$input = this.find('input').on('input', this._handleOnInputChange).on('focus', this._handleOnInputFocus).on('blur', this._handleOnInputBlur);
            this.renderInitialState();
        }
    }, {
        key: 'focus',
        value: function focus() {
            this.$input.focus();
        }
    }]);

    return SearchFilter;
}(_TemplateView3.default);

exports.default = SearchFilter;

/***/ }),
/* 1382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _DropdownTemplateView2 = __webpack_require__(42);

var _DropdownTemplateView3 = _interopRequireDefault(_DropdownTemplateView2);

var _ScrollableContainer = __webpack_require__(49);

var _ScrollableContainer2 = _interopRequireDefault(_ScrollableContainer);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _ScrollUtils = __webpack_require__(39);

var _ScrollUtils2 = _interopRequireDefault(_ScrollUtils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ScrollableDropdownView = function (_DropdownTemplateView) {
    _inherits(ScrollableDropdownView, _DropdownTemplateView);

    function ScrollableDropdownView(_ref) {
        var component = _ref.component,
            _ref$disableFlip = _ref.disableFlip,
            disableFlip = _ref$disableFlip === undefined ? false : _ref$disableFlip,
            _ref$onHide = _ref.onHide,
            onHide = _ref$onHide === undefined ? function () {} : _ref$onHide,
            _ref$onShow = _ref.onShow,
            onShow = _ref$onShow === undefined ? function () {} : _ref$onShow;

        _classCallCheck(this, ScrollableDropdownView);

        var _this = _possibleConstructorReturn(this, (ScrollableDropdownView.__proto__ || Object.getPrototypeOf(ScrollableDropdownView)).call(this, null, {
            toggleMode: false,
            onHide: onHide
        }));

        _this.props = {
            component: component,
            disableFlip: disableFlip,
            onShow: onShow
        };

        return _this;
    }

    _createClass(ScrollableDropdownView, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class="scrollableDropdownView">' + '</div>';
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            this.scrollableContainer = new _ScrollableContainer2.default(null, this.props.component).init(this.getEl());
            this.registerChildComponents(this.scrollableContainer);
        }
    }, {
        key: 'setState',
        value: function setState(data) {
            this.applyForChildrenComponents(function (child) {
                return child.setState(data);
            });
        }
    }, {
        key: 'onShow',
        value: function onShow() {
            _get(ScrollableDropdownView.prototype.__proto__ || Object.getPrototypeOf(ScrollableDropdownView.prototype), 'onShow', this).call(this);
            this.scrollableContainer.forceUpdate();
            this.props.onShow();
        }
    }, {
        key: 'showAt',
        value: function showAt($element, positionParams, $positionEl) {
            if (this.props.disableFlip) {
                positionParams = _extends({}, positionParams, {
                    collision: 'none'
                });
            }
            _get(ScrollableDropdownView.prototype.__proto__ || Object.getPrototypeOf(ScrollableDropdownView.prototype), 'showAt', this).call(this, $element, positionParams, $positionEl);
        }
    }, {
        key: 'scrollTo',
        value: function scrollTo(selector) {
            var $element = this.find(selector);
            if ($element.length > 0) this.scrollableContainer.scrollToElementVertical($element, _ScrollUtils2.default.POSITIONS.TOP);
        }
    }, {
        key: 'mouseDownTargetElement',
        value: function mouseDownTargetElement() {
            return (0, _jquery2.default)('body');
        }
    }, {
        key: '_mouseDownIgnoreElement',
        value: function _mouseDownIgnoreElement() {
            return this.$containerEl;
        }
    }]);

    return ScrollableDropdownView;
}(_DropdownTemplateView3.default);

exports.default = ScrollableDropdownView;

/***/ }),
/* 1383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _SimpleListMenuButton = __webpack_require__(187);

var _SimpleListMenuButton2 = _interopRequireDefault(_SimpleListMenuButton);

var _GroupType = __webpack_require__(34);

var _GroupType2 = _interopRequireDefault(_GroupType);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GroupBySelector = function (_TemplateView) {
    _inherits(GroupBySelector, _TemplateView);

    function GroupBySelector(_ref) {
        var _ref$onGroupBySelecte = _ref.onGroupBySelected,
            onGroupBySelected = _ref$onGroupBySelecte === undefined ? function (groupBy) {} : _ref$onGroupBySelecte;

        _classCallCheck(this, GroupBySelector);

        var _this = _possibleConstructorReturn(this, (GroupBySelector.__proto__ || Object.getPrototypeOf(GroupBySelector)).call(this));

        _this.onGroupBySelected = onGroupBySelected;

        _this.state = {
            groupBy: _GroupType2.default.USER_GROUP
        };

        _this.onStatePropertyChanged("groupBy", function (groupBy) {
            return _this._updateMenuButton(groupBy);
        });
        return _this;
    }

    _createClass(GroupBySelector, [{
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='groupBySelector'></div>";
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            var _this2 = this;

            this.menuButton = new _SimpleListMenuButton2.default({
                itemHtmlCallback: function itemHtmlCallback(groupType) {
                    if (groupType === _GroupType2.default.USER_GROUP) return _messageResource2.default.getEscapedMessage("common.User_Group");else if (groupType === _GroupType2.default.TIME_ZONE_GROUP) return _messageResource2.default.getEscapedMessage("common.Time_Zone_Group");
                },
                onSelect: function onSelect(groupType) {
                    _this2.setState({ groupBy: groupType });
                    _this2.onGroupBySelected(groupType);
                },
                extraClass: "withLinkStyle",
                menuExtraClass: "groupBySelectorMenu",
                menuPositionParams: {
                    my: "right top",
                    at: "right bottom"
                },
                autoMenuWidth: false
            }).init(this.$el);

            this.renderInitialState();
        }
    }, {
        key: "_updateMenuButton",
        value: function _updateMenuButton(groupBy) {
            this.menuButton.setItems([_GroupType2.default.USER_GROUP, _GroupType2.default.TIME_ZONE_GROUP], groupBy);
        }
    }]);

    return GroupBySelector;
}(_TemplateView3.default);

exports.default = GroupBySelector;

/***/ }),
/* 1384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _GroupBlock = __webpack_require__(1385);

var _GroupBlock2 = _interopRequireDefault(_GroupBlock);

var _UserItem = __webpack_require__(1386);

var _UserItem2 = _interopRequireDefault(_UserItem);

var _GroupType = __webpack_require__(34);

var _GroupType2 = _interopRequireDefault(_GroupType);

var _utils = __webpack_require__(293);

var _UserNameFormat = __webpack_require__(17);

var _NonGroupBlock = __webpack_require__(1387);

var _NonGroupBlock2 = _interopRequireDefault(_NonGroupBlock);

var _atUtils = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UsersList = function (_TemplateView) {
    _inherits(UsersList, _TemplateView);

    function UsersList(_ref) {
        var _ref$onUserDelete = _ref.onUserDelete,
            onUserDelete = _ref$onUserDelete === undefined ? function (userId) {} : _ref$onUserDelete,
            _ref$userSubtitleGene = _ref.userSubtitleGenerator,
            userSubtitleGenerator = _ref$userSubtitleGene === undefined ? function (user) {
            return "";
        } : _ref$userSubtitleGene,
            _ref$showPermissionIc = _ref.showPermissionIcons,
            showPermissionIcons = _ref$showPermissionIc === undefined ? false : _ref$showPermissionIc,
            _ref$getDisabledToolt = _ref.getDisabledTooltipText,
            getDisabledTooltipText = _ref$getDisabledToolt === undefined ? function (user) {
            return "";
        } : _ref$getDisabledToolt,
            _ref$canModifyPredica = _ref.canModifyPredicate,
            canModifyPredicate = _ref$canModifyPredica === undefined ? function (user) {
            return true;
        } : _ref$canModifyPredica;

        _classCallCheck(this, UsersList);

        var _this = _possibleConstructorReturn(this, (UsersList.__proto__ || Object.getPrototypeOf(UsersList)).call(this));

        _this.params = {
            userSubtitleGenerator: userSubtitleGenerator,
            showPermissionIcons: showPermissionIcons,
            getDisabledTooltipText: getDisabledTooltipText,
            canModifyPredicate: canModifyPredicate,
            onUserDelete: onUserDelete
        };

        _this.state = {
            groupBy: null,
            users: [],
            userGroups: [],
            timeZoneGroups: [],
            canModifyAny: false,
            isBTYEnabled: false,
            isURAEnabled: false,
            isTTAEnabled: false
        };

        _this.onStateDeeplyChanged(function () {
            return _this._updateUsers();
        });
        return _this;
    }

    _createClass(UsersList, [{
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='usersList components_itemGroup'></div>";
        }
    }, {
        key: "_updateUsers",
        value: function _updateUsers() {
            var _this2 = this;

            var mapUsersToUserItems = function mapUsersToUserItems(users) {
                return users.map(function (user) {
                    return new _UserItem2.default(_extends({
                        title: (0, _UserNameFormat.formatFML)(user.firstName, user.lastName, user.middleName),
                        subtitle: _this2.params.userSubtitleGenerator(user),
                        deleteButtonVisible: _this2.state.canModifyAny,
                        deleteButtonDisabled: !_this2.params.canModifyPredicate(user),
                        deleteButtonDisabledTooltipText: _this2.params.getDisabledTooltipText(user),
                        showPermissionIcons: _this2.params.showPermissionIcons,
                        onDeleteClick: function onDeleteClick() {
                            return _this2.params.onUserDelete(user.id);
                        },
                        showCostReports: _this2.state.isURAEnabled || _this2.state.isBTYEnabled,
                        costReportsTooltipText: (0, _utils.getTitleOfGenerateMoneyReportsRight)(_this2.state.isBTYEnabled, _this2.state.isURAEnabled),
                        modifyTimeTrackTooltipText: (0, _utils.getTitleOfModifyTimeTrackRight)(_this2.state.isTTAEnabled)
                    }, (0, _utils.extractPermissionsFromUser)(user)));
                });
            };

            this.$el.empty();

            if (this.state.groupBy) {
                var groups = void 0,
                    groupIdProp = void 0;
                if (this.state.groupBy === _GroupType2.default.USER_GROUP) {
                    groups = this.state.userGroups;
                    groupIdProp = "userGroupId";
                } else if (this.state.groupBy === _GroupType2.default.TIME_ZONE_GROUP) {
                    groups = this.state.timeZoneGroups;
                    groupIdProp = "timeZoneGroupId";
                }

                var groupedUsers = (0, _utils.groupUsers)(this.state.users, groups, groupIdProp);

                groupedUsers.forEach(function (group) {
                    return new _GroupBlock2.default(_this2.$el, {
                        title: (0, _atUtils.escapeHtmlSymbols)(group.name),
                        items: mapUsersToUserItems(group.users)
                    }).init();
                });
            } else {
                new _NonGroupBlock2.default(mapUsersToUserItems(this.state.users)).init(this.$el);
            }
        }
    }]);

    return UsersList;
}(_TemplateView3.default);

exports.default = UsersList;

/***/ }),
/* 1385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GroupBlock = function (_TemplateView) {
    _inherits(GroupBlock, _TemplateView);

    function GroupBlock($containerEl, _ref) {
        var _ref$title = _ref.title,
            title = _ref$title === undefined ? "" : _ref$title,
            _ref$items = _ref.items,
            items = _ref$items === undefined ? [] : _ref$items;

        _classCallCheck(this, GroupBlock);

        var _this = _possibleConstructorReturn(this, (GroupBlock.__proto__ || Object.getPrototypeOf(GroupBlock)).call(this, $containerEl));

        _this.title = title;
        _this.items = items;
        return _this;
    }

    _createClass(GroupBlock, [{
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='groupSection components_itemGroup'>" + "  <div class='header'><%=title.toUpperCase()%></div>" + "  <div class='items'></div>" + "</div>";
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            var $items = this.find(".items");
            this.items.forEach(function (item) {
                return item.init($items);
            });
        }
    }]);

    return GroupBlock;
}(_TemplateView3.default);

exports.default = GroupBlock;

/***/ }),
/* 1386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _PermissionIcons = __webpack_require__(775);

var _PermissionIcons2 = _interopRequireDefault(_PermissionIcons);

var _SimpleSingletonTooltip = __webpack_require__(45);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UserItem = function (_TemplateView) {
    _inherits(UserItem, _TemplateView);

    function UserItem(_ref) {
        var _ref$title = _ref.title,
            title = _ref$title === undefined ? "" : _ref$title,
            _ref$subtitle = _ref.subtitle,
            subtitle = _ref$subtitle === undefined ? "" : _ref$subtitle,
            _ref$deleteButtonVisi = _ref.deleteButtonVisible,
            deleteButtonVisible = _ref$deleteButtonVisi === undefined ? false : _ref$deleteButtonVisi,
            _ref$deleteButtonDisa = _ref.deleteButtonDisabled,
            deleteButtonDisabled = _ref$deleteButtonDisa === undefined ? false : _ref$deleteButtonDisa,
            _ref$onDeleteClick = _ref.onDeleteClick,
            onDeleteClick = _ref$onDeleteClick === undefined ? function () {} : _ref$onDeleteClick,
            _ref$showPermissionIc = _ref.showPermissionIcons,
            showPermissionIcons = _ref$showPermissionIc === undefined ? false : _ref$showPermissionIc,
            _ref$manageUsers = _ref.manageUsers,
            manageUsers = _ref$manageUsers === undefined ? false : _ref$manageUsers,
            _ref$modifyTimeTrack = _ref.modifyTimeTrack,
            modifyTimeTrack = _ref$modifyTimeTrack === undefined ? false : _ref$modifyTimeTrack,
            _ref$manageScope = _ref.manageScope,
            manageScope = _ref$manageScope === undefined ? false : _ref$manageScope,
            _ref$costReports = _ref.costReports,
            costReports = _ref$costReports === undefined ? false : _ref$costReports,
            _ref$showCostReports = _ref.showCostReports,
            showCostReports = _ref$showCostReports === undefined ? false : _ref$showCostReports,
            _ref$costReportsToolt = _ref.costReportsTooltipText,
            costReportsTooltipText = _ref$costReportsToolt === undefined ? "" : _ref$costReportsToolt,
            _ref$modifyTimeTrackT = _ref.modifyTimeTrackTooltipText,
            modifyTimeTrackTooltipText = _ref$modifyTimeTrackT === undefined ? '' : _ref$modifyTimeTrackT,
            _ref$deleteButtonDisa2 = _ref.deleteButtonDisabledTooltipText,
            deleteButtonDisabledTooltipText = _ref$deleteButtonDisa2 === undefined ? "" : _ref$deleteButtonDisa2;

        _classCallCheck(this, UserItem);

        var _this = _possibleConstructorReturn(this, (UserItem.__proto__ || Object.getPrototypeOf(UserItem)).call(this));

        _this.title = title;
        _this.subtitle = subtitle;
        _this.deleteButtonVisible = deleteButtonVisible;
        _this.deleteButtonDisabled = deleteButtonDisabled;
        _this.deleteButtonDisabledTooltipText = deleteButtonDisabledTooltipText;
        _this.onDeleteClick = onDeleteClick;
        if (showPermissionIcons) {
            _this.permissionIcons = new _PermissionIcons2.default({
                manageUsers: manageUsers,
                modifyTimeTrack: modifyTimeTrack,
                manageScope: manageScope,
                costReports: costReports,
                showCostReports: showCostReports,
                costReportsTooltipText: costReportsTooltipText,
                modifyTimeTrackTooltipText: modifyTimeTrackTooltipText
            });
        }
        return _this;
    }

    _createClass(UserItem, [{
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='item withDeleteButton'>" + "  <div class='itemContent'>" + "    <div class='title'><%-title%></div>" + "    <div class='optionalContent'>" + "        <div class='subtitle'><%-subtitle%></div>" + "        <div class='permissionIconsContainer'></div>" + "        <div class='deleteButton'>" + "           <div class='deleteIcon'></div>" + "        </div>" + "    </div>" + "  </div>" + "</div>";
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            var _this2 = this;

            var $deleteButton = this.find(".deleteButton");
            if (this.deleteButtonVisible && !this.deleteButtonDisabled) {
                $deleteButton.click(function () {
                    return _this2.onDeleteClick();
                });
            }

            if (this.permissionIcons) {
                this.permissionIcons.init(this.find(".permissionIconsContainer"));
            }

            this.$el.toggleClass("deleteButtonVisible", this.deleteButtonVisible);
            this.$el.toggleClass("deleteButtonDisabled", this.deleteButtonDisabled);
            this.$el.toggleClass("withSubtitle", !!this.subtitle);
            this.$el.toggleClass("withPermissionIcons", !!this.permissionIcons);

            if (this.deleteButtonVisible && this.deleteButtonDisabled && this.deleteButtonDisabledTooltipText) {
                (0, _SimpleSingletonTooltip.getInstance)().subscribeToMouseEvents($deleteButton, function () {
                    (0, _SimpleSingletonTooltip.getInstance)().setState({
                        text: _this2.deleteButtonDisabledTooltipText,
                        extraClass: 'hierarchyAssignmentsTooltip'
                    });
                });
            }
        }
    }]);

    return UserItem;
}(_TemplateView3.default);

exports.default = UserItem;

/***/ }),
/* 1387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NonGroupBlock = function (_TemplateView) {
    _inherits(NonGroupBlock, _TemplateView);

    function NonGroupBlock() {
        var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

        _classCallCheck(this, NonGroupBlock);

        var _this = _possibleConstructorReturn(this, (NonGroupBlock.__proto__ || Object.getPrototypeOf(NonGroupBlock)).call(this));

        _this.items = items;
        return _this;
    }

    _createClass(NonGroupBlock, [{
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='nonGroupSection components_itemGroup'>" + "  <div class='items'></div>" + "</div>";
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            var $items = this.find(".items");
            this.items.forEach(function (item) {
                return item.init($items);
            });
        }
    }]);

    return NonGroupBlock;
}(_TemplateView3.default);

exports.default = NonGroupBlock;

/***/ }),
/* 1388 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
        value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _UserGroupNodeRenderer = __webpack_require__(238);

var _UserGroupNodeRenderer2 = _interopRequireDefault(_UserGroupNodeRenderer);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _atBrowserUtils = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UserGroupSelectableNodeRenderer = function (_UserGroupNodeRendere) {
        _inherits(UserGroupSelectableNodeRenderer, _UserGroupNodeRendere);

        function UserGroupSelectableNodeRenderer(tree, selectorFilter, expandCollapseCallback, hideSelect) {
                _classCallCheck(this, UserGroupSelectableNodeRenderer);

                var _this = _possibleConstructorReturn(this, (UserGroupSelectableNodeRenderer.__proto__ || Object.getPrototypeOf(UserGroupSelectableNodeRenderer)).call(this, tree, selectorFilter, expandCollapseCallback));

                _this.hideSelect = hideSelect;
                return _this;
        }

        _createClass(UserGroupSelectableNodeRenderer, [{
                key: "generateContent",
                value: function generateContent(treeNode, targetEl) {
                        var tableEl = document.createElement("table");
                        var tBodyEl = document.createElement("tbody");
                        var trEl = document.createElement("tr");
                        var titleTdEl = document.createElement("td");
                        var selectTdEl = document.createElement("td");
                        var collapseTdEl = document.createElement("td");

                        var selectEl = this.generateSelect(treeNode);
                        var normalExpandCollapseButton = this.generateExpandCollapseButton(treeNode, true, "normalExpandCollapseButton", null);
                        var disabledExpandCollapseButtonWithTitle = this.generateExpandCollapseButton(treeNode, false, "disabledExpandCollapseButtonWithTitle", this.getExpandCollapseButtonTitle(treeNode));
                        var disabledExpandCollapseButtonWithoutTitle = this.generateExpandCollapseButton(treeNode, false, "disabledExpandCollapseButtonWithoutTitle", null);

                        tableEl.appendChild(tBodyEl);
                        tBodyEl.appendChild(trEl);
                        trEl.appendChild(titleTdEl);
                        if (!this.hideSelect) {
                                trEl.appendChild(selectTdEl);
                        }
                        trEl.appendChild(collapseTdEl);
                        selectTdEl.appendChild(selectEl);
                        collapseTdEl.appendChild(normalExpandCollapseButton);
                        collapseTdEl.appendChild(disabledExpandCollapseButtonWithTitle);
                        collapseTdEl.appendChild(disabledExpandCollapseButtonWithoutTitle);

                        var spacerDiv = document.createElement("div");
                        spacerDiv.className = "spacer";
                        spacerDiv.innerHTML = "<b></b>"; // for IE to display correctly

                        targetEl.appendChild(tableEl);
                        targetEl.appendChild(spacerDiv);

                        var titleNode = document.createElement("a");
                        titleNode.className = "titleNode";
                        titleNode.hidefocus = "true";

                        (0, _atBrowserUtils.disableTextSelection)(titleNode);

                        var labelEl = document.createElement("span");
                        labelEl.className = "ellipsisLabel ellipsisSelectableLabel";
                        this.generateLabel(treeNode, labelEl);

                        titleTdEl.appendChild(titleNode);
                        titleNode.appendChild(labelEl);

                        this.tree.getUIObjectForNode(treeNode).cbEl = titleNode;
                        this.tree.getUIObjectForNode(treeNode).labelEl = labelEl;
                        this.tree.getUIObjectForNode(treeNode).selectEl = selectEl;
                }
        }, {
                key: "generateSelect",
                value: function generateSelect(treeNode) {
                        var selectEl = document.createElement("p");
                        this.renderSelectContent(treeNode, selectEl);

                        selectEl.className = "selectUserGroupElement";

                        return selectEl;
                }
        }, {
                key: "renderSelectContent",
                value: function renderSelectContent(treeNode, selectEl) {
                        var selectionController = this.tree.getSelectionController();
                        var showDeselectAll = selectionController.hasAllChildrenSelected(treeNode);
                        var disabled = selectionController.hasAllChildrenDisabled(treeNode);

                        selectEl.className = !disabled ? "selectUserGroupElement" : "selectUserGroupElement disabledSelectedUserGroupElement";

                        selectEl.onclick = function () {
                                showDeselectAll ? selectionController.deselectSubtree(treeNode) : selectionController.selectSubtree(treeNode, true);
                        };

                        selectEl.innerText = showDeselectAll ? _messageResource2.default.getMessage("assigned_users_editor.managers.task.users_deselect_group") : _messageResource2.default.getMessage("assigned_users_editor.managers.task.users_select_group");
                }
        }, {
                key: "updateUI",
                value: function updateUI(treeNode) {
                        var uiObject = this.tree.getUIObjectForNode(treeNode);

                        if (uiObject.selectEl) {
                                this.renderSelectContent(treeNode, uiObject.selectEl);
                        }

                        _get(UserGroupSelectableNodeRenderer.prototype.__proto__ || Object.getPrototypeOf(UserGroupSelectableNodeRenderer.prototype), "updateUI", this).call(this, treeNode);
                }
        }]);

        return UserGroupSelectableNodeRenderer;
}(_UserGroupNodeRenderer2.default);

exports.default = UserGroupSelectableNodeRenderer;

/***/ }),
/* 1389 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
        value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _DisabledUsersParentNodeRenderer = __webpack_require__(776);

var _DisabledUsersParentNodeRenderer2 = _interopRequireDefault(_DisabledUsersParentNodeRenderer);

var _atBrowserUtils = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DisabledUsersParentNodeRendererWithoutCheckbox = function (_DisabledUsersParentN) {
        _inherits(DisabledUsersParentNodeRendererWithoutCheckbox, _DisabledUsersParentN);

        function DisabledUsersParentNodeRendererWithoutCheckbox() {
                _classCallCheck(this, DisabledUsersParentNodeRendererWithoutCheckbox);

                return _possibleConstructorReturn(this, (DisabledUsersParentNodeRendererWithoutCheckbox.__proto__ || Object.getPrototypeOf(DisabledUsersParentNodeRendererWithoutCheckbox)).apply(this, arguments));
        }

        _createClass(DisabledUsersParentNodeRendererWithoutCheckbox, [{
                key: "generateContent",
                value: function generateContent(treeNode, targetEl) {
                        var triStateEl = document.createElement("a");
                        triStateEl.hidefocus = "true";
                        triStateEl.onfocus = function () {
                                this.blur();
                        };
                        (0, _atBrowserUtils.disableTextSelection)(triStateEl, true);

                        var labelEl = document.createElement("span");
                        labelEl.className = "ellipsisLabel";
                        this.generateLabel(treeNode, labelEl);

                        targetEl.appendChild(triStateEl);
                        triStateEl.appendChild(labelEl);

                        this.appendAdditionalElements(targetEl, treeNode);

                        this.tree.getUIObjectForNode(treeNode).cbEl = triStateEl;
                        this.tree.getUIObjectForNode(treeNode).labelEl = labelEl;
                }
        }]);

        return DisabledUsersParentNodeRendererWithoutCheckbox;
}(_DisabledUsersParentNodeRenderer2.default);

exports.default = DisabledUsersParentNodeRendererWithoutCheckbox;

/***/ }),
/* 1390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _DeleteTasksConfirmationDialog = __webpack_require__(777);

var _DeleteTasksConfirmationDialog2 = _interopRequireDefault(_DeleteTasksConfirmationDialog);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DeleteTaskPopupConfirmationDialog = function (_DeleteTasksConfirmat) {
    _inherits(DeleteTaskPopupConfirmationDialog, _DeleteTasksConfirmat);

    function DeleteTaskPopupConfirmationDialog($container, cancelHandler, deleteHandler) {
        _classCallCheck(this, DeleteTaskPopupConfirmationDialog);

        return _possibleConstructorReturn(this, (DeleteTaskPopupConfirmationDialog.__proto__ || Object.getPrototypeOf(DeleteTaskPopupConfirmationDialog)).call(this, $container, cancelHandler, deleteHandler));
    }

    _createClass(DeleteTaskPopupConfirmationDialog, [{
        key: "createBlockedEntitiesList",
        value: function createBlockedEntitiesList() {
            // do nothing
        }
    }, {
        key: "titleText",
        value: function titleText() {
            return _messageResource2.default.getMessage("task.edit_popup.about_to_delete", [this.state.entityName]);
        }
    }]);

    return DeleteTaskPopupConfirmationDialog;
}(_DeleteTasksConfirmationDialog2.default);

exports.default = DeleteTaskPopupConfirmationDialog;

/***/ }),
/* 1391 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _UserInitialsIcon = __webpack_require__(758);

var _UserInitialsIcon2 = _interopRequireDefault(_UserInitialsIcon);

var _constants = __webpack_require__(120);

var _LoadingContainer = __webpack_require__(28);

var _LoadingContainer2 = _interopRequireDefault(_LoadingContainer);

var _CommentInput = __webpack_require__(1392);

var _CommentInput2 = _interopRequireDefault(_CommentInput);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CommentInputContainer = function (_TemplateView) {
    _inherits(CommentInputContainer, _TemplateView);

    function CommentInputContainer(_ref) {
        var userInfo = _ref.userInfo,
            _ref$onCommentTextCha = _ref.onCommentTextChange,
            onCommentTextChange = _ref$onCommentTextCha === undefined ? function () {} : _ref$onCommentTextCha,
            _ref$onShowInputChang = _ref.onShowInputChanged,
            onShowInputChanged = _ref$onShowInputChang === undefined ? function () {} : _ref$onShowInputChang,
            _ref$onCommentAdded = _ref.onCommentAdded,
            onCommentAdded = _ref$onCommentAdded === undefined ? function () {} : _ref$onCommentAdded,
            _ref$refreshScrollCb = _ref.refreshScrollCb,
            refreshScrollCb = _ref$refreshScrollCb === undefined ? function () {} : _ref$refreshScrollCb;

        _classCallCheck(this, CommentInputContainer);

        var _this = _possibleConstructorReturn(this, (CommentInputContainer.__proto__ || Object.getPrototypeOf(CommentInputContainer)).call(this));

        _this.params = {
            userInfo: userInfo
        };

        _this.callbacks = {
            onCommentTextChange: onCommentTextChange,
            onShowInputChanged: onShowInputChanged,
            onCommentAdded: onCommentAdded,
            refreshScrollCb: refreshScrollCb
        };

        _this.state = {
            showCommentInput: false,
            commentText: '',
            sending: false
        };

        _this.onStatePropertyChanged('sending', function (sending) {
            _this.loadingWrapper.setState({ loading: sending });
        });

        _this.onStatePropertyChanged('showCommentInput', function (showInput) {
            _this.commentInput.setState({ showInput: showInput });
        });

        _this.onStatePropertyChanged('commentText', function (commentText) {
            _this.commentInput.setState({ text: commentText });
        });
        return _this;
    }

    _createClass(CommentInputContainer, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return "<div class='commentInputContainer'/>";
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            new _UserInitialsIcon2.default({
                firstName: this.params.userInfo.firstName,
                lastName: this.params.userInfo.lastName,
                color: _constants.LOGGED_IN_USER_ICON_COLOR
            }).init(this.getEl());

            this.commentInput = new _CommentInput2.default({
                onShowInputChanged: this.callbacks.onShowInputChanged,
                onTextChange: this.callbacks.onCommentTextChange,
                onCommentAdded: this.callbacks.onCommentAdded,
                refreshScrollCb: this.callbacks.refreshScrollCb
            });

            this.loadingWrapper = new _LoadingContainer2.default({
                contentComponent: this.commentInput,
                containerClass: 'commentInputLoadingWrapper'
            }).init(this.getEl());
        }
    }]);

    return CommentInputContainer;
}(_TemplateView3.default);

exports.default = CommentInputContainer;

/***/ }),
/* 1392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _ResizableInput = __webpack_require__(287);

var _ResizableInput2 = _interopRequireDefault(_ResizableInput);

var _keyHandlers = __webpack_require__(48);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _constants = __webpack_require__(120);

var _utils = __webpack_require__(362);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CommentInput = function (_TemplateView) {
    _inherits(CommentInput, _TemplateView);

    function CommentInput(_ref) {
        var _ref$onShowInputChang = _ref.onShowInputChanged,
            onShowInputChanged = _ref$onShowInputChang === undefined ? function () {} : _ref$onShowInputChang,
            _ref$onTextChange = _ref.onTextChange,
            onTextChange = _ref$onTextChange === undefined ? function () {} : _ref$onTextChange,
            _ref$onCommentAdded = _ref.onCommentAdded,
            onCommentAdded = _ref$onCommentAdded === undefined ? function () {} : _ref$onCommentAdded,
            _ref$refreshScrollCb = _ref.refreshScrollCb,
            refreshScrollCb = _ref$refreshScrollCb === undefined ? function () {} : _ref$refreshScrollCb;

        _classCallCheck(this, CommentInput);

        var _this = _possibleConstructorReturn(this, (CommentInput.__proto__ || Object.getPrototypeOf(CommentInput)).call(this));

        _this.callbacks = {
            onShowInputChanged: onShowInputChanged,
            onTextChange: onTextChange,
            onCommentAdded: onCommentAdded,
            refreshScrollCb: refreshScrollCb
        };

        _this.state = {
            showInput: false,
            text: '',
            preventBlur: false
        };

        _this.onStatePropertyChanged('showInput', function (showInput) {
            _this.input.toggle(showInput);
            _this.getEl().toggleClass('inEdit', _this.state.showInput);

            if (showInput) {
                _this.input.focus();
            } else {
                _this.input.setState({ text: "" });
            }
        });

        _this.onStatePropertyChanged('text', function (text) {
            _this.input.setState({ text: text });
            _this._updateBottomLine();
        });
        return _this;
    }

    _createClass(CommentInput, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return "<div class='components_commentInput'>" + "    <div class='inputArea'/>" + "    <div class='sendCommentLine'>" + "        <div class='bottomLineText'>" + "            <span class='placeholderText'><%=placeholderText%></span>" + "            <span class='errorText'></span>" + "        </div>" + "        <div class='sendCommentButton'>" + "            <div class='commentLabel'><%=comment%></div>" + "            <div class='sendIcon'/>" + "        </div>" + "    </div>" + "</div>";
        }
    }, {
        key: 'messageKeys',
        value: function messageKeys() {
            return {
                placeholderText: 'panel.common.comments.comment_input.placeholder',
                comment: 'panel.common.comments.comment_input.comment_label'
            };
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            var _this2 = this;

            this.input = new _ResizableInput2.default({
                showCounter: false,
                heightLimit: 300,
                minHeight: 75,
                maxLength: _constants.NUMBER_ALLOWED_CHARACTERS,
                allowInputOverMaxLength: true,
                onFocus: function onFocus() {
                    _this2.callbacks.refreshScrollCb();
                },
                onBlur: function onBlur(text) {
                    if (text === '' && !_this2.state.preventBlur) {
                        _this2.callbacks.onShowInputChanged(false);
                        _this2.callbacks.refreshScrollCb();
                    }
                },
                onResize: function onResize() {
                    return _this2.callbacks.refreshScrollCb();
                },
                onKeyDown: function onKeyDown(e) {
                    return _this2._handleKeyDown(e);
                },
                onChange: this.callbacks.onTextChange
            }).init(this.find('.inputArea'));

            this.input.hide();

            this.$errorText = this.find('.errorText');
            this.$sendCommentButton = this.find('.sendCommentButton');
            this.$sendCommentButton.click(function (e) {
                e.stopPropagation();
                _this2._handleSendClick();
            });

            this.find('.sendCommentLine').click(function () {
                if (!_this2.state.showInput) {
                    _this2.callbacks.onShowInputChanged(true);
                }
                _this2.input.focus();
            });

            this._subscribeToPreventOnInputBlurEventOnBottomLineClick();
            this.renderInitialState();
        }
    }, {
        key: '_updateBottomLine',
        value: function _updateBottomLine() {
            var characterCount = this.state.text.length;
            var allowSend = (0, _utils.validateCommentText)(this.state.text);
            this.$sendCommentButton.toggleClass('active', allowSend && this.state.showInput);
            this.$errorText.toggle(characterCount > _constants.NUMBER_ALLOWED_CHARACTERS);

            if (characterCount > _constants.NUMBER_ALLOWED_CHARACTERS) {
                var exceededCharacters = characterCount - _constants.NUMBER_ALLOWED_CHARACTERS;
                this.$errorText.text(_messageResource2.default.getMessage('panel.common.comments.number_characters_exceeded', [_constants.NUMBER_ALLOWED_CHARACTERS, exceededCharacters]));
            }
        }
    }, {
        key: '_handleSendClick',
        value: function _handleSendClick() {
            if (this.state.text !== '' && this.state.text.length <= _constants.NUMBER_ALLOWED_CHARACTERS) {
                this.callbacks.onCommentAdded(this.state.text);
                this.callbacks.refreshScrollCb();
            }
        }
    }, {
        key: '_handleKeyDown',
        value: function _handleKeyDown(e) {
            if ((0, _keyHandlers.isEnter)(e.keyCode) && ((0, _keyHandlers.isCtrlPressed)(e) || (0, _keyHandlers.isShiftPressed)(e))) {
                this._handleSendClick();
            }
        }
    }, {
        key: '_subscribeToPreventOnInputBlurEventOnBottomLineClick',
        value: function _subscribeToPreventOnInputBlurEventOnBottomLineClick() {
            var _this3 = this;

            this.find('.sendCommentLine').on('mousedown', function () {
                return _this3.setStateInternal({ preventBlur: true });
            }).on('mouseup', function () {
                return _this3.setStateInternal({ preventBlur: false });
            });
        }
    }]);

    return CommentInput;
}(_TemplateView3.default);

exports.default = CommentInput;

/***/ }),
/* 1393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InformationBlockLine = function (_TemplateView) {
    _inherits(InformationBlockLine, _TemplateView);

    function InformationBlockLine(_ref) {
        var _ref$lineText = _ref.lineText,
            lineText = _ref$lineText === undefined ? '' : _ref$lineText;

        _classCallCheck(this, InformationBlockLine);

        var _this = _possibleConstructorReturn(this, (InformationBlockLine.__proto__ || Object.getPrototypeOf(InformationBlockLine)).call(this));

        _this.lineText = lineText;
        return _this;
    }

    _createClass(InformationBlockLine, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class="informationBlockLine">' + '    <div class="iconPlaceholder"/>' + '    <div class="text"><%-lineText%></div>' + '</div>';
        }
    }]);

    return InformationBlockLine;
}(_TemplateView3.default);

exports.default = InformationBlockLine;

/***/ }),
/* 1394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CopySettingsItem = function (_TemplateView) {
    _inherits(CopySettingsItem, _TemplateView);

    function CopySettingsItem(_ref) {
        var _ref$id = _ref.id,
            id = _ref$id === undefined ? null : _ref$id,
            _ref$text = _ref.text,
            text = _ref$text === undefined ? '' : _ref$text;

        _classCallCheck(this, CopySettingsItem);

        var _this = _possibleConstructorReturn(this, (CopySettingsItem.__proto__ || Object.getPrototypeOf(CopySettingsItem)).call(this));

        _this.id = id;
        _this.text = text;
        return _this;
    }

    _createClass(CopySettingsItem, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<label class="copySettingsItem">' + '   <input type="checkbox" id="<%=id%>" class="input" checked/>' + '   <span class="text"><%-text%></span>' + '</label>';
        }
    }, {
        key: 'isChecked',
        value: function isChecked() {
            return this.find('input').is(':checked');
        }
    }]);

    return CopySettingsItem;
}(_TemplateView3.default);

exports.default = CopySettingsItem;

/***/ }),
/* 1395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = handlePageVisited;

var _UserEventsMap = __webpack_require__(99);

var _atUtils = __webpack_require__(5);

var startDate = Date.now();

function handlePageVisited(event, params) {
    var path = (0, _atUtils.getCurrentRelativeLinkWithoutQuery)();

    if (event === _UserEventsMap.UserEventsMap.PAGE_VISIBLE) {
        startDate = Date.now();
    } else if (event === _UserEventsMap.UserEventsMap.PAGE_HIDDEN) {
        var endDate = Date.now();
        var duration = (endDate - startDate) / 1000;
        startDate = endDate;

        return {
            event: _UserEventsMap.UserEventsMap.PAGE_VISITED,
            params: {
                Duration: duration,
                'Tab Name': path,
                'Browser Width': window.innerWidth,
                'Browser Height': window.innerHeight
            }
        };
    }

    return { event: event, params: params };
}

/***/ }),
/* 1396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = handlePopupVideo;

var _UserEventsMap = __webpack_require__(99);

var startTime = null;
var endTime = 0;
var sentOnce = false;

function handlePopupVideo(event, params) {
    var isVideoWatchedEvent = event === _UserEventsMap.UserEventsMap.PAGE_HIDDEN || event === _UserEventsMap.UserEventsMap.POPUP_CLOSED;
    var shouldSend = isVideoWatchedEvent && !sentOnce && startTime !== null;

    if (event === _UserEventsMap.UserEventsMap.PLAY_VIDEO && startTime === null) {
        startTime = params.startTime;
    } else if (event === _UserEventsMap.UserEventsMap.VIDEO_TIMELINE_UPDATED) {
        endTime = params.time;
    } else if (shouldSend) {
        sentOnce = true;
        var duration = endTime - startTime;
        return { event: _UserEventsMap.UserEventsMap.VIDEO_WATCHED, params: { 'Play Duration': duration } };
    }

    return { event: event, params: params };
}

/***/ }),
/* 1397 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _NameInput = __webpack_require__(370);

var _NameInput2 = _interopRequireDefault(_NameInput);

var _ProjectPanel = __webpack_require__(503);

var _atBrowserUtils = __webpack_require__(8);

var _EditActionButton = __webpack_require__(494);

var _EditActionButton2 = _interopRequireDefault(_EditActionButton);

var _constants = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ProjectPanelHeader = function (_TemplateView) {
    _inherits(ProjectPanelHeader, _TemplateView);

    function ProjectPanelHeader($containerEl, $panel) {
        _classCallCheck(this, ProjectPanelHeader);

        var _this = _possibleConstructorReturn(this, (ProjectPanelHeader.__proto__ || Object.getPrototypeOf(ProjectPanelHeader)).call(this, $containerEl));

        _this.$panel = $panel;

        _this.state = {
            projectName: '',
            customerName: '',
            readOnly: false,
            blockedDueToLockedTime: false,
            blockedDueToUnavailableToModifyTimeTrack: false,
            canManageAllUsersWithoutAutoApproved: false
        };

        _this.onStateChanged(function () {
            return _this.updateView();
        });
        return _this;
    }

    _createClass(ProjectPanelHeader, [{
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='editProjectPanelHeader'>" + "  <div class='cpInfo'>" + "    <span class='customerName ellipsis'/><img src='<%=separatorArrow%>' class='separator'/>" + "  </div>" + "  <div class='projectNamePlaceholder'/>" + "  <div class='actions'></div>" + "  <div class='tabs'>" + "    <div class='details'><span class='tabText'><%=detailsTab%></span></div>" + "    <div class='assignedUsers'><span class='tabText'><%=assignedUsersTab%></span></div>" + "    <div class='managers'><span class='tabText'><%=managersTab%></span></div>" + "    <div class='budgets'><span class='tabText'><%=budgetsTab%></span></div>" + "  </div>" + "</div>";
        }
    }, {
        key: "shouldUpdateOnInit",
        value: function shouldUpdateOnInit() {
            return false;
        }
    }, {
        key: "messageKeys",
        value: function messageKeys() {
            return {
                detailsTab: "project.edit_panel.tabs.details",
                assignedUsersTab: 'project.edit_panel.tabs.assigned_users',
                managersTab: 'project.edit_panel.tabs.managers',
                budgetsTab: 'project.edit_panel.tabs.budgets'
            };
        }
    }, {
        key: "templateModel",
        value: function templateModel() {
            return {
                separatorArrow: (0, _atBrowserUtils.atImgPath)('taskManagement/arrow.png')
            };
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            var _this2 = this;

            this.$projectName = this.find('.projectName');
            this.$customerName = this.find('.customerName');
            this.$tabs = [];
            this.$tabs[_ProjectPanel.ProjectPanelTabs.DETAILS_TAB] = this.find('.details');
            this.$tabs[_ProjectPanel.ProjectPanelTabs.ASSIGNED_USERS_TAB] = this.find('.assignedUsers');
            this.$tabs[_ProjectPanel.ProjectPanelTabs.MANAGERS_TAB] = this.find('.managers');
            this.$tabs[_ProjectPanel.ProjectPanelTabs.BUDGETS] = this.find('.budgets');

            this.nameInput = new _NameInput2.default({
                editable: true,
                placeholder: _messageResource2.default.getMessage('project.common.projectNamePlaceholder'),
                maxLength: _constants.EntityTextLimits.MAX_CPT_NAME,
                onChangeCb: function onChangeCb(name) {
                    if (name !== _this2.state.projectName && name) {
                        _this2.nameInput.trigger('change', name);
                    }
                    _this2.nameInput.setState({
                        name: name,
                        invalid: !name,
                        focus: !name
                    });
                }
            }).init(this.$containerEl.find('.projectNamePlaceholder'));
            this.actions = new _EditActionButton2.default({
                panelEl: this.$panel,
                headerEl: this.$containerEl,
                needMove: true,
                needCopy: true,
                needDelete: true
            }).init(this.find(".actions"));
            this.$assignedUsersCount = this.find('.assignedUsersCount');

            this.$assignedUsersTabTitle = this.find(".assignedUsers .tabText");
            this.$managersTabTitle = this.find(".managers .tabText");
        }
    }, {
        key: "updateView",
        value: function updateView() {
            this.nameInput.setEditable(!this.state.readOnly);
            this.nameInput.resetName(this.state.projectName);
            this.actions.disableDeleteButton(this.disableDeleteButtonText(this.state.blockedDueToLockedTime, this.state.blockedDueToUnavailableToModifyTimeTrack, this.state.canManageAllUsersWithoutAutoApproved));
            this.$customerName.text(this.state.customerName);
            this.actions.toggle(!this.state.readOnly);
        }
    }, {
        key: "disableDeleteButtonText",
        value: function disableDeleteButtonText(blockedDueToLockedTime, blockedDueToUnavailableToModifyTimeTrack, canManageAllUsersWithoutAutoApproved) {
            var disableText = null;
            if (blockedDueToLockedTime) {
                disableText = _messageResource2.default.getMessage("project.edit.cannot_delete_due_to_lock_time");
            } else if (blockedDueToUnavailableToModifyTimeTrack) {
                var projectText = _messageResource2.default.getMessage("common.project");
                disableText = _messageResource2.default.getMessage(canManageAllUsersWithoutAutoApproved ? "hierarchy_entity.edit_popup.cannot_delete_due_to_unavailable_modify_time_of_autoapproved_users" : "hierarchy_entity.edit_popup.cannot_delete_due_to_unavailable_modify_time", [projectText]);
            }
            return disableText;
        }
    }, {
        key: "onDependantDataUpdate",
        value: function onDependantDataUpdate(event) {
            if (event.type == 'assignmentsUpdated') {
                this.$assignedUsersCount.text(event['assignedUsersNumber']);
            }
        }
    }]);

    return ProjectPanelHeader;
}(_TemplateView3.default);

exports.default = ProjectPanelHeader;

/***/ }),
/* 1398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _ProjectPanelDetails = __webpack_require__(1399);

var _ProjectPanelDetails2 = _interopRequireDefault(_ProjectPanelDetails);

var _CommentsSection = __webpack_require__(1404);

var _CommentsSection2 = _interopRequireDefault(_CommentsSection);

var _Description = __webpack_require__(290);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ProjectPanelContent = function (_TemplateView) {
    _inherits(ProjectPanelContent, _TemplateView);

    function ProjectPanelContent(_ref) {
        var _ref$updateDescriptio = _ref.updateDescription,
            updateDescription = _ref$updateDescriptio === undefined ? function () {} : _ref$updateDescriptio,
            _ref$refreshScrollCb = _ref.refreshScrollCb,
            refreshScrollCb = _ref$refreshScrollCb === undefined ? function () {} : _ref$refreshScrollCb,
            _ref$scrollToElementC = _ref.scrollToElementCb,
            scrollToElementCb = _ref$scrollToElementC === undefined ? function () {} : _ref$scrollToElementC;

        _classCallCheck(this, ProjectPanelContent);

        var _this = _possibleConstructorReturn(this, (ProjectPanelContent.__proto__ || Object.getPrototypeOf(ProjectPanelContent)).call(this));

        _this.state = {
            readOnly: false,
            description: "",
            active: false,
            projectSpentTimeValues: null,
            workflowStatuses: [],
            canReopenProject: false
        };

        _this.callbacks = {
            updateDescription: updateDescription,
            scrollToElementCb: scrollToElementCb,
            refreshScrollCb: refreshScrollCb
        };

        _this.onStateChanged(function () {
            return _this.updateView();
        });
        return _this;
    }

    _createClass(ProjectPanelContent, [{
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='tab detailsTab'>" + "  <div class='details section'/>" + "  <div class='description section'>" + "    <div class='title'><%=description%></div>" + "    <div class='descriptionArea'></div>" + "  </div>" + "  <div class='commentsSectionPlaceholder'></div>" + "</div>";
        }
    }, {
        key: "shouldUpdateOnInit",
        value: function shouldUpdateOnInit() {
            return false;
        }
    }, {
        key: "messageKeys",
        value: function messageKeys() {
            return {
                description: "panel.common.description"
            };
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            this.$details = this.$containerEl.find(".details");
            this.details = new _ProjectPanelDetails2.default(this.$details).init();

            this.$description = this.$containerEl.find(".descriptionArea");
            this.description = new _Description.Description({
                onChange: this.callbacks.updateDescription
            }).init(this.$description);
            this.description.setState({
                placeholder: _messageResource2.default.getMessage('project.edit_panel.description.empty')
            });
            new _CommentsSection2.default({
                refreshScrollCb: this.callbacks.refreshScrollCb,
                scrollToElementCb: this.callbacks.scrollToElementCb
            }).init(this.find('.commentsSectionPlaceholder'));
        }
    }, {
        key: "updateView",
        value: function updateView() {
            this.details.setState({
                active: this.state.active,
                readOnly: this.state.readOnly,
                projectSpentTimeValues: this.state.projectSpentTimeValues,
                workflowStatuses: this.state.workflowStatuses,
                canReopenProject: this.state.canReopenProject
            });
            this.details.show();

            this.description.setState({
                text: this.state.description,
                editable: !this.state.readOnly,
                placeholder: this.state.readOnly ? _messageResource2.default.getMessage('panel.common.description.no_description') : _messageResource2.default.getMessage('project.edit_panel.description.empty')
            });
        }
    }, {
        key: "updateLastAudit",
        value: function updateLastAudit(lastUpdateAudit) {
            this.details.setLastAudit(lastUpdateAudit);
        }
    }]);

    return ProjectPanelContent;
}(_TemplateView3.default);

exports.default = ProjectPanelContent;

/***/ }),
/* 1399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _AuditHistoryView = __webpack_require__(228);

var _AuditHistoryView2 = _interopRequireDefault(_AuditHistoryView);

var _CustomerStatusButton = __webpack_require__(780);

var _CustomerStatusButton2 = _interopRequireDefault(_CustomerStatusButton);

var _constants = __webpack_require__(23);

var _ProjectPanelTimeDetails = __webpack_require__(1401);

var _ProjectPanelTimeDetails2 = _interopRequireDefault(_ProjectPanelTimeDetails);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ProjectPanelDetails = function (_TemplateView) {
    _inherits(ProjectPanelDetails, _TemplateView);

    function ProjectPanelDetails($containerEl) {
        _classCallCheck(this, ProjectPanelDetails);

        var _this = _possibleConstructorReturn(this, (ProjectPanelDetails.__proto__ || Object.getPrototypeOf(ProjectPanelDetails)).call(this, $containerEl));

        _this.state = {
            active: false,
            readOnly: false,
            projectSpentTimeValues: null,
            workflowStatuses: [],
            canReopenProject: false
        };

        _this.onAnyStatePropertyChanged(['projectSpentTimeValues', 'workflowStatuses'], function () {
            _this.updateSpentTime();
        });

        _this.onStatePropertyChanged('canReopenProject', function () {
            _this.updateInactiveOpenStatus();
        });

        _this.onStatePropertyChanged('active', function () {
            _this.statusButton.setActive(_this.state.active);
        });

        _this.onStatePropertyChanged('readOnly', function () {
            _this.statusButton.setEditable(!_this.state.readOnly);
        });
        return _this;
    }

    _createClass(ProjectPanelDetails, [{
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='details'>" + "  <div class='auditHistoryPlaceholder'/>" + "  <div class='detailsColumn'>" + "    <div class='title'><%=details%></div>" + "    <div class='status'><%=status%></div>" + "    <div class='statusButton'></div>" + "  </div>" + "  <div class='timeDetails'></div>" + "</div>";
        }
    }, {
        key: "shouldUpdateOnInit",
        value: function shouldUpdateOnInit() {
            return false;
        }
    }, {
        key: "messageKeys",
        value: function messageKeys() {
            return {
                status: "common.status",
                details: "customer.edit_panel.details"
            };
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            this.auditHistory = new _AuditHistoryView2.default({
                extraClass: 'projectAudit'
            }).init(this.find('.auditHistoryPlaceholder'));
            var dateFormat = Date.convertSmartToExtDateFormat(window.SystemSettings.dateFormat).replace(/F/, "M");
            this.auditHistory.setDateFormat(dateFormat);

            this.statusButton = new _CustomerStatusButton2.default({
                editable: true
            }).init(this.find(".statusButton"));
            this.$timeDetails = this.find('.timeDetails');
            this.timeTable = new _ProjectPanelTimeDetails2.default().init(this.$timeDetails);

            this.updateInactiveOpenStatus();
        }
    }, {
        key: "updateSpentTime",
        value: function updateSpentTime() {
            if (this.state.projectSpentTimeValues) {
                this.timeTable.show();
                var totalOpenTime = this.state.projectSpentTimeValues.totalTime.map[_constants.WorkflowStatusType.OPEN];
                var totalCompletedTime = this.state.projectSpentTimeValues.totalTime.map[_constants.WorkflowStatusType.COMPLETED];
                var totalTime = totalOpenTime + totalCompletedTime;
                var showDetailedInfo = !!this.state.projectSpentTimeValues.timeByStatuses;
                var timeByStatuses = showDetailedInfo ? this.state.projectSpentTimeValues.timeByStatuses.map : null;
                this.timeTable.setState({
                    totalTime: totalTime,
                    totalOpenTime: totalOpenTime,
                    totalCompletedTime: totalCompletedTime,
                    statuses: this.state.workflowStatuses,
                    timeByStatuses: timeByStatuses,
                    showDetailedInfo: showDetailedInfo
                });
            } else {
                this.timeTable.hide();
            }
        }
    }, {
        key: "updateInactiveOpenStatus",
        value: function updateInactiveOpenStatus() {
            this.statusButton.setInactiveOpenStatus(!this.state.canReopenProject);
        }
    }, {
        key: "setProjectId",
        value: function setProjectId(projectId) {}
    }, {
        key: "hideSelectors",
        value: function hideSelectors() {
            this.statusButton.disableAndHide();
        }
    }, {
        key: "setSelectorsDisabled",
        value: function setSelectorsDisabled(disabled) {
            this.statusButton.setDisabled(disabled);
        }
    }, {
        key: "clearAuditHistory",
        value: function clearAuditHistory() {
            this.auditHistory.hide();
        }
    }, {
        key: "setAuditHistory",
        value: function setAuditHistory(createAction, lastUpdateAction) {
            this.auditHistory.setAuditActions(createAction, lastUpdateAction, []);
        }
    }, {
        key: "setLastAudit",
        value: function setLastAudit(lastUpdateAudit) {
            this.auditHistory.setLastAuditAction(lastUpdateAudit);
        }
    }, {
        key: "hideAuditHistoryMenu",
        value: function hideAuditHistoryMenu() {
            this.auditHistory.auditHistoryMenu.hide();
        }
    }, {
        key: "addAuditRecords",
        value: function addAuditRecords(auditRecords) {
            this.auditHistory.addRecords(auditRecords);
        }
    }, {
        key: "setAuditRecords",
        value: function setAuditRecords(auditRecords) {
            this.auditHistory.setRecords(auditRecords);
        }
    }]);

    return ProjectPanelDetails;
}(_TemplateView3.default);

exports.default = ProjectPanelDetails;

/***/ }),
/* 1400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _DropdownTemplateView2 = __webpack_require__(42);

var _DropdownTemplateView3 = _interopRequireDefault(_DropdownTemplateView2);

var _SimpleTooltip = __webpack_require__(36);

var _SimpleTooltip2 = _interopRequireDefault(_SimpleTooltip);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CustomerStatusMenu = function (_DropdownTemplateView) {
    _inherits(CustomerStatusMenu, _DropdownTemplateView);

    function CustomerStatusMenu() {
        _classCallCheck(this, CustomerStatusMenu);

        return _possibleConstructorReturn(this, (CustomerStatusMenu.__proto__ || Object.getPrototypeOf(CustomerStatusMenu)).apply(this, arguments));
    }

    _createClass(CustomerStatusMenu, [{
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='dropdownContainer customerStatusMenu'>" + "  <div class='activeStatus'>" + "    <div class='cover'></div>" + "    <div class='item activeContainer'>" + "        <div class='active'><%-active%></div>" + "    </div>" + "  </div>" + "  <div class='item archivedContainer'>" + "    <div class='archived'><%-archived%></div>" + "  </div>" + "</div>";
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            var self = this;
            this.$activeStatus = this.$el.find('.activeStatus');
            this.findAndBindClick(".activeContainer", function (e) {
                stopEventPropagation(e);
                self._itemClick(e, true);
            });
            this.findAndBindClick(".archivedContainer", function (e) {
                stopEventPropagation(e);
                self._itemClick(e, false);
            });

            var inactiveOpenStatusTooltip = this.inactiveOpenStatusTooltip();
            inactiveOpenStatusTooltip.subscribeToMouseEvents(this.$activeStatus);
        }
    }, {
        key: "update",
        value: function update() {
            this.$el.toggleClass("active", this.active);
            this.$el.toggleClass("archived", !this.active);
            this.$activeStatus.toggleClass('inactive', this.inactiveOpenStatus);
        }
    }, {
        key: "showAt",
        value: function showAt($element, positionParams, callback) {
            _get(CustomerStatusMenu.prototype.__proto__ || Object.getPrototypeOf(CustomerStatusMenu.prototype), "showAt", this).call(this, $element, positionParams);
            this.update();
            this.callback = callback;
        }
    }, {
        key: "messageKeys",
        value: function messageKeys() {
            return {
                active: "customer.edit.status.active",
                archived: "customer.edit.status.archived"
            };
        }
    }, {
        key: "onHide",
        value: function onHide() {
            _get(CustomerStatusMenu.prototype.__proto__ || Object.getPrototypeOf(CustomerStatusMenu.prototype), "onHide", this).call(this);
            this.callback(this.active);
        }
    }, {
        key: "isActive",
        value: function isActive() {
            return this.active;
        }
    }, {
        key: "setActive",
        value: function setActive(active) {
            this.active = active;
        }
    }, {
        key: "_itemClick",
        value: function _itemClick(e, active) {
            this.active = active;
            this.hide();
        }
    }, {
        key: "mouseDownTargetElement",
        value: function mouseDownTargetElement() {
            return (0, _jquery2.default)('body');
        }
    }, {
        key: "setInactiveOpenStatus",
        value: function setInactiveOpenStatus(inactiveOpenStatus) {
            this.inactiveOpenStatus = inactiveOpenStatus;
            this.inactiveOpenStatusTooltip().setEnabled(inactiveOpenStatus);
        }
    }, {
        key: "inactiveOpenStatusTooltip",
        value: function inactiveOpenStatusTooltip() {
            if (!CustomerStatusMenu.tooltip) {
                CustomerStatusMenu.tooltip = new _SimpleTooltip2.default({
                    text: _messageResource2.default.getMessage('task.list.tooltip.project.inactive_open_statuses'),
                    extraClass: 'workflowStatusList_inactiveOpenStatusesTooltip'
                }).init((0, _jquery2.default)('body'));
            }
            return CustomerStatusMenu.tooltip;
        }
    }]);

    return CustomerStatusMenu;
}(_DropdownTemplateView3.default);

exports.default = CustomerStatusMenu;

/***/ }),
/* 1401 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _WorkflowStatusTimeColumn = __webpack_require__(1402);

var _WorkflowStatusTimeColumn2 = _interopRequireDefault(_WorkflowStatusTimeColumn);

var _constants = __webpack_require__(23);

var _user_time = __webpack_require__(30);

var _user_time2 = _interopRequireDefault(_user_time);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ProjectPanelTimeDetails = function (_TemplateView) {
    _inherits(ProjectPanelTimeDetails, _TemplateView);

    function ProjectPanelTimeDetails() {
        _classCallCheck(this, ProjectPanelTimeDetails);

        var _this = _possibleConstructorReturn(this, (ProjectPanelTimeDetails.__proto__ || Object.getPrototypeOf(ProjectPanelTimeDetails)).call(this));

        _this.state = {
            totalTime: 0,
            totalOpenTime: 0,
            totalCompletedTime: 0,
            statuses: [],
            timeByStatuses: null,
            showDetailedInfo: false
        };

        _this.onStateChanged(function () {
            return _this.updateView();
        });
        return _this;
    }

    _createClass(ProjectPanelTimeDetails, [{
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='timeDetails'>" + "  <div class='totalSpent'>" + "    <div class='title'><%-title%></div>" + "    <div class='time'></div>" + "  </div>" + "  <div class='timeTable'>" + "    <div class='timeColumn open'></div>" + "    <div class='timeColumn completed'></div>" + "  </div>" + "</div>";
        }
    }, {
        key: "messageKeys",
        value: function messageKeys() {
            return {
                title: "project.edit_panel.total_spent_time"
            };
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            this.$totalTime = this.find(".totalSpent .time");

            this.$openColumn = this.find(".timeColumn.open");
            this.$completedColumn = this.find(".timeColumn.completed");
            this.openColumn = new _WorkflowStatusTimeColumn2.default().init(this.$openColumn);
            this.completedColumn = new _WorkflowStatusTimeColumn2.default().init(this.$completedColumn);
        }
    }, {
        key: "updateView",
        value: function updateView() {
            this.$totalTime.text(_user_time2.default.formatTimeWithDigitSeparator(this.state.totalTime));
            var openStatuses = [];
            var completedStatuses = [];
            var showOpenColumn = true;
            var showCompletedColumn = true;
            var openTaskTitle = "project.edit_panel.open_spent_time";
            var completedTaskTitle = "project.edit_panel.completed_spent_time";

            if (this.state.showDetailedInfo) {
                showCompletedColumn = this.state.totalCompletedTime > 0;
                showOpenColumn = this.state.totalOpenTime > 0;
                // TODO bakharev: add sorting by position
                openStatuses = this.state.statuses.filter(function (status) {
                    return status.type === _constants.WorkflowStatusType.OPEN;
                });
                completedStatuses = this.state.statuses.filter(function (status) {
                    return status.type === _constants.WorkflowStatusType.COMPLETED;
                });
                openTaskTitle = "workflow_list.open_tasks";
                completedTaskTitle = "workflow_list.completed_tasks";

                this.$openColumn.toggle(showOpenColumn);
                this.$completedColumn.toggle(showCompletedColumn);
            }
            this.openColumn.setState({
                title: _messageResource2.default.getMessage(openTaskTitle),
                statuses: openStatuses,
                time: this.state.timeByStatuses,
                totalTime: this.state.totalOpenTime
            });
            this.completedColumn.setState({
                title: _messageResource2.default.getMessage(completedTaskTitle),
                statuses: completedStatuses,
                time: this.state.timeByStatuses,
                totalTime: this.state.totalCompletedTime
            });

            this.$el.toggleClass("shortInfo", !this.state.showDetailedInfo);
            this.$el.toggleClass("detailedInfo", this.state.showDetailedInfo);
        }
    }]);

    return ProjectPanelTimeDetails;
}(_TemplateView3.default);

exports.default = ProjectPanelTimeDetails;

/***/ }),
/* 1402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _user_time = __webpack_require__(30);

var _user_time2 = _interopRequireDefault(_user_time);

var _WorkflowStatusTimeRow = __webpack_require__(1403);

var _WorkflowStatusTimeRow2 = _interopRequireDefault(_WorkflowStatusTimeRow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var WorkflowStatusTimeColumn = function (_TemplateView) {
    _inherits(WorkflowStatusTimeColumn, _TemplateView);

    function WorkflowStatusTimeColumn() {
        _classCallCheck(this, WorkflowStatusTimeColumn);

        var _this = _possibleConstructorReturn(this, (WorkflowStatusTimeColumn.__proto__ || Object.getPrototypeOf(WorkflowStatusTimeColumn)).call(this));

        _this.state = {
            statuses: [],
            time: {},
            totalTime: 0,
            title: ""
        };

        _this.onStateChanged(function () {
            return _this.updateView();
        });
        return _this;
    }

    _createClass(WorkflowStatusTimeColumn, [{
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='workflowTimeColumn'>" + "  <div class='totalRow'>" + "    <div class='title'></div>" + "    <div class='time'></div>" + "  </div>" + "  <div class='rowsContainer'></div>" + "</div>";
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            this.$rowsContainer = this.find(".rowsContainer");
            this.$totalTitle = this.find(".totalRow .title");
            this.$totalTime = this.find(".totalRow .time");
        }
    }, {
        key: "updateView",
        value: function updateView() {
            this.$totalTitle.text(this.state.title);
            this.$totalTime.text(_user_time2.default.formatTimeWithDigitSeparator(this.state.totalTime));
            this.createRows();
        }
    }, {
        key: "createRows",
        value: function createRows() {
            this.$rowsContainer.empty();
            for (var i = 0; i < this.state.statuses.length; ++i) {
                var status = this.state.statuses[i];
                var time = this.state.time[status.id];
                if (!_.isUndefined(time)) {
                    this.$rowsContainer.append("<div class='row status" + status.id + "'></div>");
                    new _WorkflowStatusTimeRow2.default({
                        statusName: status.name,
                        statusType: status.type,
                        statusColorId: status.colorId,
                        time: time
                    }).init(this.find(".rowsContainer .status" + status.id));
                }
            }
        }
    }]);

    return WorkflowStatusTimeColumn;
}(_TemplateView3.default);

exports.default = WorkflowStatusTimeColumn;

/***/ }),
/* 1403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _WorkflowStatus = __webpack_require__(360);

var _WorkflowStatus2 = _interopRequireDefault(_WorkflowStatus);

var _user_time = __webpack_require__(30);

var _user_time2 = _interopRequireDefault(_user_time);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var WorkflowStatusTimeRow = function (_TemplateView) {
    _inherits(WorkflowStatusTimeRow, _TemplateView);

    function WorkflowStatusTimeRow(_ref) {
        var statusName = _ref.statusName,
            statusType = _ref.statusType,
            statusColorId = _ref.statusColorId,
            time = _ref.time;

        _classCallCheck(this, WorkflowStatusTimeRow);

        var _this = _possibleConstructorReturn(this, (WorkflowStatusTimeRow.__proto__ || Object.getPrototypeOf(WorkflowStatusTimeRow)).call(this));

        _this.params = {
            statusName: statusName,
            statusType: statusType,
            statusColorId: statusColorId,
            time: time
        };
        return _this;
    }

    _createClass(WorkflowStatusTimeRow, [{
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='totalSpent'>" + "  <div class='workflowStatusDescription'></div>" + "  <div class='workflowStatusTime'></div>" + "</div>";
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            this.$workflowStatus = this.find(".workflowStatusDescription");
            this.$time = this.find(".workflowStatusTime");
            new _WorkflowStatus2.default({
                name: this.params.statusName,
                type: this.params.statusType,
                colorId: this.params.statusColorId
            }).init(this.$workflowStatus);

            this.$time.text(_user_time2.default.formatTimeWithDigitSeparator(this.params.time));
        }
    }]);

    return WorkflowStatusTimeRow;
}(_TemplateView3.default);

exports.default = WorkflowStatusTimeRow;

/***/ }),
/* 1404 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _redux = __webpack_require__(7);

var _utils = __webpack_require__(6);

var _selectors = __webpack_require__(244);

var _selectors2 = __webpack_require__(19);

var _actions = __webpack_require__(141);

var _CommentsSection = __webpack_require__(487);

var _CommentsSection2 = _interopRequireDefault(_CommentsSection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _utils.connect)(function (state) {
    return {
        comments: (0, _selectors.getComments)(state),
        users: (0, _selectors.getUsers)(state),
        commentsCount: (0, _selectors.getCommentsCount)(state),
        allCommentsUserIds: (0, _selectors.getAllCommentsUserIds)(state),
        loggedInUser: (0, _selectors2.getLoggedInUser)(state),
        isNewCommentsOnTop: (0, _selectors.isNewCommentsOnTop)(state),
        recentlyAddedCommentsIds: (0, _selectors.getRecentlyAddedCommentsIds)(state),
        commentsScrollTo: (0, _selectors.getCommentsScrollTo)(state),
        editingCommentId: (0, _selectors.getEditingCommentId)(state),
        editingCommentText: (0, _selectors.getEditingCommentText)(state),
        loading: (0, _selectors.isCommentsLoading)(state),
        sendingComment: (0, _selectors.isSendingComment)(state),
        updatingCommentId: (0, _selectors.getUpdatingCommentId)(state),
        readOnly: (0, _selectors.isCommentsReadOnly)(state),
        canManage: (0, _selectors.canManage)(state)
    };
}, function (dispatch) {
    return {
        loadMoreComments: (0, _redux.bindActionCreators)(_actions.commentsServiceActions.loadMoreComments, dispatch),
        saveComment: (0, _redux.bindActionCreators)(_actions.commentsServiceActions.saveComment, dispatch),
        deleteComment: (0, _redux.bindActionCreators)(_actions.commentsServiceActions.deleteComment, dispatch),
        changeCommentsOrder: (0, _redux.bindActionCreators)(_actions.commentsActions.changeCommentsOrder, dispatch),
        resetCommentsScrollTo: (0, _redux.bindActionCreators)(_actions.commentsActions.resetCommentsScrollTo, dispatch),
        startEditComment: (0, _redux.bindActionCreators)(_actions.commentsServiceActions.startEditComment, dispatch),
        cancelEditComment: (0, _redux.bindActionCreators)(_actions.commentsActions.cancelEditComment, dispatch),
        updateEditingCommentText: (0, _redux.bindActionCreators)(_actions.commentsActions.updateEditingCommentText, dispatch),
        saveEditingComment: (0, _redux.bindActionCreators)(_actions.commentsServiceActions.saveEditingComment, dispatch)
    };
})(_CommentsSection2.default);

/***/ }),
/* 1405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _DeleteConfirmationDialog = __webpack_require__(499);

var _DeleteConfirmationDialog2 = _interopRequireDefault(_DeleteConfirmationDialog);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DeleteProjectPopupConfirmationDialog = function (_DeleteConfirmationDi) {
    _inherits(DeleteProjectPopupConfirmationDialog, _DeleteConfirmationDi);

    function DeleteProjectPopupConfirmationDialog($container, cancelHandler, deleteHandler) {
        _classCallCheck(this, DeleteProjectPopupConfirmationDialog);

        return _possibleConstructorReturn(this, (DeleteProjectPopupConfirmationDialog.__proto__ || Object.getPrototypeOf(DeleteProjectPopupConfirmationDialog)).call(this, $container, cancelHandler, deleteHandler));
    }

    _createClass(DeleteProjectPopupConfirmationDialog, [{
        key: "titleText",
        value: function titleText() {
            return _messageResource2.default.getMessage("delete.confirm.dialog.cp.popup.project", [this.state.entityName]);
        }
    }, {
        key: "firstOrangeSentence",
        value: function firstOrangeSentence() {
            return _messageResource2.default.getMessage("delete.confirm.dialog.cp.popup.first_orange_sentence", [_messageResource2.default.getMessage("common.Project")]);
        }
    }, {
        key: "secondOrangeSentence",
        value: function secondOrangeSentence() {
            return _messageResource2.default.getMessage(this.hasTimeTrack() ? "delete.confirm.dialog.cp.second_orange_sentence.please_confirm_actions" : "delete.confirm.dialog.cp.second_orange_sentence.please_confirm");
        }
    }, {
        key: "removeEntitiesPointText",
        value: function removeEntitiesPointText() {
            var pronoun = _messageResource2.default.getMessage("delete.confirm.dialog.its");
            return _messageResource2.default.getMessage("delete.confirm.dialog.cp.popup.remove_entities_point_text", [_messageResource2.default.getMessage("common.project"), pronoun]);
        }
    }, {
        key: "removeTimeTrackPointText",
        value: function removeTimeTrackPointText() {
            return _messageResource2.default.getMessage("delete.confirm.dialog.cp.remove_time_track_point_text");
        }
    }, {
        key: "deleteButtonText",
        value: function deleteButtonText() {
            if (this.hasTimeTrack()) return _messageResource2.default.getMessage("delete.confirm.dialog.delete_task_with_entries");else return _messageResource2.default.getMessage("delete.confirm.dialog.cp.delete_button_text.no_tt");
        }
    }]);

    return DeleteProjectPopupConfirmationDialog;
}(_DeleteConfirmationDialog2.default);

exports.default = DeleteProjectPopupConfirmationDialog;

/***/ }),
/* 1406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _ArchiveDialog2 = __webpack_require__(781);

var _ArchiveDialog3 = _interopRequireDefault(_ArchiveDialog2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ArchiveProjectDialog = function (_ArchiveDialog) {
    _inherits(ArchiveProjectDialog, _ArchiveDialog);

    function ArchiveProjectDialog($container) {
        _classCallCheck(this, ArchiveProjectDialog);

        return _possibleConstructorReturn(this, (ArchiveProjectDialog.__proto__ || Object.getPrototypeOf(ArchiveProjectDialog)).call(this, $container, _messageResource2.default.getMessage("common.project")));
    }

    return ArchiveProjectDialog;
}(_ArchiveDialog3.default);

exports.default = ArchiveProjectDialog;

/***/ }),
/* 1407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _TaskPanel = __webpack_require__(483);

var _TaskPanel2 = _interopRequireDefault(_TaskPanel);

var _utils = __webpack_require__(6);

var _selectors = __webpack_require__(97);

var _actions = __webpack_require__(81);

var _redux = __webpack_require__(7);

var _selectors2 = __webpack_require__(19);

var _selectors3 = __webpack_require__(15);

var _selectors4 = __webpack_require__(14);

var _selectors5 = __webpack_require__(27);

var _actions2 = __webpack_require__(56);

var _selectors6 = __webpack_require__(57);

var _selectors7 = __webpack_require__(504);

var _selectors8 = __webpack_require__(190);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _utils.connect)(function (state) {
    return {
        loggedInUser: (0, _selectors2.getLoggedInUser)(state),
        sendingComment: (0, _selectors.isSendingComment)(state),
        showNewCommentInput: (0, _selectors.isShowNewCommentInput)(state),
        newCommentText: (0, _selectors.getTaskNewComment)(state),

        canEdit: (0, _selectors.isEditTaskPanelEditable)(state),
        canEditHierarchy: (0, _selectors2.canEditHierarchy)(state),
        openTaskId: (0, _selectors.getOpenTaskId)(state),
        openTaskNextId: (0, _selectors.getOpenTaskNextId)(state),
        name: (0, _selectors.getTaskName)(state),
        completed: (0, _selectors.isTaskCompleted)(state),
        workflowStatusId: (0, _selectors.getTaskStatusId)(state),
        deadline: (0, _selectors.getTaskDeadline)(state),
        typeOfWork: (0, _selectors.getBillingType)(state),
        typesOfWork: (0, _selectors7.getSortedTypeOfWorkList)(state),
        estimatedTime: (0, _selectors.getEstimatedTime)(state),
        spentTime: (0, _selectors.getSpentTime)(state),
        description: (0, _selectors.getTaskDescription)(state),
        commentsCount: (0, _selectors.getCommentsCount)(state),

        projectName: (0, _selectors.getProjectName)(state),
        customerName: (0, _selectors.getCustomerName)(state),
        customer: (0, _selectors.getCustomerFromTask)(state),

        nameUpdating: (0, _selectors.isNameUpdating)(state),
        deadlineUpdating: (0, _selectors.isDeadlineUpdating)(state),
        typeOfWorkUpdating: (0, _selectors.isTypeOfWorkUpdating)(state),
        estimateUpdating: (0, _selectors.isEstimateUpdating)(state),
        descriptionUpdating: (0, _selectors.isDescriptionUpdating)(state),
        statusUpdating: (0, _selectors.isStatusUpdating)(state),
        moveToDialogLoading: (0, _selectors.isMoveToDialogLoading)(state),

        errors: (0, _selectors.getTaskPanelErrors)(state),

        isBTYEnabled: (0, _selectors3.isBTYEnabled)(state),
        isURAEnabled: (0, _selectors3.isURAEnabled)(state),
        isBRAEnabled: (0, _selectors3.isBRAEnabled)(state),
        isTWSEnabled: (0, _selectors3.isTWSEnabled)(state),
        isESTEnabled: (0, _selectors3.isESTEnabled)(state),
        isWASEnabled: (0, _selectors3.isWASEnabled)(state),
        isTTAEnabled: (0, _selectors3.isTTAEnabled)(state),
        isCPTBUDEnabled: (0, _selectors3.isCPTBUDEnabled)(state),

        assignedUsers: (0, _selectors.getAssignedUsers)(state),
        assignedManagers: (0, _selectors.getAssignedManagers)(state),
        userGroupsEnabled: (0, _selectors3.isUGREnabled)(state),
        timeZoneGroupsEnabled: (0, _selectors3.isTZGEnabled)(state),
        userGroups: (0, _selectors4.getUserGroups)(state),
        timeZoneGroups: (0, _selectors4.getTimeZoneGroups)(state),
        canModifyAnyUser: (0, _selectors.canModifyAnyUser)(state),
        canModifyAnyManager: (0, _selectors.canModifyAnyManager)(state),
        canEditTaskStatus: (0, _selectors5.canViewerEditTaskStatus)(state),
        canGenerateMoneyReports: (0, _selectors2.canGenerateMoneyReports)(state),

        taskDetails: (0, _selectors.getTaskDetails)(state),
        taskDeletedSuccessfully: (0, _selectors.isTaskDeletedSuccessfully)(state),
        taskDeletedUnsuccessfully: (0, _selectors.isTaskDeletedUnsuccessfully)(state),

        copyMoveSelectorsCustomerIds: (0, _selectors5.getCustomerIdsWhereCanManageLeastOneProject)(state),
        copyMoveSelectorsProjectIds: (0, _selectors5.getEditableProjectIdsWithExcludeSelf)(state),
        editableCustomersIds: (0, _selectors5.getEditableCustomerIds)(state),
        editableProjectsIds: (0, _selectors5.getEditableProjectIds)(state),

        auditActions: (0, _selectors.getAuditActions)(state),
        lastAuditActions: (0, _selectors.getLastAuditActions)(state),
        allAuditHistoryLoaded: (0, _selectors.isAllAuditHistoryLoaded)(state),

        canReopenProject: (0, _selectors.canReopenProject)(state),
        canMoveTask: (0, _selectors.canMoveTask)(state),
        isTaskAssigned: (0, _selectors.isTaskManageable)(state),
        canManageAccountsAndPermissions: (0, _selectors2.canManageAccountsAndPermissions)(state),
        hasManageScopeRights: (0, _selectors2.hasManageScopeRights)(state),
        executorsSummary: (0, _selectors.getTaskExecutorsSummary)(state),
        reportedTimeComments: (0, _selectors.getReportedTimeComments)(state),
        allTimeCommentsLoaded: (0, _selectors.isAllTimeCommentsLoaded)(state),
        timeAndCommentsLoading: (0, _selectors.isTimeAndCommentsLoading)(state),
        sortingSettings: (0, _selectors.getSortingSettings)(state),

        currentTabKey: (0, _selectors.getTaskPanelTabKey)(state),
        lastSelectedTabKey: (0, _selectors.getLastTaskPanelTabKey)(state),

        defaultCompletedStatus: (0, _selectors6.getFirstCompletedWorkflowStatus)(state),

        hasSomeTeamAssignment: (0, _selectors2.canAccessSomeTeamAssignment)(state),

        customFields: (0, _selectors8.selectTaskCustomFields)(state),
        customFieldsValues: (0, _selectors.getTaskCustomFieldsValues)(state),
        readonlyFields: (0, _selectors.getReadOnlyFields)(state)
    };
}, function (dispatch) {
    return _extends({
        saveComment: (0, _redux.bindActionCreators)(_actions.saveComment, dispatch),
        saveEditingComment: (0, _redux.bindActionCreators)(_actions.saveEditingComment, dispatch),
        toggleNewCommentInput: (0, _redux.bindActionCreators)(_actions.toggleNewCommentInput, dispatch),
        updateNewCommentText: (0, _redux.bindActionCreators)(_actions.updateNewCommentText, dispatch),
        reloadComments: (0, _redux.bindActionCreators)(_actions.reloadComments, dispatch),
        deleteAssignedUser: (0, _redux.bindActionCreators)(_actions.deleteAssignedUser, dispatch),
        updateAssignedUsers: (0, _redux.bindActionCreators)(_actions.updateAssignedUsers, dispatch),
        deleteAssignedManager: (0, _redux.bindActionCreators)(_actions.deleteAssignedManager, dispatch),
        updateAssignedManagers: (0, _redux.bindActionCreators)(_actions.updateAssignedManagers, dispatch),
        deleteTask: (0, _redux.bindActionCreators)(_actions.deleteTask, dispatch),
        resetDeletionStatus: (0, _redux.bindActionCreators)(_actions.resetDeletionStatus, dispatch),
        moveTask: (0, _redux.bindActionCreators)(_actions.moveTask, dispatch),
        copyTask: (0, _redux.bindActionCreators)(_actions.copyTask, dispatch),
        loadTaskAuditHistory: (0, _redux.bindActionCreators)(_actions.loadTaskAuditHistory, dispatch),
        setTaskPanelTab: (0, _redux.bindActionCreators)(_actions.setTaskPanelTab, dispatch),
        setLastTaskPanelTab: (0, _redux.bindActionCreators)(_actions.setLastTaskPanelTab, dispatch),
        openLastTaskPanelTab: (0, _redux.bindActionCreators)(_actions.openLastTaskPanelTab, dispatch),
        loadTimeComments: (0, _redux.bindActionCreators)(_actions.loadTimeComments, dispatch),
        saveSortingSettings: (0, _redux.bindActionCreators)(_actions.saveSortingSettings, dispatch),
        toast: (0, _redux.bindActionCreators)(_actions2.toast, dispatch)
    }, (0, _redux.bindActionCreators)({
        updateStatus: _actions.updateStatus,
        updateName: _actions.updateName,
        updateDeadline: _actions.updateDeadline,
        updateTypeOfWork: _actions.updateTypeOfWork,
        updateEstimate: _actions.updateEstimate,
        updateDescription: _actions.updateDescription,
        updateCustomField: _actions.updateCustomField
    }, dispatch));
})(_TaskPanel2.default);

/***/ }),
/* 1408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _LightBox2 = __webpack_require__(196);

var _LightBox3 = _interopRequireDefault(_LightBox2);

var _CreateTasksLightboxHeader = __webpack_require__(1410);

var _CreateTasksLightboxHeader2 = _interopRequireDefault(_CreateTasksLightboxHeader);

var _CreateTaskLightboxContent = __webpack_require__(1411);

var _CreateTaskLightboxContent2 = _interopRequireDefault(_CreateTaskLightboxContent);

var _CreateTasksLightboxFooter = __webpack_require__(1415);

var _CreateTasksLightboxFooter2 = _interopRequireDefault(_CreateTasksLightboxFooter);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NO_TASKS_FOR_CREATE_ERROR_MSG = 'add_new_tasks.there_are_no_tasks_to_create';
var INVALID_TASK_FIELDS_ERROR_MSG = 'add_new_tasks.js.footer_error.invalid_fields_exist';

var CreateTasksLightbox = function (_LightBox) {
    _inherits(CreateTasksLightbox, _LightBox);

    function CreateTasksLightbox(serviceName) {
        var contentData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var _ref = arguments[2];
        var successTaskCreationCallback = _ref.successTaskCreationCallback,
            submitTaskCreationCallback = _ref.submitTaskCreationCallback;

        _classCallCheck(this, CreateTasksLightbox);

        var _this = _possibleConstructorReturn(this, (CreateTasksLightbox.__proto__ || Object.getPrototypeOf(CreateTasksLightbox)).call(this));

        _this.params = {
            contentData: contentData,
            submitTaskCreationCallback: submitTaskCreationCallback,
            successTaskCreationCallback: successTaskCreationCallback,
            serviceName: serviceName
        };

        _this.cancel_confirmation_message_key = "add_new_tasks.js.cancel_confirmation";
        _this.close_tab_confirmation_message_key = "add_new_tasks.exit_confirmation";
        _this.exist_invalid_fields_message_key = "add_new_tasks.js.footer_error.invalid_fields_exist";

        _this._changesCallback = function () {
            _this.getWrapper().update();
            _this.dataChanged = true;
            _this.updateErrors(true);
        };
        return _this;
    }

    _createClass(CreateTasksLightbox, [{
        key: 'init',
        value: function init() {
            var _this2 = this;

            var header = new _CreateTasksLightboxHeader2.default();
            var footer = new _CreateTasksLightboxFooter2.default();
            var content = new _CreateTaskLightboxContent2.default(this.params.contentData, {
                onChangedDataCb: this._changesCallback,
                validationCb: this._validateCallback,
                getScrollPositionCallback: function getScrollPositionCallback() {
                    return _this2.getScrollPosition();
                },
                refreshScrollCb: function refreshScrollCb() {
                    return _this2.refreshScroll();
                }
            });

            _get(CreateTasksLightbox.prototype.__proto__ || Object.getPrototypeOf(CreateTasksLightbox.prototype), 'init', this).call(this, {
                id: 'createTasksPopup', // do not delete
                header: header,
                content: content,
                footer: footer,
                classNames: 'taskProjectOrCustomerLightbox lightboxWithWhiteContent',
                correctionOffset: 60
            });

            if (this.params.submitTaskCreationCallback) {
                this.setSuccessCallback(function () {
                    _this2.params.submitTaskCreationCallback(function () {
                        return _this2.onSubmit();
                    }, function () {});
                });
            } else {
                this.setSuccessCallback(function () {
                    return _this2.onSubmit();
                });
            }

            return this;
        }
    }, {
        key: 'onSubmit',
        value: function onSubmit() {
            var _this3 = this;

            this.disableUserInputWhileSaving();
            this.components.content.sendCreateTasksRequest(this.params.serviceName).then(function (result) {
                _this3.enableUserInputWhileSaving();

                if (!result.taskError && !result.billingTypeError && !result.containsCustomerProjectListError) {
                    if (_this3.params.successTaskCreationCallback) {
                        _this3.hide();
                        _this3.params.successTaskCreationCallback(result);
                    } else {
                        document.location.reload();
                    }
                }

                if (result.customerProjectError || result.taskError) {
                    _this3.printErrorInFooter(_messageResource2.default.getMessage(INVALID_TASK_FIELDS_ERROR_MSG));
                }

                if (result.customerProjectError) _this3.scrollToCustomerProjectSelector();
                if (result.taskError) _this3.scrollToFirstTaskWithError();
            }).catch(function (result) {
                _this3.enableUserInputWhileSaving();
            });
        }
    }, {
        key: 'commit',
        value: function commit() {
            if (this.getContent().getTaskComponent().hideDescriptionPopup(true)) _get(CreateTasksLightbox.prototype.__proto__ || Object.getPrototypeOf(CreateTasksLightbox.prototype), 'commit', this).call(this, this);
        }
    }, {
        key: 'getDataToCommit',
        value: function getDataToCommit() {
            return this.getContent().getData();
        }
    }, {
        key: 'hide',
        value: function hide() {
            this.getContent().getTaskComponent().hideDescriptionPopup();
            this.getContent().getTaskComponent().restoreGetOnPageDescriptionFunction();
            _get(CreateTasksLightbox.prototype.__proto__ || Object.getPrototypeOf(CreateTasksLightbox.prototype), 'hide', this).call(this);
        }
    }, {
        key: 'scrollToCustomerProjectSelector',
        value: function scrollToCustomerProjectSelector() {
            this.getWrapper().scrollToSection(this.getContent().getCustomerProjectSelectorSection());
        }
    }, {
        key: 'scrollToTasksTable',
        value: function scrollToTasksTable() {
            this.getWrapper().scrollToSection(this.getContent().getImportTasksContainer());
        }
    }, {
        key: 'scrollToFirstTaskWithError',
        value: function scrollToFirstTaskWithError() {
            // TODO replace with find task with error
            /*var taskWithErr = this.popupEl.find(".createTasksTable .nameCell .error");
            if (taskWithErr.get(0))
                this.getWrapper().scrollToSection(taskWithErr);
            else*/
            this.scrollToTasksTable();
        }
    }, {
        key: 'hasErrors',
        value: function hasErrors() {
            return this.getContent().hasErrors();
        }
    }, {
        key: 'validate',
        value: function validate() {
            var errorMsgKey = INVALID_TASK_FIELDS_ERROR_MSG;

            if (this.getContent().validateCustomerProjectSelector()) {
                if (this.getContent().validateTasksTableComponent()) {
                    return true;
                }

                if (this.getContent().isTaskTableComponentEmpty()) {
                    errorMsgKey = NO_TASKS_FOR_CREATE_ERROR_MSG;
                    this.scrollToTasksTable();
                } else {
                    this.scrollToFirstTaskWithError();
                }
            } else this.scrollToCustomerProjectSelector();

            this.printErrorInFooter(_messageResource2.default.getMessage(errorMsgKey));
            this._blinkErrorInFooter();
            return false;
        }
    }]);

    return CreateTasksLightbox;
}(_LightBox3.default);

exports.default = CreateTasksLightbox;

/***/ }),
/* 1409 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _ScrollableContainer = __webpack_require__(49);

var _ScrollableContainer2 = _interopRequireDefault(_ScrollableContainer);

var _ScrollUtils = __webpack_require__(39);

var _ScrollUtils2 = _interopRequireDefault(_ScrollUtils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LightBoxWrapper = function (_TemplateView) {
    _inherits(LightBoxWrapper, _TemplateView);

    function LightBoxWrapper() {
        var $el = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _jquery2.default)('body');
        var _ref = arguments[1];
        var _ref$id = _ref.id,
            id = _ref$id === undefined ? '' : _ref$id,
            _ref$header = _ref.header,
            header = _ref$header === undefined ? null : _ref$header,
            _ref$content = _ref.content,
            content = _ref$content === undefined ? null : _ref$content,
            _ref$footer = _ref.footer,
            footer = _ref$footer === undefined ? null : _ref$footer,
            _ref$classNames = _ref.classNames,
            classNames = _ref$classNames === undefined ? '' : _ref$classNames,
            _ref$correctionOffset = _ref.correctionOffset,
            correctionOffset = _ref$correctionOffset === undefined ? 0 : _ref$correctionOffset;

        _classCallCheck(this, LightBoxWrapper);

        var _this = _possibleConstructorReturn(this, (LightBoxWrapper.__proto__ || Object.getPrototypeOf(LightBoxWrapper)).call(this, $el));

        _initialiseProps.call(_this);

        _this.params = {
            id: id,
            header: header,
            content: content,
            footer: footer,
            classNames: classNames,
            correctionOffset: correctionOffset
        };
        return _this;
    }

    _createClass(LightBoxWrapper, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div id="<%=id%>" class="lightbox <%=additionalClasses%>" style="display:none">' + '    <div id="<%=id%>_content" class="content"></div>' + '</div>';
        }
    }, {
        key: 'templateModel',
        value: function templateModel() {
            return {
                additionalClasses: this.params.classNames,
                id: this.params.id
            };
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            var _this2 = this;

            var $contentPlaceholder = this.find('.content');
            this.params.header.init($contentPlaceholder);
            this.scrollableContainer = new _ScrollableContainer2.default(null, this.params.content, { triggerScrollEvent: true }).init($contentPlaceholder);
            this.params.footer.init($contentPlaceholder);

            // subscribe for user interraptions its need for sync ScrollableContainer
            // TODO we can sync ScrollableContainer by using only setState method for change data and presentation of View
            this.$el.on('keyup keydown keypress click mouseup mousedown', function () {
                _this2.scrollableContainer.forceUpdate();
            });
        }
    }, {
        key: 'update',
        value: function update() {
            this.scrollableContainer.forceUpdate();
        }
    }, {
        key: 'scrollToSectionIfNeeded',
        value: function scrollToSectionIfNeeded($el) {
            if ($el.offset().top + $el.outerHeight() > this.scrollableContainer.getEl().offset().top + this.scrollableContainer.getEl().outerHeight()) this.scrollToSection($el);
        }
    }]);

    return LightBoxWrapper;
}(_TemplateView3.default);

var _initialiseProps = function _initialiseProps() {
    this.scrollToSection = function ($el) {
        this.scrollableContainer.scrollToElementVertical($el, {
            pos: _ScrollUtils2.default.POSITIONS.TOP,
            offset: this.params.correctionOffset
        }, 600);
    };
};

exports.default = LightBoxWrapper;

/***/ }),
/* 1410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CreateTasksLightboxHeader = function (_TemplateView) {
    _inherits(CreateTasksLightboxHeader, _TemplateView);

    function CreateTasksLightboxHeader() {
        _classCallCheck(this, CreateTasksLightboxHeader);

        return _possibleConstructorReturn(this, (CreateTasksLightboxHeader.__proto__ || Object.getPrototypeOf(CreateTasksLightboxHeader)).call(this, null));
    }

    _createClass(CreateTasksLightboxHeader, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<table class="dialog-header">' + '    <tr>' + '        <td>' + '            <div class="close-button">' + '                <div id="closeCreateTasksPopupButton" class="closeCreateTasksPopupButton closeButton"></div>' + '                <div class="disabledCloseButton"></div>' + '            </div>' + '' + '            <div class="lightBoxTitle">' + '                <%-title%>' + '            </div>' + '        </td>' + '    </tr>' + '</table>';
        }
    }, {
        key: 'messageKeys',
        value: function messageKeys() {
            return {
                title: 'add_new_tasks.title'
            };
        }
    }, {
        key: 'getCloseButtonEl',
        value: function getCloseButtonEl() {
            return this.find('.closeCreateTasksPopupButton');
        }
    }]);

    return CreateTasksLightboxHeader;
}(_TemplateView3.default);

exports.default = CreateTasksLightboxHeader;

/***/ }),
/* 1411 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CreateTaskLightboxContent = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _jquery_rpc = __webpack_require__(26);

var _jquery_rpc2 = _interopRequireDefault(_jquery_rpc);

var _constants = __webpack_require__(507);

var _CreateTasksCustomerProjectSelector = __webpack_require__(1412);

var _CreateTasksCustomerProjectSelector2 = _interopRequireDefault(_CreateTasksCustomerProjectSelector);

var _TaskTableTemplate = __webpack_require__(509);

var _TaskTableTemplate2 = _interopRequireDefault(_TaskTableTemplate);

var _ImportTasksSelector = __webpack_require__(787);

var _ImportTasksSelector2 = _interopRequireDefault(_ImportTasksSelector);

var _ImportTasksSelectorButton = __webpack_require__(788);

var _ImportTasksSelectorButton2 = _interopRequireDefault(_ImportTasksSelectorButton);

var _ExitConfirmationHandlersManager = __webpack_require__(298);

var _ExitConfirmationHandlersManager2 = _interopRequireDefault(_ExitConfirmationHandlersManager);

var _ClassicBridge = __webpack_require__(18);

var _ClassicBridge2 = _interopRequireDefault(_ClassicBridge);

var _utils = __webpack_require__(135);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var INITIAL_NUMBER_OF_ROWS = 3;
var INITIAL_NUMBER_OF_ROWS_WHEN_OPENED_FROM_OPEN_TASKS = 5;

var CreateTaskLightboxContent = exports.CreateTaskLightboxContent = function (_TemplateView) {
    _inherits(CreateTaskLightboxContent, _TemplateView);

    function CreateTaskLightboxContent(_ref, _ref2) {
        var customers = _ref.customers,
            projects = _ref.projects,
            billingTypes = _ref.billingTypes,
            defaultBillingTypeId = _ref.defaultBillingTypeId,
            canEditHierarchy = _ref.canEditHierarchy,
            canAddTasksToUser = _ref.canAddTasksToUser,
            weekStartDay = _ref.weekStartDay,
            scheduleCalculator = _ref.scheduleCalculator,
            estEnabled = _ref.estEnabled,
            tstEnabled = _ref.tstEnabled,
            projectsWithTasksExist = _ref.projectsWithTasksExist,
            isOpenedFromOpenTasks = _ref.isOpenedFromOpenTasks,
            selectedCustomerId = _ref.selectedCustomerId,
            selectedProjectId = _ref.selectedProjectId,
            selectedUserId = _ref.selectedUserId,
            user = _ref.user,
            dayOnWeek = _ref.dayOnWeek,
            userManagementAssignmentsData = _ref.userManagementAssignmentsData;
        var _ref2$onChangedDataCb = _ref2.onChangedDataCb,
            onChangedDataCb = _ref2$onChangedDataCb === undefined ? function () {} : _ref2$onChangedDataCb,
            _ref2$validationCb = _ref2.validationCb,
            validationCb = _ref2$validationCb === undefined ? function () {} : _ref2$validationCb,
            _ref2$getScrollPositi = _ref2.getScrollPositionCallback,
            getScrollPositionCallback = _ref2$getScrollPositi === undefined ? function () {
            return 0;
        } : _ref2$getScrollPositi,
            _ref2$refreshScrollCb = _ref2.refreshScrollCb,
            refreshScrollCb = _ref2$refreshScrollCb === undefined ? function () {} : _ref2$refreshScrollCb;

        _classCallCheck(this, CreateTaskLightboxContent);

        var _this = _possibleConstructorReturn(this, (CreateTaskLightboxContent.__proto__ || Object.getPrototypeOf(CreateTaskLightboxContent)).call(this, null));

        _this.sendCreateTasksRequest = function (serviceName) {
            var _this$getData = _this.getData(),
                _this$getData2 = _slicedToArray(_this$getData, 6),
                customerId = _this$getData2[0],
                newCustomerName = _this$getData2[1],
                projectId = _this$getData2[2],
                newProjectName = _this$getData2[3],
                selectedProjectNames = _this$getData2[4],
                tasks = _this$getData2[5];

            return new Promise(function (resolve, reject) {
                // TODO temporary commented
                var notEmptyTaskRowsNumbers = _this.createTasksComponent.getCreateTasksTable().getNotEmptyRowsNumbers();

                var errorHandler = function errorHandler(jqXHR, textStatus, errorThrown) {
                    if (errorThrown.exception === 'com.actimind.actitime.services.BaseNewTasksService$NoRightsToManageTasksException') {
                        alert(_messageResource2.default.getMessage('add_new_tasks.no_right_create_tasks'));
                        document.location.reload();
                        return true;
                    }
                    if (errorThrown.exception === 'com.actimind.actitime.services.BaseNewTasksService$NoRightsToManageCustomersAndProjectException') {
                        alert(_messageResource2.default.getMessage('add_new_tasks.no_right_create_project_customer'));
                        _ExitConfirmationHandlersManager2.default.restoreExitConfirmation();
                        document.location.reload();
                        return true;
                    }
                    if (errorThrown.exception === 'com.actimind.actitime.services.BaseNewTasksService$NoRightsToManageSelectedProjectException') {
                        alert(_messageResource2.default.getMessage('add_new_tasks.project_unavailable'));
                        _this.customerProjectSelector.removeProject(projectId);
                        _this.customerProjectSelector.addProjectNotSelectedError();
                        return true;
                    }

                    reject();
                    return false;
                };

                var successHandler = function successHandler(result) {
                    if (result.customerProjectError) {
                        _this.handleCustomerProjectError(result.customerProjectError, customerId, projectId, selectedProjectNames, result.customers ? result.customers.list : null, result.projects ? result.projects.list : null);
                    } else if (result.taskError) {
                        var rowNumber = notEmptyTaskRowsNumbers[result.taskErrorRowNumber];
                        _this.createTasksComponent.handleTaskError(result.taskError, rowNumber);
                    } else if (result.billingTypeError) {
                        _this.createTasksComponent.handleBillingTypeError(result.billingTypeError, result.billingTypes ? result.billingTypes.list : null);
                    }

                    var classicIds = void 0;

                    if (result.createdTaskIdsList) classicIds = result.createdTaskIdsList.list;else classicIds = result.createdTasks.list.map(function (_ref3) {
                        var task = _ref3.task;
                        return task.id;
                    });

                    _ClassicBridge2.default.getTasksAfterModification(classicIds).then(function (nextTasks) {
                        if (nextTasks) result.createdTasks.list = result.createdTasks.list.map(function (createdTask) {
                            var task = createdTask.task;

                            var nextTask = nextTasks.find(function (_ref4) {
                                var classicId = _ref4.classicId;
                                return classicId === task.id;
                            });
                            if (nextTask) return _extends({}, createdTask, { task: (0, _utils.mergeClassicAndNextTask)(task, nextTask) });
                            return createdTask;
                        });

                        //todo: task list is empty case : alert( messageResource.getMessage( "add_new_tasks.js.unexpected_error" ) );
                        resolve(result);
                    }).catch(function () {
                        return resolve(result);
                    });
                };
                var data = [customerId, newCustomerName, projectId, newProjectName, selectedProjectNames, tasks];

                if (!_this.params.isOpenedFromOpenTasks && _this.params.selectedUserId && _this.params.dayOnWeek) {
                    data.push(_this.params.selectedUserId);
                    data.push(_this.params.dayOnWeek);
                }

                (0, _jquery_rpc2.default)(serviceName + ".createNewTasks", data, successHandler, errorHandler);
            });
        };

        _this.params = {
            customers: customers,
            projects: projects,
            billingTypes: billingTypes,
            defaultBillingTypeId: defaultBillingTypeId,
            canEditHierarchy: canEditHierarchy,
            canAddTasksToUser: canAddTasksToUser,
            weekStartDay: weekStartDay,
            scheduleCalculator: scheduleCalculator,
            estEnabled: estEnabled,
            tstEnabled: tstEnabled,
            projectsWithTasksExist: projectsWithTasksExist,
            isOpenedFromOpenTasks: isOpenedFromOpenTasks,
            selectedCustomerId: selectedCustomerId,
            selectedProjectId: selectedProjectId,
            selectedUserId: selectedUserId,
            user: user,
            dayOnWeek: dayOnWeek,
            userManagementAssignmentsData: userManagementAssignmentsData
        };

        _this.callbacks = {
            onChangedDataCb: onChangedDataCb,
            validationCb: validationCb,
            getScrollPositionCallback: getScrollPositionCallback,
            refreshScrollCb: refreshScrollCb
        };
        return _this;
    }

    _createClass(CreateTaskLightboxContent, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class="innerContent">' + '    <div class="customerProjectSelectorPlaceholder"></div>' + '    <div class="importTasksHeader">' + '        <div class="title"><%-importTasksHeader%></div>' + '        <div class="importTasksSelectorButtonContainer"></div>' + '    </div>' + '    <div class="tablePlaceholder"></div>' + '</div>';
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            this.customerProjectSelector = new _CreateTasksCustomerProjectSelector2.default({
                customers: this.params.customers,
                projects: this.params.projects,
                canEditHierarchy: this.params.canEditHierarchy,
                selectedCustomerId: this.params.selectedCustomerId,
                selectedProjectId: this.params.selectedProjectId,
                changesCallback: this.callbacks.onChangedDataCb,
                validationCallback: this.callbacks.validationCb,
                scrollableContainer: this.$el,
                userManagementAssignmentsData: this.params.userManagementAssignmentsData
            }).init(this.getCustomerProjectSelectorSection());

            this.initImportTasksSelector();

            this.initCreateTasksComponent();
        }
    }, {
        key: 'templateModel',
        value: function templateModel() {
            return {
                id: 'createTasksPopup'
            };
        }
    }, {
        key: 'messageKeys',
        value: function messageKeys() {
            return {
                importTasksHeader: 'add_new_tasks.new_tasks'
            };
        }
    }, {
        key: 'getCustomerProjectSelectorSection',
        value: function getCustomerProjectSelectorSection() {
            return this.find(".customerProjectSelectorPlaceholder");
        }
    }, {
        key: 'getImportTasksContainer',
        value: function getImportTasksContainer() {
            // TODO set correct value
            return this.createTasksComponent.getEl();
        }
    }, {
        key: 'getCustomerProjectSelector',
        value: function getCustomerProjectSelector() {
            return this.customerProjectSelector;
        }
    }, {
        key: 'validateCustomerProjectSelector',
        value: function validateCustomerProjectSelector() {
            return this.customerProjectSelector.validate();
        }
    }, {
        key: 'validateTasksTableComponent',
        value: function validateTasksTableComponent() {
            return this.createTasksComponent.validate();
        }
    }, {
        key: 'isTaskTableComponentEmpty',
        value: function isTaskTableComponentEmpty() {
            return this.createTasksComponent.isEmpty();
        }
    }, {
        key: 'hasErrors',
        value: function hasErrors() {
            return this.customerProjectSelector && this.customerProjectSelector.hasErrors() || this.createTasksComponent && this.createTasksComponent.hasErrors();
        }
    }, {
        key: 'getData',
        value: function getData() {
            var cpValues = this.customerProjectSelector.getValues();
            var tasks = this.createTasksComponent.getTasks();

            return [cpValues.customerId, cpValues.newCustomerName, cpValues.projectId, cpValues.newProjectName, cpValues.selectedProjectNames, tasks];
        }
    }, {
        key: 'initImportTasksSelector',
        value: function initImportTasksSelector() {
            var _this2 = this;

            this.importTasksSelector = new _ImportTasksSelector2.default((0, _jquery2.default)("body"), {
                scrollableContainer: this.$el,
                canSelectAllInCustomer: true,
                canSelectAllInProject: true,
                selectionCallback: function selectionCallback(_ref5) {
                    var taskIds = _ref5.taskIds,
                        customerId = _ref5.customerId,
                        projectId = _ref5.projectId,
                        importDescriptions = _ref5.importDescriptions,
                        importOnlyActiveProjects = _ref5.importOnlyActiveProjects;

                    _this2.createTasksComponent.importTasksRequest(taskIds, importDescriptions, customerId, projectId, importOnlyActiveProjects);
                    _this2.importTasksSelector.hidePanel();
                }
            }).init();
            this.importTasksSelector.setState({
                user: this.params.user
            });

            var importTasksSelectorButton = new _ImportTasksSelectorButton2.default(function () {
                _this2.importTasksSelector.showPanel({ of: importTasksSelectorButton.$el });
            }).init(this.find(".importTasksSelectorButtonContainer"));
        }
    }, {
        key: 'initCreateTasksComponent',
        value: function initCreateTasksComponent() {
            var defaultRowsNumber = this.params.isOpenedFromOpenTasks ? INITIAL_NUMBER_OF_ROWS_WHEN_OPENED_FROM_OPEN_TASKS : INITIAL_NUMBER_OF_ROWS;

            this.createTasksComponent = new _TaskTableTemplate2.default(this.find(".tablePlaceholder"), {
                billingTypes: this.params.billingTypes,
                defaultBillingTypeId: this.params.defaultBillingTypeId,
                canAddTasksToUser: this.params.canAddTasksToUser,
                weekStartDay: this.params.weekStartDay,
                scheduleCalculator: this.params.scheduleCalculator,
                estEnabled: this.params.estEnabled,
                tstEnabled: this.params.tstEnabled,
                defaultRowsNumber: defaultRowsNumber,
                isOpenedFromOpenTasks: this.params.isOpenedFromOpenTasks,
                changesCallback: this.callbacks.onChangedDataCb,
                validateCallback: this.callbacks.validationCb,
                scrollableContainer: this.$el,
                getScrollPositionCallback: this.callbacks.getScrollPositionCallback,
                refreshScrollCb: this.callbacks.refreshScrollCb
            }).init();
        }
    }, {
        key: 'getTaskComponent',
        value: function getTaskComponent() {
            return this.createTasksComponent;
        }
    }, {
        key: 'getCustomerName',
        value: function getCustomerName(customerId) {
            for (var c = 0; c < this.params.customers.length; c++) {
                if (this.params.customers[c].id === customerId) return this.params.customers[c].name;
            }
            return "";
        }
    }, {
        key: 'getProjectName',
        value: function getProjectName(projectId) {
            for (var j = 0; j < this.params.projects.length; j++) {
                if (this.params.projects[j].id === projectId) return this.params.projects[j].name;
            }
            return "";
        }
    }, {
        key: 'handleCustomerProjectError',
        value: function handleCustomerProjectError(customerProjectError, customerId, projectId, selectedProjectNames, customers, projects) {
            var msgKey = void 0;

            switch (customerProjectError) {
                case _constants.CREATE_TASKS_CONSTANTS.CUSTOMER_IS_NOT_EXIST_ERROR:
                    alert(_messageResource2.default.getMessage('add_new_tasks.customer_deleted'));
                    this.customerProjectSelector.setCustomersAndProjectsAndUpdateSelector(customers, projects);
                    this.customerProjectSelector.addCustomerNotSelectedError();
                    break;

                case _constants.CREATE_TASKS_CONSTANTS.CUSTOMER_EXISTS_ERROR:
                    this.customerProjectSelector.addCustomerExistsError();
                    break;

                case _constants.CREATE_TASKS_CONSTANTS.CUSTOMER_IS_ARCHIVED_ERROR:
                    {
                        var customerName = this.getCustomerName(customerId);
                        msgKey = this.params.canEditHierarchy ? 'add_new_tasks.customer_archived' : 'add_new_tasks.customer_archived.cant_manage_projects';
                        alert(_messageResource2.default.getMessage(msgKey, [customerName]));
                        this.customerProjectSelector.setCustomersAndProjectsAndUpdateSelector(customers, projects);
                        this.customerProjectSelector.addCustomerNotSelectedError();
                        break;
                    }
                case _constants.CREATE_TASKS_CONSTANTS.NO_ACTIVE_CUSTOMERS_ERROR:
                    this.customerProjectSelector.setCustomersAndProjectsAndUpdateSelector(null, null);
                    this.customerProjectSelector.addNoActiveCustomersError();
                    break;

                case _constants.CREATE_TASKS_CONSTANTS.PROJECT_IS_NOT_EXIST_ERROR:
                    alert(_messageResource2.default.getMessage('add_new_tasks.project_unavailable'));
                    this.customerProjectSelector.setProjectsAndUpdateSelector(projects);
                    this.customerProjectSelector.addProjectNotSelectedError();
                    break;

                case _constants.CREATE_TASKS_CONSTANTS.PROJECT_EXISTS_ERROR:
                    this.customerProjectSelector.addProjectExistsError();
                    break;

                case _constants.CREATE_TASKS_CONSTANTS.PROJECT_IS_ARCHIVED_ERROR:
                    var projectName = this.getProjectName(projectId);
                    msgKey = this.params.canEditHierarchy ? 'add_new_tasks.project_archived' : 'add_new_tasks.project_archived.cant_manage_projects';
                    alert(_messageResource2.default.getMessage(msgKey, [projectName]));
                    this.customerProjectSelector.setProjectsAndUpdateSelector(projects);
                    this.customerProjectSelector.addProjectNotSelectedError();
                    break;

                case _constants.CREATE_TASKS_CONSTANTS.NO_ACTIVE_PROJECTS_ERROR:
                    if (selectedProjectNames) {
                        this.customerProjectSelector.removeProjectsFromList(selectedProjectNames, customerId);
                        if (selectedProjectNames.length > 1) alert(_messageResource2.default.getMessage('add_new_tasks.projects_unavailable'));else alert(_messageResource2.default.getMessage('add_new_tasks.project_unavailable'));
                    } else if (projectId === _constants.CREATE_TASKS_CONSTANTS.ALL_ACTIVE_PROJECTS_OPTION_INDEX) {
                        alert(_messageResource2.default.getMessage('add_new_tasks.projects_unavailable'));
                        this.customerProjectSelector.removeAllProjectsOfSelectedCustomer();
                        this.customerProjectSelector.addNoActiveProjectsError();
                    }
                    break;

                case _constants.CREATE_TASKS_CONSTANTS.CUSTOMER_IS_NOT_ASSIGNED_ERROR:
                    {
                        this.customerProjectSelector.setCustomersAndProjectsAndUpdateSelector(customers, projects);
                        this.customerProjectSelector.addCustomerNotSelectedError();
                        alert(_messageResource2.default.getMessage('add_new_tasks.customer_not_assigned.error'));
                        break;
                    }

                case _constants.CREATE_TASKS_CONSTANTS.PROJECT_IS_NOT_ASSIGNED_ERROR:
                    {
                        alert(_messageResource2.default.getMessage('add_new_tasks.project_not_assigned.error'));
                        this.customerProjectSelector.setProjectsAndUpdateSelector(projects);
                        this.customerProjectSelector.addProjectNotSelectedError();
                        break;
                    }
            }
        }

        // TODO move to action provider

    }]);

    return CreateTaskLightboxContent;
}(_TemplateView3.default);

exports.default = CreateTaskLightboxContent;

/***/ }),
/* 1412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CreateTasksCustomerProjectSelector = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _constants = __webpack_require__(507);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _atUtils = __webpack_require__(5);

var _atBrowserUtils = __webpack_require__(8);

var _CustomCheckbox = __webpack_require__(83);

var _CustomCheckbox2 = _interopRequireDefault(_CustomCheckbox);

var _ScrollView = __webpack_require__(346);

var _ScrollView2 = _interopRequireDefault(_ScrollView);

var _constants2 = __webpack_require__(4);

var _CPCombobox = __webpack_require__(372);

var _CPCombobox2 = _interopRequireDefault(_CPCombobox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CreateTasksCustomerProjectSelector = exports.CreateTasksCustomerProjectSelector = function (_TemplateView) {
    _inherits(CreateTasksCustomerProjectSelector, _TemplateView);

    function CreateTasksCustomerProjectSelector(_ref) {
        var customers = _ref.customers,
            projects = _ref.projects,
            canEditHierarchy = _ref.canEditHierarchy,
            selectedCustomerId = _ref.selectedCustomerId,
            selectedProjectId = _ref.selectedProjectId,
            changesCallback = _ref.changesCallback,
            userManagementAssignmentsData = _ref.userManagementAssignmentsData,
            validationCallback = _ref.validationCallback,
            scrollableContainer = _ref.scrollableContainer;

        _classCallCheck(this, CreateTasksCustomerProjectSelector);

        var _this = _possibleConstructorReturn(this, (CreateTasksCustomerProjectSelector.__proto__ || Object.getPrototypeOf(CreateTasksCustomerProjectSelector)).call(this, null));

        _this.params = {
            customers: customers,
            projects: projects,
            canEditHierarchy: canEditHierarchy,
            selectedCustomerId: selectedCustomerId,
            selectedProjectId: selectedProjectId,
            changesCallback: changesCallback,
            userManagementAssignmentsData: userManagementAssignmentsData,
            validationCallback: validationCallback,
            scrollableContainer: scrollableContainer,
            manageAssignments: {
                allManagementScopeAssigned: userManagementAssignmentsData.canManageAllScope,
                customerAssignments: userManagementAssignmentsData.customerAssignments,
                projectAssignments: userManagementAssignmentsData.projectAssignments
            }
        };

        _this.errors = {};
        _this.warnings = {};

        _this.changesCallback = _this.params.changesCallback;
        _this.scrollableContainer = _this.params.scrollableContainer;

        _this.customers = _this.params.customers ? _this.params.customers : [];
        _this.projects = _this.params.projects ? _this.params.projects : [];

        _this.withInactive = false;
        _this.containerClass = 'createTasksCustomerProjectSelector';

        _this.selectedProjectNamesSet = {};

        _this.state = {
            selectedCustomerId: _constants.CREATE_TASKS_CONSTANTS.SELECT_CUSTOMER_OPTION_INDEX,
            selectedProjectId: _constants.CREATE_TASKS_CONSTANTS.SELECT_PROJECT_OPTION_INDEX
        };
        return _this;
    }

    _createClass(CreateTasksCustomerProjectSelector, [{
        key: 'templateModel',
        value: function templateModel() {
            return {
                maxNameLength: _constants2.EntityTextLimits.MAX_CPT_NAME
            };
        }
    }, {
        key: 'messageKeys',
        value: function messageKeys() {
            return {
                cpTitle: 'add_new_tasks.select_customer_and_project',
                customerNotSelectedErr: 'add_new_tasks.err.customerid_not_selected',
                customerNameEmptyErr: 'add_new_tasks.err_customer_name_empty',
                customerNameExistsErr: 'add_new_tasks.err_customer_exists',
                noActiveCustomersWarn: 'add_new_tasks.no_active_customers',
                newCustomerNamePlaceholder: 'add_new_tasks.new_customer_name.placeholder',
                projectNotSelectedErr: 'add_new_tasks.err.projectid_not_selected',
                noActiveProjectsWarn: 'add_new_tasks.no_active_projects',
                newProjectNamePlaceholder: 'add_new_tasks.new_project_name.placeholder',
                newProjectNameEmptyErr: 'add_new_tasks.err_project_name_empty',
                newProjectNameExistsErr: 'add_new_tasks.err_project_exists',
                emptyProjectListErr: 'add_new_tasks.err.select_one_or_more_project_names'
            };
        }
    }, {
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class="selectCustomerAndProject">' + '     <div class="selectCPTitle"><%-cpTitle%></div>' + '        <table cellpadding=0 cellspacing=0>' + '            <tr class="selectCustomerRow">' + '                <td>' + '                    <div class="customerSelector customerOrProjectSelector selectorWithPlaceholderContainer"></div>' + '                </td>' + '                <td class="selectCustomerErrorCell">' + '                    <div class="errorMsg"><%-customerNotSelectedErr%></div>' + '                    <div class="warningMsg"><%-noActiveCustomersWarn%></div>' + '                </td>' + '            </tr>' + '            <tr class="selectCustomerRow">' + '                <td>' + '                    <input class="newCustomer newCustomerProjectField inputFieldWithPlaceholder" maxlength="<%=maxNameLength%>"' + '                           placeholder="<%=newCustomerNamePlaceholder%>"/>' + '                </td>' + '                <td class="newCustomerErrorCell">' + '                    <div class="errorMsg emptyName"><%-customerNameEmptyErr%></div>' + '                    <div class="errorMsg alreadyExist"><%-customerNameExistsErr%></div>' + '                </td>' + '            </tr>' + '            <tr class="selectProjectRow projectSelectorRow">' + '                <td>' + '                    <div class="projectSelector customerOrProjectSelector selectorWithPlaceholderContainer"></div>' + '                </td>' + '                <td class="selectProjectErrorCell">' + '                    <div class="errorMsg"><%-projectNotSelectedErr%></div>' + '                    <div class="warningMsg"><%-noActiveProjectsWarn%></div>' + '                </td>' + '            </tr>' + '            <tr class="selectProjectRow">' + '                <td>' + '                    <input class="newProject newCustomerProjectField inputFieldWithPlaceholder" maxlength="<%=maxNameLength%>"' + '                           placeholder="<%=newProjectNamePlaceholder%>"/>' + '                </td>' + '                <td class="newProjectErrorCell">' + '                    <div class="errorMsg emptyName"><%-newProjectNameEmptyErr%></div>' + '                    <div class="errorMsg alreadyExist"><%-newProjectNameExistsErr%></div>' + '                </td>' + '            </tr>' + '            <tr class="selectProjectRow">' + '                <td>' + '                    <div class="projectList"></div>' + '                </td>' + '                <td class="emptyProjectListErrorCell">' + '                    <div class="errorMsg emptyProjectList"><%-emptyProjectListErr%></div>' + '                </td>' + '            </tr>' + '        </table>' + '' + '</div>';
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            this.container = this.$el[0];
            this.projectListContainer = this.find('.projectList');
            this.customerSelectorContainer = this.find('.customerSelector.customerOrProjectSelector')[0];
            this.projectSelectorContainer = this.find('.projectSelector.customerOrProjectSelector')[0];

            this.newCustomerField = this.find('.newCustomer.newCustomerProjectField')[0];
            this.newProjectField = this.find('.newProject.newCustomerProjectField')[0];
            (0, _jquery2.default)(this.newCustomerField).placeholder();
            (0, _jquery2.default)(this.newProjectField).placeholder();

            this.createCustomerSelector(this.params.selectedCustomerId);
            this.createProjectSelector(this.params.selectedCustomerId ? this.getProjectsOfCustomer(this.params.selectedCustomerId) : this.params.projects, this.params.selectedProjectId);

            this.addFieldHandlers(this.newCustomerField, [_constants.CreateTasksCustomerProjectSelectorErrors.CUSTOMER_EMPTY, _constants.CreateTasksCustomerProjectSelectorErrors.CUSTOMER_EXISTS]);
            this.addFieldHandlers(this.newProjectField, [_constants.CreateTasksCustomerProjectSelectorErrors.PROJECT_EMPTY, _constants.CreateTasksCustomerProjectSelectorErrors.PROJECT_EXISTS]);

            this.createProjectList(this.params.selectedCustomerId ? this.getProjectsOfCustomer(this.params.selectedCustomerId) : this.params.projects);

            if (!this.customersExist()) {
                this.selectCustomer(_constants.CREATE_TASKS_CONSTANTS.NEW_CUSTOMER_OPTION_INDEX);
                this.selectProject(_constants.CREATE_TASKS_CONSTANTS.NEW_PROJECT_OPTION_INDEX);
                (0, _jquery2.default)(this.container).addClass("newCustomer newProject");
                (0, _atBrowserUtils.setFocusIntoFieldWithPlaceholder)(this.newCustomerField);
            }

            return this;
        }
    }, {
        key: 'createAdditionalCustomerItems',
        value: function createAdditionalCustomerItems() {
            var items = [];
            if (this.params.manageAssignments.allManagementScopeAssigned) {
                items.push({
                    name: _messageResource2.default.getEscapedMessage("add_new_tasks.option.new_customer"),
                    id: _constants.CREATE_TASKS_CONSTANTS.NEW_CUSTOMER_OPTION_INDEX
                });
            }
            var allActiveCustomersMsgKey = "add_new_tasks.option.all" + (this.params.manageAssignments.allManagementScopeAssigned ? "" : "_available") + "_active_customers";
            items.push({
                name: _messageResource2.default.getEscapedMessage(allActiveCustomersMsgKey),
                id: _constants.CREATE_TASKS_CONSTANTS.ALL_ACTIVE_CUSTOMERS_OPTION_INDEX
            });

            return items;
        }
    }, {
        key: 'createAdditionalProjectItems',
        value: function createAdditionalProjectItems() {
            var items = [];

            if (this.canManageProjectsOfCustomer(this.getSelectedCustomerId())) {
                items.push({
                    name: _messageResource2.default.getEscapedMessage("add_new_tasks.option.new_project"),
                    id: _constants.CREATE_TASKS_CONSTANTS.NEW_PROJECT_OPTION_INDEX
                });
            }
            var allActiveProjectsMsgKey = "add_new_tasks.option.all" + (this.canManageProjectsOfCustomer(this.getSelectedCustomerId()) ? "" : "_available") + "_active_projects";
            items.push({
                name: _messageResource2.default.getEscapedMessage(allActiveProjectsMsgKey),
                id: _constants.CREATE_TASKS_CONSTANTS.ALL_ACTIVE_PROJECTS_OPTION_INDEX
            }, {
                name: _messageResource2.default.getEscapedMessage("add_new_tasks.option.selected_active_projects"),
                id: _constants.CREATE_TASKS_CONSTANTS.SELECTED_PROJECTS_OPTION_INDEX
            });

            return items;
        }
    }, {
        key: 'createListSelector',
        value: function createListSelector(items, additionalItems, containerEl, selectorCls, changeCallback, messageKeys, selectCallback, emptySelectionId) {
            var _this2 = this;

            (0, _jquery2.default)(containerEl).empty();

            var handler = function handler(value) {
                if (value === _constants.CREATE_TASKS_CONSTANTS.SELECT_CUSTOMER_OPTION_INDEX || value === _constants.CREATE_TASKS_CONSTANTS.SELECT_PROJECT_OPTION_INDEX) (0, _jquery2.default)(containerEl).addClass("notSelected");else (0, _jquery2.default)(containerEl).removeClass("notSelected");

                if (changeCallback) changeCallback(value);

                if (_this2.params.changesCallback) _this2.params.changesCallback();
            };

            var listSelector = new _CPCombobox2.default(_extends({}, messageKeys, {
                onItemSelectedCb: function onItemSelectedCb(item) {
                    selectCallback(item);
                    handler(item.id);
                },
                emptySelectionId: emptySelectionId,
                inputMaxLength: 255
            })).init((0, _jquery2.default)(containerEl));

            listSelector.setState({
                items: items,
                additionalItems: additionalItems
            });

            return listSelector;
        }
    }, {
        key: 'createProjectList',
        value: function createProjectList(projects) {
            var _this3 = this;

            if (!projects || projects.length === 0) return;

            var projectNamesSet = (0, _atUtils.arrayToSet)(projects.map(function (p) {
                return p.name;
            }));
            this.selectedProjectNamesSet = (0, _atUtils.filterSet)(this.selectedProjectNamesSet, function (name) {
                return projectNamesSet[name];
            });

            var items = projects.map(function (project) {
                return new _CustomCheckbox2.default({
                    label: project.name,
                    checked: _this3.selectedProjectNamesSet[project.name],
                    containerAdditionalClass: 'projectListItem',
                    onChange: function onChange(_ref2) {
                        var checked = _ref2.checked;
                        return _this3.selectedProjectNamesSet[project.name] = checked;
                    }
                });
            });

            this.selectedProjectsList = new _ScrollView2.default(null, 22).init(this.projectListContainer);
            this.selectedProjectsList.setItems(items);
        }
    }, {
        key: 'customerChanged',
        value: function customerChanged() {
            this.params.changesCallback();
            this.removeAllErrors();
            this.removeWarning(_constants.CreateTasksCustomerProjectSelectorWarnings.NO_CUSTOMERS);
            this.removeWarning(_constants.CreateTasksCustomerProjectSelectorWarnings.NO_PROJECTS);

            (0, _jquery2.default)(this.container).removeClass("newCustomer");

            var customerValue = this.getSelectedCustomerId();
            var projectValue = this.getSelectedProjectId();

            switch (parseInt(customerValue)) {
                case _constants.CREATE_TASKS_CONSTANTS.SELECT_CUSTOMER_OPTION_INDEX:
                    {
                        this.selectProject(_constants.CREATE_TASKS_CONSTANTS.SELECT_PROJECT_OPTION_INDEX);
                        this.projectChanged();
                        this.loadCustomerProjects();
                        break;
                    }
                case _constants.CREATE_TASKS_CONSTANTS.ALL_ACTIVE_CUSTOMERS_OPTION_INDEX:
                    {
                        if (projectValue !== _constants.CREATE_TASKS_CONSTANTS.ALL_ACTIVE_PROJECTS_OPTION_INDEX && projectValue !== _constants.CREATE_TASKS_CONSTANTS.NEW_PROJECT_OPTION_INDEX && projectValue !== _constants.CREATE_TASKS_CONSTANTS.SELECTED_PROJECTS_OPTION_INDEX && projectValue !== _constants.CREATE_TASKS_CONSTANTS.SELECT_PROJECT_OPTION_INDEX) {
                            this.selectProject(_constants.CREATE_TASKS_CONSTANTS.SELECT_PROJECT_OPTION_INDEX);
                            this.projectChanged();
                        }

                        this.loadCustomerProjects();
                        if (!this.customersExist()) {
                            this.addWarning(_constants.CreateTasksCustomerProjectSelectorWarnings.NO_CUSTOMERS);
                        }
                        if (!this.projectsExist() && (projectValue === _constants.CREATE_TASKS_CONSTANTS.ALL_ACTIVE_PROJECTS_OPTION_INDEX || projectValue === _constants.CREATE_TASKS_CONSTANTS.SELECTED_PROJECTS_OPTION_INDEX)) {
                            this.addWarning(_constants.CreateTasksCustomerProjectSelectorWarnings.NO_PROJECTS);
                        }
                        break;
                    }
                case _constants.CREATE_TASKS_CONSTANTS.NEW_CUSTOMER_OPTION_INDEX:
                    {
                        if (this.canManageProjectsOfCustomer(customerValue)) {
                            (0, _jquery2.default)(this.container).addClass("newCustomer");
                            this.selectProject(_constants.CREATE_TASKS_CONSTANTS.NEW_PROJECT_OPTION_INDEX);
                            this.projectChanged();
                            (0, _atBrowserUtils.setFocusIntoFieldWithPlaceholder)(this.newCustomerField);
                        }
                        break;
                    }
                default:
                    {
                        if (this.customerHasProjects(customerValue)) {
                            this.loadCustomerProjects();
                        } else {
                            this.selectProject(_constants.CREATE_TASKS_CONSTANTS.NEW_PROJECT_OPTION_INDEX);
                            this.projectChanged();
                        }
                    }
            }
        }
    }, {
        key: 'projectChanged',
        value: function projectChanged() {
            this.params.changesCallback();
            this.removeAllErrors();
            this.removeWarning(_constants.CreateTasksCustomerProjectSelectorWarnings.NO_PROJECTS);

            (0, _jquery2.default)(this.container).removeClass("newProject selectProjectsFromList");

            var customerValue = this.getSelectedCustomerId();
            var projectValue = this.getSelectedProjectId();

            if (projectValue === _constants.CREATE_TASKS_CONSTANTS.ALL_ACTIVE_PROJECTS_OPTION_INDEX) {
                if (!this.projectsExist() || this.isConcreteCustomerId(customerValue) && !this.customerHasProjects(customerValue)) {
                    this.addWarning(_constants.CreateTasksCustomerProjectSelectorWarnings.NO_PROJECTS);
                }
            } else if (projectValue === _constants.CREATE_TASKS_CONSTANTS.SELECTED_PROJECTS_OPTION_INDEX) {
                (0, _jquery2.default)(this.container).addClass("selectProjectsFromList");
                if (!this.projectsExist() || this.isConcreteCustomerId(customerValue) && !this.customerHasProjects(customerValue)) {
                    this.addWarning(_constants.CreateTasksCustomerProjectSelectorWarnings.NO_PROJECTS);
                }
                if (customerValue !== _constants.CREATE_TASKS_CONSTANTS.ALL_ACTIVE_CUSTOMERS_OPTION_INDEX && !this.isConcreteCustomerId(customerValue)) {
                    this.selectCustomer(_constants.CREATE_TASKS_CONSTANTS.ALL_ACTIVE_CUSTOMERS_OPTION_INDEX);
                    this.loadCustomerProjects();
                }
                this.selectedProjectsList.refreshScroll();
            } else if (this.isConcreteProjectId(projectValue)) {
                var customerId = this.findProjectCustomerId(projectValue);
                if (customerId !== customerValue) {
                    this.selectCustomer(customerId);
                    this.loadCustomerProjects();
                }
            } else if (projectValue === _constants.CREATE_TASKS_CONSTANTS.NEW_PROJECT_OPTION_INDEX && this.canManageProjectsOfCustomer(customerValue)) {
                (0, _jquery2.default)(this.container).addClass("newProject");
                this.loadCustomerProjects();
                (0, _atBrowserUtils.setFocusIntoFieldWithPlaceholder)(this.newProjectField);
            }
        }
    }, {
        key: 'loadCustomerProjects',
        value: function loadCustomerProjects() {
            var customerValue = this.getSelectedCustomerId();
            var projectValue = this.getSelectedProjectId();
            var projects = this.getProjectsOfCustomer(customerValue, this.withInactive);
            this.createProjectSelector(projects, projectValue);

            this.updateProjectList(projects);
        }
    }, {
        key: 'updateProjectList',
        value: function updateProjectList(projects) {
            (0, _jquery2.default)(this.projectListContainer).empty();
            this.createProjectList(this.getSelectedCustomerId() !== _constants.CREATE_TASKS_CONSTANTS.ALL_ACTIVE_CUSTOMERS_OPTION_INDEX ? projects : this.params.projects);
        }
    }, {
        key: 'hasSelectedProjects',
        value: function hasSelectedProjects() {
            return !_underscore2.default.isEmpty(this.selectedProjectNamesSet);
        }
    }, {
        key: 'getSelectedProjectsNames',
        value: function getSelectedProjectsNames() {
            return Object.keys(this.selectedProjectNamesSet);
        }
    }, {
        key: 'getSelectedProjectsNamesSet',
        value: function getSelectedProjectsNamesSet() {
            return this.selectedProjectNamesSet;
        }
    }, {
        key: 'isConcreteCustomerId',
        value: function isConcreteCustomerId(selected) {
            return ![_constants.CREATE_TASKS_CONSTANTS.SELECT_CUSTOMER_OPTION_INDEX, _constants.CREATE_TASKS_CONSTANTS.NEW_CUSTOMER_OPTION_INDEX, _constants.CREATE_TASKS_CONSTANTS.ALL_ACTIVE_CUSTOMERS_OPTION_INDEX].includes(selected);
        }
    }, {
        key: 'isConcreteProjectId',
        value: function isConcreteProjectId(selected) {
            return ![_constants.CREATE_TASKS_CONSTANTS.SELECT_PROJECT_OPTION_INDEX, _constants.CREATE_TASKS_CONSTANTS.NEW_PROJECT_OPTION_INDEX, _constants.CREATE_TASKS_CONSTANTS.ALL_ACTIVE_PROJECTS_OPTION_INDEX, _constants.CREATE_TASKS_CONSTANTS.SELECTED_PROJECTS_OPTION_INDEX].includes(selected);
        }
    }, {
        key: 'validate',
        value: function validate() {
            this.removeErrors([_constants.CreateTasksCustomerProjectSelectorErrors.CUSTOMER_EMPTY, _constants.CreateTasksCustomerProjectSelectorErrors.PROJECT_EMPTY, _constants.CreateTasksCustomerProjectSelectorErrors.CUSTOMER_NOT_SELECTED, _constants.CreateTasksCustomerProjectSelectorErrors.PROJECT_NOT_SELECTED, _constants.CreateTasksCustomerProjectSelectorErrors.PROJECTS_NOT_SELECTED]);

            var customerValue = this.getSelectedCustomerId();
            var projectValue = this.getSelectedProjectId();

            var projectsWarningShowed = this.hasWarning(_constants.CreateTasksCustomerProjectSelectorWarnings.NO_PROJECTS);

            if (customerValue === _constants.CREATE_TASKS_CONSTANTS.SELECT_CUSTOMER_OPTION_INDEX) this.addError(_constants.CreateTasksCustomerProjectSelectorErrors.CUSTOMER_NOT_SELECTED);

            if (projectValue === _constants.CREATE_TASKS_CONSTANTS.SELECT_PROJECT_OPTION_INDEX) this.addError(_constants.CreateTasksCustomerProjectSelectorErrors.PROJECT_NOT_SELECTED);

            if (projectsWarningShowed) this.addError(_constants.CreateTasksCustomerProjectSelectorErrors.NO_PROJECTS);

            if (this.hasWarning(_constants.CreateTasksCustomerProjectSelectorWarnings.NO_CUSTOMERS)) this.addError(_constants.CreateTasksCustomerProjectSelectorErrors.NO_CUSTOMERS);

            if (projectValue === _constants.CREATE_TASKS_CONSTANTS.SELECTED_PROJECTS_OPTION_INDEX && !projectsWarningShowed && !this.hasSelectedProjects()) this.addError(_constants.CreateTasksCustomerProjectSelectorErrors.PROJECTS_NOT_SELECTED);

            if (customerValue === _constants.CREATE_TASKS_CONSTANTS.NEW_CUSTOMER_OPTION_INDEX && (0, _jquery2.default)(this.newCustomerField).pVal() == "") this.addError(_constants.CreateTasksCustomerProjectSelectorErrors.CUSTOMER_EMPTY);

            if (projectValue === _constants.CREATE_TASKS_CONSTANTS.NEW_PROJECT_OPTION_INDEX && (0, _jquery2.default)(this.newProjectField).pVal() == "") this.addError(_constants.CreateTasksCustomerProjectSelectorErrors.PROJECT_EMPTY);

            return !this.hasErrors();
        }
    }, {
        key: 'hasErrors',
        value: function hasErrors() {
            //noinspection LoopStatementThatDoesntLoopJS
            for (var prop in this.errors) {
                if (this.errors[prop] === true) return true;
            }
            return false;
        }
    }, {
        key: 'addFieldHandlers',
        value: function addFieldHandlers(field, errorsToRemove) {
            var self = this;
            var keyUpChangesHandler = function keyUpChangesHandler() {
                this.keyPressed = false;
                if (!this.prevValue && !!this.value || this.prevValue !== this.value) {
                    self.removeErrors(errorsToRemove);
                    if (self.params.changesCallback) self.params.changesCallback();
                    this.prevValue = this.value;
                }
            };

            (0, _jquery2.default)(field).keypress(function () {
                this.keyPressed = true;
            });

            (0, _jquery2.default)(field).keyup(function () {
                keyUpChangesHandler.call(this);
            });

            (0, _jquery2.default)(field).blur(function () {
                (0, _jquery2.default)(this).pVal((0, _atUtils.trim)((0, _jquery2.default)(this).pVal()));
                //see Bug 48539
                if (this.keyPressed) keyUpChangesHandler.call(this);
            });
        }
    }, {
        key: 'getValues',
        value: function getValues() {
            var customerValue = this.getSelectedCustomerId();
            var projectValue = this.getSelectedProjectId();

            var newCustomerName = customerValue === _constants.CREATE_TASKS_CONSTANTS.NEW_CUSTOMER_OPTION_INDEX ? (0, _jquery2.default)(this.newCustomerField).pVal() : null;
            var newProjectName = projectValue === _constants.CREATE_TASKS_CONSTANTS.NEW_PROJECT_OPTION_INDEX ? (0, _jquery2.default)(this.newProjectField).pVal() : null;

            var selectedProjectNames = projectValue === _constants.CREATE_TASKS_CONSTANTS.SELECTED_PROJECTS_OPTION_INDEX ? this.getSelectedProjectsNames() : null;

            return {
                customerId: customerValue,
                projectId: projectValue,
                newCustomerName: newCustomerName,
                newProjectName: newProjectName,
                selectedProjectNames: selectedProjectNames
            };
        }
    }, {
        key: 'addError',
        value: function addError(error) {
            this.errors[error] = true;
            (0, _jquery2.default)(this.container).addClass(error);
        }
    }, {
        key: 'removeError',
        value: function removeError(error) {
            this.errors[error] = false;
            (0, _jquery2.default)(this.container).removeClass(error);

            if (this.params.validationCallback) this.params.validationCallback();
        }
    }, {
        key: 'removeErrors',
        value: function removeErrors(errors) {
            for (var i = 0; i < errors.length; i++) {
                this.removeError(errors[i]);
            }
        }
    }, {
        key: 'removeAllErrors',
        value: function removeAllErrors() {
            this.removeErrors([_constants.CreateTasksCustomerProjectSelectorErrors.CUSTOMER_EMPTY, _constants.CreateTasksCustomerProjectSelectorErrors.PROJECT_EMPTY, _constants.CreateTasksCustomerProjectSelectorErrors.CUSTOMER_NOT_SELECTED, _constants.CreateTasksCustomerProjectSelectorErrors.PROJECT_NOT_SELECTED, _constants.CreateTasksCustomerProjectSelectorErrors.NO_CUSTOMERS, _constants.CreateTasksCustomerProjectSelectorErrors.NO_PROJECTS, _constants.CreateTasksCustomerProjectSelectorErrors.CUSTOMER_EXISTS, _constants.CreateTasksCustomerProjectSelectorErrors.PROJECT_EXISTS, _constants.CreateTasksCustomerProjectSelectorErrors.PROJECTS_NOT_SELECTED]);
        }
    }, {
        key: 'addCustomerNotSelectedError',
        value: function addCustomerNotSelectedError() {
            this.addError(_constants.CreateTasksCustomerProjectSelectorErrors.CUSTOMER_NOT_SELECTED);
        }
    }, {
        key: 'addProjectNotSelectedError',
        value: function addProjectNotSelectedError() {
            this.addError(_constants.CreateTasksCustomerProjectSelectorErrors.PROJECT_NOT_SELECTED);
        }
    }, {
        key: 'addNoActiveCustomersError',
        value: function addNoActiveCustomersError() {
            this.addError(_constants.CreateTasksCustomerProjectSelectorErrors.NO_CUSTOMERS);
        }
    }, {
        key: 'addNoActiveProjectsError',
        value: function addNoActiveProjectsError() {
            this.addError(_constants.CreateTasksCustomerProjectSelectorErrors.NO_PROJECTS);
        }
    }, {
        key: 'addCustomerExistsError',
        value: function addCustomerExistsError() {
            this.addError(_constants.CreateTasksCustomerProjectSelectorErrors.CUSTOMER_EXISTS);
        }
    }, {
        key: 'addProjectExistsError',
        value: function addProjectExistsError() {
            this.addError(_constants.CreateTasksCustomerProjectSelectorErrors.PROJECT_EXISTS);
        }
    }, {
        key: 'addWarning',
        value: function addWarning(warning) {
            this.warnings[warning] = true;
            (0, _jquery2.default)(this.container).addClass(warning);
        }
    }, {
        key: 'removeWarning',
        value: function removeWarning(warning) {
            this.warnings[warning] = false;
            (0, _jquery2.default)(this.container).removeClass(warning);
        }
    }, {
        key: 'hasWarning',
        value: function hasWarning(warning) {
            return this.warnings[warning];
        }
    }, {
        key: 'removeProject',
        value: function removeProject(projectId) {
            for (var i = 0; i < this.params.projects.length; i++) {
                if (this.params.projects[i].id === projectId) {
                    this.params.projects.splice(i, 1);
                    break;
                }
            }

            this.updateProjectSelector();
        }
    }, {
        key: 'setCanCreateCustomerProject',
        value: function setCanCreateCustomerProject(canCreateCustomerProject) {
            this.params.canEditHierarchy = canCreateCustomerProject;

            this.createCustomerSelector(this.getSelectedCustomerId());
            this.createProjectSelector(this.params.projects, this.getSelectedProjectId());
            this.customerChanged();
        }
    }, {
        key: 'removeAllProjectsOfSelectedCustomer',
        value: function removeAllProjectsOfSelectedCustomer() {
            var customerValue = this.getSelectedCustomerId();
            if (!this.isConcreteCustomerId(customerValue)) {
                this.setProjectsAndUpdateSelector(null);
            } else {
                this.params.projects = this.params.projects.filter(function (project) {
                    return project.customerId !== customerValue;
                });

                this.createProjectSelector(this.params.projects);
            }
        }
    }, {
        key: 'removeProjectsFromList',
        value: function removeProjectsFromList(selectedProjectNames, customerId) {
            for (var i = 0; i < this.params.projects.length; i++) {
                if (_jquery2.default.inArray(this.params.projects[i].name, selectedProjectNames) !== -1 && (!this.isConcreteCustomerId(customerId) || this.params.projects[i].customerId === customerId)) {
                    this.params.projects.splice(i, 1);
                    i--;
                }
            }

            (0, _jquery2.default)(this.container).removeClass("selectProjectsFromList");
            this.updateProjectSelector();
        }
    }, {
        key: 'updateProjectSelector',
        value: function updateProjectSelector(saveSelectedProjectId) {
            var selectedCustomerId = this.getSelectedCustomerId();
            var visibleProjects = this.isConcreteCustomerId(selectedCustomerId) ? this.getProjectsOfCustomer(selectedCustomerId) : this.params.projects;
            this.createProjectSelector(visibleProjects, saveSelectedProjectId ? this.getSelectedProjectId() : null);

            this.updateProjectList(visibleProjects);
        }
    }, {
        key: 'canManageProjectsOfCustomer',
        value: function canManageProjectsOfCustomer(customerValue) {
            return this.params.canEditHierarchy && (this.params.manageAssignments.allManagementScopeAssigned || this.isConcreteCustomerId(customerValue) && _underscore2.default.some(this.params.manageAssignments.customerAssignments, function (c) {
                return c.id === customerValue;
            }) || !this.isConcreteCustomerId(customerValue) && this.params.manageAssignments.customerAssignments.length > 0);
        }
    }, {
        key: 'createCustomerListItems',
        value: function createCustomerListItems() {
            var items = [];

            for (var i = 0; i < this.params.customers.length; i++) {
                var customer = this.params.customers[i];
                items.push({
                    name: customer.name,
                    id: customer.id,
                    archived: !customer.activeCustomer
                });
            }

            return items;
        }
    }, {
        key: 'createProjectListItems',
        value: function createProjectListItems(projects) {
            var items = [];

            for (var i = 0; i < projects.length; i++) {
                items.push({
                    name: projects[i].name,
                    id: projects[i].id,
                    archived: !projects[i].activeProject
                });
            }

            return items;
        }
    }, {
        key: 'createCustomerSelector',
        value: function createCustomerSelector(selectedValue) {
            var _this4 = this;

            var items = this.createCustomerListItems();
            var additionalItems = this.createAdditionalCustomerItems();
            this.customerButton = this.createListSelector(items, additionalItems, this.customerSelectorContainer, "customerListSelector", function () {
                return _this4.customerChanged();
            }, {
                emptySelectionMessageKey: "add_new_tasks.option.select_customer",
                notFoundMessageKey: "task.list.move_to.no_customers_found",
                hiddenItemsCollapsedMessageKey: 'task.list.move_to.show_archived_customers',
                hiddenItemsExpandedMessageKey: 'task.list.move_to.hide_archived_customers',
                emptyListMessageKey: "task.list.move_to.no_customers"
            }, function (entity) {
                _this4.selectCustomer(entity.id);
            }, _constants.CREATE_TASKS_CONSTANTS.SELECT_CUSTOMER_OPTION_INDEX);

            var selectedItem = items.find(function (item) {
                return item.id === selectedValue;
            }) || additionalItems.find(function (item) {
                return item.id === selectedValue;
            });
            this.selectCustomer(selectedItem ? selectedItem.id : _constants.CREATE_TASKS_CONSTANTS.SELECT_CUSTOMER_OPTION_INDEX);
        }
    }, {
        key: 'createProjectSelector',
        value: function createProjectSelector(projects, selectedValue) {
            var _this5 = this;

            var items = this.createProjectListItems(projects);
            var additionalItems = this.createAdditionalProjectItems();
            this.projectButton = this.createListSelector(items, additionalItems, this.projectSelectorContainer, "projectListSelector", function () {
                return _this5.projectChanged();
            }, {
                emptySelectionMessageKey: "add_new_tasks.option.select_project",
                notFoundMessageKey: "task.list.move_to.no_projects_found",
                hiddenItemsCollapsedMessageKey: 'task.list.move_to.show_archived_projects',
                hiddenItemsExpandedMessageKey: 'task.list.move_to.hide_archived_projects',
                emptyListMessageKey: "task.list.move_to.no_projects"
            }, function (entity) {
                _this5.selectProject(entity.id);
            }, _constants.CREATE_TASKS_CONSTANTS.SELECT_PROJECT_OPTION_INDEX);

            var selectedItem = items.find(function (item) {
                return item.id === selectedValue;
            }) || additionalItems.find(function (item) {
                return item.id === selectedValue;
            });
            this.selectProject(selectedItem ? selectedItem.id : _constants.CREATE_TASKS_CONSTANTS.SELECT_PROJECT_OPTION_INDEX);
        }
    }, {
        key: 'getSelectedCustomerId',
        value: function getSelectedCustomerId() {
            return this.state.selectedCustomerId;
        }
    }, {
        key: 'getSelectedProjectId',
        value: function getSelectedProjectId() {
            return this.state.selectedProjectId;
        }
    }, {
        key: 'customerHasProjects',
        value: function customerHasProjects(customerId) {
            for (var i = 0; i < this.params.projects.length; i++) {
                if (this.params.projects[i].customerId === customerId) return true;
            }
            return false;
        }
    }, {
        key: 'findProjectCustomerId',
        value: function findProjectCustomerId(projectId) {
            for (var i = 0; i < this.params.projects.length; i++) {
                if (this.params.projects[i].id === projectId) return this.params.projects[i].customerId;
            }
            return -1;
        }
    }, {
        key: 'getProjectsOfCustomer',
        value: function getProjectsOfCustomer(customerId) {
            var result = [];
            for (var i = 0; i < this.params.projects.length; i++) {
                var project = this.params.projects[i];
                if ((customerId <= 0 || project.customerId === customerId) && (this.withInactive || project.activeProject)) result[result.length] = project;
            }
            return result;
        }
    }, {
        key: 'setCustomersAndProjectsAndUpdateSelector',
        value: function setCustomersAndProjectsAndUpdateSelector(customers, projects) {
            this.params.customers = customers ? customers : [];
            this.createCustomerSelector();

            this.setProjectsAndUpdateSelector(projects);
        }
    }, {
        key: 'setProjectsAndUpdateSelector',
        value: function setProjectsAndUpdateSelector(projects) {
            this.params.projects = projects ? projects : [];
            this.updateProjectSelector(true);
        }
    }, {
        key: 'customersExist',
        value: function customersExist() {
            return this.params.customers.length !== 0;
        }
    }, {
        key: 'projectsExist',
        value: function projectsExist() {
            return this.params.projects.length !== 0;
        }
    }, {
        key: 'selectCustomer',
        value: function selectCustomer(customerId) {
            this.customerButton.setState({
                selectedItemId: customerId
            });
            this.setStateInternal({
                selectedCustomerId: customerId
            });
        }
    }, {
        key: 'selectProject',
        value: function selectProject(projectId) {
            this.projectButton.setState({
                selectedItemId: projectId
            });
            this.setStateInternal({
                selectedProjectId: projectId
            });
        }
    }]);

    return CreateTasksCustomerProjectSelector;
}(_TemplateView3.default);

exports.default = CreateTasksCustomerProjectSelector;

/***/ }),
/* 1413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _constants = __webpack_require__(508);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CustomCheckbox = function (_TemplateView) {
    _inherits(CustomCheckbox, _TemplateView);

    function CustomCheckbox(_ref) {
        var _ref$label = _ref.label,
            label = _ref$label === undefined ? "" : _ref$label,
            _ref$htmlLabel = _ref.htmlLabel,
            htmlLabel = _ref$htmlLabel === undefined ? "" : _ref$htmlLabel,
            _ref$checked = _ref.checked,
            checked = _ref$checked === undefined ? false : _ref$checked,
            _ref$onChange = _ref.onChange,
            onChange = _ref$onChange === undefined ? function () {} : _ref$onChange,
            _ref$type = _ref.type,
            type = _ref$type === undefined ? _constants.CustomSelectorType.CHECKBOX : _ref$type,
            _ref$containerAdditio = _ref.containerAdditionalClass,
            containerAdditionalClass = _ref$containerAdditio === undefined ? "" : _ref$containerAdditio,
            _ref$checkboxAddition = _ref.checkboxAdditionalClass,
            checkboxAdditionalClass = _ref$checkboxAddition === undefined ? "" : _ref$checkboxAddition,
            _ref$checkmarkAdditio = _ref.checkmarkAdditionalClass,
            checkmarkAdditionalClass = _ref$checkmarkAdditio === undefined ? "" : _ref$checkmarkAdditio,
            _ref$checkboxTitleAdd = _ref.checkboxTitleAdditionalClass,
            checkboxTitleAdditionalClass = _ref$checkboxTitleAdd === undefined ? "" : _ref$checkboxTitleAdd,
            _ref$tabindex = _ref.tabindex,
            tabindex = _ref$tabindex === undefined ? 0 : _ref$tabindex,
            _ref$size = _ref.size,
            size = _ref$size === undefined ? _constants.CustomSelectorSize.DEFAULT : _ref$size;

        _classCallCheck(this, CustomCheckbox);

        var _this = _possibleConstructorReturn(this, (CustomCheckbox.__proto__ || Object.getPrototypeOf(CustomCheckbox)).call(this));

        _this.props = {
            label: label,
            onChange: onChange,
            containerAdditionalClass: containerAdditionalClass,
            checkboxAdditionalClass: checkboxAdditionalClass,
            checkmarkAdditionalClass: checkmarkAdditionalClass,
            checkboxTitleAdditionalClass: checkboxTitleAdditionalClass,
            tabindex: tabindex,
            size: size,
            type: type
        };
        _this.state = {
            label: label,
            htmlLabel: htmlLabel,
            checked: checked,
            disabled: false,
            indeterminate: false
        };

        _this.onStatePropertyChanged("checked", function (checked) {
            _this.getEl().toggleClass("checked", checked);
            _this.checkbox.prop("checked", checked);
        });
        _this.onStatePropertyChanged("disabled", function (disabled) {
            _this.getEl().toggleClass('disabled', disabled);
            _this.checkbox.prop("disabled", disabled);
        });
        _this.onStatePropertyChanged("indeterminate", function (indeterminate) {
            return _this.$el.toggleClass("indeterminate", indeterminate);
        });
        _this.onStatePropertyChanged("label", function (label) {
            return _this._updateLabel(label);
        });
        _this.onStatePropertyChanged("htmlLabel", function (htmlLabel) {
            return _this._updateHtmlLabel(htmlLabel);
        });
        return _this;
    }

    _createClass(CustomCheckbox, [{
        key: "templateHtml",
        value: function templateHtml() {
            return "<label class='components_checkboxContainer <%-containerClass%>'>" + "  <span class='label <%-titleClass%>'></span>" + "  <input type='<%-type%>' class='checkbox <%-checkboxClass%>' tabindex='<%-tabindex%>'>" + "  <span class='checkmark type_<%-type%> <%-checkmarkClass%>'></span>" + "</label>";
        }
    }, {
        key: "templateModel",
        value: function templateModel() {
            return {
                containerClass: this.props.containerAdditionalClass,
                checkboxClass: this.props.checkboxAdditionalClass,
                checkmarkClass: this.props.checkmarkAdditionalClass,
                titleClass: this.props.checkboxTitleAdditionalClass,
                tabindex: this.props.tabindex,
                type: this.props.type
            };
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            var _this2 = this;

            this.checkbox = this.$el.find('.checkbox');
            this.checkmark = this.$el.find('.checkmark');

            this.$el.on('click', function (e) {
                e.stopPropagation();
            });

            this.checkbox.on('click', function (e) {
                e.stopPropagation();

                var checked = !_this2.state.checked;
                _this2.setState({
                    checked: checked
                });
                if (_this2.props.onChange) {
                    _this2.props.onChange({
                        checked: checked,
                        disabled: _this2.state.disabled
                    }, e);
                }
            });

            this.getEl().toggleClass('little', this.props.size === _constants.CustomSelectorSize.LITTLE);

            this.renderInitialState();
        }
    }, {
        key: "isChecked",
        value: function isChecked() {
            return this.checkbox[0].checked || false;
        }
    }, {
        key: "_updateLabel",
        value: function _updateLabel(label) {
            !this.state.htmlLabel && this.find('.label').text(label);
        }
    }, {
        key: "_updateHtmlLabel",
        value: function _updateHtmlLabel(htmlLabel) {
            !this.state.label && this.find('.label').html(htmlLabel);
        }
    }]);

    return CustomCheckbox;
}(_TemplateView3.default);

exports.default = CustomCheckbox;

/***/ }),
/* 1414 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _cp_selector_controller = __webpack_require__(722);

var _cp_selector_controller2 = _interopRequireDefault(_cp_selector_controller);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _key_down_handler = __webpack_require__(184);

var _key_down_handler2 = _interopRequireDefault(_key_down_handler);

var _UserNameFormat = __webpack_require__(17);

var _UserNameFormat2 = _interopRequireDefault(_UserNameFormat);

var _keyCodes = __webpack_require__(66);

var _atUtils = __webpack_require__(5);

var _atBrowserUtils = __webpack_require__(8);

var _ScrollUtils = __webpack_require__(39);

var _ScrollUtils2 = _interopRequireDefault(_ScrollUtils);

var _constants = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BaseTaskSelector = function (_TemplateView) {
    _inherits(BaseTaskSelector, _TemplateView);

    function BaseTaskSelector($containerEl, _ref) {
        var $scrollableContainerElement = _ref.$scrollableContainerElement,
            selectionCallback = _ref.selectionCallback,
            _ref$onHideCallback = _ref.onHideCallback,
            onHideCallback = _ref$onHideCallback === undefined ? function () {} : _ref$onHideCallback,
            _ref$isImportTasksMod = _ref.isImportTasksMode,
            isImportTasksMode = _ref$isImportTasksMod === undefined ? true : _ref$isImportTasksMod,
            _ref$canSelectAllInCu = _ref.canSelectAllInCustomer,
            canSelectAllInCustomer = _ref$canSelectAllInCu === undefined ? false : _ref$canSelectAllInCu,
            _ref$canSelectAllInPr = _ref.canSelectAllInProject,
            canSelectAllInProject = _ref$canSelectAllInPr === undefined ? false : _ref$canSelectAllInPr;

        _classCallCheck(this, BaseTaskSelector);

        var _this = _possibleConstructorReturn(this, (BaseTaskSelector.__proto__ || Object.getPrototypeOf(BaseTaskSelector)).call(this, $containerEl));

        _this.onKeyDown = function (event) {
            event = event || window.event;
            if (event.keyCode === _keyCodes.KEY_CODE_ESC) {
                if (_this.isFilterOpen()) _this.closeFilter();else _this.hidePanel();
            }
        };

        _this.$scrollableContainerElement = $scrollableContainerElement;
        _this.selectionCallback = selectionCallback;
        _this.onHideCallback = onHideCallback;
        _this.isImportTasksMode = isImportTasksMode;
        _this.canSelectAllInCustomer = canSelectAllInCustomer;
        _this.canSelectAllInProject = canSelectAllInProject;

        _this.rpc = null;
        _this.desiredPortionSize = 100;
        _this.maxResultsPerPortion = 150;

        _this.preSelectedProjectIdsSet = {};
        _this.preSelectedCustomerIdsSet = {};

        _this.state = {
            preSelectedTaskIds: [],
            preSelectedProjectIds: [],
            preSelectedCustomerIds: [],
            customerProjectSelection: {
                customerId: null,
                projectId: null
            },
            allSelected: false,
            allSelectedDisabled: false,
            selectedTaskIds: [],
            user: null
        };

        _this.onStateChanged(function (_ref2, prevState) {
            var user = _ref2.user,
                preSelectedTaskIds = _ref2.preSelectedTaskIds;

            if (user !== prevState.user || preSelectedTaskIds !== prevState.preSelectedTaskIds) {
                _this._updateTaskListController();
            }
        });
        _this.onStatePropertyDeeplyChanged("preSelectedProjectIds", function (ids) {
            return _this.preSelectedProjectIdsSet = (0, _atUtils.arrayToSet)(ids);
        });
        _this.onStatePropertyDeeplyChanged("preSelectedCustomerIds", function (ids) {
            return _this.preSelectedCustomerIdsSet = (0, _atUtils.arrayToSet)(ids);
        });
        _this.onStatePropertyDeeplyChanged("customerProjectSelection", function (customerProjectSelection) {
            return _this._updateCustomerProjectSelection(customerProjectSelection);
        });
        _this.onStatePropertyDeeplyChanged("allSelected", function (allSelected) {
            return _this._updateAllSelected(allSelected);
        });
        _this.onStatePropertyDeeplyChanged("allSelectedDisabled", function (allSelected) {
            return _this._updateAllSelected(allSelected);
        });
        _this.onStateChanged(function () {
            return _this._updateApplyButtonEnabled();
        });
        return _this;
    }

    _createClass(BaseTaskSelector, [{
        key: "afterRender",
        value: function afterRender() {
            var _this2 = this;

            _get(BaseTaskSelector.prototype.__proto__ || Object.getPrototypeOf(BaseTaskSelector.prototype), "afterRender", this).call(this);

            this.$panel = this.$el;
            this.$applyButton = this.$panel.find("." + this.getApplyButtonClass());
            this.$selectAllCheckbox = this.$panel.find(".selectAll input");
            this.$selectAllLabel = this.$panel.find(".selectAllLabel");

            this.$selectAllCheckbox.click(function () {
                return _this2.setState({ allSelected: !_this2.state.allSelected });
            });

            this.initCpSelectorController();
            this.initTaskListController();

            this.$applyButton.click(function () {
                return _this2.onApplyButtonClick();
            });

            (0, _atBrowserUtils.setMouseDownOutsideHandler)(this.$panel, function (event) {
                return _this2.onMouseDownOutside(event);
            });

            this.$panel.find(".selectorFilterButton").click(function () {
                return _this2.onFilterButtonClick();
            });
            this.$panel.find(".filterPanel .closeButton").click(function () {
                return _this2.onFilterCloseButtonClick();
            });
            this.$panel.find(".selectAllButton").click(function () {
                return _this2.onSelectAllButtonClick();
            });
            this.$panel.find(".unselectAllButton").click(function () {
                return _this2.onUnselectAllButtonClick();
            });

            this.$el.on('click', function (e) {
                e.stopPropagation();
            });
        }
    }, {
        key: "initCpSelectorController",
        value: function initCpSelectorController() {
            var _this3 = this;

            this.cpSelectorController = new _cp_selector_controller2.default(this.$panel.find(".customerProjectSelector.activeProjects"), function (customerId, projectId, customer, project) {
                var directlySelected = !!(customerId && _this3.preSelectedCustomerIdsSet[customerId]) || !!(projectId && _this3.preSelectedProjectIdsSet[projectId]);

                var selectedByParent = !!(projectId && _this3.preSelectedCustomerIdsSet[project.customerId]);

                _this3.setState({
                    customerProjectSelection: { customerId: customerId, projectId: projectId },
                    allSelected: directlySelected || selectedByParent,
                    allSelectedDisabled: directlySelected || selectedByParent
                });
            });
        }
    }, {
        key: "createTaskListController",
        value: function createTaskListController(params) {
            // Abstract
        }
    }, {
        key: "initTaskListController",
        value: function initTaskListController() {
            var _this4 = this;

            var taskListScroll = _ScrollUtils2.default.addVerticalScroll(this.$panel.find(".taskList"));
            this.taskListController = this.createTaskListController({
                container: this.$panel.find(".taskList .content"),
                searchField: this.$panel.find(".filterField"),
                initialRequestSpinnerPlaceholder: this.$panel.find(".spinnerPlaceholder"),
                isOwnTimeTrack: true,
                isRecentTasksMode: false,
                isImportTasksMode: this.isImportTasksMode,
                desiredPortionSize: this.desiredPortionSize,
                maxResultsPerPortion: this.maxResultsPerPortion,
                isMultiSelect: true,
                onSelectionChange: function onSelectionChange() {
                    return _this4.setState({ selectedTaskIds: _this4.taskListController.getSelectedTaskIds() });
                },
                disableAlreadyAdded: true,
                onRequestProcessingComplete: function onRequestProcessingComplete(data) {
                    _ScrollUtils2.default.refreshCustomScroll(taskListScroll);
                }
            });
        }
    }, {
        key: "templateHtml",
        value: function templateHtml() {
            var tableRowTemplates = "            <div class='templates' style='display: none'>" + "                <div class='row task'>" + "                    <table cellpadding='0' cellspacing='0' style='width: 100%'>" + "                        <tr>" + "                            <td class='checkboxCol'>" + "                                <input type='checkbox'>" + "                            </td>" + "                            <td class='infoCol'>" + "                                <span class='taskId' style='display: none'>#</span>" + "                                <span class='taskName'>#</span>" + "                                <span class='alreadyAdded' style='display: none'><%-alreadyAdded%></span>" + "                                <br>" + "                                <span class='details'>#</span>" + "                            </td>" + "                        </tr>" + "                    </table>" + "                </div>" + "                <div class='row showMore last'>" + "                    <div class='panelDiv'>" + "                        <div class='resultsContainDiv'>#</div>" + "                        <div class='showMoreLinkDiv'>" + "                            <span class='showMoreLink'><%-showMore%></span>" + "                        </div>" + "                    </div>" + "                </div>" + "            </div>";

            var selectTasksPanel = "        <div style='margin-top: 12px; margin-bottom: 8px'>" + "            <table cellpadding='0' cellspacing='0' style='width: 100%'>" + "                <tr>" + "                    <td style='white-space: nowrap' class='label'>" + "                        <div class='selectTasksLabel'>" + "                            <%-selectTasks%>" + "                        </div>" + "                        <div class='spinnerPlaceholder'></div>" + "                    </td>" + "                    <td style='width: 195px; text-align: right;'>" + "                   " + this.filterPanelTemplateHtml() + "                    </td>" + "                </tr>" + "            </table>" + "        </div>";

            return "<div class='taskSelectorPanel addTasksPanel hidden'>" + "    <div class='addTasksSelectorPanelContent'>" + "        " + this.topPanelTemplateHtml() + "        <div class='titleContainer label'>" + "            <span class='selectCustomerProjectLabel'><%-selectProjectOrCustomer%></span>" + "            " + this.selectCpSectionAdditionalControlsTemplateHtml() + "        </div>" + "        " + this.cpSelectorControllerContainerTemplateHtml() + "        " + selectTasksPanel + "        <div class='selectAllContainer'>" + "            <div class='selectAll'><label><input type='checkbox'/><span class='selectAllLabel'></span></label></div>" + "        </div>" + "        <div class='taskListContainer'>" + "            <div class='taskList' style='position: relative'>" + "                <div class='content'>" + "                    <div class='pleaseSelectCustomerOrProject'>" + "                        <%-pleaseSelectCustomerOrProject%>" + "                    </div>" + "                    <div>" + "                        <table cellpadding='0' cellspacing='0' style='width: 100%'>" + "                            <tr>" + "                                <td class='noMatches' style='display: none; max-width: 100px'>#</td>" + "                            </tr>" + "                        </table>" + "                    </div>" + "                    " + tableRowTemplates + "                </div>" + "            </div>" + "            <div class='moire'></div>" + "        </div>" + "        <div class='bottom'>" + "            " + this.bottomPanelTemplateHtml() + "        </div>" + "    </div>" + "</div>";
        }
    }, {
        key: "selectCpSectionAdditionalControlsTemplateHtml",
        value: function selectCpSectionAdditionalControlsTemplateHtml() {
            return "";
        }
    }, {
        key: "filterPanelTemplateHtml",
        value: function filterPanelTemplateHtml() {
            return "<div style='position: relative'>" + "    <button class='selectorFilterButton' disabled></button>" + "    <div class='filterPanel' style='display: none'>" + "        <input maxlength='<%=maxNameLength%>' class='filterField' type='text' autocomplete='off'>" + "        <button class='closeButton'></button>" + "    </div>" + "</div>";
        }
    }, {
        key: "bottomPanelTemplateHtml",
        value: function bottomPanelTemplateHtml() {
            return "<button class='addSelectedButton' disabled><%-addSelected%></button>";
        }
    }, {
        key: "topPanelTemplateHtml",
        value: function topPanelTemplateHtml() {
            return "";
        }
    }, {
        key: "cpSelectorControllerContainerTemplateHtml",
        value: function cpSelectorControllerContainerTemplateHtml() {
            var cpSelectorControllerTemplate = BaseTaskSelector.cpSelectorControllerTemplateHtml();
            var cpSelectorController = cpSelectorControllerTemplate.replace("#divClassName", "activeProjects");
            return "<div>" + cpSelectorController + "</div>";
        }
    }, {
        key: "templateModel",
        value: function templateModel() {
            return {
                maxNameLength: _constants.EntityTextLimits.MAX_CPT_NAME
            };
        }
    }, {
        key: "messageKeys",
        value: function messageKeys() {
            return {
                selectProjectOrCustomer: "submit_tt.task_selector.select_customer_or_project",
                selectTasks: "submit_tt.task_selector.select_tasks",
                pleaseSelectCustomerOrProject: "submit_tt.task_selector.to_view_tasks",
                expandAll: "submit_tt.task_selector.expand_all",
                collapseAll: "submit_tt.task_selector.collapse_all",
                cpSelectorEmptyActive: "submit_tt.cp_selector.empty.active",
                cpSelectorNothingFoundActive: "submit_tt.cp_selector.nothing_found.active",
                showMore: "submit_tt.task_search.show_more",
                alreadyAdded: "submit_tt.task_search.already_added",
                addSelected: "submit_tt.task_selector.add_selected"
            };
        }
    }, {
        key: "getApplyButtonClass",
        value: function getApplyButtonClass() {
            return "addSelectedButton";
        }
    }, {
        key: "showCpSelectorController",
        value: function showCpSelectorController(needReinit) {
            var _this5 = this;

            if (!this.cpSelectorController.isInitialized() && this.rpc === null || needReinit) {
                this.cpSelectorController.spin();
                this.rpc = this._getCPListRpcCall(function (data) {
                    return _this5.onCustomersProjectsRequestComplete(data);
                }, function (jqXHR, textStatus, errorThrown) {
                    return _this5.onCustomersProjectsRequestError(jqXHR, textStatus, errorThrown);
                });
            }
        }
    }, {
        key: "_getCPListRpcCall",
        value: function _getCPListRpcCall(onSuccess, onError) {
            // Abstract
        }
    }, {
        key: "showPanel",
        value: function showPanel(positionParams) {
            var _this6 = this;

            if (this.$panel.hasClass('hidden')) {
                this.$panel.removeClass('hidden');

                this.showCpSelectorController(true);
                _key_down_handler2.default.setOnKeyDownHandler(this.onKeyDown);

                if (this.$scrollableContainerElement) this.$scrollableContainerElement.one("scroll", function () {
                    return _this6.hidePanel();
                });

                (0, _atBrowserUtils.showElementAt)(this.$panel, positionParams);

                (0, _atBrowserUtils.smoothlyScrollDownToElement)(this.$panel, 5);
            }
        }
    }, {
        key: "hidePanel",
        value: function hidePanel() {
            if (!this.$panel.hasClass('hidden')) {
                this.$panel.addClass('hidden');
                _key_down_handler2.default.restoreOnKeyDownHandler();
                this.cpSelectorController.closeDropdown();
                this.onHideCallback();
            }
        }
    }, {
        key: "hide",
        value: function hide() {
            this.hidePanel();
        }
    }, {
        key: "openFilter",
        value: function openFilter() {
            this.$panel.find(".filterPanel").show();
            this.$panel.find(".filterField").focus();
        }
    }, {
        key: "closeFilter",
        value: function closeFilter(skipUpdate) {
            this.$panel.find(".filterPanel").hide();
            this.taskListController.clearQuery(skipUpdate);
        }
    }, {
        key: "isFilterOpen",
        value: function isFilterOpen() {
            return this.$panel.find(".filterPanel:visible").length === 1;
        }
    }, {
        key: "onApplyButtonClick",
        value: function onApplyButtonClick() {
            if (!this.$applyButton.hasClass("disabled")) {
                this.selectionCallback(this._getSelection(), this.taskListController.getLoadedTaskList());
            }
        }
    }, {
        key: "_getSelection",
        value: function _getSelection() {
            var selectAllCheckBoxDisabled = this.$selectAllCheckbox.attr('disabled');
            return {
                customerId: this.state.allSelected && !selectAllCheckBoxDisabled && this.state.customerProjectSelection.customerId ? this.state.customerProjectSelection.customerId : null,
                projectId: this.state.allSelected && !selectAllCheckBoxDisabled && this.state.customerProjectSelection.projectId ? this.state.customerProjectSelection.projectId : null,
                taskIds: !this.state.allSelected ? this.state.selectedTaskIds : null
            };
        }
    }, {
        key: "onMouseDownOutside",
        value: function onMouseDownOutside(event) {
            this.hidePanel();
        }

        /**
         * @param data
         * @config customers
         * @config projects
         */

    }, {
        key: "onCustomersProjectsRequestComplete",
        value: function onCustomersProjectsRequestComplete(data) {
            this.cpSelectorController.init(data, true);
            this.cpSelectorController.stopSpin();
        }
    }, {
        key: "onCustomersProjectsRequestError",
        value: function onCustomersProjectsRequestError(jqXHR, textStatus, errorThrown) {
            this.cpSelectorController.stopSpin();
            this.hidePanel();
            this.rpc = null;

            if (errorThrown.exception === 'com.actimind.actitime.administration.NoSuchUserException') {
                document.location.reload();
                return true;
            }

            return false;
        }
    }, {
        key: "onFilterButtonClick",
        value: function onFilterButtonClick() {
            this.openFilter();
        }
    }, {
        key: "onFilterCloseButtonClick",
        value: function onFilterCloseButtonClick() {
            this.closeFilter();
        }
    }, {
        key: "onSelectAllButtonClick",
        value: function onSelectAllButtonClick() {
            this.taskListController.selectAll();
        }
    }, {
        key: "onUnselectAllButtonClick",
        value: function onUnselectAllButtonClick() {
            this.taskListController.unselectAll();
        }
    }, {
        key: "_updateTaskListController",
        value: function _updateTaskListController() {
            var user = this.state.user;
            this.taskListController.setData(user ? user.id : -1, user ? _UserNameFormat2.default.formatFML(user.firstName, user.lastName, user.middleName) : '', this.state.preSelectedCustomerIds, this.state.preSelectedProjectIds, this.state.preSelectedTaskIds);
        }
    }, {
        key: "_updateCustomerProjectSelection",
        value: function _updateCustomerProjectSelection(_ref3) {
            var customerId = _ref3.customerId,
                projectId = _ref3.projectId;

            this.closeFilter(true);

            if (customerId || projectId) {
                this.$panel.find(".pleaseSelectCustomerOrProject").hide();
                this.$panel.find(".selectorFilterButton").prop('disabled', false);
                this.taskListController.makeInitialRequest(customerId, projectId);
            } else {
                this.taskListController.clear();
                this.$panel.find(".pleaseSelectCustomerOrProject").show();
                this.$panel.find(".selectorFilterButton").prop('disabled', true);
            }

            var allSelectedAllowed = false;
            if (this.canSelectAllInCustomer && !!customerId) {
                this.$selectAllLabel.text(this._selectAllForCustomerMessage());
                allSelectedAllowed = true;
            } else if (this.canSelectAllInProject && !!projectId) {
                this.$selectAllLabel.text(this._selectAllForProjectMessage());
                allSelectedAllowed = true;
            }
            this.$panel.toggleClass("allSelectedAllowed", allSelectedAllowed);
        }
    }, {
        key: "_updateAllSelected",
        value: function _updateAllSelected() {
            var _state = this.state,
                allSelected = _state.allSelected,
                allSelectedDisabled = _state.allSelectedDisabled;

            if (allSelected) {
                this.$selectAllCheckbox.attr("checked", "checked");
                this.taskListController.selectAll();
            } else {
                this.$selectAllCheckbox.removeAttr("checked");
                if (this.taskListController.isSelectAllRows()) {
                    this.taskListController.unselectAll();
                }
            }
            this.$selectAllCheckbox.attr('disabled', allSelectedDisabled);
            this.$panel.toggleClass("allSelected", allSelected);
        }
    }, {
        key: "_isButtonEnabled",
        value: function _isButtonEnabled() {
            return this.state.allSelected || this.state.selectedTaskIds.length !== 0;
        }
    }, {
        key: "_updateApplyButtonEnabled",
        value: function _updateApplyButtonEnabled() {
            var applyButtonDisabled = !this._isButtonEnabled();
            this.$applyButton.toggleClass("disabled", applyButtonDisabled);
            this.$applyButton.prop("disabled", applyButtonDisabled);
        }
    }, {
        key: "_selectAllForCustomerMessage",
        value: function _selectAllForCustomerMessage() {
            return _messageResource2.default.getMessage("task_selector.select_all_for_customer");
        }
    }, {
        key: "_selectAllForProjectMessage",
        value: function _selectAllForProjectMessage() {
            return _messageResource2.default.getMessage("task_selector.select_all_for_project");
        }
    }], [{
        key: "cpSelectorControllerTemplateHtml",
        value: function cpSelectorControllerTemplateHtml() {
            return "<div class='customerProjectSelector #divClassName'>" + "    <table cellpadding='0' cellspacing='0' class='combobox'>" + "        <tr>" + "            <td><input type='text' maxlength='<%=maxNameLength%>' autocapitalize='off' autocorrect='off' autocomplete='off' spellcheck='false'></td>" + "            <td class='dropdownButton'>&nbsp;</td>" + "        </tr>" + "    </table>" + "    <div class='cpDropdown hidden'>" + "        <div class='cpList'>" + "            <div class='noEntriesMsg'><%-cpSelectorEmptyActive%></div>" + "            <div class='noMatchesMsg'><%-cpSelectorNothingFoundActive%></div>" + "            <div class='templates' style='display: none'>" + "                <table class='row customer' cellpadding='0' cellspacing='0'>" + "                    <tr>" + "                        <td class='name'>#</td>" + "                        <td class='expandCollapseCell'><button class='expandCollapse'></button></td>" + "                    </tr>" + "                </table>" + "                <div class='row project' style='display: none'>" + "                    <span class='name'>#</span>" + "                </div>" + "                <div class='projectsTrailer'></div>" + "            </div>" + "        </div>" + "        <div class='bottomBar'>" + "            <button class='expandAll'><%-expandAll%></button>" + "            <button class='collapseAll'><%-collapseAll%></button>" + "        </div>" + "    </div>" + "</div>";
        }
    }]);

    return BaseTaskSelector;
}(_TemplateView3.default);

exports.default = BaseTaskSelector;

/***/ }),
/* 1415 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CreateTasksLightboxFooter = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _Button = __webpack_require__(33);

var _Button2 = _interopRequireDefault(_Button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CreateTasksLightboxFooter = exports.CreateTasksLightboxFooter = function (_TemplateView) {
    _inherits(CreateTasksLightboxFooter, _TemplateView);

    function CreateTasksLightboxFooter() {
        _classCallCheck(this, CreateTasksLightboxFooter);

        return _possibleConstructorReturn(this, (CreateTasksLightboxFooter.__proto__ || Object.getPrototypeOf(CreateTasksLightboxFooter)).call(this));
    }

    _createClass(CreateTasksLightboxFooter, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class="createLightBoxFooter">' + '    <div class="errorMessageBox">' + '        <div class="errorIcon"/>' + '        <span class="errormsg"></span>' + '    </div>' + '    <div class="buttonsBox">' + '        <span class="changesMsg"><%-changeMsg%></span>' + '        <span class="savingMsg"><%-savingMsg%></span>' + '        <div class="commitButtonPlaceHolder"/> ' + '        <div class="greyButton cancelBtn"><%-cancelMsg%></div>' + '    </div>' + '</div>';
        }
    }, {
        key: 'messageKeys',
        value: function messageKeys() {
            return {
                changeMsg: 'add_new_tasks.not_saved',
                savingMsg: 'add_new_tasks.saving',
                cancelMsg: 'common.cancel'
            };
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            var title = _messageResource2.default.getMessage("add_new_tasks.create_tasks_btn_title");
            if (title.length > 17) {
                title = _messageResource2.default.getMessage("add_new_tasks.default_create_tasks_btn_title");
            }
            this.commitButton = new _Button2.default({
                label: title,
                withPlusIcon: true
            }).init(this.find('.commitButtonPlaceHolder'));
        }
    }, {
        key: 'getCommitBtnEl',
        value: function getCommitBtnEl() {
            return this.commitButton.getEl();
        }
    }, {
        key: 'getCancelBtnEl',
        value: function getCancelBtnEl() {
            return this.find('.cancelBtn');
        }
    }]);

    return CreateTasksLightboxFooter;
}(_TemplateView3.default);

exports.default = CreateTasksLightboxFooter;

/***/ }),
/* 1416 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _ReportDescriptionSection = __webpack_require__(1417);

var _ReportDescriptionSection2 = _interopRequireDefault(_ReportDescriptionSection);

var _ChooseReportSection = __webpack_require__(1431);

var _ChooseReportSection2 = _interopRequireDefault(_ChooseReportSection);

var _constants = __webpack_require__(11);

var _utils = __webpack_require__(6);

var _redux = __webpack_require__(7);

var _selectors = __webpack_require__(19);

var _selectors2 = __webpack_require__(15);

var _selectors3 = __webpack_require__(1432);

var _actions = __webpack_require__(1433);

var _utils2 = __webpack_require__(792);

var _selectors4 = __webpack_require__(1434);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ChooseReportComponent = function (_TemplateView) {
    _inherits(ChooseReportComponent, _TemplateView);

    function ChooseReportComponent(_ref) {
        var _ref$reportUrls = _ref.reportUrls,
            reportUrls = _ref$reportUrls === undefined ? {} : _ref$reportUrls,
            _ref$reportNameKeys = _ref.reportNameKeys,
            reportNameKeys = _ref$reportNameKeys === undefined ? {} : _ref$reportNameKeys,
            _ref$changeTab = _ref.changeTab,
            changeTab = _ref$changeTab === undefined ? function () {} : _ref$changeTab;

        _classCallCheck(this, ChooseReportComponent);

        var _this = _possibleConstructorReturn(this, (ChooseReportComponent.__proto__ || Object.getPrototypeOf(ChooseReportComponent)).call(this));

        _this.params = {
            reportUrls: reportUrls,
            reportNameKeys: reportNameKeys
        };

        _this.actions = {
            changeTab: changeTab
        };

        _this.state = {
            selectedType: null,
            userRights: {},
            userInDar: false,
            overtimeAvailable: false,
            hasSick: false,
            hasPTO: false
        };

        _this.onAnyStatePropertyChanged(['selectedType', 'userRights', 'features', 'userInDar', 'hasSick', 'hasPTO', 'overtimeAvailable'], function (state) {
            _this.chooseReport.setState({
                selectedType: state.selectedType,
                userRights: state.userRights,
                features: state.features
            });

            _this.descriptionReport.setState({
                selectedType: state.selectedType,
                userInDar: state.userInDar,
                overtimeAvailable: state.overtimeAvailable,
                enabledFeatures: state.features,
                userRights: state.userRights,
                hasSick: state.hasSick,
                hasPTO: state.hasPTO
            });

            var isBillingTab = state.tab === _constants.ReportType.BILLING_SUMMARY || state.tab === _constants.ReportType.INVOICING || state.tab === _constants.ReportType.COST_OF_WORK || state.tab === _constants.ReportType.PROFIT_LOSS;
            _this.find('.reportDescription_section').toggleClass('timeReport', !isBillingTab);
            _this.find('.reportDescription_section').toggleClass('billingReport', isBillingTab);
        });
        return _this;
    }

    _createClass(ChooseReportComponent, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return "<div class='chooseReport_content'>" + "  <div class='chooseReport_section'></div>" + "  <div class='reportDescription_section'></div>" + "</div>";
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            var _this2 = this;

            this.chooseReport = new _ChooseReportSection2.default({
                reportNameKeys: this.params.reportNameKeys,
                tabSelected: function tabSelected(tab) {
                    return _this2.actions.changeTab(tab);
                }
            }).init(this.find('.chooseReport_section'));

            this.descriptionReport = new _ReportDescriptionSection2.default({
                reportNameKeys: this.params.reportNameKeys,
                reportUrls: this.params.reportUrls
            }).init(this.find('.reportDescription_section'));

            var selectedType = Object.values(_constants.ReportType).find(function (type) {
                return (0, _utils2.isReportAvailable)(type, _this2.state.userRights, _this2.state.features);
            });

            this.actions.changeTab(!!selectedType ? selectedType : _constants.ReportType.STAFF_PERFORMANCE);
        }
    }]);

    return ChooseReportComponent;
}(_TemplateView3.default);

exports.default = (0, _utils.connect)(function (state) {
    return {
        selectedType: (0, _selectors3.getSelectedTab)(state),
        userRights: (0, _selectors.getAccessRights)(state),
        features: (0, _selectors2.selectFeatures)(state),
        hasPTO: (0, _selectors.hasPto)(state),
        hasSick: (0, _selectors.hasSick)(state),
        overtimeAvailable: (0, _selectors4.isOvertimeAvailable)(state),
        userInDar: (0, _selectors4.isAllUsersTimeTrackAvailable)(state)
    };
}, function (dispatch) {
    return {
        changeTab: (0, _redux.bindActionCreators)(_actions.changeTab, dispatch)
    };
})(ChooseReportComponent);

/***/ }),
/* 1417 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _constants = __webpack_require__(11);

var _StaffPerformanceDescriptionStrategy = __webpack_require__(1418);

var _StaffPerformanceDescriptionStrategy2 = _interopRequireDefault(_StaffPerformanceDescriptionStrategy);

var _OvertimeDescriptionStrategy = __webpack_require__(1419);

var _OvertimeDescriptionStrategy2 = _interopRequireDefault(_OvertimeDescriptionStrategy);

var _LeaveTimeDescriptionStrategy = __webpack_require__(1420);

var _LeaveTimeDescriptionStrategy2 = _interopRequireDefault(_LeaveTimeDescriptionStrategy);

var _TimeTrackDetailDescriptionStrategy = __webpack_require__(1421);

var _TimeTrackDetailDescriptionStrategy2 = _interopRequireDefault(_TimeTrackDetailDescriptionStrategy);

var _EstimateVsActualDescriptionStrategy = __webpack_require__(1422);

var _EstimateVsActualDescriptionStrategy2 = _interopRequireDefault(_EstimateVsActualDescriptionStrategy);

var _BillingSummaryDescriptionStrategy = __webpack_require__(1423);

var _BillingSummaryDescriptionStrategy2 = _interopRequireDefault(_BillingSummaryDescriptionStrategy);

var _InvoiceDescriptionStrategy = __webpack_require__(1424);

var _InvoiceDescriptionStrategy2 = _interopRequireDefault(_InvoiceDescriptionStrategy);

var _CostOfWorkDescriptionStrategy = __webpack_require__(1425);

var _CostOfWorkDescriptionStrategy2 = _interopRequireDefault(_CostOfWorkDescriptionStrategy);

var _ProfitLossDescriptionStrategy = __webpack_require__(1426);

var _ProfitLossDescriptionStrategy2 = _interopRequireDefault(_ProfitLossDescriptionStrategy);

var _CustomFieldsDescriptionStrategy = __webpack_require__(1427);

var _CustomFieldsDescriptionStrategy2 = _interopRequireDefault(_CustomFieldsDescriptionStrategy);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _WorkStatusesDescriptionStrategy = __webpack_require__(1428);

var _WorkStatusesDescriptionStrategy2 = _interopRequireDefault(_WorkStatusesDescriptionStrategy);

var _TimeCardsDescriptionStrategy = __webpack_require__(1429);

var _TimeCardsDescriptionStrategy2 = _interopRequireDefault(_TimeCardsDescriptionStrategy);

var _TimeTrackDescriptionStrategy = __webpack_require__(1430);

var _TimeTrackDescriptionStrategy2 = _interopRequireDefault(_TimeTrackDescriptionStrategy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ReportDescriptionSection = function (_TemplateView) {
    _inherits(ReportDescriptionSection, _TemplateView);

    function ReportDescriptionSection(_ref) {
        var _ref$reportUrls = _ref.reportUrls,
            reportUrls = _ref$reportUrls === undefined ? {} : _ref$reportUrls,
            _ref$reportNameKeys = _ref.reportNameKeys,
            reportNameKeys = _ref$reportNameKeys === undefined ? {} : _ref$reportNameKeys;

        _classCallCheck(this, ReportDescriptionSection);

        var _this = _possibleConstructorReturn(this, (ReportDescriptionSection.__proto__ || Object.getPrototypeOf(ReportDescriptionSection)).call(this));

        _this.params = {
            reportUrls: reportUrls,
            reportNameKeys: reportNameKeys
        };

        _this.state = {
            selectedType: null,

            userInDar: false,
            overtimeAvailable: false,
            enabledFeatures: {},
            userRights: {},
            hasSick: false,
            hasPTO: false
        };

        _this.onAnyStatePropertyChanged(['selectedType'], function (state) {
            var generator = _this.generators[state.selectedType];

            generator.setState(state);

            _this.$header.text(generator.getHeader());
            _this.$description.html(generator.getDescription());
            _this.$detailsLink.off().click(function () {
                return generator.getDetailsCallback();
            });
            _this.$configureButton.off().click(function () {
                return generator.getGenerateCallback();
            });
        });
        return _this;
    }

    _createClass(ReportDescriptionSection, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class="sectionContent">' + '  <div class="header"></div>' + '  <div class="description"></div>' + '  <div class="details">' + '   <span class="link"><%-details%></span><span>>></span>' + '  </div>' + '  <div class="configureButton components_button"><%-configureButton%></div>' + '</div>';
        }
    }, {
        key: 'templateModel',
        value: function templateModel() {
            return {
                details: _messageResource2.default.getMessage('dashboard.description.see_details'),
                configureButton: _messageResource2.default.getMessage('dashboard.description.configure_button')
            };
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            var _generators;

            this.$header = this.find('.header');
            this.$description = this.find('.description');
            this.$detailsLink = this.find('.details .link');
            this.$configureButton = this.find('.configureButton');

            this.generators = (_generators = {}, _defineProperty(_generators, _constants.ReportType.STAFF_PERFORMANCE, new _StaffPerformanceDescriptionStrategy2.default({
                name: this.params.reportNameKeys[_constants.ReportType.STAFF_PERFORMANCE],
                reportUrl: this.params.reportUrls[_constants.ReportType.STAFF_PERFORMANCE]
            })), _defineProperty(_generators, _constants.ReportType.OVERTIME, new _OvertimeDescriptionStrategy2.default({
                name: this.params.reportNameKeys[_constants.ReportType.OVERTIME],
                reportUrl: this.params.reportUrls[_constants.ReportType.OVERTIME]
            })), _defineProperty(_generators, _constants.ReportType.LEAVE_TIME, new _LeaveTimeDescriptionStrategy2.default({
                name: this.params.reportNameKeys[_constants.ReportType.LEAVE_TIME],
                reportUrl: this.params.reportUrls[_constants.ReportType.LEAVE_TIME]
            })), _defineProperty(_generators, _constants.ReportType.TIME_TRACK, new _TimeTrackDescriptionStrategy2.default({
                reportUrl: this.params.reportUrls[_constants.ReportType.TIME_TRACK]
            })), _defineProperty(_generators, _constants.ReportType.TIME_TRACK_IN_DETAIL, new _TimeTrackDetailDescriptionStrategy2.default({
                name: this.params.reportNameKeys[_constants.ReportType.TIME_TRACK_IN_DETAIL],
                reportUrl: this.params.reportUrls[_constants.ReportType.TIME_TRACK_IN_DETAIL]
            })), _defineProperty(_generators, _constants.ReportType.ESTIMATED_VS_ACTUAL, new _EstimateVsActualDescriptionStrategy2.default({
                name: this.params.reportNameKeys[_constants.ReportType.ESTIMATED_VS_ACTUAL],
                reportUrl: this.params.reportUrls[_constants.ReportType.ESTIMATED_VS_ACTUAL]
            })), _defineProperty(_generators, _constants.ReportType.BILLING_SUMMARY, new _BillingSummaryDescriptionStrategy2.default({
                name: this.params.reportNameKeys[_constants.ReportType.BILLING_SUMMARY],
                reportUrl: this.params.reportUrls[_constants.ReportType.BILLING_SUMMARY]
            })), _defineProperty(_generators, _constants.ReportType.INVOICING, new _InvoiceDescriptionStrategy2.default({
                name: this.params.reportNameKeys[_constants.ReportType.INVOICING],
                reportUrl: this.params.reportUrls[_constants.ReportType.INVOICING]
            })), _defineProperty(_generators, _constants.ReportType.COST_OF_WORK, new _CostOfWorkDescriptionStrategy2.default({
                name: this.params.reportNameKeys[_constants.ReportType.COST_OF_WORK],
                reportUrl: this.params.reportUrls[_constants.ReportType.COST_OF_WORK]
            })), _defineProperty(_generators, _constants.ReportType.PROFIT_LOSS, new _ProfitLossDescriptionStrategy2.default({
                name: this.params.reportNameKeys[_constants.ReportType.PROFIT_LOSS],
                reportUrl: this.params.reportUrls[_constants.ReportType.PROFIT_LOSS]
            })), _defineProperty(_generators, _constants.ReportType.CUSTOM_FIELDS, new _CustomFieldsDescriptionStrategy2.default({
                reportUrl: this.params.reportUrls[_constants.ReportType.CUSTOM_FIELDS]
            })), _defineProperty(_generators, _constants.ReportType.WORK_STATUSES, new _WorkStatusesDescriptionStrategy2.default({
                reportUrl: this.params.reportUrls[_constants.ReportType.WORK_STATUSES]
            })), _defineProperty(_generators, _constants.ReportType.TIME_CARDS, new _TimeCardsDescriptionStrategy2.default({
                reportUrl: this.params.reportUrls[_constants.ReportType.TIME_CARDS]
            })), _generators);
        }
    }]);

    return ReportDescriptionSection;
}(_TemplateView3.default);

exports.default = ReportDescriptionSection;

/***/ }),
/* 1418 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _DescriptionStrategy2 = __webpack_require__(84);

var _DescriptionStrategy3 = _interopRequireDefault(_DescriptionStrategy2);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _constants = __webpack_require__(78);

var _constants2 = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var StaffPerformanceDescriptionStrategy = function (_DescriptionStrategy) {
    _inherits(StaffPerformanceDescriptionStrategy, _DescriptionStrategy);

    function StaffPerformanceDescriptionStrategy(_ref) {
        var _ref$name = _ref.name,
            name = _ref$name === undefined ? '' : _ref$name,
            _ref$reportUrl = _ref.reportUrl,
            reportUrl = _ref$reportUrl === undefined ? '' : _ref$reportUrl;

        _classCallCheck(this, StaffPerformanceDescriptionStrategy);

        var _this = _possibleConstructorReturn(this, (StaffPerformanceDescriptionStrategy.__proto__ || Object.getPrototypeOf(StaffPerformanceDescriptionStrategy)).call(this));

        _this.params = {
            reportUrl: reportUrl,
            name: name
        };

        _this.state = {
            userInDar: false,
            enabledFeatures: {},
            userRights: {}
        };

        _this.userType = null;

        _this.onStatePropertyChanged('userRights', function (userRights) {
            if (userRights[_constants2.AccessRights.MANAGE_USERS]) _this.userType = UserTypes.MANAGE_ALL;else if (userRights[_constants2.AccessRights.EDIT_HIERARCHY] || userRights[_constants2.AccessRights.GENERATE_MONEY_REPORTS] || userRights[_constants2.AccessRights.SUBMIT_OTHER_USER_TIME_TRACK]) {
                _this.userType = userRights[_constants2.AccessRights.SUBMIT_TIME_TRACK] ? UserTypes.SCOPE_WITH_TT : UserTypes.SCOPE_WITHOUT_TT;
            } else {
                _this.userType = userRights[_constants2.AccessRights.SUBMIT_TIME_TRACK] ? UserTypes.REGULAR_WITH_TT : UserTypes.REGULAR_WITHOUT_TT;
            }
        });
        return _this;
    }

    _createClass(StaffPerformanceDescriptionStrategy, [{
        key: 'getHeader',
        value: function getHeader() {
            return _messageResource2.default.getMessage(this.params.name) + ' ' + _messageResource2.default.getMessage('report.common.report');
        }
    }, {
        key: 'getDescription',
        value: function getDescription() {
            var inDar = this.state.userInDar;
            var leaveTimeFeature = this.state.enabledFeatures[_constants.Feature.LVT];

            var yourTeam = void 0;
            var firstParagraph = void 0;
            var secondParagraph = void 0;
            var thirdParagraph = void 0;
            switch (this.userType) {
                case UserTypes.REGULAR_WITH_TT:
                    firstParagraph = _messageResource2.default.getEscapedMessage('dashboard.description.staff_output.regular_with_entertt.part1');
                    secondParagraph = _messageResource2.default.getEscapedMessage('dashboard.description.staff_output.regular_with_entertt.part2');
                    thirdParagraph = inDar ? _messageResource2.default.getEscapedMessage('dashboard.description.staff_output.regular_with_entertt.part3.dar') : _messageResource2.default.getEscapedMessage('dashboard.description.staff_output.regular_with_entertt.part3.not_dar');
                    return this._createDescription(firstParagraph, secondParagraph, thirdParagraph);
                case UserTypes.REGULAR_WITHOUT_TT:
                    return '';
                case UserTypes.SCOPE_WITH_TT:
                    yourTeam = inDar ? _messageResource2.default.getEscapedMessage('dashboard.description.all_team') : _messageResource2.default.getEscapedMessage('dashboard.description.your_team');
                    firstParagraph = _messageResource2.default.getEscapedMessage('dashboard.description.staff_output.scope_with_entertt.part1', [yourTeam, leaveTimeFeature ? _messageResource2.default.getEscapedMessage('dashboard.description.staff_output.scope_with_entertt.part1.leave_feature') : '']);
                    secondParagraph = _messageResource2.default.getEscapedMessage('dashboard.description.staff_output.scope_with_entertt.part2');
                    thirdParagraph = inDar ? '' : _messageResource2.default.getEscapedMessage('dashboard.description.staff_output.scope_with_entertt.part3');
                    return this._createDescription(firstParagraph, secondParagraph, thirdParagraph);
                case UserTypes.SCOPE_WITHOUT_TT:
                    yourTeam = inDar ? _messageResource2.default.getEscapedMessage('dashboard.description.all_team') : _messageResource2.default.getEscapedMessage('dashboard.description.your_team');
                    firstParagraph = _messageResource2.default.getEscapedMessage('dashboard.description.staff_output.scope_without_entertt.part1', [yourTeam, leaveTimeFeature ? _messageResource2.default.getEscapedMessage('dashboard.description.staff_output.scope_without_entertt.part1.leave_feature') : '']);
                    secondParagraph = _messageResource2.default.getEscapedMessage('dashboard.description.staff_output.scope_without_entertt.part2');
                    thirdParagraph = inDar ? '' : _messageResource2.default.getEscapedMessage('dashboard.description.staff_output.scope_without_entertt.part3');
                    return this._createDescription(firstParagraph, secondParagraph, thirdParagraph);
                case UserTypes.MANAGE_ALL:
                    firstParagraph = _messageResource2.default.getEscapedMessage('dashboard.description.staff_output.ap_permission.part1');
                    secondParagraph = _messageResource2.default.getEscapedMessage('dashboard.description.staff_output.ap_permission.part2');
                    thirdParagraph = leaveTimeFeature ? _messageResource2.default.getEscapedMessage('dashboard.description.staff_output.ap_permission.part3') : '';
                    return this._createDescription(firstParagraph, secondParagraph, thirdParagraph);
                default:
                    return '';
            }
        }
    }, {
        key: '_createDescription',
        value: function _createDescription(first, second, third) {
            return '<div>' + '  <div class="firstParagraph">' + first + '</div>' + '  <div class="secondParagraph">' + second + '</div>' + '  <div class="thirdParagraph">' + third + '</div>' + '</div>';
        }
    }, {
        key: 'getDetailsCallback',
        value: function getDetailsCallback() {
            openUserGuidePage('reporting#report-staff-performance');
        }
    }, {
        key: 'getGenerateCallback',
        value: function getGenerateCallback() {
            window.location.href = this.params.reportUrl;
        }
    }]);

    return StaffPerformanceDescriptionStrategy;
}(_DescriptionStrategy3.default);

exports.default = StaffPerformanceDescriptionStrategy;


var UserTypes = {
    REGULAR_WITH_TT: 'RegularUserWithEnterTT',
    REGULAR_WITHOUT_TT: 'RegularUserWithoutEnterTT',
    SCOPE_WITH_TT: 'ScopeUserWithEnterTT',
    SCOPE_WITHOUT_TT: 'ScopeUserWithoutEnterTT',
    MANAGE_ALL: 'ManageAccountsUser'
};

/***/ }),
/* 1419 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _DescriptionStrategy2 = __webpack_require__(84);

var _DescriptionStrategy3 = _interopRequireDefault(_DescriptionStrategy2);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _constants = __webpack_require__(78);

var _constants2 = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OvertimeDescriptionStrategy = function (_DescriptionStrategy) {
    _inherits(OvertimeDescriptionStrategy, _DescriptionStrategy);

    function OvertimeDescriptionStrategy(_ref) {
        var _ref$reportUrl = _ref.reportUrl,
            reportUrl = _ref$reportUrl === undefined ? '' : _ref$reportUrl,
            _ref$name = _ref.name,
            name = _ref$name === undefined ? '' : _ref$name;

        _classCallCheck(this, OvertimeDescriptionStrategy);

        var _this = _possibleConstructorReturn(this, (OvertimeDescriptionStrategy.__proto__ || Object.getPrototypeOf(OvertimeDescriptionStrategy)).call(this));

        _this.params = {
            reportUrl: reportUrl,
            name: name
        };

        _this.state = {
            userInDar: false,
            enabledFeatures: {},
            userRights: {},
            overtimeAvailable: false
        };

        _this.userType = null;

        _this.onStatePropertyChanged('userRights', function (userRights) {
            if (userRights[_constants2.AccessRights.MANAGE_PTO_AND_SICK] || userRights[_constants2.AccessRights.MANAGE_USERS]) _this.userType = UserTypes.MANAGE_PTO_AND_AP;else if (userRights[_constants2.AccessRights.SUBMIT_OTHER_USER_TIME_TRACK]) {
                _this.userType = UserTypes.USER_WITH_MODIFY_OTHERS;
            } else {
                _this.userType = userRights[_constants2.AccessRights.SUBMIT_TIME_TRACK] ? UserTypes.REGULAR_WITH_TT : UserTypes.REGULAR_WITHOUT_TT;
            }
        });
        return _this;
    }

    _createClass(OvertimeDescriptionStrategy, [{
        key: 'getHeader',
        value: function getHeader() {
            return _messageResource2.default.getMessage(this.params.name) + ' ' + _messageResource2.default.getMessage('report.common.report');
        }
    }, {
        key: 'getDescription',
        value: function getDescription() {
            var overtimeAvailable = this.state.overtimeAvailable;
            var overtimeFeatureEnabled = !!this.state.enabledFeatures[_constants.Feature.OVR];
            var leaveTimeFeature = !!this.state.enabledFeatures[_constants.Feature.LVT];

            var firstParagraph = void 0;
            var secondParagraph = void 0;
            var thirdParagraph = void 0;
            switch (this.userType) {
                case UserTypes.REGULAR_WITH_TT:
                    firstParagraph = overtimeAvailable ? _messageResource2.default.getEscapedMessage('dashboard.description.overtime.regular_with_tt.part1.overtime') : _messageResource2.default.getEscapedMessage('dashboard.description.overtime.regular_with_tt.part1');
                    secondParagraph = overtimeAvailable ? _messageResource2.default.getEscapedMessage('dashboard.description.overtime.regular_with_tt.part2.overtime') : _messageResource2.default.getEscapedMessage('dashboard.description.overtime.regular_with_tt.part2');
                    thirdParagraph = leaveTimeFeature ? _messageResource2.default.getEscapedMessage('dashboard.description.overtime.regular_with_tt.part3') : '';
                    return this._createDescription(firstParagraph, secondParagraph, thirdParagraph);
                case UserTypes.REGULAR_WITHOUT_TT:
                    return '';
                case UserTypes.MANAGE_PTO_AND_AP:
                    firstParagraph = overtimeFeatureEnabled ? _messageResource2.default.getEscapedMessage('dashboard.description.overtime.user_modify_or_ap.part1.overtime') : _messageResource2.default.getEscapedMessage('dashboard.description.overtime.user_modify_or_ap.part1');
                    secondParagraph = overtimeFeatureEnabled ? _messageResource2.default.getEscapedMessage('dashboard.description.overtime.user_modify_or_ap.part2.overtime') : _messageResource2.default.getEscapedMessage('dashboard.description.overtime.user_modify_or_ap.part2');
                    thirdParagraph = leaveTimeFeature ? _messageResource2.default.getEscapedMessage('dashboard.description.overtime.user_modify_or_ap.part3') : '';
                    return this._createDescription(firstParagraph, secondParagraph, thirdParagraph);
                case UserTypes.USER_WITH_MODIFY_OTHERS:
                    firstParagraph = overtimeFeatureEnabled ? _messageResource2.default.getEscapedMessage('dashboard.description.overtime.user_submit_other_tt.part1.overtime') : _messageResource2.default.getEscapedMessage('dashboard.description.overtime.user_submit_other_tt.part1');
                    secondParagraph = overtimeFeatureEnabled ? _messageResource2.default.getEscapedMessage('dashboard.description.overtime.user_submit_other_tt.part2.overtime') : _messageResource2.default.getEscapedMessage('dashboard.description.overtime.user_submit_other_tt.part2');
                    thirdParagraph = leaveTimeFeature ? _messageResource2.default.getEscapedMessage('dashboard.description.overtime.user_submit_other_tt.part3') : '';
                    return this._createDescription(firstParagraph, secondParagraph, thirdParagraph);
            }
        }
    }, {
        key: '_createDescription',
        value: function _createDescription(first, second, third) {
            return '<div>' + '  <div class="firstParagraph">' + first + '</div>' + '  <div class="secondParagraph">' + second + '</div>' + '  <div class="thirdParagraph">' + third + '</div>' + '</div>';
        }
    }, {
        key: 'getDetailsCallback',
        value: function getDetailsCallback() {
            openUserGuidePage('reporting#report-overtime');
        }
    }, {
        key: 'getGenerateCallback',
        value: function getGenerateCallback() {
            window.location.href = this.params.reportUrl;
        }
    }]);

    return OvertimeDescriptionStrategy;
}(_DescriptionStrategy3.default);

exports.default = OvertimeDescriptionStrategy;


var UserTypes = {
    REGULAR_WITH_TT: 'RegularUserWithEnterTT',
    REGULAR_WITHOUT_TT: 'RegularUserWithoutEnterTT',
    MANAGE_PTO_AND_AP: 'UserWithManagePTOandAPPermissions',
    USER_WITH_MODIFY_OTHERS: 'UserWithSubmitOtherTTRight'
};

/***/ }),
/* 1420 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _DescriptionStrategy2 = __webpack_require__(84);

var _DescriptionStrategy3 = _interopRequireDefault(_DescriptionStrategy2);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _constants = __webpack_require__(4);

var _constants2 = __webpack_require__(78);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LeaveTimeDescriptionStrategy = function (_DescriptionStrategy) {
    _inherits(LeaveTimeDescriptionStrategy, _DescriptionStrategy);

    function LeaveTimeDescriptionStrategy(_ref) {
        var _ref$reportUrl = _ref.reportUrl,
            reportUrl = _ref$reportUrl === undefined ? '' : _ref$reportUrl,
            _ref$name = _ref.name,
            name = _ref$name === undefined ? '' : _ref$name;

        _classCallCheck(this, LeaveTimeDescriptionStrategy);

        var _this = _possibleConstructorReturn(this, (LeaveTimeDescriptionStrategy.__proto__ || Object.getPrototypeOf(LeaveTimeDescriptionStrategy)).call(this));

        _this.params = {
            reportUrl: reportUrl,
            name: name
        };

        _this.state = {
            userInDar: false,
            enabledFeatures: {},
            userRights: {},
            hasSick: false,
            hasPTO: false
        };

        _this.userType = null;

        _this.onStatePropertyChanged('userRights', function (userRights) {
            if (userRights[_constants.AccessRights.MANAGE_PTO_AND_SICK] || userRights[_constants.AccessRights.MANAGE_USERS]) _this.userType = UserTypes.MANAGE_PTO_AND_AP;else if (userRights[_constants.AccessRights.SUBMIT_OTHER_USER_TIME_TRACK]) {
                _this.userType = UserTypes.USER_WITH_MODIFY_OTHERS;
            } else {
                _this.userType = userRights[_constants.AccessRights.SUBMIT_TIME_TRACK] ? UserTypes.REGULAR_WITH_TT : UserTypes.REGULAR_WITHOUT_TT;
            }
        });
        return _this;
    }

    _createClass(LeaveTimeDescriptionStrategy, [{
        key: 'getHeader',
        value: function getHeader() {
            return _messageResource2.default.getMessage(this.params.name) + ' ' + _messageResource2.default.getMessage('report.common.report');
        }
    }, {
        key: 'getDescription',
        value: function getDescription() {
            var sickFeatureEnabled = this.state.enabledFeatures[_constants2.Feature.SDB];
            var ptoFeatureEnabled = this.state.enabledFeatures[_constants2.Feature.PTO];
            var hasPTO = ptoFeatureEnabled && this.state.hasPTO;
            var hasSick = sickFeatureEnabled && this.state.hasSick;
            var userRights = this.state.userRights;
            var isPersonalReport = !userRights[_constants.AccessRights.MANAGE_PTO_AND_SICK] && !userRights[_constants.AccessRights.MANAGE_USERS] && !userRights[_constants.AccessRights.SUBMIT_OTHER_USER_TIME_TRACK];

            var balancesName = void 0;
            var balancesDisabled = void 0;
            if (isPersonalReport) {
                balancesName = hasPTO && hasSick ? _messageResource2.default.getMessage('dashboard.description.leavetime.both_balances') : hasSick ? _messageResource2.default.getMessage('dashboard.description.leavetime.sick_balance') : hasPTO ? _messageResource2.default.getMessage('dashboard.description.leavetime.pto_balance') : '';
                balancesDisabled = balancesName === '';
            } else {
                balancesName = sickFeatureEnabled && ptoFeatureEnabled ? _messageResource2.default.getMessage('dashboard.description.leavetime.both_balances') : sickFeatureEnabled ? _messageResource2.default.getMessage('dashboard.description.leavetime.sick_balance') : ptoFeatureEnabled ? _messageResource2.default.getMessage('dashboard.description.leavetime.pto_balance') : '';
                balancesDisabled = balancesName === '';
            }

            var firstParagraph = void 0;
            var secondParagraph = void 0;
            switch (this.userType) {
                case UserTypes.REGULAR_WITH_TT:
                    firstParagraph = _messageResource2.default.getEscapedMessage('dashboard.description.leavetime.regular_with_tt.part1');
                    if (!balancesDisabled) {
                        secondParagraph = _messageResource2.default.getEscapedMessage('dashboard.description.leavetime.regular_with_tt.part2', [balancesName]);
                    } else {
                        secondParagraph = _messageResource2.default.getEscapedMessage('dashboard.description.leavetime.regular_with_tt.part2.none_balance');
                    }
                    return this._createDescription(firstParagraph, secondParagraph);
                case UserTypes.REGULAR_WITHOUT_TT:
                    return '';
                case UserTypes.MANAGE_PTO_AND_AP:
                    firstParagraph = _messageResource2.default.getEscapedMessage('dashboard.description.leavetime.user_modify_or_ap.part1');
                    if (!balancesDisabled) {
                        secondParagraph = _messageResource2.default.getEscapedMessage('dashboard.description.leavetime.user_modify_or_ap.part2', [balancesName]);
                    } else {
                        secondParagraph = _messageResource2.default.getEscapedMessage('dashboard.description.leavetime.user_modify_or_ap.part2.none_balance');
                    }
                    return this._createDescription(firstParagraph, secondParagraph);
                case UserTypes.USER_WITH_MODIFY_OTHERS:
                    firstParagraph = _messageResource2.default.getEscapedMessage('dashboard.description.leavetime.user_submit_other_tt.part1');
                    if (!balancesDisabled) {
                        secondParagraph = _messageResource2.default.getEscapedMessage('dashboard.description.leavetime.user_submit_other_tt.part2', [balancesName]);
                    } else {
                        secondParagraph = _messageResource2.default.getEscapedMessage('dashboard.description.leavetime.user_submit_other_tt.part2.none_balance');
                    }
                    return this._createDescription(firstParagraph, secondParagraph);
            }
        }
    }, {
        key: '_createDescription',
        value: function _createDescription(first, second) {
            return '<div>' + '  <div class="firstParagraph">' + first + '</div>' + '  <div class="secondParagraph">' + second + '</div>' + '</div>';
        }
    }, {
        key: 'getDetailsCallback',
        value: function getDetailsCallback() {
            openUserGuidePage('reporting#report-leaves-balances');
        }
    }, {
        key: 'getGenerateCallback',
        value: function getGenerateCallback() {
            window.location.href = this.params.reportUrl;
        }
    }]);

    return LeaveTimeDescriptionStrategy;
}(_DescriptionStrategy3.default);

exports.default = LeaveTimeDescriptionStrategy;


var UserTypes = {
    REGULAR_WITH_TT: 'RegularUserWithEnterTT',
    REGULAR_WITHOUT_TT: 'RegularUserWithoutEnterTT',
    MANAGE_PTO_AND_AP: 'UserWithManagePTOandAPPermissions',
    USER_WITH_MODIFY_OTHERS: 'UserWithSubmitOtherTTRight'
};

/***/ }),
/* 1421 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _DescriptionStrategy2 = __webpack_require__(84);

var _DescriptionStrategy3 = _interopRequireDefault(_DescriptionStrategy2);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _constants = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TimeTrackDetailDescriptionStrategy = function (_DescriptionStrategy) {
    _inherits(TimeTrackDetailDescriptionStrategy, _DescriptionStrategy);

    function TimeTrackDetailDescriptionStrategy(_ref) {
        var _ref$reportUrl = _ref.reportUrl,
            reportUrl = _ref$reportUrl === undefined ? '' : _ref$reportUrl,
            _ref$name = _ref.name,
            name = _ref$name === undefined ? '' : _ref$name;

        _classCallCheck(this, TimeTrackDetailDescriptionStrategy);

        var _this = _possibleConstructorReturn(this, (TimeTrackDetailDescriptionStrategy.__proto__ || Object.getPrototypeOf(TimeTrackDetailDescriptionStrategy)).call(this));

        _this.params = {
            reportUrl: reportUrl,
            name: name
        };

        _this.state = {
            userInDar: false,
            enabledFeatures: {},
            userRights: {}
        };

        _this.userType = null;

        _this.onStatePropertyChanged('userRights', function (userRights) {
            if (userRights[_constants.AccessRights.MANAGE_USERS]) _this.userType = UserTypes.MANAGE_ALL;else if (userRights[_constants.AccessRights.EDIT_HIERARCHY] || userRights[_constants.AccessRights.GENERATE_MONEY_REPORTS] || userRights[_constants.AccessRights.SUBMIT_OTHER_USER_TIME_TRACK]) {
                _this.userType = UserTypes.SCOPE_USER;
            } else {
                _this.userType = userRights[_constants.AccessRights.SUBMIT_TIME_TRACK] ? UserTypes.REGULAR_WITH_TT : UserTypes.REGULAR_WITHOUT_TT;
            }
        });
        return _this;
    }

    _createClass(TimeTrackDetailDescriptionStrategy, [{
        key: 'getHeader',
        value: function getHeader() {
            return _messageResource2.default.getMessage(this.params.name) + ' ' + _messageResource2.default.getMessage('report.common.report');
        }
    }, {
        key: 'getDescription',
        value: function getDescription() {
            var firstParagraph = void 0;
            var secondParagraph = void 0;
            switch (this.userType) {
                case UserTypes.REGULAR_WITH_TT:
                    firstParagraph = _messageResource2.default.getEscapedMessage('dashboard.description.time_track_details.regular_with_entertt.part1');
                    secondParagraph = _messageResource2.default.getEscapedMessage('dashboard.description.time_track_details.regular_with_entertt.part2');
                    return this._createDescription(firstParagraph, secondParagraph);
                case UserTypes.REGULAR_WITHOUT_TT:
                    return '';
                case UserTypes.SCOPE_USER:
                    var inDar = this.state.userInDar;
                    var yourTeam = inDar ? _messageResource2.default.getEscapedMessage('dashboard.description.all_team') : _messageResource2.default.getEscapedMessage('dashboard.description.your_team');
                    firstParagraph = _messageResource2.default.getEscapedMessage('dashboard.description.time_track_details.scope_user.part1', [yourTeam]);
                    secondParagraph = _messageResource2.default.getEscapedMessage('dashboard.description.time_track_details.scope_user.part2');
                    return this._createDescription(firstParagraph, secondParagraph);
                case UserTypes.MANAGE_ALL:
                    firstParagraph = _messageResource2.default.getEscapedMessage('dashboard.description.time_track_details.ap_permission.part1');
                    secondParagraph = _messageResource2.default.getEscapedMessage('dashboard.description.time_track_details.ap_permission.part2');
                    return this._createDescription(firstParagraph, secondParagraph);
                default:
                    return '';
            }
        }
    }, {
        key: '_createDescription',
        value: function _createDescription(first, second) {
            return '<div>' + '  <div class="firstParagraph">' + first + '</div>' + '  <div class="secondParagraph">' + second + '</div>' + '</div>';
        }
    }, {
        key: 'getDetailsCallback',
        value: function getDetailsCallback() {
            openUserGuidePage('reporting#report-tt-detail');
        }
    }, {
        key: 'getGenerateCallback',
        value: function getGenerateCallback() {
            window.location.href = this.params.reportUrl;
        }
    }]);

    return TimeTrackDetailDescriptionStrategy;
}(_DescriptionStrategy3.default);

exports.default = TimeTrackDetailDescriptionStrategy;


var UserTypes = {
    REGULAR_WITH_TT: 'RegularUserWithEnterTT',
    REGULAR_WITHOUT_TT: 'RegularUserWithoutEnterTT',
    SCOPE_USER: 'ScopeUser',
    MANAGE_ALL: 'ManageAccountsUser'
};

/***/ }),
/* 1422 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _DescriptionStrategy2 = __webpack_require__(84);

var _DescriptionStrategy3 = _interopRequireDefault(_DescriptionStrategy2);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _constants = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EstimateVsActualDescriptionStrategy = function (_DescriptionStrategy) {
    _inherits(EstimateVsActualDescriptionStrategy, _DescriptionStrategy);

    function EstimateVsActualDescriptionStrategy(_ref) {
        var _ref$reportUrl = _ref.reportUrl,
            reportUrl = _ref$reportUrl === undefined ? '' : _ref$reportUrl,
            _ref$name = _ref.name,
            name = _ref$name === undefined ? '' : _ref$name;

        _classCallCheck(this, EstimateVsActualDescriptionStrategy);

        var _this = _possibleConstructorReturn(this, (EstimateVsActualDescriptionStrategy.__proto__ || Object.getPrototypeOf(EstimateVsActualDescriptionStrategy)).call(this));

        _this.params = {
            reportUrl: reportUrl,
            name: name
        };

        _this.state = {
            userInDar: false,
            enabledFeatures: {},
            userRights: {}
        };

        _this.userType = null;

        _this.onStatePropertyChanged('userRights', function (userRights) {
            if (userRights[_constants.AccessRights.MANAGE_USERS]) _this.userType = UserTypes.MANAGE_ALL;else if (userRights[_constants.AccessRights.EDIT_HIERARCHY] || userRights[_constants.AccessRights.GENERATE_MONEY_REPORTS] || userRights[_constants.AccessRights.SUBMIT_OTHER_USER_TIME_TRACK]) {
                _this.userType = userRights[_constants.AccessRights.SUBMIT_TIME_TRACK] ? UserTypes.SCOPE_WITH_TT : UserTypes.SCOPE_WITHOUT_TT;
            } else {
                _this.userType = userRights[_constants.AccessRights.SUBMIT_TIME_TRACK] ? UserTypes.REGULAR_WITH_TT : UserTypes.REGULAR_WITHOUT_TT;
            }
        });
        return _this;
    }

    _createClass(EstimateVsActualDescriptionStrategy, [{
        key: 'getHeader',
        value: function getHeader() {
            return _messageResource2.default.getMessage(this.params.name) + ' ' + _messageResource2.default.getMessage('report.common.report');
        }
    }, {
        key: 'getDescription',
        value: function getDescription() {
            var inDar = this.state.userInDar;
            var yourTeam = inDar ? _messageResource2.default.getEscapedMessage('dashboard.description.all_team') : _messageResource2.default.getEscapedMessage('dashboard.description.your_team');
            var firstParagraph = void 0;
            var secondParagraph = void 0;
            var thirdParagraph = void 0;
            switch (this.userType) {
                case UserTypes.REGULAR_WITH_TT:
                    firstParagraph = _messageResource2.default.getEscapedMessage('dashboard.description.estimate_vs_actual.regular_with_entertt.part1');
                    secondParagraph = _messageResource2.default.getEscapedMessage('dashboard.description.estimate_vs_actual.regular_with_entertt.part2');
                    thirdParagraph = inDar ? _messageResource2.default.getEscapedMessage('dashboard.description.estimate_vs_actual.regular_with_entertt.part3.dar') : _messageResource2.default.getEscapedMessage('dashboard.description.estimate_vs_actual.regular_with_entertt.part3.not_dar');
                    return this._createDescription(firstParagraph, secondParagraph, thirdParagraph);
                case UserTypes.REGULAR_WITHOUT_TT:
                    return '';
                case UserTypes.SCOPE_WITH_TT:
                    firstParagraph = _messageResource2.default.getEscapedMessage('dashboard.description.estimate_vs_actual.scope_with_entertt.part1', [yourTeam]);
                    return this._createDescription(firstParagraph, '', '');
                case UserTypes.SCOPE_WITHOUT_TT:
                    firstParagraph = _messageResource2.default.getEscapedMessage('dashboard.description.estimate_vs_actual.scope_without_entertt.part1', [yourTeam]);
                    secondParagraph = _messageResource2.default.getEscapedMessage('dashboard.description.estimate_vs_actual.scope_without_entertt.part2');
                    return this._createDescription(firstParagraph, secondParagraph, '');
                case UserTypes.MANAGE_ALL:
                    firstParagraph = _messageResource2.default.getEscapedMessage('dashboard.description.estimate_vs_actual.ap_permission.part1');
                    secondParagraph = _messageResource2.default.getEscapedMessage('dashboard.description.estimate_vs_actual.ap_permission.part2');
                    return this._createDescription(firstParagraph, secondParagraph, '');
                default:
                    return '';
            }
        }
    }, {
        key: '_createDescription',
        value: function _createDescription(first, second, third) {
            return '<div>' + '  <div class="firstParagraph">' + first + '</div>' + '  <div class="secondParagraph">' + second + '</div>' + '  <div class="thirdParagraph">' + third + '</div>' + '</div>';
        }
    }, {
        key: 'getDetailsCallback',
        value: function getDetailsCallback() {
            openUserGuidePage('reporting#report-estimated-actual');
        }
    }, {
        key: 'getGenerateCallback',
        value: function getGenerateCallback() {
            window.location.href = this.params.reportUrl;
        }
    }]);

    return EstimateVsActualDescriptionStrategy;
}(_DescriptionStrategy3.default);

exports.default = EstimateVsActualDescriptionStrategy;


var UserTypes = {
    REGULAR_WITH_TT: 'RegularUserWithEnterTT',
    REGULAR_WITHOUT_TT: 'RegularUserWithoutEnterTT',
    SCOPE_WITH_TT: 'ScopeUserWithEnterTT',
    SCOPE_WITHOUT_TT: 'ScopeUserWithoutEnterTT',
    MANAGE_ALL: 'ManageAccountsUser'
};

/***/ }),
/* 1423 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _DescriptionStrategy2 = __webpack_require__(84);

var _DescriptionStrategy3 = _interopRequireDefault(_DescriptionStrategy2);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _constants = __webpack_require__(4);

var _constants2 = __webpack_require__(78);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BillingSummaryDescriptionStrategy = function (_DescriptionStrategy) {
    _inherits(BillingSummaryDescriptionStrategy, _DescriptionStrategy);

    function BillingSummaryDescriptionStrategy(_ref) {
        var _ref$reportUrl = _ref.reportUrl,
            reportUrl = _ref$reportUrl === undefined ? '' : _ref$reportUrl,
            _ref$name = _ref.name,
            name = _ref$name === undefined ? '' : _ref$name;

        _classCallCheck(this, BillingSummaryDescriptionStrategy);

        var _this = _possibleConstructorReturn(this, (BillingSummaryDescriptionStrategy.__proto__ || Object.getPrototypeOf(BillingSummaryDescriptionStrategy)).call(this));

        _this.params = {
            reportUrl: reportUrl,
            name: name
        };

        _this.state = {
            userInDar: false,
            enabledFeatures: {},
            userRights: {}
        };

        _this.userType = null;

        _this.onStatePropertyChanged('userRights', function (userRights) {
            if (userRights[_constants.AccessRights.GENERATE_MONEY_REPORTS]) _this.userType = UserTypes.MANAGE_BILLING_REPORT;else _this.userType = UserTypes.REGULAR;
        });
        return _this;
    }

    _createClass(BillingSummaryDescriptionStrategy, [{
        key: 'getHeader',
        value: function getHeader() {
            return _messageResource2.default.getMessage(this.params.name) + ' ' + _messageResource2.default.getMessage('report.common.report');
        }
    }, {
        key: 'getDescription',
        value: function getDescription() {
            var BRAEnabled = this.state.enabledFeatures[_constants2.Feature.BRA];
            var firstParagraph = void 0;
            var secondParagraph = void 0;
            switch (this.userType) {
                case UserTypes.MANAGE_BILLING_REPORT:
                    firstParagraph = BRAEnabled ? _messageResource2.default.getEscapedMessage('dashboard.description.billing_summary.user_with_right.part1') : _messageResource2.default.getEscapedMessage('dashboard.description.billing_summary.user_with_right.part1.without_feature');
                    secondParagraph = BRAEnabled ? _messageResource2.default.getEscapedMessage('dashboard.description.billing_summary.user_with_right.part2') : _messageResource2.default.getEscapedMessage('dashboard.description.billing_summary.user_with_right.part2.without_feature');
                    return this._createDescription(firstParagraph, secondParagraph);
                case UserTypes.REGULAR:
                    return '';
            }
        }
    }, {
        key: '_createDescription',
        value: function _createDescription(first, second) {
            return '<div>' + '  <div class="firstParagraph billingDescriptionColor">' + first + '</div>' + '  <div class="secondParagraph">' + second + '</div>' + '</div>';
        }
    }, {
        key: 'getDetailsCallback',
        value: function getDetailsCallback() {
            openUserGuidePage('reporting#report-billing-summary');
        }
    }, {
        key: 'getGenerateCallback',
        value: function getGenerateCallback() {
            window.location.href = this.params.reportUrl;
        }
    }]);

    return BillingSummaryDescriptionStrategy;
}(_DescriptionStrategy3.default);

exports.default = BillingSummaryDescriptionStrategy;


var UserTypes = {
    REGULAR: 'RegularUser',
    MANAGE_BILLING_REPORT: 'ManageBillingReport'
};

/***/ }),
/* 1424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _DescriptionStrategy2 = __webpack_require__(84);

var _DescriptionStrategy3 = _interopRequireDefault(_DescriptionStrategy2);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _constants = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InvoiceDescriptionStrategy = function (_DescriptionStrategy) {
    _inherits(InvoiceDescriptionStrategy, _DescriptionStrategy);

    function InvoiceDescriptionStrategy(_ref) {
        var _ref$reportUrl = _ref.reportUrl,
            reportUrl = _ref$reportUrl === undefined ? '' : _ref$reportUrl,
            _ref$name = _ref.name,
            name = _ref$name === undefined ? '' : _ref$name;

        _classCallCheck(this, InvoiceDescriptionStrategy);

        var _this = _possibleConstructorReturn(this, (InvoiceDescriptionStrategy.__proto__ || Object.getPrototypeOf(InvoiceDescriptionStrategy)).call(this));

        _this.params = {
            reportUrl: reportUrl,
            name: name
        };

        _this.state = {
            userInDar: false,
            enabledFeatures: {},
            userRights: {}
        };

        _this.userType = null;

        _this.onStatePropertyChanged('userRights', function (userRights) {
            if (userRights[_constants.AccessRights.GENERATE_MONEY_REPORTS]) _this.userType = UserTypes.MANAGE_BILLING_REPORT;else _this.userType = UserTypes.REGULAR;
        });
        return _this;
    }

    _createClass(InvoiceDescriptionStrategy, [{
        key: 'getHeader',
        value: function getHeader() {
            return _messageResource2.default.getMessage(this.params.name) + ' ' + _messageResource2.default.getMessage('report.common.report');
        }
    }, {
        key: 'getDescription',
        value: function getDescription() {
            var firstParagraph = void 0;
            var secondParagraph = void 0;
            var thirdParagraph = void 0;
            switch (this.userType) {
                case UserTypes.MANAGE_BILLING_REPORT:
                    firstParagraph = _messageResource2.default.getEscapedMessage('dashboard.description.invoice.user_with_right.part1');
                    secondParagraph = _messageResource2.default.getEscapedMessage('dashboard.description.invoice.user_with_right.part2');
                    thirdParagraph = '';
                    return this._createDescription(firstParagraph, secondParagraph, thirdParagraph);
                case UserTypes.REGULAR:
                    return '';
            }
        }
    }, {
        key: '_createDescription',
        value: function _createDescription(first, second, third) {
            return '<div>' + '  <div class="firstParagraph billingDescriptionColor">' + first + '</div>' + '  <div class="secondParagraph">' + second + '</div>' + '  <div class="thirdParagraph">' + third + '</div>' + '</div>';
        }
    }, {
        key: 'getDetailsCallback',
        value: function getDetailsCallback() {
            openUserGuidePage('reporting#report-pdf-invoices');
        }
    }, {
        key: 'getGenerateCallback',
        value: function getGenerateCallback() {
            window.location.href = this.params.reportUrl;
        }
    }]);

    return InvoiceDescriptionStrategy;
}(_DescriptionStrategy3.default);

exports.default = InvoiceDescriptionStrategy;


var UserTypes = {
    REGULAR: 'RegularUser',
    MANAGE_BILLING_REPORT: 'ManageBillingReport'
};

/***/ }),
/* 1425 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _DescriptionStrategy2 = __webpack_require__(84);

var _DescriptionStrategy3 = _interopRequireDefault(_DescriptionStrategy2);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _constants = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CostOfWorkDescriptionStrategy = function (_DescriptionStrategy) {
    _inherits(CostOfWorkDescriptionStrategy, _DescriptionStrategy);

    function CostOfWorkDescriptionStrategy(_ref) {
        var _ref$reportUrl = _ref.reportUrl,
            reportUrl = _ref$reportUrl === undefined ? '' : _ref$reportUrl,
            _ref$name = _ref.name,
            name = _ref$name === undefined ? '' : _ref$name;

        _classCallCheck(this, CostOfWorkDescriptionStrategy);

        var _this = _possibleConstructorReturn(this, (CostOfWorkDescriptionStrategy.__proto__ || Object.getPrototypeOf(CostOfWorkDescriptionStrategy)).call(this));

        _this.params = {
            reportUrl: reportUrl,
            name: name
        };

        _this.state = {
            userInDar: false,
            enabledFeatures: {},
            userRights: {}
        };

        _this.userType = null;

        _this.onStatePropertyChanged('userRights', function (userRights) {
            if (userRights[_constants.AccessRights.GENERATE_MONEY_REPORTS]) _this.userType = UserTypes.MANAGE_BILLING_REPORT;else _this.userType = UserTypes.REGULAR;
        });
        return _this;
    }

    _createClass(CostOfWorkDescriptionStrategy, [{
        key: 'getHeader',
        value: function getHeader() {
            return _messageResource2.default.getMessage(this.params.name) + ' ' + _messageResource2.default.getMessage('report.common.report');
        }
    }, {
        key: 'getDescription',
        value: function getDescription() {
            var firstParagraph = void 0;
            var secondParagraph = void 0;
            var thirdParagraph = void 0;
            switch (this.userType) {
                case UserTypes.MANAGE_BILLING_REPORT:
                    firstParagraph = _messageResource2.default.getEscapedMessage('dashboard.description.cost_of_work.user_with_right.part1');
                    secondParagraph = _messageResource2.default.getEscapedMessage('dashboard.description.cost_of_work.user_with_right.part2');
                    thirdParagraph = '';
                    return this._createDescription(firstParagraph, secondParagraph, thirdParagraph);
                case UserTypes.REGULAR:
                    return '';
            }
        }
    }, {
        key: '_createDescription',
        value: function _createDescription(first, second, third) {
            return '<div>' + '  <div class="firstParagraph billingDescriptionColor">' + first + '</div>' + '  <div class="secondParagraph">' + second + '</div>' + '  <div class="thirdParagraph">' + third + '</div>' + '</div>';
        }
    }, {
        key: 'getDetailsCallback',
        value: function getDetailsCallback() {
            openUserGuidePage('reporting#report-cost-of-work');
        }
    }, {
        key: 'getGenerateCallback',
        value: function getGenerateCallback() {
            window.location.href = this.params.reportUrl;
        }
    }]);

    return CostOfWorkDescriptionStrategy;
}(_DescriptionStrategy3.default);

exports.default = CostOfWorkDescriptionStrategy;


var UserTypes = {
    REGULAR: 'RegularUser',
    MANAGE_BILLING_REPORT: 'ManageBillingReport'
};

/***/ }),
/* 1426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _DescriptionStrategy2 = __webpack_require__(84);

var _DescriptionStrategy3 = _interopRequireDefault(_DescriptionStrategy2);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _constants = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ProfitLossDescriptionStrategy = function (_DescriptionStrategy) {
    _inherits(ProfitLossDescriptionStrategy, _DescriptionStrategy);

    function ProfitLossDescriptionStrategy(_ref) {
        var _ref$reportUrl = _ref.reportUrl,
            reportUrl = _ref$reportUrl === undefined ? '' : _ref$reportUrl,
            _ref$name = _ref.name,
            name = _ref$name === undefined ? '' : _ref$name;

        _classCallCheck(this, ProfitLossDescriptionStrategy);

        var _this = _possibleConstructorReturn(this, (ProfitLossDescriptionStrategy.__proto__ || Object.getPrototypeOf(ProfitLossDescriptionStrategy)).call(this));

        _this.params = {
            reportUrl: reportUrl,
            name: name
        };

        _this.state = {
            userInDar: false,
            enabledFeatures: {},
            userRights: {}
        };

        _this.userType = null;

        _this.onStatePropertyChanged('userRights', function (userRights) {
            if (userRights[_constants.AccessRights.GENERATE_MONEY_REPORTS]) _this.userType = UserTypes.MANAGE_BILLING_REPORT;else _this.userType = UserTypes.REGULAR;
        });
        return _this;
    }

    _createClass(ProfitLossDescriptionStrategy, [{
        key: 'getHeader',
        value: function getHeader() {
            return _messageResource2.default.getMessage(this.params.name) + ' ' + _messageResource2.default.getMessage('report.common.report');
        }
    }, {
        key: 'getDescription',
        value: function getDescription() {
            var firstParagraph = void 0;
            var secondParagraph = void 0;
            var thirdParagraph = void 0;
            switch (this.userType) {
                case UserTypes.MANAGE_BILLING_REPORT:
                    firstParagraph = _messageResource2.default.getEscapedMessage('dashboard.description.profit_loss.user_with_right.part1');
                    secondParagraph = _messageResource2.default.getEscapedMessage('dashboard.description.profit_loss.user_with_right.part2');
                    thirdParagraph = '';
                    return this._createDescription(firstParagraph, secondParagraph, thirdParagraph);
                case UserTypes.REGULAR:
                    return '';
            }
        }
    }, {
        key: '_createDescription',
        value: function _createDescription(first, second, third) {
            return '<div>' + '  <div class="firstParagraph billingDescriptionColor">' + first + '</div>' + '  <div class="secondParagraph">' + second + '</div>' + '  <div class="thirdParagraph">' + third + '</div>' + '</div>';
        }
    }, {
        key: 'getDetailsCallback',
        value: function getDetailsCallback() {
            openUserGuidePage('reporting#report-profit-loss');
        }
    }, {
        key: 'getGenerateCallback',
        value: function getGenerateCallback() {
            window.location.href = this.params.reportUrl;
        }
    }]);

    return ProfitLossDescriptionStrategy;
}(_DescriptionStrategy3.default);

exports.default = ProfitLossDescriptionStrategy;


var UserTypes = {
    REGULAR: 'RegularUser',
    MANAGE_BILLING_REPORT: 'ManageBillingReport'
};

/***/ }),
/* 1427 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _DescriptionStrategy2 = __webpack_require__(84);

var _DescriptionStrategy3 = _interopRequireDefault(_DescriptionStrategy2);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CustomFieldsDescriptionStrategy = function (_DescriptionStrategy) {
    _inherits(CustomFieldsDescriptionStrategy, _DescriptionStrategy);

    function CustomFieldsDescriptionStrategy(_ref) {
        var _ref$reportUrl = _ref.reportUrl,
            reportUrl = _ref$reportUrl === undefined ? '' : _ref$reportUrl;

        _classCallCheck(this, CustomFieldsDescriptionStrategy);

        var _this = _possibleConstructorReturn(this, (CustomFieldsDescriptionStrategy.__proto__ || Object.getPrototypeOf(CustomFieldsDescriptionStrategy)).call(this));

        _this.params = { reportUrl: reportUrl };
        return _this;
    }

    _createClass(CustomFieldsDescriptionStrategy, [{
        key: 'getHeader',
        value: function getHeader() {
            return _messageResource2.default.getMessage('report.custom_fields.title');
        }
    }, {
        key: 'getDescription',
        value: function getDescription() {
            var firstParagraph = _messageResource2.default.getEscapedMessage('dashboard.description.custom_fields.part1');
            var secondParagraph = _messageResource2.default.getEscapedMessage('dashboard.description.custom_fields.part2');
            return this._createDescription(firstParagraph, secondParagraph);
        }
    }, {
        key: 'getGenerateCallback',
        value: function getGenerateCallback() {
            window.location.href = this.params.reportUrl;
        }
    }, {
        key: 'getDetailsCallback',
        value: function getDetailsCallback() {
            openUserGuidePage('reporting#custom-fields-report');
        }
    }, {
        key: '_createDescription',
        value: function _createDescription(first, second) {
            return '<div>' + '  <div class="firstParagraph customFieldsDescriptionColor">' + first + '</div>' + '  <div class="secondParagraph">' + second + '</div>' + '</div>';
        }
    }]);

    return CustomFieldsDescriptionStrategy;
}(_DescriptionStrategy3.default);

exports.default = CustomFieldsDescriptionStrategy;

/***/ }),
/* 1428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _DescriptionStrategy2 = __webpack_require__(84);

var _DescriptionStrategy3 = _interopRequireDefault(_DescriptionStrategy2);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var WorkStatusesDescriptionStrategy = function (_DescriptionStrategy) {
    _inherits(WorkStatusesDescriptionStrategy, _DescriptionStrategy);

    function WorkStatusesDescriptionStrategy(_ref) {
        var _ref$reportUrl = _ref.reportUrl,
            reportUrl = _ref$reportUrl === undefined ? '' : _ref$reportUrl;

        _classCallCheck(this, WorkStatusesDescriptionStrategy);

        var _this = _possibleConstructorReturn(this, (WorkStatusesDescriptionStrategy.__proto__ || Object.getPrototypeOf(WorkStatusesDescriptionStrategy)).call(this));

        _this.params = { reportUrl: reportUrl };
        return _this;
    }

    _createClass(WorkStatusesDescriptionStrategy, [{
        key: 'getHeader',
        value: function getHeader() {
            return _messageResource2.default.getMessage('report.work_statuses.title');
        }
    }, {
        key: 'getDescription',
        value: function getDescription() {
            var firstParagraph = _messageResource2.default.getEscapedMessage('dashboard.description.work_statuses.part1');
            var secondParagraph = _messageResource2.default.getEscapedMessage('dashboard.description.work_statuses.part2');
            return '<div>' + '  <div class="firstParagraph workStatusesDescriptionColor">' + firstParagraph + '</div>' + '  <div class="secondParagraph">' + secondParagraph + '</div>' + '</div>';
        }
    }, {
        key: 'getGenerateCallback',
        value: function getGenerateCallback() {
            window.location.href = this.params.reportUrl;
        }
    }, {
        key: 'getDetailsCallback',
        value: function getDetailsCallback() {
            openUserGuidePage('reporting#report-work-statuses');
        }
    }]);

    return WorkStatusesDescriptionStrategy;
}(_DescriptionStrategy3.default);

exports.default = WorkStatusesDescriptionStrategy;

/***/ }),
/* 1429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _DescriptionStrategy2 = __webpack_require__(84);

var _DescriptionStrategy3 = _interopRequireDefault(_DescriptionStrategy2);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TimeCardsDescriptionStrategy = function (_DescriptionStrategy) {
    _inherits(TimeCardsDescriptionStrategy, _DescriptionStrategy);

    function TimeCardsDescriptionStrategy(_ref) {
        var _ref$reportUrl = _ref.reportUrl,
            reportUrl = _ref$reportUrl === undefined ? '' : _ref$reportUrl;

        _classCallCheck(this, TimeCardsDescriptionStrategy);

        var _this = _possibleConstructorReturn(this, (TimeCardsDescriptionStrategy.__proto__ || Object.getPrototypeOf(TimeCardsDescriptionStrategy)).call(this));

        _this.params = { reportUrl: reportUrl };
        return _this;
    }

    _createClass(TimeCardsDescriptionStrategy, [{
        key: 'getHeader',
        value: function getHeader() {
            return _messageResource2.default.getMessage('report.time_cards.title');
        }
    }, {
        key: 'getDescription',
        value: function getDescription() {
            var firstParagraph = _messageResource2.default.getEscapedMessage('dashboard.description.time_cards.part1');
            var secondParagraph = _messageResource2.default.getEscapedMessage('dashboard.description.time_cards.part2');
            var thirdParagraph = _messageResource2.default.getEscapedMessage('dashboard.description.time_cards.part3');
            return '<div>' + '  <div class="firstParagraph workStatusesDescriptionColor">' + firstParagraph + '</div>' + '  <div class="secondParagraph">' + secondParagraph + '</div>' + '  <div class="thirdParagraph">' + thirdParagraph + '</div>' + '</div>';
        }
    }, {
        key: 'getGenerateCallback',
        value: function getGenerateCallback() {
            window.location.href = this.params.reportUrl;
        }
    }, {
        key: 'getDetailsCallback',
        value: function getDetailsCallback() {
            openUserGuidePage('reporting#report-time-cards');
        }
    }]);

    return TimeCardsDescriptionStrategy;
}(_DescriptionStrategy3.default);

exports.default = TimeCardsDescriptionStrategy;

/***/ }),
/* 1430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _DescriptionStrategy2 = __webpack_require__(84);

var _DescriptionStrategy3 = _interopRequireDefault(_DescriptionStrategy2);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TimeTrackDescriptionStrategy = function (_DescriptionStrategy) {
    _inherits(TimeTrackDescriptionStrategy, _DescriptionStrategy);

    function TimeTrackDescriptionStrategy(_ref) {
        var _ref$reportUrl = _ref.reportUrl,
            reportUrl = _ref$reportUrl === undefined ? '' : _ref$reportUrl;

        _classCallCheck(this, TimeTrackDescriptionStrategy);

        var _this = _possibleConstructorReturn(this, (TimeTrackDescriptionStrategy.__proto__ || Object.getPrototypeOf(TimeTrackDescriptionStrategy)).call(this));

        _this.params = { reportUrl: reportUrl };
        return _this;
    }

    _createClass(TimeTrackDescriptionStrategy, [{
        key: 'getHeader',
        value: function getHeader() {
            return _messageResource2.default.getMessage('report.newTimetrack.header');
        }
    }, {
        key: 'getDescription',
        value: function getDescription() {
            var firstParagraph = _messageResource2.default.getEscapedMessage('dashboard.description.timetrack.part1');
            var secondParagraph = _messageResource2.default.getEscapedMessage('dashboard.description.timetrack.part2');
            return '<div>' + '  <div class="firstParagraph workStatusesDescriptionColor">' + firstParagraph + '</div>' + '  <div class="secondParagraph">' + secondParagraph + '</div>' + '</div>';
        }
    }, {
        key: 'getGenerateCallback',
        value: function getGenerateCallback() {
            window.location.href = this.params.reportUrl;
        }
    }, {
        key: 'getDetailsCallback',
        value: function getDetailsCallback() {
            openUserGuidePage('reporting#report-time-track');
        }
    }]);

    return TimeTrackDescriptionStrategy;
}(_DescriptionStrategy3.default);

exports.default = TimeTrackDescriptionStrategy;

/***/ }),
/* 1431 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _constants = __webpack_require__(11);

var _utils = __webpack_require__(792);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ChooseReportSection = function (_TemplateView) {
    _inherits(ChooseReportSection, _TemplateView);

    function ChooseReportSection(_ref) {
        var _ref$reportNameKeys = _ref.reportNameKeys,
            reportNameKeys = _ref$reportNameKeys === undefined ? {} : _ref$reportNameKeys,
            _ref$tabSelected = _ref.tabSelected,
            tabSelected = _ref$tabSelected === undefined ? function () {} : _ref$tabSelected;

        _classCallCheck(this, ChooseReportSection);

        var _this = _possibleConstructorReturn(this, (ChooseReportSection.__proto__ || Object.getPrototypeOf(ChooseReportSection)).call(this));

        _this.params = {
            reportNameKeys: reportNameKeys,
            tabSelected: tabSelected
        };

        _this.state = {
            selectedType: null,
            userRights: {},
            features: {}
        };

        _this.timeReports = [_constants.ReportType.STAFF_PERFORMANCE, _constants.ReportType.OVERTIME, _constants.ReportType.LEAVE_TIME, _constants.ReportType.WORK_STATUSES, _constants.ReportType.TIME_TRACK, _constants.ReportType.TIME_TRACK_IN_DETAIL, _constants.ReportType.ESTIMATED_VS_ACTUAL, _constants.ReportType.TIME_CARDS];

        _this.billingReports = [_constants.ReportType.BILLING_SUMMARY, _constants.ReportType.INVOICING, _constants.ReportType.COST_OF_WORK, _constants.ReportType.PROFIT_LOSS];

        _this.customDataReports = [_constants.ReportType.CUSTOM_FIELDS];

        _this.onStatePropertyChanged('selectedType', function (selectedType) {
            Object.keys(_this.$buttons).map(function (type) {
                _this.$buttons[type].toggleClass('pressed', selectedType === type);
            });
        });

        _this.onStatePropertyChanged('userRights', function () {
            _this.$buttons[_constants.ReportType.STAFF_PERFORMANCE].toggle(_this._isTabShown(_constants.ReportType.STAFF_PERFORMANCE));
            _this.$buttons[_constants.ReportType.OVERTIME].toggle(_this._isTabShown(_constants.ReportType.OVERTIME));
            _this.$buttons[_constants.ReportType.LEAVE_TIME].toggle(_this._isTabShown(_constants.ReportType.LEAVE_TIME));
            _this.$buttons[_constants.ReportType.TIME_TRACK].toggle(_this._isTabShown(_constants.ReportType.TIME_TRACK));
            _this.$buttons[_constants.ReportType.TIME_TRACK_IN_DETAIL].toggle(_this._isTabShown(_constants.ReportType.TIME_TRACK_IN_DETAIL));
            _this.$buttons[_constants.ReportType.ESTIMATED_VS_ACTUAL].toggle(_this._isTabShown(_constants.ReportType.ESTIMATED_VS_ACTUAL));
            _this.$buttons[_constants.ReportType.BILLING_SUMMARY].toggle(_this._isTabShown(_constants.ReportType.BILLING_SUMMARY));
            _this.$buttons[_constants.ReportType.INVOICING].toggle(_this._isTabShown(_constants.ReportType.INVOICING));
            _this.$buttons[_constants.ReportType.COST_OF_WORK].toggle(_this._isTabShown(_constants.ReportType.COST_OF_WORK));
            _this.$buttons[_constants.ReportType.PROFIT_LOSS].toggle(_this._isTabShown(_constants.ReportType.PROFIT_LOSS));
            _this.$buttons[_constants.ReportType.CUSTOM_FIELDS].toggle(_this._isTabShown(_constants.ReportType.CUSTOM_FIELDS));
            _this.$buttons[_constants.ReportType.WORK_STATUSES].toggle(_this._isTabShown(_constants.ReportType.WORK_STATUSES));
            _this.$buttons[_constants.ReportType.TIME_CARDS].toggle(_this._isTabShown(_constants.ReportType.TIME_CARDS));

            var showTimeReports = _this.timeReports.map(function (type) {
                return _this._isTabShown(type);
            }).reduce(function (acc, value) {
                return acc || value;
            }, false);
            _this.find('.timeReports').toggle(showTimeReports);

            var showBillingReports = _this.billingReports.map(function (type) {
                return _this._isTabShown(type);
            }).reduce(function (acc, value) {
                return acc || value;
            }, false);
            _this.find('.billingReports').toggle(showBillingReports);

            var showCustomDataReports = _this.customDataReports.map(function (type) {
                return _this._isTabShown(type);
            }).reduce(function (acc, value) {
                return acc || value;
            }, false);
            _this.find('.customDataReports').toggle(showCustomDataReports);
        });
        return _this;
    }

    _createClass(ChooseReportSection, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class="indexContent">' + '  <div class="timeReports">' + '    <div class="indexHeader"><%-firstCategoryHeader%></div>' + '    <div class="staffButton reportButton"><%-staff%></div>' + '    <div class="overtimeButton reportButton"><%-overtime%></div>' + '    <div class="balancesButton reportButton"><%-balance%></div>' + '    <div class="workStatusesButton reportButton"><%-work_statuses%></div>' + '    <div class="newTimeTrackButton reportButton"><%-newTimetrack%></div>' + '    <div class="timeTrackButton reportButton"><%-timetrack%></div>' + '    <div class="evaButton reportButton"><%-eva%></div>' + '    <div class="timeCardsButton reportButton"><%-time_cards%></div>' + '  </div>' + '  <div class="billingReports">' + '    <div class="indexHeader"><%-secondCategoryHeader%></div>' + '    <div class="billingButton reportButton"><%-billing%></div>' + '    <div class="invoiceButton reportButton"><%-invoice%></div>' + '    <div class="costOfWorkButton reportButton"><%-cost%></div>' + '    <div class="profitLossButton reportButton"><%-profit_loss%></div>' + '  </div>' + '  <div class="customDataReports">' + '    <div class="indexHeader"><%-thirdCategoryHeader%></div>' + '    <div class="customFieldsButton reportButton"><%-custom_fields%></div>' + '  </div>' + '</div>';
        }
    }, {
        key: 'messageKeys',
        value: function messageKeys() {
            return {
                firstCategoryHeader: 'saved_reports.category.time',
                secondCategoryHeader: 'saved_reports.category.money',
                thirdCategoryHeader: 'saved_reports.category.custom_data',

                staff: this.params.reportNameKeys[_constants.ReportType.STAFF_PERFORMANCE],
                overtime: this.params.reportNameKeys[_constants.ReportType.OVERTIME],
                balance: this.params.reportNameKeys[_constants.ReportType.LEAVE_TIME],
                newTimetrack: 'report.newTimetrack.title',
                timetrack: this.params.reportNameKeys[_constants.ReportType.TIME_TRACK_IN_DETAIL],
                eva: this.params.reportNameKeys[_constants.ReportType.ESTIMATED_VS_ACTUAL],
                billing: this.params.reportNameKeys[_constants.ReportType.BILLING_SUMMARY],
                invoice: this.params.reportNameKeys[_constants.ReportType.INVOICING],
                cost: this.params.reportNameKeys[_constants.ReportType.COST_OF_WORK],
                profit_loss: this.params.reportNameKeys[_constants.ReportType.PROFIT_LOSS],

                work_statuses: 'report.work_statuses',
                custom_fields: 'report.custom_fields.title',
                time_cards: 'report.time_cards.title'
            };
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            var _this2 = this;

            this.$buttons = {};
            this.$buttons[_constants.ReportType.STAFF_PERFORMANCE] = this.find('.staffButton');
            this.$buttons[_constants.ReportType.OVERTIME] = this.find('.overtimeButton');
            this.$buttons[_constants.ReportType.LEAVE_TIME] = this.find('.balancesButton');
            this.$buttons[_constants.ReportType.TIME_TRACK] = this.find('.newTimeTrackButton');
            this.$buttons[_constants.ReportType.TIME_TRACK_IN_DETAIL] = this.find('.timeTrackButton');
            this.$buttons[_constants.ReportType.ESTIMATED_VS_ACTUAL] = this.find('.evaButton');
            this.$buttons[_constants.ReportType.BILLING_SUMMARY] = this.find('.billingButton');
            this.$buttons[_constants.ReportType.INVOICING] = this.find('.invoiceButton');
            this.$buttons[_constants.ReportType.COST_OF_WORK] = this.find('.costOfWorkButton');
            this.$buttons[_constants.ReportType.PROFIT_LOSS] = this.find('.profitLossButton');
            this.$buttons[_constants.ReportType.CUSTOM_FIELDS] = this.find('.customFieldsButton');
            this.$buttons[_constants.ReportType.WORK_STATUSES] = this.find('.workStatusesButton');
            this.$buttons[_constants.ReportType.TIME_CARDS] = this.find('.timeCardsButton');

            Object.keys(this.$buttons).map(function (type) {
                _this2.$buttons[type].click(function () {
                    return _this2.params.tabSelected(type);
                });
            });
        }
    }, {
        key: '_isTabShown',
        value: function _isTabShown(type) {
            return (0, _utils.isReportAvailable)(type, this.state.userRights, this.state.features);
        }
    }]);

    return ChooseReportSection;
}(_TemplateView3.default);

exports.default = ChooseReportSection;

/***/ }),
/* 1432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getSelectedTab = undefined;

var _reselect = __webpack_require__(13);

var _selectors = __webpack_require__(793);

var getCreateReportPopupState = (0, _reselect.createSelector)(_selectors.getReportsState, function (reports) {
    return reports.dashboard.createReportPopup;
});

var getSelectedTab = exports.getSelectedTab = (0, _reselect.createSelector)(getCreateReportPopupState, function (createReportPopup) {
    return createReportPopup.tab;
});

/***/ }),
/* 1433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.changeTab = undefined;

var _actionTypes = __webpack_require__(700);

var ActionTypes = _interopRequireWildcard(_actionTypes);

var _reduxActions = __webpack_require__(9);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var setSelectedTab = (0, _reduxActions.createAction)(ActionTypes.SELECTED_TAB_SET);

var changeTab = exports.changeTab = function changeTab(tab) {
    return function (dispatch) {
        dispatch(setSelectedTab(tab));
    };
};

/***/ }),
/* 1434 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isOvertimeAvailable = exports.isAllUsersTimeTrackAvailable = undefined;

var _reselect = __webpack_require__(13);

var _selectors = __webpack_require__(793);

var selectAuthorizationInfo = (0, _reselect.createSelector)(_selectors.getReportsState, function (reports) {
    return reports.authorizationInfo;
});

var isAllUsersTimeTrackAvailable = exports.isAllUsersTimeTrackAvailable = (0, _reselect.createSelector)(selectAuthorizationInfo, function (authorizationInfo) {
    return authorizationInfo.allUsersTimeTrackAvailable;
});

var isOvertimeAvailable = exports.isOvertimeAvailable = (0, _reselect.createSelector)(selectAuthorizationInfo, function (authorizationInfo) {
    return authorizationInfo.overtimeAvailable;
});

/***/ }),
/* 1435 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ChooseReportHeader = function (_TemplateView) {
    _inherits(ChooseReportHeader, _TemplateView);

    function ChooseReportHeader() {
        _classCallCheck(this, ChooseReportHeader);

        return _possibleConstructorReturn(this, (ChooseReportHeader.__proto__ || Object.getPrototypeOf(ChooseReportHeader)).call(this));
    }

    _createClass(ChooseReportHeader, [{
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='chooseReport_header'>" + "  <div class='chooseReport_title'><%-title%></div>" + "  <div class='reportDescription_closeButton'></div>" + "</div>";
        }
    }, {
        key: "templateModel",
        value: function templateModel() {
            return {
                title: 'Reports Description'
            };
        }
    }, {
        key: "getCloseButtonEl",
        value: function getCloseButtonEl() {
            return this.find('.reportDescription_closeButton');
        }
    }]);

    return ChooseReportHeader;
}(_TemplateView3.default);

exports.default = ChooseReportHeader;

/***/ }),
/* 1436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ChooseReportFooter = function (_TemplateView) {
    _inherits(ChooseReportFooter, _TemplateView);

    function ChooseReportFooter() {
        _classCallCheck(this, ChooseReportFooter);

        return _possibleConstructorReturn(this, (ChooseReportFooter.__proto__ || Object.getPrototypeOf(ChooseReportFooter)).call(this));
    }

    _createClass(ChooseReportFooter, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class="lightBoxFooter">' + '   <div class="commitButton"/>' + '   <div class="cancelBtn"></div>' + '</div>';
        }
    }, {
        key: 'getCommitBtnEl',
        value: function getCommitBtnEl() {
            return this.find('.commitButton');
        }
    }, {
        key: 'getCancelBtnEl',
        value: function getCancelBtnEl() {
            return this.find('.cancelBtn');
        }
    }]);

    return ChooseReportFooter;
}(_TemplateView3.default);

exports.default = ChooseReportFooter;

/***/ }),
/* 1437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _BasicLightbox = __webpack_require__(163);

var _BasicLightbox2 = _interopRequireDefault(_BasicLightbox);

var _ChartDataParametersSectionController = __webpack_require__(1438);

var _ChartDataParametersSectionController2 = _interopRequireDefault(_ChartDataParametersSectionController);

var _SpinnerController = __webpack_require__(69);

var _SpinnerController2 = _interopRequireDefault(_SpinnerController);

var _spin = __webpack_require__(93);

var _spin2 = _interopRequireDefault(_spin);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _jquery_rpc = __webpack_require__(26);

var _jquery_rpc2 = _interopRequireDefault(_jquery_rpc);

var _ChartDisplayParametersSectionController = __webpack_require__(1455);

var _ChartDisplayParametersSectionController2 = _interopRequireDefault(_ChartDisplayParametersSectionController);

var _constants = __webpack_require__(11);

var _ChartController = __webpack_require__(1461);

var _ChartController2 = _interopRequireDefault(_ChartController);

var _ChartDataController = __webpack_require__(1463);

var _ChartDataController2 = _interopRequireDefault(_ChartDataController);

var _ReportChartUtils = __webpack_require__(303);

var _ReportChartUtils2 = _interopRequireDefault(_ReportChartUtils);

var _BaseFormatterCreator = __webpack_require__(379);

var _BaseFormatterCreator2 = _interopRequireDefault(_BaseFormatterCreator);

var _CreateChartLightboxPDFPreviewViewController = __webpack_require__(1464);

var _CreateChartLightboxPDFPreviewViewController2 = _interopRequireDefault(_CreateChartLightboxPDFPreviewViewController);

var _atUtils = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CreateChartLightbox() {}

CreateChartLightbox.prototype = new _BasicLightbox2.default();

CreateChartLightbox.prototype.exist_invalid_fields_message_key = "";
CreateChartLightbox.prototype.close_tab_confirmation_message_key = "";

CreateChartLightbox.prototype.init = function (config) {
    _BasicLightbox2.default.prototype.init.call(this, config.popupId, config.closeBtnId);

    var self = this;
    this.titleEl = (0, _jquery2.default)(this.lightBoxEl).find(".lightBoxTitle");
    this.setCancelCallback(function () {
        self.hide();
    });

    this.needToReloadPageAfterClose = config.needToReloadPageAfterClose;
    this.reloadPageAfterClose = false;
    this.formatter = new _BaseFormatterCreator2.default();

    this.createChartErrorEl = this.innerContent.find(".createChartError");

    // get display parameters from cookies only if this is new config
    if (!config.chartId) {
        config.chartDisplayParameters = _ChartDisplayParametersSectionController2.default.getDefaultDisplayParameters();
        _jquery2.default.extend(config.chartDisplayParameters, this.read_cookie("actiTIME-CHARTDisplayParameters"));
    }

    this.chartDataParametersSectionController = new _ChartDataParametersSectionController2.default().init(config.popupId, config.chartPopupData, config.chartType, config.chartDataParameters, function () {
        self.onDataParametersChanged();
    });

    this.chartDataController = new _ChartDataController2.default().init(config.chartPoints, config.chartDisplayParameters.stackColumns);
    this.chartDisplayParametersSectionController = new _ChartDisplayParametersSectionController2.default().init(config.chartDisplayParameters, config.chartDataParameters.groupingLevel, this.chartDataController.getMinValue(), this.chartDataController.getMaxValue(), function () {
        self.displayParametersChanged();
    }, config.chartPopupData.showStackColumnsCheckMark);
    this.totalValueContainer = (0, _jquery2.default)(config.totalValueContainer);

    var chartData = {
        title: ReportChartTitle[config.chartType],
        chartPoints: config.chartPoints,
        total: this.chartDataController.getTotal(),
        max: this.chartDataController.getMaxValue(),
        min: this.chartDataController.getMinValue()
    };

    this.chartController = new _ChartController2.default().init({
        containerId: config.chartContainerId,
        partsContainerId: config.partsContainerId,
        data: chartData,
        settings: {
            showPercents: config.chartDisplayParameters.showPercents,
            colorId: config.chartDisplayParameters.chartColor,
            chartType: config.chartDisplayParameters.chartType,
            reportChartType: config.chartType,
            groupingLevel: config.chartDataParameters.groupingLevel,
            sortCategoryComparator: self.getSortCategoryFunctionForChart(),
            sortOption: config.chartDisplayParameters.sortOption,
            sortOrder: config.chartDisplayParameters.sortOrderIsAsc,
            emptyPieCallback: _jquery2.default.proxy(self.showChartErrorMessageWithControls, this),
            stackColumns: this.chartDisplayParametersSectionController.isStackColumnsCheckboxVisibleAndChecked()
        }
    });
    this.showOrHideNotFullDataMessage(this.chartDataController.getMinValue(), this.chartDataController.getMaxValue());
    this.showTotalValue(this.chartDataController.getTotal(), this.formatter.getValueFormattedFunction(config.chartType), this.formatter.getMeasureUnit(config.chartType));

    this.initPdfPreviewViewController(config);

    this.successCallback = function () {
        self.pdfPreviewViewController.switchLightboxToPDFPreviewView(self.chartDataParametersSectionController.getSelectedValues(), self.chartDisplayParametersSectionController.getChartType(), self.chartDataController);
    };

    this.initConfig = this.getReportConfig();

    self.chartId = config.chartId;

    this.saveConfigControl = new SaveConfigurationControl().init({
        reportName: config.chartName,
        hasChanges: false
    }, SaveConfigurationControl.CHART_TYPE, function (reportName) {
        var reportConfig = self.getReportConfig();
        reportConfig.reportName = reportName;
        self.saveChartManager.saveReport(reportConfig);
    }, function (reportName) {
        var reportConfig = self.getReportConfig();
        reportConfig.reportId = self.chartId;
        reportConfig.reportName = reportName;
        self.saveChartManager.updateReport(reportConfig);
    }, function () {
        return self.resetConfig();
    });
    this.saveChartManager = new SaveReportChartManager().init(this.saveConfigControl, function (reportId) {
        if (reportId) self.chartId = reportId;
        self.initConfig = self.getReportConfig();
        (0, _jquery2.default)(document).trigger("chartSaved", { chartId: self.chartId });
        self.reloadPageAfterClose = this.needToReloadPageAfterClose ? true : false;
    }, function (errorThrown) {
        // default
        return false;
    });

    if (config.makeChartPointsException) this.handleMakeChartPointsException(config.makeChartPointsException);else if (config.chartPoints.length === 0) this.showEmptyChartDataMessage();else if (config.chartDisplayParameters.chartType === _constants.ChartType.PIE_CHART && chartData.max === 0 && chartData.min === 0) this.showChartErrorMessageWithControls();else this.removeChartErrorMessage();

    var spinnerOptions = {
        lines: 11, // The number of lines to draw
        length: 8, // The length of each line
        width: 3, // The line thickness
        radius: 6, // The radius of the inner circle
        corners: 1, // Corner roundness (0..1)
        rotate: 0, // The rotation offset
        direction: 1, // 1: clockwise, -1: counterclockwise
        color: '#888888', // #rgb or #rrggbb
        speed: 1, // Rounds per second
        trail: 60, // Afterglow percentage
        shadow: false, // Whether to render a shadow
        hwaccel: false, // Whether to use hardware acceleration
        className: 'spinner', // The CSS class to assign to the spinner
        zIndex: 2e9, // The z-index (defaults to 2000000000)
        top: 'auto', // Top position relative to parent in px
        left: 'auto' // Left position relative to parent in px
    };
    this.spinnerController = new _SpinnerController2.default();
    this.spinnerController.setSpinner(new _spin2.default(spinnerOptions));

    this.switchLightboxToCreateChartView();
    this.updateLightboxChartTypeClass();

    return this;
};

CreateChartLightbox.prototype.extractReportAuthorizationInfo = function (_ref) {
    var chartsAuthorizationInfo = _ref.chartsAuthorizationInfo,
        chartType = _ref.chartType;

    var reportAuthInfo = null;
    switch (chartType) {
        case _constants.ReportChartType.TOTAL_WORKING_HOURS:
        case _constants.ReportChartType.APPROVED_WORKING_HOURS:
            reportAuthInfo = chartsAuthorizationInfo.taskChartsAuthorizationInfo;
            break;
        case _constants.ReportChartType.COST_OF_WORK:
        case _constants.ReportChartType.BILLABLE_AMOUNTS:
            reportAuthInfo = chartsAuthorizationInfo.billingChartsAuthorizationInfo;
            break;
        case _constants.ReportChartType.LEAVE_HOURS:
        case _constants.ReportChartType.PTO_BALANCE:
        case _constants.ReportChartType.SICK_DAYS_BALANCE:
        case _constants.ReportChartType.OVERTIME_HOURS:
            reportAuthInfo = chartsAuthorizationInfo.balanceChartsAuthorizationInfo;
            break;
    }
    return chartsAuthorizationInfo;
};

CreateChartLightbox.prototype.initPdfPreviewViewController = function (config) {
    var _this = this;

    var reportAuthInfo = this.extractReportAuthorizationInfo({
        chartsAuthorizationInfo: config.chartPopupData.chartsAuthorizationInfo,
        chartType: config.chartType
    });

    this.pdfPreviewViewController = new _CreateChartLightboxPDFPreviewViewController2.default().init(this.lightBoxEl, this.titleEl, config.popupId, config.chartPopupData.printParameters, function () {
        _this.switchLightboxToCreateChartView();
    }, this.chartController, {
        users: config.chartPopupData.users,
        enabledFeatures: config.chartPopupData.enabledFeatures,
        userGroups: config.chartPopupData.userGroups,
        timeZoneGroups: config.chartPopupData.timeZoneGroups,
        customersProjects: config.chartPopupData.customersProjects,
        leaveTypesMap: (0, _atUtils.arrayToMap)(config.chartPopupData.leaveTypes),
        manageableUserIds: config.chartPopupData.manageableUsersIds,
        projectsWithMaIds: config.chartPopupData.projectsWithMaIds
    }, function () {
        return _this.chartDataParametersSectionController.includeOtherUsers();
    }, function () {
        return _this.chartDisplayParametersSectionController.isStackColumnsCheckboxVisibleAndChecked();
    }, reportAuthInfo);
};

CreateChartLightbox.prototype.hide = function () {
    this.cancelAllExportingProcesses();
    this.abortMakeChartPointsRequest();
    _BasicLightbox2.default.prototype.hide.call(this);

    if (this.reloadPageAfterClose) document.location.reload();

    (0, _jquery2.default)(document).trigger("reportCharts.createChartLightbox.hide"); // private of CreateChartLightboxPDFPreviewViewController, can't reuse without refactoring
    (0, _jquery2.default)(document).trigger("chartClosed", { chartId: this.chartId });
};

CreateChartLightbox.prototype.showTotalValue = function (value, formatter, unit) {
    this.totalValueContainer.html(formatter(value) + "&nbsp;" + unit);
};

CreateChartLightbox.prototype.getReportConfig = function () {
    return {
        reportType: this.chartDataParametersSectionController.getChartType(),
        reportParameters: {
            dataParameters: this.chartDataParametersSectionController.getSelectedParams(),
            displayParameters: this.chartDisplayParametersSectionController.getDisplayParameters()
        }
    };
};

CreateChartLightbox.prototype.resetConfig = function () {
    this.chartDataParametersSectionController.setParameters(this.initConfig.reportType, this.initConfig.reportParameters.dataParameters);
    this.chartDisplayParametersSectionController.setParameters(this.initConfig.reportParameters.displayParameters, this.initConfig.reportParameters.dataParameters.groupingLevel);
    this.displayParametersChanged();
    this.onDataParametersChanged();
    return true;
};

CreateChartLightbox.prototype.displayParametersChanged = function () {
    this.updateLightboxChartTypeClass();
    this.write_cookie("actiTIME-CHARTDisplayParameters", this.chartDisplayParametersSectionController.getDisplayParameters());
    this.saveConfigControl.registerConfigChanged();
    this.removeChartErrorMessage();
    this.chartController.updateDisplayData({
        chartType: this.chartDisplayParametersSectionController.getChartType(),
        colorId: this.chartDisplayParametersSectionController.getChartColorId(),
        sortOption: this.chartDisplayParametersSectionController.getSortOption().by,
        sortOrder: this.chartDisplayParametersSectionController.getSortOption().isAsc,
        isShowPercents: this.chartDisplayParametersSectionController.changeCheckboxStateIfNeededAndGetShowPercentsValue(this.chartDataController.getMinValue(), this.chartDataController.getMaxValue()),
        stackColumns: this.chartDisplayParametersSectionController.changeCheckboxStateIfNeededAndGetShowShowStackedColumnsValue()
    });
};

CreateChartLightbox.prototype.updateLightboxChartTypeClass = function () {
    var chartType = this.chartDisplayParametersSectionController.getChartType();
    var cssClass = "";
    switch (chartType) {
        case _constants.ChartType.VERTICAL_BAR:
            cssClass = "verticalBar";break;
        case _constants.ChartType.HORIZONTAL_BAR:
            cssClass = "horizontalBar";break;
        case _constants.ChartType.PIE_CHART:
            cssClass = "pieChart";
    }
    (0, _jquery2.default)(this.lightBoxEl).removeClass("verticalBar horizontalBar pieChart").addClass(cssClass);
};

CreateChartLightbox.prototype.onDataParametersChanged = function () {
    this.abortMakeChartPointsRequest();

    if (!this.chartDataParametersSectionController.validate()) {
        this.saveConfigControl.disableEditConfig();
        this.printErrorInFooter(this.chartDataParametersSectionController.getUnescapedErrorMessage());
        this._blinkErrorInFooter();
        this.showChartErrorMessage(_messageResource2.default.getMessage("report.create_chart.error.params_not_valid"));
        return;
    }

    this.saveConfigControl.enableEditConfig();
    this.removeErrorInFooter();
    this.removeChartErrorMessage();
    this.showLoadingChartSpinner();

    var self = this;
    var newChartType = this.chartDataParametersSectionController.getChartType();
    var newParams = this.chartDataParametersSectionController.getSelectedParams();
    this.saveConfigControl.registerConfigChanged();
    this.makeChartPointsRequestObject = (0, _jquery_rpc2.default)("ReportChartService.makeChartPoints", [newChartType, newParams], function (result) {
        self.hideLoadingChartSpinner();
        if (result && result.length > 0) {
            self.chartDisplayParametersSectionController.changeSortClassAccordingGroupingLevel(newParams.groupingLevel);
            self.chartDisplayParametersSectionController.changeCheckboxStateIfNeededAndGetShowShowStackedColumnsValue();
            var stackColumns = self.chartDisplayParametersSectionController.isStackColumnsCheckboxVisibleAndChecked();
            self.chartDataController.updateData(result, stackColumns);
            self.chartController.updateData({
                title: ReportChartTitle[newChartType],
                chartPoints: result,
                total: self.chartDataController.getTotal(),
                max: self.chartDataController.getMaxValue(),
                min: self.chartDataController.getMinValue()
            }, {
                groupingLevel: newParams.groupingLevel,
                reportChartType: newChartType,
                sortOption: self.chartDisplayParametersSectionController.getSortOption().by,
                sortOrder: self.chartDisplayParametersSectionController.getSortOption().isAsc,
                sortCategoryComparator: self.getSortCategoryFunctionForChart(),
                isShowPercents: self.chartDisplayParametersSectionController.changeCheckboxStateIfNeededAndGetShowPercentsValue(self.chartDataController.getMinValue(), self.chartDataController.getMaxValue()),
                stackColumns: stackColumns
            });
            self.showOrHideNotFullDataMessage(self.chartDataController.getMinValue(), self.chartDataController.getMaxValue());
            self.showTotalValue(self.chartDataController.getTotal(), self.formatter.getValueFormattedFunction(newChartType), self.formatter.getMeasureUnit(newChartType));
        } else {
            self.showEmptyChartDataMessage();
        }
    }, function (jqXHR, textStatus, errorThrown) {
        if (textStatus === 'rpc_sessionExpired' || textStatus === 'rpc_noRights') return false;

        self.hideLoadingChartSpinner();

        if (textStatus === "abort") return true;

        if (textStatus === "timeout") {
            self.showChartErrorMessage(_messageResource2.default.getMessage("report.create_chart.error.timeout"));
            return true;
        }

        return self.handleMakeChartPointsException(errorThrown.exception);
    });
};

CreateChartLightbox.prototype.abortMakeChartPointsRequest = function () {
    if (this.makeChartPointsRequestObject) this.makeChartPointsRequestObject.abort();
};

CreateChartLightbox.prototype.handleMakeChartPointsException = function (exception) {
    if (exception === 'com.actimind.actitime.reports.AllSelectedProjectsAreUnavailableException') {
        this.showChartErrorMessage(_messageResource2.default.getEscapedMessage("report.create_chart.error.no_selected_projects"));
        return true;
    }
    if (exception === 'com.actimind.actitime.reports.AllSelectedUsersWereDeletedException') {
        this.showChartErrorMessage(_messageResource2.default.getMessage("report.create_chart.error.no_selected_users"));
        return true;
    }
    if (exception === 'com.actimind.actitime.reports.NoSelectedUsersWithEnabledOvertimeException') {
        this.showChartErrorMessage(_messageResource2.default.getMessage("report.create_chart.error.no_selected_overtime_users"));
        return true;
    }
    if (exception === 'com.actimind.actitime.reports.charts.NoPtoUsersSelectedException') {
        this.showChartErrorMessage(_messageResource2.default.getMessage("report.create_chart.error.no_selected_pto_users"));
        return true;
    }
    if (exception === 'com.actimind.actitime.reports.charts.NoSickUsersSelectedException') {
        this.showChartErrorMessage(_messageResource2.default.getMessage("report.create_chart.error.no_selected_sick_users"));
        return true;
    }
    if (exception === 'com.actimind.actitime.reports.AllSelectedLeaveTypesWereDeletedException') {
        this.showChartErrorMessage(_messageResource2.default.getMessage("report.create_chart.error.no_selected_leave_types"));
        return true;
    }
    if (exception === 'com.actimind.actitime.reports.NoBillableTasksException') {
        this.showChartErrorMessage(_messageResource2.default.getEscapedMessage("report.create_chart.error.no_billable_tasks"));
        return true;
    }

    this.showChartErrorMessage(_messageResource2.default.getMessage("report.create_chart.error.unexpected_error"));
    return false;
};

CreateChartLightbox.prototype.getSortCategoryFunctionForChart = function () {
    var groupingLevel = this.chartDataParametersSectionController.getGroupingLevel();
    return _ReportChartUtils2.default.getSortCategoryFunctionForChart(groupingLevel);
};

CreateChartLightbox.prototype.changeShowPercents = function (checked) {
    this.chartController.changeShowPercents(checked);
};

CreateChartLightbox.prototype.changeStackColumns = function (checked) {
    this.chartController.changeStackColumns(checked);
};

CreateChartLightbox.prototype.validate = function () {
    return this.chartDataParametersSectionController.validate();
};

CreateChartLightbox.prototype.updateUI = function () {
    return this.chartDataParametersSectionController.updateUI();
};

CreateChartLightbox.prototype.switchLightboxToCreateChartView = function () {
    this.cancelAllExportingProcesses();
    (0, _jquery2.default)(this.lightBoxEl).removeClass("pdfPreviewMode").addClass("createChartMode");
    this.titleEl.text(_messageResource2.default.getMessage("report.create_chart.title"));
};

CreateChartLightbox.prototype.cancelAllExportingProcesses = function () {
    this.pdfPreviewViewController.cancelAllExportingProcesses();
};

CreateChartLightbox.prototype.showEmptyChartDataMessage = function () {
    this.showChartErrorMessage(_messageResource2.default.getMessage("report.create_chart.error.empty_result_data"));
};

CreateChartLightbox.prototype.showChartErrorMessage = function (errorMessage) {
    this.createChartErrorEl.find(".createChartErrorMessage").html(errorMessage);
    this.innerContent.addClass("inErrorState");
    this.disableCommitButton();
};

CreateChartLightbox.prototype.showChartErrorMessageWithControls = function () {
    this.createChartErrorEl.find(".createChartErrorMessage").html(_messageResource2.default.getMessage("report.create_chart.error.empty_result_data"));
    this.innerContent.addClass("emptyPieState");
    this.disableCommitButton();
};

CreateChartLightbox.prototype.removeChartErrorMessage = function () {
    this.innerContent.removeClass("inErrorState");
    this.innerContent.removeClass("emptyPieState");
    this.enableCommitButton();
};

CreateChartLightbox.prototype.showLoadingChartSpinner = function () {
    this.innerContent.addClass("inLoadingState");
    this.spinnerController.spinInElement(this.innerContent.find(".createChartSpinnerPlaceholder"));
    this.disableCommitButton();
};

CreateChartLightbox.prototype.hideLoadingChartSpinner = function () {
    this.innerContent.removeClass("inLoadingState");
    this.spinnerController.stop();
    this.enableCommitButton();
};

CreateChartLightbox.prototype.disableCommitButton = function () {
    this._commitEnabled = false;
    (0, _jquery2.default)(this.commitButton).addClass('disabled');
};

CreateChartLightbox.prototype.enableCommitButton = function () {
    this._commitEnabled = true;
    (0, _jquery2.default)(this.commitButton).removeClass('disabled');
};

CreateChartLightbox.prototype.write_cookie = function (name, value) {
    _jquery2.default.cookie(name, JSON.stringify(value));
};

CreateChartLightbox.prototype.read_cookie = function (name) {
    return JSON.parse(_jquery2.default.cookie(name));
};

CreateChartLightbox.prototype.showOrHideNotFullDataMessage = function (minValue, maxValue) {
    if (minValue < 0 && maxValue > 0) (0, _jquery2.default)("#infoMessageLine").html(_messageResource2.default.getMessage("report.create_chart.negative_values_are_missed_message"));else (0, _jquery2.default)("#infoMessageLine").html("");
};

CreateChartLightbox.prototype.showOrHideNotFullDataMessage = function (minValue, maxValue) {
    if (minValue < 0 && maxValue > 0) (0, _jquery2.default)("#infoMessageLine").html(_messageResource2.default.getMessage("report.create_chart.negative_values_are_missed_message"));else (0, _jquery2.default)("#infoMessageLine").html("");
};

exports.default = CreateChartLightbox;

/***/ }),
/* 1438 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _atUtils = __webpack_require__(5);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _constants = __webpack_require__(4);

var _ListSelector = __webpack_require__(96);

var _ListSelector2 = _interopRequireDefault(_ListSelector);

var _constants2 = __webpack_require__(11);

var _features = __webpack_require__(22);

var _cp_selector_report_config = __webpack_require__(350);

var _cp_selector_report_config2 = _interopRequireDefault(_cp_selector_report_config);

var _constants3 = __webpack_require__(197);

var _SingleDateChartDateRangeSectionStrategy = __webpack_require__(1439);

var _SingleDateChartDateRangeSectionStrategy2 = _interopRequireDefault(_SingleDateChartDateRangeSectionStrategy);

var _DateRangeChartDateRangeSectionStrategy = __webpack_require__(1440);

var _DateRangeChartDateRangeSectionStrategy2 = _interopRequireDefault(_DateRangeChartDateRangeSectionStrategy);

var _LeaveHierarchicalSelectorsSectionStrategy = __webpack_require__(1441);

var _LeaveHierarchicalSelectorsSectionStrategy2 = _interopRequireDefault(_LeaveHierarchicalSelectorsSectionStrategy);

var _BalanceHierarchicalSelectorsSectionStrategy = __webpack_require__(1442);

var _BalanceHierarchicalSelectorsSectionStrategy2 = _interopRequireDefault(_BalanceHierarchicalSelectorsSectionStrategy);

var _OvertimeHoursHierarchicalSelectorsSectionStrategy = __webpack_require__(1443);

var _OvertimeHoursHierarchicalSelectorsSectionStrategy2 = _interopRequireDefault(_OvertimeHoursHierarchicalSelectorsSectionStrategy);

var _UsersGroupsGroupingLevelSelectorFillingStrategy = __webpack_require__(1444);

var _UsersGroupsGroupingLevelSelectorFillingStrategy2 = _interopRequireDefault(_UsersGroupsGroupingLevelSelectorFillingStrategy);

var _UsersGroupsMonthsWeeksDaysGroupingLevelSelectorFillingStrategy = __webpack_require__(1445);

var _UsersGroupsMonthsWeeksDaysGroupingLevelSelectorFillingStrategy2 = _interopRequireDefault(_UsersGroupsMonthsWeeksDaysGroupingLevelSelectorFillingStrategy);

var _UsersGroupsLeaveTypesMonthsWeeksDaysGroupingLevelSelectorFillingStrategy = __webpack_require__(1446);

var _UsersGroupsLeaveTypesMonthsWeeksDaysGroupingLevelSelectorFillingStrategy2 = _interopRequireDefault(_UsersGroupsLeaveTypesMonthsWeeksDaysGroupingLevelSelectorFillingStrategy);

var _AllItemsGroupingLevelSelectorFillingStrategy = __webpack_require__(1447);

var _AllItemsGroupingLevelSelectorFillingStrategy2 = _interopRequireDefault(_AllItemsGroupingLevelSelectorFillingStrategy);

var _UsersGroupsCPMonthsWeeksDaysGroupingLevelSelectorFillingStrategy = __webpack_require__(1448);

var _UsersGroupsCPMonthsWeeksDaysGroupingLevelSelectorFillingStrategy2 = _interopRequireDefault(_UsersGroupsCPMonthsWeeksDaysGroupingLevelSelectorFillingStrategy);

var _IconWithTooltip = __webpack_require__(1449);

var _IconWithTooltip2 = _interopRequireDefault(_IconWithTooltip);

var _at_overtime_report_selector_panel = __webpack_require__(1450);

var _at_overtime_report_selector_panel2 = _interopRequireDefault(_at_overtime_report_selector_panel);

var _at_reports_selector_users_panel = __webpack_require__(302);

var _at_reports_selector_users_panel2 = _interopRequireDefault(_at_reports_selector_users_panel);

var _ErrorTooltipsForSectionsController = __webpack_require__(798);

var _ErrorTooltipsForSectionsController2 = _interopRequireDefault(_ErrorTooltipsForSectionsController);

var _ReportUserSelectorButton = __webpack_require__(511);

var _ReportUserSelectorButton2 = _interopRequireDefault(_ReportUserSelectorButton);

var _LeaveTypesSelectorButton = __webpack_require__(512);

var _LeaveTypesSelectorButton2 = _interopRequireDefault(_LeaveTypesSelectorButton);

var _CustomCheckbox = __webpack_require__(83);

var _CustomCheckbox2 = _interopRequireDefault(_CustomCheckbox);

var _SimpleTooltip = __webpack_require__(36);

var _SimpleTooltip2 = _interopRequireDefault(_SimpleTooltip);

var _BillingHierarchicalSelectorsSectionStrategy = __webpack_require__(1453);

var _BillingHierarchicalSelectorsSectionStrategy2 = _interopRequireDefault(_BillingHierarchicalSelectorsSectionStrategy);

var _TaskHierarchicalSelectorsSectionStrategy = __webpack_require__(1454);

var _TaskHierarchicalSelectorsSectionStrategy2 = _interopRequireDefault(_TaskHierarchicalSelectorsSectionStrategy);

var _utils = __webpack_require__(6);

var _selectors = __webpack_require__(19);

var _StateComponent2 = __webpack_require__(105);

var _StateComponent3 = _interopRequireDefault(_StateComponent2);

var _user_group_selector_util = __webpack_require__(98);

var _UserNameFormat = __webpack_require__(17);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ChartDataParametersSectionController = function (_StateComponent) {
    _inherits(ChartDataParametersSectionController, _StateComponent);

    function ChartDataParametersSectionController() {
        _classCallCheck(this, ChartDataParametersSectionController);

        var _this = _possibleConstructorReturn(this, (ChartDataParametersSectionController.__proto__ || Object.getPrototypeOf(ChartDataParametersSectionController)).call(this));

        _this.state = {
            loggedInUserId: null
        };
        return _this;
    }

    return ChartDataParametersSectionController;
}(_StateComponent3.default);

ChartDataParametersSectionController.prototype.init = function (containerId, chartPopupData, chartType, chartDataParameters, changesCallback) {
    var _this2 = this;

    this.containerId = containerId;
    this.$containerEl = (0, _jquery2.default)("#" + this.containerId);

    this.availableCharts = (0, _atUtils.arrayToSet)(chartPopupData.availableCharts);
    this.enabledFeatures = chartPopupData.enabledFeatures;
    this.taskChartsAuthorizationInfo = chartPopupData.chartsAuthorizationInfo.taskChartsAuthorizationInfo;
    this.balanceChartsAuthorizationInfo = chartPopupData.chartsAuthorizationInfo.balanceChartsAuthorizationInfo;
    this.billingChartsAuthorizationInfo = chartPopupData.chartsAuthorizationInfo.billingChartsAuthorizationInfo;

    this.customersProjects = chartPopupData.customersProjects;
    this.customersWithMaIds = chartPopupData.customersWithMaIds;
    this.projectsWithMaIds = chartPopupData.projectsWithMaIds;
    this.users = chartPopupData.users;
    this.userGroups = chartPopupData.userGroups;
    this.timeZoneGroups = chartPopupData.timeZoneGroups;
    this.manageableUsersIds = chartPopupData.manageableUsersIds;
    this.leaveTypes = chartPopupData.leaveTypes;

    this.initiallySelectedGroupingLevel = chartDataParameters.groupingLevel;

    this.changesCallback = changesCallback;

    this.dateSelectorContainer = this.getElementBySubId("dateSelector");
    this.singleDateSelectorContainer = this.getElementBySubId("singleDateSelector");
    this.chartTypeListSelectorContainer = this.getElementBySubId("chartTypeListSelectorPlaceholder");
    this.groupingLevelListSelectorContainer = this.getElementBySubId("groupingLevelListSelectorPlaceholder");
    this.$groupingLevelListSelectorRow = this.$containerEl.find(".groupingLevelListSelectorRow");
    this.hierarchicalSelectorsSection = this.getElementBySubId("hierarchicalSelectorsSection");
    this.dateRangeSection = this.getElementBySubId("dateRangeSection");
    this.cpSelectorContainer = this.getElementBySubId("cpSelectorId");
    this.taskUsersSelectorContainer = this.getElementBySubId("taskUserSelectorButtonWrapperId");
    this.billingUsersSelectorContainer = this.getElementBySubId("billingUserSelectorButtonWrapperId");
    this.balanceUsersSelectorContainer = this.getElementBySubId("balanceUserSelectorButtonWrapperId");
    this.overtimeUsersSelectorContainer = this.getElementBySubId("overtimeUserSelectorButtonWrapperId");
    this.withUsernameLabel = this.getElementBySubId("withUsernameLabelId");
    this.leaveTypesSelectorContainer = this.getElementBySubId("leaveTypesSelectorId");
    this.noteMsgContainer = this.getElementBySubId("noteMsgId");
    this.prevUserGroupSelection = {};
    this.prevCpSelection = {};

    this.errorsToSectionElsMap = {};
    this.errorsToSectionElsMap[_constants3.Errors.ERROR_EMPTY_TASK_USER_SELECTION] = (0, _jquery2.default)(this.taskUsersSelectorContainer);
    this.errorsToSectionElsMap[_constants3.Errors.ERROR_EMPTY_BALANCE_USER_SELECTION] = (0, _jquery2.default)(this.balanceUsersSelectorContainer);
    this.errorsToSectionElsMap[_constants3.Errors.ERROR_EMPTY_BILLABLE_USER_SELECTION] = (0, _jquery2.default)(this.billingUsersSelectorContainer);
    this.errorsToSectionElsMap[_constants3.Errors.ERROR_EMPTY_OVERTIME_USER_SELECTION] = (0, _jquery2.default)(this.overtimeUsersSelectorContainer);
    this.errorsToSectionElsMap[_constants3.Errors.ERROR_EMPTY_CP_SELECTION] = (0, _jquery2.default)(this.cpSelectorContainer);
    this.errorsToSectionElsMap[_constants3.Errors.ERROR_EMPTY_LEAVE_TYPES_SELECTION] = (0, _jquery2.default)(this.leaveTypesSelectorContainer);

    this.errorTooltipsForSectionsController = new _ErrorTooltipsForSectionsController2.default().init("createChartErrorTooltip", this.errorsToSectionElsMap, function (error) {
        return _this2.getErrorMessageForSingleError(error);
    });

    var $infoIconWrappers = this.$containerEl.find(".infoIconWrapper");
    _underscore2.default.each($infoIconWrappers, function (wrapper) {
        var $wrapper = (0, _jquery2.default)(wrapper);
        $wrapper.empty();
        new _IconWithTooltip2.default(_messageResource2.default.getMessage("report.create_chart.users_wo_data_note")).init($wrapper);
    });

    this.$includeOtherUsersCheckboxPlaceholder = this.$containerEl.find('.includeOtherUsersCheckboxPlaceholder');

    this.setParameters(chartType, chartDataParameters);

    return this;
};

ChartDataParametersSectionController.prototype.setParameters = function (chartType, chartDataParameters) {
    this.deleteOldSelectors();

    this.dateRangeSelector = this.createDateRangeSelector(chartDataParameters);
    this.singleDateSelector = this.createSingleDateSelector(chartDataParameters);
    this.chartTypeSelector = this.createChartTypeSelector(chartType);
    this.groupingLevelSelector = this.createGroupingSelector(chartType, chartDataParameters.groupingLevel);
    this.cpSelector = this.makeCPSelector(chartDataParameters, this.customersProjects, this.customersWithMaIds, this.projectsWithMaIds);

    this.balanceUserSelector = this.makeUserSelector(this.balanceUsersSelectorContainer, chartDataParameters, this._getSortedAvailableUsersByIds(this.balanceChartsAuthorizationInfo.availableUserIds), this.userGroups, this.timeZoneGroups, this.balanceChartsAuthorizationInfo.allUsersAvailable);

    this.billingUserSelector = this.makeUserSelector(this.billingUsersSelectorContainer, chartDataParameters, this._getSortedAvailableUsersByIds(this.billingChartsAuthorizationInfo.availableUserIds), this.userGroups, this.timeZoneGroups, this.billingChartsAuthorizationInfo.allUsersAvailable);

    this.taskUserSelector = this.makeUserSelector(this.taskUsersSelectorContainer, chartDataParameters, this._getSortedAvailableUsersByIds(this.taskChartsAuthorizationInfo.availableUserIds), this.userGroups, this.timeZoneGroups, this.taskChartsAuthorizationInfo.allUsersAvailable);

    this.overtimeUserSelector = this.makeOvertimeUserSelector(chartDataParameters, this.users.sort(_user_group_selector_util.userComparator), this.userGroups, this.timeZoneGroups, this.balanceChartsAuthorizationInfo.allUsersAvailable);

    this.leaveTypesSelector = this.makeLeaveTypesSelector(chartDataParameters, this.leaveTypes);
    this.includeOtherUsersCheckbox = this.makeIncludeOtherUsersCheckbox(chartDataParameters);

    this.dateRangeSectionStrategy = this.getDateRangeSectionStrategy(chartType);
    this.hierarchicalSelectorsSectionStrategy = this.getHierarchicalSelectorsSectionStrategy(chartType);

    this.errors = [];

    this.updateUI();
};

ChartDataParametersSectionController.prototype.DEFAULT_SELECTOR_PARAMETERS = {
    dateRangeSelection: {
        qualifier: _constants.DateRangeSelectionQualifier.CURRENT_MONTH,
        fromDate: null,
        toDate: null
    },
    singleDateSelection: {
        qualifier: _constants.EvaDateQualifier.TODAY,
        date: null
    },
    cpSelection: {
        qualifier: _constants.CustomersProjectsSelectionQualifier.ALL,
        customers: [],
        projects: [],
        showArchivedProjects: false
    },
    userSelection: {
        allUsers: true,
        selectedUsers: [],
        selectedGroups: [],
        showDisabled: false
    },
    leavesSelection: {
        qualifier: _constants.LeaveTypeSelectionQualifier.ALL,
        leaveTypes: [],
        showInactive: false
    }
};

ChartDataParametersSectionController.prototype.onChartTypeChanged = function () {
    var newChartType = this.chartTypeSelector.getSelectedItem().value;
    this.hierarchicalSelectorsSectionStrategy = this.getHierarchicalSelectorsSectionStrategy(newChartType);
    this.prevUserGroupSelection = this.hierarchicalSelectorsSectionStrategy.getUserSelection();
    // To save selection while chart type changes - need to be fixed or remove
    // const oldUserSelection = this.hierarchicalSelectorsSectionStrategy.getUserSelection()
    // const userSelected = this.hierarchicalSelectorsSectionStrategy.validateIsUserSelected()
    // const withUserSelector = this.hierarchicalSelectorsSectionStrategy.withUserSelector()
    // this.hierarchicalSelectorsSectionStrategy.setUserSelection(withUserSelector && userSelected ? oldUserSelection : this.DEFAULT_SELECTOR_PARAMETERS.userSelection)
    this.handleWaMaCpSelectorScope(newChartType);
    this.dateRangeSectionStrategy = this.getDateRangeSectionStrategy(newChartType);
    var oldSelectedGroupingLevel = this.groupingLevelSelector.getSelectedItem().value;
    (0, _jquery2.default)(this.groupingLevelListSelectorContainer).empty();
    this.groupingLevelSelector = this.createGroupingSelector(newChartType, oldSelectedGroupingLevel);
    this.changesDetected();
};

ChartDataParametersSectionController.prototype.handleWaMaCpSelectorScope = function (chartType) {
    if (this.cpSelector.panel.isAlreadyShown()) {
        switch (chartType) {
            case _constants2.ReportChartType.TOTAL_WORKING_HOURS:
            case _constants2.ReportChartType.APPROVED_WORKING_HOURS:
                this.cpSelector.panel.toggleScopeSwitcher(true);
                break;
            case _constants2.ReportChartType.COST_OF_WORK:
            case _constants2.ReportChartType.BILLABLE_AMOUNTS:
                this.showManageScopeOnly = true;
                this.cpSelector.panel.showOnlyManageScope(true);
                this.cpSelector.panel.toggleScopeSwitcher(false);
                break;
        }
    }
};

ChartDataParametersSectionController.prototype.changesDetected = function () {
    this.validate();
    this.updateUI();

    if (this.changesCallback) this.changesCallback();
};

ChartDataParametersSectionController.prototype.updateUI = function () {
    this.hierarchicalSelectorsSectionStrategy.updateSectionUI();
    this.dateRangeSectionStrategy.updateSectionUI();
    this._updateIncludeOtherUsersCheckbox();
    this._updateUsernameLabel();

    var containerEl = (0, _jquery2.default)("#" + this.containerId);

    Object.values(_constants3.Errors).forEach(function (errorClass) {
        return containerEl.removeClass(errorClass);
    });

    for (var i = 0; i < this.errors.length; i++) {
        containerEl.addClass(this.errors[i]);
    }this.errorTooltipsForSectionsController.updateTooltips(this.errors);
};

ChartDataParametersSectionController.prototype._updateIncludeOtherUsersCheckbox = function () {
    var disabled = this.hierarchicalSelectorsSectionStrategy.getUserSelection().allUsers !== true;
    this.includeOtherUsersCheckbox.setState({
        checked: !disabled && this.includeOtherUsersCheckbox.isChecked(),
        disabled: disabled,
        label: this.showUserSelector ? _messageResource2.default.getMessage('report.common.include_not_assigned_users') : _messageResource2.default.getMessage('report.common.include_other_users')
    });

    this.includeOtherUsersCheckboxTooltip.setEnabled(disabled);
};

ChartDataParametersSectionController.prototype._updateUsernameLabel = function () {
    var _this3 = this;

    var usernameLabelText = "";
    if (!this.showUserSelector) {
        var user = this.users.find(function (u) {
            return u.id === _this3.state.loggedInUserId;
        });
        usernameLabelText = (0, _UserNameFormat.formatLFM)(user.firstName, user.lastName, user.middleName, ", ");
    }
    this.withUsernameLabel.innerText = usernameLabelText;
};

ChartDataParametersSectionController.prototype.getElementBySubId = function (id) {
    return document.getElementById(this.containerId + "_" + id);
};

ChartDataParametersSectionController.prototype.deleteOldSelectors = function () {
    (0, _jquery2.default)(this.dateSelectorContainer).empty();
    (0, _jquery2.default)(this.singleDateSelectorContainer).empty();
    (0, _jquery2.default)(this.chartTypeListSelectorContainer).empty();
    (0, _jquery2.default)(this.groupingLevelListSelectorContainer).empty();
    (0, _jquery2.default)(this.cpSelectorContainer).empty();
    (0, _jquery2.default)(this.taskUsersSelectorContainer).empty();
    (0, _jquery2.default)(this.balanceUsersSelectorContainer).empty();
    (0, _jquery2.default)(this.billingUsersSelectorContainer).empty();
    (0, _jquery2.default)(this.overtimeUsersSelectorContainer).empty();
    (0, _jquery2.default)(this.leaveTypesSelectorContainer).empty();
    this.$includeOtherUsersCheckboxPlaceholder.empty();
};

ChartDataParametersSectionController.prototype.createDateRangeSelector = function (chartDataParameters) {
    var dateRangeSelection = chartDataParameters.dateRangeSelection ? chartDataParameters.dateRangeSelection : this.DEFAULT_SELECTOR_PARAMETERS.dateRangeSelection;

    var self = this;
    var dateRangeSelectorConfig = {
        dateRangeSelection: dateRangeSelection,
        menuStates: new DateRangeMenuItemsUtil().createDefaultDateRangeMenuItems(dateRangeSelection.qualifier),
        layout: "auto",
        renderTo: self.dateSelectorContainer.id,
        callOnChangeCallbackIfInvalid: true,
        shortDateFormat: true,
        dropdownClassName: "chartDateDropdown"
    };

    var dateRangeSelector = new DateRangeSelectorController().init(dateRangeSelectorConfig);
    dateRangeSelector._flushErrorState();
    dateRangeSelector.setOnChangeCallback(function () {
        self.changesDetected();
    });
    return dateRangeSelector;
};

ChartDataParametersSectionController.prototype.createSingleDateSelector = function (chartDataParameters) {
    var dateSelection = chartDataParameters.dateSelection ? chartDataParameters.dateSelection : this.DEFAULT_SELECTOR_PARAMETERS.singleDateSelection;

    var self = this;
    var dateSelectorConfig = {
        dateRangeSelection: dateSelection,
        menuStates: new DateRangeMenuItemsUtil().createDefaultSingleDateMenuItems(),
        layout: "auto",
        renderTo: self.singleDateSelectorContainer.id,
        shortDateFormat: true
    };

    var dateSelector = new SingleDateSelectorController().init(dateSelectorConfig);
    dateSelector.setOnChangeCallback(function () {
        self.changesDetected();
    });

    var labelEl = (0, _jquery2.default)("<span class='singleDateRangeLabel'>" + _messageResource2.default.getMessage("report.create_chart.as_of") + "</span>");
    labelEl.insertBefore((0, _jquery2.default)(this.singleDateSelectorContainer).find(".dateRangeDropdownSelector "));

    return dateSelector;
};

ChartDataParametersSectionController.prototype.createChartTypeSelector = function (chartType) {
    var self = this;
    return this.createListSelector(this.chartTypeListSelectorContainer, function (listSelector) {
        self.fillChartTypeListSelector(listSelector, chartType);
    }, "chartTypeListSelector", chartType, function () {
        self.onChartTypeChanged();
    });
};

ChartDataParametersSectionController.prototype.createGroupingSelector = function (chartType, selectedGroupingLevel) {
    var _this4 = this;

    this.groupingLevelsSelectorFillingStrategy = this.getGroupingLevelSelectorFillingStrategy(chartType);

    return this.createListSelector(this.groupingLevelListSelectorContainer, function (listSelector) {
        _this4.groupingLevelsSelectorFillingStrategy.fillGroupingLevelListSelector(listSelector);
    }, "groupingLevelListSelector", selectedGroupingLevel, function () {
        _this4.changesDetected();
    });
};

ChartDataParametersSectionController.prototype.createListSelector = function (containerEl, fillSelectorCallback, selectorCls, selectedValue, changesCallback) {
    var listSelector = new _ListSelector2.default({
        renderTo: containerEl,
        menuCls: selectorCls
    });
    fillSelectorCallback(listSelector);
    if (selectedValue) listSelector.setActiveItemByValue(selectedValue, true);

    if (listSelector.getSelectedItem() === null) listSelector.setItem(listSelector.menu.items.items[0]);

    listSelector.on("change", function () {
        if (changesCallback) changesCallback();
    });

    return listSelector;
};

ChartDataParametersSectionController.prototype.fillChartTypeListSelector = function (listSelector, chartType) {
    var taskCharts = [];
    if (this.availableCharts[_constants2.ReportChartType.TOTAL_WORKING_HOURS]) taskCharts.push({ text: _messageResource2.default.getMessage("report.chart_type.total_working_hours"), value: _constants2.ReportChartType.TOTAL_WORKING_HOURS });
    if (this.availableCharts[_constants2.ReportChartType.APPROVED_WORKING_HOURS] || chartType === _constants2.ReportChartType.APPROVED_WORKING_HOURS) taskCharts.push({ text: _messageResource2.default.getMessage("report.chart_type.approved_working_hours"), value: _constants2.ReportChartType.APPROVED_WORKING_HOURS });

    var timeCharts = [];
    if (this.availableCharts[_constants2.ReportChartType.LEAVE_HOURS] || chartType === _constants2.ReportChartType.LEAVE_HOURS) timeCharts.push({ text: _messageResource2.default.getMessage("report.chart_type.leave_hours"), value: _constants2.ReportChartType.LEAVE_HOURS });
    if (this.availableCharts[_constants2.ReportChartType.PTO_BALANCE] || chartType === _constants2.ReportChartType.PTO_BALANCE) timeCharts.push({ text: _messageResource2.default.getMessage("report.chart_type.pto_balance"), value: _constants2.ReportChartType.PTO_BALANCE });
    if (this.availableCharts[_constants2.ReportChartType.SICK_DAYS_BALANCE] || chartType === _constants2.ReportChartType.SICK_DAYS_BALANCE) timeCharts.push({ text: _messageResource2.default.getMessage("report.chart_type.sick_days_balance"), value: _constants2.ReportChartType.SICK_DAYS_BALANCE });
    if (this.availableCharts[_constants2.ReportChartType.OVERTIME_HOURS] || chartType === _constants2.ReportChartType.OVERTIME_HOURS) timeCharts.push({ text: _messageResource2.default.getMessage("report.chart_type.overtime_hours"), value: _constants2.ReportChartType.OVERTIME_HOURS });

    var moneyCharts = [];
    if (this.availableCharts[_constants2.ReportChartType.COST_OF_WORK] || chartType === _constants2.ReportChartType.COST_OF_WORK) moneyCharts.push({ text: _messageResource2.default.getMessage("report.chart_type.cost_of_work"), value: _constants2.ReportChartType.COST_OF_WORK });
    if (this.availableCharts[_constants2.ReportChartType.BILLABLE_AMOUNTS] || chartType === _constants2.ReportChartType.BILLABLE_AMOUNTS) moneyCharts.push({ text: _messageResource2.default.getMessage("report.chart_type.billable_amounts"), value: _constants2.ReportChartType.BILLABLE_AMOUNTS });

    if (taskCharts.length > 0) {
        listSelector.addItems(taskCharts);
        if (timeCharts.length > 0 || moneyCharts.length > 0) listSelector.addSeparator();
    }

    if (timeCharts.length > 0) {
        listSelector.addItems(timeCharts);
        if (moneyCharts.length > 0) listSelector.addSeparator();
    }

    if (moneyCharts.length > 0) {
        listSelector.addItems(moneyCharts);
    }
};

ChartDataParametersSectionController.prototype.isEnabledFeature = function (featureName) {
    return this.enabledFeatures.hasOwnProperty(featureName);
};

ChartDataParametersSectionController.prototype.getDateRangeSectionStrategy = function (selectedValueType) {
    if (selectedValueType === _constants2.ReportChartType.PTO_BALANCE || selectedValueType === _constants2.ReportChartType.SICK_DAYS_BALANCE) return new _SingleDateChartDateRangeSectionStrategy2.default().init(this.dateRangeSection, this.dateRangeSelector, this.singleDateSelector);

    return new _DateRangeChartDateRangeSectionStrategy2.default().init(this.dateRangeSection, this.dateRangeSelector, this.singleDateSelector);
};

ChartDataParametersSectionController.prototype.getHierarchicalSelectorsSectionStrategy = function (selectedValueType) {
    var strategy = void 0;
    var showUserSelector = false;

    switch (selectedValueType) {
        case _constants2.ReportChartType.TOTAL_WORKING_HOURS:
        case _constants2.ReportChartType.APPROVED_WORKING_HOURS:
            showUserSelector = this.taskChartsAuthorizationInfo.anyOtherUsersAvailable || this.taskChartsAuthorizationInfo.allUsersAvailable;

            strategy = new _TaskHierarchicalSelectorsSectionStrategy2.default({
                showUserSelector: showUserSelector,
                showIncludeOtherUsersCheckbox: !this.taskChartsAuthorizationInfo.allUsersAvailable,
                taskUserSelector: this.taskUserSelector
            });
            break;

        case _constants2.ReportChartType.COST_OF_WORK:
            showUserSelector = this.billingChartsAuthorizationInfo.anyOtherUsersAvailable || this.billingChartsAuthorizationInfo.allUsersAvailable;

            strategy = new _BillingHierarchicalSelectorsSectionStrategy2.default({
                showUserSelector: showUserSelector,
                showIncludeOtherUsersCheckbox: !this.billingChartsAuthorizationInfo.allUsersAvailable,
                billingUserSelector: this.billingUserSelector
            });
            break;

        case _constants2.ReportChartType.BILLABLE_AMOUNTS:
            showUserSelector = true;

            strategy = new _BillingHierarchicalSelectorsSectionStrategy2.default({
                showUserSelector: showUserSelector,
                showIncludeOtherUsersCheckbox: !this.billingChartsAuthorizationInfo.allUsersAvailable,
                billingUserSelector: this.billingUserSelector
            });
            break;

        case _constants2.ReportChartType.LEAVE_HOURS:
            showUserSelector = this.balanceChartsAuthorizationInfo.anyOtherUsersAvailable;

            strategy = new _LeaveHierarchicalSelectorsSectionStrategy2.default({
                showUserSelector: showUserSelector,
                balanceUserSelector: this.balanceUserSelector
            });
            break;

        case _constants2.ReportChartType.PTO_BALANCE:
        case _constants2.ReportChartType.SICK_DAYS_BALANCE:
            showUserSelector = this.balanceChartsAuthorizationInfo.anyOtherUsersAvailable;
            strategy = new _BalanceHierarchicalSelectorsSectionStrategy2.default({
                showUserSelector: showUserSelector,
                balanceUserSelector: this.balanceUserSelector
            });
            break;

        case _constants2.ReportChartType.OVERTIME_HOURS:
            showUserSelector = this.balanceChartsAuthorizationInfo.anyOtherUsersAvailable;
            strategy = new _OvertimeHoursHierarchicalSelectorsSectionStrategy2.default({
                showUserSelector: showUserSelector,
                overtimeUserSelector: this.overtimeUserSelector
            });
            break;

        default:
            throw "Incorrect report chart type";
    }

    this.showUserSelector = showUserSelector;

    strategy.init({
        container: this.hierarchicalSelectorsSection,
        leaveTypesSelector: this.leaveTypesSelector,
        noteMsgContainer: this.noteMsgContainer,
        includeOtherUsersCheckbox: this.includeOtherUsersCheckbox,
        cpSelector: this.cpSelector
    });

    return strategy;
};

ChartDataParametersSectionController.prototype._getSortedAvailableUsersByIds = function (userIds) {
    var idsSet = (0, _atUtils.arrayToSet)(userIds);
    return this.users.filter(function (user) {
        return idsSet[user.id];
    }).sort(_user_group_selector_util.userComparator);
};

ChartDataParametersSectionController.prototype.getGroupingLevelSelectorFillingStrategy = function (selectedChartType) {
    var ugrEnabled = (0, _features.isEnabled)(_features.Feature.UGR);
    var tzgEnabled = (0, _features.isEnabled)(_features.Feature.TZG);
    var btyEnabled = (0, _features.isEnabled)(_features.Feature.BTY);

    if (selectedChartType === _constants2.ReportChartType.PTO_BALANCE || selectedChartType === _constants2.ReportChartType.SICK_DAYS_BALANCE) {
        return new _UsersGroupsGroupingLevelSelectorFillingStrategy2.default().init(ugrEnabled, btyEnabled, tzgEnabled, this.initiallySelectedGroupingLevel);
    } else if (selectedChartType === _constants2.ReportChartType.OVERTIME_HOURS) {
        return new _UsersGroupsMonthsWeeksDaysGroupingLevelSelectorFillingStrategy2.default().init(ugrEnabled, btyEnabled, tzgEnabled, this.initiallySelectedGroupingLevel);
    } else if (selectedChartType === _constants2.ReportChartType.LEAVE_HOURS) {
        return new _UsersGroupsLeaveTypesMonthsWeeksDaysGroupingLevelSelectorFillingStrategy2.default().init(ugrEnabled, btyEnabled, tzgEnabled, this.initiallySelectedGroupingLevel);
    } else if (selectedChartType === _constants2.ReportChartType.TOTAL_WORKING_HOURS || selectedChartType === _constants2.ReportChartType.APPROVED_WORKING_HOURS) {
        return new _AllItemsGroupingLevelSelectorFillingStrategy2.default().init(ugrEnabled, btyEnabled, tzgEnabled, this.initiallySelectedGroupingLevel);
    } else {
        return new _UsersGroupsCPMonthsWeeksDaysGroupingLevelSelectorFillingStrategy2.default().init(ugrEnabled, btyEnabled, tzgEnabled, this.initiallySelectedGroupingLevel);
    }
};

ChartDataParametersSectionController.prototype.makeCPSelector = function (chartDataParameters, cpList, customersWithMaIds, projectsWithMaIds) {
    var _this5 = this;

    var cpSelection = chartDataParameters.customersProjectsSelection ? chartDataParameters.customersProjectsSelection : this.DEFAULT_SELECTOR_PARAMETERS.cpSelection;

    var cpSelector = new _cp_selector_report_config2.default().init(cpSelection, this.cpSelectorContainer.id, function () {
        var currentSelection = cpSelector.getCpSelection();
        if (_this5.cpSelector.panel.shouldSave && !_underscore2.default.isEqual(currentSelection, _this5.prevCpSelection)) {
            _this5.changesDetected();
            _this5.cpSelector.setInitialValueFromCurrent();
            _this5.prevCpSelection = currentSelection;
        }
    }, true, function () {
        return _this5.handleWaMaCpSelectorScope(_this5.chartTypeSelector.getSelectedItem().value);
    });

    this.showManageScopeOnly = false;
    this.prevCpSelection = cpSelection;
    cpSelector.initializeData(cpList, customersWithMaIds, projectsWithMaIds);
    return cpSelector;
};

ChartDataParametersSectionController.prototype.makeUserSelector = function (usersSelectorContainer, chartDataParameters, users, userGroups, timeZoneGroups, allUsersAvailable) {
    return this.createUserSelector(usersSelectorContainer, chartDataParameters, users, userGroups, timeZoneGroups, _at_reports_selector_users_panel2.default, allUsersAvailable, this.manageableUsersIds);
};

ChartDataParametersSectionController.prototype.makeOvertimeUserSelector = function (chartDataParameters, users, userGroups, timeZoneGroups, allUsersAvailable) {
    var overtimeUsers = [];
    var manageableOvertimeUsersIds = [];
    var manageableIdsSet = this.manageableUsersIds != null ? (0, _atUtils.arrayToSet)(this.manageableUsersIds) : null;

    for (var i = 0; i < users.length; i++) {
        if (users[i].overtimeEnabled) {
            overtimeUsers.push(users[i]);

            if (manageableIdsSet == null || manageableIdsSet[users[i].id]) {
                manageableOvertimeUsersIds.push(users[i].id);
            }
        }
    }

    return this.createUserSelector(this.overtimeUsersSelectorContainer, chartDataParameters, overtimeUsers, userGroups, timeZoneGroups, _at_overtime_report_selector_panel2.default, allUsersAvailable, manageableOvertimeUsersIds);
};

ChartDataParametersSectionController.prototype.createUserSelector = function (selectorContainer, chartDataParameters, users, userGroups, timeZoneGroups, panelConstructor, allUsersAvailable, manageableUsersIds) {
    var _this6 = this;

    var defaultUserSelection = {
        allUsers: true,
        selectedUsers: [],
        selectedGroups: [],
        showDisabled: false,
        groupType: null,
        includeUserTeamOnly: false
    };
    var userSelection = chartDataParameters.userSelection ? chartDataParameters.userSelection : defaultUserSelection;

    var userSelector = new _ReportUserSelectorButton2.default();

    var selectorConfig = {
        selectorId: selectorContainer.id,
        userSelection: userSelection,
        specificConstructorPanel: panelConstructor,
        changeCallback: function changeCallback() {
            var currentSelection = userSelector.getSelection();
            if (userSelector.panel.shouldSave && !_underscore2.default.isEqual(currentSelection, _this6.prevUserGroupSelection)) {
                _this6.changesDetected();
                userSelector.setInitialValueFromCurrent();
                _this6.prevUserGroupSelection = currentSelection;
            }
        },
        withApplyButton: true,
        needAdditionalCheckbox: false,
        includeUsersWithoutDataDefaultValue: true,
        allUsersAvailable: allUsersAvailable
    };

    userSelector.init(selectorConfig);
    userSelector.updateSelector(users, userGroups, timeZoneGroups, manageableUsersIds, userSelection.includeUserTeamOnly);

    userSelector.panel.loggedInUserNotInTeam = this.manageableUsersIds !== null && this.manageableUsersIds.indexOf(this.state.loggedInUserId) === -1 && users.some(function (u) {
        return u.id === _this6.state.loggedInUserId;
    });

    userSelector.updateButton();

    this.prevUserGroupSelection = userSelection;

    return userSelector;
};

ChartDataParametersSectionController.prototype.makeIncludeOtherUsersCheckbox = function (chartDataParameters) {
    var _this7 = this;

    this.includeOtherUsersCheckbox = new _CustomCheckbox2.default({
        label: _messageResource2.default.getMessage('report.common.include_not_assigned_users'),
        checkboxAdditionalClass: 'checkboxInput',
        checkmarkAdditionalClass: 'hiddenCheckmark',
        checked: chartDataParameters.includeOtherUsersColumn,
        onChange: function onChange() {
            return _this7.changesDetected();
        }
    }).init(this.$includeOtherUsersCheckboxPlaceholder);

    this.includeOtherUsersCheckboxTooltip = new _SimpleTooltip2.default({
        text: _messageResource2.default.getMessage('report.common.show_other_users_checkbox_tooltip_text')
    }).init((0, _jquery2.default)('body'));
    this.includeOtherUsersCheckboxTooltip.subscribeToMouseEvents(this.includeOtherUsersCheckbox.getEl());

    return this.includeOtherUsersCheckbox;
};

ChartDataParametersSectionController.prototype.includeOtherUsers = function () {
    if (this.hierarchicalSelectorsSectionStrategy.isShowIncludeOtherUsersCheckbox()) return this.includeOtherUsersCheckbox.isChecked();
    return false;
};

ChartDataParametersSectionController.prototype.isStateChanged = function (currentSelectionData, previousSelectionData) {

    if (currentSelectionData.optionValue !== previousSelectionData.optionValue) {
        return true;
    } else {
        if (currentSelectionData.isCustomOptionSelected) {
            return !this.twoLevelSelectionEquals(currentSelectionData.selection, previousSelectionData.selection);
        }
    }
    return false;
};

ChartDataParametersSectionController.prototype.twoLevelSelectionEquals = function (currentSelection, previousSelection) {
    return (0, _atUtils.areUnorderedArraysEqual)(currentSelection.getFirstLevel(), previousSelection.getFirstLevel()) && (0, _atUtils.areUnorderedArraysEqual)(currentSelection.getSecondLevel(), previousSelection.getSecondLevel());
};

ChartDataParametersSectionController.prototype.makeLeaveTypesSelector = function (chartDataParameters, leavesData) {
    var leavesSelection = chartDataParameters.leaveTypeSelection ? chartDataParameters.leaveTypeSelection : this.DEFAULT_SELECTOR_PARAMETERS.leavesSelection;

    var self = this;
    return new _LeaveTypesSelectorButton2.default().init({
        renderTo: this.leaveTypesSelectorContainer.id,
        leavesSelection: leavesSelection,
        leavesData: leavesData,
        ptoFeatureEnabled: (0, _features.isEnabled)(_features.Feature.PTO),
        sickBalanceFeatureEnabled: (0, _features.isEnabled)(_features.Feature.SDB),
        changeCallback: function changeCallback() {
            if (self.leaveTypesSelector.isStateChanged()) self.changesDetected();
            self.leaveTypesSelector.setInitialValuesFromCurrent();
        },
        withApplyButton: true,
        showInactiveCheckbox: true
    });
};

ChartDataParametersSectionController.prototype.validate = function () {
    this.errors = [];

    var dateRangeErrors = this.dateRangeSectionStrategy.validate();
    var hierarchicalSelectorsErrors = this.hierarchicalSelectorsSectionStrategy.validate();

    var i = void 0;
    for (i = 0; i < dateRangeErrors.length; i++) {
        this.errors.push(dateRangeErrors[i]);
    }for (i = 0; i < hierarchicalSelectorsErrors.length; i++) {
        this.errors.push(hierarchicalSelectorsErrors[i]);
    }return this.errors.length === 0;
};

ChartDataParametersSectionController.prototype.hasErrors = function () {
    return this.errors.length !== 0;
};

ChartDataParametersSectionController.prototype.getChartType = function () {
    return this.chartTypeSelector.getSelectedItem().value;
};

ChartDataParametersSectionController.prototype.getSelectedValues = function () {
    return {
        chartTypeValue: this.getChartType(),
        groupingLevelValue: this.getGroupingLevel(),
        dateParameters: this.dateRangeSectionStrategy.getSelectedParams(),
        hierarchicalSelectorsParameters: this.hierarchicalSelectorsSectionStrategy.getSelectedParams()
    };
};

ChartDataParametersSectionController.prototype.getSelectedParams = function () {
    var params = {
        groupingLevel: this.getGroupingLevel()
    };
    var hierarchicalParams = this.hierarchicalSelectorsSectionStrategy.getSelectedParams();
    var dateRangeParams = this.dateRangeSectionStrategy.getSelectedParamsJSON();
    return _jquery2.default.extend(_jquery2.default.extend(params, hierarchicalParams), dateRangeParams);
};

ChartDataParametersSectionController.prototype.getGroupingLevel = function () {
    return this.groupingLevelSelector.getSelectedItem().value;
};

ChartDataParametersSectionController.prototype.getErrorMessage = function () {
    if (this.errors.length === 0) return "";
    if (this.errors.length > 1) return _messageResource2.default.getMessage("report.js.error.exist_invalid_fields");

    return this.getErrorMessageForSingleError(this.errors[0]);
};

ChartDataParametersSectionController.prototype.getErrorMessageForSingleError = function (error) {
    return (0, _atUtils.escapeHtmlSymbols)(this.getUnescapedErrorMessageForSingleError(error));
};

ChartDataParametersSectionController.prototype.getUnescapedErrorMessage = function () {
    if (this.errors.length === 0) return "";
    if (this.errors.length > 1) return _messageResource2.default.getMessage("report.js.error.exist_invalid_fields");

    return this.getUnescapedErrorMessageForSingleError(this.errors[0]);
};

ChartDataParametersSectionController.prototype.getUnescapedErrorMessageForSingleError = function (error) {
    switch (error) {
        case _constants3.Errors.ERROR_EMPTY_CP_SELECTION:
            return _messageResource2.default.getMessage("projects_customers_selector.please_select_customer_or_project");
        case _constants3.Errors.ERROR_EMPTY_TASK_USER_SELECTION:
        case _constants3.Errors.ERROR_EMPTY_BALANCE_USER_SELECTION:
        case _constants3.Errors.ERROR_EMPTY_BILLABLE_USER_SELECTION:
        case _constants3.Errors.ERROR_EMPTY_OVERTIME_USER_SELECTION:
            return _messageResource2.default.getMessage("report.js.choose_person");
        case _constants3.Errors.ERROR_EMPTY_LEAVE_TYPES_SELECTION:
            return _messageResource2.default.getMessage("report.leaves.js.choose_leave_type");
        case _constants3.Errors.ERROR_INCORRECT_DATE_RANGE:
            return _messageResource2.default.getMessage(this.dateRangeSelector.getErrorMessageKey());
    }
    return "";
};

exports.default = (0, _utils.connect)(function (state) {
    return {
        loggedInUserId: (0, _selectors.getLoggedInUserId)(state)
    };
})(ChartDataParametersSectionController);

/***/ }),
/* 1439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _ChartDateRangeSectionStrategy = __webpack_require__(795);

var _ChartDateRangeSectionStrategy2 = _interopRequireDefault(_ChartDateRangeSectionStrategy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function SingleDateChartDateRangeSectionStrategy() {}

SingleDateChartDateRangeSectionStrategy.prototype = new _ChartDateRangeSectionStrategy2.default();

SingleDateChartDateRangeSectionStrategy.prototype.updateSectionUI = function () {
    _ChartDateRangeSectionStrategy2.default.prototype.updateSectionUI.call(this);
    (0, _jquery2.default)(this.container).addClass("withSingleDateSelector");
};

SingleDateChartDateRangeSectionStrategy.prototype.getSelectedParamsJSON = function () {
    return { dateSelection: this.singleDateSelector.getSelectedRangeJSON() };
};

SingleDateChartDateRangeSectionStrategy.prototype.getSelectedParams = function () {
    return { dateSelection: this.singleDateSelector.getSelectedRange() };
};

exports.default = SingleDateChartDateRangeSectionStrategy;

/***/ }),
/* 1440 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _constants = __webpack_require__(197);

var _ChartDateRangeSectionStrategy = __webpack_require__(795);

var _ChartDateRangeSectionStrategy2 = _interopRequireDefault(_ChartDateRangeSectionStrategy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function DateRangeChartDateRangeSectionStrategy() {}

DateRangeChartDateRangeSectionStrategy.prototype = new _ChartDateRangeSectionStrategy2.default();

DateRangeChartDateRangeSectionStrategy.prototype.updateSectionUI = function () {
    _ChartDateRangeSectionStrategy2.default.prototype.updateSectionUI.call(this);
    (0, _jquery2.default)(this.container).addClass("withDateRangeSelector");
};

DateRangeChartDateRangeSectionStrategy.prototype.getSelectedParamsJSON = function () {
    return { dateRangeSelection: this.dateRangeSelector.getSelectedRangeJSON() };
};

DateRangeChartDateRangeSectionStrategy.prototype.getSelectedParams = function () {
    return { dateRangeSelection: this.dateRangeSelector.getSelectedRange() };
};

DateRangeChartDateRangeSectionStrategy.prototype.validate = function () {
    if (this.dateRangeSelector.hasErrors()) return [_constants.Errors.ERROR_INCORRECT_DATE_RANGE];
    return [];
};

exports.default = DateRangeChartDateRangeSectionStrategy;

/***/ }),
/* 1441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _ChartHierarchicalSelectorsSectionStrategy = __webpack_require__(300);

var _ChartHierarchicalSelectorsSectionStrategy2 = _interopRequireDefault(_ChartHierarchicalSelectorsSectionStrategy);

var _constants = __webpack_require__(197);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function LeaveHierarchicalSelectorsSectionStrategy(_ref) {
    var showUserSelector = _ref.showUserSelector,
        balanceUserSelector = _ref.balanceUserSelector;

    this.params = {
        showUserSelector: showUserSelector,
        balanceUserSelector: balanceUserSelector
    };
}

LeaveHierarchicalSelectorsSectionStrategy.prototype = new _ChartHierarchicalSelectorsSectionStrategy2.default();

LeaveHierarchicalSelectorsSectionStrategy.prototype.updateSectionUI = function () {
    _ChartHierarchicalSelectorsSectionStrategy2.default.prototype.updateSectionUI.call(this);
    var classes = this.params.showUserSelector ? this.getVisibleBalanceUsersSelectorClassName() + " " + this.getVisibleUserSelectorInfoIconClassName() : " " + this.getVisibleUsernameClassName();
    classes += " " + this.getVisibleLeaveTypesSelectorClassName();
    (0, _jquery2.default)(this.container).addClass(classes);
};

LeaveHierarchicalSelectorsSectionStrategy.prototype.withUserSelector = function () {
    return this.params.showUserSelector;
};

LeaveHierarchicalSelectorsSectionStrategy.prototype.getUserSelection = function () {
    return this.params.balanceUserSelector.getSelection();
};

LeaveHierarchicalSelectorsSectionStrategy.prototype.getSelectedParams = function () {
    return {
        userSelection: this.params.balanceUserSelector.getSelection(),
        leaveTypeSelection: this.leaveTypesSelector.getLeaveTypeSelection()
    };
};

LeaveHierarchicalSelectorsSectionStrategy.prototype.validate = function () {
    var errors = [];

    if (!this.validateIsUserSelected()) errors.push(_constants.Errors.ERROR_EMPTY_BALANCE_USER_SELECTION);
    if (this.leaveTypesSelector.isEmptySelection()) errors.push(_constants.Errors.ERROR_EMPTY_LEAVE_TYPES_SELECTION);

    return errors;
};

LeaveHierarchicalSelectorsSectionStrategy.prototype.validateIsUserSelected = function () {
    return this.params.balanceUserSelector.validateIsUserSelected();
};

LeaveHierarchicalSelectorsSectionStrategy.prototype.setUserSelection = function (selection) {
    this.params.balanceUserSelector.setSelection(selection);
};

exports.default = LeaveHierarchicalSelectorsSectionStrategy;

/***/ }),
/* 1442 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _constants = __webpack_require__(197);

var _ChartHierarchicalSelectorsSectionStrategy = __webpack_require__(300);

var _ChartHierarchicalSelectorsSectionStrategy2 = _interopRequireDefault(_ChartHierarchicalSelectorsSectionStrategy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function BalanceHierarchicalSelectorsSectionStrategy(_ref) {
    var showUserSelector = _ref.showUserSelector,
        balanceUserSelector = _ref.balanceUserSelector;

    this.params = {
        showUserSelector: showUserSelector,
        balanceUserSelector: balanceUserSelector
    };
}

BalanceHierarchicalSelectorsSectionStrategy.prototype = new _ChartHierarchicalSelectorsSectionStrategy2.default();

BalanceHierarchicalSelectorsSectionStrategy.prototype.updateSectionUI = function () {
    _ChartHierarchicalSelectorsSectionStrategy2.default.prototype.updateSectionUI.call(this);
    var classes = this.params.showUserSelector ? this.getVisibleBalanceUsersSelectorClassName() : " " + this.getVisibleUsernameClassName();
    classes += " " + this.getVisibleNoteMsgClassName();
    (0, _jquery2.default)(this.container).addClass(classes);
    this.noteMsgContainer.innerHTML = _messageResource2.default.getMessage("report.chart.balance_shown_within_date_range");
};

BalanceHierarchicalSelectorsSectionStrategy.prototype.withUserSelector = function () {
    return this.params.showUserSelector;
};

BalanceHierarchicalSelectorsSectionStrategy.prototype.getUserSelection = function () {
    return this.params.balanceUserSelector.getSelection();
};

BalanceHierarchicalSelectorsSectionStrategy.prototype.getSelectedParams = function () {
    return {
        userSelection: this.params.balanceUserSelector.getSelection()
    };
};

BalanceHierarchicalSelectorsSectionStrategy.prototype.validate = function () {
    var errors = [];

    if (!this.validateIsUserSelected()) errors.push(_constants.Errors.ERROR_EMPTY_BALANCE_USER_SELECTION);

    return errors;
};

BalanceHierarchicalSelectorsSectionStrategy.prototype.validateIsUserSelected = function () {
    return this.params.balanceUserSelector.validateIsUserSelected();
};

BalanceHierarchicalSelectorsSectionStrategy.prototype.setUserSelection = function (selection) {
    this.params.balanceUserSelector.setSelection(selection);
};

exports.default = BalanceHierarchicalSelectorsSectionStrategy;

/***/ }),
/* 1443 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _ChartHierarchicalSelectorsSectionStrategy = __webpack_require__(300);

var _ChartHierarchicalSelectorsSectionStrategy2 = _interopRequireDefault(_ChartHierarchicalSelectorsSectionStrategy);

var _constants = __webpack_require__(197);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function OvertimeHoursHierarchicalSelectorsSectionStrategy(_ref) {
    var showUserSelector = _ref.showUserSelector,
        overtimeUserSelector = _ref.overtimeUserSelector;

    this.params = {
        showUserSelector: showUserSelector,
        overtimeUserSelector: overtimeUserSelector
    };
}

OvertimeHoursHierarchicalSelectorsSectionStrategy.prototype = new _ChartHierarchicalSelectorsSectionStrategy2.default();

OvertimeHoursHierarchicalSelectorsSectionStrategy.prototype.updateSectionUI = function () {
    _ChartHierarchicalSelectorsSectionStrategy2.default.prototype.updateSectionUI.call(this);
    if (this.params.showUserSelector) {
        (0, _jquery2.default)(this.container).addClass(this.getVisibleOvertimeUsersSelectorClassName() + " " + this.getVisibleUserSelectorInfoIconClassName());
    } else {
        (0, _jquery2.default)(this.container).addClass(this.getVisibleUsernameClassName());
    }
};

OvertimeHoursHierarchicalSelectorsSectionStrategy.prototype.withUserSelector = function () {
    return this.params.showUserSelector;
};

OvertimeHoursHierarchicalSelectorsSectionStrategy.prototype.getUserSelection = function () {
    return this.params.overtimeUserSelector.getSelection();
};

OvertimeHoursHierarchicalSelectorsSectionStrategy.prototype.getSelectedParams = function () {
    return {
        userSelection: this.params.overtimeUserSelector.getSelection()
    };
};

OvertimeHoursHierarchicalSelectorsSectionStrategy.prototype.validate = function () {
    var errors = [];

    if (!this.validateIsUserSelected()) errors.push(_constants.Errors.ERROR_EMPTY_OVERTIME_USER_SELECTION);

    return errors;
};

OvertimeHoursHierarchicalSelectorsSectionStrategy.prototype.validateIsUserSelected = function () {
    return this.params.overtimeUserSelector.validateIsUserSelected();
};

OvertimeHoursHierarchicalSelectorsSectionStrategy.prototype.setUserSelection = function (selection) {
    this.params.overtimeUserSelector.setSelection(selection);
};

exports.default = OvertimeHoursHierarchicalSelectorsSectionStrategy;

/***/ }),
/* 1444 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ChartGroupingLevelSelectorFillingStrategy = __webpack_require__(301);

var _ChartGroupingLevelSelectorFillingStrategy2 = _interopRequireDefault(_ChartGroupingLevelSelectorFillingStrategy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function UsersGroupsGroupingLevelSelectorFillingStrategy() {}

UsersGroupsGroupingLevelSelectorFillingStrategy.prototype = new _ChartGroupingLevelSelectorFillingStrategy2.default();

UsersGroupsGroupingLevelSelectorFillingStrategy.prototype.fillGroupingLevelListSelector = function (listSelector) {
    this.addUsersItem(listSelector);
    this.addUserGroupsItemIfNeeded(listSelector);
    this.addTimeZoneGroupsItemIfNeeded(listSelector);
};

exports.default = UsersGroupsGroupingLevelSelectorFillingStrategy;

/***/ }),
/* 1445 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ChartGroupingLevelSelectorFillingStrategy = __webpack_require__(301);

var _ChartGroupingLevelSelectorFillingStrategy2 = _interopRequireDefault(_ChartGroupingLevelSelectorFillingStrategy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function UsersGroupsMonthsWeeksDaysGroupingLevelSelectorFillingStrategy() {}

UsersGroupsMonthsWeeksDaysGroupingLevelSelectorFillingStrategy.prototype = new _ChartGroupingLevelSelectorFillingStrategy2.default();

UsersGroupsMonthsWeeksDaysGroupingLevelSelectorFillingStrategy.prototype.fillGroupingLevelListSelector = function (listSelector) {
    this.addUsersItem(listSelector);
    this.addUserGroupsItemIfNeeded(listSelector);
    this.addTimeZoneGroupsItemIfNeeded(listSelector);

    listSelector.addSeparator();

    this.addDaysItem(listSelector);
    this.addWeeksItem(listSelector);
    this.addMonthsItem(listSelector);
};

exports.default = UsersGroupsMonthsWeeksDaysGroupingLevelSelectorFillingStrategy;

/***/ }),
/* 1446 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ChartGroupingLevelSelectorFillingStrategy = __webpack_require__(301);

var _ChartGroupingLevelSelectorFillingStrategy2 = _interopRequireDefault(_ChartGroupingLevelSelectorFillingStrategy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function UsersGroupsLeaveTypesMonthsWeeksDaysGroupingLevelSelectorFillingStrategy() {}

UsersGroupsLeaveTypesMonthsWeeksDaysGroupingLevelSelectorFillingStrategy.prototype = new _ChartGroupingLevelSelectorFillingStrategy2.default();

UsersGroupsLeaveTypesMonthsWeeksDaysGroupingLevelSelectorFillingStrategy.prototype.fillGroupingLevelListSelector = function (listSelector) {
    this.addUsersItem(listSelector);
    this.addUserGroupsItemIfNeeded(listSelector);
    this.addTimeZoneGroupsItemIfNeeded(listSelector);

    listSelector.addSeparator();

    this.addLeaveTypesItem(listSelector);
    listSelector.addSeparator();
    this.addDaysItem(listSelector);
    this.addWeeksItem(listSelector);
    this.addMonthsItem(listSelector);
};

exports.default = UsersGroupsLeaveTypesMonthsWeeksDaysGroupingLevelSelectorFillingStrategy;

/***/ }),
/* 1447 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ChartGroupingLevelSelectorFillingStrategy = __webpack_require__(301);

var _ChartGroupingLevelSelectorFillingStrategy2 = _interopRequireDefault(_ChartGroupingLevelSelectorFillingStrategy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function AllItemsGroupingLevelSelectorFillingStrategy() {}

AllItemsGroupingLevelSelectorFillingStrategy.prototype = new _ChartGroupingLevelSelectorFillingStrategy2.default();

AllItemsGroupingLevelSelectorFillingStrategy.prototype.fillGroupingLevelListSelector = function (listSelector) {
    this.addUsersItem(listSelector);
    this.addUserGroupsItemIfNeeded(listSelector);
    this.addTimeZoneGroupsItemIfNeeded(listSelector);

    listSelector.addSeparator();

    this.addCustomersItem(listSelector);
    this.addProjectsItem(listSelector);
    this.addTypesOfWorkItemIfNeeded(listSelector);
    listSelector.addSeparator();
    this.addDaysItem(listSelector);
    this.addWeeksItem(listSelector);
    this.addMonthsItem(listSelector);
};

exports.default = AllItemsGroupingLevelSelectorFillingStrategy;

/***/ }),
/* 1448 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ChartGroupingLevelSelectorFillingStrategy = __webpack_require__(301);

var _ChartGroupingLevelSelectorFillingStrategy2 = _interopRequireDefault(_ChartGroupingLevelSelectorFillingStrategy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function UsersGroupsCPMonthsWeeksDaysGroupingLevelSelectorFillingStrategy() {}

UsersGroupsCPMonthsWeeksDaysGroupingLevelSelectorFillingStrategy.prototype = new _ChartGroupingLevelSelectorFillingStrategy2.default();

UsersGroupsCPMonthsWeeksDaysGroupingLevelSelectorFillingStrategy.prototype.fillGroupingLevelListSelector = function (listSelector) {
    this.addUsersItem(listSelector);
    this.addUserGroupsItemIfNeeded(listSelector);
    this.addTimeZoneGroupsItemIfNeeded(listSelector);

    listSelector.addSeparator();

    this.addCustomersItem(listSelector);
    this.addProjectsItem(listSelector);
    this.addTypesOfWorkItemIfNeeded(listSelector);
    listSelector.addSeparator();
    this.addDaysItem(listSelector);
    this.addWeeksItem(listSelector);
    this.addMonthsItem(listSelector);
};

exports.default = UsersGroupsCPMonthsWeeksDaysGroupingLevelSelectorFillingStrategy;

/***/ }),
/* 1449 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _SimpleTooltip = __webpack_require__(36);

var _SimpleTooltip2 = _interopRequireDefault(_SimpleTooltip);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var IconWithTooltip = function (_TemplateView) {
    _inherits(IconWithTooltip, _TemplateView);

    function IconWithTooltip(text) {
        var extraClass = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";

        _classCallCheck(this, IconWithTooltip);

        var _this = _possibleConstructorReturn(this, (IconWithTooltip.__proto__ || Object.getPrototypeOf(IconWithTooltip)).call(this));

        _this.text = text;
        _this.extraClass = extraClass;
        return _this;
    }

    _createClass(IconWithTooltip, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return "<div class='iconWithTooltip'></div>";
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            this.tooltip = new _SimpleTooltip2.default({
                text: this.text,
                extraClass: 'aboveMenuZindex createChartUserSelectorTooltip ' + this.extraClass
            }).init((0, _jquery2.default)('body'));
            this.tooltip.subscribeToMouseEvents(this.$el);
        }
    }]);

    return IconWithTooltip;
}(_TemplateView3.default);

exports.default = IconWithTooltip;

/***/ }),
/* 1450 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Ext = __webpack_require__(12);

var _Ext2 = _interopRequireDefault(_Ext);

var _at_reports_selector_users_panel = __webpack_require__(302);

var _at_reports_selector_users_panel2 = _interopRequireDefault(_at_reports_selector_users_panel);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _OvertimeEmptyMessageBuilder = __webpack_require__(1451);

var _OvertimeEmptyMessageBuilder2 = _interopRequireDefault(_OvertimeEmptyMessageBuilder);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_Ext2.default.namespace("AT");

var OvertimeReportSelectorPanel = _Ext2.default.extend(_at_reports_selector_users_panel2.default, {

    allItemsOptionLabelKey: "users_selector.reports.overtime.all_users",
    allItemsOptionMessageParams: [window.SystemSettings.overtimeNaming],

    createEmptyMessageBuilder: function createEmptyMessageBuilder() {
        return new _OvertimeEmptyMessageBuilder2.default(this.userSelectorGroupsStrategy);
    },

    getDetailsSection: function getDetailsSection() {
        var res = OvertimeReportSelectorPanel.superclass.getDetailsSection.call(this);
        res.push({ xtype: "box",
            autoEl: {
                tag: "span",
                html: _messageResource2.default.getMessage("users_selector.reports.overtime.list_note"),
                cls: "label notemsg overtimeInfoTooltip"
            } });
        return res;
    }

});

_Ext2.default.reg("at_overtime_report_selector_panel", _at_reports_selector_users_panel2.default);

exports.default = OvertimeReportSelectorPanel;

/***/ }),
/* 1451 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = OvertimeEmptyMessageBuilder;

var _UserSelectorEmptyMessageBuilder = __webpack_require__(358);

var _UserSelectorEmptyMessageBuilder2 = _interopRequireDefault(_UserSelectorEmptyMessageBuilder);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function OvertimeEmptyMessageBuilder(userSelectorGroupsStrategy) {
    _UserSelectorEmptyMessageBuilder2.default.call(this, userSelectorGroupsStrategy);
}

OvertimeEmptyMessageBuilder.prototype = _.create(_UserSelectorEmptyMessageBuilder2.default.prototype, {
    createMessages: function createMessages() {
        _UserSelectorEmptyMessageBuilder2.default.prototype.createMessages.call(this);

        var message = _messageResource2.default.getMessage("users_selector.reports.no_overtime_enabled", [window.SystemSettings.overtimeNaming]);
        this.messages["noActiveNodes"] = message;
        this.messages["emptyTree"] = message;
    }
});

/***/ }),
/* 1452 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = GenericAdditionalCheckboxExtension;

var _Ext = __webpack_require__(12);

var _Ext2 = _interopRequireDefault(_Ext);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function GenericAdditionalCheckboxExtension(extendedClass, label) {

    return {
        genericCls: "generic withCheckbox",
        _createAdditionalCheckBox: function _createAdditionalCheckBox() {
            var self = this;
            this.additionalCheckBox = new _Ext2.default.form.Checkbox({
                boxLabel: label,
                checked: this.additionalCheckBoxValue,
                handler: function handler() {
                    self.fireEvent("change");
                }
            });
            return this.additionalCheckBox;
        },

        getPreFooterSection: function getPreFooterSection() {
            return [this._createAdditionalCheckBox()];
        },

        getAdditionalCheckboxValue: function getAdditionalCheckboxValue() {
            if (this.additionalCheckBox) {
                return this.additionalCheckBox.getValue();
            } else {
                return this.additionalCheckBoxValue;
            }
        },

        _setInitialAdditionalCheckBoxValue: function _setInitialAdditionalCheckBoxValue(checked) {
            this.additionalCheckBoxInitValue = checked;
        },

        _setAdditionalCheckboxValue: function _setAdditionalCheckboxValue(checked) {
            if (this.additionalCheckBox) {
                if (!this.additionalCheckBox.disabled) this.additionalCheckBox.setValue(checked);
                this.additionalCheckBox.prevValue = checked;
            }
        },

        loadState: function loadState(state) {
            this.additionalCheckBoxValue = state.additionalCheckBoxValue;
            this._setInitialAdditionalCheckBoxValue(state.additionalCheckBoxValue);
            this._setAdditionalCheckboxValue(state.additionalCheckBoxValue);
            extendedClass.prototype.loadState.apply(this, arguments);
        },

        resetState: function resetState(isEnableActiveActions) {
            this.additionalCheckBoxValue = this.additionalCheckBoxInitValue;
            this._setAdditionalCheckboxValue(this.additionalCheckBoxInitValue);
            extendedClass.prototype.resetState.apply(this, arguments);
        },

        setInitialValueFromCurrent: function setInitialValueFromCurrent() {
            if (this.isAlreadyShown()) {
                this._setInitialAdditionalCheckBoxValue(this.getAdditionalCheckboxValue());
                this.setFilterFlag(this.getShowInactive());
                this.selectorTree.initializeByNodeSet(this.makeNodeSet(this.getSelection()));
                this.setInitialOptionValue(!this.isCustomOptionSelected());
                this.updateInitialTreeSet();
            }
        },

        getLabelTextTemplate: function getLabelTextTemplate() {
            var result = extendedClass.superclass.getLabelTextTemplate.apply(this, arguments);
            if (this.getAdditionalCheckboxValue() === true) result += " (" + label + ")";
            return result;
        },

        collectCurrentSettings: function collectCurrentSettings() {
            var settings = extendedClass.prototype.collectCurrentSettings.apply(this, arguments);
            settings.additionalCheckBoxValue = this.getAdditionalCheckboxValue();
            return settings;
        },

        getStateFromSettings: function getStateFromSettings(settings) {
            var state = extendedClass.prototype.getStateFromSettings.apply(this, arguments);
            state.additionalCheckBoxValue = this.getAdditionalCheckboxValue();
            return state;
        }
    };
};

/***/ }),
/* 1453 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _ChartHierarchicalSelectorsSectionStrategy = __webpack_require__(300);

var _ChartHierarchicalSelectorsSectionStrategy2 = _interopRequireDefault(_ChartHierarchicalSelectorsSectionStrategy);

var _constants = __webpack_require__(197);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function BillingHierarchicalSelectorsSectionStrategy(_ref) {
    var showUserSelector = _ref.showUserSelector,
        showIncludeOtherUsersCheckbox = _ref.showIncludeOtherUsersCheckbox,
        billingUserSelector = _ref.billingUserSelector;

    this.params = {
        showUserSelector: showUserSelector,
        showIncludeOtherUsersCheckbox: showIncludeOtherUsersCheckbox,
        billingUserSelector: billingUserSelector
    };
}

BillingHierarchicalSelectorsSectionStrategy.prototype = new _ChartHierarchicalSelectorsSectionStrategy2.default();

BillingHierarchicalSelectorsSectionStrategy.prototype.updateSectionUI = function () {
    _ChartHierarchicalSelectorsSectionStrategy2.default.prototype.updateSectionUI.call(this);
    var classes = this.getVisibleCPSelectorClassName() + " " + this.getVisibleUserSelectorInfoIconClassName();
    classes += this.params.showUserSelector ? " " + this.getVisibleBillingUsersSelectorClassName() : " " + this.getVisibleUsernameClassName();
    classes += this.params.showIncludeOtherUsersCheckbox ? " " + this.getVisibleIncludeOtherUsersCheckboxClassName() : "";

    (0, _jquery2.default)(this.container).addClass(classes);
};

BillingHierarchicalSelectorsSectionStrategy.prototype.withUserSelector = function () {
    return this.params.showUserSelector;
};

BillingHierarchicalSelectorsSectionStrategy.prototype.getUserSelection = function () {
    return this.params.billingUserSelector.getSelection();
};

BillingHierarchicalSelectorsSectionStrategy.prototype.getSelectedParams = function () {
    return {
        userSelection: this.params.billingUserSelector.getSelection(),
        customersProjectsSelection: this.cpSelector.getCpSelection(),
        includeOtherUsersColumn: this.includeOtherUsersCheckbox.isChecked()
    };
};

BillingHierarchicalSelectorsSectionStrategy.prototype.validate = function () {
    var errors = [];

    if (!this.cpSelector.checkSelected()) errors.push(_constants.Errors.ERROR_EMPTY_CP_SELECTION);
    if (!this.validateIsUserSelected()) errors.push(_constants.Errors.ERROR_EMPTY_BILLABLE_USER_SELECTION);

    return errors;
};

BillingHierarchicalSelectorsSectionStrategy.prototype.validateIsUserSelected = function () {
    return this.params.billingUserSelector.validateIsUserSelected();
};

BillingHierarchicalSelectorsSectionStrategy.prototype.isShowIncludeOtherUsersCheckbox = function () {
    return this.params.showIncludeOtherUsersCheckbox;
};

BillingHierarchicalSelectorsSectionStrategy.prototype.setUserSelection = function (selection) {
    this.params.billingUserSelector.setSelection(selection);
};

exports.default = BillingHierarchicalSelectorsSectionStrategy;

/***/ }),
/* 1454 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _ChartHierarchicalSelectorsSectionStrategy = __webpack_require__(300);

var _ChartHierarchicalSelectorsSectionStrategy2 = _interopRequireDefault(_ChartHierarchicalSelectorsSectionStrategy);

var _constants = __webpack_require__(197);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function TaskHierarchicalSelectorsSectionStrategy(_ref) {
    var showUserSelector = _ref.showUserSelector,
        showIncludeOtherUsersCheckbox = _ref.showIncludeOtherUsersCheckbox,
        taskUserSelector = _ref.taskUserSelector;

    this.params = {
        showUserSelector: showUserSelector,
        showIncludeOtherUsersCheckbox: showIncludeOtherUsersCheckbox,
        taskUserSelector: taskUserSelector
    };
}

TaskHierarchicalSelectorsSectionStrategy.prototype = new _ChartHierarchicalSelectorsSectionStrategy2.default();

TaskHierarchicalSelectorsSectionStrategy.prototype.updateSectionUI = function () {
    _ChartHierarchicalSelectorsSectionStrategy2.default.prototype.updateSectionUI.call(this);
    var classes = this.getVisibleCPSelectorClassName() + " " + this.getVisibleUserSelectorInfoIconClassName();
    classes += this.params.showUserSelector ? " " + this.getVisibleTaskUsersSelectorClassName() : " " + this.getVisibleUsernameClassName();
    classes += this.params.showIncludeOtherUsersCheckbox ? " " + this.getVisibleIncludeOtherUsersCheckboxClassName() : "";

    (0, _jquery2.default)(this.container).addClass(classes);
};

TaskHierarchicalSelectorsSectionStrategy.prototype.withUserSelector = function () {
    return this.params.showUserSelector;
};

TaskHierarchicalSelectorsSectionStrategy.prototype.getUserSelection = function () {
    return this.params.taskUserSelector.getSelection();
};

TaskHierarchicalSelectorsSectionStrategy.prototype.getSelectedParams = function () {
    return {
        userSelection: this.params.taskUserSelector.getSelection(),
        customersProjectsSelection: this.cpSelector.getCpSelection(),
        includeOtherUsersColumn: this.includeOtherUsersCheckbox.isChecked()
    };
};

TaskHierarchicalSelectorsSectionStrategy.prototype.validate = function () {
    var errors = [];

    if (!this.cpSelector.checkSelected()) errors.push(_constants.Errors.ERROR_EMPTY_CP_SELECTION);
    if (!this.validateIsUserSelected()) errors.push(_constants.Errors.ERROR_EMPTY_TASK_USER_SELECTION);

    return errors;
};

TaskHierarchicalSelectorsSectionStrategy.prototype.validateIsUserSelected = function () {
    return this.params.taskUserSelector.validateIsUserSelected();
};

TaskHierarchicalSelectorsSectionStrategy.prototype.isShowIncludeOtherUsersCheckbox = function () {
    return this.params.showIncludeOtherUsersCheckbox;
};

TaskHierarchicalSelectorsSectionStrategy.prototype.setUserSelection = function (selection) {
    this.params.taskUserSelector.setSelection(selection);
};

exports.default = TaskHierarchicalSelectorsSectionStrategy;

/***/ }),
/* 1455 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Created by filatov on 30.10.2015.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */


var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _constants = __webpack_require__(11);

var _ChartColorSelectorPanel = __webpack_require__(1456);

var _ChartColorSelectorPanel2 = _interopRequireDefault(_ChartColorSelectorPanel);

var _ChartColorSelector = __webpack_require__(1457);

var _ChartColorSelector2 = _interopRequireDefault(_ChartColorSelector);

var _ChartPercentsCheckbox = __webpack_require__(1458);

var _ChartPercentsCheckbox2 = _interopRequireDefault(_ChartPercentsCheckbox);

var _ChartTypeSelector = __webpack_require__(1459);

var _ChartTypeSelector2 = _interopRequireDefault(_ChartTypeSelector);

var _ChartShowStackColumnsCheckbox = __webpack_require__(1460);

var _ChartShowStackColumnsCheckbox2 = _interopRequireDefault(_ChartShowStackColumnsCheckbox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ChartDisplayParametersSectionController = function () {
    function ChartDisplayParametersSectionController() {
        _classCallCheck(this, ChartDisplayParametersSectionController);
    }

    _createClass(ChartDisplayParametersSectionController, [{
        key: 'init',
        value: function init(chartDisplayParameters, groupingLevel, minChartPointValue, maxChartPointValue, changeCallback, showStackColumnsCheckMark) {
            this.createChartModeElement = (0, _jquery2.default)(".createChartModeElement ");

            this.changeCallback = changeCallback;
            this.showStackColumnsCheckMark = showStackColumnsCheckMark;

            this.sortCategoryClasses = { date: "date", name: "name" };

            this.setParameters(chartDisplayParameters, groupingLevel);
            this.changeCheckboxStateIfNeededAndGetShowPercentsValue(minChartPointValue, maxChartPointValue);
            this.changeCheckboxStateIfNeededAndGetShowShowStackedColumnsValue();

            return this;
        }
    }, {
        key: 'setParameters',
        value: function setParameters(chartDisplayParameters, groupingLevel) {
            var self = this;

            this.sortOption = {};
            this.sortOption.by = chartDisplayParameters.sortOption;
            this.sortOption.isAsc = chartDisplayParameters.sortOrderIsAsc;

            this.chartColorSelectorPanel = new _ChartColorSelectorPanel2.default().init(function () {
                self.chartColorSelector.updateOpenState(false);
            });
            this.chartColorSelector = new _ChartColorSelector2.default().init("chartColorSelector", this.chartColorSelectorPanel, chartDisplayParameters.chartColor, function () {
                self.changeCallback();
            });

            this.chartPercentsCheckbox = new _ChartPercentsCheckbox2.default().init("chartShowPercents", function () {
                self.changeCallback();
            }, chartDisplayParameters.showPercents);

            this.chartStackColumnsCheckbox = new _ChartShowStackColumnsCheckbox2.default().init("chartShowStackedColumns", function () {
                self.changeCallback();
            }, chartDisplayParameters.stackColumns);

            this.chartSortContainer = (0, _jquery2.default)("#chartSortContainer");
            this.chartSortContainer.removeClass();
            this.chartSortContainer.addClass("sortContainer");

            this.changeSortClassAccordingGroupingLevel(groupingLevel);
            this.changeSort(this.sortOption.by);
            this.initSortButtons();

            this.chartTypeSelector = new _ChartTypeSelector2.default().init("chartTypeSelector", chartDisplayParameters.chartType, self.changeCallback);
        }
    }, {
        key: 'getSortOption',
        value: function getSortOption() {
            return this.sortOption;
        }
    }, {
        key: 'getChartType',
        value: function getChartType() {
            return this.chartTypeSelector.getChartType();
        }
    }, {
        key: 'initSortButtons',
        value: function initSortButtons() {
            var self = this;
            this.chartSortContainer.find(".sortLink").off("click").on("click", function (event) {
                self.changeSort(event.target.id, true);
                if (self.changeCallback) self.changeCallback();
            });
        }
    }, {
        key: 'changeSort',
        value: function changeSort(sortValue, changeSortOrder) {
            this.chartSortContainer.removeClass(this.getClassSortOption(this.sortOption.by));
            this.chartSortContainer.removeClass(this.sortOption.isAsc ? "asc" : "desc");

            if (changeSortOrder) this.sortOption.isAsc = !this.sortOption.isAsc;
            this.sortOption.isAsc = this.sortOption.by !== sortValue && (sortValue === _constants.ChartSortOptions.BY_VALUES || this.sortOption.by === _constants.ChartSortOptions.BY_VALUES) ? true : this.sortOption.isAsc;
            this.sortOption.by = sortValue;

            this.chartSortContainer.addClass(this.getClassSortOption(this.sortOption.by));
            this.chartSortContainer.addClass(this.sortOption.isAsc ? "asc" : "desc");
        }
    }, {
        key: 'getClassSortOption',
        value: function getClassSortOption(sortOptionBy) {
            var res = "sort";
            var cls = "";
            switch (sortOptionBy) {
                case _constants.ChartSortOptions.ALPHABETICALLY:
                    cls = "Alphabetically";
                    break;
                case _constants.ChartSortOptions.BY_VALUES:
                    cls = "Values";
                    break;
                case _constants.ChartSortOptions.CHRONOLOGICALLY:
                    cls = "Chronologically";
                    break;
            }
            return res.concat(cls);
        }
    }, {
        key: 'changeSortClassAccordingGroupingLevel',
        value: function changeSortClassAccordingGroupingLevel(groupingLevel) {
            this.groupingLevel = groupingLevel;
            this.createChartModeElement.removeClass(this.sortCategoryClasses.date);
            this.createChartModeElement.removeClass(this.sortCategoryClasses.name);
            switch (groupingLevel) {
                case _constants.ReportGroupingLevel.DATE:
                case _constants.ReportGroupingLevel.WEEK:
                case _constants.ReportGroupingLevel.MONTH:
                    {
                        this.createChartModeElement.addClass(this.sortCategoryClasses.date);
                        if (this.sortOption.by !== _constants.ChartSortOptions.BY_VALUES) {
                            this.changeSort(_constants.ChartSortOptions.CHRONOLOGICALLY);
                        }
                        break;
                    }
                case _constants.ReportGroupingLevel.USER:
                case _constants.ReportGroupingLevel.USER_GROUP:
                case _constants.ReportGroupingLevel.TIME_ZONE_GROUP:
                case _constants.ReportGroupingLevel.LEAVE_TYPE:
                case _constants.ReportGroupingLevel.CUSTOMER:
                case _constants.ReportGroupingLevel.PROJECT:
                case _constants.ReportGroupingLevel.BILLING_TYPE:
                    {
                        this.createChartModeElement.addClass(this.sortCategoryClasses.name);
                        if (this.sortOption.by !== _constants.ChartSortOptions.BY_VALUES) {
                            this.changeSort(_constants.ChartSortOptions.ALPHABETICALLY);
                        }
                        break;
                    }
            }
        }
    }, {
        key: 'getChartColorId',
        value: function getChartColorId() {
            return this.chartColorSelector.getColorId();
        }
    }, {
        key: 'isPercentsCheckboxVisibleAndChecked',
        value: function isPercentsCheckboxVisibleAndChecked() {
            return this.chartPercentsCheckbox.isVisibleAndChecked();
        }
    }, {
        key: 'isStackColumnsCheckboxVisibleAndChecked',
        value: function isStackColumnsCheckboxVisibleAndChecked() {
            return this.chartStackColumnsCheckbox.isVisibleAndChecked();
        }
    }, {
        key: 'getDisplayParameters',
        value: function getDisplayParameters() {
            return {
                showPercents: this.isPercentsCheckboxVisibleAndChecked(),
                sortOption: this.getSortOption().by,
                sortOrderIsAsc: this.getSortOption().isAsc,
                chartType: this.getChartType(),
                chartColor: this.chartColorSelector.getColorId(),
                stackColumns: this.isStackColumnsCheckboxVisibleAndChecked()
            };
        }
    }, {
        key: 'changeCheckboxStateIfNeededAndGetShowPercentsValue',
        value: function changeCheckboxStateIfNeededAndGetShowPercentsValue(minChartPointValue, maxChartPointValue) {
            if (this.getChartType() === _constants.ChartType.PIE_CHART || minChartPointValue < 0 && maxChartPointValue > 0) {
                this.chartPercentsCheckbox.hidePercentsCheckbox();
                return false;
            } else {
                this.chartPercentsCheckbox.showPercentsCheckbox();
                return this.chartPercentsCheckbox.getValue();
            }
        }
    }, {
        key: 'changeCheckboxStateIfNeededAndGetShowShowStackedColumnsValue',
        value: function changeCheckboxStateIfNeededAndGetShowShowStackedColumnsValue() {
            if (!this.showStackColumnsCheckMark || this.getChartType() === _constants.ChartType.PIE_CHART || this.groupingLevel === _constants.ReportGroupingLevel.USER) {
                this.chartStackColumnsCheckbox.hideStackColumnsCheckbox();
                return false;
            } else {
                this.chartStackColumnsCheckbox.showStackColumnsCheckbox();
                return this.chartStackColumnsCheckbox.getValue();
            }
        }
    }], [{
        key: 'getDefaultDisplayParameters',
        value: function getDefaultDisplayParameters() {
            return {
                showPercents: false,
                sortOption: _constants.ChartSortOptions.ALPHABETICALLY,
                sortOrderIsAsc: true,
                chartType: _constants.ChartType.VERTICAL_BAR,
                chartColor: 'DEFAULT',
                stackColumns: false
            };
        }
    }]);

    return ChartDisplayParametersSectionController;
}();

exports.default = ChartDisplayParametersSectionController;

/***/ }),
/* 1456 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ChartColorSelectorPanel;

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _DropdownDialog = __webpack_require__(185);

var _DropdownDialog2 = _interopRequireDefault(_DropdownDialog);

var _key_down_handler = __webpack_require__(184);

var _key_down_handler2 = _interopRequireDefault(_key_down_handler);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ChartColorSelectorPanel() {} /**
                                       * Created by filatov on 27.10.2015.
                                       */


ChartColorSelectorPanel.prototype.init = function (closeCallback) {
    var self = this;
    this.chartColorSelectorPanel = (0, _jquery2.default)("#chartColorSelectorPanel");
    this.panel = new _DropdownDialog2.default({
        wrapperClass: "chartColorSelectorPanelWrapper",
        dialogDiv: this.chartColorSelectorPanel,
        hideButtons: true,
        hideOnResize: true,
        showEmptyTitleBar: false,
        width: '90px',
        onClose: function onClose(event) {
            /* here we restore old key-down-handler
             * and stop propagation of the event in order to avoid restored handler immediate invoking,
             * because current key-down event is related only to panel and should be handled only by panel
             * */
            if (closeCallback) closeCallback();
            event.stopPropagation();
            _key_down_handler2.default.restoreOnKeyDownHandler();
        }
    });

    (0, _jquery2.default)(this.chartColorSelectorPanel).find(".imageContainer").on("click", function () {
        self.clickColor(this);self.panel.hide();
    });
    return this;
};

ChartColorSelectorPanel.prototype.clickColor = function (element) {
    (0, _jquery2.default)(this.selectedColor).find("div").removeClass("selected");
    this.selectedColor = element;
    (0, _jquery2.default)(this.selectedColor).find("div").addClass("selected");
    this.selectedColorId = (0, _jquery2.default)(this.selectedColor).attr('id');
    if (this.changeCallback) this.changeCallback();
};
ChartColorSelectorPanel.prototype.getColorId = function () {
    return this.selectedColorId;
};

ChartColorSelectorPanel.prototype.initAndShow = function (currentColorId, elementToShowAt, changeCallback) {

    this.chartColorSelectorPanel.find(".selected").removeClass("selected");
    this.selectedColor = (0, _jquery2.default)(this.chartColorSelectorPanel).find("#" + currentColorId);
    this.selectedColor.find("div").addClass("selected");
    this.changeCallback = changeCallback;

    this.panel.showAt(elementToShowAt, { my: "left top",
        at: "left bottom",
        collision: "flip" });
    var chartPanel = (0, _jquery2.default)(".chartColorSelectorPanelWrapper");
    chartPanel.width("100px");
    var chartColorSelectorZIndex = (0, _jquery2.default)("#createChartLightbox").zIndex();
    (0, _jquery2.default)(".ui-widget-overlay").zIndex(chartColorSelectorZIndex + 1);
    chartPanel.zIndex(chartColorSelectorZIndex + 2);
    /* we set empty key-down-handler, because:
     * - after the panel is shown, all key-down-events are related only to it and it handles them itself;
     * - we need to save old handler and restore it after the panel is hidden.
     * */
    _key_down_handler2.default.setOnKeyDownHandler(function () {});
};

/***/ }),
/* 1457 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ChartColorSelector;

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _ReportChartUtils = __webpack_require__(303);

var _ReportChartUtils2 = _interopRequireDefault(_ReportChartUtils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Created by filatov on 28.10.2015.
 */
function ChartColorSelector() {}

ChartColorSelector.prototype.init = function (selectorDivId, selectorColorPanel, chartColorId, changesCallback) {
    this.iconSelectorPanel = selectorColorPanel;
    if (changesCallback) this.changesCallback = changesCallback;

    var self = this;
    this.selectorDiv = document.getElementById(selectorDivId);
    (0, _jquery2.default)(this.selectorDiv).empty();
    this.selectorDiv.className = "chartColorSelector";

    var requestColorDiv = document.createElement("div");
    requestColorDiv.className = "requestColorDiv";
    this.requestColorDiv = (0, _jquery2.default)(requestColorDiv);
    this.selectorDiv.appendChild(requestColorDiv);

    var arrowDiv = document.createElement("div");
    arrowDiv.className = "arrowDiv";
    this.selectorDiv.appendChild(arrowDiv);

    this.setColor(chartColorId);
    this.selectorDiv.onclick = function () {
        self.updateOpenState(true);self.iconSelectorPanel.initAndShow(self.selectedColorId, self.selectorDiv, function () {
            self.handlePanelClicking(self.iconSelectorPanel.getColorId());
        });
    };
    return this;
};

ChartColorSelector.prototype.getColorId = function () {
    return this.selectedColorId;
};

ChartColorSelector.prototype.setColor = function (backgroundColorId) {
    this.selectedColorId = backgroundColorId;
    (0, _jquery2.default)(this.requestColorDiv).css("background-color", _ReportChartUtils2.default.getChartColorSchemeById(this.selectedColorId).singleColumn);
};

ChartColorSelector.prototype.handlePanelClicking = function (backgroundColor) {
    this.setColor(backgroundColor);
    if (this.changesCallback) this.changesCallback();
};

ChartColorSelector.prototype.updateOpenState = function (isOpen) {
    (0, _jquery2.default)(this.selectorDiv).toggleClass("open", isOpen);
};

/***/ }),
/* 1458 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ChartPercentsCheckbox;

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ChartPercentsCheckbox() {};

ChartPercentsCheckbox.prototype.init = function (containerId, changeShowPercents, showPercents) {
    this.container = (0, _jquery2.default)("#" + containerId);
    this.container.empty();
    this.checkbox = (0, _jquery2.default)("<input type='checkbox' id='chartShowPercentsCheckbox'>");

    this.setPercentsCheckboxValue(showPercents);

    this.checkbox.click(function (e) {
        changeShowPercents(e.target.checked);
    });

    this.container.append(this.checkbox, (0, _jquery2.default)("<label for='chartShowPercentsCheckbox'>" + _messageResource2.default.getMessage("report.create_chart.show_percent_values") + "</label>"));

    return this;
};

ChartPercentsCheckbox.prototype.setPercentsCheckboxValue = function (value) {
    if (value) this.checkbox.attr("checked", "checked");else this.checkbox.removeAttr("checked");
};

ChartPercentsCheckbox.prototype.hidePercentsCheckbox = function () {
    this.container.addClass("hidden");
};

ChartPercentsCheckbox.prototype.showPercentsCheckbox = function () {
    this.container.removeClass("hidden");
};

ChartPercentsCheckbox.prototype.getValue = function () {
    return !!this.checkbox.attr("checked");
};

ChartPercentsCheckbox.prototype.isVisibleAndChecked = function () {
    return !this.container.hasClass("hidden") && !!this.checkbox.attr("checked");
};

/***/ }),
/* 1459 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ChartTypeSelector;

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ChartTypeSelector() {} /**
                                 * Created by filatov on 30.10.2015.
                                 */


ChartTypeSelector.prototype.init = function (containerId, chartType, changeCallback) {
    var self = this;
    this.selectedChartType = chartType;
    this.containerId = "#" + containerId;
    (0, _jquery2.default)(this.containerId).find("span").removeClass("checked");

    (0, _jquery2.default)(this.containerId).find("#" + chartType).addClass("checked");

    (0, _jquery2.default)(this.containerId).find("span").off("click").click(function (e) {
        if ((0, _jquery2.default)(e.target).hasClass("checked")) return false;
        (0, _jquery2.default)(self.containerId).find("span").removeClass("checked");
        (0, _jquery2.default)(e.target).addClass("checked");
        self.selectedChartType = (0, _jquery2.default)(e.target).attr("id");
        if (changeCallback) changeCallback();
    });

    return this;
};

ChartTypeSelector.prototype.getChartType = function () {
    return this.selectedChartType;
};

/***/ }),
/* 1460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ChartShowStackColumnsCheckbox;

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ChartShowStackColumnsCheckbox() {};

ChartShowStackColumnsCheckbox.prototype.init = function (containerId, changeShowStackColumns, showStackColumns) {
    this.container = (0, _jquery2.default)("#" + containerId);
    this.container.empty();
    this.checkbox = (0, _jquery2.default)("<input type='checkbox' id='chartShowStackColumnsCheckbox'>");

    this.setStackColumnsCheckboxValue(showStackColumns);

    this.checkbox.click(function (e) {
        changeShowStackColumns(e.target.checked);
    });

    this.container.append(this.checkbox, (0, _jquery2.default)("<label for='chartShowStackColumnsCheckbox'>" + _messageResource2.default.getMessage("report.create_chart.show_stacked_columns") + "</label>"));

    return this;
};

ChartShowStackColumnsCheckbox.prototype.setStackColumnsCheckboxValue = function (value) {
    if (value) this.checkbox.attr("checked", "checked");else this.checkbox.removeAttr("checked");
};

ChartShowStackColumnsCheckbox.prototype.hideStackColumnsCheckbox = function () {
    this.container.addClass("hidden");
};

ChartShowStackColumnsCheckbox.prototype.showStackColumnsCheckbox = function () {
    this.container.removeClass("hidden");
};

ChartShowStackColumnsCheckbox.prototype.getValue = function () {
    return !!this.checkbox.attr("checked");
};

ChartShowStackColumnsCheckbox.prototype.isVisibleAndChecked = function () {
    return !this.container.hasClass("hidden") && !!this.checkbox.attr("checked");
};

/***/ }),
/* 1461 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ChartController;

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _constants = __webpack_require__(11);

var _number_formatter = __webpack_require__(61);

var _number_formatter2 = _interopRequireDefault(_number_formatter);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _ReportChartUtils = __webpack_require__(303);

var _ReportChartUtils2 = _interopRequireDefault(_ReportChartUtils);

var _ChartFormatterCreator = __webpack_require__(1462);

var _ChartFormatterCreator2 = _interopRequireDefault(_ChartFormatterCreator);

var _constants2 = __webpack_require__(4);

var _atUtils = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AmCharts = window.AmCharts;

function ChartController() {}

ChartController.prototype.init = function (config) {
    this.containerId = config.containerId;
    this.partsContainer = (0, _jquery2.default)("#" + config.partsContainerId);
    this.chartFormatter = new _ChartFormatterCreator2.default();
    this.currentData = config.data;
    this.currentState = config.settings;
    this._extendCurrentStateWithFormattedFunctions(config.settings.groupingLevel, config.settings.reportChartType);

    if (this.currentState.sortOption === _constants.ChartSortOptions.BY_VALUES) this.sortDataByValues(this.currentState.sortOrder, this.currentState.sortCategoryComparator);else this.sortDataByCategory(this.currentState.sortOrder, this.currentState.sortCategoryComparator);

    this.numberFormatter = new _number_formatter2.default(window.SystemSettings.decimalSeparator, window.SystemSettings.digitGroupingSymbol, 2, false);

    if (!this.currentData.chartPoints || !this.currentData.chartPoints.length) return this;

    this.chart = this.showChart(this.currentData, this.currentState);

    return this;
};

ChartController.prototype.getBarChartConfiguration = function (chartPoints, title, settings) {
    var dataProvider = this._getDataProvider(chartPoints, this.currentState.groupingLevel, this.currentState.stackColumns);

    var conf = {
        "type": "serial",
        "rotate": settings.horizontal,
        "categoryField": "category",
        "startDuration": settings.withoutAnimation ? 0 : 0.3,
        "startEffect": "easeOutSine",
        "sequencedAnimation": false,
        "theme": AmCharts.themes["light"],
        "fontSize": settings.fontSize ? settings.fontSize : 11,
        "chartCursor": {
            "categoryBalloonFunction": settings.horizontal ? this.currentState.formatHBarChartCursorLabelFunction : this.currentState.formatVBarChartCursorLabelFunction,
            "categoryBalloonEnabled": !this.currentState.stackColumns
        },
        "categoryAxis": {
            "color": "#414141",
            "labelRotation": 48,
            "labelFrequency": 1,
            "minHorizontalGap": 65,
            "minVerticalGap": 50,
            "labelOffset": settings.horizontal ? 11 : 0,
            "categoryFunction": this.currentState.formatCategoryFunction
        },
        "chartScrollbar": settings.withoutScroll ? false : {
            "scrollbarHeight": 16,
            "dragIconHeight": 30,
            "dragIconWidth": 30,
            "backgroundColor": "#f9f9f9",
            "backgroundAlpha": 1,
            "selectedBackgroundAlpha": 1,
            "selectedBackgroundColor": "#e8e8e8"
        },
        "graphs": this._buildGraphs(settings),
        "valueAxes": [{
            "stackType": this.currentState.stackColumns ? "regular" : "none",
            "gridCount": 5,
            "labelFrequency": 1,
            "autoGridCount": false,
            "includeAllValues": true,
            "minHorizontalGap": 70,
            "labelFunction": this.currentState.formatValueFunction,
            "fontSize": 11,
            "title": title
        }],
        "titles": [{
            "text": ""
        }],
        "dataProvider": dataProvider,
        "export": {
            "enabled": true,
            "menu": [],
            "libs": {
                "autoLoad": false
            }
        }
    };

    if (settings.minimum) conf.valueAxes[0].minimum = settings.minimum;else if (this.currentData.min > 0) conf.valueAxes[0].minimum = 0;else conf.valueAxes[0].minimum = this.currentData.min * 1.1;

    if (settings.maximum) conf.valueAxes[0].maximum = settings.maximum;else if (this.currentData.max < 0) conf.valueAxes[0].maximum = 0;else conf.valueAxes[0].maximum = this.currentData.max * 1.1;

    return conf;
};

ChartController.prototype.showChart = function (data, currentState) {
    if (this.chart) this.chart.clear(); // clear previous chart for performance issues

    switch (currentState.chartType) {
        case _constants.ChartType.HORIZONTAL_BAR:
            return this.buildBarChart(this.containerId, this.getBarChartConfiguration(data.chartPoints, data.title, { horizontal: true }));
        case _constants.ChartType.VERTICAL_BAR:
            return this.buildBarChart(this.containerId, this.getBarChartConfiguration(data.chartPoints, data.title, {}));
        case _constants.ChartType.PIE_CHART:
            {
                if (data.max === 0 && data.min === 0) this.currentState.emptyPieCallback();
                return this.buildPieChart(this.containerId, this.buildPieChartDataProvider(data.min, data.max), 11, 290, true);
            }
    }
};

ChartController.prototype.buildPieChartDataProvider = function (minValue, maxValue) {
    var _this = this;

    var plainDataProvider = [];

    var abs = !isNaN(maxValue) && !isNaN(minValue); //for chart we need positive values but for data-tables we need values "as-is"
    var filter = abs && minValue < 0 && maxValue > 0;
    var colorScheme = _ReportChartUtils2.default.getChartColorSchemeById(this.currentState.colorId);
    _jquery2.default.each(this.currentData.chartPoints, function (i, item) {
        var value = item.value.total;
        if (!filter || value > 0) plainDataProvider.push({
            sectorColor: _this._isOtherUsersData(_this.currentState.groupingLevel, item) ? colorScheme.notAssigned : undefined,
            category: item.category,
            value: abs ? Math.abs(value) : value,
            formattedValue: _this.currentState.formatValueFunction(value)
        });
    });
    return plainDataProvider;
};

ChartController.prototype.buildPieChart = function (container, dataProvider, fontSize, maxLabelWidth, animate, onRenderedHandler) {
    var chart = new AmCharts.AmPieChart();
    if (onRenderedHandler) chart.addListener("rendered", function (e) {
        onRenderedHandler(e);
    });
    chart.addListener("drawn", function (e) {
        if (document.createElementNS && e.chart.realHeight > 0 && e.chart.realWidth > 0) {
            var rectangle = document.createElementNS('http://www.w3.org/2000/svg', "rect");
            rectangle.setAttribute("width", e.chart.realWidth);
            rectangle.setAttribute("height", e.chart.realHeight * 0.08);
            rectangle.setAttribute("fill", "white");
            (0, _jquery2.default)(e.chart.chartDiv).find(".amcharts-title").before(rectangle);
        }
    });

    var numberFormatter = this.numberFormatter;
    var toStringFunction = this.currentState.toStringFunction;
    var formatLabelFunction = this.currentState.formatLabelFunction;
    var self = this;
    AmCharts.extend(chart, {
        "type": "pie",
        "startDuration": animate ? 0.6 : 0,
        "startEffect": "easeOutSine",
        "startRadius": 120,
        "sequencedAnimation": false,
        "balloonFunction": function balloonFunction(item) {
            return "<div class='pieChartBalloon'>" + (0, _atUtils.escapeHtmlSymbols)(self.currentState.toStringFunction(item.dataContext.category)) + "<br><span style='font-size:14px'><b>" + item.dataContext.formattedValue + " </b>(" + numberFormatter.format(item.percents) + "%)</span>" + "</div>";
        },
        "dataProvider": dataProvider,
        "titleField": "category",
        "valueField": "value",
        "outlineThickness": 1,
        "outlineAlpha": 1,
        "fontSize": fontSize,
        "labelRadius": 20,
        "maxLabelWidth": maxLabelWidth,
        "hideLabelsPercent": 1.5,
        "labelFunction": function labelFunction(data) {
            var title = toStringFunction(data.title);
            return formatLabelFunction(title);
        },
        "radius": "30%",
        "innerRadius": "38%",
        "titles": [{
            "text": this.currentData.title
        }],
        "export": {
            "enabled": true,
            "menu": [],
            "libs": {
                "autoLoad": false
            }
        },
        "colorField": "sectorColor",
        "colors": ["#5e9fd9", "#3fbe67", "#9fdf4d", "#ffd600", "#f6ad19", "#f77a36", "#df3c72", "#a44fce", "#5470c0", "#189195", "#649f2f", "#426ec7", "#2c8a49", "#98911e", "#d28e03", "#d65c1c", "#c74419", "#b72c59", "#723d98", "#475699", "#0a7399"]
    });

    AmCharts.isReady ? chart.write(container) : AmCharts.ready(function () {
        chart.write(container);
    });

    return chart;
};

ChartController.prototype.buildBarChart = function (container, settings, onRenderedHandler) {

    var theme = AmCharts.themes["light"];
    var chart = new AmCharts.AmSerialChart(theme);
    var self = this;
    if (onRenderedHandler) {
        chart.addListener("rendered", function (e) {
            onRenderedHandler(e);
        });
    } else {
        chart.addListener("zoomed", function (e) {
            self.currentBarCount = e.endIndex - e.startIndex + 1;
        });
    }

    AmCharts.extend(chart, settings);

    AmCharts.isReady ? chart.write(container) : AmCharts.ready(function () {
        chart.write(container);
    });
    return chart;
};

ChartController.prototype.sortByValues = function (asc, secondaryComparator) {
    this.currentState.sortOrder = asc;
    this.sortDataByValues(asc, secondaryComparator);
    this.chart = this.showChart(this.currentData, this.currentState);
};

ChartController.prototype.sortDataByValues = function (asc, secondaryComparator) {
    this.currentData.chartPoints.sort(function (x, y) {
        var xValue = x.value.total;
        var yValue = y.value.total;

        if (xValue === yValue) return secondaryComparator(x.category, y.category);

        return xValue < yValue ? asc ? -1 : 1 : asc ? 1 : -1;
    });
};

ChartController.prototype.sortByCategory = function (asc, comparator) {
    this.currentState.sortCategoryComparator = comparator;
    this.currentState.sortOrder = asc;
    this.sortDataByCategory(asc, comparator);
    this.chart = this.showChart(this.currentData, this.currentState);
};

ChartController.prototype.sortDataByCategory = function (asc, comparator) {
    this.currentData.chartPoints.sort(function (x, y) {
        return asc ? comparator(x.category, y.category) : -comparator(x.category, y.category);
    });
};

ChartController.prototype.changeChartType = function (type) {
    this.currentState.chartType = type;
    this.currentState.stackColumns = type !== _constants.ChartType.PIE_CHART;
    return this.showChart(this.currentData, this.currentState);
};

ChartController.prototype.changeShowPercents = function (isShown) {
    this.currentState.showPercents = isShown;
    this.chart = this.showChart(this.currentData, this.currentState);
};

ChartController.prototype.changeStackColumns = function (stackColumns) {
    this.currentState.stackColumns = stackColumns;
    this.chart = this.showChart(this.currentData, this.currentState);
};

ChartController.prototype.getCurrentDataProvider = function () {
    return this.chart.dataProvider;
};

ChartController.prototype.updateDisplayData = function (config) {
    this.currentState.colorId = config.colorId;
    this.currentState.chartType = config.chartType;
    this.currentState.sortOption = config.sortOption;
    this.currentState.sortOrder = config.sortOrder;
    this.currentState.showPercents = config.isShowPercents;
    this.currentState.stackColumns = config.stackColumns;
    if (this.currentState.sortOption === _constants.ChartSortOptions.BY_VALUES) this.sortDataByValues(this.currentState.sortOrder, this.currentState.sortCategoryComparator);else this.sortDataByCategory(this.currentState.sortOrder, this.currentState.sortCategoryComparator);

    this.chart = this.showChart(this.currentData, this.currentState);
};

ChartController.prototype.updateData = function (data, state) {
    this.currentData = data;
    this.currentState.sortCategoryComparator = state.sortCategoryComparator;
    this.currentState.sortOption = state.sortOption;
    this.currentState.sortOrder = state.sortOrder;
    this.currentState.showPercents = state.isShowPercents;
    this.currentState.stackColumns = state.stackColumns;
    this.currentState.groupingLevel = state.groupingLevel;
    this._extendCurrentStateWithFormattedFunctions(state.groupingLevel, state.reportChartType);

    if (this.currentState.sortOption === _constants.ChartSortOptions.BY_VALUES) this.sortDataByValues(this.currentState.sortOrder, this.currentState.sortCategoryComparator);else this.sortDataByCategory(this.currentState.sortOrder, this.currentState.sortCategoryComparator);

    this.chart = this.showChart(this.currentData, this.currentState);
};

ChartController.prototype.exportChart = function (size, callback, barCount) {
    this.partsContainer.width(size.width);
    this.partsContainer.height(size.height);

    var breaker = { 'break': false };
    this.currentExportBreaker = breaker;

    switch (this.currentState.chartType) {
        case _constants.ChartType.HORIZONTAL_BAR:
            this._exportBarChart(barCount, true, breaker, callback);
            return;
        case _constants.ChartType.VERTICAL_BAR:
            this._exportBarChart(barCount, false, breaker, callback);
            return;
        case _constants.ChartType.PIE_CHART:
            this._exportPieChart(callback);
            return;
    }
};

ChartController.prototype._exportPieChart = function (callback) {
    var result = [{
        data: this.buildPieChartDataProvider()
    }];

    var getIndexOf = function getIndexOf(array, item) {
        var r = _jquery2.default.map(array, function (obj, index) {
            if (Math.abs(obj.value) === Math.abs(item.value) && obj.category === item.category) {
                return index;
            }
        });
        return r.length ? r[0] : -1;
    };

    this.buildPieChart("chartPart", this.buildPieChartDataProvider(this.currentData.min, this.currentData.max), 14, 325, false, function (e) {
        _jquery2.default.each(e.chart.chartData, function (i, item) {
            var index = getIndexOf(result[0].data, item.dataContext);
            if (index >= 0) result[0].data[index].color = item.color;
        });
        var interval = setInterval(function () {
            if (window.fabric) {
                clearTimeout(interval);
                // CAPTURE CHART
                e.chart['export'].capture({}, function () {
                    // SAVE TO JPG
                    this.toJPG({}, function (base64) {
                        result[0].image = base64;
                        if (callback) callback(result);
                    });
                });
            }
        }, 50);
    });
};

ChartController.prototype._exportBarChart = function (barCount, horizontal, breaker, callback) {
    var _this2 = this;

    var self = this;
    var result = [];

    var minimumValue = this.chart.valueAxes[0].min;
    var maximumValue = this.chart.valueAxes[0].max;

    var dataParts = [];
    for (var i = 0; i < Math.ceil(this.currentData.chartPoints.length / barCount); i++) {
        dataParts.push(this.currentData.chartPoints.slice(i * barCount, i * barCount + barCount));
    }
    if (dataParts[dataParts.length - 1].length < barCount) {
        var emptyItem = {
            category: {}, // ant need return string value
            value: ""
        };
        for (var _i = dataParts[dataParts.length - 1].length; _i < barCount; _i++) {
            dataParts[dataParts.length - 1].push(emptyItem);
        }
    }

    var chart = void 0;

    var setPart = function setPart(i) {
        if (i === dataParts.length) {
            callback(result);
            return;
        }

        result[i] = {};
        result[i].data = dataParts[i];

        if (i === 0) {

            chart = _this2.buildBarChart("chartPart", _this2.getBarChartConfiguration(dataParts[i], _this2.currentData.title, {
                horizontal: _this2.currentState.chartType === _constants.ChartType.HORIZONTAL_BAR,
                withoutAnimation: true,
                withoutScroll: true,
                minimum: minimumValue,
                maximum: maximumValue,
                fontSize: 14
            }), function (e) {
                var interval = setInterval(function () {
                    if (window.fabric) {
                        clearTimeout(interval);
                        // CAPTURE CHART
                        e.chart['export'].capture({}, function () {
                            // SAVE TO JPG
                            this.toJPG({}, function (base64) {
                                if (!breaker['break']) {
                                    result[i].image = base64;
                                    setPart(++i);
                                }
                            });
                        });
                    }
                }, 50);
            });
        } else {
            chart.dataProvider = _this2._getDataProvider(dataParts[i], _this2.currentState.groupingLevel, _this2.currentState.stackColumns);
            chart.validateData();
            chart.validateNow();
        }
    };

    setPart(0);
};
ChartController.prototype.getCurrentBarCount = function () {
    return this.currentBarCount ? this.currentBarCount : 0;
};

ChartController.prototype.breakExport = function () {
    if (this.currentExportBreaker) this.currentExportBreaker['break'] = true;
};

ChartController.prototype._extendCurrentStateWithFormattedFunctions = function (groupingLevel, reportChartType) {
    this.currentState.formatCategoryFunction = this.chartFormatter.getFormatCategoryFunctionForChart(groupingLevel, false, 17, false);
    this.currentState.formatHBarChartCursorLabelFunction = this.chartFormatter.getFormatCategoryFunctionForChart(groupingLevel, true, 18, true);
    this.currentState.formatVBarChartCursorLabelFunction = this.chartFormatter.getFormatCategoryFunctionForChart(groupingLevel, true, 30, true);
    this.currentState.formatValueFunction = this.chartFormatter.getValueFormattedFunction(reportChartType);
    this.currentState.formatLabelFunction = this.chartFormatter.getFormatPieLabelFunction(groupingLevel);
    this.currentState.toStringFunction = this.chartFormatter.getCategoryToStringFunction(groupingLevel);
};

ChartController.prototype._buildGraphs = function (settings) {
    var _this3 = this;

    var total = this.currentData.total;
    var chartColorSchemeById = _ReportChartUtils2.default.getChartColorSchemeById(this.currentState.colorId);
    var userColor = chartColorSchemeById.user;
    var userTeamColor = chartColorSchemeById.userTeam;
    var notAssignedColor = chartColorSchemeById.notAssigned;

    if (this.currentState.stackColumns) {
        return [{
            "fillAlphas": 1,
            "fillColors": userColor,
            "labelPosition": "middle",
            "labelRotation": settings.horizontal ? 0 : 270,
            "balloonFunction": function balloonFunction() {},
            "lineThickness": 0,
            "type": "column",
            "valueField": "me",
            "balloon": {
                "maxWidth": 320
            }
        }, {
            "fillAlphas": 1,
            "fillColors": userTeamColor,
            "labelPosition": "middle",
            "labelRotation": settings.horizontal ? 0 : 270,
            "balloonFunction": function balloonFunction() {},
            "lineThickness": 0,
            "type": "column",
            "valueField": "myTeam",
            "balloon": {
                "maxWidth": 320
            }
        }, {
            "fillAlphas": 1,
            "fillColors": notAssignedColor,
            "labelPosition": "middle",
            "labelRotation": settings.horizontal ? 0 : 270,
            "balloonFunction": function balloonFunction(item) {
                var dataContext = item.dataContext;
                var showPercents = _this3.currentState.showPercents;

                var getTextFor = function getTextFor(value, total) {
                    return _this3.currentState.formatValueFunction(value) + (showPercents ? " (" + _this3.numberFormatter.format(value * 100 / total) + "%)" : "");
                };

                if (_this3.currentState.stackColumns) {
                    var text = '<div class = "chartBalloon"><b>' + _this3.currentState.toStringFunction(dataContext.category) + '</b>';
                    var reportTitle = _this3.currentData.title;
                    var balloonTotalTitle = reportTitle.substr(0, reportTitle.lastIndexOf(' ('));
                    text += '<br><b>' + balloonTotalTitle + ': ' + getTextFor(dataContext.total, total) + '</b>';
                    if (dataContext.notAssignedUsers) {
                        text += '<br>' + _this3._getColorMarkerForBalloon(notAssignedColor) + ' ' + _messageResource2.default.getMessage('report.create_chart.stacked_columns_popup.not_assigned_users') + ': ' + getTextFor(dataContext.notAssignedUsers, total);
                    }
                    if (dataContext.myTeam) {
                        text += '<br>' + _this3._getColorMarkerForBalloon(userTeamColor) + ' ' + _messageResource2.default.getMessage('report.create_chart.stacked_columns_popup.user_team') + ': ' + getTextFor(dataContext.myTeam, total);
                    }
                    if (dataContext.me) {
                        text += '<br>' + _this3._getColorMarkerForBalloon(userColor) + ' ' + _messageResource2.default.getMessage("report.create_chart.stacked_columns_popup.user") + ': ' + getTextFor(dataContext.me, total);
                    }
                    text += '</div>';
                    return text;
                } else {
                    return getTextFor(dataContext.value);
                }
            },
            "lineThickness": 0,
            "type": "column",
            "valueField": "notAssignedUsers",
            "balloon": {
                "maxWidth": 320
            }
        }];
    } else {
        return [{
            "fillAlphas": 1,
            "fillColorsField": "color",
            "labelPosition": "middle",
            "labelRotation": settings.horizontal ? 0 : 270,
            "labelText": "[[value]]",
            "labelFunction": function labelFunction(item) {
                return _this3.currentState.formatValueFunction(item.dataContext.value) + (_this3.currentState.showPercents && item.dataContext.value.toString().length ? " " + "(" + _this3.numberFormatter.format(total === 0 ? 0.00 : item.dataContext.value * 100 / total) + "%)" : "");
            },
            "balloonFunction": function balloonFunction(item) {
                return _this3.currentState.formatValueFunction(item.dataContext.value);
            },
            "lineThickness": 0,
            "type": "column",
            "valueField": "value"
        }];
    }
};

ChartController.prototype._getColorMarkerForBalloon = function (color) {
    return '<span style="background-color:' + color + ';">&nbsp&nbsp</span>';
};

ChartController.prototype._buildStackedDataProvider = function (chartPoints) {
    return chartPoints.map(function (point) {
        var value = point.value;
        return {
            category: point.category,
            me: value.userPoint,
            myTeam: value.userTeamPoint,
            notAssignedUsers: value.notAssignedUsersPoint,
            total: value.total
        };
    });
};

ChartController.prototype._buildSimpleColumnDataProvider = function (chartPoints, groupingLevel) {
    var _this4 = this;

    var colorScheme = _ReportChartUtils2.default.getChartColorSchemeById(this.currentState.colorId);
    return chartPoints.map(function (point) {
        var value = point.value;
        var othersColumn = _this4._isOtherUsersData(groupingLevel, point);
        return {
            category: point.category,
            value: value.total,
            color: othersColumn ? colorScheme.notAssigned : colorScheme.singleColumn
        };
    });
};

ChartController.prototype._isOtherUsersData = function (groupingLevel, chartPoint) {
    return _constants.ReportGroupingLevel.USER_GROUP === groupingLevel && chartPoint.category.id === _constants2.OTHER_USER_GROUPS_ENTITY_ID || _constants.ReportGroupingLevel.TIME_ZONE_GROUP === groupingLevel && chartPoint.category.id === _constants2.OTHER_USER_GROUPS_ENTITY_ID || _constants.ReportGroupingLevel.USER === groupingLevel && chartPoint.category.id === _constants2.OTHER_USERS_ENTITY_ID;
};

ChartController.prototype._getDataProvider = function (chartPoints, groupingLevel, stackColumns) {
    return stackColumns ? this._buildStackedDataProvider(chartPoints) : this._buildSimpleColumnDataProvider(chartPoints, groupingLevel);
};

/***/ }),
/* 1462 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ReportChartUtils = __webpack_require__(303);

var _ReportChartUtils2 = _interopRequireDefault(_ReportChartUtils);

var _BaseFormatterCreator2 = __webpack_require__(379);

var _BaseFormatterCreator3 = _interopRequireDefault(_BaseFormatterCreator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ChartFormatterCreator = function (_BaseFormatterCreator) {
    _inherits(ChartFormatterCreator, _BaseFormatterCreator);

    function ChartFormatterCreator() {
        _classCallCheck(this, ChartFormatterCreator);

        return _possibleConstructorReturn(this, (ChartFormatterCreator.__proto__ || Object.getPrototypeOf(ChartFormatterCreator)).apply(this, arguments));
    }

    _createClass(ChartFormatterCreator, [{
        key: 'getFormatPieLabelFunction',
        value: function getFormatPieLabelFunction(selectedValueType) {
            return function (label) {
                return label.substr(0, 65);
            };
        }
    }, {
        key: 'getFormatCategoryFunctionForChart',
        value: function getFormatCategoryFunctionForChart(selectedCategoryType, escape, partsLimit, recursively) {
            return _ReportChartUtils2.default.getFormatCategoryFunctionForChart(selectedCategoryType, this.DATE_FORMAT, escape, partsLimit, recursively);
        }
    }]);

    return ChartFormatterCreator;
}(_BaseFormatterCreator3.default);

exports.default = ChartFormatterCreator;

/***/ }),
/* 1463 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ChartDataController;
function ChartDataController() {}

ChartDataController.prototype.init = function (chartPoints, stackColumns) {
    this.chartPoints = chartPoints;
    this.stackColumns = stackColumns;
    this.calculateTotalMaxMin();
    return this;
};

ChartDataController.prototype.updateData = function (chartPoints, stackColumns) {
    this.chartPoints = chartPoints;
    this.stackColumns = stackColumns;
    this.calculateTotalMaxMin();
};

ChartDataController.prototype.getCountPoints = function () {
    return this.chartPoints.length;
};

ChartDataController.prototype.getTotal = function () {
    return this.total ? this.total : 0;
};
ChartDataController.prototype.getMaxValue = function () {
    return this.maxValue;
};
ChartDataController.prototype.getMinValue = function () {
    return this.minValue;
};

ChartDataController.prototype.calculateTotalMaxMin = function () {
    if (!this.chartPoints || !this.chartPoints.length) {
        return;
    }

    var min = this.chartPoints[0].value.total;
    var max = this.chartPoints[0].value.total;
    var total = 0;

    this.chartPoints.forEach(function (point) {
        var value = point.value.total;

        if (value > max) max = value;
        if (value < min) min = value;

        total += value;
    });

    this.total = total;
    this.minValue = min;
    this.maxValue = max;
};

/***/ }),
/* 1464 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _ChartPDFGenerator = __webpack_require__(1465);

var _ChartPDFGenerator2 = _interopRequireDefault(_ChartPDFGenerator);

var _PDFPreviewController = __webpack_require__(380);

var _PDFPreviewController2 = _interopRequireDefault(_PDFPreviewController);

var _ChartsPDFSettingsPreview = __webpack_require__(1479);

var _ChartsPDFSettingsPreview2 = _interopRequireDefault(_ChartsPDFSettingsPreview);

var _constants = __webpack_require__(11);

var _OvertimeParametersFormattingStrategy = __webpack_require__(1481);

var _OvertimeParametersFormattingStrategy2 = _interopRequireDefault(_OvertimeParametersFormattingStrategy);

var _utils = __webpack_require__(513);

var _ReportChartsStore = __webpack_require__(519);

var _ReportChartsStore2 = _interopRequireDefault(_ReportChartsStore);

var _WorkingHoursCostBillingParametersFormattingStrategy = __webpack_require__(1482);

var _WorkingHoursCostBillingParametersFormattingStrategy2 = _interopRequireDefault(_WorkingHoursCostBillingParametersFormattingStrategy);

var _BalanceParametersFormattingStrategy = __webpack_require__(1483);

var _BalanceParametersFormattingStrategy2 = _interopRequireDefault(_BalanceParametersFormattingStrategy);

var _LeaveParametersFormattingStrategy = __webpack_require__(1484);

var _LeaveParametersFormattingStrategy2 = _interopRequireDefault(_LeaveParametersFormattingStrategy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CreateChartLightboxPDFPreviewViewController() {}

CreateChartLightboxPDFPreviewViewController.prototype = _.create(_PDFPreviewController2.default.prototype, {

    init: function init(lightBoxEl, titleEl, elementsIdPrefix, printParameters, switchBackCallback, chartController, selectorsData, includeOtherUsersChecker, useStackColumnsChecker, reportAuthorizationInfo) {
        var _this = this;

        _ReportChartsStore2.default.setPrintParametersForSave(printParameters);

        _PDFPreviewController2.default.prototype.init.call(this, lightBoxEl, titleEl, elementsIdPrefix);

        this.backToChartParametersBtn = (0, _jquery2.default)(document.getElementById(elementsIdPrefix + "_backBtn"));
        this.backToChartParametersBtn.off();
        this.backToChartParametersBtn.click(switchBackCallback);

        this.pdfGenerator = new _ChartPDFGenerator2.default(function (pdfData) {
            _this.onGeneratePDFCompleted(pdfData);
        });
        this.chartController = chartController;
        this.selectorsData = selectorsData;
        this.includeOtherUsersChecker = includeOtherUsersChecker;
        this.useStackColumnsChecker = useStackColumnsChecker;
        this.reportAuthorizationInfo = reportAuthorizationInfo;

        return this;
    },

    _initPdfSettingsPreview: function _initPdfSettingsPreview(elementsIdPrefix) {
        if (!CreateChartLightboxPDFPreviewViewController.pdfSettingsPreview) {
            CreateChartLightboxPDFPreviewViewController.pdfSettingsPreview = new _ChartsPDFSettingsPreview2.default((0, _jquery2.default)(this.lightBoxEl).find(".pdfPreviewContainer"), elementsIdPrefix).init();
        }
        this.pdfSettingsPreview = CreateChartLightboxPDFPreviewViewController.pdfSettingsPreview;
    },

    _subscribeForEvents: function _subscribeForEvents() {
        var self = this;
        (0, _jquery2.default)(document).on("reportCharts.intermediatePrintParametersChange", function (event, printParameters) {
            _ReportChartsStore2.default.setPrintNumberOfPages(self._calculateTotalNumberOfPages(printParameters));
        });
        (0, _jquery2.default)(document).on("reportCharts.printParametersForSaveChange", function (event, printParametersForSave) {
            _ReportChartsStore2.default.setPrintParametersForSave(printParametersForSave);
            self.cancelAllExportingProcesses();
            self.updatePDF();
        });
        (0, _jquery2.default)(document).on("reportCharts.createChartLightbox.hide", function () {
            (0, _jquery2.default)(document).off("reportCharts.createChartLightbox.hide").off("reportCharts.intermediatePrintParametersChange").off("reportCharts.printParametersForSaveChange");
        });
    },

    cancelAllExportingProcesses: function cancelAllExportingProcesses() {
        this.chartController.breakExport();
        this.pdfGenerator.interruptGeneration();
        this.pdfViewer.interruptPreview();
    },

    switchLightboxToPDFPreviewView: function switchLightboxToPDFPreviewView(selectedParameters, chartType, chartDataController) {
        this.chartType = chartType;
        this.chartDataController = chartDataController;
        this.selectedParameters = selectedParameters;

        (0, _jquery2.default)(this.lightBoxEl).removeClass("createChartMode").addClass("pdfPreviewMode");

        this._setTitle(this.createFormattingStrategy(selectedParameters.chartTypeValue), selectedParameters);

        this.pdfSettingsPreview.onShow(this.chartType, this.chartDataController.getCountPoints(), this.chartController.getCurrentBarCount(), this.chartDataController.getMinValue(), this.chartDataController.getMaxValue());

        _ReportChartsStore2.default.setPrintNumberOfPages(this._calculateTotalNumberOfPages(this.pdfSettingsPreview.collectPrintParametersForGenerate()));

        this.updatePDF();
    },

    createFormattingStrategy: function createFormattingStrategy(chartTypeValue) {
        var availableUsers = void 0;
        switch (chartTypeValue) {
            case _constants.ReportChartType.TOTAL_WORKING_HOURS:
            case _constants.ReportChartType.APPROVED_WORKING_HOURS:
                availableUsers = (0, _utils.getUsersFilteredByAuthorizer)(this.selectorsData.users, this.reportAuthorizationInfo.taskChartsAuthorizationInfo);
                return new _WorkingHoursCostBillingParametersFormattingStrategy2.default().init({
                    selectorsData: _extends({}, this.selectorsData, { users: availableUsers }),
                    dateFormat: this.dateFormat,
                    reportAuthorizationInfo: this.reportAuthorizationInfo.taskChartsAuthorizationInfo
                });
            case _constants.ReportChartType.COST_OF_WORK:
            case _constants.ReportChartType.BILLABLE_AMOUNTS:
                availableUsers = (0, _utils.getUsersFilteredByAuthorizer)(this.selectorsData.users, this.reportAuthorizationInfo.billingChartsAuthorizationInfo);
                return new _WorkingHoursCostBillingParametersFormattingStrategy2.default().init({
                    selectorsData: _extends({}, this.selectorsData, { users: availableUsers }),
                    dateFormat: this.dateFormat,
                    reportAuthorizationInfo: this.reportAuthorizationInfo.billingChartsAuthorizationInfo
                });
            case _constants.ReportChartType.LEAVE_HOURS:
                availableUsers = (0, _utils.getUsersFilteredByAuthorizer)(this.selectorsData.users, this.reportAuthorizationInfo.balanceChartsAuthorizationInfo);
                return new _LeaveParametersFormattingStrategy2.default().init({
                    selectorsData: _extends({}, this.selectorsData, { users: availableUsers }),
                    dateFormat: this.dateFormat,
                    reportAuthorizationInfo: this.reportAuthorizationInfo.balanceChartsAuthorizationInfo
                });
            case _constants.ReportChartType.PTO_BALANCE:
            case _constants.ReportChartType.SICK_DAYS_BALANCE:
                availableUsers = (0, _utils.getUsersFilteredByAuthorizer)(this.selectorsData.users, this.reportAuthorizationInfo.balanceChartsAuthorizationInfo);
                return new _BalanceParametersFormattingStrategy2.default().init({
                    selectorsData: _extends({}, this.selectorsData, { users: availableUsers }),
                    dateFormat: this.dateFormat,
                    reportAuthorizationInfo: this.reportAuthorizationInfo.balanceChartsAuthorizationInfo
                });
            case _constants.ReportChartType.OVERTIME_HOURS:
                availableUsers = (0, _utils.getUsersFilteredByAuthorizer)(this.selectorsData.users, this.reportAuthorizationInfo.balanceChartsAuthorizationInfo);
                return new _OvertimeParametersFormattingStrategy2.default().init({
                    selectorsData: _extends({}, this.selectorsData, { users: availableUsers }),
                    dateFormat: this.dateFormat,
                    reportAuthorizationInfo: this.reportAuthorizationInfo.balanceChartsAuthorizationInfo
                });
        }
    },

    updatePDF: function updatePDF() {
        var _this2 = this;

        this.disableDownloadPDFButton();
        this.pdfSettingsPreview.beforePreviewUpdate();
        this.pdfViewer.showMoire();

        var printParams = this.pdfSettingsPreview.collectPrintParametersForGenerate();

        this.chartController.exportChart((0, _utils.getChartImageDimensionsInPixels)(this.chartType, this.chartDataController.getCountPoints(), printParams), function (pagesData) {
            _this2.pdfGenerator.generatePDF({
                pagesData: pagesData,
                totalValue: _this2.chartDataController.getTotal(),
                chartType: _this2.chartType,
                pdfPrintParameters: printParams,
                selectedParameters: _this2.selectedParameters,
                selectorsData: _this2.selectorsData,
                dateFormat: _this2.dateFormat,
                includeOtherUsers: _this2.includeOtherUsersChecker(),
                useStackColumns: _this2.useStackColumnsChecker(),
                reportAuthorizationInfo: _this2.reportAuthorizationInfo
            });
        }, printParams.barsOnPage);
    },

    onDownloadPDFBtnClicked: function onDownloadPDFBtnClicked() {
        if (!this.downloadPDFBtnEnabled) return;

        this.pdfSettingsPreview.sendSaveChartPrintParametersRequest();
        this.pdfGenerator.downloadPDF();
    },

    onGeneratePDFCompleted: function onGeneratePDFCompleted(pdfData) {
        this.pdfViewer.showPDF(pdfData);
        this.enableDownloadPDFButton();
    },

    _calculateTotalNumberOfPages: function _calculateTotalNumberOfPages(printParameters) {
        return (0, _utils.getTotalPagesCalculator)(this.chartType).getTotalNumberOfPages(this.chartDataController.getCountPoints(), printParameters);
    }
});

exports.default = CreateChartLightboxPDFPreviewViewController;

/***/ }),
/* 1465 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _PDFFormatterCreator = __webpack_require__(1466);

var _PDFFormatterCreator2 = _interopRequireDefault(_PDFFormatterCreator);

var _constants = __webpack_require__(11);

var _date_format = __webpack_require__(16);

var _PDFImageCache = __webpack_require__(122);

var _PDFImageCache2 = _interopRequireDefault(_PDFImageCache);

var _ChartPDFDefinitionBuilder = __webpack_require__(1467);

var _ChartPDFDefinitionBuilder2 = _interopRequireDefault(_ChartPDFDefinitionBuilder);

var _ChartPDFDefinitionPartsConstructors = __webpack_require__(198);

var _utils = __webpack_require__(164);

var _SimpleTableDefinitionBuilder = __webpack_require__(1468);

var _SimpleTableDefinitionBuilder2 = _interopRequireDefault(_SimpleTableDefinitionBuilder);

var _StackedTableDefinitionBuilder = __webpack_require__(1469);

var _StackedTableDefinitionBuilder2 = _interopRequireDefault(_StackedTableDefinitionBuilder);

var _utils2 = __webpack_require__(513);

var _atBrowserUtils = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ChartPDFGenerator = function () {
    function ChartPDFGenerator(onGenerateCb) {
        _classCallCheck(this, ChartPDFGenerator);

        this.onGeneratePdfCallback = onGenerateCb;

        this.lastGeneratedPDF = { // save last generated pdf for prevent new generate on download
            encodedPDF: null,
            fileName: 'file.pdf'
        };

        this.pdfFormatter = new _PDFFormatterCreator2.default();
        this.onGenerateBreaker = { needBreak: false };
    }

    /**
     * We cant interrupt pdf generated process, but we can interrupt on generate process
     */


    _createClass(ChartPDFGenerator, [{
        key: 'interruptGeneration',
        value: function interruptGeneration() {
            this.onGenerateBreaker.needBreak = true;
        }
    }, {
        key: 'downloadPDF',
        value: function downloadPDF() {
            (0, _utils.downloadPDF)(this.lastGeneratedPDF.encodedPDF, this.lastGeneratedPDF.fileName);
        }
    }, {
        key: 'generatePDF',
        value: function generatePDF(config) {
            var _this = this;

            _PDFImageCache2.default.preloadImages({
                "logo": {
                    "url": window.__GENERATED_CONSTANTS__.REPORT_LOGO_PATH
                },
                "filterIcon": {
                    "url": (0, _atBrowserUtils.atImgPath)('filter-for-pdf.png'),
                    "saveAlpha": true
                }
            }).then(function () {
                var loadedImage = _PDFImageCache2.default.getImage("logo");
                config.logo = {
                    imageBase64: loadedImage.image,
                    width: loadedImage.width,
                    height: loadedImage.height
                };
                _this._generatePDF(config);
            });
        }
    }, {
        key: 'createPDFBuilder',
        value: function createPDFBuilder(config, paramFormattingStrategy) {
            var selectedParameters = config.selectedParameters;
            var isPieChart = config.chartType === _constants.ChartType.PIE_CHART;

            var tableDefinitionBuilder = void 0;
            if (isPieChart || !config.useStackColumns) {
                tableDefinitionBuilder = new _SimpleTableDefinitionBuilder2.default(config.chartType, this.pdfFormatter.getValueFormattedFunction(selectedParameters.chartTypeValue), this.pdfFormatter.getCategoryToStringFunction(selectedParameters.groupingLevelValue, config.chartType), config.totalValue);
            } else {
                tableDefinitionBuilder = new _StackedTableDefinitionBuilder2.default(config.chartType, this.pdfFormatter.getValueFormattedFunction(selectedParameters.chartTypeValue), this.pdfFormatter.getCategoryToStringFunction(selectedParameters.groupingLevelValue, config.chartType), paramFormattingStrategy.getTableHeaders(selectedParameters), config.totalValue, config.includeOtherUsers);
            }

            return new _ChartPDFDefinitionBuilder2.default(config.logo, config.chartType, config.pdfPrintParameters.paperSize, config.pdfPrintParameters.paperOrientation, config.totalValue, {
                chartTypeName: paramFormattingStrategy.formatChartPDFHeaderTitle(selectedParameters),
                dateRangeDescription: paramFormattingStrategy.formatChartPDFHeaderDateInformation(selectedParameters),
                filterTexts: paramFormattingStrategy.formatChartPDFFilterInformation(selectedParameters),
                grandTotalDescription: paramFormattingStrategy.formatGrandTotalDescription(selectedParameters)
            }, this.pdfFormatter.getValueFormattedFunction(selectedParameters.chartTypeValue), tableDefinitionBuilder);
        }
    }, {
        key: '_generatePDF',
        value: function _generatePDF(config) {
            var _this2 = this;

            var newBreaker = {
                needBreak: false
            };
            this.onGenerateBreaker = newBreaker;

            var selectedParameters = config.selectedParameters;
            var paramFormattingStrategy = (0, _utils2.getParametersFormattingStrategy)({
                chartTypeValue: selectedParameters.chartTypeValue,
                selectorsData: config.selectorsData,
                dateFormat: config.dateFormat,
                reportAuthorizationInfo: config.reportAuthorizationInfo
            });
            var ddBuilder = this.createPDFBuilder(config, paramFormattingStrategy);
            var createDDStrategy = (0, _utils2.getCreateDefinitionObjectStrategy)(config.chartType);

            var doc = (0, _utils.createPdf)(createDDStrategy.createDocDefinitionObject(ddBuilder, config.pagesData, config.pdfPrintParameters, config.includeOtherUsers));

            var currentFileName = paramFormattingStrategy.formatChartPDFFileName(selectedParameters);
            try {
                doc._createDoc(_ChartPDFDefinitionPartsConstructors.ChartPDFOptions, function (result) {
                    if (newBreaker.needBreak) {
                        return;
                    }

                    _this2.lastGeneratedPDF = { // save last generated pdf for prevent new generate on download
                        encodedPDF: result,
                        fileName: currentFileName
                    };

                    if (_this2.onGeneratePdfCallback) {
                        _this2.onGeneratePdfCallback(result);
                    }
                });
            } catch (e) {
                throw e;
            }
        }
    }]);

    return ChartPDFGenerator;
}();

exports.default = ChartPDFGenerator;

/***/ }),
/* 1466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _BaseFormatterCreator2 = __webpack_require__(379);

var _BaseFormatterCreator3 = _interopRequireDefault(_BaseFormatterCreator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PDFFormatterCreator = function (_BaseFormatterCreator) {
    _inherits(PDFFormatterCreator, _BaseFormatterCreator);

    function PDFFormatterCreator() {
        _classCallCheck(this, PDFFormatterCreator);

        return _possibleConstructorReturn(this, (PDFFormatterCreator.__proto__ || Object.getPrototypeOf(PDFFormatterCreator)).apply(this, arguments));
    }

    _createClass(PDFFormatterCreator, [{
        key: 'getCategoryToStringFunction',
        value: function getCategoryToStringFunction(selectedCategoryType, chartType) {
            var categoryToStringFn = _get(PDFFormatterCreator.prototype.__proto__ || Object.getPrototypeOf(PDFFormatterCreator.prototype), 'getCategoryToStringFunction', this).call(this, selectedCategoryType);
            return function (category, maxLens) {
                var formattedCategory = categoryToStringFn(category);
                if (formattedCategory.length > maxLens) {
                    formattedCategory = formattedCategory.substr(0, maxLens - 1) + '...'; // cut characters and add ellipsis
                }
                return formattedCategory;
            };
        }
    }]);

    return PDFFormatterCreator;
}(_BaseFormatterCreator3.default);

exports.default = PDFFormatterCreator;

/***/ }),
/* 1467 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _constants = __webpack_require__(100);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _ChartPDFDefinitionPartsConstructors = __webpack_require__(198);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ChartPDFDefinitionBuilder = function () {
    function ChartPDFDefinitionBuilder(logoPicture, chartType, paperSize, paperOrientation, grandTotalValue, headerTexts, valueFormatter, tableDefinitionBuilder) {
        _classCallCheck(this, ChartPDFDefinitionBuilder);

        this.chartType = chartType;

        this.paperSize = paperSize;
        this.paperOrientation = paperOrientation;

        this.allParams = {};
        _jquery2.default.extend(true, this.allParams, _ChartPDFDefinitionPartsConstructors.ChartPDFParameters); // need to prevent changes parameters by pdfmake
        this.orientationParams = this.allParams[paperOrientation];
        this.paperSizeParams = this.orientationParams[paperSize];
        this.chartTypeParams = this.paperSizeParams[chartType];

        this.chartTypeName = headerTexts.chartTypeName;
        this.filterTexts = headerTexts.filterTexts;
        this.dateRangeDescription = headerTexts.dateRangeDescription;
        this.grandTotalDescription = headerTexts.grandTotalDescription;

        this.valueFormatter = valueFormatter;

        this.grandTotalValue = grandTotalValue;

        this.logoPicture = logoPicture;

        this.templateCtrs = _ChartPDFDefinitionPartsConstructors.ChartPDFTemplateConstructors;

        this.tableDefinitionBuilder = tableDefinitionBuilder;

        return this;
    }

    _createClass(ChartPDFDefinitionBuilder, [{
        key: 'getTable',
        value: function getTable(dataRows, margins, tableStyle) {
            return this.tableDefinitionBuilder.getTable(dataRows, margins, tableStyle);
        }
    }, {
        key: 'getDataRows',
        value: function getDataRows(pageDataList, showDataList, showPercentsList, tableValueStyles, rowDataMaxLens) {
            return this.tableDefinitionBuilder.getDataRows(pageDataList, showDataList, showPercentsList, tableValueStyles, rowDataMaxLens);
        }

        /**
         * Crete new doc definition with current page parameters and with footer
         * @returns {{}}
         */

    }, {
        key: 'createNewDocDefinitionWithFooter',
        value: function createNewDocDefinitionWithFooter() {

            var docDefinition = {};

            docDefinition.pageSize = this.paperSizeParams.pageSize;
            docDefinition.pageOrientation = this.orientationParams.pageOrientation;
            docDefinition.pageMargins = this.orientationParams.pageMargins;

            docDefinition.content = [];
            docDefinition.footer = _ChartPDFDefinitionPartsConstructors.ChartPDFFooters.simpleFooter();
            docDefinition.styles = _ChartPDFDefinitionPartsConstructors.ChartPDFStyles;

            return docDefinition;
        }

        /**
         * Method add header to pdf page doc definition
         * @param docDefinition - current doc definition
         * @param showLogo - true if need add logo to page
         * @param includeOtherUsers - if need to add row in header. TODO looks like incorrect parameter
         */

    }, {
        key: 'addHeader',
        value: function addHeader(docDefinition, showLogo, includeOtherUsers) {
            var placeCtrs = _ChartPDFDefinitionPartsConstructors.ChartPDFPlaceholderConstructors;

            var filterTextMaxLen = this.paperSizeParams.filterViewTextLen;
            var filterViewElement = void 0;
            if (includeOtherUsers) {
                filterViewElement = this.templateCtrs.filterViewWithThreeRows(_extends({}, this.orientationParams.filterViewParameters, this.orientationParams.filterViewParametersWithThreeRows), this._cutLongLabels(this.filterTexts.firstRow, filterTextMaxLen), _messageResource2.default.getMessage('report.chart_pdf.table_header.data_of_not_assigned_users_shown'), this._cutLongLabels(this.filterTexts.secondRow, filterTextMaxLen));
            } else {
                filterViewElement = this.templateCtrs.filterView(_extends({}, this.orientationParams.filterViewParameters, this.orientationParams.filterViewParametersWithTwoRows), this._cutLongLabels(this.filterTexts.firstRow, filterTextMaxLen), this._cutLongLabels(this.filterTexts.secondRow, filterTextMaxLen));
            }
            var logoElement = showLogo ? this.templateCtrs.logoPicture(this.logoPicture.imageBase64, this._calculatePDFLogoDimensions(this.logoPicture)) : '';

            var chartInfoParameters = showLogo ? this.paperSizeParams.chartInfoParameters.withLogo : this.paperSizeParams.chartInfoParameters.withoutLogo;

            var chartInfoElement = this.makeChartInformationHeader(chartInfoParameters, logoElement);
            var headerElement = void 0;
            var appender = _underscore2.default.bind(this._appendContentElement, this, docDefinition);

            if (this.paperOrientation === _constants.PaperOrientation.PORTRAIT) {
                headerElement = placeCtrs.headerPortrait(chartInfoElement);
                appender(headerElement);
                appender(filterViewElement);
            } else {
                headerElement = placeCtrs.headerLandscape(chartInfoElement, filterViewElement);
                appender(headerElement);
            }
        }
    }, {
        key: 'makeChartInformationHeader',
        value: function makeChartInformationHeader(chartInfoParameters, logoElement) {
            return this.templateCtrs.chartInformation(chartInfoParameters, logoElement, this.chartTypeName, this.dateRangeDescription, this.grandTotalDescription, this.valueFormatter(this.grandTotalValue));
        }

        /**
         * method adds image and data on page depends page parameters
         * @param docDefinition - doc definition of pdf
         * @param imageBase64 - image
         * @param pageDataList - list of data for one page
         * @param showDataList - if need to show data
         * @param showPercentsList - if need show percent values
         * @param smallTable - if data list with small rows
         */

    }, {
        key: 'addImageAndData',
        value: function addImageAndData(docDefinition, imageBase64, pageDataList, showDataList, showPercentsList, smallTable) {
            var placeCtrs = _ChartPDFDefinitionPartsConstructors.ChartPDFPlaceholderConstructors;

            var imageParams = this.chartTypeParams.imageParams.singleImage;
            var tableMargins = this.chartTypeParams.dataTableMargins;
            var tableStyles = smallTable ? this.allParams.dataTableCommonStyles.small : this.allParams.dataTableCommonStyles.big;
            var rowDataMaxLens = smallTable ? this.chartTypeParams.rowDataMaxLen.fit : this.chartTypeParams.rowDataMaxLen.normal;

            var image = this.templateCtrs.imageWithSizes(imageParams.sizes, imageBase64);

            var rows = this.getDataRows(pageDataList, showDataList, showPercentsList, tableStyles.tableValueStyles, rowDataMaxLens);

            var table = this.getTable(rows, tableMargins, tableStyles.tableStyle);

            this._appendContentElement(docDefinition, placeCtrs.singleImage(image, imageParams.margins));
            this._appendContentElement(docDefinition, table);
        }

        /**
         * Method add double image on one page depends of parameters
         * @param docDefinition - current doc definition
         * @param firstImageBase64 - firstImage
         * @param secondImageBase64 - secondImage
         */

    }, {
        key: 'addDoubleImagesVertical',
        value: function addDoubleImagesVertical(docDefinition, firstImageBase64, secondImageBase64) {
            var _this = this;

            this._addDoubleImagesInternal(docDefinition, firstImageBase64, secondImageBase64, function (imageFirst, imageSecond, margins) {
                var placeCtrs = _ChartPDFDefinitionPartsConstructors.ChartPDFPlaceholderConstructors;
                _this._appendContentElement(docDefinition, placeCtrs.singleImage(imageFirst, margins));
                _this._appendContentElement(docDefinition, placeCtrs.singleImage(imageSecond, margins));
            });
        }

        /**
         * Method add double images with horizontal layout
         * @param docDefinition - current dd
         * @param firstImageBase64 - firstImage
         * @param secondImageBase64 - secondImage
         */

    }, {
        key: 'addDoubleImagesHorizontal',
        value: function addDoubleImagesHorizontal(docDefinition, firstImageBase64, secondImageBase64) {
            var _this2 = this;

            this._addDoubleImagesInternal(docDefinition, firstImageBase64, secondImageBase64, function (imageFirst, imageSecond, margins) {
                _this2._appendContentElement(docDefinition, _ChartPDFDefinitionPartsConstructors.ChartPDFPlaceholderConstructors.horizontalDoubleImages(imageFirst, imageSecond, margins));
            });
        }
    }, {
        key: '_addDoubleImagesInternal',
        value: function _addDoubleImagesInternal(docDefinition, firstImageBase64, secondImageBase64) {
            var appender = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function (imageFirst, imageSecond, margins) {};

            var imageParams = this.chartTypeParams.imageParams.doubleImage;

            var imageFirstElement = this.templateCtrs.imageWithSizes(imageParams.sizes, firstImageBase64);
            var imageSecondElement = void 0;
            if (secondImageBase64) {
                imageSecondElement = this.templateCtrs.imageWithSizes(imageParams.sizes, secondImageBase64);
            } else {
                imageSecondElement = this.templateCtrs.fakeImage();
            }

            appender(imageFirstElement, imageSecondElement, imageParams.margins);
        }

        /**
         * Add only table for page
         * @param docDefinition - current doc definition
         * @param pageDataList - list of data for current page
         * @param showDataList - if need to show data
         * @param showPercentsList - if need to show percents
         * @param smallTable - small version of table
         */

    }, {
        key: 'addOnlyTableToPage',
        value: function addOnlyTableToPage(docDefinition, pageDataList, showDataList, showPercentsList, smallTable) {
            var tableStyles = smallTable ? this.allParams.dataTableCommonStyles.small : this.allParams.dataTableCommonStyles.big;
            var rowDataMaxLens = smallTable ? this.chartTypeParams.rowDataMaxLen.fit : this.chartTypeParams.rowDataMaxLen.normal;
            var rows = this.getDataRows(pageDataList, showDataList, showPercentsList, tableStyles.tableValueStyles, rowDataMaxLens);

            var table = this.getTable(rows, this.chartTypeParams.dataTableMargins, tableStyles.tableStyle);
            this._appendContentElement(docDefinition, table);
        }

        /**
         * Add only image to page
         * @param docDefinition - current doc definition
         * @param imageBase64 - image in base64
         */

    }, {
        key: 'addOnlyImageToPage',
        value: function addOnlyImageToPage(docDefinition, imageBase64) {
            var imageParams = this.chartTypeParams.imageParams.singleImage;
            var image = this.templateCtrs.imageWithSizes(imageParams.sizes, imageBase64);
            this._appendContentElement(docDefinition, _ChartPDFDefinitionPartsConstructors.ChartPDFPlaceholderConstructors.singleImage(image, imageParams.margins));
        }

        /**
         * Add to doc definition page breaker
         * @param docDefinition - current doc definition
         */

    }, {
        key: 'addPageBreaker',
        value: function addPageBreaker(docDefinition) {
            this._appendContentElement(docDefinition, _ChartPDFDefinitionPartsConstructors.ChartPDFPlaceholderConstructors.pageBreaker());
        }

        /**
         * Append element to content list in doc definition
         * @param dd - doc def
         * @param element - element fo add
         * @private
         */

    }, {
        key: '_appendContentElement',
        value: function _appendContentElement(dd, element) {
            dd.content.push(element);
        }
    }, {
        key: '_cutLongLabels',
        value: function _cutLongLabels(label, maxLen) {
            if (label.length > maxLen) {
                return label.substr(0, maxLen - 3) + '...';
            }
            return label;
        }

        /**
         * method calculate logo image dimensions for fit it to placeholder sizes and save ration
         * @param logoPicture logo picture (logo + sizes in pixels)
         * @returns {{w: number, h: number, mL: number, mT: number}}
         * @private
         */

    }, {
        key: '_calculatePDFLogoDimensions',
        value: function _calculatePDFLogoDimensions(logoPicture) {

            var maxW = _ChartPDFDefinitionPartsConstructors.ChartPDFParameters.logoPlaceholderSizes.width;
            var maxH = _ChartPDFDefinitionPartsConstructors.ChartPDFParameters.logoPlaceholderSizes.height;

            var widthInPix = logoPicture.width;
            var heightInPix = logoPicture.height;

            var ratioForPlace = maxW / maxH;
            var rationForPixSizes = widthInPix / heightInPix;

            var coeff = 0; // coeff for calculate pdf logo dimensions
            // if ration for placeholder(w/h) less than for image, then need to adjust max height of image or width otherwise
            if (ratioForPlace > rationForPixSizes) {
                coeff = heightInPix / maxH;
            } else {
                coeff = widthInPix / maxW;
            }
            var wInPDF = widthInPix / coeff;
            var hInPDF = heightInPix / coeff;
            return {
                w: wInPDF,
                h: hInPDF,
                mL: (maxW - wInPDF) / 2,
                mT: 0
            };
        }
    }]);

    return ChartPDFDefinitionBuilder;
}();

exports.default = ChartPDFDefinitionBuilder;

/***/ }),
/* 1468 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _constants = __webpack_require__(11);

var _TableDefinitionBuilder = __webpack_require__(800);

var _TableDefinitionBuilder2 = _interopRequireDefault(_TableDefinitionBuilder);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SimpleTableDefinitionBuilder = function (_TableDefinitionBuild) {
    _inherits(SimpleTableDefinitionBuilder, _TableDefinitionBuild);

    function SimpleTableDefinitionBuilder(chartType, valueFormatter, categoryFormatter, grandTotalValue) {
        _classCallCheck(this, SimpleTableDefinitionBuilder);

        var _this = _possibleConstructorReturn(this, (SimpleTableDefinitionBuilder.__proto__ || Object.getPrototypeOf(SimpleTableDefinitionBuilder)).call(this, chartType, valueFormatter, categoryFormatter, grandTotalValue));

        _this._getDataRow = function (cellValue, showDataList, showPercentsList, tableValueStyles, rowDataMaxLens, isSecond) {
            var isValueAndPercentsCell = showDataList && showPercentsList;
            var maxDataRowLen = isValueAndPercentsCell ? rowDataMaxLens.valueAndPercents : rowDataMaxLens.valueOrPercents; // get max len for current parameters

            var value = this.chartType === _constants.ChartType.PIE_CHART ? cellValue.value : cellValue.value.total;
            var formattedValue = this.valueFormatter(value);
            var formattedPercent = this._getPercentValue(value);

            maxDataRowLen -= showDataList ? formattedValue.toString().length - 3 : formattedPercent.length; // substrate len of value without 3 chars (:dd or .dd) or percent length
            var formattedCategory = this.categoryFormatter(cellValue.category, maxDataRowLen);

            if (isValueAndPercentsCell) {
                return this.chartType === _constants.ChartType.PIE_CHART ? this.templateCtrs.colorValuePercentRow(cellValue.color, formattedCategory, formattedValue, formattedPercent, tableValueStyles, isSecond) : this.templateCtrs.valuePercentRow(formattedCategory, formattedValue, formattedPercent, tableValueStyles, isSecond);
            } else {
                var cellData = showDataList ? formattedValue : formattedPercent; // percent or value
                return this.chartType === _constants.ChartType.PIE_CHART ? this.templateCtrs.colorValueRow(cellValue.color, formattedCategory, cellData, tableValueStyles, isSecond) : this.templateCtrs.valueRow(formattedCategory, cellData, tableValueStyles, isSecond);
            }
        };

        return _this;
    }

    _createClass(SimpleTableDefinitionBuilder, [{
        key: 'getTable',
        value: function getTable(dataRows, margins, tableStyle) {
            return this.placeholderCtrs.simpleTable(dataRows, margins, tableStyle);
        }
    }, {
        key: 'getDataRows',
        value: function getDataRows(pageDataList, showDataList, showPercentsList, tableValueStyles, rowDataMaxLens) {
            var rows = [];
            for (var i = 0; i < pageDataList.length; i++) {
                var isSecond = i % 2 !== 0; //!counter starts with 0
                if (!_jquery2.default.isEmptyObject(pageDataList[i].category)) {
                    var row = this._getDataRow(pageDataList[i], showDataList, showPercentsList, tableValueStyles, rowDataMaxLens, isSecond);
                    rows.push(row);
                }
            }
            return rows;
        }

        /**
         * Create data cell element depends parameters or chartType
         * If chartType is pie, than cell will contains color rectangle
         * @param cellValue - object of value for one cell
         * @param showDataList - if need show values
         * @param showPercentsList - if need show percents
         * @param tableValueStyles - styles for table cell
         * @param rowDataMaxLens - max len in chars of value string (name + value)
         * @param isSecond - second row or not
         * @returns {*}
         * @private
         */

    }]);

    return SimpleTableDefinitionBuilder;
}(_TableDefinitionBuilder2.default);

exports.default = SimpleTableDefinitionBuilder;

/***/ }),
/* 1469 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _constants = __webpack_require__(100);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _TableDefinitionBuilder = __webpack_require__(800);

var _TableDefinitionBuilder2 = _interopRequireDefault(_TableDefinitionBuilder);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var StackedTableDefinitionBuilder = function (_TableDefinitionBuild) {
    _inherits(StackedTableDefinitionBuilder, _TableDefinitionBuild);

    function StackedTableDefinitionBuilder(chartType, valueFormatter, categoryFormatter, tableHeaders, grandTotalValue, includeOtherUsers) {
        _classCallCheck(this, StackedTableDefinitionBuilder);

        var _this = _possibleConstructorReturn(this, (StackedTableDefinitionBuilder.__proto__ || Object.getPrototypeOf(StackedTableDefinitionBuilder)).call(this, chartType, valueFormatter, categoryFormatter, grandTotalValue));

        _this._getPreparedData = function (pageDataList, showDataList, showPercentsList) {
            var data = [];

            var charWidthCoef = 6;
            var widths = {
                total: this.tableHeaders.total.length * charWidthCoef,
                user: this.tableHeaders.user.length * charWidthCoef,
                team: this.tableHeaders.team.length * charWidthCoef,
                notAssigned: this.tableHeaders.notAssigned.length * charWidthCoef
            };

            var noUserData = true;
            var noTeamData = true;
            var noNotAssignedData = true;

            for (var i = 0; i < pageDataList.length; i++) {
                var isSecond = i % 2 !== 0; //!counter starts with 0
                if (!_jquery2.default.isEmptyObject(pageDataList[i].category)) {
                    var cellValue = pageDataList[i];

                    var total = this.valueFormatter(cellValue.value.total);
                    var userPoint = cellValue.value.userPoint;
                    var userTeamPoint = cellValue.value.userTeamPoint;
                    var notAssignedUsersPoint = cellValue.value.notAssignedUsersPoint;

                    var userPercent = this._getPercentValue(userPoint);
                    var teamPercent = this._getPercentValue(userTeamPoint);
                    var notAssignedPercent = this._getPercentValue(notAssignedUsersPoint);

                    var user = "";
                    var team = "";
                    var notAssigned = "";

                    if (showDataList) {
                        user += this.valueFormatter(userPoint);
                        team += this.valueFormatter(userTeamPoint);
                        notAssigned += this.valueFormatter(notAssignedUsersPoint);
                    }

                    if (showPercentsList) {
                        user += (showDataList ? "  (" : "") + userPercent + (showDataList ? ")" : "");
                        team += (showDataList ? "  (" : "") + teamPercent + (showDataList ? ")" : "");
                        notAssigned += (showDataList ? "  (" : "") + notAssignedPercent + (showDataList ? ")" : "");
                    }

                    if (!userPoint) {
                        user = "—";
                    } else {
                        noUserData = false;
                    }
                    if (!userTeamPoint) {
                        team = "—";
                    } else {
                        noTeamData = false;
                    }
                    if (!notAssignedUsersPoint) {
                        notAssigned = "—";
                    } else {
                        noNotAssignedData = false;
                    }

                    var formattedCategory = this.categoryFormatter(cellValue.category);

                    if (widths.total < total.length * charWidthCoef) widths.total = total.length * charWidthCoef;
                    if (widths.user < user.length * charWidthCoef) widths.user = user.length * charWidthCoef;
                    if (widths.team < team.length * charWidthCoef) widths.team = team.length * charWidthCoef;
                    if (widths.notAssigned < notAssigned.length * charWidthCoef) widths.notAssigned = notAssigned.length * charWidthCoef;

                    data.push({
                        category: formattedCategory,
                        total: total,
                        user: user,
                        team: team,
                        notAssigned: notAssigned,
                        isSecond: isSecond
                    });
                }
            }
            return {
                data: data,
                contains: {
                    user: !noUserData,
                    team: !noTeamData,
                    notAssigned: !noNotAssignedData
                },
                widths: widths
            };
        };

        _this.includeDataOfOtherUsers = includeOtherUsers;
        _this.tableHeaders = tableHeaders;
        return _this;
    }

    _createClass(StackedTableDefinitionBuilder, [{
        key: 'getTable',
        value: function getTable(dataRows, margins, tableStyle) {
            return this.placeholderCtrs.stackedChartTable(dataRows, margins, tableStyle);
        }
    }, {
        key: 'getDataRows',
        value: function getDataRows(pageDataList, showDataList, showPercentsList, tableValueStyles, rowDataMaxLens) {
            var rows = [];
            var preparedData = this._getPreparedData(pageDataList, showDataList, showPercentsList, tableValueStyles);
            var data = [this.tableHeaders].concat(_toConsumableArray(preparedData.data));
            var widths = preparedData.widths;
            var valuesColumnsWidths = [widths.user, widths.team];
            if (this.includeDataOfOtherUsers) {
                valuesColumnsWidths.push(widths.notAssigned);
            }

            var valuesColumnsWidthSum = widths.total + widths.user + widths.team;
            if (this.includeDataOfOtherUsers) valuesColumnsWidthSum += widths.notAssigned;
            var paperWidth = this.paperSize === _constants.PaperSize.A4 ? 475 : 495;
            var categoryWidth = paperWidth - valuesColumnsWidthSum;

            for (var i = 0; i < data.length; i++) {
                var valuesColumns = [];
                valuesColumns.push({ value: data[i].user });
                valuesColumns.push({ value: data[i].team });
                if (this.includeDataOfOtherUsers) {
                    valuesColumns.push({ value: data[i].notAssigned });
                }

                var isHeader = i === 0;
                rows.push(this.templateCtrs.stackedValueRow(data[i].category, categoryWidth, data[i].total, widths.total, valuesColumns, valuesColumnsWidths, tableValueStyles, data[i].isSecond, isHeader));
            }

            return rows;
        }
    }]);

    return StackedTableDefinitionBuilder;
}(_TableDefinitionBuilder2.default);

exports.default = StackedTableDefinitionBuilder;

/***/ }),
/* 1470 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _BaseBarsChartsStrategy = __webpack_require__(801);

var _BaseBarsChartsStrategy2 = _interopRequireDefault(_BaseBarsChartsStrategy);

var _constants = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var VerticalBarsChartStrategy = function (_BaseBarsChartsStrate) {
    _inherits(VerticalBarsChartStrategy, _BaseBarsChartsStrate);

    function VerticalBarsChartStrategy() {
        _classCallCheck(this, VerticalBarsChartStrategy);

        return _possibleConstructorReturn(this, (VerticalBarsChartStrategy.__proto__ || Object.getPrototypeOf(VerticalBarsChartStrategy)).call(this, _constants.ChartType.VERTICAL_BAR));
    }

    return VerticalBarsChartStrategy;
}(_BaseBarsChartsStrategy2.default);

exports.default = VerticalBarsChartStrategy;

/***/ }),
/* 1471 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _BaseBarsChartsStrategy = __webpack_require__(801);

var _BaseBarsChartsStrategy2 = _interopRequireDefault(_BaseBarsChartsStrategy);

var _constants = __webpack_require__(100);

var _constants2 = __webpack_require__(11);

var _ChartPDFDefinitionPartsConstructors = __webpack_require__(198);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var HorBarsChartStrategy = function (_BaseBarsChartsStrate) {
    _inherits(HorBarsChartStrategy, _BaseBarsChartsStrate);

    function HorBarsChartStrategy() {
        _classCallCheck(this, HorBarsChartStrategy);

        return _possibleConstructorReturn(this, (HorBarsChartStrategy.__proto__ || Object.getPrototypeOf(HorBarsChartStrategy)).call(this, _constants2.ChartType.HORIZONTAL_BAR));
    }

    _createClass(HorBarsChartStrategy, [{
        key: 'adjustDataParameters',
        value: function adjustDataParameters(pagesData, pdfPrintParameters) {
            if (this._isDoublePageDataPortion(pdfPrintParameters)) {
                // need to split data by image and data
                return pagesData.reduce(function (res, cur) {
                    // page with image
                    res.push({
                        image: cur.image
                    });
                    // page with data
                    res.push({
                        data: cur.data
                    });
                    return res;
                }, []);
            } else {
                return _get(HorBarsChartStrategy.prototype.__proto__ || Object.getPrototypeOf(HorBarsChartStrategy.prototype), 'adjustDataParameters', this).call(this, pagesData, pdfPrintParameters);
            }
        }
    }, {
        key: '_isDoublePageDataPortion',
        value: function _isDoublePageDataPortion(pdfPrintParameters) {
            return pdfPrintParameters.paperOrientation === _constants.PaperOrientation.LANDSCAPE && this._needToShowTable(pdfPrintParameters);
        }
    }, {
        key: 'addPageDataWithDataList',
        value: function addPageDataWithDataList(ddBuilder, docDefinition, pageData, pdfPrintParameters, pageIndex) {
            var pageNumber = pageIndex + 1;
            if (this._isDoublePageDataPortion(pdfPrintParameters)) {
                if (pageNumber % 2 !== 0) {
                    // odd page with image, even page with data
                    ddBuilder.addOnlyImageToPage(docDefinition, pageData.image);
                } else {
                    ddBuilder.addOnlyTableToPage(docDefinition, pageData.data, pdfPrintParameters.showListOfDataValues, pdfPrintParameters.showListOfPercentValues, pdfPrintParameters.fitDataToOnePage);
                }
            } else {
                _get(HorBarsChartStrategy.prototype.__proto__ || Object.getPrototypeOf(HorBarsChartStrategy.prototype), 'addPageDataWithDataList', this).call(this, ddBuilder, docDefinition, pageData, pdfPrintParameters, pageIndex);
            }
        }
    }, {
        key: 'addPageDataWithoutDataList',
        value: function addPageDataWithoutDataList(ddBuilder, docDefinition, pageData, pdfPrintParameters, nPages) {
            if (pdfPrintParameters.paperOrientation === _constants.PaperOrientation.LANDSCAPE) {
                if (pageData.secondImage || nPages > 1) ddBuilder.addDoubleImagesHorizontal(docDefinition, pageData.firstImage, pageData.secondImage);else ddBuilder.addOnlyImageToPage(docDefinition, pageData.firstImage); // show single image only if single page
            } else {
                _get(HorBarsChartStrategy.prototype.__proto__ || Object.getPrototypeOf(HorBarsChartStrategy.prototype), 'addPageDataWithoutDataList', this).call(this, ddBuilder, docDefinition, pageData, pdfPrintParameters, nPages);
            }
        }
    }, {
        key: 'getMaxValuesOnPage',
        value: function getMaxValuesOnPage(_ref) {
            var paperOrientation = _ref.paperOrientation,
                paperSize = _ref.paperSize,
                showHeaderOnEachPage = _ref.showHeaderOnEachPage;

            if (paperOrientation === _constants.PaperOrientation.LANDSCAPE) {
                return (0, _ChartPDFDefinitionPartsConstructors.getMaxValuesOnPageWithoutImageProperty)({ paperOrientation: paperOrientation, paperSize: paperSize, chartType: this.chartType, withHeader: showHeaderOnEachPage });
            } else {
                return _get(HorBarsChartStrategy.prototype.__proto__ || Object.getPrototypeOf(HorBarsChartStrategy.prototype), 'getMaxValuesOnPage', this).call(this, { paperOrientation: paperOrientation, paperSize: paperSize, showHeaderOnEachPage: showHeaderOnEachPage });
            }
        }
    }, {
        key: 'getMaxValuesOnFitPage',
        value: function getMaxValuesOnFitPage(_ref2) {
            var paperOrientation = _ref2.paperOrientation,
                paperSize = _ref2.paperSize,
                showHeaderOnEachPage = _ref2.showHeaderOnEachPage;

            if (paperOrientation === _constants.PaperOrientation.LANDSCAPE) {
                return (0, _ChartPDFDefinitionPartsConstructors.getMaxValuesOnFitPageWithoutImageProperty)({ paperOrientation: paperOrientation, paperSize: paperSize, chartType: this.chartType, withHeader: showHeaderOnEachPage });
            } else {
                return _get(HorBarsChartStrategy.prototype.__proto__ || Object.getPrototypeOf(HorBarsChartStrategy.prototype), 'getMaxValuesOnFitPage', this).call(this, { paperOrientation: paperOrientation, paperSize: paperSize, showHeaderOnEachPage: showHeaderOnEachPage });
            }
        }
    }, {
        key: 'getTotalNumberOfPages',
        value: function getTotalNumberOfPages(lengthOfDataList, pdfPrintParameters) {
            if (this._isDoublePageDataPortion(pdfPrintParameters)) {
                if (pdfPrintParameters.fitDataToOnePage) {
                    // TODO need to rename property :)
                    return 2;
                } else {
                    return _get(HorBarsChartStrategy.prototype.__proto__ || Object.getPrototypeOf(HorBarsChartStrategy.prototype), 'getTotalNumberOfPages', this).call(this, lengthOfDataList, pdfPrintParameters) * 2;
                }
            } else {
                return _get(HorBarsChartStrategy.prototype.__proto__ || Object.getPrototypeOf(HorBarsChartStrategy.prototype), 'getTotalNumberOfPages', this).call(this, lengthOfDataList, pdfPrintParameters);
            }
        }
    }, {
        key: 'getChartImageDimensions',
        value: function getChartImageDimensions(lengthOfDataList, pdfPrintParameters) {
            if (pdfPrintParameters.paperOrientation === _constants.PaperOrientation.LANDSCAPE && !this._needToShowTable(pdfPrintParameters)) {
                // barsOnPage means barsOnChart
                // if landscape and without table we can show singe image to full page if there are no another images
                var isDoubleImages = !pdfPrintParameters.fitDataToOnePage && pdfPrintParameters.barsOnPage < lengthOfDataList;
                return (0, _ChartPDFDefinitionPartsConstructors.getNeededImageDimensions)(pdfPrintParameters.paperOrientation, pdfPrintParameters.paperSize, this.chartType, isDoubleImages);
            } else {
                return _get(HorBarsChartStrategy.prototype.__proto__ || Object.getPrototypeOf(HorBarsChartStrategy.prototype), 'getChartImageDimensions', this).call(this, lengthOfDataList, pdfPrintParameters);
            }
        }
    }]);

    return HorBarsChartStrategy;
}(_BaseBarsChartsStrategy2.default);

exports.default = HorBarsChartStrategy;

/***/ }),
/* 1472 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ChartPDFDefinitionPartsConstructors = __webpack_require__(198);

var _BaseCreateDefinitionObjectStrategy = __webpack_require__(802);

var _BaseCreateDefinitionObjectStrategy2 = _interopRequireDefault(_BaseCreateDefinitionObjectStrategy);

var _constants = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure undefined"); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PieChartStrategy = function (_BaseCreateDefinition) {
    _inherits(PieChartStrategy, _BaseCreateDefinition);

    function PieChartStrategy() {
        _classCallCheck(this, PieChartStrategy);

        return _possibleConstructorReturn(this, (PieChartStrategy.__proto__ || Object.getPrototypeOf(PieChartStrategy)).call(this, _constants.ChartType.PIE_CHART));
    }

    /**
     * for pie chart data are provided in one page, however we need to fit data to some pages (only if it needs)
     * this function split one page data depends on max number of values on one page
     * @param pagesData
     * @param pdfPrintParameters parameters for display pdf
     * @returns {Array}
     * @private
     */


    _createClass(PieChartStrategy, [{
        key: 'adjustDataParameters',
        value: function adjustDataParameters(pagesData, pdfPrintParameters) {
            var paperOrientation = pdfPrintParameters.paperOrientation,
                paperSize = pdfPrintParameters.paperSize,
                fitDataToOnePage = pdfPrintParameters.fitDataToOnePage;
            // if data need to fit to one page return original data

            if (fitDataToOnePage) {
                return pagesData;
            }
            var newPages = [];
            var currentPage = {
                image: pagesData[0].image,
                data: []

                // if no need data list - return page only with image
            };if (!this._needToShowTable(pdfPrintParameters)) {
                newPages.push(currentPage);
                return newPages;
            }

            var nValuesOnPageWithImage = (0, _ChartPDFDefinitionPartsConstructors.getMaxValuesOnPageProperty)({
                paperOrientation: paperOrientation,
                paperSize: paperSize,
                chartType: this.chartType
            });
            var nValuesOnPageWithoutImage = (0, _ChartPDFDefinitionPartsConstructors.getMaxValuesOnPageWithoutImageProperty)({
                paperOrientation: paperOrientation,
                paperSize: paperSize,
                chartType: this.chartType,
                withHeader: pdfPrintParameters.showHeaderOnEachPage
            });

            var currentPageCount = 0;
            var enoughValuesToPage = false;
            for (var i = 0; i < pagesData[0].data.length; i++) {
                currentPage.data.push(pagesData[0].data[i]);
                currentPageCount++;

                if (newPages.length === 0) {
                    if (currentPageCount === nValuesOnPageWithImage) {
                        enoughValuesToPage = true;
                    }
                } else {
                    if (currentPageCount === nValuesOnPageWithoutImage) {
                        enoughValuesToPage = true;
                    }
                }

                if (enoughValuesToPage) {
                    enoughValuesToPage = false;
                    newPages.push(currentPage);
                    currentPage = { data: [] };
                    currentPageCount = 0;
                }
            }
            if (currentPage.data.length !== 0) {
                newPages.push(currentPage); // add last page if there are no added values
            }
            return newPages;
        }
    }, {
        key: 'addPageDataWithDataList',
        value: function addPageDataWithDataList(ddBuilder, docDefinition, pageData, pdfPrintParameters, pageIndex) {
            if (pageIndex === 0) {
                // first page
                ddBuilder.addImageAndData(docDefinition, pageData.image, pageData.data, pdfPrintParameters.showListOfDataValues, pdfPrintParameters.showListOfPercentValues, pdfPrintParameters.fitDataToOnePage);
            } else {
                ddBuilder.addOnlyTableToPage(docDefinition, pageData.data, pdfPrintParameters.showListOfDataValues, pdfPrintParameters.showListOfPercentValues);
            }
        }
    }, {
        key: 'addPageDataWithoutDataList',
        value: function addPageDataWithoutDataList(ddBuilder, docDefinition, pageData, pdfPrintParameters, nPages) {
            ddBuilder.addOnlyImageToPage(docDefinition, pageData.image);
        }
    }, {
        key: 'getMaxValuesOnPageWithoutTable',
        value: function getMaxValuesOnPageWithoutTable(_ref) {
            _objectDestructuringEmpty(_ref);

            return -1;
        }
    }, {
        key: 'getTotalNumberOfPages',
        value: function getTotalNumberOfPages(lengthOfDataList, pdfPrintParameters) {
            var paperSize = pdfPrintParameters.paperSize,
                paperOrientation = pdfPrintParameters.paperOrientation,
                showHeaderOnEachPage = pdfPrintParameters.showHeaderOnEachPage,
                fitDataToOnePage = pdfPrintParameters.fitDataToOnePage;

            if (fitDataToOnePage || !this._needToShowTable(pdfPrintParameters)) {
                return 1;
            } else {
                var maxValuesOnPage = (0, _ChartPDFDefinitionPartsConstructors.getMaxValuesOnPageProperty)({
                    paperOrientation: paperOrientation,
                    paperSize: paperSize,
                    chartType: _constants.ChartType.PIE_CHART
                });
                var maxValuesOnPageWithoutImage = (0, _ChartPDFDefinitionPartsConstructors.getMaxValuesOnPageWithoutImageProperty)({
                    paperOrientation: paperOrientation,
                    paperSize: paperSize,
                    chartType: _constants.ChartType.PIE_CHART,
                    withHeader: showHeaderOnEachPage
                });

                var nValues = lengthOfDataList;
                var nPages = 0;
                if (nValues >= maxValuesOnPage) {
                    nPages++;
                    nValues -= maxValuesOnPage;
                }
                if (nValues > 0) {
                    nPages += Math.ceil(nValues / maxValuesOnPageWithoutImage);
                }
                return nPages;
            }
        }
    }, {
        key: 'getChartImageDimensions',
        value: function getChartImageDimensions(lengthOfDataList, pdfPrintParameters) {
            return (0, _ChartPDFDefinitionPartsConstructors.getNeededImageDimensions)(pdfPrintParameters.paperOrientation, pdfPrintParameters.paperSize, this.chartType, false);
        }
    }]);

    return PieChartStrategy;
}(_BaseCreateDefinitionObjectStrategy2.default);

exports.default = PieChartStrategy;

/***/ }),
/* 1473 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _ChartPDFParametersFormattingStrategy = __webpack_require__(245);

var _ChartPDFParametersFormattingStrategy2 = _interopRequireDefault(_ChartPDFParametersFormattingStrategy);

var _ChartPDFDateRangeFormattingStrategy = __webpack_require__(247);

var _ChartPDFDateRangeFormattingStrategy2 = _interopRequireDefault(_ChartPDFDateRangeFormattingStrategy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ChartPDFOvertimeParametersFormattingStrategy = function (_ChartPDFParametersFo) {
    _inherits(ChartPDFOvertimeParametersFormattingStrategy, _ChartPDFParametersFo);

    function ChartPDFOvertimeParametersFormattingStrategy() {
        _classCallCheck(this, ChartPDFOvertimeParametersFormattingStrategy);

        return _possibleConstructorReturn(this, (ChartPDFOvertimeParametersFormattingStrategy.__proto__ || Object.getPrototypeOf(ChartPDFOvertimeParametersFormattingStrategy)).apply(this, arguments));
    }

    _createClass(ChartPDFOvertimeParametersFormattingStrategy, [{
        key: 'init',
        value: function init(selectorsData, dateFormat, dateFormatForFile, reportAuthorizationInfo, reportParamsStringBuilderConstructor) {
            _get(ChartPDFOvertimeParametersFormattingStrategy.prototype.__proto__ || Object.getPrototypeOf(ChartPDFOvertimeParametersFormattingStrategy.prototype), 'init', this).call(this, selectorsData, dateFormat, dateFormatForFile, reportAuthorizationInfo, reportParamsStringBuilderConstructor);
            return this;
        }
    }, {
        key: 'createDateParametersFormattingStrategy',
        value: function createDateParametersFormattingStrategy(dateFormat, dateFormatForFile) {
            return new _ChartPDFDateRangeFormattingStrategy2.default(dateFormat, dateFormatForFile);
        }
    }, {
        key: 'formatChartPDFFilterInformation',
        value: function formatChartPDFFilterInformation(selectedParameters) {
            return {
                firstRow: this.parametersFormatter.formatOvertimeUsersSelection(selectedParameters.hierarchicalSelectorsParameters.userSelection),
                secondRow: ' '
            };
        }
    }]);

    return ChartPDFOvertimeParametersFormattingStrategy;
}(_ChartPDFParametersFormattingStrategy2.default);

exports.default = ChartPDFOvertimeParametersFormattingStrategy;

/***/ }),
/* 1474 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _ChartParametersFormatter = __webpack_require__(516);

var _ChartParametersFormatter2 = _interopRequireDefault(_ChartParametersFormatter);

var _constants = __webpack_require__(11);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ChartPDFParametersFormatter = function (_ChartParametersForma) {
    _inherits(ChartPDFParametersFormatter, _ChartParametersForma);

    function ChartPDFParametersFormatter() {
        _classCallCheck(this, ChartPDFParametersFormatter);

        return _possibleConstructorReturn(this, (ChartPDFParametersFormatter.__proto__ || Object.getPrototypeOf(ChartPDFParametersFormatter)).apply(this, arguments));
    }

    _createClass(ChartPDFParametersFormatter, [{
        key: 'init',
        value: function init(_ref) {
            var selectorsData = _ref.selectorsData,
                dateFormat = _ref.dateFormat,
                ugrEnabled = _ref.ugrEnabled,
                tzgEnabled = _ref.tzgEnabled,
                reportAuthorizationInfo = _ref.reportAuthorizationInfo,
                reportParamsStringBuilderConstructor = _ref.reportParamsStringBuilderConstructor;

            _get(ChartPDFParametersFormatter.prototype.__proto__ || Object.getPrototypeOf(ChartPDFParametersFormatter.prototype), 'init', this).call(this, {
                selectorsData: selectorsData,
                dateFormat: dateFormat,
                ugrFeatureEnabled: ugrEnabled,
                tzgFeatureEnabled: tzgEnabled,
                reportAuthorizationInfo: reportAuthorizationInfo,
                reportParamsStringBuilderConstructor: reportParamsStringBuilderConstructor
            });
            return this;
        }
    }, {
        key: 'formatGrandTotalValueType',
        value: function formatGrandTotalValueType(chartTypeValue) {
            switch (chartTypeValue) {
                case _constants.ReportChartType.PTO_BALANCE:
                    if (SystemSettings.showPTOInHours) {
                        return _messageResource2.default.getMessage('report.chart_pdf.grand_total_hours');
                    } else {
                        return _messageResource2.default.getMessage('report.chart_pdf.grand_total_days');
                    }
                case _constants.ReportChartType.SICK_DAYS_BALANCE:
                    if (SystemSettings.showSickInHours) {
                        return _messageResource2.default.getMessage('report.chart_pdf.grand_total_hours');
                    } else {
                        return _messageResource2.default.getMessage('report.chart_pdf.grand_total_days');
                    }
                case _constants.ReportChartType.TOTAL_WORKING_HOURS:
                case _constants.ReportChartType.APPROVED_WORKING_HOURS:
                case _constants.ReportChartType.LEAVE_HOURS:
                case _constants.ReportChartType.OVERTIME_HOURS:
                    return _messageResource2.default.getMessage('report.chart_pdf.grand_total_hours');
                case _constants.ReportChartType.COST_OF_WORK:
                case _constants.ReportChartType.BILLABLE_AMOUNTS:
                    return _messageResource2.default.getMessage('report.chart_pdf.grand_total_amount');
            }
        }
    }, {
        key: 'formatGrandTotalPostfix',
        value: function formatGrandTotalPostfix(chartTypeValue) {
            switch (chartTypeValue) {
                case _constants.ReportChartType.PTO_BALANCE:
                case _constants.ReportChartType.SICK_DAYS_BALANCE:
                    return '';
                case _constants.ReportChartType.TOTAL_WORKING_HOURS:
                case _constants.ReportChartType.APPROVED_WORKING_HOURS:
                case _constants.ReportChartType.LEAVE_HOURS:
                case _constants.ReportChartType.OVERTIME_HOURS:
                    return _messageResource2.default.getMessage('common.mh');
                case _constants.ReportChartType.COST_OF_WORK:
                case _constants.ReportChartType.BILLABLE_AMOUNTS:
                    return SystemSettings.currencySign;
            }
        }
    }]);

    return ChartPDFParametersFormatter;
}(_ChartParametersFormatter2.default);

exports.default = ChartPDFParametersFormatter;

/***/ }),
/* 1475 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _ChartPDFParametersFormattingStrategy = __webpack_require__(245);

var _ChartPDFParametersFormattingStrategy2 = _interopRequireDefault(_ChartPDFParametersFormattingStrategy);

var _ChartPDFDateRangeFormattingStrategy = __webpack_require__(247);

var _ChartPDFDateRangeFormattingStrategy2 = _interopRequireDefault(_ChartPDFDateRangeFormattingStrategy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ChartPDFLeaveParametersFormattingStrategy = function (_ChartPDFParametersFo) {
    _inherits(ChartPDFLeaveParametersFormattingStrategy, _ChartPDFParametersFo);

    function ChartPDFLeaveParametersFormattingStrategy() {
        _classCallCheck(this, ChartPDFLeaveParametersFormattingStrategy);

        return _possibleConstructorReturn(this, (ChartPDFLeaveParametersFormattingStrategy.__proto__ || Object.getPrototypeOf(ChartPDFLeaveParametersFormattingStrategy)).apply(this, arguments));
    }

    _createClass(ChartPDFLeaveParametersFormattingStrategy, [{
        key: 'init',
        value: function init(selectorsData, dateFormat, dateFormatForFile, reportAuthorizationInfo, reportParamsStringBuilderConstructor) {
            _get(ChartPDFLeaveParametersFormattingStrategy.prototype.__proto__ || Object.getPrototypeOf(ChartPDFLeaveParametersFormattingStrategy.prototype), 'init', this).call(this, selectorsData, dateFormat, dateFormatForFile, reportAuthorizationInfo, reportParamsStringBuilderConstructor);
            return this;
        }
    }, {
        key: 'createDateParametersFormattingStrategy',
        value: function createDateParametersFormattingStrategy(dateFormat, dateFormatForFile) {
            return new _ChartPDFDateRangeFormattingStrategy2.default(dateFormat, dateFormatForFile);
        }
    }, {
        key: 'formatChartPDFFilterInformation',
        value: function formatChartPDFFilterInformation(selectedParameters) {
            return {
                firstRow: this.parametersFormatter.formatUsersSelection(selectedParameters.hierarchicalSelectorsParameters.userSelection),
                secondRow: this.parametersFormatter.formatLeaveTypesSelection(selectedParameters.hierarchicalSelectorsParameters.leaveTypeSelection)
            };
        }
    }]);

    return ChartPDFLeaveParametersFormattingStrategy;
}(_ChartPDFParametersFormattingStrategy2.default);

exports.default = ChartPDFLeaveParametersFormattingStrategy;

/***/ }),
/* 1476 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _ChartPDFParametersFormattingStrategy = __webpack_require__(245);

var _ChartPDFParametersFormattingStrategy2 = _interopRequireDefault(_ChartPDFParametersFormattingStrategy);

var _ChartPDFDateRangeFormattingStrategy = __webpack_require__(247);

var _ChartPDFDateRangeFormattingStrategy2 = _interopRequireDefault(_ChartPDFDateRangeFormattingStrategy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ChartPDFWorkingHoursCostBillingParametersFormattingStrategy = function (_ChartPDFParametersFo) {
    _inherits(ChartPDFWorkingHoursCostBillingParametersFormattingStrategy, _ChartPDFParametersFo);

    function ChartPDFWorkingHoursCostBillingParametersFormattingStrategy() {
        _classCallCheck(this, ChartPDFWorkingHoursCostBillingParametersFormattingStrategy);

        return _possibleConstructorReturn(this, (ChartPDFWorkingHoursCostBillingParametersFormattingStrategy.__proto__ || Object.getPrototypeOf(ChartPDFWorkingHoursCostBillingParametersFormattingStrategy)).apply(this, arguments));
    }

    _createClass(ChartPDFWorkingHoursCostBillingParametersFormattingStrategy, [{
        key: 'init',
        value: function init(selectorsData, dateFormat, dateFormatForFile, reportAuthorizationInfo, reportParamsStringBuilderConstructor) {
            _get(ChartPDFWorkingHoursCostBillingParametersFormattingStrategy.prototype.__proto__ || Object.getPrototypeOf(ChartPDFWorkingHoursCostBillingParametersFormattingStrategy.prototype), 'init', this).call(this, selectorsData, dateFormat, dateFormatForFile, reportAuthorizationInfo, reportParamsStringBuilderConstructor);
            return this;
        }
    }, {
        key: 'createDateParametersFormattingStrategy',
        value: function createDateParametersFormattingStrategy(dateFormat, dateFormatForFile) {
            return new _ChartPDFDateRangeFormattingStrategy2.default(dateFormat, dateFormatForFile);
        }
    }, {
        key: 'formatChartPDFFilterInformation',
        value: function formatChartPDFFilterInformation(selectedParameters) {
            return {
                firstRow: this.parametersFormatter.formatUsersSelection(selectedParameters.hierarchicalSelectorsParameters.userSelection),
                secondRow: this.parametersFormatter.formatCustomersAndProjectsSelection(selectedParameters.hierarchicalSelectorsParameters.customersProjectsSelection)
            };
        }
    }]);

    return ChartPDFWorkingHoursCostBillingParametersFormattingStrategy;
}(_ChartPDFParametersFormattingStrategy2.default);

exports.default = ChartPDFWorkingHoursCostBillingParametersFormattingStrategy;

/***/ }),
/* 1477 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _ChartPDFParametersFormattingStrategy = __webpack_require__(245);

var _ChartPDFParametersFormattingStrategy2 = _interopRequireDefault(_ChartPDFParametersFormattingStrategy);

var _ChartPDFSingleDateFormattingStrategy = __webpack_require__(806);

var _ChartPDFSingleDateFormattingStrategy2 = _interopRequireDefault(_ChartPDFSingleDateFormattingStrategy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ChartPDFBalanceParametersFormattingStrategy = function (_ChartPDFParametersFo) {
    _inherits(ChartPDFBalanceParametersFormattingStrategy, _ChartPDFParametersFo);

    function ChartPDFBalanceParametersFormattingStrategy() {
        _classCallCheck(this, ChartPDFBalanceParametersFormattingStrategy);

        return _possibleConstructorReturn(this, (ChartPDFBalanceParametersFormattingStrategy.__proto__ || Object.getPrototypeOf(ChartPDFBalanceParametersFormattingStrategy)).apply(this, arguments));
    }

    _createClass(ChartPDFBalanceParametersFormattingStrategy, [{
        key: 'init',
        value: function init(selectorsData, dateFormat, dateFormatForFile, reportAuthorizationInfo, reportParamsStringBuilderConstructor) {
            _get(ChartPDFBalanceParametersFormattingStrategy.prototype.__proto__ || Object.getPrototypeOf(ChartPDFBalanceParametersFormattingStrategy.prototype), 'init', this).call(this, selectorsData, dateFormat, dateFormatForFile, reportAuthorizationInfo, reportParamsStringBuilderConstructor);
            return this;
        }
    }, {
        key: 'createDateParametersFormattingStrategy',
        value: function createDateParametersFormattingStrategy(dateFormat, dateFormatForFile) {
            return new _ChartPDFSingleDateFormattingStrategy2.default(dateFormat, dateFormatForFile);
        }
    }, {
        key: 'formatChartPDFFilterInformation',
        value: function formatChartPDFFilterInformation(selectedParameters) {
            return {
                firstRow: this.parametersFormatter.formatUsersSelection(selectedParameters.hierarchicalSelectorsParameters.userSelection),
                secondRow: ' '
            };
        }
    }]);

    return ChartPDFBalanceParametersFormattingStrategy;
}(_ChartPDFParametersFormattingStrategy2.default);

exports.default = ChartPDFBalanceParametersFormattingStrategy;

/***/ }),
/* 1478 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _SpinnerController = __webpack_require__(69);

var _SpinnerController2 = _interopRequireDefault(_SpinnerController);

var _spin = __webpack_require__(93);

var _spin2 = _interopRequireDefault(_spin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ChartPDFViewer = function ChartPDFViewer() {};

ChartPDFViewer.prototype.init = function () {

    window.PDFJS.disableWorker = false;
    window.PDFJS.workerSrc = window.BASE_PATH + 'js/pdfjs/pdf.worker.js';

    this.previewPlaceholder = (0, _jquery2.default)('#pdfPreviewSectionId');

    this.spinnerController = this._initSpinner();

    this.moire = (0, _jquery2.default)('#pdfPreviewSectionMoireId');

    this.currentPDF = null;
    this.currentPageForRender = 1;

    this.renderBreaker = { // need for break rendering process
        needBreak: false
    };

    return this;
};

ChartPDFViewer.prototype.showPDF = function (pdfData) {

    var newRenderBreaker = { needBreak: false };
    this.renderBreaker = newRenderBreaker;

    var self = this;

    window.PDFJS.getDocument({ data: pdfData }).then(function getPdfPreview(pdf) {
        self.currentPDF = pdf;
        self.currentPageForRender = 1;
        self._renderNextPage(newRenderBreaker);
    });
};

ChartPDFViewer.prototype._clearPlaceholder = function () {
    this.previewPlaceholder.empty();
    this.previewPlaceholder.scrollLeft(0); //need for chrome
    this.previewPlaceholder.scrollTop(0);
};

ChartPDFViewer.prototype._appendPageElement = function (pageNumber, maxPages, width, height) {
    var pageDiv = document.createElement('div');
    pageDiv.setAttribute('class', 'pdfPreviewPage');
    pageDiv.setAttribute('id', 'pdfPage_' + pageNumber);
    pageDiv = (0, _jquery2.default)(pageDiv).innerWidth(width).innerHeight(height);

    var pageNumFlag = document.createElement('div');
    pageNumFlag.setAttribute('class', 'pageNumInfo');
    pageNumFlag = (0, _jquery2.default)(pageNumFlag).html('<div>' + pageNumber + '/' + maxPages + '</div>');

    var canvas = document.createElement('canvas');
    canvas.height = height;
    canvas.width = width;

    pageDiv.append(pageNumFlag);
    pageDiv.append(canvas);

    this.previewPlaceholder.append(pageDiv);
};

ChartPDFViewer.prototype._getCurrentPageCanvasContext = function (currentPageNum) {
    return this.previewPlaceholder.find('#pdfPage_' + currentPageNum).find('canvas')[0].getContext('2d');
};

ChartPDFViewer.prototype._renderNextPage = function (renderBreaker) {
    var self = this;

    if (renderBreaker.needBreak) {
        return;
    }

    this.currentPDF.getPage(this.currentPageForRender).then(function renderPage(page) {

        if (renderBreaker.needBreak) return;

        var scale = 0.70;
        var viewport = page.getViewport(scale);

        // if first page - render all empty pages
        if (self.currentPageForRender === 1) {
            for (var i = 1; i <= self.currentPDF.numPages; i++) {
                self._appendPageElement(i, self.currentPDF.numPages, viewport.width, viewport.height);
            }
        }

        // Render PDF page into canvas context.
        var renderContext = {
            canvasContext: self._getCurrentPageCanvasContext(self.currentPageForRender),
            viewport: viewport
        };
        // used promises for asynchronous rendering each page
        page.render(renderContext).promise.then(function () {

            if (self.currentPDF.numPages === 1 || self.currentPageForRender === 2) {
                //if already render 2 page - hide moire
                self.hideMoire();
            }
            self.currentPageForRender++;
            if (self.currentPageForRender <= self.currentPDF.numPages) {

                self._renderNextPage(renderBreaker);
            }
        });
    });
};

ChartPDFViewer.prototype._initSpinner = function () {
    var spinnerOptions = {
        lines: 11, // The number of lines to draw
        length: 8, // The length of each line
        width: 3, // The line thickness
        radius: 6, // The radius of the inner circle
        corners: 1, // Corner roundness (0..1)
        rotate: 0, // The rotation offset
        direction: 1, // 1: clockwise, -1: counterclockwise
        color: '#888888', // #rgb or #rrggbb
        speed: 1, // Rounds per second
        trail: 60, // Afterglow percentage
        shadow: false, // Whether to render a shadow
        hwaccel: false, // Whether to use hardware acceleration
        className: 'spinner', // The CSS class to assign to the spinner
        zIndex: 2e9, // The z-index (defaults to 2000000000)
        top: 'auto', // Top position relative to parent in px
        left: 'auto' // Left position relative to parent in px
    };
    var spinnerController = new _SpinnerController2.default();
    spinnerController.setSpinner(new _spin2.default(spinnerOptions));

    return spinnerController;
};

ChartPDFViewer.prototype.interruptPreview = function () {
    this.renderBreaker.needBreak = true;
    this._clearPlaceholder();
};

ChartPDFViewer.prototype.showMoire = function () {
    this.spinnerController.spin('previewChartPDFSpinner');
    this.moire.show();
    this._clearPlaceholder();
};

ChartPDFViewer.prototype.hideMoire = function () {
    this.moire.hide();
    this.spinnerController.stop();
};

exports.default = ChartPDFViewer;

/***/ }),
/* 1479 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _PDFSettingsPreview2 = __webpack_require__(518);

var _PDFSettingsPreview3 = _interopRequireDefault(_PDFSettingsPreview2);

var _constants = __webpack_require__(11);

var _constants2 = __webpack_require__(100);

var _ListSelector = __webpack_require__(96);

var _ListSelector2 = _interopRequireDefault(_ListSelector);

var _jquery_rpc = __webpack_require__(26);

var _jquery_rpc2 = _interopRequireDefault(_jquery_rpc);

var _CustomSettingsSection = __webpack_require__(1480);

var _CustomSettingsSection2 = _interopRequireDefault(_CustomSettingsSection);

var _utils = __webpack_require__(513);

var _ReportChartsStore = __webpack_require__(519);

var _ReportChartsStore2 = _interopRequireDefault(_ReportChartsStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ChartsPDFSettingsPreview = function (_PDFSettingsPreview) {
    _inherits(ChartsPDFSettingsPreview, _PDFSettingsPreview);

    function ChartsPDFSettingsPreview() {
        _classCallCheck(this, ChartsPDFSettingsPreview);

        return _possibleConstructorReturn(this, (ChartsPDFSettingsPreview.__proto__ || Object.getPrototypeOf(ChartsPDFSettingsPreview)).apply(this, arguments));
    }

    _createClass(ChartsPDFSettingsPreview, [{
        key: 'afterRender',
        value: function afterRender() {
            _PDFSettingsPreview3.default.prototype.afterRender.call(this);
            this.lastSavedPaperOrientation = this.getStore().getPrintParametersForSave().paperOrientation;

            this.customSettingsSection = new _CustomSettingsSection2.default(this.getCustomSettingsSectionContainer(), this.printParameters, this.lightboxId, this.changesCallback).init();
        }
    }, {
        key: 'update',
        value: function update() {
            _PDFSettingsPreview3.default.prototype.update.call(this);
            this.customSettingsSection.update();
        }
    }, {
        key: 'getStore',
        value: function getStore() {
            return _ReportChartsStore2.default;
        }
    }, {
        key: 'triggerIntermediatePrintParametersChange',
        value: function triggerIntermediatePrintParametersChange(newPrintParameters) {
            (0, _jquery2.default)(document).trigger("reportCharts.intermediatePrintParametersChange", newPrintParameters);
        }
    }, {
        key: 'triggerPrintParametersForSaveChange',
        value: function triggerPrintParametersForSaveChange(printParametersForSave) {
            (0, _jquery2.default)(document).trigger("reportCharts.printParametersForSaveChange", printParametersForSave);
        }

        /**
         * Show checkbox if there is data list and number of data values between maxOnPage and maxOnFitPage
         * or
         * if there is no data list but number of data points more than 2 * maxOnPage and chart type is not PIE(for pie without data only one page is used)
         * @param totalNumberOfPoints number of values in current chart
         */

    }, {
        key: '_updateFitDataCheckboxVisibility',
        value: function _updateFitDataCheckboxVisibility(totalNumberOfPoints) {
            var paperOrientation = this.chartType === _constants.ChartType.PIE_CHART ? _constants2.PaperOrientation.PORTRAIT : this._getPaperOrientationParameter();
            var paperSize = this._getPaperSizeParameter();

            var _get$call = _get(ChartsPDFSettingsPreview.prototype.__proto__ || Object.getPrototypeOf(ChartsPDFSettingsPreview.prototype), 'collectPrintParametersForGenerate', this).call(this),
                showHeaderOnEachPage = _get$call.showHeaderOnEachPage;

            var maxValuesCalculator = (0, _utils.getMaxValuesCalculator)(this.chartType);
            var maxValuesOnFitPage = maxValuesCalculator.getMaxValuesOnFitPage({
                paperOrientation: paperOrientation,
                paperSize: paperSize,
                showHeaderOnEachPage: showHeaderOnEachPage
            });
            var maxValuesOnPage = maxValuesCalculator.getMaxValuesOnPage({
                paperOrientation: paperOrientation,
                paperSize: paperSize,
                showHeaderOnEachPage: showHeaderOnEachPage
            });

            var tableIsShowed = this.customSettingsSection.showListOfDataValuesCheckbox.checked || (this.customSettingsSection.showListOfPercentValuesCheckboxIsVisible ? this.customSettingsSection.showListOfPercentValuesCheckbox.checked : false);

            /*
                show fit data to one page
                   with table:
                      if values <= maxFittedValues
                   without table:
                      if chart not PIE or if data more than possible for one page
             */
            var needToShowCheckBox = void 0;
            if (tableIsShowed) {
                needToShowCheckBox = totalNumberOfPoints > maxValuesOnPage && totalNumberOfPoints <= maxValuesOnFitPage;
            } else {
                if (this.chartType === _constants.ChartType.PIE_CHART) {
                    needToShowCheckBox = false;
                } else {
                    needToShowCheckBox = totalNumberOfPoints > maxValuesCalculator.getMaxValuesOnPageWithoutTable({
                        paperOrientation: paperOrientation, paperSize: paperSize, showHeaderOnEachPage: showHeaderOnEachPage
                    });
                }
            }

            // update fitted pages
            var fitToNPages = 1;
            if (this.chartType === _constants.ChartType.HORIZONTAL_BAR && paperOrientation === _constants2.PaperOrientation.LANDSCAPE && tableIsShowed) {
                fitToNPages = 2;
            }
            this.customSettingsSection.setState({
                fitToNPages: fitToNPages
            });

            if (needToShowCheckBox) {
                this.isfitDataCheckboxVisible = true;
                this.section.removeClass("fitDataCheckboxHidden");
            } else {
                this.section.addClass("fitDataCheckboxHidden");
                this.isfitDataCheckboxVisible = false;
            }
        }

        // this method removes old chart size selector from dom and initializes new selector according to current chart and print parameters

    }, {
        key: '_reinitializeChartSizeSelector',
        value: function _reinitializeChartSizeSelector(numberOfBars) {
            this.customSettingsSection.chartSizeSelectorContainer.innerHTML = "";

            var dataFitToOnePage = this._isFitDataToOnePage();

            var maxNumberOfBarsForCurrentChart = dataFitToOnePage ? this.totalNumberOfPoints : Math.min(this.totalNumberOfPoints, this.getMaxCountBarsOnPage());

            var initialValue = numberOfBars > 0 ? Math.min(numberOfBars, maxNumberOfBarsForCurrentChart) : maxNumberOfBarsForCurrentChart;

            var chartSizeItems = [];
            for (var i = 1; i <= maxNumberOfBarsForCurrentChart; i++) {
                chartSizeItems.push({ text: i, value: i });
            }this.customSettingsSection.chartSizeSelector = new _ListSelector2.default({
                menuCls: "chartSizeSelectorMenu",
                renderTo: this.customSettingsSection.chartSizeSelectorContainer,
                listItems: chartSizeItems,
                value: dataFitToOnePage ? maxNumberOfBarsForCurrentChart : initialValue
            });
            this.customSettingsSection.chartSizeSelector.on("change", this.changesCallback);
            if (dataFitToOnePage) {
                this.customSettingsSection.chartSizeSelector.disable();
            }
        }
    }, {
        key: 'handleParameterChange',
        value: function handleParameterChange() {
            this._updateFitDataCheckboxVisibility(this.totalNumberOfPoints);

            if (this.chartType !== _constants.ChartType.PIE_CHART) {
                var numberOfBars = this.getCurrentChartSizeSelectorValue();
                // save previous value in selector if fit to one page checked
                if (this._isFitDataToOnePage() && this._prevFitDataToOnePage === false) {
                    this.prevChartSizeValue = numberOfBars;
                } else if (this._isFitDataToOnePage() === false) {
                    if (this.prevChartSizeValue) {
                        numberOfBars = this.prevChartSizeValue;
                        this.prevChartSizeValue = null;
                    }
                }
                this._reinitializeChartSizeSelector(numberOfBars);
            }
            this._prevFitDataToOnePage = this._isFitDataToOnePage();

            _PDFSettingsPreview3.default.prototype.handleParameterChange.call(this);
        }
    }, {
        key: 'getCurrentChartSizeSelectorValue',
        value: function getCurrentChartSizeSelectorValue() {
            return this.customSettingsSection.chartSizeSelector.getSelectedItem().value;
        }
    }, {
        key: 'getMaxCountBarsOnPage',
        value: function getMaxCountBarsOnPage() {
            return (0, _utils.getMaxValuesCalculator)(this.chartType).getMaxValuesOnPage({
                paperOrientation: this._getPaperOrientationParameter(),
                paperSize: this._getPaperSizeParameter(),
                showHeaderOnEachPage: _get(ChartsPDFSettingsPreview.prototype.__proto__ || Object.getPrototypeOf(ChartsPDFSettingsPreview.prototype), 'collectPrintParametersForGenerate', this).call(this).showHeaderOnEachPage
            });
        }
    }, {
        key: 'collectPrintParametersForGenerate',
        value: function collectPrintParametersForGenerate() {
            var printParameters = _PDFSettingsPreview3.default.prototype.collectPrintParametersForGenerate.call(this);
            if (this.chartType === _constants.ChartType.PIE_CHART) printParameters.paperOrientation = _constants2.PaperOrientation.PORTRAIT;

            printParameters.showListOfDataValues = this.customSettingsSection.showListOfDataValuesCheckbox.checked;
            if (this.chartType !== _constants.ChartType.PIE_CHART) {
                printParameters.barsOnPage = this.getCurrentChartSizeSelectorValue();
            }
            printParameters.showListOfPercentValues = this.customSettingsSection.showListOfPercentValuesCheckboxIsVisible ? this.customSettingsSection.showListOfPercentValuesCheckbox.checked : false;
            printParameters.fitDataToOnePage = this._isFitDataToOnePage();

            return printParameters;
        }
    }, {
        key: 'collectPrintParametersForSave',
        value: function collectPrintParametersForSave() {
            var printParametersForSaving = _PDFSettingsPreview3.default.prototype.collectPrintParametersForSave.call(this);
            if (this.chartType === _constants.ChartType.PIE_CHART) {
                printParametersForSaving.paperOrientation = this.lastSavedPaperOrientation;
            }

            printParametersForSaving.showListOfDataValues = this.customSettingsSection.showListOfDataValuesCheckbox.checked;
            printParametersForSaving.showListOfPercentValues = this.customSettingsSection.showListOfPercentValuesCheckboxIsVisible ? this.customSettingsSection.showListOfPercentValuesCheckbox.checked : this.customSettingsSection.lastSavedShowListOfPercentValues;
            printParametersForSaving.fitDataToOnePage = this.isfitDataCheckboxVisible ? this.customSettingsSection.fitDataToOnePageCheckbox.checked : this.customSettingsSection.lastSavedFitDataToOnePage;

            return printParametersForSaving;
        }
    }, {
        key: 'updateNeededLastSavedParameters',
        value: function updateNeededLastSavedParameters() {
            var lastSavedPrintParameters = _ReportChartsStore2.default.getPrintParametersForSave();
            this.lastSavedPaperOrientation = lastSavedPrintParameters.paperOrientation;
            this.customSettingsSection.lastSavedShowListOfPercentValues = lastSavedPrintParameters.showListOfPercentValues;
            this.customSettingsSection.lastSavedFitDataToOnePage = lastSavedPrintParameters.fitDataToOnePage;
        }
    }, {
        key: 'onShow',
        value: function onShow(chartType, totalNumberOfPoints, numberOfBars, minValue, maxValue) {
            this.chartType = chartType;

            this.totalNumberOfPoints = totalNumberOfPoints;

            this._updateShowListOfPercentValuesCheckboxVisibility(minValue, maxValue);
            this._updateFitDataCheckboxVisibility(totalNumberOfPoints);

            if (this.chartType !== _constants.ChartType.PIE_CHART) {
                this._reinitializeChartSizeSelector(numberOfBars);
            }
        }
    }, {
        key: '_updateShowListOfPercentValuesCheckboxVisibility',
        value: function _updateShowListOfPercentValuesCheckboxVisibility(minValue, maxValue) {
            if (minValue < 0 && maxValue > 0) {
                this.customSettingsSection.showListOfPercentValuesCheckboxIsVisible = false;
                this.section.addClass("percentCheckboxHidden");
            } else {
                this.customSettingsSection.showListOfPercentValuesCheckboxIsVisible = true;
                this.section.removeClass("percentCheckboxHidden");
            }
        }
    }, {
        key: 'sendSaveChartPrintParametersRequest',
        value: function sendSaveChartPrintParametersRequest() {
            var self = this;
            (0, _jquery_rpc2.default)("ReportChartService.saveChartPrintParameters", [_ReportChartsStore2.default.getPrintParametersForSave()], function () {
                self.updateNeededLastSavedParameters();
            }, function () {
                return true;
            });
        }
    }, {
        key: '_isFitDataToOnePage',
        value: function _isFitDataToOnePage() {
            return this.isfitDataCheckboxVisible ? this.customSettingsSection.fitDataToOnePageCheckbox.checked : false;
        }
    }]);

    return ChartsPDFSettingsPreview;
}(_PDFSettingsPreview3.default);

exports.default = ChartsPDFSettingsPreview;

/***/ }),
/* 1480 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _ReportChartsStore = __webpack_require__(519);

var _ReportChartsStore2 = _interopRequireDefault(_ReportChartsStore);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CustomSettingsSection = function (_TemplateView) {
    _inherits(CustomSettingsSection, _TemplateView);

    function CustomSettingsSection($containerEl, printParameters, lightboxId, changesCallback) {
        _classCallCheck(this, CustomSettingsSection);

        // these parameters are updated every time we update preview and saved only when we download pdf file
        var _this = _possibleConstructorReturn(this, (CustomSettingsSection.__proto__ || Object.getPrototypeOf(CustomSettingsSection)).call(this, $containerEl));

        _this.printParameters = printParameters;
        _this.lightboxId = lightboxId; //TODO: make this component markup independent from lightbox at some point
        _this.changesCallback = changesCallback;

        _this.state = {
            fitToNPages: 1
        };

        _this.onStatePropertyChanged('fitToNPages', function (fitToNPages) {
            var label = '';
            switch (fitToNPages) {
                case 1:
                    label = _messageResource2.default.getMessage('report.chart_pdf_preview.fit_data_to_one_page');
                    break;
                case 2:
                    label = _messageResource2.default.getMessage('report.chart_pdf_preview.fit_data_to_two_pages');
                    break;
            }
            _this.$fitDataCheckboxLabel.text(label);
        });
        return _this;
    }

    _createClass(CustomSettingsSection, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return "<div class='dataLayoutSection'>" + "  <div class='parametersSectionHeader'><%=dataLayoutLabel%></div>" + "  <div class='chartSizeParameter'>" + "    <div class='selectorLabel'><%=chartSizeLabel%></div>" + "    <div id='<%=id%>_chartSizeSelector'></div>" + "    <div class='selectorLabel'><%=barsLabel%></div>" + "  </div>" + "  <div>" + "    <table>" + "      <tr>" + "        <td><input type='checkbox' id='<%=id%>_showListOfDataValues'/></td>" + "        <td><label for='<%=id%>_showListOfDataValues'><%=showDataValuesLabel%></label></td>" + "      </tr>" + "      <tr class='percentCheckboxTr'>" + "        <td><input type='checkbox' id='<%=id%>_showListOfPercentValues'/></td>" + "        <td><label for='<%=id%>_showListOfPercentValues'><%=showPercentValuesLabel%></label></td>" + "      </tr>" + "      <tr class='fitDataCheckboxTr'>" + "        <td><input type='checkbox' id='<%=id%>_fitDataToOnePage'/></td>" + "        <td><label for='<%=id%>_fitDataToOnePage'></label></td>" + "      </tr>" + "    </table>" + "  </div>" + "</div>";
        }
    }, {
        key: 'templateModel',
        value: function templateModel() {
            return { id: this.lightboxId };
        }
    }, {
        key: 'messageKeys',
        value: function messageKeys() {
            return {
                "dataLayoutLabel": "report.chart_pdf_preview.data_layout",
                "chartSizeLabel": "report.chart_pdf_preview.chart_size",
                "barsLabel": "report.chart_pdf_preview.bars",
                "showDataValuesLabel": "report.chart_pdf_preview.show_data_values_list",
                "showPercentValuesLabel": "report.chart_pdf_preview.show_percent_values_list"
            };
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            this.fitDataToOnePageCheckbox = this.initFitDataCheckBox();
            // chart size selector is reinitialized every time we switch lightbox to PDF Preview View if chart type is not PIE_CHART, so we do not initialize it here
            this.chartSizeSelectorContainer = document.getElementById(this.lightboxId + "_chartSizeSelector");

            this.initShowValuesCheckboxes();
            this.lastSavedShowListOfPercentValues = _ReportChartsStore2.default.getPrintParametersForSave().showListOfPercentValues;

            this.$fitDataCheckboxLabel = this.find('.fitDataCheckboxTr label');

            this.renderInitialState();
        }
    }, {
        key: 'update',
        value: function update() {
            var printParameters = _ReportChartsStore2.default.getPrintParametersForSave();
            this.fitDataToOnePageCheckbox.checked = printParameters.fitDataToOnePage;
            this.showListOfDataValuesCheckbox.checked = printParameters.showListOfDataValues;
            this.showListOfPercentValuesCheckbox.checked = printParameters.showListOfPercentValues;
        }
    }, {
        key: 'initFitDataCheckBox',
        value: function initFitDataCheckBox() {
            var checkBox = document.getElementById(this.lightboxId + "_fitDataToOnePage");
            checkBox.onchange = this.changesCallback;
            return checkBox;
        }
    }, {
        key: 'initShowValuesCheckboxes',
        value: function initShowValuesCheckboxes() {
            this.showListOfDataValuesCheckbox = document.getElementById(this.lightboxId + "_showListOfDataValues");
            this.showListOfDataValuesCheckbox.onchange = this.changesCallback;

            this.showListOfPercentValuesCheckbox = document.getElementById(this.lightboxId + "_showListOfPercentValues");
            this.showListOfPercentValuesCheckbox.onchange = this.changesCallback;
            this.showListOfPercentValuesCheckboxIsVisible = true;
        }
    }]);

    return CustomSettingsSection;
}(_TemplateView3.default);

exports.default = CustomSettingsSection;

/***/ }),
/* 1481 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _ChartParametersFormattingStrategy = __webpack_require__(305);

var _ChartParametersFormattingStrategy2 = _interopRequireDefault(_ChartParametersFormattingStrategy);

var _DateRangeFormattingStrategy = __webpack_require__(165);

var _DateRangeFormattingStrategy2 = _interopRequireDefault(_DateRangeFormattingStrategy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OvertimeParametersFormattingStrategy = function (_ChartParametersForma) {
    _inherits(OvertimeParametersFormattingStrategy, _ChartParametersForma);

    function OvertimeParametersFormattingStrategy() {
        _classCallCheck(this, OvertimeParametersFormattingStrategy);

        return _possibleConstructorReturn(this, (OvertimeParametersFormattingStrategy.__proto__ || Object.getPrototypeOf(OvertimeParametersFormattingStrategy)).apply(this, arguments));
    }

    _createClass(OvertimeParametersFormattingStrategy, [{
        key: "init",
        value: function init(_ref) {
            var selectorsData = _ref.selectorsData,
                dateFormat = _ref.dateFormat,
                reportAuthorizationInfo = _ref.reportAuthorizationInfo;

            _get(OvertimeParametersFormattingStrategy.prototype.__proto__ || Object.getPrototypeOf(OvertimeParametersFormattingStrategy.prototype), "init", this).call(this, { selectorsData: selectorsData, dateFormat: dateFormat, reportAuthorizationInfo: reportAuthorizationInfo });
            return this;
        }
    }, {
        key: "createDateParametersFormattingStrategy",
        value: function createDateParametersFormattingStrategy(config) {
            return new _DateRangeFormattingStrategy2.default(config.dateFormat);
        }
    }, {
        key: "formatParametersText",
        value: function formatParametersText(selectedParameters) {
            return this.parametersFormatter.formatOvertimeUsersSelection(selectedParameters.hierarchicalSelectorsParameters.userSelection);
        }
    }]);

    return OvertimeParametersFormattingStrategy;
}(_ChartParametersFormattingStrategy2.default);

exports.default = OvertimeParametersFormattingStrategy;

/***/ }),
/* 1482 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _ChartParametersFormattingStrategy = __webpack_require__(305);

var _ChartParametersFormattingStrategy2 = _interopRequireDefault(_ChartParametersFormattingStrategy);

var _DateRangeFormattingStrategy = __webpack_require__(165);

var _DateRangeFormattingStrategy2 = _interopRequireDefault(_DateRangeFormattingStrategy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var WorkingHoursCostBillingParametersFormattingStrategy = function (_ChartParametersForma) {
    _inherits(WorkingHoursCostBillingParametersFormattingStrategy, _ChartParametersForma);

    function WorkingHoursCostBillingParametersFormattingStrategy() {
        _classCallCheck(this, WorkingHoursCostBillingParametersFormattingStrategy);

        return _possibleConstructorReturn(this, (WorkingHoursCostBillingParametersFormattingStrategy.__proto__ || Object.getPrototypeOf(WorkingHoursCostBillingParametersFormattingStrategy)).apply(this, arguments));
    }

    _createClass(WorkingHoursCostBillingParametersFormattingStrategy, [{
        key: 'init',
        value: function init(_ref) {
            var selectorsData = _ref.selectorsData,
                dateFormat = _ref.dateFormat,
                reportAuthorizationInfo = _ref.reportAuthorizationInfo;

            _get(WorkingHoursCostBillingParametersFormattingStrategy.prototype.__proto__ || Object.getPrototypeOf(WorkingHoursCostBillingParametersFormattingStrategy.prototype), 'init', this).call(this, { selectorsData: selectorsData, dateFormat: dateFormat, reportAuthorizationInfo: reportAuthorizationInfo });
            return this;
        }
    }, {
        key: 'createDateParametersFormattingStrategy',
        value: function createDateParametersFormattingStrategy(config) {
            return new _DateRangeFormattingStrategy2.default(config.dateFormat);
        }
    }, {
        key: 'formatParametersText',
        value: function formatParametersText(selectedParameters) {
            return this.parametersFormatter.formatUsersSelection(selectedParameters.hierarchicalSelectorsParameters.userSelection) + "; " + this.parametersFormatter.formatCustomersAndProjectsSelection(selectedParameters.hierarchicalSelectorsParameters.customersProjectsSelection);
        }
    }]);

    return WorkingHoursCostBillingParametersFormattingStrategy;
}(_ChartParametersFormattingStrategy2.default);

exports.default = WorkingHoursCostBillingParametersFormattingStrategy;

/***/ }),
/* 1483 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _ChartParametersFormattingStrategy = __webpack_require__(305);

var _ChartParametersFormattingStrategy2 = _interopRequireDefault(_ChartParametersFormattingStrategy);

var _SingleDateFormattingStrategy = __webpack_require__(517);

var _SingleDateFormattingStrategy2 = _interopRequireDefault(_SingleDateFormattingStrategy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BalanceParametersFormattingStrategy = function (_ChartParametersForma) {
    _inherits(BalanceParametersFormattingStrategy, _ChartParametersForma);

    function BalanceParametersFormattingStrategy() {
        _classCallCheck(this, BalanceParametersFormattingStrategy);

        return _possibleConstructorReturn(this, (BalanceParametersFormattingStrategy.__proto__ || Object.getPrototypeOf(BalanceParametersFormattingStrategy)).apply(this, arguments));
    }

    _createClass(BalanceParametersFormattingStrategy, [{
        key: 'init',
        value: function init(_ref) {
            var selectorsData = _ref.selectorsData,
                dateFormat = _ref.dateFormat,
                reportAuthorizationInfo = _ref.reportAuthorizationInfo;

            _get(BalanceParametersFormattingStrategy.prototype.__proto__ || Object.getPrototypeOf(BalanceParametersFormattingStrategy.prototype), 'init', this).call(this, { selectorsData: selectorsData, dateFormat: dateFormat, reportAuthorizationInfo: reportAuthorizationInfo });
            return this;
        }
    }, {
        key: 'createDateParametersFormattingStrategy',
        value: function createDateParametersFormattingStrategy(config) {
            return new _SingleDateFormattingStrategy2.default(config.dateFormat);
        }
    }, {
        key: 'formatParametersText',
        value: function formatParametersText(selectedParameters) {
            return this.parametersFormatter.formatUsersSelection(selectedParameters.hierarchicalSelectorsParameters.userSelection);
        }
    }]);

    return BalanceParametersFormattingStrategy;
}(_ChartParametersFormattingStrategy2.default);

exports.default = BalanceParametersFormattingStrategy;

/***/ }),
/* 1484 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _ChartParametersFormattingStrategy = __webpack_require__(305);

var _ChartParametersFormattingStrategy2 = _interopRequireDefault(_ChartParametersFormattingStrategy);

var _DateRangeFormattingStrategy = __webpack_require__(165);

var _DateRangeFormattingStrategy2 = _interopRequireDefault(_DateRangeFormattingStrategy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LeaveParametersFormattingStrategy = function (_ChartParametersForma) {
    _inherits(LeaveParametersFormattingStrategy, _ChartParametersForma);

    function LeaveParametersFormattingStrategy() {
        _classCallCheck(this, LeaveParametersFormattingStrategy);

        return _possibleConstructorReturn(this, (LeaveParametersFormattingStrategy.__proto__ || Object.getPrototypeOf(LeaveParametersFormattingStrategy)).apply(this, arguments));
    }

    _createClass(LeaveParametersFormattingStrategy, [{
        key: 'init',
        value: function init(_ref) {
            var selectorsData = _ref.selectorsData,
                dateFormat = _ref.dateFormat,
                reportAuthorizationInfo = _ref.reportAuthorizationInfo;

            _get(LeaveParametersFormattingStrategy.prototype.__proto__ || Object.getPrototypeOf(LeaveParametersFormattingStrategy.prototype), 'init', this).call(this, { selectorsData: selectorsData, dateFormat: dateFormat, reportAuthorizationInfo: reportAuthorizationInfo });
            return this;
        }
    }, {
        key: 'createDateParametersFormattingStrategy',
        value: function createDateParametersFormattingStrategy(config) {
            return new _DateRangeFormattingStrategy2.default(config.dateFormat);
        }
    }, {
        key: 'formatParametersText',
        value: function formatParametersText(selectedParameters) {
            return this.parametersFormatter.formatUsersSelection(selectedParameters.hierarchicalSelectorsParameters.userSelection) + "; " + this.parametersFormatter.formatLeaveTypesSelection(selectedParameters.hierarchicalSelectorsParameters.leaveTypeSelection);
        }
    }]);

    return LeaveParametersFormattingStrategy;
}(_ChartParametersFormattingStrategy2.default);

exports.default = LeaveParametersFormattingStrategy;

/***/ }),
/* 1485 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Ext = __webpack_require__(12);

var _Ext2 = _interopRequireDefault(_Ext);

var _atUtils = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CreateChartButton = _Ext2.default.extend(_Ext2.default.Container, {
    buttonText: "",
    clickAction: _Ext2.default.emptyFn,

    autoEl: "div",
    layout: "table",
    buttonClass: "graphicButton createChart button",
    hideOnResize: false,

    initComponent: function initComponent() {
        CreateChartButton.superclass.initComponent.call(this);
        this.baseButton = this.getBaseButton();
        this.add(this.baseButton.button);
    },

    mouseOver: function mouseOver() {
        this.baseButton.hover();
    },

    mouseOut: function mouseOut() {
        this.baseButton.reset();
    },

    afterRender: function afterRender() {
        this.baseButton.button.on("render", function () {
            this.baseButton.defineStandardEventHandlers(false, false, true, true);
            this.baseButton.button.el.on("mouseover", this.mouseOver, this);
            this.baseButton.button.el.on("mouseout", this.mouseOut, this);
            this.baseButton.button.el.on("click", this.baseButtonClick, this);
        }, this);
    },

    baseButtonClick: function baseButtonClick() {
        this.baseButton.deactivate();
        this.clickAction((0, _atUtils.makeHandler)(this.dialogHide, this));
    },

    dialogHide: function dialogHide() {
        this.baseButton.reset();
    },

    getBaseButton: function getBaseButton() {
        return new GraphicButton(new AT.RectangularBox({
            cls: this.buttonClass,
            items: [{
                xtype: "box",
                autoEl: {
                    tag: "div",
                    html: "<div class='icon'></div><span unselectable='on'>" + this.buttonText + "</span>"
                }
            }]
        }));
    }
});

exports.default = CreateChartButton;

/***/ }),
/* 1486 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var SHOW_COUNTDOWN_TIP_LICENSE_DAYS_TO_EXPIRATION = exports.SHOW_COUNTDOWN_TIP_LICENSE_DAYS_TO_EXPIRATION = 15;

var LicenseManagerStatus = exports.LicenseManagerStatus = {
    ACTIVE: 'ACTIVE',
    PENDING_ACCEPTANCE: 'PENDING_ACCEPTANCE',
    DECLINE_ACCEPTANCE: 'DECLINE_ACCEPTANCE',
    REVOKED: 'REVOKED',
    PREDEFINED: 'PREDEFINED',
    DISABLED: 'DISABLED'
};

var licensesType = exports.licensesType = {
    TRIAL: 'trial',
    COMMERCIAL: 'commercial',
    FREE: 'free'
};

/***/ }),
/* 1487 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = checkAndSendLicenseUserEvent;

var _UserEventsMap = __webpack_require__(99);

var _utils = __webpack_require__(6);

var _selectors = __webpack_require__(143);

var _constant = __webpack_require__(1488);

var _LocalStorage = __webpack_require__(72);

var _ClassicBridge = __webpack_require__(18);

var _ClassicBridge2 = _interopRequireDefault(_ClassicBridge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function checkAndSendLicenseUserEvent(isFree) {
    var storage = (0, _LocalStorage.getLocalStorage)();
    var userClickedObtainLicense = storage.getItem(_constant.USER_CLICKED_OBTAIN_LICENSE, true, true);

    if (!userClickedObtainLicense && (0, _utils.unsafe_selectWithState)(_selectors.isLicenseTrial)) {
        storage.setItem(_constant.USER_CLICKED_OBTAIN_LICENSE, true, true, true);
        return _ClassicBridge2.default.sendUserEvent(_UserEventsMap.UserEventsMap.LICENSE_OBTAINED, {
            "Type": isFree ? "Free" : "Commercial"
        }, false).catch(function (e) {
            //ignore event error
        });
    }
    return Promise.resolve();
}

/***/ }),
/* 1488 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var USER_CLICKED_OBTAIN_LICENSE = exports.USER_CLICKED_OBTAIN_LICENSE = 'userClickedObtainLicense';

/***/ }),
/* 1489 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _NameInput = __webpack_require__(370);

var _NameInput2 = _interopRequireDefault(_NameInput);

var _CustomerPanel = __webpack_require__(382);

var _EditActionButton = __webpack_require__(494);

var _EditActionButton2 = _interopRequireDefault(_EditActionButton);

var _constants = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CustomerPanelHeader = function (_TemplateView) {
    _inherits(CustomerPanelHeader, _TemplateView);

    function CustomerPanelHeader($containerEl, $panel) {
        _classCallCheck(this, CustomerPanelHeader);

        var _this = _possibleConstructorReturn(this, (CustomerPanelHeader.__proto__ || Object.getPrototypeOf(CustomerPanelHeader)).call(this, $containerEl));

        _this.$panel = $panel;
        return _this;
    }

    _createClass(CustomerPanelHeader, [{
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='editCustomerPanelHeader'>" + "  <div class='cpInfo'>" + "    <span class='customerName'><%-customers%></span>" + "  </div>" + "  <div class='customerNamePlaceHolder'/>" + "  <div class='actions'></div>" + "  <div class='tabs'>" + "    <div class='details'><span class='tabText'><%=detailsTab%></span></div>" + "    <div class='assignedUsers'><span class='tabText'><%=assignedUsersTab%></span></div>" + "    <div class='managers'><span class='tabText'><%=managersTab%></span></div>" + "    <div class='budgets'><span class='tabText'><%=budgetsTab%></span></div>" + "  </div>" + "</div>";
        }
    }, {
        key: "shouldUpdateOnInit",
        value: function shouldUpdateOnInit() {
            return false;
        }
    }, {
        key: "messageKeys",
        value: function messageKeys() {
            return {
                customers: "common.Customer",
                placeholder: "customer.edit.name.placeholder.text",
                detailsTab: "project.edit_panel.tabs.details",
                assignedUsersTab: 'project.edit_panel.tabs.assigned_users',
                managersTab: 'project.edit_panel.tabs.managers',
                budgetsTab: 'project.edit_panel.tabs.budgets'
            };
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            var _this2 = this;

            this.nameInput = new _NameInput2.default({
                editable: true,
                placeholder: _messageResource2.default.getMessage('customer.edit_popup.name_placeholder'),
                maxLength: _constants.EntityTextLimits.MAX_CPT_NAME,
                onChangeCb: function onChangeCb(name) {
                    if (name !== _this2.customerName && name) {
                        _this2.nameInput.trigger('change', name);
                    }
                    _this2.nameInput.setState({
                        name: name,
                        invalid: !name,
                        focus: !name
                    });
                }
            }).init(this.$containerEl.find('.customerNamePlaceHolder'));

            var $actions = this.$containerEl.find(".actions");
            this.actions = new _EditActionButton2.default({
                panelEl: this.$panel,
                headerEl: this.$containerEl,
                needMove: false,
                needCopy: true,
                needDelete: true,
                copyButtonMessageKey: 'edit_panel.action.copy'
            }).init($actions);

            this.$tabs = [];
            this.$tabs[_CustomerPanel.CustomerPanelTabs.DETAILS_TAB] = this.find('.details');
            this.$tabs[_CustomerPanel.CustomerPanelTabs.ASSIGNED_USERS_TAB] = this.find('.assignedUsers');
            this.$tabs[_CustomerPanel.CustomerPanelTabs.MANAGERS_TAB] = this.find('.managers');
            this.$tabs[_CustomerPanel.CustomerPanelTabs.BUDGETS] = this.find('.budgets');

            this.$assignedUsersTabTitle = this.find(".assignedUsers .tabText");
            this.$managersTabTitle = this.find(".managers .tabText");
        }
    }, {
        key: "update",
        value: function update(config) {
            var name = config.name,
                id = config.id,
                readOnly = config.readOnly;

            this.customerName = name;
            this.nameInput.setEditable(!readOnly); // don't calls update (omg)
            this.nameInput.resetName(name);
            this.id = id;

            this.actions.disableDeleteButton(this.disableDeleteButtonText(config));

            this.actions.hideMenu();

            this.actions.toggle(!readOnly);
        }
    }, {
        key: "disableDeleteButtonText",
        value: function disableDeleteButtonText(config) {
            var disableText = null;
            if (config.blockedDueToLockedTime) {
                disableText = _messageResource2.default.getMessage("customer.edit.cannot_delete_due_to_lock_time");
            } else if (config.blockedDueToUnavailableToModifyTimeTrack) {
                var customerText = _messageResource2.default.getMessage("common.customer");
                disableText = _messageResource2.default.getMessage(config.canManageAllUsersWithoutAutoApproved ? "hierarchy_entity.edit_popup.cannot_delete_due_to_unavailable_modify_time_of_autoapproved_users" : "hierarchy_entity.edit_popup.cannot_delete_due_to_unavailable_modify_time", [customerText]);
            }
            return disableText;
        }
    }]);

    return CustomerPanelHeader;
}(_TemplateView3.default);

exports.default = CustomerPanelHeader;

/***/ }),
/* 1490 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _CustomerPanelDetails = __webpack_require__(1491);

var _CustomerPanelDetails2 = _interopRequireDefault(_CustomerPanelDetails);

var _CommentsSection = __webpack_require__(1492);

var _CommentsSection2 = _interopRequireDefault(_CommentsSection);

var _Description = __webpack_require__(290);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CustomerPanelContent = function (_TemplateView) {
    _inherits(CustomerPanelContent, _TemplateView);

    function CustomerPanelContent(_ref) {
        var _ref$updateDescriptio = _ref.updateDescription,
            updateDescription = _ref$updateDescriptio === undefined ? function () {} : _ref$updateDescriptio,
            _ref$refreshScrollCb = _ref.refreshScrollCb,
            refreshScrollCb = _ref$refreshScrollCb === undefined ? function () {} : _ref$refreshScrollCb,
            _ref$scrollToElementC = _ref.scrollToElementCb,
            scrollToElementCb = _ref$scrollToElementC === undefined ? function () {} : _ref$scrollToElementC;

        _classCallCheck(this, CustomerPanelContent);

        var _this = _possibleConstructorReturn(this, (CustomerPanelContent.__proto__ || Object.getPrototypeOf(CustomerPanelContent)).call(this));

        _this.callbacks = {
            updateDescription: updateDescription,
            refreshScrollCb: refreshScrollCb,
            scrollToElementCb: scrollToElementCb
        };
        return _this;
    }

    _createClass(CustomerPanelContent, [{
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='tab detailsTab'>" + "  <div class='details'/>" + "  <div class='description'>" + "    <div class='title'><%=description%></div>" + "    <div class='descriptionArea'></div>" + "  </div>" + "  <div class='commentsSectionPlaceholder'></div>" + "</div>";
        }
    }, {
        key: "shouldUpdateOnInit",
        value: function shouldUpdateOnInit() {
            return false;
        }
    }, {
        key: "messageKeys",
        value: function messageKeys() {
            return {
                description: "panel.common.description"
            };
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            this.$details = this.$containerEl.find(".details");
            this.details = new _CustomerPanelDetails2.default(this.$details).init();

            this.$description = this.$containerEl.find(".descriptionArea");
            this.description = new _Description.Description({
                onChange: this.callbacks.updateDescription
            }).init(this.$description);
            this.description.setState({
                placeholder: _messageResource2.default.getMessage('customer.edit_panel.description.empty')
            });

            new _CommentsSection2.default({
                refreshScrollCb: this.callbacks.refreshScrollCb,
                scrollToElementCb: this.callbacks.scrollToElementCb
            }).init(this.find('.commentsSectionPlaceholder'));
        }
    }, {
        key: "updateState",
        value: function updateState(_ref2) {
            var readOnly = _ref2.readOnly,
                active = _ref2.active,
                spentTimeValues = _ref2.spentTimeValues,
                description = _ref2.description;

            this.details.setSelectorsDisabled(readOnly);
            this.details.setState({
                active: active,
                readOnly: readOnly,
                spentTimeValues: spentTimeValues
            });

            this.description.setState({
                text: description,
                editable: !readOnly,
                placeholder: readOnly ? _messageResource2.default.getMessage('panel.common.description.no_description') : _messageResource2.default.getMessage('customer.edit_panel.description.empty')
            });
            this.callbacks.refreshScrollCb();
        }
    }, {
        key: "updateLastAudit",
        value: function updateLastAudit(lastUpdateAudit) {
            this.details.setLastAudit(lastUpdateAudit);
        }
    }]);

    return CustomerPanelContent;
}(_TemplateView3.default);

exports.default = CustomerPanelContent;

/***/ }),
/* 1491 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _user_time = __webpack_require__(30);

var _user_time2 = _interopRequireDefault(_user_time);

var _AuditHistoryView = __webpack_require__(228);

var _CustomerStatusButton = __webpack_require__(780);

var _CustomerStatusButton2 = _interopRequireDefault(_CustomerStatusButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CustomerPanelDetails = function (_TemplateView) {
    _inherits(CustomerPanelDetails, _TemplateView);

    function CustomerPanelDetails($containerEl) {
        _classCallCheck(this, CustomerPanelDetails);

        var _this = _possibleConstructorReturn(this, (CustomerPanelDetails.__proto__ || Object.getPrototypeOf(CustomerPanelDetails)).call(this, $containerEl));

        _this.state = {
            active: false,
            readOnly: false,
            spentTimeValues: {}
        };

        _this.onStatePropertyChanged('spentTimeValues', function () {
            _this.updateSpentTime();
        });

        _this.onStatePropertyChanged('readOnly', function () {
            _this.statusButton.setEditable(!_this.state.readOnly);
        });

        _this.onStatePropertyChanged('active', function () {
            _this.statusButton.setActive(_this.state.active);
        });
        return _this;
    }

    _createClass(CustomerPanelDetails, [{
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='auditHistoryPlaceholder'/>" + "<div class='detailsColumn'>" + "  <div class='title'><%=details%></div>" + "  <div class='status'><%=status%></div>" + "  <div class='statusButton'></div>" + "</div>" + "<div class='timeColumn'>" + "  <div class='totalSpentTime'>" + "    <span class='descriptionTime ellipsis'><%-totalTime%></span>" + "    <span class='time'></span>" + "  </div>" + "  <div class='activeProjects'>" + "    <span class='descriptionTime ellipsis'><%-activeTime%></span>" + "    <span class='time'></span>" + "  </div>" + "  <div class='archiveProjects'>" + "    <span class='descriptionTime ellipsis'><%-archiveTime%></span>" + "    <span class='time'></span>" + "  </div>" + "</div>";
        }
    }, {
        key: "messageKeys",
        value: function messageKeys() {
            return {
                totalTime: "customer.edit_panel.total_spent_time",
                activeTime: "customer.edit_panel.active_spent_time",
                archiveTime: "customer.edit_panel.archived_spent_time",
                status: "common.status",
                details: "customer.edit_panel.details"
            };
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            var _this2 = this;

            this.$timeColumn = this.$containerEl.find('.timeColumn');
            this.$totalTime = this.$containerEl.find(".totalSpentTime .time");
            this.$activeTime = this.$containerEl.find(".activeProjects .time");
            this.$archivedTime = this.$containerEl.find(".archiveProjects .time");
            this.$statusButton = this.$containerEl.find(".statusButton");

            this.auditHistory = new _AuditHistoryView.AuditHistoryView({
                extraClass: 'customerAudit'
            }).init(this.$containerEl.find('.auditHistoryPlaceholder'));
            var dateFormat = Date.convertSmartToExtDateFormat(window.SystemSettings.dateFormat).replace(/F/, "M");
            this.auditHistory.setDateFormat(dateFormat);
            this.statusButton = new _CustomerStatusButton2.default({
                editable: true
            }).init(this.$statusButton);

            this.statusButton.on('change', function (e, active) {
                return _this2.setStateInternal({ active: active });
            });
        }
    }, {
        key: "updateSpentTime",
        value: function updateSpentTime() {
            if (this.state.spentTimeValues) {
                this.$timeColumn.show();
                this.$activeTime.text(_user_time2.default.formatTimeWithDigitSeparator(this.state.spentTimeValues.activeProjectsTime));
                this.$totalTime.text(_user_time2.default.formatTimeWithDigitSeparator(this.state.spentTimeValues.spentTime));
                this.$archivedTime.text(_user_time2.default.formatTimeWithDigitSeparator(this.state.spentTimeValues.archivedProjectsTime));
            } else {
                this.$timeColumn.hide();
            }
        }
    }, {
        key: "hideSelectors",
        value: function hideSelectors() {
            this.statusButton.disableAndHide();
        }
    }, {
        key: "setSelectorsDisabled",
        value: function setSelectorsDisabled(disabled) {
            this.statusButton.setDisabled(disabled);
        }
    }, {
        key: "clearAuditHistory",
        value: function clearAuditHistory() {
            this.auditHistory.hide();
        }
    }, {
        key: "setAuditHistory",
        value: function setAuditHistory(createAction, lastUpdateAction) {
            this.auditHistory.setAuditActions(createAction, lastUpdateAction, []);
        }
    }, {
        key: "setLastAudit",
        value: function setLastAudit(lastUpdateAudit) {
            this.auditHistory.setLastAuditAction(lastUpdateAudit);
        }
    }, {
        key: "addAuditRecords",
        value: function addAuditRecords(auditRecords) {
            this.auditHistory.addRecords(auditRecords);
        }
    }, {
        key: "setAuditRecords",
        value: function setAuditRecords(auditRecords) {
            this.auditHistory.setRecords(auditRecords);
        }
    }, {
        key: "hideAuditHistoryMenu",
        value: function hideAuditHistoryMenu() {
            this.auditHistory.auditHistoryMenu.hide();
        }
    }]);

    return CustomerPanelDetails;
}(_TemplateView3.default);

exports.default = CustomerPanelDetails;

/***/ }),
/* 1492 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _redux = __webpack_require__(7);

var _utils = __webpack_require__(6);

var _selectors = __webpack_require__(249);

var _selectors2 = __webpack_require__(19);

var _actions = __webpack_require__(308);

var _CommentsSection = __webpack_require__(487);

var _CommentsSection2 = _interopRequireDefault(_CommentsSection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _utils.connect)(function (state) {
    return {
        comments: (0, _selectors.getComments)(state),
        users: (0, _selectors.getUsers)(state),
        commentsCount: (0, _selectors.getCommentsCount)(state),
        allCommentsUserIds: (0, _selectors.getAllCommentsUserIds)(state),
        loggedInUser: (0, _selectors2.getLoggedInUser)(state),
        isNewCommentsOnTop: (0, _selectors.isNewCommentsOnTop)(state),
        recentlyAddedCommentsIds: (0, _selectors.getRecentlyAddedCommentsIds)(state),
        commentsScrollTo: (0, _selectors.getCommentsScrollTo)(state),
        editingCommentId: (0, _selectors.getEditingCommentId)(state),
        editingCommentText: (0, _selectors.getEditingCommentText)(state),
        loading: (0, _selectors.isCommentsLoading)(state),
        sendingComment: (0, _selectors.isSendingComment)(state),
        updatingCommentId: (0, _selectors.getUpdatingCommentId)(state),
        readOnly: (0, _selectors.isCommentsReadOnly)(state),
        canManage: (0, _selectors.canManage)(state)
    };
}, function (dispatch) {
    return {
        loadMoreComments: (0, _redux.bindActionCreators)(_actions.commentsServiceActions.loadMoreComments, dispatch),
        saveComment: (0, _redux.bindActionCreators)(_actions.commentsServiceActions.saveComment, dispatch),
        deleteComment: (0, _redux.bindActionCreators)(_actions.commentsServiceActions.deleteComment, dispatch),
        changeCommentsOrder: (0, _redux.bindActionCreators)(_actions.commentsActions.changeCommentsOrder, dispatch),
        resetCommentsScrollTo: (0, _redux.bindActionCreators)(_actions.commentsActions.resetCommentsScrollTo, dispatch),
        startEditComment: (0, _redux.bindActionCreators)(_actions.commentsServiceActions.startEditComment, dispatch),
        cancelEditComment: (0, _redux.bindActionCreators)(_actions.commentsActions.cancelEditComment, dispatch),
        updateEditingCommentText: (0, _redux.bindActionCreators)(_actions.commentsActions.updateEditingCommentText, dispatch),
        saveEditingComment: (0, _redux.bindActionCreators)(_actions.commentsServiceActions.saveEditingComment, dispatch)
    };
})(_CommentsSection2.default);

/***/ }),
/* 1493 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.copyCustomerRpcErrorHandler = copyCustomerRpcErrorHandler;

var _ExceptionsTypes = __webpack_require__(107);

var _constants = __webpack_require__(108);

function copyCustomerRpcErrorHandler(rpcError) {
    rpcError.handleOnExceptions([_ExceptionsTypes.NO_RIGHT_TO_EDIT_HIERARCHY_EXCEPTION, _ExceptionsTypes.NO_SUCH_CUSTOMER_EXCEPTION, _constants.Exceptions.NO_RIGHTS_FOR_REMOTE_CALL_EXCEPTION]);
}

/***/ }),
/* 1494 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _DeleteConfirmationDialog = __webpack_require__(499);

var _DeleteConfirmationDialog2 = _interopRequireDefault(_DeleteConfirmationDialog);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DeleteCustomerPopupConfirmationDialog = function (_DeleteConfirmationDi) {
    _inherits(DeleteCustomerPopupConfirmationDialog, _DeleteConfirmationDi);

    function DeleteCustomerPopupConfirmationDialog($container, cancelHandler, deleteHandler, visibleProjectCount, isCustomerActive) {
        _classCallCheck(this, DeleteCustomerPopupConfirmationDialog);

        var _this = _possibleConstructorReturn(this, (DeleteCustomerPopupConfirmationDialog.__proto__ || Object.getPrototypeOf(DeleteCustomerPopupConfirmationDialog)).call(this, $container, cancelHandler, deleteHandler));

        _this.visibleProjectCount = visibleProjectCount;
        _this.isCustomerActive = isCustomerActive;
        return _this;
    }

    _createClass(DeleteCustomerPopupConfirmationDialog, [{
        key: "titleText",
        value: function titleText() {
            var withProjects = "";
            if (this.visibleProjectCount > 0) {
                var projectsCountText = _messageResource2.default.getMessage(this.isCustomerActive ? "common.active_multiple" : "common.archived_multiple", [this.visibleProjectCount]);
                withProjects = _messageResource2.default.getMessage("delete.confirm.dialog.cp.popup.along_with_projects", [projectsCountText]);
            }
            return _messageResource2.default.getMessage("delete.confirm.dialog.cp.popup.customer", [this.state.entityName, withProjects]);
        }
    }, {
        key: "firstOrangeSentence",
        value: function firstOrangeSentence() {
            return _messageResource2.default.getMessage("delete.confirm.dialog.cp.popup.first_orange_sentence", [_messageResource2.default.getMessage("common.Customer")]);
        }
    }, {
        key: "secondOrangeSentence",
        value: function secondOrangeSentence() {
            return _messageResource2.default.getMessage(this.hasTimeTrack() ? "delete.confirm.dialog.cp.second_orange_sentence.please_confirm_actions" : "delete.confirm.dialog.cp.second_orange_sentence.please_confirm");
        }
    }, {
        key: "removeEntitiesPointText",
        value: function removeEntitiesPointText() {
            var pronoun = _messageResource2.default.getMessage("delete.confirm.dialog.their");
            return _messageResource2.default.getMessage("delete.confirm.dialog.cp.remove_entities_point_text.customers_and_projects", [_messageResource2.default.getMessage("common.customer"), pronoun]);
        }
    }, {
        key: "removeTimeTrackPointText",
        value: function removeTimeTrackPointText() {
            return _messageResource2.default.getMessage("delete.confirm.dialog.cp.remove_time_track_point_text");
        }
    }, {
        key: "deleteButtonText",
        value: function deleteButtonText() {
            if (this.hasTimeTrack()) return _messageResource2.default.getMessage("delete.confirm.dialog.delete_task_with_entries");else return _messageResource2.default.getMessage("delete.confirm.dialog.cp.delete_button_text.no_tt");
        }
    }]);

    return DeleteCustomerPopupConfirmationDialog;
}(_DeleteConfirmationDialog2.default);

exports.default = DeleteCustomerPopupConfirmationDialog;

/***/ }),
/* 1495 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _ArchiveDialog2 = __webpack_require__(781);

var _ArchiveDialog3 = _interopRequireDefault(_ArchiveDialog2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ArchiveCustomerDialog = function (_ArchiveDialog) {
    _inherits(ArchiveCustomerDialog, _ArchiveDialog);

    function ArchiveCustomerDialog($container) {
        _classCallCheck(this, ArchiveCustomerDialog);

        return _possibleConstructorReturn(this, (ArchiveCustomerDialog.__proto__ || Object.getPrototypeOf(ArchiveCustomerDialog)).call(this, $container, _messageResource2.default.getMessage("common.customer")));
    }

    return ArchiveCustomerDialog;
}(_ArchiveDialog3.default);

exports.default = ArchiveCustomerDialog;

/***/ }),
/* 1496 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _CopySettingsBlock = __webpack_require__(296);

var _CopySettingsBlock2 = _interopRequireDefault(_CopySettingsBlock);

var _utils = __webpack_require__(297);

var _InformationBlock = __webpack_require__(295);

var _InformationBlock2 = _interopRequireDefault(_InformationBlock);

var _constants = __webpack_require__(4);

var _atUtils = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CopyCustomerDialog = function (_TemplateView) {
    _inherits(CopyCustomerDialog, _TemplateView);

    function CopyCustomerDialog(_ref) {
        var _ref$onCopyCb = _ref.onCopyCb,
            onCopyCb = _ref$onCopyCb === undefined ? function (customerName, settings) {} : _ref$onCopyCb,
            _ref$onCancelCb = _ref.onCancelCb,
            onCancelCb = _ref$onCancelCb === undefined ? function () {} : _ref$onCancelCb;

        _classCallCheck(this, CopyCustomerDialog);

        var _this = _possibleConstructorReturn(this, (CopyCustomerDialog.__proto__ || Object.getPrototypeOf(CopyCustomerDialog)).call(this));

        _this.state = {
            customerName: '',
            copyEnabled: false,

            canManageAccountsAndPermissions: false,
            isBTYEnabled: false,
            isESTEnabled: false,
            isTWSEnabled: false,
            isWASEnabled: false,

            hasSomeTeamAssignment: false
        };

        _this.callbacks = {
            onCopyCb: onCopyCb,
            onCancelCb: onCancelCb
        };

        _this.onStatePropertyChanged('customerName', function (customerName) {
            _this.$title.text(_messageResource2.default.getMessage('customer.copy_dialog.title', [customerName]));
        });

        _this.onAnyStatePropertyChanged(['canManageAccountsAndPermissions', 'isBTYEnabled', 'isESTEnabled', 'isTWSEnabled', 'isWASEnabled', 'hasSomeTeamAssignment'], function () {
            _this.copySettingsBlock.setState((0, _utils.getItemsForCopyCustomerSettingsBlock)(_this.state.canManageAccountsAndPermissions, _this.state.isBTYEnabled, _this.state.isESTEnabled, _this.state.isTWSEnabled, _this.state.isWASEnabled, _this.state.hasSomeTeamAssignment));
        });

        _this.onStatePropertyChanged('copyEnabled', function (enabled) {
            return _this.$el.toggleClass('actionEnabled', enabled);
        });
        return _this;
    }

    _createClass(CopyCustomerDialog, [{
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='copyCustomerDialog moveToDialog'>" + "  <div class='title'></div>" + "    <div class='nameInput'>" + "        <input type='text' maxlength='<%=maxNameLength%>'/>" + "    </div>" + "  <div class='settingsBlockContainer'/>" + "  <div class='informationBlockContainer'/>" + "  <div class='buttonsContainer'>" + "    <div class='ok button'><%=copyLabel%></div>" + "    <div class='cancel button'><%=cancelLabel%></div>" + "  </div>" + "</div>";
        }
    }, {
        key: "messageKeys",
        value: function messageKeys() {
            return {
                copyLabel: "edit_panel.action.copy",
                cancelLabel: "common.cancel"
            };
        }
    }, {
        key: "templateModel",
        value: function templateModel() {
            return {
                maxNameLength: _constants.EntityTextLimits.MAX_CPT_NAME
            };
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            var _this2 = this;

            this.$title = this.find('.title');
            this.$input = this.find('input');

            this.$input.valueChanged(function () {
                return _this2.updateButton();
            });
            this.$input.keyup(function () {
                return _this2.updateButton();
            });

            this.find(".ok.button").click(function () {
                if (_this2.state.copyEnabled) {
                    _this2.callbacks.onCopyCb((0, _atUtils.trim)(_this2.$input.pVal()), _this2.copySettingsBlock.getSelectedSettings());
                }
            });

            this.find(".cancel.button").click(function () {
                (0, _jquery2.default)(_this2).trigger("cancel");
                _this2.callbacks.onCancelCb();
            });

            this.copySettingsBlock = new _CopySettingsBlock2.default().init(this.find('.settingsBlockContainer'));

            new _InformationBlock2.default({
                paragraphs: [_messageResource2.default.getMessage('customer.copy_dialog.info_paragraph')]
            }).init(this.find('.informationBlockContainer'));

            this.renderInitialState();
        }
    }, {
        key: "updateNewCustomerName",
        value: function updateNewCustomerName(name) {
            this.$input.pVal(name);
            this.updateButton();
        }
    }, {
        key: "updateButton",
        value: function updateButton() {
            this.setState({
                copyEnabled: !!this.$input.pVal()
            });
        }
    }]);

    return CopyCustomerDialog;
}(_TemplateView3.default);

exports.default = CopyCustomerDialog;

/***/ }),
/* 1497 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _UserRow = __webpack_require__(1498);

var _UserRow2 = _interopRequireDefault(_UserRow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UserGroup = function () {
    function UserGroup(groupName) {
        _classCallCheck(this, UserGroup);

        this.userRows = [];
        this.groupCell = null;
        this.contentDiv = null;
        this.buildGroupCell(groupName);

        var userGroup = this;

        this.expandCollapseListener = function (userRow) {
            userGroup.updateGroupCellRowspan(userRow);
            userGroup.updateGroupCellHeight();
        };
    }

    _createClass(UserGroup, [{
        key: "createUserRow",
        value: function createUserRow(userId, expandedUsersStorage, today, workingDays) {
            var userRow = new _UserRow2.default(userId, expandedUsersStorage, today, workingDays);
            if (this.userRows.length == 0) {
                userRow.getRowEl().appendChild(this.groupCell);
            }
            this.userRows.push(userRow);
            userRow.addExpandCollapseListener(this.expandCollapseListener);
            return userRow;
        }
    }, {
        key: "buildGroupCell",
        value: function buildGroupCell(groupName) {
            this.groupCell = document.createElement("td");
            this.groupCell.className = "userGroupCell";

            this.contentDiv = document.createElement("div");
            this.contentDiv.className = "groupCellContent";
            this.contentDiv.innerHTML = '<span>' + groupName + '</span>';
            this.groupCell.appendChild(this.contentDiv);
        }
    }, {
        key: "removeBottomBorder",
        value: function removeBottomBorder() {
            this.groupCell.style.borderBottom = "none";
        }
    }, {
        key: "updateGroupCellRowspan",
        value: function updateGroupCellRowspan(collapseExpandRow) {
            if (collapseExpandRow.isExpanded()) {
                this.groupCell.rowSpan += collapseExpandRow.getChildRows().length;
            } else {
                this.groupCell.rowSpan -= collapseExpandRow.getChildRows().length;
            }
        }
    }, {
        key: "updateGroupCellHeight",
        value: function updateGroupCellHeight() {
            this.contentDiv.style.height = "auto";
            this.contentDiv.style.height = this.groupCell.clientHeight;
        }
    }, {
        key: "fitHeightOnBuildDomComplete",
        value: function fitHeightOnBuildDomComplete() {
            var rowspan = 0;
            for (var i = 0; i < this.userRows.length; i++) {
                rowspan += 1;
                if (this.userRows[i].isExpanded()) {
                    rowspan += this.userRows[i].getChildRows().length;
                }
            }
            this.groupCell.rowSpan = rowspan;

            this.updateGroupCellHeight();
        }
    }]);

    return UserGroup;
}();

exports.default = UserGroup;

/***/ }),
/* 1498 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _LockTableRow2 = __webpack_require__(309);

var _LockTableRow3 = _interopRequireDefault(_LockTableRow2);

var _UserNameCellRenderer = __webpack_require__(1499);

var _UserNameCellRenderer2 = _interopRequireDefault(_UserNameCellRenderer);

var _OvertimeRow = __webpack_require__(809);

var _OvertimeRow2 = _interopRequireDefault(_OvertimeRow);

var _UserLeavesRow = __webpack_require__(1502);

var _UserLeavesRow2 = _interopRequireDefault(_UserLeavesRow);

var _UserDayCellRenderer = __webpack_require__(1505);

var _UserDayCellRenderer2 = _interopRequireDefault(_UserDayCellRenderer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UserRow = function (_LockTableRow) {
    _inherits(UserRow, _LockTableRow);

    function UserRow(userId, expandedUsersStorage, today, workdayDurations) {
        _classCallCheck(this, UserRow);

        var _this = _possibleConstructorReturn(this, (UserRow.__proto__ || Object.getPrototypeOf(UserRow)).call(this));

        _this.childRows = [];
        _this.userId = userId;
        _this.expandedUsersStorage = expandedUsersStorage;
        _this.expanded = expandedUsersStorage.contains(userId);
        _this.expandCollapseDisabled = false;
        _this.expandCollapseListeners = [];
        _this.today = today;
        _this.workdayDurations = workdayDurations;
        return _this;
    }

    _createClass(UserRow, [{
        key: "createRowHeaderRenderer",
        value: function createRowHeaderRenderer() {
            return new _UserNameCellRenderer2.default();
        }
    }, {
        key: "createLockCellRenderer",
        value: function createLockCellRenderer() {
            return new _UserDayCellRenderer2.default();
        }
    }, {
        key: "disableExpandCollapse",
        value: function disableExpandCollapse(disable) {
            this.expandCollapseDisabled = disable;
        }
    }, {
        key: "addExpandCollapseListener",
        value: function addExpandCollapseListener(listener) {
            this.expandCollapseListeners.push(listener);
        }
    }, {
        key: "isExpanded",
        value: function isExpanded() {
            return this.expanded;
        }
    }, {
        key: "addChildRow",
        value: function addChildRow(row) {
            this.childRows.push(row);
            row.setParentRow(this);
            row.setTable(this.getTable());
            row.showHide(this.expanded);
            if (row instanceof _OvertimeRow2.default && !this.overtimeRow) this.overtimeRow = row;
        }
    }, {
        key: "getChildRows",
        value: function getChildRows() {
            return this.childRows;
        }
    }, {
        key: "getLastChildRow",
        value: function getLastChildRow() {
            if (this.childRows.length > 0) return this.childRows[this.childRows.length - 1];else return null;
        }
    }, {
        key: "expand",
        value: function expand() {
            if (!this.expanded) this.changeExpandCollapse();
        }
    }, {
        key: "collapse",
        value: function collapse() {
            if (this.expanded) this.changeExpandCollapse();
        }
    }, {
        key: "changeExpandCollapse",
        value: function changeExpandCollapse() {
            if (this.childRows.length == 0 || this.expandCollapseDisabled) return;

            this.expanded = !this.expanded;

            if (this.expanded) this.expandedUsersStorage.add(this.userId);else this.expandedUsersStorage.remove(this.userId);

            this.updateUI();
            for (var i = 0; i < this.expandCollapseListeners.length; i++) {
                this.expandCollapseListeners[i](this);
            }
        }
    }, {
        key: "accept",
        value: function accept(visitor, cell) {
            return visitor.visitUserRow(cell);
        }
    }, {
        key: "updateUI",
        value: function updateUI() {
            for (var i = 0; i < this.childRows.length; i++) {
                this.childRows[i].showHide(this.expanded);
            }

            for (i = 0; i < this.cells.length; i++) {
                this.updateCellUI(i);
            }
        }
    }, {
        key: "createUserLeavesRow",
        value: function createUserLeavesRow(headerText) {
            this.userLeavesRow = new _UserLeavesRow2.default();
            this.userLeavesRow.addCell(headerText);
            this.addChildRow(this.userLeavesRow);
            this.getTable().addRow(this.userLeavesRow);
            return this.userLeavesRow;
        }
    }, {
        key: "getUserLeavesRow",
        value: function getUserLeavesRow() {
            return this.userLeavesRow;
        }
    }, {
        key: "getUserLeaveInfo",
        value: function getUserLeaveInfo(cellIdx) {
            if (this.userLeavesRow) return this.userLeavesRow.getCell(cellIdx).getValue();

            return { time: 0, leaveInfo: undefined };
        }
    }, {
        key: "getUserOvertimeInfo",
        value: function getUserOvertimeInfo(cellIdx) {
            if (this.overtimeRow) return this.overtimeRow.getCell(cellIdx).getValue();else return 0;
        }
    }, {
        key: "isTodayCell",
        value: function isTodayCell(cell) {
            return this.getTable().getDatesRow().getCell(cell.getColIdx()).getValue().date.getTime() == this.today.getTime();
        }
    }, {
        key: "isHolidayCell",
        value: function isHolidayCell(cell) {
            return this.workdayDurations[cell.getColIdx() - 1] == 0; // -1 because of one header column
        }
    }]);

    return UserRow;
}(_LockTableRow3.default);

exports.default = UserRow;

/***/ }),
/* 1499 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _LockTableCellRenderer = __webpack_require__(123);

var _LockTableCellRenderer2 = _interopRequireDefault(_LockTableCellRenderer);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _atUtils = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UserNameCellRenderer = function (_LockTableCellRendere) {
    _inherits(UserNameCellRenderer, _LockTableCellRendere);

    function UserNameCellRenderer() {
        _classCallCheck(this, UserNameCellRenderer);

        return _possibleConstructorReturn(this, (UserNameCellRenderer.__proto__ || Object.getPrototypeOf(UserNameCellRenderer)).apply(this, arguments));
    }

    _createClass(UserNameCellRenderer, [{
        key: "generateContent",
        value: function generateContent(cell) {
            var userBean = cell.getValue();
            var cellRow = cell.getRow();

            var expandCollapseDivClassNames = [];
            var expandCollapseDiv = document.createElement("div");
            if (cellRow.getChildRows().length > 0) {
                expandCollapseDivClassNames.push("expandCollapse");
                expandCollapseDiv.onclick = function () {
                    cellRow.changeExpandCollapse();
                };
            } else if (!cellRow.hasData) {
                cell.getCellEl().title = _messageResource2.default.getMessage("lock_tt.table.tooltip.user_without_tt");
                if (!LockTTStore.isHideDetailsOnLockTT()) {
                    expandCollapseDivClassNames.push("userWithoutTt");
                }
            }

            if (userBean.isActive()) expandCollapseDivClassNames.push("activeUserName");
            expandCollapseDivClassNames.push("lockTableEllipsis");

            expandCollapseDiv.className = expandCollapseDivClassNames.join(" ");
            expandCollapseDiv.innerHTML = ['&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;', (0, _atUtils.escapeHtmlSymbols)(userBean.formatNameLFM())].join('');
            cell.getCellEl().appendChild(expandCollapseDiv);
        }
    }, {
        key: "getCellClassName",
        value: function getCellClassName(cell) {
            var cssClass = "userCell";
            if (this.getSelectionController(cell).isRowIncludedIntoSelection(cell.getRow().getRowIdx())) cssClass += "MarkSelection";
            if (cell.getRow().isExpanded()) cssClass += "Expanded";

            return cssClass;
        }
    }]);

    return UserNameCellRenderer;
}(_LockTableCellRenderer2.default);

exports.default = UserNameCellRenderer;

/***/ }),
/* 1500 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _LockTableCellRenderer = __webpack_require__(123);

var _LockTableCellRenderer2 = _interopRequireDefault(_LockTableCellRenderer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OvertimeCellRenderer = function (_LockTableCellRendere) {
    _inherits(OvertimeCellRenderer, _LockTableCellRendere);

    function OvertimeCellRenderer(topBorderClass, cssAdditionalClass) {
        _classCallCheck(this, OvertimeCellRenderer);

        var _this = _possibleConstructorReturn(this, (OvertimeCellRenderer.__proto__ || Object.getPrototypeOf(OvertimeCellRenderer)).call(this));

        _this.topBorderClass = topBorderClass;
        _this.cssAdditionalClass = cssAdditionalClass;
        return _this;
    }

    _createClass(OvertimeCellRenderer, [{
        key: "generateContent",
        value: function generateContent(cell) {
            cell.getCellEl().innerHTML = "<div>" + cell.getValue() + "</div>";
        }
    }, {
        key: "getTopBorderClassName",
        value: function getTopBorderClassName(cell) {
            return this.topBorderClass;
        }
    }, {
        key: "getComplicatedBorderClassName",
        value: function getComplicatedBorderClassName(cell) {
            var firstRow = cell.getRow().isFirstChildRow();
            var lastRow = cell.getRow().isLastChildRow();
            if (firstRow || lastRow) return firstRow && lastRow ? "singleDetailsRow" : firstRow ? "firstDetailsRow" : "lastDetailsRow";else return "";
        }
    }, {
        key: "getCellClassName",
        value: function getCellClassName(cell) {
            return "overtimeCell " + this.cssAdditionalClass;
        }
    }]);

    return OvertimeCellRenderer;
}(_LockTableCellRenderer2.default);

exports.default = OvertimeCellRenderer;

/***/ }),
/* 1501 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _DayDetailsCellRenderer = __webpack_require__(383);

var _DayDetailsCellRenderer2 = _interopRequireDefault(_DayDetailsCellRenderer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OvertimeDayDetailsCellRenderer = function (_DayDetailsCellRender) {
    _inherits(OvertimeDayDetailsCellRenderer, _DayDetailsCellRender);

    function OvertimeDayDetailsCellRenderer(cssBaseClass, cssTopBorderClass, cssAdditionalClass) {
        _classCallCheck(this, OvertimeDayDetailsCellRenderer);

        var _this = _possibleConstructorReturn(this, (OvertimeDayDetailsCellRenderer.__proto__ || Object.getPrototypeOf(OvertimeDayDetailsCellRenderer)).call(this, cssBaseClass, cssTopBorderClass));

        _this.cssAdditionalClass = cssAdditionalClass;
        return _this;
    }

    _createClass(OvertimeDayDetailsCellRenderer, [{
        key: "getCellClassName",
        value: function getCellClassName(cell) {
            var baseClass = _DayDetailsCellRenderer2.default.prototype.getCellClassName.call(this, cell);
            return baseClass + " " + this.cssAdditionalClass;
        }
    }, {
        key: "addTooltip",
        value: function addTooltip(cell) {
            cell.getRow().getTable().getTooltipController().addDayTooltip(cell.getCellEl(), cell.getRow().getParentRow().getHeaderCell().getValue().id, cell.getRow().getTable().getDatesRow().getCell(cell.getColIdx()).getValue().date, undefined, { showOvertimeWhenZero: true, time: cell.getValue(), showTime: false, overtimeText: cell.getRow().getHeaderCell().getValue() }, cell.getRow().getParentRow().getCell(cell.getColIdx()).getValue());
        }
    }]);

    return OvertimeDayDetailsCellRenderer;
}(_DayDetailsCellRenderer2.default);

exports.default = OvertimeDayDetailsCellRenderer;

/***/ }),
/* 1502 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _DetailsRow2 = __webpack_require__(520);

var _DetailsRow3 = _interopRequireDefault(_DetailsRow2);

var _LeaveNameCellRenderer = __webpack_require__(1503);

var _LeaveNameCellRenderer2 = _interopRequireDefault(_LeaveNameCellRenderer);

var _LeaveTimeCellRenderer = __webpack_require__(1504);

var _LeaveTimeCellRenderer2 = _interopRequireDefault(_LeaveTimeCellRenderer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UserLeavesRow = function (_DetailsRow) {
    _inherits(UserLeavesRow, _DetailsRow);

    function UserLeavesRow() {
        _classCallCheck(this, UserLeavesRow);

        return _possibleConstructorReturn(this, (UserLeavesRow.__proto__ || Object.getPrototypeOf(UserLeavesRow)).apply(this, arguments));
    }

    _createClass(UserLeavesRow, [{
        key: "createRowHeaderRenderer",
        value: function createRowHeaderRenderer() {
            return new _LeaveNameCellRenderer2.default();
        }
    }, {
        key: "createLockCellRenderer",
        value: function createLockCellRenderer() {
            return new _LeaveTimeCellRenderer2.default("odd DayDetailsCell", this.isFirstChildRow() ? "detailsRowSeparator" : "leaveDetailsCellTopBorder");
        }
    }, {
        key: "addValueToCell",
        value: function addValueToCell(colIdx, leaveInfoWithTime) {
            var cell = this.getCell(colIdx);
            if (!cell) this.addCell(leaveInfoWithTime);else if (leaveInfoWithTime.time > 0) {
                cell.setValue(leaveInfoWithTime);
            }
        }
    }]);

    return UserLeavesRow;
}(_DetailsRow3.default);

exports.default = UserLeavesRow;

/***/ }),
/* 1503 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _LockTableCellRenderer = __webpack_require__(123);

var _LockTableCellRenderer2 = _interopRequireDefault(_LockTableCellRenderer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LeaveNameCellRenderer = function (_LockTableCellRendere) {
    _inherits(LeaveNameCellRenderer, _LockTableCellRendere);

    function LeaveNameCellRenderer() {
        _classCallCheck(this, LeaveNameCellRenderer);

        return _possibleConstructorReturn(this, (LeaveNameCellRenderer.__proto__ || Object.getPrototypeOf(LeaveNameCellRenderer)).apply(this, arguments));
    }

    _createClass(LeaveNameCellRenderer, [{
        key: "generateContent",
        value: function generateContent(cell) {
            cell.getCellEl().innerHTML = ["<span class='lockTableEllipsis'>", cell.getValue(), "</span>"].join("");
        }
    }, {
        key: "getTopBorderClassName",
        value: function getTopBorderClassName(cell) {
            if (cell.getRow().isFirstChildRow()) return "detailsRowSeparator";else return "leaveNameTopBorder";
        }
    }, {
        key: "getComplicatedBorderClassName",
        value: function getComplicatedBorderClassName(cell) {
            var firstRow = cell.getRow().isFirstChildRow();
            var lastRow = cell.getRow().isLastChildRow();
            if (firstRow || lastRow) return firstRow && lastRow ? "singleDetailsRow" : firstRow ? "firstDetailsRow" : "lastDetailsRow";else return "";
        }
    }, {
        key: "getCellClassName",
        value: function getCellClassName(cell) {
            return "leaveNameCell";
        }
    }]);

    return LeaveNameCellRenderer;
}(_LockTableCellRenderer2.default);

exports.default = LeaveNameCellRenderer;

/***/ }),
/* 1504 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _DayDetailsCellRenderer = __webpack_require__(383);

var _DayDetailsCellRenderer2 = _interopRequireDefault(_DayDetailsCellRenderer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LeaveTimeCellRenderer = function (_DayDetailsCellRender) {
    _inherits(LeaveTimeCellRenderer, _DayDetailsCellRender);

    function LeaveTimeCellRenderer(cssBaseClass, cssTopBorderClass) {
        _classCallCheck(this, LeaveTimeCellRenderer);

        return _possibleConstructorReturn(this, (LeaveTimeCellRenderer.__proto__ || Object.getPrototypeOf(LeaveTimeCellRenderer)).call(this, cssBaseClass, cssTopBorderClass));
    }

    _createClass(LeaveTimeCellRenderer, [{
        key: "buildContent",
        value: function buildContent(cell) {
            if (cell.getValue().time > 0) cell.getCellEl().innerHTML = "<img src='" + cell.getValue().leaveInfo.printIconPath + "' class='for-print-only leavePrintIcon'/>" + this.parseTime(cell.getValue().time);else cell.getCellEl().innerHTML = this.parseTime(cell.getValue().time);
        }
    }, {
        key: "addTooltip",
        value: function addTooltip(cell) {
            var leaveInfo = cell.getValue();
            cell.getRow().getTable().getTooltipController().addLeaveTooltip(cell.getCellEl(), cell.getRow().getParentRow().getHeaderCell().getValue().id, cell.getRow().getTable().getDatesRow().getCell(cell.getColIdx()).getValue().date, leaveInfo, cell.getRow().getParentRow().getCell(cell.getColIdx()).getValue());
        }
    }]);

    return LeaveTimeCellRenderer;
}(_DayDetailsCellRenderer2.default);

exports.default = LeaveTimeCellRenderer;

/***/ }),
/* 1505 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _DayCellRenderer2 = __webpack_require__(810);

var _DayCellRenderer3 = _interopRequireDefault(_DayCellRenderer2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UserDayCellRenderer = function (_DayCellRenderer) {
    _inherits(UserDayCellRenderer, _DayCellRenderer);

    function UserDayCellRenderer() {
        _classCallCheck(this, UserDayCellRenderer);

        return _possibleConstructorReturn(this, (UserDayCellRenderer.__proto__ || Object.getPrototypeOf(UserDayCellRenderer)).apply(this, arguments));
    }

    _createClass(UserDayCellRenderer, [{
        key: "buildContent",
        value: function buildContent(cell) {
            cell.getCellEl().innerHTML = this.parseTime(cell.getValue().actuals);
        }
    }, {
        key: "addTooltip",
        value: function addTooltip(cell) {
            cell.getRow().getTable().getTooltipController().addDayTooltip(cell.getCellEl(), cell.getRow().getHeaderCell().getValue().id, cell.getRow().getTable().getDatesRow().getCell(cell.getColIdx()).getValue().date, cell.getRow().getUserLeaveInfo(cell.getColIdx()), { showOvertimeWhenZero: false, time: cell.getRow().getUserOvertimeInfo(cell.getColIdx()), showTime: true }, cell.getValue());
        }
    }, {
        key: "getCellClassName",
        value: function getCellClassName(cell) {
            var className = ["userDayCell"];

            if (cell.getRow().isTodayCell(cell)) className.push("Today");else if (cell.getRow().isHolidayCell(cell)) className.push("Holiday");

            if (cell.getValue().locked) className.push("Locked");

            if (cell.getRow().isExpanded()) className.push("Expanded");

            if (this.isSelected(cell)) className.push("Selected");else if (this.isHovered(cell)) className.push("Hover");

            if (cell.getValue().approveInfo && (cell.getValue().approveInfo.approved || cell.getValue().approveInfo.autoApproved)) className.push("Approved");
            return className.join(" ");
        }
    }]);

    return UserDayCellRenderer;
}(_DayCellRenderer3.default);

exports.default = UserDayCellRenderer;

/***/ }),
/* 1506 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _LockTableRow2 = __webpack_require__(309);

var _LockTableRow3 = _interopRequireDefault(_LockTableRow2);

var _DateCellRenderer = __webpack_require__(1507);

var _DateCellRenderer2 = _interopRequireDefault(_DateCellRenderer);

var _EmptyCellRenderer = __webpack_require__(811);

var _EmptyCellRenderer2 = _interopRequireDefault(_EmptyCellRenderer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DatesRow = function (_LockTableRow) {
    _inherits(DatesRow, _LockTableRow);

    function DatesRow(weekDayNames) {
        _classCallCheck(this, DatesRow);

        var _this = _possibleConstructorReturn(this, (DatesRow.__proto__ || Object.getPrototypeOf(DatesRow)).call(this));

        _this.cellRenderer = new _DateCellRenderer2.default(weekDayNames);
        return _this;
    }

    _createClass(DatesRow, [{
        key: "createRowHeaderRenderer",
        value: function createRowHeaderRenderer() {
            return new _EmptyCellRenderer2.default();
        }
    }, {
        key: "createLockCellRenderer",
        value: function createLockCellRenderer() {
            return this.cellRenderer;
        }
    }, {
        key: "accept",
        value: function accept(visitor, cell) {
            return visitor.visitDatesRow(cell);
        }
    }, {
        key: "updateSelectionMarks",
        value: function updateSelectionMarks(updateRegion) {
            for (var colIdx = updateRegion.colMin; colIdx <= updateRegion.colMax; colIdx++) {
                var cell = this.getCell(colIdx);
                cell.getRenderer().updateSelectionMarks(cell);
            }
        }
    }]);

    return DatesRow;
}(_LockTableRow3.default);

exports.default = DatesRow;

/***/ }),
/* 1507 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _LockTableCellRenderer = __webpack_require__(123);

var _LockTableCellRenderer2 = _interopRequireDefault(_LockTableCellRenderer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DateCellRenderer = function (_LockTableCellRendere) {
    _inherits(DateCellRenderer, _LockTableCellRendere);

    function DateCellRenderer(weekDayNames) {
        _classCallCheck(this, DateCellRenderer);

        var _this = _possibleConstructorReturn(this, (DateCellRenderer.__proto__ || Object.getPrototypeOf(DateCellRenderer)).call(this));

        _this.weekDayNames = weekDayNames;
        return _this;
    }

    _createClass(DateCellRenderer, [{
        key: 'generateContent',
        value: function generateContent(cell) {
            var dateInfo = cell.getValue();
            cell.getCellEl().innerHTML = '<div class="columnWidthStrut"></div>' + this.weekDayNames[dateInfo.date.getDay()] + '<br/>' + dateInfo.date.getDate();
        }
    }, {
        key: 'getCellClassName',
        value: function getCellClassName(cell) {
            var result = ["dateCell"];

            if (cell.getRow().isViewerTodayCell(cell)) result.push("Today");

            if (this.isSelected(cell)) result.push("Selected");else if (this.isHovered(cell)) result.push("Hovered");else {
                if (!cell.getValue().working) result.push("Non");
                result.push("Working");

                if (this.isColumnIncludedIntoSelection(cell)) result.push("MarkSelection");
            }

            return result.join("");
        }
    }, {
        key: 'getLastCellRightBorderClassName',
        value: function getLastCellRightBorderClassName() {
            return "lockTableLightRightBorder";
        }
    }, {
        key: 'isColumnIncludedIntoSelection',
        value: function isColumnIncludedIntoSelection(cell) {
            return this.getSelectionController(cell).isColumnIncludedIntoSelection(cell.getColIdx());
        }
    }]);

    return DateCellRenderer;
}(_LockTableCellRenderer2.default);

exports.default = DateCellRenderer;

/***/ }),
/* 1508 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _LockTableRow2 = __webpack_require__(309);

var _LockTableRow3 = _interopRequireDefault(_LockTableRow2);

var _EmptyCellRenderer = __webpack_require__(811);

var _EmptyCellRenderer2 = _interopRequireDefault(_EmptyCellRenderer);

var _RunnerCellRenderer = __webpack_require__(1509);

var _RunnerCellRenderer2 = _interopRequireDefault(_RunnerCellRenderer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RunnerRow = function (_LockTableRow) {
    _inherits(RunnerRow, _LockTableRow);

    function RunnerRow() {
        _classCallCheck(this, RunnerRow);

        return _possibleConstructorReturn(this, (RunnerRow.__proto__ || Object.getPrototypeOf(RunnerRow)).apply(this, arguments));
    }

    _createClass(RunnerRow, [{
        key: "createRowHeaderRenderer",
        value: function createRowHeaderRenderer() {
            return new _EmptyCellRenderer2.default();
        }
    }, {
        key: "createLockCellRenderer",
        value: function createLockCellRenderer() {
            return new _RunnerCellRenderer2.default();
        }
    }, {
        key: "accept",
        value: function accept(visitor, cell) {
            return visitor.visitRunnerRow(cell);
        }
    }]);

    return RunnerRow;
}(_LockTableRow3.default);

exports.default = RunnerRow;

/***/ }),
/* 1509 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _LockTableCellRenderer = __webpack_require__(123);

var _LockTableCellRenderer2 = _interopRequireDefault(_LockTableCellRenderer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RunnerCellRenderer = function (_LockTableCellRendere) {
    _inherits(RunnerCellRenderer, _LockTableCellRendere);

    function RunnerCellRenderer() {
        _classCallCheck(this, RunnerCellRenderer);

        return _possibleConstructorReturn(this, (RunnerCellRenderer.__proto__ || Object.getPrototypeOf(RunnerCellRenderer)).apply(this, arguments));
    }

    _createClass(RunnerCellRenderer, [{
        key: "generateContent",
        value: function generateContent(cell) {
            cell.getCellEl().innerHTML = '<div class="runnerCellStateImg"><div class="runnerCellArrow"></div></div>';
        }
    }, {
        key: "getCellClassName",
        value: function getCellClassName(cell) {
            return [this.getBackgroundClass(cell), this.getStateImgClass(cell), this.getArrowClass(cell)].join(" ");
        }
    }, {
        key: "getBackgroundClass",
        value: function getBackgroundClass(cell) {
            if (this.isStateChanging(cell)) return "runnerCellStateChanging";

            if (cell.getValue().runnerOver) return "runnerCellLocked";

            if (cell.getRow().isViewerTodayCell(cell)) return "runnerCellToday";

            if (cell.getValue().working) return "runnerCellWorking";else return "runnerCellNonworking";
        }
    }, {
        key: "getStateImgClass",
        value: function getStateImgClass(cell) {
            if (this.isStateChanging(cell)) {
                if (cell.getValue().runnerOver) return "unlockingImg";else if (this.isNewLastLocked(cell)) return "lastLockingImg";else return "lockingImg";
            } else if (this.isHighlighted(cell) || this.isOldLastLocked(cell)) {
                return "lastLockedImg";
            }

            return "";
        }
    }, {
        key: "getArrowClass",
        value: function getArrowClass(cell) {
            if (this.isHighlighted(cell)) {
                if (this.isNewLastLocked(cell) || this.isOldLastLocked(cell)) {
                    if (!this.isStateChanging(cell)) return "lockArrowHoverBg";else if (cell.getValue().working) return "hoverArrowWorkingBg";else return "hoverArrowDayoffBg";
                }
            } else if (this.isOldLastLocked(cell)) {
                if (cell.getValue().working) return "lockArrowWorkingBg";else return "lockArrowDayoffBg";
            }

            return "";
        }
    }, {
        key: "isStateChanging",
        value: function isStateChanging(cell) {
            if (this.isHighlighted(cell)) {
                var newLastLockDate = this.getRunnerController(cell).getNewLastLockDate();
                if (newLastLockDate != null) {
                    var isCurrentlyUnlocked = newLastLockDate < cell.getValue().date;
                    return isCurrentlyUnlocked != !cell.getValue().runnerOver;
                }
            }
        }
    }, {
        key: "getLastCellRightBorderClassName",
        value: function getLastCellRightBorderClassName() {
            return "lockTableLightRightBorder";
        }
    }, {
        key: "getRunnerController",
        value: function getRunnerController(cell) {
            return cell.getRow().getTable().getRunnerController();
        }
    }, {
        key: "isHighlighted",
        value: function isHighlighted(cell) {
            return this.isHovered(cell) || this.getRunnerController(cell).isSelected(cell);
        }
    }, {
        key: "isNewLastLocked",
        value: function isNewLastLocked(cell) {
            return this.getRunnerController(cell).isNewLastLocked(cell);
        }
    }, {
        key: "isOldLastLocked",
        value: function isOldLastLocked(cell) {
            var lastLockedDate = this.getRunnerController(cell).getLastLockedDate();
            if (lastLockedDate != null) return lastLockedDate.getTime() == cell.getValue().date.getTime();else return false;
        }
    }]);

    return RunnerCellRenderer;
}(_LockTableCellRenderer2.default);

exports.default = RunnerCellRenderer;

/***/ }),
/* 1510 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.addHeaderCells = addHeaderCells;
exports.buildUsersHeaderCell = buildUsersHeaderCell;
exports.buildMonthRow = buildMonthRow;
exports.createMonthCell = createMonthCell;
exports.addUserRow = addUserRow;
exports.addLeaveTypeToUserRow = addLeaveTypeToUserRow;
exports.addTaskRow = addTaskRow;
exports.addOvertimeRow = addOvertimeRow;
exports.addOtherTasksRow = addOtherTasksRow;
exports.addSeparateRow = addSeparateRow;
exports.addBottomBorderRow = addBottomBorderRow;

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _OvertimeRow = __webpack_require__(809);

var _OvertimeRow2 = _interopRequireDefault(_OvertimeRow);

var _OtherTasksRow = __webpack_require__(1511);

var _OtherTasksRow2 = _interopRequireDefault(_OtherTasksRow);

var _UserGroupsSeparateRow = __webpack_require__(1514);

var _UserGroupsSeparateRow2 = _interopRequireDefault(_UserGroupsSeparateRow);

var _DisabledUsersSeparateRow = __webpack_require__(1516);

var _DisabledUsersSeparateRow2 = _interopRequireDefault(_DisabledUsersSeparateRow);

var _InactiveRow = __webpack_require__(521);

var _InactiveRow2 = _interopRequireDefault(_InactiveRow);

var _TaskRow = __webpack_require__(813);

var _TaskRow2 = _interopRequireDefault(_TaskRow);

var _LockTableDayInfo = __webpack_require__(1521);

var _LockTableDayInfo2 = _interopRequireDefault(_LockTableDayInfo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function addHeaderCells(datesRow, runnerRow, date, isWorking, isRunnerOver, hasLockedInvisibleUser, hasUnlockedInvisibleUser) {
    var dayInfo = new _LockTableDayInfo2.default(date, isWorking, isRunnerOver, hasLockedInvisibleUser, hasUnlockedInvisibleUser);
    datesRow.addCell(dayInfo);
    runnerRow.addCell(dayInfo);
} /*
   * Utility js functions to simplify lock table structure creation. (used by lock_table.jsp)
   *
   */
function buildUsersHeaderCell(lockTable, note, topMessage, sortByLink, showDetails) {
    window.expandAllUserRows = function () {
        var userRows = lockTable.getUserRows();
        for (var i = 0; i < userRows.length; i++) {
            var userRow = userRows[i];
            if (!userRow.isExpanded()) userRow.expand();
        }
    };
    window.collapseAllUserRows = function () {
        var userRows = lockTable.getUserRows();
        for (var i = 0; i < userRows.length; i++) {
            var userRow = userRows[i];
            if (userRow.isExpanded()) userRow.collapse();
        }
    };

    var td = document.createElement("td");
    td.rowSpan = 3;
    td.className = "userTasksHeaderCell";
    var content = ['<span class="sortByCaption">', topMessage, '</span>', '<br/>', '<div class="expandCollapseAllContainer">'];

    if (showDetails) {
        content.push('<a href="javascript:void(0);" onclick="expandAllUserRows()" class="expandCollapseAll noprint">', _messageResource2.default.getMessage("lock_tt.table.header.expand_all"), '</a>&nbsp;&nbsp;', '<a href="javascript:void(0);" onclick="collapseAllUserRows()" class="expandCollapseAll noprint">', _messageResource2.default.getMessage("lock_tt.table.header.collapse_all"), '</a>');
    }

    content.push(sortByLink, '</div>');

    if (note) {
        content.push('<div class="disabledUsersNote noteContainer">');
        content.push('<img src="');
        content.push(note.imgPath);
        content.push('" class="noteImage"/>');
        content.push('<span class="notemsg">');
        content.push(note.text);
        content.push('</span>');
        content.push('</div>');
    }
    content.push('<div class="rowHeaderWidthStrut"></div>');

    td.innerHTML = content.join('');
    return td;
}

function buildMonthRow(lockTable, monthArray, canGotoNextWeek, note, topMessage, sortByLink, showDetails) {
    var row = document.createElement("tr");
    lockTable.getTBody().appendChild(row);

    //user group column
    var td = document.createElement("td");
    td.id = "userEmptyHeaderCell";
    td.rowSpan = 3;
    row.appendChild(td);

    row.appendChild(buildUsersHeaderCell(lockTable, note, topMessage, sortByLink, showDetails));

    for (var i = 0; i < monthArray.length; i++) {
        var month = monthArray[i];
        var lastMonthCell = i == monthArray.length - 1;
        td = createMonthCell(month.description, month.datesInMonth, lastMonthCell);
        if (i == 0) {
            var div = document.createElement("div");
            div.className = 'gotoPrevWeekLinkContainer noprint';
            div.innerHTML = ['<div class="gotoPrevWeekLinkPosition">', '<a class="scrollWeekLink" href="javascript:gotoPrevWeek();" title="', _messageResource2.default.getMessage("lock_tt.table.tooltip.7_days_back"), '">', '</a>', '</div>'].join("");
            td.appendChild(div);
        }

        if (canGotoNextWeek && lastMonthCell) {
            var div = document.createElement("div");
            div.className = 'gotoNextWeekLinkContainer noprint';
            div.innerHTML = ['<div class="gotoNextWeekLinkPosition">', '<a class="scrollWeekLink" href="javascript:gotoNextWeek();" title="', _messageResource2.default.getMessage("lock_tt.table.tooltip.7_days_forward"), '">', '<div class="strut"></div>', '</a>', '</div>'].join("");
            td.appendChild(div);
        }

        if (lastMonthCell) td.className += " printTableRightBorder";

        row.appendChild(td);
    }
}

function createMonthCell(value, colSpan, isLastMonthCell) {
    var td = document.createElement("td");
    td.colSpan = colSpan;
    td.className = "monthCell " + (isLastMonthCell ? "lastMonthCell" : "");

    var div = document.createElement("div");
    var columnWidth = 48;
    div.className = "lockTableEllipsis";
    div.innerHTML = value;
    div.style.width = columnWidth * colSpan - 10 + "px";
    td.appendChild(div);

    return td;
}

function addUserRow(userGroup, table, userBean, values, approveValues, userWorkdayDurations, expandedUsersStorage, today) {

    var userRow = userGroup.createUserRow(userBean.id, expandedUsersStorage, today, userWorkdayDurations);
    userRow.addCell(userBean);
    if (approveValues != null) {
        for (var i = 0; i < values.length; i++) {
            values[i].approveInfo = approveValues[i];
        }
    }
    var hasData = false;
    for (var i = 0; i < values.length; i++) {
        hasData |= values[i].actuals > 0;
        userRow.addCell(values[i]);
    }
    userRow.hasData = hasData;
    table.addRow(userRow);
    return userRow;
}

// function addLeaveTypeRow( targetRow, leaveInfo, values )
// {
//     var leaveTypeRow = new LeaveTypeRow();
//     leaveTypeRow.addCell( leaveInfo );
//     for( var i = 0; i < values.length; i++ )
//         leaveTypeRow.addCell( values[i] );
//     targetRow.addChildRow( leaveTypeRow );
//     targetRow.getTable().addRow( leaveTypeRow );
//     return leaveTypeRow;
// }

function addLeaveTypeToUserRow(targetRow, leaveInfo, values, headerText) {
    var leaveTypeRow = targetRow.getUserLeavesRow();
    if (!leaveTypeRow) leaveTypeRow = targetRow.createUserLeavesRow(headerText);

    for (var i = 0; i < values.length; i++) {
        leaveTypeRow.addValueToCell(i + 1, { leaveInfo: leaveInfo, time: values[i] });
    }
}

function addTaskRow(targetRow, taskBean, values) {
    var taskRow = new _TaskRow2.default(taskBean.available ? function (e) {
        (0, _jquery2.default)(document).trigger("lockTT_table_taskClick", [e, taskBean.id]);
    } : function () {});
    taskRow.addCell(taskBean);
    for (var i = 0; i < values.length; i++) {
        taskRow.addCell(values[i]);
    }
    targetRow.addChildRow(taskRow);
    targetRow.getTable().addRow(taskRow);
    return taskRow;
}

function addOvertimeRow(targetRow, headerText, values) {
    var otRow = new _OvertimeRow2.default();
    otRow.addCell(headerText);
    for (var i = 0; i < values.length; i++) {
        otRow.addCell(values[i]);
    }targetRow.addChildRow(otRow);
    targetRow.getTable().addRow(otRow);
    return otRow;
}

function addOtherTasksRow(targetRow, headerText, values) {
    var otherTasksRow = new _OtherTasksRow2.default();
    otherTasksRow.addCell(headerText);
    for (var i = 0; i < values.length; i++) {
        otherTasksRow.addCell(values[i]);
    }
    targetRow.addChildRow(otherTasksRow);
    targetRow.getTable().addRow(otherTasksRow);
    return otherTasksRow;
}

function addSeparateRow(table, columnCount, isFirstRow, label) {
    var separateRow;
    if (label === "") {
        separateRow = new _DisabledUsersSeparateRow2.default(isFirstRow);
        label = _messageResource2.default.getMessage("lock_tt.table.disabled_users_separator_text");
    } else {
        separateRow = new _UserGroupsSeparateRow2.default(isFirstRow);
    }
    separateRow.addCell(label);
    for (var i = 0; i < columnCount; i++) {
        separateRow.addCell("&nbsp;");
    }table.addRow(separateRow);
    return separateRow;
}

function addBottomBorderRow(table, columnCount) {
    var inactiveRow = new _InactiveRow2.default();
    var rowHeader = 1;
    for (var i = 0; i < columnCount + rowHeader; i++) {
        inactiveRow.addCell("&nbsp;");
    }table.addRow(inactiveRow);
    return inactiveRow;
}

/***/ }),
/* 1511 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _BaseTaskRow2 = __webpack_require__(812);

var _BaseTaskRow3 = _interopRequireDefault(_BaseTaskRow2);

var _OtherTasksNameCellRenderer = __webpack_require__(1512);

var _OtherTasksNameCellRenderer2 = _interopRequireDefault(_OtherTasksNameCellRenderer);

var _OtherTasksCellRenderer = __webpack_require__(1513);

var _OtherTasksCellRenderer2 = _interopRequireDefault(_OtherTasksCellRenderer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OtherTasksRow = function (_BaseTaskRow) {
    _inherits(OtherTasksRow, _BaseTaskRow);

    function OtherTasksRow() {
        _classCallCheck(this, OtherTasksRow);

        return _possibleConstructorReturn(this, (OtherTasksRow.__proto__ || Object.getPrototypeOf(OtherTasksRow)).apply(this, arguments));
    }

    _createClass(OtherTasksRow, [{
        key: "createRowHeaderRenderer",
        value: function createRowHeaderRenderer() {
            return new _OtherTasksNameCellRenderer2.default();
        }
    }, {
        key: "getTopBorderClass",
        value: function getTopBorderClass() {
            var topBorderClass = _BaseTaskRow3.default.prototype.getTopBorderClass.call(this);
            if (!topBorderClass) {
                return "notAvailableTaskDetailsTopSeparator";
            }
            return topBorderClass;
        }
    }, {
        key: "createLockCellRenderer",
        value: function createLockCellRenderer() {
            return new _OtherTasksCellRenderer2.default(this.appendOddEvenPrefix("DayDetailsCell"), this.getTopBorderClass());
        }
    }]);

    return OtherTasksRow;
}(_BaseTaskRow3.default);

exports.default = OtherTasksRow;

/***/ }),
/* 1512 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _LockTableCellRenderer = __webpack_require__(123);

var _LockTableCellRenderer2 = _interopRequireDefault(_LockTableCellRenderer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OtherTasksNameCellRenderer = function (_LockTableCellRendere) {
    _inherits(OtherTasksNameCellRenderer, _LockTableCellRendere);

    function OtherTasksNameCellRenderer() {
        _classCallCheck(this, OtherTasksNameCellRenderer);

        return _possibleConstructorReturn(this, (OtherTasksNameCellRenderer.__proto__ || Object.getPrototypeOf(OtherTasksNameCellRenderer)).apply(this, arguments));
    }

    _createClass(OtherTasksNameCellRenderer, [{
        key: "generateContent",
        value: function generateContent(cell) {
            cell.getCellEl().innerHTML = "<div class='otherTasksNameCell'>" + cell.getValue() + "</div>";
        }
    }, {
        key: "getTopBorderClassName",
        value: function getTopBorderClassName(cell) {
            var cssClass = "";
            if (cell.getRow().isFirstChildRow()) cssClass = "detailsRowSeparator";else if (cell.getRow().hasRowSeparator()) cssClass = "taskNameTopBorder";else cssClass = "notAvailableTaskTopBorder";
            return cssClass;
        }
    }, {
        key: "getComplicatedBorderClassName",
        value: function getComplicatedBorderClassName(cell) {
            var firstRow = cell.getRow().isFirstChildRow();
            var lastRow = cell.getRow().isLastChildRow();
            if (firstRow || lastRow) return firstRow && lastRow ? "singleDetailsRow" : firstRow ? "firstDetailsRow" : "lastDetailsRow";else return "";
        }
    }, {
        key: "getCellClassName",
        value: function getCellClassName(cell) {
            return "notAvailableTaskCell TaskCell";
        }
    }]);

    return OtherTasksNameCellRenderer;
}(_LockTableCellRenderer2.default);

exports.default = OtherTasksNameCellRenderer;

/***/ }),
/* 1513 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _DayDetailsCellRenderer = __webpack_require__(383);

var _DayDetailsCellRenderer2 = _interopRequireDefault(_DayDetailsCellRenderer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OtherTasksCellRenderer = function (_DayDetailsCellRender) {
    _inherits(OtherTasksCellRenderer, _DayDetailsCellRender);

    function OtherTasksCellRenderer(cssBaseClass, cssTopBorderClass) {
        _classCallCheck(this, OtherTasksCellRenderer);

        return _possibleConstructorReturn(this, (OtherTasksCellRenderer.__proto__ || Object.getPrototypeOf(OtherTasksCellRenderer)).call(this, cssBaseClass, cssTopBorderClass));
    }

    _createClass(OtherTasksCellRenderer, [{
        key: "addTooltip",
        value: function addTooltip(cell) {}
    }]);

    return OtherTasksCellRenderer;
}(_DayDetailsCellRenderer2.default);

exports.default = OtherTasksCellRenderer;

/***/ }),
/* 1514 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _InactiveRow2 = __webpack_require__(521);

var _InactiveRow3 = _interopRequireDefault(_InactiveRow2);

var _InactiveCellRenderer = __webpack_require__(384);

var _InactiveCellRenderer2 = _interopRequireDefault(_InactiveCellRenderer);

var _UserGroupCellRenderer = __webpack_require__(1515);

var _UserGroupCellRenderer2 = _interopRequireDefault(_UserGroupCellRenderer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UserGroupsSeparateRow = function (_InactiveRow) {
    _inherits(UserGroupsSeparateRow, _InactiveRow);

    function UserGroupsSeparateRow(isFirstRow) {
        _classCallCheck(this, UserGroupsSeparateRow);

        var _this = _possibleConstructorReturn(this, (UserGroupsSeparateRow.__proto__ || Object.getPrototypeOf(UserGroupsSeparateRow)).call(this));

        _this.separateCellRenderer = new _InactiveCellRenderer2.default("userGroupsSeparatorLockCell");
        _this.separateCellRenderer.getLastCellRightBorderClassName = function () {
            return "lockTableRightBorder";
        };
        if (isFirstRow) _this.groupCell.style.borderTop = "none";
        return _this;
    }

    _createClass(UserGroupsSeparateRow, [{
        key: "createRowHeaderRenderer",
        value: function createRowHeaderRenderer() {
            return new _UserGroupCellRenderer2.default("userGroupsSeparatorHeader");
        }
    }, {
        key: "createLockCellRenderer",
        value: function createLockCellRenderer() {
            return this.separateCellRenderer;
        }
    }]);

    return UserGroupsSeparateRow;
}(_InactiveRow3.default);

exports.default = UserGroupsSeparateRow;

/***/ }),
/* 1515 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _InactiveCellRenderer2 = __webpack_require__(384);

var _InactiveCellRenderer3 = _interopRequireDefault(_InactiveCellRenderer2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UserGroupCellRenderer = function (_InactiveCellRenderer) {
    _inherits(UserGroupCellRenderer, _InactiveCellRenderer);

    function UserGroupCellRenderer(additionalCssClass) {
        _classCallCheck(this, UserGroupCellRenderer);

        return _possibleConstructorReturn(this, (UserGroupCellRenderer.__proto__ || Object.getPrototypeOf(UserGroupCellRenderer)).call(this, additionalCssClass));
    }

    _createClass(UserGroupCellRenderer, [{
        key: "generateContent",
        value: function generateContent(cell) {
            var contentDiv = document.createElement("div");
            contentDiv.className = "userGroupName lockTableEllipsis";
            contentDiv.innerHTML = cell.getValue();

            cell.getCellEl().appendChild(contentDiv);
        }
    }]);

    return UserGroupCellRenderer;
}(_InactiveCellRenderer3.default);

exports.default = UserGroupCellRenderer;

/***/ }),
/* 1516 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _InactiveRow2 = __webpack_require__(521);

var _InactiveRow3 = _interopRequireDefault(_InactiveRow2);

var _InactiveCellRenderer = __webpack_require__(384);

var _InactiveCellRenderer2 = _interopRequireDefault(_InactiveCellRenderer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DisabledUsersSeparateRow = function (_InactiveRow) {
    _inherits(DisabledUsersSeparateRow, _InactiveRow);

    function DisabledUsersSeparateRow(isFirstRow) {
        _classCallCheck(this, DisabledUsersSeparateRow);

        var _this = _possibleConstructorReturn(this, (DisabledUsersSeparateRow.__proto__ || Object.getPrototypeOf(DisabledUsersSeparateRow)).call(this));

        _this.separateCellRenderer = new _InactiveCellRenderer2.default();
        _this.separateCellRenderer.getLastCellRightBorderClassName = function () {
            return "lockTableRightBorder";
        };
        if (isFirstRow) _this.groupCell.style.borderTop = "none";
        return _this;
    }

    _createClass(DisabledUsersSeparateRow, [{
        key: "createRowHeaderRenderer",
        value: function createRowHeaderRenderer() {
            return new _InactiveCellRenderer2.default("disabledUserSeparatorHeader");
        }
    }, {
        key: "createLockCellRenderer",
        value: function createLockCellRenderer() {
            return this.separateCellRenderer;
        }
    }]);

    return DisabledUsersSeparateRow;
}(_InactiveRow3.default);

exports.default = DisabledUsersSeparateRow;

/***/ }),
/* 1517 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _LockTableCellRenderer = __webpack_require__(123);

var _LockTableCellRenderer2 = _interopRequireDefault(_LockTableCellRenderer);

var _IconNameContainer = __webpack_require__(1518);

var _IconNameContainer2 = _interopRequireDefault(_IconNameContainer);

var _selectors = __webpack_require__(57);

var _utils = __webpack_require__(6);

var _WorkflowStatusIcon = __webpack_require__(241);

var _WorkflowStatusIcon2 = _interopRequireDefault(_WorkflowStatusIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LockTableTaskNameCellRenderer = function (_LockTableCellRendere) {
    _inherits(LockTableTaskNameCellRenderer, _LockTableCellRendere);

    function LockTableTaskNameCellRenderer(cssClassNames, taskDetailsFunc) {
        _classCallCheck(this, LockTableTaskNameCellRenderer);

        var _this = _possibleConstructorReturn(this, (LockTableTaskNameCellRenderer.__proto__ || Object.getPrototypeOf(LockTableTaskNameCellRenderer)).call(this));

        _this.cssClassNames = cssClassNames;
        _this.taskDetailsFunc = taskDetailsFunc;
        return _this;
    }

    _createClass(LockTableTaskNameCellRenderer, [{
        key: "generateContent",
        value: function generateContent(cell) {
            var _this2 = this;

            new _IconNameContainer2.default((0, _jquery2.default)(cell.getCellEl()), {
                title: cell.getValue().name,
                icon: new _WorkflowStatusIcon2.default(null, (0, _utils.unsafe_selectWithState)(function (state) {
                    return (0, _selectors.selectStatusByTask)(state, cell.getValue());
                })),
                commentsNumber: cell.getValue().commentsNumber,
                onClick: function onClick(e) {
                    _this2.taskDetailsFunc(e);
                }
            }).init();

            if (cell.getValue().available) {
                cell.getRow().getTable().getTooltipController().addTaskTooltip(cell.getCellEl(), cell.getValue());
            } else {
                cell.getRow().getTable().getTooltipController().addNotAvailableTasksTooltip(cell.getCellEl(), cell.getValue());
            }
        }
    }, {
        key: "getComplicatedBorderClassName",
        value: function getComplicatedBorderClassName(cell) {
            var firstRow = cell.getRow().isFirstChildRow();
            var lastRow = cell.getRow().isLastChildRow();
            if (firstRow || lastRow) return firstRow && lastRow ? "singleDetailsRow" : firstRow ? "firstDetailsRow" : "lastDetailsRow";else return "";
        }
    }, {
        key: "getCellClassName",
        value: function getCellClassName(cell) {
            return this.cssClassNames;
        }
    }, {
        key: "updateContent",
        value: function updateContent(cell) {
            (0, _jquery2.default)(cell.getCellEl()).empty();
            this.generateContent(cell);
        }
    }]);

    return LockTableTaskNameCellRenderer;
}(_LockTableCellRenderer2.default);

exports.default = LockTableTaskNameCellRenderer;

/***/ }),
/* 1518 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _CommentsNumberContainer = __webpack_require__(251);

var _CommentsNumberContainer2 = _interopRequireDefault(_CommentsNumberContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var IconNameContainer = function (_TemplateView) {
    _inherits(IconNameContainer, _TemplateView);

    function IconNameContainer($containerEl, _ref) {
        var title = _ref.title,
            icon = _ref.icon,
            onClick = _ref.onClick,
            commentsNumber = _ref.commentsNumber;

        _classCallCheck(this, IconNameContainer);

        var _this = _possibleConstructorReturn(this, (IconNameContainer.__proto__ || Object.getPrototypeOf(IconNameContainer)).call(this, $containerEl));

        _this.props = {
            icon: icon,
            onClick: onClick,
            commentsNumber: commentsNumber
        };

        _this.title = title;
        _this.$containerEl = $containerEl;
        return _this;
    }

    _createClass(IconNameContainer, [{
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='iconNameContainer'>" + "  <div class='iconContainer'></div>" + "  <div class='lockTableEllipsis'><%-title%></div>" + "  <div class='commentsNumberPlaceholder'></div>" + "</div>";
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            this.props.icon.init(this.find(".iconContainer"));

            var commentsNumber = new _CommentsNumberContainer2.default().init(this.find('.commentsNumberPlaceholder'));
            commentsNumber.setState({
                commentsNumber: this.props.commentsNumber
            });

            this.$el.click(this.props.onClick);
        }
    }]);

    return IconNameContainer;
}(_TemplateView3.default);

exports.default = IconNameContainer;

/***/ }),
/* 1519 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CommentsNumberCounter = function (_TemplateView) {
    _inherits(CommentsNumberCounter, _TemplateView);

    function CommentsNumberCounter() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            _ref$onClick = _ref.onClick,
            onClick = _ref$onClick === undefined ? function () {} : _ref$onClick;

        _classCallCheck(this, CommentsNumberCounter);

        var _this = _possibleConstructorReturn(this, (CommentsNumberCounter.__proto__ || Object.getPrototypeOf(CommentsNumberCounter)).call(this));

        _this.params = {
            onClick: onClick
        };

        _this.state = {
            commentsNumber: 0
        };

        _this.onStatePropertyChanged('commentsNumber', function (number) {
            _this.$label.text(number);
        });
        return _this;
    }

    _createClass(CommentsNumberCounter, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return "<div class='components_commentsNumberCounter'>" + "  <span class='number label'></span>" + "  <span class='icon'></span>" + "</div>";
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            var _this2 = this;

            this.$label = this.find('.number.label');

            this.bindClick(function () {
                _this2.params.onClick();
            });

            this.renderInitialState();
        }
    }]);

    return CommentsNumberCounter;
}(_TemplateView3.default);

exports.default = CommentsNumberCounter;

/***/ }),
/* 1520 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _DayDetailsCellRenderer = __webpack_require__(383);

var _DayDetailsCellRenderer2 = _interopRequireDefault(_DayDetailsCellRenderer);

var _atBrowserUtils = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TaskDayCellRenderer = function (_DayDetailsCellRender) {
    _inherits(TaskDayCellRenderer, _DayDetailsCellRender);

    function TaskDayCellRenderer(available, cssBaseClass, cssTopBorderClass, completed) {
        _classCallCheck(this, TaskDayCellRenderer);

        var _this = _possibleConstructorReturn(this, (TaskDayCellRenderer.__proto__ || Object.getPrototypeOf(TaskDayCellRenderer)).call(this, cssBaseClass, cssTopBorderClass));

        _this.available = available;
        _this.completed = completed;
        return _this;
    }

    _createClass(TaskDayCellRenderer, [{
        key: "getCellClassName",
        value: function getCellClassName(cell) {
            var baseClass = _DayDetailsCellRenderer2.default.prototype.getCellClassName.call(this, cell);
            return baseClass + (this.completed ? " completedTimeText" : "");
        }
    }, {
        key: "buildContent",
        value: function buildContent(cell) {
            var formatedTime = this.parseTime(cell.getValue().actuals);
            if (this.available && cell.getValue().hasComment) {
                //workaround: positioning of showComments element ignores td paddings under ie
                cell.getCellEl().style.padding = 0;
                var div = document.createElement("div");
                div.className = "showCommentsContainer";
                div.innerHTML = formatedTime;

                var commentsImg = document.createElement("img");
                commentsImg.className = "showComments";
                commentsImg.src = (0, _atBrowserUtils.imgPath)("lock_tt/small-comment.gif");

                cell.getRow().getTable().getCommentsController().registerCommentsEl(commentsImg, cell);

                div.appendChild(commentsImg);
                cell.getCellEl().appendChild(div);
            } else {
                cell.getCellEl().innerHTML = formatedTime;
            }
        }
    }, {
        key: "addTooltip",
        value: function addTooltip(cell) {
            cell.getRow().getTable().getTooltipController().addTaskDayTooltip(cell.getCellEl(), cell.getRow().getParentRow().getHeaderCell().getValue().id, cell.getRow().getTable().getDatesRow().getCell(cell.getColIdx()).getValue().date, cell.getRow().getHeaderCell().getValue(), cell.getRow().getParentRow().getCell(cell.getColIdx()).getValue());
        }
    }]);

    return TaskDayCellRenderer;
}(_DayDetailsCellRenderer2.default);

exports.default = TaskDayCellRenderer;

/***/ }),
/* 1521 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var LockTableDayInfo = function LockTableDayInfo(date, working, runnerOver, hasLockedInvisibleUser, hasUnlockedInvisibleUser) {
    _classCallCheck(this, LockTableDayInfo);

    this.date = date;
    this.working = working;
    this.runnerOver = runnerOver;
    this.hasLockedInvisibleUser = hasLockedInvisibleUser;
    this.hasUnlockedInvisibleUser = hasUnlockedInvisibleUser;
};

exports.default = LockTableDayInfo;

/***/ }),
/* 1522 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _atBrowserUtils = __webpack_require__(8);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SelectionScrollController = function () {
    function SelectionScrollController() {
        _classCallCheck(this, SelectionScrollController);

        this.enabled = false;
    }

    _createClass(SelectionScrollController, [{
        key: "setEnabled",
        value: function setEnabled(enabled) {
            if (this.enabled == enabled) return;

            if (enabled) {
                //subscribe
                var previousMousemove = document.onmousemove;
                var self = this;
                this.previousMousemove = previousMousemove;
                document.onmousemove = function (evt) {
                    if (previousMousemove) previousMousemove.call(this, evt);

                    self.scroll(evt);
                };
                this.enabled = true;
            } else {
                //unsubscribe
                document.onmousemove = this.previousMousemove;
                this.enabled = false;
            }
        }
    }, {
        key: "scroll",
        value: function scroll(evt) {
            evt = (0, _atBrowserUtils.getEventObj)(evt);
            this.mousePosX = evt.clientX;
            this.mousePosY = evt.clientY;

            var self = this;
            var doScroll = function doScroll() {
                var dx = 0;
                var dy = 0;

                if (self.mousePosX < 50) dx = -10;
                if (document.body.clientWidth - self.mousePosX < 50) dx = 10;
                if (self.mousePosY < 50) dy = -10;
                if (document.body.clientHeight - self.mousePosY < 50) dy = 10;

                window.scrollBy(dx, dy); // horizontal and vertical scroll increments

                if (self.enabled && (dx != 0 || dy != 0)) {
                    self.scrollTid = setTimeout(doScroll, 20);
                } else {
                    self.scrollTid = null;
                }
            };

            if (!this.scrollTid) {
                doScroll();
            }
        }
    }, {
        key: "linkTo",
        value: function linkTo(lockTable) {
            var self = this;
            //enable on selection start
            lockTable.getSelectionController().addSelectionChangeListener(function (selectionChangeEvent) {
                self.setEnabled(selectionChangeEvent.newValue != null);
            });

            //disable on selection complete
            lockTable.addLockEventsListener({
                selectionRemoved: function selectionRemoved() {},
                selectionFinished: function selectionFinished() {
                    self.setEnabled(false);
                },
                userDayClicked: function userDayClicked() {
                    self.setEnabled(false);
                }
            });
        }
    }]);

    return SelectionScrollController;
}();

exports.default = SelectionScrollController;

/***/ }),
/* 1523 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _atBrowserUtils = __webpack_require__(8);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SelectionVeil = function () {
    function SelectionVeil(animationImages, wrapperElement) {
        _classCallCheck(this, SelectionVeil);

        this.animationImages = animationImages;
        this.wrapperElement = wrapperElement;
        this.veilDiv = document.getElementById("selectionVeil");
        this.animationDiv = document.getElementById("veilAnimation");
        this.textDiv = document.getElementById("veilText");
        (0, _atBrowserUtils.disableTextSelection)(this.animationDiv);
        (0, _atBrowserUtils.disableTextSelection)(this.textDiv);
    }

    _createClass(SelectionVeil, [{
        key: "startAnimation",
        value: function startAnimation() {
            this.imageIdx = 0;
            var self = this;
            var doAnimate = function doAnimate() {
                self.nextAnimationImage();
                self.animationTid = setTimeout(doAnimate, 100);
            };
            doAnimate();
        }
    }, {
        key: "nextAnimationImage",
        value: function nextAnimationImage() {
            var imgSrc = this.animationImages[this.imageIdx];
            this.animationDiv.style.backgroundImage = 'url(' + imgSrc + ')';
            this.imageIdx++;
            if (this.imageIdx == this.animationImages.length) this.imageIdx = 0;
        }
    }, {
        key: "stopAnimation",
        value: function stopAnimation() {
            if (this.animationTid) {
                clearTimeout(this.animationTid);
                this.animationTid = undefined;
            }
        }
    }, {
        key: "showOver",
        value: function showOver(selection, text) {
            var topLeftCell = selection.getTopLeftVisibleCell();
            var bottomRightCell = selection.getBottomRightVisibleCell();
            var topLeftTdPos = (0, _atBrowserUtils.calculateObjectCoords)(topLeftCell.getCellEl());
            var bottomRightTdPos = (0, _atBrowserUtils.calculateObjectCoords)(bottomRightCell.getCellEl());
            var wrapperElementPos = this.wrapperElement ? (0, _atBrowserUtils.calculateObjectCoords)(this.wrapperElement) : { x: 0, y: 0 };

            this.veilDiv.style.left = topLeftTdPos.x - wrapperElementPos.x + "px";
            this.veilDiv.style.top = topLeftTdPos.y - wrapperElementPos.y + "px";

            this.veilDiv.style.width = bottomRightTdPos.x - topLeftTdPos.x + bottomRightCell.getCellEl().clientWidth + 2 + "px";
            var height = bottomRightTdPos.y - topLeftTdPos.y + bottomRightCell.getCellEl().clientHeight + 1;
            this.veilDiv.style.height = height + "px";

            var showText = text != null && topLeftCell.getRow().getRowIdx() < bottomRightCell.getRow().getRowIdx();
            var contentHeight = 23; //animation height
            if (showText) {
                this.textDiv.innerHTML = text;
                this.textDiv.style.display = "block";
                contentHeight += 12; //text height
            } else {
                this.textDiv.style.display = "none";
            }

            this.animationDiv.style.marginTop = (height - contentHeight) / 2 + "px";

            this.startAnimation();
            this.veilDiv.style.display = "block";
        }
    }, {
        key: "hide",
        value: function hide() {
            this.stopAnimation();
            this.veilDiv.style.display = "none";
        }
    }]);

    return SelectionVeil;
}();

exports.default = SelectionVeil;

/***/ }),
/* 1524 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _atBrowserUtils = __webpack_require__(8);

var _NullTableRegion = __webpack_require__(144);

var _NullTableRegion2 = _interopRequireDefault(_NullTableRegion);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _LockingSelectionUpdater = __webpack_require__(1525);

var _LockingSelectionUpdater2 = _interopRequireDefault(_LockingSelectionUpdater);

var _UnlockingSelectionUpdater = __webpack_require__(1526);

var _UnlockingSelectionUpdater2 = _interopRequireDefault(_UnlockingSelectionUpdater);

var _DateSelectionType = __webpack_require__(815);

var _DateSelectionType2 = _interopRequireDefault(_DateSelectionType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var LockEventsHandler = function () {
    function LockEventsHandler(dateFormat, dateParser, timestamp, selectionVeil, menuCancelHandler, menuCancelScope, menuDateFormat) {
        _classCallCheck(this, LockEventsHandler);

        this.menuCancelHandler = menuCancelHandler;
        this.menuCancelScope = menuCancelScope;
        this.menuDateFormat = menuDateFormat;
        this.dateFormat = dateFormat;
        this.dateParser = dateParser;
        this.timestamp = timestamp;
        this.selectionVeil = selectionVeil;
    }

    _createClass(LockEventsHandler, [{
        key: "selectionRemoved",
        value: function selectionRemoved() {
            if (this.lockMenu) {
                this.lockMenu.hide();
            }
        }
    }, {
        key: "selectionFinished",
        value: function selectionFinished(selection, mouseEvent) {
            this.lockMenu = this.getLockMenu(selection);
            this.lockMenu.setCancelHandler(this.menuCancelHandler, this.menuCancelScope);
            if (selection.canBeLocked()) {
                this.lockMenu.setLockEnabled(true);
                this.lockMenu.setLockHandler(this.getLockHandler(selection));
            } else {
                this.lockMenu.setLockEnabled(false);
            }

            if (selection.canBeUnlocked()) {
                this.lockMenu.setUnlockEnabled(true);
                this.lockMenu.setUnlockHandler(this.getUnlockHandler(selection));
            } else {
                this.lockMenu.setUnlockEnabled(false);
            }

            var panelPosition = this.getLockPanelPosition(selection, mouseEvent.clientX + (0, _atBrowserUtils.getBodyScrollLeft)(), mouseEvent.clientY + (0, _atBrowserUtils.getBodyScrollTop)());
            this.lockMenu.show(panelPosition.x, panelPosition.y);
        }
    }, {
        key: "getLockPanelPosition",
        value: function getLockPanelPosition(selection, clickX, clickY) {
            if (selection === _NullTableRegion2.default) return { x: clickX + 10, y: clickY + 10 };

            var topLeftCorner = (0, _atBrowserUtils.calculateObjectCoords)(selection.getTopLeftVisibleCell().getCellEl());
            var bottomRightTd = selection.getBottomRightVisibleCell().getCellEl();
            var bottomRightCorner = (0, _atBrowserUtils.calculateObjectCoords)(bottomRightTd);
            bottomRightCorner.x += bottomRightTd.clientWidth;
            bottomRightCorner.y += bottomRightTd.clientHeight;

            if (clickX < topLeftCorner.x) clickX = topLeftCorner.x + 10;else if (clickX > bottomRightCorner.x) clickX = bottomRightCorner.x - 10;else clickX += 10;

            if (clickY < topLeftCorner.y) clickY = topLeftCorner.y + 10;else if (clickY > bottomRightCorner.y) clickY = bottomRightCorner.y - 10;else clickY += 10;

            return { x: clickX, y: clickY };
        }

        /**
         * Gets lock handler for specified selection
         */

    }, {
        key: "getLockHandler",
        value: function getLockHandler(selection) {
            var selectedData = selection.getSelectedData();
            var dateFormat = this.dateFormat;
            var dateParser = this.dateParser;
            var timestamp = this.timestamp;
            var selectionVeil = this.selectionVeil;

            return selection.type.accept({
                visitCellSelection: function visitCellSelection() {
                    return function () {
                        var lockManager = new LockUsersManager(selectedData.userIds, dateFormat.formatDate(selectedData.dateRange.dateFrom), dateFormat.formatDate(selectedData.dateRange.dateTo), new _LockingSelectionUpdater2.default(selection.lockTable, selection, dateParser, selectionVeil), timestamp);
                        RpcControlManager.saveRpcControlBoundData(lockManager);
                    };
                },
                visitDateSelection: function visitDateSelection() {
                    return function () {
                        lockSelectedDates(selectedData.dateRange.dateFrom, selectedData.dateRange.dateTo);
                    };
                },
                visitRunnerSelection: function visitRunnerSelection() {
                    return function () {
                        lockByRunner(selectedData.dateRange.dateFrom, selectedData.dateRange.dateTo);
                    };
                }
            });
        }
    }, {
        key: "getLockMenu",
        value: function getLockMenu(selection) {
            var leh = this;
            var getCommonMenu = function getCommonMenu() {
                return new LockMenu({
                    text: _messageResource2.default.getMessage("lock_tt.table.menu.lock_selected"),
                    icon: (0, _atBrowserUtils.imgPath)("/lock_tt/lock-icon.png")
                }, {
                    text: _messageResource2.default.getMessage("lock_tt.table.menu.unlock_selected"),
                    icon: (0, _atBrowserUtils.imgPath)("/lock_tt/unlock-icon.png")
                });
            };

            var getSliderMenu = function getSliderMenu() {
                var dateRange = selection.getSelectedData().dateRange;

                var dateToStr = leh.menuDateFormat.formatDate(dateRange.dateTo);

                var lockText = void 0,
                    unlockText = void 0;
                if (selection.canBeLocked()) {
                    lockText = _messageResource2.default.getMessage("lock_tt.table.slider_menu.lock_enabled", [dateToStr]);
                    unlockText = _messageResource2.default.getMessage("lock_tt.table.slider_menu.unlock_disabled");
                } else {
                    var dateBeforeStr = leh.menuDateFormat.formatDate(dateRange.dateFrom.add(Date.DAY, -1));
                    var dateFromStr = leh.menuDateFormat.formatDate(dateRange.dateFrom);
                    lockText = _messageResource2.default.getMessage("lock_tt.table.slider_menu.lock_disabled");
                    unlockText = _messageResource2.default.getMessage("lock_tt.table.slider_menu.unlock_enabled", [dateBeforeStr, dateFromStr, dateToStr]);
                }
                return new LockMenu({
                    text: lockText,
                    icon: (0, _atBrowserUtils.imgPath)("/lock_tt/lock-icon.png")
                }, {
                    text: unlockText,
                    icon: (0, _atBrowserUtils.imgPath)("/lock_tt/unlock-icon.png")
                });
            };

            // TODO hot fix for section.type=null see AT-2490 - this function does not important(AT-3095)
            if (selection.type === null) {
                selection.type = new _DateSelectionType2.default();
            }

            return selection.type.accept({
                visitCellSelection: getCommonMenu,
                visitDateSelection: getCommonMenu,
                visitRunnerSelection: getSliderMenu
            });
        }

        /**
         * Gets unlock handler for specified selection
         */

    }, {
        key: "getUnlockHandler",
        value: function getUnlockHandler(selection) {
            var selectedData = selection.getSelectedData();
            var dateFormat = this.dateFormat;
            var selectionVeil = this.selectionVeil;

            return selection.type.accept({
                visitCellSelection: function visitCellSelection() {
                    return function () {
                        var unlockManager = new UnlockUsersManager(selectedData.userIds, dateFormat.formatDate(selectedData.dateRange.dateFrom), dateFormat.formatDate(selectedData.dateRange.dateTo), new _UnlockingSelectionUpdater2.default(selection.lockTable, selection, selectionVeil));
                        RpcControlManager.saveRpcControlBoundData(unlockManager);
                    };
                },
                visitDateSelection: function visitDateSelection() {
                    return function () {
                        unlockSelectedDates(selectedData.dateRange.dateFrom, selectedData.dateRange.dateTo);
                    };
                },
                visitRunnerSelection: function visitRunnerSelection() {
                    return function () {
                        unlockByRunner(selectedData.dateRange.dateFrom, selectedData.dateRange.dateTo);
                    };
                }
            });
        }
    }, {
        key: "userDayClicked",
        value: function userDayClicked(userId, date, dayCell) {
            var manager = null;
            var dateStr = this.dateFormat.formatDate(date);
            var lockTable = dayCell.getRow().getTable();
            var selection = lockTable.getSelectionController().getSelection();

            if (dayCell.getValue().locked) {
                manager = new UnlockUsersManager([userId], dateStr, dateStr, new _UnlockingSelectionUpdater2.default(lockTable, selection, this.selectionVeil));
            } else {
                manager = new LockUsersManager([userId], dateStr, dateStr, new _LockingSelectionUpdater2.default(lockTable, selection, this.dateParser, this.selectionVeil), this.timestamp);
            }

            RpcControlManager.saveRpcControlBoundData(manager, false);
        }
    }]);

    return LockEventsHandler;
}();

exports.default = LockEventsHandler;

/***/ }),
/* 1525 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _DateRange = __webpack_require__(304);

var _DateRange2 = _interopRequireDefault(_DateRange);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _SelectionUpdater2 = __webpack_require__(814);

var _SelectionUpdater3 = _interopRequireDefault(_SelectionUpdater2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LockingSelectionUpdater = function (_SelectionUpdater) {
    _inherits(LockingSelectionUpdater, _SelectionUpdater);

    function LockingSelectionUpdater(lockTable, selection, dateParser, selectionVeil) {
        _classCallCheck(this, LockingSelectionUpdater);

        var _this = _possibleConstructorReturn(this, (LockingSelectionUpdater.__proto__ || Object.getPrototypeOf(LockingSelectionUpdater)).call(this, lockTable, selection, _messageResource2.default.getMessage("lock_tt.table.veil.locking"), selectionVeil));

        _this.dateParser = dateParser;
        return _this;
    }

    _createClass(LockingSelectionUpdater, [{
        key: "handleResult",
        value: function handleResult(result) {
            var userRowsMap = [];
            var userRows = this.lockTable.getUserRows(this.selection.rowMin, this.selection.rowMax);
            for (var i = 0; i < userRows.length; i++) {
                var currentRow = userRows[i];

                var userId = currentRow.getHeaderCell().getValue().id;
                userRowsMap[userId] = currentRow;
            }

            var datesRow = this.lockTable.getDatesRow();
            var columnDates = [];
            for (var colIdx = this.selection.colMin; colIdx <= this.selection.colMax; colIdx++) {
                columnDates[colIdx] = datesRow.getCell(colIdx).getValue().date;
            }

            for (var _i = 0; _i < result.length; _i++) {
                var userLock = result[_i];
                var userRow = userRowsMap[userLock.lockedUserId];
                var dateRange = new _DateRange2.default(this.dateParser.parse(userLock.dateFrom), this.dateParser.parse(userLock.dateTo));

                for (var _colIdx = this.selection.colMin; _colIdx <= this.selection.colMax; _colIdx++) {
                    if (dateRange.contains(columnDates[_colIdx])) {
                        var userDayInfo = userRow.getCell(_colIdx).getValue();
                        userDayInfo.locked = true;
                        userDayInfo.whoLocked = userLock.whoLockedId;
                        userDayInfo.lockDate = this.dateParser.parse(userLock.whenLockedDate);
                    }
                }
            }

            this.runnerController.regionLocked(this.lockTable, this.selection);
        }
    }]);

    return LockingSelectionUpdater;
}(_SelectionUpdater3.default);

exports.default = LockingSelectionUpdater;

/***/ }),
/* 1526 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _SelectionUpdater2 = __webpack_require__(814);

var _SelectionUpdater3 = _interopRequireDefault(_SelectionUpdater2);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UnlockingSelectionUpdater = function (_SelectionUpdater) {
    _inherits(UnlockingSelectionUpdater, _SelectionUpdater);

    function UnlockingSelectionUpdater(lockTable, selection, selectionVeil) {
        _classCallCheck(this, UnlockingSelectionUpdater);

        return _possibleConstructorReturn(this, (UnlockingSelectionUpdater.__proto__ || Object.getPrototypeOf(UnlockingSelectionUpdater)).call(this, lockTable, selection, _messageResource2.default.getMessage("lock_tt.table.veil.unlocking"), selectionVeil));
    }

    _createClass(UnlockingSelectionUpdater, [{
        key: "handleResult",
        value: function handleResult(result) {
            this.selection.visitUserCells(function (cell) {
                if (cell.getValue().locked) {
                    cell.getValue().locked = false;
                    cell.getValue().lockDate = null;
                    cell.getValue().whoLocked = null;
                }
            });

            this.runnerController.regionUnlocked(this.lockTable, this.selection);
        }
    }]);

    return UnlockingSelectionUpdater;
}(_SelectionUpdater3.default);

exports.default = UnlockingSelectionUpdater;

/***/ }),
/* 1527 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Table2 = __webpack_require__(385);

var _Table3 = _interopRequireDefault(_Table2);

var _LockTableSelectionController = __webpack_require__(1529);

var _LockTableSelectionController2 = _interopRequireDefault(_LockTableSelectionController);

var _TableRegion = __webpack_require__(145);

var _TableRegion2 = _interopRequireDefault(_TableRegion);

var _atBrowserUtils = __webpack_require__(8);

var _LockTableHoverController = __webpack_require__(1531);

var _LockTableHoverController2 = _interopRequireDefault(_LockTableHoverController);

var _LockTableMouseEventsHandler = __webpack_require__(1532);

var _LockTableMouseEventsHandler2 = _interopRequireDefault(_LockTableMouseEventsHandler);

var _NullTableRegion = __webpack_require__(144);

var _NullTableRegion2 = _interopRequireDefault(_NullTableRegion);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LockTable = function (_Table) {
    _inherits(LockTable, _Table);

    function LockTable(todayDate, weekStartDay) {
        _classCallCheck(this, LockTable);

        var _this = _possibleConstructorReturn(this, (LockTable.__proto__ || Object.getPrototypeOf(LockTable)).call(this));

        _this.listeners = [];
        _this.viewerTodayDate = todayDate;
        _this.viewerTodayColIdx = -1;
        _this.weekStartDay = weekStartDay;
        _this.datesRow = null;
        _this.tooltipController = null;
        _this.commentsController = null;
        _this.runnerController = null;
        return _this;
    }

    _createClass(LockTable, [{
        key: "createSelectionController",
        value: function createSelectionController() {
            return new _LockTableSelectionController2.default();
        }
    }, {
        key: "createHoverController",
        value: function createHoverController() {
            return new _LockTableHoverController2.default();
        }
    }, {
        key: "createMouseEventsHandler",
        value: function createMouseEventsHandler() {
            var lockTableMouseEventsHandler = new _LockTableMouseEventsHandler2.default(this, this.getSelectionController(), this.getHoverController(), this.getRunnerController());
            var table = this;
            lockTableMouseEventsHandler.addSelectionFinishedListener(function (mouseUpEvent) {
                table.fireSelectionFinished((0, _atBrowserUtils.getEventObj)(mouseUpEvent));
            });
            return lockTableMouseEventsHandler;
        }
    }, {
        key: "init",
        value: function init(runnerController, tooltipController, commentsController) {
            this.runnerController = runnerController;
            this.tooltipController = tooltipController;
            this.commentsController = commentsController;

            // TODO: remove mouseEventsHandler initialization and call Table.prototype.init method after Table class refactoring, now is calling in constructor
            this.mouseEventsHandler = this.createMouseEventsHandler();

            var self = this;
            commentsController.addViewCommentsListener({
                onViewComments: function onViewComments() {
                    self.setIgnoreUserActivity(true);
                    self.hoverController.unhover();
                    tooltipController.enableTooltips(false);
                },
                onCloseComments: function onCloseComments() {
                    self.setIgnoreUserActivity(false);
                    tooltipController.enableTooltips(true);
                }
            });

            this.selectionController.addSelectionChangeListener(function (selectionChangeEvent) {
                if (selectionChangeEvent.newValue == _NullTableRegion2.default) {
                    commentsController.enableComments(true);
                    tooltipController.enableTooltips(true);
                } else {
                    commentsController.enableComments(false);
                    tooltipController.enableTooltips(false);
                }
            });
        }
    }, {
        key: "getHoverController",
        value: function getHoverController() {
            return this.hoverController;
        }
    }, {
        key: "getRunnerController",
        value: function getRunnerController() {
            return this.runnerController;
        }
    }, {
        key: "getCommentsController",
        value: function getCommentsController() {
            return this.commentsController;
        }
    }, {
        key: "getTooltipController",
        value: function getTooltipController() {
            return this.tooltipController;
        }
    }, {
        key: "containsViewerTodayColumn",
        value: function containsViewerTodayColumn() {
            return this.viewerTodayColIdx > 0;
        }
    }, {
        key: "getViewerTodayColIdx",
        value: function getViewerTodayColIdx() {
            return this.viewerTodayColIdx;
        }
    }, {
        key: "addDatesRow",
        value: function addDatesRow(datesRow) {
            this.addRow(datesRow);
            this.datesRow = datesRow;

            for (var colIdx = 1; colIdx < datesRow.getCells().length; colIdx++) {
                if (datesRow.getCell(colIdx).getValue().date.getTime() == this.viewerTodayDate.getTime()) {
                    this.viewerTodayColIdx = colIdx;
                    break;
                }
            }
        }
    }, {
        key: "getDatesRow",
        value: function getDatesRow() {
            return this.datesRow;
        }
    }, {
        key: "selectionChanged",
        value: function selectionChanged(selectionChangeEvent) {
            var updateRegion = this.computeChangedRegion(selectionChangeEvent);

            if (updateRegion != _NullTableRegion2.default) {
                //should update selection bottom border
                if (updateRegion.rowMax < this.rows.length - 1) updateRegion = new _TableRegion2.default(updateRegion.rowMin, updateRegion.colMin, updateRegion.rowMax + 1, updateRegion.colMax);

                //should update selection right border
                if (updateRegion.colMax < this.getLastRow().getCells().length - 1) updateRegion = new _TableRegion2.default(updateRegion.rowMin, updateRegion.colMin, updateRegion.rowMax, updateRegion.colMax + 1);

                this.updateCellRegionUI(updateRegion);

                //update marked selected dates
                if (updateRegion.rowMin > 0) for (var colIdx = updateRegion.colMin; colIdx <= updateRegion.colMax; colIdx++) {
                    this.getDatesRow().updateCellUI(colIdx);
                }for (var rowIdx = updateRegion.rowMin; rowIdx <= updateRegion.rowMax; rowIdx++) {
                    this.rows[rowIdx].updateCellUI(0);
                }
            } else if (selectionChangeEvent.oldValue == _NullTableRegion2.default || selectionChangeEvent.newValue == _NullTableRegion2.default) {
                var userRows = this.getUserRows();
                for (var userRowIdx = 0; userRowIdx < userRows.length; userRowIdx++) {
                    userRows[userRowIdx].updateCellUI(0);
                }
            }

            if (selectionChangeEvent.newValue != _NullTableRegion2.default) this.fireSelectionRemoved();
        }
    }, {
        key: "hoverChanged",
        value: function hoverChanged(regionChangeEvent) {
            if (regionChangeEvent.oldValue != _NullTableRegion2.default) this.updateCellRegionUI(regionChangeEvent.oldValue);
            if (regionChangeEvent.newValue != _NullTableRegion2.default) this.updateCellRegionUI(regionChangeEvent.newValue);
        }
    }, {
        key: "addLockEventsListener",
        value: function addLockEventsListener(listener) {
            this.listeners.push(listener);
        }
    }, {
        key: "fireSelectionFinished",
        value: function fireSelectionFinished(mouseUpEvent) {
            if (this.selectionController.hasSelection()) {
                var selection = this.getSelectionController().getSelection();
                for (var i = 0; i < this.listeners.length; i++) {
                    this.listeners[i].selectionFinished(selection, mouseUpEvent);
                }
            }
        }
    }, {
        key: "fireSelectionRemoved",
        value: function fireSelectionRemoved() {
            for (var i = 0; i < this.listeners.length; i++) {
                this.listeners[i].selectionRemoved();
            }
        }
    }, {
        key: "fireUserCellClicked",
        value: function fireUserCellClicked(userDayCell) {
            for (var i = 0; i < this.listeners.length; i++) {
                this.listeners[i].userDayClicked(userDayCell.getRow().getHeaderCell().getValue().id, this.getDatesRow().getCell(userDayCell.getColIdx()).getValue().date, userDayCell);
            }
        }

        /**
         * Gets user rows from specified row range.
         * Returns all user rows if row range not specified.
         *
         * @param startRowIdx - range start
         * @param endRowIdx - range end
         */

    }, {
        key: "getUserRows",
        value: function getUserRows(startRowIdx, endRowIdx) {
            var startIdx = startRowIdx ? startRowIdx : 0;
            var endIdx = endRowIdx ? endRowIdx : this.rows.length - 1;

            var userRows = [];
            for (var i = startIdx; i <= endIdx; i++) {
                var currentRow = this.rows[i];
                var isUserRow = currentRow.accept({
                    visitUserRow: function visitUserRow(cell) {
                        return true;
                    },
                    visitDetailsRow: function visitDetailsRow(cell) {
                        return false;
                    },
                    visitDatesRow: function visitDatesRow(cell) {
                        return false;
                    },
                    visitRunnerRow: function visitRunnerRow(cell) {
                        return false;
                    },
                    visitInactiveRow: function visitInactiveRow(cell) {
                        return false;
                    }
                }, null);

                if (isUserRow) userRows.push(currentRow);
            }
            return userRows;
        }
    }, {
        key: "getLastSelectableRow",
        value: function getLastSelectableRow() {
            for (var i = this.rows.length - 1; i > 0; i--) {
                var row = this.rows[i];
                var isSelectableRow = row.accept({
                    visitUserRow: function visitUserRow(cell) {
                        return true;
                    },
                    visitDetailsRow: function visitDetailsRow(cell) {
                        return true;
                    },
                    visitDatesRow: function visitDatesRow(cell) {
                        return true;
                    },
                    visitRunnerRow: function visitRunnerRow(cell) {
                        return true;
                    },
                    visitInactiveRow: function visitInactiveRow(cell) {
                        return false;
                    }
                }, null);

                if (isSelectableRow) return row;
            }
        }
    }, {
        key: "setIgnoreUserActivity",
        value: function setIgnoreUserActivity(ignore) {
            this.getMouseEventsHandler().setIgnoreMouseEvents(ignore);

            var userRows = this.getUserRows();
            for (var i = 0; i < userRows.length; i++) {
                userRows[i].disableExpandCollapse(ignore);
            }
        }
    }, {
        key: "getWeekStartDay",
        value: function getWeekStartDay() {
            return this.weekStartDay;
        }
    }, {
        key: "isHolidayColumn",
        value: function isHolidayColumn(colIdx) {
            return !this.getDatesRow().getCell(colIdx).getValue().working;
        }
    }, {
        key: "updateCellRegionUI",
        value: function updateCellRegionUI(region) {
            // update main region and update also cells that appears right from that region
            for (var rowIdx = region.rowMin; rowIdx <= region.rowMax; rowIdx++) {
                for (var colIdx = region.colMin; colIdx <= Math.min(region.colMax + 1, this.getLastRow().getCells().length - 1); colIdx++) {
                    this.rows[rowIdx].updateCellUI(colIdx);
                }
            }
        }
    }]);

    return LockTable;
}(_Table3.default);

exports.default = LockTable;

/***/ }),
/* 1528 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _NullTableRegion = __webpack_require__(144);

var _NullTableRegion2 = _interopRequireDefault(_NullTableRegion);

var _TableRegionChangeEvent = __webpack_require__(524);

var _TableRegionChangeEvent2 = _interopRequireDefault(_TableRegionChangeEvent);

var _TableRegion = __webpack_require__(145);

var _TableRegion2 = _interopRequireDefault(_TableRegion);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var HoverController = function () {
    function HoverController() {
        _classCallCheck(this, HoverController);

        this.hoverRegion = _NullTableRegion2.default;
        this.listeners = [];
    }

    _createClass(HoverController, [{
        key: "addHoverChangeListener",
        value: function addHoverChangeListener(listener) {
            this.listeners.push(listener);
        }
    }, {
        key: "fireHoverChangeEvent",
        value: function fireHoverChangeEvent(oldHoverRegion, mouseEvent) {
            var hoverChangeEvent = new _TableRegionChangeEvent2.default(oldHoverRegion, this.hoverRegion);
            for (var i = 0; i < this.listeners.length; i++) {
                this.listeners[i].call(this.listeners[i], hoverChangeEvent, mouseEvent);
            }
        }
    }, {
        key: "hover",
        value: function hover(startCell, endCell, mouseEvent) {
            var oldHoverRegion = this.hoverRegion;
            this.hoverRegion = _TableRegion2.default.prototype.createFromCells(startCell, endCell);
            if (!this.hoverRegion.equals(oldHoverRegion)) this.fireHoverChangeEvent(oldHoverRegion, mouseEvent);
        }
    }, {
        key: "unhover",
        value: function unhover(mouseEvent) {
            var oldHoverRegion = this.hoverRegion;
            this.hoverRegion = _NullTableRegion2.default;
            this.fireHoverChangeEvent(oldHoverRegion, mouseEvent);
        }
    }, {
        key: "isHovered",
        value: function isHovered(cell) {
            return this.hoverRegion.contains(cell.getRow().getRowIdx(), cell.getColIdx());
        }
    }, {
        key: "getHoverRegion",
        value: function getHoverRegion() {
            return this.hoverRegion;
        }
    }]);

    return HoverController;
}();

exports.default = HoverController;

/***/ }),
/* 1529 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _NullTableRegion = __webpack_require__(144);

var _NullTableRegion2 = _interopRequireDefault(_NullTableRegion);

var _LockTableRegion = __webpack_require__(1530);

var _LockTableRegion2 = _interopRequireDefault(_LockTableRegion);

var _SelectionController2 = __webpack_require__(816);

var _SelectionController3 = _interopRequireDefault(_SelectionController2);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _RunnerSelectionType = __webpack_require__(817);

var _RunnerSelectionType2 = _interopRequireDefault(_RunnerSelectionType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LockTableSelectionController = function (_SelectionController) {
    _inherits(LockTableSelectionController, _SelectionController);

    function LockTableSelectionController() {
        _classCallCheck(this, LockTableSelectionController);

        var _this = _possibleConstructorReturn(this, (LockTableSelectionController.__proto__ || Object.getPrototypeOf(LockTableSelectionController)).call(this));

        _this.selectionType = null;
        _this.lockTable = null;
        return _this;
    }

    _createClass(LockTableSelectionController, [{
        key: "setLockTable",
        value: function setLockTable(lockTable) {
            this.lockTable = lockTable;
        }
    }, {
        key: "isLeftmostSelectedCell",
        value: function isLeftmostSelectedCell(cell) {
            if (this.isSelected(cell.getRow().getRowIdx(), cell.getColIdx())) return this.selectedRegion.colMin == cell.getColIdx();
        }
    }, {
        key: "isUpwardmostSelectedCell",
        value: function isUpwardmostSelectedCell(cell) {
            if (this.isSelected(cell.getRow().getRowIdx(), cell.getColIdx())) return this.selectedRegion.rowMin == cell.getRow().getRowIdx();
        }
    }, {
        key: "isRightmostSelectedCell",
        value: function isRightmostSelectedCell(cell) {
            if (this.isSelected(cell.getRow().getRowIdx(), cell.getColIdx())) return this.selectedRegion.colMax == cell.getColIdx();
        }
    }, {
        key: "isDownwardmostSelectedCell",
        value: function isDownwardmostSelectedCell(cell) {
            if (this.isSelected(cell.getRow().getRowIdx(), cell.getColIdx())) return this.selectedRegion.rowMax == cell.getRow().getRowIdx();
        }
    }, {
        key: "visitSelection",
        value: function visitSelection(visitor) {
            if (this.selectionType !== null) return this.selectionType.accept(visitor, this.getSelection());
        }
    }, {
        key: "setSelectionType",
        value: function setSelectionType(selectionType) {
            var oldSelection = this.getSelection();
            this.selectionType = selectionType;
            this.fireSelectionChangeEvent(oldSelection);
        }
    }, {
        key: "createSelection",
        value: function createSelection(cell) {
            return _LockTableRegion2.default.prototype.createFromCells(this.selectionType, this.lockTable, this.selectionAnchor, cell);
        }
    }, {
        key: "isSelected",
        value: function isSelected(rowIdx, colIdx) {
            if (this._isRunnerAfterLastVisibleDaySelection(colIdx)) return false;
            return _get(LockTableSelectionController.prototype.__proto__ || Object.getPrototypeOf(LockTableSelectionController.prototype), "isSelected", this).call(this, rowIdx, colIdx);
        }
    }, {
        key: "isColumnIncludedIntoSelection",
        value: function isColumnIncludedIntoSelection(colIdx) {
            if (this._isRunnerAfterLastVisibleDaySelection(colIdx)) return false;
            return this.selectedRegion.containsCol(colIdx);
        }
    }, {
        key: "clearSelection",
        value: function clearSelection() {
            this.selectionAnchor = null;
            if (this.hasSelection()) {
                var oldSelection = this.getSelection();
                this.selectionType = null;
                this.selectedRegion = _NullTableRegion2.default;
                this.fireSelectionChangeEvent(oldSelection);
            }
        }
    }, {
        key: "hasSelection",
        value: function hasSelection() {
            return this.selectedRegion !== _NullTableRegion2.default || this.selectionType !== null;
        }
    }, {
        key: "isRowIncludedIntoSelection",
        value: function isRowIncludedIntoSelection(rowIdx) {
            return this.visitSelection({
                visitCellSelection: function visitCellSelection(selection) {
                    if (selection != _NullTableRegion2.default) return selection.rowMin <= rowIdx && rowIdx <= selection.rowMax;
                    return false;
                },

                visitDateSelection: _underscore2.default.constant(true),
                visitRunnerSelection: _underscore2.default.constant(true)
            });
        }
    }, {
        key: "_isRunnerAfterLastVisibleDaySelection",
        value: function _isRunnerAfterLastVisibleDaySelection(colIdx) {
            if (this.selectionType instanceof _RunnerSelectionType2.default && this.selectedRegion.colMax === this.selectedRegion.colMin) {
                var datesRowCells = this.lockTable.selectionController.lockTable.datesRow.cells;
                var newLastLockedDate = this.lockTable.runnerController.newLastLockedCell.value.date;
                var lastVisibleDateRow = datesRowCells[datesRowCells.length - 1];

                if (colIdx === datesRowCells.length - 1 && lastVisibleDateRow.value.date < this.lockTable.runnerController.lastLockedDate && newLastLockedDate === lastVisibleDateRow.value.date) {
                    return true;
                }
            }
            return false;
        }
    }]);

    return LockTableSelectionController;
}(_SelectionController3.default);

exports.default = LockTableSelectionController;

/***/ }),
/* 1530 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TableRegion2 = __webpack_require__(145);

var _TableRegion3 = _interopRequireDefault(_TableRegion2);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LockTableRegion = function (_TableRegion) {
    _inherits(LockTableRegion, _TableRegion);

    function LockTableRegion(type, lockTable, startRow, startCol, endRow, endCol) {
        _classCallCheck(this, LockTableRegion);

        var _this = _possibleConstructorReturn(this, (LockTableRegion.__proto__ || Object.getPrototypeOf(LockTableRegion)).call(this, startRow, startCol, endRow, endCol));

        _this.type = type;
        _this.lockTable = lockTable;
        return _this;
    }

    _createClass(LockTableRegion, [{
        key: "createFromCells",
        value: function createFromCells(type, lockTable, startCell, endCell) {
            return new LockTableRegion(type, lockTable, startCell.getRow().getRowIdx(), startCell.getColIdx(), endCell.getRow().getRowIdx(), endCell.getColIdx());
        }
    }, {
        key: "getSelectedData",
        value: function getSelectedData() {
            return this.type.getSelectedData(this.lockTable, this);
        }
    }, {
        key: "canBeLocked",
        value: function canBeLocked() {
            return this.type.canBeLocked(this.lockTable, this);
        }
    }, {
        key: "canBeUnlocked",
        value: function canBeUnlocked() {
            return this.type.canBeUnlocked(this.lockTable, this);
        }
    }, {
        key: "getTopLeftVisibleCell",
        value: function getTopLeftVisibleCell() {
            return this.lockTable.getCell(this.rowMin, this.colMin);
        }
    }, {
        key: "getBottomRightVisibleCell",
        value: function getBottomRightVisibleCell() {
            var region = this;
            var row = this.lockTable.rows[region.rowMax];
            return row.accept({
                visitUserRow: function visitUserRow(cell) {
                    return row.getCell(region.colMax);
                },
                visitDetailsRow: function visitDetailsRow(cell) {
                    var userRow = row.getParentRow();
                    if (userRow.isExpanded()) return row.getCell(region.colMax);else return userRow.getCell(region.colMax);
                },

                visitDatesRow: _underscore2.default.constant(null),
                visitRunnerRow: _underscore2.default.constant(null),
                visitInactiveRow: _underscore2.default.constant(null)
            }, null);
        }
    }, {
        key: "visitUserCells",
        value: function visitUserCells(visitor) {
            var userRows = this.lockTable.getUserRows(this.rowMin, this.rowMax);
            for (var i = 0; i < userRows.length; i++) {
                var currentRow = userRows[i];

                for (var colIdx = this.colMin; colIdx <= this.colMax; colIdx++) {
                    visitor(currentRow.getCell(colIdx));
                }
            }
        }
    }]);

    return LockTableRegion;
}(_TableRegion3.default);

exports.default = LockTableRegion;

/***/ }),
/* 1531 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _NullTableRegion = __webpack_require__(144);

var _NullTableRegion2 = _interopRequireDefault(_NullTableRegion);

var _TableRegionChangeEvent = __webpack_require__(524);

var _TableRegionChangeEvent2 = _interopRequireDefault(_TableRegionChangeEvent);

var _TableRegion = __webpack_require__(145);

var _TableRegion2 = _interopRequireDefault(_TableRegion);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var LockTableHoverController = function () {
    function LockTableHoverController() {
        _classCallCheck(this, LockTableHoverController);

        this.hoverRegion = _NullTableRegion2.default;
        this.listeners = [];
    }

    _createClass(LockTableHoverController, [{
        key: "addHoverChangeListener",
        value: function addHoverChangeListener(listener) {
            this.listeners.push(listener);
        }
    }, {
        key: "fireHoverChangeEvent",
        value: function fireHoverChangeEvent(oldHoverRegion) {
            var hoverChangeEvent = new _TableRegionChangeEvent2.default(oldHoverRegion, this.hoverRegion);
            for (var i = 0; i < this.listeners.length; i++) {
                this.listeners[i].call(this.listeners[i], hoverChangeEvent);
            }
        }
    }, {
        key: "hover",
        value: function hover(startCell, endCell) {
            var oldHoverRegion = this.hoverRegion;
            this.hoverRegion = _TableRegion2.default.prototype.createFromCells(startCell, endCell);
            if (!this.hoverRegion.equals(oldHoverRegion)) this.fireHoverChangeEvent(oldHoverRegion);
        }
    }, {
        key: "unhover",
        value: function unhover() {
            var oldHoverRegion = this.hoverRegion;
            this.hoverRegion = _NullTableRegion2.default;
            this.fireHoverChangeEvent(oldHoverRegion);
        }
    }, {
        key: "isHovered",
        value: function isHovered(cell) {
            return this.hoverRegion != _NullTableRegion2.default && this.hoverRegion.contains(cell.getRow().getRowIdx(), cell.getColIdx());
        }
    }, {
        key: "getHoverRegion",
        value: function getHoverRegion() {
            return this.hoverRegion;
        }
    }]);

    return LockTableHoverController;
}();

exports.default = LockTableHoverController;

/***/ }),
/* 1532 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _CellSelectionType = __webpack_require__(1533);

var _CellSelectionType2 = _interopRequireDefault(_CellSelectionType);

var _DateSelectionType = __webpack_require__(815);

var _DateSelectionType2 = _interopRequireDefault(_DateSelectionType);

var _TableMouseEventsHandler = __webpack_require__(525);

var _TableMouseEventsHandler2 = _interopRequireDefault(_TableMouseEventsHandler);

var _LockTableCellSelectionState = __webpack_require__(1534);

var _LockTableCellSelectionState2 = _interopRequireDefault(_LockTableCellSelectionState);

var _ColumnSelectionState = __webpack_require__(1535);

var _ColumnSelectionState2 = _interopRequireDefault(_ColumnSelectionState);

var _DelayedSelectionState = __webpack_require__(1536);

var _DelayedSelectionState2 = _interopRequireDefault(_DelayedSelectionState);

var _LockTableRangeSelectedState = __webpack_require__(1537);

var _LockTableRangeSelectedState2 = _interopRequireDefault(_LockTableRangeSelectedState);

var _LockTableHoverState = __webpack_require__(1538);

var _LockTableHoverState2 = _interopRequireDefault(_LockTableHoverState);

var _atBrowserUtils = __webpack_require__(8);

var _IgnoreMouseEventsState = __webpack_require__(1539);

var _IgnoreMouseEventsState2 = _interopRequireDefault(_IgnoreMouseEventsState);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LockTableMouseEventsHandler = function (_TableMouseEventsHand) {
    _inherits(LockTableMouseEventsHandler, _TableMouseEventsHand);

    function LockTableMouseEventsHandler(table, selectionController, hoverController, runnerController) {
        _classCallCheck(this, LockTableMouseEventsHandler);

        var _this = _possibleConstructorReturn(this, (LockTableMouseEventsHandler.__proto__ || Object.getPrototypeOf(LockTableMouseEventsHandler)).call(this, table, selectionController, hoverController));

        _this.runnerController = runnerController;
        _this.cellSelectionState = new _LockTableCellSelectionState2.default(_this);
        _this.columnSelectionState = new _ColumnSelectionState2.default(_this);
        _this.delayedSelectionState = new _DelayedSelectionState2.default(_this);
        _this.rangeSelectedState = new _LockTableRangeSelectedState2.default(_this);
        _this.hoverState = new _LockTableHoverState2.default(_this);
        _this.state = _this.hoverState;
        _this.selectionFinishedListeners = [];
        _this.ignoreMouseEvents = false;

        //should handle mouseUp which occurs beyond table borders
        var self = _this;
        var prevMouseUp = document.onmouseup;
        (0, _jquery2.default)(document).mouseup(function (evt) {
            if (prevMouseUp) prevMouseUp.call(this, evt);
            self.mouseUp(evt, null);
        });
        return _this;
    }

    _createClass(LockTableMouseEventsHandler, [{
        key: "mouseOver",
        value: function mouseOver(evt, cell) {
            this.state.mouseOver(evt, cell);
        }
    }, {
        key: "mouseOut",
        value: function mouseOut(evt, cell) {
            this.state.mouseOut(evt, cell);
        }
    }, {
        key: "mouseDown",
        value: function mouseDown(evt, cell) {
            if (this.isLeftButton(evt)) this.state.mouseDown(evt, cell);
        }
    }, {
        key: "mouseUp",
        value: function mouseUp(evt, cell) {
            if (this.isLeftButton(evt)) this.state.mouseUp(evt, cell);
        }
    }, {
        key: "mouseMove",
        value: function mouseMove(evt, cell) {
            this.state.mouseMove(evt, cell);
        }
    }, {
        key: "isLeftButton",
        value: function isLeftButton(evt) {
            return (0, _atBrowserUtils.whichButtonPressed)((0, _atBrowserUtils.getEventObj)(evt)) == "left";
        }
    }, {
        key: "getRunnerController",
        value: function getRunnerController() {
            return this.runnerController;
        }
    }, {
        key: "setIgnoreMouseEvents",
        value: function setIgnoreMouseEvents(ignore) {
            if (ignore && !this.ignoredState) {
                this.ignoredState = this.state;
                this.state = new _IgnoreMouseEventsState2.default(this);
            } else if (!ignore && this.ignoredState) {
                if (this.selectionController.hasSelection()) {
                    this.state = this.ignoredState;
                    this.ignoredState = undefined;
                } else {
                    this.ignoredState = undefined;
                    var lastHoveredCell = this.state.lastHoveredCell;
                    this.setHoverState();
                    if (lastHoveredCell) this.mouseOver(null, lastHoveredCell);
                }
            }
        }
    }, {
        key: "setCellSelectionState",
        value: function setCellSelectionState(anchorCell) {
            this.getSelectionController().setSelectionAnchor(anchorCell);
            this.getSelectionController().setSelectionType(new _CellSelectionType2.default());
            this.state = this.cellSelectionState;
        }
    }, {
        key: "setColumnSelectionState",
        value: function setColumnSelectionState(anchorCell) {
            this.getSelectionController().setSelectionAnchor(anchorCell);
            this.getSelectionController().setSelectionType(new _DateSelectionType2.default());
            this.getSelectionController().changeSelectionTo(anchorCell.getRow().getTable().getLastSelectableRow().getCell(anchorCell.getColIdx()));
            this.state = this.columnSelectionState;
        }
    }, {
        key: "setHoverState",
        value: function setHoverState() {
            this.state = this.hoverState;
        }
    }, {
        key: "setDelayedSelectionState",
        value: function setDelayedSelectionState(stateSwitcher) {
            this.delayedSelectionState.setDelayedStateSwitcher(stateSwitcher);
            this.state = this.delayedSelectionState;
        }
    }, {
        key: "setRangeSelectedState",
        value: function setRangeSelectedState() {
            this.state = this.rangeSelectedState;
        }
    }, {
        key: "addSelectionFinishedListener",
        value: function addSelectionFinishedListener(listener) {
            this.selectionFinishedListeners.push(listener);
        }
    }, {
        key: "fireSelectionFinished",
        value: function fireSelectionFinished(mouseUpEvent) {
            for (var i = 0; i < this.selectionFinishedListeners.length; i++) {
                this.selectionFinishedListeners[i].call(this.selectionFinishedListeners[i], mouseUpEvent);
            }
        }
    }]);

    return LockTableMouseEventsHandler;
}(_TableMouseEventsHandler2.default);

exports.default = LockTableMouseEventsHandler;

/***/ }),
/* 1533 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _BaseSelectionType2 = __webpack_require__(522);

var _BaseSelectionType3 = _interopRequireDefault(_BaseSelectionType2);

var _SelectedData = __webpack_require__(523);

var _SelectedData2 = _interopRequireDefault(_SelectedData);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CellSelectionType = function (_BaseSelectionType) {
    _inherits(CellSelectionType, _BaseSelectionType);

    function CellSelectionType() {
        _classCallCheck(this, CellSelectionType);

        return _possibleConstructorReturn(this, (CellSelectionType.__proto__ || Object.getPrototypeOf(CellSelectionType)).apply(this, arguments));
    }

    _createClass(CellSelectionType, [{
        key: "accept",
        value: function accept(visitor, selectedRegion) {
            return visitor.visitCellSelection(selectedRegion);
        }
    }, {
        key: "getSelectedData",
        value: function getSelectedData(lockTable, selectedRegion) {
            var userIds = [];
            var userRows = lockTable.getUserRows(selectedRegion.rowMin, selectedRegion.rowMax);
            for (var i = 0; i < userRows.length; i++) {
                userIds.push(userRows[i].getHeaderCell().getValue().id);
            }

            return new _SelectedData2.default(this.getSelectionDateRange(lockTable.getDatesRow(), selectedRegion), userIds);
        }
    }, {
        key: "checkSelectedUserCells",
        value: function checkSelectedUserCells(lockTable, selectedRegion, cellChecker) {
            var userRows = lockTable.getUserRows(selectedRegion.rowMin, selectedRegion.rowMax);
            for (var i = 0; i < userRows.length; i++) {
                var row = userRows[i];
                for (var colIdx = selectedRegion.colMin; colIdx <= selectedRegion.colMax; colIdx++) {
                    if (cellChecker(row.getCell(colIdx))) return true;
                }
            }
            return false;
        }
    }, {
        key: "canBeLocked",
        value: function canBeLocked(lockTable, selectedRegion) {
            return this.checkSelectedUserCells(lockTable, selectedRegion, function (cell) {
                return !cell.getValue().locked;
            });
        }
    }, {
        key: "canBeUnlocked",
        value: function canBeUnlocked(lockTable, selectedRegion) {
            return this.checkSelectedUserCells(lockTable, selectedRegion, function (cell) {
                return cell.getValue().locked;
            });
        }
    }]);

    return CellSelectionType;
}(_BaseSelectionType3.default);

exports.default = CellSelectionType;

/***/ }),
/* 1534 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _LockTableMouseEventsHandlerState = __webpack_require__(252);

var _LockTableMouseEventsHandlerState2 = _interopRequireDefault(_LockTableMouseEventsHandlerState);

var _NullTableRegion = __webpack_require__(144);

var _NullTableRegion2 = _interopRequireDefault(_NullTableRegion);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LockTableCellSelectionState = function (_LockTableMouseEvents) {
    _inherits(LockTableCellSelectionState, _LockTableMouseEvents);

    function LockTableCellSelectionState(mouseEventsHandler) {
        _classCallCheck(this, LockTableCellSelectionState);

        return _possibleConstructorReturn(this, (LockTableCellSelectionState.__proto__ || Object.getPrototypeOf(LockTableCellSelectionState)).call(this, mouseEventsHandler));
    }

    _createClass(LockTableCellSelectionState, [{
        key: "mouseOver",
        value: function mouseOver(evt, cell) {
            // refine columns if we have a row header cell
            if (cell.getColIdx() == 0) cell = cell.getRow().getCell(1);

            var mouseEventsHandler = this.mouseEventsHandler;

            return cell.getRow().accept({
                computeAndSetSelection: function computeAndSetSelection(cell2) {
                    var cell1 = mouseEventsHandler.getSelectionController().getSelectionAnchor();
                    var lowerCell = cell1.getRow().getRowIdx() > cell2.getRow().getRowIdx() ? cell1 : cell2;

                    if (lowerCell.getRow().getChildRows().length > 0) {
                        lowerCell = lowerCell.getRow().getLastChildRow().getCell(lowerCell.getColIdx());
                    }
                    mouseEventsHandler.getSelectionController().changeSelectionTo(lowerCell);
                },
                visitUserRow: function visitUserRow(cell) {
                    this.computeAndSetSelection(cell);
                },
                visitDetailsRow: function visitDetailsRow(cell) {
                    this.computeAndSetSelection(cell.getRow().getParentRow().getCell(cell.getColIdx()));
                },
                visitDatesRow: function visitDatesRow(cell) {
                    cell = cell.getRow().getTable().getCell(cell.getRow().getRowIdx() + 1, cell.getColIdx());
                    cell.getRow().accept(this, cell);
                },
                visitRunnerRow: function visitRunnerRow(cell) {
                    cell = cell.getRow().getTable().getCell(cell.getRow().getRowIdx() + 2, cell.getColIdx());
                    cell.getRow().accept(this, cell);
                },
                visitInactiveRow: function visitInactiveRow(cell) {
                    var anchor = mouseEventsHandler.getSelectionController().getSelectionAnchor();
                    var rowIdx = cell.getRow().getRowIdx() + (anchor.getRow().getRowIdx() > cell.getRow().getRowIdx() ? 1 : -1);
                    mouseEventsHandler.mouseOver(evt, cell.getRow().getTable().getCell(rowIdx, cell.getColIdx()));
                }
            }, cell);
        }
    }, {
        key: "mouseUp",
        value: function mouseUp(evt, cell) {
            var selection = this.mouseEventsHandler.getSelectionController().getSelection();
            if (selection == null || selection == _NullTableRegion2.default) {
                var userCell;

                if (cell) {
                    userCell = cell.getRow().accept({
                        visitUserRow: function visitUserRow(cell) {
                            return cell;
                        },
                        visitDetailsRow: function visitDetailsRow(cell) {
                            return cell.getRow().getParentRow().getCell(cell.getColIdx());
                        },
                        visitDatesRow: function visitDatesRow(cell) {
                            return null;
                        },
                        visitRunnerRow: function visitRunnerRow(cell) {
                            return null;
                        },
                        visitInactiveRow: function visitInactiveRow(cell) {
                            return null;
                        }
                    }, cell);
                } else {
                    userCell = this.mouseEventsHandler.getSelectionController().getSelectionAnchor();
                }

                if (userCell != null) {
                    var lastDetailsRow = userCell.getRow().getLastChildRow();
                    if (lastDetailsRow != null) cell = lastDetailsRow.getCell(userCell.getColIdx());else cell = userCell;

                    this.mouseEventsHandler.getSelectionController().changeSelectionTo(cell);
                    this.mouseEventsHandler.setRangeSelectedState();
                    cell.getRow().getTable().fireUserCellClicked(userCell);
                }
            } else {
                this.mouseEventsHandler.setRangeSelectedState();
                this.mouseEventsHandler.fireSelectionFinished(evt);
            }
        }
    }, {
        key: "mouseMove",
        value: function mouseMove(evt, cell) {
            if (Ext.isIE && window.event && window.event.button == 0) {
                this.mouseEventsHandler.getSelectionController().clearSelection();
                this.mouseEventsHandler.setHoverState();
            }
        }
    }]);

    return LockTableCellSelectionState;
}(_LockTableMouseEventsHandlerState2.default);

exports.default = LockTableCellSelectionState;

/***/ }),
/* 1535 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Ext = __webpack_require__(12);

var _Ext2 = _interopRequireDefault(_Ext);

var _LockTableMouseEventsHandlerState = __webpack_require__(252);

var _LockTableMouseEventsHandlerState2 = _interopRequireDefault(_LockTableMouseEventsHandlerState);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ColumnSelectionState = function (_LockTableMouseEvents) {
    _inherits(ColumnSelectionState, _LockTableMouseEvents);

    function ColumnSelectionState(mouseEventsHandler) {
        _classCallCheck(this, ColumnSelectionState);

        return _possibleConstructorReturn(this, (ColumnSelectionState.__proto__ || Object.getPrototypeOf(ColumnSelectionState)).call(this, mouseEventsHandler));
    }

    _createClass(ColumnSelectionState, [{
        key: "resolveTargetCell",
        value: function resolveTargetCell(cell) {
            cell = cell.getRow().getTable().getLastSelectableRow().getCell(cell.getColIdx());

            // refine columns if we have a row header cell
            if (cell.getColIdx() == 0) cell = cell.getRow().getCell(1);

            return cell;
        }
    }, {
        key: "mouseOver",
        value: function mouseOver(evt, cell) {
            this.mouseEventsHandler.getSelectionController().changeSelectionTo(this.resolveTargetCell(cell));
        }
    }, {
        key: "mouseUp",
        value: function mouseUp(evt, cell) {
            this.mouseEventsHandler.setRangeSelectedState();
            this.mouseEventsHandler.fireSelectionFinished(evt);
        }
    }, {
        key: "mouseMove",
        value: function mouseMove(evt, cell) {
            if (_Ext2.default.isIE && window.event && window.event.button == 0) {
                this.mouseEventsHandler.getSelectionController().clearSelection();
                this.mouseEventsHandler.setHoverState();
            }
        }
    }]);

    return ColumnSelectionState;
}(_LockTableMouseEventsHandlerState2.default);

exports.default = ColumnSelectionState;

/***/ }),
/* 1536 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _LockTableMouseEventsHandlerState = __webpack_require__(252);

var _LockTableMouseEventsHandlerState2 = _interopRequireDefault(_LockTableMouseEventsHandlerState);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DelayedSelectionState = function (_LockTableMouseEvents) {
    _inherits(DelayedSelectionState, _LockTableMouseEvents);

    function DelayedSelectionState(mouseEventsHandler) {
        _classCallCheck(this, DelayedSelectionState);

        var _this = _possibleConstructorReturn(this, (DelayedSelectionState.__proto__ || Object.getPrototypeOf(DelayedSelectionState)).call(this, mouseEventsHandler));

        _this.stateSwitcher = undefined;
        return _this;
    }

    _createClass(DelayedSelectionState, [{
        key: "setDelayedStateSwitcher",
        value: function setDelayedStateSwitcher(stateSwitcher) {
            this.stateSwitcher = stateSwitcher;
        }
    }, {
        key: "mouseOut",
        value: function mouseOut(evt, cell) {
            this.stateSwitcher(this.mouseEventsHandler);
            this.mouseEventsHandler.mouseOut(evt, cell);
        }
    }, {
        key: "mouseUp",
        value: function mouseUp(evt, cell) {
            this.mouseEventsHandler.setHoverState();
            this.mouseEventsHandler.mouseOver(null, cell);
        }
    }]);

    return DelayedSelectionState;
}(_LockTableMouseEventsHandlerState2.default);

exports.default = DelayedSelectionState;

/***/ }),
/* 1537 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _LockTableMouseEventsHandlerState = __webpack_require__(252);

var _LockTableMouseEventsHandlerState2 = _interopRequireDefault(_LockTableMouseEventsHandlerState);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LockTableRangeSelectedState = function (_LockTableMouseEvents) {
    _inherits(LockTableRangeSelectedState, _LockTableMouseEvents);

    function LockTableRangeSelectedState(mouseEventsHandler) {
        _classCallCheck(this, LockTableRangeSelectedState);

        return _possibleConstructorReturn(this, (LockTableRangeSelectedState.__proto__ || Object.getPrototypeOf(LockTableRangeSelectedState)).call(this, mouseEventsHandler));
    }

    _createClass(LockTableRangeSelectedState, [{
        key: "mouseDown",
        value: function mouseDown(evt, cell) {
            if (cell.getColIdx() == 0) {
                this.mouseEventsHandler.getSelectionController().clearSelection();
                this.mouseEventsHandler.setHoverState();
                return;
            }

            var mouseEventsHandler = this.mouseEventsHandler;
            cell.getRow().accept({
                visitUserRow: function visitUserRow(cell) {
                    mouseEventsHandler.getSelectionController().clearSelection();
                    mouseEventsHandler.setDelayedSelectionState(function () {
                        mouseEventsHandler.setCellSelectionState(cell);
                    });
                },
                visitDetailsRow: function visitDetailsRow(cell) {
                    mouseEventsHandler.getSelectionController().clearSelection();
                    mouseEventsHandler.setDelayedSelectionState(function () {
                        var parentCell = cell.getRow().getParentRow().getCell(cell.getColIdx());
                        mouseEventsHandler.setCellSelectionState(parentCell);
                    });
                },
                visitDatesRow: function visitDatesRow(cell) {
                    var singleDateSelected = mouseEventsHandler.getSelectionController().visitSelection({
                        visitCellSelection: function visitCellSelection(selection) {
                            return false;
                        },
                        visitDateSelection: function visitDateSelection(selection) {
                            return selection.colMax == selection.colMin;
                        },
                        visitRunnerSelection: function visitRunnerSelection(selection) {
                            return false;
                        }
                    });
                    mouseEventsHandler.getSelectionController().clearSelection();
                    if (singleDateSelected) {
                        mouseEventsHandler.setColumnSelectionState(cell);
                    } else mouseEventsHandler.setDelayedSelectionState(function () {
                        mouseEventsHandler.setColumnSelectionState(cell);
                    });
                },
                visitRunnerRow: function visitRunnerRow(cell) {
                    var runnerPositionChanged = mouseEventsHandler.getSelectionController().visitSelection({
                        visitCellSelection: function visitCellSelection(selection) {
                            return false;
                        },
                        visitDateSelection: function visitDateSelection(selection) {
                            return false;
                        },
                        visitRunnerSelection: function visitRunnerSelection(selection) {
                            return true;
                        }
                    });

                    //clear selection after selection type checked
                    mouseEventsHandler.getSelectionController().clearSelection();
                    if (runnerPositionChanged) {
                        mouseEventsHandler.setHoverState();
                        mouseEventsHandler.mouseOver(null, cell);
                    } else {
                        mouseEventsHandler.setDelayedSelectionState(function () {
                            mouseEventsHandler.setHoverState();
                        });
                    }
                },
                visitInactiveRow: function visitInactiveRow(cell) {
                    mouseEventsHandler.getSelectionController().clearSelection();
                    mouseEventsHandler.setHoverState();
                }
            }, cell);
        }
    }, {
        key: "mouseOver",
        value: function mouseOver(evt, cell) {
            if (!this.mouseEventsHandler.getSelectionController().hasSelection()) {
                this.mouseEventsHandler.setHoverState();
                this.mouseEventsHandler.mouseOver(evt, cell);
            }
        }
    }]);

    return LockTableRangeSelectedState;
}(_LockTableMouseEventsHandlerState2.default);

exports.default = LockTableRangeSelectedState;

/***/ }),
/* 1538 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _LockTableMouseEventsHandlerState = __webpack_require__(252);

var _LockTableMouseEventsHandlerState2 = _interopRequireDefault(_LockTableMouseEventsHandlerState);

var _atBrowserUtils = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LockTableHoverState = function (_LockTableMouseEvents) {
    _inherits(LockTableHoverState, _LockTableMouseEvents);

    function LockTableHoverState(mouseEventsHandler) {
        _classCallCheck(this, LockTableHoverState);

        return _possibleConstructorReturn(this, (LockTableHoverState.__proto__ || Object.getPrototypeOf(LockTableHoverState)).call(this, mouseEventsHandler));
    }

    _createClass(LockTableHoverState, [{
        key: "mouseOver",
        value: function mouseOver(evt, cell) {
            //ignore hover for row header
            if (cell.getColIdx() == 0) return;

            //ignore hover if cell already hovered
            if (this.mouseEventsHandler.hoverController.isHovered(cell)) return;

            var mouseEventsHandler = this.mouseEventsHandler;
            cell.getRow().accept({
                visitUserRow: function visitUserRow(cell) {
                    var endCell = cell;
                    if (cell.getRow().getChildRows().length > 0) {
                        endCell = cell.getRow().getLastChildRow().getCell(cell.getColIdx());
                    }
                    mouseEventsHandler.hoverController.hover(cell, endCell);
                },
                visitDetailsRow: function visitDetailsRow(cell) {
                    this.visitUserRow(cell.getRow().getParentRow().getCell(cell.getColIdx()));
                },
                visitDatesRow: function visitDatesRow(cell) {
                    mouseEventsHandler.hoverController.hover(cell, cell);
                },
                visitRunnerRow: function visitRunnerRow(cell) {
                    mouseEventsHandler.getRunnerController().hover(cell);
                },
                visitInactiveRow: function visitInactiveRow(cell) {
                    //do nothing for inactive row
                }
            }, cell);
        }
    }, {
        key: "mouseOut",
        value: function mouseOut(evt, cell) {
            evt = (0, _atBrowserUtils.getEventObj)(evt);
            if (this.shouldRemoveHover(cell, getTargetElement(evt))) {
                var mouseEventsHandler = this.mouseEventsHandler;
                cell.getRow().accept({
                    visitUserRow: function visitUserRow(cell) {
                        mouseEventsHandler.hoverController.unhover();
                    },
                    visitDetailsRow: function visitDetailsRow(cell) {
                        mouseEventsHandler.hoverController.unhover();
                    },
                    visitDatesRow: function visitDatesRow(cell) {
                        mouseEventsHandler.hoverController.unhover();
                    },
                    visitRunnerRow: function visitRunnerRow(cell) {
                        mouseEventsHandler.getRunnerController().unhover(cell);
                    },
                    visitInactiveRow: function visitInactiveRow(cell) {}
                }, cell);
            }
        }
    }, {
        key: "shouldRemoveHover",
        value: function shouldRemoveHover(cell, targetElement) {
            var targetCell = null;
            while (targetElement) {
                if (targetElement.cellObj) {
                    targetCell = targetElement.cellObj;
                    break;
                }
                targetElement = targetElement.parentNode;
            }

            if (targetCell == null) return true;

            return !this.hasEqualHover(cell, targetCell);
        }
    }, {
        key: "hasEqualHover",
        value: function hasEqualHover(cell1, cell2) {
            if (cell1 == cell2) return true;

            //only details and user cells in the same column can have equal hovers
            if (cell1.getColIdx() != cell2.getColIdx()) return false;

            var userCellGetter = {
                visitUserRow: function visitUserRow(cell) {
                    return cell;
                },
                visitDetailsRow: function visitDetailsRow(cell) {
                    return cell.getRow().getParentRow().getCell(cell.getColIdx());
                },
                visitDatesRow: function visitDatesRow(cell) {
                    return null;
                },
                visitRunnerRow: function visitRunnerRow(cell) {
                    return null;
                },
                visitInactiveRow: function visitInactiveRow(cell) {
                    return null;
                }
            };

            var userDayCell1 = cell1.getRow().accept(userCellGetter, cell1);
            var userDayCell2 = cell2.getRow().accept(userCellGetter, cell2);

            return userDayCell1 != null && userDayCell1 == userDayCell2;
        }
    }, {
        key: "mouseDown",
        value: function mouseDown(evt, cell) {
            //ignore selection start for row headers
            if (cell.getColIdx() == 0) return;

            var mouseEventsHandler = this.mouseEventsHandler;
            cell.getRow().accept({
                visitUserRow: function visitUserRow(cell) {
                    mouseEventsHandler.hoverController.unhover();
                    mouseEventsHandler.setCellSelectionState(cell);
                },
                visitDetailsRow: function visitDetailsRow(cell) {
                    mouseEventsHandler.hoverController.unhover();
                    mouseEventsHandler.setCellSelectionState(cell.getRow().getParentRow().getCell(cell.getColIdx()));
                },
                visitDatesRow: function visitDatesRow(cell) {
                    mouseEventsHandler.hoverController.unhover();
                    mouseEventsHandler.setColumnSelectionState(cell);
                },
                visitRunnerRow: function visitRunnerRow(cell) {},
                visitInactiveRow: function visitInactiveRow(cell) {}
            }, cell);
        }
    }, {
        key: "mouseUp",
        value: function mouseUp(evt, cell) {
            if (cell == null) return;

            if (cell.getColIdx() == 0) return;

            var mouseEventsHandler = this.mouseEventsHandler;

            cell.getRow().accept({
                visitUserRow: function visitUserRow(cell) {},
                visitDetailsRow: function visitDetailsRow(cell) {},
                visitDatesRow: function visitDatesRow(cell) {},
                visitRunnerRow: function visitRunnerRow(cell) {
                    mouseEventsHandler.getSelectionController().clearSelection();
                    mouseEventsHandler.getRunnerController().setNewLastLockedCell(cell);
                    if (mouseEventsHandler.getSelectionController().hasSelection()) {
                        mouseEventsHandler.setRangeSelectedState();
                        mouseEventsHandler.fireSelectionFinished(evt);
                    }
                },
                visitInactiveRow: function visitInactiveRow(cell) {}
            }, cell);
        }
    }]);

    return LockTableHoverState;
}(_LockTableMouseEventsHandlerState2.default);

exports.default = LockTableHoverState;

/***/ }),
/* 1539 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _LockTableMouseEventsHandlerState = __webpack_require__(252);

var _LockTableMouseEventsHandlerState2 = _interopRequireDefault(_LockTableMouseEventsHandlerState);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var IgnoreMouseEventsState = function (_LockTableMouseEvents) {
    _inherits(IgnoreMouseEventsState, _LockTableMouseEvents);

    function IgnoreMouseEventsState(mouseEventsHandler) {
        _classCallCheck(this, IgnoreMouseEventsState);

        var _this = _possibleConstructorReturn(this, (IgnoreMouseEventsState.__proto__ || Object.getPrototypeOf(IgnoreMouseEventsState)).call(this, mouseEventsHandler));

        _this.lastHoveredCell = null;
        return _this;
    }

    return IgnoreMouseEventsState;
}(_LockTableMouseEventsHandlerState2.default);

exports.default = IgnoreMouseEventsState;

/***/ }),
/* 1540 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dhtml_title = __webpack_require__(470);

var _dhtml_title2 = _interopRequireDefault(_dhtml_title);

var _date_format = __webpack_require__(16);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _user_time = __webpack_require__(30);

var _user_time2 = _interopRequireDefault(_user_time);

var _atBrowserUtils = __webpack_require__(8);

var _atUtils = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var LockTableTooltipController = function () {
    function LockTableTooltipController(userMap, tooltipDivId, weekDayNames) {
        _classCallCheck(this, LockTableTooltipController);

        this.userMap = userMap;
        this.title = new _dhtml_title2.default(tooltipDivId, true, true);
        this.dateFormat = new _date_format.DateFormat("MMM dd");
        this.dateFormat = new _date_format.DateFormat("MMM dd, yyyy");
        this.tooltipsEnabled = true;
        this.hiddenTooltip = null;
        this.weekDayNames = weekDayNames;
    }

    _createClass(LockTableTooltipController, [{
        key: "enableTooltips",
        value: function enableTooltips(enabled) {
            this.tooltipsEnabled = enabled;
            if (!enabled) {
                this.title.immediateHide();
            } else if (this.hiddenTooltip) {
                this.showTooltip(this.hiddenTooltip.getTooltip, this.hiddenTooltip.x, this.hiddenTooltip.y);
                this.hiddenTooltip = null;
            }
        }
    }, {
        key: "correctY",
        value: function correctY(y, evt) {
            var height = (0, _atBrowserUtils.getObjectHeight)(this.title.getDiv().id);
            var horizontalScrollHeight = 16;
            var oversizeY = y + height - (0, _atBrowserUtils.getBodyScrollTop)() - (0, _atBrowserUtils.getInsideWindowHeight)() + horizontalScrollHeight;
            if (oversizeY > 0) y = evt.clientY + (0, _atBrowserUtils.getBodyScrollTop)() - 2 - height;
            return y;
        }
    }, {
        key: "addTooltip",
        value: function addTooltip(element, getTooltip) {
            var dx = 12;
            var dy = 14;
            var self = this;
            element.hasCustomTooltip = true;

            var prevOnmouseover = element.onmouseover;
            element.onmouseover = function (evt) {
                if (prevOnmouseover) prevOnmouseover.call(this, evt);

                evt = (0, _atBrowserUtils.getEventObj)(evt);
                var x = evt.clientX + (0, _atBrowserUtils.getBodyScrollLeft)() + dx;
                var y = evt.clientY + (0, _atBrowserUtils.getBodyScrollTop)() + dy;

                y = self.correctY(y, evt);

                self.showTooltip(getTooltip, x, y);
            };

            var prevOnmousemove = element.onmousemove;
            element.onmousemove = function (evt) {
                if (prevOnmousemove) prevOnmousemove.call(this, evt);

                evt = (0, _atBrowserUtils.getEventObj)(evt);
                var x = evt.clientX + (0, _atBrowserUtils.getBodyScrollLeft)() + dx;
                var y = evt.clientY + (0, _atBrowserUtils.getBodyScrollTop)() + dy;

                y = self.correctY(y, evt);

                self.moveTooltip(x, y);
            };

            var prevOnmouseout = element.onmouseout;
            element.onmouseout = function (evt) {
                if (prevOnmouseout) prevOnmouseout.call(this, evt);

                var hideTooltip = true;
                var target = getTargetElement((0, _atBrowserUtils.getEventObj)(evt));
                while (target) {
                    if (target.hasCustomTooltip) {
                        hideTooltip = false;
                        break;
                    } else {
                        target = target.parentElement;
                    }
                }

                if (hideTooltip) self.hideTooltip();
            };
        }
    }, {
        key: "addDayTooltip",
        value: function addDayTooltip(td, userId, date, leaveInfo, overtimeInfo, userDayInfo) {
            var self = this;
            this.addTooltip(td, function () {
                return self.getDayTooltipText(userId, date, leaveInfo, overtimeInfo, userDayInfo);
            });
        }
    }, {
        key: "addTaskTooltip",
        value: function addTaskTooltip(element, taskBean) {
            var self = this;
            this.addTooltip(element, function () {
                return self.getTaskTooltipText(taskBean);
            });
        }
    }, {
        key: "addTaskDayTooltip",
        value: function addTaskDayTooltip(element, userId, date, taskBean, userDayInfo) {
            var self = this;
            this.addTooltip(element, function () {
                return self.getTaskDayTooltipText(userId, date, taskBean, userDayInfo);
            });
        }
    }, {
        key: "addNotAvailableTasksTooltip",
        value: function addNotAvailableTasksTooltip(element, taskBean) {
            var self = this;
            this.addTooltip(element, function () {
                return self.getNotAvailableTasksTooltipText(taskBean);
            });
        }
    }, {
        key: "addLeaveTooltip",
        value: function addLeaveTooltip(element, userId, date, leaveInfo, userDayInfo) {
            var self = this;
            this.addTooltip(element, function () {
                return self.getLeaveDayTooltipText(userId, date, leaveInfo, userDayInfo);
            });
        }
    }, {
        key: "getTaskTooltipText",
        value: function getTaskTooltipText(taskBean) {
            return this.getCPTNamesInTextArray(taskBean, "", "taskName", "customerProject", true, false).join("");
        }
    }, {
        key: "getDayTooltipText",
        value: function getDayTooltipText(userId, date, leaveInfo, overtimeInfo, userDayInfo) {
            var result = this.getUserNameAndDateInTextArray(userId, date);

            var showLeaveInfo = false;
            var showSeparator = false;
            if ((typeof leaveInfo === "undefined" ? "undefined" : _typeof(leaveInfo)) != ( true ? "undefined" : _typeof(undefined)) && leaveInfo.time > 0) {
                result = result.concat(this.getLeaveInfoInTextArray(leaveInfo));
                showLeaveInfo = true;
            }
            //alert(overtime)
            if (overtimeInfo.time != 0 || overtimeInfo.showOvertimeWhenZero) {
                result = result.concat(this.getOvertimeInTextArray(overtimeInfo, showLeaveInfo));
                showSeparator = true;
            }

            showSeparator = showLeaveInfo || showSeparator;
            result = result.concat(this.getDayInfoInTextArray(userDayInfo, showSeparator));
            return result.join("");
        }
    }, {
        key: "getTaskDayTooltipText",
        value: function getTaskDayTooltipText(userId, date, taskBean, userDayInfo) {
            var result = this.getUserNameAndDateInTextArray(userId, date);

            result = result.concat(this.getCPTNamesInTextArray(taskBean, "timeTooltipTaskNameWithStatus ellipsis", "timeTooltipTaskName", "timeTooltipCustomerProjectNames ellipsis", false, true));

            result = result.concat(this.getDayInfoInTextArray(userDayInfo, true));
            return result.join("");
        }
    }, {
        key: "getNotAvailableTasksTooltipText",
        value: function getNotAvailableTasksTooltipText(taskBean) {
            var result = this.getCPTNamesInTextArray(taskBean, "", "taskName", "customerProject", true, false).join("");
            result = result.concat(createDiv("separator", _messageResource2.default.getEscapedMessage("common.tooltip.not_assigned_task")));
            return createDiv("notAvailableTasksTooltipText", result);
        }
    }, {
        key: "getLeaveDayTooltipText",
        value: function getLeaveDayTooltipText(userId, date, leaveInfo, userDayInfo) {
            var result = this.getUserNameAndDateInTextArray(userId, date);

            if ((typeof leaveInfo === "undefined" ? "undefined" : _typeof(leaveInfo)) != ( true ? "undefined" : _typeof(undefined)) && leaveInfo.time > 0) {
                result = result.concat(this.getLeaveInfoInTextArray(leaveInfo, true));
            }
            result = result.concat(this.getDayInfoInTextArray(userDayInfo, true));
            return result.join("");
        }
    }, {
        key: "getUserNameAndDateInTextArray",
        value: function getUserNameAndDateInTextArray(userId, date) {
            return ['<span class="userNameAndDate">', this.getFullName(userId), " / <span class='cellDate'>", this.weekDayNames[date.getDay()], ", ", this.dateFormat.formatDate(date), "</span></span>"];
        }
    }, {
        key: "getCPTNamesInTextArray",
        value: function getCPTNamesInTextArray(taskBean, taskNameWithStatusClass, taskNameClass, CPNamesClass, useBR, shouldTruncate) {
            return ['<span class="', taskNameWithStatusClass, '">', '<span class="', taskNameClass, '">', shouldTruncate ? this.truncateString(taskBean.name, 60 - (taskBean.completed ? _messageResource2.default.getMessage('common.completed').length : 0)) : taskBean.name, '</span>', taskBean.completed ? ' <span class="completed">(' + _messageResource2.default.getMessage('common.completed') + ')</span>' : '', '</span>', useBR ? '<br/>' : '', '<span class="', CPNamesClass, '">', shouldTruncate ? this.truncateString(taskBean.customerName, 35) : taskBean.customerName, ' / ', shouldTruncate ? this.truncateString(taskBean.projectName, 35) : taskBean.projectName, '</span>'];
        }
    }, {
        key: "getDayInfoInTextArray",
        value: function getDayInfoInTextArray(userDayInfo, showSeparator) {
            showSeparator = showSeparator && (userDayInfo.locked || userDayInfo.approveInfo && (userDayInfo.approveInfo.approved || userDayInfo.approveInfo.autoApproved));
            var self = this;
            var result = [];
            result.push('<div class="infoDayDiv', showSeparator ? ' daySeparator' : '', '">');
            if (userDayInfo.approveInfo) {
                result.push(this.getApproveInfoInTextArray(userDayInfo.approveInfo));
            }
            if (userDayInfo.locked) {
                result.push(self.getLockedInfoInTextArray(userDayInfo));
            }
            result.push('</div>');
            return result;
        }
    }, {
        key: "getLockedInfoInTextArray",
        value: function getLockedInfoInTextArray(userDayInfo) {
            var result = [];
            result.push('<div class="lockInfoDiv tooltipText">');
            result.push(_messageResource2.default.getMessage("lock_tt.table.tooltip.locked"));
            var name = this.getFullName(userDayInfo.whoLocked);
            var lockDate = this.dateFormat.formatDate(userDayInfo.lockDate);
            if (name) {
                result.push(_messageResource2.default.getMessage("lock_tt.table.tooltip.by", [name]));
            } // if the user is unknown, just skipping the "by" part
            result.push(_messageResource2.default.getMessage("lock_tt.table.tooltip.on", [lockDate]));
            result.push('</div>');
            return result.join("");
        }
    }, {
        key: "getApproveInfoInTextArray",
        value: function getApproveInfoInTextArray(approveInfo, showSeparator) {
            var result = [];
            if (approveInfo.autoApproved || approveInfo.approved) {
                result.push('<div class="approveInfoDiv tooltipText">');
                result.push(_messageResource2.default.getMessage("lock_tt.table.tooltip.approved"));
                if (approveInfo.autoApproved && approveInfo.whoApproved == null) {
                    result.push(" ");
                    result.push(_messageResource2.default.getMessage("lock_tt.table.tooltip.approved.automatically"));
                } else {
                    var name;
                    if (approveInfo.whoApproved != null) name = this.getFullName(approveInfo.whoApproved);else name = _messageResource2.default.getMessage("lock_tt.table.tooltip.approved.system");
                    var approvedDate = this.dateFormat.formatDate(approveInfo.approvedDate);
                    result.push(_messageResource2.default.getMessage("lock_tt.table.tooltip.by", [name]));
                    result.push(_messageResource2.default.getMessage("lock_tt.table.tooltip.on", [approvedDate]));
                }
                result.push('</div>');
            }
            return result.join("");
        }
    }, {
        key: "getLeaveInfoInTextArray",
        value: function getLeaveInfoInTextArray(leaveInfo, showWithoutTime) {
            var result = [];

            result.push("<div class='leaveInfo' style='background-image: url(", '"', leaveInfo.leaveInfo.iconPath, '"', ")'>", this.truncateString(leaveInfo.leaveInfo.name, 35));
            if (!showWithoutTime) result.push("&nbsp;&nbsp;<span class='time'>", _user_time2.default.formatTime(leaveInfo.time), "</span>");
            result.push("</div>");
            return result;
        }
    }, {
        key: "getOvertimeInTextArray",
        value: function getOvertimeInTextArray(overtimeInfo, shouldShift) {
            var result = [];

            result.push("<div class='overtimeInfo", shouldShift ? "Shifted" : "", "'>");
            if (overtimeInfo.showTime) {
                result.push(_messageResource2.default.getMessage("overtime.overtime"));
                result.push("&nbsp;&nbsp;<span class='time'>", _user_time2.default.formatTime(overtimeInfo.time), "</span>");
            } else result.push(overtimeInfo.overtimeText);
            result.push("</div>");
            return result;
        }
    }, {
        key: "getFullName",
        value: function getFullName(userId) {
            var user = this.userMap[userId];
            if (user) {
                return (0, _atUtils.escapeHtmlSymbols)(user.formatNameFML());
            } else {
                return null;
            }
        }
    }, {
        key: "showTooltip",
        value: function showTooltip(getTooltip, x, y) {
            if (this.tooltipsEnabled) {
                this.title.show(getTooltip(), null, x, y);
            } else {
                this.hiddenTooltip = { getTooltip: getTooltip, x: x, y: y };
            }
        }
    }, {
        key: "moveTooltip",
        value: function moveTooltip(x, y) {
            if (this.tooltipsEnabled) {
                this.title.shiftTo(x, y);
            } else if (this.hiddenTooltip) {
                this.hiddenTooltip.x = x;
                this.hiddenTooltip.y = y;
            }
        }
    }, {
        key: "hideTooltip",
        value: function hideTooltip() {
            if (this.tooltipsEnabled) {
                this.title.immediateHide();
            } else {
                this.hiddenTooltip = null;
            }
        }
    }, {
        key: "truncateString",
        value: function truncateString(stringToTruncate, maxLength) {
            var length = maxLength - 3;
            return stringToTruncate.length <= maxLength ? stringToTruncate : stringToTruncate.substr(0, length) + "...";
        }
    }]);

    return LockTableTooltipController;
}();

exports.default = LockTableTooltipController;

/***/ }),
/* 1541 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _NullTableRegion = __webpack_require__(144);

var _NullTableRegion2 = _interopRequireDefault(_NullTableRegion);

var _TableRegion = __webpack_require__(145);

var _TableRegion2 = _interopRequireDefault(_TableRegion);

var _DateRange = __webpack_require__(304);

var _DateRange2 = _interopRequireDefault(_DateRange);

var _RunnerSelectionType = __webpack_require__(817);

var _RunnerSelectionType2 = _interopRequireDefault(_RunnerSelectionType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var RunnerController = function () {
    function RunnerController(lastLockedDate, selectionController, hoverController, allLockedTillDateBeyondDateRange) {
        _classCallCheck(this, RunnerController);

        this.selectionController = selectionController;
        this.hoverController = hoverController;
        this.lastLockedDate = lastLockedDate;
        this.allLockedTillDateBeyondDateRange = allLockedTillDateBeyondDateRange;
        this.newLastLockedCell = null;
        this.selectedRegion = _NullTableRegion2.default;
        this.listeners = [];

        var runnerController = this;
        this.selectingAffectedCells = false;
        this.selectionController.addSelectionChangeListener(function (selectionChangeEvent) {
            if (!runnerController.selectingAffectedCells) runnerController.removeSelection();
        });
    }

    _createClass(RunnerController, [{
        key: "addPositionChangeListener",
        value: function addPositionChangeListener(listener) {
            this.listeners.push(listener);
        }
    }, {
        key: "firePositionChangeEvent",
        value: function firePositionChangeEvent() {
            for (var i = 0; i < this.listeners.length; i++) {
                this.listeners[i].call(this.listeners[i], this.lastLockedDate);
            }
        }
    }, {
        key: "getLastLockedDate",
        value: function getLastLockedDate() {
            return this.lastLockedDate;
        }
    }, {
        key: "hover",
        value: function hover(cell) {
            if (!this.hasSelection()) this.moveLockTo(cell, false);
        }
    }, {
        key: "unhover",
        value: function unhover(cell) {
            if (!this.hasSelection()) {
                this.newLastLockedCell = null;
                this.hoverController.unhover();
            }
        }
    }, {
        key: "moveLockTo",
        value: function moveLockTo(cell, setSelection) {
            if (this.lastLockedDate == null || this.lastLockedDate < cell.getValue().date) {
                this.moveLockForward(cell, setSelection);
            } else if (this.lastLockedDate > cell.getValue().date) {
                this.moveLockBack(cell, setSelection);
            }
        }
    }, {
        key: "moveLockBack",
        value: function moveLockBack(cell, setSelection) {
            this.newLastLockedCell = cell;
            this.hoverController.hover(cell, this.getLastLockedCell(cell.getRow()));

            if (setSelection) {
                this.selectedRegion = this.hoverController.hoverRegion;
                this.hoverController.unhover();
                var datesRowCells = this.selectionController.lockTable.datesRow.cells;
                if (this.selectedRegion.colMax !== this.selectedRegion.colMin) {
                    this.selectAffectedRegion(cell.getRow().getTable(), this.selectedRegion.colMin + 1, this.selectedRegion.colMax);
                } else if (this.selectedRegion.colMin === datesRowCells[datesRowCells.length - 1].colIdx && datesRowCells[datesRowCells.length - 1].value.date < this.lastLockedDate) {
                    this.selectAffectedRegion(cell.getRow().getTable(), this.selectedRegion.colMin, this.selectedRegion.colMax);
                } else {
                    this.selectAffectedCells(null, null);
                }
            }
        }
    }, {
        key: "moveLockForward",
        value: function moveLockForward(cell, setSelection) {
            this.newLastLockedCell = cell;
            this.hoverController.hover(this.getLastLockedCell(cell.getRow()), cell);

            if (setSelection) {
                this.selectedRegion = this.hoverController.hoverRegion;
                this.hoverController.unhover();
                var xStart = this.selectedRegion.colMin;
                if (cell.getRow().getCell(xStart).getValue().runnerOver) xStart = xStart + 1;

                this.selectAffectedRegion(cell.getRow().getTable(), xStart, this.selectedRegion.colMax);
            }
        }
    }, {
        key: "selectAffectedRegion",
        value: function selectAffectedRegion(lockTable, xStart, xEnd) {
            this.selectAffectedCells(lockTable.getDatesRow().getCell(xStart), lockTable.getLastSelectableRow().getCell(xEnd));
        }
    }, {
        key: "selectAffectedCells",
        value: function selectAffectedCells(startCell, endCell) {
            this.selectingAffectedCells = true;
            try {
                this.selectionController.setSelectionAnchor(startCell);
                this.selectionController.setSelectionType(new _RunnerSelectionType2.default());
                if (endCell) this.selectionController.changeSelectionTo(endCell);
            } finally {
                this.selectingAffectedCells = false;
            }
        }
    }, {
        key: "getLastLockedCell",
        value: function getLastLockedCell(runnerRow) {
            if (this.lastLockedDate == null || runnerRow.getCell(1).getValue().date > this.lastLockedDate) {
                return runnerRow.getCell(1);
            }

            var lastCell = runnerRow.getCell(runnerRow.getCells().length - 1);
            if (lastCell.getValue().date < this.lastLockedDate) {
                return lastCell;
            }

            for (var i = 1; i <= runnerRow.getCells().length; i++) {
                var curCell = runnerRow.getCell(i);
                if (curCell.getValue().date.getTime() == this.lastLockedDate.getTime()) {
                    return curCell;
                }
            }
        }
    }, {
        key: "removeSelection",
        value: function removeSelection() {
            if (!this.hasSelection()) return;

            var updatedRegion = this.selectedRegion;
            var runnerRow = this.newLastLockedCell.getRow();

            this.selectedRegion = _NullTableRegion2.default;
            this.newLastLockedCell = null;

            for (var i = 1; i < runnerRow.getCells().length; i++) {
                if (updatedRegion.contains(runnerRow.getRowIdx(), i)) {
                    runnerRow.getCell(i).updateUI();
                }
            }
        }
    }, {
        key: "setNewLastLockedCell",
        value: function setNewLastLockedCell(cell) {
            this.removeSelection();

            if (cell != null) {
                this.moveLockTo(cell, true);
            }
        }
    }, {
        key: "isSelected",
        value: function isSelected(cell) {
            return this.hasSelection() && this.selectedRegion.contains(cell.getRow().getRowIdx(), cell.getColIdx());
        }
    }, {
        key: "getNextDate",
        value: function getNextDate(date) {
            return Date.create(date.getFullYear(), date.getMonth(), date.getDate() + 1);
        }
    }, {
        key: "getPreviousDate",
        value: function getPreviousDate(date) {
            return Date.create(date.getFullYear(), date.getMonth(), date.getDate() - 1);
        }
    }, {
        key: "getSelectedDateRange",
        value: function getSelectedDateRange() {
            if (this.newLastLockedCell != null) {
                if (this.lastLockedDate == null) {
                    return new _DateRange2.default(null, this.newLastLockedCell.getValue().date);
                } else if (this.newLastLockedCell.getValue().date > this.lastLockedDate) {
                    return new _DateRange2.default(this.getNextDate(this.lastLockedDate), this.newLastLockedCell.getValue().date);
                } else return new _DateRange2.default(this.getNextDate(this.newLastLockedCell.getValue().date), this.lastLockedDate);
            }
            return null;
        }
    }, {
        key: "isNewLastLocked",
        value: function isNewLastLocked(cell) {
            return this.newLastLockedCell == cell;
        }
    }, {
        key: "getNewLastLockDate",
        value: function getNewLastLockDate() {
            return this.newLastLockedCell != null ? this.newLastLockedCell.getValue().date : null;
        }
    }, {
        key: "hasSelection",
        value: function hasSelection() {
            return this.selectedRegion != _NullTableRegion2.default;
        }
    }, {
        key: "regionLocked",


        /*
         * Checks locks for specified region and move runner forward if needed.
         */
        value: function regionLocked(lockTable, lockedRegion) {
            var runnerRow = lockTable.rows[0];
            var previousDate = this.getPreviousDate(runnerRow.getCell(lockedRegion.colMin).getValue().date);

            if (this.lastLockedDate == null || previousDate > this.lastLockedDate) {
                return;
            }

            var lastLockedCell = 0;
            var userRows = lockTable.getUserRows();
            for (var colIdx = lockedRegion.colMin; colIdx < runnerRow.getCells().length; colIdx++) {
                var runnerCell = runnerRow.getCell(colIdx);
                if (!runnerCell.getValue().runnerOver) {
                    if (runnerCell.getValue().hasUnlockedInvisibleUser) {
                        break;
                    }

                    var allLockedDate = true;
                    for (var rowIdx = 0; rowIdx < userRows.length; rowIdx++) {
                        var userCell = userRows[rowIdx].getCell(colIdx);
                        if (!userCell.getValue().locked) {
                            allLockedDate = false;
                            break;
                        }
                    }

                    if (allLockedDate) {
                        runnerCell.getValue().runnerOver = true;
                        lastLockedCell = colIdx;
                    } else {
                        break;
                    }
                }
            }

            if (lastLockedCell > 0) {
                if (this.allLockedTillDateBeyondDateRange != null && lastLockedCell == runnerRow.getCells().length - 1) {
                    this.lastLockedDate = this.allLockedTillDateBeyondDateRange;
                } else {
                    this.lastLockedDate = runnerRow.getCell(lastLockedCell).getValue().date;
                }
                this.firePositionChangeEvent();

                var startColumn = lockedRegion.colMin > 1 ? lockedRegion.colMin - 1 : lockedRegion.colMin;
                lockTable.updateCellRegionUI(new _TableRegion2.default(0, startColumn, 0, lastLockedCell));
            }
        }
    }, {
        key: "regionUnlocked",


        /*
         * Checks locks for specified region and move runner back if needed.
         */
        value: function regionUnlocked(lockTable, unlockedRegion) {
            var runnerRow = lockTable.rows[0];

            if (!runnerRow.getCell(unlockedRegion.colMin).getValue().runnerOver) {
                return;
            }

            var endColumn = 0;
            for (var colIdx = unlockedRegion.colMin; colIdx < runnerRow.getCells().length; colIdx++) {
                var runnerCell = runnerRow.getCell(colIdx);
                if (runnerCell.getValue().runnerOver) {
                    runnerCell.getValue().runnerOver = false;
                    endColumn = colIdx;
                } else {
                    break;
                }
            }

            this.lastLockedDate = this.getPreviousDate(runnerRow.getCell(unlockedRegion.colMin).getValue().date);
            this.firePositionChangeEvent();

            var startColumn = unlockedRegion.colMin > 1 ? unlockedRegion.colMin - 1 : unlockedRegion.colMin;
            lockTable.updateCellRegionUI(new _TableRegion2.default(0, startColumn, 0, endColumn));
        }
    }]);

    return RunnerController;
}();

exports.default = RunnerController;

/***/ }),
/* 1542 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _atBrowserUtils = __webpack_require__(8);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CommentsController = function () {
    function CommentsController(dateFormat) {
        _classCallCheck(this, CommentsController);

        this.dateFormat = dateFormat;
        this.enabled = true;
        this.commentsShown = false;

        var self = this;
        this.viewCommentsListeners = [];
        descriptionPopup.setAfterShowHandler(function () {
            self.fireViewComments();
        });
        descriptionPopup.setAfterHideHandler(function () {
            self.fireCloseComments();
        });

        this.addViewCommentsListener({
            onViewComments: function onViewComments() {
                self.commentsShown = true;
            },
            onCloseComments: function onCloseComments() {
                self.commentsShown = false;
            }
        });

        var prevHandler = document.onmousedown;
        document.onmousedown = function (evt) {
            if (prevHandler) prevHandler.call(this, evt);

            if (self.commentsShown && !isBusyState()) {
                evt = (0, _atBrowserUtils.getEventObj)(evt);
                var targetElm = evt.target || evt.srcElement;

                while (targetElm) {
                    if (targetElm.id == descriptionPopup.getDivId()) break;

                    targetElm = targetElm.parentNode;
                }
            }
        };
    }

    _createClass(CommentsController, [{
        key: "addViewCommentsListener",
        value: function addViewCommentsListener(listener) {
            this.viewCommentsListeners.push(listener);
        }
    }, {
        key: "fireViewComments",
        value: function fireViewComments() {
            for (var i = 0; i < this.viewCommentsListeners.length; i++) {
                this.viewCommentsListeners[i].onViewComments();
            }
        }
    }, {
        key: "fireCloseComments",
        value: function fireCloseComments() {
            for (var i = 0; i < this.viewCommentsListeners.length; i++) {
                this.viewCommentsListeners[i].onCloseComments();
            }
        }
    }, {
        key: "registerCommentsEl",
        value: function registerCommentsEl(elm, cell) {
            var self = this;
            var commentsParameters = this.getCommentsParameters(cell);

            elm.onmousedown = function (evt) {
                if (self.enabled) {
                    evt = (0, _atBrowserUtils.getEventObj)(evt);
                    evt.cancelBubble = true;
                }
            };

            elm.onclick = function () {
                if (self.enabled) {
                    showViewCommentsPopup(commentsParameters);
                    self.fireViewComments();
                }
            };
        }
    }, {
        key: "getCommentsParameters",
        value: function getCommentsParameters(taskDayCell) {
            var userId = taskDayCell.getRow().getParentRow().getHeaderCell().getValue().id;
            var taskId = taskDayCell.getRow().getHeaderCell().getValue().id;
            var commentsDate = taskDayCell.getRow().getTable().getDatesRow().getCell(taskDayCell.getColIdx()).getValue().date;
            var commentsDateStr = this.dateFormat.formatDate(commentsDate);
            return new ViewCommentsParameters(taskId, userId, commentsDateStr);
        }
    }, {
        key: "enableComments",
        value: function enableComments(enable) {
            this.enabled = enable;
        }
    }]);

    return CommentsController;
}();

exports.default = CommentsController;

/***/ }),
/* 1543 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _atBrowserUtils = __webpack_require__(8);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ExpandedUsersStorage = function () {
    function ExpandedUsersStorage() {
        _classCallCheck(this, ExpandedUsersStorage);

        this.cookieName = "lockTableExpandedUsers";
        this.expandedUsers = this.loadExpandedUsers();
    }

    _createClass(ExpandedUsersStorage, [{
        key: "loadExpandedUsers",
        value: function loadExpandedUsers() {
            return (0, _atBrowserUtils.getArrayFromCookies)(this.cookieName);
        }
    }, {
        key: "contains",
        value: function contains(userId) {
            for (var i = 0; i < this.expandedUsers.length; i++) {
                if (this.expandedUsers[i] == userId) return true;
            }
        }
    }, {
        key: "add",
        value: function add(userId) {
            this.expandedUsers.push(userId);
            this.saveExpandedUsers();
        }
    }, {
        key: "remove",
        value: function remove(userId) {
            for (var i = 0; i < this.expandedUsers.length; i++) {
                if (this.expandedUsers[i] == userId) {
                    this.expandedUsers.splice(i, 1);
                    this.saveExpandedUsers();
                    return;
                }
            }
        }
    }, {
        key: "saveExpandedUsers",
        value: function saveExpandedUsers() {
            (0, _atBrowserUtils.saveArrayIntoCookies)(this.expandedUsers, this.cookieName);
        }
    }]);

    return ExpandedUsersStorage;
}();

exports.default = ExpandedUsersStorage;

/***/ }),
/* 1544 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = NoNotificationMessageParams;

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 Intended to show tooltips with cause why user can not receive notification.
 */
function NoNotificationMessageParams(accessRight) {
    this.accessRight = accessRight;
    this.disabledMessageKey = "mail_notifications.users_selector.no_notification.disabled";
    this.noEmailMessageKey = "mail_notifications.users_selector.no_notification.no_email";
}

NoNotificationMessageParams.prototype.getDisabledMessage = function (user) {
    return _messageResource2.default.getMessage(this.disabledMessageKey, [user.formatNameFML()]);
};

NoNotificationMessageParams.prototype.getAccessRightMessage = function (user) {
    return this.accessRight ? this.accessRight.getNoNotificationAccessRightMessage(user) : null;
};

NoNotificationMessageParams.prototype.getNoEmailMessage = function (user) {
    return _messageResource2.default.getMessage(this.noEmailMessageKey, [user.formatNameFML()]);
};

/***/ }),
/* 1545 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = MailNotificationsUserSelectorCache;

var _Ext = __webpack_require__(12);

var _Ext2 = _interopRequireDefault(_Ext);

var _at_users_selector_panel = __webpack_require__(162);

var _at_users_selector_panel2 = _interopRequireDefault(_at_users_selector_panel);

var _at_user_selector_panel_with_ar = __webpack_require__(820);

var _at_user_selector_panel_with_ar2 = _interopRequireDefault(_at_user_selector_panel_with_ar);

var _at_shared_user_button_menu = __webpack_require__(159);

var _at_shared_user_button_menu2 = _interopRequireDefault(_at_shared_user_button_menu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Holds selector panels on mail notifications page
 */
function MailNotificationsUserSelectorCache(userGroupsEnabled, timeZoneGroupsEnabled, users, userGroups, timeZoneGroups, userGroupsTreeData, timeZoneGroupsTreeData, allAccessRightGrantedMapForUserGroups, allAccessRightGrantedMapForTimeZoneGroups) {
    this.userGroupsEnabled = userGroupsEnabled;
    this.timeZoneGroupsEnabled = timeZoneGroupsEnabled;
    this.users = users;
    this.userGroups = userGroups;
    this.timeZoneGroups = timeZoneGroups;
    this.userGroupsTreeData = userGroupsTreeData;
    this.timeZoneGroupsTreeData = timeZoneGroupsTreeData;
    this.allAccessRightGrantedMapForUserGroups = allAccessRightGrantedMapForUserGroups;
    this.allAccessRightGrantedMapForTimeZoneGroups = allAccessRightGrantedMapForTimeZoneGroups;
    this.accessRightPanels = {};
}

MailNotificationsUserSelectorCache.SELECTOR_ALL_USERS_NO_EMAIL_CHECK = 1;
MailNotificationsUserSelectorCache.SELECTOR_USERS_WITH_ENTER_TT_RIGHT = 2;
MailNotificationsUserSelectorCache.SELECTOR_USERS_WITH_ENTER_TT_RIGHT_NO_EMAIL_CHECK = 3;
MailNotificationsUserSelectorCache.SELECTOR_USERS_WITH_EDIT_HIERARCHY_RIGHT = 4;
MailNotificationsUserSelectorCache.SELECTOR_USERS_WITH_ACCESS_TO_MANAGER_SCOPES = 5;
MailNotificationsUserSelectorCache.SELECTOR_USERS_WITH_GENERATE_MONEY_REPORTS_RIGHT = 6;

MailNotificationsUserSelectorCache.prototype.getAllUsersPanel = function (config) {
    if (!this.allUsersPanel) {
        this.allUsersPanel = this.createAllUsersMenu(config);
    }
    return this.allUsersPanel;
};

MailNotificationsUserSelectorCache.prototype.getAccessRightPanel = function (selectorType, config, accessRight) {
    if (!this.accessRightPanels[selectorType]) {
        this.accessRightPanels[selectorType] = this.createAccessRightsMenu(config, accessRight);
    }
    return this.accessRightPanels[selectorType];
};

MailNotificationsUserSelectorCache.prototype.createAccessRightsMenu = function (config, accessRight) {
    var allAccessRightGrantedSetForUserGroups = accessRight ? this.allAccessRightGrantedMapForUserGroups[accessRight.getId()] : null;
    var allAccessRightGrantedSetForTimeZoneGroups = accessRight ? this.allAccessRightGrantedMapForTimeZoneGroups[accessRight.getId()] : null;

    var panel = new _at_user_selector_panel_with_ar2.default(_Ext2.default.applyIf({
        accessRight: accessRight,
        itemLabelMaxLength: 62,
        allAccessRightGrantedSetForUserGroups: allAccessRightGrantedSetForUserGroups,
        allAccessRightGrantedSetForTimeZoneGroups: allAccessRightGrantedSetForTimeZoneGroups
    }, config));
    panel.setGroupByUserGroupsTreeData(this.userGroupsTreeData);
    panel.setGroupByTimeZoneGroupsTreeData(this.timeZoneGroupsTreeData);
    panel.initialize(this.userGroupsEnabled, this.timeZoneGroupsEnabled, this.users, this.userGroups, this.timeZoneGroups);
    return this.createMenu(panel);
};

MailNotificationsUserSelectorCache.prototype.createAllUsersMenu = function (config) {
    var panel = new _at_users_selector_panel2.default(_Ext2.default.apply({}, config));
    panel.setGroupByUserGroupsTreeData(this.userGroupsTreeData);
    panel.setGroupByTimeZoneGroupsTreeData(this.timeZoneGroupsTreeData);
    panel.initialize(this.userGroupsEnabled, this.timeZoneGroupsEnabled, this.users, this.userGroups, this.timeZoneGroups);
    return this.createMenu(panel);
};

MailNotificationsUserSelectorCache.prototype.createMenu = function (panel) {
    return new _at_shared_user_button_menu2.default({ panel: panel });
};

/***/ }),
/* 1546 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _SelectorFilter2 = __webpack_require__(282);

var _SelectorFilter3 = _interopRequireDefault(_SelectorFilter2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Intended for selectors with access right filtration
 */
var AccessRightFilter = function (_SelectorFilter) {
    _inherits(AccessRightFilter, _SelectorFilter);

    function AccessRightFilter(tree, searchIndex, allActiveSet, accessRight, allAccessRightGrantedSet) {
        _classCallCheck(this, AccessRightFilter);

        var _this = _possibleConstructorReturn(this, (AccessRightFilter.__proto__ || Object.getPrototypeOf(AccessRightFilter)).call(this, tree, searchIndex, allActiveSet));

        _this.allAccessRightGrantedSet = allAccessRightGrantedSet;
        _this.accessRight = accessRight;
        _this.accessRightSet = _this.allAccessRightGrantedSet;
        return _this;
    }

    _createClass(AccessRightFilter, [{
        key: "hasNoFilter",
        value: function hasNoFilter() {
            return _get(AccessRightFilter.prototype.__proto__ || Object.getPrototypeOf(AccessRightFilter.prototype), "hasNoFilter", this).call(this) && !this.accessRightSet;
        }
    }, {
        key: "setShowUsersWithoutGrantedAccessRight",
        value: function setShowUsersWithoutGrantedAccessRight(showWithout) {
            if (showWithout && this.accessRightSet) {
                this.accessRightSet = null;
                this.reFilter();
            } else if (!showWithout && !this.accessRightSet) {
                this.accessRightSet = this.allAccessRightGrantedSet;
                this.reFilter();
            }
        }
    }, {
        key: "doFilter",
        value: function doFilter() {
            var result = void 0;
            if (this.keywordSet) {
                if (this.activeOnlySet || this.accessRightSet) {
                    result = this.keywordSet.clone();
                    if (this.activeOnlySet) {
                        result = result.intersection(this.activeOnlySet);
                    }
                    if (this.accessRightSet) {
                        result = result.intersection(this.accessRightSet);
                    }
                    if (result.isEmpty() && !this.keywordSet.isEmpty()) {
                        result = this.keywordSet.clone();
                    }
                } else {
                    result = this.keywordSet.clone();
                }
            } else {
                if (this.selectedOnlySet) {
                    result = this.selectedOnlySet.clone();
                }
                if (this.activeOnlySet) {
                    result = this.safeIntersection(this.activeOnlySet, result);
                }
                if (this.accessRightSet) {
                    result = this.safeIntersection(this.accessRightSet, result);
                }
            }

            return result;
        }
    }, {
        key: "getVisibleNodeSet",
        value: function getVisibleNodeSet(selectedNodeSet) {
            return this.safeIntersection(_get(AccessRightFilter.prototype.__proto__ || Object.getPrototypeOf(AccessRightFilter.prototype), "getVisibleNodeSet", this).call(this, selectedNodeSet), this.accessRightSet);
        }
    }, {
        key: "getClassesForEmptyMessages",
        value: function getClassesForEmptyMessages() {
            var classesMap = _get(AccessRightFilter.prototype.__proto__ || Object.getPrototypeOf(AccessRightFilter.prototype), "getClassesForEmptyMessages", this).call(this);

            if (!this.keywordSet && !this.selectedOnlySet && this.accessRightSet) {
                if (this.activeOnlySet) {
                    classesMap[this.NO_ACTIVE_NODES_EMPTY_MESSAGE_KEY] = "showNoEnabledAccessRightGrantedUsers";
                } else {
                    classesMap[this.NO_NODES_EMPTY_MESSAGE_KEY] = "showNoAccessRightGrantedUsers";
                }
            }
            return classesMap;
        }
    }, {
        key: "getClassNameForEmptyVisibleSelection",
        value: function getClassNameForEmptyVisibleSelection() {
            return "showNoSelectedNodesHasDisabledOrWithoutAccessRight";
        }
    }]);

    return AccessRightFilter;
}(_SelectorFilter3.default);

exports.default = AccessRightFilter;

/***/ }),
/* 1547 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = AccessRightUserGroupNodeRenderer;

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _UserGroupNodeRenderer = __webpack_require__(238);

var _UserGroupNodeRenderer2 = _interopRequireDefault(_UserGroupNodeRenderer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function AccessRightUserGroupNodeRenderer(tree, selectorFilter, expandCollapseCallback, accessRight) {
    _UserGroupNodeRenderer2.default.call(this, tree, selectorFilter, expandCollapseCallback);
    this.accessRight = accessRight;
}

AccessRightUserGroupNodeRenderer.prototype = _underscore2.default.create(_UserGroupNodeRenderer2.default.prototype);

AccessRightUserGroupNodeRenderer.prototype.getEmptyEntityTooltip = function () {
    return this.accessRight.getGroupEmptyEntityTooltip();
};

/***/ }),
/* 1548 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = AccessRightUserNodeRenderer;

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _EmailCheckUserNodeRenderer = __webpack_require__(747);

var _EmailCheckUserNodeRenderer2 = _interopRequireDefault(_EmailCheckUserNodeRenderer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function AccessRightUserNodeRenderer(tree, selectorFilter, selectionHelper, checkEmail, messageParams, accessRight) {
    _EmailCheckUserNodeRenderer2.default.call(this, tree, selectorFilter, selectionHelper, checkEmail, messageParams);
    this.accessRight = accessRight;
}

AccessRightUserNodeRenderer.prototype = _underscore2.default.create(_EmailCheckUserNodeRenderer2.default.prototype);

AccessRightUserNodeRenderer.prototype.isInvalidUser = function (user) {
    return _EmailCheckUserNodeRenderer2.default.prototype.isInvalidUser.call(this, user) || !this.accessRight.isGranted(user.accessRight);
};

AccessRightUserNodeRenderer.prototype.getAdditionalTitle = function (user) {
    if (!this.accessRight.isGranted(user.accessRight)) {
        return this.messageParams.getAccessRightMessage(user);
    } else {
        return null;
    }
};

/***/ }),
/* 1549 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = AccessRightEmptyMessageBuilder;

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _UserSelectorEmptyMessageBuilder = __webpack_require__(358);

var _UserSelectorEmptyMessageBuilder2 = _interopRequireDefault(_UserSelectorEmptyMessageBuilder);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function AccessRightEmptyMessageBuilder(userSelectorGroupsStrategy, accessRight) {
    _UserSelectorEmptyMessageBuilder2.default.call(this, userSelectorGroupsStrategy);
    this.accessRight = accessRight;
}

AccessRightEmptyMessageBuilder.prototype = _underscore2.default.create(_UserSelectorEmptyMessageBuilder2.default.prototype, {
    createMessages: function createMessages() {
        _UserSelectorEmptyMessageBuilder2.default.prototype.createMessages.call(this);

        this.messages["noAccessRightGrantedUsers"] = this.accessRight.getNoAccessRightGrantedUsersMessage();
        this.messages["noEnabledAccessRightGrantedUsers"] = this.accessRight.getNoEnabledAccessRightGrantedUsersMessage();
        this.messages["noSelectedNodesHasDisabledOrWithoutAccessRight"] = this.accessRight.getNoSelectedNodesHasDisabledOrWithoutAccessRightMessage();
    }
});

/***/ }),
/* 1550 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = TimeZoneGroupController;

var _group_controller = __webpack_require__(527);

var _group_controller2 = _interopRequireDefault(_group_controller);

var _GroupValidatorStrategy = __webpack_require__(186);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function TimeZoneGroupController() {}

TimeZoneGroupController.prototype = new _group_controller2.default();

TimeZoneGroupController.prototype.init = function (config) {
    _group_controller2.default.prototype.init.call(this, config);
    this.selectorIdPrefix = config.selectorIdPrefix;
    this.groupNamingKey = "common.time_zone_group";
    this.GroupNamingKey = "common.Time_Zone_Group";
    return this;
};

TimeZoneGroupController.prototype.createGroupRow = function (group, controller) {
    return new TimeZoneGroupRow().init(document.getElementById(formatId(this.groupDivIdPrefix, group.id)), document.getElementById(formatId(this.groupDeleteLinkIdPrefix, group.id)), document.getElementById(formatId(this.undoDeleteIdPrefix, group.id)), document.getElementById(formatId(this.acceptDeleteIdPrefix, group.id)), document.getElementById(formatId(this.undoEditIdPrefix, group.id)), document.getElementById(formatId(this.acceptEditIdPrefix, group.id)), document.getElementById(formatId(this.editInputIdPrefix, group.id)), document.getElementById(formatId(this.nameCellIdPrefix, group.id)), document.getElementById(formatId(this.inputCellIdPrefix, group.id)), document.getElementById(formatId(this.editGroupCellIdPrefix, group.id)), document.getElementById(formatId(this.waitingAnimationCellIdPrefix, group.id)), group, new _GroupValidatorStrategy.TimeZoneGroupValidatorStrategy(), controller, formatId(this.selectorIdPrefix, group.id));
};

TimeZoneGroupController.prototype.getGroupData = function (group, name) {
    return {
        id: group.id,
        name: name,
        cityPlaceId: group.cityPlaceId,
        cityName: group.cityName,
        timeZoneId: group.timeZoneId,
        rawOffset: group.rawOffset,
        currentTime: group.currentTime
    };
};

TimeZoneGroupController.prototype.cleanup = function () {
    _group_controller2.default.prototype.cleanup.call(this);
    for (var groupId in this.groups) {
        if (this.groups.hasOwnProperty(groupId)) this.groups[groupId].cleanup();
    }
};

/***/ }),
/* 1551 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _GroupRow2 = __webpack_require__(828);

var _GroupRow3 = _interopRequireDefault(_GroupRow2);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _TimeZonesSelector = __webpack_require__(355);

var _TimeZonesSelector2 = _interopRequireDefault(_TimeZonesSelector);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TimeZoneGroupRow = function (_GroupRow) {
    _inherits(TimeZoneGroupRow, _GroupRow);

    function TimeZoneGroupRow() {
        _classCallCheck(this, TimeZoneGroupRow);

        return _possibleConstructorReturn(this, (TimeZoneGroupRow.__proto__ || Object.getPrototypeOf(TimeZoneGroupRow)).apply(this, arguments));
    }

    _createClass(TimeZoneGroupRow, [{
        key: "init",
        value: function init(div, deleteLink, undoDeleteButton, acceptDeleteButton, undoEditButton, acceptEditButton, input, nameCell, inputCell, editGroupCell, waitingAnimationCell, group, validatorGroupStrategy, controller, selectorId) {
            _get(TimeZoneGroupRow.prototype.__proto__ || Object.getPrototypeOf(TimeZoneGroupRow.prototype), "init", this).call(this, div, deleteLink, undoDeleteButton, acceptDeleteButton, undoEditButton, acceptEditButton, input, nameCell, inputCell, editGroupCell, waitingAnimationCell, group, validatorGroupStrategy, controller);
            this.cityPlaceId = group.cityPlaceId;
            this.cityName = group.cityName;
            this.timeZoneId = group.timeZoneId;
            this.rawOffset = group.rawOffset;
            this.currentTime = group.currentTime;
            var self = this;
            this.controller = controller;
            this.citySelector = new _TimeZonesSelector2.default().init((0, _jquery2.default)("#" + selectorId), { name: group.cityName, placeId: group.cityPlaceId, timeZoneId: group.timeZoneId, rawOffset: group.rawOffset }, function () {
                self.cityChanged.apply(self, arguments);
            }, null, false, "timeZoneGroupRowSearch", true);

            return this;
        }
    }, {
        key: "cityChanged",
        value: function cityChanged(city) {
            this.cityName = city.name;
            this.cityPlaceId = city.placeId;
            this.timeZoneId = city.timeZoneId;
            this.rawOffset = city.rawOffset;
            this.currentTime = city.currentTime;
            this.controller.getGroupController().startNewGroupNameSaving(this.controller, this);
        }
    }, {
        key: "cleanup",
        value: function cleanup() {
            this.citySelector.resetToInit();
        }
    }]);

    return TimeZoneGroupRow;
}(_GroupRow3.default);

exports.default = TimeZoneGroupRow;

/***/ }),
/* 1552 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _UserInGroup2 = __webpack_require__(388);

var _UserInGroup3 = _interopRequireDefault(_UserInGroup2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Wrapper for UserInGroup. Contains all needed dom elements of user row
 * @param div user row
 * @param checkbox checkbox on user row
 * @param ddWrapper drag and drop class for this user row
 * @param controller user group management controller
 * @param user UserInGroup instance for wrapping
 */
var UserInGroupRow = function (_UserInGroup) {
    _inherits(UserInGroupRow, _UserInGroup);

    function UserInGroupRow(div, checkbox, ddWrapper, controller, user) {
        _classCallCheck(this, UserInGroupRow);

        var _this = _possibleConstructorReturn(this, (UserInGroupRow.__proto__ || Object.getPrototypeOf(UserInGroupRow)).call(this, user.id, user.name, user.active));

        _this.div = div;
        _this.checkbox = checkbox;
        _this.ddWrapper = ddWrapper;
        _this.generateEventHandlers(controller);
        _this.enableControls();
        return _this;
    }

    /**
     * Is this user selected or not
     */


    _createClass(UserInGroupRow, [{
        key: 'isSelected',
        value: function isSelected() {
            return this.checkbox.checked;
        }

        /**
         * Hide this user
         */

    }, {
        key: 'hide',
        value: function hide() {
            this.div.style.display = 'none';
        }

        /**
         * Make this user visible
         */

    }, {
        key: 'open',
        value: function open() {
            this.div.style.display = '';
        }

        /**
         * Generate all event handlers needed for this user row
         * @param controller user group management controller
         */

    }, {
        key: 'generateEventHandlers',
        value: function generateEventHandlers(controller) {
            var _this2 = this;

            this.checkBoxOnClick = function () {
                return controller.passiveEventHandler(function () {
                    return controller.getUserController().selectUser(_this2);
                }, true);
            };
        }

        /**
         * Enable all event handlers. Calls to initialize row
         */

    }, {
        key: 'enableControls',
        value: function enableControls() {
            this.checkbox.onclick = this.checkBoxOnClick;
        }
    }]);

    return UserInGroupRow;
}(_UserInGroup3.default);

exports.default = UserInGroupRow;

/***/ }),
/* 1553 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _utils = __webpack_require__(25);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _redux = __webpack_require__(7);

var _utils2 = __webpack_require__(6);

var _TaskStore = __webpack_require__(91);

var _TaskStore2 = _interopRequireDefault(_TaskStore);

var _LockTTStore = __webpack_require__(526);

var _LockTTStore2 = _interopRequireDefault(_LockTTStore);

var _User = __webpack_require__(119);

var _User2 = _interopRequireDefault(_User);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _atBrowserUtils = __webpack_require__(8);

var _jquery_rpc = __webpack_require__(26);

var _jquery_rpc2 = _interopRequireDefault(_jquery_rpc);

var _LoadingMoire = __webpack_require__(92);

var _LoadingMoire2 = _interopRequireDefault(_LoadingMoire);

var _LockTTTableController = __webpack_require__(808);

var _LockTTTableController2 = _interopRequireDefault(_LockTTTableController);

var _selectors = __webpack_require__(97);

var _actions = __webpack_require__(81);

var _TimeTrackPageFeatureDiffController = __webpack_require__(529);

var _TimeTrackPageFeatureDiffController2 = _interopRequireDefault(_TimeTrackPageFeatureDiffController);

var _View2 = __webpack_require__(20);

var _View3 = _interopRequireDefault(_View2);

var _EditTaskPanelContainer = __webpack_require__(377);

var _EditTaskPanelContainer2 = _interopRequireDefault(_EditTaskPanelContainer);

var _actions2 = __webpack_require__(56);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LockTTMediator = function (_View) {
    _inherits(LockTTMediator, _View);

    function LockTTMediator(_ref) {
        var _ref$openTaskPanel = _ref.openTaskPanel,
            openTaskPanel = _ref$openTaskPanel === undefined ? function (taskId) {} : _ref$openTaskPanel,
            _ref$toast = _ref.toast,
            toast = _ref$toast === undefined ? function () {} : _ref$toast;

        _classCallCheck(this, LockTTMediator);

        var _this = _possibleConstructorReturn(this, (LockTTMediator.__proto__ || Object.getPrototypeOf(LockTTMediator)).call(this));

        _this._updateTaskSelection = function (taskId) {
            var $lockTablePlaceholder = (0, _jquery2.default)("#lockTablePlaceholder");
            $lockTablePlaceholder.find(".TaskCell.editing").removeClass("editing");
            if (taskId) {
                $lockTablePlaceholder.find(".TaskCell").filter(function (index, taskCell) {
                    return taskCell.cellObj.value.id === taskId;
                }).addClass("editing");
            }
        };

        _this.actions = {
            openTaskPanel: openTaskPanel,
            toast: toast
        };

        _this.state = {
            openTaskId: null
        };

        _this.onStatePropertyChanged('openTaskId', _this._updateTaskSelection);
        return _this;
    }

    _createClass(LockTTMediator, [{
        key: "init",
        value: function init(config) {
            _get(LockTTMediator.prototype.__proto__ || Object.getPrototypeOf(LockTTMediator.prototype), "init", this).call(this);
            this._initModel();
            this._setStore(config);
            this._initControls();
            this._initCallbacks();
            this._toggleFirstLoad(true);

            this.loadData();
            this._update();
        }
    }, {
        key: "_setStore",
        value: function _setStore(config) {
            _LockTTStore2.default.setDateFormat(config.dateFormat);
            _LockTTStore2.default.setDateRangeConfig(config.dateRangeConfig);
            _LockTTStore2.default.setEnabledFeatures(config.enabledFeatures);
            _LockTTStore2.default.setUsersSelectorConfig(config.userSelectorConfig);
            _LockTTStore2.default.setSortingOrder(config.sortingOrder);
            _LockTTStore2.default.setPagerConfig(config.pagerConfig);
            _LockTTStore2.default.setSelectionVeilImages(config.selectionVeilImages);
            _LockTTStore2.default.setUsersForSelector(config.usersForSelector);
            _LockTTStore2.default.setTimeZonesForSelector(config.timeZonesForSelector);
            _LockTTStore2.default.setUsersGroupsForSelector(config.usersGroupsForSelector);
            _LockTTStore2.default.setFeaturesForSelector(config.usersGroupFeature, config.timeZoneGroupFeature);
            _LockTTStore2.default.setCalendarConfig(config.calendarConfig);
            _LockTTStore2.default.setHideDetailsOnLockTT(config.hideDetailsOnLockTT);
        }
    }, {
        key: "_initControls",
        value: function _initControls() {
            var _this2 = this;

            this.configurationPanel = new LockTTPage.ConfigurationPanel((0, _jquery2.default)("#lockTableFilter")).init();
            this.filterController = new LockTTPage.FilterController().init();

            this.pager = new LockTTPager((0, _jquery2.default)("#pagerPlaceholder"), _LockTTStore2.default.getPagerConfig().selectOptions).init();
            this.pager.hide();

            this.topInfo = new LockTTTopInfo((0, _jquery2.default)("#topInfoPlaceHolder")).init();
            this.topInfo.hide();

            this.tableController = new _LockTTTableController2.default().init();
            this.moire = new _LoadingMoire2.default({
                lines: 12,
                length: 9,
                width: 5,
                radius: 11
            }).init((0, _jquery2.default)('.lockTableWrapper'));

            this.UGREnabled = _LockTTStore2.default.getUserGroupFeatureForSelector();
            this.TZGEnabled = _LockTTStore2.default.getTimeZoneGroupFeatureForSelector();

            new _EditTaskPanelContainer2.default({
                onTaskDeletedCb: function onTaskDeletedCb(taskId) {
                    return _this2.loadData();
                }
            }).init();
        }
    }, {
        key: "_initModel",
        value: function _initModel() {
            this.page = new LockTTPage((0, _jquery2.default)("#pageContent")).init();
            new _TimeTrackPageFeatureDiffController2.default().init();
        }
    }, {
        key: "_shiftDateRange",
        value: function _shiftDateRange(milliseconds) {
            var dateRangeConfig = _LockTTStore2.default.getDateRangeConfig();
            var newDateRangeConfig = {
                qualifier: "CUSTOM",
                fromDate: new Date(dateRangeConfig.fromDate.getTime() + milliseconds),
                toDate: new Date(dateRangeConfig.toDate.getTime() + milliseconds)
            };
            _LockTTStore2.default.setDateRangeConfig(newDateRangeConfig);
        }
    }, {
        key: "_initCallbacks",
        value: function _initCallbacks() {
            var _this3 = this;

            var self = this;
            // configuration panel
            (0, _jquery2.default)("#clearButton").click(function () {
                self.filterController.setUserSelection(UserSelectionUtils.defaultUserSelector());
                (0, _jquery2.default)(document).trigger("usersSelector.changed");
            });

            (0, _jquery2.default)(document).on("dateRangeSelector.changed", function (e, dateRange) {
                _LockTTStore2.default.setDateRangeConfig(dateRange);
                self.loadData();
                self.configurationPanel.update();
            });

            (0, _jquery2.default)(document).on("usersSelector.changed", function () {
                var userSelection = self.filterController.getUserSelection();
                var prevUserSelection = _LockTTStore2.default.getUsersSelectorConfig();
                _LockTTStore2.default.setUsersSelectorConfig(self.filterController.getUserSelection());

                if (!UserSelectionUtils.empty(userSelection) && !UserSelectionUtils.equals(prevUserSelection, userSelection)) {
                    self.loadData();
                }
                self._update();
            });

            // action for table
            (0, _jquery2.default)(document).on("navigate.previous_week", function () {
                var week = 7 * 24 * 60 * 60 * 1000;
                self._shiftDateRange(-week);
                self.loadData();
                (0, _jquery2.default)(document).trigger("updateDateRange");
            });

            (0, _jquery2.default)(document).on("navigate.next_week", function () {
                var week = 7 * 24 * 60 * 60 * 1000;
                self._shiftDateRange(week);
                self.loadData();
                (0, _jquery2.default)(document).trigger("updateDateRange");
            });

            (0, _jquery2.default)(document).on("navigate.till_lock_date", function () {
                var day = 24 * 60 * 60 * 1000;
                var tillLockDate = _LockTTStore2.default.getLockedTillDate();
                var fromDate = _LockTTStore2.default.getDateRangeConfig().fromDate;
                self._shiftDateRange(tillLockDate.getTime() - 2 * day - fromDate.getTime());
                self.loadData();
                (0, _jquery2.default)(document).trigger("updateDateRange");
            });

            (0, _jquery2.default)(document).on("lock.submitted", function (e, actionParameters) {
                self.loadData(actionParameters);
            });

            (0, _jquery2.default)(document).on("order.changed", function (e, sortingOrder) {
                _LockTTStore2.default.setSortingOrder(sortingOrder);
                self.loadData();
            });

            (0, _jquery2.default)(document).on("pager.records_per_page.change", function (e, recordsPerPage) {
                _LockTTStore2.default.getPagerConfig().recordsPerPage = recordsPerPage;
                self.loadData();
            });

            (0, _jquery2.default)(document).on("pager.shown_record.change", function (e, shownRecord) {
                _LockTTStore2.default.getPagerConfig().shownRecord = shownRecord;
                self.loadData();
            });

            (0, _jquery2.default)(document).on("lockTT_table_taskClick", function (e, clickEvent, taskId) {
                (0, _utils.setEventPreventHidingEditTaskSlidingPanel)(clickEvent);
                self.actions.openTaskPanel(taskId);
            });

            (0, _jquery2.default)(document).on('editTaskPanel_updateTask', function (e, _ref2) {
                var taskId = _ref2.taskId,
                    prevTaskState = _ref2.prevTaskState;

                _this3._onTaskChanged(taskId, prevTaskState);
            });

            (0, _jquery2.default)(document).on('task_added_to_timesheet_event', function (_, hasError) {
                return hasError ? alert(_messageResource2.default.getMessage("api.error.unexpected_error")) : _this3.actions.toast(_messageResource2.default.getMessage("add_to_timesheet.tasks.toast"));
            });
        }
    }, {
        key: "loadData",
        value: function loadData(customActionParameters) {
            descriptionPopup.hide();
            this.moire.find(".spinnerPlaceholder").css("margin-top", (0, _jquery2.default)(".lockTableWrapper").height() / 2 + "px");
            this.moire.show();

            var actionParameters = {
                pageAction: "navigate",
                lockUnlockMode: null,
                lockUnlockFromDate: null,
                lockUnlockToDate: null
            };
            actionParameters = _.extend(actionParameters, customActionParameters);

            if (this.rpc) {
                this.rpc.abort();
            }
            var userSelectorConfig = _LockTTStore2.default.getUsersSelectorConfig();
            var dateRangeConfig = _LockTTStore2.default.getDateRangeConfig();
            var dateFormat = _LockTTStore2.default.getDateFormat();
            this.rpc = (0, _jquery_rpc2.default)("LockTTService.getLockTTData", [actionParameters.pageAction, userSelectorConfig.allUsers, userSelectorConfig.selectedUsers, userSelectorConfig.showDisabled, userSelectorConfig.groupType, userSelectorConfig.selectedGroups, _LockTTStore2.default.getSortingOrder(), actionParameters.lockUnlockMode, actionParameters.lockUnlockFromDate, actionParameters.lockUnlockToDate, _LockTTStore2.default.getPagerConfig().shownRecord, _LockTTStore2.default.getPagerConfig().recordsPerPage, dateFormat.formatDate(dateRangeConfig.fromDate), dateFormat.formatDate(dateRangeConfig.toDate), DateRangeStateUtil[dateRangeConfig.qualifier]], _.bind(this._loadDataSuccess, this), _.bind(this._loadDataFail, this));
        }
    }, {
        key: "_updateMessages",
        value: function _updateMessages(messages, errors) {
            var $container = (0, _jquery2.default)(".messagesBottomMargin");
            $container.empty();
            var hasMessages = messages && messages.length > 0;
            var hasErrors = errors && errors.length > 0;
            if (hasMessages || hasErrors) {
                var data = {
                    messages: messages,
                    errors: errors,
                    hasMessages: hasMessages,
                    hasErrors: hasErrors,
                    hasWarnings: false,
                    hasAdditionalError: false,
                    successImg: (0, _atBrowserUtils.atImgPath)("success.gif"),
                    errorImg: (0, _atBrowserUtils.atImgPath)("error.gif")
                };
                new LockTTMessages($container, data).init();
            }
        }
    }, {
        key: "_validateLeaveTypes",
        value: function _validateLeaveTypes(data) {
            return _.every(data.userDataGroups, function (userGroupData) {
                return _.every(userGroupData.usersData, function (userData) {
                    return _.every(userData.leaveTypes, function (leaveType) {
                        return LeaveTypeUtil.validateLeaveType(leaveType);
                    });
                });
            });
        }
    }, {
        key: "_validateGroupFeatures",
        value: function _validateGroupFeatures(enabledFeatures) {
            if (this.UGREnabled != !!enabledFeatures.UGR) {
                this._showAlertAboutFeatureOnOffAndReloadPage(this.UGREnabled, _messageResource2.default.getMessage("common.User_Groups"));
                return false;
            } else if (this.TZGEnabled != !!enabledFeatures.TZG) {
                this._showAlertAboutFeatureOnOffAndReloadPage(this.TZGEnabled, _messageResource2.default.getMessage("common.Time_Zone_Groups"));
                return false;
            }
            return true;
        }
    }, {
        key: "_showAlertAboutFeatureOnOffAndReloadPage",
        value: function _showAlertAboutFeatureOnOffAndReloadPage(oldFeatureStateOn, featureText) {
            alert(_messageResource2.default.getMessage(oldFeatureStateOn ? "common.turned_off_functionality" : "common.enabled_functionality", [featureText]));
            window.location.reload();
        }
    }, {
        key: "_prepareAndSetDataIntoStore",
        value: function _prepareAndSetDataIntoStore(data) {
            var needReload = !this._validateLeaveTypes(data) || !this._validateGroupFeatures(data.enabledFeatures);
            if (needReload) return false;

            _LockTTStore2.default.setPagerConfig(data.pagerInfo);
            _LockTTStore2.default.setEnabledFeatures(data.enabledFeatures);
            _LockTTStore2.default.setLockedTillDate(_.isNull(data.allLockedTillDate) ? null : Date.parseJSONDate(data.allLockedTillDate));
            _LockTTStore2.default.setAllLockedTillDateBeyondDateRange(_.isNull(data.allLockedTillDateBeyondDateRange) ? null : Date.parseJSONDate(data.allLockedTillDateBeyondDateRange));
            _LockTTStore2.default.setDeletedUsers(this._createUserArray(data.deletedUsers));
            _LockTTStore2.default.setUsers(this._createUserArray(data.users));
            _LockTTStore2.default.setTimestamp(data.timestamp);
            _LockTTStore2.default.setWeekStartDay(data.weekStartDay);
            _LockTTStore2.default.setLoggedInUserToday(Date.parseJSONDate(data.today));
            _LockTTStore2.default.setSortingOrder(data.order);
            _LockTTStore2.default.setDisabledUsersSelected(data.disabledUsersSelected);
            _LockTTStore2.default.setMonths(data.months);

            _.each(data.headerData, function (headerData) {
                headerData.date = Date.parseJSONDate(headerData.date);
            });
            _LockTTStore2.default.setHeaderData(data.headerData);

            _LockTTStore2.default.setDateRangeConfig({
                "fromDate": Date.parseJSONDate(data.fromDate),
                "toDate": Date.parseJSONDate(data.toDate),
                "qualifier": _.invert(DateRangeStateUtil)[data.qualifier]
            });

            _LockTTStore2.default.setUserDataGroups(data.userDataGroups);
            return true;
        }
    }, {
        key: "_loadDataSuccess",
        value: function _loadDataSuccess(data) {
            if (!this._prepareAndSetDataIntoStore(data)) return;

            var $tableContainer = (0, _jquery2.default)("#lockTablePlaceholder");
            $tableContainer.empty();
            var $emptyTable = (0, _jquery2.default)("#emptyTable");
            $emptyTable.empty();
            if (_LockTTStore2.default.getPagerConfig() && _LockTTStore2.default.getPagerConfig().recordsNumber > 0) {
                this.tableController.createLockTable($tableContainer[0], _.bind(this._onLockedTillDateChange, this));
                (0, _jquery2.default)(document).trigger("data.loaded");
            } else {
                new LockTTEmptyTable($emptyTable).init();
                (0, _jquery2.default)(document).trigger("data.empty");
            }
            this.pager.update();
            this.topInfo.update();
            this._updateMessages(data.messages, data.errors);
            this._toggleFirstLoad(false);
            this.moire.hide();
        }
    }, {
        key: "_loadDataFail",
        value: function _loadDataFail(data) {
            this._toggleFirstLoad(false);
            this.moire.hide();
            (0, _jquery2.default)(document).trigger("data.loaded.fail");
        }
    }, {
        key: "_createUserArray",
        value: function _createUserArray(users) {
            var array = [];
            _.each(users, function (user) {
                array.push(new _User2.default(user.id, user.firstName, user.lastName, user.middleName, user.username, user.activeInAt, user.hasEmail, user.userGroupId, user.timeZoneGroupId));
            });
            return array;
        }
    }, {
        key: "_onLockedTillDateChange",
        value: function _onLockedTillDateChange(date) {
            _LockTTStore2.default.setLockedTillDate(date);
            this.topInfo.updateTillDate();
        }
    }, {
        key: "_update",
        value: function _update() {
            var chooseUserButton = (0, _jquery2.default)(".chooseUserButton");
            var filterButton = (0, _jquery2.default)(".chooseUserButton .commonVisibleFilterButton");
            var clearButton = (0, _jquery2.default)("#clearButton");
            chooseUserButton.removeClass("emptySelector");
            filterButton.removeClass("filtered");
            clearButton.removeClass();

            var userSelection = _LockTTStore2.default.getUsersSelectorConfig();

            this.filterController.setErrorTooltipEnabled(UserSelectionUtils.empty(userSelection));
            if (UserSelectionUtils.empty(userSelection)) {
                chooseUserButton.addClass("emptySelector");
                filterButton.addClass("filtered");
                clearButton.addClass("enabled");
            }

            if (!UserSelectionUtils.equals(userSelection, UserSelectionUtils.defaultUserSelector())) {
                filterButton.addClass("filtered");
                clearButton.addClass("enabled");
            }

            this.configurationPanel.update();
        }
    }, {
        key: "_toggleFirstLoad",
        value: function _toggleFirstLoad(value) {
            (0, _jquery2.default)(".lockTableWrapper").toggleClass("firstLoad", value);
        }
    }, {
        key: "_onTaskChanged",
        value: function _onTaskChanged(taskId, prevTaskState) {
            var task = _TaskStore2.default.get(taskId);
            if (!task) return;
            if (prevTaskState.name !== task.name || prevTaskState.workflowStatusId !== task.workflowStatusId || prevTaskState.commentsNumber !== task.commentsNumber) {
                this.tableController._updateTask(task);
            }

            this._updateTaskSelection(this.state.openTaskId);
        }
    }]);

    return LockTTMediator;
}(_View3.default);

exports.default = (0, _utils2.connect)(function (state) {
    return {
        openTaskId: (0, _selectors.getOpenTaskId)(state)
    };
}, function (dispatch) {
    return {
        openTaskPanel: (0, _redux.bindActionCreators)(_actions.openEditTaskPanel, dispatch),
        toast: (0, _redux.bindActionCreators)(_actions2.toast, dispatch)
    };
})(LockTTMediator);

/***/ }),
/* 1554 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.AccessToManagerScopesStrategy = exports.EditHierarchyRightStrategy = exports.GenerateMoneyReportRightStrategy = exports.SubmitTTRightStrategy = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _constants = __webpack_require__(4);

var _atUtils = __webpack_require__(5);

var _features = __webpack_require__(22);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AccessRightsStrategy = function () {
    function AccessRightsStrategy(id, nameKey, selectAllMessageKey, filterMessageKey, userNoRightsMessageKey, userNoEmailAndRightsMessageKey, noAccessRightGrantedUsersMessageKey, noEnabledAccessRightGrantedUsersMessageKey, noSelectedNodesHasDisabledOrWithoutAccessRightMessageKey, groupEmptyEntityTooltipKey, noNotificationAccessRightMessageKey) {
        _classCallCheck(this, AccessRightsStrategy);

        this.id = id;
        this.nameKey = nameKey;
        this.name = null;
        this.selectAllMessageKey = selectAllMessageKey ? selectAllMessageKey : "common.users_selector.access_right.select_all";
        this.filterMessageKey = filterMessageKey ? filterMessageKey : "common.users_selector.access_right.show_users_without_right";
        this.userNoRightsMessageKey = userNoRightsMessageKey ? userNoRightsMessageKey : "common.users_selector.access_right.insufficient_rights";
        this.userNoEmailAndRightsMessageKey = userNoEmailAndRightsMessageKey ? userNoEmailAndRightsMessageKey : "common.users_selector.access_right.insufficient_rights_without_email";
        this.noAccessRightGrantedUsersMessageKey = noAccessRightGrantedUsersMessageKey ? noAccessRightGrantedUsersMessageKey : "users_selector.no_access_right_granted_users";
        this.noEnabledAccessRightGrantedUsersMessageKey = noEnabledAccessRightGrantedUsersMessageKey ? noEnabledAccessRightGrantedUsersMessageKey : "users_selector.no_access_right_granted_users_with_enabled_access";
        this.noSelectedNodesHasDisabledOrWithoutAccessRightMessageKey = noSelectedNodesHasDisabledOrWithoutAccessRightMessageKey ? noSelectedNodesHasDisabledOrWithoutAccessRightMessageKey : "users_selector.hide_not_selected.only_disabled_or_without_ar";
        this.groupEmptyEntityTooltipKey = groupEmptyEntityTooltipKey ? groupEmptyEntityTooltipKey : "users_selector.notifications.expand_collapse_disabled.tooltip";
        this.noNotificationAccessRightMessageKey = noNotificationAccessRightMessageKey ? noNotificationAccessRightMessageKey : "mail_notifications.users_selector.no_notification.access_right";
        this.name = this.nameKey ? _messageResource2.default.getMessage(this.nameKey) : "";
    }

    _createClass(AccessRightsStrategy, [{
        key: "getId",
        value: function getId() {
            return this.id;
        }

        /**
         * Determines whether passed access rights provide privileges
         * @param userRights the set of rights to be verified
         */

    }, {
        key: "isGranted",
        value: function isGranted(userRights) {
            return userRights.indexOf(this.id) !== -1;
        }
    }, {
        key: "getSelectAllMessage",
        value: function getSelectAllMessage() {
            return _messageResource2.default.getMessage(this.selectAllMessageKey, [this.name]);
        }
    }, {
        key: "getFilterMessage",
        value: function getFilterMessage() {
            return _messageResource2.default.getMessage(this.filterMessageKey, [this.name]);
        }
    }, {
        key: "getUserNoRightsMessage",
        value: function getUserNoRightsMessage() {
            return _messageResource2.default.getMessage(this.userNoRightsMessageKey, [this.name]);
        }
    }, {
        key: "getUserNoEmailAndRightsMessage",
        value: function getUserNoEmailAndRightsMessage() {
            return _messageResource2.default.getMessage(this.userNoEmailAndRightsMessageKey);
        }
    }, {
        key: "getNoAccessRightGrantedUsersMessage",
        value: function getNoAccessRightGrantedUsersMessage() {
            return _messageResource2.default.getMessage(this.noAccessRightGrantedUsersMessageKey, [(0, _atUtils.escapeHtmlSymbols)(this.name)]);
        }
    }, {
        key: "getNoEnabledAccessRightGrantedUsersMessage",
        value: function getNoEnabledAccessRightGrantedUsersMessage() {
            return _messageResource2.default.getMessage(this.noEnabledAccessRightGrantedUsersMessageKey, [(0, _atUtils.escapeHtmlSymbols)(this.name)]);
        }
    }, {
        key: "getNoSelectedNodesHasDisabledOrWithoutAccessRightMessage",
        value: function getNoSelectedNodesHasDisabledOrWithoutAccessRightMessage() {
            return _messageResource2.default.getMessage(this.noSelectedNodesHasDisabledOrWithoutAccessRightMessageKey, [(0, _atUtils.escapeHtmlSymbols)(this.name)]);
        }
    }, {
        key: "getGroupEmptyEntityTooltip",
        value: function getGroupEmptyEntityTooltip() {
            return _messageResource2.default.getMessage(this.groupEmptyEntityTooltipKey, [this.name]);
        }
    }, {
        key: "getNoNotificationAccessRightMessage",
        value: function getNoNotificationAccessRightMessage(user) {
            return _messageResource2.default.getMessage(this.noNotificationAccessRightMessageKey, [user.formatNameFML(), this.name]);
        }
    }, {
        key: "getName",
        value: function getName() {
            return this.name;
        }
    }]);

    return AccessRightsStrategy;
}();

var SubmitTTRightStrategy = exports.SubmitTTRightStrategy = function (_AccessRightsStrategy) {
    _inherits(SubmitTTRightStrategy, _AccessRightsStrategy);

    function SubmitTTRightStrategy() {
        _classCallCheck(this, SubmitTTRightStrategy);

        return _possibleConstructorReturn(this, (SubmitTTRightStrategy.__proto__ || Object.getPrototypeOf(SubmitTTRightStrategy)).call(this, _constants.AccessRights.SUBMIT_TIME_TRACK, "common.users_selector.access_right.submit_time_track"));
    }

    return SubmitTTRightStrategy;
}(AccessRightsStrategy);

var GenerateMoneyReportRightStrategy = exports.GenerateMoneyReportRightStrategy = function (_AccessRightsStrategy2) {
    _inherits(GenerateMoneyReportRightStrategy, _AccessRightsStrategy2);

    function GenerateMoneyReportRightStrategy() {
        _classCallCheck(this, GenerateMoneyReportRightStrategy);

        var isURAEnabled = (0, _features.isEnabled)(_features.Feature.URA);
        var isBTYEnabled = (0, _features.isEnabled)(_features.Feature.BTY);
        var rightTitleKey = "";
        if (isURAEnabled && isBTYEnabled) rightTitleKey = "common.users_selector.access_right.generate_money_reports";
        if (!isURAEnabled && isBTYEnabled) rightTitleKey = "common.users_selector.access_right.generate_money_reports_only_billing";
        if (isURAEnabled && !isBTYEnabled) rightTitleKey = "common.users_selector.access_right.generate_money_reports_only_cost";
        return _possibleConstructorReturn(this, (GenerateMoneyReportRightStrategy.__proto__ || Object.getPrototypeOf(GenerateMoneyReportRightStrategy)).call(this, _constants.AccessRights.GENERATE_MONEY_REPORTS, rightTitleKey));
    }

    return GenerateMoneyReportRightStrategy;
}(AccessRightsStrategy);

var EditHierarchyRightStrategy = exports.EditHierarchyRightStrategy = function (_AccessRightsStrategy3) {
    _inherits(EditHierarchyRightStrategy, _AccessRightsStrategy3);

    function EditHierarchyRightStrategy() {
        _classCallCheck(this, EditHierarchyRightStrategy);

        return _possibleConstructorReturn(this, (EditHierarchyRightStrategy.__proto__ || Object.getPrototypeOf(EditHierarchyRightStrategy)).call(this, _constants.AccessRights.EDIT_HIERARCHY, "common.users_selector.access_right.manage_scope"));
    }

    return EditHierarchyRightStrategy;
}(AccessRightsStrategy);

var AccessToManagerScopesStrategy = exports.AccessToManagerScopesStrategy = function (_AccessRightsStrategy4) {
    _inherits(AccessToManagerScopesStrategy, _AccessRightsStrategy4);

    function AccessToManagerScopesStrategy() {
        _classCallCheck(this, AccessToManagerScopesStrategy);

        return _possibleConstructorReturn(this, (AccessToManagerScopesStrategy.__proto__ || Object.getPrototypeOf(AccessToManagerScopesStrategy)).call(this, 100, "users_selector.access_right.access_to_scope_of_work", "users_selector.access_right.access_to_scope_of_work.select_all", "users_selector.access_right.access_to_scope_of_work.show_users_without_right", "users_selector.access_right.access_to_scope_of_work.insufficient_rights", "users_selector.access_right.access_to_scope_of_work.insufficient_rights_without_email", "users_selector.access_right.access_to_scope_of_work.no_access_right_granted_users", "users_selector.access_right.access_to_scope_of_work.no_access_right_granted_users_with_enabled_access", "users_selector.access_right.access_to_scope_of_work.hide_not_selected.only_disabled_or_without_ar", "users_selector.access_right.access_to_scope_of_work.expand_collapse_disabled.tooltip", "users_selector.access_right.access_to_scope_of_work.no_notification.access_right"));
    }

    _createClass(AccessToManagerScopesStrategy, [{
        key: "isGranted",
        value: function isGranted(userRights) {
            //TODO[enkov]: use common method
            return userRights.indexOf(_constants.AccessRights.MANAGE_USERS) !== -1 || userRights.indexOf(_constants.AccessRights.EDIT_HIERARCHY) !== -1 || userRights.indexOf(_constants.AccessRights.SUBMIT_OTHER_USER_TIME_TRACK) !== -1 || userRights.indexOf(_constants.AccessRights.GENERATE_MONEY_REPORTS) !== -1;
        }
    }]);

    return AccessToManagerScopesStrategy;
}(AccessRightsStrategy);

/***/ }),
/* 1555 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.PersonalEarningsRuleState = exports.ProjectBudgetRuleState = exports.EstimateRuleState = exports.DeadlineRuleState = exports.UnsubmittedTTRuleState = exports.PersonalTTRuleState = undefined;

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _CoarseSelection = __webpack_require__(284);

var _CoarseSelection2 = _interopRequireDefault(_CoarseSelection);

var _GroupType = __webpack_require__(34);

var _GroupType2 = _interopRequireDefault(_GroupType);

var _two_level_selection = __webpack_require__(70);

var _two_level_selection2 = _interopRequireDefault(_two_level_selection);

var _index = __webpack_require__(22);

var _atUtils = __webpack_require__(5);

var _user_group_selector_util = __webpack_require__(98);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _UserSelectorUtils = __webpack_require__(514);

var _UserSelectorUtils2 = _interopRequireDefault(_UserSelectorUtils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Base object representing a single notification rule state.
 *
 *
 */

var RuleState = function () {
    function RuleState(rule) {
        _classCallCheck(this, RuleState);

        this.savedState = {};
        this.currentState = null;
        this.rule = rule;
        this.recipientsKey = 'recipients';
        this.cpSelectorKey = 'projects';
        this.cpParamPrefix = 'customers_projects';
        this.ttUsersKey = 'ttUsers';
        this.ttLimitKey = 'ttLimit';
        this.moneyKey = 'money';
    }

    /**
     * Set rule initial state. The method should be called when new rule is created
     */


    _createClass(RuleState, [{
        key: 'setInitialState',
        value: function setInitialState() {
            this.getCurrentState(true);
            this.savedState = this.currentState;
            this.setStateOfAllUserSelectors();
        }
    }, {
        key: 'update',
        value: function update() {
            this.getCurrentState();
            if (this.isValid()) {
                this.savedState = this.currentState;
                return true;
            }
            return false;
        }
    }, {
        key: 'reset',
        value: function reset() {
            if (this.savedState[this.recipientsKey]) this.setState();
        }
    }, {
        key: 'isChanged',
        value: function isChanged() {
            var currentCpSelectorState;
            var savedCpSelectorState;
            if (this.rule.cpSelector) {
                currentCpSelectorState = this.currentState[this.cpSelectorKey];
                savedCpSelectorState = this.savedState[this.cpSelectorKey];
                if (!this.rule.cpSelector.isAlreadyShown()) {
                    delete this.currentState[this.cpSelectorKey];
                    delete this.savedState[this.cpSelectorKey];
                } else {
                    delete this.savedState[this.cpSelectorKey].outputData;
                }
            }
            var result = !equalObjects(this.currentState, this.savedState);
            if (this.rule.cpSelector) {
                this.currentState[this.cpSelectorKey] = currentCpSelectorState;
                this.savedState[this.cpSelectorKey] = savedCpSelectorState;
            }
            return result;
        }
    }, {
        key: 'isValid',
        value: function isValid() {
            return this.checkUsersSelectorParams(this.rule.recipientsSelector, this.recipientsKey);
        }
    }, {
        key: 'focusFirstErroneousInput',
        value: function focusFirstErroneousInput() {}
    }, {
        key: 'setState',
        value: function setState() {
            this.rule.disableInputs();
            this.setStateOfAllUserSelectors();
        }
    }, {
        key: 'setStateOfAllUserSelectors',
        value: function setStateOfAllUserSelectors() {
            this.setUsersSelectorState(this.rule.recipientsSelector, this.recipientsKey);
        }
    }, {
        key: 'getCurrentState',
        value: function getCurrentState(isInitial) {
            this.currentState = this.getParams(isInitial);
            return this.currentState;
        }
    }, {
        key: 'getParams',
        value: function getParams(isInitial) {
            var params = {};
            params[this.recipientsKey] = {};
            this.fillUsersSelectorParams(params[this.recipientsKey], this.rule.recipientsSelector);
            return params;
        }
    }, {
        key: 'checkRecipients',
        value: function checkRecipients() {
            this.getCurrentState();
            var selector = this.rule.recipientsSelector;
            var selectedUsers = !selector.selector.isCustomOptionSelected() ? selector.selector.getLowLevelEntities() :
            // if the selector is shown, a group's children will be selected and returned by getOnlyUsersSelection(),
            // otherwise a initial selection will be used. The initial selection don't have selected group's children for selected groups.
            selector.selector.isAlreadyShown() ? selector.selector.getOnlyUsersSelection() : selector.selector.getAllSelectedUsers();
            var hasSuitableUsers = false;

            for (var i = 0; i < selectedUsers.length; i++) {
                if (selectedUsers[i].hasEmail() && selectedUsers[i].isActive() && (!selector.accessRight || selector.accessRight.isGranted(selectedUsers[i].accessRight))) {
                    hasSuitableUsers = true;
                    break;
                }
            }

            var message = null;
            if (!hasSuitableUsers) {
                message = _messageResource2.default.getMessage("mail_notifications.warning.recipients");
                if (selector.accessRight) {
                    message += _messageResource2.default.getMessage("mail_notifications.warning.recipients.insufficient_rights");
                }
                message += _messageResource2.default.getMessage("mail_notifications.warning.recipients.footer");
                return message;
            }

            return message;
        }

        /**
         * Initiates RuleState.
         * NOTE: Inheritors should perform specific initiations first and call parent method after all as it calls setState method.
         * Otherwise it is developer's responsibility to handel any error which may occur.
         * @param params
         */

    }, {
        key: 'initState',
        value: function initState(params) {
            this.setUsersSelectorParams(params, this.recipientsKey, this.recipientsKey, this.rule.recipientsSelector);
            this.setState();
            this.currentState = this.savedState;
            this.isDaysValid = true;
            this.isTimeValid = true;
        }
    }, {
        key: 'setStateParam',
        value: function setStateParam(paramName, value) {
            this.savedState[paramName] = value;
        }
    }, {
        key: 'fillUsersSelectorParams',
        value: function fillUsersSelectorParams(params, selector) {
            params.allUsers = !selector.selector.isCustomOptionSelected();
            var selection = selector.selector.getSelection();
            //sorting of arrays is needed due to check equality of objects in future (Rule state isChanged() method).
            params.selectedGroups = params.allUsers ? null : selection.getFirstLevel().sort(_atUtils.numberComparator);
            params.selectedUsers = params.allUsers ? null : selection.getSecondLevel().sort(_atUtils.numberComparator);
            params.selectedGroupType = params.allUsers ? null : selector.selector.getGroupType();
            params.allUsers = "" + params.allUsers; // a workaround in a purpose of object comparison.
            // Need to have allUsers String, as far as when we get params for saved rules we are received String.
        }
    }, {
        key: 'checkUsersSelectorParams',
        value: function checkUsersSelectorParams(userSelector, paramName) {
            var selectorParams = this.currentState[paramName];
            if (selectorParams.allUsers == "true" || selectorParams.selectedUsers.length != 0 || selectorParams.selectedGroups.length != 0) return true;
            userSelector.setDisplayInputError(true, (0, _user_group_selector_util.getUserSelectorFeatureStrategy)().getEmptySelectionTooltipText());
            return false;
        }
    }, {
        key: 'setUsersSelectorParams',
        value: function setUsersSelectorParams(params, prefix, paramName, selector) {
            var featureDependentUserGroups = (0, _index.isEnabled)(_index.Feature.UGR) ? this.rule.usersInfo.userGroups : [];
            var featureDependentTZGroups = (0, _index.isEnabled)(_index.Feature.TZG) ? this.rule.usersInfo.timeZoneGroups : [];

            var userList = this.rule.usersInfo.users;

            var allUsers = params[String.format('{0}.allUsers', prefix)] || "";
            var selectedUsers = params[String.format('{0}.selectedUsers', prefix)].split(",") || "";
            var selectedGroups = params[String.format('{0}.selectedGroups', prefix)].split(",") || "";
            var selectedGroupType = params[String.format('{0}.selectedGroupType', prefix)] || "";
            var existingUsers = getPropertyValues(selectFromArray(selectedUsers, userList), "id");
            var existingGroups = getPropertyValues(selectFromArray(selectedGroups, selectedGroupType == _GroupType2.default.TIME_ZONE_GROUP ? featureDependentTZGroups : featureDependentUserGroups), "id");

            var isAllUsers = allUsers == "true";

            var convertedUsers = _UserSelectorUtils2.default.convertSelectedGroupsIntoSelectedUsersIfNecessary(userList, selectedGroupType, isAllUsers, false, selectedGroups, (0, _index.isEnabled)(_index.Feature.UGR), (0, _index.isEnabled)(_index.Feature.TZG));

            if (selector.accessRight) {
                convertedUsers = _jquery2.default.grep(convertedUsers, function (user) {
                    return selector.accessRight.isGranted(user.accessRight);
                });
            }

            existingUsers = _jquery2.default.merge(existingUsers, getPropertyValues(convertedUsers, "id"));

            this.setStateParam(paramName, {
                allUsers: allUsers,
                selectedUsers: isAllUsers ? null : existingUsers,
                selectedGroups: isAllUsers ? null : existingGroups,
                selectedGroupType: isAllUsers ? null : selectedGroupType
            });
            if (!isAllUsers && existingUsers.length == 0 && existingGroups.length == 0) this.setParamsError = true;
        }
    }, {
        key: 'setUsersSelectorState',
        value: function setUsersSelectorState(selector, paramName) {
            var users = this.savedState[paramName].selectedUsers;
            var groups = this.savedState[paramName].selectedGroups;
            var groupType = this.savedState[paramName].selectedGroupType;
            var allUsers = this.savedState[paramName].allUsers == "true";
            selector.setInitialSelection(allUsers, new _two_level_selection2.default(groups ? groups : [], users ? users : []), groupType);
        }
    }, {
        key: 'fillTTLimitParams',
        value: function fillTTLimitParams(params, ttLimit) {
            params.rangeDays = ttLimit.daysInput.value;
            params.time = ttLimit.timeInput.value;
            params.onlyWorkingDays = ttLimit.dayTypeDropdownBtn.getValue();
        }
    }, {
        key: 'checkTTLimitParams',
        value: function checkTTLimitParams(ttLimit, paramName) {
            this.isDaysValid = this.checkPositiveIntegerInput(ttLimit.daysInput, this.currentState[paramName].rangeDays);
            this.isTimeValid = this.checkTimeInput(ttLimit.timeInput, this.currentState[paramName].time);
            return this.isDaysValid && this.isTimeValid;
        }
    }, {
        key: 'checkPositiveIntegerInput',
        value: function checkPositiveIntegerInput(input, value, message) {
            var errorMessage = null;

            if (!isUnsignedPositiveInteger(value)) {
                if (typeof message === "undefined") message = _messageResource2.default.getMessage("mail_notifications.form.input.invalid_data.positive_integer");
                errorMessage = message;
            }
            errorMessage = this.checkNotEmpty(value, errorMessage);
            this.displayInputError(input, errorMessage);
            return errorMessage == null;
        }
    }, {
        key: 'checkTimeInput',
        value: function checkTimeInput(input, value) {
            return this.checkPositiveIntegerInput(input, value, _messageResource2.default.getMessage('mail_notifications.form.input.invalid_data.positive_time', [SystemSettings.decimalSeparator]));
        }
    }, {
        key: 'checkNotEmpty',
        value: function checkNotEmpty(value, message) {
            if (value.length == 0) {
                message = _messageResource2.default.getMessage("mail_notifications.form.input.invalid_data.empty");
            }
            return message;
        }
    }, {
        key: 'displayInputError',
        value: function displayInputError(input, message) {
            if (message) input.setDisplayInputError(true, message);
        }
    }, {
        key: 'setTTLimitParams',
        value: function setTTLimitParams(params, prefix, paramName) {
            this.setStateParam(paramName, {
                rangeDays: params[String.format('{0}.rangeDays', prefix)],
                time: params[String.format('{0}.time', prefix)],
                onlyWorkingDays: params[String.format('{0}.onlyWorkingDays', prefix)]
            });
        }
    }, {
        key: 'setTTLimitState',
        value: function setTTLimitState(ttLimit, paramName) {
            ttLimit.daysInput.value = this.savedState[paramName].rangeDays;
            ttLimit.timeInput.value = this.savedState[paramName].time;

            var workingDays = this.savedState[paramName].onlyWorkingDays;
            ttLimit.dayTypeDropdownBtn.currentValue = workingDays;
            ttLimit.dayTypeDropdownBtn.setActiveItemByValue(workingDays);
            ttLimit.dayTypeSelect.updateData(ttLimit.dayTypeDropdownBtn.getText());
        }
    }, {
        key: 'initTTLimitState',
        value: function initTTLimitState(ttLimit, paramName) {
            ttLimit.daysInput.init(this.savedState[paramName].rangeDays);
            ttLimit.timeInput.init(this.savedState[paramName].time);
            //ttLimit.dayTypeSelect.init ( this.savedState[paramName].onlyWorkingDays );
        }
    }, {
        key: 'fillCPSelectorParams',
        value: function fillCPSelectorParams(params, cpSelector, isInitial) {
            if (isInitial) {
                params.coarseSelection = _CoarseSelection2.default.ALL;
                params.showArchived = false;
                params.customerList = "";
                params.projectList = "";
            } else if (cpSelector.isAlreadyShown()) {
                var state = cpSelector.getState();
                params.coarseSelection = state.optionValue;
                params.showArchived = state.showInactive;
                var customersCSV = "";
                var projectsCSV = "";
                if (cpSelector.isCustomOptionSelected()) {
                    //sorting of arrays is needed due to check equality of objects in future (Rule state isChanged() method).
                    customersCSV = state.selection.getFirstLevel().sort(_atUtils.numberComparator).join();
                    projectsCSV = state.selection.getSecondLevel().sort(_atUtils.numberComparator).join();
                }
                params.customerList = customersCSV;
                params.projectList = projectsCSV;
            } else {
                var savedState = this.savedState[this.cpSelectorKey];
                params.coarseSelection = savedState.coarseSelection;
                params.showArchived = savedState.showArchived;
                params.customerList = savedState.customerList;
                params.projectList = savedState.projectList;
                params.outputData = savedState.outputData;
            }
        }
    }, {
        key: 'checkCPSelectorParams',
        value: function checkCPSelectorParams(cpSelectorButton, paramName) {
            var cpSelectorParams = this.currentState[paramName];
            if (cpSelectorParams.coarseSelection != _CoarseSelection2.default.SPECIFIC || cpSelectorParams.projectList.length != 0 || cpSelectorParams.customerList.length != 0) return true;
            cpSelectorButton.setDisplayInputError(true, _messageResource2.default.getEscapedMessage("mail_notifications.projects_customers_selector.error.no_projects_customers_selected"));
            return false;
        }
    }, {
        key: 'setCPSelectorParams',
        value: function setCPSelectorParams(params, prefix, paramName) {
            var coarseSelection = params[String.format('{0}.coarseSelection', prefix)];
            var projectList = params[String.format('{0}.projectList', prefix)] || "";
            var customerList = params[String.format('{0}.customerList', prefix)] || "";
            var outputData = params.customerProjectOutputData;
            var existingProjects = projectList.split(',');
            var existingCustomers = customerList.split(',');
            this.setStateParam(paramName, {
                coarseSelection: coarseSelection,
                showArchived: params[String.format('{0}.showArchived', prefix)] == 'true',
                projectList: existingProjects.toString(),
                customerList: existingCustomers.toString(),
                outputData: outputData
            });

            //to pause the Rule
            if (coarseSelection == _CoarseSelection2.default.SPECIFIC && existingProjects.length == 0 && existingCustomers.length == 0) this.setParamsError = true;
        }
    }, {
        key: 'setCPSelectorState',
        value: function setCPSelectorState(cpSelector, paramName) {
            var state = {};

            state.optionValue = this.savedState[paramName].coarseSelection;
            state.showInactive = this.savedState[paramName].showArchived;
            state.selection = state.optionValue == _CoarseSelection2.default.SPECIFIC ? new _two_level_selection2.default(safeSplit(this.savedState[paramName].customerList, ','), safeSplit(this.savedState[paramName].projectList, ',')) : _two_level_selection2.default.emptySelection();
            if (cpSelector.isAlreadyShown()) {
                cpSelector.setPredefinedParameters(state);
                cpSelector.loadState(state);
            } else {
                this.rule.cpSelectorButton.setText(CPSelectorClientUtil.makePredefinedSelection(cpSelector, state, this.savedState[paramName].outputData));
                this.rule.cpSelector.setGetPredefinedSelectionCallback(function () {
                    return state;
                });
            }
        }
    }, {
        key: 'checkMoneyConditionParams',
        value: function checkMoneyConditionParams(moneyCondition, paramName) {
            return this.checkPositiveIntegerInput(moneyCondition.amountInput, this.currentState[paramName].amount);
        }
    }, {
        key: 'fillMoneyConditionParams',
        value: function fillMoneyConditionParams(params, moneyCondition) {
            params.rangeName = moneyCondition.timeRangeDropdownBtn.getValue();
            params.amount = moneyCondition.amountInput.value;
        }
    }, {
        key: 'setMoneyConditionParams',
        value: function setMoneyConditionParams(params, prefix, paramName) {
            this.setStateParam(paramName, {
                rangeName: params[String.format('{0}.range', prefix)],
                amount: new Number(params[String.format('{0}.amount', prefix)])
            });
        }
    }, {
        key: 'setMoneyConditionState',
        value: function setMoneyConditionState(moneyCondition, paramName) {
            var amount = this.savedState[paramName].amount;
            var rangeName = this.savedState[paramName].rangeName;
            if (amount && !isNaN(amount)) moneyCondition.amountInput.value = amount;

            if (rangeName) {
                moneyCondition.timeRangeDropdownBtn.currentValue = rangeName;
                moneyCondition.timeRangeDropdownBtn.setActiveItemByValue(rangeName);
                moneyCondition.timeRangeSelect.updateData(moneyCondition.timeRangeDropdownBtn.getText());
            }
        }
    }]);

    return RuleState;
}();

/**
 * PersonalTTRuleState
 */

var PersonalTTRuleState = exports.PersonalTTRuleState = function (_RuleState) {
    _inherits(PersonalTTRuleState, _RuleState);

    function PersonalTTRuleState(rule) {
        _classCallCheck(this, PersonalTTRuleState);

        return _possibleConstructorReturn(this, (PersonalTTRuleState.__proto__ || Object.getPrototypeOf(PersonalTTRuleState)).call(this, rule));
    }

    _createClass(PersonalTTRuleState, [{
        key: 'isValid',
        value: function isValid() {
            var checkDefault = RuleState.prototype.isValid.call(this);
            var checkTTLimit = this.checkTTLimitParams(this.rule.ttLimit, this.ttLimitKey);
            return checkDefault && checkTTLimit;
        }
    }, {
        key: 'focusFirstErroneousInput',
        value: function focusFirstErroneousInput() {
            if (!this.isTimeValid) this.rule.ttLimit.timeInput.focus();else if (!this.isDaysValid) this.rule.ttLimit.daysInput.focus();
        }
    }, {
        key: 'setState',
        value: function setState() {
            _get(PersonalTTRuleState.prototype.__proto__ || Object.getPrototypeOf(PersonalTTRuleState.prototype), 'setState', this).call(this);
            this.setTTLimitState(this.rule.ttLimit, this.ttLimitKey);
        }
    }, {
        key: 'getParams',
        value: function getParams(isInitial) {
            var params = _get(PersonalTTRuleState.prototype.__proto__ || Object.getPrototypeOf(PersonalTTRuleState.prototype), 'getParams', this).call(this, isInitial);
            params[this.ttLimitKey] = {};
            this.fillTTLimitParams(params[this.ttLimitKey], this.rule.ttLimit);
            return params;
        }
    }, {
        key: 'initState',
        value: function initState(params) {
            this.setTTLimitParams(params, 'tt_limit', this.ttLimitKey);
            this.initTTLimitState(this.rule.ttLimit, this.ttLimitKey);
            RuleState.prototype.initState.call(this, params);
        }
    }]);

    return PersonalTTRuleState;
}(RuleState);

/**
 * UnsubmittedTTRuleState
 */

var UnsubmittedTTRuleState = exports.UnsubmittedTTRuleState = function (_RuleState2) {
    _inherits(UnsubmittedTTRuleState, _RuleState2);

    function UnsubmittedTTRuleState(rule) {
        _classCallCheck(this, UnsubmittedTTRuleState);

        return _possibleConstructorReturn(this, (UnsubmittedTTRuleState.__proto__ || Object.getPrototypeOf(UnsubmittedTTRuleState)).call(this, rule));
    }

    _createClass(UnsubmittedTTRuleState, [{
        key: 'isValid',
        value: function isValid() {
            var checkDefault = RuleState.prototype.isValid.call(this);
            var checkUsers = this.checkUsersSelectorParams(this.rule.ttUsersSelector, this.ttUsersKey);
            var checkTTLimit = this.checkTTLimitParams(this.rule.ttLimit, this.ttLimitKey);
            return checkDefault && checkUsers && checkTTLimit;
        }
    }, {
        key: 'focusFirstErroneousInput',
        value: function focusFirstErroneousInput() {
            if (!this.isTimeValid) this.rule.ttLimit.timeInput.focus();else if (!this.isDaysValid) this.rule.ttLimit.daysInput.focus();
        }
    }, {
        key: 'setState',
        value: function setState() {
            _get(UnsubmittedTTRuleState.prototype.__proto__ || Object.getPrototypeOf(UnsubmittedTTRuleState.prototype), 'setState', this).call(this);
            this.setTTLimitState(this.rule.ttLimit, this.ttLimitKey);
        }
    }, {
        key: 'setStateOfAllUserSelectors',
        value: function setStateOfAllUserSelectors() {
            _get(UnsubmittedTTRuleState.prototype.__proto__ || Object.getPrototypeOf(UnsubmittedTTRuleState.prototype), 'setStateOfAllUserSelectors', this).call(this);
            this.setUsersSelectorState(this.rule.ttUsersSelector, this.ttUsersKey);
        }
    }, {
        key: 'getParams',
        value: function getParams(isInitial) {
            var params = _get(UnsubmittedTTRuleState.prototype.__proto__ || Object.getPrototypeOf(UnsubmittedTTRuleState.prototype), 'getParams', this).call(this, isInitial);
            params[this.ttLimitKey] = {};
            this.fillTTLimitParams(params[this.ttLimitKey], this.rule.ttLimit);
            params[this.ttUsersKey] = {};
            this.fillUsersSelectorParams(params[this.ttUsersKey], this.rule.ttUsersSelector);
            return params;
        }
    }, {
        key: 'initState',
        value: function initState(params) {
            this.setTTLimitParams(params, 'tt_limit', this.ttLimitKey);
            this.setUsersSelectorParams(params, 'tt_users', this.ttUsersKey, this.rule.ttUsersSelector);
            this.initTTLimitState(this.rule.ttLimit, this.ttLimitKey);

            RuleState.prototype.initState.call(this, params);
        }
    }]);

    return UnsubmittedTTRuleState;
}(RuleState);

/**
 * DeadlineRuleState
 */

var DeadlineRuleState = exports.DeadlineRuleState = function (_RuleState3) {
    _inherits(DeadlineRuleState, _RuleState3);

    function DeadlineRuleState(rule) {
        _classCallCheck(this, DeadlineRuleState);

        var _this3 = _possibleConstructorReturn(this, (DeadlineRuleState.__proto__ || Object.getPrototypeOf(DeadlineRuleState)).call(this, rule));

        _this3.deadlineKey = 'deadline';
        _this3.stateButtonKey = 'stateButtonValue';
        _this3.isDeadlineValid = true;
        return _this3;
    }

    _createClass(DeadlineRuleState, [{
        key: 'isValid',
        value: function isValid() {
            var checkDefault = RuleState.prototype.isValid.call(this);
            var checkCP = this.checkCPSelectorParams(this.rule.cpSelectorButton, this.cpSelectorKey);
            this.isDeadlineValid = this.checkDeadlineConditionParams(this.rule.deadlineCondition);
            return checkDefault && checkCP && this.isDeadlineValid;
        }
    }, {
        key: 'focusFirstErroneousInput',
        value: function focusFirstErroneousInput() {
            if (!this.isDeadlineValid) this.rule.deadlineCondition.focus();
        }
    }, {
        key: 'setState',
        value: function setState() {
            _get(DeadlineRuleState.prototype.__proto__ || Object.getPrototypeOf(DeadlineRuleState.prototype), 'setState', this).call(this);
            this.setCPSelectorState(this.rule.cpSelector, this.cpSelectorKey);
            this.setDeadlineConditionState(this.rule.deadlineCondition);
        }
    }, {
        key: 'getParams',
        value: function getParams(isInitial) {
            var params = _get(DeadlineRuleState.prototype.__proto__ || Object.getPrototypeOf(DeadlineRuleState.prototype), 'getParams', this).call(this, isInitial);
            params[this.cpSelectorKey] = {};
            this.fillCPSelectorParams(params[this.cpSelectorKey], this.rule.cpSelector, isInitial);
            this.fillDeadlineConditionParams(params, this.rule.deadlineCondition);
            return params;
        }
    }, {
        key: 'initState',
        value: function initState(params) {
            this.setCPSelectorParams(params, this.cpParamPrefix, this.cpSelectorKey);
            this.setDeadlineConditionParams(params);
            this.rule.deadlineCondition.daysInput.init(Math.abs(this.savedState[this.deadlineKey]));
            this.rule.deadlineCondition.stateSelect.init(this.rule.deadlineCondition.stateBtn.getText());

            RuleState.prototype.initState.call(this, params);
            this.rule.deadlineCondition.daysInput.disableInput();
        }
    }, {
        key: 'checkDeadlineConditionParams',
        value: function checkDeadlineConditionParams(deadlineCondition) {
            if (this.currentState[this.stateButtonKey] == DeadlineCondition.TODAY) return true;

            return this.checkPositiveIntegerInput(deadlineCondition.daysInput, deadlineCondition.daysInput.value);
        }
    }, {
        key: 'fillDeadlineConditionParams',
        value: function fillDeadlineConditionParams(params, deadlineCondition) {
            var stateValue = deadlineCondition.stateBtn.getValue();
            if (stateValue == DeadlineCondition.TODAY) {
                params[this.deadlineKey] = 0;
            } else if (stateValue == DeadlineCondition.MISSED) {
                params[this.deadlineKey] = (-1 * deadlineCondition.daysInput.value).toString();
            } else {
                params[this.deadlineKey] = deadlineCondition.daysInput.value;
            }
            params[this.stateButtonKey] = stateValue;
        }
    }, {
        key: 'setDeadlineConditionParams',
        value: function setDeadlineConditionParams(params) {
            var deadline = new Number(params[this.deadlineKey]);
            var stateButtonValue;

            if (!deadline || isNaN(deadline)) return;
            stateButtonValue = this.getDeadlineConditionStateButtonValue(deadline);
            this.savedState[this.stateButtonKey] = stateButtonValue;
            this.savedState[this.deadlineKey] = deadline;
        }
    }, {
        key: 'getDeadlineConditionStateButtonValue',
        value: function getDeadlineConditionStateButtonValue(deadlineValue) {
            var deadline = parseFloat(deadlineValue);
            if (isNaN(deadline)) return -1;
            if (deadline > 0) return DeadlineCondition.COMING_UP;else if (deadline < 0) return DeadlineCondition.MISSED;else return DeadlineCondition.TODAY;
        }
    }, {
        key: 'setDeadlineConditionState',
        value: function setDeadlineConditionState(deadlineCondition) {
            deadlineCondition.stateBtn.currentValue = this.savedState[this.stateButtonKey];
            deadlineCondition.stateBtn.setActiveItemByPosition(this.savedState[this.stateButtonKey] - 1);

            deadlineCondition.stateBtn.fireEvent('change', deadlineCondition.stateBtn);

            var inputValue = this.savedState[this.deadlineKey] == "" ? "" : Math.abs(this.savedState[this.deadlineKey]);
            deadlineCondition.daysInput.value = inputValue;
            deadlineCondition.stateSelect.updateData(deadlineCondition.stateBtn.getText());
        }
    }]);

    return DeadlineRuleState;
}(RuleState);

/**
 * EstimateRuleState
 */

var EstimateRuleState = exports.EstimateRuleState = function (_RuleState4) {
    _inherits(EstimateRuleState, _RuleState4);

    function EstimateRuleState(rule) {
        _classCallCheck(this, EstimateRuleState);

        var _this4 = _possibleConstructorReturn(this, (EstimateRuleState.__proto__ || Object.getPrototypeOf(EstimateRuleState)).call(this, rule));

        _this4.percentsKey = 'estimatePercents';
        _this4.isPercentsValid = true;
        return _this4;
    }

    _createClass(EstimateRuleState, [{
        key: 'isValid',
        value: function isValid() {
            var checkDefault = RuleState.prototype.isValid.call(this);
            var checkCP = this.checkCPSelectorParams(this.rule.cpSelectorButton, this.cpSelectorKey);
            this.isPercentsValid = this.checkPositiveIntegerInput(this.rule.estimateInput, this.currentState[this.percentsKey]);
            return checkDefault && checkCP && this.isPercentsValid;
        }
    }, {
        key: 'focusFirstErroneousInput',
        value: function focusFirstErroneousInput() {
            if (!this.isPercentsValid) this.rule.estimateInput.focus();
        }
    }, {
        key: 'setState',
        value: function setState() {
            _get(EstimateRuleState.prototype.__proto__ || Object.getPrototypeOf(EstimateRuleState.prototype), 'setState', this).call(this);
            this.setCPSelectorState(this.rule.cpSelector, this.cpSelectorKey);
            this.rule.estimateInput.value = this.savedState[this.percentsKey];
        }
    }, {
        key: 'getParams',
        value: function getParams(isInitial) {
            var params = _get(EstimateRuleState.prototype.__proto__ || Object.getPrototypeOf(EstimateRuleState.prototype), 'getParams', this).call(this, isInitial);
            params[this.cpSelectorKey] = {};
            this.fillCPSelectorParams(params[this.cpSelectorKey], this.rule.cpSelector, isInitial);
            params[this.percentsKey] = this.rule.estimateInput.value;
            return params;
        }
    }, {
        key: 'initState',
        value: function initState(params) {
            this.setCPSelectorParams(params, this.cpParamPrefix, this.cpSelectorKey);
            this.savedState[this.percentsKey] = params[this.percentsKey];
            if (!isNaN(this.savedState[this.percentsKey])) this.rule.estimateInput.init(this.savedState[this.percentsKey]);
            this.rule.estimateInput.setValidator(new IntegerInputControlValidator(1));
            RuleState.prototype.initState.call(this, params);
        }
    }]);

    return EstimateRuleState;
}(RuleState);

/**
 * ProjectBudgetRuleState
 */

var ProjectBudgetRuleState = exports.ProjectBudgetRuleState = function (_RuleState5) {
    _inherits(ProjectBudgetRuleState, _RuleState5);

    function ProjectBudgetRuleState(rule) {
        _classCallCheck(this, ProjectBudgetRuleState);

        var _this5 = _possibleConstructorReturn(this, (ProjectBudgetRuleState.__proto__ || Object.getPrototypeOf(ProjectBudgetRuleState)).call(this, rule));

        _this5.isMoneyValid = true;
        return _this5;
    }

    _createClass(ProjectBudgetRuleState, [{
        key: 'isValid',
        value: function isValid() {
            var checkDefault = RuleState.prototype.isValid.call(this);
            var checkCP = this.checkCPSelectorParams(this.rule.cpSelectorButton, this.cpSelectorKey);
            this.isMoneyValid = this.checkMoneyConditionParams(this.rule.moneyCondition, this.moneyKey);
            return checkDefault && checkCP && this.isMoneyValid;
        }
    }, {
        key: 'focusFirstErroneousInput',
        value: function focusFirstErroneousInput() {
            if (!this.isMoneyValid) this.rule.moneyCondition.focus();
        }
    }, {
        key: 'setState',
        value: function setState() {
            _get(ProjectBudgetRuleState.prototype.__proto__ || Object.getPrototypeOf(ProjectBudgetRuleState.prototype), 'setState', this).call(this);
            this.setCPSelectorState(this.rule.cpSelector, this.cpSelectorKey);
            this.setMoneyConditionState(this.rule.moneyCondition, this.moneyKey);
        }
    }, {
        key: 'getParams',
        value: function getParams(isInitial) {
            var params = _get(ProjectBudgetRuleState.prototype.__proto__ || Object.getPrototypeOf(ProjectBudgetRuleState.prototype), 'getParams', this).call(this, isInitial);
            params[this.cpSelectorKey] = {};
            this.fillCPSelectorParams(params[this.cpSelectorKey], this.rule.cpSelector, isInitial);
            params[this.moneyKey] = {};
            this.fillMoneyConditionParams(params[this.moneyKey], this.rule.moneyCondition);
            return params;
        }
    }, {
        key: 'initState',
        value: function initState(params) {
            this.setCPSelectorParams(params, this.cpParamPrefix, this.cpSelectorKey);
            this.setMoneyConditionParams(params, this.moneyKey, this.moneyKey);
            var amount = this.savedState[this.moneyKey].amount;
            if (amount && !isNaN(amount)) this.rule.moneyCondition.amountInput.init(amount);

            RuleState.prototype.initState.call(this, params);
        }
    }]);

    return ProjectBudgetRuleState;
}(RuleState);

/**
 * PersonalEarningsRuleState
 */

var PersonalEarningsRuleState = exports.PersonalEarningsRuleState = function (_RuleState6) {
    _inherits(PersonalEarningsRuleState, _RuleState6);

    function PersonalEarningsRuleState(rule) {
        _classCallCheck(this, PersonalEarningsRuleState);

        var _this6 = _possibleConstructorReturn(this, (PersonalEarningsRuleState.__proto__ || Object.getPrototypeOf(PersonalEarningsRuleState)).call(this, rule));

        _this6.ttUsersKey = 'ttUsers';
        _this6.moneyKey = 'money';
        _this6.isMoneyValid = true;
        return _this6;
    }

    _createClass(PersonalEarningsRuleState, [{
        key: 'isValid',
        value: function isValid() {
            var checkDefault = RuleState.prototype.isValid.call(this);
            var checkUsers = this.checkUsersSelectorParams(this.rule.ttUsersSelector, this.ttUsersKey);
            this.isMoneyValid = this.checkMoneyConditionParams(this.rule.moneyCondition, this.moneyKey);
            return checkDefault && checkUsers && this.isMoneyValid;
        }
    }, {
        key: 'focusFirstErroneousInput',
        value: function focusFirstErroneousInput() {
            if (!this.isMoneyValid) this.rule.moneyCondition.focus();
        }
    }, {
        key: 'setState',
        value: function setState() {
            _get(PersonalEarningsRuleState.prototype.__proto__ || Object.getPrototypeOf(PersonalEarningsRuleState.prototype), 'setState', this).call(this);
            this.setMoneyConditionState(this.rule.moneyCondition, this.moneyKey);
        }
    }, {
        key: 'setStateOfAllUserSelectors',
        value: function setStateOfAllUserSelectors() {
            _get(PersonalEarningsRuleState.prototype.__proto__ || Object.getPrototypeOf(PersonalEarningsRuleState.prototype), 'setStateOfAllUserSelectors', this).call(this);
            this.setUsersSelectorState(this.rule.ttUsersSelector, this.ttUsersKey);
        }
    }, {
        key: 'getParams',
        value: function getParams(isInitial) {
            var params = _get(PersonalEarningsRuleState.prototype.__proto__ || Object.getPrototypeOf(PersonalEarningsRuleState.prototype), 'getParams', this).call(this, isInitial);
            params[this.ttUsersKey] = {};
            this.fillUsersSelectorParams(params[this.ttUsersKey], this.rule.ttUsersSelector);
            params[this.moneyKey] = {};
            this.fillMoneyConditionParams(params[this.moneyKey], this.rule.moneyCondition);
            return params;
        }
    }, {
        key: 'initState',
        value: function initState(params) {
            this.setUsersSelectorParams(params, 'tt_users', this.ttUsersKey, this.rule.ttUsersSelector);
            this.setMoneyConditionParams(params, this.moneyKey, this.moneyKey);
            var amount = this.savedState[this.moneyKey].amount;
            if (amount && !isNaN(amount)) this.rule.moneyCondition.amountInput.init(amount);

            RuleState.prototype.initState.call(this, params);
        }
    }]);

    return PersonalEarningsRuleState;
}(RuleState);

/***/ }),
/* 1556 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _TaskStore = __webpack_require__(91);

var _TaskStore2 = _interopRequireDefault(_TaskStore);

var _ProjectStore = __webpack_require__(59);

var _ProjectStore2 = _interopRequireDefault(_ProjectStore);

var _CustomerStore = __webpack_require__(65);

var _CustomerStore2 = _interopRequireDefault(_CustomerStore);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _date_format = __webpack_require__(16);

var _utils = __webpack_require__(6);

var _redux = __webpack_require__(7);

var _selectors = __webpack_require__(57);

var _utils2 = __webpack_require__(25);

var _selectors2 = __webpack_require__(14);

var _CommentsNumberContainer = __webpack_require__(251);

var _CommentsNumberContainer2 = _interopRequireDefault(_CommentsNumberContainer);

var _selectors3 = __webpack_require__(97);

var _constants = __webpack_require__(4);

var _CreateTasksPopupController = __webpack_require__(505);

var _CreateTasksPopupController2 = _interopRequireDefault(_CreateTasksPopupController);

var _actions = __webpack_require__(81);

var _TimeTrackPageFeatureDiffController = __webpack_require__(529);

var _TimeTrackPageFeatureDiffController2 = _interopRequireDefault(_TimeTrackPageFeatureDiffController);

var _View2 = __webpack_require__(20);

var _View3 = _interopRequireDefault(_View2);

var _EditTaskPanelContainer = __webpack_require__(377);

var _EditTaskPanelContainer2 = _interopRequireDefault(_EditTaskPanelContainer);

var _ChangeTaskStatusButton = __webpack_require__(1557);

var _ChangeTaskStatusButton2 = _interopRequireDefault(_ChangeTaskStatusButton);

var _utils3 = __webpack_require__(1558);

var _constants2 = __webpack_require__(23);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var dateFormat = new _date_format.DateFormat(window.SystemSettings.dateFormat);

var Mediator = function (_View) {
    _inherits(Mediator, _View);

    function Mediator(_ref) {
        var data = _ref.data,
            _ref$deleteTaskCallba = _ref.deleteTaskCallback,
            deleteTaskCallback = _ref$deleteTaskCallba === undefined ? function () {} : _ref$deleteTaskCallba,
            _ref$editTaskWithRelo = _ref.editTaskWithReloadCallback,
            editTaskWithReloadCallback = _ref$editTaskWithRelo === undefined ? function () {} : _ref$editTaskWithRelo,
            _ref$reopenTaskCallba = _ref.reopenTaskCallback,
            reopenTaskCallback = _ref$reopenTaskCallba === undefined ? function (taskId, statusId, statusName, isTaskInArchivedProject) {} : _ref$reopenTaskCallba,
            _ref$openTaskPanel = _ref.openTaskPanel,
            openTaskPanel = _ref$openTaskPanel === undefined ? function (taskId) {} : _ref$openTaskPanel;

        _classCallCheck(this, Mediator);

        var _this = _possibleConstructorReturn(this, (Mediator.__proto__ || Object.getPrototypeOf(Mediator)).call(this));

        _this._handleOpenTaskIdChange = function (taskId) {
            var $actualTTRows = (0, _jquery2.default)("#actualTTRows");
            $actualTTRows.find(".taskRow.editing").removeClass("editing");
            if (taskId) {
                $actualTTRows.find("#taskRow" + taskId).addClass("editing");
            }
        };

        _this.data = data;
        _this.params = {
            deleteTaskCallback: deleteTaskCallback,
            editTaskWithReloadCallback: editTaskWithReloadCallback,
            reopenTaskCallback: reopenTaskCallback
        };

        _this.actions = {
            openTaskPanel: openTaskPanel
        };

        _this.state = {
            workflowStatuses: {},
            openTaskId: null
        };

        _this.onStatePropertyChanged('openTaskId', _this._handleOpenTaskIdChange);
        return _this;
    }

    _createClass(Mediator, [{
        key: "init",
        value: function init() {
            var _this2 = this;

            _get(Mediator.prototype.__proto__ || Object.getPrototypeOf(Mediator.prototype), "init", this).call(this);
            new _TimeTrackPageFeatureDiffController2.default().init();

            this.$pageEl = (0, _jquery2.default)('#container');

            new _EditTaskPanelContainer2.default({
                onTaskDeletedCb: function onTaskDeletedCb(taskId) {
                    return _this2.params.deleteTaskCallback(taskId);
                },
                onTaskMovedCb: function onTaskMovedCb(taskId) {
                    return _this2.updateTaskRow(taskId);
                }
            }).init();

            this.workflowStatusIconsMap = {};
            this.commentsCountersMap = {};

            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                var _loop = function _loop() {
                    var task = _step.value;

                    var id = task.id;
                    var $taskRow = (0, _jquery2.default)('#taskRow' + id);
                    var $idInput = (0, _jquery2.default)((0, _utils3.getTaskStatusIdElement)(id));
                    var $workStatusIcon = $taskRow.find(".workStatusIconContainer");
                    _this2.workflowStatusIconsMap[id] = new _ChangeTaskStatusButton2.default({
                        taskId: id,
                        curStatusId: (0, _selectors.selectStatusIdByTask)(task),
                        onStatusChangedCb: function onStatusChangedCb(statusId) {
                            _this2._changeStatusOfTask(id, (0, _selectors.selectStatusIdByTask)(task), statusId);
                            _this2._handleStatusChange(id, (0, _selectors.selectStatusIdByTask)(task), statusId);
                        }
                    }).init($workStatusIcon);

                    _this2._changeStatusOfTask(id, (0, _selectors.selectStatusIdByTask)(task), Number($idInput.val()));
                    _this2.workflowStatusIconsMap[id].setState({
                        canBeReopened: task.canBeReopened,
                        editable: !task.notAssigned
                    });

                    _this2.commentsCountersMap[id] = new _CommentsNumberContainer2.default().init($taskRow.find('.commentsNumberPlaceholder'));
                    _this2.commentsCountersMap[id].setState({
                        commentsNumber: task.commentsNumber
                    });
                };

                for (var _iterator = SubmitTTData.tasks.getValues()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    _loop();
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            this.createTasksPopupController = new _CreateTasksPopupController2.default({
                successTaskCreationCb: function successTaskCreationCb(result) {
                    return _this2._successTaskCreationCallback(result);
                },
                serviceName: "AddNewTasksService"
            });

            (0, _jquery2.default)('#addTaskButtonId').click(function () {
                return _this2.createTasksPopupController.showPopup(null, null, _this2.data.selectedUserId, false, { taskCreationDate: _this2.data.submitTtDate });
            });

            this.subscribeToEvents();
            return this;
        }
    }, {
        key: "subscribeToEvents",
        value: function subscribeToEvents() {
            var _this3 = this;

            var self = this;

            (0, _jquery2.default)(".clickableTask").click(function (event) {
                (0, _utils2.setEventPreventHidingEditTaskSlidingPanel)(event);
                var taskId = (0, _jquery2.default)(this).data("taskid");
                self.actions.openTaskPanel(taskId);
            });

            (0, _jquery2.default)(document).on('editTaskPanel_updateTask', function (e, _ref2) {
                var taskId = _ref2.taskId,
                    prevTaskState = _ref2.prevTaskState;

                _this3._onTaskChanged(taskId, prevTaskState);
            });
        }
    }, {
        key: "_onTaskChanged",
        value: function _onTaskChanged(taskId, prevTaskState) {
            var task = _TaskStore2.default.get(taskId);
            if (!task || !prevTaskState || task.id !== prevTaskState.id) return;
            var currWorkflowStatus = this.state.workflowStatuses[(0, _selectors.selectStatusIdByTask)(task)];
            var prevWorkflowStatus = this.state.workflowStatuses[(0, _selectors.selectStatusIdByTask)(prevTaskState)];

            if (!!prevWorkflowStatus && currWorkflowStatus.id !== prevWorkflowStatus.id) {
                this._changeStatusOfTask(taskId, currWorkflowStatus.id, currWorkflowStatus.id);
                this._handleStatusChange(taskId, currWorkflowStatus.id, currWorkflowStatus.id);
            }
            if (!!prevWorkflowStatus && currWorkflowStatus.type !== prevWorkflowStatus.type) {
                this.params.editTaskWithReloadCallback(taskId);
            }
            this.updateTaskRow(taskId);
        }
    }, {
        key: "updateTaskRow",
        value: function updateTaskRow(taskId) {
            var $taskRow = (0, _jquery2.default)('#taskRow' + taskId);
            var task = _TaskStore2.default.get(taskId);

            if (!task) return;
            $taskRow.find('.taskNameColumn  .task').text(task['name']);
            $taskRow.find('.taskNameColumn .customer').text(_CustomerStore2.default.get(task.customerId)['name']);
            $taskRow.find('.taskNameColumn .project').text(_ProjectStore2.default.get(task.projectId)['name']);

            var $newDeadlineSpan = (0, _jquery2.default)("<span/>");
            $newDeadlineSpan.text(task.deadline ? dateFormat.formatDate(task.deadline) : _messageResource2.default.getMessage('common.not_available'));
            if (task.deadline) {
                $newDeadlineSpan.addClass(currentUserTime().clearTime().getTime() > task.deadline.getTime() ? "deadline_in_the_past" : "deadline");
            } else {
                $newDeadlineSpan.addClass("deadline_NA");
            }
            var $deadlineCell = $taskRow.find('.deadlineCell');
            $deadlineCell.empty();
            $deadlineCell.append($newDeadlineSpan);

            this._updateCommentsNumber(taskId, task.commentsNumber);
        }
    }, {
        key: "_updateCommentsNumber",
        value: function _updateCommentsNumber(taskId, commentsNumber) {
            this.commentsCountersMap[taskId].setState({
                commentsNumber: commentsNumber
            });
        }
    }, {
        key: "_successTaskCreationCallback",
        value: function _successTaskCreationCallback(result) {
            var createdTaskIds = result.createdTaskIdsList.list;
            var cannotAddTasksForOtherUserDisabledOrDeletedError = result.cannotAddTasksForOtherUserDisabledOrDeletedError;

            if (_typeof(window.disableWarningOnUnloadPage) !== ( true ? "undefined" : _typeof(undefined))) window.disableWarningOnUnloadPage();

            if (cannotAddTasksForOtherUserDisabledOrDeletedError) {
                document.location.href = '<html:rewrite page="/user/submit_tt.do"/>';
            } else {
                if (!createdTaskIds) createdTaskIds = [];

                document.SubmitTTForm.pageAction.value = _constants.SubmitTTFormConstants.HIGHLIGHT_TASKS_ACTION;
                document.SubmitTTForm.addTaskList.value = createdTaskIds.join(",");
                document.SubmitTTForm.submit();
            }
        }
    }, {
        key: "_changeStatusOfTask",
        value: function _changeStatusOfTask(taskId, curStatusId, newStatusId) {
            var curStatus = this.state.workflowStatuses[curStatusId];
            var newStatus = this.state.workflowStatuses[newStatusId];
            this.workflowStatusIconsMap[taskId].setState({
                newStatus: newStatus,
                curStatus: curStatus
            });

            (0, _jquery2.default)((0, _utils3.getTaskStatusIdElement)(taskId)).val(newStatusId);
            (0, _jquery2.default)((0, _utils3.getTaskStatusNameElement)(taskId)).val(newStatus.name);
            (0, _jquery2.default)((0, _utils3.getTaskStatusModifiedElement)(taskId)).val(curStatusId !== newStatusId);

            if (curStatus.type === _constants2.WorkflowStatusType.COMPLETED && newStatus.type === _constants2.WorkflowStatusType.OPEN) {
                this._reopenTask(taskId, newStatus.id, newStatus.name);
            } else {
                this._updateCompletedStateOfTask(taskId, curStatus.type, newStatus.type);
            }
        }
    }, {
        key: "_handleStatusChange",
        value: function _handleStatusChange(taskId, curStatusId, newStatusId) {
            if (curStatusId !== newStatusId) {
                window.SubmitTTChanges.registerChange("statusChanged_" + taskId);
                window.submitTTManager.handleChange(true, false);
            } else {
                window.SubmitTTChanges.unregisterChange("statusChanged_" + taskId);
            }
        }
    }, {
        key: "_updateCompletedStateOfTask",
        value: function _updateCompletedStateOfTask(taskId, curStatusType, newStatusType) {
            var $taskRow = (0, _jquery2.default)('#taskRow' + taskId);
            $taskRow.toggleClass('markedCompleted', curStatusType === _constants2.WorkflowStatusType.OPEN && newStatusType === _constants2.WorkflowStatusType.COMPLETED);
        }
    }, {
        key: "_reopenTask",
        value: function _reopenTask(taskId, newStatusId, newStatusName) {
            var task = SubmitTTData.getTaskById(taskId);
            var taskInArchivedProject = !!task && task.inArchivedProject;

            this.params.reopenTaskCallback(taskId, newStatusId, newStatusName, taskInArchivedProject);
        }
    }]);

    return Mediator;
}(_View3.default);

exports.default = (0, _utils.connect)(function (state) {
    return {
        workflowStatuses: (0, _selectors2.getWorkflowStatuses)(state),
        openTaskId: (0, _selectors3.getOpenTaskId)(state)
    };
}, function (dispatch) {
    return {
        openTaskPanel: (0, _redux.bindActionCreators)(_actions.openEditTaskPanel, dispatch)
    };
})(Mediator);

/***/ }),
/* 1557 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _TaskStatusButton = __webpack_require__(240);

var _TaskStatusButton2 = _interopRequireDefault(_TaskStatusButton);

var _TaskStatusMenu = __webpack_require__(289);

var _TaskStatusMenu2 = _interopRequireDefault(_TaskStatusMenu);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _constants = __webpack_require__(23);

var _SimpleSingletonTooltip = __webpack_require__(45);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ChangeTaskStatusButton = function (_TemplateView) {
    _inherits(ChangeTaskStatusButton, _TemplateView);

    function ChangeTaskStatusButton(_ref) {
        var taskId = _ref.taskId,
            curStatusId = _ref.curStatusId,
            _ref$onStatusChangedC = _ref.onStatusChangedCb,
            onStatusChangedCb = _ref$onStatusChangedC === undefined ? function (id) {} : _ref$onStatusChangedC;

        _classCallCheck(this, ChangeTaskStatusButton);

        var _this = _possibleConstructorReturn(this, (ChangeTaskStatusButton.__proto__ || Object.getPrototypeOf(ChangeTaskStatusButton)).call(this));

        _this.taskId = taskId;

        _this.callbacks = {
            onStatusChangedCb: onStatusChangedCb
        };

        _this.state = {
            newStatus: {
                id: -1,
                name: '',
                type: _constants.WorkflowStatusType.COMPLETED
            },
            curStatus: {
                id: -1,
                name: '',
                type: _constants.WorkflowStatusType.COMPLETED
            },
            canBeReopened: false,
            editable: true
        };

        _this.onAnyStatePropertyDeeplyChanged(['newStatus', 'curStatus'], function (_ref2) {
            var newStatus = _ref2.newStatus,
                curStatus = _ref2.curStatus;

            _this.button.setState({
                statusId: newStatus.id
            });
            _this.taskStatusMenu.setState({
                showCompletedFirst: curStatus.type === _constants.WorkflowStatusType.COMPLETED,
                showReopenLabel: curStatus.type === _constants.WorkflowStatusType.COMPLETED
            });
            _this.$buttonContainer.toggleClass('modified', curStatus.id !== newStatus.id);
            _this.$buttonContainer.toggleClass('completed', newStatus.type === _constants.WorkflowStatusType.COMPLETED);
        });

        _this.onStatePropertyChanged('canBeReopened', function (canBeReopened) {
            _this.button.setState({
                canReopenProject: canBeReopened
            });
        });

        _this.onStatePropertyChanged('editable', function (editable) {
            _this.button.setEditable(editable);
        });
        return _this;
    }

    _createClass(ChangeTaskStatusButton, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class="changeTaskStatusButton">' + '  <div class="buttonPlaceholder"></div>' + '</div>';
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            var _this2 = this;

            this.$buttonContainer = this.find(".buttonPlaceholder");
            this.taskStatusMenu = new _TaskStatusMenu2.default(null, {
                showActionNames: true
            }).init(this.$el);
            this.button = new _TaskStatusButton2.default({
                hideName: true,
                taskStatusMenu: this.taskStatusMenu,
                onStatusChangedCb: this.callbacks.onStatusChangedCb,
                onShowMenu: function onShowMenu() {
                    _this2.$buttonContainer.addClass("pressed");
                },
                onHideMenu: function onHideMenu() {
                    _this2.$buttonContainer.removeClass("pressed");
                }
            }).init(this.$buttonContainer);

            (0, _SimpleSingletonTooltip.getInstance)().subscribeToMouseEvents(this.$buttonContainer, function () {
                (0, _SimpleSingletonTooltip.getInstance)().setState({
                    html: _this2._getStatusTooltipHtml(_this2.state.newStatus.name),
                    extraClass: "change_status_button_tooltip"
                });
            });
        }
    }, {
        key: '_getStatusTooltipHtml',
        value: function _getStatusTooltipHtml(statusName) {
            var html = '<div class="statusName">' + _messageResource2.default.getMessageWithEscapedArgs('change_status_button.tooltip.status', [statusName]) + '</div>';
            if (this.state.curStatus.id !== this.state.newStatus.id) html += '<div class="prevStatus">' + _messageResource2.default.getMessageWithEscapedArgs('change_status_button.changed_from', [this.state.curStatus.name]) + '</div>';

            return html;
        }
    }]);

    return ChangeTaskStatusButton;
}(_TemplateView3.default);

exports.default = ChangeTaskStatusButton;

/***/ }),
/* 1558 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var getTaskStatusIdElement = exports.getTaskStatusIdElement = function getTaskStatusIdElement(taskId) {
    return document.SubmitTTForm.elements["taskStatuses[" + taskId + "].id"];
};

var getTaskStatusNameElement = exports.getTaskStatusNameElement = function getTaskStatusNameElement(taskId) {
    return document.SubmitTTForm.elements["taskStatuses[" + taskId + "].name"];
};

var getTaskStatusModifiedElement = exports.getTaskStatusModifiedElement = function getTaskStatusModifiedElement(taskId) {
    return document.SubmitTTForm.elements["taskStatuses[" + taskId + "].modified"];
};

/***/ }),
/* 1559 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _EntityWithNameStore = __webpack_require__(278);

var _EntityWithNameStore2 = _interopRequireDefault(_EntityWithNameStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var userGroupStore = new _EntityWithNameStore2.default();
exports.default = userGroupStore;

/***/ }),
/* 1560 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _EntityWithNameStore = __webpack_require__(278);

var _EntityWithNameStore2 = _interopRequireDefault(_EntityWithNameStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var timeZoneGroupStore = new _EntityWithNameStore2.default();
exports.default = timeZoneGroupStore;

/***/ }),
/* 1561 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Ext = __webpack_require__(12);

var _Ext2 = _interopRequireDefault(_Ext);

var _at_group_selector_switcher = __webpack_require__(373);

var _at_group_selector_switcher2 = _interopRequireDefault(_at_group_selector_switcher);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ExtendedGroupSelectorSwitcher = _Ext2.default.extend(_at_group_selector_switcher2.default, {

    init: function init(userGroupsEnabled, timeZoneGroupsEnabled, groupByUserCallback, groupByUserGroupCallback, groupByTimeZoneGroupCallback) {
        this.groupByUserCallback = groupByUserCallback;
        ExtendedGroupSelectorSwitcher.superclass.init.call(this, userGroupsEnabled, timeZoneGroupsEnabled, groupByUserGroupCallback, groupByTimeZoneGroupCallback);
    },

    addComponents: function addComponents() {
        if (this.userGroupsEnabled && this.timeZoneGroupsEnabled) {
            this.addSortByUserLink();
            this.addSeparator("nearByUsers");
            this.addSortByUserGroupLink();
            this.addSeparator("betweenGroups");
            this.addSortByTimeZoneGroupLink();
        } else if (this.userGroupsEnabled) {
            this.addSortByUserLink();
            this.addSortByUserGroupLink();
        } else if (this.timeZoneGroupsEnabled) {
            this.addSortByUserLink();
            this.addSortByTimeZoneGroupLink();
        } else {
            this.addTextPanel(_messageResource2.default.getMessage("user_selector.group_by.by_users") + ":");
        }
    },

    addSortByUserLink: function addSortByUserLink() {
        this.addSortByLink(_messageResource2.default.getMessage("user_selector.group_by.by_users"), "userLabel", this.groupByUserCallback);
    },

    addSeparator: function addSeparator(additionalClass) {
        this.add(new _Ext2.default.BoxComponent({
            autoEl: {
                tag: 'div',
                cls: 'vertical-separator ' + additionalClass
            }
        }));
    },

    updateUI: function updateUI(groupType) {
        this.removeClass('groupedByUsers');
        if (!groupType) {
            this.addClass('groupedByUsers');
        }
        ExtendedGroupSelectorSwitcher.superclass.updateUI.apply(this, arguments);
    },

    getSortByTimeZoneGroupLinkText: function getSortByTimeZoneGroupLinkText() {
        if (!this.userGroupsEnabled) return _messageResource2.default.getEscapedMessage("user_selector.group_by.by_time_zone_groups");

        return ExtendedGroupSelectorSwitcher.superclass.getSortByTimeZoneGroupLinkText.call(this);
    }

});

_Ext2.default.reg("at_extended_group_selector_switcher", ExtendedGroupSelectorSwitcher);

exports.default = ExtendedGroupSelectorSwitcher;

/***/ }),
/* 1562 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Ext = __webpack_require__(12);

var _Ext2 = _interopRequireDefault(_Ext);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _at_gradient_button = __webpack_require__(285);

var _at_gradient_button2 = _interopRequireDefault(_at_gradient_button);

var _at_groups_selector_panel = __webpack_require__(537);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ExtendedGroupsSelectorPanel = _Ext2.default.extend(_at_groups_selector_panel.SmartGroupsSelectorPanel, {

    cls: "selector-panel userGroupsSelector extended",

    cancelButtonLabelKey: "user_groups_selector.cancel_button.label",

    initComponent: function initComponent() {
        ExtendedGroupsSelectorPanel.superclass.initComponent.call(this);
        this.optionValueInit = this.optionValue;

        if (this.customOnChangeHandler) this.on("change", this.customOnChangeHandler, this);
    },

    createFooterButtons: function createFooterButtons() {
        ExtendedGroupsSelectorPanel.superclass.createFooterButtons.call(this);

        this.cancelButton = new _at_gradient_button2.default({
            text: _messageResource2.default.getMessage(this.cancelButtonLabelKey),
            minWidth: 60,
            cls: "greyButton close-button cancel-button"
        });
    },

    onCancelButtonClick: function onCancelButtonClick() {
        this.resetState(true);
        this.fireEvent("close");
    },

    getFooterSection: function getFooterSection() {
        var res = ExtendedGroupsSelectorPanel.superclass.getFooterSection.call(this);
        return [this.cancelButton].concat(res);
    },

    getSelectedGroupIds: function getSelectedGroupIds(getValuesGroupsIfAll) {
        if (this.currentOption.inputValue == this.allItemsOptionValue && !getValuesGroupsIfAll) return null;

        var result = [];
        var selection = this.getSelection();
        for (var i = 0; i < selection.length; i++) {
            var groupDataBean = selection[i];
            result.push(groupDataBean.id);
        }

        return result;
    },

    getSelectedGroupIdsSet: function getSelectedGroupIdsSet(getValuesGroupsIfAll) {
        var groupIdSet = {};
        var groupIdsArray = this.getSelectedGroupIds(getValuesGroupsIfAll);

        if (groupIdsArray == null) return groupIdSet;

        for (var i = 0; i < groupIdsArray.length; i++) {
            groupIdSet[groupIdsArray[i]] = true;
        }

        return groupIdSet;
    },

    updateState: function updateState() {
        this.selectOption(this.optionValue);
    },

    setAllIfNoneSelected: function setAllIfNoneSelected() {
        if (this.getSelectedGroupIds() && this.getSelectedGroupIds().length == 0 && this.currentOption.inputValue == this.customOptionValue) this.selectOption(this.allItemsOptionValue);
    }
});

exports.default = ExtendedGroupsSelectorPanel;

/***/ }),
/* 1563 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Ext = __webpack_require__(12);

var _Ext2 = _interopRequireDefault(_Ext);

var _at_date_picker = __webpack_require__(389);

var _at_date_picker2 = _interopRequireDefault(_at_date_picker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_Ext2.default.namespace('AT.menu');

// TODO delete?
var WeekPickerItem = _Ext2.default.extend(_Ext2.default.menu.DateItem, {
    constructor: function constructor(config) {
        WeekPickerItem.superclass.constructor.call(this, new _at_date_picker2.default(config), config);

        this.picker = this.component;
        this.addEvents('select');

        this.picker.on("render", function (picker) {
            picker.getEl().swallowEvent("click");
            picker.container.addClass("x-menu-date-item");
        });

        this.picker.on("select", this.onSelect, this);
    }
});

_Ext2.default.extend(WeekPickerItem, _Ext2.default.menu.Adapter, {
    // private
    onSelect: function onSelect(picker, date) {
        this.fireEvent("select", this, date, picker);
        WeekPickerItem.superclass.handleClick.call(this);
    }
});

exports.default = WeekPickerItem;

/***/ }),
/* 1564 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CircleSpinner = function (_TemplateView) {
    _inherits(CircleSpinner, _TemplateView);

    function CircleSpinner() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            _ref$additionalClassC = _ref.additionalClassCircle,
            additionalClassCircle = _ref$additionalClassC === undefined ? '' : _ref$additionalClassC,
            _ref$additionalClassC2 = _ref.additionalClassContainer,
            additionalClassContainer = _ref$additionalClassC2 === undefined ? '' : _ref$additionalClassC2,
            _ref$label = _ref.label,
            label = _ref$label === undefined ? '' : _ref$label;

        _classCallCheck(this, CircleSpinner);

        var _this = _possibleConstructorReturn(this, (CircleSpinner.__proto__ || Object.getPrototypeOf(CircleSpinner)).call(this));

        _this.params = {
            additionalClassCircle: additionalClassCircle,
            additionalClassContainer: additionalClassContainer,
            label: label
        };
        return _this;
    }

    _createClass(CircleSpinner, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class="circleSpinner">' + '    <div class="circlesProgressContainer <%=additionalClassContainer%>">' + '        <div class="loadProgressAnimateCircle1 <%=additionalClassCircle%>">' + '            <div class="loadProgressAnimateCircle2">' + '                <div class="loadProgressAnimateCircle3">' + '                    <div class="loadProgressAnimateCircle4"/>' + '                </div>' + '            </div>' + '        </div>' + '    </div>' + '    <div class="label"><%=label%></div>' + '</div>';
        }
    }, {
        key: 'templateModel',
        value: function templateModel() {
            return {
                additionalClassCircle: this.params.additionalClassCircle,
                additionalClassContainer: this.params.additionalClassContainer,
                label: this.params.label
            };
        }
    }]);

    return CircleSpinner;
}(_TemplateView3.default);

exports.default = CircleSpinner;

/***/ }),
/* 1565 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _jquery_rpc = __webpack_require__(26);

var _jquery_rpc2 = _interopRequireDefault(_jquery_rpc);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _TaskStore = __webpack_require__(91);

var _TaskStore2 = _interopRequireDefault(_TaskStore);

var _date_format = __webpack_require__(16);

var _ViewTTStore = __webpack_require__(73);

var _ViewTTStore2 = _interopRequireDefault(_ViewTTStore);

var _selectors = __webpack_require__(57);

var _utils = __webpack_require__(6);

var _redux = __webpack_require__(7);

var _PDFGenerator = __webpack_require__(1566);

var _PDFGenerator2 = _interopRequireDefault(_PDFGenerator);

var _utils2 = __webpack_require__(25);

var _selectors2 = __webpack_require__(14);

var _selectors3 = __webpack_require__(97);

var _DetailsTable = __webpack_require__(1572);

var _DetailsTable2 = _interopRequireDefault(_DetailsTable);

var _actions = __webpack_require__(81);

var _TimeTrackPageFeatureDiffController = __webpack_require__(529);

var _TimeTrackPageFeatureDiffController2 = _interopRequireDefault(_TimeTrackPageFeatureDiffController);

var _View2 = __webpack_require__(20);

var _View3 = _interopRequireDefault(_View2);

var _utils3 = __webpack_require__(164);

var _EditTaskPanelContainer = __webpack_require__(377);

var _EditTaskPanelContainer2 = _interopRequireDefault(_EditTaskPanelContainer);

var _FilterController = __webpack_require__(1586);

var _FilterController2 = _interopRequireDefault(_FilterController);

var _actions2 = __webpack_require__(56);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ViewTTMediator = function (_View) {
    _inherits(ViewTTMediator, _View);

    function ViewTTMediator(_ref) {
        var _ref$openTaskPanel = _ref.openTaskPanel,
            openTaskPanel = _ref$openTaskPanel === undefined ? function (taskId) {} : _ref$openTaskPanel,
            _ref$toast = _ref.toast,
            toast = _ref$toast === undefined ? function () {} : _ref$toast;

        _classCallCheck(this, ViewTTMediator);

        var _this = _possibleConstructorReturn(this, (ViewTTMediator.__proto__ || Object.getPrototypeOf(ViewTTMediator)).call(this));

        _this.actions = {
            openTaskPanel: openTaskPanel,
            toast: toast
        };

        _this.state = {
            workflowStatuses: {},
            openTaskId: null
        };

        _this.onStatePropertyChanged('openTaskId', function (openTaskId) {
            if (_this.detailsTable) {
                _this.detailsTable.setState({ selectedTaskId: openTaskId });
            }
        });
        return _this;
    }

    _createClass(ViewTTMediator, [{
        key: "init",
        value: function init(config) {
            _get(ViewTTMediator.prototype.__proto__ || Object.getPrototypeOf(ViewTTMediator.prototype), "init", this).call(this);
            new _TimeTrackPageFeatureDiffController2.default().init();

            this._subscribeForPageEvents();
            this._setInitialSettings(config);

            this._balanceRpc = undefined;
            this._dataRpc = undefined;
            this._dataAndBalanceRpc = undefined;

            this._componentesInitialized = false;

            this.$pageWrapper = (0, _jquery2.default)(".pageWrapper");
            this.page = new ViewTTPage(this.$pageWrapper).init();

            this._initUsersSelector();

            if (!_underscore2.default.isNull(config["data"])) {
                this._prepareAndSetServerData(config["data"]);
                this._initViewTTPageComponents();
                if (_ViewTTStore2.default.getBalancesViewerConfig().displayPto || _ViewTTStore2.default.getBalancesViewerConfig().displaySick) {
                    this._loadBalances();
                }
            } else if (_underscore2.default.isEmpty(config["users"])) {
                new ViewTTPage.NoUsersWarning((0, _jquery2.default)("#viewTTUsersSelectorWarning")).init();
            } else if (_ViewTTStore2.default.getSelectedUserId() == -1) {
                new ViewTTPage.UserIsNotSelectedWarning((0, _jquery2.default)("#viewTTUsersSelectorWarning")).init();
            }
            (0, _jquery2.default)(document).trigger("viewTT.init");

            return this;
        }
    }, {
        key: "_initViewTTPageComponents",
        value: function _initViewTTPageComponents() {
            var _this2 = this;

            // need to be careful in event subscription order, we don`t need to reload data here
            // we just fill dateRange config with not null values for dateFrom and dateTo
            _ViewTTStore2.default.setDateRangeConfig(new _FilterController2.default().init().getDateRange());
            _ViewTTStore2.default.backupDataConfig();

            new ViewTTPage.Totals((0, _jquery2.default)("#viewTTTotals")).init();

            new ViewTTPage.PrintableHeader((0, _jquery2.default)("#viewTTPrintHeaderContainer")).init();

            this.detailsTable = new _DetailsTable2.default().init((0, _jquery2.default)("#viewTTDetailsTableContainer"));

            this.chartController = new ViewTTPage.ChartController().init();

            if (!isOldIE()) // IE8 and IE9 don't support pdf preview and pdf generate
                {
                    this.pdfGenerator = new _PDFGenerator2.default().init();
                    //TODO need to remove init parameters (take it from viewttstore into component)
                    this.pdfPreviewLightbox = new ViewTTPage.PDFPreviewLightbox().init({
                        popupId: "viewTTPdfPreviewLightbox",
                        closeBtnId: "closeViewTTPdfPreviewLightboxButton"
                    });
                }

            this.balancesViewerController = new ViewTTPage.BalancesViewerController((0, _jquery2.default)("#balancesViewerPlaceholder")).init();
            _ViewTTStore2.default.setBalancesViewerDate(this.balancesViewerController.getViewerDate());

            new _EditTaskPanelContainer2.default({
                onTaskDeletedCb: function onTaskDeletedCb() {
                    return _this2.loadData();
                }
            }).init();

            this.page.showPageComponents();

            this._componentesInitialized = true;
        }
    }, {
        key: "_initUsersSelector",
        value: function _initUsersSelector() {
            if (_ViewTTStore2.default.isNeedToRenderUsersSelector()) {
                var usersSelector = new ViewTTPage.UsersSelector();
                usersSelector.init(_ViewTTStore2.default.getUsers(), _ViewTTStore2.default.getGroups(), _ViewTTStore2.default.getSelectedUserId());
            }
        }
    }, {
        key: "_loadBalances",
        value: function _loadBalances() {
            var balancesViewerDate = this.balancesViewerController.getViewerDate();
            var selectedUserId = _ViewTTStore2.default.getSelectedUserId();
            this.balancesViewerController.spin();
            this._abortRpcCall(this._balanceRpc);
            var self = this;
            this._balanceRpc = (0, _jquery_rpc2.default)("BalancesViewerService.getBalancesForDate", [selectedUserId, balancesViewerDate], function (data) {
                _ViewTTStore2.default.setBalancesViewerDate(balancesViewerDate);
                _ViewTTStore2.default.setBalancesData(data);
            }, function (jqXHR, textStatus) {
                // we update date even if rpc was aborted,
                self.balancesViewerController.setDate(_ViewTTStore2.default.getBalancesViewerDate());

                if (textStatus == "abort") {
                    return true;
                }

                // update balances to remove spinner
                // on abort update will be made in _restoreBalancesForSelectedUserIfNeeded or in next _balanceRpc
                _ViewTTStore2.default.setBalancesData(_ViewTTStore2.default.getBalancesData());
            });
        }
    }, {
        key: "_loadViewTTDataAndBalances",
        value: function _loadViewTTDataAndBalances() {
            (0, _jquery2.default)(document).trigger("viewTT.beginLoadData");
            var dataRangeConfig = _ViewTTStore2.default.getDateRangeConfig();
            var userId = _ViewTTStore2.default.getSelectedUserId();
            var dateRangeQualifier = dataRangeConfig.qualifier;
            var fromDate = dataRangeConfig.fromDate;
            var toDate = dataRangeConfig.toDate;

            var filter = _ViewTTStore2.default.getFilter();
            var cpSelection = filter.cpSelection;
            var selectionQualifier = cpSelection.qualifier;
            var customers = cpSelection.customers;
            var projects = cpSelection.projects;
            var showArchivedProjects = cpSelection.showArchivedProjects;

            var balancesViewerDate = null;
            if (this._componentesInitialized) {
                balancesViewerDate = this.balancesViewerController.getViewerDate();
                if (ViewTTPageUtils.isFeatureEnabled(Features["PTO"]) || ViewTTPageUtils.isFeatureEnabled(Features["SDB"])) {
                    this.balancesViewerController.spin();
                }
            }

            var self = this;
            this._abortRpcCall(this._dataRpc);
            this._abortRpcCall(this._balanceRpc);
            this._abortRpcCall(this._dataAndBalanceRpc);

            this._dataAndBalanceRpc = (0, _jquery_rpc2.default)("ViewTTFacadeService.getViewTTDataAndBalances", [userId, dateRangeQualifier, fromDate, toDate, selectionQualifier, customers, projects, !!showArchivedProjects, filter.weekApprovalStatuses, balancesViewerDate], function (viewTTDataAndBalances) {
                if (!self._validateLeaveTypeConsistency(viewTTDataAndBalances.viewTTData)) return;
                self._prepareAndSetServerData(viewTTDataAndBalances.viewTTData);
                var newBalanceViewerConfig = {
                    hireDate: viewTTDataAndBalances.userWorkScheduleData.hireDate,
                    releaseDate: viewTTDataAndBalances.userWorkScheduleData.releaseDate,
                    initialSchedule: viewTTDataAndBalances.userWorkScheduleData.initialSchedule,
                    schedules: viewTTDataAndBalances.userWorkScheduleData.schedules,
                    displayPto: viewTTDataAndBalances.userBalances.displayPto,
                    displaySick: viewTTDataAndBalances.userBalances.displaySick
                };
                _ViewTTStore2.default.setBalancesViewerConfig(newBalanceViewerConfig);
                if (!self._componentesInitialized) {
                    self._initViewTTPageComponents();
                }
                _ViewTTStore2.default.setBalancesData(viewTTDataAndBalances.userBalances);

                if (_underscore2.default.isNull(balancesViewerDate)) balancesViewerDate = currentUserTime().clearTime(); //today
                if (newBalanceViewerConfig.releaseDate) {
                    var releaseDate = Date.parseJSONDate(newBalanceViewerConfig.releaseDate);
                    if (balancesViewerDate > releaseDate) balancesViewerDate = releaseDate;
                }
                var hireDate = Date.parseJSONDate(newBalanceViewerConfig.hireDate);
                if (balancesViewerDate < hireDate) balancesViewerDate = hireDate;
                _ViewTTStore2.default.setBalancesViewerDate(balancesViewerDate);
                self.balancesViewerController.setDate(balancesViewerDate);

                (0, _jquery2.default)(document).trigger("viewTT.endLoadData");
            }, function (jqXHR, textStatus, errorThrown) {
                if (self._componentesInitialized) {
                    self.balancesViewerController.setDate(_ViewTTStore2.default.getBalancesViewerDate());
                }

                if (textStatus == "abort") {
                    return true;
                }

                if (textStatus == "rpc_customException") {
                    if (self._handleCustomException(errorThrown.exception)) return true;
                }

                _ViewTTStore2.default.restoreDataConfig();
                _ViewTTStore2.default.setBalancesData(_ViewTTStore2.default.getBalancesData());

                (0, _jquery2.default)(document).trigger("viewTT.endLoadData");

                return false;
            });
        }
    }, {
        key: "_needToShowBalances",
        value: function _needToShowBalances() {
            return _ViewTTStore2.default.getBalancesViewerConfig().displayPto || _ViewTTStore2.default.getBalancesViewerConfig().displaySick;
        }
    }, {
        key: "_restoreBalancesForSelectedUserIfNeeded",
        value: function _restoreBalancesForSelectedUserIfNeeded() {
            if (this._componentesInitialized && !_underscore2.default.isNull(_ViewTTStore2.default.getData())) {
                this._abortRpcCall(this._balanceRpc);

                // todo: check restore behaviour
                if (this._needToShowBalances()) {
                    _ViewTTStore2.default.setBalancesData(_ViewTTStore2.default.getBalancesData());
                } else {
                    this.balancesViewerController.hide();
                }
            }
        }

        /**
         * Subscribe for all page events that can change page state
         * @private
         */

    }, {
        key: "_subscribeForPageEvents",
        value: function _subscribeForPageEvents() {
            var _this3 = this;

            var self = this;

            if (!isOldIE()) // IE8 and IE9 don't support pdf preview and pdf generate
                {
                    (0, _jquery2.default)(document).on("viewTT.showPDFPreview", function () {
                        self.pdfPreviewLightbox.show();
                    });
                    (0, _jquery2.default)(document).on("viewTT.downloadPDF", function () {
                        self._saveDisplaySettings();
                        (0, _utils3.downloadPDF)(_ViewTTStore2.default.getGeneratedPDF(), _ViewTTStore2.default.getPDFFileName());
                    });
                    (0, _jquery2.default)(document).on("viewTT.pdfPreview.printParametersForSaveChange", function (event, printParametersForSave) {
                        _ViewTTStore2.default.setPrintParametersForSave(printParametersForSave);
                    });
                    (0, _jquery2.default)(document).on("viewTT.pdfPreview.printParametersForGenerateChange", function (event, printParametersForGenerate) {
                        _ViewTTStore2.default.setPrintParametersForGenerate(printParametersForGenerate);
                        self.cancelAllExportingProcesses();
                        self.generatePDF();
                    });
                    (0, _jquery2.default)(document).on("viewTT.pdfPreview.lightbox.hide", function () {
                        self.cancelAllExportingProcesses();
                    });
                }
            (0, _jquery2.default)(document).on("viewTT.detailsTable.configPanel.change", function (e, detailsTableConfig) {
                _ViewTTStore2.default.setDetailsTableConfig(detailsTableConfig);
                self._saveDisplaySettings();
            });
            (0, _jquery2.default)(document).on("viewTT.chartSection.change", function (e, chartSectionConfig) {
                _ViewTTStore2.default.setChartSectionConfig(chartSectionConfig);
                self._saveDisplaySettings();
            });

            (0, _jquery2.default)(document).on("viewTT.dateRangeChange", function (e, dateRangeConfig) {
                _ViewTTStore2.default.setDateRangeConfig(dateRangeConfig);
                self.loadData();
            });

            (0, _jquery2.default)(document).on("viewTT.filterChange", function (e, filter) {
                _ViewTTStore2.default.setFilter(filter);
                self.loadData();
            });

            (0, _jquery2.default)(document).on("viewTT.selectedUserChange", function (e, userId) {
                _ViewTTStore2.default.setSelectedUserId(userId);
                self._loadViewTTDataAndBalances();
            });

            (0, _jquery2.default)(_ViewTTStore2.default).on("dataConfigRestored", function () {
                self._restoreBalancesForSelectedUserIfNeeded();
            });

            (0, _jquery2.default)(document).on("viewTT.balancesViewerDateChange", function () {
                self._loadBalances();
            });

            (0, _jquery2.default)(document).on("viewTT.detailsTable.taskClick", function (e, clickEvent, taskId) {
                (0, _utils2.setEventPreventHidingEditTaskSlidingPanel)(clickEvent);
                self.actions.openTaskPanel(taskId);
            });

            (0, _jquery2.default)(document).on('editTaskPanel_updateTask', function (e, _ref2) {
                var taskId = _ref2.taskId,
                    prevTaskState = _ref2.prevTaskState;

                _this3._onTaskChanged(taskId, prevTaskState);
            });

            (0, _jquery2.default)(document).on('task_added_to_timesheet_event', function (_, hasError) {
                return hasError ? alert(_messageResource2.default.getMessage("api.error.unexpected_error")) : _this3.actions.toast(_messageResource2.default.getMessage("add_to_timesheet.tasks.toast"));
            });
        }
    }, {
        key: "loadData",
        value: function loadData() {
            (0, _jquery2.default)(document).trigger("viewTT.beginLoadData");
            var dataRangeConfig = _ViewTTStore2.default.getDateRangeConfig();
            var userId = _ViewTTStore2.default.getSelectedUserId();
            var dateRangeQualifier = dataRangeConfig.qualifier;
            var fromDate = dataRangeConfig.fromDate;
            var toDate = dataRangeConfig.toDate;

            var filter = _ViewTTStore2.default.getFilter();
            var cpSelection = filter.cpSelection;
            var selectionQualifier = cpSelection.qualifier;
            var customers = cpSelection.customers;
            var projects = cpSelection.projects;
            var showArchivedProjects = cpSelection.showArchivedProjects;

            var self = this;
            this._abortRpcCall(this._dataRpc);
            this._dataRpc = (0, _jquery_rpc2.default)("ViewTimeTrackService.getViewTTData", [userId, dateRangeQualifier, fromDate, toDate, selectionQualifier, customers, projects, !!showArchivedProjects, filter.weekApprovalStatuses], function (data) {
                if (!self._validateLeaveTypeConsistency(data)) return;
                self._prepareAndSetServerData(data);
                if (!self._componentesInitialized) {
                    self._initViewTTPageComponents();
                }
                (0, _jquery2.default)(document).trigger("viewTT.endLoadData");
            }, function (jqXHR, textStatus, errorThrown) {
                if (textStatus == "abort") {
                    return true;
                }

                if (textStatus == "rpc_customException") {
                    if (self._handleCustomException(errorThrown.exception)) return true;
                }

                _ViewTTStore2.default.restoreDataConfig();
                (0, _jquery2.default)(document).trigger("viewTT.endLoadData");

                return false;
            });
        }
    }, {
        key: "_showAlertAndReloadPage",
        value: function _showAlertAndReloadPage(msgKey) {
            alert(_messageResource2.default.getMessage(msgKey));
            window.location.reload();
            return true;
        }
    }, {
        key: "_handleCustomException",
        value: function _handleCustomException(exception) {
            if (exception == 'com.actimind.actitime.util.TTUserSelectorValidationProvider$NoRightsSubmitMyTTException') {
                return this._showAlertAndReloadPage("view_tt.reload_alert.no_rights.submit_my_tt");
            }

            if (exception == 'com.actimind.actitime.util.TTUserSelectorValidationProvider$NoRightsSubmitOtherUserTTException') {
                return this._showAlertAndReloadPage("view_tt.reload_alert.no_rights.submit_other_tt");
            }

            if (exception == 'com.actimind.actitime.util.TTUserSelectorValidationProvider$SelectedUserIsDisabledException') {
                return this._showAlertAndReloadPage("view_tt.reload_alert.selected_user.disabled");
            }

            if (exception == 'com.actimind.actitime.util.TTUserSelectorValidationProvider$SelectedUserIsDeletedException') {
                return this._showAlertAndReloadPage("view_tt.reload_alert.selected_user.deleted");
            }

            if (exception == 'com.actimind.actitime.util.TTUserSelectorValidationProvider$SelectedUserNotVisibleToManagerException') {
                return this._showAlertAndReloadPage("view_tt.reload_alert.selected_user.not_visible");
            }

            return false;
        }

        /*
         Set initial page settings to ViewTTStore
         */

    }, {
        key: "_setInitialSettings",
        value: function _setInitialSettings(config) {
            // used in _prepareAndSetServerData
            _ViewTTStore2.default.setAssignedCPList(config.assignedCPList);
            _ViewTTStore2.default.setAssignedCPMaps({
                customersById: arrayToMapById(config.assignedCPList.customers),
                projectsById: arrayToMapById(config.assignedCPList.projects)
            });
            _ViewTTStore2.default.setWeekStartDay(SystemSettings.weekStartDay - 1);
            _ViewTTStore2.default.setViewerId(config["viewerId"]);
            _ViewTTStore2.default.setUsersAndGroups(config["users"], config["groups"]);
            _ViewTTStore2.default.setNeedToRenderUsersSelector(config["needToRenderUsersSelector"]);
            _ViewTTStore2.default.setDateFormat(new _date_format.DateFormat("MMM dd, EEE"));
            var displaySetting = config["displaySettings"];
            _ViewTTStore2.default.setDetailsTableConfig({
                viewByDays: displaySetting["tableSortOptions"] == ViewTTTableSortOptions.BY_DAYS,
                asc: displaySetting["tableAsc"],
                showTasks: displaySetting["showTasks"]
            });
            _ViewTTStore2.default.setChartSectionConfig({
                chartType: displaySetting["chartType"],
                showChart: displaySetting["showChart"]
            });
            _ViewTTStore2.default.setPrintParametersForSave({
                paperSize: displaySetting["pdfPaperSize"],
                paperOrientation: displaySetting["pdfPaperOrientation"],
                showHeaderOnEachPage: displaySetting["pdfShowHeaderOnEachPage"],
                showLogoInHeader: displaySetting["pdfShowLogoInHeader"],
                showSignature: displaySetting["pdfShowSignature"],
                showSignatureOnEachPage: displaySetting["pdfShowSignatureOnEachPage"]
            });
            var pageSettings = config["pageSettings"];

            _ViewTTStore2.default.setSelectedUserId(pageSettings["selectedUserId"]);
            //TODO need to handle situation when TIME TRACK APPROVAL FEATURE OFF
            var weekApprovalStatuses = pageSettings["weekApprovalStatuses"];

            _ViewTTStore2.default.setFilter({
                weekApprovalStatuses: weekApprovalStatuses,
                cpSelection: pageSettings["customersProjectsSelection"]
            });

            _ViewTTStore2.default.setDateRangeConfig(_FilterController2.default.parseDateRangeConfig({
                qualifier: pageSettings["dateRangeQualifier"],
                fromDate: pageSettings["dateFrom"],
                toDate: pageSettings["dateTo"]
            }));
            _ViewTTStore2.default.setBalancesData(_underscore2.default.isNull(config.balancesViewerConfig) ? null : {
                displayPto: config.balancesViewerConfig.displayPto,
                displaySick: config.balancesViewerConfig.displaySick,
                balances: { PTOBalances: 0, sickBalances: 0 }
            });
            _ViewTTStore2.default.setBalancesViewerConfig(config.balancesViewerConfig);
            _ViewTTStore2.default.setFormatterConfig(config.formatterConfig);
        }

        /*
         Send display settings to server for save
         */

    }, {
        key: "_saveDisplaySettings",
        value: function _saveDisplaySettings() {
            var detailsTableConfig = _ViewTTStore2.default.getDetailsTableConfig();
            var chartSectionConfig = _ViewTTStore2.default.getChartSectionConfig();
            var pdfPrintParameters = _ViewTTStore2.default.getPrintParametersForSave();
            var displaySettings = {
                tableSortOptions: detailsTableConfig["viewByDays"] ? ViewTTTableSortOptions.BY_DAYS : ViewTTTableSortOptions.BY_HIERARCHY,
                tableAsc: detailsTableConfig["asc"],
                showTasks: detailsTableConfig["showTasks"],
                chartType: chartSectionConfig["chartType"],
                showChart: chartSectionConfig["showChart"],
                pdfPaperSize: pdfPrintParameters["paperSize"],
                pdfPaperOrientation: pdfPrintParameters["paperOrientation"],
                pdfShowHeaderOnEachPage: pdfPrintParameters["showHeaderOnEachPage"],
                pdfShowLogoInHeader: pdfPrintParameters["showLogoInHeader"],
                pdfShowSignature: pdfPrintParameters["showSignature"],
                pdfShowSignatureOnEachPage: pdfPrintParameters["showSignatureOnEachPage"]
            };
            (0, _jquery_rpc2.default)("ViewTimeTrackService.saveDisplaySettings", [displaySettings], function () {}, function () {
                return true;
            });
        }

        /*
         Check if we know all leave types
         */

    }, {
        key: "_validateLeaveTypeConsistency",
        value: function _validateLeaveTypeConsistency(serverData) {
            var daysInfo = serverData["daysInfoData"];
            return _underscore2.default.every(daysInfo, function (dayinfo) {
                return LeaveTypeUtil.validateLeaveType(dayinfo["leave"]);
            });
        }

        /*
         Convert server data to convenient form
         */

    }, {
        key: "_prepareAndSetServerData",
        value: function _prepareAndSetServerData(serverData) {
            _ViewTTStore2.default.backupDataConfig();
            // convert date offset to date fields
            var nextDate = Date.parseJSONDate(serverData["dateFrom"]);
            for (var i = 0; i < serverData["daysInfoData"].length; i++) {
                serverData["daysInfoData"][i]["date"] = nextDate.getNDaysAfter(i);
            }

            var userInfo = {
                "today": Date.parseJSONDate(serverData["userInfo"]["today"]),
                "hireDate": Date.parseJSONDate(serverData["userInfo"]["hireDate"]),
                "autoApproved": serverData["userInfo"]["autoApproved"]
            };
            _ViewTTStore2.default.setUserInfo(userInfo);

            var cptMaps = {
                customersById: arrayToMapById(serverData.customers),
                projectsById: arrayToMapById(serverData.projects),
                tasksById: arrayToMapById(serverData.tasks)
            };
            ViewTTPageUtils.updateCPList(_ViewTTStore2.default.getAssignedCPList(), cptMaps);

            // features must be set before the data, or we dispatch them with old features
            // same goes for mergedCp
            _ViewTTStore2.default.setEnabledFeatures(serverData.enabledFeatures);
            var mergedCp = ViewTTPageUtils.mergeCPLists(_ViewTTStore2.default.getAssignedCPMaps(), _ViewTTStore2.default.getAssignedCPList(), {
                customers: serverData.customers,
                projects: serverData.projects
            });
            _ViewTTStore2.default.setMergedCp(mergedCp);
            _ViewTTStore2.default.setData(serverData, cptMaps);
        }
    }, {
        key: "generatePDF",
        value: function generatePDF() {
            (0, _jquery2.default)(document).trigger("viewTT.pdfGenerator.start");
            var self = this;
            this.pdfGenerator.generatePDF(function (config, onDataProvided) {
                self.chartController.exportChart(config["chartImageSizes"], function (img) {
                    onDataProvided({
                        chartImage: img
                    });
                });
            }).then(function (pdf) {
                _ViewTTStore2.default.setGeneratedPDF(pdf.encodedPDF);
                _ViewTTStore2.default.setPDFFileName(pdf.fileName);
            }, function (error) {
                if (error.message != "abort") {
                    console.error(error);
                }
            });
        }
    }, {
        key: "cancelAllExportingProcesses",
        value: function cancelAllExportingProcesses() {
            this.pdfGenerator.interruptGeneration();
            this.pdfPreviewLightbox.cancelAllExportingProcesses();
        }
    }, {
        key: "_onTaskChanged",
        value: function _onTaskChanged(taskId, prevTaskState) {
            var task = _TaskStore2.default.get(taskId);
            if (!task || !prevTaskState) return;

            if (taskId !== prevTaskState.id) return;

            var currWorkflowStatus = this.state.workflowStatuses[(0, _selectors.selectStatusIdByTask)(task)];
            var prevWorkflowStatus = this.state.workflowStatuses[(0, _selectors.selectStatusIdByTask)(prevTaskState)];

            var curTaskProject = _ViewTTStore2.default.getProject(task.projectId);
            var curTaskCustomer = _ViewTTStore2.default.getCustomer(task.customerId);

            if (prevTaskState.name !== task.name || !!prevWorkflowStatus && prevWorkflowStatus.colorId !== currWorkflowStatus.colorId || prevTaskState.commentsNumber !== task.commentsNumber || !prevTaskState.description && task.description || prevTaskState.description !== task.description || !!curTaskCustomer && curTaskCustomer.name !== prevTaskState.customerName || !!curTaskProject && curTaskProject.name !== prevTaskState.projectName) {
                _ViewTTStore2.default.updateTask(task);
                this.detailsTable.update();
            }
        }
    }, {
        key: "_abortRpcCall",
        value: function _abortRpcCall(rpc) {
            if (!_underscore2.default.isUndefined(rpc)) {
                rpc.abort();
            }
        }
    }]);

    return ViewTTMediator;
}(_View3.default);

;

exports.default = (0, _utils.connect)(function (state) {
    return {
        workflowStatuses: (0, _selectors2.getWorkflowStatuses)(state),
        openTaskId: (0, _selectors3.getOpenTaskId)(state)
    };
}, function (dispatch) {
    return {
        openTaskPanel: (0, _redux.bindActionCreators)(_actions.openEditTaskPanel, dispatch),
        toast: (0, _redux.bindActionCreators)(_actions2.toast, dispatch)
    };
})(ViewTTMediator);

/***/ }),
/* 1566 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _PDFDefinitionCreator = __webpack_require__(1567);

var _PDFDefinitionCreator2 = _interopRequireDefault(_PDFDefinitionCreator);

var _date_format = __webpack_require__(16);

var _ViewTTStore = __webpack_require__(73);

var _ViewTTStore2 = _interopRequireDefault(_ViewTTStore);

var _atUtils = __webpack_require__(5);

var _PDFParametersFormattingStrategy = __webpack_require__(1571);

var _PDFParametersFormattingStrategy2 = _interopRequireDefault(_PDFParametersFormattingStrategy);

var _utils = __webpack_require__(164);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PDFGenerator = function PDFGenerator() {};

PDFGenerator.prototype = _.create(Object.prototype, {
    init: function init() {
        this.onGenerateBreaker = { needBreak: false };

        this.docDefinitionCreator = new _PDFDefinitionCreator2.default();
        return this;
    },

    /**
     * We cant interrupt pdf generated process, but we can interrupt on generate process
     */
    interruptGeneration: function interruptGeneration() {
        this.onGenerateBreaker.needBreak = true;
    },

    _getCreatePDFDefinitionStrategy: function _getCreatePDFDefinitionStrategy() {
        return null;
    },

    _getParametersFormattingStrategy: function _getParametersFormattingStrategy(config) {
        var dateFormatForFileName = new _date_format.DateFormat('yyyy-MM-dd');
        return new _PDFParametersFormattingStrategy2.default().init({
            customersProjects: _ViewTTStore2.default.getMergedCpList()
        }, config.dateFormat, dateFormatForFileName);
    },

    calculateTotalNumberOfPages: function calculateTotalNumberOfPages(params) {
        return 0;
    },

    generatePDF: function generatePDF(additionalDataProvider) {
        var newBreaker = {
            needBreak: false
        };
        this.onGenerateBreaker = newBreaker;

        var config = _ViewTTStore2.default.getDetailsTableConfig();
        var pageData = config.viewByDays ? ViewTTPageUtils.tablePresentDataByDays() : ViewTTPageUtils.tablePresentDataByCP();

        var filter = _ViewTTStore2.default.getFilter();
        var user = _ViewTTStore2.default.getSelectedUser();

        var dateRangeSelection = _ViewTTStore2.default.getDateRangeConfig();
        var statuses = ViewTTPageUtils.isFeatureEnabled(Features["TTA"]) ? filter.weekApprovalStatuses : null;
        var cpSelection = filter.cpSelection;
        var storedData = _ViewTTStore2.default.getData();
        var cpList = _ViewTTStore2.default.getMergedCpList();

        var pdfPrintParameters = _ViewTTStore2.default.getPrintParametersForGenerate();
        var getChartSectionConfig = _ViewTTStore2.default.getChartSectionConfig();

        var pdfConfig = {
            chartType: ChartType.VERTICAL_BAR,
            getChartSectionConfig: getChartSectionConfig,
            pdfPrintParameters: pdfPrintParameters,
            dateFormat: new _date_format.DateFormat(SystemSettings.dateFormat),
            storedData: storedData,
            selectorsData: {
                customersProjects: cpList
            },
            selectedParameters: {
                viewByDays: config.viewByDays,
                showTasks: config.showTasks,
                dateParameters: { dateRangeSelection: dateRangeSelection },
                user: user,
                statuses: statuses,
                hierarchicalSelectorsParameters: {
                    customersProjectsSelection: cpSelection
                }
            },
            pdfData: {
                "tableData": pageData,
                "chartImage": null
            }
        };

        var s = this;
        return new Promise(function (onComplete) {
            if (s.isNeedRetrieveAdditionalData(pdfConfig)) {
                additionalDataProvider(s.getAdditionalDataConfig(pdfConfig), function (additionalData) {
                    s.updateConfigWithAdditionalData(pdfConfig, additionalData);
                    onComplete(pdfConfig);
                });
            } else {
                onComplete(pdfConfig);
            }
        }).then(function (pdfConfig) {
            return new Promise(function (onComplete, onError) {
                (0, _atUtils.defer)(_.bind(onComplete, this, pdfConfig));
            });
        }).then(function (pdfConfig) {
            if (newBreaker["needBreak"]) {
                return Promise.reject(new Error("abort"));
            }
            return s._generatePDF(pdfConfig, newBreaker);
        });
    },

    isNeedRetrieveAdditionalData: function isNeedRetrieveAdditionalData(pdfConfig) {
        return _ViewTTStore2.default.getChartSectionConfig()["showChart"];
    },

    getAdditionalDataConfig: function getAdditionalDataConfig(pdfConfig) {
        return {
            chartImageSizes: this.docDefinitionCreator.getChartImageSizes(pdfConfig.pdfPrintParameters)
        };
    },

    updateConfigWithAdditionalData: function updateConfigWithAdditionalData(pdfConfig, additionalData) {
        pdfConfig.pdfData.chartImage = additionalData["chartImage"];
    },

    _generatePDF: function _generatePDF(config, breaker) {
        var paramFormattingStrategy = this._getParametersFormattingStrategy(config);
        var self = this;

        return this.docDefinitionCreator.createDocDefinition(config, paramFormattingStrategy).then(function (ddObject) {
            var doc = (0, _utils.createPdf)(ddObject["docDefinition"]);
            var currentFileName = paramFormattingStrategy.formatChartPDFFileName(config.selectedParameters);

            return new Promise(function (onComplete, onError) {
                try {
                    doc._createDoc({
                        tableLayouts: ddObject["tableLayouts"]
                    }, function (result, pages) {
                        if (breaker.needBreak) {
                            return onError(new Error("abort"));
                        }

                        onComplete({
                            encodedPDF: result,
                            fileName: currentFileName,
                            pageCount: pages.length
                        });
                    });
                } catch (e) {
                    onError(e);
                }
            });
        });
    }
});

exports.default = PDFGenerator;

/***/ }),
/* 1567 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _DataTableCreateDefinitionHelper = __webpack_require__(1568);

var _DataTableCreateDefinitionHelper2 = _interopRequireDefault(_DataTableCreateDefinitionHelper);

var _ViewTTStore = __webpack_require__(73);

var _ViewTTStore2 = _interopRequireDefault(_ViewTTStore);

var _PDFImageCache = __webpack_require__(122);

var _PDFImageCache2 = _interopRequireDefault(_PDFImageCache);

var _user_time = __webpack_require__(30);

var _user_time2 = _interopRequireDefault(_user_time);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _LeaveTypeStore = __webpack_require__(124);

var _LeaveTypeStore2 = _interopRequireDefault(_LeaveTypeStore);

var _atBrowserUtils = __webpack_require__(8);

var _PDFDefinitionBuilder = __webpack_require__(1570);

var _PDFDefinitionBuilder2 = _interopRequireDefault(_PDFDefinitionBuilder);

var _constants = __webpack_require__(100);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PDFDefinitionCreator = function PDFDefinitionCreator(parameterFormatter) {};

PDFDefinitionCreator.prototype = _underscore2.default.create(PDFDefinitionCreator.prototype, {

    createDocDefinition: function createDocDefinition(pdfConfig, parameterFormatter) {
        this.parameterFormatter = parameterFormatter;
        this.pdfPrintParams = pdfConfig.pdfPrintParameters;
        this.pdfData = pdfConfig.pdfData;
        this.pdfConfig = pdfConfig;

        var ddb = new _PDFDefinitionBuilder2.default();
        ddb.init(this.pdfPrintParams.paperOrientation, this.pdfPrintParams.paperSize);

        // start create doc definition
        return _PDFImageCache2.default.preloadImages(this._imagesMap(pdfConfig)) // preload needed images
        .then(_underscore2.default.bind(this._processCreateDocDefinition, this, ddb) // construct doc definition
        ).then(function () {
            // return object for generate pdf
            return {
                "docDefinition": ddb.getDocDefinitionObject(),
                "tableLayouts": ddb.getTableLayouts()
            };
        });
    },

    _imagesMap: function _imagesMap() {
        var imagesMap = {
            "logo": {
                "url": window.__GENERATED_CONSTANTS__.REPORT_LOGO_PATH
            },
            "openTask": {
                "url": (0, _atBrowserUtils.atImgPath)('workflow/open-big.png'),
                "saveAlpha": true
            },
            "completedTask": {
                "url": (0, _atBrowserUtils.atImgPath)('workflow/completed-big.png'),
                "saveAlpha": true
            },
            "lockedDay": {
                "url": (0, _atBrowserUtils.atImgPath)('lock_tt/lock-icon.png'),
                "saveAlpha": true
            },
            "filterIcon": {
                "url": (0, _atBrowserUtils.atImgPath)('filter-for-pdf.png'),
                "saveAlpha": true
            }
        };
        var leaveTypesIds = _underscore2.default.map(_LeaveTypeStore2.default.getLeaveTypes(), function (leaveType) {
            return leaveType["iconId"];
        });
        _underscore2.default.each(leaveTypesIds, function (id) {
            imagesMap["leaveTypeIcon_" + id] = {
                "url": getLeaveTypeIconPath(id)
            };
        });

        return imagesMap;
    },

    _processCreateDocDefinition: function _processCreateDocDefinition(ddb) {
        ddb.initDocDefinitionObject(this.pdfPrintParams.showSignatureOnEachPage && this.pdfPrintParams.showSignature, this.pdfPrintParams.showHeaderOnEachPage);

        var headerData = this._createHeaderData();
        if (this.pdfPrintParams.paperOrientation == _constants.PaperOrientation.PORTRAIT) {
            ddb.addPortraitHeader(this.pdfPrintParams.showHeaderOnEachPage, this.pdfPrintParams.showLogoInHeader, headerData);
        } else {
            ddb.addLandscapeHeader(this.pdfPrintParams.showHeaderOnEachPage, this.pdfPrintParams.showLogoInHeader, headerData);
        }

        this.addTotals(ddb);

        if (this.pdfConfig.getChartSectionConfig.showChart && this.pdfData.chartImage != null) {
            var viewByText = _messageResource2.default.getMessage('view_tt.chart.view_by_label');
            viewByText += " " + ViewTTPageUtils.getChartTypeMessage(this.pdfConfig.getChartSectionConfig.chartType);
            ddb.addChartImage(viewByText, this.pdfData.chartImage);
        }

        this._addTableData(ddb);

        if (this.pdfPrintParams.showSignature && !this.pdfPrintParams.showSignatureOnEachPage) {
            ddb.addSignatureToEnd();
        }
        ddb.addFooterWithSignature(this.pdfPrintParams.showSignatureOnEachPage && this.pdfPrintParams.showSignature);
    },

    addTotals: function addTotals(ddb) {
        var storedData = this.pdfConfig.storedData;
        var dateStr = this.formatDateSelection(this.pdfConfig.selectedParameters.dateParameters.dateRangeSelection);

        var leaveTimeTotals = [];
        ViewTTPageUtils.leaveTotalsOrderedIterate(storedData["leaveTimeTotals"], function (leaveType, leaveTime) {
            leaveTimeTotals.push({ name: leaveType["name"], value: _user_time2.default.formatTimeWithDigitSeparator(leaveTime) });
        });

        var totalSpentVal = ViewTTPageUtils.calculateTotalSpent(storedData);
        var totalSpent = _user_time2.default.formatTimeWithDigitSeparator(totalSpentVal);
        var totalWorkingTimeVal = storedData["totalWorking"];
        var totalWorkingTime = _user_time2.default.formatTimeWithDigitSeparator(totalWorkingTimeVal);
        var effectiveDuration = !_underscore2.default.isNull(storedData["effectiveDuration"]) ? _user_time2.default.formatTimeWithDigitSeparator(storedData["effectiveDuration"]) : null;
        var totalDiffVal = 0;
        if (!_underscore2.default.isNull(storedData["effectiveDuration"])) {
            totalDiffVal = totalSpentVal - storedData.effectiveDuration;
        }

        if (!_underscore2.default.isNull(storedData['totalWorkingForToday'])) {
            var totalSpentForTodayVal = ViewTTPageUtils.calculateTotalSpentForToday(storedData);
            var totalSpentForToday = _user_time2.default.formatTimeWithDigitSeparator(totalSpentForTodayVal);
            var effectiveDurationForToday = !_underscore2.default.isNull(storedData['effectiveDurationForToday']) ? _user_time2.default.formatTimeWithDigitSeparator(storedData["effectiveDurationForToday"]) : null;
            if (!_underscore2.default.isNull(storedData["effectiveDurationForToday"])) {
                totalDiffVal = totalSpentForTodayVal - storedData.effectiveDurationForToday;
            }
        }
        var showLeaves = storedData.totalLeaveTime !== null;
        var showOvertime = storedData["totalOvertimeInfo"] !== null;

        var showSecondColumn = showOvertime || showLeaves;
        var totalsBuilder = ddb.getTotalElementBuilder(totalSpent, effectiveDuration, totalSpentForToday, effectiveDurationForToday, totalDiffVal, dateStr, showSecondColumn);

        if (showSecondColumn) {
            totalsBuilder.appendSecondColumn(showLeaves);
        }

        totalsBuilder.appendTotalWorkingTime(totalWorkingTime);

        if (showOvertime) {
            var ovtValue = storedData["totalOvertimeInfo"]["reported"];
            var autoValue = storedData["totalOvertimeInfo"]["auto"];
            if (_underscore2.default.isNull(ovtValue)) {
                ovtValue = autoValue;
            }

            if (!_underscore2.default.isNull(ovtValue)) {
                var regularWorkingTime = _user_time2.default.formatTimeWithDigitSeparator(totalWorkingTimeVal - ovtValue);
                totalsBuilder.appendRegularWorkingTime(regularWorkingTime);
                var totalOvertime = _user_time2.default.formatTimeWithDigitSeparator(ovtValue);
                totalsBuilder.appendTotalOvertime(totalOvertime);
            }

            if (!_underscore2.default.isNull(autoValue) && ovtValue != autoValue) {
                var totalAutoOvertime = _user_time2.default.formatTimeWithDigitSeparator(autoValue);
                totalsBuilder.appendTotalAutoOvertime(totalAutoOvertime);
            }
        }

        if (showLeaves) {
            var totalLeaveTime = _user_time2.default.formatTimeWithDigitSeparator(storedData["totalLeaveTime"]);
            totalsBuilder.appendTotalLeaveTime(totalLeaveTime, leaveTimeTotals);
        }
        totalsBuilder.build();
    },

    formatDateSelection: function formatDateSelection(dateSelection) {
        return new ViewTTPage.TotalsForPeriod().formatDateQualifier(dateSelection.qualifier);
    },

    getChartImageSizes: function getChartImageSizes(pdfPrintParameters) {
        var pdfParameters = _PDFDefinitionBuilder.PDFDefinitionBuilderParameters;
        if (pdfPrintParameters.paperOrientation == _constants.PaperOrientation.LANDSCAPE) {
            pdfParameters = pdfParameters.Landscape;
        } else {
            pdfParameters = pdfParameters.Portrait;
        }

        if (pdfPrintParameters.paperSize == _constants.PaperSize.A4) {
            pdfParameters = pdfParameters.A4;
        } else {
            pdfParameters = pdfParameters.Letter;
        }

        return {
            width: pdfParameters.chartImageSize.width * 2,
            height: pdfParameters.chartImageSize.height * 2
        };
    },

    _createHeaderData: function _createHeaderData() {
        var selectedParameters = this.pdfConfig.selectedParameters;
        return {
            informationTexts: {
                title: this.parameterFormatter.formatChartPDFHeaderTitle(selectedParameters),
                dateRange: this.parameterFormatter.formatChartPDFHeaderDateInformation(selectedParameters)
            },
            filterTexts: this.parameterFormatter.formatChartPDFFilterInformation(selectedParameters),
            logo: _PDFImageCache2.default.getImage('logo')
        };
    },

    _addTableData: function _addTableData(ddb) {
        new _DataTableCreateDefinitionHelper2.default(ddb, this.pdfData.tableData, {
            viewByDays: this.pdfConfig.selectedParameters.viewByDays,
            showTasks: this.pdfConfig.selectedParameters.showTasks,
            dateFormat: _ViewTTStore2.default.getDateFormat()
        }).createTable();
    }

});

exports.default = PDFDefinitionCreator;

/***/ }),
/* 1568 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _LeaveTypeStore = __webpack_require__(124);

var _LeaveTypeStore2 = _interopRequireDefault(_LeaveTypeStore);

var _user_time = __webpack_require__(30);

var _user_time2 = _interopRequireDefault(_user_time);

var _PDFImageCache = __webpack_require__(122);

var _PDFImageCache2 = _interopRequireDefault(_PDFImageCache);

var _ViewTTStore = __webpack_require__(73);

var _ViewTTStore2 = _interopRequireDefault(_ViewTTStore);

var _selectors = __webpack_require__(57);

var _utils = __webpack_require__(6);

var _utils2 = __webpack_require__(1569);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DataTableCreateDefinitionHelper = function DataTableCreateDefinitionHelper(ddBuilder, tableData, config) {
    this.ddBuilder = ddBuilder;
    this.tableData = tableData;
    this.config = config;

    this.labels = {
        nonWorkingLabel: _messageResource2.default.getMessage("view_tt.details_table.day_row.nonworking_day"),
        approvedLabel: _messageResource2.default.getMessage("view_tt.details_table.day_row.approved"),
        autoApprovedLabel: _messageResource2.default.getMessage("view_tt.details_table.day_row.auto_approved"),
        notReadyLabel: _messageResource2.default.getMessage("view_tt.details_table.day_row.not_ready"),
        readyLabel: _messageResource2.default.getMessage("view_tt.details_table.day_row.ready"),
        rejectedLabel: _messageResource2.default.getMessage("view_tt.details_table.day_row.rejected"),
        workingTimeLabel: _messageResource2.default.getMessage("view_tt.details_table.day_row.working_time"),
        overtimeLabel: _messageResource2.default.getMessage("overtime.overtime"),
        leaveTimeLabel: _messageResource2.default.getMessage("view_tt.details_table.day_row.leave_time"),
        autoOvertime: _messageResource2.default.getMessage("view_tt.details_table.overtime_row.auto")
    };
};

DataTableCreateDefinitionHelper.prototype = {

    createTable: function createTable() {
        var showTasks = this.config.showTasks;
        var rows = [];
        var rowTypes = ViewTTPageUtils.RowType;
        for (var i = 0; i < this.tableData.length; i++) {
            var rowData = this.tableData[i];

            var rowDefinition;
            var data;
            var isWeekend;
            var day;
            var task;
            var overtime;
            var taskObject;
            var otherTTInfo;
            switch (rowData.type) {
                case rowTypes.DAY:
                    {
                        day = rowData["dayModel"];

                        var isLeaveTimePresent = !_.isNull(day["leave"]);
                        var isOvertimePresent = !_.isNull(day["overtime"]);

                        var workingTime = day["totalWorkingTime"];
                        var leaveTime = isLeaveTimePresent ? day["leave"]["leaveTime"] : 0;
                        overtime = isOvertimePresent ? _.isNull(day["overtime"]["reported"]) ? day["overtime"]["auto"] : day["overtime"]["reported"] : 0;

                        var isEmptyLeaveTime = !isLeaveTimePresent || leaveTime == 0;
                        var isEmptyOvertime = !isOvertimePresent || overtime == 0;
                        var isEmptyWorkingTime = workingTime == 0;

                        var totalTime = leaveTime + workingTime;
                        isWeekend = this.isWeekend(day);

                        var descriptionSection = [];
                        if (!showTasks) {
                            var leaveTypeName = isEmptyLeaveTime ? this.labels.leaveTimeLabel : _LeaveTypeStore2.default.getLeaveType(day["leave"]["leaveTypeId"])["name"];
                            var descriptionData = {
                                workingTime: this.labels.workingTimeLabel + ": " + (!isEmptyWorkingTime ? _user_time2.default.formatTimeWithDigitSeparator(workingTime) : "--"),
                                leaveTime: leaveTypeName + ": " + (!isEmptyLeaveTime ? _user_time2.default.formatTimeWithDigitSeparator(leaveTime) : "--"),
                                overtime: this.labels.overtimeLabel + ": " + (!isEmptyOvertime ? _user_time2.default.formatTimeWithDigitSeparator(overtime) : "--")
                            };
                            var descriptionParams = {
                                isEmptyWorkingTime: isEmptyWorkingTime,
                                isEmptyOvertime: isEmptyOvertime,
                                isEmptyLeaveTime: isEmptyLeaveTime,
                                isLeaveTimePresent: isLeaveTimePresent,
                                isOvertimePresent: isOvertimePresent
                            };
                            descriptionSection = this.ddBuilder.crateDayRowDescription(descriptionData, descriptionParams);
                        }

                        var approvalStatusLabel = "";
                        var statusClass = "";
                        switch (day["approvalStatus"]) {
                            case EffectiveWeekApprovalStatus.AUTO_APPROVED:
                                approvalStatusLabel = this.labels.autoApprovedLabel;
                                statusClass = "approved";
                                break;
                            case EffectiveWeekApprovalStatus.APPROVED:
                                approvalStatusLabel = this.labels.approvedLabel;
                                statusClass = "approved";
                                break;
                            case EffectiveWeekApprovalStatus.NOT_READY:
                                approvalStatusLabel = this.labels.notReadyLabel;
                                statusClass = "notReady";
                                break;
                            case EffectiveWeekApprovalStatus.READY:
                                approvalStatusLabel = this.labels.readyLabel;
                                statusClass = "ready";
                                break;
                            case EffectiveWeekApprovalStatus.REJECTED:
                                approvalStatusLabel = this.labels.rejectedLabel;
                                statusClass = "rejected";
                                break;
                        }

                        data = {
                            category: this.config["dateFormat"].formatDate(day.date),
                            total: _user_time2.default.formatTimeWithDigitSeparator(totalTime),
                            statusLabel: approvalStatusLabel,
                            nonWorkingLabel: isWeekend ? this.labels.nonWorkingLabel : "",
                            lockImage: _PDFImageCache2.default.getImage("lockedDay")["image"]
                        };

                        var params = {
                            isWeekend: isWeekend,
                            statusClass: statusClass,
                            isEmptyTotal: totalTime == 0,
                            locked: day["locked"]
                        };

                        rowDefinition = this.ddBuilder.createDayRow(data, params, descriptionSection);
                        break;
                    }
                case rowTypes.TASK_BY_DAY:
                    {
                        if (!showTasks) continue;

                        day = rowData["dayModel"];
                        isWeekend = this.isWeekend(day);
                        task = rowData["taskModel"];
                        taskObject = _ViewTTStore2.default.getTask(task["taskId"]);
                        var workflowStatus = (0, _utils.unsafe_selectWithState)(function (state) {
                            return (0, _selectors.selectStatusByTask)(state, taskObject);
                        });
                        data = {
                            category: taskObject.name,
                            customerName: _ViewTTStore2.default.getCustomer(task["customerId"])["name"],
                            projectName: _ViewTTStore2.default.getProject(task["projectId"])["name"],
                            total: _user_time2.default.formatTimeWithDigitSeparator(task["spent"]),
                            comment: _.isNull(task["comment"]) ? '' : task["comment"],
                            color: (0, _utils2.getPdfColorByColorIdAndStatusType)(workflowStatus.colorId, workflowStatus.type),
                            image: _PDFImageCache2.default.getImage((0, _utils2.getPdfIconNameByType)(workflowStatus.type))["image"]
                        };

                        params = {
                            isWeekend: isWeekend,
                            isCompleted: taskObject["completed"]
                        };
                        rowDefinition = this.ddBuilder.createTaskByDayRow(data, params);
                        break;
                    }
                case rowTypes.LEAVE:
                    {
                        if (!showTasks) continue;

                        day = rowData["dayModel"];
                        isWeekend = this.isWeekend(day);
                        var leaveType = _LeaveTypeStore2.default.getLeaveType(day["leave"]["leaveTypeId"]);
                        data = {
                            image: _PDFImageCache2.default.getImage("leaveTypeIcon_" + leaveType["iconId"])["image"],
                            category: leaveType["name"],
                            total: _user_time2.default.formatTimeWithDigitSeparator(day["leave"]["leaveTime"])
                        };
                        params = {
                            isWeekend: isWeekend
                        };
                        rowDefinition = this.ddBuilder.createLeaveRow(data, params);
                        break;
                    }
                case rowTypes.OVERTIME:
                    {
                        if (!showTasks) continue;

                        day = rowData["dayModel"];
                        isWeekend = this.isWeekend(day);
                        overtime = day["overtime"];
                        var total = _.isNumber(overtime["reported"]) ? overtime["reported"] : overtime["auto"];
                        var autoTotal = overtime["auto"];
                        var isNeedToShowAuto = total != autoTotal;
                        data = {
                            category: this.labels.overtimeLabel,
                            total: _user_time2.default.formatTimeWithDigitSeparator(total),
                            autoOvertimeMsg: isNeedToShowAuto ? this.labels.autoOvertime + " " + this.labels.overtimeLabel + " " + _user_time2.default.formatTimeWithDigitSeparator(autoTotal) : ""
                        };

                        params = {
                            isWeekend: isWeekend,
                            showAuto: isNeedToShowAuto
                        };
                        rowDefinition = this.ddBuilder.createOvertimeRow(data, params);
                        break;
                    }
                case rowTypes.OTHER_SPENT_BY_DAY:
                    {
                        if (!showTasks) continue;

                        day = rowData["dayModel"];
                        isWeekend = this.isWeekend(day);
                        otherTTInfo = day["otherTTInfo"];
                        data = {
                            category: this._createOtherTimeTrackLabel(otherTTInfo),
                            total: _user_time2.default.formatTimeWithDigitSeparator(otherTTInfo["spent"])
                        };

                        params = {
                            isWeekend: isWeekend
                        };
                        rowDefinition = this.ddBuilder.createOtherSpentByDayRow(data, params);
                        break;
                    }

                case rowTypes.CUSTOMER:
                    {
                        var customer = rowData["customerModel"];
                        data = {
                            category: _ViewTTStore2.default.getCustomer(customer["customerId"])["name"],
                            total: _user_time2.default.formatTimeWithDigitSeparator(customer["totalSpent"])
                        };

                        rowDefinition = this.ddBuilder.createCustomerRow(data);
                        break;
                    }
                case rowTypes.PROJECT:
                    {
                        var project = rowData["projectModel"];
                        data = {
                            category: _ViewTTStore2.default.getProject(project["projectId"])["name"],
                            total: _user_time2.default.formatTimeWithDigitSeparator(project["totalSpent"])
                        };

                        rowDefinition = this.ddBuilder.createProjectRow(data);
                        break;
                    }
                case rowTypes.TASK_BY_CP:
                    {
                        if (!showTasks) continue;

                        task = rowData["taskModel"];
                        taskObject = _ViewTTStore2.default.getTask(task.taskId);
                        var _workflowStatus = (0, _utils.unsafe_selectWithState)(function (state) {
                            return (0, _selectors.selectStatusByTask)(state, taskObject);
                        });
                        data = {
                            category: taskObject["name"],
                            total: _user_time2.default.formatTimeWithDigitSeparator(task["totalSpent"]),
                            description: _.isNull(taskObject["description"]) ? '' : taskObject["description"],
                            color: (0, _utils2.getPdfColorByColorIdAndStatusType)(_workflowStatus.colorId, _workflowStatus.type),
                            image: _PDFImageCache2.default.getImage((0, _utils2.getPdfIconNameByType)(_workflowStatus.type))["image"]
                        };

                        params = {
                            isCompleted: taskObject["completed"]
                        };

                        rowDefinition = this.ddBuilder.createTaskByCpRow(data, params);
                        break;
                    }
                case rowTypes.OTHER_SPENT_BY_CP:
                    {
                        otherTTInfo = rowData["otherTTInfo"];
                        data = {
                            category: this._createOtherTimeTrackLabel(otherTTInfo),
                            total: _user_time2.default.formatTimeWithDigitSeparator(otherTTInfo["spent"])
                        };

                        rowDefinition = this.ddBuilder.createOtherSpentByCpRow(data);
                        break;
                    }
            }
            rows.push(rowDefinition);
        }

        var thereAreNoRows = rows.length == 0;
        if (thereAreNoRows) {
            var emptyDataMessage = this.config["viewByDays"] ? _messageResource2.default.getMessage("view_tt.details_table.no_day_rows") : _messageResource2.default.getMessage("view_tt.details_table.no_cp_rows");
            rows.push(this.ddBuilder.createEmptyDataRow(emptyDataMessage));
        }

        var titleByKey = this.config["viewByDays"] ? "view_tt.pdf.details_table.title_by_days" : "view_tt.pdf.details_table.title_by_cp";
        var titleMessage = _messageResource2.default.getMessage("view_tt.pdf.details_table.title", [_messageResource2.default.getMessage(titleByKey)]);

        this.ddBuilder.addDataTableWithHeader(titleMessage, rows);
    },

    isWeekend: function isWeekend(dayModel) {
        return dayModel["workdayDuration"] == 0;
    },

    _createOtherTimeTrackLabel: function _createOtherTimeTrackLabel(otherTTInfo) {
        return _messageResource2.default.getMessage("view_tt.details_table.other_tt");
    }
};

exports.default = DataTableCreateDefinitionHelper;

/***/ }),
/* 1569 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getPdfColorByColorIdAndStatusType = getPdfColorByColorIdAndStatusType;
exports.getPdfIconNameByType = getPdfIconNameByType;

var _constants = __webpack_require__(842);

var _constants2 = __webpack_require__(23);

function getPdfColorByColorIdAndStatusType(colorId, type) {
    if (type === _constants2.WorkflowStatusType.OPEN) {
        return _constants.PDF_OPEN_TYPE_COLOR_MAP_BY_COLOR_NAME[colorId];
    } else if (type === _constants2.WorkflowStatusType.COMPLETED) {
        return _constants.PDF_COMPLETED_TYPE_COLOR_MAP_BY_COLOR_NAME[colorId];
    }
}

function getPdfIconNameByType(workflowStatusType) {
    return _constants.PDF_ICON_MAP_BY_TYPE[workflowStatusType];
}

/***/ }),
/* 1570 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.PDFDefinitionBuilderParameters = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _BasePDFDefinitionBuilder = __webpack_require__(541);

var _BasePDFDefinitionBuilder2 = _interopRequireDefault(_BasePDFDefinitionBuilder);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _ViewTTStore = __webpack_require__(73);

var _ViewTTStore2 = _interopRequireDefault(_ViewTTStore);

var _user_time = __webpack_require__(30);

var _user_time2 = _interopRequireDefault(_user_time);

var _StringUtils = __webpack_require__(121);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PDFDefinitionBuilder = function (_BasePDFDefinitionBui) {
    _inherits(PDFDefinitionBuilder, _BasePDFDefinitionBui);

    function PDFDefinitionBuilder() {
        _classCallCheck(this, PDFDefinitionBuilder);

        return _possibleConstructorReturn(this, (PDFDefinitionBuilder.__proto__ || Object.getPrototypeOf(PDFDefinitionBuilder)).apply(this, arguments));
    }

    _createClass(PDFDefinitionBuilder, [{
        key: 'getAdditionalStyles',
        value: function getAdditionalStyles() {
            return PDFDefinitionBuilderStyles;
        }
    }, {
        key: 'getAdditionalParameters',
        value: function getAdditionalParameters() {
            return PDFDefinitionBuilderParameters;
        }
    }, {
        key: 'getAdditionalTableLayouts',
        value: function getAdditionalTableLayouts() {
            return {};
        }
    }, {
        key: 'initDocDefinitionObject',
        value: function initDocDefinitionObject(withSignatureOnEachPage, headerOnEachPage) {
            _get(PDFDefinitionBuilder.prototype.__proto__ || Object.getPrototypeOf(PDFDefinitionBuilder.prototype), 'initDocDefinitionObject', this).call(this, headerOnEachPage);
            var margins = [];
            _underscore2.default.extend(margins, this.dd.pageMargins);
            if (withSignatureOnEachPage) {
                margins[3] += 40; //TODO adjust with parameters
            }
            this.dd.pageMargins = margins;

            this.dd.pageBreakBefore = function (currentNode, followingNodesOnPage, nodesOnNextPage, previousNodesOnPage) {
                if (currentNode.headlineLevel === 1) {
                    for (var i = 0; i < followingNodesOnPage.length; i++) {
                        if (followingNodesOnPage[i].headlineLevel == 2) return false;
                    }

                    return true;
                }
                return false;
            };
        }
    }, {
        key: '_createSignatureRows',
        value: function _createSignatureRows() {
            return [[{
                style: 'footerSignatureSeparator',
                canvas: [{
                    type: 'line',
                    x1: 0, x2: 200,
                    y1: 0, y2: 0,
                    lineWidth: 0.4,
                    lineColor: '#3D3D3D'
                }]
            }, "", {
                style: 'footerSignatureSeparator',
                canvas: [{
                    type: 'line',
                    x1: 0, x2: 200,
                    y1: 0, y2: 0,
                    lineWidth: 0.4,
                    lineColor: '#3D3D3D'
                }]
            }], [{ text: _messageResource2.default.getMessage('view_tt.pdf.footer.signature'), style: "footerSignature" }, "", { text: _messageResource2.default.getMessage("view_tt.pdf.footer.date"), style: "footerSignature" }]];
        }
    }, {
        key: 'addSignatureToEnd',
        value: function addSignatureToEnd() {
            this.appendContentElement({
                style: 'footerTable',
                margin: [0, 20, 0, 0],
                layout: 'noBordersNoPadding',

                table: {
                    widths: ["40%", "20%", "40%"],
                    body: this._createSignatureRows()
                }
            });
        }
    }, {
        key: 'addFooterWithSignature',
        value: function addFooterWithSignature(withSignature) {
            var footerMargins = this.p("footerMargins")(this.p("pageMargins"));
            if (withSignature) {
                footerMargins = _jquery2.default.extend([], footerMargins);
                footerMargins[1] += 30;
            }
            var s = this;
            this.dd.footer = function () {
                return function (currentPage, pageCount) {
                    var footerRows = [];
                    if (withSignature) {
                        footerRows = footerRows.concat(s._createSignatureRows());
                    }
                    footerRows.push(["", "", { style: "footerPageCount", text: _messageResource2.default.getMessage('report.chart_pdf.rightFooterLabel', [currentPage, pageCount]) }]);
                    return {
                        style: 'footerTable',
                        margin: footerMargins,
                        layout: 'noBordersNoPadding',

                        table: {
                            widths: ["40%", "20%", "40%"],
                            body: footerRows
                        }
                    };
                };
            }();
        }
    }, {
        key: 'makeSingleTotalRow',
        value: function makeSingleTotalRow(name, value, lineMargins, nameStyle, valueStyle) {
            return {
                columns: [{
                    width: 'auto',
                    style: nameStyle,
                    text: name
                }, {
                    width: '*',
                    margin: lineMargins ? lineMargins : [2, 5, 2, 4],
                    table: {
                        widths: ['*'],
                        headerRows: 1,
                        body: [[{ text: '' }]]
                    },
                    layout: leaveTotalColumnLayout
                }, {
                    width: 'auto',
                    style: valueStyle,
                    text: value
                }]
            };
        }
    }, {
        key: 'makeTotalTimeColumns',
        value: function makeTotalTimeColumns(totalSpent, effectiveDuration, totalSpentForToday, effectiveDurationForToday, totalDiffVal, dateStr, showSecondColumn) {
            var showScheduled = !_underscore2.default.isNull(effectiveDuration);
            var reportedColSpan = showScheduled ? 1 : 3;
            var wrapHelper = function wrapHelper(valStr, ext) {
                var text = _underscore2.default.extend({ noWrap: true, text: valStr }, ext);
                return valStr && valStr.length > 6 ? [' ', text] : text;
            };
            var totalTimeTableBody = [['', { noWrap: true, text: _messageResource2.default.getMessage("view_tt.totals.reported"), style: 'viewTTtotalsReported', colSpan: reportedColSpan }, '', { noWrap: true, text: _messageResource2.default.getMessage("view_tt.totals.scheduled"), style: 'viewTTtotalsScheduled' }], [{ text: _messageResource2.default.getMessage("view_tt.totals.for", [dateStr]) }, wrapHelper(totalSpent, { style: 'viewTTtotalsReported', colSpan: reportedColSpan }), { text: _messageResource2.default.getMessage("view_tt.totals.of"), alignment: 'right' }, { noWrap: true, text: ' ' + effectiveDuration + ' ', style: 'viewTTtotalsScheduled' }]];
            if (totalSpentForToday) {
                totalTimeTableBody.push([{ text: _messageResource2.default.getMessage("view_tt.totals.today") }, wrapHelper(totalSpentForToday, { style: 'viewTTtotalsReported', colSpan: reportedColSpan }), { text: _messageResource2.default.getMessage("view_tt.totals.of"), alignment: 'right' }, wrapHelper(effectiveDurationForToday, { style: 'viewTTtotalsScheduled' })]);
            }

            var futureDateRange = _ViewTTStore2.default.getDateRangeConfig().fromDate > _ViewTTStore2.default.getUserInfo()["today"];
            if (totalDiffVal !== 0 && !futureDateRange) {
                var totalDiffMsg = _messageResource2.default.getMessage(totalDiffVal > 0 ? 'view_tt.totals.diff.more' : 'view_tt.totals.diff.less');
                var totalDiffClass = totalDiffVal > 0 ? 'viewTTtotalsDiffMore' : 'viewTTtotalsDiffLess';
                var totalDiff = _user_time2.default.formatTimeWithDigitSeparator(Math.abs(totalDiffVal));

                totalTimeTableBody.push([{ text: [{ text: totalDiff + '  ', bold: true }, { text: totalDiffMsg }], style: totalDiffClass, colSpan: 4 }]);
            }
            var totalTimeLabel = { text: _messageResource2.default.getMessage("view_tt.totals.period") + '\n', style: 'viewTTtotalsSpent',
                margin: showSecondColumn ? [] : [0, 16, 0, 0] };
            var totalTimeTable = { table: {
                    headerRows: 1,
                    widths: showScheduled ? ['50%', '18%', '8%', '18%'] : ['50%', '18%', '0%', '0%'],
                    body: totalTimeTableBody
                }, style: 'viewTTtotalsTimeTable',
                layout: {
                    vLineWidth: function vLineWidth(i, node) {
                        return 0;
                    },
                    hLineWidth: function hLineWidth(i, node) {
                        var rowsN = node.table.body.length;
                        return i === 0 || i === rowsN || i === rowsN - 1 ? 0 : 1;
                    },
                    hLineColor: function hLineColor(i, node) {
                        return '#dbdedf';
                    }
                }

            };

            var totalsColumn = showSecondColumn ? { width: '35%', stack: [totalTimeLabel, totalTimeTable] } : { width: '50%', columns: [_underscore2.default.create(totalTimeLabel, { width: '25%' }), _underscore2.default.create(totalTimeTable, { width: '75%' })] };

            return [totalsColumn];
        }
    }, {
        key: 'appendTotalWorkingTime',
        value: function appendTotalWorkingTime(totalWorkingTime, totalWorkingTimeStack) {
            var totalWorkingTimeDefinition = this.makeSingleTotalRow(_messageResource2.default.getMessage("view_tt.totals.total_working_time"), totalWorkingTime, null, 'viewTTTotalLabel', 'viewTTTotalValue');
            totalWorkingTimeStack.push(totalWorkingTimeDefinition);
            totalWorkingTimeDefinition.margin = [0, 0, 0, 12];
        }
    }, {
        key: 'appendRegularWorkingTime',
        value: function appendRegularWorkingTime(regularWorkingTime, totalWorkingTimeStack) {
            var regularWorkingTimeDefinition = this.makeSingleTotalRow(_messageResource2.default.getMessage("view_tt.totals.regular_working"), regularWorkingTime, null, 'viewTTTotalLabel', ['viewTTTotalSubValue']);
            totalWorkingTimeStack.push(regularWorkingTimeDefinition);
        }
    }, {
        key: 'appendTotalOvertime',
        value: function appendTotalOvertime(totalOvertime, totalWorkingTimeStack) {
            var totalOvertimeDefinition = this.makeSingleTotalRow(_messageResource2.default.getMessage("view_tt.totals.overtime"), totalOvertime, null, ['viewTTTotalLabel'], ['viewTTTotalSubValue']);
            totalOvertimeDefinition.style = 'leaveMargins';
            totalWorkingTimeStack.push(totalOvertimeDefinition);
        }
    }, {
        key: 'appendTotalAutoOvertime',
        value: function appendTotalAutoOvertime(totalAutoOvertime, totalWorkingTimeStack) {
            var totalAutoOvertimeDefinition = this.makeSingleTotalRow(_messageResource2.default.getMessage("view_tt.totals.auto_overtime"), totalAutoOvertime, null, ['viewTTTotalLabel'], ['viewTTTotalSubValue']);
            totalAutoOvertimeDefinition.style = 'leaveMargins';
            totalWorkingTimeStack.push(totalAutoOvertimeDefinition);
        }
    }, {
        key: 'appendTotalLeaveTime',
        value: function appendTotalLeaveTime(totalLeaveTime, leaveTimeTotals, columns) {
            var additionalTotalsTable = [];
            var leaveTotalsDefinition = this.makeSingleTotalRow(_messageResource2.default.getMessage("view_tt.totals.leave_time"), totalLeaveTime, null, 'viewTTTotalLabel', 'viewTTTotalValue');

            leaveTotalsDefinition.margin = [0, 0, 0, 10];
            additionalTotalsTable.push(leaveTotalsDefinition);

            var self = this;
            var leaveMaxLen = this.p("leaveTextLen");
            _underscore2.default.each(leaveTimeTotals, function (leave) {
                var leaveTotalsDefinition = self.makeSingleTotalRow((0, _StringUtils.cutLongText)(leave.name, leaveMaxLen), leave.value, null, 'viewTTLeaveTotal', 'viewTTLeaveTotal');
                leaveTotalsDefinition.style = 'leaveMargins';
                additionalTotalsTable.push(leaveTotalsDefinition);
            });

            columns.push({
                margin: [20, 0, 0, 0],
                stack: additionalTotalsTable
            });
        }
    }, {
        key: 'getTotalElementBuilder',
        value: function getTotalElementBuilder(totalSpent, effectiveDuration, totalSpentForToday, effectiveDurationForToday, totalDiffVal, dateStr, showSecondColumn) {
            var self = this;
            var tableStyles = this.p("dataTableCommonStyles").small;
            var columns = this.makeTotalTimeColumns(totalSpent, effectiveDuration, totalSpentForToday, effectiveDurationForToday, totalDiffVal, dateStr, showSecondColumn);
            var totalWorkingTimeStack = [];

            return {
                appendSecondColumn: function appendSecondColumn(showLeaves) {
                    var totalWorkingTimeStackMargins = showLeaves ? [5, 0, 5, 0] : [135, 0, 5, 0];
                    columns.push({
                        margin: totalWorkingTimeStackMargins,
                        stack: totalWorkingTimeStack
                    });
                },

                appendTotalWorkingTime: function appendTotalWorkingTime(totalWorkingTime) {
                    self.appendTotalWorkingTime(totalWorkingTime, totalWorkingTimeStack);
                },

                appendRegularWorkingTime: function appendRegularWorkingTime(regularWorkingTime) {
                    self.appendRegularWorkingTime(regularWorkingTime, totalWorkingTimeStack);
                },

                appendTotalOvertime: function appendTotalOvertime(totalOvertime) {
                    self.appendTotalOvertime(totalOvertime, totalWorkingTimeStack);
                },

                appendTotalAutoOvertime: function appendTotalAutoOvertime(totalAutoOvertime) {
                    self.appendTotalAutoOvertime(totalAutoOvertime, totalWorkingTimeStack);
                },

                appendTotalLeaveTime: function appendTotalLeaveTime(totalLeaveTime, leaveTimeTotals) {
                    self.appendTotalLeaveTime(totalLeaveTime, leaveTimeTotals, columns);
                },

                build: function build() {
                    self.appendContentElement({
                        style: tableStyles.tableStyle,
                        layout: 'headerBorderSeparatedRows',
                        marginTop: 20,
                        columns: columns
                    });
                }
            };
        }
    }, {
        key: 'addChartImage',
        value: function addChartImage(viewByText, image) {
            var sizes = this.p("chartImageSize");

            this.appendContentElement({
                marginTop: 30,
                marginBottom: 0,
                text: viewByText,
                style: 'viewChartBy',
                headlineLevel: 1
            });

            this.appendContentElement({
                layout: 'noBordersNoPadding',
                headlineLevel: 2,
                marginTop: 5,
                marginBottom: 0,
                table: {
                    width: ['100%'],
                    body: [[{
                        height: sizes.height,
                        width: sizes.width,
                        image: image
                    }]]
                }
            });
        }
    }, {
        key: 'addDataTableWithHeader',
        value: function addDataTableWithHeader(headerText, dataRows) {
            var tableMargins = {
                top: 20
            };
            var tableStyles = this.p("dataTableStyles");

            var rows = [];
            rows.push([{ width: '100%', noWrap: true, style: tableStyles.tableHeaderStyle, text: headerText, colSpan: 3 }, {}, {}]);
            rows = rows.concat(dataRows);

            var table = {
                style: tableStyles.tableStyle,
                layout: 'headerBorderSeparatedRows',
                marginTop: tableMargins.top,

                table: {
                    dontBreakRows: true,
                    widths: ['47%', '6%', '47%'],
                    body: rows
                }
            };
            this.appendContentElement(table);
        }
    }, {
        key: 'crateDayRowDescription',
        value: function crateDayRowDescription(data, params) {
            var columns = [];
            var columnsCount = 1;
            if (params.isOvertimePresent) columnsCount++;
            if (params.isLeaveTimePresent) columnsCount++;

            var columnPercentWidth = Math.round(100 / columnsCount * 10) / 10 + "%";
            columns.push({ width: columnPercentWidth, style: ["dayRowDescription", params.isEmptyWorkingTime ? "emptyTableData" : ""], text: data.workingTime });
            if (params.isOvertimePresent) {
                columns.push({ width: columnPercentWidth, style: ["dayRowDescription", params.isEmptyOvertime ? "emptyTableData" : ""], text: data.overtime });
            }
            if (params.isLeaveTimePresent) {
                columns.push({ width: columnPercentWidth, style: ["dayRowDescription", params.isEmptyLeaveTime ? "emptyTableData" : ""], text: data.leaveTime });
            }
            return columns;
        }
    }, {
        key: 'createDayRow',
        value: function createDayRow(data, params, description) {
            var lockedImage = params.locked ? { width: 9, image: data.lockImage } : { width: 0, text: "" };
            return [{
                style: [params.isWeekend ? "weekendRow" : ""], marginLeft: params.locked ? 0 : 15, alignment: 'left',
                columns: [lockedImage, {
                    marginLeft: params.locked ? 5 : 0,
                    width: "55%",
                    text: [{ style: ["tableText", "tableFirstLevel"], text: data.category }, { style: ["tableSubText"], text: " " + data.nonWorkingLabel }]
                }, {
                    width: "*",
                    text: data.statusLabel, style: ["dayRowStatus", params.statusClass]
                }]
            }, {
                style: ["total", "firstLevelTotal", params.isWeekend ? "firstLevelTotalWeekend" : "", params.isEmptyTotal ? "emptyTableData" : ""],
                text: data.total
            }, {
                style: [params.isWeekend ? "weekendRow" : ""],
                margin: [0, 0, 0, 0],
                columns: description
            }];
        }
    }, {
        key: 'createTaskByDayRow',
        value: function createTaskByDayRow(data, params) {
            var ellipseCanvas = {
                canvas: [{
                    type: 'ellipse',
                    x: -7.8,
                    y: 4.5,
                    r1: 4.3,
                    color: data.color
                }],
                width: 'auto',
                marginLeft: 24
            };
            var imageColumn = {
                width: 9,
                image: data.image,
                absolutePosition: { x: 34.8, y: 5 }
            };
            return [{
                style: ["daySubRow", params.isWeekend ? "weekendRow" : ""],
                marginLeft: 18,
                columns: [ellipseCanvas, imageColumn, {
                    marginLeft: -10,
                    stack: [{
                        width: "*",
                        style: ["tableText", params.isCompleted ? "completedTask" : ""],
                        text: data.category
                    }, {
                        style: ["tableSubText", "tableGrayText"],
                        marginTop: 1,
                        text: data.customerName + " / " + data.projectName
                    }]
                }]
            }, {
                style: ["total", params.isWeekend ? "totalWeekend" : ""], text: data.total
            }, {
                text: (0, _StringUtils.cutNumberOfTextLines)(data.comment, this.p("limitOfLinesInTextCell")),
                style: ["tableText", "taskComment", params.isWeekend ? "weekendRow" : ""]
            }];
        }
    }, {
        key: 'createTaskByCpRow',
        value: function createTaskByCpRow(data, params) {
            var ellipseCanvas = {
                canvas: [{
                    type: 'ellipse',
                    x: -7.8,
                    y: 4.5,
                    r1: 4.3,
                    color: data.color
                }],
                width: 'auto',
                marginLeft: 19
            };
            var imageColumn = {
                width: 9,
                image: data.image,
                absolutePosition: { x: 34.8, y: 5 }
            };
            return [{
                marginLeft: 23,
                columns: [ellipseCanvas, imageColumn, {
                    marginLeft: -10,
                    width: "*",
                    style: ["tableText", params.isCompleted ? "completedTask" : ""],
                    text: data.category
                }]
            }, {
                style: ["total", params.isWeekend ? "totalWeekend" : ""], text: data.total
            }, {
                style: ["tableText", "taskComment"],
                text: (0, _StringUtils.cutNumberOfTextLines)(data.description, this.p("limitOfLinesInTextCell"))
            }];
        }
    }, {
        key: 'createProjectRow',
        value: function createProjectRow(data) {
            return [{
                marginLeft: 20,
                style: "tableText",
                text: data.category
            }, {
                style: ["total"], text: data.total
            }, ''];
        }
    }, {
        key: 'createCustomerRow',
        value: function createCustomerRow(data) {
            return [{
                marginLeft: 10,
                style: ["tableText", "tableFirstLevel"],
                text: data.category
            }, {
                style: ["total", "firstLevelTotal"], text: data.total
            }, ''];
        }
    }, {
        key: 'createLeaveRow',
        value: function createLeaveRow(data, params) {
            return [{
                style: ["daySubRow", params.isWeekend ? "weekendRow" : ""],
                columns: [{
                    marginTop: 1,
                    width: 8,
                    height: 8,
                    image: data.image
                }, {
                    marginLeft: 3,
                    width: "*",
                    text: data.category
                }]
            }, {
                style: ["total", params.isWeekend ? "totalWeekend" : ""], text: data.total
            }, {
                style: ["tableText", params.isWeekend ? "weekendRow" : ""],
                text: ""
            }];
        }
    }, {
        key: 'createOvertimeRow',
        value: function createOvertimeRow(data, params) {
            return [{
                style: ["daySubRow", params.isWeekend ? "weekendRow" : ""],
                stack: [{
                    style: ["tableText"],
                    text: data.category
                }, {
                    marginTop: params.showAuto ? 3 : 0,
                    style: ["tableSubText", "tableGrayText"],
                    text: data.autoOvertimeMsg
                }]
            }, {
                style: ["total", params.isWeekend ? "totalWeekend" : ""], text: data.total
            }, {
                style: ["tableText", params.isWeekend ? "weekendRow" : ""],
                text: ""
            }];
        }
    }, {
        key: 'createOtherSpentByDayRow',
        value: function createOtherSpentByDayRow(data, params) {
            return [{
                style: ["tableText", "daySubRow", "tableGrayText", params.isWeekend ? "weekendRow" : ""],
                text: data.category
            }, {
                style: ["total", params.isWeekend ? "totalWeekend" : ""], text: data.total
            }, {
                style: ["tableText", params.isWeekend ? "weekendRow" : ""],
                text: ""
            }];
        }
    }, {
        key: 'createOtherSpentByCpRow',
        value: function createOtherSpentByCpRow(data) {
            return [{
                style: ["tableText", "tableGrayText"],
                marginLeft: 10,
                text: data.category
            }, {
                style: ["total"],
                text: data.total
            }, ''];
        }
    }, {
        key: 'createEmptyDataRow',
        value: function createEmptyDataRow(message) {
            return [{
                style: ["tableText", "tableGrayText", "emptyTableRow"],
                text: message,
                colSpan: 3
            }, '', ''];
        }
    }]);

    return PDFDefinitionBuilder;
}(_BasePDFDefinitionBuilder2.default);

exports.default = PDFDefinitionBuilder;
var PDFDefinitionBuilderParameters = exports.PDFDefinitionBuilderParameters = {

    dataTableStyles: {
        tableHeaderStyle: "viewTTHeader",
        tableStyle: 'viewTTRows',
        tableValueStyles: {
            nameValueStyle: 'viewTTRows',
            timeValueStyle: 'coloredTime',
            commentValueStyle: 'viewTTRows'
        }
    },

    dataTableCommonStyles: {
        small: {
            tableStyle: 'dataTableSmall',
            tableValueStyles: {
                dataValueStyle: 'dataValueSmall',
                dataValueWithPercentStyle: 'dataValueWithPercentsSmall',
                dataNameStyle: 'dataNameSmall',
                colorRectangleDimensions: {
                    width: 8,
                    x: 4,
                    y: 1.25,
                    h: 3.8,
                    w: 7
                }
            }
        },
        big: {
            tableStyle: 'dataTable',
            tableValueStyles: {
                dataValueStyle: 'dataValue',
                dataValueWithPercentStyle: 'dataValueWithPercents',
                dataNameStyle: 'dataName',
                colorRectangleDimensions: {
                    width: 10,
                    x: 4,
                    y: 4,
                    h: 5,
                    w: 9
                }
            }
        }
    },

    Portrait: {
        A4: {
            limitOfLinesInTextCell: 62,
            chartImageSize: {
                height: 238,
                width: 515
            }
        },
        Letter: {
            limitOfLinesInTextCell: 56,
            chartImageSize: {
                height: 245,
                width: 530
            }
        }
    },
    Landscape: {
        A4: {
            limitOfLinesInTextCell: 40,
            chartImageSize: {
                height: 290,
                width: 730
            }
        },
        Letter: {
            limitOfLinesInTextCell: 42,
            chartImageSize: {
                height: 310,
                width: 680
            }
        }
    }
};

var PDFDefinitionBuilderStyles = {
    viewTTHeader: {
        fillColor: '#EFEFEF',
        color: '#373737',
        fontSize: 9,
        alignment: 'left',
        margin: [12, 3, 0, 3],
        border: 1
    },
    viewTTRows: {
        fontSize: 9,
        alignment: 'left'
    },

    emptyTableData: {
        color: '#85898e'
    },

    emptyTableRow: {
        marginTop: 5,
        marginBottom: 5,
        alignment: "center"
    },

    tableFirstLevel: {
        bold: true
    },

    tableText: {
        fontSize: 8
    },

    tableSubText: {
        fontSize: 7
    },

    tableGrayText: {
        color: '#8a8a8a'
    },

    daySubRow: {
        marginLeft: 30
    },

    taskByDaysCompleted: {
        marginLeft: 18
    },

    dayRowDescription: {
        marginLeft: 5,
        alignment: 'left',
        fontSize: 7
    },

    dayRowStatus: {
        alignment: "right",
        fontSize: 7,
        marginRight: 3,
        marginTop: 0
    },

    dayRowTotal: {
        fillColor: '#ebf2f9'
    },

    firstLevelTotalWeekend: {
        fillColor: '#e7e8ec'
    },

    leaveMargins: {
        margin: [0, 2, 0, 0]
    },

    total: {
        fillColor: '#f5f9fc',
        alignment: "center",
        fontSize: 8
    },

    totalWeekend: {
        fillColor: '#EEEFF2'
    },

    firstLevelTotal: {
        fillColor: '#ebf2f9',
        bold: true
    },

    weekendRow: {
        fillColor: '#f4f5f7'
    },

    approved: {
        color: '#61a861'
    },
    notReady: {
        color: '#999ea3'
    },
    ready: {
        color: '#5c5e62'
    },
    rejected: {
        color: '#e85a34'
    },

    completedTask: {
        color: '#716e6e'
    },

    taskComment: {
        color: '#999ea3'
    },

    coloredTime: {
        fillColor: '#f5f9fc',
        fontSize: 9,
        alignment: 'center'
    },

    coloredBoldTime: {
        bold: true,
        fillColor: '#ebf2f9'
    },

    viewTTtotalsReported: {
        alignment: 'right'
    },

    viewTTtotalsScheduled: {
        alignment: 'right'
    },

    viewTTtotalsDiffLess: {
        color: '#e45600',
        alignment: 'right'
    },

    viewTTtotalsDiffMore: {
        color: '#4C8A54',
        alignment: 'right'
    },

    viewTTtotalsTimeTable: {
        fontSize: 9
    },

    viewTTtotalsSpent: {
        fontSize: 10,
        bold: true
    },

    viewTTtotalsSpentValue: {
        fontSize: 17
    },

    viewTTtotalsOf: {
        fontSize: 10
    },

    viewTTLine: {
        marginTop: 6
    },

    viewTTTotalLabel: {
        fontSize: 10
    },

    viewTTTotalValue: {
        fontSize: 10,
        bold: true
    },

    viewTTTotalSubValue: {
        fontSize: 10
    },

    viewTTLeaveTotal: {
        fontSize: 10
    },

    viewChartBy: {
        fontSize: 10
    },

    footerTable: {
        fontSize: 9
    },

    footerSignature: {
        alignment: 'left',
        color: '#3D3D3D',
        marginBottom: 5
    },
    footerSignatureSeparator: {
        marginBottom: 5
    },
    footerPageCount: {
        alignment: 'right',
        color: '#6A6A6A',
        fontSize: 7
    }
};

var leaveTotalColumnLayout = {
    hLineWidth: function hLineWidth(i) {
        return i === 1 ? 0.5 : 0;
    },
    vLineWidth: function vLineWidth() {
        return 0;
    },
    hLineColor: function hLineColor() {
        return '#afb4b9';
    },
    vLineColor: function vLineColor() {
        return 0;
    }
};

/***/ }),
/* 1571 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _ChartPDFParametersFormattingStrategy = __webpack_require__(245);

var _ChartPDFParametersFormattingStrategy2 = _interopRequireDefault(_ChartPDFParametersFormattingStrategy);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _UserNameFormat = __webpack_require__(17);

var _UserNameFormat2 = _interopRequireDefault(_UserNameFormat);

var _ChartPDFDateRangeFormattingStrategy = __webpack_require__(247);

var _ChartPDFDateRangeFormattingStrategy2 = _interopRequireDefault(_ChartPDFDateRangeFormattingStrategy);

var _ATReportParamsStringBuilder = __webpack_require__(52);

var _ATReportParamsStringBuilder2 = _interopRequireDefault(_ATReportParamsStringBuilder);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PDFParametersFormattingStrategy = function (_ChartPDFParametersFo) {
    _inherits(PDFParametersFormattingStrategy, _ChartPDFParametersFo);

    function PDFParametersFormattingStrategy() {
        _classCallCheck(this, PDFParametersFormattingStrategy);

        return _possibleConstructorReturn(this, (PDFParametersFormattingStrategy.__proto__ || Object.getPrototypeOf(PDFParametersFormattingStrategy)).apply(this, arguments));
    }

    _createClass(PDFParametersFormattingStrategy, [{
        key: 'init',
        value: function init(selectorsData, dateFormat, dateFormatForFile) {
            _get(PDFParametersFormattingStrategy.prototype.__proto__ || Object.getPrototypeOf(PDFParametersFormattingStrategy.prototype), 'init', this).call(this, selectorsData, dateFormat, dateFormatForFile, ATReportsStore.getReportAuthorizationInfo(), _ATReportParamsStringBuilder2.default);
            return this;
        }
    }, {
        key: 'createDateParametersFormattingStrategy',
        value: function createDateParametersFormattingStrategy(dateFormat, dateFormatForFile) {
            return new _ChartPDFDateRangeFormattingStrategy2.default(dateFormat, dateFormatForFile);
        }
    }, {
        key: 'formatChartPDFFilterInformation',
        value: function formatChartPDFFilterInformation(selectedParameters) {
            var statusesFilter = ViewTTPageUtils.makeStatusFilterToDisplay(selectedParameters.statuses);
            return {
                firstRow: this.parametersFormatter.formatCustomersAndProjectsSelection(selectedParameters.hierarchicalSelectorsParameters.customersProjectsSelection),
                secondRow: _.isNull(statusesFilter) ? "" : this.parametersFormatter.formatStatusesSelection(statusesFilter)
            };
        }
    }, {
        key: 'formatChartPDFFilterInformation',
        value: function formatChartPDFFilterInformation(selectedParameters) {
            var statusesFilter = ViewTTPageUtils.makeStatusFilterToDisplay(selectedParameters.statuses);
            return {
                firstRow: this.parametersFormatter.formatCustomersAndProjectsSelection(selectedParameters.hierarchicalSelectorsParameters.customersProjectsSelection),
                secondRow: _.isNull(statusesFilter) ? "" : this.parametersFormatter.formatStatusesSelection(statusesFilter)
            };
        }
    }, {
        key: 'formatChartPDFFileName',
        value: function formatChartPDFFileName(selectedParameters) {
            var fileNameParts = [];
            var user = selectedParameters.user;
            var formattedName = _UserNameFormat2.default.formatFML(user.firstName, user.lastName, user.middleName);
            fileNameParts.push(formattedName);
            fileNameParts.push(this.dateParametersFormattingStrategy.formatDateForFileName(selectedParameters.dateParameters));
            return _messageResource2.default.getMessage('view_tt.pdf.file_name', fileNameParts); /*.replace(/[^a-z0-9]/gi, '_').toLowerCase()*/
        }
    }, {
        key: 'formatChartPDFHeaderTitle',
        value: function formatChartPDFHeaderTitle(selectedParameters) {
            var user = selectedParameters.user;
            var formattedName = _UserNameFormat2.default.formatFML(user.firstName, user.lastName, user.middleName);
            return _messageResource2.default.getMessage('view_tt.pdf.header', [formattedName]);
        }
    }]);

    return PDFParametersFormattingStrategy;
}(_ChartPDFParametersFormattingStrategy2.default);

exports.default = PDFParametersFormattingStrategy;

/***/ }),
/* 1572 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _ViewByDaysTaskRow = __webpack_require__(1573);

var _ViewByDaysTaskRow2 = _interopRequireDefault(_ViewByDaysTaskRow);

var _ConfigPanel = __webpack_require__(1575);

var _ConfigPanel2 = _interopRequireDefault(_ConfigPanel);

var _DayRow = __webpack_require__(1577);

var _DayRow2 = _interopRequireDefault(_DayRow);

var _CustomerRow = __webpack_require__(1579);

var _CustomerRow2 = _interopRequireDefault(_CustomerRow);

var _OvertimeRow = __webpack_require__(1580);

var _OvertimeRow2 = _interopRequireDefault(_OvertimeRow);

var _ViewByDaysOtherSpentRow = __webpack_require__(1581);

var _ViewByDaysOtherSpentRow2 = _interopRequireDefault(_ViewByDaysOtherSpentRow);

var _ViewByCPTaskRow = __webpack_require__(1582);

var _ViewByCPTaskRow2 = _interopRequireDefault(_ViewByCPTaskRow);

var _ProjectRow = __webpack_require__(1583);

var _ProjectRow2 = _interopRequireDefault(_ProjectRow);

var _ViewByCPOtherSpentRow = __webpack_require__(1584);

var _ViewByCPOtherSpentRow2 = _interopRequireDefault(_ViewByCPOtherSpentRow);

var _LeaveRow = __webpack_require__(1585);

var _LeaveRow2 = _interopRequireDefault(_LeaveRow);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _LoadingMoire = __webpack_require__(92);

var _LoadingMoire2 = _interopRequireDefault(_LoadingMoire);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _ViewTTStore = __webpack_require__(73);

var _ViewTTStore2 = _interopRequireDefault(_ViewTTStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DetailsTable = function (_TemplateView) {
    _inherits(DetailsTable, _TemplateView);

    function DetailsTable() {
        _classCallCheck(this, DetailsTable);

        var _this = _possibleConstructorReturn(this, (DetailsTable.__proto__ || Object.getPrototypeOf(DetailsTable)).call(this));

        _this.state = {
            selectedTaskId: null
        };

        _this.onStatePropertyChanged('selectedTaskId', function (selectedTaskId) {
            return _this._updateSelectedTaskId(selectedTaskId);
        });
        return _this;
    }

    _createClass(DetailsTable, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return "<div class='detailsTable'>" + "  <div class='title'><%=titleLabel%></div>" + "  <div class='configPanelContainer'></div>" + "  <div class='dayRowsContainer'>" + "    <table class='dayRows display-for-print' cellspacing='0' cellpadding='0'></table>" + "    <div class='noDayRowsLabel'><%=noDayRowsLabel%></div>" + "  </div>" + "  <div class='cpRowsContainer'>" + "    <table class='cpRows display-for-print' cellspacing='0' cellpadding='0'></table>" + "    <div class='noCPRowsLabel'><%-noCPRowsLabel%></div>" + "  </div>" + "</div>";
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            var _this2 = this;

            this.$configPanelContainer = this.find(".configPanelContainer");
            this.$dayRowsTable = this.find(".dayRows");
            this.$cpRowsTable = this.find(".cpRows");
            this.configPanel = new _ConfigPanel2.default().init(this.$configPanelContainer);
            this.loadingMoire = new _LoadingMoire2.default(ViewTTPageUtils.SPINNER_SETTINGS).init(this.$el);
            this._rememberDetailsTableConfig();

            (0, _jquery2.default)(document).on("viewTT.beginLoadData", function () {
                return _this2.disable();
            });

            (0, _jquery2.default)(document).on("viewTT.endLoadData", function () {
                return _this2.enable();
            });

            (0, _jquery2.default)(_ViewTTStore2.default).on("dataChange", function () {
                return _this2.update();
            });

            (0, _jquery2.default)(_ViewTTStore2.default).on("detailsTableConfigChange", function () {
                _this2.update();
                (0, _jquery2.default)(document).trigger("viewTT.detailsTable.update");
                _this2._rememberDetailsTableConfig();
            });
        }
    }, {
        key: 'update',
        value: function update() {
            this._updateVisibilityClasses();

            this.$dayRowsTable.empty();
            this.$cpRowsTable.empty();

            var presentDataByDays = ViewTTPageUtils.tablePresentDataByDays();
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = presentDataByDays[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var row = _step.value;

                    switch (row.type) {
                        case ViewTTPageUtils.RowType.DAY:
                            new _DayRow2.default({ dayModel: row.dayModel }).init(this.$dayRowsTable);
                            break;
                        case ViewTTPageUtils.RowType.LEAVE:
                            new _LeaveRow2.default(this.$dayRowsTable, row.dayModel, row.last).init();
                            break;
                        case ViewTTPageUtils.RowType.TASK_BY_DAY:
                            new _ViewByDaysTaskRow2.default({
                                dayModel: row.dayModel,
                                taskModel: row.taskModel,
                                last: row.last
                            }).init(this.$dayRowsTable);
                            break;
                        case ViewTTPageUtils.RowType.OTHER_SPENT_BY_DAY:
                            new _ViewByDaysOtherSpentRow2.default(this.$dayRowsTable, row.dayModel, row.last).init();
                            break;
                        case ViewTTPageUtils.RowType.OVERTIME:
                            new _OvertimeRow2.default(this.$dayRowsTable, row.dayModel, row.last).init();
                            break;
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            var presentDataByCP = ViewTTPageUtils.tablePresentDataByCP();
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = presentDataByCP[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var _row = _step2.value;

                    switch (_row.type) {
                        case ViewTTPageUtils.RowType.CUSTOMER:
                            new _CustomerRow2.default({ customerModel: _row.customerModel }).init(this.$cpRowsTable);
                            break;
                        case ViewTTPageUtils.RowType.OTHER_SPENT_BY_CP:
                            new _ViewByCPOtherSpentRow2.default(this.$cpRowsTable, _row.otherTTInfo).init();
                            break;
                        case ViewTTPageUtils.RowType.PROJECT:
                            new _ProjectRow2.default(this.$cpRowsTable, _row.projectModel).init();
                            break;
                        case ViewTTPageUtils.RowType.TASK_BY_CP:
                            var taskModel = _row.taskModel,
                                last = _row.last;

                            new _ViewByCPTaskRow2.default({ taskModel: taskModel, last: last }).init(this.$cpRowsTable);
                            break;
                    }
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }

            this.$el.toggleClass("hasDayRows", presentDataByDays.length > 0);
            this.$el.toggleClass("hasCPRows", presentDataByCP.length > 0);
            this.$el.toggleClass("otherUser", _ViewTTStore2.default.getSelectedUserId() !== _ViewTTStore2.default.getViewerId());

            this._updateSelectedTaskId(this.state.selectedTaskId);

            (0, _jquery2.default)(document).trigger("viewTT.detailsTable.update");
        }
    }, {
        key: 'messageKeys',
        value: function messageKeys() {
            return {
                titleLabel: "view_tt.details_table.title",
                noDayRowsLabel: "view_tt.details_table.no_day_rows",
                noCPRowsLabel: "view_tt.details_table.no_cp_rows"
            };
        }
    }, {
        key: 'disable',
        value: function disable() {
            this.$el.attr("disabled", true);
            this.loadingMoire.show();
        }
    }, {
        key: 'enable',
        value: function enable() {
            this.$el.attr("disabled", false);
            this.loadingMoire.hide();
        }
    }, {
        key: '_updateVisibilityClasses',
        value: function _updateVisibilityClasses() {
            var detailsTableConfig = _ViewTTStore2.default.getDetailsTableConfig();
            this.$el.toggleClass("viewByDays", detailsTableConfig.viewByDays);
            this.$el.toggleClass("viewByCP", !detailsTableConfig.viewByDays);
            this.$el.toggleClass("showTasks", detailsTableConfig.showTasks);
            this.$el.toggleClass("hideTasks", !detailsTableConfig.showTasks);
        }
    }, {
        key: '_rememberDetailsTableConfig',
        value: function _rememberDetailsTableConfig() {
            this.prevDetailsTableConfig = _underscore2.default.clone(_ViewTTStore2.default.getDetailsTableConfig());
        }
    }, {
        key: '_updateSelectedTaskId',
        value: function _updateSelectedTaskId(taskId) {
            this.find(".taskRow.editing").removeClass("editing");
            if (taskId) {
                this.find(".task" + taskId).addClass("editing");
            }
        }
    }]);

    return DetailsTable;
}(_TemplateView3.default);

exports.default = DetailsTable;

/***/ }),
/* 1573 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _TaskRow2 = __webpack_require__(843);

var _TaskRow3 = _interopRequireDefault(_TaskRow2);

var _CommentsNumberContainer = __webpack_require__(251);

var _CommentsNumberContainer2 = _interopRequireDefault(_CommentsNumberContainer);

var _utils = __webpack_require__(6);

var _WorkflowStatusIcon = __webpack_require__(241);

var _WorkflowStatusIcon2 = _interopRequireDefault(_WorkflowStatusIcon);

var _selectors = __webpack_require__(57);

var _ViewTTStore = __webpack_require__(73);

var _ViewTTStore2 = _interopRequireDefault(_ViewTTStore);

var _CustomerStore = __webpack_require__(65);

var _CustomerStore2 = _interopRequireDefault(_CustomerStore);

var _ProjectStore = __webpack_require__(59);

var _ProjectStore2 = _interopRequireDefault(_ProjectStore);

var _TruncatedTextView = __webpack_require__(496);

var _TruncatedTextView2 = _interopRequireDefault(_TruncatedTextView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ViewByDaysTaskRow = function (_TaskRow) {
    _inherits(ViewByDaysTaskRow, _TaskRow);

    function ViewByDaysTaskRow() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            _ref$dayModel = _ref.dayModel,
            dayModel = _ref$dayModel === undefined ? null : _ref$dayModel,
            _ref$taskModel = _ref.taskModel,
            taskModel = _ref$taskModel === undefined ? null : _ref$taskModel,
            _ref$last = _ref.last,
            last = _ref$last === undefined ? false : _ref$last;

        _classCallCheck(this, ViewByDaysTaskRow);

        var _this = _possibleConstructorReturn(this, (ViewByDaysTaskRow.__proto__ || Object.getPrototypeOf(ViewByDaysTaskRow)).call(this, { taskModel: taskModel, last: last }));

        _this.params = _extends({}, _this.params, {
            dayModel: dayModel
        });
        return _this;
    }

    _createClass(ViewByDaysTaskRow, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return "<tr class='taskRow'>" + "  <td class='nameColumn'>" + "    <div class='subContainer'>" + "      <div class='iconNameContainer'>" + "        <div class='iconContainer'></div>" + "        <div class='name'><%-name%></div>" + "        <div class='subtitle'><%-customerName%> / <%-projectName%></div>" + "      </div>" + "      <div class='commentsNumberPlaceholder'></div>" + "    </div>" + "  </td>" + "  <td class='totalColumn'><div class='subContainer'><%-total%></div></td>" + "  <td class='detailsColumn'><div class='subContainer'></div></td>" + "</tr>";
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            _get(ViewByDaysTaskRow.prototype.__proto__ || Object.getPrototypeOf(ViewByDaysTaskRow.prototype), 'afterRender', this).call(this);

            var task = _ViewTTStore2.default.getTask(this.params.taskModel.taskId);
            new _WorkflowStatusIcon2.default(this.find(".iconContainer"), (0, _utils.unsafe_selectWithState)(function (state) {
                return (0, _selectors.selectStatusByTask)(state, task);
            })).init();
            this.$el.toggleClass("locked", this.params.dayModel.locked);
            this.$el.toggleClass("nonWorking", this.params.dayModel.workdayDuration === 0);

            this.commentsNumber = new _CommentsNumberContainer2.default().init(this.find('.commentsNumberPlaceholder'));
            this.commentsNumber.setState({
                commentsNumber: task.commentsNumber
            });

            new _TruncatedTextView2.default({ text: this.params.taskModel.comment, lineCount: 5 }).init(this.find('.detailsColumn > .subContainer'));
        }
    }, {
        key: 'templateModel',
        value: function templateModel() {
            var task = _ViewTTStore2.default.getTask(this.params.taskModel.taskId);
            return {
                name: task.name,
                customerName: _ViewTTStore2.default.getCustomer(task.customerId).name,
                projectName: _ViewTTStore2.default.getProject(task.projectId).name,
                total: UserTime.formatTimeWithDigitSeparator(this.params.taskModel.spent)
            };
        }
    }]);

    return ViewByDaysTaskRow;
}(_TaskRow3.default);

exports.default = ViewByDaysTaskRow;

/***/ }),
/* 1574 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var TaskTooltip = function TaskTooltip($containerEl) {
    Tooltip.call(this, $containerEl);
};

TaskTooltip.prototype = _.create(Tooltip.prototype, {
    html: "<div id='viewTTPageDetailsTableTaskTooltip' class='viewTTPageDetailsTableTaskTooltip noprint'><%-labelText%></div>",

    messageKeys: function messageKeys() {
        return {
            labelText: "common.tooltip.not_assigned_task"
        };
    }
});

TaskTooltip.getInstance = function () {
    if (!this._instance) this._instance = new this($("body")).init();
    return this._instance;
};

exports.default = TaskTooltip;

/***/ }),
/* 1575 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _SortButton = __webpack_require__(1576);

var _SortButton2 = _interopRequireDefault(_SortButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ConfigPanel = function (_TemplateView) {
    _inherits(ConfigPanel, _TemplateView);

    function ConfigPanel() {
        _classCallCheck(this, ConfigPanel);

        return _possibleConstructorReturn(this, (ConfigPanel.__proto__ || Object.getPrototypeOf(ConfigPanel)).apply(this, arguments));
    }

    _createClass(ConfigPanel, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return "<div class='configPanel'>" + "  <span class='viewByLabel'><%=viewByLabel%></span>" + "  <div class='viewByDaysContainer'></div>" + "  <span class='separator'></span>" + "  <div class='viewByCPContainer'></div>" + "  <div class='showTasksContainer'>" + "    <label><input type='checkbox' class='showTasks'/><%-showTasksLabel%></label>" + "  </div>" + "</div>";
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            this.configModel = ViewTTStore.getDetailsTableConfig();

            this.viewByDaysButton = new _SortButton2.default({
                active: this.configModel.viewByDays,
                asc: this.configModel.asc,
                titleLabel: "view_tt.details_table.view_by_days",
                onClick: this.bind(this._onViewByDaysButtonClick)
            }).init(this.find(".viewByDaysContainer"));

            this.viewByCPButton = new _SortButton2.default({
                active: !this.configModel.viewByDays,
                asc: this.configModel.asc,
                titleLabel: "view_tt.details_table.view_by_cp",
                onClick: this.bind(this._onViewByCPButtonClick) }).init(this.find(".viewByCPContainer"));

            this.$showTasksCheckbox = this.findAndBindClick(".showTasks", this._onShowTasksCheckboxClick);
            if (this.configModel.showTasks) this.$showTasksCheckbox.attr("checked", true);else this.$showTasksCheckbox.removeAttr("checked");
        }
    }, {
        key: 'messageKeys',
        value: function messageKeys() {
            return {
                viewByLabel: "view_tt.details_table.view_by",
                showTasksLabel: "view_tt.details_table.show_tasks"
            };
        }
    }, {
        key: '_onViewByDaysButtonClick',
        value: function _onViewByDaysButtonClick() {
            this.configModel.viewByDays = true;
            this.configModel.asc = this.viewByDaysButton.isAsc();
            this.viewByCPButton.setActive(false);
            this._triggerChange();
        }
    }, {
        key: '_onViewByCPButtonClick',
        value: function _onViewByCPButtonClick() {
            this.configModel.viewByDays = false;
            this.configModel.asc = this.viewByCPButton.isAsc();
            this.viewByDaysButton.setActive(false);
            this._triggerChange();
        }
    }, {
        key: '_onShowTasksCheckboxClick',
        value: function _onShowTasksCheckboxClick() {
            this.configModel.showTasks = !!this.$showTasksCheckbox.attr("checked");
            this._triggerChange();
        }
    }, {
        key: '_triggerChange',
        value: function _triggerChange() {
            $(document).trigger("viewTT.detailsTable.configPanel.change", this.configModel);
        }
    }]);

    return ConfigPanel;
}(_TemplateView3.default);

exports.default = ConfigPanel;

/***/ }),
/* 1576 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SortButton = function (_TemplateView) {
    _inherits(SortButton, _TemplateView);

    function SortButton() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            _ref$active = _ref.active,
            active = _ref$active === undefined ? false : _ref$active,
            _ref$asc = _ref.asc,
            asc = _ref$asc === undefined ? false : _ref$asc,
            _ref$titleLabel = _ref.titleLabel,
            titleLabel = _ref$titleLabel === undefined ? '' : _ref$titleLabel,
            _ref$onClick = _ref.onClick,
            onClick = _ref$onClick === undefined ? function () {} : _ref$onClick;

        _classCallCheck(this, SortButton);

        var _this = _possibleConstructorReturn(this, (SortButton.__proto__ || Object.getPrototypeOf(SortButton)).call(this));

        _this.params = {
            active: active,
            asc: asc,
            titleLabel: titleLabel,
            onClick: onClick
        };
        return _this;
    }

    _createClass(SortButton, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return "<div class='sortButton'>" + "  <span class='titleLabel'><%-titleLabel%></span>" + "  <div class='arrowContainer'>" + "    <div class='ascArrow'><img src='<%=ascArrow%>'/> <span class='for-print-only'>&darr;</span></div>" + "    <div class='descArrow'><img src='<%=descArrow%>'/> <span class='for-print-only'>&uarr;</span></div>" + "  </div>" + "</div>";
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            this.bindClick(this._onClick);
        }
    }, {
        key: 'update',
        value: function update() {
            this.$el.toggleClass("active", this.params.active);
            this.$el.toggleClass("asc", this.params.asc);
            this.$el.toggleClass("desc", !this.params.asc);
        }
    }, {
        key: 'templateModel',
        value: function templateModel() {
            return {
                ascArrow: atImgPath("arrow-down.png"),
                descArrow: atImgPath("arrow-up.png")
            };
        }
    }, {
        key: 'messageKeys',
        value: function messageKeys() {
            return { titleLabel: this.params.titleLabel };
        }
    }, {
        key: 'isActive',
        value: function isActive() {
            return this.params.active;
        }
    }, {
        key: 'setActive',
        value: function setActive(active) {
            this.params.active = active;
            this.update();
        }
    }, {
        key: 'isAsc',
        value: function isAsc() {
            return this.params.asc;
        }
    }, {
        key: '_onClick',
        value: function _onClick() {
            if (!this.params.active) this.params.active = true;else this.params.asc = !this.params.asc;

            this.update();
            this.params.onClick();
        }
    }]);

    return SortButton;
}(_TemplateView3.default);

exports.default = SortButton;

/***/ }),
/* 1577 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _Tooltip = __webpack_require__(1578);

var _Tooltip2 = _interopRequireDefault(_Tooltip);

var _date_format = __webpack_require__(16);

var _user_time = __webpack_require__(30);

var _user_time2 = _interopRequireDefault(_user_time);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _LeaveTypeStore = __webpack_require__(124);

var _LeaveTypeStore2 = _interopRequireDefault(_LeaveTypeStore);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DayRow = function (_TemplateView) {
    _inherits(DayRow, _TemplateView);

    function DayRow() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            _ref$dayModel = _ref.dayModel,
            dayModel = _ref$dayModel === undefined ? null : _ref$dayModel;

        _classCallCheck(this, DayRow);

        var _this = _possibleConstructorReturn(this, (DayRow.__proto__ || Object.getPrototypeOf(DayRow)).call(this));

        _this.params = {
            dayModel: dayModel
        };
        return _this;
    }

    _createClass(DayRow, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return "<tr class='dayRow'>" + "  <td class='nameColumn'>" + "    <table cellspacing='0' cellpadding='0'>" + "      <tr>" + "        <td class='dateColumn'>" + "          <div class='subContainer'>" + "            <span><%-date%></span>" + "            <div class='separator'/>" + "            <span class='nonWorkingLabel'/>" + "          </div>" + "        </td>" + "        <td class='approvedStatusColumn'>" + "          <div class='subContainer'>" + "            <span class='autoApprovedLabel'><%=autoApprovedLabel%></span>" + "            <span class='approvedLabel'><%=approvedLabel%></span>" + "            <span class='notReadyLabel'><%=notReadyLabel%></span>" + "            <span class='readyLabel'><%=readyLabel%></span>" + "            <span class='rejectedLabel'><%=rejectedLabel%></span>" + "            <span class='lockedLabel for-print-only'>Locked</span>" + "          </div>" + "        </td>" + "      </tr>" + "    </table>" + "  </td>" + "  <td class='totalColumn'><div class='subContainer'><%-total%></div></td>" + "  <td class='detailsColumn'>" + "    <table cellspacing='0' cellpadding='0'>" + "      <tr>" + "        <td class='workingTimeColumn'>" + "          <div class='subContainer'>" + "            <span><%=workingTimeLabel%>:</span>" + "            <span class='workingTime'><%-workingTime%></span>" + "          </div>" + "        </td>" + "        <td class='overtimeColumn'>" + "          <div class='subContainer'>" + "            <span class='overtimeLabel'><%=overtimeLabel%>:</span>" + "            <span class='overtime'><%-overtime%></span>" + "          </div>" + "        </td>" + "        <td class='leaveTimeColumn'>" + "          <div class='subContainer'>" + "            <span class='leaveTimeName'><%-leaveTimeName%>:</span>" + "            <span class='leaveTime'><%-leaveTime%></span>" + "          </div>" + "        </td>" + "      </tr>" + "    </table>" + "  </td>" + "</tr>";
        }
    }, {
        key: 'beforeRender',
        value: function beforeRender() {
            this.leaveTime = this.params.dayModel.leave && this.params.dayModel.leave.leaveTime || 0;
            if (this.params.dayModel.overtime) this.overtime = _underscore2.default.isNumber(this.params.dayModel.overtime.reported) ? this.params.dayModel.overtime.reported : this.params.dayModel.overtime.auto;else this.overtime = 0;
            this.workingTime = this.params.dayModel.totalWorkingTime;
            this.totalTime = this.leaveTime + this.workingTime;
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            var nonWorking = this.params.dayModel.workdayDuration === 0;
            if (nonWorking) {
                var corporateDayName = this.params.dayModel.corporateDayName ? this.params.dayModel.corporateDayName + ' ' : '';
                this.find('.nonWorkingLabel').text(corporateDayName + _messageResource2.default.getMessage('view_tt.details_table.day_row.nonworking'));
            }
            this.find('.dateColumn .separator').toggle(nonWorking && !!this.params.dayModel.corporateDayName);

            this.$el.toggleClass("autoApproved", this.params.dayModel.approvalStatus === EffectiveWeekApprovalStatus.AUTO_APPROVED);
            this.$el.toggleClass("approved", this.params.dayModel.approvalStatus === EffectiveWeekApprovalStatus.APPROVED);
            this.$el.toggleClass("notReady", this.params.dayModel.approvalStatus === EffectiveWeekApprovalStatus.NOT_READY);
            this.$el.toggleClass("ready", this.params.dayModel.approvalStatus === EffectiveWeekApprovalStatus.READY);
            this.$el.toggleClass("rejected", this.params.dayModel.approvalStatus === EffectiveWeekApprovalStatus.REJECTED);
            this.$el.toggleClass("locked", this.params.dayModel.locked);
            this.$el.toggleClass("nonWorking", nonWorking);
            this.$el.toggleClass("noOvertime", !_underscore2.default.isObject(this.params.dayModel.overtime));
            this.$el.toggleClass("noLeaves", !_underscore2.default.isObject(this.params.dayModel.leave));
            this.$el.toggleClass("leaveTimeZero", this.leaveTime === 0);
            this.$el.toggleClass("workingTimeZero", this.workingTime === 0);
            this.$el.toggleClass("totalTimeZero", this.workingTime + this.leaveTime === 0);
            this.$el.toggleClass("overtimePositive", this.overtime > 0);
            this.$el.toggleClass("overtimeNegative", this.overtime < 0);
            this.$el.toggleClass("overtimeZero", this.overtime === 0);

            this.tooltip = _Tooltip2.default.getInstance();
            this.tooltip.subscribeToMouseEvents(this.$el, this.bind(this._beforeTooltipShow));

            this.$el.click(this.bind(this._onClick));
        }
    }, {
        key: 'templateModel',
        value: function templateModel() {
            return {
                date: DayRow.tableDateFormat.formatDate(this.params.dayModel.date),
                name: this.params.dayModel.name,
                total: _user_time2.default.formatTimeWithDigitSeparator(this.totalTime),
                workingTime: this.workingTime ? _user_time2.default.formatTimeWithDigitSeparator(this.workingTime) : "--",
                leaveTime: this.leaveTime ? _user_time2.default.formatTimeWithDigitSeparator(this.leaveTime) : "--",
                overtime: this.overtime ? _user_time2.default.formatTimeWithDigitSeparator(this.overtime) : "--",
                leaveTimeName: this.leaveTime ? _LeaveTypeStore2.default.getLeaveType(this.params.dayModel.leave.leaveTypeId).name : _messageResource2.default.getMessage("view_tt.details_table.day_row.leave_time")
            };
        }
    }, {
        key: 'messageKeys',
        value: function messageKeys() {
            return {
                autoApprovedLabel: "view_tt.details_table.day_row.auto_approved",
                approvedLabel: "view_tt.details_table.day_row.approved",
                notReadyLabel: "view_tt.details_table.day_row.not_ready",
                readyLabel: "view_tt.details_table.day_row.ready",
                rejectedLabel: "view_tt.details_table.day_row.rejected",
                workingTimeLabel: "view_tt.details_table.day_row.working_time",
                overtimeLabel: "overtime.overtime"
            };
        }
    }, {
        key: '_onClick',
        value: function _onClick() {
            window.location.href = ViewTTPageUtils.createEnterTTURL(this.params.dayModel.date);
        }
    }, {
        key: '_beforeTooltipShow',
        value: function _beforeTooltipShow() {
            this.tooltip.updateDate(this.params.dayModel.date);
        }
    }]);

    return DayRow;
}(_TemplateView3.default);

exports.default = DayRow;


DayRow.tableDateFormat = new _date_format.DateFormat("MMM dd, EEE");

/***/ }),
/* 1578 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _date_format = __webpack_require__(16);

var _ViewTTStore = __webpack_require__(73);

var _ViewTTStore2 = _interopRequireDefault(_ViewTTStore);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _Tooltip = __webpack_require__(183);

var _Tooltip2 = _interopRequireDefault(_Tooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Tooltip = function Tooltip($containerEl) {
    _Tooltip2.default.call(this, $containerEl);
};

Tooltip.prototype = _.create(_Tooltip2.default.prototype, {
    html: "<div id='viewTTPageDetailsTableDayRowTooltip'></div>",

    updateDate: function updateDate(date) {
        if (!this.date || this.date.getTime() != date.getTime()) {
            this.date = date;
            var weekStart = this.date.getWeekStartDate(_ViewTTStore2.default.getWeekStartDay());
            var weekEnd = weekStart.getNDaysAfter(6);
            var weekStartStr = Tooltip.dateFormat.formatDate(weekStart);
            var weekEndStr = Tooltip.dateFormat.formatDate(weekEnd);
            this.$el.html(_messageResource2.default.getMessage("view_tt.details_table.tooltip_html", [weekStartStr, weekEndStr]));
        }
    }
});

Tooltip.getInstance = function () {
    if (!this._instance) this._instance = new this($("body")).init();
    return this._instance;
};

Tooltip.dateFormat = new _date_format.DateFormat("MMM dd");

exports.default = Tooltip;

/***/ }),
/* 1579 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CustomerRow = function (_TemplateView) {
    _inherits(CustomerRow, _TemplateView);

    function CustomerRow() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            _ref$customerModel = _ref.customerModel,
            customerModel = _ref$customerModel === undefined ? null : _ref$customerModel;

        _classCallCheck(this, CustomerRow);

        var _this = _possibleConstructorReturn(this, (CustomerRow.__proto__ || Object.getPrototypeOf(CustomerRow)).call(this));

        _this.params = {
            customerModel: customerModel
        };
        return _this;
    }

    _createClass(CustomerRow, [{
        key: "templateHtml",
        value: function templateHtml() {
            return "" + "<tr class='customerRow'>" + "  <td class='nameColumn'><div class='subContainer'><%-name%></div></td>" + "  <td class='totalColumn'><div class='subContainer'><%-total%></div></td>" + "  <td class='detailsColumn'></td>" + "</tr>";
        }
    }, {
        key: "templateModel",
        value: function templateModel() {
            return {
                name: ViewTTStore.getCustomer(this.params.customerModel.customerId).name,
                total: UserTime.formatTimeWithDigitSeparator(this.params.customerModel.totalSpent)
            };
        }
    }]);

    return CustomerRow;
}(_TemplateView3.default);

exports.default = CustomerRow;

/***/ }),
/* 1580 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var OvertimeRow = function OvertimeRow($containerEl, dayModel, last) {
    TemplateView.call(this, $containerEl);
    this.dayModel = dayModel;
    this.last = last;
};

OvertimeRow.prototype = _.create(TemplateView.prototype, {
    html: "<tr class='overtimeRow'>" + "  <td class='nameColumn'>" + "    <div class='subContainer'>" + "      <div class='overtimeLabel'><%=overtimeLabel%></div>" + "      <div class='subtitle'>" + "        <span><%=autoLabel%></span>" + "        <span class='overtimeLabel'><%=overtimeLabel%>:</span>" + "        <span class='totalLabel'><%-autoTotal%></span>" + "      </div>" + "    </div>" + "  </td>" + "  <td class='totalColumn'><div class='subContainer'><%-total%></div></td>" + "  <td class='detailsColumn'></td>" + "</tr>",

    beforeRender: function beforeRender() {
        this.total = _.isNumber(this.dayModel.overtime.reported) ? this.dayModel.overtime.reported : this.dayModel.overtime.auto;
        this.autoTotal = this.dayModel.overtime.auto;
    },

    afterRender: function afterRender() {
        var reported = this.dayModel.overtime.reported;
        var auto = this.dayModel.overtime.auto;

        this.$el.toggleClass("overtimePositive", this.total >= 0);
        this.$el.toggleClass("overtimeNegative", this.total < 0);
        this.$el.toggleClass("showSubtitle", _.isNumber(reported) && _.isNumber(auto) && reported != auto);
        this.$el.toggleClass("locked", this.dayModel.locked);
        this.$el.toggleClass("nonWorking", this.dayModel.workdayDuration == 0);
        this.$el.toggleClass("nonLast", !this.last);
    },

    templateModel: function templateModel() {
        return {
            total: UserTime.formatTimeWithDigitSeparator(this.total),
            autoTotal: UserTime.formatTimeWithDigitSeparator(this.autoTotal)
        };
    },

    messageKeys: function messageKeys() {
        return {
            overtimeLabel: "overtime.overtime",
            autoLabel: "view_tt.details_table.overtime_row.auto"
        };
    }
});

exports.default = OvertimeRow;

/***/ }),
/* 1581 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _OtherSpentRow = __webpack_require__(844);

var _OtherSpentRow2 = _interopRequireDefault(_OtherSpentRow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ViewByDaysOtherSpentRow = function ViewByDaysOtherSpentRow($containerEl, dayModel, last) {
    _OtherSpentRow2.default.call(this, $containerEl, dayModel.otherTTInfo);
    this.dayModel = dayModel;
    this.last = last;
};

ViewByDaysOtherSpentRow.prototype = _.create(_OtherSpentRow2.default.prototype, {
    html: "<tr class='otherSpentRow'>" + "  <td class='nameColumn'><div class='subContainer'><%-otherLabel%></div></td>" + "  <td class='totalColumn'><div class='subContainer'><%-total%></div></td>" + "  <td class='detailsColumn'></td>" + "</tr>",

    afterRender: function afterRender() {
        this.$el.toggleClass("locked", this.dayModel.locked);
        this.$el.toggleClass("nonWorking", this.dayModel.workdayDuration == 0);
        this.$el.toggleClass("nonLast", !this.last);
    },

    templateModel: function templateModel() {
        var baseTemplateModel = this.baseTemplateModel();
        return {
            otherLabel: baseTemplateModel.otherLabel,
            total: baseTemplateModel.total
        };
    }
});

exports.default = ViewByDaysOtherSpentRow;

/***/ }),
/* 1582 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TaskRow2 = __webpack_require__(843);

var _TaskRow3 = _interopRequireDefault(_TaskRow2);

var _user_time = __webpack_require__(30);

var _user_time2 = _interopRequireDefault(_user_time);

var _selectors = __webpack_require__(57);

var _utils = __webpack_require__(6);

var _CommentsNumberContainer = __webpack_require__(251);

var _CommentsNumberContainer2 = _interopRequireDefault(_CommentsNumberContainer);

var _WorkflowStatusIcon = __webpack_require__(241);

var _WorkflowStatusIcon2 = _interopRequireDefault(_WorkflowStatusIcon);

var _ViewTTStore = __webpack_require__(73);

var _ViewTTStore2 = _interopRequireDefault(_ViewTTStore);

var _TruncatedTextView = __webpack_require__(496);

var _TruncatedTextView2 = _interopRequireDefault(_TruncatedTextView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ViewByCPTaskRow = function (_TaskRow) {
    _inherits(ViewByCPTaskRow, _TaskRow);

    function ViewByCPTaskRow() {
        _classCallCheck(this, ViewByCPTaskRow);

        return _possibleConstructorReturn(this, (ViewByCPTaskRow.__proto__ || Object.getPrototypeOf(ViewByCPTaskRow)).apply(this, arguments));
    }

    _createClass(ViewByCPTaskRow, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return "<tr class='taskRow'>" + "  <td class='nameColumn'>" + "    <div class='subContainer'>" + "      <div class='iconNameContainer'>" + "        <div class='iconContainer'></div>" + "        <div class='name'><%-name%></div>" + "      </div>" + "      <div class='commentsNumberPlaceholder'></div>" + "    </div>" + "  </td>" + "  <td class='totalColumn'><div class='subContainer'><%-total%></div></td>" + "  <td class='detailsColumn'><div class='subContainer'></div></td>" + "</tr>";
        }
    }, {
        key: 'templateModel',
        value: function templateModel() {
            var task = _ViewTTStore2.default.getTask(this.params.taskModel.taskId);
            return {
                name: task.name,
                total: _user_time2.default.formatTimeWithDigitSeparator(this.params.taskModel.totalSpent)
            };
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            _TaskRow3.default.prototype.afterRender.call(this);
            var task = _ViewTTStore2.default.getTask(this.params.taskModel.taskId);
            new _WorkflowStatusIcon2.default(this.find(".iconContainer"), (0, _utils.unsafe_selectWithState)(function (state) {
                return (0, _selectors.selectStatusByTask)(state, task);
            })).init();

            this.commentsNumber = new _CommentsNumberContainer2.default().init(this.find('.commentsNumberPlaceholder'));
            this.commentsNumber.setState({ commentsNumber: task.commentsNumber });

            new _TruncatedTextView2.default({ text: task.description, lineCount: 5 }).init(this.find('.detailsColumn > .subContainer'));
        }
    }]);

    return ViewByCPTaskRow;
}(_TaskRow3.default);

exports.default = ViewByCPTaskRow;

/***/ }),
/* 1583 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var ProjectRow = function ProjectRow($containerEl, projectModel) {
    TemplateView.call(this, $containerEl);
    this.projectModel = projectModel;
};

ProjectRow.prototype = _.create(TemplateView.prototype, {
    html: "<tr class='projectRow'>" + "  <td class='nameColumn'><div class='subContainer'><%-name%></div></td>" + "  <td class='totalColumn'><div class='subContainer'><%-total%></div></td>" + "  <td class='detailsColumn'></td>" + "</tr>",

    templateModel: function templateModel() {
        return {
            name: ViewTTStore.getProject(this.projectModel.projectId).name,
            total: UserTime.formatTimeWithDigitSeparator(this.projectModel.totalSpent)
        };
    }
});

exports.default = ProjectRow;

/***/ }),
/* 1584 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _OtherSpentRow = __webpack_require__(844);

var _OtherSpentRow2 = _interopRequireDefault(_OtherSpentRow);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ViewByCPOtherSpentRow = function ViewByCPOtherSpentRow($containerEl, otherTTInfo) {
    _OtherSpentRow2.default.call(this, $containerEl, otherTTInfo);
};

ViewByCPOtherSpentRow.prototype = _.create(_OtherSpentRow2.default.prototype, {
    html: "<tr class='otherSpentRow'>" + "  <td class='nameColumn otherTasksTimeTrackText '><div class='subContainer'><%-otherTaskLabel%></div></td>" + "  <td class='nameColumn otherProjectsTimeTrackText'><div class='subContainer'><%-otherProjectLabel%></div></td>" + "  <td class='totalColumn'><div class='subContainer'><%-total%></div></td>" + "  <td class='detailsColumn'></td>" + "</tr>",

    templateModel: function templateModel() {
        var baseTemplateModel = this.baseTemplateModel();
        return {
            otherTaskLabel: baseTemplateModel.otherLabel,
            otherProjectLabel: _messageResource2.default.getMessage("view_tt.details_table.other_projects_tt"),
            total: baseTemplateModel.total
        };
    }
});

exports.default = ViewByCPOtherSpentRow;

/***/ }),
/* 1585 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var LeaveRow = function LeaveRow($containerEl, dayModel, last) {
    TemplateView.call(this, $containerEl);
    this.dayModel = dayModel;
    this.last = last;
};

LeaveRow.prototype = _.create(TemplateView.prototype, {
    html: "<tr class='leaveRow'>" + "  <td class='nameColumn'>" + "    <div class='subContainer'>" + "      <img class='noprint' src='<%=imageUrl%>'/>" + "      <img class='printImgType for-print-only' src='<%=printImageUrl%>'/>" + "      <span class='name'><%-name%></span>" + "    </div>" + "  </td>" + "  <td class='totalColumn'><div class='subContainer'><%-total%></div></td>" + "  <td class='detailsColumn'></td>" + "</tr>",

    afterRender: function afterRender() {
        this.$el.toggleClass("locked", this.dayModel.locked);
        this.$el.toggleClass("nonWorking", this.dayModel.workdayDuration == 0);
        this.$el.toggleClass("nonLast", !this.last);
    },

    templateModel: function templateModel() {
        var leaveType = LeaveTypeStore.getLeaveType(this.dayModel.leave.leaveTypeId);
        return {
            imageUrl: getLeaveTypeIconPath(leaveType.iconId),
            printImageUrl: getLeaveTypePrintIconPath(leaveType.iconId),
            name: leaveType.name,
            total: UserTime.formatTimeWithDigitSeparator(this.dayModel.leave.leaveTime)
        };
    }
});

exports.default = LeaveRow;

/***/ }),
/* 1586 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = FilterController;

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _SimpleTooltip = __webpack_require__(36);

var _SimpleTooltip2 = _interopRequireDefault(_SimpleTooltip);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _FilterDialog = __webpack_require__(1587);

var _FilterDialog2 = _interopRequireDefault(_FilterDialog);

var _DropdownDialog = __webpack_require__(185);

var _DropdownDialog2 = _interopRequireDefault(_DropdownDialog);

var _ViewTTStore = __webpack_require__(73);

var _ViewTTStore2 = _interopRequireDefault(_ViewTTStore);

var _features = __webpack_require__(22);

var _constants = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function FilterController() {};

FilterController.parseDateRangeConfig = function (dateRangeConfig) {
    return DateRangeSelectorController.prototype.parseJSON.call(this, dateRangeConfig);
};

FilterController.prototype = {

    defaultCPSelectorId: "cpSelector",
    noTTACPSelectorId: "noTTACPSelector",

    _triggerDateRangeChange: function _triggerDateRangeChange() {
        (0, _jquery2.default)(document).trigger("viewTT.dateRangeChange", this.getDateRange());
    },

    getDateRange: function getDateRange() {
        return this.dateSelectorController.getSelectedRange();
    },

    _triggerFilterChange: function _triggerFilterChange(filter) {
        this._updateEmptyCPSelectionStatus(filter.cpSelection);
        (0, _jquery2.default)(document).trigger("viewTT.filterChange", [filter]);
    },

    init: function init() {
        var self = this;
        this._ignoreWeekApprovalStatuses = false;

        var $filterDialogEl = (0, _jquery2.default)('#filterDialog');
        this._filterDialog = new _FilterDialog2.default().init($filterDialogEl);

        this.$filterContainer = (0, _jquery2.default)('#viewTTFilterContainer');
        this.$filterEditButton = this.$filterContainer.find('.filterEditButton .commonVisibleFilterButton');
        this.$filterClearButton = this.$filterContainer.find('.filterClearButton');
        this.$filterSelectorButton = this.$filterContainer.find('.noTTACPSelector .commonVisibleFilterButton');

        this.filterEditDialog = new _DropdownDialog2.default({
            wrapperClass: 'viewTTFilterDialogWrapper noprint ui-dialog-titlebar ui-widget-header ui-corner-all ui-helper-clearfix',
            dialogDiv: $filterDialogEl,
            hideButtons: true,
            hideOnResize: true,
            showEmptyTitleBar: false,
            outsideClickCallback: function outsideClickCallback() {
                self._editFiltersCanceled();
            },
            hideOnResizeCallback: function hideOnResizeCallback() {
                self._editFiltersCanceled();
            },
            onClose: function onClose(event) {
                if (event.keyCode === _jquery2.default.ui.keyCode.ESCAPE) self._editFiltersCanceled();

                self.$filterEditButton.removeClass("pressed");
            }
        });

        this.$filterEditButton.click(function () {
            self.$filterEditButton.addClass("pressed");

            self._fillDialogData();

            self.filterEditDialog.showAt(this, {
                offset: "0 6px",
                my: "left top",
                at: "left bottom",
                collision: "none"
            });

            // don`t know better solution for removing focus from some input in dialog
            $filterDialogEl.parent().focus();
        });

        var $applyEditButton = (0, _jquery2.default)('#applyFilterEdit');
        var $cancelEditButton = (0, _jquery2.default)('#cancelFilterEdit');

        $applyEditButton.click(function () {
            self._setNewFilter();
            self._hideDialog();
        });
        $cancelEditButton.click(function () {
            self._hideDialog();
        });

        this.$filterClearButton.click(function () {
            self._restoreFilter();
        });

        this.defaultFilter = this._createDefaultFilter();

        // init date range selector
        this.dateSelectorController = new DateRangeSelectorController().init({
            dateRangeSelection: _ViewTTStore2.default.getDateRangeConfig(),
            dateRangeParsed: true,
            rangeMaxDays: 366,
            rangeTooLongMessageKey: "date_range_selector.range_error.longer_than_1_year",
            renderTo: 'viewTTDateSelector',
            menuStates: this._createDateRangeMenu()
        });
        this.dateSelectorController.setOnChangeCallback(_underscore2.default.bind(this._triggerDateRangeChange, this));

        this.errorTooltip = new _SimpleTooltip2.default({
            text: _messageResource2.default.getMessage('view_tt.filter.tooltip.cp_selection_empty'),
            extraClass: 'viewTTPageFilterErrorTooltip'
        }).init((0, _jquery2.default)('body'));

        this.errorTooltip.subscribeToMouseEvents(this.$filterEditButton);
        this.errorTooltip.subscribeToMouseEvents(this.$filterSelectorButton);
        this.errorTooltip.disable();

        (0, _jquery2.default)(_ViewTTStore2.default).on("dataChange", _underscore2.default.bind(this._reInitCPSelector, this));
        (0, _jquery2.default)(_ViewTTStore2.default).on("dataConfigRestored", _underscore2.default.bind(this._reInit, this));
        this.ttaEnabled = null;
        this._reInitCPSelector();

        return this;
    },

    _reInit: function _reInit() {
        this.dateSelectorController.setSelectedRange(_ViewTTStore2.default.getDateRangeConfig());
        this._reInitCPSelector();
    },

    _reInitCPSelector: function _reInitCPSelector() {
        var ttaEnabled = ViewTTPageUtils.isFeatureEnabled(_features.Feature["TTA"]);
        this._ignoreWeekApprovalStatuses = _ViewTTStore2.default.getUserInfo()["autoApproved"];

        if (ttaEnabled !== this.ttaEnabled) {
            if (ttaEnabled) {
                if (!this.defaultCPSelector) this.defaultCPSelector = this._makeCPSelector(this.defaultCPSelectorId);else this.defaultCPSelector.markAsInvalid();

                this.cpSelector = this.defaultCPSelector;
            } else {
                if (!this.noTTACPSelector) this.noTTACPSelector = this._makeNoTTACPSelector();else this.noTTACPSelector.markAsInvalid();

                this.cpSelector = this.noTTACPSelector;
            }

            this.$filterContainer.toggleClass('ttaEnabled', ttaEnabled);

            this.ttaEnabled = ttaEnabled;
        }

        if (this.ttaEnabled) this._filterDialog.activateStatusesSection(!this._ignoreWeekApprovalStatuses);

        this._updateFilterStatus(_ViewTTStore2.default.getFilter());
    },

    _createDateRangeMenu: function _createDateRangeMenu() {
        return [new AT.CurrentMonthMenuItem(), new AT.PreviousMonthMenuItem(), AT.DateRangeSelectorSeparator, new AT.CurrentWeekNoImgMenuItem(), new AT.PreviousWeekNoImgMenuItem(), AT.DateRangeSelectorSeparator, new AT.CurrentQuarterMenuItem(), new AT.PreviousQuarterMenuItem(), AT.DateRangeSelectorSeparator, new AT.CustomDateRangeMenuItem()];
    },

    // default is all enabled
    _createDefaultFilter: function _createDefaultFilter() {
        return {
            cpSelection: {
                customers: [],
                projects: [],
                showArchivedProjects: false,
                qualifier: _constants.CustomersProjectsSelectionQualifier.ALL
            },
            weekApprovalStatuses: [_constants.WeekApprovalStatus.APPROVED, _constants.WeekApprovalStatus.READY, _constants.WeekApprovalStatus.NOT_READY, _constants.WeekApprovalStatus.REJECTED]
        };
    },

    _editFiltersCanceled: function _editFiltersCanceled() {
        this._hideDialog();
    },

    _hideDialog: function _hideDialog() {
        this.filterEditDialog.hide();
    },

    _removeCPSelectionError: function _removeCPSelectionError() {},

    _makeCPSelector: function _makeCPSelector(id, selectorConstructor) {
        var self = this;
        var configChanged = function configChanged() {
            self._removeCPSelectionError();

            if (!self.ttaEnabled) {
                var filter = _ViewTTStore2.default.getFilter();
                var cpSelection = self._getCPSelection();
                if (self._isCPSelectorChanged(cpSelection, filter.cpSelection)) {
                    filter.cpSelection = cpSelection;
                    self._triggerFilterChange(filter);
                }
            }

            self.cpSelector.setInitialValueFromCurrent();
        };

        var cpSelector = _underscore2.default.isUndefined(selectorConstructor) ? new ViewTTPage.ViewTTCPSelector() : new selectorConstructor();
        cpSelector.init(_ViewTTStore2.default.getFilter().cpSelection, id, configChanged);

        cpSelector.panel.on("change", function () {
            cpSelector.setWasChanged();
        });
        (0, _jquery2.default)(cpSelector).on("selectionChange", function () {
            var cpSelection = cpSelector.isValid() ? cpSelector.getCpSelection() : _ViewTTStore2.default.getFilter()["cpSelection"];
            self._updateEmptyCPSelectionStatus(cpSelection);
        });
        this._updateEmptyCPSelectionStatus(cpSelector.getCpSelection());

        return cpSelector;
    },

    _makeNoTTACPSelector: function _makeNoTTACPSelector() {
        var $containerEl = this.$filterSelectorButton;
        var $btnLabel = $containerEl.find('.label');

        var btnConstructor = function btnConstructor(buttonConfig) {
            ViewTTPage.ViewTTCPSelectorDropDownButton.call(this, buttonConfig);
            this.buttonHandler = _underscore2.default.bind(this.showMenu, this);
        };
        btnConstructor.prototype = _underscore2.default.create(ViewTTPage.ViewTTCPSelectorDropDownButton.prototype, {
            init: function init(cpSelector) {
                ViewTTPage.ViewTTCPSelectorDropDownButton.prototype.init.call(this, cpSelector);
                this._subscribeButton();
                return this;
            },

            setText: function setText(text) {
                $btnLabel.html(text);
            },
            _showMenu: function _showMenu() {
                if (this.menu) {
                    this._unsubscribeButton();
                    $containerEl.toggleClass('pressed', true);
                    this.menu.show($containerEl[0], this.menuAlign);
                }
                return this;
            },
            onMenuHide: function onMenuHide(menu) {
                $containerEl.toggleClass('pressed', false);
                ViewTTPage.ViewTTCPSelectorDropDownButton.prototype.onMenuHide.call(this, menu);
                // 250 is the value that used in Ext.js when we open CPSelector in dialog
                _underscore2.default.delay(_underscore2.default.bind(this._subscribeButton, this), 250);
            },

            _subscribeButton: function _subscribeButton() {
                $containerEl.on('click', this.buttonHandler);
            },

            _unsubscribeButton: function _unsubscribeButton() {
                $containerEl.off('click', this.buttonHandler);
            }
        });

        var selectorConstructor = function selectorConstructor() {};
        selectorConstructor.prototype = _underscore2.default.create(ViewTTPage.ViewTTCPSelector.prototype, {
            _createDropDownButton: function _createDropDownButton(buttonConfig) {
                return new btnConstructor(buttonConfig);
            }
        });

        return this._makeCPSelector(this.noTTACPSelectorId, selectorConstructor);
    },

    _getCPSelection: function _getCPSelection() {
        return this.cpSelector.getCpSelection();
    },

    _fillDialogData: function _fillDialogData() {
        var filter = _ViewTTStore2.default.getFilter();

        if (!this._ignoreWeekApprovalStatuses) {
            this._filterDialog.setStatuses(filter.weekApprovalStatuses);
        }
        this.cpSelector.setSelection(filter.cpSelection);
        this.cpSelector.setInitialValueFromCurrent();
    },

    _setNewFilter: function _setNewFilter() {
        var filter = this._getDialogData();
        if (this._compareAndStoreFilter(filter)) this._updateFilterStatus(filter);
    },

    _restoreFilter: function _restoreFilter() {
        this._setFilterActive(false);
        var filter = this._createDefaultFilter();
        if (this._ignoreWeekApprovalStatuses) {
            filter.weekApprovalStatuses = _ViewTTStore2.default.getFilter()["weekApprovalStatuses"];
        }
        this._changeFilter(filter);
    },

    _updateFilterStatus: function _updateFilterStatus(newFilter) {
        this._setFilterActive(this._isFilterChanged(newFilter, this.defaultFilter));
    },

    _updateEmptyCPSelectionStatus: function _updateEmptyCPSelectionStatus(cpSelection) {
        this.cpSelectionEmpty = !this._isCPSelectorValid(cpSelection);
        this.$filterContainer.toggleClass('cpSelectionEmpty', this.cpSelectionEmpty);
        this.errorTooltip.setEnabled(this.cpSelectionEmpty);
    },

    /**
     * Change ui based on filterStatus
     * @param isActive{Boolean}
     * @private
     */
    _setFilterActive: function _setFilterActive(isActive) {
        this.$filterClearButton.toggleClass('filtered', isActive);
        this.$filterEditButton.toggleClass('filtered', isActive);
        this.$filterSelectorButton.toggleClass('filtered', isActive);
    },

    _getDialogData: function _getDialogData() {
        var weekApprovalStatuses = this._ignoreWeekApprovalStatuses ? _ViewTTStore2.default.getFilter()["weekApprovalStatuses"] : this._filterDialog.getStatuses();

        var cpSelection = this.cpSelector.isValid() ? this._getCPSelection() : _ViewTTStore2.default.getFilter()["cpSelection"];

        return {
            cpSelection: cpSelection,
            weekApprovalStatuses: weekApprovalStatuses
        };
    },

    _changeFilter: function _changeFilter(filter) {
        this._triggerFilterChange(filter);
    },

    _compareAndStoreFilter: function _compareAndStoreFilter(newFilter) {
        if (!this._isFilterChanged(newFilter, _ViewTTStore2.default.getFilter())) return false;
        this._changeFilter(newFilter);
        return true;
    },

    _isFilterChanged: function _isFilterChanged(newFilter, defaultFilter) {
        if (this._isCPSelectorChanged(newFilter.cpSelection, defaultFilter.cpSelection)) {
            return true;
        }
        if (this._ignoreWeekApprovalStatuses || !this.ttaEnabled) {
            return false;
        } else {
            return !this._isArraysEquals(newFilter.weekApprovalStatuses, defaultFilter.weekApprovalStatuses);
        }
    },

    _isCPSelectorChanged: function _isCPSelectorChanged(cpSelection, defaultCPSelection) {
        if (cpSelection.qualifier !== defaultCPSelection.qualifier) return true;

        // check only for SELECTED qualifier
        return cpSelection.qualifier === _constants.CustomersProjectsSelectionQualifier.SELECTED && !(cpSelection.showArchivedProjects == defaultCPSelection.showArchivedProjects && this._isArraysEquals(cpSelection.projects, defaultCPSelection.projects) && this._isArraysEquals(cpSelection.customers, defaultCPSelection.customers));
    },

    _isCPSelectorValid: function _isCPSelectorValid(cpSelection) {
        return !(cpSelection.qualifier === _constants.CustomersProjectsSelectionQualifier.SELECTED && cpSelection.customers.length === 0 && cpSelection.projects.length === 0);
    },

    _isArraysEquals: function _isArraysEquals(list1, list2) {
        if (list1.length != list2.length) return false;

        // we have small lists, so it`s ok for n^2
        for (var i = 0; i < list1.length; i++) {
            if (!_underscore2.default.contains(list2, list1[i])) return false;
        }

        return true;
    }
};

/***/ }),
/* 1587 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _constants = __webpack_require__(4);

var _SimpleTooltip = __webpack_require__(36);

var _SimpleTooltip2 = _interopRequireDefault(_SimpleTooltip);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FilterDialog = function (_TemplateView) {
    _inherits(FilterDialog, _TemplateView);

    function FilterDialog() {
        _classCallCheck(this, FilterDialog);

        return _possibleConstructorReturn(this, (FilterDialog.__proto__ || Object.getPrototypeOf(FilterDialog)).apply(this, arguments));
    }

    _createClass(FilterDialog, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return "<div class='filterDialogTitle'><%=filterDialogTitle%></div>" + "<div class='controlsContainer'>" + "   <table>" + "       <tr>" + "           <td class='controlLabel'>" + "               <div class='filterDialogLabel cpSelectorLabel'>" + "                   <%-Customer%><wbr>/<%-Project%>" + "               </div>" + "           </td>" + "           <td class='cPSelectorCell'>" + "               <div id = 'cpSelector' class='cpSelector'/>" + "           </td>" + "       </tr>" + "       <tr>" + "           <td class='controlLabel'>" + "               <div class='filterDialogLabel ttStatusLabel'>" + "                   <%=filterDialogTTStatus%>" + "               </div>" + "           </td>" + "           <td class='ttStatus'>" + "                <%for(var i = 0; i < checkboxes.length; i++){ var labelId = 'viewTTStatusCheckboxId_' + i;%>" + "                    <div>" + "                        <table><tr>" + "                            <td valign='top'><input type='checkbox' id='<%=labelId%>' class='<%=checkboxes[i].cls%>'></td>" + "                            <td valign='top' style='padding: 4px 0 0 3px;'>" + "                                <label for='<%=labelId%>' class='text'><%=messageResource.getMessage(checkboxes[i].labelKey)%></label>" + "                            </td>" + "                        </tr></table>" + "                    </div>" + "                <%}%>" + "           </td>" + "       </tr>" + "    </table>" + "</div>" + "<div class='buttonsPanel'>" + "   <input type='button' id='cancelFilterEdit' class='cancelFilterEdit' value='<%=filterCancel%>'/>" + "   <input type='button' id='applyFilterEdit' class='applyFilterEdit' value='<%=filterApply%>'/>" + "   <div class='errorMessage'></div>" + "</div>";
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            this.$approved = this.find(".showApproved");
            this.$ready = this.find(".showReady");
            this.$notReadyAndRejected = this.find(".showNotReadyAndRejected");

            this.autoApprovedTooltip = new _SimpleTooltip2.default({
                text: _messageResource2.default.getMessage('view_tt.filter.tooltip.auto_approved')
            }).init((0, _jquery2.default)('body'));
            this.autoApprovedTooltip.subscribeToMouseEvents(this.find('.ttStatus'));
            this.autoApprovedTooltip.disable();
        }
    }, {
        key: 'messageKeys',
        value: function messageKeys() {
            return {
                Customer: "common.Customer",
                Project: "common.Project",
                filterDialogTitle: "view_tt.filter.dialog.title",
                filterDialogTTStatus: "view_tt.filter.dialog.tt_status.label",
                filterApply: "common.approvers_dialog.apply",
                filterCancel: "common.approvers_dialog.cancel"
            };
        }
    }, {
        key: 'templateModel',
        value: function templateModel() {
            return {
                checkboxes: [{ cls: "showApproved", labelKey: "view_tt.filter.dialog.tt_status.approved" }, { cls: "showReady", labelKey: "view_tt.filter.dialog.tt_status.ready" }, { cls: "showNotReadyAndRejected", labelKey: "view_tt.filter.dialog.tt_status.not_ready_and_rejected" }]
            };
        }
    }, {
        key: 'activateStatusesSection',
        value: function activateStatusesSection(isActive) {
            if (!isActive) {
                this.setStatuses([_constants.WeekApprovalStatus.APPROVED]);
            }
            this.$approved.attr("disabled", !isActive);
            this.$ready.attr("disabled", !isActive);
            this.$notReadyAndRejected.attr("disabled", !isActive);

            this.autoApprovedTooltip.setEnabled(!isActive);
        }
    }, {
        key: 'getStatuses',
        value: function getStatuses() {
            var weekApprovalStatuses = [];

            if (this.$approved.prop("checked")) weekApprovalStatuses.push(_constants.WeekApprovalStatus.APPROVED);
            if (this.$ready.prop("checked")) weekApprovalStatuses.push(_constants.WeekApprovalStatus.READY);
            if (this.$notReadyAndRejected.prop("checked")) {
                weekApprovalStatuses.push(_constants.WeekApprovalStatus.NOT_READY);
                weekApprovalStatuses.push(_constants.WeekApprovalStatus.REJECTED);
            }

            return weekApprovalStatuses;
        }
    }, {
        key: 'setStatuses',
        value: function setStatuses(statuses) {
            this.$approved.prop("checked", _underscore2.default.contains(statuses, _constants.WeekApprovalStatus.APPROVED));
            this.$ready.prop("checked", _underscore2.default.contains(statuses, _constants.WeekApprovalStatus.READY));
            this.$notReadyAndRejected.prop("checked", _underscore2.default.contains(statuses, _constants.WeekApprovalStatus.NOT_READY) && _underscore2.default.contains(statuses, _constants.WeekApprovalStatus.REJECTED));
        }
    }]);

    return FilterDialog;
}(_TemplateView3.default);

exports.default = FilterDialog;

/***/ }),
/* 1588 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TableCellRenderer2 = __webpack_require__(63);

var _TableCellRenderer3 = _interopRequireDefault(_TableCellRenderer2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EditableCellRenderer = function (_TableCellRenderer) {
    _inherits(EditableCellRenderer, _TableCellRenderer);

    function EditableCellRenderer() {
        _classCallCheck(this, EditableCellRenderer);

        return _possibleConstructorReturn(this, (EditableCellRenderer.__proto__ || Object.getPrototypeOf(EditableCellRenderer)).apply(this, arguments));
    }

    _createClass(EditableCellRenderer, [{
        key: "init",
        value: function init() {
            _TableCellRenderer3.default.apply(this, arguments);
            return this;
        }
    }, {
        key: "setEditorSelected",
        value: function setEditorSelected() {
            this.addExtraClass("editorSelected");
        }
    }, {
        key: "unsetEditorSelected",
        value: function unsetEditorSelected() {
            this.removeExtraClass("editorSelected");
        }
    }]);

    return EditableCellRenderer;
}(_TableCellRenderer3.default);

exports.default = EditableCellRenderer;

/***/ }),
/* 1589 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = TaskBillingTypeCellRenderer;

var _TypeOfWorkMenu = __webpack_require__(846);

var _TableCellRenderer = __webpack_require__(63);

var _TableCellRenderer2 = _interopRequireDefault(_TableCellRenderer);

var _atUtils = __webpack_require__(5);

var _TypeOfWorkButton = __webpack_require__(848);

var _TypeOfWorkButton2 = _interopRequireDefault(_TypeOfWorkButton);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function TaskBillingTypeCellRenderer() {}

TaskBillingTypeCellRenderer.prototype = _.create(_TableCellRenderer2.default.prototype);

TaskBillingTypeCellRenderer.BILLING_TYPE_NOT_SELECTED_VALUE = -1;

TaskBillingTypeCellRenderer.prototype.init = function (billingTypes, defaultBillingTypeId, changesCallback, scrollableContainer) {
    _TableCellRenderer2.default.call(this);
    this.billingTypesMap = (0, _atUtils.arrayToMap)(billingTypes);
    this.defaultBillingTypeId = defaultBillingTypeId;
    this.changesCallback = changesCallback;
    this.scrollableContainer = scrollableContainer;
    return this;
};

TaskBillingTypeCellRenderer.prototype.generateContent = function (cell) {
    var _this = this;

    if (cell.getValue() == null) cell.setValue(this.defaultBillingTypeId);

    var selectedBillingTypeExists = this.billingTypesMap[cell.getValue()];
    if (!selectedBillingTypeExists) cell.setValue(TaskBillingTypeCellRenderer.BILLING_TYPE_NOT_SELECTED_VALUE);

    var typeOfWorkEditor = new _TypeOfWorkButton2.default({
        editable: true,
        showCategory: false,
        typeOfWorkMenu: new _TypeOfWorkMenu.TypeOfWorkMenu({
            additionalClass: 'typeOfWorkEditorMenu addNewTasks'
        }).init((0, _jquery2.default)(cell.getCellEl())),
        positionParams: {
            within: this.scrollableContainer,
            collision: 'fit',
            my: 'right top',
            at: 'left top'
        },
        onTypeOfWorkChangedCb: function onTypeOfWorkChangedCb(newTypeOfWorkId) {
            cell.setValue(newTypeOfWorkId);
            cell.updateUI();
            _this.changesCallback(cell);
        }
    }).init((0, _jquery2.default)(cell.getCellEl()));

    typeOfWorkEditor.setState({
        typeOfWorkId: cell.getValue()
    });
    cell.typeOfWorkEditor = typeOfWorkEditor;

    if (!selectedBillingTypeExists) cell.updateUI();
};

TaskBillingTypeCellRenderer.prototype.updateUI = function (cell) {
    _TableCellRenderer2.default.prototype.updateUI.call(this, cell);

    cell.typeOfWorkEditor.setState({
        typeOfWorkId: cell.getValue(),
        typeOfWorkName: cell.getValue() !== TaskBillingTypeCellRenderer.BILLING_TYPE_NOT_SELECTED_VALUE ? this.billingTypesMap[cell.getValue()].name : ''
    });

    if (cell.isValid()) (0, _jquery2.default)(cell.getCellEl()).removeClass("error");else (0, _jquery2.default)(cell.getCellEl()).addClass("error");
};

TaskBillingTypeCellRenderer.prototype.updateBillingTypes = function (billingTypes) {
    this.billingTypesMap = billingTypes ? (0, _atUtils.arrayToMap)(billingTypes) : {};
};

TaskBillingTypeCellRenderer.prototype.getCellClassName = function (cell) {
    return ["billingTypeCell"];
};

/***/ }),
/* 1590 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _ScrollableContainer = __webpack_require__(49);

var _ScrollableContainer2 = _interopRequireDefault(_ScrollableContainer);

var _TypesOfWorkList = __webpack_require__(1591);

var _TypesOfWorkList2 = _interopRequireDefault(_TypesOfWorkList);

var _utils = __webpack_require__(6);

var _TypeOfWorkNode = __webpack_require__(1593);

var _TypeOfWorkNode2 = _interopRequireDefault(_TypeOfWorkNode);

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _selectors = __webpack_require__(504);

var _SearchField = __webpack_require__(847);

var _SearchField2 = _interopRequireDefault(_SearchField);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TypeOfWorkSelector = function (_TemplateView) {
    _inherits(TypeOfWorkSelector, _TemplateView);

    function TypeOfWorkSelector(_ref) {
        var _ref$onlyActive = _ref.onlyActive,
            onlyActive = _ref$onlyActive === undefined ? true : _ref$onlyActive,
            _ref$onTypeSelected = _ref.onTypeSelected,
            onTypeSelected = _ref$onTypeSelected === undefined ? function () {} : _ref$onTypeSelected;

        _classCallCheck(this, TypeOfWorkSelector);

        var _this = _possibleConstructorReturn(this, (TypeOfWorkSelector.__proto__ || Object.getPrototypeOf(TypeOfWorkSelector)).call(this));

        _this.filterTypeOfWork = function (searchText) {
            _this.setState({ searchText: searchText });
        };

        _this.onTypeSelected = function (id) {
            _this.params.onTypeSelected(id);
            _this.setState({ searchText: '' });
            _this.searchField.clear();
        };

        _this.params = {
            onlyActive: onlyActive,
            onTypeSelected: onTypeSelected
        };

        _this.state = {
            typesOfWork: [],
            selectedTypeId: -1,
            searchText: ''
        };

        _this.onAnyStatePropertyChanged(['typesOfWork', 'selectedTypeId', 'searchText'], function () {
            return _this._renderList();
        });
        return _this;
    }

    _createClass(TypeOfWorkSelector, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class="components_typeOfWorkSelector">' + '    <div class="components_typeOfWorkSearchField" />' + '    <div class="components_typeOfWorkSelectorList" />' + '</div>';
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            var $searchFieldContainer = this.find(".components_typeOfWorkSearchField");
            this.searchField = new _SearchField2.default({
                onFieldChange: this.filterTypeOfWork
            }).init($searchFieldContainer);
            this._renderList();
        }
    }, {
        key: 'update',
        value: function update() {
            _get(TypeOfWorkSelector.prototype.__proto__ || Object.getPrototypeOf(TypeOfWorkSelector.prototype), 'update', this).call(this);
            if (this.scrollableContainer) this.scrollableContainer.forceUpdate();
        }
    }, {
        key: '_renderList',
        value: function _renderList() {
            var _this2 = this;

            var list = this.$el.find(".components_typeOfWorkSelectorList");
            list.empty();

            this.scrollableContainer = new _ScrollableContainer2.default(null, new _TypesOfWorkList2.default({
                nodeRenderer: function nodeRenderer($el, typeOfWork, searchText) {
                    new _TypeOfWorkNode2.default({
                        typeOfWork: typeOfWork,
                        selected: _this2.state.selectedTypeId === typeOfWork.id,
                        onClick: _this2.onTypeSelected,
                        searchText: searchText
                    }).init($el);
                }
            }));
            this.scrollableContainer.init(list).setState({
                typesOfWork: this._getTypesOfWork(),
                searchText: this.state.searchText
            });
        }
    }, {
        key: '_getTypesOfWork',
        value: function _getTypesOfWork() {
            var _this3 = this;

            var filteredTypesOfWorks = this.state.typesOfWork.filter(function (t) {
                return t.name.startsWith(_this3.state.searchText);
            });
            if (this.params.onlyActive) {
                return filteredTypesOfWorks.reduce(function (acc, t) {
                    if (t.active) acc.push(t);
                    // if assigned ToW is archived, place it first in list
                    if (!t.active && t.id === _this3.state.selectedTypeId) {
                        t.position = -1;
                        acc.push(t);
                    }
                    return acc;
                }, []);
            }

            return filteredTypesOfWorks;
        }
    }]);

    return TypeOfWorkSelector;
}(_TemplateView3.default);

exports.default = (0, _utils.connect)(function (state) {
    return {
        typesOfWork: (0, _selectors.getSortedTypeOfWorkList)(state)
    };
})(TypeOfWorkSelector);

/***/ }),
/* 1591 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _TypeOfWorkEmptyListPlaceholder = __webpack_require__(1592);

var _TypeOfWorkEmptyListPlaceholder2 = _interopRequireDefault(_TypeOfWorkEmptyListPlaceholder);

var _utils = __webpack_require__(786);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TypesOfWorkList = function (_TemplateView) {
    _inherits(TypesOfWorkList, _TemplateView);

    function TypesOfWorkList(_ref) {
        var _ref$nodeRenderer = _ref.nodeRenderer,
            nodeRenderer = _ref$nodeRenderer === undefined ? null : _ref$nodeRenderer;

        _classCallCheck(this, TypesOfWorkList);

        var _this = _possibleConstructorReturn(this, (TypesOfWorkList.__proto__ || Object.getPrototypeOf(TypesOfWorkList)).call(this));

        _this.state = {
            typesOfWork: [],
            searchText: ''
        };

        _this.params = {
            nodeRenderer: nodeRenderer
        };

        _this.onAnyStatePropertyDeeplyChanged(['typesOfWork', 'searchText'], function () {
            _this._renderTypesOfWork();
        });
        return _this;
    }

    _createClass(TypesOfWorkList, [{
        key: "templateHtml",
        value: function templateHtml() {
            return '<div class="typeOfWorkList">' + '</div>';
        }
    }, {
        key: "_renderTypesOfWork",
        value: function _renderTypesOfWork() {
            var _this2 = this;

            this.$el.empty();

            if (this.state.typesOfWork.length) {
                this.state.typesOfWork.sort(_utils.typeOfWorkComparator).forEach(function (typeOfWork) {
                    _this2.params.nodeRenderer(_this2.$el, typeOfWork, _this2.state.searchText);
                });
            } else {
                new _TypeOfWorkEmptyListPlaceholder2.default().init(this.$el);
            }
        }
    }]);

    return TypesOfWorkList;
}(_TemplateView3.default);

exports.default = TypesOfWorkList;

/***/ }),
/* 1592 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TypeOfWorkEmptyListPlaceholder = function (_TemplateView) {
    _inherits(TypeOfWorkEmptyListPlaceholder, _TemplateView);

    function TypeOfWorkEmptyListPlaceholder() {
        _classCallCheck(this, TypeOfWorkEmptyListPlaceholder);

        return _possibleConstructorReturn(this, (TypeOfWorkEmptyListPlaceholder.__proto__ || Object.getPrototypeOf(TypeOfWorkEmptyListPlaceholder)).call(this));
    }

    _createClass(TypeOfWorkEmptyListPlaceholder, [{
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='emptyListPlaceholder'>" + "    <div class='icon' />" + "    <div class='placeholder'><%-placeholder%></div>" + "</div>";
        }
    }, {
        key: "templateModel",
        value: function templateModel() {
            return {
                placeholder: _messageResource2.default.getMessage('billing_type.not_found')
            };
        }
    }]);

    return TypeOfWorkEmptyListPlaceholder;
}(_TemplateView3.default);

exports.default = TypeOfWorkEmptyListPlaceholder;

/***/ }),
/* 1593 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TypeOfWorkNode = function (_TemplateView) {
    _inherits(TypeOfWorkNode, _TemplateView);

    function TypeOfWorkNode(_ref) {
        var typeOfWork = _ref.typeOfWork,
            selected = _ref.selected,
            _ref$onClick = _ref.onClick,
            onClick = _ref$onClick === undefined ? function () {} : _ref$onClick,
            searchText = _ref.searchText;

        _classCallCheck(this, TypeOfWorkNode);

        var _this = _possibleConstructorReturn(this, (TypeOfWorkNode.__proto__ || Object.getPrototypeOf(TypeOfWorkNode)).call(this));

        _this.onClick = onClick;

        _this.params = {
            id: typeOfWork.id,
            name: typeOfWork.name,
            billable: typeOfWork.billable,
            active: typeOfWork.active,
            default: typeOfWork.default,
            selected: selected,
            searchText: searchText
        };
        return _this;
    }

    _createClass(TypeOfWorkNode, [{
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='typeOfWorkRow'>" + "    <div class='typeLabel ellipsis <%-archived%>'>" + "        <span class='searchText'><%-searchText%></span><%-name%> <%-defaultLabel%>" + "    </div>" + "    <span class='nonBillableLabel'><%-nonBillable%></span>" + "</div>";
        }
    }, {
        key: "templateModel",
        value: function templateModel() {
            return {
                name: this.params.name.substring(this.params.searchText.length),
                searchText: this.params.searchText,
                nonBillable: this.params.billable ? '' : _messageResource2.default.getMessage('billing_type.non_billable.lowercase'),
                archived: this.params.active ? '' : _messageResource2.default.getMessage('billing_type.archived'),
                defaultLabel: this.params.default ? _messageResource2.default.getMessage('billing_type.default') : ''
            };
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            var _this2 = this;

            this.$el.toggleClass('selected', this.params.selected);
            this.$el.click(function () {
                return _this2.onClick(_this2.params.id);
            });
        }
    }]);

    return TypeOfWorkNode;
}(_TemplateView3.default);

exports.default = TypeOfWorkNode;

/***/ }),
/* 1594 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ErrorMap;

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _atUtils = __webpack_require__(5);

var _atBrowserUtils = __webpack_require__(8);

var _GroupType = __webpack_require__(34);

var _GroupType2 = _interopRequireDefault(_GroupType);

var _BalanceType = __webpack_require__(253);

var _BalanceType2 = _interopRequireDefault(_BalanceType);

var _PagerController = __webpack_require__(461);

var _PagerController2 = _interopRequireDefault(_PagerController);

var _UserTableController = __webpack_require__(1595);

var _UserTableController2 = _interopRequireDefault(_UserTableController);

var _ManagementFilter = __webpack_require__(1623);

var _ManagementFilter2 = _interopRequireDefault(_ManagementFilter);

var _SpinnerController = __webpack_require__(69);

var _SpinnerController2 = _interopRequireDefault(_SpinnerController);

var _constants = __webpack_require__(21);

var _userStore = __webpack_require__(460);

var _userStore2 = _interopRequireDefault(_userStore);

var _User = __webpack_require__(119);

var _User2 = _interopRequireDefault(_User);

var _StringTokenizer = __webpack_require__(103);

var _StringTokenizer2 = _interopRequireDefault(_StringTokenizer);

var _jquery_rpc = __webpack_require__(26);

var _jquery_rpc2 = _interopRequireDefault(_jquery_rpc);

var _FeaturesDiffStateController = __webpack_require__(822);

var _FeaturesDiffStateController2 = _interopRequireDefault(_FeaturesDiffStateController);

var _UserListConfirmation = __webpack_require__(545);

var _UserListConfirmation2 = _interopRequireDefault(_UserListConfirmation);

var _UserNameFormat = __webpack_require__(17);

var _UserNameFormat2 = _interopRequireDefault(_UserNameFormat);

var _constants2 = __webpack_require__(4);

var _PermissionsDescriptionLightBox = __webpack_require__(546);

var _PermissionsDescriptionLightBox2 = _interopRequireDefault(_PermissionsDescriptionLightBox);

var _ATUserGroupRenderer = __webpack_require__(1628);

var _ATUserGroupRenderer2 = _interopRequireDefault(_ATUserGroupRenderer);

var _LeaveBalanceEditor = __webpack_require__(547);

var _LeaveBalanceEditor2 = _interopRequireDefault(_LeaveBalanceEditor);

var _base_group_management_controller = __webpack_require__(310);

var _ATAddUserGroupController = __webpack_require__(1629);

var _ATAddUserGroupController2 = _interopRequireDefault(_ATAddUserGroupController);

var _ATInviteSeveralUsersLightBox = __webpack_require__(1631);

var _ATInviteSeveralUsersLightBox2 = _interopRequireDefault(_ATInviteSeveralUsersLightBox);

var _actions = __webpack_require__(126);

var _actions2 = __webpack_require__(148);

var _CreateUserPanel = __webpack_require__(1639);

var _CreateUserPanel2 = _interopRequireDefault(_CreateUserPanel);

var _EditUserPanel = __webpack_require__(1711);

var _EditUserPanel2 = _interopRequireDefault(_EditUserPanel);

var _WorkAssignmentsEditorPanel = __webpack_require__(1714);

var _WorkAssignmentsEditorPanel2 = _interopRequireDefault(_WorkAssignmentsEditorPanel);

var _ManagementAssignmentsEditorPanel = __webpack_require__(881);

var _ManagementAssignmentsEditorPanel2 = _interopRequireDefault(_ManagementAssignmentsEditorPanel);

var _CustomCheckbox = __webpack_require__(83);

var _CustomCheckbox2 = _interopRequireDefault(_CustomCheckbox);

var _ManagementButtonsContainer = __webpack_require__(1718);

var _ManagementButtonsContainer2 = _interopRequireDefault(_ManagementButtonsContainer);

var _WorkAssignmentsTabContainer = __webpack_require__(1721);

var _WorkAssignmentsTabContainer2 = _interopRequireDefault(_WorkAssignmentsTabContainer);

var _TabsContainer = __webpack_require__(1731);

var _TabsContainer2 = _interopRequireDefault(_TabsContainer);

var _View2 = __webpack_require__(20);

var _View3 = _interopRequireDefault(_View2);

var _utils = __webpack_require__(6);

var _selectors = __webpack_require__(53);

var _actions3 = __webpack_require__(50);

var _redux = __webpack_require__(7);

var _TableControls = __webpack_require__(899);

var _TableControls2 = _interopRequireDefault(_TableControls);

var _WordsFilter = __webpack_require__(400);

var _WordsFilter2 = _interopRequireDefault(_WordsFilter);

var _utils2 = __webpack_require__(200);

var _groupUtils = __webpack_require__(71);

var _actions4 = __webpack_require__(1732);

var _WorkAssignmentPanel = __webpack_require__(1733);

var _WorkAssignmentPanel2 = _interopRequireDefault(_WorkAssignmentPanel);

var _LicenseContainer = __webpack_require__(1742);

var _LicenseContainer2 = _interopRequireDefault(_LicenseContainer);

var _utils3 = __webpack_require__(25);

var _ManagementAssignmentsPanel = __webpack_require__(1744);

var _ManagementAssignmentsPanel2 = _interopRequireDefault(_ManagementAssignmentsPanel);

var _LeaveBalanceEditorContent = __webpack_require__(901);

var _LeaveBalanceEditorContent2 = _interopRequireDefault(_LeaveBalanceEditorContent);

var _BalanceHistoryPanelContent = __webpack_require__(902);

var _BalanceHistoryPanelContent2 = _interopRequireDefault(_BalanceHistoryPanelContent);

var _UsersFilter = __webpack_require__(562);

var _UsersFilter2 = _interopRequireDefault(_UsersFilter);

var _constants3 = __webpack_require__(4);

var _actions5 = __webpack_require__(207);

var _group_controller = __webpack_require__(527);

var _group_controller2 = _interopRequireDefault(_group_controller);

var _selectors2 = __webpack_require__(15);

var _actions6 = __webpack_require__(1747);

var _constants4 = __webpack_require__(201);

var _EditTeamAssignmentsPanel = __webpack_require__(1748);

var _EditTeamAssignmentsPanel2 = _interopRequireDefault(_EditTeamAssignmentsPanel);

var _PermissionsUtils = __webpack_require__(359);

var _selectors3 = __webpack_require__(316);

var _ExportUsersDropdown = __webpack_require__(1749);

var _ExportUsersDropdown2 = _interopRequireDefault(_ExportUsersDropdown);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ErrorMap = (_ErrorMap = {}, _defineProperty(_ErrorMap, _constants2.UserManagementConstants.ERROR_NO_RIGHTS_TO_MANAGE_ACCOUNT_SETTINGS, "userlist.js.error_manage_account_settings_right_revoked"), _defineProperty(_ErrorMap, _constants2.UserManagementConstants.ERROR_DUPLICATE_USERNAME, true), _defineProperty(_ErrorMap, _constants2.UserManagementConstants.ERROR_NO_RIGHTS_TO_MANAGE_PTO_AND_SICK, "userlist.js.error_no_rights_to_manage_leave_balance"), _defineProperty(_ErrorMap, _constants2.UserManagementConstants.ERROR_PTO_FEATURE_DISABLED, "userlist.js.error_pto_feature_disabled"), _defineProperty(_ErrorMap, _constants2.UserManagementConstants.ERROR_PTO_CONTROL_DISABLED, "userlist.js.error_pto_control_disabled"), _defineProperty(_ErrorMap, _constants2.UserManagementConstants.ERROR_SICK_CONTROL_DISABLED, "userlist.js.error_sick_control_disabled"), _defineProperty(_ErrorMap, _constants2.UserManagementConstants.ERROR_NO_SUCH_USER, "userlist.js.error_no_such_user"), _defineProperty(_ErrorMap, _constants2.UserManagementConstants.ERROR_CANT_DELETE, "userlist.js.error_cant_delete"), _defineProperty(_ErrorMap, _constants2.UserManagementConstants.ERROR_CANNOT_DISABLE_LAST_USER_MANAGER_IN_OTHER_PRODUCT, "user.edit.js.cannot_disable.last_admin_at"), _ErrorMap);

var BOTTOM_BAR_HEIGHT = 29;

var UserManagementMediator = function (_View) {
    _inherits(UserManagementMediator, _View);

    function UserManagementMediator(_ref) {
        var openEditUserPanel = _ref.openEditUserPanel,
            openCreateUserPanel = _ref.openCreateUserPanel,
            closeCreateUserPanel = _ref.closeCreateUserPanel,
            setStateOnPageDataReceivedAction = _ref.setStateOnPageDataReceivedAction,
            setStateOnInviteSeveralUsersSuccess = _ref.setStateOnInviteSeveralUsersSuccess,
            openTeamAssignmentsPanel = _ref.openTeamAssignmentsPanel,
            openManagementAssignmentsPanel = _ref.openManagementAssignmentsPanel,
            addNewUsersToList = _ref.addNewUsersToList,
            removeUserFromList = _ref.removeUserFromList,
            updateUserManagementData = _ref.updateUserManagementData,
            updateUsersGroups = _ref.updateUsersGroups,
            updateUsersTimeZoneGroups = _ref.updateUsersTimeZoneGroups,
            updateDepartments = _ref.updateDepartments,
            updateTimeZoneGroups = _ref.updateTimeZoneGroups;

        _classCallCheck(this, UserManagementMediator);

        var _this = _possibleConstructorReturn(this, (UserManagementMediator.__proto__ || Object.getPrototypeOf(UserManagementMediator)).call(this));

        (0, _jquery2.default)(document).on("editUserPanel_updateUserData", function (e, data) {
            if (_this.state.activeTabNum !== _constants2.UserManagementConstants.WORK_ASSIGNMENTS_TAB_NUM) {
                _this.updateCallSucceeded(data, null, false, null, data.userInfo.id, null, null, true);
            }
        });

        (0, _jquery2.default)(document).on("editUserPanel_deleteUserSucceeded", function (e, data) {
            if (_this.state.activeTabNum !== _constants2.UserManagementConstants.WORK_ASSIGNMENTS_TAB_NUM) {
                _this.deleteCallSucceeded(data, data.id, null, null, null);
            }
        });

        (0, _jquery2.default)(document).on("editUserPanel_noSuchUserException", function (e, userId) {
            if (_this.state.activeTabNum !== _constants2.UserManagementConstants.WORK_ASSIGNMENTS_TAB_NUM) {
                _this._deleteUser(userId);
            }
        });

        (0, _jquery2.default)(document).on("createUserPanel_userCreated", function (e, data) {
            _this.createSingleUserCallSucceeded(data, _this.createUserPanel, false, null, data.userInfo.id);
        });

        (0, _jquery2.default)(document).on("createUserPanel_panelClosed", function () {
            _this.showGettingStartedMenuIfNeeded();
        });

        _this.state = {
            activeTabNum: -1,
            allowedToManageAccountSettings: false,
            editingUserId: null,
            isURAEnabled: false,
            isBTYEnabled: false,
            isUGREnabled: false,
            isTZGEnabled: false,
            isTTAEnabled: false,
            availableUsers: [],
            permissionsTemplates: [],
            isWaTabLoading: false
        };

        _this.actions = {
            openEditUserPanel: openEditUserPanel,
            openCreateUserPanel: openCreateUserPanel,
            closeCreateUserPanel: closeCreateUserPanel,
            setStateOnPageDataReceivedAction: setStateOnPageDataReceivedAction,
            setStateOnInviteSeveralUsersSuccess: setStateOnInviteSeveralUsersSuccess,
            openTeamAssignmentsPanel: openTeamAssignmentsPanel,
            openManagementAssignmentsPanel: openManagementAssignmentsPanel,
            addNewUsersToList: addNewUsersToList,
            removeUserFromList: removeUserFromList,
            updateUsersGroups: updateUsersGroups,
            updateDepartments: updateDepartments,
            updateUserManagementData: updateUserManagementData,
            updateUsersTimeZoneGroups: updateUsersTimeZoneGroups,
            updateTimeZoneGroups: updateTimeZoneGroups
        };

        _this.spinner = _this.createSpinner();
        _this.spinnerEl = "spinnerPlaceholderId";

        _this.onStatePropertyChanged('activeTabNum', function () {
            _this._toggleTableClassForTabs(_this.state.activeTabNum);
        });

        _this.onStatePropertyChanged('allowedToManageAccountSettings', function () {
            var managementButtonsPlaceholder = (0, _jquery2.default)('.userList_managementButtonsPlaceholder');
            if (_this.state.allowedToManageAccountSettings) {
                managementButtonsPlaceholder.show();
            } else {
                managementButtonsPlaceholder.hide();
            }
        });

        _this.onStatePropertyChanged('editingUserId', function (userId, prevUserId) {
            if (_this.state.activeTabNum !== _constants2.UserManagementConstants.WORK_ASSIGNMENTS_TAB_NUM) {
                if (userId !== null) {
                    _this.userTableController.addRowSelectionByUserId(userId);
                }

                if (prevUserId !== null) {
                    _this.userTableController.clearRowSelectionByUserId(prevUserId);
                }
            }
        });

        _this.onStatePropertyChanged('availableUsers', function (availableUsers) {
            _this.usersFilter.setState({
                users: availableUsers.map(function (user) {
                    return new _User2.default(user["id"], user["firstName"], user["lastName"], user["middleInitial"], user["username"], user["activeInAT"] || user["enabled"], false, user["userGroupId"], user["timeZoneGroupId"]);
                })
            });
        });

        _this.onStatePropertyDeeplyChanged('permissionsTemplates', function (templates) {
            if (_this.inviteSeveralUsersPopup) _this.inviteSeveralUsersPopup.updatePermissionsTemplatesData(templates);
        });

        _this.onStatePropertyChanged('isWaTabLoading', function (loading) {
            if (loading) {
                _this.spinner.spin(_this.spinnerEl);
            } else {
                _this.spinner.stop();
            }
        });

        _this.onAnyStatePropertyChanged(['isURAEnabled', 'isBTYEnabled', 'isTTAEnabled'], function () {
            _this.userTableController.setState({
                isURAEnabled: _this.state.isURAEnabled,
                isBTYEnabled: _this.state.isBTYEnabled,
                isTTAEnabled: _this.state.isTTAEnabled
            });
        });
        return _this;
    }

    _createClass(UserManagementMediator, [{
        key: 'init',
        value: function init(userListBeans, pagerData, userGroupList, timeZoneGroupList, viewerSettings, userListSettings, license, loggedInUserId, ptoHoursPerDay, usersWithoutApprovers, ptoDefaults, sickDefaults, exportBalanceHistoryUrl, loggedInUserGroup, loggedInUserTZGroupId) {
            var _this2 = this;

            this.actions.setStateOnPageDataReceivedAction({
                licenseCounters: license,
                viewerSettings: viewerSettings,
                usersWithoutApprovers: usersWithoutApprovers,
                allUserGroups: userGroupList,
                allTimeZoneGroups: timeZoneGroupList,
                records: userListBeans
            });

            _View3.default.prototype.init.call(this);

            this.$pageEl = (0, _jquery2.default)('.userListPage');

            this.$userListTableContainer = (0, _jquery2.default)("#userListTableContainer");
            this.$workAssignmentsTablePlaceholder = (0, _jquery2.default)('.userList_workAssignmentsTableContainer');

            this._initTabs();

            this.loggedInUserId = loggedInUserId;
            this.loggedInUserGroup = loggedInUserGroup;

            this.time = null;
            this.rpcRequest = null;
            this.spinnerTimer = null;
            this.ptoHoursPerDay = ptoHoursPerDay;

            userListSettings.filter = (0, _atUtils.convertUsersFilterDependingOnFeatures)(userListSettings.filter, this.state.isUGREnabled, this.state.isTZGEnabled, this.state.availableUsers);

            this.currentState = {};
            this.currentState.userListSettings = userListSettings;
            this.currentState.viewerSettings = viewerSettings;
            this.currentState.recordsPerPage = pagerData.recordsPerPage;
            this.currentState.pageNum = pagerData.pageNum;
            this.currentState.totalRecords = pagerData.totalRecords;
            this.currentState.userListOrder = userListSettings.order;
            this.currentState.searchText = "";
            this.currentState.license = license;
            this.currentState.noUsersShown = userListBeans.length <= 0;

            this.newState = _jquery2.default.extend(true, {}, this.currentState);

            // time zone group of logged in user
            var previousLoggedInUserTZGroup = _underscore2.default.find(timeZoneGroupList, function (tzGroup) {
                return tzGroup.id === loggedInUserTZGroupId;
            });

            //init users export on top
            this.exportUsersDropdown = new _ExportUsersDropdown2.default().init((0, _jquery2.default)('.userList_exportUsersDropdownPlaceholder'));
            this._updateUsersExportDropdown();

            // init management buttons on top
            new _ManagementButtonsContainer2.default({
                onManageUserDepartmentsClick: function onManageUserDepartmentsClick() {
                    _this2.showManageDepartmentsPopup(function (controller) {
                        _this2._departmentsChanged(controller);
                    });
                },
                onManageTimeZoneGroupsClick: function onManageTimeZoneGroupsClick() {
                    _this2.showManageTimeZoneGroupsPopup(function (controller) {
                        // get actual time zone group off logged in user
                        var newLoggedInUserTZGroup = _underscore2.default.find(controller.storedData, function (tzGroupWithUsers) {
                            var tzGroupUserIds = _underscore2.default.map(tzGroupWithUsers.users, function (user) {
                                return user.id;
                            });
                            return _underscore2.default.contains(tzGroupUserIds, loggedInUserId);
                        });
                        // check new and prev tz group of logged in user
                        if (previousLoggedInUserTZGroup.id !== newLoggedInUserTZGroup.id || previousLoggedInUserTZGroup.timeZoneId !== newLoggedInUserTZGroup.timeZoneId || previousLoggedInUserTZGroup.cityName !== newLoggedInUserTZGroup.cityName) {
                            // update user list if his time zone group will be changed
                            alert(_messageResource2.default.getMessage('userlist.js.time_zone_was_changed'));
                            _this2._reloadPage();
                            return;
                        }

                        _this2._timeZoneGroupsChanged(controller);
                    });
                },
                onAddNewUserClick: function onAddNewUserClick() {
                    return _this2.createUser();
                },
                onManualInvitationsClick: function onManualInvitationsClick() {
                    return _this2.inviteSeveralUsers();
                },
                onImportUsersFinished: function onImportUsersFinished(importedUsersData) {
                    return _this2.importUsersFinished(importedUsersData);
                }
            }).init((0, _jquery2.default)('.userList_managementButtonsPlaceholder'));

            new _LicenseContainer2.default().init((0, _jquery2.default)('.licenseInfoPlaceholder'));

            // init workAssignments tab
            this.workAssignmentsTableContainer = new _WorkAssignmentsTabContainer2.default().init(this.$workAssignmentsTablePlaceholder);

            this.userGroupMap = this._initGroupMap(userGroupList, true, _constants2.USERS_WITHOUT_GROUP_ID);
            this.userGroupList = userGroupList;

            this.timeZoneGroupMap = this._initGroupMap(timeZoneGroupList, false, _constants2.DEFAULT_TIME_ZONE_GROUP_ID);
            this.timeZoneGroupList = timeZoneGroupList;

            this._initFilters();

            this.usersFilter = new _UsersFilter2.default({
                onChange: function onChange(_ref2) {
                    var userIds = _ref2.userIds,
                        groupIds = _ref2.groupIds,
                        groupType = _ref2.groupType,
                        allSelected = _ref2.allSelected;

                    _this2._filterByUsersChangedCallBack(_this2.currentState.userListSettings.filter.showDisabled, userIds, groupIds, groupType, allSelected);
                },
                createSelectionDescription: _utils2.getUserSelectionDescription
            });

            this.wordsFilterComponent = new _WordsFilter2.default({
                onChange: function onChange(text) {
                    return _this2._searchTermsChangedCallback(text);
                }
            });

            this.tableControls = new _TableControls2.default({
                wordsFilterComponent: this.wordsFilterComponent,
                usersFilterComponent: this.usersFilter,
                onUserSortClick: function onUserSortClick(e) {
                    return _this2._sortingChangedCallback(e, _constants2.UserManagementConstants.USER_LIST_ORDER_BY_NAME);
                },
                onUserGroupSortClick: function onUserGroupSortClick(e) {
                    return _this2._sortingChangedCallback(e, _constants2.UserManagementConstants.USER_LIST_ORDER_BY_GROUP_NAME);
                },
                onTimeZoneSortClick: function onTimeZoneSortClick(e) {
                    return _this2._sortingChangedCallback(e, _constants2.UserManagementConstants.USER_LIST_ORDER_BY_TIME_ZONE_GROUP_NAME);
                }
            }).init((0, _jquery2.default)('.userNameSelectorsTable'));
            this.tableControls.setState({
                sorting: userListSettings.order,
                showUserGroups: this._isUGREnabled(),
                showTimeZoneGroups: this._isTZGEnabled()
            });

            this.pagerController = this._initPagerController(pagerData, function (pageNum) {
                _this2._pageNumChangedCallback(pageNum);
            }, function (recordsPerPage) {
                _this2._recordsPerPageChangedCallback(recordsPerPage);
            });

            this.userTableController = this._initUserTableController(userListSettings, viewerSettings, userListBeans, this.userGroupMap, this.timeZoneGroupMap, usersWithoutApprovers, ptoDefaults, sickDefaults);

            this.userTableController.init();

            this.usersFilter.setState({
                userGroups: userGroupList !== null ? (0, _groupUtils.transformListToGroups)((0, _groupUtils.addDefaultUserGroup)(userGroupList)) : null,
                timeZoneGroups: (0, _groupUtils.transformListToGroups)(this.timeZoneGroupList),
                groupType: this.currentState.userListSettings.filter.groupType,
                userIds: this.currentState.userListSettings.filter.userIds || [],
                groupIds: this.currentState.userListSettings.filter.groupIds || [],
                allSelected: this.currentState.userListSettings.filter.allSelected
            });

            this.toggleNoUsersCaption(userListBeans.length, this.currentState.userListSettings.filter.groupIds || this.currentState.userListSettings.filter.userIds);

            this.pageBodyEl = document.getElementById("pageBody");

            this.initHeaderSelectorsFunction = function () {
                _this2.showDisabledUsersChBox.setState({
                    checked: _this2.currentState.userListSettings.filter.showDisabled
                });
                new _PermissionsDescriptionLightBox2.default().init((0, _jquery2.default)("#permissionsInfoIcon"));
            };

            this._updateUIAccordingToViewerPermissions();

            this.leaveBalanceEditor = new _LeaveBalanceEditorContent2.default().init(this.$pageEl);

            this._balanceHistoryPanel = new _BalanceHistoryPanelContent2.default({
                exportBalanceHistoryUrl: exportBalanceHistoryUrl
            }).init(this.$pageEl);

            this.$tableContainerEl = (0, _jquery2.default)("#balanceHistoryTableBodyDiv");

            new _EditUserPanel2.default().init(this.$pageEl);

            new _EditTeamAssignmentsPanel2.default().init(this.$pageEl);

            new _CreateUserPanel2.default().init(this.$pageEl);

            new _WorkAssignmentPanel2.default().init(this.$pageEl);

            new _WorkAssignmentsEditorPanel2.default().init(this.$pageEl);

            new _ManagementAssignmentsPanel2.default().init(this.$pageEl);

            new _ManagementAssignmentsEditorPanel2.default().init(this.$pageEl);

            _underscore2.default.each(userListBeans, function (user) {
                _userStore2.default.add(new _User2.default(user["id"], user["firstName"], user["lastName"], user["middleInitial"], user["username"], user["enabled"], false, user["userGroupId"], user["timeZoneGroupId"]));
            });

            return this;
        }
    }, {
        key: 'showGettingStartedMenuIfNeeded',
        value: function showGettingStartedMenuIfNeeded() {
            // on hide show getting started menu if need
            if (!_underscore2.default.isUndefined(window.GettingStartedShortcuts)) {
                window.GettingStartedShortcuts.showJustCheckedShortcutIfExists();
            }
        }
    }, {
        key: '_initPagerController',
        value: function _initPagerController(pagerData, pageNumChangedCallback, recordsPerPageChangedCallback) {
            return new _PagerController2.default().init({
                pagerData: pagerData,
                handlersMap: {
                    pageChanged: pageNumChangedCallback,
                    recordsPerPageChanged: recordsPerPageChangedCallback
                },
                pagerControlsElementId: "userListFooterId",
                pagerElementId: "pager",
                recordsPerPageSelectorId: "recordsPerPageSelector",
                minRecordsPerPage: _constants2.UserManagementConstants.MIN_RECORDS_PER_PAGE
            });
        }
    }, {
        key: '_initUserTableController',
        value: function _initUserTableController(userListSettings, viewerSettings, userListBeans, groupMap, timeZoneGroupMap, usersWithoutApprovers, ptoDefaults, sickDefaults) {
            var _this3 = this;

            var tHeadEl = document.getElementById("userListTableHeader"),
                handlersMap = {};

            handlersMap.sortByPTO = function (event) {
                _this3._sortingChangedCallback(event, _constants2.UserManagementConstants.USER_LIST_ORDER_BY_PTO_BALANCE);
            };
            handlersMap.sortByApprovedPTO = function (event) {
                _this3._sortingChangedCallback(event, _constants2.UserManagementConstants.USER_LIST_ORDER_BY_APPROVED_PTO);
            };
            handlersMap.sortByPTOControl = function (event) {
                _this3._sortingChangedCallback(event, _constants2.UserManagementConstants.USER_LIST_ORDER_BY_PTO_CONTROL_STATUS);
            };

            handlersMap.sortBySick = function (event) {
                _this3._sortingChangedCallback(event, _constants2.UserManagementConstants.USER_LIST_ORDER_BY_SICK_BALANCE);
            };
            handlersMap.sortByApprovedSick = function (event) {
                _this3._sortingChangedCallback(event, _constants2.UserManagementConstants.USER_LIST_ORDER_BY_APPROVED_SICK);
            };
            handlersMap.sortBySickControl = function (event) {
                _this3._sortingChangedCallback(event, _constants2.UserManagementConstants.USER_LIST_ORDER_BY_SICK_CONTROL_STATUS);
            };

            handlersMap.editUserAccountSettings = function (cell, e) {
                (0, _utils3.setEventPreventHidingEditUserSlidingPanel)(e);
                (0, _atUtils.defer)(function () {
                    _this3.editUser(cell, _constants.TabKeys.ACCOUNT_SETTINGS);
                });
            };

            handlersMap.editUserPermissions = function (cell, e) {
                (0, _utils3.setEventPreventHidingEditUserSlidingPanel)(e);
                (0, _atUtils.defer)(function () {
                    _this3.editUser(cell, _constants.TabKeys.PERMISSIONS);
                });
            };

            handlersMap.editTeamAssignmentsPermissions = function (cell, e) {
                (0, _utils3.setEventPreventHidingTeamAssignmentSlidingPanel)(e);
                (0, _atUtils.defer)(function () {
                    _this3.editTeamAssignments(cell);
                });
            };

            handlersMap.editManagementAssignmentsPermissions = function (cell, e) {
                (0, _utils3.setEventPreventHidingManagementAssignmentsSlidingPanel)(e);
                (0, _atUtils.defer)(function () {
                    _this3.editManagementAssignments(cell);
                });
            };

            handlersMap.editPTOBalance = function (cell) {
                _this3.editBalance(cell, _BalanceType2.default.PTO);
            };
            handlersMap.editSickDaysBalance = function (cell) {
                _this3.editBalance(cell, _BalanceType2.default.SICK);
            };
            handlersMap.switchManagePTOAndSickRight = function (cell) {
                _this3.switchManagePTOAndSickRight(cell);
            };
            handlersMap.showPtoHistory = function (cell) {
                _this3.showPtoHistory(cell);
            };
            handlersMap.showSickHistory = function (cell) {
                _this3.showSickHistory(cell);
            };
            handlersMap.togglePTOControlStatus = function (cell, value) {
                _this3.toggleBalanceControlStatus(cell, _BalanceType2.default.PTO, value);
            };
            handlersMap.toggleSickDaysControlStatus = function (cell, value) {
                _this3.toggleBalanceControlStatus(cell, _BalanceType2.default.SICK, value);
            };
            handlersMap.toggleIsTTApprover = function (cell) {
                _this3.toggleIsTTApprover(cell);
            };
            handlersMap.modifyPTOAccrualRules = function (cell, dialogValues, onCompleteCallback) {
                _this3.modifyBalanceAccrualRules(cell, _BalanceType2.default.PTO, dialogValues, onCompleteCallback);
            };
            handlersMap.modifySickAccrualRules = function (cell, dialogValues, onCompleteCallback) {
                _this3.modifyBalanceAccrualRules(cell, _BalanceType2.default.SICK, dialogValues, onCompleteCallback);
            };

            return new _UserTableController2.default({
                containerEl: this.$userListTableContainer,
                tHeadEl: tHeadEl,
                userBeans: userListBeans,
                canManageLeaveBalances: viewerSettings.allowedToManageLeaveBalanceSettings,
                canManageAccounts: viewerSettings.allowedToManageAccountSettings,
                canManageScope: viewerSettings.allowedToManageScope,
                accountSettingsVisible: viewerSettings.showAccountSettings,
                usersWithoutApprovers: usersWithoutApprovers,
                ptoFeatureEnabled: this._isPTOEnabled(),
                sickFeatureEnabled: this._isSickEnabled(),
                wasFeatureEnabled: this._isWASEnabled(),
                ugrFeatureEnabled: this._isUGREnabled(),
                sortOrder: userListSettings.order,
                handlersMap: handlersMap,
                ptoHoursPerDay: this.ptoHoursPerDay,
                groupMap: groupMap,
                timeZoneGroupMap: timeZoneGroupMap,
                ptoDefaults: ptoDefaults,
                sickDefaults: sickDefaults,
                generateMoneyReportsTitle: (0, _PermissionsUtils.getGenerateMoneyReportsRightTitle)(this._isURAEnabled(), this._isBTYEnabled())
            });
        }
    }, {
        key: '_initGroupMap',
        value: function _initGroupMap(groupList, includeNullGroup) {
            var groupMap = null;
            if (groupList !== null) {
                groupMap = {};

                if (includeNullGroup) {
                    groupMap[_constants2.UserManagementConstants.USER_WITHOUT_GROUP] = _messageResource2.default.getMessage("userlist.js.table.username_cell.user_without_group");
                }

                for (var i = 0; i < groupList.length; i++) {
                    var group = groupList[i];
                    if (includeNullGroup && group.id === _constants2.UserManagementConstants.USER_WITHOUT_GROUP) continue;

                    groupMap[group.id] = group.name;
                }
            }

            return groupMap;
        }
    }, {
        key: 'showManageDepartmentsPopup',
        value: function showManageDepartmentsPopup(departmentsChangedCallback) {
            var _this4 = this;

            if (!this.manageDeparmentsController) {
                this.manageDeparmentsController = new _base_group_management_controller.ATUserGroupManagementController();
                window.GroupManagementUtil.initializeGroupsLightBox(this.manageDeparmentsController, new _ATUserGroupRenderer2.default(), new _group_controller2.default(), new _ATAddUserGroupController2.default());
            }

            var popup = window.createLightbox("groupManagementLightBox", function () {
                _this4.manageDeparmentsController.hideLightboxHandler(function () {
                    departmentsChangedCallback(_this4.manageDeparmentsController);
                });
            }, (0, _atUtils.makeHandler)(this.manageDeparmentsController.isPermitToHideLightbox, this.manageDeparmentsController));

            this.manageDeparmentsController.setLightbox(popup);
            this.manageDeparmentsController.initAfterShowing();
        }
    }, {
        key: 'showManageTimeZoneGroupsPopup',
        value: function showManageTimeZoneGroupsPopup(timeZoneGroupsChangedCallback) {
            var _this5 = this;

            if (!this.manageTimeZoneGroupsController) {
                this.manageTimeZoneGroupsController = window.GroupManagementUtil.initializeTimeZoneGroupsLightBox();
            }

            var popup = window.createLightbox("timeZoneGroupManagementLightBox", function () {
                _this5.manageTimeZoneGroupsController.hideLightboxHandler(function () {
                    timeZoneGroupsChangedCallback(_this5.manageTimeZoneGroupsController);
                });
            }, (0, _atUtils.makeHandler)(this.manageTimeZoneGroupsController.isPermitToHideLightbox, this.manageTimeZoneGroupsController));

            this.manageTimeZoneGroupsController.setLightbox(popup);
            this.manageTimeZoneGroupsController.initAfterShowing();
        }
    }, {
        key: 'abortPreparedAndActiveRequests',
        value: function abortPreparedAndActiveRequests() {
            clearTimeout(this.timer);

            if (this.rpcRequest) this.rpcRequest.abort();
        }
    }, {
        key: 'prepareInitialRequest',
        value: function prepareInitialRequest(onTimer, withDelay) {

            this.abortPreparedAndActiveRequests();

            this.abortPreparedOrActiveSpin();

            if (withDelay) {
                this.timer = setTimeout(onTimer, 200);
                this.spinInAfterDelay(200);
            } else {
                this.spinner.spin(this.spinnerEl);
                onTimer();
            }
        }
    }, {
        key: '_abortRequestsAndRevertState',
        value: function _abortRequestsAndRevertState() {
            this.abortPreparedAndActiveRequests();
            this.abortPreparedOrActiveSpin();
            this._revertState();
        }
    }, {
        key: 'onShowDisabledUsersCallBack',
        value: function onShowDisabledUsersCallBack(showDisabled) {
            this._filterByUsersChangedCallBack(showDisabled, this.currentState.userListSettings.filter.userIds, this.currentState.userListSettings.filter.groupIds, this.currentState.userListSettings.filter.groupType, this.currentState.userListSettings.filter.allSelected);
        }
    }, {
        key: 'createSpinner',
        value: function createSpinner() {
            return new _SpinnerController2.default();
        }
    }, {
        key: 'spinInAfterDelay',
        value: function spinInAfterDelay(delay) {
            var _this6 = this;

            this.spinnerTimer = setTimeout(function () {
                _this6.spinner.spin(_this6.spinnerEl);
            }, delay);
        }
    }, {
        key: 'abortPreparedOrActiveSpin',
        value: function abortPreparedOrActiveSpin() {
            clearTimeout(this.spinnerTimer);
            this.spinner.stop();
        }
    }, {
        key: 'hideNoUsersCaptionAndBottomSpacer',
        value: function hideNoUsersCaptionAndBottomSpacer() {
            if (this.noUsersCaptionisHidden) return;

            (0, _jquery2.default)(".bottomSpacer").remove();
            var noUsersCaptionEl = document.getElementById("noUsersToShowId");
            noUsersCaptionEl.style.display = 'none';
        }
    }, {
        key: 'toggleNoUsersCaption',
        value: function toggleNoUsersCaption(recordsSize, customUsersSelected) {
            var noUsersCaptionEl = document.getElementById("noUsersToShowId");
            if (recordsSize === 0) {
                noUsersCaptionEl.style.display = 'block';
                this.noUsersCaptionisHidden = false;
                var groupType = this.currentState.userListSettings.filter.groupType;
                var noEnabledUsersMsg = customUsersSelected ? groupType === _GroupType2.default.USER_GROUP ? _messageResource2.default.getEscapedMessage('userlist.js.users_table_no_enabled_users_found_in_selected_user_groups') : _messageResource2.default.getMessage('userlist.js.users_table_no_enabled_users_found_in_selected_time_zone_groups') : _messageResource2.default.getMessage('userlist.js.users_table_no_enabled_users_found');
                var noUsersMsg = customUsersSelected ? groupType === _GroupType2.default.USER_GROUP ? _messageResource2.default.getEscapedMessage('userlist.js.users_table_no_users_found_in_selected_user_groups') : _messageResource2.default.getMessage('userlist.js.users_table_no_users_found_in_selected_time_zone_groups') : _messageResource2.default.getMessage('userlist.js.users_table_no_users_found');
                noUsersCaptionEl.innerHTML = this.currentState.userListSettings.filter.showDisabled ? noUsersMsg : noEnabledUsersMsg;
            } else {
                noUsersCaptionEl.style.display = 'none';
                this.noUsersCaptionisHidden = true;
            }
        }
    }, {
        key: 'getSortedUserList',
        value: function getSortedUserList(userListBeansArrivedCallBack, withDelay) {
            var _this7 = this;

            this.tokens = this.newState.searchText === null ? [] : new _StringTokenizer2.default(_UserTableController.PUNCTUATORS).getTokens(this.newState.searchText.toLowerCase());

            var params = [this.newState.userListSettings.filter, this.tokens, this.newState.userListOrder, this.newState.pageNum, this.newState.recordsPerPage];
            var successHandler = function successHandler(result, textStatus, jqXHR) {
                _this7.abortPreparedOrActiveSpin();
                userListBeansArrivedCallBack(result);

                _this7.actions.setStateOnPageDataReceivedAction(result);
            };

            var failHandler = function failHandler(result, textStatus, jqXHR) {
                if (textStatus === 'abort') return;

                _this7.abortPreparedOrActiveSpin();
                _this7._revertState();
            };

            this.prepareInitialRequest(function () {
                _this7.rpcRequest = (0, _jquery_rpc2.default)("UserManagementService.getUsers", params, successHandler, failHandler);
            }, withDelay);
        }
    }, {
        key: '_revertState',
        value: function _revertState() {
            this._revertUI();
            this.newState = _jquery2.default.extend(true, {}, this.currentState);
        }
    }, {
        key: '_revertUI',
        value: function _revertUI() {
            this.managementFilter.setState({
                selectedValue: this.currentState.userListSettings.filter.managementFilter
            });
            this.showDisabledUsersChBox.setState({
                checked: this.currentState.userListSettings.filter.showDisabled
            });
            this.wordsFilterComponent.setState({
                test: this.currentState.searchText
            });
            this.pagerController.setRecordsPerPage(this.currentState.recordsPerPage);
        }
    }, {
        key: '_updateCurrentState',
        value: function _updateCurrentState(userListPageData) {
            this.currentState.recordsPerPage = this.newState.recordsPerPage;
            this.currentState.userListOrder.order = this.newState.userListOrder.order;
            this.currentState.userListOrder.asc = this.newState.userListOrder.asc;
            this.currentState.searchText = this.newState.searchText;
            this.currentState.totalRecords = userListPageData.totalRecords;
            this.currentState.pageNum = userListPageData.pageNum;
            this.currentState.viewerSettings = userListPageData.viewerSettings;
            this.currentState.userListSettings.filter.showDisabled = this.newState.userListSettings.filter.showDisabled;
            this.currentState.userListSettings.filter.userIds = this.newState.userListSettings.filter.userIds;
            this.currentState.userListSettings.filter.groupIds = this.newState.userListSettings.filter.groupIds;
            this.currentState.userListSettings.filter.groupType = this.newState.userListSettings.filter.groupType;
            this.currentState.userListSettings.filter.allSelected = this.newState.userListSettings.filter.allSelected;
            this.currentState.userListSettings.filter.managementFilter = this.newState.userListSettings.filter.managementFilter;
            this.currentState.noUsersShown = userListPageData.records.length <= 0;
        }
    }, {
        key: '_updateCurrentStateFromUserData',
        value: function _updateCurrentStateFromUserData(userData) {
            var oldFeatures = this.currentState.viewerSettings.enabledFeatures;
            var newFeatures = userData.userManagementData.viewerSettings.enabledFeatures;

            var featureDiff = new _FeaturesDiffStateController2.default().init(oldFeatures, newFeatures);
            var areRightsChanged = this._areUserRightsChanged(this.currentState.viewerSettings, userData.userManagementData.viewerSettings);

            window.SystemSettings.dateFormat = userData.userManagementData.dateFormat;

            this.currentState.viewerSettings = userData.userManagementData.viewerSettings;

            return { featureDiff: featureDiff, areRightsChanged: areRightsChanged };
        }
    }, {
        key: '_updateUsersExportDropdown',
        value: function _updateUsersExportDropdown() {
            this.exportUsersDropdown.setState({
                filter: this.currentState.userListSettings.filter,
                tokens: this.tokens || [],
                userListOrder: this.currentState.userListOrder,
                userCount: this.currentState.totalRecords,
                balanceHoursPerDay: this.ptoHoursPerDay,
                isDisabled: this.currentState.noUsersShown
            });
        }
    }, {
        key: '_getDiffBetweenFeaturesAndRights',
        value: function _getDiffBetweenFeaturesAndRights(data, oldFeatureDiff) {
            var currentState = this.currentState;
            var oldFeatures = currentState.viewerSettings.enabledFeatures;
            var newFeatures = data.viewerSettings.enabledFeatures;
            var newFeatureDiff = new _FeaturesDiffStateController2.default().init(oldFeatures, newFeatures);
            if (oldFeatureDiff !== null) {
                if (newFeatureDiff.featuresChanged) newFeatureDiff = this._intersectTwoSuccessiveFeaturesChanges(oldFeatureDiff, newFeatureDiff);else newFeatureDiff = oldFeatureDiff;
            }

            return {
                // !Note, that the _getFeatureDiff() method changes the oldFeatures object.
                // If you will need it later, make its copy before calling this method.
                featureDiff: newFeatureDiff,
                userRightsChanged: this._areUserRightsChanged(currentState.viewerSettings, data.viewerSettings),
                areAllowedToManageAccountSettingsChanged: this._areAllowedToManageAccountSettingsChanged(currentState.viewerSettings, data.viewerSettings),
                areAllowedToManageLeaveBalanceSettingsChanged: this._areAllowedToManageLeaveBalanceSettingsChanged(currentState.viewerSettings, data.viewerSettings),
                showAccountSettingsChanged: this._areShowAccountSettingsChanged(currentState.viewerSettings, data.viewerSettings)
            };
        }
    }, {
        key: '_getDiffBetweenStates',
        value: function _getDiffBetweenStates(data) {

            var currentState = this.currentState;
            var oldLicense = currentState.license;
            var newLicense = this.newState.license;
            var oldShowDisabledUsers = this.currentState.userListSettings.filter.showDisabled;
            var newShowDisabledUsers = this.newState.userListSettings.filter.showDisabled;
            var oldNoUsersShown = currentState.noUsersShown;
            var newNoUsersShown = data.records.length <= 0;

            var result = this._getDiffBetweenFeaturesAndRights(data, null);
            result.licenseChanged = this._isLicenseChanged(oldLicense, newLicense);
            result.numOfRecordsChanged = oldNoUsersShown !== newNoUsersShown || oldShowDisabledUsers !== newShowDisabledUsers;
            result.groupTypeChanged = currentState.userListSettings.filter.groupType !== this.newState.userListSettings.filter.groupType;

            return result;
        }
    }, {
        key: '_isLicenseChanged',
        value: function _isLicenseChanged(oldLicense, newLicense) {

            return oldLicense.allowedCount !== newLicense.allowedCount || oldLicense.actualCount !== newLicense.actualCount;
        }
    }, {
        key: '_areUserRightsChanged',
        value: function _areUserRightsChanged(oldViewerSettings, newViewerSettings) {
            return this._areAllowedToManageAccountSettingsChanged(oldViewerSettings, newViewerSettings) || this._areAllowedToManageLeaveBalanceSettingsChanged(oldViewerSettings, newViewerSettings) || this._areShowAccountSettingsChanged(oldViewerSettings, newViewerSettings);
        }
    }, {
        key: '_areAllowedToManageAccountSettingsChanged',
        value: function _areAllowedToManageAccountSettingsChanged(oldViewerSettings, newViewerSettings) {
            return oldViewerSettings.allowedToManageAccountSettings !== newViewerSettings.allowedToManageAccountSettings;
        }
    }, {
        key: '_areShowAccountSettingsChanged',
        value: function _areShowAccountSettingsChanged(oldViewerSettings, newViewerSettings) {
            return oldViewerSettings.showAccountSettings !== newViewerSettings.showAccountSettings;
        }
    }, {
        key: '_areAllowedToManageLeaveBalanceSettingsChanged',
        value: function _areAllowedToManageLeaveBalanceSettingsChanged(oldViewerSettings, newViewerSettings) {
            return oldViewerSettings.allowedToManageLeaveBalanceSettings !== newViewerSettings.allowedToManageLeaveBalanceSettings;
        }

        //this method intersect two successive changes features  (nedded for show popups user)

    }, {
        key: '_intersectTwoSuccessiveFeaturesChanges',
        value: function _intersectTwoSuccessiveFeaturesChanges(oldFeaturesDiff, newFeaturesDiff) {
            for (var f in oldFeaturesDiff.addedFeatures) {
                if (newFeaturesDiff.deletedFeatures[f]) {
                    delete oldFeaturesDiff.addedFeatures[f];
                    delete newFeaturesDiff.deletedFeatures[f];
                }
            }
            for (var _f in oldFeaturesDiff.deletedFeatures) {
                if (newFeaturesDiff.addedFeatures[_f]) {
                    delete oldFeaturesDiff.deletedFeatures[_f];
                    delete newFeaturesDiff.addedFeatures[_f];
                }
            }
            for (var _f2 in newFeaturesDiff.addedFeatures) {
                oldFeaturesDiff.addedFeatures[_f2] = true;
            }
            for (var _f3 in newFeaturesDiff.deletedFeatures) {
                oldFeaturesDiff.deletedFeatures[_f3] = true;
            }

            oldFeaturesDiff.validateFeaturesChanged();
            return oldFeaturesDiff;
        }
    }, {
        key: '_userListPageDataReceived',
        value: function _userListPageDataReceived(userListPageData) {
            var diffBetweenStates = this._getDiffBetweenStates(userListPageData);
            this._updateCurrentState(userListPageData);

            if (!this.validateIsChangedFeaturesOrRights(diffBetweenStates, false)) return;

            this.ptoHoursPerDay = userListPageData.ptoHoursPerDay;

            if (this._isUGREnabled() || this._isTZGEnabled()) {
                var previouslySelectedGroupIds = this._rebuildGroupMapAndUpdateFilter(userListPageData.allUserGroups, userListPageData.allTimeZoneGroups);
                if (this.currentState.userListSettings.filter.groupType === _GroupType2.default.USER_GROUP) {
                    for (var groupId in previouslySelectedGroupIds.userGroups) {
                        if (!this.userGroupMap[groupId]) {
                            this._onGroupDeletedCallBack();
                            break;
                        }
                    }
                } else if (this.currentState.userListSettings.filter.groupType === _GroupType2.default.TIME_ZONE_GROUP) {
                    for (var _groupId in previouslySelectedGroupIds.timeZoneGroups) {
                        if (!this.timeZoneGroupMap[_groupId]) {
                            this._onGroupDeletedCallBack();
                            break;
                        }
                    }
                }
            }

            this.pagerController.setPagerStateAndUpdateUI(this.currentState.totalRecords, this.currentState.pageNum, this.currentState.recordsPerPage);

            this.userTableController.setUserTableStateAndUpdateUI(userListPageData.records, this.userGroupMap, this.timeZoneGroupMap, userListPageData.usersWithoutApprovers, this.currentState.viewerSettings, this.currentState.userListOrder, this.tokens, this._isPTOEnabled(), this.ptoHoursPerDay);

            if (diffBetweenStates.featureDiff.areFeaturesChanged() || diffBetweenStates.licenseChanged) this._updateUIAccordingToViewerPermissions();

            var userGroupIds = this.currentState.userListSettings.filter.groupIds;
            var userIds = this.currentState.userListSettings.filter.userIds;

            if (diffBetweenStates.numOfRecordsChanged || diffBetweenStates.groupTypeChanged) this.toggleNoUsersCaption(userListPageData.records.length, userGroupIds && userGroupIds.length > 0 || userIds && userIds.length > 0);

            this.showDisabledUsersChBox.setState({
                checked: this.currentState.userListSettings.filter.showDisabled
            });

            this._updateUsersExportDropdown();

            this._scrollToTableTop();
        }
    }, {
        key: '_scrollToTableTop',
        value: function _scrollToTableTop() {
            var windowTop = (0, _jquery2.default)(window).scrollTop();
            var topPositionMustBeVisible = this.$userListTableContainer.offset().top - 55;

            if (windowTop > topPositionMustBeVisible) {
                window.scrollTo(0, topPositionMustBeVisible);
            }
        }
    }, {
        key: '_updateUIAccordingToViewerPermissions',
        value: function _updateUIAccordingToViewerPermissions() {
            this.pageBodyEl.className = this._getPageBodyClasses();
        }
    }, {
        key: '_hasManageAccountSettings',
        value: function _hasManageAccountSettings() {
            return this.currentState.viewerSettings.allowedToManageAccountSettings;
        }
    }, {
        key: '_getPageBodyClasses',
        value: function _getPageBodyClasses() {
            var classes = [];
            if (!this._hasManageAccountSettings()) {
                classes.push("addUserHidden");
                classes.push("editGroupsHidden");
            }

            if (!this._isUGREnabled()) classes.push("ugrDisabled");

            if (!this._isTZGEnabled()) classes.push("tzgDisabled");

            classes.push("usersManagement pageBody");

            return classes.join(" ");
        }
    }, {
        key: '_isUGREnabled',
        value: function _isUGREnabled() {
            return this.validateEnabledFeature(_constants2.UserManagementConstants.UGRFeature);
        }
    }, {
        key: '_isTZGEnabled',
        value: function _isTZGEnabled() {
            return this.validateEnabledFeature(_constants2.UserManagementConstants.TZGFeature);
        }
    }, {
        key: '_onFeatureChanged',
        value: function _onFeatureChanged(isEnablesFeature, featureTitle, needReload) {
            var msg = _messageResource2.default.getMessage("userlist.js.error_change_feature.prefix");
            msg += " ";
            msg += isEnablesFeature ? _messageResource2.default.getMessage("userlist.js.error_change_feature.enabled") : _messageResource2.default.getMessage("userlist.js.error_change_feature.disabled");
            msg += " ";
            msg += featureTitle;
            msg += " ";
            msg += needReload ? _messageResource2.default.getMessage("userlist.js.error_change_feature.suffix_reloaded") : _messageResource2.default.getMessage("userlist.js.error_change_feature.suffix_updated");

            alert(msg);

            if (needReload) this._reloadPage();
        }
    }, {
        key: '_onShowPTOSettingsChanged',
        value: function _onShowPTOSettingsChanged() {
            var ptoEnabled = this._isPTOEnabled();
            var sickEnabled = this._isSickEnabled();
            var haveRightMsg = void 0;
            var noRightMsg = void 0;
            if (ptoEnabled && sickEnabled) {
                haveRightMsg = "userlist.js.error_have_right_to_view_pto_and_sick_tabs";
                noRightMsg = "userlist.js.error_no_right_to_view_pto_and_sick_tabs";
            } else if (ptoEnabled) {
                haveRightMsg = "userlist.js.error_have_right_to_view_pto_tab";
                noRightMsg = "userlist.js.error_no_right_to_view_pto_tab";
            } else if (sickEnabled) {
                haveRightMsg = "userlist.js.error_have_right_to_view_sick_tab";
                noRightMsg = "userlist.js.error_no_right_to_view_sick_tab";
            }
            this._onRightChanged(this.currentState.viewerSettings.allowedToManageLeaveBalanceSettings, haveRightMsg, noRightMsg);
        }
    }, {
        key: '_onShowAccountSettingsChanged',
        value: function _onShowAccountSettingsChanged() {
            this._onRightChanged(this._isAccountSettingsVisible(), "userlist.js.error_have_right_to_view_account_tab", "userlist.js.error_no_right_to_view_account_tab");
        }
    }, {
        key: '_onManageAccountSettingsChanged',
        value: function _onManageAccountSettingsChanged() {
            this._onRightChanged(this._hasManageAccountSettings(), "userlist.js.error_have_right_to_manage_account", "userlist.js.error_no_right_to_view_account_tab_readonly");
        }
    }, {
        key: '_onRightChanged',
        value: function _onRightChanged(isVisible, keyTextHaveRights, keyTextNotHaveRights) {
            var _this8 = this;

            var messageKey = isVisible ? keyTextHaveRights : keyTextNotHaveRights;
            alert(_messageResource2.default.getMessage(messageKey));

            if (isVisible) {
                this.getSortedUserList(function (userListPageData) {

                    _this8.actions.setStateOnPageDataReceivedAction({
                        licenseCounters: userListPageData.licenseCounters,
                        viewerSettings: userListPageData.viewerSettings,
                        usersWithoutApprovers: userListPageData.usersWithoutApprovers,
                        allUserGroups: userListPageData.allUserGroups,
                        allTimeZoneGroups: userListPageData.allTimeZoneGroups,
                        records: userListPageData.records
                    });

                    _this8._updateCurrentState(userListPageData);

                    _this8.userTableController.setState({
                        ptoDefaults: userListPageData.ptoDefaults,
                        sickDefaults: userListPageData.sickDefaults
                    });

                    _this8.userTableController.setUserTableStateAndUpdateUI(userListPageData.records, _this8.userGroupMap, _this8.timeZoneGroupMap, userListPageData.usersWithoutApprovers, _this8.currentState.viewerSettings, _this8.currentState.userListOrder, _this8.tokens, _this8._isPTOEnabled(), _this8.ptoHoursPerDay);
                });
            }
        }
    }, {
        key: '_onUGRChanged',
        value: function _onUGRChanged() {
            this._onFeatureChanged(this._isUGREnabled(), _messageResource2.default.getMessage("userlist.js.error_change_feature.user_groups"), true);
        }
    }, {
        key: '_onTZGChanged',
        value: function _onTZGChanged() {
            this._onFeatureChanged(this._isTZGEnabled(), _messageResource2.default.getMessage("userlist.js.error_change_feature.time_zone_groups"), true);
        }
    }, {
        key: '_onPTOChanged',
        value: function _onPTOChanged() {
            this._onFeatureChanged(this._isPTOEnabled(), _messageResource2.default.getMessage("features.PTO.title"), true);
        }
    }, {
        key: '_onSickChanged',
        value: function _onSickChanged() {
            this._onFeatureChanged(this._isSickEnabled(), _messageResource2.default.getMessage("features.SDB.title"), true);
        }
    }, {
        key: '_onTTAChanged',
        value: function _onTTAChanged() {
            this._onFeatureChanged(this._isTTAEnabled(), _messageResource2.default.getMessage("features.TTA.title"), true);
        }
    }, {
        key: '_onOVRChanged',
        value: function _onOVRChanged() {
            this._onFeatureChanged(this._isOVREnabled(), _messageResource2.default.getMessage("features.OVR.title"), false);
        }
    }, {
        key: '_onURAChanged',
        value: function _onURAChanged() {
            this._onFeatureChanged(this._isURAEnabled(), _messageResource2.default.getMessage("features.URA.title"), false);
        }
    }, {
        key: '_onLVTChanged',
        value: function _onLVTChanged() {
            this._onFeatureChanged(this._isLVTEnabled(), _messageResource2.default.getMessage("features.LVT.title"), false);
        }
    }, {
        key: '_onGenerateMoneyReportsRightChanged',
        value: function _onGenerateMoneyReportsRightChanged() {
            if (this._isGenerateMoneyReportEnabled()) alert(_messageResource2.default.getMessage("userlist.js.alert_change_features.money_reports_enabled"));else alert(_messageResource2.default.getMessage("userlist.js.alert_change_features.money_reports_disabled"));
        }
    }, {
        key: '_isPTOEnabled',
        value: function _isPTOEnabled() {
            return this.validateEnabledFeature(_constants2.UserManagementConstants.PTOFeature);
        }
    }, {
        key: '_isSickEnabled',
        value: function _isSickEnabled() {
            return this.validateEnabledFeature(_constants2.UserManagementConstants.SDBFeature);
        }
    }, {
        key: '_isTTAEnabled',
        value: function _isTTAEnabled() {
            return this.validateEnabledFeature(_constants2.UserManagementConstants.TTAFeature);
        }
    }, {
        key: '_isWASEnabled',
        value: function _isWASEnabled() {
            return this.validateEnabledFeature(_constants2.UserManagementConstants.WASFeature);
        }
    }, {
        key: '_isURAEnabled',
        value: function _isURAEnabled() {
            return this.validateEnabledFeature(_constants2.UserManagementConstants.URAFeature);
        }
    }, {
        key: '_isOVREnabled',
        value: function _isOVREnabled() {
            return this.validateEnabledFeature(_constants2.UserManagementConstants.OVRFeature);
        }
    }, {
        key: '_isLVTEnabled',
        value: function _isLVTEnabled() {
            return this.validateEnabledFeature(_constants2.UserManagementConstants.LVTFeature);
        }
    }, {
        key: '_isBTYEnabled',
        value: function _isBTYEnabled() {
            return this.validateEnabledFeature(_constants2.UserManagementConstants.BTYFeature);
        }
    }, {
        key: '_isGenerateMoneyReportEnabled',
        value: function _isGenerateMoneyReportEnabled() {
            return this._isURAEnabled() || this._isBTYEnabled();
        }
    }, {
        key: '_isAccountSettingsVisible',
        value: function _isAccountSettingsVisible() {
            return this.currentState.viewerSettings.showAccountSettings;
        }
    }, {
        key: '_isPTOSettingsVisible',
        value: function _isPTOSettingsVisible() {
            return this.currentState.viewerSettings.allowedToManageLeaveBalanceSettings && this._isPTOEnabled();
        }
    }, {
        key: '_isSickDaysSettingsVisible',
        value: function _isSickDaysSettingsVisible() {
            return this.currentState.viewerSettings.allowedToManageLeaveBalanceSettings && this._isSickEnabled();
        }
    }, {
        key: 'validateEnabledFeature',
        value: function validateEnabledFeature(featureName) {
            return this.currentState.viewerSettings.enabledFeatures.hasOwnProperty(featureName);
        }
    }, {
        key: '_pageNumChangedCallback',
        value: function _pageNumChangedCallback(pageNum) {
            var _this9 = this;

            this.newState.pageNum = pageNum;

            this.getSortedUserList(function (userListPageData) {
                _this9._userListPageDataReceived(userListPageData);

                if (_this9._hasManageAccountSettings()) {
                    // TODO global variable?
                    window.licenseChanged = _this9._isLicenseChanged(_this9.currentState.license, userListPageData.licenseCounters);
                    _this9.currentState.license = userListPageData.licenseCounters;
                    _this9._updateUIAccordingToViewerPermissions();
                }
            });
        }
    }, {
        key: '_recordsPerPageChangedCallback',
        value: function _recordsPerPageChangedCallback(recordsPerPage) {
            this.newState.recordsPerPage = recordsPerPage;
            this.pagerController.loadPage(1);
        }
    }, {
        key: '_sortingChangedCallback',
        value: function _sortingChangedCallback(event, order) {
            //this.spinner.spin(this.spinnerEl);
            this.userTableController.removeTrSpacers();

            this.newState.userListOrder.asc = order !== this.currentState.userListOrder.order || !this.currentState.userListOrder.asc;
            this.newState.userListOrder.order = order;
            this.newState.pageNum = 1;

            this.tableControls.setState({
                sorting: this.newState.userListOrder
            });

            this.pagerController.loadPage(1);
            //this.spinner.stop();
        }
    }, {
        key: '_searchTermsChangedCallback',
        value: function _searchTermsChangedCallback(inputText) {
            this.userTableController.removeTrSpacers();
            this._searchTerms(inputText);
        }
    }, {
        key: '_searchTerms',
        value: function _searchTerms(text) {
            this.newState.searchText = text;
            if (this.currentState.searchText !== this.newState.searchText) {
                var pagerController = this.pagerController;

                // set timer to make request later to prevent from too fast keyboard typing
                this.prepareInitialRequest(function () {
                    return pagerController.loadPage(1);
                }, true);
            }
        }
    }, {
        key: '_filterByUsersChangedCallBack',
        value: function _filterByUsersChangedCallBack(showDisabled, userIds, groupIds, groupType, allSelected) {
            this.newState.userListSettings.filter.showDisabled = showDisabled;
            this.newState.userListSettings.filter.userIds = userIds;
            this.newState.userListSettings.filter.groupIds = groupIds;
            this.newState.userListSettings.filter.groupType = groupType;
            this.newState.userListSettings.filter.allSelected = allSelected;
            this.pagerController.loadPage(1);
        }
    }, {
        key: '_filterChange',
        value: function _filterChange(nameFilter, value) {
            //this.spinner.spin(this.spinnerEl);
            this.newState.userListSettings.filter[nameFilter] = value;
            this.pagerController.loadPage(1);
            //this.spinner.stop();
        }
    }, {
        key: '_onGroupDeletedCallBack',
        value: function _onGroupDeletedCallBack() {
            this.usersFilter.setState({
                groupType: this.currentState.userListSettings.filter.groupType,
                groupIds: []
            });
            this._filterByUsersChangedCallBack(this.currentState.userListSettings.filter.showDisabled, this.currentState.userListSettings.filter.userIds, null, this.currentState.userListSettings.filter.groupType, this.currentState.userListSettings.filter.allSelected);
        }
    }, {
        key: '_departmentsChanged',
        value: function _departmentsChanged(departmentController) {
            this.pagerController.loadPage(1); // need to reload user list because assignments can be changed

            var noGroupObj = departmentController.storedData.shift();
            var previouslySelectedGroupIds = this._rebuildGroupMapAndUpdateFilter(departmentController.storedData, this.timeZoneGroupList);

            var deletedGroupFind = false;
            for (var groupId in previouslySelectedGroupIds.userGroups) {
                if (!this.userGroupMap[groupId]) {
                    this._onGroupDeletedCallBack(); // reload page data if group deleted
                    deletedGroupFind = true;
                    break;
                }
            }

            departmentController.storedData.unshift(noGroupObj);
            var userIdGroupIdMap = this.convertToUserToGroupMap(departmentController.storedData);
            this.actions.updateDepartments((0, _groupUtils.transformListToGroups)(departmentController.storedData));
            this.actions.updateUsersGroups(userIdGroupIdMap);
            this.userTableController.updateUserGroups(userIdGroupIdMap, this.userGroupMap);
        }
    }, {
        key: '_timeZoneGroupsChanged',
        value: function _timeZoneGroupsChanged(timeZoneGroupController) {
            var previouslySelectedTimeZoneGroupIds = this._rebuildGroupMapAndUpdateFilter(this.userGroupList, timeZoneGroupController.storedData);

            var deletedGroupFind = false;
            for (var groupId in previouslySelectedTimeZoneGroupIds.timeZoneGroups) {
                if (!this.timeZoneGroupMap[groupId]) {
                    this._onGroupDeletedCallBack(); // reload page data if group deleted
                    deletedGroupFind = true;
                    break;
                }
            }

            var userIdGroupIdMap = this.convertToUserToGroupMap(timeZoneGroupController.storedData);
            this.userTableController.updateTimeZoneGroups(userIdGroupIdMap, this.timeZoneGroupMap);
            this.actions.updateUsersTimeZoneGroups(userIdGroupIdMap);
            this.actions.updateTimeZoneGroups(timeZoneGroupController.storedData);
        }
    }, {
        key: '_rebuildGroupMapAndUpdateFilter',
        value: function _rebuildGroupMapAndUpdateFilter(userGroupList, timeZoneGroupList) {
            this.userGroupMap = this._initGroupMap(userGroupList, true);
            this.timeZoneGroupMap = this._initGroupMap(timeZoneGroupList, false);

            var previouslySelectedGroupIds = { userGroups: null, timeZoneGroups: null };

            var ids = this.currentState.userListSettings.filter.groupIds;
            if (this._isUGREnabled()) {
                this.userGroupList = userGroupList;
                previouslySelectedGroupIds.userGroups = ids !== null ? (0, _atUtils.arrayToSet)(ids) : {};
            }
            if (this._isTZGEnabled()) {
                this.timeZoneGroupList = timeZoneGroupList;
                previouslySelectedGroupIds.timeZoneGroups = ids !== null ? (0, _atUtils.arrayToSet)(ids) : {};
            }

            this.usersFilter.setState({
                userGroups: userGroupList !== null ? (0, _groupUtils.transformListToGroups)((0, _groupUtils.addDefaultUserGroup)(userGroupList)) : null,
                timeZoneGroups: (0, _groupUtils.transformListToGroups)(this.timeZoneGroupList),
                groupType: this.currentState.userListSettings.filter.groupType,
                userIds: this.currentState.userListSettings.filter.userIds || [],
                groupIds: ids || [],
                allSelected: this.currentState.userListSettings.filter.allSelected
            });
            return previouslySelectedGroupIds;
        }
    }, {
        key: '_updateGroupsOnUserCreateOrUpdate',
        value: function _updateGroupsOnUserCreateOrUpdate(groupList, timeZoneGroupsList) {
            if (this._isUGREnabled() || this._isTZGEnabled()) this._rebuildGroupMapAndUpdateFilter(groupList, timeZoneGroupsList);

            if (this._isUGREnabled()) {
                var userIdGroupIdMap = this.userTableController.makeUserIdGroupIdMapForVisibleUser();
                this.userTableController.updateUserGroups(userIdGroupIdMap, this.userGroupMap);
            }
            if (this._isTZGEnabled()) {
                var timeZoneIdGroupIdMap = this.userTableController.makeTimeZoneIdGroupIdMapForVisibleUser();
                this.userTableController.updateTimeZoneGroups(timeZoneIdGroupIdMap, this.timeZoneGroupMap);
            }
        }
    }, {
        key: 'convertToUserToGroupMap',
        value: function convertToUserToGroupMap(groupWithUsersList) {
            var userGroupMap = {};

            for (var i = 0; i < groupWithUsersList.length; i++) {
                var group = groupWithUsersList[i];
                var users = group.users;

                if (users) for (var j = 0; j < users.length; j++) {
                    var userId = group.users[j].id;
                    userGroupMap[userId] = group.id;
                }
            }

            return userGroupMap;
        }
    }, {
        key: 'start',
        value: function start() {
            var _this10 = this;

            this.showDisabledUsersChBox = new _CustomCheckbox2.default({
                label: _messageResource2.default.getMessage('userlist.show_disabled_users'),
                onChange: function onChange(_ref3) {
                    var checked = _ref3.checked;

                    _this10.onShowDisabledUsersCallBack(checked);
                },
                checkboxTitleAdditionalClass: 'title'
            }).init((0, _jquery2.default)(document.getElementsByClassName("disabledAccountsCheckboxContainer")));
            this.showDisabledUsersChBox.setState({
                checked: this.currentState.userListSettings.filter.showDisabled
            });

            this.pagerController.render();
            this.initHeaderSelectorsFunction();
        }
    }, {
        key: 'cl',
        value: function cl(func) {
            var _this11 = this,
                _arguments = arguments;

            return function () {
                func.apply(_this11, _arguments);
            };
        }
    }, {
        key: 'createUser',
        value: function createUser() {
            this.actions.openCreateUserPanel();
        }
    }, {
        key: 'importUsersFinished',
        value: function importUsersFinished(importedUsersData) {
            var _this12 = this;

            var userIds = importedUsersData.map(function (data) {
                return data.id;
            });
            var warningsPerUserId = new Map();
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = importedUsersData[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var _ref5 = _step.value;
                    var id = _ref5.id,
                        licenseViolated = _ref5.licenseViolated;

                    if (licenseViolated) {
                        warningsPerUserId.set(id, [_constants2.UserManagementConstants.WARNING_ACCOUNT_DISABLED_DUE_TO_LICENSE_TERMS]);
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            if (userIds.length === 0) return;
            (0, _jquery_rpc2.default)("UserManagementService.getCreatedUsers", [userIds], function (usersData) {
                // add warnings
                var _iteratorNormalCompletion2 = true;
                var _didIteratorError2 = false;
                var _iteratorError2 = undefined;

                try {
                    for (var _iterator2 = usersData.additionalUsersInfo[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                        var user = _step2.value;

                        if (warningsPerUserId.has(user.id)) {
                            user.warnings = warningsPerUserId.get(user.id);
                        }
                    }
                } catch (err) {
                    _didIteratorError2 = true;
                    _iteratorError2 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion2 && _iterator2.return) {
                            _iterator2.return();
                        }
                    } finally {
                        if (_didIteratorError2) {
                            throw _iteratorError2;
                        }
                    }
                }

                var $body = (0, _jquery2.default)("body");
                var scrollTop = $body.scrollTop();
                _this12.createCallSucceeded(usersData, null, true, null, usersData.additionalUsersInfo, null);
                $body.scrollTop(scrollTop);
                _this12.actions.setStateOnInviteSeveralUsersSuccess(usersData);
            });
        }
    }, {
        key: 'inviteSeveralUsers',
        value: function inviteSeveralUsers() {
            var _this13 = this;

            this._abortRequestsAndRevertState();

            this._showInviteUsersPopupLoadingMoire();
            (0, _jquery_rpc2.default)("UserManagementService.getInviteSeveralUsersData", [], function (inviteUsersData) {
                _this13.showInviteSeveralUsersPopup(inviteUsersData);
            }, function (jqXHR, textStatus, errorThrown) {
                _this13._hideInviteUsersPopupLoadingMoire();

                if (errorThrown.exception === 'com.actimind.actitime.services.NoRightsToManageAccountSettings') {
                    alert(_messageResource2.default.getMessage('userlist.js.error_cant_create_user_account'));
                    document.location.reload();
                    return true;
                }
                if (errorThrown.msg.indexOf('com.actimind.common.licensing.NoActiveLicensesException') !== -1) {
                    alert(_messageResource2.default.getMessage('common.license_expired_exception.reload_page'));
                    document.location.reload();
                    return true;
                }
                return false;
            });
        }
    }, {
        key: 'showInviteSeveralUsersPopup',
        value: function showInviteSeveralUsersPopup(inviteUsersData) {
            var _this14 = this;

            this._hideInviteUsersPopupLoadingMoire();

            var lb = new _ATInviteSeveralUsersLightBox2.default().init({
                inviteUsersData: inviteUsersData,
                onChangePermissionsTemplates: function onChangePermissionsTemplates(_ref6) {
                    var templates = _ref6.templates;
                    _this14.actions.updateUserManagementData({ permissionsTemplates: templates });
                },
                onHideCallback: function onHideCallback() {
                    // show getting started menu if need
                    if (!_underscore2.default.isUndefined(window.GettingStartedShortcuts)) {
                        window.GettingStartedShortcuts.showJustCheckedShortcutIfExists();
                    }
                }
            });

            this.inviteSeveralUsersPopup = lb;
            var changes = this._updateCurrentStateFromUserData(inviteUsersData);
            var pageUIMustBeUpdated = changes.featureDiff.areFeaturesChanged() || changes.areRightsChanged;

            lb.setSuccessCallback(function (userFieldsArray) {
                if (userFieldsArray.length === 0) {
                    return;
                }
                lb.disableUserInputWhileSaving();
                (0, _jquery_rpc2.default)("UserManagementService.inviteUsers", [userFieldsArray], function (inviteUsersResult) {
                    lb.enableUserInputWhileSaving();
                    _this14.createSeveralUsersCallSucceeded(inviteUsersResult, lb, pageUIMustBeUpdated, changes.featureDiff);
                    _this14.actions.setStateOnInviteSeveralUsersSuccess(inviteUsersResult);
                }, function (jqXHR, textStatus, errorThrown) {
                    lb.enableUserInputWhileSaving();
                    if (errorThrown.exception === "com.actimind.actitime.services.InviteSeveralUsersExceptionWithPermissionsTemplates") {
                        lb.showServerErrors(errorThrown.userTableErrors);
                        lb.updatePermissionsTemplatesData(errorThrown.permissionsTemplates);
                        return true;
                    }
                    if (errorThrown.exception === "com.actimind.actitime.administration.UserExistsException") {
                        alert(_messageResource2.default.getMessage("userlist.js.invite_user_mode_popup.duplicate_username"));
                        return true;
                    }
                    return false;
                });
            });
            lb.setCancelCallback(function () {
                lb.hide();

                if (!_this14.validateIsChangedFeaturesOrRights(changes)) {
                    if (pageUIMustBeUpdated) _this14._updateUIAccordingToViewerPermissions();
                    return;
                }

                _this14._updateGroupsOnUserCreateOrUpdate(inviteUsersData.userManagementData.allUserGroups, inviteUsersData.userManagementData.allTimeZoneGroups);
            });
            lb.show();
        }
    }, {
        key: 'createSingleUserCallSucceeded',
        value: function createSingleUserCallSucceeded(createUserResult, createLightBox, pageUIMustBeUpdated, oldFeatureDiff, userId) {
            this.createCallSucceeded(createUserResult, createLightBox, pageUIMustBeUpdated, oldFeatureDiff, [createUserResult.userInfo], userId);
        }
    }, {
        key: 'createSeveralUsersCallSucceeded',
        value: function createSeveralUsersCallSucceeded(inviteUsersResult, inviteLightBox, pageUIMustBeUpdated, oldFeatureDiff) {
            var $body = (0, _jquery2.default)("body");
            var scrollTop = $body.scrollTop();
            var userId = inviteUsersResult.additionalUsersInfo ? inviteUsersResult.additionalUsersInfo[0].id : null;
            this.createCallSucceeded(inviteUsersResult, inviteLightBox, pageUIMustBeUpdated, oldFeatureDiff, inviteUsersResult.additionalUsersInfo, userId);
            $body.scrollTop(scrollTop);
            inviteLightBox.switchToUsersInvitedState(inviteUsersResult.additionalUsersInfo);
        }
    }, {
        key: 'createCallSucceeded',
        value: function createCallSucceeded(createResult, createLightBox, pageUIMustBeUpdated, oldFeatureDiff, userInfos, userId) {
            // mark on client that user(s) will be created
            if (!_underscore2.default.isUndefined(window.GettingStartedShortcuts) && userInfos.length > 0) {
                window.GettingStartedShortcuts.markShortcutAsChecked(window.GettingStartedShortcut.USERS);
            }

            var changeData = this._getDiffBetweenFeaturesAndRights(createResult, oldFeatureDiff);
            this.currentState.viewerSettings = createResult.viewerSettings;
            var featureDiff = changeData.featureDiff;

            if (!this.wasOperationSuccessful(createResult)) {
                this.handleError(createResult, createLightBox, userId);
            } else {

                pageUIMustBeUpdated |= featureDiff.areFeaturesChanged();

                var licenseChanged = false;

                if (this._hasManageAccountSettings()) {
                    licenseChanged = this._isLicenseChanged(this.currentState.license, createResult.licenseCounters);
                    this.currentState.license = createResult.licenseCounters;
                }

                this.validateIsChangedFeaturesOrRights(changeData);

                var groupName = void 0;

                this.actions.addNewUsersToList(userInfos);
                this._updateGroupsOnUserCreateOrUpdate(createResult.userGroups, createResult.timeZoneGroups);
                groupName = this._isUGREnabled() ? this.userGroupMap[userInfos[0].userGroupId] : " ";
                var timeZoneGroupName = this._isTZGEnabled() ? this.timeZoneGroupMap[userInfos[0].timeZoneGroupId] : " ";
                var warningMsgs = void 0;
                for (var i = userInfos.length - 1; i > -1; i--) {
                    var userInfo = userInfos[i];
                    warningMsgs = (0, _utils2.createWarningMsgs)(userInfo, true);
                    this.userTableController.addCreatedUser(userInfos[i], groupName, timeZoneGroupName, warningMsgs);
                }

                this.hideNoUsersCaptionAndBottomSpacer();

                if (createResult.additionalResultData !== null) {
                    var additionalData = createResult.additionalResultData.map;
                    if (additionalData[_constants4.AdditionalDataConstants.USERS_WITHOUT_APPROVERS_DATA]) {
                        this.userTableController.updateUsersWithoutApprovers(additionalData[_constants4.AdditionalDataConstants.USERS_WITHOUT_APPROVERS_DATA]);
                    }
                }

                if (pageUIMustBeUpdated || licenseChanged) this._updateUIAccordingToViewerPermissions();

                this.currentState.noUsersShown = false;
            }
        }

        /**
         * @param userResult
         * @param dialog {UserDataLightBox|LeaveBalanceEditor}
         * @param userId
         */

    }, {
        key: 'handleError',
        value: function handleError(userResult, dialog, userId) {
            var errorMessage = ErrorMap[userResult.resultCode];

            if (!errorMessage && userResult.resultCode === _constants2.UserManagementConstants.ERROR_BALANCE_CAP_EXCEEDED) {
                dialog.showCapExceededError(userResult.additionalResultData.map.cap);
                return false;
            }

            if (!errorMessage) throw "unknown user create/update/delete result error code:" + userResult.resultCode;

            if (userResult.resultCode === _constants2.UserManagementConstants.ERROR_NO_RIGHTS_TO_MANAGE_ACCOUNT_SETTINGS || userResult.resultCode === _constants2.UserManagementConstants.ERROR_NO_RIGHTS_TO_MANAGE_PTO_AND_SICK || userResult.resultCode === _constants2.UserManagementConstants.ERROR_PTO_FEATURE_DISABLED || userResult.resultCode === _constants2.UserManagementConstants.ERROR_PTO_CONTROL_DISABLED || userResult.resultCode === _constants2.UserManagementConstants.ERROR_SICK_CONTROL_DISABLED) {
                dialog.hide();
                alert(_messageResource2.default.getMessage(errorMessage));
                this._reloadPage();
                return true;
            }

            if (userResult.resultCode === _constants2.UserManagementConstants.ERROR_DUPLICATE_USERNAME) {
                dialog.handleSectionError(userResult.resultCode);
                return true;
            }

            if (userResult.resultCode === _constants2.UserManagementConstants.ERROR_NO_SUCH_USER) {
                dialog.hide();
                alert(_messageResource2.default.getMessage(errorMessage));
                this._deleteUser(userId);
                return false;
            }

            alert(_messageResource2.default.getMessage(errorMessage));
        }

        /**
         * @param updateUserResult
         * @param dialog {UserDataLightBox|LeaveBalanceEditor}
         * @param pageUIMustBeUpdated
         * @param oldFeatureDiff
         * @param userId
         * @param previousTimeZoneGroupId
         * @param customErrHandler
         * @param forceNoHighlight
         */

    }, {
        key: 'updateCallSucceeded',
        value: function updateCallSucceeded(updateUserResult, dialog, pageUIMustBeUpdated, oldFeatureDiff, userId) {
            var previousTimeZoneGroupId = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
            var customErrHandler = arguments[6];
            var forceNoHighlight = arguments[7];

            var changeData = this._getDiffBetweenFeaturesAndRights(updateUserResult, oldFeatureDiff);
            var featureDiff = changeData.featureDiff;
            var viewerSettings = updateUserResult.viewerSettings;
            this.currentState.viewerSettings = viewerSettings;

            if (updateUserResult.userInfo && updateUserResult.userInfo.id === this.loggedInUserId) {
                var isLeaveSettingsTabVisible = this.currentState.viewerSettings.allowedToManageLeaveBalanceSettings && (this._isPTOEnabled() || this._isSickEnabled());
                if (isLeaveSettingsTabVisible !== updateUserResult.userInfo.hasManagePTOAndSickRight) {
                    this.currentState.viewerSettings.allowedToManageLeaveBalanceSettings = updateUserResult.userInfo.hasManagePTOAndSickRight;
                    changeData.areAllowedToManageLeaveBalanceSettingsChanged = true;
                }
            }

            var successfulResult = this.wasOperationSuccessful(updateUserResult);

            if (!successfulResult) {
                if (dialog && !this.handleError(updateUserResult, dialog, userId)) return this.validateIsChangedFeaturesOrRights(changeData);else if (customErrHandler) customErrHandler(updateUserResult);
            } else {
                pageUIMustBeUpdated |= featureDiff.areFeaturesChanged();

                var licenseChanged = false;

                if (this._hasManageAccountSettings()) {
                    licenseChanged = this._isLicenseChanged(this.currentState.license, updateUserResult.licenseCounters);
                    this.currentState.license = updateUserResult.licenseCounters;
                }

                if (dialog) dialog.hide();

                this.validateIsChangedFeaturesOrRights(changeData);

                if (previousTimeZoneGroupId !== null && this.loggedInUserId === updateUserResult.userInfo.id && previousTimeZoneGroupId !== updateUserResult.userInfo.timeZoneGroupId) {
                    // update user list if user has changed his time zone
                    alert(_messageResource2.default.getMessage('userlist.js.time_zone_was_changed'));
                    this._reloadPage();
                    return;
                }

                this._updateGroupsOnUserCreateOrUpdate(updateUserResult.userGroups, updateUserResult.timeZoneGroups);
                var userInfo = updateUserResult.userInfo;
                this.updateUser(userInfo, viewerSettings, !forceNoHighlight);
                if (updateUserResult.additionalUsersInfo) {
                    var additionalUsersInfos = updateUserResult.additionalUsersInfo;
                    for (var i = 0; i < additionalUsersInfos.length; i++) {
                        this.updateUser(additionalUsersInfos[i], viewerSettings, false);
                    }
                }

                this._updateAdditionalData(updateUserResult);

                if (pageUIMustBeUpdated || licenseChanged) this._updateUIAccordingToViewerPermissions();
            }
        }
    }, {
        key: 'updateUser',
        value: function updateUser(userInfo, viewerSettings, isHighlight) {
            var groupName = this._isUGREnabled() ? this.userGroupMap[userInfo.userGroupId] : "";
            var timeZoneGroupName = this._isTZGEnabled() ? this.timeZoneGroupMap[userInfo.timeZoneGroupId] : "";

            var warningMsgs = (0, _utils2.createWarningMsgs)(userInfo, false);

            var editedUserIsLoggedInUser = userInfo.id === this.loggedInUserId;
            this.userTableController.updateUser(userInfo, viewerSettings, groupName, timeZoneGroupName, warningMsgs, editedUserIsLoggedInUser, !isHighlight);
        }
    }, {
        key: '_reloadPage',
        value: function _reloadPage() {
            location.reload();
        }
    }, {
        key: 'wasOperationSuccessful',
        value: function wasOperationSuccessful(userResult) {
            return userResult.resultCode === _constants2.UserManagementConstants.RESULT_CODE_SUCCESS;
        }
    }, {
        key: 'updateOrDeleteCallSucceeded',
        value: function updateOrDeleteCallSucceeded(confirmationNotNeededCallback) {
            if (confirmationNotNeededCallback) confirmationNotNeededCallback();
        }
    }, {
        key: 'updateOrDeleteCallFailed',
        value: function updateOrDeleteCallFailed(errorThrown, lightBox, resendRequestWithForceParameterCallback, hideLightBoxBeforeConfirmation) {
            var confirmationMessage = void 0;
            if (errorThrown.exception === "com.actimind.common.administration.EditUserConfirmationIsNeededException") confirmationMessage = new _UserListConfirmation2.default().createEditConfirmationMsg(errorThrown);else if (errorThrown.exception === "com.actimind.common.administration.DeleteUserConfirmationIsNeededException") confirmationMessage = new _UserListConfirmation2.default().createDeleteConfirmationMsg(errorThrown);else return false;

            if (hideLightBoxBeforeConfirmation) lightBox.hide();

            if (confirm(confirmationMessage)) resendRequestWithForceParameterCallback();else if (!hideLightBoxBeforeConfirmation) lightBox.enableUserInputWhileSaving();

            return true;
        }
    }, {
        key: 'deleteCallSucceeded',
        value: function deleteCallSucceeded(deleteUserResult, userId, editLightBox, pageUIMustBeUpdated, oldFeaturesDiff) {

            var changeData = this._getDiffBetweenFeaturesAndRights(deleteUserResult, oldFeaturesDiff);
            this.currentState.viewerSettings = deleteUserResult.viewerSettings;

            if (deleteUserResult.userGroups !== null || deleteUserResult.timeZoneGroups !== null) {
                this._updateGroupsOnUserCreateOrUpdate(deleteUserResult.userGroups, deleteUserResult.timeZoneGroups);
            }
            var licenses = deleteUserResult.licenseCounters;
            if (licenses !== null && (pageUIMustBeUpdated || this._isLicenseChanged(this.currentState.license, licenses))) {
                this.currentState.license = licenses;
                this._updateUIAccordingToViewerPermissions();
            }

            this._updateAdditionalData(deleteUserResult);

            var result = deleteUserResult.resultCode;
            if (result === _constants2.UserManagementConstants.RESULT_CODE_SUCCESS || result === _constants2.UserManagementConstants.ERROR_NO_SUCH_USER) {
                this._deleteUser(userId);
                this.actions.removeUserFromList(userId);
            } else {
                alert(_messageResource2.default.getMessage(ErrorMap[result]));
            }
            this.validateIsChangedFeaturesOrRights(changeData);
        }
    }, {
        key: '_deleteUser',
        value: function _deleteUser(userId) {
            this.userTableController.deleteUser(userId);
            if (this.userTableController.getRows().length === 0) {
                this.pagerController.reloadEmptyPage();
            }
        }
    }, {
        key: '_deleteUsers',
        value: function _deleteUsers(userIdsArray) {
            for (var i = 0, usersLength = userIdsArray.length; i < usersLength; i++) {
                try {
                    this.userTableController.deleteUser(userIdsArray[i]);
                } catch (e) {}
            } // user with this id is not on this page, move on

            if (this.userTableController.getRows().length === 0) {
                this.pagerController.reloadEmptyPage();
            }
        }
    }, {
        key: '_initFilters',
        value: function _initFilters() {
            var _this15 = this;

            this.managementFilter = new _ManagementFilter2.default({
                onChange: function onChange(value) {
                    _this15._filterChange('managementFilter', value);
                }
            }).init((0, _jquery2.default)('.userlist_managementFilter'));
            this.managementFilter.setState({
                selectedValue: this.currentState.userListSettings.filter.managementFilter
            });
        }
    }, {
        key: '_updateAdditionalData',
        value: function _updateAdditionalData(data) {
            if (data.additionalResultData !== null) {
                var additionalData = data.additionalResultData.map;
                if (additionalData[_constants4.AdditionalDataConstants.USERS_WITHOUT_APPROVERS_DATA]) {
                    this.userTableController.updateUsersWithoutApprovers(additionalData[_constants4.AdditionalDataConstants.USERS_WITHOUT_APPROVERS_DATA]);
                }

                if (additionalData[_constants4.AdditionalDataConstants.ALL_USERS_AUTOAPPROVED]) {
                    this.userTableController.setUsersAutoapproved();
                }
            }
        }
    }, {
        key: 'editUser',
        value: function editUser(cell, tab) {
            this._abortRequestsAndRevertState();
            var userId = cell.getValue().id;
            this.actions.openEditUserPanel(userId, tab);
        }
    }, {
        key: 'editTeamAssignments',
        value: function editTeamAssignments(cell) {
            this._abortRequestsAndRevertState();
            var userId = cell.getValue().id;
            this.actions.openTeamAssignmentsPanel(userId);
        }
    }, {
        key: 'editManagementAssignments',
        value: function editManagementAssignments(cell) {
            this._abortRequestsAndRevertState();
            var userId = cell.getValue().id;
            this.actions.openManagementAssignmentsPanel(userId, _constants3.HierarchyLevels.CUSTOMER);
        }
    }, {
        key: '_showInviteUsersPopupLoadingMoire',
        value: function _showInviteUsersPopupLoadingMoire() {
            this._inviteUsersLoadingMoire = new LoadingPopup().init("inviteUsersLoadingPopup");
            this._inviteUsersLoadingMoire.show();
        }
    }, {
        key: '_hideInviteUsersPopupLoadingMoire',
        value: function _hideInviteUsersPopupLoadingMoire() {
            this._inviteUsersLoadingMoire.hide();
        }
    }, {
        key: 'switchManagePTOAndSickRight',
        value: function switchManagePTOAndSickRight(cell) {
            var _this16 = this;

            this._abortRequestsAndRevertState();

            var cellValue = cell.getValue();
            var userId = cellValue.id;

            this.spinner.spin(this.spinnerEl);

            (0, _jquery_rpc2.default)('UserManagementService.setManagePTOAndSickRight', [userId, !cellValue.hasManagePTOAndSickRight], function (result) {
                _this16.spinner.stop();
                _this16.updateCallSucceeded(result, null, false, null, userId, undefined, _this16.defaultErrorHandler);
            }, function (jqXHR, textStatus, errorThrown) {
                _this16.spinner.stop();
                return _this16.handlePTOExceptions(errorThrown, userId, _this16);
            });
        }
    }, {
        key: 'editBalance',
        value: function editBalance(cell, balanceType) {
            var _this17 = this;

            this._abortRequestsAndRevertState();

            var cellValue = cell.getValue();
            var userId = cellValue.id;
            var userName = _UserNameFormat2.default.formatFML(cellValue.firstName, cellValue.lastName, cellValue.middleInitial);
            var currentBalance = void 0;
            var titleMessageKey = void 0;
            if (balanceType === _BalanceType2.default.PTO) {
                currentBalance = cellValue.currentPTOBalance.balance;
                titleMessageKey = 'common.pto_editor.title';
            }
            if (balanceType === _BalanceType2.default.SICK) {
                currentBalance = cellValue.currentSickDaysBalance.balance;
                titleMessageKey = 'common.sick_editor.title';
            }

            this.addRowSelection(cell);

            this.leaveBalanceEditor.show(cell.getCellEl(), currentBalance, userName, this.ptoHoursPerDay, balanceType, titleMessageKey);
            this.leaveBalanceEditor.setOnCloseCallback(function () {
                _this17.clearRowSelection(cell);
            });
            this.leaveBalanceEditor.setOnApplyCallback(function (correctionType, valueInDays, comment) {
                (0, _jquery_rpc2.default)("UserManagementService.addBalanceCorrection", [userId, correctionType, valueInDays, balanceType, comment], function (result) {
                    _this17.leaveBalanceEditor.busyModeOff();
                    _this17.updateCallSucceeded(result, _this17.leaveBalanceEditor, false, null, userId);
                }, function () {
                    _this17.leaveBalanceEditor.busyModeOff();
                });
            });
        }
    }, {
        key: 'handlePtoHistoryError',
        value: function handlePtoHistoryError(resultCode, userId) {
            if (resultCode === _constants2.UserManagementConstants.ERROR_NO_RIGHTS_TO_MANAGE_PTO_AND_SICK) {
                alert(_messageResource2.default.getMessage(ErrorMap[resultCode]));
                this._reloadPage();
            } else if (resultCode === _constants2.UserManagementConstants.ERROR_NO_SUCH_USER) {
                alert(_messageResource2.default.getEscapedMessage("userlist.js.error_no_such_user.short"));
                this._deleteUser(userId);
            }
        }
    }, {
        key: 'showSickHistory',
        value: function showSickHistory(cell) {
            this._balanceHistoryPanel.updateTitle(_messageResource2.default.getMessage("common.balance_history.balance_history_panel.title", [_messageResource2.default.getMessage("common.balance_history.table.sick")]));

            var config = {};
            config.balanceHistoryService = 'UserManagementService.getUserSickBalanceHistory';
            config.prefix = BalanceHistory.BalanceTypes.SICK;
            config.balanceType = _BalanceType2.default.SICK;
            config.showBalanceInHours = window.SystemSettings.showSickInHours;
            this.showBalanceHistory(cell, config);
        }
    }, {
        key: 'showPtoHistory',
        value: function showPtoHistory(cell) {
            this._balanceHistoryPanel.updateTitle(_messageResource2.default.getMessage("common.balance_history.balance_history_panel.title", [_messageResource2.default.getMessage("common.balance_history.table.pto")]));

            var config = {};
            config.balanceHistoryService = 'UserManagementService.getUserPtoBalanceHistory';
            config.prefix = BalanceHistory.BalanceTypes.PTO;
            config.balanceType = _BalanceType2.default.PTO;
            config.showBalanceInHours = window.SystemSettings.showPTOInHours;
            this.showBalanceHistory(cell, config);
        }
    }, {
        key: 'showBalanceHistory',
        value: function showBalanceHistory(cell, historyConfig) {
            var _this18 = this;

            this._abortRequestsAndRevertState();

            var cellValue = cell.getValue();
            var userId = cellValue.id;

            var cellEl = cell.getCellEl();
            var jQcell = (0, _jquery2.default)(cellEl);
            var row = (0, _jquery2.default)(cell.getRow().getRowEl());
            this.addRowSelection(cell);
            this.showLoadingHistoryProgress(jQcell);

            (0, _jquery_rpc2.default)(historyConfig.balanceHistoryService, [userId], function (extendedUserPtoBalanceHistoryData) {
                jQcell.removeClass("hovered");
                if (!_this18.wasOperationSuccessful(extendedUserPtoBalanceHistoryData)) {
                    _this18.handlePtoHistoryError(extendedUserPtoBalanceHistoryData.resultCode, userId);
                    _this18.clearRowSelection(cell);
                    _this18.hideLoadingHistoryProgress(jQcell);
                } else {
                    new PanelBalanceHistoryTable(_this18.$tableContainerEl, extendedUserPtoBalanceHistoryData.userBalanceHistoryRecords.list, _this18.ptoHoursPerDay, historyConfig.showBalanceInHours, historyConfig.prefix).init();
                    _this18._balanceHistoryPanel.setOnCloseCallback(function () {
                        row.removeClass("balanceHistorySelected");
                        _this18.clearRowSelection(cell);
                    });
                    _this18._balanceHistoryPanel.updateLinkState(extendedUserPtoBalanceHistoryData.userBalanceHistoryRecords.list.length, userId, historyConfig.balanceType);
                    _this18._balanceHistoryPanel.showAt(cellEl, { my: "left top", at: "left bottom" });
                    _this18.hideLoadingHistoryProgress(jQcell);
                    row.addClass("balanceHistorySelected");
                }
            }, function () {
                _this18.clearRowSelection(cell);
                _this18.hideLoadingHistoryProgress(jQcell);
                jQcell.removeClass("hovered");
            });
        }
    }, {
        key: 'defaultErrorHandler',
        value: function defaultErrorHandler(userResult) {
            var errorMessage = _messageResource2.default.getMessage(ErrorMap[userResult.resultCode]);
            alert(errorMessage);
            location.reload();
        }
    }, {
        key: 'handlePTOExceptions',
        value: function handlePTOExceptions(errorThrown, userId, tableManager) {
            if (errorThrown.exception === 'com.actimind.actitime.administration.NoSuchUserException') {
                alert(_messageResource2.default.getMessage('userlist.js.error_no_such_user.edit_user'));
                tableManager._deleteUser(userId);
                return true;
            }
            if (errorThrown.exception === 'com.actimind.common.administration.UserPTOControlTurnedOff') {
                alert(_messageResource2.default.getMessage('userlist.js.error_pto_control_disabled'));
                this._reloadPage();
                return true;
            }
            if (errorThrown.exception === 'com.actimind.common.administration.UserSickBalanceControlTurnedOff') {
                alert(_messageResource2.default.getMessage('userlist.js.error_sick_control_disabled'));
                this._reloadPage();
                return true;
            }
            return false;
        }
    }, {
        key: 'toggleBalanceControlStatus',
        value: function toggleBalanceControlStatus(cell, balanceType, value) {
            var _this19 = this;

            this._abortRequestsAndRevertState();

            var cellValue = cell.getValue();
            var userId = cellValue.id;

            this.spinner.spin(this.spinnerEl);

            (0, _jquery_rpc2.default)('UserManagementService.setBalanceControlStatus', [userId, balanceType, value], function (result) {
                _this19.spinner.stop();
                _this19.updateCallSucceeded(result, null, false, null, userId, undefined, _this19.defaultErrorHandler);
            }, function (jqXHR, textStatus, errorThrown) {
                _this19.spinner.stop();
                return _this19.handlePTOExceptions(errorThrown, userId, _this19);
            });
        }
    }, {
        key: 'modifyBalanceAccrualRules',
        value: function modifyBalanceAccrualRules(cell, balanceType, dialogValues, onCompleteCallback) {
            var _this20 = this;

            this._abortRequestsAndRevertState();

            var cellValue = cell.getValue();
            var userId = cellValue.id;

            (0, _jquery_rpc2.default)('UserManagementService.setBalanceRules', [userId, balanceType, dialogValues.useDefaults, dialogValues.accrualRule, dialogValues.resetRule, dialogValues.capRule], function (result) {
                onCompleteCallback();
                _this20.updateCallSucceeded(result, null, false, null, userId, undefined, _this20.defaultErrorHandler);
            }, function (jqXHR, textStatus, errorThrown) {
                onCompleteCallback();
                return _this20.handlePTOExceptions(errorThrown, userId, _this20);
            });
        }
    }, {
        key: 'getShowTooltip',
        value: function getShowTooltip(tooltip) {
            return function (config, event) {
                return tooltip.updateUIAndShow(config, (0, _atBrowserUtils.calculateTooltipOffset)(tooltip, event, BOTTOM_BAR_HEIGHT));
            };
        }
    }, {
        key: 'getMoveTooltip',
        value: function getMoveTooltip(tooltip) {
            return function (event) {
                return tooltip.move((0, _atBrowserUtils.calculateTooltipOffset)(tooltip, event, BOTTOM_BAR_HEIGHT));
            };
        }
    }, {
        key: 'getHideTooltip',
        value: function getHideTooltip(tooltip) {
            return function () {
                return tooltip.hide();
            };
        }
    }, {
        key: 'addRowSelection',
        value: function addRowSelection(cell) {
            this.userTableController.addRowSelectionByIdx(cell.getRow().rowIdx);
        }
    }, {
        key: 'clearRowSelection',
        value: function clearRowSelection(cell) {
            this.userTableController.clearRowSelectionByIdx(cell.getRow().rowIdx);
        }
    }, {
        key: 'showLoadingHistoryProgress',
        value: function showLoadingHistoryProgress(cell) {
            this.userTableController.showLoadingHistoryProgress(cell, this.spinner);
        }
    }, {
        key: 'hideLoadingHistoryProgress',
        value: function hideLoadingHistoryProgress(cell) {
            this.userTableController.hideLoadingHistoryProgress(cell, this.spinner);
        }
    }, {
        key: '_initTabs',
        value: function _initTabs() {
            new _TabsContainer2.default().init((0, _jquery2.default)('.userList_tabsPlaceholder'));
        }
    }, {
        key: '_toggleTableClassForTabs',
        value: function _toggleTableClassForTabs(activeTabValue) {
            var isShowPTO = activeTabValue === _constants2.UserManagementConstants.PTO_SETTINGS_TAB_NUM;
            var isShowSickDays = activeTabValue === _constants2.UserManagementConstants.SICK_DAYS_SETTINGS_TAB_NUM;
            var isShowAccountSettings = activeTabValue === _constants2.UserManagementConstants.ACCOUNT_SETTINGS_TAB_NUM;
            var isShowWorkAssignments = activeTabValue === _constants2.UserManagementConstants.WORK_ASSIGNMENTS_TAB_NUM;

            var mainTableContainer = (0, _jquery2.default)('.userList_mainTableContainer');
            if (isShowWorkAssignments) {
                mainTableContainer.hide();

                this.workAssignmentsTableContainer.show();
                this.$workAssignmentsTablePlaceholder.show();
            } else {
                mainTableContainer.show();

                this.$workAssignmentsTablePlaceholder.hide();
                this.workAssignmentsTableContainer.hide();
            }
            this.$userListTableContainer.toggleClass("showPTOSettings", isShowPTO);
            this.$userListTableContainer.toggleClass("showSickDaysSettings", isShowSickDays);
            this.$userListTableContainer.toggleClass("showAccSettings", isShowAccountSettings);
        }
    }, {
        key: 'validateIsChangedFeaturesOrRights',
        value: function validateIsChangedFeaturesOrRights(changeData) {
            return this.validateCanViewUserList(changeData) && this.validateIsChangedFeatures(changeData.featureDiff) && this.validateIsChangedRights(changeData);
        }
    }, {
        key: 'validateCanViewUserList',
        value: function validateCanViewUserList(diffBetweenData) {
            if (!this._isPTOSettingsVisible() && !this._isSickDaysSettingsVisible() && !this._isAccountSettingsVisible()) {
                alert(_messageResource2.default.getMessage("userlist.js.error_no_right_to_view_userlist"));
                this._reloadPage();
                return false;
            }

            return true;
        }
    }, {
        key: 'validateIsChangedRights',
        value: function validateIsChangedRights(diffBetweenData) {
            if (diffBetweenData.areAllowedToManageLeaveBalanceSettingsChanged) {
                this._onShowPTOSettingsChanged();
                return false;
            }
            if (diffBetweenData.showAccountSettingsChanged) {
                this._onShowAccountSettingsChanged();
                return false;
            }
            if (diffBetweenData.areAllowedToManageAccountSettingsChanged) {
                this._onManageAccountSettingsChanged();
                return false;
            }
            return true;
        }
    }, {
        key: 'validateIsChangedFeatures',
        value: function validateIsChangedFeatures(featureDiff) {
            if (featureDiff.wasFeatureChanged(_constants2.UserManagementConstants.UGRFeature)) {
                this._onUGRChanged();
                return false;
            }
            if (featureDiff.wasFeatureChanged(_constants2.UserManagementConstants.TZGFeature)) {
                this._onTZGChanged();
                return false;
            }
            if (featureDiff.wasFeatureChanged(_constants2.UserManagementConstants.TTAFeature)) {
                this._onTTAChanged();
                return false;
            }
            if (featureDiff.wasFeatureChanged(_constants2.UserManagementConstants.PTOFeature)) {
                this._onPTOChanged();
                return false;
            }
            if (featureDiff.wasFeatureChanged(_constants2.UserManagementConstants.SDBFeature)) {
                this._onSickChanged();
                return false;
            }

            this.validateGenerateMoneyReportsRightChanged(featureDiff);

            if (featureDiff.wasFeatureChanged(_constants2.UserManagementConstants.OVRFeature)) {
                this._onOVRChanged();
                return false;
            }

            if (featureDiff.wasFeatureChanged(_constants2.UserManagementConstants.LVTFeature)) {
                this._onLVTChanged();
                return false;
            }
            return true;
        }
    }, {
        key: 'validateGenerateMoneyReportsRightChanged',
        value: function validateGenerateMoneyReportsRightChanged(featureDiff) {
            if (this._isGenerateMoneyReportsRightChanged(featureDiff)) this._onGenerateMoneyReportsRightChanged();

            if (this._isURAEnabled() !== featureDiff.wasFeatureEnabledBefore(_constants2.UserManagementConstants.URAFeature) || this._isBTYEnabled() !== featureDiff.wasFeatureEnabledBefore(_constants2.UserManagementConstants.BTYFeature)) this.userTableController.updatePermissionsColumn(this._isURAEnabled(), this._isBTYEnabled());
        }
    }, {
        key: '_isGenerateMoneyReportsRightChanged',
        value: function _isGenerateMoneyReportsRightChanged(featureDiff) {
            var generateMoneyReportsEnabled = this._isURAEnabled() || this._isBTYEnabled();
            var prevGenerateMoneyReportsEnabled = featureDiff.wasFeatureEnabledBefore(_constants2.UserManagementConstants.URAFeature) || featureDiff.wasFeatureEnabledBefore(_constants2.UserManagementConstants.BTYFeature);

            return generateMoneyReportsEnabled !== prevGenerateMoneyReportsEnabled;
        }
    }, {
        key: 'getCurrentTime',
        value: function getCurrentTime(timeZoneGroupId, successCallback, errorCallback) {
            (0, _jquery_rpc2.default)("CurrentTimeInfoService.getCurrentTimeInfo", [timeZoneGroupId], successCallback, errorCallback);
        }
    }]);

    return UserManagementMediator;
}(_View3.default);

exports.default = (0, _utils.connect)(function (state) {
    return {
        activeTabNum: (0, _selectors.getActiveTabNum)(state),
        allowedToManageAccountSettings: (0, _selectors.isAllowedToManageAccountSettings)(state),
        editingUserId: (0, _selectors.getEditingUserId)(state),
        isBTYEnabled: (0, _selectors2.isBTYEnabled)(state),
        isURAEnabled: (0, _selectors2.isURAEnabled)(state),
        isUGREnabled: (0, _selectors2.isUGREnabled)(state),
        isTZGEnabled: (0, _selectors2.isTZGEnabled)(state),
        isTTAEnabled: (0, _selectors2.isTTAEnabled)(state),
        availableUsers: (0, _selectors.getSortedUsersList)(state),
        permissionsTemplates: (0, _selectors.getPermissionsTemplates)(state),
        isWaTabLoading: (0, _selectors3.isLoading)(state)
    };
}, function (dispatch) {
    return {
        openEditUserPanel: (0, _redux.bindActionCreators)(_actions.openEditUserPanel, dispatch),
        openCreateUserPanel: (0, _redux.bindActionCreators)(_actions2.openCreateUserPanel, dispatch),
        closeCreateUserPanel: (0, _redux.bindActionCreators)(_actions2.closeCreateUserPanel, dispatch),
        setStateOnPageDataReceivedAction: (0, _redux.bindActionCreators)(_actions4.setStateOnPageDataReceivedAction, dispatch),
        setStateOnInviteSeveralUsersSuccess: (0, _redux.bindActionCreators)(_actions4.setStateOnInviteSeveralUsersSuccess, dispatch),
        openTeamAssignmentsPanel: (0, _redux.bindActionCreators)(_actions4.openTeamAssignmentsPanelFromUserList, dispatch),
        openManagementAssignmentsPanel: (0, _redux.bindActionCreators)(_actions5.openManagementAssignmentPanel, dispatch),
        addNewUsersToList: (0, _redux.bindActionCreators)(_actions3.addNewUsersToList, dispatch),
        removeUserFromList: (0, _redux.bindActionCreators)(_actions3.removeUserFromList, dispatch),
        updateUsersGroups: (0, _redux.bindActionCreators)(_actions6.updateUsersGroups, dispatch),
        updateUsersTimeZoneGroups: (0, _redux.bindActionCreators)(_actions6.updateUsersTimeZoneGroups, dispatch),
        updateDepartments: (0, _redux.bindActionCreators)(_actions6.updateDepartments, dispatch),
        updateTimeZoneGroups: (0, _redux.bindActionCreators)(_actions6.updateTimeZoneGroups, dispatch),
        updateUserManagementData: (0, _redux.bindActionCreators)(_actions3.setUserManagementData, dispatch)
    };
})(UserManagementMediator);

/***/ }),
/* 1595 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.PUNCTUATORS = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _number_formatter = __webpack_require__(61);

var _number_formatter2 = _interopRequireDefault(_number_formatter);

var _StringTokenizer = __webpack_require__(103);

var _StringTokenizer2 = _interopRequireDefault(_StringTokenizer);

var _EmptyHighlighter = __webpack_require__(137);

var _EmptyHighlighter2 = _interopRequireDefault(_EmptyHighlighter);

var _TokensHighlighter = __webpack_require__(94);

var _TokensHighlighter2 = _interopRequireDefault(_TokensHighlighter);

var _WarningsController = __webpack_require__(542);

var _WarningsController2 = _interopRequireDefault(_WarningsController);

var _Table2 = __webpack_require__(385);

var _Table3 = _interopRequireDefault(_Table2);

var _TableCell = __webpack_require__(166);

var _TableCell2 = _interopRequireDefault(_TableCell);

var _UserTableRow = __webpack_require__(849);

var _UserTableRow2 = _interopRequireDefault(_UserTableRow);

var _UserRowRenderer = __webpack_require__(1596);

var _UserRowRenderer2 = _interopRequireDefault(_UserRowRenderer);

var _UserTableRenderer = __webpack_require__(1597);

var _UserTableRenderer2 = _interopRequireDefault(_UserTableRenderer);

var _EditableCell = __webpack_require__(845);

var _EditableCell2 = _interopRequireDefault(_EditableCell);

var _utils = __webpack_require__(6);

var _selectors = __webpack_require__(1598);

var _selectors2 = __webpack_require__(15);

var _UserNameCell = __webpack_require__(1599);

var _UserNameCell2 = _interopRequireDefault(_UserNameCell);

var _PlannedLeaveRenderer = __webpack_require__(1600);

var _ShowPtoHistoryCellRenderer = __webpack_require__(1601);

var _ShowPtoHistoryCellRenderer2 = _interopRequireDefault(_ShowPtoHistoryCellRenderer);

var _ShowSickDaysHistoryCellRenderer = __webpack_require__(1602);

var _ShowSickDaysHistoryCellRenderer2 = _interopRequireDefault(_ShowSickDaysHistoryCellRenderer);

var _PtoResetRulesCell = __webpack_require__(1603);

var _PtoResetRulesCell2 = _interopRequireDefault(_PtoResetRulesCell);

var _PtoAccrualRulesCell = __webpack_require__(1604);

var _PtoAccrualRulesCell2 = _interopRequireDefault(_PtoAccrualRulesCell);

var _SickDaysResetRulesCell = __webpack_require__(1605);

var _SickDaysResetRulesCell2 = _interopRequireDefault(_SickDaysResetRulesCell);

var _PtoCapRulesCell = __webpack_require__(1606);

var _PtoCapRulesCell2 = _interopRequireDefault(_PtoCapRulesCell);

var _SickDaysAccrualRulesCell = __webpack_require__(1607);

var _SickDaysAccrualRulesCell2 = _interopRequireDefault(_SickDaysAccrualRulesCell);

var _PtoDefaultRulesCell = __webpack_require__(1608);

var _PtoDefaultRulesCell2 = _interopRequireDefault(_PtoDefaultRulesCell);

var _SickDaysCapRulesCell = __webpack_require__(1609);

var _SickDaysCapRulesCell2 = _interopRequireDefault(_SickDaysCapRulesCell);

var _SickDaysDefaultRulesCell = __webpack_require__(1610);

var _SickDaysDefaultRulesCell2 = _interopRequireDefault(_SickDaysDefaultRulesCell);

var _SickDaysControlRenderer = __webpack_require__(1611);

var _SickDaysControlRenderer2 = _interopRequireDefault(_SickDaysControlRenderer);

var _PtoControlRenderer = __webpack_require__(1612);

var _PtoControlRenderer2 = _interopRequireDefault(_PtoControlRenderer);

var _SickDaysCellRenderer = __webpack_require__(1613);

var _SickDaysCellRenderer2 = _interopRequireDefault(_SickDaysCellRenderer);

var _PTOCellRenderer = __webpack_require__(1614);

var _PTOCellRenderer2 = _interopRequireDefault(_PTOCellRenderer);

var _NameCellRenderer = __webpack_require__(1615);

var _NameCellRenderer2 = _interopRequireDefault(_NameCellRenderer);

var _EmptyCellRenderer = __webpack_require__(1616);

var _EmptyCellRenderer2 = _interopRequireDefault(_EmptyCellRenderer);

var _PermissionsCellRenderer = __webpack_require__(1617);

var _PermissionsCellRenderer2 = _interopRequireDefault(_PermissionsCellRenderer);

var _TeamScopeCellRenderer = __webpack_require__(1619);

var _TeamScopeCellRenderer2 = _interopRequireDefault(_TeamScopeCellRenderer);

var _ManageScopeCellRenderer = __webpack_require__(1621);

var _ManageScopeCellRenderer2 = _interopRequireDefault(_ManageScopeCellRenderer);

var _utils2 = __webpack_require__(200);

var _BalanceRulesEditorDialogContent = __webpack_require__(857);

var _BalanceRulesEditorDialogContent2 = _interopRequireDefault(_BalanceRulesEditorDialogContent);

var _atUtils = __webpack_require__(5);

var _PermissionsUtils = __webpack_require__(359);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PUNCTUATORS = exports.PUNCTUATORS = _StringTokenizer2.default.PUNCTUATORS_FOR_SEARCH;

var UserTableController = function (_Table) {
    _inherits(UserTableController, _Table);

    function UserTableController(_ref) {
        var containerEl = _ref.containerEl,
            tHeadEl = _ref.tHeadEl,
            userBeans = _ref.userBeans,
            canManageLeaveBalances = _ref.canManageLeaveBalances,
            canManageAccounts = _ref.canManageAccounts,
            canManageScope = _ref.canManageScope,
            accountSettingsVisible = _ref.accountSettingsVisible,
            usersWithoutApprovers = _ref.usersWithoutApprovers,
            ptoFeatureEnabled = _ref.ptoFeatureEnabled,
            sickFeatureEnabled = _ref.sickFeatureEnabled,
            wasFeatureEnabled = _ref.wasFeatureEnabled,
            _ref$ugrFeatureEnable = _ref.ugrFeatureEnabled,
            ugrFeatureEnabled = _ref$ugrFeatureEnable === undefined ? false : _ref$ugrFeatureEnable,
            sortOrder = _ref.sortOrder,
            handlersMap = _ref.handlersMap,
            ptoHoursPerDay = _ref.ptoHoursPerDay,
            groupMap = _ref.groupMap,
            timeZoneGroupMap = _ref.timeZoneGroupMap,
            ptoDefaults = _ref.ptoDefaults,
            sickDefaults = _ref.sickDefaults,
            _ref$generateMoneyRep = _ref.generateMoneyReportsTitle,
            generateMoneyReportsTitle = _ref$generateMoneyRep === undefined ? "" : _ref$generateMoneyRep;

        _classCallCheck(this, UserTableController);

        var _this = _possibleConstructorReturn(this, (UserTableController.__proto__ || Object.getPrototypeOf(UserTableController)).call(this, tHeadEl, containerEl));

        _this._handleNameCellClick = function (cell, e) {
            _this.params.handlersMap.editUserAccountSettings(cell, e);
        };

        _this._handleNameCellMouseIn = function (cell, e) {
            _this.toggleHoverClassInNameCell(cell, true);
        };

        _this._handleNameCellMouseOut = function (cell, e) {
            _this.toggleHoverClassInNameCell(cell, false);
        };

        _this._handlePermissionsCellClick = function (cell, e) {
            if (_this._isEditingUsersAllowed() && !cell.value.locked) {
                _this.params.handlersMap.editUserPermissions(cell, e);
            }
        };

        _this._handlePermissionsCellMouseIn = function (cell, e) {
            if (_this._isEditingUsersAllowed()) {
                _this.toggleHoverClassInManageCell(cell, true);
            }
        };

        _this._handlePermissionsCellMouseOut = function (cell, e) {
            if (_this._isEditingUsersAllowed()) {
                _this.toggleHoverClassInManageCell(cell, false);
            }
        };

        _this._handleTeamScopeCellClick = function (cell, e) {
            if (_this._isEditingUsersAllowed() && (0, _utils2.isPossibleToEditUserAssignments)({
                userInfo: cell.getValue(),
                isURAEnabled: _this.state.isURAEnabled,
                isBTYEnabled: _this.state.isBTYEnabled
            })) {
                _this.params.handlersMap.editTeamAssignmentsPermissions(cell, e);
            }
        };

        _this._handleTeamScopeCellMouseIn = function (cell, e) {
            if (_this._isEditingUsersAllowed() && (0, _utils2.isPossibleToEditUserAssignments)({
                userInfo: cell.getValue(),
                isURAEnabled: _this.state.isURAEnabled,
                isBTYEnabled: _this.state.isBTYEnabled
            })) {
                _this.toggleHoverClassInTeamScopeCell(cell, true);
            }
        };

        _this._handleTeamScopeCellMouseOut = function (cell, e) {
            if (_this._isEditingUsersAllowed() && (0, _utils2.isPossibleToEditUserAssignments)({
                userInfo: cell.getValue(),
                isURAEnabled: _this.state.isURAEnabled,
                isBTYEnabled: _this.state.isBTYEnabled
            })) {
                _this.toggleHoverClassInTeamScopeCell(cell, false);
            }
        };

        _this._handleManageScopeCellClick = function (cell, e) {
            if (_this._isEditingUsersAllowed() && (0, _utils2.isPossibleToEditUserAssignments)({
                userInfo: cell.getValue(),
                isURAEnabled: _this.state.isURAEnabled,
                isBTYEnabled: _this.state.isBTYEnabled
            })) {
                _this.params.handlersMap.editManagementAssignmentsPermissions(cell, e);
            }
        };

        _this._handleManageScopeCellMouseIn = function (cell, e) {
            if (_this._isEditingUsersAllowed() && (0, _utils2.isPossibleToEditUserAssignments)({
                userInfo: cell.getValue(),
                isURAEnabled: _this.state.isURAEnabled,
                isBTYEnabled: _this.state.isBTYEnabled
            })) {
                _this.toggleHoverClassInManageScopeCell(cell, true);
            }
        };

        _this._handleManageScopeCellMouseOut = function (cell, e) {
            if (_this._isEditingUsersAllowed() && (0, _utils2.isPossibleToEditUserAssignments)({
                userInfo: cell.getValue(),
                isURAEnabled: _this.state.isURAEnabled,
                isBTYEnabled: _this.state.isBTYEnabled
            })) {
                _this.toggleHoverClassInManageScopeCell(cell, false);
            }
        };

        _this.containerEl = containerEl;

        _this.params = {
            containerEl: containerEl,
            userBeans: userBeans,
            canManageLeaveBalances: canManageLeaveBalances,
            canManageAccounts: canManageAccounts,
            canManageScope: canManageScope,
            accountSettingsVisible: accountSettingsVisible,
            usersWithoutApprovers: usersWithoutApprovers,
            ptoFeatureEnabled: ptoFeatureEnabled,
            sickFeatureEnabled: sickFeatureEnabled,
            wasFeatureEnabled: wasFeatureEnabled,
            ugrFeatureEnabled: ugrFeatureEnabled,
            sortOrder: sortOrder,
            handlersMap: handlersMap,
            ptoHoursPerDay: ptoHoursPerDay,
            groupMap: groupMap,
            timeZoneGroupMap: timeZoneGroupMap,
            generateMoneyReportsTitle: generateMoneyReportsTitle
        };

        _this.state = {
            showPTOTab: ptoFeatureEnabled && canManageLeaveBalances,
            showSDPTab: sickFeatureEnabled && canManageLeaveBalances,
            isURAEnabled: false,
            isBTYEnabled: false,
            isTTAEnabled: false,
            ptoDefaults: ptoDefaults,
            sickDefaults: sickDefaults
        };

        _this.warningsController = new _WarningsController2.default();

        _this.tableRenderer = new _UserTableRenderer2.default();
        _this.tableRenderer.init();
        _this.rowRenderer = new _UserRowRenderer2.default().init();

        _this.userIdRowMap = {};

        _this.tokensHighlighter = new _EmptyHighlighter2.default();

        if (ugrFeatureEnabled && groupMap !== null) {
            _this.groupList = _underscore2.default.map(Object.keys(groupMap), function (id) {
                return {
                    id: Number(id),
                    name: groupMap[id]
                };
            });
        } else {
            _this.groupList = [];
        }

        _this.$body = (0, _jquery2.default)('body');

        _this._initializeFormatters();

        _this._createPtoRuleManager(_this.state.ptoDefaults, _this.$body);

        _this._createSickRulesManager(_this.state.sickDefaults, _this.$body);

        _this.createBodyContent(userBeans, groupMap, timeZoneGroupMap, _this.tokensHighlighter);

        _this.onStatePropertyChanged('showPTOTab', function (isPTOTabVisible) {
            _this._createPtoRuleManager(_this.state.ptoDefaults, _this.$body);
        });

        _this.onStatePropertyChanged('showSDPTab', function (showSDPTab) {
            _this._createSickRulesManager(_this.state.sickDefaults, _this.$body);
        });

        _this.onAnyStatePropertyChanged(['isURAEnabled', 'isBTYEnabled', 'isTTAEnabled'], function () {
            _this.params.generateMoneyReportsEnabled = _this.state.isURAEnabled || _this.state.isBTYEnabled;
            _this.params.generateMoneyReportsTitle = (0, _PermissionsUtils.getGenerateMoneyReportsRightTitle)(_this.state.isURAEnabled, _this.state.isBTYEnabled);

            _this.updatePermissionsColumn(_this.state.isURAEnabled, _this.state.isBTYEnabled);
            _this.updateManageScopeColumn(_this.state.isURAEnabled, _this.state.isBTYEnabled);
            _this.updateTeamsScopeColumn(_this.state.isURAEnabled, _this.state.isBTYEnabled);
        });
        return _this;
    }

    _createClass(UserTableController, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return "<div></div>";
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            this.buildDOM(this.getEl());
        }
    }, {
        key: 'makeUserIdGroupIdMapForVisibleUser',
        value: function makeUserIdGroupIdMapForVisibleUser() {
            var map = {};
            for (var i = 0; i < this.rows.length; i++) {
                var userListUserInfo = this.rows[i].getUserListUserInfo();
                map[userListUserInfo.id] = userListUserInfo.userGroupId;
            }
            return map;
        }
    }, {
        key: 'makeTimeZoneIdGroupIdMapForVisibleUser',
        value: function makeTimeZoneIdGroupIdMapForVisibleUser() {
            var map = {};
            for (var i = 0; i < this.rows.length; i++) {
                var userListUserInfo = this.rows[i].getUserListUserInfo();
                map[userListUserInfo.id] = userListUserInfo.timeZoneGroupId;
            }
            return map;
        }
    }, {
        key: 'getBaseRowClasses',
        value: function getBaseRowClasses(rowIdx) {
            // TODO: When we get rid of the UserTableRow, this table has to keep array of UserListUserInfo structures.
            return this.rowRenderer.getRowClasses(this.getRow(rowIdx).getUserListUserInfo());
        }
    }, {
        key: 'createBodyContent',
        value: function createBodyContent(userListUserInfoRecords, groupsMap, timeZoneGroupsMap, tokensHighlighter) {
            for (var i = 0; i < userListUserInfoRecords.length; i++) {
                var userListUserInfo = userListUserInfoRecords[i];
                var groupName = groupsMap === null ? "" : groupsMap[userListUserInfo.userGroupId];
                var timeZoneGroupName = timeZoneGroupsMap === null ? "" : timeZoneGroupsMap[userListUserInfo.timeZoneGroupId];

                this.addRow(this.createRow(userListUserInfo, groupName, timeZoneGroupName, tokensHighlighter, []));
            }
        }
    }, {
        key: 'disableTextSelection',
        value: function disableTextSelection() {
            //do not disable selection;
        }
    }, {
        key: 'buildDOM',
        value: function buildDOM(containerEl) {
            _get(UserTableController.prototype.__proto__ || Object.getPrototypeOf(UserTableController.prototype), 'buildDOM', this).call(this, containerEl[0]);
            this.updateUI();
            this.tableRenderer.setupEventHandlers(this.params.handlersMap);
        }
    }, {
        key: '_findRow',
        value: function _findRow(e) {
            //this two rows for fix bug  51665 IE8
            var event = e || window.event;
            var targetElement = event.target || event.srcElement;
            return (0, _jquery2.default)(targetElement).closest('tr');
        }
    }, {
        key: 'toggleHoverClassInPtoRulesCell',
        value: function toggleHoverClassInPtoRulesCell(e, hovered) {
            this._findRow(e).toggleClass('ptoRulesCellHovered', hovered);
        }
    }, {
        key: 'toggleHoverClassInSickDaysRulesCell',
        value: function toggleHoverClassInSickDaysRulesCell(e, hovered) {
            this._findRow(e).toggleClass('sickDaysRulesCellHovered', hovered);
        }
    }, {
        key: 'toggleHoverClassInPtoBalanceCell',
        value: function toggleHoverClassInPtoBalanceCell(e, hovered) {
            this._findRow(e).toggleClass('ptoBalanceCellHovered', hovered);
        }
    }, {
        key: 'toggleHoverClassInSickDaysBalanceCell',
        value: function toggleHoverClassInSickDaysBalanceCell(e, hovered) {
            this._findRow(e).toggleClass('sickDaysBalanceCellHovered', hovered);
        }
    }, {
        key: 'toggleHoverClassInPtoHistoryCell',
        value: function toggleHoverClassInPtoHistoryCell(e, hovered) {
            this._findRow(e).toggleClass('ptoHistoryCellHovered', hovered);
        }
    }, {
        key: 'toggleHoverClassInSickDaysHistoryCell',
        value: function toggleHoverClassInSickDaysHistoryCell(e, hovered) {
            this._findRow(e).toggleClass('sickDaysHistoryCellHovered', hovered);
        }
    }, {
        key: 'toggleHoverClassInPtoControlCell',
        value: function toggleHoverClassInPtoControlCell(e, hovered) {
            this._findRow(e).toggleClass('ptoControlCellHovered', hovered);
        }
    }, {
        key: 'toggleHoverClassInSickDaysControlCell',
        value: function toggleHoverClassInSickDaysControlCell(e, hovered) {
            this._findRow(e).toggleClass('sickDaysControlCellHovered', hovered);
        }
    }, {
        key: 'toggleHoverClassInNameCell',
        value: function toggleHoverClassInNameCell(cell, hovered) {
            (0, _jquery2.default)(cell.getRow().getRowEl()).toggleClass('nameCellHovered', hovered);
        }
    }, {
        key: 'toggleHoverClassInManageCell',
        value: function toggleHoverClassInManageCell(cell, hovered) {
            (0, _jquery2.default)(cell.getRow().getRowEl()).toggleClass('manageCellHovered', hovered);
        }
    }, {
        key: 'toggleHoverClassInTeamScopeCell',
        value: function toggleHoverClassInTeamScopeCell(cell, hovered) {
            (0, _jquery2.default)(cell.getRow().getRowEl()).toggleClass('teamScopeCellHovered', hovered);
        }
    }, {
        key: 'toggleHoverClassInManageScopeCell',
        value: function toggleHoverClassInManageScopeCell(cell, hovered) {
            (0, _jquery2.default)(cell.getRow().getRowEl()).toggleClass('manageScopeCellHovered', hovered);
        }
    }, {
        key: '_modifyPTOAccrualRules',
        value: function _modifyPTOAccrualRules(cell) {
            var _this2 = this;

            var dialogValues = this.ptoRulesManager.getDialogValues();

            this.params.handlersMap.modifyPTOAccrualRules(cell, dialogValues, function () {
                _this2.ptoRulesManager.hideDialog();
            });
        }
    }, {
        key: '_modifySickAccrualRules',
        value: function _modifySickAccrualRules(cell) {
            var _this3 = this;

            var dialogValues = this.sickRulesManager.getDialogValues();

            this.params.handlersMap.modifySickAccrualRules(cell, dialogValues, function () {
                _this3.sickRulesManager.hideDialog();
            });
        }
    }, {
        key: '_onEditRulesClicked',
        value: function _onEditRulesClicked(jQueryEvent, rulesManager, balanceData, cell, cellSelector, onClickCallback) {
            var _this4 = this;

            if (!balanceData) return;

            rulesManager.hideAccrualRulesTooltip();
            rulesManager.updateDialog(balanceData, cell.getRow().getUserListUserInfo().today);

            var row = this._findRow(jQueryEvent);

            rulesManager.setModifyBalanceAccrualRulesOkClick(onClickCallback);

            rulesManager.setOnCloseCallback(function () {
                row.removeClass("ptoEditorSelected");
                _this4.clearRowSelection(row);
            });

            var event = jQueryEvent || window.event;
            var targetCell = event.target || event.srcElement;
            targetCell = !balanceData.defaultRules ? row.find(".resetRule:visible") : row.find(".defaultRule:visible");

            rulesManager.showDialogAt(targetCell, { offset: "5px -10px" });

            row.addClass("ptoEditorSelected");
            this.addRowSelection(row);
        }
    }, {
        key: '_onEditPTORulesClicked',
        value: function _onEditPTORulesClicked(jQueryEvent, balanceData, cell) {
            var _this5 = this;

            this._onEditRulesClicked(jQueryEvent, this.ptoRulesManager, balanceData, cell, ".ptoRulesCell", function () {
                _this5._modifyPTOAccrualRules(cell);
            });
        }
    }, {
        key: '_onEditSickRulesClicked',
        value: function _onEditSickRulesClicked(jQueryEvent, balanceData, cell) {
            var _this6 = this;

            this._onEditRulesClicked(jQueryEvent, this.sickRulesManager, balanceData, cell, ".sickRulesCell", function () {
                _this6._modifySickAccrualRules(cell);
            });
        }
    }, {
        key: 'createRow',
        value: function createRow(userListUserInfo, groupName, timeZoneGroupName, tokensHighlighter, warningsData) {
            var _this7 = this;

            var row = new _UserTableRow2.default().init(userListUserInfo);
            this.userIdRowMap[userListUserInfo.id] = row;

            var possibleToEditAccountSettings = this._isEditingUsersAllowed();
            var usersWithoutApproversSet = (0, _atUtils.arrayToSet)(this.params.usersWithoutApprovers);

            var nameCell = new _UserNameCell2.default().init(userListUserInfo, groupName, timeZoneGroupName, row, warningsData.warningMsgs, warningsData.infoMsgs);
            nameCell.setRenderer(new _NameCellRenderer2.default().init({
                tokensHighlighter: tokensHighlighter,
                isEditingAllowed: userListUserInfo.editable,
                hasApprover: !usersWithoutApproversSet[userListUserInfo.id],
                onClickCb: this._handleNameCellClick,
                warningsController: this.warningsController,
                onMouseIn: this._handleNameCellMouseIn,
                onMouseOut: this._handleNameCellMouseOut
            }));

            row.addNameCellObj(nameCell);

            var spacerOne = new _TableCell2.default();
            spacerOne.setRenderer(new _EmptyCellRenderer2.default());
            row.addCellObj(spacerOne);

            var permissionsCell = new _EditableCell2.default().init(userListUserInfo, row);
            var permissionsCellRenderer = new _PermissionsCellRenderer2.default({
                editable: possibleToEditAccountSettings,
                generateMoneyReportsEnabled: this.state.isURAEnabled || this.state.isBTYEnabled,
                generateMoneyReportsTitle: this.params.generateMoneyReportsTitle,
                isTTAEnabled: this.params.isTTAEnabled,
                onClick: this._handlePermissionsCellClick,
                onMouseIn: this._handlePermissionsCellMouseIn,
                onMouseOut: this._handlePermissionsCellMouseOut
            });
            permissionsCell.setRenderer(permissionsCellRenderer);
            row.addPermissionsCellObj(permissionsCell);

            var teamScopeCell = new _EditableCell2.default().init(userListUserInfo, row);
            teamScopeCell.setRenderer(new _TeamScopeCellRenderer2.default({
                editable: possibleToEditAccountSettings,
                onClick: this._handleTeamScopeCellClick,
                onMouseIn: this._handleTeamScopeCellMouseIn,
                onMouseOut: this._handleTeamScopeCellMouseOut,
                isURAEnabled: this.state.isURAEnabled,
                isBTYEnabled: this.state.isBTYEnabled
            }));
            row.addTeamScopeCellObj(teamScopeCell);

            var manageScopeCell = new _EditableCell2.default().init(userListUserInfo, row);
            manageScopeCell.setRenderer(new _ManageScopeCellRenderer2.default({
                editable: possibleToEditAccountSettings,
                onClick: this._handleManageScopeCellClick,
                onMouseIn: this._handleManageScopeCellMouseIn,
                onMouseOut: this._handleManageScopeCellMouseOut,
                isURAEnabled: this.state.isURAEnabled,
                isBTYEnabled: this.state.isBTYEnabled
            }));
            row.addManageScopeCellObj(manageScopeCell);

            if (this.state.showPTOTab) {
                var ptoCell = new _TableCell2.default(userListUserInfo);
                ptoCell.setRenderer(new _PTOCellRenderer2.default().init({
                    onClickHandler: this.params.handlersMap.editPTOBalance,
                    onMouseOverHandler: function onMouseOverHandler(e) {
                        return _this7.toggleHoverClassInPtoBalanceCell(e, true);
                    },
                    onMouseOutHandler: function onMouseOutHandler(e) {
                        return _this7.toggleHoverClassInPtoBalanceCell(e, false);
                    }
                }, this.params.ptoHoursPerDay));
                row.addCellObj(ptoCell);
            }

            if (this.state.showSDPTab) {
                var sickDaysCell = new _TableCell2.default(userListUserInfo);
                sickDaysCell.setRenderer(new _SickDaysCellRenderer2.default().init({
                    onClickHandler: this.params.handlersMap.editSickDaysBalance,
                    onMouseOverHandler: function onMouseOverHandler(e) {
                        return _this7.toggleHoverClassInSickDaysBalanceCell(e, true);
                    },
                    onMouseOutHandler: function onMouseOutHandler(e) {
                        return _this7.toggleHoverClassInSickDaysBalanceCell(e, false);
                    }
                }, this.params.ptoHoursPerDay));
                row.addCellObj(sickDaysCell);
            }

            if (this.isShowHistoryAvailable()) {
                var showPtoHistoryCell = new _TableCell2.default(userListUserInfo);
                showPtoHistoryCell.setRenderer(new _ShowPtoHistoryCellRenderer2.default().init({
                    onClickHandler: this.params.handlersMap.showPtoHistory,
                    onMouseOverHandler: function onMouseOverHandler(e) {
                        return _this7.toggleHoverClassInPtoHistoryCell(e, true);
                    },
                    onMouseOutHandler: function onMouseOutHandler(e) {
                        return _this7.toggleHoverClassInPtoHistoryCell(e, false);
                    }
                }));
                row.addCellObj(showPtoHistoryCell);

                var showSickDaysHistoryCell = new _TableCell2.default(userListUserInfo);
                showSickDaysHistoryCell.setRenderer(new _ShowSickDaysHistoryCellRenderer2.default().init({
                    onClickHandler: this.params.handlersMap.showSickHistory,
                    onMouseOverHandler: function onMouseOverHandler(e) {
                        return _this7.toggleHoverClassInSickDaysHistoryCell(e, true);
                    },
                    onMouseOutHandler: function onMouseOutHandler(e) {
                        return _this7.toggleHoverClassInSickDaysHistoryCell(e, false);
                    }
                }));
                row.addCellObj(showSickDaysHistoryCell);
            }

            if (this.state.showPTOTab) {
                var handlers = {
                    onMouseOverHandler: function onMouseOverHandler(e, ptoData) {
                        _this7.toggleHoverClassInPtoRulesCell(e, true);
                        _this7.ptoRulesManager.showAccrualRulesTooltip(e, ptoData);
                    },

                    onMouseOutHandler: function onMouseOutHandler(e) {
                        _this7.toggleHoverClassInPtoRulesCell(e, false);
                        _this7.ptoRulesManager.hideAccrualRulesTooltip();
                    },

                    onMouseMoveHandler: function onMouseMoveHandler(e) {
                        return _this7.ptoRulesManager.moveAccrualRulesTooltip(e);
                    },

                    onClickHandler: function onClickHandler(e, ptoData, cell) {
                        return _this7._onEditPTORulesClicked(e, ptoData, cell);
                    }
                };

                var plannedPTOLeavesCell = new _TableCell2.default(userListUserInfo);
                plannedPTOLeavesCell.setRenderer(new _PlannedLeaveRenderer.PlannedPTOLeaveRenderer().init(this.ptoValueFormatter));
                row.addCellObj(plannedPTOLeavesCell);

                var ptoSpacerOne = new _TableCell2.default();
                ptoSpacerOne.setRenderer(new _EmptyCellRenderer2.default('ptoTab'));
                row.addCellObj(ptoSpacerOne);

                var ptoResetRulesCell = new _TableCell2.default(userListUserInfo);
                ptoResetRulesCell.setRenderer(new _PtoResetRulesCell2.default().init(this.ptoRulesFormatter, handlers));
                row.addCellObj(ptoResetRulesCell);

                var ptoAccrualRulesCell = new _TableCell2.default(userListUserInfo);
                ptoAccrualRulesCell.setRenderer(new _PtoAccrualRulesCell2.default().init(this.ptoRulesFormatter, handlers));
                row.addCellObj(ptoAccrualRulesCell);

                var ptoCapRulesCell = new _TableCell2.default(userListUserInfo);
                ptoCapRulesCell.setRenderer(new _PtoCapRulesCell2.default().init(this.ptoRulesFormatter, handlers));
                row.addCellObj(ptoCapRulesCell);

                var defaultRulesCell = new _TableCell2.default(userListUserInfo);
                defaultRulesCell.setRenderer(new _PtoDefaultRulesCell2.default().init(null, handlers));
                defaultRulesCell.setColspan(3);
                row.addCellObj(defaultRulesCell);

                var ptoSpacerTwo = new _TableCell2.default();
                ptoSpacerTwo.setRenderer(new _EmptyCellRenderer2.default('ptoTab'));
                row.addCellObj(ptoSpacerTwo);

                var ptoControl = new _TableCell2.default(userListUserInfo);
                ptoControl.setRenderer(new _PtoControlRenderer2.default().init({
                    onClickHandler: this.params.handlersMap.togglePTOControlStatus,
                    onMouseOverHandler: function onMouseOverHandler(e) {
                        return _this7.toggleHoverClassInPtoControlCell(e, true);
                    },
                    onMouseOutHandler: function onMouseOutHandler(e) {
                        return _this7.toggleHoverClassInPtoControlCell(e, false);
                    }
                }));
                row.addCellObj(ptoControl);
            }

            if (this.state.showSDPTab) {
                var _handlers = {
                    onMouseOverHandler: function onMouseOverHandler(e, ptoData) {
                        _this7.toggleHoverClassInSickDaysRulesCell(e, true);
                        _this7.sickRulesManager.showAccrualRulesTooltip(e, ptoData);
                    },

                    onMouseOutHandler: function onMouseOutHandler(e) {
                        _this7.toggleHoverClassInSickDaysRulesCell(e, false);
                        _this7.sickRulesManager.hideAccrualRulesTooltip();
                    },

                    onMouseMoveHandler: function onMouseMoveHandler(e) {
                        return _this7.sickRulesManager.moveAccrualRulesTooltip(e);
                    },

                    onClickHandler: function onClickHandler(e, sickData, cell) {
                        return _this7._onEditSickRulesClicked(e, sickData, cell);
                    }
                };

                var plannedSickLeavesCell = new _TableCell2.default(userListUserInfo);
                plannedSickLeavesCell.setRenderer(new _PlannedLeaveRenderer.PlannedSickLeaveRenderer().init(this.sickValueFormatter));
                row.addCellObj(plannedSickLeavesCell);

                var sickDaysSpacerOne = new _TableCell2.default();
                sickDaysSpacerOne.setRenderer(new _EmptyCellRenderer2.default('sickDaysTab'));
                row.addCellObj(sickDaysSpacerOne);

                var sickDaysResetRulesCell = new _TableCell2.default(userListUserInfo);
                sickDaysResetRulesCell.setRenderer(new _SickDaysResetRulesCell2.default().init(this.sickRulesFormatter, _handlers));
                row.addCellObj(sickDaysResetRulesCell);

                var sickDaysAccrualRulesCell = new _TableCell2.default(userListUserInfo);
                sickDaysAccrualRulesCell.setRenderer(new _SickDaysAccrualRulesCell2.default().init(this.sickRulesFormatter, _handlers));
                row.addCellObj(sickDaysAccrualRulesCell);

                var sickDaysCapRulesCell = new _TableCell2.default(userListUserInfo);
                sickDaysCapRulesCell.setRenderer(new _SickDaysCapRulesCell2.default().init(this.sickRulesFormatter, _handlers));
                row.addCellObj(sickDaysCapRulesCell);

                var defaultSickDaysRulesCell = new _TableCell2.default(userListUserInfo);
                defaultSickDaysRulesCell.setRenderer(new _SickDaysDefaultRulesCell2.default().init(null, _handlers));
                defaultSickDaysRulesCell.setColspan(3);
                row.addCellObj(defaultSickDaysRulesCell);

                var sickDaysSpacerTwo = new _TableCell2.default();
                sickDaysSpacerTwo.setRenderer(new _EmptyCellRenderer2.default('sickDaysTab'));
                row.addCellObj(sickDaysSpacerTwo);

                var sickDaysControl = new _TableCell2.default(userListUserInfo);
                sickDaysControl.setRenderer(new _SickDaysControlRenderer2.default().init({
                    onClickHandler: this.params.handlersMap.toggleSickDaysControlStatus,
                    onMouseOverHandler: function onMouseOverHandler(e) {
                        return _this7.toggleHoverClassInSickDaysControlCell(e, true);
                    },
                    onMouseOutHandler: function onMouseOutHandler(e) {
                        return _this7.toggleHoverClassInSickDaysControlCell(e, false);
                    }
                }));
                row.addCellObj(sickDaysControl);
            }

            return row;
        }
    }, {
        key: 'updatePermissionsColumn',
        value: function updatePermissionsColumn(isURAEnabled, isBTYEnabled) {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = this.rows[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var row = _step.value;

                    row.getPermissionsCell().getRenderer().setContentState({
                        generateMoneyReportsEnabled: isURAEnabled || isBTYEnabled,
                        generateMoneyReportsTooltip: (0, _PermissionsUtils.getGenerateMoneyReportsRightTitle)(isURAEnabled, isBTYEnabled)
                    });
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    }, {
        key: 'updateManageScopeColumn',
        value: function updateManageScopeColumn(isURAEnabled, isBTYEnabled) {
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = this.rows[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var row = _step2.value;

                    var userInfo = row.getManageScopeCell().getValue();

                    row.getManageScopeCell().getRenderer().update({
                        isURAEnabled: isURAEnabled,
                        isBTYEnabled: isBTYEnabled,
                        hasManageScope: (0, _utils2.canUserAccessManagerScopes)({ userInfo: userInfo, isURAEnabled: isURAEnabled, isBTYEnabled: isBTYEnabled })
                    });
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }
        }
    }, {
        key: 'updateTeamsScopeColumn',
        value: function updateTeamsScopeColumn(isURAEnabled, isBTYEnabled) {
            var _iteratorNormalCompletion3 = true;
            var _didIteratorError3 = false;
            var _iteratorError3 = undefined;

            try {
                for (var _iterator3 = this.rows[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                    var row = _step3.value;

                    var userInfo = row.getTeamScopeCell().getValue();

                    row.getTeamScopeCell().getRenderer().update({
                        isURAEnabled: isURAEnabled,
                        isBTYEnabled: isBTYEnabled,
                        hasManageScope: (0, _utils2.canUserAccessManagerScopes)({ userInfo: userInfo, isURAEnabled: isURAEnabled, isBTYEnabled: isBTYEnabled })
                    });
                }
            } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion3 && _iterator3.return) {
                        _iterator3.return();
                    }
                } finally {
                    if (_didIteratorError3) {
                        throw _iteratorError3;
                    }
                }
            }
        }
    }, {
        key: 'setUserTableStateAndUpdateUI',
        value: function setUserTableStateAndUpdateUI(userListBeans, groupsMap, timeZoneGroupMap, usersWithoutApprovers, viewerSettings, sortOrder, tokens, isPTOEnabled, ptoHoursPerDay) {
            var usersData = userListBeans;
            this._updateParamsWithViewerSettings(viewerSettings);
            this.params.ptoFeatureEnabled = isPTOEnabled;
            this.params.ptoHoursPerDay = ptoHoursPerDay;
            this.params.sortOrder = sortOrder;
            this.params.usersWithoutApprovers = usersWithoutApprovers;

            this._createPtoRuleManager(this.state.ptoDefaults, this.$body);

            this._createSickRulesManager(this.state.sickDefaults, this.$body);

            this.deleteAllRowsFromModelAndDom();

            this.removeTrSpacers();

            this.tokensHighlighter = tokens && tokens.length > 0 ? new _TokensHighlighter2.default(tokens, PUNCTUATORS) : new _EmptyHighlighter2.default();
            if (this.ptoRulesManager) this.ptoRulesManager.reinitAccrualRulesControls(ptoHoursPerDay);

            if (this.sickRulesManager) this.sickRulesManager.reinitAccrualRulesControls(ptoHoursPerDay);
            this.createBodyContent(usersData, groupsMap, timeZoneGroupMap, this.tokensHighlighter);

            this.buildModelRowsDOM(this.tbody);
            this.updateUI();
        }
    }, {
        key: 'addCreatedUser',
        value: function addCreatedUser(userListUserInfo, groupName, timeZoneGroupName, warnings) {
            var row = this.createRow(userListUserInfo, groupName, timeZoneGroupName, this.tokensHighlighter, warnings);
            this._insertRowIntoFirstPosition(row);
        }
    }, {
        key: 'updateUser',
        value: function updateUser(userListUserInfo, viewerSettings, groupName, timeZoneGroupName, warnings, isEditMyself, noHighlight) {
            this._updateParamsWithViewerSettings(viewerSettings);

            var row = this.userIdRowMap[userListUserInfo.id];
            if (!row) {
                // update only existing rows
                return;
            }
            this._updateRow(userListUserInfo, groupName, timeZoneGroupName, row, warnings, noHighlight);
            if (isEditMyself) {
                var canManageLeaveBalancesChanged = this.params.canManageLeaveBalances !== userListUserInfo.hasManagePTOAndSickRight;
                this.params.canManageLeaveBalances = userListUserInfo.hasManagePTOAndSickRight;
                if (canManageLeaveBalancesChanged) this.updateUI();
            }
        }
    }, {
        key: 'deleteUser',
        value: function deleteUser(userId) {
            var row = (0, _jquery2.default)(this.userIdRowMap[userId].rowEl);
            var resetFirst = row.hasClass("first") && row.hasClass("newUser");

            this.removeRow(this.userIdRowMap[userId].getRowIdx());

            var newUsers = (0, _jquery2.default)(_get(UserTableController.prototype.__proto__ || Object.getPrototypeOf(UserTableController.prototype), 'getTableEl', this).call(this)).find(".newUser");
            if (!newUsers.length) this.removeTrSpacers();else newUsers.first().addClass("first");
        }
    }, {
        key: 'highlightRow',
        value: function highlightRow(row) {
            (0, _jquery2.default)(row.getRowEl()).addClass("updatedUser");
            setTimeout(function () {
                (0, _jquery2.default)(row.getRowEl()).removeClass('updatedUser');
            }, 1500);
        }
    }, {
        key: '_updateRow',
        value: function _updateRow(userListUserInfo, groupName, timeZoneGroupName, row, warnings, noHighlight) {
            var newRow = this.createRow(userListUserInfo, groupName, timeZoneGroupName, this.tokensHighlighter, warnings);
            this.replaceRowAndUpdateDOM(row.getRowIdx(), newRow);

            var classesToCopy = ["newUser", "first", "last", "selected"];
            for (var i = 0; i < classesToCopy.length; i++) {
                if ((0, _jquery2.default)(row.getRowEl()).hasClass(classesToCopy[i])) (0, _jquery2.default)(newRow.getRowEl()).addClass(classesToCopy[i]);
            }

            if (!noHighlight) {
                this.highlightRow(newRow);
            }
        }
    }, {
        key: 'removeTrSpacers',
        value: function removeTrSpacers() {
            (0, _jquery2.default)(".topSpacer, .bottomSpacer").remove();
        }
    }, {
        key: '_insertRowIntoFirstPosition',
        value: function _insertRowIntoFirstPosition(row) {
            this.setupRow(0, row);
            this.rows.unshift(row);
            for (var i = 1; i < this.rows.length; i++) {
                var nextRow = this.rows[i];
                nextRow.setRowIdx(i);
            }

            var rowElClasses = this.getRowElClasses(0);

            if (!(0, _jquery2.default)(_get(UserTableController.prototype.__proto__ || Object.getPrototypeOf(UserTableController.prototype), 'getTableEl', this).call(this)).find('.newUser').length) {
                this.tbody.insertBefore(row.getRowEl(), this.tbody.firstChild);

                rowElClasses.push("last");
            } else {
                var firstNewUserEl = (0, _jquery2.default)(_get(UserTableController.prototype.__proto__ || Object.getPrototypeOf(UserTableController.prototype), 'getTableEl', this).call(this)).find(".newUser.first")[0];
                this.tbody.insertBefore(row.getRowEl(), firstNewUserEl);
                (0, _jquery2.default)(_get(UserTableController.prototype.__proto__ || Object.getPrototypeOf(UserTableController.prototype), 'getTableEl', this).call(this)).find(".newUser.first").removeClass("first");
            }

            row.writeCellsContent();
            rowElClasses.push("newUser");
            rowElClasses.push("first");
            row.getRowEl().className = rowElClasses.join(" ");
        }
    }, {
        key: 'updateUserGroups',
        value: function updateUserGroups(userIdGroupIdMap, groupMap) {
            for (var i = 0; i < this.rows.length; i++) {
                var row = this.rows[i];

                row.userListUserInfo.userGroupId = userIdGroupIdMap[row.userListUserInfo.id];

                var cell = row.getNameCell();
                var name = groupMap[row.userListUserInfo.userGroupId];

                //if user was concurrently deleted he isn't in userGroupMap but we do not react
                if (name) cell.updateGroupName(name);
            }
        }
    }, {
        key: 'updateTimeZoneGroups',
        value: function updateTimeZoneGroups(timeZoneIdGroupIdMap, timeZoneGroupsMap) {
            for (var i = 0; i < this.rows.length; i++) {
                var row = this.rows[i];

                row.userListUserInfo.timeZoneGroupId = timeZoneIdGroupIdMap[row.userListUserInfo.id];

                var cell = row.getNameCell();
                var name = timeZoneGroupsMap[row.userListUserInfo.timeZoneGroupId];

                if (name) cell.updateTimeZoneGroupName(name);
            }
        }
    }, {
        key: 'updateUsersWithoutApprovers',
        value: function updateUsersWithoutApprovers(usersWithoutApprovers) {
            this.params.usersWithoutApprovers = usersWithoutApprovers;

            var usersWithoutApproversSet = (0, _atUtils.arrayToSet)(usersWithoutApprovers);
            this.rows.forEach(function (row) {
                var cell = row.getNameCell();
                cell.getRenderer().updateUsersWithoutApproval(cell, !usersWithoutApproversSet[cell.getValue().id]);
            });
        }
    }, {
        key: 'setUsersAutoapproved',
        value: function setUsersAutoapproved() {
            this.rows.forEach(function (row) {
                var cell = row.getNameCell();
                cell.setValue(_extends({}, cell.getValue(), { requiresTTApproval: false }));
                cell.updateCell();
            });
        }
    }, {
        key: 'addRowSelection',
        value: function addRowSelection(row) {
            row.addClass("selected");
        }
    }, {
        key: 'addRowSelectionByIdx',
        value: function addRowSelectionByIdx(idx) {
            var row = this.rows[idx];
            if (row) {
                this.addRowSelection((0, _jquery2.default)(row.getRowEl()));
            }
        }
    }, {
        key: 'addRowSelectionByUserId',
        value: function addRowSelectionByUserId(userId) {
            var row = this.rows.find(function (row) {
                return row.userListUserInfo.id === userId;
            });
            if (row) {
                this.addRowSelection((0, _jquery2.default)(row.getRowEl()));
            }
        }
    }, {
        key: 'clearRowSelectionByUserId',
        value: function clearRowSelectionByUserId(userId) {
            var row = this.rows.find(function (row) {
                return row.userListUserInfo.id === userId;
            });
            if (row) {
                this.clearRowSelection((0, _jquery2.default)(row.getRowEl()));
            }
        }
    }, {
        key: 'clearRowSelectionByIdx',
        value: function clearRowSelectionByIdx(idx) {
            var row = this.rows[idx];
            if (row) {
                this.clearRowSelection((0, _jquery2.default)(row.getRowEl()));
            }
        }
    }, {
        key: 'clearRowSelection',
        value: function clearRowSelection(row) {
            row.removeClass("selected");
        }
    }, {
        key: 'showLoadingHistoryProgress',
        value: function showLoadingHistoryProgress(cell, spinner) {
            cell.addClass("loading");
            spinner.spinInElement((0, _jquery2.default)(cell.find(".ptoHistorySpinnerPlaceholder").get(0)));
        }
    }, {
        key: 'hideLoadingHistoryProgress',
        value: function hideLoadingHistoryProgress(cell, spinner) {
            cell.removeClass("loading");
            spinner.stop();
        }
    }, {
        key: 'updateUI',
        value: function updateUI() {
            this.tableRenderer.updateUI(this, this._isEditingUsersAllowed(), (this.params.ptoFeatureEnabled || this.params.sickFeatureEnabled) && this.params.canManageLeaveBalances, this.params.ptoFeatureEnabled, this.params.sickFeatureEnabled, this.params.accountSettingsVisible, this.params.sortOrder.order, this.params.sortOrder.asc);
        }
    }, {
        key: '_updateParamsWithViewerSettings',
        value: function _updateParamsWithViewerSettings(viewerSettings) {
            this.params.canManageLeaveBalances = viewerSettings.allowedToManageLeaveBalanceSettings;
            this.params.canManageAccounts = viewerSettings.allowedToManageAccountSettings;
            this.params.accountSettingsVisible = viewerSettings.showAccountSettings;
        }
    }, {
        key: 'isManageLeaveBalancesColumnAvailable',
        value: function isManageLeaveBalancesColumnAvailable() {
            return (this.params.ptoFeatureEnabled || this.params.sickFeatureEnabled) && this.params.accountSettingsVisible;
        }
    }, {
        key: 'isShowHistoryAvailable',
        value: function isShowHistoryAvailable() {
            return this.params.canManageLeaveBalances;
        }
    }, {
        key: '_initializeFormatters',
        value: function _initializeFormatters() {
            var _this8 = this;

            var ptoPostfixSymbol = window.SystemSettings.showPTOInHours ? _messageResource2.default.getMessage('common.pto_units.hours.short') : _messageResource2.default.getMessage('common.pto_units.days.short');
            this.ptoFormatter = this.getBalanceFormatter(ptoPostfixSymbol);
            this.rulesFormatter = this.getBalanceFormatter(ptoPostfixSymbol);

            var sickPostfixSymbol = window.SystemSettings.showSickInHours ? _messageResource2.default.getMessage('common.pto_units.hours.short') : _messageResource2.default.getMessage('common.pto_units.days.short');
            this.sickFormatter = this.getBalanceFormatter(sickPostfixSymbol);
            this.sickDaysRulesFormatter = this.getBalanceFormatter(sickPostfixSymbol);

            this.ptoValueFormatter = function (value) {
                var val = window.SystemSettings.showPTOInHours ? value * _this8.params.ptoHoursPerDay : value;
                return _this8.ptoFormatter.format(val);
            };

            this.ptoRulesFormatter = function (value) {
                var val = window.SystemSettings.showPTOInHours ? value * _this8.params.ptoHoursPerDay : value;
                return _this8.rulesFormatter.format(val);
            };

            this.sickValueFormatter = function (value) {
                var val = window.SystemSettings.showSickInHours ? value * _this8.params.ptoHoursPerDay : value;
                return _this8.sickFormatter.format(val);
            };

            this.sickRulesFormatter = function (value) {
                var val = window.SystemSettings.showSickInHours ? value * _this8.params.ptoHoursPerDay : value;
                return _this8.sickDaysRulesFormatter.format(val);
            };
        }
    }, {
        key: 'getBalanceFormatter',
        value: function getBalanceFormatter(postfixSymbol) {
            var precision = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;

            return new _number_formatter2.default(window.SystemSettings.decimalSeparator, window.SystemSettings.digitGroupingSymbol, precision, true, '', postfixSymbol);
        }
    }, {
        key: '_createSickRulesManager',
        value: function _createSickRulesManager(sickDefaults, $body) {
            if (this.state.showSDPTab && sickDefaults) {
                this.sickRulesManager && this.sickRulesManager.getEl().remove();
                this.sickRulesManager = new _BalanceRulesEditorDialogContent2.default({
                    leaveBalanceTypePrefix: "sick",
                    balanceDefaults: sickDefaults,
                    countHoursPerDay: this.params.ptoHoursPerDay,
                    parameters: {
                        defaultMessageNoteKey: "sick_rules_editor.info.default",
                        titleNoteKey: "sick_rules_editor.use_accrual_rules",
                        customMessageNoteKey: "pto_rules_editor.info.custom",
                        customTitleTooltip: "sick_rules_editor.custom_rules",
                        defaultTitleTooltip: "sick_rules_editor.default_rules"
                    }
                }).init($body);
            }
        }
    }, {
        key: '_createPtoRuleManager',
        value: function _createPtoRuleManager(ptoDefaults, $body) {
            if (this.state.showPTOTab && ptoDefaults) {
                this.ptoRulesManager && this.ptoRulesManager.getEl().remove();
                this.ptoRulesManager = new _BalanceRulesEditorDialogContent2.default({
                    leaveBalanceTypePrefix: "pto",
                    balanceDefaults: ptoDefaults,
                    countHoursPerDay: this.params.ptoHoursPerDay,
                    parameters: {
                        defaultMessageNoteKey: "pto_rules_editor.info.default",
                        titleNoteKey: "pto_rules_editor.use_accrual_rules",
                        customMessageNoteKey: "pto_rules_editor.info.custom",
                        customTitleTooltip: "pto_rules_editor.custom_rules",
                        defaultTitleTooltip: "pto_rules_editor.default_rules"
                    }
                }).init($body);
            }
        }
    }, {
        key: '_isEditingUsersAllowed',
        value: function _isEditingUsersAllowed() {
            return this.params.canManageAccounts;
        }
    }, {
        key: '_getNameForTooltips',
        value: function _getNameForTooltips(cell) {
            return cell.getValue().firstName;
        }

        /* name cell */


        /* management cells */

    }]);

    return UserTableController;
}(_Table3.default);

exports.default = (0, _utils.connect)(function (state) {
    return {
        showPTOTab: (0, _selectors.isPTOTabAvailable)(state),
        showSDPTab: (0, _selectors.isSDBTabAvailable)(state),
        isBTYEnabled: (0, _selectors2.isBTYEnabled)(state),
        isURAEnabled: (0, _selectors2.isURAEnabled)(state),
        isTTAEnabled: (0, _selectors2.isTTAEnabled)(state)
    };
})(UserTableController);

/***/ }),
/* 1596 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
function UserRowRenderer() {
    this.constructor = UserRowRenderer;
}

UserRowRenderer.prototype.init = function () {
    return this;
};

UserRowRenderer.prototype.getRowClasses = function (userListUserInfo) {
    var classes = ["userListRow"];
    if (!userListUserInfo.enabled) classes.push("disabled");
    if (userListUserInfo.enabledInOtherProduct !== null) {
        classes.push("linkedNotNull");
        if (userListUserInfo.enabledInOtherProduct === true) classes.push("linkedWithActiplans");
    }
    if (userListUserInfo.hasManageUsersRight) classes.push("accountPermission");
    if (userListUserInfo.hasManageSettingsRight) classes.push("settingsPermission");
    if (userListUserInfo.hasManageCustomersProjectsRight) classes.push("customerProjectPermission");
    if (userListUserInfo.hasManageTasksRight) classes.push("taskPermission");
    if (userListUserInfo.locked) classes.push("locked");
    return classes;
};

UserRowRenderer.prototype.updateUI = function (row, userListUserInfo) {
    row.getRowEl().className = this.getRowClasses(userListUserInfo).join(" ");
};

exports.default = UserRowRenderer;

/***/ }),
/* 1597 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _FilterWordsField = __webpack_require__(348);

var _FilterWordsField2 = _interopRequireDefault(_FilterWordsField);

var _constants = __webpack_require__(4);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function UserTableRenderer() {
    this.constructor = UserTableRenderer;
}

UserTableRenderer.sortOrderClasses = [];
UserTableRenderer.sortOrderClasses[_constants.UserManagementConstants.USER_LIST_ORDER_BY_NAME] = "sortByName";
UserTableRenderer.sortOrderClasses[_constants.UserManagementConstants.USER_LIST_ORDER_BY_GROUP_NAME] = "sortByGroupName";
UserTableRenderer.sortOrderClasses[_constants.UserManagementConstants.USER_LIST_ORDER_BY_PTO_BALANCE] = "sortByPTO";
UserTableRenderer.sortOrderClasses[_constants.UserManagementConstants.USER_LIST_ORDER_BY_APPROVED_PTO] = "sortByApprovedPTO";
UserTableRenderer.sortOrderClasses[_constants.UserManagementConstants.USER_LIST_ORDER_BY_PTO_CONTROL_STATUS] = "sortByPTOControl";
UserTableRenderer.sortOrderClasses[_constants.UserManagementConstants.USER_LIST_ORDER_BY_SICK_BALANCE] = "sortBySick";
UserTableRenderer.sortOrderClasses[_constants.UserManagementConstants.USER_LIST_ORDER_BY_APPROVED_SICK] = "sortByApprovedSick";
UserTableRenderer.sortOrderClasses[_constants.UserManagementConstants.USER_LIST_ORDER_BY_SICK_CONTROL_STATUS] = "sortBySickControl";
UserTableRenderer.sortOrderClasses[_constants.UserManagementConstants.USER_LIST_ORDER_BY_TIME_ZONE_GROUP_NAME] = "sortByTimeZoneGroupName";

UserTableRenderer.prototype.init = function () {
    return this;
};

UserTableRenderer.prototype.setupEventHandlers = function (handlersMap) {
    document.getElementById("sortByPTOLink").onclick = handlersMap.sortByPTO;
    document.getElementById("sortByApprovedPTO").onclick = handlersMap.sortByApprovedPTO;
    document.getElementById("sortByPTOControl").onclick = handlersMap.sortByPTOControl;
    document.getElementById("sortBySickLink").onclick = handlersMap.sortBySick;
    document.getElementById("sortByApprovedSick").onclick = handlersMap.sortByApprovedSick;
    document.getElementById("sortBySickControl").onclick = handlersMap.sortBySickControl;
};

UserTableRenderer.prototype._getViewerRightsClasses = function (canEditUsers, showPTO, showPTOSettings, showSick, showSickSettings, showAccountSettings) {
    var classes = [];
    if (canEditUsers) classes.push("canEditUsers");
    if (!showPTOSettings) {
        classes.push("hidePTOSettings");
    }
    if (!showSickSettings) {
        classes.push("hideSickSettings");
    }
    if (!showPTO && !showSick) classes.push("hideBalances");
    if (!showAccountSettings) classes.push("hideAccountSettings");
    return classes;
};

UserTableRenderer.prototype._getSortClasses = function (sortOrder, asc) {
    var classes = [UserTableRenderer.sortOrderClasses[sortOrder]];
    if (!asc) classes.push("desc");
    return classes;
};

UserTableRenderer.prototype.updateUI = function (table, canEditUsers, canManageLeaveBalances, showPTO, showSick, showAccountSettings, sortOrder, asc) {
    var viewerRightsClasses = this._getViewerRightsClasses(canEditUsers, showPTO, canManageLeaveBalances, showSick, canManageLeaveBalances, showAccountSettings);
    var sortClasses = this._getSortClasses(sortOrder, asc);
    var classes = ["userListTable"].concat(viewerRightsClasses).concat(sortClasses);
    table.getTableEl().className = classes.join(" ");
};

exports.default = UserTableRenderer;

/***/ }),
/* 1598 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isSDBTabAvailable = exports.isPTOTabAvailable = exports.getViewerSettings = undefined;

var _reselect = __webpack_require__(13);

var _selectors = __webpack_require__(15);

var getViewerSettings = exports.getViewerSettings = function getViewerSettings(state) {
    return state.userManagement.common.viewerSettings;
};

var isPTOTabAvailable = exports.isPTOTabAvailable = (0, _reselect.createSelector)(getViewerSettings, _selectors.isPTOEnabled, function (viewerSettings, isPtoEnabled) {
    return viewerSettings.allowedToManageLeaveBalanceSettings && isPtoEnabled;
});

var isSDBTabAvailable = exports.isSDBTabAvailable = (0, _reselect.createSelector)(getViewerSettings, _selectors.isSDBEnabled, function (viewerSettings, isSDBEnabled) {
    return viewerSettings.allowedToManageLeaveBalanceSettings && isSDBEnabled;
});

/***/ }),
/* 1599 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _TableCell = __webpack_require__(166);

var _TableCell2 = _interopRequireDefault(_TableCell);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function UserNameCell() {
    this.constructor = UserNameCell;
}

UserNameCell.prototype = _.create(_TableCell2.default.prototype, {

    init: function init(userListUserInfo, groupName, timeZoneGroupName, rowObj, warnings, infos) {
        _TableCell2.default.call(this, userListUserInfo, rowObj);
        this.groupName = groupName;
        this.timeZoneGroupName = timeZoneGroupName;
        this.warnings = warnings;
        this.infos = infos;
        return this;
    },

    getTimeZoneGroupName: function getTimeZoneGroupName() {
        return this.timeZoneGroupName;
    },

    getGroupName: function getGroupName() {
        return this.groupName;
    },

    updateTimeZoneGroupName: function updateTimeZoneGroupName(timeZoneGroupName) {
        this.timeZoneGroupName = timeZoneGroupName;
        this.renderer.updateTimeZoneGroupName(this);
    },

    updateGroupName: function updateGroupName(groupName) {
        this.groupName = groupName;
        this.renderer.updateGroupName(this);
    }
});

exports.default = UserNameCell;

/***/ }),
/* 1600 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.PlannedSickLeaveRenderer = exports.PlannedPTOLeaveRenderer = undefined;

var _TableCellRenderer = __webpack_require__(63);

var _TableCellRenderer2 = _interopRequireDefault(_TableCellRenderer);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function PlannedLeaveRenderer() {}

PlannedLeaveRenderer.prototype = _underscore2.default.create(_TableCellRenderer2.default.prototype);

PlannedLeaveRenderer.prototype.init = function (formatter) {
    _TableCellRenderer2.default.call(this);
    this.formatter = formatter;
    return this;
};

PlannedLeaveRenderer.prototype.hasValue = function (cell) {
    return false;
};

PlannedLeaveRenderer.prototype.getCellClassName = function (cell) {
    var value = cell.getValue();
    return [this.cellGeneralClassName, 'plannedLeaveCell', this.hasValue(cell) ? "on" : "off"];
};

PlannedLeaveRenderer.prototype.generateContent = function (cell) {
    //abstract
};

function PlannedPTOLeaveRenderer() {}

PlannedPTOLeaveRenderer.prototype = _underscore2.default.create(PlannedLeaveRenderer.prototype);
PlannedPTOLeaveRenderer.prototype.cellGeneralClassName = "ptoCell";
PlannedPTOLeaveRenderer.prototype.hasValue = function (cell) {
    return cell.getValue().pto;
};
PlannedPTOLeaveRenderer.prototype.generateContent = function (cell) {
    var value = cell.getValue();
    cell.getCellEl().innerHTML = !this.hasValue(cell) ? "&ndash;" : this.formatter(value.currentPTOBalance.plannedBalanceApproved);
};

function PlannedSickLeaveRenderer() {}

PlannedSickLeaveRenderer.prototype = _underscore2.default.create(PlannedLeaveRenderer.prototype);
PlannedSickLeaveRenderer.prototype.cellGeneralClassName = "sickDaysCell";
PlannedSickLeaveRenderer.prototype.hasValue = function (cell) {
    return cell.getValue().sick;
};
PlannedSickLeaveRenderer.prototype.generateContent = function (cell) {
    var value = cell.getValue();
    cell.getCellEl().innerHTML = !this.hasValue(cell) ? "&ndash;" : this.formatter(value.currentSickDaysBalance.plannedBalanceApproved);
};

exports.default = PlannedLeaveRenderer;
exports.PlannedPTOLeaveRenderer = PlannedPTOLeaveRenderer;
exports.PlannedSickLeaveRenderer = PlannedSickLeaveRenderer;

/***/ }),
/* 1601 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _ShowBalanceHistoryCellRenderer = __webpack_require__(850);

var _ShowBalanceHistoryCellRenderer2 = _interopRequireDefault(_ShowBalanceHistoryCellRenderer);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ShowPtoHistoryCellRenderer() {
    this.constructor = ShowPtoHistoryCellRenderer;
}

ShowPtoHistoryCellRenderer.prototype = _underscore2.default.create(_ShowBalanceHistoryCellRenderer2.default.prototype, {
    getCellGeneralClassName: function getCellGeneralClassName() {
        return "showPtoHistoryCell";
    },

    getFlagValue: function getFlagValue(value) {
        return value.pto; //TODO(petrov): refactor this function
    },
    getCellTooltipText: function getCellTooltipText() {
        return _messageResource2.default.getMessage("common.pto_history.show_pto_history.tooltip.text");
    }
});

exports.default = ShowPtoHistoryCellRenderer;

/***/ }),
/* 1602 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _ShowBalanceHistoryCellRenderer = __webpack_require__(850);

var _ShowBalanceHistoryCellRenderer2 = _interopRequireDefault(_ShowBalanceHistoryCellRenderer);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ShowSickDaysHistoryCellRenderer() {
    this.constructor = ShowSickDaysHistoryCellRenderer;
}

ShowSickDaysHistoryCellRenderer.prototype = _underscore2.default.create(_ShowBalanceHistoryCellRenderer2.default.prototype, {

    getCellGeneralClassName: function getCellGeneralClassName() {
        return "showSickDaysHistoryCell";
    },

    getFlagValue: function getFlagValue(value) {
        return value.sick;
    },

    getCellTooltipText: function getCellTooltipText() {
        return _messageResource2.default.getMessage("common.sick_history.show_sick_history.tooltip.text");
    }
});

exports.default = ShowSickDaysHistoryCellRenderer;

/***/ }),
/* 1603 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ResetRulesCell2 = __webpack_require__(543);

var _ResetRulesCell3 = _interopRequireDefault(_ResetRulesCell2);

var _PtoRulesMixin = __webpack_require__(391);

var _PtoRulesMixin2 = _interopRequireDefault(_PtoRulesMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PtoResetRulesCell = function (_ResetRulesCell) {
    _inherits(PtoResetRulesCell, _ResetRulesCell);

    function PtoResetRulesCell() {
        _classCallCheck(this, PtoResetRulesCell);

        var _this = _possibleConstructorReturn(this, (PtoResetRulesCell.__proto__ || Object.getPrototypeOf(PtoResetRulesCell)).call(this));

        _this.mixin = new _PtoRulesMixin2.default();
        return _this;
    }

    return PtoResetRulesCell;
}(_ResetRulesCell3.default);

exports.default = PtoResetRulesCell;

/***/ }),
/* 1604 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _AccrualRulesCell2 = __webpack_require__(544);

var _AccrualRulesCell3 = _interopRequireDefault(_AccrualRulesCell2);

var _PtoRulesMixin = __webpack_require__(391);

var _PtoRulesMixin2 = _interopRequireDefault(_PtoRulesMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PtoAccrualRulesCell = function (_AccrualRulesCell) {
    _inherits(PtoAccrualRulesCell, _AccrualRulesCell);

    function PtoAccrualRulesCell() {
        _classCallCheck(this, PtoAccrualRulesCell);

        var _this = _possibleConstructorReturn(this, (PtoAccrualRulesCell.__proto__ || Object.getPrototypeOf(PtoAccrualRulesCell)).call(this));

        _this.mixin = new _PtoRulesMixin2.default();
        return _this;
    }

    return PtoAccrualRulesCell;
}(_AccrualRulesCell3.default);

exports.default = PtoAccrualRulesCell;

/***/ }),
/* 1605 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ResetRulesCell2 = __webpack_require__(543);

var _ResetRulesCell3 = _interopRequireDefault(_ResetRulesCell2);

var _SickDaysRulesMixin = __webpack_require__(392);

var _SickDaysRulesMixin2 = _interopRequireDefault(_SickDaysRulesMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SickDaysResetRulesCell = function (_ResetRulesCell) {
    _inherits(SickDaysResetRulesCell, _ResetRulesCell);

    function SickDaysResetRulesCell() {
        _classCallCheck(this, SickDaysResetRulesCell);

        var _this = _possibleConstructorReturn(this, (SickDaysResetRulesCell.__proto__ || Object.getPrototypeOf(SickDaysResetRulesCell)).call(this));

        _this.mixin = new _SickDaysRulesMixin2.default();
        return _this;
    }

    return SickDaysResetRulesCell;
}(_ResetRulesCell3.default);

exports.default = SickDaysResetRulesCell;

/***/ }),
/* 1606 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _CapRulesCell2 = __webpack_require__(851);

var _CapRulesCell3 = _interopRequireDefault(_CapRulesCell2);

var _PtoRulesMixin = __webpack_require__(391);

var _PtoRulesMixin2 = _interopRequireDefault(_PtoRulesMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PtoCapRulesCell = function (_CapRulesCell) {
    _inherits(PtoCapRulesCell, _CapRulesCell);

    function PtoCapRulesCell() {
        _classCallCheck(this, PtoCapRulesCell);

        var _this = _possibleConstructorReturn(this, (PtoCapRulesCell.__proto__ || Object.getPrototypeOf(PtoCapRulesCell)).call(this));

        _this.mixin = new _PtoRulesMixin2.default();
        return _this;
    }

    return PtoCapRulesCell;
}(_CapRulesCell3.default);

exports.default = PtoCapRulesCell;

/***/ }),
/* 1607 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _AccrualRulesCell2 = __webpack_require__(544);

var _AccrualRulesCell3 = _interopRequireDefault(_AccrualRulesCell2);

var _SickDaysRulesMixin = __webpack_require__(392);

var _SickDaysRulesMixin2 = _interopRequireDefault(_SickDaysRulesMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SickDaysAccrualRulesCell = function (_AccrualRulesCell) {
    _inherits(SickDaysAccrualRulesCell, _AccrualRulesCell);

    function SickDaysAccrualRulesCell() {
        _classCallCheck(this, SickDaysAccrualRulesCell);

        var _this = _possibleConstructorReturn(this, (SickDaysAccrualRulesCell.__proto__ || Object.getPrototypeOf(SickDaysAccrualRulesCell)).call(this));

        _this.mixin = new _SickDaysRulesMixin2.default();
        return _this;
    }

    return SickDaysAccrualRulesCell;
}(_AccrualRulesCell3.default);

exports.default = SickDaysAccrualRulesCell;

/***/ }),
/* 1608 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _DefaultRulesCell2 = __webpack_require__(852);

var _DefaultRulesCell3 = _interopRequireDefault(_DefaultRulesCell2);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _PtoRulesMixin = __webpack_require__(391);

var _PtoRulesMixin2 = _interopRequireDefault(_PtoRulesMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PtoDefaultRulesCell = function (_DefaultRulesCell) {
    _inherits(PtoDefaultRulesCell, _DefaultRulesCell);

    function PtoDefaultRulesCell() {
        _classCallCheck(this, PtoDefaultRulesCell);

        var _this = _possibleConstructorReturn(this, (PtoDefaultRulesCell.__proto__ || Object.getPrototypeOf(PtoDefaultRulesCell)).call(this));

        _this.defaultMessage = _messageResource2.default.getMessage("pto_rules_editor.default_pto_rules");
        _this.mixin = new _PtoRulesMixin2.default();
        return _this;
    }

    return PtoDefaultRulesCell;
}(_DefaultRulesCell3.default);

exports.default = PtoDefaultRulesCell;

/***/ }),
/* 1609 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _CapRulesCell2 = __webpack_require__(851);

var _CapRulesCell3 = _interopRequireDefault(_CapRulesCell2);

var _SickDaysRulesMixin = __webpack_require__(392);

var _SickDaysRulesMixin2 = _interopRequireDefault(_SickDaysRulesMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SickDaysCapRulesCell = function (_CapRulesCell) {
    _inherits(SickDaysCapRulesCell, _CapRulesCell);

    function SickDaysCapRulesCell() {
        _classCallCheck(this, SickDaysCapRulesCell);

        var _this = _possibleConstructorReturn(this, (SickDaysCapRulesCell.__proto__ || Object.getPrototypeOf(SickDaysCapRulesCell)).call(this));

        _this.mixin = new _SickDaysRulesMixin2.default();
        return _this;
    }

    return SickDaysCapRulesCell;
}(_CapRulesCell3.default);

exports.default = SickDaysCapRulesCell;

/***/ }),
/* 1610 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _DefaultRulesCell2 = __webpack_require__(852);

var _DefaultRulesCell3 = _interopRequireDefault(_DefaultRulesCell2);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _SickDaysRulesMixin = __webpack_require__(392);

var _SickDaysRulesMixin2 = _interopRequireDefault(_SickDaysRulesMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SickDaysDefaultRulesCell = function (_DefaultRulesCell) {
    _inherits(SickDaysDefaultRulesCell, _DefaultRulesCell);

    function SickDaysDefaultRulesCell() {
        _classCallCheck(this, SickDaysDefaultRulesCell);

        var _this = _possibleConstructorReturn(this, (SickDaysDefaultRulesCell.__proto__ || Object.getPrototypeOf(SickDaysDefaultRulesCell)).call(this));

        _this.defaultMessage = _messageResource2.default.getMessage("sick_days_rules_editor.default_sick_days_rules");
        _this.mixin = new _SickDaysRulesMixin2.default();
        return _this;
    }

    return SickDaysDefaultRulesCell;
}(_DefaultRulesCell3.default);

exports.default = SickDaysDefaultRulesCell;

/***/ }),
/* 1611 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _BalanceControlRenderer = __webpack_require__(853);

var _BalanceControlRenderer2 = _interopRequireDefault(_BalanceControlRenderer);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function SickDaysControlRenderer() {}
SickDaysControlRenderer.prototype = _underscore2.default.create(_BalanceControlRenderer2.default.prototype);
SickDaysControlRenderer.prototype.cellGeneralClassName = "sickDaysControlCell";
SickDaysControlRenderer.prototype.getFlagValue = function (value) {
    return value.sick;
};

exports.default = SickDaysControlRenderer;

/***/ }),
/* 1612 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _BalanceControlRenderer = __webpack_require__(853);

var _BalanceControlRenderer2 = _interopRequireDefault(_BalanceControlRenderer);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function PtoControlRenderer() {}
PtoControlRenderer.prototype = _underscore2.default.create(_BalanceControlRenderer2.default.prototype);
PtoControlRenderer.prototype.cellGeneralClassName = "ptoControlCell";
PtoControlRenderer.prototype.getFlagValue = function (value) {
    return value.pto;
};

exports.default = PtoControlRenderer;

/***/ }),
/* 1613 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _BalanceCellRenderer = __webpack_require__(854);

var _BalanceCellRenderer2 = _interopRequireDefault(_BalanceCellRenderer);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function SickDaysCellRenderer() {
    this.constructor = SickDaysCellRenderer;
}

SickDaysCellRenderer.prototype = _.create(_BalanceCellRenderer2.default.prototype, {

    getCellGeneralClassName: function getCellGeneralClassName() {
        return _BalanceCellRenderer2.default.prototype.getCellGeneralClassName.call(this) + " sickDaysCell";
    },

    roundBalance: function roundBalance() {
        return window.SystemSettings.roundSickBalanceOnUserlist;
    },

    getFlagValue: function getFlagValue(value) {
        return value.sick;
    },

    getCurrentBalanceFromValue: function getCurrentBalanceFromValue(value) {
        return value.currentSickDaysBalance;
    },

    showBalanceInHours: function showBalanceInHours() {
        return window.SystemSettings.showSickInHours;
    },

    getNotStartedText: function getNotStartedText() {
        return _messageResource2.default.getEscapedMessage("userlist.js.table.sickCell.not_started");
    }
});

exports.default = SickDaysCellRenderer;

/***/ }),
/* 1614 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _BalanceCellRenderer = __webpack_require__(854);

var _BalanceCellRenderer2 = _interopRequireDefault(_BalanceCellRenderer);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function PTOCellRenderer() {
    this.constructor = PTOCellRenderer;
}

PTOCellRenderer.prototype = _underscore2.default.create(_BalanceCellRenderer2.default.prototype, {
    getCellGeneralClassName: function getCellGeneralClassName() {
        return _BalanceCellRenderer2.default.prototype.getCellGeneralClassName.call(this) + " ptoCell";
    },

    roundBalance: function roundBalance() {
        return window.SystemSettings.roundPTOBalanceOnUserlist;
    },

    getFlagValue: function getFlagValue(value) {
        return value.pto;
    },

    getCurrentBalanceFromValue: function getCurrentBalanceFromValue(value) {
        return value.currentPTOBalance;
    },

    showBalanceInHours: function showBalanceInHours() {
        return window.SystemSettings.showPTOInHours;
    },

    getNotStartedText: function getNotStartedText() {
        return _messageResource2.default.getEscapedMessage("userlist.js.table.ptoCell.not_started");
    }
});

exports.default = PTOCellRenderer;

/***/ }),
/* 1615 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _TableCellRenderer2 = __webpack_require__(63);

var _TableCellRenderer3 = _interopRequireDefault(_TableCellRenderer2);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _NameCellContent = __webpack_require__(855);

var _NameCellContent2 = _interopRequireDefault(_NameCellContent);

var _atUtils = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NameCellRenderer = function (_TableCellRenderer) {
    _inherits(NameCellRenderer, _TableCellRenderer);

    function NameCellRenderer() {
        _classCallCheck(this, NameCellRenderer);

        return _possibleConstructorReturn(this, (NameCellRenderer.__proto__ || Object.getPrototypeOf(NameCellRenderer)).apply(this, arguments));
    }

    _createClass(NameCellRenderer, [{
        key: 'init',
        value: function init(_ref) {
            var tokensHighlighter = _ref.tokensHighlighter,
                isEditingAllowed = _ref.isEditingAllowed,
                hasApprover = _ref.hasApprover,
                onClickCb = _ref.onClickCb,
                warningsController = _ref.warningsController,
                onMouseIn = _ref.onMouseIn,
                onMouseOut = _ref.onMouseOut;

            _TableCellRenderer3.default.call(this);
            this.tokensHighlighter = tokensHighlighter;
            this.isEditingAllowed = isEditingAllowed;
            this.onClickCb = onClickCb;

            this.warningsController = warningsController;

            this.params = {
                hasApprover: hasApprover,
                onMouseIn: onMouseIn,
                onMouseOut: onMouseOut
            };

            return this;
        }
    }, {
        key: 'generateContent',
        value: function generateContent(cell) {
            var _this2 = this;

            var cellEl = cell.getCellEl();
            var $cell = (0, _jquery2.default)(cellEl);

            this.content = new _NameCellContent2.default({
                warningsController: this.warningsController,
                onClick: function onClick(e) {
                    if (_this2.isEditingAllowed && !cell.getValue().locked) {
                        _this2.onClickCb(cell, e);
                    }
                },
                onMouseIn: function onMouseIn(e) {
                    if (_this2.isEditingAllowed && !cell.getValue().locked) {
                        _this2.params.onMouseIn(cell, e);
                        $cell.addClass("hovered");
                    }
                },
                onMouseOut: function onMouseOut(e) {
                    if (_this2.isEditingAllowed && !cell.getValue().locked) {
                        _this2.params.onMouseOut(cell, e);
                        $cell.removeClass("hovered");
                    }
                }
            }).init($cell);

            this.content.setState({
                userGroupName: cell.getGroupName(),
                timeZoneGroupName: cell.getTimeZoneGroupName(),
                infos: cell.infos,
                warnings: cell.warnings,
                firstName: cell.getValue().firstName,
                lastName: cell.getValue().lastName,
                username: cell.getValue().username,
                middleInitial: cell.getValue().middleInitial,
                clickable: cell.getValue().editable,
                locked: cell.getValue().locked,
                highlighter: this.tokensHighlighter
            });

            if (this.isEditingAllowed && cell.getValue().locked) {
                cellEl.title = _messageResource2.default.getMessage("user.edit.js.user_is_locked");
            }

            this.updateContent(cell);
        }
    }, {
        key: 'updateContent',
        value: function updateContent(cell) {
            this.content.setState({
                withoutApprover: cell.getValue().requiresTTApproval && !this.params.hasApprover,
                invalidReleaseDate: (0, _atUtils.compareNullableStrDates)(cell.getValue().hireDate, cell.getValue().releaseDate) > 0,
                userGroupName: cell.groupName,
                timeZoneGroupName: cell.timeZoneGroupName
            });
        }
    }, {
        key: 'getCellClassName',
        value: function getCellClassName() {
            return ["userNameCell"];
        }
    }, {
        key: 'updateGroupName',
        value: function updateGroupName(cell) {
            this.updateContent(cell);
        }
    }, {
        key: 'updateTimeZoneGroupName',
        value: function updateTimeZoneGroupName(cell) {
            this.updateContent(cell);
        }
    }, {
        key: 'updateUsersWithoutApproval',
        value: function updateUsersWithoutApproval(cell, hasApprover) {
            this.params.hasApprover = hasApprover;
            this.updateContent(cell);
        }
    }]);

    return NameCellRenderer;
}(_TableCellRenderer3.default);

exports.default = NameCellRenderer;

/***/ }),
/* 1616 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TableCellRenderer2 = __webpack_require__(63);

var _TableCellRenderer3 = _interopRequireDefault(_TableCellRenderer2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EmptyCellRenderer = function (_TableCellRenderer) {
    _inherits(EmptyCellRenderer, _TableCellRenderer);

    function EmptyCellRenderer() {
        var additionalClass = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

        _classCallCheck(this, EmptyCellRenderer);

        var _this = _possibleConstructorReturn(this, (EmptyCellRenderer.__proto__ || Object.getPrototypeOf(EmptyCellRenderer)).call(this));

        _this.additionalClassName = additionalClass;
        return _this;
    }

    _createClass(EmptyCellRenderer, [{
        key: 'generateContent',
        value: function generateContent(cell) {
            cell.innerHTML = '';
        }
    }, {
        key: 'getCellClassName',
        value: function getCellClassName() {
            return ['emptyCell', this.additionalClassName];
        }
    }]);

    return EmptyCellRenderer;
}(_TableCellRenderer3.default);

exports.default = EmptyCellRenderer;

/***/ }),
/* 1617 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TableCellRenderer2 = __webpack_require__(63);

var _TableCellRenderer3 = _interopRequireDefault(_TableCellRenderer2);

var _PermissionsCellContent = __webpack_require__(1618);

var _PermissionsCellContent2 = _interopRequireDefault(_PermissionsCellContent);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PermissionsCellRenderer = function (_TableCellRenderer) {
    _inherits(PermissionsCellRenderer, _TableCellRenderer);

    function PermissionsCellRenderer(_ref) {
        var editable = _ref.editable,
            generateMoneyReportsEnabled = _ref.generateMoneyReportsEnabled,
            generateMoneyReportsTitle = _ref.generateMoneyReportsTitle,
            isTTAEnabled = _ref.isTTAEnabled,
            onClick = _ref.onClick,
            onMouseIn = _ref.onMouseIn,
            onMouseOut = _ref.onMouseOut;

        _classCallCheck(this, PermissionsCellRenderer);

        var _this = _possibleConstructorReturn(this, (PermissionsCellRenderer.__proto__ || Object.getPrototypeOf(PermissionsCellRenderer)).call(this));

        _this.params = {
            editable: editable,
            generateMoneyReportsEnabled: generateMoneyReportsEnabled,
            generateMoneyReportsTitle: generateMoneyReportsTitle,
            isTTAEnabled: isTTAEnabled,
            onClick: onClick,
            onMouseIn: onMouseIn,
            onMouseOut: onMouseOut
        };
        return _this;
    }

    _createClass(PermissionsCellRenderer, [{
        key: 'generateContent',
        value: function generateContent(cell) {
            this.content = new _PermissionsCellContent2.default({
                generateMoneyReportsEnabled: this.params.generateMoneyReportsEnabled,
                generateMoneyReportsTooltip: this.params.generateMoneyReportsTitle,
                isTTAEnabled: this.params.isTTAEnabled
            }).init((0, _jquery2.default)(cell.getCellEl()));

            this.updateContent(cell);
        }
    }, {
        key: 'getCellClassName',
        value: function getCellClassName() {
            return ['permissionsCell'];
        }
    }, {
        key: 'updateContent',
        value: function updateContent(cell) {
            var _this2 = this;

            var _cell$getValue = cell.getValue(),
                hasManageUsersRight = _cell$getValue.hasManageUsersRight,
                hasManageOtherTTRight = _cell$getValue.hasManageOtherTTRight,
                hasGenerateMoneyReportsRight = _cell$getValue.hasGenerateMoneyReportsRight,
                hasManageScopeRight = _cell$getValue.hasManageScopeRight;

            this.content.setState({
                canManageUsers: hasManageUsersRight,
                canModifyTime: hasManageOtherTTRight,
                canManageScope: hasManageScopeRight,
                canGenerateMoneyReports: hasGenerateMoneyReportsRight
            });

            (0, _jquery2.default)(cell.getCellEl()).on('click', function (e) {
                _this2.params.onClick(cell, e);
            }).hover(function (e) {
                return _this2.params.onMouseIn(cell, e);
            }, function (e) {
                return _this2.params.onMouseOut(cell, e);
            });
        }
    }, {
        key: 'setContentState',
        value: function setContentState(state) {
            this.content.setState(state);
        }
    }]);

    return PermissionsCellRenderer;
}(_TableCellRenderer3.default);

exports.default = PermissionsCellRenderer;

/***/ }),
/* 1618 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _constants = __webpack_require__(4);

var _constants2 = __webpack_require__(755);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _SimpleSingletonTooltip = __webpack_require__(45);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PermissionsCellContent = function (_TemplateView) {
    _inherits(PermissionsCellContent, _TemplateView);

    function PermissionsCellContent(_ref) {
        var generateMoneyReportsEnabled = _ref.generateMoneyReportsEnabled,
            generateMoneyReportsTooltip = _ref.generateMoneyReportsTooltip,
            _ref$isTTAEnabled = _ref.isTTAEnabled,
            isTTAEnabled = _ref$isTTAEnabled === undefined ? false : _ref$isTTAEnabled;

        _classCallCheck(this, PermissionsCellContent);

        var _this = _possibleConstructorReturn(this, (PermissionsCellContent.__proto__ || Object.getPrototypeOf(PermissionsCellContent)).call(this));

        _this.params = {
            generateMoneyReportsEnabled: generateMoneyReportsEnabled,
            generateMoneyReportsTooltip: generateMoneyReportsTooltip,
            isTTAEnabled: isTTAEnabled
        };

        _this.state = {
            canManageUsers: false,
            canModifyTime: false,
            canManageScope: false,
            canGenerateMoneyReports: false,
            generateMoneyReportsTooltip: _this.params.generateMoneyReportsTooltip,
            generateMoneyReportsEnabled: _this.params.generateMoneyReportsEnabled
        };

        _this.onStateChanged(function () {
            _this._updateIcons();
        });

        _this.onStatePropertyChanged('generateMoneyReportsEnabled', function (enabled) {
            _this.costReports.toggle(enabled);
        });
        return _this;
    }

    _createClass(PermissionsCellContent, [{
        key: "templateHtml",
        value: function templateHtml() {
            return '<div class="permissions">' + '  <div class="icons">' + '    <div class="icon <%=manageUsers%>"/>' + '    <div class="icon <%=modifyTT%>"/>' + '    <div class="icon <%=manageScope%>"/>' + '    <div class="icon <%=costReports%>"/>' + '  </div>' + '</div>';
        }
    }, {
        key: "templateModel",
        value: function templateModel() {
            return {
                manageUsers: _constants2.PERMISSION_ICON_CLASS[_constants.AccessRights.MANAGE_USERS],
                modifyTT: _constants2.PERMISSION_ICON_CLASS[_constants.AccessRights.SUBMIT_OTHER_USER_TIME_TRACK],
                manageScope: _constants2.PERMISSION_ICON_CLASS[_constants.AccessRights.EDIT_HIERARCHY],
                costReports: _constants2.PERMISSION_ICON_CLASS[_constants.AccessRights.GENERATE_MONEY_REPORTS]
            };
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            var _this2 = this;

            this.manageUsers = this.find("." + _constants2.PERMISSION_ICON_CLASS[_constants.AccessRights.MANAGE_USERS]);
            this.modifyTT = this.find("." + _constants2.PERMISSION_ICON_CLASS[_constants.AccessRights.SUBMIT_OTHER_USER_TIME_TRACK]);
            this.manageScope = this.find("." + _constants2.PERMISSION_ICON_CLASS[_constants.AccessRights.EDIT_HIERARCHY]);
            this.costReports = this.find("." + _constants2.PERMISSION_ICON_CLASS[_constants.AccessRights.GENERATE_MONEY_REPORTS]);
            this.costReports.toggle(this.params.generateMoneyReportsEnabled);

            var extraClass = 'permissionsTooltip';
            (0, _SimpleSingletonTooltip.getInstance)().subscribeToMouseEvents(this.manageUsers, function () {
                (0, _SimpleSingletonTooltip.getInstance)().setState({
                    text: _messageResource2.default.getMessage('access_rights.manage_users'),
                    extraClass: extraClass
                });
            });
            (0, _SimpleSingletonTooltip.getInstance)().subscribeToMouseEvents(this.modifyTT, function () {
                var msgKey = _this2.params.isTTAEnabled ? 'access_rights.modify_and_approve_tt' : 'access_rights.submit_other_time_track';
                (0, _SimpleSingletonTooltip.getInstance)().setState({
                    text: _messageResource2.default.getMessage(msgKey),
                    extraClass: extraClass
                });
            });
            (0, _SimpleSingletonTooltip.getInstance)().subscribeToMouseEvents(this.manageScope, function () {
                (0, _SimpleSingletonTooltip.getInstance)().setState({
                    text: _messageResource2.default.getMessage('access_rights.edit_hierarchy'),
                    extraClass: extraClass
                });
            });
            (0, _SimpleSingletonTooltip.getInstance)().subscribeToMouseEvents(this.costReports, function () {
                (0, _SimpleSingletonTooltip.getInstance)().setState({
                    text: _this2.state.generateMoneyReportsTooltip,
                    extraClass: extraClass
                });
            });
        }
    }, {
        key: "_updateIcons",
        value: function _updateIcons() {
            this.manageUsers.toggleClass('inactive', !this.state.canManageUsers);
            this.modifyTT.toggleClass('inactive', !this.state.canModifyTime);
            this.manageScope.toggleClass('inactive', !this.state.canManageScope);
            this.costReports.toggleClass('inactive', !this.state.canGenerateMoneyReports);
        }
    }]);

    return PermissionsCellContent;
}(_TemplateView3.default);

exports.default = PermissionsCellContent;

/***/ }),
/* 1619 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _TableCellRenderer2 = __webpack_require__(63);

var _TableCellRenderer3 = _interopRequireDefault(_TableCellRenderer2);

var _TeamScopeCellContent = __webpack_require__(1620);

var _TeamScopeCellContent2 = _interopRequireDefault(_TeamScopeCellContent);

var _utils = __webpack_require__(200);

var _constants = __webpack_require__(21);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TeamScopeCellRenderer = function (_TableCellRenderer) {
    _inherits(TeamScopeCellRenderer, _TableCellRenderer);

    function TeamScopeCellRenderer(_ref) {
        var editable = _ref.editable,
            _ref$onClick = _ref.onClick,
            onClick = _ref$onClick === undefined ? function () {} : _ref$onClick,
            _ref$onMouseIn = _ref.onMouseIn,
            onMouseIn = _ref$onMouseIn === undefined ? function () {} : _ref$onMouseIn,
            _ref$onMouseOut = _ref.onMouseOut,
            onMouseOut = _ref$onMouseOut === undefined ? function () {} : _ref$onMouseOut,
            _ref$isURAEnabled = _ref.isURAEnabled,
            isURAEnabled = _ref$isURAEnabled === undefined ? false : _ref$isURAEnabled,
            _ref$isBTYEnabled = _ref.isBTYEnabled,
            isBTYEnabled = _ref$isBTYEnabled === undefined ? false : _ref$isBTYEnabled;

        _classCallCheck(this, TeamScopeCellRenderer);

        var _this = _possibleConstructorReturn(this, (TeamScopeCellRenderer.__proto__ || Object.getPrototypeOf(TeamScopeCellRenderer)).call(this));

        _this.params = {
            editable: editable,
            onClick: onClick,
            onMouseIn: onMouseIn,
            onMouseOut: onMouseOut,
            isURAEnabled: isURAEnabled,
            isBTYEnabled: isBTYEnabled
        };

        return _this;
    }

    _createClass(TeamScopeCellRenderer, [{
        key: 'generateContent',
        value: function generateContent(cell) {
            this.content = new _TeamScopeCellContent2.default();
            this.content.init((0, _jquery2.default)(cell.getCellEl()));
            this.updateContent(cell);
        }
    }, {
        key: 'updateContent',
        value: function updateContent(cell) {
            var _this2 = this;

            var _cell$getValue = cell.getValue(),
                teamAssignmentType = _cell$getValue.teamAssignmentType,
                assignedUsersCount = _cell$getValue.assignedUsersCount,
                hasManageUsersRight = _cell$getValue.hasManageUsersRight;

            var hasManageScope = (0, _utils.canUserAccessManagerScopes)({
                userInfo: cell.getValue(),
                isURAEnabled: this.params.isURAEnabled,
                isBTYEnabled: this.params.isBTYEnabled
            });
            this.content.setState({
                assignedUsersCount: assignedUsersCount,
                disabled: !hasManageScope,
                notAvailable: !this.params.editable,
                allScope: teamAssignmentType === _constants.UserTeamAssignmentType.ALL || hasManageUsersRight,
                noAccess: teamAssignmentType === _constants.UserTeamAssignmentType.NO
            });

            (0, _jquery2.default)(cell.getCellEl()).on('click', function (e) {
                return _this2.params.onClick(cell, e);
            }).hover(function (e) {
                return _this2.params.onMouseIn(cell, e);
            }, function (e) {
                return _this2.params.onMouseOut(cell, e);
            });
        }
    }, {
        key: 'getCellClassName',
        value: function getCellClassName() {
            return ['teamScopeCell'];
        }
    }, {
        key: 'update',
        value: function update(_ref2) {
            var isURAEnabled = _ref2.isURAEnabled,
                isBTYEnabled = _ref2.isBTYEnabled,
                hasManageScope = _ref2.hasManageScope;

            this.params.isURAEnabled = isURAEnabled;
            this.params.isBTYEnabled = isBTYEnabled;

            this.content.setState({ disabled: !hasManageScope });
        }
    }]);

    return TeamScopeCellRenderer;
}(_TableCellRenderer3.default);

exports.default = TeamScopeCellRenderer;

/***/ }),
/* 1620 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _BaseScopeCellContent2 = __webpack_require__(856);

var _BaseScopeCellContent3 = _interopRequireDefault(_BaseScopeCellContent2);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _pluralizeUtils = __webpack_require__(40);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TeamScopeCellContent = function (_BaseScopeCellContent) {
    _inherits(TeamScopeCellContent, _BaseScopeCellContent);

    function TeamScopeCellContent() {
        _classCallCheck(this, TeamScopeCellContent);

        var _this = _possibleConstructorReturn(this, (TeamScopeCellContent.__proto__ || Object.getPrototypeOf(TeamScopeCellContent)).call(this, null, {
            className: 'teamScopeContent'
        }));

        _this.state = _extends({}, _this.state, {
            assignedUsersCount: 0
        });
        return _this;
    }

    _createClass(TeamScopeCellContent, [{
        key: '_isScopeEmpty',
        value: function _isScopeEmpty() {
            return !this.state.allScope && this.state.assignedUsersCount === 0;
        }
    }, {
        key: '_getSelectedScopeMessage',
        value: function _getSelectedScopeMessage() {
            return this.state.assignedUsersCount + ' ' + (0, _pluralizeUtils.userNameLower)(this.state.assignedUsersCount);
        }
    }, {
        key: '_getEmptyScopeMessage',
        value: function _getEmptyScopeMessage() {
            return _messageResource2.default.getMessage('user_list.table.team_scope.not_selected');
        }
    }, {
        key: '_getNoAccessScopeMessage',
        value: function _getNoAccessScopeMessage() {
            return _messageResource2.default.getMessage('user_list.table.team_scope.no_access');
        }
    }, {
        key: '_getAllScopeMessage',
        value: function _getAllScopeMessage() {
            return _messageResource2.default.getMessage('user_list.table.team_scope.all_users');
        }
    }, {
        key: '_getEmptyNotAvailableScopeMessage',
        value: function _getEmptyNotAvailableScopeMessage() {
            return _messageResource2.default.getMessage('user_list.table.team_scope.empty');
        }
    }]);

    return TeamScopeCellContent;
}(_BaseScopeCellContent3.default);

exports.default = TeamScopeCellContent;

/***/ }),
/* 1621 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TableCellRenderer2 = __webpack_require__(63);

var _TableCellRenderer3 = _interopRequireDefault(_TableCellRenderer2);

var _ManageScopeCellContent = __webpack_require__(1622);

var _ManageScopeCellContent2 = _interopRequireDefault(_ManageScopeCellContent);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _utils = __webpack_require__(200);

var _constants = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ManageScopeCellRenderer = function (_TableCellRenderer) {
    _inherits(ManageScopeCellRenderer, _TableCellRenderer);

    function ManageScopeCellRenderer(_ref) {
        var editable = _ref.editable,
            _ref$onClick = _ref.onClick,
            onClick = _ref$onClick === undefined ? function () {} : _ref$onClick,
            _ref$onMouseIn = _ref.onMouseIn,
            onMouseIn = _ref$onMouseIn === undefined ? function () {} : _ref$onMouseIn,
            _ref$onMouseOut = _ref.onMouseOut,
            onMouseOut = _ref$onMouseOut === undefined ? function () {} : _ref$onMouseOut,
            _ref$isURAEnabled = _ref.isURAEnabled,
            isURAEnabled = _ref$isURAEnabled === undefined ? false : _ref$isURAEnabled,
            _ref$isBTYEnabled = _ref.isBTYEnabled,
            isBTYEnabled = _ref$isBTYEnabled === undefined ? false : _ref$isBTYEnabled;

        _classCallCheck(this, ManageScopeCellRenderer);

        var _this = _possibleConstructorReturn(this, (ManageScopeCellRenderer.__proto__ || Object.getPrototypeOf(ManageScopeCellRenderer)).call(this));

        _this.params = {
            editable: editable,
            onClick: onClick,
            onMouseIn: onMouseIn,
            onMouseOut: onMouseOut,
            isURAEnabled: isURAEnabled,
            isBTYEnabled: isBTYEnabled
        };
        return _this;
    }

    _createClass(ManageScopeCellRenderer, [{
        key: 'generateContent',
        value: function generateContent(cell) {
            this.content = new _ManageScopeCellContent2.default();
            this.content.init((0, _jquery2.default)(cell.getCellEl()));
            this.updateContent(cell);
        }
    }, {
        key: 'updateContent',
        value: function updateContent(cell) {
            var _this2 = this;

            var _cell$getValue = cell.getValue(),
                managementAssignmentsSelection = _cell$getValue.managementAssignmentsSelection,
                hasAssignedManagementScope = _cell$getValue.hasAssignedManagementScope,
                hasManageUsersRight = _cell$getValue.hasManageUsersRight;

            var hasManageScope = (0, _utils.canUserAccessManagerScopes)({
                userInfo: cell.getValue(),
                isURAEnabled: this.params.isURAEnabled,
                isBTYEnabled: this.params.isBTYEnabled
            });

            this.content.setState({
                allScope: hasManageUsersRight || managementAssignmentsSelection === _constants.ManagementAssignmentsSelection.ALL,
                noAccess: managementAssignmentsSelection === _constants.ManagementAssignmentsSelection.NO,
                disabled: !hasManageScope,
                notAvailable: !this.params.editable,
                selectedScopeExists: hasAssignedManagementScope
            });

            (0, _jquery2.default)(cell.getCellEl()).on('click', function (e) {
                return _this2.params.onClick(cell, e);
            }).hover(function (e) {
                return _this2.params.onMouseIn(cell, e);
            }, function (e) {
                return _this2.params.onMouseOut(cell, e);
            });
        }
    }, {
        key: 'getCellClassName',
        value: function getCellClassName() {
            return ['manageScopeCell'];
        }
    }, {
        key: 'update',
        value: function update(_ref2) {
            var isURAEnabled = _ref2.isURAEnabled,
                isBTYEnabled = _ref2.isBTYEnabled,
                hasManageScope = _ref2.hasManageScope;

            this.params.isURAEnabled = isURAEnabled;
            this.params.isBTYEnabled = isBTYEnabled;

            this.content.setState({ disabled: !hasManageScope });
        }
    }]);

    return ManageScopeCellRenderer;
}(_TableCellRenderer3.default);

exports.default = ManageScopeCellRenderer;

/***/ }),
/* 1622 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _BaseScopeCellContent2 = __webpack_require__(856);

var _BaseScopeCellContent3 = _interopRequireDefault(_BaseScopeCellContent2);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ManageScopeCellContent = function (_BaseScopeCellContent) {
    _inherits(ManageScopeCellContent, _BaseScopeCellContent);

    function ManageScopeCellContent() {
        _classCallCheck(this, ManageScopeCellContent);

        var _this = _possibleConstructorReturn(this, (ManageScopeCellContent.__proto__ || Object.getPrototypeOf(ManageScopeCellContent)).call(this, null, {
            className: 'manageScopeContent'
        }));

        _this.state = _extends({}, _this.state, {
            selectedScopeExists: false
        });
        return _this;
    }

    _createClass(ManageScopeCellContent, [{
        key: '_isScopeEmpty',
        value: function _isScopeEmpty() {
            return !this.state.allScope && !this.state.selectedScopeExists;
        }
    }, {
        key: '_getAllScopeMessage',
        value: function _getAllScopeMessage() {
            return _messageResource2.default.getMessage('user_list.table.manage_scope.entire_scope');
        }
    }, {
        key: '_getSelectedScopeMessage',
        value: function _getSelectedScopeMessage() {
            return _messageResource2.default.getMessage('user_list.table.manage_scope.part_scope');
        }
    }, {
        key: '_getNoAccessScopeMessage',
        value: function _getNoAccessScopeMessage() {
            return _messageResource2.default.getMessage('user_list.table.manage_scope.no_access');
        }
    }, {
        key: '_getEmptyScopeMessage',
        value: function _getEmptyScopeMessage() {
            return _messageResource2.default.getMessage('user_list.table.manage_scope.not_selected');
        }
    }, {
        key: '_getEmptyNotAvailableScopeMessage',
        value: function _getEmptyNotAvailableScopeMessage() {
            return _messageResource2.default.getMessage('user_list.table.manage_scope.empty');
        }
    }]);

    return ManageScopeCellContent;
}(_BaseScopeCellContent3.default);

exports.default = ManageScopeCellContent;

/***/ }),
/* 1623 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _constants = __webpack_require__(4);

var _View2 = __webpack_require__(20);

var _View3 = _interopRequireDefault(_View2);

var _ItemsFilter = __webpack_require__(858);

var _ItemsFilter2 = _interopRequireDefault(_ItemsFilter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ManagementFilterValues = _constants.UserManagementConstants.ManagementFilter;

var ManagementFilter = function (_View) {
    _inherits(ManagementFilter, _View);

    function ManagementFilter(_ref) {
        var _ref$onChange = _ref.onChange,
            onChange = _ref$onChange === undefined ? function () {} : _ref$onChange;

        _classCallCheck(this, ManagementFilter);

        var _this = _possibleConstructorReturn(this, (ManagementFilter.__proto__ || Object.getPrototypeOf(ManagementFilter)).call(this));

        _this._handleChangeItem = function (value) {
            _this.itemsFitler.setState({
                selectedValue: value
            });
            _this.onChange(value);
        };

        _this.onChange = onChange;

        _this.state = {
            selectedValue: null
        };

        _this.onStateChanged(function () {
            _this.itemsFitler.setState({
                selectedValue: _this.state.selectedValue
            });
        });
        return _this;
    }

    _createClass(ManagementFilter, [{
        key: 'afterRender',
        value: function afterRender() {
            var items = [(0, _ItemsFilter.createItemObject)(ManagementFilterValues.ALL, _messageResource2.default.getEscapedMessage('userlist.management.filter.all')), (0, _ItemsFilter.createDelimiterObject)()].concat(_toConsumableArray(this._getPermissionsItems()), [(0, _ItemsFilter.createDelimiterObject)()], _toConsumableArray(this._getTeamItems()), [(0, _ItemsFilter.createDelimiterObject)()], _toConsumableArray(this._getScopeOfWorkItems()));

            this.itemsFitler = new _ItemsFilter2.default({
                items: items,
                defaultValue: ManagementFilterValues.ALL,
                onChange: this._handleChangeItem,
                additionalListClass: 'userlist_managementFilter_list',
                additionalFilterClass: 'greyBackground'
            }).init(this.$containerEl);
        }
    }, {
        key: '_getPermissionsItems',
        value: function _getPermissionsItems() {
            return [(0, _ItemsFilter.createItemObject)(ManagementFilterValues.ALL_PERMISSIONS, _messageResource2.default.getEscapedMessage('userlist.management.filter.all_permissions')), (0, _ItemsFilter.createItemObject)(ManagementFilterValues.NO_PERMISSIONS, _messageResource2.default.getEscapedMessage('userlist.management.filter.no_permissions'))];
        }
    }, {
        key: '_getTeamItems',
        value: function _getTeamItems() {
            return [(0, _ItemsFilter.createItemObject)(ManagementFilterValues.ALL_TEAM, _messageResource2.default.getEscapedMessage('userlist.management.filter.all_team')), (0, _ItemsFilter.createItemObject)(ManagementFilterValues.NO_TEAM, _messageResource2.default.getEscapedMessage('userlist.management.filter.no_team')), (0, _ItemsFilter.createItemObject)(ManagementFilterValues.NO_ACCESS_TO_TEAM, _messageResource2.default.getEscapedMessage('userlist.management.filter.no_access_to_team'))];
        }
    }, {
        key: '_getScopeOfWorkItems',
        value: function _getScopeOfWorkItems() {
            return [(0, _ItemsFilter.createItemObject)(ManagementFilterValues.ALL_SCOPE, _messageResource2.default.getEscapedMessage('userlist.management.filter.all_scope')), (0, _ItemsFilter.createItemObject)(ManagementFilterValues.NO_SCOPE, _messageResource2.default.getEscapedMessage('userlist.management.filter.no_scope')), (0, _ItemsFilter.createItemObject)(ManagementFilterValues.NO_ACCESS_TO_SCOPE, _messageResource2.default.getEscapedMessage('userlist.management.filter.no_access_to_scope'))];
        }
    }]);

    return ManagementFilter;
}(_View3.default);

exports.default = ManagementFilter;

/***/ }),
/* 1624 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ItemsList = function (_TemplateView) {
    _inherits(ItemsList, _TemplateView);

    function ItemsList(_ref) {
        var _ref$items = _ref.items,
            items = _ref$items === undefined ? [] : _ref$items;

        _classCallCheck(this, ItemsList);

        var _this = _possibleConstructorReturn(this, (ItemsList.__proto__ || Object.getPrototypeOf(ItemsList)).call(this, null));

        _this.items = items;
        return _this;
    }

    _createClass(ItemsList, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class="list"></div>';
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            var _this2 = this;

            this.items.forEach(function (item) {
                item.init(_this2.$el);
            });
        }
    }]);

    return ItemsList;
}(_TemplateView3.default);

exports.default = ItemsList;

/***/ }),
/* 1625 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Item = function (_TemplateView) {
    _inherits(Item, _TemplateView);

    function Item(_ref) {
        var _ref$text = _ref.text,
            text = _ref$text === undefined ? '' : _ref$text,
            _ref$onClick = _ref.onClick,
            onClick = _ref$onClick === undefined ? function () {} : _ref$onClick,
            _ref$value = _ref.value,
            value = _ref$value === undefined ? null : _ref$value;

        _classCallCheck(this, Item);

        var _this = _possibleConstructorReturn(this, (Item.__proto__ || Object.getPrototypeOf(Item)).call(this, null));

        _this.params = {
            text: text,
            onClick: onClick,
            value: value
        };

        _this.state = {
            selected: false
        };

        _this.onStatePropertyChanged('selected', function () {
            _this.$el.toggleClass('selected', _this.state.selected);
        });
        return _this;
    }

    _createClass(Item, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class="listItem"><span class="text"></span></div>';
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            var _this2 = this;

            this.find('.text').text(this.params.text);
            this.$el.on('click', function () {
                _this2.params.onClick(_this2.params.value);
            });
        }
    }]);

    return Item;
}(_TemplateView3.default);

exports.default = Item;

/***/ }),
/* 1626 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DelimiterItem = function (_TemplateView) {
    _inherits(DelimiterItem, _TemplateView);

    function DelimiterItem() {
        _classCallCheck(this, DelimiterItem);

        return _possibleConstructorReturn(this, (DelimiterItem.__proto__ || Object.getPrototypeOf(DelimiterItem)).apply(this, arguments));
    }

    _createClass(DelimiterItem, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class="delimiter"></div>';
        }
    }]);

    return DelimiterItem;
}(_TemplateView3.default);

exports.default = DelimiterItem;

/***/ }),
/* 1627 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var gConstants = window.__GENERATED_CONSTANTS__.UserListConfirmationConstants;
var UserListConfirmationConstants = exports.UserListConfirmationConstants = {
    LAST_APPROVER_DISABLED: gConstants.LAST_APPROVER_DISABLED,
    LAST_APPROVER_RIGHT_REVOKED: gConstants.LAST_APPROVER_RIGHT_REVOKED,
    LAST_OTHER_PRODUCT_APPROVER_DISABLED: gConstants.LAST_OTHER_PRODUCT_APPROVER_DISABLED,
    LAST_APPROVER_DELETED: gConstants.LAST_APPROVER_DELETED,
    LAST_OTHER_PRODUCT_APPROVER_DELETED: gConstants.LAST_OTHER_PRODUCT_APPROVER_DELETED,
    HAS_LEAVE_REQUESTS: gConstants.HAS_LEAVE_REQUESTS
};

exports.default = UserListConfirmationConstants;

/***/ }),
/* 1628 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _user_group_renderer = __webpack_require__(827);

var _user_group_renderer2 = _interopRequireDefault(_user_group_renderer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ATUserGroupRenderer = function (_UserGroupRenderer) {
    _inherits(ATUserGroupRenderer, _UserGroupRenderer);

    function ATUserGroupRenderer() {
        _classCallCheck(this, ATUserGroupRenderer);

        return _possibleConstructorReturn(this, (ATUserGroupRenderer.__proto__ || Object.getPrototypeOf(ATUserGroupRenderer)).apply(this, arguments));
    }

    _createClass(ATUserGroupRenderer, [{
        key: "fillTable",

        /**
         * Build columns for group row
         */
        value: function fillTable(table, group) {
            var tr = document.createElement('tr');
            tr.appendChild(this.buildFolderImgCell(group));
            tr.appendChild(this.buildNameCell(group));
            tr.appendChild(this.buildCountCell(group));
            tr.appendChild(this.buildDeleteCell(group));
            tr.appendChild(this.buildConfirmDeleteCell(group));
            tr.appendChild(this.buildWaitingAnimationCell(group));
            table.appendChild(tr);
        }
    }]);

    return ATUserGroupRenderer;
}(_user_group_renderer2.default);

exports.default = ATUserGroupRenderer;

/***/ }),
/* 1629 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _GroupWithUsers = __webpack_require__(387);

var _GroupWithUsers2 = _interopRequireDefault(_GroupWithUsers);

var _UserInGroup = __webpack_require__(388);

var _UserInGroup2 = _interopRequireDefault(_UserInGroup);

var _add_group_controller = __webpack_require__(829);

var _add_group_controller2 = _interopRequireDefault(_add_group_controller);

var _actionsProviders = __webpack_require__(1630);

var _errors = __webpack_require__(528);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ATAddUserGroupController = function (_AddGroupController) {
    _inherits(ATAddUserGroupController, _AddGroupController);

    function ATAddUserGroupController() {
        _classCallCheck(this, ATAddUserGroupController);

        return _possibleConstructorReturn(this, (ATAddUserGroupController.__proto__ || Object.getPrototypeOf(ATAddUserGroupController)).apply(this, arguments));
    }

    _createClass(ATAddUserGroupController, [{
        key: "createUserGroupRpc",
        value: function createUserGroupRpc(controller) {
            _actionsProviders.atUserGroupManagementActionsProvider.createUserGroup(this.getNewGroupData()).then(function (data) {
                var groupWithUsersData = data["groupWithUsers"];
                var group = new _GroupWithUsers2.default(groupWithUsersData["group"]["id"], groupWithUsersData["group"]["name"], controller.validatorGroupStrategy, groupWithUsersData["users"]["list"].map(function (u) {
                    return new _UserInGroup2.default(u["id"], u["name"], u["active"]);
                }));
                controller.rebuildViewAfterGroupCreation(group);
            }).catch(function (e) {
                console.error(e);
                if (e instanceof _errors.GroupExistsError) {
                    controller.getAddGroupController().resetRowIntoDefaultState();
                    controller.showDuplicateUserGroupMessage();
                }
            });

            this.spinnerController.spin(this.waitingAnimationCellId);
        }
    }]);

    return ATAddUserGroupController;
}(_add_group_controller2.default);

exports.default = ATAddUserGroupController;

/***/ }),
/* 1630 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.atUserGroupManagementActionsProvider = exports.ActionsProvider = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _ATUserGroupManagementService = __webpack_require__(826);

var _ATUserGroupManagementService2 = _interopRequireDefault(_ATUserGroupManagementService);

var _errors = __webpack_require__(528);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ActionsProvider = exports.ActionsProvider = function () {
    function ActionsProvider(groupManagementService) {
        _classCallCheck(this, ActionsProvider);

        this.groupManagementService = groupManagementService;
    }

    _createClass(ActionsProvider, [{
        key: "createUserGroup",
        value: function createUserGroup(group) {
            return this.groupManagementService.createUserGroup(group).catch(this._commonErrorsHandler);
        }
    }, {
        key: "_commonErrorsHandler",
        value: function _commonErrorsHandler(e) {
            if (e instanceof _errors.UserGroupsDisabledError) {
                alert(_messageResource2.default.getMessage('userlist.js.error_ugr_disabled'));
                document.location.reload();
            }

            if (e instanceof _errors.NoRightsToManageAccountSettingsError) {
                alert(_messageResource2.default.getMessage('group_management.permissions_changed'));
                document.location.reload();
            }

            throw e;
        }
    }]);

    return ActionsProvider;
}();

var atUserGroupManagementActionsProvider = exports.atUserGroupManagementActionsProvider = new ActionsProvider(new _ATUserGroupManagementService2.default());

/***/ }),
/* 1631 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _PermissionsTemplateButtonControllerWithoutChoosing = __webpack_require__(751);

var _PermissionsTemplateButtonControllerWithoutChoosing2 = _interopRequireDefault(_PermissionsTemplateButtonControllerWithoutChoosing);

var _ATInviteSeveralUsersRow = __webpack_require__(1632);

var _ATInviteSeveralUsersRow2 = _interopRequireDefault(_ATInviteSeveralUsersRow);

var _DropdownList = __webpack_require__(862);

var _DropdownList2 = _interopRequireDefault(_DropdownList);

var _constants = __webpack_require__(4);

var _InviteSeveralUsersLightBox = __webpack_require__(863);

var _InviteSeveralUsersLightBox2 = _interopRequireDefault(_InviteSeveralUsersLightBox);

var _utils = __webpack_require__(6);

var _selectors = __webpack_require__(15);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ATInviteSeveralUsersLightBox() {}

ATInviteSeveralUsersLightBox.prototype = _underscore2.default.create(_InviteSeveralUsersLightBox2.default.prototype, {
    PERMISSIONS_TEMPLATE_SELECTOR_ROW: "<tr class='permissionsTemplateSelectorRow <%= isLastRow ? \'last\' : \'\'%>'>" + "   <td>" + "       <div>" + "           <%= escapeHtmlSymbols(name) + (id == DEFAULT_PERMISSIONS_TEMPLATE_ID ? ' ' + defaultTemplateLabel : '')%>" + "       </div>" + "   </td>" + "</tr>",

    init: function init(_ref) {
        var inviteUsersData = _ref.inviteUsersData,
            onChangePermissionsTemplates = _ref.onChangePermissionsTemplates,
            onHideCallback = _ref.onHideCallback;

        this.templatesList = new _DropdownList2.default().init("inviteSeveralUsersTemplatesDropdownList", "templatesDropdownList", this.PERMISSIONS_TEMPLATE_SELECTOR_ROW, this._createTemplatesData(inviteUsersData.userManagementData.permissionsTemplates), document.getElementById(this._getLightBoxId()));

        this.currentPermisisonsTemplates = inviteUsersData.userManagementData.permissionsTemplates;
        _InviteSeveralUsersLightBox2.default.prototype.init.call(this, inviteUsersData);

        var $permissionTemplatesMenuButton = (0, _jquery2.default)(this.lightBoxEl).find(".innerContent .editPermissionsTemplateButton");
        var $editPermissionsTemplateMenu = (0, _jquery2.default)(this.lightBoxEl).find(".innerContent .editPermissionsTemplateMenu");

        this.permissionsTemplatesButtonController = new _PermissionsTemplateButtonControllerWithoutChoosing2.default($editPermissionsTemplateMenu, $permissionTemplatesMenuButton, onChangePermissionsTemplates).init();
        this.permissionsTemplatesButtonController.setState({
            templates: inviteUsersData.userManagementData.permissionsTemplates,
            isURAEnabled: (0, _utils.unsafe_selectWithState)(_selectors.isURAEnabled),
            isBTYEnabled: (0, _utils.unsafe_selectWithState)(_selectors.isBTYEnabled),
            isPTOEnabled: (0, _utils.unsafe_selectWithState)(_selectors.isPTOEnabled),
            isSDBEnabled: (0, _utils.unsafe_selectWithState)(_selectors.isSDBEnabled),
            isLTTEnabled: (0, _utils.unsafe_selectWithState)(_selectors.isLTTEnabled)
        });

        this.onHideCallback = onHideCallback;

        var hideMenuOnScrollContentCallback = _underscore2.default.bind(function () {
            this.templatesList.hide();
        }, this);

        (0, _jquery2.default)(this.lightBoxEl).find(".innerContent").off("scroll.templatesDropdownList", hideMenuOnScrollContentCallback).on("scroll.templatesDropdownList", hideMenuOnScrollContentCallback);

        return this;
    },

    _getDefaultTemplateName: function _getDefaultTemplateName() {
        return _underscore2.default.findWhere(this.currentPermisisonsTemplates, { id: _constants.DEFAULT_PERMISSIONS_TEMPLATE_ID }).name + " " + _messageResource2.default.getMessage('userlist.userdata.permissions_templates.js.menu.row.default_template');
    },

    _generateTable: function _generateTable() {
        this.rows = [];
        var $tableContainer = this.innerContent.find(".tableContainer");
        $tableContainer.empty();
        var defaultTemplateName = this._getDefaultTemplateName();
        var $table = (0, _jquery2.default)('<table>');
        var row;
        for (var i = 0; i < this.INITIAL_NUMBER_OF_ROWS; i++) {
            this._addRow($table, i, i === 0 ? "firstRow" : i === this.INITIAL_NUMBER_OF_ROWS - 1 ? "lastRow" : "", defaultTemplateName);
        }
        $tableContainer.append($table);
    },

    _createTemplatesData: function _createTemplatesData(permissionsTemplatesData) {
        var templatesData = [];
        var defaultTemplateLabel = _messageResource2.default.getMessage('userlist.userdata.permissions_templates.js.menu.row.default_template');
        _underscore2.default.each(permissionsTemplatesData, function (data) {
            templatesData.push({
                id: data.id,
                name: data.name,
                isLastRow: false,
                defaultTemplateLabel: defaultTemplateLabel
            });
        });
        templatesData[templatesData.length - 1].isLastRow = true;
        return templatesData;
    },

    updatePermissionsTemplatesData: function updatePermissionsTemplatesData(templatesData) {
        this.permissionsTemplatesButtonController.setState({
            templates: templatesData
        });
        this.templatesList.updateData(this._createTemplatesData(templatesData));
        this.currentPermisisonsTemplates = templatesData;
        this._updateRows();
    },

    hide: function hide() {
        _InviteSeveralUsersLightBox2.default.prototype.hide.apply(this, arguments);
        if (this.onHideCallback) {
            this.onHideCallback();
        }
    },

    _addEmptyRows: function _addEmptyRows(number) {
        if (this.rows.length + number > 10) {
            (0, _jquery2.default)(this.lightBoxEl).addClass("scrollable");
        }
        var rowCount = this.rows.length;
        this.rows[rowCount - 1].setSpecialRowClasses("");
        var defaultTemplateName = this._getDefaultTemplateName();
        var $table = this.innerContent.find(".tableContainer table");
        for (var i = 0; i < number; i++) {
            this._addRow($table, i + rowCount, i === number - 1 ? "lastRow" : "", defaultTemplateName);
        }
        this.updateUI();
    },

    _addRow: function _addRow($table, number, specialClass, defaultTemplateName) {
        var row = new _ATInviteSeveralUsersRow2.default().init(number, specialClass, _jquery2.default.proxy(this._validateCallback, this), _jquery2.default.proxy(this._changesCallback, this), this.templatesList, _constants.DEFAULT_PERMISSIONS_TEMPLATE_ID, defaultTemplateName, this.errorTooltip);
        this.rows.push(row);
        $table.append(row.getElement());
    },

    _updateRows: function _updateRows() {
        var _this = this;

        this.rows.forEach(function (row) {
            var template = _this.currentPermisisonsTemplates.find(function (template) {
                return template.id === row.permissionsTemplateId;
            });
            row.setTemplateName({
                templateId: template.id,
                templateName: template.name
            });
            row.updateUI();
        });
    }
});

exports.default = ATInviteSeveralUsersLightBox;

/***/ }),
/* 1632 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _InviteSeveralUsersRow = __webpack_require__(861);

var _InviteSeveralUsersRow2 = _interopRequireDefault(_InviteSeveralUsersRow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ATInviteSeveralUsersRow() {}

ATInviteSeveralUsersRow.prototype = _underscore2.default.create(_InviteSeveralUsersRow2.default.prototype, {
    CONCURRENTLY_DELETED_TEMPLATE_ERROR: "concurrentlyDeletedTemplateError",

    init: function init(rowNumber, specialRowClasses, validationCallback, changesCallback, templatesDropdownList, defaultPermissionsTemplateId, defaultPermissionsTemplateName, errorTooltip) {
        this.templatesDropdownList = templatesDropdownList;
        this.permissionsTemplateId = defaultPermissionsTemplateId;
        this.defaultPermissionsTemplateId = defaultPermissionsTemplateId;
        this.permissionsTemplateName = defaultPermissionsTemplateName;

        _InviteSeveralUsersRow2.default.prototype.init.call(this, rowNumber, specialRowClasses, validationCallback, changesCallback, errorTooltip);

        this.$permissionsTemplateButton = (0, _jquery2.default)("<td class='permissionsTemplateButton'>");
        this.$permissionsTemplateButtonText = (0, _jquery2.default)("<div class='permissionsTemplateButtonText'>");
        this.$permissionsTemplateButtonText.text(this.permissionsTemplateName);
        this.$permissionsTemplateButton.append(this.$permissionsTemplateButtonText);
        this.$permissionsTemplateButton.append((0, _jquery2.default)("<span class='permissionsTemplateButtonArrow'>&nbsp;</span>"));
        var errorTextsMap = {};
        this._addCallbackToPermissionsTemplateButton();
        errorTextsMap[ATInviteSeveralUsersRow.prototype.CONCURRENTLY_DELETED_TEMPLATE_ERROR] = _messageResource2.default.getMessage("user.js.invite_several_users.error.template_not_exists");
        this._addErrorTooltipCallbacks(this.$permissionsTemplateButton, errorTextsMap);
        this.$row.append(this.$permissionsTemplateButton);

        return this;
    },

    _addCallbackToPermissionsTemplateButton: function _addCallbackToPermissionsTemplateButton() {
        var self = this;
        this.$permissionsTemplateButton.click(function () {
            self.templatesDropdownList.setCallbackHandler({
                onShow: function onShow() {
                    self.$permissionsTemplateButton.addClass("active");
                },
                onRowClick: function onRowClick(templateData) {
                    self.setTemplateName({
                        templateId: templateData.id,
                        templateName: templateData.name
                    });
                    self.errors[ATInviteSeveralUsersRow.prototype.CONCURRENTLY_DELETED_TEMPLATE_ERROR] = false;
                    self.updateUI();
                    if (self.validationCallback) {
                        self.validationCallback();
                    }
                    if (self.changesCallback) {
                        self.changesCallback();
                    }
                },
                onHide: function onHide() {
                    self.$permissionsTemplateButton.removeClass("active");
                }
            });
            self.templatesDropdownList.showAt(self.$permissionsTemplateButton);
        });
    },

    getUserFields: function getUserFields() {
        var result = _InviteSeveralUsersRow2.default.prototype.getUserFields.call(this);
        result.permissionsTemplateId = this.permissionsTemplateId;
        return result;
    },

    updateUI: function updateUI() {
        _InviteSeveralUsersRow2.default.prototype.updateUI.call(this);
        this.$permissionsTemplateButtonText.text(this.permissionsTemplateName);
    },

    addServerErrors: function addServerErrors(errors) {
        var self = this;
        _underscore2.default.each(errors, function (error) {
            switch (error) {
                case "com.actimind.common.services.UserEmailInvalidException":
                    self.errors[_InviteSeveralUsersRow2.default.prototype.INVALID_EMAIL_ERROR] = true;
                    break;
                case "com.actimind.actitime.services.PermissionsTemplateNotExistException":
                    self.errors[ATInviteSeveralUsersRow.prototype.CONCURRENTLY_DELETED_TEMPLATE_ERROR] = true;
                    break;
            }
        });
    },

    setTemplateName: function setTemplateName(_ref) {
        var templateId = _ref.templateId,
            templateName = _ref.templateName;

        this.permissionsTemplateId = templateId;
        this.permissionsTemplateName = templateName + (templateId === this.defaultPermissionsTemplateId ? " " + _messageResource2.default.getMessage('userlist.userdata.permissions_templates.js.menu.row.default_template') : "");
    }
});

exports.default = ATInviteSeveralUsersRow;

/***/ }),
/* 1633 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var selectPanels = exports.selectPanels = function selectPanels(state) {
  return state.panels;
};

/***/ }),
/* 1634 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.triggerActiveTabChanged = undefined;

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var triggerActiveTabChanged = exports.triggerActiveTabChanged = function triggerActiveTabChanged(tabNum) {
    (0, _jquery2.default)(document).trigger('userManagement_userList_activeTabChanged', [tabNum]);
};

/***/ }),
/* 1635 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateLoggedInUser = undefined;

var _reduxActions = __webpack_require__(9);

var _actionTypes = __webpack_require__(664);

var updateLoggedInUser = exports.updateLoggedInUser = (0, _reduxActions.createAction)(_actionTypes.LOGGED_IN_USER_UPDATE);

/***/ }),
/* 1636 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var RECORDS_LOAD_LIMIT = exports.RECORDS_LOAD_LIMIT = 20;

/***/ }),
/* 1637 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.onCreateUserPanelClosed = exports.onUserCreated = undefined;

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var onUserCreated = exports.onUserCreated = function onUserCreated(data) {
    (0, _jquery2.default)(document).trigger('createUserPanel_userCreated', [data]);
};

var onCreateUserPanelClosed = exports.onCreateUserPanelClosed = function onCreateUserPanelClosed() {
    (0, _jquery2.default)(document).trigger('createUserPanel_panelClosed');
};

/***/ }),
/* 1638 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DEFAULT_TEAM_ASSIGNMENTS = exports.DEFAULT_MANAGEMENT_ASSIGNMENTS = undefined;

var _constants = __webpack_require__(4);

var _constants2 = __webpack_require__(21);

var DEFAULT_MANAGEMENT_ASSIGNMENTS = exports.DEFAULT_MANAGEMENT_ASSIGNMENTS = {
    managementAssignmentsSelection: _constants.ManagementAssignmentsSelection.SELECTED,
    addedTaskIds: [],
    addedProjectIds: [],
    addedProjectIdsExcludingSelf: [],
    addedCustomerIds: [],
    addedCustomerIdsExcludingSelf: []
};

var DEFAULT_TEAM_ASSIGNMENTS = exports.DEFAULT_TEAM_ASSIGNMENTS = {
    teamAssignmentType: _constants2.UserTeamAssignmentType.SELECTED,
    assignedGroups: [],
    assignedUsers: []
};

/***/ }),
/* 1639 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _View2 = __webpack_require__(20);

var _View3 = _interopRequireDefault(_View2);

var _utils = __webpack_require__(6);

var _redux = __webpack_require__(7);

var _selectors = __webpack_require__(208);

var _PanelContainer = __webpack_require__(109);

var _PanelContainer2 = _interopRequireDefault(_PanelContainer);

var _CreateUserPanelContainer = __webpack_require__(1640);

var _CreateUserPanelContainer2 = _interopRequireDefault(_CreateUserPanelContainer);

var _actions = __webpack_require__(148);

var _LoadingContainer = __webpack_require__(28);

var _LoadingContainer2 = _interopRequireDefault(_LoadingContainer);

var _constants = __webpack_require__(62);

var _CreateUserManagementAssignmentsEditorPanel = __webpack_require__(1679);

var _CreateUserManagementAssignmentsEditorPanel2 = _interopRequireDefault(_CreateUserManagementAssignmentsEditorPanel);

var _ManagementAssignmentsPanel = __webpack_require__(1694);

var _ManagementAssignmentsPanel2 = _interopRequireDefault(_ManagementAssignmentsPanel);

var _CreateTeamAssignmentsPanel = __webpack_require__(1702);

var _CreateTeamAssignmentsPanel2 = _interopRequireDefault(_CreateTeamAssignmentsPanel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CreateUserPanel = function (_View) {
    _inherits(CreateUserPanel, _View);

    function CreateUserPanel(_ref) {
        var _ref$onPanelHide = _ref.onPanelHide,
            onPanelHide = _ref$onPanelHide === undefined ? function () {} : _ref$onPanelHide,
            _ref$loadCreateUserPa = _ref.loadCreateUserPanelData,
            loadCreateUserPanelData = _ref$loadCreateUserPa === undefined ? function () {} : _ref$loadCreateUserPa,
            _ref$cancelUserCreati = _ref.cancelUserCreation,
            cancelUserCreation = _ref$cancelUserCreati === undefined ? function () {} : _ref$cancelUserCreati;

        _classCallCheck(this, CreateUserPanel);

        var _this = _possibleConstructorReturn(this, (CreateUserPanel.__proto__ || Object.getPrototypeOf(CreateUserPanel)).call(this));

        _this.onPanelHide = onPanelHide;
        _this.loadCreateUserPanelData = loadCreateUserPanelData;
        _this.cancelUserCreation = cancelUserCreation;

        _this.state = {
            isShown: false,
            needToLoadData: false,
            loading: false
        };

        _this.onStatePropertyChanged('isShown', function (isShown) {
            _this.createUserPanelContainerWrapper.setState({ isShown: isShown });
        });

        _this.onStatePropertyChanged('needToLoadData', function (needToLoadData, prevNeedToLoadData) {
            if (needToLoadData !== prevNeedToLoadData && needToLoadData === true) {
                _this.loadCreateUserPanelData();
            }
        });

        _this.onStatePropertyChanged('loading', function (loading) {
            return _this.loadingWrapper.setState({ loading: loading });
        });
        return _this;
    }

    _createClass(CreateUserPanel, [{
        key: 'afterRender',
        value: function afterRender() {
            var _this2 = this;

            this.loadingWrapper = new _LoadingContainer2.default({
                contentComponent: new _CreateUserPanelContainer2.default(),
                containerClass: 'userPanelLoadingWrapper'

            });
            this.createUserPanelContainerWrapper = new _PanelContainer2.default({
                component: this.loadingWrapper,
                additionalClass: "create_user_sliding_panel sliding_panel",
                showAnimationClass: _constants.SHOW_ANIMATION_CLASSES.SLIDE_LEFT,
                hideAnimationClass: _constants.HIDE_ANIMATION_CLASSES.SLIDE_LEFT,
                showHideButton: false,
                hideOnEsc: true,
                showMoire: true,
                onHideCallback: function onHideCallback() {
                    return _this2.onPanelHide();
                },
                hideHandler: function hideHandler() {
                    return _this2.cancelUserCreation();
                }
            }).init(this.$containerEl);

            this.registerChildComponents(new _CreateTeamAssignmentsPanel2.default().init(this.$containerEl));

            this.registerChildComponents(new _ManagementAssignmentsPanel2.default().init(this.$containerEl));

            this.registerChildComponents(new _CreateUserManagementAssignmentsEditorPanel2.default().init(this.$containerEl));
        }
    }]);

    return CreateUserPanel;
}(_View3.default);

exports.default = (0, _utils.connect)(function (state) {
    return {
        isShown: (0, _selectors.isShown)(state),
        needToLoadData: (0, _selectors.isNeedToLoadData)(state),
        loading: (0, _selectors.isLoading)(state)
    };
}, function (dispatch) {
    return {
        cancelUserCreation: (0, _redux.bindActionCreators)(_actions.cancelUserCreation, dispatch),
        onPanelHide: (0, _redux.bindActionCreators)(_actions.closeCreateUserPanel, dispatch),
        loadCreateUserPanelData: (0, _redux.bindActionCreators)(_actions.loadCreateUserPanelData, dispatch)
    };
})(CreateUserPanel);

/***/ }),
/* 1640 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _UserPanelContainer2 = __webpack_require__(149);

var _UserPanelContainer3 = _interopRequireDefault(_UserPanelContainer2);

var _Header = __webpack_require__(1676);

var _Header2 = _interopRequireDefault(_Header);

var _constants = __webpack_require__(21);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _constants2 = __webpack_require__(4);

var _AccountCreatedContainer = __webpack_require__(1678);

var _AccountCreatedContainer2 = _interopRequireDefault(_AccountCreatedContainer);

var _selectors = __webpack_require__(64);

var _utils = __webpack_require__(6);

var _redux = __webpack_require__(7);

var _actions = __webpack_require__(148);

var _actions2 = __webpack_require__(262);

var _actions3 = __webpack_require__(319);

var _selectors2 = __webpack_require__(208);

var _InvitationDialog = __webpack_require__(877);

var _InvitationDialog2 = _interopRequireDefault(_InvitationDialog);

var _date_format = __webpack_require__(16);

var _UserWithAccessRights = __webpack_require__(138);

var _UserWithAccessRights2 = _interopRequireDefault(_UserWithAccessRights);

var _utils2 = __webpack_require__(25);

var _TimeZoneGroupRow = __webpack_require__(878);

var _TimeZoneGroupRow2 = _interopRequireDefault(_TimeZoneGroupRow);

var _UserGroupRow = __webpack_require__(879);

var _UserGroupRow2 = _interopRequireDefault(_UserGroupRow);

var _selectors3 = __webpack_require__(19);

var _CreateFooter = __webpack_require__(778);

var _CreateFooter2 = _interopRequireDefault(_CreateFooter);

var _actions4 = __webpack_require__(147);

var _selectors4 = __webpack_require__(556);

var _selectors5 = __webpack_require__(515);

var _actions5 = __webpack_require__(880);

var _actions6 = __webpack_require__(50);

var _selectors6 = __webpack_require__(53);

var _groupUtils = __webpack_require__(71);

var _PasswordAsyncValidator = __webpack_require__(280);

var _utils3 = __webpack_require__(202);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CreateUserPanelContainer = function (_UserPanelContainer) {
    _inherits(CreateUserPanelContainer, _UserPanelContainer);

    function CreateUserPanelContainer(_ref) {
        var actions = _ref.actions;

        _classCallCheck(this, CreateUserPanelContainer);

        var _this = _possibleConstructorReturn(this, (CreateUserPanelContainer.__proto__ || Object.getPrototypeOf(CreateUserPanelContainer)).call(this, {
            accountSettingsId: "createUserPanel",
            mode: _UserPanelContainer2.MODE.CREATE,
            actions: actions
        }));

        _this._handleTeamAssignmentsPanelVisibility = function (visible, e) {
            _this.actions.openTeamAssignmentsPanel();
            (0, _utils2.setEventPreventHidingTeamAssignmentSlidingPanel)(e);
        };

        _this.state = _extends({}, _this.state, {
            saving: false,
            userCreated: false,
            invitationSent: false,
            showFutureInvitation: false,
            managementAssignmentsCounts: {
                customers: 0,
                projects: 0,
                tasks: 0
            },
            needToLoadManagementAssignmentsCounts: false,
            allUsers: [],
            copyUser: null,
            approversByGroupIds: {},
            password: "",
            passwordCopy: "",
            licenseCounters: {
                actualCount: 0,
                allowedCount: 0,
                extraUsersCount: 0,
                licenseViolated: false,
                remainingCount: 1
            }
        });

        _this.onStatePropertyChanged('saving', function (saving) {
            _this.footer.setState({ saving: saving });
        });

        _this.onStatePropertyChanged('userCreated', function (userCreated) {
            _this.userPanelContentWrapper.toggle(!userCreated);
            _this.accountCreatedSection.toggle(userCreated);
            _this.accountCreatedOverlay.toggle(userCreated);

            if (userCreated) {
                _this.accountCreatedSection.setState({
                    firstName: _this.state.fullUserInfo.firstName,
                    lastName: _this.state.fullUserInfo.lastName,
                    middleInitial: _this.state.fullUserInfo.middleInitial,
                    email: _this.state.fullUserInfo.email,
                    hireDate: _this.state.fullUserInfo.hireDate,
                    invitationSent: _this.state.invitationSent
                });
            }
        });

        _this.onAnyStatePropertyChanged(['userCreated', 'licenseCounters'], function () {
            if (_this.state.userCreated) {
                _this.accountCreatedSection.setState({
                    inviteOneMoreDisabled: !(0, _utils3.isLicenseUnlimited)(_this.state.licenseCounters) && !(0, _utils3.haveMoreLicenses)(_this.state.licenseCounters)
                });
            }
        });

        _this.onStatePropertyChanged('providerErrors', function (providerErrors) {
            if (!_jquery2.default.isEmptyObject(providerErrors)) {
                _this.footer.setState({
                    hasErrors: true
                });
                _this.setState({ selectedTab: _constants.TabKeys.ACCOUNT_SETTINGS });
                _this.scrollToError(_this.state.providerErrors);
            } else {
                _this.footer.setState({
                    hasErrors: false
                });
            }
        });

        _this.onStatePropertyBecameTrue('showFutureInvitation', function () {
            return _this._showFutureInvitationDialog();
        });

        _this.onStateChanged(function (state) {
            return _this._updateCopyUserSelector(state);
        });

        _this.onStatePropertyChanged('managementAssignmentsCounts', function (managementAssignmentsCounts) {
            _this.permissionsTab.setState({
                managementAssignmentsCounts: managementAssignmentsCounts
            });
        });
        _this.onStatePropertyBecameTrue('needToLoadManagementAssignmentsCounts', function () {
            _this.actions.loadManagementAssignmentsCounts();
        });

        _this.onAnyStatePropertyChanged(['approversByGroupIds', 'fullUserInfo'], function (_ref2) {
            var approversByGroupIds = _ref2.approversByGroupIds,
                fullUserInfo = _ref2.fullUserInfo;

            _this.accountSettingsTab.setState({ approversList: approversByGroupIds[fullUserInfo.userGroupId] });
        });

        _this.asyncPasswordValidator = (0, _PasswordAsyncValidator.getPasswordValidator)({
            onValidationStart: _this.actions.onPasswordValidationStart,
            onValidationEnd: _this.actions.onPasswordValidationEnd
        });

        _this.onStatePropertyBecameTrue("passwordValidationRequested", function () {
            var _this$state = _this.state,
                password = _this$state.password,
                passwordCopy = _this$state.passwordCopy;

            _this.asyncPasswordValidator.setState({ password: password, passwordCopy: passwordCopy, forcePasswordCheck: true });
        });
        return _this;
    }

    _createClass(CreateUserPanelContainer, [{
        key: "afterRender",
        value: function afterRender() {
            var _this2 = this;

            this.$el.attr("id", "createUserPanel");
            this.$el.addClass("createMode components_createUserPanel");
            this.$el.toggleClass("online", _constants2.ProductVersion.isOlVersion);
            this.$el.toggleClass("downloadable", !_constants2.ProductVersion.isOlVersion);

            this.header = new _Header2.default({
                onCopyUserSelectionCallback: this.actions.copyUserSettings,
                onCloseCallback: this.actions.cancelUserCreation
            }).init(this.find('.panelHeader'));

            this.accountCreatedSection = new _AccountCreatedContainer2.default({
                onInviteOneMoreUserCb: function onInviteOneMoreUserCb() {
                    return _this2.actions.inviteOneMoreUser();
                },
                onCloseCb: function onCloseCb() {
                    return _this2.actions.closeCreateUserPanel();
                }
            }).init(this.find(".panelContent"));
            this.accountCreatedSection.hide();

            this.footer = new _CreateFooter2.default({
                submitBtnLabelMsgKey: _constants2.ProductVersion.isOlVersion ? "user.add.js.create_user_with_invitation" : "user.add.js.create_user",
                onSubmitCb: function onSubmitCb() {
                    return _this2.actions.validateAndSaveUser();
                },
                onCancelCb: function onCancelCb() {
                    return _this2.actions.cancelUserCreation();
                }
            }).init(this.find(".panelFooter"));

            this.accountCreatedOverlay = (0, _jquery2.default)("<div class='createUserPanel_accountCreatedOverlay'/>").appendTo(this.getEl());

            _get(CreateUserPanelContainer.prototype.__proto__ || Object.getPrototypeOf(CreateUserPanelContainer.prototype), "afterRender", this).call(this);
        }
    }, {
        key: "subscribeForEvents",
        value: function subscribeForEvents() {
            var _this3 = this;

            _get(CreateUserPanelContainer.prototype.__proto__ || Object.getPrototypeOf(CreateUserPanelContainer.prototype), "subscribeForEvents", this).call(this);

            this.accountSettingsTab.accountInformation.on('changeAccessToOtherProduct', function (e, enable) {
                _this3.actions.updateAccessAP(enable, false);
            });
        }
    }, {
        key: "_showFutureInvitationDialog",
        value: function _showFutureInvitationDialog() {
            var _this4 = this;

            var hireDatePlaceholder = (0, _jquery2.default)("#createUserPanel_hireDatePlaceholder");
            var invitationDialog = new _InvitationDialog2.default().init(this.getEl());
            var formattedHireDate = new _date_format.DateFormat(window.SystemSettings.dateFormat).formatDate(this.state.fullUserInfo.hireDate.parseJSONDate());
            invitationDialog.setContent(_messageResource2.default.getMessage("userlist.user_popup.confirmation.hire_date", [formattedHireDate]));
            invitationDialog.show(hireDatePlaceholder, { offset: "0 7px" }, function () {
                _this4.actions.saveUser(true);
                invitationDialog.hideAndRemove();
            }, function () {
                _this4.actions.onFutureInvitationDialogCancel(false);
            });
        }
    }, {
        key: "_updateCopyUserSelector",
        value: function _updateCopyUserSelector(state) {
            this.header.setState({
                users: state.allUsers.map(function (user) {
                    return _UserWithAccessRights2.default.fromRPC(user);
                }),
                userGroups: (0, _groupUtils.addDefaultUserGroup)(state.allUserGroups),
                timeZoneGroups: state.allTimeZoneGroups,
                ugrEnabled: this.state.isUGREnabled,
                tzgEnabled: this.state.isTZGEnabled,
                isURAEnabled: this.state.isURAEnabled,
                isBTYEnabled: this.state.isBTYEnabled,
                isTTAEnabled: this.state.isTTAEnabled,
                copyUser: state.copyUser
            });
        }
    }, {
        key: "_createUserGroupRowComponent",
        value: function _createUserGroupRowComponent() {
            var _this5 = this;

            return new _UserGroupRow2.default({
                showSaveButton: false,
                createNewUserGroup: function createNewUserGroup(name) {
                    _this5.actions.updateUserGroup(_constants.GROUP_NEW_OR_NOT_KNOWN, name);
                },
                onGroupChanged: function onGroupChanged(id) {
                    _this5.actions.updateUserGroup(id, "");
                },
                updateRowDate: function updateRowDate(data) {
                    _this5.actions.setUserGroupData(data);
                },
                resetGroup: function resetGroup() {
                    return _this5.actions.resetUserGroupRow();
                }
            });
        }
    }, {
        key: "_createTimeZoneGroupRowComponent",
        value: function _createTimeZoneGroupRowComponent() {
            var _this6 = this;

            return new _TimeZoneGroupRow2.default({
                showSaveButton: false,
                createNewGroup: function createNewGroup(data) {
                    _this6.actions.updateTimeZoneGroup(_constants.GROUP_NEW_OR_NOT_KNOWN, data);
                },
                onGroupChanged: function onGroupChanged(id) {
                    _this6.actions.updateTimeZoneGroup(id, null);
                },
                updateRowDate: function updateRowDate(data) {
                    _this6.actions.setTimeZoneGroupData(data);
                },
                resetGroup: function resetGroup() {
                    return _this6.actions.resetTimeZoneGroupRow();
                },
                validateTimeZoneGroup: function validateTimeZoneGroup() {
                    return _this6.actions.validateTimeZoneGroup();
                }
            });
        }
    }]);

    return CreateUserPanelContainer;
}(_UserPanelContainer3.default);

exports.default = (0, _utils.connect)(function (state) {
    return _extends({
        loggedInUserId: (0, _selectors3.getLoggedInUserId)(state),
        selectedTab: (0, _selectors2.getSelectedTab)(state),
        saving: (0, _selectors2.isSaving)(state),
        loaded: (0, _selectors2.isLoaded)(state),
        userCreated: (0, _selectors2.isUserCreated)(state),
        invitationSent: (0, _selectors2.isInvitationSent)(state),
        showFutureInvitation: (0, _selectors2.isShowFutureInvitation)(state),
        managementAssignmentsCounts: (0, _selectors.getManagementAssignmentsCounters)(state),
        copyUser: (0, _selectors2.getCopyUser)(state),
        allUserGroups: (0, _selectors5.getUserGroupsList)(state),
        allTimeZoneGroups: (0, _selectors5.getTimeZoneGroupsList)(state),
        approversByGroupIds: (0, _selectors2.getApproversByGroupIds)(state),
        userManagementData: (0, _selectors6.getUserManagementData)(state),
        password: (0, _selectors.getPassword)(state),
        passwordCopy: (0, _selectors.getPasswordCopy)(state),
        passwordValidationRequested: (0, _selectors2.getUserPanelPasswordValidationRequested)(state),
        licenseCounters: (0, _selectors6.getLicenseCounters)(state)
    }, (0, _selectors.getUserDataWithAdditionalData)(state), (0, _selectors4.getAuthorizationInfo)(state));
}, function (dispatch) {
    return {
        actions: _extends({
            switchTab: (0, _redux.bindActionCreators)(_actions.setUserPanelTab, dispatch),
            onFutureInvitationDialogCancel: (0, _redux.bindActionCreators)(_actions.setShowFutureInvitation, dispatch)
        }, (0, _redux.bindActionCreators)({
            updateFirstName: _actions.updateFirstName,
            updateLastName: _actions.updateLastName,
            updateMiddleName: _actions.updateMiddleName,
            updateUserName: _actions.updateUserName,
            updateEmail: _actions.updateEmail,
            updatePassword: _actions.updatePassword,
            updateUserGroup: _actions.updateUserGroup,
            setUserGroupData: _actions4.setUserGroupData,
            resetUserGroupRow: _actions4.resetUserGroupRow,
            updateTimeZoneGroup: _actions.updateTimeZoneGroup,
            validateTimeZoneGroup: _actions4.validateTimeZoneGroup,
            setTimeZoneGroupData: _actions4.setTimeZoneGroupData,
            resetTimeZoneGroupRow: _actions4.resetTimeZoneGroupRow,
            updateHireDate: _actions.updateHireDate,
            updateAccess: _actions.updateAccess,
            updateAccessAP: _actions.updateAccessAP,
            updateRequireApproval: _actions.updateRequireApproval,
            updateUserSchedules: _actions.updateUserSchedules,
            updateInitialUserSchedule: _actions.updateInitialUserSchedule,
            updateOvertime: _actions.updateOvertime,
            updateUserRates: _actions.updateUserRates,
            deleteUserRate: _actions.deleteUserRate,
            changeTeamAssignments: _actions.changeTeamAssignments,
            updateUserRights: _actions.updateUserRights,
            saveUser: _actions.saveUser,
            validateAndSaveUser: _actions.validateAndSaveUser,
            updateValidateUserRatesResult: _actions.updateValidateUserRatesResult,
            updateValidateWorkScheduleResult: _actions.updateValidateWorkScheduleResult,
            copyUserSettings: _actions.copyUserSettings,
            closeCreateUserPanel: _actions.closeCreateUserPanel,
            cancelUserCreation: _actions.cancelUserCreation,
            inviteOneMoreUser: _actions.inviteOneMoreUser,
            openTeamAssignmentsPanel: _actions5.openTeamAssignmentsPanel,
            openManagementAssignmentPanel: _actions3.openManagementAssignmentPanel,
            openManagementAssignmentsEditor: _actions2.openEditor,
            loadManagementAssignmentsCounts: _actions.loadManagementAssignmentsCounts,
            setUserManagementData: _actions6.setUserManagementData,
            onPasswordValidationStart: _actions.onPasswordValidationStart,
            onPasswordValidationEnd: _actions.onPasswordValidationEnd
        }, dispatch))
    };
})(CreateUserPanelContainer);

/***/ }),
/* 1641 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _AccountInformation = __webpack_require__(1642);

var _AccountInformation2 = _interopRequireDefault(_AccountInformation);

var _WorkSchedule = __webpack_require__(1645);

var _WorkSchedule2 = _interopRequireDefault(_WorkSchedule);

var _TimeTrackApprovalSetting = __webpack_require__(1651);

var _TimeTrackApprovalSetting2 = _interopRequireDefault(_TimeTrackApprovalSetting);

var _UserRates = __webpack_require__(1654);

var _UserRates2 = _interopRequireDefault(_UserRates);

var _UserPanelContainer = __webpack_require__(149);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _Overtime = __webpack_require__(1665);

var _Overtime2 = _interopRequireDefault(_Overtime);

var _index = __webpack_require__(22);

var _constants = __webpack_require__(21);

var _UserPanelModalAlert = __webpack_require__(209);

var _WorkStatusesContainer = __webpack_require__(875);

var _WorkStatusesContainer2 = _interopRequireDefault(_WorkStatusesContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AccountSettings = function (_TemplateView) {
    _inherits(AccountSettings, _TemplateView);

    function AccountSettings(_ref) {
        var wrapperId = _ref.wrapperId,
            mode = _ref.mode,
            userGroupRow = _ref.userGroupRow,
            timeZoneGroupRow = _ref.timeZoneGroupRow,
            _ref$onInitialSchedul = _ref.onInitialScheduleChanged,
            onInitialScheduleChanged = _ref$onInitialSchedul === undefined ? function () {} : _ref$onInitialSchedul,
            _ref$onWorkScheduleCh = _ref.onWorkScheduleChanged,
            onWorkScheduleChanged = _ref$onWorkScheduleCh === undefined ? function () {} : _ref$onWorkScheduleCh,
            _ref$onDefaultWorkSta = _ref.onDefaultWorkStatusesChanged,
            onDefaultWorkStatusesChanged = _ref$onDefaultWorkSta === undefined ? function () {} : _ref$onDefaultWorkSta,
            _ref$deleteWorkSchedu = _ref.deleteWorkSchedule,
            deleteWorkSchedule = _ref$deleteWorkSchedu === undefined ? function () {} : _ref$deleteWorkSchedu,
            _ref$addNewSchedule = _ref.addNewSchedule,
            addNewSchedule = _ref$addNewSchedule === undefined ? function () {} : _ref$addNewSchedule,
            _ref$refreshScrollCb = _ref.refreshScrollCb,
            refreshScrollCb = _ref$refreshScrollCb === undefined ? function () {} : _ref$refreshScrollCb,
            _ref$scrollToElement = _ref.scrollToElement,
            scrollToElement = _ref$scrollToElement === undefined ? function ($el) {} : _ref$scrollToElement,
            _ref$scrollToTop = _ref.scrollToTop,
            scrollToTop = _ref$scrollToTop === undefined ? function () {} : _ref$scrollToTop,
            _ref$restoreState = _ref.restoreState,
            restoreState = _ref$restoreState === undefined ? function () {} : _ref$restoreState;

        _classCallCheck(this, AccountSettings);

        var _this = _possibleConstructorReturn(this, (AccountSettings.__proto__ || Object.getPrototypeOf(AccountSettings)).call(this));

        _this.updateOnInit = false;
        _this.accountSettingsId = wrapperId;
        _this.mode = mode;
        _this.userGroupRow = userGroupRow;
        _this.timeZoneGroupRow = timeZoneGroupRow;
        _this.restoreState = restoreState;
        _this.scrollToElement = scrollToElement;
        _this.scrollToTop = scrollToTop;
        _this.state = {
            showOvertime: (0, _index.isEnabled)(_index.Feature.OVR),
            showUserRates: false,
            updatingUserRates: false,
            loaded: false,
            approversList: []
        };

        _this.callbacks = {
            onInitialScheduleChanged: onInitialScheduleChanged,
            onWorkScheduleChanged: onWorkScheduleChanged,
            onDefaultWorkStatusesChanged: onDefaultWorkStatusesChanged,
            deleteWorkSchedule: deleteWorkSchedule,
            addNewSchedule: addNewSchedule,
            refreshScrollCb: refreshScrollCb
        };

        _this.onStatePropertyChanged('showUserRates', function (showUserRates) {
            return _this._updateUserRatesSection(showUserRates);
        });
        _this.onStatePropertyChanged('updatingUserRates', function (updating) {
            return _this.userRates.setState({ updating: updating });
        });
        _this.onStatePropertyChanged('showOvertime', function (show) {
            return _this.overtime.toggle(show);
        });
        _this.onStatePropertyChanged('approversList', function (approversList) {
            return _this.timeTrackApprovalSetting.setState({
                approvers: approversList
            });
        });

        _this.onStatePropertyChanged('loaded', function (loaded) {
            _this.timeTrackApprovalSetting.setState({ loaded: loaded });
            _this.accountInformation.setState({ loaded: loaded });
        });
        return _this;
    }

    _createClass(AccountSettings, [{
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='accountSettings panelTab'>" + "    <div class='accountInformation section <%=accountInformationScrollClass%>'/>" + "    <div class='timeTrackApproval section <%=timeTrackApprovalScrollClass%>'/>" + "    <div class='workScheduleAndOvertime section <%=workScheduleScrollClass%>'>" + "        <div class='sectionHeader'>" + "            <span id='<%=id%>_sectionHeaderPlaceholder'><%=header%></span>" + "            <span class='section_sync_icon' title='<%=syncWithOtherProduct%>'/>" + "        </div>" + "    </div>" + "    <div class='workStatusSchedule section <%=defaultWorkStatusPlanningScrollClass%>'>" + "    </div>" + "    <div class='userRates section <%=userRatesScrollClass%>'/>" + "</div>";
        }
    }, {
        key: "templateModel",
        value: function templateModel() {
            return {
                id: this.id,
                accountInformationScrollClass: _constants.ValidationErrorsScrollClasses.ACCOUNT_INFORMATION,
                timeTrackApprovalScrollClass: _constants.ValidationErrorsScrollClasses.TIME_TRACK_APPROVAL,
                workScheduleScrollClass: _constants.ValidationErrorsScrollClasses.WORK_SCHEDULE,
                defaultWorkStatusPlanningScrollClass: _constants.ValidationErrorsScrollClasses.DEFAULT_WORK_STATUS_PLANNING,
                userRatesScrollClass: _constants.ValidationErrorsScrollClasses.USER_RATES
            };
        }
    }, {
        key: "messageKeys",
        value: function messageKeys() {
            return {
                header: this.state.showOvertime ? 'userlist.userdata.schedule.work_schedule_and_overtime' : 'userlist.userdata.schedule.work_schedule',
                syncWithOtherProduct: 'user.add_edit.section_synchronized_with_other_product'
            };
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            var _this2 = this;

            _get(AccountSettings.prototype.__proto__ || Object.getPrototypeOf(AccountSettings.prototype), "afterRender", this).call(this);

            this.$userRates = this.find('.userRates');

            this.accountInformation = new _AccountInformation2.default({
                id: this.accountSettingsId,
                mode: this.mode,
                userGroupRow: this.userGroupRow,
                timeZoneGroupRow: this.timeZoneGroupRow,
                restoreState: this.restoreState,
                scrollTo: this.scrollToTop
            }).init(this.find('.accountInformation'));
            this.timeTrackApprovalSetting = new _TimeTrackApprovalSetting2.default(this.find('.timeTrackApproval')).init();
            this.workSchedule = new _WorkSchedule2.default({
                id: this.accountSettingsId,
                mode: this.mode,
                scrollTo: this.scrollToElement,
                onInitialScheduleChanged: this.callbacks.onInitialScheduleChanged,
                onWorkScheduleChanged: this.callbacks.onWorkScheduleChanged,
                deleteWorkSchedule: this.callbacks.deleteWorkSchedule,
                addNewSchedule: this.callbacks.addNewSchedule,
                refreshScrollCb: this.callbacks.refreshScrollCb,
                subscribeSelectorOnScroll: function subscribeSelectorOnScroll(hideCb) {
                    return _this2._subscribeSelectorOnScroll(hideCb);
                }
            }).init(this.find('.workScheduleAndOvertime'));

            this.overtime = new _Overtime2.default(this.find('.workScheduleAndOvertime')).init();
            this.overtime.toggle(this.state.showOvertime);

            this.workStatusSchedule = new _WorkStatusesContainer2.default({
                mode: this.mode,
                refreshScrollCb: this.callbacks.refreshScrollCb,
                onRemoteUpdate: this.callbacks.onDefaultWorkStatusesChanged
            }).init(this.find('.workStatusSchedule'));

            this.find('.workStatusSchedule').toggle((0, _index.isEnabled)(_index.Feature.WSD));

            (0, _jquery2.default)(document).scroll(function () {
                return _this2.onScroll();
            });

            if (this.mode === _UserPanelContainer.MODE.EDIT) (0, _UserPanelModalAlert.createInstance)(this.getEl());
        }
    }, {
        key: "_subscribeSelectorOnScroll",
        value: function _subscribeSelectorOnScroll(hideOpenSelectorCallback) {
            this.hideOpenSelectorCallback = hideOpenSelectorCallback;
        }
    }, {
        key: "onScroll",
        value: function onScroll() {
            if (this.hideOpenSelectorCallback) this.hideOpenSelectorCallback();
        }
    }, {
        key: "isShowUserRates",
        value: function isShowUserRates() {
            return this.state.showUserRates;
        }
    }, {
        key: "_updateUserRatesSection",
        value: function _updateUserRatesSection(showUserRates) {
            var _this3 = this;

            if (showUserRates) {
                this.userRates = new _UserRates2.default({
                    id: this.accountSettingsId,
                    mode: this.mode,
                    scrollTo: this.scrollToElement,
                    refreshScrollCb: this.callbacks.refreshScrollCb,
                    subscribeSelectorOnScroll: function subscribeSelectorOnScroll(hideCb) {
                        return _this3._subscribeSelectorOnScroll(hideCb);
                    }
                }).init(this.$userRates);
                this.registerChildComponents(this.userRates);
            } else {
                this.$userRates.empty();
            }
        }
    }]);

    return AccountSettings;
}(_TemplateView3.default);

exports.default = AccountSettings;

/***/ }),
/* 1642 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _constants = __webpack_require__(4);

var _OnlineAccountFieldsUserPopupDrawer = __webpack_require__(465);

var _DownloadableAccountFieldsUserPopupDrawer = __webpack_require__(467);

var _EditAccountInformationSection = __webpack_require__(868);

var _EditAccountInformationSection2 = _interopRequireDefault(_EditAccountInformationSection);

var _CreateAccountInformationSection = __webpack_require__(870);

var _CreateAccountInformationSection2 = _interopRequireDefault(_CreateAccountInformationSection);

var _UserPanelContainer = __webpack_require__(149);

var _StringUtils = __webpack_require__(121);

var StringUtils = _interopRequireWildcard(_StringUtils);

var _constants2 = __webpack_require__(21);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _UserPanelModalAlert = __webpack_require__(209);

var _constants3 = __webpack_require__(110);

var _atUtils = __webpack_require__(5);

var _PasswordPolicyManager = __webpack_require__(227);

var _PasswordPolicyManager2 = _interopRequireDefault(_PasswordPolicyManager);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AccountInformation = function (_TemplateView) {
    _inherits(AccountInformation, _TemplateView);

    function AccountInformation(_ref) {
        var _ref$id = _ref.id,
            id = _ref$id === undefined ? "" : _ref$id,
            _ref$mode = _ref.mode,
            mode = _ref$mode === undefined ? null : _ref$mode,
            _ref$userGroupRow = _ref.userGroupRow,
            userGroupRow = _ref$userGroupRow === undefined ? null : _ref$userGroupRow,
            _ref$timeZoneGroupRow = _ref.timeZoneGroupRow,
            timeZoneGroupRow = _ref$timeZoneGroupRow === undefined ? null : _ref$timeZoneGroupRow,
            _ref$restoreState = _ref.restoreState,
            restoreState = _ref$restoreState === undefined ? function () {} : _ref$restoreState,
            _ref$scrollTo = _ref.scrollTo,
            scrollTo = _ref$scrollTo === undefined ? function () {} : _ref$scrollTo;

        _classCallCheck(this, AccountInformation);

        var _this = _possibleConstructorReturn(this, (AccountInformation.__proto__ || Object.getPrototypeOf(AccountInformation)).call(this));

        _this.id = id;
        _this.updateOnInit = false;
        _this.isOnline = _constants.isOlVersion;
        _this.mode = mode;

        _this.userGroupRow = userGroupRow;
        _this.timeZoneGroupRow = timeZoneGroupRow;
        _this.restoreState = restoreState;
        _this.scrollTo = scrollTo;

        _this.state = {
            firstName: null,
            lastName: null,
            middleInitial: null,
            email: "",
            username: null,
            hireDate: new Date().toJSON(),
            releaseDate: null,
            password: null,
            retypedPassword: null,
            enabled: false,
            enabledInOtherProduct: false,
            editUserIsLoggedIn: false,
            firstTTDate: null,
            firstRequestDate: null,
            userManagementData: {
                viewerSettings: {
                    enabledFeatures: {}
                },
                allUserGroups: null,
                allTimeZoneGroups: null
            },
            currentTime: new Date().toJSON(),
            activated: false,
            userId: null,
            providerErrors: {},
            passwordValidationResult: null,
            hasLeavesOrTTBeforeNewHireDateError: false,

            baseAccountInformationReadOnly: false,
            accessToActiTimeEditable: true,
            accessToActiPlansEditable: true,
            hireAndReleaseDatesEditable: false,

            loaded: false
        };

        _this.onAnyStatePropertyChanged(['firstName', 'lastName', 'middleInitial', 'email', 'enabled', 'enabledInOtherProduct', 'activated'], function () {
            _this.accountFieldsDrawer.updateAccountSettings(_this.state);
        });

        _this.onStatePropertyChanged('firstName', function (name) {
            _this.editAccountInformation.setValue(_this.editAccountInformation.firstNameField, name);
        });

        _this.onStatePropertyChanged('lastName', function (name) {
            _this.editAccountInformation.setValue(_this.editAccountInformation.lastNameField, name);
        });

        _this.onStatePropertyChanged('middleInitial', function (name) {
            _this.editAccountInformation.setValue(_this.editAccountInformation.middleNameField, name);
        });

        _this.onStatePropertyChanged('email', function (email) {
            _this.editAccountInformation.setValue(_this.editAccountInformation.emailField, email);
        });

        _this.onStatePropertyChanged('username', function (username) {
            if (_this.accountFieldsDrawer.userNameDrawer) _this.accountFieldsDrawer.userNameDrawer.setValue(_this.accountFieldsDrawer.userNameDrawer.usernameField, username);
        });

        _this.onStatePropertyChanged('hireDate', function (hireDate) {
            _this.editAccountInformation.setHireDate(_underscore2.default.isString(hireDate) ? Date.parseJSONDate(hireDate) : hireDate);
        });

        _this.onStatePropertyChanged('hasLeavesOrTTBeforeNewHireDateError', function (hasLeavesOrTTBeforeNewHireDateError) {
            _this.editAccountInformation.toggleHireDateChangedWrning(hasLeavesOrTTBeforeNewHireDateError);
        });

        _this.onAnyStatePropertyChanged(['releaseDate', 'hireAndReleaseDatesEditable'], function (_ref2) {
            var releaseDate = _ref2.releaseDate,
                hireAndReleaseDatesEditable = _ref2.hireAndReleaseDatesEditable;

            _this.editAccountInformation.setReleaseDate(releaseDate, hireAndReleaseDatesEditable);
            //hide read-only release date row in edit user panel if there is no release date
            if (_this.editAccountInformation.initAndShowReleaseDate) _this.editAccountInformation.setReleaseDate(_this.state.releaseDate, hireAndReleaseDatesEditable);
            _this.find(".releaseDateData").toggle((hireAndReleaseDatesEditable || !!releaseDate) && _this.mode === _UserPanelContainer.MODE.EDIT);
        });

        _this.onStatePropertyChanged('password', function (password) {
            if (_this.accountFieldsDrawer.passwordDrawer) _this.accountFieldsDrawer.passwordDrawer.setValue(_this.accountFieldsDrawer.passwordDrawer.passwordField, password);
        });

        _this.onStatePropertyChanged('retypedPassword', function (password) {
            if (_this.accountFieldsDrawer.passwordDrawer) _this.accountFieldsDrawer.passwordDrawer.setValue(_this.accountFieldsDrawer.passwordDrawer.passwordCopyField, password);
        });

        _this.onStatePropertyChanged('enabled', function (enabled) {
            _this.editAccountInformation.accessSelector.setState({ enabled: enabled });
        });

        _this.onStatePropertyChanged('enabledInOtherProduct', function (enabledInOtherProduct) {
            _this.editAccountInformation.setState({ enabledInOtherProduct: enabledInOtherProduct });
        });

        _this.onStatePropertyChanged('firstTTDate', function (firstTTDate) {
            _this.editAccountInformation.firstTTDate = firstTTDate;
        });

        _this.onStatePropertyChanged('firstRequestDate', function (firstRequestDate) {
            _this.editAccountInformation.firstLeaveRequestDate = firstRequestDate;
        });

        _this.onAnyStatePropertyChanged(['userManagementData', 'hireAndReleaseDatesEditable'], function (_ref3) {
            var userManagementData = _ref3.userManagementData,
                hireAndReleaseDatesEditable = _ref3.hireAndReleaseDatesEditable;

            _this.editAccountInformation.corporateSchedule = userManagementData.defaultWorkSchedule;
            _this.editAccountInformation.updateHireDateSelector(userManagementData, _this.state.hireDate, hireAndReleaseDatesEditable);
            if (_this.editAccountInformation.initAndShowReleaseDate) _this.editAccountInformation.initAndShowReleaseDate(_this.state.releaseDate, userManagementData, hireAndReleaseDatesEditable);
        });

        var initFields = function initFields() {
            var self = _this;
            _this.accountFieldsDrawer.initFields({
                accountSettings: _this.state,
                currentTime: _this.state.currentTime,
                editedUserIsSelf: _this.state.editUserIsLoggedIn
            });
            if (_this.accountFieldsDrawer.userNameDrawer) {
                _this.accountFieldsDrawer.userNameDrawer.usernameField.on('changed', function (e, username, duplicateError) {
                    if (self.state.username !== username) {
                        self.setStateInternal({ username: username });
                        self.trigger('changeUsername', [username, duplicateError]);
                    }
                });
            }

            if (_this.accountFieldsDrawer.passwordDrawer) {
                _this.accountFieldsDrawer.passwordDrawer.setPasswordsAreMandatory(true);
                _this.accountFieldsDrawer.passwordDrawer.passwordField.on('changed', function (e, password, retypedPassword, isPasswordChanged, isPasswordCopyChanged) {
                    self.setStateInternal({ password: password, retypedPassword: retypedPassword });
                    self.trigger('changePassword', [password, retypedPassword, isPasswordChanged, isPasswordCopyChanged]);
                });
            }
        };

        _this.onStatePropertyChanged('editUserIsLoggedIn', function (editSelf) {
            _this.editAccountInformation.setState({ editSelf: editSelf });
            initFields();
        });

        _this.onStatePropertyChanged('activated', function () {
            return initFields();
        });
        _this.onStatePropertyChanged('currentTime', function () {
            return initFields();
        });
        _this.onStatePropertyChanged('userId', function (userId) {
            return _this.editAccountInformation.userId = userId;
        });

        _this.onAnyStatePropertyChanged(['providerErrors', 'passwordValidationResult'], function (_ref4) {
            var passwordValidationResult = _ref4.passwordValidationResult,
                providerErrors = _ref4.providerErrors;

            _this._updateErrors(providerErrors, passwordValidationResult);
        });

        _this.onStatePropertyChanged('baseAccountInformationReadOnly', function (readOnly) {
            _this.editAccountInformation.setDisabled(readOnly);
            if (_this.accountFieldsDrawer.userNameDrawer) _this.accountFieldsDrawer.userNameDrawer.setFieldDisabled(_this.accountFieldsDrawer.userNameDrawer.usernameField, readOnly);
            _this.find('.passwordBlock').toggle(_this.mode === _UserPanelContainer.MODE.EDIT && !readOnly);

            if (!_constants.isOlVersion) {
                _this.find('.passwordColumn').toggle(!readOnly);
                _this.find('.passwordCopyColumn').toggle(!readOnly);
            }
        });

        _this.onStatePropertyChanged('accessToActiPlansEditable', function (accessToActiPlansEditable) {
            _this.editAccountInformation.setState({ accessToOtherProductEditable: accessToActiPlansEditable });
        });

        _this.onStatePropertyChanged('accessToActiTimeEditable', function (accessToActiTimeEditable) {
            if (_this.editAccountInformation.accessSelector !== null) {
                _this.editAccountInformation.accessSelector.setState({ readOnly: !accessToActiTimeEditable });
            }
        });

        _this.onStatePropertyChanged('loaded', function (loaded) {
            _this.editAccountInformation.setLoaded(loaded);
        });
        return _this;
    }

    _createClass(AccountInformation, [{
        key: "templateHtml",
        value: function templateHtml() {
            var _html = "<div class='sectionHeader'><%=account_information_header%></div>" + "<div id='<%=id%>_accountInformationSection'><div class='sectionContent'>" + "    <div class='inputFieldsContainer'>" + "            <div class='userInputField firstName'>" + "                <div class='inputGroup'>" + "                   <div class='firstNameInputContainer'>" + "                       <input tabindex='10' type='text' class='firstNameField inputFieldWithPlaceholder' name='firstName' id='<%=id%>_firstNameField' " + "                           placeholder='<%=first_name_placeholder%>' maxlength='32' autocomplete='off'>" + "                   </div><!-- this comment is needed to remove space between inputs-->" + "                   <div class='miInputContainer'>" + "                       <input tabindex='11' type='text' class='middleNameField inputFieldWithPlaceholder' name='middleName' id='<%=id%>_middleNameField'" + "                              placeholder='<%=mi_placeholder%>' maxlength='32' autocomplete='off'>" + "                   </div>" + "                </div>" + "                <div id='<%=id%>_firstNameEmptyError' class='inlineErrorMessage'><%=cannot_be_empty%></div>" + "            </div>" + "            <div class='userInputField lastName'>" + "                <input tabindex='12' type='text' class='lastNameField inputFieldWithPlaceholder' name='lastName' id='<%=id%>_lastNameField' " + "                       placeholder='<%=last_name_placeholder%>' maxlength='32' autocomplete='off'>" + "                <div id='<%=id%>_lastNameEmptyError' class='inlineErrorMessage'><%=cannot_be_empty%></div>" + "            </div>" + "            <% if (isOnline) { %>" + "            <div class='userInputField usernameContainer username' id='<%=id%>_usernameColumn'>" + "                <input tabindex='13' type='text' class='usernameField inputFieldWithPlaceholder' name='username' id='<%=id%>_usernameField' " + "                       placeholder='<%=username_placeholder%>' maxlength='191' autocomplete='off'>" + "                <div id='<%=id%>_usernameEmptyError' class='usernameEmptyError inlineErrorMessage'><%=cannot_be_empty%></div>" + "                <div id='<%=id%>_duplicateUsernameError' class='duplicateUsernameError inlineErrorMessage'><%=username_duplicate%></div>" + "            </div>" + "           <% } %>" + "            <div class='userInputField email'>" + "                <input tabindex='14' type='text' class='emailField inputFieldWithPlaceholder' name='email' id='<%=id%>_emailField' " + "                       placeholder='<%=email_placeholder%>' maxlength='255' autocomplete='off'>" + "                <div id='<%=id%>_emailEmptyError' class='emailEmptyError inlineErrorMessage'><%=cannot_be_empty%></div>" + "                <div id='<%=id%>_emailInvalidError' class='emailInvalidError inlineErrorMessage'><%=email_invalid%></div>" + "            </div>" + "    </div>";

            _html += "    <%if ( !isOnline ){  %>" + "    <div class='downloadableRow'>" + "       <div class='details'>" + "          <span  id='<%=id%>_passwordRequirementsTip' class='passwordHintLink'></span>" + "          <%=downloadable_row_details%>" + "       </div>" + "       <div class='inputFieldsContainer'>" + "           <div style='display:none;' class='userInputField usernameColumn username' id='<%=id%>_usernameColumn'>" + "             <input tabindex='14' type='text' class='usernameField inputFieldWithPlaceholder' name='username'" + "                    id='<%=id%>_usernameField' placeholder='<%=username_placeholder%>'" + "                    maxlength='191' autocomplete='off'>" + "               <div id='<%=id%>_usernameEmptyError' class='usernameEmptyError inlineErrorMessage'>" + "                  <%=username_empty%>" + "               </div>" + "               <div id='<%=id%>_duplicateUsernameError' class='duplicateUsernameError inlineErrorMessage'>" + "                  <%=username_duplicate%>" + "               </div>" + "           </div>" + "           <div class='userInputField passwordColumn'>" + "             <input tabindex='15' type='password' class='passwordField inputFieldWithPlaceholder'" + "                    name='password' id='<%=id%>_passwordField' maxlength='255' autocomplete='off'>" + "               <div id='<%=id%>_passwordEmptyError' class='passwordEmptyError inlineErrorMessage'>" + "                  <%=password_empty%>" + "               </div>" + "               <div class='passwordsErrorContainer' id='<%=id%>_errorsContainer'></div>" + "           </div>" + "           <div class='userInputField passwordCopyColumn'>" + "             <input tabindex='16' type='password' class='passwordCopyField inputFieldWithPlaceholder'" + "                    name='passwordCopy' id='<%=id%>_passwordCopyField' maxlength='255' autocomplete='off'>" + "               <div id='<%=id%>_passwordCopyEmptyError' class='passwordCopyEmptyError inlineErrorMessage'>" + "                 <%=password_copy_empty%>" + "               </div>" + "               <div id='<%=id%>_passwordsDoNotMatchError' class='passwordsDoNotMatchError inlineErrorMessage'>" + "                 <%=passwords_mismatch%>" + "               </div>" + "           </div>" + "         </div>" + "       </div>" + "    </div>" + "    <% } %>" + "    <div class='passwordBlock'>" + "            <div class='resetPassword' style='display: none' id='<%=id%>_resetPasswordLink'><%=reset_password%></div>" + "            <div class='resendInvitation' style='display: none' id='<%=id%>_resendInvitation'><%=resend_invitation%></div>" + "    </div>";

            _html += "    <div class='userDataTable'>" + "       <div id='<%=id%>_accessBoxRow' class='accessDataContainer'>" + "           <div id='<%=id%>_accessToOtherProductSelectorLabel' class='createData labelCell accessSelectorLabel actiplans accessToOnlyOtherProductSelectorLabel'>" + "               <%=access_title%>" + "           </div>" + "           <div id='<%=id%>_accessToProductSelectorLabel' class='editData labelCell accessSelectorLabel accessToProductSelectorLabel'>" + "               <%=access_to%>:" + "           </div> " + "           <div class='editData valueCell accessSelectorLabel actitimeSelectorLabel'>" + "               <%=product_actitime%>" + "           </div>" + "           <div id='<%=id%>_accessSelectorPlaceholder' class='editData valueCell accessSelectorCell accessSelectorPlaceholder'></div>" + "           <div class='editData accessSelectorSeparator'></div>" + "           <div class='editData valueCell accessSelectorLabel accessToOtherProductSelectorLabel'>" + "               <%=product_actiplans%>" + "           </div>" + "           <div id='<%=id%>_accessToOtherProductSelectorPlaceholder' class='createData editData valueCell accessSelectorCell accessToOtherProductSelectorPlaceholder'></div>" + "       </div>" + "        <div class='userGroupPlaceholder'/>" + "        <div class='timeZoneGroupPlaceholder'/>" + "        <div id='<%=id%>_hireDate' class='hireDateData'>" + "            <div class='labelCell selectorsLabelCell'>" + "                <%=hire_date_title%>" + "            </div>" + "            <div class='hireDateLabel'></div>" + "            <div class='valueCell hireDateValueCell'>" + "                <div id='<%=id%>_hireDatePlaceholder' class='atNextMount'></div>" + "            </div>" + "        </div>" + "        <div id='<%=id%>_hireDateEmptyError' class='inlineErrorMessage forDateFields'><%=hire_date_empty%></div>" + "            <div id='<%=id%>_hireDateInFutureForSelfError' class='inlineErrorMessage forDateFields'><%=future_hire_date%></div>" + "        <div id='<%=id%>_releaseDate' class='releaseDateData'>" + "            <div class='labelCell selectorsLabelCell'>" + "                <%=release_date_title%>" + "            </div>" + "            <div class='releaseDateLabel'></div>" + "            <div class='valueCell hireDateValueCell'>" + "                <div id='<%=id%>_releaseDatePlaceholder' class='atNextMount'></div>" + "            </div>" + "                <div class='deleteDateBtn'><a id='<%=id%>_delReleaseDateBtn' class='valueCell'>&nbsp;</a></div>" + "            </div>" + "    </div>" + "</div>";
            return _html;
        }
    }, {
        key: "messageKeys",
        value: function messageKeys() {
            return {
                first_name_placeholder: "user.first_name",
                mi_placeholder: "user.mi",
                last_name_placeholder: "user.last_name",
                username_placeholder: "user.username",
                email_placeholder: "user.email_short",
                cannot_be_empty: 'user.add_edit.error.cannot_be_empty',
                first_name_empty: 'user.add_edit.error.first_name_empty',
                last_name_empty: 'user.add_edit.error.last_name_empty',
                username_empty: 'user.add_edit.error.username_empty',
                username_duplicate: 'user.add_edit.error.username_duplicate',
                email_empty: 'user.add_edit.error.email_empty',
                email_invalid: 'user.add_edit.error.email_invalid',
                hire_date_title: 'userlist.userdata.account_section.hire_date',
                hire_date_empty: 'user.add_edit.js.error.hire_date_empty',
                future_hire_date: 'user.add_edit.js.error.hire_date_in_future_for_self',
                release_date_title: 'userlist.userdata.account_section.release_date',
                access_title: 'userlist.userdata.account_section.access',
                access_to: 'user.add_edit.access_to',
                product_actiplans: 'product.actiplans',
                product_actitime: 'product.actitime',
                account_information_header: 'userlist.userdata.account_section.header',
                reset_password: 'user.edit.reset_password',
                resend_invitation: 'user.edit.resend_invitation',
                downloadable_row_details: 'user.add_edit.login_details',
                password_empty: 'user.add_edit.error.password_empty',
                password_copy_empty: 'user.add_edit.error.password_copy_empty',
                passwords_mismatch: 'user.add_edit.error.passwords_do_not_match'

            };
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            var _this2 = this;

            var accountFieldsDrawer = this.mode === _UserPanelContainer.MODE.EDIT ? _constants.isOlVersion ? new _OnlineAccountFieldsUserPopupDrawer.OnlineAccountFieldsEditUserPopupDrawer() : new _DownloadableAccountFieldsUserPopupDrawer.DownloadableAccountFieldsEditUserPopupDrawer() : _constants.isOlVersion ? new _OnlineAccountFieldsUserPopupDrawer.OnlineAccountFieldsCreateUserPopupDrawer() : new _DownloadableAccountFieldsUserPopupDrawer.DownloadableAccountFieldsCreateUserPopupDrawer();
            this.editAccountInformation = this.mode === _UserPanelContainer.MODE.EDIT ? new _EditAccountInformationSection2.default() : new _CreateAccountInformationSection2.default();
            this.accountFieldsDrawer = accountFieldsDrawer;
            var el = document.getElementById(this.id);
            this.editAccountInformation.init({
                lightBoxEl: el,
                userManagementData: this.state.userManagementData,
                currentTime: this.state.currentTime,
                userId: this.state.userId,
                accountSettings: this.state,
                corporateSchedule: this.state.userManagementData.defaultWorkSchedule,
                userGroupsEnabled: this.state.userManagementData.viewerSettings.enabledFeatures.hasOwnProperty(_constants.UserManagementConstants.UGRFeature),
                timeZoneGroupsEnabled: this.state.userManagementData.viewerSettings.enabledFeatures.hasOwnProperty(_constants.UserManagementConstants.TZGFeature),
                firstTTDate: this.state.firstTTDate,
                firstLeaveRequestDate: this.state.firstRequestDate,
                editedUserIsSelf: this.state.editUserIsLoggedIn,
                specificVersionDrawerConstructor: accountFieldsDrawer,
                scrollableContainerEl: (0, _jquery2.default)(el).find(".innerContent"),
                showGroupRows: false,
                needValidation: this.mode !== _UserPanelContainer.MODE.EDIT,
                disableDuplicateUsernameCheck: this.mode === _UserPanelContainer.MODE.EDIT,
                disableEmptyUsernameCheck: this.mode === _UserPanelContainer.MODE.EDIT,
                releaseDateLabelEl: this.find('.releaseDateLabel'),
                hireDateLabelEl: this.find('.hireDateLabel'),
                hireAndReleaseDatesEditable: this.state.hireAndReleaseDatesEditable
            });

            this.userGroupRow.init(this.find(".userGroupPlaceholder"));
            this.timeZoneGroupRow.init(this.find(".timeZoneGroupPlaceholder"));

            this.editAccountInformation.setErrorState(this.state.providerErrors, this.state.passwordValidationResult);
            var self = this;
            this.editAccountInformation.firstNameField.on('changed', function (e, name) {
                if (self.state.firstName !== name) {
                    self.setState({ firstName: name });
                    self.trigger('changeFirstName', [name]);
                }
            });

            this.editAccountInformation.lastNameField.on('changed', function (e, name) {
                if (self.state.lastName !== name) {
                    self.setState({ lastName: name });
                    self.trigger('changeLastName', [name]);
                }
            });

            this.editAccountInformation.middleNameField.on('changed', function (e, name) {
                if ((StringUtils.isNotEmptyString(self.state.middleInitial) || StringUtils.isNotEmptyString(name)) && self.state.middleInitial !== name) {
                    self.setState({ middleInitial: name });
                    self.trigger('changeMiddleName', [name]);
                }
            });

            this.editAccountInformation.emailField.on('changed', function (e, email) {
                if (self.state.providerErrors[_constants2.ValidationErrors.EMAIL_WAS_EMPTY] && email.length === 0) {
                    _this2._showAlert(_constants2.ValidationErrors.EMAIL_WAS_EMPTY);
                } else if (self.state.email !== email) {
                    self.setState({ email: email });
                    self.trigger('changeEmail', [email]);
                }
            });

            (0, _jquery2.default)(this.editAccountInformation).on('hireDateChanged', function (e, hireDate) {
                var dateStr = hireDate ? hireDate.toJSON() : null;
                if (self.state.hireDate !== dateStr) {
                    self.trigger('changeHireDate', [dateStr]);
                }
            });

            (0, _jquery2.default)(this.editAccountInformation).on('hireDateForceChanged', function (e, hireDate) {
                var dateStr = hireDate ? hireDate.toJSON() : null;
                if (self.state.hireDate !== dateStr) {
                    self.trigger('forceChangeHireDate', [dateStr]);
                }
            });

            (0, _jquery2.default)(this.editAccountInformation).on('setHasLeavesOrTTBeforeNewHireDateError', function (e, hasLeavesOrTTBeforeNewHireDateError) {
                self.trigger('setHasLeavesOrTTBeforeNewHireDateError', [hasLeavesOrTTBeforeNewHireDateError]);
            });

            (0, _jquery2.default)(this.editAccountInformation).on('releaseDateChanged', function (e, releaseDate) {
                var dateStr = releaseDate ? releaseDate.toJSON() : null;
                if (self.state.releaseDate !== dateStr) {
                    self.setStateInternal({ releaseDate: dateStr });
                    self.trigger('changeReleaseDate', [dateStr]);
                }
            });

            (0, _jquery2.default)(this.editAccountInformation).on('changeAccess', function (e, enabled) {
                if (self.state.enabled !== enabled) {
                    self.trigger('changeAccess', [enabled]);
                }
            });

            (0, _jquery2.default)(this.editAccountInformation).on('changeAccessToOtherProduct', function (e, enabled) {
                if (self.state.enabledInOtherProduct !== enabled) {
                    self.trigger('changeAccessToOtherProduct', [enabled]);
                }
            });

            this.subscribeSelectors();

            this.initValidation();
        }
    }, {
        key: "update",
        value: function update() {}
    }, {
        key: "initValidation",
        value: function initValidation() {
            var _validationFields,
                _validationState,
                _this3 = this;

            var $firstName = this.find('.inputFieldsContainer .firstName .firstNameInputContainer');
            var $lastName = this.find('.inputFieldsContainer .lastName');
            var $email = this.find('.inputFieldsContainer .email');
            var $username = this.find('.inputFieldsContainer .username');
            var $releaseDate = this.find('.userDataTable #editUserPanel_releaseDatePlaceholder');

            this.validationFields = (_validationFields = {}, _defineProperty(_validationFields, _constants2.ValidationErrors.FIRST_NAME_EMPTY, $firstName), _defineProperty(_validationFields, _constants2.ValidationErrors.LAST_NAME_EMPTY, $lastName), _defineProperty(_validationFields, _constants2.ValidationErrors.USERNAME_EMPTY, $username), _defineProperty(_validationFields, _constants2.ValidationErrors.USERNAME_DUPLICATE, $username), _defineProperty(_validationFields, _constants2.ValidationErrors.EMAIL_EMPTY, $email), _defineProperty(_validationFields, _constants2.ValidationErrors.EMAIL_WAS_EMPTY, $email), _defineProperty(_validationFields, _constants2.ValidationErrors.EMAIL_INVALID, $email), _defineProperty(_validationFields, _constants2.ValidationErrors.RELEASE_DATE_IS_BEFORE_HIRE_DATE, $releaseDate), _defineProperty(_validationFields, _constants2.ValidationErrors.RELEASE_DATE_WAS_BEFORE_HIRE_DATE, $releaseDate), _validationFields);

            var emailEmptyState = {
                text: _messageResource2.default.getMessage('user.panel.edit.modal_error.email.empty') + '\n' + _messageResource2.default.getMessage('user.panel.edit.modal_error.discarded'),
                pointerPosition: _constants3.ModalAlertPointerPosition.RIGHT,
                offsets: {
                    left: 100,
                    top: 20
                }
            };

            this.validationState = (_validationState = {}, _defineProperty(_validationState, _constants2.ValidationErrors.FIRST_NAME_EMPTY, {
                text: _messageResource2.default.getMessage('user.panel.edit.modal_error.first_name.empty') + '\n' + _messageResource2.default.getMessage('user.panel.edit.modal_error.discarded'),
                pointerPosition: _constants3.ModalAlertPointerPosition.LEFT
            }), _defineProperty(_validationState, _constants2.ValidationErrors.LAST_NAME_EMPTY, {
                text: _messageResource2.default.getMessage('user.panel.edit.modal_error.last_name.empty') + '\n' + _messageResource2.default.getMessage('user.panel.edit.modal_error.discarded')
            }), _defineProperty(_validationState, _constants2.ValidationErrors.USERNAME_EMPTY, {
                text: _messageResource2.default.getMessage('user.panel.edit.modal_error.username.empty') + '\n' + _messageResource2.default.getMessage('user.panel.edit.modal_error.discarded'),
                pointerPosition: this.isOnline ? _constants3.ModalAlertPointerPosition.RIGHT : _constants3.ModalAlertPointerPosition.LEFT
            }), _defineProperty(_validationState, _constants2.ValidationErrors.RELEASE_DATE_IS_BEFORE_HIRE_DATE, {
                text: _messageResource2.default.getMessage('user.add_edit.release_date_before_hire_date') + '\n' + _messageResource2.default.getMessage('user.panel.edit.modal_error.discarded'),
                pointerPosition: _constants3.ModalAlertPointerPosition.CENTER
            }), _defineProperty(_validationState, _constants2.ValidationErrors.RELEASE_DATE_WAS_BEFORE_HIRE_DATE, {
                text: _messageResource2.default.getMessage('user.add_edit.release_date_before_hire_date'),
                pointerPosition: _constants3.ModalAlertPointerPosition.CENTER
            }), _defineProperty(_validationState, _constants2.ValidationErrors.EMAIL_EMPTY, emailEmptyState), _defineProperty(_validationState, _constants2.ValidationErrors.EMAIL_WAS_EMPTY, _extends({}, emailEmptyState, {
                text: _messageResource2.default.getMessage('user.panel.edit.modal_error.email.was_empty')
            })), _defineProperty(_validationState, _constants2.ValidationErrors.EMAIL_INVALID, {
                text: _messageResource2.default.getMessage('user.panel.edit.modal_error.email.invalid') + '\n' + _messageResource2.default.getMessage('user.panel.edit.modal_error.discarded'),
                pointerPosition: _constants3.ModalAlertPointerPosition.RIGHT,
                offsets: {
                    left: 100,
                    top: 20
                }
            }), _defineProperty(_validationState, _constants2.ValidationErrors.USERNAME_DUPLICATE, {
                text: _messageResource2.default.getMessage('user.panel.edit.modal_error.username.duplicate'),
                pointerPosition: this.isOnline ? _constants3.ModalAlertPointerPosition.RIGHT : _constants3.ModalAlertPointerPosition.LEFT
            }), _validationState);

            if (!this.isOnline) {
                var _extends2, _extends3;

                var $password = this.find('.inputFieldsContainer .passwordColumn');
                var $passwordCopy = this.find('.inputFieldsContainer .passwordCopyColumn');
                this.validationFields = _extends({}, this.validationFields, (_extends2 = {}, _defineProperty(_extends2, _constants2.ValidationErrors.PASSWORDS_DO_NOT_MATCH, $passwordCopy), _defineProperty(_extends2, _constants2.ValidationErrors.PASSWORD_COPY_EMPTY, $passwordCopy), _defineProperty(_extends2, _constants2.ValidationErrors.PASSWORD_RESTRICTIONS_VIOLATED, $password), _extends2));

                this.validationState = _extends({}, this.validationState, (_extends3 = {}, _defineProperty(_extends3, _constants2.ValidationErrors.PASSWORD_COPY_EMPTY, {
                    text: _messageResource2.default.getMessage('user.panel.edit.modal_error.password.not_match'), //seems like we need to show same error when copy is empty
                    pointerPosition: _constants3.ModalAlertPointerPosition.RIGHT
                }), _defineProperty(_extends3, _constants2.ValidationErrors.PASSWORDS_DO_NOT_MATCH, {
                    text: _messageResource2.default.getMessage('user.panel.edit.modal_error.password.not_match'),
                    pointerPosition: _constants3.ModalAlertPointerPosition.RIGHT
                }), _defineProperty(_extends3, _constants2.ValidationErrors.PASSWORD_RESTRICTIONS_VIOLATED, function () {
                    return {
                        text: _PasswordPolicyManager2.default.getErrorMessage(_this3.state.passwordValidationResult),
                        pointerPosition: _constants3.ModalAlertPointerPosition.LEFT
                    };
                }), _extends3));
            }
        }
    }, {
        key: "subscribeSelectors",
        value: function subscribeSelectors() {}
    }, {
        key: "_skipPasswordCopyErrorsIfFocused",
        value: function _skipPasswordCopyErrorsIfFocused(errors) {
            if (this.accountFieldsDrawer.passwordDrawer && this.accountFieldsDrawer.passwordDrawer.passwordCopyField[0].inFocus) {
                return _underscore2.default.omit(errors, [_constants2.ValidationErrors.PASSWORDS_DO_NOT_MATCH, _constants2.ValidationErrors.PASSWORD_COPY_EMPTY]);
            }
            return errors;
        }
    }, {
        key: "_updateErrors",
        value: function _updateErrors(errors, passwordValidationResult) {
            var _this4 = this;

            if (this.mode === _UserPanelContainer.MODE.CREATE) {
                this.editAccountInformation.setErrorState(errors, passwordValidationResult);
            } else {
                (0, _UserPanelModalAlert.getInstance)().hide();
                errors = this._skipPasswordCopyErrorsIfFocused(errors);
                var errorsServer = (0, _atUtils.filterSet)(errors, function (error) {
                    return !_this4.validationFields[error];
                });
                var errorsModals = (0, _atUtils.filterSet)(errors, function (error) {
                    return !!_this4.validationFields[error];
                });

                Object.values(this.validationFields).forEach(function ($field) {
                    return $field.removeClass('invalid').removeAttr('title');
                });

                Object.keys(this.validationFields).filter(function (error) {
                    return !!errors[error];
                }).forEach(function (error) {
                    _this4.validationFields[error].addClass('invalid');
                });

                //todo: what for?
                if (errors[_constants2.ValidationErrors.PASSWORDS_DO_NOT_MATCH]) {
                    this.validationFields[_constants2.ValidationErrors.PASSWORDS_DO_NOT_MATCH].addClass('invalid').attr('title', _messageResource2.default.getMessage('user.panel.edit.modal_error.password.not_match'));
                }

                Object.keys(errorsModals).forEach(function (error) {
                    if (errors[error]) {
                        _this4._showAlert(error);
                    }
                });
                this.editAccountInformation.setErrorState(errorsServer, passwordValidationResult);
            }
        }
    }, {
        key: "_showAlert",
        value: function _showAlert(error) {
            var _this5 = this;

            var state = this.validationState[error];
            if (_underscore2.default.isFunction(state)) state = state();
            var $field = this.validationFields[error];
            this.scrollTo($field);

            var alert = (0, _UserPanelModalAlert.getInstance)().setState(state);

            alert.showAt($field, function () {
                if (error !== _constants2.ValidationErrors.USERNAME_DUPLICATE && error !== _constants2.ValidationErrors.EMAIL_WAS_EMPTY && error !== _constants2.ValidationErrors.RELEASE_DATE_WAS_BEFORE_HIRE_DATE && !isPasswordError(error)) {
                    _this5.restoreState();
                }

                var input = $field.find('input')[0];
                if (input && !isPasswordError(error)) {
                    //delay focus to prevent mousedown event triggering after it
                    _underscore2.default.defer(function () {
                        return input.focus();
                    });
                }
            });
        }
    }]);

    return AccountInformation;
}(_TemplateView3.default);

exports.default = AccountInformation;


function isPasswordError(error) {
    return [_constants2.ValidationErrors.PASSWORDS_DO_NOT_MATCH, _constants2.ValidationErrors.PASSWORD_COPY_EMPTY, _constants2.ValidationErrors.PASSWORD_RESTRICTIONS_VIOLATED].includes(error);
}

/***/ }),
/* 1643 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.InvisibleMoire = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InvisibleMoire = exports.InvisibleMoire = function (_TemplateView) {
    _inherits(InvisibleMoire, _TemplateView);

    function InvisibleMoire() {
        _classCallCheck(this, InvisibleMoire);

        return _possibleConstructorReturn(this, (InvisibleMoire.__proto__ || Object.getPrototypeOf(InvisibleMoire)).apply(this, arguments));
    }

    _createClass(InvisibleMoire, [{
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='invisibleMoireContainer'/>";
        }
    }], [{
        key: "getInstance",
        value: function getInstance() {
            return _getInstance();
        }
    }]);

    return InvisibleMoire;
}(_TemplateView3.default);

var instance = null;
var _getInstance = function _getInstance() {
    if (!instance) {
        instance = new InvisibleMoire().init((0, _jquery2.default)("body"));
    }
    return instance;
};

/***/ }),
/* 1644 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ModalAlertLine = function (_TemplateView) {
    _inherits(ModalAlertLine, _TemplateView);

    function ModalAlertLine(_ref) {
        var _ref$lineText = _ref.lineText,
            lineText = _ref$lineText === undefined ? '' : _ref$lineText;

        _classCallCheck(this, ModalAlertLine);

        var _this = _possibleConstructorReturn(this, (ModalAlertLine.__proto__ || Object.getPrototypeOf(ModalAlertLine)).call(this));

        _this.lineText = lineText;
        return _this;
    }

    _createClass(ModalAlertLine, [{
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='modalAlertLine'><%-lineText%></div>";
        }
    }]);

    return ModalAlertLine;
}(_TemplateView3.default);

exports.default = ModalAlertLine;

/***/ }),
/* 1645 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _UserPanelContainer = __webpack_require__(149);

var _WorkScheduleTable = __webpack_require__(1646);

var _WorkScheduleTable2 = _interopRequireDefault(_WorkScheduleTable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var WorkSchedule = function (_TemplateView) {
    _inherits(WorkSchedule, _TemplateView);

    function WorkSchedule(_ref) {
        var id = _ref.id,
            mode = _ref.mode,
            _ref$scrollTo = _ref.scrollTo,
            scrollTo = _ref$scrollTo === undefined ? function () {} : _ref$scrollTo,
            _ref$onInitialSchedul = _ref.onInitialScheduleChanged,
            onInitialScheduleChanged = _ref$onInitialSchedul === undefined ? function () {} : _ref$onInitialSchedul,
            _ref$onWorkScheduleCh = _ref.onWorkScheduleChanged,
            onWorkScheduleChanged = _ref$onWorkScheduleCh === undefined ? function () {} : _ref$onWorkScheduleCh,
            _ref$deleteWorkSchedu = _ref.deleteWorkSchedule,
            deleteWorkSchedule = _ref$deleteWorkSchedu === undefined ? function () {} : _ref$deleteWorkSchedu,
            _ref$addNewSchedule = _ref.addNewSchedule,
            addNewSchedule = _ref$addNewSchedule === undefined ? function () {} : _ref$addNewSchedule,
            _ref$refreshScrollCb = _ref.refreshScrollCb,
            refreshScrollCb = _ref$refreshScrollCb === undefined ? function () {} : _ref$refreshScrollCb,
            _ref$subscribeSelecto = _ref.subscribeSelectorOnScroll,
            subscribeSelectorOnScroll = _ref$subscribeSelecto === undefined ? function () {} : _ref$subscribeSelecto;

        _classCallCheck(this, WorkSchedule);

        var _this = _possibleConstructorReturn(this, (WorkSchedule.__proto__ || Object.getPrototypeOf(WorkSchedule)).call(this));

        _this.id = id;
        _this.updateOnInit = false;
        _this.mode = mode;

        _this.isEditMode = _this.mode === _UserPanelContainer.MODE.EDIT;
        _this.scrollTo = scrollTo;

        _this.callbacks = {
            onInitialScheduleChanged: onInitialScheduleChanged,
            onWorkScheduleChanged: onWorkScheduleChanged,
            deleteWorkSchedule: deleteWorkSchedule,
            addNewSchedule: addNewSchedule,
            refreshScrollCb: refreshScrollCb,
            subscribeSelectorOnScroll: subscribeSelectorOnScroll
        };

        _this.state = {
            userManagementData: null,
            accountSettings: null,
            currentTime: null,
            readOnly: false,

            updating: false
        };

        _this.onAnyStatePropertyDeeplyChanged(['userManagementData', 'accountSettings', 'currentTime'], function (state) {
            _this.workScheduleTable.setState({
                isDefaultInitialSchedule: state.accountSettings.defaultInitialSchedule,
                initialSchedule: state.accountSettings.initialSchedule,
                workSchedule: state.accountSettings.workSchedule,
                defaultWorkSchedule: state.userManagementData.defaultWorkSchedule,

                currentDate: state.currentTime,
                weekStartDay: state.userManagementData.weekStartDay,
                invertedDays: state.userManagementData.invertedDaysMap,
                decimalSeparator: state.userManagementData.decimalSeparator
            });
        });

        _this.onStatePropertyChanged('updating', function (updating) {
            return _this.workScheduleTable.setState({ updating: updating });
        });
        _this.onStatePropertyChanged('readOnly', function (readOnly) {
            return _this.workScheduleTable.setState({ readOnly: readOnly });
        });
        return _this;
    }

    _createClass(WorkSchedule, [{
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='workScheduleSection'/>";
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            this.workScheduleTable = new _WorkScheduleTable2.default({
                readOnly: false,
                editMode: this.isEditMode,
                scrollTo: this.scrollTo,
                onWorkScheduleChanged: this.callbacks.onWorkScheduleChanged,
                onInitialScheduleChanged: this.callbacks.onInitialScheduleChanged,
                deleteWorkSchedule: this.callbacks.deleteWorkSchedule,
                addNewSchedule: this.callbacks.addNewSchedule,
                refreshScrollCb: this.callbacks.refreshScrollCb,
                subscribeSelectorOnScroll: this.callbacks.subscribeSelectorOnScroll
            }).init(this.getEl());
        }
    }]);

    return WorkSchedule;
}(_TemplateView3.default);

exports.default = WorkSchedule;

/***/ }),
/* 1646 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _TableHeader = __webpack_require__(1647);

var _TableHeader2 = _interopRequireDefault(_TableHeader);

var _WorkScheduleList = __webpack_require__(1648);

var _WorkScheduleList2 = _interopRequireDefault(_WorkScheduleList);

var _InitialScheduleRow = __webpack_require__(1650);

var _InitialScheduleRow2 = _interopRequireDefault(_InitialScheduleRow);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _LoadingContainer = __webpack_require__(28);

var _LoadingContainer2 = _interopRequireDefault(_LoadingContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var WorkScheduleTable = function (_TemplateView) {
    _inherits(WorkScheduleTable, _TemplateView);

    function WorkScheduleTable(_ref) {
        var readOnly = _ref.readOnly,
            _ref$editMode = _ref.editMode,
            editMode = _ref$editMode === undefined ? true : _ref$editMode,
            _ref$scrollTo = _ref.scrollTo,
            scrollTo = _ref$scrollTo === undefined ? function () {} : _ref$scrollTo,
            _ref$onInitialSchedul = _ref.onInitialScheduleChanged,
            onInitialScheduleChanged = _ref$onInitialSchedul === undefined ? function () {} : _ref$onInitialSchedul,
            _ref$onWorkScheduleCh = _ref.onWorkScheduleChanged,
            onWorkScheduleChanged = _ref$onWorkScheduleCh === undefined ? function () {} : _ref$onWorkScheduleCh,
            _ref$deleteWorkSchedu = _ref.deleteWorkSchedule,
            deleteWorkSchedule = _ref$deleteWorkSchedu === undefined ? function () {} : _ref$deleteWorkSchedu,
            _ref$addNewSchedule = _ref.addNewSchedule,
            addNewSchedule = _ref$addNewSchedule === undefined ? function () {} : _ref$addNewSchedule,
            _ref$refreshScrollCb = _ref.refreshScrollCb,
            refreshScrollCb = _ref$refreshScrollCb === undefined ? function () {} : _ref$refreshScrollCb,
            _ref$subscribeSelecto = _ref.subscribeSelectorOnScroll,
            subscribeSelectorOnScroll = _ref$subscribeSelecto === undefined ? function () {} : _ref$subscribeSelecto;

        _classCallCheck(this, WorkScheduleTable);

        var _this = _possibleConstructorReturn(this, (WorkScheduleTable.__proto__ || Object.getPrototypeOf(WorkScheduleTable)).call(this));

        _this.params = {
            readOnly: readOnly,
            editMode: editMode,
            scrollTo: scrollTo
        };

        _this.callbacks = {
            onInitialScheduleChanged: onInitialScheduleChanged,
            onWorkScheduleChanged: onWorkScheduleChanged,
            deleteWorkSchedule: deleteWorkSchedule,
            addNewSchedule: addNewSchedule,
            refreshScrollCb: refreshScrollCb,
            subscribeSelectorOnScroll: subscribeSelectorOnScroll
        };

        _this.state = {
            isDefaultInitialSchedule: false,
            initialSchedule: [],
            workSchedule: [],
            defaultWorkSchedule: [],
            readOnly: _this.params.readOnly,

            currentDate: null,
            weekStartDay: 0,
            invertedDays: {},
            decimalSeparator: null,

            updating: false
        };

        _this.onAnyStatePropertyChanged(['isDefaultInitialSchedule', 'initialSchedule', 'workSchedule', 'defaultWorkSchedule', 'currentDate', 'weekStartDay', 'invertedDays', 'decimalSeparator', 'readOnly'], function () {
            _this.workScheduleList.setState({
                isDefaultInitialSchedule: _this.state.isDefaultInitialSchedule,
                defaultWorkSchedule: _this.state.defaultWorkSchedule,
                workSchedule: _this.state.workSchedule,

                currentDate: _this.state.currentDate,
                weekStartDay: _this.state.weekStartDay,
                invertedDays: _this.state.invertedDays,
                decimalSeparator: _this.state.decimalSeparator,
                readOnly: _this.state.readOnly
            });

            var isInitialScheduleEffective = !_this.state.workSchedule.find(function (s) {
                return s.effectiveDate && s.effectiveDate.parseJSONDate() <= _this.state.currentDate.parseJSONDate();
            });

            _this.initialSchedule.setState({
                isDefaultInitialSchedule: _this.state.isDefaultInitialSchedule,
                initialSchedule: _this.state.initialSchedule,
                weekStartDay: _this.state.weekStartDay,
                effective: isInitialScheduleEffective,
                readOnly: _this.state.readOnly
            });

            _this.$addRecordButton.toggle(!_this.state.readOnly);
        });

        _this.onStatePropertyChanged('weekStartDay', function (weekStartDay) {
            return _this.tableHeader.setState({ weekStartDay: weekStartDay });
        });
        _this.onStatePropertyChanged('updating', function (loading) {
            return _this.loadingWrapper.setState({ loading: loading });
        });
        return _this;
    }

    _createClass(WorkScheduleTable, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class="workScheduleTable">' + '    <div class="tableHeader"/>' + '    <div class="workSchedulesContainer"></div>' + '    <% if (params.editMode) { %>' + '    <div class="addRecordButtonPlaceholder">' + '        <div class="addRecordButton">' + '            <div class="icon"/>' + '            <span class="label"><%=newScheduleLabel%></span>' + '        </div>' + '    </div>' + '    <% } %>' + '</div>';
        }
    }, {
        key: 'messageKeys',
        value: function messageKeys() {
            return {
                newScheduleLabel: 'user.add_edit.js.wd_editor.new_schedule'
            };
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            var _this2 = this;

            this.$addRecordButton = this.find('.addRecordButton');
            this.tableHeader = new _TableHeader2.default().init(this.find('.tableHeader'));

            this.initialSchedule = new _InitialScheduleRow2.default({
                readOnly: this.params.readOnly,
                scheduleHeaderLabel: _messageResource2.default.getMessage('user.add_edit.js.wd_editor.initial_schedule_row_header'),
                scrollTo: this.params.scrollTo,
                onChangeCb: this.callbacks.onInitialScheduleChanged
            });

            this.workScheduleList = new _WorkScheduleList2.default({
                editMode: this.params.editMode,
                readOnly: this.params.readOnly,
                scrollTo: this.params.scrollTo,
                onScheduleChanged: this.callbacks.onWorkScheduleChanged,
                deleteWorkSchedule: this.callbacks.deleteWorkSchedule,
                refreshScrollCb: this.callbacks.refreshScrollCb,
                subscribeSelectorOnScroll: this.callbacks.subscribeSelectorOnScroll
            });

            this.loadingWrapper = new _LoadingContainer2.default({
                contentComponent: [this.initialSchedule, this.workScheduleList],
                proxySetState: false,
                loadingMoireConfig: {
                    delay: 500
                }
            }).init(this.find('.workSchedulesContainer'));

            if (this.params.editMode && !this.params.readOnly) this.$addRecordButton.click(function () {
                return _this2.callbacks.addNewSchedule();
            });

            this.$addRecordButton.toggle(!this.params.readOnly);
        }
    }]);

    return WorkScheduleTable;
}(_TemplateView3.default);

exports.default = WorkScheduleTable;

/***/ }),
/* 1647 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _WorkdayDurationsEditor = __webpack_require__(260);

var _WorkdayDurationsEditor2 = _interopRequireDefault(_WorkdayDurationsEditor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TableHeader = function (_TemplateView) {
    _inherits(TableHeader, _TemplateView);

    function TableHeader() {
        _classCallCheck(this, TableHeader);

        var _this = _possibleConstructorReturn(this, (TableHeader.__proto__ || Object.getPrototypeOf(TableHeader)).call(this));

        _this.state = {
            weekStartDay: 0
        };

        _this.onStatePropertyChanged('weekStartDay', function (weekStartDay) {
            return _this._update(weekStartDay);
        });
        return _this;
    }

    _createClass(TableHeader, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<table class="workScheduleTableHeader"/>';
        }
    }, {
        key: '_update',
        value: function _update(weekStartDay) {
            this.getEl().empty().append(_WorkdayDurationsEditor2.default.buildTableHeader(weekStartDay));
        }
    }]);

    return TableHeader;
}(_TemplateView3.default);

exports.default = TableHeader;

/***/ }),
/* 1648 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _WorkScheduleRow = __webpack_require__(1649);

var _WorkScheduleRow2 = _interopRequireDefault(_WorkScheduleRow);

var _utils = __webpack_require__(873);

var _constants = __webpack_require__(21);

var _constants2 = __webpack_require__(206);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var WorkScheduleList = function (_TemplateView) {
    _inherits(WorkScheduleList, _TemplateView);

    function WorkScheduleList(_ref) {
        var editMode = _ref.editMode,
            readOnly = _ref.readOnly,
            _ref$scrollTo = _ref.scrollTo,
            scrollTo = _ref$scrollTo === undefined ? function () {} : _ref$scrollTo,
            _ref$onScheduleChange = _ref.onScheduleChanged,
            onScheduleChanged = _ref$onScheduleChange === undefined ? function () {} : _ref$onScheduleChange,
            _ref$deleteWorkSchedu = _ref.deleteWorkSchedule,
            deleteWorkSchedule = _ref$deleteWorkSchedu === undefined ? function () {} : _ref$deleteWorkSchedu,
            _ref$refreshScrollCb = _ref.refreshScrollCb,
            refreshScrollCb = _ref$refreshScrollCb === undefined ? function () {} : _ref$refreshScrollCb,
            _ref$subscribeSelecto = _ref.subscribeSelectorOnScroll,
            subscribeSelectorOnScroll = _ref$subscribeSelecto === undefined ? function () {} : _ref$subscribeSelecto;

        _classCallCheck(this, WorkScheduleList);

        var _this = _possibleConstructorReturn(this, (WorkScheduleList.__proto__ || Object.getPrototypeOf(WorkScheduleList)).call(this));

        _this.params = {
            editMode: editMode,
            readOnly: readOnly,
            scrollTo: scrollTo
        };

        _this.callbacks = {
            onScheduleChanged: onScheduleChanged,
            deleteWorkSchedule: deleteWorkSchedule,
            refreshScrollCb: refreshScrollCb,
            subscribeSelectorOnScroll: subscribeSelectorOnScroll
        };

        _this.state = {
            useDefaultSchedule: false,
            defaultWorkSchedule: [],
            workSchedule: [],
            readOnly: _this.params.readOnly,

            currentDate: null,
            weekStartDay: null,
            invertedDays: {},
            decimalSeparator: null
        };

        _this.schedulesMap = {};

        _this.onStateChanged(function () {
            return _this._updateRows();
        });
        return _this;
    }

    _createClass(WorkScheduleList, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class="workScheduleList"/>';
        }
    }, {
        key: '_updateRows',
        value: function _updateRows() {
            var _this2 = this;

            this.getEl().empty();
            this.schedulesMap = {};

            var effectiveDate = (0, _utils.getEffectiveDate)(this.state.workSchedule.map(function (s) {
                return s.effectiveDate;
            }), this.state.currentDate);

            this.state.workSchedule.forEach(function (schedule, index) {
                var node = new _WorkScheduleRow2.default({
                    readOnly: _this2.state.readOnly,
                    scrollTo: _this2.params.scrollTo,
                    onChangeCb: function onChangeCb(schedule) {
                        return _this2._handleScheduleRowChanged(index, schedule);
                    },
                    onDeleteCb: function onDeleteCb(_ref2) {
                        var removePermanently = _ref2.removePermanently;
                        return _this2.callbacks.deleteWorkSchedule({
                            scheduleToRemove: _extends({}, schedule, { oldEffectiveDate: schedule.effectiveDate }),
                            removePermanently: removePermanently,
                            index: index
                        });
                    },
                    rollbackEffectiveDateChanges: function rollbackEffectiveDateChanges() {
                        node.setState({
                            effectiveDate: schedule.effectiveDate,
                            error: null
                        });
                        Object.values(_this2.schedulesMap).forEach(function (schedule) {
                            return schedule.setState({ error: null });
                        });
                    },
                    subscribeSelectorOnScroll: _this2.callbacks.subscribeSelectorOnScroll
                }).init(_this2.getEl());

                node.setState({
                    oldEffectiveDate: schedule.effectiveDate,
                    effectiveDate: schedule.effectiveDate,
                    durations: schedule.durations,
                    weekStartDay: _this2.state.weekStartDay,
                    invertedDays: _this2.state.invertedDays,
                    useDefaultSchedule: schedule.sameAsDefault,
                    defaultWorkSchedule: _this2.state.defaultWorkSchedule,
                    currentDate: _this2.state.currentDate,
                    effective: effectiveDate !== null && effectiveDate === schedule.effectiveDate
                });

                _this2.schedulesMap[index] = node;
            });

            this.callbacks.refreshScrollCb();
        }
    }, {
        key: '_handleScheduleRowChanged',
        value: function _handleScheduleRowChanged(index, _ref3) {
            var _this3 = this;

            var effectiveDate = _ref3.effectiveDate,
                oldEffectiveDate = _ref3.oldEffectiveDate,
                durations = _ref3.durations,
                sameAsDefault = _ref3.sameAsDefault;

            var newSchedule = { effectiveDate: effectiveDate, oldEffectiveDate: oldEffectiveDate, durations: durations, sameAsDefault: sameAsDefault };
            var schedules = this.state.workSchedule.map(function (schedule) {
                return _extends({}, schedule, { oldEffectiveDate: schedule.effectiveDate });
            });
            schedules.splice(index, 1, newSchedule);

            var sameEffectiveDateSchedule = schedules.find(function (schedule) {
                return schedule.oldEffectiveDate === effectiveDate;
            });

            if (effectiveDate !== oldEffectiveDate && sameEffectiveDateSchedule) {
                var _error2;

                schedules.forEach(function (schedule, index) {
                    _this3.schedulesMap[index].setState({
                        error: _defineProperty({}, _constants.ValidationErrors.DUPLICATED_EFFECTIVE_DATE, sameEffectiveDateSchedule.effectiveDate === schedule.oldEffectiveDate)
                    });
                });
                this.schedulesMap[index].setState({
                    effectiveDate: effectiveDate,
                    error: (_error2 = {}, _defineProperty(_error2, _constants.ValidationErrors.DUPLICATED_EFFECTIVE_DATE, true), _defineProperty(_error2, 'showWarning', this.params.editMode ? _constants2.ShowWarning.EFFECTIVE_DATE_WARNING : false), _error2)
                });
            } else {
                this.callbacks.onScheduleChanged(schedules);
            }
        }
    }]);

    return WorkScheduleList;
}(_TemplateView3.default);

exports.default = WorkScheduleList;

/***/ }),
/* 1649 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _EffectiveDateCell = __webpack_require__(871);

var _EffectiveDateCell2 = _interopRequireDefault(_EffectiveDateCell);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _WorkdayDurationsEditor = __webpack_require__(260);

var _WorkdayDurationsEditor2 = _interopRequireDefault(_WorkdayDurationsEditor);

var _CustomCheckbox = __webpack_require__(83);

var _CustomCheckbox2 = _interopRequireDefault(_CustomCheckbox);

var _user_time = __webpack_require__(30);

var _user_time2 = _interopRequireDefault(_user_time);

var _DeleteConfirmationCell = __webpack_require__(872);

var _DeleteConfirmationCell2 = _interopRequireDefault(_DeleteConfirmationCell);

var _UserPanelModalAlert = __webpack_require__(209);

var _constants = __webpack_require__(110);

var _constants2 = __webpack_require__(21);

var _constants3 = __webpack_require__(206);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var WorkScheduleRow = function (_TemplateView) {
    _inherits(WorkScheduleRow, _TemplateView);

    function WorkScheduleRow(_ref) {
        var _ref$readOnly = _ref.readOnly,
            readOnly = _ref$readOnly === undefined ? false : _ref$readOnly,
            _ref$showWarning = _ref.showWarning,
            showWarning = _ref$showWarning === undefined ? false : _ref$showWarning,
            _ref$scrollTo = _ref.scrollTo,
            scrollTo = _ref$scrollTo === undefined ? function () {} : _ref$scrollTo,
            _ref$onChangeCb = _ref.onChangeCb,
            onChangeCb = _ref$onChangeCb === undefined ? function () {} : _ref$onChangeCb,
            _ref$onDeleteCb = _ref.onDeleteCb,
            onDeleteCb = _ref$onDeleteCb === undefined ? function () {} : _ref$onDeleteCb,
            _ref$rollbackEffectiv = _ref.rollbackEffectiveDateChanges,
            rollbackEffectiveDateChanges = _ref$rollbackEffectiv === undefined ? function () {} : _ref$rollbackEffectiv,
            _ref$subscribeSelecto = _ref.subscribeSelectorOnScroll,
            subscribeSelectorOnScroll = _ref$subscribeSelecto === undefined ? function () {} : _ref$subscribeSelecto;

        _classCallCheck(this, WorkScheduleRow);

        var _this = _possibleConstructorReturn(this, (WorkScheduleRow.__proto__ || Object.getPrototypeOf(WorkScheduleRow)).call(this));

        _this.params = {
            readOnly: readOnly,
            showWarning: showWarning,
            scrollTo: scrollTo
        };

        _this.callbacks = {
            onChangeCb: onChangeCb,
            onDeleteCb: onDeleteCb,
            rollbackEffectiveDateChanges: rollbackEffectiveDateChanges,
            subscribeSelectorOnScroll: subscribeSelectorOnScroll
        };

        _this.state = {
            oldEffectiveDate: null,
            effectiveDate: null,
            durations: [],
            weekStartDay: null,
            invertedDays: {},
            defaultWorkSchedule: [],
            useDefaultSchedule: false,
            currentDate: new Date().toJSON(),
            effective: false,
            error: null,
            readOnly: _this.params.readOnly
        };

        _this.onAnyStatePropertyChanged(['effectiveDate', 'durations', 'weekStartDay', 'invertedDays', 'defaultWorkSchedule', 'useDefaultSchedule', 'currentDate', 'effective', 'readOnly'], function () {
            return _this._update();
        });

        _this.onStatePropertyChanged('error', function (error) {
            return _this._updateError(error);
        });
        return _this;
    }

    _createClass(WorkScheduleRow, [{
        key: 'messageKeys',
        value: function messageKeys() {
            return {
                usedCorporateSettings: 'user.add_edit.js.wd_editor.used_corporate_settings'
            };
        }
    }, {
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class="workScheduleRow">' + '    <div class="workSchedule">' + '        <div class="headerCell"/>' + '        <div class="workScheduleEditorCell"/>' + '        <div class="totalCell"/>' + '        <div class="useDefaultScheduleCell">' + '            <div class="usedDefaultScheduleLabel"><%-usedCorporateSettings%></div>' + '        </div>' + '        <div class="deleteButtonCell">' + '            <div class="deleteIcon"/>' + '        </div>' + '    </div>' + '    <div class="deleteConfirmationContainer"/>' + '</div>';
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            var _this2 = this;

            this.$workschedule = this.find('.workSchedule');
            this.$deleteCell = this.find('.deleteButtonCell');
            this.$usedDefaultScheduleLabel = this.find('.usedDefaultScheduleLabel');

            this.effectiveDate = new _EffectiveDateCell2.default({
                dateFromLabel: _messageResource2.default.getMessage('user.add_edit.js.wd_editor.effective_date_prefix'),
                readOnly: this.params.readOnly,
                scrollTo: this.params.scrollTo,
                onChangeCb: function onChangeCb(effectiveDate) {
                    return _this2._handleScheduleChanged({ effectiveDate: effectiveDate });
                },
                rollbackChanges: this.callbacks.rollbackEffectiveDateChanges,
                subscribeSelectorOnScroll: this.callbacks.subscribeSelectorOnScroll
            }).init(this.find('.headerCell'));

            this.$workdayDurationsPlaceholder = this.find('.workScheduleEditorCell');

            this.$totalCell = this.find('.totalCell');

            this.useDefaultScheduleCheckbox = new _CustomCheckbox2.default({
                label: _messageResource2.default.getMessage('user.add_edit.js.wd_editor.use_corporate_settings'),
                containerAdditionalClass: 'useDefaultScheduleCheckbox',
                onChange: function onChange(_ref2) {
                    var checked = _ref2.checked;
                    return _this2._handleScheduleChanged({ useDefaultSchedule: checked });
                }
            }).init(this.find('.useDefaultScheduleCell'));

            this.$deleteCell.toggle(!this.params.readOnly);

            this.find('.deleteIcon').click(function (e) {
                e.stopPropagation();

                if (_this2.state.effectiveDate === null) {
                    _this2.callbacks.onDeleteCb({ removePermanently: true });
                } else {
                    _this2._toggleDeleteConfirmation(true);
                }
            });

            this.$deleteConfirmationContainer = this.find('.deleteConfirmationContainer').hide();
        }
    }, {
        key: '_update',
        value: function _update() {
            var _this3 = this;

            this.$workschedule.toggleClass('effective', this.state.effective);

            this.effectiveDate.setState({
                invertedDays: this.state.invertedDays,
                weekStartDay: this.state.weekStartDay,
                defaultWorkSchedule: this.state.defaultWorkSchedule,
                date: this.state.effectiveDate,
                effective: this.state.effective
            });

            this.$workdayDurationsPlaceholder.empty();

            this.workdayDurationsEditor = new _WorkdayDurationsEditor2.default().init([].concat(_toConsumableArray(this.state.durations)), this.state.weekStartDay, function () {
                if (_this3.workdayDurationsEditor.hasErrors()) {
                    _this3._handleWorkdayDurationEditorError();
                } else {
                    _this3._handleScheduleChanged({
                        useDefaultSchedule: false,
                        durations: _this3.workdayDurationsEditor.getDurations()
                    });
                }
            }, false, null, window.SystemSettings.decimalSeparator, this.state.readOnly);
            var showCorporateCheckbox = !this.state.readOnly && this.state.effectiveDate !== null && this.state.effectiveDate.parseJSONDate() >= this.state.currentDate.parseJSONDate();

            this.workdayDurationsEditor.renderTo(this.$workdayDurationsPlaceholder[0]);
            this.workdayDurationsEditor.setInputDisabled(this.state.useDefaultSchedule && showCorporateCheckbox || this.state.readOnly);

            this.$totalCell.text(_user_time2.default.formatTime(_WorkdayDurationsEditor2.default.sumDurations(this.state.durations)));

            this.useDefaultScheduleCheckbox.setState({
                checked: this.state.useDefaultSchedule,
                disabled: !showCorporateCheckbox
            });

            this.useDefaultScheduleCheckbox.toggle(showCorporateCheckbox);
            this.$usedDefaultScheduleLabel.toggle(this.state.readOnly && this.state.useDefaultSchedule);

            this.$deleteCell.toggle(!this.state.readOnly);
        }
    }, {
        key: '_handleScheduleChanged',
        value: function _handleScheduleChanged(changes) {
            var _state$changes = _extends({}, this.state, changes),
                oldEffectiveDate = _state$changes.oldEffectiveDate,
                effectiveDate = _state$changes.effectiveDate,
                durations = _state$changes.durations,
                useDefaultSchedule = _state$changes.useDefaultSchedule;

            this.callbacks.onChangeCb({
                oldEffectiveDate: oldEffectiveDate,
                effectiveDate: effectiveDate,
                durations: durations,
                sameAsDefault: useDefaultSchedule
            });
        }
    }, {
        key: '_toggleDeleteConfirmation',
        value: function _toggleDeleteConfirmation(show) {
            var _this4 = this;

            this.$workschedule.toggle(!show);
            this.$deleteConfirmationContainer.toggle(show);

            if (show) {
                new _DeleteConfirmationCell2.default({
                    deleteMessageKey: 'userlist.userdata.effective_date_row_delete_confirmation',
                    onConfirm: function onConfirm() {
                        return _this4.callbacks.onDeleteCb({ removePermanently: false });
                    },
                    onCancel: function onCancel() {
                        return _this4._toggleDeleteConfirmation(false);
                    }
                }).init(this.find('.deleteConfirmationContainer'));
            } else {
                this.find('.deleteConfirmationContainer').empty();
            }
        }
    }, {
        key: '_updateError',
        value: function _updateError(error) {
            this.effectiveDate.setState({
                error: error && !!error[_constants2.ValidationErrors.DUPLICATED_EFFECTIVE_DATE] ? _constants2.ValidationErrors.DUPLICATED_EFFECTIVE_DATE : null,
                needShowWarning: error && error.showWarning === _constants3.ShowWarning.EFFECTIVE_DATE_WARNING
            });
        }
    }, {
        key: '_handleWorkdayDurationEditorError',
        value: function _handleWorkdayDurationEditorError() {
            var _this5 = this;

            var $invalidWorkDayCell = this.find('.' + this.workdayDurationsEditor.getTableClassName() + ' td.error');
            var msg = _messageResource2.default.getMessage('rates.editor.work_schedule.day_value.error', [window.SystemSettings.decimalSeparator]) + '\n' + _messageResource2.default.getMessage('rates.editor.modifications_will_be_discarded');

            this.params.scrollTo($invalidWorkDayCell);

            var prevDurations = this.state.durations;
            this.setStateInternal({ durations: this.workdayDurationsEditor.getDurations() });

            (0, _UserPanelModalAlert.getInstance)().setState({
                text: msg,
                pointerPosition: _constants.ModalAlertPointerPosition.CENTER
            }).showAt($invalidWorkDayCell, function () {
                _this5.setState({ durations: prevDurations });
            });
        }
    }]);

    return WorkScheduleRow;
}(_TemplateView3.default);

exports.default = WorkScheduleRow;

/***/ }),
/* 1650 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _WorkdayDurationsEditor = __webpack_require__(260);

var _WorkdayDurationsEditor2 = _interopRequireDefault(_WorkdayDurationsEditor);

var _CustomCheckbox = __webpack_require__(83);

var _CustomCheckbox2 = _interopRequireDefault(_CustomCheckbox);

var _user_time = __webpack_require__(30);

var _user_time2 = _interopRequireDefault(_user_time);

var _UserPanelModalAlert = __webpack_require__(209);

var _constants = __webpack_require__(110);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InitialScheduleRow = function (_TemplateView) {
    _inherits(InitialScheduleRow, _TemplateView);

    function InitialScheduleRow(_ref) {
        var _ref$readOnly = _ref.readOnly,
            readOnly = _ref$readOnly === undefined ? false : _ref$readOnly,
            _ref$scheduleHeaderLa = _ref.scheduleHeaderLabel,
            scheduleHeaderLabel = _ref$scheduleHeaderLa === undefined ? '' : _ref$scheduleHeaderLa,
            _ref$scrollTo = _ref.scrollTo,
            scrollTo = _ref$scrollTo === undefined ? function () {} : _ref$scrollTo,
            _ref$onChangeCb = _ref.onChangeCb,
            onChangeCb = _ref$onChangeCb === undefined ? function () {} : _ref$onChangeCb;

        _classCallCheck(this, InitialScheduleRow);

        var _this = _possibleConstructorReturn(this, (InitialScheduleRow.__proto__ || Object.getPrototypeOf(InitialScheduleRow)).call(this));

        _this.params = {
            readOnly: readOnly,
            scheduleHeaderLabel: scheduleHeaderLabel,
            scrollTo: scrollTo
        };

        _this.callbacks = {
            onChangeCb: onChangeCb
        };

        _this.state = {
            initialSchedule: [],
            isDefaultInitialSchedule: false,
            weekStartDay: 0,
            effective: false,
            readOnly: _this.params.readOnly
        };

        _this.onStateChanged(function () {
            return _this._update();
        });
        return _this;
    }

    _createClass(InitialScheduleRow, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class="workScheduleRow">' + '    <div class="workSchedule">' + '        <div class="headerCell">' + '            <div class="scheduleHeaderLabel"><%=scheduleHeaderLabel%></div>' + '            <div class="current"><%=dateFromLabel%></div>' + '        </div>' + '        <div class="workScheduleEditorCell"/>' + '        <div class="totalCell"/>' + '        <div class="useDefaultScheduleCell">' + '            <div class="usedDefaultScheduleLabel"><%-usedCorporateSettings%></div>' + '        </div>' + '    </div>' + '</div>';
        }
    }, {
        key: 'templateModel',
        value: function templateModel() {
            return {
                dateFromLabel: this.params.dateFromLabel,
                scheduleHeaderLabel: this.params.scheduleHeaderLabel
            };
        }
    }, {
        key: 'messageKeys',
        value: function messageKeys() {
            return {
                usedCorporateSettings: 'user.add_edit.js.wd_editor.used_corporate_settings'
            };
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            var _this2 = this;

            this.$workschedule = this.find('.workSchedule');
            this.$workdayDurationsPlaceholder = this.find('.workScheduleEditorCell');
            this.$totalCell = this.find('.totalCell');
            this.$usedDefaultScheduleLabel = this.find('.usedDefaultScheduleLabel');

            this.useDefaultScheduleCheckbox = new _CustomCheckbox2.default({
                label: _messageResource2.default.getMessage('user.add_edit.js.wd_editor.use_corporate_settings'),
                containerAdditionalClass: 'useDefaultScheduleCheckbox',
                onChange: function onChange(_ref2) {
                    var checked = _ref2.checked;
                    return _this2._handleChanged({ isDefaultInitialSchedule: checked });
                }
            }).init(this.find('.useDefaultScheduleCell'));
        }
    }, {
        key: '_update',
        value: function _update() {
            var _this3 = this;

            this.$workdayDurationsPlaceholder.empty();
            this.$workschedule.toggleClass('effective', this.state.effective);

            this.workdayDurationsEditor = new _WorkdayDurationsEditor2.default().init(this.state.initialSchedule.slice(), this.state.weekStartDay, function () {
                if (_this3.workdayDurationsEditor.hasErrors()) {
                    _this3._handleWorkdayDurationEditorError();
                } else {
                    _this3._handleChanged({
                        isDefaultInitialSchedule: false,
                        initialSchedule: _this3.workdayDurationsEditor.getDurations()
                    });
                }
            }, false, null, window.SystemSettings.decimalSeparator, this.state.readOnly);
            var showCorporateCheckbox = !this.state.readOnly && this.state.effective;

            this.workdayDurationsEditor.renderTo(this.$workdayDurationsPlaceholder[0]);
            this.workdayDurationsEditor.setInputDisabled(this.state.isDefaultInitialSchedule && showCorporateCheckbox || this.state.readOnly);

            this.$totalCell.text(_user_time2.default.formatTime(_WorkdayDurationsEditor2.default.sumDurations(this.state.initialSchedule)));

            this.useDefaultScheduleCheckbox.setState({
                checked: this.state.isDefaultInitialSchedule,
                disabled: !showCorporateCheckbox
            });
            this.useDefaultScheduleCheckbox.toggle(showCorporateCheckbox);
            this.$usedDefaultScheduleLabel.toggle(this.state.readOnly && this.state.isDefaultInitialSchedule);
        }
    }, {
        key: '_handleChanged',
        value: function _handleChanged(changes) {
            var _state$changes = _extends({}, this.state, changes),
                initialSchedule = _state$changes.initialSchedule,
                isDefaultInitialSchedule = _state$changes.isDefaultInitialSchedule;

            this.callbacks.onChangeCb({ initialSchedule: initialSchedule, isDefaultInitialSchedule: isDefaultInitialSchedule });
        }
    }, {
        key: '_handleWorkdayDurationEditorError',
        value: function _handleWorkdayDurationEditorError() {
            var _this4 = this;

            var $invalidWorkDayCell = this.find('.' + this.workdayDurationsEditor.getTableClassName() + ' td.error');
            var msg = _messageResource2.default.getMessage('rates.editor.work_schedule.day_value.error', [window.SystemSettings.decimalSeparator]) + '\n' + _messageResource2.default.getMessage('rates.editor.modifications_will_be_discarded');

            this.params.scrollTo($invalidWorkDayCell);

            (0, _UserPanelModalAlert.getInstance)().setState({
                text: msg,
                pointerPosition: _constants.ModalAlertPointerPosition.CENTER
            }).showAt($invalidWorkDayCell, function () {
                _this4.setState({ initialSchedule: _this4.state.initialSchedule });
            });
        }
    }]);

    return InitialScheduleRow;
}(_TemplateView3.default);

exports.default = InitialScheduleRow;

/***/ }),
/* 1651 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _Switcher = __webpack_require__(236);

var _Switcher2 = _interopRequireDefault(_Switcher);

var _ApproversDialogWrapper = __webpack_require__(1652);

var _ApproversDialogWrapper2 = _interopRequireDefault(_ApproversDialogWrapper);

var _pluralizeUtils = __webpack_require__(40);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TimeTrackApprovalSetting = function (_TemplateView) {
    _inherits(TimeTrackApprovalSetting, _TemplateView);

    function TimeTrackApprovalSetting($containerEl) {
        _classCallCheck(this, TimeTrackApprovalSetting);

        var _this = _possibleConstructorReturn(this, (TimeTrackApprovalSetting.__proto__ || Object.getPrototypeOf(TimeTrackApprovalSetting)).call(this, $containerEl));

        _this.updateOnInit = false;

        _this.state = {
            requiresTTApproval: null,
            nameGroup: null,
            editable: false,
            approvers: [],
            isUGREnabled: false,
            isTTAEnabled: false,
            loaded: false
        };

        _this.onStateChanged(function () {
            return _this.update();
        });

        _this.onStatePropertyChanged('loaded', function (loaded) {
            _this.timetrackApprovalCheckbox.setState({ animated: loaded });
        });
        return _this;
    }

    _createClass(TimeTrackApprovalSetting, [{
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='sectionHeader'><%=timetrack_approval_settings_header%></div>" + "<div class='timeTrackApprovalSetting'>" + "   <div class='sectionContent'>" + "      <table class='autoApprovalRow'>" + "        <tr>" + "          <td class='title'><%=button_title%></td>" + "          <td class='tumbler'></td>" + "          <td class='errorNote'></td>" + "          <td class='infoNote'></td>" + "          <td class='automaticApproveNote'><%=automatic_message%></td>" + "        </tr>" + "      </table>" + "   </div>" + "</div>";
        }
    }, {
        key: "messageKeys",
        value: function messageKeys() {
            return {
                button_title: 'user.edit.timetrack_settings.approval.button',
                timetrack_approval_settings_header: 'user.edit.timetrack_settings.approval.header',
                automatic_message: "user.edit.timetrack_settings.approval.auto_info"
            };
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            var _this2 = this;

            this.$error = this.find(".errorNote");
            this.$info = this.find(".infoNote");
            this.$tumbler = this.find(".tumbler");
            this.$auto = this.find(".automaticApproveNote");

            this.timetrackApprovalCheckbox = new _Switcher2.default({
                additionalClass: 'small',
                onSwitchCallback: function onSwitchCallback(isEnabled) {
                    return _this2.$tumbler.trigger("changed", isEnabled);
                }
            }).init(this.find(".tumbler"));

            this.approversDialog = new _ApproversDialogWrapper2.default().init(this.$containerEl);

            var self = this;
            this.$tumbler.on('changed', function (e, isEnabled) {
                if (self.state.requiresTTApproval !== isEnabled) {
                    self.setState({ requiresTTApproval: isEnabled });
                    self.trigger('changeApprovalState', [isEnabled]);
                }
            });

            this.$containerEl.toggle(this.state.isTTAEnabled);
        }
    }, {
        key: "update",
        value: function update() {
            var _this3 = this;

            this.$containerEl.toggle(this.state.isTTAEnabled);

            this.timetrackApprovalCheckbox.setState({
                enabled: this.state.requiresTTApproval,
                readOnly: !this.state.editable
            });

            this.$auto.hide();
            this.$error.hide();
            this.$info.hide();

            if (!this.state.editable) return;

            if (!this.state.requiresTTApproval) {
                this.$auto.show();
            } else if (!!this.state.approvers && this.state.approvers.length > 0) {
                var infoTitle = "\n<span class='firstPart'>" + _messageResource2.default.getMessage("user.edit.timetrack_settings.approval.info.title.first") + "</span>\n<span class='secondPart'>" + this.state.approvers.length + " " + (0, _pluralizeUtils.managerLower)(this.state.approvers.length) + "</span>\n";

                this.approversDialog.setState({
                    approvers: this.state.approvers
                });

                this.$info.html(infoTitle);

                var $secondPart = this.$info.find(".secondPart");

                $secondPart.click(function () {
                    _this3.approversDialog.showAt($secondPart, {
                        my: "center top",
                        at: "center bottom"
                    });
                    _this3.approversDialog.update();
                });

                this.$info.show();
            } else {
                this.$error.text(_messageResource2.default.getMessage("user.edit.timetrack_settings.approval.error.no_approvers"));
                this.$error.show();
            }
        }
    }]);

    return TimeTrackApprovalSetting;
}(_TemplateView3.default);

exports.default = TimeTrackApprovalSetting;

/***/ }),
/* 1652 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _DropdownDialogWithPointerWrapper = __webpack_require__(182);

var _DropdownDialogWithPointerWrapper2 = _interopRequireDefault(_DropdownDialogWithPointerWrapper);

var _ApproversDialog = __webpack_require__(1653);

var _ApproversDialog2 = _interopRequireDefault(_ApproversDialog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ApproversDialogWrapper = function (_DropdownDialogWithPo) {
    _inherits(ApproversDialogWrapper, _DropdownDialogWithPo);

    function ApproversDialogWrapper() {
        _classCallCheck(this, ApproversDialogWrapper);

        return _possibleConstructorReturn(this, (ApproversDialogWrapper.__proto__ || Object.getPrototypeOf(ApproversDialogWrapper)).call(this, {
            dialog: new _ApproversDialog2.default(),
            additionalClass: "approversDialogWrapper",
            dialogOffsets: {
                left: 45,
                top: 10
            }
        }));
    }

    return ApproversDialogWrapper;
}(_DropdownDialogWithPointerWrapper2.default);

exports.default = ApproversDialogWrapper;

/***/ }),
/* 1653 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _atUtils = __webpack_require__(5);

var _UserNameFormat = __webpack_require__(17);

var UserNameFormat = _interopRequireWildcard(_UserNameFormat);

var _ScrollUtils = __webpack_require__(39);

var _ScrollUtils2 = _interopRequireDefault(_ScrollUtils);

var _atBrowserUtils = __webpack_require__(8);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ApproversDialog = function (_TemplateView) {
    _inherits(ApproversDialog, _TemplateView);

    function ApproversDialog() {
        _classCallCheck(this, ApproversDialog);

        var _this = _possibleConstructorReturn(this, (ApproversDialog.__proto__ || Object.getPrototypeOf(ApproversDialog)).call(this));

        _this.state = {
            approvers: []
        };

        _this.onStatePropertyChanged("approvers", function (approvers) {
            _this._updateView(approvers);
        });
        return _this;
    }

    _createClass(ApproversDialog, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return "<div class='approversDialog'>" + "  <div class='text'><%-text%></div>" + "  <div class='managersListScrollableContainer'>" + "    <div class='managersList'></div>" + "  </div>" + "</div>";
        }
    }, {
        key: 'messageKeys',
        value: function messageKeys() {
            return {
                text: "user.timetrack_settings.approvers_dialog.managers_with_access_to_user"
            };
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            this.$managersList = this.find('.managersList');
            this.managersListScroll = _ScrollUtils2.default.addVerticalScroll(this.find('.managersListScrollableContainer'), {});
            (0, _atBrowserUtils.fixIScrollInnerWheelEvent)(this.find('.managersListScrollableContainer'));
        }
    }, {
        key: '_updateView',
        value: function _updateView(approvers) {
            var _html = "";
            for (var i = 0; i < approvers.length; ++i) {
                var userInfo = approvers[i];
                _html += "<div class='manager'><div class='name'>" + (0, _atUtils.escapeHtmlSymbols)(UserNameFormat.formatFML(userInfo.firstName, userInfo.lastName, userInfo.middleInitial)) + "</div></div>";
            }

            this.$managersList.html(_html);
        }
    }, {
        key: 'update',
        value: function update() {
            _get(ApproversDialog.prototype.__proto__ || Object.getPrototypeOf(ApproversDialog.prototype), 'update', this).call(this);
            _ScrollUtils2.default.refreshCustomScroll(this.managersListScroll);
        }
    }]);

    return ApproversDialog;
}(_TemplateView3.default);

exports.default = ApproversDialog;

/***/ }),
/* 1654 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _UserPanelContainer = __webpack_require__(149);

var _EditPanelUserRatesTable = __webpack_require__(1655);

var _EditPanelUserRatesTable2 = _interopRequireDefault(_EditPanelUserRatesTable);

var _CreatePanelUserRatesTable = __webpack_require__(1664);

var _CreatePanelUserRatesTable2 = _interopRequireDefault(_CreatePanelUserRatesTable);

var _LoadingContainer = __webpack_require__(28);

var _LoadingContainer2 = _interopRequireDefault(_LoadingContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UserRates = function (_TemplateView) {
    _inherits(UserRates, _TemplateView);

    function UserRates(_ref) {
        var id = _ref.id,
            mode = _ref.mode,
            _ref$scrollTo = _ref.scrollTo,
            scrollTo = _ref$scrollTo === undefined ? function () {} : _ref$scrollTo,
            _ref$refreshScrollCb = _ref.refreshScrollCb,
            refreshScrollCb = _ref$refreshScrollCb === undefined ? function () {} : _ref$refreshScrollCb,
            _ref$subscribeSelecto = _ref.subscribeSelectorOnScroll,
            subscribeSelectorOnScroll = _ref$subscribeSelecto === undefined ? function () {} : _ref$subscribeSelecto;

        _classCallCheck(this, UserRates);

        var _this = _possibleConstructorReturn(this, (UserRates.__proto__ || Object.getPrototypeOf(UserRates)).call(this));

        _this.id = id;
        _this.updateOnInit = false;
        _this.mode = mode;
        _this.scrollTo = scrollTo;

        _this.callbacks = {
            refreshScrollCb: refreshScrollCb,
            subscribeSelectorOnScroll: subscribeSelectorOnScroll
        };

        _this.state = {
            userManagementData: null,
            currentTime: null,
            rates: [],
            overtimeLevel: null,
            isURAEnabled: false,
            updating: false
        };

        _this.onStateChanged(function (state) {
            _this.state.rates = state.rates;
            _this.state.overtimeLevel = state.overtimeLevel;
            _this.update();
        });

        _this.onStatePropertyChanged('updating', function (loading) {
            return _this.loadingWrapper.setState({ loading: loading });
        });
        return _this;
    }

    _createClass(UserRates, [{
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='userRates'>" + "    <div class='sectionHeader'><%=cost_of_work_rates%></div>" + "    <div class='userRatesSection'>" + "    </div>" + "</div>";
        }
    }, {
        key: "messageKeys",
        value: function messageKeys() {
            return {
                cost_of_work_rates: 'userlist.userdata.schedule.cost_of_work_rates'
            };
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            this.userRatesTable = this.mode === _UserPanelContainer.MODE.EDIT ? new _EditPanelUserRatesTable2.default({
                readOnly: false,
                scrollTo: this.scrollTo,
                refreshScrollCb: this.callbacks.refreshScrollCb,
                subscribeSelectorOnScroll: this.callbacks.subscribeSelectorOnScroll
            }) : new _CreatePanelUserRatesTable2.default({
                readOnly: false,
                scrollTo: this.scrollTo,
                refreshScrollCb: this.callbacks.refreshScrollCb
            });

            this.loadingWrapper = new _LoadingContainer2.default({
                contentComponent: this.userRatesTable,
                proxySetState: false,
                loadingMoireConfig: {
                    delay: 500
                }
            }).init(this.find('.userRatesSection'));

            this.registerChildComponents(this.userRatesTable);
        }
    }]);

    return UserRates;
}(_TemplateView3.default);

exports.default = UserRates;

/***/ }),
/* 1655 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.EditPanelUserRatesTable = undefined;

var _utils = __webpack_require__(6);

var _selectors = __webpack_require__(257);

var _actions = __webpack_require__(551);

var _redux = __webpack_require__(7);

var _selectors2 = __webpack_require__(15);

var _UserRatesTable2 = __webpack_require__(874);

var _selectors3 = __webpack_require__(556);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EditPanelUserRatesTable = exports.EditPanelUserRatesTable = function (_UserRatesTable) {
    _inherits(EditPanelUserRatesTable, _UserRatesTable);

    function EditPanelUserRatesTable(_ref) {
        var readOnly = _ref.readOnly,
            _ref$scrollTo = _ref.scrollTo,
            scrollTo = _ref$scrollTo === undefined ? function () {} : _ref$scrollTo,
            _ref$updateUserRates = _ref.updateUserRates,
            updateUserRates = _ref$updateUserRates === undefined ? function () {} : _ref$updateUserRates,
            _ref$deleteUserRate = _ref.deleteUserRate,
            deleteUserRate = _ref$deleteUserRate === undefined ? function () {} : _ref$deleteUserRate,
            _ref$addNewUserRate = _ref.addNewUserRate,
            addNewUserRate = _ref$addNewUserRate === undefined ? function () {} : _ref$addNewUserRate,
            _ref$rollbackLastEdit = _ref.rollbackLastEditedUserRateChanges,
            rollbackLastEditedUserRateChanges = _ref$rollbackLastEdit === undefined ? function () {} : _ref$rollbackLastEdit,
            _ref$refreshScrollCb = _ref.refreshScrollCb,
            refreshScrollCb = _ref$refreshScrollCb === undefined ? function () {} : _ref$refreshScrollCb,
            _ref$subscribeSelecto = _ref.subscribeSelectorOnScroll,
            subscribeSelectorOnScroll = _ref$subscribeSelecto === undefined ? function () {} : _ref$subscribeSelecto;

        _classCallCheck(this, EditPanelUserRatesTable);

        return _possibleConstructorReturn(this, (EditPanelUserRatesTable.__proto__ || Object.getPrototypeOf(EditPanelUserRatesTable)).call(this, {
            readOnly: readOnly,
            editMode: true,
            scrollTo: scrollTo,
            updateUserRates: updateUserRates,
            deleteUserRate: deleteUserRate,
            addNewUserRate: addNewUserRate,
            rollbackLastEditedUserRateChanges: rollbackLastEditedUserRateChanges,
            refreshScrollCb: refreshScrollCb,
            subscribeSelectorOnScroll: subscribeSelectorOnScroll
        }));
    }

    return EditPanelUserRatesTable;
}(_UserRatesTable2.UserRatesTable);

exports.default = (0, _utils.connect)(function (state) {
    return {
        userManagementData: (0, _selectors.getUserManagementDataForUserRates)(state),
        userRates: (0, _selectors.getUserRates)(state),
        overtimeLevel: (0, _selectors.getOvertimeLevel)(state),
        ovrFeatureEnabled: (0, _selectors2.isOVREnabled)(state),
        lvtFeatureEnabled: (0, _selectors2.isLVTEnabled)(state),
        readOnly: (0, _selectors3.isUserRatesReadOnly)(state),
        errors: (0, _selectors.getErrors)(state)
    };
}, function (dispatch) {
    return {
        updateUserRates: (0, _redux.bindActionCreators)(_actions.updateUserRates, dispatch),
        deleteUserRate: (0, _redux.bindActionCreators)(_actions.deleteUserRate, dispatch),
        addNewUserRate: (0, _redux.bindActionCreators)(_actions.addNewUserRate, dispatch),
        rollbackLastEditedUserRateChanges: (0, _redux.bindActionCreators)(_actions.rollbackLastEditedUserRateChanges, dispatch)
    };
})(EditPanelUserRatesTable);

/***/ }),
/* 1656 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TableHeader = function (_TemplateView) {
    _inherits(TableHeader, _TemplateView);

    function TableHeader() {
        _classCallCheck(this, TableHeader);

        var _this = _possibleConstructorReturn(this, (TableHeader.__proto__ || Object.getPrototypeOf(TableHeader)).call(this));

        _this.state = {
            showOvertime: false,
            showLeave: false
        };

        _this.onStatePropertyChanged('showOvertime', function (showOvertime) {
            return _this.$overtimeRateColumn.toggle(showOvertime);
        });
        _this.onStatePropertyChanged('showLeave', function (showLeave) {
            return _this.$leaveRatesColumn.toggle(showLeave);
        });
        return _this;
    }

    _createClass(TableHeader, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class="userRatesTableHeader">' + '    <div class="regularRateColumn headerColumn"><%-regularRate%></div>' + '    <div class="overtimeRateColumn headerColumn"><%-overtimeRate%></div>' + '    <div class="leaveRatesColumn headerColumn"><%-leaveRates%></div>' + '</div>';
        }
    }, {
        key: 'messageKeys',
        value: function messageKeys() {
            return {
                regularRate: 'user.add_edit.js.rates_editor.regular_rate_column_title',
                overtimeRate: 'user.add_edit.js.rates_editor.overtime_rate_column_title',
                leaveRates: 'user.add_edit.js.rates_editor.leave_rates_column_title'
            };
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            this.$overtimeRateColumn = this.find('.overtimeRateColumn');
            this.$leaveRatesColumn = this.find('.leaveRatesColumn');

            this.renderInitialState();
        }
    }]);

    return TableHeader;
}(_TemplateView3.default);

exports.default = TableHeader;

/***/ }),
/* 1657 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _EffectiveDateCell = __webpack_require__(871);

var _EffectiveDateCell2 = _interopRequireDefault(_EffectiveDateCell);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _DeleteConfirmationCell = __webpack_require__(872);

var _DeleteConfirmationCell2 = _interopRequireDefault(_DeleteConfirmationCell);

var _RateCell = __webpack_require__(1658);

var _RateCell2 = _interopRequireDefault(_RateCell);

var _LeaveRatesCell = __webpack_require__(1659);

var _LeaveRatesCell2 = _interopRequireDefault(_LeaveRatesCell);

var _validationUtils = __webpack_require__(205);

var _FloatNumberValidator = __webpack_require__(314);

var _FloatNumberValidator2 = _interopRequireDefault(_FloatNumberValidator);

var _constants = __webpack_require__(206);

var _constants2 = __webpack_require__(21);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UserRatesRow = function (_TemplateView) {
    _inherits(UserRatesRow, _TemplateView);

    function UserRatesRow(_ref) {
        var _ref$readOnly = _ref.readOnly,
            readOnly = _ref$readOnly === undefined ? false : _ref$readOnly,
            _ref$scrollTo = _ref.scrollTo,
            scrollTo = _ref$scrollTo === undefined ? function () {} : _ref$scrollTo,
            activeLeaveTypes = _ref.activeLeaveTypes,
            _ref$onChangeCb = _ref.onChangeCb,
            onChangeCb = _ref$onChangeCb === undefined ? function () {} : _ref$onChangeCb,
            _ref$onDeleteCb = _ref.onDeleteCb,
            onDeleteCb = _ref$onDeleteCb === undefined ? function () {} : _ref$onDeleteCb,
            _ref$rollbackLastEdit = _ref.rollbackLastEditedUserRateChanges,
            rollbackLastEditedUserRateChanges = _ref$rollbackLastEdit === undefined ? function () {} : _ref$rollbackLastEdit,
            _ref$subscribeSelecto = _ref.subscribeSelectorOnScroll,
            subscribeSelectorOnScroll = _ref$subscribeSelecto === undefined ? function () {} : _ref$subscribeSelecto,
            leaveRatesMenu = _ref.leaveRatesMenu;

        _classCallCheck(this, UserRatesRow);

        var _this = _possibleConstructorReturn(this, (UserRatesRow.__proto__ || Object.getPrototypeOf(UserRatesRow)).call(this));

        _this.activeLeaveTypes = activeLeaveTypes;

        _this.params = {
            readOnly: readOnly,
            scrollTo: scrollTo,
            leaveRatesMenu: leaveRatesMenu
        };

        _this.callbacks = {
            onChangeCb: onChangeCb,
            onDeleteCb: onDeleteCb,
            rollbackLastEditedUserRateChanges: rollbackLastEditedUserRateChanges,
            subscribeSelectorOnScroll: subscribeSelectorOnScroll
        };

        _this.state = {
            rate: {
                rateId: null,
                effectiveDate: null,
                regularRate: null,
                overtimeRate: null,
                leaveRates: null
            },

            overtimeEnabled: false,
            leavesEnabled: false,
            activeLeaveTypes: [],
            overtimeRateCoefficient: 0,
            invertedDays: null,
            weekStartDay: 0,
            defaultWorkSchedule: [],
            effective: false,
            duplicateDate: false,
            error: {}
        };

        _this.onStateChanged(function () {
            return _this._update();
        });

        _this.onStatePropertyDeeplyChanged('error', function (error) {
            return _this._updateError(error);
        });
        return _this;
    }

    _createClass(UserRatesRow, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class="userRatesRow">' + '    <div class="userRates">' + '        <div class="effectiveDateCellPlaceholder preventPanelsHiding"/>' + '        <div class="regularRateColumn"/>' + '        <div class="overtimeRateColumn"/>' + '        <div class="leaveRatesColumn"/>' + '        <div class="deleteButtonCell">' + '            <div class="deleteIcon"/>' + '        </div>' + '    </div>' + '    <div class="deleteConfirmationContainer"/>' + '</div>';
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            var _this2 = this;

            this.$userRates = this.find('.userRates');

            this.effectiveDate = new _EffectiveDateCell2.default({
                dateFromLabel: _messageResource2.default.getMessage('user.add_edit.js.rates_editor.effective_form.edit'),
                scrollTo: this.params.scrollTo,
                onChangeCb: function onChangeCb(effectiveDate) {
                    return _this2._handleRatesChanged({ effectiveDate: effectiveDate });
                },
                rollbackChanges: this.callbacks.rollbackLastEditedUserRateChanges,
                subscribeSelectorOnScroll: this.callbacks.subscribeSelectorOnScroll,
                readOnly: this.params.readOnly
            }).init(this.find('.effectiveDateCellPlaceholder'));

            this.regularRate = new _RateCell2.default({
                readOnly: this.params.readOnly,
                scrollTo: this.params.scrollTo,
                onChangeCb: function onChangeCb(regularRate) {
                    return _this2._handleRegularRateChanged(regularRate);
                },
                rollbackChanges: this.callbacks.rollbackLastEditedUserRateChanges
            }).init(this.find('.regularRateColumn'));

            this.$overtimeRateColumn = this.find('.overtimeRateColumn');

            this.overtimeRate = new _RateCell2.default({
                readOnly: this.params.readOnly,
                scrollTo: this.params.scrollTo,
                onChangeCb: function onChangeCb(overtimeRate) {
                    return _this2._handleRatesChanged({ overtimeRate: overtimeRate });
                },
                rollbackChanges: this.callbacks.rollbackLastEditedUserRateChanges
            }).init(this.$overtimeRateColumn);

            this.$leaveRatesColumn = this.find('.leaveRatesColumn');

            if (this.params.readOnly) {
                this.find('.deleteButtonCell').hide();
            } else {
                this.find('.deleteIcon').click(function (e) {
                    e.stopPropagation();

                    if (_this2.state.rate.rateId === -1) {
                        _this2.callbacks.onDeleteCb({ removePermanently: true });
                    } else {
                        _this2._toggleDeleteConfirmation(true);
                    }
                });

                this.$deleteConfirmationContainer = this.find('.deleteConfirmationContainer').hide();
            }
        }
    }, {
        key: '_update',
        value: function _update() {
            var _this3 = this;

            this.$userRates.toggleClass('effective', this.state.effective);

            this.effectiveDate.setState({
                invertedDays: this.state.invertedDays,
                weekStartDay: this.state.weekStartDay,
                defaultWorkSchedule: this.state.defaultWorkSchedule,
                date: this.state.rate.effectiveDate,
                effective: this.state.effective
            });

            this.regularRate.setState({
                rate: this.state.rate.regularRate
            });

            this.$overtimeRateColumn.toggle(this.state.overtimeEnabled);

            if (this.state.overtimeEnabled) {
                this.overtimeRate.setState({
                    rate: this.state.rate.overtimeRate
                });
            }

            this.$leaveRatesColumn.toggle(this.state.leavesEnabled && this.state.activeLeaveTypes.length > 0);

            if (this.state.leavesEnabled && this.state.activeLeaveTypes.length > 0) {
                this.$leaveRatesColumn.empty();

                this.leaveRates = new _LeaveRatesCell2.default({
                    readOnly: this.params.readOnly,
                    scrollTo: this.params.scrollTo,
                    activeLeaveTypes: this.state.activeLeaveTypes,
                    onChangeCb: function onChangeCb(leaveRates) {
                        return _this3._handleRatesChanged({ leaveRates: leaveRates });
                    },
                    rollbackChanges: this.callbacks.rollbackLastEditedUserRateChanges,
                    subscribeSelectorOnScroll: this.callbacks.subscribeSelectorOnScroll,
                    leaveRatesMenu: this.params.leaveRatesMenu
                }).init(this.$leaveRatesColumn);

                this.leaveRates.setState({
                    regularRate: this.state.rate.regularRate,
                    leaveRates: this.state.rate.leaveRates,
                    isEmptyValid: (0, _validationUtils.isRateEmpty)(this.state.rate, this.state.overtimeEnabled, this.state.leavesEnabled)
                });
            }

            this._updateError(this.state.error);
        }
    }, {
        key: '_handleRegularRateChanged',
        value: function _handleRegularRateChanged(regularRate) {
            this.callbacks.onChangeCb(this._fillRatesIfNeeded(regularRate));
        }
    }, {
        key: '_fillRatesIfNeeded',
        value: function _fillRatesIfNeeded(regularRate) {
            var rates = _extends({}, this.state.rate, {
                regularRate: regularRate
            });

            if ((0, _validationUtils.isValueEmpty)(regularRate) || !_FloatNumberValidator2.default.getInstance().isValidNumber(regularRate)) {
                return rates;
            }

            if (this.state.overtimeEnabled && (0, _validationUtils.isValueEmpty)(this.state.rate.overtimeRate)) {
                rates.overtimeRate = regularRate * this.state.overtimeRateCoefficient;
            }

            if (this.state.leavesEnabled && this.state.activeLeaveTypes.length > 0 && (0, _validationUtils.isLeaveRatesEmpty)(this.state.rate.leaveRates)) {
                rates.leaveRates = this.state.activeLeaveTypes.map(function (lt) {
                    return { leaveTypeId: lt.id, rate: regularRate * lt.rateCoefficient };
                });
            }

            return rates;
        }
    }, {
        key: '_handleRatesChanged',
        value: function _handleRatesChanged(changes) {
            this.callbacks.onChangeCb(_extends({}, this.state.rate, changes));
        }
    }, {
        key: '_updateError',
        value: function _updateError(error) {
            this.effectiveDate.setState({
                error: !!error[_constants.UserRatesErrors.EFFECTIVE_DATE_EMPTY] ? _constants.UserRatesErrors.EFFECTIVE_DATE_EMPTY : !!error[_constants2.ValidationErrors.DUPLICATED_EFFECTIVE_DATE] ? _constants2.ValidationErrors.DUPLICATED_EFFECTIVE_DATE : null,
                needShowWarning: error.showWarning === _constants.ShowWarning.EFFECTIVE_DATE_WARNING
            });

            this.regularRate.setState({
                error: !!error[_constants.UserRatesErrors.REGULAR_RATE_EMPTY] ? _constants.UserRatesErrors.RATE_EMPTY : !!error[_constants.UserRatesErrors.REGULAR_RATE_INVALID] ? _constants.UserRatesErrors.RATE_INVALID : null,
                needShowWarning: error.showWarning === _constants.ShowWarning.REGULAR_RATE_WARNING
            });

            if (this.state.overtimeEnabled) {
                var isEmpty = (0, _validationUtils.isRateValid)(this.state.rate.regularRate) && (0, _validationUtils.isValueEmpty)(this.state.rate.overtimeRate) || !!error[_constants.UserRatesErrors.OVERTIME_RATE_EMPTY];
                this.overtimeRate.setState({
                    error: isEmpty ? _constants.UserRatesErrors.RATE_EMPTY : !!error[_constants.UserRatesErrors.OVERTIME_RATE_INVALID] ? _constants.UserRatesErrors.RATE_INVALID : null,
                    needShowWarning: error.showWarning === _constants.ShowWarning.OVERTIME_RATE_WARNING
                });
            }

            if (this.state.leavesEnabled && this.state.activeLeaveTypes.length > 0) {
                var _isEmpty = (0, _validationUtils.isRateValid)(this.state.rate.regularRate) && (0, _validationUtils.isLeaveRatesEmpty)(this.state.rate.leaveRates) || !!error[_constants.UserRatesErrors.LEAVE_RATES_EMPTY];
                this.leaveRates.setState({
                    error: _isEmpty ? _constants.UserRatesErrors.RATE_EMPTY : !!error[_constants.UserRatesErrors.LEAVE_RATES_INVALID] ? _constants.UserRatesErrors.RATE_INVALID : null,
                    needShowWarning: error.showWarning === _constants.ShowWarning.LEAVE_RATES_WARNING
                });
            }
        }
    }, {
        key: '_toggleDeleteConfirmation',
        value: function _toggleDeleteConfirmation(show) {
            var _this4 = this;

            this.$userRates.toggle(!show);
            this.$deleteConfirmationContainer.toggle(show);

            if (show) {
                new _DeleteConfirmationCell2.default({
                    deleteMessageKey: 'userlist.userdata.effective_date_row_delete_confirmation',
                    onConfirm: function onConfirm() {
                        return _this4.callbacks.onDeleteCb({ removePermanently: false });
                    },
                    onCancel: function onCancel() {
                        return _this4._toggleDeleteConfirmation(false);
                    }
                }).init(this.find('.deleteConfirmationContainer'));
            } else {
                this.find('.deleteConfirmationContainer').empty();
            }
        }
    }]);

    return UserRatesRow;
}(_TemplateView3.default);

exports.default = UserRatesRow;

/***/ }),
/* 1658 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _atUtils = __webpack_require__(5);

var _validationUtils = __webpack_require__(205);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _constants = __webpack_require__(4);

var _atBrowserUtils = __webpack_require__(8);

var _number_formatter = __webpack_require__(61);

var _number_formatter2 = _interopRequireDefault(_number_formatter);

var _UserPanelModalAlert = __webpack_require__(209);

var _constants2 = __webpack_require__(110);

var _constants3 = __webpack_require__(206);

var _FloatNumberValidator = __webpack_require__(314);

var _FloatNumberValidator2 = _interopRequireDefault(_FloatNumberValidator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var numberFormatter = new _number_formatter2.default(window.SystemSettings.decimalSeparator, window.SystemSettings.digitGroupingSymbol, 4, false, undefined, undefined, undefined, 2);

var RateCell = function (_TemplateView) {
    _inherits(RateCell, _TemplateView);

    function RateCell(_ref) {
        var _ref$readOnly = _ref.readOnly,
            readOnly = _ref$readOnly === undefined ? false : _ref$readOnly,
            _ref$scrollTo = _ref.scrollTo,
            scrollTo = _ref$scrollTo === undefined ? function () {} : _ref$scrollTo,
            _ref$onChangeCb = _ref.onChangeCb,
            onChangeCb = _ref$onChangeCb === undefined ? function () {} : _ref$onChangeCb,
            _ref$rollbackChanges = _ref.rollbackChanges,
            rollbackChanges = _ref$rollbackChanges === undefined ? function () {} : _ref$rollbackChanges;

        _classCallCheck(this, RateCell);

        var _this = _possibleConstructorReturn(this, (RateCell.__proto__ || Object.getPrototypeOf(RateCell)).call(this));

        _this.params = {
            readOnly: readOnly,
            scrollTo: scrollTo
        };

        _this.callbacks = {
            onChangeCb: onChangeCb,
            rollbackChanges: rollbackChanges
        };

        _this.state = {
            rate: null,
            isEmptyValid: true,
            error: null,
            needShowWarning: false
        };

        _this.onAnyStatePropertyChanged(['rate'], function (state) {
            return _this._update(state);
        });
        _this.onStatePropertyChanged('error', function (error) {
            return _this._updateError(error);
        });
        _this.onStatePropertyBecameTrue('needShowWarning', function () {
            return _this._showWarning(_this.state.rate);
        });
        return _this;
    }

    _createClass(RateCell, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class="rateCell">' + '    <input type="text" placeholder="<%=placeholder%>" maxlength="8"/>' + '    <div class="clearButton"></div>' + '    <div class="rateLabel"></div>' + '</div>';
        }
    }, {
        key: 'templateModel',
        value: function templateModel() {
            return {
                placeholder: '0' + window.SystemSettings.decimalSeparator + '00'
            };
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            var _this2 = this;

            this.$input = this.find('input');
            this.$rateLabel = this.find('.rateLabel');
            this.$clearButton = this.find('.clearButton');

            if (!this.params.readOnly) {
                this.$input.on('input', function () {
                    return _this2._handleInputChange();
                }).on('blur', function () {
                    return _this2._handleInputBlur();
                }).on('focus', function () {
                    return _this2._handleInputChange();
                }).on('keydown', function (e) {
                    return _this2._handleKeyDown(e);
                });

                this.$clearButton.mousedown(function (e) {
                    return e.preventDefault();
                });

                this.$clearButton.click(function () {
                    if (!_this2.params.readOnly) _this2.$input.val('').focus();
                });
            }

            this.$input.toggle(!this.params.readOnly);
            this.$rateLabel.toggle(this.params.readOnly);
        }
    }, {
        key: '_update',
        value: function _update(state) {
            var rate = state.rate;

            if (!this.params.readOnly) {
                this.$input.val(_FloatNumberValidator2.default.getInstance().isValidNumber(rate) ? numberFormatter.format(rate) : rate);
            } else {
                this.$rateLabel.text(_FloatNumberValidator2.default.getInstance().isValidNumber(rate) ? numberFormatter.format(rate) : rate);
            }

            this._updateError(state.error);
        }
    }, {
        key: '_updateError',
        value: function _updateError(error) {
            var isValid = error === null;
            this.getEl().toggleClass('invalid', !isValid);

            if (!isValid) {
                var msg = error === _constants3.UserRatesErrors.RATE_EMPTY ? _messageResource2.default.getMessage('user.add_edit.js.rates_editor.empty_rate') : error === _constants3.UserRatesErrors.RATE_INVALID ? _messageResource2.default.getMessage('user.add_edit.js.rates_editor.invalid_rate', [_constants.MAX_RATE]) : "";
                this.$input.attr('title', msg);
            }
        }
    }, {
        key: '_handleInputChange',
        value: function _handleInputChange() {
            var value = (0, _atUtils.trim)(this.$input.val());
            this.$clearButton.toggle(value.length > 0);
        }
    }, {
        key: '_handleInputBlur',
        value: function _handleInputBlur() {
            this.$clearButton.hide();
            this._handleRateChanged();
        }
    }, {
        key: '_handleKeyDown',
        value: function _handleKeyDown(e) {
            if ((0, _atBrowserUtils.isEscapePressed)(e) || (0, _atBrowserUtils.isEnterPressed)(e)) {
                this._handleInputBlur();
                e.stopPropagation();
            }
        }
    }, {
        key: '_handleRateChanged',
        value: function _handleRateChanged() {
            var value = numberFormatter.normalize((0, _atUtils.trim)(this.$input.val()));
            this.$input.val(value);

            if (value.length === 0 && (0, _validationUtils.isValueEmpty)(this.state.rate) || value == this.state.rate) {
                this.$input.val(numberFormatter.format(value));
                return;
            }

            var isValid = value.length > 0 && _FloatNumberValidator2.default.getInstance().isValidNumber(value);
            this.callbacks.onChangeCb(isValid ? Number(numberFormatter.normalize(value)) : value);
        }
    }, {
        key: '_showWarning',
        value: function _showWarning(value) {
            var _this3 = this;

            var msg = value.length === 0 ? _messageResource2.default.getMessage('user.add_edit.js.rates_editor.empty_rate') : _messageResource2.default.getMessage('user.add_edit.js.rates_editor.invalid_rate', [_constants.MAX_RATE]);
            msg = msg + '\n' + _messageResource2.default.getMessage('rates.editor.modifications_will_be_discarded');

            this.params.scrollTo(this.getEl());

            (0, _UserPanelModalAlert.getInstance)().setState({
                text: msg,
                pointerPosition: _constants2.ModalAlertPointerPosition.CENTER
            }).showAt(this.getEl(), function () {
                _this3.callbacks.rollbackChanges();
            });
        }
    }]);

    return RateCell;
}(_TemplateView3.default);

exports.default = RateCell;

/***/ }),
/* 1659 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _LeaveRatesEditor = __webpack_require__(1660);

var _LeaveRatesEditor2 = _interopRequireDefault(_LeaveRatesEditor);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _validationUtils = __webpack_require__(205);

var _FloatNumberValidator = __webpack_require__(314);

var _FloatNumberValidator2 = _interopRequireDefault(_FloatNumberValidator);

var _number_formatter = __webpack_require__(61);

var _number_formatter2 = _interopRequireDefault(_number_formatter);

var _constants = __webpack_require__(4);

var _UserPanelModalAlert = __webpack_require__(209);

var _constants2 = __webpack_require__(110);

var _constants3 = __webpack_require__(206);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var numberFormatter = new _number_formatter2.default(window.SystemSettings.decimalSeparator, window.SystemSettings.digitGroupingSymbol, 4, false, undefined, undefined, undefined, 2);

var LeaveRatesCell = function (_TemplateView) {
    _inherits(LeaveRatesCell, _TemplateView);

    function LeaveRatesCell(_ref) {
        var _ref$readOnly = _ref.readOnly,
            readOnly = _ref$readOnly === undefined ? false : _ref$readOnly,
            _ref$scrollTo = _ref.scrollTo,
            scrollTo = _ref$scrollTo === undefined ? function () {} : _ref$scrollTo,
            activeLeaveTypes = _ref.activeLeaveTypes,
            _ref$onChangeCb = _ref.onChangeCb,
            onChangeCb = _ref$onChangeCb === undefined ? function () {} : _ref$onChangeCb,
            _ref$rollbackChanges = _ref.rollbackChanges,
            rollbackChanges = _ref$rollbackChanges === undefined ? function () {} : _ref$rollbackChanges,
            _ref$subscribeSelecto = _ref.subscribeSelectorOnScroll,
            subscribeSelectorOnScroll = _ref$subscribeSelecto === undefined ? function () {} : _ref$subscribeSelecto,
            leaveRatesMenu = _ref.leaveRatesMenu;

        _classCallCheck(this, LeaveRatesCell);

        var _this = _possibleConstructorReturn(this, (LeaveRatesCell.__proto__ || Object.getPrototypeOf(LeaveRatesCell)).call(this));

        _this.activeLeaveTypes = activeLeaveTypes;

        _this.params = {
            readOnly: readOnly,
            scrollTo: scrollTo,
            leaveRatesMenu: leaveRatesMenu
        };

        _this.callbacks = {
            onChangeCb: onChangeCb,
            rollbackChanges: rollbackChanges,
            subscribeSelectorOnScroll: subscribeSelectorOnScroll
        };

        _this.state = {
            regularRate: null,
            leaveRates: [],
            isEmptyValid: false,
            error: null,
            needShowWarning: false
        };

        _this.onAnyStatePropertyChanged(['regularRate', 'leaveRates', 'isEmptyValid'], function (state) {
            _this._updateView(state.leaveRates, state.regularRate, state.isEmptyValid);
        });
        _this.onStatePropertyChanged('error', function (error) {
            return _this._updateLeaveRatesText(_this.state.leaveRates, error);
        });
        _this.onStatePropertyBecameTrue('needShowWarning', function () {
            return _this._showWarning(_this.state.error);
        });
        return _this;
    }

    _createClass(LeaveRatesCell, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class="leaveRatesCell">' + '    <div class="leaveRatesEditorPlaceholder"/>' + '    <div class="leaveRatesLabel"/>' + '</div>';
        }
    }, {
        key: 'templateModel',
        value: function templateModel() {
            return {
                placeholder: '0' + window.SystemSettings.decimalSeparator + '00'
            };
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            this.$leavesEditor = this.find('.leaveRatesEditorPlaceholder');
            this.$leavesRatesLabel = this.find('.leaveRatesLabel');
        }
    }, {
        key: '_updateView',
        value: function _updateView(leaveRates, regularRate, isEmptyValid) {
            if (!this.params.readOnly) {
                this._updateLeavesEditor(leaveRates, regularRate, isEmptyValid);
            } else {
                this.$leavesEditor.empty();
            }
        }
    }, {
        key: '_updateLeavesEditor',
        value: function _updateLeavesEditor(leaveRates, regularRate, isEmptyValid) {
            var _this2 = this;

            this.$leavesEditor.empty();
            this.$leavesRatesLabel.hide();

            this.leaveRatesEditor = new _LeaveRatesEditor2.default({
                menu: this.params.leaveRatesMenu,
                renderTo: this.$leavesEditor[0],
                value: leaveRates,
                menuAlign: "br-tr"
            });

            this.leaveRatesEditor.on("menushow", function () {
                _this2.getEl().toggleClass('leavesEditorOpened', true);
                _this2.leaveRatesEditor.menu.setUp(leaveRates, regularRate, isEmptyValid && _this2.state.error === null);
            });

            this.leaveRatesEditor.on("menuhide", function () {
                _this2.getEl().toggleClass('leavesEditorOpened', false);
            });

            this.leaveRatesEditor.on("change", function (leaveRates) {
                return _this2._handleRatesChanged(leaveRates);
            });

            this._updateLeaveRatesText(leaveRates, this.state.error);
        }
    }, {
        key: '_updateLeaveRatesText',
        value: function _updateLeaveRatesText(leaveRates, error) {
            var isEmpty = (0, _validationUtils.isLeaveRatesEmpty)(leaveRates);
            this.getEl().toggleClass('empty', isEmpty);

            if (isEmpty) {
                this._setLeavesRatesText(_messageResource2.default.getMessage("user.add_edit.js.rates_editor.leave_rates.not_defined"), error === _constants3.UserRatesErrors.RATE_EMPTY);
            } else if (error === _constants3.UserRatesErrors.RATE_INVALID) {
                this._setLeavesRatesText(_messageResource2.default.getMessage("user.add_edit.js.rates_editor.leave_rates.invalid"), true);
            } else {
                var rates = leaveRates.map(function (lr) {
                    return _FloatNumberValidator2.default.getInstance().parseFloat(lr.rate);
                });
                var minRate = Math.min.apply(Math, _toConsumableArray(rates));
                var maxRate = Math.max.apply(Math, _toConsumableArray(rates));

                if (minRate === maxRate) this._setLeavesRatesText(numberFormatter.format(minRate), false);else this._setLeavesRatesText(numberFormatter.format(minRate) + " - " + numberFormatter.format(maxRate), false);
            }
        }
    }, {
        key: '_setLeavesRatesText',
        value: function _setLeavesRatesText(text, invalid) {
            if (this.params.readOnly) {
                this.$leavesRatesLabel.text(text);
            } else {
                this.leaveRatesEditor.setText(text);
                this.getEl().toggleClass('invalid', invalid);
            }
        }
    }, {
        key: '_handleRatesChanged',
        value: function _handleRatesChanged(leaveRates) {
            var normalizedRates = leaveRates.map(function (leaveRate) {
                return _extends({}, leaveRate, {
                    rate: numberFormatter.normalize(leaveRate.rate)
                });
            });
            this.callbacks.onChangeCb(normalizedRates);
        }
    }, {
        key: '_showWarning',
        value: function _showWarning(error) {
            var _this3 = this;

            var msg = error === _constants3.UserRatesErrors.RATE_EMPTY ? _messageResource2.default.getMessage('user.add_edit.js.rates_editor.empty_rate') : _messageResource2.default.getMessage('user.add_edit.js.rates_editor.invalid_rate', [_constants.MAX_RATE]);
            msg = msg + '\n' + _messageResource2.default.getMessage('rates.editor.modifications_will_be_discarded');

            this.params.scrollTo(this.getEl());

            (0, _UserPanelModalAlert.getInstance)().setState({
                text: msg,
                pointerPosition: _constants2.ModalAlertPointerPosition.RIGHT
            }).showAt(this.getEl(), function () {
                _this3.callbacks.rollbackChanges();
            });
        }
    }]);

    return LeaveRatesCell;
}(_TemplateView3.default);

exports.default = LeaveRatesCell;

/***/ }),
/* 1660 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _abstract_dropdown_button = __webpack_require__(233);

var _abstract_dropdown_button2 = _interopRequireDefault(_abstract_dropdown_button);

var _Ext = __webpack_require__(12);

var _Ext2 = _interopRequireDefault(_Ext);

var _number_formatter = __webpack_require__(61);

var _number_formatter2 = _interopRequireDefault(_number_formatter);

var _validationUtils = __webpack_require__(205);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var numberFormatter = new _number_formatter2.default(window.SystemSettings.decimalSeparator, null, 4, false, undefined, undefined, undefined, 2);

var LeaveRatesEditor = _Ext2.default.extend(_abstract_dropdown_button2.default, {

    value: null,

    initComponent: function initComponent() {
        this.cls = "at-dropdown-list-btn";
        this.ctCls = "at-dropdown-list-btn-ct";

        LeaveRatesEditor.superclass.initComponent.call(this);

        this.addEvents("change");
    },

    showMenu: function showMenu() {
        this.menu.setActivatedButton(this);
        return LeaveRatesEditor.superclass.showMenu.call(this);
    },

    onOk: function onOk() {
        this.menu.hide();
    },

    onCancel: function onCancel() {
        this.menu.hide();
    },

    onMenuShow: function onMenuShow(menu) {
        if (this.menu.getActivatedButton() === this) LeaveRatesEditor.superclass.onMenuShow.call(this, menu);
    },

    onMenuHide: function onMenuHide(menu) {
        if (this.menu.getActivatedButton() === this) {
            LeaveRatesEditor.superclass.onMenuHide.call(this, menu);
            this.menu.setActivatedButton(null);
            if (!this.menu.wasCanceled()) {
                var oldValue = this.value;
                this.value = this.menu.getLeaveRates();
                if (!this.areEqual(this.value, oldValue)) this.fireEvent("change", this.value);
            }
        }
    },

    areEqual: function areEqual(leaveRates1, leaveRates2) {
        if (leaveRates1 == null || leaveRates2 == null) return leaveRates1 == leaveRates2;

        if ((0, _validationUtils.isLeaveRatesEmpty)(leaveRates1) && (0, _validationUtils.isLeaveRatesEmpty)(leaveRates2)) return true;

        for (var i1 = 0; i1 < leaveRates1.length; i1++) {
            var lr1 = leaveRates1[i1];
            var lr2 = null;
            for (var i2 = 0; i2 < leaveRates2.length; i2++) {
                if (leaveRates2[i2].leaveTypeId == lr1.leaveTypeId) {
                    lr2 = leaveRates2[i2];
                    break;
                }
            }

            if (!lr2 || numberFormatter.format(lr2.rate) !== numberFormatter.format(lr1.rate)) return false;
        }

        return true;
    }
});

exports.default = LeaveRatesEditor;

/***/ }),
/* 1661 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Ext = __webpack_require__(12);

var _Ext2 = _interopRequireDefault(_Ext);

var _LeaveRatesEditorItem = __webpack_require__(1662);

var _LeaveRatesEditorItem2 = _interopRequireDefault(_LeaveRatesEditorItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LeaveRatesMenu = function LeaveRatesMenu(config) {
    LeaveRatesMenu.superclass.constructor.call(this, config);
    this.plain = true;
    this.item = new _LeaveRatesEditorItem2.default(config);
    this.add(this.item);
    this.canceled = false;
    var self = this;
    this.item.component.on("cancelclick", function () {
        self.canceled = true;self.hide();
    });
    this.item.component.on("okclick", function () {
        self.canceled = false;self.hide();
    });
};

_Ext2.default.extend(LeaveRatesMenu, _Ext2.default.menu.Menu, {

    cls: 'userDataLightBox_leaveRatesMenu',
    shadow: false,

    setActivatedButton: function setActivatedButton(activatedButton) {
        this.activatedButton = activatedButton;
    },

    getActivatedButton: function getActivatedButton() {
        return this.activatedButton;
    },

    setUp: function setUp(leaveRatesArray, defaultValue, isEmptyValid) {
        this.item.component.setUp(leaveRatesArray, defaultValue, isEmptyValid);
    },

    getLeaveRates: function getLeaveRates() {
        return this.item.component.getLeaveRates();
    },

    show: function show(el, pos, parentMenu) {
        this.parentMenu = parentMenu;
        if (!this.el) {
            this.render();
        }
        this.fireEvent("beforeshow", this);
        this.fireEvent("show", this);
        this.el.setXY([-1000, -1000]);
        this.el.show();
        this.hidden = false;
        this.focus();

        // delay position correction since the menu width is changed before show.
        var self = this;
        setTimeout(function () {
            var xy = self.el.getAlignToXY(el, pos || self.defaultAlign, self.offsetXY);
            xy = self.el.adjustForConstraints(xy);
            self.el.setXY(xy);
        }, 5);

        this.canceled = false;
    },

    wasCanceled: function wasCanceled() {
        return this.canceled;
    }
});

exports.default = LeaveRatesMenu;

/***/ }),
/* 1662 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Ext = __webpack_require__(12);

var _Ext2 = _interopRequireDefault(_Ext);

var _LeaveRatesEditorComponent = __webpack_require__(1663);

var _LeaveRatesEditorComponent2 = _interopRequireDefault(_LeaveRatesEditorComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LeaveRatesEditorItem = function LeaveRatesEditorItem(config) {
    LeaveRatesEditorItem.superclass.constructor.call(this, new _LeaveRatesEditorComponent2.default(config), config);
    this.editor = this.component;
    this.editor.on("render", function (editor) {
        editor.getEl().swallowEvent("click");
    });
};

_Ext2.default.extend(LeaveRatesEditorItem, _Ext2.default.menu.Adapter, {});

exports.default = LeaveRatesEditorItem;

/***/ }),
/* 1663 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ValidationResult = undefined;

var _Ext = __webpack_require__(12);

var _Ext2 = _interopRequireDefault(_Ext);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _atUtils = __webpack_require__(5);

var _atBrowserUtils = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ValidationResult = exports.ValidationResult = {
    VALID: 'valid',
    EMPTY_RATE: 'emptyRate',
    INVALID_RATE: 'invalidRate'
};

var LeaveRatesEditorComponent = function LeaveRatesEditorComponent(config) {
    LeaveRatesEditorComponent.superclass.constructor.call(this, config);
    this.numberFormatter = config.numberFormatter;
    this.floatNumberValidator = config.floatNumberValidator;
    this.maxRate = config.maxRate;
    this.addEvents("okclick");
    this.addEvents("cancelclick");
};

_Ext2.default.extend(LeaveRatesEditorComponent, _Ext2.default.Component, {

    activeLeaveTypes: [],
    inputMap: {},
    defValTdMap: {},

    onRender: function onRender(container, position) {
        var self = this;

        var mainDiv = document.createElement("div");

        this.el = _Ext2.default.get(mainDiv);

        (0, _jquery2.default)(mainDiv).html('<table class="leaveRatesTable">' + '   <thead class="header">' + '       <tr class="headerRow">' + '           <th class="leaveTypeName">' + _messageResource2.default.getMessage('user.add_edit.js.rates_editor.leave_rates.header.leave_type') + '</th>' + '           <th class="icon"></th>' + '           <th class="rate">' + _messageResource2.default.getMessage('user.add_edit.js.rates_editor.leave_rates.header.rate') + '</th>' + '           <th class="default">' + _messageResource2.default.getMessage('user.add_edit.js.rates_editor.leave_rates.header.default') + '</th>' + '       </tr>' + '   </thead>' + '   <tbody class="leaveRatesList"/>' + '   <tfoot class="footer"/>' + '</table>');

        this.inputMap = {};

        var $leaveRatesList = (0, _jquery2.default)(mainDiv).find('.leaveRatesList');

        for (var i = 0; i < this.activeLeaveTypes.length; i++) {
            var leaveType = this.activeLeaveTypes[i];
            var leaveTypeName = (0, _atUtils.escapeHtmlSymbols)(leaveType.name);

            var leaveRateRow = (0, _jquery2.default)('<tr class="leaveRateRow">' + '   <td class="leaveTypeName" title="' + leaveTypeName + '">' + leaveTypeName + '</td>' + '   <td class="icon">' + '       <img class="iconImg"/>' + '   </td>' + '   <td class="rate">' + '       <div class="rateCellWrapper">' + '           <input maxlength="8"/>' + '           <div class="clearIcon"/>' + '       </div>' + '   </td>' + '   <td class="default"/>' + '</tr>');

            leaveRateRow.find('.iconImg').attr('src', (0, _atBrowserUtils.imgPath)("leave_types/icons/leave_type_" + leaveType.iconId + "_24bit.png"));
            var $rateInput = leaveRateRow.find('input');

            $rateInput.attr('placeholder', _messageResource2.default.getMessage('user.add_edit.js.rates_editor.rate.placeholder'));
            this.initRateInput($rateInput, leaveRateRow.find('.clearIcon'));
            this.inputMap[leaveType.id] = $rateInput[0];

            this.defValTdMap[leaveType.id] = leaveRateRow.find('.default')[0];

            $leaveRatesList.append(leaveRateRow);
        }

        var $footer = (0, _jquery2.default)(mainDiv).find('.footer').append((0, _jquery2.default)('<tr>' + '   <td colspan=4>' + '       <div class="preFooter">' + '           <div class="message"/>' + '           <div class="clearAllButton">' + '               <div class="clearIcon"/>' + '               <span class="clearAllLabel">' + _messageResource2.default.getMessage('user.add_edit.js.rates_editor.clear_all') + '</span>' + '           </div>' + '       </div>' + '   </td>' + '</tr>' + '<tr>' + '   <td colspan=4>' + '       <div class="buttons">' + '           <div class="components_button okButton">' + _messageResource2.default.getMessage("common.ok") + '</div>' + '           <div class="components_button cancelButton">' + _messageResource2.default.getMessage("common.cancel") + '</div>' + '       </div>' + '   </td>' + '</tr>'));

        this.$message = $footer.find('.message');

        $footer.find('.clearIcon, .clearAllLabel').click(function () {
            return self.clearAll();
        });
        $footer.find('.okButton').click(function () {
            return self.onOkClick();
        });
        $footer.find('.cancelButton').click(function () {
            return self.fireEvent("cancelclick");
        });

        container.dom.insertBefore(mainDiv, position);
    },

    initRateInput: function initRateInput($input, $clearButton) {
        var _this = this;

        $input.on('input', function () {
            return _this._handleInputChange($input, $clearButton);
        }).on('focus', function () {
            $input.removeClass('invalid');
            _this._handleInputChange($input, $clearButton);
        }).on('blur', function () {
            return _this._handleInputBlur($input, $clearButton);
        });

        $clearButton.mousedown(function (e) {
            return e.preventDefault();
        }).click(function () {
            $input.val('').removeClass('invalid').removeAttr('title').focus();
        });
    },

    _handleInputChange: function _handleInputChange($input, $clearButton) {
        var value = (0, _atUtils.trim)($input.val());
        $clearButton.toggle(value.length > 0);
    },

    _handleInputBlur: function _handleInputBlur($input, $clearButton) {
        $input.val((0, _atUtils.trim)($input.val()));
        if (this.prevValue !== $input.val()) {
            this.hasNotEmptyValue = this.hasNotEmptyValue || $input.val().length > 0;
            this.validate($input[0], this.hasNotEmptyValue || this.regularRateSpecified);
        }

        $clearButton.hide();
    },

    setUp: function setUp(leaveRatesArray, regularRate, isEmptyValid) {
        var _this2 = this;

        Object.keys(this.inputMap).forEach(function (p) {
            return _this2.inputMap[p].value = "";
        });
        this.$message.empty();
        this.leaveRatesArray = leaveRatesArray;
        this.hasNotEmptyValue = false;
        this.isEmptyValid = isEmptyValid;

        if (leaveRatesArray) {
            for (var i = 0; i < leaveRatesArray.length; i++) {
                var leaveRate = leaveRatesArray[i];
                var input = this.inputMap[leaveRate.leaveTypeId];
                if (input) {
                    if (leaveRate.rate !== undefined && leaveRate.rate != null) input.value = (0, _atUtils.trim)(String(leaveRate.rate));
                    this.hasNotEmptyValue = this.hasNotEmptyValue || input.value.length > 0;
                    input.prevValue = input.value;
                }
            }
        }

        this.regularRateSpecified = _underscore2.default.isNumber(regularRate);

        var self = this;
        for (var l = 0; l < this.activeLeaveTypes.length; l++) {
            var leaveType = this.activeLeaveTypes[l];
            var defTd = this.defValTdMap[leaveType.id];
            if (this.regularRateSpecified) {
                var defaultValue = this.numberFormatter.format(regularRate * leaveType.rateCoefficient);
                var a = document.createElement("a");
                a.innerHTML = defaultValue;
                a.val = defaultValue;
                a.ltId = leaveType.id;
                a.onclick = function () {
                    var input = self.inputMap[this.ltId];
                    input.value = this.val;
                    self.validate(input, true);
                };
                defTd.innerHTML = "";
                defTd.appendChild(document.createTextNode("( "));
                defTd.appendChild(a);
                defTd.appendChild(document.createTextNode(" )"));
            } else {
                defTd.innerHTML = "( " + _messageResource2.default.getMessage("common.not_available_lower") + " )";
            }
        }

        this.validateAll();
    },

    validate: function validate(input, emptyIsNotValid) {
        var validationResult = ValidationResult.VALID;

        var normalizedValue = this.numberFormatter.normalize(input.value);
        if (input.value.length === 0) {
            if (emptyIsNotValid) {
                input.className = "invalid";
                input.title = _messageResource2.default.getMessage("user.add_edit.js.rates_editor.empty_rate");
                validationResult = ValidationResult.EMPTY_RATE;
            } else {
                input.className = null;
                input.removeAttribute("title");
            }
        } else if (this.floatNumberValidator.isValidNumber(normalizedValue) && this.floatNumberValidator.parseFloat(normalizedValue) < this.maxRate) {
            var val = this.floatNumberValidator.parseFloat(normalizedValue);
            input.value = this.numberFormatter.format(val);
            input.className = null;
            input.removeAttribute("title");
        } else {
            input.className = "invalid";
            input.title = _messageResource2.default.getMessage("user.add_edit.js.rates_editor.invalid_rate", [this.maxRate]);
            validationResult = ValidationResult.INVALID_RATE;
        }

        return validationResult;
    },

    clearAll: function clearAll() {
        var _this3 = this;

        Object.keys(this.inputMap).forEach(function (p) {
            _this3.inputMap[p].value = "";
            _this3.inputMap[p].className = null;
            _this3.inputMap[p].removeAttribute("title");
        });
        this.hasNotEmptyValue = false;
        this.$message.empty();
    },

    onOkClick: function onOkClick() {
        var validationResult = this.validateAll();
        if (!validationResult[ValidationResult.EMPTY_RATE] && !validationResult[ValidationResult.INVALID_RATE]) {
            this.fireEvent("okclick");
        } else {
            this.updateMessage(validationResult);
        }
    },

    validateAll: function validateAll() {
        var _this4 = this;

        var result = {};

        Object.keys(this.inputMap).forEach(function (t) {
            result[_this4.validate(_this4.inputMap[t], _this4.hasNotEmptyValue || !_this4.isEmptyValid)] = true;
        });

        this.updateMessage(result);

        return result;
    },

    updateMessage: function updateMessage(validationResult) {
        if (!validationResult[ValidationResult.EMPTY_RATE] && !validationResult[ValidationResult.INVALID_RATE]) {
            this.$message.empty();
        } else if (validationResult[ValidationResult.EMPTY_RATE] && !validationResult[ValidationResult.INVALID_RATE]) {
            this.$message.text(_messageResource2.default.getMessage('user.add_edit.js.rates_editor.error.empty_rate'));
        } else if (!validationResult[ValidationResult.EMPTY_RATE] && validationResult[ValidationResult.INVALID_RATE]) {
            this.$message.text(_messageResource2.default.getMessage('user.add_edit.js.rates_editor.error.invalid_rate'));
        } else {
            this.$message.text(_messageResource2.default.getMessage('user.add_edit.js.rates_editor.error.correct_errors'));
        }
    },

    getLeaveRates: function getLeaveRates() {
        var _this5 = this;

        var leaveRates = [];

        Object.keys(this.inputMap).forEach(function (leaveTypeId) {
            return leaveRates.push({ leaveTypeId: leaveTypeId, rate: _this5.inputMap[leaveTypeId].value });
        });
        return leaveRates;
    }

});

exports.default = LeaveRatesEditorComponent;

/***/ }),
/* 1664 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CreatePanelUserRatesTable = undefined;

var _utils = __webpack_require__(6);

var _selectors = __webpack_require__(257);

var _actions = __webpack_require__(148);

var _redux = __webpack_require__(7);

var _selectors2 = __webpack_require__(15);

var _UserRatesTable2 = __webpack_require__(874);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CreatePanelUserRatesTable = exports.CreatePanelUserRatesTable = function (_UserRatesTable) {
    _inherits(CreatePanelUserRatesTable, _UserRatesTable);

    function CreatePanelUserRatesTable(_ref) {
        var _ref$updateUserRates = _ref.updateUserRates,
            updateUserRates = _ref$updateUserRates === undefined ? function () {} : _ref$updateUserRates,
            _ref$deleteUserRate = _ref.deleteUserRate,
            deleteUserRate = _ref$deleteUserRate === undefined ? function () {} : _ref$deleteUserRate,
            _ref$addNewUserRate = _ref.addNewUserRate,
            addNewUserRate = _ref$addNewUserRate === undefined ? function () {} : _ref$addNewUserRate,
            _ref$refreshScrollCb = _ref.refreshScrollCb,
            refreshScrollCb = _ref$refreshScrollCb === undefined ? function () {} : _ref$refreshScrollCb,
            _ref$subscribeSelecto = _ref.subscribeSelectorOnScroll,
            subscribeSelectorOnScroll = _ref$subscribeSelecto === undefined ? function () {} : _ref$subscribeSelecto;

        _classCallCheck(this, CreatePanelUserRatesTable);

        return _possibleConstructorReturn(this, (CreatePanelUserRatesTable.__proto__ || Object.getPrototypeOf(CreatePanelUserRatesTable)).call(this, {
            editMode: false,
            updateUserRates: updateUserRates,
            deleteUserRate: deleteUserRate,
            addNewUserRate: addNewUserRate,
            refreshScrollCb: refreshScrollCb,
            subscribeSelectorOnScroll: subscribeSelectorOnScroll
        }));
    }

    return CreatePanelUserRatesTable;
}(_UserRatesTable2.UserRatesTable);

exports.default = (0, _utils.connect)(function (state) {
    return {
        userManagementData: (0, _selectors.getUserManagementDataForUserRates)(state),
        userRates: (0, _selectors.getUserRates)(state),
        overtimeLevel: (0, _selectors.getOvertimeLevel)(state),
        ovrFeatureEnabled: (0, _selectors2.isOVREnabled)(state),
        lvtFeatureEnabled: (0, _selectors2.isLVTEnabled)(state),
        errors: (0, _selectors.getErrors)(state)
    };
}, function (dispatch) {
    return {
        updateUserRates: (0, _redux.bindActionCreators)(_actions.updateUserRates, dispatch),
        addNewUserRate: (0, _redux.bindActionCreators)(_actions.addNewUserRate, dispatch),
        deleteUserRate: (0, _redux.bindActionCreators)(_actions.deleteUserRate, dispatch)
    };
})(CreatePanelUserRatesTable);

/***/ }),
/* 1665 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _constants = __webpack_require__(4);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _ListSelector = __webpack_require__(96);

var _ListSelector2 = _interopRequireDefault(_ListSelector);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _ScrollUtils = __webpack_require__(39);

var _ScrollUtils2 = _interopRequireDefault(_ScrollUtils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Overtime = function (_TemplateView) {
    _inherits(Overtime, _TemplateView);

    function Overtime($containerEl, id) {
        _classCallCheck(this, Overtime);

        var _this = _possibleConstructorReturn(this, (Overtime.__proto__ || Object.getPrototypeOf(Overtime)).call(this, $containerEl));

        _this.id = id;
        _this.state = {
            overtimeLevel: _constants.UserManagementConstants.OVERTIME_OFF,
            readOnly: false
        };

        _this.onStatePropertyChanged("overtimeLevel", function (level) {
            _this._setOvertimeLevel(level);
        });

        _this.onStatePropertyChanged('readOnly', function (readOnly) {
            _this.$overtimeSelectorLabel.toggle(readOnly);

            if (!readOnly) _this.overtimeSelector.show();else _this.overtimeSelector.hide();
        });
        return _this;
    }

    _createClass(Overtime, [{
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='scheduleOvertimeTable'>" + "    <div><%=overtime%></div>" + "    <div class='overtimeSelectorPlaceholder'></div>" + "    <div class='overtimeSelectorLabel'></div>" + "</div>";
        }
    }, {
        key: "messageKeys",
        value: function messageKeys() {
            return {
                overtime: 'userlist.userdata.schedule.overtime'
            };
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            this.overtimeSelector = this.createOvertimeSelector(this.state.overtimeLevel, this.find(".overtimeSelectorPlaceholder")[0]);
            this.$overtimeSelectorLabel = this.find('.overtimeSelectorLabel');
            this.renderInitialState();
        }
    }, {
        key: "createOvertimeSelector",
        value: function createOvertimeSelector(userOvertimeValue, renderTo) {
            var defaultLevel = window.SystemSettings.defaultOvertimeLevel;
            var defaultLevelExpl = " " + _messageResource2.default.getMessage("userlist.js.overtime_selector.default");
            this.listItems = [{
                text: _messageResource2.default.getMessage("userlist.js.overtime_off") + (defaultLevel == _constants.UserManagementConstants.OVERTIME_OFF ? defaultLevelExpl : ""),
                value: _constants.UserManagementConstants.OVERTIME_OFF
            }, {
                text: _messageResource2.default.getMessage("userlist.js.overtime_auto_hidden") + (defaultLevel == _constants.UserManagementConstants.OVERTIME_AUTO_HIDDEN ? defaultLevelExpl : ""),
                value: _constants.UserManagementConstants.OVERTIME_AUTO_HIDDEN
            }, {
                text: _messageResource2.default.getMessage("userlist.js.overtime_auto") + (defaultLevel == _constants.UserManagementConstants.OVERTIME_AUTO ? defaultLevelExpl : ""),
                value: _constants.UserManagementConstants.OVERTIME_AUTO
            }, {
                text: _messageResource2.default.getMessage("userlist.js.overtime_manual") + (defaultLevel == _constants.UserManagementConstants.OVERTIME_MANUAL ? defaultLevelExpl : ""),
                value: _constants.UserManagementConstants.OVERTIME_MANUAL
            }];

            var selector = new _ListSelector2.default({
                menuCls: "overtimeSelectorMenu",
                renderTo: renderTo,
                value: userOvertimeValue,
                listItems: this.listItems,
                scrollableContainer: this.$containerEl[0],
                listeners: {
                    menushow: function menushow(button, menu) {
                        (0, _jquery2.default)(menu.el.dom).on(_ScrollUtils2.default.getWheelEventName(), function (e) {
                            e.preventDefault();
                        });
                    }
                }
            });

            var self = this;
            selector.on("change", function (context, item) {
                if (self.state.overtimeLevel !== item.value) {
                    self.setState({ overtimeLevel: item.value });
                    self.trigger("changeOvertime", [item.value]);
                }
            });

            return selector;
        }
    }, {
        key: "getElementBySubId",
        value: function getElementBySubId(name) {
            return document.getElementById(this.id + "_" + name);
        }
    }, {
        key: "hideOpenedExtJSSelector",
        value: function hideOpenedExtJSSelector() {
            this.overtimeSelector.hideMenuOnScrollOrResize();
        }
    }, {
        key: "_setOvertimeLevel",
        value: function _setOvertimeLevel(level) {
            this.overtimeSelector.setItem(this.overtimeSelector.getItemByValue(level));
            this.$overtimeSelectorLabel.html(this.listItems.find(function (item) {
                return item.value === level;
            }).text);
        }
    }]);

    return Overtime;
}(_TemplateView3.default);

exports.default = Overtime;

/***/ }),
/* 1666 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _PermissionsBlock = __webpack_require__(1667);

var _PermissionsBlock2 = _interopRequireDefault(_PermissionsBlock);

var _ScopeCellContainer = __webpack_require__(1668);

var _ScopeCellContainer2 = _interopRequireDefault(_ScopeCellContainer);

var _constants = __webpack_require__(4);

var _utils = __webpack_require__(865);

var _TeamScopeCell = __webpack_require__(1669);

var _TeamScopeCell2 = _interopRequireDefault(_TeamScopeCell);

var _ManageScopeCell = __webpack_require__(1672);

var _ManageScopeCell2 = _interopRequireDefault(_ManageScopeCell);

var _SimpleTooltip = __webpack_require__(36);

var _SimpleTooltip2 = _interopRequireDefault(_SimpleTooltip);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _constants2 = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Permissions = function (_TemplateView) {
    _inherits(Permissions, _TemplateView);

    function Permissions($containerEl, _ref) {
        var _ref$onTeamAssignment = _ref.onTeamAssignmentsCellClick,
            onTeamAssignmentsCellClick = _ref$onTeamAssignment === undefined ? function () {} : _ref$onTeamAssignment,
            _ref$onManagementAssi = _ref.onManagementAssignmentsCellClick,
            onManagementAssignmentsCellClick = _ref$onManagementAssi === undefined ? function () {} : _ref$onManagementAssi;

        _classCallCheck(this, Permissions);

        var _this = _possibleConstructorReturn(this, (Permissions.__proto__ || Object.getPrototypeOf(Permissions)).call(this, $containerEl));

        _this._handleTeamAssignmentsCellClick = function ($el, e) {
            _this.params.onTeamAssignmentsCellClick(true, e);
        };

        _this._handleManageAssignmentsCellClick = function ($el, e) {
            _this.params.onManagementAssignmentsCellClick(e);
        };

        _this._handleScopePermissionsMouseIn = function (accessRight) {
            if (accessRight === _constants.AccessRights.GENERATE_MONEY_REPORTS || accessRight === _constants.AccessRights.EDIT_HIERARCHY || accessRight === _constants.AccessRights.SUBMIT_OTHER_USER_TIME_TRACK || accessRight === _constants.AccessRights.MANAGE_USERS) {
                _this.teamAssignmentsCell.setState({
                    highlighted: true
                });
                _this.manageScopeCell.setState({
                    highlighted: true
                });
            }
        };

        _this._handleScopePermissionsMouseOut = function (a) {
            _this.teamAssignmentsCell.setState({
                highlighted: false
            });
            _this.manageScopeCell.setState({
                highlighted: false
            });
        };

        _this.updateOnInit = false;

        _this.state = {
            editUserIsLoggedIn: false,
            accessRights: [],
            userGroups: [],
            managementAssignmentsSelection: _constants2.ManagementAssignmentsSelection.SELECTED,
            managementAssignmentsCounts: {
                customers: 0,
                projects: 0,
                tasks: 0
            },
            teamAssignmentsData: {},
            disabled: false,
            isUGREnabled: false,
            isAllowedToSeeAllUsersTT: false,
            userFirstName: '',
            isURAEnabled: false,
            isBTYEnabled: false,
            isLTTEnabled: false,

            permissionsReadOnly: false,
            teamScopeReadOnly: false,
            manageScopeReadOnly: false
        };

        _this.params = {
            onTeamAssignmentsCellClick: onTeamAssignmentsCellClick,
            onManagementAssignmentsCellClick: onManagementAssignmentsCellClick
        };

        _this.onStatePropertyChanged('editUserIsLoggedIn', function () {
            _this.permissionsBlock.setState({
                editLoggedIn: _this.state.editUserIsLoggedIn
            });
        });

        _this.onStatePropertyChanged('accessRights', function () {
            _this.permissionsBlock.setState({
                accessRights: _this.state.accessRights
            });

            _this._setManageScopeCellState();
            _this._setTeamScopeCellState();
        });

        _this.onStatePropertyChanged('userGroups', function () {
            _this._setTeamScopeCellState();
        });
        _this.onAnyStatePropertyChanged(['managementAssignmentsSelection', 'managementAssignmentsCounts'], function () {
            _this._setManageScopeCellState();
        });
        _this.onStatePropertyChanged('teamAssignmentsData', function () {
            _this._setTeamScopeCellState();
        });

        _this.onStatePropertyChanged('disabled', function (disabled) {
            _this.permissionsBlock.setState({
                disabled: disabled
            });
        });

        _this.onAnyStatePropertyChanged(['isAllowedToSeeAllUsersTT', 'userFirstName'], function () {
            _this.updateWarning();
        });

        _this.onStatePropertyChanged('isURAEnabled', function (enabled) {
            _this.permissionsBlock.setState({
                isURAEnabled: enabled
            });
        });
        _this.onStatePropertyChanged('isBTYEnabled', function (enabled) {
            _this.permissionsBlock.setState({
                isBTYEnabled: enabled
            });
        });
        _this.onStatePropertyChanged('isLTTEnabled', function (enabled) {
            _this.permissionsBlock.setState({
                isLTTEnabled: enabled
            });
        });
        _this.onStatePropertyChanged('isPTOEnabled', function (enabled) {
            _this.permissionsBlock.setState({
                isPTOEnabled: enabled
            });
        });
        _this.onStatePropertyChanged('isSDBEnabled', function (enabled) {
            _this.permissionsBlock.setState({
                isSDBEnabled: enabled
            });
        });

        _this.onStatePropertyChanged('permissionsReadOnly', function (readOnly) {
            _this.permissionsBlock.setState({ readOnly: readOnly });
        });

        _this.onStatePropertyChanged('teamScopeReadOnly', function (readOnly) {
            _this.teamAssignmentsCell.setState({ readOnly: readOnly });
        });

        _this.onStatePropertyChanged('manageScopeReadOnly', function (readOnly) {
            _this.manageScopeCell.setState({ readOnly: readOnly });
        });
        return _this;
    }

    _createClass(Permissions, [{
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='permissions panelTab'>" + "    <div class='permissionSection section'>" + "        <div class='sectionContent'>" + "            <div class='permissionsBlockPlaceholder'/>" + "            <div class='manageScopePlaceholder'>" + "                <div class='scopeCellsPlaceholder'/>" + "                <div class='showOthersWarning'>" + "                    <div class='icon'/>" + "                    <div class='text'/>" + "                </div>" + "            </div>" + "        </div>" + "    </div>" + "    <div class='templatePanel'/>" + "</div>";
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            _get(Permissions.prototype.__proto__ || Object.getPrototypeOf(Permissions.prototype), "afterRender", this).call(this);
            this.$content = this.find('.sectionContent');
            this.$warning = this.find('.showOthersWarning');
            this.$warningText = this.find('.showOthersWarning .text');
            this.permissionsBlock = new _PermissionsBlock2.default(this.find('.permissionsBlockPlaceholder'), {
                permissionRowMouseIn: this._handleScopePermissionsMouseIn,
                permissionRowMouseOut: this._handleScopePermissionsMouseOut
            }).init();

            this.$templatePanel = this.find('.templatePanel');
            this.$permissionsInfoButton = this.find('.permissionsInfoButton');

            this.teamAssignmentsCell = new _TeamScopeCell2.default({
                onClickCb: this._handleTeamAssignmentsCellClick
            });

            this.manageScopeCell = new _ManageScopeCell2.default({
                onClickCb: this._handleManageAssignmentsCellClick
            });

            new _ScopeCellContainer2.default({
                innerElement: this.teamAssignmentsCell
            }).init(this.find('.scopeCellsPlaceholder')).setState({
                labelKey: 'user.scope_cell.users.header'
            });

            new _ScopeCellContainer2.default({
                innerElement: this.manageScopeCell
            }).init(this.find('.scopeCellsPlaceholder')).setState({
                labelKey: 'user.scope_cell.manage_scope.header'
            });

            var showOthersTooltip = this.showOthersTooltip();
            showOthersTooltip.subscribeToMouseEvents(this.$warning);
            this.updateWarning();
        }
    }, {
        key: "update",
        value: function update() {
            _get(Permissions.prototype.__proto__ || Object.getPrototypeOf(Permissions.prototype), "update", this).call(this);
        }
    }, {
        key: "_setManageScopeCellState",
        value: function _setManageScopeCellState() {
            this.manageScopeCell.setState((0, _utils.getManagerScopeState)(this.state.managementAssignmentsCounts, this.state.managementAssignmentsSelection, this.state.accessRights, {
                isURAEnabled: this.state.isURAEnabled,
                isBTYEnabled: this.state.isBTYEnabled
            }));
        }
    }, {
        key: "_setTeamScopeCellState",
        value: function _setTeamScopeCellState() {
            this.teamAssignmentsCell.setState((0, _utils.getTeamScopeState)(this.state.teamAssignmentsData, this.state.accessRights, {
                isURAEnabled: this.state.isURAEnabled,
                isBTYEnabled: this.state.isBTYEnabled
            }));
        }
    }, {
        key: "updateWarning",
        value: function updateWarning() {
            this.$warningText.text(this.state.isAllowedToSeeAllUsersTT ? _messageResource2.default.getMessage("user.panel.permissions.warning_text") : '');
            this.$warning.toggle(this.state.isAllowedToSeeAllUsersTT);
            var warningTooltipText = _messageResource2.default.getEscapedMessage("user.panel.permissions.warning_tooltip.part1", [this.state.userFirstName]) + _messageResource2.default.getMessage("user.panel.permissions.warning_tooltip.part2");
            this.showOthersTooltip().setHtml(this.state.isAllowedToSeeAllUsersTT ? warningTooltipText : '');
            this.showOthersTooltip().setEnabled(this.state.isAllowedToSeeAllUsersTT);
        }
    }, {
        key: "showOthersTooltip",
        value: function showOthersTooltip() {
            if (!Permissions.tooltip) {
                Permissions.tooltip = new _SimpleTooltip2.default({
                    extraClass: 'userPanelPermissionsTabShowOthersTooltip'
                }).init((0, _jquery2.default)('body'));
            }
            return Permissions.tooltip;
        }
    }]);

    return Permissions;
}(_TemplateView3.default);

exports.default = Permissions;

/***/ }),
/* 1667 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _constants = __webpack_require__(4);

var _PermissionsUtils = __webpack_require__(359);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PermissionsBlock = function (_TemplateView) {
    _inherits(PermissionsBlock, _TemplateView);

    function PermissionsBlock($containerEl, _ref) {
        var _ref$permissionRowMou = _ref.permissionRowMouseIn,
            permissionRowMouseIn = _ref$permissionRowMou === undefined ? function () {} : _ref$permissionRowMou,
            _ref$permissionRowMou2 = _ref.permissionRowMouseOut,
            permissionRowMouseOut = _ref$permissionRowMou2 === undefined ? function () {} : _ref$permissionRowMou2;

        _classCallCheck(this, PermissionsBlock);

        var _this = _possibleConstructorReturn(this, (PermissionsBlock.__proto__ || Object.getPrototypeOf(PermissionsBlock)).call(this, $containerEl));

        _this.state = {
            accessRights: [],
            editLoggedIn: false,
            disabled: false,
            readOnly: false,
            isURAEnabled: false,
            isBTYEnabled: false,
            isLTTEnabled: false,
            isPTOEnabled: false,
            isSDBEnabled: false
        };

        _this.params = {
            permissionRowMouseIn: permissionRowMouseIn,
            permissionRowMouseOut: permissionRowMouseOut
        };

        _this.onStatePropertyChanged('accessRights', function () {
            Object.values(_this.permissionRows).map(function (row) {
                return row.setState({ checked: false });
            });

            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = _this.state.accessRights[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var accessRight = _step.value;

                    if (_this.permissionRows[accessRight]) _this.permissionRows[accessRight].setState({ checked: true });
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        });
        _this.onStatePropertyChanged('editLoggedIn', function () {
            _this.permissionRows[_constants.AccessRights.MANAGE_USERS].setState({ disabled: _this.state.editLoggedIn || _this.state.readOnly });
        });

        _this.onAnyStatePropertyChanged(['disabled', 'readOnly'], function (_ref2) {
            var disabled = _ref2.disabled,
                readOnly = _ref2.readOnly;

            _this._switchDisabledStateOfPermissionsRows(disabled || readOnly);
            _this.permissionRows[_constants.AccessRights.MANAGE_USERS].setState({ disabled: _this.state.editLoggedIn || disabled || readOnly });
        });

        _this.onAnyStatePropertyChanged(['isURAEnabled', 'isBTYEnabled'], function (_ref3) {
            var isURAEnabled = _ref3.isURAEnabled,
                isBTYEnabled = _ref3.isBTYEnabled;

            _this.permissionRows[_constants.AccessRights.GENERATE_MONEY_REPORTS].toggle(isURAEnabled || isBTYEnabled);
            _this.permissionRows[_constants.AccessRights.GENERATE_MONEY_REPORTS].setState({
                name: (0, _PermissionsUtils.getGenerateMoneyReportsRightTitle)(isURAEnabled, isBTYEnabled)
            });
        });

        _this.onStatePropertyChanged('isLTTEnabled', function (enabled) {
            _this.permissionRows[_constants.AccessRights.LOCK_TIME_TRACK].toggle(enabled);
        });

        _this.onAnyStatePropertyChanged(['isPTOEnabled', 'isSDBEnabled'], function (_ref4) {
            var isPTOEnabled = _ref4.isPTOEnabled,
                isSDBEnabled = _ref4.isSDBEnabled;

            _this.permissionRows[_constants.AccessRights.MANAGE_PTO_AND_SICK].toggle(isPTOEnabled || isSDBEnabled);

            _this.permissionRows[_constants.AccessRights.MANAGE_PTO_AND_SICK].setState({
                name: (0, _PermissionsUtils.getManagePtoAndSickDaysRightTitle)(isPTOEnabled, isSDBEnabled)
            });
        });

        _this.onStatePropertyChanged('readOnly', function (readOnly) {
            _this.$permissionTemplatesMenuButton.toggle(!readOnly);
        });
        return _this;
    }

    _createClass(PermissionsBlock, [{
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='permissionsBlock block'>" + "    <div class='blockHeader'>" + "        <div class='label'><%=headerLabel%></div>" + "        <div class='templatesButton'>" + "            <div class='icon'/><div class='applyTemplate'><%=applyTemplateBtnText%></div>" + "        </div>" + "    </div>" + "    <div class='blockContent'>" + "        <div class='firstGroup permissionGroup'/>" + "        <div class='secondGroup permissionGroup'/>" + "    </div>" + "    <div class='permissionsInfoButton'><%=permissions_info_button_text%></div>" + "</div>";
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            var _this2 = this;

            _get(PermissionsBlock.prototype.__proto__ || Object.getPrototypeOf(PermissionsBlock.prototype), "afterRender", this).call(this);
            this.$firstGroup = this.find('.firstGroup');
            this.$secondGroup = this.find('.secondGroup');
            this.permissionRows = (0, _PermissionsUtils.generatePermissionRows)(this.$firstGroup, this.$secondGroup);
            this.$permissionTemplatesMenuButton = this.find('.templatesButton');

            Object.values(this.permissionRows).map(function (row) {
                row.on('changed', function (e, id, active) {
                    row.setState({ checked: active });
                    var rights = _this2.state.accessRights.slice();
                    var index = rights.indexOf(row.id);
                    if (active && index === -1) rights.push(row.id);
                    if (!active && index !== -1) rights.splice(index, 1);
                    _this2.setStateInternal({ accessRights: rights });
                    _this2.trigger('permissionsChanged', [rights, _this2.state.editLoggedIn]);
                });
                row.$el.mouseover(function () {
                    _this2.params.permissionRowMouseIn(row.getId());
                });
                row.$el.mouseout(function () {
                    _this2.params.permissionRowMouseOut(row.getId());
                });
            });

            this.renderInitialState();
        }
    }, {
        key: "messageKeys",
        value: function messageKeys() {
            return {
                headerLabel: "userlist.userdata.permissions",
                permissions_info_button_text: "user.panel.permissions.permissions_info_button_text",
                applyTemplateBtnText: "userlist.userdata.permissions_templates.apply_template"
            };
        }
    }, {
        key: "_switchDisabledStateOfPermissionsRows",
        value: function _switchDisabledStateOfPermissionsRows(disabled) {
            Object.values(this.permissionRows).map(function (row) {
                row.setState({
                    disabled: disabled
                });
            });
        }
    }]);

    return PermissionsBlock;
}(_TemplateView3.default);

exports.default = PermissionsBlock;

/***/ }),
/* 1668 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ScopeCellContainer = function (_TemplateView) {
    _inherits(ScopeCellContainer, _TemplateView);

    function ScopeCellContainer(_ref) {
        var _ref$innerElement = _ref.innerElement,
            innerElement = _ref$innerElement === undefined ? null : _ref$innerElement;

        _classCallCheck(this, ScopeCellContainer);

        var _this = _possibleConstructorReturn(this, (ScopeCellContainer.__proto__ || Object.getPrototypeOf(ScopeCellContainer)).call(this));

        _this.params = {
            innerElement: innerElement
        };

        _this.state = {
            labelKey: ''
        };

        _this.onStateChanged(function () {
            _this.updateLabel();
        });
        return _this;
    }

    _createClass(ScopeCellContainer, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return "<div class='userPanelScopeCellContainer block'>" + "    <div class='label blockHeader'></div>" + "    <div class='content'></div>" + "</div>";
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            this.params.innerElement.init(this.$el.find('.content'));

            this.$label = this.find('.label');
        }
    }, {
        key: 'updateLabel',
        value: function updateLabel() {
            this.$label.text(_messageResource2.default.getMessage(this.state.labelKey));
        }
    }]);

    return ScopeCellContainer;
}(_TemplateView3.default);

exports.default = ScopeCellContainer;

/***/ }),
/* 1669 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _ScopeCell = __webpack_require__(315);

var _ScopeCell2 = _interopRequireDefault(_ScopeCell);

var _TeamCellDetailsBlock = __webpack_require__(1670);

var _TeamCellDetailsBlock2 = _interopRequireDefault(_TeamCellDetailsBlock);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TeamScopeCell = function (_TemplateView) {
    _inherits(TeamScopeCell, _TemplateView);

    function TeamScopeCell(_ref) {
        var _ref$onClickCb = _ref.onClickCb,
            onClickCb = _ref$onClickCb === undefined ? function () {} : _ref$onClickCb;

        _classCallCheck(this, TeamScopeCell);

        var _this = _possibleConstructorReturn(this, (TeamScopeCell.__proto__ || Object.getPrototypeOf(TeamScopeCell)).call(this));

        _this.params = {
            onClickCb: onClickCb
        };

        _this.state = {
            highlighted: false,
            disabled: false,
            readOnly: false,
            status: _ScopeCell.SCOPE_CELL_STATUS.ALL,
            assignedUsersCount: 0
        };

        _this.onAnyStatePropertyChanged(['highlighted', 'disabled', 'status', 'readOnly'], function () {
            _this.scopeCell.setState({
                highlighted: _this.state.highlighted,
                disabled: _this.state.disabled || _this.state.readOnly,
                status: _this.state.status
            });
        });

        _this.onAnyStatePropertyChanged(['status', 'assignedUsersCount'], function () {
            _this.teamDetailsBlock.setState({
                status: _this.state.status,
                assignedUsersCount: _this.state.assignedUsersCount
            });
        });
        return _this;
    }

    _createClass(TeamScopeCell, [{
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='teamScopeCellContainer'></div>";
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            this.teamDetailsBlock = new _TeamCellDetailsBlock2.default();

            this.scopeCell = new _ScopeCell2.default({
                onClickCb: this.params.onClickCb,
                detailsBlock: this.teamDetailsBlock,
                notAllowedTextKey: 'user.scope_cell.no_access',
                notSelectedTextKey: 'user.scope_cell.users.not_selected',
                noAccessTextKey: 'user.scope_cell.users.no_access'
            }).init(this.$el);

            this.scopeCell.setState({
                allSelectedTextKey: 'user.scope_cell.users.all_selected'
            });

            this.renderInitialState();
        }
    }]);

    return TeamScopeCell;
}(_TemplateView3.default);

exports.default = TeamScopeCell;

/***/ }),
/* 1670 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _ScopeCell = __webpack_require__(315);

var _SelectedUsersBlock = __webpack_require__(1671);

var _SelectedUsersBlock2 = _interopRequireDefault(_SelectedUsersBlock);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TeamCellDetailsBlock = function (_TemplateView) {
    _inherits(TeamCellDetailsBlock, _TemplateView);

    function TeamCellDetailsBlock() {
        _classCallCheck(this, TeamCellDetailsBlock);

        var _this = _possibleConstructorReturn(this, (TeamCellDetailsBlock.__proto__ || Object.getPrototypeOf(TeamCellDetailsBlock)).call(this));

        _this.state = {
            status: _ScopeCell.SCOPE_CELL_STATUS.ALL,
            assignedUsersCount: 0
        };

        _this.onStatePropertyChanged('assignedUsersCount', function (assignedUsersCount) {
            _this.scopeDetails.setState({ assignedUsersCount: assignedUsersCount });
        });

        _this.onStatePropertyChanged('status', function (status) {
            _this.$scopeDetails.toggle(status === _ScopeCell.SCOPE_CELL_STATUS.SELECTED);
        });
        return _this;
    }

    _createClass(TeamCellDetailsBlock, [{
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='cellDetailsBlock'>" + "    <div class='scopeDetails'></div>" + "</div>";
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            this.$scopeDetails = this.find('.scopeDetails');
            this.scopeDetails = new _SelectedUsersBlock2.default().init(this.$scopeDetails);
        }
    }]);

    return TeamCellDetailsBlock;
}(_TemplateView3.default);

exports.default = TeamCellDetailsBlock;

/***/ }),
/* 1671 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _pluralizeUtils = __webpack_require__(40);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SelectedUsersBlock = function (_TemplateView) {
    _inherits(SelectedUsersBlock, _TemplateView);

    function SelectedUsersBlock() {
        _classCallCheck(this, SelectedUsersBlock);

        var _this = _possibleConstructorReturn(this, (SelectedUsersBlock.__proto__ || Object.getPrototypeOf(SelectedUsersBlock)).call(this));

        _this.state = {
            assignedUsersCount: 0
        };

        _this.onStatePropertyChanged('assignedUsersCount', function (assignedUsersCount) {
            var label = assignedUsersCount + " " + (0, _pluralizeUtils.userNameLower)(assignedUsersCount);
            _this.getEl().text(label);
        });
        return _this;
    }

    _createClass(SelectedUsersBlock, [{
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='selectedUsersBlock'/>";
        }
    }]);

    return SelectedUsersBlock;
}(_TemplateView3.default);

exports.default = SelectedUsersBlock;

/***/ }),
/* 1672 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _ScopeCell = __webpack_require__(315);

var _ScopeCell2 = _interopRequireDefault(_ScopeCell);

var _ManageCellDetailsBlock = __webpack_require__(1673);

var _ManageCellDetailsBlock2 = _interopRequireDefault(_ManageCellDetailsBlock);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ManageScopeCell = function (_TemplateView) {
    _inherits(ManageScopeCell, _TemplateView);

    function ManageScopeCell(_ref) {
        var _ref$onClickCb = _ref.onClickCb,
            onClickCb = _ref$onClickCb === undefined ? function () {} : _ref$onClickCb;

        _classCallCheck(this, ManageScopeCell);

        var _this = _possibleConstructorReturn(this, (ManageScopeCell.__proto__ || Object.getPrototypeOf(ManageScopeCell)).call(this));

        _this.params = {
            onClickCb: onClickCb
        };

        _this.state = {
            highlighted: false,
            disabled: false,
            readOnly: false,
            status: _ScopeCell.SCOPE_CELL_STATUS.ALL,
            nCustomers: 0,
            nProjects: 0,
            nTasks: 0
        };

        _this.onAnyStatePropertyChanged(['highlighted', 'disabled', 'status', 'readOnly'], function () {
            _this.scopeCell.setState({
                highlighted: _this.state.highlighted,
                disabled: _this.state.disabled || _this.state.readOnly,
                status: _this.state.status
            });
        });

        _this.onAnyStatePropertyChanged(['status', 'nCustomers', 'nProjects', 'nTasks'], function () {
            _this.manageDetailsBlock.setState({
                status: _this.state.status,
                nCustomers: _this.state.nCustomers,
                nProjects: _this.state.nProjects,
                nTasks: _this.state.nTasks
            });
        });
        return _this;
    }

    _createClass(ManageScopeCell, [{
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='manageScopeCellContainer'></div>";
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            this.manageDetailsBlock = new _ManageCellDetailsBlock2.default();
            this.scopeCell = new _ScopeCell2.default({
                onClickCb: this.params.onClickCb,
                detailsBlock: this.manageDetailsBlock,
                notAllowedTextKey: 'user.scope_cell.no_access',
                notSelectedTextKey: 'user.scope_cell.manage_scope.not_selected',
                noAccessTextKey: 'user.scope_cell.manage_scope.no_access'
            }).init(this.$el);
            this.scopeCell.setState({
                allSelectedTextKey: 'user.scope_cell.manage_scope.all_selected'
            });
        }
    }]);

    return ManageScopeCell;
}(_TemplateView3.default);

exports.default = ManageScopeCell;

/***/ }),
/* 1673 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _ScopeCell = __webpack_require__(315);

var _constants = __webpack_require__(4);

var _CounterWithProgressBar = __webpack_require__(210);

var _CounterWithProgressBar2 = _interopRequireDefault(_CounterWithProgressBar);

var _pluralizeUtils = __webpack_require__(40);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ManageCellDetailsBlock = function (_TemplateView) {
    _inherits(ManageCellDetailsBlock, _TemplateView);

    function ManageCellDetailsBlock() {
        _classCallCheck(this, ManageCellDetailsBlock);

        var _this = _possibleConstructorReturn(this, (ManageCellDetailsBlock.__proto__ || Object.getPrototypeOf(ManageCellDetailsBlock)).call(this));

        _this.state = {
            status: _ScopeCell.SCOPE_CELL_STATUS.ALL,
            nCustomers: 0,
            nProjects: 0,
            nTasks: 0
        };

        _this.onStatePropertyChanged('nCustomers', function (nCustomers) {
            return _this.updateCounter(_this.customersCounter, nCustomers, (0, _pluralizeUtils.customerNameLower)(nCustomers));
        });

        _this.onStatePropertyChanged('nProjects', function (nProjects) {
            return _this.updateCounter(_this.projectsCounter, nProjects, (0, _pluralizeUtils.projectNameLower)(nProjects));
        });

        _this.onStatePropertyChanged('nTasks', function (nTasks) {
            return _this.updateCounter(_this.tasksCounter, nTasks, (0, _pluralizeUtils.taskNameLower)(nTasks));
        });

        _this.onStatePropertyChanged('status', function () {
            _this.$scopeDetails.toggle(_this.state.status === _ScopeCell.SCOPE_CELL_STATUS.SELECTED);
        });
        return _this;
    }

    _createClass(ManageCellDetailsBlock, [{
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='cellDetailsBlock'>" + "    <div class='scopeDetails'>" + "      <div class='counterRow customers'>" + "      </div>" + "      <div class='counterRow projects'>" + "      </div>" + "      <div class='counterRow tasks'>" + "      </div>" + "    </div>" + "</div>";
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            this.$scopeDetails = this.find('.scopeDetails');
            this.customersCounter = new _CounterWithProgressBar2.default({
                hierarchyLevel: _constants.HierarchyLevels.CUSTOMER
            }).init(this.find('.counterRow.customers'));
            this.customersCounter.setState({ pale: true });

            this.projectsCounter = new _CounterWithProgressBar2.default({
                hierarchyLevel: _constants.HierarchyLevels.PROJECT
            }).init(this.find('.counterRow.projects'));
            this.projectsCounter.setState({ pale: true });

            this.tasksCounter = new _CounterWithProgressBar2.default({
                hierarchyLevel: _constants.HierarchyLevels.TASK
            }).init(this.find('.counterRow.tasks'));
            this.tasksCounter.setState({ pale: true });

            this.renderInitialState();
        }
    }, {
        key: "updateCounter",
        value: function updateCounter(counter, value, label) {
            counter.setState({
                curValue: value,
                title: label
            });
        }
    }]);

    return ManageCellDetailsBlock;
}(_TemplateView3.default);

exports.default = ManageCellDetailsBlock;

/***/ }),
/* 1674 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _constants = __webpack_require__(261);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CounterProgressBar = function (_TemplateView) {
    _inherits(CounterProgressBar, _TemplateView);

    function CounterProgressBar(_ref) {
        var _ref$hierarchyLevel = _ref.hierarchyLevel,
            hierarchyLevel = _ref$hierarchyLevel === undefined ? "" : _ref$hierarchyLevel;

        _classCallCheck(this, CounterProgressBar);

        var _this = _possibleConstructorReturn(this, (CounterProgressBar.__proto__ || Object.getPrototypeOf(CounterProgressBar)).call(this));

        _this.props = {
            hierarchyLevel: hierarchyLevel
        };
        _this.state = {
            ratio: 0
        };
        _this.onStateChanged(function () {
            return _this._updateProgress();
        });
        return _this;
    }

    _createClass(CounterProgressBar, [{
        key: "_updateProgress",
        value: function _updateProgress() {
            this.$barValue.css({
                'width': Math.round(this.state.ratio * 100) + '%'
            });
        }
    }, {
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='components_cptProgressBar <%-hierarchyLevelClass%>'>" + "   <div class='border'></div>" + "   <div class='value'></div>" + "</div>";
        }
    }, {
        key: "templateModel",
        value: function templateModel() {
            return {
                hierarchyLevelClass: _constants.HIERARCHY_LEVEL_CLASSES[this.props.hierarchyLevel]
            };
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            this.$barValue = this.find('.value');
        }
    }]);

    return CounterProgressBar;
}(_TemplateView3.default);

exports.default = CounterProgressBar;

/***/ }),
/* 1675 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _constants = __webpack_require__(21);

var _constants2 = __webpack_require__(62);

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _constants3 = __webpack_require__(4);

var _TabsController = __webpack_require__(239);

var _TabsController2 = _interopRequireDefault(_TabsController);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UserPanelContent = function (_TemplateView) {
    _inherits(UserPanelContent, _TemplateView);

    function UserPanelContent(_ref) {
        var $headerTabs = _ref.$headerTabs,
            accountSettings = _ref.accountSettings,
            permissions = _ref.permissions,
            _ref$tabSwitchedCallb = _ref.tabSwitchedCallback,
            tabSwitchedCallback = _ref$tabSwitchedCallb === undefined ? function (tabKey) {} : _ref$tabSwitchedCallb;

        _classCallCheck(this, UserPanelContent);

        var _this = _possibleConstructorReturn(this, (UserPanelContent.__proto__ || Object.getPrototypeOf(UserPanelContent)).call(this, null));

        _this._handleTabSwitched = function (selectedKey, previousKey) {
            _this.tabsController.setState({ selectedTabKey: selectedKey });

            if (previousKey) _this.buttons.get(previousKey).toggleClass('selected', false);
            _this.buttons.get(selectedKey).toggleClass('selected', true);
        };

        _this.params = {
            $headerTabs: $headerTabs
        };

        _this.components = {
            accountSettings: accountSettings,
            permissions: permissions
        };

        _this.type = _constants2.PANEL_TYPES.EDIT_USER;

        _this.onHideCb = function () {};
        _this.tabSwitchedCallback = tabSwitchedCallback;

        _this.updateOnInit = true;

        _this.state = {
            currentTabKey: null
        };
        _this.onStatePropertyChanged('currentTabKey', _this._handleTabSwitched);
        return _this;
    }

    _createClass(UserPanelContent, [{
        key: "templateHtml",
        value: function templateHtml() {
            return '<div class="content"/>';
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            var _this2 = this;

            this.$el.toggleClass("showIntegrationMarks", _constants3.LicenseInfo.isApActive);

            this.components.accountSettings.init(this.getEl());
            this.components.permissions.init(this.getEl());

            var tabs = new Map([[_constants.TabKeys.ACCOUNT_SETTINGS, this.components.accountSettings], [_constants.TabKeys.PERMISSIONS, this.components.permissions]]);

            tabs.forEach(function ($tab, tabKey) {
                $tab.hide();
            });

            this.tabsController = new _TabsController2.default({
                tabs: tabs
            }).init();

            this.buttons = new Map([[_constants.TabKeys.ACCOUNT_SETTINGS, this.params.$headerTabs.$accountSettingsTab], [_constants.TabKeys.PERMISSIONS, this.params.$headerTabs.$permissionsTab]]);

            this.buttons.forEach(function ($button, key) {
                $button.click(function () {
                    return _this2.tabSwitchedCallback(key);
                });
            });
        }
    }, {
        key: "onScroll",
        value: function onScroll() {
            this.components.accountSettings.onScroll();
        }
    }]);

    return UserPanelContent;
}(_TemplateView3.default);

exports.default = UserPanelContent;

/***/ }),
/* 1676 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _UserNameFormat = __webpack_require__(17);

var _CopyUserSelector = __webpack_require__(397);

var _CopyUserSelector2 = _interopRequireDefault(_CopyUserSelector);

var _CopySettingsFromButton = __webpack_require__(1677);

var _CopySettingsFromButton2 = _interopRequireDefault(_CopySettingsFromButton);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Header = function (_TemplateView) {
    _inherits(Header, _TemplateView);

    function Header(_ref) {
        var _ref$onCopyUserSelect = _ref.onCopyUserSelectionCallback,
            onCopyUserSelectionCallback = _ref$onCopyUserSelect === undefined ? function () {} : _ref$onCopyUserSelect,
            _ref$onCloseCallback = _ref.onCloseCallback,
            onCloseCallback = _ref$onCloseCallback === undefined ? function () {} : _ref$onCloseCallback;

        _classCallCheck(this, Header);

        var _this = _possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).call(this, null));

        _this.state = {
            firstName: '',
            lastName: '',
            middleInitial: '',
            users: [],
            userGroups: [],
            timeZoneGroups: [],
            ugrEnabled: false,
            tzgEnabled: false,
            copyUser: null,
            isURAEnabled: false,
            isBTYEnabled: false,
            isTTAEnabled: false
        };

        _this.callbacks = {
            onCopyUserSelectionCallback: onCopyUserSelectionCallback,
            onCloseCallback: onCloseCallback
        };

        _this.onAnyStatePropertyChanged(['firstName', 'lastName', 'middleInitial'], function () {
            return _this._updateUsername();
        });
        _this.onAnyStatePropertyChanged(['users', 'userGroups', 'timeZoneGroups', 'ugrEnabled', 'tzgEnabled', 'copyUser', 'isURAEnabled', 'isBTYEnabled'], function () {
            return _this._updateCopySelector();
        });
        return _this;
    }

    _createClass(Header, [{
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='header userPanel_panelHeader'>" + "<div class='closeButton hideButton_panelContainer'></div>" + "    <div class='userName nameInfo ellipsis'></div>" + "    <div class='tabs'>" + "        <div class='accountSettings'><span class='tabText'><%=accountSettingsTab%></span></div>" + "        <div class='permissions'><span class='tabText'><%=permissionsTab%></span></div>" + "    </div>" + "    <div class='copySettingPlaceholder'/>" + "    <div class='spinner'/>" + "</div>";
        }
    }, {
        key: "messageKeys",
        value: function messageKeys() {
            return {
                accountSettingsTab: "user.panel.header.tabs.account",
                permissionsTab: "user.panel.header.tabs.permissions",
                deleteButton: "user.panel.header.delete"
            };
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            var _this2 = this;

            this.$userName = this.find('.userName');
            this.$accountSettingsTab = this.find('.accountSettings');
            this.$permissionsTab = this.find('.permissions');
            this.$closeButton = this.find('.closeButton');

            this.copyUserSelector = new _CopyUserSelector2.default({
                title: _messageResource2.default.getMessage("user.add.js.copy_setting.selector.label"),
                selectionCallback: function selectionCallback(selectedUser) {
                    _this2.copyAccountButton.setState({ selectedUser: selectedUser });
                    _this2.copyUserSelector.hide();
                    _this2.callbacks.onCopyUserSelectionCallback(selectedUser.id);
                },
                showPermissionIcons: true,
                renderTo: this.$el
            }).init();

            this.copyAccountButton = new _CopySettingsFromButton2.default().init(this.find(".copySettingPlaceholder"));
            this.copyAccountButton.bindClick(function () {
                return _this2.copyUserSelector.showAt(_this2.copyAccountButton.$el, "tr-br");
            });

            this.$closeButton.click(this.callbacks.onCloseCallback);
        }
    }, {
        key: "_updateUsername",
        value: function _updateUsername() {
            var nameInfo = _messageResource2.default.getMessage('user.add.js.new');
            if (this.state.firstName || this.state.lastName) {
                nameInfo += ': ' + (0, _UserNameFormat.formatFmlWithCheck)({
                    firstName: this.state.firstName,
                    middleInitial: this.state.middleInitial,
                    lastName: this.state.lastName
                });
            }
            this.$userName.text(nameInfo);
        }
    }, {
        key: "_updateCopySelector",
        value: function _updateCopySelector() {
            this.copyAccountButton.setState({
                selectedUser: this.state.copyUser
            });

            this.copyUserSelector.setState({
                users: this.state.users,
                userGroups: this.state.userGroups,
                timeZoneGroups: this.state.timeZoneGroups,
                ugrEnabled: this.state.ugrEnabled,
                tzgEnabled: this.state.tzgEnabled,
                isURAEnabled: this.state.isURAEnabled,
                isBTYEnabled: this.state.isBTYEnabled,
                isTTAEnabled: this.state.isTTAEnabled
            });
        }
    }]);

    return Header;
}(_TemplateView3.default);

exports.default = Header;

/***/ }),
/* 1677 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _UserNameFormat = __webpack_require__(17);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CopySettingsFromButton = function (_TemplateView) {
    _inherits(CopySettingsFromButton, _TemplateView);

    function CopySettingsFromButton() {
        _classCallCheck(this, CopySettingsFromButton);

        var _this = _possibleConstructorReturn(this, (CopySettingsFromButton.__proto__ || Object.getPrototypeOf(CopySettingsFromButton)).call(this));

        _this.state = {
            selectedUser: null
        };

        _this.onStatePropertyChanged('selectedUser', function (user) {
            var username = user ? (0, _UserNameFormat.formatFML)(user.firstName, user.lastName, user.middleName) : "";
            var buttonTitle = user ? _messageResource2.default.getMessage("user.add.js.copy_settings_from", [username]) : _messageResource2.default.getMessage("user.add.js.copy_settings_from.empty");

            _this.$userButton.text(buttonTitle);
        });
        return _this;
    }

    _createClass(CopySettingsFromButton, [{
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='buttonWrapper'>" + "    <div class='user ellipsis'/>" + "</div>";
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            this.$userButton = this.find('.user');
            this.renderInitialState();
        }
    }]);

    return CopySettingsFromButton;
}(_TemplateView3.default);

exports.default = CopySettingsFromButton;

/***/ }),
/* 1678 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _UserNameFormat = __webpack_require__(17);

var _UserNameFormat2 = _interopRequireDefault(_UserNameFormat);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _date_format = __webpack_require__(16);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AccountCreatedContainer = function (_TemplateView) {
    _inherits(AccountCreatedContainer, _TemplateView);

    function AccountCreatedContainer(_ref) {
        var _ref$onInviteOneMoreU = _ref.onInviteOneMoreUserCb,
            onInviteOneMoreUserCb = _ref$onInviteOneMoreU === undefined ? function () {} : _ref$onInviteOneMoreU,
            _ref$onCloseCb = _ref.onCloseCb,
            onCloseCb = _ref$onCloseCb === undefined ? function () {} : _ref$onCloseCb;

        _classCallCheck(this, AccountCreatedContainer);

        var _this = _possibleConstructorReturn(this, (AccountCreatedContainer.__proto__ || Object.getPrototypeOf(AccountCreatedContainer)).call(this, null));

        _this.state = {
            firstName: '',
            lastName: '',
            middleInitial: '',
            email: '',
            hireDate: null,
            invitationSent: false,
            inviteOneMoreDisabled: false
        };

        _this.callbacks = {
            onInviteOneMoreUserCb: onInviteOneMoreUserCb,
            onCloseCb: onCloseCb
        };

        _this.onStateChanged(function (state) {
            return _this._update();
        });
        return _this;
    }

    _createClass(AccountCreatedContainer, [{
        key: "templateHtml",
        value: function templateHtml() {
            return '<div class="createUserPanel_accountCreatedContainer">' + '    <div class="invitationImg"/>' + '    <div class="invitationInfoHeader"></div>' + '    <div class="invitationInfo"></div>' + '    <div class="inviteOneMoreButton">' + '        <div class="addIcon"/>' + '        <span><%-inviteOneMoreUser%></span>' + '    </div>' + '    <div class="closeLink"><span><%-closeLink%></span></div>' + '</div>';
        }
    }, {
        key: "_update",
        value: function _update() {
            var _this2 = this;

            this.getEl().toggleClass("letterWillBeSent", !this.state.invitationSent);

            var formattedUserName = _UserNameFormat2.default.formatFML(this.state.firstName, this.state.lastName, this.state.middleInitial);
            var invitationInfoHeader = _messageResource2.default.getEscapedMessage("user.created.account_has_been_created", [formattedUserName]);
            this.find(".invitationInfoHeader").html(invitationInfoHeader);

            var formattedHireDate = new _date_format.DateFormat(window.SystemSettings.dateFormat).formatDate(this.state.hireDate.parseJSONDate());
            var invitationInfoText = this.state.invitationSent ? _messageResource2.default.getEscapedMessage("user.created.invitation_info.letter_sent", [this.state.email]) : _messageResource2.default.getEscapedMessage("user.created.invitation_info.hire_date_in_future", [this.state.email, formattedHireDate]);
            this.find(".invitationInfo").html(invitationInfoText);

            this.find('.inviteOneMoreButton').toggle(!this.state.inviteOneMoreDisabled);
            if (!this.state.inviteOneMoreDisabled) {
                this.find('.inviteOneMoreButton span').click(function () {
                    return _this2.callbacks.onInviteOneMoreUserCb();
                });
            }

            this.find(".closeLink span").click(function () {
                return _this2.callbacks.onCloseCb();
            });
        }
    }, {
        key: "messageKeys",
        value: function messageKeys() {
            return {
                inviteOneMoreUser: "user.created.invite_one_more_user",
                closeLink: "common.close"
            };
        }
    }]);

    return AccountCreatedContainer;
}(_TemplateView3.default);

exports.default = AccountCreatedContainer;

/***/ }),
/* 1679 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CreateUserManagementAssignmentsEditorPanel = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _utils = __webpack_require__(6);

var _selectors = __webpack_require__(398);

var _redux = __webpack_require__(7);

var _ManagementAssignmentsEditorPanel = __webpack_require__(881);

var _CreateUserManagementAssignmentsEditor = __webpack_require__(1693);

var _CreateUserManagementAssignmentsEditor2 = _interopRequireDefault(_CreateUserManagementAssignmentsEditor);

var _actions = __webpack_require__(148);

var _actions2 = __webpack_require__(262);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CreateUserManagementAssignmentsEditorPanel = exports.CreateUserManagementAssignmentsEditorPanel = function (_ManagementAssignment) {
    _inherits(CreateUserManagementAssignmentsEditorPanel, _ManagementAssignment);

    function CreateUserManagementAssignmentsEditorPanel(params) {
        _classCallCheck(this, CreateUserManagementAssignmentsEditorPanel);

        return _possibleConstructorReturn(this, (CreateUserManagementAssignmentsEditorPanel.__proto__ || Object.getPrototypeOf(CreateUserManagementAssignmentsEditorPanel)).call(this, _extends({
            hierarchyAssignmentsEditor: new _CreateUserManagementAssignmentsEditor2.default(),
            extraClass: 'userManagement_managementAssignmentsEditorPanel createUserAssignmentPanel'
        }, params)));
    }

    return CreateUserManagementAssignmentsEditorPanel;
}(_ManagementAssignmentsEditorPanel.ManagementAssignmentsEditorPanel);

exports.default = (0, _utils.connect)(function (state) {
    return {
        show: (0, _selectors.showEditor)(state)
    };
}, function (dispatch) {
    return {
        closeEditor: (0, _redux.bindActionCreators)(_actions2.closeEditor, dispatch),
        closeAllPanels: (0, _redux.bindActionCreators)(_actions.cancelUserCreation, dispatch)
    };
})(CreateUserManagementAssignmentsEditorPanel);

/***/ }),
/* 1680 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _Breadcrumb = __webpack_require__(1681);

var _Breadcrumb2 = _interopRequireDefault(_Breadcrumb);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BreadcrumbsPanel = function (_TemplateView) {
    _inherits(BreadcrumbsPanel, _TemplateView);

    function BreadcrumbsPanel(_ref) {
        var _ref$onCustomerClose = _ref.onCustomerClose,
            onCustomerClose = _ref$onCustomerClose === undefined ? function () {} : _ref$onCustomerClose,
            _ref$onProjectClose = _ref.onProjectClose,
            onProjectClose = _ref$onProjectClose === undefined ? function () {} : _ref$onProjectClose;

        _classCallCheck(this, BreadcrumbsPanel);

        var _this = _possibleConstructorReturn(this, (BreadcrumbsPanel.__proto__ || Object.getPrototypeOf(BreadcrumbsPanel)).call(this));

        _this.callbacks = {
            onCustomerClose: onCustomerClose,
            onProjectClose: onProjectClose
        };

        _this.state = {
            customerName: '',
            projectName: ''
        };

        _this.onStateDeeplyChanged(function (state) {
            _this.customerBreadcrumb.setState({
                text: state.customerName
            });
            _this.projectBreadcrumb.setState({
                text: state.projectName
            });

            _this.$customer.toggle(!!state.customerName);
            _this.$project.toggle(!!state.projectName);
            _this.$separator.toggle(!!state.projectName);
        });
        return _this;
    }

    _createClass(BreadcrumbsPanel, [{
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='breadcrumbsPanel'>" + "  <div class='breadcrumbContainer customer'></div>" + "  <div class='projectBreadcrumbContainer'>" + "    <div class='separator'></div>" + "    <div class='breadcrumbContainer project'></div>" + "</div>" + "</div>";
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            var _this2 = this;

            this.$customer = this.find('.customer');
            this.customerBreadcrumb = new _Breadcrumb2.default({
                onClose: function onClose() {
                    return _this2.callbacks.onCustomerClose();
                }
            }).init(this.$customer);
            this.customerBreadcrumb.setState({
                caption: _messageResource2.default.getMessage('common.Customer')
            });

            this.$separator = this.find('.separator');
            this.$project = this.find('.project');
            this.projectBreadcrumb = new _Breadcrumb2.default({
                onClose: function onClose() {
                    return _this2.callbacks.onProjectClose();
                }
            }).init(this.$project);
            this.projectBreadcrumb.setState({
                caption: _messageResource2.default.getMessage('common.Project')
            });

            this.renderInitialState();
        }
    }]);

    return BreadcrumbsPanel;
}(_TemplateView3.default);

exports.default = BreadcrumbsPanel;

/***/ }),
/* 1681 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Breadcrumb = function (_TemplateView) {
    _inherits(Breadcrumb, _TemplateView);

    function Breadcrumb(_ref) {
        var _ref$onClose = _ref.onClose,
            onClose = _ref$onClose === undefined ? function () {} : _ref$onClose;

        _classCallCheck(this, Breadcrumb);

        var _this = _possibleConstructorReturn(this, (Breadcrumb.__proto__ || Object.getPrototypeOf(Breadcrumb)).call(this));

        _this.onClose = onClose;

        _this.state = {
            caption: '',
            text: ''
        };

        _this.onStatePropertyChanged('caption', function (caption) {
            return _this.$caption.text(caption + ':');
        });
        _this.onStatePropertyChanged('text', function (text) {
            return _this.$text.text(text);
        });
        return _this;
    }

    _createClass(Breadcrumb, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return "<div class='breadcrumb'>" + "  <div class='caption'></div>" + "  <div class='text'></div>" + "  <div class='closeIcon'></div> " + "</div>";
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            var _this2 = this;

            this.$caption = this.find('.caption');
            this.$text = this.find('.text');
            this.find('.closeIcon').click(function () {
                return _this2.onClose();
            });
        }
    }]);

    return Breadcrumb;
}(_TemplateView3.default);

exports.default = Breadcrumb;

/***/ }),
/* 1682 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _AssignAllMenu = __webpack_require__(1683);

var _AssignAllMenu2 = _interopRequireDefault(_AssignAllMenu);

var _AssignAllMenuButton = __webpack_require__(1684);

var _AssignAllMenuButton2 = _interopRequireDefault(_AssignAllMenuButton);

var _WordsFilter = __webpack_require__(400);

var _WordsFilter2 = _interopRequireDefault(_WordsFilter);

var _OnlyActiveSwitch = __webpack_require__(1685);

var _OnlyActiveSwitch2 = _interopRequireDefault(_OnlyActiveSwitch);

var _Switcher = __webpack_require__(236);

var _Switcher2 = _interopRequireDefault(_Switcher);

var _StringUtils = __webpack_require__(121);

var _SimpleSingletonTooltip = __webpack_require__(45);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EntitiesListHeader = function (_TemplateView) {
    _inherits(EntitiesListHeader, _TemplateView);

    function EntitiesListHeader(_ref) {
        var _ref$title = _ref.title,
            title = _ref$title === undefined ? "" : _ref$title,
            _ref$nameColumnHeader = _ref.nameColumnHeaderTitle,
            nameColumnHeaderTitle = _ref$nameColumnHeader === undefined ? "" : _ref$nameColumnHeader,
            _ref$countersColumnHe = _ref.countersColumnHeaderTitle,
            countersColumnHeaderTitle = _ref$countersColumnHe === undefined ? "" : _ref$countersColumnHe,
            _ref$assignAllLabel = _ref.assignAllLabel,
            assignAllLabel = _ref$assignAllLabel === undefined ? "" : _ref$assignAllLabel,
            _ref$unassignAllLabel = _ref.unassignAllLabel,
            unassignAllLabel = _ref$unassignAllLabel === undefined ? "" : _ref$unassignAllLabel,
            _ref$showOnlyActiveSw = _ref.showOnlyActiveSwitch,
            showOnlyActiveSwitch = _ref$showOnlyActiveSw === undefined ? false : _ref$showOnlyActiveSw,
            _ref$onlyActiveSelect = _ref.onlyActiveSelectedText,
            onlyActiveSelectedText = _ref$onlyActiveSelect === undefined ? '' : _ref$onlyActiveSelect,
            _ref$allStatusesSelec = _ref.allStatusesSelectedText,
            allStatusesSelectedText = _ref$allStatusesSelec === undefined ? '' : _ref$allStatusesSelec,
            _ref$onAssignAll = _ref.onAssignAll,
            onAssignAll = _ref$onAssignAll === undefined ? function () {} : _ref$onAssignAll,
            _ref$onUnassignAll = _ref.onUnassignAll,
            onUnassignAll = _ref$onUnassignAll === undefined ? function () {} : _ref$onUnassignAll,
            _ref$onOnlyActiveChan = _ref.onOnlyActiveChanged,
            onOnlyActiveChanged = _ref$onOnlyActiveChan === undefined ? function (onlyActive) {} : _ref$onOnlyActiveChan,
            _ref$onChangeExisting = _ref.onChangeExistingAndFutureAssignment,
            onChangeExistingAndFutureAssignment = _ref$onChangeExisting === undefined ? function (assigned) {} : _ref$onChangeExisting,
            _ref$onSearchTextChan = _ref.onSearchTextChanged,
            onSearchTextChanged = _ref$onSearchTextChan === undefined ? function (text) {} : _ref$onSearchTextChan,
            _ref$hideSearch = _ref.hideSearch,
            hideSearch = _ref$hideSearch === undefined ? function () {} : _ref$hideSearch,
            _ref$titleMessageSwit = _ref.titleMessageSwitcher,
            titleMessageSwitcher = _ref$titleMessageSwit === undefined ? '' : _ref$titleMessageSwit,
            _ref$additionalClass = _ref.additionalClass,
            additionalClass = _ref$additionalClass === undefined ? '' : _ref$additionalClass,
            _ref$workAssignmentsV = _ref.workAssignmentsVisible,
            workAssignmentsVisible = _ref$workAssignmentsV === undefined ? false : _ref$workAssignmentsV,
            _ref$managementAssign = _ref.managementAssignmentsEditable,
            managementAssignmentsEditable = _ref$managementAssign === undefined ? false : _ref$managementAssign;

        _classCallCheck(this, EntitiesListHeader);

        var _this = _possibleConstructorReturn(this, (EntitiesListHeader.__proto__ || Object.getPrototypeOf(EntitiesListHeader)).call(this));

        _this.params = {
            title: title,
            nameColumnHeaderTitle: nameColumnHeaderTitle,
            countersColumnHeaderTitle: countersColumnHeaderTitle,
            assignAllLabel: assignAllLabel,
            unassignAllLabel: unassignAllLabel,
            showOnlyActiveSwitch: showOnlyActiveSwitch,
            onlyActiveSelectedText: onlyActiveSelectedText,
            allStatusesSelectedText: allStatusesSelectedText,
            titleMessageSwitcher: titleMessageSwitcher,
            additionalClass: additionalClass,
            workAssignmentsVisible: workAssignmentsVisible,
            managementAssignmentsEditable: managementAssignmentsEditable
        };

        _this.callbacks = {
            onAssignAll: onAssignAll,
            onUnassignAll: onUnassignAll,
            onOnlyActiveChanged: onOnlyActiveChanged,
            onSearchTextChanged: onSearchTextChanged,
            hideSearch: hideSearch,
            onChangeExistingAndFutureAssignment: onChangeExistingAndFutureAssignment
        };

        _this.state = {
            futureAssigned: false,
            allAssigned: false,
            someAssigned: false,
            onlyActive: false,
            searchOpen: false,
            searchText: '',
            changingAllAssignments: false,
            disabledSwitcherTooltipText: '',
            disabledCheckboxTooltipText: '',
            listIsEmpty: false,
            isAssignAllCheckboxDisabled: false
        };

        _this.onAnyStatePropertyChanged(['allAssigned', 'someAssigned'], function (state) {
            _this.assignAllButton.setState({
                checked: state.allAssigned,
                indeterminate: state.someAssigned
            });
        });

        _this.onStatePropertyChanged('onlyActive', function (onlyActive) {
            if (_this.onlyActiveSwitch) {
                _this.onlyActiveSwitch.setState({
                    onlyActive: onlyActive
                });
            }
        });

        _this.onAnyStatePropertyChanged(['searchOpen', 'searchText', 'listIsEmpty'], function (state) {
            _this.wordsFilter.setState({
                open: state.searchOpen,
                text: state.searchText,
                disabled: state.listIsEmpty
            });
        });

        _this.onStatePropertyChanged('futureAssigned', function (futureAssigned) {
            if (_this.allExistingAndFutureSwitcher) {
                _this.allExistingAndFutureSwitcher.setState({
                    enabled: futureAssigned
                });
            }
        });

        _this.onAnyStatePropertyDeeplyChanged(['disabledCheckboxTooltipText', 'isAssignAllCheckboxDisabled'], function (state) {
            _this.assignAllButton.setState({
                disabled: state.isAssignAllCheckboxDisabled
            });

            _this.unsubscribeAssignAllTooltip && _this.unsubscribeAssignAllTooltip();
            if (state.isAssignAllCheckboxDisabled) {
                _this._createTooltipOnAllAssignButton(state.disabledCheckboxTooltipText);
            }
        });

        _this.onStatePropertyChanged('disabledSwitcherTooltipText', function (text) {
            if (_this.allExistingAndFutureSwitcher) {
                _this.allExistingAndFutureSwitcher.setState({
                    readOnly: !!text
                });

                _this.unsubscribeAllExistingAndFutureTooltip && _this.unsubscribeAllExistingAndFutureTooltip();
                if (text) {
                    _this.unsubscribeAllExistingAndFutureTooltip = (0, _SimpleSingletonTooltip.getInstance)().subscribeToMouseEvents(_this.allExistingAndFutureSwitcher.getEl(), function () {
                        return (0, _SimpleSingletonTooltip.getInstance)().setState({
                            text: text,
                            extraClass: 'hierarchyAssignmentsTooltip'
                        });
                    });
                }
            }
        });
        return _this;
    }

    _createClass(EntitiesListHeader, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return "<div class='entitiesListHeader'>" + "  <div class='mainHeaderContainer'>" + "    <div class='title'><%-params.title%></div>" + "    <div class='allExistingFuturesBlock'>" + "        <div class='allExistingFuturesSwitcher'></div>" + "        <div class='allExistingFuturesText'><%-params.titleMessageSwitcher%></div>" + "    </div>" + "  </div>" + "  <div class='columnHeaders'>" + "    <div class='searchFieldArea'>" + "      <div class='columnHeader allAssignedSelectorContainer'></div>" + "      <div class='columnHeader nameColumnHeader'>" + "        <div class='nameColumnHeaderTitle'><%-params.nameColumnHeaderTitle%></div>" + "      </div>" + "      <div class='wordsFilterPlaceholder'></div>" + "    </div>" + "    <%if (params.showOnlyActiveSwitch) {%>" + "      <div class='separator'></div>" + "      <div class='onlyActiveSwitchPlaceholder'></div>" + "    <%}%>" + "    <%if (params.countersColumnHeaderTitle) {%>" + "      <div class='columnHeader countersColumnHeader'><%-params.countersColumnHeaderTitle%></div>" + "     <%}%>" + "  </div>" + "</div>";
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            var _this2 = this;

            this.$allAssignedSelectorContainer = this.find('.allAssignedSelectorContainer');

            this.assignAllMenu = new _AssignAllMenu2.default({
                assignAllLabel: this.params.assignAllLabel,
                unassignAllLabel: this.params.unassignAllLabel,
                onAssignAll: function onAssignAll() {
                    return _this2.callbacks.onAssignAll();
                },
                onUnassignAll: function onUnassignAll() {
                    return _this2.callbacks.onUnassignAll();
                }
            }).init(this.$allAssignedSelectorContainer);

            this.assignAllButton = new _AssignAllMenuButton2.default({
                additionalClass: this.params.additionalClass,
                onClick: function onClick() {
                    return _this2.assignAllMenu.showAt(_this2.assignAllButton.getEl());
                }
            }).init(this.$allAssignedSelectorContainer);

            if (this.params.showOnlyActiveSwitch) {
                this.onlyActiveSwitch = new _OnlyActiveSwitch2.default({
                    onlyActiveSelectedText: this.params.onlyActiveSelectedText,
                    allStatusesSelectedText: this.params.allStatusesSelectedText,
                    onChanged: function onChanged(onlyActive) {
                        return _this2.callbacks.onOnlyActiveChanged(onlyActive);
                    }
                }).init(this.find('.onlyActiveSwitchPlaceholder'));
            }

            this.wordsFilter = new _WordsFilter2.default({
                onChange: function onChange(text) {
                    return _this2.callbacks.onSearchTextChanged(text);
                },
                onHide: function onHide() {
                    return _this2.callbacks.hideSearch();
                }
            }).init(this.find('.wordsFilterPlaceholder'));

            this.$allExistingFuturesSwitcher = this.find('.allExistingFuturesSwitcher');
            if ((0, _StringUtils.isNotEmptyString)(this.params.titleMessageSwitcher)) {
                this.allExistingAndFutureSwitcher = new _Switcher2.default({
                    additionalClass: 'small',
                    onSwitchCallback: function onSwitchCallback(enabled) {
                        return _this2.callbacks.onChangeExistingAndFutureAssignment(enabled);
                    }
                }).init(this.$allExistingFuturesSwitcher);
            }
        }
    }, {
        key: '_createTooltipOnAllAssignButton',
        value: function _createTooltipOnAllAssignButton() {
            var _this3 = this;

            this.unsubscribeAssignAllTooltip = (0, _SimpleSingletonTooltip.getInstance)().subscribeToMouseEvents(this.assignAllButton.getEl(), function () {
                return (0, _SimpleSingletonTooltip.getInstance)().setState({
                    text: _this3.state.disabledCheckboxTooltipText,
                    extraClass: 'hierarchyAssignmentsTooltip'
                });
            });
        }
    }]);

    return EntitiesListHeader;
}(_TemplateView3.default);

exports.default = EntitiesListHeader;

/***/ }),
/* 1683 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _DropdownTemplateView2 = __webpack_require__(42);

var _DropdownTemplateView3 = _interopRequireDefault(_DropdownTemplateView2);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AssignAllMenu = function (_DropdownTemplateView) {
    _inherits(AssignAllMenu, _DropdownTemplateView);

    function AssignAllMenu(_ref) {
        var _ref$assignAllLabel = _ref.assignAllLabel,
            assignAllLabel = _ref$assignAllLabel === undefined ? '' : _ref$assignAllLabel,
            _ref$unassignAllLabel = _ref.unassignAllLabel,
            unassignAllLabel = _ref$unassignAllLabel === undefined ? '' : _ref$unassignAllLabel,
            _ref$onAssignAll = _ref.onAssignAll,
            onAssignAll = _ref$onAssignAll === undefined ? function () {} : _ref$onAssignAll,
            _ref$onUnassignAll = _ref.onUnassignAll,
            onUnassignAll = _ref$onUnassignAll === undefined ? function () {} : _ref$onUnassignAll;

        _classCallCheck(this, AssignAllMenu);

        var _this = _possibleConstructorReturn(this, (AssignAllMenu.__proto__ || Object.getPrototypeOf(AssignAllMenu)).call(this));

        _this.params = {
            assignAllLabel: assignAllLabel,
            unassignAllLabel: unassignAllLabel
        };

        _this.callbacks = {
            onAssignAll: onAssignAll,
            onUnassignAll: onUnassignAll
        };
        return _this;
    }

    _createClass(AssignAllMenu, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return "<div class='userManagement_hierarchyAssignmentsEditor_assignAllMenu'>" + "  <div class='item assignAll'><%-params.assignAllLabel%></div>" + "  <div class='item unassignAll'><%-params.unassignAllLabel%></div>" + "</div>";
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            var _this2 = this;

            this.find('.assignAll').click(function (e) {
                e.stopPropagation();
                _this2.hide();
                _this2.callbacks.onAssignAll();
            });
            this.find('.unassignAll').click(function (e) {
                e.stopPropagation();
                _this2.hide();
                _this2.callbacks.onUnassignAll();
            });
        }
    }, {
        key: 'mouseDownTargetElement',
        value: function mouseDownTargetElement() {
            return (0, _jquery2.default)('body');
        }
    }]);

    return AssignAllMenu;
}(_DropdownTemplateView3.default);

exports.default = AssignAllMenu;

/***/ }),
/* 1684 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _CheckboxIcon = __webpack_require__(885);

var _CheckboxIcon2 = _interopRequireDefault(_CheckboxIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AssignAllMenuButton = function (_TemplateView) {
    _inherits(AssignAllMenuButton, _TemplateView);

    function AssignAllMenuButton(_ref) {
        var _ref$onClick = _ref.onClick,
            onClick = _ref$onClick === undefined ? function () {} : _ref$onClick,
            _ref$additionalClass = _ref.additionalClass,
            additionalClass = _ref$additionalClass === undefined ? '' : _ref$additionalClass;

        _classCallCheck(this, AssignAllMenuButton);

        var _this = _possibleConstructorReturn(this, (AssignAllMenuButton.__proto__ || Object.getPrototypeOf(AssignAllMenuButton)).call(this));

        _this.onClick = onClick;
        _this.additionalClass = additionalClass;

        _this.state = {
            checked: false,
            indeterminate: false,
            disabled: false
        };

        _this.onAnyStatePropertyChanged(['checked', 'indeterminate'], function (_ref2) {
            var checked = _ref2.checked,
                indeterminate = _ref2.indeterminate;
            return _this.checkbox.setState({
                checked: checked,
                indeterminate: !checked && indeterminate
            });
        });
        _this.onStatePropertyChanged('disabled', function (disabled) {
            return _this.$el.toggleClass('disabled', disabled);
        });
        return _this;
    }

    _createClass(AssignAllMenuButton, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return "<div class='assignAllMenuButton <%=additionalClass%>'>" + "  <div class='checkboxPlaceholder'></div>" + "  <div class='icon'></div>" + "</div>";
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            var _this2 = this;

            this.checkbox = new _CheckboxIcon2.default().init(this.find('.checkboxPlaceholder'));

            this.$el.click(function () {
                if (!_this2.state.disabled) {
                    _this2.onClick();
                }
            });
        }
    }]);

    return AssignAllMenuButton;
}(_TemplateView3.default);

exports.default = AssignAllMenuButton;

/***/ }),
/* 1685 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OnlyActiveSwitch = function (_TemplateView) {
    _inherits(OnlyActiveSwitch, _TemplateView);

    function OnlyActiveSwitch(_ref) {
        var _ref$onlyActiveSelect = _ref.onlyActiveSelectedText,
            onlyActiveSelectedText = _ref$onlyActiveSelect === undefined ? '' : _ref$onlyActiveSelect,
            _ref$allStatusesSelec = _ref.allStatusesSelectedText,
            allStatusesSelectedText = _ref$allStatusesSelec === undefined ? '' : _ref$allStatusesSelec,
            _ref$onChanged = _ref.onChanged,
            onChanged = _ref$onChanged === undefined ? function (onlyActive) {} : _ref$onChanged;

        _classCallCheck(this, OnlyActiveSwitch);

        var _this = _possibleConstructorReturn(this, (OnlyActiveSwitch.__proto__ || Object.getPrototypeOf(OnlyActiveSwitch)).call(this));

        _this.params = {
            onlyActiveSelectedText: onlyActiveSelectedText,
            allStatusesSelectedText: allStatusesSelectedText
        };

        _this.callbacks = {
            onChanged: onChanged
        };

        _this.state = {
            onlyActive: false
        };

        _this.onStatePropertyChanged('onlyActive', function (onlyActive) {
            _this.$el.text(!onlyActive ? _this.params.onlyActiveSelectedText : _this.params.allStatusesSelectedText);
        });
        return _this;
    }

    _createClass(OnlyActiveSwitch, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return "<div class='onlyActiveSwitcher'></div>";
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            var _this2 = this;

            this.$el.click(function () {
                var newOnlyActiveValue = !_this2.state.onlyActive;
                _this2.setState({
                    onlyActive: newOnlyActiveValue
                });
                _this2.callbacks.onChanged(newOnlyActiveValue);
            });

            this.renderInitialState();
        }
    }]);

    return OnlyActiveSwitch;
}(_TemplateView3.default);

exports.default = OnlyActiveSwitch;

/***/ }),
/* 1686 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Header = function (_TemplateView) {
    _inherits(Header, _TemplateView);

    function Header(_ref) {
        var messageKey = _ref.messageKey;

        _classCallCheck(this, Header);

        var _this = _possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).call(this));

        _this.state = {
            name: ''
        };

        _this.onStatePropertyChanged('name', function (name) {
            _this.$el.text(_messageResource2.default.getMessage(messageKey, [name]));
        });
        return _this;
    }

    _createClass(Header, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return "<div class='header'></div>";
        }
    }]);

    return Header;
}(_TemplateView3.default);

exports.default = Header;

/***/ }),
/* 1687 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _EntityListItem = __webpack_require__(1688);

var _EntityListItem2 = _interopRequireDefault(_EntityListItem);

var _LoadingContainer = __webpack_require__(28);

var _LoadingContainer2 = _interopRequireDefault(_LoadingContainer);

var _ComponentsList = __webpack_require__(1690);

var _ComponentsList2 = _interopRequireDefault(_ComponentsList);

var _constants = __webpack_require__(4);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EntitiesList = function (_TemplateView) {
    _inherits(EntitiesList, _TemplateView);

    function EntitiesList(_ref) {
        var _ref$hierarchyLevel = _ref.hierarchyLevel,
            hierarchyLevel = _ref$hierarchyLevel === undefined ? '' : _ref$hierarchyLevel,
            _ref$showProjectsCoun = _ref.showProjectsCount,
            showProjectsCount = _ref$showProjectsCoun === undefined ? false : _ref$showProjectsCoun,
            _ref$showTasksCount = _ref.showTasksCount,
            showTasksCount = _ref$showTasksCount === undefined ? false : _ref$showTasksCount,
            _ref$workAssignmentsV = _ref.workAssignmentsVisible,
            workAssignmentsVisible = _ref$workAssignmentsV === undefined ? true : _ref$workAssignmentsV,
            _ref$managementAssign = _ref.managementAssignmentsEditable,
            managementAssignmentsEditable = _ref$managementAssign === undefined ? true : _ref$managementAssign,
            _ref$entitiesClickabl = _ref.entitiesClickable,
            entitiesClickable = _ref$entitiesClickabl === undefined ? false : _ref$entitiesClickabl,
            _ref$revokeMenu = _ref.revokeMenu,
            revokeMenu = _ref$revokeMenu === undefined ? null : _ref$revokeMenu,
            _ref$revokeMenuTextsM = _ref.revokeMenuTextsMaps,
            revokeMenuTextsMaps = _ref$revokeMenuTextsM === undefined ? {} : _ref$revokeMenuTextsM,
            _ref$onAssignmentChan = _ref.onAssignmentChange,
            onAssignmentChange = _ref$onAssignmentChan === undefined ? function (entityId, assigned) {} : _ref$onAssignmentChan,
            _ref$onEntityClick = _ref.onEntityClick,
            onEntityClick = _ref$onEntityClick === undefined ? function (entityId) {} : _ref$onEntityClick,
            _ref$checkIfViewerCan = _ref.checkIfViewerCanManage,
            checkIfViewerCanManage = _ref$checkIfViewerCan === undefined ? function (itemId) {
            return false;
        } : _ref$checkIfViewerCan;

        _classCallCheck(this, EntitiesList);

        var _this = _possibleConstructorReturn(this, (EntitiesList.__proto__ || Object.getPrototypeOf(EntitiesList)).call(this));

        _this.params = {
            hierarchyLevel: hierarchyLevel,
            showProjectsCount: showProjectsCount,
            showTasksCount: showTasksCount,
            workAssignmentsVisible: workAssignmentsVisible,
            managementAssignmentsEditable: managementAssignmentsEditable,
            entitiesClickable: entitiesClickable,
            revokeMenu: revokeMenu,
            revokeMenuTextsMaps: revokeMenuTextsMaps,
            checkIfViewerCanManage: checkIfViewerCanManage
        };

        _this.callbacks = {
            onAssignmentChange: onAssignmentChange,
            onEntityClick: onEntityClick
        };

        _this.state = {
            entities: [],
            futureAssigned: false,
            canWorkIds: {},
            canManageIds: {},
            canManageExcludeSelfIds: {},
            projectCounts: {},
            taskCounts: {},
            changingAssignments: {},
            topLevelAccess: false,
            readOnlyTooltipText: ""
        };

        _this.onStateChanged(function (_ref2) {
            var entities = _ref2.entities;
            return _this.componentsList.setState({
                items: entities
            });
        });
        return _this;
    }

    _createClass(EntitiesList, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return "<div class='entitiesList'></div>";
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            var _this2 = this;

            this.componentsList = new _ComponentsList2.default({
                itemToComponent: function itemToComponent(entity) {
                    return new _LoadingContainer2.default({
                        containerClass: 'entityItemLoadingWrapper',
                        contentComponent: new _EntityListItem2.default({
                            hierarchyLevel: _this2.params.hierarchyLevel,
                            showProjectsCount: _this2.params.showProjectsCount,
                            showTasksCount: _this2.params.showTasksCount,
                            clickable: _this2.params.entitiesClickable,
                            revokeMenu: _this2.params.revokeMenu,
                            revokeMenuTextsMaps: _this2.params.revokeMenuTextsMaps,
                            isArchived: entity.archived || !entity.archived && !entity.open,
                            onAssignmentChanged: function onAssignmentChanged(assigned) {
                                return _this2.callbacks.onAssignmentChange(entity.id, assigned);
                            },
                            onClick: function onClick() {
                                return _this2.callbacks.onEntityClick(entity.id);
                            }
                        })
                    });
                },
                itemToState: function itemToState(entity) {
                    var id = entity.id;
                    var canWork = !!_this2.state.canWorkIds[id];
                    var canManage = !!_this2.state.canManageIds[id];
                    var canManageExcludeSelf = _this2.state.canManageExcludeSelfIds[id];
                    var assigned = _this2.params.workAssignmentsVisible && canWork || canManage;
                    var viewerCanManage = _this2.params.checkIfViewerCanManage(id);
                    var disabled = !_this2.params.workAssignmentsVisible && _this2.state.futureAssigned || !_this2.params.managementAssignmentsEditable && canManage || _this2.params.workAssignmentsVisible && canManageExcludeSelf || !_this2.params.workAssignmentsVisible && _this2.state.topLevelAccess || !viewerCanManage;
                    var disabledCheckboxTooltipText = _this2.state.readOnlyTooltipText;
                    var hierarchyLevelName = "";
                    var childHierarchyLevelName = "";
                    if (_this2.params.hierarchyLevel === _constants.HierarchyLevels.CUSTOMER) {
                        hierarchyLevelName = _messageResource2.default.getMessage('common.customer');
                        childHierarchyLevelName = _messageResource2.default.getMessage('common.projects');
                    } else if (_this2.params.hierarchyLevel === _constants.HierarchyLevels.PROJECT) {
                        hierarchyLevelName = _messageResource2.default.getMessage('common.project');
                        childHierarchyLevelName = _messageResource2.default.getMessage('common.tasks');
                    } else if (_this2.params.hierarchyLevel === _constants.HierarchyLevels.TASK) {
                        hierarchyLevelName = _messageResource2.default.getMessage('common.task');
                    }

                    if (_this2.params.workAssignmentsVisible && !viewerCanManage) {
                        disabledCheckboxTooltipText = _messageResource2.default.getMessage('assigned_users_editor.work.disabled_tooltip.no_permission_to_manage', [hierarchyLevelName]);
                    } else if (_this2.params.workAssignmentsVisible && disabled && !_this2.state.topLevelAccess) {
                        if (canManageExcludeSelf) {
                            disabledCheckboxTooltipText = _messageResource2.default.getMessage('assigned_users_editor.disabled_tooltip.user_manage_all_existing_and_future', [hierarchyLevelName, childHierarchyLevelName]);
                        } else if (canManage) {
                            disabledCheckboxTooltipText = _messageResource2.default.getMessage('assigned_users_editor.work.disabled_tooltip.user_manages_item', [hierarchyLevelName]);
                        }
                    }

                    var canManageSubtitleText = '';
                    if (canManageExcludeSelf) {
                        canManageSubtitleText = _messageResource2.default.getMessage('userlist.ha_editor.can_manage_existing_and_future', [childHierarchyLevelName]);
                    } else if (canManage) {
                        canManageSubtitleText = _messageResource2.default.getMessage('userlist.ma_editor.can_manage');
                    }

                    return {
                        name: entity.name,
                        assigned: assigned,
                        disabled: disabled,
                        showCanManage: (canManage || canManageExcludeSelf) && _this2.params.workAssignmentsVisible,
                        projectsCount: _this2.state.projectCounts[id] || 0,
                        tasksCount: _this2.state.taskCounts[id] || 0,
                        loading: !!_this2.state.changingAssignments[id],
                        isArchived: entity.archived || _this2.params.hierarchyLevel === _constants.HierarchyLevels.TASK && !entity.open,
                        disabledTooltipText: disabledCheckboxTooltipText,
                        canManageSubtitleText: canManageSubtitleText
                    };
                }
            }).init(this.$el);
        }
    }]);

    return EntitiesList;
}(_TemplateView3.default);

exports.default = EntitiesList;

/***/ }),
/* 1688 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _constants = __webpack_require__(261);

var _constants2 = __webpack_require__(4);

var _IndeterminateCustomCheckboxWithMenu = __webpack_require__(1689);

var _IndeterminateCustomCheckboxWithMenu2 = _interopRequireDefault(_IndeterminateCustomCheckboxWithMenu);

var _SimpleSingletonTooltip = __webpack_require__(45);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EntityListItem = function (_TemplateView) {
    _inherits(EntityListItem, _TemplateView);

    function EntityListItem(_ref) {
        var _ref$hierarchyLevel = _ref.hierarchyLevel,
            hierarchyLevel = _ref$hierarchyLevel === undefined ? '' : _ref$hierarchyLevel,
            _ref$showProjectsCoun = _ref.showProjectsCount,
            showProjectsCount = _ref$showProjectsCoun === undefined ? false : _ref$showProjectsCoun,
            _ref$showTasksCount = _ref.showTasksCount,
            showTasksCount = _ref$showTasksCount === undefined ? false : _ref$showTasksCount,
            _ref$clickable = _ref.clickable,
            clickable = _ref$clickable === undefined ? false : _ref$clickable,
            _ref$isArchived = _ref.isArchived,
            isArchived = _ref$isArchived === undefined ? false : _ref$isArchived,
            _ref$onAssignmentChan = _ref.onAssignmentChanged,
            onAssignmentChanged = _ref$onAssignmentChan === undefined ? function (assigned) {} : _ref$onAssignmentChan,
            _ref$onClick = _ref.onClick,
            onClick = _ref$onClick === undefined ? function () {} : _ref$onClick,
            _ref$revokeMenu = _ref.revokeMenu,
            revokeMenu = _ref$revokeMenu === undefined ? null : _ref$revokeMenu,
            _ref$revokeMenuTextsM = _ref.revokeMenuTextsMaps,
            revokeMenuTextsMaps = _ref$revokeMenuTextsM === undefined ? {} : _ref$revokeMenuTextsM;

        _classCallCheck(this, EntityListItem);

        var _this = _possibleConstructorReturn(this, (EntityListItem.__proto__ || Object.getPrototypeOf(EntityListItem)).call(this));

        _this.props = {
            hierarchyLevel: hierarchyLevel,
            showProjectsCount: showProjectsCount,
            showTasksCount: showTasksCount,
            clickable: clickable,
            revokeMenu: revokeMenu,
            revokeMenuTextsMaps: revokeMenuTextsMaps
        };

        _this.callbacks = {
            onAssignmentChanged: onAssignmentChanged,
            onClick: onClick
        };

        _this.state = {
            name: '',
            assigned: false,
            disabled: false,
            projectsCount: null,
            tasksCount: null,
            isArchived: false,
            disabledTooltipText: "",
            canManageSubtitleText: "",
            showCanManage: false
        };

        _this.onStatePropertyChanged('name', function (name) {
            return _this.$name.text(name);
        });

        _this.onAnyStatePropertyChanged(['disabled', 'disabledTooltipText'], function (_ref2) {
            var disabled = _ref2.disabled,
                disabledTooltipText = _ref2.disabledTooltipText;

            _this.$el.toggleClass('disabled', disabled);
            _this.checkbox.setState({
                disabled: disabled
            });

            _this.unsubscribeTooltip && _this.unsubscribeTooltip();
            if (disabled && disabledTooltipText) {
                _this.unsubscribeTooltip = (0, _SimpleSingletonTooltip.getInstance)().subscribeToMouseEvents(_this.checkbox.getEl(), function () {
                    (0, _SimpleSingletonTooltip.getInstance)().setState({
                        text: disabledTooltipText,
                        extraClass: 'hierarchyAssignmentsTooltip'
                    });
                });
            }
        });

        _this.onAnyStatePropertyChanged(['projectsCount', 'tasksCount', 'assigned', 'isArchived', 'showCanManage', 'canManageSubtitleText'], function (_ref3) {
            var projectsCount = _ref3.projectsCount,
                tasksCount = _ref3.tasksCount,
                assigned = _ref3.assigned,
                isArchived = _ref3.isArchived,
                showCanManage = _ref3.showCanManage,
                canManageSubtitleText = _ref3.canManageSubtitleText;

            _this.$projectsCountContainer.toggle(assigned || projectsCount > 0);
            _this.$tasksCountContainer.toggle(assigned || tasksCount > 0);

            if (!assigned) {
                _this.$projectsCount.text(projectsCount);
                _this.$tasksCount.text(tasksCount);
            } else {
                var message = _messageResource2.default.getMessage('common.all');
                _this.$projectsCount.text(message);
                _this.$tasksCount.text(message);
            }

            _this.checkbox.setState({
                checked: assigned,
                indeterminate: !assigned && projectsCount + tasksCount > 0
            });

            if (isArchived) {
                _this.$archivedSubTitle.text(_this.props.hierarchyLevel === _constants2.HierarchyLevels.TASK ? _messageResource2.default.getMessage('panel.common.completed') : _messageResource2.default.getMessage('panel.common.archived'));
            }

            _this.find('.tasksCounterContainer').toggleClass('tasksCounterContainerCenter', _this.props.hierarchyLevel === _constants2.HierarchyLevels.PROJECT);

            _this.$archivedSubTitle.toggle(isArchived);

            _this.$canManageSubTitle.toggle(showCanManage);
            _this.$canManageSubTitle.text(canManageSubtitleText);
            _this.$nameContainer.toggleClass('canManage', showCanManage);

            _this.$el.toggleClass('assigned', assigned);
        });
        return _this;
    }

    _createClass(EntityListItem, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return "<div class='entityListItem <%=hierarchyLevelClass%>'>" + "  <div class='checkboxPlaceholder'></div>" + "    <div class='nameCounterContainer'>" + "        <div class='nameContainer'>" + "            <div class='fixedNameContent'>" + "                <div class='name'></div>" + "                <div class='archivedSubTitle'></div>" + "            </div>" + "            <div class='canManageSubTitle'></div>" + "        </div>" + "        <div class='counters'> " + "        <%if (showProjectsCount) {%>" + "        <div class='projectsCounterContainer'>" + "            <div class='counter projects <%=projectsCounterClass%>'></div>" + "        </div>" + "        <%}%>" + "        <%if (showTasksCount) {%>" + "        <div class='tasksCounterContainer'>" + "            <div class='counter tasks <%=tasksCounterClass%>'></div>" + "        </div>" + "        <%}%>" + "        </div>" + "  </div>" + "</div>";
        }
    }, {
        key: 'templateModel',
        value: function templateModel() {
            return {
                showProjectsCount: this.props.showProjectsCount,
                showTasksCount: this.props.showTasksCount,
                hierarchyLevelClass: _constants.HIERARCHY_LEVEL_CLASSES[this.props.hierarchyLevel],
                projectsCounterClass: _constants.HIERARCHY_LEVEL_CLASSES[_constants2.HierarchyLevels.PROJECT],
                tasksCounterClass: _constants.HIERARCHY_LEVEL_CLASSES[_constants2.HierarchyLevels.TASK]
            };
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            var _this2 = this;

            if (this.props.clickable) {
                this.$el.click(function () {
                    return _this2.callbacks.onClick();
                });
            }

            this.$checkboxPlaceholder = this.find('.checkboxPlaceholder');
            this.checkbox = new _IndeterminateCustomCheckboxWithMenu2.default({
                menu: this.props.revokeMenu,
                menuTextsMaps: this.props.revokeMenuTextsMaps,
                hierarchyLevel: this.props.hierarchyLevel,
                onClick: function onClick(checked) {
                    return _this2.callbacks.onAssignmentChanged(checked);
                }
            }).init(this.$checkboxPlaceholder);

            this.$name = this.find('.name');

            if (!this.props.showProjectsCount && !this.props.showTasksCount) this.find('.counters').hide();
            this.$projectsCount = this.find('.counter.projects');
            this.$tasksCount = this.find('.counter.tasks');

            this.$projectsCountContainer = this.find('.projectsCounterContainer');
            this.$tasksCountContainer = this.find('.tasksCounterContainer');

            this.$archivedSubTitle = this.find('.archivedSubTitle');
            this.$canManageSubTitle = this.find('.canManageSubTitle');
            this.$nameContainer = this.find('.nameContainer');
        }
    }]);

    return EntityListItem;
}(_TemplateView3.default);

exports.default = EntityListItem;

/***/ }),
/* 1689 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _constants = __webpack_require__(4);

var _constants2 = __webpack_require__(261);

var _CheckboxIcon = __webpack_require__(885);

var _CheckboxIcon2 = _interopRequireDefault(_CheckboxIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var IndeterminateCustomCheckboxWithMenu = function (_TemplateView) {
    _inherits(IndeterminateCustomCheckboxWithMenu, _TemplateView);

    function IndeterminateCustomCheckboxWithMenu(_ref) {
        var _ref$menu = _ref.menu,
            menu = _ref$menu === undefined ? null : _ref$menu,
            _ref$menuTextsMaps = _ref.menuTextsMaps,
            menuTextsMaps = _ref$menuTextsMaps === undefined ? {} : _ref$menuTextsMaps,
            _ref$onClick = _ref.onClick,
            onClick = _ref$onClick === undefined ? function () {} : _ref$onClick,
            _ref$hierarchyLevel = _ref.hierarchyLevel,
            hierarchyLevel = _ref$hierarchyLevel === undefined ? _constants.HierarchyLevels.TASK : _ref$hierarchyLevel;

        _classCallCheck(this, IndeterminateCustomCheckboxWithMenu);

        var _this = _possibleConstructorReturn(this, (IndeterminateCustomCheckboxWithMenu.__proto__ || Object.getPrototypeOf(IndeterminateCustomCheckboxWithMenu)).call(this));

        _this.onClick = onClick;
        _this.menu = menu;
        _this.menuTextsMaps = menuTextsMaps;
        _this.hierarchyLevel = hierarchyLevel;

        _this.state = {
            checked: false,
            indeterminate: false,
            disabled: false
        };

        _this.onAnyStatePropertyChanged(['checked', 'indeterminate', 'disabled'], function (_ref2) {
            var checked = _ref2.checked,
                indeterminate = _ref2.indeterminate,
                disabled = _ref2.disabled;

            _this.getEl().toggleClass('indeterminate', indeterminate);
            _this.getEl().toggleClass('disabled', disabled);
            _this.checkbox.setState({
                checked: checked,
                indeterminate: indeterminate,
                disabled: disabled
            });
        });
        return _this;
    }

    _createClass(IndeterminateCustomCheckboxWithMenu, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return "<div class='indeterminateCustomCheckboxWithMenu <%-hierarchyLevelClass%>'>" + "  <div class='checkboxPlaceholder'></div>" + "  <div class='icon'></div>" + "</div>";
        }
    }, {
        key: 'templateModel',
        value: function templateModel() {
            return {
                hierarchyLevelClass: _constants2.HIERARCHY_LEVEL_CLASSES[this.hierarchyLevel]
            };
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            var _this2 = this;

            this.checkbox = new _CheckboxIcon2.default().init(this.find('.checkboxPlaceholder'));

            this.$el.click(function (e) {
                e.stopPropagation();

                if (_this2.state.disabled) return;

                if (_this2.state.indeterminate) {
                    _this2.menu.setCallback(function (checked) {
                        _this2.onClick(checked);
                        _this2.menu.hide();
                    });

                    _this2.menu.setOnHideCallback(function () {
                        _this2.getEl().removeClass('pressed');
                    });

                    _this2.menu.setState({
                        hierarchyLevel: _this2.hierarchyLevel,
                        assignTextsMap: _this2.menuTextsMaps.assignTextsMap,
                        revokeTextsMap: _this2.menuTextsMaps.revokeTextsMap
                    });
                    _this2.menu.showAt(_this2.find('.checkboxPlaceholder'), {});
                    _this2.getEl().addClass('pressed');
                } else {
                    _this2.onClick(!_this2.state.checked);
                }
            });
        }
    }]);

    return IndeterminateCustomCheckboxWithMenu;
}(_TemplateView3.default);

exports.default = IndeterminateCustomCheckboxWithMenu;

/***/ }),
/* 1690 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ComponentsList = function (_TemplateView) {
    _inherits(ComponentsList, _TemplateView);

    function ComponentsList(_ref) {
        var _ref$containerClass = _ref.containerClass,
            containerClass = _ref$containerClass === undefined ? '' : _ref$containerClass,
            _ref$itemToId = _ref.itemToId,
            itemToId = _ref$itemToId === undefined ? function (item) {
            return item.id;
        } : _ref$itemToId,
            _ref$itemToState = _ref.itemToState,
            itemToState = _ref$itemToState === undefined ? function (item) {
            return item;
        } : _ref$itemToState,
            _ref$itemToComponent = _ref.itemToComponent,
            itemToComponent = _ref$itemToComponent === undefined ? function (item) {
            return null;
        } : _ref$itemToComponent;

        _classCallCheck(this, ComponentsList);

        var _this = _possibleConstructorReturn(this, (ComponentsList.__proto__ || Object.getPrototypeOf(ComponentsList)).call(this));

        _this.containerClass = containerClass;
        _this.componentsMap = {};

        _this.state = {
            items: []
        };

        _this.onStateChanged(function (_ref2, _ref3) {
            var items = _ref2.items;
            var prevItems = _ref3.items;

            var needReInit = false;
            if (items.length >= prevItems.length) {
                for (var i = 0; i < length; i++) {
                    var item = items[i];
                    var prevItem = prevItems[i];
                    if (prevItem && itemToId(item) !== itemToId(prevItem)) {
                        needReInit = true;
                        break;
                    }
                }
            } else {
                needReInit = true;
            }

            if (needReInit) {
                _this.$el.empty();
                _this.componentsMap = {};
                items.forEach(function (item) {
                    var component = itemToComponent(item).init(_this.$el);
                    component.setState(itemToState(item));
                    _this.componentsMap[itemToId(item)] = component;
                });
            } else {
                items.forEach(function (item) {
                    var id = itemToId(item);

                    var component = _this.componentsMap[id];
                    if (!component) {
                        component = itemToComponent(item).init(_this.$el);
                        _this.componentsMap[id] = component;
                    }

                    component.setState(itemToState(item));
                });
            }
        });
        return _this;
    }

    _createClass(ComponentsList, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class="<%=containerClass%>"></div>';
        }
    }]);

    return ComponentsList;
}(_TemplateView3.default);

exports.default = ComponentsList;

/***/ }),
/* 1691 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LoadingSpinnerWrapper = function (_TemplateView) {
    _inherits(LoadingSpinnerWrapper, _TemplateView);

    function LoadingSpinnerWrapper(loadingSpinner) {
        _classCallCheck(this, LoadingSpinnerWrapper);

        var _this = _possibleConstructorReturn(this, (LoadingSpinnerWrapper.__proto__ || Object.getPrototypeOf(LoadingSpinnerWrapper)).call(this));

        _this.loadingSpinner = loadingSpinner;
        return _this;
    }

    _createClass(LoadingSpinnerWrapper, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class="loadingSpinnerWrapper"></div>';
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            this.loadingSpinner.init(this.$el);
        }
    }]);

    return LoadingSpinnerWrapper;
}(_TemplateView3.default);

exports.default = LoadingSpinnerWrapper;

/***/ }),
/* 1692 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _DropdownTemplateView2 = __webpack_require__(42);

var _DropdownTemplateView3 = _interopRequireDefault(_DropdownTemplateView2);

var _constants = __webpack_require__(4);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _SimpleMenu = __webpack_require__(402);

var _SimpleMenu2 = _interopRequireDefault(_SimpleMenu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RevokeMenu = function (_DropdownTemplateView) {
    _inherits(RevokeMenu, _DropdownTemplateView);

    function RevokeMenu() {
        _classCallCheck(this, RevokeMenu);

        var _this = _possibleConstructorReturn(this, (RevokeMenu.__proto__ || Object.getPrototypeOf(RevokeMenu)).call(this));

        _this.onItemSelected = function () {};

        _this.state = {
            hierarchyLevel: _constants.HierarchyLevels.TASK,
            assignTextsMap: {},
            revokeTextsMap: {}
        };

        _this.onAnyStatePropertyChanged(['hierarchyLevel', 'assignTextsMap', 'revokeTextsMap'], function (level) {
            _this.$grantTitleButtonButton.setState({
                title: _this.state.assignTextsMap[level.hierarchyLevel]
            });
            _this.$revokeTitleButtonButton.setState({
                title: _this.state.revokeTextsMap[level.hierarchyLevel]
            });
        });
        return _this;
    }

    _createClass(RevokeMenu, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return "<div class='chooseAccessMenuContainer'/>";
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            var _this2 = this;

            this.simpleMenu = new _SimpleMenu2.default({
                additionalClass: 'chooseAccessMenu'
            }).init(this.$el);

            this.$grantTitleButtonButton = new _SimpleMenu.Option({
                onSelected: function onSelected() {
                    return _this2.onItemSelected(true);
                },
                additionalClass: 'grantTitle'
            }).init(this.simpleMenu.$el);
            this.$revokeTitleButtonButton = new _SimpleMenu.Option({
                onSelected: function onSelected() {
                    return _this2.onItemSelected(false);
                },
                additionalClass: 'revokeTitle'
            }).init(this.simpleMenu.$el);
        }
    }, {
        key: 'setCallback',
        value: function setCallback(callback) {
            this.onItemSelected = callback;
        }
    }, {
        key: 'setOnHideCallback',
        value: function setOnHideCallback(callback) {
            this.onHideCallback = callback;
        }
    }, {
        key: 'onHide',
        value: function onHide() {
            _get(RevokeMenu.prototype.__proto__ || Object.getPrototypeOf(RevokeMenu.prototype), 'onHide', this).call(this);
            this.onHideCallback();
        }
    }], [{
        key: 'getInstance',
        value: function getInstance() {
            return _getInstance();
        }
    }]);

    return RevokeMenu;
}(_DropdownTemplateView3.default);

exports.default = RevokeMenu;


var instance = null;
var _getInstance = function _getInstance() {
    if (!instance) {
        instance = new RevokeMenu().init((0, _jquery2.default)('body'));
    }
    return instance;
};

/***/ }),
/* 1693 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _utils = __webpack_require__(6);

var _redux = __webpack_require__(7);

var _selectors = __webpack_require__(398);

var _actions = __webpack_require__(262);

var _ManagementAssignmentsEditor = __webpack_require__(883);

exports.default = (0, _utils.connect)(function (state) {
    return {
        viewerCanManageCustomerIds: (0, _selectors.getViewerCanManageCustomerIds)(state),
        viewerCanManageProjectIds: (0, _selectors.getViewerCanManageProjectIds)(state),
        user: (0, _selectors.getEditingUser)(state),
        customers: (0, _selectors.getCustomers)(state),
        projects: (0, _selectors.getProjects)(state),
        tasks: (0, _selectors.getTasks)(state),
        futureCustomersAssigned: (0, _selectors.areFutureCustomersAssigned)(state),
        futureProjectsAssigned: (0, _selectors.areFutureProjectsAssigned)(state),
        futureTasksAssigned: (0, _selectors.areFutureTasksAssigned)(state),
        someCustomersOrLowerAssigned: (0, _selectors.areSomeCustomersOrLowerAssigned)(state),
        someProjectsOrLowerAssigned: (0, _selectors.areSomeProjectsOrLowerAssigned)(state),
        someTasksAssigned: (0, _selectors.areSomeTasksAssigned)(state),
        allCustomersAssigned: (0, _selectors.areAllCustomersAssigned)(state),
        allProjectsAssigned: (0, _selectors.areAllProjectsAssigned)(state),
        allTasksAssigned: (0, _selectors.areAllTasksAssigned)(state),
        canWorkCustomerIds: (0, _selectors.getCanWorkCustomerIds)(state),
        canManageCustomerIds: (0, _selectors.getCanManageCustomerIds)(state),
        canManageCustomerExcludeSelfIds: (0, _selectors.getCanManageCustomerExcludeSelfIds)(state),
        canWorkProjectIds: (0, _selectors.getCanWorkProjectIds)(state),
        canManageProjectIds: (0, _selectors.getCanManageProjectIds)(state),
        canManageProjectExcludeSelfIds: (0, _selectors.getCanManageProjectExcludeSelfIds)(state),
        canWorkTaskIds: (0, _selectors.getCanWorkTaskIds)(state),
        canManageTaskIds: (0, _selectors.getCanManageTaskIds)(state),
        projectCountsByCustomers: (0, _selectors.getProjectCountsByCustomers)(state),
        taskCountsByCustomers: (0, _selectors.getTaskCountsByCustomers)(state),
        taskCountsByProjects: (0, _selectors.getTaskCountsByProjects)(state),
        selectedCustomer: (0, _selectors.getSelectedCustomer)(state),
        selectedProject: (0, _selectors.getSelectedProject)(state),
        loading: (0, _selectors.isLoading)(state),
        changingCustomerAssignments: (0, _selectors.getChangingCustomerAssignments)(state),
        changingProjectAssignments: (0, _selectors.getChangingProjectAssignments)(state),
        changingTaskAssignments: (0, _selectors.getChangingTaskAssignments)(state),
        onlyActive: (0, _selectors.showOnlyActiveEntities)(state),
        customersSearchOpen: (0, _selectors.getCustomersSearchOpen)(state),
        customersSearchText: (0, _selectors.getCustomersSearchText)(state),
        projectsSearchOpen: (0, _selectors.getProjectsSearchOpen)(state),
        projectsSearchText: (0, _selectors.getProjectsSearchText)(state),
        tasksSearchOpen: (0, _selectors.getTasksSearchOpen)(state),
        tasksSearchText: (0, _selectors.getTasksSearchText)(state),
        canManageParentCustomer: (0, _selectors.canManageParentCustomer)(state),
        canManageParentProject: (0, _selectors.canManageParentProject)(state)
    };
}, function (dispatch) {
    return (0, _redux.bindActionCreators)({
        changeCustomerAssignment: _actions.changeCustomerAssignment,
        changeProjectAssignment: _actions.changeProjectAssignment,
        changeTaskAssignment: _actions.changeTaskAssignment,
        changeAllCustomersAssignments: _actions.changeAllCustomersAssignments,
        changeAllProjectsAssignments: _actions.changeAllProjectsAssignments,
        changeAllTasksAssignments: _actions.changeAllTasksAssignments,
        deselectCustomer: _actions.deselectCustomer,
        deselectProject: _actions.deselectProject,
        selectCustomer: _actions.selectCustomer,
        selectProject: _actions.selectProject,
        loadMoreEntities: _actions.loadMoreEntities,
        changeOnlyActive: _actions.changeOnlyActive,
        changeCustomersSearchText: _actions.changeCustomersSearchText,
        clearCustomersSearchText: _actions.clearCustomersSearchText,
        changeProjectsSearchText: _actions.changeProjectsSearchText,
        clearProjectsSearchText: _actions.clearProjectsSearchText,
        changeTasksSearchText: _actions.changeTasksSearchText,
        clearTasksSearchText: _actions.clearTasksSearchText,
        closeEditor: _actions.closeEditor,
        changeAllExistingAndFutureProjectsAssignment: _actions.changeAllExistingAndFutureProjectsAssignment,
        changeAllExistingAndFutureTasksAssignment: _actions.changeAllExistingAndFutureTasksAssignment
    }, dispatch);
})(_ManagementAssignmentsEditor.ManagementAssignmentsEditor);

/***/ }),
/* 1694 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _redux = __webpack_require__(7);

var _utils = __webpack_require__(6);

var _ManagementAssignmentsPanel = __webpack_require__(886);

var _ManagementAssignmentsPanel2 = _interopRequireDefault(_ManagementAssignmentsPanel);

var _selectors = __webpack_require__(208);

var _ManagementAssignmentsPanelContent = __webpack_require__(1695);

var _ManagementAssignmentsPanelContent2 = _interopRequireDefault(_ManagementAssignmentsPanelContent);

var _utils2 = __webpack_require__(25);

var _selectors2 = __webpack_require__(399);

var _actions = __webpack_require__(319);

var _actions2 = __webpack_require__(148);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CreateManagementAssignmentsPanel = function (_ManagementAssignment) {
    _inherits(CreateManagementAssignmentsPanel, _ManagementAssignment);

    function CreateManagementAssignmentsPanel(params) {
        var _this;

        _classCallCheck(this, CreateManagementAssignmentsPanel);

        var panelContent = new _ManagementAssignmentsPanelContent2.default({
            onBackButtonClick: function onBackButtonClick() {
                return _this.params.onPanelHide();
            },
            onClickDialogContent: function onClickDialogContent(e) {
                return (0, _utils2.setEventPreventHidingEditUserSlidingPanel)(e);
            },
            onCloseButtonClick: function onCloseButtonClick() {
                return params.closeAllPanels();
            }
        });
        return _this = _possibleConstructorReturn(this, (CreateManagementAssignmentsPanel.__proto__ || Object.getPrototypeOf(CreateManagementAssignmentsPanel)).call(this, _extends({}, params, {
            additionalClass: 'createManagementAssignmentsPanel',
            panelContent: panelContent
        })));
    }

    return CreateManagementAssignmentsPanel;
}(_ManagementAssignmentsPanel2.default);

exports.default = (0, _utils.connect)(function (state) {
    return {
        userPanelOpenedBelow: (0, _selectors.isShown)(state),
        needToLoadData: (0, _selectors2.isNeedToLoadData)(state),
        isShown: (0, _selectors2.isShown)(state),
        loading: (0, _selectors2.isLoading)(state)
    };
}, function (dispatch) {
    return {
        loadData: (0, _redux.bindActionCreators)(_actions.loadData, dispatch),
        onPanelHide: (0, _redux.bindActionCreators)(_actions.closePanel, dispatch),
        closeAllPanels: (0, _redux.bindActionCreators)(_actions2.cancelUserCreation, dispatch)
    };
})(CreateManagementAssignmentsPanel);

/***/ }),
/* 1695 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _redux = __webpack_require__(7);

var _utils = __webpack_require__(6);

var _ManagementAssignmentsPanelContent = __webpack_require__(887);

var _ManagementAssignmentsPanelContent2 = _interopRequireDefault(_ManagementAssignmentsPanelContent);

var _selectors = __webpack_require__(64);

var _actions = __webpack_require__(319);

var _actions2 = __webpack_require__(262);

var _TabContent = __webpack_require__(1698);

var _TabContent2 = _interopRequireDefault(_TabContent);

var _selectors2 = __webpack_require__(399);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CreateManagementAssignmentsPanelContent = function (_ManagementAssignment) {
    _inherits(CreateManagementAssignmentsPanelContent, _ManagementAssignment);

    function CreateManagementAssignmentsPanelContent(params) {
        _classCallCheck(this, CreateManagementAssignmentsPanelContent);

        var tabContent = new _TabContent2.default();

        return _possibleConstructorReturn(this, (CreateManagementAssignmentsPanelContent.__proto__ || Object.getPrototypeOf(CreateManagementAssignmentsPanelContent)).call(this, _extends({}, params, {
            tabContent: tabContent,
            showCopyButton: false
        })));
    }

    return CreateManagementAssignmentsPanelContent;
}(_ManagementAssignmentsPanelContent2.default);

exports.default = (0, _utils.connect)(function (state) {
    return {
        userFML: (0, _selectors.getUserFML)(state),
        openTab: (0, _selectors2.getTab)(state),

        managementAssignmentsSelection: (0, _selectors2.getManagementAssignmentsSelection)(state),
        counters: (0, _selectors.getManagementAssignmentsCounters)(state)
    };
}, function (dispatch) {
    return {
        onManagementAssignmentsSelectionChange: (0, _redux.bindActionCreators)(_actions.changeManagementAssignmentsSelection, dispatch),
        openEditorPanel: (0, _redux.bindActionCreators)(_actions2.openEditor, dispatch),
        loadData: (0, _redux.bindActionCreators)(_actions.loadData, dispatch),
        onTabChanged: (0, _redux.bindActionCreators)(_actions.setTab, dispatch)
    };
})(CreateManagementAssignmentsPanelContent);

/***/ }),
/* 1696 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _Counter = __webpack_require__(876);

var _Counter2 = _interopRequireDefault(_Counter);

var _constants = __webpack_require__(4);

var _pluralizeUtils = __webpack_require__(40);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CounterHeader = function (_TemplateView) {
    _inherits(CounterHeader, _TemplateView);

    function CounterHeader(_ref) {
        var _ref$changeTab = _ref.changeTab,
            changeTab = _ref$changeTab === undefined ? function (tab) {} : _ref$changeTab;

        _classCallCheck(this, CounterHeader);

        var _this = _possibleConstructorReturn(this, (CounterHeader.__proto__ || Object.getPrototypeOf(CounterHeader)).call(this));

        _this.params = {
            changeTab: changeTab
        };

        _this.state = {
            tab: null,

            counters: {
                customers: 0,
                projects: 0,
                tasks: 0
            }
        };

        _this.onStatePropertyChanged('counters', function (counters) {
            _this.customerTab.setState({ value: counters.customers });
            _this.projectTab.setState({ value: counters.projects });
            _this.taskTab.setState({ value: counters.tasks });

            var allTabsEmpty = _this._areAllTabsEmpty();
            _this.getEl().toggleClass('disabled', allTabsEmpty);
            _this.$customerTab.toggleClass('active', !allTabsEmpty);
            _this.$projectTab.toggleClass('active', !allTabsEmpty);
            _this.$taskTab.toggleClass('active', !allTabsEmpty);

            _this.$customerTabTitle.text((0, _pluralizeUtils.customerNameLower)(counters.customers));
            _this.$projectTabTitle.text((0, _pluralizeUtils.projectNameLower)(counters.projects));
            _this.$taskTabTitle.text((0, _pluralizeUtils.taskNameLower)(counters.tasks));
        });

        _this.onStatePropertyChanged('tab', function (tab) {
            _this.$el.toggleClass('selected', tab !== null);

            _this.$customerTab.toggleClass('selected', tab === _constants.HierarchyLevels.CUSTOMER);
            _this.$projectTab.toggleClass('selected', tab === _constants.HierarchyLevels.PROJECT);
            _this.$taskTab.toggleClass('selected', tab === _constants.HierarchyLevels.TASK);
        });
        return _this;
    }

    _createClass(CounterHeader, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class="countersHeaderTabs">' + '    <div class="customerTab border">' + '        <div class="title hierarchyClass_customer"></div>' + '    </div>' + '    <div class="projectTab border">' + '        <div class="title hierarchyClass_project"></div>' + '    </div>' + '    <div class="taskTab border">' + '        <div class="title hierarchyClass_task "></div>' + '    </div>' + '</div>';
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            var _this2 = this;

            this.$customerTab = this.find('.customerTab');
            this.$projectTab = this.find('.projectTab');
            this.$taskTab = this.find('.taskTab');
            this.$customerTabTitle = this.find('.customerTab .title');
            this.$projectTabTitle = this.find('.projectTab .title');
            this.$taskTabTitle = this.find('.taskTab .title');

            this.customerTab = new _Counter2.default({
                hierarchyLevel: _constants.HierarchyLevels.CUSTOMER
            }).init(this.$customerTab);
            this.customerTab.setState({ pale: true });

            this.projectTab = new _Counter2.default({
                hierarchyLevel: _constants.HierarchyLevels.PROJECT
            }).init(this.$projectTab);
            this.projectTab.setState({ pale: true });

            this.taskTab = new _Counter2.default({
                hierarchyLevel: _constants.HierarchyLevels.TASK
            }).init(this.$taskTab);
            this.taskTab.setState({ pale: true });

            this.$customerTab.click(function () {
                if (!_this2._areAllTabsEmpty()) _this2.params.changeTab(_constants.HierarchyLevels.CUSTOMER);
            });
            this.$projectTab.click(function () {
                if (!_this2._areAllTabsEmpty()) _this2.params.changeTab(_constants.HierarchyLevels.PROJECT);
            });
            this.$taskTab.click(function () {
                if (!_this2._areAllTabsEmpty()) _this2.params.changeTab(_constants.HierarchyLevels.TASK);
            });

            this.renderInitialState();
        }
    }, {
        key: '_areAllTabsEmpty',
        value: function _areAllTabsEmpty() {
            return this.state.counters.tasks === 0 && this.state.counters.projects === 0 && this.state.counters.customers === 0;
        }
    }]);

    return CounterHeader;
}(_TemplateView3.default);

exports.default = CounterHeader;

/***/ }),
/* 1697 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _CopyAssignmentsFromButton = __webpack_require__(557);

var _CopyAssignmentsFromButton2 = _interopRequireDefault(_CopyAssignmentsFromButton);

var _CopyUserSelector = __webpack_require__(397);

var _CopyUserSelector2 = _interopRequireDefault(_CopyUserSelector);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _CounterWithProgressBar = __webpack_require__(210);

var _CounterWithProgressBar2 = _interopRequireDefault(_CounterWithProgressBar);

var _constants = __webpack_require__(4);

var _redux = __webpack_require__(7);

var _utils = __webpack_require__(6);

var _UserWithAccessRights = __webpack_require__(138);

var _UserWithAccessRights2 = _interopRequireDefault(_UserWithAccessRights);

var _selectors = __webpack_require__(15);

var _pluralizeUtils = __webpack_require__(40);

var _selectors2 = __webpack_require__(204);

var _actions = __webpack_require__(207);

var _selectors3 = __webpack_require__(316);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CopyContent = function (_TemplateView) {
    _inherits(CopyContent, _TemplateView);

    function CopyContent() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            _ref$onCancel = _ref.onCancel,
            onCancel = _ref$onCancel === undefined ? function () {} : _ref$onCancel,
            _ref$onSelectUser = _ref.onSelectUser,
            onSelectUser = _ref$onSelectUser === undefined ? function (userId) {} : _ref$onSelectUser,
            _ref$onCopy = _ref.onCopy,
            onCopy = _ref$onCopy === undefined ? function () {} : _ref$onCopy,
            _ref$refreshScrollCb = _ref.refreshScrollCb,
            refreshScrollCb = _ref$refreshScrollCb === undefined ? function () {} : _ref$refreshScrollCb;

        _classCallCheck(this, CopyContent);

        var _this = _possibleConstructorReturn(this, (CopyContent.__proto__ || Object.getPrototypeOf(CopyContent)).call(this));

        _this.params = {
            onCancel: onCancel,
            onSelectUser: onSelectUser,
            onCopy: onCopy,
            refreshScrollCb: refreshScrollCb
        };

        _this.state = {
            userId: null,
            userFrom: null,
            userTo: null,
            viewer: null,
            userHasSelectedScope: false,

            counters: {
                tasks: 0,
                projects: 0,
                customers: 0
            },

            users: [],
            userGroups: [],
            timeZoneGroups: [],

            ugrEnabled: true,
            tzgEnabled: true,
            wasEnabled: false,
            ttaEnabled: false
        };

        _this.onAnyStatePropertyChanged(['userFrom', 'userHasSelectedScope'], function (state) {
            _this.copyAssignmentsButton.setState({
                selectedUser: state.userFrom
            });
            _this._updateCommentNote();
        });

        _this.onAnyStatePropertyChanged(['users', 'userGroups', 'timeZoneGroups', 'ugrEnabled', 'tzgEnabled'], function () {
            var usersWithAccessRights = _this.state.users.map(function (userFrom) {
                return _UserWithAccessRights2.default.fromRPC(userFrom);
            });

            _this.copyUserSelector.setState({
                users: usersWithAccessRights,
                ugrEnabled: _this.state.ugrEnabled,
                userGroups: Object.values(_this.state.userGroups),
                tzgEnabled: _this.state.tzgEnabled,
                timeZoneGroups: Object.values(_this.state.timeZoneGroups)
            });
        });

        _this.onAnyStatePropertyChanged(['userId', 'counters'], function (state) {
            var userId = state.userId;
            var counters = state.counters;
            var isCopyEnabled = userId !== null;

            _this.customerCounter.setState({
                curValue: counters.customers,
                maxValue: counters.customers,
                title: (0, _pluralizeUtils.customerNameLower)(counters.customers),
                active: counters.customers > 0
            });

            _this.projectCounter.setState({
                curValue: counters.projects,
                maxValue: counters.projects,
                title: (0, _pluralizeUtils.projectNameLower)(counters.projects),
                active: counters.projects > 0
            });

            _this.taskCounter.setState({
                curValue: counters.tasks,
                maxValue: counters.tasks,
                title: (0, _pluralizeUtils.taskNameLower)(counters.tasks),
                active: counters.tasks > 0
            });

            _this.find('.counters').toggleClass('invisible', !isCopyEnabled);
            _this.$copyButton.toggleClass('disabled', !isCopyEnabled);
        });
        return _this;
    }

    _createClass(CopyContent, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class="copyContent">' + '  <div class="title"><%-title%></div>' + '  <div class="userSelector"/>' + '  <div class="counters">' + '    <div class="title"><%-counterTitle%></div>' + '    <div class="customers"></div>' + '    <div class="projects"></div>' + '    <div class="tasks"></div>' + '  </div>' + '  <div class="commentNote">' + '    <div class="part1"/>' + '    <div class="part2"/>' + '  </div>' + '  <div class="buttonsSection">' + '    <div class="copyButton"><%-copy%></div>' + '    <div class="cancelButton"><%-cancel%></div>' + '  </div>' + '</div>';
        }
    }, {
        key: 'templateModel',
        value: function templateModel() {
            return {
                title: _messageResource2.default.getMessage('management_assignment.panel.copy.title'),
                counterTitle: _messageResource2.default.getMessage('work_assignments.panel.copy.counter_title'),
                copy: _messageResource2.default.getMessage('common.copy'),
                cancel: _messageResource2.default.getMessage('common.cancel')
            };
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            var _this2 = this;

            this.$userSelector = this.find('.userSelector');
            this.$countersSection = this.find('.counters');
            this.$copyButton = this.find('.copyButton');
            this.$cancelButton = this.find('.cancelButton');

            this.$cancelButton.click(function () {
                _this2.params.onCancel();
            });

            this.$copyButton.click(function () {
                if (_this2._copyEnabled()) {
                    _this2.params.onCopy();
                }
            });

            this.copyUserSelector = new _CopyUserSelector2.default({
                title: _messageResource2.default.getMessage("user.add.js.copy_setting.selector.label"),
                selectionCallback: function selectionCallback(user) {
                    _this2.params.onSelectUser(user.id);
                    _this2.copyUserSelector.hide();
                },
                onHideCb: function onHideCb() {
                    _this2.$el.removeClass('withUserSelector');
                    _this2.params.refreshScrollCb();
                },
                showPermissionIcons: false,
                renderTo: this.getEl()
            }).init();

            this.$customerCounter = this.find('.counters .customers');
            this.customerCounter = new _CounterWithProgressBar2.default({
                hierarchyLevel: _constants.HierarchyLevels.CUSTOMER,
                pale: true
            }).init(this.$customerCounter);

            this.$projectCounter = this.find('.counters .projects');
            this.projectCounter = new _CounterWithProgressBar2.default({
                hierarchyLevel: _constants.HierarchyLevels.PROJECT,
                pale: true
            }).init(this.$projectCounter);

            this.$taskCounter = this.find('.counters .tasks');
            this.taskCounter = new _CounterWithProgressBar2.default({
                hierarchyLevel: _constants.HierarchyLevels.TASK,
                pale: true
            }).init(this.$taskCounter);

            this.copyAssignmentsButton = new _CopyAssignmentsFromButton2.default().init(this.$userSelector);
            this.copyAssignmentsButton.bindClick(function () {
                _this2.copyUserSelector.showAt(_this2.copyAssignmentsButton.$el, "t-b");
                _this2.$el.toggleClass('withUserSelector', true);
                _this2.params.refreshScrollCb();
            });

            this.$commentNote = this.find('.commentNote');
            this.$commentNote1 = this.$commentNote.find('.part1');
            this.$commentNote2 = this.$commentNote.find('.part2');
        }
    }, {
        key: '_copyEnabled',
        value: function _copyEnabled() {
            return this.state.userId !== null;
        }
    }, {
        key: '_updateCommentNote',
        value: function _updateCommentNote() {
            this.$commentNote.toggleClass('invisible', !this.state.userFrom);
            if (this.state.userTo) {
                this.$commentNote1.text(_messageResource2.default.getMessage('management_assignment.panel.copy.note_part1', [this.state.userTo]));

                this.$commentNote2.toggleClass('invisible', !this.state.wasEnabled || !this.state.userHasSelectedScope);

                if (this.state.wasEnabled && this.state.userHasSelectedScope) this.$commentNote2.html(_messageResource2.default.getMessageWithEscapedArgs('management_assignment.panel.copy.note_part2', [this.state.userTo]));
            }
        }
    }]);

    return CopyContent;
}(_TemplateView3.default);

exports.default = (0, _utils.connect)(function (state) {
    return {
        userId: (0, _selectors2.getCopyUserId)(state),
        userFrom: (0, _selectors2.getCopyUserFrom)(state),
        userTo: (0, _selectors2.getPanelUserFirstName)(state),

        counters: (0, _selectors2.getCopyUserCounters)(state),
        userHasSelectedScope: (0, _selectors2.isUserHasSelectedScope)(state),

        users: (0, _selectors2.getSelectorsUsers)(state),
        ugrEnabled: (0, _selectors.isUGREnabled)(state),
        userGroups: (0, _selectors3.getSortedUserGroupsList)(state),
        tzgEnabled: (0, _selectors.isTZGEnabled)(state),
        timeZoneGroups: (0, _selectors3.getSortedTimeZoneGroupsList)(state),

        wasEnabled: (0, _selectors.isWASEnabled)(state)
    };
}, function (dispatch) {
    return {
        onSelectUser: (0, _redux.bindActionCreators)(_actions.loadUserCounters, dispatch),
        onCopy: (0, _redux.bindActionCreators)(_actions.copyAssignments, dispatch),
        onCancel: (0, _redux.bindActionCreators)(_actions.cancelCopy, dispatch)
    };
})(CopyContent);

/***/ }),
/* 1698 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _utils = __webpack_require__(6);

var _redux = __webpack_require__(7);

var _selectors = __webpack_require__(399);

var _actions = __webpack_require__(319);

var _selectors2 = __webpack_require__(64);

var _ManagementAssignmentPanelTabContent = __webpack_require__(889);

var _ManagementAssignmentPanelTabContent2 = _interopRequireDefault(_ManagementAssignmentPanelTabContent);

var _actions2 = __webpack_require__(262);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _utils.connect)(function (state) {
    return {
        userFirstName: (0, _selectors2.getFullUserInfo)(state).firstName,
        counters: (0, _selectors.getCounters)(state),

        searchString: (0, _selectors.getSearch)(state),
        searchOpen: (0, _selectors.isSearchOpen)(state),

        entirelyAssignedTasksCounter: (0, _selectors.getEntirelyAssignedTasksCounter)(state),
        entirelyAssignedProjectsCounter: (0, _selectors.getEntirelyAssignedProjectCounter)(state),

        customerEntities: (0, _selectors.selectCustomerEntities)(state),
        projectEntities: (0, _selectors.selectProjectEntities)(state),
        taskEntities: (0, _selectors.selectTaskEntities)(state),
        isShowArchivedEntities: (0, _selectors.isShowArchivedEntities)(state),

        openTab: (0, _selectors.getTab)(state)
    };
}, function (dispatch) {
    return {
        onSearchChanged: (0, _redux.bindActionCreators)(_actions.setSearchString, dispatch),
        onSearchToggled: (0, _redux.bindActionCreators)(_actions.setSearchOpen, dispatch),

        onEntityRevoked: (0, _redux.bindActionCreators)(_actions.revokeEntitiesAction, dispatch),
        onAllRevoked: (0, _redux.bindActionCreators)(_actions.revokeAllTypeAction, dispatch),

        setIsShowArchiveEntities: (0, _redux.bindActionCreators)(_actions.setIsShowArchiveEntities, dispatch),
        onEditButtonClick: (0, _redux.bindActionCreators)(_actions2.openEditor, dispatch)

    };
})(_ManagementAssignmentPanelTabContent2.default);

/***/ }),
/* 1699 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _constants = __webpack_require__(4);

var _EmptyHighlighter = __webpack_require__(137);

var _EmptyHighlighter2 = _interopRequireDefault(_EmptyHighlighter);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _SimpleSingletonTooltip = __webpack_require__(45);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TextNode = function (_TemplateView) {
    _inherits(TextNode, _TemplateView);

    function TextNode(_ref) {
        var _ref$id = _ref.id,
            id = _ref$id === undefined ? -1 : _ref$id,
            _ref$type = _ref.type,
            type = _ref$type === undefined ? _constants.HierarchyLevels.TASK : _ref$type,
            _ref$additionalClass = _ref.additionalClass,
            additionalClass = _ref$additionalClass === undefined ? "" : _ref$additionalClass,
            _ref$needRevokeButton = _ref.needRevokeButton,
            needRevokeButton = _ref$needRevokeButton === undefined ? false : _ref$needRevokeButton;

        _classCallCheck(this, TextNode);

        var _this = _possibleConstructorReturn(this, (TextNode.__proto__ || Object.getPrototypeOf(TextNode)).call(this));

        _this.params = {
            id: id,
            type: type,
            additionalClass: additionalClass,
            needRevokeButton: needRevokeButton
        };

        _this.state = {
            highlightedTitle: "",
            tokensHighlighter: new _EmptyHighlighter2.default(),
            additionalTitle: "",
            note: "",
            revokeEnabled: false,
            revokeCallback: function revokeCallback(id) {},
            maExcludeSelf: false
        };

        _this.onStateChanged(function () {
            _this.find(".title").html(_this.state.highlightedTitle);
            _this.find(".additionalTitle").text(_this.state.additionalTitle);
            _this.find(".note").text(_this.state.note);

            _this.unsubscribeTooltip && _this.unsubscribeTooltip();
            if (_this.state.revokeEnabled) {
                _this.$revokeButton.click(function () {
                    return _this.state.revokeCallback(_this.params.id);
                });
            } else {
                _this.$revokeButton.addClass("disabled");
                var levelName = "";
                var childLevelsName = "";
                switch (_this.params.type) {
                    case _constants.HierarchyLevels.CUSTOMER:
                        levelName = _messageResource2.default.getMessage('common.customer');
                        childLevelsName = _messageResource2.default.getMessage('common.projects');
                        break;
                    case _constants.HierarchyLevels.PROJECT:
                        levelName = _messageResource2.default.getMessage('common.project');
                        childLevelsName = _messageResource2.default.getMessage('common.tasks');
                        break;
                    default:
                        levelName = _messageResource2.default.getMessage('common.task');
                        break;
                }
                var tooltipText = "";
                if (_this.state.maExcludeSelf) {
                    tooltipText = _messageResource2.default.getMessage('assigned_users_editor.disabled_tooltip.user_manage_all_existing_and_future', [levelName, childLevelsName]);
                } else {
                    tooltipText = _messageResource2.default.getMessage('assigned_users_editor.work.disabled_tooltip.user_manages_item', [levelName]);
                }

                _this.unsubscribeTooltip = (0, _SimpleSingletonTooltip.getInstance)().subscribeToMouseEvents(_this.$revokeButton, function () {
                    (0, _SimpleSingletonTooltip.getInstance)().setState({
                        text: tooltipText,
                        extraClass: 'hierarchyAssignmentsTooltip'
                    });
                });
            }

            _this.$revokeButton.toggle(needRevokeButton && !!_this.state.revokeCallback);
        });
        return _this;
    }

    _createClass(TextNode, [{
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='<%-additionalClass%>'>" + "    <div class='entitiesName'>" + "        <div class='title'></div>" + "        <div class='additionalTitle'></div>" + "    </div>" + "    <div class='noteAndRevokeButtonContainer'>" + "        <div class='note'></div>" + "        <div class='revokeButton'></div>" + "    </div>" + "</div>";
        }
    }, {
        key: "templateModel",
        value: function templateModel() {
            return {
                additionalClass: this.params.additionalClass
            };
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            this.$revokeButton = this.find(".revokeButton");
        }
    }]);

    return TextNode;
}(_TemplateView3.default);

exports.default = TextNode;

/***/ }),
/* 1700 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _WordsFilter = __webpack_require__(400);

var _WordsFilter2 = _interopRequireDefault(_WordsFilter);

var _constants = __webpack_require__(110);

var _ModalAlert = __webpack_require__(318);

var _ModalAlert2 = _interopRequireDefault(_ModalAlert);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TabContentHeader = function (_TemplateView) {
    _inherits(TabContentHeader, _TemplateView);

    function TabContentHeader(_ref) {
        var _ref$onAllRevoked = _ref.onAllRevoked,
            onAllRevoked = _ref$onAllRevoked === undefined ? function () {} : _ref$onAllRevoked,
            _ref$onSearchChanged = _ref.onSearchChanged,
            onSearchChanged = _ref$onSearchChanged === undefined ? function (text) {} : _ref$onSearchChanged,
            _ref$onSearchToggled = _ref.onSearchToggled,
            onSearchToggled = _ref$onSearchToggled === undefined ? function () {} : _ref$onSearchToggled,
            _ref$onClickToggleArc = _ref.onClickToggleArchivedButton,
            onClickToggleArchivedButton = _ref$onClickToggleArc === undefined ? function () {} : _ref$onClickToggleArc;

        _classCallCheck(this, TabContentHeader);

        var _this = _possibleConstructorReturn(this, (TabContentHeader.__proto__ || Object.getPrototypeOf(TabContentHeader)).call(this));

        _this.params = {
            onAllRevoked: onAllRevoked,
            onSearchChanged: onSearchChanged,
            onSearchToggled: onSearchToggled,
            onClickToggleArchivedButton: onClickToggleArchivedButton
        };

        _this.state = {
            title: "",
            searchText: null,
            searchOpen: false,
            hideArchivedButtonText: "",
            showArchivedButtonText: "",
            showToggleArchivedButton: true,
            isShowArchivedEntities: false,
            searchDisabled: false,
            revokeDisabled: false,
            revokeConfirmationText: ''
        };

        _this.onStatePropertyChanged('title', function (title) {
            return _this.find(".title").html(title);
        });
        _this.onAnyStatePropertyChanged(['searchText', 'searchOpen'], function (_ref2) {
            var searchText = _ref2.searchText,
                searchOpen = _ref2.searchOpen;

            _this.wordFilter.setState({
                open: searchOpen,
                text: searchText ? searchText : ""
            });
        });

        _this.onAnyStatePropertyChanged(['hideArchivedButtonText', 'showArchivedButtonText', 'isShowArchivedEntities'], function () {
            _this._changeTextHideButton();
        });

        _this.onStatePropertyChanged('showToggleArchivedButton', function (show) {
            _this.$toggleArchivedButton.toggle(show);
            _this.find(".hideSeparator").toggle(show);
        });

        _this.onStatePropertyChanged('searchDisabled', function (disabled) {
            _this.wordFilter.setState({
                disabled: disabled
            });
        });

        _this.onStatePropertyChanged('revokeDisabled', function (disabled) {
            _this.$revokeButton.toggleClass('disabled', disabled);
        });

        _this.onStatePropertyChanged('revokeConfirmationText', function (revokeConfirmationText) {
            _this.revokeDialog.setState({
                text: revokeConfirmationText
            });
        });
        return _this;
    }

    _createClass(TabContentHeader, [{
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='additionalInfo'>" + "  <div class='searchFieldArea'>" + "    <div class='title ellipsis'/>" + "    <div class='searchButton'/>" + "  </div>" + "  <div class='rightContainer'>" + "    <div class='vertical-separator hideSeparator'></div>" + "    <div class='toggleArchivedButton'></div>" + "    <div class='vertical-separator'></div>" + "    <div class='revokeButton'><%-revokeAll%> <div class='revokeEdgeButton'></div></div>" + "  </div>" + "</div>";
        }
    }, {
        key: "templateModel",
        value: function templateModel() {
            return {
                revokeAll: _messageResource2.default.getMessage("work_assignments.panel.revoke_all")
            };
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            var _this2 = this;

            this.$toggleArchivedButton = this.find(".toggleArchivedButton");

            this.$revokeButton = this.find(".revokeButton");

            this.revokeDialog = new _ModalAlert2.default({
                showCancelButton: true,
                onConfirm: function onConfirm() {
                    _this2.$revokeButton.toggleClass('active', false);
                    _this2.params.onAllRevoked();
                },
                okButtonLabel: _messageResource2.default.getMessage('assignments.panels.ok_revoke'),
                onCancelButtonClick: function onCancelButtonClick() {
                    _this2.$revokeButton.toggleClass('active', false);
                }
            }).init(this.$containerEl);

            this.$revokeButton.click(function () {
                if (!_this2.state.revokeDisabled) {
                    _this2.$revokeButton.toggleClass('active', true);
                    _this2.revokeDialog.setState({
                        pointerPosition: _constants.ModalAlertPointerPosition.RIGHT,
                        additionalClass: 'revokeAllConfirmationDialogue',
                        offsets: {
                            left: 40,
                            top: 10
                        }
                    }).showAt(_this2.$revokeButton);
                }
            });

            this.$toggleArchivedButton.click(function () {
                return _this2.params.onClickToggleArchivedButton(!_this2.state.isShowArchivedEntities);
            });

            this.wordFilter = new _WordsFilter2.default({
                onChange: function onChange(text) {
                    return _this2.params.onSearchChanged(text);
                },
                onShow: function onShow() {
                    return _this2.params.onSearchToggled(true);
                },
                onHide: function onHide() {
                    return _this2.params.onSearchToggled(false);
                }
            }).init(this.find(".searchButton"));
        }
    }, {
        key: "_changeTextHideButton",
        value: function _changeTextHideButton() {
            if (!this.state.isShowArchivedEntities) {
                this.$toggleArchivedButton.text(this.state.showArchivedButtonText);
            } else {
                this.$toggleArchivedButton.text(this.state.hideArchivedButtonText);
            }
        }
    }]);

    return TabContentHeader;
}(_TemplateView3.default);

exports.default = TabContentHeader;

/***/ }),
/* 1701 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EmptyList = function (_TemplateView) {
    _inherits(EmptyList, _TemplateView);

    function EmptyList(_ref) {
        var _ref$actionOnEmptyLis = _ref.actionOnEmptyList,
            actionOnEmptyList = _ref$actionOnEmptyLis === undefined ? function () {} : _ref$actionOnEmptyLis;

        _classCallCheck(this, EmptyList);

        var _this = _possibleConstructorReturn(this, (EmptyList.__proto__ || Object.getPrototypeOf(EmptyList)).call(this));

        _this.params = {
            actionOnEmptyList: actionOnEmptyList
        };

        _this.state = {
            openTabKey: "",
            isAssignMoreSubtitle: false,
            isNoSelectedTitle: false,
            titlesMap: {},
            noSelectedTitlesMap: {},
            subtitlesAssignItemsMap: {},
            subtitlesAssignMoreItemsMap: {},
            withBorderAndBackground: true,
            noWorkScopeWarningText: ""
        };

        _this.onAnyStatePropertyChanged(['openTabKey', 'isAssignMoreSubtitle', 'isNoSelectedTitle', 'titlesMap', 'noSelectedTitlesMap', 'subtitlesAssignItemsMap', 'subtitlesAssignMoreItemsMap', 'noWorkScopeWarningText'], function (_ref2) {
            var openTabKey = _ref2.openTabKey,
                isAssignMoreSubtitle = _ref2.isAssignMoreSubtitle,
                isNoSelectedTitle = _ref2.isNoSelectedTitle,
                titlesMap = _ref2.titlesMap,
                noSelectedTitlesMap = _ref2.noSelectedTitlesMap,
                subtitlesAssignItemsMap = _ref2.subtitlesAssignItemsMap,
                subtitlesAssignMoreItemsMap = _ref2.subtitlesAssignMoreItemsMap,
                noWorkScopeWarningText = _ref2.noWorkScopeWarningText;

            var titleText = isNoSelectedTitle ? noSelectedTitlesMap[openTabKey] : titlesMap[openTabKey];
            _this.$emptyListTitle.text(titleText);
            _this.$emptyListTitle.toggle(!noWorkScopeWarningText);
            _this.$noWorkScopeWarning.toggle(!!noWorkScopeWarningText);

            noWorkScopeWarningText && _this.$noWorkScopeWarningText.text(noWorkScopeWarningText);

            var subtitleText = "";
            if (isAssignMoreSubtitle) {
                subtitleText = subtitlesAssignMoreItemsMap[openTabKey];
            } else {
                subtitleText = subtitlesAssignItemsMap[openTabKey];
            }
            _this.$emptyListSubTitle.text(subtitleText);
        });

        _this.onStatePropertyChanged('withBorderAndBackground', function (withBorderAndBackground) {
            _this.getEl().toggleClass('withBorderAndBackground', withBorderAndBackground);
        });
        return _this;
    }

    _createClass(EmptyList, [{
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='emptyCptList'>" + "    <div class='noWorkScopeWarning'>" + "        <span class='warningIcon'/>" + "        <span class='warningText'/>" + "    </div>" + "    <div class='title'></div>" + "    <div class='subTitle'></div>" + "</div>";
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            var _this2 = this;

            this.$emptyListTitle = this.find(".title");
            this.$emptyListSubTitle = this.find(".subTitle");
            this.$noWorkScopeWarning = this.find(".noWorkScopeWarning");
            this.$noWorkScopeWarning.hide();
            this.$noWorkScopeWarningText = this.$noWorkScopeWarning.find('.warningText');

            this.$emptyListSubTitle.click(function (e) {
                _this2.params.actionOnEmptyList();
                e.stopPropagation();
            });

            this.renderInitialState();
        }
    }]);

    return EmptyList;
}(_TemplateView3.default);

exports.default = EmptyList;

/***/ }),
/* 1702 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _TeamAssignmentsPanelContainer = __webpack_require__(893);

var _TeamAssignmentsPanelContainer2 = _interopRequireDefault(_TeamAssignmentsPanelContainer);

var _selectors = __webpack_require__(15);

var _selectors2 = __webpack_require__(895);

var _utils = __webpack_require__(6);

var _redux = __webpack_require__(7);

var _selectors3 = __webpack_require__(1710);

var _actions = __webpack_require__(148);

var _actions2 = __webpack_require__(880);

var _selectors4 = __webpack_require__(208);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CreateTeamAssignmentsPanel = function (_TeamAssignmentsPanel) {
    _inherits(CreateTeamAssignmentsPanel, _TeamAssignmentsPanel);

    function CreateTeamAssignmentsPanel(params) {
        _classCallCheck(this, CreateTeamAssignmentsPanel);

        return _possibleConstructorReturn(this, (CreateTeamAssignmentsPanel.__proto__ || Object.getPrototypeOf(CreateTeamAssignmentsPanel)).call(this, _extends({
            showCopyButton: false,
            additionalClass: 'createTeamAssignmentsPanel'
        }, params)));
    }

    return CreateTeamAssignmentsPanel;
}(_TeamAssignmentsPanelContainer2.default);

exports.default = (0, _utils.connect)(function (state) {
    return {
        isShown: (0, _selectors3.isPanelOpened)(state),
        userPanelOpenedBelow: (0, _selectors4.isShown)(state),
        assignedUserIds: (0, _selectors2.getAssignedUserIds)(state),
        assignedGroupIds: (0, _selectors2.getAssignedGroupIds)(state),
        users: (0, _selectors2.getUsers)(state),
        userGroups: (0, _selectors2.getUserGroups)(state),
        isUGREnabled: (0, _selectors.isUGREnabled)(state),
        teamAssignmentType: (0, _selectors2.getTeamAssignmentType)(state),
        userFML: (0, _selectors2.getUserFML)(state)
    };
}, function (dispatch) {
    return {
        onPanelHide: (0, _redux.bindActionCreators)(_actions2.closeTeamAssignmentsPanel, dispatch),
        onCloseButtonClick: (0, _redux.bindActionCreators)(_actions.cancelUserCreation, dispatch),
        changeTeamAssignments: (0, _redux.bindActionCreators)(_actions.changeTeamAssignments, dispatch)
    };
})(CreateTeamAssignmentsPanel);

/***/ }),
/* 1703 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _LoadingSpinner = __webpack_require__(191);

var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);

var _constants = __webpack_require__(21);

var _UserSelectorPanel = __webpack_require__(1704);

var _UserSelectorPanel2 = _interopRequireDefault(_UserSelectorPanel);

var _LoadingContainer = __webpack_require__(28);

var _LoadingContainer2 = _interopRequireDefault(_LoadingContainer);

var _UserNameFormat = __webpack_require__(17);

var _ScrollableContainer = __webpack_require__(49);

var _ScrollableContainer2 = _interopRequireDefault(_ScrollableContainer);

var _DisabledContainer = __webpack_require__(888);

var _DisabledContainer2 = _interopRequireDefault(_DisabledContainer);

var _CopyContent = __webpack_require__(1707);

var _CopyContent2 = _interopRequireDefault(_CopyContent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TeamAssignmentsPanelContent = function (_TemplateView) {
    _inherits(TeamAssignmentsPanelContent, _TemplateView);

    function TeamAssignmentsPanelContent(_ref) {
        var _ref$showCopyButton = _ref.showCopyButton,
            showCopyButton = _ref$showCopyButton === undefined ? true : _ref$showCopyButton,
            _ref$onChangeDialogDa = _ref.onChangeDialogData,
            onChangeDialogData = _ref$onChangeDialogDa === undefined ? function () {} : _ref$onChangeDialogDa,
            _ref$onCopyFromButton = _ref.onCopyFromButtonClick,
            onCopyFromButtonClick = _ref$onCopyFromButton === undefined ? function () {} : _ref$onCopyFromButton,
            _ref$onBackButtonClic = _ref.onBackButtonClick,
            onBackButtonClick = _ref$onBackButtonClic === undefined ? function () {} : _ref$onBackButtonClic,
            _ref$onClickDialogCon = _ref.onClickDialogContent,
            onClickDialogContent = _ref$onClickDialogCon === undefined ? function () {} : _ref$onClickDialogCon,
            _ref$onCloseButtonCli = _ref.onCloseButtonClick,
            onCloseButtonClick = _ref$onCloseButtonCli === undefined ? function () {} : _ref$onCloseButtonCli;

        _classCallCheck(this, TeamAssignmentsPanelContent);

        var _this = _possibleConstructorReturn(this, (TeamAssignmentsPanelContent.__proto__ || Object.getPrototypeOf(TeamAssignmentsPanelContent)).call(this));

        _this._handleChange = function (changes) {
            var state = {
                teamAssignmentType: _this.state.teamAssignmentType,
                assignedGroupIds: _this.state.assignedGroupIds,
                assignedUserIds: _this.state.assignedUserIds
            };

            _this.params.onChangeDialogData(_extends({}, state, changes));
        };

        _this.state = {
            disabled: false,
            assignedUserIds: [],
            assignedGroupIds: [],
            users: [],
            userGroups: [],
            teamAssignmentType: _constants.UserTeamAssignmentType.SELECTED,
            hideNonSelected: false,
            userFML: {},
            userId: '',
            withBackButton: true,
            showCopyContent: false,
            copyContentLoading: false
        };

        _this.params = {
            showCopyButton: showCopyButton,
            onChangeDialogData: onChangeDialogData,
            onCopyFromButtonClick: onCopyFromButtonClick,
            onBackButtonClick: onBackButtonClick,
            onClickDialogContent: onClickDialogContent,
            onCloseButtonClick: onCloseButtonClick
        };

        _this.onStatePropertyChanged('disabled', function (disabled) {
            return _this._updateDisabled(disabled);
        });

        _this.onStatePropertyChanged('teamAssignmentType', function () {
            _this._updateRadio();
        });

        _this.onStatePropertyChanged('userFML', function () {
            _this._updateHeader();
        });

        _this.onStatePropertyChanged('userId', function () {
            _this.selectorPanel.resetFilters();
        });

        _this.onAnyStatePropertyChanged(['users', 'userGroups', 'assignedUserIds', 'assignedGroupIds', 'isUGREnabled'], function () {
            _this.userSelectorPanel.setState({
                assignedUserIds: _this.state.assignedUserIds,
                assignedGroupIds: _this.state.assignedGroupIds,
                users: _this.state.users,
                userGroups: _this.state.userGroups,
                isUGREnabled: _this.state.isUGREnabled
            });
        });

        _this.onAnyStatePropertyChanged(['teamAssignmentType', 'showCopyContent'], function (_ref2) {
            var teamAssignmentType = _ref2.teamAssignmentType,
                showCopyContent = _ref2.showCopyContent;

            var needToShowCopyContent = teamAssignmentType === _constants.UserTeamAssignmentType.SELECTED && showCopyContent;
            _this.$groupsList.toggle(!needToShowCopyContent);
            _this.$copyContent.toggle(needToShowCopyContent);
            _this.$copyButton.toggleClass('selected', needToShowCopyContent);
            _this.$separator.toggleClass('invisible', needToShowCopyContent);
        });

        _this.onStatePropertyChanged('withBackButton', function (withBackButton) {
            _this.$backButton.toggle(withBackButton);
            _this.$crossButton.toggle(!withBackButton);
        });

        _this.onStatePropertyChanged('copyContentLoading', function (loading) {
            return _this.copyContentWrapper.setState({ loading: loading });
        });
        return _this;
    }

    _createClass(TeamAssignmentsPanelContent, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class="teamAssignmentsPanel">' + '   <div class="header">' + '        <div class="updatingSpinner"/>' + '        <div class="backButton">' + '            <div class="arrow"></div>' + '            <div class="text"></div>' + '        </div>' + '        <div class="headerText"></div>' + '        <div class="crossButton"></div>' + '   </div>' + '   <div class="radioSection">' + '        <label>' + '            <div class="noAccessSection">' + '                <input type="radio" class="noAccess"/>' + '                <div class="icon"></div>' + '                <span><%-noAccessLabel%></span>' + '            </div>' + '        </label>' + '        <label>' + '            <div class="allSection">' + '                <input type="radio" class="selectAll"/>' + '                <div class="icon"></div>' + '                <span><%-selectAllLabel%></span>' + '            </div>' + '        </label>' + '        <label>' + '            <div class="customSection">' + '                <div class="option">' + '                    <input type="radio" class="customSelect"/>' + '                    <div class="icon"></div>' + '                    <span><%-customSelectLabel%></span>' + '                </div>' + '                <div class="vertical-separator"></div>' + '                <div class="copyButton">' + '                    <div class="copyButtonImg"/>' + '                    <div class="copyButtonLabel"><%-copyButtonLabel%></div>' + '                </div>' + '            </div>' + '        </label>' + '   </div>' + '   <div class="groupsList">' + '        <div class="groupsContent"/>' + '        <div class="moire"/>' + '   </div>' + '   <div class="copyContentPlaceholder"/>' + '</div>';
        }
    }, {
        key: 'messageKeys',
        value: function messageKeys() {
            return {
                noAccessLabel: 'user.panel.permissions.team_assignments.no_users',
                selectAllLabel: 'user.panel.permissions.team_assignments.all_users',
                customSelectLabel: 'user.panel.permissions.team_assignments.selected_users',
                copyButtonLabel: 'management_assignment.panel.copy_button'
            };
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            var _this2 = this;

            this.$el.click(function (e) {
                _this2.params.onClickDialogContent(e);
            });

            this.loadingSpinner = new _LoadingSpinner2.default().init(this.find('.updatingSpinner'));

            this.find('.backButton .text').text(_messageResource2.default.getMessage('user.panel.permissions.team_assignments.back'));
            this.$backButton = this.find('.backButton').on('click', function () {
                _this2.params.onBackButtonClick();
            });

            this.$crossButton = this.find('.crossButton').on('click', function () {
                _this2.params.onCloseButtonClick();
            });
            this.$crossButton.addClass('hideButton_panelContainer');

            this.$groupsList = this.find('.groupsList');
            this.$noAccessSection = this.find('.noAccessSection');
            this.$allSection = this.find('.allSection');
            this.$customSection = this.find('.customSection');
            this.$separator = this.find('.vertical-separator');
            this.$copyButton = this.find('.copyButton');
            this.$copyContent = this.find('.copyContentPlaceholder');

            this.$copyButton.toggle(this.params.showCopyButton);

            if (this.params.showCopyButton) {
                this.$copyButton.click(function (e) {
                    if (_this2.state.teamAssignmentType === _constants.UserTeamAssignmentType.SELECTED) {
                        _this2.params.onCopyFromButtonClick();
                        e.stopPropagation();
                    }
                });
            }

            this.$noAccessRadio = this.find('.noAccess').on('change', function () {
                _this2._handleChange({ teamAssignmentType: _constants.UserTeamAssignmentType.NO });
            });

            this.$selectAllRadio = this.find('.selectAll').on('change', function () {
                _this2._handleChange({ teamAssignmentType: _constants.UserTeamAssignmentType.ALL });
            });

            this.$customSelectRadio = this.find('.customSelect').on('change', function () {
                _this2._handleChange({ teamAssignmentType: _constants.UserTeamAssignmentType.SELECTED });
            });

            this.selectorPanel = new _UserSelectorPanel2.default({
                onChange: function onChange(_ref3) {
                    var assignedUserIds = _ref3.assignedUserIds,
                        assignedGroupIds = _ref3.assignedGroupIds;
                    return _this2._handleChange({ assignedUserIds: assignedUserIds, assignedGroupIds: assignedGroupIds });
                }
            });

            this.userSelectorPanel = new _LoadingContainer2.default({
                contentComponent: this.selectorPanel,
                loadingMoireConfig: {
                    delay: 500
                }
            }).init(this.find('.groupsContent'));

            this.$headerText = this.find('.headerText');

            this.copyContent = new _CopyContent2.default({
                refreshScrollCb: function refreshScrollCb() {
                    return _this2.copyContentScrollableWrapper.forceUpdate();
                }
            });
            this.copyContentScrollableWrapper = new _ScrollableContainer2.default(null, this.copyContent, { triggerScrollEvent: false });
            this.copyContentWrapper = new _DisabledContainer2.default({
                contentComponent: new _LoadingContainer2.default({
                    contentComponent: this.copyContentScrollableWrapper,
                    containerClass: 'copyContentWrapper',
                    loadingMoireConfig: {
                        delay: 500
                    }
                }),
                containerClass: 'copyContentWrapper'
            }).init(this.$copyContent);

            this.renderInitialState();
        }
    }, {
        key: 'update',
        value: function update() {
            _get(TeamAssignmentsPanelContent.prototype.__proto__ || Object.getPrototypeOf(TeamAssignmentsPanelContent.prototype), 'update', this).call(this);
            this.selectorPanel.update();
        }
    }, {
        key: '_updateRadio',
        value: function _updateRadio() {
            this.$noAccessRadio.prop('checked', this.state.teamAssignmentType === _constants.UserTeamAssignmentType.NO);
            this.$selectAllRadio.prop('checked', this.state.teamAssignmentType === _constants.UserTeamAssignmentType.ALL);
            this.$customSelectRadio.prop('checked', this.state.teamAssignmentType === _constants.UserTeamAssignmentType.SELECTED);

            this.$noAccessSection.toggleClass('selected', this.state.teamAssignmentType === _constants.UserTeamAssignmentType.NO);
            this.$allSection.toggleClass('selected', this.state.teamAssignmentType === _constants.UserTeamAssignmentType.ALL);
            this.$customSection.toggleClass('selected', this.state.teamAssignmentType === _constants.UserTeamAssignmentType.SELECTED);
            this.$copyButton.toggleClass('disabled', this.state.teamAssignmentType !== _constants.UserTeamAssignmentType.SELECTED);

            this.$groupsList.toggleClass('notAvailable', this.state.teamAssignmentType !== _constants.UserTeamAssignmentType.SELECTED);
        }
    }, {
        key: '_updateHeader',
        value: function _updateHeader() {
            this.$headerText.text(_messageResource2.default.getMessage('user.panel.permissions.team_assignments.title', [(0, _UserNameFormat.formatFmlWithCheck)(this.state.userFML || {})]));
        }
    }, {
        key: '_updateDisabled',
        value: function _updateDisabled(disabled) {
            this.loadingSpinner.setState({ show: disabled });
            this.$selectAllRadio.prop('disabled', disabled);
            this.$customSelectRadio.prop('disabled', disabled);
            this.$noAccessRadio.prop('disabled', disabled);
            this.userSelectorPanel.setState({ loading: disabled });
        }
    }]);

    return TeamAssignmentsPanelContent;
}(_TemplateView3.default);

exports.default = TeamAssignmentsPanelContent;

/***/ }),
/* 1704 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _two_level_selection = __webpack_require__(70);

var _two_level_selection2 = _interopRequireDefault(_two_level_selection);

var _Ext = __webpack_require__(12);

var _Ext2 = _interopRequireDefault(_Ext);

var _at_users_selector_panel = __webpack_require__(162);

var _at_users_selector_panel2 = _interopRequireDefault(_at_users_selector_panel);

var _UserGroupNodeRenderer = __webpack_require__(1705);

var _UserGroupNodeRenderer2 = _interopRequireDefault(_UserGroupNodeRenderer);

var _constants = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UserSelectorPanel = function (_TemplateView) {
    _inherits(UserSelectorPanel, _TemplateView);

    function UserSelectorPanel(_ref) {
        var _ref$onChange = _ref.onChange,
            onChange = _ref$onChange === undefined ? function () {} : _ref$onChange;

        _classCallCheck(this, UserSelectorPanel);

        var _this = _possibleConstructorReturn(this, (UserSelectorPanel.__proto__ || Object.getPrototypeOf(UserSelectorPanel)).call(this));

        _this.callbacks = {
            onChange: onChange
        };

        _this.state = {
            assignedUserIds: [],
            assignedGroupIds: [],
            users: [],
            userGroups: [],
            isUGREnabled: false
        };

        _this.onAnyStatePropertyDeeplyChanged(['users', 'userGroups', 'isUGREnabled'], function () {
            return _this._initPanel();
        });
        _this.onAnyStatePropertyChanged(['assignedUserIds', 'assignedGroupIds'], function () {
            _this.panel.setSelection(new _two_level_selection2.default(_this.state.assignedGroupIds, _this.state.assignedUserIds));
        });
        return _this;
    }

    _createClass(UserSelectorPanel, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class="components_userSelectorPanel"/>';
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            this._initPanel();
        }
    }, {
        key: 'update',
        value: function update() {
            _get(UserSelectorPanel.prototype.__proto__ || Object.getPrototypeOf(UserSelectorPanel.prototype), 'update', this).call(this);
            this.panel.update();
        }
    }, {
        key: 'resetFilters',
        value: function resetFilters() {
            this.panel.afterResetAction();
        }
    }, {
        key: '_initPanel',
        value: function _initPanel() {
            var _this2 = this;

            this.getEl().empty();

            this.panel = new SelectorPanel({
                showShowInactiveCheckbox: true
            });

            this.panel.initialize(this.state.isUGREnabled, false, this.state.users, this.state.userGroups);

            this.panel.setSelectionChangedHandler(function () {
                return _this2._handleSelectionChanges();
            });

            this.panel.init(this.getEl());

            this.panel.setSelection(new _two_level_selection2.default(this.state.assignedGroupIds, this.state.assignedUserIds));
        }
    }, {
        key: '_handleSelectionChanges',
        value: function _handleSelectionChanges() {
            var changes = {
                assignedGroupIds: this.panel.getSelection().getFirstLevel(),
                assignedUserIds: this.panel.getSelection().getSecondLevel()
            };

            if (this.panel.getSelection().getFirstLevel().includes(_constants.USERS_WITHOUT_GROUP_ID)) {
                changes = {
                    assignedGroupIds: changes.assignedGroupIds.filter(function (id) {
                        return id !== _constants.USERS_WITHOUT_GROUP_ID;
                    }),
                    assignedUserIds: this.state.users.filter(function (user) {
                        return user.userGroupId === _constants.USERS_WITHOUT_GROUP_ID;
                    }).map(function (user) {
                        return user.id;
                    })
                };
            }

            this.callbacks.onChange(changes);
        }
    }]);

    return UserSelectorPanel;
}(_TemplateView3.default);

exports.default = UserSelectorPanel;


var SelectorPanel = _Ext2.default.extend(_at_users_selector_panel2.default, {
    showPermissionIcons: false,
    title: "",
    selectionChangedOnShowInactive: false,

    init: function init($el) {
        this.render($el[0]);
        this.processFirstPanelOpen();
    },
    createGenericOptions: function createGenericOptions() {
        this.genericOptions = [];
    },
    createCustomOption: function createCustomOption() {},
    getFooterSection: function getFooterSection() {
        return [];
    },
    getGenericOptionsSection: function getGenericOptionsSection() {
        return [];
    },
    getCustomOptionSection: function getCustomOptionSection() {
        var toolbox = new _Ext2.default.Container({
            cls: "userSelectorCustomControlsContainer",
            autoEl: "div",
            items: [this.viewByPanel, this.getCustomOptionButtonsSection()]
        });
        return [toolbox];
    },
    getFilterWordsPopupCoordinates: function getFilterWordsPopupCoordinates() {
        return this.userGroupsEnabled ? { x: -87, y: -3 } : { x: 2, y: -3 };
    },
    getDetailsSection: function getDetailsSection() {
        return [this.selectorTree, this.showInactiveCheckboxContainer];
    },


    getUserGroupNodeRenderer: function getUserGroupNodeRenderer() {
        return new _UserGroupNodeRenderer2.default(this.selectorTree, this.selectorFilter, this.getExpandCollapseCallback());
    },

    getCurrentOptionValue: function getCurrentOptionValue() {
        return this.customOptionValue;
    },
    isCustomOptionSelected: function isCustomOptionSelected() {
        return true;
    },
    setSelection: function setSelection(selection) {
        this.selectNodes(selection);
    },
    update: function update() {
        this.selectorTree.refreshScroller();
    }
});

/***/ }),
/* 1705 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _UserGroupWithoutCheckboxNodeRenderer = __webpack_require__(1706);

var _UserGroupWithoutCheckboxNodeRenderer2 = _interopRequireDefault(_UserGroupWithoutCheckboxNodeRenderer);

var _constants = __webpack_require__(4);

var _UserGroupNodeRenderer = __webpack_require__(238);

var _UserGroupNodeRenderer2 = _interopRequireDefault(_UserGroupNodeRenderer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UserSelectorPanelUserGroupNodeRenderer = function (_UserGroupWithoutChec) {
    _inherits(UserSelectorPanelUserGroupNodeRenderer, _UserGroupWithoutChec);

    function UserSelectorPanelUserGroupNodeRenderer() {
        _classCallCheck(this, UserSelectorPanelUserGroupNodeRenderer);

        return _possibleConstructorReturn(this, (UserSelectorPanelUserGroupNodeRenderer.__proto__ || Object.getPrototypeOf(UserSelectorPanelUserGroupNodeRenderer)).apply(this, arguments));
    }

    _createClass(UserSelectorPanelUserGroupNodeRenderer, [{
        key: 'generateContent',
        value: function generateContent(treeNode, targetEl) {
            if (treeNode.getValue().id === _constants.USERS_WITHOUT_GROUP_ID) {
                _get(UserSelectorPanelUserGroupNodeRenderer.prototype.__proto__ || Object.getPrototypeOf(UserSelectorPanelUserGroupNodeRenderer.prototype), 'generateContent', this).call(this, treeNode, targetEl);
            } else {
                _UserGroupNodeRenderer2.default.prototype.generateContent.call(this, treeNode, targetEl);
            }
        }
    }]);

    return UserSelectorPanelUserGroupNodeRenderer;
}(_UserGroupWithoutCheckboxNodeRenderer2.default);

exports.default = UserSelectorPanelUserGroupNodeRenderer;

/***/ }),
/* 1706 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
        value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _UserGroupNodeRenderer = __webpack_require__(238);

var _UserGroupNodeRenderer2 = _interopRequireDefault(_UserGroupNodeRenderer);

var _atBrowserUtils = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UserGroupWithoutCheckboxNodeRenderer = function (_UserGroupNodeRendere) {
        _inherits(UserGroupWithoutCheckboxNodeRenderer, _UserGroupNodeRendere);

        function UserGroupWithoutCheckboxNodeRenderer() {
                _classCallCheck(this, UserGroupWithoutCheckboxNodeRenderer);

                return _possibleConstructorReturn(this, (UserGroupWithoutCheckboxNodeRenderer.__proto__ || Object.getPrototypeOf(UserGroupWithoutCheckboxNodeRenderer)).apply(this, arguments));
        }

        _createClass(UserGroupWithoutCheckboxNodeRenderer, [{
                key: "generateContent",
                value: function generateContent(treeNode, targetEl) {
                        var tableEl = document.createElement("table");
                        var tBodyEl = document.createElement("tbody");
                        var trEl = document.createElement("tr");
                        var titleTdEl = document.createElement("td");
                        var collapseTdEl = document.createElement("td");

                        //visibility of this buttons are maintained by css
                        var normalExpandCollapseButton = this.generateExpandCollapseButton(treeNode, true, "normalExpandCollapseButton", null);
                        var disabledExpandCollapseButtonWithTitle = this.generateExpandCollapseButton(treeNode, false, "disabledExpandCollapseButtonWithTitle", this.getExpandCollapseButtonTitle(treeNode));
                        var disabledExpandCollapseButtonWithoutTitle = this.generateExpandCollapseButton(treeNode, false, "disabledExpandCollapseButtonWithoutTitle", null);

                        tableEl.appendChild(tBodyEl);
                        tBodyEl.appendChild(trEl);
                        trEl.appendChild(titleTdEl);
                        trEl.appendChild(collapseTdEl);
                        collapseTdEl.appendChild(normalExpandCollapseButton);
                        collapseTdEl.appendChild(disabledExpandCollapseButtonWithTitle);
                        collapseTdEl.appendChild(disabledExpandCollapseButtonWithoutTitle);

                        var spacerDiv = document.createElement("div");
                        spacerDiv.className = "spacer";
                        spacerDiv.innerHTML = "<b></b>"; // for IE to display correctly

                        targetEl.appendChild(tableEl);
                        targetEl.appendChild(spacerDiv);

                        var titleNode = document.createElement("a");
                        titleNode.className = "titleNode";
                        titleNode.hidefocus = "true";

                        (0, _atBrowserUtils.disableTextSelection)(titleNode);

                        var labelEl = document.createElement("span");
                        labelEl.className = "ellipsisLabel";
                        this.generateLabel(treeNode, labelEl);

                        titleTdEl.appendChild(titleNode);
                        titleNode.appendChild(labelEl);

                        this.tree.getUIObjectForNode(treeNode).cbEl = titleNode;
                        this.tree.getUIObjectForNode(treeNode).labelEl = labelEl;
                }
        }]);

        return UserGroupWithoutCheckboxNodeRenderer;
}(_UserGroupNodeRenderer2.default);

exports.default = UserGroupWithoutCheckboxNodeRenderer;

/***/ }),
/* 1707 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _UserWithAccessRights = __webpack_require__(138);

var _UserWithAccessRights2 = _interopRequireDefault(_UserWithAccessRights);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _CopyUserSelector = __webpack_require__(397);

var _CopyUserSelector2 = _interopRequireDefault(_CopyUserSelector);

var _CopyAssignmentsFromButton = __webpack_require__(557);

var _CopyAssignmentsFromButton2 = _interopRequireDefault(_CopyAssignmentsFromButton);

var _utils = __webpack_require__(6);

var _redux = __webpack_require__(7);

var _selectors = __webpack_require__(313);

var _selectors2 = __webpack_require__(15);

var _selectors3 = __webpack_require__(14);

var _actions = __webpack_require__(403);

var _pluralizeUtils = __webpack_require__(40);

var _DropdownDialogWithPointerWrapper = __webpack_require__(182);

var _DropdownDialogWithPointerWrapper2 = _interopRequireDefault(_DropdownDialogWithPointerWrapper);

var _ScrollableContainer = __webpack_require__(49);

var _ScrollableContainer2 = _interopRequireDefault(_ScrollableContainer);

var _UsersList = __webpack_require__(1708);

var _UsersList2 = _interopRequireDefault(_UsersList);

var _atUtils = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CopyContent = function (_TemplateView) {
    _inherits(CopyContent, _TemplateView);

    function CopyContent() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            _ref$onCancel = _ref.onCancel,
            onCancel = _ref$onCancel === undefined ? function () {} : _ref$onCancel,
            _ref$onSelectUser = _ref.onSelectUser,
            onSelectUser = _ref$onSelectUser === undefined ? function (userId) {} : _ref$onSelectUser,
            _ref$onCopy = _ref.onCopy,
            onCopy = _ref$onCopy === undefined ? function () {} : _ref$onCopy,
            _ref$refreshScrollCb = _ref.refreshScrollCb,
            refreshScrollCb = _ref$refreshScrollCb === undefined ? function () {} : _ref$refreshScrollCb;

        _classCallCheck(this, CopyContent);

        var _this = _possibleConstructorReturn(this, (CopyContent.__proto__ || Object.getPrototypeOf(CopyContent)).call(this));

        _this.params = {
            onCancel: onCancel,
            onSelectUser: onSelectUser,
            onCopy: onCopy,
            refreshScrollCb: refreshScrollCb
        };

        _this.state = {
            userId: null,
            userFrom: null,
            userTo: null,
            viewer: null,

            userFromAssignedUsers: [],

            users: [],
            userGroups: {},
            timeZoneGroups: {},

            ugrEnabled: true,
            tzgEnabled: true
        };

        _this.onAnyStatePropertyChanged(['userFrom', 'userTo'], function (_ref2) {
            var userFrom = _ref2.userFrom;

            _this.copyAssignmentsButton.setState({
                selectedUser: userFrom
            });
            _this._updateCommentNote();
        });

        _this.onAnyStatePropertyChanged(['users', 'userGroups', 'timeZoneGroups', 'ugrEnabled', 'tzgEnabled'], function () {
            var usersWithAccessRights = _this.state.users.map(function (userFrom) {
                return _UserWithAccessRights2.default.fromRPC(userFrom);
            });

            _this.copyUserSelector.setState({
                users: usersWithAccessRights,
                ugrEnabled: _this.state.ugrEnabled,
                userGroups: Object.values(_this.state.userGroups).sort(_atUtils.userGroupsComparator),
                tzgEnabled: _this.state.tzgEnabled,
                timeZoneGroups: Object.values(_this.state.timeZoneGroups).sort(_atUtils.timeZoneGroupsComparator)
            });
        });

        _this.onStatePropertyChanged('userId', function (userId) {
            _this.$copyButton.toggleClass('disabled', userId === null);
        });

        _this.onStatePropertyChanged('userFromAssignedUsers', function (users) {
            _this.$users.toggleClass('disabled', users.length === 0).text(users.length + ' ' + (0, _pluralizeUtils.userNameLower)(users.length));

            _this.usersList.setState({
                showGroups: _this.state.ugrEnabled,
                items: users,
                groups: _this.state.userGroups
            });
        });
        return _this;
    }

    _createClass(CopyContent, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class="copyContent">' + '  <div class="title"><%-title%></div>' + '  <div class="userSelector"/>' + '  <div class="copyInfo">' + '    <div class="usersInfo">' + '      <div class="title"><%-counterTitle%></div>' + '      <div class="users"></div>' + '    </div>' + '    <div class="commentNote"/>' + '  </div>' + '  <div class="buttonsSection">' + '    <div class="copyButton"><%-copy%></div>' + '    <div class="cancelButton"><%-cancel%></div>' + '  </div>' + '</div>';
        }
    }, {
        key: 'templateModel',
        value: function templateModel() {
            return {
                title: _messageResource2.default.getMessage('user.panel.permissions.team_assignments.copy.title'),
                counterTitle: _messageResource2.default.getMessage('work_assignments.panel.copy.counter_title'),
                copy: _messageResource2.default.getMessage('common.copy'),
                cancel: _messageResource2.default.getMessage('common.cancel')
            };
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            var _this2 = this;

            this.$userSelector = this.find('.userSelector');
            this.$countersSection = this.find('.counters');
            this.$copyButton = this.find('.copyButton');
            this.$cancelButton = this.find('.cancelButton');

            this.$cancelButton.click(function () {
                _this2.params.onCancel();
            });

            this.$copyButton.click(function () {
                if (_this2._copyEnabled()) {
                    _this2.params.onCopy();
                }
            });

            this.copyUserSelector = new _CopyUserSelector2.default({
                title: _messageResource2.default.getMessage("user.add.js.copy_setting.selector.label"),
                selectionCallback: function selectionCallback(user) {
                    _this2.params.onSelectUser(user.id);
                    _this2.copyUserSelector.hide();
                },
                onHideCb: function onHideCb() {
                    _this2.$el.removeClass('withUserSelector');
                    _this2.params.refreshScrollCb();
                },
                showPermissionIcons: false,
                renderTo: this.getEl()
            }).init();

            this.copyAssignmentsButton = new _CopyAssignmentsFromButton2.default().init(this.$userSelector);
            this.copyAssignmentsButton.bindClick(function () {
                _this2.copyUserSelector.showAt(_this2.copyAssignmentsButton.$el, "t-b");
                _this2.$el.toggleClass('withUserSelector', true);
                _this2.params.refreshScrollCb();
            });

            this.$users = this.find('.users');
            this.$users.click(function () {
                if (_this2.state.userFromAssignedUsers.length > 0) {
                    _this2.usersListDialog.showAt(_this2.$users, {
                        my: "center top",
                        at: "center bottom"
                    });
                    _this2.$el.toggleClass('withUserSelector', true);
                    _this2.params.refreshScrollCb();
                    _this2.usersList.forceUpdate();
                }
            });

            this.usersList = new _ScrollableContainer2.default(null, new _UsersList2.default({
                additionalClass: 'assignedUsersList'
            }), {
                containerClass: 'assignedUsersListScrollableWrapper'
            });

            this.usersListDialog = new _DropdownDialogWithPointerWrapper2.default({
                dialog: this.usersList,
                dialogOffsets: {
                    top: 10,
                    left: 70
                },
                onHide: function onHide() {
                    _this2.$el.removeClass('withUserSelector');
                    _this2.params.refreshScrollCb();
                }
            }).init(this.$el);

            this.$copyInfo = this.find('.copyInfo');
            this.$commentNote = this.find('.commentNote');
        }
    }, {
        key: '_copyEnabled',
        value: function _copyEnabled() {
            return this.state.userId !== null;
        }
    }, {
        key: '_updateCommentNote',
        value: function _updateCommentNote() {
            this.$copyInfo.toggleClass('invisible', !this.state.userFrom);
            if (this.state.userTo) {
                this.$commentNote.text(_messageResource2.default.getMessage('user.panel.permissions.team_assignments.copy.note', [this.state.userTo]));
            } else {
                this.$commentNote.empty();
            }
        }
    }]);

    return CopyContent;
}(_TemplateView3.default);

exports.default = (0, _utils.connect)(function (state) {
    return {
        userId: (0, _selectors.getCopyUserId)(state),
        userFrom: (0, _selectors.getCopyUserFrom)(state),
        userTo: (0, _selectors.getPanelUserFirstName)(state),
        userFromAssignedUsers: (0, _selectors.getUserFromAssignedUsers)(state),

        users: (0, _selectors.getSelectorsUsers)(state),
        userGroups: (0, _selectors3.getUserGroupsWithDefault)(state),
        timeZoneGroups: (0, _selectors3.getTimeZoneGroups)(state),

        ugrEnabled: (0, _selectors2.isUGREnabled)(state),
        tzgEnabled: (0, _selectors2.isTZGEnabled)(state)
    };
}, function (dispatch) {
    return {
        onSelectUser: (0, _redux.bindActionCreators)(_actions.loadUserFromAssignedUsers, dispatch),
        onCopy: (0, _redux.bindActionCreators)(_actions.copyAssignments, dispatch),
        onCancel: (0, _redux.bindActionCreators)(_actions.cancelCopy, dispatch)
    };
})(CopyContent);

/***/ }),
/* 1708 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _TwoLevelList2 = __webpack_require__(1709);

var _TwoLevelList3 = _interopRequireDefault(_TwoLevelList2);

var _ListItem = __webpack_require__(894);

var _ListItem2 = _interopRequireDefault(_ListItem);

var _atUtils = __webpack_require__(5);

var _user_group_selector_util = __webpack_require__(98);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UsersList = function (_TwoLevelList) {
    _inherits(UsersList, _TwoLevelList);

    function UsersList(_ref) {
        var _ref$additionalClass = _ref.additionalClass,
            additionalClass = _ref$additionalClass === undefined ? '' : _ref$additionalClass;

        _classCallCheck(this, UsersList);

        return _possibleConstructorReturn(this, (UsersList.__proto__ || Object.getPrototypeOf(UsersList)).call(this, {
            additionalClass: 'usersList ' + additionalClass,
            groupToComponent: function groupToComponent(group) {
                return new _ListItem2.default({
                    text: group.name.toUpperCase(),
                    additionalClass: 'group'
                });
            },
            itemToComponent: function itemToComponent(user) {
                return new _ListItem2.default({
                    text: user.lastName + ', ' + user.firstName,
                    additionalClass: 'user'
                });
            },
            itemToGroupId: function itemToGroupId(user) {
                return user.userGroupId;
            },
            groupComparator: _atUtils.userGroupsComparator,
            itemComparator: function itemComparator(u1, u2) {
                return (0, _user_group_selector_util.userComparator)(u1, u2);
            }
        }));
    }

    return UsersList;
}(_TwoLevelList3.default);

exports.default = UsersList;

/***/ }),
/* 1709 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Component's list with ability show group titles.
 * @state   items - items array
 *          groups - groups map
 */
var TwoLevelList = function (_TemplateView) {
    _inherits(TwoLevelList, _TemplateView);

    function TwoLevelList(_ref) {
        var _ref$additionalClass = _ref.additionalClass,
            additionalClass = _ref$additionalClass === undefined ? '' : _ref$additionalClass,
            _ref$itemToComponent = _ref.itemToComponent,
            itemToComponent = _ref$itemToComponent === undefined ? function (item) {
            return null;
        } : _ref$itemToComponent,
            _ref$itemToGroupId = _ref.itemToGroupId,
            itemToGroupId = _ref$itemToGroupId === undefined ? function (item) {
            return null;
        } : _ref$itemToGroupId,
            _ref$groupToComponent = _ref.groupToComponent,
            groupToComponent = _ref$groupToComponent === undefined ? function (group) {
            return null;
        } : _ref$groupToComponent,
            _ref$groupComparator = _ref.groupComparator,
            groupComparator = _ref$groupComparator === undefined ? function (g1, g2) {
            return 0;
        } : _ref$groupComparator,
            _ref$itemComparator = _ref.itemComparator,
            itemComparator = _ref$itemComparator === undefined ? function (i1, i2) {
            return 0;
        } : _ref$itemComparator;

        _classCallCheck(this, TwoLevelList);

        var _this = _possibleConstructorReturn(this, (TwoLevelList.__proto__ || Object.getPrototypeOf(TwoLevelList)).call(this));

        _this._itemByGroupComparator = function (i1, i2) {
            var item1group = _this.state.groups[_this.params.itemToGroupId(i1)];
            var item2group = _this.state.groups[_this.params.itemToGroupId(i2)];
            var compareResult = _this.params.groupComparator(item1group, item2group);
            return compareResult === 0 ? _this.params.itemComparator(i1, i2) : compareResult;
        };

        _this.params = {
            additionalClass: additionalClass,
            groupToComponent: groupToComponent,
            itemToComponent: itemToComponent,
            itemToGroupId: itemToGroupId,
            groupComparator: groupComparator,
            itemComparator: itemComparator
        };

        _this.state = {
            groups: {},
            items: [],
            showGroups: false
        };

        _this.onStatePropertyDeeplyChanged('items', function () {
            return _this._renderList();
        });
        return _this;
    }

    _createClass(TwoLevelList, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class="components_twoLevelList <%=additionalClass%>"/>';
        }
    }, {
        key: 'templateModel',
        value: function templateModel() {
            return {
                additionalClass: this.params.additionalClass
            };
        }
    }, {
        key: '_renderList',
        value: function _renderList() {
            var _this2 = this;

            this.$el.empty();

            var prevGroupId = null;

            this.state.items.sort(function (i1, i2) {
                return _this2.state.showGroups ? _this2._itemByGroupComparator(i1, i2) : _this2.params.itemComparator(i1, i2);
            }).forEach(function (item) {
                if (_this2.state.showGroups) {
                    var currentGroupId = _this2.params.itemToGroupId(item);
                    if (prevGroupId !== currentGroupId) {
                        prevGroupId = currentGroupId;
                        _this2.params.groupToComponent(_this2.state.groups[currentGroupId]).init(_this2.$el);
                    }
                }
                _this2.params.itemToComponent(item).init(_this2.$el);
            });
        }
    }]);

    return TwoLevelList;
}(_TemplateView3.default);

exports.default = TwoLevelList;

/***/ }),
/* 1710 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isPanelOpened = exports.selectTeamAssignmentsPanel = undefined;

var _reselect = __webpack_require__(13);

var selectTeamAssignmentsPanel = exports.selectTeamAssignmentsPanel = function selectTeamAssignmentsPanel(state) {
    return state.userManagement.createTeamAssignmentsPanel;
};

var isPanelOpened = exports.isPanelOpened = (0, _reselect.createSelector)(selectTeamAssignmentsPanel, function (panel) {
    return panel.show;
});

/***/ }),
/* 1711 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _View2 = __webpack_require__(20);

var _View3 = _interopRequireDefault(_View2);

var _utils = __webpack_require__(6);

var _redux = __webpack_require__(7);

var _selectors = __webpack_require__(146);

var _PanelContainer = __webpack_require__(109);

var _PanelContainer2 = _interopRequireDefault(_PanelContainer);

var _EditUserPanelContainer = __webpack_require__(1712);

var _EditUserPanelContainer2 = _interopRequireDefault(_EditUserPanelContainer);

var _actions = __webpack_require__(126);

var _LoadingContainer = __webpack_require__(28);

var _LoadingContainer2 = _interopRequireDefault(_LoadingContainer);

var _constants = __webpack_require__(62);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EditUserPanel = function (_View) {
    _inherits(EditUserPanel, _View);

    function EditUserPanel(_ref) {
        var _ref$onPanelHide = _ref.onPanelHide,
            onPanelHide = _ref$onPanelHide === undefined ? function () {} : _ref$onPanelHide,
            _ref$loadEditUserPane = _ref.loadEditUserPanelData,
            loadEditUserPanelData = _ref$loadEditUserPane === undefined ? function () {} : _ref$loadEditUserPane;

        _classCallCheck(this, EditUserPanel);

        var _this = _possibleConstructorReturn(this, (EditUserPanel.__proto__ || Object.getPrototypeOf(EditUserPanel)).call(this));

        _this.onPanelHide = onPanelHide;
        _this.loadEditUserPanelData = loadEditUserPanelData;

        _this.state = {
            show: false,
            loading: false,
            needToLoadData: true
        };

        _this.onStatePropertyChanged('loading', function (loading) {
            return _this.loadingWrapper.setState({ loading: loading });
        });

        _this.onStatePropertyChanged('show', function (show) {
            _this.wrapper.setState({ isShown: show });
        });

        _this.onStatePropertyChanged('needToLoadData', function (needToLoadData, prevNeedToLoadData) {
            if (needToLoadData !== prevNeedToLoadData && needToLoadData === true) {
                _this.loadEditUserPanelData();
            }
        });
        return _this;
    }

    _createClass(EditUserPanel, [{
        key: 'afterRender',
        value: function afterRender() {
            var _this2 = this;

            this.loadingWrapper = new _LoadingContainer2.default({
                contentComponent: new _EditUserPanelContainer2.default(),
                containerClass: 'userPanelLoadingWrapper',
                loadingMoireConfig: { delay: 500 }
            });

            this.wrapper = new _PanelContainer2.default({
                component: this.loadingWrapper,
                additionalClass: "edit_user_sliding_panel sliding_panel",
                showAnimationClass: _constants.SHOW_ANIMATION_CLASSES.SLIDE_LEFT,
                hideAnimationClass: _constants.HIDE_ANIMATION_CLASSES.SLIDE_LEFT,
                showHideButton: true,
                hideOnEsc: true,
                hideOnClickOutside: {
                    hideOnClick: true,
                    panelType: _constants.PANEL_TYPES.EDIT_USER
                },
                onHideCallback: function onHideCallback() {
                    return _this2.onPanelHide();
                },
                hideHandler: function hideHandler() {
                    return _this2.wrapper.setState({ isShown: false });
                },
                onClickCloseButton: function onClickCloseButton() {
                    return _this2.onPanelHide();
                }
            }).init(this.$containerEl);
        }
    }]);

    return EditUserPanel;
}(_View3.default);

exports.default = (0, _utils.connect)(function (state) {
    return {
        needToLoadData: (0, _selectors.isNeedToLoadData)(state),
        show: (0, _selectors.isPanelOpened)(state),
        loading: (0, _selectors.isLoading)(state)
    };
}, function (dispatch) {
    return {
        onPanelHide: (0, _redux.bindActionCreators)(_actions.closeEditUserPanel, dispatch),
        loadEditUserPanelData: (0, _redux.bindActionCreators)(_actions.loadEditUserPanelData, dispatch)
    };
})(EditUserPanel);

/***/ }),
/* 1712 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _UserPanelContainer2 = __webpack_require__(149);

var _UserPanelContainer3 = _interopRequireDefault(_UserPanelContainer2);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _utils = __webpack_require__(6);

var _redux = __webpack_require__(7);

var _selectors = __webpack_require__(146);

var _Header = __webpack_require__(1713);

var _Header2 = _interopRequireDefault(_Header);

var _actions = __webpack_require__(147);

var _actions2 = __webpack_require__(126);

var _selectors2 = __webpack_require__(64);

var _actions3 = __webpack_require__(403);

var _utils2 = __webpack_require__(25);

var _UserGroupRow = __webpack_require__(879);

var _UserGroupRow2 = _interopRequireDefault(_UserGroupRow);

var _TimeZoneGroupRow = __webpack_require__(878);

var _TimeZoneGroupRow2 = _interopRequireDefault(_TimeZoneGroupRow);

var _actions4 = __webpack_require__(207);

var _constants = __webpack_require__(21);

var _selectors3 = __webpack_require__(19);

var _selectors4 = __webpack_require__(257);

var _selectors5 = __webpack_require__(556);

var _selectors6 = __webpack_require__(515);

var _actions5 = __webpack_require__(50);

var _selectors7 = __webpack_require__(53);

var _ConfirmationDialog = __webpack_require__(559);

var _ConfirmationDialog2 = _interopRequireDefault(_ConfirmationDialog);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _LastManagerInfo = __webpack_require__(560);

var _LastManagerInfo2 = _interopRequireDefault(_LastManagerInfo);

var _constants2 = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EditUserPanelContainer = function (_UserPanelContainer) {
    _inherits(EditUserPanelContainer, _UserPanelContainer);

    function EditUserPanelContainer(_ref) {
        var actions = _ref.actions;

        _classCallCheck(this, EditUserPanelContainer);

        var _this = _possibleConstructorReturn(this, (EditUserPanelContainer.__proto__ || Object.getPrototypeOf(EditUserPanelContainer)).call(this, {
            accountSettingsId: "editUserPanel",
            mode: _UserPanelContainer2.MODE.EDIT,
            actions: actions
        }));

        _this._handleTeamAssignmentsPanelVisibility = function (visible, e) {
            _this.actions.openTeamAssignmentsPanelFromEditPanel();
            (0, _utils2.setEventPreventHidingTeamAssignmentSlidingPanel)(e);
        };

        _this.state = _extends({}, _get(EditUserPanelContainer.prototype.__proto__ || Object.getPrototypeOf(EditUserPanelContainer.prototype), "state", _this), {
            isLastLicenseManagerOnDeleteAlertShown: false,
            isLastLicenseManagerOnDisableAtAlertShown: false,
            isLastLicenseManagerOnDisableApAlertShown: false
        });

        _this.onStatePropertyChanged('selectedTab', function (selectedTab) {
            _this.userPanelContent.setState({
                currentTabKey: selectedTab
            });
        });

        _this.onStatePropertyBecameTrue('isLastLicenseManagerOnDeleteAlertShown', function () {
            return _this.deleteAlert.show();
        });
        _this.onStatePropertyBecameTrue('isLastLicenseManagerOnDisableAtAlertShown', function () {
            return _this.disableAtAlert.show();
        });
        _this.onStatePropertyBecameTrue('isLastLicenseManagerOnDisableApAlertShown', function () {
            return _this.disableApAlert.show();
        });

        _this.onStatePropertyChanged('allApprovers', function (approversList) {
            _this.accountSettingsTab.setState({ approversList: approversList });
        });
        return _this;
    }

    _createClass(EditUserPanelContainer, [{
        key: "afterRender",
        value: function afterRender() {
            this.$el.attr("id", "editUserPanel");
            this.$el.addClass("components_editUserPanel");

            this.header = new _Header2.default().init(this.find('.panelHeader'));
            this._createLastManagerInfoComponents();
            _get(EditUserPanelContainer.prototype.__proto__ || Object.getPrototypeOf(EditUserPanelContainer.prototype), "afterRender", this).call(this);
        }
    }, {
        key: "subscribeForEvents",
        value: function subscribeForEvents() {
            var _this2 = this;

            _get(EditUserPanelContainer.prototype.__proto__ || Object.getPrototypeOf(EditUserPanelContainer.prototype), "subscribeForEvents", this).call(this);

            this.header.on('deleteUser', function () {
                if (confirm(_messageResource2.default.getMessage("userlist.js.confirm_delete_user"))) {
                    _this2.actions.deleteUser(false);
                }
            });

            this.accountSettingsTab.accountInformation.on('changeAccess', function () {
                _this2.actions.updateAccess(!_this2.state.fullUserInfo.enabled, false);
            });

            this.accountSettingsTab.accountInformation.on('changeAccessToOtherProduct', function () {
                _this2.actions.updateAccessAP(!_this2.state.fullUserInfo.enabledInOtherProduct, false);
            });
        }
    }, {
        key: "_createLastManagerInfoComponents",
        value: function _createLastManagerInfoComponents() {
            var _this3 = this;

            this.deleteLastManagerInfo = new _LastManagerInfo2.default({ isDeleting: true });
            var $body = (0, _jquery2.default)('body');
            this.deleteAlert = new _ConfirmationDialog2.default({
                onShow: function onShow() {
                    return _this3.deleteLastManagerInfo.setState({
                        userName: _this3.state.fullUserInfo.firstName + " " + _this3.state.fullUserInfo.lastName
                    });
                },
                // pass first force = true due to last approver check done before last LM
                onConfirm: function onConfirm() {
                    return _this3.actions.deleteUser(true, true);
                },
                onHide: function onHide() {
                    return _this3.actions.setLastLicenseManagerOnDeleteAlertShown(false);
                },
                contentComponent: this.deleteLastManagerInfo
            }).init($body);

            this.disableAtLastManagerInfo = new _LastManagerInfo2.default({});
            this.disableAtAlert = new _ConfirmationDialog2.default({
                onShow: function onShow() {
                    return _this3.disableAtLastManagerInfo.setState({
                        userName: _this3.state.fullUserInfo.firstName + " " + _this3.state.fullUserInfo.lastName
                    });
                },
                // pass first force = true due to last approver check done before last LM
                onConfirm: function onConfirm() {
                    return _this3.actions.updateAccess(!_this3.state.fullUserInfo.enabled, true, true);
                },
                onCancel: function onCancel() {
                    return _this3.accountSettingsTab.accountInformation.editAccountInformation.accessSelector.setState({ enabled: _this3.state.fullUserInfo.enabled });
                },
                onHide: function onHide() {
                    return _this3.actions.setLastLicenseManagerOnDisableAtAlertShown(false);
                },
                contentComponent: this.disableAtLastManagerInfo
            }).init($body);

            this.disableApLastManagerInfo = new _LastManagerInfo2.default({ product: _constants2.Product.actiPLANS });
            this.disableApAlert = new _ConfirmationDialog2.default({
                onShow: function onShow() {
                    return _this3.disableApLastManagerInfo.setState({
                        userName: _this3.state.fullUserInfo.firstName + " " + _this3.state.fullUserInfo.lastName
                    });
                },
                // pass first force = true due to last approver check done before last LM
                onConfirm: function onConfirm() {
                    return _this3.actions.updateAccessAP(!_this3.state.fullUserInfo.enabledInOtherProduct, true, true);
                },
                onCancel: function onCancel() {
                    return _this3.accountSettingsTab.accountInformation.editAccountInformation.accessToOtherProductSelector.setState({ enabled: _this3.state.fullUserInfo.enabledInOtherProduct });
                },
                onHide: function onHide() {
                    return _this3.actions.setLastLicenseManagerOnDisableApAlertShown(false);
                },
                contentComponent: this.disableApLastManagerInfo
            }).init($body);
        }
    }, {
        key: "_createUserGroupRowComponent",
        value: function _createUserGroupRowComponent() {
            var _this4 = this;

            return new _UserGroupRow2.default({
                showSaveButton: true,
                createNewUserGroup: function createNewUserGroup(name) {
                    return _this4.actions.updateUserGroup(_constants.GROUP_NEW_OR_NOT_KNOWN, name);
                },
                onGroupChanged: function onGroupChanged(id) {
                    return _this4.actions.updateUserGroup(id, "");
                },
                updateRowDate: function updateRowDate(data) {
                    return _this4.actions.setUserGroupData(data);
                },
                resetGroup: function resetGroup() {
                    return _this4.actions.resetUserGroupRow();
                }
            });
        }
    }, {
        key: "_createTimeZoneGroupRowComponent",
        value: function _createTimeZoneGroupRowComponent() {
            var _this5 = this;

            return new _TimeZoneGroupRow2.default({
                showSaveButton: true,
                createNewGroup: function createNewGroup(data) {
                    return _this5.actions.updateTimeZoneGroup(_constants.GROUP_NEW_OR_NOT_KNOWN, data);
                },
                onGroupChanged: function onGroupChanged(id) {
                    return _this5.actions.updateTimeZoneGroup(id, null);
                },
                updateRowDate: function updateRowDate(data) {
                    return _this5.actions.setTimeZoneGroupData(data);
                },
                resetGroup: function resetGroup() {
                    return _this5.actions.resetTimeZoneGroupRow();
                },
                validateTimeZoneGroup: function validateTimeZoneGroup(tzgId, newTzg) {
                    return _this5.actions.validateTimeZoneGroup(tzgId, newTzg);
                }
            });
        }
    }]);

    return EditUserPanelContainer;
}(_UserPanelContainer3.default);

exports.default = (0, _utils.connect)(function (state) {
    return _extends({}, (0, _selectors.selectEditUserPanel)(state), (0, _selectors2.getUserDataWithAdditionalData)(state), (0, _selectors5.getAuthorizationInfo)(state), {
        userManagementData: (0, _selectors7.getUserManagementData)(state),
        loggedInUserId: (0, _selectors3.getLoggedInUserId)(state),
        managementAssignmentsCounts: (0, _selectors2.getManagementAssignmentsCounters)(state),
        updatingUserRates: (0, _selectors4.isUpdating)(state),
        updatingWorkSchedule: (0, _selectors.isUpdatingWorkSchedule)(state),
        allUserGroups: (0, _selectors6.getUserGroupsList)(state),
        allTimeZoneGroups: (0, _selectors6.getTimeZoneGroupsList)(state),
        allApprovers: (0, _selectors2.getAllApprovers)(state),
        isLastLicenseManagerOnDeleteAlertShown: (0, _selectors.isLastLicenseManagerOnDeleteAlertShown)(state),
        isLastLicenseManagerOnDisableAtAlertShown: (0, _selectors.isLastLicenseManagerOnDisableAtAlertShown)(state),
        isLastLicenseManagerOnDisableApAlertShown: (0, _selectors.isLastLicenseManagerOnDisableApAlertShown)(state)
    });
}, function (dispatch) {
    return {
        actions: _extends({
            restoreState: (0, _redux.bindActionCreators)(_actions2.restoreState, dispatch),
            switchTab: (0, _redux.bindActionCreators)(_actions2.setUserPanelTab, dispatch)
        }, (0, _redux.bindActionCreators)({
            updateFirstName: _actions2.updateFirstName,
            updateLastName: _actions2.updateLastName,
            updateMiddleName: _actions2.updateMiddleName,
            updateUserName: _actions2.updateUserName,
            updateEmail: _actions2.updateEmail,
            updatePassword: _actions2.updatePassword,
            updateUserGroup: _actions2.updateUserGroup,
            setUserGroupData: _actions.setUserGroupData,
            resetUserGroupRow: _actions.resetUserGroupRow,
            updateTimeZoneGroup: _actions2.updateTimeZoneGroup,
            validateTimeZoneGroup: _actions.validateTimeZoneGroup,
            setTimeZoneGroupData: _actions.setTimeZoneGroupData,
            resetTimeZoneGroupRow: _actions.resetTimeZoneGroupRow,
            updateHireDate: _actions2.updateHireDate,
            setHasLeavesOrTTBeforeNewHireDateError: _actions2.setHasLeavesOrTTBeforeNewHireDateError,
            updateReleaseDate: _actions2.updateReleaseDate,
            updateAccess: _actions2.updateAccess,
            updateAccessAP: _actions2.updateAccessAP,
            updateRequireApproval: _actions2.updateRequireApproval,
            updateUserSchedules: _actions2.updateUserSchedules,
            updateDefaultWorkStatuses: _actions2.updateDefaultWorkStatuses,
            updateInitialUserSchedule: _actions2.updateInitialUserSchedule,
            addNewSchedule: _actions2.addNewSchedule,
            deleteUserSchedule: _actions2.deleteUserSchedule,
            updateOvertime: _actions2.updateOvertime,
            changeTeamAssignments: _actions2.changeTeamAssignments,
            updateUserRights: _actions2.updateUserRights,
            deleteUser: _actions2.deleteUser,
            openTeamAssignmentsPanelFromEditPanel: _actions3.openTeamAssignmentsPanelFromEditPanel,
            openManagementAssignmentPanel: _actions4.openManagementAssignmentPanel,
            setUserManagementData: _actions5.setUserManagementData,
            setLastLicenseManagerOnDeleteAlertShown: _actions2.setLastLicenseManagerOnDeleteAlertShown,
            setLastLicenseManagerOnDisableAtAlertShown: _actions2.setLastLicenseManagerOnDisableAtAlertShown,
            setLastLicenseManagerOnDisableApAlertShown: _actions2.setLastLicenseManagerOnDisableApAlertShown
        }, dispatch))
    };
})(EditUserPanelContainer);

/***/ }),
/* 1713 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _UserNameFormat = __webpack_require__(17);

var _UserNameFormat2 = _interopRequireDefault(_UserNameFormat);

var _SpinnerController = __webpack_require__(69);

var _SpinnerController2 = _interopRequireDefault(_SpinnerController);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Header = function (_TemplateView) {
    _inherits(Header, _TemplateView);

    function Header() {
        _classCallCheck(this, Header);

        var _this = _possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).call(this, null));

        _this.lastLoginTime = null;
        _this.userName = null;
        _this.delDisabled = false;

        _this.state = {
            hasTimeTrack: null,
            loggedIn: null,
            lastOtherProductAdmin: null,
            firstName: null,
            lastName: null,
            middleInitial: null,
            lastLoginTime: null,
            updateLoading: null,
            noRightsToDelete: false
        };

        _this.onStateChanged(function () {
            return _this.update();
        });
        _this.onStatePropertyChanged('lastLoginTime', function (lastLoginTime) {
            _this.$lastLoginLabel.text(_messageResource2.default.getMessage(lastLoginTime ? "user.panel.header.last_login" : "user.panel.header.never_logged_in"));
            _this.$lastLoginTimestamp.text(lastLoginTime ? lastLoginTime : "");
        });

        var onNameChanged = function onNameChanged() {
            _this.$userName.text(_UserNameFormat2.default.formatFML(_this.state.firstName, _this.state.lastName, _this.state.middleInitial));
        };

        _this.onStatePropertyChanged('firstName', onNameChanged);
        _this.onStatePropertyChanged('lastName', onNameChanged);
        _this.onStatePropertyChanged('middleInitial', onNameChanged);

        var toggleDeleteButtonState = function toggleDeleteButtonState() {
            _this.$deleteButton.toggle(!_this.state.loggedIn && !_this.state.noRightsToDelete);
            _this.delDisabled = _this.state.hasTimeTrack || _this.state.lastOtherProductAdmin || _this.state.noRightsToDelete;
            _this.$deleteButton.toggleClass('disabled', !!_this.delDisabled);
            var tooltip = null;
            if (_this.state.hasTimeTrack) tooltip = _messageResource2.default.getMessage("user.edit.js.cannot_delete.has_task_record");else if (_this.state.lastOtherProductAdmin) tooltip = _messageResource2.default.getMessage("user.edit.js.cannot_delete.last_admin_ap");

            if (tooltip) _this.$deleteButton.attr('title', tooltip);else _this.$deleteButton.removeAttr('title');
        };
        _this.onStatePropertyChanged('hasTimeTrack', toggleDeleteButtonState);
        _this.onStatePropertyChanged('loggedIn', toggleDeleteButtonState);
        _this.onStatePropertyChanged('lastOtherProductAdmin', toggleDeleteButtonState);
        _this.onStatePropertyChanged('noRightsToDelete', toggleDeleteButtonState);

        _this.onStatePropertyChanged('updateLoading', function (loading) {
            return loading ? _this.spinner.spinInElement(_this.$spinner) : _this.spinner.stop();
        });
        return _this;
    }

    _createClass(Header, [{
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='header userPanel_panelHeader'>" + "    <div class='lastLogin'>" + "        <span class='loggedInLabel'/> <span class='lastLoginTimestamp'/>" + "    </div>" + "    <div class='userName nameInfo ellipsis'/>" + "    <div class='tabs'>" + "        <div class='accountSettingsTab'><span class='tabText'><%=accountSettingsTab%></span></div>" + "        <div class='permissionsTab'><span class='tabText'><%=permissionsTab%></span></div>" + "    </div>" + "    <div class='actions'><div class='actionButtonWrapper'>" + "        <div class='deleteButton actionButton'><div class='action'><%=deleteButton%></div></div>" + "    </div></div>" + "    <div class='spinner'/>" + "</div>";
        }
    }, {
        key: "messageKeys",
        value: function messageKeys() {
            return {
                accountSettingsTab: "user.panel.header.tabs.account",
                permissionsTab: "user.panel.header.tabs.permissions",
                deleteButton: "user.panel.header.delete"
            };
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            var _this2 = this;

            this.$lastLoginLabel = this.find(".loggedInLabel");
            this.$lastLoginTimestamp = this.find('.lastLoginTimestamp');
            this.$userName = this.find('.userName');
            this.$accountSettingsTab = this.find('.accountSettingsTab');
            this.$permissionsTab = this.find('.permissionsTab');
            this.$deleteButton = this.find('.deleteButton');
            this.$deleteButton.click(function () {
                if (!_this2.delDisabled) _this2.trigger('deleteUser');
            });
            this.$spinner = this.find('.spinner');
            this.spinner = new _SpinnerController2.default();
            this.renderInitialState();
        }
    }]);

    return Header;
}(_TemplateView3.default);

exports.default = Header;

/***/ }),
/* 1714 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.WorkAssignmentsEditorPanel = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _utils = __webpack_require__(6);

var _selectors = __webpack_require__(312);

var _redux = __webpack_require__(7);

var _HierarchyAssignmentsEditorPanel = __webpack_require__(882);

var _HierarchyAssignmentsEditorPanel2 = _interopRequireDefault(_HierarchyAssignmentsEditorPanel);

var _WorkAssignmentsEditor = __webpack_require__(1715);

var _WorkAssignmentsEditor2 = _interopRequireDefault(_WorkAssignmentsEditor);

var _constants = __webpack_require__(62);

var _utils2 = __webpack_require__(25);

var _actions = __webpack_require__(50);

var _actions2 = __webpack_require__(561);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var WorkAssignmentsEditorPanel = exports.WorkAssignmentsEditorPanel = function (_HierarchyAssignments) {
    _inherits(WorkAssignmentsEditorPanel, _HierarchyAssignments);

    function WorkAssignmentsEditorPanel(params) {
        _classCallCheck(this, WorkAssignmentsEditorPanel);

        return _possibleConstructorReturn(this, (WorkAssignmentsEditorPanel.__proto__ || Object.getPrototypeOf(WorkAssignmentsEditorPanel)).call(this, _extends({
            hierarchyAssignmentsEditor: new _WorkAssignmentsEditor2.default(),
            extraClass: 'userManagement_workAssignmentsEditorPanel',
            panelType: _constants.PANEL_TYPES.WORK_ASSIGNMENTS_EDITOR,
            onClickContent: function onClickContent(e) {
                return (0, _utils2.setEventPreventHidingWorkAssignmentSlidingPanel)(e);
            }
        }, params)));
    }

    return WorkAssignmentsEditorPanel;
}(_HierarchyAssignmentsEditorPanel2.default);

exports.default = (0, _utils.connect)(function (state) {
    return {
        show: (0, _selectors.showEditor)(state)
    };
}, function (dispatch) {
    return {
        closeEditor: (0, _redux.bindActionCreators)(_actions2.closeEditor, dispatch),
        closeAllPanels: (0, _redux.bindActionCreators)(_actions.closeAllPanels, dispatch)
    };
})(WorkAssignmentsEditorPanel);

/***/ }),
/* 1715 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.WorkAssignmentsEditor = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utils = __webpack_require__(6);

var _redux = __webpack_require__(7);

var _selectors = __webpack_require__(312);

var _actions = __webpack_require__(561);

var _HierarchyAssignmentsEditor = __webpack_require__(884);

var _HierarchyAssignmentsEditor2 = _interopRequireDefault(_HierarchyAssignmentsEditor);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _constants = __webpack_require__(4);

var _selectors2 = __webpack_require__(19);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var WorkAssignmentsEditor = exports.WorkAssignmentsEditor = function (_HierarchyAssignments) {
    _inherits(WorkAssignmentsEditor, _HierarchyAssignments);

    function WorkAssignmentsEditor(params) {
        var _this;

        _classCallCheck(this, WorkAssignmentsEditor);

        return _this = _possibleConstructorReturn(this, (WorkAssignmentsEditor.__proto__ || Object.getPrototypeOf(WorkAssignmentsEditor)).call(this, _extends({
            headerMessageKey: 'userlist.wa_editor.title',
            workAssignmentsVisible: true,
            managementAssignmentsEditable: false,
            showAllExistingFuturesSwitcher: false,
            getAssignAllTextsMap: function getAssignAllTextsMap() {
                return _this._getAssignAllTextsMap();
            },
            getRevokeAllTextsMap: function getRevokeAllTextsMap() {
                return _this._getRevokeAllTextsMap();
            },
            getAssignTextsMap: function getAssignTextsMap() {
                return _this._getAssignTextsMap();
            },
            getRevokeTextsMap: function getRevokeTextsMap() {
                return _this._getRevokeTextsMap();
            }
        }, params)));
    }

    _createClass(WorkAssignmentsEditor, [{
        key: '_getAssignAllTextsMap',
        value: function _getAssignAllTextsMap() {
            var _ref;

            return _ref = {}, _defineProperty(_ref, _constants.HierarchyLevels.CUSTOMER, _messageResource2.default.getMessage('userlist.wa_editor.customers.assign_all')), _defineProperty(_ref, _constants.HierarchyLevels.PROJECT, _messageResource2.default.getMessage('userlist.wa_editor.projects.assign_all')), _defineProperty(_ref, _constants.HierarchyLevels.TASK, _messageResource2.default.getMessage('userlist.wa_editor.tasks.assign_all')), _ref;
        }
    }, {
        key: '_getRevokeAllTextsMap',
        value: function _getRevokeAllTextsMap() {
            var _ref2;

            return _ref2 = {}, _defineProperty(_ref2, _constants.HierarchyLevels.CUSTOMER, _messageResource2.default.getMessage('userlist.wa_editor.customers.unassign_all')), _defineProperty(_ref2, _constants.HierarchyLevels.PROJECT, _messageResource2.default.getMessage('userlist.wa_editor.projects.unassign_all')), _defineProperty(_ref2, _constants.HierarchyLevels.TASK, _messageResource2.default.getMessage('userlist.wa_editor.tasks.unassign_all')), _ref2;
        }
    }, {
        key: '_getAssignTextsMap',
        value: function _getAssignTextsMap() {
            var _ref3;

            return _ref3 = {}, _defineProperty(_ref3, _constants.HierarchyLevels.CUSTOMER, _messageResource2.default.getMessage('userlist.wa_editor.revoke_menu.customer.grant')), _defineProperty(_ref3, _constants.HierarchyLevels.PROJECT, _messageResource2.default.getMessage('userlist.wa_editor.revoke_menu.project.grant')), _defineProperty(_ref3, _constants.HierarchyLevels.TASK, _messageResource2.default.getMessage('userlist.wa_editor.revoke_menu.task.grant')), _ref3;
        }
    }, {
        key: '_getRevokeTextsMap',
        value: function _getRevokeTextsMap() {
            var _ref4;

            return _ref4 = {}, _defineProperty(_ref4, _constants.HierarchyLevels.CUSTOMER, _messageResource2.default.getMessage('userlist.wa_editor.revoke_menu.customer.revoke')), _defineProperty(_ref4, _constants.HierarchyLevels.PROJECT, _messageResource2.default.getMessage('userlist.wa_editor.revoke_menu.project.revoke')), _defineProperty(_ref4, _constants.HierarchyLevels.TASK, _messageResource2.default.getMessage('userlist.wa_editor.revoke_menu.task.revoke')), _ref4;
        }
    }]);

    return WorkAssignmentsEditor;
}(_HierarchyAssignmentsEditor2.default);

exports.default = (0, _utils.connect)(function (state) {
    return {
        viewerCanManageCustomerIds: (0, _selectors.getViewerCanManageCustomerIds)(state),
        viewerCanManageProjectIds: (0, _selectors.getViewerCanManageProjectIds)(state),
        user: (0, _selectors.getEditingUser)(state),
        customers: (0, _selectors.getCustomers)(state),
        projects: (0, _selectors.getProjects)(state),
        tasks: (0, _selectors.getTasks)(state),
        futureCustomersAssigned: (0, _selectors.areFutureCustomersAssigned)(state),
        futureProjectsAssigned: (0, _selectors.areFutureProjectsAssigned)(state),
        futureTasksAssigned: (0, _selectors.areFutureTasksAssigned)(state),
        someCustomersOrLowerAssigned: (0, _selectors.areSomeCustomersOrLowerAssigned)(state),
        someProjectsOrLowerAssigned: (0, _selectors.areSomeProjectsOrLowerAssigned)(state),
        someTasksAssigned: (0, _selectors.areSomeTasksAssigned)(state),
        allCustomersAssigned: (0, _selectors.areAllCustomersAssigned)(state),
        allProjectsAssigned: (0, _selectors.areAllProjectsAssigned)(state),
        allTasksAssigned: (0, _selectors.areAllTasksAssigned)(state),
        canWorkCustomerIds: (0, _selectors.getCanWorkCustomerIds)(state),
        canManageCustomerIds: (0, _selectors.getCanManageCustomerIds)(state),
        canManageCustomerExcludeSelfIds: (0, _selectors.getCanManageCustomerExcludeSelfIds)(state),
        canWorkProjectIds: (0, _selectors.getCanWorkProjectIds)(state),
        canManageProjectIds: (0, _selectors.getCanManageProjectIds)(state),
        canManageProjectExcludeSelfIds: (0, _selectors.getCanManageProjectExcludeSelfIds)(state),
        canWorkTaskIds: (0, _selectors.getCanWorkTaskIds)(state),
        canManageTaskIds: (0, _selectors.getCanManageTaskIds)(state),
        projectCountsByCustomers: (0, _selectors.getProjectCountsByCustomers)(state),
        taskCountsByCustomers: (0, _selectors.getTaskCountsByCustomers)(state),
        taskCountsByProjects: (0, _selectors.getTaskCountsByProjects)(state),
        selectedCustomer: (0, _selectors.getSelectedCustomer)(state),
        selectedProject: (0, _selectors.getSelectedProject)(state),
        loading: (0, _selectors.isLoading)(state),
        changingCustomerAssignments: (0, _selectors.getChangingCustomerAssignments)(state),
        changingProjectAssignments: (0, _selectors.getChangingProjectAssignments)(state),
        changingTaskAssignments: (0, _selectors.getChangingTaskAssignments)(state),
        customersSearchOpen: (0, _selectors.getCustomersSearchOpen)(state),
        customersSearchText: (0, _selectors.getCustomersSearchText)(state),
        projectsSearchOpen: (0, _selectors.getProjectsSearchOpen)(state),
        projectsSearchText: (0, _selectors.getProjectsSearchText)(state),
        tasksSearchOpen: (0, _selectors.getTasksSearchOpen)(state),
        tasksSearchText: (0, _selectors.getTasksSearchText)(state),
        changingAllAssignments: (0, _selectors.isChangingAllAssignments)(state),
        canManageParentCustomer: (0, _selectors.canManageParentCustomer)(state),
        canManageParentProject: (0, _selectors.canManageParentProject)(state),
        viewerHasAccessAllManagementScope: (0, _selectors2.hasAccessAllManagementScope)(state)
    };
}, function (dispatch) {
    return (0, _redux.bindActionCreators)({
        changeCustomerAssignment: _actions.changeCustomerAssignment,
        changeProjectAssignment: _actions.changeProjectAssignment,
        changeTaskAssignment: _actions.changeTaskAssignment,
        changeAllCustomersAssignments: _actions.changeAllCustomersAssignments,
        changeAllProjectsAssignments: _actions.changeAllProjectsAssignments,
        changeAllTasksAssignments: _actions.changeAllTasksAssignments,
        deselectCustomer: _actions.deselectCustomer,
        deselectProject: _actions.deselectProject,
        selectCustomer: _actions.selectCustomer,
        selectProject: _actions.selectProject,
        loadMoreEntities: _actions.loadMoreEntities,
        changeCustomersSearchText: _actions.changeCustomersSearchText,
        clearCustomersSearchText: _actions.clearCustomersSearchText,
        changeProjectsSearchText: _actions.changeProjectsSearchText,
        clearProjectsSearchText: _actions.clearProjectsSearchText,
        changeTasksSearchText: _actions.changeTasksSearchText,
        clearTasksSearchText: _actions.clearTasksSearchText,
        closeEditor: _actions.closeEditor
    }, dispatch);
})(WorkAssignmentsEditor);

/***/ }),
/* 1716 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.rpcErrorHandler = rpcErrorHandler;

var _constants = __webpack_require__(108);

var _constants2 = __webpack_require__(259);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function rpcErrorHandler(rpcError) {
    rpcError.handleOnExceptions([].concat(_toConsumableArray(Object.values(_constants2.Exceptions)), [_constants.Exceptions.NO_RIGHTS_TO_SUBMIT_TT_EXCEPTION, _constants.Exceptions.WORK_ASSIGNMENTS_FEATURE_DISABLED_EXCEPTION]));
}

/***/ }),
/* 1717 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.rpcErrorHandler = rpcErrorHandler;

var _constants = __webpack_require__(259);

var _constants2 = __webpack_require__(108);

function rpcErrorHandler(rpcError) {
    rpcError.handleOnException(_constants.Exceptions.NoSuchUserException, _constants.Exceptions.UserHasAccessToAllScopeException, _constants2.Exceptions.WORK_ASSIGNMENTS_FEATURE_DISABLED_EXCEPTION, _constants2.Exceptions.NO_RIGHTS_TO_SUBMIT_TT_EXCEPTION);
}

/***/ }),
/* 1718 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ManagementButtonsContainer = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _utils = __webpack_require__(6);

var _selectors = __webpack_require__(15);

var _constants = __webpack_require__(4);

var _selectors2 = __webpack_require__(53);

var _ManageGroupsList = __webpack_require__(896);

var _ManageGroupsList2 = _interopRequireDefault(_ManageGroupsList);

var _ManageGroupsButton = __webpack_require__(898);

var _ManageGroupsButton2 = _interopRequireDefault(_ManageGroupsButton);

var _AnimatedDialogWrapper = __webpack_require__(286);

var _AnimatedDialogWrapper2 = _interopRequireDefault(_AnimatedDialogWrapper);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _Button = __webpack_require__(33);

var _Button2 = _interopRequireDefault(_Button);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _BulkInvitationsDropdown = __webpack_require__(1719);

var _BulkInvitationsDropdown2 = _interopRequireDefault(_BulkInvitationsDropdown);

var _ClassicBridge = __webpack_require__(18);

var _ClassicBridge2 = _interopRequireDefault(_ClassicBridge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ManagementButtonsContainer = exports.ManagementButtonsContainer = function (_TemplateView) {
    _inherits(ManagementButtonsContainer, _TemplateView);

    function ManagementButtonsContainer(_ref) {
        var _ref$onManageUserDepa = _ref.onManageUserDepartmentsClick,
            onManageUserDepartmentsClick = _ref$onManageUserDepa === undefined ? function () {} : _ref$onManageUserDepa,
            _ref$onManageTimeZone = _ref.onManageTimeZoneGroupsClick,
            onManageTimeZoneGroupsClick = _ref$onManageTimeZone === undefined ? function () {} : _ref$onManageTimeZone,
            _ref$onAddNewUserClic = _ref.onAddNewUserClick,
            onAddNewUserClick = _ref$onAddNewUserClic === undefined ? function () {} : _ref$onAddNewUserClic,
            _ref$onManualInvitati = _ref.onManualInvitationsClick,
            onManualInvitationsClick = _ref$onManualInvitati === undefined ? function () {} : _ref$onManualInvitati,
            _ref$onImportUsersFin = _ref.onImportUsersFinished,
            onImportUsersFinished = _ref$onImportUsersFin === undefined ? function (importedUsersData) {} : _ref$onImportUsersFin;

        _classCallCheck(this, ManagementButtonsContainer);

        var _this = _possibleConstructorReturn(this, (ManagementButtonsContainer.__proto__ || Object.getPrototypeOf(ManagementButtonsContainer)).call(this, null));

        _this._openCsvUserImportModal = function () {
            _this.setState({ isCsvUserImportModalShown: true });
        };

        _this._closeCsvUserImportModal = function (importedUsersData) {
            _this.callbacks.onImportUsersFinished(importedUsersData);
            _this.setState({ isCsvUserImportModalShown: false });
        };

        _this._handleManageGroupsButtonClick = function () {
            if (_this.state.isUGREnabled && _this.state.isTZGEnabled) {
                _this.manageGroupsDialog.showAt(_this.manageGroupsButton.getEl(), {
                    my: 'left top',
                    at: 'left bottom'
                });
            } else if (_this.state.isUGREnabled) {
                _this.callbacks.onManageUserDepartmentsClick();
            } else if (_this.state.isTZGEnabled) {
                _this.callbacks.onManageTimeZoneGroupsClick();
            }
        };

        _this.state = {
            isUGREnabled: false,
            isTZGEnabled: false,
            isPossibleToCreateUsers: false,
            licenseViolated: false,
            isCsvUserImportModalShown: false
        };

        _this.callbacks = {
            onManageUserDepartmentsClick: onManageUserDepartmentsClick,
            onManageTimeZoneGroupsClick: onManageTimeZoneGroupsClick,
            onAddNewUserClick: onAddNewUserClick,
            onManualInvitationsClick: onManualInvitationsClick,
            onImportUsersFinished: onImportUsersFinished
        };

        _this.onStatePropertyChanged('isCsvUserImportModalShown', function () {
            _this._setModalProperties({
                isShown: _this.state.isCsvUserImportModalShown,
                onClose: _this._closeCsvUserImportModal
            });
        });

        _this.onAnyStatePropertyChanged(['isUGREnabled', 'isTZGEnabled'], function () {
            _this.manageGroupsButton.setState({
                isUGREnabled: _this.state.isUGREnabled,
                isTZGEnabled: _this.state.isTZGEnabled
            });

            _this.manageGroupsButton.toggle(_this.state.isUGREnabled || _this.state.isTZGEnabled);
        });

        _this.onStatePropertyChanged('isPossibleToCreateUsers', function () {
            _this.addNewUserButton.setState({
                disabled: !_this.state.isPossibleToCreateUsers
            });

            if (_this.inviteUsersButton) {
                _this.inviteUsersButton.setState({
                    disabled: !_this.state.isPossibleToCreateUsers
                });
            }
        });

        _this.onStatePropertyChanged('licenseViolated', function () {
            _this.manageGroupsButton.setState({ disabled: _this.state.licenseViolated });
        });

        _this._handleManageGroupsButtonClick = _this._handleManageGroupsButtonClick.bind(_this);
        return _this;
    }

    _createClass(ManagementButtonsContainer, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class="userList_container_managementButtonsContainer">' + '  <div class="importUsersMount"></div>' + '  <div class="manageGroups"></div>' + '</div>';
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            var _this2 = this;

            var _ClassicBridge$integr = _ClassicBridge2.default.integrateCsvUserImportModal(this.find('.importUsersMount')[0]),
                setProps = _ClassicBridge$integr.setProps;

            this._setModalProperties = setProps;

            this.manageGroupsButton = new _ManageGroupsButton2.default({
                onButtonClick: this._handleManageGroupsButtonClick
            }).init(this.$el);
            this.manageGroupsButton.hide();

            this.manageGroupsDialog = new _AnimatedDialogWrapper2.default(null, {
                className: 'userList_manageButtons_component_manageGroupsList',
                toggleMode: true, // TODO not working :(
                dialog: new _ManageGroupsList2.default({
                    departmentsOnClick: function departmentsOnClick() {
                        _this2.manageGroupsDialog.hide();
                        _this2.callbacks.onManageUserDepartmentsClick();
                    },
                    timeZoneOnClick: function timeZoneOnClick() {
                        _this2.manageGroupsDialog.hide();
                        _this2.callbacks.onManageTimeZoneGroupsClick();
                    }
                }),
                autoPosition: true
            }).init((0, _jquery2.default)('body'));

            this.addNewUserButton = new _Button2.default({
                label: _messageResource2.default.getMessage('userlist.add_new_user'),
                withPlusIcon: true,
                onClickCb: this.callbacks.onAddNewUserClick
            }).init(this.$el);

            if (_constants.isOlVersion || _constants.isDemoVersion) {
                var inviteUsersDropdown = new _AnimatedDialogWrapper2.default(null, {
                    className: 'userList_invitationButtonsDropdown',
                    toggleMode: true,
                    dialog: new _BulkInvitationsDropdown2.default({
                        manualInvitationsClick: function manualInvitationsClick() {
                            inviteUsersDropdown.hide();
                            _this2.callbacks.onManualInvitationsClick();
                        },
                        csvImportClick: function csvImportClick() {
                            inviteUsersDropdown.hide();
                            _this2._openCsvUserImportModal();
                        }
                    }),
                    autoPosition: true
                }).init((0, _jquery2.default)('body'));

                this.inviteUsersButton = new _Button2.default({
                    label: _messageResource2.default.getMessage('userlist.bulk_invitations'),
                    additionalClass: 'addSeveralUsersButton dropdown',
                    onClickCb: function onClickCb() {
                        inviteUsersDropdown.showAt(_this2.inviteUsersButton.getEl(), {
                            my: 'right top',
                            at: 'right bottom'
                        });
                    }
                }).init(this.$el);
            } else {
                this.inviteUsersButton = new _Button2.default({
                    label: _messageResource2.default.getMessage('userlist.csv_import'),
                    additionalClass: 'addSeveralUsersButton',
                    onClickCb: this._openCsvUserImportModal
                }).init(this.$el);
            }
        }
    }]);

    return ManagementButtonsContainer;
}(_TemplateView3.default);

exports.default = (0, _utils.connect)(function (state) {
    return {
        isUGREnabled: (0, _selectors.isUGREnabled)(state),
        isTZGEnabled: (0, _selectors.isTZGEnabled)(state),
        isPossibleToCreateUsers: (0, _selectors2.isPossibleToCreateUsers)(state),
        licenseViolated: (0, _selectors2.licenseViolated)(state)
    };
})(ManagementButtonsContainer);

/***/ }),
/* 1719 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _BulkInvitationsItem = __webpack_require__(1720);

var _BulkInvitationsItem2 = _interopRequireDefault(_BulkInvitationsItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BulkInvitationsDropdown = function (_TemplateView) {
    _inherits(BulkInvitationsDropdown, _TemplateView);

    function BulkInvitationsDropdown(_ref) {
        var _ref$manualInvitation = _ref.manualInvitationsClick,
            manualInvitationsClick = _ref$manualInvitation === undefined ? function () {} : _ref$manualInvitation,
            _ref$csvImportClick = _ref.csvImportClick,
            csvImportClick = _ref$csvImportClick === undefined ? function () {} : _ref$csvImportClick;

        _classCallCheck(this, BulkInvitationsDropdown);

        var _this = _possibleConstructorReturn(this, (BulkInvitationsDropdown.__proto__ || Object.getPrototypeOf(BulkInvitationsDropdown)).call(this));

        _this.manualInvitationsClick = manualInvitationsClick;
        _this.csvImportClick = csvImportClick;
        return _this;
    }

    _createClass(BulkInvitationsDropdown, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return "<div></div>";
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            new _BulkInvitationsItem2.default({
                type: _BulkInvitationsItem.Type.MANUAL,
                additionalClass: 'option',
                onClick: this.manualInvitationsClick
            }).init(this.$el);

            new _BulkInvitationsItem2.default({
                type: _BulkInvitationsItem.Type.CSV_IMPORT,
                additionalClass: 'option',
                onClick: this.csvImportClick
            }).init(this.$el);
        }
    }]);

    return BulkInvitationsDropdown;
}(_TemplateView3.default);

exports.default = BulkInvitationsDropdown;

/***/ }),
/* 1720 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Type = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Type = exports.Type = {
    MANUAL: 'manual',
    CSV_IMPORT: 'csvImport'
};

var BulkInvitationsItem = function (_TemplateView) {
    _inherits(BulkInvitationsItem, _TemplateView);

    function BulkInvitationsItem(_ref) {
        var _ref$type = _ref.type,
            type = _ref$type === undefined ? '' : _ref$type,
            _ref$additionalClass = _ref.additionalClass,
            additionalClass = _ref$additionalClass === undefined ? '' : _ref$additionalClass,
            _ref$onClick = _ref.onClick,
            onClick = _ref$onClick === undefined ? function (type) {} : _ref$onClick;

        _classCallCheck(this, BulkInvitationsItem);

        var _this = _possibleConstructorReturn(this, (BulkInvitationsItem.__proto__ || Object.getPrototypeOf(BulkInvitationsItem)).call(this, null));

        _this.type = type;
        _this.additionalClass = additionalClass;
        _this.onClick = onClick;

        _this.text = '';
        switch (type) {
            case Type.MANUAL:
                _this.text = _messageResource2.default.getMessage('userlist.manual_invitation');
                break;
            case Type.CSV_IMPORT:
                _this.text = _messageResource2.default.getMessage('userlist.csv_import');
                break;
        }
        return _this;
    }

    _createClass(BulkInvitationsItem, [{
        key: 'afterRender',
        value: function afterRender() {
            var _this2 = this;

            this.$el.on('click', function () {
                _this2.onClick(_this2.type);
            });
        }
    }, {
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class="userList_invitationButtonsDropdown_item <%=type%> <%=additionalClass%>">' + '  <%-text%>' + '</div>';
        }
    }]);

    return BulkInvitationsItem;
}(_TemplateView3.default);

exports.default = BulkInvitationsItem;

/***/ }),
/* 1721 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.WorkAssignmentsTabContainer = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _selectors = __webpack_require__(14);

var _selectors2 = __webpack_require__(316);

var _actions = __webpack_require__(167);

var _utils = __webpack_require__(6);

var _redux = __webpack_require__(7);

var _selectors3 = __webpack_require__(53);

var _TableHead = __webpack_require__(1722);

var _TableHead2 = _interopRequireDefault(_TableHead);

var _TableBody = __webpack_require__(1725);

var _TableBody2 = _interopRequireDefault(_TableBody);

var _Pager = __webpack_require__(1729);

var _Pager2 = _interopRequireDefault(_Pager);

var _ItemsFilter = __webpack_require__(858);

var _ItemsFilter2 = _interopRequireDefault(_ItemsFilter);

var _constants = __webpack_require__(4);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _actions2 = __webpack_require__(126);

var _selectors4 = __webpack_require__(15);

var _actions3 = __webpack_require__(211);

var _ViewerManagementCounters = __webpack_require__(1730);

var _ViewerManagementCounters2 = _interopRequireDefault(_ViewerManagementCounters);

var _atUtils = __webpack_require__(5);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _LoadingMoire = __webpack_require__(92);

var _LoadingMoire2 = _interopRequireDefault(_LoadingMoire);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var WorkAssignmentsFilterValues = _constants.UserManagementConstants.WorkAssignmentsFilter;

var WorkAssignmentsTabContainer = exports.WorkAssignmentsTabContainer = function (_TemplateView) {
    _inherits(WorkAssignmentsTabContainer, _TemplateView);

    function WorkAssignmentsTabContainer(_ref) {
        var _ref$loadUsersDataAct = _ref.loadUsersDataAction,
            loadUsersDataAction = _ref$loadUsersDataAct === undefined ? function () {} : _ref$loadUsersDataAct,
            _ref$changeCurrentPag = _ref.changeCurrentPageNum,
            changeCurrentPageNum = _ref$changeCurrentPag === undefined ? function () {} : _ref$changeCurrentPag,
            _ref$changeUsersPerPa = _ref.changeUsersPerPage,
            changeUsersPerPage = _ref$changeUsersPerPa === undefined ? function () {} : _ref$changeUsersPerPa,
            _ref$changeWorkAssign = _ref.changeWorkAssignmentsFilter,
            changeWorkAssignmentsFilter = _ref$changeWorkAssign === undefined ? function () {} : _ref$changeWorkAssign,
            _ref$openEditUserPane = _ref.openEditUserPanel,
            openEditUserPanel = _ref$openEditUserPane === undefined ? function () {} : _ref$openEditUserPane,
            _ref$openWorkAssignme = _ref.openWorkAssignmentPanel,
            openWorkAssignmentPanel = _ref$openWorkAssignme === undefined ? function () {} : _ref$openWorkAssignme;

        _classCallCheck(this, WorkAssignmentsTabContainer);

        var _this = _possibleConstructorReturn(this, (WorkAssignmentsTabContainer.__proto__ || Object.getPrototypeOf(WorkAssignmentsTabContainer)).call(this, null));

        _this._handleOnChangeWorkAssignmentsFilter = function (value) {
            _this.actions.changeWorkAssignmentsFilter(value);
        };

        _this._handleOnWorkAssignmentsCellClick = function (id, level) {
            _this.actions.openWorkAssignmentPanel(id, level);
        };

        _this._handleOnNameCellClick = function (id) {
            _this.actions.openEditUserPanel(id);
        };

        _this._createWorkAssignmentsFilterItems = function () {
            return [(0, _ItemsFilter.createItemObject)(WorkAssignmentsFilterValues.ALL, _messageResource2.default.getMessage('userlist.work_assignments.filter.all')), (0, _ItemsFilter.createDelimiterObject)(), (0, _ItemsFilter.createItemObject)(WorkAssignmentsFilterValues.NO_TASK, _messageResource2.default.getMessage('userlist.work_assignments.filter.no_assignments')), (0, _ItemsFilter.createDelimiterObject)(), (0, _ItemsFilter.createItemObject)(WorkAssignmentsFilterValues.ALL_SCOPE, _messageResource2.default.getMessage('userlist.work_assignments.filter.all_scope'))];
        };

        _this.state = {
            needToReload: false,
            loading: false,
            users: [],
            userGroups: {},
            timeZoneGroups: {},
            usersWithoutApprovers: [],
            nUsersPerPage: 0,
            nTotalUsers: 0,
            currentPageNum: 1,
            wordsFilter: '',
            warningMsgsByUserId: {},
            workAssignmentsFilter: null,
            editingUserId: null,
            newUsersIdSet: {},
            userGroupsEnabled: false,
            timeZoneGroupsEnabled: false,
            viewerManagementCounters: {},
            usersWorkAssignmentsCounters: {},
            assignedUserIds: null,
            allowedToManageAccountSettings: false,
            isBTYEnabled: false,
            isURAEnabled: false
        };

        _this.actions = {
            loadUsersDataAction: loadUsersDataAction,
            changeCurrentPageNum: changeCurrentPageNum,
            changeUsersPerPage: changeUsersPerPage,
            changeWorkAssignmentsFilter: changeWorkAssignmentsFilter,
            openEditUserPanel: openEditUserPanel,
            openWorkAssignmentPanel: openWorkAssignmentPanel
        };

        _this.onStatePropertyChanged('needToReload', function (needToReload, prevNeedToReload) {
            if (prevNeedToReload !== needToReload && needToReload === true) {
                _this.actions.loadUsersDataAction();
            }
        });

        _this.onAnyStatePropertyChanged(['nUsersPerPage', 'nTotalUsers', 'currentPageNum'], function () {
            _this.pager.setState({
                totalNumberOfUsers: _this.state.nTotalUsers,
                pageNum: _this.state.currentPageNum,
                usersPerPage: _this.state.nUsersPerPage
            });
        });

        _this.onStateChanged(function () {
            _this.tableBody.setState({
                users: _this.state.users,
                userGroups: _this.state.userGroups,
                timeZoneGroups: _this.state.timeZoneGroups,
                usersWithoutApproversSet: (0, _atUtils.arrayToSet)(_this.state.usersWithoutApprovers),
                wordsFilter: _this.state.wordsFilter,
                warningMsgsByUserId: _this.state.warningMsgsByUserId,
                editingUserId: _this.state.editingUserId,
                newUsersIdSet: _this.state.newUsersIdSet,
                userGroupsEnabled: _this.state.userGroupsEnabled,
                timeZoneGroupsEnabled: _this.state.timeZoneGroupsEnabled,
                viewerManagementCounters: _this.state.viewerManagementCounters,
                usersWorkAssignmentsCounters: _this.state.usersWorkAssignmentsCounters,
                allowedToManageAccountSettings: _this.state.allowedToManageAccountSettings,
                isURAEnabled: _this.state.isURAEnabled,
                isBTYEnabled: _this.state.isBTYEnabled
            });
        });

        _this.onStatePropertyChanged('workAssignmentsFilter', function () {
            _this.workAssignmentsFilter.setState({
                selectedValue: _this.state.workAssignmentsFilter
            });
        });

        _this.onStatePropertyChanged('viewerManagementCounters', function () {
            _this.vieweManagementCounters.setState(_extends({}, _this.state.viewerManagementCounters));
        });

        _this.onStatePropertyChanged('assignedUserIds', function () {
            _this.tableHead.setState({
                assignedUserIds: _this.state.assignedUserIds
            });
        });

        _this.onStatePropertyChanged('allowedToManageAccountSettings', function () {
            // for support old styles from (userList.less)
            _this.$table.toggleClass('canEditUsers', _this.state.allowedToManageAccountSettings);
        });

        _this.onAnyStatePropertyChanged(['wordsFilter', 'users', 'loading'], function (_ref2) {
            var wordsFilter = _ref2.wordsFilter,
                users = _ref2.users,
                loading = _ref2.loading;

            var noUsers = users.length === 0;
            var filterEmpty = _underscore2.default.isEmpty(wordsFilter);
            _this.loadingMoire.toggle(loading);
            _this.$noFoundUserMessage.toggle(noUsers && !loading);
            if (noUsers && !loading) {
                _this.$noFoundUserMessage.text(!filterEmpty ? _messageResource2.default.getMessage('userlist.js.users_table_no_users_found') : _messageResource2.default.getMessage('userlist.js.users_table_no_users'));
            }
        });
        return _this;
    }

    _createClass(WorkAssignmentsTabContainer, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div>' + '  <table class="userListTable userList_workAssignmentsTable"></table>' + '  <div class="noFoundUsersMessage"></div>' + '  <div class="workAssignmentsTab_loadingMoirePlaceholder"></div>' + '  <div class="pager"></div>' + '</div>';
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            this.$table = this.find('.userListTable');

            this.$noFoundUserMessage = this.find('.noFoundUsersMessage');

            this.workAssignmentsFilter = new _ItemsFilter2.default({
                items: this._createWorkAssignmentsFilterItems(),
                defaultValue: WorkAssignmentsFilterValues.ALL,
                onChange: this._handleOnChangeWorkAssignmentsFilter,
                additionalFilterClass: 'greyBackground'
            });

            this.vieweManagementCounters = new _ViewerManagementCounters2.default();

            this.tableHead = new _TableHead2.default({
                workAssignmentsFilter: this.workAssignmentsFilter,
                viewerManagementCountersComponent: this.vieweManagementCounters
            }).init(this.$table);
            this.tableBody = new _TableBody2.default({
                onNameCellClick: this._handleOnNameCellClick,
                onWorkAssignmentsCellClick: this._handleOnWorkAssignmentsCellClick
            }).init(this.$table);

            this.loadingMoire = new _LoadingMoire2.default({
                additionalSpinnerSettings: {
                    radius: 17,
                    length: 13,
                    width: 4
                }
            }).init(this.find('.workAssignmentsTab_loadingMoirePlaceholder'));

            this.pager = new _Pager2.default({
                onChangeUserPerPage: this.actions.changeUsersPerPage,
                onChangePageNum: this.actions.changeCurrentPageNum
            }).init(this.find('.pager'));
        }
    }]);

    return WorkAssignmentsTabContainer;
}(_TemplateView3.default);

exports.default = (0, _utils.connect)(function (state) {
    return {
        users: (0, _selectors2.getUsersList)(state),
        userGroups: (0, _selectors.getUserGroupsWithDefault)(state),
        timeZoneGroups: (0, _selectors.getTimeZoneGroups)(state),
        usersWithoutApprovers: (0, _selectors3.getUsersWithoutApprovers)(state),
        needToReload: (0, _selectors2.isNeedToReloadData)(state),
        currentPageNum: (0, _selectors2.getCurrentPageNum)(state),
        nUsersPerPage: (0, _selectors2.getNUsersPerPage)(state),
        nTotalUsers: (0, _selectors2.getNTotalUsers)(state),
        wordsFilter: (0, _selectors2.getSubmittedWordsFilter)(state),
        warningMsgsByUserId: (0, _selectors2.getWarningMsgsByUserId)(state),
        workAssignmentsFilter: (0, _selectors2.getWorkAssignmentsFilter)(state),
        editingUserId: (0, _selectors3.getEditingUserId)(state),
        newUsersIdSet: (0, _selectors3.getNewUsersIdSet)(state),
        userGroupsEnabled: (0, _selectors4.isUGREnabled)(state),
        timeZoneGroupsEnabled: (0, _selectors4.isTZGEnabled)(state),
        viewerManagementCounters: (0, _selectors3.getViewerManagementCounters)(state),
        usersWorkAssignmentsCounters: (0, _selectors2.getUsersWorkAssignmentsCounters)(state),
        assignedUserIds: (0, _selectors3.getActiveAssignedUserIds)(state),
        allowedToManageAccountSettings: (0, _selectors3.isAllowedToManageAccountSettings)(state),
        loading: (0, _selectors2.isLoading)(state),
        isURAEnabled: (0, _selectors4.isURAEnabled)(state),
        isBTYEnabled: (0, _selectors4.isBTYEnabled)(state)
    };
}, function (dispatch) {
    return {
        loadUsersDataAction: (0, _redux.bindActionCreators)(_actions.loadUsersDataAction, dispatch),
        changeCurrentPageNum: (0, _redux.bindActionCreators)(_actions.changeCurrentPageNum, dispatch),
        changeUsersPerPage: (0, _redux.bindActionCreators)(_actions.changeUsersPerPage, dispatch),
        changeWorkAssignmentsFilter: (0, _redux.bindActionCreators)(_actions.changeWorkAssignmentsFilter, dispatch),
        openEditUserPanel: (0, _redux.bindActionCreators)(_actions2.openEditUserPanel, dispatch),
        openWorkAssignmentPanel: (0, _redux.bindActionCreators)(_actions3.openWorkAssignmentPanel, dispatch)
    };
})(WorkAssignmentsTabContainer);

/***/ }),
/* 1722 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _TableControlsContainer = __webpack_require__(1723);

var _TableControlsContainer2 = _interopRequireDefault(_TableControlsContainer);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _pluralizeUtils = __webpack_require__(40);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TableHead = function (_TemplateView) {
    _inherits(TableHead, _TemplateView);

    function TableHead(_ref) {
        var _ref$workAssignmentsF = _ref.workAssignmentsFilter,
            workAssignmentsFilter = _ref$workAssignmentsF === undefined ? null : _ref$workAssignmentsF,
            _ref$viewerManagement = _ref.viewerManagementCountersComponent,
            viewerManagementCountersComponent = _ref$viewerManagement === undefined ? null : _ref$viewerManagement;

        _classCallCheck(this, TableHead);

        var _this = _possibleConstructorReturn(this, (TableHead.__proto__ || Object.getPrototypeOf(TableHead)).call(this, null));

        _this.workAssignmentsFilter = workAssignmentsFilter;
        _this.viewerManagementCountersComponent = viewerManagementCountersComponent;

        _this.state = {
            assignedUserIds: null
        };

        _this.onStateChanged(function () {
            var allAssigned = _this.state.assignedUserIds === null;

            var val = allAssigned ? _messageResource2.default.getMessage('common.all') : _this.state.assignedUserIds.length;
            var text = allAssigned ? (0, _pluralizeUtils.userNameCapitalizedPlural)() : (0, _pluralizeUtils.userNameCapitalized)(_this.state.assignedUserIds.length);
            _this.$teamDetails.text('(' + val + ' ' + text + ')');
        });
        return _this;
    }

    _createClass(TableHead, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<thead class="tableHead">' + '  <tr class="userListHead firstHeader">' + '    <th class="userName firstLayer">' + '     <div class="cellName"><%=myTeam%></div>' + '     <span class="details teamDetails"></span>' + '    </th>' + '    <th class="spacer firstLayer"></th>' + '    <th class="workAssignmentsHeader firstLayer">' + '       <%=myScope%><span class="details">(<%=myScopeDetails%>)</span>' + '       <div class="workAssignmentsFilter"></div>' + '    </th>' + '    </tr>' + '    <tr class="userListHead secondHeader">' + '      <th class="controlsPlaceholder userName secondLayer"></th>' + '      <th class="spacer secondLayer"></th>' + '      <th class="workAssignmentsHeader secondLayer"></th>' + '    </tr>' + '</thead>';
        }
    }, {
        key: 'messageKeys',
        value: function messageKeys() {
            return {
                myScope: 'userlist.work_assignments.table.my_scope',
                myScopeDetails: 'userlist.work_assignments.table.i_can_assign',
                myTeam: 'userlist.work_assignments.table.my_team'
            };
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            this.$teamDetails = this.find('.details.teamDetails');
            new _TableControlsContainer2.default().init(this.find('.controlsPlaceholder'));
            this.workAssignmentsFilter.init(this.find('.workAssignmentsFilter'));
            this.viewerManagementCountersComponent.init(this.find('.workAssignmentsHeader.secondLayer'));

            this.renderInitialState();
        }
    }]);

    return TableHead;
}(_TemplateView3.default);

exports.default = TableHead;

/***/ }),
/* 1723 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TableControlsContainer = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _View2 = __webpack_require__(20);

var _View3 = _interopRequireDefault(_View2);

var _utils = __webpack_require__(6);

var _redux = __webpack_require__(7);

var _TableControls = __webpack_require__(899);

var _TableControls2 = _interopRequireDefault(_TableControls);

var _selectors = __webpack_require__(316);

var _actions = __webpack_require__(167);

var _constants = __webpack_require__(4);

var _selectors2 = __webpack_require__(15);

var _WordsFilter = __webpack_require__(400);

var _WordsFilter2 = _interopRequireDefault(_WordsFilter);

var _UsersFilter = __webpack_require__(562);

var _UsersFilter2 = _interopRequireDefault(_UsersFilter);

var _selectors3 = __webpack_require__(53);

var _User = __webpack_require__(119);

var _User2 = _interopRequireDefault(_User);

var _groupUtils = __webpack_require__(71);

var _utils2 = __webpack_require__(200);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TableControlsContainer = exports.TableControlsContainer = function (_View) {
    _inherits(TableControlsContainer, _View);

    function TableControlsContainer(_ref) {
        var _ref$changeSorting = _ref.changeSorting,
            changeSorting = _ref$changeSorting === undefined ? function () {} : _ref$changeSorting,
            _ref$changeUsersFilte = _ref.changeUsersFilter,
            changeUsersFilter = _ref$changeUsersFilte === undefined ? function () {} : _ref$changeUsersFilte,
            _ref$changeWordsFilte = _ref.changeWordsFilter,
            changeWordsFilter = _ref$changeWordsFilte === undefined ? function () {} : _ref$changeWordsFilte;

        _classCallCheck(this, TableControlsContainer);

        var _this = _possibleConstructorReturn(this, (TableControlsContainer.__proto__ || Object.getPrototypeOf(TableControlsContainer)).call(this, null));

        _this._handleSortingClick = function (order) {
            var orderChanged = order !== _this.state.sorting.order;
            _this.params.changeSorting({
                order: order,
                asc: orderChanged ? true : !_this.state.sorting.asc
            });
        };

        _this._handleUserSortClick = function () {
            _this._handleSortingClick(_constants.UserManagementConstants.USER_LIST_ORDER_BY_NAME);
        };

        _this._handleUserGroupSortClick = function () {
            _this._handleSortingClick(_constants.UserManagementConstants.USER_LIST_ORDER_BY_GROUP_NAME);
        };

        _this._handleTimeZoneGroupSortClick = function () {
            _this._handleSortingClick(_constants.UserManagementConstants.USER_LIST_ORDER_BY_TIME_ZONE_GROUP_NAME);
        };

        _this.state = {
            sorting: {
                order: -1,
                asc: false
            },
            usersFilter: {
                userIds: [],
                groupIds: [],
                groupType: null,
                allSelected: true
            },
            wordsFilter: '',
            ugrEnabled: false,
            tzgEnabled: false,
            userGroupsList: null,
            timeZoneGroupsList: null,
            availableUsers: []
        };

        _this.params = {
            changeSorting: changeSorting,
            changeUsersFilter: changeUsersFilter,
            changeWordsFilter: changeWordsFilter
        };

        _this.onStatePropertyChanged('sorting', function () {
            _this.tableControls.setState({
                sorting: _this.state.sorting
            });
        });

        _this.onAnyStatePropertyChanged(['ugrEnabled', 'tzgEnabled'], function () {
            _this.tableControls.setState({
                showUserGroups: _this.state.ugrEnabled,
                showTimeZoneGroups: _this.state.tzgEnabled
            });
        });

        _this.onStatePropertyChanged('wordsFilter', function () {
            _this.wordsFilter.setState({
                text: _this.state.wordsFilter
            });
        });

        _this.onStateChanged(function () {
            _this.usersFilter.setState({
                allSelected: _this.state.usersFilter.allSelected,
                groupType: _this.state.usersFilter.groupType,
                groupIds: _this.state.usersFilter.groupIds,
                userIds: _this.state.usersFilter.userIds,
                userGroups: _this.state.ugrEnabled ? (0, _groupUtils.transformListToGroups)(_this.state.userGroupsList) : null,
                timeZoneGroups: _this.state.tzgEnabled ? (0, _groupUtils.transformListToGroups)(_this.state.timeZoneGroupsList) : null,
                users: _this.state.availableUsers.map(function (user) {
                    return new _User2.default(user["id"], user["firstName"], user["lastName"], user["middleInitial"], user["username"], user["activeInAT"] || user["enabled"], false, user["userGroupId"], user["timeZoneGroupId"]);
                })
            });
        });
        return _this;
    }

    _createClass(TableControlsContainer, [{
        key: "afterRender",
        value: function afterRender() {
            this.usersFilter = new _UsersFilter2.default({
                onChange: this.params.changeUsersFilter,
                createSelectionDescription: _utils2.getUserSelectionDescription,
                showInactiveCheckbox: false
            });
            this.wordsFilter = new _WordsFilter2.default({ onChange: this.params.changeWordsFilter });
            this.tableControls = new _TableControls2.default({
                usersFilterComponent: this.usersFilter,
                wordsFilterComponent: this.wordsFilter,
                onUserSortClick: this._handleUserSortClick,
                onUserGroupSortClick: this._handleUserGroupSortClick,
                onTimeZoneSortClick: this._handleTimeZoneGroupSortClick
            }).init(this.$containerEl);
        }
    }]);

    return TableControlsContainer;
}(_View3.default);

exports.default = (0, _utils.connect)(function (state) {
    return {
        sorting: (0, _selectors.getSorting)(state),
        ugrEnabled: (0, _selectors2.isUGREnabled)(state),
        tzgEnabled: (0, _selectors2.isTZGEnabled)(state),
        userGroupsList: (0, _selectors.getSortedUserGroupsList)(state),
        timeZoneGroupsList: (0, _selectors.getSortedTimeZoneGroupsList)(state),
        wordsFilter: (0, _selectors.getWordsFilter)(state),
        usersFilter: (0, _selectors.getUsersFilter)(state),
        availableUsers: (0, _selectors3.getUsersListForWorkAssignmentsTab)(state)
    };
}, function (dispatch) {
    return {
        changeSorting: (0, _redux.bindActionCreators)(_actions.changeSorting, dispatch),
        changeUsersFilter: (0, _redux.bindActionCreators)(_actions.changeUsersFilter, dispatch),
        changeWordsFilter: (0, _redux.bindActionCreators)(_actions.changeWordsFilter, dispatch)
    };
})(TableControlsContainer);

/***/ }),
/* 1724 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SortLink = function (_TemplateView) {
    _inherits(SortLink, _TemplateView);

    function SortLink(_ref) {
        var _ref$title = _ref.title,
            title = _ref$title === undefined ? '' : _ref$title,
            _ref$clazz = _ref.clazz,
            clazz = _ref$clazz === undefined ? '' : _ref$clazz;

        _classCallCheck(this, SortLink);

        var _this = _possibleConstructorReturn(this, (SortLink.__proto__ || Object.getPrototypeOf(SortLink)).call(this, null));

        _this.title = title;
        _this.clazz = clazz;

        _this.state = {
            asc: false,
            active: false
        };

        _this.onStatePropertyChanged('asc', function () {
            _this.getEl().toggleClass('asc', _this.state.asc);
        });
        _this.onStatePropertyChanged('active', function () {
            _this.getEl().toggleClass('active', _this.state.active);
        });
        return _this;
    }

    _createClass(SortLink, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class="sortLink <%=clazz%>"><%-title%></div>';
        }
    }]);

    return SortLink;
}(_TemplateView3.default);

exports.default = SortLink;

/***/ }),
/* 1725 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _EmptyHighlighter = __webpack_require__(137);

var _EmptyHighlighter2 = _interopRequireDefault(_EmptyHighlighter);

var _TableCell = __webpack_require__(1726);

var _TableCell2 = _interopRequireDefault(_TableCell);

var _TableRow = __webpack_require__(1727);

var _TableRow2 = _interopRequireDefault(_TableRow);

var _NameCellContent = __webpack_require__(855);

var _NameCellContent2 = _interopRequireDefault(_NameCellContent);

var _utils = __webpack_require__(200);

var _TokensHighlighter = __webpack_require__(94);

var _TokensHighlighter2 = _interopRequireDefault(_TokensHighlighter);

var _StringTokenizer = __webpack_require__(103);

var _StringTokenizer2 = _interopRequireDefault(_StringTokenizer);

var _WarningsController = __webpack_require__(542);

var _WarningsController2 = _interopRequireDefault(_WarningsController);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _constants = __webpack_require__(4);

var _atUtils = __webpack_require__(5);

var _WorkAssignmentsCellContent = __webpack_require__(1728);

var _WorkAssignmentsCellContent2 = _interopRequireDefault(_WorkAssignmentsCellContent);

var _SimpleSingletonTooltip = __webpack_require__(45);

var _utils2 = __webpack_require__(25);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TableBody = function (_TemplateView) {
    _inherits(TableBody, _TemplateView);

    function TableBody(_ref) {
        var _ref$onNameCellClick = _ref.onNameCellClick,
            onNameCellClick = _ref$onNameCellClick === undefined ? function (id) {} : _ref$onNameCellClick,
            _ref$onWorkAssignment = _ref.onWorkAssignmentsCellClick,
            onWorkAssignmentsCellClick = _ref$onWorkAssignment === undefined ? function (id) {} : _ref$onWorkAssignment;

        _classCallCheck(this, TableBody);

        var _this = _possibleConstructorReturn(this, (TableBody.__proto__ || Object.getPrototypeOf(TableBody)).call(this, null));

        _this._setRowState = function (row, user) {
            row.setState({
                enabled: user.enabled,
                enabledInOtherProduct: user.enabledInOtherProduct,
                locked: user.locked,
                isNew: !!_this.state.newUsersIdSet[user.id]
            });
        };

        _this._setNameCellState = function (nameCell, user) {
            var warningMsgs = _this.state.warningMsgsByUserId[user.id];
            nameCell.setState({
                userGroupName: _this._getUserGroupName(user.userGroupId),
                timeZoneGroupName: _this._getTimeZoneGroupName(user.timeZoneGroupId),
                infos: warningMsgs.infoMsgs,
                warnings: warningMsgs.warningMsgs,
                firstName: user.firstName,
                lastName: user.lastName,
                middleInitial: user.middleInitial,
                username: user.username,
                withoutApprover: user.requiresTTApproval && !!_this.state.usersWithoutApproversSet[user.id],
                invalidReleaseDate: (0, _atUtils.compareNullableStrDates)(user.hireDate, user.releaseDate) > 0,
                highlighter: _this._highlighter,
                enabled: user.enabled,
                locked: user.locked,
                enabledInAp: user.enabledInOtherProduct,
                withoutWorkScope: (0, _utils.doesUserCanEnterTimeTrack)(user) ? _this._doesUserWithoutWorkScope(user) : false,
                clickable: user.editable
            });
        };

        _this._setWACellState = function (waCell, user) {
            waCell.setState(_extends({
                viewerManagementCounters: _this.state.viewerManagementCounters
            }, _this._getUserWorkAssignmentsCounters(user.id), {
                allScope: (0, _utils.canAccessAllWorkScope)({ userInfo: user, isURAEnabled: _this.state.isURAEnabled, isBTYEnabled: _this.state.isBTYEnabled }),
                noEnterTTPermission: !(0, _utils.doesUserCanEnterTimeTrack)(user)
            }));
        };

        _this._getUserWorkAssignmentsCounters = function (userId) {
            var counters = _this.state.usersWorkAssignmentsCounters[userId];
            if (!counters) {
                counters = {
                    customers: 0,
                    projects: 0,
                    tasks: 0
                };
            }
            return counters;
        };

        _this._doesUserWithoutWorkScope = function (user) {
            return !(0, _utils.canAccessAllWorkScope)({ userInfo: user, isURAEnabled: _this.state.isURAEnabled, isBTYEnabled: _this.state.isBTYEnabled }) && !user.hasAssignedWorkScope;
        };

        _this._setRowSelectedState = function (userId, selected) {
            var row = _this._rowsMap[userId];
            if (row) {
                row.setState({
                    selected: selected
                });
            }
        };

        _this._handleHoveredNameCell = function (id, hovered) {
            _this._rowsMap[id].setState({
                hoveredCls: hovered ? 'nameCellHovered' : ''
            });
        };

        _this._handleNameCellClick = function (id, e) {
            (0, _utils2.setEventPreventHidingEditUserSlidingPanel)(e);
            _this.params.onNameCellClick(id);
        };

        _this._handleHoveredWACell = function (id, hovered) {
            var user = _this._getUser(id);

            if ((0, _utils.doesUserCanEnterTimeTrack)(user)) {
                if ((0, _utils.canAccessAllWorkScope)({ userInfo: user, isURAEnabled: _this.state.isURAEnabled, isBTYEnabled: _this.state.isBTYEnabled })) {
                    var tooltip = (0, _SimpleSingletonTooltip.getInstance)();
                    if (hovered) {
                        tooltip.setState({
                            text: _messageResource2.default.getMessage('userlist.work_assignments.table.tooltip.all_scope', [user.firstName]),
                            extraClass: 'userlist_workAssignmentsTab_allScopeTooltip'
                        });
                        tooltip.show();
                    } else {
                        tooltip.hide();
                    }
                } else _this._rowsMap[id].setState({
                    hoveredCls: hovered ? 'workAssignmentsCellHovered' : ''
                });
            }
        };

        _this._handleMousemoveWACell = function (e) {
            (0, _SimpleSingletonTooltip.getInstance)().moveAfterCursor(e);
        };

        _this._getUser = function (id) {
            return _this.state.users.find(function (user) {
                return id === user.id;
            });
        };

        _this._getUserGroupName = function (groupId) {
            if (_this.state.userGroupsEnabled) {
                return groupId === _constants.USERS_WITHOUT_GROUP_ID ? _messageResource2.default.getMessage("userlist.js.table.username_cell.user_without_group") : !!_this.state.userGroups[groupId] ? _this.state.userGroups[groupId].name : '';
            } else {
                return '';
            }
        };

        _this._getTimeZoneGroupName = function (tzGroupId) {
            if (_this.state.timeZoneGroupsEnabled) {
                return !!_this.state.timeZoneGroups[tzGroupId] ? _this.state.timeZoneGroups[tzGroupId].name : '';
            } else {
                return '';
            }
        };

        _this._handleCustomersWAClick = function (userId, e) {
            (0, _utils2.setEventPreventHidingWorkAssignmentSlidingPanel)(e);
            _this.params.onWorkAssignmentsCellClick(userId, _constants.HierarchyLevels.CUSTOMER);
        };

        _this._handleProjectsWAClick = function (userId, e) {
            (0, _utils2.setEventPreventHidingWorkAssignmentSlidingPanel)(e);
            _this.params.onWorkAssignmentsCellClick(userId, _constants.HierarchyLevels.PROJECT);
        };

        _this._handleTasksWAClick = function (userId, e) {
            (0, _utils2.setEventPreventHidingWorkAssignmentSlidingPanel)(e);
            _this.params.onWorkAssignmentsCellClick(userId, _constants.HierarchyLevels.TASK);
        };

        _this.state = {
            users: [],
            userGroups: {},
            timeZoneGroups: {},
            usersWithoutApproversSet: [],
            userGroupsEnabled: false,
            timeZoneGroupsEnabled: false,
            wordsFilter: '',
            warningMsgsByUserId: {},
            editingUserId: null,
            newUsersIdSet: {},
            viewerManagementCounters: {},
            usersWorkAssignmentsCounters: {},
            allowedToManageAccountSettings: false,
            isURAEnabled: false,
            isBTYEnabled: false
        };

        _this.params = {
            onNameCellClick: onNameCellClick,
            onWorkAssignmentsCellClick: onWorkAssignmentsCellClick
        };

        _this._rowsMap = {};
        _this._nameCellsMap = {};
        _this._waCellsMap = {};

        _this._highlighter = new _EmptyHighlighter2.default();
        _this._warningsController = new _WarningsController2.default();

        _this.onStatePropertyChanged('wordsFilter', function (wordsFilter) {
            var tokens = new _StringTokenizer2.default(_StringTokenizer2.default.PUNCTUATORS_FOR_SEARCH).getTokens(wordsFilter.toLowerCase());
            _this._highlighter = tokens && tokens.length > 0 ? new _TokensHighlighter2.default(tokens, _StringTokenizer2.default.PUNCTUATORS_FOR_SEARCH) : new _EmptyHighlighter2.default();
        });

        _this.onStateChanged(function (state, prevState) {
            var users = state.users;

            var prevUsers = prevState.users;
            if (!(0, _atUtils.isArraysWithIdsItemsOrderEqual)(users, prevUsers) || !(0, _atUtils.isMapsWithIdsItemsOrderEqual)(state.usersWorkAssignmentsCounters, prevState.usersWorkAssignmentsCounters)) {
                _this._renderTable();
            }

            users.forEach(function (user) {
                var id = user.id;

                if (_this._rowsMap[id] && _this._nameCellsMap[id] && _this._waCellsMap[id]) {
                    _this._setRowState(_this._rowsMap[id], user);
                    _this._setNameCellState(_this._nameCellsMap[id], user);
                    _this._setWACellState(_this._waCellsMap[id], user);
                }
            });
        });

        _this.onStatePropertyChanged('editingUserId', function (editingUserId, prevEditingUserId) {
            if (editingUserId !== null) {
                _this._setRowSelectedState(editingUserId, true);
            }

            if (prevEditingUserId !== null) {
                _this._setRowSelectedState(prevEditingUserId, false);
            }
        });
        return _this;
    }

    _createClass(TableBody, [{
        key: "templateHtml",
        value: function templateHtml() {
            return '<tbody class="tableBody"></tbody>';
        }
    }, {
        key: "_renderTable",
        value: function _renderTable() {
            var _this2 = this;

            this.$el.empty();
            this._rowsMap = {};
            this._nameCellsMap = {};
            this._waCellsMap = {};

            this.state.users.forEach(function (user) {
                if (_this2.isRenderTableLine(user)) {
                    var waCell = new _WorkAssignmentsCellContent2.default({
                        onMouseIn: function onMouseIn(e) {
                            _this2._handleHoveredWACell(user.id, true, e);
                        },
                        onMouseOut: function onMouseOut(e) {
                            _this2._handleHoveredWACell(user.id, false, e);
                        },
                        onMouseMove: function onMouseMove(e) {
                            _this2._handleMousemoveWACell(e);
                        },
                        onCustomersClick: function onCustomersClick(e) {
                            return _this2._handleCustomersWAClick(user.id, e);
                        },
                        onProjectsClick: function onProjectsClick(e) {
                            return _this2._handleProjectsWAClick(user.id, e);
                        },
                        onTasksClick: function onTasksClick(e) {
                            return _this2._handleTasksWAClick(user.id, e);
                        }
                    });
                    var nameCell = new _NameCellContent2.default({
                        warningsController: _this2._warningsController,
                        onClick: function onClick(e) {
                            if (user.editable && !user.locked) _this2._handleNameCellClick(user.id, e);
                        },
                        onMouseIn: function onMouseIn() {
                            if (user.editable && !user.locked) _this2._handleHoveredNameCell(user.id, true);
                        },
                        onMouseOut: function onMouseOut() {
                            if (user.editable && !user.locked) _this2._handleHoveredNameCell(user.id, false);
                        }
                    });
                    var cells = [new _TableCell2.default({
                        cellClass: 'first userNameCell',
                        content: nameCell
                    }), new _TableCell2.default({
                        cellClass: 'emptyCell'
                    }), new _TableCell2.default({
                        cellClass: 'last taskWorkAssignmentsCell enabled',
                        content: waCell
                    })];
                    var row = new _TableRow2.default({
                        cells: cells
                    }).init(_this2.$el);

                    _this2._setRowState(row, user);
                    _this2._setNameCellState(nameCell, user);
                    _this2._setWACellState(waCell, user);

                    _this2._rowsMap[user.id] = row;
                    _this2._nameCellsMap[user.id] = nameCell;
                    _this2._waCellsMap[user.id] = waCell;

                    if (_this2.state.editingUserId !== null) {
                        _this2._setRowSelectedState(_this2.state.editingUserId, true);
                    }
                }
            });
        }
    }, {
        key: "isRenderTableLine",
        value: function isRenderTableLine(user) {
            return this.state.usersWorkAssignmentsCounters[user.id] || (0, _utils.canAccessAllWorkScope)({ userInfo: user, isURAEnabled: this.state.isURAEnabled, isBTYEnabled: this.state.isBTYEnabled }) || !(0, _utils.doesUserCanEnterTimeTrack)(user);
        }
    }]);

    return TableBody;
}(_TemplateView3.default);

exports.default = TableBody;

/***/ }),
/* 1726 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TableCell = function (_TemplateView) {
    _inherits(TableCell, _TemplateView);

    function TableCell(_ref) {
        var _ref$content = _ref.content,
            content = _ref$content === undefined ? null : _ref$content,
            _ref$cellClass = _ref.cellClass,
            cellClass = _ref$cellClass === undefined ? '' : _ref$cellClass;

        _classCallCheck(this, TableCell);

        var _this = _possibleConstructorReturn(this, (TableCell.__proto__ || Object.getPrototypeOf(TableCell)).call(this, null));

        _this.params = {
            content: content,
            cellClass: cellClass
        };
        return _this;
    }

    _createClass(TableCell, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<td></td>';
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            this.$el.addClass(this.params.cellClass);
            if (this.params.content !== null) {
                this.params.content.init(this.$el);
            }
        }
    }]);

    return TableCell;
}(_TemplateView3.default);

exports.default = TableCell;

/***/ }),
/* 1727 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TableRow = function (_TemplateView) {
    _inherits(TableRow, _TemplateView);

    function TableRow(_ref) {
        var _ref$cells = _ref.cells,
            cells = _ref$cells === undefined ? [] : _ref$cells;

        _classCallCheck(this, TableRow);

        var _this = _possibleConstructorReturn(this, (TableRow.__proto__ || Object.getPrototypeOf(TableRow)).call(this, null));

        _this.params = {
            cells: cells
        };

        _this.state = {
            enabled: false,
            enabledInOtherProduct: null,
            locked: false,
            isNew: false,
            selected: false,
            hoveredCls: ''
        };

        _this.onStateChanged(function () {
            _this.$el.toggleClass('linkedNotNull', _this.state.enabledInOtherProduct !== null).toggleClass('linkedWithActiplans', _this.state.enabledInOtherProduct === true).toggleClass('locked', _this.state.locked).toggleClass('newUser', _this.state.isNew).toggleClass('selected', _this.state.selected).toggleClass('disabled', !_this.state.enabled);
        });

        _this.onStatePropertyChanged('hoveredCls', function (cls, prevCls) {
            _this.$el.toggleClass(cls, true).toggleClass(prevCls, false);
        });
        return _this;
    }

    _createClass(TableRow, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<tr class="userListRow"></tr>';
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            var _this2 = this;

            this.params.cells.forEach(function (cell) {
                cell.init(_this2.$el);
            });
        }
    }]);

    return TableRow;
}(_TemplateView3.default);

exports.default = TableRow;

/***/ }),
/* 1728 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _CounterWithProgressBar = __webpack_require__(210);

var _CounterWithProgressBar2 = _interopRequireDefault(_CounterWithProgressBar);

var _constants = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var WorkAssignmentsCellContent = function (_TemplateView) {
    _inherits(WorkAssignmentsCellContent, _TemplateView);

    function WorkAssignmentsCellContent(_ref) {
        var _ref$onCustomersClick = _ref.onCustomersClick,
            onCustomersClick = _ref$onCustomersClick === undefined ? function (e) {} : _ref$onCustomersClick,
            _ref$onProjectsClick = _ref.onProjectsClick,
            onProjectsClick = _ref$onProjectsClick === undefined ? function (e) {} : _ref$onProjectsClick,
            _ref$onTasksClick = _ref.onTasksClick,
            onTasksClick = _ref$onTasksClick === undefined ? function (e) {} : _ref$onTasksClick,
            _ref$onMouseIn = _ref.onMouseIn,
            onMouseIn = _ref$onMouseIn === undefined ? function (e) {} : _ref$onMouseIn,
            _ref$onMouseOut = _ref.onMouseOut,
            onMouseOut = _ref$onMouseOut === undefined ? function (e) {} : _ref$onMouseOut,
            _ref$onMouseMove = _ref.onMouseMove,
            onMouseMove = _ref$onMouseMove === undefined ? function (e) {} : _ref$onMouseMove;

        _classCallCheck(this, WorkAssignmentsCellContent);

        var _this = _possibleConstructorReturn(this, (WorkAssignmentsCellContent.__proto__ || Object.getPrototypeOf(WorkAssignmentsCellContent)).call(this, null));

        _this.params = {
            onCustomersClick: onCustomersClick,
            onProjectsClick: onProjectsClick,
            onTasksClick: onTasksClick,
            onMouseIn: onMouseIn,
            onMouseOut: onMouseOut,
            onMouseMove: onMouseMove
        };

        _this.state = {
            viewerManagementCounters: {
                customers: 0,
                projects: 0,
                tasks: 0
            },
            customers: 0,
            projects: 0,
            tasks: 0,
            allScope: false,
            noEnterTTPermission: false
        };

        _this.onStateDeeplyChanged(function () {
            _this.$el.toggleClass('noEnterTTPermission', _this.state.noEnterTTPermission);
            _this.$el.toggleClass('allScope', _this.state.allScope && !_this.state.noEnterTTPermission);

            if (!_this.state.allScope && !_this.state.noEnterTTPermission) {
                var viewerManagementCustomers = _this.state.viewerManagementCounters.customers;
                _this.customersCounter.setState({
                    curValue: _this.state.customers,
                    maxValue: viewerManagementCustomers,
                    all: viewerManagementCustomers > 0 && _this.state.customers >= viewerManagementCustomers,
                    pale: true,
                    active: viewerManagementCustomers > 0
                });
                _this.$c.toggleClass('inactive', viewerManagementCustomers === 0);
                _this.$c.toggleClass('active', viewerManagementCustomers > 0);

                var viewerManagementProjects = _this.state.viewerManagementCounters.projects;
                _this.projectsCounter.setState({
                    curValue: _this.state.projects,
                    maxValue: viewerManagementProjects,
                    all: viewerManagementProjects > 0 && _this.state.projects >= viewerManagementProjects,
                    pale: true,
                    active: viewerManagementProjects > 0
                });
                _this.$p.toggleClass('inactive', viewerManagementProjects === 0);
                _this.$p.toggleClass('active', viewerManagementProjects > 0);

                var viewerManagementTasks = _this.state.viewerManagementCounters.tasks;
                _this.tasksCounter.setState({
                    curValue: _this.state.tasks,
                    maxValue: viewerManagementTasks,
                    all: viewerManagementTasks > 0 && _this.state.tasks >= viewerManagementTasks,
                    pale: true,
                    active: viewerManagementTasks > 0
                });
                _this.$t.toggleClass('inactive', viewerManagementTasks === 0);
                _this.$t.toggleClass('active', viewerManagementTasks > 0);
            }
        });
        return _this;
    }

    _createClass(WorkAssignmentsCellContent, [{
        key: "messageKeys",
        value: function messageKeys() {
            return {
                allScopeLabel: 'userlist.work_assignments.table.cell.all_scope',
                noEnterTTPermissionLabel: 'userlist.work_assignments.table.cell.no_enter_tt_permission'
            };
        }
    }, {
        key: "templateHtml",
        value: function templateHtml() {
            return '<div class="workAssignmentsTab_workAssignmentsCell">' + '   <div class="customers"></div>' + '   <div class="projects"></div>' + '   <div class="tasks"></div>' + '   <div class="allScopeLabel"><%-allScopeLabel%></div>' + '   <div class="noEnterTTPermissionLabel"><%-noEnterTTPermissionLabel%></div>' + '</div>';
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            var _this2 = this;

            this.$el.mousemove(this.params.onMouseMove).hover(this.params.onMouseIn, this.params.onMouseOut);

            this.$c = this.find('.customers').click(function (e) {
                if (_this2.state.viewerManagementCounters.customers > 0) _this2.params.onCustomersClick(e);
            });
            this.customersCounter = new _CounterWithProgressBar2.default({
                hierarchyLevel: _constants.HierarchyLevels.CUSTOMER,
                hasProgressBar: true
            }).init(this.$c);
            this.customersCounter.setState({ pale: true });

            this.$p = this.find('.projects').click(function (e) {
                if (_this2.state.viewerManagementCounters.projects > 0) _this2.params.onProjectsClick(e);
            });
            this.projectsCounter = new _CounterWithProgressBar2.default({
                hierarchyLevel: _constants.HierarchyLevels.PROJECT,
                hasProgressBar: true
            }).init(this.$p);
            this.projectsCounter.setState({ pale: true });

            this.$t = this.find('.tasks').click(function (e) {
                if (_this2.state.viewerManagementCounters.tasks > 0) _this2.params.onTasksClick(e);
            });
            this.tasksCounter = new _CounterWithProgressBar2.default({
                hierarchyLevel: _constants.HierarchyLevels.TASK,
                hasProgressBar: true
            }).init(this.$t);
            this.tasksCounter.setState({ pale: true });
        }
    }]);

    return WorkAssignmentsCellContent;
}(_TemplateView3.default);

exports.default = WorkAssignmentsCellContent;

/***/ }),
/* 1729 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _constants = __webpack_require__(4);

var _PagerController = __webpack_require__(461);

var _PagerController2 = _interopRequireDefault(_PagerController);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Pager = function (_TemplateView) {
    _inherits(Pager, _TemplateView);

    function Pager(_ref) {
        var _ref$onChangeUserPerP = _ref.onChangeUserPerPage,
            onChangeUserPerPage = _ref$onChangeUserPerP === undefined ? function () {} : _ref$onChangeUserPerP,
            _ref$onChangePageNum = _ref.onChangePageNum,
            onChangePageNum = _ref$onChangePageNum === undefined ? function () {} : _ref$onChangePageNum;

        _classCallCheck(this, Pager);

        var _this = _possibleConstructorReturn(this, (Pager.__proto__ || Object.getPrototypeOf(Pager)).call(this, null));

        _this.params = {
            onChangeUserPerPage: onChangeUserPerPage,
            onChangePageNum: onChangePageNum
        };

        _this.state = {
            totalNumberOfUsers: 0,
            pageNum: 1,
            usersPerPage: 1
        };

        _this.onStateChanged(function () {
            _this.pagerController.setPagerStateAndUpdateUI(_this.state.totalNumberOfUsers, _this.state.pageNum, _this.state.usersPerPage);
        });
        return _this;
    }

    _createClass(Pager, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<table class="userListFooter">' + '    <tr>' + '        <td class="usersPerPage">' + '            <table>' + '                <tr>' + '                  <td class="showCaption"><%=show%></td>' + '                  <td class="selector" >' + '                    <select name="recordsPerPage" class="recordsPerPageSelector">' + '                        <% _.each(pagesSet, function(value) { %>' + '                            <option value="<%=value%>"><%=value%></option>' + '                        <% }); %>' + '                    </select>' + '                  </td>' + '                  <td class="userPerPageCaption"><%=perPage%></td>' + '               </tr>' + '            </table>' + '        </td>' + '        <td class="tableNavigation" colspan="5">' + '            <div class="pager"></div>' + '        </td>' + '    </tr>' + '</table>';
        }
    }, {
        key: 'messageKeys',
        value: function messageKeys() {
            return {
                show: 'userlist.table.show',
                perPage: 'userlist.table.users_per_page'
            };
        }
    }, {
        key: 'templateModel',
        value: function templateModel() {
            return {
                pagesSet: _constants.Pager.CUSTOM_PAGE_SET_2
            };
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            this.pagerController = new _PagerController2.default().init({
                handlersMap: {
                    pageChanged: this.params.onChangePageNum,
                    recordsPerPageChanged: this.params.onChangeUserPerPage
                },
                pagerControlsElement: this.$el[0],
                pagerElement: this.find('.pager')[0],
                recordsPerPageSelectorElement: this.find('.recordsPerPageSelector')[0],
                minRecordsPerPage: _constants.UserManagementConstants.MIN_RECORDS_PER_PAGE,
                ignoreHashChange: true
            });
            this.pagerController.render();
        }
    }]);

    return Pager;
}(_TemplateView3.default);

exports.default = Pager;

/***/ }),
/* 1730 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _CounterWithProgressBar = __webpack_require__(210);

var _CounterWithProgressBar2 = _interopRequireDefault(_CounterWithProgressBar);

var _constants = __webpack_require__(4);

var _pluralizeUtils = __webpack_require__(40);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ViewerManagementCounters = function (_TemplateView) {
    _inherits(ViewerManagementCounters, _TemplateView);

    function ViewerManagementCounters() {
        _classCallCheck(this, ViewerManagementCounters);

        var _this = _possibleConstructorReturn(this, (ViewerManagementCounters.__proto__ || Object.getPrototypeOf(ViewerManagementCounters)).call(this, null));

        _this.state = {
            customers: 0,
            projects: 0,
            tasks: 0
        };

        _this.onStateChanged(function () {
            var customers = _this.state.customers;
            _this.customersCounter.setState({
                maxValue: customers,
                curValue: customers,
                active: customers > 0,
                pale: customers === 0,
                title: _messageResource2.default.getMessage('userlist.work_assignments.active') + " " + (0, _pluralizeUtils.customerNameLower)(customers)
            });

            var projects = _this.state.projects;
            _this.projectsCounter.setState({
                maxValue: projects,
                curValue: projects,
                active: projects > 0,
                pale: projects === 0,
                title: _messageResource2.default.getMessage('userlist.work_assignments.active') + " " + (0, _pluralizeUtils.projectNameLower)(projects)
            });

            var tasks = _this.state.tasks;
            _this.tasksCounter.setState({
                maxValue: tasks,
                curValue: tasks,
                active: tasks > 0,
                pale: tasks === 0,
                title: _messageResource2.default.getMessage('userlist.work_assignments.open') + " " + (0, _pluralizeUtils.taskNameLower)(tasks)
            });
        });
        return _this;
    }

    _createClass(ViewerManagementCounters, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class="workAssignmentsTab_viewerManagementCounter">' + '   <div class="customers"></div>' + '   <div class="projects"></div>' + '   <div class="tasks"></div>' + '</div>';
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            var $customers = this.find('.customers');
            this.customersCounter = new _CounterWithProgressBar2.default({
                hierarchyLevel: _constants.HierarchyLevels.CUSTOMER,
                hasProgressBar: true
            }).init($customers);

            var $projects = this.find('.projects');
            this.projectsCounter = new _CounterWithProgressBar2.default({
                hierarchyLevel: _constants.HierarchyLevels.PROJECT,
                hasProgressBar: true
            }).init($projects);

            var $tasks = this.find('.tasks');
            this.tasksCounter = new _CounterWithProgressBar2.default({
                hierarchyLevel: _constants.HierarchyLevels.TASK,
                hasProgressBar: true
            }).init($tasks);
        }
    }]);

    return ViewerManagementCounters;
}(_TemplateView3.default);

exports.default = ViewerManagementCounters;

/***/ }),
/* 1731 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TabsContainer = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _utils = __webpack_require__(6);

var _redux = __webpack_require__(7);

var _selectors = __webpack_require__(53);

var _actions = __webpack_require__(50);

var _constants = __webpack_require__(4);

var _Tab = __webpack_require__(563);

var _Tab2 = _interopRequireDefault(_Tab);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TabsContainer = exports.TabsContainer = function (_TemplateView) {
    _inherits(TabsContainer, _TemplateView);

    function TabsContainer(_ref) {
        var _ref$setActiveTabActi = _ref.setActiveTabAction,
            setActiveTabAction = _ref$setActiveTabActi === undefined ? function () {} : _ref$setActiveTabActi;

        _classCallCheck(this, TabsContainer);

        var _this = _possibleConstructorReturn(this, (TabsContainer.__proto__ || Object.getPrototypeOf(TabsContainer)).call(this, null));

        _this._toggleTab = function (tabNum, show) {
            _this._tabsMap[tabNum].toggle(show);
        };

        _this.props = {
            setActiveTabAction: setActiveTabAction
        };

        _this.state = {
            tabNum: _constants.UserManagementConstants.ACCOUNT_SETTINGS_TAB_NUM,
            showAccountSettingsTab: false,
            showPTOTab: false,
            showSDBTab: false,
            showWASTab: false
        };

        _this._tabsMap = {};

        _this.onStatePropertyChanged('tabNum', function (newTabNum, prevTabNum) {
            _this._tabsMap[newTabNum].setState({ active: true });
            if (prevTabNum !== undefined) {
                _this._tabsMap[prevTabNum].setState({ active: false });
            }
        });

        _this.onStatePropertyChanged('showAccountSettingsTab', _underscore2.default.partial(_this._toggleTab, _constants.UserManagementConstants.ACCOUNT_SETTINGS_TAB_NUM));
        _this.onStatePropertyChanged('showPTOTab', _underscore2.default.partial(_this._toggleTab, _constants.UserManagementConstants.PTO_SETTINGS_TAB_NUM));
        _this.onStatePropertyChanged('showSDBTab', _underscore2.default.partial(_this._toggleTab, _constants.UserManagementConstants.SICK_DAYS_SETTINGS_TAB_NUM));
        _this.onStatePropertyChanged('showWASTab', _underscore2.default.partial(_this._toggleTab, _constants.UserManagementConstants.WORK_ASSIGNMENTS_TAB_NUM));
        return _this;
    }

    _createClass(TabsContainer, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class="userManagement_tabsContainer"></div>';
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            this._tabsMap[_constants.UserManagementConstants.ACCOUNT_SETTINGS_TAB_NUM] = new _Tab2.default({
                id: _constants.UserManagementConstants.ACCOUNT_SETTINGS_TAB_NUM,
                onClick: this.props.setActiveTabAction,
                text: _messageResource2.default.getMessage('userlist.tabs.accounts_permissions')
            }).init(this.$el);

            this._tabsMap[_constants.UserManagementConstants.PTO_SETTINGS_TAB_NUM] = new _Tab2.default({
                id: _constants.UserManagementConstants.PTO_SETTINGS_TAB_NUM,
                onClick: this.props.setActiveTabAction,
                text: _messageResource2.default.getMessage('userlist.tabs.users_pto')
            }).init(this.$el);

            this._tabsMap[_constants.UserManagementConstants.SICK_DAYS_SETTINGS_TAB_NUM] = new _Tab2.default({
                id: _constants.UserManagementConstants.SICK_DAYS_SETTINGS_TAB_NUM,
                onClick: this.props.setActiveTabAction,
                text: _messageResource2.default.getMessage('userlist.tabs.users_sick_days')
            }).init(this.$el);

            this._tabsMap[_constants.UserManagementConstants.WORK_ASSIGNMENTS_TAB_NUM] = new _Tab2.default({
                id: _constants.UserManagementConstants.WORK_ASSIGNMENTS_TAB_NUM,
                onClick: this.props.setActiveTabAction,
                text: _messageResource2.default.getMessage('userlist.tabs.work_assignments'),
                extraClass: 'workAssignmentTabTips'
            }).init(this.$el);
        }
    }]);

    return TabsContainer;
}(_TemplateView3.default);

exports.default = (0, _utils.connect)(function (state) {
    return {
        tabNum: (0, _selectors.getActiveTabNum)(state),
        showAccountSettingsTab: (0, _selectors.isAccountSettingsTabVisible)(state),
        showPTOTab: (0, _selectors.isPTOTabVisible)(state),
        showSDBTab: (0, _selectors.isSDBTabVisible)(state),
        showWASTab: (0, _selectors.isWASTabVisible)(state)
    };
}, function (dispatch) {
    return {
        setActiveTabAction: (0, _redux.bindActionCreators)(_actions.setActiveTabAction, dispatch)
    };
})(TabsContainer);

/***/ }),
/* 1732 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.openTeamAssignmentsPanelFromUserList = exports.setStateOnInviteSeveralUsersSuccess = exports.setStateOnPageDataReceivedAction = undefined;

var _actions = __webpack_require__(50);

var _actions2 = __webpack_require__(68);

var _actions3 = __webpack_require__(29);

var _actions4 = __webpack_require__(167);

var _selectors = __webpack_require__(313);

var _actions5 = __webpack_require__(403);

var _actions6 = __webpack_require__(126);

var _constants = __webpack_require__(201);

var setStateOnPageDataReceivedAction = exports.setStateOnPageDataReceivedAction = function setStateOnPageDataReceivedAction(data) {
    return function (dispatch) {
        dispatch((0, _actions.setLicenseCounters)(data.licenseCounters));

        if (data.allUserGroups) {
            dispatch((0, _actions3.addUserGroups)(data.allUserGroups));
        }
        if (data.allTimeZoneGroups) {
            dispatch((0, _actions3.addTimeZoneGroups)(data.allTimeZoneGroups));
        }

        dispatch((0, _actions.setViewerSettings)(data.viewerSettings));
        dispatch((0, _actions.setUsersWithoutApprovers)(data.usersWithoutApprovers));

        dispatch((0, _actions2.setEnabledFeatures)(data.viewerSettings.enabledFeatures));
        dispatch((0, _actions3.addUsers)(data.records));
    };
};

var setStateOnInviteSeveralUsersSuccess = exports.setStateOnInviteSeveralUsersSuccess = function setStateOnInviteSeveralUsersSuccess(data) {
    return function (dispatch) {
        dispatch((0, _actions.setLicenseCounters)(data.licenseCounters));

        if (data.userGroups) {
            dispatch((0, _actions3.addUserGroups)(data.userGroups));
        }
        if (data.timeZoneGroups) {
            dispatch((0, _actions3.addTimeZoneGroups)(data.timeZoneGroups));
        }

        dispatch((0, _actions.setViewerSettings)(data.viewerSettings));
        dispatch((0, _actions.setUsersWithoutApprovers)(data.additionalResultData.map[_constants.AdditionalDataConstants.USERS_WITHOUT_APPROVERS_DATA]));

        dispatch((0, _actions2.setEnabledFeatures)(data.viewerSettings.enabledFeatures));
        var addedUsers = data.additionalUsersInfo;
        var ids = addedUsers.map(function (user) {
            return user.id;
        });
        dispatch((0, _actions3.addUsers)(addedUsers));
        dispatch((0, _actions.addNewUserIds)(ids));
        dispatch((0, _actions4.prependUserIdsOrder)(ids));
    };
};

var openTeamAssignmentsPanelFromUserList = exports.openTeamAssignmentsPanelFromUserList = function openTeamAssignmentsPanelFromUserList(userId) {
    return function (dispatch, getState) {
        var configuredUserId = (0, _selectors.getUserId)(getState());
        if (configuredUserId !== userId) {
            dispatch((0, _actions5.openTeamAssignmentsPanel)(userId));
            dispatch((0, _actions6.reloadUserData)());
        } else {
            dispatch((0, _actions5.closeTeamAssignmentsPanel)());
        }
    };
};

/***/ }),
/* 1733 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _View2 = __webpack_require__(20);

var _View3 = _interopRequireDefault(_View2);

var _utils = __webpack_require__(6);

var _redux = __webpack_require__(7);

var _PanelContainer = __webpack_require__(109);

var _PanelContainer2 = _interopRequireDefault(_PanelContainer);

var _WorkAssignmentComponent = __webpack_require__(1734);

var _WorkAssignmentComponent2 = _interopRequireDefault(_WorkAssignmentComponent);

var _selectors = __webpack_require__(203);

var _actions = __webpack_require__(211);

var _LoadingContainer = __webpack_require__(28);

var _LoadingContainer2 = _interopRequireDefault(_LoadingContainer);

var _constants = __webpack_require__(62);

var _actions2 = __webpack_require__(50);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var WorkAssignmentPanel = function (_View) {
    _inherits(WorkAssignmentPanel, _View);

    function WorkAssignmentPanel(_ref) {
        var _ref$onPanelHide = _ref.onPanelHide,
            onPanelHide = _ref$onPanelHide === undefined ? function () {} : _ref$onPanelHide,
            _ref$loadPanel = _ref.loadPanel,
            loadPanel = _ref$loadPanel === undefined ? function () {} : _ref$loadPanel,
            _ref$closeAllPanels = _ref.closeAllPanels,
            closeAllPanels = _ref$closeAllPanels === undefined ? function () {} : _ref$closeAllPanels;

        _classCallCheck(this, WorkAssignmentPanel);

        var _this = _possibleConstructorReturn(this, (WorkAssignmentPanel.__proto__ || Object.getPrototypeOf(WorkAssignmentPanel)).call(this));

        _this.state = {
            isShown: false,
            loading: false,
            needToLoadData: null
        };

        _this.onPanelHide = onPanelHide;
        _this.loadPanel = loadPanel;
        _this.closeAllPanels = closeAllPanels;

        _this.onStatePropertyChanged('loading', function (loading) {
            _this.loadingContainer.setState({ loading: loading });
        });
        _this.onStatePropertyChanged('isShown', function (isShown) {
            _this.panelContainerWrapper.setState({ isShown: isShown });
        });
        _this.onStatePropertyBecameTrue('needToLoadData', function () {
            _this.loadPanel();
        });
        return _this;
    }

    _createClass(WorkAssignmentPanel, [{
        key: 'afterRender',
        value: function afterRender() {
            var _this2 = this;

            this.component = new _WorkAssignmentComponent2.default();
            this.loadingContainer = new _LoadingContainer2.default({
                contentComponent: this.component,
                containerClass: "loading_workAssignmentPanel",
                contentClass: "loading_workAssignmentPanel_content",
                loadingMoireConfig: {
                    delay: 100
                }
            });
            this.panelContainerWrapper = new _PanelContainer2.default({
                component: this.loadingContainer,
                additionalClass: 'workAssignment_panel',
                showAnimationClass: _constants.SHOW_ANIMATION_CLASSES.SLIDE_LEFT,
                hideAnimationClass: _constants.HIDE_ANIMATION_CLASSES.SLIDE_LEFT,
                hideOnEsc: true,
                showHideButton: true,
                onHideCallback: function onHideCallback() {
                    return _this2.onPanelHide();
                },
                hideOnClickOutside: {
                    hideOnClick: true,
                    panelType: _constants.PANEL_TYPES.WORK_ASSIGNMENTS_PANEL
                },
                hideHandler: function hideHandler() {
                    return _this2.panelContainerWrapper.setState({ isShown: false });
                },
                onClickCloseButton: function onClickCloseButton() {
                    return _this2.closeAllPanels();
                }
            });
            this.panelContainerWrapper.init(this.$containerEl);
        }
    }]);

    return WorkAssignmentPanel;
}(_View3.default);

exports.default = (0, _utils.connect)(function (state) {
    return {
        isShown: (0, _selectors.isShown)(state),
        needToLoadData: (0, _selectors.isNeedToLoadData)(state),
        loading: (0, _selectors.isLoading)(state)
    };
}, function (dispatch) {
    return {
        onPanelHide: (0, _redux.bindActionCreators)(_actions.closePanel, dispatch),
        loadPanel: (0, _redux.bindActionCreators)(_actions.loadWorkAssignmentPanelDataAction, dispatch),
        closeAllPanels: (0, _redux.bindActionCreators)(_actions2.closeAllPanels, dispatch)
    };
})(WorkAssignmentPanel);

/***/ }),
/* 1734 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _TabContainer = __webpack_require__(1735);

var _TabContainer2 = _interopRequireDefault(_TabContainer);

var _redux = __webpack_require__(7);

var _utils = __webpack_require__(6);

var _selectors = __webpack_require__(203);

var _actions = __webpack_require__(211);

var _actions2 = __webpack_require__(561);

var _TabContent = __webpack_require__(1736);

var _TabContent2 = _interopRequireDefault(_TabContent);

var _utils2 = __webpack_require__(25);

var _CopyContent = __webpack_require__(1738);

var _CopyContent2 = _interopRequireDefault(_CopyContent);

var _ActionsMenuButtons = __webpack_require__(1739);

var _ActionsMenuButtons2 = _interopRequireDefault(_ActionsMenuButtons);

var _AssignAllScopeContent = __webpack_require__(1741);

var _AssignAllScopeContent2 = _interopRequireDefault(_AssignAllScopeContent);

var _UserNameFormat = __webpack_require__(17);

var _ScrollableContainer = __webpack_require__(49);

var _ScrollableContainer2 = _interopRequireDefault(_ScrollableContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var WorkAssignmentComponent = function (_TemplateView) {
    _inherits(WorkAssignmentComponent, _TemplateView);

    function WorkAssignmentComponent(_ref) {
        var _ref$onEntityRevoked = _ref.onEntityRevoked,
            onEntityRevoked = _ref$onEntityRevoked === undefined ? function () {} : _ref$onEntityRevoked,
            _ref$onAllRevoked = _ref.onAllRevoked,
            onAllRevoked = _ref$onAllRevoked === undefined ? function () {} : _ref$onAllRevoked,
            _ref$onSearchChanged = _ref.onSearchChanged,
            onSearchChanged = _ref$onSearchChanged === undefined ? function () {} : _ref$onSearchChanged,
            _ref$onEditButtonClic = _ref.onEditButtonClick,
            onEditButtonClick = _ref$onEditButtonClic === undefined ? function () {} : _ref$onEditButtonClic,
            _ref$tabChanged = _ref.tabChanged,
            tabChanged = _ref$tabChanged === undefined ? function () {} : _ref$tabChanged,
            _ref$openCopyMenu = _ref.openCopyMenu,
            openCopyMenu = _ref$openCopyMenu === undefined ? function () {} : _ref$openCopyMenu,
            _ref$closeCopyMenu = _ref.closeCopyMenu,
            closeCopyMenu = _ref$closeCopyMenu === undefined ? function () {} : _ref$closeCopyMenu,
            _ref$openAllAssignSco = _ref.openAllAssignScopeMenu,
            openAllAssignScopeMenu = _ref$openAllAssignSco === undefined ? function () {} : _ref$openAllAssignSco,
            _ref$closeAllAssignSc = _ref.closeAllAssignScopeMenu,
            closeAllAssignScopeMenu = _ref$closeAllAssignSc === undefined ? function () {} : _ref$closeAllAssignSc;

        _classCallCheck(this, WorkAssignmentComponent);

        var _this = _possibleConstructorReturn(this, (WorkAssignmentComponent.__proto__ || Object.getPrototypeOf(WorkAssignmentComponent)).call(this));

        _this.state = {
            userId: 0,
            userFML: {},
            counters: {
                customers: {
                    curValue: 0,
                    maxValue: 0
                },
                projects: {
                    curValue: 0,
                    maxValue: 0
                },
                tasks: {
                    curValue: 0,
                    maxValue: 0
                }
            },

            showCopyContent: false,
            showAllAssignScope: false,
            openTab: ''
        };

        _this.params = {
            onEditButtonClick: onEditButtonClick,
            tabChanged: tabChanged,
            openCopyMenu: openCopyMenu,
            closeCopyMenu: closeCopyMenu,
            openAllAssignScopeMenu: openAllAssignScopeMenu,
            closeAllAssignScopeMenu: closeAllAssignScopeMenu
        };

        _this.onStatePropertyChanged('counters', function (counters) {
            _this.tabsContainer.setState(counters);
        });

        _this.onStatePropertyChanged('openTab', function (tab) {
            _this.tabsContainer.setState({ selectedTab: tab });
        });

        _this.onStatePropertyChanged('userFML', function (userFML) {
            _this.find('.containerTitle .title').text(_messageResource2.default.getMessage('work_assignments.panel.title', [(0, _UserNameFormat.formatFmlWithCheck)(userFML)]));
        });

        _this.onAnyStatePropertyChanged(['showAllAssignScope', 'showCopyContent'], function (state) {
            var showAllAssignScope = state.showAllAssignScope;
            var showCopyContent = state.showCopyContent;

            _this.$assignAllScopeContent.toggle(showAllAssignScope);
            _this.$copyContent.toggle(showCopyContent);

            _this.find('.containerHeader').toggle(!showCopyContent && !showAllAssignScope);
            _this.find(".tabContentPlaceholder").toggle(!showCopyContent && !showAllAssignScope);
        });
        return _this;
    }

    _createClass(WorkAssignmentComponent, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class="workAssignmentContainer">' + '  <div class="containerTitle">' + '    <div class="title"></div>' + '    <div class="actions"></div>' + '  </div>' + '  <div class="assignAllScopeContent"></div>' + '  <div class="copyContent"></div>' + '  <div class="containerHeader">' + '    <div class="tabs"/>' + '    <div class="vertical-separator"/>' + '    <div class="editButton"><%-editAssignments%></div>' + '  </div>' + '  <div class="tabContentPlaceholder"/>' + '</div>';
        }
    }, {
        key: 'templateModel',
        value: function templateModel() {
            return {
                editAssignments: _messageResource2.default.getMessage('common.edit'),
                copy: _messageResource2.default.getMessage('work_assignments.panel.copy_button')
            };
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            var _this2 = this;

            this.tabsContainer = new _TabContainer2.default({ onTabChanged: this.params.tabChanged }).init(this.find('.tabs'));

            this.$editButton = this.find('.editButton');
            this.$editButton.click(function (e) {
                (0, _utils2.setEventPreventHidingWorkAssignmentsEditorSlidingPanel)(e);
                _this2.params.onEditButtonClick(_this2.state.userId);
            });

            this.actions = new _ActionsMenuButtons2.default({ actions: this._createActionButtonInformation() }).init(this.find('.actions'));

            this.$copyContent = this.find('.copyContent');
            this.copyContent = new _CopyContent2.default({
                onCancel: function onCancel() {
                    _this2.params.closeCopyMenu();
                }
            });
            this.scrollableCopyContentContainer = new _ScrollableContainer2.default(null, this.copyContent, { triggerScrollEvent: false }).init(this.$copyContent);

            this.$assignAllScopeContent = this.find('.assignAllScopeContent');
            this.assignAllScopeContent = new _AssignAllScopeContent2.default({
                onCancel: function onCancel() {
                    _this2.params.closeAllAssignScopeMenu();
                }
            });

            this.scrollableAssignAllScopeContentContainer = new _ScrollableContainer2.default(null, this.assignAllScopeContent, { triggerScrollEvent: false }).init(this.$assignAllScopeContent);

            this.registerChildComponents(this.tabsContainer, this.scrollableCopyContentContainer, this.scrollableAssignAllScopeContentContainer, this.actions, new _TabContent2.default({ onEditButtonClick: function onEditButtonClick() {
                    _this2.params.onEditButtonClick(_this2.state.userId);
                } }).init(this.find(".tabContentPlaceholder")));
        }
    }, {
        key: 'openCopyMenuCallback',
        value: function openCopyMenuCallback() {
            this._closeAllPanel();

            if (!this.state.showCopyContent) {
                this.params.openCopyMenu();
            }
        }
    }, {
        key: 'openAllAssignMenuCallback',
        value: function openAllAssignMenuCallback() {
            this._closeAllPanel();

            if (!this.state.showAllAssignScope) {
                this.params.openAllAssignScopeMenu();
            }
        }
    }, {
        key: '_createActionButtonInformation',
        value: function _createActionButtonInformation() {
            return [{
                actionClick: this.openAllAssignMenuCallback.bind(this),
                title: _messageResource2.default.getMessage('work_assignments.panel.all.assignments'),
                extraClass: 'assignAllScopeButton'
            }, {
                actionClick: this.openCopyMenuCallback.bind(this),
                title: _messageResource2.default.getMessage('work_assignments.panel.copy_button'),
                extraClass: 'copyButtonImg'
            }];
        }
    }, {
        key: '_closeAllPanel',
        value: function _closeAllPanel() {
            this.params.closeCopyMenu();
            this.params.closeAllAssignScopeMenu();
        }
    }]);

    return WorkAssignmentComponent;
}(_TemplateView3.default);

exports.default = (0, _utils.connect)(function (state) {
    return {
        userId: (0, _selectors.getUserId)(state),
        userFML: (0, _selectors.getPanelUserFML)(state),
        counters: (0, _selectors.getCounters)(state),
        openTab: (0, _selectors.getTab)(state),
        showCopyContent: (0, _selectors.isShowCopyContent)(state),
        showAllAssignScope: (0, _selectors.isShowAllAssignScopeContent)(state)
    };
}, function (dispatch) {
    return {
        tabChanged: (0, _redux.bindActionCreators)(_actions.changeWorkAssignmentPanelTab, dispatch),
        onEditButtonClick: (0, _redux.bindActionCreators)(_actions2.openEditor, dispatch),
        openCopyMenu: (0, _redux.bindActionCreators)(_actions.openCopyMenu, dispatch),
        closeCopyMenu: (0, _redux.bindActionCreators)(_actions.closeCopyContentMenu, dispatch),
        openAllAssignScopeMenu: (0, _redux.bindActionCreators)(_actions.openAssignAllScopeContentMenu, dispatch),
        closeAllAssignScopeMenu: (0, _redux.bindActionCreators)(_actions.closeAssignAllScopeContentMenu, dispatch)
    };
})(WorkAssignmentComponent);

/***/ }),
/* 1735 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _CounterWithProgressBar = __webpack_require__(210);

var _CounterWithProgressBar2 = _interopRequireDefault(_CounterWithProgressBar);

var _constants = __webpack_require__(4);

var _pluralizeUtils = __webpack_require__(40);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TabContainer = function (_TemplateView) {
    _inherits(TabContainer, _TemplateView);

    function TabContainer(_ref) {
        var _ref$onTabChanged = _ref.onTabChanged,
            onTabChanged = _ref$onTabChanged === undefined ? function (tab) {} : _ref$onTabChanged;

        _classCallCheck(this, TabContainer);

        var _this = _possibleConstructorReturn(this, (TabContainer.__proto__ || Object.getPrototypeOf(TabContainer)).call(this));

        _this.params = {
            onTabChanged: onTabChanged
        };

        _this.state = {
            customers: {
                curValue: 0,
                maxValue: 0
            },
            projects: {
                curValue: 0,
                maxValue: 0
            },
            tasks: {
                curValue: 0,
                maxValue: 0
            },
            selectedTab: ""
        };

        _this.onStatePropertyChanged('customers', function (values) {
            return _this._updateTab({
                tab: _this.customerTab,
                values: values,
                title: _messageResource2.default.getMessage('userlist.work_assignments.active') + " " + (0, _pluralizeUtils.customerNameLower)(values.curValue)
            });
        });

        _this.onStatePropertyChanged('projects', function (values) {
            return _this._updateTab({
                tab: _this.projectTab,
                values: values,
                title: _messageResource2.default.getMessage('userlist.work_assignments.active') + " " + (0, _pluralizeUtils.projectNameLower)(values.curValue)
            });
        });

        _this.onStatePropertyChanged('tasks', function (values) {
            return _this._updateTab({
                tab: _this.taskTab,
                values: values,
                title: _messageResource2.default.getMessage('userlist.work_assignments.open') + " " + (0, _pluralizeUtils.taskNameLower)(values.curValue)
            });
        });

        _this.onStatePropertyChanged('selectedTab', function (hierarchyLevel) {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = Object.values(_constants.HierarchyLevels)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var level = _step.value;

                    _this.$tabs[level].toggleClass("selected", hierarchyLevel === level);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            _this.$arrow.toggleClass('taskArrow', hierarchyLevel === _constants.HierarchyLevels.TASK);
            _this.$arrow.toggleClass('projectArrow', hierarchyLevel === _constants.HierarchyLevels.PROJECT);
            _this.$arrow.toggleClass('customerArrow', hierarchyLevel === _constants.HierarchyLevels.CUSTOMER);
        });
        return _this;
    }

    _createClass(TabContainer, [{
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='tabsContainer'>" + "    <div class='arrow'/>" + "    <div class='customerTabHeader tabHeader'></div>" + "    <div class='projectTabHeader tabHeader'></div>" + "    <div class='taskTabHeader tabHeader'></div>" + "</div>";
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            var _this2 = this;

            this.$arrow = this.find('.arrow');
            this.$tabs = {};
            this.$tabs[_constants.HierarchyLevels.CUSTOMER] = this.find(".customerTabHeader");
            this.$tabs[_constants.HierarchyLevels.PROJECT] = this.find(".projectTabHeader");
            this.$tabs[_constants.HierarchyLevels.TASK] = this.find(".taskTabHeader");

            this.customerTab = new _CounterWithProgressBar2.default({
                hierarchyLevel: _constants.HierarchyLevels.CUSTOMER,
                hasProgressBar: true
            }).init(this.$tabs[_constants.HierarchyLevels.CUSTOMER]);
            this.$tabs[_constants.HierarchyLevels.CUSTOMER].click(function () {
                if (_this2.state.customers.maxValue > 0 && !_this2._areAllTabsEmpty()) _this2.params.onTabChanged(_constants.HierarchyLevels.CUSTOMER);
            });

            this.projectTab = new _CounterWithProgressBar2.default({
                hierarchyLevel: _constants.HierarchyLevels.PROJECT,
                hasProgressBar: true
            }).init(this.$tabs[_constants.HierarchyLevels.PROJECT]);
            this.$tabs[_constants.HierarchyLevels.PROJECT].click(function () {
                if (_this2.state.projects.maxValue > 0 && !_this2._areAllTabsEmpty()) _this2.params.onTabChanged(_constants.HierarchyLevels.PROJECT);
            });

            this.taskTab = new _CounterWithProgressBar2.default({
                hierarchyLevel: _constants.HierarchyLevels.TASK,
                hasProgressBar: true
            }).init(this.$tabs[_constants.HierarchyLevels.TASK]);
            this.$tabs[_constants.HierarchyLevels.TASK].click(function () {
                if (_this2.state.tasks.maxValue > 0 && !_this2._areAllTabsEmpty()) _this2.params.onTabChanged(_constants.HierarchyLevels.TASK);
            });
        }
    }, {
        key: "_areAllTabsEmpty",
        value: function _areAllTabsEmpty() {
            return this.state.tasks.curValue === 0 && this.state.projects.curValue === 0 && this.state.customers.curValue === 0;
        }
    }, {
        key: "_updateTab",
        value: function _updateTab(_ref2) {
            var tab = _ref2.tab,
                values = _ref2.values,
                title = _ref2.title;

            var allTabsEmpty = this._areAllTabsEmpty();
            this.$arrow.toggle(!allTabsEmpty);
            var active = values.maxValue > 0 && !allTabsEmpty;
            tab.setState(_extends({}, values, {
                active: active,
                pale: true,
                title: title
            }));

            this.$tabs[tab.props.hierarchyLevel].toggleClass('inactive', !active);
            this.$tabs[tab.props.hierarchyLevel].toggleClass('active', active);
        }
    }]);

    return TabContainer;
}(_TemplateView3.default);

exports.default = TabContainer;

/***/ }),
/* 1736 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _redux = __webpack_require__(7);

var _utils = __webpack_require__(6);

var _selectors = __webpack_require__(203);

var _actions = __webpack_require__(211);

var _WorkAssignmentPanelTabContent = __webpack_require__(1737);

var _WorkAssignmentPanelTabContent2 = _interopRequireDefault(_WorkAssignmentPanelTabContent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _utils.connect)(function (state) {
    return {
        userFirstName: (0, _selectors.getPanelUserFirstName)(state),
        counters: (0, _selectors.getCounters)(state),
        noCptAssignedToUserAtAll: (0, _selectors.isNoCptAssignedToUserAtAll)(state),

        searchString: (0, _selectors.getSearch)(state),
        searchOpen: (0, _selectors.isSearchOpen)(state),

        entirelyAssignedTasksCounter: (0, _selectors.getEntirelyAssignedTasksCounter)(state),
        entirelyAssignedProjectsCounter: (0, _selectors.getEntirelyAssignedProjectCounter)(state),

        customerEntities: (0, _selectors.selectCustomerEntities)(state),
        projectEntities: (0, _selectors.selectProjectEntities)(state),
        taskEntities: (0, _selectors.selectTaskEntities)(state),

        isShowArchiveEntities: (0, _selectors.isShowArchivedEntities)(state),

        openTab: (0, _selectors.getTab)(state),

        // work assignment panel must be without toggle archived entities
        showToggleArchivedButton: false
    };
}, function (dispatch) {
    return {
        onEntityRevoked: (0, _redux.bindActionCreators)(_actions.revokeEntitiesAction, dispatch),
        onAllRevoked: (0, _redux.bindActionCreators)(_actions.revokeAllTypeAction, dispatch),
        onSearchChanged: (0, _redux.bindActionCreators)(_actions.setSearchString, dispatch),
        onSearchToggled: (0, _redux.bindActionCreators)(_actions.setSearchOpen, dispatch),

        setIsShowArchiveEntities: (0, _redux.bindActionCreators)(_actions.setIsShowArchiveEntities, dispatch)
    };
})(_WorkAssignmentPanelTabContent2.default);

/***/ }),
/* 1737 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TabContent2 = __webpack_require__(890);

var _TabContent3 = _interopRequireDefault(_TabContent2);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _constants = __webpack_require__(4);

var _constants2 = __webpack_require__(558);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var WorkAssignmentPanelTabContent = function (_TabContent) {
    _inherits(WorkAssignmentPanelTabContent, _TabContent);

    function WorkAssignmentPanelTabContent() {
        _classCallCheck(this, WorkAssignmentPanelTabContent);

        return _possibleConstructorReturn(this, (WorkAssignmentPanelTabContent.__proto__ || Object.getPrototypeOf(WorkAssignmentPanelTabContent)).apply(this, arguments));
    }

    _createClass(WorkAssignmentPanelTabContent, [{
        key: 'tabHeaderTitle',
        value: function tabHeaderTitle() {
            var tab = this.state.openTab;
            switch (tab) {
                case _constants.HierarchyLevels.TASK:
                    return _messageResource2.default.getMessage("work_assignments.panel.tasks.title", [], true);
                case _constants.HierarchyLevels.PROJECT:
                    return _messageResource2.default.getMessage("work_assignments.panel.projects.title", [], true);
                case _constants.HierarchyLevels.CUSTOMER:
                    return _messageResource2.default.getMessage("work_assignments.panel.customer.title", [], true);
            }
            return "";
        }
    }, {
        key: 'getRevokeConfirmationText',
        value: function getRevokeConfirmationText() {
            var tab = this.state.openTab;
            var hierarchyLevelName = "";
            var entitiesList = [];

            switch (tab) {
                case _constants.HierarchyLevels.TASK:
                    hierarchyLevelName = _messageResource2.default.getMessage('common.tasks');
                    entitiesList = this.state.taskEntities;
                    break;
                case _constants.HierarchyLevels.PROJECT:
                    hierarchyLevelName = _messageResource2.default.getMessage('common.projects');
                    entitiesList = this.state.projectEntities;
                    break;
                case _constants.HierarchyLevels.CUSTOMER:
                    hierarchyLevelName = _messageResource2.default.getMessage('common.customers');
                    entitiesList = this.state.customerEntities;
                    break;
            }
            var resultMessage = _messageResource2.default.getMessage('work_assignments.panel.revoke_message', [hierarchyLevelName, this.state.userFirstName]);

            var hasAnyManageableEntity = entitiesList.some(function (entity) {
                return !entity.revokeEnabled;
            });
            if (hasAnyManageableEntity) resultMessage += '\n' + _messageResource2.default.getMessage('work_assignments.panel.revoke_message_note', [hierarchyLevelName]);

            return resultMessage;
        }
    }, {
        key: '_setEmptyListTitles',
        value: function _setEmptyListTitles() {
            var _titlesMap, _noSelectedTitlesMap, _subtitlesAssignItems, _subtitlesAssignMoreI;

            this.emptyList.setState({
                titlesMap: (_titlesMap = {}, _defineProperty(_titlesMap, _constants.HierarchyLevels.CUSTOMER, _messageResource2.default.getMessage("work_assignments.empty_customer_list", [this.state.userFirstName])), _defineProperty(_titlesMap, _constants.HierarchyLevels.PROJECT, _messageResource2.default.getMessage("work_assignments.empty_project_list", [this.state.userFirstName])), _defineProperty(_titlesMap, _constants.HierarchyLevels.TASK, _messageResource2.default.getMessage("work_assignments.empty_task_list", [this.state.userFirstName])), _defineProperty(_titlesMap, _constants2.ALL_TABS_EMPTY_KEY, _messageResource2.default.getMessage("work_assignments.empty_list.no_work_from_my_scope", [this.state.userFirstName])), _titlesMap),
                noSelectedTitlesMap: (_noSelectedTitlesMap = {}, _defineProperty(_noSelectedTitlesMap, _constants.HierarchyLevels.CUSTOMER, _messageResource2.default.getMessage("management_assignment.empty_customer_list", [this.state.userFirstName])), _defineProperty(_noSelectedTitlesMap, _constants.HierarchyLevels.PROJECT, _messageResource2.default.getMessage("management_assignment.no_selected_projects")), _defineProperty(_noSelectedTitlesMap, _constants.HierarchyLevels.TASK, _messageResource2.default.getMessage("management_assignment.no_selected_tasks")), _defineProperty(_noSelectedTitlesMap, _constants2.ALL_TABS_EMPTY_KEY, _messageResource2.default.getMessage("work_assignments.empty_list.assign_cpt")), _noSelectedTitlesMap),
                subtitlesAssignItemsMap: (_subtitlesAssignItems = {}, _defineProperty(_subtitlesAssignItems, _constants.HierarchyLevels.CUSTOMER, _messageResource2.default.getMessage("work_assignments.empty_customer_list.assign_customers", [this.state.userFirstName])), _defineProperty(_subtitlesAssignItems, _constants.HierarchyLevels.PROJECT, _messageResource2.default.getMessage("work_assignments.empty_project_list.assign_projects", [this.state.userFirstName])), _defineProperty(_subtitlesAssignItems, _constants.HierarchyLevels.TASK, _messageResource2.default.getMessage("work_assignments.empty_task_list.assign_tasks", [this.state.userFirstName])), _defineProperty(_subtitlesAssignItems, _constants2.ALL_TABS_EMPTY_KEY, _messageResource2.default.getMessage("work_assignments.empty_list.assign_cpt")), _subtitlesAssignItems),
                subtitlesAssignMoreItemsMap: (_subtitlesAssignMoreI = {}, _defineProperty(_subtitlesAssignMoreI, _constants.HierarchyLevels.CUSTOMER, _messageResource2.default.getMessage("work_assignments.empty_customer_list.assign_more_customers", [this.state.userFirstName])), _defineProperty(_subtitlesAssignMoreI, _constants.HierarchyLevels.PROJECT, _messageResource2.default.getMessage("work_assignments.empty_project_list.assign_more_projects", [this.state.userFirstName])), _defineProperty(_subtitlesAssignMoreI, _constants.HierarchyLevels.TASK, _messageResource2.default.getMessage("work_assignments.empty_task_list.assign_more_tasks", [this.state.userFirstName])), _defineProperty(_subtitlesAssignMoreI, _constants2.ALL_TABS_EMPTY_KEY, _messageResource2.default.getMessage("work_assignments.empty_list.assign_cpt")), _subtitlesAssignMoreI)
            });
        }
    }]);

    return WorkAssignmentPanelTabContent;
}(_TabContent3.default);

exports.default = WorkAssignmentPanelTabContent;

/***/ }),
/* 1738 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _CopyAssignmentsFromButton = __webpack_require__(557);

var _CopyAssignmentsFromButton2 = _interopRequireDefault(_CopyAssignmentsFromButton);

var _CopyUserSelector = __webpack_require__(397);

var _CopyUserSelector2 = _interopRequireDefault(_CopyUserSelector);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _CounterWithProgressBar = __webpack_require__(210);

var _CounterWithProgressBar2 = _interopRequireDefault(_CounterWithProgressBar);

var _constants = __webpack_require__(4);

var _redux = __webpack_require__(7);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _utils = __webpack_require__(6);

var _selectors = __webpack_require__(203);

var _selectors2 = __webpack_require__(14);

var _actions = __webpack_require__(211);

var _UserWithAccessRights = __webpack_require__(138);

var _UserWithAccessRights2 = _interopRequireDefault(_UserWithAccessRights);

var _SpinnerController = __webpack_require__(69);

var _SpinnerController2 = _interopRequireDefault(_SpinnerController);

var _selectors3 = __webpack_require__(15);

var _pluralizeUtils = __webpack_require__(40);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CopyContent = function (_TemplateView) {
    _inherits(CopyContent, _TemplateView);

    function CopyContent() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            _ref$onCancel = _ref.onCancel,
            onCancel = _ref$onCancel === undefined ? function () {} : _ref$onCancel,
            _ref$onSelectUser = _ref.onSelectUser,
            onSelectUser = _ref$onSelectUser === undefined ? function (userId) {} : _ref$onSelectUser,
            _ref$onCopy = _ref.onCopy,
            onCopy = _ref$onCopy === undefined ? function () {} : _ref$onCopy,
            _ref$onOptionSelected = _ref.onOptionSelected,
            onOptionSelected = _ref$onOptionSelected === undefined ? function (option) {} : _ref$onOptionSelected;

        _classCallCheck(this, CopyContent);

        var _this = _possibleConstructorReturn(this, (CopyContent.__proto__ || Object.getPrototypeOf(CopyContent)).call(this));

        _this.params = {
            onCancel: onCancel,
            onSelectUser: onSelectUser,
            onCopy: onCopy,
            onOptionSelected: onOptionSelected
        };

        _this.state = {
            userId: null,
            userFrom: null,
            userTo: null,
            viewer: null,

            loading: false,
            counters: {
                tasks: 0,
                projects: 0,
                customers: 0
            },
            isAllScopeToCopyUserFrom: false,
            isViewerHasEntireScope: true,

            selectedOption: null,

            users: [],
            ugrEnabled: true,
            userGroups: [],
            timeZoneGroups: [],
            tzgEnabled: true
        };

        _this.onStatePropertyChanged('userFrom', function (userFrom) {
            _this.copyAssignmentsButton.setState({
                selectedUser: userFrom
            });
        });

        _this.onAnyStatePropertyChanged(['users', 'userGroups', 'timeZoneGroups', 'ugrEnabled', 'tzgEnabled'], function () {
            var usersWithAccessRights = _this.state.users.map(function (userFrom) {
                return _UserWithAccessRights2.default.fromRPC(userFrom);
            });

            _this.copyUserSelector.setState({
                users: usersWithAccessRights,
                ugrEnabled: _this.state.ugrEnabled,
                userGroups: Object.values(_this.state.userGroups),
                tzgEnabled: _this.state.tzgEnabled,
                timeZoneGroups: Object.values(_this.state.timeZoneGroups)
            });
        });

        _this.onAnyStatePropertyChanged(['userId', 'counters', 'isAllScopeToCopyUserFrom'], function (state) {
            var userId = state.userId;
            var counters = state.counters;
            var isCopyEnabled = userId !== null;

            if (userId === null) {
                _this.find('.commentNote').empty();
            }

            _this.$taskCounter.toggle(!state.isAllScopeToCopyUserFrom);
            _this.$projectCounter.toggle(!state.isAllScopeToCopyUserFrom);
            _this.$customerCounter.toggle(!state.isAllScopeToCopyUserFrom);
            _this.$allScope.toggle(!!state.isAllScopeToCopyUserFrom);

            if (!state.isAllScopeToCopyUserFrom && counters) {
                _this.customerCounter.setState({
                    curValue: counters.customers,
                    maxValue: counters.customers,
                    title: _messageResource2.default.getMessage('userlist.work_assignments.active') + " " + (0, _pluralizeUtils.customerNameLower)(counters.customers),
                    active: counters.customers > 0
                });

                _this.projectCounter.setState({
                    curValue: counters.projects,
                    maxValue: counters.projects,
                    title: _messageResource2.default.getMessage('userlist.work_assignments.active') + " " + (0, _pluralizeUtils.projectNameLower)(counters.projects),
                    active: counters.projects > 0
                });

                _this.taskCounter.setState({
                    curValue: counters.tasks,
                    maxValue: counters.tasks,
                    title: _messageResource2.default.getMessage('userlist.work_assignments.open') + " " + (0, _pluralizeUtils.taskNameLower)(counters.tasks),
                    active: counters.tasks > 0
                });
            }

            _this.find('.radioSection .overwriteSection').toggleClass('disabled', !isCopyEnabled);
            _this.find('.radioSection .appendSection').toggleClass('disabled', !isCopyEnabled);
            _this.find('.radioSection .overwrite').prop('disabled', !isCopyEnabled);
            _this.find('.radioSection .append').prop('disabled', !isCopyEnabled);
            // TODO bakharev: not toggle element just hide it
            _this.find('.counters').toggle(isCopyEnabled);
        });

        _this.onStatePropertyChanged('isViewerHasEntireScope', function (isViewerHasEntireScope) {
            return _this.find('.counterSubtitle').toggle(!isViewerHasEntireScope);
        });

        _this.onStatePropertyChanged('selectedOption', function (option) {
            var selected = option !== null;
            _this.$copyButton.toggleClass('disabled', !selected);

            _this.find('.radioSection .overwrite').prop('checked', option === _constants.CopyWorkAssignmentOptions.OVERWRITE);
            _this.find('.radioSection .overwriteSection').toggleClass('selected', option === _constants.CopyWorkAssignmentOptions.OVERWRITE);
            _this.find('.radioSection .append').prop('checked', option === _constants.CopyWorkAssignmentOptions.APPEND);
            _this.find('.radioSection .appendSection').toggleClass('selected', option === _constants.CopyWorkAssignmentOptions.APPEND);
        });

        _this.onStatePropertyChanged('loading', function (loading) {
            if (loading) {
                _this.spinner.spinInElement(_this.$spinner);
            } else {
                _this.spinner.stop();
            }
        });

        _this.onAnyStatePropertyChanged(['selectedOption', 'userFrom'], function () {
            return _this._updateCommentNote();
        });
        return _this;
    }

    _createClass(CopyContent, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class="copyContent">' + '  <div class="title"><%-title%></div>' + '  <div class="userSelector"/>' + '  <div class="spinner"/>' + '  <div class="counters">' + '    <div class="title"><%-counterTitle%></div>' + '    <div class="customers"></div>' + '    <div class="projects"></div>' + '    <div class="tasks"></div>' + '    <div class="allScope"><%-entireScope%></div>' + '  </div>' + '  <div class="counterSubtitle"><%-counterSubtitle%></div>' + '  <div class="optionsTitle"><%-optionsTitle%></div>' + '  <div class="radioSection">' + '    <label>' + '        <div class="overwriteSection">' + '            <input type="radio" class="overwrite"/>' + '            <span><%-overwrite%></span>' + '        </div>' + '    </label>' + '    <label>' + '        <div class="appendSection">' + '            <input type="radio" class="append"/>' + '            <span><%-append%></span>' + '        </div>' + '    </label>' + '  </div>' + '  <div class="disableRadioChoose"/>' + '  <div class="commentNote"/>' + '  <div class="buttonsSection">' + '    <div class="copyButton"><%-copy%></div>' + '    <div class="cancelButton"><%-cancel%></div>' + '  </div>' + '</div>';
        }
    }, {
        key: 'templateModel',
        value: function templateModel() {
            return {
                title: _messageResource2.default.getMessage('work_assignments.panel.copy.title'),
                entireScope: _messageResource2.default.getMessage('user_list.table.manage_scope.entire_scope'),
                counterTitle: _messageResource2.default.getMessage('work_assignments.panel.copy.counter_title'),
                optionsTitle: _messageResource2.default.getMessage('work_assignments.panel.copy.options.title'),
                overwrite: _messageResource2.default.getMessage('work_assignments.panel.copy.options.overwrite'),
                append: _messageResource2.default.getMessage('work_assignments.panel.copy.options.append'),
                copy: _messageResource2.default.getMessage('common.copy'),
                cancel: _messageResource2.default.getMessage('common.cancel'),
                counterSubtitle: _messageResource2.default.getMessage('work_assignments.panel.copy.counters.subtitle')
            };
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            var _this2 = this;

            this.$userSelector = this.find('.userSelector');
            this.$countersSection = this.find('.counters');
            this.$allScope = this.find('.counters .allScope');
            this.$copyButton = this.find('.copyButton');
            this.$cancelButton = this.find('.cancelButton');

            this.$cancelButton.click(function () {
                _this2.find('.commentNote').empty();
                _this2.params.onCancel();
            });

            this.$copyButton.click(function () {
                if (_this2.state.selectedOption !== null) {
                    _this2.params.onCopy();
                }
            });

            this.copyUserSelector = new _CopyUserSelector2.default({
                title: _messageResource2.default.getMessage("user.add.js.copy_setting.selector.label"),
                selectionCallback: function selectionCallback(user) {
                    _this2.params.onSelectUser(user.id);
                    _this2.copyUserSelector.hide();
                },
                showPermissionIcons: false,
                renderTo: this.getEl()
            }).init();

            this.$customerCounter = this.find('.counters .customers');
            this.customerCounter = new _CounterWithProgressBar2.default({
                hierarchyLevel: _constants.HierarchyLevels.CUSTOMER
            }).init(this.$customerCounter);
            this.customerCounter.setState({ pale: true });

            this.$projectCounter = this.find('.counters .projects');
            this.projectCounter = new _CounterWithProgressBar2.default({
                hierarchyLevel: _constants.HierarchyLevels.PROJECT
            }).init(this.$projectCounter);
            this.projectCounter.setState({ pale: true });

            this.$taskCounter = this.find('.counters .tasks');
            this.taskCounter = new _CounterWithProgressBar2.default({
                hierarchyLevel: _constants.HierarchyLevels.TASK
            }).init(this.$taskCounter);
            this.taskCounter.setState({ pale: true });

            this.copyAssignmentsButton = new _CopyAssignmentsFromButton2.default().init(this.$userSelector);
            this.copyAssignmentsButton.bindClick(function () {
                return _this2.copyUserSelector.showAt(_this2.copyAssignmentsButton.$el, "t-b");
            });

            this.find('.radioSection .appendSection').change(function (e) {
                e.preventDefault();
                if (_this2._copyEnabled()) {
                    _this2.params.onOptionSelected(_constants.CopyWorkAssignmentOptions.APPEND);
                }
            });

            this.find('.radioSection .overwriteSection').change(function (e) {
                e.preventDefault();
                if (_this2._copyEnabled()) {
                    _this2.params.onOptionSelected(_constants.CopyWorkAssignmentOptions.OVERWRITE);
                }
            });

            this.$spinner = this.find('.spinner');
            this.spinner = new _SpinnerController2.default();

            this.renderInitialState();
        }
    }, {
        key: '_copyEnabled',
        value: function _copyEnabled() {
            return this.state.userId !== null;
        }
    }, {
        key: '_updateCommentNote',
        value: function _updateCommentNote() {
            if (this.state.userFrom && this.state.userTo) {

                var option = this.state.selectedOption;

                var userFromFirstName = this.state.userFrom.firstName;
                var userToFirstName = this.state.userTo.firstName;

                var $commentNote = this.find('.commentNote').empty();
                if (option === _constants.CopyWorkAssignmentOptions.OVERWRITE) {

                    if (this.state.isViewerHasEntireScope) {
                        $commentNote.append((0, _jquery2.default)('<div>' + _messageResource2.default.getEscapedMessage('work_assignments.panel.copy.options.overwrite.description_part1.with_entire_scope', [userFromFirstName, userToFirstName]) + '</div>' + '<div class="part2">' + _messageResource2.default.getMessage('work_assignments.panel.copy.options.overwrite.description_part2') + '</div>'));
                    } else {
                        $commentNote.append((0, _jquery2.default)('<div>' + _messageResource2.default.getMessage('work_assignments.panel.copy.options.overwrite.description_part1', [userFromFirstName, userToFirstName]) + '</div>' + '<div class="additionalText">' + _messageResource2.default.getMessage('work_assignments.panel.copy.options.overwrite.description_part2') + '</div>'));
                    }
                } else if (option === _constants.CopyWorkAssignmentOptions.APPEND) {
                    $commentNote.append((0, _jquery2.default)('<div>' + _messageResource2.default.getEscapedMessage('work_assignments.panel.copy.options.append.description', [userFromFirstName, userToFirstName]) + '</div>'));
                }
            }
        }
    }]);

    return CopyContent;
}(_TemplateView3.default);

exports.default = (0, _utils.connect)(function (state) {
    return {
        userId: (0, _selectors.getCopyUserId)(state),
        userFrom: (0, _selectors.getCopyUserFrom)(state),
        userTo: (0, _selectors.getPanelUserFML)(state),

        loading: (0, _selectors.isCopyLoading)(state),
        counters: (0, _selectors.getCopyUserCounters)(state),
        isAllScopeToCopyUserFrom: (0, _selectors.isCopyUserAllScope)(state),
        isViewerHasEntireScope: (0, _selectors.isViewerHasEntireScope)(state),
        selectedOption: (0, _selectors.getCopySelectedOption)(state),

        users: (0, _selectors.getSelectorsUsers)(state),
        ugrEnabled: (0, _selectors3.isUGREnabled)(state),
        userGroups: (0, _selectors2.getUserGroupsWithDefault)(state),
        tzgEnabled: (0, _selectors3.isTZGEnabled)(state),
        timeZoneGroups: (0, _selectors2.getTimeZoneGroups)(state)
    };
}, function (dispatch) {
    return {
        onSelectUser: (0, _redux.bindActionCreators)(_actions.loadUserCounters, dispatch),
        onCopy: (0, _redux.bindActionCreators)(_actions.copyAssignments, dispatch),
        onOptionSelected: (0, _redux.bindActionCreators)(_actions.setCopyOption, dispatch)
    };
})(CopyContent);

/***/ }),
/* 1739 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _ActionButton = __webpack_require__(900);

var _ActionButton2 = _interopRequireDefault(_ActionButton);

var _DropdownActionMenu = __webpack_require__(1740);

var _DropdownActionMenu2 = _interopRequireDefault(_DropdownActionMenu);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @author makovchik.
 * @since 16.08.2018.
 */
var ActionsMenuButtons = function (_TemplateView) {
    _inherits(ActionsMenuButtons, _TemplateView);

    function ActionsMenuButtons(_ref) {
        var _ref$actions = _ref.actions,
            actions = _ref$actions === undefined ? [] : _ref$actions;

        _classCallCheck(this, ActionsMenuButtons);

        var _this = _possibleConstructorReturn(this, (ActionsMenuButtons.__proto__ || Object.getPrototypeOf(ActionsMenuButtons)).call(this));

        _this.params = {
            actions: actions
        };
        return _this;
    }

    _createClass(ActionsMenuButtons, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return "<div class='actionButtonWrapper'>" + "  <div class='actionButton'>" + "    <div class='img'></div>" + "    <div class='action'><%-actionsTitle%></div>" + "  </div>" + "  <div class='buttonMenu'/>" + "</div>";
        }
    }, {
        key: 'templateModel',
        value: function templateModel() {
            return {
                actionsTitle: _messageResource2.default.getMessage('edit_panel.actions.title')
            };
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            var actions = this.params.actions;
            this.buttonMenu = new _DropdownActionMenu2.default({ actions: actions }).init(this.find('.buttonMenu'));

            this.find('.actionButton').click(this.openDropdownMenu.bind(this));
        }
    }, {
        key: 'openDropdownMenu',
        value: function openDropdownMenu() {
            this.buttonMenu.showAt(this.$el);
        }
    }]);

    return ActionsMenuButtons;
}(_TemplateView3.default);

exports.default = ActionsMenuButtons;

/***/ }),
/* 1740 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _DropdownTemplateView2 = __webpack_require__(42);

var _DropdownTemplateView3 = _interopRequireDefault(_DropdownTemplateView2);

var _ActionButton = __webpack_require__(900);

var _ActionButton2 = _interopRequireDefault(_ActionButton);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @author makovchik.
 * @since 17.08.2018.
 */
var DropdownActionMenu = function (_DropdownTemplateView) {
    _inherits(DropdownActionMenu, _DropdownTemplateView);

    function DropdownActionMenu(_ref) {
        var _ref$actions = _ref.actions,
            actions = _ref$actions === undefined ? [] : _ref$actions;

        _classCallCheck(this, DropdownActionMenu);

        var _this = _possibleConstructorReturn(this, (DropdownActionMenu.__proto__ || Object.getPrototypeOf(DropdownActionMenu)).call(this));

        _this.params = {
            actions: actions
        };
        return _this;
    }

    _createClass(DropdownActionMenu, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return "<div class='dropdownContainer addNewMenu'>" + "</div>";
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            var _this2 = this;

            this.params.actions.forEach(function (value) {
                new _ActionButton2.default({
                    title: value.title,
                    extraClass: value.extraClass,
                    actionClick: value.actionClick,
                    hideMenu: _this2.hide.bind(_this2)
                }).init(_this2.$el);
            });
        }
    }, {
        key: 'mouseDownTargetElement',
        value: function mouseDownTargetElement() {
            return (0, _jquery2.default)('body');
        }
    }]);

    return DropdownActionMenu;
}(_DropdownTemplateView3.default);

exports.default = DropdownActionMenu;

/***/ }),
/* 1741 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _utils = __webpack_require__(6);

var _selectors = __webpack_require__(203);

var _actions = __webpack_require__(211);

var _redux = __webpack_require__(7);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _CounterWithProgressBar = __webpack_require__(210);

var _CounterWithProgressBar2 = _interopRequireDefault(_CounterWithProgressBar);

var _constants = __webpack_require__(4);

var _selectors2 = __webpack_require__(53);

var _SpinnerController = __webpack_require__(69);

var _SpinnerController2 = _interopRequireDefault(_SpinnerController);

var _pluralizeUtils = __webpack_require__(40);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @author makovchik.
 * @since 14.08.2018.
 */
var AssignAllScopeContent = function (_TemplateView) {
    _inherits(AssignAllScopeContent, _TemplateView);

    function AssignAllScopeContent() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            _ref$onCopy = _ref.onCopy,
            onCopy = _ref$onCopy === undefined ? function () {} : _ref$onCopy,
            _ref$onCancel = _ref.onCancel,
            onCancel = _ref$onCancel === undefined ? function () {} : _ref$onCancel;

        _classCallCheck(this, AssignAllScopeContent);

        var _this = _possibleConstructorReturn(this, (AssignAllScopeContent.__proto__ || Object.getPrototypeOf(AssignAllScopeContent)).call(this));

        _this.params = {
            onCopy: onCopy,
            onCancel: onCancel
        };

        _this.state = {
            userFirstName: '',
            loading: false,
            counters: {
                tasks: 0,
                projects: 0,
                customers: 0
            }
        };

        _this.onStatePropertyChanged('userFirstName', function (name) {

            _this.$title.text(_messageResource2.default.getMessage('work_assignments.panel.all.assignments.title', [name]));
            _this.$subtitle.text(_messageResource2.default.getMessage('work_assignments.panel.all.assignments.subtitle', [name]));
        });

        _this.onStatePropertyChanged('counters', function (state) {

            _this.customerCounter.setState({
                curValue: state.customers,
                maxValue: state.customers,
                title: _messageResource2.default.getMessage('userlist.work_assignments.active') + " " + (0, _pluralizeUtils.customerNameLower)(state.customers),
                active: state.customers > 0,
                pale: state.customers === 0
            });

            _this.projectCounter.setState({
                curValue: state.projects,
                maxValue: state.projects,
                title: _messageResource2.default.getMessage('userlist.work_assignments.active') + " " + (0, _pluralizeUtils.projectNameLower)(state.projects),
                active: state.projects > 0,
                pale: state.projects === 0
            });

            _this.taskCounter.setState({
                curValue: state.tasks,
                maxValue: state.tasks,
                title: _messageResource2.default.getMessage('userlist.work_assignments.open') + " " + (0, _pluralizeUtils.taskNameLower)(state.tasks),
                active: state.tasks > 0,
                pale: state.tasks === 0
            });
        });

        _this.onStatePropertyChanged('loading', function (loading) {
            if (loading) {
                _this.spinner.spinInElement(_this.$spinner);
            } else {
                _this.spinner.stop();
            }
        });
        return _this;
    }

    _createClass(AssignAllScopeContent, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class="copyContent">' + '  <div class="title"></div>' + '  <div class="subtitle"></div>' + '  <div class="spinner"/>' + '  <div class="counters">' + '    <div class="customers"></div>' + '    <div class="projects"></div>' + '    <div class="tasks"></div>' + '  </div>' + '  <div class="buttonsSection">' + '    <div class="copyButton"><%-accept%></div>' + '    <div class="cancelButton"><%-cancel%></div>' + '  </div>' + '</div>';
        }
    }, {
        key: 'templateModel',
        value: function templateModel() {
            return {
                accept: _messageResource2.default.getMessage('common.assign'),
                cancel: _messageResource2.default.getMessage('common.cancel')
            };
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            var _this2 = this;

            this.$copyButton = this.find('.copyButton');
            this.$cancelButton = this.find('.cancelButton');
            this.$title = this.find('.title');
            this.$subtitle = this.find('.subtitle');

            this.$cancelButton.click(function () {
                _this2.params.onCancel();
            });

            this.$copyButton.click(function () {
                _this2.params.onCopy();
            });

            this.$customerCounter = this.find('.counters .customers');
            this.customerCounter = new _CounterWithProgressBar2.default({
                hierarchyLevel: _constants.HierarchyLevels.CUSTOMER
            }).init(this.$customerCounter);
            this.$projectCounter = this.find('.counters .projects');
            this.projectCounter = new _CounterWithProgressBar2.default({
                hierarchyLevel: _constants.HierarchyLevels.PROJECT
            }).init(this.$projectCounter);
            this.$taskCounter = this.find('.counters .tasks');
            this.taskCounter = new _CounterWithProgressBar2.default({
                hierarchyLevel: _constants.HierarchyLevels.TASK
            }).init(this.$taskCounter);

            this.$spinner = this.find('.spinner');
            this.spinner = new _SpinnerController2.default();

            this.renderInitialState();
        }
    }]);

    return AssignAllScopeContent;
}(_TemplateView3.default);

exports.default = (0, _utils.connect)(function (state) {
    return {
        userFirstName: (0, _selectors.getPanelUserFirstName)(state),
        loading: (0, _selectors.isAssignAllScopeContentLoading)(state),
        counters: (0, _selectors2.getViewerManagementCounters)(state)
    };
}, function (dispatch) {
    return {
        onCopy: (0, _redux.bindActionCreators)(_actions.assignAllWorkAssignments, dispatch)
    };
})(AssignAllScopeContent);

/***/ }),
/* 1742 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.LicenseContainer = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _View2 = __webpack_require__(20);

var _View3 = _interopRequireDefault(_View2);

var _utils = __webpack_require__(6);

var _selectors = __webpack_require__(53);

var _Counter = __webpack_require__(1743);

var _Counter2 = _interopRequireDefault(_Counter);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _utils2 = __webpack_require__(202);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LicenseContainer = exports.LicenseContainer = function (_View) {
    _inherits(LicenseContainer, _View);

    function LicenseContainer() {
        _classCallCheck(this, LicenseContainer);

        var _this = _possibleConstructorReturn(this, (LicenseContainer.__proto__ || Object.getPrototypeOf(LicenseContainer)).call(this));

        _this._counterIsVisible = function () {
            var canManageAccountsSettings = _this.state.canManageAccountsSettings;

            return canManageAccountsSettings && !(0, _utils2.isLicenseUnlimited)(_this.state.licenseCounters);
        };

        _this._createLicenseCounterText = function () {
            var _this$state$licenseCo = _this.state.licenseCounters,
                extraUsersCount = _this$state$licenseCo.extraUsersCount,
                remainingCount = _this$state$licenseCo.remainingCount;

            var text = void 0;
            if ((0, _utils2.isLicenseViolated)(_this.state.licenseCounters)) {
                text = _messageResource2.default.getMessage(extraUsersCount === 1 ? "userlist.license.disable_user" : "userlist.license.disable_users", [extraUsersCount]);
            } else {
                var remainingCountText = (0, _utils2.haveMoreLicenses)(_this.state.licenseCounters) ? remainingCount : _messageResource2.default.getMessage("userlist.pagebody.no_licenses_left");

                text = _messageResource2.default.getMessage(remainingCount === 1 ? "userlist.pagebody.license_left" : "userlist.pagebody.licenses_left", [remainingCountText]);
            }

            return text;
        };

        _this._isLicenseWithWarning = function () {
            return !(0, _utils2.isLicenseUnlimited)(_this.state.licenseCounters) && !(0, _utils2.haveMoreLicenses)(_this.state.licenseCounters);
        };

        _this.state = {
            canManageAccountsSettings: false,
            licenseCounters: {
                actualCount: 0,
                allowedCount: 0,
                extraUsersCount: 0,
                licenseViolated: false,
                remainingCount: 1
            }
        };

        _this.onStateChanged(function () {
            if (_this._counterIsVisible()) {
                _this.counter.show();

                _this.counter.setState({
                    withWarning: _this._isLicenseWithWarning(),
                    text: _this._createLicenseCounterText()
                });
            } else {
                _this.counter.hide();
            }
        });
        return _this;
    }

    _createClass(LicenseContainer, [{
        key: 'afterRender',
        value: function afterRender() {
            this.counter = new _Counter2.default().init(this.$containerEl);
        }
    }]);

    return LicenseContainer;
}(_View3.default);

exports.default = (0, _utils.connect)(function (state) {
    return {
        canManageAccountsSettings: (0, _selectors.isAllowedToManageAccountSettings)(state),
        licenseCounters: (0, _selectors.getLicenseCounters)(state)
    };
})(LicenseContainer);

/***/ }),
/* 1743 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Counter = function (_TemplateView) {
    _inherits(Counter, _TemplateView);

    function Counter() {
        _classCallCheck(this, Counter);

        var _this = _possibleConstructorReturn(this, (Counter.__proto__ || Object.getPrototypeOf(Counter)).call(this));

        _this.state = {
            text: '',
            withWarning: false
        };

        _this.onStatePropertyChanged('text', function () {
            _this.$el.text(_this.state.text);
        });

        _this.onStatePropertyChanged('withWarning', function () {
            _this.$el.toggleClass('withWarning', _this.state.withWarning);
        });
        return _this;
    }

    _createClass(Counter, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class="userManagement_licenseCounter">' + '</div>';
        }
    }]);

    return Counter;
}(_TemplateView3.default);

exports.default = Counter;

/***/ }),
/* 1744 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _redux = __webpack_require__(7);

var _actions = __webpack_require__(207);

var _utils = __webpack_require__(6);

var _ManagementAssignmentsPanel = __webpack_require__(886);

var _ManagementAssignmentsPanel2 = _interopRequireDefault(_ManagementAssignmentsPanel);

var _selectors = __webpack_require__(204);

var _selectors2 = __webpack_require__(146);

var _ManagementAssignmentsPanelContent = __webpack_require__(1745);

var _ManagementAssignmentsPanelContent2 = _interopRequireDefault(_ManagementAssignmentsPanelContent);

var _utils2 = __webpack_require__(25);

var _actions2 = __webpack_require__(50);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EditManagementAssignmentsPanel = function (_ManagementAssignment) {
    _inherits(EditManagementAssignmentsPanel, _ManagementAssignment);

    function EditManagementAssignmentsPanel(params) {
        var _this;

        _classCallCheck(this, EditManagementAssignmentsPanel);

        var panelContent = new _ManagementAssignmentsPanelContent2.default({
            onBackButtonClick: function onBackButtonClick() {
                return _this.params.onPanelHide();
            },
            onCloseButtonClick: function onCloseButtonClick() {
                return params.closeAllPanels();
            },
            onClickDialogContent: function onClickDialogContent(e) {
                return (0, _utils2.setEventPreventHidingEditUserSlidingPanel)(e);
            }
        });
        return _this = _possibleConstructorReturn(this, (EditManagementAssignmentsPanel.__proto__ || Object.getPrototypeOf(EditManagementAssignmentsPanel)).call(this, _extends({}, params, {
            additionalClass: 'editManagementAssignmentsPanel',
            panelContent: panelContent
        })));
    }

    return EditManagementAssignmentsPanel;
}(_ManagementAssignmentsPanel2.default);

exports.default = (0, _utils.connect)(function (state) {
    return {
        userPanelOpenedBelow: (0, _selectors2.isPanelOpened)(state),
        needToLoadData: (0, _selectors.isNeedToLoadData)(state),
        isShown: (0, _selectors.isPanelOpened)(state),
        loading: (0, _selectors.isLoading)(state)
    };
}, function (dispatch) {
    return {
        loadData: (0, _redux.bindActionCreators)(_actions.loadManagementAssignmentPanelDataAction, dispatch),
        onPanelHide: (0, _redux.bindActionCreators)(_actions.closePanel, dispatch),
        closeAllPanels: (0, _redux.bindActionCreators)(_actions2.closeAllPanels, dispatch)
    };
})(EditManagementAssignmentsPanel);

/***/ }),
/* 1745 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _redux = __webpack_require__(7);

var _selectors = __webpack_require__(204);

var _utils = __webpack_require__(6);

var _ManagementAssignmentsPanelContent = __webpack_require__(887);

var _ManagementAssignmentsPanelContent2 = _interopRequireDefault(_ManagementAssignmentsPanelContent);

var _actions = __webpack_require__(207);

var _actions2 = __webpack_require__(258);

var _TabContent = __webpack_require__(1746);

var _TabContent2 = _interopRequireDefault(_TabContent);

var _selectors2 = __webpack_require__(64);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EditManagementAssignmentsPanelContent = function (_ManagementAssignment) {
    _inherits(EditManagementAssignmentsPanelContent, _ManagementAssignment);

    function EditManagementAssignmentsPanelContent(params) {
        _classCallCheck(this, EditManagementAssignmentsPanelContent);

        var tabContent = new _TabContent2.default();

        return _possibleConstructorReturn(this, (EditManagementAssignmentsPanelContent.__proto__ || Object.getPrototypeOf(EditManagementAssignmentsPanelContent)).call(this, _extends({}, params, {
            tabContent: tabContent
        })));
    }

    return EditManagementAssignmentsPanelContent;
}(_ManagementAssignmentsPanelContent2.default);

exports.default = (0, _utils.connect)(function (state) {
    return {
        managementAssignmentsSelection: (0, _selectors.getManagementAssignmentsSelection)(state),
        userFML: (0, _selectors.getPanelUserFML)(state),
        counters: (0, _selectors2.getManagementAssignmentsCounters)(state),
        openTab: (0, _selectors.getTab)(state),
        showCopyContent: (0, _selectors.isShowCopyContent)(state),
        copyContentLoading: (0, _selectors.isCopyLoading)(state)
    };
}, function (dispatch) {
    return {
        onManagementAssignmentsSelectionChange: (0, _redux.bindActionCreators)(_actions.changeManagementAssignmentsSelection, dispatch),
        openEditorPanel: (0, _redux.bindActionCreators)(_actions2.openEditor, dispatch),
        onPanelHide: (0, _redux.bindActionCreators)(_actions.closePanel, dispatch),
        onTabChanged: (0, _redux.bindActionCreators)(_actions.changeAssignmentPanelTab, dispatch),
        onCopyFromButtonClick: (0, _redux.bindActionCreators)(_actions.showCopyContent, dispatch)
    };
})(EditManagementAssignmentsPanelContent);

/***/ }),
/* 1746 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _utils = __webpack_require__(6);

var _redux = __webpack_require__(7);

var _selectors = __webpack_require__(204);

var _actions = __webpack_require__(207);

var _ManagementAssignmentPanelTabContent = __webpack_require__(889);

var _ManagementAssignmentPanelTabContent2 = _interopRequireDefault(_ManagementAssignmentPanelTabContent);

var _actions2 = __webpack_require__(258);

var _selectors2 = __webpack_require__(15);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _utils.connect)(function (state) {
    return {
        userFirstName: (0, _selectors.getPanelUserFirstName)(state),
        counters: (0, _selectors.getCounters)(state),

        searchString: (0, _selectors.getSearch)(state),
        searchOpen: (0, _selectors.isSearchOpen)(state),

        entirelyAssignedTasksCounter: (0, _selectors.getEntirelyAssignedTasksCounter)(state),
        entirelyAssignedProjectsCounter: (0, _selectors.getEntirelyAssignedProjectCounter)(state),

        customerEntities: (0, _selectors.selectCustomerEntities)(state),
        projectEntities: (0, _selectors.selectProjectEntities)(state),
        taskEntities: (0, _selectors.selectTaskEntities)(state),

        isShowArchivedEntities: (0, _selectors.isShowArchivedEntities)(state),

        openTab: (0, _selectors.getTab)(state),

        isWASEnabled: (0, _selectors2.isWASEnabled)(state)
    };
}, function (dispatch) {
    return {
        onSearchChanged: (0, _redux.bindActionCreators)(_actions.setSearchString, dispatch),
        onSearchToggled: (0, _redux.bindActionCreators)(_actions.setSearchOpen, dispatch),

        onEntityRevoked: (0, _redux.bindActionCreators)(_actions.revokeEntitiesAction, dispatch),
        onAllRevoked: (0, _redux.bindActionCreators)(_actions.revokeAllTypeAction, dispatch),

        setIsShowArchiveEntities: (0, _redux.bindActionCreators)(_actions.setIsShowArchiveEntities, dispatch),
        onEditButtonClick: (0, _redux.bindActionCreators)(_actions2.openEditor, dispatch)
    };
})(_ManagementAssignmentPanelTabContent2.default);

/***/ }),
/* 1747 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.updateTimeZoneGroups = exports.updateDepartments = exports.updateUsersTimeZoneGroups = exports.updateUsersGroups = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _selectors = __webpack_require__(14);

var _actions = __webpack_require__(29);

var _selectors2 = __webpack_require__(53);

var _actions2 = __webpack_require__(50);

var _constants = __webpack_require__(4);

var updateUsersGroups = exports.updateUsersGroups = function updateUsersGroups(userIdGroupIdMap) {
    return function (dispatch, getState) {
        var state = getState();
        var entitiesUsers = (0, _selectors.getUsers)(state);
        var usersList = (0, _selectors2.getUsersList)(state);
        dispatch((0, _actions.addUsers)(Object.values(entitiesUsers).map(function (user) {
            return _extends({}, user, { userGroupId: userIdGroupIdMap[user.id] });
        })));
        dispatch((0, _actions2.addNewUsersToList)(Object.values(usersList).map(function (user) {
            return _extends({}, user, { userGroupId: userIdGroupIdMap[user.id] });
        })));
    };
};

var updateUsersTimeZoneGroups = exports.updateUsersTimeZoneGroups = function updateUsersTimeZoneGroups(userIdGroupIdMap) {
    return function (dispatch, getState) {
        var state = getState();
        var entitiesUsers = (0, _selectors.getUsers)(state);
        var usersList = (0, _selectors2.getUsersList)(state);
        dispatch((0, _actions.addUsers)(Object.values(entitiesUsers).map(function (user) {
            return _extends({}, user, { timeZoneGroupId: userIdGroupIdMap[user.id] });
        })));
        dispatch((0, _actions2.addNewUsersToList)(Object.values(usersList).map(function (user) {
            return _extends({}, user, { timeZoneGroupId: userIdGroupIdMap[user.id] });
        })));
    };
};

var updateDepartments = exports.updateDepartments = function updateDepartments(departments) {
    return function (dispatch) {
        var departmentsInfo = departments.filter(function (d) {
            return d.getId() !== _constants.USERS_WITHOUT_GROUP_ID;
        }).map(function (d) {
            return {
                id: d.getId(),
                name: d.getName()
            };
        });

        dispatch((0, _actions.setUserGroupsList)(departmentsInfo));
    };
};

var updateTimeZoneGroups = exports.updateTimeZoneGroups = function updateTimeZoneGroups(timeZoneGroups) {
    return function (dispatch) {
        var tzgInfo = timeZoneGroups.filter(function (g) {
            return g.id !== _constants.USERS_WITHOUT_GROUP_ID;
        }).map(function (g) {
            return {
                id: g.id,
                name: g.name,
                rawOffset: g.rawOffset
            };
        });

        dispatch((0, _actions.setTimeZoneGroupsList)(timeZoneGroups));
    };
};

/***/ }),
/* 1748 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _TeamAssignmentsPanelContainer = __webpack_require__(893);

var _TeamAssignmentsPanelContainer2 = _interopRequireDefault(_TeamAssignmentsPanelContainer);

var _selectors = __webpack_require__(15);

var _selectors2 = __webpack_require__(895);

var _actions = __webpack_require__(403);

var _utils = __webpack_require__(6);

var _redux = __webpack_require__(7);

var _selectors3 = __webpack_require__(313);

var _actions2 = __webpack_require__(50);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EditTeamAssignmentsPanel = function (_TeamAssignmentsPanel) {
    _inherits(EditTeamAssignmentsPanel, _TeamAssignmentsPanel);

    function EditTeamAssignmentsPanel(params) {
        _classCallCheck(this, EditTeamAssignmentsPanel);

        return _possibleConstructorReturn(this, (EditTeamAssignmentsPanel.__proto__ || Object.getPrototypeOf(EditTeamAssignmentsPanel)).call(this, _extends({
            additionalClass: 'editTeamAssignmentsPanel'
        }, params)));
    }

    return EditTeamAssignmentsPanel;
}(_TeamAssignmentsPanelContainer2.default);

exports.default = (0, _utils.connect)(function (state) {
    return {
        isShown: (0, _selectors3.isPanelOpened)(state),
        userPanelOpenedBelow: (0, _selectors2.isEditUserPanelOpened)(state),
        needToLoadData: (0, _selectors3.isNeedToLoadData)(state),
        loading: (0, _selectors2.isLoading)(state),
        disabled: (0, _selectors2.isUpdatingData)(state),

        assignedUserIds: (0, _selectors2.getAssignedUserIds)(state),
        assignedGroupIds: (0, _selectors2.getAssignedGroupIds)(state),
        users: (0, _selectors2.getUsers)(state),
        userGroups: (0, _selectors2.getUserGroups)(state),
        isUGREnabled: (0, _selectors.isUGREnabled)(state),
        teamAssignmentType: (0, _selectors2.getTeamAssignmentType)(state),
        userFML: (0, _selectors2.getUserFML)(state),
        userId: (0, _selectors3.getUserId)(state),

        showCopyContent: (0, _selectors3.isShowCopyContent)(state),
        copyContentLoading: (0, _selectors3.isCopyLoading)(state)
    };
}, function (dispatch) {
    return {
        onPanelHide: (0, _redux.bindActionCreators)(_actions.closeTeamAssignmentsPanel, dispatch),
        onCloseButtonClick: (0, _redux.bindActionCreators)(_actions2.closeAllPanels, dispatch),
        changeTeamAssignments: (0, _redux.bindActionCreators)(_actions.changeTeamAssignmentsData, dispatch),
        loadTeamAssignmentsData: (0, _redux.bindActionCreators)(_actions.loadTeamAssignmentsData, dispatch),
        showCopyContent: (0, _redux.bindActionCreators)(_actions.showCopyContent, dispatch)
    };
})(EditTeamAssignmentsPanel);

/***/ }),
/* 1749 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _utils = __webpack_require__(6);

var _ClassicBridge = __webpack_require__(18);

var _ClassicBridge2 = _interopRequireDefault(_ClassicBridge);

var _selectors = __webpack_require__(53);

var _UserInfoRepository = __webpack_require__(1750);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ExportUsersDropdown = function (_TemplateView) {
    _inherits(ExportUsersDropdown, _TemplateView);

    function ExportUsersDropdown() {
        _classCallCheck(this, ExportUsersDropdown);

        var _this = _possibleConstructorReturn(this, (ExportUsersDropdown.__proto__ || Object.getPrototypeOf(ExportUsersDropdown)).call(this, null));

        _this.state = {
            filter: {},
            tokens: [],
            userListOrder: {},
            userCount: 0,
            balanceHoursPerDay: 0,
            isAccountSettingsVisible: false,
            isPtoVisible: false,
            isSickDaysVisible: false,
            isDisabled: false
        };

        _this.userInfoRepository = new _UserInfoRepository.UserInfoRepository();

        _this.onStatePropertyChanged('filter', function (filter) {
            _this.userInfoRepository.updateFilter(filter);
        });

        _this.onStatePropertyChanged('tokens', function (tokens) {
            _this.userInfoRepository.updateTokens(tokens);
        });

        _this.onStatePropertyChanged('userListOrder', function (userListOrder) {
            _this.userInfoRepository.updateUserListOrder(userListOrder);
        });

        _this.onStatePropertyChanged('userCount', function (userCount) {
            _this.userInfoRepository.updateUserCount(userCount);
        });

        _this.onStatePropertyChanged('balanceHoursPerDay', function (balanceHoursPerDay) {
            _this.userInfoRepository.updateBalanceHoursPerDay(balanceHoursPerDay);
        });

        _this.onStatePropertyChanged('isAccountSettingsVisible', function (isAccountSettingsVisible) {
            _this.exportCPDropdown.setProps({ isAccountSettingsVisible: isAccountSettingsVisible });
        });

        _this.onStatePropertyChanged('isSickDaysVisible', function (isSickDaysVisible) {
            _this.exportCPDropdown.setProps({ isSickDaysVisible: isSickDaysVisible });
        });

        _this.onStatePropertyChanged('isPtoVisible', function (isPtoVisible) {
            _this.exportCPDropdown.setProps({ isPtoVisible: isPtoVisible });
        });

        _this.onStatePropertyChanged('isDisabled', function (isDisabled) {
            _this.exportCPDropdown.setProps({ isDisabled: isDisabled });
        });
        return _this;
    }

    _createClass(ExportUsersDropdown, [{
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='atNextMount exportUsersMount'></div>";
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            this.exportCPDropdown = _ClassicBridge2.default.integrateExportUsersDropdown(this.$el[0], {
                classicUserInfosRepository: this.userInfoRepository
            });
        }
    }]);

    return ExportUsersDropdown;
}(_TemplateView3.default);

exports.default = (0, _utils.connect)(function (state) {
    return {
        isAccountSettingsVisible: (0, _selectors.isAccountSettingsTabVisible)(state),
        isPtoVisible: (0, _selectors.isPTOTabVisible)(state),
        isSickDaysVisible: (0, _selectors.isSDBTabVisible)(state)
    };
})(ExportUsersDropdown);

/***/ }),
/* 1750 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.UserInfoRepository = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery_rpc = __webpack_require__(26);

var _jquery_rpc2 = _interopRequireDefault(_jquery_rpc);

var _AccrualRulesCell = __webpack_require__(544);

var _AccrualRulesCell2 = _interopRequireDefault(_AccrualRulesCell);

var _ResetRulesCell = __webpack_require__(543);

var _ResetRulesCell2 = _interopRequireDefault(_ResetRulesCell);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var USER_BATCH_SIZE = 500;

var UserInfoRepository = exports.UserInfoRepository = function () {
    function UserInfoRepository() {
        _classCallCheck(this, UserInfoRepository);

        this.userListOrder = {};
        this.filter = {};
        this.tokens = [];
        this.userCount = 0;
        this.balanceHoursPerDay = 0;
    }

    _createClass(UserInfoRepository, [{
        key: 'updateUserListOrder',
        value: function updateUserListOrder(userListOrder) {
            this.userListOrder = userListOrder;
        }
    }, {
        key: 'updateFilter',
        value: function updateFilter(filter) {
            this.filter = filter;
        }
    }, {
        key: 'updateTokens',
        value: function updateTokens(tokens) {
            this.tokens = tokens;
        }
    }, {
        key: 'updateUserCount',
        value: function updateUserCount(userCount) {
            this.userCount = userCount;
        }
    }, {
        key: 'updateBalanceHoursPerDay',
        value: function updateBalanceHoursPerDay(balanceHoursPerDay) {
            this.balanceHoursPerDay = balanceHoursPerDay;
        }
    }, {
        key: '_convertUserToInfo',
        value: function _convertUserToInfo(user, ptoDefaults, sickDaysDefaults) {
            var currentPtoBalance = null;
            var plannedPtoBalanceApproved = null;
            var isDefaultPtoRule = null;
            var ptoAccrualRule = null;
            var ptoResetRule = null;
            var ptoLimit = null;

            var currentSickDaysBalance = null;
            var plannedSickDaysBalanceApproved = null;
            var isDefaultSickDaysRule = null;
            var sickDaysAccrualRule = null;
            var sickDaysResetRule = null;
            var sickDaysLimit = null;

            var ptoFormatter = new PTOFormatter().init(this.balanceHoursPerDay, SystemSettings.roundPTOBalanceOnUserlist);
            var ptoAccrualRuleFormatter = new _AccrualRulesCell2.default().init(function (value) {
                return ptoFormatter.format(value);
            }, {});
            var ptoResetRuleFormatter = new _ResetRulesCell2.default().init(function (value) {
                return ptoFormatter.format(value);
            }, {});

            var sickDaysBalanceFormatter = new SickFormatter().init(this.balanceHoursPerDay, SystemSettings.roundSickBalanceOnUserlist);
            var sickDaysAccrualRuleFormatter = new _AccrualRulesCell2.default().init(function (value) {
                return sickDaysBalanceFormatter.format(value);
            }, {});
            var sickDaysResetRuleFormatter = new _ResetRulesCell2.default().init(function (value) {
                return sickDaysBalanceFormatter.format(value);
            }, {});

            if (user.currentPTOBalance && user.currentPTOBalance.balance !== undefined) {
                currentPtoBalance = ptoFormatter.format(user.currentPTOBalance.balance);
            }

            if (user.currentPTOBalance && user.currentPTOBalance.plannedBalanceApproved !== undefined) {
                plannedPtoBalanceApproved = ptoFormatter.format(user.currentPTOBalance.plannedBalanceApproved);
            }

            if (user.currentPTOBalance && user.currentPTOBalance.defaultRules !== undefined) {
                isDefaultPtoRule = user.currentPTOBalance.defaultRules;
            }

            if (user.currentPTOBalance && user.currentPTOBalance.accrualRule) {
                ptoAccrualRule = ptoAccrualRuleFormatter._getRuleValue(user.currentPTOBalance);
            }

            if (user.currentPTOBalance && user.currentPTOBalance.resetRule) {
                ptoResetRule = ptoResetRuleFormatter._getRuleValue(user.currentPTOBalance);
            }

            if (user.currentPTOBalance && user.currentPTOBalance.balanceCap) {
                ptoLimit = ptoFormatter.format(user.currentPTOBalance.balanceCap);
            }

            if (isDefaultPtoRule && ptoDefaults) {
                ptoAccrualRule = ptoAccrualRuleFormatter._getRuleValue(ptoDefaults);
                ptoResetRule = ptoResetRuleFormatter._getRuleValue(ptoDefaults);
                ptoLimit = ptoFormatter.format(ptoDefaults.balanceCap);
            }

            if (user.currentSickDaysBalance && user.currentSickDaysBalance.balance !== undefined) {
                currentSickDaysBalance = sickDaysBalanceFormatter.format(user.currentSickDaysBalance.balance);
            }

            if (user.currentSickDaysBalance && user.currentSickDaysBalance.plannedBalanceApproved !== undefined) {
                plannedSickDaysBalanceApproved = sickDaysBalanceFormatter.format(user.currentSickDaysBalance.plannedBalanceApproved);
            }

            if (user.currentSickDaysBalance && user.currentSickDaysBalance.defaultRules !== undefined) {
                isDefaultSickDaysRule = user.currentSickDaysBalance.defaultRules;
            }

            if (user.currentSickDaysBalance && user.currentSickDaysBalance.accrualRule) {
                sickDaysAccrualRule = sickDaysAccrualRuleFormatter._getRuleValue(user.currentSickDaysBalance);
            }

            if (user.currentSickDaysBalance && user.currentSickDaysBalance.resetRule) {
                sickDaysResetRule = sickDaysResetRuleFormatter._getRuleValue(user.currentSickDaysBalance);
            }

            if (user.currentSickDaysBalance && user.currentSickDaysBalance.balanceCap) {
                sickDaysLimit = sickDaysBalanceFormatter.format(user.currentSickDaysBalance.balanceCap);
            }

            if (isDefaultSickDaysRule && sickDaysDefaults) {
                sickDaysAccrualRule = sickDaysAccrualRuleFormatter._getRuleValue(sickDaysDefaults);
                sickDaysResetRule = sickDaysResetRuleFormatter._getRuleValue(sickDaysDefaults);
                sickDaysLimit = sickDaysBalanceFormatter.format(sickDaysDefaults.balanceCap);
            }

            return {
                id: user.id,
                isPtoOn: user.currentPTOBalance,
                currentPtoBalance: currentPtoBalance,
                plannedPtoBalanceApproved: plannedPtoBalanceApproved,
                isDefaultPtoRule: isDefaultPtoRule,
                ptoAccrualRule: ptoAccrualRule,
                ptoResetRule: ptoResetRule,
                ptoLimit: ptoLimit,
                isSickDaysOn: user.currentSickDaysBalance,
                currentSickDaysBalance: currentSickDaysBalance,
                plannedSickDaysBalanceApproved: plannedSickDaysBalanceApproved,
                isDefaultSickDaysRule: isDefaultSickDaysRule,
                sickDaysAccrualRule: sickDaysAccrualRule,
                sickDaysResetRule: sickDaysResetRule,
                sickDaysLimit: sickDaysLimit
            };
        }
    }, {
        key: 'load',
        value: function load() {
            var _this = this;

            var userCount = this.userCount;
            var pageCount = Math.floor(userCount / USER_BATCH_SIZE);
            var pageNumArray = Array.from({ length: pageCount + 1 }, function (_, index) {
                return index + 1;
            });
            var filter = _extends({}, this.filter);
            var tokens = [].concat(_toConsumableArray(this.tokens));
            var userListOrder = _extends({}, this.userListOrder);

            return pageNumArray.map(function (pageNum) {
                var userStartNum = (pageNum - 1) * USER_BATCH_SIZE;
                var userEndNum = Math.min(pageNum * USER_BATCH_SIZE, userCount);

                return new Promise(function (res) {
                    var params = [filter, tokens, userListOrder, pageNum, USER_BATCH_SIZE];

                    _this.rpcRequest = (0, _jquery_rpc2.default)("UserManagementService.getUsers", params, function (data) {
                        var users = data.records.map(function (user) {
                            return _this._convertUserToInfo(user, data.ptoDefaults, data.sdbDefaults);
                        });
                        res({
                            start: userStartNum,
                            end: userEndNum,
                            items: users
                        });
                    }, function (jqXHR, textStatus, errorThrown) {
                        if (textStatus === 'abort') return;

                        if (errorThrown && !!errorThrown.exception) {
                            alert(errorThrown.exception);
                            return true;
                        }
                    });
                });
            });
        }
    }]);

    return UserInfoRepository;
}();

/***/ }),
/* 1751 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _UserProfilePopup = __webpack_require__(903);

var _UserProfilePopup2 = _interopRequireDefault(_UserProfilePopup);

var _UserATProfileSection = __webpack_require__(1753);

var _UserATProfileSection2 = _interopRequireDefault(_UserATProfileSection);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function UserATProfilePopup() {}

UserATProfilePopup.prototype = _underscore2.default.create(_UserProfilePopup2.default.prototype);

UserATProfilePopup.prototype.init = function (data, isLocked, highlightStartingNewWeekSection, isUserCannotSeenAnyPages, successCallback, enabledFeatures, areMailSettingsSpecified) {
    this._enabledFeatures = enabledFeatures;
    this._areMailSettingsSpecified = areMailSettingsSpecified;
    this._isUserCannotSeenAnyPages = isUserCannotSeenAnyPages;

    var self = this;

    UserATProfilePopup.prototype.initAndShow.call(self, data, isLocked, highlightStartingNewWeekSection, isUserCannotSeenAnyPages, successCallback);
};

UserATProfilePopup.prototype.initAndShow = function (data, isLocked, highlightStartingNewWeekSection, isUserCannotSeenAnyPages, successCallback) {
    _UserProfilePopup2.default.prototype.init.call(this, data, isLocked, successCallback, undefined, undefined, EnabledFeatures.WSD, EnabledFeatures.FTT);

    if (highlightStartingNewWeekSection) {
        (0, _jquery2.default)(".startingNewWeekBlock").addClass("highlighted");
        setTimeout(function () {
            (0, _jquery2.default)(".startingNewWeekBlock").removeClass("highlighted");
        }, 2000);
    }
    if (isUserCannotSeenAnyPages) {
        var self = this;
        this.onShowAnimationEnd = function () {
            self._userProfileSection.scrollToPermissionsSection();
        };
    }
    return this;
};

UserATProfilePopup.prototype.createUserProfileSection = function (data) {
    return new _UserATProfileSection2.default().init(this._popupEl[0], data, this._changesCallback, this._validateCallback, true, this._enabledFeatures, this._areMailSettingsSpecified, this._isUserCannotSeenAnyPages, this._isDefaultWorkdaySectionShown);
};

UserATProfilePopup.prototype.getServiceAndMethod = function () {
    return "EditATProfileService.updateProfile";
};

UserATProfilePopup.prototype.getDataToCommit = function () {
    var data = this._userProfileSection;
    return [{
        firstName: data.getFirstName(),
        middleName: data.getMiddleInitial(),
        lastName: data.getLastName(),
        email: data.getEmail(),
        username: data.getUsername(),
        plainOldPassword: data.getOldPassword(),
        plainPassword: data.getNewPassword(),
        keepAllTasksFromPreviousWeek: data.getStartingNewWeekOption()
        // TODO: notifications are disabled for now, remove or rewrite later
        // receiveUserChangesNotification: data.getReceiveUserChangesOption(),
        // receiveCommentsChangesNotification: data.getReceiveCommentsChangesOption()
    }];
};

exports.default = UserATProfilePopup;

/***/ }),
/* 1752 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DefaultWorkday = DefaultWorkday;

var _constants = __webpack_require__(21);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function DefaultWorkday() {}

DefaultWorkday.prototype.init = function (el, data, changesCallback, onScrollCallback) {
    el.innerHTML = "";

    var defaultWorkdayStartEnd = document.createElement("div");
    el.appendChild(defaultWorkdayStartEnd);
    defaultWorkdayStartEnd.classList.add('atNextMount');

    var self = this;
    this.errors = _defineProperty({}, _constants.ValidationErrors.WORKDAY_END_BEFORE_WORKDAY_START, false);

    var props = {
        startValue: data.defaultDayStart,
        endValue: data.defaultDayEnd,
        headerClassName: 'defaultDayStartSectionHeader',
        onStartChange: function onStartChange(value) {
            data.defaultDayStart = value;
            changesCallback();
            self._defaultWorkday.setProps({ startValue: data.defaultDayStart });
        },
        onEndChange: function onEndChange(value) {
            data.defaultDayEnd = value;
            changesCallback();
            self._defaultWorkday.setProps({ endValue: data.defaultDayEnd });
        },
        setErrors: function setErrors(hasErrors) {
            self.errors[_constants.ValidationErrors.WORKDAY_END_BEFORE_WORKDAY_START] = hasErrors;
        },
        onScrollCallback: onScrollCallback
    };

    this._defaultWorkday = ClassicBridge.integrateDefaultWorkdayStartEnd(defaultWorkdayStartEnd, props);

    return this;
};

DefaultWorkday.prototype.validate = function () {
    return this.errors;
};

/***/ }),
/* 1753 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _PermissionsSectionContent = __webpack_require__(1754);

var _PermissionsSectionContent2 = _interopRequireDefault(_PermissionsSectionContent);

var _TotalWorkAssignments = __webpack_require__(1762);

var _TotalWorkAssignments2 = _interopRequireDefault(_TotalWorkAssignments);

var _UserProfileSection2 = __webpack_require__(564);

var _UserProfileSection3 = _interopRequireDefault(_UserProfileSection2);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _ScrollUtils = __webpack_require__(39);

var _ScrollUtils2 = _interopRequireDefault(_ScrollUtils);

var _constants = __webpack_require__(78);

var _PermissionsDescriptionLightBox = __webpack_require__(546);

var _PermissionsDescriptionLightBox2 = _interopRequireDefault(_PermissionsDescriptionLightBox);

var _constants2 = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UserATProfileSection = function (_UserProfileSection) {
    _inherits(UserATProfileSection, _UserProfileSection);

    function UserATProfileSection() {
        _classCallCheck(this, UserATProfileSection);

        return _possibleConstructorReturn(this, (UserATProfileSection.__proto__ || Object.getPrototypeOf(UserATProfileSection)).apply(this, arguments));
    }

    _createClass(UserATProfileSection, [{
        key: 'init',
        value: function init(lightBoxEl, userData, changesCallback, validateCallback, isInstantValidation, enabledFeatures, mailSettingsSpecified, isUserCannotSeenAnyPages, isDefaultWorkdaySectionShown) {
            var _this2 = this;

            var isPTOEnabled = enabledFeatures.hasOwnProperty(_constants.Feature.PTO);
            var isSickEnabled = enabledFeatures.hasOwnProperty(_constants.Feature.SDB);
            var isTTAEnabled = enabledFeatures.hasOwnProperty(_constants.Feature.TTA);
            var isLTTEnabled = enabledFeatures.hasOwnProperty(_constants.Feature.LTT);
            var isURAEnabled = enabledFeatures.hasOwnProperty(_constants.Feature.URA);
            var isBTYEnabled = enabledFeatures.hasOwnProperty(_constants.Feature.BTY);
            var isWSDEnabled = enabledFeatures.hasOwnProperty(_constants.Feature.WSD);

            _get(UserATProfileSection.prototype.__proto__ || Object.getPrototypeOf(UserATProfileSection.prototype), 'init', this).call(this, lightBoxEl, userData, changesCallback, validateCallback, isInstantValidation, isPTOEnabled, isSickEnabled, mailSettingsSpecified, isWSDEnabled, isDefaultWorkdaySectionShown);

            var $permissionsContainer = (0, _jquery2.default)('#profilePopup_permissionsTable');
            new _PermissionsSectionContent2.default({
                userRights: userData.userRights.set,
                isPTOEnabled: isPTOEnabled,
                isSickEnabled: isSickEnabled,
                isTTAEnabled: isTTAEnabled,
                isLTTEnabled: isLTTEnabled,
                isURAEnabled: isURAEnabled,
                isBTYEnabled: isBTYEnabled,
                teamAssignmentType: userData.teamAssignmentType,
                managementAssignmentsSelection: userData.managementAssignmentsSelection,
                usersCount: userData.usersCount,
                tasksCount: userData.cptCounters.tasks,
                projectsCount: userData.cptCounters.projects,
                customersCount: userData.cptCounters.customers
            }).init($permissionsContainer);

            new _PermissionsDescriptionLightBox2.default({
                additionalClass: 'userProfilePermissionInfo'
            }).init((0, _jquery2.default)('#profilePermissionsSection .aboutPermissionIcon'));

            new _TotalWorkAssignments2.default({
                hasEnterTTRight: userData.userRights.set[_constants2.AccessRights.SUBMIT_TIME_TRACK],
                allWorkAssignments: userData.canWorkWithAllScope,
                nTasks: userData.nWorkAssignedTasks
            }).init((0, _jquery2.default)('#userProfilePopup_content .workAssignmentsSection .content'));

            this.startingNewWeekRadio = (0, _jquery2.default)('input[name="' + this.lightBoxEl.id + '_startingNewWeekRadio"]');
            this.startingNewWeekRadio.change(function () {
                _this2.changesDetected();
            });
            this.startingNewWeekRadio.filter('[value="' + userData.keepAllTasksFromPreviousWeek + '"]').prop('checked', true);

            // warning about no rights
            if (isUserCannotSeenAnyPages) {
                (0, _jquery2.default)(".rightSection").find(".noPermissionsWarning").show();
            }

            return this;
        }
    }, {
        key: 'getStartingNewWeekOption',
        value: function getStartingNewWeekOption() {
            return this.startingNewWeekRadio.filter(':checked').val();
        }
    }, {
        key: 'scrollToPermissionsSection',
        value: function scrollToPermissionsSection() {
            if (this.rightSectionScroll) {
                _ScrollUtils2.default.scrollIntoViewVertical(this.rightSectionScroll, (0, _jquery2.default)("#profilePermissionsSection")[0], _ScrollUtils2.default.POSITIONS.TOP, false, 500);
            }
        }
    }]);

    return UserATProfileSection;
}(_UserProfileSection3.default);

exports.default = UserATProfileSection;

/***/ }),
/* 1754 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _AccessRightToClassMa;

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _constants = __webpack_require__(4);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _Button = __webpack_require__(33);

var _Button2 = _interopRequireDefault(_Button);

var _AssignedTeamListContainer = __webpack_require__(1755);

var _AssignedTeamListContainer2 = _interopRequireDefault(_AssignedTeamListContainer);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _CPTAssignmentsListContainer = __webpack_require__(1760);

var _constants2 = __webpack_require__(21);

var _constants3 = __webpack_require__(4);

var _pluralizeUtils = __webpack_require__(40);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var AccessRightToClassMap = (_AccessRightToClassMa = {}, _defineProperty(_AccessRightToClassMa, _constants.AccessRights.MANAGE_USERS, 'manageUsers'), _defineProperty(_AccessRightToClassMa, _constants.AccessRights.SUBMIT_OTHER_USER_TIME_TRACK, 'modifyTT'), _defineProperty(_AccessRightToClassMa, _constants.AccessRights.EDIT_HIERARCHY, 'manageScope'), _defineProperty(_AccessRightToClassMa, _constants.AccessRights.GENERATE_MONEY_REPORTS, 'generateMoneyReports'), _defineProperty(_AccessRightToClassMa, _constants.AccessRights.SUBMIT_TIME_TRACK, 'submitTT'), _defineProperty(_AccessRightToClassMa, _constants.AccessRights.LOCK_TIME_TRACK, 'lockTT'), _defineProperty(_AccessRightToClassMa, _constants.AccessRights.MANAGE_PTO_AND_SICK, 'manageBalances'), _defineProperty(_AccessRightToClassMa, _constants.AccessRights.MANAGE_GENERAL_SETTINGS, 'generalSettings'), _AccessRightToClassMa);

var PermissionsSectionContent = function (_TemplateView) {
    _inherits(PermissionsSectionContent, _TemplateView);

    function PermissionsSectionContent(_ref) {
        var userRights = _ref.userRights,
            isPTOEnabled = _ref.isPTOEnabled,
            isSickEnabled = _ref.isSickEnabled,
            isTTAEnabled = _ref.isTTAEnabled,
            isLTTEnabled = _ref.isLTTEnabled,
            isURAEnabled = _ref.isURAEnabled,
            isBTYEnabled = _ref.isBTYEnabled,
            teamAssignmentType = _ref.teamAssignmentType,
            usersCount = _ref.usersCount,
            managementAssignmentsSelection = _ref.managementAssignmentsSelection,
            tasksCount = _ref.tasksCount,
            projectsCount = _ref.projectsCount,
            customersCount = _ref.customersCount;

        _classCallCheck(this, PermissionsSectionContent);

        var _this = _possibleConstructorReturn(this, (PermissionsSectionContent.__proto__ || Object.getPrototypeOf(PermissionsSectionContent)).call(this));

        _this.params = {
            userRights: userRights,
            isPTOEnabled: isPTOEnabled,
            isSickEnabled: isSickEnabled,
            isTTAEnabled: isTTAEnabled,
            isLTTEnabled: isLTTEnabled,
            isURAEnabled: isURAEnabled,
            isBTYEnabled: isBTYEnabled,

            teamAssignmentType: teamAssignmentType,
            usersCount: usersCount,

            managementAssignmentsSelection: managementAssignmentsSelection,
            tasksCount: tasksCount,
            projectsCount: projectsCount,
            customersCount: customersCount
        };
        return _this;
    }

    _createClass(PermissionsSectionContent, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class="permissions">' + '    <div class="manageRightsSection">' + '        <div class="title"><%-manageTitle%></div>' + '        <div class="permissionLabelContainer manageUsers">' + '            <label><%-manageUsers%></label>' + '        </div>' + '        <div class="permissionLabelContainer modifyTT">' + '            <label></label>' + '        </div>' + '        <div class="permissionLabelContainer manageScope">' + '            <label><%-manageScope%></label>' + '        </div>' + '        <div class="permissionLabelContainer generateMoneyReports">' + '            <label><%-generateMoneyReports%></label>' + '        </div>' + '    </div>' + '   <div class="scopeSection">' + '        <div class="title"><%-scopeTitle%></div>' + '        <div class="teamSection">' + '           <div class="subtitle"><%-selectedTeam%></div>' + '           <div class="teamSelectionLabel"></div>' + '           <div class="users"></div>' + '        </div>' + '        <div class="scopeOfWorkSection">' + '           <div class="subtitle"><%-scopeOfWork%></div>' + '           <div class="scopeSelectionLabel"></div>' + '           <div class="partScope">' + '              <div class="customers"></div>' + '              <div class="separator">/</div>' + '              <div class="projects"></div>' + '              <div class="separator">/</div>' + '              <div class="tasks"></div>' + '           </div>' + '        </div>' + '    </div>' + '    <div class="otherRightsSection">' + '        <div class="title"><%-otherTitle%></div>' + '        <div class="permissionLabelContainer submitTT">' + '            <label><%-submitTT%></label>' + '        </div>' + '        <div class="permissionLabelContainer lockTT">' + '            <label><%-lockTT%></label>' + '        </div>' + '        <div class="permissionLabelContainer manageBalances">' + '            <label></label>' + '        </div>' + '        <div class="permissionLabelContainer generalSettings">' + '            <label><%-systemSettings%></label>' + '        </div>' + '    </div>' + '</div>';
        }
    }, {
        key: 'messageKeys',
        value: function messageKeys() {
            return {
                manageUsers: 'access_rights.manage_users',
                manageScope: 'access_rights.edit_hierarchy',
                generateMoneyReports: 'access_rights.generate_money_reports',
                lockTT: 'access_rights.lock_time_track',
                systemSettings: 'access_rights.manage_general_settings',
                submitTT: 'access_rights.submit_time_track',
                manageTitle: 'profile.permissions.management_rights',
                otherTitle: 'profile.permissions.other_rights',
                scopeTitle: 'profile.permissions.scope_of_work',
                selectedTeam: 'profile.permissions.selected_team.title',
                scopeOfWork: 'profile.permissions.scope_of_work.title'
            };
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            this._updateModifyTTLabel();
            this._updateBalancesRightLabel();
            this._updateLockTTLabel();
            this._updateGenerateMoneyReportsRight();
            this._updateActiveRights();

            var manageUsers = !!this.params.userRights[_constants.AccessRights.MANAGE_USERS];
            var submitOtherUsersTT = !!this.params.userRights[_constants.AccessRights.SUBMIT_OTHER_USER_TIME_TRACK];
            var editHierarchy = !!this.params.userRights[_constants.AccessRights.EDIT_HIERARCHY];
            var generateMoneyReports = !!this.params.userRights[_constants.AccessRights.GENERATE_MONEY_REPORTS];

            var manageRights = void 0;

            if (manageUsers && submitOtherUsersTT && editHierarchy && generateMoneyReports) {
                manageRights = _constants3.ManagementAssignmentsSelection.ALL;
            } else if (manageUsers || submitOtherUsersTT || editHierarchy || generateMoneyReports) {
                manageRights = _constants3.ManagementAssignmentsSelection.SELECTED;
            } else {
                manageRights = _constants3.ManagementAssignmentsSelection.NO;
            }

            if (manageRights === _constants3.ManagementAssignmentsSelection.NO) {
                (0, _jquery2.default)('.scopeSection').hide();
            } else {
                (0, _jquery2.default)('.scopeSection').show();
                this._updateTeamCount();
                this._updateManagementAssignmentsCounts();
            }
        }
    }, {
        key: '_updateTeamCount',
        value: function _updateTeamCount() {
            var _this2 = this;

            (0, _jquery2.default)('.userProfile_teamList').remove();

            this.teamMenu = new _AssignedTeamListContainer2.default({
                additionalClass: 'userProfile_teamList'
            }).init((0, _jquery2.default)('body'));
            this.teamMenu.hide();

            var isAllScopeAssigned = this.params.teamAssignmentType === _constants2.UserTeamAssignmentType.ALL;
            var noAccessToTeamScope = this.params.teamAssignmentType === _constants2.UserTeamAssignmentType.NO;
            var isNoneScopeAssigned = this.params.teamAssignmentType === _constants2.UserTeamAssignmentType.SELECTED && this.params.usersCount === 0;

            if (isAllScopeAssigned) {
                this.showTeamLabel(_messageResource2.default.getMessage('profile.permissions.selected_team.all_departments'));
            } else if (noAccessToTeamScope) {
                this.showTeamLabel(_messageResource2.default.getMessage('profile.permissions.selected_team.no_access'));
            } else if (isNoneScopeAssigned) {
                this.showTeamLabel(_messageResource2.default.getMessage('profile.permissions.selected_team.not_selected'));
            } else {
                this.find('.scopeSection .teamSelectionLabel').hide();
                new _Button2.default({
                    label: this.params.usersCount + " " + (0, _pluralizeUtils.userNameLower)(this.params.usersCount),
                    onClickCb: function onClickCb() {
                        return _this2.teamMenu.showAt(_this2.find('.teamSection .users'), {
                            my: 'center top',
                            at: 'center bottom',
                            offset: '0px 10px',
                            collision: 'none'
                        });
                    },
                    additionalClass: 'permissionButton'
                }).init(this.find('.teamSection .users'));
            }
        }
    }, {
        key: 'showTeamLabel',
        value: function showTeamLabel(text) {
            var $teamSelectionLabel = this.find('.scopeSection .teamSelectionLabel');
            $teamSelectionLabel.text(text);
            $teamSelectionLabel.show();
        }
    }, {
        key: '_updateManagementAssignmentsCounts',
        value: function _updateManagementAssignmentsCounts() {
            var $body = (0, _jquery2.default)('body');

            var notSelected = this.params.managementAssignmentsSelection === _constants3.ManagementAssignmentsSelection.SELECTED && this.params.customersCount === 0 && this.params.projectsCount === 0 && this.params.tasksCount === 0;

            var all = this.params.managementAssignmentsSelection === _constants3.ManagementAssignmentsSelection.ALL;

            var noAccess = this.params.managementAssignmentsSelection === _constants3.ManagementAssignmentsSelection.NO;

            if (all) {
                this.setupScopeSection(false, true, _messageResource2.default.getMessage('user.scope_cell.manage_scope.all_selected'));
            } else if (notSelected) {
                this.setupScopeSection(false, true, _messageResource2.default.getMessage('user.scope_cell.manage_scope.not_selected'));
            } else if (noAccess) {
                this.setupScopeSection(false, true, _messageResource2.default.getMessage('user.scope_cell.manage_scope.no_access'));
            } else {
                this.setupScopeSection(false, true, _messageResource2.default.getMessage('user.scope_cell.manage_scope.selected', [this.params.customersCount, (0, _pluralizeUtils.customerNameLower)(this.params.customersCount), this.params.projectsCount, (0, _pluralizeUtils.projectNameLower)(this.params.projectsCount), this.params.tasksCount, (0, _pluralizeUtils.taskNameLower)(this.params.tasksCount)]));

                //TODO CPT assignments list are disabled until counters in CPT editors would be fixed. See AT-3370
                /* this.setupScopeSection(true, false, '')
                 $('.userProfile_taskAssignmentsList').remove()
                const taskLabel = this.params.tasksCount + ' ' + taskNameLower(this.params.tasksCount)
                this.$tasksScope = this.find('.scopeOfWorkSection .tasks')
                 if (this.params.tasksCount !== 0) {
                    this.taskMenu = new TaskCPTAssignmentsListContainer({
                        additionalClass: 'userProfile_taskAssignmentsList',
                        currentCptLevel: HierarchyLevels.TASK,
                    }).init($body)
                    this.taskMenu.hide()
                     this.taskButton = new Button({
                        label: taskLabel,
                        onClickCb: () => this.taskMenu.showAt(this.$tasksScope, {
                            my: 'center top',
                            at: 'center bottom',
                            offset: '0px 10px',
                            collision: 'none',
                        }),
                        additionalClass: 'permissionButton',
                    }).init(this.$tasksScope)
                } else {
                    this.$tasksScope.text(taskLabel)
                }
                 $('.userProfile_projectAssignmentsList').remove()
                const projectLabel = this.params.projectsCount + ' ' + projectNameLower(this.params.projectsCount)
                this.$projectsScope = this.find('.scopeOfWorkSection .projects')
                 if (this.params.projectsCount !== 0) {
                    this.projectMenu = new ProjectCPTAssignmentsListContainer({
                        additionalClass: 'userProfile_projectAssignmentsList',
                        currentCptLevel: HierarchyLevels.PROJECT,
                    }).init($body)
                    this.projectMenu.hide()
                     this.projectButton = new Button({
                        label: projectLabel,
                        onClickCb: () => this.projectMenu.showAt(this.$projectsScope, {
                            my: 'center top',
                            at: 'center bottom',
                            offset: '0px 10px',
                            collision: 'none',
                        }),
                        additionalClass: 'permissionButton',
                    }).init(this.$projectsScope)
                } else {
                    this.$projectsScope.text(projectLabel)
                }
                 $('.userProfile_customerAssignmentsList').remove()
                const customerLabel = this.params.customersCount + ' ' + customerNameLower(this.params.customersCount)
                this.$customersScope = this.find('.scopeOfWorkSection .customers')
                 if (this.params.customersCount !== 0) {
                    this.customerMenu = new CustomerCPTAssignmentsListContainer({
                        additionalClass: 'userProfile_customerAssignmentsList',
                        currentCptLevel: HierarchyLevels.CUSTOMER,
                    }).init($body)
                    this.customerMenu.hide()
                     this.customerButton = new Button({
                        label: customerLabel,
                        onClickCb: () => this.customerMenu.showAt(this.$customersScope, {
                            my: 'center top',
                            at: 'center bottom',
                            offset: '0px 10px',
                            collision: 'none',
                        }),
                        additionalClass: 'permissionButton',
                    }).init(this.$customersScope)
                } else {
                    this.$customersScope.text(customerLabel)
                }
                */
            }
        }
    }, {
        key: 'setupScopeSection',
        value: function setupScopeSection(togglePartScope, toggleLabel, labelText) {
            this.find('.scopeSection .scopeSelectionLabel').toggle(true);
            this.find('.scopeSection .partScope').toggle(togglePartScope);
            this.find('.scopeSection .scopeSelectionLabel').text(labelText);
        }
    }, {
        key: '_updateActiveRights',
        value: function _updateActiveRights() {
            var _this3 = this;

            Object.keys(AccessRightToClassMap).forEach(function (right) {
                _this3._setActiveRight(AccessRightToClassMap[right], !!_this3.params.userRights[right]);
            });
        }
    }, {
        key: '_setActiveRight',
        value: function _setActiveRight(clazz, active) {
            this.find('.permissionLabelContainer.' + clazz).toggleClass('rowWithTick', active).toggleClass('active', active).toggleClass('inactive', !active);
        }
    }, {
        key: '_updateModifyTTLabel',
        value: function _updateModifyTTLabel() {
            this.find('.modifyTT label').text(this.params.isTTAEnabled ? _messageResource2.default.getMessage('access_rights.modify_and_approve_tt') : _messageResource2.default.getMessage('access_rights.submit_other_time_track'));
        }
    }, {
        key: '_updateLockTTLabel',
        value: function _updateLockTTLabel() {
            this.find('.lockTT').toggle(this.params.isLTTEnabled);
        }
    }, {
        key: '_updateBalancesRightLabel',
        value: function _updateBalancesRightLabel() {
            var _params = this.params,
                isSickEnabled = _params.isSickEnabled,
                isPTOEnabled = _params.isPTOEnabled;

            var $container = this.find('.manageBalances');

            var text = '';
            if (isPTOEnabled && isSickEnabled) {
                text = _messageResource2.default.getMessage('access_rights.manage_pto_and_sick');
            } else if (isPTOEnabled) {
                text = _messageResource2.default.getMessage('access_rights.manage_pto_only');
            } else if (isSickEnabled) {
                text = _messageResource2.default.getMessage('access_rights.manage_sick_only');
            } else {
                $container.hide();
            }

            $container.find('label').text(text);
        }
    }, {
        key: '_updateGenerateMoneyReportsRight',
        value: function _updateGenerateMoneyReportsRight() {
            var $container = this.find('.generateMoneyReports');
            $container.toggle(this.params.isBTYEnabled || this.params.isURAEnabled);

            if (!this.params.isBTYEnabled) $container.find('label').text(_messageResource2.default.getMessage('access_rights.generate_money_reports_only_cost'));
            if (!this.params.isURAEnabled) $container.find('label').text(_messageResource2.default.getMessage('access_rights.generate_money_reports_only_billing'));
        }
    }]);

    return PermissionsSectionContent;
}(_TemplateView3.default);

exports.default = PermissionsSectionContent;

/***/ }),
/* 1755 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _DropdownTemplateView2 = __webpack_require__(42);

var _DropdownTemplateView3 = _interopRequireDefault(_DropdownTemplateView2);

var _utils = __webpack_require__(6);

var _ScrollableContainer = __webpack_require__(49);

var _ScrollableContainer2 = _interopRequireDefault(_ScrollableContainer);

var _AssignedTeamList = __webpack_require__(1756);

var _AssignedTeamList2 = _interopRequireDefault(_AssignedTeamList);

var _LoadingContainer = __webpack_require__(28);

var _LoadingContainer2 = _interopRequireDefault(_LoadingContainer);

var _selectors = __webpack_require__(1758);

var _redux = __webpack_require__(7);

var _actions = __webpack_require__(1759);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AssignedTeamDropdownListContainer = function (_DropdownTemplateView) {
    _inherits(AssignedTeamDropdownListContainer, _DropdownTemplateView);

    function AssignedTeamDropdownListContainer(_ref) {
        var _ref$additionalClass = _ref.additionalClass,
            additionalClass = _ref$additionalClass === undefined ? '' : _ref$additionalClass,
            _ref$loadTeamsData = _ref.loadTeamsData,
            loadTeamsData = _ref$loadTeamsData === undefined ? function () {} : _ref$loadTeamsData,
            _ref$onShowCallback = _ref.onShowCallback,
            onShowCallback = _ref$onShowCallback === undefined ? function () {} : _ref$onShowCallback;

        _classCallCheck(this, AssignedTeamDropdownListContainer);

        var _this = _possibleConstructorReturn(this, (AssignedTeamDropdownListContainer.__proto__ || Object.getPrototypeOf(AssignedTeamDropdownListContainer)).call(this));

        _this.loadTeamsData = loadTeamsData;
        _this.onShowCallback = onShowCallback;
        _this.additionalClass = additionalClass;

        _this.isShown = true;

        _this.state = {
            loading: false,
            needToLoadData: false,

            teamUsers: []
        };

        _this.onStatePropertyBecameTrue('needToLoadData', function () {
            _this.loadTeamsData();
        });

        _this.onStatePropertyChanged('loading', function (loading) {
            _this.content.setState({
                loading: loading
            });
        });

        _this.onStatePropertyChanged('teamUsers', function (teamUsers) {
            _this.content.setState({
                teamUsers: teamUsers
            });
        });
        return _this;
    }

    _createClass(AssignedTeamDropdownListContainer, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class="teamsContainer <%-additionalClass%>">' + '    <div class="pointerPlaceholder">' + '        <div class="pointer"/>' + '    </div>' + '</div>';
        }
    }, {
        key: 'templateModel',
        value: function templateModel() {
            return {
                additionalClass: this.additionalClass
            };
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            this.teamList = new _AssignedTeamList2.default();

            this.loadingContainer = new _LoadingContainer2.default({
                contentComponent: this.teamList,
                containerClass: '',
                loadingMoireConfig: {
                    delay: 500
                }
            });

            this.content = new _ScrollableContainer2.default(null, this.loadingContainer).init(this.getEl());
        }
    }, {
        key: 'onShow',
        value: function onShow() {
            _get(AssignedTeamDropdownListContainer.prototype.__proto__ || Object.getPrototypeOf(AssignedTeamDropdownListContainer.prototype), 'onShow', this).call(this);
            this.onShowCallback();
        }
    }]);

    return AssignedTeamDropdownListContainer;
}(_DropdownTemplateView3.default);

exports.default = (0, _utils.connect)(function (state) {
    return {
        loading: (0, _selectors.isLoading)(state),
        needToLoadData: (0, _selectors.isNeedToLoadData)(state),

        teamUsers: (0, _selectors.getSortedTeamUsers)(state)
    };
}, function (dispatch) {
    return {
        loadTeamsData: (0, _redux.bindActionCreators)(_actions.loadAssignedTeamNames, dispatch),
        onShowCallback: (0, _redux.bindActionCreators)(_actions.openTeamList, dispatch)
    };
})(AssignedTeamDropdownListContainer);

/***/ }),
/* 1756 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _AssignedTeamRow = __webpack_require__(1757);

var _AssignedTeamRow2 = _interopRequireDefault(_AssignedTeamRow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AssignedTeamList = function (_TemplateView) {
    _inherits(AssignedTeamList, _TemplateView);

    function AssignedTeamList() {
        _classCallCheck(this, AssignedTeamList);

        var _this = _possibleConstructorReturn(this, (AssignedTeamList.__proto__ || Object.getPrototypeOf(AssignedTeamList)).call(this));

        _this.state = {
            teamUsers: []
        };

        _this.onStatePropertyChanged('teamUsers', function (teamUsers) {
            _this.$teamList.empty();
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = teamUsers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var user = _step.value;

                    new _AssignedTeamRow2.default({
                        firstName: user.firstName,
                        lastName: user.lastName,
                        middleInitial: user.middleInitial
                    }).init(_this.$teamList);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        });
        return _this;
    }

    _createClass(AssignedTeamList, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class="teamsList"></div>';
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            this.$teamList = this.getEl();
        }
    }]);

    return AssignedTeamList;
}(_TemplateView3.default);

exports.default = AssignedTeamList;

/***/ }),
/* 1757 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _UserNameFormat = __webpack_require__(17);

var UserNameFormat = _interopRequireWildcard(_UserNameFormat);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AssignedTeamRow = function (_TemplateView) {
    _inherits(AssignedTeamRow, _TemplateView);

    function AssignedTeamRow(_ref) {
        var _ref$firstName = _ref.firstName,
            firstName = _ref$firstName === undefined ? '' : _ref$firstName,
            _ref$lastName = _ref.lastName,
            lastName = _ref$lastName === undefined ? '' : _ref$lastName,
            _ref$middleInitial = _ref.middleInitial,
            middleInitial = _ref$middleInitial === undefined ? '' : _ref$middleInitial;

        _classCallCheck(this, AssignedTeamRow);

        var _this = _possibleConstructorReturn(this, (AssignedTeamRow.__proto__ || Object.getPrototypeOf(AssignedTeamRow)).call(this));

        _this.params = {
            firstName: firstName,
            lastName: lastName,
            middleInitial: middleInitial
        };
        return _this;
    }

    _createClass(AssignedTeamRow, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return "<div class='teamRow'><%-rowText%></div>";
        }
    }, {
        key: 'templateModel',
        value: function templateModel() {
            return {
                rowText: UserNameFormat.formatLFM(this.params.firstName, this.params.lastName, this.params.middleInitial)
            };
        }
    }]);

    return AssignedTeamRow;
}(_TemplateView3.default);

exports.default = AssignedTeamRow;

/***/ }),
/* 1758 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getSortedTeamUsers = exports.getTeamNames = exports.isNeedToLoadData = exports.isLoading = exports.selectTeamList = undefined;

var _selectors = __webpack_require__(904);

var _reselect = __webpack_require__(13);

var _user_group_selector_util = __webpack_require__(98);

var selectTeamList = exports.selectTeamList = function selectTeamList(state) {
    return (0, _selectors.selectUserProfile)(state).teamList;
};

var isLoading = exports.isLoading = function isLoading(state) {
    return selectTeamList(state).loading;
};

var isNeedToLoadData = exports.isNeedToLoadData = function isNeedToLoadData(state) {
    return selectTeamList(state).needToLoadData;
};

var getTeamNames = exports.getTeamNames = function getTeamNames(state) {
    return selectTeamList(state).teamNames;
};

var getSortedTeamUsers = exports.getSortedTeamUsers = (0, _reselect.createSelector)(getTeamNames, function (teamUsers) {
    return teamUsers.sort(_user_group_selector_util.userComparator);
});

/***/ }),
/* 1759 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.openTeamList = exports.loadAssignedTeamNames = exports.setNeedToLoadData = exports.setTeamNames = exports.setLoading = undefined;

var _actionTypes = __webpack_require__(699);

var ActionTypes = _interopRequireWildcard(_actionTypes);

var _reduxActions = __webpack_require__(9);

var _rpcCalls = __webpack_require__(24);

var _rpcCalls2 = _interopRequireDefault(_rpcCalls);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var setLoading = exports.setLoading = (0, _reduxActions.createAction)(ActionTypes.LOADING_SET);

var setTeamNames = exports.setTeamNames = (0, _reduxActions.createAction)(ActionTypes.TEAM_NAMES_SET);

var setNeedToLoadData = exports.setNeedToLoadData = (0, _reduxActions.createAction)(ActionTypes.NEED_TO_LOAD_DATA_SET);

var loadAssignedTeamNames = exports.loadAssignedTeamNames = function loadAssignedTeamNames() {
    return function (dispatch) {
        dispatch(setLoading(true));
        (0, _rpcCalls2.default)("UserProfileService.getTeamListInfo", []).then(function (data) {
            dispatch(setTeamNames(data.teamNames));
            dispatch(setNeedToLoadData(false));
            dispatch(setLoading(false));
        }).catch(function () {
            dispatch(setLoading(false));
        });
    };
};

var openTeamList = exports.openTeamList = function openTeamList() {
    return function (dispatch) {
        dispatch(setNeedToLoadData(true));
    };
};

/***/ }),
/* 1760 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CustomerCPTAssignmentsListContainer = exports.ProjectCPTAssignmentsListContainer = exports.TaskCPTAssignmentsListContainer = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _DropdownTemplateView2 = __webpack_require__(42);

var _DropdownTemplateView3 = _interopRequireDefault(_DropdownTemplateView2);

var _utils = __webpack_require__(6);

var _ScrollableContainer = __webpack_require__(49);

var _ScrollableContainer2 = _interopRequireDefault(_ScrollableContainer);

var _LoadingContainer = __webpack_require__(28);

var _LoadingContainer2 = _interopRequireDefault(_LoadingContainer);

var _redux = __webpack_require__(7);

var _AssignmentsList = __webpack_require__(891);

var _AssignmentsList2 = _interopRequireDefault(_AssignmentsList);

var _utils2 = __webpack_require__(549);

var _selectors = __webpack_require__(905);

var _constants = __webpack_require__(4);

var _actions = __webpack_require__(1761);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CPTAssignmentsListContainer = function (_DropdownTemplateView) {
    _inherits(CPTAssignmentsListContainer, _DropdownTemplateView);

    function CPTAssignmentsListContainer(_ref) {
        var _ref$additionalClass = _ref.additionalClass,
            additionalClass = _ref$additionalClass === undefined ? '' : _ref$additionalClass,
            _ref$loadData = _ref.loadData,
            loadData = _ref$loadData === undefined ? function () {} : _ref$loadData,
            _ref$openMenu = _ref.openMenu,
            openMenu = _ref$openMenu === undefined ? function () {} : _ref$openMenu,
            _ref$closeMenu = _ref.closeMenu,
            closeMenu = _ref$closeMenu === undefined ? function () {} : _ref$closeMenu,
            _ref$createEntirelyAs = _ref.createEntirelyAssignedTitle,
            createEntirelyAssignedTitle = _ref$createEntirelyAs === undefined ? function () {} : _ref$createEntirelyAs,
            _ref$createNodesForLi = _ref.createNodesForList,
            createNodesForList = _ref$createNodesForLi === undefined ? function () {} : _ref$createNodesForLi,
            _ref$currentCptLevel = _ref.currentCptLevel,
            currentCptLevel = _ref$currentCptLevel === undefined ? null : _ref$currentCptLevel;

        _classCallCheck(this, CPTAssignmentsListContainer);

        var _this = _possibleConstructorReturn(this, (CPTAssignmentsListContainer.__proto__ || Object.getPrototypeOf(CPTAssignmentsListContainer)).call(this));

        _this.params = {
            loadData: loadData,
            openMenu: openMenu,
            closeMenu: closeMenu,
            createEntirelyAssignedTitle: createEntirelyAssignedTitle,
            createNodesForList: createNodesForList,
            additionalClass: additionalClass,
            currentCptLevel: currentCptLevel
        };

        _this.isShown = true;

        _this.state = {
            loading: false,
            needToLoadData: null,

            nodeEntities: [],
            entirelyAssignedCurrentLevel: 0,
            entirelyAssignedPrevLevel: 0
        };

        _this.onStatePropertyBecameTrue('needToLoadData', function () {
            _this.params.loadData();
        });

        _this.onStatePropertyChanged('loading', function (loading) {
            _this.content.setState({
                loading: loading
            });
        });

        _this.onStatePropertyChanged('nodeEntities', function (entities) {
            _this.content.setState({
                nodeEntities: entities
            });
        });

        _this.onStatePropertyChanged('entirelyAssignedCurrentLevel', function (count) {
            _this.content.setState({
                entirelyAssignedCurrentLevel: count
            });
        });

        _this.onStatePropertyChanged('entirelyAssignedPrevLevel', function (count) {
            _this.content.setState({
                entirelyAssignedPrevLevel: count
            });
        });
        return _this;
    }

    _createClass(CPTAssignmentsListContainer, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class="cptContainer <%-additionalClass%>">' + '    <div class="pointerPlaceholder">' + '        <div class="pointer"/>' + '    </div>' + '</div>';
        }
    }, {
        key: 'templateModel',
        value: function templateModel() {
            return {
                additionalClass: this.params.additionalClass
            };
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            this.assignmentsList = new _AssignmentsList2.default({
                revokeMap: {},
                entirelyAssignedTitle: this.params.createEntirelyAssignedTitle,
                createNodesForList: this.params.createNodesForList,
                hierarchyLevel: this.params.currentCptLevel
            });

            this.loadingContainer = new _LoadingContainer2.default({
                contentComponent: this.assignmentsList,
                containerClass: '',
                loadingMoireConfig: {
                    delay: 500
                }
            });

            this.content = new _ScrollableContainer2.default(null, this.loadingContainer).init(this.getEl());
        }
    }, {
        key: 'onShow',
        value: function onShow() {
            _get(CPTAssignmentsListContainer.prototype.__proto__ || Object.getPrototypeOf(CPTAssignmentsListContainer.prototype), 'onShow', this).call(this);
            this.params.openMenu();
        }
    }, {
        key: 'onHide',
        value: function onHide() {
            _get(CPTAssignmentsListContainer.prototype.__proto__ || Object.getPrototypeOf(CPTAssignmentsListContainer.prototype), 'onHide', this).call(this);
            this.params.closeMenu();
        }
    }]);

    return CPTAssignmentsListContainer;
}(_DropdownTemplateView3.default);

var TaskCPTAssignmentsListContainer = exports.TaskCPTAssignmentsListContainer = (0, _utils.connect)(function (state) {
    return {
        loading: (0, _selectors.isLoading)(state),
        needToLoadData: (0, _selectors.isNeedToLoadTaskData)(state),

        nodeEntities: (0, _selectors.selectTaskEntities)(state),
        entirelyAssignedCurrentLevel: (0, _selectors.getEntirelyAssignedTasksCounter)(state),
        entirelyAssignedPrevLevel: (0, _selectors.getAllAssignedProjectCounter)(state)
    };
}, function (dispatch) {
    return {
        loadData: (0, _redux.bindActionCreators)(_actions.loadDataAction, dispatch),
        openMenu: function openMenu() {
            return (0, _redux.bindActionCreators)(_actions.openMenu, dispatch)(_constants.HierarchyLevels.TASK);
        },
        closeMenu: (0, _redux.bindActionCreators)(_actions.closeMenu, dispatch),

        createEntirelyAssignedTitle: _utils2.entirelyAssignedTaskTitle,
        createNodesForList: _utils2.createNodesForTaskList
    };
})(CPTAssignmentsListContainer);

var ProjectCPTAssignmentsListContainer = exports.ProjectCPTAssignmentsListContainer = (0, _utils.connect)(function (state) {
    return {
        loading: (0, _selectors.isLoading)(state),
        needToLoadData: (0, _selectors.isNeedToLoadProjectData)(state),

        nodeEntities: (0, _selectors.selectProjectEntities)(state),
        entirelyAssignedCurrentLevel: (0, _selectors.getEntirelyAssignedProjectCounter)(state),
        entirelyAssignedPrevLevel: (0, _selectors.getAllAssignedCustomerCounter)(state)
    };
}, function (dispatch) {
    return {
        loadData: (0, _redux.bindActionCreators)(_actions.loadDataAction, dispatch),
        openMenu: function openMenu() {
            return (0, _redux.bindActionCreators)(_actions.openMenu, dispatch)(_constants.HierarchyLevels.PROJECT);
        },
        closeMenu: (0, _redux.bindActionCreators)(_actions.closeMenu, dispatch),

        createEntirelyAssignedTitle: _utils2.entirelyAssignedProjectTitle,
        createNodesForList: _utils2.createNodesForProjectList
    };
})(CPTAssignmentsListContainer);

var CustomerCPTAssignmentsListContainer = exports.CustomerCPTAssignmentsListContainer = (0, _utils.connect)(function (state) {
    return {
        loading: (0, _selectors.isLoading)(state),
        needToLoadData: (0, _selectors.isNeedToLoadCustomerData)(state),

        nodeEntities: (0, _selectors.selectCustomerEntities)(state),
        entirelyAssignedCurrentLevel: 0,
        entirelyAssignedPrevLevel: 0
    };
}, function (dispatch) {
    return {
        loadData: (0, _redux.bindActionCreators)(_actions.loadDataAction, dispatch),
        openMenu: function openMenu() {
            return (0, _redux.bindActionCreators)(_actions.openMenu, dispatch)(_constants.HierarchyLevels.CUSTOMER);
        },
        closeMenu: (0, _redux.bindActionCreators)(_actions.closeMenu, dispatch),

        createEntirelyAssignedTitle: _utils2.entirelyAssignedCustomerTitle,
        createNodesForList: _utils2.createNodesForCustomerList
    };
})(CPTAssignmentsListContainer);

/***/ }),
/* 1761 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.loadDataAction = exports.closeMenu = exports.openMenu = exports.prepareLoadedData = exports.setLoading = exports.setUserCounters = exports.setTab = exports.setCustomerIds = exports.setProjectIds = exports.setTaskIds = undefined;

var _actionTypes = __webpack_require__(698);

var ActionTypes = _interopRequireWildcard(_actionTypes);

var _rpcCalls = __webpack_require__(24);

var _rpcCalls2 = _interopRequireDefault(_rpcCalls);

var _selectors = __webpack_require__(19);

var _actions = __webpack_require__(29);

var _constants = __webpack_require__(4);

var _actionsGenerator = __webpack_require__(395);

var _actionsGenerator2 = _interopRequireDefault(_actionsGenerator);

var _selectors2 = __webpack_require__(905);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var hierarchyAssignmentsTabActions = (0, _actionsGenerator2.default)({
    actionTypes: ActionTypes
});

var setTaskIds = exports.setTaskIds = hierarchyAssignmentsTabActions.setTaskIds;

var setProjectIds = exports.setProjectIds = hierarchyAssignmentsTabActions.setProjectIds;

var setCustomerIds = exports.setCustomerIds = hierarchyAssignmentsTabActions.setCustomerIds;

var setTab = exports.setTab = hierarchyAssignmentsTabActions.setTab;

var setUserCounters = exports.setUserCounters = hierarchyAssignmentsTabActions.setUserCounters;

var setLoading = exports.setLoading = hierarchyAssignmentsTabActions.setLoading;

var prepareLoadedData = exports.prepareLoadedData = function prepareLoadedData(data, tabType) {
    return function (dispatch) {
        dispatch((0, _actions.addCustomers)(data.customers));
        dispatch((0, _actions.addProjects)(data.projects));
        dispatch((0, _actions.addTasks)(data.tasks));

        dispatch(setUserCounters(data.viewerCounter));

        switch (tabType) {
            case _constants.HierarchyLevels.TASK:
                dispatch(setTaskIds(data.taskIds));
                break;
            case _constants.HierarchyLevels.PROJECT:
                dispatch(setProjectIds(data.projectIds));
                break;
            case _constants.HierarchyLevels.CUSTOMER:
                dispatch(setCustomerIds(data.customerIds));
                break;
        }
    };
};

var openMenu = exports.openMenu = function openMenu(tabType) {
    return function (dispatch) {
        dispatch(setTab(tabType));
    };
};

var closeMenu = exports.closeMenu = function closeMenu() {
    return function (dispatch) {
        dispatch(setTab(null));
    };
};

var loadDataAction = exports.loadDataAction = function loadDataAction() {
    return function (dispatch, getState) {
        var userId = (0, _selectors.getLoggedInUserId)(getState());
        var tab = (0, _selectors2.getTab)(getState());
        dispatch(setLoading(true));
        (0, _rpcCalls2.default)('UserManagementService.getViewUserManagementAssignments', [userId, tab]).then(function (data) {
            dispatch(prepareLoadedData(data.viewAssignmentsData, tab));
            dispatch(setLoading(false));
        }).catch(function (err) {
            dispatch(setLoading(false));
            // TODO bakharev: add error handling
            console.log(err);
        });
    };
};

/***/ }),
/* 1762 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _pluralizeUtils = __webpack_require__(40);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TotalWorkAssignments = function (_TemplateView) {
    _inherits(TotalWorkAssignments, _TemplateView);

    function TotalWorkAssignments(_ref) {
        var _ref$hasEnterTTRight = _ref.hasEnterTTRight,
            hasEnterTTRight = _ref$hasEnterTTRight === undefined ? false : _ref$hasEnterTTRight,
            _ref$allWorkAssignmen = _ref.allWorkAssignments,
            allWorkAssignments = _ref$allWorkAssignmen === undefined ? false : _ref$allWorkAssignmen,
            _ref$nTasks = _ref.nTasks,
            nTasks = _ref$nTasks === undefined ? 0 : _ref$nTasks;

        _classCallCheck(this, TotalWorkAssignments);

        var _this = _possibleConstructorReturn(this, (TotalWorkAssignments.__proto__ || Object.getPrototypeOf(TotalWorkAssignments)).call(this));

        _this.params = {
            hasEnterTTRight: hasEnterTTRight,
            allWorkAssignments: allWorkAssignments,
            nTasks: nTasks
        };
        return _this;
    }

    _createClass(TotalWorkAssignments, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class="totalWorkAssignments">' + '    <span class="label"></span>' + '    <span class="nTasks"></span>' + '</div>';
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            this._updateLabel();
            this._updateNTasksText();
        }
    }, {
        key: '_updateLabel',
        value: function _updateLabel() {
            var labelText = void 0;
            if (!this.params.hasEnterTTRight) labelText = _messageResource2.default.getMessage('profile.work_assignments.cant_enter_tt');else if (this.params.allWorkAssignments) labelText = _messageResource2.default.getMessage('profile.work_assignments.can_enter_tt_all');else labelText = _messageResource2.default.getMessage('profile.work_assignments.can_enter_tt');

            this.find('.label').text(labelText);
        }
    }, {
        key: '_updateNTasksText',
        value: function _updateNTasksText() {
            var nTasks = this.params.nTasks;
            var $taskLabel = this.find('.nTasks');
            if (this.params.allWorkAssignments || !this.params.hasEnterTTRight) {
                $taskLabel.hide();
            } else {
                $taskLabel.text(' ' + nTasks + ' ' + (0, _pluralizeUtils.taskNameLower)(nTasks));
            }
        }
    }]);

    return TotalWorkAssignments;
}(_TemplateView3.default);

exports.default = TotalWorkAssignments;

/***/ }),
/* 1763 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _ChartGenerator = __webpack_require__(291);

var _ChartGenerator2 = _interopRequireDefault(_ChartGenerator);

var _utils = __webpack_require__(565);

var _user_time = __webpack_require__(30);

var _user_time2 = _interopRequireDefault(_user_time);

var _atBrowserUtils = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ColumnChartGenerator() {}

ColumnChartGenerator.prototype = _underscore2.default.create(_ChartGenerator2.default.prototype, {
    MAX_VERTICAL_GRIDS: 11,

    _prepareChartSettings: function _prepareChartSettings(chartData, config) {
        var collectedData = this._getCollectedData(chartData, config["userToday"], config["userHireDate"]);
        var dateFormat = config["dateFormat"];

        var chartMargins = this._getMargins(collectedData);

        var chartGraphs = this._prepareChartGraphs(collectedData, config["colorScheme"], dateFormat);

        var valueAxisMaxValue = (0, _utils.getMaxScaleValue)(collectedData.maxSummaryDayData, this.MAX_VERTICAL_GRIDS);
        var valueAxisGridCount = (0, _utils.getVerticalGridCount)(valueAxisMaxValue, 0, this.MAX_VERTICAL_GRIDS);
        var valueAxisLabelFunction = this._getValueAxisLabelFunction();

        var categoryAxisFunction = this._getCategoryAxisFunction();
        var categoryGridCount = this._getCategoryGridCount(collectedData);
        var categoryAxisLabelFunction = this._getCategoryAxisLabelFunction(dateFormat);

        var dataProvider = this._prepareDataProvider(collectedData, valueAxisMaxValue);

        return {
            "type": "serial",
            "autoResize": false,

            "startDuration": 0,
            "startEffect": "easeOutSine",
            "sequencedAnimation": true,

            "theme": "light",
            "columnWidth": 0.9,
            "columnSpacing": 0,
            "fontSize": 11,
            "addClassNames": true,

            "autoMargins": false,
            "marginTop": chartMargins["top"],
            "marginBottom": chartMargins["bottom"],
            "marginLeft": chartMargins["left"],
            "marginRight": chartMargins["right"],

            "chartCursor": {
                "oneBalloonOnly": true,
                "categoryBalloonEnabled": false,
                "balloonPointerOrientation": "vertical",
                "cursorAlpha": 0,
                "zoomable": false
            },

            "graphs": chartGraphs,

            "valueAxes": [{
                "id": "main",
                "maximum": valueAxisMaxValue,
                "stackType": "regular",
                "autoGridCount": false,
                "strictMinMax": true,
                "gridCount": valueAxisGridCount,
                "labelFunction": valueAxisLabelFunction,
                "axisAlpha": 0.11,
                "tickLength": 0
            }, {
                "id": "hidden",
                "gridCount": 0,
                "position": "right",
                "synchronizeWith": "main",
                "synchronizationMultiplier": 1,
                "autoGridCount": false,
                "axisAlpha": 0.11,
                // it need for show axis if auto margin off (hack)
                "minimum": 0,
                "logarithmic": true
            }],

            "categoryField": "date",
            "categoryAxis": {
                "parseDates": true,
                "minPeriod": "DD",
                "firstDayOfWeek": config["weekStartDay"],
                "categoryFunction": categoryAxisFunction,

                "gridPosition": "start",
                "gridThickness": 1,
                "tickLength": 30,
                "tickPosition": "start",
                "autoGridCount": false,
                "gridCount": categoryGridCount,

                "fontSize": 11,
                "labelOffset": 3,
                "boldLabels": false,
                "markPeriodChange": false,
                "boldPeriodBeginning": false,
                "centerLabelOnFullPeriod": false,
                "labelFunction": categoryAxisLabelFunction,
                "color": "#797C80" //TODO adjust color
            },
            "dataProvider": dataProvider
        };
    },

    _updateSettingsForExport: function _updateSettingsForExport(settings, chartData, config) {
        var scales = this._getChartScales(config);
        settings["marginTop"] *= scales.vertical;
        settings["marginBottom"] *= scales.vertical;
        settings["marginLeft"] *= scales.horizontal;
        settings["marginRight"] *= scales.horizontal;
        settings["fontSize"] = settings["fontSize"] * scales.common;
        settings["categoryAxis"]["fontSize"] *= scales.common;
        settings["categoryAxis"]["tickLength"] *= scales.common;
        settings["categoryAxis"]["labelOffset"] *= scales.common;
        _underscore2.default.each(settings["graphs"], function (graph) {
            if (graph["valueField"] == "today") {
                graph["bulletOffset"] *= scales.common;
                graph["bulletSize"] *= scales.common;
                graph["lineThickness"] *= scales.common;
                graph["dashLength"] *= scales.common;
            }
        });
    },

    _prepareDataProvider: function _prepareDataProvider(collectedData, maxScaleValue) {
        var dataProvider = [];
        var dataContext = collectedData.daysData;
        for (var i = 0; i < dataContext.length; i++) {
            var dayData = dataContext[i];

            var isToday = dayData.isToday;
            var isWeekend = dayData.isWeekend;
            var thereAreNoDayData = dayData.thereAreNoDayData;

            var dayDuration = isWeekend ? maxScaleValue : dayData.dayDuration;

            var balloon = thereAreNoDayData ? dayDuration : dayData.overtime + dayData.leaveTime + dayData.workingTimeRest;
            var oneDayContext = {
                "date": dayData.date,

                "workingTimeRest": dayData.workingTimeRest,
                "overtime": dayData.overtime,
                "leaveTime": dayData.leaveTime,
                "dayDuration": dayDuration,
                "balloon": balloon,

                "balloonContext": {
                    "date": dayData.date,
                    "workingTime": dayData.initialData.workingTime,
                    "overtime": dayData.initialData.overtime,
                    "leaveTime": dayData.initialData.leaveTime,
                    "isBeforeHireDate": dayData.isBeforeHireDate,
                    "isWeekend": isWeekend,
                    "thereAreNoDayData": thereAreNoDayData,
                    "corporateDayName": dayData.corporateDayName
                }
            };

            var defaultColorScheme = ColumnChartGenerator.colorScheme.DEFAULT;
            var dayDurationColor;
            if (isToday) {
                oneDayContext["today"] = maxScaleValue;
                oneDayContext["todayBullet"] = this._getTodayBulletURL();
                dayDurationColor = defaultColorScheme.todayDayDuration;
            } else {
                if (isWeekend) {
                    dayDurationColor = defaultColorScheme.weekendDuration;
                } else {
                    dayDurationColor = defaultColorScheme.dayDuration;
                }
            }
            oneDayContext["dayDurationColor"] = dayDurationColor;
            dataProvider.push(oneDayContext);
        }
        return dataProvider;
    },

    /**
     * Get additional event listeners specified for current chart
     */
    _getAdditionalEventListeners: function _getAdditionalEventListeners() {
        return [{
            "event": "clickGraphItem",
            "method": function method(event) {
                var date = event.item.dataContext.date;
                window.location.href = ViewTTPageUtils.createEnterTTURL(date);
            }
        }];
    },

    _getCollectedData: function _getCollectedData(dayInfoArray, userToday, userHireDate) {
        var maxSummaryDayData = 0;
        var daysData = [];
        for (var i = 0; i < dayInfoArray.length; i++) {
            var dayInfo = dayInfoArray[i];
            var date = dayInfo["date"];
            var isToday = date.isSameDate(userToday);

            var workDayDuration = dayInfo["workdayDuration"];
            var isWeekend = workDayDuration == 0;

            var leaveTime = 0;
            var initialLeaveTime = 0;
            if (!_underscore2.default.isNull(dayInfo["leave"])) {
                leaveTime = dayInfo["leave"]["leaveTime"];
                initialLeaveTime = leaveTime;
            }

            var overtime = 0;
            var initialOvertime = 0;
            if (!_underscore2.default.isNull(dayInfo["overtime"])) {
                var reportedOvertime = dayInfo["overtime"]["reported"];
                var autoOvertime = dayInfo["overtime"]["auto"];

                overtime = _underscore2.default.isNull(reportedOvertime) ? autoOvertime : reportedOvertime;
                initialOvertime = overtime;
                if (overtime < 0) {
                    overtime = 0;
                }
            }

            var initialWorkingTime = dayInfo["totalWorkingTime"];
            var workingTimeRest = initialWorkingTime - overtime;
            var dayDuration = workDayDuration - (workingTimeRest + overtime + leaveTime);
            if (dayDuration < 0) {
                dayDuration = 0;
            }

            var summaryDayData = dayDuration + overtime + workingTimeRest + leaveTime;

            if (summaryDayData > maxSummaryDayData) {
                maxSummaryDayData = summaryDayData;
            }

            var thereAreNoDayData = leaveTime == 0 && overtime == 0 && workingTimeRest == 0;

            // we need to convert data to hour because it more convenient
            daysData.push({
                "date": date,

                "dayDuration": this._toHour(dayDuration),
                "leaveTime": this._toHour(leaveTime),
                "workingTimeRest": this._toHour(workingTimeRest),
                "overtime": this._toHour(overtime),

                "isToday": isToday,
                "isWeekend": isWeekend,
                "thereAreNoDayData": thereAreNoDayData,
                "isBeforeHireDate": date < userHireDate,

                "initialData": {
                    "workingTime": initialWorkingTime,
                    "overtime": initialOvertime,
                    "leaveTime": initialLeaveTime
                },
                "corporateDayName": dayInfo.corporateDayName
            });
        }

        return {
            "maxSummaryDayData": this._toHour(maxSummaryDayData),
            "daysData": daysData
        };
    },
    _getValueAxisLabelFunction: function _getValueAxisLabelFunction() {
        var self = this;
        return function (val) {
            return self._formatDataTime(self._toMinutes(val));
        };
    },

    _getCategoryAxisLabelFunction: function _getCategoryAxisLabelFunction(dateFormat) {
        return function (_, date) {
            return dateFormat.formatDate(date);
        };
    },

    /**
     * Create function that returns category as is
     * Because we use already parsed dates in data provider
     */
    _getCategoryAxisFunction: function _getCategoryAxisFunction() {
        return function (date) {
            return date;
        };
    },

    _toHour: function _toHour(val) {
        return val / 60;
    },

    _toMinutes: function _toMinutes(val) {
        return val * 60;
    },

    _formatDataTime: function _formatDataTime(val) {
        return _user_time2.default.formatTime(val);
    },

    /*
     Get number of grids for horizontal axis
     Its depends on number of visible days
     */
    _getCategoryGridCount: function _getCategoryGridCount(collectedData) {
        var nDays = collectedData.daysData.length;
        var nGrids;
        if (nDays < 49) // ~7 weeks
            {
                nGrids = nDays / 7;
            } else if (nDays < 183) // ~6 month
            {
                nGrids = nDays / 30;
            } else if (nDays < 550) // ~6 quarter
            {
                nGrids = nDays / 90;
            } else {
            nGrids = nDays / 180;
        }
        return Math.ceil(nGrids);
    },

    _getMargins: function _getMargins(collectedData) {
        var nDays = collectedData.daysData.length;

        var left = 0;
        var right = 0;
        var top = 20;
        var bottom = 40;
        if (nDays <= 7) {
            left = 180;
            right = 160;
        } else if (nDays <= 14) {
            left = 110;
            right = 80;
        } else {
            left = 50;
            right = 5;
        }

        return {
            "top": top,
            "bottom": bottom,
            "left": left,
            "right": right
        };
    },

    _getTodayBulletURL: function _getTodayBulletURL() {
        return (0, _atBrowserUtils.atImgPath)("viewtt/today.png");
    },

    /**
     * Prepare graphs for chart. Every graph represents one type of column
     */
    _prepareChartGraphs: function _prepareChartGraphs(collectedData, colorScheme, dateFormat) {
        var defaultColorScheme = ColumnChartGenerator.colorScheme.DEFAULT;
        var graphs = [];
        graphs.push(this._createDataGraph("leaveTime", colorScheme.leaveTime), this._createDataGraph("workingTimeRest", colorScheme.workingTime), this._createDataGraph("overtime", colorScheme.overtime));

        var dayDurationGraph = _underscore2.default.extend(this._createDataGraph("dayDuration", ""), {
            "colorField": "dayDurationColor"
        });
        graphs.push(dayDurationGraph);
        // column for show today bullet and border
        var todayGraph = _underscore2.default.extend(this._createDataGraph("today", ""), {
            "bulletOffset": 5,
            "bulletSize": 30,
            "customBulletField": "todayBullet",
            "fillAlphas": 0,
            "lineAlpha": 0.6,
            "lineColor": defaultColorScheme.todayBorder,
            "lineThickness": 1,
            "dashLength": 3,
            "clustered": false,
            "newStack": true,
            "columnWidth": 0.9
        });
        graphs.push(todayGraph);
        // transparent column for show balloon
        var balloonGraph = _underscore2.default.extend(this._createDataGraph("balloon", "#FFFFFF"), {
            "newStack": true,
            "showBalloon": true,
            "balloonFunction": this._createBalloonFunction(dateFormat),
            "balloon": {
                "adjustBorderColor": false,
                "borderColor": defaultColorScheme.balloonBorder,
                "borderThickness": 1,
                "fillAlpha": 0.9
            },
            "fillAlphas": 0
        });
        graphs.push(balloonGraph);
        return graphs;
    },

    /**
     * Create base graph
     * @param valueField name for data provider
     * @param fillColor color of graph
     * @returns {{showBalloon: boolean, fillAlphas: number, fillColors: *, lineThickness: number, clustered: boolean, type: string, valueField: *}}
     * @private
     */
    _createDataGraph: function _createDataGraph(valueField, fillColor) {
        var fillAlpha = 0.85;
        return {
            "showBalloon": false,
            "fillAlphas": fillAlpha,
            "fillColors": fillColor,
            "lineAlpha": 0,
            "lineThickness": 0,
            "clustered": false,
            "type": "column",
            "valueField": valueField
        };
    },

    _createBalloonFunction: function _createBalloonFunction(dateFormat) {
        var balloonTemplate = _underscore2.default.template("<div class='daysChartBalloon'>" + "   <div class='date'>" + "       <%=dateFormat.formatDate(date)%> " + "           <%if(isBeforeHireDate){%>" + "               <%=messageResource.getMessage(\"view_tt.chart.balloon.before_hire\")%>" + "           <%} else if(isWeekend){%>" + "               <% if(corporateDayName){%>" + "                   <div class='separator'></div> " + "                   <%-corporateDayName%>" + "               <%}%>" + "               <%=messageResource.getMessage(\"view_tt.chart.balloon.weekend\")%>" + "           <%}%>" + "   </div>" + "   <div class='values'>" + "       <%if(workingTime != 0){%>" + "           <div><%=messageResource.getMessage(\"view_tt.chart.balloon.w_t\", [self._formatDataTime(workingTime)])%></div>" + "       <%}%>" + "       <%if(overtime != 0){%>" + "           <div><%=messageResource.getMessage(\"view_tt.chart.balloon.o_t\", [self._formatDataTime(overtime)])%></div>" + "       <%}%>" + "       <%if(leaveTime != 0){%>" + "           <div><%=messageResource.getMessage(\"view_tt.chart.balloon.l_t\", [self._formatDataTime(leaveTime)])%></div>" + "       <%}%>" + "       <%if(thereAreNoDayData){%>" + "           <%=messageResource.getMessage(\"view_tt.chart.balloon.t_t\", [self._formatDataTime(0)])%>" + "       <%}%>" + "   </div>" + "   <div class='enterTtNote'><%=messageResource.getMessage(\"view_tt.chart.balloon.click_note\")%></div>" + "</div>");

        var self = this;
        return function (item) {
            var context = item.dataContext;
            return balloonTemplate(_underscore2.default.extend(context["balloonContext"], { self: self, dateFormat: dateFormat }));
        };
    }
});

ColumnChartGenerator.colorScheme = {
    "DEFAULT": {
        "workingTime": "#397ec0",
        "overtime": "#7cd5da",
        "leaveTime": "#9a7eda",
        "dayDuration": "#F3F5F6",
        "todayDayDuration": "#FFF4C1",
        "weekendDuration": "#E0E6EC",
        "todayBorder": "#232323",
        "balloonBorder": "#b2b2b2"
    },
    "DEFAULT_GREY": {
        "workingTime": "#697f92",
        "overtime": "#8ed6e2",
        "leaveTime": "#a797cc"
    },
    "ORANGE": {
        "workingTime": "#70839e",
        "overtime": "#95cb61",
        "leaveTime": "#d9862e"
    },
    "ORANGE_GREY": {
        "workingTime": "#697f92",
        "overtime": "#91b56f",
        "leaveTime": "#d2a06b"
    },
    "RED": {
        "workingTime": "#70839e",
        "overtime": "#95cb61",
        "leaveTime": "#cf7272"
    },
    "RED_GREY": {
        "workingTime": "#697f92",
        "overtime": "#91b56f",
        "leaveTime": "#bc7c7c"
    }
};

exports.default = ColumnChartGenerator;

/***/ }),
/* 1764 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Ext = __webpack_require__(12);

var _Ext2 = _interopRequireDefault(_Ext);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
    This class extends Ext.form.ComboBox and prevents showing of a drop-down panel with the "Loading ..." text.
*/

var RemoteComboWithouLoadingState = _Ext2.default.extend(_Ext2.default.form.ComboBox, {

    initComponent: function initComponent() {
        RemoteComboWithouLoadingState.superclass.initComponent.call(this);

        // this work-around prevents visual glitches when empty results loaded
        var me = this;
        this.store.on("beforeload", function () {
            me.expandDisabled = true;
        });

        this.store.on("load", function () {
            me.expandDisabled = false;
        });
    },

    // this is necessary to avoid 'Loading ...' view
    onBeforeLoad: function onBeforeLoad() {
        if (!this.hasFocus) return;
        this.restrictHeight();
        this.selectedIndex = -1;
    },

    // this work-around prevents visual glitches when empty results loaded
    expand: function expand() {
        if (!this.expandDisabled) RemoteComboWithouLoadingState.superclass.expand.call(this);
    }
});

exports.default = RemoteComboWithouLoadingState;

/***/ }),
/* 1765 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Ext = __webpack_require__(12);

var _Ext2 = _interopRequireDefault(_Ext);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
This class extends Ext.data.DataProxy and implements loading of data using existing StringIndex
*/

function StringIndexDataProxy(stringIndex, idPropName, dataArray) {
    StringIndexDataProxy.superclass.constructor.call(this);
    this.stringIndex = stringIndex;
    this.idPropName = idPropName;
    this.dataArray = dataArray;
}

_Ext2.default.extend(StringIndexDataProxy, _Ext2.default.data.DataProxy, {

    load: function load(params, reader, callback, scope, arg) {
        var result;
        if (params.searchTokens) result = this.filterBy(this.stringIndex.search(params.searchTokens));else result = this.dataArray;

        var o = reader.readRecords(result);
        setTimeout(function () {
            callback.call(scope, o, arg, true);
        }, 1);
    },

    filterBy: function filterBy(searchResults) {
        var result = [];
        for (var i = 0; i < this.dataArray.length; i++) {
            var obj = this.dataArray[i];
            if (searchResults[obj[this.idPropName]] != undefined) result.push(obj);
        }
        return result;
    }
});

exports.default = StringIndexDataProxy;

/***/ }),
/* 1766 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _TabularDataWithEffectiveDatesTableRow = __webpack_require__(910);

var _TabularDataWithEffectiveDatesTableRow2 = _interopRequireDefault(_TabularDataWithEffectiveDatesTableRow);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _TabularDataTableCell = __webpack_require__(908);

var _TabularDataTableCell2 = _interopRequireDefault(_TabularDataTableCell);

var _TabularDataTableCellValidator = __webpack_require__(911);

var _TabularDataTableCellValidator2 = _interopRequireDefault(_TabularDataTableCellValidator);

var _TableCell = __webpack_require__(166);

var _TableCell2 = _interopRequireDefault(_TableCell);

var _WorkdayDurationsEditor = __webpack_require__(260);

var _WorkdayDurationsEditor2 = _interopRequireDefault(_WorkdayDurationsEditor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function WorkdayDurationsTableRow() {}

WorkdayDurationsTableRow.prototype = _underscore2.default.create(_TabularDataWithEffectiveDatesTableRow2.default.prototype);

WorkdayDurationsTableRow.prototype.init = function (defaultSchedule, durationsCellIdx, deletable, effectiveDate, changesCallback) {
    _TabularDataWithEffectiveDatesTableRow2.default.prototype.init.call(this);
    this.validatableCells = [];
    this.defaultSchedule = defaultSchedule;
    this.deletable = deletable;
    this.changesCallback = changesCallback;
    this.markedAsDefault = false;
    this.oldEffectiveDate = null;
    return this;
};

WorkdayDurationsTableRow.prototype.setOldEffectiveDate = function (date) {
    this.oldEffectiveDate = date;
};

WorkdayDurationsTableRow.prototype.getOldEffectiveDate = function () {
    return this.oldEffectiveDate;
};

WorkdayDurationsTableRow.prototype.addCellObj = function (cellObj, validatable) {
    _TabularDataWithEffectiveDatesTableRow2.default.prototype.addCellObj.call(this, cellObj);
    if (validatable) this.validatableCells.push(cellObj);
};

WorkdayDurationsTableRow.prototype.canBeDeletedPermanently = function () {
    return this.deletable ? true : false;
};

WorkdayDurationsTableRow.prototype.validate = function () {
    var valid = true;
    for (var i = 0; i < this.validatableCells.length; i++) {
        this.validatableCells[i].validate(false);
        valid = valid && this.validatableCells[i].isValid();
    }
    return valid;
};

WorkdayDurationsTableRow.prototype.createDurationsCell = function (durations, durationsCellValidator, durationsCellRenderer) {
    var cell = new _TabularDataTableCell2.default();
    cell.init(durations, durationsCellValidator, this);
    cell.setRenderer(durationsCellRenderer);
    return cell;
};

WorkdayDurationsTableRow.prototype.createTotalCell = function (total, totalCellRenderer) {
    var cell = new _TableCell2.default(total);
    cell.setRenderer(totalCellRenderer);
    return cell;
};

WorkdayDurationsTableRow.prototype.createSetAsDefaultCell = function (isDefault, setAsDefaultCellRenderer) {
    var setAsDefaultCell = new _TabularDataTableCell2.default().init(isDefault, new _TabularDataTableCellValidator2.default().init(), this);
    setAsDefaultCell.setRenderer(setAsDefaultCellRenderer);
    return setAsDefaultCell;
};

WorkdayDurationsTableRow.prototype.setupTotalAndDefaultCellUpdates = function (totalCell, setAsDefaultCell, durationsCell, changeCallback) {
    var self = this;
    setAsDefaultCell.onChange(function () {
        self.setMarkedAsDefault(setAsDefaultCell.getValue() ? true : false);
        if (self.isMarkedAsDefault()) durationsCell.setValue(self.defaultSchedule.slice());else if (changeCallback) changeCallback();
        durationsCell.updateUI();
        if (self.changesCallback) self.changesCallback();
    });

    durationsCell.onChange(function () {
        if (durationsCell.isValid()) {
            if (changeCallback) changeCallback();
            totalCell.setValue(_WorkdayDurationsEditor2.default.sumDurations(durationsCell.getValue()));
            totalCell.updateUI();
        }
    });
};

// Override it to avoid renderers substitution
WorkdayDurationsTableRow.prototype.writeCellsContent = function () {
    for (var i = 0; i < this.cells.length; i++) {
        var cell = this.cells[i];
        cell.writeContent();
    }
};

WorkdayDurationsTableRow.prototype.isEmpty = function () {
    var effectiveDateCell = this.validatableCells[0];
    return effectiveDateCell.isEmpty();
};

WorkdayDurationsTableRow.prototype.hasErrors = function () {
    if (this.isMarkedToRemove()) return false;

    for (var i = 0; i < this.validatableCells.length; i++) {
        if (!this.validatableCells[i].isValid()) return true;
    }return false;
};

WorkdayDurationsTableRow.prototype.isMarkedAsDefault = function () {
    return this.markedAsDefault;
};

WorkdayDurationsTableRow.prototype.setMarkedAsDefault = function (markedAsDefault) {
    this.markedAsDefault = markedAsDefault;
};

exports.default = WorkdayDurationsTableRow;

/***/ }),
/* 1767 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TableCell2 = __webpack_require__(166);

var _TableCell3 = _interopRequireDefault(_TableCell2);

var _LoadingMoire = __webpack_require__(92);

var _LoadingMoire2 = _interopRequireDefault(_LoadingMoire);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LoadingCell = function (_TableCell) {
    _inherits(LoadingCell, _TableCell);

    function LoadingCell(rowObj) {
        _classCallCheck(this, LoadingCell);

        return _possibleConstructorReturn(this, (LoadingCell.__proto__ || Object.getPrototypeOf(LoadingCell)).call(this, null, rowObj));
    }

    _createClass(LoadingCell, [{
        key: "toggleLoading",
        value: function toggleLoading(loading) {
            if (!this.loadingMoire) this.loadingMoire = new _LoadingMoire2.default().init(this.$cell);
            if (loading) this.loadingMoire.show();else this.loadingMoire.hide();
        }
    }, {
        key: "updateUI",
        value: function updateUI() {}
    }, {
        key: "updateCell",
        value: function updateCell() {}
    }, {
        key: "writeContent",
        value: function writeContent() {
            this.$cell = (0, _jquery2.default)(this.getCellEl());
            this.$cell.addClass('loadingCell');
        }
    }]);

    return LoadingCell;
}(_TableCell3.default);

exports.default = LoadingCell;

/***/ }),
/* 1768 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = init;

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _Page = __webpack_require__(1769);

var _Page2 = _interopRequireDefault(_Page);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function init() {
    new _Page2.default().init((0, _jquery2.default)('.workflowSettingsPage'));
}

/***/ }),
/* 1769 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Page = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _LoadingContainer = __webpack_require__(28);

var _LoadingContainer2 = _interopRequireDefault(_LoadingContainer);

var _PageContent = __webpack_require__(1770);

var _PageContent2 = _interopRequireDefault(_PageContent);

var _utils = __webpack_require__(6);

var _redux = __webpack_require__(7);

var _actions = __webpack_require__(912);

var _selectors = __webpack_require__(566);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Page = exports.Page = function (_TemplateView) {
    _inherits(Page, _TemplateView);

    function Page(_ref) {
        var loadData = _ref.loadData;

        _classCallCheck(this, Page);

        var _this = _possibleConstructorReturn(this, (Page.__proto__ || Object.getPrototypeOf(Page)).call(this, null));

        _this.state = {
            firstLoading: false
        };

        _this.actions = {
            loadData: loadData
        };

        _this.onStatePropertyChanged("firstLoading", function (firstLoading, prevFirstLoading) {
            _this.loadingContainer.setState({ loading: firstLoading });

            if (firstLoading !== prevFirstLoading && firstLoading === true) {
                _this.actions.loadData();
            }
        });
        return _this;
    }

    _createClass(Page, [{
        key: "templateHtml",
        value: function templateHtml() {
            return '<div class="page"\>';
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            this.contentComponent = new _PageContent2.default();
            this.loadingContainer = new _LoadingContainer2.default({
                contentComponent: this.contentComponent,
                containerClass: 'workflowSettingsPageLoadingContainer',
                loadingMoireConfig: {
                    additionalSpinnerSettings: {
                        radius: 16
                    }
                },
                showAnimated: false,
                proxySetState: false
            }).init(this.getEl());
        }
    }]);

    return Page;
}(_TemplateView3.default);

exports.default = (0, _utils.connect)(function (state) {
    return {
        firstLoading: (0, _selectors.isFirstLoading)(state)
    };
}, function (dispatch) {
    return {
        loadData: (0, _redux.bindActionCreators)(_actions.loadData, dispatch)
    };
})(Page);

/***/ }),
/* 1770 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.PageContent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _StatusesSectionWrapper = __webpack_require__(1771);

var _StatusesSectionWrapper2 = _interopRequireDefault(_StatusesSectionWrapper);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _EditWorkflowStatusDialog = __webpack_require__(1772);

var _EditWorkflowStatusDialog2 = _interopRequireDefault(_EditWorkflowStatusDialog);

var _SelectColorContent = __webpack_require__(1773);

var _SelectColorContent2 = _interopRequireDefault(_SelectColorContent);

var _DialogFooter = __webpack_require__(1775);

var _DialogFooter2 = _interopRequireDefault(_DialogFooter);

var _constants = __webpack_require__(23);

var _actions = __webpack_require__(912);

var _selectors = __webpack_require__(566);

var _EditWorkflowStatusDialogWrapper = __webpack_require__(1777);

var _EditWorkflowStatusDialogWrapper2 = _interopRequireDefault(_EditWorkflowStatusDialogWrapper);

var _constants2 = __webpack_require__(180);

var _LoadingContainer = __webpack_require__(28);

var _LoadingContainer2 = _interopRequireDefault(_LoadingContainer);

var _InfoContent = __webpack_require__(1778);

var _InfoContent2 = _interopRequireDefault(_InfoContent);

var _LoadingSpinner = __webpack_require__(191);

var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);

var _StatusesListContainer = __webpack_require__(1779);

var _StatusesListContainer2 = _interopRequireDefault(_StatusesListContainer);

var _redux = __webpack_require__(7);

var _utils = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PageContent = exports.PageContent = function (_TemplateView) {
    _inherits(PageContent, _TemplateView);

    function PageContent(_ref) {
        var addNewStatusAction = _ref.addNewStatusAction,
            changeWorkflowStatusPosition = _ref.changeWorkflowStatusPosition,
            createOrEditWorkflowStatus = _ref.createOrEditWorkflowStatus,
            deleteWorkflowStatus = _ref.deleteWorkflowStatus,
            updateEditingStatusColorIdAction = _ref.updateEditingStatusColorIdAction,
            startEditStatusAction = _ref.startEditStatusAction,
            updateEditingStatusNameAction = _ref.updateEditingStatusNameAction,
            cancelEditOrCreateStatusAction = _ref.cancelEditOrCreateStatusAction;

        _classCallCheck(this, PageContent);

        var _this = _possibleConstructorReturn(this, (PageContent.__proto__ || Object.getPrototypeOf(PageContent)).call(this, null));

        _this._handleDeleteStatusClick = function (id) {
            _this.actions.deleteWorkflowStatus(id);
        };

        _this._handleAddNewStatusClick = function (type) {
            _this.actions.addNewStatusAction(type);
        };

        _this.state = {
            loading: false,
            statuses: [],
            showEditStatusDialog: false,
            editingStatus: {
                id: null,
                name: '',
                colorId: -1
            },
            errors: []
        };
        _this.actions = {
            addNewStatusAction: addNewStatusAction,
            changeWorkflowStatusPosition: changeWorkflowStatusPosition,
            createOrEditWorkflowStatus: createOrEditWorkflowStatus,
            deleteWorkflowStatus: deleteWorkflowStatus,
            updateEditingStatusNameAction: updateEditingStatusNameAction,
            updateEditingStatusColorIdAction: updateEditingStatusColorIdAction,
            startEditStatusAction: startEditStatusAction,
            cancelEditOrCreateStatusAction: cancelEditOrCreateStatusAction
        };

        _this.onStatePropertyChanged('loading', function (loading) {
            _this.loadingSpinner.setState({ show: loading });
            _this.editWorkflowStatusDialog.setState({ loading: loading });
            _this.statusesSection.setState({ loading: loading });
        });

        _this.onStatePropertyChanged('showEditStatusDialog', function (showEditStatusDialog) {
            if (!showEditStatusDialog) _this.editWorkflowStatusDialog.hide();
        });

        _this.onStatePropertyChanged('statuses', function (statuses) {
            _this.openStatusesList.setState({
                statuses: statuses.filter(function (s) {
                    return s.type === _constants.WorkflowStatusType.OPEN;
                })
            });
            _this.completedStatusesList.setState({
                statuses: statuses.filter(function (s) {
                    return s.type === _constants.WorkflowStatusType.COMPLETED;
                })
            });
        });

        _this.onStatePropertyDeeplyChanged('editingStatus', function () {
            _this.editWorkflowStatusDialog.setState({
                statusName: _this.state.editingStatus.name,
                errors: _this.state.errors
            });

            _this.openStatusesSection.setState({
                newStatusInEdit: _this.state.editingStatus.id === _constants2.NEW_STATUS_ID && _this.state.editingStatus.type === _constants.WorkflowStatusType.OPEN
            });
            _this.completedStatusesSection.setState({
                newStatusInEdit: _this.state.editingStatus.id === _constants2.NEW_STATUS_ID && _this.state.editingStatus.type === _constants.WorkflowStatusType.COMPLETED
            });
            _this.openStatusesList.setState({ editItemId: _this.state.editingStatus.id });
            _this.completedStatusesList.setState({ editItemId: _this.state.editingStatus.id });
            _this.selectColorDialog.setState({ selectedColorId: _this.state.editingStatus.colorId });
        });

        _this.onStatePropertyChanged('errors', function (errors) {
            _this.editWorkflowStatusDialog.setState({ errors: errors });
            _this._handleErrors();
        });
        return _this;
    }

    _createClass(PageContent, [{
        key: "templateHtml",
        value: function templateHtml() {
            return '<div class="page">' + '    <div class="header">' + '        <div class="pagetitle"><%-pageTitle%></div>' + '    </div>' + '    <div class="pageContent">' + '    </div>' + '</div>';
        }
    }, {
        key: "messageKeys",
        value: function messageKeys() {
            return {
                pageTitle: "workflow_settings.page_title"
            };
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            var _this2 = this;

            this.loadingSpinner = new _LoadingSpinner2.default({
                config: {
                    radius: 8,
                    length: 5
                },
                delay: 500
            }).init(this.find('.header'));

            new _InfoContent2.default().init(this.find('.pageContent'));

            this.selectColorDialog = new _SelectColorContent2.default({
                onSelectColorCb: function onSelectColorCb(colorId) {
                    return _this2.actions.updateEditingStatusColorIdAction(colorId);
                }
            });

            var dialog = new _EditWorkflowStatusDialog2.default({
                selectColorContent: this.selectColorDialog,
                dialogFooter: new _DialogFooter2.default({
                    submitBtnLabel: _messageResource2.default.getMessage('common.apply'),
                    cancelBtnLabel: _messageResource2.default.getMessage('common.cancel'),
                    onSubmitCb: function onSubmitCb() {
                        _this2.actions.createOrEditWorkflowStatus();
                    },
                    onCancelCb: function onCancelCb() {
                        _this2.editWorkflowStatusDialog.hide();
                    }
                }),
                onNameChangedCb: function onNameChangedCb(name) {
                    return _this2.actions.updateEditingStatusNameAction(name);
                }
            });

            this.editWorkflowStatusDialog = new _EditWorkflowStatusDialogWrapper2.default(null, {
                className: 'editWorkflowStatusDialogWrapper',
                dialog: new _LoadingContainer2.default({
                    contentComponent: dialog,
                    containerClass: 'editWorkflowStatusDialogLoadingContainer'
                }),
                preventHide: function preventHide() {
                    return _this2.state.loading;
                },
                onHide: function onHide() {
                    _this2.actions.cancelEditOrCreateStatusAction();
                }
            }).init(this.getEl());

            this.openStatusesList = new _StatusesListContainer2.default({
                onPositionChangedCb: this.actions.changeWorkflowStatusPosition,
                onStatusNameClickCb: function onStatusNameClickCb($el, id) {
                    _this2.actions.startEditStatusAction(id);
                    _this2.editWorkflowStatusDialog.showAt($el);
                },
                onItemDeleteClickCb: this._handleDeleteStatusClick
            });

            this.openStatusesSection = new _StatusesSectionWrapper2.default({
                title: _messageResource2.default.getMessage("workflow_settings.open_tasks_statuses_section.title"),
                listContainer: this.openStatusesList,
                onAddBtnClickCb: function onAddBtnClickCb($el) {
                    _this2._handleAddNewStatusClick(_constants.WorkflowStatusType.OPEN);
                    _this2.editWorkflowStatusDialog.showAt($el);
                }
            });

            this.completedStatusesList = new _StatusesListContainer2.default({
                onPositionChangedCb: this.actions.changeWorkflowStatusPosition,
                onStatusNameClickCb: function onStatusNameClickCb($el, id) {
                    _this2.actions.startEditStatusAction(id);
                    _this2.editWorkflowStatusDialog.showAt($el);
                },
                onItemDeleteClickCb: function onItemDeleteClickCb(id) {
                    return _this2.actions.deleteWorkflowStatus(id);
                }
            });

            this.completedStatusesSection = new _StatusesSectionWrapper2.default({
                title: _messageResource2.default.getMessage("workflow_settings.completed_tasks_statuses_section.title"),
                listContainer: this.completedStatusesList,
                onAddBtnClickCb: function onAddBtnClickCb($el) {
                    _this2._handleAddNewStatusClick(_constants.WorkflowStatusType.COMPLETED);
                    _this2.editWorkflowStatusDialog.showAt($el);
                }
            });

            this.statusesSection = new _LoadingContainer2.default({
                contentComponent: [this.openStatusesSection, this.completedStatusesSection],
                containerClass: 'workflowStatusesSection',
                loadingMoireConfig: {
                    delay: 500
                }
            }).init(this.find('.pageContent'));
        }
    }, {
        key: "_handleErrors",
        value: function _handleErrors() {
            this.state.errors.forEach(function (error) {
                if (error === _constants2.ValidationErrors.STATUS_DELETED) {
                    alert(_messageResource2.default.getMessage('workflow_settings.errors.status_deleted'));
                }

                if (error === _constants2.ValidationErrors.STATUS_IN_USE) {
                    alert(_messageResource2.default.getMessage('workflow_settings.errors.status_in_use'));
                }

                if (error === _constants2.ValidationErrors.STATUS_IS_LAST) {
                    alert(_messageResource2.default.getMessage('workflow_settings.errors.status_is_last'));
                }
            });
        }
    }]);

    return PageContent;
}(_TemplateView3.default);

exports.default = (0, _utils.connect)(function (state) {
    return {
        loading: (0, _selectors.isLoading)(state),
        statuses: (0, _selectors.getPageStatuses)(state),
        showEditStatusDialog: (0, _selectors.isShowEditStatusDialog)(state),
        editingStatus: (0, _selectors.getEditDialogData)(state),
        errors: (0, _selectors.getErrors)(state)
    };
}, function (dispatch) {
    return {
        addNewStatusAction: (0, _redux.bindActionCreators)(_actions.addNewStatusAction, dispatch),
        changeWorkflowStatusPosition: (0, _redux.bindActionCreators)(_actions.changeWorkflowStatusPosition, dispatch),
        createOrEditWorkflowStatus: (0, _redux.bindActionCreators)(_actions.createOrEditWorkflowStatus, dispatch),
        deleteWorkflowStatus: (0, _redux.bindActionCreators)(_actions.deleteWorkflowStatus, dispatch),
        updateEditingStatusColorIdAction: (0, _redux.bindActionCreators)(_actions.updateEditingStatusColorIdAction, dispatch),
        startEditStatusAction: (0, _redux.bindActionCreators)(_actions.startEditStatusAction, dispatch),
        updateEditingStatusNameAction: (0, _redux.bindActionCreators)(_actions.updateEditingStatusNameAction, dispatch),
        cancelEditOrCreateStatusAction: (0, _redux.bindActionCreators)(_actions.cancelEditOrCreateStatusAction, dispatch)
    };
})(PageContent);

/***/ }),
/* 1771 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _Button = __webpack_require__(33);

var _Button2 = _interopRequireDefault(_Button);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _LoadingControlMixin = __webpack_require__(136);

var _LoadingControlMixin2 = _interopRequireDefault(_LoadingControlMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var StatusesSectionWrapper = function (_TemplateView) {
    _inherits(StatusesSectionWrapper, _TemplateView);

    function StatusesSectionWrapper(_ref) {
        var title = _ref.title,
            listContainer = _ref.listContainer,
            _ref$onAddBtnClickCb = _ref.onAddBtnClickCb,
            onAddBtnClickCb = _ref$onAddBtnClickCb === undefined ? function () {} : _ref$onAddBtnClickCb;

        _classCallCheck(this, StatusesSectionWrapper);

        var _this = _possibleConstructorReturn(this, (StatusesSectionWrapper.__proto__ || Object.getPrototypeOf(StatusesSectionWrapper)).call(this, null));

        _this.params = {
            title: title
        };

        _this.components = {
            listContainer: listContainer
        };

        _this.callbacks = {
            onAddBtnClickCb: onAddBtnClickCb
        };

        _this.state = {
            newStatusInEdit: false
        };

        _this.onStatePropertyChanged('newStatusInEdit', function (newStatusInEdit) {
            return _this._setAddNewBtnEditMode(newStatusInEdit);
        });
        return _this;
    }

    _createClass(StatusesSectionWrapper, [{
        key: "templateHtml",
        value: function templateHtml() {
            return '<div class="statusesSection">' + '    <div class="title"><%-title%></div>' + '    <div class="addBtn"></div>' + '</div>';
        }
    }, {
        key: "templateModel",
        value: function templateModel() {
            return {
                title: this.params.title
            };
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            var _this2 = this;

            this.addNewBtn = new _Button2.default({
                label: _messageResource2.default.getMessage("workflow_settings.add_new_status"),
                withPlusIcon: true,
                onClickCb: function onClickCb(e) {
                    return _this2.callbacks.onAddBtnClickCb(_this2.addNewBtn.getEl(), e);
                }
            }).init(this.find('.addBtn'));

            this.components.listContainer.init(this.getEl());
        }
    }, {
        key: "_setAddNewBtnEditMode",
        value: function _setAddNewBtnEditMode(newStatusInEdit) {
            this.addNewBtn.getEl().toggleClass('inEdit', newStatusInEdit);
        }
    }]);

    return StatusesSectionWrapper;
}(_TemplateView3.default);

exports.default = StatusesSectionWrapper;

/***/ }),
/* 1772 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _constants = __webpack_require__(23);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _constants2 = __webpack_require__(180);

var _constants3 = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EditWorkflowStatusDialog = function (_TemplateView) {
    _inherits(EditWorkflowStatusDialog, _TemplateView);

    function EditWorkflowStatusDialog(_ref) {
        var selectColorContent = _ref.selectColorContent,
            dialogFooter = _ref.dialogFooter,
            onNameChangedCb = _ref.onNameChangedCb,
            _ref$onHideCb = _ref.onHideCb,
            onHideCb = _ref$onHideCb === undefined ? function () {} : _ref$onHideCb;

        _classCallCheck(this, EditWorkflowStatusDialog);

        var _this = _possibleConstructorReturn(this, (EditWorkflowStatusDialog.__proto__ || Object.getPrototypeOf(EditWorkflowStatusDialog)).call(this, null));

        _this.state = {
            statusId: -1,
            statusType: _constants.WorkflowStatusType.OPEN,
            statusName: '',
            errors: []
        };

        _this.components = {
            selectColorContent: selectColorContent,
            dialogFooter: dialogFooter
        };

        _this.callbacks = {
            onNameChangedCb: onNameChangedCb,
            onHideCb: onHideCb
        };

        _this.onStatePropertyChanged('statusName', function () {
            _this.nameField.val(_this.state.statusName);
        });

        _this.onStatePropertyChanged('errors', function () {
            _this._updateErrors();
        });

        return _this;
    }

    _createClass(EditWorkflowStatusDialog, [{
        key: "templateHtml",
        value: function templateHtml() {
            return '<div class="editWorkflowStatusDialog">' + '    <div class="content">' + '        <input class="nameField inputFieldWithPlaceholder" maxlength="<%=maxNameLength%>" placeholder="<%-statusNamePlaceholder%>"/>' + '        <div class="nameFieldErrorWrapper">' + '            <div class="nameFieldError"></div>' + '        </div>' + '    </div>' + '</div>';
        }
    }, {
        key: "templateModel",
        value: function templateModel() {
            return {
                maxNameLength: _constants3.EntityTextLimits.MAX_WORKFLOW_STATUS_NAME
            };
        }
    }, {
        key: "messageKeys",
        value: function messageKeys() {
            return {
                statusNamePlaceholder: "workflow_settings.status_name_placeholder"
            };
        }
    }, {
        key: "show",
        value: function show() {
            _get(EditWorkflowStatusDialog.prototype.__proto__ || Object.getPrototypeOf(EditWorkflowStatusDialog.prototype), "show", this).call(this);
            this.nameField.focus();
        }
    }, {
        key: "hide",
        value: function hide() {
            _get(EditWorkflowStatusDialog.prototype.__proto__ || Object.getPrototypeOf(EditWorkflowStatusDialog.prototype), "hide", this).call(this);
            this.callbacks.onHideCb();
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            this.content = this.find('.content');
            this.components.selectColorContent.init(this.content);
            this.components.dialogFooter.init(this.getEl());
            this.nameField = this.find('.nameField');
            this.nameFieldError = this.find('.nameFieldError');

            this._subscribeForEvents();
        }
    }, {
        key: "_subscribeForEvents",
        value: function _subscribeForEvents() {
            var _this2 = this;

            this.nameField.on('blur', function () {
                var val = _this2.nameField.val().trim();
                if (_this2.state.statusName !== val) _this2.callbacks.onNameChangedCb(val);
            });
        }
    }, {
        key: "_updateErrors",
        value: function _updateErrors() {
            this.nameField.removeClass('error');
            this.nameFieldError.hide();

            if (this.state.errors.includes(_constants2.ValidationErrors.DUPLICATE_NAME_ERROR)) {
                this.nameField.addClass('error');
                this.nameFieldError.text(_messageResource2.default.getMessage('workflow_settings.errors.duplicate_name'));
                this.nameFieldError.show();
            }

            if (this.state.errors.includes(_constants2.ValidationErrors.EMPTY_NAME_ERROR)) {
                this.nameField.addClass('error');
                this.nameFieldError.text(_messageResource2.default.getMessage('workflow_settings.errors.empty_name'));
                this.nameFieldError.show();
            }
        }
    }]);

    return EditWorkflowStatusDialog;
}(_TemplateView3.default);

exports.default = EditWorkflowStatusDialog;

/***/ }),
/* 1773 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _Checkbox = __webpack_require__(1774);

var _Checkbox2 = _interopRequireDefault(_Checkbox);

var _constants = __webpack_require__(23);

var _utils = __webpack_require__(80);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SelectColorContent = function (_TemplateView) {
    _inherits(SelectColorContent, _TemplateView);

    function SelectColorContent(_ref) {
        var _ref$onSelectColorCb = _ref.onSelectColorCb,
            onSelectColorCb = _ref$onSelectColorCb === undefined ? function () {} : _ref$onSelectColorCb;

        _classCallCheck(this, SelectColorContent);

        var _this = _possibleConstructorReturn(this, (SelectColorContent.__proto__ || Object.getPrototypeOf(SelectColorContent)).call(this, null));

        _this.params = {
            colorItems: Object.values(_constants.COLORS)
        };

        _this.state = {
            selectedColorId: -1
        };

        _this.checkboxes = {};

        _this.callbacks = {
            onSelectColorCb: onSelectColorCb
        };

        _this.onStatePropertyChanged('selectedColorId', function () {
            _this._updateCheckboxes();
        });
        return _this;
    }

    _createClass(SelectColorContent, [{
        key: "templateHtml",
        value: function templateHtml() {
            return '<div class="selectColorContainer"/>';
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            var _this2 = this;

            this.checkboxes = {};
            this.params.colorItems.forEach(function (id) {
                _this2.checkboxes[id] = new _Checkbox2.default({
                    boxClasses: (0, _utils.getColorClassById)(id),
                    onClickCb: function onClickCb() {
                        _this2.setState({
                            selectedColorId: id
                        });
                        _this2.callbacks.onSelectColorCb(id);
                    }
                }).init(_this2.getEl());
            });
        }
    }, {
        key: "_updateCheckboxes",
        value: function _updateCheckboxes() {
            var _this3 = this;

            this.params.colorItems.forEach(function (id) {
                _this3.checkboxes[id].setState({
                    checked: _this3.getState().selectedColorId === id
                });
            });
        }
    }]);

    return SelectColorContent;
}(_TemplateView3.default);

exports.default = SelectColorContent;

/***/ }),
/* 1774 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Checkbox = function (_TemplateView) {
    _inherits(Checkbox, _TemplateView);

    function Checkbox(_ref) {
        var boxClasses = _ref.boxClasses,
            _ref$onClickCb = _ref.onClickCb,
            onClickCb = _ref$onClickCb === undefined ? function () {} : _ref$onClickCb;

        _classCallCheck(this, Checkbox);

        var _this = _possibleConstructorReturn(this, (Checkbox.__proto__ || Object.getPrototypeOf(Checkbox)).call(this, null));

        _this.params = {
            boxClasses: boxClasses
        };

        _this.state = {
            checked: false
        };

        _this.onClickCb = onClickCb;

        _this.onStatePropertyChanged('checked', function () {
            _this.getEl().toggleClass('checked', _this.state.checked);
        });
        return _this;
    }

    _createClass(Checkbox, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class="checkbox <%-boxClasses%>"/>';
        }
    }, {
        key: 'templateModel',
        value: function templateModel() {
            return {
                boxClasses: this.params.boxClasses
            };
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            var _this2 = this;

            this.getEl().on("click", function () {
                _this2.setState({ checked: true });
                _this2.onClickCb();
            });
        }
    }]);

    return Checkbox;
}(_TemplateView3.default);

exports.default = Checkbox;

/***/ }),
/* 1775 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _Button = __webpack_require__(33);

var _Button2 = _interopRequireDefault(_Button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DialogFooter = function (_TemplateView) {
    _inherits(DialogFooter, _TemplateView);

    function DialogFooter(_ref) {
        var submitBtnLabel = _ref.submitBtnLabel,
            cancelBtnLabel = _ref.cancelBtnLabel,
            _ref$onSubmitCb = _ref.onSubmitCb,
            onSubmitCb = _ref$onSubmitCb === undefined ? function () {} : _ref$onSubmitCb,
            _ref$onCancelCb = _ref.onCancelCb,
            onCancelCb = _ref$onCancelCb === undefined ? function () {} : _ref$onCancelCb;

        _classCallCheck(this, DialogFooter);

        var _this = _possibleConstructorReturn(this, (DialogFooter.__proto__ || Object.getPrototypeOf(DialogFooter)).call(this, null));

        _this.params = {
            submitBtnLabel: submitBtnLabel,
            cancelBtnLabel: cancelBtnLabel
        };

        _this.callbacks = {
            onSubmitCb: onSubmitCb,
            onCancelCb: onCancelCb
        };
        return _this;
    }

    _createClass(DialogFooter, [{
        key: "templateHtml",
        value: function templateHtml() {
            return '<div class="dialogFooter">';
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            new _Button2.default({
                additionalClass: 'applyBtn',
                label: this.params.submitBtnLabel,
                onClickCb: this.callbacks.onSubmitCb
            }).init(this.getEl());

            new _Button2.default({
                additionalClass: 'cancelBtn',
                label: this.params.cancelBtnLabel,
                onClickCb: this.callbacks.onCancelCb
            }).init(this.getEl());
        }
    }]);

    return DialogFooter;
}(_TemplateView3.default);

exports.default = DialogFooter;

/***/ }),
/* 1776 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.addNewWorkflowStatus = addNewWorkflowStatus;
exports.updateWorkflowStatus = updateWorkflowStatus;
exports.deleteWorkflowStatus = deleteWorkflowStatus;
exports.updateWorkflowStatusPosition = updateWorkflowStatusPosition;
exports.getPageData = getPageData;

var _rpcCalls = __webpack_require__(24);

var _constants = __webpack_require__(180);

var _utils = __webpack_require__(118);

var _constants2 = __webpack_require__(78);

var _constants3 = __webpack_require__(4);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function addNewWorkflowStatus(status) {
    return (0, _rpcCalls.rpcCall)("WorkflowStatusesService.addWorkflowStatus", [status.name, status.colorId, status.type], _handleError);
}

function updateWorkflowStatus(status) {
    return (0, _rpcCalls.rpcCall)("WorkflowStatusesService.editWorkflowStatus", [status.id, status.name, status.colorId], _handleError);
}

function deleteWorkflowStatus(statusId) {
    return (0, _rpcCalls.rpcCall)("WorkflowStatusesService.deleteWorkflowStatus", [statusId], _handleError);
}

function updateWorkflowStatusPosition(_ref) {
    var id = _ref.id,
        newPosition = _ref.newPosition;

    return (0, _rpcCalls.rpcCall)("WorkflowStatusesService.moveWorkflowStatus", [id, newPosition], _handleError);
}

function getPageData() {
    return (0, _rpcCalls.rpcCall)("WorkflowStatusesService.getWorkflowStatuses", [], _handleError);
}

function _handleError(error) {
    if (error.errorThrown.exception === _constants.apiExceptions.FEATURE_DISABLED_EXCEPTION) {
        var msg = (0, _utils.getFeaturesChangesMessage)(_defineProperty({}, _constants2.Feature.TWS, false)).concat(_messageResource2.default.getMessage('common.interface_will_reloaded'));

        alert(msg);
        window.location.href = _constants3.BASE_PATH;
    }

    var data = {};
    if (error.errorThrown['workflowStatusesInfo']) {
        data = JSON.parse(error.errorThrown['workflowStatusesInfo']);
    }
    error.handleOnException(_constants.apiExceptions.DUPLICATE_NAME_EXCEPTION, { error: _constants.ValidationErrors.DUPLICATE_NAME_ERROR, data: data });
    error.handleOnException(_constants.apiExceptions.STATUS_DELETED_EXCEPTION, { error: _constants.ValidationErrors.STATUS_DELETED, data: data });
    error.handleOnException(_constants.apiExceptions.STATUS_IN_USE_EXCEPTION, { error: _constants.ValidationErrors.STATUS_IN_USE, data: data });
    error.handleOnException(_constants.apiExceptions.STATUS_IS_LAST_EXCEPTION, { error: _constants.ValidationErrors.STATUS_IS_LAST, data: data });
}

/***/ }),
/* 1777 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _AnimatedDialogWrapper = __webpack_require__(286);

var _AnimatedDialogWrapper2 = _interopRequireDefault(_AnimatedDialogWrapper);

var _DropdownTemplateView = __webpack_require__(42);

var _DropdownTemplateView2 = _interopRequireDefault(_DropdownTemplateView);

var _atBrowserUtils = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EditWorkflowStatusDialogWrapper = function (_AnimatedDialogWrappe) {
    _inherits(EditWorkflowStatusDialogWrapper, _AnimatedDialogWrappe);

    function EditWorkflowStatusDialogWrapper($el, _ref) {
        var dialog = _ref.dialog,
            className = _ref.className,
            _ref$onHide = _ref.onHide,
            onHide = _ref$onHide === undefined ? function () {} : _ref$onHide,
            _ref$preventHide = _ref.preventHide,
            preventHide = _ref$preventHide === undefined ? function () {
            return false;
        } : _ref$preventHide;

        _classCallCheck(this, EditWorkflowStatusDialogWrapper);

        return _possibleConstructorReturn(this, (EditWorkflowStatusDialogWrapper.__proto__ || Object.getPrototypeOf(EditWorkflowStatusDialogWrapper)).call(this, $el, {
            dialog: dialog,
            className: className,
            onHide: onHide,
            preventHide: preventHide
        }));
    }

    _createClass(EditWorkflowStatusDialogWrapper, [{
        key: "afterRender",
        value: function afterRender() {
            _get(EditWorkflowStatusDialogWrapper.prototype.__proto__ || Object.getPrototypeOf(EditWorkflowStatusDialogWrapper.prototype), "afterRender", this).call(this);
            this.getEl().append('<div class="pointer"/>');
            this.pointer = this.find('.pointer');
        }
    }, {
        key: "_showElementAt",
        value: function _showElementAt($el, pos) {
            this.params.dialog.show();
            _DropdownTemplateView2.default.prototype._showElementAt.call(this, $el, _extends({}, pos, {
                my: 'left top',
                at: 'right center',
                offset: '14px -60px'
            }));

            this._adjustPointer(pos);
        }
    }, {
        key: "_adjustPointer",
        value: function _adjustPointer(pos) {
            this.getEl().removeClass('pointerAtLeft pointerAtRight');

            var positionParams = void 0;
            if (this.getEl().offset().left + this.getEl().width() < (0, _jquery2.default)(pos.of).offset().left) {
                this.getEl().addClass('pointerAtRight');
                positionParams = _extends({}, pos, {
                    my: 'right center',
                    at: 'left center',
                    offset: '7px 0'
                });
            } else {
                this.getEl().addClass('pointerAtLeft');
                positionParams = _extends({}, pos, {
                    my: 'left center',
                    at: 'right center',
                    offset: '-5px 0'
                });
            }

            (0, _atBrowserUtils.showElementAt)(this.pointer, positionParams);
        }
    }]);

    return EditWorkflowStatusDialogWrapper;
}(_AnimatedDialogWrapper2.default);

exports.default = EditWorkflowStatusDialogWrapper;

/***/ }),
/* 1778 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InfoContent = function (_TemplateView) {
    _inherits(InfoContent, _TemplateView);

    function InfoContent() {
        _classCallCheck(this, InfoContent);

        return _possibleConstructorReturn(this, (InfoContent.__proto__ || Object.getPrototypeOf(InfoContent)).apply(this, arguments));
    }

    _createClass(InfoContent, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class="infoContainer">' + '    <div class="infoSentence"><%-infoTextFirstSentencePart1%> <%=infoTextFirstSentencePart2%></div>' + '    <div class="infoSentence"><%-infoTextSecondSentencePart1%> <%=infoTextSecondSentencePart2%> <%-infoTextSecondSentencePart3%></div>' + '    <div class="infoSentence"><%-infoTextThirdSentence%></div>' + '</div>';
        }
    }, {
        key: 'messageKeys',
        value: function messageKeys() {
            return {
                infoTextFirstSentencePart1: "workflow_settings.info_text.sentence_1.part1",
                infoTextFirstSentencePart2: "workflow_settings.info_text.sentence_1.part2",
                infoTextSecondSentencePart1: "workflow_settings.info_text.sentence_2.part1",
                infoTextSecondSentencePart2: "workflow_settings.info_text.sentence_2.part2",
                infoTextSecondSentencePart3: "workflow_settings.info_text.sentence_2.part3",
                infoTextThirdSentence: "workflow_settings.info_text.sentence_3"
            };
        }
    }]);

    return InfoContent;
}(_TemplateView3.default);

exports.default = InfoContent;

/***/ }),
/* 1779 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _StatusRow = __webpack_require__(1780);

var _StatusRow2 = _interopRequireDefault(_StatusRow);

var _SortableListContainer = __webpack_require__(914);

var _SortableListContainer2 = _interopRequireDefault(_SortableListContainer);

var _AutoScrollableWrapper = __webpack_require__(401);

var _AutoScrollableWrapper2 = _interopRequireDefault(_AutoScrollableWrapper);

var _atUtils = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var StatusesListContainer = function (_TemplateView) {
    _inherits(StatusesListContainer, _TemplateView);

    function StatusesListContainer(_ref) {
        var _ref$onPositionChange = _ref.onPositionChangedCb,
            onPositionChangedCb = _ref$onPositionChange === undefined ? function () {} : _ref$onPositionChange,
            _ref$onStatusNameClic = _ref.onStatusNameClickCb,
            onStatusNameClickCb = _ref$onStatusNameClic === undefined ? function () {} : _ref$onStatusNameClic,
            _ref$onItemDeleteClic = _ref.onItemDeleteClickCb,
            onItemDeleteClickCb = _ref$onItemDeleteClic === undefined ? function () {} : _ref$onItemDeleteClic;

        _classCallCheck(this, StatusesListContainer);

        var _this = _possibleConstructorReturn(this, (StatusesListContainer.__proto__ || Object.getPrototypeOf(StatusesListContainer)).call(this, null));

        _this.nodes = {};

        _this.state = {
            statuses: [],
            editItemId: null
        };

        _this.callbacks = {
            onPositionChangedCb: onPositionChangedCb,
            onStatusNameClickCb: onStatusNameClickCb,
            onItemDeleteClickCb: onItemDeleteClickCb
        };

        _this.onStatePropertyChanged('statuses', function (statuses, prevStatuses) {
            if (!(0, _atUtils.isArraysWithIdsItemsOrderEqual)(statuses, prevStatuses)) {
                _this.sortableListContainer.setState({ items: statuses });
                _this.sortableStatusesListWrapper.refreshScroll();
            } else {
                _this._updateStatusRowsStates(statuses);
            }
        });

        _this.onAnyStatePropertyChanged(['editItemId'], function () {
            _this._updateStatusRowsStates(_this.state.statuses);
        });
        return _this;
    }

    _createClass(StatusesListContainer, [{
        key: "templateHtml",
        value: function templateHtml() {
            return '<div class="statusesList"/>';
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            var _this2 = this;

            var statusRowRenderer = function statusRowRenderer(item) {
                var node = new _StatusRow2.default({
                    id: item.id,
                    name: item.name,
                    type: item.type,
                    colorId: item.colorId,
                    enabledStatus: item.enabledStatus,
                    onStatusClickCb: function onStatusClickCb() {
                        return _this2.callbacks.onStatusNameClickCb(node.getEl(), item.id);
                    },
                    onDeleteClickCb: function onDeleteClickCb() {
                        return _this2.callbacks.onItemDeleteClickCb(item.id);
                    }
                });

                _this2.nodes[item.id] = node;
                _this2._updateStatusRowState(item);
                return node;
            };

            this.sortableListContainer = new _SortableListContainer2.default({
                itemRenderer: statusRowRenderer,
                sortableConfig: {
                    axis: 'y',
                    tolerance: 'pointer',
                    containmentEl: '.statusesList',
                    cursorAt: { top: 30 }
                },
                onPositionChangedCb: function onPositionChangedCb(_ref2) {
                    var id = _ref2.id,
                        itemIndex = _ref2.itemIndex;

                    _this2.callbacks.onPositionChangedCb({
                        id: id,
                        newPosition: _this2.state.statuses[itemIndex].position
                    });
                }
            });

            this.sortableStatusesListWrapper = new _AutoScrollableWrapper2.default({
                components: [this.sortableListContainer],
                autoScrollEnabled: true,
                enableVerticalScroll: true,
                verticalScrollConfig: {
                    probeType: 2
                },
                scrollEvent: 'sortableList_itemDrag',
                eventDataRetriever: function eventDataRetriever(event, mouseEvent) {
                    return mouseEvent;
                }
            }).init(this.getEl());
        }
    }, {
        key: "_updateStatusRowsStates",
        value: function _updateStatusRowsStates(statuses) {
            var _this3 = this;

            statuses.forEach(function (status) {
                return _this3._updateStatusRowState(status);
            });
        }
    }, {
        key: "_updateStatusRowState",
        value: function _updateStatusRowState(item) {
            this.nodes[item.id].setState({
                inEdit: item.id === this.state.editItemId,
                name: item.name,
                colorId: item.colorId,
                type: item.type,
                enabledStatus: item.enabledStatus
            });
        }
    }]);

    return StatusesListContainer;
}(_TemplateView3.default);

exports.default = StatusesListContainer;

/***/ }),
/* 1780 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _WorkflowStatus = __webpack_require__(360);

var _WorkflowStatus2 = _interopRequireDefault(_WorkflowStatus);

var _SimpleTooltip = __webpack_require__(36);

var _SimpleTooltip2 = _interopRequireDefault(_SimpleTooltip);

var _utils = __webpack_require__(913);

var _constants = __webpack_require__(180);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _constants2 = __webpack_require__(23);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var StatusRow = function (_TemplateView) {
    _inherits(StatusRow, _TemplateView);

    function StatusRow(_ref) {
        var id = _ref.id,
            _ref$onStatusClickCb = _ref.onStatusClickCb,
            onStatusClickCb = _ref$onStatusClickCb === undefined ? function () {} : _ref$onStatusClickCb,
            _ref$onDeleteClickCb = _ref.onDeleteClickCb,
            onDeleteClickCb = _ref$onDeleteClickCb === undefined ? function () {} : _ref$onDeleteClickCb;

        _classCallCheck(this, StatusRow);

        var _this = _possibleConstructorReturn(this, (StatusRow.__proto__ || Object.getPrototypeOf(StatusRow)).call(this));

        _this._toggleConfirmDeleteDialog = function (inDeleting) {
            _this.$statusInfoContainer.toggle(!inDeleting);
            _this.$deleteStatusContainer.toggle(inDeleting);
        };

        _this.id = id;
        _this.params = {
            id: id
        };

        _this.state = {
            inEdit: false,
            name: '',
            colorId: 0,
            type: _constants2.WorkflowStatusType.COMPLETED,
            enabledStatus: _constants.enabledStatus.ENABLED
        };

        _this.callbacks = {
            onStatusClickCb: onStatusClickCb,
            onDeleteClickCb: onDeleteClickCb
        };

        _this.onStatePropertyChanged('inEdit', function () {
            return _this._setEditMode();
        });
        _this.onStatePropertyChanged('enabledStatus', function () {
            return _this._setEnabledStatus();
        });
        _this.onAnyStatePropertyChanged(['name', 'type', 'colorId'], function () {
            return _this._updateWorkflowStatusState();
        });
        return _this;
    }

    _createClass(StatusRow, [{
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='statusRow'>" + "        <div class='statusInfoContainer'>" + "            <div class='dragIcon'/>" + "            <div class='status'/>" + "            <div class='deleteIcon'/>" + "        </div>" + "    <div class='deleteStatusContainer'>" + "        <div class='innerContainer'>" + "            <div class='deleteMessage'><%-deleteConfirmationMessageFirstPart%> '<div class='statusName'><%-statusName%></div>' <%-deleteConfirmationMessageSecondPart%></div>" + "            <button class='confirmDelete'><%-confirmDeleteButtonText%></button>" + "            <div class='cancelDelete'><%-cancelDeleteButtonText%></div>" + "        </div>" + "    </div>";
        }
    }, {
        key: "templateModel",
        value: function templateModel() {
            return {
                statusName: this.state.name,
                deleteConfirmationMessageFirstPart: _messageResource2.default.getMessage('workflow_settings.delete_confirmation_message_first_part'),
                deleteConfirmationMessageSecondPart: _messageResource2.default.getMessage('workflow_settings.delete_confirmation_message_second_part'),
                confirmDeleteButtonText: _messageResource2.default.getMessage('workflow_settings.delete_confirm_button'),
                cancelDeleteButtonText: _messageResource2.default.getMessage('workflow_settings.delete_cancel_button')
            };
        }
    }, {
        key: "_updateWorkflowStatusState",
        value: function _updateWorkflowStatusState() {
            this.status.setState({
                name: this.state.name,
                type: this.state.type,
                colorId: this.state.colorId
            });
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            var _this2 = this;

            this.status = new _WorkflowStatus2.default({
                name: this.params.name,
                type: this.params.type,
                colorId: this.params.colorId,
                onClickCb: this.callbacks.onStatusClickCb
            }).init(this.find('.status'));

            this._updateWorkflowStatusState();

            this.deleteIcon = this.find('.deleteIcon');
            this.deleteIcon.on('click', function () {
                if (_this2.state.enabledStatus === _constants.enabledStatus.ENABLED) {
                    _this2._toggleConfirmDeleteDialog(true);
                }
            });

            this._setEnabledStatus();

            this.$statusInfoContainer = this.find('.statusInfoContainer');
            this.$deleteStatusContainer = this.find('.deleteStatusContainer');
            var confirmDeleteButton = this.find('.confirmDelete');
            confirmDeleteButton.on('click', function () {
                _this2.callbacks.onDeleteClickCb();
                _this2._toggleConfirmDeleteDialog(false);
            });
            var cancelDeleteButton = this.find('.cancelDelete');
            cancelDeleteButton.on('click', function () {
                _this2._toggleConfirmDeleteDialog(false);
            });
        }
    }, {
        key: "_setEditMode",
        value: function _setEditMode() {
            this.status.getEl().toggleClass('inEdit', this.state.inEdit);
        }
    }, {
        key: "_setEnabledStatus",
        value: function _setEnabledStatus() {
            var _this3 = this;

            this.deleteIcon.toggleClass('disabled', this.state.enabledStatus !== _constants.enabledStatus.ENABLED);
            this.getTooltip().subscribeToMouseEvents(this.deleteIcon, function () {
                if (_this3.state.enabledStatus !== _constants.enabledStatus.ENABLED) {
                    _this3.getTooltip().setText(_messageResource2.default.getMessage((0, _utils.getEnabledStatusMessageKeyByStatus)(_this3.state.enabledStatus)));
                    _this3.getTooltip().enable();
                } else {
                    _this3.getTooltip().disable();
                }
            });
        }
    }, {
        key: "getTooltip",
        value: function getTooltip() {
            if (!StatusRow.tooltip) StatusRow.tooltip = new _SimpleTooltip2.default().init((0, _jquery2.default)('body'));
            return StatusRow.tooltip;
        }
    }, {
        key: "getDraggableEl",
        value: function getDraggableEl() {
            return this.find('.dragIcon');
        }
    }]);

    return StatusRow;
}(_TemplateView3.default);

exports.default = StatusRow;

/***/ }),
/* 1781 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = init;

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _CalendarPage = __webpack_require__(1782);

var _CalendarPage2 = _interopRequireDefault(_CalendarPage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function init() {
    new _CalendarPage2.default().init((0, _jquery2.default)('.workSchedulePage'));
}

/***/ }),
/* 1782 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _utils = __webpack_require__(6);

var _redux = __webpack_require__(7);

var _PageContent = __webpack_require__(1783);

var _PageContent2 = _interopRequireDefault(_PageContent);

var _LoadingContainer = __webpack_require__(28);

var _LoadingContainer2 = _interopRequireDefault(_LoadingContainer);

var _selectors = __webpack_require__(212);

var _actions = __webpack_require__(213);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Page = function (_TemplateView) {
    _inherits(Page, _TemplateView);

    function Page(_ref) {
        var loadData = _ref.loadData;

        _classCallCheck(this, Page);

        var _this = _possibleConstructorReturn(this, (Page.__proto__ || Object.getPrototypeOf(Page)).call(this));

        _this.actions = {
            loadData: loadData
        };

        _this.state = {
            firstLoading: false,
            loading: false,
            selectedYear: ''
        };

        _this.onStatePropertyChanged('loading', function (loading) {
            _this.loadingContainer.setState({ loading: loading });
        });

        _this.onStatePropertyChanged("firstLoading", function (firstLoading, prevFirstLoading) {
            _this.loadingContainer.setState({ loading: firstLoading });

            if (firstLoading !== prevFirstLoading && firstLoading === true) {
                _this.actions.loadData(_this.state.selectedYear);
            }
        });
        return _this;
    }

    _createClass(Page, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class="page"\>';
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            this.contentComponent = new _PageContent2.default();
            this.loadingContainer = new _LoadingContainer2.default({
                contentComponent: [this.contentComponent],
                containerClass: 'calendarPageLoadingContainer',
                loadingMoireConfig: {
                    additionalSpinnerSettings: {
                        radius: 16
                    }
                },
                showAnimated: false,
                proxySetState: false
            }).init(this.getEl());
        }
    }]);

    return Page;
}(_TemplateView3.default);

exports.default = (0, _utils.connect)(function (state) {
    return {
        firstLoading: (0, _selectors.isFirstLoading)(state),
        loading: (0, _selectors.isLoading)(state),
        selectedYear: (0, _selectors.geSelectedYear)(state)
    };
}, function (dispatch) {
    return {
        loadData: (0, _redux.bindActionCreators)(_actions.loadData, dispatch)
    };
})(Page);

/***/ }),
/* 1783 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _utils = __webpack_require__(6);

var _selectors = __webpack_require__(212);

var _selectors2 = __webpack_require__(15);

var _constants = __webpack_require__(4);

var _CalendarHeader = __webpack_require__(1784);

var _CalendarHeader2 = _interopRequireDefault(_CalendarHeader);

var _Calendar = __webpack_require__(1789);

var _Calendar2 = _interopRequireDefault(_Calendar);

var _HolidayListPanel = __webpack_require__(1797);

var _HolidayListPanel2 = _interopRequireDefault(_HolidayListPanel);

var _actions = __webpack_require__(320);

var _redux = __webpack_require__(7);

var _ImportHolidaysPanelContainer = __webpack_require__(1804);

var _ImportHolidaysPanelContainer2 = _interopRequireDefault(_ImportHolidaysPanelContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PageContent = function (_TemplateView) {
    _inherits(PageContent, _TemplateView);

    function PageContent(_ref) {
        var openHolidayListPanel = _ref.openHolidayListPanel,
            setSelectedYearHolidayPanel = _ref.setSelectedYearHolidayPanel;

        _classCallCheck(this, PageContent);

        var _this = _possibleConstructorReturn(this, (PageContent.__proto__ || Object.getPrototypeOf(PageContent)).call(this));

        _this.actions = {
            openHolidayListPanel: openHolidayListPanel,
            setSelectedYearHolidayPanel: setSelectedYearHolidayPanel
        };

        _this.state = {
            isLVTEnabled: false,
            loading: false,
            year: ''
        };
        return _this;
    }

    _createClass(PageContent, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return "<div class='content'>" + "    <div class='header'/>" + "    <div class='calendar'/>" + "    <div class='holidayPanels'/>" + "</div>";
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            var _this2 = this;

            this.$holidayPanels = this.find('.holidayPanels');
            this.holidayPanel = new _HolidayListPanel2.default().init(this.$holidayPanels);
            this.importHolidaysPanel = new _ImportHolidaysPanelContainer2.default().init(this.$holidayPanels);

            this.header = new _CalendarHeader2.default({
                leaveBlackoutEnabled: this._isLeaveBlackoutEnabled(),
                onHolidayListButtonClick: function onHolidayListButtonClick() {
                    _this2.actions.setSelectedYearHolidayPanel(_this2.state.year);
                    _this2.actions.openHolidayListPanel();
                }
            }).init(this.find('.header'));
            this.calendar = new _Calendar2.default({
                leaveBlackoutEnabled: this._isLeaveBlackoutEnabled()
            }).init(this.find('.calendar'));
        }
    }, {
        key: '_isLeaveBlackoutEnabled',
        value: function _isLeaveBlackoutEnabled() {
            return _constants.CURRENT_PRODUCT === _constants.Product.actiPLANS || _constants.PRODUCTS_INTEGRATED || this.state.isLVTEnabled;
        }
    }]);

    return PageContent;
}(_TemplateView3.default);

exports.default = (0, _utils.connect)(function (state) {
    return {
        isLVTEnabled: (0, _selectors2.isLVTEnabled)(state),
        loading: (0, _selectors.isLoading)(state),
        year: (0, _selectors.geSelectedYear)(state)
    };
}, function (dispatch) {
    return {
        setSelectedYearHolidayPanel: (0, _redux.bindActionCreators)(_actions.setPanelSelectedYear, dispatch),
        openHolidayListPanel: (0, _redux.bindActionCreators)(_actions.openPanel, dispatch)
    };
})(PageContent);

/***/ }),
/* 1784 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _utils = __webpack_require__(6);

var _SimpleListMenuButton = __webpack_require__(187);

var _SimpleListMenuButton2 = _interopRequireDefault(_SimpleListMenuButton);

var _Button = __webpack_require__(33);

var _Button2 = _interopRequireDefault(_Button);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _utils2 = __webpack_require__(85);

var _constants = __webpack_require__(116);

var _redux = __webpack_require__(7);

var _actions = __webpack_require__(213);

var _selectors = __webpack_require__(212);

var _LoadingSpinner = __webpack_require__(191);

var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);

var _constants2 = __webpack_require__(4);

var _ImportHolidaysDialog = __webpack_require__(916);

var _selectors2 = __webpack_require__(19);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CalendarHeader = function (_TemplateView) {
    _inherits(CalendarHeader, _TemplateView);

    function CalendarHeader(_ref) {
        var loadData = _ref.loadData,
            setSelectedYear = _ref.setSelectedYear,
            leaveBlackoutEnabled = _ref.leaveBlackoutEnabled,
            _ref$onImportButtonCl = _ref.onImportButtonClick,
            onImportButtonClick = _ref$onImportButtonCl === undefined ? function () {} : _ref$onImportButtonCl,
            _ref$onExportButtonCl = _ref.onExportButtonClick,
            onExportButtonClick = _ref$onExportButtonCl === undefined ? function () {} : _ref$onExportButtonCl,
            _ref$onHolidayListBut = _ref.onHolidayListButtonClick,
            onHolidayListButtonClick = _ref$onHolidayListBut === undefined ? function () {} : _ref$onHolidayListBut;

        _classCallCheck(this, CalendarHeader);

        var _this = _possibleConstructorReturn(this, (CalendarHeader.__proto__ || Object.getPrototypeOf(CalendarHeader)).call(this));

        _this.actions = {
            onImportButtonClick: onImportButtonClick,
            onExportButtonClick: onExportButtonClick,
            onHolidayListButtonClick: onHolidayListButtonClick,
            loadData: loadData,
            setSelectedYear: setSelectedYear
        };

        _this.state = {
            selectedYear: '',
            editing: false,
            canManage: false
        };

        _this._leaveBlackoutEnabled = leaveBlackoutEnabled;

        _this.onStatePropertyChanged('selectedYear', function (selectedYear) {
            _this.yearSelector.setSelectedItem({ year: selectedYear });
            _this.importButton.setState({ disabled: selectedYear < window.currentUserTime().clearTime().getFullYear() });
        });

        _this.onStatePropertyChanged('editing', function (editing) {
            _this.editingSpinner.setState({ show: editing });
        });

        _this.onStatePropertyChanged('canManage', function (canManage) {
            _this.$buttonsContainer.toggle(canManage);
        });
        return _this;
    }

    _createClass(CalendarHeader, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class="headerContent">' + '    <div class="title">' + '        <div class="label"><%=headerYearSelectorTitle%></div>' + '        <div class="list"></div>' + '        <span class="sharedSettingsImage" title="<%=sharedSettingsImageTitle%>"/>' + '        <div class="spinnerContainer"/>' + '    </div>' + '    <div class="legendButtonContainer">' + '        <div class="legend">' + '            <div class="legendItem leaveBlackout atNextMount" />' + '            <div class="legendItem workingDay">' + '                <div class="marker"></div>' + '                <div class="label"><%=workingDayLegendTitle%></div>' + '            </div>' + '            <div class="legendItem nonworkingDay">' + '                <div class="marker"></div>' + '                <div class="label"><%=nonworkingDayLegendTitle%></div>' + '            </div>' + '            <div class="legendItem holiday">' + '                <div class="marker"></div>' + '                <div class="label"><%=holidayLegendTitle%></div>' + '            </div>' + '        </div>' + '        <div class="buttons">' + '            <div class="separator"/>' + '            <div class="exportHolidaysButton">' + '                <div class="icon"/>' + '                <div class="link"><%=exportHolidays%></div>' + '            </div>' + '            <div class="separator"/>' + '            <div class="holidayListButton"/>' + '            <div class="importHolidaysButton"/>' + '        </div>' + '    </div>' + '</div>';
        }
    }, {
        key: 'messageKeys',
        value: function messageKeys() {
            return {
                headerYearSelectorTitle: 'work_schedule.page_title_selector',
                workingDayLegendTitle: 'work_schedule.header.legend.working_day',
                nonworkingDayLegendTitle: 'work_schedule.header.legend.nonworking_day',
                holidayLegendTitle: 'work_schedule.header.legend.holiday',
                sharedSettingsImageTitle: 'general_settings.shared_settings',
                exportHolidays: 'work_schedule.header.export_holidays_button'
            };
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            var _this2 = this;

            this.yearSelector = new _SimpleListMenuButton2.default({
                itemHtmlCallback: function itemHtmlCallback(item) {
                    return item.year;
                },
                onSelect: function onSelect(item) {
                    _this2.actions.setSelectedYear(item.year);
                    _this2.actions.loadData(item.year);
                },
                menuPositionParams: {
                    my: "right top",
                    at: "right bottom"
                },
                itemHeight: 30
            }).init(this.find('.list'));

            this.editingSpinner = new _LoadingSpinner2.default().init(this.find('.spinnerContainer'));

            var currentYear = new Date().getFullYear();
            this.yearSelector.setItems((0, _utils2.createYearsListForSelector)(_constants.WORK_SCHEDULE_YEAR_START, currentYear + 1), { year: currentYear });

            this.$buttonsContainer = this.find('.legendButtonContainer .buttons');
            new _Button2.default({
                additionalClass: 'list',
                label: _messageResource2.default.getMessage('work_schedule.header.holiday_list_button'),
                onClickCb: function onClickCb() {
                    if (_this2.state.canManage) _this2.actions.onHolidayListButtonClick();
                }
            }).init(this.find('.holidayListButton'));

            this.importButton = new _Button2.default({
                additionalClass: 'import',
                label: _messageResource2.default.getMessage('work_schedule.header.import_holidays_button'),
                onClickCb: function onClickCb() {
                    if (_this2.state.canManage) _this2._showImportDialog();
                },
                withDisableTooltip: true,
                tooltipAdditionalClass: 'importHolidaysButtonDisabledTooltip'
            }).init(this.find('.importHolidaysButton'));
            this.importButton.setState({ disableTooltipText: _messageResource2.default.getMessage('work_schedule.header.import_holidays_button_disabled_tooltip') });

            this.find('.exportHolidaysButton').click(function () {
                return _this2.actions.onExportButtonClick();
            });

            this.find('.sharedSettingsImage').toggle(_constants2.CURRENT_PRODUCT === _constants2.Product.actiTIME ? _constants2.LicenseInfo.isApActive : _constants2.LicenseInfo.isAtActive);

            if (this._leaveBlackoutEnabled) {
                window.ClassicBridge.integrateLeaveBlackoutLegendDropdown(this.find('.legendButtonContainer .leaveBlackout')[0], {
                    context: 'corporateCalendar',
                    showDoubleColorBlock: true
                });
            }

            this.renderInitialState();
        }
    }, {
        key: '_showImportDialog',
        value: function _showImportDialog() {
            (0, _ImportHolidaysDialog.getInstance)().showAt(this.importButton.getEl(), {
                my: 'right top',
                at: 'right bottom'
            });
            this.actions.onImportButtonClick();
        }
    }]);

    return CalendarHeader;
}(_TemplateView3.default);

exports.default = (0, _utils.connect)(function (state) {
    return {
        selectedYear: (0, _selectors.geSelectedYear)(state),
        editing: (0, _selectors.isEditing)(state),
        canManage: (0, _selectors2.canManageSystemSettings)(state)
    };
}, function (dispatch) {
    return {
        loadData: (0, _redux.bindActionCreators)(_actions.loadData, dispatch),
        setSelectedYear: (0, _redux.bindActionCreators)(_actions.selectYear, dispatch),
        onImportButtonClick: (0, _redux.bindActionCreators)(_actions.loadCountries, dispatch),
        onExportButtonClick: (0, _redux.bindActionCreators)(_actions.exportSchedule, dispatch)
    };
})(CalendarHeader);

/***/ }),
/* 1785 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.mergeHolidaysWithSameDate = mergeHolidaysWithSameDate;
function mergeHolidaysWithSameDate(holidays) {
    var mapByDate = holidays.reduce(function (map, holiday) {
        map[holiday.date] = !!map[holiday.date] ? { date: holiday.date, name: map[holiday.date].name + " / " + holiday.name } : holiday;
        return map;
    }, {});
    return Object.values(mapByDate);
}

/***/ }),
/* 1786 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ICalParser = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ical = __webpack_require__(1787);

var _ical2 = _interopRequireDefault(_ical);

var _utils = __webpack_require__(85);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MAX_HOLIDAY_NAME_LENGTH = 80;

var ICalParser = exports.ICalParser = function () {
    function ICalParser() {
        _classCallCheck(this, ICalParser);
    }

    _createClass(ICalParser, [{
        key: 'parseHolidays',
        value: function parseHolidays(file, year, successCallback, errorCallback) {
            var _this = this;

            var reader = new FileReader();

            reader.onload = function () {
                var icalData = reader.result;

                try {
                    successCallback(_this.parseHolidayFromText(icalData, year));
                } catch (error) {
                    errorCallback(error);
                }
            };

            reader.readAsText(file);
        }
    }, {
        key: 'parseHolidayFromText',
        value: function parseHolidayFromText(text, year) {
            var _this2 = this;

            var data = _ical2.default.parse(text);
            var comp = new _ical2.default.Component(data);

            var allICalHolidays = comp.getAllSubcomponents("vevent");
            var allHolidays = [];

            allICalHolidays.filter(function (event) {
                return new Date(event.getFirstPropertyValue("dtstart").year, event.getFirstPropertyValue("dtstart").month - 1, event.getFirstPropertyValue("dtstart").day).getFullYear() === year;
            }).forEach(function (event) {
                var icalTimeStart = event.getFirstPropertyValue("dtstart");
                var icalTimeEnd = event.getFirstPropertyValue("dtend");

                var dayStart = _this2._createDate(icalTimeStart);

                // if "DTEND" property has "DATE" type,
                // due to "DTEND" property for a "VEVENT" calendar component specifies the non-inclusive end of the event
                // and DatesIterator includes dateTo set dayEnd as previous day
                var dayEnd = !icalTimeEnd ? dayStart : icalTimeEnd.isDate ? _this2._createDate(icalTimeEnd).prevDay() : _this2._createDate(icalTimeEnd);

                var iterator = new _utils.DatesIterator(dayStart, dayEnd);
                while (iterator.hasNext()) {
                    var name = _this2.createValidString(event.getFirstPropertyValue("summary"));

                    allHolidays.push({
                        date: iterator.next(),
                        name: name
                    });
                }
            });

            return allHolidays;
        }
    }, {
        key: 'createValidString',
        value: function createValidString(string) {

            if (string.length > MAX_HOLIDAY_NAME_LENGTH) {
                return string.substring(0, MAX_HOLIDAY_NAME_LENGTH);
            }

            return string;
        }
    }, {
        key: '_createDate',
        value: function _createDate(icalTimeStart) {
            return Date.create(icalTimeStart.year, icalTimeStart.month - 1, icalTimeStart.day);
        }
    }]);

    return ICalParser;
}();

/***/ }),
/* 1787 */
/***/ (function(module, exports, __webpack_require__) {

/* This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/.
 * Portions Copyright (C) Philipp Kewisch, 2011-2015 */


/* istanbul ignore next */
/* jshint ignore:start */
if (true) {
  // CommonJS, where exports may be different each time.
  ICAL = module.exports;
} else if (typeof ICAL !== 'object') {/* istanbul ignore next */
  /** @ignore */
  this.ICAL = {};
}
/* jshint ignore:end */


/**
 * The number of characters before iCalendar line folding should occur
 * @type {Number}
 * @default 75
 */
ICAL.foldLength = 75;


/**
 * The character(s) to be used for a newline. The default value is provided by
 * rfc5545.
 * @type {String}
 * @default "\r\n"
 */
ICAL.newLineChar = '\r\n';


/**
 * Helper functions used in various places within ical.js
 * @namespace
 */
ICAL.helpers = {
  /**
   * Compiles a list of all referenced TZIDs in all subcomponents and
   * removes any extra VTIMEZONE subcomponents. In addition, if any TZIDs
   * are referenced by a component, but a VTIMEZONE does not exist,
   * an attempt will be made to generate a VTIMEZONE using ICAL.TimezoneService.
   *
   * @param {ICAL.Component} vcal     The top-level VCALENDAR component.
   * @return {ICAL.Component}         The ICAL.Component that was passed in.
   */
  updateTimezones: function(vcal) {
    var allsubs, properties, vtimezones, reqTzid, i, tzid;

    if (!vcal || vcal.name !== "vcalendar") {
      //not a top-level vcalendar component
      return vcal;
    }

    //Store vtimezone subcomponents in an object reference by tzid.
    //Store properties from everything else in another array
    allsubs = vcal.getAllSubcomponents();
    properties = [];
    vtimezones = {};
    for (i = 0; i < allsubs.length; i++) {
      if (allsubs[i].name === "vtimezone") {
        tzid = allsubs[i].getFirstProperty("tzid").getFirstValue();
        vtimezones[tzid] = allsubs[i];
      } else {
        properties = properties.concat(allsubs[i].getAllProperties());
      }
    }

    //create an object with one entry for each required tz
    reqTzid = {};
    for (i = 0; i < properties.length; i++) {
      if ((tzid = properties[i].getParameter("tzid"))) {
        reqTzid[tzid] = true;
      }
    }

    //delete any vtimezones that are not on the reqTzid list.
    for (i in vtimezones) {
      if (vtimezones.hasOwnProperty(i) && !reqTzid[i]) {
        vcal.removeSubcomponent(vtimezones[i]);
      }
    }

    //create any missing, but registered timezones
    for (i in reqTzid) {
      if (
        reqTzid.hasOwnProperty(i) &&
        !vtimezones[i] &&
        ICAL.TimezoneService.has(i)
      ) {
        vcal.addSubcomponent(ICAL.TimezoneService.get(i).component);
      }
    }

    return vcal;
  },

  /**
   * Checks if the given type is of the number type and also NaN.
   *
   * @param {Number} number     The number to check
   * @return {Boolean}          True, if the number is strictly NaN
   */
  isStrictlyNaN: function(number) {
    return typeof(number) === 'number' && isNaN(number);
  },

  /**
   * Parses a string value that is expected to be an integer, when the valid is
   * not an integer throws a decoration error.
   *
   * @param {String} string     Raw string input
   * @return {Number}           Parsed integer
   */
  strictParseInt: function(string) {
    var result = parseInt(string, 10);

    if (ICAL.helpers.isStrictlyNaN(result)) {
      throw new Error(
        'Could not extract integer from "' + string + '"'
      );
    }

    return result;
  },

  /**
   * Creates or returns a class instance of a given type with the initialization
   * data if the data is not already an instance of the given type.
   *
   * @example
   * var time = new ICAL.Time(...);
   * var result = ICAL.helpers.formatClassType(time, ICAL.Time);
   *
   * (result instanceof ICAL.Time)
   * // => true
   *
   * result = ICAL.helpers.formatClassType({}, ICAL.Time);
   * (result isntanceof ICAL.Time)
   * // => true
   *
   *
   * @param {Object} data       object initialization data
   * @param {Object} type       object type (like ICAL.Time)
   * @return {?}                An instance of the found type.
   */
  formatClassType: function formatClassType(data, type) {
    if (typeof(data) === 'undefined') {
      return undefined;
    }

    if (data instanceof type) {
      return data;
    }
    return new type(data);
  },

  /**
   * Identical to indexOf but will only match values when they are not preceded
   * by a backslash character.
   *
   * @param {String} buffer         String to search
   * @param {String} search         Value to look for
   * @param {Number} pos            Start position
   * @return {Number}               The position, or -1 if not found
   */
  unescapedIndexOf: function(buffer, search, pos) {
    while ((pos = buffer.indexOf(search, pos)) !== -1) {
      if (pos > 0 && buffer[pos - 1] === '\\') {
        pos += 1;
      } else {
        return pos;
      }
    }
    return -1;
  },

  /**
   * Find the index for insertion using binary search.
   *
   * @param {Array} list            The list to search
   * @param {?} seekVal             The value to insert
   * @param {function(?,?)} cmpfunc The comparison func, that can
   *                                  compare two seekVals
   * @return {Number}               The insert position
   */
  binsearchInsert: function(list, seekVal, cmpfunc) {
    if (!list.length)
      return 0;

    var low = 0, high = list.length - 1,
        mid, cmpval;

    while (low <= high) {
      mid = low + Math.floor((high - low) / 2);
      cmpval = cmpfunc(seekVal, list[mid]);

      if (cmpval < 0)
        high = mid - 1;
      else if (cmpval > 0)
        low = mid + 1;
      else
        break;
    }

    if (cmpval < 0)
      return mid; // insertion is displacing, so use mid outright.
    else if (cmpval > 0)
      return mid + 1;
    else
      return mid;
  },

  /**
   * Convenience function for debug output
   * @private
   */
  dumpn: /* istanbul ignore next */ function() {
    if (!ICAL.debug) {
      return;
    }

    if (typeof (console) !== 'undefined' && 'log' in console) {
      ICAL.helpers.dumpn = function consoleDumpn(input) {
        console.log(input);
      };
    } else {
      ICAL.helpers.dumpn = function geckoDumpn(input) {
        dump(input + '\n');
      };
    }

    ICAL.helpers.dumpn(arguments[0]);
  },

  /**
   * Clone the passed object or primitive. By default a shallow clone will be
   * executed.
   *
   * @param {*} aSrc            The thing to clone
   * @param {Boolean=} aDeep    If true, a deep clone will be performed
   * @return {*}                The copy of the thing
   */
  clone: function(aSrc, aDeep) {
    if (!aSrc || typeof aSrc != "object") {
      return aSrc;
    } else if (aSrc instanceof Date) {
      return new Date(aSrc.getTime());
    } else if ("clone" in aSrc) {
      return aSrc.clone();
    } else if (Array.isArray(aSrc)) {
      var arr = [];
      for (var i = 0; i < aSrc.length; i++) {
        arr.push(aDeep ? ICAL.helpers.clone(aSrc[i], true) : aSrc[i]);
      }
      return arr;
    } else {
      var obj = {};
      for (var name in aSrc) {
        // uses prototype method to allow use of Object.create(null);
        /* istanbul ignore else */
        if (Object.prototype.hasOwnProperty.call(aSrc, name)) {
          if (aDeep) {
            obj[name] = ICAL.helpers.clone(aSrc[name], true);
          } else {
            obj[name] = aSrc[name];
          }
        }
      }
      return obj;
    }
  },

  /**
   * Performs iCalendar line folding. A line ending character is inserted and
   * the next line begins with a whitespace.
   *
   * @example
   * SUMMARY:This line will be fold
   *  ed right in the middle of a word.
   *
   * @param {String} aLine      The line to fold
   * @return {String}           The folded line
   */
  foldline: function foldline(aLine) {
    var result = "";
    var line = aLine || "";

    while (line.length) {
      result += ICAL.newLineChar + " " + line.substr(0, ICAL.foldLength);
      line = line.substr(ICAL.foldLength);
    }
    return result.substr(ICAL.newLineChar.length + 1);
  },

  /**
   * Pads the given string or number with zeros so it will have at least two
   * characters.
   *
   * @param {String|Number} data    The string or number to pad
   * @return {String}               The number padded as a string
   */
  pad2: function pad(data) {
    if (typeof(data) !== 'string') {
      // handle fractions.
      if (typeof(data) === 'number') {
        data = parseInt(data);
      }
      data = String(data);
    }

    var len = data.length;

    switch (len) {
      case 0:
        return '00';
      case 1:
        return '0' + data;
      default:
        return data;
    }
  },

  /**
   * Truncates the given number, correctly handling negative numbers.
   *
   * @param {Number} number     The number to truncate
   * @return {Number}           The truncated number
   */
  trunc: function trunc(number) {
    return (number < 0 ? Math.ceil(number) : Math.floor(number));
  },

  /**
   * Poor-man's cross-browser inheritance for JavaScript. Doesn't support all
   * the features, but enough for our usage.
   *
   * @param {Function} base     The base class constructor function.
   * @param {Function} child    The child class constructor function.
   * @param {Object} extra      Extends the prototype with extra properties
   *                              and methods
   */
  inherits: function(base, child, extra) {
    function F() {}
    F.prototype = base.prototype;
    child.prototype = new F();

    if (extra) {
      ICAL.helpers.extend(extra, child.prototype);
    }
  },

  /**
   * Poor-man's cross-browser object extension. Doesn't support all the
   * features, but enough for our usage. Note that the target's properties are
   * not overwritten with the source properties.
   *
   * @example
   * var child = ICAL.helpers.extend(parent, {
   *   "bar": 123
   * });
   *
   * @param {Object} source     The object to extend
   * @param {Object} target     The object to extend with
   * @return {Object}           Returns the target.
   */
  extend: function(source, target) {
    for (var key in source) {
      var descr = Object.getOwnPropertyDescriptor(source, key);
      if (descr && !Object.getOwnPropertyDescriptor(target, key)) {
        Object.defineProperty(target, key, descr);
      }
    }
    return target;
  }
};
/* This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/.
 * Portions Copyright (C) Philipp Kewisch, 2011-2015 */

/** @namespace ICAL */


/**
 * This symbol is further described later on
 * @ignore
 */
ICAL.design = (function() {
  'use strict';

  var FROM_ICAL_NEWLINE = /\\\\|\\;|\\,|\\[Nn]/g;
  var TO_ICAL_NEWLINE = /\\|;|,|\n/g;
  var FROM_VCARD_NEWLINE = /\\\\|\\,|\\[Nn]/g;
  var TO_VCARD_NEWLINE = /\\|,|\n/g;

  function createTextType(fromNewline, toNewline) {
    var result = {
      matches: /.*/,

      fromICAL: function(aValue, structuredEscape) {
        return replaceNewline(aValue, fromNewline, structuredEscape);
      },

      toICAL: function(aValue, structuredEscape) {
        var regEx = toNewline;
        if (structuredEscape)
          regEx = new RegExp(regEx.source + '|' + structuredEscape);
        return aValue.replace(regEx, function(str) {
          switch (str) {
          case "\\":
            return "\\\\";
          case ";":
            return "\\;";
          case ",":
            return "\\,";
          case "\n":
            return "\\n";
          /* istanbul ignore next */
          default:
            return str;
          }
        });
      }
    };
    return result;
  }

  // default types used multiple times
  var DEFAULT_TYPE_TEXT = { defaultType: "text" };
  var DEFAULT_TYPE_TEXT_MULTI = { defaultType: "text", multiValue: "," };
  var DEFAULT_TYPE_TEXT_STRUCTURED = { defaultType: "text", structuredValue: ";" };
  var DEFAULT_TYPE_INTEGER = { defaultType: "integer" };
  var DEFAULT_TYPE_DATETIME_DATE = { defaultType: "date-time", allowedTypes: ["date-time", "date"] };
  var DEFAULT_TYPE_DATETIME = { defaultType: "date-time" };
  var DEFAULT_TYPE_URI = { defaultType: "uri" };
  var DEFAULT_TYPE_UTCOFFSET = { defaultType: "utc-offset" };
  var DEFAULT_TYPE_RECUR = { defaultType: "recur" };
  var DEFAULT_TYPE_DATE_ANDOR_TIME = { defaultType: "date-and-or-time", allowedTypes: ["date-time", "date", "text"] };

  function replaceNewlineReplace(string) {
    switch (string) {
      case "\\\\":
        return "\\";
      case "\\;":
        return ";";
      case "\\,":
        return ",";
      case "\\n":
      case "\\N":
        return "\n";
      /* istanbul ignore next */
      default:
        return string;
    }
  }

  function replaceNewline(value, newline, structuredEscape) {
    // avoid regex when possible.
    if (value.indexOf('\\') === -1) {
      return value;
    }
    if (structuredEscape)
      newline = new RegExp(newline.source + '|\\\\' + structuredEscape);
    return value.replace(newline, replaceNewlineReplace);
  }

  var commonProperties = {
    "categories": DEFAULT_TYPE_TEXT_MULTI,
    "url": DEFAULT_TYPE_URI,
    "version": DEFAULT_TYPE_TEXT,
    "uid": DEFAULT_TYPE_TEXT
  };

  var commonValues = {
    "boolean": {
      values: ["TRUE", "FALSE"],

      fromICAL: function(aValue) {
        switch (aValue) {
          case 'TRUE':
            return true;
          case 'FALSE':
            return false;
          default:
            //TODO: parser warning
            return false;
        }
      },

      toICAL: function(aValue) {
        if (aValue) {
          return 'TRUE';
        }
        return 'FALSE';
      }

    },
    float: {
      matches: /^[+-]?\d+\.\d+$/,

      fromICAL: function(aValue) {
        var parsed = parseFloat(aValue);
        if (ICAL.helpers.isStrictlyNaN(parsed)) {
          // TODO: parser warning
          return 0.0;
        }
        return parsed;
      },

      toICAL: function(aValue) {
        return String(aValue);
      }
    },
    integer: {
      fromICAL: function(aValue) {
        var parsed = parseInt(aValue);
        if (ICAL.helpers.isStrictlyNaN(parsed)) {
          return 0;
        }
        return parsed;
      },

      toICAL: function(aValue) {
        return String(aValue);
      }
    },
    "utc-offset": {
      toICAL: function(aValue) {
        if (aValue.length < 7) {
          // no seconds
          // -0500
          return aValue.substr(0, 3) +
                 aValue.substr(4, 2);
        } else {
          // seconds
          // -050000
          return aValue.substr(0, 3) +
                 aValue.substr(4, 2) +
                 aValue.substr(7, 2);
        }
      },

      fromICAL: function(aValue) {
        if (aValue.length < 6) {
          // no seconds
          // -05:00
          return aValue.substr(0, 3) + ':' +
                 aValue.substr(3, 2);
        } else {
          // seconds
          // -05:00:00
          return aValue.substr(0, 3) + ':' +
                 aValue.substr(3, 2) + ':' +
                 aValue.substr(5, 2);
        }
      },

      decorate: function(aValue) {
        return ICAL.UtcOffset.fromString(aValue);
      },

      undecorate: function(aValue) {
        return aValue.toString();
      }
    }
  };

  var icalParams = {
    // Although the syntax is DQUOTE uri DQUOTE, I don't think we should
    // enfoce anything aside from it being a valid content line.
    //
    // At least some params require - if multi values are used - DQUOTEs
    // for each of its values - e.g. delegated-from="uri1","uri2"
    // To indicate this, I introduced the new k/v pair
    // multiValueSeparateDQuote: true
    //
    // "ALTREP": { ... },

    // CN just wants a param-value
    // "CN": { ... }

    "cutype": {
      values: ["INDIVIDUAL", "GROUP", "RESOURCE", "ROOM", "UNKNOWN"],
      allowXName: true,
      allowIanaToken: true
    },

    "delegated-from": {
      valueType: "cal-address",
      multiValue: ",",
      multiValueSeparateDQuote: true
    },
    "delegated-to": {
      valueType: "cal-address",
      multiValue: ",",
      multiValueSeparateDQuote: true
    },
    // "DIR": { ... }, // See ALTREP
    "encoding": {
      values: ["8BIT", "BASE64"]
    },
    // "FMTTYPE": { ... }, // See ALTREP
    "fbtype": {
      values: ["FREE", "BUSY", "BUSY-UNAVAILABLE", "BUSY-TENTATIVE"],
      allowXName: true,
      allowIanaToken: true
    },
    // "LANGUAGE": { ... }, // See ALTREP
    "member": {
      valueType: "cal-address",
      multiValue: ",",
      multiValueSeparateDQuote: true
    },
    "partstat": {
      // TODO These values are actually different per-component
      values: ["NEEDS-ACTION", "ACCEPTED", "DECLINED", "TENTATIVE",
               "DELEGATED", "COMPLETED", "IN-PROCESS"],
      allowXName: true,
      allowIanaToken: true
    },
    "range": {
      values: ["THISLANDFUTURE"]
    },
    "related": {
      values: ["START", "END"]
    },
    "reltype": {
      values: ["PARENT", "CHILD", "SIBLING"],
      allowXName: true,
      allowIanaToken: true
    },
    "role": {
      values: ["REQ-PARTICIPANT", "CHAIR",
               "OPT-PARTICIPANT", "NON-PARTICIPANT"],
      allowXName: true,
      allowIanaToken: true
    },
    "rsvp": {
      values: ["TRUE", "FALSE"]
    },
    "sent-by": {
      valueType: "cal-address"
    },
    "tzid": {
      matches: /^\//
    },
    "value": {
      // since the value here is a 'type' lowercase is used.
      values: ["binary", "boolean", "cal-address", "date", "date-time",
               "duration", "float", "integer", "period", "recur", "text",
               "time", "uri", "utc-offset"],
      allowXName: true,
      allowIanaToken: true
    }
  };

  // When adding a value here, be sure to add it to the parameter types!
  var icalValues = ICAL.helpers.extend(commonValues, {
    text: createTextType(FROM_ICAL_NEWLINE, TO_ICAL_NEWLINE),

    uri: {
      // TODO
      /* ... */
    },

    "binary": {
      decorate: function(aString) {
        return ICAL.Binary.fromString(aString);
      },

      undecorate: function(aBinary) {
        return aBinary.toString();
      }
    },
    "cal-address": {
      // needs to be an uri
    },
    "date": {
      decorate: function(aValue, aProp) {
        return ICAL.Time.fromDateString(aValue, aProp);
      },

      /**
       * undecorates a time object.
       */
      undecorate: function(aValue) {
        return aValue.toString();
      },

      fromICAL: function(aValue) {
        // from: 20120901
        // to: 2012-09-01
        return aValue.substr(0, 4) + '-' +
               aValue.substr(4, 2) + '-' +
               aValue.substr(6, 2);
      },

      toICAL: function(aValue) {
        // from: 2012-09-01
        // to: 20120901

        if (aValue.length > 11) {
          //TODO: serialize warning?
          return aValue;
        }

        return aValue.substr(0, 4) +
               aValue.substr(5, 2) +
               aValue.substr(8, 2);
      }
    },
    "date-time": {
      fromICAL: function(aValue) {
        // from: 20120901T130000
        // to: 2012-09-01T13:00:00
        var result = aValue.substr(0, 4) + '-' +
                     aValue.substr(4, 2) + '-' +
                     aValue.substr(6, 2) + 'T' +
                     aValue.substr(9, 2) + ':' +
                     aValue.substr(11, 2) + ':' +
                     aValue.substr(13, 2);

        if (aValue[15] && aValue[15] === 'Z') {
          result += 'Z';
        }

        return result;
      },

      toICAL: function(aValue) {
        // from: 2012-09-01T13:00:00
        // to: 20120901T130000

        if (aValue.length < 19) {
          // TODO: error
          return aValue;
        }

        var result = aValue.substr(0, 4) +
                     aValue.substr(5, 2) +
                     // grab the (DDTHH) segment
                     aValue.substr(8, 5) +
                     // MM
                     aValue.substr(14, 2) +
                     // SS
                     aValue.substr(17, 2);

        if (aValue[19] && aValue[19] === 'Z') {
          result += 'Z';
        }

        return result;
      },

      decorate: function(aValue, aProp) {
        return ICAL.Time.fromDateTimeString(aValue, aProp);
      },

      undecorate: function(aValue) {
        return aValue.toString();
      }
    },
    duration: {
      decorate: function(aValue) {
        return ICAL.Duration.fromString(aValue);
      },
      undecorate: function(aValue) {
        return aValue.toString();
      }
    },
    period: {

      fromICAL: function(string) {
        var parts = string.split('/');
        parts[0] = icalValues['date-time'].fromICAL(parts[0]);

        if (!ICAL.Duration.isValueString(parts[1])) {
          parts[1] = icalValues['date-time'].fromICAL(parts[1]);
        }

        return parts;
      },

      toICAL: function(parts) {
        parts[0] = icalValues['date-time'].toICAL(parts[0]);

        if (!ICAL.Duration.isValueString(parts[1])) {
          parts[1] = icalValues['date-time'].toICAL(parts[1]);
        }

        return parts.join("/");
      },

      decorate: function(aValue, aProp) {
        return ICAL.Period.fromJSON(aValue, aProp);
      },

      undecorate: function(aValue) {
        return aValue.toJSON();
      }
    },
    recur: {
      fromICAL: function(string) {
        return ICAL.Recur._stringToData(string, true);
      },

      toICAL: function(data) {
        var str = "";
        for (var k in data) {
          /* istanbul ignore if */
          if (!Object.prototype.hasOwnProperty.call(data, k)) {
            continue;
          }
          var val = data[k];
          if (k == "until") {
            if (val.length > 10) {
              val = icalValues['date-time'].toICAL(val);
            } else {
              val = icalValues.date.toICAL(val);
            }
          } else if (k == "wkst") {
            if (typeof val === 'number') {
              val = ICAL.Recur.numericDayToIcalDay(val);
            }
          } else if (Array.isArray(val)) {
            val = val.join(",");
          }
          str += k.toUpperCase() + "=" + val + ";";
        }
        return str.substr(0, str.length - 1);
      },

      decorate: function decorate(aValue) {
        return ICAL.Recur.fromData(aValue);
      },

      undecorate: function(aRecur) {
        return aRecur.toJSON();
      }
    },

    time: {
      fromICAL: function(aValue) {
        // from: MMHHSS(Z)?
        // to: HH:MM:SS(Z)?
        if (aValue.length < 6) {
          // TODO: parser exception?
          return aValue;
        }

        // HH::MM::SSZ?
        var result = aValue.substr(0, 2) + ':' +
                     aValue.substr(2, 2) + ':' +
                     aValue.substr(4, 2);

        if (aValue[6] === 'Z') {
          result += 'Z';
        }

        return result;
      },

      toICAL: function(aValue) {
        // from: HH:MM:SS(Z)?
        // to: MMHHSS(Z)?
        if (aValue.length < 8) {
          //TODO: error
          return aValue;
        }

        var result = aValue.substr(0, 2) +
                     aValue.substr(3, 2) +
                     aValue.substr(6, 2);

        if (aValue[8] === 'Z') {
          result += 'Z';
        }

        return result;
      }
    }
  });

  var icalProperties = ICAL.helpers.extend(commonProperties, {

    "action": DEFAULT_TYPE_TEXT,
    "attach": { defaultType: "uri" },
    "attendee": { defaultType: "cal-address" },
    "calscale": DEFAULT_TYPE_TEXT,
    "class": DEFAULT_TYPE_TEXT,
    "comment": DEFAULT_TYPE_TEXT,
    "completed": DEFAULT_TYPE_DATETIME,
    "contact": DEFAULT_TYPE_TEXT,
    "created": DEFAULT_TYPE_DATETIME,
    "description": DEFAULT_TYPE_TEXT,
    "dtend": DEFAULT_TYPE_DATETIME_DATE,
    "dtstamp": DEFAULT_TYPE_DATETIME,
    "dtstart": DEFAULT_TYPE_DATETIME_DATE,
    "due": DEFAULT_TYPE_DATETIME_DATE,
    "duration": { defaultType: "duration" },
    "exdate": {
      defaultType: "date-time",
      allowedTypes: ["date-time", "date"],
      multiValue: ','
    },
    "exrule": DEFAULT_TYPE_RECUR,
    "freebusy": { defaultType: "period", multiValue: "," },
    "geo": { defaultType: "float", structuredValue: ";" },
    "last-modified": DEFAULT_TYPE_DATETIME,
    "location": DEFAULT_TYPE_TEXT,
    "method": DEFAULT_TYPE_TEXT,
    "organizer": { defaultType: "cal-address" },
    "percent-complete": DEFAULT_TYPE_INTEGER,
    "priority": DEFAULT_TYPE_INTEGER,
    "prodid": DEFAULT_TYPE_TEXT,
    "related-to": DEFAULT_TYPE_TEXT,
    "repeat": DEFAULT_TYPE_INTEGER,
    "rdate": {
      defaultType: "date-time",
      allowedTypes: ["date-time", "date", "period"],
      multiValue: ',',
      detectType: function(string) {
        if (string.indexOf('/') !== -1) {
          return 'period';
        }
        return (string.indexOf('T') === -1) ? 'date' : 'date-time';
      }
    },
    "recurrence-id": DEFAULT_TYPE_DATETIME_DATE,
    "resources": DEFAULT_TYPE_TEXT_MULTI,
    "request-status": DEFAULT_TYPE_TEXT_STRUCTURED,
    "rrule": DEFAULT_TYPE_RECUR,
    "sequence": DEFAULT_TYPE_INTEGER,
    "status": DEFAULT_TYPE_TEXT,
    "summary": DEFAULT_TYPE_TEXT,
    "transp": DEFAULT_TYPE_TEXT,
    "trigger": { defaultType: "duration", allowedTypes: ["duration", "date-time"] },
    "tzoffsetfrom": DEFAULT_TYPE_UTCOFFSET,
    "tzoffsetto": DEFAULT_TYPE_UTCOFFSET,
    "tzurl": DEFAULT_TYPE_URI,
    "tzid": DEFAULT_TYPE_TEXT,
    "tzname": DEFAULT_TYPE_TEXT
  });

  // When adding a value here, be sure to add it to the parameter types!
  var vcardValues = ICAL.helpers.extend(commonValues, {
    text: createTextType(FROM_VCARD_NEWLINE, TO_VCARD_NEWLINE),
    uri: createTextType(FROM_VCARD_NEWLINE, TO_VCARD_NEWLINE),

    date: {
      decorate: function(aValue) {
        return ICAL.VCardTime.fromDateAndOrTimeString(aValue, "date");
      },
      undecorate: function(aValue) {
        return aValue.toString();
      },
      fromICAL: function(aValue) {
        if (aValue.length == 8) {
          return icalValues.date.fromICAL(aValue);
        } else if (aValue[0] == '-' && aValue.length == 6) {
          return aValue.substr(0, 4) + '-' + aValue.substr(4);
        } else {
          return aValue;
        }
      },
      toICAL: function(aValue) {
        if (aValue.length == 10) {
          return icalValues.date.toICAL(aValue);
        } else if (aValue[0] == '-' && aValue.length == 7) {
          return aValue.substr(0, 4) + aValue.substr(5);
        } else {
          return aValue;
        }
      }
    },

    time: {
      decorate: function(aValue) {
        return ICAL.VCardTime.fromDateAndOrTimeString("T" + aValue, "time");
      },
      undecorate: function(aValue) {
        return aValue.toString();
      },
      fromICAL: function(aValue) {
        var splitzone = vcardValues.time._splitZone(aValue, true);
        var zone = splitzone[0], value = splitzone[1];

        //console.log("SPLIT: ",splitzone);

        if (value.length == 6) {
          value = value.substr(0, 2) + ':' +
                  value.substr(2, 2) + ':' +
                  value.substr(4, 2);
        } else if (value.length == 4 && value[0] != '-') {
          value = value.substr(0, 2) + ':' + value.substr(2, 2);
        } else if (value.length == 5) {
          value = value.substr(0, 3) + ':' + value.substr(3, 2);
        }

        if (zone.length == 5 && (zone[0] == '-' || zone[0] == '+')) {
          zone = zone.substr(0, 3) + ':' + zone.substr(3);
        }

        return value + zone;
      },

      toICAL: function(aValue) {
        var splitzone = vcardValues.time._splitZone(aValue);
        var zone = splitzone[0], value = splitzone[1];

        if (value.length == 8) {
          value = value.substr(0, 2) +
                  value.substr(3, 2) +
                  value.substr(6, 2);
        } else if (value.length == 5 && value[0] != '-') {
          value = value.substr(0, 2) + value.substr(3, 2);
        } else if (value.length == 6) {
          value = value.substr(0, 3) + value.substr(4, 2);
        }

        if (zone.length == 6 && (zone[0] == '-' || zone[0] == '+')) {
          zone = zone.substr(0, 3) + zone.substr(4);
        }

        return value + zone;
      },

      _splitZone: function(aValue, isFromIcal) {
        var lastChar = aValue.length - 1;
        var signChar = aValue.length - (isFromIcal ? 5 : 6);
        var sign = aValue[signChar];
        var zone, value;

        if (aValue[lastChar] == 'Z') {
          zone = aValue[lastChar];
          value = aValue.substr(0, lastChar);
        } else if (aValue.length > 6 && (sign == '-' || sign == '+')) {
          zone = aValue.substr(signChar);
          value = aValue.substr(0, signChar);
        } else {
          zone = "";
          value = aValue;
        }

        return [zone, value];
      }
    },

    "date-time": {
      decorate: function(aValue) {
        return ICAL.VCardTime.fromDateAndOrTimeString(aValue, "date-time");
      },

      undecorate: function(aValue) {
        return aValue.toString();
      },

      fromICAL: function(aValue) {
        return vcardValues['date-and-or-time'].fromICAL(aValue);
      },

      toICAL: function(aValue) {
        return vcardValues['date-and-or-time'].toICAL(aValue);
      }
    },

    "date-and-or-time": {
      decorate: function(aValue) {
        return ICAL.VCardTime.fromDateAndOrTimeString(aValue, "date-and-or-time");
      },

      undecorate: function(aValue) {
        return aValue.toString();
      },

      fromICAL: function(aValue) {
        var parts = aValue.split('T');
        return (parts[0] ? vcardValues.date.fromICAL(parts[0]) : '') +
               (parts[1] ? 'T' + vcardValues.time.fromICAL(parts[1]) : '');
      },

      toICAL: function(aValue) {
        var parts = aValue.split('T');
        return vcardValues.date.toICAL(parts[0]) +
               (parts[1] ? 'T' + vcardValues.time.toICAL(parts[1]) : '');

      }
    },
    timestamp: icalValues['date-time'],
    "language-tag": {
      matches: /^[a-zA-Z0-9-]+$/ // Could go with a more strict regex here
    }
  });

  var vcardParams = {
    "type": {
      valueType: "text",
      multiValue: ","
    },
    "value": {
      // since the value here is a 'type' lowercase is used.
      values: ["text", "uri", "date", "time", "date-time", "date-and-or-time",
               "timestamp", "boolean", "integer", "float", "utc-offset",
               "language-tag"],
      allowXName: true,
      allowIanaToken: true
    }
  };

  var vcardProperties = ICAL.helpers.extend(commonProperties, {
    "adr": { defaultType: "text", structuredValue: ";", multiValue: "," },
    "anniversary": DEFAULT_TYPE_DATE_ANDOR_TIME,
    "bday": DEFAULT_TYPE_DATE_ANDOR_TIME,
    "caladruri": DEFAULT_TYPE_URI,
    "caluri": DEFAULT_TYPE_URI,
    "clientpidmap": DEFAULT_TYPE_TEXT_STRUCTURED,
    "email": DEFAULT_TYPE_TEXT,
    "fburl": DEFAULT_TYPE_URI,
    "fn": DEFAULT_TYPE_TEXT,
    "gender": DEFAULT_TYPE_TEXT_STRUCTURED,
    "geo": DEFAULT_TYPE_URI,
    "impp": DEFAULT_TYPE_URI,
    "key": DEFAULT_TYPE_URI,
    "kind": DEFAULT_TYPE_TEXT,
    "lang": { defaultType: "language-tag" },
    "logo": DEFAULT_TYPE_URI,
    "member": DEFAULT_TYPE_URI,
    "n": { defaultType: "text", structuredValue: ";", multiValue: "," },
    "nickname": DEFAULT_TYPE_TEXT_MULTI,
    "note": DEFAULT_TYPE_TEXT,
    "org": { defaultType: "text", structuredValue: ";" },
    "photo": DEFAULT_TYPE_URI,
    "related": DEFAULT_TYPE_URI,
    "rev": { defaultType: "timestamp" },
    "role": DEFAULT_TYPE_TEXT,
    "sound": DEFAULT_TYPE_URI,
    "source": DEFAULT_TYPE_URI,
    "tel": { defaultType: "uri", allowedTypes: ["uri", "text"] },
    "title": DEFAULT_TYPE_TEXT,
    "tz": { defaultType: "text", allowedTypes: ["text", "utc-offset", "uri"] },
    "xml": DEFAULT_TYPE_TEXT
  });

  var vcard3Values = ICAL.helpers.extend(commonValues, {
    binary: icalValues.binary,
    date: vcardValues.date,
    "date-time": vcardValues["date-time"],
    "phone-number": {
      // TODO
      /* ... */
    },
    uri: icalValues.uri,
    text: icalValues.text,
    time: icalValues.time,
    vcard: icalValues.text,
    "utc-offset": {
      toICAL: function(aValue) {
        return aValue.substr(0, 7);
      },

      fromICAL: function(aValue) {
        return aValue.substr(0, 7);
      },

      decorate: function(aValue) {
        return ICAL.UtcOffset.fromString(aValue);
      },

      undecorate: function(aValue) {
        return aValue.toString();
      }
    }
  });

  var vcard3Params = {
    "type": {
      valueType: "text",
      multiValue: ","
    },
    "value": {
      // since the value here is a 'type' lowercase is used.
      values: ["text", "uri", "date", "date-time", "phone-number", "time",
               "boolean", "integer", "float", "utc-offset", "vcard", "binary"],
      allowXName: true,
      allowIanaToken: true
    }
  };

  var vcard3Properties = ICAL.helpers.extend(commonProperties, {
    fn: DEFAULT_TYPE_TEXT,
    n: { defaultType: "text", structuredValue: ";", multiValue: "," },
    nickname: DEFAULT_TYPE_TEXT_MULTI,
    photo: { defaultType: "binary", allowedTypes: ["binary", "uri"] },
    bday: {
      defaultType: "date-time",
      allowedTypes: ["date-time", "date"],
      detectType: function(string) {
        return (string.indexOf('T') === -1) ? 'date' : 'date-time';
      }
    },

    adr: { defaultType: "text", structuredValue: ";", multiValue: "," },
    label: DEFAULT_TYPE_TEXT,

    tel: { defaultType: "phone-number" },
    email: DEFAULT_TYPE_TEXT,
    mailer: DEFAULT_TYPE_TEXT,

    tz: { defaultType: "utc-offset", allowedTypes: ["utc-offset", "text"] },
    geo: { defaultType: "float", structuredValue: ";" },

    title: DEFAULT_TYPE_TEXT,
    role: DEFAULT_TYPE_TEXT,
    logo: { defaultType: "binary", allowedTypes: ["binary", "uri"] },
    agent: { defaultType: "vcard", allowedTypes: ["vcard", "text", "uri"] },
    org: DEFAULT_TYPE_TEXT_STRUCTURED,

    note: DEFAULT_TYPE_TEXT_MULTI,
    prodid: DEFAULT_TYPE_TEXT,
    rev: {
      defaultType: "date-time",
      allowedTypes: ["date-time", "date"],
      detectType: function(string) {
        return (string.indexOf('T') === -1) ? 'date' : 'date-time';
      }
    },
    "sort-string": DEFAULT_TYPE_TEXT,
    sound: { defaultType: "binary", allowedTypes: ["binary", "uri"] },

    class: DEFAULT_TYPE_TEXT,
    key: { defaultType: "binary", allowedTypes: ["binary", "text"] }
  });

  /**
   * iCalendar design set
   * @type {ICAL.design.designSet}
   */
  var icalSet = {
    value: icalValues,
    param: icalParams,
    property: icalProperties
  };

  /**
   * vCard 4.0 design set
   * @type {ICAL.design.designSet}
   */
  var vcardSet = {
    value: vcardValues,
    param: vcardParams,
    property: vcardProperties
  };

  /**
   * vCard 3.0 design set
   * @type {ICAL.design.designSet}
   */
  var vcard3Set = {
    value: vcard3Values,
    param: vcard3Params,
    property: vcard3Properties
  };

  /**
   * The design data, used by the parser to determine types for properties and
   * other metadata needed to produce correct jCard/jCal data.
   *
   * @alias ICAL.design
   * @namespace
   */
  var design = {
    /**
     * A designSet describes value, parameter and property data. It is used by
     * ther parser and stringifier in components and properties to determine they
     * should be represented.
     *
     * @typedef {Object} designSet
     * @memberOf ICAL.design
     * @property {Object} value       Definitions for value types, keys are type names
     * @property {Object} param       Definitions for params, keys are param names
     * @property {Object} property    Defintions for properties, keys are property names
     */


    /**
     * The default set for new properties and components if none is specified.
     * @type {ICAL.design.designSet}
     */
    defaultSet: icalSet,

    /**
     * The default type for unknown properties
     * @type {String}
     */
    defaultType: 'unknown',

    /**
     * Holds the design set for known top-level components
     *
     * @type {Object}
     * @property {ICAL.design.designSet} vcard       vCard VCARD
     * @property {ICAL.design.designSet} vevent      iCalendar VEVENT
     * @property {ICAL.design.designSet} vtodo       iCalendar VTODO
     * @property {ICAL.design.designSet} vjournal    iCalendar VJOURNAL
     * @property {ICAL.design.designSet} valarm      iCalendar VALARM
     * @property {ICAL.design.designSet} vtimezone   iCalendar VTIMEZONE
     * @property {ICAL.design.designSet} daylight    iCalendar DAYLIGHT
     * @property {ICAL.design.designSet} standard    iCalendar STANDARD
     *
     * @example
     * var propertyName = 'fn';
     * var componentDesign = ICAL.design.components.vcard;
     * var propertyDetails = componentDesign.property[propertyName];
     * if (propertyDetails.defaultType == 'text') {
     *   // Yep, sure is...
     * }
     */
    components: {
      vcard: vcardSet,
      vcard3: vcard3Set,
      vevent: icalSet,
      vtodo: icalSet,
      vjournal: icalSet,
      valarm: icalSet,
      vtimezone: icalSet,
      daylight: icalSet,
      standard: icalSet
    },


    /**
     * The design set for iCalendar (rfc5545/rfc7265) components.
     * @type {ICAL.design.designSet}
     */
    icalendar: icalSet,

    /**
     * The design set for vCard (rfc6350/rfc7095) components.
     * @type {ICAL.design.designSet}
     */
    vcard: vcardSet,

    /**
     * The design set for vCard (rfc2425/rfc2426/rfc7095) components.
     * @type {ICAL.design.designSet}
     */
    vcard3: vcard3Set,

    /**
     * Gets the design set for the given component name.
     *
     * @param {String} componentName        The name of the component
     * @return {ICAL.design.designSet}      The design set for the component
     */
    getDesignSet: function(componentName) {
      var isInDesign = componentName && componentName in design.components;
      return isInDesign ? design.components[componentName] : design.defaultSet;
    }
  };

  return design;
}());
/* This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/.
 * Portions Copyright (C) Philipp Kewisch, 2011-2015 */


/**
 * Contains various functions to convert jCal and jCard data back into
 * iCalendar and vCard.
 * @namespace
 */
ICAL.stringify = (function() {
  'use strict';

  var LINE_ENDING = '\r\n';
  var DEFAULT_VALUE_TYPE = 'unknown';

  var design = ICAL.design;
  var helpers = ICAL.helpers;

  /**
   * Convert a full jCal/jCard array into a iCalendar/vCard string.
   *
   * @function ICAL.stringify
   * @variation function
   * @param {Array} jCal    The jCal/jCard document
   * @return {String}       The stringified iCalendar/vCard document
   */
  function stringify(jCal) {
    if (typeof jCal[0] == "string") {
      // This is a single component
      jCal = [jCal];
    }

    var i = 0;
    var len = jCal.length;
    var result = '';

    for (; i < len; i++) {
      result += stringify.component(jCal[i]) + LINE_ENDING;
    }

    return result;
  }

  /**
   * Converts an jCal component array into a ICAL string.
   * Recursive will resolve sub-components.
   *
   * Exact component/property order is not saved all
   * properties will come before subcomponents.
   *
   * @function ICAL.stringify.component
   * @param {Array} component
   *        jCal/jCard fragment of a component
   * @param {ICAL.design.designSet} designSet
   *        The design data to use for this component
   * @return {String}       The iCalendar/vCard string
   */
  stringify.component = function(component, designSet) {
    var name = component[0].toUpperCase();
    var result = 'BEGIN:' + name + LINE_ENDING;

    var props = component[1];
    var propIdx = 0;
    var propLen = props.length;

    var designSetName = component[0];
    // rfc6350 requires that in vCard 4.0 the first component is the VERSION
    // component with as value 4.0, note that 3.0 does not have this requirement.
    if (designSetName === 'vcard' && component[1].length > 0 &&
            !(component[1][0][0] === "version" && component[1][0][3] === "4.0")) {
      designSetName = "vcard3";
    }
    designSet = designSet || design.getDesignSet(designSetName);

    for (; propIdx < propLen; propIdx++) {
      result += stringify.property(props[propIdx], designSet) + LINE_ENDING;
    }

    // Ignore subcomponents if none exist, e.g. in vCard.
    var comps = component[2] || [];
    var compIdx = 0;
    var compLen = comps.length;

    for (; compIdx < compLen; compIdx++) {
      result += stringify.component(comps[compIdx], designSet) + LINE_ENDING;
    }

    result += 'END:' + name;
    return result;
  };

  /**
   * Converts a single jCal/jCard property to a iCalendar/vCard string.
   *
   * @function ICAL.stringify.property
   * @param {Array} property
   *        jCal/jCard property array
   * @param {ICAL.design.designSet} designSet
   *        The design data to use for this property
   * @param {Boolean} noFold
   *        If true, the line is not folded
   * @return {String}       The iCalendar/vCard string
   */
  stringify.property = function(property, designSet, noFold) {
    var name = property[0].toUpperCase();
    var jsName = property[0];
    var params = property[1];

    var line = name;

    var paramName;
    for (paramName in params) {
      var value = params[paramName];

      /* istanbul ignore else */
      if (params.hasOwnProperty(paramName)) {
        var multiValue = (paramName in designSet.param) && designSet.param[paramName].multiValue;
        if (multiValue && Array.isArray(value)) {
          if (designSet.param[paramName].multiValueSeparateDQuote) {
            multiValue = '"' + multiValue + '"';
          }
          value = value.map(stringify._rfc6868Unescape);
          value = stringify.multiValue(value, multiValue, "unknown", null, designSet);
        } else {
          value = stringify._rfc6868Unescape(value);
        }


        line += ';' + paramName.toUpperCase();
        line += '=' + stringify.propertyValue(value);
      }
    }

    if (property.length === 3) {
      // If there are no values, we must assume a blank value
      return line + ':';
    }

    var valueType = property[2];

    if (!designSet) {
      designSet = design.defaultSet;
    }

    var propDetails;
    var multiValue = false;
    var structuredValue = false;
    var isDefault = false;

    if (jsName in designSet.property) {
      propDetails = designSet.property[jsName];

      if ('multiValue' in propDetails) {
        multiValue = propDetails.multiValue;
      }

      if (('structuredValue' in propDetails) && Array.isArray(property[3])) {
        structuredValue = propDetails.structuredValue;
      }

      if ('defaultType' in propDetails) {
        if (valueType === propDetails.defaultType) {
          isDefault = true;
        }
      } else {
        if (valueType === DEFAULT_VALUE_TYPE) {
          isDefault = true;
        }
      }
    } else {
      if (valueType === DEFAULT_VALUE_TYPE) {
        isDefault = true;
      }
    }

    // push the VALUE property if type is not the default
    // for the current property.
    if (!isDefault) {
      // value will never contain ;/:/, so we don't escape it here.
      line += ';VALUE=' + valueType.toUpperCase();
    }

    line += ':';

    if (multiValue && structuredValue) {
      line += stringify.multiValue(
        property[3], structuredValue, valueType, multiValue, designSet, structuredValue
      );
    } else if (multiValue) {
      line += stringify.multiValue(
        property.slice(3), multiValue, valueType, null, designSet, false
      );
    } else if (structuredValue) {
      line += stringify.multiValue(
        property[3], structuredValue, valueType, null, designSet, structuredValue
      );
    } else {
      line += stringify.value(property[3], valueType, designSet, false);
    }

    return noFold ? line : ICAL.helpers.foldline(line);
  };

  /**
   * Handles escaping of property values that may contain:
   *
   *    COLON (:), SEMICOLON (;), or COMMA (,)
   *
   * If any of the above are present the result is wrapped
   * in double quotes.
   *
   * @function ICAL.stringify.propertyValue
   * @param {String} value      Raw property value
   * @return {String}           Given or escaped value when needed
   */
  stringify.propertyValue = function(value) {

    if ((helpers.unescapedIndexOf(value, ',') === -1) &&
        (helpers.unescapedIndexOf(value, ':') === -1) &&
        (helpers.unescapedIndexOf(value, ';') === -1)) {

      return value;
    }

    return '"' + value + '"';
  };

  /**
   * Converts an array of ical values into a single
   * string based on a type and a delimiter value (like ",").
   *
   * @function ICAL.stringify.multiValue
   * @param {Array} values      List of values to convert
   * @param {String} delim      Used to join the values (",", ";", ":")
   * @param {String} type       Lowecase ical value type
   *        (like boolean, date-time, etc..)
   * @param {?String} innerMulti If set, each value will again be processed
   *        Used for structured values
   * @param {ICAL.design.designSet} designSet
   *        The design data to use for this property
   *
   * @return {String}           iCalendar/vCard string for value
   */
  stringify.multiValue = function(values, delim, type, innerMulti, designSet, structuredValue) {
    var result = '';
    var len = values.length;
    var i = 0;

    for (; i < len; i++) {
      if (innerMulti && Array.isArray(values[i])) {
        result += stringify.multiValue(values[i], innerMulti, type, null, designSet, structuredValue);
      } else {
        result += stringify.value(values[i], type, designSet, structuredValue);
      }

      if (i !== (len - 1)) {
        result += delim;
      }
    }

    return result;
  };

  /**
   * Processes a single ical value runs the associated "toICAL" method from the
   * design value type if available to convert the value.
   *
   * @function ICAL.stringify.value
   * @param {String|Number} value       A formatted value
   * @param {String} type               Lowercase iCalendar/vCard value type
   *  (like boolean, date-time, etc..)
   * @return {String}                   iCalendar/vCard value for single value
   */
  stringify.value = function(value, type, designSet, structuredValue) {
    if (type in designSet.value && 'toICAL' in designSet.value[type]) {
      return designSet.value[type].toICAL(value, structuredValue);
    }
    return value;
  };

  /**
   * Internal helper for rfc6868. Exposing this on ICAL.stringify so that
   * hackers can disable the rfc6868 parsing if the really need to.
   *
   * @param {String} val        The value to unescape
   * @return {String}           The escaped value
   */
  stringify._rfc6868Unescape = function(val) {
    return val.replace(/[\n^"]/g, function(x) {
      return RFC6868_REPLACE_MAP[x];
    });
  };
  var RFC6868_REPLACE_MAP = { '"': "^'", "\n": "^n", "^": "^^" };

  return stringify;
}());
/* This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/.
 * Portions Copyright (C) Philipp Kewisch, 2011-2015 */


/**
 * Contains various functions to parse iCalendar and vCard data.
 * @namespace
 */
ICAL.parse = (function() {
  'use strict';

  var CHAR = /[^ \t]/;
  var MULTIVALUE_DELIMITER = ',';
  var VALUE_DELIMITER = ':';
  var PARAM_DELIMITER = ';';
  var PARAM_NAME_DELIMITER = '=';
  var DEFAULT_VALUE_TYPE = 'unknown';
  var DEFAULT_PARAM_TYPE = 'text';

  var design = ICAL.design;
  var helpers = ICAL.helpers;

  /**
   * An error that occurred during parsing.
   *
   * @param {String} message        The error message
   * @memberof ICAL.parse
   * @extends {Error}
   * @class
   */
  function ParserError(message) {
    this.message = message;
    this.name = 'ParserError';

    try {
      throw new Error();
    } catch (e) {
      if (e.stack) {
        var split = e.stack.split('\n');
        split.shift();
        this.stack = split.join('\n');
      }
    }
  }

  ParserError.prototype = Error.prototype;

  /**
   * Parses iCalendar or vCard data into a raw jCal object. Consult
   * documentation on the {@tutorial layers|layers of parsing} for more
   * details.
   *
   * @function ICAL.parse
   * @variation function
   * @todo Fix the API to be more clear on the return type
   * @param {String} input      The string data to parse
   * @return {Object|Object[]}  A single jCal object, or an array thereof
   */
  function parser(input) {
    var state = {};
    var root = state.component = [];

    state.stack = [root];

    parser._eachLine(input, function(err, line) {
      parser._handleContentLine(line, state);
    });


    // when there are still items on the stack
    // throw a fatal error, a component was not closed
    // correctly in that case.
    if (state.stack.length > 1) {
      throw new ParserError(
        'invalid ical body. component began but did not end'
      );
    }

    state = null;

    return (root.length == 1 ? root[0] : root);
  }

  /**
   * Parse an iCalendar property value into the jCal for a single property
   *
   * @function ICAL.parse.property
   * @param {String} str
   *   The iCalendar property string to parse
   * @param {ICAL.design.designSet=} designSet
   *   The design data to use for this property
   * @return {Object}
   *   The jCal Object containing the property
   */
  parser.property = function(str, designSet) {
    var state = {
      component: [[], []],
      designSet: designSet || design.defaultSet
    };
    parser._handleContentLine(str, state);
    return state.component[1][0];
  };

  /**
   * Convenience method to parse a component. You can use ICAL.parse() directly
   * instead.
   *
   * @function ICAL.parse.component
   * @see ICAL.parse(function)
   * @param {String} str    The iCalendar component string to parse
   * @return {Object}       The jCal Object containing the component
   */
  parser.component = function(str) {
    return parser(str);
  };

  // classes & constants
  parser.ParserError = ParserError;

  /**
   * The state for parsing content lines from an iCalendar/vCard string.
   *
   * @private
   * @memberof ICAL.parse
   * @typedef {Object} parserState
   * @property {ICAL.design.designSet} designSet    The design set to use for parsing
   * @property {ICAL.Component[]} stack             The stack of components being processed
   * @property {ICAL.Component} component           The currently active component
   */


  /**
   * Handles a single line of iCalendar/vCard, updating the state.
   *
   * @private
   * @function ICAL.parse._handleContentLine
   * @param {String} line               The content line to process
   * @param {ICAL.parse.parserState}    The current state of the line parsing
   */
  parser._handleContentLine = function(line, state) {
    // break up the parts of the line
    var valuePos = line.indexOf(VALUE_DELIMITER);
    var paramPos = line.indexOf(PARAM_DELIMITER);

    var lastParamIndex;
    var lastValuePos;

    // name of property or begin/end
    var name;
    var value;
    // params is only overridden if paramPos !== -1.
    // we can't do params = params || {} later on
    // because it sacrifices ops.
    var params = {};

    /**
     * Different property cases
     *
     *
     * 1. RRULE:FREQ=foo
     *    // FREQ= is not a param but the value
     *
     * 2. ATTENDEE;ROLE=REQ-PARTICIPANT;
     *    // ROLE= is a param because : has not happened yet
     */
      // when the parameter delimiter is after the
      // value delimiter then its not a parameter.

    if ((paramPos !== -1 && valuePos !== -1)) {
      // when the parameter delimiter is after the
      // value delimiter then its not a parameter.
      if (paramPos > valuePos) {
        paramPos = -1;
      }
    }

    var parsedParams;
    if (paramPos !== -1) {
      name = line.substring(0, paramPos).toLowerCase();
      parsedParams = parser._parseParameters(line.substring(paramPos), 0, state.designSet);
      if (parsedParams[2] == -1) {
        throw new ParserError("Invalid parameters in '" + line + "'");
      }
      params = parsedParams[0];
      lastParamIndex = parsedParams[1].length + parsedParams[2] + paramPos;
      if ((lastValuePos =
        line.substring(lastParamIndex).indexOf(VALUE_DELIMITER)) !== -1) {
        value = line.substring(lastParamIndex + lastValuePos + 1);
      } else {
        throw new ParserError("Missing parameter value in '" + line + "'");
      }
    } else if (valuePos !== -1) {
      // without parmeters (BEGIN:VCAENDAR, CLASS:PUBLIC)
      name = line.substring(0, valuePos).toLowerCase();
      value = line.substring(valuePos + 1);

      if (name === 'begin') {
        var newComponent = [value.toLowerCase(), [], []];
        if (state.stack.length === 1) {
          state.component.push(newComponent);
        } else {
          state.component[2].push(newComponent);
        }
        state.stack.push(state.component);
        state.component = newComponent;
        if (!state.designSet) {
          state.designSet = design.getDesignSet(state.component[0]);
        }
        return;
      } else if (name === 'end') {
        state.component = state.stack.pop();
        return;
      }
      // If its not begin/end, then this is a property with an empty value,
      // which should be considered valid.
    } else {
      /**
       * Invalid line.
       * The rational to throw an error is we will
       * never be certain that the rest of the file
       * is sane and its unlikely that we can serialize
       * the result correctly either.
       */
      throw new ParserError(
        'invalid line (no token ";" or ":") "' + line + '"'
      );
    }

    var valueType;
    var multiValue = false;
    var structuredValue = false;
    var propertyDetails;

    if (name in state.designSet.property) {
      propertyDetails = state.designSet.property[name];

      if ('multiValue' in propertyDetails) {
        multiValue = propertyDetails.multiValue;
      }

      if ('structuredValue' in propertyDetails) {
        structuredValue = propertyDetails.structuredValue;
      }

      if (value && 'detectType' in propertyDetails) {
        valueType = propertyDetails.detectType(value);
      }
    }

    // attempt to determine value
    if (!valueType) {
      if (!('value' in params)) {
        if (propertyDetails) {
          valueType = propertyDetails.defaultType;
        } else {
          valueType = DEFAULT_VALUE_TYPE;
        }
      } else {
        // possible to avoid this?
        valueType = params.value.toLowerCase();
      }
    }

    delete params.value;

    /**
     * Note on `var result` juggling:
     *
     * I observed that building the array in pieces has adverse
     * effects on performance, so where possible we inline the creation.
     * Its a little ugly but resulted in ~2000 additional ops/sec.
     */

    var result;
    if (multiValue && structuredValue) {
      value = parser._parseMultiValue(value, structuredValue, valueType, [], multiValue, state.designSet, structuredValue);
      result = [name, params, valueType, value];
    } else if (multiValue) {
      result = [name, params, valueType];
      parser._parseMultiValue(value, multiValue, valueType, result, null, state.designSet, false);
    } else if (structuredValue) {
      value = parser._parseMultiValue(value, structuredValue, valueType, [], null, state.designSet, structuredValue);
      result = [name, params, valueType, value];
    } else {
      value = parser._parseValue(value, valueType, state.designSet, false);
      result = [name, params, valueType, value];
    }
    // rfc6350 requires that in vCard 4.0 the first component is the VERSION
    // component with as value 4.0, note that 3.0 does not have this requirement.
    if (state.component[0] === 'vcard' && state.component[1].length === 0 &&
            !(name === 'version' && value === '4.0')) {
      state.designSet = design.getDesignSet("vcard3");
    }
    state.component[1].push(result);
  };

  /**
   * Parse a value from the raw value into the jCard/jCal value.
   *
   * @private
   * @function ICAL.parse._parseValue
   * @param {String} value          Original value
   * @param {String} type           Type of value
   * @param {Object} designSet      The design data to use for this value
   * @return {Object} varies on type
   */
  parser._parseValue = function(value, type, designSet, structuredValue) {
    if (type in designSet.value && 'fromICAL' in designSet.value[type]) {
      return designSet.value[type].fromICAL(value, structuredValue);
    }
    return value;
  };

  /**
   * Parse parameters from a string to object.
   *
   * @function ICAL.parse._parseParameters
   * @private
   * @param {String} line           A single unfolded line
   * @param {Numeric} start         Position to start looking for properties
   * @param {Object} designSet      The design data to use for this property
   * @return {Object} key/value pairs
   */
  parser._parseParameters = function(line, start, designSet) {
    var lastParam = start;
    var pos = 0;
    var delim = PARAM_NAME_DELIMITER;
    var result = {};
    var name, lcname;
    var value, valuePos = -1;
    var type, multiValue, mvdelim;

    // find the next '=' sign
    // use lastParam and pos to find name
    // check if " is used if so get value from "->"
    // then increment pos to find next ;

    while ((pos !== false) &&
           (pos = helpers.unescapedIndexOf(line, delim, pos + 1)) !== -1) {

      name = line.substr(lastParam + 1, pos - lastParam - 1);
      if (name.length == 0) {
        throw new ParserError("Empty parameter name in '" + line + "'");
      }
      lcname = name.toLowerCase();

      if (lcname in designSet.param && designSet.param[lcname].valueType) {
        type = designSet.param[lcname].valueType;
      } else {
        type = DEFAULT_PARAM_TYPE;
      }

      if (lcname in designSet.param) {
        multiValue = designSet.param[lcname].multiValue;
        if (designSet.param[lcname].multiValueSeparateDQuote) {
          mvdelim = parser._rfc6868Escape('"' + multiValue + '"');
        }
      }

      var nextChar = line[pos + 1];
      if (nextChar === '"') {
        valuePos = pos + 2;
        pos = helpers.unescapedIndexOf(line, '"', valuePos);
        if (multiValue && pos != -1) {
            var extendedValue = true;
            while (extendedValue) {
              if (line[pos + 1] == multiValue && line[pos + 2] == '"') {
                pos = helpers.unescapedIndexOf(line, '"', pos + 3);
              } else {
                extendedValue = false;
              }
            }
          }
        if (pos === -1) {
          throw new ParserError(
            'invalid line (no matching double quote) "' + line + '"'
          );
        }
        value = line.substr(valuePos, pos - valuePos);
        lastParam = helpers.unescapedIndexOf(line, PARAM_DELIMITER, pos);
        if (lastParam === -1) {
          pos = false;
        }
      } else {
        valuePos = pos + 1;

        // move to next ";"
        var nextPos = helpers.unescapedIndexOf(line, PARAM_DELIMITER, valuePos);
        var propValuePos = helpers.unescapedIndexOf(line, VALUE_DELIMITER, valuePos);
        if (propValuePos !== -1 && nextPos > propValuePos) {
          // this is a delimiter in the property value, let's stop here
          nextPos = propValuePos;
          pos = false;
        } else if (nextPos === -1) {
          // no ";"
          if (propValuePos === -1) {
            nextPos = line.length;
          } else {
            nextPos = propValuePos;
          }
          pos = false;
        } else {
          lastParam = nextPos;
          pos = nextPos;
        }

        value = line.substr(valuePos, nextPos - valuePos);
      }

      value = parser._rfc6868Escape(value);
      if (multiValue) {
        var delimiter = mvdelim || multiValue;
        result[lcname] = parser._parseMultiValue(value, delimiter, type, [], null, designSet);
      } else {
        result[lcname] = parser._parseValue(value, type, designSet);
      }
    }
    return [result, value, valuePos];
  };

  /**
   * Internal helper for rfc6868. Exposing this on ICAL.parse so that
   * hackers can disable the rfc6868 parsing if the really need to.
   *
   * @function ICAL.parse._rfc6868Escape
   * @param {String} val        The value to escape
   * @return {String}           The escaped value
   */
  parser._rfc6868Escape = function(val) {
    return val.replace(/\^['n^]/g, function(x) {
      return RFC6868_REPLACE_MAP[x];
    });
  };
  var RFC6868_REPLACE_MAP = { "^'": '"', "^n": "\n", "^^": "^" };

  /**
   * Parse a multi value string. This function is used either for parsing
   * actual multi-value property's values, or for handling parameter values. It
   * can be used for both multi-value properties and structured value properties.
   *
   * @private
   * @function ICAL.parse._parseMultiValue
   * @param {String} buffer     The buffer containing the full value
   * @param {String} delim      The multi-value delimiter
   * @param {String} type       The value type to be parsed
   * @param {Array.<?>} result        The array to append results to, varies on value type
   * @param {String} innerMulti The inner delimiter to split each value with
   * @param {ICAL.design.designSet} designSet   The design data for this value
   * @return {?|Array.<?>}            Either an array of results, or the first result
   */
  parser._parseMultiValue = function(buffer, delim, type, result, innerMulti, designSet, structuredValue) {
    var pos = 0;
    var lastPos = 0;
    var value;
    if (delim.length === 0) {
      return buffer;
    }

    // split each piece
    while ((pos = helpers.unescapedIndexOf(buffer, delim, lastPos)) !== -1) {
      value = buffer.substr(lastPos, pos - lastPos);
      if (innerMulti) {
        value = parser._parseMultiValue(value, innerMulti, type, [], null, designSet, structuredValue);
      } else {
        value = parser._parseValue(value, type, designSet, structuredValue);
      }
      result.push(value);
      lastPos = pos + delim.length;
    }

    // on the last piece take the rest of string
    value = buffer.substr(lastPos);
    if (innerMulti) {
      value = parser._parseMultiValue(value, innerMulti, type, [], null, designSet, structuredValue);
    } else {
      value = parser._parseValue(value, type, designSet, structuredValue);
    }
    result.push(value);

    return result.length == 1 ? result[0] : result;
  };

  /**
   * Process a complete buffer of iCalendar/vCard data line by line, correctly
   * unfolding content. Each line will be processed with the given callback
   *
   * @private
   * @function ICAL.parse._eachLine
   * @param {String} buffer                         The buffer to process
   * @param {function(?String, String)} callback    The callback for each line
   */
  parser._eachLine = function(buffer, callback) {
    var len = buffer.length;
    var lastPos = buffer.search(CHAR);
    var pos = lastPos;
    var line;
    var firstChar;

    var newlineOffset;

    do {
      pos = buffer.indexOf('\n', lastPos) + 1;

      if (pos > 1 && buffer[pos - 2] === '\r') {
        newlineOffset = 2;
      } else {
        newlineOffset = 1;
      }

      if (pos === 0) {
        pos = len;
        newlineOffset = 0;
      }

      firstChar = buffer[lastPos];

      if (firstChar === ' ' || firstChar === '\t') {
        // add to line
        line += buffer.substr(
          lastPos + 1,
          pos - lastPos - (newlineOffset + 1)
        );
      } else {
        if (line)
          callback(null, line);
        // push line
        line = buffer.substr(
          lastPos,
          pos - lastPos - newlineOffset
        );
      }

      lastPos = pos;
    } while (pos !== len);

    // extra ending line
    line = line.trim();

    if (line.length)
      callback(null, line);
  };

  return parser;

}());
/* This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/.
 * Portions Copyright (C) Philipp Kewisch, 2011-2015 */


/**
 * This symbol is further described later on
 * @ignore
 */
ICAL.Component = (function() {
  'use strict';

  var PROPERTY_INDEX = 1;
  var COMPONENT_INDEX = 2;
  var NAME_INDEX = 0;

  /**
   * @classdesc
   * Wraps a jCal component, adding convenience methods to add, remove and
   * update subcomponents and properties.
   *
   * @class
   * @alias ICAL.Component
   * @param {Array|String} jCal         Raw jCal component data OR name of new
   *                                      component
   * @param {ICAL.Component} parent     Parent component to associate
   */
  function Component(jCal, parent) {
    if (typeof(jCal) === 'string') {
      // jCal spec (name, properties, components)
      jCal = [jCal, [], []];
    }

    // mostly for legacy reasons.
    this.jCal = jCal;

    this.parent = parent || null;
  }

  Component.prototype = {
    /**
     * Hydrated properties are inserted into the _properties array at the same
     * position as in the jCal array, so its possible the array contains
     * undefined values for unhydrdated properties. To avoid iterating the
     * array when checking if all properties have been hydrated, we save the
     * count here.
     *
     * @type {Number}
     * @private
     */
    _hydratedPropertyCount: 0,

    /**
     * The same count as for _hydratedPropertyCount, but for subcomponents
     *
     * @type {Number}
     * @private
     */
    _hydratedComponentCount: 0,

    /**
     * The name of this component
     * @readonly
     */
    get name() {
      return this.jCal[NAME_INDEX];
    },

    /**
     * The design set for this component, e.g. icalendar vs vcard
     *
     * @type {ICAL.design.designSet}
     * @private
     */
    get _designSet() {
      var parentDesign = this.parent && this.parent._designSet;
      return parentDesign || ICAL.design.getDesignSet(this.name);
    },

    _hydrateComponent: function(index) {
      if (!this._components) {
        this._components = [];
        this._hydratedComponentCount = 0;
      }

      if (this._components[index]) {
        return this._components[index];
      }

      var comp = new Component(
        this.jCal[COMPONENT_INDEX][index],
        this
      );

      this._hydratedComponentCount++;
      return (this._components[index] = comp);
    },

    _hydrateProperty: function(index) {
      if (!this._properties) {
        this._properties = [];
        this._hydratedPropertyCount = 0;
      }

      if (this._properties[index]) {
        return this._properties[index];
      }

      var prop = new ICAL.Property(
        this.jCal[PROPERTY_INDEX][index],
        this
      );

      this._hydratedPropertyCount++;
      return (this._properties[index] = prop);
    },

    /**
     * Finds first sub component, optionally filtered by name.
     *
     * @param {String=} name        Optional name to filter by
     * @return {?ICAL.Component}     The found subcomponent
     */
    getFirstSubcomponent: function(name) {
      if (name) {
        var i = 0;
        var comps = this.jCal[COMPONENT_INDEX];
        var len = comps.length;

        for (; i < len; i++) {
          if (comps[i][NAME_INDEX] === name) {
            var result = this._hydrateComponent(i);
            return result;
          }
        }
      } else {
        if (this.jCal[COMPONENT_INDEX].length) {
          return this._hydrateComponent(0);
        }
      }

      // ensure we return a value (strict mode)
      return null;
    },

    /**
     * Finds all sub components, optionally filtering by name.
     *
     * @param {String=} name            Optional name to filter by
     * @return {ICAL.Component[]}       The found sub components
     */
    getAllSubcomponents: function(name) {
      var jCalLen = this.jCal[COMPONENT_INDEX].length;
      var i = 0;

      if (name) {
        var comps = this.jCal[COMPONENT_INDEX];
        var result = [];

        for (; i < jCalLen; i++) {
          if (name === comps[i][NAME_INDEX]) {
            result.push(
              this._hydrateComponent(i)
            );
          }
        }
        return result;
      } else {
        if (!this._components ||
            (this._hydratedComponentCount !== jCalLen)) {
          for (; i < jCalLen; i++) {
            this._hydrateComponent(i);
          }
        }

        return this._components || [];
      }
    },

    /**
     * Returns true when a named property exists.
     *
     * @param {String} name     The property name
     * @return {Boolean}        True, when property is found
     */
    hasProperty: function(name) {
      var props = this.jCal[PROPERTY_INDEX];
      var len = props.length;

      var i = 0;
      for (; i < len; i++) {
        // 0 is property name
        if (props[i][NAME_INDEX] === name) {
          return true;
        }
      }

      return false;
    },

    /**
     * Finds the first property, optionally with the given name.
     *
     * @param {String=} name        Lowercase property name
     * @return {?ICAL.Property}     The found property
     */
    getFirstProperty: function(name) {
      if (name) {
        var i = 0;
        var props = this.jCal[PROPERTY_INDEX];
        var len = props.length;

        for (; i < len; i++) {
          if (props[i][NAME_INDEX] === name) {
            var result = this._hydrateProperty(i);
            return result;
          }
        }
      } else {
        if (this.jCal[PROPERTY_INDEX].length) {
          return this._hydrateProperty(0);
        }
      }

      return null;
    },

    /**
     * Returns first property's value, if available.
     *
     * @param {String=} name    Lowercase property name
     * @return {?String}        The found property value.
     */
    getFirstPropertyValue: function(name) {
      var prop = this.getFirstProperty(name);
      if (prop) {
        return prop.getFirstValue();
      }

      return null;
    },

    /**
     * Get all properties in the component, optionally filtered by name.
     *
     * @param {String=} name        Lowercase property name
     * @return {ICAL.Property[]}    List of properties
     */
    getAllProperties: function(name) {
      var jCalLen = this.jCal[PROPERTY_INDEX].length;
      var i = 0;

      if (name) {
        var props = this.jCal[PROPERTY_INDEX];
        var result = [];

        for (; i < jCalLen; i++) {
          if (name === props[i][NAME_INDEX]) {
            result.push(
              this._hydrateProperty(i)
            );
          }
        }
        return result;
      } else {
        if (!this._properties ||
            (this._hydratedPropertyCount !== jCalLen)) {
          for (; i < jCalLen; i++) {
            this._hydrateProperty(i);
          }
        }

        return this._properties || [];
      }
    },

    _removeObjectByIndex: function(jCalIndex, cache, index) {
      cache = cache || [];
      // remove cached version
      if (cache[index]) {
        var obj = cache[index];
        if ("parent" in obj) {
            obj.parent = null;
        }
      }

      cache.splice(index, 1);

      // remove it from the jCal
      this.jCal[jCalIndex].splice(index, 1);
    },

    _removeObject: function(jCalIndex, cache, nameOrObject) {
      var i = 0;
      var objects = this.jCal[jCalIndex];
      var len = objects.length;
      var cached = this[cache];

      if (typeof(nameOrObject) === 'string') {
        for (; i < len; i++) {
          if (objects[i][NAME_INDEX] === nameOrObject) {
            this._removeObjectByIndex(jCalIndex, cached, i);
            return true;
          }
        }
      } else if (cached) {
        for (; i < len; i++) {
          if (cached[i] && cached[i] === nameOrObject) {
            this._removeObjectByIndex(jCalIndex, cached, i);
            return true;
          }
        }
      }

      return false;
    },

    _removeAllObjects: function(jCalIndex, cache, name) {
      var cached = this[cache];

      // Unfortunately we have to run through all children to reset their
      // parent property.
      var objects = this.jCal[jCalIndex];
      var i = objects.length - 1;

      // descending search required because splice
      // is used and will effect the indices.
      for (; i >= 0; i--) {
        if (!name || objects[i][NAME_INDEX] === name) {
          this._removeObjectByIndex(jCalIndex, cached, i);
        }
      }
    },

    /**
     * Adds a single sub component.
     *
     * @param {ICAL.Component} component        The component to add
     * @return {ICAL.Component}                 The passed in component
     */
    addSubcomponent: function(component) {
      if (!this._components) {
        this._components = [];
        this._hydratedComponentCount = 0;
      }

      if (component.parent) {
        component.parent.removeSubcomponent(component);
      }

      var idx = this.jCal[COMPONENT_INDEX].push(component.jCal);
      this._components[idx - 1] = component;
      this._hydratedComponentCount++;
      component.parent = this;
      return component;
    },

    /**
     * Removes a single component by name or the instance of a specific
     * component.
     *
     * @param {ICAL.Component|String} nameOrComp    Name of component, or component
     * @return {Boolean}                            True when comp is removed
     */
    removeSubcomponent: function(nameOrComp) {
      var removed = this._removeObject(COMPONENT_INDEX, '_components', nameOrComp);
      if (removed) {
        this._hydratedComponentCount--;
      }
      return removed;
    },

    /**
     * Removes all components or (if given) all components by a particular
     * name.
     *
     * @param {String=} name            Lowercase component name
     */
    removeAllSubcomponents: function(name) {
      var removed = this._removeAllObjects(COMPONENT_INDEX, '_components', name);
      this._hydratedComponentCount = 0;
      return removed;
    },

    /**
     * Adds an {@link ICAL.Property} to the component.
     *
     * @param {ICAL.Property} property      The property to add
     * @return {ICAL.Property}              The passed in property
     */
    addProperty: function(property) {
      if (!(property instanceof ICAL.Property)) {
        throw new TypeError('must instance of ICAL.Property');
      }

      if (!this._properties) {
        this._properties = [];
        this._hydratedPropertyCount = 0;
      }

      if (property.parent) {
        property.parent.removeProperty(property);
      }

      var idx = this.jCal[PROPERTY_INDEX].push(property.jCal);
      this._properties[idx - 1] = property;
      this._hydratedPropertyCount++;
      property.parent = this;
      return property;
    },

    /**
     * Helper method to add a property with a value to the component.
     *
     * @param {String}               name         Property name to add
     * @param {String|Number|Object} value        Property value
     * @return {ICAL.Property}                    The created property
     */
    addPropertyWithValue: function(name, value) {
      var prop = new ICAL.Property(name);
      prop.setValue(value);

      this.addProperty(prop);

      return prop;
    },

    /**
     * Helper method that will update or create a property of the given name
     * and sets its value. If multiple properties with the given name exist,
     * only the first is updated.
     *
     * @param {String}               name         Property name to update
     * @param {String|Number|Object} value        Property value
     * @return {ICAL.Property}                    The created property
     */
    updatePropertyWithValue: function(name, value) {
      var prop = this.getFirstProperty(name);

      if (prop) {
        prop.setValue(value);
      } else {
        prop = this.addPropertyWithValue(name, value);
      }

      return prop;
    },

    /**
     * Removes a single property by name or the instance of the specific
     * property.
     *
     * @param {String|ICAL.Property} nameOrProp     Property name or instance to remove
     * @return {Boolean}                            True, when deleted
     */
    removeProperty: function(nameOrProp) {
      var removed = this._removeObject(PROPERTY_INDEX, '_properties', nameOrProp);
      if (removed) {
        this._hydratedPropertyCount--;
      }
      return removed;
    },

    /**
     * Removes all properties associated with this component, optionally
     * filtered by name.
     *
     * @param {String=} name        Lowercase property name
     * @return {Boolean}            True, when deleted
     */
    removeAllProperties: function(name) {
      var removed = this._removeAllObjects(PROPERTY_INDEX, '_properties', name);
      this._hydratedPropertyCount = 0;
      return removed;
    },

    /**
     * Returns the Object representation of this component. The returned object
     * is a live jCal object and should be cloned if modified.
     * @return {Object}
     */
    toJSON: function() {
      return this.jCal;
    },

    /**
     * The string representation of this component.
     * @return {String}
     */
    toString: function() {
      return ICAL.stringify.component(
        this.jCal, this._designSet
      );
    }
  };

  /**
   * Create an {@link ICAL.Component} by parsing the passed iCalendar string.
   *
   * @param {String} str        The iCalendar string to parse
   */
  Component.fromString = function(str) {
    return new Component(ICAL.parse.component(str));
  };

  return Component;
}());
/* This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/.
 * Portions Copyright (C) Philipp Kewisch, 2011-2015 */


/**
 * This symbol is further described later on
 * @ignore
 */
ICAL.Property = (function() {
  'use strict';

  var NAME_INDEX = 0;
  var PROP_INDEX = 1;
  var TYPE_INDEX = 2;
  var VALUE_INDEX = 3;

  var design = ICAL.design;

  /**
   * @classdesc
   * Provides a layer on top of the raw jCal object for manipulating a single
   * property, with its parameters and value.
   *
   * @description
   * Its important to note that mutations done in the wrapper
   * directly mutate the jCal object used to initialize.
   *
   * Can also be used to create new properties by passing
   * the name of the property (as a String).
   *
   * @class
   * @alias ICAL.Property
   * @param {Array|String} jCal         Raw jCal representation OR
   *  the new name of the property
   *
   * @param {ICAL.Component=} parent    Parent component
   */
  function Property(jCal, parent) {
    this._parent = parent || null;

    if (typeof(jCal) === 'string') {
      // We are creating the property by name and need to detect the type
      this.jCal = [jCal, {}, design.defaultType];
      this.jCal[TYPE_INDEX] = this.getDefaultType();
    } else {
      this.jCal = jCal;
    }
    this._updateType();
  }

  Property.prototype = {

    /**
     * The value type for this property
     * @readonly
     * @type {String}
     */
    get type() {
      return this.jCal[TYPE_INDEX];
    },

    /**
     * The name of this property, in lowercase.
     * @readonly
     * @type {String}
     */
    get name() {
      return this.jCal[NAME_INDEX];
    },

    /**
     * The parent component for this property.
     * @type {ICAL.Component}
     */
    get parent() {
      return this._parent;
    },

    set parent(p) {
      // Before setting the parent, check if the design set has changed. If it
      // has, we later need to update the type if it was unknown before.
      var designSetChanged = !this._parent || (p && p._designSet != this._parent._designSet);

      this._parent = p;

      if (this.type == design.defaultType && designSetChanged) {
        this.jCal[TYPE_INDEX] = this.getDefaultType();
        this._updateType();
      }

      return p;
    },

    /**
     * The design set for this property, e.g. icalendar vs vcard
     *
     * @type {ICAL.design.designSet}
     * @private
     */
    get _designSet() {
      return this.parent ? this.parent._designSet : design.defaultSet;
    },

    /**
     * Updates the type metadata from the current jCal type and design set.
     *
     * @private
     */
    _updateType: function() {
      var designSet = this._designSet;

      if (this.type in designSet.value) {
        var designType = designSet.value[this.type];

        if ('decorate' in designSet.value[this.type]) {
          this.isDecorated = true;
        } else {
          this.isDecorated = false;
        }

        if (this.name in designSet.property) {
          this.isMultiValue = ('multiValue' in designSet.property[this.name]);
          this.isStructuredValue = ('structuredValue' in designSet.property[this.name]);
        }
      }
    },

    /**
     * Hydrate a single value. The act of hydrating means turning the raw jCal
     * value into a potentially wrapped object, for example {@link ICAL.Time}.
     *
     * @private
     * @param {Number} index        The index of the value to hydrate
     * @return {Object}             The decorated value.
     */
    _hydrateValue: function(index) {
      if (this._values && this._values[index]) {
        return this._values[index];
      }

      // for the case where there is no value.
      if (this.jCal.length <= (VALUE_INDEX + index)) {
        return null;
      }

      if (this.isDecorated) {
        if (!this._values) {
          this._values = [];
        }
        return (this._values[index] = this._decorate(
          this.jCal[VALUE_INDEX + index]
        ));
      } else {
        return this.jCal[VALUE_INDEX + index];
      }
    },

    /**
     * Decorate a single value, returning its wrapped object. This is used by
     * the hydrate function to actually wrap the value.
     *
     * @private
     * @param {?} value         The value to decorate
     * @return {Object}         The decorated value
     */
    _decorate: function(value) {
      return this._designSet.value[this.type].decorate(value, this);
    },

    /**
     * Undecorate a single value, returning its raw jCal data.
     *
     * @private
     * @param {Object} value         The value to undecorate
     * @return {?}                   The undecorated value
     */
    _undecorate: function(value) {
      return this._designSet.value[this.type].undecorate(value, this);
    },

    /**
     * Sets the value at the given index while also hydrating it. The passed
     * value can either be a decorated or undecorated value.
     *
     * @private
     * @param {?} value             The value to set
     * @param {Number} index        The index to set it at
     */
    _setDecoratedValue: function(value, index) {
      if (!this._values) {
        this._values = [];
      }

      if (typeof(value) === 'object' && 'icaltype' in value) {
        // decorated value
        this.jCal[VALUE_INDEX + index] = this._undecorate(value);
        this._values[index] = value;
      } else {
        // undecorated value
        this.jCal[VALUE_INDEX + index] = value;
        this._values[index] = this._decorate(value);
      }
    },

    /**
     * Gets a parameter on the property.
     *
     * @param {String}        name   Property name (lowercase)
     * @return {Array|String}        Property value
     */
    getParameter: function(name) {
      if (name in this.jCal[PROP_INDEX]) {
        return this.jCal[PROP_INDEX][name];
      } else {
        return undefined;
      }
    },

    /**
     * Gets first parameter on the property.
     *
     * @param {String}        name   Property name (lowercase)
     * @return {String}        Property value
     */
    getFirstParameter: function(name) {
      var parameters = this.getParameter(name);

      if (Array.isArray(parameters)) {
        return parameters[0];
      }

      return parameters;
    },

    /**
     * Sets a parameter on the property.
     *
     * @param {String}       name     The parameter name
     * @param {Array|String} value    The parameter value
     */
    setParameter: function(name, value) {
      var lcname = name.toLowerCase();
      if (typeof value === "string" &&
          lcname in this._designSet.param &&
          'multiValue' in this._designSet.param[lcname]) {
          value = [value];
      }
      this.jCal[PROP_INDEX][name] = value;
    },

    /**
     * Removes a parameter
     *
     * @param {String} name     The parameter name
     */
    removeParameter: function(name) {
      delete this.jCal[PROP_INDEX][name];
    },

    /**
     * Get the default type based on this property's name.
     *
     * @return {String}     The default type for this property
     */
    getDefaultType: function() {
      var name = this.jCal[NAME_INDEX];
      var designSet = this._designSet;

      if (name in designSet.property) {
        var details = designSet.property[name];
        if ('defaultType' in details) {
          return details.defaultType;
        }
      }
      return design.defaultType;
    },

    /**
     * Sets type of property and clears out any existing values of the current
     * type.
     *
     * @param {String} type     New iCAL type (see design.*.values)
     */
    resetType: function(type) {
      this.removeAllValues();
      this.jCal[TYPE_INDEX] = type;
      this._updateType();
    },

    /**
     * Finds the first property value.
     *
     * @return {String}         First property value
     */
    getFirstValue: function() {
      return this._hydrateValue(0);
    },

    /**
     * Gets all values on the property.
     *
     * NOTE: this creates an array during each call.
     *
     * @return {Array}          List of values
     */
    getValues: function() {
      var len = this.jCal.length - VALUE_INDEX;

      if (len < 1) {
        // its possible for a property to have no value.
        return [];
      }

      var i = 0;
      var result = [];

      for (; i < len; i++) {
        result[i] = this._hydrateValue(i);
      }

      return result;
    },

    /**
     * Removes all values from this property
     */
    removeAllValues: function() {
      if (this._values) {
        this._values.length = 0;
      }
      this.jCal.length = 3;
    },

    /**
     * Sets the values of the property.  Will overwrite the existing values.
     * This can only be used for multi-value properties.
     *
     * @param {Array} values    An array of values
     */
    setValues: function(values) {
      if (!this.isMultiValue) {
        throw new Error(
          this.name + ': does not not support mulitValue.\n' +
          'override isMultiValue'
        );
      }

      var len = values.length;
      var i = 0;
      this.removeAllValues();

      if (len > 0 &&
          typeof(values[0]) === 'object' &&
          'icaltype' in values[0]) {
        this.resetType(values[0].icaltype);
      }

      if (this.isDecorated) {
        for (; i < len; i++) {
          this._setDecoratedValue(values[i], i);
        }
      } else {
        for (; i < len; i++) {
          this.jCal[VALUE_INDEX + i] = values[i];
        }
      }
    },

    /**
     * Sets the current value of the property. If this is a multi-value
     * property, all other values will be removed.
     *
     * @param {String|Object} value     New property value.
     */
    setValue: function(value) {
      this.removeAllValues();
      if (typeof(value) === 'object' && 'icaltype' in value) {
        this.resetType(value.icaltype);
      }

      if (this.isDecorated) {
        this._setDecoratedValue(value, 0);
      } else {
        this.jCal[VALUE_INDEX] = value;
      }
    },

    /**
     * Returns the Object representation of this component. The returned object
     * is a live jCal object and should be cloned if modified.
     * @return {Object}
     */
    toJSON: function() {
      return this.jCal;
    },

    /**
     * The string representation of this component.
     * @return {String}
     */
    toICALString: function() {
      return ICAL.stringify.property(
        this.jCal, this._designSet, true
      );
    }
  };

  /**
   * Create an {@link ICAL.Property} by parsing the passed iCalendar string.
   *
   * @param {String} str                        The iCalendar string to parse
   * @param {ICAL.design.designSet=} designSet  The design data to use for this property
   * @return {ICAL.Property}                    The created iCalendar property
   */
  Property.fromString = function(str, designSet) {
    return new Property(ICAL.parse.property(str, designSet));
  };

  return Property;
}());
/* This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/.
 * Portions Copyright (C) Philipp Kewisch, 2011-2015 */


/**
 * This symbol is further described later on
 * @ignore
 */
ICAL.UtcOffset = (function() {

  /**
   * @classdesc
   * This class represents the "duration" value type, with various calculation
   * and manipulation methods.
   *
   * @class
   * @alias ICAL.UtcOffset
   * @param {Object} aData          An object with members of the utc offset
   * @param {Number=} aData.hours   The hours for the utc offset
   * @param {Number=} aData.minutes The minutes in the utc offset
   * @param {Number=} aData.factor  The factor for the utc-offset, either -1 or 1
   */
  function UtcOffset(aData) {
    this.fromData(aData);
  }

  UtcOffset.prototype = {

    /**
     * The hours in the utc-offset
     * @type {Number}
     */
    hours: 0,

    /**
     * The minutes in the utc-offset
     * @type {Number}
     */
    minutes: 0,

    /**
     * The sign of the utc offset, 1 for positive offset, -1 for negative
     * offsets.
     * @type {Number}
     */
    factor: 1,

    /**
     * The type name, to be used in the jCal object.
     * @constant
     * @type {String}
     * @default "utc-offset"
     */
    icaltype: "utc-offset",

    /**
     * Returns a clone of the utc offset object.
     *
     * @return {ICAL.UtcOffset}     The cloned object
     */
    clone: function() {
      return ICAL.UtcOffset.fromSeconds(this.toSeconds());
    },

    /**
     * Sets up the current instance using members from the passed data object.
     *
     * @param {Object} aData          An object with members of the utc offset
     * @param {Number=} aData.hours   The hours for the utc offset
     * @param {Number=} aData.minutes The minutes in the utc offset
     * @param {Number=} aData.factor  The factor for the utc-offset, either -1 or 1
     */
    fromData: function(aData) {
      if (aData) {
        for (var key in aData) {
          /* istanbul ignore else */
          if (aData.hasOwnProperty(key)) {
            this[key] = aData[key];
          }
        }
      }
      this._normalize();
    },

    /**
     * Sets up the current instance from the given seconds value. The seconds
     * value is truncated to the minute. Offsets are wrapped when the world
     * ends, the hour after UTC+14:00 is UTC-12:00.
     *
     * @param {Number} aSeconds         The seconds to convert into an offset
     */
    fromSeconds: function(aSeconds) {
      var secs = Math.abs(aSeconds);

      this.factor = aSeconds < 0 ? -1 : 1;
      this.hours = ICAL.helpers.trunc(secs / 3600);

      secs -= (this.hours * 3600);
      this.minutes = ICAL.helpers.trunc(secs / 60);
      return this;
    },

    /**
     * Convert the current offset to a value in seconds
     *
     * @return {Number}                 The offset in seconds
     */
    toSeconds: function() {
      return this.factor * (60 * this.minutes + 3600 * this.hours);
    },

    /**
     * Compare this utc offset with another one.
     *
     * @param {ICAL.UtcOffset} other        The other offset to compare with
     * @return {Number}                     -1, 0 or 1 for less/equal/greater
     */
    compare: function icaltime_compare(other) {
      var a = this.toSeconds();
      var b = other.toSeconds();
      return (a > b) - (b > a);
    },

    _normalize: function() {
      // Range: 97200 seconds (with 1 hour inbetween)
      var secs = this.toSeconds();
      var factor = this.factor;
      while (secs < -43200) { // = UTC-12:00
        secs += 97200;
      }
      while (secs > 50400) { // = UTC+14:00
        secs -= 97200;
      }

      this.fromSeconds(secs);

      // Avoid changing the factor when on zero seconds
      if (secs == 0) {
        this.factor = factor;
      }
    },

    /**
     * The iCalendar string representation of this utc-offset.
     * @return {String}
     */
    toICALString: function() {
      return ICAL.design.icalendar.value['utc-offset'].toICAL(this.toString());
    },

    /**
     * The string representation of this utc-offset.
     * @return {String}
     */
    toString: function toString() {
      return (this.factor == 1 ? "+" : "-") +
              ICAL.helpers.pad2(this.hours) + ':' +
              ICAL.helpers.pad2(this.minutes);
    }
  };

  /**
   * Creates a new {@link ICAL.UtcOffset} instance from the passed string.
   *
   * @param {String} aString    The string to parse
   * @return {ICAL.Duration}    The created utc-offset instance
   */
  UtcOffset.fromString = function(aString) {
    // -05:00
    var options = {};
    //TODO: support seconds per rfc5545 ?
    options.factor = (aString[0] === '+') ? 1 : -1;
    options.hours = ICAL.helpers.strictParseInt(aString.substr(1, 2));
    options.minutes = ICAL.helpers.strictParseInt(aString.substr(4, 2));

    return new ICAL.UtcOffset(options);
  };

  /**
   * Creates a new {@link ICAL.UtcOffset} instance from the passed seconds
   * value.
   *
   * @param {Number} aSeconds       The number of seconds to convert
   */
  UtcOffset.fromSeconds = function(aSeconds) {
    var instance = new UtcOffset();
    instance.fromSeconds(aSeconds);
    return instance;
  };

  return UtcOffset;
}());
/* This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/.
 * Portions Copyright (C) Philipp Kewisch, 2011-2015 */


/**
 * This symbol is further described later on
 * @ignore
 */
ICAL.Binary = (function() {

  /**
   * @classdesc
   * Represents the BINARY value type, which contains extra methods for
   * encoding and decoding.
   *
   * @class
   * @alias ICAL.Binary
   * @param {String} aValue     The binary data for this value
   */
  function Binary(aValue) {
    this.value = aValue;
  }

  Binary.prototype = {
    /**
     * The type name, to be used in the jCal object.
     * @default "binary"
     * @constant
     */
    icaltype: "binary",

    /**
     * Base64 decode the current value
     *
     * @return {String}         The base64-decoded value
     */
    decodeValue: function decodeValue() {
      return this._b64_decode(this.value);
    },

    /**
     * Encodes the passed parameter with base64 and sets the internal
     * value to the result.
     *
     * @param {String} aValue      The raw binary value to encode
     */
    setEncodedValue: function setEncodedValue(aValue) {
      this.value = this._b64_encode(aValue);
    },

    _b64_encode: function base64_encode(data) {
      // http://kevin.vanzonneveld.net
      // +   original by: Tyler Akins (http://rumkin.com)
      // +   improved by: Bayron Guevara
      // +   improved by: Thunder.m
      // +   improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
      // +   bugfixed by: Pellentesque Malesuada
      // +   improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
      // +   improved by: Rafał Kukawski (http://kukawski.pl)
      // *     example 1: base64_encode('Kevin van Zonneveld');
      // *     returns 1: 'S2V2aW4gdmFuIFpvbm5ldmVsZA=='
      // mozilla has this native
      // - but breaks in 2.0.0.12!
      //if (typeof this.window['atob'] == 'function') {
      //    return atob(data);
      //}
      var b64 = "ABCDEFGHIJKLMNOPQRSTUVWXYZ" +
                "abcdefghijklmnopqrstuvwxyz0123456789+/=";
      var o1, o2, o3, h1, h2, h3, h4, bits, i = 0,
        ac = 0,
        enc = "",
        tmp_arr = [];

      if (!data) {
        return data;
      }

      do { // pack three octets into four hexets
        o1 = data.charCodeAt(i++);
        o2 = data.charCodeAt(i++);
        o3 = data.charCodeAt(i++);

        bits = o1 << 16 | o2 << 8 | o3;

        h1 = bits >> 18 & 0x3f;
        h2 = bits >> 12 & 0x3f;
        h3 = bits >> 6 & 0x3f;
        h4 = bits & 0x3f;

        // use hexets to index into b64, and append result to encoded string
        tmp_arr[ac++] = b64.charAt(h1) + b64.charAt(h2) + b64.charAt(h3) + b64.charAt(h4);
      } while (i < data.length);

      enc = tmp_arr.join('');

      var r = data.length % 3;

      return (r ? enc.slice(0, r - 3) : enc) + '==='.slice(r || 3);

    },

    _b64_decode: function base64_decode(data) {
      // http://kevin.vanzonneveld.net
      // +   original by: Tyler Akins (http://rumkin.com)
      // +   improved by: Thunder.m
      // +      input by: Aman Gupta
      // +   improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
      // +   bugfixed by: Onno Marsman
      // +   bugfixed by: Pellentesque Malesuada
      // +   improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
      // +      input by: Brett Zamir (http://brett-zamir.me)
      // +   bugfixed by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
      // *     example 1: base64_decode('S2V2aW4gdmFuIFpvbm5ldmVsZA==');
      // *     returns 1: 'Kevin van Zonneveld'
      // mozilla has this native
      // - but breaks in 2.0.0.12!
      //if (typeof this.window['btoa'] == 'function') {
      //    return btoa(data);
      //}
      var b64 = "ABCDEFGHIJKLMNOPQRSTUVWXYZ" +
                "abcdefghijklmnopqrstuvwxyz0123456789+/=";
      var o1, o2, o3, h1, h2, h3, h4, bits, i = 0,
        ac = 0,
        dec = "",
        tmp_arr = [];

      if (!data) {
        return data;
      }

      data += '';

      do { // unpack four hexets into three octets using index points in b64
        h1 = b64.indexOf(data.charAt(i++));
        h2 = b64.indexOf(data.charAt(i++));
        h3 = b64.indexOf(data.charAt(i++));
        h4 = b64.indexOf(data.charAt(i++));

        bits = h1 << 18 | h2 << 12 | h3 << 6 | h4;

        o1 = bits >> 16 & 0xff;
        o2 = bits >> 8 & 0xff;
        o3 = bits & 0xff;

        if (h3 == 64) {
          tmp_arr[ac++] = String.fromCharCode(o1);
        } else if (h4 == 64) {
          tmp_arr[ac++] = String.fromCharCode(o1, o2);
        } else {
          tmp_arr[ac++] = String.fromCharCode(o1, o2, o3);
        }
      } while (i < data.length);

      dec = tmp_arr.join('');

      return dec;
    },

    /**
     * The string representation of this value
     * @return {String}
     */
    toString: function() {
      return this.value;
    }
  };

  /**
   * Creates a binary value from the given string.
   *
   * @param {String} aString        The binary value string
   * @return {ICAL.Binary}          The binary value instance
   */
  Binary.fromString = function(aString) {
    return new Binary(aString);
  };

  return Binary;
}());
/* This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/.
 * Portions Copyright (C) Philipp Kewisch, 2011-2015 */



(function() {
  /**
   * @classdesc
   * This class represents the "period" value type, with various calculation
   * and manipulation methods.
   *
   * @description
   * The passed data object cannot contain both and end date and a duration.
   *
   * @class
   * @param {Object} aData                  An object with members of the period
   * @param {ICAL.Time=} aData.start        The start of the period
   * @param {ICAL.Time=} aData.end          The end of the period
   * @param {ICAL.Duration=} aData.duration The duration of the period
   */
  ICAL.Period = function icalperiod(aData) {
    this.wrappedJSObject = this;

    if (aData && 'start' in aData) {
      if (aData.start && !(aData.start instanceof ICAL.Time)) {
        throw new TypeError('.start must be an instance of ICAL.Time');
      }
      this.start = aData.start;
    }

    if (aData && aData.end && aData.duration) {
      throw new Error('cannot accept both end and duration');
    }

    if (aData && 'end' in aData) {
      if (aData.end && !(aData.end instanceof ICAL.Time)) {
        throw new TypeError('.end must be an instance of ICAL.Time');
      }
      this.end = aData.end;
    }

    if (aData && 'duration' in aData) {
      if (aData.duration && !(aData.duration instanceof ICAL.Duration)) {
        throw new TypeError('.duration must be an instance of ICAL.Duration');
      }
      this.duration = aData.duration;
    }
  };

  ICAL.Period.prototype = {

    /**
     * The start of the period
     * @type {ICAL.Time}
     */
    start: null,

    /**
     * The end of the period
     * @type {ICAL.Time}
     */
    end: null,

    /**
     * The duration of the period
     * @type {ICAL.Duration}
     */
    duration: null,

    /**
     * The class identifier.
     * @constant
     * @type {String}
     * @default "icalperiod"
     */
    icalclass: "icalperiod",

    /**
     * The type name, to be used in the jCal object.
     * @constant
     * @type {String}
     * @default "period"
     */
    icaltype: "period",

    /**
     * Returns a clone of the duration object.
     *
     * @return {ICAL.Period}      The cloned object
     */
    clone: function() {
      return ICAL.Period.fromData({
        start: this.start ? this.start.clone() : null,
        end: this.end ? this.end.clone() : null,
        duration: this.duration ? this.duration.clone() : null
      });
    },

    /**
     * Calculates the duration of the period, either directly or by subtracting
     * start from end date.
     *
     * @return {ICAL.Duration}      The calculated duration
     */
    getDuration: function duration() {
      if (this.duration) {
        return this.duration;
      } else {
        return this.end.subtractDate(this.start);
      }
    },

    /**
     * Calculates the end date of the period, either directly or by adding
     * duration to start date.
     *
     * @return {ICAL.Time}          The calculated end date
     */
    getEnd: function() {
      if (this.end) {
        return this.end;
      } else {
        var end = this.start.clone();
        end.addDuration(this.duration);
        return end;
      }
    },

    /**
     * The string representation of this period.
     * @return {String}
     */
    toString: function toString() {
      return this.start + "/" + (this.end || this.duration);
    },

    /**
     * The jCal representation of this period type.
     * @return {Object}
     */
    toJSON: function() {
      return [this.start.toString(), (this.end || this.duration).toString()];
    },

    /**
     * The iCalendar string representation of this period.
     * @return {String}
     */
    toICALString: function() {
      return this.start.toICALString() + "/" +
             (this.end || this.duration).toICALString();
    }
  };

  /**
   * Creates a new {@link ICAL.Period} instance from the passed string.
   *
   * @param {String} str            The string to parse
   * @param {ICAL.Property} prop    The property this period will be on
   * @return {ICAL.Period}          The created period instance
   */
  ICAL.Period.fromString = function fromString(str, prop) {
    var parts = str.split('/');

    if (parts.length !== 2) {
      throw new Error(
        'Invalid string value: "' + str + '" must contain a "/" char.'
      );
    }

    var options = {
      start: ICAL.Time.fromDateTimeString(parts[0], prop)
    };

    var end = parts[1];

    if (ICAL.Duration.isValueString(end)) {
      options.duration = ICAL.Duration.fromString(end);
    } else {
      options.end = ICAL.Time.fromDateTimeString(end, prop);
    }

    return new ICAL.Period(options);
  };

  /**
   * Creates a new {@link ICAL.Period} instance from the given data object.
   * The passed data object cannot contain both and end date and a duration.
   *
   * @param {Object} aData                  An object with members of the period
   * @param {ICAL.Time=} aData.start        The start of the period
   * @param {ICAL.Time=} aData.end          The end of the period
   * @param {ICAL.Duration=} aData.duration The duration of the period
   * @return {ICAL.Period}                  The period instance
   */
  ICAL.Period.fromData = function fromData(aData) {
    return new ICAL.Period(aData);
  };

  /**
   * Returns a new period instance from the given jCal data array. The first
   * member is always the start date string, the second member is either a
   * duration or end date string.
   *
   * @param {Array<String,String>} aData    The jCal data array
   * @param {ICAL.Property} aProp           The property this jCal data is on
   * @return {ICAL.Period}                  The period instance
   */
  ICAL.Period.fromJSON = function(aData, aProp) {
    if (ICAL.Duration.isValueString(aData[1])) {
      return ICAL.Period.fromData({
        start: ICAL.Time.fromDateTimeString(aData[0], aProp),
        duration: ICAL.Duration.fromString(aData[1])
      });
    } else {
      return ICAL.Period.fromData({
        start: ICAL.Time.fromDateTimeString(aData[0], aProp),
        end: ICAL.Time.fromDateTimeString(aData[1], aProp)
      });
    }
  };
})();
/* This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/.
 * Portions Copyright (C) Philipp Kewisch, 2011-2015 */



(function() {
  var DURATION_LETTERS = /([PDWHMTS]{1,1})/;

  /**
   * @classdesc
   * This class represents the "duration" value type, with various calculation
   * and manipulation methods.
   *
   * @class
   * @alias ICAL.Duration
   * @param {Object} data               An object with members of the duration
   * @param {Number} data.weeks         Duration in weeks
   * @param {Number} data.days          Duration in days
   * @param {Number} data.hours         Duration in hours
   * @param {Number} data.minutes       Duration in minutes
   * @param {Number} data.seconds       Duration in seconds
   * @param {Boolean} data.isNegative   If true, the duration is negative
   */
  ICAL.Duration = function icalduration(data) {
    this.wrappedJSObject = this;
    this.fromData(data);
  };

  ICAL.Duration.prototype = {
    /**
     * The weeks in this duration
     * @type {Number}
     * @default 0
     */
    weeks: 0,

    /**
     * The days in this duration
     * @type {Number}
     * @default 0
     */
    days: 0,

    /**
     * The days in this duration
     * @type {Number}
     * @default 0
     */
    hours: 0,

    /**
     * The minutes in this duration
     * @type {Number}
     * @default 0
     */
    minutes: 0,

    /**
     * The seconds in this duration
     * @type {Number}
     * @default 0
     */
    seconds: 0,

    /**
     * The seconds in this duration
     * @type {Boolean}
     * @default false
     */
    isNegative: false,

    /**
     * The class identifier.
     * @constant
     * @type {String}
     * @default "icalduration"
     */
    icalclass: "icalduration",

    /**
     * The type name, to be used in the jCal object.
     * @constant
     * @type {String}
     * @default "duration"
     */
    icaltype: "duration",

    /**
     * Returns a clone of the duration object.
     *
     * @return {ICAL.Duration}      The cloned object
     */
    clone: function clone() {
      return ICAL.Duration.fromData(this);
    },

    /**
     * The duration value expressed as a number of seconds.
     *
     * @return {Number}             The duration value in seconds
     */
    toSeconds: function toSeconds() {
      var seconds = this.seconds + 60 * this.minutes + 3600 * this.hours +
                    86400 * this.days + 7 * 86400 * this.weeks;
      return (this.isNegative ? -seconds : seconds);
    },

    /**
     * Reads the passed seconds value into this duration object. Afterwards,
     * members like {@link ICAL.Duration#days days} and {@link ICAL.Duration#weeks weeks} will be set up
     * accordingly.
     *
     * @param {Number} aSeconds     The duration value in seconds
     * @return {ICAL.Duration}      Returns this instance
     */
    fromSeconds: function fromSeconds(aSeconds) {
      var secs = Math.abs(aSeconds);

      this.isNegative = (aSeconds < 0);
      this.days = ICAL.helpers.trunc(secs / 86400);

      // If we have a flat number of weeks, use them.
      if (this.days % 7 == 0) {
        this.weeks = this.days / 7;
        this.days = 0;
      } else {
        this.weeks = 0;
      }

      secs -= (this.days + 7 * this.weeks) * 86400;

      this.hours = ICAL.helpers.trunc(secs / 3600);
      secs -= this.hours * 3600;

      this.minutes = ICAL.helpers.trunc(secs / 60);
      secs -= this.minutes * 60;

      this.seconds = secs;
      return this;
    },

    /**
     * Sets up the current instance using members from the passed data object.
     *
     * @param {Object} aData               An object with members of the duration
     * @param {Number} aData.weeks         Duration in weeks
     * @param {Number} aData.days          Duration in days
     * @param {Number} aData.hours         Duration in hours
     * @param {Number} aData.minutes       Duration in minutes
     * @param {Number} aData.seconds       Duration in seconds
     * @param {Boolean} aData.isNegative   If true, the duration is negative
     */
    fromData: function fromData(aData) {
      var propsToCopy = ["weeks", "days", "hours",
                         "minutes", "seconds", "isNegative"];
      for (var key in propsToCopy) {
        /* istanbul ignore if */
        if (!propsToCopy.hasOwnProperty(key)) {
          continue;
        }
        var prop = propsToCopy[key];
        if (aData && prop in aData) {
          this[prop] = aData[prop];
        } else {
          this[prop] = 0;
        }
      }
    },

    /**
     * Resets the duration instance to the default values, i.e. PT0S
     */
    reset: function reset() {
      this.isNegative = false;
      this.weeks = 0;
      this.days = 0;
      this.hours = 0;
      this.minutes = 0;
      this.seconds = 0;
    },

    /**
     * Compares the duration instance with another one.
     *
     * @param {ICAL.Duration} aOther        The instance to compare with
     * @return {Number}                     -1, 0 or 1 for less/equal/greater
     */
    compare: function compare(aOther) {
      var thisSeconds = this.toSeconds();
      var otherSeconds = aOther.toSeconds();
      return (thisSeconds > otherSeconds) - (thisSeconds < otherSeconds);
    },

    /**
     * Normalizes the duration instance. For example, a duration with a value
     * of 61 seconds will be normalized to 1 minute and 1 second.
     */
    normalize: function normalize() {
      this.fromSeconds(this.toSeconds());
    },

    /**
     * The string representation of this duration.
     * @return {String}
     */
    toString: function toString() {
      if (this.toSeconds() == 0) {
        return "PT0S";
      } else {
        var str = "";
        if (this.isNegative) str += "-";
        str += "P";
        if (this.weeks) str += this.weeks + "W";
        if (this.days) str += this.days + "D";

        if (this.hours || this.minutes || this.seconds) {
          str += "T";
          if (this.hours) str += this.hours + "H";
          if (this.minutes) str += this.minutes + "M";
          if (this.seconds) str += this.seconds + "S";
        }
        return str;
      }
    },

    /**
     * The iCalendar string representation of this duration.
     * @return {String}
     */
    toICALString: function() {
      return this.toString();
    }
  };

  /**
   * Returns a new ICAL.Duration instance from the passed seconds value.
   *
   * @param {Number} aSeconds       The seconds to create the instance from
   * @return {ICAL.Duration}        The newly created duration instance
   */
  ICAL.Duration.fromSeconds = function icalduration_from_seconds(aSeconds) {
    return (new ICAL.Duration()).fromSeconds(aSeconds);
  };

  /**
   * Internal helper function to handle a chunk of a duration.
   *
   * @param {String} letter type of duration chunk
   * @param {String} number numeric value or -/+
   * @param {Object} dict target to assign values to
   */
  function parseDurationChunk(letter, number, object) {
    var type;
    switch (letter) {
      case 'P':
        if (number && number === '-') {
          object.isNegative = true;
        } else {
          object.isNegative = false;
        }
        // period
        break;
      case 'D':
        type = 'days';
        break;
      case 'W':
        type = 'weeks';
        break;
      case 'H':
        type = 'hours';
        break;
      case 'M':
        type = 'minutes';
        break;
      case 'S':
        type = 'seconds';
        break;
      default:
        // Not a valid chunk
        return 0;
    }

    if (type) {
      if (!number && number !== 0) {
        throw new Error(
          'invalid duration value: Missing number before "' + letter + '"'
        );
      }
      var num = parseInt(number, 10);
      if (ICAL.helpers.isStrictlyNaN(num)) {
        throw new Error(
          'invalid duration value: Invalid number "' + number + '" before "' + letter + '"'
        );
      }
      object[type] = num;
    }

    return 1;
  }

  /**
   * Checks if the given string is an iCalendar duration value.
   *
   * @param {String} value      The raw ical value
   * @return {Boolean}          True, if the given value is of the
   *                              duration ical type
   */
  ICAL.Duration.isValueString = function(string) {
    return (string[0] === 'P' || string[1] === 'P');
  };

  /**
   * Creates a new {@link ICAL.Duration} instance from the passed string.
   *
   * @param {String} aStr       The string to parse
   * @return {ICAL.Duration}    The created duration instance
   */
  ICAL.Duration.fromString = function icalduration_from_string(aStr) {
    var pos = 0;
    var dict = Object.create(null);
    var chunks = 0;

    while ((pos = aStr.search(DURATION_LETTERS)) !== -1) {
      var type = aStr[pos];
      var numeric = aStr.substr(0, pos);
      aStr = aStr.substr(pos + 1);

      chunks += parseDurationChunk(type, numeric, dict);
    }

    if (chunks < 2) {
      // There must be at least a chunk with "P" and some unit chunk
      throw new Error(
        'invalid duration value: Not enough duration components in "' + aStr + '"'
      );
    }

    return new ICAL.Duration(dict);
  };

  /**
   * Creates a new ICAL.Duration instance from the given data object.
   *
   * @param {Object} aData               An object with members of the duration
   * @param {Number} aData.weeks         Duration in weeks
   * @param {Number} aData.days          Duration in days
   * @param {Number} aData.hours         Duration in hours
   * @param {Number} aData.minutes       Duration in minutes
   * @param {Number} aData.seconds       Duration in seconds
   * @param {Boolean} aData.isNegative   If true, the duration is negative
   * @return {ICAL.Duration}             The createad duration instance
   */
  ICAL.Duration.fromData = function icalduration_from_data(aData) {
    return new ICAL.Duration(aData);
  };
})();
/* This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/.
 * Portions Copyright (C) Philipp Kewisch, 2011-2012 */



(function() {
  var OPTIONS = ["tzid", "location", "tznames",
                 "latitude", "longitude"];

  /**
   * @classdesc
   * Timezone representation, created by passing in a tzid and component.
   *
   * @example
   * var vcalendar;
   * var timezoneComp = vcalendar.getFirstSubcomponent('vtimezone');
   * var tzid = timezoneComp.getFirstPropertyValue('tzid');
   *
   * var timezone = new ICAL.Timezone({
   *   component: timezoneComp,
   *   tzid
   * });
   *
   * @class
   * @param {ICAL.Component|Object} data options for class
   * @param {String|ICAL.Component} data.component
   *        If data is a simple object, then this member can be set to either a
   *        string containing the component data, or an already parsed
   *        ICAL.Component
   * @param {String} data.tzid      The timezone identifier
   * @param {String} data.location  The timezone locationw
   * @param {String} data.tznames   An alternative string representation of the
   *                                  timezone
   * @param {Number} data.latitude  The latitude of the timezone
   * @param {Number} data.longitude The longitude of the timezone
   */
  ICAL.Timezone = function icaltimezone(data) {
    this.wrappedJSObject = this;
    this.fromData(data);
  };

  ICAL.Timezone.prototype = {

    /**
     * Timezone identifier
     * @type {String}
     */
    tzid: "",

    /**
     * Timezone location
     * @type {String}
     */
    location: "",

    /**
     * Alternative timezone name, for the string representation
     * @type {String}
     */
    tznames: "",

    /**
     * The primary latitude for the timezone.
     * @type {Number}
     */
    latitude: 0.0,

    /**
     * The primary longitude for the timezone.
     * @type {Number}
     */
    longitude: 0.0,

    /**
     * The vtimezone component for this timezone.
     * @type {ICAL.Component}
     */
    component: null,

    /**
     * The year this timezone has been expanded to. All timezone transition
     * dates until this year are known and can be used for calculation
     *
     * @private
     * @type {Number}
     */
    expandedUntilYear: 0,

    /**
     * The class identifier.
     * @constant
     * @type {String}
     * @default "icaltimezone"
     */
    icalclass: "icaltimezone",

    /**
     * Sets up the current instance using members from the passed data object.
     *
     * @param {ICAL.Component|Object} aData options for class
     * @param {String|ICAL.Component} aData.component
     *        If aData is a simple object, then this member can be set to either a
     *        string containing the component data, or an already parsed
     *        ICAL.Component
     * @param {String} aData.tzid      The timezone identifier
     * @param {String} aData.location  The timezone locationw
     * @param {String} aData.tznames   An alternative string representation of the
     *                                  timezone
     * @param {Number} aData.latitude  The latitude of the timezone
     * @param {Number} aData.longitude The longitude of the timezone
     */
    fromData: function fromData(aData) {
      this.expandedUntilYear = 0;
      this.changes = [];

      if (aData instanceof ICAL.Component) {
        // Either a component is passed directly
        this.component = aData;
      } else {
        // Otherwise the component may be in the data object
        if (aData && "component" in aData) {
          if (typeof aData.component == "string") {
            // If a string was passed, parse it as a component
            var jCal = ICAL.parse(aData.component);
            this.component = new ICAL.Component(jCal);
          } else if (aData.component instanceof ICAL.Component) {
            // If it was a component already, then just set it
            this.component = aData.component;
          } else {
            // Otherwise just null out the component
            this.component = null;
          }
        }

        // Copy remaining passed properties
        for (var key in OPTIONS) {
          /* istanbul ignore else */
          if (OPTIONS.hasOwnProperty(key)) {
            var prop = OPTIONS[key];
            if (aData && prop in aData) {
              this[prop] = aData[prop];
            }
          }
        }
      }

      // If we have a component but no TZID, attempt to get it from the
      // component's properties.
      if (this.component instanceof ICAL.Component && !this.tzid) {
        this.tzid = this.component.getFirstPropertyValue('tzid');
      }

      return this;
    },

    /**
     * Finds the utcOffset the given time would occur in this timezone.
     *
     * @param {ICAL.Time} tt        The time to check for
     * @return {Number} utc offset in seconds
     */
    utcOffset: function utcOffset(tt) {
      if (this == ICAL.Timezone.utcTimezone || this == ICAL.Timezone.localTimezone) {
        return 0;
      }

      this._ensureCoverage(tt.year);

      if (!this.changes.length) {
        return 0;
      }

      var tt_change = {
        year: tt.year,
        month: tt.month,
        day: tt.day,
        hour: tt.hour,
        minute: tt.minute,
        second: tt.second
      };

      var change_num = this._findNearbyChange(tt_change);
      var change_num_to_use = -1;
      var step = 1;

      // TODO: replace with bin search?
      for (;;) {
        var change = ICAL.helpers.clone(this.changes[change_num], true);
        if (change.utcOffset < change.prevUtcOffset) {
          ICAL.Timezone.adjust_change(change, 0, 0, 0, change.utcOffset);
        } else {
          ICAL.Timezone.adjust_change(change, 0, 0, 0,
                                          change.prevUtcOffset);
        }

        var cmp = ICAL.Timezone._compare_change_fn(tt_change, change);

        if (cmp >= 0) {
          change_num_to_use = change_num;
        } else {
          step = -1;
        }

        if (step == -1 && change_num_to_use != -1) {
          break;
        }

        change_num += step;

        if (change_num < 0) {
          return 0;
        }

        if (change_num >= this.changes.length) {
          break;
        }
      }

      var zone_change = this.changes[change_num_to_use];
      var utcOffset_change = zone_change.utcOffset - zone_change.prevUtcOffset;

      if (utcOffset_change < 0 && change_num_to_use > 0) {
        var tmp_change = ICAL.helpers.clone(zone_change, true);
        ICAL.Timezone.adjust_change(tmp_change, 0, 0, 0,
                                        tmp_change.prevUtcOffset);

        if (ICAL.Timezone._compare_change_fn(tt_change, tmp_change) < 0) {
          var prev_zone_change = this.changes[change_num_to_use - 1];

          var want_daylight = false; // TODO

          if (zone_change.is_daylight != want_daylight &&
              prev_zone_change.is_daylight == want_daylight) {
            zone_change = prev_zone_change;
          }
        }
      }

      // TODO return is_daylight?
      return zone_change.utcOffset;
    },

    _findNearbyChange: function icaltimezone_find_nearby_change(change) {
      // find the closest match
      var idx = ICAL.helpers.binsearchInsert(
        this.changes,
        change,
        ICAL.Timezone._compare_change_fn
      );

      if (idx >= this.changes.length) {
        return this.changes.length - 1;
      }

      return idx;
    },

    _ensureCoverage: function(aYear) {
      if (ICAL.Timezone._minimumExpansionYear == -1) {
        var today = ICAL.Time.now();
        ICAL.Timezone._minimumExpansionYear = today.year;
      }

      var changesEndYear = aYear;
      if (changesEndYear < ICAL.Timezone._minimumExpansionYear) {
        changesEndYear = ICAL.Timezone._minimumExpansionYear;
      }

      changesEndYear += ICAL.Timezone.EXTRA_COVERAGE;

      if (changesEndYear > ICAL.Timezone.MAX_YEAR) {
        changesEndYear = ICAL.Timezone.MAX_YEAR;
      }

      if (!this.changes.length || this.expandedUntilYear < aYear) {
        var subcomps = this.component.getAllSubcomponents();
        var compLen = subcomps.length;
        var compIdx = 0;

        for (; compIdx < compLen; compIdx++) {
          this._expandComponent(
            subcomps[compIdx], changesEndYear, this.changes
          );
        }

        this.changes.sort(ICAL.Timezone._compare_change_fn);
        this.expandedUntilYear = changesEndYear;
      }
    },

    _expandComponent: function(aComponent, aYear, changes) {
      if (!aComponent.hasProperty("dtstart") ||
          !aComponent.hasProperty("tzoffsetto") ||
          !aComponent.hasProperty("tzoffsetfrom")) {
        return null;
      }

      var dtstart = aComponent.getFirstProperty("dtstart").getFirstValue();
      var change;

      function convert_tzoffset(offset) {
        return offset.factor * (offset.hours * 3600 + offset.minutes * 60);
      }

      function init_changes() {
        var changebase = {};
        changebase.is_daylight = (aComponent.name == "daylight");
        changebase.utcOffset = convert_tzoffset(
          aComponent.getFirstProperty("tzoffsetto").getFirstValue()
        );

        changebase.prevUtcOffset = convert_tzoffset(
          aComponent.getFirstProperty("tzoffsetfrom").getFirstValue()
        );

        return changebase;
      }

      if (!aComponent.hasProperty("rrule") && !aComponent.hasProperty("rdate")) {
        change = init_changes();
        change.year = dtstart.year;
        change.month = dtstart.month;
        change.day = dtstart.day;
        change.hour = dtstart.hour;
        change.minute = dtstart.minute;
        change.second = dtstart.second;

        ICAL.Timezone.adjust_change(change, 0, 0, 0,
                                        -change.prevUtcOffset);
        changes.push(change);
      } else {
        var props = aComponent.getAllProperties("rdate");
        for (var rdatekey in props) {
          /* istanbul ignore if */
          if (!props.hasOwnProperty(rdatekey)) {
            continue;
          }
          var rdate = props[rdatekey];
          var time = rdate.getFirstValue();
          change = init_changes();

          change.year = time.year;
          change.month = time.month;
          change.day = time.day;

          if (time.isDate) {
            change.hour = dtstart.hour;
            change.minute = dtstart.minute;
            change.second = dtstart.second;

            if (dtstart.zone != ICAL.Timezone.utcTimezone) {
              ICAL.Timezone.adjust_change(change, 0, 0, 0,
                                              -change.prevUtcOffset);
            }
          } else {
            change.hour = time.hour;
            change.minute = time.minute;
            change.second = time.second;

            if (time.zone != ICAL.Timezone.utcTimezone) {
              ICAL.Timezone.adjust_change(change, 0, 0, 0,
                                              -change.prevUtcOffset);
            }
          }

          changes.push(change);
        }

        var rrule = aComponent.getFirstProperty("rrule");

        if (rrule) {
          rrule = rrule.getFirstValue();
          change = init_changes();

          if (rrule.until && rrule.until.zone == ICAL.Timezone.utcTimezone) {
            rrule.until.adjust(0, 0, 0, change.prevUtcOffset);
            rrule.until.zone = ICAL.Timezone.localTimezone;
          }

          var iterator = rrule.iterator(dtstart);

          var occ;
          while ((occ = iterator.next())) {
            change = init_changes();
            if (occ.year > aYear || !occ) {
              break;
            }

            change.year = occ.year;
            change.month = occ.month;
            change.day = occ.day;
            change.hour = occ.hour;
            change.minute = occ.minute;
            change.second = occ.second;
            change.isDate = occ.isDate;

            ICAL.Timezone.adjust_change(change, 0, 0, 0,
                                            -change.prevUtcOffset);
            changes.push(change);
          }
        }
      }

      return changes;
    },

    /**
     * The string representation of this timezone.
     * @return {String}
     */
    toString: function toString() {
      return (this.tznames ? this.tznames : this.tzid);
    }
  };

  ICAL.Timezone._compare_change_fn = function icaltimezone_compare_change_fn(a, b) {
    if (a.year < b.year) return -1;
    else if (a.year > b.year) return 1;

    if (a.month < b.month) return -1;
    else if (a.month > b.month) return 1;

    if (a.day < b.day) return -1;
    else if (a.day > b.day) return 1;

    if (a.hour < b.hour) return -1;
    else if (a.hour > b.hour) return 1;

    if (a.minute < b.minute) return -1;
    else if (a.minute > b.minute) return 1;

    if (a.second < b.second) return -1;
    else if (a.second > b.second) return 1;

    return 0;
  };

  /**
   * Convert the date/time from one zone to the next.
   *
   * @param {ICAL.Time} tt                  The time to convert
   * @param {ICAL.Timezone} from_zone       The source zone to convert from
   * @param {ICAL.Timezone} to_zone         The target zone to conver to
   * @return {ICAL.Time}                    The converted date/time object
   */
  ICAL.Timezone.convert_time = function icaltimezone_convert_time(tt, from_zone, to_zone) {
    if (tt.isDate ||
        from_zone.tzid == to_zone.tzid ||
        from_zone == ICAL.Timezone.localTimezone ||
        to_zone == ICAL.Timezone.localTimezone) {
      tt.zone = to_zone;
      return tt;
    }

    var utcOffset = from_zone.utcOffset(tt);
    tt.adjust(0, 0, 0, - utcOffset);

    utcOffset = to_zone.utcOffset(tt);
    tt.adjust(0, 0, 0, utcOffset);

    return null;
  };

  /**
   * Creates a new ICAL.Timezone instance from the passed data object.
   *
   * @param {ICAL.Component|Object} aData options for class
   * @param {String|ICAL.Component} aData.component
   *        If aData is a simple object, then this member can be set to either a
   *        string containing the component data, or an already parsed
   *        ICAL.Component
   * @param {String} aData.tzid      The timezone identifier
   * @param {String} aData.location  The timezone locationw
   * @param {String} aData.tznames   An alternative string representation of the
   *                                  timezone
   * @param {Number} aData.latitude  The latitude of the timezone
   * @param {Number} aData.longitude The longitude of the timezone
   */
  ICAL.Timezone.fromData = function icaltimezone_fromData(aData) {
    var tt = new ICAL.Timezone();
    return tt.fromData(aData);
  };

  /**
   * The instance describing the UTC timezone
   * @type {ICAL.Timezone}
   * @constant
   * @instance
   */
  ICAL.Timezone.utcTimezone = ICAL.Timezone.fromData({
    tzid: "UTC"
  });

  /**
   * The instance describing the local timezone
   * @type {ICAL.Timezone}
   * @constant
   * @instance
   */
  ICAL.Timezone.localTimezone = ICAL.Timezone.fromData({
    tzid: "floating"
  });

  /**
   * Adjust a timezone change object.
   * @private
   * @param {Object} change     The timezone change object
   * @param {Number} days       The extra amount of days
   * @param {Number} hours      The extra amount of hours
   * @param {Number} minutes    The extra amount of minutes
   * @param {Number} seconds    The extra amount of seconds
   */
  ICAL.Timezone.adjust_change = function icaltimezone_adjust_change(change, days, hours, minutes, seconds) {
    return ICAL.Time.prototype.adjust.call(
      change,
      days,
      hours,
      minutes,
      seconds,
      change
    );
  };

  ICAL.Timezone._minimumExpansionYear = -1;
  ICAL.Timezone.MAX_YEAR = 2035; // TODO this is because of time_t, which we don't need. Still usefull?
  ICAL.Timezone.EXTRA_COVERAGE = 5;
})();
/* This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/.
 * Portions Copyright (C) Philipp Kewisch, 2011-2015 */


/**
 * This symbol is further described later on
 * @ignore
 */
ICAL.TimezoneService = (function() {
  var zones;

  /**
   * @classdesc
   * Singleton class to contain timezones.  Right now its all manual registry in
   * the future we may use this class to download timezone information or handle
   * loading pre-expanded timezones.
   *
   * @namespace
   * @alias ICAL.TimezoneService
   */
  var TimezoneService = {
    reset: function() {
      zones = Object.create(null);
      var utc = ICAL.Timezone.utcTimezone;

      zones.Z = utc;
      zones.UTC = utc;
      zones.GMT = utc;
    },

    /**
     * Checks if timezone id has been registered.
     *
     * @param {String} tzid     Timezone identifier (e.g. America/Los_Angeles)
     * @return {Boolean}        False, when not present
     */
    has: function(tzid) {
      return !!zones[tzid];
    },

    /**
     * Returns a timezone by its tzid if present.
     *
     * @param {String} tzid     Timezone identifier (e.g. America/Los_Angeles)
     * @return {?ICAL.Timezone} The timezone, or null if not found
     */
    get: function(tzid) {
      return zones[tzid];
    },

    /**
     * Registers a timezone object or component.
     *
     * @param {String=} name
     *        The name of the timezone. Defaults to the component's TZID if not
     *        passed.
     * @param {ICAL.Component|ICAL.Timezone} zone
     *        The initialized zone or vtimezone.
     */
    register: function(name, timezone) {
      if (name instanceof ICAL.Component) {
        if (name.name === 'vtimezone') {
          timezone = new ICAL.Timezone(name);
          name = timezone.tzid;
        }
      }

      if (timezone instanceof ICAL.Timezone) {
        zones[name] = timezone;
      } else {
        throw new TypeError('timezone must be ICAL.Timezone or ICAL.Component');
      }
    },

    /**
     * Removes a timezone by its tzid from the list.
     *
     * @param {String} tzid     Timezone identifier (e.g. America/Los_Angeles)
     * @return {?ICAL.Timezone} The removed timezone, or null if not registered
     */
    remove: function(tzid) {
      return (delete zones[tzid]);
    }
  };

  // initialize defaults
  TimezoneService.reset();

  return TimezoneService;
}());
/* This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/.
 * Portions Copyright (C) Philipp Kewisch, 2011-2015 */



(function() {

  /**
   * @classdesc
   * iCalendar Time representation (similar to JS Date object).  Fully
   * independent of system (OS) timezone / time.  Unlike JS Date, the month
   * January is 1, not zero.
   *
   * @example
   * var time = new ICAL.Time({
   *   year: 2012,
   *   month: 10,
   *   day: 11
   *   minute: 0,
   *   second: 0,
   *   isDate: false
   * });
   *
   *
   * @alias ICAL.Time
   * @class
   * @param {Object} data           Time initialization
   * @param {Number=} data.year     The year for this date
   * @param {Number=} data.month    The month for this date
   * @param {Number=} data.day      The day for this date
   * @param {Number=} data.hour     The hour for this date
   * @param {Number=} data.minute   The minute for this date
   * @param {Number=} data.second   The second for this date
   * @param {Boolean=} data.isDate  If true, the instance represents a date (as
   *                                  opposed to a date-time)
   * @param {ICAL.Timezone} zone timezone this position occurs in
   */
  ICAL.Time = function icaltime(data, zone) {
    this.wrappedJSObject = this;
    var time = this._time = Object.create(null);

    /* time defaults */
    time.year = 0;
    time.month = 1;
    time.day = 1;
    time.hour = 0;
    time.minute = 0;
    time.second = 0;
    time.isDate = false;

    this.fromData(data, zone);
  };

  ICAL.Time._dowCache = {};
  ICAL.Time._wnCache = {};

  ICAL.Time.prototype = {

    /**
     * The class identifier.
     * @constant
     * @type {String}
     * @default "icaltime"
     */
    icalclass: "icaltime",
    _cachedUnixTime: null,

    /**
     * The type name, to be used in the jCal object. This value may change and
     * is strictly defined by the {@link ICAL.Time#isDate isDate} member.
     * @readonly
     * @type {String}
     * @default "date-time"
     */
    get icaltype() {
      return this.isDate ? 'date' : 'date-time';
    },

    /**
     * The timezone for this time.
     * @type {ICAL.Timezone}
     */
    zone: null,

    /**
     * Internal uses to indicate that a change has been made and the next read
     * operation must attempt to normalize the value (for example changing the
     * day to 33).
     *
     * @type {Boolean}
     * @private
     */
    _pendingNormalization: false,

    /**
     * Returns a clone of the time object.
     *
     * @return {ICAL.Time}              The cloned object
     */
    clone: function() {
      return new ICAL.Time(this._time, this.zone);
    },

    /**
     * Reset the time instance to epoch time
     */
    reset: function icaltime_reset() {
      this.fromData(ICAL.Time.epochTime);
      this.zone = ICAL.Timezone.utcTimezone;
    },

    /**
     * Reset the time instance to the given date/time values.
     *
     * @param {Number} year             The year to set
     * @param {Number} month            The month to set
     * @param {Number} day              The day to set
     * @param {Number} hour             The hour to set
     * @param {Number} minute           The minute to set
     * @param {Number} second           The second to set
     * @param {ICAL.Timezone} timezone  The timezone to set
     */
    resetTo: function icaltime_resetTo(year, month, day,
                                       hour, minute, second, timezone) {
      this.fromData({
        year: year,
        month: month,
        day: day,
        hour: hour,
        minute: minute,
        second: second,
        zone: timezone
      });
    },

    /**
     * Set up the current instance from the Javascript date value.
     *
     * @param {?Date} aDate     The Javascript Date to read, or null to reset
     * @param {Boolean} useUTC  If true, the UTC values of the date will be used
     */
    fromJSDate: function icaltime_fromJSDate(aDate, useUTC) {
      if (!aDate) {
        this.reset();
      } else {
        if (useUTC) {
          this.zone = ICAL.Timezone.utcTimezone;
          this.year = aDate.getUTCFullYear();
          this.month = aDate.getUTCMonth() + 1;
          this.day = aDate.getUTCDate();
          this.hour = aDate.getUTCHours();
          this.minute = aDate.getUTCMinutes();
          this.second = aDate.getUTCSeconds();
        } else {
          this.zone = ICAL.Timezone.localTimezone;
          this.year = aDate.getFullYear();
          this.month = aDate.getMonth() + 1;
          this.day = aDate.getDate();
          this.hour = aDate.getHours();
          this.minute = aDate.getMinutes();
          this.second = aDate.getSeconds();
        }
      }
      this._cachedUnixTime = null;
      return this;
    },

    /**
     * Sets up the current instance using members from the passed data object.
     *
     * @param {Object} aData            Time initialization
     * @param {Number=} aData.year      The year for this date
     * @param {Number=} aData.month     The month for this date
     * @param {Number=} aData.day       The day for this date
     * @param {Number=} aData.hour      The hour for this date
     * @param {Number=} aData.minute    The minute for this date
     * @param {Number=} aData.second    The second for this date
     * @param {Boolean=} aData.isDate   If true, the instance represents a date
     *                                    (as opposed to a date-time)
     * @param {ICAL.Timezone=} aZone    Timezone this position occurs in
     */
    fromData: function fromData(aData, aZone) {
      if (aData) {
        for (var key in aData) {
          /* istanbul ignore else */
          if (Object.prototype.hasOwnProperty.call(aData, key)) {
            // ical type cannot be set
            if (key === 'icaltype') continue;
            this[key] = aData[key];
          }
        }
      }

      if (aZone) {
        this.zone = aZone;
      }

      if (aData && !("isDate" in aData)) {
        this.isDate = !("hour" in aData);
      } else if (aData && ("isDate" in aData)) {
        this.isDate = aData.isDate;
      }

      if (aData && "timezone" in aData) {
        var zone = ICAL.TimezoneService.get(
          aData.timezone
        );

        this.zone = zone || ICAL.Timezone.localTimezone;
      }

      if (aData && "zone" in aData) {
        this.zone = aData.zone;
      }

      if (!this.zone) {
        this.zone = ICAL.Timezone.localTimezone;
      }

      this._cachedUnixTime = null;
      return this;
    },

    /**
     * Calculate the day of week.
     * @return {ICAL.Time.weekDay}
     */
    dayOfWeek: function icaltime_dayOfWeek() {
      var dowCacheKey = (this.year << 9) + (this.month << 5) + this.day;
      if (dowCacheKey in ICAL.Time._dowCache) {
        return ICAL.Time._dowCache[dowCacheKey];
      }

      // Using Zeller's algorithm
      var q = this.day;
      var m = this.month + (this.month < 3 ? 12 : 0);
      var Y = this.year - (this.month < 3 ? 1 : 0);

      var h = (q + Y + ICAL.helpers.trunc(((m + 1) * 26) / 10) + ICAL.helpers.trunc(Y / 4));
      /* istanbul ignore else */
      if (true /* gregorian */) {
        h += ICAL.helpers.trunc(Y / 100) * 6 + ICAL.helpers.trunc(Y / 400);
      } else {
        h += 5;
      }

      // Normalize to 1 = sunday
      h = ((h + 6) % 7) + 1;
      ICAL.Time._dowCache[dowCacheKey] = h;
      return h;
    },

    /**
     * Calculate the day of year.
     * @return {Number}
     */
    dayOfYear: function dayOfYear() {
      var is_leap = (ICAL.Time.isLeapYear(this.year) ? 1 : 0);
      var diypm = ICAL.Time.daysInYearPassedMonth;
      return diypm[is_leap][this.month - 1] + this.day;
    },

    /**
     * Returns a copy of the current date/time, rewound to the start of the
     * week. The resulting ICAL.Time instance is of icaltype date, even if this
     * is a date-time.
     *
     * @param {ICAL.Time.weekDay=} aWeekStart
     *        The week start weekday, defaults to SUNDAY
     * @return {ICAL.Time}      The start of the week (cloned)
     */
    startOfWeek: function startOfWeek(aWeekStart) {
      var firstDow = aWeekStart || ICAL.Time.SUNDAY;
      var result = this.clone();
      result.day -= ((this.dayOfWeek() + 7 - firstDow) % 7);
      result.isDate = true;
      result.hour = 0;
      result.minute = 0;
      result.second = 0;
      return result;
    },

    /**
     * Returns a copy of the current date/time, shifted to the end of the week.
     * The resulting ICAL.Time instance is of icaltype date, even if this is a
     * date-time.
     *
     * @param {ICAL.Time.weekDay=} aWeekStart
     *        The week start weekday, defaults to SUNDAY
     * @return {ICAL.Time}      The end of the week (cloned)
     */
    endOfWeek: function endOfWeek(aWeekStart) {
      var firstDow = aWeekStart || ICAL.Time.SUNDAY;
      var result = this.clone();
      result.day += (7 - this.dayOfWeek() + firstDow - ICAL.Time.SUNDAY) % 7;
      result.isDate = true;
      result.hour = 0;
      result.minute = 0;
      result.second = 0;
      return result;
    },

    /**
     * Returns a copy of the current date/time, rewound to the start of the
     * month. The resulting ICAL.Time instance is of icaltype date, even if
     * this is a date-time.
     *
     * @return {ICAL.Time}      The start of the month (cloned)
     */
    startOfMonth: function startOfMonth() {
      var result = this.clone();
      result.day = 1;
      result.isDate = true;
      result.hour = 0;
      result.minute = 0;
      result.second = 0;
      return result;
    },

    /**
     * Returns a copy of the current date/time, shifted to the end of the
     * month.  The resulting ICAL.Time instance is of icaltype date, even if
     * this is a date-time.
     *
     * @return {ICAL.Time}      The end of the month (cloned)
     */
    endOfMonth: function endOfMonth() {
      var result = this.clone();
      result.day = ICAL.Time.daysInMonth(result.month, result.year);
      result.isDate = true;
      result.hour = 0;
      result.minute = 0;
      result.second = 0;
      return result;
    },

    /**
     * Returns a copy of the current date/time, rewound to the start of the
     * year. The resulting ICAL.Time instance is of icaltype date, even if
     * this is a date-time.
     *
     * @return {ICAL.Time}      The start of the year (cloned)
     */
    startOfYear: function startOfYear() {
      var result = this.clone();
      result.day = 1;
      result.month = 1;
      result.isDate = true;
      result.hour = 0;
      result.minute = 0;
      result.second = 0;
      return result;
    },

    /**
     * Returns a copy of the current date/time, shifted to the end of the
     * year.  The resulting ICAL.Time instance is of icaltype date, even if
     * this is a date-time.
     *
     * @return {ICAL.Time}      The end of the year (cloned)
     */
    endOfYear: function endOfYear() {
      var result = this.clone();
      result.day = 31;
      result.month = 12;
      result.isDate = true;
      result.hour = 0;
      result.minute = 0;
      result.second = 0;
      return result;
    },

    /**
     * First calculates the start of the week, then returns the day of year for
     * this date. If the day falls into the previous year, the day is zero or negative.
     *
     * @param {ICAL.Time.weekDay=} aFirstDayOfWeek
     *        The week start weekday, defaults to SUNDAY
     * @return {Number}     The calculated day of year
     */
    startDoyWeek: function startDoyWeek(aFirstDayOfWeek) {
      var firstDow = aFirstDayOfWeek || ICAL.Time.SUNDAY;
      var delta = this.dayOfWeek() - firstDow;
      if (delta < 0) delta += 7;
      return this.dayOfYear() - delta;
    },

    /**
     * Get the dominical letter for the current year. Letters range from A - G
     * for common years, and AG to GF for leap years.
     *
     * @param {Number} yr           The year to retrieve the letter for
     * @return {String}             The dominical letter.
     */
    getDominicalLetter: function() {
      return ICAL.Time.getDominicalLetter(this.year);
    },

    /**
     * Finds the nthWeekDay relative to the current month (not day).  The
     * returned value is a day relative the month that this month belongs to so
     * 1 would indicate the first of the month and 40 would indicate a day in
     * the following month.
     *
     * @param {Number} aDayOfWeek   Day of the week see the day name constants
     * @param {Number} aPos         Nth occurrence of a given week day values
     *        of 1 and 0 both indicate the first weekday of that type. aPos may
     *        be either positive or negative
     *
     * @return {Number} numeric value indicating a day relative
     *                   to the current month of this time object
     */
    nthWeekDay: function icaltime_nthWeekDay(aDayOfWeek, aPos) {
      var daysInMonth = ICAL.Time.daysInMonth(this.month, this.year);
      var weekday;
      var pos = aPos;

      var start = 0;

      var otherDay = this.clone();

      if (pos >= 0) {
        otherDay.day = 1;

        // because 0 means no position has been given
        // 1 and 0 indicate the same day.
        if (pos != 0) {
          // remove the extra numeric value
          pos--;
        }

        // set current start offset to current day.
        start = otherDay.day;

        // find the current day of week
        var startDow = otherDay.dayOfWeek();

        // calculate the difference between current
        // day of the week and desired day of the week
        var offset = aDayOfWeek - startDow;


        // if the offset goes into the past
        // week we add 7 so its goes into the next
        // week. We only want to go forward in time here.
        if (offset < 0)
          // this is really important otherwise we would
          // end up with dates from in the past.
          offset += 7;

        // add offset to start so start is the same
        // day of the week as the desired day of week.
        start += offset;

        // because we are going to add (and multiply)
        // the numeric value of the day we subtract it
        // from the start position so not to add it twice.
        start -= aDayOfWeek;

        // set week day
        weekday = aDayOfWeek;
      } else {

        // then we set it to the last day in the current month
        otherDay.day = daysInMonth;

        // find the ends weekday
        var endDow = otherDay.dayOfWeek();

        pos++;

        weekday = (endDow - aDayOfWeek);

        if (weekday < 0) {
          weekday += 7;
        }

        weekday = daysInMonth - weekday;
      }

      weekday += pos * 7;

      return start + weekday;
    },

    /**
     * Checks if current time is the nth weekday, relative to the current
     * month.  Will always return false when rule resolves outside of current
     * month.
     *
     * @param {ICAL.Time.weekDay} aDayOfWeek       Day of week to check
     * @param {Number} aPos                        Relative position
     * @return {Boolean}                           True, if its the nth weekday
     */
    isNthWeekDay: function(aDayOfWeek, aPos) {
      var dow = this.dayOfWeek();

      if (aPos === 0 && dow === aDayOfWeek) {
        return true;
      }

      // get pos
      var day = this.nthWeekDay(aDayOfWeek, aPos);

      if (day === this.day) {
        return true;
      }

      return false;
    },

    /**
     * Calculates the ISO 8601 week number. The first week of a year is the
     * week that contains the first Thursday. The year can have 53 weeks, if
     * January 1st is a Friday.
     *
     * Note there are regions where the first week of the year is the one that
     * starts on January 1st, which may offset the week number. Also, if a
     * different week start is specified, this will also affect the week
     * number.
     *
     * @see ICAL.Time.weekOneStarts
     * @param {ICAL.Time.weekDay} aWeekStart        The weekday the week starts with
     * @return {Number}                             The ISO week number
     */
    weekNumber: function weekNumber(aWeekStart) {
      var wnCacheKey = (this.year << 12) + (this.month << 8) + (this.day << 3) + aWeekStart;
      if (wnCacheKey in ICAL.Time._wnCache) {
        return ICAL.Time._wnCache[wnCacheKey];
      }
      // This function courtesty of Julian Bucknall, published under the MIT license
      // http://www.boyet.com/articles/publishedarticles/calculatingtheisoweeknumb.html
      // plus some fixes to be able to use different week starts.
      var week1;

      var dt = this.clone();
      dt.isDate = true;
      var isoyear = this.year;

      if (dt.month == 12 && dt.day > 25) {
        week1 = ICAL.Time.weekOneStarts(isoyear + 1, aWeekStart);
        if (dt.compare(week1) < 0) {
          week1 = ICAL.Time.weekOneStarts(isoyear, aWeekStart);
        } else {
          isoyear++;
        }
      } else {
        week1 = ICAL.Time.weekOneStarts(isoyear, aWeekStart);
        if (dt.compare(week1) < 0) {
          week1 = ICAL.Time.weekOneStarts(--isoyear, aWeekStart);
        }
      }

      var daysBetween = (dt.subtractDate(week1).toSeconds() / 86400);
      var answer = ICAL.helpers.trunc(daysBetween / 7) + 1;
      ICAL.Time._wnCache[wnCacheKey] = answer;
      return answer;
    },

    /**
     * Adds the duration to the current time. The instance is modified in
     * place.
     *
     * @param {ICAL.Duration} aDuration         The duration to add
     */
    addDuration: function icaltime_add(aDuration) {
      var mult = (aDuration.isNegative ? -1 : 1);

      // because of the duration optimizations it is much
      // more efficient to grab all the values up front
      // then set them directly (which will avoid a normalization call).
      // So we don't actually normalize until we need it.
      var second = this.second;
      var minute = this.minute;
      var hour = this.hour;
      var day = this.day;

      second += mult * aDuration.seconds;
      minute += mult * aDuration.minutes;
      hour += mult * aDuration.hours;
      day += mult * aDuration.days;
      day += mult * 7 * aDuration.weeks;

      this.second = second;
      this.minute = minute;
      this.hour = hour;
      this.day = day;

      this._cachedUnixTime = null;
    },

    /**
     * Subtract the date details (_excluding_ timezone).  Useful for finding
     * the relative difference between two time objects excluding their
     * timezone differences.
     *
     * @param {ICAL.Time} aDate     The date to substract
     * @return {ICAL.Duration}      The difference as a duration
     */
    subtractDate: function icaltime_subtract(aDate) {
      var unixTime = this.toUnixTime() + this.utcOffset();
      var other = aDate.toUnixTime() + aDate.utcOffset();
      return ICAL.Duration.fromSeconds(unixTime - other);
    },

    /**
     * Subtract the date details, taking timezones into account.
     *
     * @param {ICAL.Time} aDate  The date to subtract
     * @return {ICAL.Duration}  The difference in duration
     */
    subtractDateTz: function icaltime_subtract_abs(aDate) {
      var unixTime = this.toUnixTime();
      var other = aDate.toUnixTime();
      return ICAL.Duration.fromSeconds(unixTime - other);
    },

    /**
     * Compares the ICAL.Time instance with another one.
     *
     * @param {ICAL.Duration} aOther        The instance to compare with
     * @return {Number}                     -1, 0 or 1 for less/equal/greater
     */
    compare: function icaltime_compare(other) {
      var a = this.toUnixTime();
      var b = other.toUnixTime();

      if (a > b) return 1;
      if (b > a) return -1;
      return 0;
    },

    /**
     * Compares only the date part of this instance with another one.
     *
     * @param {ICAL.Duration} other         The instance to compare with
     * @param {ICAL.Timezone} tz            The timezone to compare in
     * @return {Number}                     -1, 0 or 1 for less/equal/greater
     */
    compareDateOnlyTz: function icaltime_compareDateOnlyTz(other, tz) {
      function cmp(attr) {
        return ICAL.Time._cmp_attr(a, b, attr);
      }
      var a = this.convertToZone(tz);
      var b = other.convertToZone(tz);
      var rc = 0;

      if ((rc = cmp("year")) != 0) return rc;
      if ((rc = cmp("month")) != 0) return rc;
      if ((rc = cmp("day")) != 0) return rc;

      return rc;
    },

    /**
     * Convert the instance into another timzone. The returned ICAL.Time
     * instance is always a copy.
     *
     * @param {ICAL.Timezone} zone      The zone to convert to
     * @return {ICAL.Time}              The copy, converted to the zone
     */
    convertToZone: function convertToZone(zone) {
      var copy = this.clone();
      var zone_equals = (this.zone.tzid == zone.tzid);

      if (!this.isDate && !zone_equals) {
        ICAL.Timezone.convert_time(copy, this.zone, zone);
      }

      copy.zone = zone;
      return copy;
    },

    /**
     * Calculates the UTC offset of the current date/time in the timezone it is
     * in.
     *
     * @return {Number}     UTC offset in seconds
     */
    utcOffset: function utc_offset() {
      if (this.zone == ICAL.Timezone.localTimezone ||
          this.zone == ICAL.Timezone.utcTimezone) {
        return 0;
      } else {
        return this.zone.utcOffset(this);
      }
    },

    /**
     * Returns an RFC 5545 compliant ical representation of this object.
     *
     * @return {String} ical date/date-time
     */
    toICALString: function() {
      var string = this.toString();

      if (string.length > 10) {
        return ICAL.design.icalendar.value['date-time'].toICAL(string);
      } else {
        return ICAL.design.icalendar.value.date.toICAL(string);
      }
    },

    /**
     * The string representation of this date/time, in jCal form
     * (including : and - separators).
     * @return {String}
     */
    toString: function toString() {
      var result = this.year + '-' +
                   ICAL.helpers.pad2(this.month) + '-' +
                   ICAL.helpers.pad2(this.day);

      if (!this.isDate) {
          result += 'T' + ICAL.helpers.pad2(this.hour) + ':' +
                    ICAL.helpers.pad2(this.minute) + ':' +
                    ICAL.helpers.pad2(this.second);

        if (this.zone === ICAL.Timezone.utcTimezone) {
          result += 'Z';
        }
      }

      return result;
    },

    /**
     * Converts the current instance to a Javascript date
     * @return {Date}
     */
    toJSDate: function toJSDate() {
      if (this.zone == ICAL.Timezone.localTimezone) {
        if (this.isDate) {
          return new Date(this.year, this.month - 1, this.day);
        } else {
          return new Date(this.year, this.month - 1, this.day,
                          this.hour, this.minute, this.second, 0);
        }
      } else {
        return new Date(this.toUnixTime() * 1000);
      }
    },

    _normalize: function icaltime_normalize() {
      var isDate = this._time.isDate;
      if (this._time.isDate) {
        this._time.hour = 0;
        this._time.minute = 0;
        this._time.second = 0;
      }
      this.adjust(0, 0, 0, 0);

      return this;
    },

    /**
     * Adjust the date/time by the given offset
     *
     * @param {Number} aExtraDays       The extra amount of days
     * @param {Number} aExtraHours      The extra amount of hours
     * @param {Number} aExtraMinutes    The extra amount of minutes
     * @param {Number} aExtraSeconds    The extra amount of seconds
     * @param {Number=} aTime           The time to adjust, defaults to the
     *                                    current instance.
     */
    adjust: function icaltime_adjust(aExtraDays, aExtraHours,
                                     aExtraMinutes, aExtraSeconds, aTime) {

      var minutesOverflow, hoursOverflow,
          daysOverflow = 0, yearsOverflow = 0;

      var second, minute, hour, day;
      var daysInMonth;

      var time = aTime || this._time;

      if (!time.isDate) {
        second = time.second + aExtraSeconds;
        time.second = second % 60;
        minutesOverflow = ICAL.helpers.trunc(second / 60);
        if (time.second < 0) {
          time.second += 60;
          minutesOverflow--;
        }

        minute = time.minute + aExtraMinutes + minutesOverflow;
        time.minute = minute % 60;
        hoursOverflow = ICAL.helpers.trunc(minute / 60);
        if (time.minute < 0) {
          time.minute += 60;
          hoursOverflow--;
        }

        hour = time.hour + aExtraHours + hoursOverflow;

        time.hour = hour % 24;
        daysOverflow = ICAL.helpers.trunc(hour / 24);
        if (time.hour < 0) {
          time.hour += 24;
          daysOverflow--;
        }
      }


      // Adjust month and year first, because we need to know what month the day
      // is in before adjusting it.
      if (time.month > 12) {
        yearsOverflow = ICAL.helpers.trunc((time.month - 1) / 12);
      } else if (time.month < 1) {
        yearsOverflow = ICAL.helpers.trunc(time.month / 12) - 1;
      }

      time.year += yearsOverflow;
      time.month -= 12 * yearsOverflow;

      // Now take care of the days (and adjust month if needed)
      day = time.day + aExtraDays + daysOverflow;

      if (day > 0) {
        for (;;) {
          daysInMonth = ICAL.Time.daysInMonth(time.month, time.year);
          if (day <= daysInMonth) {
            break;
          }

          time.month++;
          if (time.month > 12) {
            time.year++;
            time.month = 1;
          }

          day -= daysInMonth;
        }
      } else {
        while (day <= 0) {
          if (time.month == 1) {
            time.year--;
            time.month = 12;
          } else {
            time.month--;
          }

          day += ICAL.Time.daysInMonth(time.month, time.year);
        }
      }

      time.day = day;

      this._cachedUnixTime = null;
      return this;
    },

    /**
     * Sets up the current instance from unix time, the number of seconds since
     * January 1st, 1970.
     *
     * @param {Number} seconds      The seconds to set up with
     */
    fromUnixTime: function fromUnixTime(seconds) {
      this.zone = ICAL.Timezone.utcTimezone;
      var epoch = ICAL.Time.epochTime.clone();
      epoch.adjust(0, 0, 0, seconds);

      this.year = epoch.year;
      this.month = epoch.month;
      this.day = epoch.day;
      this.hour = epoch.hour;
      this.minute = epoch.minute;
      this.second = Math.floor(epoch.second);

      this._cachedUnixTime = null;
    },

    /**
     * Converts the current instance to seconds since January 1st 1970.
     *
     * @return {Number}         Seconds since 1970
     */
    toUnixTime: function toUnixTime() {
      if (this._cachedUnixTime !== null) {
        return this._cachedUnixTime;
      }
      var offset = this.utcOffset();

      // we use the offset trick to ensure
      // that we are getting the actual UTC time
      var ms = Date.UTC(
        this.year,
        this.month - 1,
        this.day,
        this.hour,
        this.minute,
        this.second - offset
      );

      // seconds
      this._cachedUnixTime = ms / 1000;
      return this._cachedUnixTime;
    },

    /**
     * Converts time to into Object which can be serialized then re-created
     * using the constructor.
     *
     * @example
     * // toJSON will automatically be called
     * var json = JSON.stringify(mytime);
     *
     * var deserialized = JSON.parse(json);
     *
     * var time = new ICAL.Time(deserialized);
     *
     * @return {Object}
     */
    toJSON: function() {
      var copy = [
        'year',
        'month',
        'day',
        'hour',
        'minute',
        'second',
        'isDate'
      ];

      var result = Object.create(null);

      var i = 0;
      var len = copy.length;
      var prop;

      for (; i < len; i++) {
        prop = copy[i];
        result[prop] = this[prop];
      }

      if (this.zone) {
        result.timezone = this.zone.tzid;
      }

      return result;
    }

  };

  (function setupNormalizeAttributes() {
    // This needs to run before any instances are created!
    function defineAttr(attr) {
      Object.defineProperty(ICAL.Time.prototype, attr, {
        get: function getTimeAttr() {
          if (this._pendingNormalization) {
            this._normalize();
            this._pendingNormalization = false;
          }

          return this._time[attr];
        },
        set: function setTimeAttr(val) {
          // Check if isDate will be set and if was not set to normalize date.
          // This avoids losing days when seconds, minutes and hours are zeroed
          // what normalize will do when time is a date.
          if (attr === "isDate" && val && !this._time.isDate) {
            this.adjust(0, 0, 0, 0);
          }
          this._cachedUnixTime = null;
          this._pendingNormalization = true;
          this._time[attr] = val;

          return val;
        }
      });

    }

    /* istanbul ignore else */
    if ("defineProperty" in Object) {
      defineAttr("year");
      defineAttr("month");
      defineAttr("day");
      defineAttr("hour");
      defineAttr("minute");
      defineAttr("second");
      defineAttr("isDate");
    }
  })();

  /**
   * Returns the days in the given month
   *
   * @param {Number} month      The month to check
   * @param {Number} year       The year to check
   * @return {Number}           The number of days in the month
   */
  ICAL.Time.daysInMonth = function icaltime_daysInMonth(month, year) {
    var _daysInMonth = [0, 31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    var days = 30;

    if (month < 1 || month > 12) return days;

    days = _daysInMonth[month];

    if (month == 2) {
      days += ICAL.Time.isLeapYear(year);
    }

    return days;
  };

  /**
   * Checks if the year is a leap year
   *
   * @param {Number} year       The year to check
   * @return {Boolean}          True, if the year is a leap year
   */
  ICAL.Time.isLeapYear = function isLeapYear(year) {
    if (year <= 1752) {
      return ((year % 4) == 0);
    } else {
      return (((year % 4 == 0) && (year % 100 != 0)) || (year % 400 == 0));
    }
  };

  /**
   * Create a new ICAL.Time from the day of year and year. The date is returned
   * in floating timezone.
   *
   * @param {Number} aDayOfYear     The day of year
   * @param {Number} aYear          The year to create the instance in
   * @return {ICAL.Time}            The created instance with the calculated date
   */
  ICAL.Time.fromDayOfYear = function icaltime_fromDayOfYear(aDayOfYear, aYear) {
    var year = aYear;
    var doy = aDayOfYear;
    var tt = new ICAL.Time();
    tt.auto_normalize = false;
    var is_leap = (ICAL.Time.isLeapYear(year) ? 1 : 0);

    if (doy < 1) {
      year--;
      is_leap = (ICAL.Time.isLeapYear(year) ? 1 : 0);
      doy += ICAL.Time.daysInYearPassedMonth[is_leap][12];
      return ICAL.Time.fromDayOfYear(doy, year);
    } else if (doy > ICAL.Time.daysInYearPassedMonth[is_leap][12]) {
      is_leap = (ICAL.Time.isLeapYear(year) ? 1 : 0);
      doy -= ICAL.Time.daysInYearPassedMonth[is_leap][12];
      year++;
      return ICAL.Time.fromDayOfYear(doy, year);
    }

    tt.year = year;
    tt.isDate = true;

    for (var month = 11; month >= 0; month--) {
      if (doy > ICAL.Time.daysInYearPassedMonth[is_leap][month]) {
        tt.month = month + 1;
        tt.day = doy - ICAL.Time.daysInYearPassedMonth[is_leap][month];
        break;
      }
    }

    tt.auto_normalize = true;
    return tt;
  };

  /**
   * Returns a new ICAL.Time instance from a date string, e.g 2015-01-02.
   *
   * @deprecated                Use {@link ICAL.Time.fromDateString} instead
   * @param {String} str        The string to create from
   * @return {ICAL.Time}        The date/time instance
   */
  ICAL.Time.fromStringv2 = function fromString(str) {
    return new ICAL.Time({
      year: parseInt(str.substr(0, 4), 10),
      month: parseInt(str.substr(5, 2), 10),
      day: parseInt(str.substr(8, 2), 10),
      isDate: true
    });
  };

  /**
   * Returns a new ICAL.Time instance from a date string, e.g 2015-01-02.
   *
   * @param {String} aValue     The string to create from
   * @return {ICAL.Time}        The date/time instance
   */
  ICAL.Time.fromDateString = function(aValue) {
    // Dates should have no timezone.
    // Google likes to sometimes specify Z on dates
    // we specifically ignore that to avoid issues.

    // YYYY-MM-DD
    // 2012-10-10
    return new ICAL.Time({
      year: ICAL.helpers.strictParseInt(aValue.substr(0, 4)),
      month: ICAL.helpers.strictParseInt(aValue.substr(5, 2)),
      day: ICAL.helpers.strictParseInt(aValue.substr(8, 2)),
      isDate: true
    });
  };

  /**
   * Returns a new ICAL.Time instance from a date-time string, e.g
   * 2015-01-02T03:04:05. If a property is specified, the timezone is set up
   * from the property's TZID parameter.
   *
   * @param {String} aValue         The string to create from
   * @param {ICAL.Property=} prop   The property the date belongs to
   * @return {ICAL.Time}            The date/time instance
   */
  ICAL.Time.fromDateTimeString = function(aValue, prop) {
    if (aValue.length < 19) {
      throw new Error(
        'invalid date-time value: "' + aValue + '"'
      );
    }

    var zone;

    if (aValue[19] && aValue[19] === 'Z') {
      zone = 'Z';
    } else if (prop) {
      zone = prop.getParameter('tzid');
    }

    // 2012-10-10T10:10:10(Z)?
    var time = new ICAL.Time({
      year: ICAL.helpers.strictParseInt(aValue.substr(0, 4)),
      month: ICAL.helpers.strictParseInt(aValue.substr(5, 2)),
      day: ICAL.helpers.strictParseInt(aValue.substr(8, 2)),
      hour: ICAL.helpers.strictParseInt(aValue.substr(11, 2)),
      minute: ICAL.helpers.strictParseInt(aValue.substr(14, 2)),
      second: ICAL.helpers.strictParseInt(aValue.substr(17, 2)),
      timezone: zone
    });

    return time;
  };

  /**
   * Returns a new ICAL.Time instance from a date or date-time string,
   *
   * @param {String} aValue         The string to create from
   * @return {ICAL.Time}            The date/time instance
   */
  ICAL.Time.fromString = function fromString(aValue) {
    if (aValue.length > 10) {
      return ICAL.Time.fromDateTimeString(aValue);
    } else {
      return ICAL.Time.fromDateString(aValue);
    }
  };

  /**
   * Creates a new ICAL.Time instance from the given Javascript Date.
   *
   * @param {?Date} aDate     The Javascript Date to read, or null to reset
   * @param {Boolean} useUTC  If true, the UTC values of the date will be used
   */
  ICAL.Time.fromJSDate = function fromJSDate(aDate, useUTC) {
    var tt = new ICAL.Time();
    return tt.fromJSDate(aDate, useUTC);
  };

  /**
   * Creates a new ICAL.Time instance from the the passed data object.
   *
   * @param {Object} aData            Time initialization
   * @param {Number=} aData.year      The year for this date
   * @param {Number=} aData.month     The month for this date
   * @param {Number=} aData.day       The day for this date
   * @param {Number=} aData.hour      The hour for this date
   * @param {Number=} aData.minute    The minute for this date
   * @param {Number=} aData.second    The second for this date
   * @param {Boolean=} aData.isDate   If true, the instance represents a date
   *                                    (as opposed to a date-time)
   * @param {ICAL.Timezone=} aZone    Timezone this position occurs in
   */
  ICAL.Time.fromData = function fromData(aData, aZone) {
    var t = new ICAL.Time();
    return t.fromData(aData, aZone);
  };

  /**
   * Creates a new ICAL.Time instance from the current moment.
   * @return {ICAL.Time}
   */
  ICAL.Time.now = function icaltime_now() {
    return ICAL.Time.fromJSDate(new Date(), false);
  };

  /**
   * Returns the date on which ISO week number 1 starts.
   *
   * @see ICAL.Time#weekNumber
   * @param {Number} aYear                  The year to search in
   * @param {ICAL.Time.weekDay=} aWeekStart The week start weekday, used for calculation.
   * @return {ICAL.Time}                    The date on which week number 1 starts
   */
  ICAL.Time.weekOneStarts = function weekOneStarts(aYear, aWeekStart) {
    var t = ICAL.Time.fromData({
      year: aYear,
      month: 1,
      day: 1,
      isDate: true
    });

    var dow = t.dayOfWeek();
    var wkst = aWeekStart || ICAL.Time.DEFAULT_WEEK_START;
    if (dow > ICAL.Time.THURSDAY) {
      t.day += 7;
    }
    if (wkst > ICAL.Time.THURSDAY) {
      t.day -= 7;
    }

    t.day -= dow - wkst;

    return t;
  };

  /**
   * Get the dominical letter for the given year. Letters range from A - G for
   * common years, and AG to GF for leap years.
   *
   * @param {Number} yr           The year to retrieve the letter for
   * @return {String}             The dominical letter.
   */
  ICAL.Time.getDominicalLetter = function(yr) {
    var LTRS = "GFEDCBA";
    var dom = (yr + (yr / 4 | 0) + (yr / 400 | 0) - (yr / 100 | 0) - 1) % 7;
    var isLeap = ICAL.Time.isLeapYear(yr);
    if (isLeap) {
      return LTRS[(dom + 6) % 7] + LTRS[dom];
    } else {
      return LTRS[dom];
    }
  };

  /**
   * January 1st, 1970 as an ICAL.Time.
   * @type {ICAL.Time}
   * @constant
   * @instance
   */
  ICAL.Time.epochTime = ICAL.Time.fromData({
    year: 1970,
    month: 1,
    day: 1,
    hour: 0,
    minute: 0,
    second: 0,
    isDate: false,
    timezone: "Z"
  });

  ICAL.Time._cmp_attr = function _cmp_attr(a, b, attr) {
    if (a[attr] > b[attr]) return 1;
    if (a[attr] < b[attr]) return -1;
    return 0;
  };

  /**
   * The days that have passed in the year after a given month. The array has
   * two members, one being an array of passed days for non-leap years, the
   * other analog for leap years.
   * @example
   * var isLeapYear = ICAL.Time.isLeapYear(year);
   * var passedDays = ICAL.Time.daysInYearPassedMonth[isLeapYear][month];
   * @type {Array.<Array.<Number>>}
   */
  ICAL.Time.daysInYearPassedMonth = [
    [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334, 365],
    [0, 31, 60, 91, 121, 152, 182, 213, 244, 274, 305, 335, 366]
  ];

  /**
   * The weekday, 1 = SUNDAY, 7 = SATURDAY. Access via
   * ICAL.Time.MONDAY, ICAL.Time.TUESDAY, ...
   *
   * @typedef {Number} weekDay
   * @memberof ICAL.Time
   */

  ICAL.Time.SUNDAY = 1;
  ICAL.Time.MONDAY = 2;
  ICAL.Time.TUESDAY = 3;
  ICAL.Time.WEDNESDAY = 4;
  ICAL.Time.THURSDAY = 5;
  ICAL.Time.FRIDAY = 6;
  ICAL.Time.SATURDAY = 7;

  /**
   * The default weekday for the WKST part.
   * @constant
   * @default ICAL.Time.MONDAY
   */
  ICAL.Time.DEFAULT_WEEK_START = ICAL.Time.MONDAY;
})();
/* This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/.
 * Portions Copyright (C) Philipp Kewisch, 2015 */



(function() {

  /**
   * Describes a vCard time, which has slight differences to the ICAL.Time.
   * Properties can be null if not specified, for example for dates with
   * reduced accuracy or truncation.
   *
   * Note that currently not all methods are correctly re-implemented for
   * VCardTime. For example, comparison will have undefined results when some
   * members are null.
   *
   * Also, normalization is not yet implemented for this class!
   *
   * @alias ICAL.VCardTime
   * @class
   * @extends {ICAL.Time}
   * @param {Object} data                           The data for the time instance
   * @param {Number=} data.year                     The year for this date
   * @param {Number=} data.month                    The month for this date
   * @param {Number=} data.day                      The day for this date
   * @param {Number=} data.hour                     The hour for this date
   * @param {Number=} data.minute                   The minute for this date
   * @param {Number=} data.second                   The second for this date
   * @param {ICAL.Timezone|ICAL.UtcOffset} zone     The timezone to use
   * @param {String} icaltype                       The type for this date/time object
   */
  ICAL.VCardTime = function(data, zone, icaltype) {
    this.wrappedJSObject = this;
    var time = this._time = Object.create(null);

    time.year = null;
    time.month = null;
    time.day = null;
    time.hour = null;
    time.minute = null;
    time.second = null;

    this.icaltype = icaltype || "date-and-or-time";

    this.fromData(data, zone);
  };
  ICAL.helpers.inherits(ICAL.Time, ICAL.VCardTime, /** @lends ICAL.VCardTime */ {

    /**
     * The class identifier.
     * @constant
     * @type {String}
     * @default "vcardtime"
     */
    icalclass: "vcardtime",

    /**
     * The type name, to be used in the jCal object.
     * @type {String}
     * @default "date-and-or-time"
     */
    icaltype: "date-and-or-time",

    /**
     * The timezone. This can either be floating, UTC, or an instance of
     * ICAL.UtcOffset.
     * @type {ICAL.Timezone|ICAL.UtcOFfset}
     */
    zone: null,

    /**
     * Returns a clone of the vcard date/time object.
     *
     * @return {ICAL.VCardTime}     The cloned object
     */
    clone: function() {
      return new ICAL.VCardTime(this._time, this.zone, this.icaltype);
    },

    _normalize: function() {
      return this;
    },

    /**
     * @inheritdoc
     */
    utcOffset: function() {
      if (this.zone instanceof ICAL.UtcOffset) {
        return this.zone.toSeconds();
      } else {
        return ICAL.Time.prototype.utcOffset.apply(this, arguments);
      }
    },

    /**
     * Returns an RFC 6350 compliant representation of this object.
     *
     * @return {String}         vcard date/time string
     */
    toICALString: function() {
      return ICAL.design.vcard.value[this.icaltype].toICAL(this.toString());
    },

    /**
     * The string representation of this date/time, in jCard form
     * (including : and - separators).
     * @return {String}
     */
    toString: function toString() {
      var p2 = ICAL.helpers.pad2;
      var y = this.year, m = this.month, d = this.day;
      var h = this.hour, mm = this.minute, s = this.second;

      var hasYear = y !== null, hasMonth = m !== null, hasDay = d !== null;
      var hasHour = h !== null, hasMinute = mm !== null, hasSecond = s !== null;

      var datepart = (hasYear ? p2(y) + (hasMonth || hasDay ? '-' : '') : (hasMonth || hasDay ? '--' : '')) +
                     (hasMonth ? p2(m) : '') +
                     (hasDay ? '-' + p2(d) : '');
      var timepart = (hasHour ? p2(h) : '-') + (hasHour && hasMinute ? ':' : '') +
                     (hasMinute ? p2(mm) : '') + (!hasHour && !hasMinute ? '-' : '') +
                     (hasMinute && hasSecond ? ':' : '') +
                     (hasSecond ? p2(s) : '');

      var zone;
      if (this.zone === ICAL.Timezone.utcTimezone) {
        zone = 'Z';
      } else if (this.zone instanceof ICAL.UtcOffset) {
        zone = this.zone.toString();
      } else if (this.zone === ICAL.Timezone.localTimezone) {
        zone = '';
      } else if (this.zone instanceof ICAL.Timezone) {
        var offset = ICAL.UtcOffset.fromSeconds(this.zone.utcOffset(this));
        zone = offset.toString();
      } else {
        zone = '';
      }

      switch (this.icaltype) {
        case "time":
          return timepart + zone;
        case "date-and-or-time":
        case "date-time":
          return datepart + (timepart == '--' ? '' : 'T' + timepart + zone);
        case "date":
          return datepart;
      }
      return null;
    }
  });

  /**
   * Returns a new ICAL.VCardTime instance from a date and/or time string.
   *
   * @param {String} aValue     The string to create from
   * @param {String} aIcalType  The type for this instance, e.g. date-and-or-time
   * @return {ICAL.VCardTime}   The date/time instance
   */
  ICAL.VCardTime.fromDateAndOrTimeString = function(aValue, aIcalType) {
    function part(v, s, e) {
      return v ? ICAL.helpers.strictParseInt(v.substr(s, e)) : null;
    }
    var parts = aValue.split('T');
    var dt = parts[0], tmz = parts[1];
    var splitzone = tmz ? ICAL.design.vcard.value.time._splitZone(tmz) : [];
    var zone = splitzone[0], tm = splitzone[1];

    var stoi = ICAL.helpers.strictParseInt;
    var dtlen = dt ? dt.length : 0;
    var tmlen = tm ? tm.length : 0;

    var hasDashDate = dt && dt[0] == '-' && dt[1] == '-';
    var hasDashTime = tm && tm[0] == '-';

    var o = {
      year: hasDashDate ? null : part(dt, 0, 4),
      month: hasDashDate && (dtlen == 4 || dtlen == 7) ? part(dt, 2, 2) : dtlen == 7 ? part(dt, 5, 2) : dtlen == 10 ? part(dt, 5, 2) : null,
      day: dtlen == 5 ? part(dt, 3, 2) : dtlen == 7 && hasDashDate ? part(dt, 5, 2) : dtlen == 10 ? part(dt, 8, 2) : null,

      hour: hasDashTime ? null : part(tm, 0, 2),
      minute: hasDashTime && tmlen == 3 ? part(tm, 1, 2) : tmlen > 4 ? hasDashTime ? part(tm, 1, 2) : part(tm, 3, 2) : null,
      second: tmlen == 4 ? part(tm, 2, 2) : tmlen == 6 ? part(tm, 4, 2) : tmlen == 8 ? part(tm, 6, 2) : null
    };

    if (zone == 'Z') {
      zone = ICAL.Timezone.utcTimezone;
    } else if (zone && zone[3] == ':') {
      zone = ICAL.UtcOffset.fromString(zone);
    } else {
      zone = null;
    }

    return new ICAL.VCardTime(o, zone, aIcalType);
  };
})();
/* This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/.
 * Portions Copyright (C) Philipp Kewisch, 2011-2015 */



(function() {
  var DOW_MAP = {
    SU: ICAL.Time.SUNDAY,
    MO: ICAL.Time.MONDAY,
    TU: ICAL.Time.TUESDAY,
    WE: ICAL.Time.WEDNESDAY,
    TH: ICAL.Time.THURSDAY,
    FR: ICAL.Time.FRIDAY,
    SA: ICAL.Time.SATURDAY
  };

  var REVERSE_DOW_MAP = {};
  for (var key in DOW_MAP) {
    /* istanbul ignore else */
    if (DOW_MAP.hasOwnProperty(key)) {
      REVERSE_DOW_MAP[DOW_MAP[key]] = key;
    }
  }

  var COPY_PARTS = ["BYSECOND", "BYMINUTE", "BYHOUR", "BYDAY",
                    "BYMONTHDAY", "BYYEARDAY", "BYWEEKNO",
                    "BYMONTH", "BYSETPOS"];

  /**
   * @classdesc
   * This class represents the "recur" value type, with various calculation
   * and manipulation methods.
   *
   * @class
   * @alias ICAL.Recur
   * @param {Object} data                               An object with members of the recurrence
   * @param {ICAL.Recur.frequencyValues=} data.freq     The frequency value
   * @param {Number=} data.interval                     The INTERVAL value
   * @param {ICAL.Time.weekDay=} data.wkst              The week start value
   * @param {ICAL.Time=} data.until                     The end of the recurrence set
   * @param {Number=} data.count                        The number of occurrences
   * @param {Array.<Number>=} data.bysecond             The seconds for the BYSECOND part
   * @param {Array.<Number>=} data.byminute             The minutes for the BYMINUTE part
   * @param {Array.<Number>=} data.byhour               The hours for the BYHOUR part
   * @param {Array.<String>=} data.byday                The BYDAY values
   * @param {Array.<Number>=} data.bymonthday           The days for the BYMONTHDAY part
   * @param {Array.<Number>=} data.byyearday            The days for the BYYEARDAY part
   * @param {Array.<Number>=} data.byweekno             The weeks for the BYWEEKNO part
   * @param {Array.<Number>=} data.bymonth              The month for the BYMONTH part
   * @param {Array.<Number>=} data.bysetpos             The positionals for the BYSETPOS part
   */
  ICAL.Recur = function icalrecur(data) {
    this.wrappedJSObject = this;
    this.parts = {};

    if (data && typeof(data) === 'object') {
      this.fromData(data);
    }
  };

  ICAL.Recur.prototype = {
    /**
     * An object holding the BY-parts of the recurrence rule
     * @type {Object}
     */
    parts: null,

    /**
     * The interval value for the recurrence rule.
     * @type {Number}
     */
    interval: 1,

    /**
     * The week start day
     *
     * @type {ICAL.Time.weekDay}
     * @default ICAL.Time.MONDAY
     */
    wkst: ICAL.Time.MONDAY,

    /**
     * The end of the recurrence
     * @type {?ICAL.Time}
     */
    until: null,

    /**
     * The maximum number of occurrences
     * @type {?Number}
     */
    count: null,

    /**
     * The frequency value.
     * @type {ICAL.Recur.frequencyValues}
     */
    freq: null,

    /**
     * The class identifier.
     * @constant
     * @type {String}
     * @default "icalrecur"
     */
    icalclass: "icalrecur",

    /**
     * The type name, to be used in the jCal object.
     * @constant
     * @type {String}
     * @default "recur"
     */
    icaltype: "recur",

    /**
     * Create a new iterator for this recurrence rule. The passed start date
     * must be the start date of the event, not the start of the range to
     * search in.
     *
     * @example
     * var recur = comp.getFirstPropertyValue('rrule');
     * var dtstart = comp.getFirstPropertyValue('dtstart');
     * var iter = recur.iterator(dtstart);
     * for (var next = iter.next(); next; next = iter.next()) {
     *   if (next.compare(rangeStart) < 0) {
     *     continue;
     *   }
     *   console.log(next.toString());
     * }
     *
     * @param {ICAL.Time} aStart        The item's start date
     * @return {ICAL.RecurIterator}     The recurrence iterator
     */
    iterator: function(aStart) {
      return new ICAL.RecurIterator({
        rule: this,
        dtstart: aStart
      });
    },

    /**
     * Returns a clone of the recurrence object.
     *
     * @return {ICAL.Recur}      The cloned object
     */
    clone: function clone() {
      return new ICAL.Recur(this.toJSON());
    },

    /**
     * Checks if the current rule is finite, i.e. has a count or until part.
     *
     * @return {Boolean}        True, if the rule is finite
     */
    isFinite: function isfinite() {
      return !!(this.count || this.until);
    },

    /**
     * Checks if the current rule has a count part, and not limited by an until
     * part.
     *
     * @return {Boolean}        True, if the rule is by count
     */
    isByCount: function isbycount() {
      return !!(this.count && !this.until);
    },

    /**
     * Adds a component (part) to the recurrence rule. This is not a component
     * in the sense of {@link ICAL.Component}, but a part of the recurrence
     * rule, i.e. BYMONTH.
     *
     * @param {String} aType            The name of the component part
     * @param {Array|String} aValue     The component value
     */
    addComponent: function addPart(aType, aValue) {
      var ucname = aType.toUpperCase();
      if (ucname in this.parts) {
        this.parts[ucname].push(aValue);
      } else {
        this.parts[ucname] = [aValue];
      }
    },

    /**
     * Sets the component value for the given by-part.
     *
     * @param {String} aType        The component part name
     * @param {Array} aValues       The component values
     */
    setComponent: function setComponent(aType, aValues) {
      this.parts[aType.toUpperCase()] = aValues.slice();
    },

    /**
     * Gets (a copy) of the requested component value.
     *
     * @param {String} aType        The component part name
     * @return {Array}              The component part value
     */
    getComponent: function getComponent(aType) {
      var ucname = aType.toUpperCase();
      return (ucname in this.parts ? this.parts[ucname].slice() : []);
    },

    /**
     * Retrieves the next occurrence after the given recurrence id. See the
     * guide on {@tutorial terminology} for more details.
     *
     * NOTE: Currently, this method iterates all occurrences from the start
     * date. It should not be called in a loop for performance reasons. If you
     * would like to get more than one occurrence, you can iterate the
     * occurrences manually, see the example on the
     * {@link ICAL.Recur#iterator iterator} method.
     *
     * @param {ICAL.Time} aStartTime        The start of the event series
     * @param {ICAL.Time} aRecurrenceId     The date of the last occurrence
     * @return {ICAL.Time}                  The next occurrence after
     */
    getNextOccurrence: function getNextOccurrence(aStartTime, aRecurrenceId) {
      var iter = this.iterator(aStartTime);
      var next, cdt;

      do {
        next = iter.next();
      } while (next && next.compare(aRecurrenceId) <= 0);

      if (next && aRecurrenceId.zone) {
        next.zone = aRecurrenceId.zone;
      }

      return next;
    },

    /**
     * Sets up the current instance using members from the passed data object.
     *
     * @param {Object} data                               An object with members of the recurrence
     * @param {ICAL.Recur.frequencyValues=} data.freq     The frequency value
     * @param {Number=} data.interval                     The INTERVAL value
     * @param {ICAL.Time.weekDay=} data.wkst              The week start value
     * @param {ICAL.Time=} data.until                     The end of the recurrence set
     * @param {Number=} data.count                        The number of occurrences
     * @param {Array.<Number>=} data.bysecond             The seconds for the BYSECOND part
     * @param {Array.<Number>=} data.byminute             The minutes for the BYMINUTE part
     * @param {Array.<Number>=} data.byhour               The hours for the BYHOUR part
     * @param {Array.<String>=} data.byday                The BYDAY values
     * @param {Array.<Number>=} data.bymonthday           The days for the BYMONTHDAY part
     * @param {Array.<Number>=} data.byyearday            The days for the BYYEARDAY part
     * @param {Array.<Number>=} data.byweekno             The weeks for the BYWEEKNO part
     * @param {Array.<Number>=} data.bymonth              The month for the BYMONTH part
     * @param {Array.<Number>=} data.bysetpos             The positionals for the BYSETPOS part
     */
    fromData: function(data) {
      for (var key in data) {
        var uckey = key.toUpperCase();

        if (uckey in partDesign) {
          if (Array.isArray(data[key])) {
            this.parts[uckey] = data[key];
          } else {
            this.parts[uckey] = [data[key]];
          }
        } else {
          this[key] = data[key];
        }
      }

      if (this.interval && typeof this.interval != "number") {
        optionDesign.INTERVAL(this.interval, this);
      }

      if (this.wkst && typeof this.wkst != "number") {
        this.wkst = ICAL.Recur.icalDayToNumericDay(this.wkst);
      }

      if (this.until && !(this.until instanceof ICAL.Time)) {
        this.until = ICAL.Time.fromString(this.until);
      }
    },

    /**
     * The jCal representation of this recurrence type.
     * @return {Object}
     */
    toJSON: function() {
      var res = Object.create(null);
      res.freq = this.freq;

      if (this.count) {
        res.count = this.count;
      }

      if (this.interval > 1) {
        res.interval = this.interval;
      }

      for (var k in this.parts) {
        /* istanbul ignore if */
        if (!this.parts.hasOwnProperty(k)) {
          continue;
        }
        var kparts = this.parts[k];
        if (Array.isArray(kparts) && kparts.length == 1) {
          res[k.toLowerCase()] = kparts[0];
        } else {
          res[k.toLowerCase()] = ICAL.helpers.clone(this.parts[k]);
        }
      }

      if (this.until) {
        res.until = this.until.toString();
      }
      if ('wkst' in this && this.wkst !== ICAL.Time.DEFAULT_WEEK_START) {
        res.wkst = ICAL.Recur.numericDayToIcalDay(this.wkst);
      }
      return res;
    },

    /**
     * The string representation of this recurrence rule.
     * @return {String}
     */
    toString: function icalrecur_toString() {
      // TODO retain order
      var str = "FREQ=" + this.freq;
      if (this.count) {
        str += ";COUNT=" + this.count;
      }
      if (this.interval > 1) {
        str += ";INTERVAL=" + this.interval;
      }
      for (var k in this.parts) {
        /* istanbul ignore else */
        if (this.parts.hasOwnProperty(k)) {
          str += ";" + k + "=" + this.parts[k];
        }
      }
      if (this.until) {
        str += ';UNTIL=' + this.until.toICALString();
      }
      if ('wkst' in this && this.wkst !== ICAL.Time.DEFAULT_WEEK_START) {
        str += ';WKST=' + ICAL.Recur.numericDayToIcalDay(this.wkst);
      }
      return str;
    }
  };

  function parseNumericValue(type, min, max, value) {
    var result = value;

    if (value[0] === '+') {
      result = value.substr(1);
    }

    result = ICAL.helpers.strictParseInt(result);

    if (min !== undefined && value < min) {
      throw new Error(
        type + ': invalid value "' + value + '" must be > ' + min
      );
    }

    if (max !== undefined && value > max) {
      throw new Error(
        type + ': invalid value "' + value + '" must be < ' + min
      );
    }

    return result;
  }

  /**
   * Convert an ical representation of a day (SU, MO, etc..)
   * into a numeric value of that day.
   *
   * @param {String} string     The iCalendar day name
   * @return {Number}           Numeric value of given day
   */
  ICAL.Recur.icalDayToNumericDay = function toNumericDay(string) {
    //XXX: this is here so we can deal
    //     with possibly invalid string values.

    return DOW_MAP[string];
  };

  /**
   * Convert a numeric day value into its ical representation (SU, MO, etc..)
   *
   * @param {Number} num        Numeric value of given day
   * @return {String}           The ICAL day value, e.g SU,MO,...
   */
  ICAL.Recur.numericDayToIcalDay = function toIcalDay(num) {
    //XXX: this is here so we can deal with possibly invalid number values.
    //     Also, this allows consistent mapping between day numbers and day
    //     names for external users.
    return REVERSE_DOW_MAP[num];
  };

  var VALID_DAY_NAMES = /^(SU|MO|TU|WE|TH|FR|SA)$/;
  var VALID_BYDAY_PART = /^([+-])?(5[0-3]|[1-4][0-9]|[1-9])?(SU|MO|TU|WE|TH|FR|SA)$/;

  /**
   * Possible frequency values for the FREQ part
   * (YEARLY, MONTHLY, WEEKLY, DAILY, HOURLY, MINUTELY, SECONDLY)
   *
   * @typedef {String} frequencyValues
   * @memberof ICAL.Recur
   */

  var ALLOWED_FREQ = ['SECONDLY', 'MINUTELY', 'HOURLY',
                      'DAILY', 'WEEKLY', 'MONTHLY', 'YEARLY'];

  var optionDesign = {
    FREQ: function(value, dict, fmtIcal) {
      // yes this is actually equal or faster then regex.
      // upside here is we can enumerate the valid values.
      if (ALLOWED_FREQ.indexOf(value) !== -1) {
        dict.freq = value;
      } else {
        throw new Error(
          'invalid frequency "' + value + '" expected: "' +
          ALLOWED_FREQ.join(', ') + '"'
        );
      }
    },

    COUNT: function(value, dict, fmtIcal) {
      dict.count = ICAL.helpers.strictParseInt(value);
    },

    INTERVAL: function(value, dict, fmtIcal) {
      dict.interval = ICAL.helpers.strictParseInt(value);
      if (dict.interval < 1) {
        // 0 or negative values are not allowed, some engines seem to generate
        // it though. Assume 1 instead.
        dict.interval = 1;
      }
    },

    UNTIL: function(value, dict, fmtIcal) {
      if (value.length > 10) {
        dict.until = ICAL.design.icalendar.value['date-time'].fromICAL(value);
      } else {
        dict.until = ICAL.design.icalendar.value.date.fromICAL(value);
      }
      if (!fmtIcal) {
        dict.until = ICAL.Time.fromString(dict.until);
      }
    },

    WKST: function(value, dict, fmtIcal) {
      if (VALID_DAY_NAMES.test(value)) {
        dict.wkst = ICAL.Recur.icalDayToNumericDay(value);
      } else {
        throw new Error('invalid WKST value "' + value + '"');
      }
    }
  };

  var partDesign = {
    BYSECOND: parseNumericValue.bind(this, 'BYSECOND', 0, 60),
    BYMINUTE: parseNumericValue.bind(this, 'BYMINUTE', 0, 59),
    BYHOUR: parseNumericValue.bind(this, 'BYHOUR', 0, 23),
    BYDAY: function(value) {
      if (VALID_BYDAY_PART.test(value)) {
        return value;
      } else {
        throw new Error('invalid BYDAY value "' + value + '"');
      }
    },
    BYMONTHDAY: parseNumericValue.bind(this, 'BYMONTHDAY', -31, 31),
    BYYEARDAY: parseNumericValue.bind(this, 'BYYEARDAY', -366, 366),
    BYWEEKNO: parseNumericValue.bind(this, 'BYWEEKNO', -53, 53),
    BYMONTH: parseNumericValue.bind(this, 'BYMONTH', 0, 12),
    BYSETPOS: parseNumericValue.bind(this, 'BYSETPOS', -366, 366)
  };


  /**
   * Creates a new {@link ICAL.Recur} instance from the passed string.
   *
   * @param {String} string         The string to parse
   * @return {ICAL.Recur}           The created recurrence instance
   */
  ICAL.Recur.fromString = function(string) {
    var data = ICAL.Recur._stringToData(string, false);
    return new ICAL.Recur(data);
  };

  /**
   * Creates a new {@link ICAL.Recur} instance using members from the passed
   * data object.
   *
   * @param {Object} aData                              An object with members of the recurrence
   * @param {ICAL.Recur.frequencyValues=} aData.freq    The frequency value
   * @param {Number=} aData.interval                    The INTERVAL value
   * @param {ICAL.Time.weekDay=} aData.wkst             The week start value
   * @param {ICAL.Time=} aData.until                    The end of the recurrence set
   * @param {Number=} aData.count                       The number of occurrences
   * @param {Array.<Number>=} aData.bysecond            The seconds for the BYSECOND part
   * @param {Array.<Number>=} aData.byminute            The minutes for the BYMINUTE part
   * @param {Array.<Number>=} aData.byhour              The hours for the BYHOUR part
   * @param {Array.<String>=} aData.byday               The BYDAY values
   * @param {Array.<Number>=} aData.bymonthday          The days for the BYMONTHDAY part
   * @param {Array.<Number>=} aData.byyearday           The days for the BYYEARDAY part
   * @param {Array.<Number>=} aData.byweekno            The weeks for the BYWEEKNO part
   * @param {Array.<Number>=} aData.bymonth             The month for the BYMONTH part
   * @param {Array.<Number>=} aData.bysetpos            The positionals for the BYSETPOS part
   */
  ICAL.Recur.fromData = function(aData) {
    return new ICAL.Recur(aData);
  };

  /**
   * Converts a recurrence string to a data object, suitable for the fromData
   * method.
   *
   * @param {String} string     The string to parse
   * @param {Boolean} fmtIcal   If true, the string is considered to be an
   *                              iCalendar string
   * @return {ICAL.Recur}       The recurrence instance
   */
  ICAL.Recur._stringToData = function(string, fmtIcal) {
    var dict = Object.create(null);

    // split is slower in FF but fast enough.
    // v8 however this is faster then manual split?
    var values = string.split(';');
    var len = values.length;

    for (var i = 0; i < len; i++) {
      var parts = values[i].split('=');
      var ucname = parts[0].toUpperCase();
      var lcname = parts[0].toLowerCase();
      var name = (fmtIcal ? lcname : ucname);
      var value = parts[1];

      if (ucname in partDesign) {
        var partArr = value.split(',');
        var partArrIdx = 0;
        var partArrLen = partArr.length;

        for (; partArrIdx < partArrLen; partArrIdx++) {
          partArr[partArrIdx] = partDesign[ucname](partArr[partArrIdx]);
        }
        dict[name] = (partArr.length == 1 ? partArr[0] : partArr);
      } else if (ucname in optionDesign) {
        optionDesign[ucname](value, dict, fmtIcal);
      } else {
        // Don't swallow unknown values. Just set them as they are.
        dict[lcname] = value;
      }
    }

    return dict;
  };
})();
/* This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/.
 * Portions Copyright (C) Philipp Kewisch, 2011-2015 */


/**
 * This symbol is further described later on
 * @ignore
 */
ICAL.RecurIterator = (function() {

  /**
   * @classdesc
   * An iterator for a single recurrence rule. This class usually doesn't have
   * to be instanciated directly, the convenience method
   * {@link ICAL.Recur#iterator} can be used.
   *
   * @description
   * The options object may contain additional members when resuming iteration from a previous run
   *
   * @description
   * The options object may contain additional members when resuming iteration
   * from a previous run.
   *
   * @class
   * @alias ICAL.RecurIterator
   * @param {Object} options                The iterator options
   * @param {ICAL.Recur} options.rule       The rule to iterate.
   * @param {ICAL.Time} options.dtstart     The start date of the event.
   * @param {Boolean=} options.initialized  When true, assume that options are
   *        from a previously constructed iterator. Initialization will not be
   *        repeated.
   */
  function icalrecur_iterator(options) {
    this.fromData(options);
  }

  icalrecur_iterator.prototype = {

    /**
     * True when iteration is finished.
     * @type {Boolean}
     */
    completed: false,

    /**
     * The rule that is being iterated
     * @type {ICAL.Recur}
     */
    rule: null,

    /**
     * The start date of the event being iterated.
     * @type {ICAL.Time}
     */
    dtstart: null,

    /**
     * The last occurrence that was returned from the
     * {@link ICAL.RecurIterator#next} method.
     * @type {ICAL.Time}
     */
    last: null,

    /**
     * The sequence number from the occurrence
     * @type {Number}
     */
    occurrence_number: 0,

    /**
     * The indices used for the {@link ICAL.RecurIterator#by_data} object.
     * @type {Object}
     * @private
     */
    by_indices: null,

    /**
     * If true, the iterator has already been initialized
     * @type {Boolean}
     * @private
     */
    initialized: false,

    /**
     * The initializd by-data.
     * @type {Object}
     * @private
     */
    by_data: null,

    /**
     * The expanded yeardays
     * @type {Array}
     * @private
     */
    days: null,

    /**
     * The index in the {@link ICAL.RecurIterator#days} array.
     * @type {Number}
     * @private
     */
    days_index: 0,

    /**
     * Initialize the recurrence iterator from the passed data object. This
     * method is usually not called directly, you can initialize the iterator
     * through the constructor.
     *
     * @param {Object} options                The iterator options
     * @param {ICAL.Recur} options.rule       The rule to iterate.
     * @param {ICAL.Time} options.dtstart     The start date of the event.
     * @param {Boolean=} options.initialized  When true, assume that options are
     *        from a previously constructed iterator. Initialization will not be
     *        repeated.
     */
    fromData: function(options) {
      this.rule = ICAL.helpers.formatClassType(options.rule, ICAL.Recur);

      if (!this.rule) {
        throw new Error('iterator requires a (ICAL.Recur) rule');
      }

      this.dtstart = ICAL.helpers.formatClassType(options.dtstart, ICAL.Time);

      if (!this.dtstart) {
        throw new Error('iterator requires a (ICAL.Time) dtstart');
      }

      if (options.by_data) {
        this.by_data = options.by_data;
      } else {
        this.by_data = ICAL.helpers.clone(this.rule.parts, true);
      }

      if (options.occurrence_number)
        this.occurrence_number = options.occurrence_number;

      this.days = options.days || [];
      if (options.last) {
        this.last = ICAL.helpers.formatClassType(options.last, ICAL.Time);
      }

      this.by_indices = options.by_indices;

      if (!this.by_indices) {
        this.by_indices = {
          "BYSECOND": 0,
          "BYMINUTE": 0,
          "BYHOUR": 0,
          "BYDAY": 0,
          "BYMONTH": 0,
          "BYWEEKNO": 0,
          "BYMONTHDAY": 0
        };
      }

      this.initialized = options.initialized || false;

      if (!this.initialized) {
        this.init();
      }
    },

    /**
     * Intialize the iterator
     * @private
     */
    init: function icalrecur_iterator_init() {
      this.initialized = true;
      this.last = this.dtstart.clone();
      var parts = this.by_data;

      if ("BYDAY" in parts) {
        // libical does this earlier when the rule is loaded, but we postpone to
        // now so we can preserve the original order.
        this.sort_byday_rules(parts.BYDAY, this.rule.wkst);
      }

      // If the BYYEARDAY appares, no other date rule part may appear
      if ("BYYEARDAY" in parts) {
        if ("BYMONTH" in parts || "BYWEEKNO" in parts ||
            "BYMONTHDAY" in parts || "BYDAY" in parts) {
          throw new Error("Invalid BYYEARDAY rule");
        }
      }

      // BYWEEKNO and BYMONTHDAY rule parts may not both appear
      if ("BYWEEKNO" in parts && "BYMONTHDAY" in parts) {
        throw new Error("BYWEEKNO does not fit to BYMONTHDAY");
      }

      // For MONTHLY recurrences (FREQ=MONTHLY) neither BYYEARDAY nor
      // BYWEEKNO may appear.
      if (this.rule.freq == "MONTHLY" &&
          ("BYYEARDAY" in parts || "BYWEEKNO" in parts)) {
        throw new Error("For MONTHLY recurrences neither BYYEARDAY nor BYWEEKNO may appear");
      }

      // For WEEKLY recurrences (FREQ=WEEKLY) neither BYMONTHDAY nor
      // BYYEARDAY may appear.
      if (this.rule.freq == "WEEKLY" &&
          ("BYYEARDAY" in parts || "BYMONTHDAY" in parts)) {
        throw new Error("For WEEKLY recurrences neither BYMONTHDAY nor BYYEARDAY may appear");
      }

      // BYYEARDAY may only appear in YEARLY rules
      if (this.rule.freq != "YEARLY" && "BYYEARDAY" in parts) {
        throw new Error("BYYEARDAY may only appear in YEARLY rules");
      }

      this.last.second = this.setup_defaults("BYSECOND", "SECONDLY", this.dtstart.second);
      this.last.minute = this.setup_defaults("BYMINUTE", "MINUTELY", this.dtstart.minute);
      this.last.hour = this.setup_defaults("BYHOUR", "HOURLY", this.dtstart.hour);
      this.last.day = this.setup_defaults("BYMONTHDAY", "DAILY", this.dtstart.day);
      this.last.month = this.setup_defaults("BYMONTH", "MONTHLY", this.dtstart.month);

      if (this.rule.freq == "WEEKLY") {
        if ("BYDAY" in parts) {
          var bydayParts = this.ruleDayOfWeek(parts.BYDAY[0]);
          var pos = bydayParts[0];
          var dow = bydayParts[1];
          var wkdy = dow - this.last.dayOfWeek();
          if ((this.last.dayOfWeek() < dow && wkdy >= 0) || wkdy < 0) {
            // Initial time is after first day of BYDAY data
            this.last.day += wkdy;
          }
        } else {
          var dayName = ICAL.Recur.numericDayToIcalDay(this.dtstart.dayOfWeek());
          parts.BYDAY = [dayName];
        }
      }

      if (this.rule.freq == "YEARLY") {
        for (;;) {
          this.expand_year_days(this.last.year);
          if (this.days.length > 0) {
            break;
          }
          this.increment_year(this.rule.interval);
        }

        this._nextByYearDay();
      }

      if (this.rule.freq == "MONTHLY" && this.has_by_data("BYDAY")) {
        var tempLast = null;
        var initLast = this.last.clone();
        var daysInMonth = ICAL.Time.daysInMonth(this.last.month, this.last.year);

        // Check every weekday in BYDAY with relative dow and pos.
        for (var i in this.by_data.BYDAY) {
          /* istanbul ignore if */
          if (!this.by_data.BYDAY.hasOwnProperty(i)) {
            continue;
          }
          this.last = initLast.clone();
          var bydayParts = this.ruleDayOfWeek(this.by_data.BYDAY[i]);
          var pos = bydayParts[0];
          var dow = bydayParts[1];
          var dayOfMonth = this.last.nthWeekDay(dow, pos);

          // If |pos| >= 6, the byday is invalid for a monthly rule.
          if (pos >= 6 || pos <= -6) {
            throw new Error("Malformed values in BYDAY part");
          }

          // If a Byday with pos=+/-5 is not in the current month it
          // must be searched in the next months.
          if (dayOfMonth > daysInMonth || dayOfMonth <= 0) {
            // Skip if we have already found a "last" in this month.
            if (tempLast && tempLast.month == initLast.month) {
              continue;
            }
            while (dayOfMonth > daysInMonth || dayOfMonth <= 0) {
              this.increment_month();
              daysInMonth = ICAL.Time.daysInMonth(this.last.month, this.last.year);
              dayOfMonth = this.last.nthWeekDay(dow, pos);
            }
          }

          this.last.day = dayOfMonth;
          if (!tempLast || this.last.compare(tempLast) < 0) {
            tempLast = this.last.clone();
          }
        }
        this.last = tempLast.clone();

        //XXX: This feels like a hack, but we need to initialize
        //     the BYMONTHDAY case correctly and byDayAndMonthDay handles
        //     this case. It accepts a special flag which will avoid incrementing
        //     the initial value without the flag days that match the start time
        //     would be missed.
        if (this.has_by_data('BYMONTHDAY')) {
          this._byDayAndMonthDay(true);
        }

        if (this.last.day > daysInMonth || this.last.day == 0) {
          throw new Error("Malformed values in BYDAY part");
        }

      } else if (this.has_by_data("BYMONTHDAY")) {
        if (this.last.day < 0) {
          var daysInMonth = ICAL.Time.daysInMonth(this.last.month, this.last.year);
          this.last.day = daysInMonth + this.last.day + 1;
        }
      }

    },

    /**
     * Retrieve the next occurrence from the iterator.
     * @return {ICAL.Time}
     */
    next: function icalrecur_iterator_next() {
      var before = (this.last ? this.last.clone() : null);

      if ((this.rule.count && this.occurrence_number >= this.rule.count) ||
          (this.rule.until && this.last.compare(this.rule.until) > 0)) {

        //XXX: right now this is just a flag and has no impact
        //     we can simplify the above case to check for completed later.
        this.completed = true;

        return null;
      }

      if (this.occurrence_number == 0 && this.last.compare(this.dtstart) >= 0) {
        // First of all, give the instance that was initialized
        this.occurrence_number++;
        return this.last;
      }


      var valid;
      do {
        valid = 1;

        switch (this.rule.freq) {
        case "SECONDLY":
          this.next_second();
          break;
        case "MINUTELY":
          this.next_minute();
          break;
        case "HOURLY":
          this.next_hour();
          break;
        case "DAILY":
          this.next_day();
          break;
        case "WEEKLY":
          this.next_week();
          break;
        case "MONTHLY":
          valid = this.next_month();
          break;
        case "YEARLY":
          this.next_year();
          break;

        default:
          return null;
        }
      } while (!this.check_contracting_rules() ||
               this.last.compare(this.dtstart) < 0 ||
               !valid);

      // TODO is this valid?
      if (this.last.compare(before) == 0) {
        throw new Error("Same occurrence found twice, protecting " +
                        "you from death by recursion");
      }

      if (this.rule.until && this.last.compare(this.rule.until) > 0) {
        this.completed = true;
        return null;
      } else {
        this.occurrence_number++;
        return this.last;
      }
    },

    next_second: function next_second() {
      return this.next_generic("BYSECOND", "SECONDLY", "second", "minute");
    },

    increment_second: function increment_second(inc) {
      return this.increment_generic(inc, "second", 60, "minute");
    },

    next_minute: function next_minute() {
      return this.next_generic("BYMINUTE", "MINUTELY",
                               "minute", "hour", "next_second");
    },

    increment_minute: function increment_minute(inc) {
      return this.increment_generic(inc, "minute", 60, "hour");
    },

    next_hour: function next_hour() {
      return this.next_generic("BYHOUR", "HOURLY", "hour",
                               "monthday", "next_minute");
    },

    increment_hour: function increment_hour(inc) {
      this.increment_generic(inc, "hour", 24, "monthday");
    },

    next_day: function next_day() {
      var has_by_day = ("BYDAY" in this.by_data);
      var this_freq = (this.rule.freq == "DAILY");

      if (this.next_hour() == 0) {
        return 0;
      }

      if (this_freq) {
        this.increment_monthday(this.rule.interval);
      } else {
        this.increment_monthday(1);
      }

      return 0;
    },

    next_week: function next_week() {
      var end_of_data = 0;

      if (this.next_weekday_by_week() == 0) {
        return end_of_data;
      }

      if (this.has_by_data("BYWEEKNO")) {
        var idx = ++this.by_indices.BYWEEKNO;

        if (this.by_indices.BYWEEKNO == this.by_data.BYWEEKNO.length) {
          this.by_indices.BYWEEKNO = 0;
          end_of_data = 1;
        }

        // HACK should be first month of the year
        this.last.month = 1;
        this.last.day = 1;

        var week_no = this.by_data.BYWEEKNO[this.by_indices.BYWEEKNO];

        this.last.day += 7 * week_no;

        if (end_of_data) {
          this.increment_year(1);
        }
      } else {
        // Jump to the next week
        this.increment_monthday(7 * this.rule.interval);
      }

      return end_of_data;
    },

    /**
     * Normalize each by day rule for a given year/month.
     * Takes into account ordering and negative rules
     *
     * @private
     * @param {Number} year         Current year.
     * @param {Number} month        Current month.
     * @param {Array}  rules        Array of rules.
     *
     * @return {Array} sorted and normalized rules.
     *                 Negative rules will be expanded to their
     *                 correct positive values for easier processing.
     */
    normalizeByMonthDayRules: function(year, month, rules) {
      var daysInMonth = ICAL.Time.daysInMonth(month, year);

      // XXX: This is probably bad for performance to allocate
      //      a new array for each month we scan, if possible
      //      we should try to optimize this...
      var newRules = [];

      var ruleIdx = 0;
      var len = rules.length;
      var rule;

      for (; ruleIdx < len; ruleIdx++) {
        rule = rules[ruleIdx];

        // if this rule falls outside of given
        // month discard it.
        if (Math.abs(rule) > daysInMonth) {
          continue;
        }

        // negative case
        if (rule < 0) {
          // we add (not subtract its a negative number)
          // one from the rule because 1 === last day of month
          rule = daysInMonth + (rule + 1);
        } else if (rule === 0) {
          // skip zero its invalid.
          continue;
        }

        // only add unique items...
        if (newRules.indexOf(rule) === -1) {
          newRules.push(rule);
        }

      }

      // unique and sort
      return newRules.sort(function(a, b) { return a - b; });
    },

    /**
     * NOTES:
     * We are given a list of dates in the month (BYMONTHDAY) (23, etc..)
     * Also we are given a list of days (BYDAY) (MO, 2SU, etc..) when
     * both conditions match a given date (this.last.day) iteration stops.
     *
     * @private
     * @param {Boolean=} isInit     When given true will not increment the
     *                                current day (this.last).
     */
    _byDayAndMonthDay: function(isInit) {
      var byMonthDay; // setup in initMonth
      var byDay = this.by_data.BYDAY;

      var date;
      var dateIdx = 0;
      var dateLen; // setup in initMonth
      var dayLen = byDay.length;

      // we are not valid by default
      var dataIsValid = 0;

      var daysInMonth;
      var self = this;
      // we need a copy of this, because a DateTime gets normalized
      // automatically if the day is out of range. At some points we
      // set the last day to 0 to start counting.
      var lastDay = this.last.day;

      function initMonth() {
        daysInMonth = ICAL.Time.daysInMonth(
          self.last.month, self.last.year
        );

        byMonthDay = self.normalizeByMonthDayRules(
          self.last.year,
          self.last.month,
          self.by_data.BYMONTHDAY
        );

        dateLen = byMonthDay.length;

        // For the case of more than one occurrence in one month
        // we have to be sure to start searching after the last
        // found date or at the last BYMONTHDAY, unless we are
        // initializing the iterator because in this case we have
        // to consider the last found date too.
        while (byMonthDay[dateIdx] <= lastDay &&
               !(isInit && byMonthDay[dateIdx] == lastDay) &&
               dateIdx < dateLen - 1) {
          dateIdx++;
        }
      }

      function nextMonth() {
        // since the day is incremented at the start
        // of the loop below, we need to start at 0
        lastDay = 0;
        self.increment_month();
        dateIdx = 0;
        initMonth();
      }

      initMonth();

      // should come after initMonth
      if (isInit) {
        lastDay -= 1;
      }

      // Use a counter to avoid an infinite loop with malformed rules.
      // Stop checking after 4 years so we consider also a leap year.
      var monthsCounter = 48;

      while (!dataIsValid && monthsCounter) {
        monthsCounter--;
        // increment the current date. This is really
        // important otherwise we may fall into the infinite
        // loop trap. The initial date takes care of the case
        // where the current date is the date we are looking
        // for.
        date = lastDay + 1;

        if (date > daysInMonth) {
          nextMonth();
          continue;
        }

        // find next date
        var next = byMonthDay[dateIdx++];

        // this logic is dependant on the BYMONTHDAYS
        // being in order (which is done by #normalizeByMonthDayRules)
        if (next >= date) {
          // if the next month day is in the future jump to it.
          lastDay = next;
        } else {
          // in this case the 'next' monthday has past
          // we must move to the month.
          nextMonth();
          continue;
        }

        // Now we can loop through the day rules to see
        // if one matches the current month date.
        for (var dayIdx = 0; dayIdx < dayLen; dayIdx++) {
          var parts = this.ruleDayOfWeek(byDay[dayIdx]);
          var pos = parts[0];
          var dow = parts[1];

          this.last.day = lastDay;
          if (this.last.isNthWeekDay(dow, pos)) {
            // when we find the valid one we can mark
            // the conditions as met and break the loop.
            // (Because we have this condition above
            //  it will also break the parent loop).
            dataIsValid = 1;
            break;
          }
        }

        // Its completely possible that the combination
        // cannot be matched in the current month.
        // When we reach the end of possible combinations
        // in the current month we iterate to the next one.
        // since dateIdx is incremented right after getting
        // "next", we don't need dateLen -1 here.
        if (!dataIsValid && dateIdx === dateLen) {
          nextMonth();
          continue;
        }
      }

      if (monthsCounter <= 0) {
        // Checked 4 years without finding a Byday that matches
        // a Bymonthday. Maybe the rule is not correct.
        throw new Error("Malformed values in BYDAY combined with BYMONTHDAY parts");
      }


      return dataIsValid;
    },

    next_month: function next_month() {
      var this_freq = (this.rule.freq == "MONTHLY");
      var data_valid = 1;

      if (this.next_hour() == 0) {
        return data_valid;
      }

      if (this.has_by_data("BYDAY") && this.has_by_data("BYMONTHDAY")) {
        data_valid = this._byDayAndMonthDay();
      } else if (this.has_by_data("BYDAY")) {
        var daysInMonth = ICAL.Time.daysInMonth(this.last.month, this.last.year);
        var setpos = 0;
        var setpos_total = 0;

        if (this.has_by_data("BYSETPOS")) {
          var last_day = this.last.day;
          for (var day = 1; day <= daysInMonth; day++) {
            this.last.day = day;
            if (this.is_day_in_byday(this.last)) {
              setpos_total++;
              if (day <= last_day) {
                setpos++;
              }
            }
          }
          this.last.day = last_day;
        }

        data_valid = 0;
        for (var day = this.last.day + 1; day <= daysInMonth; day++) {
          this.last.day = day;

          if (this.is_day_in_byday(this.last)) {
            if (!this.has_by_data("BYSETPOS") ||
                this.check_set_position(++setpos) ||
                this.check_set_position(setpos - setpos_total - 1)) {

              data_valid = 1;
              break;
            }
          }
        }

        if (day > daysInMonth) {
          this.last.day = 1;
          this.increment_month();

          if (this.is_day_in_byday(this.last)) {
            if (!this.has_by_data("BYSETPOS") || this.check_set_position(1)) {
              data_valid = 1;
            }
          } else {
            data_valid = 0;
          }
        }
      } else if (this.has_by_data("BYMONTHDAY")) {
        this.by_indices.BYMONTHDAY++;

        if (this.by_indices.BYMONTHDAY >= this.by_data.BYMONTHDAY.length) {
          this.by_indices.BYMONTHDAY = 0;
          this.increment_month();
        }

        var daysInMonth = ICAL.Time.daysInMonth(this.last.month, this.last.year);
        var day = this.by_data.BYMONTHDAY[this.by_indices.BYMONTHDAY];

        if (day < 0) {
          day = daysInMonth + day + 1;
        }

        if (day > daysInMonth) {
          this.last.day = 1;
          data_valid = this.is_day_in_byday(this.last);
        } else {
          this.last.day = day;
        }

      } else {
        this.increment_month();
        var daysInMonth = ICAL.Time.daysInMonth(this.last.month, this.last.year);
        if (this.by_data.BYMONTHDAY[0] > daysInMonth) {
          data_valid = 0;
        } else {
          this.last.day = this.by_data.BYMONTHDAY[0];
        }
      }

      return data_valid;
    },

    next_weekday_by_week: function next_weekday_by_week() {
      var end_of_data = 0;

      if (this.next_hour() == 0) {
        return end_of_data;
      }

      if (!this.has_by_data("BYDAY")) {
        return 1;
      }

      for (;;) {
        var tt = new ICAL.Time();
        this.by_indices.BYDAY++;

        if (this.by_indices.BYDAY == Object.keys(this.by_data.BYDAY).length) {
          this.by_indices.BYDAY = 0;
          end_of_data = 1;
        }

        var coded_day = this.by_data.BYDAY[this.by_indices.BYDAY];
        var parts = this.ruleDayOfWeek(coded_day);
        var dow = parts[1];

        dow -= this.rule.wkst;

        if (dow < 0) {
          dow += 7;
        }

        tt.year = this.last.year;
        tt.month = this.last.month;
        tt.day = this.last.day;

        var startOfWeek = tt.startDoyWeek(this.rule.wkst);

        if (dow + startOfWeek < 1) {
          // The selected date is in the previous year
          if (!end_of_data) {
            continue;
          }
        }

        var next = ICAL.Time.fromDayOfYear(startOfWeek + dow,
                                                  this.last.year);

        /**
         * The normalization horrors below are due to
         * the fact that when the year/month/day changes
         * it can effect the other operations that come after.
         */
        this.last.year = next.year;
        this.last.month = next.month;
        this.last.day = next.day;

        return end_of_data;
      }
    },

    next_year: function next_year() {

      if (this.next_hour() == 0) {
        return 0;
      }

      if (++this.days_index == this.days.length) {
        this.days_index = 0;
        do {
          this.increment_year(this.rule.interval);
          this.expand_year_days(this.last.year);
        } while (this.days.length == 0);
      }

      this._nextByYearDay();

      return 1;
    },

    _nextByYearDay: function _nextByYearDay() {
        var doy = this.days[this.days_index];
        var year = this.last.year;
        if (doy < 1) {
            // Time.fromDayOfYear(doy, year) indexes relative to the
            // start of the given year. That is different from the
            // semantics of BYYEARDAY where negative indexes are an
            // offset from the end of the given year.
            doy += 1;
            year += 1;
        }
        var next = ICAL.Time.fromDayOfYear(doy, year);
        this.last.day = next.day;
        this.last.month = next.month;
    },

    ruleDayOfWeek: function ruleDayOfWeek(dow) {
      var matches = dow.match(/([+-]?[0-9])?(MO|TU|WE|TH|FR|SA|SU)/);
      if (matches) {
        var pos = parseInt(matches[1] || 0, 10);
        dow = ICAL.Recur.icalDayToNumericDay(matches[2]);
        return [pos, dow];
      } else {
        return [0, 0];
      }
    },

    next_generic: function next_generic(aRuleType, aInterval, aDateAttr,
                                        aFollowingAttr, aPreviousIncr) {
      var has_by_rule = (aRuleType in this.by_data);
      var this_freq = (this.rule.freq == aInterval);
      var end_of_data = 0;

      if (aPreviousIncr && this[aPreviousIncr]() == 0) {
        return end_of_data;
      }

      if (has_by_rule) {
        this.by_indices[aRuleType]++;
        var idx = this.by_indices[aRuleType];
        var dta = this.by_data[aRuleType];

        if (this.by_indices[aRuleType] == dta.length) {
          this.by_indices[aRuleType] = 0;
          end_of_data = 1;
        }
        this.last[aDateAttr] = dta[this.by_indices[aRuleType]];
      } else if (this_freq) {
        this["increment_" + aDateAttr](this.rule.interval);
      }

      if (has_by_rule && end_of_data && this_freq) {
        this["increment_" + aFollowingAttr](1);
      }

      return end_of_data;
    },

    increment_monthday: function increment_monthday(inc) {
      for (var i = 0; i < inc; i++) {
        var daysInMonth = ICAL.Time.daysInMonth(this.last.month, this.last.year);
        this.last.day++;

        if (this.last.day > daysInMonth) {
          this.last.day -= daysInMonth;
          this.increment_month();
        }
      }
    },

    increment_month: function increment_month() {
      this.last.day = 1;
      if (this.has_by_data("BYMONTH")) {
        this.by_indices.BYMONTH++;

        if (this.by_indices.BYMONTH == this.by_data.BYMONTH.length) {
          this.by_indices.BYMONTH = 0;
          this.increment_year(1);
        }

        this.last.month = this.by_data.BYMONTH[this.by_indices.BYMONTH];
      } else {
        if (this.rule.freq == "MONTHLY") {
          this.last.month += this.rule.interval;
        } else {
          this.last.month++;
        }

        this.last.month--;
        var years = ICAL.helpers.trunc(this.last.month / 12);
        this.last.month %= 12;
        this.last.month++;

        if (years != 0) {
          this.increment_year(years);
        }
      }
    },

    increment_year: function increment_year(inc) {
      this.last.year += inc;
    },

    increment_generic: function increment_generic(inc, aDateAttr,
                                                  aFactor, aNextIncrement) {
      this.last[aDateAttr] += inc;
      var nextunit = ICAL.helpers.trunc(this.last[aDateAttr] / aFactor);
      this.last[aDateAttr] %= aFactor;
      if (nextunit != 0) {
        this["increment_" + aNextIncrement](nextunit);
      }
    },

    has_by_data: function has_by_data(aRuleType) {
      return (aRuleType in this.rule.parts);
    },

    expand_year_days: function expand_year_days(aYear) {
      var t = new ICAL.Time();
      this.days = [];

      // We need our own copy with a few keys set
      var parts = {};
      var rules = ["BYDAY", "BYWEEKNO", "BYMONTHDAY", "BYMONTH", "BYYEARDAY"];
      for (var p in rules) {
        /* istanbul ignore else */
        if (rules.hasOwnProperty(p)) {
          var part = rules[p];
          if (part in this.rule.parts) {
            parts[part] = this.rule.parts[part];
          }
        }
      }

      if ("BYMONTH" in parts && "BYWEEKNO" in parts) {
        var valid = 1;
        var validWeeks = {};
        t.year = aYear;
        t.isDate = true;

        for (var monthIdx = 0; monthIdx < this.by_data.BYMONTH.length; monthIdx++) {
          var month = this.by_data.BYMONTH[monthIdx];
          t.month = month;
          t.day = 1;
          var first_week = t.weekNumber(this.rule.wkst);
          t.day = ICAL.Time.daysInMonth(month, aYear);
          var last_week = t.weekNumber(this.rule.wkst);
          for (monthIdx = first_week; monthIdx < last_week; monthIdx++) {
            validWeeks[monthIdx] = 1;
          }
        }

        for (var weekIdx = 0; weekIdx < this.by_data.BYWEEKNO.length && valid; weekIdx++) {
          var weekno = this.by_data.BYWEEKNO[weekIdx];
          if (weekno < 52) {
            valid &= validWeeks[weekIdx];
          } else {
            valid = 0;
          }
        }

        if (valid) {
          delete parts.BYMONTH;
        } else {
          delete parts.BYWEEKNO;
        }
      }

      var partCount = Object.keys(parts).length;

      if (partCount == 0) {
        var t1 = this.dtstart.clone();
        t1.year = this.last.year;
        this.days.push(t1.dayOfYear());
      } else if (partCount == 1 && "BYMONTH" in parts) {
        for (var monthkey in this.by_data.BYMONTH) {
          /* istanbul ignore if */
          if (!this.by_data.BYMONTH.hasOwnProperty(monthkey)) {
            continue;
          }
          var t2 = this.dtstart.clone();
          t2.year = aYear;
          t2.month = this.by_data.BYMONTH[monthkey];
          t2.isDate = true;
          this.days.push(t2.dayOfYear());
        }
      } else if (partCount == 1 && "BYMONTHDAY" in parts) {
        for (var monthdaykey in this.by_data.BYMONTHDAY) {
          /* istanbul ignore if */
          if (!this.by_data.BYMONTHDAY.hasOwnProperty(monthdaykey)) {
            continue;
          }
          var t3 = this.dtstart.clone();
          var day_ = this.by_data.BYMONTHDAY[monthdaykey];
          if (day_ < 0) {
            var daysInMonth = ICAL.Time.daysInMonth(t3.month, aYear);
            day_ = day_ + daysInMonth + 1;
          }
          t3.day = day_;
          t3.year = aYear;
          t3.isDate = true;
          this.days.push(t3.dayOfYear());
        }
      } else if (partCount == 2 &&
                 "BYMONTHDAY" in parts &&
                 "BYMONTH" in parts) {
        for (var monthkey in this.by_data.BYMONTH) {
          /* istanbul ignore if */
          if (!this.by_data.BYMONTH.hasOwnProperty(monthkey)) {
            continue;
          }
          var month_ = this.by_data.BYMONTH[monthkey];
          var daysInMonth = ICAL.Time.daysInMonth(month_, aYear);
          for (var monthdaykey in this.by_data.BYMONTHDAY) {
            /* istanbul ignore if */
            if (!this.by_data.BYMONTHDAY.hasOwnProperty(monthdaykey)) {
              continue;
            }
            var day_ = this.by_data.BYMONTHDAY[monthdaykey];
            if (day_ < 0) {
              day_ = day_ + daysInMonth + 1;
            }
            t.day = day_;
            t.month = month_;
            t.year = aYear;
            t.isDate = true;

            this.days.push(t.dayOfYear());
          }
        }
      } else if (partCount == 1 && "BYWEEKNO" in parts) {
        // TODO unimplemented in libical
      } else if (partCount == 2 &&
                 "BYWEEKNO" in parts &&
                 "BYMONTHDAY" in parts) {
        // TODO unimplemented in libical
      } else if (partCount == 1 && "BYDAY" in parts) {
        this.days = this.days.concat(this.expand_by_day(aYear));
      } else if (partCount == 2 && "BYDAY" in parts && "BYMONTH" in parts) {
        for (var monthkey in this.by_data.BYMONTH) {
          /* istanbul ignore if */
          if (!this.by_data.BYMONTH.hasOwnProperty(monthkey)) {
            continue;
          }
          var month = this.by_data.BYMONTH[monthkey];
          var daysInMonth = ICAL.Time.daysInMonth(month, aYear);

          t.year = aYear;
          t.month = this.by_data.BYMONTH[monthkey];
          t.day = 1;
          t.isDate = true;

          var first_dow = t.dayOfWeek();
          var doy_offset = t.dayOfYear() - 1;

          t.day = daysInMonth;
          var last_dow = t.dayOfWeek();

          if (this.has_by_data("BYSETPOS")) {
            var set_pos_counter = 0;
            var by_month_day = [];
            for (var day = 1; day <= daysInMonth; day++) {
              t.day = day;
              if (this.is_day_in_byday(t)) {
                by_month_day.push(day);
              }
            }

            for (var spIndex = 0; spIndex < by_month_day.length; spIndex++) {
              if (this.check_set_position(spIndex + 1) ||
                  this.check_set_position(spIndex - by_month_day.length)) {
                this.days.push(doy_offset + by_month_day[spIndex]);
              }
            }
          } else {
            for (var daycodedkey in this.by_data.BYDAY) {
              /* istanbul ignore if */
              if (!this.by_data.BYDAY.hasOwnProperty(daycodedkey)) {
                continue;
              }
              var coded_day = this.by_data.BYDAY[daycodedkey];
              var bydayParts = this.ruleDayOfWeek(coded_day);
              var pos = bydayParts[0];
              var dow = bydayParts[1];
              var month_day;

              var first_matching_day = ((dow + 7 - first_dow) % 7) + 1;
              var last_matching_day = daysInMonth - ((last_dow + 7 - dow) % 7);

              if (pos == 0) {
                for (var day = first_matching_day; day <= daysInMonth; day += 7) {
                  this.days.push(doy_offset + day);
                }
              } else if (pos > 0) {
                month_day = first_matching_day + (pos - 1) * 7;

                if (month_day <= daysInMonth) {
                  this.days.push(doy_offset + month_day);
                }
              } else {
                month_day = last_matching_day + (pos + 1) * 7;

                if (month_day > 0) {
                  this.days.push(doy_offset + month_day);
                }
              }
            }
          }
        }
        // Return dates in order of occurrence (1,2,3,...) instead
        // of by groups of weekdays (1,8,15,...,2,9,16,...).
        this.days.sort(function(a, b) { return a - b; }); // Comparator function allows to sort numbers.
      } else if (partCount == 2 && "BYDAY" in parts && "BYMONTHDAY" in parts) {
        var expandedDays = this.expand_by_day(aYear);

        for (var daykey in expandedDays) {
          /* istanbul ignore if */
          if (!expandedDays.hasOwnProperty(daykey)) {
            continue;
          }
          var day = expandedDays[daykey];
          var tt = ICAL.Time.fromDayOfYear(day, aYear);
          if (this.by_data.BYMONTHDAY.indexOf(tt.day) >= 0) {
            this.days.push(day);
          }
        }
      } else if (partCount == 3 &&
                 "BYDAY" in parts &&
                 "BYMONTHDAY" in parts &&
                 "BYMONTH" in parts) {
        var expandedDays = this.expand_by_day(aYear);

        for (var daykey in expandedDays) {
          /* istanbul ignore if */
          if (!expandedDays.hasOwnProperty(daykey)) {
            continue;
          }
          var day = expandedDays[daykey];
          var tt = ICAL.Time.fromDayOfYear(day, aYear);

          if (this.by_data.BYMONTH.indexOf(tt.month) >= 0 &&
              this.by_data.BYMONTHDAY.indexOf(tt.day) >= 0) {
            this.days.push(day);
          }
        }
      } else if (partCount == 2 && "BYDAY" in parts && "BYWEEKNO" in parts) {
        var expandedDays = this.expand_by_day(aYear);

        for (var daykey in expandedDays) {
          /* istanbul ignore if */
          if (!expandedDays.hasOwnProperty(daykey)) {
            continue;
          }
          var day = expandedDays[daykey];
          var tt = ICAL.Time.fromDayOfYear(day, aYear);
          var weekno = tt.weekNumber(this.rule.wkst);

          if (this.by_data.BYWEEKNO.indexOf(weekno)) {
            this.days.push(day);
          }
        }
      } else if (partCount == 3 &&
                 "BYDAY" in parts &&
                 "BYWEEKNO" in parts &&
                 "BYMONTHDAY" in parts) {
        // TODO unimplemted in libical
      } else if (partCount == 1 && "BYYEARDAY" in parts) {
        this.days = this.days.concat(this.by_data.BYYEARDAY);
      } else {
        this.days = [];
      }
      return 0;
    },

    expand_by_day: function expand_by_day(aYear) {

      var days_list = [];
      var tmp = this.last.clone();

      tmp.year = aYear;
      tmp.month = 1;
      tmp.day = 1;
      tmp.isDate = true;

      var start_dow = tmp.dayOfWeek();

      tmp.month = 12;
      tmp.day = 31;
      tmp.isDate = true;

      var end_dow = tmp.dayOfWeek();
      var end_year_day = tmp.dayOfYear();

      for (var daykey in this.by_data.BYDAY) {
        /* istanbul ignore if */
        if (!this.by_data.BYDAY.hasOwnProperty(daykey)) {
          continue;
        }
        var day = this.by_data.BYDAY[daykey];
        var parts = this.ruleDayOfWeek(day);
        var pos = parts[0];
        var dow = parts[1];

        if (pos == 0) {
          var tmp_start_doy = ((dow + 7 - start_dow) % 7) + 1;

          for (var doy = tmp_start_doy; doy <= end_year_day; doy += 7) {
            days_list.push(doy);
          }

        } else if (pos > 0) {
          var first;
          if (dow >= start_dow) {
            first = dow - start_dow + 1;
          } else {
            first = dow - start_dow + 8;
          }

          days_list.push(first + (pos - 1) * 7);
        } else {
          var last;
          pos = -pos;

          if (dow <= end_dow) {
            last = end_year_day - end_dow + dow;
          } else {
            last = end_year_day - end_dow + dow - 7;
          }

          days_list.push(last - (pos - 1) * 7);
        }
      }
      return days_list;
    },

    is_day_in_byday: function is_day_in_byday(tt) {
      for (var daykey in this.by_data.BYDAY) {
        /* istanbul ignore if */
        if (!this.by_data.BYDAY.hasOwnProperty(daykey)) {
          continue;
        }
        var day = this.by_data.BYDAY[daykey];
        var parts = this.ruleDayOfWeek(day);
        var pos = parts[0];
        var dow = parts[1];
        var this_dow = tt.dayOfWeek();

        if ((pos == 0 && dow == this_dow) ||
            (tt.nthWeekDay(dow, pos) == tt.day)) {
          return 1;
        }
      }

      return 0;
    },

    /**
     * Checks if given value is in BYSETPOS.
     *
     * @private
     * @param {Numeric} aPos position to check for.
     * @return {Boolean} false unless BYSETPOS rules exist
     *                   and the given value is present in rules.
     */
    check_set_position: function check_set_position(aPos) {
      if (this.has_by_data('BYSETPOS')) {
        var idx = this.by_data.BYSETPOS.indexOf(aPos);
        // negative numbers are not false-y
        return idx !== -1;
      }
      return false;
    },

    sort_byday_rules: function icalrecur_sort_byday_rules(aRules, aWeekStart) {
      for (var i = 0; i < aRules.length; i++) {
        for (var j = 0; j < i; j++) {
          var one = this.ruleDayOfWeek(aRules[j])[1];
          var two = this.ruleDayOfWeek(aRules[i])[1];
          one -= aWeekStart;
          two -= aWeekStart;
          if (one < 0) one += 7;
          if (two < 0) two += 7;

          if (one > two) {
            var tmp = aRules[i];
            aRules[i] = aRules[j];
            aRules[j] = tmp;
          }
        }
      }
    },

    check_contract_restriction: function check_contract_restriction(aRuleType, v) {
      var indexMapValue = icalrecur_iterator._indexMap[aRuleType];
      var ruleMapValue = icalrecur_iterator._expandMap[this.rule.freq][indexMapValue];
      var pass = false;

      if (aRuleType in this.by_data &&
          ruleMapValue == icalrecur_iterator.CONTRACT) {

        var ruleType = this.by_data[aRuleType];

        for (var bydatakey in ruleType) {
          /* istanbul ignore else */
          if (ruleType.hasOwnProperty(bydatakey)) {
            if (ruleType[bydatakey] == v) {
              pass = true;
              break;
            }
          }
        }
      } else {
        // Not a contracting byrule or has no data, test passes
        pass = true;
      }
      return pass;
    },

    check_contracting_rules: function check_contracting_rules() {
      var dow = this.last.dayOfWeek();
      var weekNo = this.last.weekNumber(this.rule.wkst);
      var doy = this.last.dayOfYear();

      return (this.check_contract_restriction("BYSECOND", this.last.second) &&
              this.check_contract_restriction("BYMINUTE", this.last.minute) &&
              this.check_contract_restriction("BYHOUR", this.last.hour) &&
              this.check_contract_restriction("BYDAY", ICAL.Recur.numericDayToIcalDay(dow)) &&
              this.check_contract_restriction("BYWEEKNO", weekNo) &&
              this.check_contract_restriction("BYMONTHDAY", this.last.day) &&
              this.check_contract_restriction("BYMONTH", this.last.month) &&
              this.check_contract_restriction("BYYEARDAY", doy));
    },

    setup_defaults: function setup_defaults(aRuleType, req, deftime) {
      var indexMapValue = icalrecur_iterator._indexMap[aRuleType];
      var ruleMapValue = icalrecur_iterator._expandMap[this.rule.freq][indexMapValue];

      if (ruleMapValue != icalrecur_iterator.CONTRACT) {
        if (!(aRuleType in this.by_data)) {
          this.by_data[aRuleType] = [deftime];
        }
        if (this.rule.freq != req) {
          return this.by_data[aRuleType][0];
        }
      }
      return deftime;
    },

    /**
     * Convert iterator into a serialize-able object.  Will preserve current
     * iteration sequence to ensure the seamless continuation of the recurrence
     * rule.
     * @return {Object}
     */
    toJSON: function() {
      var result = Object.create(null);

      result.initialized = this.initialized;
      result.rule = this.rule.toJSON();
      result.dtstart = this.dtstart.toJSON();
      result.by_data = this.by_data;
      result.days = this.days;
      result.last = this.last.toJSON();
      result.by_indices = this.by_indices;
      result.occurrence_number = this.occurrence_number;

      return result;
    }
  };

  icalrecur_iterator._indexMap = {
    "BYSECOND": 0,
    "BYMINUTE": 1,
    "BYHOUR": 2,
    "BYDAY": 3,
    "BYMONTHDAY": 4,
    "BYYEARDAY": 5,
    "BYWEEKNO": 6,
    "BYMONTH": 7,
    "BYSETPOS": 8
  };

  icalrecur_iterator._expandMap = {
    "SECONDLY": [1, 1, 1, 1, 1, 1, 1, 1],
    "MINUTELY": [2, 1, 1, 1, 1, 1, 1, 1],
    "HOURLY": [2, 2, 1, 1, 1, 1, 1, 1],
    "DAILY": [2, 2, 2, 1, 1, 1, 1, 1],
    "WEEKLY": [2, 2, 2, 2, 3, 3, 1, 1],
    "MONTHLY": [2, 2, 2, 2, 2, 3, 3, 1],
    "YEARLY": [2, 2, 2, 2, 2, 2, 2, 2]
  };
  icalrecur_iterator.UNKNOWN = 0;
  icalrecur_iterator.CONTRACT = 1;
  icalrecur_iterator.EXPAND = 2;
  icalrecur_iterator.ILLEGAL = 3;

  return icalrecur_iterator;

}());
/* This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/.
 * Portions Copyright (C) Philipp Kewisch, 2011-2015 */


/**
 * This symbol is further described later on
 * @ignore
 */
ICAL.RecurExpansion = (function() {
  function formatTime(item) {
    return ICAL.helpers.formatClassType(item, ICAL.Time);
  }

  function compareTime(a, b) {
    return a.compare(b);
  }

  function isRecurringComponent(comp) {
    return comp.hasProperty('rdate') ||
           comp.hasProperty('rrule') ||
           comp.hasProperty('recurrence-id');
  }

  /**
   * @classdesc
   * Primary class for expanding recurring rules.  Can take multiple rrules,
   * rdates, exdate(s) and iterate (in order) over each next occurrence.
   *
   * Once initialized this class can also be serialized saved and continue
   * iteration from the last point.
   *
   * NOTE: it is intended that this class is to be used
   *       with ICAL.Event which handles recurrence exceptions.
   *
   * @example
   * // assuming event is a parsed ical component
   * var event;
   *
   * var expand = new ICAL.RecurExpansion({
   *   component: event,
   *   dtstart: event.getFirstPropertyValue('dtstart')
   * });
   *
   * // remember there are infinite rules
   * // so its a good idea to limit the scope
   * // of the iterations then resume later on.
   *
   * // next is always an ICAL.Time or null
   * var next;
   *
   * while (someCondition && (next = expand.next())) {
   *   // do something with next
   * }
   *
   * // save instance for later
   * var json = JSON.stringify(expand);
   *
   * //...
   *
   * // NOTE: if the component's properties have
   * //       changed you will need to rebuild the
   * //       class and start over. This only works
   * //       when the component's recurrence info is the same.
   * var expand = new ICAL.RecurExpansion(JSON.parse(json));
   *
   * @description
   * The options object can be filled with the specified initial values. It can
   * also contain additional members, as a result of serializing a previous
   * expansion state, as shown in the example.
   *
   * @class
   * @alias ICAL.RecurExpansion
   * @param {Object} options
   *        Recurrence expansion options
   * @param {ICAL.Time} options.dtstart
   *        Start time of the event
   * @param {ICAL.Component=} options.component
   *        Component for expansion, required if not resuming.
   */
  function RecurExpansion(options) {
    this.ruleDates = [];
    this.exDates = [];
    this.fromData(options);
  }

  RecurExpansion.prototype = {
    /**
     * True when iteration is fully completed.
     * @type {Boolean}
     */
    complete: false,

    /**
     * Array of rrule iterators.
     *
     * @type {ICAL.RecurIterator[]}
     * @private
     */
    ruleIterators: null,

    /**
     * Array of rdate instances.
     *
     * @type {ICAL.Time[]}
     * @private
     */
    ruleDates: null,

    /**
     * Array of exdate instances.
     *
     * @type {ICAL.Time[]}
     * @private
     */
    exDates: null,

    /**
     * Current position in ruleDates array.
     * @type {Number}
     * @private
     */
    ruleDateInc: 0,

    /**
     * Current position in exDates array
     * @type {Number}
     * @private
     */
    exDateInc: 0,

    /**
     * Current negative date.
     *
     * @type {ICAL.Time}
     * @private
     */
    exDate: null,

    /**
     * Current additional date.
     *
     * @type {ICAL.Time}
     * @private
     */
    ruleDate: null,

    /**
     * Start date of recurring rules.
     *
     * @type {ICAL.Time}
     */
    dtstart: null,

    /**
     * Last expanded time
     *
     * @type {ICAL.Time}
     */
    last: null,

    /**
     * Initialize the recurrence expansion from the data object. The options
     * object may also contain additional members, see the
     * {@link ICAL.RecurExpansion constructor} for more details.
     *
     * @param {Object} options
     *        Recurrence expansion options
     * @param {ICAL.Time} options.dtstart
     *        Start time of the event
     * @param {ICAL.Component=} options.component
     *        Component for expansion, required if not resuming.
     */
    fromData: function(options) {
      var start = ICAL.helpers.formatClassType(options.dtstart, ICAL.Time);

      if (!start) {
        throw new Error('.dtstart (ICAL.Time) must be given');
      } else {
        this.dtstart = start;
      }

      if (options.component) {
        this._init(options.component);
      } else {
        this.last = formatTime(options.last) || start.clone();

        if (!options.ruleIterators) {
          throw new Error('.ruleIterators or .component must be given');
        }

        this.ruleIterators = options.ruleIterators.map(function(item) {
          return ICAL.helpers.formatClassType(item, ICAL.RecurIterator);
        });

        this.ruleDateInc = options.ruleDateInc;
        this.exDateInc = options.exDateInc;

        if (options.ruleDates) {
          this.ruleDates = options.ruleDates.map(formatTime);
          this.ruleDate = this.ruleDates[this.ruleDateInc];
        }

        if (options.exDates) {
          this.exDates = options.exDates.map(formatTime);
          this.exDate = this.exDates[this.exDateInc];
        }

        if (typeof(options.complete) !== 'undefined') {
          this.complete = options.complete;
        }
      }
    },

    /**
     * Retrieve the next occurrence in the series.
     * @return {ICAL.Time}
     */
    next: function() {
      var iter;
      var ruleOfDay;
      var next;
      var compare;

      var maxTries = 500;
      var currentTry = 0;

      while (true) {
        if (currentTry++ > maxTries) {
          throw new Error(
            'max tries have occured, rule may be impossible to forfill.'
          );
        }

        next = this.ruleDate;
        iter = this._nextRecurrenceIter(this.last);

        // no more matches
        // because we increment the rule day or rule
        // _after_ we choose a value this should be
        // the only spot where we need to worry about the
        // end of events.
        if (!next && !iter) {
          // there are no more iterators or rdates
          this.complete = true;
          break;
        }

        // no next rule day or recurrence rule is first.
        if (!next || (iter && next.compare(iter.last) > 0)) {
          // must be cloned, recur will reuse the time element.
          next = iter.last.clone();
          // move to next so we can continue
          iter.next();
        }

        // if the ruleDate is still next increment it.
        if (this.ruleDate === next) {
          this._nextRuleDay();
        }

        this.last = next;

        // check the negative rules
        if (this.exDate) {
          compare = this.exDate.compare(this.last);

          if (compare < 0) {
            this._nextExDay();
          }

          // if the current rule is excluded skip it.
          if (compare === 0) {
            this._nextExDay();
            continue;
          }
        }

        //XXX: The spec states that after we resolve the final
        //     list of dates we execute exdate this seems somewhat counter
        //     intuitive to what I have seen most servers do so for now
        //     I exclude based on the original date not the one that may
        //     have been modified by the exception.
        return this.last;
      }
    },

    /**
     * Converts object into a serialize-able format. This format can be passed
     * back into the expansion to resume iteration.
     * @return {Object}
     */
    toJSON: function() {
      function toJSON(item) {
        return item.toJSON();
      }

      var result = Object.create(null);
      result.ruleIterators = this.ruleIterators.map(toJSON);

      if (this.ruleDates) {
        result.ruleDates = this.ruleDates.map(toJSON);
      }

      if (this.exDates) {
        result.exDates = this.exDates.map(toJSON);
      }

      result.ruleDateInc = this.ruleDateInc;
      result.exDateInc = this.exDateInc;
      result.last = this.last.toJSON();
      result.dtstart = this.dtstart.toJSON();
      result.complete = this.complete;

      return result;
    },

    /**
     * Extract all dates from the properties in the given component. The
     * properties will be filtered by the property name.
     *
     * @private
     * @param {ICAL.Component} component        The component to search in
     * @param {String} propertyName             The property name to search for
     * @return {ICAL.Time[]}                    The extracted dates.
     */
    _extractDates: function(component, propertyName) {
      function handleProp(prop) {
        idx = ICAL.helpers.binsearchInsert(
          result,
          prop,
          compareTime
        );

        // ordered insert
        result.splice(idx, 0, prop);
      }

      var result = [];
      var props = component.getAllProperties(propertyName);
      var len = props.length;
      var i = 0;
      var prop;

      var idx;

      for (; i < len; i++) {
        props[i].getValues().forEach(handleProp);
      }

      return result;
    },

    /**
     * Initialize the recurrence expansion.
     *
     * @private
     * @param {ICAL.Component} component    The component to initialize from.
     */
    _init: function(component) {
      this.ruleIterators = [];

      this.last = this.dtstart.clone();

      // to provide api consistency non-recurring
      // events can also use the iterator though it will
      // only return a single time.
      if (!isRecurringComponent(component)) {
        this.ruleDate = this.last.clone();
        this.complete = true;
        return;
      }

      if (component.hasProperty('rdate')) {
        this.ruleDates = this._extractDates(component, 'rdate');

        // special hack for cases where first rdate is prior
        // to the start date. We only check for the first rdate.
        // This is mostly for google's crazy recurring date logic
        // (contacts birthdays).
        if ((this.ruleDates[0]) &&
            (this.ruleDates[0].compare(this.dtstart) < 0)) {

          this.ruleDateInc = 0;
          this.last = this.ruleDates[0].clone();
        } else {
          this.ruleDateInc = ICAL.helpers.binsearchInsert(
            this.ruleDates,
            this.last,
            compareTime
          );
        }

        this.ruleDate = this.ruleDates[this.ruleDateInc];
      }

      if (component.hasProperty('rrule')) {
        var rules = component.getAllProperties('rrule');
        var i = 0;
        var len = rules.length;

        var rule;
        var iter;

        for (; i < len; i++) {
          rule = rules[i].getFirstValue();
          iter = rule.iterator(this.dtstart);
          this.ruleIterators.push(iter);

          // increment to the next occurrence so future
          // calls to next return times beyond the initial iteration.
          // XXX: I find this suspicious might be a bug?
          iter.next();
        }
      }

      if (component.hasProperty('exdate')) {
        this.exDates = this._extractDates(component, 'exdate');
        // if we have a .last day we increment the index to beyond it.
        this.exDateInc = ICAL.helpers.binsearchInsert(
          this.exDates,
          this.last,
          compareTime
        );

        this.exDate = this.exDates[this.exDateInc];
      }
    },

    /**
     * Advance to the next exdate
     * @private
     */
    _nextExDay: function() {
      this.exDate = this.exDates[++this.exDateInc];
    },

    /**
     * Advance to the next rule date
     * @private
     */
    _nextRuleDay: function() {
      this.ruleDate = this.ruleDates[++this.ruleDateInc];
    },

    /**
     * Find and return the recurrence rule with the most recent event and
     * return it.
     *
     * @private
     * @return {?ICAL.RecurIterator}    Found iterator.
     */
    _nextRecurrenceIter: function() {
      var iters = this.ruleIterators;

      if (iters.length === 0) {
        return null;
      }

      var len = iters.length;
      var iter;
      var iterTime;
      var iterIdx = 0;
      var chosenIter;

      // loop through each iterator
      for (; iterIdx < len; iterIdx++) {
        iter = iters[iterIdx];
        iterTime = iter.last;

        // if iteration is complete
        // then we must exclude it from
        // the search and remove it.
        if (iter.completed) {
          len--;
          if (iterIdx !== 0) {
            iterIdx--;
          }
          iters.splice(iterIdx, 1);
          continue;
        }

        // find the most recent possible choice
        if (!chosenIter || chosenIter.last.compare(iterTime) > 0) {
          // that iterator is saved
          chosenIter = iter;
        }
      }

      // the chosen iterator is returned but not mutated
      // this iterator contains the most recent event.
      return chosenIter;
    }
  };

  return RecurExpansion;
}());
/* This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/.
 * Portions Copyright (C) Philipp Kewisch, 2011-2015 */


/**
 * This symbol is further described later on
 * @ignore
 */
ICAL.Event = (function() {

  /**
   * @classdesc
   * ICAL.js is organized into multiple layers. The bottom layer is a raw jCal
   * object, followed by the component/property layer. The highest level is the
   * event representation, which this class is part of. See the
   * {@tutorial layers} guide for more details.
   *
   * @class
   * @alias ICAL.Event
   * @param {ICAL.Component=} component         The ICAL.Component to base this event on
   * @param {Object} options                    Options for this event
   * @param {Boolean} options.strictExceptions
   *          When true, will verify exceptions are related by their UUID
   * @param {Array<ICAL.Component|ICAL.Event>} options.exceptions
   *          Exceptions to this event, either as components or events. If not
   *            specified exceptions will automatically be set in relation of
   *            component's parent
   */
  function Event(component, options) {
    if (!(component instanceof ICAL.Component)) {
      options = component;
      component = null;
    }

    if (component) {
      this.component = component;
    } else {
      this.component = new ICAL.Component('vevent');
    }

    this._rangeExceptionCache = Object.create(null);
    this.exceptions = Object.create(null);
    this.rangeExceptions = [];

    if (options && options.strictExceptions) {
      this.strictExceptions = options.strictExceptions;
    }

    if (options && options.exceptions) {
      options.exceptions.forEach(this.relateException, this);
    } else if (this.component.parent && !this.isRecurrenceException()) {
      this.component.parent.getAllSubcomponents('vevent').forEach(function(event) {
        if (event.hasProperty('recurrence-id')) {
          this.relateException(event);
        }
      }, this);
    }
  }

  Event.prototype = {

    THISANDFUTURE: 'THISANDFUTURE',

    /**
     * List of related event exceptions.
     *
     * @type {ICAL.Event[]}
     */
    exceptions: null,

    /**
     * When true, will verify exceptions are related by their UUID.
     *
     * @type {Boolean}
     */
    strictExceptions: false,

    /**
     * Relates a given event exception to this object.  If the given component
     * does not share the UID of this event it cannot be related and will throw
     * an exception.
     *
     * If this component is an exception it cannot have other exceptions
     * related to it.
     *
     * @param {ICAL.Component|ICAL.Event} obj       Component or event
     */
    relateException: function(obj) {
      if (this.isRecurrenceException()) {
        throw new Error('cannot relate exception to exceptions');
      }

      if (obj instanceof ICAL.Component) {
        obj = new ICAL.Event(obj);
      }

      if (this.strictExceptions && obj.uid !== this.uid) {
        throw new Error('attempted to relate unrelated exception');
      }

      var id = obj.recurrenceId.toString();

      // we don't sort or manage exceptions directly
      // here the recurrence expander handles that.
      this.exceptions[id] = obj;

      // index RANGE=THISANDFUTURE exceptions so we can
      // look them up later in getOccurrenceDetails.
      if (obj.modifiesFuture()) {
        var item = [
          obj.recurrenceId.toUnixTime(), id
        ];

        // we keep them sorted so we can find the nearest
        // value later on...
        var idx = ICAL.helpers.binsearchInsert(
          this.rangeExceptions,
          item,
          compareRangeException
        );

        this.rangeExceptions.splice(idx, 0, item);
      }
    },

    /**
     * Checks if this record is an exception and has the RANGE=THISANDFUTURE
     * value.
     *
     * @return {Boolean}        True, when exception is within range
     */
    modifiesFuture: function() {
      if (!this.component.hasProperty('recurrence-id')) {
        return false;
      }

      var range = this.component.getFirstProperty('recurrence-id').getParameter('range');
      return range === this.THISANDFUTURE;
    },

    /**
     * Finds the range exception nearest to the given date.
     *
     * @param {ICAL.Time} time usually an occurrence time of an event
     * @return {?ICAL.Event} the related event/exception or null
     */
    findRangeException: function(time) {
      if (!this.rangeExceptions.length) {
        return null;
      }

      var utc = time.toUnixTime();
      var idx = ICAL.helpers.binsearchInsert(
        this.rangeExceptions,
        [utc],
        compareRangeException
      );

      idx -= 1;

      // occurs before
      if (idx < 0) {
        return null;
      }

      var rangeItem = this.rangeExceptions[idx];

      /* istanbul ignore next: sanity check only */
      if (utc < rangeItem[0]) {
        return null;
      }

      return rangeItem[1];
    },

    /**
     * This object is returned by {@link ICAL.Event#getOccurrenceDetails getOccurrenceDetails}
     *
     * @typedef {Object} occurrenceDetails
     * @memberof ICAL.Event
     * @property {ICAL.Time} recurrenceId       The passed in recurrence id
     * @property {ICAL.Event} item              The occurrence
     * @property {ICAL.Time} startDate          The start of the occurrence
     * @property {ICAL.Time} endDate            The end of the occurrence
     */

    /**
     * Returns the occurrence details based on its start time.  If the
     * occurrence has an exception will return the details for that exception.
     *
     * NOTE: this method is intend to be used in conjunction
     *       with the {@link ICAL.Event#iterator iterator} method.
     *
     * @param {ICAL.Time} occurrence time occurrence
     * @return {ICAL.Event.occurrenceDetails} Information about the occurrence
     */
    getOccurrenceDetails: function(occurrence) {
      var id = occurrence.toString();
      var utcId = occurrence.convertToZone(ICAL.Timezone.utcTimezone).toString();
      var item;
      var result = {
        //XXX: Clone?
        recurrenceId: occurrence
      };

      if (id in this.exceptions) {
        item = result.item = this.exceptions[id];
        result.startDate = item.startDate;
        result.endDate = item.endDate;
        result.item = item;
      } else if (utcId in this.exceptions) {
        item = this.exceptions[utcId];
        result.startDate = item.startDate;
        result.endDate = item.endDate;
        result.item = item;
      } else {
        // range exceptions (RANGE=THISANDFUTURE) have a
        // lower priority then direct exceptions but
        // must be accounted for first. Their item is
        // always the first exception with the range prop.
        var rangeExceptionId = this.findRangeException(
          occurrence
        );
        var end;

        if (rangeExceptionId) {
          var exception = this.exceptions[rangeExceptionId];

          // range exception must modify standard time
          // by the difference (if any) in start/end times.
          result.item = exception;

          var startDiff = this._rangeExceptionCache[rangeExceptionId];

          if (!startDiff) {
            var original = exception.recurrenceId.clone();
            var newStart = exception.startDate.clone();

            // zones must be same otherwise subtract may be incorrect.
            original.zone = newStart.zone;
            startDiff = newStart.subtractDate(original);

            this._rangeExceptionCache[rangeExceptionId] = startDiff;
          }

          var start = occurrence.clone();
          start.zone = exception.startDate.zone;
          start.addDuration(startDiff);

          end = start.clone();
          end.addDuration(exception.duration);

          result.startDate = start;
          result.endDate = end;
        } else {
          // no range exception standard expansion
          end = occurrence.clone();
          end.addDuration(this.duration);

          result.endDate = end;
          result.startDate = occurrence;
          result.item = this;
        }
      }

      return result;
    },

    /**
     * Builds a recur expansion instance for a specific point in time (defaults
     * to startDate).
     *
     * @param {ICAL.Time} startTime     Starting point for expansion
     * @return {ICAL.RecurExpansion}    Expansion object
     */
    iterator: function(startTime) {
      return new ICAL.RecurExpansion({
        component: this.component,
        dtstart: startTime || this.startDate
      });
    },

    /**
     * Checks if the event is recurring
     *
     * @return {Boolean}        True, if event is recurring
     */
    isRecurring: function() {
      var comp = this.component;
      return comp.hasProperty('rrule') || comp.hasProperty('rdate');
    },

    /**
     * Checks if the event describes a recurrence exception. See
     * {@tutorial terminology} for details.
     *
     * @return {Boolean}    True, if the even describes a recurrence exception
     */
    isRecurrenceException: function() {
      return this.component.hasProperty('recurrence-id');
    },

    /**
     * Returns the types of recurrences this event may have.
     *
     * Returned as an object with the following possible keys:
     *
     *    - YEARLY
     *    - MONTHLY
     *    - WEEKLY
     *    - DAILY
     *    - MINUTELY
     *    - SECONDLY
     *
     * @return {Object.<ICAL.Recur.frequencyValues, Boolean>}
     *          Object of recurrence flags
     */
    getRecurrenceTypes: function() {
      var rules = this.component.getAllProperties('rrule');
      var i = 0;
      var len = rules.length;
      var result = Object.create(null);

      for (; i < len; i++) {
        var value = rules[i].getFirstValue();
        result[value.freq] = true;
      }

      return result;
    },

    /**
     * The uid of this event
     * @type {String}
     */
    get uid() {
      return this._firstProp('uid');
    },

    set uid(value) {
      this._setProp('uid', value);
    },

    /**
     * The start date
     * @type {ICAL.Time}
     */
    get startDate() {
      return this._firstProp('dtstart');
    },

    set startDate(value) {
      this._setTime('dtstart', value);
    },

    /**
     * The end date. This can be the result directly from the property, or the
     * end date calculated from start date and duration. Setting the property
     * will remove any duration properties.
     * @type {ICAL.Time}
     */
    get endDate() {
      var endDate = this._firstProp('dtend');
      if (!endDate) {
          var duration = this._firstProp('duration');
          endDate = this.startDate.clone();
          if (duration) {
              endDate.addDuration(duration);
          } else if (endDate.isDate) {
              endDate.day += 1;
          }
      }
      return endDate;
    },

    set endDate(value) {
      if (this.component.hasProperty('duration')) {
        this.component.removeProperty('duration');
      }
      this._setTime('dtend', value);
    },

    /**
     * The duration. This can be the result directly from the property, or the
     * duration calculated from start date and end date. Setting the property
     * will remove any `dtend` properties.
     * @type {ICAL.Duration}
     */
    get duration() {
      var duration = this._firstProp('duration');
      if (!duration) {
        return this.endDate.subtractDate(this.startDate);
      }
      return duration;
    },

    set duration(value) {
      if (this.component.hasProperty('dtend')) {
        this.component.removeProperty('dtend');
      }

      this._setProp('duration', value);
    },

    /**
     * The location of the event.
     * @type {String}
     */
    get location() {
      return this._firstProp('location');
    },

    set location(value) {
      return this._setProp('location', value);
    },

    /**
     * The attendees in the event
     * @type {ICAL.Property[]}
     * @readonly
     */
    get attendees() {
      //XXX: This is way lame we should have a better
      //     data structure for this later.
      return this.component.getAllProperties('attendee');
    },


    /**
     * The event summary
     * @type {String}
     */
    get summary() {
      return this._firstProp('summary');
    },

    set summary(value) {
      this._setProp('summary', value);
    },

    /**
     * The event description.
     * @type {String}
     */
    get description() {
      return this._firstProp('description');
    },

    set description(value) {
      this._setProp('description', value);
    },

    /**
     * The organizer value as an uri. In most cases this is a mailto: uri, but
     * it can also be something else, like urn:uuid:...
     * @type {String}
     */
    get organizer() {
      return this._firstProp('organizer');
    },

    set organizer(value) {
      this._setProp('organizer', value);
    },

    /**
     * The sequence value for this event. Used for scheduling
     * see {@tutorial terminology}.
     * @type {Number}
     */
    get sequence() {
      return this._firstProp('sequence');
    },

    set sequence(value) {
      this._setProp('sequence', value);
    },

    /**
     * The recurrence id for this event. See {@tutorial terminology} for details.
     * @type {ICAL.Time}
     */
    get recurrenceId() {
      return this._firstProp('recurrence-id');
    },

    set recurrenceId(value) {
      this._setProp('recurrence-id', value);
    },

    /**
     * Set/update a time property's value.
     * This will also update the TZID of the property.
     *
     * TODO: this method handles the case where we are switching
     * from a known timezone to an implied timezone (one without TZID).
     * This does _not_ handle the case of moving between a known
     *  (by TimezoneService) timezone to an unknown timezone...
     *
     * We will not add/remove/update the VTIMEZONE subcomponents
     *  leading to invalid ICAL data...
     * @private
     * @param {String} propName     The property name
     * @param {ICAL.Time} time      The time to set
     */
    _setTime: function(propName, time) {
      var prop = this.component.getFirstProperty(propName);

      if (!prop) {
        prop = new ICAL.Property(propName);
        this.component.addProperty(prop);
      }

      // utc and local don't get a tzid
      if (
        time.zone === ICAL.Timezone.localTimezone ||
        time.zone === ICAL.Timezone.utcTimezone
      ) {
        // remove the tzid
        prop.removeParameter('tzid');
      } else {
        prop.setParameter('tzid', time.zone.tzid);
      }

      prop.setValue(time);
    },

    _setProp: function(name, value) {
      this.component.updatePropertyWithValue(name, value);
    },

    _firstProp: function(name) {
      return this.component.getFirstPropertyValue(name);
    },

    /**
     * The string representation of this event.
     * @return {String}
     */
    toString: function() {
      return this.component.toString();
    }

  };

  function compareRangeException(a, b) {
    if (a[0] > b[0]) return 1;
    if (b[0] > a[0]) return -1;
    return 0;
  }

  return Event;
}());
/* This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/.
 * Portions Copyright (C) Philipp Kewisch, 2011-2015 */


/**
 * This symbol is further described later on
 * @ignore
 */
ICAL.ComponentParser = (function() {
  /**
   * @classdesc
   * The ComponentParser is used to process a String or jCal Object,
   * firing callbacks for various found components, as well as completion.
   *
   * @example
   * var options = {
   *   // when false no events will be emitted for type
   *   parseEvent: true,
   *   parseTimezone: true
   * };
   *
   * var parser = new ICAL.ComponentParser(options);
   *
   * parser.onevent(eventComponent) {
   *   //...
   * }
   *
   * // ontimezone, etc...
   *
   * parser.oncomplete = function() {
   *
   * };
   *
   * parser.process(stringOrComponent);
   *
   * @class
   * @alias ICAL.ComponentParser
   * @param {Object=} options        Component parser options
   * @param {Boolean} options.parseEvent        Whether events should be parsed
   * @param {Boolean} options.parseTimezeone    Whether timezones should be parsed
   */
  function ComponentParser(options) {
    if (typeof(options) === 'undefined') {
      options = {};
    }

    var key;
    for (key in options) {
      /* istanbul ignore else */
      if (options.hasOwnProperty(key)) {
        this[key] = options[key];
      }
    }
  }

  ComponentParser.prototype = {

    /**
     * When true, parse events
     *
     * @type {Boolean}
     */
    parseEvent: true,

    /**
     * When true, parse timezones
     *
     * @type {Boolean}
     */
    parseTimezone: true,


    /* SAX like events here for reference */

    /**
     * Fired when parsing is complete
     * @callback
     */
    oncomplete: /* istanbul ignore next */ function() {},

    /**
     * Fired if an error occurs during parsing.
     *
     * @callback
     * @param {Error} err details of error
     */
    onerror: /* istanbul ignore next */ function(err) {},

    /**
     * Fired when a top level component (VTIMEZONE) is found
     *
     * @callback
     * @param {ICAL.Timezone} component     Timezone object
     */
    ontimezone: /* istanbul ignore next */ function(component) {},

    /**
     * Fired when a top level component (VEVENT) is found.
     *
     * @callback
     * @param {ICAL.Event} component    Top level component
     */
    onevent: /* istanbul ignore next */ function(component) {},

    /**
     * Process a string or parse ical object.  This function itself will return
     * nothing but will start the parsing process.
     *
     * Events must be registered prior to calling this method.
     *
     * @param {ICAL.Component|String|Object} ical      The component to process,
     *        either in its final form, as a jCal Object, or string representation
     */
    process: function(ical) {
      //TODO: this is sync now in the future we will have a incremental parser.
      if (typeof(ical) === 'string') {
        ical = ICAL.parse(ical);
      }

      if (!(ical instanceof ICAL.Component)) {
        ical = new ICAL.Component(ical);
      }

      var components = ical.getAllSubcomponents();
      var i = 0;
      var len = components.length;
      var component;

      for (; i < len; i++) {
        component = components[i];

        switch (component.name) {
          case 'vtimezone':
            if (this.parseTimezone) {
              var tzid = component.getFirstPropertyValue('tzid');
              if (tzid) {
                this.ontimezone(new ICAL.Timezone({
                  tzid: tzid,
                  component: component
                }));
              }
            }
            break;
          case 'vevent':
            if (this.parseEvent) {
              this.onevent(new ICAL.Event(component));
            }
            break;
          default:
            continue;
        }
      }

      //XXX: ideally we should do a "nextTick" here
      //     so in all cases this is actually async.
      this.oncomplete();
    }
  };

  return ComponentParser;
}());


/***/ }),
/* 1788 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CountriesList = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ListItem = __webpack_require__(894);

var _ListItem2 = _interopRequireDefault(_ListItem);

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CountriesList = exports.CountriesList = function (_TemplateView) {
    _inherits(CountriesList, _TemplateView);

    function CountriesList(_ref) {
        var _ref$onCountrySelecte = _ref.onCountrySelected,
            onCountrySelected = _ref$onCountrySelecte === undefined ? function (countryId) {} : _ref$onCountrySelecte;

        _classCallCheck(this, CountriesList);

        var _this = _possibleConstructorReturn(this, (CountriesList.__proto__ || Object.getPrototypeOf(CountriesList)).call(this));

        _this.callbacks = {
            onCountrySelected: onCountrySelected
        };

        _this.state = {
            defaultTimeZoneCountry: null,
            countries: []
        };

        _this.onStatePropertyChanged('countries', function () {
            return _this._updateList();
        });
        _this.onStatePropertyChanged('defaultTimeZoneCountry', function (defaultTimeZoneCountry) {
            _this.$defaultTimeZoneCountry.toggle(defaultTimeZoneCountry !== null);
            if (defaultTimeZoneCountry !== null) _this.$defaultTimeZoneCountry.text(defaultTimeZoneCountry.name);
        });
        return _this;
    }

    _createClass(CountriesList, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class="countriesListWrapper">' + '    <div class="defaultTimeZoneCountry"/>' + '    <div class="countriesList"/>' + '</div>';
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            var _this2 = this;

            this.$defaultTimeZoneCountry = this.find('.defaultTimeZoneCountry');
            this.$countriesList = this.find('.countriesList');

            this.$defaultTimeZoneCountry.on('click', function () {
                return _this2.callbacks.onCountrySelected(_this2.state.defaultTimeZoneCountry);
            });
        }
    }, {
        key: '_updateList',
        value: function _updateList() {
            var _this3 = this;

            this.$countriesList.empty();

            this.state.countries.forEach(function (country) {
                new _ListItem2.default({
                    text: country.name,
                    onClick: function onClick() {
                        return _this3.callbacks.onCountrySelected(country);
                    }
                }).init(_this3.$countriesList);
            });
        }
    }]);

    return CountriesList;
}(_TemplateView3.default);

/***/ }),
/* 1789 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _Month = __webpack_require__(1790);

var _Month2 = _interopRequireDefault(_Month);

var _selectors = __webpack_require__(212);

var _actions = __webpack_require__(213);

var _utils = __webpack_require__(6);

var _constants = __webpack_require__(116);

var _redux = __webpack_require__(7);

var _CorporateHolidayEditor = __webpack_require__(1793);

var _CorporateHolidayEditor2 = _interopRequireDefault(_CorporateHolidayEditor);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _RegularNonworkingDayEditor = __webpack_require__(1794);

var _RegularNonworkingDayEditor2 = _interopRequireDefault(_RegularNonworkingDayEditor);

var _SimpleDiv = __webpack_require__(569);

var _SimpleDiv2 = _interopRequireDefault(_SimpleDiv);

var _selectors2 = __webpack_require__(19);

var _WorkingDayEditor = __webpack_require__(1795);

var _WorkingDayEditor2 = _interopRequireDefault(_WorkingDayEditor);

var _ConfirmationDropdown = __webpack_require__(1796);

var _ConfirmationDropdown2 = _interopRequireDefault(_ConfirmationDropdown);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Calendar = function (_TemplateView) {
    _inherits(Calendar, _TemplateView);

    function Calendar(_ref) {
        var leaveBlackoutEnabled = _ref.leaveBlackoutEnabled,
            _ref$addCorporateDay = _ref.addCorporateDay,
            addCorporateDay = _ref$addCorporateDay === undefined ? function () {} : _ref$addCorporateDay,
            _ref$deleteCorporateD = _ref.deleteCorporateDay,
            deleteCorporateDay = _ref$deleteCorporateD === undefined ? function () {} : _ref$deleteCorporateD,
            _ref$addLeaveBlackout = _ref.addLeaveBlackoutDay,
            addLeaveBlackoutDay = _ref$addLeaveBlackout === undefined ? function () {} : _ref$addLeaveBlackout,
            _ref$deleteLeaveBlack = _ref.deleteLeaveBlackoutDay,
            deleteLeaveBlackoutDay = _ref$deleteLeaveBlack === undefined ? function () {} : _ref$deleteLeaveBlack,
            _ref$deleteLeaveBlack2 = _ref.deleteLeaveBlackoutAndAddCorporateDay,
            deleteLeaveBlackoutAndAddCorporateDay = _ref$deleteLeaveBlack2 === undefined ? function () {} : _ref$deleteLeaveBlack2;

        _classCallCheck(this, Calendar);

        var _this = _possibleConstructorReturn(this, (Calendar.__proto__ || Object.getPrototypeOf(Calendar)).call(this));

        _this.actions = {
            addCorporateDay: addCorporateDay,
            deleteCorporateDay: deleteCorporateDay,
            addLeaveBlackoutDay: addLeaveBlackoutDay,
            deleteLeaveBlackoutDay: deleteLeaveBlackoutDay,
            deleteLeaveBlackoutAndAddCorporateDay: deleteLeaveBlackoutAndAddCorporateDay
        };

        _this.state = {
            defaultWorkSchedules: [],
            corporateDays: {},
            leaveBlackoutDays: {},
            selectedYear: _constants.WORK_SCHEDULE_YEAR_START,
            canManage: false,
            leaveBlackoutEnabled: leaveBlackoutEnabled
        };

        _this.months = {};

        _this._leaveBlackoutEnabled = leaveBlackoutEnabled;

        _this.onAnyStatePropertyChanged(['defaultWorkSchedules', 'selectedYear', 'canManage'], function () {
            return _this.updateCalendar();
        });

        _this.onAnyStatePropertyChanged(['corporateDays', 'leaveBlackoutDays'], function () {
            if (_underscore2.default.size(_this.months) > 0) {
                for (var i = 0; i < 12; i++) {
                    var monthDate = new Date(_this.state.selectedYear, i);
                    var corporateDays = {};
                    var leaveBlackoutDays = {};
                    if (_this.state.corporateDays) {
                        corporateDays = _this.state.corporateDays[i] || {};
                    }
                    if (_this.state.leaveBlackoutDays) {
                        leaveBlackoutDays = _this.state.leaveBlackoutDays[i] || {};
                    }
                    _this.months[monthDate].setState({
                        corporateDays: corporateDays,
                        leaveBlackoutDays: leaveBlackoutDays
                    });
                }
            }
        });
        return _this;
    }

    _createClass(Calendar, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class="monthsContainer">' + '</div>';
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            this.confirmationDropdown = new _ConfirmationDropdown2.default().init((0, _jquery2.default)('body'));

            this.updateCalendar();
        }
    }, {
        key: 'updateCalendar',
        value: function updateCalendar() {
            var _this2 = this;

            this.getEl().empty();
            var currentDate = window.currentUserTime();
            currentDate.clearTime();

            if (this.state.defaultWorkSchedules.length > 0) {
                for (var i = 0; i < 12; i++) {
                    var monthDate = new Date(this.state.selectedYear, i);

                    var month = new _Month2.default({
                        firstMonthDate: monthDate.getFirstDateOfMonth(),
                        weekStartDay: SystemSettings.weekStartDay,
                        defaultWorkSchedules: this.state.defaultWorkSchedules,
                        currentDate: currentDate,
                        editable: this.state.canManage,
                        onDayClick: function onDayClick(day, date, nonWorking, leaveBlackout, status, title) {
                            return _this2.handleDayClick(day, date, nonWorking, leaveBlackout, status, title);
                        }

                    }).init(this.getEl());

                    var corporateDays = {};
                    var leaveBlackoutDays = {};

                    if (this.state.corporateDays) {
                        corporateDays = this.state.corporateDays[i] || {};
                    }
                    if (this.state.leaveBlackoutDays) {
                        leaveBlackoutDays = this.state.leaveBlackoutDays[i] || {};
                    }
                    month.setState({
                        corporateDays: corporateDays,
                        leaveBlackoutDays: leaveBlackoutDays
                    });

                    this.months[monthDate] = month;
                }
            }

            //add empty month elements for proper positioning
            for (var n = 0; n < 4; n++) {
                new _SimpleDiv2.default({
                    additionalClass: 'components_month emptyMonth'
                }).init(this.getEl());
            }

            var $body = (0, _jquery2.default)('body');
            this.corporateHolidayEditor = new _CorporateHolidayEditor2.default({
                editCallback: function editCallback(date, isWorking, title) {
                    return _this2.actions.addCorporateDay(date, isWorking, title);
                },
                deleteCallback: function deleteCallback(date) {
                    return _this2.actions.deleteCorporateDay(date);
                }
            }).init($body);

            this.regularNonworkingDayEditor = new _RegularNonworkingDayEditor2.default({
                leaveBlackoutEnabled: this._leaveBlackoutEnabled,
                editCorporateCallback: function editCorporateCallback(date, isWorking, title, isLeaveBlackout) {
                    if (isLeaveBlackout && !isWorking) _this2.actions.deleteLeaveBlackoutAndAddCorporateDay(date, isWorking, title);else _this2.actions.addCorporateDay(date, isWorking, title);
                },
                deleteCorporateCallback: function deleteCorporateCallback(date) {
                    return _this2.actions.deleteCorporateDay(date);
                },
                addLeaveBlackoutCallback: function addLeaveBlackoutCallback(date) {
                    return _this2.actions.addLeaveBlackoutDay(date);
                },
                deleteLeaevBlackoutCallback: function deleteLeaevBlackoutCallback(date) {
                    return _this2.actions.deleteLeaveBlackoutDay(date);
                },
                openDeleteNonApprovedLeaveRequestsConfirmationCallback: function openDeleteNonApprovedLeaveRequestsConfirmationCallback(element, date, nonApprovedLeaveRequestsCount) {
                    return _this2._openDeleteNonApprovedLeaveRequestsConfirmation(element, date, nonApprovedLeaveRequestsCount);
                }
            }).init($body);

            this.workingDayEditor = new _WorkingDayEditor2.default({
                leaveBlackoutEnabled: this._leaveBlackoutEnabled,
                addCorporateCallback: function addCorporateCallback(date, isLeaveBlackout) {
                    if (isLeaveBlackout) _this2.actions.deleteLeaveBlackoutAndAddCorporateDay(date, false, _messageResource2.default.getMessage('work_schedule.corporate_holiday'));else _this2.actions.addCorporateDay(date, false, _messageResource2.default.getMessage('work_schedule.corporate_holiday'));
                },
                deleteCorporateCallback: function deleteCorporateCallback(date) {
                    return _this2.actions.deleteCorporateDay(date);
                },
                addLeaveBlackoutCallback: function addLeaveBlackoutCallback(date) {
                    return _this2.actions.addLeaveBlackoutDay(date);
                },
                deleteLeaevBlackoutCallback: function deleteLeaevBlackoutCallback(date) {
                    return _this2.actions.deleteLeaveBlackoutDay(date);
                },
                openDeleteNonApprovedLeaveRequestsConfirmationCallback: function openDeleteNonApprovedLeaveRequestsConfirmationCallback(element, date, nonApprovedLeaveRequestsCount) {
                    return _this2._openDeleteNonApprovedLeaveRequestsConfirmation(element, date, nonApprovedLeaveRequestsCount);
                }
            }).init($body);
        }
    }, {
        key: 'handleDayClick',
        value: function handleDayClick(day, date, nonWorking, isLeaveBlackout, status) {
            var title = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';

            if (!nonWorking && status === _constants.dayStatuses.STANDARD_DAY) {
                this.workingDayEditor.setState({
                    date: date,
                    title: title,
                    showMarkAsWorkingButton: nonWorking,
                    isLeaveBlackout: isLeaveBlackout
                });
                this._openEditor(this.workingDayEditor, day);
            } else if (status === _constants.dayStatuses.CORPORATE_HOLIDAY) {
                this.corporateHolidayEditor.setState({
                    date: date,
                    title: title,
                    showMarkAsWorkingButton: nonWorking
                });
                this._openEditor(this.corporateHolidayEditor, day);
            } else if (nonWorking) {
                this.regularNonworkingDayEditor.setState({
                    date: date,
                    nonStandardWorking: status === _constants.dayStatuses.NON_STANDARD_WORKING_DAY,
                    isLeaveBlackout: isLeaveBlackout
                });
                this._openEditor(this.regularNonworkingDayEditor, day);
            }
        }
    }, {
        key: '_openEditor',
        value: function _openEditor(editor, day) {
            editor.setOnHideCallback(function () {
                return day.setState({ editing: false });
            });
            editor.setOnShowCallback(function () {
                return day.setState({ editing: true });
            });
            editor.showAt(day.$el);
        }
    }, {
        key: '_openDeleteNonApprovedLeaveRequestsConfirmation',
        value: function _openDeleteNonApprovedLeaveRequestsConfirmation(element, date, nonApprovedLeaveRequestsCount) {
            var _this3 = this;

            this.confirmationDropdown.setProps(date, function () {
                _this3.actions.addLeaveBlackoutDay(date);
            }, nonApprovedLeaveRequestsCount);
            this.confirmationDropdown.showAt(element);
        }
    }]);

    return Calendar;
}(_TemplateView3.default);

exports.default = (0, _utils.connect)(function (state) {
    return {
        defaultWorkSchedules: (0, _selectors.getDefaultWorkSchedule)(state),
        corporateDays: (0, _selectors.getCorporateDaysForSelectedYear)(state),
        leaveBlackoutDays: (0, _selectors.getLeaveBlackoutDaysForSelectedYear)(state),
        selectedYear: (0, _selectors.geSelectedYear)(state),
        canManage: (0, _selectors2.canManageSystemSettings)(state)
    };
}, function (dispatch) {
    return {
        addCorporateDay: (0, _redux.bindActionCreators)(_actions.addCorporateDay, dispatch),
        deleteCorporateDay: (0, _redux.bindActionCreators)(_actions.deleteCorporateDay, dispatch),
        addLeaveBlackoutDay: (0, _redux.bindActionCreators)(_actions.addLeaveBlackoutDay, dispatch),
        deleteLeaveBlackoutDay: (0, _redux.bindActionCreators)(_actions.deleteLeaveBlackoutDay, dispatch),
        deleteLeaveBlackoutAndAddCorporateDay: (0, _redux.bindActionCreators)(_actions.deleteLeaveBlackoutAndAddCorporateDay, dispatch)
    };
})(Calendar);

/***/ }),
/* 1790 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _Day = __webpack_require__(1791);

var _Day2 = _interopRequireDefault(_Day);

var _constants = __webpack_require__(116);

var _utils = __webpack_require__(85);

var _MonthHeaderDay = __webpack_require__(1792);

var _MonthHeaderDay2 = _interopRequireDefault(_MonthHeaderDay);

var _SimpleDiv = __webpack_require__(569);

var _SimpleDiv2 = _interopRequireDefault(_SimpleDiv);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Month = function (_TemplateView) {
    _inherits(Month, _TemplateView);

    function Month() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            _ref$additionalClass = _ref.additionalClass,
            additionalClass = _ref$additionalClass === undefined ? '' : _ref$additionalClass,
            _ref$firstMonthDate = _ref.firstMonthDate,
            firstMonthDate = _ref$firstMonthDate === undefined ? null : _ref$firstMonthDate,
            _ref$currentDate = _ref.currentDate,
            currentDate = _ref$currentDate === undefined ? new Date() : _ref$currentDate,
            _ref$weekStartDay = _ref.weekStartDay,
            weekStartDay = _ref$weekStartDay === undefined ? 1 : _ref$weekStartDay,
            _ref$defaultWorkSched = _ref.defaultWorkSchedules,
            defaultWorkSchedules = _ref$defaultWorkSched === undefined ? [] : _ref$defaultWorkSched,
            _ref$editable = _ref.editable,
            editable = _ref$editable === undefined ? false : _ref$editable,
            _ref$onDayClick = _ref.onDayClick,
            onDayClick = _ref$onDayClick === undefined ? function () {} : _ref$onDayClick;

        _classCallCheck(this, Month);

        var _this = _possibleConstructorReturn(this, (Month.__proto__ || Object.getPrototypeOf(Month)).call(this));

        _this.params = {
            additionalClass: additionalClass,
            firstMonthDate: firstMonthDate,
            currentDate: currentDate,
            weekStartDay: weekStartDay - 1,
            defaultWorkSchedules: defaultWorkSchedules,
            editable: editable
        };

        _this.callbacks = {
            onDayClick: onDayClick
        };

        _this.state = {
            corporateDays: {},
            leaveBlackoutDays: {}
        };

        _this.days = {};

        _this.onStatePropertyChanged('corporateDays', function (corporateDays) {
            for (var date in corporateDays) {
                var status = _constants.dayStatuses.STANDARD_DAY;
                if (corporateDays[date].working) status = _constants.dayStatuses.NON_STANDARD_WORKING_DAY;else status = _constants.dayStatuses.CORPORATE_HOLIDAY;

                _this.days[date].setState({
                    status: status,
                    title: corporateDays[date].name
                });
            }
        });

        _this.onStatePropertyChanged('leaveBlackoutDays', function (leaveBlackoutDays) {
            for (var date in leaveBlackoutDays) {
                _this.days[date].setState({
                    leaveBlackout: leaveBlackoutDays[date]
                });
            }
        });
        return _this;
    }

    _createClass(Month, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return "<div class='components_month <%-additionalClass%>'>" + "    <div class='monthName'><%=monthName%></div>" + "    <div class='monthDaysHeader'></div>" + "    <div class='monthDays'></div>" + "</div>";
        }
    }, {
        key: 'templateModel',
        value: function templateModel() {
            return {
                additionalClass: this.params.additionalClass
            };
        }
    }, {
        key: 'messageKeys',
        value: function messageKeys() {
            return {
                monthName: (0, _utils.getMonthNameKey)(this.params.firstMonthDate.getMonth())
            };
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            this.$monthDaysHeader = this.find('.monthDaysHeader');
            this.$monthDays = this.find('.monthDays');

            for (var n = 0; n < 7; n++) {
                new _MonthHeaderDay2.default({
                    dayNum: (this.params.weekStartDay + n) % 7
                }).init(this.$monthDaysHeader);
            }

            //add empty date cells
            for (var _n = 0; _n < (7 + this.params.firstMonthDate.getFirstDayOfMonth() - this.params.weekStartDay) % 7; _n++) {
                new _SimpleDiv2.default({
                    additionalClass: 'components_day monthEmptyDay'
                }).init(this.$monthDays);
            }

            var currentDay = void 0;
            for (var i = new _utils.DayIteratorWithWorkSchedule(this.params.firstMonthDate, this.params.firstMonthDate.getLastDateOfMonth(), this.params.defaultWorkSchedules); i.hasNext();) {
                currentDay = i.next();
                this.days[currentDay.date.getDate()] = new _Day2.default(_extends({
                    additionalClass: 'monthDay',
                    editable: this.params.editable,
                    onClick: this.callbacks.onDayClick
                }, currentDay)).init(this.$monthDays);
            }

            var currentMonth = (0, _utils.isSameMonth)(this.params.firstMonthDate, this.params.currentDate);
            this.$el.toggleClass('current', currentMonth);
            if (currentMonth) {
                this.days[this.params.currentDate.getDate()].setState({
                    current: true
                });
            }
        }
    }]);

    return Month;
}(_TemplateView3.default);

exports.default = Month;

/***/ }),
/* 1791 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _constants = __webpack_require__(116);

var _SimpleSingletonTooltip = __webpack_require__(45);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _atUtils = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Day = function (_TemplateView) {
    _inherits(Day, _TemplateView);

    function Day() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            _ref$additionalClass = _ref.additionalClass,
            additionalClass = _ref$additionalClass === undefined ? '' : _ref$additionalClass,
            _ref$date = _ref.date,
            date = _ref$date === undefined ? null : _ref$date,
            _ref$nonWorking = _ref.nonWorking,
            nonWorking = _ref$nonWorking === undefined ? false : _ref$nonWorking,
            _ref$onClick = _ref.onClick,
            onClick = _ref$onClick === undefined ? function () {} : _ref$onClick,
            _ref$editable = _ref.editable,
            editable = _ref$editable === undefined ? false : _ref$editable;

        _classCallCheck(this, Day);

        var _this = _possibleConstructorReturn(this, (Day.__proto__ || Object.getPrototypeOf(Day)).call(this));

        _this.params = {
            additionalClass: additionalClass,
            date: date,
            nonWorking: nonWorking,
            editable: editable
        };

        _this.callbacks = {
            onClick: onClick
        };

        _this.state = {
            current: false,
            status: _constants.dayStatuses.STANDARD_DAY,
            title: '',
            leaveBlackout: false,
            editing: false
        };

        _this.onStatePropertyChanged('current', function () {
            return _this.$el.toggleClass('current', _this.state.current);
        });
        _this.onStatePropertyChanged('leaveBlackout', function () {
            return _this.$el.toggleClass('leaveBlackout', _this.state.leaveBlackout);
        });
        _this.onStatePropertyChanged('editing', function () {
            _this.$el.toggleClass('editing', _this.state.editing);
            _this.state.editing && (0, _SimpleSingletonTooltip.getInstance)().hide();
        });

        _this.onStatePropertyChanged('status', function () {
            _this.$el.toggleClass('nonWorking', _this.params.nonWorking && _this.state.status !== _constants.dayStatuses.NON_STANDARD_WORKING_DAY);
            _this.$el.toggleClass('corporateHoliday', _this.state.status === _constants.dayStatuses.CORPORATE_HOLIDAY);
            _this._updateTooltip();
        });
        return _this;
    }

    _createClass(Day, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return "<div class='components_day <%-additionalClass%>'><%=dayNumber%></div>";
        }
    }, {
        key: 'templateModel',
        value: function templateModel() {
            return {
                additionalClass: this.params.additionalClass,
                dayNumber: this.params.date.getDate()
            };
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            var _this2 = this;

            this.getEl().toggleClass('nonWorking', this.params.nonWorking);
            this.getEl().toggleClass('editable', this.params.editable);
            if (this.params.editable) {
                this.getEl().click(function () {
                    return _this2.callbacks.onClick(_this2, _this2.params.date, _this2.params.nonWorking, _this2.state.leaveBlackout, _this2.state.status, _this2.state.title);
                });
            }

            this._updateTooltip();
        }
    }, {
        key: '_updateTooltip',
        value: function _updateTooltip() {
            var _this3 = this;

            if (this.params.editable || this.state.status === _constants.dayStatuses.CORPORATE_HOLIDAY) {
                (0, _SimpleSingletonTooltip.getInstance)().subscribeToMouseEvents(this.getEl(), function () {
                    if (_this3.state.editing) {
                        (0, _SimpleSingletonTooltip.getInstance)().disable();
                    } else {
                        (0, _SimpleSingletonTooltip.getInstance)().enable();
                        (0, _SimpleSingletonTooltip.getInstance)().setState({
                            html: _this3._getDayTooltipHtml(),
                            extraClass: "calendarDayTooltip"
                        });
                    }
                });
            }
        }
    }, {
        key: '_getDayTooltipHtml',
        value: function _getDayTooltipHtml() {
            var tooltipText = this.state.leaveBlackout ? _messageResource2.default.getMessage('work_schedule.working_day_with_leave_blackout_txt') : _messageResource2.default.getMessage('work_schedule.working_day_txt');

            if (this.state.status === _constants.dayStatuses.CORPORATE_HOLIDAY) tooltipText = (0, _atUtils.escapeHtmlSymbols)(this.state.title);else if (this.params.nonWorking && this.state.status !== _constants.dayStatuses.NON_STANDARD_WORKING_DAY) tooltipText = this.state.leaveBlackout ? _messageResource2.default.getMessage('work_schedule.nonworking_day_with_leave_blackout_txt') : _messageResource2.default.getMessage('work_schedule.nonworking_day_txt');

            var result = '<div class="dayStatus">' + tooltipText + '</div>';

            if (this.params.editable) {
                var tooltipNoteKey = 'work_schedule.click_to_edit';

                result += '<div class="note">' + _messageResource2.default.getMessage(tooltipNoteKey) + '</div>';
            }
            return result;
        }
    }]);

    return Day;
}(_TemplateView3.default);

exports.default = Day;

/***/ }),
/* 1792 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _utils = __webpack_require__(85);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MonthHeaderDay = function (_TemplateView) {
    _inherits(MonthHeaderDay, _TemplateView);

    function MonthHeaderDay() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            dayNum = _ref.dayNum;

        _classCallCheck(this, MonthHeaderDay);

        var _this = _possibleConstructorReturn(this, (MonthHeaderDay.__proto__ || Object.getPrototypeOf(MonthHeaderDay)).call(this));

        _this.params = {
            dayNum: dayNum
        };
        return _this;
    }

    _createClass(MonthHeaderDay, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return "<div class='monthHeaderDay'><%=dayShortName%></div>";
        }
    }, {
        key: 'messageKeys',
        value: function messageKeys() {
            return {
                dayShortName: (0, _utils.getAbbrDayNameKey)(this.params.dayNum)
            };
        }
    }]);

    return MonthHeaderDay;
}(_TemplateView3.default);

exports.default = MonthHeaderDay;

/***/ }),
/* 1793 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _DropdownTemplateView2 = __webpack_require__(42);

var _DropdownTemplateView3 = _interopRequireDefault(_DropdownTemplateView2);

var _atUtils = __webpack_require__(5);

var _constants = __webpack_require__(116);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _SimpleMenu = __webpack_require__(402);

var _SimpleMenu2 = _interopRequireDefault(_SimpleMenu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CorporateHolidayEditor = function (_DropdownTemplateView) {
    _inherits(CorporateHolidayEditor, _DropdownTemplateView);

    function CorporateHolidayEditor() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            _ref$editCallback = _ref.editCallback,
            editCallback = _ref$editCallback === undefined ? function () {} : _ref$editCallback,
            _ref$deleteCallback = _ref.deleteCallback,
            deleteCallback = _ref$deleteCallback === undefined ? function () {} : _ref$deleteCallback;

        _classCallCheck(this, CorporateHolidayEditor);

        var _this = _possibleConstructorReturn(this, (CorporateHolidayEditor.__proto__ || Object.getPrototypeOf(CorporateHolidayEditor)).call(this));

        _this.callbacks = {
            editCallback: editCallback,
            deleteCallback: deleteCallback
        };

        _this.state = {
            date: null,
            title: '',
            showMarkAsWorkingButton: false,
            mode: _constants.corporateHolidayEditorModes.CHANGE_NAME
        };

        _this.onStatePropertyChanged('showMarkAsWorkingButton', function (show) {
            return _this.$markAsRegularNonworkingButton.toggle(show);
        });

        _this.onStatePropertyChanged('title', function (title) {
            _this.$title.pVal(title);
        });
        return _this;
    }

    _createClass(CorporateHolidayEditor, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class="corporateHolidayEditor"></div>';
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            var _this2 = this;

            this.simpleMenu = new _SimpleMenu2.default().init(this.$el);

            var holidayEditor = (0, _jquery2.default)('<div class="editorSection">' + '    <input class="titleInput" type="text" maxlength="80"/>' + '</div>');
            holidayEditor.appendTo(this.simpleMenu.$el);
            this.$title = this.find('.titleInput');

            this.$markAsRegularNonworkingButton = new _SimpleMenu.Option({
                onSelected: function onSelected() {
                    _this2.setStateInternal({
                        mode: _constants.corporateHolidayEditorModes.DELETE
                    });
                    _this2.callbacks.deleteCallback(_this2.state.date);
                    _this2.hide();
                }
            }).init(this.simpleMenu.$el);
            this.$markAsRegularNonworkingButton.toggle(false);
            this.$markAsRegularNonworkingButton.setState({
                title: _messageResource2.default.getMessage('work_schedule.mark_as_regular_nonworking_day')
            });

            this.$markAsWorkingButton = new _SimpleMenu.Option({
                onSelected: function onSelected() {
                    if (_this2.state.showMarkAsWorkingButton) {
                        _this2.setStateInternal({
                            mode: _constants.corporateHolidayEditorModes.MARK_AS_WORKING
                        });
                        _this2.callbacks.editCallback(_this2.state.date, true, '');
                    } else {
                        _this2.setStateInternal({
                            mode: _constants.corporateHolidayEditorModes.DELETE
                        });
                        _this2.callbacks.deleteCallback(_this2.state.date);
                    }
                    _this2.hide();
                }
            }).init(this.simpleMenu.$el);
            this.$markAsWorkingButton.setState({
                title: _messageResource2.default.getMessage('work_schedule.mark_as_working_day')
            });

            this.renderInitialState();
        }
    }, {
        key: 'onShow',
        value: function onShow() {
            _get(CorporateHolidayEditor.prototype.__proto__ || Object.getPrototypeOf(CorporateHolidayEditor.prototype), 'onShow', this).call(this);
            this.onShowCallback();
            this.setStateInternal({
                mode: _constants.corporateHolidayEditorModes.CHANGE_NAME
            });
        }
    }, {
        key: 'setOnShowCallback',
        value: function setOnShowCallback(callback) {
            this.onShowCallback = callback;
        }
    }, {
        key: 'onHide',
        value: function onHide() {
            _get(CorporateHolidayEditor.prototype.__proto__ || Object.getPrototypeOf(CorporateHolidayEditor.prototype), 'onHide', this).call(this);
            this.onHideCallback();
            if (this.state.mode === _constants.corporateHolidayEditorModes.CHANGE_NAME) {
                var newTitle = (0, _atUtils.trim)(this.$title.pVal()) === '' ? _messageResource2.default.getMessage('work_schedule.corporate_holiday') : (0, _atUtils.trim)(this.$title.pVal());
                if (this.state.title !== newTitle) this.callbacks.editCallback(this.state.date, false, newTitle);
            }
        }
    }, {
        key: 'setOnHideCallback',
        value: function setOnHideCallback(callback) {
            this.onHideCallback = callback;
        }
    }, {
        key: 'mouseDownTargetElement',
        value: function mouseDownTargetElement() {
            return (0, _jquery2.default)(document);
        }
    }]);

    return CorporateHolidayEditor;
}(_DropdownTemplateView3.default);

exports.default = CorporateHolidayEditor;

/***/ }),
/* 1794 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _DropdownTemplateView2 = __webpack_require__(42);

var _DropdownTemplateView3 = _interopRequireDefault(_DropdownTemplateView2);

var _SimpleMenu = __webpack_require__(402);

var _SimpleMenu2 = _interopRequireDefault(_SimpleMenu);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _ClassicBridge = __webpack_require__(18);

var _ClassicBridge2 = _interopRequireDefault(_ClassicBridge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RegularNonworkingDayEditor = function (_DropdownTemplateView) {
    _inherits(RegularNonworkingDayEditor, _DropdownTemplateView);

    function RegularNonworkingDayEditor() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            leaveBlackoutEnabled = _ref.leaveBlackoutEnabled,
            _ref$editCorporateCal = _ref.editCorporateCallback,
            editCorporateCallback = _ref$editCorporateCal === undefined ? function () {} : _ref$editCorporateCal,
            _ref$deleteCorporateC = _ref.deleteCorporateCallback,
            deleteCorporateCallback = _ref$deleteCorporateC === undefined ? function () {} : _ref$deleteCorporateC,
            _ref$addLeaveBlackout = _ref.addLeaveBlackoutCallback,
            addLeaveBlackoutCallback = _ref$addLeaveBlackout === undefined ? function () {} : _ref$addLeaveBlackout,
            _ref$deleteLeaevBlack = _ref.deleteLeaevBlackoutCallback,
            deleteLeaevBlackoutCallback = _ref$deleteLeaevBlack === undefined ? function () {} : _ref$deleteLeaevBlack,
            _ref$openDeleteNonApp = _ref.openDeleteNonApprovedLeaveRequestsConfirmationCallback,
            openDeleteNonApprovedLeaveRequestsConfirmationCallback = _ref$openDeleteNonApp === undefined ? function () {} : _ref$openDeleteNonApp;

        _classCallCheck(this, RegularNonworkingDayEditor);

        var _this = _possibleConstructorReturn(this, (RegularNonworkingDayEditor.__proto__ || Object.getPrototypeOf(RegularNonworkingDayEditor)).call(this));

        _this.callbacks = {
            editCorporateCallback: editCorporateCallback,
            deleteCorporateCallback: deleteCorporateCallback,
            addLeaveBlackoutCallback: addLeaveBlackoutCallback,
            deleteLeaevBlackoutCallback: deleteLeaevBlackoutCallback,
            openDeleteNonApprovedLeaveRequestsConfirmationCallback: openDeleteNonApprovedLeaveRequestsConfirmationCallback
        };

        _this.state = {
            date: null,
            nonStandardWorking: false,
            isLeaveBlackout: false
        };

        _this._leaveBlackoutEnabled = leaveBlackoutEnabled;

        _this.onStatePropertyChanged('nonStandardWorking', function (isWorking) {
            _this.$markAsWorkingButton.setState({
                title: _messageResource2.default.getMessage(isWorking ? 'work_schedule.mark_as_regular_nonworking_day' : 'work_schedule.mark_as_working_day')
            });
        });
        _this.onStatePropertyChanged('isLeaveBlackout', function (isLeaveBlackout) {
            if (_this._leaveBlackoutEnabled) {
                _this.$markAsLeaveBlackoutButton.setState({
                    title: _messageResource2.default.getMessage(isLeaveBlackout ? 'work_schedule.remove_leave_blackout' : 'work_schedule.set_leave_blackout')
                });
            }
        });
        return _this;
    }

    _createClass(RegularNonworkingDayEditor, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return "<div class='regularNonworkingDayEditorContainer' />";
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            var _this2 = this;

            this.simpleMenu = new _SimpleMenu2.default().init(this.$el);

            if (this._leaveBlackoutEnabled) {
                this.$markAsLeaveBlackoutButton = new _SimpleMenu.Option({
                    onSelected: function onSelected() {
                        if (_this2.state.isLeaveBlackout) {
                            _this2.callbacks.deleteLeaevBlackoutCallback(_this2.state.date);
                            _this2.hide();
                        } else {
                            _this2.$markAsLeaveBlackoutButton.setState({ isLoading: true });
                            _ClassicBridge2.default.getNonApprovedLeaveRequestsForDay(_this2.state.date).then(function (nonApprovedLeaveRequestsCount) {
                                if (nonApprovedLeaveRequestsCount) _this2.callbacks.openDeleteNonApprovedLeaveRequestsConfirmationCallback(_this2.$elementShowAt, _this2.state.date, nonApprovedLeaveRequestsCount);else _this2.callbacks.addLeaveBlackoutCallback(_this2.state.date);
                            }).finally(function () {
                                _this2.$markAsLeaveBlackoutButton.setState({ isLoading: false });
                                _this2.hide();
                            });
                        }
                    }
                }).init(this.simpleMenu.$el);
            }

            this.$markAsWorkingButton = new _SimpleMenu.Option({
                onSelected: function onSelected() {
                    if (_this2.state.nonStandardWorking) {
                        _this2.callbacks.deleteCorporateCallback(_this2.state.date);
                    } else {
                        _this2.callbacks.editCorporateCallback(_this2.state.date, true, '', _this2.state.isLeaveBlackout);
                    }
                    _this2.hide();
                }
            }).init(this.simpleMenu.$el);

            this.$markAsHolidayButton = new _SimpleMenu.Option({
                onSelected: function onSelected() {
                    _this2.callbacks.editCorporateCallback(_this2.state.date, false, _messageResource2.default.getMessage('work_schedule.corporate_holiday'), _this2.state.isLeaveBlackout);
                    _this2.hide();
                }
            }).init(this.simpleMenu.$el);

            this.$markAsHolidayButton.setState({
                title: _messageResource2.default.getMessage('work_schedule.mark_as_holiday')
            });

            this.renderInitialState();
        }
    }, {
        key: 'setOnHideCallback',
        value: function setOnHideCallback(callback) {
            this.onHideCallback = callback;
        }
    }, {
        key: 'setOnShowCallback',
        value: function setOnShowCallback(callback) {
            this.onShowCallback = callback;
        }
    }, {
        key: 'onHide',
        value: function onHide() {
            _get(RegularNonworkingDayEditor.prototype.__proto__ || Object.getPrototypeOf(RegularNonworkingDayEditor.prototype), 'onHide', this).call(this);
            this.onHideCallback();
        }
    }, {
        key: 'onShow',
        value: function onShow() {
            _get(RegularNonworkingDayEditor.prototype.__proto__ || Object.getPrototypeOf(RegularNonworkingDayEditor.prototype), 'onShow', this).call(this);
            this.onShowCallback();
        }
    }, {
        key: 'mouseDownTargetElement',
        value: function mouseDownTargetElement() {
            return (0, _jquery2.default)(document);
        }
    }]);

    return RegularNonworkingDayEditor;
}(_DropdownTemplateView3.default);

exports.default = RegularNonworkingDayEditor;

/***/ }),
/* 1795 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _DropdownTemplateView2 = __webpack_require__(42);

var _DropdownTemplateView3 = _interopRequireDefault(_DropdownTemplateView2);

var _SimpleMenu = __webpack_require__(402);

var _SimpleMenu2 = _interopRequireDefault(_SimpleMenu);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _ClassicBridge = __webpack_require__(18);

var _ClassicBridge2 = _interopRequireDefault(_ClassicBridge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var WorkingDayEditor = function (_DropdownTemplateView) {
    _inherits(WorkingDayEditor, _DropdownTemplateView);

    function WorkingDayEditor() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            leaveBlackoutEnabled = _ref.leaveBlackoutEnabled,
            _ref$addCorporateCall = _ref.addCorporateCallback,
            addCorporateCallback = _ref$addCorporateCall === undefined ? function () {} : _ref$addCorporateCall,
            _ref$deleteCorporateC = _ref.deleteCorporateCallback,
            deleteCorporateCallback = _ref$deleteCorporateC === undefined ? function () {} : _ref$deleteCorporateC,
            _ref$addLeaveBlackout = _ref.addLeaveBlackoutCallback,
            addLeaveBlackoutCallback = _ref$addLeaveBlackout === undefined ? function () {} : _ref$addLeaveBlackout,
            _ref$deleteLeaevBlack = _ref.deleteLeaevBlackoutCallback,
            deleteLeaevBlackoutCallback = _ref$deleteLeaevBlack === undefined ? function () {} : _ref$deleteLeaevBlack,
            _ref$openDeleteNonApp = _ref.openDeleteNonApprovedLeaveRequestsConfirmationCallback,
            openDeleteNonApprovedLeaveRequestsConfirmationCallback = _ref$openDeleteNonApp === undefined ? function () {} : _ref$openDeleteNonApp;

        _classCallCheck(this, WorkingDayEditor);

        var _this = _possibleConstructorReturn(this, (WorkingDayEditor.__proto__ || Object.getPrototypeOf(WorkingDayEditor)).call(this));

        _this.callbacks = {
            addCorporateCallback: addCorporateCallback,
            deleteCorporateCallback: deleteCorporateCallback,
            addLeaveBlackoutCallback: addLeaveBlackoutCallback,
            deleteLeaevBlackoutCallback: deleteLeaevBlackoutCallback,
            openDeleteNonApprovedLeaveRequestsConfirmationCallback: openDeleteNonApprovedLeaveRequestsConfirmationCallback
        };

        _this.state = {
            date: null,
            isLeaveBlackout: false
        };

        _this._leaveBlackoutEnabled = leaveBlackoutEnabled;

        _this.onStatePropertyChanged('isLeaveBlackout', function (isLeaveBlackout) {
            if (_this._leaveBlackoutEnabled) {
                _this.$markAsLeaveBlackoutButton.setState({
                    title: _messageResource2.default.getMessage(isLeaveBlackout ? 'work_schedule.remove_leave_blackout' : 'work_schedule.set_leave_blackout')
                });
            }
        });
        return _this;
    }

    _createClass(WorkingDayEditor, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return "<div class='regularNonworkingDayEditorContainer' />";
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            var _this2 = this;

            this.simpleMenu = new _SimpleMenu2.default().init(this.$el);

            if (this._leaveBlackoutEnabled) {
                this.$markAsLeaveBlackoutButton = new _SimpleMenu.Option({
                    onSelected: function onSelected() {
                        if (_this2.state.isLeaveBlackout) {
                            _this2.callbacks.deleteLeaevBlackoutCallback(_this2.state.date);
                            _this2.hide();
                        } else {
                            _this2.$markAsLeaveBlackoutButton.setState({ isLoading: true });
                            _ClassicBridge2.default.getNonApprovedLeaveRequestsForDay(_this2.state.date).then(function (nonApprovedLeaveRequestsCount) {
                                if (nonApprovedLeaveRequestsCount) _this2.callbacks.openDeleteNonApprovedLeaveRequestsConfirmationCallback(_this2.$elementShowAt, _this2.state.date, nonApprovedLeaveRequestsCount);else _this2.callbacks.addLeaveBlackoutCallback(_this2.state.date);
                            }).finally(function () {
                                _this2.$markAsLeaveBlackoutButton.setState({ isLoading: false });
                                _this2.hide();
                            });
                        }
                    }
                }).init(this.simpleMenu.$el);
            }

            this.$markAsHolidayButton = new _SimpleMenu.Option({
                onSelected: function onSelected() {
                    _this2.callbacks.addCorporateCallback(_this2.state.date, _this2.state.isLeaveBlackout);
                    _this2.hide();
                }
            }).init(this.simpleMenu.$el);
            this.$markAsHolidayButton.setState({
                title: _messageResource2.default.getMessage('work_schedule.mark_as_holiday')
            });

            this.renderInitialState();
        }
    }, {
        key: 'setOnHideCallback',
        value: function setOnHideCallback(callback) {
            this.onHideCallback = callback;
        }
    }, {
        key: 'setOnShowCallback',
        value: function setOnShowCallback(callback) {
            this.onShowCallback = callback;
        }
    }, {
        key: 'onHide',
        value: function onHide() {
            _get(WorkingDayEditor.prototype.__proto__ || Object.getPrototypeOf(WorkingDayEditor.prototype), 'onHide', this).call(this);
            this.onHideCallback();
        }
    }, {
        key: 'onShow',
        value: function onShow() {
            _get(WorkingDayEditor.prototype.__proto__ || Object.getPrototypeOf(WorkingDayEditor.prototype), 'onShow', this).call(this);
            this.onShowCallback();
        }
    }, {
        key: 'mouseDownTargetElement',
        value: function mouseDownTargetElement() {
            return (0, _jquery2.default)(document);
        }
    }]);

    return WorkingDayEditor;
}(_DropdownTemplateView3.default);

exports.default = WorkingDayEditor;

/***/ }),
/* 1796 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _DropdownTemplateView2 = __webpack_require__(42);

var _DropdownTemplateView3 = _interopRequireDefault(_DropdownTemplateView2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ConfirmationDropdown = function (_DropdownTemplateView) {
    _inherits(ConfirmationDropdown, _DropdownTemplateView);

    function ConfirmationDropdown() {
        _classCallCheck(this, ConfirmationDropdown);

        return _possibleConstructorReturn(this, (ConfirmationDropdown.__proto__ || Object.getPrototypeOf(ConfirmationDropdown)).call(this));
    }

    _createClass(ConfirmationDropdown, [{
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='leaveBlackoutConfirmation atNextMount' />";
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            var _this2 = this;

            this.$confirmationComponent = ClassicBridge.integrateMarkAsLeaveBlackoutConfirmation(this.$el[0], {
                onCancel: function onCancel() {
                    return _this2.hide();
                }
            });
            this.renderInitialState();
        }
    }, {
        key: "setProps",
        value: function setProps(date, onConfirmCallback, nonApprovedLeaveRequestsCount) {
            var _this3 = this;

            this.$confirmationComponent.setProps({
                date: date,
                rejectedCount: nonApprovedLeaveRequestsCount,
                onConfirm: function onConfirm() {
                    onConfirmCallback();
                    _this3.hide();
                }
            });
        }
    }]);

    return ConfirmationDropdown;
}(_DropdownTemplateView3.default);

exports.default = ConfirmationDropdown;

/***/ }),
/* 1797 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _View2 = __webpack_require__(20);

var _View3 = _interopRequireDefault(_View2);

var _constants = __webpack_require__(62);

var _LoadingContainer = __webpack_require__(28);

var _LoadingContainer2 = _interopRequireDefault(_LoadingContainer);

var _PanelContainer = __webpack_require__(109);

var _PanelContainer2 = _interopRequireDefault(_PanelContainer);

var _utils = __webpack_require__(6);

var _redux = __webpack_require__(7);

var _HolidayListPanelContent = __webpack_require__(1798);

var _HolidayListPanelContent2 = _interopRequireDefault(_HolidayListPanelContent);

var _selectors = __webpack_require__(263);

var _actions = __webpack_require__(320);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var HolidayListPanel = function (_View) {
    _inherits(HolidayListPanel, _View);

    function HolidayListPanel(_ref) {
        var closePanel = _ref.closePanel;

        _classCallCheck(this, HolidayListPanel);

        var _this = _possibleConstructorReturn(this, (HolidayListPanel.__proto__ || Object.getPrototypeOf(HolidayListPanel)).call(this));

        _this.actions = {
            closePanel: closePanel
        };

        _this.state = {
            isShown: false,
            loading: false
        };

        _this.onStatePropertyChanged('loading', function (loading) {
            _this.loadingContainer.setState({ loading: loading });
        });
        _this.onStatePropertyChanged('isShown', function (isShown) {
            _this.panelContainerWrapper.setState({ isShown: isShown });
        });
        return _this;
    }

    _createClass(HolidayListPanel, [{
        key: 'afterRender',
        value: function afterRender() {
            var _this2 = this;

            this.loadingContainer = new _LoadingContainer2.default({
                contentComponent: new _HolidayListPanelContent2.default(),
                containerClass: "loading_holidayListPanel",
                contentClass: "loading_holidayListPanel_content",
                loadingMoireConfig: {
                    delay: 100
                }
            });
            this.panelContainerWrapper = new _PanelContainer2.default({
                component: this.loadingContainer,
                additionalClass: 'holidayListPanel',
                showAnimationClass: _constants.SHOW_ANIMATION_CLASSES.SLIDE_LEFT,
                hideAnimationClass: _constants.HIDE_ANIMATION_CLASSES.SLIDE_LEFT,
                hideOnEsc: true,
                showHideButton: true,
                onHideCallback: function onHideCallback() {
                    return _this2.actions.closePanel();
                },
                hideOnClickOutside: {
                    hideOnClick: true,
                    panelType: _constants.PANEL_TYPES.HOLIDAY_LIST_PANEL
                },
                hideHandler: function hideHandler() {
                    return _this2.panelContainerWrapper.setState({ isShown: false });
                },
                onClickCloseButton: function onClickCloseButton() {
                    return _this2.actions.closePanel();
                }
            }).init(this.$containerEl);
        }
    }]);

    return HolidayListPanel;
}(_View3.default);

exports.default = (0, _utils.connect)(function (state) {
    return {
        isShown: (0, _selectors.isShownHolidayList)(state),
        loading: (0, _selectors.isLoadingHolidayList)(state)
    };
}, function (dispatch) {
    return {
        closePanel: (0, _redux.bindActionCreators)(_actions.closePanel, dispatch)
    };
})(HolidayListPanel);

/***/ }),
/* 1798 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _utils = __webpack_require__(6);

var _Button = __webpack_require__(33);

var _Button2 = _interopRequireDefault(_Button);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _YearSelector = __webpack_require__(1799);

var _YearSelector2 = _interopRequireDefault(_YearSelector);

var _RemoveAllConfirmation = __webpack_require__(1800);

var _RemoveAllConfirmation2 = _interopRequireDefault(_RemoveAllConfirmation);

var _selectors = __webpack_require__(263);

var _actions = __webpack_require__(320);

var _redux = __webpack_require__(7);

var _HolidayListContainer = __webpack_require__(1801);

var _HolidayListContainer2 = _interopRequireDefault(_HolidayListContainer);

var _constants = __webpack_require__(116);

var _ImportHolidaysDialog = __webpack_require__(916);

var _actions2 = __webpack_require__(213);

var _ScrollableContainer = __webpack_require__(49);

var _ScrollableContainer2 = _interopRequireDefault(_ScrollableContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var HolidayListPanelContent = function (_TemplateView) {
    _inherits(HolidayListPanelContent, _TemplateView);

    function HolidayListPanelContent(_ref) {
        var openRemoveAllConfirm = _ref.openRemoveAllConfirm,
            closeRemoveAllConfirm = _ref.closeRemoveAllConfirm,
            loadPanelData = _ref.loadPanelData,
            removeAllHolidays = _ref.removeAllHolidays,
            _ref$onImportButtonCl = _ref.onImportButtonClick,
            onImportButtonClick = _ref$onImportButtonCl === undefined ? function () {} : _ref$onImportButtonCl;

        _classCallCheck(this, HolidayListPanelContent);

        var _this = _possibleConstructorReturn(this, (HolidayListPanelContent.__proto__ || Object.getPrototypeOf(HolidayListPanelContent)).call(this));

        _this.actions = {
            openRemoveAllConfirm: openRemoveAllConfirm,
            closeRemoveAllConfirm: closeRemoveAllConfirm,
            loadPanelData: loadPanelData,
            removeAllHolidays: removeAllHolidays,
            onImportButtonClick: onImportButtonClick
        };

        _this.state = {
            year: '',
            isShownRemoveAllConfirm: false,
            holidays: {},
            loading: false
        };

        _this.onStatePropertyChanged('isShownRemoveAllConfirm', function (isShownRemoveAllConfirm) {
            if (isShownRemoveAllConfirm) {
                _this.removeAllConfirmation.setState({
                    year: _this.state.year
                });
            }

            _this.$holidayListPlaceholder.toggle(!isShownRemoveAllConfirm);
            _this.$removeAllConfirmation.toggle(isShownRemoveAllConfirm);

            _this.yearSelector.setState({
                decrementDisabled: isShownRemoveAllConfirm,
                incrementDisabled: isShownRemoveAllConfirm
            });
        });

        _this.onAnyStatePropertyChanged(['holidays', 'loading'], function () {
            if (!_this.state.loading) _this.removeAllButton.setState({ disabled: Object.keys(_this.state.holidays).length === 0 });
        });

        _this.onStatePropertyDeeplyChanged('year', function (year) {
            _this._updateYear(year);
            _this.importButton.setState({ disabled: year < window.currentUserTime().clearTime().getFullYear() });
        });
        return _this;
    }

    _createClass(HolidayListPanelContent, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class="holidayListContainer">' + '  <div class="containerTitle">' + '    <div class="titleContainer">' + '        <div class="selector"></div>' + '        <div class="title"><%=holidayList%></div>' + '    </div>' + '    <div class="buttonContainer">' + '        <div class="importButton"/>' + '        <div class="removeAllButton"/>' + '    </div>' + '  </div>' + '  <div class="removeAllConfirmation"/>' + '  <div class="holidayListPlaceholder"/>' + '</div>';
        }
    }, {
        key: 'messageKeys',
        value: function messageKeys() {
            return {
                holidayList: 'work_schedule.header.holiday_list_button'
            };
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            var _this2 = this;

            this.yearSelector = new _YearSelector2.default({
                incrementYear: function incrementYear() {
                    var year = _this2.state.year + 1;
                    _this2._updateYear(year);
                    _this2.actions.loadPanelData(year);
                },
                decrementYear: function decrementYear() {
                    var year = _this2.state.year - 1;
                    _this2._updateYear(year);
                    _this2.actions.loadPanelData(year);
                }
            }).init(this.find('.selector'));

            this.$holidayListPlaceholder = this.find('.holidayListPlaceholder');
            this.holidayList = new _HolidayListContainer2.default().init(this.$holidayListPlaceholder);

            this.$removeAllConfirmation = this.find('.removeAllConfirmation');

            this.removeAllConfirmation = new _ScrollableContainer2.default(null, new _RemoveAllConfirmation2.default({
                onConfirmButtonClick: function onConfirmButtonClick() {
                    return _this2.actions.removeAllHolidays();
                },
                onCancelButtonClick: function onCancelButtonClick() {
                    return _this2.actions.closeRemoveAllConfirm();
                }
            })).init(this.$removeAllConfirmation);

            this.importButton = new _Button2.default({
                additionalClass: 'import',
                label: _messageResource2.default.getMessage('work_schedule.header.import_holidays_button'),
                onClickCb: function onClickCb() {
                    return _this2._showImportDialog();
                },
                withDisableTooltip: true,
                tooltipAdditionalClass: 'importHolidaysButtonDisabledTooltip'
            }).init(this.find('.importButton'));
            this.importButton.setState({ disableTooltipText: _messageResource2.default.getMessage('work_schedule.header.import_holidays_button_disabled_tooltip') });

            this.removeAllButton = new _Button2.default({
                additionalClass: 'remove',
                label: _messageResource2.default.getMessage('work_schedule.remove_all_button'),
                onClickCb: function onClickCb() {
                    return _this2.actions.openRemoveAllConfirm();
                }
            }).init(this.find('.removeAllButton'));

            this.renderInitialState();
        }
    }, {
        key: '_updateYear',
        value: function _updateYear(year) {
            this.yearSelector.setState({
                year: year,
                decrementHidden: year <= _constants.WORK_SCHEDULE_YEAR_START,
                incrementHidden: year >= new Date().getFullYear() + 1
            });
        }
    }, {
        key: '_showImportDialog',
        value: function _showImportDialog() {
            (0, _ImportHolidaysDialog.getInstance)().showAt(this.importButton.getEl(), {
                my: 'right top',
                at: 'right bottom'
            });
            this.actions.onImportButtonClick();
        }
    }]);

    return HolidayListPanelContent;
}(_TemplateView3.default);

exports.default = (0, _utils.connect)(function (state) {
    return {
        isShownRemoveAllConfirm: (0, _selectors.isShownRemoveAllConfirm)(state),
        year: (0, _selectors.getPanelSelectedYear)(state),
        holidays: (0, _selectors.getHolidays)(state),
        loading: (0, _selectors.isLoadingHolidayList)(state)
    };
}, function (dispatch) {
    return {
        openRemoveAllConfirm: (0, _redux.bindActionCreators)(_actions.openRemoveAllConfirmation, dispatch),
        closeRemoveAllConfirm: (0, _redux.bindActionCreators)(_actions.closeRemoveAllConfirmation, dispatch),
        loadPanelData: (0, _redux.bindActionCreators)(_actions.loadPanelData, dispatch),
        removeAllHolidays: (0, _redux.bindActionCreators)(_actions.removeAllHolidays, dispatch),
        onImportButtonClick: (0, _redux.bindActionCreators)(_actions2.loadCountries, dispatch)
    };
})(HolidayListPanelContent);

/***/ }),
/* 1799 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var YearSelector = function (_TemplateView) {
    _inherits(YearSelector, _TemplateView);

    function YearSelector(_ref) {
        var _ref$incrementYear = _ref.incrementYear,
            incrementYear = _ref$incrementYear === undefined ? function () {} : _ref$incrementYear,
            _ref$decrementYear = _ref.decrementYear,
            decrementYear = _ref$decrementYear === undefined ? function () {} : _ref$decrementYear;

        _classCallCheck(this, YearSelector);

        var _this = _possibleConstructorReturn(this, (YearSelector.__proto__ || Object.getPrototypeOf(YearSelector)).call(this));

        _this.actions = {
            incrementYear: incrementYear,
            decrementYear: decrementYear
        };

        _this.state = {
            year: '',
            decrementDisabled: false,
            incrementDisabled: false,
            decrementHidden: false,
            incrementHidden: false
        };

        _this.onStatePropertyChanged('year', function (year) {
            _this.$year.text(year);
        });

        _this.onStatePropertyChanged('decrementDisabled', function (disabled) {
            _this.$decrementButton.toggleClass('disabled', disabled);
        });

        _this.onStatePropertyChanged('incrementDisabled', function (disabled) {
            _this.$incrementButton.toggleClass('disabled', disabled);
        });

        _this.onStatePropertyChanged('decrementHidden', function (hidden) {
            _this.$decrementButton.toggleClass('invisible', hidden);
        });

        _this.onStatePropertyChanged('incrementHidden', function (hidden) {
            _this.$incrementButton.toggleClass('invisible', hidden);
        });
        return _this;
    }

    _createClass(YearSelector, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class="yearSelector">' + '   <div class="decrementButton"/>' + '   <div class="year"/>' + '   <div class="incrementButton"/>' + '</div>';
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            var _this2 = this;

            this.$decrementButton = this.find('.decrementButton');
            this.$incrementButton = this.find('.incrementButton');
            this.$decrementButton.click(function () {
                if (!_this2.state.decrementDisabled) _this2.actions.decrementYear();
            });
            this.$incrementButton.click(function () {
                if (!_this2.state.incrementDisabled) _this2.actions.incrementYear();
            });

            this.$year = this.find('.year');
        }
    }]);

    return YearSelector;
}(_TemplateView3.default);

exports.default = YearSelector;

/***/ }),
/* 1800 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RemoveAllConfirmation = function (_TemplateView) {
    _inherits(RemoveAllConfirmation, _TemplateView);

    function RemoveAllConfirmation(_ref) {
        var _ref$onConfirmButtonC = _ref.onConfirmButtonClick,
            onConfirmButtonClick = _ref$onConfirmButtonC === undefined ? function () {} : _ref$onConfirmButtonC,
            _ref$onCancelButtonCl = _ref.onCancelButtonClick,
            onCancelButtonClick = _ref$onCancelButtonCl === undefined ? function () {} : _ref$onCancelButtonCl;

        _classCallCheck(this, RemoveAllConfirmation);

        var _this = _possibleConstructorReturn(this, (RemoveAllConfirmation.__proto__ || Object.getPrototypeOf(RemoveAllConfirmation)).call(this));

        _this.actions = {
            onConfirmButtonClick: onConfirmButtonClick,
            onCancelButtonClick: onCancelButtonClick
        };

        _this.state = {
            year: ''
        };

        _this.onStatePropertyChanged('year', function (year) {
            _this.$title.text(_messageResource2.default.getMessage('work_schedule.delete_holidays_confirm_title', [year]));
        });
        return _this;
    }

    _createClass(RemoveAllConfirmation, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class="operationConfirmDialog">' + '  <div class="operationConfirmDialogInnerContainer">' + '    <div class="warningIcon"></div>' + '    <div class="title"/>' + '    <div class="orangeBlock">' + '       <%=confirmationText%>' + '    </div>' + '    <div class="buttonsContainer">' + '      <div class="submitBtn withIcon commitBtn greyButton" tabindex="-1">' + '        <%=confirmButtonText%>' + '      </div>' + '      <div class="cancelBtn greyButton"><%=cancelButtonText%></div>' + '    </div>' + '  </div>' + '</div>';
        }
    }, {
        key: 'messageKeys',
        value: function messageKeys() {
            return {
                confirmationText: 'work_schedule.delete_holidays_confirm_text',
                cancelButtonText: 'common.cancel',
                confirmButtonText: 'work_schedule.delete_holidays_confirm_button'
            };
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            var _this2 = this;

            this.find('.cancelBtn').click(function () {
                return _this2.actions.onCancelButtonClick();
            });
            this.find('.submitBtn').click(function () {
                return _this2.actions.onConfirmButtonClick();
            });

            this.$title = this.find('.title');
        }
    }]);

    return RemoveAllConfirmation;
}(_TemplateView3.default);

exports.default = RemoveAllConfirmation;

/***/ }),
/* 1801 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _selectors = __webpack_require__(263);

var _actions = __webpack_require__(320);

var _utils = __webpack_require__(6);

var _redux = __webpack_require__(7);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _utils2 = __webpack_require__(85);

var _actions2 = __webpack_require__(213);

var _HolidayList = __webpack_require__(1802);

var _HolidayList2 = _interopRequireDefault(_HolidayList);

var _ScrollableContainer = __webpack_require__(49);

var _ScrollableContainer2 = _interopRequireDefault(_ScrollableContainer);

var _constants = __webpack_require__(116);

var _atUtils = __webpack_require__(5);

var _EmptyList = __webpack_require__(917);

var _EmptyList2 = _interopRequireDefault(_EmptyList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var HolidayListContainer = function (_TemplateView) {
    _inherits(HolidayListContainer, _TemplateView);

    function HolidayListContainer(_ref) {
        var changeSort = _ref.changeSort,
            addCorporateDay = _ref.addCorporateDay,
            deleteCorporateDay = _ref.deleteCorporateDay,
            setListTransformed = _ref.setListTransformed;

        _classCallCheck(this, HolidayListContainer);

        var _this = _possibleConstructorReturn(this, (HolidayListContainer.__proto__ || Object.getPrototypeOf(HolidayListContainer)).call(this));

        _this.actions = {
            changeSort: changeSort,
            addCorporateDay: addCorporateDay,
            deleteCorporateDay: deleteCorporateDay,
            setListTransformed: setListTransformed
        };

        _this.state = {
            holidays: {},
            importedHolidayDates: {},
            selectedYear: '',
            sorting: {},
            isListTransformed: false
        };

        _this.onStatePropertyChanged(['sorting'], function () {
            _this.$dateSortArow.toggle(_this.state.sorting.by === _constants.sortBy.DATE);
            _this.$nameSortArow.toggle(_this.state.sorting.by === _constants.sortBy.NAME);
            _this.$dateSortArow.toggleClass('descArrow', _this.state.sorting.by === _constants.sortBy.DATE && _this.state.sorting.asc);
            _this.$nameSortArow.toggleClass('descArrow', _this.state.sorting.by === _constants.sortBy.NAME && _this.state.sorting.asc);
        });

        _this.onAnyStatePropertyDeeplyChanged(['holidays', 'isListTransformed'], function () {
            _this.updateList();
        });

        _this.onStatePropertyChanged('holidays', function () {
            var hasHolidays = Object.keys(_this.state.holidays).length > 0;
            _this.$emptyListPlaceholder.toggle(!hasHolidays);
            _this.$fillContainer.toggle(hasHolidays);
        });

        _this.onStatePropertyChanged('selectedYear', function () {
            _this.emptyList.setState({
                title: _messageResource2.default.getMessage('work_schedule.empty_list_title', [_this.state.selectedYear])
            });
            if (Object.keys(_this.state.holidays).length > 0) _this.holidayList.forceUpdate();
        });

        _this.onStatePropertyChanged('importedHolidayDates', function (importedHolidays) {
            return _this.holidayList.setState({ importedHolidays: importedHolidays });
        });
        return _this;
    }

    _createClass(HolidayListContainer, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class="listContainer">' + '    <div class="fillContainer">' + '        <div class="listHeader">' + '            <div class="date">' + '                <%=date%>' + '                <div class="sortArrow"/>' + '             </div>' + '            <div class="separator"></div>' + '            <div class="holidayName">' + '                <%-holidayName%>' + '                <div class="sortArrow"/>' + '            </div>' + '        </div>' + '        <div class="listPlaceholder">' + '        </div>' + '    </div>' + '    <div class="emptyListPlaceholder"/>' + '</div>';
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            var _this2 = this;

            this.$fillContainer = this.find('.fillContainer');
            this.$emptyListPlaceholder = this.find('.emptyListPlaceholder');
            this.$dateSortArow = this.find('.date .sortArrow');
            this.$nameSortArow = this.find('.holidayName .sortArrow');

            this.emptyList = new _ScrollableContainer2.default(null, new _EmptyList2.default()).init(this.$emptyListPlaceholder);

            this.holidayList = new _ScrollableContainer2.default(null, new _HolidayList2.default({
                addCorporateDay: this.actions.addCorporateDay,
                deleteCorporateDay: this.actions.deleteCorporateDay,
                updateListCallback: function updateListCallback() {
                    return _this2.actions.setListTransformed(false);
                }
            })).init(this.find('.listPlaceholder'));

            this.find('.date').click(function () {
                return _this2.actions.changeSort({
                    by: _constants.sortBy.DATE,
                    asc: _constants.sortBy.DATE === _this2.state.sorting.by ? !_this2.state.sorting.asc : false
                });
            });
            this.find('.holidayName').click(function () {
                return _this2.actions.changeSort({
                    by: _constants.sortBy.NAME,
                    asc: _constants.sortBy.NAME === _this2.state.sorting.by ? !_this2.state.sorting.asc : false
                });
            });

            this.updateList();
        }
    }, {
        key: 'messageKeys',
        value: function messageKeys() {
            return {
                date: 'work_schedule.table_title_date',
                holidayName: 'work_schedule.table_title_holiday_name'
            };
        }
    }, {
        key: 'updateList',
        value: function updateList() {
            var dates = Object.keys(this.state.holidays);

            if (dates.length > 0) {

                var holidaysArray = [];

                if (this.state.isListTransformed) {
                    holidaysArray = this.state.sorting.by === _constants.sortBy.DATE ? (0, _utils2.getSortedArrayFromObjectByDate)(this.state.holidays, this.state.sorting.asc) : (0, _utils2.getSortedArrayFromObjectByName)(this.state.holidays, this.state.sorting.asc);
                } else {
                    holidaysArray = (0, _atUtils.createArrayOfObjectFromMap)(this.state.holidays, _utils2.createHolidayListObject);
                }

                this.holidayList.setState({
                    holidays: holidaysArray,
                    isListTransformed: this.state.isListTransformed
                });
            }
        }
    }]);

    return HolidayListContainer;
}(_TemplateView3.default);

exports.default = (0, _utils.connect)(function (state) {
    return {
        isShown: (0, _selectors.isShownHolidayList)(state),
        holidays: (0, _selectors.getHolidays)(state),
        importedHolidayDates: (0, _selectors.getImportedHolidayDatess)(state),
        selectedYear: (0, _selectors.getPanelSelectedYear)(state),
        sorting: (0, _selectors.getSorting)(state),
        isListTransformed: (0, _selectors.isListTransformed)(state)
    };
}, function (dispatch) {
    return {
        changeSort: (0, _redux.bindActionCreators)(_actions.changeSort, dispatch),
        addCorporateDay: (0, _redux.bindActionCreators)(_actions2.addCorporateDay, dispatch),
        deleteCorporateDay: (0, _redux.bindActionCreators)(_actions2.deleteCorporateDay, dispatch),
        setListTransformed: (0, _redux.bindActionCreators)(_actions.setListTransformed, dispatch)
    };
})(HolidayListContainer);

/***/ }),
/* 1802 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _HolidayInfoLine = __webpack_require__(1803);

var _HolidayInfoLine2 = _interopRequireDefault(_HolidayInfoLine);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var HolidayList = function (_TemplateView) {
    _inherits(HolidayList, _TemplateView);

    function HolidayList(_ref) {
        var addCorporateDay = _ref.addCorporateDay,
            deleteCorporateDay = _ref.deleteCorporateDay,
            _ref$updateListCallba = _ref.updateListCallback,
            updateListCallback = _ref$updateListCallba === undefined ? function () {} : _ref$updateListCallba;

        _classCallCheck(this, HolidayList);

        var _this = _possibleConstructorReturn(this, (HolidayList.__proto__ || Object.getPrototypeOf(HolidayList)).call(this));

        _this.actions = {
            addCorporateDay: addCorporateDay,
            deleteCorporateDay: deleteCorporateDay,
            updateListCallback: updateListCallback
        };

        _this.state = {
            holidays: [],
            isListTransformed: false,
            importedHolidays: {}
        };

        _this.holidaysMapInputs = {};

        _this.onAnyStatePropertyChanged(['holidays', 'isListTransformed'], function () {
            if (_this.state.isListTransformed) {
                _this.updateList();
            } else {
                _this.updateListState();
            }
        });

        _this.onStatePropertyChanged('importedHolidays', function (importedHolidays) {
            Object.keys(_this.holidaysMapInputs).forEach(function (holidayDate) {
                _this.holidaysMapInputs[holidayDate].setState({ imported: !!importedHolidays[holidayDate] });
            });
        });
        return _this;
    }

    _createClass(HolidayList, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class="list"/>';
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            this.updateList();
        }
    }, {
        key: 'updateList',
        value: function updateList() {
            var _this2 = this;

            this.getEl().empty();

            this.holidaysMapInputs = {};

            this.state.holidays.forEach(function (holiday) {
                _this2.holidaysMapInputs[holiday.date] = new _HolidayInfoLine2.default({
                    date: Date.parseJSONDate(holiday.date),
                    name: holiday.name,
                    editCallback: function editCallback(date, isWorking, title) {
                        return _this2.actions.addCorporateDay(date, isWorking, title);
                    },
                    deleteCallback: function deleteCallback(date) {
                        return _this2.actions.deleteCorporateDay(date);
                    }
                }).init(_this2.getEl());
            });

            this.actions.updateListCallback();
        }
    }, {
        key: 'updateListState',
        value: function updateListState() {
            var _this3 = this;

            this.state.holidays.forEach(function (holiday) {
                _this3.holidaysMapInputs[holiday.date] && _this3.holidaysMapInputs[holiday.date].setState({
                    name: holiday.name
                });
            });
        }
    }]);

    return HolidayList;
}(_TemplateView3.default);

exports.default = HolidayList;

/***/ }),
/* 1803 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _NameInput = __webpack_require__(370);

var _NameInput2 = _interopRequireDefault(_NameInput);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _utils = __webpack_require__(85);

var _Button = __webpack_require__(33);

var _Button2 = _interopRequireDefault(_Button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var HolidayInfoLine = function (_TemplateView) {
    _inherits(HolidayInfoLine, _TemplateView);

    function HolidayInfoLine(_ref) {
        var _ref$name = _ref.name,
            name = _ref$name === undefined ? '' : _ref$name,
            _ref$date = _ref.date,
            date = _ref$date === undefined ? new Date() : _ref$date,
            _ref$editCallback = _ref.editCallback,
            editCallback = _ref$editCallback === undefined ? function () {} : _ref$editCallback,
            _ref$deleteCallback = _ref.deleteCallback,
            deleteCallback = _ref$deleteCallback === undefined ? function () {} : _ref$deleteCallback;

        _classCallCheck(this, HolidayInfoLine);

        var _this = _possibleConstructorReturn(this, (HolidayInfoLine.__proto__ || Object.getPrototypeOf(HolidayInfoLine)).call(this));

        _this._toggleDeleteConfirmationMode = function (inDeleting) {
            _this.$el.toggleClass('deleteConfirmation', inDeleting);
        };

        _this.params = {
            date: date
        };

        _this.callbacks = {
            editCallback: editCallback,
            deleteCallback: deleteCallback
        };

        _this.state = {
            name: name,
            imported: false
        };

        _this.onStatePropertyChanged('name', function (name) {
            return _this.nameInput.setState({ name: name });
        });
        _this.onStatePropertyChanged('imported', function (imported) {
            return _this.getEl().toggleClass('imported', imported);
        });
        return _this;
    }

    _createClass(HolidayInfoLine, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return "<div class='holidayInfo'>" + "    <div class='dateColumn'> " + "        <span class='date'></span>" + "        <span class='dayWeek'></span>" + "    </div>" + "    <div class='nameContainer'>" + "        <div class='nameColumn'/>" + "        <div class='separator'/>" + "        <div class='deleteIcon'/>" + "    </div>" + "    <div class='deleteHolidayContainer'>" + "        <div class='deleteMessage'><%=deleteConfirmationMessage%></div>" + "        <div class='confirmDelete'></div>" + "        <div class='cancelDelete'><%=cancelDeleteButtonText%></div>" + "    </div>" + "</div>";
        }
    }, {
        key: 'messageKeys',
        value: function messageKeys() {
            return {
                deleteConfirmationMessage: 'work_schedule.remove_confirm',
                cancelDeleteButtonText: 'common.cancel'
            };
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            var _this2 = this;

            this.find('.date').text(_jquery2.default.datepicker.formatDate('M d', this.params.date));
            this.find('.dayWeek').text(_messageResource2.default.getMessage((0, _utils.getShortDayNameKey)(this.params.date.getDay())));

            this.nameInput = new _NameInput2.default({
                editable: true,
                maxLength: 80,
                showEmptyInput: false,
                onChangeCb: function onChangeCb(title, oldTitle) {
                    var newTitle = title === '' ? _messageResource2.default.getMessage('work_schedule.corporate_holiday') : title;
                    if (oldTitle !== newTitle) {
                        _this2.setState({ name: newTitle });
                        _this2.callbacks.editCallback(_this2.params.date, false, newTitle);
                    }
                    _this2.$el.removeClass('active');
                },
                onFocusCb: function onFocusCb() {
                    return _this2.$el.addClass('active');
                }
            }).init(this.find('.nameColumn'));

            this.find('.deleteIcon').click(function () {
                _this2._toggleDeleteConfirmationMode(true);
            });

            new _Button2.default({
                label: _messageResource2.default.getMessage('common.remove'),
                onClickCb: function onClickCb() {
                    _this2.callbacks.deleteCallback(_this2.params.date);
                    //don't remove from DOM to avoid sorting
                    _this2.hide();
                    _this2._toggleDeleteConfirmationMode(false);
                }
            }).init(this.find('.confirmDelete'));

            this.find('.cancelDelete').on('click', function () {
                _this2._toggleDeleteConfirmationMode(false);
            });

            this.renderInitialState();
        }
    }]);

    return HolidayInfoLine;
}(_TemplateView3.default);

exports.default = HolidayInfoLine;

/***/ }),
/* 1804 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _View2 = __webpack_require__(20);

var _View3 = _interopRequireDefault(_View2);

var _constants = __webpack_require__(62);

var _LoadingContainer = __webpack_require__(28);

var _LoadingContainer2 = _interopRequireDefault(_LoadingContainer);

var _PanelContainer = __webpack_require__(109);

var _PanelContainer2 = _interopRequireDefault(_PanelContainer);

var _utils = __webpack_require__(6);

var _redux = __webpack_require__(7);

var _selectors = __webpack_require__(404);

var _actions = __webpack_require__(568);

var _ImportHolidaysPanelContent = __webpack_require__(1805);

var _ImportHolidaysPanelContent2 = _interopRequireDefault(_ImportHolidaysPanelContent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ImportHolidaysPanelContainer = function (_View) {
    _inherits(ImportHolidaysPanelContainer, _View);

    function ImportHolidaysPanelContainer(_ref) {
        var closePanel = _ref.closePanel;

        _classCallCheck(this, ImportHolidaysPanelContainer);

        var _this = _possibleConstructorReturn(this, (ImportHolidaysPanelContainer.__proto__ || Object.getPrototypeOf(ImportHolidaysPanelContainer)).call(this));

        _this.actions = {
            closePanel: closePanel
        };

        _this.state = {
            isShown: false,
            loading: false,
            importProcess: false
        };

        _this.onAnyStatePropertyChanged(['loading', 'importProcess'], function () {
            _this.loadingContainer.setState({
                loading: _this.state.loading || _this.state.importProcess
            });
            _this.panelContainerWrapper.getEl().toggleClass('importProcess', _this.state.importProcess);
        });

        _this.onStatePropertyChanged('isShown', function (isShown) {
            return _this.panelContainerWrapper.setState({ isShown: isShown });
        });
        return _this;
    }

    _createClass(ImportHolidaysPanelContainer, [{
        key: 'afterRender',
        value: function afterRender() {
            var _this2 = this;

            this.loadingContainer = new _LoadingContainer2.default({
                contentComponent: new _ImportHolidaysPanelContent2.default(),
                containerClass: "loading_importHolidaysPanel",
                loadingMoireConfig: {
                    delay: 100
                }
            });

            this.panelContainerWrapper = new _PanelContainer2.default({
                component: this.loadingContainer,
                additionalClass: 'importHolidaysPanel',
                showAnimationClass: _constants.SHOW_ANIMATION_CLASSES.SLIDE_LEFT,
                hideAnimationClass: _constants.HIDE_ANIMATION_CLASSES.SLIDE_LEFT,
                hideOnEsc: true,
                showHideButton: true,
                onHideCallback: function onHideCallback() {
                    return _this2.actions.closePanel();
                },
                hideOnClickOutside: {
                    hideOnClick: true,
                    panelType: _constants.PANEL_TYPES.IMPORT_HOLIDAYS_PANEL
                },
                onClickCloseButton: function onClickCloseButton() {
                    return _this2.actions.closePanel();
                }
            }).init(this.$containerEl);
        }
    }]);

    return ImportHolidaysPanelContainer;
}(_View3.default);

exports.default = (0, _utils.connect)(function (state) {
    return {
        isShown: (0, _selectors.isShownImportHolidaysPanel)(state),
        loading: (0, _selectors.isLoadingImportedHolidays)(state),
        importProcess: (0, _selectors.isImportHolidaysInProcess)(state)
    };
}, function (dispatch) {
    return {
        closePanel: (0, _redux.bindActionCreators)(_actions.closePanel, dispatch)
    };
})(ImportHolidaysPanelContainer);

/***/ }),
/* 1805 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _utils = __webpack_require__(6);

var _Button = __webpack_require__(33);

var _Button2 = _interopRequireDefault(_Button);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _selectors = __webpack_require__(404);

var _ImportHolidaysList = __webpack_require__(1806);

var _ImportHolidaysList2 = _interopRequireDefault(_ImportHolidaysList);

var _actions = __webpack_require__(568);

var _redux = __webpack_require__(7);

var _ScrollableContainer = __webpack_require__(49);

var _ScrollableContainer2 = _interopRequireDefault(_ScrollableContainer);

var _EmptyList = __webpack_require__(917);

var _EmptyList2 = _interopRequireDefault(_EmptyList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ImportHolidaysPanelContent = function (_TemplateView) {
    _inherits(ImportHolidaysPanelContent, _TemplateView);

    function ImportHolidaysPanelContent(_ref) {
        var onCancelClick = _ref.onCancelClick,
            _ref$onImportButtonCl = _ref.onImportButtonClick,
            onImportButtonClick = _ref$onImportButtonCl === undefined ? function () {} : _ref$onImportButtonCl;

        _classCallCheck(this, ImportHolidaysPanelContent);

        var _this = _possibleConstructorReturn(this, (ImportHolidaysPanelContent.__proto__ || Object.getPrototypeOf(ImportHolidaysPanelContent)).call(this));

        _this.actions = {
            onCancelClick: onCancelClick,
            onImportButtonClick: onImportButtonClick
        };

        _this.state = {
            year: '',
            country: null,
            fileName: null,
            holidays: [],
            hasHolidaysInPast: false,
            hasHolidaysOnLeaveBlackoutDays: false,
            importProcess: false
        };

        _this.onAnyStatePropertyChanged(['country', 'fileName', 'year'], function () {
            var title = _this.state.country !== null ? _messageResource2.default.getMessage('work_schedule.import_panel.title_country', [_this.state.country, _this.state.year]) : _messageResource2.default.getMessage('work_schedule.import_panel.title_file', [_this.state.fileName, _this.state.year]);
            _this.$panelTitle.text(title);
        });

        _this.onStatePropertyChanged('holidays', function (holidays) {
            _this.holidayList.setState({ holidays: holidays });
            var hasHolidays = Object.keys(holidays).length > 0;
            _this.$emptyListPlaceholder.toggle(!hasHolidays);
            _this.$holidayListPlaceholder.toggle(hasHolidays);
            _this.importButton.setState({ disabled: !hasHolidays });
            _this.holidayList.forceUpdate();
        });

        _this.onAnyStatePropertyChanged(['hasHolidaysInPast', 'hasHolidaysOnLeaveBlackoutDays'], function (_ref2) {
            var hasHolidaysInPast = _ref2.hasHolidaysInPast,
                hasHolidaysOnLeaveBlackoutDays = _ref2.hasHolidaysOnLeaveBlackoutDays;

            var textKey = hasHolidaysOnLeaveBlackoutDays ? hasHolidaysInPast ? 'work_schedule.import_panel.past_and_blackout_holiday_note' : 'work_schedule.import_panel.blackout_holiday_note' : hasHolidaysInPast ? 'work_schedule.import_panel.past_holiday_note' : '';

            _this.$hasFilteredNote.toggle(textKey !== '').find('.text').text(_messageResource2.default.getMessage(textKey));
        });

        _this.onStatePropertyChanged('importProcess', function (importProcess) {
            _this.$importButton.toggleClass('loading', importProcess);
            _this.importButton.setState({
                label: importProcess ? '' : _messageResource2.default.getMessage('common.import')
            });
        });
        return _this;
    }

    _createClass(ImportHolidaysPanelContent, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class="importHolidaysPanelContent">' + '    <div class="panelTitle"/>' + '    <div class="holidayListContainer">' + '        <div class="listHeader">' + '            <div class="title"><%=listTitle%></div>' + '            <div class="note">' + '                <div class="icon"/>' + '                <div class="text"/>' + '            </div>' + '        </div>' + '        <div class="holidayListPlaceholder"></div>' + '        <div class="emptyListPlaceholder"></div>' + '    </div>' + '    <div class="footer">' + '        <div class="importButton"/>' + '        <div class="cancelButton"/>' + '    </div>' + '</div>';
        }
    }, {
        key: 'messageKeys',
        value: function messageKeys() {
            return {
                listTitle: 'work_schedule.import_panel.list_title'
            };
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            var _this2 = this;

            this.$panelTitle = this.find('.panelTitle');
            this.$hasFilteredNote = this.find('.listHeader .note');
            this.$importButton = this.find('.importButton');
            this.$emptyListPlaceholder = this.find('.emptyListPlaceholder');
            this.$holidayListPlaceholder = this.find('.holidayListPlaceholder');

            this.emptyList = new _ScrollableContainer2.default(null, new _EmptyList2.default()).init(this.$emptyListPlaceholder);
            this.emptyList.setState({ title: _messageResource2.default.getMessage('work_schedule.import.empty_list_title') });

            this.holidayList = new _ScrollableContainer2.default(null, new _ImportHolidaysList2.default()).init(this.$holidayListPlaceholder);

            this.importButton = new _Button2.default({
                additionalClass: 'import',
                label: _messageResource2.default.getMessage('common.import'),
                onClickCb: function onClickCb() {
                    return _this2.actions.onImportButtonClick();
                }
            }).init(this.$importButton);

            new _Button2.default({
                additionalClass: 'cancel',
                label: _messageResource2.default.getMessage('common.cancel'),
                onClickCb: function onClickCb() {
                    return _this2.actions.onCancelClick();
                }
            }).init(this.find('.cancelButton'));
        }
    }]);

    return ImportHolidaysPanelContent;
}(_TemplateView3.default);

exports.default = (0, _utils.connect)(function (state) {
    return {
        year: (0, _selectors.getYear)(state),
        country: (0, _selectors.getCountry)(state),
        fileName: (0, _selectors.getFileName)(state),
        holidays: (0, _selectors.getHolidays)(state),
        hasHolidaysInPast: (0, _selectors.hasHolidaysInPast)(state),
        hasHolidaysOnLeaveBlackoutDays: (0, _selectors.hasHolidaysOnLeaveBlackoutDays)(state),
        importProcess: (0, _selectors.isImportHolidaysInProcess)(state)
    };
}, function (dispatch) {
    return {
        onImportButtonClick: (0, _redux.bindActionCreators)(_actions.importHolidays, dispatch),
        onCancelClick: (0, _redux.bindActionCreators)(_actions.closePanel, dispatch)
    };
})(ImportHolidaysPanelContent);

/***/ }),
/* 1806 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _ImportHolidaysListLine = __webpack_require__(1807);

var _ImportHolidaysListLine2 = _interopRequireDefault(_ImportHolidaysListLine);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ImportHolidaysList = function (_TemplateView) {
    _inherits(ImportHolidaysList, _TemplateView);

    function ImportHolidaysList() {
        _classCallCheck(this, ImportHolidaysList);

        var _this = _possibleConstructorReturn(this, (ImportHolidaysList.__proto__ || Object.getPrototypeOf(ImportHolidaysList)).call(this));

        _this.state = {
            holidays: []
        };

        _this.onStatePropertyChanged('holidays', function () {
            _this.renderList();
        });
        return _this;
    }

    _createClass(ImportHolidaysList, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class="importHolidaysList"/>';
        }
    }, {
        key: 'renderList',
        value: function renderList() {
            var _this2 = this;

            this.getEl().empty();
            this.state.holidays.forEach(function (holiday) {
                new _ImportHolidaysListLine2.default({
                    date: Date.parseJSONDate(holiday.date),
                    name: holiday.name
                }).init(_this2.getEl());
            });
        }
    }]);

    return ImportHolidaysList;
}(_TemplateView3.default);

exports.default = ImportHolidaysList;

/***/ }),
/* 1807 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _utils = __webpack_require__(85);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ImportHolidaysListLine = function (_TemplateView) {
    _inherits(ImportHolidaysListLine, _TemplateView);

    function ImportHolidaysListLine(_ref) {
        var _ref$name = _ref.name,
            name = _ref$name === undefined ? '' : _ref$name,
            _ref$date = _ref.date,
            date = _ref$date === undefined ? new Date() : _ref$date;

        _classCallCheck(this, ImportHolidaysListLine);

        var _this = _possibleConstructorReturn(this, (ImportHolidaysListLine.__proto__ || Object.getPrototypeOf(ImportHolidaysListLine)).call(this));

        _this.params = {
            date: date,
            name: name
        };
        return _this;
    }

    _createClass(ImportHolidaysListLine, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return "<div class='holidayInfo'>" + "    <div class='dateColumn'> " + "        <span class='date'><%=date%></span>" + "        <span class='weekDay'><%=weekDay%></span>" + "    </div>" + "    <div class='nameColumn'><%-name%></div>" + "</div>";
        }
    }, {
        key: 'templateModel',
        value: function templateModel() {
            return {
                date: _jquery2.default.datepicker.formatDate('M d', this.params.date),
                name: this.params.name
            };
        }
    }, {
        key: 'messageKeys',
        value: function messageKeys() {
            return {
                weekDay: (0, _utils.getShortDayNameKey)(this.params.date.getDay())
            };
        }
    }]);

    return ImportHolidaysListLine;
}(_TemplateView3.default);

exports.default = ImportHolidaysListLine;

/***/ }),
/* 1808 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TaskManagementMediator = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _redux = __webpack_require__(7);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _PageMediator2 = __webpack_require__(919);

var _PageMediator3 = _interopRequireDefault(_PageMediator2);

var _StoreUtils = __webpack_require__(531);

var StoreUtils = _interopRequireWildcard(_StoreUtils);

var _TaskManagementStore = __webpack_require__(140);

var _TaskManagementStore2 = _interopRequireDefault(_TaskManagementStore);

var _CustomerProjectSelection = __webpack_require__(156);

var _CustomerProjectSelection2 = _interopRequireDefault(_CustomerProjectSelection);

var _TasksTable = __webpack_require__(1809);

var _TasksTable2 = _interopRequireDefault(_TasksTable);

var _CustomersProjectsPanel = __webpack_require__(1819);

var _CustomersProjectsPanel2 = _interopRequireDefault(_CustomersProjectsPanel);

var _CustomerPanelController = __webpack_require__(819);

var _CustomerPanelController2 = _interopRequireDefault(_CustomerPanelController);

var _ProjectPanelController = __webpack_require__(818);

var _ProjectPanelController2 = _interopRequireDefault(_ProjectPanelController);

var _CustomerStore = __webpack_require__(65);

var _CustomerStore2 = _interopRequireDefault(_CustomerStore);

var _ProjectStore = __webpack_require__(59);

var _ProjectStore2 = _interopRequireDefault(_ProjectStore);

var _TaskStore = __webpack_require__(91);

var _TaskStore2 = _interopRequireDefault(_TaskStore);

var _LoadingMoire = __webpack_require__(92);

var _LoadingMoire2 = _interopRequireDefault(_LoadingMoire);

var _jquery_rpc = __webpack_require__(26);

var _jquery_rpc2 = _interopRequireDefault(_jquery_rpc);

var _constants = __webpack_require__(4);

var _KanbanViewContainer = __webpack_require__(1826);

var _KanbanViewContainer2 = _interopRequireDefault(_KanbanViewContainer);

var _actions = __webpack_require__(55);

var _selectors = __webpack_require__(367);

var _actions2 = __webpack_require__(29);

var _selectors2 = __webpack_require__(27);

var _selectors3 = __webpack_require__(82);

var _actions3 = __webpack_require__(195);

var _actions4 = __webpack_require__(364);

var _constants2 = __webpack_require__(44);

var _HeaderPanel = __webpack_require__(1836);

var _HeaderPanel2 = _interopRequireDefault(_HeaderPanel);

var _Container = __webpack_require__(1856);

var _Container2 = _interopRequireDefault(_Container);

var _utils = __webpack_require__(6);

var _selectors4 = __webpack_require__(14);

var _selectors5 = __webpack_require__(97);

var _LoadTasksFromCSVManager = __webpack_require__(1862);

var _LoadTasksFromCSVManager2 = _interopRequireDefault(_LoadTasksFromCSVManager);

var _Page = __webpack_require__(1863);

var _Page2 = _interopRequireDefault(_Page);

var _selectors6 = __webpack_require__(19);

var _CreateTasksPopupController = __webpack_require__(505);

var _CreateTasksPopupController2 = _interopRequireDefault(_CreateTasksPopupController);

var _CreateProjectPopupController = __webpack_require__(1864);

var _CreateProjectPopupController2 = _interopRequireDefault(_CreateProjectPopupController);

var _CreateCustomerPopupController = __webpack_require__(1869);

var _CreateCustomerPopupController2 = _interopRequireDefault(_CreateCustomerPopupController);

var _actions5 = __webpack_require__(141);

var _actions6 = __webpack_require__(308);

var _CreateTaskPanelContainer = __webpack_require__(1874);

var _CreateTaskPanelContainer2 = _interopRequireDefault(_CreateTaskPanelContainer);

var _actions7 = __webpack_require__(81);

var _utils2 = __webpack_require__(192);

var _actions8 = __webpack_require__(56);

var _actions9 = __webpack_require__(366);

var _actions10 = __webpack_require__(491);

var _BulkOperationProgress = __webpack_require__(1876);

var _BulkOperationProgress2 = _interopRequireDefault(_BulkOperationProgress);

var _selectors7 = __webpack_require__(15);

var _PageFeatureDiffController = __webpack_require__(1877);

var _PageFeatureDiffController2 = _interopRequireDefault(_PageFeatureDiffController);

var _SelectionController = __webpack_require__(1878);

var _SelectionController2 = _interopRequireDefault(_SelectionController);

var _actions11 = __webpack_require__(194);

var _selectors8 = __webpack_require__(106);

var _selectors9 = __webpack_require__(1879);

var _actions12 = __webpack_require__(68);

var _EditTaskPanelContainer = __webpack_require__(1880);

var _EditTaskPanelContainer2 = _interopRequireDefault(_EditTaskPanelContainer);

var _ExceptionsTypes = __webpack_require__(107);

var _urlHelper = __webpack_require__(1881);

var _urlHelper2 = _interopRequireDefault(_urlHelper);

var _syncCallbacks = __webpack_require__(161);

var _rpcUtils = __webpack_require__(160);

var _RpcError = __webpack_require__(281);

var _RpcError2 = _interopRequireDefault(_RpcError);

var _connector = __webpack_require__(288);

var _actions13 = __webpack_require__(493);

var _utils3 = __webpack_require__(135);

var _constants3 = __webpack_require__(77);

var _ClassicBridge = __webpack_require__(18);

var _ClassicBridge2 = _interopRequireDefault(_ClassicBridge);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TaskManagementMediator = exports.TaskManagementMediator = function (_PageMediator) {
    _inherits(TaskManagementMediator, _PageMediator);

    function TaskManagementMediator(_ref) {
        var data = _ref.data,
            _ref$openTaskPanel = _ref.openTaskPanel,
            openTaskPanel = _ref$openTaskPanel === undefined ? function (taskId) {} : _ref$openTaskPanel,
            _ref$openProjectPanel = _ref.openProjectPanel,
            openProjectPanel = _ref$openProjectPanel === undefined ? function (projectId) {} : _ref$openProjectPanel,
            _ref$openCustomerPane = _ref.openCustomerPanel,
            openCustomerPanel = _ref$openCustomerPane === undefined ? function (customerId) {} : _ref$openCustomerPane,
            _ref$addNewTasks = _ref.addNewTasks,
            addNewTasks = _ref$addNewTasks === undefined ? function (tasks) {} : _ref$addNewTasks,
            _ref$changeSelectAllT = _ref.changeSelectAllTasks,
            changeSelectAllTasks = _ref$changeSelectAllT === undefined ? function (isAll) {} : _ref$changeSelectAllT,
            _ref$changeTaskSelect = _ref.changeTaskSelected,
            changeTaskSelected = _ref$changeTaskSelect === undefined ? function (id, selected) {} : _ref$changeTaskSelect,
            _ref$changeTaskNameFi = _ref.changeTaskNameFilterAction,
            changeTaskNameFilterAction = _ref$changeTaskNameFi === undefined ? function () {} : _ref$changeTaskNameFi,
            _ref$changeSingleCPSe = _ref.changeSingleCPSelectionAction,
            changeSingleCPSelectionAction = _ref$changeSingleCPSe === undefined ? function () {} : _ref$changeSingleCPSe,
            _ref$changeCPSelectio = _ref.changeCPSelection,
            changeCPSelection = _ref$changeCPSelectio === undefined ? function () {} : _ref$changeCPSelectio,
            _ref$addCustomers = _ref.addCustomers,
            addCustomers = _ref$addCustomers === undefined ? function () {} : _ref$addCustomers,
            _ref$addProjects = _ref.addProjects,
            addProjects = _ref$addProjects === undefined ? function () {} : _ref$addProjects,
            _ref$addTasks = _ref.addTasks,
            addTasks = _ref$addTasks === undefined ? function () {} : _ref$addTasks,
            _ref$setTypesOfWork = _ref.setTypesOfWork,
            setTypesOfWork = _ref$setTypesOfWork === undefined ? function () {} : _ref$setTypesOfWork,
            _ref$setTasksTableLoa = _ref.setTasksTableLoaded,
            setTasksTableLoaded = _ref$setTasksTableLoa === undefined ? function () {} : _ref$setTasksTableLoa,
            _ref$setKanbanLoaded = _ref.setKanbanLoaded,
            setKanbanLoaded = _ref$setKanbanLoaded === undefined ? function () {} : _ref$setKanbanLoaded,
            _ref$setManagementAss = _ref.setManagementAssignments,
            setManagementAssignments = _ref$setManagementAss === undefined ? function () {} : _ref$setManagementAss,
            _ref$setViewerSetting = _ref.setViewerSettings,
            setViewerSettings = _ref$setViewerSetting === undefined ? function () {} : _ref$setViewerSetting,
            _ref$setHasManageable = _ref.setHasManageableTasks,
            setHasManageableTasks = _ref$setHasManageable === undefined ? function () {} : _ref$setHasManageable,
            _ref$removeTasks = _ref.removeTasks,
            removeTasks = _ref$removeTasks === undefined ? function () {} : _ref$removeTasks,
            _ref$removeProject = _ref.removeProject,
            removeProject = _ref$removeProject === undefined ? function () {} : _ref$removeProject,
            _ref$removeCustomer = _ref.removeCustomer,
            removeCustomer = _ref$removeCustomer === undefined ? function () {} : _ref$removeCustomer,
            _ref$setRecentlyCreat = _ref.setRecentlyCreatedCustomers,
            setRecentlyCreatedCustomers = _ref$setRecentlyCreat === undefined ? function () {} : _ref$setRecentlyCreat,
            _ref$setRecentlyCreat2 = _ref.setRecentlyCreatedProjects,
            setRecentlyCreatedProjects = _ref$setRecentlyCreat2 === undefined ? function () {} : _ref$setRecentlyCreat2,
            _ref$setWorkflowStatu = _ref.setWorkflowStatusesList,
            setWorkflowStatusesList = _ref$setWorkflowStatu === undefined ? function () {} : _ref$setWorkflowStatu,
            _ref$copyTasksToProje = _ref.copyTasksToProjectsAction,
            copyTasksToProjectsAction = _ref$copyTasksToProje === undefined ? function () {} : _ref$copyTasksToProje,
            _ref$archiveProjectsO = _ref.archiveProjectsOfCustomer,
            archiveProjectsOfCustomer = _ref$archiveProjectsO === undefined ? function () {} : _ref$archiveProjectsO,
            _ref$archiveProject = _ref.archiveProject,
            archiveProject = _ref$archiveProject === undefined ? function () {} : _ref$archiveProject,
            _ref$changedTaskWorkf = _ref.changedTaskWorkflowStatus,
            changedTaskWorkflowStatus = _ref$changedTaskWorkf === undefined ? function () {} : _ref$changedTaskWorkf,
            _ref$setLoadedTaskIds = _ref.setLoadedTaskIds,
            setLoadedTaskIds = _ref$setLoadedTaskIds === undefined ? function () {} : _ref$setLoadedTaskIds,
            _ref$addLoadedTaskIds = _ref.addLoadedTaskIds,
            addLoadedTaskIds = _ref$addLoadedTaskIds === undefined ? function () {} : _ref$addLoadedTaskIds,
            _ref$toggleLoadingMoi = _ref.toggleLoadingMoire,
            toggleLoadingMoire = _ref$toggleLoadingMoi === undefined ? function () {} : _ref$toggleLoadingMoi,
            _ref$updateEnabledFea = _ref.updateEnabledFeatures,
            updateEnabledFeatures = _ref$updateEnabledFea === undefined ? function () {} : _ref$updateEnabledFea,
            _ref$loadTaskCustomFi = _ref.loadTaskCustomFields,
            loadTaskCustomFields = _ref$loadTaskCustomFi === undefined ? function () {} : _ref$loadTaskCustomFi,
            _ref$setTaskCustomFie = _ref.setTaskCustomFields,
            setTaskCustomFields = _ref$setTaskCustomFie === undefined ? function () {} : _ref$setTaskCustomFie,
            _ref$loadNextWorkflow = _ref.loadNextWorkflowStatuses,
            loadNextWorkflowStatuses = _ref$loadNextWorkflow === undefined ? function () {} : _ref$loadNextWorkflow,
            _ref$changeTasksSorti = _ref.changeTasksSortingAction,
            changeTasksSortingAction = _ref$changeTasksSorti === undefined ? function () {} : _ref$changeTasksSorti,
            _ref$toast = _ref.toast,
            toast = _ref$toast === undefined ? function () {} : _ref$toast;

        _classCallCheck(this, TaskManagementMediator);

        var _this = _possibleConstructorReturn(this, (TaskManagementMediator.__proto__ || Object.getPrototypeOf(TaskManagementMediator)).call(this));

        _this._loadTasksErrorHandler = function (jqXHR, textStatus, errorThrown) {
            switch (errorThrown.exception) {
                case _ExceptionsTypes.NO_SUCH_PROJECT_EXCEPTION:
                    return _this.showAlertAndReloadPage("task.list.error.load_tasks.no_such_project");
                case _ExceptionsTypes.PROJECT_IS_NOT_AVAILABLE_EXCEPTION:
                case _ExceptionsTypes.PROJECT_IS_NOT_ASSIGNED_EXCEPTION:
                    return _this.showAlertAndReloadPage("task.list.error.load_tasks.project_not_assigned");
                case _ExceptionsTypes.NO_SUCH_CUSTOMER_EXCEPTION:
                    return _this.showAlertAndReloadPage("project.edit.customer_deleted_concurrently");
                case _ExceptionsTypes.CUSTOMER_UNAVAILABLE_EXCEPTION:
                    return _this.showAlertAndReloadPage("customer.edit.not_assigned_concurrently");
                default:
                    alert(_messageResource2.default.getMessage("task.list.error.load_tasks.no_network"));
            }
            return false;
        };

        _this._loadTasksNextErrorHandler = function (error) {
            if ((0, _utils3.isNotFoundError)(error, _constants3.ApiEntityTypes.CustomField)) {
                _this.actions.changeTasksSortingAction(_constants2.TaskTableDefaultSorting);
                return true;
            } else if ((0, _utils3.isUnauthenticated)(error)) {
                _this.showAlertAndReloadPage("error.js.json_rpc.session_expired");
                return true;
            }
            return false;
        };

        _this.data = data;

        _this.actions = {
            changeTaskSelected: changeTaskSelected,
            changeSelectAllTasks: changeSelectAllTasks,
            openTaskPanel: openTaskPanel,
            openProjectPanel: openProjectPanel,
            openCustomerPanel: openCustomerPanel,
            changeTaskNameFilterAction: changeTaskNameFilterAction,
            addNewTasks: addNewTasks,
            changeSingleCPSelectionAction: changeSingleCPSelectionAction,
            changeCPSelection: changeCPSelection,
            addCustomers: addCustomers,
            addProjects: addProjects,
            addTasks: addTasks,
            setTypesOfWork: setTypesOfWork,
            setTasksTableLoaded: setTasksTableLoaded,
            setKanbanLoaded: setKanbanLoaded,
            setManagementAssignments: setManagementAssignments,
            setViewerSettings: setViewerSettings,
            setHasManageableTasks: setHasManageableTasks,
            removeTasks: removeTasks,
            removeProject: removeProject,
            removeCustomer: removeCustomer,
            setRecentlyCreatedCustomers: setRecentlyCreatedCustomers,
            setRecentlyCreatedProjects: setRecentlyCreatedProjects,
            setWorkflowStatusesList: setWorkflowStatusesList,
            copyTasksToProjectsAction: copyTasksToProjectsAction,
            archiveProjectsOfCustomer: archiveProjectsOfCustomer,
            archiveProject: archiveProject,
            changedTaskWorkflowStatus: changedTaskWorkflowStatus,
            setLoadedTaskIds: setLoadedTaskIds,
            addLoadedTaskIds: addLoadedTaskIds,
            toggleLoadingMoire: toggleLoadingMoire,
            updateEnabledFeatures: updateEnabledFeatures,
            loadTaskCustomFields: loadTaskCustomFields,
            setTaskCustomFields: setTaskCustomFields,
            loadNextWorkflowStatuses: loadNextWorkflowStatuses,
            changeTasksSortingAction: changeTasksSortingAction,
            toast: toast
        };

        _this.state = {
            viewMode: null,
            showLoadingMoire: false,
            bulkOperationProgress: 0,
            selectedTaskIds: {},
            taskStatusFilter: {
                allSelected: false,
                statusIds: [],
                statusTypes: []
            },
            customFieldsFilters: {},
            filterCustomerProjectSelection: {
                customers: [],
                projects: [],
                qualifier: _CustomerProjectSelection2.default.ALL,
                activeOnly: false
            },
            singleCustomerProjectSelection: {
                customerId: null,
                projectId: null
            },
            intersectedCustomerProjectSelection: {},
            taskNameFilter: '',
            workflowStatusesMap: {},
            tasksSorting: {
                by: '',
                asc: false
            },
            isNeedToReloadTableTasks: false,
            taskIdWithDetailsOpen: null,
            viewerSettings: {
                hasEditHierarchyRight: false,
                hasAccessToAllManagementScope: false,
                canAccessCompleteTaskInformation: false
            },
            managementAssignments: {
                isAllScopeAssigned: false,
                customers: {},
                projects: {},
                tasks: {}
            },
            showOnlyManageableTasks: false,
            loggedInUser: null,
            twsEnabled: false,
            isWASEnabled: false,
            projects: {},
            customers: {},
            isPossibleToAddTasks: false
        };

        _this.onStatePropertyBecameTrue('isNeedToReloadTableTasks', function () {
            _this.loadTasks(true);
        });

        _this.onStatePropertyChanged("viewMode", function (viewMode) {
            return _this._updateViewMode(viewMode);
        });

        //TODO deprecated
        _this.onStatePropertyChanged('selectedTaskIds', function (selectedTaskIds) {
            // synchronize with old store may be need to connect TaskTable with store
            _TaskManagementStore2.default.setTaskSelection({
                isAllSelected: false,
                selectedTasks: selectedTaskIds
            });
        });

        _this.onStatePropertyChanged('showLoadingMoire', function (show) {
            _this.pageLoadingMoire.toggle(show);
        });

        _this.onStatePropertyChanged('bulkOperationProgress', function (progress) {
            _this.bulkProgress.setState({ progress: progress });
            if (progress === null) {
                _this.bulkProgress.setState({ longTimeWarningShown: false });
            }
        });

        _this.onStatePropertyChanged('taskNameFilter', function (taskNameFilter) {
            _TaskManagementStore2.default.setTaskNameFilter(taskNameFilter);
        });
        _this.onStatePropertyChanged('taskIdWithDetailsOpen', function (taskId, prevTaskId) {
            if (taskId !== null) (0, _jquery2.default)(document).trigger('taskManagement_task_startEditing', taskId);
            if (prevTaskId !== null) (0, _jquery2.default)(document).trigger('taskManagement_task_stopEditing', prevTaskId);
        });

        _this.onAnyStatePropertyChanged(['viewerSettings', 'managementAssignments'], function () {
            _this.projectPanelController.updatePanelManagementsAssignmentsState(_this.state.viewerSettings, _this.state.managementAssignments);
        });
        return _this;
    }

    _createClass(TaskManagementMediator, [{
        key: "getPage",
        value: function getPage() {
            return this.page;
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            this.loadInitialData();
            this.initStore();
            this.initComponents();
            this.subscribeToEvents();
        }
    }, {
        key: "loadInitialData",
        value: function loadInitialData() {
            this.actions.loadTaskCustomFields();
            this.actions.loadNextWorkflowStatuses();
        }
    }, {
        key: "initStore",
        value: function initStore() {
            StoreUtils.mergeCustomersProjectsFromJSP(this.data);
            _TaskManagementStore2.default.setTaskStatusFilter(this.state.taskStatusFilter);
        }
    }, {
        key: "initComponents",
        value: function initComponents() {
            var _this2 = this;

            var self = this;

            new _PageFeatureDiffController2.default().init();

            this.page = new _Page2.default().init((0, _jquery2.default)("body"));
            this.customersProjectsPanel = new _CustomersProjectsPanel2.default({
                importTasksCb: function importTasksCb() {
                    return _this2._showImportTasksPopup();
                },
                createNewTasksCb: function createNewTasksCb() {
                    return _this2._showCreateTaskPopup();
                },
                createNewProjectCb: function createNewProjectCb() {
                    return _this2._showCreateProjectPopup();
                },
                createNewCustomerCb: function createNewCustomerCb() {
                    return _this2._showCreateCustomerPopup();
                }
            }).init((0, _jquery2.default)(".cpTreeBlock"));

            this.page.adjustSize();

            var $taskListBlock = (0, _jquery2.default)("#taskListBlock");
            this.headerPanel = new _HeaderPanel2.default().init($taskListBlock);
            this.tasksTable = new _TasksTable2.default().init($taskListBlock);
            this.kanbanViewContainer = new _KanbanViewContainer2.default({}).init($taskListBlock);

            new _Container2.default({
                $pageEl: self.page.$el,
                $dialogsContainerEl: (0, _jquery2.default)(".taskListBlockWrapper"),
                $containerEl: $taskListBlock
            }).init();

            new _SelectionController2.default().init();

            this.customerPanelController = new _CustomerPanelController2.default().init();

            (0, _jquery2.default)(this.customerPanelController).on("deleteBegin", function () {
                self.pageLoadingMoire.show();
            });
            (0, _jquery2.default)(this.customerPanelController).on("deleteEnd", function () {
                self.pageLoadingMoire.hide();
            });
            (0, _jquery2.default)(this.customerPanelController).on("hidePanel", function (e, data) {
                (0, _jquery2.default)(document).trigger("taskManagement_customerViewEnd", data.customerId);
                if (data.changed && _CustomerProjectSelection2.default.fromPlainObject(self.state.intersectedCustomerProjectSelection).includesCustomer(_CustomerStore2.default.get(data.customerId), true)) {
                    self.tasksTable.updateRows();
                }
            });

            new _EditTaskPanelContainer2.default({
                onTaskMovedCb: function onTaskMovedCb(taskId) {
                    return _this2.tasksTable.updateRow(taskId);
                }
            }).init();

            new _CreateTaskPanelContainer2.default().init();

            this.projectPanelController = new _ProjectPanelController2.default().init();

            (0, _jquery2.default)(this.projectPanelController).on("projectCannotBeModified customerCannotBeModified", function () {
                self._updateAll();
            });

            (0, _jquery2.default)(this.projectPanelController).on("projectMoved", function (e, projectId) {
                self.actions.addProjects([projectId]);
                if (self.state.singleCustomerProjectSelection.projectId === projectId) {
                    var selection = {
                        customerId: _ProjectStore2.default.get(projectId).customerId,
                        projectId: projectId
                    };
                    self.actions.changeSingleCPSelectionAction(selection);
                }
            });
            (0, _jquery2.default)(this.projectPanelController).on("deleteBegin", function () {
                self.pageLoadingMoire.show();
            });
            (0, _jquery2.default)(this.projectPanelController).on("deleteEnd", function () {
                self.pageLoadingMoire.hide();
            });
            (0, _jquery2.default)(this.projectPanelController).on("hidePanel", function (e, data) {
                (0, _jquery2.default)(document).trigger("taskManagement_projectViewEnd", data.projectId);
                if (data.changed) {
                    self.tasksTable.updateRows();
                }
            });

            (0, _jquery2.default)(document).on('task_added_to_timesheet_event', function (_, hasError) {
                return hasError ? alert(_messageResource2.default.getMessage("api.error.unexpected_error")) : _this2.actions.toast(_messageResource2.default.getMessage("add_to_timesheet.tasks.toast"));
            });

            this.loadTasksFromCSVManager = new _LoadTasksFromCSVManager2.default().init(this.data.importCsv.actionUrl, window.SystemSettings.csvSeparator, this.data.importCsv.errorCodes, this.data.importCsv.errorMessages, function (projectIds) {
                return self._onImportFromCsvCompleted(projectIds);
            }, function (_ref2) {
                var customers = _ref2.customers,
                    projects = _ref2.projects;

                self.actions.addCustomers(customers);
                self.actions.addProjects(projects);
            }, function (typesOfWork) {
                self.actions.setTypesOfWork(typesOfWork);
            }, function (customFields) {
                self.actions.setTaskCustomFields(customFields);
            }, function (error) {
                return _this2._loadTasksNextErrorHandler(error);
            });

            this.bulkProgress = new _BulkOperationProgress2.default();

            this.pageLoadingMoire = new _LoadingMoire2.default({
                innerContent: this.bulkProgress,
                additionalSpinnerSettings: {
                    radius: 17,
                    length: 13,
                    width: 4
                },
                delay: 500
            }).init((0, _jquery2.default)('body'));

            this.createTasksPopupContorller = new _CreateTasksPopupController2.default({
                successTaskCreationCb: function successTaskCreationCb(res) {
                    _this2.actions.setWorkflowStatusesList(res.workflowStatuses);
                    _this2._appendCreatedTasks(res);
                },
                serviceName: "TaskManagementService"
            });

            this.createProjectPopupController = new _CreateProjectPopupController2.default({
                createProjectSuccessCb: function createProjectSuccessCb(result) {
                    return _this2._createProjectSuccess(result);
                },
                createProjectFailureCb: function createProjectFailureCb(result) {
                    return _this2._createProjectFailure(result);
                },
                setTypesOfWorkCb: this.actions.setTypesOfWork
            });

            this.createCustomerPopupController = new _CreateCustomerPopupController2.default({
                createCustomerStartCb: function createCustomerStartCb() {
                    return _this2.actions.toggleLoadingMoire(true);
                },
                createCustomerSuccessCb: function createCustomerSuccessCb(result) {
                    return _this2._onCreateCustomerSuccess(result);
                },
                createCustomerFailureCb: function createCustomerFailureCb() {
                    return _this2.actions.toggleLoadingMoire(false);
                },
                copyTasksCb: this.actions.copyTasksToProjectsAction
            });

            new _urlHelper2.default({
                openCreateTaskPopup: function openCreateTaskPopup() {
                    if (_this2.state.isPossibleToAddTasks) {
                        _this2.createTasksPopupContorller.showPopup();
                    }
                }
            }).init();
        }
    }, {
        key: "subscribeToEvents",
        value: function subscribeToEvents() {
            var _this3 = this;

            var self = this;
            (0, _jquery2.default)(document).on("taskManagement_tasksTable_allCustomersClick taskManagement_tasksTable_allTasksClick " + "taskManagement_customersProjectsPanel_allCustomersNode_select", function () {
                var selection = { customerId: null, projectId: null };
                self.actions.changeSingleCPSelectionAction(selection);
            });
            (0, _jquery2.default)(document).on("taskManagement_tasksTable_customerClick", function () {
                var selection = { customerId: self.state.singleCustomerProjectSelection.customerId, projectId: null };
                self.actions.changeSingleCPSelectionAction(selection);
            });
            (0, _jquery2.default)(document).on("taskManagement_tasksTable_scrollToEnd", function () {
                if (!_TaskManagementStore2.default.isAllTasksLoaded()) {
                    _this3.loadTasks(false);
                }
            });
            (0, _jquery2.default)(document).on("taskManagement_tasksTable_tasksSearchField_change", function (e, text) {
                _TaskManagementStore2.default.setTaskNameFilter(text);
                self.actions.changeTaskNameFilterAction(text);
            });
            (0, _jquery2.default)(document).on("taskManagement_tasksTable_taskRow_statusChange", function (e, changeData) {

                var workflowStatusBean = self.state.workflowStatusesMap[changeData.workflowStatusId];
                var workflowStatusEnabled = self.state.twsEnabled;
                var method = workflowStatusEnabled ? 'TaskManagementService.updateTaskWorkflowStatus' : 'TaskManagementService.updateTaskStatus';

                var params = workflowStatusEnabled ? [changeData.taskId, workflowStatusBean.type, workflowStatusBean.id, workflowStatusBean.name, false] : [changeData.taskId, workflowStatusBean.type, false];
                self.updateTask(method, params, changeData.taskId);
            });
            (0, _jquery2.default)(document).on("taskManagement_tasksTable_taskRow_estimateChange", function (e, changeData) {
                self.updateTask("TaskManagementService.updateTaskEstimatedTime", [changeData.taskId, changeData.estimatedTime], changeData.taskId);
            });
            (0, _jquery2.default)(document).on("taskManagement_tasksTable_taskRow_deadlineChange", function (e, changeData) {
                self.updateTask("TaskManagementService.updateTaskDeadline", [changeData.taskId, changeData.deadline], changeData.taskId);
            });
            (0, _jquery2.default)(document).on("taskManagement_customersProjectsPanel_projectNode_select", function (e, projectId) {
                var project = _ProjectStore2.default.get(projectId);
                var selection = { customerId: project.customerId, projectId: projectId };
                self.actions.changeSingleCPSelectionAction(selection);
            });
            (0, _jquery2.default)(document).on("taskManagement_customersProjectsPanel_customerNode_select", function (e, customerId) {
                var selection = { customerId: customerId, projectId: null };
                self.actions.changeSingleCPSelectionAction(selection);
            });

            (0, _jquery2.default)(document).on("taskManagement_taskTable_taskRow_selectionChange", function (e, data) {
                _this3.actions.changeTaskSelected(data.taskId, data.isSelected);
            });

            (0, _jquery2.default)(document).on("taskManagement_taskTable_selectAllChange", function () {
                _this3.actions.changeSelectAllTasks();
            });

            (0, _jquery2.default)(document).on("taskManagement_tasksTable_addNewTaskMenu_importTasks", function () {
                self._showImportTasksPopup();
            });

            (0, _jquery2.default)(document).on("taskManagement_viewCustomer", function (e, customerId) {
                var prevCustomerId = self.customerPanelController.customerId;

                if (prevCustomerId) (0, _jquery2.default)(document).trigger("taskManagement_customerViewEnd", prevCustomerId);

                self.actions.openCustomerPanel(customerId);
            });

            (0, _jquery2.default)(document).on("taskManagement_customersProjectsPanel_viewProject", function (e, projectId) {
                var prevProjectId = self.projectPanelController.projectId;

                if (prevProjectId) {
                    (0, _jquery2.default)(document).trigger("taskManagement_projectViewEnd", prevProjectId);
                }

                self.actions.openProjectPanel(projectId);
            });

            (0, _jquery2.default)(document).on('editTaskPanel_updateTask', function (e, _ref3) {
                var taskId = _ref3.taskId;
                return _this3.tasksTable.updateRow(taskId);
            });

            (0, _jquery2.default)(document).on(_syncCallbacks.exportErrorEvent, function (e, err) {
                if ((0, _rpcUtils.isAborted)(err)) return;

                if ((0, _utils3.isNetworkError)(err)) {
                    alert(_messageResource2.default.getMessage("task.list.error.load_tasks.no_network"));
                } else if ((0, _utils3.isNextApiError)(err)) {
                    _this3._loadTasksNextErrorHandler(err);
                } else if (err instanceof _RpcError2.default) {
                    _this3._loadTasksErrorHandler(err.jqXHR, err.textStatus, err.errorThrown);
                }
            });
        }
    }, {
        key: "loadTasks",
        value: function loadTasks(isReload) {
            var _this4 = this;

            (0, _jquery2.default)(document).trigger(isReload ? "taskManagement_loadTasks_withReload_begin" : "taskManagement_loadTasks_withAppend_begin");

            (0, _connector.makeLoadTasksRequest)({
                intersectedCPSelection: this.state.intersectedCustomerProjectSelection,
                taskStatusFilter: this.state.taskStatusFilter,
                customFieldsFilters: this.state.customFieldsFilters,
                taskNameFilter: this.state.taskNameFilter,
                showOnlyManageableTasks: this.state.showOnlyManageableTasks,
                taskSorting: this.state.tasksSorting,
                offset: isReload ? 0 : _TaskManagementStore2.default.getTaskIds().length,
                limit: _constants2.TASK_LOAD_LIMIT,
                // TODO: remove after https://jira.actimind.com/browse/AT-10481
                noRetry: true
            }).then(function (data) {
                _this4.actions.setTypesOfWork(data['billingTypes']['list']);

                if (_this4.state.twsEnabled) {
                    _this4.actions.setWorkflowStatusesList(data['workflowStatuses']);
                }

                StoreUtils.mergeCustomersProjectsFromRPC(data.customers, data.projects);
                var loadedTasks = data["tasks"].map(function (task) {
                    return (0, _utils2.taskFromRpc)(task);
                });
                var taskIds = _underscore2.default.pluck(loadedTasks, "id");

                _TaskManagementStore2.default.setAllTasksLoaded(loadedTasks.length < _constants2.TASK_LOAD_LIMIT);
                _this4.actions.addTasks(loadedTasks);

                if (isReload) {
                    _this4.intersectWithSelectedTasks(taskIds);
                    _this4.actions.setTasksTableLoaded(true);
                }

                _this4.actions.setManagementAssignments(data["managementAssignments"]);
                _this4.actions.setHasManageableTasks(data["hasManageableTasks"]);

                if (isReload) {
                    _TaskManagementStore2.default.replaceTaskIds(taskIds);

                    _this4.actions.setLoadedTaskIds(taskIds);
                } else {
                    _TaskManagementStore2.default.appendTaskIds(taskIds);

                    _this4.actions.addLoadedTaskIds(taskIds);
                }
            }).catch(function (error) {
                _this4.actions.setTasksTableLoaded(true);
                if ((0, _utils3.isNextApiError)(error)) {
                    return _this4._loadTasksNextErrorHandler(error);
                }
                if (error.getTextStatus() === "rpc_customException") {
                    return _this4._loadTasksErrorHandler(error.getJQXHR(), error.getTextStatus(), error.getErrorThrown());
                }

                return false;
            });
        }
    }, {
        key: "intersectWithSelectedTasks",
        value: function intersectWithSelectedTasks(taskIds) {
            var selectedTaskIds = _TaskManagementStore2.default.getSelectedTasks();
            var filteredTaskIds = _underscore2.default.filter(taskIds, function (key) {
                return !!selectedTaskIds[key];
            });
            var filteredTaskIdsMap = _underscore2.default.pick(selectedTaskIds, filteredTaskIds);

            _TaskManagementStore2.default.setTaskSelection({
                isAllSelected: false,
                selectedTasks: filteredTaskIdsMap,
                countLoading: false,
                count: filteredTaskIds.length
            });
        }
    }, {
        key: "updateTask",
        value: function updateTask(rpcMethod, rpcParams, taskId) {
            var _this5 = this;

            var self = this;
            var prevTask = _TaskStore2.default.get(taskId);
            return (0, _jquery_rpc2.default)(rpcMethod, rpcParams, function (data) {
                _ClassicBridge2.default.getTasksAfterModification([prevTask.id]).then(function (nextTasks) {
                    var task = (0, _utils2.taskFromRpc)(data["task"]);
                    task.spentTime = prevTask.spentTime; // do not overwrite

                    if (nextTasks) {
                        task = (0, _utils3.mergeClassicAndNextTask)(task, nextTasks[0]);
                    }

                    var project = (0, _utils2.projectFromRpc)(data["project"]);
                    var customer = (0, _utils2.customerFromRpc)(data["customer"]);

                    self.actions.addTasks([task]);

                    // TODO: remove this hot fix(trying to understand what method was called)
                    if (rpcMethod.indexOf("Status") !== -1) {
                        self.actions.changedTaskWorkflowStatus({
                            taskId: taskId,
                            workflowStatusId: task.workflowStatusId,
                            prevWorkflowStatusId: prevTask.workflowStatusId
                        });
                        (0, _actions8.toast)(_messageResource2.default.getMessage("status.tasks.toast.singular", [task.name]));
                    }
                    if (!_underscore2.default.isEqual(_ProjectStore2.default.get(task.projectId), project) || !_underscore2.default.isEqual(_CustomerStore2.default.get(project.customerId), customer)) {
                        _ProjectStore2.default.add(project);
                        self.actions.addProjects([project]);
                        _CustomerStore2.default.add(customer);
                        self.actions.addCustomers([customer]);
                    }

                    (0, _jquery2.default)(document).trigger("taskManagement_taskUpdated", task.id);
                });
            }, function (jqXHR, textStatus, errorThrown) {
                if (textStatus === "rpc_customException") {
                    switch (errorThrown.exception) {
                        case _ExceptionsTypes.NO_SUCH_TASK_EXCEPTION:
                            self.actions.removeTasks([taskId]);
                            alert(_messageResource2.default.getMessage("task.error.concurrently_deleted.cannot_edit"));
                            return true;
                        case _ExceptionsTypes.TASK_UNAVAILABLE_EXCEPTION:
                            self.actions.removeTasks([taskId]);
                            alert(_messageResource2.default.getMessage("task.list.error.update_task.task_unavailable"));
                            return true;
                        case _ExceptionsTypes.TASK_CANNOT_BE_MODIFIED_EXCEPTION:
                            return _get(TaskManagementMediator.prototype.__proto__ || Object.getPrototypeOf(TaskManagementMediator.prototype), "showAlertAndReloadPage", _this5).call(_this5, "common.no_rights_for_operation_anymore");
                        case _ExceptionsTypes.PROJECT_IS_NOT_AVAILABLE_EXCEPTION:
                            alert(_messageResource2.default.getMessage("common.no_rights_for_operation_anymore"));
                            _ProjectStore2.default.remove(prevTask.projectId);
                            self.actions.removeProject(prevTask.projectId);
                            return true;
                        case _ExceptionsTypes.PROJECT_CANNOT_BE_MODIFIED_EXCEPTION:
                            alert(_messageResource2.default.getMessage("common.no_rights_for_operation_anymore"));
                            self._updateAll();
                            return true;
                        case _ExceptionsTypes.CUSTOMER_UNAVAILABLE_EXCEPTION:
                            alert(_messageResource2.default.getMessage("common.no_rights_for_operation_anymore"));
                            _CustomerStore2.default.remove(prevTask.customerId);
                            self.actions.removeCustomer(prevTask.customerId);
                            return true;
                        case _ExceptionsTypes.CUSTOMER_CANNOT_BE_MODIFIED_EXCEPTION:
                            alert(_messageResource2.default.getMessage("common.no_rights_for_operation_anymore"));
                            self._updateAll();
                            return true;
                        case _ExceptionsTypes.TASK_ESTIMATE_DISABLED_EXCEPTION:
                            return _get(TaskManagementMediator.prototype.__proto__ || Object.getPrototypeOf(TaskManagementMediator.prototype), "showAlertAndReloadPage", _this5).call(_this5, "task.list.error.estimate_off");
                        case _ExceptionsTypes.PROJECT_IS_ARCHIVED_EXCEPTION:
                            // confirm reopening of archived project containing this task
                            if (confirm(_messageResource2.default.getMessage('task.error.reopen.project_archived'))) {
                                var newRpcParams = rpcParams.slice();
                                newRpcParams.pop();
                                newRpcParams.push(true);
                                self.updateTask(rpcMethod, newRpcParams, taskId);
                            } else {
                                (0, _jquery2.default)(document).trigger("taskManagement_taskUpdated", prevTask.id);
                            }
                            return true;
                        case _ExceptionsTypes.WORKFLOW_STATUS_CHANGED_EXCEPTION:
                            return _get(TaskManagementMediator.prototype.__proto__ || Object.getPrototypeOf(TaskManagementMediator.prototype), "showAlertAndReloadPage", _this5).call(_this5, "change_tasks_workflow_status.workflow_status_changed_error");
                        case _ExceptionsTypes.NO_SUCH_WORKFLOW_STATUSES_EXCEPTION:
                            return _get(TaskManagementMediator.prototype.__proto__ || Object.getPrototypeOf(TaskManagementMediator.prototype), "showAlertAndReloadPage", _this5).call(_this5, "change_tasks_workflow_status.no_such_workflow_status_error");
                        case _ExceptionsTypes.WORKFLOW_STATUSES_FEATURE_BECOME_ENABLED_EXCEPTION:
                            return _get(TaskManagementMediator.prototype.__proto__ || Object.getPrototypeOf(TaskManagementMediator.prototype), "showAlertAndReloadPage", _this5).call(_this5, "change_tasks_workflow_status.feature_became_enabled");
                        case _ExceptionsTypes.WORKFLOW_STATUSES_FEATURE_BECAME_DISABLED_EXCEPTION:
                            return _get(TaskManagementMediator.prototype.__proto__ || Object.getPrototypeOf(TaskManagementMediator.prototype), "showAlertAndReloadPage", _this5).call(_this5, "change_tasks_workflow_status.feature_became_disabled");
                    }
                }

                return false;
            });
        }
    }, {
        key: "_showImportTasksPopup",
        value: function _showImportTasksPopup() {
            this.loadTasksFromCSVManager.showPopup();
        }
    }, {
        key: "_onImportFromCsvCompleted",
        value: function _onImportFromCsvCompleted(projectIds) {
            if (projectIds.length > 0) {
                this._updateVisibleCustomersProjectsAfterNewDataLoaded(new _CustomerProjectSelection2.default(_constants.CustomersProjectsSelectionQualifier.SELECTED, [], projectIds), { customerId: null, projectId: null });
                this._markTaskShortcutIfPresent();
            }
        }
    }, {
        key: "_showCreateTaskPopup",
        value: function _showCreateTaskPopup() {
            var singleSelection = this.state.singleCustomerProjectSelection;
            this.createTasksPopupContorller.showPopup(singleSelection.customerId, singleSelection.projectId, null, true);
        }
    }, {
        key: "_appendCreatedTasks",
        value: function _appendCreatedTasks(result) {
            var _this6 = this;

            var createdTasks = result["createdTasks"].list;

            // mark shortcuts for tasks
            if (createdTasks.length > 0) {
                this._markTaskShortcutIfPresent();
            }

            var createdTaskIds = [];
            var currentSingleCPSelection = this.state.singleCustomerProjectSelection;

            var newProjectCreated = !this.state.projects[createdTasks.find(function (taskInfo) {
                return taskInfo.project.id;
            })];
            var affectedProjectsSet = {};
            var affectedCustomersSet = {};
            var tasksIdsInCurrentSelection = [];
            _underscore2.default.forEach(createdTasks, function (taskInfo) {
                var task = (0, _utils2.taskFromRpc)(taskInfo["task"]);
                var project = (0, _utils2.projectFromRpc)(taskInfo["project"]);
                var customer = (0, _utils2.customerFromRpc)(taskInfo["customer"]);

                _this6.actions.addTasks([task]);
                _ProjectStore2.default.addFirst(project);
                _this6.actions.addProjects([project]);
                _CustomerStore2.default.addFirst(customer);
                _this6.actions.addCustomers([customer]);

                var noNeedToChangeSelection = (_underscore2.default.isNull(currentSingleCPSelection.customerId) || currentSingleCPSelection.customerId === customer.id) && _underscore2.default.isNull(currentSingleCPSelection.projectId) && !newProjectCreated || currentSingleCPSelection.customerId === customer.id && currentSingleCPSelection.projectId === project.id;
                if (noNeedToChangeSelection) tasksIdsInCurrentSelection.push(task.id);

                createdTaskIds.push(task.id);

                affectedProjectsSet[project.id] = true;
                affectedCustomersSet[customer.id] = true;
            });

            var affectedCustomerIds = Object.keys(affectedCustomersSet);
            var affectedProjectIds = Object.keys(affectedProjectsSet);

            var singleSelectionByCreatedTasks = {
                customerId: affectedProjectIds.length === 1 ? createdTasks[0].customer.id : null,
                projectId: affectedProjectIds.length === 1 ? affectedProjectIds[0] : null
            };

            if (_underscore2.default.isEmpty(tasksIdsInCurrentSelection) || affectedProjectIds.length > 1) {
                this.actions.changeSingleCPSelectionAction(singleSelectionByCreatedTasks);
                (0, _jquery2.default)(_TaskManagementStore2.default).one('createdTaskIdsReset', function () {
                    _TaskManagementStore2.default.replaceCreatedTaskIds(createdTaskIds);
                });
            } else {
                _TaskManagementStore2.default.appendCreatedTaskIds(tasksIdsInCurrentSelection);
            }

            (0, _actions8.toast)((0, _utils2.createdTasksToast)(createdTaskIds, affectedProjectIds, affectedCustomerIds));

            var tasks = createdTasks.map(function (taskData) {
                return _extends({}, (0, _utils2.taskFromRpc)(taskData['task']));
            });
            var projects = createdTasks.map(function (taskData) {
                return _extends({}, (0, _utils2.projectFromRpc)(taskData['project']));
            });
            var customers = createdTasks.map(function (taskData) {
                return _extends({}, (0, _utils2.customerFromRpc)(taskData['customer']));
            });
            this.actions.addNewTasks({
                tasks: tasks,
                projects: projects,
                customers: customers
            });

            this.actions.setRecentlyCreatedCustomers(affectedCustomerIds.filter(function (cId) {
                return !_this6.state.customers[cId];
            }));
            this.actions.setRecentlyCreatedProjects(affectedProjectIds.filter(function (pId) {
                return !_this6.state.projects[pId];
            }));
        }
    }, {
        key: "_createProjectSuccess",
        value: function _createProjectSuccess(result) {
            var _this7 = this;

            var customer = (0, _utils2.customerFromRpc)(result["customer"]);
            _CustomerStore2.default.addFirst(customer);
            this.actions.addCustomers([customer]);

            var project = (0, _utils2.projectFromRpc)(result["project"]);
            project.archived = false;
            _ProjectStore2.default.addFirst(project);
            this.actions.addProjects([project]);
            this.actions.setRecentlyCreatedProjects([project.id]);

            var createdTaskList = result["tasks"].list;
            if (createdTaskList.length > 0) {
                this._markTaskShortcutIfPresent();
            }
            var createdTaskIds = [];
            createdTaskList.forEach(function (taskInfo) {
                var task = (0, _utils2.taskFromRpc)(taskInfo);
                _this7.actions.addTasks([task]);
                createdTaskIds.push(task.id);
            });

            var newFilterCpSelection = _CustomerProjectSelection2.default.fromPlainObject(this.state.filterCustomerProjectSelection);

            var isCreatedProjectCustomerSelected = newFilterCpSelection.includesCustomer(customer);

            if (newFilterCpSelection.qualifier === _constants.CustomersProjectsSelectionQualifier.SELECTED && !isCreatedProjectCustomerSelected) {
                newFilterCpSelection = new _CustomerProjectSelection2.default(_constants.CustomersProjectsSelectionQualifier.SELECTED, newFilterCpSelection.customers, newFilterCpSelection.projects.concat(project.id));
            }
            this._updateVisibleCustomersProjectsAfterNewDataLoaded(newFilterCpSelection, { customerId: customer.id, projectId: project.id });

            (0, _actions8.toast)(_messageResource2.default.getMessage("create.project.toast", [project.name]));
            if (_CustomerProjectSelection2.default.fromPlainObject(this.state.filterCustomerProjectSelection).includesProject(project)) {
                this.actions.changeSingleCPSelectionAction({ customerId: customer.id, projectId: project.id });
            }
        }
    }, {
        key: "_createProjectFailure",
        value: function _createProjectFailure(jqXHR, textStatus, errorThrown) {
            console.log(errorThrown);
        }
    }, {
        key: "_showCreateCustomerPopup",
        value: function _showCreateCustomerPopup() {
            this.createCustomerPopupController.showPopup();
        }
    }, {
        key: "_onCreateCustomerSuccess",
        value: function _onCreateCustomerSuccess(result) {
            // TODO: this piece of code is very similar to handlers for creating projects and tasks from popups

            this.actions.toggleLoadingMoire(false);
            var customer = (0, _utils2.customerFromRpc)(result["customer"]);
            _CustomerStore2.default.addFirst(customer);
            this.actions.addCustomers([customer]);

            // if tasks copied (aka created) need to check shortcut
            if (result["taskIds"] && result["taskIds"].length > 0) {
                this._markTaskShortcutIfPresent();
            }

            if (result["projects"]) {
                var projects = result["projects"].list.map(function (data) {
                    var p = (0, _utils2.projectFromRpc)(data);
                    p.archived = false;
                    return p;
                });
                _ProjectStore2.default.mergeAll(projects);
                this.actions.addProjects(projects);
            }

            var newFilterCpSelection = _CustomerProjectSelection2.default.fromPlainObject(this.state.filterCustomerProjectSelection);
            if (newFilterCpSelection.qualifier === _constants.CustomersProjectsSelectionQualifier.SELECTED) newFilterCpSelection = new _CustomerProjectSelection2.default(_constants.CustomersProjectsSelectionQualifier.SELECTED, newFilterCpSelection.customers.concat(customer.id), newFilterCpSelection.projects);
            this._updateVisibleCustomersProjectsAfterNewDataLoaded(newFilterCpSelection, { customerId: customer.id, projectId: null });
            this.actions.setRecentlyCreatedCustomers([customer.id]);

            (0, _actions8.toast)(_messageResource2.default.getMessage("create.customer.toast", [customer.name]));
            if (_CustomerProjectSelection2.default.fromPlainObject(this.state.filterCustomerProjectSelection).includesCustomer(customer)) this.actions.changeSingleCPSelectionAction({ customerId: customer.id, projectId: null });
        }
    }, {
        key: "_showCreateProjectPopup",
        value: function _showCreateProjectPopup() {
            var singleSelection = this.state.singleCustomerProjectSelection;
            var customerId = !_underscore2.default.isNull(singleSelection.customerId) ? singleSelection.customerId : null;

            this.createProjectPopupController.showPopup(customerId);
        }
    }, {
        key: "_updateVisibleCustomersProjectsAfterNewDataLoaded",
        value: function _updateVisibleCustomersProjectsAfterNewDataLoaded(newFilterCpSelection, newSingleCpSelection) {
            this.actions.changeCPSelection(newSingleCpSelection, newFilterCpSelection.toPlainObject());
        }
    }, {
        key: "_updateAll",
        value: function _updateAll() {
            // need to reload all view modes
            this.actions.setTasksTableLoaded(false);
            this.actions.setKanbanLoaded(false);
        }
    }, {
        key: "_triggerTaskEdited",
        value: function _triggerTaskEdited(taskId) {
            _TaskManagementStore2.default.setTaskIdInEdit(null);
            (0, _jquery2.default)(document).trigger('taskManagement_task_stopEditing', taskId);
        }
    }, {
        key: "_triggerTaskUpdated",
        value: function _triggerTaskUpdated(taskId) {
            (0, _jquery2.default)(document).trigger('taskManagement_task_updated_in_panel', taskId);
        }
    }, {
        key: "_handleCustomerArchived",
        value: function _handleCustomerArchived(customer) {
            this.actions.archiveProjectsOfCustomer(customer.id);
            this.tasksTable.updateRows();
        }
    }, {
        key: "_markTaskShortcutIfPresent",
        value: function _markTaskShortcutIfPresent() {
            // mark on client that task(s) will be created and show just checked shortcut
            if (!_underscore2.default.isUndefined(window.GettingStartedShortcuts)) {
                window.GettingStartedShortcuts.markShortcutAsChecked(window.GettingStartedShortcut.TASKS);
                window.GettingStartedShortcuts.showJustCheckedShortcutIfExists();
            }
        }
    }, {
        key: "_updateViewMode",
        value: function _updateViewMode(viewMode) {
            this.tasksTable.toggle(viewMode === _constants2.TaskManagementViewMode.TABLE);
            this.kanbanViewContainer.toggle(viewMode === _constants2.TaskManagementViewMode.KANBAN);
        }
    }]);

    return TaskManagementMediator;
}(_PageMediator3.default);

exports.default = (0, _utils.connect)(function (state) {
    return {
        viewMode: (0, _selectors2.getViewMode)(state),
        selectedTaskIds: (0, _selectors8.getSelectedTaskIds)(state),
        showLoadingMoire: (0, _selectors9.isShowLoadingMoire)(state),
        bulkOperationProgress: (0, _selectors.getBulkOperationProgress)(state),
        filterCustomerProjectSelection: (0, _selectors2.getFilterCPSelection)(state),
        singleCustomerProjectSelection: (0, _selectors2.getSingleCPSelection)(state),
        intersectedCustomerProjectSelection: (0, _selectors2.getIntersectedCPSelection)(state),
        taskNameFilter: (0, _selectors2.getTaskNameFilter)(state),
        taskStatusFilter: (0, _selectors2.getTaskStatusFilter)(state),
        customFieldsFilters: (0, _selectors2.getCustomFieldsFilters)(state),
        workflowStatusesMap: (0, _selectors4.getWorkflowStatuses)(state),
        tasksSorting: (0, _selectors3.getTasksSorting)(state),
        isNeedToReloadTableTasks: (0, _selectors3.isNeedToReloadTasks)(state),
        taskIdWithDetailsOpen: (0, _selectors5.getOpenTaskId)(state),
        showOnlyManageableTasks: (0, _selectors2.isShowOnlyManageableTasks)(state),
        loggedInUser: (0, _selectors6.getLoggedInUser)(state),
        twsEnabled: (0, _selectors7.isTWSEnabled)(state),
        isWASEnabled: (0, _selectors7.isWASEnabled)(state),
        projects: (0, _selectors4.getProjects)(state),
        customers: (0, _selectors4.getCustomers)(state),
        isPossibleToAddTasks: (0, _selectors2.isPossibleToAddTasks)(state)
    };
}, function (dispatch) {
    return {
        openTaskPanel: (0, _redux.bindActionCreators)(_actions7.openEditTaskPanel, dispatch),
        openProjectPanel: (0, _redux.bindActionCreators)(_actions5.openProjectPanel, dispatch),
        openCustomerPanel: (0, _redux.bindActionCreators)(_actions6.openCustomerPanel, dispatch),
        changeSelectAllTasks: (0, _redux.bindActionCreators)(_actions3.changeAllTasksSelectedAction, dispatch),
        changeTaskSelected: (0, _redux.bindActionCreators)(_actions11.changeTaskSelected, dispatch),
        changeTaskNameFilterAction: (0, _redux.bindActionCreators)(_actions.changeTaskNameFilterAction, dispatch),
        addNewTasks: (0, _redux.bindActionCreators)(_actions.addNewTasks, dispatch),
        addCustomers: (0, _redux.bindActionCreators)(_actions2.addCustomers, dispatch),
        addProjects: (0, _redux.bindActionCreators)(_actions2.addProjects, dispatch),
        addTasks: (0, _redux.bindActionCreators)(_actions.addTasks, dispatch),
        setTypesOfWork: (0, _redux.bindActionCreators)(_actions2.setTypesOfWorkList, dispatch),
        removeTasks: (0, _redux.bindActionCreators)(_actions.removeTasks, dispatch),
        removeProject: (0, _redux.bindActionCreators)(_actions.removeProject, dispatch),
        removeCustomer: (0, _redux.bindActionCreators)(_actions.removeCustomer, dispatch),
        changeSingleCPSelectionAction: (0, _redux.bindActionCreators)(_actions.changeSingleCPSelectionAction, dispatch),
        changeCPSelection: (0, _redux.bindActionCreators)(_actions.changeCPSelection, dispatch),
        setTasksTableLoaded: (0, _redux.bindActionCreators)(_actions3.setLoaded, dispatch),
        setKanbanLoaded: (0, _redux.bindActionCreators)(_actions4.setLoaded, dispatch),
        setManagementAssignments: (0, _redux.bindActionCreators)(_actions.setManagementAssignments, dispatch),
        setViewerSettings: (0, _redux.bindActionCreators)(_actions.setViewerSettings, dispatch),
        setHasManageableTasks: (0, _redux.bindActionCreators)(_actions.setHasManageableTasks, dispatch),
        setRecentlyCreatedCustomers: (0, _redux.bindActionCreators)(_actions.setRecentlyCreatedCustomers, dispatch),
        setRecentlyCreatedProjects: (0, _redux.bindActionCreators)(_actions.setRecentlyCreatedProjects, dispatch),
        setWorkflowStatusesList: (0, _redux.bindActionCreators)(_actions2.setWorkflowStatusesList, dispatch),
        copyTasksToProjectsAction: (0, _redux.bindActionCreators)(_actions9.copyTasksToProjectsAction, dispatch),
        archiveProjectsOfCustomer: (0, _redux.bindActionCreators)(_actions.archiveProjectsOfCustomerAndReloadTasks, dispatch),
        archiveProject: (0, _redux.bindActionCreators)(_actions.archiveProjectAndReloadTasks, dispatch),
        changedTaskWorkflowStatus: (0, _redux.bindActionCreators)(_actions10.changedTaskWorkflowStatus, dispatch),
        setLoadedTaskIds: (0, _redux.bindActionCreators)(_actions3.setLoadedTaskIds, dispatch),
        addLoadedTaskIds: (0, _redux.bindActionCreators)(_actions3.addLoadedTaskIds, dispatch),
        toggleLoadingMoire: (0, _redux.bindActionCreators)(_actions.toggleLoadingMoire, dispatch),
        updateEnabledFeatures: (0, _redux.bindActionCreators)(_actions12.setEnabledFeatures, dispatch),
        loadTaskCustomFields: (0, _redux.bindActionCreators)(_actions13.loadCustomFields, dispatch),
        setTaskCustomFields: (0, _redux.bindActionCreators)(_actions13.setCustomFields, dispatch),
        loadNextWorkflowStatuses: (0, _redux.bindActionCreators)(_actions.loadNextWorkflowStatuses, dispatch),
        changeTasksSortingAction: (0, _redux.bindActionCreators)(_actions3.changeTasksSortingAction, dispatch),
        toast: (0, _redux.bindActionCreators)(_actions8.toast, dispatch)
    };
})(TaskManagementMediator);

/***/ }),
/* 1809 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TasksTable = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _TaskManagementStore = __webpack_require__(140);

var _TaskManagementStore2 = _interopRequireDefault(_TaskManagementStore);

var _utils = __webpack_require__(6);

var _redux = __webpack_require__(7);

var _selectors = __webpack_require__(82);

var _actions = __webpack_require__(195);

var _selectors2 = __webpack_require__(27);

var _TaskTableHeader = __webpack_require__(1810);

var _TaskTableHeader2 = _interopRequireDefault(_TaskTableHeader);

var _TaskRowsTableContent = __webpack_require__(1812);

var _TaskRowsTableContent2 = _interopRequireDefault(_TaskRowsTableContent);

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _AutoScrollableWrapper = __webpack_require__(401);

var _AutoScrollableWrapper2 = _interopRequireDefault(_AutoScrollableWrapper);

var _constants = __webpack_require__(44);

var _atBrowserUtils = __webpack_require__(8);

var _selectors3 = __webpack_require__(106);

var _TasksNotFoundMessage = __webpack_require__(923);

var _TasksNotFoundMessage2 = _interopRequireDefault(_TasksNotFoundMessage);

var _selectors4 = __webpack_require__(307);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TasksTable = exports.TasksTable = function (_TemplateView) {
    _inherits(TasksTable, _TemplateView);

    function TasksTable(_ref) {
        var _ref$changeTasksSorti = _ref.changeTasksSortingAction,
            changeTasksSortingAction = _ref$changeTasksSorti === undefined ? function () {} : _ref$changeTasksSorti,
            _ref$updateTaskTypeOf = _ref.updateTaskTypeOfWork,
            updateTaskTypeOfWork = _ref$updateTaskTypeOf === undefined ? function () {} : _ref$updateTaskTypeOf;

        _classCallCheck(this, TasksTable);

        var _this = _possibleConstructorReturn(this, (TasksTable.__proto__ || Object.getPrototypeOf(TasksTable)).call(this));

        _this._onScrollCb = function (scrollPosition) {
            _this.header.setState({ isScrolling: scrollPosition !== 0 });
        };

        _this.updateOnInit = true;

        _this.actions = {
            changeTasksSortingAction: changeTasksSortingAction,
            updateTaskTypeOfWork: updateTaskTypeOfWork
        };

        _this.state = {
            sorting: {
                by: '',
                asc: false
            },

            archivedProjectIds: {},
            viewerSettings: {
                hasEditHierarchyRight: false,
                hasAccessToAllManagementScope: false,
                canAccessCompleteTaskInformation: false
            },
            manageableTaskIds: {},
            editableProjectIds: {},
            showSelection: false,
            singleCPSelection: {},
            selectedTaskIds: {},
            bulkOperationsPanelShown: false,
            columnsWithOrder: [],
            isCPPanelClosed: false,
            scrollToTopButtonShifted: false
        };

        _this.onAnyStatePropertyChanged(['viewerSettings', 'manageableTaskIds', 'showSelection', 'editableProjectIds'], function () {
            _this._updateTaskSelectionView();
        });

        _this.onStatePropertyChanged('selectedTaskIds', function () {
            _this._updateTaskSelectionView();
        });

        _this.onStatePropertyChanged('scrollToTopButtonShifted', function (scrollToTopButtonShifted) {
            _this.getEl().toggleClass('scrollToTopButtonShifted', scrollToTopButtonShifted);
        });
        return _this;
    }

    _createClass(TasksTable, [{
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='tasksTable'></div>";
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            var _this2 = this;

            this.header = new _TaskTableHeader2.default();

            this.taskRowsTableContent = new _TaskRowsTableContent2.default({
                afterWidthChanged: function afterWidthChanged() {
                    return _this2.taskTableContentHorizontalScrollWrapper.refreshScroll();
                }
            });

            this.registerChildComponents(this.taskRowsTableContent);

            this.taskTableContentVerticalScrollWrapper = new _AutoScrollableWrapper2.default({
                components: [this.taskRowsTableContent],
                additionalClasses: 'tasksTableVerticalScrollContainer',
                autoScrollEnabled: false,
                enableVerticalScroll: true,
                verticalScrollConfig: {
                    probeType: 2
                },
                verticalScrollContainerClass: 'tasksTable',
                showScrollToTopButton: true,
                scrollToTopButtonAdditionalClass: 'tasksTableVerticalScrollToTopButton',
                onVerticalScrollCb: this._onScrollCb,
                onScrollToBottom: function onScrollToBottom() {
                    if (!_this2.suppressScrollCheck) {
                        (0, _jquery2.default)(document).trigger("taskManagement_tasksTable_scrollToEnd");
                        _this2.suppressScrollCheck = true;
                    }
                }
            });

            var tasksTableHorizontalScrollableWrapper = 'tasksTableHorizontalScrollableWrapper';
            this.taskTableContentHorizontalScrollWrapper = new _AutoScrollableWrapper2.default({
                components: [this.header, this.taskTableContentVerticalScrollWrapper],
                additionalClasses: tasksTableHorizontalScrollableWrapper,
                autoScrollEnabled: false,
                enableHorizontalScroll: true,
                horizontalScrollConfig: {
                    probeType: 2,
                    mouseWheel: false
                },
                onHorizontalScrollCb: this._onScrollCb
            });

            this.taskTableContentHorizontalScrollWrapper.init(this.getEl());

            this.tasksNotFoundMessage = new _TasksNotFoundMessage2.default().init(this.find("." + tasksTableHorizontalScrollableWrapper));

            this.$el.toggleClass("incompleteTaskInformation", !this.state.viewerSettings.canAccessCompleteTaskInformation);

            (0, _jquery2.default)(_TaskManagementStore2.default).on("taskIdsReplace", function () {
                _this2._clearTaskRows();
                _underscore2.default.each(_TaskManagementStore2.default.getCreatedTaskIds(), function (taskId) {
                    _this2.taskRowsTableContent.addNewCreatedTaskRow(taskId);
                });
                _this2._appendTaskRows();
                _this2._updateCpSelectionClasses();
            });

            (0, _jquery2.default)(_TaskManagementStore2.default).on("taskIdsAppend", function () {
                return _this2._appendTaskRows();
            });
            (0, _jquery2.default)(_TaskManagementStore2.default).on("createdTaskIdsAppend", function (e, taskIds) {
                return _this2._appendCreatedTaskRows(taskIds);
            });

            // TODO bakharev: convert to callback
            (0, _jquery2.default)(document).on("taskManagement_tasksTable_taskRow_typeOfWorkChange", function (e, _ref2) {
                var taskId = _ref2.taskId,
                    typeOfWorkId = _ref2.typeOfWorkId;

                _this2.actions.updateTaskTypeOfWork(taskId, typeOfWorkId);
            });

            (0, _jquery2.default)(document).on("taskManagement_removeTasks", function (e, taskIds) {
                if (_underscore2.default.isUndefined(taskIds)) return;

                _this2.taskRowsTableContent.removeRows(taskIds);

                _this2._updateNoTasksMessage(_this2.taskRowsTableContent.isTaskRowsEmpty());

                _this2.taskTableContentVerticalScrollWrapper.refreshScroll();
            });

            this.taskRowsTableContent.showReloadLoadingMoire();

            if ((0, _atBrowserUtils.isMSIE)()) {
                this.onAnyStatePropertyChanged(['isCPPanelClosed', 'columnsWithOrder'], _underscore2.default.debounce(function () {
                    return _this2._setWidthsForIE();
                }, 500));
                (0, _jquery2.default)(window).resize(_underscore2.default.debounce(function () {
                    return _this2._setWidthsForIE();
                }, 500));
            }
        }
    }, {
        key: "_setWidthsForIE",
        value: function _setWidthsForIE() {
            var fixWidthColumnsWidth = 165; // status column  width

            var columnsWithOrder = this.state.columnsWithOrder;
            if (this.state.showSelection) fixWidthColumnsWidth += 40;
            if (columnsWithOrder.includes(_constants.TaskSortBy.TYPE_OF_WORK)) fixWidthColumnsWidth += 165;
            if (columnsWithOrder.includes(_constants.TaskSortBy.ESTIMATE)) fixWidthColumnsWidth += 100;
            if (columnsWithOrder.includes(_constants.TaskSortBy.SPENT_TIME)) fixWidthColumnsWidth += 100;
            if (columnsWithOrder.includes(_constants.TaskSortBy.DEADLINE)) fixWidthColumnsWidth += 185;
            if (columnsWithOrder.includes(_constants.TaskSortBy.LAST_TRACKING_DATE)) fixWidthColumnsWidth += 160;
            if (columnsWithOrder.includes(_constants.TaskSortBy.CREATION_DATE)) fixWidthColumnsWidth += 140;
            fixWidthColumnsWidth += 40; // config column

            var tableComponentWidth = this.find('.tasksTableHorizontalScrollableWrapper').width();
            var namesColumnWidth = 275;
            var remainder = tableComponentWidth - fixWidthColumnsWidth;
            if (remainder > namesColumnWidth) namesColumnWidth = remainder;
            var innerScrollableContainerWidth = fixWidthColumnsWidth + namesColumnWidth;

            var $names = this.find('.names');
            $names.css({ "flex": "auto" });
            $names.width(namesColumnWidth);
            var $innerScrollableContainer = this.find('.innerScrollableContainer');
            $innerScrollableContainer.css({ "min-width": innerScrollableContainerWidth + "px" });

            this.taskTableContentHorizontalScrollWrapper.refreshScroll();
        }
    }, {
        key: "_updateTaskSelectionView",
        value: function _updateTaskSelectionView() {
            var selectedTaskIds = this.state.selectedTaskIds;
            this.taskRowsTableContent.clearTasksSelection();
            this._updateTaskRowsSelection(selectedTaskIds);
        }
    }, {
        key: "_updateTaskRowsSelection",
        value: function _updateTaskRowsSelection(selectedTaskIds) {
            if (this.state.showSelection) this.taskRowsTableContent.setTasksSelected(selectedTaskIds);
        }
    }, {
        key: "_clearTaskRows",
        value: function _clearTaskRows() {
            this.taskRowsTableContent.clearRows();
        }
    }, {
        key: "_appendTaskRows",
        value: function _appendTaskRows() {
            var taskIds = _TaskManagementStore2.default.getTaskIds();
            this.taskRowsTableContent.appendTaskRows(taskIds, true);
            this.taskRowsTableContent.hideLoadingMoires();
            this.suppressScrollCheck = false;
            this._updateView(taskIds.length);
        }
    }, {
        key: "_appendCreatedTaskRows",
        value: function _appendCreatedTaskRows(createdTaskIds) {
            this.taskRowsTableContent.appendCreatedTaskRows(createdTaskIds, true);
            this._updateView(createdTaskIds.length);
        }
    }, {
        key: "_updateCpSelectionClasses",
        value: function _updateCpSelectionClasses() {
            this.$el.toggleClass("hasSelectedCustomer", !!this.state.singleCPSelection.customerId);
            this.$el.toggleClass("hasSelectedProject", !!this.state.singleCPSelection.projectId);
        }
    }, {
        key: "updateRows",
        value: function updateRows() {
            this.taskRowsTableContent.updateRows();
        }
    }, {
        key: "updateRow",
        value: function updateRow(id) {
            this.taskRowsTableContent.updateRow(id);
        }
    }, {
        key: "_updateView",
        value: function _updateView(tasksCount) {
            this._updateTaskSelectionView();
            this.$el.toggleClass("allTasksLoaded", _TaskManagementStore2.default.isAllTasksLoaded());
            this._updateNoTasksMessage(tasksCount === 0);
            this.taskTableContentVerticalScrollWrapper.refreshScroll();
        }
    }, {
        key: "_updateNoTasksMessage",
        value: function _updateNoTasksMessage(taskRowsEmpty) {
            var taskNameFilterEmpty = !_TaskManagementStore2.default.getTaskNameFilter();
            this.$el.toggleClass("noTasks", taskRowsEmpty && taskNameFilterEmpty);
            this.$el.toggleClass("noTasksFound", taskRowsEmpty && !taskNameFilterEmpty);
            this.find('.tasksTablesWrapper').toggle(!taskRowsEmpty);
        }
    }, {
        key: "show",
        value: function show() {
            _get(TasksTable.prototype.__proto__ || Object.getPrototypeOf(TasksTable.prototype), "show", this).call(this);
            this.taskTableContentHorizontalScrollWrapper.show();
        }
    }]);

    return TasksTable;
}(_TemplateView3.default);

exports.default = (0, _utils.connect)(function (state) {
    return {
        sorting: (0, _selectors.getTasksSorting)(state),
        archivedProjectIds: (0, _selectors.getArchivedProjectIds)(state),
        viewerSettings: (0, _selectors2.getViewerSettings)(state),
        manageableTaskIds: (0, _selectors2.getManageableTaskIds)(state),
        editableProjectIds: (0, _selectors2.getEditableProjectIds)(state),
        showSelection: (0, _selectors2.isNeedToShowSelection)(state),
        singleCPSelection: (0, _selectors2.getSingleCPSelection)(state),
        selectedTaskIds: (0, _selectors3.getSelectedTaskIds)(state),
        bulkOperationsPanelShown: (0, _selectors2.isBulkOperationsPanelShown)(state),
        columnsWithOrder: (0, _selectors.getShownColumnsWithOrder)(state),
        isCPPanelClosed: (0, _selectors2.isCPPanelClosed)(state),
        scrollToTopButtonShifted: (0, _selectors4.showSupportQuestionButton)(state)
    };
}, function (dispatch) {
    return {
        changeTasksSortingAction: (0, _redux.bindActionCreators)(_actions.changeTasksSortingAction, dispatch),
        updateTaskTypeOfWork: (0, _redux.bindActionCreators)(_actions.updateTaskTypeOfWork, dispatch)
    };
})(TasksTable);

/***/ }),
/* 1810 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _constants = __webpack_require__(44);

var _SortableTableHeader = __webpack_require__(495);

var _SortableTableHeader2 = _interopRequireDefault(_SortableTableHeader);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _TaskSelectionLabel = __webpack_require__(920);

var _TaskSelectionLabel2 = _interopRequireDefault(_TaskSelectionLabel);

var _actions = __webpack_require__(195);

var _selectors = __webpack_require__(82);

var _selectors2 = __webpack_require__(27);

var _utils = __webpack_require__(6);

var _redux = __webpack_require__(7);

var _selectors3 = __webpack_require__(15);

var _selectors4 = __webpack_require__(106);

var _SimpleTooltip = __webpack_require__(36);

var _SimpleTooltip2 = _interopRequireDefault(_SimpleTooltip);

var _SummaryRow = __webpack_require__(1811);

var _SummaryRow2 = _interopRequireDefault(_SummaryRow);

var _ClassicBridge = __webpack_require__(18);

var _ClassicBridge2 = _interopRequireDefault(_ClassicBridge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TaskTableHeader = function (_TemplateView) {
    _inherits(TaskTableHeader, _TemplateView);

    function TaskTableHeader(_ref) {
        var _ref$changeTasksSorti = _ref.changeTasksSortingAction,
            changeTasksSortingAction = _ref$changeTasksSorti === undefined ? function () {} : _ref$changeTasksSorti,
            _ref$updateTaskTypeOf = _ref.updateTaskTypeOfWork,
            updateTaskTypeOfWork = _ref$updateTaskTypeOf === undefined ? function () {} : _ref$updateTaskTypeOf;

        _classCallCheck(this, TaskTableHeader);

        var _this = _possibleConstructorReturn(this, (TaskTableHeader.__proto__ || Object.getPrototypeOf(TaskTableHeader)).call(this));

        _this.actions = {
            changeTasksSortingAction: changeTasksSortingAction,
            updateTaskTypeOfWork: updateTaskTypeOfWork
        };

        _this.state = {
            isScrolling: false,
            isTWSEnabled: null,
            isBTYEnabled: null,
            isESTEnabled: null,

            sorting: {
                by: '',
                asc: false
            },

            showSelection: false,
            allTaskSelected: false,
            selectAllDisabled: false,
            isSummaryRowShown: false,

            columnsOrder: [],
            singleCustomerProjectSelection: {},

            customFields: {}
        };

        _this.onStatePropertyChanged('singleCustomerProjectSelection', function (singleCustomerProjectSelection) {
            if (singleCustomerProjectSelection.customerId && !singleCustomerProjectSelection.projectId) {
                _this._toggleCptSortButtons(false, true);
            } else if (singleCustomerProjectSelection.customerId && singleCustomerProjectSelection.projectId) {
                _this._toggleCptSortButtons(false, false);
            } else {
                _this._toggleCptSortButtons(true, true);
            }
        });

        _this.onStatePropertyChanged('isScrolling', function (isScrolling) {
            _this.$el.toggleClass('scrolling', isScrolling);
        });

        _this.onStatePropertyChanged('sorting', function (sorting) {
            _this.setSortHeader(sorting.by, sorting.asc);
        });

        _this.onStatePropertyDeeplyChanged('customFields', function (customFields) {
            _this._removeCustomFieldsColumns();
            _this._renderCustomFieldsColumns(customFields);
            _this._registerSortingHeaderCallbacks();
        });

        _this.onStatePropertyChanged('columnsOrder', function (columnsOrder) {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = Object.values(_this.columnsMap)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var column = _step.value;

                    _this.find(".prioritySeparator").hide();
                    column.hide();
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            for (var i = 0; i < columnsOrder.length; ++i) {
                var columnKey = columnsOrder[i];
                if (!_this.columnsMap[columnKey]) continue;
                _this.columnsMap[columnKey].show();
                if (columnKey === _constants.PRIORITY_FIELD_NAME) {
                    _this.columnsMap[columnKey].show();
                    _this.find(".prioritySeparator").show();
                } else {
                    _this.columnsMap[columnKey].css('display', 'flex');
                }
                _this.columnsMap[columnKey].css('order', i.toString());
            }
        });

        _this.onStatePropertyChanged('isTWSEnabled', function (isTWSEnabled) {
            // rewrite click action on status header
            (0, _jquery2.default)(_this.statusHeader).off('click');
            (0, _jquery2.default)(_this.statusHeader).on('click', function () {
                _this.actions.changeTasksSortingAction({
                    by: isTWSEnabled ? _constants.TaskSortBy.WORKFLOW_STATUS : _constants.TaskSortBy.STATUS,
                    asc: _this.statusHeader.isAsc()
                });
            });
        });

        _this.onStatePropertyChanged('isBTYEnabled', function (isBTYEnabled) {
            _this.typeOfWorkHeader.toggle(isBTYEnabled);
        });

        _this.onStatePropertyChanged('isESTEnabled', function (isESTEnabled) {
            _this.estimateHeader.toggle(isESTEnabled);
            _this.varianceManHoursHeader.toggle(isESTEnabled);
            _this.variancePercentHeader.toggle(isESTEnabled);
            _this.varianceProgressBarHeader.toggle(isESTEnabled);
        });

        _this.onAnyStatePropertyChanged(['allTaskSelected', 'showSelection', 'selectAllDisabled'], function () {
            _this._updateAllTasksSelection();
        });

        _this.onStatePropertyChanged('isSummaryRowShown', function (isSummaryRowShown) {
            _this.summaryRow.toggle(isSummaryRowShown);
        });
        return _this;
    }

    _createClass(TaskTableHeader, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return "<table class='headerRowTable' cellpadding='0' cellspacing='0'>" + "  <tr class='headers'>" + "    <td class='selection'></td>" + "    <td class='names'>" + "      <div class='headerCellWrapper'>" + "        <div class='tipPlaceholderContainer'><span class='tipPlaceholder'></span></div>" + "        <span class='priorityHeader'><span class='customFieldHeader' /></span>" + "        <span class='shortSeparator prioritySeparator'>&nbsp;</span>" + "        <span class='customerNameHeader'></span>" + "        <span class='shortSeparator customerNameSeparator'>&nbsp;</span>" + "        <span class='projectNameHeader'></span>" + "        <span class='shortSeparator projectNameSeparator'>&nbsp;</span>" + "        <span class='taskNameHeader'></span>" + "      </div>" + "    </td>" + "    <td class='status'>" + "      <div class='headerCellWrapper'>" + "        <span class='statusHeader'></span>" + "      </div>" + "    </td>" + "    <td class='typeOfWork'>" + "      <div class='headerCellWrapper'><span class='typeOfWorkHeader'></span></div>" + "    </td>" + "    <td class='estimate'>" + "      <div class='headerCellWrapper'><span class='estimateHeader'></span></div>" + "    </td>" + "    <td class='spentTime'>" + "      <div class='headerCellWrapper'><span class='spentTimeHeader'></span></div>" + "    </td>" + "    <td class='deadline'>" + "      <div class='headerCellWrapper'><span class='deadlineHeader'></span></div>" + "    </td>" + "    <td class='lastTrackingDate'>" + "      <div class='headerCellWrapper'><span class='lastTrackingDateHeader'></span></div>" + "    </td>" + "    <td class='creationDate'>" + "      <div class='headerCellWrapper'><span class='creationDateHeader'></span></div>" + "    </td>" + "    <td class='varianceManHours'>" + "      <div class='headerCellWrapper'><span class='varianceManHoursHeader'></span></div>" + "    </td>" + "    <td class='variancePercent'>" + "      <div class='headerCellWrapper'><span class='variancePercentHeader'></span></div>" + "    </td>" + "    <td class='varianceProgressBar'>" + "      <div class='headerCellWrapper'><span class='varianceProgressBarHeader'></span></div>" + "    </td>" + "  </tr>" + "</table>";
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            var _this2 = this,
                _columnsMap;

            this.$allTaskSelection = this.find(".selection");
            this.tooltip = new _SimpleTooltip2.default().init((0, _jquery2.default)('body'));

            this.sortingHeaders = {};
            // Persistence block
            this.customerNameHeader = new _SortableTableHeader2.default(this.find(".customerNameHeader"), false, true, "common.Customer").init();
            this.customerNameSeparator = this.find(".customerNameSeparator");
            this.sortingHeaders[_constants.TaskSortBy.CUSTOMER] = this.customerNameHeader;

            this.projectNameHeader = new _SortableTableHeader2.default(this.find(".projectNameHeader"), false, true, "common.Project").init();
            this.projectNameSeparator = this.find(".projectNameSeparator");
            this.sortingHeaders[_constants.TaskSortBy.PROJECT] = this.projectNameHeader;

            this.taskNameHeader = new _SortableTableHeader2.default(this.find(".taskNameHeader"), false, true, "common.Task").init();
            this.sortingHeaders[_constants.TaskSortBy.TASK] = this.taskNameHeader;

            // this header sorting depends from feature
            this.statusHeader = new _SortableTableHeader2.default(this.find(".statusHeader"), false, true, "task.list.status").init();
            this.sortingHeaders[_constants.TaskSortBy.STATUS] = this.statusHeader;
            this.sortingHeaders[_constants.TaskSortBy.WORKFLOW_STATUS] = this.statusHeader;

            this.typeOfWorkHeader = new _SortableTableHeader2.default(this.find(" .typeOfWorkHeader"), false, true, "task.list.type_of_work").init();
            this.sortingHeaders[_constants.TaskSortBy.TYPE_OF_WORK] = this.typeOfWorkHeader;

            this.estimateHeader = new _SortableTableHeader2.default(this.find(".estimateHeader"), false, true, "task.list.estimate").init();
            this.sortingHeaders[_constants.TaskSortBy.ESTIMATE] = this.estimateHeader;

            this.deadlineHeader = new _SortableTableHeader2.default(this.find(".deadlineHeader"), false, true, "task.list.deadline").init();
            this.sortingHeaders[_constants.TaskSortBy.DEADLINE] = this.deadlineHeader;

            this.spentTimeHeader = new _SortableTableHeader2.default(this.find(".spentTimeHeader"), false, true, "task.list.spent_time").init();
            this.sortingHeaders[_constants.TaskSortBy.SPENT_TIME] = this.spentTimeHeader;

            this.lastTrackingDateHeader = new _SortableTableHeader2.default(this.find(".lastTrackingDateHeader"), false, true, "task.list.last_tracking_date").init();
            this.sortingHeaders[_constants.TaskSortBy.LAST_TRACKING_DATE] = this.lastTrackingDateHeader;

            this.creationDateHeader = new _SortableTableHeader2.default(this.find(".creationDateHeader"), false, true, "task.list.creation_date").init();
            this.sortingHeaders[_constants.TaskSortBy.CREATION_DATE] = this.creationDateHeader;

            this.varianceManHoursHeader = new _SortableTableHeader2.default(this.find(".varianceManHoursHeader"), false, true, "task.list.variance_man_hours").init();
            this.sortingHeaders[_constants.TaskSortBy.VARIANCE_MAN_HOURS] = this.varianceManHoursHeader;
            this.tooltip.subscribeToMouseEvents(this.find(".varianceManHoursHeader"), function () {
                return _this2.tooltip.setText(messageResource.getMessage("task.list.variance_man_hours.tooltip"));
            });

            this.variancePercentHeader = new _SortableTableHeader2.default(this.find(".variancePercentHeader"), false, true, "task.list.variance_percents").init();
            this.sortingHeaders[_constants.TaskSortBy.VARIANCE_PERCENTS] = this.variancePercentHeader;
            this.tooltip.subscribeToMouseEvents(this.find(".variancePercentHeader"), function () {
                return _this2.tooltip.setText(messageResource.getMessage("task.list.variance_percents.tooltip"));
            });

            this.varianceProgressBarHeader = new _SortableTableHeader2.default(this.find(".varianceProgressBarHeader"), false, true, "task.list.variance_progress_bar").init();
            this.sortingHeaders[_constants.TaskSortBy.VARIANCE_PROGRESS_BAR] = this.varianceProgressBarHeader;

            this.summaryRow = new _SummaryRow2.default().init(this.find("tbody"));
            this.summaryRow.hide();

            this.columnsMap = (_columnsMap = {}, _defineProperty(_columnsMap, _constants.TaskTableConfigurableColumns.ESTIMATE, this.find("td.estimate")), _defineProperty(_columnsMap, _constants.TaskTableConfigurableColumns.DEADLINE, this.find("td.deadline")), _defineProperty(_columnsMap, _constants.TaskTableConfigurableColumns.CREATION_DATE, this.find("td.creationDate")), _defineProperty(_columnsMap, _constants.TaskTableConfigurableColumns.LAST_TRACKING_DATE, this.find("td.lastTrackingDate")), _defineProperty(_columnsMap, _constants.TaskTableConfigurableColumns.SPENT_TIME, this.find("td.spentTime")), _defineProperty(_columnsMap, _constants.TaskTableConfigurableColumns.TYPE_OF_WORK, this.find("td.typeOfWork")), _defineProperty(_columnsMap, _constants.TaskTableConfigurableColumns.VARIANCE_MAN_HOURS, this.find("td.varianceManHours")), _defineProperty(_columnsMap, _constants.TaskTableConfigurableColumns.VARIANCE_PERCENTS, this.find("td.variancePercent")), _defineProperty(_columnsMap, _constants.TaskTableConfigurableColumns.VARIANCE_PROGRESS_BAR, this.find("td.varianceProgressBar")), _columnsMap);

            this._registerSortingHeaderCallbacks();
        }
    }, {
        key: 'setSortHeader',
        value: function setSortHeader(by, asc) {
            var byWorkflowStatus = by === _constants.TaskSortBy.WORKFLOW_STATUS;
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = Object.keys(this.sortingHeaders)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var key = _step2.value;

                    var sortingHeader = this.sortingHeaders[key];
                    if (byWorkflowStatus && key !== _constants.TaskSortBy.STATUS || !byWorkflowStatus && key === _constants.TaskSortBy.STATUS || key !== _constants.TaskSortBy.STATUS && key !== _constants.TaskSortBy.WORKFLOW_STATUS) {
                        if (key === by) {
                            sortingHeader.setActive(true);
                            sortingHeader.setAsc(asc);
                        } else {
                            sortingHeader.setActive(false);
                        }
                    }
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }
        }
    }, {
        key: '_toggleCptSortButtons',
        value: function _toggleCptSortButtons(showCustomer, showProject) {
            this.customerNameHeader.toggle(showCustomer);
            this.customerNameSeparator.toggle(showCustomer);
            this.projectNameHeader.toggle(showProject);
            this.projectNameSeparator.toggle(showProject);

            if (!showCustomer && this.state.sorting.by === _constants.TaskSortBy.CUSTOMER) {
                if (showProject) {
                    this.setSortHeader(_constants.TaskSortBy.PROJECT, this.state.sorting.asc);
                } else {
                    this.setSortHeader(_constants.TaskSortBy.TASK, this.state.sorting.asc);
                }
            } else if (!showProject && this.state.sorting.by === _constants.TaskSortBy.PROJECT) {
                this.setSortHeader(_constants.TaskSortBy.TASK, this.state.sorting.asc);
            } else {
                this.setSortHeader(this.state.sorting.by, this.state.sorting.asc);
            }
        }
    }, {
        key: '_updateAllTasksSelection',
        value: function _updateAllTasksSelection() {
            this.$allTaskSelection.empty();
            if (this.state.showSelection) {
                this.$allTaskSelection.show();
                this.allTaskSelectionLabel = new _TaskSelectionLabel2.default(this.$allTaskSelection, true).init();
                this.allTaskSelectionLabel.setSelection(this.state.allTaskSelected);
                this.allTaskSelectionLabel.setDisabled(this.state.selectAllDisabled);
                this.allTaskSelectionLabel.on("change", function (e, isAllSelected) {
                    // this.actions.changeSelectAllTasks(isAllSelected)

                    (0, _jquery2.default)(document).trigger("taskManagement_taskTable_selectAllChange", isAllSelected);
                });
            } else {
                this.$allTaskSelection.hide();
            }
        }
    }, {
        key: '_removeCustomFieldsColumns',
        value: function _removeCustomFieldsColumns() {
            var _this3 = this;

            Object.keys(this.columnsMap).filter(function (column) {
                return _ClassicBridge2.default.isCustomField(column);
            }).forEach(function (cf) {
                _this3.columnsMap[cf].remove();
                delete _this3.columnsMap[cf];
            });
        }
    }, {
        key: '_renderCustomFieldsColumns',
        value: function _renderCustomFieldsColumns(customFields) {
            var _this4 = this;

            var $headerRow = this.find('.headers');
            Object.values(customFields).forEach(function (customField) {
                var tableCell = customField.fieldName === _constants.PRIORITY_FIELD_NAME ? _this4.find(".priorityHeader") : (0, _jquery2.default)("<td class='customField'>" + "   <div class='headerCellWrapper'>" + "       <span class='customFieldHeader'>" + "       </span>" + "   </div>" + "</td>").appendTo($headerRow);
                _this4.columnsMap[customField.fieldName] = tableCell;
                tableCell.attr('title', customField.title);

                _this4.sortingHeaders[customField.fieldName] = new _SortableTableHeader2.default(tableCell.find(".customFieldHeader"), false, true, null, customField.title).init();
            });
        }
    }, {
        key: '_registerSortingHeaderCallbacks',
        value: function _registerSortingHeaderCallbacks() {
            var _this5 = this;

            var _iteratorNormalCompletion3 = true;
            var _didIteratorError3 = false;
            var _iteratorError3 = undefined;

            try {
                var _loop = function _loop() {
                    var sortingHeaderKey = _step3.value;

                    var sortingHeader = _this5.sortingHeaders[sortingHeaderKey];
                    (0, _jquery2.default)(sortingHeader).off('click');
                    (0, _jquery2.default)(sortingHeader).on('click', function () {
                        _this5.actions.changeTasksSortingAction({
                            by: sortingHeaderKey,
                            asc: sortingHeader.isAsc()
                        });
                    });
                };

                for (var _iterator3 = Object.keys(this.sortingHeaders)[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                    _loop();
                }
            } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion3 && _iterator3.return) {
                        _iterator3.return();
                    }
                } finally {
                    if (_didIteratorError3) {
                        throw _iteratorError3;
                    }
                }
            }
        }
    }]);

    return TaskTableHeader;
}(_TemplateView3.default);

exports.default = (0, _utils.connect)(function (state) {
    return {
        sorting: (0, _selectors.getTasksSorting)(state),
        archivedProjectIds: (0, _selectors.getArchivedProjectIds)(state),
        viewerSettings: (0, _selectors2.getViewerSettings)(state),
        editableTaskIds: (0, _selectors2.getEditableTaskIds)(state),
        editableProjectIds: (0, _selectors2.getEditableProjectIds)(state),
        showSelection: (0, _selectors2.isNeedToShowSelection)(state),
        isTWSEnabled: (0, _selectors3.isTWSEnabled)(state),
        isBTYEnabled: (0, _selectors3.isBTYEnabled)(state),
        isESTEnabled: (0, _selectors3.isESTEnabled)(state),
        columnsOrder: (0, _selectors.getShownColumnsWithOrder)(state),
        singleCustomerProjectSelection: (0, _selectors2.getSingleCPSelection)(state),
        allTaskSelected: (0, _selectors4.isAllTasksSelectedCheckboxChecked)(state),
        selectAllDisabled: !(0, _selectors.thereAreTableTasks)(state),
        customFields: (0, _selectors2.getTaskCustomFieldsMap)(state),
        isSummaryRowShown: (0, _selectors.getIsSummaryRowShown)(state)
    };
}, function (dispatch) {
    return {
        changeTasksSortingAction: (0, _redux.bindActionCreators)(_actions.changeTasksSortingAction, dispatch),
        updateTaskTypeOfWork: (0, _redux.bindActionCreators)(_actions.updateTaskTypeOfWork, dispatch)
    };
})(TaskTableHeader);

/***/ }),
/* 1811 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _COLUMNS_CLASSNAME_MA;

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _utils = __webpack_require__(6);

var _selectors = __webpack_require__(82);

var _selectors2 = __webpack_require__(27);

var _constants = __webpack_require__(44);

var _selectors3 = __webpack_require__(15);

var _selectors4 = __webpack_require__(82);

var _user_time = __webpack_require__(30);

var _user_time2 = _interopRequireDefault(_user_time);

var _redux = __webpack_require__(7);

var _actions = __webpack_require__(195);

var _selectors5 = __webpack_require__(106);

var _ClassicBridge = __webpack_require__(18);

var _ClassicBridge2 = _interopRequireDefault(_ClassicBridge);

var _syncCallbacks = __webpack_require__(161);

var _selectors6 = __webpack_require__(14);

var _constants2 = __webpack_require__(842);

var _constants3 = __webpack_require__(23);

var _date_format = __webpack_require__(16);

var _WorkflowStatusIcon = __webpack_require__(241);

var _WorkflowStatusIcon2 = _interopRequireDefault(_WorkflowStatusIcon);

var _selectors7 = __webpack_require__(57);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var dateFormat = new _date_format.DateFormat(window.SystemSettings.dateFormat);

var TOTAL_TASKS = 'TOTAL_TASKS';
var STATUS = 'STATUS';
var DEBOUNCE_UPDATE_DELAY = 500;

var STATIC_COLUMNS = new Set([TOTAL_TASKS, STATUS]);
var EMPTY_PLACEHOLDER = '--';

var TASK_UPDATE_EVENTS = ["taskManagement_tasksMovedTo", "taskManagement_taskUpdated", "taskManagement_removeTasks", "editTaskPanel_updateTask", "taskManagement_task_startEditing", "taskManagement_tasksStatusChanged", "taskManagement_projectCustomerStatusChanged", _syncCallbacks.importTasksSuccessEvent];

var COLUMNS_CLASSNAME_MAP = (_COLUMNS_CLASSNAME_MA = {}, _defineProperty(_COLUMNS_CLASSNAME_MA, TOTAL_TASKS, "totalTasks"), _defineProperty(_COLUMNS_CLASSNAME_MA, STATUS, "statusFiller"), _defineProperty(_COLUMNS_CLASSNAME_MA, _constants.TaskTableConfigurableColumns.ESTIMATE, "totalEstimate"), _defineProperty(_COLUMNS_CLASSNAME_MA, _constants.TaskTableConfigurableColumns.DEADLINE, "deadlineFiller"), _defineProperty(_COLUMNS_CLASSNAME_MA, _constants.TaskTableConfigurableColumns.CREATION_DATE, "creationDateFiller"), _defineProperty(_COLUMNS_CLASSNAME_MA, _constants.TaskTableConfigurableColumns.LAST_TRACKING_DATE, "lastTrackingDateFiller"), _defineProperty(_COLUMNS_CLASSNAME_MA, _constants.TaskTableConfigurableColumns.SPENT_TIME, "totalSpentTime"), _defineProperty(_COLUMNS_CLASSNAME_MA, _constants.TaskTableConfigurableColumns.TYPE_OF_WORK, "typeOfWorkFiller"), _defineProperty(_COLUMNS_CLASSNAME_MA, _constants.TaskTableConfigurableColumns.VARIANCE_MAN_HOURS, "totalVarianceManHours"), _defineProperty(_COLUMNS_CLASSNAME_MA, _constants.TaskTableConfigurableColumns.VARIANCE_PERCENTS, "totalVariancePercent"), _defineProperty(_COLUMNS_CLASSNAME_MA, _constants.TaskTableConfigurableColumns.VARIANCE_PROGRESS_BAR, "varianceProgressBarFiller"), _COLUMNS_CLASSNAME_MA);

var SummaryRow = function (_TemplateView) {
    _inherits(SummaryRow, _TemplateView);

    function SummaryRow(_ref) {
        var update = _ref.update;

        _classCallCheck(this, SummaryRow);

        var _this = _possibleConstructorReturn(this, (SummaryRow.__proto__ || Object.getPrototypeOf(SummaryRow)).call(this));

        _this.state = {
            columnsOrder: [],
            customFields: {},
            isBTYEnabled: null,
            isTWSEnabled: null,
            isLoaded: false,
            tasksLoaded: false,
            isNeedToReloadTableTasks: false,
            recentlyCreatedTaskIds: {},
            isShown: false,
            viewMode: _constants.TaskManagementViewMode.TABLE,
            customFieldsFilters: {},
            taskStatusFilter: {
                allSelected: false,
                statusIds: [],
                statusTypes: []
            },
            summaryRow: {},
            workflowStatuses: {}
        };
        _this.actions = {
            update: update
        };

        _this.onStatePropertyDeeplyChanged('customFields', function (customFields) {
            _this._clearCustomFieldsColumns();
            _this._renderCustomFieldsColumns(customFields);
        });

        _this.onStatePropertyChanged('columnsOrder', function (columnsOrder) {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = Object.keys(COLUMNS_CLASSNAME_MAP)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var _column = _step.value;

                    if (_this._isStaticField(_column)) continue;

                    var _columnEl = _this._findByKey(_column);
                    _columnEl.hide();
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            for (var i = 0; i < columnsOrder.length; ++i) {
                var column = columnsOrder[i];
                var columnEl = _this._findByKey(column);

                columnEl.show().css('display', 'flex');
                columnEl.css('order', i.toString());
            }

            if (columnsOrder.includes(_constants.PRIORITY_FIELD_NAME)) {
                _this._findByKey(TOTAL_TASKS).addClass('withPriority');
            }
        });

        _this.onStatePropertyChanged('isBTYEnabled', function (isBTYEnabled) {
            _this._toggleColumn(_constants.TaskTableConfigurableColumns.TYPE_OF_WORK, isBTYEnabled && _this.state.columnsOrder.includes(_constants.TaskTableConfigurableColumns.TYPE_OF_WORK));
        });

        _this.onStatePropertyChanged('isESTEnabled', function (isESTEnabled) {
            var columnsOrder = _this.state.columnsOrder;
            _this._toggleColumn(_constants.TaskTableConfigurableColumns.ESTIMATE, isESTEnabled && columnsOrder.includes(_constants.TaskTableConfigurableColumns.ESTIMATE));
            _this._toggleColumn(_constants.TaskTableConfigurableColumns.VARIANCE_MAN_HOURS, isESTEnabled && columnsOrder.includes(_constants.TaskTableConfigurableColumns.VARIANCE_MAN_HOURS));
            _this._toggleColumn(_constants.TaskTableConfigurableColumns.VARIANCE_PERCENTS, isESTEnabled && columnsOrder.includes(_constants.TaskTableConfigurableColumns.VARIANCE_PERCENTS));
            _this._toggleColumn(_constants.TaskTableConfigurableColumns.VARIANCE_PROGRESS_BAR, isESTEnabled && columnsOrder.includes(_constants.TaskTableConfigurableColumns.VARIANCE_PROGRESS_BAR));
        });

        _this.onStatePropertyChanged('isTWSEnabled', function (isTWSEnabled) {
            if (isTWSEnabled) {
                _this._renderColumnChartValue(_this._workflowStatusesBins(), COLUMNS_CLASSNAME_MAP[STATUS]);
            } else {
                _this._renderWorkstatuses();
            }
        });

        _this.onStatePropertyChanged('isLoaded', function () {
            if (_this.state.isLoaded) {
                _this._setColumnTextValue(TOTAL_TASKS, _this._totalTasks());
                _this._setColumnTextValue(_constants.TaskTableConfigurableColumns.ESTIMATE, _this._totalEstimate());
                _this._setColumnTextValue(_constants.TaskTableConfigurableColumns.SPENT_TIME, _this._totalSpentTime());
                _this._setColumnTextValue(_constants.TaskTableConfigurableColumns.VARIANCE_MAN_HOURS, _this._totalVarianceManHours());
                _this._setColumnTextValue(_constants.TaskTableConfigurableColumns.VARIANCE_PERCENTS, _this._totalVariancePercent());
                _this._setColumnTextValue(_constants.TaskTableConfigurableColumns.DEADLINE, _this._closestDeadline(), messageResource.getMessage('common.nearest'));
                _this._setColumnTextValue(_constants.TaskTableConfigurableColumns.LAST_TRACKING_DATE, _this._lastTrackingDate(), messageResource.getMessage('common.latest'));
                _this._setColumnTextValue(_constants.TaskTableConfigurableColumns.CREATION_DATE, _this._lastCreationDate(), messageResource.getMessage('common.latest'));

                if (_this.state.isTWSEnabled) {
                    _this._setColumnChartValue(STATUS, _this._workflowStatusesBins());
                } else {
                    _this._renderWorkstatuses();
                }
            } else {
                _this._renderLoadingState();
            }
            _this._updateColumnsStyle();
        });

        _this.onStatePropertyChanged('workflowstatuses', function () {
            _this._setColumnChartValue(STATUS, _this._workflowStatusesBins());
        });

        _this._debounceUpdateIfVisible = _underscore2.default.debounce(function () {
            return _this._updateIfVisible();
        }, DEBOUNCE_UPDATE_DELAY);

        _this._subscribeToUpdateEvents();
        return _this;
    }

    _createClass(SummaryRow, [{
        key: "_subscribeToUpdateEvents",
        value: function _subscribeToUpdateEvents() {
            var _this2 = this;

            TASK_UPDATE_EVENTS.forEach(function (event) {
                $(document).on(event, _this2._debounceUpdateIfVisible);
            });

            this.onAnyStatePropertyDeeplyChanged(['recentlyCreatedTaskIds', 'viewMode', 'taskNameFilter', 'cpSelection', 'showOnlyManagableTasks', 'taskStatusFilter', 'customFieldsFilters', 'isShown'], this._debounceUpdateIfVisible);
        }
    }, {
        key: "_updateIfVisible",
        value: function _updateIfVisible() {
            if (this._isVisible()) {
                this.actions.update();
            }
        }
    }, {
        key: "_isVisible",
        value: function _isVisible() {
            return this.state.isShown && this.state.viewMode === _constants.TaskManagementViewMode.TABLE;
        }
    }, {
        key: "_clearCustomFieldsColumns",
        value: function _clearCustomFieldsColumns() {
            var _this3 = this;

            Object.keys(COLUMNS_CLASSNAME_MAP).filter(function (column) {
                return _ClassicBridge2.default.isCustomField(column);
            }).forEach(function (cf) {
                return _this3._clearColumn(cf);
            });
        }
    }, {
        key: "_clearColumn",
        value: function _clearColumn(column) {
            var columnEl = this._findByKey(column);
            columnEl.remove();
            COLUMNS_CLASSNAME_MAP[column] = null;
        }
    }, {
        key: "_toggleColumn",
        value: function _toggleColumn(column, value) {
            var columnEl = this._findByKey(column);
            columnEl.toggle(value);
        }
    }, {
        key: "_setColumnTextValue",
        value: function _setColumnTextValue(column, value, label) {
            var textEl = this._findByKey(column).find(".headerCellWrapper > span");
            if (label) {
                textEl.replaceWith($("<span class=\"valueWithLabel\">\n                <span class=\"label\">" + label + "</span>\n                <span class=\"value\">" + value + "</span>\n            </span>"));
            } else {
                textEl.text(value);
            }
        }
    }, {
        key: "_setColumnChartValue",
        value: function _setColumnChartValue(column, value) {
            var columnEl = this._findByKey(column).find(".headerCellWrapper");

            if (value.length !== 0) {
                var chartEl = columnEl.find(".atNextMount.histogram");

                if (chartEl.length === 0) {
                    this._renderColumnChartValue(this._workflowStatusesBins(), COLUMNS_CLASSNAME_MAP[column]);
                } else {
                    chartEl[0].nextComponent.setProps({
                        bins: value
                    });
                }
            } else {
                columnEl.html($("<span>" + EMPTY_PLACEHOLDER + "</span>"));
            }
        }
    }, {
        key: "_updateColumnsStyle",
        value: function _updateColumnsStyle() {
            var _this4 = this;

            Object.keys(COLUMNS_CLASSNAME_MAP).forEach(function (column) {
                var columnValue = _this4._getColumnValueByKey(column);
                var columnEl = _this4._findByKey(column);
                if (column !== TOTAL_TASKS) {
                    _this4._updateEmptyStyle(columnValue, columnEl);
                }
                _this4._updateNegativeStyle(columnValue, columnEl);
            });
        }
    }, {
        key: "_updateEmptyStyle",
        value: function _updateEmptyStyle(columnValue, columnEl) {
            var isNotEmpty = _underscore2.default.isNumber(columnValue) && this.state.isLoaded;
            columnEl.toggleClass('nonEmptyFiller', isNotEmpty);
        }
    }, {
        key: "_updateNegativeStyle",
        value: function _updateNegativeStyle(columnValue, columnEl) {
            var isNegative = _underscore2.default.isNumber(columnValue) && columnValue < 0 && this.state.isLoaded;
            columnEl.toggleClass('negativeFiller', isNegative);
        }
    }, {
        key: "_renderColumnValue",
        value: function _renderColumnValue(valueElement, className) {
            var valueCell = $("<td class='" + className + "'>" + "  <div class='headerCellWrapper'></div>" + "</td>");

            valueCell.find(':last').append(valueElement);

            valueCell.appendTo(this.$el);
        }
    }, {
        key: "_renderColumnTextValue",
        value: function _renderColumnTextValue(value, className) {
            var valueElement = $("<span>" + value + "</span>");
            this._renderColumnValue(valueElement, className);
        }
    }, {
        key: "_renderColumnChartValue",
        value: function _renderColumnChartValue(value, className) {
            var chartEl = this._findByKey(STATUS).find(".headerCellWrapper");

            var valueWrapper = $("<div class='atNextMount histogram'></div>")[0];
            valueWrapper.nextComponent = _ClassicBridge2.default.integrateHistogram(valueWrapper, {
                bins: value,
                maxVisibleBinsCount: 6,
                tooltipId: className
            });
            chartEl.html(valueWrapper);
        }
    }, {
        key: "_renderWorkstatuses",
        value: function _renderWorkstatuses() {
            var columnEl = this._findByKey(STATUS).find(".headerCellWrapper");
            if (columnEl.length === 0 || !this.state.summaryRow.active) {
                columnEl.html($("<span>" + EMPTY_PLACEHOLDER + "</span>"));
            } else {
                var activeStatus = (0, _utils.unsafe_selectWithState)(function (state) {
                    return (0, _selectors7.selectStatusById)(state, (0, _selectors7.selectFakeStatusIdByTaskComplete)(false));
                });
                var inactiveStatus = (0, _utils.unsafe_selectWithState)(function (state) {
                    return (0, _selectors7.selectStatusById)(state, (0, _selectors7.selectFakeStatusIdByTaskComplete)(true));
                });

                var valueWrapper = $("<div class=\"workflowStatusesContainer\">\n                <div class=\"activeStatusIcon\" /><span class=\"workflowStatusLabel\">" + (this.state.summaryRow.active.true || EMPTY_PLACEHOLDER) + "</span>\n                <div class=\"inactiveStatusIcon\" /><span class=\"workflowStatusLabel\">" + (this.state.summaryRow.active.false || EMPTY_PLACEHOLDER) + "</span>\n            </div>");

                new _WorkflowStatusIcon2.default(null, activeStatus).init(valueWrapper.find('.activeStatusIcon'));
                new _WorkflowStatusIcon2.default(null, inactiveStatus).init(valueWrapper.find('.inactiveStatusIcon'));

                columnEl.html(valueWrapper);
            }
        }
    }, {
        key: "_renderCustomFieldsColumns",
        value: function _renderCustomFieldsColumns(customFields) {
            var _this5 = this;

            Object.values(customFields).filter(function (customField) {
                return !customField.builtin;
            }).forEach(function (customField) {
                var column = customField.fieldName;
                var className = "customFieldFiller " + column;

                COLUMNS_CLASSNAME_MAP[customField.fieldName] = column;

                _this5._renderColumnTextValue(EMPTY_PLACEHOLDER, className);
            });
        }
    }, {
        key: "_renderInitialColumns",
        value: function _renderInitialColumns() {
            var _this6 = this;

            Object.values(COLUMNS_CLASSNAME_MAP).forEach(function (className) {
                _this6._renderColumnTextValue(EMPTY_PLACEHOLDER, className);
            });
        }
    }, {
        key: "_renderLoadingState",
        value: function _renderLoadingState() {
            var _this7 = this;

            Object.keys(COLUMNS_CLASSNAME_MAP).forEach(function (column) {
                _this7._setColumnTextValue(column, column === TOTAL_TASKS ? _this7._totalTasksEmpty() : EMPTY_PLACEHOLDER);
                if (column === TOTAL_TASKS) {
                    _this7._findByKey(TOTAL_TASKS).toggleClass('nonEmptyFiller', true);
                }
            });
        }
    }, {
        key: "_totalTasks",
        value: function _totalTasks() {
            return messageResource.getMessage('task.list.header.totalTasks', [this.state.summaryRow.taskCount]);
        }
    }, {
        key: "_totalTasksEmpty",
        value: function _totalTasksEmpty() {
            return messageResource.getMessage('task.list.header.totalTasksEmpty');
        }
    }, {
        key: "_totalEstimate",
        value: function _totalEstimate() {
            var estimate = this.state.summaryRow.estimate;
            return _underscore2.default.isNumber(estimate) ? _user_time2.default.formatTimeWithDigitSeparator(estimate) : EMPTY_PLACEHOLDER;
        }
    }, {
        key: "_totalSpentTime",
        value: function _totalSpentTime() {
            return _user_time2.default.formatTimeWithDigitSeparator(this.state.summaryRow.spentTime);
        }
    }, {
        key: "_totalVarianceManHours",
        value: function _totalVarianceManHours() {
            var variance = this.state.summaryRow.variance;
            return variance && _underscore2.default.isNumber(variance.duration) ? _user_time2.default.formatTimeWithDigitSeparator(variance.duration) : EMPTY_PLACEHOLDER;
        }
    }, {
        key: "_workflowStatusesBins",
        value: function _workflowStatusesBins() {
            var _this8 = this;

            if (!this.state.summaryRow.workflowstatuses || !this.state.workflowStatuses) return [];

            var bins = Object.entries(this.state.summaryRow.workflowstatuses).map(function (_ref2) {
                var _ref3 = _slicedToArray(_ref2, 2),
                    key = _ref3[0],
                    value = _ref3[1];

                var workstatus = _this8.state.workflowStatuses[key];

                return {
                    name: workstatus.name,
                    value: value,
                    properties: [{
                        name: 'count',
                        value: value,
                        color: _constants2.PDF_OPEN_TYPE_COLOR_MAP_BY_COLOR_NAME[workstatus.colorId] + (workstatus.type === _constants3.WorkflowStatusType.OPEN ? '88' : '')
                    }]
                };
            });

            bins.sort(function (a, b) {
                return b.value - a.value;
            });
            return bins;
        }
    }, {
        key: "_totalVariancePercent",
        value: function _totalVariancePercent() {
            var variance = this.state.summaryRow.variance;
            return variance && _underscore2.default.isNumber(variance.percentage) ? (Math.round(variance.percentage * 100) / 100).toFixed(1) + '%' : EMPTY_PLACEHOLDER;
        }
    }, {
        key: "_closestDeadline",
        value: function _closestDeadline() {
            return this._renderDate(this.state.summaryRow.closestDeadline);
        }
    }, {
        key: "_lastTrackingDate",
        value: function _lastTrackingDate() {
            return this._renderDate(this.state.summaryRow.lastTrackingDate);
        }
    }, {
        key: "_lastCreationDate",
        value: function _lastCreationDate() {
            return this._renderDate(this.state.summaryRow.lastCreationDate);
        }
    }, {
        key: "_renderDate",
        value: function _renderDate(date) {
            if (!date) return EMPTY_PLACEHOLDER;

            var dateFormatted = new Date(date);
            return dateFormat.formatDate(dateFormatted);
        }
    }, {
        key: "_findByKey",
        value: function _findByKey(key) {
            return this.find("." + COLUMNS_CLASSNAME_MAP[key]);
        }
    }, {
        key: "_getColumnValueByKey",
        value: function _getColumnValueByKey(key) {
            var _TOTAL_TASKS$TaskTabl;

            return (_TOTAL_TASKS$TaskTabl = {}, _defineProperty(_TOTAL_TASKS$TaskTabl, TOTAL_TASKS, this.state.summaryRow.taskCount), _defineProperty(_TOTAL_TASKS$TaskTabl, _constants.TaskTableConfigurableColumns.ESTIMATE, this.state.summaryRow.estimate), _defineProperty(_TOTAL_TASKS$TaskTabl, _constants.TaskTableConfigurableColumns.SPENT_TIME, this.state.summaryRow.spentTime), _defineProperty(_TOTAL_TASKS$TaskTabl, _constants.TaskTableConfigurableColumns.VARIANCE_MAN_HOURS, this.state.summaryRow.variance && this.state.summaryRow.variance.duration), _defineProperty(_TOTAL_TASKS$TaskTabl, _constants.TaskTableConfigurableColumns.VARIANCE_PERCENTS, this.state.summaryRow.variance && this.state.summaryRow.variance.percentage), _defineProperty(_TOTAL_TASKS$TaskTabl, _constants.TaskTableConfigurableColumns.DEADLINE, this.state.summaryRow.closestDeadline), _defineProperty(_TOTAL_TASKS$TaskTabl, _constants.TaskTableConfigurableColumns.LAST_TRACKING_DATE, this.state.summaryRow.lastTrackingDate), _defineProperty(_TOTAL_TASKS$TaskTabl, _constants.TaskTableConfigurableColumns.CREATION_DATE, this.state.summaryRow.lastCreationDate), _TOTAL_TASKS$TaskTabl)[key];
        }
    }, {
        key: "_isStaticField",
        value: function _isStaticField(column) {
            return STATIC_COLUMNS.has(column);
        }
    }, {
        key: "templateHtml",
        value: function templateHtml() {
            return "<tr class='summary'></tr>";
        }
    }, {
        key: "toggle",
        value: function toggle(value) {
            this.setState({ isShown: value });
            _get(SummaryRow.prototype.__proto__ || Object.getPrototypeOf(SummaryRow.prototype), "toggle", this).call(this, value);
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            this.$el.hide();

            this._renderInitialColumns();
            this._renderLoadingState();
            this.renderInitialState();
        }
    }]);

    return SummaryRow;
}(_TemplateView3.default);

exports.default = (0, _utils.connect)(function (state) {
    return {
        summaryRow: (0, _selectors.getSummaryRow)(state),
        columnsOrder: (0, _selectors.getShownColumnsWithOrder)(state),
        customFields: (0, _selectors2.getTaskCustomFieldsMap)(state),
        isBTYEnabled: (0, _selectors3.isBTYEnabled)(state),
        isESTEnabled: (0, _selectors3.isESTEnabled)(state),
        isTWSEnabled: (0, _selectors3.isTWSEnabled)(state),
        isLoaded: (0, _selectors4.isSummaryRowLoaded)(state),
        tasksLoaded: (0, _selectors5.isTasksLoaded)(state),
        recentlyCreatedTaskIds: (0, _selectors2.getRecentlyCreatedTaskIds)(state),
        viewMode: (0, _selectors2.getViewMode)(state),
        cpSelection: (0, _selectors2.getIntersectedCPSelection)(state),
        taskNameFilter: (0, _selectors2.getTaskNameFilter)(state),
        taskStatusFilter: (0, _selectors2.getTaskStatusFilter)(state),
        customFieldsFilters: (0, _selectors2.getCustomFieldsFilters)(state),
        showOnlyManagableTasks: (0, _selectors2.isShowOnlyManageableTasks)(state),
        workflowStatuses: (0, _selectors6.getWorkflowStatuses)(state)
    };
}, function (dispatch) {
    return {
        update: (0, _redux.bindActionCreators)(_actions.updateSummaryRow, dispatch)
    };
})(SummaryRow);

/***/ }),
/* 1812 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TaskRowsTableContent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _redux = __webpack_require__(7);

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _LoadingMoire = __webpack_require__(92);

var _LoadingMoire2 = _interopRequireDefault(_LoadingMoire);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _TaskStore = __webpack_require__(91);

var _TaskStore2 = _interopRequireDefault(_TaskStore);

var _TaskRow = __webpack_require__(1813);

var _TaskRow2 = _interopRequireDefault(_TaskRow);

var _utils = __webpack_require__(6);

var _selectors = __webpack_require__(27);

var _selectors2 = __webpack_require__(82);

var _StringTokenizer = __webpack_require__(103);

var _StringTokenizer2 = _interopRequireDefault(_StringTokenizer);

var _TokensHighlighter = __webpack_require__(94);

var _TokensHighlighter2 = _interopRequireDefault(_TokensHighlighter);

var _actions = __webpack_require__(81);

var _selectors3 = __webpack_require__(15);

var _selectors4 = __webpack_require__(19);

var _TypeOfWorkMenu = __webpack_require__(846);

var _TaskStatusMenu = __webpack_require__(289);

var _TaskStatusMenu2 = _interopRequireDefault(_TaskStatusMenu);

var _actions2 = __webpack_require__(195);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TaskRowsTableContent = exports.TaskRowsTableContent = function (_TemplateView) {
    _inherits(TaskRowsTableContent, _TemplateView);

    function TaskRowsTableContent(_ref) {
        var _ref$openTaskPanel = _ref.openTaskPanel,
            openTaskPanel = _ref$openTaskPanel === undefined ? function () {} : _ref$openTaskPanel,
            _ref$afterWidthChange = _ref.afterWidthChanged,
            afterWidthChanged = _ref$afterWidthChange === undefined ? function () {} : _ref$afterWidthChange,
            _ref$updateTaskCustom = _ref.updateTaskCustomField,
            updateTaskCustomField = _ref$updateTaskCustom === undefined ? function () {} : _ref$updateTaskCustom;

        _classCallCheck(this, TaskRowsTableContent);

        var _this = _possibleConstructorReturn(this, (TaskRowsTableContent.__proto__ || Object.getPrototypeOf(TaskRowsTableContent)).call(this));

        _this.actions = {
            openTaskPanel: openTaskPanel,
            updateTaskCustomField: updateTaskCustomField
        };

        _this.callbacks = {
            afterWidthChanged: afterWidthChanged
        };

        _this.state = {
            manageableTaskIds: {},
            archivedProjectIds: {},
            archivedCustomerIds: {},
            editableProjectIds: {},
            editableCustomerIds: {},
            showSelection: false,
            columnsOrder: [],
            isTWSEnabled: false,
            isBTYEnabled: false,
            isESTEnabled: false,
            canEditHierarchy: false,
            canGenerateMoneyReports: false,
            canEditTaskStatus: true,
            customFields: {}
        };

        _this.onAnyStatePropertyChanged(['manageableTaskIds', 'showSelection', 'editableProjectIds', 'editableCustomerIds', 'archivedProjectIds', 'archivedCustomerIds', 'canEditHierarchy', 'canGenerateMoneyReports', 'customFields', 'canEditTaskStatus'], function () {
            _this._updateTaskRowsState();
        });

        _this.onStatePropertyChanged('isTWSEnabled', function (isTWSEnabled) {
            Object.values(_this.taskRows).forEach(function (row) {
                return row.setState({ isTWSEnabled: isTWSEnabled });
            });
        });

        _this.onStatePropertyChanged('isBTYEnabled', function (isBTYEnabled) {
            Object.values(_this.taskRows).forEach(function (row) {
                return row.setState({ isBTYEnabled: isBTYEnabled });
            });
        });

        _this.onStatePropertyChanged('isESTEnabled', function (isESTEnabled) {
            Object.values(_this.taskRows).forEach(function (row) {
                return row.setState({ isESTEnabled: isESTEnabled });
            });
        });

        _this.onStatePropertyChanged('columnsOrder', function (columnsOrder) {
            Object.values(_this.taskRows).forEach(function (row) {
                return row.setState({ columnsOrder: columnsOrder });
            });
            _this.callbacks.afterWidthChanged();
        });

        _this.taskRows = {};
        _this.stringTokenizer = null;
        _this.tokensHighligter = null;
        return _this;
    }

    _createClass(TaskRowsTableContent, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return "<div class='taskRowsTableContent'>" + "    <div class='tasksTablesWrapper'>" + "        <div class='createdTasksTableContainer'>" + "            <table class='createdTasksRowsTable' cellpadding='0' cellspacing='0'></table>" + "        </div>" + "        <div class='taskRowsTableContainer'>" + "            <table class='taskRowsTable' cellpadding='0' cellspacing='0'></table>" + "        </div>" + "    </div>" + "    <div class='loadingIndicatorContainer'></div>" + "</div>";
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            var _this2 = this;

            this.$taskRowsTable = this.find('.taskRowsTable');
            this.$createdTaskRowsTable = this.find('.createdTasksRowsTable');

            this.appendLoadingMoire = new _LoadingMoire2.default({
                additionalSpinnerSettings: {},
                showAnimated: false,
                hideAnimated: false
            }).init(this.find('.loadingIndicatorContainer'));
            this.reloadLoadingMoire = new _LoadingMoire2.default().init(this.$containerEl);

            (0, _jquery2.default)(document).on("taskManagement_task_startEditing", function (e, taskId) {
                var taskRow = _this2.taskRows[taskId];
                if (taskRow) {
                    taskRow.startEditing();
                }
            });

            (0, _jquery2.default)(document).on("taskManagement_task_stopEditing", function (e, taskId) {
                var taskRow = _this2.taskRows[taskId];
                if (taskRow) {
                    taskRow.stopEditing();
                }
            });

            (0, _jquery2.default)(document).on("taskManagement_tasksStatusChange", function (e, data) {
                var taskIds = data.taskIds;
                var workflowStatusId = data.workflowStatusId;
                var completed = data.isCompleted;

                for (var i = 0; i < taskIds.length; ++i) {
                    _this2._changeTaskStatusButton(taskIds[i], workflowStatusId, completed);
                }
            });

            this.stringTokenizer = new _StringTokenizer2.default(_StringTokenizer2.default.PUNCTUATORS_FOR_SEARCH);
            (0, _jquery2.default)(document).on("taskManagement_tasksTable_tasksSearchField_change", function (e, text) {
                var tokens = _this2.stringTokenizer.getTokens(text);
                _this2.tokensHighligter = text && tokens.length > 0 ? new _TokensHighlighter2.default(tokens, _this2.stringTokenizer.getPunctuators()) : null;
            });

            (0, _jquery2.default)(document).on("taskManagement_tasksAssignedTo", function () {
                _this2.updateRows();
            });

            (0, _jquery2.default)(document).on("taskManagement_task_updated_in_panel", function (e, taskId) {
                _this2.updateRow(taskId);
            });

            (0, _jquery2.default)(document).on("taskManagement_loadTasks_withReload_begin", function () {
                _this2.showReloadLoadingMoire();
            });
            (0, _jquery2.default)(document).on("taskManagement_loadTasks_withAppend_begin", function () {
                _this2.showAppendLoadingMoire();
            });

            this.taskStatusMenu = new _TaskStatusMenu2.default().init(this.$el);
            this.typeOfWorkMenu = new _TypeOfWorkMenu.TypeOfWorkMenu({
                additionalClass: 'tasksTableTypeOfWorkMenu'
            }).init(this.$el);
        }
    }, {
        key: 'addNewCreatedTaskRow',
        value: function addNewCreatedTaskRow(taskId) {
            this.taskRows[taskId] = new _TaskRow2.default({
                taskId: taskId,
                tokensHighlighter: this.tokensHighligter,
                openTaskPanel: this.actions.openTaskPanel,
                typeOfWorkMenu: this.typeOfWorkMenu,
                taskStatusMenu: this.taskStatusMenu,
                onCustomFieldChange: this.actions.updateTaskCustomField
            }).init(this.$createdTaskRowsTable);
        }
    }, {
        key: 'clearTasksSelection',
        value: function clearTasksSelection() {
            _underscore2.default.each(this.taskRows, function (row) {
                return row.setSelection(false);
            });
        }
    }, {
        key: 'setTasksSelected',
        value: function setTasksSelected(selectedTaskIds) {
            _underscore2.default.each(this.taskRows, function (row, id) {
                row.taskSelectionLabel.setDisabled(false);
                row.setSelection(!!selectedTaskIds[id]);
            });
        }
    }, {
        key: 'clearRows',
        value: function clearRows() {
            Object.values(this.taskRows).forEach(function (row) {
                row.clear();
            });
            this.$taskRowsTable.empty();
            this.$createdTaskRowsTable.empty();
            this.taskRows = {};
        }
    }, {
        key: 'removeRows',
        value: function removeRows(ids) {
            for (var i = 0; i < ids.length; ++i) {
                this.removeRow(ids[i]);
            }
        }
    }, {
        key: 'removeRow',
        value: function removeRow(taskId) {
            if (_underscore2.default.isUndefined(this.taskRows[taskId])) return;

            this.taskRows[taskId].fadeOut();
            this.taskRows[taskId].clear();
            this.taskRows[taskId].$el.remove();
            delete this.taskRows[taskId];
        }
    }, {
        key: 'isTaskRowsEmpty',
        value: function isTaskRowsEmpty() {
            return _underscore2.default.isEmpty(this.taskRows);
        }
    }, {
        key: 'updateRow',
        value: function updateRow(taskId) {
            var taskRow = this.taskRows[taskId];
            if (taskRow) taskRow.update();
        }
    }, {
        key: 'updateRows',
        value: function updateRows() {
            _underscore2.default.each(this.taskRows, function (row) {
                return row.update();
            });
        }
    }, {
        key: 'appendTaskRows',
        value: function appendTaskRows(taskIds, updateExisting) {
            this._updateTaskRowsInContainer(taskIds, this.$taskRowsTable, updateExisting);
        }
    }, {
        key: 'appendCreatedTaskRows',
        value: function appendCreatedTaskRows(taskIds, updateExisting) {
            this._updateTaskRowsInContainer(taskIds, this.$createdTaskRowsTable, updateExisting);
        }
    }, {
        key: 'showReloadLoadingMoire',
        value: function showReloadLoadingMoire() {
            this.reloadLoadingMoire.show();
        }
    }, {
        key: 'showAppendLoadingMoire',
        value: function showAppendLoadingMoire() {
            this.appendLoadingMoire.show();
        }
    }, {
        key: 'hideLoadingMoires',
        value: function hideLoadingMoires() {
            this.appendLoadingMoire.hide();
            this.reloadLoadingMoire.hide();
        }
    }, {
        key: '_changeTaskStatusButton',
        value: function _changeTaskStatusButton(taskId, workflowStatusId, completed) {
            if (_underscore2.default.isUndefined(this.taskRows[taskId])) return;

            this.taskRows[taskId].setState({
                workflowStatusId: workflowStatusId,
                completed: completed
            });
        }
    }, {
        key: '_updateTaskRowsState',
        value: function _updateTaskRowsState() {
            var _this3 = this;

            _underscore2.default.each(this.taskRows, function (taskRow) {
                return _this3._updateTaskRowState(taskRow);
            });
        }
    }, {
        key: '_updateTaskRowState',
        value: function _updateTaskRowState(taskRow) {
            var task = _TaskStore2.default.get(taskRow.taskId);
            var canEdit = this.state.canEditHierarchy && !!this.state.manageableTaskIds[task.id];

            taskRow.setState({
                canEdit: canEdit,
                canEditTypeOfWork: canEdit || this.state.canGenerateMoneyReports && !!this.state.manageableTaskIds[task.id],
                canEditTaskStatus: this.state.canEditTaskStatus,
                canReopenProject: !this.state.archivedProjectIds[task.projectId] || !!this.state.editableProjectIds[task.projectId] && !this.state.archivedCustomerIds[task.customerId] || !!this.state.editableCustomerIds[task.customerId],
                selectable: this.state.showSelection,
                columnsOrder: this.state.columnsOrder,
                isTWSEnabled: this.state.isTWSEnabled,
                isBTYEnabled: this.state.isBTYEnabled,
                isESTEnabled: this.state.isESTEnabled,
                singleCPSelection: this.state.singleCustomerProjectSelection,
                customFields: this.state.customFields
            });

            taskRow.update();
        }
    }, {
        key: '_updateTaskRowsInContainer',
        value: function _updateTaskRowsInContainer(taskIds, $container, updateExisting) {
            var _this4 = this;

            _underscore2.default.each(taskIds, function (taskId) {
                if (!_this4.taskRows[taskId]) {
                    _this4.taskRows[taskId] = new _TaskRow2.default({
                        taskId: taskId,
                        tokensHighlighter: _this4.tokensHighligter,
                        openTaskPanel: _this4.actions.openTaskPanel,
                        typeOfWorkMenu: _this4.typeOfWorkMenu,
                        taskStatusMenu: _this4.taskStatusMenu,
                        onCustomFieldChange: _this4.actions.updateTaskCustomField
                    }).init($container);
                } else if (updateExisting) _this4.taskRows[taskId].update();

                _this4._updateTaskRowState(_this4.taskRows[taskId]);
            }, this);
        }
    }]);

    return TaskRowsTableContent;
}(_TemplateView3.default);

exports.default = (0, _utils.connect)(function (state) {
    return {
        archivedProjectIds: (0, _selectors2.getArchivedProjectIds)(state),
        archivedCustomerIds: (0, _selectors2.getArchivedCustomerIds)(state),
        manageableTaskIds: (0, _selectors.getManageableTaskIds)(state),
        editableProjectIds: (0, _selectors.getEditableProjectIds)(state),
        editableCustomerIds: (0, _selectors.getEditableCustomerIds)(state),
        showSelection: (0, _selectors.isNeedToShowSelection)(state),
        columnsOrder: (0, _selectors2.getShownColumnsWithOrder)(state),
        isTWSEnabled: (0, _selectors3.isTWSEnabled)(state),
        isBTYEnabled: (0, _selectors3.isBTYEnabled)(state),
        isESTEnabled: (0, _selectors3.isESTEnabled)(state),
        canEditHierarchy: (0, _selectors4.canEditHierarchy)(state),
        canEditTaskStatus: (0, _selectors.canViewerEditTaskStatus)(state),
        canGenerateMoneyReports: (0, _selectors4.canGenerateMoneyReports)(state),
        singleCustomerProjectSelection: (0, _selectors.getSingleCPSelection)(state),
        customFields: (0, _selectors.getTaskCustomFieldsMap)(state)
    };
}, function (dispatch) {
    return {
        openTaskPanel: (0, _redux.bindActionCreators)(_actions.openEditTaskPanel, dispatch),
        updateTaskCustomField: (0, _redux.bindActionCreators)(_actions2.updateTaskCustomField, dispatch)
    };
})(TaskRowsTableContent);

/***/ }),
/* 1813 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _atUtils = __webpack_require__(5);

var _atBrowserUtils = __webpack_require__(8);

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _NamesCell = __webpack_require__(1814);

var _NamesCell2 = _interopRequireDefault(_NamesCell);

var _CustomerStore = __webpack_require__(65);

var _CustomerStore2 = _interopRequireDefault(_CustomerStore);

var _ProjectStore = __webpack_require__(59);

var _ProjectStore2 = _interopRequireDefault(_ProjectStore);

var _TaskStore = __webpack_require__(91);

var _TaskStore2 = _interopRequireDefault(_TaskStore);

var _TaskSelectionLabel = __webpack_require__(920);

var _TaskSelectionLabel2 = _interopRequireDefault(_TaskSelectionLabel);

var _date_format = __webpack_require__(16);

var _DeadlineEditor = __webpack_require__(1815);

var _DeadlineEditor2 = _interopRequireDefault(_DeadlineEditor);

var _TaskStatusButton = __webpack_require__(240);

var _TaskStatusButton2 = _interopRequireDefault(_TaskStatusButton);

var _selectors = __webpack_require__(57);

var _utils = __webpack_require__(6);

var _selectors2 = __webpack_require__(14);

var _TypeOfWorkButton = __webpack_require__(848);

var _TypeOfWorkButton2 = _interopRequireDefault(_TypeOfWorkButton);

var _TimeEditor = __webpack_require__(767);

var _TimeEditor2 = _interopRequireDefault(_TimeEditor);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _utils2 = __webpack_require__(25);

var _constants = __webpack_require__(44);

var _DatePickerMenu = __webpack_require__(921);

var _DatePickerMenu2 = _interopRequireDefault(_DatePickerMenu);

var _CorporateScheduleCalculator = __webpack_require__(378);

var _CorporateScheduleCalculator2 = _interopRequireDefault(_CorporateScheduleCalculator);

var _constants2 = __webpack_require__(4);

var _TextEditor = __webpack_require__(1816);

var _TextEditor2 = _interopRequireDefault(_TextEditor);

var _constants3 = __webpack_require__(922);

var _VarianceCell = __webpack_require__(1817);

var _VarianceCell2 = _interopRequireDefault(_VarianceCell);

var _ClassicBridge = __webpack_require__(18);

var _ClassicBridge2 = _interopRequireDefault(_ClassicBridge);

var _CFDropdownEditor = __webpack_require__(1818);

var _CFDropdownEditor2 = _interopRequireDefault(_CFDropdownEditor);

var _utils3 = __webpack_require__(570);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var dateFormat = new _date_format.DateFormat(window.SystemSettings.dateFormat);

var TaskRow = function (_TemplateView) {
    _inherits(TaskRow, _TemplateView);

    function TaskRow(_ref) {
        var _ref$taskId = _ref.taskId,
            taskId = _ref$taskId === undefined ? 0 : _ref$taskId,
            _ref$tokensHighlighte = _ref.tokensHighlighter,
            tokensHighlighter = _ref$tokensHighlighte === undefined ? null : _ref$tokensHighlighte,
            _ref$openTaskPanel = _ref.openTaskPanel,
            openTaskPanel = _ref$openTaskPanel === undefined ? function (id) {} : _ref$openTaskPanel,
            _ref$typeOfWorkMenu = _ref.typeOfWorkMenu,
            typeOfWorkMenu = _ref$typeOfWorkMenu === undefined ? null : _ref$typeOfWorkMenu,
            _ref$taskStatusMenu = _ref.taskStatusMenu,
            taskStatusMenu = _ref$taskStatusMenu === undefined ? null : _ref$taskStatusMenu,
            _ref$onCustomFieldCha = _ref.onCustomFieldChange,
            onCustomFieldChange = _ref$onCustomFieldCha === undefined ? function (taskId, fieldName, value) {} : _ref$onCustomFieldCha;

        _classCallCheck(this, TaskRow);

        var _this = _possibleConstructorReturn(this, (TaskRow.__proto__ || Object.getPrototypeOf(TaskRow)).call(this));

        _this.taskId = taskId;
        _this.tokensHighlighter = tokensHighlighter;
        _this.typeOfWorkMenu = typeOfWorkMenu;
        _this.taskStatusMenu = taskStatusMenu;
        _this.onCustomFieldChange = onCustomFieldChange;

        _this.actions = {
            openTaskPanel: openTaskPanel
        };

        _this.state = {
            canEdit: false,
            canEditTypeOfWork: false,
            canReopenProject: false,
            canEditTaskStatus: true,
            selectable: false,
            singleCPSelection: {},

            editable: false,
            taskName: "",
            projectName: "",
            customerName: "",
            workflowStatusId: 0,
            completed: false,
            typeOfWorkId: -1,
            estimatedTime: null,
            spentTime: 0,
            deadline: null,
            lastTrackingDate: null,
            creationDate: null,
            commentsNumber: 0,

            variance: null,
            progress: null,

            isESTEnabled: false,
            isBTYEnabled: false,
            isTWSEnabled: false,

            columnsOrder: [],

            customFieldsValues: {}, // map { custom_field_1: value }
            customFields: {} // structure of custom fields
        };

        _this.customFieldsControls = {};

        _this.onStatePropertyChanged('taskName', function (name) {
            _this.namesCell.setState({
                taskName: name
            });
        });

        _this.onStatePropertyChanged('commentsNumber', function (commentsNumber) {
            _this.namesCell.setState({
                commentsNumber: commentsNumber
            });
        });

        _this.onAnyStatePropertyChanged(['customerName', 'projectName', 'singleCPSelection'], function () {
            _this.namesCell.setState({
                customerName: !_this.state.singleCPSelection.customerId ? _this.state.customerName : '',
                projectName: !_this.state.singleCPSelection.projectId ? _this.state.projectName : ''
            });
        });

        _this.onAnyStatePropertyChanged(['workflowStatusId', 'completed', 'isTWSEnabled'], function () {
            var isTWSEnabled = _this.state.isTWSEnabled;
            _this.statusButton.setState({
                statusId: isTWSEnabled ? _this.state.workflowStatusId : (0, _selectors.selectFakeStatusIdByTaskComplete)(_this.state.completed)
            });
        });

        _this.onAnyStatePropertyChanged(['canEditTaskStatus'], function () {
            if (_this.statusButton && _this.statusButton.setEditable) {
                _this.statusButton.setEditable(_this.state.canEditTaskStatus);
            }
        });

        _this.onAnyStatePropertyChanged(['typeOfWorkId', 'isBTYEnabled'], function (_ref2) {
            var typeOfWorkId = _ref2.typeOfWorkId,
                isBTYEnabled = _ref2.isBTYEnabled;

            if (isBTYEnabled) _this._updateTypeOfWork(typeOfWorkId);
        });

        _this.onStatePropertyChanged('estimatedTime', function (estimate) {
            _this.estimateEditor.setTime(estimate);
        });

        _this.onStatePropertyChanged('spentTime', function (time) {
            _this.spentTimeCell.setTime(time);
        });

        _this.onStatePropertyChanged('variance', function (variance) {
            _this.varianceManHoursCell.setState({ value: variance ? variance.duration : null });
            _this.variancePercentCell.setState({ value: variance ? variance.percentage : null });
        });

        _this.onStatePropertyChanged('progress', function (progress) {
            _this.progressBar.setProps({ value: progress * 100 });
        });

        _this.onStatePropertyChanged('deadline', function (deadline) {
            _this.deadlineEditor.setDeadline(deadline);
        });

        _this.onStatePropertyChanged('lastTrackingDate', function (date) {
            _this.$lastTrackingDate.text(date ? dateFormat.formatDate(date) : "");
            _this.$el.toggleClass("noLastTrackingDate", !date);
        });

        _this.onStatePropertyChanged('creationDate', function (date) {
            _this.$creationDate.text(date ? dateFormat.formatDate(date) : "");
        });

        _this.onStatePropertyChanged('canEdit', function (canEdit) {
            _this.taskSelectionLabel.setDisabled(!canEdit);
            _this.setEditable(canEdit);
        });

        _this.onStatePropertyChanged('canEditTypeOfWork', function (canEdit) {
            _this.typeOfWorkEditor.setState({ editable: canEdit });
        });

        _this.onStatePropertyChanged('selectable', function (selectable) {
            _this.taskSelectionLabel.toggle(selectable);
            _this._updateSelectionLabel(selectable);
        });

        _this.onStatePropertyChanged('canReopenProject', function (canReopenProject) {
            _this.statusButton.setState({
                canReopenProject: canReopenProject
            });
        });

        _this.onStatePropertyChanged('isBTYEnabled', function (enabled) {
            _this.$typeOfWorkSection.toggle(enabled);
        });

        _this.onStatePropertyChanged('isESTEnabled', function (enabled) {
            _this.$estimateSection.toggle(enabled);
            _this.$varianceManHoursSection.toggle(enabled);
            _this.$variancePercentSection.toggle(enabled);
            _this.$varianceProgressBarSection.toggle(enabled);
        });

        _this.onStatePropertyDeeplyChanged('customFields', function (customFields) {
            _this._clearCustomFieldsColumns();
            _this._renderCustomFieldsColumns(customFields);
        });

        _this.onAnyStatePropertyDeeplyChanged(['customFieldsValues', 'customFields'], function (state) {
            Object.keys(state.customFields).forEach(function (cf) {
                var control = _this.customFieldsControls[cf];
                var fieldInfo = state.customFields[cf];
                if (control && fieldInfo) {
                    var value = state.customFieldsValues[cf];
                    if (fieldInfo.type === _constants3.CustomFieldType.Dropdown) {
                        control.setState({
                            selected: fieldInfo.options.find(function (opt) {
                                return opt.value === value;
                            }),
                            options: fieldInfo.options
                        });
                    } else {
                        control.setState({ value: value });
                    }
                }
            });
        });

        _this.onStatePropertyChanged('columnsOrder', function (columnsOrder) {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = Object.values(_this.columnsMap)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var column = _step.value;

                    column.hide();
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            for (var i = 0; i < columnsOrder.length; ++i) {
                var columnKey = columnsOrder[i];
                if (!_this.columnsMap[columnKey]) continue;
                _this.columnsMap[columnKey].show().css('display', 'flex');
                !(0, _utils3.isColumnFixed)(columnKey) && _this.columnsMap[columnKey].css('order', i.toString());
            }
        });
        return _this;
    }

    _createClass(TaskRow, [{
        key: "templateHtml",
        value: function templateHtml() {
            return "<tr class='taskRow'>" + "  <td class='selection'></td>" + "  <td class='priorityCell'><div class='taskRowCellWrapper' /></td>" + "  <td class='names'>" + "    <div class='taskRowCellWrapper'></div>" + "  </td>" + "  <td class='status'>" + "    <div class='taskRowCellWrapper'></div>" + "  </td>" + "  <td class='typeOfWork'>" + "    <div class='taskRowCellWrapper'></div>" + "  </td>" + "  <td class='estimate'>" + "    <div class='taskRowCellWrapper'></div>" + "  </td>" + "  <td class='varianceManHours'>" + "    <div class='taskRowCellWrapper'></div>" + "  </td>" + "  <td class='variancePercent'>" + "    <div class='taskRowCellWrapper'></div>" + "  </td>" + "  <td class='atNextMount varianceProgressBar'>" + "    <div class='taskRowCellWrapper'></div>" + "  </td>" + "  <td class='spentTime'>" + "    <div class='taskRowCellWrapper'></div>" + "  </td>" + "  <td class='deadline'>" + "    <div class='taskRowCellWrapper'></div>" + "  </td>" + "  <td class='lastTrackingDate'>" + "    <div class='taskRowCellWrapper'>" + "      <span class='value'></span>" + "      <span class='na'><%-na%></span>" + "    </div>" + "  </td>" + "  <td class='creationDate'>" + "    <div class='taskRowCellWrapper'>" + "      <span class='value'></span>" + "    </div>" + "  </td>" + "</tr>";
        }
    }, {
        key: "messageKeys",
        value: function messageKeys() {
            return {
                na: 'common.not_available'
            };
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            var _this2 = this,
                _columnsMap;

            this.$selection = this.find(".selection");
            this.taskSelectionLabel = new _TaskSelectionLabel2.default(this.$selection, true).init();
            this.taskSelectionLabel.on("change", function (e, isSelected) {
                return _this2.setClickSelection(isSelected);
            });

            this.$priorityCell = this.find(".priorityCell");
            this.$namesCell = this.find("td.names .taskRowCellWrapper");
            this.$lastTrackingDate = this.find("td.lastTrackingDate .value");
            this.$creationDate = this.find("td.creationDate .value");
            this.$deadlineCell = this.find("td.deadline .taskRowCellWrapper");
            this.$estimateColumn = this.find("td.estimate .taskRowCellWrapper");
            this.$spentTimeColumn = this.find("td.spentTime .taskRowCellWrapper");
            this.$statusButton = this.find("td.status .taskRowCellWrapper");
            this.$typeOfWork = this.find("td.typeOfWork .taskRowCellWrapper");
            this.$varianceManHoursColumn = this.find("td.varianceManHours .taskRowCellWrapper");
            this.$variancePercentColumn = this.find("td.variancePercent .taskRowCellWrapper");
            this.$varianceProgressBarColumn = this.find("td.varianceProgressBar .taskRowCellWrapper");

            this.$estimateSection = this.find("td.estimate");
            this.$varianceManHoursSection = this.find("td.varianceManHours");
            this.$variancePercentSection = this.find("td.variancePercent");
            this.$varianceProgressBarSection = this.find("td.varianceProgressBar");
            this.$typeOfWorkSection = this.find("td.typeOfWork");

            this.$tasksTableVerticalScrollContainer = (0, _jquery2.default)('.tasksTableVerticalScrollContainer');

            this.columnsMap = (_columnsMap = {}, _defineProperty(_columnsMap, _constants.TaskTableConfigurableColumns.ESTIMATE, this.find("td.estimate")), _defineProperty(_columnsMap, _constants.TaskTableConfigurableColumns.DEADLINE, this.find("td.deadline")), _defineProperty(_columnsMap, _constants.TaskTableConfigurableColumns.CREATION_DATE, this.find("td.creationDate")), _defineProperty(_columnsMap, _constants.TaskTableConfigurableColumns.LAST_TRACKING_DATE, this.find("td.lastTrackingDate")), _defineProperty(_columnsMap, _constants.TaskTableConfigurableColumns.SPENT_TIME, this.find("td.spentTime")), _defineProperty(_columnsMap, _constants.TaskTableConfigurableColumns.TYPE_OF_WORK, this.find("td.typeOfWork")), _defineProperty(_columnsMap, _constants.TaskTableConfigurableColumns.VARIANCE_MAN_HOURS, this.find("td.varianceManHours")), _defineProperty(_columnsMap, _constants.TaskTableConfigurableColumns.VARIANCE_PERCENTS, this.find("td.variancePercent")), _defineProperty(_columnsMap, _constants.TaskTableConfigurableColumns.VARIANCE_PROGRESS_BAR, this.find("td.varianceProgressBar")), _columnsMap);

            this.namesCell = new _NamesCell2.default({
                tokensHighlighter: this.tokensHighlighter
            }).init(this.$namesCell);

            this.$namesCell.click(function (e) {
                (0, _utils2.setEventPreventHidingEditTaskSlidingPanel)(e);
                _this2.actions.openTaskPanel(_this2.taskId);
            });

            var canEdit = this.state.canEdit;

            this.editable = canEdit;
            this._updateSelectionLabel(this.state.selectable);

            this.statusButton = new _TaskStatusButton2.default({
                editable: true,
                showStatusTypePrefix: false,
                positionParams: {
                    offset: "0px 1px",
                    within: this.$tasksTableVerticalScrollContainer,
                    collision: 'fit'
                },
                onShowMenu: function onShowMenu() {
                    return _this2.toggleClassMenuOpen(true);
                },
                onHideMenu: function onHideMenu() {
                    return _this2.toggleClassMenuOpen(false);
                },
                taskStatusMenu: this.taskStatusMenu,
                onStatusChangedCb: function onStatusChangedCb(statusId) {
                    _this2._startUpdating(true);
                    (0, _jquery2.default)(document).trigger("taskManagement_tasksTable_taskRow_statusChange", {
                        taskId: _this2.taskId,
                        workflowStatusId: statusId
                    });
                }
            }).init(this.$statusButton);

            this.typeOfWorkEditor = new _TypeOfWorkButton2.default({
                showCategory: false,
                onShowMenu: function onShowMenu() {
                    return _this2.toggleClassMenuOpen(true);
                },
                onHideMenu: function onHideMenu() {
                    return _this2.toggleClassMenuOpen(false);
                },
                typeOfWorkMenu: this.typeOfWorkMenu,
                positionParams: {
                    offset: "0px 1px",
                    within: this.$tasksTableVerticalScrollContainer,
                    collision: 'fit'
                },
                onTypeOfWorkChangedCb: function onTypeOfWorkChangedCb(typeOfWorkId) {
                    _this2._startUpdating(true);
                    (0, _jquery2.default)(document).trigger("taskManagement_tasksTable_taskRow_typeOfWorkChange", {
                        taskId: _this2.taskId,
                        typeOfWorkId: typeOfWorkId
                    });
                }
            }).init(this.$typeOfWork);

            this.estimateEditor = new _TimeEditor2.default(this.$estimateColumn, canEdit, _messageResource2.default.getMessage('task.time_editor_placeholder.enter_hours'), _messageResource2.default.getMessage('task.time_editor_placeholder.not_defined')).init();
            this.estimateEditor.on("change", function (e, time) {
                _this2._startUpdating(true);
                _this2.estimatedTime = time;
                (0, _jquery2.default)(document).trigger("taskManagement_tasksTable_taskRow_estimateChange", {
                    taskId: _this2.taskId,
                    estimatedTime: time
                });
            });

            this.spentTimeCell = new _TimeEditor2.default(null, false).init(this.$spentTimeColumn);

            this.varianceManHoursCell = new _VarianceCell2.default({ isTimeValue: true }).init(this.$varianceManHoursColumn);
            this.variancePercentCell = new _VarianceCell2.default({ isTimeValue: false }).init(this.$variancePercentColumn);

            this.progressBar = window.ClassicBridge.integrateProgressBar(this.$varianceProgressBarColumn[0], {
                value: 0,
                isShowValue: true,
                isShowLabel: false,
                barWrapperClassName: 'varianceBarWrapper',
                barClassName: 'varianceBar'
            });

            if (!this.state.isESTEnabled) {
                this.$varianceManHoursSection.hide();
                this.$variancePercentSection.hide();
                this.$varianceProgressBarSection.hide();
            }

            this.deadlineEditor = new _DeadlineEditor2.default(this.$deadlineCell, canEdit).init();

            this.deadlineEditor.on("change", function (e, date) {
                _this2._startUpdating(true);
                // TODO bakharev: look carefully
                _this2.deadline = date;
                (0, _jquery2.default)(document).trigger("taskManagement_tasksTable_taskRow_deadlineChange", {
                    taskId: _this2.taskId,
                    deadline: date
                });
            });

            this.renderInitialState();
        }
    }, {
        key: "toggleClassMenuOpen",
        value: function toggleClassMenuOpen(switcher) {
            this.$el.toggleClass('menuOpen', switcher);
        }
    }, {
        key: "setClickSelection",
        value: function setClickSelection(isSelected) {
            (0, _jquery2.default)(document).trigger("taskManagement_taskTable_taskRow_selectionChange", {
                taskId: this.taskId,
                isSelected: isSelected
            });
        }
    }, {
        key: "setSelection",
        value: function setSelection(isSelected) {
            this.taskSelectionLabel.setSelection(isSelected);
        }
    }, {
        key: "_updateSelectionLabel",
        value: function _updateSelectionLabel(selectable) {
            this.$selection.toggle(selectable);
        }
    }, {
        key: "update",
        value: function update() {
            var task = _TaskStore2.default.get(this.taskId);
            var projectName = _ProjectStore2.default.get(task.projectId).name;
            var customerName = _CustomerStore2.default.get(task.customerId).name;
            this.setState(_extends({}, task, {
                taskName: task.name,
                projectName: projectName,
                customerName: customerName
            }));
        }
    }, {
        key: "setEditable",
        value: function setEditable(editable) {
            this.estimateEditor.setEditable(editable);
            this.deadlineEditor.setEditable(editable);
            this.taskSelectionLabel.setEditable(editable);
            this.statusButton.setEditable(this.state.canEditTaskStatus);
        }

        // TODO: rename, too abstract name, may be startDataUpdating or startEntityUpdating

    }, {
        key: "_startUpdating",
        value: function _startUpdating(disable) {
            var _this3 = this;

            if (this.updating) return;

            var setDisabled = function setDisabled(disabled) {
                _this3.$el.toggleClass("disabled", disabled);
                _this3.statusButton.setDisabled(disabled);
                _this3.estimateEditor.setDisabled(disabled);
                _this3.deadlineEditor.setDisabled(disabled);
                _this3.typeOfWorkEditor.setDisabled(disabled);
                _this3.taskSelectionLabel.setDisabled(disabled);
                Object.values(_this3.customFieldsControls).forEach(function (control) {
                    control.setState({ disabled: disabled });
                });
            };

            this.updating = true;
            if (disable) {
                setDisabled(true);
            }

            var handler = function handler(e, taskId) {
                if (_this3.taskId === taskId) {
                    _this3.updating = false;
                    setDisabled(false);
                    _this3.setEditable(_this3.state.canEdit);
                    // TODO bakharev: set state was here
                    _this3.update();
                    (0, _jquery2.default)(document).off(e, handler);
                }
            };
            (0, _jquery2.default)(document).on("taskManagement_taskUpdated", handler);
        }
    }, {
        key: "startEditing",
        value: function startEditing() {
            if (this.inEdit) return;

            this.inEdit = true;
            this.$el.addClass("inEdit");
        }
    }, {
        key: "stopEditing",
        value: function stopEditing() {
            this.inEdit = false;
            this.$el.removeClass("inEdit");
            // TODO bakharev: set state was here
            this.update();
        }
    }, {
        key: "fadeOut",
        value: function fadeOut() {
            this.$el.atAnimation().fadeOut();
            this._hidden = true;
        }
    }, {
        key: "clear",
        value: function clear() {
            Object.values(this.customFieldsControls).forEach(function (cfc) {
                cfc.remove && cfc.remove();
            });
        }
    }, {
        key: "isHidden",
        value: function isHidden() {
            return this._hidden === true;
        }
    }, {
        key: "_updateTypeOfWork",
        value: function _updateTypeOfWork(typeOfWorkId) {
            this.typeOfWorkEditor.setState({
                typeOfWorkId: typeOfWorkId,
                // TODO bakharev: change to normal code
                typeOfWorkName: (0, _utils.unsafe_selectWithState)(function (state) {
                    return (0, _selectors2.getTypeOfWork)(state, typeOfWorkId);
                }).name
            });
        }
    }, {
        key: "_clearCustomFieldsColumns",
        value: function _clearCustomFieldsColumns() {
            var _this4 = this;

            Object.keys(this.columnsMap).filter(function (column) {
                return _ClassicBridge2.default.isCustomField(column);
            }).forEach(function (cf) {
                _this4.columnsMap[cf].remove();
                delete _this4.columnsMap[cf];
            });
        }
    }, {
        key: "_renderCustomFieldsColumns",
        value: function _renderCustomFieldsColumns(customFields) {
            var _this5 = this;

            Object.values(customFields).forEach(function (customField) {
                var $cell = customField.fieldName === _constants.PRIORITY_FIELD_NAME ? _this5.$priorityCell : (0, _jquery2.default)("  <td class='customField'>" + "    <div class='taskRowCellWrapper'></div>" + "  </td>").appendTo(_this5.$el);
                _this5.columnsMap[customField.fieldName] = $cell;
                var $controlPlaceholder = $cell.find('.taskRowCellWrapper');
                var control = void 0;
                if (customField.type === _constants3.CustomFieldType.Dropdown) {
                    var taskIds = TaskManagementStore.getTaskIds();
                    control = new _CFDropdownEditor2.default({
                        $containerEl: $controlPlaceholder,
                        disabled: !_this5.state.canEdit,
                        onSelectedChanged: _this5._createOnChangeCustomFieldCallback(customField.fieldName),
                        fieldName: customField.fieldName,
                        tooltipPlace: taskIds[0] === _this5.taskId ? 'bottom' : 'top',
                        className: customField.fieldName
                    }).init();
                }
                if (customField.type === _constants3.CustomFieldType.String) {
                    control = new _TextEditor2.default({
                        onChangeCallback: _this5._createOnChangeCustomFieldCallback(customField.fieldName),
                        maxInputLength: _constants2.EntityTextLimits.CUSTOM_FIELD_STRING_VALUE,
                        fieldId: customField.id
                    }).init($controlPlaceholder);
                    control.setState({ editable: _this5.state.canEdit });
                }
                _this5.customFieldsControls[customField.fieldName] = control;
            });
        }
    }, {
        key: "_createOnChangeCustomFieldCallback",
        value: function _createOnChangeCustomFieldCallback(fieldName) {
            var _this6 = this;

            return function (value) {
                _this6._startUpdating(true);
                _this6.onCustomFieldChange(_this6.taskId, fieldName, value);
            };
        }
    }], [{
        key: "getSubtitle",
        value: function getSubtitle(projectName, customerName, singleCPSelection) {
            var subtitle = "";
            var customerEscapedName = (0, _atUtils.escapeHtmlSymbols)(customerName);
            var projectEscapedName = (0, _atUtils.escapeHtmlSymbols)(projectName);
            if (!singleCPSelection.customerId && !singleCPSelection.projectId) subtitle = customerEscapedName + TaskRow.getArrowImg() + projectEscapedName;else if (!singleCPSelection.projectId) subtitle = projectEscapedName;
            return subtitle;
        }
    }, {
        key: "getSubtitleTooltip",
        value: function getSubtitleTooltip(projectName, customerName, singleCPSelection) {
            var tooltip = "";
            if (!singleCPSelection.customerId && !singleCPSelection.projectId) tooltip = customerName + " > " + projectName;else if (!singleCPSelection.projectId) tooltip = projectName;

            return tooltip;
        }
    }, {
        key: "getArrowImg",
        value: function getArrowImg() {
            return "<img src='" + (0, _atBrowserUtils.atImgPath)('taskManagement/arrow.png') + "'/>";
        }
    }]);

    return TaskRow;
}(_TemplateView3.default);

exports.default = TaskRow;

/***/ }),
/* 1814 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _atUtils = __webpack_require__(5);

var _CommentsNumberContainer = __webpack_require__(251);

var _CommentsNumberContainer2 = _interopRequireDefault(_CommentsNumberContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NamesCell = function (_TemplateView) {
    _inherits(NamesCell, _TemplateView);

    function NamesCell() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            tokensHighlighter = _ref.tokensHighlighter;

        _classCallCheck(this, NamesCell);

        var _this = _possibleConstructorReturn(this, (NamesCell.__proto__ || Object.getPrototypeOf(NamesCell)).call(this));

        _this.tokensHighlighter = tokensHighlighter;

        _this.state = {
            taskName: "",
            projectName: "",
            customerName: "",
            commentsNumber: 0
        };

        _this.onStatePropertyChanged('taskName', function (taskName) {
            _this.$title.html(_this.tokensHighlighter ? _this.tokensHighlighter.highlightTokens(taskName) : (0, _atUtils.escapeHtmlSymbols)(taskName));
            _this._updateTooltip(_this.$title, taskName);
        });

        _this.onStatePropertyChanged('customerName', function (customerName) {
            _this.$customerTitle.text(customerName);
        });

        _this.onStatePropertyChanged('projectName', function (projectName) {
            _this.$projectTitle.text(projectName);
        });

        _this.onAnyStatePropertyChanged(['customerName', 'projectName'], function () {
            _this.$arrowIcon.toggle(!!_this.state.projectName && !!_this.state.customerName);
            _this._updateTooltip(_this.$subtitle, _this._getSubtitleTooltip(_this.state.projectName, _this.state.customerName));
        });

        _this.onStatePropertyChanged('commentsNumber', function (num) {
            _this.commentsNumber.setState({
                commentsNumber: num
            });
        });

        return _this;
    }

    _createClass(NamesCell, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return "<div class='namesCell_taskManagement'>" + "  <div class='namesContainer'>" + "    <div class='subtitle'>" + "      <div class='customerTitle'></div>" + "      <div class='arrow'></div>" + "      <div class='projectTitle'></div>" + "    </div>" + "    <div class='title'></div>" + "  </div>" + "  <div class='commentsNumberPlaceholder'></div>" + "</div>";
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            this.$subtitle = this.find('.subtitle');
            this.$customerTitle = this.find('.customerTitle');
            this.$projectTitle = this.find('.projectTitle');
            this.$title = this.find('.title');
            this.$arrowIcon = this.find('.arrow');

            this.commentsNumber = new _CommentsNumberContainer2.default().init(this.find('.commentsNumberPlaceholder'));
        }
    }, {
        key: '_updateTooltip',
        value: function _updateTooltip($elem, tooltipText) {
            $elem.attr('title', tooltipText);
        }
    }, {
        key: '_getSubtitleTooltip',
        value: function _getSubtitleTooltip(projectName, customerName) {
            var tooltip = '';
            if (customerName && projectName) tooltip = customerName + ' > ' + projectName;else if (projectName) tooltip = projectName;

            return tooltip;
        }
    }]);

    return NamesCell;
}(_TemplateView3.default);

exports.default = NamesCell;

/***/ }),
/* 1815 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _LoadingControlMixin = __webpack_require__(136);

var _LoadingControlMixin2 = _interopRequireDefault(_LoadingControlMixin);

var _ClassicBridge = __webpack_require__(18);

var _ClassicBridge2 = _interopRequireDefault(_ClassicBridge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DeadlineEditor = function (_TemplateView) {
    _inherits(DeadlineEditor, _TemplateView);

    function DeadlineEditor($containerEl, editable) {
        _classCallCheck(this, DeadlineEditor);

        var _this = _possibleConstructorReturn(this, (DeadlineEditor.__proto__ || Object.getPrototypeOf(DeadlineEditor)).call(this, $containerEl));

        _this.state = {
            editable: editable
        };

        _this.onStatePropertyChanged('editable', function (editable) {
            return _this.setEditable(editable);
        });
        return _this;
    }

    _createClass(DeadlineEditor, [{
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='deadlineEditor atNextMount' />";
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            var _this2 = this;

            this.selector = _ClassicBridge2.default.integrateDeadlineSelector(this.$el[0], {
                readonly: false,
                dateClassName: 'deadlineDate',
                valueClassName: 'deadlineValue',
                crossButtonClassName: 'deadlineCrossButton',
                notDefinedClassName: 'notDefinedDeadlineDate',
                onDeadlineChanged: function onDeadlineChanged(date) {
                    return _this2.trigger('change', date);
                }
            });
        }
    }, {
        key: "setDeadline",
        value: function setDeadline(deadline) {
            this.selector.setProps({
                deadlineDate: deadline
            });
        }
    }, {
        key: "setEditable",
        value: function setEditable(editable) {
            this.selector.setProps({
                readonly: !editable
            });
        }
    }, {
        key: "setDisabled",
        value: function setDisabled(disabled) {
            this.selector.setProps({
                readonly: disabled
            });
        }
    }]);

    return DeadlineEditor;
}(_TemplateView3.default);

exports.default = DeadlineEditor;


_underscore2.default.extend(DeadlineEditor.prototype, _LoadingControlMixin2.default);

/***/ }),
/* 1816 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _ClassicBridge = __webpack_require__(18);

var _ClassicBridge2 = _interopRequireDefault(_ClassicBridge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TextEditor = function (_TemplateView) {
    _inherits(TextEditor, _TemplateView);

    function TextEditor(_ref) {
        var _ref$onChangeCallback = _ref.onChangeCallback,
            onChangeCallback = _ref$onChangeCallback === undefined ? function () {} : _ref$onChangeCallback,
            _ref$maxInputLength = _ref.maxInputLength,
            maxInputLength = _ref$maxInputLength === undefined ? 2000 : _ref$maxInputLength,
            fieldId = _ref.fieldId;

        _classCallCheck(this, TextEditor);

        var _this = _possibleConstructorReturn(this, (TextEditor.__proto__ || Object.getPrototypeOf(TextEditor)).call(this));

        _this._onInputChange = function (value) {
            _this.integratedInput.setProps({
                value: value
            });
        };

        _this._onApplyInputValue = function (value) {
            // if empty string entered, send null
            var fixedValue = value || null;
            // empty string or undefined may be received from server, normalize them to null before comparing
            var stateNormalizedValue = _this.state.value || null;
            if (fixedValue !== stateNormalizedValue) {
                _this.setState({
                    value: fixedValue
                });
                _this.onChangeCallback(fixedValue);
            }
            _this._stopEditing();
        };

        _this._onClickHandler = function () {
            if (!_this.state.editable || _this.state.editing) return;

            _this._startEditing();
        };

        _this._onEscHandler = function () {
            if (_this.state.editing) _this._stopEditing();
        };

        _this._onBlurHandler = function () {
            if (_this.state.editing) {
                _this._stopEditing();
            }
        };

        _this.onChangeCallback = onChangeCallback;
        _this.maxInputLength = maxInputLength;
        _this.fieldId = fieldId;

        _this.state = {
            editable: true,
            editing: false,
            value: null
        };

        _this.onStatePropertyChanged('value', function (value) {
            // null or undefined may be received from server, display them as empty string
            var fixedValue = value || '';
            _this.integratedInput.setProps({
                value: fixedValue,
                title: fixedValue
            });
        });

        _this.onStatePropertyChanged('editable', function (editable) {
            _this.getEl().toggleClass('editable', editable);
            _this.integratedInput.setProps({
                disabled: !editable
            });
        });

        _this.onStatePropertyChanged('editing', function (editing) {
            _this.getEl().toggleClass('editing', editing);
        });
        return _this;
    }

    _createClass(TextEditor, [{
        key: 'templateModel',
        value: function templateModel() {
            return {
                maxLength: this.maxInputLength
            };
        }
    }, {
        key: 'templateHtml',
        value: function templateHtml() {
            return "<div class='textEditor atNextMount'></div>";
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            this.bindClick(this._onClickHandler);
            this.integratedInput = _ClassicBridge2.default.integrateInputWithSuggestions(this.getEl()[0], {
                onChange: this._onInputChange,
                onBlur: this._onBlurHandler,
                onApply: this._onApplyInputValue,
                maxLength: this.maxInputLength
            }, this.fieldId);
        }
    }, {
        key: '_startEditing',
        value: function _startEditing() {
            this.setState({ editing: true });
            this.integratedInput.setProps({
                focus: true
            });
        }
    }, {
        key: '_stopEditing',
        value: function _stopEditing() {
            this.setState({ editing: false });
            this.integratedInput.setProps({
                focus: false
            });
        }
    }, {
        key: 'remove',
        value: function remove() {
            // need for remove react node from dom
            this.integratedInput.remove();
        }
    }]);

    return TextEditor;
}(_TemplateView3.default);

exports.default = TextEditor;

/***/ }),
/* 1817 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _user_time = __webpack_require__(30);

var _user_time2 = _interopRequireDefault(_user_time);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var VarianceCell = function (_TemplateView) {
    _inherits(VarianceCell, _TemplateView);

    function VarianceCell(_ref) {
        var _ref$isTimeValue = _ref.isTimeValue,
            isTimeValue = _ref$isTimeValue === undefined ? true : _ref$isTimeValue;

        _classCallCheck(this, VarianceCell);

        var _this = _possibleConstructorReturn(this, (VarianceCell.__proto__ || Object.getPrototypeOf(VarianceCell)).call(this));

        _this.state = {
            value: 0
        };

        _this.params = {
            isTimeValue: isTimeValue
        };

        _this.placeholder = '--';

        _this.onStatePropertyChanged('value', function (value) {
            _this.updateValue(value);
        });
        return _this;
    }

    _createClass(VarianceCell, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return "<div class='variance'>" + "  <div class='value'></div>" + "</div>";
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            this.$value = this.find(".value");
        }
    }, {
        key: 'updateValue',
        value: function updateValue(value) {
            if (!_underscore2.default.isNumber(value)) {
                this.$value.removeClass('negative');
                this.$value.text(this.placeholder);
                return;
            }

            if (this.params.isTimeValue) {
                this.$value.text(_user_time2.default.formatTimeWithDigitSeparator(value));
            } else {
                this.$value.text((Math.round(value * 100) / 100).toFixed(1) + '%');
            }

            this.$value.toggleClass('negative', value < 0);
        }
    }]);

    return VarianceCell;
}(_TemplateView3.default);

exports.default = VarianceCell;

/***/ }),
/* 1818 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _LoadingControlMixin = __webpack_require__(136);

var _LoadingControlMixin2 = _interopRequireDefault(_LoadingControlMixin);

var _ClassicBridge = __webpack_require__(18);

var _ClassicBridge2 = _interopRequireDefault(_ClassicBridge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CFDropdownEditor = function (_TemplateView) {
    _inherits(CFDropdownEditor, _TemplateView);

    function CFDropdownEditor(_ref) {
        var $containerEl = _ref.$containerEl,
            selected = _ref.selected,
            options = _ref.options,
            fieldName = _ref.fieldName,
            onSelectedChanged = _ref.onSelectedChanged,
            disabled = _ref.disabled,
            tooltipPlace = _ref.tooltipPlace,
            className = _ref.className;

        _classCallCheck(this, CFDropdownEditor);

        var _this = _possibleConstructorReturn(this, (CFDropdownEditor.__proto__ || Object.getPrototypeOf(CFDropdownEditor)).call(this, $containerEl));

        _this.state = {
            disabled: disabled,
            selected: selected,
            options: options
        };

        _this.params = {
            fieldName: fieldName,
            onSelectedChanged: onSelectedChanged,
            tooltipPlace: tooltipPlace,
            className: className
        };

        _this.onStatePropertyChanged('disabled', function (disabled) {
            return _this.setDisabled(disabled);
        });
        _this.onStatePropertyChanged('selected', function (selected) {
            return _this.setSelection(selected);
        });
        _this.onStatePropertyChanged('options', function (options) {
            return _this.setOptions(options);
        });
        return _this;
    }

    _createClass(CFDropdownEditor, [{
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='dropdownSelectorButton atNextMount' />";
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            this.selector = _ClassicBridge2.default.integrateCFDropdownSelector(this.$el[0], {
                selected: this.state.selected,
                options: this.state.options,
                readonly: !!this.state.disabled,
                fieldName: this.params.fieldName,
                onSelectedChanged: this.params.onSelectedChanged,
                tooltipPlace: this.params.tooltipPlace,
                className: this.params.className
            });
        }
    }, {
        key: "setSelection",
        value: function setSelection(selected) {
            this.selector.setProps({ selected: selected });
        }
    }, {
        key: "setOptions",
        value: function setOptions(options) {
            this.selector.setProps({ options: options });
        }
    }, {
        key: "setDisabled",
        value: function setDisabled(disabled) {
            this.selector.setProps({
                readonly: disabled
            });
        }
    }]);

    return CFDropdownEditor;
}(_TemplateView3.default);

exports.default = CFDropdownEditor;


_underscore2.default.extend(CFDropdownEditor.prototype, _LoadingControlMixin2.default);

/***/ }),
/* 1819 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _AddNewButton = __webpack_require__(1820);

var _AddNewButton2 = _interopRequireDefault(_AddNewButton);

var _SearchField = __webpack_require__(847);

var _SearchField2 = _interopRequireDefault(_SearchField);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _Tree = __webpack_require__(1821);

var _Tree2 = _interopRequireDefault(_Tree);

var _CustomerStore = __webpack_require__(65);

var _CustomerStore2 = _interopRequireDefault(_CustomerStore);

var _ProjectStore = __webpack_require__(59);

var _ProjectStore2 = _interopRequireDefault(_ProjectStore);

var _cp_selector_report_config = __webpack_require__(350);

var _cp_selector_report_config2 = _interopRequireDefault(_cp_selector_report_config);

var _utils = __webpack_require__(6);

var _selectors = __webpack_require__(27);

var _selectors2 = __webpack_require__(249);

var _selectors3 = __webpack_require__(244);

var _Button = __webpack_require__(33);

var _Button2 = _interopRequireDefault(_Button);

var _redux = __webpack_require__(7);

var _actions = __webpack_require__(55);

var _selectors4 = __webpack_require__(574);

var _actions2 = __webpack_require__(928);

var _constants = __webpack_require__(344);

var _CustomerProjectSelection = __webpack_require__(156);

var _CustomerProjectSelection2 = _interopRequireDefault(_CustomerProjectSelection);

var _selectors5 = __webpack_require__(14);

var _AddNewMenu = __webpack_require__(1824);

var _AddNewMenu2 = _interopRequireDefault(_AddNewMenu);

var _ExportCPDropdown = __webpack_require__(1825);

var _ExportCPDropdown2 = _interopRequireDefault(_ExportCPDropdown);

var _constants2 = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CustomersProjectsPanel = function (_TemplateView) {
    _inherits(CustomersProjectsPanel, _TemplateView);

    function CustomersProjectsPanel() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            _ref$importTasksCb = _ref.importTasksCb,
            importTasksCb = _ref$importTasksCb === undefined ? function () {} : _ref$importTasksCb,
            _ref$createNewTasksCb = _ref.createNewTasksCb,
            createNewTasksCb = _ref$createNewTasksCb === undefined ? function () {} : _ref$createNewTasksCb,
            _ref$createNewProject = _ref.createNewProjectCb,
            createNewProjectCb = _ref$createNewProject === undefined ? function () {} : _ref$createNewProject,
            _ref$createNewCustome = _ref.createNewCustomerCb,
            createNewCustomerCb = _ref$createNewCustome === undefined ? function () {} : _ref$createNewCustome,
            _ref$changeFilterCPSe = _ref.changeFilterCPSelection,
            changeFilterCPSelection = _ref$changeFilterCPSe === undefined ? function () {} : _ref$changeFilterCPSe,
            _ref$changeSingleCPSe = _ref.changeSingleCPSelection,
            changeSingleCPSelection = _ref$changeSingleCPSe === undefined ? function () {} : _ref$changeSingleCPSe,
            _ref$changeNameFilter = _ref.changeNameFilter,
            changeNameFilter = _ref$changeNameFilter === undefined ? function () {} : _ref$changeNameFilter,
            _ref$expandPanel = _ref.expandPanel,
            expandPanel = _ref$expandPanel === undefined ? function () {} : _ref$expandPanel,
            _ref$collapsePanel = _ref.collapsePanel,
            collapsePanel = _ref$collapsePanel === undefined ? function () {} : _ref$collapsePanel,
            _ref$setWidth = _ref.setWidth,
            setWidth = _ref$setWidth === undefined ? function () {} : _ref$setWidth,
            _ref$addCollapsedCust = _ref.addCollapsedCustomers,
            addCollapsedCustomers = _ref$addCollapsedCust === undefined ? function () {} : _ref$addCollapsedCust,
            _ref$removeCollapsedC = _ref.removeCollapsedCustomers,
            removeCollapsedCustomers = _ref$removeCollapsedC === undefined ? function () {} : _ref$removeCollapsedC,
            _ref$changeVisibleCus = _ref.changeVisibleCustomerIds,
            changeVisibleCustomerIds = _ref$changeVisibleCus === undefined ? function () {} : _ref$changeVisibleCus,
            _ref$changeVisiblePro = _ref.changeVisibleProjectIds,
            changeVisibleProjectIds = _ref$changeVisiblePro === undefined ? function () {} : _ref$changeVisiblePro,
            _ref$changeIsCustomer = _ref.changeIsCustomersAsc,
            changeIsCustomersAsc = _ref$changeIsCustomer === undefined ? function () {} : _ref$changeIsCustomer;

        _classCallCheck(this, CustomersProjectsPanel);

        var _this = _possibleConstructorReturn(this, (CustomersProjectsPanel.__proto__ || Object.getPrototypeOf(CustomersProjectsPanel)).call(this, null));

        _this.actions = {
            changeFilterCPSelection: changeFilterCPSelection,
            changeSingleCPSelection: changeSingleCPSelection,
            changeNameFilter: changeNameFilter,
            expandPanel: expandPanel,
            collapsePanel: collapsePanel,
            setWidth: setWidth,
            addCollapsedCustomers: addCollapsedCustomers,
            removeCollapsedCustomers: removeCollapsedCustomers,
            changeVisibleProjectIds: changeVisibleProjectIds,
            changeVisibleCustomerIds: changeVisibleCustomerIds,
            changeIsCustomersAsc: changeIsCustomersAsc
        };

        _this.callbacks = {
            importTasksCb: importTasksCb,
            createNewTasksCb: createNewTasksCb,
            createNewProjectCb: createNewProjectCb,
            createNewCustomerCb: createNewCustomerCb
        };

        _this.state = {
            isPossibleToAddCustomers: false,
            isPossibleToAddProjects: false,
            isPossibleToAddTasks: false,
            editableCustomerIds: {},
            editableProjectIds: {},
            isCustomersAsc: true,
            singleCustomerProjectSelection: {},
            filterCustomerProjectSelection: {},
            customers: {},
            projects: {},
            nameFilter: '',
            editingCustomerId: null,
            editingProjectId: null,
            recentlyCreatedCustomerIds: [],
            recentlyCreatedProjectIds: [],
            cpPanelClosed: false,
            resizableMaxWidth: 0,
            resizableMinWidth: _constants.LEFT_MIN_WIDTH,
            width: 0,
            collapsedCustomersSet: {}
        };

        _this.onStatePropertyChanged('isCustomersAsc', function (isCustomersAsc) {
            return _this.tree.setState({ isCustomersAsc: isCustomersAsc });
        });
        _this.onStatePropertyChanged('editableCustomerIds', function (editableCustomerIds) {
            return _this.tree.setState({ editableCustomerIds: editableCustomerIds });
        });
        _this.onStatePropertyChanged('editableProjectIds', function (editableProjectIds) {
            return _this.tree.setState({ editableProjectIds: editableProjectIds });
        });
        _this.onAnyStatePropertyChanged(['filterCustomerProjectSelection', 'customers', 'projects'], function () {
            return _this._updateCpSelector();
        });

        _this.onStateChanged(function (state) {
            return _this.tree.setState({
                nameFilter: state.nameFilter,
                singleCustomerProjectSelection: state.singleCustomerProjectSelection,
                filterCustomerProjectSelection: state.filterCustomerProjectSelection,
                customers: state.customers,
                projects: state.projects,
                editableCustomerIds: state.editableCustomerIds,
                editableProjectIds: state.editableProjectIds,
                editingCustomerId: state.editingCustomerId,
                editingProjectId: state.editingProjectId,
                recentlyCreatedCustomerIds: state.recentlyCreatedCustomerIds,
                recentlyCreatedProjectIds: state.recentlyCreatedProjectIds,
                collapsedCustomersSet: state.collapsedCustomersSet
            });
        });

        _this.onStatePropertyChanged('cpPanelClosed', function (closed) {
            return closed ? _this._collapse() : _this._expand();
        });
        _this.onStatePropertyChanged('resizableMaxWidth', function (maxWidth) {
            _this.$containerEl.resizable("option", "maxWidth", maxWidth);
            _this._updateWidth();
        });

        _this.onStatePropertyChanged('resizableMinWidth', function (minWidth) {
            return _this.$containerEl.resizable("option", "minWidth", minWidth);
        });
        _this.onStatePropertyChanged('width', function (width) {
            _this.$containerEl.width(width);
            _this.tree.adjustSize();
        });

        _this.onStatePropertyChanged('isPossibleToAddTasks', function (show) {
            return _this.addNewButton.toggle(show);
        });

        _this.onAnyStatePropertyChanged(['isPossibleToAddProjects', 'isPossibleToAddCustomers'], function (_ref2) {
            var isPossibleToAddProjects = _ref2.isPossibleToAddProjects,
                isPossibleToAddCustomers = _ref2.isPossibleToAddCustomers;

            _this.addNewCustomerProjectMenu.setState({ isPossibleToAddProjects: isPossibleToAddProjects, isPossibleToAddCustomers: isPossibleToAddCustomers });
        });
        return _this;
    }

    _createClass(CustomersProjectsPanel, [{
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='customersProjectsPanel'>" + "  <div class='header'>" + "    <div class='titleContainer'>" + "        <div class='collapseButtonPlaceholder'></div>" + "        <div class='title'><%-customers_and_projects%></div>" + "        <div class='addNewContainer'></div>" + "    </div>" + "    <div class='searchAndExportContainer'>" + "        <div class='searchFieldContainer'></div>" + "    </div>" + "  </div>" + "  <div class='customersProjectsTreeContainer'></div>" + "  <div class='collapsedContainer'>" + "    <div class='expandButtonPlaceholder'></div>" + "    <div class='title'><%-customers_and_projects%></div>" + "  </div>" + "</div>";
        }
    }, {
        key: "templateModel",
        value: function templateModel() {
            return {
                customers_and_projects: _messageResource2.default.getMessage("projects_customers_selector.customers_and_projects")
            };
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            var _this2 = this;

            var buttonsContainer = this.find(".addNewContainer");
            this._createAddNewButtons(buttonsContainer);

            new _SearchField2.default({
                onFieldChange: function onFieldChange(text) {
                    return _this2.actions.changeNameFilter(text.trim());
                }
            }).init(this.find(".searchFieldContainer"));

            new _Button2.default({
                additionalClass: "collapseCPPanelButton",
                onClickCb: function onClickCb() {
                    return _this2.actions.collapsePanel();
                }
            }).init(this.find(".collapseButtonPlaceholder"));

            new _Button2.default({
                additionalClass: "expandCPPanelButton",
                onClickCb: function onClickCb() {
                    return _this2.actions.expandPanel();
                }
            }).init(this.find(".collapsedContainer .expandButtonPlaceholder"));

            this.tree = new _Tree2.default({
                onSingleCPSelectionChanged: this.actions.changeSingleCPSelection,
                addCollapsedCustomers: this.actions.addCollapsedCustomers,
                removeCollapsedCustomers: this.actions.removeCollapsedCustomers,
                onVisibleCustomerIdsChanged: this.actions.changeVisibleCustomerIds,
                onVisibleProjectIdsChanged: this.actions.changeVisibleProjectIds,
                onIsCustomersAscChanged: this.actions.changeIsCustomersAsc
            }).init(this.find(".customersProjectsTreeContainer"));

            this.exportCPDropdown = new _ExportCPDropdown2.default().init(this.find(".searchAndExportContainer"));

            this.$containerEl.resizable({
                handles: 'e',
                stop: function stop(event, ui) {
                    _this2.actions.setWidth(ui.element.width());
                    // Remove unwanted side-effect of jQuery UI resizable
                    ui.element.css("height", "");
                }
            });
        }
    }, {
        key: "_collapse",
        value: function _collapse() {
            this.$containerEl.addClass('collapsed');
            this.$containerEl.resizable('disable');
        }
    }, {
        key: "_expand",
        value: function _expand() {
            this.$containerEl.removeClass('collapsed');
            this.$containerEl.resizable('enable');
            this._updateWidth();
        }
    }, {
        key: "_updateWidth",
        value: function _updateWidth() {
            if (this.$containerEl.width() > this.state.resizableMaxWidth) this.actions.setWidth(this.state.resizableMaxWidth);
        }
    }, {
        key: "_createAddNewButtons",
        value: function _createAddNewButtons() {
            this.addNewCustomerProjectMenu = new _AddNewMenu2.default({
                importTasksCb: this.callbacks.importTasksCb,
                createNewTasksCb: this.callbacks.createNewTasksCb,
                createNewProjectCb: this.callbacks.createNewProjectCb,
                createNewCustomerCb: this.callbacks.createNewCustomerCb
            }).init((0, _jquery2.default)("body"));

            this.addNewButton = new _AddNewButton2.default({
                title: _messageResource2.default.getMessage('task.list.add_new'),
                menu: this.addNewCustomerProjectMenu
            }).init(this.find(".addNewContainer"));
        }
    }, {
        key: "_updateCpSelector",
        value: function _updateCpSelector() {
            var _this3 = this;

            (0, _jquery2.default)("#customersProjectsPanelFilterCPSelectorContainer").empty();

            this.cpSelector = new _cp_selector_report_config2.default({ showEmptyCustomers: true });
            this.cpSelector.init(this.state.filterCustomerProjectSelection, "customersProjectsPanelFilterCPSelectorContainer", function () {
                var cpSelection = _this3.cpSelector.getCpSelection();
                if (_CustomerProjectSelection2.default.fromPlainObject(cpSelection).isEmpty()) {
                    _this3.cpSelector.resetSelection();
                }
                _this3.actions.changeFilterCPSelection(cpSelection);
            });
            this.cpSelector.initializeData({
                customers: _CustomerStore2.default.getAll(),
                projects: _ProjectStore2.default.getAll()
            });

            this.tree.setState({
                cpSelectorFiltered: this.state.filterCustomerProjectSelection.qualifier !== _constants2.CustomersProjectsSelectionQualifier.ALL
            });

            this.cpSelector.getButton().on("menuhide", function () {
                _this3.tree.setState({
                    cpSelectorOpened: false
                });
            });
            this.cpSelector.getButton().on("menushow", function () {
                _this3.tree.setState({
                    cpSelectorOpened: true
                });
            });
        }
    }]);

    return CustomersProjectsPanel;
}(_TemplateView3.default);

exports.default = (0, _utils.connect)(function (state) {
    return {
        canAccessAllScope: (0, _selectors.isViewerHasAccessToAllManagementScope)(state),
        isPossibleToAddTasks: (0, _selectors.isPossibleToAddTasks)(state),
        isPossibleToAddCustomers: (0, _selectors.isPossibleToAddCustomers)(state),
        isPossibleToAddProjects: (0, _selectors.isPossibleToAddProjects)(state),
        editableCustomerIds: (0, _selectors.getEditableCustomerIds)(state),
        editableProjectIds: (0, _selectors.getEditableProjectIds)(state),
        isCustomersAsc: (0, _selectors4.getIsCustomersAsc)(state),
        singleCustomerProjectSelection: (0, _selectors.getSingleCPSelection)(state),
        filterCustomerProjectSelection: (0, _selectors.getFilterCPSelection)(state),
        customers: (0, _selectors5.getCustomers)(state),
        projects: (0, _selectors5.getProjects)(state),
        nameFilter: (0, _selectors.getCustomerProjectNameFilter)(state),
        editingCustomerId: (0, _selectors2.getOpenCustomerId)(state),
        editingProjectId: (0, _selectors3.getOpenProjectId)(state),
        recentlyCreatedCustomerIds: (0, _selectors.getRecentlyCreatedCustomerIds)(state),
        recentlyCreatedProjectIds: (0, _selectors.getRecentlyCreatedProjectIds)(state),
        cpPanelClosed: (0, _selectors.isCPPanelClosed)(state),
        resizableMaxWidth: (0, _selectors4.getCPPanelMaxWidth)(state),
        resizableMinWidth: (0, _selectors4.getCPPanelMinWidth)(state),
        width: (0, _selectors4.getCPPanelWidth)(state),
        collapsedCustomersSet: (0, _selectors4.getCollapsedCustomersSet)(state)
    };
}, function (dispatch) {
    return {
        changeFilterCPSelection: (0, _redux.bindActionCreators)(_actions.changeFilterCPSelectionAction, dispatch),
        changeSingleCPSelection: (0, _redux.bindActionCreators)(_actions.changeSingleCPSelectionAction, dispatch),
        changeNameFilter: (0, _redux.bindActionCreators)(_actions.changeCustomerProjectNameFilter, dispatch),
        expandPanel: (0, _redux.bindActionCreators)(_actions.expandPanel, dispatch),
        collapsePanel: (0, _redux.bindActionCreators)(_actions.collapsePanel, dispatch),
        setWidth: (0, _redux.bindActionCreators)(_actions2.setCpPanelWidth, dispatch),
        addCollapsedCustomers: (0, _redux.bindActionCreators)(_actions2.addCollapsedCustomers, dispatch),
        removeCollapsedCustomers: (0, _redux.bindActionCreators)(_actions2.removeCollapsedCustomers, dispatch),
        changeVisibleCustomerIds: (0, _redux.bindActionCreators)(_actions2.changeVisibleCustomerIds, dispatch),
        changeVisibleProjectIds: (0, _redux.bindActionCreators)(_actions2.changeVisibleProjectIds, dispatch),
        changeIsCustomersAsc: (0, _redux.bindActionCreators)(_actions2.changeIsCustomersAsc, dispatch)
    };
})(CustomersProjectsPanel);

/***/ }),
/* 1820 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AddNewButton = function (_TemplateView) {
    _inherits(AddNewButton, _TemplateView);

    function AddNewButton(_ref) {
        var _ref$title = _ref.title,
            title = _ref$title === undefined ? "" : _ref$title,
            _ref$menu = _ref.menu,
            menu = _ref$menu === undefined ? null : _ref$menu;

        _classCallCheck(this, AddNewButton);

        var _this = _possibleConstructorReturn(this, (AddNewButton.__proto__ || Object.getPrototypeOf(AddNewButton)).call(this));

        _this.params = {
            title: title,
            menu: menu
        };
        return _this;
    }

    _createClass(AddNewButton, [{
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='addNewButton'>" + "  <div class='plusIcon'></div>" + "  <div class='title ellipsis'><%-title%></div>" + "  <div class='downIcon'></div>" + "</div>";
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            var _this2 = this;

            this.bindClick(function () {
                return _this2.params.menu.showAt(_this2.$el);
            });
        }
    }, {
        key: "templateModel",
        value: function templateModel() {
            return {
                title: this.params.title
            };
        }
    }]);

    return AddNewButton;
}(_TemplateView3.default);

exports.default = AddNewButton;

/***/ }),
/* 1821 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _TokensHighlighter = __webpack_require__(94);

var _TokensHighlighter2 = _interopRequireDefault(_TokensHighlighter);

var _WindowSizeDependedView = __webpack_require__(458);

var _WindowSizeDependedView2 = _interopRequireDefault(_WindowSizeDependedView);

var _SortableTableHeader = __webpack_require__(495);

var _SortableTableHeader2 = _interopRequireDefault(_SortableTableHeader);

var _StringTokenizer = __webpack_require__(103);

var _StringTokenizer2 = _interopRequireDefault(_StringTokenizer);

var _ScrollView = __webpack_require__(346);

var _ScrollView2 = _interopRequireDefault(_ScrollView);

var _AllCustomersNode = __webpack_require__(1822);

var _AllCustomersNode2 = _interopRequireDefault(_AllCustomersNode);

var _CustomerNode = __webpack_require__(924);

var _CustomerNode2 = _interopRequireDefault(_CustomerNode);

var _ProjectNode = __webpack_require__(926);

var _ProjectNode2 = _interopRequireDefault(_ProjectNode);

var _OtherProjectsNode = __webpack_require__(927);

var _OtherProjectsNode2 = _interopRequireDefault(_OtherProjectsNode);

var _utils = __webpack_require__(1823);

var _atUtils = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Tree = function (_WindowSizeDependedVi) {
    _inherits(Tree, _WindowSizeDependedVi);

    function Tree() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            _ref$onSingleCPSelect = _ref.onSingleCPSelectionChanged,
            onSingleCPSelectionChanged = _ref$onSingleCPSelect === undefined ? function () {} : _ref$onSingleCPSelect,
            _ref$addCollapsedCust = _ref.addCollapsedCustomers,
            addCollapsedCustomers = _ref$addCollapsedCust === undefined ? function () {} : _ref$addCollapsedCust,
            _ref$removeCollapsedC = _ref.removeCollapsedCustomers,
            removeCollapsedCustomers = _ref$removeCollapsedC === undefined ? function () {} : _ref$removeCollapsedC,
            _ref$onIsCustomersAsc = _ref.onIsCustomersAscChanged,
            onIsCustomersAscChanged = _ref$onIsCustomersAsc === undefined ? function () {} : _ref$onIsCustomersAsc,
            _ref$onVisibleCustome = _ref.onVisibleCustomerIdsChanged,
            onVisibleCustomerIdsChanged = _ref$onVisibleCustome === undefined ? function () {} : _ref$onVisibleCustome,
            _ref$onVisibleProject = _ref.onVisibleProjectIdsChanged,
            onVisibleProjectIdsChanged = _ref$onVisibleProject === undefined ? function () {} : _ref$onVisibleProject;

        _classCallCheck(this, Tree);

        var _this = _possibleConstructorReturn(this, (Tree.__proto__ || Object.getPrototypeOf(Tree)).call(this));

        _this.handleCustomerEditing = function (editingCustomerId, prevEditingCustomerId) {
            if (prevEditingCustomerId) _this._setNodeEditing("c" + prevEditingCustomerId, false);
            if (editingCustomerId) _this._setNodeEditing("c" + editingCustomerId, true);
        };

        _this.handleProjectEditing = function (editingProjectId, prevEditingProjectId) {
            if (prevEditingProjectId) _this._setNodeEditing("p" + prevEditingProjectId, false);
            if (editingProjectId) _this._setNodeEditing("p" + editingProjectId, true);
        };

        _this.actions = {
            onSingleCPSelectionChanged: onSingleCPSelectionChanged,
            addCollapsedCustomers: addCollapsedCustomers,
            removeCollapsedCustomers: removeCollapsedCustomers,
            onIsCustomersAscChanged: onIsCustomersAscChanged,
            onVisibleCustomerIdsChanged: onVisibleCustomerIdsChanged,
            onVisibleProjectIdsChanged: onVisibleProjectIdsChanged
        };

        _this.state = {
            singleCustomerProjectSelection: {},
            filterCustomerProjectSelection: {},
            customers: {},
            projects: {},
            nameFilter: '',
            editableCustomerIds: {},
            editableProjectIds: {},
            editingCustomerId: null,
            editingProjectId: null,
            recentlyCreatedCustomerIds: [],
            recentlyCreatedProjectIds: [],
            suppressScroll: false,
            collapsedCustomersSet: {},
            cpSelectorOpened: false,
            cpSelectorFiltered: false,
            isCustomersAsc: true
        };

        _this.onStatePropertyChanged('isCustomersAsc', function () {
            _this._updateUnfilteredNodes();
            if (_this.filtered) _this._showFiltered();else _this._showUnfiltered();
        });

        _this.onStatePropertyChanged('editingCustomerId', _this.handleCustomerEditing);
        _this.onStatePropertyChanged('editingProjectId', _this.handleProjectEditing);

        _this.onAnyStatePropertyDeeplyChanged(['editableCustomerIds', 'editableProjectIds'], function () {
            return _this._updateManageableNodes();
        });

        _this.onAnyStatePropertyDeeplyChanged(['nameFilter', 'customers', 'projects', 'filterCustomerProjectSelection', 'recentlyCreatedCustomerIds', 'recentlyCreatedProjectIds'], function (state) {
            if (state.nameFilter !== '') {
                _this._showFiltered();
            } else {
                _this._updateUnfilteredNodes();
                _this._showUnfiltered();
            }

            _this.actions.onVisibleCustomerIdsChanged((0, _utils.getVisibleCustomerIds)(_this.nodes));
            _this.actions.onVisibleProjectIdsChanged((0, _utils.getVisibleProjectIds)(_this.nodes));
        });

        _this.onAnyStatePropertyDeeplyChanged(['customers', 'projects'], function () {
            _this._scrollToEditingEntity();
        });

        _this.onStatePropertyDeeplyChanged('singleCustomerProjectSelection', function () {
            _this._updateNodesWithSpecialStatus();
        });

        _this.onStatePropertyDeeplyChanged('recentlyCreatedCustomerIds', function (recentlyCreatedCustomerIds) {
            if (recentlyCreatedCustomerIds.length > 0) {
                _this._currentScrollView().scrollToItem(_this.nodes.map['c' + recentlyCreatedCustomerIds[0]]);
            }
        });

        _this.onStatePropertyDeeplyChanged('recentlyCreatedProjectIds', function (recentlyCreatedProjectIds) {
            if (recentlyCreatedProjectIds.length > 0) {
                _this._currentScrollView().scrollToItem(_this.nodes.map['p' + recentlyCreatedProjectIds[0]]);
            }
        });

        _this.onStatePropertyDeeplyChanged('collapsedCustomersSet', function (collapsedSet, prevCollapsedSet) {
            _this._updateCollapsedStateOfNodes(prevCollapsedSet, collapsedSet);
            _this._currentScrollView().setItems(_this._filterCollapsedNodes(_this.nodes.array));
            _this.visibleCollapsedCustomersSet = Object.keys(collapsedSet).filter(function (id) {
                return !!_this.nodes.map['c' + id];
            });
        });

        _this.onStatePropertyChanged('cpSelectorOpened', function (cpSelectorOpened) {
            _this.$filterButton.toggleClass('pressed', cpSelectorOpened);
        });

        _this.onStatePropertyChanged('cpSelectorFiltered', function (cpSelectorFiltered) {
            _this.$filterButton.toggleClass('filtered', cpSelectorFiltered);
        });
        return _this;
    }

    _createClass(Tree, [{
        key: "_scrollToEditingEntity",
        value: function _scrollToEditingEntity() {
            if (this.state.editingCustomerId) this._currentScrollView().scrollToItem(this.nodes.map['c' + this.state.editingCustomerId]);else if (this.state.editingProjectId) this._currentScrollView().scrollToItem(this.nodes.map['p' + this.state.editingProjectId]);
        }
    }, {
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='customersProjectsTree'>" + "  <div class='header'>" + "    <div class='collapseAllButton'></div>" + "    <div class='separator'>&nbsp;</div>" + "    <div class='customerNameHeaderContainer'></div>" + "    <div class='separator'>&nbsp;</div>" + "    <div class='filterCPSelectorContainer'>" + "       <div class='commonVisibleFilterButton greyBackground'>" + "           <div class='mainIcon'></div>" + "           <div id='customersProjectsPanelFilterCPSelectorContainer' class='buttonContainer label ellipsis'></div>" + "           <div class='downIcon'></div>" + "       </div>" + "    </div>" + "  </div>" + "  <div class='unfilteredContainer'></div>" + "  <div class='filteredContainer'></div>" + "  <div class='notFoundMessage'><%-notFoundMessage%></div>" + "</div>";
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            var _this2 = this;

            this.find(".collapseAllButton").on("click", function () {
                if (_underscore2.default.isEmpty(_this2.visibleCollapsedCustomersSet)) _this2._collapseAll();else _this2._expandAll();
            });

            this.customerNameHeader = new _SortableTableHeader2.default(this.find(".customerNameHeaderContainer"), true, this.state.isCustomersAsc, "common.Customer").init();
            this.customerNameHeader.on("click", function () {
                _this2.actions.onIsCustomersAscChanged(_this2.customerNameHeader.isAsc());
            });

            this.stringTokenizer = new _StringTokenizer2.default(_StringTokenizer2.default.PUNCTUATORS_FOR_SEARCH);
            this.$unfilteredContainer = this.find(".unfilteredContainer");
            this.$filteredContainer = this.find(".filteredContainer");

            this.unfilteredScrollView = new _ScrollView2.default(this.$unfilteredContainer, 40).init();
            this.filteredScrollView = new _ScrollView2.default(this.$filteredContainer, 40).init();

            this._updateUnfilteredNodes();

            _WindowSizeDependedView2.default.prototype.afterRender.call(this);

            (0, _jquery2.default)(document).on("taskManagement_visibleCustomersWillChange", function () {
                _underscore2.default.each(_this2.nodes.array, function (node) {
                    node.disableRendering();
                });
            });

            this.$filterButton = this.find('.filterCPSelectorContainer .commonVisibleFilterButton');
        }
    }, {
        key: "adjustSize",
        value: function adjustSize() {
            _WindowSizeDependedView2.default.prototype.adjustSize.call(this);
            if (!this.filtered) {
                this.unfilteredScrollView.adjustHeightToWindowSize();
                this.unfilteredScrollViewHeightValid = true;
                this.filteredScrollViewHeightValid = false;
            } else {
                this.filteredScrollView.adjustHeightToWindowSize();
                this.filteredScrollViewHeightValid = true;
                this.unfilteredScrollViewHeightValid = false;
            }
        }
    }, {
        key: "messageKeys",
        value: function messageKeys() {
            return {
                notFoundMessage: "task.list.cp_not_found"
            };
        }
    }, {
        key: "_updateUnfilteredNodes",
        value: function _updateUnfilteredNodes() {
            var _this3 = this;

            this.unfilteredScrollViewHeightValid = false;
            var data = (0, _utils.buildVisibleCustomers)(this.state.filterCustomerProjectSelection, this.state.customers, this.state.projects, this.state.editingCustomerId, this.state.editingProjectId);
            this.visibleCollapsedCustomersSet = data.filter(function (c) {
                return _this3.state.collapsedCustomersSet[c.customerId];
            });

            this.unfilteredNodes = this._buildNodes(this.unfilteredScrollView, data, this.state.collapsedCustomersSet, null);
            this.unfilteredScrollView.setItems(this._filterCollapsedNodes(this.unfilteredNodes.array));
            if (!this.filtered) {
                this.nodes = this.unfilteredNodes;
                this._updateNodesWithSpecialStatus();
                this._updateAllExpandedState();
                this._updateNotFoundState();
                this.unfilteredScrollView.adjustHeightToWindowSize();
                this.unfilteredScrollViewHeightValid = true;
            }
        }
    }, {
        key: "_showFiltered",
        value: function _showFiltered() {
            var _this4 = this;

            this.filtered = true;
            this.$el.addClass("filtered");

            if (!this.filteredScrollViewHeightValid) {
                this.filteredScrollView.adjustHeightToWindowSize();
                this.filteredScrollViewHeightValid = true;
            }

            var text = this.state.nameFilter;
            var tokens = this.stringTokenizer.getTokens(text);

            var data = (0, _utils.buildVisibleCustomersFiltered)(this.state.filterCustomerProjectSelection, this.state.customers, this.state.projects, this.state.editingCustomerId, this.state.editingProjectId, this.state.recentlyCreatedCustomerIds, this.state.recentlyCreatedProjectIds, text);
            this.visibleCollapsedCustomersSet = data.filter(function (c) {
                return _this4.state.collapsedCustomersSet[c.customerId];
            });

            this.nodes = this._buildNodes(this.filteredScrollView, data, this.state.collapsedCustomersSet, text && tokens.length > 0 ? new _TokensHighlighter2.default(tokens, this.stringTokenizer.getPunctuators()) : null);
            this.filteredScrollView.setItems(this._filterCollapsedNodes(this.nodes.array));
            this._updateNodesWithSpecialStatus();
            this._updateAllExpandedState();
            this._updateNotFoundState();
        }
    }, {
        key: "_showUnfiltered",
        value: function _showUnfiltered() {
            this.filtered = false;
            this.$el.removeClass("filtered");

            this.nodes = this.unfilteredNodes;

            this._updateNodesWithSpecialStatus();
            this._updateAllExpandedState();
            this._updateNotFoundState();

            if (!this.unfilteredScrollViewHeightValid) {
                this.unfilteredScrollView.adjustHeightToWindowSize();
                this.unfilteredScrollViewHeightValid = true;
            }
        }
    }, {
        key: "_updateNodesWithSpecialStatus",
        value: function _updateNodesWithSpecialStatus() {
            var _this5 = this;

            var findAndSelectNode = function findAndSelectNode(nodeId) {
                var node = _this5.nodes.map[nodeId];
                _this5._setSelectedNode(node);
            };

            var singleCPSelection = this.state.singleCustomerProjectSelection;
            if (singleCPSelection.projectId) findAndSelectNode("p" + singleCPSelection.projectId);else if (singleCPSelection.customerId) findAndSelectNode("c" + singleCPSelection.customerId);else {
                findAndSelectNode("all");
                this._currentScrollView().scrollToItem(this.nodes.map["all"]);
            }

            var editingCustomerKey = this.state.editingCustomerId ? "c" + this.state.editingCustomerId : null;
            var editingProjectKey = this.state.editingProjectId ? "p" + this.state.editingProjectId : null;

            for (var key in this.nodes.map) {
                if (this.nodes.map.hasOwnProperty(key)) {
                    this._setNodeEditing(key, key === editingCustomerKey || key === editingProjectKey);
                }
            }
        }
    }, {
        key: "_buildNodes",
        value: function _buildNodes(scrollView, data, collapsedSet, tokensHighlighter) {
            var _this6 = this;

            var nodesMap = {};
            var nodesArray = [];

            var addNode = function addNode(node, id) {
                nodesArray.push(node);
                nodesMap[id] = node;
                return node;
            };

            var onProjectNodeSelect = function onProjectNodeSelect(project) {
                return _this6.actions.onSingleCPSelectionChanged({ customerId: project.customerId, projectId: project.id });
            };
            var onCustomerNodeSelect = function onCustomerNodeSelect(customerId) {
                return _this6.actions.onSingleCPSelectionChanged({ customerId: customerId, projectId: null });
            };

            var onCustomerNodeCollapse = function onCustomerNodeCollapse(e) {
                if (e.target.isCollapsed()) _this6.actions.addCollapsedCustomers([e.target.customer.id]);else _this6.actions.removeCollapsedCustomers([e.target.customer.id]);

                _this6._updateAllExpandedState();
            };

            if (!this.state.nameFilter) {
                var onAllCustomersNodeSelect = function onAllCustomersNodeSelect() {
                    return _this6.actions.onSingleCPSelectionChanged({ customerId: null, projectId: null });
                };

                addNode(new _AllCustomersNode2.default({
                    onClick: onAllCustomersNodeSelect
                }), "all");
            }

            var visibleCustomers = _underscore2.default.clone(data);

            if (!this.state.isCustomersAsc) visibleCustomers.reverse();

            visibleCustomers.forEach(function (visibleCustomer) {
                var collapsed = !!collapsedSet[visibleCustomer.customerId];
                var customerNode = addNode(new _CustomerNode2.default({
                    tokensHighlighter: tokensHighlighter,
                    customer: _this6.state.customers[visibleCustomer.customerId],
                    collapsed: collapsed,
                    onClick: function onClick() {
                        return onCustomerNodeSelect(visibleCustomer.customerId);
                    }
                }), "c" + visibleCustomer.customerId);
                customerNode.setState({ editable: !!_this6.state.editableCustomerIds[visibleCustomer.customerId] });
                customerNode.on("collapse", onCustomerNodeCollapse);

                visibleCustomer.projectIds.forEach(function (projectId) {
                    var projectNode = addNode(new _ProjectNode2.default({
                        tokensHighlighter: tokensHighlighter,
                        project: _this6.state.projects[projectId],
                        onClick: function onClick() {
                            return onProjectNodeSelect(_this6.state.projects[projectId]);
                        }
                    }), "p" + projectId);
                    projectNode.setState({ editable: !!_this6.state.editableProjectIds[projectId] });
                });

                if (tokensHighlighter !== null && visibleCustomer.otherProjectIds.length > 0) {
                    var otherProjectNode = addNode(new _OtherProjectsNode2.default({
                        onClick: function onClick() {
                            scrollView.setItems(_this6._filterCollapsedNodes(nodesArray));
                            _this6.actions.onVisibleProjectIdsChanged((0, _utils.getVisibleProjectIds)(_this6.nodes));
                        }
                    }), "other" + visibleCustomer.customerId);
                    otherProjectNode.setState({ onlyOtherProjectsInCustomer: visibleCustomer.projectIds.length === 0 });

                    visibleCustomer.otherProjectIds.forEach(function (projectId) {
                        var projectNode = addNode(new _ProjectNode2.default({
                            tokensHighlighter: null,
                            project: _this6.state.projects[projectId],
                            onClick: function onClick() {
                                return onProjectNodeSelect(_this6.state.projects[projectId]);
                            }
                        }), "p" + projectId);
                        projectNode.setState({ editable: !!_this6.state.editableProjectIds[projectId] });
                    });
                }
            });

            return {
                map: nodesMap,
                array: nodesArray
            };
        }
    }, {
        key: "_setSelectedNode",
        value: function _setSelectedNode(node) {
            if (this.selectedNode === node) return;

            if (this.selectedNode) this.selectedNode.setState({ selected: false });

            if (node) node.setState({ selected: true });

            this.selectedNode = node;
        }
    }, {
        key: "_setNodeEditing",
        value: function _setNodeEditing(nodeKey, editing) {
            var node = this.nodes.map[nodeKey];
            if (node) node.setState({ editing: editing });
        }
    }, {
        key: "_filterCollapsedNodes",
        value: function _filterCollapsedNodes(nodes) {
            var result = [];
            var hasCollapsedNodeAbove = false;
            nodes.forEach(function (node) {
                var isCustomerNode = node instanceof _CustomerNode2.default;
                var isOtherProjectNode = node instanceof _OtherProjectsNode2.default;

                if (hasCollapsedNodeAbove) {
                    if (isCustomerNode) hasCollapsedNodeAbove = false;else return;
                }

                if ((isCustomerNode || isOtherProjectNode) && node.isCollapsed()) hasCollapsedNodeAbove = true;

                result.push(node);
            });

            return result;
        }
    }, {
        key: "_collapseAll",
        value: function _collapseAll() {
            var collapsedIds = [];
            _underscore2.default.each(this.nodes.array, function (node) {
                if (node instanceof _CustomerNode2.default && !node.isCollapsed()) {
                    collapsedIds.push(node.getId());
                }
            });
            this.actions.addCollapsedCustomers(collapsedIds);

            this._updateAllExpandedState();
        }
    }, {
        key: "_expandAll",
        value: function _expandAll() {
            var expandedIds = [];
            _underscore2.default.each(this.nodes.array, function (node) {
                if (node instanceof _CustomerNode2.default && node.isCollapsed()) {
                    expandedIds.push(node.getId());
                }
            });
            this.actions.removeCollapsedCustomers(expandedIds);

            this._updateAllExpandedState();
        }
    }, {
        key: "_updateAllExpandedState",
        value: function _updateAllExpandedState() {
            this.$el.toggleClass("allExpanded", _underscore2.default.isEmpty(this.visibleCollapsedCustomersSet));
        }
    }, {
        key: "_updateNotFoundState",
        value: function _updateNotFoundState() {
            this.$el.toggleClass("notFound", this.nodes.array.length === 0);
        }
    }, {
        key: "_updateManageableNodes",
        value: function _updateManageableNodes() {
            var _this7 = this;

            this.nodes.array.forEach(function (node) {
                if (node instanceof _CustomerNode2.default) {
                    node.setState({ editable: !!_this7.state.editableCustomerIds[node.getId()] });
                }
                if (node instanceof _ProjectNode2.default) {
                    node.setState({ editable: !!_this7.state.editableProjectIds[node.getId()] });
                }
            });
        }
    }, {
        key: "_updateCollapsedStateOfNodes",
        value: function _updateCollapsedStateOfNodes(prevCollapsedSet, collapsedSet) {
            var _this8 = this;

            var _getDiffOfSets = (0, _atUtils.getDiffOfSets)(prevCollapsedSet, collapsedSet),
                added = _getDiffOfSets.added,
                removed = _getDiffOfSets.removed;

            Object.keys(added).forEach(function (cId) {
                if (_this8.nodes.map['c' + cId]) _this8.nodes.map['c' + cId].setCollapsed(true);
            });

            Object.keys(removed).forEach(function (cId) {
                if (_this8.nodes.map['c' + cId]) _this8.nodes.map['c' + cId].setCollapsed(false);
            });
        }

        /**
         * @returns {ScrollView}
         * @private
         */

    }, {
        key: "_currentScrollView",
        value: function _currentScrollView() {
            return this.filtered ? this.filteredScrollView : this.unfilteredScrollView;
        }
    }]);

    return Tree;
}(_WindowSizeDependedView2.default);

exports.default = Tree;

/***/ }),
/* 1822 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _Node2 = __webpack_require__(572);

var _Node3 = _interopRequireDefault(_Node2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AllCustomersNode = function (_Node) {
    _inherits(AllCustomersNode, _Node);

    function AllCustomersNode(_ref) {
        var _ref$onClick = _ref.onClick,
            onClick = _ref$onClick === undefined ? function () {} : _ref$onClick;

        _classCallCheck(this, AllCustomersNode);

        return _possibleConstructorReturn(this, (AllCustomersNode.__proto__ || Object.getPrototypeOf(AllCustomersNode)).call(this, onClick));
    }

    _createClass(AllCustomersNode, [{
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='node allCustomersNode'>" + "  <div class='icon'></div>" + "  <div class='title'><%-title%></div>" + "</div>";
        }
    }, {
        key: "messageKeys",
        value: function messageKeys() {
            return { title: "task.list.all_customers" };
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            _get(AllCustomersNode.prototype.__proto__ || Object.getPrototypeOf(AllCustomersNode.prototype), "afterRender", this).call(this);
            this.renderInitialState();
        }
    }]);

    return AllCustomersNode;
}(_Node3.default);

exports.default = AllCustomersNode;

/***/ }),
/* 1823 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getVisibleProjectIds = exports.getVisibleCustomerIds = exports.buildVisibleCustomersFiltered = exports.buildVisibleCustomers = undefined;

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _CustomerProjectSelection = __webpack_require__(156);

var _CustomerProjectSelection2 = _interopRequireDefault(_CustomerProjectSelection);

var _utils = __webpack_require__(242);

var _atUtils = __webpack_require__(5);

var _CustomerNode = __webpack_require__(924);

var _CustomerNode2 = _interopRequireDefault(_CustomerNode);

var _ProjectNode = __webpack_require__(926);

var _ProjectNode2 = _interopRequireDefault(_ProjectNode);

var _OtherProjectsNode = __webpack_require__(927);

var _OtherProjectsNode2 = _interopRequireDefault(_OtherProjectsNode);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var buildVisibleCustomers = exports.buildVisibleCustomers = function buildVisibleCustomers(filterCPSelection, customers, projects, openCustomerId, openProjectId) {
    var result = [];
    var cpSelection = _CustomerProjectSelection2.default.fromPlainObject(filterCPSelection);

    var sortedCustomers = Object.values(customers).sort(_atUtils.nameComparator);
    var sortedProjects = Object.values(projects).sort(_atUtils.nameComparator);

    var projectsByCustomer = _underscore2.default.groupBy(sortedProjects, 'customerId');

    sortedCustomers.forEach(function (customer) {
        var customerIncluded = cpSelection.includesCustomer(customer) || openCustomerId === customer.id;
        var customerProjects = projectsByCustomer[customer.id] ? projectsByCustomer[customer.id].filter(function (p) {
            return cpSelection.includesProject(p) || openProjectId === p.id;
        }) : [];

        if (customerIncluded || customerProjects.length > 0) {
            result.push({
                customerId: customer.id,
                projectIds: customerProjects.map(function (p) {
                    return p.id;
                })
            });
        }
    });

    return result;
};

var buildVisibleCustomersFiltered = exports.buildVisibleCustomersFiltered = function buildVisibleCustomersFiltered(filterCPSelection, customers, projects, openCustomerId, openProjectId, recentlyCreatedCustomerIds, recentlyCreatedProjectIds, text) {

    if (!text) return null;

    var result = [];
    var resultMap = {};
    var cpSelection = _CustomerProjectSelection2.default.fromPlainObject(filterCPSelection);

    var sortedCustomers = Object.values(customers).filter(function (customer) {
        return !recentlyCreatedCustomerIds.includes(customer.id) || openCustomerId === customer.id;
    }).sort(_atUtils.nameComparator);

    var sortedProjects = Object.values(projects).filter(function (project) {
        return !recentlyCreatedProjectIds.includes(project.id) || openCustomerId === project.customerId || openProjectId === project.id;
    }).sort(_atUtils.nameComparator);

    var getOrCreateVisibleCustomerData = function getOrCreateVisibleCustomerData(customerId) {
        var visibleCustomerData = resultMap[customerId];
        if (!visibleCustomerData) {
            visibleCustomerData = {
                customerId: customerId,
                projectIds: [],
                otherProjectIds: []
            };
            result.push(visibleCustomerData);
            resultMap[customerId] = visibleCustomerData;
        }
        return visibleCustomerData;
    };

    recentlyCreatedCustomerIds.forEach(function (cId) {
        getOrCreateVisibleCustomerData(cId);
    });

    recentlyCreatedProjectIds.forEach(function (pId) {
        var visibleCustomerData = getOrCreateVisibleCustomerData(projects[pId].customerId);
        visibleCustomerData.projectIds.push(pId);
    });

    (0, _utils.filterEntitiesBySearch)(sortedCustomers, text).forEach(function (customer) {
        if (cpSelection.includesCustomer(customer, true) || openCustomerId === customer.id) getOrCreateVisibleCustomerData(customer.id);
    });

    (0, _utils.filterEntitiesBySearch)(sortedProjects, text).forEach(function (project) {
        if (cpSelection.includesProject(project) || openProjectId === project.id || openCustomerId === project.customerId) {
            var visibleCustomerData = getOrCreateVisibleCustomerData(project.customerId);
            visibleCustomerData.projectIds.push(project.id);
        }
    });

    if (text) {
        Object.values(resultMap).forEach(function (visibleCustomerData) {
            var projectsByCustomer = _underscore2.default.groupBy(sortedProjects, 'customerId');

            var customerProjects = projectsByCustomer[visibleCustomerData.customerId] ? projectsByCustomer[visibleCustomerData.customerId] : [];
            customerProjects.filter(function (project) {
                return cpSelection.includesProject(project);
            }).forEach(function (project) {
                if (!visibleCustomerData.projectIds.find(function (id) {
                    return Number(id) === project.id;
                })) {
                    visibleCustomerData.otherProjectIds.push(project.id);
                }
            });
        });
    }

    return result;
};

var getVisibleCustomerIds = exports.getVisibleCustomerIds = function getVisibleCustomerIds(nodes) {
    var customerNodes = nodes.array.filter(function (node) {
        return node instanceof _CustomerNode2.default;
    });
    return customerNodes.map(function (customerNode) {
        return customerNode.customer.id;
    });
};

var getVisibleProjectIds = exports.getVisibleProjectIds = function getVisibleProjectIds(nodes) {
    var projectIds = [];

    var cursorInOtherProjectsNode = false;
    var shouldSkipOtherProjectsNode = false;

    for (var i = 0; i < nodes.array.length; i++) {
        var node = nodes.array[i];

        var isProjectNode = node instanceof _ProjectNode2.default;
        var isOtherProjectNode = node instanceof _OtherProjectsNode2.default;
        var isProjectNodeInOtherSelection = cursorInOtherProjectsNode && !shouldSkipOtherProjectsNode;

        if (isOtherProjectNode) {
            cursorInOtherProjectsNode = true;
            shouldSkipOtherProjectsNode = node.state.collapsed;
        } else if (!isProjectNode) {
            cursorInOtherProjectsNode = false;
        } else if (isProjectNodeInOtherSelection) {
            projectIds.push(node.project.id);
        } else if (!cursorInOtherProjectsNode && isProjectNode) {
            projectIds.push(node.project.id);
        }
    }

    return projectIds;
};

/***/ }),
/* 1824 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _DropdownTemplateView2 = __webpack_require__(42);

var _DropdownTemplateView3 = _interopRequireDefault(_DropdownTemplateView2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AddNewMenu = function (_DropdownTemplateView) {
    _inherits(AddNewMenu, _DropdownTemplateView);

    function AddNewMenu() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            _ref$importTasksCb = _ref.importTasksCb,
            importTasksCb = _ref$importTasksCb === undefined ? function () {} : _ref$importTasksCb,
            _ref$createNewTasksCb = _ref.createNewTasksCb,
            createNewTasksCb = _ref$createNewTasksCb === undefined ? function () {} : _ref$createNewTasksCb,
            _ref$createNewProject = _ref.createNewProjectCb,
            createNewProjectCb = _ref$createNewProject === undefined ? function () {} : _ref$createNewProject,
            _ref$createNewCustome = _ref.createNewCustomerCb,
            createNewCustomerCb = _ref$createNewCustome === undefined ? function () {} : _ref$createNewCustome;

        _classCallCheck(this, AddNewMenu);

        var _this = _possibleConstructorReturn(this, (AddNewMenu.__proto__ || Object.getPrototypeOf(AddNewMenu)).call(this, null));

        _this.callbacks = {
            importTasksCb: importTasksCb,
            createNewTasksCb: createNewTasksCb,
            createNewProjectCb: createNewProjectCb,
            createNewCustomerCb: createNewCustomerCb
        };

        _this.state = {
            isPossibleToAddCustomers: false,
            isPossibleToAddProjects: false
        };

        _this.onStatePropertyChanged('isPossibleToAddCustomers', function (show) {
            return _this.find('.createNewCustomer').toggle(show);
        });
        _this.onStatePropertyChanged('isPossibleToAddProjects', function (show) {
            return _this.find('.createNewProject').toggle(show);
        });
        return _this;
    }

    _createClass(AddNewMenu, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return "<div class='dropdownContainer addNewMenu'>" + "  <div class='item createNewCustomer'><%-newCustomer%></div>" + "  <div class='item createNewProject'><%-newProject%></div>" + "  <div class='item createNewTasks'><%-createTasks%></div>" + "  <div class='item importTasks'><%-importTasks%></div>" + "</div>";
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            var _this2 = this;

            this.findAndBindClick(".createNewCustomer", function () {
                return _this2._handleClick(_this2.callbacks.createNewCustomerCb);
            });
            this.findAndBindClick(".createNewProject", function () {
                return _this2._handleClick(_this2.callbacks.createNewProjectCb);
            });
            this.findAndBindClick(".importTasks", function () {
                return _this2._handleClick(_this2.callbacks.importTasksCb);
            });
            this.findAndBindClick(".createNewTasks", function () {
                return _this2._handleClick(_this2.callbacks.createNewTasksCb);
            });
            this.renderInitialState();
        }
    }, {
        key: 'messageKeys',
        value: function messageKeys() {
            return {
                "newCustomer": "task.list.add_new.customer",
                "newProject": "task.list.add_new.project",
                "importTasks": "task.list.add_new.import_tasks",
                "createTasks": "task.list.add_new_tasks"
            };
        }
    }, {
        key: '_handleClick',
        value: function _handleClick(callback) {
            this.hide();
            callback();
        }
    }]);

    return AddNewMenu;
}(_DropdownTemplateView3.default);

exports.default = AddNewMenu;

/***/ }),
/* 1825 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _selectors = __webpack_require__(574);

var _utils = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ExportCPDropdown = function (_TemplateView) {
    _inherits(ExportCPDropdown, _TemplateView);

    function ExportCPDropdown() {
        _classCallCheck(this, ExportCPDropdown);

        var _this = _possibleConstructorReturn(this, (ExportCPDropdown.__proto__ || Object.getPrototypeOf(ExportCPDropdown)).call(this, null));

        _this.state = {
            customerIdsForExport: [],
            projectIdsForExport: [],
            isCustomersAsc: true
        };

        _this.onStatePropertyChanged('customerIdsForExport', function (customerIdsForExport) {
            _this.state.customerIdsForExport = customerIdsForExport;
            _this.exportCPDropdown.setProps({ customerIds: customerIdsForExport });
        });
        _this.onStatePropertyChanged('projectIdsForExport', function (projectIdsForExport) {
            _this.state.projectIdsForExport = projectIdsForExport;
            _this.exportCPDropdown.setProps({ projectIds: projectIdsForExport });
        });
        _this.onStatePropertyChanged('isCustomersAsc', function (isCustomersAsc) {
            _this.state.isCustomersAsc = isCustomersAsc;
            _this.exportCPDropdown.setProps({ isGroupsAsc: isCustomersAsc });
        });
        return _this;
    }

    _createClass(ExportCPDropdown, [{
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='atNextMount exportCPMount'></div>";
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            this.exportCPDropdown = ClassicBridge.integrateExportCPDropdown(this.$el[0], {
                triggerClassName: "exportCPDropdownTrigger",
                triggerButtonClassName: "exportCPDropdownTriggerButton",
                isGroupsAsc: this.state.isCustomersAsc,
                customerIds: this.state.customerIdsForExport,
                projectIds: this.state.projectIdsForExport
            });
        }
    }]);

    return ExportCPDropdown;
}(_TemplateView3.default);

exports.default = (0, _utils.connect)(function (state) {
    return {
        customerIdsForExport: (0, _selectors.getCustomerIdsForExport)(state),
        projectIdsForExport: (0, _selectors.getProjectIdsForExport)(state),
        isCustomersAsc: (0, _selectors.getIsCustomersAsc)(state)
    };
})(ExportCPDropdown);

/***/ }),
/* 1826 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.KanbanViewContainer = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _redux = __webpack_require__(7);

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _StatusHeadersPanel = __webpack_require__(1827);

var _StatusHeadersPanel2 = _interopRequireDefault(_StatusHeadersPanel);

var _actions = __webpack_require__(364);

var _selectors = __webpack_require__(243);

var _selectors2 = __webpack_require__(27);

var _selectors3 = __webpack_require__(14);

var _actions2 = __webpack_require__(55);

var _selectors4 = __webpack_require__(97);

var _utils = __webpack_require__(6);

var _KanbanContent = __webpack_require__(1829);

var _KanbanContent2 = _interopRequireDefault(_KanbanContent);

var _AutoScrollableWrapper = __webpack_require__(401);

var _AutoScrollableWrapper2 = _interopRequireDefault(_AutoScrollableWrapper);

var _actions3 = __webpack_require__(81);

var _selectors5 = __webpack_require__(15);

var _TasksNotFoundMessage = __webpack_require__(923);

var _TasksNotFoundMessage2 = _interopRequireDefault(_TasksNotFoundMessage);

var _actions4 = __webpack_require__(194);

var _selectors6 = __webpack_require__(106);

var _LocalSettingsUpdater = __webpack_require__(1835);

var _LocalSettingsUpdater2 = _interopRequireDefault(_LocalSettingsUpdater);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var KanbanViewContainer = exports.KanbanViewContainer = function (_TemplateView) {
    _inherits(KanbanViewContainer, _TemplateView);

    function KanbanViewContainer(_ref) {
        var _ref$onTaskStatusAndP = _ref.onTaskStatusAndPositionChanged,
            onTaskStatusAndPositionChanged = _ref$onTaskStatusAndP === undefined ? function (taskId, newStatusId) {} : _ref$onTaskStatusAndP,
            _ref$onAllSelectedCha = _ref.onAllSelectedChanged,
            onAllSelectedChanged = _ref$onAllSelectedCha === undefined ? function (allSelected) {} : _ref$onAllSelectedCha,
            _ref$onMinimizedCards = _ref.onMinimizedCardsChanged,
            onMinimizedCardsChanged = _ref$onMinimizedCards === undefined ? function (minimizedCards) {} : _ref$onMinimizedCards,
            _ref$onProjectHeaderC = _ref.onProjectHeaderClick,
            onProjectHeaderClick = _ref$onProjectHeaderC === undefined ? function (projectId) {} : _ref$onProjectHeaderC,
            _ref$onScrollToEnd = _ref.onScrollToEnd,
            onScrollToEnd = _ref$onScrollToEnd === undefined ? function () {} : _ref$onScrollToEnd,
            _ref$onTaskClick = _ref.onTaskClick,
            onTaskClick = _ref$onTaskClick === undefined ? function (taskId) {} : _ref$onTaskClick,
            _ref$closeAnyTaskPane = _ref.closeAnyTaskPanel,
            closeAnyTaskPanel = _ref$closeAnyTaskPane === undefined ? function () {} : _ref$closeAnyTaskPane,
            _ref$onSelectTaskHand = _ref.onSelectTaskHandler,
            onSelectTaskHandler = _ref$onSelectTaskHand === undefined ? function () {} : _ref$onSelectTaskHand,
            _ref$reloadKanban = _ref.reloadKanban,
            reloadKanban = _ref$reloadKanban === undefined ? function () {} : _ref$reloadKanban,
            _ref$reloadCounters = _ref.reloadCounters,
            reloadCounters = _ref$reloadCounters === undefined ? function () {} : _ref$reloadCounters,
            _ref$clearLastCreated = _ref.clearLastCreatedTaskIds,
            clearLastCreatedTaskIds = _ref$clearLastCreated === undefined ? function () {} : _ref$clearLastCreated;

        _classCallCheck(this, KanbanViewContainer);

        var _this = _possibleConstructorReturn(this, (KanbanViewContainer.__proto__ || Object.getPrototypeOf(KanbanViewContainer)).call(this));

        _this.state = {
            statuses: [],
            projectsWithGroupedTasks: [],
            customers: [],
            showSingleProject: false,
            showSingleCustomer: false,
            canEditTaskStatus: true,
            taskStatusFilter: {
                allSelected: true,
                statusTypes: [],
                statusIds: []
            },
            minimizedCards: false,
            taskIdWithDetailsOpen: null,
            selectedTaskIds: {},
            collapsedProjectIds: {},
            lastCreatedTaskIds: {},
            recentlyCreatedTaskIds: {},
            updatingTaskIds: [],
            workflowStatusesMap: {},
            isNeedToReload: false,
            isNeedToReloadCounters: false,
            showSelection: false,
            bulkOperationsPanelShown: false,
            showEstimate: false,
            thereAreNoTasks: false,
            isSearchEnable: false,
            ignoreProjectCollapse: false,
            singleCPSelection: {},
            manageableTaskIds: {}
        };

        _this.callbacks = {
            onTaskStatusAndPositionChanged: onTaskStatusAndPositionChanged,
            onScrollToEnd: onScrollToEnd,
            onProjectHeaderClick: onProjectHeaderClick,
            onTaskClick: onTaskClick,
            closeAnyTaskPanel: closeAnyTaskPanel,
            onSelectTaskHandler: onSelectTaskHandler,
            onMinimizedCardsChanged: onMinimizedCardsChanged,
            reloadKanban: reloadKanban,
            reloadCounters: reloadCounters,
            clearLastCreatedTaskIds: clearLastCreatedTaskIds
        };

        _this.onStatePropertyBecameTrue('isNeedToReload', function () {
            return _this.callbacks.reloadKanban();
        });

        _this.onStatePropertyBecameTrue('isNeedToReloadCounters', function () {
            return _this.callbacks.reloadCounters();
        });

        _this.onStateChanged(function (state) {
            _this.statusHeadersPanel.setState({
                statuses: state.statuses,
                taskStatusFilter: state.taskStatusFilter
            });

            _this.kanbanContent.setState({
                statuses: state.statuses,
                canEditTaskStatus: state.canEditTaskStatus,
                projectsWithGroupedTasks: state.projectsWithGroupedTasks,
                collapsedProjectIds: state.collapsedProjectIds,
                customers: state.customers,
                showSingleProject: state.showSingleProject,
                showSingleCustomer: state.showSingleCustomer,
                selectedTaskIds: state.selectedTaskIds,
                taskStatusFilter: state.taskStatusFilter,
                taskIdWithDetailsOpen: state.taskIdWithDetailsOpen,
                minimizedCards: state.minimizedCards,
                lastCreatedTaskIds: state.lastCreatedTaskIds,
                recentlyCreatedTaskIds: state.recentlyCreatedTaskIds,
                updatingTaskIds: state.updatingTaskIds,
                showSelection: state.showSelection,
                showEstimate: state.showEstimate,
                ignoreProjectCollapse: state.ignoreProjectCollapse,
                manageableTaskIds: state.manageableTaskIds
            });

            _this.kanbanContentVerticalScrollWrapper.refreshScroll();
            _this.kanbanContentHorizontalScrollWrapper.refreshScroll();
        });

        _this.onStatePropertyChanged('bulkOperationsPanelShown', function () {
            _this.kanbanContentVerticalScrollWrapper.refreshScroll();
        });

        _this.onStatePropertyChanged('thereAreNoTasks', function (thereAreNoTasks) {
            _this.tasksNotFoundMessage.toggle(thereAreNoTasks);
            _this.kanbanContentVerticalScrollWrapper.toggle(!thereAreNoTasks);
        });

        _this.onAnyStatePropertyChanged(['singleCPSelection', 'isSearchEnable'], function (_ref2) {
            var singleCPSelection = _ref2.singleCPSelection,
                isSearchEnable = _ref2.isSearchEnable;

            _this.tasksNotFoundMessage.setState({
                showLinkToAllTasks: isSearchEnable && (!!singleCPSelection.customerId || !!singleCPSelection.projectId)
            });
        });
        return _this;
    }

    _createClass(KanbanViewContainer, [{
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='kanbanViewContainer'>" + "  <div class='content kanbanVerticalScrollContainer'></div>" + "</div>";
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            var _this2 = this;

            this.statusHeadersPanel = new _StatusHeadersPanel2.default();

            this.kanbanContent = new _KanbanContent2.default({
                onProjectHeaderClick: function onProjectHeaderClick(projectId) {
                    return _this2.callbacks.onProjectHeaderClick(projectId);
                },
                onTaskClick: function onTaskClick(taskId) {
                    return _this2.callbacks.onTaskClick(taskId);
                },
                closeAnyTaskPanel: this.callbacks.closeAnyTaskPanel,
                onSelectTaskHandler: this.callbacks.onSelectTaskHandler,
                onTaskStatusAndPositionChanged: this.callbacks.onTaskStatusAndPositionChanged,
                onCardActiveSelectionDisappear: this.callbacks.clearLastCreatedTaskIds
            });

            this.kanbanContentVerticalScrollWrapper = new _AutoScrollableWrapper2.default({
                components: [this.kanbanContent],
                additionalClasses: 'kanbanVerticalScrollableWrapper',
                autoScrollEnabled: true,
                scrollEvent: 'sortableList_itemDrag',
                eventDataRetriever: function eventDataRetriever(event, mouseEvent) {
                    return mouseEvent;
                },
                enableVerticalScroll: true,
                verticalScrollConfig: {
                    probeType: 2
                },
                verticalScrollContainerClass: 'kanbanVerticalScrollContainer',
                onScrollToBottom: function onScrollToBottom() {
                    return _this2.callbacks.onScrollToEnd();
                },
                showScrollToTopButton: true
            });

            var kanbanHorizontalScrollClassContainer = 'kanbanHorizontalScrollableWrapper';
            this.kanbanContentHorizontalScrollWrapper = new _AutoScrollableWrapper2.default({
                components: [this.statusHeadersPanel, this.kanbanContentVerticalScrollWrapper],
                additionalClasses: kanbanHorizontalScrollClassContainer,
                autoScrollEnabled: true,
                scrollEvent: 'sortableList_itemDrag',
                eventDataRetriever: function eventDataRetriever(event, mouseEvent) {
                    return mouseEvent;
                },
                enableHorizontalScroll: true,
                horizontalScrollConfig: {
                    probeType: 2,
                    mouseWheel: false
                }
            }).init(this.find(".content"));

            this.tasksNotFoundMessage = new _TasksNotFoundMessage2.default().init(this.find("." + kanbanHorizontalScrollClassContainer));

            // use if need to store local settings when state updating
            new _LocalSettingsUpdater2.default().init();
        }
    }, {
        key: "show",
        value: function show() {
            _get(KanbanViewContainer.prototype.__proto__ || Object.getPrototypeOf(KanbanViewContainer.prototype), "show", this).call(this);
            this.kanbanContentHorizontalScrollWrapper.show();
        }
    }]);

    return KanbanViewContainer;
}(_TemplateView3.default);

exports.default = (0, _utils.connect)(function (state) {
    return {
        statuses: (0, _selectors.getWorkflowStatuses)(state),
        allWorkflowStatuses: (0, _selectors3.getWorkflowStatuses)(state),
        projectsWithGroupedTasks: (0, _selectors.getProjectsWithGroupedTasks)(state),
        taskIdWithDetailsOpen: (0, _selectors4.getOpenTaskId)(state),
        selectedTaskIds: (0, _selectors6.getSelectedTaskIds)(state),
        taskStatusFilter: (0, _selectors2.getTaskStatusFilter)(state),
        lastCreatedTaskIds: (0, _selectors2.getLastCreatedTaskIds)(state),
        recentlyCreatedTaskIds: (0, _selectors2.getRecentlyCreatedTaskIds)(state),
        minimizedCards: (0, _selectors.isMinimizedCards)(state),
        customers: (0, _selectors3.getCustomers)(state),
        showSingleProject: (0, _selectors2.isSingleProjectSelected)(state),
        showSingleCustomer: (0, _selectors2.isSingleCustomerSelected)(state),
        updatingTaskIds: (0, _selectors.getUpdatingTaskIds)(state),
        workflowStatusesMap: (0, _selectors3.getWorkflowStatuses)(state),
        isNeedToReload: (0, _selectors.isNeedToReloadKanban)(state),
        isNeedToReloadCounters: (0, _selectors.isNeedToReloadCounters)(state),
        showSelection: (0, _selectors2.isNeedToShowSelection)(state),
        bulkOperationsPanelShown: (0, _selectors2.isBulkOperationsPanelShown)(state),
        showEstimate: (0, _selectors5.isESTEnabled)(state),
        collapsedProjectIds: (0, _selectors.getCollapsedProjectsIdsSet)(state),
        thereAreNoTasks: (0, _selectors.thereAreNoTasks)(state),
        canEditTaskStatus: (0, _selectors2.canViewerEditTaskStatus)(state),
        isSearchEnable: (0, _selectors.isSearchEnable)(state),
        ignoreProjectCollapse: (0, _selectors.doesIgnoreCollapse)(state),
        singleCPSelection: (0, _selectors2.getSingleCPSelection)(state),
        manageableTaskIds: (0, _selectors2.getEditableTaskIds)(state)
    };
}, function (dispatch) {
    return {
        onScrollToEnd: (0, _redux.bindActionCreators)(_actions.loadOnScroll, dispatch),
        onTaskClick: (0, _redux.bindActionCreators)(_actions3.openEditTaskPanel, dispatch),
        closeAnyTaskPanel: (0, _redux.bindActionCreators)(_actions3.closeAnyTaskPanel, dispatch),
        onSelectTaskHandler: (0, _redux.bindActionCreators)(_actions4.changeTaskSelected, dispatch),
        onProjectHeaderClick: (0, _redux.bindActionCreators)(_actions.toggleProjectCollapsed, dispatch),
        onMinimizedCardsChanged: (0, _redux.bindActionCreators)(_actions.toggleMinimizedCards, dispatch),
        onTaskStatusAndPositionChanged: (0, _redux.bindActionCreators)(_actions.updateTaskStatusAndPosition, dispatch),
        reloadKanban: (0, _redux.bindActionCreators)(_actions.reloadKanban, dispatch),
        reloadCounters: (0, _redux.bindActionCreators)(_actions.reloadCounters, dispatch),
        clearLastCreatedTaskIds: (0, _redux.bindActionCreators)(_actions2.removeLastCreatedTaskIdsAction, dispatch)
    };
})(KanbanViewContainer);

/***/ }),
/* 1827 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _StatusHeader = __webpack_require__(1828);

var _StatusHeader2 = _interopRequireDefault(_StatusHeader);

var _utils = __webpack_require__(80);

var _constants = __webpack_require__(23);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var StatusHeadersPanel = function (_TemplateView) {
    _inherits(StatusHeadersPanel, _TemplateView);

    function StatusHeadersPanel() {
        _classCallCheck(this, StatusHeadersPanel);

        var _this = _possibleConstructorReturn(this, (StatusHeadersPanel.__proto__ || Object.getPrototypeOf(StatusHeadersPanel)).call(this));

        _this._appendFirstStatusMarker = function (statusType, markerTextKey) {
            var statusClass = (0, _utils.getStatusClassByType)(statusType);
            var markerText = _messageResource2.default.getEscapedMessage(markerTextKey);
            var $firstStatusHeader = (0, _jquery2.default)('.statusHeadersPanel').find('.' + statusClass).first();
            $firstStatusHeader.append("<div class='firstStatusMarker'>" + markerText + "</div>");
        };

        _this.state = {
            statuses: []
        };

        _this.onStatePropertyDeeplyChanged("statuses", function (statuses) {
            return _this._updateStatuses(statuses);
        });
        return _this;
    }

    _createClass(StatusHeadersPanel, [{
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='statusHeadersPanel'></div>";
        }
    }, {
        key: "_updateStatuses",
        value: function _updateStatuses(statuses) {
            var _this2 = this;

            this.$el.empty();

            statuses.forEach(function (_ref) {
                var name = _ref.name,
                    count = _ref.count,
                    type = _ref.type,
                    colorId = _ref.colorId;

                new _StatusHeader2.default({ name: name, count: count, type: type, colorId: colorId }).init(_this2.$el);
            });

            this._appendFirstStatusMarker(_constants.WorkflowStatusType.OPEN, 'task.list.kanban.status_headers_panel.open_tasks');
            this._appendFirstStatusMarker(_constants.WorkflowStatusType.COMPLETED, 'task.list.kanban.status_headers_panel.completed_tasks');
            (0, _jquery2.default)('.statusHeadersPanel').find('.statusHeader.' + (0, _utils.getStatusClassByType)(_constants.WorkflowStatusType.OPEN)).last().addClass("lastOpen");
        }
    }]);

    return StatusHeadersPanel;
}(_TemplateView3.default);

exports.default = StatusHeadersPanel;

/***/ }),
/* 1828 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _utils = __webpack_require__(80);

var _WorkflowStatusIcon = __webpack_require__(241);

var _WorkflowStatusIcon2 = _interopRequireDefault(_WorkflowStatusIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var StatusHeader = function (_TemplateView) {
    _inherits(StatusHeader, _TemplateView);

    function StatusHeader(_ref) {
        var _ref$name = _ref.name,
            name = _ref$name === undefined ? "" : _ref$name,
            _ref$count = _ref.count,
            count = _ref$count === undefined ? 0 : _ref$count,
            _ref$type = _ref.type,
            type = _ref$type === undefined ? -1 : _ref$type,
            _ref$colorId = _ref.colorId,
            colorId = _ref$colorId === undefined ? 0 : _ref$colorId;

        _classCallCheck(this, StatusHeader);

        var _this = _possibleConstructorReturn(this, (StatusHeader.__proto__ || Object.getPrototypeOf(StatusHeader)).call(this));

        _this.name = name;
        _this.count = count;
        _this.type = type;
        _this.colorId = colorId;
        return _this;
    }

    _createClass(StatusHeader, [{
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='statusHeader <%=statusClass%> <%=colorClass%>'>" + "  <div class='icon'></div>" + "  <div class='name'><%-name%></div>" + "  <div class='count <%=colorClass%>'><%=count%></div>" + "</div>";
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            new _WorkflowStatusIcon2.default(null, {
                colorId: this.colorId,
                type: this.type
            }).init(this.find('.icon'));
        }
    }, {
        key: "templateModel",
        value: function templateModel() {
            return {
                name: this.name,
                count: this.count,
                statusClass: (0, _utils.getStatusClassByType)(this.type),
                colorClass: (0, _utils.getColorClassById)(this.colorId),
                statusTypeIconClass: (0, _utils.getStatusTypeClassByColorId)(this.colorId)
            };
        }
    }]);

    return StatusHeader;
}(_TemplateView3.default);

exports.default = StatusHeader;

/***/ }),
/* 1829 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _ProjectTasksBlock = __webpack_require__(1830);

var _ProjectTasksBlock2 = _interopRequireDefault(_ProjectTasksBlock);

var _atUtils = __webpack_require__(5);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _constants = __webpack_require__(23);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _ComponentTooltip = __webpack_require__(1834);

var _ComponentTooltip2 = _interopRequireDefault(_ComponentTooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var KanbanContent = function (_TemplateView) {
    _inherits(KanbanContent, _TemplateView);

    function KanbanContent(_ref) {
        var _ref$onProjectHeaderC = _ref.onProjectHeaderClick,
            onProjectHeaderClick = _ref$onProjectHeaderC === undefined ? function (projectId) {} : _ref$onProjectHeaderC,
            _ref$onTaskStatusAndP = _ref.onTaskStatusAndPositionChanged,
            onTaskStatusAndPositionChanged = _ref$onTaskStatusAndP === undefined ? function () {} : _ref$onTaskStatusAndP,
            _ref$onSelectTaskHand = _ref.onSelectTaskHandler,
            onSelectTaskHandler = _ref$onSelectTaskHand === undefined ? function () {} : _ref$onSelectTaskHand,
            _ref$onTaskClick = _ref.onTaskClick,
            onTaskClick = _ref$onTaskClick === undefined ? function (taskId) {} : _ref$onTaskClick,
            _ref$closeAnyTaskPane = _ref.closeAnyTaskPanel,
            closeAnyTaskPanel = _ref$closeAnyTaskPane === undefined ? function () {} : _ref$closeAnyTaskPane,
            _ref$onCardActiveSele = _ref.onCardActiveSelectionDisappear,
            onCardActiveSelectionDisappear = _ref$onCardActiveSele === undefined ? function () {} : _ref$onCardActiveSele;

        _classCallCheck(this, KanbanContent);

        var _this = _possibleConstructorReturn(this, (KanbanContent.__proto__ || Object.getPrototypeOf(KanbanContent)).call(this));

        _this.onProjectHeaderClick = onProjectHeaderClick;
        _this.onTaskClick = onTaskClick;
        _this.closeAnyTaskPanel = closeAnyTaskPanel;
        _this.onSelectTaskHandler = onSelectTaskHandler;
        _this.onTaskStatusAndPositionChanged = onTaskStatusAndPositionChanged;
        _this.onCardActiveSelectionDisappear = onCardActiveSelectionDisappear;

        _this.projectBlocks = {};

        _this.state = {
            statuses: [],
            projectsWithGroupedTasks: [],
            customers: {},
            showSingleProject: false,
            showSingleCustomer: false,
            canEditTaskStatus: true,
            taskIdWithDetailsOpen: null,
            selectedTaskIds: {},
            lastCreatedTaskIds: {},
            recentlyCreatedTaskIds: {},
            draggingTaskId: null,
            draggingTaskProjectId: null,
            updatingTaskIds: {},
            minimizedCards: false,
            showSelection: false,
            showEstimate: false,
            collapsedProjectIds: {},
            ignoreProjectCollapse: false,
            manageableTaskIds: {}
        };

        _this.onStateDeeplyChanged(function (state, prevState) {
            _this._updateProjects(state, prevState);
        });
        return _this;
    }

    _createClass(KanbanContent, [{
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='kanbanContent'>" + "</div>";
        }
    }, {
        key: "_updateProjects",
        value: function _updateProjects(state, prevState) {
            var _this2 = this;

            if (!(0, _atUtils.isOrderFullyExistsAtTheBeginningOf)(prevState.projectsWithGroupedTasks, state.projectsWithGroupedTasks)) {
                this.$el.empty();
                this.projectBlocks = {};
            }

            this._projectIndexById = state.projectsWithGroupedTasks.reduce(function (map, project, index) {
                map[project.id] = index;
                return map;
            }, {});

            state.projectsWithGroupedTasks.forEach(function (project) {
                if (!_this2.projectBlocks[project.id]) {
                    _this2.projectBlocks[project.id] = new _ProjectTasksBlock2.default({
                        projectId: project.id,
                        canReopenProject: project.canReopenProject,
                        canEditTaskStatus: _this2.state.canEditTaskStatus,
                        canManageAllProjectTasks: project.canManageAllProjectTasks,
                        onHeaderClick: function onHeaderClick() {
                            return _this2.onProjectHeaderClick(project.id);
                        },
                        onSelectTaskHandler: _this2.onSelectTaskHandler,
                        onTaskClick: function onTaskClick(taskId) {
                            return _this2.onTaskClick(taskId);
                        },
                        onTaskStatusAndPositionChanged: function onTaskStatusAndPositionChanged(data) {
                            var draggingTaskId = _this2.state.draggingTaskId;
                            _this2.setStateInternal({
                                draggingTaskProjectId: null,
                                draggingTaskId: null
                            });
                            _this2.onTaskStatusAndPositionChanged(_extends({}, data, {
                                taskId: data.taskId || draggingTaskId
                            }));
                        },
                        onTaskDragStart: function onTaskDragStart(projectId, taskId) {
                            _this2.setStateInternal({
                                draggingTaskProjectId: projectId,
                                draggingTaskId: taskId
                            });
                            Object.values(_this2.projectBlocks).forEach(function (projectBlock) {
                                projectBlock.setState({
                                    canDropDraggingTask: !!_this2.state.manageableTaskIds[taskId] && projectBlock.canManageAllProjectTasks || projectId === projectBlock.projectId
                                });
                            });

                            _this2.closeAnyTaskPanel();
                        },
                        onTaskDragStop: function onTaskDragStop() {
                            _this2.setStateInternal({
                                draggingTaskProjectId: null
                            });
                        },
                        onTasksColumnDragOver: function onTasksColumnDragOver(canDrop, status) {
                            var draggingTaskProject = _this2.state.projectsWithGroupedTasks[_this2._projectIndexById[_this2.state.draggingTaskProjectId]];

                            if (!canDrop || project.id !== draggingTaskProject.id) _this2._showTooltip(project, status, draggingTaskProject, !!_this2.state.manageableTaskIds[_this2.state.draggingTaskId]);
                        },
                        onTasksColumnDragOut: function onTasksColumnDragOut() {
                            _this2.getTooltip().hide();
                        },
                        onCardActiveSelectionDisappear: _this2.onCardActiveSelectionDisappear
                    }).init(_this2.$el);
                }

                _this2.projectBlocks[project.id].setState({
                    statuses: state.statuses,
                    tasksByStatus: project.tasksByStatus,
                    collapsed: state.ignoreProjectCollapse ? false : !!state.collapsedProjectIds[project.id],
                    taskIdWithDetailsOpen: state.taskIdWithDetailsOpen,
                    selectedTaskIds: state.selectedTaskIds,
                    lastCreatedTaskIds: state.lastCreatedTaskIds,
                    recentlyCreatedTaskIds: state.recentlyCreatedTaskIds,
                    minimizedCards: state.minimizedCards,
                    updatingTaskIds: state.updatingTaskIds,
                    showSelection: state.showSelection,
                    showSingleProject: state.showSingleProject,
                    showSingleCustomer: state.showSingleCustomer,
                    showEstimate: state.showEstimate,
                    ignoreProjectCollapse: state.ignoreProjectCollapse,
                    canEditTaskStatus: _this2.state.canEditTaskStatus,
                    customerName: state.customers[project.customerId].name,
                    projectName: project.name,
                    projectArchived: project.archived,
                    customerArchived: state.customers[project.customerId].archived
                });

                if (state.draggingTaskProjectId) {
                    var draggingTaskProject = _this2.state.projectsWithGroupedTasks[_this2._projectIndexById[state.draggingTaskProjectId]];
                    _this2.projectBlocks[project.id].setState({
                        canDropDraggingTask: !!_this2.state.manageableTaskIds[_this2.state.draggingTaskId] && project.canManageAllProjectTasks || draggingTaskProject.id === project.id
                    });
                }
            });

            if (state.draggingTaskProjectId) {
                this.projectBlocks[state.draggingTaskProjectId].setState({ needRefreshSortable: true });
            }
        }
    }, {
        key: "_showTooltip",
        value: function _showTooltip(project, status, draggingTaskProject, canManageTask) {

            var text = "";
            if (draggingTaskProject.id !== project.id) {
                if (!canManageTask) {
                    text = _messageResource2.default.getMessage("task.list.kanban.cannot_move_non_manageable_task");
                } else if (!project.canManageAllProjectTasks) {
                    text = _messageResource2.default.getMessage("task.list.kanban.cannot_move_task_to_non_manageable_project");
                } else {
                    text = _messageResource2.default.getMessage("task.list.kanban.access_to_task_after_move_to_another_project");
                }
            }
            if (project.archived && status.type === _constants.WorkflowStatusType.OPEN && !project.canReopenProject) {
                if (draggingTaskProject.id === project.id) {
                    text = _messageResource2.default.getMessage("task.list.kanban.cannot_reopen_archived_current");
                } else {
                    text = _messageResource2.default.getMessage("task.list.kanban.cannot_reopen_archived");
                }
            }

            this.getTooltip().setState({ text: text });
            this.getTooltip().show();
        }
    }, {
        key: "getTooltip",
        value: function getTooltip() {
            if (!KanbanContent.tooltip) {
                KanbanContent.tooltip = new _ComponentTooltip2.default({ extraClass: "kanbanView_tooltips_projectCannotDropTooltip" }).init((0, _jquery2.default)("body"));
            }
            return KanbanContent.tooltip;
        }
    }]);

    return KanbanContent;
}(_TemplateView3.default);

exports.default = KanbanContent;

/***/ }),
/* 1830 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _TasksColumn = __webpack_require__(1831);

var _TasksColumn2 = _interopRequireDefault(_TasksColumn);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _constants = __webpack_require__(23);

var _atUtils = __webpack_require__(5);

var _utils = __webpack_require__(80);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ProjectTasksBlock = function (_TemplateView) {
    _inherits(ProjectTasksBlock, _TemplateView);

    function ProjectTasksBlock(_ref) {
        var _ref$projectId = _ref.projectId,
            projectId = _ref$projectId === undefined ? null : _ref$projectId,
            _ref$canReopenProject = _ref.canReopenProject,
            canReopenProject = _ref$canReopenProject === undefined ? false : _ref$canReopenProject,
            _ref$canManageAllProj = _ref.canManageAllProjectTasks,
            canManageAllProjectTasks = _ref$canManageAllProj === undefined ? false : _ref$canManageAllProj,
            _ref$onHeaderClick = _ref.onHeaderClick,
            onHeaderClick = _ref$onHeaderClick === undefined ? function () {} : _ref$onHeaderClick,
            _ref$onSelectTaskHand = _ref.onSelectTaskHandler,
            onSelectTaskHandler = _ref$onSelectTaskHand === undefined ? function () {} : _ref$onSelectTaskHand,
            _ref$onTaskClick = _ref.onTaskClick,
            onTaskClick = _ref$onTaskClick === undefined ? function () {} : _ref$onTaskClick,
            _ref$onTaskStatusAndP = _ref.onTaskStatusAndPositionChanged,
            onTaskStatusAndPositionChanged = _ref$onTaskStatusAndP === undefined ? function () {} : _ref$onTaskStatusAndP,
            _ref$onTaskDragStart = _ref.onTaskDragStart,
            onTaskDragStart = _ref$onTaskDragStart === undefined ? function () {} : _ref$onTaskDragStart,
            _ref$onTaskDragStop = _ref.onTaskDragStop,
            onTaskDragStop = _ref$onTaskDragStop === undefined ? function () {} : _ref$onTaskDragStop,
            _ref$onTasksColumnDra = _ref.onTasksColumnDragOver,
            onTasksColumnDragOver = _ref$onTasksColumnDra === undefined ? function () {} : _ref$onTasksColumnDra,
            _ref$onTasksColumnDra2 = _ref.onTasksColumnDragOut,
            onTasksColumnDragOut = _ref$onTasksColumnDra2 === undefined ? function () {} : _ref$onTasksColumnDra2,
            _ref$onCardActiveSele = _ref.onCardActiveSelectionDisappear,
            onCardActiveSelectionDisappear = _ref$onCardActiveSele === undefined ? function () {} : _ref$onCardActiveSele;

        _classCallCheck(this, ProjectTasksBlock);

        var _this = _possibleConstructorReturn(this, (ProjectTasksBlock.__proto__ || Object.getPrototypeOf(ProjectTasksBlock)).call(this));

        _this._updateCollapsed = function () {
            _this.getEl().toggleClass("collapsed", !_this.state.showSingleProject && _this.state.collapsed);
        };

        _this._updateNameShowing = function () {
            if (!_this.state.showSingleProject) {
                _this.$header.show();
                if (!_this.state.showSingleCustomer) {
                    _this.$customerNamePlace.show();
                } else {
                    _this.$customerNamePlace.hide();
                }
            } else {
                _this.$header.hide();
            }
        };

        _this.projectId = projectId;

        _this.canReopenProject = canReopenProject;
        _this.canManageAllProjectTasks = canManageAllProjectTasks;
        _this.taskColumnsMap = {};

        _this.callbacks = {
            onHeaderClick: onHeaderClick,
            onSelectTaskHandler: onSelectTaskHandler,
            onTaskClick: onTaskClick,
            onTaskStatusAndPositionChanged: onTaskStatusAndPositionChanged,
            onTaskDragStart: onTaskDragStart,
            onTaskDragStop: onTaskDragStop,
            onTasksColumnDragOver: onTasksColumnDragOver,
            onTasksColumnDragOut: onTasksColumnDragOut,
            onCardActiveSelectionDisappear: onCardActiveSelectionDisappear
        };

        _this.state = {
            statuses: [],
            collapsed: false,
            tasksByStatus: {},
            taskIdWithDetailsOpen: null,
            selectedTaskIds: {},
            lastCreatedTaskIds: {},
            recentlyCreatedTaskIds: {},
            draggingTaskStatusId: null,
            currentPrecedingTaskId: null,
            canDropDraggingTask: false,
            updatingTaskIds: {},
            minimizedCards: false,
            showSelection: false,
            showSingleProject: false,
            showSingleCustomer: false,
            canEditTaskStatus: true,
            showEstimate: false,
            ignoreProjectCollapse: false,

            needRefreshSortable: false,

            customerName: '',
            projectName: '',
            projectArchived: false,
            customerArchived: false
        };

        _this.onAnyStatePropertyChanged(["statuses", "tasksByStatus"], function (state, prevState) {
            if (!(0, _atUtils.isArraysWithIdsItemsOrderEqual)(state.statuses, prevState.statuses)) {
                _this.$taskColumns.empty();
                _this.taskColumnsMap = {};
            }

            _this._updateTasks();
        });

        _this.onAnyStatePropertyChanged(["showSingleCustomer", "showSingleProject"], _this._updateNameShowing);
        _this.onAnyStatePropertyChanged(["collapsed", "showSingleProject"], _this._updateCollapsed);
        _this.onAnyStatePropertyChanged(["minimizedCards", "showEstimate"], function (_ref2) {
            var minimizedCards = _ref2.minimizedCards,
                showEstimate = _ref2.showEstimate;
            return _this._updateTasksView(minimizedCards, showEstimate);
        });

        _this.onAnyStatePropertyChanged(["selectedTaskIds", "lastCreatedTaskIds"], function () {
            return _this._updateTasks();
        });
        _this.onStatePropertyChanged("taskIdWithDetailsOpen", function (taskId) {
            return _this._updateTasksIdWithDetailsOpen(taskId);
        });
        _this.onAnyStatePropertyChanged(["canDropDraggingTask", "projectArchived"], function () {
            return _this._updateTaskColumnsCanDrop();
        });
        _this.onStatePropertyChanged("updatingTaskIds", function (updatingTaskIds) {
            return _this._updateTaskColumnsUpdatingTaskIds(updatingTaskIds);
        });

        _this.onStatePropertyBecameTrue("needRefreshSortable", function (needRefreshSortable) {
            if (_this.state.draggingTaskStatusId) _this.taskColumnsMap[_this.state.draggingTaskStatusId].setState({ needRefreshSortable: needRefreshSortable });
            _this.setStateInternal({ needRefreshSortable: false });
        });

        _this.onStatePropertyChanged('ignoreProjectCollapse', function (ignoreProjectCollapse) {
            _this.$icon.toggleClass('hide', ignoreProjectCollapse);
        });

        _this.onStatePropertyChanged('projectArchived', function (projectArchived) {
            _this.$projectArchivedLabel.toggle(projectArchived);
        });

        _this.onStatePropertyChanged('customerArchived', function (customerArchived) {
            _this.$customerArchivedLabel.toggle(customerArchived);
        });

        _this.onStatePropertyChanged('customerName', function (customerName) {
            _this.$customerName.text(customerName);
        });

        _this.onStatePropertyChanged('projectName', function (projectName) {
            _this.$projectName.text(projectName);
        });
        return _this;
    }

    _createClass(ProjectTasksBlock, [{
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='projectTasksBlock'>" + "  <div class='header'>" + "    <div class='icon'></div>" + "    <div class='customerNamePlace'>" + "        <span class='customerName'></span>" + "        <span class='customerArchivedLabel'><%=archivedLabel%></span>" + "        <span class='separator'></span>" + "    </div>" + "    <div class='projectName'></div>" + "    <div class='projectArchivedLabel'><%=archivedLabel%></div>" + "    <div class='line'></div>" + "  </div>" + "  <div class='taskColumns'></div>" + "</div>";
        }
    }, {
        key: "messageKeys",
        value: function messageKeys() {
            return {
                archivedLabel: "common.archived"
            };
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            var _this2 = this;

            this.$header = this.find(".header");
            this.$icon = this.find('.icon');
            this.$header.click(function () {
                return _this2.callbacks.onHeaderClick();
            });
            this.$customerNamePlace = this.find('.customerNamePlace');
            this.$taskColumns = this.find(".taskColumns");
            this.$projectArchivedLabel = this.find('.projectArchivedLabel');
            this.$customerArchivedLabel = this.find('.customerArchivedLabel');
            this.$customerName = this.find('.customerName');
            this.$projectName = this.find('.projectName');
        }
    }, {
        key: "_updateTasks",
        value: function _updateTasks() {
            var _this3 = this;

            this.state.statuses.forEach(function (status) {
                if (!_this3.taskColumnsMap[status.id]) {
                    _this3.taskColumnsMap[status.id] = new _TasksColumn2.default({
                        colorId: status.colorId,
                        props: {
                            projectId: _this3.projectId,
                            workflowStatus: status,
                            emptyColumnText: _messageResource2.default.getMessage("task.list.kanban.no_tasks_with_status"),
                            canDrop: (!_this3.state.projectArchived || status.type === _constants.WorkflowStatusType.COMPLETED || _this3.canReopenProject) && _this3.state.canEditTaskStatus
                        },
                        onTaskClick: function onTaskClick(taskId) {
                            return _this3.callbacks.onTaskClick(taskId);
                        },
                        onTaskSelectChanged: _this3.callbacks.onSelectTaskHandler,
                        onTaskDragStart: function onTaskDragStart(_ref3) {
                            var id = _ref3.id,
                                currentPrecedingId = _ref3.currentPrecedingId;

                            _this3.setStateInternal({
                                draggingTaskStatusId: status.id,
                                currentPrecedingTaskId: currentPrecedingId
                            });
                            _this3.callbacks.onTaskDragStart(_this3.projectId, id);
                        },
                        onTaskDragStop: function onTaskDragStop() {
                            _this3.setStateInternal({
                                draggingTaskStatusId: null,
                                currentPrecedingTaskId: null
                            });
                            _this3.callbacks.onTaskDragStop();
                        },
                        onTaskDragOver: _this3.callbacks.onTasksColumnDragOver,
                        onTaskDragOut: function onTaskDragOut() {
                            _this3.callbacks.onTasksColumnDragOut();
                        },
                        onTaskAdded: function onTaskAdded(_ref4) {
                            var workflowStatusId = _ref4.workflowStatusId,
                                precedingTaskId = _ref4.precedingTaskId;

                            _this3.callbacks.onTaskStatusAndPositionChanged({
                                projectId: _this3.projectId,
                                workflowStatusId: workflowStatusId,
                                precedingTaskId: precedingTaskId,
                                currentPrecedingTaskId: _this3.state.currentPrecedingTaskId
                            });
                        },
                        onTaskPositionChanged: function onTaskPositionChanged(_ref5) {
                            var taskId = _ref5.taskId,
                                precedingTaskId = _ref5.precedingTaskId,
                                workflowStatusId = _ref5.workflowStatusId,
                                currentPrecedingTaskId = _ref5.currentPrecedingTaskId;

                            _this3.callbacks.onTaskStatusAndPositionChanged({
                                taskId: taskId,
                                projectId: _this3.projectId,
                                workflowStatusId: workflowStatusId,
                                precedingTaskId: precedingTaskId,
                                currentPrecedingTaskId: _this3.state.currentPrecedingTaskId || currentPrecedingTaskId
                            });
                        },
                        onCardActiveSelectionDisappear: _this3.callbacks.onCardActiveSelectionDisappear
                    }).init(_this3.$taskColumns);
                }

                var tasks = _this3.state.tasksByStatus[status.id] || [];

                _this3.taskColumnsMap[status.id].setState({
                    tasks: tasks,
                    selectedTaskIds: _this3.state.selectedTaskIds,
                    taskIdWithDetailsOpen: _this3.state.taskIdWithDetailsOpen,
                    lastCreatedTaskIds: _this3.state.lastCreatedTaskIds,
                    recentlyCreatedTaskIds: _this3.state.recentlyCreatedTaskIds,
                    minimizedCards: _this3.state.minimizedCards,
                    showSelection: _this3.state.showSelection,
                    showEstimate: _this3.state.showEstimate,
                    canDrop: _this3.state.canDropDraggingTask && _this3.state.canEditTaskStatus && (!_this3.state.projectArchived || status.type === _constants.WorkflowStatusType.COMPLETED || _this3.canReopenProject)
                });
            });

            var openStatusClass = (0, _utils.getStatusClassByType)(_constants.WorkflowStatusType.OPEN);
            var lastOpenStatusColumn = this.$taskColumns.find('.' + openStatusClass).last();
            lastOpenStatusColumn.addClass("lastOpen");
        }
    }, {
        key: "_updateTasksIdWithDetailsOpen",
        value: function _updateTasksIdWithDetailsOpen(taskId) {
            Object.values(this.taskColumnsMap).forEach(function (taskColumn) {
                return taskColumn.setState({
                    taskIdWithDetailsOpen: taskId
                });
            });
        }
    }, {
        key: "_updateTasksView",
        value: function _updateTasksView(minimizedCards, showEstimate) {
            var _this4 = this;

            this.state.statuses.forEach(function (status) {
                _this4.taskColumnsMap[status.id].setState({
                    minimizedCards: minimizedCards,
                    showEstimate: showEstimate
                });
            });
        }
    }, {
        key: "_updateTaskColumnsCanDrop",
        value: function _updateTaskColumnsCanDrop() {
            var _this5 = this;

            Object.values(this.taskColumnsMap).forEach(function (taskColumn) {
                taskColumn.setState({
                    canDrop: _this5.state.canDropDraggingTask && _this5.state.canEditTaskStatus && (!_this5.state.projectArchived || taskColumn.props.workflowStatus.type === _constants.WorkflowStatusType.COMPLETED || _this5.canReopenProject)
                });
            });
        }
    }, {
        key: "_updateTaskColumnsUpdatingTaskIds",
        value: function _updateTaskColumnsUpdatingTaskIds(updatingTaskIds) {
            Object.values(this.taskColumnsMap).forEach(function (taskColumn) {
                taskColumn.setState({ updatingTaskIds: updatingTaskIds });
            });
        }
    }]);

    return ProjectTasksBlock;
}(_TemplateView3.default);

exports.default = ProjectTasksBlock;

/***/ }),
/* 1831 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _TaskCard = __webpack_require__(1832);

var _TaskCard2 = _interopRequireDefault(_TaskCard);

var _SortableListContainer = __webpack_require__(914);

var _SortableListContainer2 = _interopRequireDefault(_SortableListContainer);

var _utils = __webpack_require__(80);

var _atUtils = __webpack_require__(5);

var _constants = __webpack_require__(23);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TasksColumn = function (_TemplateView) {
    _inherits(TasksColumn, _TemplateView);

    function TasksColumn(_ref) {
        var _ref$props = _ref.props,
            props = _ref$props === undefined ? {
            projectId: null,
            workflowStatus: null,
            emptyColumnText: "",
            canDrop: true
        } : _ref$props,
            _ref$onTaskDragging = _ref.onTaskDragging,
            onTaskDragging = _ref$onTaskDragging === undefined ? function () {} : _ref$onTaskDragging,
            _ref$onTaskDragStart = _ref.onTaskDragStart,
            onTaskDragStart = _ref$onTaskDragStart === undefined ? function () {} : _ref$onTaskDragStart,
            _ref$onTaskDragStop = _ref.onTaskDragStop,
            onTaskDragStop = _ref$onTaskDragStop === undefined ? function () {} : _ref$onTaskDragStop,
            _ref$onTaskDragOver = _ref.onTaskDragOver,
            onTaskDragOver = _ref$onTaskDragOver === undefined ? function () {} : _ref$onTaskDragOver,
            _ref$onTaskDragOut = _ref.onTaskDragOut,
            onTaskDragOut = _ref$onTaskDragOut === undefined ? function () {} : _ref$onTaskDragOut,
            _ref$onTaskPositionCh = _ref.onTaskPositionChanged,
            onTaskPositionChanged = _ref$onTaskPositionCh === undefined ? function () {} : _ref$onTaskPositionCh,
            _ref$onTaskAdded = _ref.onTaskAdded,
            onTaskAdded = _ref$onTaskAdded === undefined ? function () {} : _ref$onTaskAdded,
            _ref$onTaskRemoved = _ref.onTaskRemoved,
            onTaskRemoved = _ref$onTaskRemoved === undefined ? function () {} : _ref$onTaskRemoved,
            _ref$onTaskClick = _ref.onTaskClick,
            onTaskClick = _ref$onTaskClick === undefined ? function (taskId) {} : _ref$onTaskClick,
            _ref$onTaskSelectChan = _ref.onTaskSelectChanged,
            onTaskSelectChanged = _ref$onTaskSelectChan === undefined ? function () {} : _ref$onTaskSelectChan,
            _ref$onCardActiveSele = _ref.onCardActiveSelectionDisappear,
            onCardActiveSelectionDisappear = _ref$onCardActiveSele === undefined ? function () {} : _ref$onCardActiveSele;

        _classCallCheck(this, TasksColumn);

        var _this = _possibleConstructorReturn(this, (TasksColumn.__proto__ || Object.getPrototypeOf(TasksColumn)).call(this));

        _this.state = {
            tasks: [],
            minimizedCards: false,
            selectedTaskIds: {},
            taskIdWithDetailsOpen: null,
            lastCreatedTaskIds: {},
            recentlyCreatedTaskIds: {},
            canDrop: false,
            updatingTaskIds: {},
            showSelection: false,
            showEstimate: false,

            needRefreshSortable: false
        };

        _this.props = props;

        _this.nodes = {};

        _this.callbacks = {
            onTaskDragging: onTaskDragging,
            onTaskDragStart: onTaskDragStart,
            onTaskDragStop: onTaskDragStop,
            onTaskDragOver: onTaskDragOver,
            onTaskDragOut: onTaskDragOut,
            onTaskPositionChanged: onTaskPositionChanged,
            onTaskAdded: onTaskAdded,
            onTaskRemoved: onTaskRemoved,
            onTaskClick: onTaskClick,
            onTaskSelectChanged: onTaskSelectChanged,
            onCardActiveSelectionDisappear: onCardActiveSelectionDisappear
        };

        _this.onStatePropertyChanged('tasks', function (tasks, prevStateTasks) {
            _this.getEl().toggleClass("empty", tasks.length === 0);
            if (!(0, _atUtils.isArraysWithIdsItemsOrderEqual)(tasks, prevStateTasks)) {
                _this.sortableTaskCardList.setState({ items: tasks });
            } else {
                _this._updateTaskCards(tasks);
            }
        });

        _this.onStatePropertyChanged('canDrop', function (canDrop) {
            _this.sortableTaskCardList.setState({
                canDrop: canDrop,
                previousCanDrop: canDrop
            });
        });
        _this.onAnyStatePropertyChanged(['selectedTaskIds', 'taskIdWithDetailsOpen', 'recentlyCreatedTaskIds', 'updatingTaskIds', 'showSelection', 'showEstimate', 'lastCreatedTaskIds'], function () {
            return _this._updateTaskCards();
        });

        _this.onStatePropertyChanged('minimizedCards', function (minimizedCards) {
            _this._updateTaskCards();
            _this.sortableTaskCardList.setState({
                additionalPlaceholderClass: minimizedCards ? 'minimized' : ''
            });
        });

        _this.onStatePropertyBecameTrue("needRefreshSortable", function (needRefreshSortable) {
            _this.sortableTaskCardList.setState({ needRefreshSortable: needRefreshSortable });
            _this.setStateInternal({ needRefreshSortable: false });
        });
        return _this;
    }

    _createClass(TasksColumn, [{
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='tasksColumn <%=colorClass%>'></div>";
        }
    }, {
        key: "templateModel",
        value: function templateModel() {
            var colorClass = (0, _utils.getColorClassById)(this.props.workflowStatus.colorId);
            if (this.props.workflowStatus.type === _constants.WorkflowStatusType.OPEN) {
                colorClass += " " + (0, _utils.getStatusClassByType)(_constants.WorkflowStatusType.OPEN);
            } else if (this.props.workflowStatus.type === _constants.WorkflowStatusType.COMPLETED) {
                colorClass += " " + (0, _utils.getStatusClassByType)(_constants.WorkflowStatusType.COMPLETED);
            }
            return {
                colorClass: colorClass,
                emptyColumnText: this.props.emptyColumnText
            };
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            var _this2 = this;

            var taskCardRenderer = function taskCardRenderer(task) {
                var taskActualPosition = _this2._getTaskPositionIndex(task);
                var moveTaskTo = function moveTaskTo(precedingTaskId) {
                    return function () {
                        _this2.callbacks.onTaskPositionChanged({
                            taskId: task.id,
                            precedingTaskId: precedingTaskId,
                            currentPrecedingTaskId: taskActualPosition === 0 ? null : _this2.state.tasks[taskActualPosition - 1].id,
                            workflowStatusId: _this2.props.workflowStatus.id
                        });
                    };
                };

                var node = new _TaskCard2.default({
                    onClick: function onClick() {
                        return _this2.callbacks.onTaskClick(task.id);
                    },
                    onChangeSelect: function onChangeSelect(selected) {
                        _this2.callbacks.onTaskSelectChanged(task.id, selected);
                    },
                    onCardActiveSelectionDisappear: function onCardActiveSelectionDisappear() {
                        return _this2.callbacks.onCardActiveSelectionDisappear(task.id);
                    },
                    onMoveToTopClick: moveTaskTo(null),
                    onMoveToBottomClick: moveTaskTo(_this2.state.tasks[_this2.state.tasks.length - 1].id)
                });

                _this2.nodes[task.id] = node;
                _this2._setTaskCardState(task);
                return node;
            };

            this.sortableTaskCardList = new _SortableListContainer2.default({
                itemRenderer: taskCardRenderer,
                placeholderText: this.props.workflowStatus.name,
                sortableConfig: {
                    tolerance: 'intersect',
                    cloneItem: true,
                    connectWithClass: 'tasksColumn'
                },
                onItemDragStart: this.callbacks.onTaskDragStart,
                onItemDragStop: this.callbacks.onTaskDragStop,
                onPositionChangedCb: function onPositionChangedCb(_ref2) {
                    var id = _ref2.id,
                        precedingId = _ref2.precedingId;

                    _this2.callbacks.onTaskPositionChanged({
                        workflowStatusId: _this2.props.workflowStatus.id,
                        taskId: id,
                        precedingTaskId: precedingId
                    });
                },
                onItemReceiveCb: function onItemReceiveCb(_ref3) {
                    var itemIndex = _ref3.itemIndex;

                    var lastIndex = _this2.state.tasks.length - 1;
                    var precedingTaskId = itemIndex === 0 || lastIndex === -1 ? null : itemIndex > lastIndex ? _this2.state.tasks[lastIndex].id : _this2.state.tasks[itemIndex - 1].id;
                    _this2.callbacks.onTaskAdded({
                        workflowStatusId: _this2.props.workflowStatus.id,
                        precedingTaskId: precedingTaskId
                    });
                },
                onItemRemoveCb: this.callbacks.onTaskRemoved,
                onDragOver: function onDragOver() {
                    _this2.callbacks.onTaskDragOver(_this2.state.canDrop, _this2.props.workflowStatus);
                },
                onDragOut: function onDragOut() {
                    _this2.callbacks.onTaskDragOut();
                },
                onItemDragging: this.callbacks.onTaskDragging
            }).init(this.getEl());
        }
    }, {
        key: "_updateTaskCards",
        value: function _updateTaskCards() {
            var _this3 = this;

            this.getEl().toggleClass('minimized', this.state.minimizedCards);
            this.state.tasks.forEach(function (task) {
                _this3._setTaskCardState(task);
            });
        }
    }, {
        key: "_setTaskCardState",
        value: function _setTaskCardState(task) {
            var taskActualPosition = this._getTaskPositionIndex(task);
            var isDisabled = this.state.updatingTaskIds[task.id] === true;

            this.nodes[task.id].setState({
                name: task.name,
                highlightedName: task.highlightedName,
                spentTime: task.spentTime,
                estimatedTime: task.estimatedTime,
                commentsNumber: task.commentsNumber,
                colorId: this.props.workflowStatus.colorId,
                disabled: isDisabled,
                selected: !!this.state.selectedTaskIds[task.id],
                minimized: this.state.minimizedCards,
                detailsOpen: this.state.taskIdWithDetailsOpen === task.id,
                isLastCreatedTask: !!this.state.lastCreatedTaskIds[task.id],
                recentlyCreated: !!this.state.recentlyCreatedTaskIds[task.id],
                selectable: this.state.showSelection,
                showEstimate: this.state.showEstimate,
                showMoveToTopBtn: !isDisabled && taskActualPosition !== 0,
                showMoveToBottomBtn: !isDisabled && taskActualPosition !== this.state.tasks.length - 1
            });
        }
    }, {
        key: "_getTaskPositionIndex",
        value: function _getTaskPositionIndex(task) {
            var taskActualPosition = this.state.tasks.findIndex(function (t) {
                return t.id === task.id;
            });
            if (taskActualPosition === -1) throw Error('Kanban -- Task is not present in the list');
            return taskActualPosition;
        }
    }]);

    return TasksColumn;
}(_TemplateView3.default);

exports.default = TasksColumn;

/***/ }),
/* 1832 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _user_time = __webpack_require__(30);

var _user_time2 = _interopRequireDefault(_user_time);

var _utils = __webpack_require__(80);

var _CustomCheckbox = __webpack_require__(83);

var _CustomCheckbox2 = _interopRequireDefault(_CustomCheckbox);

var _TaskCardName = __webpack_require__(1833);

var _TaskCardName2 = _interopRequireDefault(_TaskCardName);

var _atUtils = __webpack_require__(5);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _CommentsNumberContainer = __webpack_require__(251);

var _CommentsNumberContainer2 = _interopRequireDefault(_CommentsNumberContainer);

var _keyHandlers = __webpack_require__(48);

var _utils2 = __webpack_require__(25);

var _SimpleTooltip = __webpack_require__(36);

var _SimpleTooltip2 = _interopRequireDefault(_SimpleTooltip);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TaskCard = function (_TemplateView) {
    _inherits(TaskCard, _TemplateView);

    function TaskCard(_ref) {
        var _ref$onClick = _ref.onClick,
            onClick = _ref$onClick === undefined ? function () {} : _ref$onClick,
            _ref$onChangeSelect = _ref.onChangeSelect,
            onChangeSelect = _ref$onChangeSelect === undefined ? function () {} : _ref$onChangeSelect,
            _ref$onCardActiveSele = _ref.onCardActiveSelectionDisappear,
            onCardActiveSelectionDisappear = _ref$onCardActiveSele === undefined ? function () {} : _ref$onCardActiveSele,
            _ref$onMoveToTopClick = _ref.onMoveToTopClick,
            onMoveToTopClick = _ref$onMoveToTopClick === undefined ? function () {} : _ref$onMoveToTopClick,
            _ref$onMoveToBottomCl = _ref.onMoveToBottomClick,
            onMoveToBottomClick = _ref$onMoveToBottomCl === undefined ? function () {} : _ref$onMoveToBottomCl;

        _classCallCheck(this, TaskCard);

        var _this = _possibleConstructorReturn(this, (TaskCard.__proto__ || Object.getPrototypeOf(TaskCard)).call(this));

        _this.state = {
            name: "",
            highlightedName: "",
            spentTime: 0,
            estimatedTime: 0,
            commentsNumber: 0,
            colorId: 0,
            disabled: false,
            selected: false,
            selectionDisabled: false,
            detailsOpen: false,
            isLastCreatedTask: false,
            recentlyCreated: false,
            minimized: false,
            selectable: false,
            showEstimate: false,
            showMoveToTopBtn: false,
            showMoveToBottomBtn: false
        };

        _this.onClick = onClick;
        _this.onChangeSelect = onChangeSelect;
        _this.onCardActiveSelectionDisappear = onCardActiveSelectionDisappear;
        _this.onMoveToTopClick = onMoveToTopClick;
        _this.onMoveToBottomClick = onMoveToBottomClick;

        _this.onAnyStatePropertyChanged(['name', 'highlightedName'], function () {
            return _this._updateName();
        });
        _this.onStatePropertyChanged('spentTime', function (spentTime) {
            return _this._updateSpentTime(spentTime);
        });
        _this.onStatePropertyChanged('estimatedTime', function (estimatedTime) {
            return _this._updateEstimatedTime(estimatedTime);
        });
        _this.onStatePropertyChanged('colorId', function (colorId, prevColorId) {
            return _this._updateColor(colorId, prevColorId);
        });
        _this.onStatePropertyChanged('detailsOpen', function (detailsOpen) {
            return _this._updateDetailsOpen(detailsOpen);
        });
        _this.onStatePropertyBecameTrue('isLastCreatedTask', function () {
            return _this._updateLastCreated();
        });
        _this.onStatePropertyChanged('recentlyCreated', function (recentlyCreated) {
            return _this._updateRecentlyCreated(recentlyCreated);
        });
        _this.onStatePropertyChanged('minimized', function (minimized) {
            return _this._updateMinimized(minimized);
        });
        _this.onStatePropertyChanged('disabled', function (disabled) {
            return _this._updateDisabled(disabled);
        });
        _this.onAnyStatePropertyChanged(['editable', 'selected', 'selectionDisabled', 'selectable'], function () {
            return _this._updateCheckbox();
        });
        _this.onStatePropertyChanged('commentsNumber', function (commentsN) {
            return _this._updateCommentsNumber(commentsN);
        });
        _this.onStatePropertyChanged('showEstimate', function (showEstimate) {
            return _this.$estimatedTime.toggle(showEstimate);
        });
        _this.onStatePropertyChanged('selectable', function (selectable) {
            return _this.getEl().toggleClass('cardWithCheckbox', selectable);
        });
        _this.onStatePropertyChanged('showMoveToTopBtn', function (showMoveToTopBtn) {
            return _this.$btnUp.toggleClass('hidden', !showMoveToTopBtn);
        });
        _this.onStatePropertyChanged('showMoveToBottomBtn', function (showMoveToBottomBtn) {
            return _this.$btnDown.toggleClass('hidden', !showMoveToBottomBtn);
        });
        return _this;
    }

    _createClass(TaskCard, [{
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='kanbanView_components_taskCard'>" + "  <div class='content'></div>" + "  <div class='footer'>" + "    <div class='time'>" + "      <div class='trackedTime'></div>" + "      <div class='estimatedTime'></div>" + "    </div>" + "    <div class='commentsNumberPlaceholder'></div>" + "  </div>" + "  <div class='buttons'>" + "    <span class='buttonUp' tooltipText='<%=buttonUpTooltip%>'></span>" + "    <span class='spacer'></span>" + "    <span class='buttonDown' tooltipText='<%=buttonDownTooltip%>'></span>" + "  </div>" + "</div>";
        }
    }, {
        key: "messageKeys",
        value: function messageKeys() {
            return {
                buttonUpTooltip: 'task.list.kanban.task_card.button_up_tooltip',
                buttonDownTooltip: 'task.list.kanban.task_card.button_down_tooltip'
            };
        }
    }, {
        key: "templateModel",
        value: function templateModel() {
            return {
                showMoveToTopBtn: this.state.showMoveToTopBtn,
                showMoveToBottomBtn: this.state.showMoveToBottomBtn
            };
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            var _this2 = this;

            var $content = this.find('.content');
            this.checkbox = new _CustomCheckbox2.default({
                containerAdditionalClass: 'checkboxContainer',
                tabindex: -1,
                onChange: function onChange(_ref2) {
                    var checked = _ref2.checked;

                    if (!_this2.state.disabled) {
                        _this2.onChangeSelect(checked);
                    }
                }
            }).init($content);
            this.taskCardName = new _TaskCardName2.default().init($content);

            this.$trackedTime = this.find('.trackedTime');
            this.$estimatedTime = this.find('.estimatedTime');

            this.$el.click(function (e) {
                (0, _utils2.setEventPreventHidingEditTaskSlidingPanel)(e);
                if (!_this2.state.disabled) {
                    // for comfortable selection of cards
                    if (_this2.state.selectable && ((0, _keyHandlers.isCtrlPressed)(e) || (0, _keyHandlers.isMetaPressed)(e))) {
                        _this2.onChangeSelect(!_this2.state.selected);
                    } else {
                        _this2.onClick();
                    }
                }
            });

            this.commentsNumber = new _CommentsNumberContainer2.default().init(this.find('.commentsNumberPlaceholder'));

            this.$btnUp = this.find('.buttonUp');
            this.$btnDown = this.find('.buttonDown');

            var tooltip = this._getTaskCardTooltip();
            tooltip.subscribeToMouseEvents(this.$btnUp);
            tooltip.subscribeToMouseEvents(this.$btnDown);

            this.$btnUp.click(this.onMoveToTopClick).mouseenter(function () {
                return tooltip.setText(_this2.$btnUp.attr('tooltipText'));
            });
            this.$btnDown.click(this.onMoveToBottomClick).mouseenter(function () {
                return tooltip.setText(_this2.$btnDown.attr('tooltipText'));
            });

            this.renderInitialState();
        }
    }, {
        key: "_updateName",
        value: function _updateName() {
            this.taskCardName.setState({
                html: this.state.highlightedName || (0, _atUtils.escapeHtmlSymbols)(this.state.name)
            });
        }
    }, {
        key: "_updateSpentTime",
        value: function _updateSpentTime(spentTime) {
            this.$trackedTime.text(_user_time2.default.formatTimeWithDigitSeparator(spentTime));
        }
    }, {
        key: "_updateEstimatedTime",
        value: function _updateEstimatedTime(estimatedTime) {
            var text = '';
            if (estimatedTime > 0) {
                text = _messageResource2.default.getEscapedMessage('task.list.kanban.task_card.estimated_time', [_user_time2.default.formatTimeWithDigitSeparator(estimatedTime)]);
            }
            this.$estimatedTime.text(text);
        }
    }, {
        key: "_updateColor",
        value: function _updateColor(colorId, prevColorId) {
            if (prevColorId) {
                this.$el.removeClass((0, _utils.getColorClassById)(prevColorId));
            }
            this.$el.addClass((0, _utils.getColorClassById)(colorId));
        }
    }, {
        key: "_updateDetailsOpen",
        value: function _updateDetailsOpen(detailsOpen) {
            this.$el.toggleClass('activeCard', detailsOpen);
        }
    }, {
        key: "_updateLastCreated",
        value: function _updateLastCreated() {
            var _this3 = this;

            this.$el.addClass('lastCreated');
            this.$el.atAnimation().showAnimated('anim-border-hide', function () {
                _this3.$el.removeClass('lastCreated');
                _this3.onCardActiveSelectionDisappear();
            });
        }
    }, {
        key: "_updateRecentlyCreated",
        value: function _updateRecentlyCreated(recentlyCreated) {
            this.$el.toggleClass('recentlyCreated', recentlyCreated);
        }
    }, {
        key: "_updateMinimized",
        value: function _updateMinimized(minimized) {
            this.$el.toggleClass('minimized', minimized);
        }
    }, {
        key: "_updateDisabled",
        value: function _updateDisabled(disabled) {
            this.$el.toggleClass('disabled', disabled);
            this._updateCheckbox();
        }
    }, {
        key: "_updateCheckbox",
        value: function _updateCheckbox() {
            this.$el.toggleClass('selectedCard', this.state.selected);
            this.checkbox.toggle(this.state.selectable);
            this.checkbox.setState({
                checked: this.state.selected,
                disabled: this.state.selectionDisabled || this.state.disabled
            });
        }
    }, {
        key: "_updateCommentsNumber",
        value: function _updateCommentsNumber(number) {
            this.commentsNumber.setState({
                commentsNumber: number
            });
        }

        /*
         * All task cards on the page use the same tooltip element
         */

    }, {
        key: "_getTaskCardTooltip",
        value: function _getTaskCardTooltip() {
            if (!TaskCard.tooltip) {
                TaskCard.tooltip = new _SimpleTooltip2.default().init((0, _jquery2.default)('body'));
            }
            return TaskCard.tooltip;
        }
    }]);

    return TaskCard;
}(_TemplateView3.default);

exports.default = TaskCard;

/***/ }),
/* 1833 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TaskCardName = function (_TemplateView) {
    _inherits(TaskCardName, _TemplateView);

    function TaskCardName() {
        _classCallCheck(this, TaskCardName);

        var _this = _possibleConstructorReturn(this, (TaskCardName.__proto__ || Object.getPrototypeOf(TaskCardName)).call(this));

        _this.state = {
            html: ''
        };

        _this.onStatePropertyChanged('html', function (html) {
            return _this.$el.html(html);
        });
        return _this;
    }

    _createClass(TaskCardName, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return "<div class='name gradientEllipsis'></div>";
        }
    }]);

    return TaskCardName;
}(_TemplateView3.default);

exports.default = TaskCardName;

/***/ }),
/* 1834 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _Tooltip2 = __webpack_require__(183);

var _Tooltip3 = _interopRequireDefault(_Tooltip2);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ComponentTooltip = function (_Tooltip) {
    _inherits(ComponentTooltip, _Tooltip);

    function ComponentTooltip(_ref) {
        var extraClass = _ref.extraClass;

        _classCallCheck(this, ComponentTooltip);

        var _this = _possibleConstructorReturn(this, (ComponentTooltip.__proto__ || Object.getPrototypeOf(ComponentTooltip)).call(this, null));

        _this.extraClass = extraClass;
        _this._disabled = false;
        _this._visible = true;

        _this.state = {
            text: ""
        };

        _this.onStatePropertyChanged('text', function (text) {
            return _this.$el.text(text);
        });
        return _this;
    }

    _createClass(ComponentTooltip, [{
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='simpleTooltip'/>";
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            _get(ComponentTooltip.prototype.__proto__ || Object.getPrototypeOf(ComponentTooltip.prototype), "afterRender", this).call(this);
            if (this.extraClass) this.$el.addClass(this.extraClass);
        }
    }, {
        key: "show",
        value: function show() {
            (0, _jquery2.default)('body').on('mousemove', this.bind(this.moveAfterCursor));
            this.$el.css("visibility", "visible");
        }
    }, {
        key: "hide",
        value: function hide() {
            (0, _jquery2.default)('body').off('mousemove');
            this.$el.css("visibility", "hidden");
        }
    }]);

    return ComponentTooltip;
}(_Tooltip3.default);

exports.default = ComponentTooltip;

/***/ }),
/* 1835 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.LocalSettingsUpdater = undefined;

var _View2 = __webpack_require__(20);

var _View3 = _interopRequireDefault(_View2);

var _utils = __webpack_require__(6);

var _selectors = __webpack_require__(243);

var _utils2 = __webpack_require__(365);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LocalSettingsUpdater = exports.LocalSettingsUpdater = function (_View) {
    _inherits(LocalSettingsUpdater, _View);

    function LocalSettingsUpdater() {
        _classCallCheck(this, LocalSettingsUpdater);

        var _this = _possibleConstructorReturn(this, (LocalSettingsUpdater.__proto__ || Object.getPrototypeOf(LocalSettingsUpdater)).call(this));

        _this.state = {
            collapsedProjects: {}
        };

        _this.onStatePropertyDeeplyChanged('collapsedProjects', function (collapsedProjects) {
            if (collapsedProjects) (0, _utils2.storeCollapsedProjectsState)(collapsedProjects);
        });
        return _this;
    }

    return LocalSettingsUpdater;
}(_View3.default);

exports.default = (0, _utils.connect)(function (state) {
    return {
        collapsedProjects: (0, _selectors.getCollapsedProjects)(state)
    };
})(LocalSettingsUpdater);

/***/ }),
/* 1836 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _EditButton = __webpack_require__(573);

var _EditButton2 = _interopRequireDefault(_EditButton);

var _ViewModeSelector = __webpack_require__(1837);

var _ViewModeSelector2 = _interopRequireDefault(_ViewModeSelector);

var _utils = __webpack_require__(25);

var _utils2 = __webpack_require__(6);

var _redux = __webpack_require__(7);

var _selectors = __webpack_require__(27);

var _ScopeFilter = __webpack_require__(1838);

var _ScopeFilter2 = _interopRequireDefault(_ScopeFilter);

var _FiltersPanel = __webpack_require__(1839);

var _FiltersPanel2 = _interopRequireDefault(_FiltersPanel);

var _actions = __webpack_require__(55);

var _selectors2 = __webpack_require__(1840);

var _actions2 = __webpack_require__(575);

var _Button = __webpack_require__(33);

var _Button2 = _interopRequireDefault(_Button);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _TaskListExportPanel = __webpack_require__(1842);

var _TaskListExportPanel2 = _interopRequireDefault(_TaskListExportPanel);

var _ConfiguratorPanelContainer = __webpack_require__(1847);

var _ConfiguratorPanelContainer2 = _interopRequireDefault(_ConfiguratorPanelContainer);

var _actions3 = __webpack_require__(364);

var _selectors3 = __webpack_require__(243);

var _selectors4 = __webpack_require__(106);

var _selectors5 = __webpack_require__(15);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// TODO: Make this view better. Replace event triggers with callbacks, introduce state.

var HeaderPanel = function (_TemplateView) {
    _inherits(HeaderPanel, _TemplateView);

    function HeaderPanel(_ref) {
        var _ref$setShowOnlyManag = _ref.setShowOnlyManageableTasks,
            setShowOnlyManageableTasks = _ref$setShowOnlyManag === undefined ? function () {} : _ref$setShowOnlyManag,
            _ref$switchViewMode = _ref.switchViewMode,
            switchViewMode = _ref$switchViewMode === undefined ? function () {} : _ref$switchViewMode,
            _ref$openCreateTaskPa = _ref.openCreateTaskPanel,
            openCreateTaskPanel = _ref$openCreateTaskPa === undefined ? function () {} : _ref$openCreateTaskPa,
            _ref$onAllSelectedCha = _ref.onAllSelectedChanged,
            onAllSelectedChanged = _ref$onAllSelectedCha === undefined ? function (allSelected) {} : _ref$onAllSelectedCha,
            _ref$onMinimizedCards = _ref.onMinimizedCardsChanged,
            onMinimizedCardsChanged = _ref$onMinimizedCards === undefined ? function (minimizedCards) {} : _ref$onMinimizedCards,
            _ref$onCollapseAllCha = _ref.onCollapseAllChanged,
            onCollapseAllChanged = _ref$onCollapseAllCha === undefined ? function (isAllCollapsed) {} : _ref$onCollapseAllCha;

        _classCallCheck(this, HeaderPanel);

        var _this = _possibleConstructorReturn(this, (HeaderPanel.__proto__ || Object.getPrototypeOf(HeaderPanel)).call(this));

        _this.actions = {
            setShowOnlyManageableTasks: setShowOnlyManageableTasks,
            switchViewMode: switchViewMode,
            openCreateTaskPanel: openCreateTaskPanel
        };

        _this.callbacks = {
            onAllSelectedChanged: onAllSelectedChanged,
            onMinimizedCardsChanged: onMinimizedCardsChanged,
            onCollapseAllChanged: onCollapseAllChanged
        };

        _this.state = {
            canManageSelectedProject: false,
            isSelectedProjectArchived: false,
            isPossibleToAddTasks: false,
            hasManageableTasks: false,
            needToShowScopeFilter: false,
            showOnlyManageableTasks: false,
            viewMode: null,
            singleCPSelection: {},
            headerTitle: '',
            showArchivedLabel: false,
            showViewModeSelector: false,
            allTasksSelected: false,
            collapsedProjects: {
                all: false,
                idsSet: {}
            },
            minimizedCards: false,
            showSelection: false,
            ignoreProjectCollapse: false,
            isTWSEnabled: false
        };

        _this.onStatePropertyChanged('ignoreProjectCollapse', function (ignoreProjectCollapse) {
            return _this.configuratorContainer.setState({ ignoreProjectCollapse: ignoreProjectCollapse });
        });
        _this.onStatePropertyChanged('isTWSEnabled', function (isTWSEnabled) {
            return _this.configuratorContainer.setState({ isTWSEnabled: isTWSEnabled });
        });

        _this.onStatePropertyChanged('showOnlyManageableTasks', function (showOnlyManageableTasks) {
            return _this.scopeFilter.setState({ showOnlyManageableTasks: showOnlyManageableTasks });
        });
        _this.onStatePropertyChanged('showViewModeSelector', function (show) {
            _this.viewModeSelector.toggle(show);
        });
        _this.onStatePropertyChanged('viewMode', function (viewMode) {
            return _this.viewModeSelector.setState({ viewMode: viewMode });
        });
        _this.onAnyStatePropertyChanged(['singleCPSelection', 'headerTitle'], function () {
            return _this.updateNavigation();
        });
        _this.onStatePropertyChanged('showArchivedLabel', function (show) {
            return _this.$archivedLabel.toggleClass('invisible', !show);
        });

        _this.onAnyStatePropertyChanged(['canManageSelectedProject', 'singleCPSelection', 'isSelectedProjectArchived', 'isPossibleToAddTasks'], function (_ref2) {
            var canManageSelectedProject = _ref2.canManageSelectedProject,
                singleCPSelection = _ref2.singleCPSelection,
                isSelectedProjectArchived = _ref2.isSelectedProjectArchived,
                isPossibleToAddTasks = _ref2.isPossibleToAddTasks;

            var canAddTask = isPossibleToAddTasks && canManageSelectedProject && !!singleCPSelection.projectId && !!singleCPSelection.customerId;
            _this.addNewTaskButton.toggle(canAddTask);

            _this.addNewTaskButton.setState({
                disabled: canAddTask && isSelectedProjectArchived,
                disableTooltipText: _messageResource2.default.getMessage("task.list.add_new_task.disable_tooltip.project_archived")
            });
        });

        _this.onAnyStatePropertyChanged(['hasManageableTasks', 'needToShowScopeFilter'], function (state) {
            _this.scopeFilter.toggle(state.needToShowScopeFilter);
            _this.workScopeLabel.toggleClass("visible", !state.needToShowScopeFilter && !state.hasManageableTasks);
            _this.manageScopeLabel.toggleClass("visible", !state.needToShowScopeFilter && state.hasManageableTasks);
        });

        _this.onAnyStatePropertyChanged(['viewMode', 'allTasksSelected', 'collapsedProjects', 'minimizedCards', 'showSelection', 'singleCPSelection'], function (state) {
            _this.configuratorContainer.setState(state);
        });
        return _this;
    }

    _createClass(HeaderPanel, [{
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='taskManagementHeaderPanel'>" + "  <div class='archivedTaskHeaderLabel'><%=archived%></div>" + "  <div class='titleContainer'>" + "      <div class='leftContainer'>" + "        <div class='titleEditButtonContainer'>" + "            <div class='title'></div>" + "        </div>" + "      </div>" + "      <div class='rightContainer'>" + "      </div>" + "  </div>" + "  <div class='exportsContainer'>" + "      <div class='scopeAccessContainer'>" + "        <div class='scopeAccessFilter'/>" + "        <span class='workScopeLabel'><%-workScopeLabel%></span>" + "        <span class='manageScopeLabel'><%-manageScopeLabel%></span>" + "      </div>" + "      <div class='downRightSubpanel'>" + "        <div class='exportPanelContainer'></div>" + "        <div class='configuratorContainer'></div>" + "        <div class='viewModeSelectorContainer'></div>" + "      </div>" + "  </div>" + "  <div class='filtersContainer'>" + "  </div>" + "</div>";
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            var _this2 = this;

            this.scopeFilter = new _ScopeFilter2.default({
                onShowOnlyManageableTasksChange: this.actions.setShowOnlyManageableTasks
            }).init(this.find('.scopeAccessFilter'));
            this.workScopeLabel = this.find('.workScopeLabel');
            this.manageScopeLabel = this.find('.manageScopeLabel');

            var $viewModeSelectorContainer = this.find(".viewModeSelectorContainer");
            this.viewModeSelector = new _ViewModeSelector2.default({
                onModeSelected: this.actions.switchViewMode
            }).init($viewModeSelectorContainer);

            new _EditButton2.default(this.find(".titleEditButtonContainer"), function (e) {
                return _this2._editButtonClickHandler(e);
            }).init();

            this.addNewTaskButton = new _Button2.default({
                additionalClass: "addNewTaskButton",
                withPlusIcon: true,
                label: _messageResource2.default.getMessage("task.list.add_new_task"),
                onClickCb: function onClickCb(e) {
                    (0, _utils.setEventPreventHidingCreateTaskSlidingPanel)(e);
                    _this2.actions.openCreateTaskPanel();
                },
                withDisableTooltip: true
            }).init(this.find(".rightContainer"));

            this.$title = this.find(".leftContainer").find(".title");

            this.$archivedLabel = this.find(".archivedTaskHeaderLabel");

            this.configuratorContainer = new _ConfiguratorPanelContainer2.default({
                onAllSelectedChanged: this.callbacks.onAllSelectedChanged,
                onMinimizedCardsChanged: this.callbacks.onMinimizedCardsChanged,
                onCollapseAllChanged: this.callbacks.onCollapseAllChanged
            }).init(this.find('.configuratorContainer'));

            this.exportPanelContainer = new _TaskListExportPanel2.default().init(this.find('.exportPanelContainer'));

            this.filtersPanel = new _FiltersPanel2.default().init(this.find('.filtersContainer'));
        }
    }, {
        key: "messageKeys",
        value: function messageKeys() {
            return {
                archived: "task.list.header.archived",
                tasksOf: "task.list.tasks_of",
                allCustomers: "task.list.all_customers",
                workScopeLabel: "task.list.header.type_filter.my_tasks",
                manageScopeLabel: 'task.list.header.type_filter.tasks_can_manage'
            };
        }
    }, {
        key: "updateNavigation",
        value: function updateNavigation() {
            this.$title.text(this.state.headerTitle);
            this.$title.attr('title', this.state.headerTitle);
            this.$el.toggleClass("hasSelectedCustomer", !!this.state.singleCPSelection.customerId);
            this.$el.toggleClass("hasSelectedProject", !!this.state.singleCPSelection.projectId);
        }
    }, {
        key: "_editButtonClickHandler",
        value: function _editButtonClickHandler(e) {
            var selection = this.state.singleCPSelection;
            if (selection.projectId) {
                (0, _utils.setEventPreventHidingEditProjectSlidingPanel)(e);
                (0, _jquery2.default)(document).trigger("taskManagement_customersProjectsPanel_viewProject", selection.projectId);
            } else if (selection.customerId) {
                (0, _utils.setEventPreventHidingEditCustomerSlidingPanel)(e);
                (0, _jquery2.default)(document).trigger("taskManagement_viewCustomer", selection.customerId);
            }
        }
    }]);

    return HeaderPanel;
}(_TemplateView3.default);

exports.default = (0, _utils2.connect)(function (state) {
    return {
        canManageSelectedProject: (0, _selectors.canManageSelectedProject)(state),
        isSelectedProjectArchived: (0, _selectors.isSelectedProjectArchived)(state),
        isPossibleToAddTasks: (0, _selectors.isPossibleToAddTasks)(state),
        hasManageableTasks: (0, _selectors.isViewerHasManageableTasks)(state),
        needToShowScopeFilter: (0, _selectors.isNeedToShowScopeFilter)(state),
        showOnlyManageableTasks: (0, _selectors.isShowOnlyManageableTasks)(state),
        viewMode: (0, _selectors.getViewMode)(state),
        singleCPSelection: (0, _selectors.getSingleCPSelection)(state),
        headerTitle: (0, _selectors2.getHeaderTitle)(state),
        showArchivedLabel: (0, _selectors2.isShowArchivedLabel)(state),
        showViewModeSelector: (0, _selectors.isShowViewMode)(state),
        allTasksSelected: (0, _selectors4.isAllTasksSelectedCheckboxChecked)(state),
        minimizedCards: (0, _selectors3.isMinimizedCards)(state),
        showSelection: (0, _selectors.isNeedToShowSelection)(state),
        collapsedProjects: (0, _selectors3.getCollapsedProjectsWithIdsSet)(state),
        ignoreProjectCollapse: (0, _selectors3.doesIgnoreCollapse)(state),
        isTWSEnabled: (0, _selectors5.isTWSEnabled)(state)
    };
}, function (dispatch) {
    return {
        setShowOnlyManageableTasks: (0, _redux.bindActionCreators)(_actions.setShowOnlyManageableTasks, dispatch),
        switchViewMode: (0, _redux.bindActionCreators)(_actions.switchViewMode, dispatch),
        openCreateTaskPanel: (0, _redux.bindActionCreators)(_actions2.openCreateTaskPanel, dispatch),
        onAllSelectedChanged: (0, _redux.bindActionCreators)(_actions3.changeAllTasksSelectedAction, dispatch),
        onMinimizedCardsChanged: (0, _redux.bindActionCreators)(_actions3.toggleMinimizedCards, dispatch),
        onCollapseAllChanged: (0, _redux.bindActionCreators)(_actions3.collapseAllProjects, dispatch)
    };
})(HeaderPanel);

/***/ }),
/* 1837 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _SimpleTooltip = __webpack_require__(36);

var _SimpleTooltip2 = _interopRequireDefault(_SimpleTooltip);

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _constants = __webpack_require__(44);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ViewModeSelector = function (_TemplateView) {
    _inherits(ViewModeSelector, _TemplateView);

    function ViewModeSelector(_ref) {
        var _ref$onModeSelected = _ref.onModeSelected,
            onModeSelected = _ref$onModeSelected === undefined ? function (mode) {} : _ref$onModeSelected;

        _classCallCheck(this, ViewModeSelector);

        var _this = _possibleConstructorReturn(this, (ViewModeSelector.__proto__ || Object.getPrototypeOf(ViewModeSelector)).call(this));

        _this.onModeSelected = onModeSelected;

        _this.state = {
            viewMode: null
        };

        _this.onStatePropertyChanged('viewMode', function (viewMode) {
            return _this._updateViewMode(viewMode);
        });
        return _this;
    }

    _createClass(ViewModeSelector, [{
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='viewModeSelector'>" + "  <div class='modeButton table'></div>" + "  <div class='modeButton kanban'></div>" + "</div>";
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            var _this2 = this;

            this.$tableButton = this.find(".modeButton.table").click(function () {
                return _this2.onModeSelected(_constants.TaskManagementViewMode.TABLE);
            });
            this.$kanbanButton = this.find(".modeButton.kanban").click(function () {
                return _this2.onModeSelected(_constants.TaskManagementViewMode.KANBAN);
            });

            this.tooltip = new _SimpleTooltip2.default().init($('body'));
            this.tooltip.subscribeToMouseEvents(this.find(".modeButton.table"), function () {
                return _this2.tooltip.setText(messageResource.getMessage("task.list.view_mode.list"));
            });
            this.tooltip.subscribeToMouseEvents(this.find(".modeButton.kanban"), function () {
                return _this2.tooltip.setText(messageResource.getMessage("task.list.view_mode.kanban"));
            });
        }
    }, {
        key: "_updateViewMode",
        value: function _updateViewMode(viewMode) {
            this.$tableButton.toggleClass('active', viewMode === _constants.TaskManagementViewMode.TABLE);
            this.$kanbanButton.toggleClass('active', viewMode === _constants.TaskManagementViewMode.KANBAN);
        }
    }]);

    return ViewModeSelector;
}(_TemplateView3.default);

exports.default = ViewModeSelector;

/***/ }),
/* 1838 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _Tab = __webpack_require__(563);

var _Tab2 = _interopRequireDefault(_Tab);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TaskManagementScopeFilter = {
    ALL: 'ALL',
    MANAGEMENT_ONLY: 'MANAGEMENT_ONLY'
};

var ScopeFilter = function (_TemplateView) {
    _inherits(ScopeFilter, _TemplateView);

    function ScopeFilter(_ref) {
        var _ref$onShowOnlyManage = _ref.onShowOnlyManageableTasksChange,
            onShowOnlyManageableTasksChange = _ref$onShowOnlyManage === undefined ? function () {} : _ref$onShowOnlyManage;

        _classCallCheck(this, ScopeFilter);

        var _this = _possibleConstructorReturn(this, (ScopeFilter.__proto__ || Object.getPrototypeOf(ScopeFilter)).call(this, null));

        _this.callbacks = {
            onShowOnlyManageableTasksChange: onShowOnlyManageableTasksChange
        };

        _this.state = {
            showOnlyManageableTasks: false
        };

        _this._tabsMap = {};

        _this.onStatePropertyChanged('showOnlyManageableTasks', function (showOnlyManageableTasks) {
            _this._tabsMap[TaskManagementScopeFilter.ALL].setState({ active: !showOnlyManageableTasks });
            _this._tabsMap[TaskManagementScopeFilter.MANAGEMENT_ONLY].setState({ active: showOnlyManageableTasks });
        });
        return _this;
    }

    _createClass(ScopeFilter, [{
        key: "templateHtml",
        value: function templateHtml() {
            return '<div class="taskManagement_scopeFilter components_tabsContainer"></div>';
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            var _this2 = this;

            this._tabsMap[TaskManagementScopeFilter.ALL] = new _Tab2.default({
                id: TaskManagementScopeFilter.ALL,
                onClick: function onClick() {
                    return _this2.callbacks.onShowOnlyManageableTasksChange(false);
                },
                text: _messageResource2.default.getMessage('task.list.header.type_filter.all_tasks')
            }).init(this.$el);

            this._tabsMap[TaskManagementScopeFilter.MANAGEMENT_ONLY] = new _Tab2.default({
                id: TaskManagementScopeFilter.MANAGEMENT_ONLY,
                onClick: function onClick() {
                    return _this2.callbacks.onShowOnlyManageableTasksChange(true);
                },
                text: _messageResource2.default.getMessage('task.list.header.type_filter.tasks_can_manage')
            }).init(this.$el);

            this.renderInitialState();
        }
    }]);

    return ScopeFilter;
}(_TemplateView3.default);

exports.default = ScopeFilter;

/***/ }),
/* 1839 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _redux = __webpack_require__(7);

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _utils = __webpack_require__(6);

var _ClassicBridge = __webpack_require__(18);

var _ClassicBridge2 = _interopRequireDefault(_ClassicBridge);

var _selectors = __webpack_require__(190);

var _selectors2 = __webpack_require__(27);

var _actions = __webpack_require__(55);

var _selectors3 = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FiltersPanel = function (_TemplateView) {
    _inherits(FiltersPanel, _TemplateView);

    function FiltersPanel(_ref) {
        var setTaskListFilters = _ref.setTaskListFilters;

        _classCallCheck(this, FiltersPanel);

        var _this = _possibleConstructorReturn(this, (FiltersPanel.__proto__ || Object.getPrototypeOf(FiltersPanel)).call(this));

        _this.state = {
            customFields: [],
            workflowStatuses: [],
            selectedFilterKeys: [],
            customFieldsFilters: {},
            taskStatusFilter: {
                allSelected: false,
                statusIds: [],
                statusTypes: []
            }
        };

        _this.actions = {
            setTaskListFilters: setTaskListFilters
        };

        _this.onAnyStatePropertyChanged(['taskStatusFilter', 'customFieldsFilters'], function (_ref2) {
            var taskStatusFilter = _ref2.taskStatusFilter,
                customFieldsFilters = _ref2.customFieldsFilters;

            _this.panel.setProps({
                filters: {
                    status: taskStatusFilter,
                    customFields: customFieldsFilters
                }
            });
        });

        _this.onStatePropertyChanged('customFields', function (customFields) {
            _this.panel.setProps({
                customFields: customFields
            });
        });

        _this.onStatePropertyChanged('workflowStatuses', function (workflowStatuses) {
            _this.panel.setProps({
                workflowStatuses: workflowStatuses
            });
        });

        _this.onStatePropertyChanged('selectedFilterKeys', function (selectedFilterKeys) {
            _this.panel.setProps({
                visibleFilterKeys: new Set(selectedFilterKeys)
            });
        });
        return _this;
    }

    _createClass(FiltersPanel, [{
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='atNextMount'></div>";
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            var _this2 = this;

            this.panel = _ClassicBridge2.default.integrateTaskListFiltersPanel(this.$el[0], {
                customFields: this.state.customFields,
                filters: {
                    status: this.state.taskStatusFilter,
                    customFields: this.state.customFieldsFilters
                },
                onChangeSearch: function onChangeSearch(text) {
                    return $(document).trigger("taskManagement_tasksTable_tasksSearchField_change", [text]);
                },
                onChangeFilters: function onChangeFilters(filters) {
                    filters.status.statusIds = filters.status.statusIds.map(function (workflowStatusId) {
                        var workflowStatus = _this2.state.workflowStatuses.find(function (status) {
                            return workflowStatusId === status.id;
                        });
                        return workflowStatus ? workflowStatus.classicId : workflowStatusId;
                    });

                    _this2.actions.setTaskListFilters(filters);
                },
                visibleFilterKeys: new Set(this.state.selectedFilterKeys),
                workflowStatuses: this.state.workflowStatuses
            });

            this.renderInitialState();
        }
    }]);

    return FiltersPanel;
}(_TemplateView3.default);

exports.default = (0, _utils.connect)(function (state) {
    return {
        customFields: (0, _selectors.selectTaskCustomFields)(state),
        workflowStatuses: (0, _selectors3.getNextWorkflowStatusesArray)(state),
        customFieldsFilters: (0, _selectors2.getCustomFieldsFilters)(state),
        selectedFilterKeys: (0, _selectors2.getSelectedFilterKeys)(state),
        taskStatusFilter: (0, _selectors2.getNextTaskStatusFilter)(state)
    };
}, function (dispatch) {
    return {
        setTaskListFilters: (0, _redux.bindActionCreators)(_actions.setTaskListFilters, dispatch)
    };
})(FiltersPanel);

/***/ }),
/* 1840 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isShowArchivedLabel = exports.getHeaderTitle = undefined;

var _reselect = __webpack_require__(13);

var _selectors = __webpack_require__(27);

var _selectors2 = __webpack_require__(14);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getHeaderTitle = exports.getHeaderTitle = (0, _reselect.createSelector)(_selectors.getSingleCPSelection, _selectors2.getCustomers, _selectors2.getProjects, function (cpSelection, customers, projects) {
    return !!cpSelection.projectId ? projects[cpSelection.projectId].name : !!cpSelection.customerId ? customers[cpSelection.customerId].name : _messageResource2.default.getMessage("task.list.all_customers");
});

var isShowArchivedLabel = exports.isShowArchivedLabel = (0, _reselect.createSelector)(_selectors.getSingleCPSelection, _selectors2.getCustomers, _selectors2.getProjects, function (cpSelection, customers, projects) {
    return !!cpSelection.projectId ? projects[cpSelection.projectId].archived : !!cpSelection.customerId ? customers[cpSelection.customerId].archived : false;
});

/***/ }),
/* 1841 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.afterTaskCreatedCb = undefined;

var _TaskStore = __webpack_require__(91);

var _TaskStore2 = _interopRequireDefault(_TaskStore);

var _TaskManagementStore = __webpack_require__(140);

var _TaskManagementStore2 = _interopRequireDefault(_TaskManagementStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var afterTaskCreatedCb = exports.afterTaskCreatedCb = function afterTaskCreatedCb(task) {
    _TaskStore2.default.add(task);
    _TaskManagementStore2.default.appendCreatedTaskIds([task.id]);
};

/***/ }),
/* 1842 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _CsvExportButton = __webpack_require__(1843);

var _CsvExportButton2 = _interopRequireDefault(_CsvExportButton);

var _utils = __webpack_require__(6);

var _selectors = __webpack_require__(27);

var _constants = __webpack_require__(44);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TaskListExportPanel = function (_TemplateView) {
    _inherits(TaskListExportPanel, _TemplateView);

    function TaskListExportPanel() {
        _classCallCheck(this, TaskListExportPanel);

        var _this = _possibleConstructorReturn(this, (TaskListExportPanel.__proto__ || Object.getPrototypeOf(TaskListExportPanel)).call(this));

        _this.state = {
            hidden: false
        };
        _this.onStatePropertyChanged('hidden', function (value) {
            return _this.getEl().toggleClass('hidden', value);
        });
        return _this;
    }

    _createClass(TaskListExportPanel, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return "<div class='csvExportPanel'>" + "    <div class='csvExport container'/>" + "    <div class='separator'/>" + "</div>";
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            new _CsvExportButton2.default().init(this.find(".csvExport"));
        }
    }]);

    return TaskListExportPanel;
}(_TemplateView3.default);

exports.default = (0, _utils.connect)(function (state) {
    return {
        hidden: (0, _selectors.getViewMode)(state) !== _constants.TaskManagementViewMode.TABLE
    };
})(TaskListExportPanel);

/***/ }),
/* 1843 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _redux = __webpack_require__(7);

var _utils = __webpack_require__(6);

var _selectors = __webpack_require__(930);

var _actions = __webpack_require__(1844);

var _selectors2 = __webpack_require__(82);

var _ExportCSVButton2 = __webpack_require__(932);

var _ExportCSVButton3 = _interopRequireDefault(_ExportCSVButton2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ExportTaskListCSVButton = function (_ExportCSVButton) {
    _inherits(ExportTaskListCSVButton, _ExportCSVButton);

    function ExportTaskListCSVButton(props) {
        _classCallCheck(this, ExportTaskListCSVButton);

        return _possibleConstructorReturn(this, (ExportTaskListCSVButton.__proto__ || Object.getPrototypeOf(ExportTaskListCSVButton)).call(this, _extends({}, props, {
            labelMessageKey: 'task.list.export.csv',
            noDataMessageKey: 'task.list.export.no_data'
        })));
    }

    return ExportTaskListCSVButton;
}(_ExportCSVButton3.default);

exports.default = (0, _utils.connect)(function (state) {
    return {
        disabled: (0, _selectors.getExportState)(state).inProgress ? false : !(0, _selectors2.thereAreTableTasks)(state),
        inProgress: (0, _selectors.getExportState)(state).inProgress
    };
}, function (dispatch) {
    return {
        exportAction: (0, _redux.bindActionCreators)(_actions.exportTaskListCsv, dispatch)
    };
})(ExportTaskListCSVButton);

/***/ }),
/* 1844 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.exportTaskListCsv = undefined;

var _reduxActions = __webpack_require__(9);

var _actionTypes = __webpack_require__(673);

var ActionTypes = _interopRequireWildcard(_actionTypes);

var _selectors = __webpack_require__(27);

var _selectors2 = __webpack_require__(82);

var _utils = __webpack_require__(1845);

var _syncCallbacks = __webpack_require__(161);

var _selectors3 = __webpack_require__(15);

var _connector = __webpack_require__(288);

var _selectors4 = __webpack_require__(930);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var setExportInProgress = (0, _reduxActions.createAction)(ActionTypes.CSV_EXPORT_IN_PROGRESS_SET);

var exportTaskListCsv = exports.exportTaskListCsv = function exportTaskListCsv() {
    return function (dispatch, getState) {
        dispatch(setExportInProgress(true));
        var state = getState();
        var columnsWithOrder = (0, _selectors2.getShownColumnsWithOrderForCsv)(state);
        var taskCustomFields = (0, _selectors.getTaskCustomFieldsMap)(state);
        (0, _connector.makeLoadTasksRequest)({
            intersectedCPSelection: (0, _selectors.getIntersectedCPSelection)(state),
            taskStatusFilter: (0, _selectors.getTaskStatusFilter)(state),
            customFieldsFilters: (0, _selectors.getCustomFieldsFilters)(state),
            taskNameFilter: (0, _selectors.getTaskNameFilter)(state),
            showOnlyManageableTasks: (0, _selectors.isShowOnlyManageableTasks)(state),
            taskSorting: (0, _selectors2.getTasksSorting)(state),
            offset: 0,
            noRetry: true
        }).then(function (data) {
            var summaryRow = (0, _selectors4.getIsSummaryRowShown)(state) && (0, _selectors2.getSummaryRow)(state);

            (0, _utils.convertTaskListAndSaveAsCsv)(data, columnsWithOrder, taskCustomFields, (0, _selectors3.isTWSEnabled)(state), summaryRow);
            dispatch(setExportInProgress(false));
        }).catch(function (err) {
            dispatch(setExportInProgress(false));
            (0, _syncCallbacks.afterTaskListExportRequestFailed)(err);
        });
    };
};

/***/ }),
/* 1845 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _optionalColumnMapFor;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.convertTaskListAndSaveAsCsv = convertTaskListAndSaveAsCsv;

var _utils = __webpack_require__(127);

var _constants = __webpack_require__(571);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _constants2 = __webpack_require__(44);

var _date_format = __webpack_require__(16);

var _atUtils = __webpack_require__(5);

var _constants3 = __webpack_require__(23);

var _format = __webpack_require__(931);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function convertTaskListAndSaveAsCsv(_ref, optionalColumns, customFieldsMap, isTWSEnabled, summaryRow) {
    var projects = _ref.projects,
        customers = _ref.customers,
        tasks = _ref.tasks,
        billingTypes = _ref.billingTypes,
        workflowStatuses = _ref.workflowStatuses;

    var customerMap = (0, _atUtils.arrayToMap)(customers);
    var projectMap = (0, _atUtils.arrayToMap)(projects);
    var billingTypesMap = (0, _atUtils.arrayToMap)(billingTypes.list);
    var workflowStatusValueMap = {};
    var getWorkflowStatusValue = isTWSEnabled ? workflowStatusExtended : workflowStatusSimple;
    workflowStatuses.forEach(function (item) {
        return workflowStatusValueMap[item.id] = getWorkflowStatusValue(item);
    });

    var json = {
        columnNames: csvColumnNames(optionalColumns, customFieldsMap),
        columns: csvColumns(optionalColumns),
        table: csvRows(tasks, optionalColumns, customerMap, projectMap, billingTypesMap, workflowStatusValueMap, summaryRow)
    };
    var fileName = _messageResource2.default.getMessage("task.list.export_name.csv", [new _date_format.DateFormat('MMM dd, yyyy').formatDate(window.currentUserTime())]);
    (0, _utils.downloadJsonAsCSV)([json], fileName);
}

function csvColumnNames(optionalColumns, customFieldsMap) {
    return _extends({
        customer: _messageResource2.default.getMessage("common.Customer"),
        project: _messageResource2.default.getMessage("common.Project"),
        task: _messageResource2.default.getMessage("common.Task"),
        status: _messageResource2.default.getMessage("task.list.task_status")
    }, csvOptionalColumnNames(optionalColumns, customFieldsMap));
}

function csvOptionalColumnNames(optionalColumns, customFieldsMap) {
    return _underscore2.default.object(optionalColumns, _underscore2.default.map(optionalColumns, function (item) {
        if (!!customFieldsMap[item]) return customFieldsMap[item].title;else return _messageResource2.default.getMessage(_constants.ColumnTitlesKeys[item]);
    }));
}

function csvColumns(optionalColumns) {
    return ["customer", "project", "task", "status"].concat(_toConsumableArray(optionalColumns));
}

function csvRows(tasks, optionalColumns, customerMap, projectMap, billingTypesMap, workflowStatusValueMap, summaryRow) {
    var result = _underscore2.default.map(tasks, function (task) {
        var customFields = task.customFieldsValues || {};
        var formattedTask = _extends({}, task, customFields);
        return _extends({
            customer: (0, _format.nameWithArchivedMark)(customerMap[formattedTask.customerId]),
            project: (0, _format.nameWithArchivedMark)(projectMap[formattedTask.projectId]),
            task: formattedTask.name,
            status: workflowStatusValueMap[formattedTask.workflowStatusId]
        }, csvMapOptionalColumns(optionalColumns, formattedTask, billingTypesMap));
    });

    if (summaryRow) {
        var _ref2;

        result = [(_ref2 = {}, _defineProperty(_ref2, _constants2.TaskSortBy.ESTIMATE, _underscore2.default.isNumber(summaryRow.estimate) ? (0, _format.columnValue)(summaryRow.estimate, _format.formatTimeDecimal) : undefined), _defineProperty(_ref2, _constants2.TaskSortBy.SPENT_TIME, (0, _format.columnValue)(summaryRow.spentTime, _format.formatTimeDecimal)), _defineProperty(_ref2, _constants2.TaskSortBy.VARIANCE_MAN_HOURS, summaryRow.variance && _underscore2.default.isNumber(summaryRow.variance.duration) ? (0, _format.columnValue)(summaryRow.variance.duration, _format.formatTimeDecimal) : undefined), _defineProperty(_ref2, _constants2.TaskSortBy.VARIANCE_PERCENTS, summaryRow.variance && _underscore2.default.isNumber(summaryRow.variance.percentage) ? (0, _format.columnValue)(summaryRow.variance.percentage, _format.formatPercent) : undefined), _ref2)].concat(_toConsumableArray(result));
    }

    return result;
}

function csvMapOptionalColumns(optionalColumns, task, billingTypesMap) {
    var result = {};
    _underscore2.default.each(optionalColumns, function (column) {
        if (!!optionalColumnMapFormatter[column]) {
            result[column] = optionalColumnMapFormatter[column](task, billingTypesMap);
        } else {
            result[column] = (0, _format.columnValue)(task[column], function (value) {
                return value;
            });
        }
    });
    return result;
}

var optionalColumnMapFormatter = (_optionalColumnMapFor = {}, _defineProperty(_optionalColumnMapFor, _constants2.TaskSortBy.DEADLINE, function (task) {
    return (0, _format.columnValue)(task.deadline, _format.formatDate);
}), _defineProperty(_optionalColumnMapFor, _constants2.TaskSortBy.ESTIMATE, function (task) {
    return (0, _format.columnValue)(task.estimatedTime, _format.formatTimeDecimal);
}), _defineProperty(_optionalColumnMapFor, _constants2.TaskSortBy.LAST_TRACKING_DATE, function (task) {
    return (0, _format.columnValue)(task.lastTTDate, _format.formatDate);
}), _defineProperty(_optionalColumnMapFor, _constants2.TaskSortBy.TYPE_OF_WORK, function (task, billingTypesMap) {
    return billingTypeColumnValue(billingTypesMap[task.typeOfWorkId]);
}), _defineProperty(_optionalColumnMapFor, _constants2.TaskSortBy.CREATION_DATE, function (task) {
    return (0, _format.formatDate)(task.creationTimestamp);
}), _defineProperty(_optionalColumnMapFor, _constants2.TaskSortBy.SPENT_TIME, function (task) {
    return (0, _format.formatTimeDecimal)(task.spentTime);
}), _defineProperty(_optionalColumnMapFor, _constants2.TaskSortBy.VARIANCE_MAN_HOURS, function (task) {
    return (0, _format.columnValue)(task.variance ? task.variance.duration : null, _format.formatTimeDecimal);
}), _defineProperty(_optionalColumnMapFor, _constants2.TaskSortBy.VARIANCE_PERCENTS, function (task) {
    return (0, _format.columnValue)(task.variance ? task.variance.percentage : null, _format.formatPercent);
}), _optionalColumnMapFor);

function workflowStatusSimple(status) {
    return _messageResource2.default.getMessage(status.type === _constants3.WorkflowStatusType.OPEN ? "task.status.open" : "task.status.completed");
}

function workflowStatusExtended(status) {
    var statusPrefix = workflowStatusSimple(status);
    return statusPrefix + ': ' + status.name;
}

function billingTypeColumnValue(billingType) {
    var category = _messageResource2.default.getMessage(billingType.billable ? 'billing_type.billable' : 'billing_type.non_billable');
    return category + ': ' + billingType.name;
}

/***/ }),
/* 1846 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isPossibleToUseWorker = isPossibleToUseWorker;
exports.createWorkerFromFunction = createWorkerFromFunction;
function isPossibleToUseWorker() {
    return !!window.Worker && !!window.URL && !!window.Blob;
}

/**
 * Create worker from function without dependencies !!
 * @param fn function without dependencies
 * @returns {Worker}
 */
function createWorkerFromFunction(fn) {
    return new Worker(window.URL.createObjectURL(new Blob(['self.onmessage = function(wrk) {' + 'var f = ' + Function.toString.call(fn) + ';' + 'self.postMessage(f.apply(f, wrk.data.args));' + '};'], { type: 'text/javascript' })));
}

/***/ }),
/* 1847 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _constants = __webpack_require__(44);

var _KanbanConfiguratorPanel = __webpack_require__(1848);

var _KanbanConfiguratorPanel2 = _interopRequireDefault(_KanbanConfiguratorPanel);

var _TaskListConfiguratorPanel = __webpack_require__(1852);

var _TaskListConfiguratorPanel2 = _interopRequireDefault(_TaskListConfiguratorPanel);

var _AddFiltersContainer = __webpack_require__(1855);

var _AddFiltersContainer2 = _interopRequireDefault(_AddFiltersContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ConfiguratorPanelContainer = function (_TemplateView) {
    _inherits(ConfiguratorPanelContainer, _TemplateView);

    function ConfiguratorPanelContainer(_ref) {
        var _ref$onAllSelectedCha = _ref.onAllSelectedChanged,
            onAllSelectedChanged = _ref$onAllSelectedCha === undefined ? function (allSelected) {} : _ref$onAllSelectedCha,
            _ref$onMinimizedCards = _ref.onMinimizedCardsChanged,
            onMinimizedCardsChanged = _ref$onMinimizedCards === undefined ? function (minimizedCards) {} : _ref$onMinimizedCards,
            _ref$onCollapseAllCha = _ref.onCollapseAllChanged,
            onCollapseAllChanged = _ref$onCollapseAllCha === undefined ? function (isAllCollapsed) {} : _ref$onCollapseAllCha;

        _classCallCheck(this, ConfiguratorPanelContainer);

        var _this = _possibleConstructorReturn(this, (ConfiguratorPanelContainer.__proto__ || Object.getPrototypeOf(ConfiguratorPanelContainer)).call(this));

        _this._handleViewModeChanges = function (viewMode) {
            _this.kanbanConfigurator.toggle(viewMode === _constants.TaskManagementViewMode.KANBAN);
            _this.$taskTableConfigurator.toggle(viewMode === _constants.TaskManagementViewMode.TABLE);
        };

        _this.state = {
            viewMode: null,
            minimizedCards: false,
            showSelection: false,
            allTasksSelected: false,
            collapsedProjects: {
                all: false,
                idsSet: {}
            },
            singleCPSelection: {},
            ignoreProjectCollapse: false,
            isTWSEnabled: false
        };

        _this.callbacks = {
            onAllSelectedChanged: onAllSelectedChanged,
            onMinimizedCardsChanged: onMinimizedCardsChanged,
            onCollapseAllChanged: onCollapseAllChanged
        };

        _this.onStatePropertyChanged('viewMode', _this._handleViewModeChanges);
        _this.onStatePropertyChanged('isTWSEnabled', function (isTWSEnabled) {
            return _this.$separator.toggle(isTWSEnabled);
        });

        _this.onAnyStatePropertyChanged(['allTasksSelected', 'minimizedCards', 'showSelection', 'collapsedProjects', 'singleCPSelection', 'ignoreProjectCollapse'], function (state) {
            return _this.kanbanConfiguratorPanel.setState(state);
        });
        return _this;
    }

    _createClass(ConfiguratorPanelContainer, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return "<div class='configuratorPanel'>" + "    <div class='kanbanConfigurator'/>" + "    <div class='taskTableConfigurator'/>" + "    <div class='taskAddFiltersContainer atNextMount'/>" + "    <div class='configuratorSeparator'/>" + "</div>";
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            this.$taskTableConfigurator = this.find(".taskTableConfigurator");
            new _TaskListConfiguratorPanel2.default().init(this.$taskTableConfigurator);

            this.kanbanConfigurator = this.find(".kanbanConfigurator");
            this.kanbanConfiguratorPanel = new _KanbanConfiguratorPanel2.default({
                onAllSelectedChanged: this.callbacks.onAllSelectedChanged,
                onMinimizedCardsChanged: this.callbacks.onMinimizedCardsChanged,
                onCollapseAllChanged: this.callbacks.onCollapseAllChanged
            }).init(this.kanbanConfigurator);

            this.addFiltersContainer = new _AddFiltersContainer2.default().init(this.find(".taskAddFiltersContainer"));

            this.$separator = this.find(".configuratorSeparator");
            this.$separator.hide();
        }
    }]);

    return ConfiguratorPanelContainer;
}(_TemplateView3.default);

exports.default = ConfiguratorPanelContainer;

/***/ }),
/* 1848 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _MinimizeKanbanViewCardsButton = __webpack_require__(1849);

var _MinimizeKanbanViewCardsButton2 = _interopRequireDefault(_MinimizeKanbanViewCardsButton);

var _SelectAllButton = __webpack_require__(1850);

var _SelectAllButton2 = _interopRequireDefault(_SelectAllButton);

var _CollapseAllButton = __webpack_require__(1851);

var _CollapseAllButton2 = _interopRequireDefault(_CollapseAllButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var KanbanConfiguratorPanel = function (_TemplateView) {
    _inherits(KanbanConfiguratorPanel, _TemplateView);

    function KanbanConfiguratorPanel(_ref) {
        var _ref$onAllSelectedCha = _ref.onAllSelectedChanged,
            onAllSelectedChanged = _ref$onAllSelectedCha === undefined ? function (selectAll) {} : _ref$onAllSelectedCha,
            _ref$onMinimizedCards = _ref.onMinimizedCardsChanged,
            onMinimizedCardsChanged = _ref$onMinimizedCards === undefined ? function (minimized) {} : _ref$onMinimizedCards,
            _ref$onCollapseAllCha = _ref.onCollapseAllChanged,
            onCollapseAllChanged = _ref$onCollapseAllCha === undefined ? function (isAllCollapsed) {} : _ref$onCollapseAllCha;

        _classCallCheck(this, KanbanConfiguratorPanel);

        var _this = _possibleConstructorReturn(this, (KanbanConfiguratorPanel.__proto__ || Object.getPrototypeOf(KanbanConfiguratorPanel)).call(this));

        _this.callbacks = {
            onAllSelectedChanged: onAllSelectedChanged,
            onMinimizedCardsChanged: onMinimizedCardsChanged,
            onCollapseAllChanged: onCollapseAllChanged
        };

        _this.state = {
            allTasksSelected: false,
            collapsedProjects: {
                all: false,
                idsSet: {}
            },
            singleCPSelection: {},
            minimizedCards: false,
            showSelection: false,
            ignoreProjectCollapse: false
        };

        _this.onStatePropertyChanged('collapsedProjects', function (collapsedProjects) {
            _this.collapseAllButton.setState({
                isAllCollapsed: collapsedProjects.all
            });
        });

        _this.onStatePropertyChanged('ignoreProjectCollapse', function (ignoreProjectCollapse) {
            _this.collapseAllButton.setState({
                disableCollapse: ignoreProjectCollapse
            });
        });

        _this.onStatePropertyChanged('allTasksSelected', function (allTasksSelected) {
            _this.selectAllButton.setState({
                isAllSelected: allTasksSelected
            });
        });

        _this.onStatePropertyChanged("minimizedCards", function (minimizedCards) {
            _this.minimizeButton.setState({ minimizedCards: minimizedCards });
        });

        _this.onStatePropertyChanged('singleCPSelection', function (singleCPSelection) {
            var notSingleProjectSelection = !singleCPSelection.customerId || !singleCPSelection.projectId;
            _this.$collapseAllButtonContainer.toggle(notSingleProjectSelection).next('.separator').toggle(notSingleProjectSelection);
        });

        _this.onStatePropertyChanged("showSelection", function (showSelection) {
            _this.$selectAllButtonContainer.toggle(showSelection).next('.separator').toggle(showSelection);
        });
        return _this;
    }

    _createClass(KanbanConfiguratorPanel, [{
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='kanbanView_components_filtersPanel'>" + "  <div class='separator'></div>" + "  <div class='selectAllButtonContainer'></div>" + "  <div class='separator'></div>" + "  <div class='collapseAllButtonContainer'></div>" + "  <div class='separator'></div>" + "  <div class='minimizedCardsLabel'><%-cardsViewLabel%></div>" + "  <div class='minimizedCardsSelectorContainer'></div>" + "  <div class='separator'></div>" + "</div>";
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            var _this2 = this;

            this.$selectAllButtonContainer = this.find('.selectAllButtonContainer');

            this.selectAllButton = new _SelectAllButton2.default({
                onSelectAllCallback: function onSelectAllCallback(isAllSelected) {
                    if (_this2.state.showSelection) _this2.callbacks.onAllSelectedChanged(isAllSelected);
                }
            }).init(this.$selectAllButtonContainer);

            this.$collapseAllButtonContainer = this.find('.collapseAllButtonContainer');
            this.collapseAllButton = new _CollapseAllButton2.default({
                onCollapseAllCallback: this.callbacks.onCollapseAllChanged
            }).init(this.$collapseAllButtonContainer);

            this.minimizeButton = new _MinimizeKanbanViewCardsButton2.default(null, {
                onClick: function onClick() {
                    _this2.callbacks.onMinimizedCardsChanged(!_this2.state.minimizedCards);
                }
            }).init(this.find(".minimizedCardsSelectorContainer"));

            this.renderInitialState();
        }
    }, {
        key: "messageKeys",
        value: function messageKeys() {
            return {
                cardsViewLabel: "task.list.kanban.cards_view"
            };
        }
    }]);

    return KanbanConfiguratorPanel;
}(_TemplateView3.default);

exports.default = KanbanConfiguratorPanel;

/***/ }),
/* 1849 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MinimizeKanbanViewCardsButton = function (_TemplateView) {
    _inherits(MinimizeKanbanViewCardsButton, _TemplateView);

    function MinimizeKanbanViewCardsButton($containerEl, _ref) {
        var _ref$onClick = _ref.onClick,
            onClick = _ref$onClick === undefined ? {} : _ref$onClick;

        _classCallCheck(this, MinimizeKanbanViewCardsButton);

        var _this = _possibleConstructorReturn(this, (MinimizeKanbanViewCardsButton.__proto__ || Object.getPrototypeOf(MinimizeKanbanViewCardsButton)).call(this, $containerEl));

        _this.onClick = onClick;

        _this.state = {
            minimizedCards: false
        };

        _this.onStatePropertyChanged("minimizedCards", function (value) {
            _this._setButtonAppearance(value);
        });
        return _this;
    }

    _createClass(MinimizeKanbanViewCardsButton, [{
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='minimizeButtonContainer'>" + "  <div class='buttonIcon'></div>" + "  <div class='buttonText'></div>" + "</div>";
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            this.$el.on("click", this.onClick);
            this._setButtonAppearance(this.state.minimizedCards);
        }
    }, {
        key: "_setButtonAppearance",
        value: function _setButtonAppearance(minimizedCards) {
            this.$el.toggleClass("minimizeButton", !minimizedCards);
            this.$el.toggleClass("extendButton", minimizedCards);

            var minimizeButtonText = this.find(".buttonText");

            if (minimizedCards) {
                minimizeButtonText.text("Extend cards");
            } else {
                minimizeButtonText.text("Minimize cards");
            }
        }
    }]);

    return MinimizeKanbanViewCardsButton;
}(_TemplateView3.default);

exports.default = MinimizeKanbanViewCardsButton;

/***/ }),
/* 1850 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SelectAllButton = function (_TemplateView) {
    _inherits(SelectAllButton, _TemplateView);

    function SelectAllButton(_ref) {
        var _ref$onSelectAllCallb = _ref.onSelectAllCallback,
            onSelectAllCallback = _ref$onSelectAllCallb === undefined ? function (isAllSelected) {} : _ref$onSelectAllCallb;

        _classCallCheck(this, SelectAllButton);

        var _this = _possibleConstructorReturn(this, (SelectAllButton.__proto__ || Object.getPrototypeOf(SelectAllButton)).call(this));

        _this._handleAllSelection = function (isAllSelected) {
            _this.$selectAllButton.toggle(!isAllSelected);
            _this.$deselectAllButton.toggle(isAllSelected);
        };

        _this.onSelectAllCallback = onSelectAllCallback;

        _this.state = {
            isAllSelected: false
        };

        _this.onStatePropertyChanged('isAllSelected', _this._handleAllSelection);
        return _this;
    }

    _createClass(SelectAllButton, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return "<div class='selectAllButtons'>" + "    <div class='selectAllButton'>" + "        <div class='selectAllButtonImage'></div>" + "        <div class='selectAllButtonLabel'><%=selectAllText%></div>" + "    </div>" + "    <div class='deselectAllButton'>" + "        <div class='deselectAllButtonImage'></div>" + "        <div class='deselectAllButtonLabel'><%=deselectAllText%></div>" + "    </div>" + "</div>";
        }
    }, {
        key: 'messageKeys',
        value: function messageKeys() {
            return {
                selectAllText: 'task.list.kanban.filters_panel.select_all',
                deselectAllText: 'task.list.kanban.filters_panel.deselect_all'
            };
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            var _this2 = this;

            this.$selectAllButton = this.find(".selectAllButton");
            this.$selectAllButton.click(function () {
                return _this2.onSelectAllCallback(true);
            });
            this.$deselectAllButton = this.find(".deselectAllButton");
            this.$deselectAllButton.click(function () {
                return _this2.onSelectAllCallback(false);
            });
            this.renderInitialState();
        }
    }]);

    return SelectAllButton;
}(_TemplateView3.default);

exports.default = SelectAllButton;

/***/ }),
/* 1851 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CollapseAllButton = function (_TemplateView) {
    _inherits(CollapseAllButton, _TemplateView);

    function CollapseAllButton(_ref) {
        var _ref$onCollapseAllCal = _ref.onCollapseAllCallback,
            onCollapseAllCallback = _ref$onCollapseAllCal === undefined ? function (isAllCollapsed) {} : _ref$onCollapseAllCal;

        _classCallCheck(this, CollapseAllButton);

        var _this = _possibleConstructorReturn(this, (CollapseAllButton.__proto__ || Object.getPrototypeOf(CollapseAllButton)).call(this));

        _this._handleAllCollapsed = function (isAllCollapsed) {
            _this.$collapseAllButton.toggle(!isAllCollapsed);
            _this.$expandAllButton.toggle(isAllCollapsed);
        };

        _this.onCollapseAllCallback = onCollapseAllCallback;

        _this.state = {
            isAllCollapsed: false,
            disableCollapse: false
        };

        _this.onStatePropertyChanged('isAllCollapsed', _this._handleAllCollapsed);

        _this.onStatePropertyChanged('disableCollapse', function (disableCollapse) {
            _this.getEl().toggleClass('disableCollapse', disableCollapse);
        });
        return _this;
    }

    _createClass(CollapseAllButton, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return "<div class='collapseAllButtons'>" + "    <div class='collapseAllButton'>" + "        <div class='collapseAllButtonImage'></div>" + "        <div class='collapseAllButtonLabel'><%=collapseAllText%></div>" + "    </div>" + "    <div class='expandAllButton'>" + "        <div class='expandAllButtonImage'></div>" + "        <div class='expandAllButtonLabel'><%=expandAllText%></div>" + "    </div>" + "</div>";
        }
    }, {
        key: 'messageKeys',
        value: function messageKeys() {
            return {
                collapseAllText: 'task.list.kanban.filters_panel.collapse_all',
                expandAllText: 'task.list.kanban.filters_panel.expand_all'
            };
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            var _this2 = this;

            this.$collapseAllButton = this.find(".collapseAllButton").click(function () {
                if (!_this2.state.disableCollapse) {
                    _this2.onCollapseAllCallback(true);
                }
            });
            this.$expandAllButton = this.find(".expandAllButton").click(function () {
                if (!_this2.state.disableCollapse) {
                    _this2.onCollapseAllCallback(false);
                }
            });
            this.renderInitialState();
        }
    }]);

    return CollapseAllButton;
}(_TemplateView3.default);

exports.default = CollapseAllButton;

/***/ }),
/* 1852 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _ConfigurationButton = __webpack_require__(1853);

var _ConfigurationButton2 = _interopRequireDefault(_ConfigurationButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TaskListConfiguratorPanel = function (_TemplateView) {
    _inherits(TaskListConfiguratorPanel, _TemplateView);

    function TaskListConfiguratorPanel() {
        _classCallCheck(this, TaskListConfiguratorPanel);

        return _possibleConstructorReturn(this, (TaskListConfiguratorPanel.__proto__ || Object.getPrototypeOf(TaskListConfiguratorPanel)).call(this));
    }

    _createClass(TaskListConfiguratorPanel, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return "<div class='taskListFiltersPanel'>" + "    <div class='columnsConfiguration'/>" + "    <div class='separator'/>" + "</div>";
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            new _ConfigurationButton2.default().init(this.find(".columnsConfiguration"));
        }
    }]);

    return TaskListConfiguratorPanel;
}(_TemplateView3.default);

exports.default = TaskListConfiguratorPanel;

/***/ }),
/* 1853 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _redux = __webpack_require__(7);

var _utils = __webpack_require__(6);

var _actions = __webpack_require__(1854);

var _ClassicBridge = __webpack_require__(18);

var _ClassicBridge2 = _interopRequireDefault(_ClassicBridge);

var _selectors = __webpack_require__(933);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ConfigurationButton = function (_TemplateView) {
    _inherits(ConfigurationButton, _TemplateView);

    function ConfigurationButton(_ref) {
        var _ref$beforeOpen = _ref.beforeOpen,
            beforeOpen = _ref$beforeOpen === undefined ? function () {} : _ref$beforeOpen,
            _ref$afterClose = _ref.afterClose,
            afterClose = _ref$afterClose === undefined ? function () {} : _ref$afterClose,
            _ref$onPositionChange = _ref.onPositionChanged,
            onPositionChanged = _ref$onPositionChange === undefined ? function () {} : _ref$onPositionChange,
            _ref$onColumnsStatusC = _ref.onColumnsStatusChanged,
            onColumnsStatusChanged = _ref$onColumnsStatusC === undefined ? function () {} : _ref$onColumnsStatusC,
            _ref$onIsSummaryRowSh = _ref.onIsSummaryRowShownChanged,
            onIsSummaryRowShownChanged = _ref$onIsSummaryRowSh === undefined ? function () {} : _ref$onIsSummaryRowSh,
            _ref$onApply = _ref.onApply,
            onApply = _ref$onApply === undefined ? function () {} : _ref$onApply;

        _classCallCheck(this, ConfigurationButton);

        var _this = _possibleConstructorReturn(this, (ConfigurationButton.__proto__ || Object.getPrototypeOf(ConfigurationButton)).call(this));

        _this.state = {
            columns: [],
            isSummaryRowShown: false
        };

        _this.actions = {
            beforeOpen: beforeOpen,
            afterClose: afterClose,
            onPositionChanged: onPositionChanged,
            onColumnsStatusChanged: onColumnsStatusChanged,
            onIsSummaryRowShownChanged: onIsSummaryRowShownChanged,
            onApply: onApply
        };

        _this.onStatePropertyChanged('columns', function (columns) {
            _this.configurator.setProps({ columns: columns });
        });

        _this.onStatePropertyChanged('isSummaryRowShown', function (isSummaryRowShown) {
            _this.configurator.setProps({ isSummaryRowSelected: isSummaryRowShown });
        });
        return _this;
    }

    _createClass(ConfigurationButton, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return "<div class='atNextMount'>" + "</div>";
        }
    }, {
        key: 'messageKeys',
        value: function messageKeys() {
            return {
                label: "task.list.configure_columns"
            };
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            var _this2 = this;

            this.configurator = _ClassicBridge2.default.integrateTaskListColumnConfigurator(this.$el[0], {
                columns: this.state.columns,
                isSummaryRowShown: this.state.isSummaryRowShown,
                onSelect: this.actions.onColumnsStatusChanged,
                onSelectSummaryRow: this.actions.onIsSummaryRowShownChanged,
                onReorder: this.actions.onPositionChanged,
                onApply: this.actions.onApply,
                onShow: function onShow() {
                    return _this2.actions.beforeOpen();
                },
                onHide: function onHide() {
                    return _this2.actions.afterClose();
                }
            });
        }
    }]);

    return ConfigurationButton;
}(_TemplateView3.default);

exports.default = (0, _utils.connect)(function (state) {
    return {
        columns: (0, _selectors.getColumnsForConfigMenu)(state),
        isSummaryRowShown: (0, _selectors.getIsSummaryRowShown)(state)
    };
}, function (dispatch) {
    return {
        beforeOpen: (0, _redux.bindActionCreators)(_actions.beforeOpen, dispatch),
        afterClose: (0, _redux.bindActionCreators)(_actions.afterClose, dispatch),
        onApply: (0, _redux.bindActionCreators)(_actions.saveChanges, dispatch),
        onColumnsStatusChanged: (0, _redux.bindActionCreators)(_actions.changeColumnSelection, dispatch),
        onIsSummaryRowShownChanged: (0, _redux.bindActionCreators)(_actions.setIsSummaryRowShown, dispatch),
        onPositionChanged: (0, _redux.bindActionCreators)(_actions.changeColumnOrder, dispatch)
    };
})(ConfigurationButton);

/***/ }),
/* 1854 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.restoreAndSetTableColumnsOrder = exports.afterClose = exports.saveChanges = exports.beforeOpen = exports.changeColumnOrder = exports.changeColumnSelection = exports.setIsSummaryRowShown = exports.setSelected = exports.setColumnsOrder = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reduxActions = __webpack_require__(9);

var _actionTypes = __webpack_require__(670);

var ActionTypes = _interopRequireWildcard(_actionTypes);

var _selectors = __webpack_require__(82);

var _selectors2 = __webpack_require__(933);

var _atUtils = __webpack_require__(5);

var _actions = __webpack_require__(195);

var _actions2 = __webpack_require__(55);

var _constants = __webpack_require__(44);

var _utils = __webpack_require__(570);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var setColumnsOrder = exports.setColumnsOrder = (0, _reduxActions.createAction)(ActionTypes.ORDER_SET);

var setSelected = exports.setSelected = (0, _reduxActions.createAction)(ActionTypes.SELECTED_SET);

var setIsSummaryRowShown = exports.setIsSummaryRowShown = function setIsSummaryRowShown(isShown) {
    return function (dispatch) {
        dispatch((0, _reduxActions.createAction)(ActionTypes.IS_SUMMARY_ROW_SHOWN_SET)(isShown));
    };
};

var changeColumnSelection = exports.changeColumnSelection = function changeColumnSelection(column, selected) {
    return function (dispatch, getState) {
        var selectedColumns = _extends({}, (0, _selectors2.getSelectedColumns)(getState()));

        if (selected) selectedColumns[column] = selected;else delete selectedColumns[column];

        dispatch(setSelected(selectedColumns));
    };
};

var changeColumnOrder = exports.changeColumnOrder = function changeColumnOrder(id, newIndex) {
    return function (dispatch, getState) {
        var order = (0, _selectors2.getColumnsOrder)(getState());
        var fixed = order.filter(function (column) {
            return (0, _utils.isColumnFixed)(column);
        });
        order = order.filter(function (column) {
            return column !== id && !(0, _utils.isColumnFixed)(column);
        });
        order.splice(newIndex, 0, id);
        dispatch(setColumnsOrder(fixed.concat(order)));
    };
};

var beforeOpen = exports.beforeOpen = function beforeOpen() {
    return function (dispatch, getState) {
        var order = (0, _selectors.getOrderedColumns)(getState());
        var shown = (0, _selectors.getShownColumns)(getState());
        var shownSet = (0, _atUtils.arrayToSet)(shown);
        var isSummaryRowShown = (0, _selectors.getIsSummaryRowShown)(getState());
        dispatch(setColumnsOrder(order));
        dispatch(setSelected(shownSet));
        dispatch((0, _reduxActions.createAction)(ActionTypes.IS_SUMMARY_ROW_SHOWN_SET)(isSummaryRowShown));
    };
};

var saveChanges = exports.saveChanges = function saveChanges() {
    return function (dispatch, getState) {
        var state = getState();

        dispatch(restoreAndSetTableColumnsOrder());
        var selectedMap = (0, _selectors2.getSelectedColumns)(state);

        dispatch((0, _actions.setColumnsShown)(Object.keys(selectedMap)));
        dispatch((0, _actions.setIsSummaryRowShown)((0, _selectors2.getIsSummaryRowShown)(state)));
        dispatch(afterClose());

        if ((0, _utils.isSortByColumnUnavailable)((0, _selectors.getTasksSorting)(state), selectedMap)) {
            //change sorting, reload tasks and save settings
            dispatch((0, _actions.changeTasksSortingAction)(_constants.TaskTableDefaultSorting));
        } else {
            //save settings only without reloading tasks
            dispatch((0, _actions2.savePageSettings)());
        }
    };
};

var afterClose = exports.afterClose = function afterClose() {
    return function (dispatch) {
        dispatch(setSelected({}));
        dispatch(setColumnsOrder([]));
        dispatch(setIsSummaryRowShown(false));
    };
};

var restoreAndSetTableColumnsOrder = exports.restoreAndSetTableColumnsOrder = function restoreAndSetTableColumnsOrder() {
    return function (dispatch, getState) {
        var state = getState();
        var filteredOrder = (0, _selectors2.getColumnsOrder)(state);
        var tableColumns = [].concat(_toConsumableArray((0, _selectors.getOrderedColumns)(state)));

        var selectorOrderIndex = 0;
        for (var i = 0; i < tableColumns.length; i++) {
            tableColumns[i] = filteredOrder[selectorOrderIndex++];
        }

        dispatch((0, _actions.setColumnsOrder)(tableColumns));
    };
};

/***/ }),
/* 1855 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _redux = __webpack_require__(7);

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _utils = __webpack_require__(6);

var _ClassicBridge = __webpack_require__(18);

var _ClassicBridge2 = _interopRequireDefault(_ClassicBridge);

var _selectors = __webpack_require__(27);

var _actions = __webpack_require__(55);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AddFiltersContainer = function (_TemplateView) {
    _inherits(AddFiltersContainer, _TemplateView);

    function AddFiltersContainer(_ref) {
        var setSelectedFilterKeys = _ref.setSelectedFilterKeys;

        _classCallCheck(this, AddFiltersContainer);

        var _this = _possibleConstructorReturn(this, (AddFiltersContainer.__proto__ || Object.getPrototypeOf(AddFiltersContainer)).call(this));

        _this.state = {
            availableFilters: [],
            selectedFilterKeys: []
        };

        _this.actions = {
            setSelectedFilterKeys: setSelectedFilterKeys
        };

        _this.onStatePropertyChanged('availableFilters', function (availableFilters) {
            _this.addFilters.setProps({
                fields: availableFilters
            });
        });

        _this.onStatePropertyChanged('selectedFilterKeys', function (selectedFilterKeys) {
            _this.addFilters.setProps({
                selectedFieldKeys: selectedFilterKeys
            });
        });
        return _this;
    }

    _createClass(AddFiltersContainer, [{
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='taskAddFilters'></div>";
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            this.addFilters = _ClassicBridge2.default.integrateAddFilters(this.$el[0], {
                fields: this.state.availableFilters,
                selectedFieldKeys: this.state.selectedFilterKeys,
                onApply: this.actions.setSelectedFilterKeys
            });

            this.renderInitialState();
        }
    }]);

    return AddFiltersContainer;
}(_TemplateView3.default);

exports.default = (0, _utils.connect)(function (state) {
    return {
        availableFilters: (0, _selectors.getAvailableFilters)(state),
        selectedFilterKeys: (0, _selectors.getSelectedFilterKeys)(state)
    };
}, function (dispatch) {
    return {
        setSelectedFilterKeys: (0, _redux.bindActionCreators)(_actions.setSelectedFilterKeys, dispatch)
    };
})(AddFiltersContainer);

/***/ }),
/* 1856 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _redux = __webpack_require__(7);

var _utils = __webpack_require__(6);

var _View2 = __webpack_require__(20);

var _View3 = _interopRequireDefault(_View2);

var _BulkOperationsPanel = __webpack_require__(1857);

var _BulkOperationsPanel2 = _interopRequireDefault(_BulkOperationsPanel);

var _AnimatedVisibilityContainer = __webpack_require__(1858);

var _AnimatedVisibilityContainer2 = _interopRequireDefault(_AnimatedVisibilityContainer);

var _selectors = __webpack_require__(367);

var _actions = __webpack_require__(55);

var _actions2 = __webpack_require__(366);

var _constants = __webpack_require__(452);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _LoadingContainer = __webpack_require__(28);

var _LoadingContainer2 = _interopRequireDefault(_LoadingContainer);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _DeleteTasksConfirmationDialog = __webpack_require__(777);

var _DeleteTasksConfirmationDialog2 = _interopRequireDefault(_DeleteTasksConfirmationDialog);

var _DialogWithPointerWrapper = __webpack_require__(1859);

var _DialogWithPointerWrapper2 = _interopRequireDefault(_DialogWithPointerWrapper);

var _AssignTasksToDialog = __webpack_require__(1860);

var _AssignTasksToDialog2 = _interopRequireDefault(_AssignTasksToDialog);

var _ChangeTasksStatusDialog = __webpack_require__(1861);

var _ChangeTasksStatusDialog2 = _interopRequireDefault(_ChangeTasksStatusDialog);

var _constants2 = __webpack_require__(62);

var _selectors2 = __webpack_require__(27);

var _MoveToDialog = __webpack_require__(371);

var _MoveToDialog2 = _interopRequireDefault(_MoveToDialog);

var _InformationBlock = __webpack_require__(295);

var _InformationBlock2 = _interopRequireDefault(_InformationBlock);

var _selectors3 = __webpack_require__(19);

var _actions3 = __webpack_require__(194);

var _keyHandlers = __webpack_require__(48);

var _selectors4 = __webpack_require__(15);

var _CopySettingsBlock = __webpack_require__(296);

var _CopySettingsBlock2 = _interopRequireDefault(_CopySettingsBlock);

var _utils2 = __webpack_require__(297);

var _selectors5 = __webpack_require__(106);

var _constants3 = __webpack_require__(4);

var _MoveToArchivedConfirmationDialog = __webpack_require__(501);

var _MoveToArchivedConfirmationDialog2 = _interopRequireDefault(_MoveToArchivedConfirmationDialog);

var _selectors6 = __webpack_require__(57);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Container = function (_View) {
    _inherits(Container, _View);

    function Container(_ref) {
        var $pageEl = _ref.$pageEl,
            $dialogsContainerEl = _ref.$dialogsContainerEl,
            $containerEl = _ref.$containerEl,
            _ref$clearTaskSelecti = _ref.clearTaskSelectionAction,
            clearTaskSelectionAction = _ref$clearTaskSelecti === undefined ? function () {} : _ref$clearTaskSelecti,
            _ref$loadExistingTask = _ref.loadExistingTaskIdsCountAction,
            loadExistingTaskIdsCountAction = _ref$loadExistingTask === undefined ? function () {} : _ref$loadExistingTask,
            _ref$startBulkTasksDe = _ref.startBulkTasksDeleteAction,
            startBulkTasksDeleteAction = _ref$startBulkTasksDe === undefined ? function () {} : _ref$startBulkTasksDe,
            _ref$startBulkMoveAct = _ref.startBulkMoveAction,
            startBulkMoveAction = _ref$startBulkMoveAct === undefined ? function () {} : _ref$startBulkMoveAct,
            _ref$moveTasksAction = _ref.moveTasksAction,
            moveTasksAction = _ref$moveTasksAction === undefined ? function () {} : _ref$moveTasksAction,
            _ref$startBulkCopyOpe = _ref.startBulkCopyOperation,
            startBulkCopyOperation = _ref$startBulkCopyOpe === undefined ? function () {} : _ref$startBulkCopyOpe,
            _ref$copyTasksAction = _ref.copyTasksAction,
            copyTasksAction = _ref$copyTasksAction === undefined ? function () {} : _ref$copyTasksAction,
            _ref$deleteTasksActio = _ref.deleteTasksAction,
            deleteTasksAction = _ref$deleteTasksActio === undefined ? function () {} : _ref$deleteTasksActio,
            _ref$startBulkAssignA = _ref.startBulkAssignAction,
            startBulkAssignAction = _ref$startBulkAssignA === undefined ? function () {} : _ref$startBulkAssignA,
            _ref$startBulkChangeT = _ref.startBulkChangeTasksStatusAction,
            startBulkChangeTasksStatusAction = _ref$startBulkChangeT === undefined ? function () {} : _ref$startBulkChangeT,
            _ref$changeTasksStatu = _ref.changeTasksStatusAction,
            changeTasksStatusAction = _ref$changeTasksStatu === undefined ? function () {} : _ref$changeTasksStatu,
            _ref$changeTasksAssig = _ref.changeTasksAssignmentsAction,
            changeTasksAssignmentsAction = _ref$changeTasksAssig === undefined ? function () {} : _ref$changeTasksAssig,
            _ref$cleanupDialogsDa = _ref.cleanupDialogsDataAction,
            cleanupDialogsDataAction = _ref$cleanupDialogsDa === undefined ? function () {} : _ref$cleanupDialogsDa,
            _ref$setBulkOperation = _ref.setBulkOperationsPanelShownStateAction,
            setBulkOperationsPanelShownStateAction = _ref$setBulkOperation === undefined ? function () {} : _ref$setBulkOperation,
            _ref$changeBulkAssign = _ref.changeBulkAssignDialogSelection,
            changeBulkAssignDialogSelection = _ref$changeBulkAssign === undefined ? function () {} : _ref$changeBulkAssign;

        _classCallCheck(this, Container);

        var _this = _possibleConstructorReturn(this, (Container.__proto__ || Object.getPrototypeOf(Container)).call(this, null));

        _this._handleMoveTo = function (customer, project) {
            if (project.archived && _this.state.moveDialogData.includeOpenTasks) {
                _this.moveToDialog.hide();

                var canRestore = customer.archived ? !!_this.state.editableCustomersIds[customer.id] : !!_this.state.editableProjectsIds[project.id];
                _this.archivingConfirmation.setState({
                    customer: customer,
                    project: project,
                    withRestoreOption: canRestore,
                    completeOptionSelected: true,
                    workflowStatusId: _this.state.defaultCompletedStatus.id,
                    showRestoreNote: customer.archived && project.archived
                });
                _this.archivingConfirmation.show();
            } else {
                var moveType = project.archived ? _constants3.BulkMoveTypes.ARCHIVED_TO_ARCHIVED : _constants3.BulkMoveTypes.TO_OPEN;
                _this.actions.moveTasksAction(customer, project, moveType, null);
            }
        };

        _this._handleOnDeleteClick = function ($btn) {
            _this.actions.startBulkTasksDeleteAction(function () {
                _this.deleteTasksDialog.setState(_extends({}, _this.state.deleteDialogData, {
                    saving: false
                }));
                _this.deleteTasksDialog.show($btn);
            });
        };

        _this._handleOnChangeStatusClick = function ($btn) {
            _this.actions.startBulkChangeTasksStatusAction(function () {
                _this.changeTasksStatusDialog.setState(_extends({}, _this.state.changeStatusDialogData, {
                    selectedWorkflowStatusId: _this.state.changeStatusDialogData.defaultWorkflowStatusId,
                    saving: false
                }));
                _this.changeTasksStatusDialog.show($btn);
            });
        };

        _this._handleOnAssignToClick = function ($btn) {
            _this.actions.startBulkAssignAction(function () {
                _this.assignToDialog.setState(_extends({}, _this.state.assignToDialogData, {
                    saving: false
                }));
                _this.assignToDialog.show($btn);
            });
        };

        _this._handleOnMoveToClick = function ($btn) {
            _this.actions.startBulkMoveAction(function () {
                _this._updateMoveToDialogData();
                _this.moveTasksDialog.show($btn);
            });
        };

        _this._handleOnCopyToClick = function ($btn) {
            _this.actions.startBulkCopyOperation();
            _this._updateCopyToDialogData();
            _this.copyTasksDialog.show($btn);
        };

        _this._toggleOnEscHandler = function () {
            var install = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            if (_this.onKeyDownRemover) _this.onKeyDownRemover();

            if (install) {
                _this.onKeyDownRemover = _keyHandlers.KEY_HANDLERS.onKeyDown(function (e) {
                    if ((0, _keyHandlers.isEsc)(e)) {
                        _this._handleEscOnPanel();
                        return true;
                    }
                });
            }
        };

        _this._handleEscOnPanel = function () {
            _this.actions.clearTaskSelectionAction();
            _this.archivingConfirmation.hide();
        };

        _this._handleOperationDialogs = function (state, prevState) {
            var currentOperation = state.currentOperation;

            var prevOperation = prevState.currentOperation;

            if (currentOperation !== null) {
                if (currentOperation === _constants.BulkOperationType.DELETE) {
                    _this.deleteTasksDialog.setState(_extends({}, state.deleteDialogData, {
                        saving: state.operationProcessing
                    }));
                }
                if (currentOperation === _constants.BulkOperationType.CHANGE_ASSIGNMENTS) {
                    _this.assignToDialog.setState(_extends({}, state.assignToDialogData, {
                        saving: state.operationProcessing,
                        loggedInUserId: state.loggedInUserId
                    }));
                }
                if (currentOperation === _constants.BulkOperationType.CHANGE_STATUS) {
                    _this.changeTasksStatusDialog.setState(_extends({}, state.changeStatusDialogData, {
                        saving: state.operationProcessing
                    }));
                }
                if (currentOperation === _constants.BulkOperationType.MOVE) {
                    _this._updateMoveToDialogData();
                }
                if (currentOperation === _constants.BulkOperationType.COPY) {
                    _this._updateCopyToDialogData();
                }
            } else {
                if (prevOperation === _constants.BulkOperationType.DELETE) {
                    _this.deleteTasksDialog.hide();
                }
                if (prevOperation === _constants.BulkOperationType.CHANGE_ASSIGNMENTS) {
                    _this.assignToDialog.hide();
                }
                if (prevOperation === _constants.BulkOperationType.CHANGE_STATUS) {
                    _this.changeTasksStatusDialog.hide();
                }
                if (prevOperation === _constants.BulkOperationType.MOVE) {
                    _this.moveTasksDialog.hide();
                }
                if (prevOperation === _constants.BulkOperationType.COPY) {
                    _this.copyTasksDialog.hide();
                }
            }
        };

        _this.state = {
            existingTasksCount: 0,
            selectedTasksCount: 0,

            loading: false,
            showPanel: false,

            operationProcessing: false,
            currentOperation: null,
            deleteDialogData: {
                loading: false,
                defaultWorkflowStatusId: -1
            },
            assignToDialogData: {
                loading: false,
                numberOfTasks: 0,
                canModifyAny: true,
                timeZoneGroups: [],
                timeZoneGroupsEnabled: false,
                userGroups: [],
                userGroupsEnabled: false,
                users: [],
                selectedUserIds: [],
                userRatesEnabled: false,
                billingTypesEnabled: false
            },
            changeStatusDialogData: {
                loading: false
            },
            moveDialogData: {
                loading: false,
                taskIds: [],
                notAvailableToMoveTasks: [],
                includeOpenTasks: true
            },
            copyDialogTaskIds: [],

            recentlyCreatedTaskIds: {},
            moveAndCopySelectorsCustomerIds: {},
            moveAndCopySelectorsProjectIds: {},
            noTeamAccess: false,
            loggedInUserId: -1,

            isWASEnabled: false,
            isBTYEnabled: false,
            isESTEnabled: false,
            isTWSEnabled: false,

            editableCustomersIds: {},
            editableProjectsIds: {},

            canManageAccountsAndPermissions: false,
            canEditTaskStatus: true,
            hasSomeTeamAssignment: false,

            defaultCompletedStatus: {}
        };

        _this.params = {
            $pageEl: $pageEl,
            $dialogsContainerEl: $dialogsContainerEl,
            $containerEl: $containerEl
        };

        _this.actions = {
            clearTaskSelectionAction: clearTaskSelectionAction,
            loadExistingTaskIdsCountAction: loadExistingTaskIdsCountAction,
            startBulkTasksDeleteAction: startBulkTasksDeleteAction,
            startBulkMoveAction: startBulkMoveAction,
            moveTasksAction: moveTasksAction,
            startBulkCopyOperation: startBulkCopyOperation,
            copyTasksAction: copyTasksAction,
            deleteTasksAction: deleteTasksAction,
            startBulkAssignAction: startBulkAssignAction,
            startBulkChangeTasksStatusAction: startBulkChangeTasksStatusAction,
            changeTasksStatusAction: changeTasksStatusAction,
            changeTasksAssignmentsAction: changeTasksAssignmentsAction,
            cleanupDialogsDataAction: cleanupDialogsDataAction,
            setBulkOperationsPanelShownStateAction: setBulkOperationsPanelShownStateAction,
            changeBulkAssignDialogSelection: changeBulkAssignDialogSelection
        };

        _this.onStatePropertyChanged('loading', function (loading) {
            _this.bulkOperationsPanelContainer.setState({
                loading: loading
            });
        });

        _this.onStatePropertyChanged('isWASEnabled', function (wasFeatureEnabled) {
            _this.bulkOperationsPanelContainer.setState({
                assignToButtonVisible: wasFeatureEnabled
            });

            _this._updateDialogsInfo();
        });

        _this.onStatePropertyChanged('showPanel', function (show, prevShow) {
            _this.bulkOperationsPanelContainer.setState({
                visible: show
            });

            if (prevShow !== show) {
                // is show add handler if hide - only remove
                _this._toggleOnEscHandler(show);
                if (!show) {
                    _this.actions.cleanupDialogsDataAction();
                }
            }
        });

        // handle counters after handling `showPanel`
        _this.onAnyStatePropertyChanged(['selectedTasksCount', 'existingTasksCount'], function (state) {
            var selectedTasksCount = state.selectedTasksCount,
                existingTasksCount = state.existingTasksCount;

            _this.bulkOperationsPanelContainer.setState({
                empty: existingTasksCount === 0,
                selectedTasksCount: selectedTasksCount,
                existingTasksCount: existingTasksCount
            });
        });

        _this.onAnyStatePropertyChanged(['moveAndCopySelectorsProjectIds', 'moveAndCopySelectorsCustomerIds'], function (state) {
            _this.moveToDialog.setCustomersToMove(state.moveAndCopySelectorsCustomerIds);
            _this.moveToDialog.setProjectsToMove(state.moveAndCopySelectorsProjectIds);
            _this.copyToDialog.setCustomersToMove(state.moveAndCopySelectorsCustomerIds);
            _this.copyToDialog.setProjectsToMove(state.moveAndCopySelectorsProjectIds);
        });

        _this.onAnyStatePropertyChanged(['canManageAccountsAndPermissions', 'isBTYEnabled', 'isESTEnabled', 'isTWSEnabled', 'isWASEnabled', 'hasSomeTeamAssignment'], function () {
            _this.copySettingsBlock.setState((0, _utils2.getItemsForCopyTaskSettingsBlock)(_this.state.canManageAccountsAndPermissions, _this.state.isBTYEnabled, _this.state.isESTEnabled, _this.state.isTWSEnabled, _this.state.isWASEnabled, _this.state.hasSomeTeamAssignment));
        });

        _this.onStatePropertyChanged('isTWSEnabled', function (isTWSEnabled) {
            return _this.archivingConfirmation.setState({
                isTWSEnabled: isTWSEnabled,
                archiveText: isTWSEnabled ? _messageResource2.default.getMessage('task.list.move_to.bulk.confirm_archive.complete_with_status') : _messageResource2.default.getMessage('task.list.move_to.bulk.confirm_archive.complete_feature_disabled')
            });
        });

        _this.onStatePropertyDeeplyChanged('noTeamAccess', function (noTeamAccess) {
            _this.bulkOperationsPanelContainer.setState({
                assignToButtonDisabled: noTeamAccess
            });
        });

        _this.onStatePropertyChanged('canEditTaskStatus', function (canEditTaskStatus) {
            _this.bulkOperationsPanelContainer.setState({
                changeStatusButtonVisible: canEditTaskStatus
            });

            _this.archivingConfirmation.setState({
                canEditTaskStatus: canEditTaskStatus
            });
        });

        _this.onStateChanged(function (state, prevState) {
            _this._handleOperationDialogs(state, prevState);
        });
        return _this;
    }

    _createClass(Container, [{
        key: 'init',
        value: function init() {
            var _this2 = this;

            _get(Container.prototype.__proto__ || Object.getPrototypeOf(Container.prototype), 'init', this).call(this, this.params.$containerEl);

            this.bulkOperationsPanel = new _BulkOperationsPanel2.default({
                onChangeStatusClick: this._handleOnChangeStatusClick,
                onDeleteClick: this._handleOnDeleteClick,
                onClearSelectionClick: this.actions.clearTaskSelectionAction,
                onAssignToClick: this._handleOnAssignToClick,
                onMoveToClick: this._handleOnMoveToClick,
                onCopyToClick: this._handleOnCopyToClick
            });

            this.bulkOperationsPanelContainer = new _AnimatedVisibilityContainer2.default({
                $containerEl: this.params.$containerEl,
                containerClass: "tasklist_components_bulkOperationsPanelContainer",
                showAnimationClass: _constants2.SHOW_ANIMATION_CLASSES.SLIDE_UP,
                hideAnimationClass: _constants2.HIDE_ANIMATION_CLASSES.SLIDE_UP,
                contentComponent: new _LoadingContainer2.default({
                    showAnimated: false,
                    hideAnimated: false,
                    contentComponent: this.bulkOperationsPanel
                }),
                onShowCb: function onShowCb() {
                    return _this2.actions.setBulkOperationsPanelShownStateAction(true);
                },
                onHideCb: function onHideCb() {
                    return _this2.actions.setBulkOperationsPanelShownStateAction(false);
                }
            }).init();

            this.deleteTasksDialog = new _DialogWithPointerWrapper2.default(this.params.$dialogsContainerEl, this.params.$pageEl, {
                className: 'deleteDialog',
                dialog: new _DeleteTasksConfirmationDialog2.default(null, function () {
                    return _this2.deleteTasksDialog.hide();
                }, this.actions.deleteTasksAction),
                dialogType: _constants.BulkOperationType.DELETE
            }).init();

            this.assignToDialog = new _DialogWithPointerWrapper2.default(this.params.$dialogsContainerEl, this.params.$pageEl, {
                className: "assignToDialog tasksChangeDialog",
                dialog: new _AssignTasksToDialog2.default({
                    $containerElement: (0, _jquery2.default)(".assignToDialog .content"),
                    cancelHandler: function cancelHandler() {
                        _this2.assignToDialog.hide();
                    },
                    submitHandler: function submitHandler(userIds) {
                        _this2.actions.changeTasksAssignmentsAction(userIds);
                    },
                    selectionChangedCb: function selectionChangedCb(addedUserIds, removedUserIds) {
                        _this2.actions.changeBulkAssignDialogSelection(addedUserIds, removedUserIds);
                    }
                }),
                dialogType: _constants.BulkOperationType.CHANGE_ASSIGNMENTS
            }).init();

            this.changeTasksStatusDialog = new _DialogWithPointerWrapper2.default(this.params.$dialogsContainerEl, this.params.$pageEl, {
                className: "changeTasksStatusDialog tasksChangeDialog",
                dialog: new _ChangeTasksStatusDialog2.default({
                    $containerElement: (0, _jquery2.default)(".changeTasksStatusDialog .content"),
                    defaultWorkflowStatusId: -1,
                    cancelHandler: function cancelHandler() {
                        _this2.changeTasksStatusDialog.hide();
                    },
                    submitHandler: function submitHandler(workflowStatusId) {
                        _this2.actions.changeTasksStatusAction(workflowStatusId);
                    }
                }),
                dialogType: _constants.BulkOperationType.CHANGE_STATUS
            }).init();

            this._initMoveTasksDialog();
            this._initCopyTasksDialog();
        }
    }, {
        key: '_initMoveTasksDialog',
        value: function _initMoveTasksDialog() {
            var _this3 = this;

            this.moveTaskDialogInfoBlock = new _InformationBlock2.default({
                title: _messageResource2.default.getMessage('task.list.move_to.task.info_title')
            });

            this.moveToDialog = new _MoveToDialog2.default({
                mode: _MoveToDialog2.default.Mode.CUSTOMER_PROJECT,
                titleMessageKey: "task.list.move_to.task.title",
                buttonMessageKey: "edit_panel.action.move",
                onMoveCb: this._handleMoveTo,
                onCancelCb: function onCancelCb() {
                    return _this3.moveTasksDialog.hide();
                },
                infoBlock: this.moveTaskDialogInfoBlock
            });
            this.moveToDialog.setState({ showArchived: true });

            this.moveTasksDialog = new _DialogWithPointerWrapper2.default(this.params.$dialogsContainerEl, this.params.$pageEl, {
                className: 'moveDialog',
                dialog: this.moveToDialog,
                dialogType: _constants.BulkOperationType.MOVE
            }).init();

            this._initMoveToArchiveConfirmationDialog();
        }
    }, {
        key: '_initMoveToArchiveConfirmationDialog',
        value: function _initMoveToArchiveConfirmationDialog() {
            var _this4 = this;

            this.archivingConfirmation = new _MoveToArchivedConfirmationDialog2.default({
                canEditTaskStatus: this.state.canEditTaskStatus,
                confirmCallback: function confirmCallback(_ref2) {
                    var customer = _ref2.customer,
                        project = _ref2.project,
                        withRestore = _ref2.withRestore,
                        workflowStatusId = _ref2.workflowStatusId;

                    _this4.archivingConfirmation.hide();
                    var moveType = withRestore ? _constants3.BulkMoveTypes.OPEN_TO_ARCHIVED_WITH_RESTORE : _constants3.BulkMoveTypes.OPEN_TO_ARCHIVED_WITH_COMPLETION;
                    _this4.actions.moveTasksAction(customer, project, moveType, workflowStatusId);
                },
                cancelCallback: function cancelCallback() {
                    _this4.archivingConfirmation.hide();
                    var moveToDialogState = _this4.moveToDialog.getState();
                    _this4.moveToDialog.show();
                    _this4.moveToDialog.setState(moveToDialogState);
                },
                initStatusMenuTo: (0, _jquery2.default)('body')
            }).init(this.moveTasksDialog.getEl().find(".content"));
            this.archivingConfirmation.setState({
                workflowStatusId: this.state.defaultCompletedStatus.id,
                withRestoreOption: true,
                title: _messageResource2.default.getMessage("task.list.move_to.bulk.confirm_archive.title"),
                singleOptionDescription: _messageResource2.default.getMessage("task.list.move_to.bulk.confirm_archive.description.single_option"),
                multiOptionDescription: _messageResource2.default.getMessage("task.list.move_to.bulk.confirm_archive.description.multi_option"),
                archiveText: this.state.isTWSEnabled ? _messageResource2.default.getMessage('task.list.move_to.bulk.confirm_archive.complete_with_status') : _messageResource2.default.getMessage('task.list.move_to.bulk.confirm_archive.complete_feature_disabled'),
                restoreText: _messageResource2.default.getMessage("task.list.move_to.bulk.confirm_archive.restore.project")
            });
            this.archivingConfirmation.hide();
        }
    }, {
        key: '_initCopyTasksDialog',
        value: function _initCopyTasksDialog() {
            var _this5 = this;

            this.copySettingsBlock = new _CopySettingsBlock2.default(_extends({}, (0, _utils2.getItemsForCopyTaskSettingsBlock)(this.state.canManageAccountsAndPermissions, this.state.isBTYEnabled, this.state.isESTEnabled, this.state.isTWSEnabled, this.state.isWASEnabled, this.state.hasSomeTeamAssignment)));

            this.copyTasksDialogInfoBlock = new _InformationBlock2.default();

            this.copyToDialog = new _MoveToDialog2.default({
                mode: _MoveToDialog2.default.Mode.CUSTOMER_PROJECT,
                titleMessageKey: "task.list.copy_to.task.title",
                buttonMessageKey: "edit_panel.action.copy",
                onMoveCb: function onMoveCb(customer, project, settings) {
                    return _this5.actions.copyTasksAction(_this5.state.copyDialogTaskIds, project.id, settings);
                },
                onCancelCb: function onCancelCb() {
                    return _this5.copyTasksDialog.hide();
                },
                infoBlock: this.copyTasksDialogInfoBlock,
                settingsBlock: this.copySettingsBlock
            });

            this.copyTasksDialog = new _DialogWithPointerWrapper2.default(this.params.$dialogsContainerEl, this.params.$pageEl, {
                className: 'copyDialog',
                dialog: this.copyToDialog,
                dialogType: _constants.BulkOperationType.COPY
            }).init();
        }
    }, {
        key: '_updateDialogsInfo',
        value: function _updateDialogsInfo() {
            this.moveTaskDialogInfoBlock.setState({
                paragraphs: [_messageResource2.default.getMessage(this.state.isWASEnabled ? 'task.list.move_to.task.info_paragraph1' : 'task.list.move_to.task.info_paragraph1_was_off'), _messageResource2.default.getMessage(this.state.isWASEnabled ? 'task.list.move_to.task.info_paragraph2' : 'task.list.move_to.task.info_paragraph2_was_off')]
            });

            this.copyTasksDialogInfoBlock.setState({
                paragraphs: [_messageResource2.default.getMessage(this.state.isWASEnabled ? 'task.list.copy_to.bulk.info_paragraph' : 'task.list.copy_to.bulk.info_paragraph_was_off')]
            });
        }
    }, {
        key: '_updateMoveToDialogData',
        value: function _updateMoveToDialogData() {
            this.archivingConfirmation.hide();
            this.moveToDialog.setLoading(this.state.moveDialogData.loading);
            var numberOfTasks = this.state.moveDialogData.taskIds.length;
            this.moveToDialog.updateTitle(numberOfTasks === 1 ? _messageResource2.default.getMessage("task.list.move_to.bulk.title.move_task") : _messageResource2.default.getMessage("task.list.move_to.bulk.title.move_tasks", [numberOfTasks]));
            this.moveToDialog.updateNotAvailableTasks(this.state.moveDialogData.notAvailableToMoveTasks);
        }
    }, {
        key: '_updateCopyToDialogData',
        value: function _updateCopyToDialogData() {
            var numberOfTasks = this.state.copyDialogTaskIds.length;
            this.copyToDialog.updateTitle(numberOfTasks === 1 ? _messageResource2.default.getMessage("task.list.copy_to.bulk.title.copy_task") : _messageResource2.default.getMessage("task.list.copy_to.bulk.title.copy_tasks", [numberOfTasks]));
        }
    }]);

    return Container;
}(_View3.default);

exports.default = (0, _utils.connect)(function (state) {
    return _extends({}, (0, _selectors.getBulkOperationsPanelState)(state), {
        showPanel: (0, _selectors.isShowPanel)(state),
        operationProcessing: (0, _selectors.isProcessingBulkOperation)(state),
        deleteDialogData: (0, _selectors.getBulkTaskDeleteDialogData)(state),
        currentOperation: (0, _selectors.getCurrentOperation)(state),
        assignToDialogData: (0, _selectors.getBulkAssignDialogData)(state),
        moveDialogData: (0, _selectors.getBulkMoveDialogData)(state),
        copyDialogTaskIds: (0, _selectors5.getSelectedTaskIdsArray)(state),
        changeStatusDialogData: (0, _selectors.getBulkChangeStatusDialogData)(state),
        recentlyCreatedTaskIds: (0, _selectors2.getRecentlyCreatedTaskIds)(state),
        moveAndCopySelectorsCustomerIds: (0, _selectors2.getCustomerIdsWhereCanManageLeastOneProject)(state),
        moveAndCopySelectorsProjectIds: (0, _selectors2.getEditableProjectIdsWithExcludeSelf)(state),
        noTeamAccess: (0, _selectors2.isViewerHasNoTeamAccess)(state),
        loggedInUserId: (0, _selectors3.getLoggedInUserId)(state),
        isWASEnabled: (0, _selectors4.isWASEnabled)(state),
        isBTYEnabled: (0, _selectors4.isBTYEnabled)(state),
        isTWSEnabled: (0, _selectors4.isTWSEnabled)(state),
        isESTEnabled: (0, _selectors4.isESTEnabled)(state),
        canManageAccountsAndPermissions: (0, _selectors3.canManageAccountsAndPermissions)(state),
        canEditTaskStatus: (0, _selectors2.canViewerEditTaskStatus)(state),
        hasSomeTeamAssignment: (0, _selectors3.canAccessSomeTeamAssignment)(state),
        editableCustomersIds: (0, _selectors2.getEditableCustomerIds)(state),
        editableProjectsIds: (0, _selectors2.getEditableProjectIds)(state),
        defaultCompletedStatus: (0, _selectors6.getFirstCompletedWorkflowStatus)(state)
    });
}, function (dispatch) {
    return {
        clearTaskSelectionAction: (0, _redux.bindActionCreators)(_actions3.clearTaskSelectionAction, dispatch),
        loadExistingTaskIdsCountAction: (0, _redux.bindActionCreators)(_actions3.loadExistingTaskIdsAction, dispatch),
        startBulkTasksDeleteAction: (0, _redux.bindActionCreators)(_actions2.startBulkTasksDeleteAction, dispatch),
        deleteTasksAction: (0, _redux.bindActionCreators)(_actions2.deleteTasksAction, dispatch),
        startBulkMoveAction: (0, _redux.bindActionCreators)(_actions2.startBulkMoveAction, dispatch),
        moveTasksAction: (0, _redux.bindActionCreators)(_actions2.moveTasksAction, dispatch),
        startBulkCopyOperation: (0, _redux.bindActionCreators)(_actions2.startBulkCopyOperation, dispatch),
        copyTasksAction: (0, _redux.bindActionCreators)(_actions2.copyTasksAction, dispatch),
        startBulkAssignAction: (0, _redux.bindActionCreators)(_actions2.startBulkAssignAction, dispatch),
        startBulkChangeTasksStatusAction: (0, _redux.bindActionCreators)(_actions2.startBulkChangeTasksStatusAction, dispatch),
        changeTasksStatusAction: (0, _redux.bindActionCreators)(_actions2.changeTasksStatusAction, dispatch),
        changeTasksAssignmentsAction: (0, _redux.bindActionCreators)(_actions2.changeTasksAssignmentsAction, dispatch),
        cleanupDialogsDataAction: (0, _redux.bindActionCreators)(_actions2.cleanupDialogsDataAction, dispatch),
        setBulkOperationsPanelShownStateAction: (0, _redux.bindActionCreators)(_actions.setBulkOperationsPanelShownState, dispatch),
        changeBulkAssignDialogSelection: (0, _redux.bindActionCreators)(_actions2.changeBulkAssignDialogSelection, dispatch)
    };
})(Container);

/***/ }),
/* 1857 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _utils = __webpack_require__(25);

var _constants = __webpack_require__(452);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _SimpleTooltip = __webpack_require__(36);

var _SimpleTooltip2 = _interopRequireDefault(_SimpleTooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BulkOperationsPanel = function (_TemplateView) {
    _inherits(BulkOperationsPanel, _TemplateView);

    function BulkOperationsPanel(_ref) {
        var _ref$onCopyToClick = _ref.onCopyToClick,
            onCopyToClick = _ref$onCopyToClick === undefined ? function () {} : _ref$onCopyToClick,
            _ref$onMoveToClick = _ref.onMoveToClick,
            onMoveToClick = _ref$onMoveToClick === undefined ? function () {} : _ref$onMoveToClick,
            _ref$onAssignToClick = _ref.onAssignToClick,
            onAssignToClick = _ref$onAssignToClick === undefined ? function () {} : _ref$onAssignToClick,
            _ref$onChangeStatusCl = _ref.onChangeStatusClick,
            onChangeStatusClick = _ref$onChangeStatusCl === undefined ? function () {} : _ref$onChangeStatusCl,
            _ref$onDeleteClick = _ref.onDeleteClick,
            onDeleteClick = _ref$onDeleteClick === undefined ? function () {} : _ref$onDeleteClick,
            _ref$onClearSelection = _ref.onClearSelectionClick,
            onClearSelectionClick = _ref$onClearSelection === undefined ? function () {} : _ref$onClearSelection;

        _classCallCheck(this, BulkOperationsPanel);

        var _this = _possibleConstructorReturn(this, (BulkOperationsPanel.__proto__ || Object.getPrototypeOf(BulkOperationsPanel)).call(this));

        _this._updateSelectionText = function () {
            var _this$state = _this.state,
                selectedTasksCount = _this$state.selectedTasksCount,
                existingTasksCount = _this$state.existingTasksCount;

            var all = selectedTasksCount === existingTasksCount;

            var actualText = all ? _messageResource2.default.getMessage('task.list.bulk_operations.selection_title.all', [selectedTasksCount]) : '' + selectedTasksCount;

            var of = all ? '' : _messageResource2.default.getMessage('task.list.bulk_operations.selection_title.of', [existingTasksCount]);

            var postfix = existingTasksCount === 1 ? _messageResource2.default.getMessage('task.list.bulk_operations.selection_title.singular') : _messageResource2.default.getMessage('task.list.bulk_operations.selection_title.plural');

            _this.$title.find('.actual').text(actualText);
            _this.$title.find('.existing').text(of);
            _this.$title.find('.postfix').text(postfix);
        };

        _this.onCopyToClick = onCopyToClick;
        _this.onMoveToClick = onMoveToClick;
        _this.onAssignToClick = onAssignToClick;
        _this.onChangeStatusClick = onChangeStatusClick;
        _this.onDeleteClick = onDeleteClick;
        _this.onClearSelectionClick = onClearSelectionClick;

        _this.state = {
            selectedTasksCount: 0,
            existingTasksCount: 0,
            empty: true,
            copyToButtonPressed: false,
            moveToButtonPressed: false,
            assignToButtonPressed: false,
            changeStatusButtonPressed: false,
            changeStatusButtonVisible: true,
            deleteButtonPressed: false,
            assignToButtonDisabled: false,
            assignToButtonVisible: false
        };

        _this.onStatePropertyChanged('assignToButtonVisible', function (visible) {
            return _this.$assignToButton.toggle(visible);
        });
        _this.onAnyStatePropertyChanged(['selectedTasksCount', 'existingTasksCount'], function () {
            return _this._updateSelectionText();
        });
        _this.onStatePropertyChanged("empty", function (empty) {
            return _this.$el.toggleClass("empty", empty);
        });
        _this.onStatePropertyChanged("copyToButtonPressed", function (pressed) {
            return _this._toggleButtonPressed(_this.$copyToButton, pressed);
        });
        _this.onStatePropertyChanged("moveToButtonPressed", function (pressed) {
            return _this._toggleButtonPressed(_this.$moveToButton, pressed);
        });
        _this.onStatePropertyChanged("assignToButtonPressed", function (pressed) {
            return _this._toggleButtonPressed(_this.$assignToButton, pressed);
        });
        _this.onStatePropertyChanged("changeStatusButtonPressed", function (pressed) {
            return _this._toggleButtonPressed(_this.$changeStatusButton, pressed);
        });
        _this.onStatePropertyChanged("deleteButtonPressed", function (pressed) {
            return _this._toggleButtonPressed(_this.$deleteButton, pressed);
        });
        _this.onStatePropertyChanged("assignToButtonDisabled", function (assignToButtonDisabled) {
            _this.$assignToButton.toggleClass("disable", assignToButtonDisabled);
            _this.assignToTooltip.setEnabled(assignToButtonDisabled);
        });
        _this.onStatePropertyChanged("changeStatusButtonVisible", function (visible) {
            _this.$changeStatusButton.toggle(visible);
        });
        return _this;
    }

    _createClass(BulkOperationsPanel, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return "<div class='bulkOperationsPanel'>" + "  <div class='title'>" + "    <span class='actual'></span>" + "    <span class='existing'></span>" + "    <span class='postfix'></span>" + "  </div>" + "  <div class='copyTo button'><%-copyTo%></div>" + "  <div class='moveTo button'><%-moveTo%></div>" + "  <div class='assignTo button'><%-assignTo%></div>" + "  <div class='changeStatus button'><%-changeStatus%></div>" + "  <div class='delete button'><%-deleteLabel%></div>" + "  <div class='clearSelection'><span><%-clearSelection%></span></div>" + "</div>";
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            var _this2 = this;

            this.$title = this.find(".title");
            this.$copyToButton = this.find(".copyTo").click(function (e) {
                (0, _utils.setEventPreventHiding)(e, _constants.BulkOperationType.COPY);
                _this2.onCopyToClick(_this2.$copyToButton);
            });
            this.$moveToButton = this.find(".moveTo").click(function (e) {
                (0, _utils.setEventPreventHiding)(e, _constants.BulkOperationType.MOVE);
                _this2.onMoveToClick(_this2.$moveToButton);
            });
            this.$assignToButton = this.find(".assignTo").click(function (e) {
                if (!_this2.state.assignToButtonDisabled) {
                    (0, _utils.setEventPreventHiding)(e, _constants.BulkOperationType.CHANGE_ASSIGNMENTS);
                    _this2.onAssignToClick(_this2.$assignToButton);
                }
            }).hide(); // sync with initial state

            this.$changeStatusButton = this.find(".changeStatus").click(function (e) {
                (0, _utils.setEventPreventHiding)(e, _constants.BulkOperationType.CHANGE_STATUS);
                _this2.onChangeStatusClick(_this2.$changeStatusButton);
            });
            this.$deleteButton = this.find(".delete").click(function (e) {
                (0, _utils.setEventPreventHiding)(e, _constants.BulkOperationType.DELETE);
                _this2.onDeleteClick(_this2.$deleteButton);
            });
            this.find(".clearSelection").click(function () {
                return _this2.onClearSelectionClick();
            });

            this.assignToTooltip = new _SimpleTooltip2.default({
                text: _messageResource2.default.getMessage('task.list.create_pop_up.disabled_button')
            }).init((0, _jquery2.default)('body'));
            this.assignToTooltip.subscribeToMouseEvents(this.$assignToButton);
            this.assignToTooltip.disable();
        }
    }, {
        key: 'messageKeys',
        value: function messageKeys() {
            return {
                copyTo: "task.list.bulk_operations.copy_to",
                moveTo: "task.list.bulk_operations.move_to",
                assignTo: "task.list.bulk_operations.assign_to",
                changeStatus: "task.list.bulk_operations.change_status",
                deleteLabel: "task.list.bulk_operations.delete",
                clearSelection: "task.list.bulk_operations.clear_selection"
            };
        }
    }, {
        key: '_toggleButtonPressed',
        value: function _toggleButtonPressed($button, pressed) {
            $button.toggleClass("pressed", pressed);
        }
    }]);

    return BulkOperationsPanel;
}(_TemplateView3.default);

exports.default = BulkOperationsPanel;

/***/ }),
/* 1858 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AnimatedVisibilityContainer = function (_TemplateView) {
    _inherits(AnimatedVisibilityContainer, _TemplateView);

    function AnimatedVisibilityContainer(_ref) {
        var $containerEl = _ref.$containerEl,
            contentComponent = _ref.contentComponent,
            containerClass = _ref.containerClass,
            _ref$showAnimationCla = _ref.showAnimationClass,
            showAnimationClass = _ref$showAnimationCla === undefined ? "anim-fade-in" : _ref$showAnimationCla,
            _ref$hideAnimationCla = _ref.hideAnimationClass,
            hideAnimationClass = _ref$hideAnimationCla === undefined ? "anim-fade-out" : _ref$hideAnimationCla,
            _ref$onShowCb = _ref.onShowCb,
            onShowCb = _ref$onShowCb === undefined ? function () {} : _ref$onShowCb,
            _ref$onHideCb = _ref.onHideCb,
            onHideCb = _ref$onHideCb === undefined ? function () {} : _ref$onHideCb;

        _classCallCheck(this, AnimatedVisibilityContainer);

        var _this = _possibleConstructorReturn(this, (AnimatedVisibilityContainer.__proto__ || Object.getPrototypeOf(AnimatedVisibilityContainer)).call(this, $containerEl));

        _this.state = {
            visible: false
        };

        _this.callbacks = {
            onShowCb: onShowCb,
            onHideCb: onHideCb
        };

        _this.contentComponent = contentComponent;
        _this.containerClass = containerClass;

        _this.onStatePropertyChanged("visible", function (visible) {
            if (visible) {
                _this.contentComponent.resumeHandlingStateChanges();
                _this.$el.atAnimation().showAnimated(showAnimationClass, _this.callbacks.onShowCb);
            } else {
                _this.contentComponent.stopHandlingStateChanges();
                _this.$el.atAnimation().hideAnimated(hideAnimationClass, _this.callbacks.onHideCb);
            }
        });
        return _this;
    }

    _createClass(AnimatedVisibilityContainer, [{
        key: "afterRender",
        value: function afterRender() {
            this.$el.hide();
            this.contentComponent.init(this.find(".content"));
        }
    }, {
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='animatedVisibilityContainer <%=containerClass%>'>" + "  <div class='content'></div>" + "</div>";
        }
    }, {
        key: "setState",
        value: function setState(stateChanges) {
            _get(AnimatedVisibilityContainer.prototype.__proto__ || Object.getPrototypeOf(AnimatedVisibilityContainer.prototype), "setState", this).call(this, stateChanges);
            this.contentComponent.setState(stateChanges);
        }
    }]);

    return AnimatedVisibilityContainer;
}(_TemplateView3.default);

exports.default = AnimatedVisibilityContainer;

/***/ }),
/* 1859 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _index = __webpack_require__(48);

var _atBrowserUtils = __webpack_require__(8);

var _ScrollUtils = __webpack_require__(39);

var _ScrollUtils2 = _interopRequireDefault(_ScrollUtils);

var _utils = __webpack_require__(25);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DialogWithPointerWrapper = function (_TemplateView) {
    _inherits(DialogWithPointerWrapper, _TemplateView);

    function DialogWithPointerWrapper($containerElement, $pageEl, _ref) {
        var dialog = _ref.dialog,
            className = _ref.className,
            dialogType = _ref.dialogType;

        _classCallCheck(this, DialogWithPointerWrapper);

        var _this = _possibleConstructorReturn(this, (DialogWithPointerWrapper.__proto__ || Object.getPrototypeOf(DialogWithPointerWrapper)).call(this, $containerElement));

        _this.$pageEl = $pageEl;
        _this.params = {
            dialog: dialog,
            className: className,
            dialogType: dialogType
        };
        return _this;
    }

    _createClass(DialogWithPointerWrapper, [{
        key: "templateHtml",
        value: function templateHtml() {
            return "<div class='dialogWithPointerWrapper <%=className%>'>" + "    <div class='content'></div>" + "    <div class='pointer'></div>" + "</div>";
        }
    }, {
        key: "templateModel",
        value: function templateModel() {
            return _extends({}, this.params);
        }
    }, {
        key: "init",
        value: function init(ignore) {
            if (this.$content) {
                this.$content.empty();
            }
            _get(DialogWithPointerWrapper.prototype.__proto__ || Object.getPrototypeOf(DialogWithPointerWrapper.prototype), "init", this).call(this);
            return this;
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            this.$content = this.find('.content');
            this.params.dialog.init(this.$content);
            this.$pointer = this.find('.pointer');

            this.$el.hide();
        }
    }, {
        key: "show",
        value: function show($el) {
            var _this2 = this;

            _get(DialogWithPointerWrapper.prototype.__proto__ || Object.getPrototypeOf(DialogWithPointerWrapper.prototype), "show", this).call(this);
            this.params.dialog.show();
            this._setPointerPosition($el);

            (0, _atBrowserUtils.onOutsideClick)(this.$el, this.params.dialogType, function () {
                _this2.hide();
            }, function (e) {
                return (0, _utils.shouldEventPreventHiding)(e, _this2.params.dialogType);
            }, this.$pageEl);

            this.setupKeyDownHandler();

            _ScrollUtils2.default.addVerticalScroll(this.$content);
        }
    }, {
        key: "restoreOnKeyDownHandler",
        value: function restoreOnKeyDownHandler() {
            if (this.removeHandler) this.removeHandler();
        }
    }, {
        key: "setupKeyDownHandler",
        value: function setupKeyDownHandler() {
            var _this3 = this;

            this.removeHandler = (0, _index.onKeyDown)(function (code) {
                if ((0, _index.isEsc)(code)) {
                    _this3.hide();
                    return true;
                }
            });
        }
    }, {
        key: "update",
        value: function update() {
            _get(DialogWithPointerWrapper.prototype.__proto__ || Object.getPrototypeOf(DialogWithPointerWrapper.prototype), "update", this).call(this);
            this.params.dialog.update();
        }
    }, {
        key: "hide",
        value: function hide() {
            _get(DialogWithPointerWrapper.prototype.__proto__ || Object.getPrototypeOf(DialogWithPointerWrapper.prototype), "hide", this).call(this);
            this.restoreOnKeyDownHandler();
            this.params.dialog.hide();
        }
    }, {
        key: "setState",
        value: function setState(state) {
            this.params.dialog.setState(state);
        }
    }, {
        key: "setDialog",
        value: function setDialog(dialog) {
            this.params.dialog = dialog;
        }
    }, {
        key: "_setPointerPosition",
        value: function _setPointerPosition($el) {
            var pointerOffset = $el.offset().left + $el.width() / 2 - this.$el.offset().left;
            var contentOffset = $el.offset().left + $el.width() / 2 - this.$el.offset().left - this.$el.width() / 2;

            this.$pointer.css('left', pointerOffset);
            this.$content.css('left', contentOffset);
        }
    }]);

    return DialogWithPointerWrapper;
}(_TemplateView3.default);

exports.default = DialogWithPointerWrapper;

/***/ }),
/* 1860 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _BaseTasksChangeDialog = __webpack_require__(934);

var _BaseTasksChangeDialog2 = _interopRequireDefault(_BaseTasksChangeDialog);

var _UsersSelector = __webpack_require__(498);

var _UsersSelector2 = _interopRequireDefault(_UsersSelector);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _groupUtils = __webpack_require__(71);

var _at_hierarchy_selector_dropdown_button = __webpack_require__(232);

var _at_hierarchy_selector_dropdown_button2 = _interopRequireDefault(_at_hierarchy_selector_dropdown_button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AssignTasksToDialog = function (_BaseTasksChangeDialo) {
    _inherits(AssignTasksToDialog, _BaseTasksChangeDialo);

    function AssignTasksToDialog(_ref) {
        var $containerElement = _ref.$containerElement,
            _ref$cancelHandler = _ref.cancelHandler,
            cancelHandler = _ref$cancelHandler === undefined ? function () {} : _ref$cancelHandler,
            _ref$submitHandler = _ref.submitHandler,
            submitHandler = _ref$submitHandler === undefined ? function () {} : _ref$submitHandler,
            _ref$selectionChanged = _ref.selectionChangedCb,
            selectionChangedCb = _ref$selectionChanged === undefined ? function () {} : _ref$selectionChanged;

        _classCallCheck(this, AssignTasksToDialog);

        var _this = _possibleConstructorReturn(this, (AssignTasksToDialog.__proto__ || Object.getPrototypeOf(AssignTasksToDialog)).call(this, { $containerElement: $containerElement, cancelHandler: cancelHandler, submitHandler: submitHandler }));

        _this.selectionChangedCb = selectionChangedCb;

        _this.state = _extends({}, _this.state, {
            selectedUserIds: [],
            users: [],
            userGroups: [],
            timeZoneGroups: [],
            userGroupsEnabled: false,
            timeZoneGroupsEnabled: false,
            userRatesEnabled: false,
            billingTypesEnabled: false,
            timeTrackApprovalEnabled: false,
            loggedInUserId: -1
        });

        _this.onStatePropertyChanged('selectedUserIds', function (selectedUserIds) {
            _this.$el.toggleClass('assignEnabled', selectedUserIds && selectedUserIds.length > 0);
        });

        _this.onStateChanged(function () {
            var newState = {
                selection: _this.state.selectedUserIds,
                users: _this.state.users,
                userGroups: (0, _groupUtils.addDefaultUserGroup)(_this.state.userGroups),
                timeZoneGroups: _this.state.timeZoneGroups,
                userGroupsEnabled: _this.state.userGroupsEnabled,
                timeZoneGroupsEnabled: _this.state.timeZoneGroupsEnabled,
                isURAEnabled: _this.state.userRatesEnabled,
                isBTYEnabled: _this.state.billingTypesEnabled,
                isTTAEnabled: _this.state.timeTrackApprovalEnabled,
                title: _messageResource2.default.getMessage("assign_to.tasks.users_selector.title")
            };

            if (!_this.usersSelector) {
                _this.usersSelector = new _UsersSelector2.default({
                    selectionCallback: function selectionCallback(selectorData) {
                        _this.selectionChangedCb(selectorData.addedUserIds, selectorData.removedUserIds);
                    },
                    showPermissionIcons: true,
                    canDeselectUser: function canDeselectUser(user) {
                        return user.canBeModified;
                    },
                    resetOnHide: false
                }).init();

                _this.usersSelector.setState(newState);
            } else {
                _this.usersSelector.setState(newState);
            }

            // !important hack! cause UserSelector creates new menu after state changed - need to relink button and menu
            // !don not write similar code. It's cheap solution of big problem integrating old code with react programming model
            // if button not exists or linked menu already not actual - create new button and link with actual menu
            if (!_this.chooseUserButton || _this.chooseUserButton.menu !== _this.usersSelector.menu) {
                if (_this.chooseUserButton) {
                    _this.chooseUserButton.menu = null; // because ext.js cannot destroy menu without problems
                    _this.chooseUserButton.destroy(); // delete prev button
                }
                _this.chooseUserButton = new _at_hierarchy_selector_dropdown_button2.default({
                    renderTo: _this.$el.find(".selectorContainer")[0],
                    menu: _this.usersSelector.menu
                });
                if (!_this.state.selectedUserIds) {
                    _this.chooseUserButton.setText(_messageResource2.default.getMessage("assign_to.tasks.users_selector.empty_selection_text"));
                } else {
                    _this.usersSelector.menu.panel.fireChangeEvent();
                }
            }
        });
        return _this;
    }

    _createClass(AssignTasksToDialog, [{
        key: "messageKeys",
        value: function messageKeys() {
            return {
                labelText: "assign_to.tasks.users_selector.label",
                cancelButtonText: "common.cancel",
                submitButtonText: "assign_to.tasks.assign"
            };
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            _get(AssignTasksToDialog.prototype.__proto__ || Object.getPrototypeOf(AssignTasksToDialog.prototype), "afterRender", this).call(this);
            this._updateTitleText();
        }
    }, {
        key: "onSubmit",
        value: function onSubmit() {
            if (!this.state.selectedUserIds || this.state.selectedUserIds.length === 0 || this.state.saving) return;

            this.submitHandler(this.state.selectedUserIds);
        }
    }, {
        key: "titleText",
        value: function titleText() {
            if (this.state.numberOfTasks === 1) return _messageResource2.default.getMessage("assign_to.tasks.assign_selected_task_to");
            return _messageResource2.default.getMessage("assign_to.tasks.assign_selected_tasks_to", [this.state.numberOfTasks]);
        }
    }]);

    return AssignTasksToDialog;
}(_BaseTasksChangeDialog2.default);

exports.default = AssignTasksToDialog;

/***/ }),
/* 1861 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _BaseTasksChangeDialog = __webpack_require__(934);

var _BaseTasksChangeDialog2 = _interopRequireDefault(_BaseTasksChangeDialog);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _TaskStatusButton = __webpack_require__(240);

var _TaskStatusButton2 = _interopRequireDefault(_TaskStatusButton);

var _index = __webpack_require__(22);

var _TaskStatusMenu = __webpack_require__(289);

var _TaskStatusMenu2 = _interopRequireDefault(_TaskStatusMenu);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ChangeTasksStatusDialog = function (_BaseTasksChangeDialo) {
    _inherits(ChangeTasksStatusDialog, _BaseTasksChangeDialo);

    function ChangeTasksStatusDialog(_ref) {
        var $containerElement = _ref.$containerElement,
            _ref$cancelHandler = _ref.cancelHandler,
            cancelHandler = _ref$cancelHandler === undefined ? function () {} : _ref$cancelHandler,
            submitHandler = _ref.submitHandler;

        _classCallCheck(this, ChangeTasksStatusDialog);

        var _this = _possibleConstructorReturn(this, (ChangeTasksStatusDialog.__proto__ || Object.getPrototypeOf(ChangeTasksStatusDialog)).call(this, { $containerElement: $containerElement, cancelHandler: cancelHandler, submitHandler: submitHandler }));

        _this.state = _extends({}, _this.state, {
            defaultWorkflowStatusId: -1,
            selectedWorkflowStatusId: -1,
            disabled: false
        });

        _this.onStatePropertyChanged('defaultWorkflowStatusId', function (id) {
            _this.setStateInternal({
                selectedWorkflowStatusId: id
            });
        });
        _this.onStatePropertyChanged('selectedWorkflowStatusId', function (id) {
            _this.taskStatusButton.setState({
                statusId: id
            });
        });
        return _this;
    }

    _createClass(ChangeTasksStatusDialog, [{
        key: "messageKeys",
        value: function messageKeys() {
            return {
                labelText: "change_tasks_workflow_status.label",
                cancelButtonText: "common.cancel",
                submitButtonText: "common.apply"
            };
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            var _this2 = this;

            _get(ChangeTasksStatusDialog.prototype.__proto__ || Object.getPrototypeOf(ChangeTasksStatusDialog.prototype), "afterRender", this).call(this);

            var $selectorContainer = this.$el.find('.selectorContainer');
            $selectorContainer.empty();
            this.taskStatusButton = new _TaskStatusButton2.default({
                editable: true,
                showStatusTypePrefix: (0, _index.isEnabled)(_index.Feature.TWS),
                taskStatusMenu: new _TaskStatusMenu2.default((0, _jquery2.default)('body')).init(),
                onStatusChangedCb: function onStatusChangedCb(statusId) {
                    if (_underscore2.default.isUndefined(statusId) || statusId === null) return;
                    _this2.setStateInternal({
                        selectedWorkflowStatusId: statusId
                    });
                    _this2.taskStatusButton.setState({
                        statusId: statusId
                    });
                }
            }).init($selectorContainer);

            this.taskStatusButton.setState({
                canReopenProject: true
            });
        }
    }, {
        key: "onSubmit",
        value: function onSubmit() {
            if (!this.state.selectedWorkflowStatusId || this.state.saving) return;

            this.submitHandler(this.state.selectedWorkflowStatusId);
        }
    }, {
        key: "titleText",
        value: function titleText() {
            if (this.state.numberOfTasks === 1) return _messageResource2.default.getMessage("change_tasks_workflow_status.change_status_of_selected_task");
            return _messageResource2.default.getMessage("change_tasks_workflow_status.change_status_of_selected_tasks", [this.state.numberOfTasks]);
        }
    }]);

    return ChangeTasksStatusDialog;
}(_BaseTasksChangeDialog2.default);

exports.default = ChangeTasksStatusDialog;

/***/ }),
/* 1862 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = LoadTasksFromCSVManager;

var _ProjectStore = __webpack_require__(59);

var _ProjectStore2 = _interopRequireDefault(_ProjectStore);

var _jquery_rpc = __webpack_require__(26);

var _jquery_rpc2 = _interopRequireDefault(_jquery_rpc);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _StoreUtils = __webpack_require__(531);

var _utils = __webpack_require__(192);

var _constants = __webpack_require__(4);

var _utils2 = __webpack_require__(127);

var _ClassicBridge = __webpack_require__(18);

var _ClassicBridge2 = _interopRequireDefault(_ClassicBridge);

var _utils3 = __webpack_require__(135);

var _utils4 = __webpack_require__(6);

var _actionTypes = __webpack_require__(456);

var ActionTypes = _interopRequireWildcard(_actionTypes);

var _syncCallbacks = __webpack_require__(161);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Created by evdokimov on 01.06.2016.
 */

function LoadTasksFromCSVManager() {}

LoadTasksFromCSVManager.prototype = _.create(Object.prototype, {
    init: function init(actionUrl, csvSeparator, errorCodes, errorMessages, successTaskCreationCallback, onLoadCustomersProjectsCallback, onLoadTypesOfWorkCallback, onLoadCustomFieldsCallback, errorHandler) {
        this.actionUrl = actionUrl;
        this.successTaskCreationCallback = successTaskCreationCallback;
        this.onLoadCustomersProjectsCallback = onLoadCustomersProjectsCallback;
        this.onLoadTypesOfWorkCallback = onLoadTypesOfWorkCallback;
        this.onLoadCustomFieldsCallback = onLoadCustomFieldsCallback;
        this.duplicateTaskErrorCode = 'DUPLICATE';
        this.globalErrorHandler = errorHandler;

        this.importPreviewSection = $("#importPreviewSection");
        this.resultTableContainer = $("#resultTableContainer");
        this.template = this.createTemplate();

        this.resulTasksSuccessTableLink = $("#resultTasksSuccessTableLink");
        this.resultTasksDuplicatesTableLink = $("#resultTasksDuplicatesTableLink");
        this.resulTasksErrorTableLink = $("#resultTasksErrorTableLink");
        this.errorTooltip = new TableTooltip().init("incorrectFieldTooltip");
        this.errorTooltipTextPlaceholder = $("#incorrectFieldTooltip_textPlaceholder");
        this.toImportInfoContainer = $("#toImportInfoContainer");
        this.resultInfoContainer = $("#loadTasksFromCSVPopup_resultContent");

        this.csvSeparator = csvSeparator;
        var separatorTextValue = csvSeparator == "\t" ? _messageResource2.default.getMessage("import_csv_tasks_info.text.tab_separator") : csvSeparator;
        $("#atSeparatorValue").text(separatorTextValue);

        this.encoding = "UTF-8";

        this.errorCodesMap = _.invert(errorCodes);
        this.errorCodesMessages = errorMessages;

        return this;
    },

    columnOrder: ["customer", "project", "task", "description", "typeOfWork", "deadline", "estimate", "priority"],

    getColumnNames: function getColumnNames() {
        return {
            rowId: _messageResource2.default.getMessage("import_csv_tasks.columns.row"),
            customer: _messageResource2.default.getMessage('common.Customer'),
            project: _messageResource2.default.getMessage('common.Project'),
            task: _messageResource2.default.getMessage('common.Task'),
            description: _messageResource2.default.getMessage('import_csv_tasks.columns.description'),
            deadline: _messageResource2.default.getMessage('import_csv_tasks.columns.deadline'),
            typeOfWork: _messageResource2.default.getMessage('import_csv_tasks.columns.type_of_work'),
            estimate: _messageResource2.default.getMessage('import_csv_tasks.columns.estimate'),
            priority: _messageResource2.default.getMessage('import_csv_tasks.columns.priority')
        };
    },

    getErrorDescription: function getErrorDescription() {
        var msg = _messageResource2.default.getEscapedMessage;
        var nameText = _messageResource2.default.getMessage("import_csv_tasks.error.long_field_name");
        var longMsg = function longMsg(args) {
            var text = args[3] == "description" ? args[0] : args[0] + " " + nameText;
            return _messageResource2.default.getEscapedMessage('import_csv_tasks.error.long_field', [text]) + " <span style='white-space: nowrap;'>(" + args[1] + " / " + args[2] + ")<span>";
        };

        var lowerCaseMsg = function lowerCaseMsg(key, args) {
            return _messageResource2.default.getEscapedMessage(key, [args[0].toLowerCase()]);
        };

        return {
            EMPTY_FIELD: { text: _.bind(msg, _messageResource2.default, "import_csv_tasks.error.empty_field"), width: 110 },
            TOO_LONG_FIELD: { text: longMsg, width: 150 },
            PARSE_ERROR: { text: _.bind(msg, _messageResource2.default, 'import_csv_tasks.error.parse_error'), width: 130 },
            INCORRECT: { text: _.bind(msg, _messageResource2.default, 'import_csv_tasks.error.incorrect_value'), width: 130 },
            ARCHIVED: { text: _.bind(msg, _messageResource2.default, 'import_csv_tasks.error.archived'), width: 110 },
            NOT_EXISTS: function NOT_EXISTS(columnType) {
                if (columnType === 'typeOfWork' || columnType === 'priority') {
                    return {
                        text: _.partial(lowerCaseMsg, 'import_csv_tasks.error.not_exists.system_settings'),
                        width: 165
                    };
                } else {
                    return {
                        text: _.partial(lowerCaseMsg, 'import_csv_tasks.error.not_exists'),
                        width: 170
                    };
                }
            },
            NOT_ASSIGNED: { text: _.bind(msg, _messageResource2.default, 'import_csv_tasks.error.not_assigned'), width: 120 },
            DUPLICATE: { text: _.bind(msg, _messageResource2.default, 'import_csv_tasks.error.duplicate'), width: 80 }
        };
    },

    getColumnMaxSizeErrMap: function getColumnMaxSizeErrMap() {
        return {
            customer: _constants.EntityTextLimits.MAX_CPT_NAME,
            project: _constants.EntityTextLimits.MAX_CPT_NAME,
            task: _constants.EntityTextLimits.MAX_CPT_NAME,
            description: _constants.EntityTextLimits.MAX_CPT_DESCRIPTION,
            typeOfWork: _constants.EntityTextLimits.MAX_BILLING_TYPE_NAME,
            priority: _constants.EntityTextLimits.MAX_PRIORITY_NAME
        };
    },

    isDuplicateTaskError: function isDuplicateTaskError(error) {
        return error.task == this.duplicateTaskErrorCode;
    },

    _initErrorTooltip: function _initErrorTooltip() {
        var hoverFn = _.bind(this._moveTooltip, this);
        this.resultTableContainer.hover(hoverFn, _.bind(this._hideTooltip, this));
        this.resultTableContainer.mousemove(hoverFn);
    },

    _setTooltipMessage: function _setTooltipMessage(target) {
        var errorType = target.attr("errorType");
        var columnType = target.attr("column");
        var column = this.columnNames[columnType];
        var length = target.attr("textLength");
        var maxLength = this.columnMaxSizeErrMap[columnType];
        var description = this.errorDescription[errorType];
        if (_.isFunction(description)) description = description(columnType);
        this.errorTooltipTextPlaceholder.width(description.width);
        this.errorTooltipTextPlaceholder.html(description.text([column, length, maxLength, columnType]));
    },

    _moveTooltip: function _moveTooltip(event) {
        var targetEvent = event.originalEvent.target;
        if (_.isUndefined(targetEvent)) targetEvent = event.originalEvent.srcElement;

        var target = $(targetEvent);
        if (!target.hasClass("withError")) {
            this._hideTooltip();
            return;
        }

        this._setTooltipMessage(target);
        this.errorTooltip.show();
        this.errorTooltip.move(calculateTooltipOffset(this.errorTooltip, event));
    },

    _hideTooltip: function _hideTooltip() {
        this.errorTooltip.hide();
    },

    collectRowsWithErrors: function collectRowsWithErrors(data) {
        var rowsMap = {};
        _.each(data.table, function (row) {
            rowsMap[row.rowId] = row;
        });

        var self = this;
        var duplicateArray = [];
        var errorArray = [];
        var duplicatesJSON = [];
        var errorsJSON = [];
        var errorIds = [];
        var duplicateIds = [];
        _.each(data.errors, function (error) {
            var row = rowsMap[error.rowId];
            if (self.isDuplicateTaskError(error)) {
                duplicateIds.push(error.rowId);
                duplicateArray.push({ row: row, error: error });
                duplicatesJSON.push(row);
            } else {
                errorIds.push(error.rowId);
                errorArray.push({ row: row, error: error });
                errorsJSON.push(row);
            }
        });

        return {
            duplicates: duplicateArray,
            errors: errorArray,
            duplicatesJSON: duplicatesJSON,
            errorsJSON: errorsJSON,
            duplicateIds: duplicateIds,
            errorIds: errorIds
        };
    },

    updateTableData: function updateTableData(result) {
        var columns = this.getPresentedTableColumns(result.columns);
        var collectedErrors = this.collectRowsWithErrors(result);

        this.resultTable = result.table;
        this.previewErrors = { errors: collectedErrors.errorIds, duplicates: collectedErrors.duplicateIds };
        this.columns = columns;

        this.createTable({
            columnNames: this.columnNames,
            columns: columns,
            table: result.table,
            duplicates: collectedErrors.duplicates,
            errors: collectedErrors.errors
        });

        this.createCSVWithDuplicatesLink("#downloadCSVWithDuplicatesLink", columns, collectedErrors.duplicatesJSON);
        this.createCSVWithErrorsLink("#downloadCSVWithErrorsLink", columns, collectedErrors.errorsJSON);
        this.fillImportInfo(result["importCounter"]);

        var errorsNumber = collectedErrors.duplicatesJSON.length + collectedErrors.errorsJSON.length;
        var showTableLinks = errorsNumber > 0;
        this.popup.showInnerContent(showTableLinks);

        var resultSize = result.table.length;
        if (resultSize > 2000) {
            return _.bind(this.onCSVPartialLoadSuccess, this, resultSize, columns, errorsNumber, collectedErrors, showTableLinks);
        }

        this.onCSVPartialLoadSuccess(resultSize, columns, errorsNumber, collectedErrors, showTableLinks);
        return null;
    },

    onCSVPartialLoadSuccess: function onCSVPartialLoadSuccess(resultSize, columns, errorsNumber, collectedErrors, showTableLinks) {
        //must be after displaying table to calculate real width of columns
        this.applyTableScrollHacks(columns);
        this.addScroll();

        this.markRowsWithProblems(columns, this.resultTableContainer, collectedErrors.duplicates, "duplicate");
        this.markRowsWithProblems(columns, this.resultTableContainer, collectedErrors.errors, "withError");

        if (showTableLinks && resultSize - errorsNumber == 0) {
            this.popup.toggleImportEnabled(false);
            if (collectedErrors.duplicatesJSON.length > 0) this.showDuplicatesFn();else this.showErrorsFn();
        } else {
            this.popup.toggleImportEnabled(resultSize > 0);
        }
    },

    showPopup: function showPopup() {
        this.affectedProjectIds = {};

        if (_.isUndefined(this.popup)) {
            this.popup = new LoadTasksFromCSVPopup().init(this.actionUrl, _.bind(this.onCSVLoadSuccess, this), _.bind(this.completeImport, this), _.bind(this.reloadPageWithFilter, this), _.bind(this.cleanTable, this), this.globalErrorHandler);

            this.columnNames = this.getColumnNames();
            this.errorDescription = this.getErrorDescription();
            this.columnMaxSizeErrMap = this.getColumnMaxSizeErrMap();
            this.initTableViewLinks();
            this.initSampleCSV();
            this._initErrorTooltip();
        }

        this.popup.restartImport();
        this.popup.show();
    },

    reloadPageWithFilter: function reloadPageWithFilter() {
        // Only return projects, which were successfully added to the store
        var projectIdsArray = Object.keys(this.affectedProjectIds).filter(function (id) {
            return _ProjectStore2.default.get(id);
        }).map(function (id) {
            return Number(id);
        });
        if (projectIdsArray.length > 0) this.successTaskCreationCallback(projectIdsArray);
    },

    cleanTable: function cleanTable() {
        this.resultTable = null;
        this.previewErrors = null;
        this.resultTableContainer[0].innerHTML = "";
    },

    completeImport: function completeImport(successCallback, errorCallback, progressCallback) {
        var self = this;
        var maxChunkSize = 500;
        var table = this.resultTable;

        this.operationId = null;

        var i = 0;
        var makeCall = function makeCall(successCallback) {
            var chunk = table.slice(i, i + maxChunkSize);
            _ClassicBridge2.default.postImportTasksRequest(chunk, i, table.length, self.operationId).then(successCallback).catch(function (error) {
                if ((0, _utils3.isNextApiError)(error)) {
                    self.globalErrorHandler(error);
                }
                errorCallback(error);
            });
        };

        var combinedResult = {
            errors: [],
            importCounter: {
                customersCount: 0,
                projectsCount: 0,
                tasksCount: 0,
                typesOfWorkCount: 0,
                prioritiesCount: 0,
                projectIds: []
            }
        };
        var combineResults = function combineResults(chunkResult) {
            combinedResult.errors = combinedResult.errors.concat(chunkResult.errors);
            combinedResult.importCounter.customersCount += chunkResult.importCounter.customersCount;
            combinedResult.importCounter.projectsCount += chunkResult.importCounter.projectsCount;
            combinedResult.importCounter.tasksCount += chunkResult.importCounter.tasksCount;
            combinedResult.importCounter.typesOfWorkCount += chunkResult.importCounter.typesOfWorkCount;
            combinedResult.importCounter.prioritiesCount += chunkResult.importCounter.prioritiesCount;
            combinedResult.importCounter.projectIds = _.union(combinedResult.importCounter.projectIds, chunkResult.importCounter.projectIds);
        };

        var errPrefix = _messageResource2.default.getMessage("import_csv_tasks.error.some_data_imported");
        var successProcessor = function successProcessor(result) {
            self.operationId = result.operationId;

            combineResults(result);
            i += maxChunkSize;

            progressCallback(i / table.length * 100);

            if (i < table.length) {
                makeCall(successProcessor, errPrefix);
            } else {
                var done = function done() {
                    self.completeImportSuccessHandler(combinedResult);
                    successCallback();
                };

                self.updateCustomersProjectsIfNeeded(combinedResult.importCounter).then(function () {
                    return self.updateTypesOfWorkIfNeeded(combinedResult.importCounter.typesOfWorkCount);
                })
                //TODO: Add customFieldCount if able to import tasks with other custom fields than priority
                .then(function () {
                    return self.updateCustomFieldsIfNeeded(combinedResult.importCounter.prioritiesCount);
                }).then(function () {
                    return done();
                });
            }
        };

        progressCallback(maxChunkSize / table.length * 50);
        makeCall(successProcessor);
    },

    updateCustomersProjectsIfNeeded: function updateCustomersProjectsIfNeeded(importCounter) {
        var self = this;
        return new Promise(function (resolve, reject) {
            // TODO need to load only assigned customer projects
            // TODO need to load assignnments too
            // After import is completed, ask for fresh customers/projects data
            if (importCounter.customersCount > 0 || importCounter.projectsCount > 0) {
                (0, _jquery_rpc2.default)("TaskManagementService.getAllCustomersProjects", [], function (data) {
                    (0, _StoreUtils.mergeCustomersProjectsFromRPC)(data["customers"], data["projects"], true);
                    self.onLoadCustomersProjectsCallback({
                        customers: data["customers"].map(_utils.customerFromRpc),
                        projects: data["projects"].map(_utils.projectFromRpc)
                    });
                    resolve();
                }, function (error) {
                    console.error(error);
                    reject();
                });
            } else {
                resolve();
            }
        });
    },

    updateTypesOfWorkIfNeeded: function updateTypesOfWorkIfNeeded(typesOfWorkCount) {
        var self = this;
        return new Promise(function (resolve, reject) {
            if (typesOfWorkCount > 0) {
                (0, _jquery_rpc2.default)("BillingTypeService.getAllTypes", [], function (typesOfWork) {
                    (0, _StoreUtils.replaceTypesOfWorkFromRPC)(typesOfWork);
                    self.onLoadTypesOfWorkCallback(typesOfWork);
                    resolve();
                }, function (error) {
                    console.error(error);
                    reject();
                });
            } else {
                resolve();
            }
        });
    },

    updateCustomFieldsIfNeeded: function updateCustomFieldsIfNeeded(customFieldCount) {
        var self = this;
        return new Promise(function (resolve, reject) {
            if (customFieldCount > 0) {
                _ClassicBridge2.default.getTaskCustomFieldsList().then(function (_ref) {
                    var items = _ref.items;

                    self.onLoadCustomFieldsCallback(items);
                    resolve();
                }).catch(function (e) {
                    reject(e);
                });
            } else {
                resolve();
            }
        });
    },

    toggleImportDifferNote: function toggleImportDifferNote(collectedErrors) {
        var previewErrors = this.previewErrors;

        var isSameArrays = function isSameArrays(array1, array2) {
            return array1.length == array2.length && _.intersection(array1, array2).length == array1.length;
        };

        var errorListWasChanged = !isSameArrays(previewErrors.errors, collectedErrors.errorIds) || !isSameArrays(previewErrors.duplicates, collectedErrors.duplicateIds);

        var hasDuplicates = collectedErrors.duplicates.length > 0;
        var hasErrors = collectedErrors.errors.length > 0;

        this.resultInfoContainer.toggleClass("errorListWasChanged", errorListWasChanged);
        var messageErrorKey = "";
        if (hasDuplicates) {
            messageErrorKey = hasErrors ? "import_csv_tasks.result.errors_differ.errors_and_duplicates" : "import_csv_tasks.result.errors_differ.duplicates";
        } else {
            messageErrorKey = hasErrors ? "import_csv_tasks.result.errors_differ.errors" : "import_csv_tasks.result.errors_differ.errors_and_duplicates";
        }
        this.resultInfoContainer.find(".errorsDiffer").html(_messageResource2.default.getMessage("import_csv_tasks.result.errors_differ", [_messageResource2.default.getMessage(messageErrorKey)]));
        this.resultInfoContainer.toggleClass("errorsDiffer", errorListWasChanged && (hasDuplicates || hasErrors));
    },

    completeImportSuccessHandler: function completeImportSuccessHandler(result) {
        result.table = this.resultTable;
        var collectedErrors = this.collectRowsWithErrors(result);
        var resultCounters = result["importCounter"];
        _.extend(this.affectedProjectIds, arrayToSet(resultCounters.projectIds));

        var imported = this.resultInfoContainer.find(".importInfoRow");
        var importedTasks = imported[0];
        var newTypes = imported[1];
        var newPriorities = imported[2];

        var hasDuplicates = collectedErrors.duplicates.length > 0;
        var hasErrors = collectedErrors.errors.length > 0;

        var importPrefix = "<div class='importInfoText'>";

        if (!(hasDuplicates || hasErrors)) {
            importPrefix = "<div class='successIcon'></div>" + importPrefix;
            (0, _syncCallbacks.afterImportTasksSuccess)();
        }

        var counter = this._makeCounter;
        importedTasks.innerHTML = importPrefix + counter(resultCounters["customersCount"], "common.customer", "common.customers", " / ") + counter(resultCounters["projectsCount"], "common.project", "common.projects", " / ") + counter(resultCounters["tasksCount"], "common.task", "common.tasks", "") + '</div>';

        var typeOfWorkAdded = resultCounters.typesOfWorkCount > 0;
        $(newTypes).toggle(typeOfWorkAdded);
        if (typeOfWorkAdded) {
            newTypes.innerHTML = importPrefix + counter(resultCounters["typesOfWorkCount"], "common.type_of_work", "common.types_of_work", "", "import_csv_tasks.result.import_new") + '</div>';
        }
        var prioritiesAdded = resultCounters.prioritiesCount > 0;
        $(newPriorities).toggle(prioritiesAdded);
        if (prioritiesAdded) {
            newPriorities.innerHTML = importPrefix + counter(resultCounters["prioritiesCount"], "common.priority", "common.priorities", "", "import_csv_tasks.result.import_new") + '</div>';
        }

        var failsEl = this.resultInfoContainer.find(".notImported");
        var duplicatesEl = failsEl.find(".duplicatesInfoRow");
        var errorsEl = failsEl.find(".errorsInfoRow");

        this.resultInfoContainer.toggleClass("showNotImported", hasDuplicates || hasErrors);
        this.resultInfoContainer.toggleClass("showOnlyImported", !(hasDuplicates || hasErrors));
        duplicatesEl.toggle(hasDuplicates);
        errorsEl.toggle(hasErrors);

        this.toggleImportDifferNote(collectedErrors);

        var failContent = function failContent(counter, msgKeySingle, msgKeyMultiple, linkId, linkMsgKey) {
            var msgKey = counter == 1 ? msgKeySingle : msgKeyMultiple;
            return "<div class='fixedInfo'><span class='counter'>" + counter + "</span> " + _messageResource2.default.getEscapedMessage(msgKey) + "</div><div id='" + linkId + "' class='linkText noDecoration short'>" + _messageResource2.default.getEscapedMessage(linkMsgKey) + "</div>";
        };

        if (hasDuplicates) {
            var duplicateLinkId = "resultDuplicatesLink";
            duplicatesEl[0].innerHTML = failContent(collectedErrors.duplicates.length, 'import_csv_tasks.text.duplicate', 'import_csv_tasks.text.duplicates', duplicateLinkId, "import_csv_tasks.result.download_duplicates");

            this.createCSVWithDuplicatesLink("#" + duplicateLinkId, this.columns, collectedErrors.duplicatesJSON);
        }

        if (hasErrors) {
            var errorLinkId = "resultErrorsLink";
            errorsEl[0].innerHTML = failContent(collectedErrors.errors.length, 'import_csv_tasks.text.error', 'import_csv_tasks.text.errors', errorLinkId, "import_csv_tasks.result.download_errors");
            this.createCSVWithErrorsLink("#" + errorLinkId, this.columns, collectedErrors.errorsJSON);
        }
    },

    _makeCounter: function _makeCounter(counter, singleForm, multipleForm, postfix, prefixKey) {
        var key = counter == 1 ? singleForm : multipleForm;
        var prefix = _.isUndefined(prefixKey) ? "" : _messageResource2.default.getEscapedMessage(prefixKey) + " ";
        return "<span class='counterName'>" + "<span class='counter'>" + counter + "</span> " + prefix + _messageResource2.default.getEscapedMessage(key) + postfix + "</span> ";
    },

    fillImportInfo: function fillImportInfo(resultCounters) {
        var counter = this._makeCounter;
        var typeOfWorkAdded = resultCounters.typesOfWorkCount > 0;
        var prioritiesAdded = resultCounters.prioritiesCount > 0;
        this.toImportInfoContainer[0].innerHTML = counter(resultCounters["customersCount"], "common.customer", "common.customers", ", ") + counter(resultCounters["projectsCount"], "common.project", "common.projects", ", ") + counter(resultCounters["tasksCount"], "common.task", "common.tasks", prioritiesAdded || typeOfWorkAdded ? ", " : "") + (prioritiesAdded ? counter(resultCounters.prioritiesCount, "common.priority", "common.priorities", typeOfWorkAdded ? ", " : "", "import_csv_tasks.result.import_new") : "") + (typeOfWorkAdded ? counter(resultCounters.typesOfWorkCount, "common.type_of_work", "common.types_of_work", "", "import_csv_tasks.result.import_new") : "");
    },

    onCSVLoadError: function onCSVLoadError(resultJSON) {
        var exception = resultJSON.errorMessage;

        if (_.isUndefined(exception)) {
            var errorCode = resultJSON.error;
            var messages = this.errorCodesMessages;
            var codeName = this.errorCodesMap[errorCode];
            var message = _.isUndefined(codeName) || _.isUndefined(messages[codeName]) ? messages["UNEXPECTED_ERROR"] : messages[codeName];

            alert(message);

            if (codeName === "SESSION_EXPIRED" || codeName === "NO_RIGHTS" || codeName === "USER_IS_DISABLED") window.location.reload();
        }
    },

    onCSVLoadSuccess: function onCSVLoadSuccess(resultJSON) {
        var result = resultJSON;
        if (result.error) {
            this.onCSVLoadError(resultJSON);
            return { success: false };
        }

        this.csvSeparator = result.settings.separator;
        this.encoding = result.settings.encoding;

        var bigDataHandler = this.updateTableData(result);
        return { success: true, handler: bigDataHandler };
    },

    markRowsWithProblems: function markRowsWithProblems(columns, table, errors, className) {
        var errLength = errors.length;
        for (var i = 0; i < errLength; i++) {
            var rowData = errors[i];
            var rowEl = table.find("#" + this.resultTableRowPrefix + rowData.row.rowId);
            rowEl.removeClass("correct").addClass(className);

            var rowErrors = rowData.error;
            _.each(columns, function (column) {
                var errCode = rowErrors[column];
                if (!_.isUndefined(errCode) && errCode != null) {
                    var cell = rowEl.find("." + column);
                    cell.addClass("withError");
                    cell.attr("errorType", errCode);
                    cell.attr("column", column);
                    cell.attr("textLength", cell.html().length);
                }
            });
        }
    },

    createLinkText: function createLinkText(singleMsgKey, msgKey, length) {
        var key = length == 1 ? singleMsgKey : msgKey;
        return "<div class='tableLinkText'><span class='lengthValue'>" + length + "</span> " + _messageResource2.default.getEscapedMessage(key) + "</div>";
    },

    createTable: function createTable(data) {
        var duplicates = data.duplicates;
        var errors = data.errors;

        var duplicatesLength = duplicates.length;
        var errorsLength = errors.length;
        var successLength = data.table.length - duplicatesLength - errorsLength;

        this.resulTasksSuccessTableLink.get(0).innerHTML = this.createLinkText('common.task', 'common.tasks', successLength);
        this.resultTasksDuplicatesTableLink.get(0).innerHTML = this.createLinkText('import_csv_tasks.text.duplicate', 'import_csv_tasks.text.duplicates', duplicatesLength);
        this.resulTasksErrorTableLink.get(0).innerHTML = this.createLinkText('import_csv_tasks.text.error', 'import_csv_tasks.text.errors', errorsLength);

        var failsLinkContainer = $("#failsLinkContainer");
        failsLinkContainer.toggleClass("hideDuplicates", duplicatesLength == 0);
        failsLinkContainer.toggleClass("hideErrors", errorsLength == 0);

        this.resultTableContainer[0].innerHTML = this.template(data);

        this.importPreviewSection.removeClass("showDuplicates showErrors").addClass("showCorrect");

        this.addEmptyRowsIfNeeded(successLength, duplicatesLength, errorsLength);
    },

    addScroll: function addScroll() {
        var doubleScrollEl = $("#scrollableHeader");
        var scrollableBody = $("#scrollableBody");

        if (isIE8()) {
            var containerWidth = doubleScrollEl.width();
            scrollableBody.width(containerWidth).css("overflow", "auto");

            var resultTableHeader = $("#resultTableHeader");
            resultTableHeader.css("position", "relative");
            scrollableBody.scroll(function () {
                var scroll = -1 * scrollableBody.scrollLeft();
                resultTableHeader.css("left", scroll);
            });
        } else {
            this.verticalScroll = ScrollUtils.addVerticalScroll(scrollableBody, { isFaded: false, appendTo: doubleScrollEl });
            this.horizontalScroll = ScrollUtils.addHorizontalScroll(doubleScrollEl, { isFaded: false, mouseWheel: false });
        }
    },

    addEmptyRowsIfNeeded: function addEmptyRowsIfNeeded(successTasksNumber, duplicateTasksNumber, errorTasksNumber) {
        var emptyRows = $("#resultTable").find(".taskRow.empty");
        var addEmpyRows = function addEmpyRows(required, visibleNumber, className) {
            var needed = required - visibleNumber;
            for (var i = 0; i < needed; i++) {
                var row = $(emptyRows[i]);
                row.addClass(className);
            }
        };

        addEmpyRows(10, successTasksNumber, "correct");
        addEmpyRows(8, duplicateTasksNumber, "duplicate");
        addEmpyRows(8, errorTasksNumber, "withError");
    },

    applyTableScrollHacks: function applyTableScrollHacks(columns) {
        var columnNamesRow = $("#resultTable").find(".columnNames");
        _.each(columns, function (column) {
            var columnCell = columnNamesRow.find("." + column);
            var width = columnCell.width() + 10;
            $(".resultTable .columnNames ." + column).css("min-width", width).css("max-width", width);
            $(".resultTable .taskRow ." + column).css("min-width", width).css("max-width", width);
        });

        columnNamesRow.hide();
    },

    initTableViewLinks: function initTableViewLinks() {
        var section = this.importPreviewSection;
        var self = this;
        var showTableCallback = function showTableCallback(removeClass, addClass) {
            section.removeClass(removeClass).addClass(addClass);
            ScrollUtils.refreshCustomScroll(self.verticalScroll);
            ScrollUtils.refreshCustomScroll(self.horizontalScroll);
        };

        this.showDuplicatesFn = function () {
            showTableCallback("showCorrect showErrors", "showDuplicates");
        };
        this.showErrorsFn = function () {
            showTableCallback("showCorrect showDuplicates", "showErrors");
        };

        this.resulTasksSuccessTableLink.click(function () {
            showTableCallback("showDuplicates showErrors", "showCorrect");
        });
        this.resultTasksDuplicatesTableLink.click(this.showDuplicatesFn);
        this.resulTasksErrorTableLink.click(this.showErrorsFn);
    },

    createDownloadCSVLinkFunction: function createDownloadCSVLinkFunction(fileName, columns, jsonCSV) {
        var json = {
            columnNames: this.columnNames,
            columns: columns,
            table: jsonCSV
        };

        return function () {
            return (0, _utils2.downloadJsonAsCSV)([json], fileName);
        };
    },

    createCSVWithDuplicatesLink: function createCSVWithDuplicatesLink(elementId, columns, errors) {
        var fn = this.createDownloadCSVLinkFunction("Duplicate_rows.csv", columns, errors);
        $(elementId).off().click(fn);
    },

    createCSVWithErrorsLink: function createCSVWithErrorsLink(elementId, columns, errors) {
        var fn = this.createDownloadCSVLinkFunction("Errors.csv", columns, errors);
        $(elementId).off().click(fn);
    },

    getPresentedTableColumns: function getPresentedTableColumns(parsedColumns) {
        var columns = [];
        var length = this.columnOrder.length;
        for (var i = 0; i < length; i++) {
            var columnName = this.columnOrder[i];
            if (_.contains(parsedColumns, columnName)) {
                columns.push(columnName);
            }
        }

        return columns;
    },

    resultTableRowPrefix: "resultTableRow_",

    createTemplate: function createTemplate() {
        var columnNamesTemplatePart = "   <tr class='columnNames'>" + "       <td class='icon'>&nbsp;</td>" + "       <td class='row'><%=columnNames['rowId']%></td>" + "       <%_.each(columns, function(column, index) {%>" + "       <td class='<%=column%>'><%=escapeHtmlSymbols(columnNames[column])%></td>" + "       <%})%>" + "   </tr>";

        var tableTemplate = "<div id='scrollableHeader' class='horizontalScroll'><div class='horizontalScrollElementsContainer'>" + "   <table id='resultTableHeader' class='resultTable'>" + "       <thead class='resultTableHeader'>" + columnNamesTemplatePart + "       </thead>" + "   </table>" + "   <div id='scrollableBody' class='verticalScroll'>" + "       <table id='resultTable' class='resultTable'>" + "           <tbody class='resultTableBody'>" + columnNamesTemplatePart + "               <%_.each(table, function(row, index) {%>" + "               <tr id='" + this.resultTableRowPrefix + "<%=row.rowId%>' class='taskRow correct'>" + "                   <td class='icon'>&nbsp;</td>" + "                   <td class='row'><%=row['rowId']%></td>" + "                   <%_.each(columns, function(columnName, index) {%>" + "                   <td class='<%=columnName%>'><%=_.isUndefined(row[columnName]) ? '' : escapeHtmlSymbols(row[columnName])%></td>" + "                   <%})%>" + "               </tr>" + "               <%})%>" + "               <% for (var idx = 0; idx < 10; idx++ ) {%>" + "               <tr class='taskRow empty'>" + "                   <td class='icon'>&nbsp;</td>" + "                   <td class='row'>&nbsp;</td>" + "                   <%_.each(columns, function(columnName, index) {%>" + "                   <td class='<%=columnName%>'>&nbsp;</td>" + "                   <%})%>" + "               </tr>" + "               <%}%>" + "           </tbody>" + "       </table>" + "   </div>" + "</div></div>";

        return _.template(tableTemplate);
    },

    initSampleCSV: function initSampleCSV() {
        var sampleJsonColumns = this.columnOrder;
        var sampleJsonTable = [{ customer: "Customer A", project: "Project A1", task: "Task 1", description: "Description 1", deadline: "12/31/2016" }, { customer: "Customer A", project: "Project A1", task: "Task 2" }, { customer: "Customer B", project: "Project B1", task: "Task 3", "typeOfWork": "Type of Work 3", "priority": "Critical" }, { customer: "Customer B", project: "Project B2", task: "Task 4", description: "Description 4", estimate: "40" }];

        var fn = this.createDownloadCSVLinkFunction("Sample.csv", sampleJsonColumns, sampleJsonTable);
        $("#sampleCSVFileLink").off().click(this.popup.wrapEventHandler(fn));
        $("#infoSampleLink").find(".linkText").off().click(fn);
    }
});

/***/ }),
/* 1863 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _utils = __webpack_require__(6);

var _redux = __webpack_require__(7);

var _actions = __webpack_require__(928);

var _WindowSizeDependedView = __webpack_require__(458);

var _WindowSizeDependedView2 = _interopRequireDefault(_WindowSizeDependedView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TaskManagementPage = function (_WindowSizeDependedVi) {
    _inherits(TaskManagementPage, _WindowSizeDependedVi);

    function TaskManagementPage(_ref) {
        var _ref$setCpPanelMaxWid = _ref.setCpPanelMaxWidth,
            setCpPanelMaxWidth = _ref$setCpPanelMaxWid === undefined ? function () {} : _ref$setCpPanelMaxWid;

        _classCallCheck(this, TaskManagementPage);

        var _this = _possibleConstructorReturn(this, (TaskManagementPage.__proto__ || Object.getPrototypeOf(TaskManagementPage)).call(this));

        _this.actions = {
            setCpPanelMaxWidth: setCpPanelMaxWidth
        };

        return _this;
    }

    _createClass(TaskManagementPage, [{
        key: "templateHtml",
        value: function templateHtml() {
            return "<div id='taskManagementPage'>" + "  <div class='cpTreeBlock ui-widget-content'></div>" + "  <div class='taskListBlockWrapper'>" + "     <div id='taskListBlock'></div>" + "  </div>" + "</div>";
        }
    }, {
        key: "adjustSize",
        value: function adjustSize() {
            _get(TaskManagementPage.prototype.__proto__ || Object.getPrototypeOf(TaskManagementPage.prototype), "adjustSize", this).call(this);
            this.actions.setCpPanelMaxWidth((0, _jquery2.default)(window).width());
        }
    }]);

    return TaskManagementPage;
}(_WindowSizeDependedView2.default);

exports.default = (0, _utils.connect)(function (state) {
    return {};
}, function (dispatch) {
    return {
        setCpPanelMaxWidth: (0, _redux.bindActionCreators)(_actions.setCpPanelMaxWidth, dispatch)
    };
})(TaskManagementPage);

/***/ }),
/* 1864 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _redux = __webpack_require__(7);

var _PopupLoadingUtils = __webpack_require__(510);

var _CreateProjectLightbox = __webpack_require__(1865);

var _CreateProjectLightbox2 = _interopRequireDefault(_CreateProjectLightbox);

var _CorporateScheduleCalculator = __webpack_require__(378);

var _CorporateScheduleCalculator2 = _interopRequireDefault(_CorporateScheduleCalculator);

var _utils = __webpack_require__(6);

var _actions = __webpack_require__(55);

var _selectors = __webpack_require__(27);

var _atUtils = __webpack_require__(5);

var _constants = __webpack_require__(577);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CreateProjectPopupController = function () {
    function CreateProjectPopupController(_ref) {
        var createProjectSuccessCb = _ref.createProjectSuccessCb,
            createProjectFailureCb = _ref.createProjectFailureCb,
            setTypesOfWorkCb = _ref.setTypesOfWorkCb;

        _classCallCheck(this, CreateProjectPopupController);

        this.callbacks = {
            createProjectSuccessCb: createProjectSuccessCb,
            createProjectFailureCb: createProjectFailureCb,
            setTypesOfWorkCb: setTypesOfWorkCb
        };

        this.actions = (0, _utils.unsafe_bindActions)(function (dispatch) {
            return {
                setViewerSettings: (0, _redux.bindActionCreators)(_actions.setViewerSettings, dispatch)
            };
        });
    }

    _createClass(CreateProjectPopupController, [{
        key: 'showPopup',
        value: function showPopup(customerId) {
            var _this = this;

            this._requestPopupData(customerId, function (contentData) {
                new _CreateProjectLightbox2.default(contentData, {
                    successHandler: _this.callbacks.createProjectSuccessCb,
                    failureHandler: _this.callbacks.createProjectFailureCb,
                    setTypesOfWorkCb: _this.callbacks.setTypesOfWorkCb
                }).init().show();
            }, null);
        }
    }, {
        key: '_requestPopupData',
        value: function _requestPopupData(customerId, onSuccessCb, onErrorCb) {
            var _this2 = this;

            (0, _PopupLoadingUtils.loadPopupContentByRpcCall)("ProjectInfoService.getNewProjectPopupInfo", [], function (data) {
                var corporateSchedule = data['corporateSchedule'];
                var scheduleCalculator = new _CorporateScheduleCalculator2.default().init(window.invertedDaysDateMap, corporateSchedule);
                _this2.actions.setViewerSettings(data.viewerSettings);

                var customers = data['customers'].list;
                var selectedCustomerId = void 0;
                if (!!customers.find(function (_ref2) {
                    var id = _ref2.id;
                    return id === customerId;
                })) selectedCustomerId = customerId;else selectedCustomerId = _constants.PROJECT_CONSTANTS.SELECT_CUSTOMER_OPTION_INDEX;

                return onSuccessCb({
                    customersInfo: customers,
                    customerId: selectedCustomerId,
                    billingTypes: data['billingTypes'] ? data['billingTypes'].list : null,
                    enabledFeatures: (0, _atUtils.arrayToSet)(data['enabledFeatures']),
                    defaultBillingTypeId: data['defaultBillingType'],
                    weekStartDay: data['weekStartDay'] - 1,
                    scheduleCalculator: scheduleCalculator,
                    projectsWithTasksExist: data['projectsWithTasksExist'],
                    user: data['user'],
                    isPossibleToCreateCustomer: (0, _utils.unsafe_selectWithState)(_selectors.isPossibleToAddCustomers)
                });
            }, true, onErrorCb, true);
        }
    }]);

    return CreateProjectPopupController;
}();

exports.default = CreateProjectPopupController;

/***/ }),
/* 1865 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _LightBox2 = __webpack_require__(196);

var _LightBox3 = _interopRequireDefault(_LightBox2);

var _CreateProjectLightBoxFooter = __webpack_require__(1866);

var _CreateProjectLightBoxFooter2 = _interopRequireDefault(_CreateProjectLightBoxFooter);

var _CreateProjectLightboxHeader = __webpack_require__(1867);

var _CreateProjectLightboxHeader2 = _interopRequireDefault(_CreateProjectLightboxHeader);

var _CreateProjectContent = __webpack_require__(1868);

var _CreateProjectContent2 = _interopRequireDefault(_CreateProjectContent);

var _jquery_rpc = __webpack_require__(26);

var _jquery_rpc2 = _interopRequireDefault(_jquery_rpc);

var _constants = __webpack_require__(577);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _constants2 = __webpack_require__(108);

var _ExceptionsTypes = __webpack_require__(107);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CUSTOMER_NOT_SELECTED = "customerNotSelected";
var CUSTOMER_EXISTS = "customerExists";
var TASK_ERROR = "taskError";
var NAME_PROJECT_EMPTY = "nameProjectEmpty";
var DESCRIPTION_VERY_LARGE = "descriptionError";
var NAME_CUSTOMER_EMPTY = "customerNameEmpty";
var PROJECT_EXISTS = "projectExists";

var TAB_SWITCHING_ON_ERROR = 'details';

var CreateProjectLightbox = function (_LightBox) {
    _inherits(CreateProjectLightbox, _LightBox);

    function CreateProjectLightbox(contentData, _ref) {
        var _ref$successHandler = _ref.successHandler,
            successHandler = _ref$successHandler === undefined ? function () {} : _ref$successHandler,
            _ref$failureHandler = _ref.failureHandler,
            failureHandler = _ref$failureHandler === undefined ? function () {} : _ref$failureHandler,
            _ref$setTypesOfWorkCb = _ref.setTypesOfWorkCb,
            setTypesOfWorkCb = _ref$setTypesOfWorkCb === undefined ? function () {} : _ref$setTypesOfWorkCb;

        _classCallCheck(this, CreateProjectLightbox);

        var _this = _possibleConstructorReturn(this, (CreateProjectLightbox.__proto__ || Object.getPrototypeOf(CreateProjectLightbox)).call(this, undefined));

        _this._handleCustomerSelected = function (id) {
            _this.hideError(CUSTOMER_EXISTS);
            _this.hideError(CUSTOMER_NOT_SELECTED);

            if (id !== _constants.PROJECT_CONSTANTS.NEW_CUSTOMER_OPTION_INDEX) {
                _this.hideError(NAME_CUSTOMER_EMPTY);
            }
        };

        _this._handleCustomerNameChanged = function () {
            _this.hideError(CUSTOMER_EXISTS);
        };

        _this._handleProjectNameChanged = function () {
            _this.hideError(PROJECT_EXISTS);
        };

        _this._handleProjectNameBlur = function (field) {
            _this.checkEmpty(field, NAME_PROJECT_EMPTY, true, true);
            _this.updateErrors(false);
        };

        _this._handleCustomerNameBlur = function (field) {
            _this.checkEmpty(field, NAME_CUSTOMER_EMPTY, true, true);
            _this.updateErrors(false);
        };

        _this.params = _extends({}, _this.params, {
            data: contentData,
            successHandler: successHandler,
            failureHandler: failureHandler,
            setTypesOfWorkCb: setTypesOfWorkCb
        });

        _this.close_tab_confirmation_message_key = "project.add.js.close_tab_confirmation";
        _this.exist_invalid_fields_message_key = "project.common.errormsg";
        _this.cancel_confirmation_message_key = "project.add.js.cancel_confirmation";

        _this.dataChanged = false;
        _this.errors = {};

        _this.changesCallback = function () {
            if (!this.dataChanged) this.dataChanged = true;
        };
        return _this;
    }

    _createClass(CreateProjectLightbox, [{
        key: 'init',
        value: function init() {
            var _this2 = this;

            var header = new _CreateProjectLightboxHeader2.default();
            var footer = new _CreateProjectLightBoxFooter2.default();
            this.content = new _CreateProjectContent2.default(this.params.data, {
                onCustomerNameChanged: this._handleCustomerNameChanged,
                onCustomerSelected: this._handleCustomerSelected,
                onProjectNameChanged: this._handleProjectNameChanged,
                onProjectNameBlur: this._handleProjectNameBlur,
                onCustomerNameBlur: this._handleCustomerNameBlur,
                onChangeCallback: this.changesCallback.bind(this),
                onDescriptionFieldChange: this.checkDescriptionOnChange.bind(this),
                getScrollPositionCallback: function getScrollPositionCallback() {
                    return _this2.getScrollPosition();
                },
                refreshScrollCb: function refreshScrollCb() {
                    return _this2.refreshScroll();
                }
            });

            _get(CreateProjectLightbox.prototype.__proto__ || Object.getPrototypeOf(CreateProjectLightbox.prototype), 'init', this).call(this, {
                id: 'createProjectPopup', // do not delete
                header: header,
                content: this.content,
                footer: footer,
                classNames: 'createProjectLightbox taskProjectOrCustomerLightbox lightboxWithWhiteContent withTabs createMode',
                correctionOffset: 60 /* offset of the innerContent in the popup content used when scrolling to section with error*/
            });

            this.setSuccessCallback(function (projectData, tasks, addedUserIds, addedManagerIds) {
                _this2._makeCreateProjectRequest(projectData, tasks, addedUserIds, addedManagerIds);
            });

            this.setFailureValidateCallback(function () {
                return _this2.components.content.openTabByKey(TAB_SWITCHING_ON_ERROR);
            });

            return this;
        }
    }, {
        key: 'hide',
        value: function hide() {
            this.content.hide();
            _get(CreateProjectLightbox.prototype.__proto__ || Object.getPrototypeOf(CreateProjectLightbox.prototype), 'hide', this).call(this);
        }
    }, {
        key: 'getDataToCommit',
        value: function getDataToCommit() {
            return this.getContent().getNewProjectData();
        }
    }, {
        key: '_changesDetected',
        value: function _changesDetected(notRequireConfirmationOnCopySettings) {
            if (this.changesCallback) this.changesCallback(notRequireConfirmationOnCopySettings);
        }
    }, {
        key: '_makeCreateProjectRequest',
        value: function _makeCreateProjectRequest(projectData, tasks, addedUserIds, addedManagerIds) {
            var _this3 = this;

            var self = this;
            this.disableUserInputWhileSaving();

            self.customSuccessCommitCallback = function (result) {
                if (result.taskErrorCode) {
                    _this3.content.createTasksComponent.handleTaskError(result.taskError, result.taskErrorRowNumber);
                    _this3.scrollToFirstTaskWithError();
                } else if (result.billingTypeError) {
                    _this3.params.setTypesOfWorkCb(result['billingTypes']['list']);
                    _this3.content.createTasksComponent.handleBillingTypeError(result.billingTypeError, result.billingTypes ? result.billingTypes.list : null);
                    _this3.scrollToFirstTaskWithError();
                }
            };

            (0, _jquery_rpc2.default)("ProjectInfoService.createProject", [projectData, tasks, addedUserIds, addedManagerIds], function (result) {
                return self.successCommitCallback(result);
            }, function (jqXHR, textStatus, errorThrown) {
                return self.failureCommitCallback(jqXHR, textStatus, errorThrown);
            });
        }
    }, {
        key: 'failureCommitCallback',
        value: function failureCommitCallback(jqXHR, textStatus, errorThrown) {
            var self = this;

            function baseFailureHandler() {
                if (!errorThrown.exception) {
                    self.enableUserInputWhileSaving();
                    return false;
                }
                switch (errorThrown.exception) {
                    case _ExceptionsTypes.NO_RIGHT_TO_EDIT_HIERARCHY_EXCEPTION:
                        alert(_messageResource2.default.getMessage("task.create.error.no_manage_scope_right"));
                        window.location.reload();
                        return true;
                    case 'com.actimind.actitime.project.ProjectExistsException':
                        self.enableUserInputWhileSaving();
                        self.displayError(PROJECT_EXISTS);
                        self.scrollToProjectName();
                        return true;
                    case 'com.actimind.actitime.customer.CustomerExistsException':
                        self.enableUserInputWhileSaving();
                        self.displayError(CUSTOMER_EXISTS);
                        self.scrollToCustomerSelector();
                        return true;
                    case _constants2.Exceptions.USER_IS_NOT_ASSIGNED_TO_MANAGER_EXCEPTION:
                        alert(_messageResource2.default.getMessage("task.create.error.user_is_not_assigned_to_manager"));
                        window.location.reload();
                        return true;
                    case _constants2.Exceptions.USER_IS_DISABLED_EXCEPTION:
                        alert(_messageResource2.default.getMessage("task.create.error.assigned_user_disabled"));
                        window.location.reload();
                        return true;
                    case _constants2.Exceptions.NO_SUCH_USER_EXCEPTION:
                        alert(_messageResource2.default.getMessage("task.create.error.no_such_user"));
                        window.location.reload();
                        return true;
                    case _constants2.Exceptions.USER_HAS_NO_ACCESS_TO_SCOPE_EXCEPTION:
                        alert(_messageResource2.default.getMessage("task.create.error.user_does_not_have_any_scope_rights"));
                        window.location.reload();
                        return true;
                    case _constants2.Exceptions.NO_RIGHTS_TO_SUBMIT_TT_EXCEPTION:
                        alert(_messageResource2.default.getMessage("task.create.error.user_does_not_have_any_scope_rights"));
                        window.location.reload();
                        return true;
                }
                if (!self.customFailureCommitCallback(jqXHR, textStatus, errorThrown)) {
                    self.enableUserInputWhileSaving();
                    return false;
                } else return true;
            }

            if (baseFailureHandler(jqXHR, textStatus, errorThrown)) return true;

            return this.params.failureHandler(jqXHR, textStatus, errorThrown);
        }
    }, {
        key: 'successCommitCallback',
        value: function successCommitCallback(result) {
            var self = this;
            if (result.errorCode === _constants.PROJECT_CONSTANTS.RESULT_CODE_SUCESS) {
                if (!_underscore2.default.isUndefined(this.params.successHandler)) {
                    this.params.successHandler(result);
                    self.hide();
                } else document.location.reload();
            }

            if (result.errorCode === _constants.PROJECT_CONSTANTS.CUSTOMER_WAS_ARCHIVED) {
                alert(_messageResource2.default.getMessage('project.common.customer.archived'));
                self.content.initCustomerSelector(result.customers.list, 0);
                self.scrollToCustomerSelector();
            }

            if (result.errorCode === _constants.PROJECT_CONSTANTS.CUSTOMER_WAS_DELETED) {
                alert(_messageResource2.default.getMessage('project.common.customer.deleted'));
                self.content.initCustomerSelector(result.customers.list, 0);
                self.scrollToCustomerSelector();
            }
            self.customSuccessCommitCallback(result); // TODO lightbox
            self.enableUserInputWhileSaving(); // TODO lightbox
            self.updateUI(); // TODO lightbox
            return true;
        }
    }, {
        key: 'customSuccessCommitCallback',
        value: function customSuccessCommitCallback(result) {
            return true;
        }
    }, {
        key: 'customFailureCommitCallback',
        value: function customFailureCommitCallback(jqXHR, textStatus, errorThrown) {
            return false;
        }
    }, {
        key: 'hasErrors',
        value: function hasErrors() {
            var classes = [];
            for (var p in this.errors) {
                if (this.errors[p]) classes.push(p);
            }this.components.content.setErrorClasses(classes.join(" "));
            return classes.length > 0;
        }
    }, {
        key: 'displayError',
        value: function displayError(errorCode) {
            //TODO on error cb
            this.errors[errorCode] = true;
            this.updateErrors(true);
        }
    }, {
        key: 'hideError',
        value: function hideError(errorCode) {
            //TODO error cb
            this.errors[errorCode] = false;
            this.updateErrors(true);
        }
    }, {
        key: '_checkProjectNameValid',
        value: function _checkProjectNameValid(onlyRemoveEmptyError) {
            return !this.checkEmpty(this.components.content.getProjectNameField(), NAME_PROJECT_EMPTY, onlyRemoveEmptyError, true);
        }
    }, {
        key: '_checkCustomerId',
        value: function _checkCustomerId() {
            var self = this;
            var customerId = this.components.content.getCustomerId();
            if (customerId <= 0 && customerId !== _constants.PROJECT_CONSTANTS.NEW_CUSTOMER_OPTION_INDEX) {
                self.displayError(CUSTOMER_NOT_SELECTED);
                return false;
            }
            return true;
        }
    }, {
        key: 'isDescriptionValid',
        value: function isDescriptionValid() {
            var result = this.components.content.validateDescription();
            this.errors[DESCRIPTION_VERY_LARGE] = result;

            return !result;
        }
    }, {
        key: '_checkCustomerNameValid',
        value: function _checkCustomerNameValid(onlyRemoveEmptyError) {
            if (this.components.content.getCustomerId() === _constants.PROJECT_CONSTANTS.NEW_CUSTOMER_OPTION_INDEX) return !this.checkEmpty(this.components.content.getCustomerNameField(), NAME_CUSTOMER_EMPTY, onlyRemoveEmptyError, true);

            return true;
        }
    }, {
        key: '_checkCustomerValid',
        value: function _checkCustomerValid() {
            var idValid = this._checkCustomerId();
            var nameValid = this._checkCustomerNameValid();
            return idValid && nameValid;
        }
    }, {
        key: 'checkDescriptionOnChange',
        value: function checkDescriptionOnChange() {
            this.isDescriptionValid();
            this.updateErrors(false);
        }
    }, {
        key: 'updateUI',
        value: function updateUI() {
            this.updateErrors(true);
        }
    }, {
        key: 'getErrorsMap',
        value: function getErrorsMap() {
            return this.errors;
        }
    }, {
        key: 'validate',
        value: function validate() {
            this.errors = {};

            var scrolled = false;
            if (!this._checkProjectNameValid()) {
                this.scrollToProjectName();
                scrolled = true;
            }

            if (!this._checkCustomerValid() && !scrolled) {
                this.scrollToCustomerSelector();
                scrolled = true;
            }

            if (!this.isDescriptionValid() && !scrolled) {
                this.scrollToDescription();
                scrolled = true;
            }

            if (!this._customValidate() && !scrolled) {
                this._customValidateScroll();
            }

            this.updateUI();

            return !this.hasErrors();
        }
    }, {
        key: 'scrollToProjectName',
        value: function scrollToProjectName() {
            this.getWrapper().scrollToSection(this.getContent().getProjectNameField());
        }
    }, {
        key: 'scrollToDescription',
        value: function scrollToDescription() {
            this.getWrapper().scrollToSection(this.getContent().getDescriptionField());
        }
    }, {
        key: 'scrollToCustomerSelector',
        value: function scrollToCustomerSelector() {
            this.getWrapper().scrollToSection(this.getContent().getCustomerSelectorSection());
        }
    }, {
        key: '_customValidate',
        value: function _customValidate() {

            this.errors[TASK_ERROR] = !this.components.content.getCreateTaskComponent().isEmpty() && !this.components.content.getCreateTaskComponent().validate();

            return !this.errors[TASK_ERROR];
        }
    }, {
        key: '_customValidateScroll',
        value: function _customValidateScroll() {
            this.scrollToFirstTaskWithError();
        }
    }, {
        key: 'scrollToTasksTable',
        value: function scrollToTasksTable() {
            this.getWrapper().scrollToSection(this.components.content.find(".createTasksTable"));
        }
    }, {
        key: 'scrollToFirstTaskWithError',
        value: function scrollToFirstTaskWithError() {
            var taskWithErr = this.components.content.find(".createTasksTable .nameCell .error");

            if (taskWithErr.get(0)) this.getWrapper().scrollToSection(taskWithErr);else this.scrollToTasksTable();
        }
    }]);

    return CreateProjectLightbox;
}(_LightBox3.default);

exports.default = CreateProjectLightbox;

/***/ }),
/* 1866 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _Button = __webpack_require__(33);

var _Button2 = _interopRequireDefault(_Button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CreateProjectLightboxFooter = function (_TemplateView) {
    _inherits(CreateProjectLightboxFooter, _TemplateView);

    function CreateProjectLightboxFooter() {
        _classCallCheck(this, CreateProjectLightboxFooter);

        return _possibleConstructorReturn(this, (CreateProjectLightboxFooter.__proto__ || Object.getPrototypeOf(CreateProjectLightboxFooter)).call(this, null));
    }

    _createClass(CreateProjectLightboxFooter, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class="createProjectLightBoxFooter">' + '    <div class="errorMessageBox">' + '        <div class="errorIcon"/>' + //TODO styles
            '        <span class="errormsg"><%-errorMessage%></span>' + '    </div>' + '    <div class="buttonsBox">' + '        <span class="changesMsg"><%-projectNotSaved%></span>' + '        <span class="savingMsg"><%-projectSaving%></span>' + '        <div class="commitButtonPlaceHolder"/> ' + '        <div class="greyButton cancelBtn"><%-cancelBtn%></div>' + '    </div>' + '</div>';
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            var title = _messageResource2.default.getMessage("project.add.create_btn_title");
            if (title.length > 17) {
                title = _messageResource2.default.getMessage("project.add.default_create_btn_title");
            }
            this.commitButton = new _Button2.default({
                label: title,
                withPlusIcon: true
            }).init(this.find('.commitButtonPlaceHolder'));
        }
    }, {
        key: 'messageKeys',
        value: function messageKeys() {
            return {
                errorMessage: 'project.common.errormsg',
                projectNotSaved: 'project.common.not_saved',
                projectSaving: 'project.common.saving',
                cancelBtn: 'common.cancel'
            };
        }
    }, {
        key: 'getCommitBtnEl',
        value: function getCommitBtnEl() {
            return this.commitButton.getEl();
        }
    }, {
        key: 'getCancelBtnEl',
        value: function getCancelBtnEl() {
            return this.find('.cancelBtn');
        }
    }]);

    return CreateProjectLightboxFooter;
}(_TemplateView3.default);

exports.default = CreateProjectLightboxFooter;

/***/ }),
/* 1867 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CreateProjectLightboxHeader = function (_TemplateView) {
    _inherits(CreateProjectLightboxHeader, _TemplateView);

    function CreateProjectLightboxHeader() {
        _classCallCheck(this, CreateProjectLightboxHeader);

        return _possibleConstructorReturn(this, (CreateProjectLightboxHeader.__proto__ || Object.getPrototypeOf(CreateProjectLightboxHeader)).call(this, null));
    }

    _createClass(CreateProjectLightboxHeader, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<table class="dialog-header">' + '    <tr>' + '        <td>' + '            <div class="close-button">' + '                <div id="closeProjectLightBoxBtn" class="closeButton"></div>' + '                <div class="disabledCloseButton"></div>' + '            </div>' + '' + '            <div class="lightBoxTitle">' + '                <span class="titlePlaceholder"><%-title%></span>' + '            </div>' + '        </td>' + '    </tr>' + '</table>';
        }
    }, {
        key: 'messageKeys',
        value: function messageKeys() {
            return {
                title: 'project.add.page.title'
            };
        }
    }, {
        key: 'getCloseButtonEl',
        value: function getCloseButtonEl() {
            return this.find('.close-button');
        }
    }]);

    return CreateProjectLightboxHeader;
}(_TemplateView3.default);

exports.default = CreateProjectLightboxHeader;

/***/ }),
/* 1868 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _atUtils = __webpack_require__(5);

var _atBrowserUtils = __webpack_require__(8);

var _AssignedUsersEditor = __webpack_require__(292);

var _AssignedUsersEditor2 = _interopRequireDefault(_AssignedUsersEditor);

var _AssignedUsersEditorChangesHandler = __webpack_require__(935);

var _AssignedUsersEditorChangesHandler2 = _interopRequireDefault(_AssignedUsersEditorChangesHandler);

var _ProxyView = __webpack_require__(936);

var _ProxyView2 = _interopRequireDefault(_ProxyView);

var _TabHeaders = __webpack_require__(937);

var _TabHeaders2 = _interopRequireDefault(_TabHeaders);

var _LoadingContainer = __webpack_require__(28);

var _LoadingContainer2 = _interopRequireDefault(_LoadingContainer);

var _actionsProviders = __webpack_require__(363);

var _groupUtils = __webpack_require__(71);

var _AssignedUsersEditorContainer = __webpack_require__(294);

var _AssignedUsersEditorContainer2 = _interopRequireDefault(_AssignedUsersEditorContainer);

var _constants = __webpack_require__(577);

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _ImportTasksSelector = __webpack_require__(787);

var _ImportTasksSelector2 = _interopRequireDefault(_ImportTasksSelector);

var _TaskTableTemplate = __webpack_require__(509);

var _TaskTableTemplate2 = _interopRequireDefault(_TaskTableTemplate);

var _ImportTasksSelectorButton = __webpack_require__(788);

var _ImportTasksSelectorButton2 = _interopRequireDefault(_ImportTasksSelectorButton);

var _TabsController = __webpack_require__(239);

var _TabsController2 = _interopRequireDefault(_TabsController);

var _utils = __webpack_require__(118);

var _features = __webpack_require__(22);

var _constants2 = __webpack_require__(4);

var _CPCombobox = __webpack_require__(372);

var _CPCombobox2 = _interopRequireDefault(_CPCombobox);

var _Description = __webpack_require__(290);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TAB_KEYS = {
    DETAILS: 'details',
    ASSIGNED_USERS: 'assignedUsers',
    MANAGERS: 'managers'
};

var CreateProjectContent = function (_TemplateView) {
    _inherits(CreateProjectContent, _TemplateView);

    function CreateProjectContent(_ref, _ref2) {
        var customersInfo = _ref.customersInfo,
            customerId = _ref.customerId,
            billingTypes = _ref.billingTypes,
            enabledFeatures = _ref.enabledFeatures,
            defaultBillingTypeId = _ref.defaultBillingTypeId,
            weekStartDay = _ref.weekStartDay,
            scheduleCalculator = _ref.scheduleCalculator,
            projectsWithTasksExist = _ref.projectsWithTasksExist,
            user = _ref.user,
            isPossibleToCreateCustomer = _ref.isPossibleToCreateCustomer;
        var _ref2$onCustomerSelec = _ref2.onCustomerSelected,
            onCustomerSelected = _ref2$onCustomerSelec === undefined ? function () {} : _ref2$onCustomerSelec,
            _ref2$onCustomerNameC = _ref2.onCustomerNameChanged,
            onCustomerNameChanged = _ref2$onCustomerNameC === undefined ? function () {} : _ref2$onCustomerNameC,
            _ref2$onProjectNameCh = _ref2.onProjectNameChanged,
            onProjectNameChanged = _ref2$onProjectNameCh === undefined ? function () {} : _ref2$onProjectNameCh,
            _ref2$onProjectNameBl = _ref2.onProjectNameBlur,
            onProjectNameBlur = _ref2$onProjectNameBl === undefined ? function () {} : _ref2$onProjectNameBl,
            _ref2$onCustomerNameB = _ref2.onCustomerNameBlur,
            onCustomerNameBlur = _ref2$onCustomerNameB === undefined ? function () {} : _ref2$onCustomerNameB,
            _ref2$onChangeCallbac = _ref2.onChangeCallback,
            onChangeCallback = _ref2$onChangeCallbac === undefined ? function () {} : _ref2$onChangeCallbac,
            _ref2$onDescriptionFi = _ref2.onDescriptionFieldChange,
            onDescriptionFieldChange = _ref2$onDescriptionFi === undefined ? function () {} : _ref2$onDescriptionFi,
            _ref2$onValidateCallb = _ref2.onValidateCallback,
            onValidateCallback = _ref2$onValidateCallb === undefined ? function () {} : _ref2$onValidateCallb,
            _ref2$getScrollPositi = _ref2.getScrollPositionCallback,
            getScrollPositionCallback = _ref2$getScrollPositi === undefined ? function () {
            return 0;
        } : _ref2$getScrollPositi,
            _ref2$refreshScrollCb = _ref2.refreshScrollCb,
            refreshScrollCb = _ref2$refreshScrollCb === undefined ? function () {} : _ref2$refreshScrollCb;

        _classCallCheck(this, CreateProjectContent);

        var _this = _possibleConstructorReturn(this, (CreateProjectContent.__proto__ || Object.getPrototypeOf(CreateProjectContent)).call(this, null));

        _this._handleTabSwitched = function (selectedKey, previousKey) {
            _this.tabsController.setState({ selectedTabKey: selectedKey });

            if (previousKey) _this.buttons.get(previousKey).toggleClass('selected', false);
            _this.buttons.get(selectedKey).toggleClass('selected', true);
        };

        _this.params = {
            customersInfo: customersInfo,
            customerId: customerId,
            billingTypes: billingTypes,
            enabledFeatures: enabledFeatures,
            defaultBillingTypeId: defaultBillingTypeId,
            weekStartDay: weekStartDay,
            scheduleCalculator: scheduleCalculator,
            projectsWithTasksExist: projectsWithTasksExist,
            user: user,
            isPossibleToCreateCustomer: isPossibleToCreateCustomer
        };

        _this.callbacks = {
            onCustomerSelected: onCustomerSelected,
            onCustomerNameChanged: onCustomerNameChanged,
            onProjectNameChanged: onProjectNameChanged,
            onProjectNameBlur: onProjectNameBlur,
            onCustomerNameBlur: onCustomerNameBlur,
            onChangeCallback: onChangeCallback,
            onDescriptionFieldChange: onDescriptionFieldChange,
            onValidateCallback: onValidateCallback,
            getScrollPositionCallback: getScrollPositionCallback,
            refreshScrollCb: refreshScrollCb
        };

        _this.updateOnInit = true;

        _this.state = {
            currentTabKey: null,
            selectedCustomerId: _constants.PROJECT_CONSTANTS.SELECT_CUSTOMER_OPTION_INDEX
        };
        _this.onStatePropertyChanged('currentTabKey', _this._handleTabSwitched);

        _this.onStatePropertyChanged('selectedCustomerId', function (id) {
            _this.customersSelector.setState({ selectedItemId: id });
        });
        return _this;
    }

    _createClass(CreateProjectContent, [{
        key: "templateHtml",
        value: function templateHtml() {
            return '<div class="innerContent">' + '    <div class="projectSection">' + '        <div class="sectionDetails">' + '            <input maxlength="<%=maxNameLength%>"  tabindex="1" type="text" class="projectNameField inputFieldWithPlaceholder inputNameField"' + '                   placeholder="<%-projectNamePlaceholder%>"/>' + '            <div class="projectNameErrorWrapper">' + '                <div class="projectNameError"><%-emptyName%></div>' + '                <div class="projectDuplicateNameError"><%-projectExists%></div>' + '            </div>' + '            <div class="customerContainer">' + '                <div class="customerLabel"><%-customer%>:</div>' + '                <div class="customerSelectorPlaceholder selectorWithPlaceholderContainer"></div>' + '                <input maxlength="<%=maxNameLength%>" tabindex="2" type="text" class="newCustomerNameField newCustomer"' + '                       placeholder="<%=customerNamePlaceholder%>"/>' + '                <div class="customerNameErrorWrapper">' + '                    <div class="customerSelectorError"><%-customerNotSelected%></div>' + '                    <div class="emptyCustomerNameError"><%-customerEmptyName%></div>' + '                    <div class="duplicateCustomerNameError"><%-customerExists%></div>' + '                </div>' + '            </div>' + '            <div class="projectDescriptionField">' + '                <div class="descriptionLabel"><%-descriptionLabel%></div>' + '            </div>' + '        </div>' + '        <div class="taskTable">' + '            <div class="importTasksHeader">' + '                <div class="title"><%-importTasksHeader%></div>' + '                <div class="importTasksSelectorButtonContainer"></div>' + '            </div>' + '            <div class="taskTablePlaceholder"></div>' + '        </div>' + '    </div>' + '</div>';
        }
    }, {
        key: "templateModel",
        value: function templateModel() {
            return {
                maxNameLength: _constants2.EntityTextLimits.MAX_CPT_NAME
            };
        }
    }, {
        key: "messageKeys",
        value: function messageKeys() {
            return {
                projectNamePlaceholder: 'project.common.projectNamePlaceholder',
                deleteBtn: 'project.edit.js.delete_button_caption',
                emptyName: 'project.common.errormsg.empty_name',
                projectExists: 'project.common.errormsg.project_exists',
                editStatus: 'project.edit.status',
                customer: 'project.common.customer',
                customerNamePlaceholder: 'project.common.customerNamePlaceholder',
                customerNotSelected: 'project.common.errormsg.customer_not_selected',
                customerEmptyName: 'project.common.customer.empty_name',
                customerExists: 'project.common.errormsg.customer_exists',
                descriptionLabel: 'panel.common.description',
                importTasksHeader: 'project.edit.add_tasks'
            };
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            var _this2 = this;

            var self = this;
            this._innerContentEl = this.$el;

            this._isInstantValidation = true;
            this.sectionEl = this.find(".sectionDetails");
            this.commitButtonTitlePlaceholder = self.find(".commitBtn").find(".buttonTitle");

            this.projectNameField = this.find(".projectNameField");
            this.descriptionField = this.find(".projectDescriptionField");
            this.newCustomerField = this.find(".newCustomerNameField");

            this.titlePlaceholder = this.find(".titlePlaceholder")[0];
            this.projectNameError = this.find(".projectNameError")[0];

            this.customerSelectorContainer = this.find(".customerContainer")[0];
            this.customerSelectorError = this.find(".customerSelectorError")[0];
            this.$customerSelectorPlaceHolder = this.find(".customerSelectorPlaceholder");

            var tabHeaders = new _TabHeaders2.default().init((0, _jquery2.default)("<div></div>").insertBefore(this.$el.parent().parent()));

            var assignedUsersEditor = new _LoadingContainer2.default({
                contentComponent: new _AssignedUsersEditor2.default({
                    onUserDelete: function onUserDelete(userData) {
                        return _this2.assignedUsersEditorChangesHandler.handleUserDelete(userData.id);
                    },
                    onAssignedUsersChange: function onAssignedUsersChange(_ref3) {
                        var addedUserIds = _ref3.addedUserIds,
                            removedUserIds = _ref3.removedUserIds;
                        return _this2.assignedUsersEditorChangesHandler.handleAssignedUsersChange(addedUserIds, removedUserIds);
                    },
                    titleMessageKey: "assigned_users_editor.project.title",
                    userSubtitleGenerator: function userSubtitleGenerator(user) {
                        if (user.hasAllAssignments) {
                            return _messageResource2.default.getMessage("assigned_users_editor.project.has_all_assignments");
                        } else if (user.hasCustomerAssignment) {
                            return _messageResource2.default.getMessage("assigned_users_editor.project.has_customer_assignment");
                        }
                    },
                    managersMessageKey: "assigned_users_editor.project.managers_count",
                    canEditManagers: false,
                    addUsersMessageKey: "assigned_users_editor.add_title",
                    emptyListMessageKey: "assigned_users_editor.project.empty_list",
                    showPermissionIcons: false,
                    checkIfCanModify: function checkIfCanModify(user) {
                        return !user.hasManageAssignment;
                    },
                    getListDisabledTooltipText: function getListDisabledTooltipText(user) {
                        return _this2._getDisabledTooltipText(user);
                    },
                    getSelectorDisabledTooltipText: function getSelectorDisabledTooltipText(user) {
                        return _this2._getDisabledTooltipText(user);
                    },
                    renderUserSelectorToContent: true,
                    refreshScrollCb: this.callbacks.refreshScrollCb
                }),
                containerClass: "assignedUsersTab"
            }).init(this.$el);
            this.assignedUsersEditorContainer = new _AssignedUsersEditorContainer2.default({
                assignedUsersEditor: assignedUsersEditor,
                $tabTitle: tabHeaders.$assignedUsersTabTitle,
                tabTitleMessageKey: "task.edit_panel.tabs.assigned_users_with_count"
            }).init();
            this.assignedUsersEditorChangesHandler = new _AssignedUsersEditorChangesHandler2.default({
                editor: this.assignedUsersEditorContainer,
                assignedUserModelExtender: function assignedUserModelExtender(assigned) {
                    return { hasProjectAssignment: assigned };
                },
                changeCallback: function changeCallback() {
                    return _this2.callbacks.onChangeCallback();
                }
            });

            var managersEditor = new _LoadingContainer2.default({
                contentComponent: new _AssignedUsersEditor2.default({
                    onUserDelete: function onUserDelete(userData) {
                        return _this2.managersEditorChangesHandler.handleUserDelete(userData.id);
                    },
                    onAssignedUsersChange: function onAssignedUsersChange(_ref4) {
                        var addedUserIds = _ref4.addedUserIds,
                            removedUserIds = _ref4.removedUserIds;
                        return _this2.managersEditorChangesHandler.handleAssignedUsersChange(addedUserIds, removedUserIds);
                    },
                    titleMessageKey: "assigned_users_editor.managers.project.title",
                    userSubtitleGenerator: function userSubtitleGenerator(user) {
                        if (user.hasAllAssignments) {
                            return _messageResource2.default.getMessage("assigned_users_editor.managers.project.has_all_assignments");
                        } else if (user.hasCustomerAssignment) {
                            return _messageResource2.default.getMessage("assigned_users_editor.managers.project.has_customer_assignment");
                        }
                    },
                    addUsersMessageKey: "assigned_users_editor.managers.add_title",
                    showPermissionIcons: true,
                    checkIfCanModify: function checkIfCanModify(user) {
                        return !(user.hasAllAssignments || user.hasCustomerAssignment || user.hasAllFutureProjectsOfCustomerAssignment);
                    },
                    getListDisabledTooltipText: function getListDisabledTooltipText(user) {
                        return _this2._getDisabledTooltipText(user);
                    },
                    getSelectorDisabledTooltipText: function getSelectorDisabledTooltipText(user) {
                        return _this2._getDisabledTooltipText(user);
                    },
                    renderUserSelectorToContent: true,
                    refreshScrollCb: this.callbacks.refreshScrollCb
                }),
                containerClass: "managersTab"
            }).init(this.$el);
            managersEditor.setState({
                isBTYEnabled: (0, _utils.isEnabled)(this.params.enabledFeatures, _features.Feature.BTY),
                isURAEnabled: (0, _utils.isEnabled)(this.params.enabledFeatures, _features.Feature.URA),
                isTTAEnabled: (0, _utils.isEnabled)(this.params.enabledFeatures, _features.Feature.TTA)
            });

            this.managersEditorContainer = new _AssignedUsersEditorContainer2.default({
                assignedUsersEditor: managersEditor,
                $tabTitle: tabHeaders.$managersTabTitle,
                tabTitleMessageKey: "task.edit_panel.tabs.managers_with_count"
            }).init();
            this.managersEditorChangesHandler = new _AssignedUsersEditorChangesHandler2.default({
                editor: this.managersEditorContainer,
                assignedUserModelExtender: function assignedUserModelExtender(assigned) {
                    return { hasProjectAssignment: assigned };
                },
                changeCallback: function changeCallback() {
                    return _this2.callbacks.onChangeCallback();
                }
            });

            this._refreshAssignmentsData(this.params.customerId);

            var tabs = new Map([[TAB_KEYS.DETAILS, new _ProxyView2.default(this.find('.projectSection'))], [TAB_KEYS.ASSIGNED_USERS, assignedUsersEditor], [TAB_KEYS.MANAGERS, managersEditor]]);

            tabs.forEach(function ($tab, tabKey) {
                $tab.hide();
            });

            this.tabsController = new _TabsController2.default({
                tabs: tabs
            }).init();

            this.buttons = new Map([[TAB_KEYS.DETAILS, tabHeaders.$detailsTabHeader], [TAB_KEYS.ASSIGNED_USERS, tabHeaders.$assignedUsersTabHeader], [TAB_KEYS.MANAGERS, tabHeaders.$managersTabHeader]]);

            this.buttons.get(TAB_KEYS.ASSIGNED_USERS).toggle((0, _utils.isEnabled)(this.params.enabledFeatures, _features.Feature.WAS));

            this.buttons.forEach(function ($button, key) {
                $button.click(function () {
                    _this2.openTabByKey(key);
                });
            });

            this.initCustomerSelector(this.params.customersInfo, this.params.customerId);
            this.initTextAreaLengthNote();

            this.projectNameField.off();
            this.descriptionField.off();
            this.newCustomerField.off();

            this.keyUpChangesHandler = function (additionalHandler) {
                return function () {
                    this.keyPressed = false;
                    if (!this.prevValue && !!this.value || this.prevValue !== this.value) self.callbacks.onChangeCallback();

                    if (additionalHandler) additionalHandler();
                };
            };
            this.onBlurFieldHandler = function (additionalHandler) {
                return function () {
                    (0, _jquery2.default)(this).pVal((0, _atUtils.trim)(this.value));
                    //see Bug 48539
                    if (this.keyPressed) self.keyUpChangesHandler.call(this);

                    if (additionalHandler) additionalHandler();
                };
            };

            this.onKeyPressedHandler = function () {
                this.keyPressed = true;
            };

            this.projectNameField.keydown(this.onKeyPressedHandler());
            this.projectNameField.blur(this.onBlurFieldHandler(function () {
                _this2.callbacks.onProjectNameBlur(_this2.projectNameField);
            }));
            this.projectNameField.keyup(this.keyUpChangesHandler());
            this.projectNameField.change(function () {
                self.callbacks.onProjectNameChanged();
            });

            this.descriptionInput = new _Description.Description({
                onChange: function onChange(description) {
                    _this2.descriptionInput.setState({
                        text: description
                    });
                    _this2.callbacks.onDescriptionFieldChange(description);
                    _this2.callbacks.onChangeCallback();
                },
                onKeyDown: function onKeyDown() {
                    return _this2.onKeyPressedHandler();
                }
            }).init(this.descriptionField);

            this.descriptionInput.setState({
                placeholder: _messageResource2.default.getMessage('project.common.projectDescriptionPlaceholder'),
                editable: true
            });

            this.newCustomerField.keydown(this.onKeyPressedHandler());
            this.newCustomerField.blur(this.onBlurFieldHandler(function () {
                _this2.callbacks.onCustomerNameBlur(_this2.newCustomerField);
            }));
            this.newCustomerField.keyup(this.keyUpChangesHandler());
            this.newCustomerField.change(function () {
                self.callbacks.onCustomerNameChanged();
            });

            this.initCreateTasksComponent();

            this.importTasksSelector = new _ImportTasksSelector2.default((0, _jquery2.default)("body"), {
                scrollableContainer: this._innerContentEl,
                canSelectAllInCustomer: true,
                canSelectAllInProject: true,
                selectionCallback: function selectionCallback(_ref5) {
                    var taskIds = _ref5.taskIds,
                        customerId = _ref5.customerId,
                        projectId = _ref5.projectId,
                        importDescriptions = _ref5.importDescriptions,
                        importOnlyActiveProjects = _ref5.importOnlyActiveProjects;

                    _this2.createTasksComponent.importTasksRequest(taskIds, importDescriptions, customerId, projectId, importOnlyActiveProjects);
                    _this2.importTasksSelector.hidePanel();
                }
            }).init();
            this.importTasksSelector.setState({
                user: this.params.user
            });

            var importTasksSelectorButton = new _ImportTasksSelectorButton2.default(function () {
                _this2.importTasksSelector.showPanel({ of: importTasksSelectorButton.$el });
            }).init(this.find(".importTasksSelectorButtonContainer"));

            this.initPlaceholders();

            return this;
        }
    }, {
        key: "update",
        value: function update() {
            this.openTabByKey(TAB_KEYS.DETAILS);
        }
    }, {
        key: "openTabByKey",
        value: function openTabByKey(key) {
            this.setState({ currentTabKey: key });
        }
    }, {
        key: "_getDisabledTooltipText",
        value: function _getDisabledTooltipText(user) {
            var msg = _messageResource2.default.getMessage('assigned_users_editor.managers.disabled_tooltip', [_messageResource2.default.getMessage('common.project'), user.firstName]);

            if (user.hasAllAssignments) {
                msg += " " + _messageResource2.default.getMessage('assigned_users_editor.managers.disabled_tooltip.entire_scope');
            } else if (user.hasAllFutureProjectsOfCustomerAssignment) {
                msg += " " + _messageResource2.default.getMessage('assigned_users_editor.managers.disabled_tooltip.all_existing_and_future_items_assignment', [_messageResource2.default.getMessage('common.projects'), _messageResource2.default.getMessage('common.customer')]);
            } else if (user.hasCustomerAssignment) {
                msg += " " + _messageResource2.default.getMessage('assigned_users_editor.managers.disabled_tooltip.entire_item_assignment', [_messageResource2.default.getMessage('common.customer')]);
            }
            return msg;
        }
    }, {
        key: "setErrorClasses",
        value: function setErrorClasses(classes) {
            this.find('.sectionDetails').removeClass().addClass(classes).addClass('sectionDetails');
        }
    }, {
        key: "getProjectNameField",
        value: function getProjectNameField() {
            return this.projectNameField;
        }
    }, {
        key: "getCustomerNameField",
        value: function getCustomerNameField() {
            return this.newCustomerField;
        }
    }, {
        key: "getDescriptionField",
        value: function getDescriptionField() {
            return this.descriptionField;
        }
    }, {
        key: "getCustomerSelectorSection",
        value: function getCustomerSelectorSection() {
            return (0, _jquery2.default)(this.customerSelectorContainer);
        }
    }, {
        key: "validateDescription",
        value: function validateDescription() {
            return this.descriptionInput.invalid;
        }
    }, {
        key: "getCreateTaskComponent",
        value: function getCreateTaskComponent() {
            return this.createTasksComponent;
        }
    }, {
        key: "applyAssignmentsData",
        value: function applyAssignmentsData(editor, editorChangesHandler, actionResult) {
            var hideAssignButtonStateExtender = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function (state) {
                return state;
            };

            editor.setState({ loading: true });
            actionResult.then(function (_ref6) {
                var users = _ref6.users,
                    userGroups = _ref6.userGroups,
                    timeZoneGroups = _ref6.timeZoneGroups,
                    userGroupsEnabled = _ref6.userGroupsEnabled,
                    timeZoneGroupsEnabled = _ref6.timeZoneGroupsEnabled,
                    canModifyAny = _ref6.canModifyAny;

                var state = editorChangesHandler.extendEditorState({
                    users: users.map(function (user) {
                        return _extends({}, user, { canBeModified: user.canBeModified && !user.hasCustomerAssignment });
                    }),
                    userGroups: userGroups ? (0, _groupUtils.addDefaultUserGroup)(userGroups) : userGroups,
                    timeZoneGroups: timeZoneGroups,
                    userGroupsEnabled: userGroupsEnabled,
                    timeZoneGroupsEnabled: timeZoneGroupsEnabled,
                    canModifyAny: canModifyAny,
                    loading: false
                });
                state = hideAssignButtonStateExtender(state);
                editor.setState(state);
            }).catch(function (e) {
                editor.setState({ loading: false });
                console.error(e);
            });
        }
    }, {
        key: "initCreateTasksComponent",
        value: function initCreateTasksComponent() {
            var defaultRowsNumber = 3;
            this.createTasksComponent = new _TaskTableTemplate2.default(this.find(".taskTablePlaceholder"), {
                billingTypes: this.params.billingTypes,
                showBillingTypeColumn: (0, _utils.isEnabled)(this.params.enabledFeatures, _features.Feature.BTY),
                defaultBillingTypeId: this.params.defaultBillingTypeId,
                canAddTasksToUser: false,
                weekStartDay: this.params.weekStartDay,
                scheduleCalculator: this.params.scheduleCalculator,
                estEnabled: (0, _utils.isEnabled)(this.params.enabledFeatures, _features.Feature.EST),
                tstEnabled: (0, _utils.isEnabled)(this.params.enabledFeatures, _features.Feature.TST),
                defaultRowsNumber: defaultRowsNumber,
                isOpenedFromOpenTasks: true,
                changesCallback: this.callbacks.onChangeCallback,
                validateCallback: this.callbacks.onValidateCallback,
                scrollableContainer: this._innerContentEl,
                getScrollPositionCallback: this.callbacks.getScrollPositionCallback,
                refreshScrollCb: this.callbacks.refreshScrollCb
            }).init();
        }
    }, {
        key: "getNewProjectData",
        value: function getNewProjectData() {
            var tasks = this.createTasksComponent.getTasks();
            return [{
                customerId: this.getCustomerId(),
                customerName: this.getCustomerName(),
                name: this.getProjectName(),
                description: this.getDescription()
            }, tasks, this.assignedUsersEditorChangesHandler.getAddedUserIds(), this.managersEditorChangesHandler.getAddedUserIds()];
        }
    }, {
        key: "show",
        value: function show() {
            _get(CreateProjectContent.prototype.__proto__ || Object.getPrototypeOf(CreateProjectContent.prototype), "show", this).call(this);
            (0, _atBrowserUtils.setFocusIntoFieldWithPlaceholder)(this.projectNameField);
        }
    }, {
        key: "hide",
        value: function hide() {
            this.createTasksComponent.hideDescriptionPopup();
            this.createTasksComponent.restoreGetOnPageDescriptionFunction();
            _get(CreateProjectContent.prototype.__proto__ || Object.getPrototypeOf(CreateProjectContent.prototype), "hide", this).call(this);
        }
    }, {
        key: "commit",
        value: function commit() {
            if (this.createTasksComponent.hideDescriptionPopup(true)) _get(CreateProjectContent.prototype.__proto__ || Object.getPrototypeOf(CreateProjectContent.prototype), "commit", this).call(this);
        }
    }, {
        key: "initPlaceholders",
        value: function initPlaceholders() {
            this.projectNameField.placeholder();
            this.newCustomerField.placeholder();
        }
    }, {
        key: "getProjectName",
        value: function getProjectName() {
            return this.projectNameField.pVal();
        }
    }, {
        key: "getDescription",
        value: function getDescription() {
            return this.descriptionInput.getText();
        }
    }, {
        key: "getCustomerName",
        value: function getCustomerName() {
            return this.newCustomerField.pVal();
        }
    }, {
        key: "getCustomerId",
        value: function getCustomerId() {
            return this.state.selectedCustomerId;
        }
    }, {
        key: "initCustomerSelector",
        value: function initCustomerSelector(customerInfos, customerId) {
            var _this3 = this;

            var items = [];
            var additionalItems = [];
            this.$customerSelectorPlaceHolder.empty();

            if (customerId <= 0) {
                customerId = _constants.PROJECT_CONSTANTS.SELECT_CUSTOMER_OPTION_INDEX;
            }

            var newCustomerIndex = _constants.PROJECT_CONSTANTS.NEW_CUSTOMER_OPTION_INDEX;

            if (this.params.isPossibleToCreateCustomer) {
                additionalItems.push({ id: newCustomerIndex, name: _messageResource2.default.getEscapedMessage("project.common.new_customer") });
            }

            if (customerInfos.length === 0) customerId = newCustomerIndex;

            customerInfos.forEach(function (info) {
                items.push({ id: info.id, name: info.name });
            });

            var handler = function handler(customerId) {
                _this3.resetCustomerSelectorClasses();
                _this3.callbacks.onCustomerSelected(customerId);

                if (customerId === _constants.PROJECT_CONSTANTS.NEW_CUSTOMER_OPTION_INDEX) {
                    _this3.focusNewCustomerField();
                }

                if (customerId === _constants.PROJECT_CONSTANTS.SELECT_CUSTOMER_OPTION_INDEX) {
                    _this3.highlightCustomerSelector();
                }

                _this3._refreshAssignmentsData(customerId);

                _this3.callbacks.onChangeCallback();
            };

            this.customersSelector = new _CPCombobox2.default({
                emptySelectionMessageKey: "project.common.please_select_one",
                notFoundMessageKey: "task.list.move_to.no_customers_found",
                hiddenItemsCollapsedMessageKey: 'task.list.move_to.show_archived_customers',
                hiddenItemsExpandedMessageKey: 'task.list.move_to.hide_archived_customers',
                emptyListMessageKey: "task.list.move_to.no_customers",
                onItemSelectedCb: function onItemSelectedCb(entity) {
                    _this3.setState({
                        selectedCustomerId: entity.id
                    });
                    _this3.customersSelector.setState({ selectedItemId: entity.id });
                    handler(entity.id);
                }
            }).init((0, _jquery2.default)(this.$customerSelectorPlaceHolder));
            this.setState({
                selectedCustomerId: customerId
            });
            this.customersSelector.setState({
                items: items,
                additionalItems: additionalItems,
                selectedItemId: customerId
            });

            this.highlightCustomerSelector();
        }
    }, {
        key: "_refreshAssignmentsData",
        value: function _refreshAssignmentsData(customerId) {
            if ((0, _utils.isEnabled)(this.params.enabledFeatures, _features.Feature.WAS)) {
                this.applyAssignmentsData(this.assignedUsersEditorContainer, this.assignedUsersEditorChangesHandler, customerId > 0 ? _actionsProviders.customerActionsProvider.getAssignedUsers(customerId) : _actionsProviders.customerActionsProvider.getAssignedUsersForAll());
            }
            this.applyAssignmentsData(this.managersEditorContainer, this.managersEditorChangesHandler, customerId > 0 ? _actionsProviders.customerActionsProvider.getManagers(customerId) : _actionsProviders.customerActionsProvider.getManagersForAll(), function (state) {
                return _extends({}, state, {
                    hideAssignButton: !state.canModifyAny
                });
            });
        }
    }, {
        key: "resetCustomerSelectorClasses",
        value: function resetCustomerSelectorClasses() {
            (0, _jquery2.default)(this.customerSelectorContainer).removeClass("newCustomer");
            this.$customerSelectorPlaceHolder.removeClass("notSelected");
        }

        // TODO state

    }, {
        key: "focusNewCustomerField",
        value: function focusNewCustomerField() {
            (0, _jquery2.default)(this.customerSelectorContainer).addClass("newCustomer");
            (0, _atBrowserUtils.setFocusIntoFieldWithPlaceholder)(this.newCustomerField);
        }

        // TODO state

    }, {
        key: "highlightCustomerSelector",
        value: function highlightCustomerSelector() {
            this.$customerSelectorPlaceHolder.addClass("notSelected");
        }
    }, {
        key: "initTextAreaLengthNote",
        value: function initTextAreaLengthNote() {
            var self = this;
            // TODO find id
            /*this.descriptionLengthNote = new TextAreaLengthNote('projectPopup_projectDescription', 'Description', 2000);
            this.descriptionLengthNote.setTextLengthCounter(this.descriptionLengthNote.fullCounter);
            this.descriptionLengthNote.update(this.getDescriptionForUpdatingLengthNote());
            this.descriptionLengthNote.show();*/
        }
    }, {
        key: "getDescriptionForUpdatingLengthNote",
        value: function getDescriptionForUpdatingLengthNote() {
            return (0, _atUtils.trim)((0, _atUtils.getStringWithUnifiedNewLineSymbol)(this.getDescription()));
        }
    }]);

    return CreateProjectContent;
}(_TemplateView3.default);

exports.default = CreateProjectContent;

/***/ }),
/* 1869 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _CreateCustomerLightbox = __webpack_require__(1870);

var _CreateCustomerLightbox2 = _interopRequireDefault(_CreateCustomerLightbox);

var _PopupLoadingUtils = __webpack_require__(510);

var _atUtils = __webpack_require__(5);

var _accessRightsUtils = __webpack_require__(188);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CreateCustomerPopupController = function () {
    function CreateCustomerPopupController(_ref) {
        var createCustomerStartCb = _ref.createCustomerStartCb,
            createCustomerSuccessCb = _ref.createCustomerSuccessCb,
            createCustomerFailureCb = _ref.createCustomerFailureCb,
            copyTasksCb = _ref.copyTasksCb;

        _classCallCheck(this, CreateCustomerPopupController);

        this.callbacks = {
            createCustomerStartCb: createCustomerStartCb,
            createCustomerSuccessCb: createCustomerSuccessCb,
            createCustomerFailureCb: createCustomerFailureCb,
            copyTasksCb: copyTasksCb
        };
    }

    _createClass(CreateCustomerPopupController, [{
        key: 'showPopup',
        value: function showPopup() {
            var _this = this;

            this._requestPopupData(function (contentData) {
                new _CreateCustomerLightbox2.default(contentData, {
                    successHandler: _this.callbacks.createCustomerSuccessCb,
                    copyTasksCb: _this.callbacks.copyTasksCb,
                    createCustomerStartCb: _this.callbacks.createCustomerStartCb,
                    createCustomerFailureCb: _this.callbacks.createCustomerFailureCb
                }).init().show();
            });
        }
    }, {
        key: '_requestPopupData',
        value: function _requestPopupData(onSuccessCb, onErrorCb) {
            (0, _PopupLoadingUtils.loadPopupContentByRpcCall)("CustomerInfoService.getCreateCustomerPopupData", [], function (data) {
                onSuccessCb({
                    customerInfos: data['customers'],
                    enabledFeatures: (0, _atUtils.arrayToSet)(data['enabledFeatures']),
                    assignedUsersData: data['assignedUsersData'],
                    assignedUsersDataForManagers: data['assignedUsersDataForManagers'],
                    canManageAccountsAndPermissions: data['canManageAccountsAndPermissions'],
                    hasSomeTeamAssignment: data['hasSomeTeamAssignment']
                });
            }, true, onErrorCb, true);
        }
    }]);

    return CreateCustomerPopupController;
}();

exports.default = CreateCustomerPopupController;

/***/ }),
/* 1870 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _Content = __webpack_require__(1871);

var _Content2 = _interopRequireDefault(_Content);

var _Footer = __webpack_require__(1872);

var _Footer2 = _interopRequireDefault(_Footer);

var _Header = __webpack_require__(1873);

var _Header2 = _interopRequireDefault(_Header);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _jquery_rpc = __webpack_require__(26);

var _jquery_rpc2 = _interopRequireDefault(_jquery_rpc);

var _atBrowserUtils = __webpack_require__(8);

var _LightBox2 = __webpack_require__(196);

var _LightBox3 = _interopRequireDefault(_LightBox2);

var _constants = __webpack_require__(108);

var _ExceptionsTypes = __webpack_require__(107);

var _actions = __webpack_require__(141);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var WARNING_ERROR_DURING_IMPORT = 300;
var RESULT_SUCCESSFULL = 200;
var ERROR_NAME_DUPLICATE = 400;

var NAME_EMPTY = "nameEmptyError";
var NAME_DUPLICATE = "nameDuplicateError";
var TAB_SWITCHING_ON_ERROR = 'details';

var CreateCustomerLightbox = function (_LightBox) {
    _inherits(CreateCustomerLightbox, _LightBox);

    function CreateCustomerLightbox(data, _ref) {
        var createCustomerStartCb = _ref.createCustomerStartCb,
            createCustomerFailureCb = _ref.createCustomerFailureCb,
            successHandler = _ref.successHandler,
            copyTasksCb = _ref.copyTasksCb;

        _classCallCheck(this, CreateCustomerLightbox);

        var _this = _possibleConstructorReturn(this, (CreateCustomerLightbox.__proto__ || Object.getPrototypeOf(CreateCustomerLightbox)).call(this));

        _this._handleChangeNameCb = function () {
            _this.changesCallback();
            _this.hideNameDuplicateError();
        };

        _this._handleBlurNameCb = function (field) {
            var handler = _this.basicOnBlurFieldHandler(function () {
                _this.checkNameOnChange();
            }).bind(field[0]);
            handler();
        };

        _this._handleNameKeyUpCb = function () {
            _this.basicKeyUpChangesHandler();
        };

        _this._handleNameKeyPressCb = function () {
            _this.basicOnKeyPressedHandler();
        };

        _this.exist_invalid_fields_message_key = "customer.edit.correct_errors";
        _this.close_tab_confirmation_message_key = "customer.create.close_tab.confirmation";
        _this.cancel_confirmation_message_key = "customer.create.exit_confirmation";

        _this.params = {
            data: data,
            createCustomerStartCb: createCustomerStartCb,
            createCustomerFailureCb: createCustomerFailureCb,
            successHandler: successHandler,
            copyTasksCb: copyTasksCb
        };

        _this.dataChanged = false;
        _this.cancelCallback = _this.hide;
        _this.errors = {};
        _this.warningMessages = {};
        _this.warningMessages[WARNING_ERROR_DURING_IMPORT] = _messageResource2.default.getMessage('customer.create.error.copied_customer_deleted');
        return _this;
    }

    _createClass(CreateCustomerLightbox, [{
        key: 'init',
        value: function init() {
            var _this2 = this;

            var header = new _Header2.default();
            var footer = new _Footer2.default();
            var content = new _Content2.default(this.params.data, {
                onChangeNameCb: this._handleChangeNameCb,
                onBlurNameCb: this._handleBlurNameCb,
                onNameKeyUpCb: this._handleNameKeyUpCb,
                onNameKeyPressCb: this._handleNameKeyPressCb,
                onChangeCustomerSelectorCb: function onChangeCustomerSelectorCb() {
                    return _this2.changesCallback();
                },
                onChangeDescriptionCb: function onChangeDescriptionCb() {
                    return _this2.changesCallback();
                },
                onChangeCb: function onChangeCb() {
                    return _this2.changesCallback();
                },
                refreshScrollCb: function refreshScrollCb() {
                    return _this2.refreshScroll();
                },
                scrollToSelectorCb: function scrollToSelectorCb() {
                    return _this2.scrollToCustomerSelector();
                }
            });

            _get(CreateCustomerLightbox.prototype.__proto__ || Object.getPrototypeOf(CreateCustomerLightbox.prototype), 'init', this).call(this, {
                id: 'customerLightBox', // do not delete
                header: header,
                content: content,
                footer: footer,
                classNames: 'createCustomerLightbox taskProjectOrCustomerLightbox lightboxWithWhiteContent withTabs',
                correctionOffset: -60 /* offset of the innerContent in the popup content used when scrolling to section with error*/
            });

            this.setSuccessCallback(this._successCallback);

            this.setFailureValidateCallback(function () {
                return _this2.components.content.openTabByKey(TAB_SWITCHING_ON_ERROR);
            });

            return this;
        }
    }, {
        key: '_successCallback',
        value: function _successCallback(customerName, customerDescription, customerIdToImportDataFrom, copySettings, assignedUserIds, managerIds) {
            var _this3 = this;

            this.disableUserInputWhileSaving();
            this.params.createCustomerStartCb();
            (0, _jquery_rpc2.default)("CustomerInfoService.createCustomer", [customerName, customerDescription, customerIdToImportDataFrom, (0, _actions.separateProjectCopySettings)(copySettings), assignedUserIds, managerIds], function (result) {
                if (result.resultCode === RESULT_SUCCESSFULL) {
                    if (result.taskIds && result.taskIds.length > 0) {
                        _this3.params.copyTasksCb(result.taskIds, result.projectsOldIdsToNewIds.map, copySettings, result.operationId);
                    }

                    if (result.warning) {
                        if (_this3.warningMessages[result.warning]) alert(_this3.warningMessages[result.warning]);
                    } else {
                        if (_this3.params.successHandler) _this3.params.successHandler(result);
                    }
                    _this3.hide();
                } else if (result.resultCode === ERROR_NAME_DUPLICATE) {
                    _this3.displayNameDuplicateError();
                    _this3.enableUserInputWhileSaving();
                    _this3.params.createCustomerFailureCb();
                }
            }, function (jqXHR, textStatus, errorThrown) {
                _this3.enableUserInputWhileSaving();
                _this3.params.createCustomerFailureCb();

                switch (errorThrown.exception) {
                    case _ExceptionsTypes.NO_RIGHT_TO_EDIT_HIERARCHY_EXCEPTION:
                        alert(_messageResource2.default.getMessage("task.create.error.no_manage_scope_right"));
                        window.location.reload();
                        return true;
                    case _constants.Exceptions.USER_IS_NOT_ASSIGNED_TO_MANAGER_EXCEPTION:
                        alert(_messageResource2.default.getMessage("task.create.error.user_is_not_assigned_to_manager"));
                        window.location.reload();
                        return true;
                    case _constants.Exceptions.USER_IS_DISABLED_EXCEPTION:
                        alert(_messageResource2.default.getMessage("task.create.error.assigned_user_disabled"));
                        window.location.reload();
                        return true;
                    case _constants.Exceptions.NO_SUCH_USER_EXCEPTION:
                        alert(_messageResource2.default.getMessage("task.create.error.no_such_user"));
                        window.location.reload();
                        return true;
                    case _constants.Exceptions.USER_HAS_NO_ACCESS_TO_SCOPE_EXCEPTION:
                        alert(_messageResource2.default.getMessage("task.create.error.user_does_not_have_any_scope_rights"));
                        window.location.reload();
                        return true;
                }
                return false;
            });
        }
    }, {
        key: 'changesDetected',
        value: function changesDetected() {
            if (!this.dataChanged) this.dataChanged = true;
        }
    }, {
        key: 'validate',
        value: function validate() {
            return this.isNameValid(false);
        }
    }, {
        key: 'updateUI',
        value: function updateUI() {
            this.updateErrors(true);
        }
    }, {
        key: 'getErrorsMap',
        value: function getErrorsMap() {
            return this.errors;
        }
    }, {
        key: 'setErrorClasses',
        value: function setErrorClasses(classes) {
            this.getContent().setErrorClasses(classes);
        }
    }, {
        key: 'displayErrorInFooter',
        value: function displayErrorInFooter() {
            this._errorMessageBox.removeClass("disabled");
        }
    }, {
        key: 'checkNameOnChange',
        value: function checkNameOnChange() {
            this.checkEmpty(this.getContent().getNameField(), NAME_EMPTY, true, true);
            this.updateErrors(false);
        }
    }, {
        key: 'isNameValid',
        value: function isNameValid(onlyRemoveEmptyError) {
            return !this.checkEmpty(this.getContent().getNameField(), NAME_EMPTY, onlyRemoveEmptyError, true);
        }
    }, {
        key: 'displayNameDuplicateError',
        value: function displayNameDuplicateError() {
            this.errors[NAME_DUPLICATE] = true;
            this.updateErrors(true);
        }
    }, {
        key: 'hideNameDuplicateError',
        value: function hideNameDuplicateError() {
            this.errors[NAME_DUPLICATE] = false;
            this.updateErrors();
        }
    }, {
        key: 'show',
        value: function show() {
            _get(CreateCustomerLightbox.prototype.__proto__ || Object.getPrototypeOf(CreateCustomerLightbox.prototype), 'show', this).call(this);
            (0, _atBrowserUtils.setFocusIntoFieldWithPlaceholder)(this.getContent().getNameField());
        }
    }, {
        key: 'getDataToCommit',
        value: function getDataToCommit() {
            return this.getContent().getData();
        }
    }, {
        key: 'scrollToCustomerSelector',
        value: function scrollToCustomerSelector() {
            this.getWrapper().scrollToSectionIfNeeded(this.getContent().getCustomerSelectorList());
        }
    }]);

    return CreateCustomerLightbox;
}(_LightBox3.default);

exports.default = CreateCustomerLightbox;

/***/ }),
/* 1871 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _LoadingContainer = __webpack_require__(28);

var _LoadingContainer2 = _interopRequireDefault(_LoadingContainer);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _AssignedUsersEditorContainer = __webpack_require__(294);

var _AssignedUsersEditorContainer2 = _interopRequireDefault(_AssignedUsersEditorContainer);

var _TabHeaders = __webpack_require__(937);

var _TabHeaders2 = _interopRequireDefault(_TabHeaders);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _groupUtils = __webpack_require__(71);

var _AssignedUsersEditor = __webpack_require__(292);

var _AssignedUsersEditor2 = _interopRequireDefault(_AssignedUsersEditor);

var _AssignedUsersEditorChangesHandler = __webpack_require__(935);

var _AssignedUsersEditorChangesHandler2 = _interopRequireDefault(_AssignedUsersEditorChangesHandler);

var _ProxyView = __webpack_require__(936);

var _ProxyView2 = _interopRequireDefault(_ProxyView);

var _TabsController = __webpack_require__(239);

var _TabsController2 = _interopRequireDefault(_TabsController);

var _CopySettingsBlock = __webpack_require__(296);

var _CopySettingsBlock2 = _interopRequireDefault(_CopySettingsBlock);

var _InformationBlock = __webpack_require__(295);

var _InformationBlock2 = _interopRequireDefault(_InformationBlock);

var _utils = __webpack_require__(297);

var _features = __webpack_require__(22);

var _utils2 = __webpack_require__(118);

var _constants = __webpack_require__(4);

var _accessRightsUtils = __webpack_require__(188);

var _Description = __webpack_require__(290);

var _CPCombobox = __webpack_require__(372);

var _CPCombobox2 = _interopRequireDefault(_CPCombobox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TAB_KEYS = {
    DETAILS: 'details',
    ASSIGNED_USERS: 'assignedUsers',
    MANAGERS: 'managers'
};

var Content = function (_TemplateView) {
    _inherits(Content, _TemplateView);

    function Content(_ref, _ref2) {
        var customerInfos = _ref.customerInfos,
            enabledFeatures = _ref.enabledFeatures,
            assignedUsersData = _ref.assignedUsersData,
            assignedUsersDataForManagers = _ref.assignedUsersDataForManagers,
            canManageAccountsAndPermissions = _ref.canManageAccountsAndPermissions,
            hasSomeTeamAssignment = _ref.hasSomeTeamAssignment;
        var _ref2$onChangeNameCb = _ref2.onChangeNameCb,
            onChangeNameCb = _ref2$onChangeNameCb === undefined ? function () {} : _ref2$onChangeNameCb,
            _ref2$onBlurNameCb = _ref2.onBlurNameCb,
            onBlurNameCb = _ref2$onBlurNameCb === undefined ? function () {} : _ref2$onBlurNameCb,
            _ref2$onNameKeyUpCb = _ref2.onNameKeyUpCb,
            onNameKeyUpCb = _ref2$onNameKeyUpCb === undefined ? function () {} : _ref2$onNameKeyUpCb,
            _ref2$onNameKeyPressC = _ref2.onNameKeyPressCb,
            onNameKeyPressCb = _ref2$onNameKeyPressC === undefined ? function () {} : _ref2$onNameKeyPressC,
            _ref2$onChangeCustome = _ref2.onChangeCustomerSelectorCb,
            onChangeCustomerSelectorCb = _ref2$onChangeCustome === undefined ? function () {} : _ref2$onChangeCustome,
            _ref2$onChangeDescrip = _ref2.onChangeDescriptionCb,
            onChangeDescriptionCb = _ref2$onChangeDescrip === undefined ? function () {} : _ref2$onChangeDescrip,
            _ref2$onChangeCb = _ref2.onChangeCb,
            onChangeCb = _ref2$onChangeCb === undefined ? function () {} : _ref2$onChangeCb,
            _ref2$refreshScrollCb = _ref2.refreshScrollCb,
            refreshScrollCb = _ref2$refreshScrollCb === undefined ? function () {} : _ref2$refreshScrollCb,
            _ref2$scrollToSelecto = _ref2.scrollToSelectorCb,
            scrollToSelectorCb = _ref2$scrollToSelecto === undefined ? function () {} : _ref2$scrollToSelecto;

        _classCallCheck(this, Content);

        var _this = _possibleConstructorReturn(this, (Content.__proto__ || Object.getPrototypeOf(Content)).call(this, null));

        _this._handleTabSwitched = function (selectedKey, previousKey) {
            _this.tabsController.setState({ selectedTabKey: selectedKey });

            if (previousKey) _this.buttons.get(previousKey).toggleClass('selected', false);
            _this.buttons.get(selectedKey).toggleClass('selected', true);
        };

        _this.params = {
            customerInfos: customerInfos,
            enabledFeatures: enabledFeatures,
            assignedUsersData: assignedUsersData,
            assignedUsersDataForManagers: assignedUsersDataForManagers,
            canManageAccountsAndPermissions: canManageAccountsAndPermissions,
            hasSomeTeamAssignment: hasSomeTeamAssignment
        };

        _this.callbacks = {
            onChangeNameCb: onChangeNameCb,
            onBlurNameCb: onBlurNameCb,
            onNameKeyUpCb: onNameKeyUpCb,
            onNameKeyPressCb: onNameKeyPressCb,
            onChangeCustomerSelectorCb: onChangeCustomerSelectorCb,
            onChangeDescriptionCb: onChangeDescriptionCb,
            onChangeCb: onChangeCb,
            refreshScrollCb: refreshScrollCb,
            scrollToSelectorCb: scrollToSelectorCb
        };

        _this.updateOnInit = true;

        _this.state = {
            currentTabKey: null,
            selectedCustomerId: -1
        };
        _this.onStatePropertyChanged('currentTabKey', _this._handleTabSwitched);

        _this.onStatePropertyChanged('selectedCustomerId', function (id) {
            _this.$importSettings.toggle(id !== -1);
            _this.callbacks.refreshScrollCb();
            _this.customersSelector.setState({ selectedItemId: id });
            _this.callbacks.onChangeCustomerSelectorCb();
        });
        return _this;
    }

    _createClass(Content, [{
        key: "templateModel",
        value: function templateModel() {
            return {
                id: 'customerLightBox',
                maxNameLength: _constants.EntityTextLimits.MAX_CPT_NAME
            };
        }
    }, {
        key: "messageKeys",
        value: function messageKeys() {
            return {
                customerNamePlaceholder: 'customer.edit.name.placeholder.text',
                emptyNameErr: 'customer.error.name_required',
                duplicateNameErr: 'customer.edit.error.name_duplicate',
                descriptionTitle: 'common.description',
                createFromExistsCaption: 'customer.create.import_from_existing_customer.caption'
            };
        }
    }, {
        key: "templateHtml",
        value: function templateHtml() {
            return '<div class="innerContent">' + '    <div class="customerInfoDiv">' + '        <div class="customerNameDiv">' + '            <input type="text" class="inputFieldWithPlaceholder newNameField inputNameField" placeholder="<%-customerNamePlaceholder%>" maxlength="<%=maxNameLength%>" autocomplete="off">' + '            <div class="nameEmptyError inlineErrorMessage leftInlineErrorMessage"><%-emptyNameErr%></div>' + '            <div class="nameDuplicateError inlineErrorMessage leftInlineErrorMessage"><%-duplicateNameErr%></div>' + '        </div>' + '' + '        <div class="descriptionSection section">' + '           <div class="title sectionHeader"><%-descriptionTitle%></div>' + '           <div class="description"></div>' + '        </div>' + '' + '        <div class="customerImportDiv">' + '            <div class="customerImportDivTitle" class="formblocktitle">' + '                <%-createFromExistsCaption%>' + '            </div>' + '            <div>' + '                <span class="customerSelectorPlaceholder selectorWithPlaceholderContainer"></span>' + '            </div>' + '            <div class="customerImportSettingsDiv">' + '            </div>' + '        </div>' + '    </div>' + '</div>';
        }
    }, {
        key: "afterRender",
        value: function afterRender() {
            var _this2 = this;

            this.customerInfoDiv = this.find(".customerInfoDiv")[0];
            this.$customerImportDiv = this.find(".customerImportDiv");
            this.$importSettings = this.find(".customerImportSettingsDiv");

            this.initNameField();
            this.initDescriptionField();

            this.$customerSelectorPlaceHolder = this.find(".customerSelectorPlaceholder");
            this.initCustomerSelector(this.params.customerInfos);
            this.initImportSettings();

            this.initPlaceholders();

            var tabHeaders = new _TabHeaders2.default().init((0, _jquery2.default)("<div></div>").insertBefore(this.$el.parent().parent())); // TODO temporary. Move to header

            var assignedUsersEditor = new _LoadingContainer2.default({
                contentComponent: new _AssignedUsersEditor2.default({
                    onUserDelete: function onUserDelete(userData) {
                        return _this2.assignedUsersEditorChangesHandler.handleUserDelete(userData.id);
                    },
                    onAssignedUsersChange: function onAssignedUsersChange(_ref3) {
                        var addedUserIds = _ref3.addedUserIds,
                            removedUserIds = _ref3.removedUserIds;
                        return _this2.assignedUsersEditorChangesHandler.handleAssignedUsersChange(addedUserIds, removedUserIds);
                    },
                    titleMessageKey: "assigned_users_editor.customer.title",
                    userSubtitleGenerator: function userSubtitleGenerator(user) {
                        if (user.hasAllAssignments) {
                            return _messageResource2.default.getMessage("assigned_users_editor.customer.has_all_assignments");
                        }
                    },
                    managersMessageKey: "assigned_users_editor.customer.managers_count",
                    canEditManagers: false,
                    addUsersMessageKey: "assigned_users_editor.add_title",
                    emptyListMessageKey: "assigned_users_editor.customer.empty_list",
                    showPermissionIcons: false,
                    checkIfCanModify: function checkIfCanModify(user) {
                        return !user.hasManageAssignment;
                    },
                    getListDisabledTooltipText: function getListDisabledTooltipText(user) {
                        return _this2._getDisabledTooltipText(user);
                    },
                    getSelectorDisabledTooltipText: function getSelectorDisabledTooltipText(user) {
                        return _this2._getDisabledTooltipText(user);
                    },
                    renderUserSelectorToContent: true,
                    refreshScrollCb: this.callbacks.refreshScrollCb
                }),
                containerClass: "assignedUsersTab"
            }).init(this.$el);
            this.assignedUsersEditorContainer = new _AssignedUsersEditorContainer2.default({
                assignedUsersEditor: assignedUsersEditor,
                $tabTitle: tabHeaders.$assignedUsersTabTitle,
                tabTitleMessageKey: "task.edit_panel.tabs.assigned_users_with_count"
            }).init();
            this.assignedUsersEditorChangesHandler = new _AssignedUsersEditorChangesHandler2.default({
                editor: this.assignedUsersEditorContainer,
                assignedUserModelExtender: function assignedUserModelExtender(assigned) {
                    return { hasCustomerAssignment: assigned };
                },
                changeCallback: function changeCallback() {
                    return _this2.callbacks.onChangeCb();
                }
            });

            var managersEditor = new _LoadingContainer2.default({
                contentComponent: new _AssignedUsersEditor2.default({
                    onUserDelete: function onUserDelete(userData) {
                        return _this2.managersEditorChangesHandler.handleUserDelete(userData.id);
                    },
                    onAssignedUsersChange: function onAssignedUsersChange(_ref4) {
                        var addedUserIds = _ref4.addedUserIds,
                            removedUserIds = _ref4.removedUserIds;
                        return _this2.managersEditorChangesHandler.handleAssignedUsersChange(addedUserIds, removedUserIds);
                    },
                    titleMessageKey: "assigned_users_editor.managers.customer.title",
                    userSubtitleGenerator: function userSubtitleGenerator(user) {
                        if (user.hasAllAssignments) {
                            return _messageResource2.default.getMessage("assigned_users_editor.managers.customer.has_all_assignments");
                        }
                    },
                    addUsersMessageKey: "assigned_users_editor.managers.add_title",
                    showPermissionIcons: true,
                    checkIfCanModify: function checkIfCanModify(user) {
                        return !user.hasManageAssignment;
                    },
                    getListDisabledTooltipText: function getListDisabledTooltipText(user) {
                        return _this2._getDisabledTooltipText(user);
                    },
                    getSelectorDisabledTooltipText: function getSelectorDisabledTooltipText(user) {
                        return _this2._getDisabledTooltipText(user);
                    },
                    renderUserSelectorToContent: true,
                    refreshScrollCb: this.callbacks.refreshScrollCb
                }),
                containerClass: "managersTab"
            }).init(this.$el);
            managersEditor.setState({
                isBTYEnabled: (0, _utils2.isEnabled)(this.params.enabledFeatures, _features.Feature.BTY),
                isURAEnabled: (0, _utils2.isEnabled)(this.params.enabledFeatures, _features.Feature.URA),
                isTTAEnabled: (0, _utils2.isEnabled)(this.params.enabledFeatures, _features.Feature.TTA)
            });

            this.managersEditorContainer = new _AssignedUsersEditorContainer2.default({
                assignedUsersEditor: managersEditor,
                $tabTitle: tabHeaders.$managersTabTitle,
                tabTitleMessageKey: "task.edit_panel.tabs.managers_with_count"
            }).init();
            this.managersEditorChangesHandler = new _AssignedUsersEditorChangesHandler2.default({
                editor: this.managersEditorContainer,
                assignedUserModelExtender: function assignedUserModelExtender(assigned) {
                    return { hasCustomerAssignment: assigned };
                },
                changeCallback: function changeCallback() {
                    return _this2.callbacks.onChangeCb();
                }
            });

            var tabs = new Map([[TAB_KEYS.DETAILS, new _ProxyView2.default((0, _jquery2.default)(".customerInfoDiv"))], [TAB_KEYS.ASSIGNED_USERS, assignedUsersEditor], [TAB_KEYS.MANAGERS, managersEditor]]);

            tabs.forEach(function ($tab, tabKey) {
                $tab.hide();
            });

            this.tabsController = new _TabsController2.default({
                tabs: tabs
            }).init();

            this.buttons = new Map([[TAB_KEYS.DETAILS, tabHeaders.$detailsTabHeader], [TAB_KEYS.ASSIGNED_USERS, tabHeaders.$assignedUsersTabHeader], [TAB_KEYS.MANAGERS, tabHeaders.$managersTabHeader]]);

            this.buttons.forEach(function ($button, key) {
                $button.click(function () {
                    _this2.openTabByKey(key);
                });
            });

            if ((0, _utils2.isEnabled)(this.params.enabledFeatures, _features.Feature.WAS)) {
                this.assignedUsersEditorContainer.setState({
                    userGroupsEnabled: this.params.assignedUsersData.userGroupsEnabled,
                    timeZoneGroupsEnabled: this.params.assignedUsersData.timeZoneGroupsEnabled,
                    users: this.params.assignedUsersData.users,
                    userGroups: this.params.assignedUsersData.userGroups ? (0, _groupUtils.addDefaultUserGroup)(this.params.assignedUsersData.userGroups) : this.params.assignedUsersData.userGroups,
                    timeZoneGroups: this.params.assignedUsersData.timeZoneGroups,
                    canModifyAny: this.params.assignedUsersData.canModifyAny
                });
            } else {
                this.buttons.get(TAB_KEYS.ASSIGNED_USERS).hide();
            }

            this.managersEditorContainer.setState({
                userGroupsEnabled: this.params.assignedUsersDataForManagers.userGroupsEnabled,
                timeZoneGroupsEnabled: this.params.assignedUsersDataForManagers.timeZoneGroupsEnabled,
                users: this.params.assignedUsersDataForManagers.users,
                userGroups: this.params.assignedUsersDataForManagers.userGroups ? (0, _groupUtils.addDefaultUserGroup)(this.params.assignedUsersDataForManagers.userGroups) : this.params.assignedUsersDataForManagers.userGroups,
                timeZoneGroups: this.params.assignedUsersDataForManagers.timeZoneGroups,
                canModifyAny: this.params.assignedUsersDataForManagers.canModifyAny,
                hideAssignButton: !this.params.assignedUsersDataForManagers.canModifyAny
            });
        }
    }, {
        key: "update",
        value: function update() {
            this.openTabByKey(TAB_KEYS.DETAILS);
        }
    }, {
        key: "openTabByKey",
        value: function openTabByKey(key) {
            this.setState({ currentTabKey: key });
        }
    }, {
        key: "_getDisabledTooltipText",
        value: function _getDisabledTooltipText(user) {
            var msg = _messageResource2.default.getMessage('assigned_users_editor.managers.disabled_tooltip', [_messageResource2.default.getMessage('common.customer'), user.firstName]);
            msg += " " + _messageResource2.default.getMessage('assigned_users_editor.managers.disabled_tooltip.entire_scope');
            return msg;
        }
    }, {
        key: "getData",
        value: function getData() {
            return [this.getCustomerName(), this.getDescription(), this.state.selectedCustomerId, this.copySettingsBlock.getSelectedSettings(), this.assignedUsersEditorChangesHandler.getAddedUserIds(), this.managersEditorChangesHandler.getAddedUserIds()];
        }
    }, {
        key: "initNameField",
        value: function initNameField() {
            var _this3 = this;

            this.nameField = this.find(".newNameField");

            this.nameField.off();
            this.nameField.blur(function () {
                return _this3.callbacks.onBlurNameCb(_this3.nameField);
            });
            this.nameField.keyup(function () {
                return _this3.callbacks.onNameKeyUpCb(_this3.nameField);
            });
            this.nameField.change(function () {
                return _this3.callbacks.onChangeNameCb(_this3.nameField);
            });
            this.nameField.keydown(function () {
                return _this3.callbacks.onNameKeyPressCb(_this3.nameField);
            });
        }
    }, {
        key: "initPlaceholders",
        value: function initPlaceholders() {
            this.nameField.placeholder();
        }
    }, {
        key: "getNameField",
        value: function getNameField() {
            return this.nameField;
        }
    }, {
        key: "getCustomerName",
        value: function getCustomerName() {
            return this.nameField.pVal();
        }
    }, {
        key: "initDescriptionField",
        value: function initDescriptionField() {
            var _this4 = this;

            this.$description = this.find(".descriptionSection .description");
            this.description = new _Description.Description({
                onChange: function onChange(description) {
                    _this4.description.setState({
                        text: description
                    });
                    _this4.callbacks.onChangeDescriptionCb(description);
                }
            }).init(this.$description);

            this.description.setState({
                placeholder: _messageResource2.default.getMessage("customer.edit.description.placeholder.text"),
                editable: true
            });
        }
    }, {
        key: "getDescription",
        value: function getDescription() {
            return this.description.getText();
        }
    }, {
        key: "getCustomerSelectorList",
        value: function getCustomerSelectorList() {
            return this.customersSelector.getMenuEl();
        }
    }, {
        key: "initCustomerSelector",
        value: function initCustomerSelector(customerInfos) {
            var _this5 = this;

            var initialValue = { id: -1, name: _messageResource2.default.getEscapedMessage("task.list.move_to.select_customer") };

            var items = [];
            items.push.apply(items, _toConsumableArray(customerInfos));

            this.$customerSelectorPlaceHolder.empty();

            this.customersSelector = new _CPCombobox2.default({
                emptySelectionMessageKey: "task.list.move_to.select_customer",
                notFoundMessageKey: "task.list.move_to.no_customers_found",
                hiddenItemsCollapsedMessageKey: 'task.list.move_to.show_archived_customers',
                hiddenItemsExpandedMessageKey: 'task.list.move_to.hide_archived_customers',
                emptyListMessageKey: "task.list.move_to.no_customers",
                onItemSelectedCb: function onItemSelectedCb(item) {
                    _this5.setState({
                        selectedCustomerId: item.id
                    });
                },
                onListShowCb: function onListShowCb() {
                    _this5.$customerImportDiv.addClass('withCustomerSelector');
                    _this5.callbacks.scrollToSelectorCb();
                    _this5.callbacks.refreshScrollCb();
                },
                onListHideCb: function onListHideCb() {
                    _this5.$customerImportDiv.removeClass('withCustomerSelector');
                    _this5.callbacks.refreshScrollCb();
                },
                positionParams: {
                    within: this.getEl()
                }
            }).init((0, _jquery2.default)(this.$customerSelectorPlaceHolder));
            this.customersSelector.setState({
                additionalItems: [initialValue],
                items: items
            });
        }
    }, {
        key: "initImportSettings",
        value: function initImportSettings() {
            var $importSettings = this.find(".customerImportSettingsDiv");

            var enabledFeatures = this.params.enabledFeatures;
            var wasEnabled = (0, _utils2.isEnabled)(enabledFeatures, _features.Feature.WAS);

            this.copySettingsBlock = new _CopySettingsBlock2.default(_extends({
                additionalClass: 'copyProject'
            }, (0, _utils.getItemsForCopyProjectSettingsBlock)(this.params.canManageAccountsAndPermissions, (0, _utils2.isEnabled)(enabledFeatures, _features.Feature.BTY), (0, _utils2.isEnabled)(enabledFeatures, _features.Feature.EST), (0, _utils2.isEnabled)(enabledFeatures, _features.Feature.TWS), wasEnabled, this.params.hasSomeTeamAssignment))).init(this.$importSettings);

            new _InformationBlock2.default({
                paragraphs: [_messageResource2.default.getMessage(wasEnabled ? 'customer.create.copy_assignments_info' : 'customer.create.copy_assignments_info_was_off')]
            }).init(this.$importSettings);
        }
    }, {
        key: "setErrorClasses",
        value: function setErrorClasses(classes) {
            this.find('.customerInfoDiv').removeClass().addClass(classes.join(' ')).addClass('customerInfoDiv');
        }
    }]);

    return Content;
}(_TemplateView3.default);

exports.default = Content;

/***/ }),
/* 1872 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _Button = __webpack_require__(33);

var _Button2 = _interopRequireDefault(_Button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CreateProjectLightboxFooter = function (_TemplateView) {
    _inherits(CreateProjectLightboxFooter, _TemplateView);

    function CreateProjectLightboxFooter() {
        _classCallCheck(this, CreateProjectLightboxFooter);

        return _possibleConstructorReturn(this, (CreateProjectLightboxFooter.__proto__ || Object.getPrototypeOf(CreateProjectLightboxFooter)).call(this, null));
    }

    _createClass(CreateProjectLightboxFooter, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class="createLightBoxFooter">' + '    <div class="errorMessageBox">' + '        <div class="errorIcon"/>' + '        <span class="errormsg"><%-errorMsg%></span>' + '    </div>' + '    <div class="buttonsBox">' + '        <span class="changesMsg"><%-changesMsg%></span>' + '        <span class="savingMsg"><%-savingMsg%></span>' + '        <div class="commitButtonPlaceHolder"/> ' + '        <div class="greyButton cancelBtn"><%-cancelBtn%></div>' + '    </div>' + '</div>';
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            var title = _messageResource2.default.getMessage("customer.create.commit_button.text");
            if (title.length > 17) {
                title = _messageResource2.default.getMessage("customer.create.commit_button.default_text");
            }
            this.commitButton = new _Button2.default({
                label: title,
                withPlusIcon: true
            }).init(this.find('.commitButtonPlaceHolder'));
        }
    }, {
        key: 'messageKeys',
        value: function messageKeys() {
            return {
                errorMsg: 'customer.edit.correct_errors',
                changesMsg: 'customer.edit.not_saved',
                savingMsg: 'customer.edit.saving',
                cancelBtn: 'customer.edit.cancel_button.text'
            };
        }
    }, {
        key: 'getCommitBtnEl',
        value: function getCommitBtnEl() {
            return this.commitButton.getEl();
        }
    }, {
        key: 'getCancelBtnEl',
        value: function getCancelBtnEl() {
            return this.find('.cancelBtn');
        }
    }]);

    return CreateProjectLightboxFooter;
}(_TemplateView3.default);

exports.default = CreateProjectLightboxFooter;

/***/ }),
/* 1873 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Header = function (_TemplateView) {
    _inherits(Header, _TemplateView);

    function Header() {
        _classCallCheck(this, Header);

        return _possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).call(this, null));
    }

    _createClass(Header, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<table class="dialog-header">' + '    <tr>' + '        <td>' + '            <div class="close-button">' + '                <div id="customerLightBoxCloseButton" class="closeButton"></div>' + '                <div class="disabledCloseButton"></div>' + '            </div>' + '' + '            <div class="lightBoxTitle">' + '                <span id="<%=id%>_titlePlaceholder"><%-title%></span>' + '            </div>' + '        </td>' + '    </tr>' + '</table>';
        }
    }, {
        key: 'messageKeys',
        value: function messageKeys() {
            return {
                title: 'customer.create.popup.title'
            };
        }
    }, {
        key: 'getCloseButtonEl',
        value: function getCloseButtonEl() {
            return this.find('.closeButton');
        }
    }]);

    return Header;
}(_TemplateView3.default);

exports.default = Header;

/***/ }),
/* 1874 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _TaskPanelContainer2 = __webpack_require__(784);

var _TaskPanelContainer3 = _interopRequireDefault(_TaskPanelContainer2);

var _CreateTaskPanel = __webpack_require__(1875);

var _CreateTaskPanel2 = _interopRequireDefault(_CreateTaskPanel);

var _utils = __webpack_require__(6);

var _selectors = __webpack_require__(405);

var _actions = __webpack_require__(575);

var _redux = __webpack_require__(7);

var _constants = __webpack_require__(62);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CreateTaskPanelContainer = function (_TaskPanelContainer) {
    _inherits(CreateTaskPanelContainer, _TaskPanelContainer);

    function CreateTaskPanelContainer(_ref) {
        var _ref$openPanel = _ref.openPanel,
            openPanel = _ref$openPanel === undefined ? function () {} : _ref$openPanel,
            _ref$onPanelHideCb = _ref.onPanelHideCb,
            onPanelHideCb = _ref$onPanelHideCb === undefined ? function () {} : _ref$onPanelHideCb,
            _ref$loadPanelData = _ref.loadPanelData,
            loadPanelData = _ref$loadPanelData === undefined ? function () {} : _ref$loadPanelData,
            _ref$hideHandler = _ref.hideHandler,
            hideHandler = _ref$hideHandler === undefined ? function () {} : _ref$hideHandler;

        _classCallCheck(this, CreateTaskPanelContainer);

        return _possibleConstructorReturn(this, (CreateTaskPanelContainer.__proto__ || Object.getPrototypeOf(CreateTaskPanelContainer)).call(this, {
            additionalClass: 'create_task_sliding_panel sliding_panel',
            panelContent: new _CreateTaskPanel2.default({
                canEdit: true,
                showReportTab: false,
                showCreateFooter: true,
                showEmptyTaskNameInput: true,
                dateFormat: Date.convertSmartToExtDateFormat(window.SystemSettings.dateFormat).replace(/F/, "M")
            }),
            panelType: _constants.PANEL_TYPES.CREATE_TASK,
            needToHideOnOutsideClick: false,
            needShowMoire: true,
            showCopyLink: false,
            openPanel: openPanel,
            loadPanelData: loadPanelData,
            onPanelHideCb: onPanelHideCb,
            hideHandler: hideHandler
        }));
    }

    return CreateTaskPanelContainer;
}(_TaskPanelContainer3.default);

exports.default = (0, _utils.connect)(function (state) {
    return {
        isShown: (0, _selectors.isPanelOpened)(state),
        needToLoadData: (0, _selectors.isNeedToLoadData)(state),
        loading: (0, _selectors.isLoading)(state)
    };
}, function (dispatch) {
    return {
        openPanel: (0, _redux.bindActionCreators)(_actions.openCreateTaskPanel, dispatch),
        onPanelHide: (0, _redux.bindActionCreators)(_actions.closeCreateTaskPanel, dispatch),
        loadPanelData: (0, _redux.bindActionCreators)(_actions.loadCreateTaskPanelData, dispatch),
        hideHandler: (0, _redux.bindActionCreators)(_actions.cancelTaskCreation, dispatch)
    };
})(CreateTaskPanelContainer);

/***/ }),
/* 1875 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _TaskPanel = __webpack_require__(483);

var _TaskPanel2 = _interopRequireDefault(_TaskPanel);

var _utils = __webpack_require__(6);

var _selectors = __webpack_require__(405);

var _redux = __webpack_require__(7);

var _selectors2 = __webpack_require__(15);

var _actions = __webpack_require__(575);

var _selectors3 = __webpack_require__(14);

var _selectors4 = __webpack_require__(504);

var _selectors5 = __webpack_require__(190);

var _selectors6 = __webpack_require__(19);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _utils.connect)(function (state) {
    return {
        name: (0, _selectors.getTaskName)(state),
        workflowStatusId: (0, _selectors.getTaskStatusId)(state),
        completed: (0, _selectors.isTaskCompleted)(state),
        deadline: (0, _selectors.getTaskDeadline)(state),
        typeOfWork: (0, _selectors.getBillingType)(state),
        typesOfWork: (0, _selectors4.getSortedTypeOfWorkList)(state),
        estimatedTime: (0, _selectors.getEstimatedTime)(state),
        description: (0, _selectors.getTaskDescription)(state),
        canReopenProject: true,

        isBTYEnabled: (0, _selectors2.isBTYEnabled)(state),
        isURAEnabled: (0, _selectors2.isURAEnabled)(state),
        isBRAEnabled: (0, _selectors2.isBRAEnabled)(state),
        isTWSEnabled: (0, _selectors2.isTWSEnabled)(state),
        isESTEnabled: (0, _selectors2.isESTEnabled)(state),
        isWASEnabled: (0, _selectors2.isWASEnabled)(state),
        isTTAEnabled: (0, _selectors2.isTTAEnabled)(state),

        errors: (0, _selectors.getTaskPanelErrors)(state),
        projectName: (0, _selectors.getProjectName)(state),
        customerName: (0, _selectors.getCustomerName)(state),
        assignedUsers: (0, _selectors.getAssignedUsers)(state),
        assignedManagers: (0, _selectors.getAssignedManagers)(state),
        userGroupsEnabled: (0, _selectors2.isUGREnabled)(state),
        timeZoneGroupsEnabled: (0, _selectors2.isTZGEnabled)(state),
        userGroups: (0, _selectors3.getUserGroups)(state),
        timeZoneGroups: (0, _selectors3.getTimeZoneGroups)(state),
        canModifyAnyUser: (0, _selectors.canModifyAnyUser)(state),
        canModifyAnyManager: (0, _selectors.canModifyAnyManager)(state),
        canGenerateMoneyReports: (0, _selectors6.canGenerateMoneyReports)(state),

        currentTabKey: (0, _selectors.getTaskPanelTabKey)(state),
        lastSelectedTabKey: (0, _selectors.getLastTaskPanelTabKey)(state),
        isNeedInitializeFocus: (0, _selectors.isNeedInitializeFocus)(state),

        customFields: (0, _selectors5.selectTaskCustomFields)(state),
        customFieldsValues: (0, _selectors.getCustomFieldsValuesWithDefaults)(state)
    };
}, function (dispatch) {
    return _extends({
        closeTaskPanel: (0, _redux.bindActionCreators)(_actions.cancelTaskCreation, dispatch),
        createTask: (0, _redux.bindActionCreators)(_actions.createTask, dispatch),
        deleteAssignedUser: (0, _redux.bindActionCreators)(_actions.deleteAssignedUser, dispatch),
        updateAssignedUsers: (0, _redux.bindActionCreators)(_actions.updateAssignedUsers, dispatch),
        deleteAssignedManager: (0, _redux.bindActionCreators)(_actions.deleteAssignedManager, dispatch),
        updateAssignedManagers: (0, _redux.bindActionCreators)(_actions.updateAssignedManagers, dispatch),
        setTaskPanelTab: (0, _redux.bindActionCreators)(_actions.setTaskPanelTab, dispatch),
        setLastTaskPanelTab: (0, _redux.bindActionCreators)(_actions.setLastTaskPanelTab, dispatch),
        openLastTaskPanelTab: (0, _redux.bindActionCreators)(_actions.openLastTaskPanelTab, dispatch)
    }, (0, _redux.bindActionCreators)({
        updateName: _actions.updateName,
        updateStatus: _actions.updateStatus,
        updateDeadline: _actions.updateDeadline,
        updateTypeOfWork: _actions.updateTypeOfWork,
        updateEstimate: _actions.updateEstimate,
        updateDescription: _actions.updateDescription,
        updateCustomField: _actions.updateCustomField
    }, dispatch));
})(_TaskPanel2.default);

/***/ }),
/* 1876 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LongTimeMs = 30000;

var BulkOperationProgress = function (_TemplateView) {
    _inherits(BulkOperationProgress, _TemplateView);

    function BulkOperationProgress() {
        _classCallCheck(this, BulkOperationProgress);

        var _this = _possibleConstructorReturn(this, (BulkOperationProgress.__proto__ || Object.getPrototypeOf(BulkOperationProgress)).call(this));

        _this.state = {
            progress: 0,
            longTimeWarningShown: false
        };

        _this.onStatePropertyChanged('progress', function (progress, oldProgress) {
            if (progress === null) {
                _this.setState({ longTimePassed: false });
                setTimeout(function () {
                    _this.setState({ longTimePassed: true });
                }, LongTimeMs);
            }
            _this.$completedLabel.toggle(!!progress && progress > 0);
            _this.$percent.text(!!progress && progress > 0 ? progress + ' %' : '');
            if (!!progress && progress > 0) {
                _this.$longProgress.hide();
            }
        });

        _this.onStatePropertyChanged('longTimePassed', function (longTimePassed) {
            if (!longTimePassed) {
                _this.$longProgress.hide();
            }
            if (longTimePassed && !_this.state.progress) {
                _this.$longProgress.show();
            }
        });
        return _this;
    }

    _createClass(BulkOperationProgress, [{
        key: 'afterRender',
        value: function afterRender() {
            this.$percent = this.find('.percents');
            this.$completedLabel = this.find('.completedLabel');
            this.$longProgress = this.find('.longProgress');
        }
    }, {
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class="bulkOperationProgress">' + '    <span class="percents"></span>' + '    <span class="completedLabel"><%=completed%></span>' + '    <span class="longProgress"><%=longProgress%></span>' + '</div>';
        }
    }, {
        key: 'messageKeys',
        value: function messageKeys() {
            return {
                completed: 'task.list.bulk_operations.progress.completed',
                longProgress: 'task.list.bulk_operations.progress.long'
            };
        }
    }]);

    return BulkOperationProgress;
}(_TemplateView3.default);

exports.default = BulkOperationProgress;

/***/ }),
/* 1877 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _utils = __webpack_require__(6);

var _selectors = __webpack_require__(15);

var _redux = __webpack_require__(7);

var _FeatureDiffController = __webpack_require__(831);

var _features = __webpack_require__(22);

var _actions = __webpack_require__(55);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PageFeatureDiffController = function (_FeatureDiffControlle) {
    _inherits(PageFeatureDiffController, _FeatureDiffControlle);

    function PageFeatureDiffController(_ref) {
        var _ref$handleFeatureCha = _ref.handleFeatureChange,
            handleFeatureChange = _ref$handleFeatureCha === undefined ? function () {} : _ref$handleFeatureCha;

        _classCallCheck(this, PageFeatureDiffController);

        return _possibleConstructorReturn(this, (PageFeatureDiffController.__proto__ || Object.getPrototypeOf(PageFeatureDiffController)).call(this, {
            handledFeatures: [_features.Feature.TWS, _features.Feature.BTY, _features.Feature.EST, _features.Feature.WAS],
            onFeaturesChanged: handleFeatureChange
        }));
    }

    return PageFeatureDiffController;
}(_FeatureDiffController.FeatureDiffController);

exports.default = (0, _utils.connect)(function (state) {
    return {
        features: (0, _selectors.selectFeatures)(state)
    };
}, function (dispatch) {
    return {
        handleFeatureChange: (0, _redux.bindActionCreators)(_actions.handleFeatureChange, dispatch)
    };
})(PageFeatureDiffController);

/***/ }),
/* 1878 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _View2 = __webpack_require__(20);

var _View3 = _interopRequireDefault(_View2);

var _utils = __webpack_require__(6);

var _redux = __webpack_require__(7);

var _selectors = __webpack_require__(106);

var _actions = __webpack_require__(194);

var _selectors2 = __webpack_require__(27);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SelectionController = function (_View) {
    _inherits(SelectionController, _View);

    function SelectionController(_ref) {
        var _ref$loadExistingTask = _ref.loadExistingTaskIdsAction,
            loadExistingTaskIdsAction = _ref$loadExistingTask === undefined ? function () {} : _ref$loadExistingTask,
            _ref$cleanupSelection = _ref.cleanupSelectionsDataAction,
            cleanupSelectionsDataAction = _ref$cleanupSelection === undefined ? function () {} : _ref$cleanupSelection,
            _ref$cleanupExistingT = _ref.cleanupExistingTaskIdsAction,
            cleanupExistingTaskIdsAction = _ref$cleanupExistingT === undefined ? function () {} : _ref$cleanupExistingT,
            _ref$cleanupNonExisti = _ref.cleanupNonExistingSelectedIdsAction,
            cleanupNonExistingSelectedIdsAction = _ref$cleanupNonExisti === undefined ? function () {} : _ref$cleanupNonExisti;

        _classCallCheck(this, SelectionController);

        var _this = _possibleConstructorReturn(this, (SelectionController.__proto__ || Object.getPrototypeOf(SelectionController)).call(this, null));

        _this.state = {
            selectedTaskIdsArray: [],
            needToLoadExistingIds: false,

            singleCPSelection: {},
            selectionAvailable: false,

            viewMode: null,
            tasksLoaded: false
        };

        _this.actions = {
            loadExistingTaskIdsAction: loadExistingTaskIdsAction,
            cleanupSelectionsDataAction: cleanupSelectionsDataAction,
            cleanupExistingTaskIdsAction: cleanupExistingTaskIdsAction,
            cleanupNonExistingSelectedIdsAction: cleanupNonExistingSelectedIdsAction
        };

        _this.onStatePropertyBecameTrue('needToLoadExistingIds', function () {
            _this.actions.loadExistingTaskIdsAction();
        });

        _this.onStatePropertyChanged('selectedTaskIdsArray', function (selectedIds, prevSelected) {
            var prevSelectedTasksCount = prevSelected ? prevSelected.length : 0;
            var selectedTasksCount = selectedIds.length;

            if (prevSelectedTasksCount !== selectedTasksCount && selectedTasksCount === 0) {
                _this.actions.cleanupSelectionsDataAction();
            }
        });

        // clear selection if filters changed
        _this.onStatePropertyDeeplyChanged('singleCPSelection', function (currentSelection) {
            var prevSelection = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
                projectId: null,
                customerId: null
            };
            var projectId = currentSelection.projectId;

            var prevProjectId = prevSelection.projectId;

            if (prevProjectId != null && projectId !== null && prevProjectId !== projectId) {
                _this.actions.cleanupSelectionsDataAction();
            }
        });

        _this.onStatePropertyBecameValue('selectionAvailable', false, function () {
            _this.actions.cleanupSelectionsDataAction();
        });

        _this.onStatePropertyBecameTrue('tasksLoaded', function () {
            // when data loaded need to sync selected ids with actual loaded
            // it's add usability when filters changed (search/statuses) or if sorting changed - no need reselect tasks
            // for case if there are problems - possible to replace by `cleanupSelectionsDataAction`
            _this.actions.cleanupExistingTaskIdsAction();
        });

        _this.onStatePropertyChanged('viewMode', function () {
            // update selected ids with current existing (may be differ). only if tab already loaded
            if (_this.state.tasksLoaded) {
                _this.actions.cleanupNonExistingSelectedIdsAction();
            }
        });
        return _this;
    }

    return SelectionController;
}(_View3.default);

exports.default = (0, _utils.connect)(function (state) {
    return {
        selectedTaskIdsArray: (0, _selectors.getSelectedTaskIdsArray)(state),
        needToLoadExistingIds: (0, _selectors.isNeedToLoadExistingTaskIds)(state),
        tasksLoaded: (0, _selectors.isTasksLoaded)(state),
        singleCPSelection: (0, _selectors2.getSingleCPSelection)(state),
        selectionAvailable: (0, _selectors2.isNeedToShowSelection)(state),
        viewMode: (0, _selectors2.getViewMode)(state)
    };
}, function (dispatch) {
    return {
        loadExistingTaskIdsAction: (0, _redux.bindActionCreators)(_actions.loadExistingTaskIdsAction, dispatch),
        cleanupSelectionsDataAction: (0, _redux.bindActionCreators)(_actions.cleanupSelectionsData, dispatch),
        cleanupExistingTaskIdsAction: (0, _redux.bindActionCreators)(_actions.cleanupExistingTaskIds, dispatch),
        cleanupNonExistingSelectedIdsAction: (0, _redux.bindActionCreators)(_actions.cleanupNonExistingSelectedIds, dispatch)
    };
})(SelectionController);

/***/ }),
/* 1879 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isShowLoadingMoire = undefined;

var _reselect = __webpack_require__(13);

var _selectors = __webpack_require__(367);

var _selectors2 = __webpack_require__(27);

var isShowLoadingMoire = exports.isShowLoadingMoire = (0, _reselect.createSelector)(_selectors2.getCommonState, _selectors.isProcessingBulkOperation, function (common, bulkProcessing) {
    return common.showLoadingMoire || bulkProcessing;
});

/***/ }),
/* 1880 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _redux = __webpack_require__(7);

var _utils = __webpack_require__(6);

var _selectors = __webpack_require__(97);

var _actions = __webpack_require__(81);

var _EditTaskPanelContainer = __webpack_require__(783);

var _EditTaskPanelContainer2 = _interopRequireDefault(_EditTaskPanelContainer);

var _selectors2 = __webpack_require__(19);

var _selectors3 = __webpack_require__(15);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _utils.connect)(function (state) {
    return {
        isShown: (0, _selectors.isPanelOpened)(state),
        needToLoadData: (0, _selectors.isNeedToLoadData)(state),
        loading: (0, _selectors.isLoading)(state),
        openTaskId: (0, _selectors.getOpenTaskId)(state),
        openTaskNextId: (0, _selectors.getOpenTaskNextId)(state),
        isOpenTaskCompleted: (0, _selectors.getIsOpenTaskCompleted)(state),
        isTSTEnabled: (0, _selectors3.isTSTEnabled)(state),
        userRights: (0, _selectors2.getAccessRights)(state)
    };
}, function (dispatch) {
    return {
        openPanel: (0, _redux.bindActionCreators)(_actions.openEditTaskPanel, dispatch),
        onPanelHide: (0, _redux.bindActionCreators)(_actions.closeEditTaskPanel, dispatch),
        loadPanelData: (0, _redux.bindActionCreators)(_actions.loadEditTaskPanelData, dispatch),
        copyLink: (0, _redux.bindActionCreators)(_actions.copyLinkTo, dispatch)
    };
})(_EditTaskPanelContainer2.default);

/***/ }),
/* 1881 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.UrlHelper = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _View2 = __webpack_require__(20);

var _View3 = _interopRequireDefault(_View2);

var _utils = __webpack_require__(6);

var _redux = __webpack_require__(7);

var _atUtils = __webpack_require__(5);

var _actions = __webpack_require__(81);

var _selectors = __webpack_require__(97);

var _actions2 = __webpack_require__(141);

var _selectors2 = __webpack_require__(244);

var _actions3 = __webpack_require__(308);

var _selectors3 = __webpack_require__(249);

var _utils2 = __webpack_require__(369);

var _constants = __webpack_require__(765);

var _selectors4 = __webpack_require__(405);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UrlHelper = exports.UrlHelper = function (_View) {
    _inherits(UrlHelper, _View);

    function UrlHelper(_ref) {
        var _ref$openTaskPanel = _ref.openTaskPanel,
            openTaskPanel = _ref$openTaskPanel === undefined ? function (taskId) {} : _ref$openTaskPanel,
            _ref$openProjectPanel = _ref.openProjectPanel,
            openProjectPanel = _ref$openProjectPanel === undefined ? function (projectId) {} : _ref$openProjectPanel,
            _ref$openCustomerPane = _ref.openCustomerPanel,
            openCustomerPanel = _ref$openCustomerPane === undefined ? function (customerId) {} : _ref$openCustomerPane,
            _ref$openCreateTaskPo = _ref.openCreateTaskPopup,
            openCreateTaskPopup = _ref$openCreateTaskPo === undefined ? function () {} : _ref$openCreateTaskPo;

        _classCallCheck(this, UrlHelper);

        var _this = _possibleConstructorReturn(this, (UrlHelper.__proto__ || Object.getPrototypeOf(UrlHelper)).call(this, null));

        _this._callOpenPanelAction = function (action, id) {
            (0, _atUtils.defer)(function () {
                return action(id, true);
            });
        };

        _this._callOpenCreatePanelAction = function (action, taskName) {
            (0, _atUtils.defer)(function () {
                action();
                (0, _utils2.removeUrlParamFromQuery)(_constants.TASK_NAME_QUERY_KEY);
                (0, _utils2.removeUrlParamFromQuery)(_constants.PAGE_ACTION_QUERY_KEY);
            });
        };

        _this._createHandleOpenPanelIdChanged = function (queryKey) {
            return function (id, prevId) {
                if (id !== null) {
                    (0, _utils2.replaceIdIntoQuery)(queryKey, id, prevId);
                } else if (prevId) {
                    (0, _utils2.removeUrlParamFromQuery)(queryKey);
                }
            };
        };

        _this.state = {
            taskId: null,
            projectId: null,
            customerId: null
        };

        _this.callbacks = {
            openCreateTaskPopup: openCreateTaskPopup
        };

        _this.actions = {
            openTaskPanel: openTaskPanel,
            openProjectPanel: openProjectPanel,
            openCustomerPanel: openCustomerPanel
        };

        _this.onStatePropertyChanged('taskId', _this._createHandleOpenPanelIdChanged(_constants.TASK_ID_QUERY_KEY));

        _this.onStatePropertyChanged('projectId', _this._createHandleOpenPanelIdChanged(_constants.PROJECT_ID_QUERY_KEY));

        _this.onStatePropertyChanged('customerId', _this._createHandleOpenPanelIdChanged(_constants.CUSTOMER_ID_QUERY_KEY));
        return _this;
    }

    _createClass(UrlHelper, [{
        key: 'afterRender',
        value: function afterRender() {
            // get all ids from query
            // first priority for task id
            // second project id
            // third customer id
            var taskId = (0, _utils2.getIdFromQuery)(_constants.TASK_ID_QUERY_KEY);
            var projectId = (0, _utils2.getIdFromQuery)(_constants.PROJECT_ID_QUERY_KEY);
            var customerId = (0, _utils2.getIdFromQuery)(_constants.CUSTOMER_ID_QUERY_KEY);
            var pageAction = (0, _utils2.getStringFromQuery)(_constants.PAGE_ACTION_QUERY_KEY);
            var taskName = (0, _utils2.getStringFromQuery)(_constants.TASK_NAME_QUERY_KEY);

            // check contains url page action and equals action to create task
            // If new actions appear on the page, you need to add more branches
            if (pageAction && pageAction === _constants.CREATE_TASK_PAGE_ACTION) {
                this._callOpenCreatePanelAction(this.callbacks.openCreateTaskPopup, taskName);
            } else {
                this._tryToOpenEntityPanel(taskId, projectId, customerId);
            }
        }
    }, {
        key: '_tryToOpenEntityPanel',
        value: function _tryToOpenEntityPanel(taskId, projectId, customerId) {
            if (taskId !== null) {
                this._callOpenPanelAction(this.actions.openTaskPanel, taskId);
            } else if (projectId !== null) {
                this._callOpenPanelAction(this.actions.openProjectPanel, projectId);
            } else if (customerId !== null) {
                this._callOpenPanelAction(this.actions.openCustomerPanel, customerId);
            }
        }
    }]);

    return UrlHelper;
}(_View3.default);

exports.default = (0, _utils.connect)(function (state) {
    return {
        taskId: (0, _selectors.getOpenTaskId)(state),
        projectId: (0, _selectors2.getOpenProjectId)(state),
        customerId: (0, _selectors3.getOpenCustomerId)(state)
    };
}, function (dispatch) {
    return {
        openTaskPanel: (0, _redux.bindActionCreators)(_actions.openEditTaskPanel, dispatch),
        openProjectPanel: (0, _redux.bindActionCreators)(_actions2.openProjectPanel, dispatch),
        openCustomerPanel: (0, _redux.bindActionCreators)(_actions3.openCustomerPanel, dispatch)
    };
})(UrlHelper);

/***/ }),
/* 1882 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = initApplication;

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _store = __webpack_require__(222);

var _index = __webpack_require__(22);

var _constants = __webpack_require__(23);

var _utils = __webpack_require__(202);

var _utils2 = __webpack_require__(362);

var _utils3 = __webpack_require__(242);

var _LocalStorage = __webpack_require__(72);

var _utils4 = __webpack_require__(929);

var _ToastsContainer = __webpack_require__(938);

var _ToastsContainer2 = _interopRequireDefault(_ToastsContainer);

var _utils5 = __webpack_require__(365);

var _utils6 = __webpack_require__(1884);

var _LicenseCountDownTip = __webpack_require__(939);

var _LicenseCountDownTip2 = _interopRequireDefault(_LicenseCountDownTip);

var _SupportQuestionButton = __webpack_require__(940);

var _SupportQuestionButton2 = _interopRequireDefault(_SupportQuestionButton);

var _ContactSupportDraggablePopupContainer = __webpack_require__(941);

var _ContactSupportDraggablePopupContainer2 = _interopRequireDefault(_ContactSupportDraggablePopupContainer);

var _utils7 = __webpack_require__(381);

var _WelcomeScreenContainer = __webpack_require__(943);

var _WelcomeScreenContainer2 = _interopRequireDefault(_WelcomeScreenContainer);

var _AddonsMenuContainer = __webpack_require__(1892);

var _AddonsMenuContainer2 = _interopRequireDefault(_AddonsMenuContainer);

var _initUserEventListeners = __webpack_require__(951);

var _initUserEventListeners2 = _interopRequireDefault(_initUserEventListeners);

var _StartupWizard = __webpack_require__(1895);

var _StartupWizard2 = _interopRequireDefault(_StartupWizard);

var _constants2 = __webpack_require__(4);

var _initIntercom = __webpack_require__(946);

var _initIntercom2 = _interopRequireDefault(_initIntercom);

var _DemoDataLoaderContainer = __webpack_require__(952);

var _DemoDataLoaderContainer2 = _interopRequireDefault(_DemoDataLoaderContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Common place for init all application data.
 * Place there initialization of all stores that used between several pages
 */
function initApplication() {
    var INIT_DATA = window.__INIT_APP_DATA__;
    var GENERATED_CONSTANTS = window.__GENERATED_CONSTANTS__;

    if (!INIT_DATA.WORKFLOW_STATUSES || !(0, _index.isEnabled)(_index.Feature.TWS)) {
        INIT_DATA.WORKFLOW_STATUSES = _constants.FAKE_WORKFLOW_STATUSES;
    }

    // load data from cookies
    INIT_DATA.USER_MANAGEMENT.ACTIVE_TAB_NUM = (0, _utils.getSavedActiveTabNumOrDefault)();

    // load data from local storage
    (0, _LocalStorage.initLocalStorage)(INIT_DATA.LOGGED_IN_USER.id, GENERATED_CONSTANTS.CLIENT_CODE);

    if (window.__IS_FIRST_SCREEN_AFTER_LOGIN__) {
        cleanupLocalStorageForNewSession();
    }

    INIT_DATA.COMMENTS = {
        TASK_NEW_COMMENTS: (0, _utils2.getTaskNewCommentsTextsFromLocalStorage)(),
        PROJECT_NEW_COMMENTS: (0, _utils2.getProjectNewCommentsTextsFromLocalStorage)(),
        CUSTOMER_NEW_COMMENTS: (0, _utils2.getCustomerNewCommentsTextsFromLocalStorage)(),
        IS_NEW_COMMENTS_ON_TOP: (0, _utils2.getCommentsOrderFromLocalStorage)()
    };

    INIT_DATA.TASK_MANAGEMENT.CP_PANEL_CLOSED = (0, _utils3.getCpPanelClosedStateInLocalStorage)();
    INIT_DATA.TASK_MANAGEMENT.CP_PANEL_WIDTH = (0, _utils4.loadCpPanelWidthFromLocalStorage)();
    INIT_DATA.TASK_MANAGEMENT.CP_PANEL_COLLAPSED_CUSTOMERS = (0, _utils4.loadCPPanelCollapsedCustomersFromLocalStorage)();
    INIT_DATA.TASK_MANAGEMENT.KANBAN_COLLAPSED_PROJECTS_STATE = (0, _utils5.getStoredCollapsedProjectsState)();
    INIT_DATA.TASK_MANAGEMENT.SINGLE_CP_SELECTION = (0, _utils3.getSingleCPSelectionFromLocalStorage)();

    INIT_DATA.GENERAL_SETTINGS = {
        DAR_SETTINGS_COLLAPSED_STATE: (0, _utils6.getStoredDARSettingsCollapsedState)()
    };

    INIT_DATA.SUPPORT = _extends({}, INIT_DATA.SUPPORT, {
        POPUP_INFO: _extends({}, (0, _utils7.getSupportPopupInfoFromLocalStorage)())
    });

    (0, _store.initStore)(INIT_DATA);

    (0, _initUserEventListeners2.default)();

    initCommonComponents(INIT_DATA);
}

function initCommonComponents(INIT_DATA) {
    var intercomEnabled = (0, _initIntercom2.default)();
    var $body = (0, _jquery2.default)('body');
    new _ToastsContainer2.default().init($body);
    new _LicenseCountDownTip2.default().init($body);
    if (!intercomEnabled) {
        new _SupportQuestionButton2.default().init((0, _jquery2.default)('.contactSupportButtonPlaceholder'));
    }
    new _ContactSupportDraggablePopupContainer2.default().init();
    new _AddonsMenuContainer2.default().init();

    if (INIT_DATA.WELCOME.needToLoadDemoData) {
        new _DemoDataLoaderContainer2.default().init();
    }

    if (INIT_DATA.WELCOME.showWelcomeScreen) {
        if (_constants2.isOlVersion) {
            new _StartupWizard2.default().init();
        } else {
            new _WelcomeScreenContainer2.default().init();
        }
    }
}

function cleanupLocalStorageForNewSession() {
    (0, _utils7.clearSupportPopupInfoInLocalStorage)();
}

/***/ }),
/* 1883 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Toast = function (_TemplateView) {
    _inherits(Toast, _TemplateView);

    function Toast(_ref) {
        var _ref$innerHtml = _ref.innerHtml,
            innerHtml = _ref$innerHtml === undefined ? '' : _ref$innerHtml,
            _ref$additionalClass = _ref.additionalClass,
            additionalClass = _ref$additionalClass === undefined ? '' : _ref$additionalClass,
            _ref$withCloseIcon = _ref.withCloseIcon,
            withCloseIcon = _ref$withCloseIcon === undefined ? false : _ref$withCloseIcon,
            _ref$onClose = _ref.onClose,
            onClose = _ref$onClose === undefined ? function () {} : _ref$onClose;

        _classCallCheck(this, Toast);

        var _this = _possibleConstructorReturn(this, (Toast.__proto__ || Object.getPrototypeOf(Toast)).call(this));

        _this.params = {
            innerHtml: innerHtml,
            additionalClass: additionalClass,
            withCloseIcon: withCloseIcon,
            onClose: onClose
        };
        return _this;
    }

    _createClass(Toast, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return "<div class='toastWrapper'>" + "    <div class='toast <%=additionalClass%>'>" + "        <span class='innerHtml'><%=innerHtml%></span>" + "        <span class='closeIcon'></span>" + "    </div>" + "</div>";
        }
    }, {
        key: 'templateModel',
        value: function templateModel() {
            return {
                innerHtml: this.params.innerHtml,
                additionalClass: this.params.additionalClass
            };
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            var _this2 = this;

            this.$el.atAnimation().fadeIn();

            if (this.params.withCloseIcon) {
                this.find('.closeIcon').click(function () {
                    return _this2.params.onClose();
                });
            }
        }
    }, {
        key: 'hide',
        value: function hide() {
            var _this3 = this;

            this.$el.atAnimation().hideAnimated('anim-hide-toast', function () {
                return _this3.$el.remove();
            });
        }
    }]);

    return Toast;
}(_TemplateView3.default);

exports.default = Toast;

/***/ }),
/* 1884 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.storeDARSettingsCollapsedState = storeDARSettingsCollapsedState;
exports.getStoredDARSettingsCollapsedState = getStoredDARSettingsCollapsedState;

var _LocalStorage = __webpack_require__(72);

var DAR_SETTINGS_COLLAPSED_STATE_LS_KEY = 'darSettingsCollapsedState';

function storeDARSettingsCollapsedState(collapsedState) {
    (0, _LocalStorage.getLocalStorage)().setItem(DAR_SETTINGS_COLLAPSED_STATE_LS_KEY, collapsedState);
}

function getStoredDARSettingsCollapsedState() {
    return (0, _LocalStorage.getLocalStorage)().getItem(DAR_SETTINGS_COLLAPSED_STATE_LS_KEY);
}

/***/ }),
/* 1885 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DraggablePopup = function (_TemplateView) {
    _inherits(DraggablePopup, _TemplateView);

    function DraggablePopup() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            _ref$contentComponent = _ref.contentComponent,
            contentComponent = _ref$contentComponent === undefined ? null : _ref$contentComponent,
            _ref$additionalClass = _ref.additionalClass,
            additionalClass = _ref$additionalClass === undefined ? '' : _ref$additionalClass,
            _ref$showHideButton = _ref.showHideButton,
            showHideButton = _ref$showHideButton === undefined ? true : _ref$showHideButton,
            _ref$noDragClass = _ref.noDragClass,
            noDragClass = _ref$noDragClass === undefined ? '' : _ref$noDragClass,
            _ref$onShow = _ref.onShow,
            onShow = _ref$onShow === undefined ? function () {} : _ref$onShow,
            _ref$onHide = _ref.onHide,
            onHide = _ref$onHide === undefined ? function () {} : _ref$onHide,
            _ref$onDragStop = _ref.onDragStop,
            onDragStop = _ref$onDragStop === undefined ? function () {} : _ref$onDragStop;

        _classCallCheck(this, DraggablePopup);

        var _this = _possibleConstructorReturn(this, (DraggablePopup.__proto__ || Object.getPrototypeOf(DraggablePopup)).call(this, null));

        _this.params = {
            contentComponent: contentComponent,
            additionalClass: additionalClass,
            showHideButton: showHideButton,
            noDragClass: noDragClass
        };

        _this.callbacks = {
            onShow: onShow,
            onHide: onHide,
            onDragStop: onDragStop
        };
        return _this;
    }

    _createClass(DraggablePopup, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class="components_draggablePopup <%-additionalClass%> ">' + '    <div class="dragIcon"/>' + '    <div class="hideButton"/>' + '    <div class="content"/>' + '</div>';
        }
    }, {
        key: 'templateModel',
        value: function templateModel() {
            return {
                additionalClass: this.params.additionalClass
            };
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            var _this2 = this;

            this.$hideButton = this.find('.hideButton');
            this.params.contentComponent.init(this.find('.content'));

            if (!this.params.showHideButton) {
                this.$hideButton.hide();
            } else {
                this.$hideButton.click(function () {
                    return _this2.hide();
                });
            }

            this.getEl().draggable({
                cancel: this.params.noDragClass ? '.' + this.params.noDragClass : '',
                containment: 'document',
                stop: function stop() {
                    return _this2.callbacks.onDragStop();
                }
            });
        }
    }, {
        key: 'hide',
        value: function hide() {
            this.callbacks.onHide();
            _get(DraggablePopup.prototype.__proto__ || Object.getPrototypeOf(DraggablePopup.prototype), 'hide', this).call(this);
        }
    }, {
        key: 'show',
        value: function show() {
            _get(DraggablePopup.prototype.__proto__ || Object.getPrototypeOf(DraggablePopup.prototype), 'show', this).call(this);
            this.callbacks.onShow();
        }
    }]);

    return DraggablePopup;
}(_TemplateView3.default);

exports.default = DraggablePopup;

/***/ }),
/* 1886 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _Button = __webpack_require__(33);

var _Button2 = _interopRequireDefault(_Button);

var _constants = __webpack_require__(181);

var _ResizableInput = __webpack_require__(287);

var _ResizableInput2 = _interopRequireDefault(_ResizableInput);

var _constants2 = __webpack_require__(4);

var _dropzone = __webpack_require__(339);

var _dropzone2 = _interopRequireDefault(_dropzone);

var _InputField = __webpack_require__(942);

var _InputField2 = _interopRequireDefault(_InputField);

var _atUtils = __webpack_require__(5);

var _utils = __webpack_require__(6);

var _redux = __webpack_require__(7);

var _actions = __webpack_require__(306);

var _selectors = __webpack_require__(307);

var _selectors2 = __webpack_require__(19);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ContactSupportForm = function (_TemplateView) {
    _inherits(ContactSupportForm, _TemplateView);

    function ContactSupportForm(_ref) {
        var _ref$setFormMode = _ref.setFormMode,
            setFormMode = _ref$setFormMode === undefined ? function () {} : _ref$setFormMode,
            _ref$setText = _ref.setText,
            setText = _ref$setText === undefined ? function () {} : _ref$setText,
            _ref$setAttachmentId = _ref.setAttachmentId,
            setAttachmentId = _ref$setAttachmentId === undefined ? function () {} : _ref$setAttachmentId,
            _ref$setAttachmentNam = _ref.setAttachmentName,
            setAttachmentName = _ref$setAttachmentNam === undefined ? function () {} : _ref$setAttachmentNam,
            _ref$setEmail = _ref.setEmail,
            setEmail = _ref$setEmail === undefined ? function () {} : _ref$setEmail,
            _ref$sendQuestion = _ref.sendQuestion,
            sendQuestion = _ref$sendQuestion === undefined ? function () {} : _ref$sendQuestion;

        _classCallCheck(this, ContactSupportForm);

        var _this = _possibleConstructorReturn(this, (ContactSupportForm.__proto__ || Object.getPrototypeOf(ContactSupportForm)).call(this));

        _this.actions = {
            setFormMode: setFormMode,
            setText: setText,
            setAttachmentId: setAttachmentId,
            setAttachmentName: setAttachmentName,
            setEmail: setEmail,
            sendQuestion: sendQuestion
        };

        _this.state = {
            hasEmail: false,
            mode: _constants.supportFormMode.EDITOR,

            text: '',
            email: '',

            attachmentName: ''
        };

        _this.onStatePropertyChanged('hasEmail', function (hasEmail) {
            _this.getEl().toggleClass('withContactInfo', !hasEmail);
        });

        _this.onStatePropertyChanged('mode', function (mode) {
            _this.$supportEditor.toggle(mode === _constants.supportFormMode.EDITOR);
            _this.$success.toggle(mode === _constants.supportFormMode.SUCCESS);
        });

        _this.onStatePropertyChanged('text', function (text) {
            _this.messageInput.setState({ text: text });

            var characterCount = text.length;
            _this.$supportEditor.toggleClass('textExceeded', characterCount > _constants.SUPPORT_NUMBER_ALLOWED_CHARACTERS);

            if (characterCount > _constants.SUPPORT_NUMBER_ALLOWED_CHARACTERS) {
                var exceededCharacters = characterCount - _constants.SUPPORT_NUMBER_ALLOWED_CHARACTERS;
                _this.$textError.text(_messageResource2.default.getMessage('contact_support.main.text_exceeded', [_constants.SUPPORT_NUMBER_ALLOWED_CHARACTERS, exceededCharacters]));
            }
        });

        _this.onStatePropertyChanged('email', function (value) {
            _this.contactInput.setState({ value: value });
        });

        _this.onAnyStatePropertyChanged(['text', 'email', 'hasEmail'], function () {
            var email = _this.state.email.trim();
            var textValid = _this.state.text !== '' && _this.state.text.length <= _constants.SUPPORT_NUMBER_ALLOWED_CHARACTERS;
            var emailValid = _this.state.hasEmail || email.length > 0 && (0, _atUtils.isEmailValid)(email);

            _this.sendButton.setState({ disabled: !textValid || !emailValid });
        });

        _this.onStatePropertyChanged('attachmentName', function () {
            _this.$textArea.toggleClass('hasFile', !!_this.state.attachmentName);
            _this.$filename.text(_this.state.attachmentName);
        });
        return _this;
    }

    _createClass(ContactSupportForm, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class="contactSupportForm">' + '    <div class="header"/>' + '    <div class="supportEditor">' + '        <div class="title"><%=contactSupport%></div>' + '        <div class="textArea <%=noDragClass%>">' + '            <div class="inputPlaceholder"/>' + '            <div class="attachment">' + '                <div class="text"><%=dropzone%></div>' + '                <div class="icon"/>' + '            </div>' + '            <div class="supportDropzonePreviewTemplate dz-preview dz-file-preview">' + '                <div class="supportDropzonePreview dz-progress">' + '                    <div class="dz-upload" data-dz-uploadprogress></div>' + '                    <div class="dz-details">' + '                        <div class="dz-filename" data-dz-name></div>' + '                        <div class="button dz-remove" data-dz-remove></div>' + '                    </div>' + '                </div>' + '            </div>' + '        </div>' + '        <div class="textError"/>' + '        <div class="contactSection">' + '            <div class="title"><%=contactInformation%></div>' + '            <div class="contactInputPlaceholder"/>' + '        </div>' + '        <div class="sendButton <%=noDragClass%>"/>' + '    </div>' + '    <div class="success">' + '        <div class="title"><%=successTitle%></div>' + '        <div class="note"><%=successNote%></div>' + '        <div class="sendAgain <%=noDragClass%>"><%=sendAgain%></div>' + '    </div>' + '</div>';
        }
    }, {
        key: 'messageKeys',
        value: function messageKeys() {
            return {
                contactSupport: 'contact_support.main.title',
                dropzone: 'contact_support.main.dropzone_placeholder',
                contactInformation: 'support.contact_information',
                successTitle: 'contact_support.success.title',
                successNote: 'contact_support.success.thank_you',
                sendAgain: 'contact_support.success.send_again'
            };
        }
    }, {
        key: 'templateModel',
        value: function templateModel() {
            return {
                noDragClass: _constants.NO_DRAG_CLASS
            };
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            var _this2 = this;

            this.$supportEditor = this.find('.supportEditor');
            this.$success = this.find('.success');
            this.$contactSection = this.find('.contactSection');
            this.$textArea = this.find('.textArea');
            this.$textError = this.find('.textError');
            this.$filename = this.find('.dz-details .dz-filename');
            this.$removeFileButton = this.find('.dz-details .dz-remove.button');

            this.messageInput = new _ResizableInput2.default({
                showCounter: false,
                heightLimit: _constants.SUPPORT_INPUT_HEIGHT,
                minHeight: _constants.SUPPORT_INPUT_HEIGHT,
                maxLength: _constants.SUPPORT_NUMBER_ALLOWED_CHARACTERS,
                allowInputOverMaxLength: true,
                onFocus: function onFocus() {
                    return _this2.$textArea.addClass('active');
                },
                onBlur: function onBlur(text) {
                    _this2.$textArea.removeClass('active');
                    if (text !== '') {
                        _this2.actions.setText(text);
                    }
                },
                onChange: function onChange(text) {
                    return _this2.actions.setText(text);
                }
            }).init(this.find('.inputPlaceholder'));
            this.messageInput.setState({
                placeholder: _messageResource2.default.getMessage('contact_support.main.type_your_message')
            });
            this._initDropzone();
            this.$removeFileButton.click(function () {
                _this2.actions.setAttachmentId(0);
                _this2.actions.setAttachmentName('');
            });

            this.contactInput = new _InputField2.default({
                placeholder: _messageResource2.default.getMessage('contact_support.main.enter_email'),
                maxLength: _constants.SUPPORT_EMAIL_NUMBER_ALLOWED_CHARACTERS,
                onChange: function onChange(email) {
                    return _this2.actions.setEmail(email);
                },
                additionalClass: _constants.NO_DRAG_CLASS
            }).init(this.find('.contactSection .contactInputPlaceholder'));

            this.sendButton = new _Button2.default({
                label: _messageResource2.default.getMessage('contact_support.main.send_message'),
                onClickCb: this.actions.sendQuestion
            }).init(this.find('.sendButton'));

            this.find('.sendAgain').click(function () {
                return _this2.actions.setFormMode(_constants.supportFormMode.EDITOR);
            });

            this.renderInitialState();
        }
    }, {
        key: 'onShow',
        value: function onShow() {
            this.messageInput.focus();
        }
    }, {
        key: '_initDropzone',
        value: function _initDropzone() {
            var _this3 = this;

            this.dropzone = new _dropzone2.default('.textArea', {
                previewTemplate: document.querySelector('.supportDropzonePreviewTemplate').innerHTML,
                url: _constants2.BASE_PATH + 'uploadsupportfile.do',
                createImageThumbnails: false,
                maxFiles: 1,
                maxFilesize: 10,
                clickable: '.attachment .icon',
                dictMaxFilesExceeded: _messageResource2.default.getMessage('common.multiple_upload_error'),
                accept: function accept(file, callback) {
                    if (file.size === 0) callback(_messageResource2.default.getMessage('contact_support.error.empty_file'));else {
                        _this3.actions.setAttachmentName(file.name);
                        callback();
                    }
                }
            });
            this.dropzone.on('addedfile', function (file) {
                //delete for compatibility - file preview must be shown on other pages
                file.previewElement.innerHTML = '';
            });
            this.dropzone.on('success', function (file, response) {
                var error = false;
                try {
                    response = JSON.parse(response);
                    error = response.error;
                } catch (e) {
                    error = true;
                }

                if (!error) {
                    _this3.actions.setAttachmentId(response.result);
                } else {
                    _this3._onDropzoneError(file, _messageResource2.default.getMessage('contact_support.error.upload'));
                }
                //delete for compatibility - file preview must be shown on other pages
                _this3.dropzone.removeFile(file);
            });
            this.dropzone.on('error', function (file, error) {
                if (file.xhr) {
                    var httpStatus = file.xhr.status;
                    if (httpStatus === 0) error = _messageResource2.default.getMessage('contact_support.error.http_0');else if (httpStatus >= 400 && httpStatus <= 499) error = _messageResource2.default.getMessage('contact_support.error.http_4xx');else if (httpStatus >= 500) error = _messageResource2.default.getMessage('contact_support.error.http_5xx');
                }

                _this3._onDropzoneError(file, error);
            });
            this.dropzone.on('removedfile', function () {
                _this3.dropzone.setupEventListeners();
            });
        }
    }, {
        key: '_onDropzoneError',
        value: function _onDropzoneError(file, errorText) {
            if (file.status !== 'canceled') {
                alert(errorText);
                this.dropzone.removeFile(file);
            }
        }
    }]);

    return ContactSupportForm;
}(_TemplateView3.default);

exports.default = (0, _utils.connect)(function (state) {
    return {
        hasEmail: (0, _selectors2.hasEmail)(state),
        mode: (0, _selectors.getSupportFormMode)(state),
        text: (0, _selectors.getSupportText)(state),
        attachmentName: (0, _selectors.getSupportAttachmentName)(state),
        email: (0, _selectors.getSupportEmail)(state)
    };
}, function (dispatch) {
    return {
        setFormMode: (0, _redux.bindActionCreators)(_actions.setSupportFormMode, dispatch),
        setText: (0, _redux.bindActionCreators)(_actions.setSupportText, dispatch),
        setAttachmentId: (0, _redux.bindActionCreators)(_actions.setSupportAttachmentId, dispatch),
        setAttachmentName: (0, _redux.bindActionCreators)(_actions.setSupportAttachmentName, dispatch),
        setEmail: (0, _redux.bindActionCreators)(_actions.setSupportEmail, dispatch),
        sendQuestion: (0, _redux.bindActionCreators)(_actions.sendQuestion, dispatch)
    };
})(ContactSupportForm);

/***/ }),
/* 1887 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.reactOnErrorMessage = reactOnErrorMessage;
function reactOnErrorMessage(component) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref$errorField = _ref.errorField,
        errorField = _ref$errorField === undefined ? "errorMessage" : _ref$errorField,
        _ref$errorMessageGett = _ref.errorMessageGetter,
        errorMessageGetter = _ref$errorMessageGett === undefined ? function (state) {
        return state[errorField];
    } : _ref$errorMessageGett,
        _ref$errorClass = _ref.errorClass,
        errorClass = _ref$errorClass === undefined ? "invalid" : _ref$errorClass,
        _ref$addTitle = _ref.addTitle,
        addTitle = _ref$addTitle === undefined ? true : _ref$addTitle;

    component.onStatePropertyChanged(errorField, function (newValue) {
        if (newValue) {
            if (addTitle) {
                component.$el.attr("title", errorMessageGetter(component.state));
            }
            component.$el.addClass(errorClass);
        } else {
            if (addTitle) {
                component.$el.removeAttr("title");
            }
            component.$el.removeClass(errorClass);
        }
    });
}

/***/ }),
/* 1888 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _ClassicBridge = __webpack_require__(18);

var _ClassicBridge2 = _interopRequireDefault(_ClassicBridge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var IframeContent = function (_TemplateView) {
    _inherits(IframeContent, _TemplateView);

    function IframeContent(_ref) {
        var iframeLoadCallback = _ref.iframeLoadCallback,
            frameName = _ref.frameName;

        _classCallCheck(this, IframeContent);

        var _this = _possibleConstructorReturn(this, (IframeContent.__proto__ || Object.getPrototypeOf(IframeContent)).call(this));

        _this.callbacks = {
            iframeLoadCallback: iframeLoadCallback
        };

        _this.state = {
            url: '',
            size: {
                width: 0,
                height: 0
            }
        };

        _this.params = {
            frameName: frameName
        };

        _this.onStatePropertyChanged('url', function (url) {
            if (!url) {
                return;
            }

            _this.iframe = (0, _jquery2.default)('<iframe>', {
                src: url,
                id: _this.params.frameName,
                frameborder: 0,
                allowfullscreen: 1,
                width: _this.state.size.width,
                height: _this.state.size.height,
                name: _this.params.frameName,
                // Allow the "unload" event after it is deprecated.
                // The "unload" event is used in ext-base.js which is loaded inside the iframe.
                // See https://jira.actimind.com/browse/AT-11367.
                allow: 'unload'
            });

            _this.iframe.appendTo('.iframeContainer');

            _this.iframe.load(function () {
                _this.find('.iframeContentPlaceholder').hide();
                _this.callbacks.iframeLoadCallback(_this.params.frameName);
            });
        });

        _this.onStatePropertyChanged('size', function (size) {
            if (_this.iframe) {
                _this.iframe.width(size.width);
                _this.iframe.height(size.height);
            }
        });
        return _this;
    }

    _createClass(IframeContent, [{
        key: 'afterRender',
        value: function afterRender() {
            _ClassicBridge2.default.integrateSpinner(this.find('.iframeContentPlaceholder')[0], {
                spinnerClassName: 'iframeContentSpinner'
            });
        }
    }, {
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class="iframeContainer">\n                    <div class="iframeContentPlaceholder atNextMount">\n                    </div>\n                </div>';
        }
    }]);

    return IframeContent;
}(_TemplateView3.default);

exports.default = IframeContent;

/***/ }),
/* 1889 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var WelcomeScreenLightboxHeader = function (_TemplateView) {
    _inherits(WelcomeScreenLightboxHeader, _TemplateView);

    function WelcomeScreenLightboxHeader(_ref) {
        var loadExternalWelcomeScreen = _ref.loadExternalWelcomeScreen,
            _ref$showCloseButton = _ref.showCloseButton,
            showCloseButton = _ref$showCloseButton === undefined ? true : _ref$showCloseButton;

        _classCallCheck(this, WelcomeScreenLightboxHeader);

        var _this = _possibleConstructorReturn(this, (WelcomeScreenLightboxHeader.__proto__ || Object.getPrototypeOf(WelcomeScreenLightboxHeader)).call(this));

        _this.params = {
            loadExternalWelcomeScreen: loadExternalWelcomeScreen,
            showCloseButton: showCloseButton
        };
        return _this;
    }

    _createClass(WelcomeScreenLightboxHeader, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div></div>';
        }
    }, {
        key: 'getCloseButtonEl',
        value: function getCloseButtonEl() {
            return this.find('.close-button');
        }
    }, {
        key: 'templateHtml',
        value: function templateHtml() {
            return this.params.loadExternalWelcomeScreen ? '<div class="dialog-header dialog-header-empty">\n                ' + (this.params.showCloseButton ? '<div class="close-button">\n                          <div id="closeProjectLightBoxBtn" class="closeButton"></div>\n                          <div class="disabledCloseButton"></div>\n                      </div>' : '') + '\n                </div>' : '<table class="dialog-header">\n                  <tr>\n                      <td>\n                ' + (this.params.showCloseButton ? '<div class="close-button">\n                              <div id="closeProjectLightBoxBtn" class="closeButton"></div>\n                              <div class="disabledCloseButton"></div>\n                          </div>' : '') + '\n                          <div class="lightBoxTitle">\n                          </div>\n                      </td>\n                  </tr>\n              </table>';
        }
    }]);

    return WelcomeScreenLightboxHeader;
}(_TemplateView3.default);

exports.default = WelcomeScreenLightboxHeader;

/***/ }),
/* 1890 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var WelcomeScreenLightboxFooter = function (_TemplateView) {
    _inherits(WelcomeScreenLightboxFooter, _TemplateView);

    function WelcomeScreenLightboxFooter(_ref) {
        var loadExternalWelcomeScreen = _ref.loadExternalWelcomeScreen;

        _classCallCheck(this, WelcomeScreenLightboxFooter);

        var _this = _possibleConstructorReturn(this, (WelcomeScreenLightboxFooter.__proto__ || Object.getPrototypeOf(WelcomeScreenLightboxFooter)).call(this));

        _this.params = { loadExternalWelcomeScreen: loadExternalWelcomeScreen };
        return _this;
    }

    _createClass(WelcomeScreenLightboxFooter, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return this.params.loadExternalWelcomeScreen ? '' : '<div></div>';
        }
    }, {
        key: 'getCommitBtnEl',
        value: function getCommitBtnEl() {
            return this.find('.cancelBtn');
        }
    }, {
        key: 'getCancelBtnEl',
        value: function getCancelBtnEl() {
            return this.find('.cancelBtn');
        }
    }]);

    return WelcomeScreenLightboxFooter;
}(_TemplateView3.default);

exports.default = WelcomeScreenLightboxFooter;

/***/ }),
/* 1891 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = isTrialWithoutRenewal;

var _utils = __webpack_require__(6);

var _selectors = __webpack_require__(143);

function isTrialWithoutRenewal() {
    return (0, _utils.unsafe_selectWithState)(_selectors.isLicenseTrialWithoutRenewal) && !(0, _utils.unsafe_selectWithState)(_selectors.isLicenseExpired);
}

/***/ }),
/* 1892 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _View2 = __webpack_require__(20);

var _View3 = _interopRequireDefault(_View2);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _utils = __webpack_require__(6);

var _redux = __webpack_require__(7);

var _DropdownDialogWithPointerWrapper = __webpack_require__(182);

var _DropdownDialogWithPointerWrapper2 = _interopRequireDefault(_DropdownDialogWithPointerWrapper);

var _AddonsMenu = __webpack_require__(947);

var _AddonsMenu2 = _interopRequireDefault(_AddonsMenu);

var _selectors = __webpack_require__(1893);

var _actions = __webpack_require__(1894);

var _AddonCard = __webpack_require__(948);

var _AddonCard2 = _interopRequireDefault(_AddonCard);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _selectors2 = __webpack_require__(19);

var _constants = __webpack_require__(949);

var _Button = __webpack_require__(33);

var _Button2 = _interopRequireDefault(_Button);

var _MobileAppButtons = __webpack_require__(950);

var _MobileAppButtons2 = _interopRequireDefault(_MobileAppButtons);

var _selectors3 = __webpack_require__(143);

var _constants2 = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AddonsMenuContainer = function (_View) {
    _inherits(AddonsMenuContainer, _View);

    function AddonsMenuContainer() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            _ref$toggleAddonsMenu = _ref.toggleAddonsMenu,
            toggleAddonsMenu = _ref$toggleAddonsMenu === undefined ? function () {} : _ref$toggleAddonsMenu,
            _ref$closeAddonsMenu = _ref.closeAddonsMenu,
            closeAddonsMenu = _ref$closeAddonsMenu === undefined ? function () {} : _ref$closeAddonsMenu;

        _classCallCheck(this, AddonsMenuContainer);

        var _this = _possibleConstructorReturn(this, (AddonsMenuContainer.__proto__ || Object.getPrototypeOf(AddonsMenuContainer)).call(this));

        _this.actions = {
            toggleAddonsMenu: toggleAddonsMenu,
            closeAddonsMenu: closeAddonsMenu
        };

        _this.state = {
            shown: false,

            canManageLicenses: false,
            isShowApIntegrationAction: false,
            isApExpired: false,
            isApViolated: false,
            qbiAvailable: false,
            canSwitchToQBI: false,
            isLicenseFree: false,

            assistantLinkOpened: window.sessionStorage.getItem(_constants.AddonsCardsModels.ASSISTANT.linkOpenedSessionStorageKey)
        };

        _this.onStatePropertyChanged('shown', function (shown) {
            if (shown) {
                _this.addonsMenuDialog.showAt((0, _jquery2.default)('.popup_menu_button_addons'));
            } else {
                _this.addonsMenuDialog.hide(true);
            }
        });

        _this.onStatePropertyChanged('isLicenseFree', function (isLicenseFree) {
            _this.zapierCard.setState({ actionNotAvailable: isLicenseFree });
            _this.apiCard.setState({ actionNotAvailable: isLicenseFree });
            _this.qbiCard.setState({ actionNotAvailable: isLicenseFree });
        });

        _this.onAnyStatePropertyChanged(['canManageLicenses', 'isLicenseFree'], function () {
            _this.addonsMenu.setState({
                showUpgradeSection: _this.state.isLicenseFree && _this.state.canManageLicenses
            });
        });

        _this.onAnyStatePropertyChanged(['qbiAvailable', 'canSwitchToQBI'], function () {
            _this.qbiCard.setState({ showActionButton: _this.state.qbiAvailable && _this.state.canSwitchToQBI });
        });

        _this.onStatePropertyChanged('isShowApIntegrationAction', function (isShowApIntegrationAction) {
            return _this.apIntegrationCard.setState({
                showActionButton: isShowApIntegrationAction
            });
        });

        _this.onAnyStatePropertyChanged(['isApExpired', 'isApViolated'], function () {
            var showWarning = _this.state.isApExpired || _this.state.isApViolated;

            _this.apIntegrationCard.setState({
                showWarning: showWarning,
                isExpired: _this.state.isApExpired
            });
            _this.$alertIcon.toggle(showWarning);
        });
        return _this;
    }

    _createClass(AddonsMenuContainer, [{
        key: 'afterRender',
        value: function afterRender() {
            var _this2 = this;

            (0, _jquery2.default)('#popup_menu_button_addons').mousedown(function (e) {
                return e.stopPropagation();
            }).click(function () {
                return _this2.actions.toggleAddonsMenu();
            });

            this.$alertIcon = (0, _jquery2.default)('.topMenuButton.addons .alertIcon');

            var openIntegrationPopup = function openIntegrationPopup() {
                _this2.addonsMenuDialog.hide();
                window.openAtIntegrationPopup();
            };
            this.apIntegrationCard = new _AddonCard2.default(_extends({}, _constants.AddonsCardsModels.AP_INTEGRATION, {
                actionNotAvailable: !_constants2.isOlVersion,
                actionButtonTextKey: _constants2.PRODUCT_SWITCHER_URL ? 'menu.addons.item.actiplans.switch_button' : 'menu.addons.item.actiplans.enable_button',
                onActionButtonClick: function onActionButtonClick() {
                    if (_constants2.PRODUCT_SWITCHER_URL) {
                        window.location.href = window.unescapeHtmlSymbols(_constants2.PRODUCT_SWITCHER_URL);
                    } else {
                        openIntegrationPopup();
                    }
                },
                onDetailsButtonClick: openIntegrationPopup,
                notAvailableButtonTextKey: 'menu.addons.item.actiplans.not_available_button',
                onLinkClickCallback: function onLinkClickCallback() {
                    return _this2.addonsMenuDialog.hide();
                }
            }));

            this.qbiCard = new _AddonCard2.default(_extends({}, _constants.AddonsCardsModels.QBI, {
                onActionButtonClick: function onActionButtonClick() {
                    if (_this2.state.qbiAvailable && _this2.state.canSwitchToQBI) _this2.openUrl(_constants.AddonsMenuActionUrls.QBI_ACTION_URL);
                },
                onLinkClickCallback: function onLinkClickCallback() {
                    return _this2.addonsMenuDialog.hide();
                }
            }));

            this.zapierCard = new _AddonCard2.default(_extends({}, _constants.AddonsCardsModels.ZAPIER, {
                onActionButtonClick: function onActionButtonClick() {
                    if (!_this2.state.isLicenseFree) _this2.openUrl(_constants.AddonsMenuActionUrls.ZAPIER_ACTION_URL);
                },
                onLinkClickCallback: function onLinkClickCallback() {
                    return _this2.addonsMenuDialog.hide();
                }
            }));

            this.apiCard = new _AddonCard2.default(_extends({}, _constants.AddonsCardsModels.API, {
                onActionButtonClick: function onActionButtonClick() {
                    if (!_this2.state.isLicenseFree) _this2.openUrl(_constants.AddonsMenuActionUrls.API_ACTION_URL);
                },
                onLinkClickCallback: function onLinkClickCallback() {
                    return _this2.addonsMenuDialog.hide();
                }
            }));

            this.assistantCard = new _AddonCard2.default(_extends({}, _constants.AddonsCardsModels.ASSISTANT, {
                additionalClass: 'assistantCard',
                customButtonComponent: new _Button2.default({
                    additionalClass: 'assistantButton',
                    label: _messageResource2.default.getMessage(_constants.AddonsCardsModels.ASSISTANT.actionButtonTextKey),
                    onClickCb: function onClickCb() {
                        try {
                            window.sessionStorage.setItem(_constants.AddonsCardsModels.ASSISTANT.linkOpenedSessionStorageKey, true);
                            _this2.setState({ assistantLinkOpened: true });
                        } catch (e) {} finally {
                            _this2.openUrl(_constants.AddonsMenuActionUrls.ASSISTANT_ACTION_URL);
                        }
                    }
                }),
                onLinkClickCallback: function onLinkClickCallback() {
                    return _this2.addonsMenuDialog.hide();
                }
            }));

            this.mobileCard = new _AddonCard2.default(_extends({}, _constants.AddonsCardsModels.MOBILE, {
                additionalIconClass: 'atMobileAppIcon',
                customButtonComponent: new _MobileAppButtons2.default({
                    onIosButtonClick: function onIosButtonClick() {
                        return _this2.openUrl(_constants.AddonsMenuActionUrls.AT_MOBILE_IOS_ACTION_URL);
                    },
                    onAndroidButtonClick: function onAndroidButtonClick() {
                        return _this2.openUrl(_constants.AddonsMenuActionUrls.AT_MOBILE_ANDROID_ACTION_URL);
                    }
                }),
                onLinkClickCallback: function onLinkClickCallback() {
                    return _this2.addonsMenuDialog.hide();
                }
            }));

            this.addonsMenu = new _AddonsMenu2.default({
                additionalClass: 'atAddonsMenu',
                onUpgradeButtonClick: function onUpgradeButtonClick() {
                    return _this2.openUrl(_constants.ManageLicensesUrl);
                },
                integrationComponents: [this.apIntegrationCard, this.qbiCard, this.zapierCard, this.apiCard],
                addonsComponents: [this.assistantCard],
                mobileComponents: [this.mobileCard]
            });
            this.addonsMenuDialog = new _DropdownDialogWithPointerWrapper2.default({
                dialog: this.addonsMenu,
                additionalClass: 'addonsMenuDropdownDialog',
                showAnimationClass: 'popup_menu_slide_down',
                hideAnimationClass: 'popup_menu_slide_up',
                onHide: this.actions.closeAddonsMenu,
                pointerLeftOffset: '-10px',
                dialogOffsets: {
                    left: -80,
                    top: 8
                }
            }).init((0, _jquery2.default)('body'));

            this.renderInitialState();
        }
    }, {
        key: 'openUrl',
        value: function openUrl(url) {
            this.addonsMenuDialog.hide();
            window.open(url);
        }
    }]);

    return AddonsMenuContainer;
}(_View3.default);

exports.default = (0, _utils.connect)(function (state) {
    return {
        shown: (0, _selectors.isAddonsMenuShown)(state),
        canManageLicenses: (0, _selectors3.loggedInUserCanManageLicenses)(state),
        qbiAvailable: (0, _selectors.isQbiAvailable)(state),
        canSwitchToQBI: (0, _selectors2.canSwitchToQBI)(state),
        isLicenseFree: (0, _selectors3.isLicenseFree)(state),
        isShowApIntegrationAction: (0, _selectors.isShowApIntegrationAction)(state),
        isApExpired: (0, _selectors3.isOtherProductLicenseExpired)(state),
        isApViolated: (0, _selectors3.isOtherProductLicenseViolated)(state)
    };
}, function (dispatch) {
    return {
        toggleAddonsMenu: (0, _redux.bindActionCreators)(_actions.toggleAddonsMenu, dispatch),
        closeAddonsMenu: (0, _redux.bindActionCreators)(_actions.closeAddonsMenu, dispatch)
    };
})(AddonsMenuContainer);

/***/ }),
/* 1893 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isQbiAvailable = exports.isShowApIntegrationAction = exports.isAddonsMenuShown = undefined;

var _reselect = __webpack_require__(13);

var _selectors = __webpack_require__(143);

var _selectors2 = __webpack_require__(19);

var _constants = __webpack_require__(4);

var _selectors3 = __webpack_require__(15);

var getAddonsState = function getAddonsState(state) {
    return state.addons;
};

var isAddonsMenuShown = exports.isAddonsMenuShown = function isAddonsMenuShown(state) {
    return getAddonsState(state).isShown;
};

var apIntegrationAccessEnabled = function apIntegrationAccessEnabled(state) {
    return getAddonsState(state).apIntegrationAccessEnabled;
};

var isShowApIntegrationAction = exports.isShowApIntegrationAction = (0, _reselect.createSelector)(_selectors.isLicenseExpired, _selectors.isLicenseViolated, _selectors.loggedInUserCanManageLicenses, _selectors2.canManageSystemSettings, _selectors2.canManageAccountsAndPermissions, _selectors.wasOtherProductEverIntegrated, apIntegrationAccessEnabled, function (licenseExpired, licenseViolated, canManageLicense, manageSystemSettings, manageAccountsAndPermissions, wasOtherProductEverIntegrated, apIntegrationAccessEnabled) {
    return apIntegrationAccessEnabled && (!_constants.isOlVersion || !!_constants.PRODUCT_SWITCHER_URL || !wasOtherProductEverIntegrated && (canManageLicense || manageAccountsAndPermissions) && !licenseExpired && !licenseViolated || wasOtherProductEverIntegrated && canManageLicense);
});

var isQbiAvailable = exports.isQbiAvailable = (0, _reselect.createSelector)(_selectors.isLicenseViolated, _selectors.isLicenseExpired, _selectors3.isQBIEnabled, function (isLicenseViolated, isLicenseExpired, isQBIEnabled) {
    return !isLicenseViolated && !isLicenseExpired && isQBIEnabled;
});

/***/ }),
/* 1894 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.closeAddonsMenu = exports.toggleAddonsMenu = undefined;

var _actionTypes = __webpack_require__(717);

var ActionTypes = _interopRequireWildcard(_actionTypes);

var _reduxActions = __webpack_require__(9);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var toggleAddonsMenu = exports.toggleAddonsMenu = (0, _reduxActions.createAction)(ActionTypes.ADDONS_MENU_TOGGLE);
var closeAddonsMenu = exports.closeAddonsMenu = (0, _reduxActions.createAction)(ActionTypes.ADDONS_MENU_CLOSE);

/***/ }),
/* 1895 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _WelcomeScreenLightbox = __webpack_require__(944);

var _WelcomeScreenLightbox2 = _interopRequireDefault(_WelcomeScreenLightbox);

var _redux = __webpack_require__(7);

var _utils = __webpack_require__(6);

var _selectors = __webpack_require__(406);

var _actions = __webpack_require__(578);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _constants = __webpack_require__(226);

var _SitePopupBridge = __webpack_require__(1896);

var _SitePopupBridge2 = _interopRequireDefault(_SitePopupBridge);

var _StateComponent2 = __webpack_require__(105);

var _StateComponent3 = _interopRequireDefault(_StateComponent2);

var _selectors2 = __webpack_require__(143);

var _selectors3 = __webpack_require__(19);

var _ClassicBridge = __webpack_require__(18);

var _ClassicBridge2 = _interopRequireDefault(_ClassicBridge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var StartupWizard = function (_StateComponent) {
    _inherits(StartupWizard, _StateComponent);

    function StartupWizard(_ref) {
        var _ref$$containerEl = _ref.$containerEl,
            $containerEl = _ref$$containerEl === undefined ? (0, _jquery2.default)('body') : _ref$$containerEl,
            openLightbox = _ref.openLightbox,
            closeLightbox = _ref.closeLightbox,
            setShowExternalContent = _ref.setShowExternalContent,
            setLoading = _ref.setLoading;

        _classCallCheck(this, StartupWizard);

        var _this = _possibleConstructorReturn(this, (StartupWizard.__proto__ || Object.getPrototypeOf(StartupWizard)).call(this, $containerEl));

        _this.state = {
            loading: false,
            showExternalContent: false,
            loadExternalWelcomeScreen: false,
            url: ''
        };

        _this.params = {
            openLightbox: openLightbox,
            closeLightbox: closeLightbox,
            setShowExternalContent: setShowExternalContent,
            setLoading: setLoading
        };

        _this.onStatePropertyChanged('loading', function (loading) {
            if (!loading) {
                _this.pageLoadingMoire.remove();
            }
        });

        _this.onStatePropertyChanged('showExternalContent', function (showExternalContent) {
            if (showExternalContent) {
                _this.lightbox.show();
            } else {
                _this.lightbox.hide();
            }
        });

        _this.onStatePropertyChanged('url', function (url) {
            _this.lightbox.changeUrl(url);
        });
        return _this;
    }

    _createClass(StartupWizard, [{
        key: 'init',
        value: function init() {
            var _this2 = this;

            this.lightbox = new _WelcomeScreenLightbox2.default({
                onCloseCallback: this.params.closeLightbox,
                iframeLoadCallback: function iframeLoadCallback(contentKey) {
                    _this2.params.setShowExternalContent(true);
                    _this2.params.setLoading(false);

                    (0, _SitePopupBridge2.default)(window.frames[contentKey], {
                        close: function close() {
                            return _this2.params.closeLightbox(false);
                        },
                        username: _this2.state.username,
                        isTrial: _this2.state.isTrial,
                        isFirstAdmin: _this2.state.isFirstAdmin
                    });
                },
                frameName: _constants.WelcomeScreenFrameId,
                loadExternalWelcomeScreen: true,
                showCloseButton: false,
                className: 'startupWizard'
            });
            this.lightbox.init();

            var overlays = document.createElement('div');
            overlays.className = 'atNextMount atNextOverlays';
            (0, _jquery2.default)('body')[0].appendChild(overlays);

            this.pageLoadingMoire = _ClassicBridge2.default.integrateFullscreenSpinner(overlays, {
                className: 'fullscreenSpinnerZindex'
            });

            this.params.openLightbox();
        }
    }]);

    return StartupWizard;
}(_StateComponent3.default);

exports.default = (0, _utils.connect)(function (state) {
    return {
        loading: (0, _selectors.getLoading)(state),
        showExternalContent: (0, _selectors.getShowExternalContent)(state),
        demoDataStage: (0, _selectors.getDemoDataStage)(state),
        url: (0, _selectors.getUrl)(state),
        loadExternalWelcomeScreen: (0, _selectors.getLoadExternalWelcomeScreen)(state),
        username: (0, _selectors3.getFirstName)(state),
        isTrial: (0, _selectors2.isLicenseTrial)(state),
        isFirstAdmin: (0, _selectors3.isFirstAdmin)(state)
    };
}, function (dispatch) {
    return (0, _redux.bindActionCreators)({
        openLightbox: _actions.openLightbox,
        closeLightbox: _actions.closeLightbox,
        setShowExternalContent: _actions.setShowExternalContent,
        setLoading: _actions.setLoading
    }, dispatch);
})(StartupWizard);

/***/ }),
/* 1896 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _sendUserEvent = __webpack_require__(579);

var _sendUserEvent2 = _interopRequireDefault(_sendUserEvent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var assignSitePopupBridge = function assignSitePopupBridge(window, _ref) {
    var close = _ref.close,
        username = _ref.username,
        isTrial = _ref.isTrial,
        isFirstAdmin = _ref.isFirstAdmin;

    window.SitePopupBridge = {
        close: close,
        sendUserEvent: _sendUserEvent2.default,
        context: {
            username: username,
            isTrial: isTrial,
            isFirstAdmin: isFirstAdmin
        }
    };
};

exports.default = assignSitePopupBridge;

/***/ }),
/* 1897 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _constants = __webpack_require__(226);

var _ClassicBridge = __webpack_require__(18);

var _ClassicBridge2 = _interopRequireDefault(_ClassicBridge);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DemoDataComponent = function (_TemplateView) {
    _inherits(DemoDataComponent, _TemplateView);

    function DemoDataComponent() {
        _classCallCheck(this, DemoDataComponent);

        var _this = _possibleConstructorReturn(this, (DemoDataComponent.__proto__ || Object.getPrototypeOf(DemoDataComponent)).call(this));

        _this.state = {
            stage: _constants.DemoDataStageType.ACTIVE
        };

        _this.onStatePropertyChanged('stage', function (stage) {
            return _this.refreshStage(stage);
        });
        return _this;
    }

    _createClass(DemoDataComponent, [{
        key: 'refreshStage',
        value: function refreshStage(stage) {
            if (stage !== _constants.DemoDataStageType.ACTIVE) {
                clearTimeout(this.progressTimer);
            }

            this.actualProgress = stage === _constants.DemoDataStageType.COMPLETED ? 100 : 0;

            if (stage === _constants.DemoDataStageType.ACTIVE) {
                this.startDemoLoadingProgress();
            } else {
                this.renderProgress();
            }
        }
    }, {
        key: 'startDemoLoadingProgress',
        value: function startDemoLoadingProgress() {
            var _this2 = this;

            var baseTimeOut = 200;
            var baseStep = 2;
            var increaseProgress = function increaseProgress() {
                _this2.renderProgress();
                // increase percent value from 0 to 95
                if (_this2.actualProgress < 95) {
                    _this2.actualProgress += Math.round(baseStep + Math.random() * baseStep);
                    _this2.progressTimer = setTimeout(increaseProgress, baseTimeOut + Math.random() * baseTimeOut);
                }
            };
            increaseProgress();
        }
    }, {
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div></div>';
        }
    }, {
        key: 'renderProgress',
        value: function renderProgress() {
            if (this.progress) {
                this.progress.setProps({ progress: this.actualProgress });
            }
        }
    }, {
        key: 'show',
        value: function show() {
            this.progress = _ClassicBridge2.default.integrateProgressFullscreenSpinner(this.$progressContainer[0], {
                className: 'transformedMoireZindex',
                progress: this.actualProgress,
                label: window.messageResource.getMessage('welcome_screen.demo.progress')
            });
            _get(DemoDataComponent.prototype.__proto__ || Object.getPrototypeOf(DemoDataComponent.prototype), 'show', this).call(this);
        }
    }, {
        key: 'hide',
        value: function hide() {
            if (this.progress) {
                this.progress.remove();
            }
            this.$progressContainer.remove();
            _get(DemoDataComponent.prototype.__proto__ || Object.getPrototypeOf(DemoDataComponent.prototype), 'hide', this).call(this);
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            this.actualProgress = 0;
            // TODO it's required for ClassicBridge.integrateProgressFullscreenSpinner component (probably should be a part of the component)
            this.$progressContainer = (0, _jquery2.default)('<div/>').addClass('atNextMount atNextOverlays').appendTo((0, _jquery2.default)('body'));
        }
    }]);

    return DemoDataComponent;
}(_TemplateView3.default);

exports.default = DemoDataComponent;

/***/ }),
/* 1898 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = initApplication;

var _LocalStorage = __webpack_require__(72);

var _store = __webpack_require__(222);

var _reducer = __webpack_require__(1899);

var _reducer2 = _interopRequireDefault(_reducer);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _LicenseCountDownTip = __webpack_require__(939);

var _LicenseCountDownTip2 = _interopRequireDefault(_LicenseCountDownTip);

var _ContactSupportDraggablePopupContainer = __webpack_require__(941);

var _ContactSupportDraggablePopupContainer2 = _interopRequireDefault(_ContactSupportDraggablePopupContainer);

var _utils = __webpack_require__(381);

var _SupportQuestionButton = __webpack_require__(940);

var _SupportQuestionButton2 = _interopRequireDefault(_SupportQuestionButton);

var _WelcomeScreenContainer = __webpack_require__(943);

var _WelcomeScreenContainer2 = _interopRequireDefault(_WelcomeScreenContainer);

var _utils2 = __webpack_require__(168);

var _AddonsMenuContainer = __webpack_require__(1904);

var _AddonsMenuContainer2 = _interopRequireDefault(_AddonsMenuContainer);

var _ToastsContainer = __webpack_require__(938);

var _ToastsContainer2 = _interopRequireDefault(_ToastsContainer);

var _initUserEventListeners = __webpack_require__(951);

var _initUserEventListeners2 = _interopRequireDefault(_initUserEventListeners);

var _DemoDataLoaderContainer = __webpack_require__(952);

var _DemoDataLoaderContainer2 = _interopRequireDefault(_DemoDataLoaderContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function initApplication() {
    var INIT_DATA = window.__INIT_APP_DATA__;
    var GENERATED_CONSTANTS = window.__GENERATED_CONSTANTS__;

    // load data from local storage
    (0, _LocalStorage.initLocalStorage)(INIT_DATA.LOGGED_IN_USER.id, GENERATED_CONSTANTS.CLIENT_CODE);

    if (window.__IS_FIRST_SCREEN_AFTER_LOGIN__) {
        cleanupLocalStorageForNewSession();
    }

    INIT_DATA.SUPPORT = _extends({}, INIT_DATA.SUPPORT, {
        POPUP_INFO: _extends({}, (0, _utils.getSupportPopupInfoFromLocalStorage)())
    });

    INIT_DATA.ICALENDAR = _extends({}, INIT_DATA.ICALENDAR, {
        ICAL_INFO: _extends({}, (0, _utils2.getICalInfoFromLocalStorage)())
    });

    (0, _store.initStore)(INIT_DATA, _reducer2.default);
    (0, _initUserEventListeners2.default)();
    initCommonComponents(INIT_DATA);
}

function initCommonComponents(INIT_DATA) {
    var $body = (0, _jquery2.default)('body');
    new _LicenseCountDownTip2.default().init($body);
    new _ToastsContainer2.default().init($body);
    new _SupportQuestionButton2.default().init((0, _jquery2.default)('.contactSupportButtonPlaceholder'));
    new _ContactSupportDraggablePopupContainer2.default().init();
    new _AddonsMenuContainer2.default().init();

    if (INIT_DATA.WELCOME.needToLoadDemoData) {
        new _DemoDataLoaderContainer2.default().init();
    }

    if (INIT_DATA.WELCOME.showWelcomeScreen) {
        new _WelcomeScreenContainer2.default().init();
    }
}

function cleanupLocalStorageForNewSession() {
    (0, _utils.clearSupportPopupInfoInLocalStorage)();
}

/***/ }),
/* 1899 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _workScheduleReducer = __webpack_require__(708);

var _workScheduleReducer2 = _interopRequireDefault(_workScheduleReducer);

var _redux = __webpack_require__(7);

var _reducer = __webpack_require__(648);

var _reducer2 = _interopRequireDefault(_reducer);

var _reducer3 = __webpack_require__(712);

var _reducer4 = _interopRequireDefault(_reducer3);

var _reducer5 = __webpack_require__(713);

var _reducer6 = _interopRequireDefault(_reducer5);

var _reducer7 = __webpack_require__(702);

var _reducer8 = _interopRequireDefault(_reducer7);

var _reducer9 = __webpack_require__(705);

var _reducer10 = _interopRequireDefault(_reducer9);

var _reducer11 = __webpack_require__(715);

var _reducer12 = _interopRequireDefault(_reducer11);

var _reducer13 = __webpack_require__(706);

var _reducer14 = _interopRequireDefault(_reducer13);

var _reducer15 = __webpack_require__(665);

var _reducer16 = _interopRequireDefault(_reducer15);

var _iCalReducer = __webpack_require__(1900);

var _iCalReducer2 = _interopRequireDefault(_iCalReducer);

var _reducer17 = __webpack_require__(1903);

var _reducer18 = _interopRequireDefault(_reducer17);

var _reducer19 = __webpack_require__(701);

var _reducer20 = _interopRequireDefault(_reducer19);

var _commonReducer = __webpack_require__(703);

var _commonReducer2 = _interopRequireDefault(_commonReducer);

var _reducer21 = __webpack_require__(696);

var _reducer22 = _interopRequireDefault(_reducer21);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (initAppData) {
    return (0, _redux.combineReducers)({
        loggedInUser: (0, _reducer2.default)(initAppData),
        entities: (0, _reducer16.default)(initAppData),
        workSchedule: (0, _workScheduleReducer2.default)(initAppData),
        activeLicenseInfo: (0, _reducer4.default)(initAppData),
        support: (0, _reducer6.default)(initAppData),
        addons: (0, _reducer18.default)(initAppData),
        lockoutPolicy: (0, _reducer20.default)(initAppData),
        lowBalanceSettings: (0, _commonReducer2.default)(initAppData),
        features: (0, _reducer22.default)(initAppData),
        passwordSettings: (0, _reducer8.default)(initAppData),
        mailSettings: (0, _reducer10.default)(initAppData),
        welcome: (0, _reducer12.default)(initAppData),
        iCalendar: (0, _iCalReducer2.default)(initAppData),
        toasts: _reducer14.default
    });
};

/***/ }),
/* 1900 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _redux = __webpack_require__(7);

var _reducer = __webpack_require__(1901);

var _reducer2 = _interopRequireDefault(_reducer);

var _reducer3 = __webpack_require__(1902);

var _reducer4 = _interopRequireDefault(_reducer3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (initAppData) {
    return (0, _redux.combineReducers)({
        feeds: (0, _reducer2.default)(initAppData),
        configuredFeed: (0, _reducer4.default)(initAppData)
    });
};

/***/ }),
/* 1901 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reduxActions = __webpack_require__(9);

var _constants = __webpack_require__(51);

var _actionTypes = __webpack_require__(953);

var ActionTypes = _interopRequireWildcard(_actionTypes);

var _actionTypes2 = __webpack_require__(580);

var LightBoxActionTypes = _interopRequireWildcard(_actionTypes2);

var _atUtils = __webpack_require__(5);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var createICalFeedsReducer = function createICalFeedsReducer(_ref) {
    var _handleActions;

    var _ref$ICALENDAR = _ref.ICALENDAR,
        ICALENDAR = _ref$ICALENDAR === undefined ? null : _ref$ICALENDAR;

    var initialState = _extends({
        activeTab: null,
        allFeeds: [],
        sharedFeeds: [],
        loading: false,
        allSorting: _constants.DEFAULT_SORTING,
        sharedSorting: _constants.DEFAULT_SORTING,
        recentlyConfiguredFeedId: null,
        userActionLoading: false,
        feedsContentLoading: false
    }, ICALENDAR.ICAL_INFO);

    return (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, ActionTypes.ACTIVE_TAB_SET, function (state, _ref2) {
        var activeTab = _ref2.payload;
        return _extends({}, state, { activeTab: activeTab });
    }), _defineProperty(_handleActions, ActionTypes.ALL_FEEDS_LIST_SET, function (state, _ref3) {
        var allFeeds = _ref3.payload;
        return _extends({}, state, { allFeeds: (0, _atUtils.arrayToMap)(allFeeds) });
    }), _defineProperty(_handleActions, ActionTypes.SHARED_FEEDS_LIST_SET, function (state, _ref4) {
        var sharedFeeds = _ref4.payload;
        return _extends({}, state, { sharedFeeds: (0, _atUtils.arrayToMap)(sharedFeeds) });
    }), _defineProperty(_handleActions, ActionTypes.DELETE_FEED_DATA_LOAD_SUCCESS, function (state, _ref5) {
        var feedId = _ref5.payload;

        return _extends({}, state, {
            allFeeds: (0, _atUtils.filterMapByKeys)(state.allFeeds, [feedId], function (feed) {
                return feed.id;
            }),
            sharedFeeds: (0, _atUtils.filterMapByKeys)(state.sharedFeeds, [feedId], function (feed) {
                return feed.id;
            })
        });
    }), _defineProperty(_handleActions, ActionTypes.LOADING_SET, function (state, _ref6) {
        var loading = _ref6.payload;
        return _extends({}, state, { loading: loading });
    }), _defineProperty(_handleActions, ActionTypes.ALL_SORTING_SET, function (state, _ref7) {
        var allSorting = _ref7.payload;
        return _extends({}, state, { allSorting: allSorting });
    }), _defineProperty(_handleActions, ActionTypes.SHARED_SORTING_SET, function (state, _ref8) {
        var sharedSorting = _ref8.payload;
        return _extends({}, state, { sharedSorting: sharedSorting });
    }), _defineProperty(_handleActions, ActionTypes.FEED_ADD, function (state, _ref9) {
        var feed = _ref9.payload;
        return _extends({}, state, {
            allFeeds: _extends({}, state.allFeeds, _defineProperty({}, feed.id, feed))
        });
    }), _defineProperty(_handleActions, ActionTypes.RECENTLY_CONFIGURED_FEED_ID_SET, function (state, _ref10) {
        var recentlyConfiguredFeedId = _ref10.payload;
        return _extends({}, state, { recentlyConfiguredFeedId: recentlyConfiguredFeedId });
    }), _defineProperty(_handleActions, ActionTypes.FEEDS_CONTENT_LOADING_SET, function (state, _ref11) {
        var feedsContentLoading = _ref11.payload;
        return _extends({}, state, { feedsContentLoading: feedsContentLoading });
    }), _defineProperty(_handleActions, (0, _reduxActions.combineActions)(ActionTypes.ALL_FEEDS_LIST_SET, ActionTypes.FEED_REMOVE, ActionTypes.ALL_SORTING_SET, LightBoxActionTypes.CREATE_FEED_LIGHTBOX_DATA_LOAD, LightBoxActionTypes.EDIT_FEED_LIGHTBOX_DATA_LOAD, LightBoxActionTypes.EXPORT_ICAL_LIGHTBOX_DATA_LOAD, ActionTypes.RENGERATE_FEED_LINK_DATA_LOAD_SUCCESS, ActionTypes.ACTIVE_TAB_SET), function (state) {
        return _extends({}, state, { recentlyConfiguredFeedId: null });
    }), _defineProperty(_handleActions, (0, _reduxActions.combineActions)(LightBoxActionTypes.CREATE_FEED_LOAD_DATA, LightBoxActionTypes.EDIT_FEED_LOAD_DATA, LightBoxActionTypes.EXPORT_ICAL_LOAD_DATA, ActionTypes.RENGERATE_FEED_LINK_DATA_LOAD, ActionTypes.DELETE_FEED_DATA_LOAD), function (state) {
        return _extends({}, state, { userActionLoading: true });
    }), _defineProperty(_handleActions, (0, _reduxActions.combineActions)(LightBoxActionTypes.CREATE_FEED_LOAD_DATA_SUCCESS, LightBoxActionTypes.CREATE_FEED_LOAD_DATA_FAILURE, LightBoxActionTypes.EDIT_FEED_LOAD_DATA_SUCCESS, LightBoxActionTypes.EDIT_FEED_LOAD_DATA_FAILURE, LightBoxActionTypes.EXPORT_ICAL_LOAD_DATA_SUCCESS, LightBoxActionTypes.EXPORT_ICAL_LOAD_DATA_FAILURE, ActionTypes.RENGERATE_FEED_LINK_DATA_LOAD_SUCCESS, ActionTypes.RENGERATE_FEED_LINK_DATA_LOAD_FAILURE, ActionTypes.DELETE_FEED_DATA_LOAD_SUCCESS, ActionTypes.DELETE_FEED_DATA_LOAD_FAILURE), function (state) {
        return _extends({}, state, { userActionLoading: false });
    }), _defineProperty(_handleActions, (0, _reduxActions.combineActions)(LightBoxActionTypes.CREATE_FEED_LOAD_DATA_SUCCESS, LightBoxActionTypes.EDIT_FEED_LOAD_DATA_SUCCESS, ActionTypes.RENGERATE_FEED_LINK_DATA_LOAD_SUCCESS), function (state, _ref12) {
        var feed = _ref12.payload;
        return _extends({}, state, {
            allFeeds: _extends({}, state.allFeeds, _defineProperty({}, feed.id, feed))
        });
    }), _handleActions), initialState);
};

exports.default = createICalFeedsReducer;

/***/ }),
/* 1902 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reduxActions = __webpack_require__(9);

var _actionTypes = __webpack_require__(580);

var ActionTypes = _interopRequireWildcard(_actionTypes);

var _constants = __webpack_require__(264);

var _constants2 = __webpack_require__(51);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _utils = __webpack_require__(168);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var createICalLightBoxReducer = function createICalLightBoxReducer() {
    var _handleActions;

    var initialState = {
        lightboxType: null,
        editedFeedId: null,
        feedName: _messageResource2.default.getMessage(_constants.DEFAULT_FEED_NAME_KEY),
        feedLeaveTypeSelection: _constants.DEFAULT_LEAVE_TYPE_SELECTION,
        includeNotApproved: false,
        userSelection: _constants.DEFAULT_USER_SELECTION,
        sharedUserSelection: _constants.DEFAULT_SHARED_WITH_USER_SELECTION,
        dateRangeSelection: null,
        dateRangeValid: false,
        lightboxLoading: false
    };

    return (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, ActionTypes.LIGHTBOX_TYPE_SET, function (state, _ref) {
        var lightboxType = _ref.payload;
        return _extends({}, state, { lightboxType: lightboxType });
    }), _defineProperty(_handleActions, ActionTypes.FEED_NAME_SET, function (state, _ref2) {
        var feedName = _ref2.payload;
        return _extends({}, state, { feedName: feedName.trim() });
    }), _defineProperty(_handleActions, ActionTypes.USER_SELECTION_SET, function (state, _ref3) {
        var userSelection = _ref3.payload;
        return _extends({}, state, { userSelection: userSelection });
    }), _defineProperty(_handleActions, ActionTypes.SHARED_USER_SELECTION_SET, function (state, _ref4) {
        var sharedUserSelection = _ref4.payload;
        return _extends({}, state, { sharedUserSelection: sharedUserSelection });
    }), _defineProperty(_handleActions, ActionTypes.LEAVE_TYPE_SELECTION_SET, function (state, _ref5) {
        var feedLeaveTypeSelection = _ref5.payload;
        return _extends({}, state, { feedLeaveTypeSelection: feedLeaveTypeSelection });
    }), _defineProperty(_handleActions, ActionTypes.INCLUDE_NOT_APPROVED_SET, function (state, _ref6) {
        var includeNotApproved = _ref6.payload;
        return _extends({}, state, { includeNotApproved: includeNotApproved });
    }), _defineProperty(_handleActions, ActionTypes.DATE_RANGE_SELECITON_SET, function (state, _ref7) {
        var _ref7$payload = _ref7.payload,
            dateRangeSelection = _ref7$payload.dateRangeSelection,
            dateRangeValid = _ref7$payload.dateRangeValid;
        return _extends({}, state, { dateRangeSelection: dateRangeSelection, dateRangeValid: dateRangeValid });
    }), _defineProperty(_handleActions, ActionTypes.CREATE_FEED_LIGHTBOX_DATA_LOAD_SUCCESS, function (state) {
        return _extends({}, state, initialState, { lightboxType: _constants2.ICalLightboxType.CREATE });
    }), _defineProperty(_handleActions, ActionTypes.EXPORT_ICAL_LIGHTBOX_DATA_LOAD_SUCCESS, function (state) {
        return _extends({}, state, initialState, {
            lightboxType: _constants2.ICalLightboxType.EXPORT,
            dateRangeSelection: (0, _utils.getDefaultDateRange)(),
            dateRangeValid: true
        });
    }), _defineProperty(_handleActions, ActionTypes.EDIT_FEED_LIGHTBOX_DATA_LOAD_SUCCESS, function (state, _ref8) {
        var feed = _ref8.payload;
        return _extends({}, state, {
            lightboxType: _constants2.ICalLightboxType.EDIT,
            editedFeedId: feed.id,
            feedName: feed.name,
            feedLeaveTypeSelection: feed.leaveTypesFilter,
            includeNotApproved: feed.leaveTypesFilter.includeNotApproved,
            userSelection: feed.usersFilter,
            sharedUserSelection: feed.sharedUsersFilter
        });
    }), _defineProperty(_handleActions, (0, _reduxActions.combineActions)(ActionTypes.CLOSE_ICAL_LIGHTBOX, ActionTypes.CREATE_FEED_LOAD_DATA_SUCCESS, ActionTypes.CREATE_FEED_LOAD_DATA_FAILURE, ActionTypes.EDIT_FEED_LOAD_DATA_SUCCESS, ActionTypes.EDIT_FEED_LOAD_DATA_FAILURE, ActionTypes.EXPORT_ICAL_LOAD_DATA_SUCCESS, ActionTypes.EXPORT_ICAL_LOAD_DATA_FAILURE), function (state) {
        return _extends({}, state, {
            lightboxType: null,
            feedLeaveTypeSelection: null,
            userSelection: null,
            sharedUserSelection: null,
            dateRangeSelection: null
        });
    }), _defineProperty(_handleActions, (0, _reduxActions.combineActions)(ActionTypes.CREATE_FEED_LIGHTBOX_DATA_LOAD, ActionTypes.EDIT_FEED_LIGHTBOX_DATA_LOAD, ActionTypes.EXPORT_ICAL_LIGHTBOX_DATA_LOAD), function (state) {
        return _extends({}, state, { lightboxLoading: true });
    }), _defineProperty(_handleActions, (0, _reduxActions.combineActions)(ActionTypes.CREATE_FEED_LIGHTBOX_DATA_LOAD_SUCCESS, ActionTypes.CREATE_FEED_LIGHTBOX_DATA_LOAD_FAILURE, ActionTypes.EDIT_FEED_LIGHTBOX_DATA_LOAD_SUCCESS, ActionTypes.EDIT_FEED_LIGHTBOX_DATA_LOAD_FAILURE, ActionTypes.EXPORT_ICAL_LIGHTBOX_DATA_LOAD_SUCCESS, ActionTypes.EXPORT_ICAL_LIGHTBOX_DATA_LOAD_FAILURE), function (state) {
        return _extends({}, state, { lightboxLoading: false });
    }), _handleActions), initialState);
};

exports.default = createICalLightBoxReducer;

/***/ }),
/* 1903 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reduxActions = __webpack_require__(9);

var _actionTypes = __webpack_require__(954);

var ActionTypes = _interopRequireWildcard(_actionTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure undefined"); }

var createAddonsReducer = function createAddonsReducer(_ref) {
    var _handleActions;

    _objectDestructuringEmpty(_ref);

    var initialState = {
        isShown: false
    };

    return (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, ActionTypes.ADDONS_MENU_TOGGLE, function (state) {
        return _extends({}, state, {
            isShown: !state.isShown
        });
    }), _defineProperty(_handleActions, ActionTypes.ADDONS_MENU_CLOSE, function (state) {
        return _extends({}, state, {
            isShown: false
        });
    }), _handleActions), initialState);
};

exports.default = createAddonsReducer;

/***/ }),
/* 1904 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _View2 = __webpack_require__(20);

var _View3 = _interopRequireDefault(_View2);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _AddonsMenu = __webpack_require__(947);

var _AddonsMenu2 = _interopRequireDefault(_AddonsMenu);

var _utils = __webpack_require__(6);

var _redux = __webpack_require__(7);

var _selectors = __webpack_require__(1905);

var _actions = __webpack_require__(1906);

var _DropdownDialogWithPointerWrapper = __webpack_require__(182);

var _DropdownDialogWithPointerWrapper2 = _interopRequireDefault(_DropdownDialogWithPointerWrapper);

var _AddonCard = __webpack_require__(948);

var _AddonCard2 = _interopRequireDefault(_AddonCard);

var _constants = __webpack_require__(4);

var _selectors2 = __webpack_require__(143);

var _constants2 = __webpack_require__(949);

var _MobileAppButtons = __webpack_require__(950);

var _MobileAppButtons2 = _interopRequireDefault(_MobileAppButtons);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AddonsMenuContainer = function (_View) {
    _inherits(AddonsMenuContainer, _View);

    function AddonsMenuContainer() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            _ref$toggleAddonsMenu = _ref.toggleAddonsMenu,
            toggleAddonsMenu = _ref$toggleAddonsMenu === undefined ? function () {} : _ref$toggleAddonsMenu,
            _ref$closeAddonsMenu = _ref.closeAddonsMenu,
            closeAddonsMenu = _ref$closeAddonsMenu === undefined ? function () {} : _ref$closeAddonsMenu;

        _classCallCheck(this, AddonsMenuContainer);

        var _this = _possibleConstructorReturn(this, (AddonsMenuContainer.__proto__ || Object.getPrototypeOf(AddonsMenuContainer)).call(this));

        _this.actions = {
            toggleAddonsMenu: toggleAddonsMenu,
            closeAddonsMenu: closeAddonsMenu
        };

        _this.state = {
            shown: false,
            isShowAtIntegrationAction: false,
            isAtExpired: false,
            isAtViolated: false
        };

        _this.onStatePropertyChanged('shown', function (shown) {
            if (shown) {
                _this.addonsMenuDialog.showAt((0, _jquery2.default)('.popup_menu_button_addons'));
            } else {
                _this.addonsMenuDialog.hide(true);
            }
        });

        _this.onStatePropertyChanged('isShowAtIntegrationAction', function (isShowAtIntegrationAction) {
            _this.atIntegrationCard.setState({
                showActionButton: isShowAtIntegrationAction
            });
        });

        _this.onAnyStatePropertyChanged(['isAtExpired', 'isAtViolated'], function () {
            _this.atIntegrationCard.setState({
                showWarning: _this.state.isAtExpired || _this.state.isAtViolated,
                isExpired: _this.state.isAtExpired
            });
            _this.$alertIcon.toggle(_this.state.isAtExpired || _this.state.isAtViolated);
        });
        return _this;
    }

    _createClass(AddonsMenuContainer, [{
        key: 'afterRender',
        value: function afterRender() {
            var _this2 = this;

            (0, _jquery2.default)('#popup_menu_button_addons').mousedown(function (e) {
                return e.stopPropagation();
            }).click(function () {
                return _this2.actions.toggleAddonsMenu();
            });

            this.$alertIcon = (0, _jquery2.default)('.topMenuButton.addons .alertIcon');

            var openIntegrationPopup = function openIntegrationPopup() {
                _this2.addonsMenuDialog.hide();
                window.openApIntegrationPopup();
            };
            this.atIntegrationCard = new _AddonCard2.default(_extends({}, _constants2.AddonsCardsModels.AT_INTEGRATION, {
                actionButtonTextKey: _constants.PRODUCT_SWITCHER_URL ? 'menu.addons.item.actitime.switch_button' : 'menu.addons.item.actitime.enable_button',
                onActionButtonClick: function onActionButtonClick() {
                    if (_constants.PRODUCT_SWITCHER_URL) {
                        window.location.href = window.unescapeHtmlSymbols(_constants.PRODUCT_SWITCHER_URL);
                    } else {
                        openIntegrationPopup();
                    }
                },
                onDetailsButtonClick: openIntegrationPopup,
                onLinkClickCallback: function onLinkClickCallback() {
                    return _this2.addonsMenuDialog.hide();
                }
            }));

            this.mobileCard = new _AddonCard2.default(_extends({}, _constants2.AddonsCardsModels.MOBILE, {
                additionalIconClass: 'apMobileAppIcon',
                customButtonComponent: new _MobileAppButtons2.default({
                    onIosButtonClick: function onIosButtonClick() {
                        return _this2.openUrl(_constants2.AddonsMenuActionUrls.AP_MOBILE_IOS_ACTION_URL);
                    },
                    onAndroidButtonClick: function onAndroidButtonClick() {
                        return _this2.openUrl(_constants2.AddonsMenuActionUrls.AP_MOBILE_ANDROID_ACTION_URL);
                    }
                }),
                onLinkClickCallback: function onLinkClickCallback() {
                    return _this2.addonsMenuDialog.hide();
                }
            }));

            this.addonsMenu = new _AddonsMenu2.default({
                additionalClass: 'apAddonsMenu',
                integrationComponents: [this.atIntegrationCard],
                mobileComponents: [this.mobileCard]
            });
            this.addonsMenuDialog = new _DropdownDialogWithPointerWrapper2.default({
                dialog: this.addonsMenu,
                additionalClass: 'addonsMenuDropdownDialog',
                showAnimationClass: 'popup_menu_slide_down',
                hideAnimationClass: 'popup_menu_slide_up',
                onHide: this.actions.closeAddonsMenu,
                pointerLeftOffset: '-10px',
                dialogOffsets: {
                    left: -80,
                    top: 8
                }
            }).init((0, _jquery2.default)('body'));
        }
    }, {
        key: 'openUrl',
        value: function openUrl(url) {
            this.addonsMenuDialog.hide();
            window.open(url);
        }
    }]);

    return AddonsMenuContainer;
}(_View3.default);

exports.default = (0, _utils.connect)(function (state) {
    return {
        shown: (0, _selectors.isAddonsMenuShown)(state),
        isShowAtIntegrationAction: (0, _selectors.isShowAtIntegrationAction)(state),
        isAtExpired: (0, _selectors2.isOtherProductLicenseExpired)(state),
        isAtViolated: (0, _selectors2.isOtherProductLicenseViolated)(state)
    };
}, function (dispatch) {
    return {
        toggleAddonsMenu: (0, _redux.bindActionCreators)(_actions.toggleAddonsMenu, dispatch),
        closeAddonsMenu: (0, _redux.bindActionCreators)(_actions.closeAddonsMenu, dispatch)
    };
})(AddonsMenuContainer);

/***/ }),
/* 1905 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isShowAtIntegrationAction = exports.isAddonsMenuShown = undefined;

var _reselect = __webpack_require__(13);

var _selectors = __webpack_require__(143);

var _selectors2 = __webpack_require__(19);

var _constants = __webpack_require__(4);

var getAddonsState = function getAddonsState(state) {
    return state.addons;
};

var isAddonsMenuShown = exports.isAddonsMenuShown = function isAddonsMenuShown(state) {
    return getAddonsState(state).isShown;
};

var isShowAtIntegrationAction = exports.isShowAtIntegrationAction = (0, _reselect.createSelector)(_selectors.isLicenseExpired, _selectors.isLicenseViolated, _selectors.loggedInUserCanManageLicenses, _selectors2.canManageAccountsAndPermissions, _selectors.wasOtherProductEverIntegrated, function (licenseExpired, licenseViolated, canManageLicense, manageAccountsAndPermission, wasOtherProductEverIntegrated) {
    return _constants.PRODUCT_SWITCHER_URL || !wasOtherProductEverIntegrated && (canManageLicense || manageAccountsAndPermission) && !licenseExpired && !licenseViolated || wasOtherProductEverIntegrated && canManageLicense;
});

/***/ }),
/* 1906 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.closeAddonsMenu = exports.toggleAddonsMenu = undefined;

var _actionTypes = __webpack_require__(954);

var ActionTypes = _interopRequireWildcard(_actionTypes);

var _reduxActions = __webpack_require__(9);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var toggleAddonsMenu = exports.toggleAddonsMenu = (0, _reduxActions.createAction)(ActionTypes.ADDONS_MENU_TOGGLE);
var closeAddonsMenu = exports.closeAddonsMenu = (0, _reduxActions.createAction)(ActionTypes.ADDONS_MENU_CLOSE);

/***/ }),
/* 1907 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.makeEnterTTUrl = makeEnterTTUrl;

var _urijs = __webpack_require__(340);

var _urijs2 = _interopRequireDefault(_urijs);

var _date_format = __webpack_require__(16);

var _constants = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function makeEnterTTUrl(date, userId) {
    var url = (0, _urijs2.default)(_constants.EnterTT.PAGE_URL);
    date && url.addSearch("date", new _date_format.DateFormat("yyyy-MM-dd").formatDate(date));
    userId && url.addSearch("cuser", userId);
    return url.toString();
}

exports.default = {
    makeEnterTTUrl: makeEnterTTUrl
};

/***/ }),
/* 1908 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _dropzone = __webpack_require__(339);

var _dropzone2 = _interopRequireDefault(_dropzone);

var _CustomCheckbox = __webpack_require__(83);

var _CustomCheckbox2 = _interopRequireDefault(_CustomCheckbox);

var _constants = __webpack_require__(508);

var _constants2 = __webpack_require__(955);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LogoDropzone = function (_TemplateView) {
    _inherits(LogoDropzone, _TemplateView);

    function LogoDropzone() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            _ref$onFileLoaded = _ref.onFileLoaded,
            onFileLoaded = _ref$onFileLoaded === undefined ? function () {} : _ref$onFileLoaded,
            _ref$onShowBackground = _ref.onShowBackgroundChange,
            onShowBackgroundChange = _ref$onShowBackground === undefined ? function (checked) {} : _ref$onShowBackground,
            _ref$onCreateThumbnai = _ref.onCreateThumbnail,
            onCreateThumbnail = _ref$onCreateThumbnai === undefined ? function (url) {} : _ref$onCreateThumbnai;

        _classCallCheck(this, LogoDropzone);

        var _this = _possibleConstructorReturn(this, (LogoDropzone.__proto__ || Object.getPrototypeOf(LogoDropzone)).call(this));

        _this.callbacks = {
            onFileLoaded: onFileLoaded,
            onShowBackgroundChange: onShowBackgroundChange,
            onCreateThumbnail: onCreateThumbnail
        };

        _this.state = {
            active: false,
            showBackground: false,
            imageUrl: ''
        };

        _this.onStatePropertyChanged('active', function (active) {
            _this.getEl().toggleClass('active', active);
            _this.showBackroundCheckbox.setState({ disabled: !active });
        });

        _this.onStatePropertyChanged('imageUrl', function (imageUrl) {
            _this.$logoPreviewImg.attr('src', imageUrl);
            _this.getEl().toggleClass('hasFile', !!imageUrl);
            _this.$logoPreview.toggle(!!imageUrl);
        });

        _this.onStatePropertyChanged('showBackground', function (showBackground) {
            _this.getEl().toggleClass('logoWithBackground', showBackground);
            _this.showBackroundCheckbox.setState({ checked: showBackground });
        });
        return _this;
    }

    _createClass(LogoDropzone, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '        <div class="logoDropzone">' + '            <div class="placeholder dropzoneClickable">' + '                <div class="image"/>' + '                <div class="text"><%=placeholderText%></div>' + '            </div>' + '            <div class="useWhiteBgCheckbox"/>' + '            <div class="logoPreview">' + '                <div class="logoDetails">' + '                    <img class="currentLogo"/>' + '                </div>' + '            </div>' + '            <div class="logoDropzonePreviewTemplate dz-preview dz-file-preview"><div/></div>' + '            <div class="uploadAnotherImageButton"><%=uploadAnother%></div>' + '        </div>';
        }
    }, {
        key: 'messageKeys',
        value: function messageKeys() {
            return {
                placeholderText: 'logo_settings.dropzone.placeholder_text',
                uploadAnother: 'logo_settings.dropzone.upload_another'
            };
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            var _this2 = this;

            this.$logoPreview = this.find('.logoPreview');
            this.$logoPreviewImg = this.find('.currentLogo');
            this.find('.logoDropzonePreviewTemplate').hide(); // dropzone preview not used here
            this._initDropzone();
            this.showBackroundCheckbox = new _CustomCheckbox2.default({
                label: _messageResource2.default.getMessage('logo_settings.dropzone.use_white_bg'),
                size: _constants.CustomSelectorSize.LITTLE,
                onChange: function onChange(_ref2) {
                    var checked = _ref2.checked;
                    return _this2.callbacks.onShowBackgroundChange(checked);
                }
            }).init(this.find('.useWhiteBgCheckbox'));
            this.find('.uploadAnotherImageButton').on('click', function () {
                if (_this2.state.active) _this2.dropzone.hiddenFileInput.click();
            });

            this.renderInitialState();
        }
    }, {
        key: '_initDropzone',
        value: function _initDropzone() {
            var _this3 = this;

            this.dropzone = new _dropzone2.default('.logoDropzone', _extends({
                previewTemplate: document.querySelector('.logoDropzonePreviewTemplate').innerHTML,
                paramName: 'formCustomInterfaceLogo.logo',
                clickable: '.dropzoneClickable'
            }, _constants2.DROPZONE_PARAMETERS, {
                accept: function accept(file, callback) {
                    if (file.size === 0) callback(_messageResource2.default.getMessage('contact_support.error.empty_file'));else {
                        if (_this3.dropzone.files[1] != null) {
                            _this3.dropzone.removeFile(_this3.dropzone.files[0]);
                        }
                        _this3.callbacks.onFileLoaded();
                        callback();
                    }
                }
            }));
            this.dropzone.on('maxfilesexceeded', function (file) {
                _this3.dropzone.removeFile(_this3.dropzone.files[0]);
                _this3.dropzone.addFile(file);
            });
            this.dropzone.on('error', function (file, error) {
                _this3._onDropzoneError(file, error);
            });
            this.dropzone.createThumbnailFromUrl = function (file, imageUrl, callback, crossOrigin) {
                if (file.accepted) {
                    _this3.callbacks.onCreateThumbnail(imageUrl);
                }
                if (callback != null) {
                    return callback();
                }
            };
        }
    }, {
        key: '_onDropzoneError',
        value: function _onDropzoneError(file, errorText) {
            if (file.status !== 'canceled') {
                alert(errorText);
                this.dropzone.removeFile(file);
            }
        }
    }, {
        key: 'hasFile',
        value: function hasFile() {
            return this.dropzone.files && this.dropzone.files.length;
        }
    }]);

    return LogoDropzone;
}(_TemplateView3.default);

exports.default = LogoDropzone;

/***/ }),
/* 1909 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _dropzone = __webpack_require__(339);

var _dropzone2 = _interopRequireDefault(_dropzone);

var _constants = __webpack_require__(955);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ReportLogoDropzone = function (_TemplateView) {
    _inherits(ReportLogoDropzone, _TemplateView);

    function ReportLogoDropzone() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            _ref$onFileLoaded = _ref.onFileLoaded,
            onFileLoaded = _ref$onFileLoaded === undefined ? function () {} : _ref$onFileLoaded,
            _ref$onCreateThumbnai = _ref.onCreateThumbnail,
            onCreateThumbnail = _ref$onCreateThumbnai === undefined ? function (url) {} : _ref$onCreateThumbnai;

        _classCallCheck(this, ReportLogoDropzone);

        var _this = _possibleConstructorReturn(this, (ReportLogoDropzone.__proto__ || Object.getPrototypeOf(ReportLogoDropzone)).call(this));

        _this.callbacks = {
            onFileLoaded: onFileLoaded,
            onCreateThumbnail: onCreateThumbnail
        };

        _this.state = {
            active: false,
            imageUrl: ''
        };

        _this.onStatePropertyChanged('active', function (active) {
            _this.getEl().toggleClass('active', active);
        });

        _this.onStatePropertyChanged('imageUrl', function (imageUrl) {
            _this.$logoPreviewImg.attr('src', imageUrl);
            _this.getEl().toggleClass('hasFile', !!imageUrl);
            _this.$logoPreview.toggle(!!imageUrl);
        });
        return _this;
    }

    _createClass(ReportLogoDropzone, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '        <div class="reportLogoDropzone">' + '            <div class="reportLogoPlaceholder">' + '                <div class="image"/>' + '                <div class="text"><%=placeholderText%></div>' + '            </div>' + '            <div class="logoPreview">' + '                <div class="logoDetails">' + '                    <img class="currentLogo"/>' + '                </div>' + '            </div>' + '            <div class="reportLogoDropzonePreviewTemplate dz-preview dz-file-preview"><div></div></div>' + '            <div class="uploadAnotherImageButton"><%=uploadAnother%></div>' + '        </div>';
        }
    }, {
        key: 'messageKeys',
        value: function messageKeys() {
            return {
                placeholderText: 'logo_settings.dropzone.placeholder_text',
                uploadAnother: 'logo_settings.dropzone.upload_another'
            };
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            var _this2 = this;

            this.$logoPreview = this.find('.logoPreview');
            this.$logoPreviewImg = this.find('.currentLogo');
            this.find('.reportLogoDropzonePreviewTemplate').hide(); // dropzone preview not used here

            this._initDropzone();
            this.find('.uploadAnotherImageButton').on('click', function () {
                _this2.dropzone.hiddenFileInput.click();
            });

            this.renderInitialState();
        }
    }, {
        key: '_initDropzone',
        value: function _initDropzone() {
            var _this3 = this;

            this.dropzone = new _dropzone2.default('.reportLogoDropzone', _extends({
                previewTemplate: document.querySelector('.reportLogoDropzonePreviewTemplate').innerHTML,
                paramName: 'formCustomReportLogo.logo',
                clickable: '.reportLogoPlaceholder'
            }, _constants.DROPZONE_REPORT_PARAMETERS, {
                accept: function accept(file, callback) {
                    if (file.size === 0) callback(_messageResource2.default.getMessage('contact_support.error.empty_file'));else {
                        if (_this3.dropzone.files[1] != null) {
                            _this3.dropzone.removeFile(_this3.dropzone.files[0]);
                        }
                        _this3.callbacks.onFileLoaded();
                        callback();
                    }
                }
            }));
            this.dropzone.on("maxfilesexceeded", function (file) {
                _this3.dropzone.removeFile(_this3.dropzone.files[0]);
                _this3.dropzone.addFile(file);
            });
            this.dropzone.on('error', function (file, error) {
                _this3._onDropzoneError(file, error);
            });
            this.dropzone.createThumbnailFromUrl = function (file, imageUrl, callback, crossOrigin) {
                if (file.accepted) {
                    _this3.callbacks.onCreateThumbnail(imageUrl);
                }
                if (callback != null) {
                    return callback();
                }
            };
        }
    }, {
        key: '_onDropzoneError',
        value: function _onDropzoneError(file, errorText) {
            if (file.status !== 'canceled') {
                alert(errorText);
                this.dropzone.removeFile(file);
            }
        }
    }, {
        key: 'hasFile',
        value: function hasFile() {
            return this.dropzone.files && this.dropzone.files.length;
        }
    }]);

    return ReportLogoDropzone;
}(_TemplateView3.default);

exports.default = ReportLogoDropzone;

/***/ }),
/* 1910 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ImageRequirementsPopup = function (_TemplateView) {
    _inherits(ImageRequirementsPopup, _TemplateView);

    function ImageRequirementsPopup(_ref) {
        var _ref$showReportsSecti = _ref.showReportsSection,
            showReportsSection = _ref$showReportsSecti === undefined ? false : _ref$showReportsSecti;

        _classCallCheck(this, ImageRequirementsPopup);

        var _this = _possibleConstructorReturn(this, (ImageRequirementsPopup.__proto__ || Object.getPrototypeOf(ImageRequirementsPopup)).call(this));

        _this.params = {
            showReportsSection: showReportsSection
        };
        return _this;
    }

    _createClass(ImageRequirementsPopup, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class="logoImageRequirementsPopup">' + '    <div class="interfacesSection">' + '        <div class="header"><%=interfacesHeader%></div>' + '        <ul>' + '            <li class="rule"><%=interfacesRule1%></li>' + '            <li class="rule"><%=interfacesRule2%></li>' + '            <li class="rule"><%=interfacesRule3%></li>' + '            <li class="note"><%=interfacesRule3Note%></li>' + '            <li class="rule"><%=interfacesRule4%></li>' + '            <li class="rule"><%=interfacesRule5%></li>' + '        </ul>' + '    </div> ' + '    <div class="reportsSection">' + '        <div class="header"><%=reportsHeader%></div>' + '        <ul>' + '            <li class="rule"><%=reportsRule1%></li>' + '            <li class="rule"><%=reportsRule2%></li>' + '            <li class="rule"><%=reportsRule3%></li>' + '        </ul>' + '    </div> ' + '</div>';
        }
    }, {
        key: 'messageKeys',
        value: function messageKeys() {
            return {
                interfacesHeader: 'logo_settings.image_requirements.interfaces.header',
                interfacesRule1: 'logo_settings.image_requirements.interfaces.rule1',
                interfacesRule2: 'logo_settings.image_requirements.interfaces.rule2',
                interfacesRule3: 'logo_settings.image_requirements.interfaces.rule3',
                interfacesRule3Note: 'logo_settings.image_requirements.interfaces.rule3_note',
                interfacesRule4: 'logo_settings.image_requirements.interfaces.rule4',
                interfacesRule5: 'logo_settings.image_requirements.interfaces.rule5',
                reportsHeader: 'logo_settings.image_requirements.reports.header',
                reportsRule1: 'logo_settings.image_requirements.reports.rule1',
                reportsRule2: 'logo_settings.image_requirements.reports.rule2',
                reportsRule3: 'logo_settings.image_requirements.reports.rule3'
            };
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            this.find('.reportsSection').toggle(this.params.showReportsSection);
        }
    }]);

    return ImageRequirementsPopup;
}(_TemplateView3.default);

exports.default = ImageRequirementsPopup;

/***/ }),
/* 1911 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _Button = __webpack_require__(33);

var _Button2 = _interopRequireDefault(_Button);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _atBrowserUtils = __webpack_require__(8);

var _constants = __webpack_require__(4);

var _CookiesInstruction = __webpack_require__(1912);

var _CookiesInstruction2 = _interopRequireDefault(_CookiesInstruction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure undefined"); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CookiesDisabledLoginPlug = function (_TemplateView) {
    _inherits(CookiesDisabledLoginPlug, _TemplateView);

    function CookiesDisabledLoginPlug() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        _objectDestructuringEmpty(_ref);

        _classCallCheck(this, CookiesDisabledLoginPlug);

        var _this = _possibleConstructorReturn(this, (CookiesDisabledLoginPlug.__proto__ || Object.getPrototypeOf(CookiesDisabledLoginPlug)).call(this));

        _this.state = {
            collapsed: true
        };

        _this.onStatePropertyChanged('collapsed', function (collapsed) {
            _this.$enableCookiesBlock.toggleClass('collapsed', collapsed);
        });
        return _this;
    }

    _createClass(CookiesDisabledLoginPlug, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class="cookiesDisabledLoginPlug">' + '    <div class="title"><%=title%></div>' + '    <div class="content">' + '        <div class="paragraph"><%=paragraph1%></div>' + '        <div class="paragraph"><%=paragraph2%></div>' + '        <div class="enableCookiesBlock">' + '                <div class="collapsibleHeader">' + '                    <div class="icon"/>' + '                    <div class="text"><%=instructionTitle%></div>' + '                </div>' + '                <div class="instructionPlaceholder"/>' + '                <div class="browserSupportSection">' + '                    <div class="cookie"/>' + '                    <div class="text"/>' + '                </div>' + '        </div>' + '        <div class="paragraph"><%=paragraph3%></div>' + '    </div>' + '    <div class="updateButton"/>' + '</div>';
        }
    }, {
        key: 'messageKeys',
        value: function messageKeys() {
            return {
                title: 'login.cookies_disabled.title',
                paragraph1: 'login.cookies_disabled.paragraph1',
                paragraph2: 'login.cookies_disabled.paragraph2',
                paragraph3: 'login.cookies_disabled.paragraph3',
                instructionTitle: 'login.cookies_disabled.instruction_title'
            };
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            var _this2 = this;

            this.$enableCookiesBlock = this.find('.enableCookiesBlock');
            new _Button2.default({
                onClickCb: function onClickCb() {
                    document.location.reload();
                },
                label: _messageResource2.default.getMessage('login.cookies_disabled.update')
            }).init(this.find('.updateButton'));

            var browser = (0, _atBrowserUtils.getBrowser)();
            this.find('.browserSupportSection .text').html(this.getBrowserSupportText(browser));
            new _CookiesInstruction2.default({
                browser: browser
            }).init(this.find('.instructionPlaceholder'));
            this.find('.collapsibleHeader').on('click', function () {
                return _this2.setState({ collapsed: !_this2.state.collapsed });
            });
            this.renderInitialState();
        }
    }, {
        key: 'getBrowserSupportText',
        value: function getBrowserSupportText(browser) {
            var _browserToTextMap;

            var browserToTextMap = (_browserToTextMap = {}, _defineProperty(_browserToTextMap, _constants.Browser.CHROME, _messageResource2.default.getMessage('login.cookies_disabled.browser_support.chrome', ['https://support.google.com/accounts/answer/61416?co=GENIE.Platform%3DDesktop&hl=en&oco=0'])), _defineProperty(_browserToTextMap, _constants.Browser.SAFARI, _messageResource2.default.getMessage('login.cookies_disabled.browser_support.safari', ['https://support.apple.com/guide/safari/manage-cookies-and-website-data-sfri11471/mac'])), _defineProperty(_browserToTextMap, _constants.Browser.EDGE, _messageResource2.default.getMessage('login.cookies_disabled.browser_support.edge', ['https://support.microsoft.com/search/results?query=enable+cookies+Microsoft+Edge&isEnrichedQuery=true'])), _defineProperty(_browserToTextMap, _constants.Browser.IE, _messageResource2.default.getMessage('login.cookies_disabled.browser_support.ie', ['https://support.microsoft.com/en-us/topic/change-security-and-privacy-settings-for-internet-explorer-11-9528b011-664c-b771-d757-43a2b78b2afe'])), _defineProperty(_browserToTextMap, _constants.Browser.FIREFOX, _messageResource2.default.getMessage('login.cookies_disabled.browser_support.firefox', ['https://support.mozilla.org/en-US/kb/websites-say-cookies-are-blocked-unblock-them'])), _defineProperty(_browserToTextMap, _constants.Browser.OPERA, _messageResource2.default.getMessage('login.cookies_disabled.browser_support.opera', ['https://help.opera.com/en/latest/web-preferences/#cookies'])), _defineProperty(_browserToTextMap, _constants.Browser.OTHER, _messageResource2.default.getMessage('login.cookies_disabled.browser_support.other')), _browserToTextMap);

            return browserToTextMap[browser];
        }
    }]);

    return CookiesDisabledLoginPlug;
}(_TemplateView3.default);

exports.default = CookiesDisabledLoginPlug;

/***/ }),
/* 1912 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _constants = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CookiesInstruction = function (_TemplateView) {
    _inherits(CookiesInstruction, _TemplateView);

    function CookiesInstruction(_ref) {
        var browser = _ref.browser;

        _classCallCheck(this, CookiesInstruction);

        var _this = _possibleConstructorReturn(this, (CookiesInstruction.__proto__ || Object.getPrototypeOf(CookiesInstruction)).call(this));

        _this.params = {
            browser: browser
        };
        return _this;
    }

    _createClass(CookiesInstruction, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class="instructions">' + '    <div class="instruction <%=chrome%>">' + '        <div class="title"><%=chromeTitle%></div>' + '        <ol class="paragraphs">' + '            <li><%=chromeParagraph1%></li>' + '            <li><%=chromeParagraph2%></li>' + '            <li><%=chromeParagraph3%></li>' + '            <li><%=chromeParagraph4%></li>' + '            <li><%=chromeParagraph5%></li>' + '        </ol>' + '    </div>' + '    <div class="instruction <%=safari%>">' + '        <div class="title"><%=safariTitle%></div>' + '        <ol class="paragraphs">' + '            <li><%=safariParagraph1%></li>' + '            <li><%=safariParagraph2%></li>' + '            <li><%=safariParagraph3%></li>' + '            <li><%=safariParagraph4%></li>' + '        </ol>' + '    </div>' + '    <div class="instruction <%=edge%>">' + '        <div class="title"><%=edgeTitle%></div>' + '        <ol class="paragraphs">' + '            <li><%=edgeParagraph1%></li>' + '            <li><%=edgeParagraph2%></li>' + '            <li><%=edgeParagraph3%></li>' + '            <li><%=edgeParagraph4%></li>' + '            <li><%=edgeParagraph5%></li>' + '        </ol>' + '    </div>' + '    <div class="instruction <%=ie%>">' + '        <div class="title"><%=ieTitle%></div>' + '        <ol class="paragraphs">' + '            <li><%=ieParagraph1%></li>' + '            <li><%=ieParagraph2%></li>' + '            <li><%=ieParagraph3%></li>' + '            <li><%=ieParagraph4%></li>' + '            <li><%=ieParagraph5%></li>' + '            <li><%=ieParagraph6%></li>' + '        </ol>' + '    </div>' + '    <div class="instruction <%=firefox%>">' + '        <div class="title"><%=firefoxTitle%></div>' + '        <ol class="paragraphs">' + '            <li><%=firefoxParagraph1%></li>' + '            <li><%=firefoxParagraph2%></li>' + '            <li><%=firefoxParagraph3%></li>' + '            <li><%=firefoxParagraph4%></li>' + '        </ol>' + '    </div>' + '    <div class="instruction <%=opera%>">' + '        <div class="title"><%=operaTitle%></div>' + '        <ol class="paragraphs">' + '            <li><%=operaParagraph1%></li>' + '            <li><%=operaParagraph2%></li>' + '            <li><%=operaParagraph3%></li>' + '            <li><%=operaParagraph4%></li>' + '        </ol>' + '    </div>' + '</div>';
        }
    }, {
        key: 'templateModel',
        value: function templateModel() {
            return {
                chrome: _constants.Browser.CHROME,
                safari: _constants.Browser.SAFARI,
                edge: _constants.Browser.EDGE,
                ie: _constants.Browser.IE,
                firefox: _constants.Browser.FIREFOX,
                opera: _constants.Browser.OPERA
            };
        }
    }, {
        key: 'messageKeys',
        value: function messageKeys() {
            return {
                chromeTitle: 'login.cookies_disabled.instruction.chrome.browser',
                chromeParagraph1: 'login.cookies_disabled.instruction.chrome.paragraph1',
                chromeParagraph2: 'login.cookies_disabled.instruction.chrome.paragraph2',
                chromeParagraph3: 'login.cookies_disabled.instruction.chrome.paragraph3',
                chromeParagraph4: 'login.cookies_disabled.instruction.chrome.paragraph4',
                chromeParagraph5: 'login.cookies_disabled.instruction.chrome.paragraph5',

                safariTitle: 'login.cookies_disabled.instruction.safari.browser',
                safariParagraph1: 'login.cookies_disabled.instruction.safari.paragraph1',
                safariParagraph2: 'login.cookies_disabled.instruction.safari.paragraph2',
                safariParagraph3: 'login.cookies_disabled.instruction.safari.paragraph3',
                safariParagraph4: 'login.cookies_disabled.instruction.safari.paragraph4',

                edgeTitle: 'login.cookies_disabled.instruction.edge.browser',
                edgeParagraph1: 'login.cookies_disabled.instruction.edge.paragraph1',
                edgeParagraph2: 'login.cookies_disabled.instruction.edge.paragraph2',
                edgeParagraph3: 'login.cookies_disabled.instruction.edge.paragraph3',
                edgeParagraph4: 'login.cookies_disabled.instruction.edge.paragraph4',
                edgeParagraph5: 'login.cookies_disabled.instruction.edge.paragraph5',

                ieTitle: 'login.cookies_disabled.instruction.ie.browser',
                ieParagraph1: 'login.cookies_disabled.instruction.ie.paragraph1',
                ieParagraph2: 'login.cookies_disabled.instruction.ie.paragraph2',
                ieParagraph3: 'login.cookies_disabled.instruction.ie.paragraph3',
                ieParagraph4: 'login.cookies_disabled.instruction.ie.paragraph4',
                ieParagraph5: 'login.cookies_disabled.instruction.ie.paragraph5',
                ieParagraph6: 'login.cookies_disabled.instruction.ie.paragraph6',

                firefoxTitle: 'login.cookies_disabled.instruction.firefox.browser',
                firefoxParagraph1: 'login.cookies_disabled.instruction.firefox.paragraph1',
                firefoxParagraph2: 'login.cookies_disabled.instruction.firefox.paragraph2',
                firefoxParagraph3: 'login.cookies_disabled.instruction.firefox.paragraph3',
                firefoxParagraph4: 'login.cookies_disabled.instruction.firefox.paragraph4',

                operaTitle: 'login.cookies_disabled.instruction.opera.browser',
                operaParagraph1: 'login.cookies_disabled.instruction.opera.paragraph1',
                operaParagraph2: 'login.cookies_disabled.instruction.opera.paragraph2',
                operaParagraph3: 'login.cookies_disabled.instruction.opera.paragraph3',
                operaParagraph4: 'login.cookies_disabled.instruction.opera.paragraph4'
            };
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            this.find('.' + this.params.browser).show();
        }
    }]);

    return CookiesInstruction;
}(_TemplateView3.default);

exports.default = CookiesInstruction;

/***/ }),
/* 1913 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _OverlayTips = __webpack_require__(86);

var _OverlayTips2 = _interopRequireDefault(_OverlayTips);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _PageOverlayTipsManager = __webpack_require__(408);

var _PageOverlayTipsManager2 = _interopRequireDefault(_PageOverlayTipsManager);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function OverlayTipsKit() {
    this._tipConfigs = {};
    this._queue = [];
}

OverlayTipsKit.isWrappedWithTip = function (el) {
    return el.parent().hasClass('overlayTipWrapper');
};

OverlayTipsKit.prototype = {
    /**
     * Hides all tips.
     */
    hideAll: function hideAll() {
        _underscore2.default.each(_underscore2.default.values(this._tipConfigs), function (config) {
            config.tip.atAnimation().fadeOut();
        });
    },

    /**
     * Shows all tips.
     */
    showAll: function showAll() {
        _underscore2.default.each(_underscore2.default.values(this._tipConfigs), function (config) {
            config.tip.atAnimation().fadeIn();
        });
        this.repositionOutsideTips();
        _PageOverlayTipsManager2.default.getInstance().disableFirstTimeCookie();
    },

    /**
     * Removes tip from the DOM.
     * @param id Tip ID.
     */
    remove: function remove(id) {
        this._tipConfigs[id].tip.remove();
        delete this._tipConfigs[id];
    },

    /**
     * Removes all tips from the DOM.
     */
    removeAll: function removeAll() {
        _underscore2.default.each(_underscore2.default.values(this._tipConfigs), function (config) {
            config.tip.remove();
        });
        this._tipConfigs = {};
    },

    /**
     * Adds config for an overlay tip to be positioned.
     * @param config Overlay tip config
     */
    enqueueTip: function enqueueTip(config) {
        this._init();

        // Set config defaults
        config = _underscore2.default.defaults(config, {
            show: false,
            direction: _OverlayTips2.default.DIRECTION_TOP_LEFT,
            offsetX: 0,
            offsetY: 0
        });

        if (config.outside) {
            config.outside = _underscore2.default.defaults(config.outside, {
                direction: config.direction,
                offsetX: config.offsetX,
                offsetY: config.offsetY
            });
        }

        // Create tip element
        config.tip = (0, _jquery2.default)("<div>").addClass("overlayTip");

        // Append text lines
        var text = config.text;
        if (config.messageKey) text = _messageResource2.default.getMessage(config.messageKey);
        _underscore2.default.each(text.split("\n"), function (line) {
            config.tip.append((0, _jquery2.default)("<div>").addClass("overlayTipLine").text(line)).append("<br/>");
        });

        // Append arrow
        config.arrow = (0, _jquery2.default)("<div>").addClass("overlayTipArrow");
        config.tip.append(config.arrow);

        // Add tip element ID
        config.id = _OverlayTips2.default._idSequence++;
        config.tip.attr("id", "overlayTip" + config.id);

        // Add extra classes to the tip
        if (config.extraClass) config.tip.addClass(config.extraClass);

        // Config processed only if it remain in _tipConfigs
        this._tipConfigs[config.id] = config;

        if (config.calculatedSizes) this._processTip(config);else {
            // Before we set tip position, it's added as a hidden body child,
            // where browser will calculate its dimensions
            (0, _jquery2.default)("body").append(config.tip);

            // Schedule queue processing
            if (this._queue.length == 0) this.scheduleQueueProcessing();
            this._queue.push(config);
        }

        return config;
    },

    scheduleQueueProcessing: function scheduleQueueProcessing() {
        defer(_underscore2.default.bind(this._processQueue, this));
    },

    isQueueProcessed: function isQueueProcessed() {
        return this._queue.length == 0;
    },

    /**
     * Processes tips queue.
     * @private
     */
    _processQueue: function _processQueue() {
        _underscore2.default.each(this._queue, this._processTip, this);
        this._queue = [];
        this.repositionOutsideTips();
    },

    /**
     * Inserts tip element into DOM, setting coordinates.
     * @param config Overlay tip config
     * @private
     */
    _processTip: function _processTip(config) {
        // Check if config processed after it was removed
        if (!this._tipConfigs[config.id]) return;

        var relativeTo = config.relativeTo;
        var tip = config.tip;

        this._positionTip(config);

        // Make tip visible
        tip.addClass("visible");

        // Show the tip immediately if needed
        if (config.show) {
            // Only animate if this is a fresh tip or if refresh animation is enabled
            if (config.refreshAnimated || !config.processedOnce && !config.noFirstTimeAnimation) tip.atAnimation().fadeIn();else tip.show();
        } else tip.hide();

        // Determine a way to put a wrapper element - inside or outside the relative
        var relativeToDisplay = relativeTo.css("display");
        var wrapInner = config.wrapInner || relativeTo.is("td");
        var wrapper;
        if (wrapInner) {
            // Try to find existing wrapper inside
            wrapper = relativeTo.children(".overlayTipWrapper");
            if (wrapper.length == 0) {
                // Existing wrapper not found, create new
                relativeTo.wrapInner((0, _jquery2.default)("<div>").addClass("overlayTipWrapper"));
                wrapper = relativeTo.children(".overlayTipWrapper");
            }
        } else {
            // Try to find existing wrapper outside
            wrapper = relativeTo.parent(".overlayTipWrapper");
            if (wrapper.length == 0) {
                // Existing wrapper not found, create new
                wrapper = (0, _jquery2.default)("<div>").addClass("overlayTipWrapper");
                if (relativeToDisplay == "inline-block" || relativeToDisplay == "inline") {
                    // Correct position properties for inline relative
                    wrapper.css("display", "inline-block");
                    wrapper.css("vertical-align", relativeTo.css("vertical-align"));
                }
                relativeTo.wrap(wrapper);
                wrapper = relativeTo.parent();
            }
        }

        // Prevent event bubble from tip
        config.tip.on("click mousedown mouseup mouseover", function (e) {
            stopEventPropagation(e);
        });

        // Add the tip to the wrapper removing any old tips
        wrapper.children(".overlayTip").remove();
        wrapper.append(tip);

        // Remember actual DOM elements
        config.tip = wrapper.children(".overlayTip");
        config.arrow = config.tip.children(".overlayTipArrow");

        // Mark tip as processed once in the config
        config.processedOnce = true;
    },

    /**
     * Sets tip and arrow element positions.
     * @private
     */
    _positionTip: function _positionTip(config) {
        var tip = config.tip;
        var arrow = config.arrow;

        var positionConfig = config;
        if (config.outsideActive) positionConfig = config.outside;
        var direction = positionConfig.direction;
        var offsetX = positionConfig.offsetX;
        var offsetY = positionConfig.offsetY;
        var anchor = positionConfig.anchor;

        // Calc tip and arrow base offsets
        if (!config.calculatedSizes) {
            // Sizes are calculated only once and are remembered for future use
            config.calculatedSizes = {
                arrowWidth: arrow.width(),
                tipWidth: tip.width(),
                tipHeight: tip.height()
            };
        }

        var arrowOffsetX = -config.calculatedSizes.arrowWidth - 5;
        var arrowOffsetY = 0;
        var tipOffsetX = -config.calculatedSizes.tipWidth + arrowOffsetX - offsetX;
        var tipOffsetY = -config.calculatedSizes.tipHeight + arrowOffsetY - offsetY;

        // Clear any prior attributes
        tip.css("left", "").css("top", "").css("right", "").css("bottom", "");
        arrow.css("left", "").css("top", "").css("right", "").css("bottom", "");
        arrow.removeClass("topLeft").removeClass("topRight").removeClass("bottomLeft").removeClass("bottomRight");

        if (anchor) {
            var flag = direction ^ anchor;
            if ((flag & (_OverlayTips2.default._ANCHOR_LEFT | _OverlayTips2.default._ANCHOR_RIGHT)) !== 0) {
                if (!config.calculatedSizes.relativeWidth) config.calculatedSizes.relativeWidth = config.relativeTo.width();
                tipOffsetX += config.calculatedSizes.relativeWidth;
            }
            if ((flag & (_OverlayTips2.default._ANCHOR_TOP | _OverlayTips2.default._ANCHOR_BOTTOM)) !== 0) {
                if (!config.calculatedSizes.relativeHeight) config.calculatedSizes.relativeHeight = config.relativeTo.height();
                tipOffsetY += config.calculatedSizes.relativeHeight;
            }
        }

        // Set tip and arrow coordinates
        switch (direction) {
            case _OverlayTips2.default.DIRECTION_TOP_LEFT:
                tip.css("left", tipOffsetX + "px");
                tip.css("top", tipOffsetY + "px");
                arrow.css("right", arrowOffsetX + "px");
                arrow.css("bottom", arrowOffsetY + "px");
                arrow.addClass("topLeft");
                break;
            case _OverlayTips2.default.DIRECTION_TOP_RIGHT:
                tip.css("right", tipOffsetX + "px");
                tip.css("top", tipOffsetY + "px");
                arrow.css("left", arrowOffsetX + "px");
                arrow.css("bottom", arrowOffsetY + "px");
                arrow.addClass("topRight");
                break;
            case _OverlayTips2.default.DIRECTION_BOTTOM_LEFT:
                tip.css("left", tipOffsetX + "px");
                tip.css("bottom", tipOffsetY + "px");
                arrow.css("right", arrowOffsetX + "px");
                arrow.css("top", arrowOffsetY + "px");
                arrow.addClass("bottomLeft");
                break;
            case _OverlayTips2.default.DIRECTION_BOTTOM_RIGHT:
                tip.css("right", tipOffsetX + "px");
                tip.css("bottom", tipOffsetY + "px");
                arrow.css("left", arrowOffsetX + "px");
                arrow.css("top", arrowOffsetY + "px");
                arrow.addClass("bottomRight");
                break;
        }
    },

    /**
     * Re-position tips, which have fallen outside the screen.
     */
    repositionOutsideTips: function repositionOutsideTips() {
        var self = this;
        _underscore2.default.each(_underscore2.default.values(this._tipConfigs), function (config) {
            // Only process tips with configured alternative position
            if (config.outside) {
                var tip = config.tip;
                var left = tip.offset().left;

                if (!tip.hasClass("outside") && left < 0) {
                    // Tip was on usual position but is outside now, so move it to alternate position
                    config.outsideActive = true;
                    self._positionTip(config);
                    tip.addClass("outside");

                    // Remember this, so we know when to put the tip back
                    var newLeft = tip.offset().left;
                    config.outside.leftDiff = newLeft - left;
                } else if (left - config.outside.leftDiff > 0) {
                    // Tip was on alternate position, but its regular position would be inside, so move it back
                    config.outsideActive = false;
                    self._positionTip(config);
                    tip.removeClass("outside");
                }
            }
        });
    },

    _init: function _init() {
        _OverlayTips2.default.init();
    }
};

exports.default = OverlayTipsKit;

/***/ }),
/* 1914 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _atUtils = __webpack_require__(5);

var _group_controller = __webpack_require__(527);

var _group_controller2 = _interopRequireDefault(_group_controller);

var _base_group_management_controller = __webpack_require__(310);

var _LeaveBalanceEditorContent = __webpack_require__(901);

var _LeaveBalanceEditorContent2 = _interopRequireDefault(_LeaveBalanceEditorContent);

var _BalanceHistoryPanelContent = __webpack_require__(902);

var _BalanceHistoryPanelContent2 = _interopRequireDefault(_BalanceHistoryPanelContent);

var _BalanceRulesEditorDialogContent = __webpack_require__(857);

var _BalanceRulesEditorDialogContent2 = _interopRequireDefault(_BalanceRulesEditorDialogContent);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _jquery_rpc = __webpack_require__(26);

var _jquery_rpc2 = _interopRequireDefault(_jquery_rpc);

var _Button = __webpack_require__(33);

var _Button2 = _interopRequireDefault(_Button);

var _EditUserLightBox = __webpack_require__(1915);

var _EditUserLightBox2 = _interopRequireDefault(_EditUserLightBox);

var _ManageGroupsButton = __webpack_require__(898);

var _ManageGroupsButton2 = _interopRequireDefault(_ManageGroupsButton);

var _ManageGroupsList = __webpack_require__(896);

var _ManageGroupsList2 = _interopRequireDefault(_ManageGroupsList);

var _AnimatedDialogWrapper = __webpack_require__(286);

var _AnimatedDialogWrapper2 = _interopRequireDefault(_AnimatedDialogWrapper);

var _LastManagerInfo = __webpack_require__(560);

var _LastManagerInfo2 = _interopRequireDefault(_LastManagerInfo);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _ConfirmationDialog = __webpack_require__(559);

var _ConfirmationDialog2 = _interopRequireDefault(_ConfirmationDialog);

var _constants = __webpack_require__(4);

var _ClassicBridge = __webpack_require__(18);

var _ClassicBridge2 = _interopRequireDefault(_ClassicBridge);

var _constants2 = __webpack_require__(77);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function UserListPage() {
    this.constructor = UserListPage;
}

UserListPage.BOTTOM_BAR_HEIGHT = 26;

UserListPage.prototype.init = function (pageData, pageState, currentUserId, weekStartDay, currentUserTZGroupId, exportBalanceHistoryUrl) {
    var _this = this;

    var that = this;

    this._weekStartDay = weekStartDay;
    this._ptoHoursPerDay = pageData.ptoHoursPerDay;
    this._userSettingsUpdateRequestObjects = {};
    this.userIdRowMap = {};

    this._currentUserId = currentUserId;
    this._currentUserTZGroupId = currentUserTZGroupId;
    this._findElementsInDocument();

    this._initUserRolesPopup();

    this._spinnerController = new SpinnerController();

    // Note: state controller must to contain only page controls, which must be reverted if server requests failed
    this._stateController = new StateController().init(pageState);
    this._stateController.addOnSaveStateActions(function (state) {
        that._renderUserListControls(state, false);
    });

    this._stateController.addOnLoadStateActions(function (state) {
        that._renderUserListControls(state, true);
    });

    this.warningsController = new WarningsController();

    function _updateUserListIfNecessary() {
        //noinspection JSPotentiallyInvalidUsageOfThis
        var input = that._userNameFilterInput.getInnerInputElement();
        if (input.prevValue != input.value) {
            input.prevValue = input.value;
            that._stateController.setProperty('userNameFilterText', that._userNameFilterInput.getSearchString());
            that._stateController.setProperty('pageNum', 1);
            that._updateUserListWithDelay(200, 'spinnerPlaceholder');
        }
    }
    function typingFilterNameFn(event) {
        var input = that._userNameFilterInput.getInnerInputElement();
        if (event.keyCode == KEY_CODE_ESC && input.value != "") {
            input.value = "";
        }
        _updateUserListIfNecessary();
    }
    function clearTypedNameFn() {
        _updateUserListIfNecessary();
    }
    this._userNameFilterInput = new FilterWordsField().initAndRender(typingFilterNameFn, (0, _jquery2.default)(".userNameInputContainer")[0], "actiplans.user_list.js.start_typing_name", clearTypedNameFn);

    this._viewerSettings = pageData.viewerSettings;
    this._ptoCalculationEnabled = pageData.ptoCalculationEnabled;
    this._sickBalanceCalculationEnabled = pageData.sickBalanceCalculationEnabled;

    if (!this._ptoCalculationEnabled && !this._sickBalanceCalculationEnabled) {
        this._hideManageBalanceColumn();
    }

    this._initUserFilter();

    this._onlyUsersWithoutApproversCaption.click(function () {
        var userListFilter = that._stateController.getProperty("userListFilter");
        userListFilter.onlyUsersWithoutApprovers = true;
        userListFilter.groupIds = null;
        userListFilter.statusFilter = UserListPageConstants.USER_STATUS_FILTER_ENABLED_ONLY;
        userListFilter.rolesFilter = UserListPageConstants.USER_ROLES_FILTER_ALL;

        that._stateController.setProperty("userListFilter", userListFilter);
        that._stateController.setProperty("userNameFilterText", "");

        that._userNameFilterInput.clearInputValue();
        that._accountStatusFilterCheckbox.attr('checked', false);
        that._accountStatusFilterCheckbox.attr('disabled', true);

        that._onlyManagersFilterCheckbox.attr('checked', false);
        that._onlyManagersFilterCheckbox.attr('disabled', true);

        that._updateUserList('spinnerPlaceholder', true);
    });

    this._cancelOnlyUsersWithoutApproversButton.click(function () {
        var userListFilter = that._stateController.getProperty("userListFilter");
        userListFilter.onlyUsersWithoutApprovers = false;
        that._stateController.setProperty(userListFilter);
        that._accountStatusFilterCheckbox.attr('disabled', false);
        that._onlyManagersFilterCheckbox.attr('disabled', false);
        that._updateUserList('spinnerPlaceholder', true);
    });

    this._accountStatusFilterCheckbox.change(function () {
        that._accountStatusSortDataHolder.attr('disabled', !this.checked);
        (0, _jquery2.default)(that._accountStatusSortDataHolder).toggleClass("disabledSortButton", !this.checked);
    });

    this._accountStatusFilterCheckbox.click(function () {
        var userListFilter = that._stateController.getProperty("userListFilter");
        userListFilter.statusFilter = this.checked ? UserListPageConstants.USER_STATUS_FILTER_ALL : UserListPageConstants.USER_STATUS_FILTER_ENABLED_ONLY;
        that._stateController.setProperty(userListFilter);
        that._stateController.setProperty('pageNum', 1);
        that._updateUserList('spinnerPlaceholder', true);
    });

    this._onlyManagersFilterCheckbox.click(function () {
        var userListFilter = that._stateController.getProperty("userListFilter");
        userListFilter.rolesFilter = this.checked ? UserListPageConstants.USER_ROLES_FILTER_MANAGERS_ONLY : UserListPageConstants.USER_ROLES_FILTER_ALL;
        that._stateController.setProperty(userListFilter);
        that._stateController.setProperty('pageNum', 1);
        that._updateUserList('spinnerPlaceholder', true);
    });

    this._pagerController = new PagerController().init({
        pagerData: this._stateController.getProperties(['pageNum', 'totalRecords', 'recordsPerPage']),
        handlersMap: {
            pageChanged: function pageChanged(pageNum) {
                that._stateController.setProperty('pageNum', pageNum);
                that._updateUserList('spinnerPlaceholderPager');
            },
            recordsPerPageChanged: function recordsPerPageChanged(recordsPerPage) {
                that._stateController.setProperty('recordsPerPage', recordsPerPage);
                that._pagerController.loadPage(1);
            }
        },
        pagerControlsElementId: "pagerPanel",
        pagerElementId: "pager",
        recordsPerPageSelectorId: "recordsPerPageSelector",
        minRecordsPerPage: MIN_RECORDS_PER_PAGE
    });
    this._pagerController.render();

    var self = this;

    // time zone group of logged in user
    this.previousLoggedInUserTZGroup = _.find(pageData.allTimeZoneGroups, function (tzGroup) {
        return tzGroup.id == currentUserTZGroupId;
    });

    this._initTabs();

    this._userListHeader.find('.sortButton').click(function () {
        var parent = (0, _jquery2.default)(this).parent();
        if (parent.attr("disabled")) return;

        that._onSortButtonClick(parent.attr("data-sortBy"), parent.attr("data-spinnerPlaceholder"));
    });

    this._getManageApproversDataRequestObject = null;

    this._approversDialog = new ApproversDialog().init({
        submit: function submit(dialogInfo, isAutoApproved, selectedApproverIds) {
            self._sendAssignApproversRequest(dialogInfo, isAutoApproved, selectedApproverIds);
        },
        loadData: function loadData(dialogInfo, dataLoadedCallback, loadingFailedCallback) {
            that._getManageApproversDataRequestObject = (0, _jquery_rpc2.default)("UserManagementService.getManageApproversData", [dialogInfo.userId], function (manageApproversData) {
                var targetRow = dialogInfo.targetRow;
                targetRow.data().record.requiresApproval = manageApproversData.userRequiresApproval;

                var approversSortingProcessor = self._createApproversSortingProcessor(manageApproversData.allApprovers);
                targetRow.data().userApprovers = approversSortingProcessor(manageApproversData.userApproverIds);

                that._updateApprovedByCellContent(targetRow);
                if (manageApproversData.allApprovers.length == 0) {
                    that._setAllUsersAutoApproved();
                }

                dataLoadedCallback(manageApproversData.allApprovers, !manageApproversData.userRequiresApproval, manageApproversData.userApproverIds);
            }, function (jqXHR, textStatus, errorThrown) {
                if (textStatus == 'abortDataLoading') {
                    return true;
                }
                if (errorThrown.exception == 'com.actimind.actitime.administration.NoSuchUserException') {
                    alert(_messageResource2.default.getMessage('actiplans.user_list.error_user_was_deleted'));
                    UserListPage.removeRow(dialogInfo.targetRow);
                    loadingFailedCallback();
                    return true;
                }
                loadingFailedCallback();
            });
        },
        abortDataLoading: function abortDataLoading() {
            if (that._getManageApproversDataRequestObject != null) {
                that._getManageApproversDataRequestObject.abort('abortDataLoading');
            }
        }
    }, 360);

    this._getAssignUsersToApproverDataRequestObject = null;
    this._usersForApproverDialog = new UsersForLTRApproverDialog().init({
        dialogWidth: 438,
        dialogId: "usersForApproverDialog",
        panelConstructor: AT.UsersForLTRApproverSelectorPanel,
        abortDataLoading: function abortDataLoading() {
            if (that._getAssignUsersToApproverDataRequestObject != null) that._getAssignUsersToApproverDataRequestObject.abort('abortDataLoading');
        },
        userGroupsEnabled: self._isUGREnabled(),
        timeZoneGroupsEnabled: self._isTZGEnabled(),

        loadData: function loadData(dialogInfo, dataLoadedCallback) {
            that._getAssignUsersToApproverDataRequestObject = (0, _jquery_rpc2.default)("UserManagementService.getUsersAssignedToApprover", [dialogInfo.userId], function (assignedUsersData) {
                if (checkReloadNeededAfterGetAssignedUsersRequest(assignedUsersData, self._isUGREnabled(), self._isTZGEnabled(), self._usersForApproverDialog)) {
                    document.location.reload();
                    return;
                }

                that._updateUsersForApproverDataAndCell(dialogInfo.targetRow, assignedUsersData.canManageAllUsers, assignedUsersData.numberOfAssignedUsers);

                dataLoadedCallback(assignedUsersData);

                PageOverlayTipsManager.getInstance().refreshDynamicTips();
            }, function (jqXHR, textStatus, errorThrown) {
                if (textStatus == 'abortDataLoading') return true;

                if (errorThrown.exception == 'com.actimind.actitime.administration.NoSuchUserException') {
                    alert(_messageResource2.default.getMessage('actiplans.user_list.error_user_was_deleted'));
                    UserListPage.removeRow(dialogInfo.targetRow);
                    self._usersForApproverDialog.close();
                    return true;
                } else if (errorThrown.exception == 'com.actimind.actitime.services.NoRightsToManageAccountSettings') {
                    alert(_messageResource2.default.getMessage('actiplans.user_list.error_cant_create_user_account'));
                    document.location.reload();
                    return true;
                }

                self._usersForApproverDialog.close();
                return false;
            });
        },
        saveData: function saveData(dialogInfo, canManageAllUsers, selectedUserIds) {
            self._sendAssignUsersRequest(dialogInfo, canManageAllUsers, selectedUserIds, self._visibleOnPageUserIds);
        }

    });

    this._licenseCounterManager = new LicenseCounterManager().init(document.getElementById("licenseCountId"));

    this.ptoRulesManager = new _BalanceRulesEditorDialogContent2.default({
        leaveBalanceTypePrefix: "pto",
        balanceDefaults: pageData.ptoDefaults,
        countHoursPerDay: this._ptoHoursPerDay,
        parameters: {
            defaultMessageNoteKey: "pto_rules_editor.info.default",
            titleNoteKey: "pto_rules_editor.use_accrual_rules",
            customMessageNoteKey: "pto_rules_editor.info.custom",
            customTitleTooltip: "pto_rules_editor.custom_rules",
            defaultTitleTooltip: "pto_rules_editor.default_rules"
        }
    }).init(this._pageContent);

    this.sickRulesManager = new _BalanceRulesEditorDialogContent2.default({
        leaveBalanceTypePrefix: "sick",
        balanceDefaults: pageData.sickDefaults,
        countHoursPerDay: this._ptoHoursPerDay,
        parameters: {
            defaultMessageNoteKey: "sick_rules_editor.info.default",
            titleNoteKey: "sick_rules_editor.use_accrual_rules",
            customMessageNoteKey: "pto_rules_editor.info.custom",
            customTitleTooltip: "sick_rules_editor.custom_rules",
            defaultTitleTooltip: "sick_rules_editor.default_rules"
        }
    }).init(this._pageContent);

    this._balanceHistoryPanel = new _BalanceHistoryPanelContent2.default({
        exportBalanceHistoryUrl: exportBalanceHistoryUrl
    }).init(this._pageContent);
    this.$tableContainerEl = (0, _jquery2.default)("#balanceHistoryTableBodyDiv");

    this._updatePage(pageData);
    this._renderUserListControls(pageState, true);

    this._balanceEditor = new _LeaveBalanceEditorContent2.default().init(this._pageContent);

    // Even Actiplans may not be Online version (can be demo)
    if (_constants.isOlVersion) {
        this._addButtonStrategy = _constants.isOlVersion ? new AddButtonOnlineStrategy().init(this._bulkInvitationsButton, this._self(this._onInviteSeveralUsersButtonClicked), this._self(this._onUsersImported)) : new AddButtonDownloadableStrategy().init(this._self(this._onCreateUserButtonClicked));
    }

    PageOverlayTipsManager.setInstance(new APUserListPageOverlayTipsManager({
        ptoEnabled: this._ptoCalculationEnabled,
        sickEnabled: this._sickBalanceCalculationEnabled,
        ugrEnabled: this._isUGREnabled(),
        tzgEnabled: this._isTZGEnabled()
    }));

    if (this._viewerSettings.allowedToManageAccountSettings) {
        new _Button2.default({
            label: _messageResource2.default.getMessage('userlist.add_new_user'),
            withPlusIcon: true,
            onClickCb: function onClickCb() {
                return _this._onCreateUserButtonClicked();
            }
        }).init((0, _jquery2.default)(this._addNewUserButton));

        this.manageGroupsButton = new _ManageGroupsButton2.default({
            onButtonClick: function onButtonClick() {
                return _this._handleManageGroupsButtonClick();
            }
        }).init((0, _jquery2.default)('.userList_container_managementButtonsContainer'));
        this.manageGroupsButton.hide();

        this.manageGroupsButton.setState({
            isUGREnabled: this._isUGREnabled(),
            isTZGEnabled: this._isTZGEnabled()
        });

        this.manageGroupsDialog = new _AnimatedDialogWrapper2.default(null, {
            className: 'userList_manageButtons_component_manageGroupsList',
            toggleMode: true, // TODO not working :(
            dialog: new _ManageGroupsList2.default({
                departmentsOnClick: function departmentsOnClick() {
                    _this.manageGroupsDialog.hide();
                    _this._handleDepartmentsButtonClick();
                },
                timeZoneOnClick: function timeZoneOnClick() {
                    _this.manageGroupsDialog.hide();
                    _this._handleTimeZoneGroupsButtonClick();
                }
            }),
            autoPosition: true
        }).init((0, _jquery2.default)('body'));

        this.manageGroupsButton.toggle(this._isUGREnabled() || this._isTZGEnabled());
    }

    return this;
};

UserListPage.prototype._initUserFilter = function () {
    var that = this;
    var userListFilter = that._stateController.getProperty("userListFilter");
    var userIds = userListFilter.userIds;
    var groupIds = userListFilter.groupIds;
    var groupType = userListFilter.groupType;

    this._userGroupsSelector = window.ClassicBridge.integrateUserFilter((0, _jquery2.default)('.userGroupsFilterPlaceholder')[0], {
        className: 'userGroupsFilterPlaceholderTrigger',
        onApply: function onApply(data) {
            that._onGroupSelectionChanged(data);
        },
        initialData: (!userIds || userIds.length === 0) && (!groupIds || groupIds.length === 0) ? 'All' : {
            ids: userIds,
            groupIds: groupType === GroupType.USER_GROUP ? groupIds : null,
            timeZoneGroupIds: groupType === GroupType.TIME_ZONE_GROUP ? groupIds : null,
            onlyIfInMyTeam: userListFilter.onlyUsersWithoutApprovers
        }
    });
};

UserListPage.prototype._initTabs = function () {
    var self = this;
    if (!this.activeTabValue) this.activeTabValue = self._loadActiveTabNum();

    if (this._viewerSettings.allowedToManageLeaveBalanceSettings && (this._ptoCalculationEnabled || this._sickBalanceCalculationEnabled)) {
        var items = [];
        items.push({ id: 'tabAccountSettings', text: "userlist.tabs.account_settings", value: UserListPageConstants.ACCOUNT_SETTINGS_TAB_NUM });
        if (this._ptoCalculationEnabled) items.push({ id: 'tabPTOSettings', text: "userlist.tabs.users_pto", value: UserListPageConstants.PTO_SETTINGS_TAB_NUM });
        if (this._sickBalanceCalculationEnabled) items.push({ id: 'tabSickDaysSettings', text: "userlist.tabs.users_sick_days", value: UserListPageConstants.SICK_DAYS_SETTINGS_TAB_NUM });

        this.tabs = new UserlistTabs().init({
            id: "userListTabs",
            items: items,
            activeTabValue: self.activeTabValue,
            changeCallback: function changeCallback() {
                self._toggleTableClassForTabs(self.tabs.getActiveTab());
                _jquery2.default.cookie("actiPLANS-userlist-tabs", self.tabs.getActiveTab(), { expires: 4000 });
            }
        });
        this._pageContent.addClass("wide");
    }
    if (!this._viewerSettings.allowedToManageLeaveBalanceSettings && (this._ptoCalculationEnabled || this._sickBalanceCalculationEnabled)) {
        this._pageContent.addClass("middle");
    }

    self._toggleTableClassForTabs(this.activeTabValue);
};

UserListPage.prototype._sendAssignApproversRequest = function (dialogInfo, isAutoApproved, selectedApproverIds) {
    var self = this;
    this._callUserManagementService(dialogInfo.targetRow, 'UserManagementService.assignApproversToUser', [dialogInfo.userId, isAutoApproved, selectedApproverIds, self._visibleOnPageUserIds], UserListPage.USER_SETTINGS_UPDATE_KEY_APPROVED_BY, null, function (userManagementResult) {
        var approversSortingProcessor = self._createApproversSortingProcessor(userManagementResult.allApprovers);
        _jquery2.default.each(userManagementResult.additionalUsersInfo, function () {
            var userInfo = this;
            var row = self.userIdRowMap[userInfo.id];
            if (row) {
                row.data().record = userInfo;
                row.data().userApprovers = approversSortingProcessor(userManagementResult.approverIdsMap.map[userInfo.id]);
                self._updateRow(row);
            }
        });

        self._updateThereAreUsersWithoutApproversSetting(userManagementResult.thereAreUsersWithoutApprovers);

        self._approversDialog.hideAfterSaving();
        self._highlightRow(dialogInfo.targetRow);

        PageOverlayTipsManager.getInstance().refreshDynamicTips();
    }, function (jqXHR, textStatus, errorThrown) {
        if (errorThrown.exception == 'com.actimind.common.administration.SomeOfSelectedApproversNotValidException') {
            var allApprovers = errorThrown.allApprovers;
            if (allApprovers.length == 0) {
                alert(_messageResource2.default.getMessage("actiplans.user_list.approvers_dialog.error.no_leave_request_managers"));
                self._setAllUsersAutoApproved();
            } else alert(_messageResource2.default.getMessage('actiplans.user_list.some_of_selected_users_are_no_longer_approvers'));

            var targetRow = dialogInfo.targetRow;
            var approversSortingProcessor = self._createApproversSortingProcessor(allApprovers);
            var actualApprovers = approversSortingProcessor(selectedApproverIds);
            targetRow.data().userApprovers = actualApprovers;

            self._updateApprovedByCellContent(targetRow);

            var actualApproverIds = [];
            for (var i = 0; i < actualApprovers.length; i++) {
                actualApproverIds.push(actualApprovers[i].id);
            }
            self._approversDialog.update(allApprovers, isAutoApproved, actualApproverIds);
            return true;
        }
        if (errorThrown.exception == 'com.actimind.actiplans.administration.NoLeaveTimeManagerException') {
            alert(_messageResource2.default.getMessage("actiplans.user_list.approvers_dialog.error.no_leave_request_managers"));
            self._approversDialog.hideAfterSaving();
            self._setAllUsersAutoApproved();
            return true;
        }
        self._approversDialog.hideAfterSaving();
    });
};

UserListPage.prototype._sendAssignUsersRequest = function (dialogInfo, canManageAllUsers, selectedUserIds, usersToUpdate) {
    var self = this;
    this._callUserManagementService(dialogInfo.targetRow, 'UserManagementService.assignUsersToApprover', [dialogInfo.userId, canManageAllUsers, selectedUserIds, usersToUpdate], UserListPage.USER_SETTINGS_UPDATE_KEY_APPROVER_FOR, null, function (userManagementResult) {
        self._updateApprovedByCellContentForRows(usersToUpdate, userManagementResult.allApprovers, userManagementResult.approverIdsMap.map, userManagementResult.autoapprovalUsers.set);

        self._updateThereAreUsersWithoutApproversSetting(userManagementResult.thereAreUsersWithoutApprovers);

        self._usersForApproverDialog.hideAfterSaving();
        self._highlightRow(dialogInfo.targetRow);
    }, function (jqXHR, textStatus, errorThrown) {
        if (errorThrown.exception == 'com.actimind.actitime.user.NoSuchUsersException') {
            alert(_messageResource2.default.getMessage('userlist.js.error_all_selected_useds_deleted'));
            self._deleteUsers(selectedUserIds);
            self._usersForApproverDialog.refreshData(dialogInfo, true);
            return true;
        }
        self._usersForApproverDialog.hideAfterSaving();
    });
};

UserListPage.prototype._updateThereAreUsersWithoutApproversSetting = function (newThereAreUsersWithoutApprovers) {
    this._thereAreUsersWithoutApprovers = newThereAreUsersWithoutApprovers;
    if (this._thereAreUsersWithoutApprovers) this._pageContent.addClass("thereAreUsersWithoutApprovers");else this._pageContent.removeClass("thereAreUsersWithoutApprovers");
};

UserListPage.prototype._hideManageBalanceColumn = function () {
    this._manageBalanceColumnHidden = true;
    var table = (0, _jquery2.default)("#userListTable");
    table.find("col.accountTab-manageBalance-col").remove();
    table.find("th.accountTab-manageRolesCell").attr("colspan", 3);
    table.addClass("manageBalanceColumnHidden");
    this._spacer.find("td.accountTabCell").last().remove();
};

UserListPage.USER_SETTINGS_UPDATE_KEY_PTO_CONTROL_STATUS = 1;
UserListPage.USER_SETTINGS_UPDATE_KEY_ACCOUNT_STATUS = 2;
UserListPage.USER_SETTINGS_UPDATE_KEY_BALANCE_MANAGER_ROLE = 3;
UserListPage.USER_SETTINGS_UPDATE_KEY_LEAVE_TIME_MANAGER_ROLE = 4;
UserListPage.USER_SETTINGS_UPDATE_KEY_ACCOUNT_SETTINGS_MANAGER_ROLE = 5;
UserListPage.USER_SETTINGS_UPDATE_KEY_PTO_RULES = 6;
UserListPage.USER_SETTINGS_UPDATE_KEY_PTO_BALANCE = 7;
UserListPage.USER_SETTINGS_UPDATE_KEY_APPROVED_BY = 8;
UserListPage.USER_SETTINGS_UPDATE_KEY_APPROVER_FOR = 9;

UserListPage.prototype._onGroupSelectionChanged = function (selection) {
    var userListFilter = this._stateController.getProperty("userListFilter");
    userListFilter.userIds = selection.selectedUsers;
    userListFilter.groupIds = selection.selectedGroups;
    userListFilter.groupType = selection.groupType;
    this._stateController.setProperty(userListFilter);
    this._stateController.setProperty("pageNum", 1);
    this._updateUserList('spinnerPlaceholder', true);
};

UserListPage.prototype._isUGREnabled = function () {
    return this._viewerSettings.userGroupsEnabled;
};

UserListPage.prototype._isTZGEnabled = function () {
    return this._viewerSettings.timeZoneGroupsEnabled;
};

UserListPage.prototype._onUGRChanged = function (showAlert) {
    this._abortAllRequests();
    if (showAlert) {
        if (!this._isUGREnabled()) {
            alert(_messageResource2.default.getMessage("actiplans.user_list.js.error.user_groups_enabled"));
        } else {
            alert(_messageResource2.default.getMessage("actiplans.user_list.js.error.user_groups_disabled"));
        }
    }
    document.location.reload();
};

UserListPage.prototype._onTZGChanged = function (showAlert) {
    this._abortAllRequests();
    if (showAlert) {
        if (!this._isTZGEnabled()) {
            alert(_messageResource2.default.getMessage("actiplans.user_list.js.error.time_zone_groups_enabled"));
        } else {
            alert(_messageResource2.default.getMessage("actiplans.user_list.js.error.time_zone_groups_disabled"));
        }
    }
    document.location.reload();
};

UserListPage.prototype._validateIsChangeRightsManageBalanceAndAccountSettings = function (pageData) {
    var msgKey = "";

    var currentPTOEnabled = pageData.viewerSettings.ptoEnabled;
    var currentSDBEnabled = pageData.viewerSettings.sickBalanceEnabled;

    var ptoChanged = this._viewerSettings.ptoEnabled != currentPTOEnabled;
    var sickChanged = this._viewerSettings.sickBalanceEnabled != currentSDBEnabled;

    var alertMessageKey = null;

    if (ptoChanged && sickChanged) {
        if (currentPTOEnabled && currentSDBEnabled) {
            // both features on
            alertMessageKey = "userlist.js.pto_and_sick_enabled";
        } else if (!currentPTOEnabled && !currentSDBEnabled) {
            // both features off
            alertMessageKey = "userlist.js.pto_and_sick_disabled";
        } else {
            // show alert only for pto
            if (currentPTOEnabled) {
                alertMessageKey = "userlist.js.pto_enabled";
            } else {
                alertMessageKey = "userlist.js.pto_disabled";
            }
        }
    } else {
        if (ptoChanged) {
            if (currentPTOEnabled) {
                alertMessageKey = "userlist.js.pto_enabled";
            } else {
                alertMessageKey = "userlist.js.pto_disabled";
            }
        }
        if (sickChanged) {
            if (currentSDBEnabled) {
                alertMessageKey = "userlist.js.sick_balance_enabled";
            } else {
                alertMessageKey = "userlist.js.sick_balance_disabled";
            }
        }
    }
    // if there is message show alert and reload page
    if (alertMessageKey) {
        alert(_messageResource2.default.getMessage(alertMessageKey));
        document.location.reload();
        return true; // is changing
    }

    var newAllowedToManageLeaveBalanceSettings = pageData.viewerSettings.allowedToManageLeaveBalanceSettings;
    if (this._viewerSettings.allowedToManageLeaveBalanceSettings != newAllowedToManageLeaveBalanceSettings) {
        this._viewerSettings.allowedToManageLeaveBalanceSettings = newAllowedToManageLeaveBalanceSettings;

        if (pageData.ptoCalculationEnabled && pageData.sickBalanceCalculationEnabled) msgKey = newAllowedToManageLeaveBalanceSettings ? "userlist.js.error_have_right_to_view_pto_and_sick_tabs" : "userlist.js.error_no_right_to_view_pto_and_sick_tabs";else if (pageData.ptoCalculationEnabled) msgKey = newAllowedToManageLeaveBalanceSettings ? "userlist.js.error_have_right_to_view_pto_tab" : "userlist.js.error_no_right_to_view_pto_tab";else if (pageData.sickBalanceCalculationEnabled) msgKey = newAllowedToManageLeaveBalanceSettings ? "userlist.js.error_have_right_to_view_sick_tab" : "userlist.js.error_no_right_to_view_sick_tab";

        if (msgKey) alert(_messageResource2.default.getMessage(msgKey));
        if (newAllowedToManageLeaveBalanceSettings) document.location.reload();
        return true; // is changing
    }
    var newAllowedToManageAccountSettings = pageData.viewerSettings.allowedToManageAccountSettings;
    if (this._viewerSettings.allowedToManageAccountSettings != newAllowedToManageAccountSettings) {
        msgKey = newAllowedToManageAccountSettings ? "userlist.js.error_have_right_to_manage_account" : "userlist.js.error_no_right_to_view_account_tab_readonly";
        alert(_messageResource2.default.getMessage(msgKey));
        document.location.reload();
        return true;
    }
    return false;
};

UserListPage.prototype.setAddUserButtonStyleAccordingToLicense = function (license) {

    if (!license.licenseViolated) {
        if (this._bulkInvitationsButton) {
            this._bulkInvitationsButton.click(this._self(function () {
                this._addButtonStrategy.callback();
            }));
            (0, _jquery2.default)(this._bulkInvitationsButton).removeClass("buttonIsDisabled");
        }
        (0, _jquery2.default)(this._addNewUserButton).removeClass("buttonIsDisabled");
    } else {
        if (this._bulkInvitationsButton) {
            this._bulkInvitationsButton.off();
            (0, _jquery2.default)(this._bulkInvitationsButton).addClass("buttonIsDisabled");
        }
        (0, _jquery2.default)(this._addNewUserButton).addClass("buttonIsDisabled");
    }
};

UserListPage.prototype._updatePage = function (pageData, showAlertOnReload) {
    var visibleUsers = [];
    _jquery2.default.each(pageData.records, function () {
        visibleUsers.push(this.id);
    });

    this._visibleOnPageUserIds = visibleUsers;
    this._stateController.setProperty('pageNum', pageData.pageNum);
    this._stateController.setProperty('totalRecords', pageData.totalRecords);
    this._weekStartDay = pageData.weekStartDay;
    this._ptoHoursPerDay = pageData.ptoHoursPerDay;
    this._ptoFormatter = new PTOFormatter().init(this._ptoHoursPerDay);
    this._ptoBalanceFormatter = new PTOFormatter().init(this._ptoHoursPerDay, SystemSettings.roundPTOBalanceOnUserlist);
    this._sickBalanceFormatter = new SickFormatter().init(this._ptoHoursPerDay, SystemSettings.roundSickBalanceOnUserlist);

    if (this.ptoRulesManager) this.ptoRulesManager.reinitAccrualRulesControls(this._ptoHoursPerDay);

    if (this.sickRulesManager) this.sickRulesManager.reinitAccrualRulesControls(this._ptoHoursPerDay);

    if (this._isUGREnabled() != pageData.viewerSettings.userGroupsEnabled) {
        this._onUGRChanged(showAlertOnReload);
        return;
    }
    if (this._isTZGEnabled() != pageData.viewerSettings.timeZoneGroupsEnabled) {
        this._onTZGChanged(showAlertOnReload);
        return;
    }

    this._validateIsChangeRightsManageBalanceAndAccountSettings(pageData);

    this._viewerSettings = pageData.viewerSettings;
    this._ptoCalculationEnabled = pageData.ptoCalculationEnabled;
    this._sickBalanceCalculationEnabled = pageData.sickBalanceCalculationEnabled;
    this._thereAreUsersWithoutApprovers = pageData.thereAreUsersWithoutApprovers;

    this._setClassesForPage();
    this._setLastColumnClass();
    this._userWorkScheduleTooltip.hide();
    this._approversTooltip.hide();

    if (pageData.allUserGroups) {
        this._allUserGroups = pageData.allUserGroups;
        this._userGroupIdToGroupMap = makeMapForEntitiesArray(pageData.allUserGroups);
    }
    if (pageData.allTimeZoneGroups) {
        this._allTimeZoneGroups = pageData.allTimeZoneGroups;
        this._timeZoneGroupIdToGroupMap = makeMapForEntitiesArray(pageData.allTimeZoneGroups);
    }

    if (pageData.allUserGroups) {
        this._allUserGroups = pageData.allUserGroups;
        this._userGroupIdToGroupMap = makeMapForEntitiesArray(pageData.allUserGroups);
    }

    this._updateUserListRows(pageData.records, pageData.allApprovers, pageData.approverIdsMap);

    var license = pageData.licenseCounters;
    this._licenseCounterManager.setAllowedToView(this._viewerSettings.allowedToManageAccountSettings);
    this._licenseCounterManager.setLicenseCounter(license);
    this._licenseCounterManager.update();

    this.setAddUserButtonStyleAccordingToLicense(license);

    PageOverlayTipsManager.getInstance().refreshDynamicTips();
};

UserListPage.prototype._renderUserListControls = function (state, includeImmediatelyControls) {
    this._accountStatusFilterCheckbox.attr('checked', state.userListFilter.statusFilter == UserListPageConstants.USER_STATUS_FILTER_ALL);
    this._accountStatusFilterCheckbox.change();

    this._onlyManagersFilterCheckbox.attr('checked', state.userListFilter.rolesFilter == UserListPageConstants.USER_ROLES_FILTER_MANAGERS_ONLY);
    this._onlyManagersFilterCheckbox.change();

    this._pagerController.setPagerStateAndUpdateUI(state.totalRecords, state.pageNum, state.recordsPerPage);
    this._totalRecordsPlaceholder.text(state.totalRecords);

    if (includeImmediatelyControls) {
        this._userNameFilterInput.setInputValue(state.userNameFilterText);
    }

    this._userListHeader.find('[data-sortBy]').removeClass("ascending descending");
    this._userListHeader.find('[data-sortBy=' + state.sortBy + ']').addClass(state.isAscending ? "ascending" : "descending");
};

UserListPage.prototype._findElementsInDocument = function () {
    this._pageContent = (0, _jquery2.default)("#userListPageContent");
    this._userListHeader = (0, _jquery2.default)("#userListTable").find("> thead");
    this._userListBody = (0, _jquery2.default)("#userListTable").find(".actualContent");
    this._requestTemplate = (0, _jquery2.default)("tbody.templates .userRow");
    this._noUsersRowTemplate = (0, _jquery2.default)("tbody.templates .noUsersRow");
    this._selectAccountsTabButton = (0, _jquery2.default)(".accountsTabButton");
    this._selectPtoTabButton = (0, _jquery2.default)(".ptoTabButton");
    this._totalRecordsPlaceholder = (0, _jquery2.default)('#totalRecordsPlaceholder');
    this._accountStatusFilterCheckbox = (0, _jquery2.default)('#userList_accountEnabledFilter');
    this._onlyManagersFilterCheckbox = (0, _jquery2.default)('#userList_onlyManagersFilter');
    this._manageRolesInfoButton = (0, _jquery2.default)('.accountTab-manageRoles-manageInfoImg-span');
    this._bulkInvitationsButton = this._pageContent.find('.bulkInvitationsButton');
    this._addNewUserButton = this._pageContent.find('.newUserButtonContainer');
    this._userWorkScheduleTooltip = (0, _jquery2.default)('#userWorkScheduleTooltip');
    this._tablePlaceholder = this._userWorkScheduleTooltip.find("#userWorkScheduleTooltip_durationsTablePlaceholder");
    this._weekTextPlaceholder = this._userWorkScheduleTooltip.find("#userWorkScheduleTooltip_weekTextPlaceholder");
    this._scheduleHeader = this._userWorkScheduleTooltip.find("#userWorkScheduleTooltip_scheduleHeader");
    this._approversTooltip = new ApproversTooltip().init("approversTooltip");
    this._usersForApproverTooltip = (0, _jquery2.default)('#usersForApproverTooltip');
    this._spacer = (0, _jquery2.default)(".templates .apUserListSpacer");
    this._onlyUsersWithoutApproversCaption = (0, _jquery2.default)("#onlyUsersWithoutApproversCaption");
    this._cancelOnlyUsersWithoutApproversButton = (0, _jquery2.default)("#cancelOnlyUsersWithoutApproversButton");
    this._accountStatusSortDataHolder = (0, _jquery2.default)("#accountStatusSortDataHolder");
};

UserListPage.prototype._self = function (func) {
    var self = this;

    return function () {
        return func.apply(self, arguments);
    };
};

UserListPage.prototype._initUserRolesPopup = function () {
    var popupDiv = (0, _jquery2.default)("#userRolesPopupDiv");
    var infoButton = this._manageRolesInfoButton;

    var manageRolesInfoPopup = new DropdownDialog({
        wrapperClass: 'userRolesPopup',
        dialogDiv: popupDiv,
        hideButtons: true,
        isWithBeak: true,
        hideOnResize: true
    });

    this._manageRolesInfoButton.click(function () {
        manageRolesInfoPopup.showAt(this, { offset: "-60px 7px", collision: "none" });
    });
};

UserListPage.prototype._toggleTableClassForTabs = function (activeTabValue) {
    var isShowPTO = activeTabValue == UserListPageConstants.PTO_SETTINGS_TAB_NUM;
    var isShowSickDays = activeTabValue == UserListPageConstants.SICK_DAYS_SETTINGS_TAB_NUM;
    var isShowAccountSettings = activeTabValue == UserListPageConstants.ACCOUNT_SETTINGS_TAB_NUM;
    this._pageContent.toggleClass("selectPtoTab", isShowPTO);
    this._pageContent.toggleClass("selectSickDaysTab", isShowSickDays);
    this._pageContent.toggleClass("selectAccountsTab", isShowAccountSettings);
    this._setLastColumnClass();
};

UserListPage.prototype._loadActiveTabNum = function () {
    var tabNum = _jquery2.default.cookie("actiPLANS-userlist-tabs");
    if (!tabNum) tabNum = UserListPageConstants.ACCOUNT_SETTINGS_TAB_NUM;

    if (!this._ptoCalculationEnabled && tabNum == UserListPageConstants.PTO_SETTINGS_TAB_NUM) tabNum = UserListPageConstants.ACCOUNT_SETTINGS_TAB_NUM;else if (!this._sickBalanceCalculationEnabled && tabNum == UserListPageConstants.SICK_DAYS_SETTINGS_TAB_NUM) tabNum = UserListPageConstants.ACCOUNT_SETTINGS_TAB_NUM;

    return tabNum;
};

UserListPage.prototype._setClassesForPage = function () {
    var classes = [];
    classes.push(this._viewerSettings.allowedToManageAccountSettings ? "allowedToManageAccountSettings" : "");

    if (this._viewerSettings.allowedToManageLeaveBalanceSettings) {
        classes.push("allowedToManageBalanceSettings");
        if (this.tabs) this.tabs.show();else this._initTabs();
    } else {
        if (this.tabs) this.tabs.hide();
    }

    if (this._thereAreUsersWithoutApprovers) classes.push("thereAreUsersWithoutApprovers");

    if (!this._isUGREnabled()) classes.push("ugrDisabled");

    if (!this._isTZGEnabled()) classes.push("tzgDisabled");

    var filter = this._stateController.getProperty("userListFilter");

    if (filter.onlyUsersWithoutApprovers) {
        classes.push("onlyUsersWithoutApproversEnabled");
        this._accountStatusFilterCheckbox.attr('disabled', true);
        this._onlyManagersFilterCheckbox.attr('disabled', true);
    } else {
        classes.push("onlyUsersWithoutApproversDisabled");
        this._accountStatusFilterCheckbox.attr('disabled', false);
        this._onlyManagersFilterCheckbox.attr('disabled', false);
    }

    if (this.tabs && (this.tabs.getActiveTab() == UserListPageConstants.PTO_SETTINGS_TAB_NUM || this.tabs.getActiveTab() == UserListPageConstants.SICK_DAYS_SETTINGS_TAB_NUM) && !this._viewerSettings.allowedToManageLeaveBalanceSettings) {
        this.tabs.setActiveTab(UserListPageConstants.ACCOUNT_SETTINGS_TAB_NUM);
        this.tabs.updateUI();
    }

    classes.push(this.tabs && this.tabs.getActiveTab() == UserListPageConstants.PTO_SETTINGS_TAB_NUM ? "selectPtoTab" : this.tabs && this.tabs.getActiveTab() == UserListPageConstants.SICK_DAYS_SETTINGS_TAB_NUM ? "selectSickDaysTab" : "selectAccountsTab");

    this._pageContent.removeClass("allowedToManageAccountSettings allowedToManageBalanceSettings selectAccountsTab selectPtoTab selectSickDaysTab ugrDisabled onlyUsersWithoutApproversEnabled onlyUsersWithoutApproversDisabled thereAreUsersWithoutApprovers");
    this._pageContent.addClass(classes.join(" "));
};

UserListPage.prototype._setLastColumnClass = function () {

    this._userListHeader.find("th").removeClass("lastColumn");

    var firstRowLastColumn = this._userListHeader.find("tr:first-child th:visible").last();

    firstRowLastColumn.addClass("lastColumn");
};

UserListPage.prototype._updateUserListRows = function (userListRecordsArray, allApprovers, approverIdsMap) {
    this._userListBody.html("");

    var self = this;
    var even = false;

    approverIdsMap = approverIdsMap.map;
    var approversSortingProcessor = allApprovers ? this._createApproversSortingProcessor(allApprovers) : function () {};
    _jquery2.default.each(userListRecordsArray, function () {
        self._createRowAtLastPosition(this, approversSortingProcessor(approverIdsMap[this.id]), even);
        even = !even;
    });

    if (userListRecordsArray.length == 0) {
        this._createNoUsersRow();
    }
};
UserListPage.prototype._handleManageGroupsButtonClick = function () {
    if (this._isUGREnabled() && this._isTZGEnabled()) {
        this.manageGroupsDialog.showAt(this.manageGroupsButton.getEl(), {
            my: 'left top',
            at: 'left bottom'
        });
    } else if (this._isUGREnabled()) {
        this._handleDepartmentsButtonClick();
    } else if (this._isTZGEnabled()) {
        this._handleTimeZoneGroupsButtonClick();
    }
};

UserListPage.prototype._handleDepartmentsButtonClick = function () {
    var self = this;
    this._showManageDepartmentsPopup(function (departmentController) {
        self._manageDepartmentsPopupClosedAndSmthChanged(departmentController);
    });
};

UserListPage.prototype._handleTimeZoneGroupsButtonClick = function () {
    var self = this;
    self._showManageTimeZoneGroupsPopup(function (timeZoneGroupController) {
        // get actual time zone group off logged in user
        var newLoggedInUserTZGroup = _.find(timeZoneGroupController.storedData, function (tzGroupWithUsers) {
            var tzGroupUserIds = _.map(tzGroupWithUsers.users, function (user) {
                return user.id;
            });
            return _.contains(tzGroupUserIds, self._currentUserId);
        });
        // check new and prev tz group of logged in user
        if (self.previousLoggedInUserTZGroup.id != newLoggedInUserTZGroup.id || self.previousLoggedInUserTZGroup.timeZoneId != newLoggedInUserTZGroup.timeZoneId || self.previousLoggedInUserTZGroup.cityName != newLoggedInUserTZGroup.cityName) {
            // update user list if his time zone group will be changed
            alert(_messageResource2.default.getMessage('userlist.js.time_zone_was_changed'));
            document.location.reload();
            return;
        }
        self._manageTimeZoneGroupsPopupClosedAndSmthChanged(timeZoneGroupController);
    });
};

UserListPage.prototype._createApproversSortingProcessor = function (allApprovers) {
    return createApproversSortingProcessor(allApprovers);
};

UserListPage.prototype._createNoUsersRow = function () {
    var row = this._noUsersRowTemplate.clone();

    var userListFilter = this._stateController.getProperty("userListFilter");
    var enabledUsersFilter = userListFilter.statusFilter == UserListPageConstants.USER_STATUS_FILTER_ENABLED_ONLY;
    var groupsFilter = userListFilter.groupIds != null && userListFilter.groupIds != [];

    var noEnabledUsersMsgKey = groupsFilter ? userListFilter.groupType == GroupType.USER_GROUP ? 'userlist.js.users_table_no_enabled_users_found_in_selected_user_groups' : 'userlist.js.users_table_no_enabled_users_found_in_selected_time_zone_groups' : 'userlist.js.users_table_no_enabled_users_found';
    var noUsersMsgKey = groupsFilter ? userListFilter.groupType == GroupType.USER_GROUP ? 'userlist.js.users_table_no_users_found_in_selected_user_groups' : 'userlist.js.users_table_no_users_found_in_selected_time_zone_groups' : 'userlist.js.users_table_no_users_found';

    row.find(".noUsersTextPlaceholder").html(_messageResource2.default.getMessage(enabledUsersFilter ? noEnabledUsersMsgKey : noUsersMsgKey));

    row.appendTo(this._userListBody);
};

UserListPage.prototype._createRowAtFirstPosition = function (record, userApprovers, even) {
    var newRow = this._createRow(record, userApprovers, even);
    newRow.prependTo(this._userListBody);
    return newRow;
};

UserListPage.prototype._createRowAtLastPosition = function (record, userApprovers, even) {
    var newRow = this._createRow(record, userApprovers, even);
    newRow.appendTo(this._userListBody);
};

UserListPage.getTooltipOffsetByElement = function (jQueryEvent, tooltipEl) {
    return calculateTooltipOffsetByItParameters(tooltipEl.outerHeight(), tooltipEl.outerWidth(), jQueryEvent, UserListPage.BOTTOM_BAR_HEIGHT);
};

UserListPage.getTooltipOffset = function (jQueryEvent, tooltip) {
    return calculateTooltipOffset(tooltip, jQueryEvent, UserListPage.BOTTOM_BAR_HEIGHT);
};

UserListPage.prototype._createRow = function (record, userApprovers, even) {

    var self = this;
    var newRow = this._requestTemplate.clone();
    this.userIdRowMap[record.id] = newRow;
    newRow.data().record = record;
    newRow.data().userApprovers = userApprovers;

    var isCurrentUser = record.id === this._currentUserId;
    this._setNewRowData(newRow, even);

    var ptoCellClass = ".ptoTabCell";
    var sickCellClass = ".sickDaysTabCell";

    newRow.find(ptoCellClass + ".balance-td").click(function (e) {
        self._onBalanceClicked(e, BalanceType.PTO);
    });
    newRow.find(ptoCellClass + ".userBalanceEnabled-td").click(function (e) {
        self._onUserPtoControlClicked(e, BalanceType.PTO);
    });
    newRow.find(ptoCellClass + ".balanceHistoryShow-td").click(this._self(this._onShowPtoBalanceHistoryClicked));
    newRow.find(ptoCellClass + ".balanceHistoryShow-td").hover(function (e) {
        (0, _jquery2.default)(e.delegateTarget).addClass("hovered");
    }, function (e) {
        (0, _jquery2.default)(e.delegateTarget).removeClass("hovered");
    });
    newRow.find(ptoCellClass + ".accrueRule-td, " + ptoCellClass + ".resetRule-td, " + ptoCellClass + ".capRule-td").click(function (e) {
        self._onEditRulesClicked(e, BalanceType.PTO);
    });

    newRow.find(ptoCellClass + ".accrueRule-td, " + ptoCellClass + ".resetRule-td, " + ptoCellClass + ".capRule-td").hover(function (e) {
        self._showAccrualRulesTooltip(e, self.ptoRulesManager, "ptoData");
        self._addAccrualRulesHoveredState(e, BalanceType.PTO);
    }, function (e) {
        self.ptoRulesManager.hideAccrualRulesTooltip();
        self._removeAccrualRulesHoveredState(e);
    });
    newRow.find(ptoCellClass + ".accrueRule-td, " + ptoCellClass + ".resetRule-td, " + ptoCellClass + ".capRule-td").mousemove(function (jQueryEvent) {
        self.ptoRulesManager.moveAccrualRulesTooltip(jQueryEvent);
    });

    newRow.find(sickCellClass + ".balance-td").click(function (e) {
        self._onBalanceClicked(e, BalanceType.SICK);
    });
    newRow.find(sickCellClass + ".userBalanceEnabled-td").click(function (e) {
        self._onUserPtoControlClicked(e, BalanceType.SICK);
    });
    newRow.find(sickCellClass + ".balanceHistoryShow-td").click(this._self(this._onShowSickBalanceHistoryClicked));
    newRow.find(sickCellClass + ".balanceHistoryShow-td").hover(function (e) {
        (0, _jquery2.default)(e.delegateTarget).addClass("hovered");
    }, function (e) {
        (0, _jquery2.default)(e.delegateTarget).removeClass("hovered");
    });
    newRow.find(sickCellClass + ".accrueRule-td, " + sickCellClass + ".resetRule-td, " + sickCellClass + ".capRule-td").click(function (e) {
        self._onEditRulesClicked(e, BalanceType.SICK);
    });

    newRow.find(sickCellClass + ".accrueRule-td, " + sickCellClass + ".resetRule-td, " + sickCellClass + ".capRule-td").hover(function (e) {
        self._showAccrualRulesTooltip(e, self.sickRulesManager, "sickDaysData");
        self._addAccrualRulesHoveredState(e, BalanceType.SICK);
    }, function (e) {
        self.sickRulesManager.hideAccrualRulesTooltip();
        self._removeAccrualRulesHoveredState(e);
    });
    newRow.find(sickCellClass + ".accrueRule-td, " + sickCellClass + ".resetRule-td, " + sickCellClass + ".capRule-td").mousemove(function (jQueryEvent) {
        self.sickRulesManager.moveAccrualRulesTooltip(jQueryEvent);
    });

    newRow.find(".accountTab-week-td").hover(function (e) {
        self._showUserWorkScheduleTooltip(e, UserListPage.getTooltipOffsetByElement(e, self._userWorkScheduleTooltip));
    }, function () {
        self._userWorkScheduleTooltip.hide();
    });
    newRow.find(".accountTab-week-td").mousemove(function (e) {
        self._userWorkScheduleTooltip.offset(UserListPage.getTooltipOffsetByElement(e, self._userWorkScheduleTooltip));
    });

    newRow.find(".accountTab-approvedBy-td").hover(function (e) {
        self._showApproversTooltip(e, UserListPage.getTooltipOffset(e, self._approversTooltip));
    }, function () {
        self._approversTooltip.hide();
    });
    newRow.find(".accountTab-approvedBy-td").mousemove(function (e) {
        self._approversTooltip.move(UserListPage.getTooltipOffset(e, self._approversTooltip));
    });

    newRow.find(".accountTab-usersForApproverSelector-td").hover(function (e) {
        self._showUsersForApproverTooltip(e, UserListPage.getTooltipOffsetByElement(e, self._usersForApproverTooltip));
    }, function () {
        self._usersForApproverTooltip.hide();
    });
    newRow.find(".accountTab-usersForApproverSelector-td").mousemove(function (e) {
        self._usersForApproverTooltip.offset(UserListPage.getTooltipOffsetByElement(e, self._usersForApproverTooltip));
    });

    var approvedByCell = newRow.find(".accountTab-approvedBy-td");

    approvedByCell.click(function (jQueryEvent) {
        if (!self._viewerSettings.allowedToManageAccountSettings) return;

        self._abortRequestsBeforeUserSettingsUpdate(UserListPage.USER_SETTINGS_UPDATE_KEY_APPROVED_BY);

        self._approversTooltip.hide();

        //do not use "record" variable that came from function args it's saved in closure
        //and if it changed later we won't see the changes!
        var recordNotInClosure = newRow.data().record;
        newRow.addClass("selected");
        approvedByCell.addClass("dialogSelected");
        self._approversDialog.setOnCloseCallback(function () {
            newRow.removeClass("selected");
            approvedByCell.removeClass("dialogSelected");
        });
        self._approversDialog.showAt({
            userId: recordNotInClosure.id,
            element: approvedByCell[0],
            offset: "0px 0px",
            targetRow: newRow
        });
    });

    var approverForCell = newRow.find(".accountTab-usersForApproverSelector-td");
    approverForCell.click(function (jQueryEvent) {
        var recordNotInClosure = newRow.data().record;

        if (!self._verifyCanAssignUsersToApprover(recordNotInClosure)) return;

        self._abortRequestsBeforeUserSettingsUpdate(UserListPage.USER_SETTINGS_UPDATE_KEY_APPROVER_FOR);
        self._usersForApproverTooltip.hide();

        newRow.addClass("selected");
        approverForCell.addClass("dialogSelected");
        self._usersForApproverDialog.setOnCloseCallback(function () {
            newRow.removeClass("selected");
            approverForCell.removeClass("dialogSelected");
        });
        self._usersForApproverDialog.showAt({
            userId: recordNotInClosure.id,
            element: approverForCell[0],
            offset: "0px 0px",
            targetRow: newRow,
            minimizedMode: recordNotInClosure.canManageAllUsers
        });
    });

    var setAccountStateButton = newRow.find(".accountTab-accountState-td");
    var setAccountManagerButton = newRow.find(".accountTab-manageAccounts-td");
    var setLeaveBalanceManagerButton = newRow.find(".accountTab-manageBalance-td");
    if (this._manageBalanceColumnHidden) setLeaveBalanceManagerButton.hide();
    var setRequestsManagerButton = newRow.find(".accountTab-manageRequests-td");
    var userNameText = newRow.find(".accountTab-userNameText-span");

    this._createWarningsTooltip(newRow, record, true);

    if (record.id == this._currentUserId) newRow.addClass("currentUserRow");else newRow.removeClass("currentUserRow");

    if (this._viewerSettings.allowedToManageAccountSettings && !record.locked) {
        userNameText.click(this._self(this._onEditUserClicked));

        if (record.id == this._currentUserId) {
            setAccountStateButton.attr("title", _messageResource2.default.getMessage('userlist.cannot_disable_own_access'));
            setAccountManagerButton.attr("title", _messageResource2.default.getMessage('user.edit.cannot_revoke_manage_users'));
        } else {
            setAccountStateButton.click(this._self(this._onAccountStateClicked));
            setAccountManagerButton.click(this._self(this._onSetAccountManagerButtonClicked));

            setAccountStateButton.addClass("activeButton");
            setAccountManagerButton.addClass("activeButton");
        }
        if (!this._manageBalanceColumnHidden) {
            setLeaveBalanceManagerButton.click(this._self(this._onSetLeaveBalanceManagerButtonClicked));
            setLeaveBalanceManagerButton.addClass("activeButton");
        }
        setRequestsManagerButton.click(this._self(this._onSetRequestsManagerButtonClicked));
        setRequestsManagerButton.addClass("activeButton");
    } else if (record.locked) {
        userNameText.attr("title", _messageResource2.default.getMessage("user.edit.js.user_is_locked"));
        setAccountStateButton.attr("title", _messageResource2.default.getMessage("actiplans.user_list.edit_status.user_is_locked"));
        setAccountManagerButton.attr("title", _messageResource2.default.getMessage("actiplans.user_list.edit_rights.user_is_locked"));
        if (!this._manageBalanceColumnHidden) setLeaveBalanceManagerButton.attr("title", _messageResource2.default.getMessage("actiplans.user_list.edit_rights.user_is_locked"));
        setRequestsManagerButton.attr("title", _messageResource2.default.getMessage("actiplans.user_list.edit_rights.user_is_locked"));
    }

    return newRow;
};

UserListPage.prototype._deleteUser = function (userId) {
    UserListPage.removeRow(this.userIdRowMap[userId]);
};
UserListPage.prototype._deleteUsers = function (userIdsArray) {
    for (var i = 0, usersLength = userIdsArray.length; i < usersLength; i++) {
        try {
            this._deleteUser(userIdsArray[i]);
        } catch (e) {}
    } // user with this id is not on this page, move on
};

UserListPage.prototype._setNewRowData = function (row, even) {
    var userInfo = row.data().record;
    var userNameTokensHighlighter = this._getUserNameTokensHighlighter();

    this._validateNewRowData(userInfo);

    this._fillInAccountSettingsData(row, userNameTokensHighlighter);
    this._fillInPtoSettingsData(row);
    this._fillInSickDaysSettingsData(row);

    this._createWarningsTooltip(row, userInfo, false);

    row.addClass(this._makeClassesForCreatedRow(userInfo, even));
};

UserListPage.prototype._validateNewRowData = function (userInfo) {
    var isReleaseDateBeforeHireDate = (0, _atUtils.compareNullableStrDates)(userInfo.hireDate, userInfo.releaseDate) > 0;
    if (isReleaseDateBeforeHireDate) (userInfo.warnings = userInfo.warnings || []).push(UserListPageConstants.WARNING_RELEASE_DATE_IS_BEFORE_HIRE_DATE);
};

UserListPage.prototype._createWarningsTooltip = function (row, userInfo, isCreatingUser) {
    var infoJQEl = row.find(".infoSpan").hide();
    var warningJQEl = row.find(".warningsInRow").hide();
    var errorJQEl = row.find(".errorSpan").hide();
    var warnings = userInfo.warnings;
    if (warnings && warnings.length > 0) {
        var noteMsgs = this._createWarningMsgs(userInfo, isCreatingUser);
        var infoMsgs = noteMsgs.infoMsgs;
        var warningMsgs = noteMsgs.warningMsgs;
        var errorMsgs = noteMsgs.errorMsgs;

        if (infoMsgs && infoMsgs.length > 0) {

            this.warningsController.setInfoHoverEvents(infoJQEl, infoMsgs);
            infoJQEl.show();
        }

        if (warningMsgs && warningMsgs.length > 0) {
            var warningSection = row.find(".warningsInRow");
            this.warningsController.setWarnings(warningSection, warningMsgs);
            warningJQEl.show();
        }

        if (errorMsgs && errorMsgs.length > 0) {
            this.warningsController.setErrorHoverEvents(errorJQEl, errorMsgs);
            errorJQEl.show();
        }
    }
};

UserListPage.prototype._updateManageRequestsRoleAndUsersForApproverCellContent = function (row) {
    var record = row.data().record;

    var manageRequestsButton = row.find(".accountTab-manageRequests-td");
    record.roles.allowedToManageRequests ? manageRequestsButton.addClass("canManage") : manageRequestsButton.removeClass("canManage");

    this._updateUsersForApproverCellContent(row);

    var assignUsersToManager = row.find(".accountTab-usersForApproverSelector-td");
    this._verifyCanAssignUsersToApprover(record) ? assignUsersToManager.addClass("activeButton") : assignUsersToManager.removeClass("activeButton");
};

UserListPage.prototype._updateUsersForApproverCellContent = function (row) {
    var record = row.data().record;
    var numberOfAssignedUsers = record.numberOfAssignedUsers;
    var text;

    if (!record.roles.allowedToManageRequests) text = "--";else if (record.canManageAllUsers) text = _messageResource2.default.getMessage("user_list.manager.approves.all_users");else if (!numberOfAssignedUsers || numberOfAssignedUsers == 0) text = _messageResource2.default.getMessage("user_list.manager.approves.no_users");else if (numberOfAssignedUsers == 1) text = _messageResource2.default.getMessage("user_list.manager.approves.one_user");else text = _messageResource2.default.getMessage("user_list.manager.approves.n_users", [numberOfAssignedUsers]);

    row.find(".accountTab-usersForApproverSelector-td").html(text);
};

UserListPage.prototype._updateUsersForApproverDataAndCell = function (row, newCanManageAllUsers, newNumberOfAssignedUsers) {
    var record = row.data().record;
    record.canManageAllUsers = newCanManageAllUsers;
    record.numberOfAssignedUsers = newNumberOfAssignedUsers;

    this._updateUsersForApproverCellContent(row);
};

UserListPage.prototype._setApprovers = function (targetRowData, allApprovers, selectedApproverIds) {
    var approversSortingProcessor = this._createApproversSortingProcessor(allApprovers);
    targetRowData.userApprovers = approversSortingProcessor(selectedApproverIds);
};

UserListPage.prototype._updateApprovedByCellContentForRows = function (usersToUpdate, allApprovers, approverIdsMap, autoapprovalUsers) {
    var self = this;
    var usersToUpdateSet = (0, _atUtils.arrayToSet)(usersToUpdate);
    _jquery2.default.each(this._userListBody.find(".userRow"), function (index, row) {
        var data = (0, _jquery2.default)(row).data();
        var record = data.record;
        if (!!usersToUpdateSet[record.id]) {
            record.requiresApproval = !autoapprovalUsers[record.id];
            self._setApprovers(data, allApprovers, approverIdsMap[record.id]);
            self._updateApprovedByCellContent((0, _jquery2.default)(row));
        }
    });
};

UserListPage.prototype._updateApprovedByCellContent = function (row) {
    var requiresApproval = row.data().record.requiresApproval;
    var userApprovers = row.data().userApprovers;
    var cellContent;
    var userIsLTM = row.data().record.roles.allowedToManageRequests;

    row.toggleClass("userIsLTM", userIsLTM);

    row.removeClass("automaticallyApprovedUser");
    row.removeClass("userIsWithoutApprovers");

    if (requiresApproval) {
        if (userApprovers == null || userApprovers.length == 0) {
            row.addClass("userIsWithoutApprovers");
            cellContent = _messageResource2.default.getMessage("actiplans.user_list.not_selected");
        } else cellContent = formatAssignApproversCellText(userApprovers);
    } else {
        row.addClass("automaticallyApprovedUser");
        cellContent = _messageResource2.default.getMessage("actiplans.user_list.automatically_approved");
    }
    row.find(".accountTab-approvedByText-span").html(cellContent);
};

UserListPage.prototype._fillInPtoSettingsData = function (newRow) {
    this._fillInBalanceSettingsData(newRow, newRow.data().record.ptoData, BalanceType.PTO);
};

UserListPage.prototype._fillInSickDaysSettingsData = function (newRow) {
    this._fillInBalanceSettingsData(newRow, newRow.data().record.sickDaysData, BalanceType.SICK);
};

UserListPage.prototype._fillInBalanceSettingsData = function (newRow, data, balanceType) {
    var balanceData = data;
    var balanceTypeCellClass;
    var balanceFormatter;
    var roundValue = false;
    if (balanceType == BalanceType.SICK) {
        balanceTypeCellClass = ".sickDaysTabCell";
        balanceFormatter = this._sickBalanceFormatter;
        roundValue = SystemSettings.roundSickBalanceOnUserlist;
    }
    if (balanceType == BalanceType.PTO) {
        balanceTypeCellClass = ".ptoTabCell";
        balanceFormatter = this._ptoBalanceFormatter;
        roundValue = SystemSettings.roundPTOBalanceOnUserlist;
    }
    var balanceSwitcher = "<span class='switcher'></span>";
    var accrualRuleText;
    var resetRuleText;
    var capText;
    var currentBalanceText;
    var currentBalanceRevertedText;
    var plannedBalanceApproved;
    var plannedBalanceWaitingForApproval;

    if (balanceData) {

        if (balanceData.defaultRules) accrualRuleText = balanceType == BalanceType.PTO ? _messageResource2.default.getMessage("pto_rules_editor.default_pto_rules") : _messageResource2.default.getMessage("sick_rules_editor.default_sick_rules");else {
            accrualRuleText = balanceData.accrualRule ? balanceFormatter.format(balanceData.accrualRule.value) + " " + CalendarFrequencyType.descriptionFor[balanceData.accrualRule.frequency.type] : "--";
            resetRuleText = balanceData.resetRule ? balanceFormatter.format(balanceData.resetRule.value) + " " + (balanceData.resetRule.frequency.type == CalendarFrequencyType.ON_HIRE_DATE ? CalendarFrequencyType.descriptionFor[balanceData.resetRule.frequency.type] : "") + " " + CalendarFrequencyType.parametersFormatterFor[balanceData.resetRule.frequency.type](balanceData.resetRule.frequency.params) : "--";
            capText = balanceData.balanceCap != null ? balanceFormatter.format(balanceData.balanceCap) : "--";
        }
        if (!balanceData.notStarted) {
            currentBalanceText = balanceFormatter.format(balanceData.balance);
            currentBalanceRevertedText = "(" + balanceFormatter.format(balanceData.balance, true) + ")";
        } else {
            currentBalanceText = "";
            currentBalanceRevertedText = _messageResource2.default.getMessage("common.not_available_lower");
        }
        plannedBalanceApproved = this._ptoFormatter.format(balanceData.plannedBalanceApproved) + " (" + this._ptoFormatter.format(balanceData.plannedBalanceApproved, true) + ")";
        plannedBalanceWaitingForApproval = this._ptoFormatter.format(balanceData.plannedBalanceWaitingForApproval) + " (" + this._ptoFormatter.format(balanceData.plannedBalanceWaitingForApproval, true) + ")";
    } else {
        accrualRuleText = "";
        resetRuleText = "";
        capText = "";
        currentBalanceText = "";
        currentBalanceRevertedText = "--";
        plannedBalanceApproved = "--";
        plannedBalanceWaitingForApproval = "--";
        // TODO: special CSS class for row to disable PTO hover effects
    }

    newRow.find(".userBalanceEnabled-td" + balanceTypeCellClass).html(balanceSwitcher);
    newRow.find(".accrueRule-td" + balanceTypeCellClass).html(accrualRuleText);
    newRow.find(".resetRule-td" + balanceTypeCellClass).html(resetRuleText);
    newRow.find(".capRule-td" + balanceTypeCellClass).html(capText);
    newRow.find(balanceTypeCellClass + " .balanceText-span").html(currentBalanceText);
    newRow.find(balanceTypeCellClass + " .balanceRevertedText-span").html(currentBalanceRevertedText);
    newRow.find(".plannedBalanceApproved-td" + balanceTypeCellClass).html(plannedBalanceApproved);
    newRow.find(".plannedBalanceWaitingForApproval-td" + balanceTypeCellClass).html(plannedBalanceWaitingForApproval);

    if (balanceData) {
        var isNegativePTO = roundValue ? balanceData.balance <= -0.0625 : balanceData.balance <= -0.00125; //0.07 days is 1h (if round to whole number) 0.00125 days is 0.01h - otherwise
        newRow.find(balanceTypeCellClass + " .balanceText-span").toggleClass("negative", isNegativePTO);
        newRow.find(balanceTypeCellClass + " .balanceRevertedText-span").toggleClass("negative", isNegativePTO);
        newRow.find(".balanceHistoryShow-td" + balanceTypeCellClass).attr("title", balanceType == BalanceType.PTO ? _messageResource2.default.getMessage("common.pto_history.show_pto_history.tooltip.text") : _messageResource2.default.getMessage("common.sick_history.show_sick_history.tooltip.text"));
        newRow.find(balanceTypeCellClass + ".balanceHistoryShow-td img").show();
    } else {
        newRow.find(".balanceHistoryShow-td" + balanceTypeCellClass).attr("title", "");
        newRow.find(balanceTypeCellClass + ".balanceHistoryShow-td img").hide();
    }

    if (balanceData && balanceData.notStarted) newRow.find(".balance-td" + balanceTypeCellClass).attr("title", balanceType == BalanceType.PTO ? _messageResource2.default.getMessage("userlist.js.table.ptoCell.not_started") : _messageResource2.default.getMessage("userlist.js.table.sickCell.not_started"));else newRow.find(".balance-td" + balanceTypeCellClass).removeAttr("title");

    if (balanceData && balanceData.defaultRules) {
        newRow.find(".accrueRule-td" + balanceTypeCellClass).attr("colspan", 3);
        newRow.find(balanceTypeCellClass + ".resetRule-td, " + balanceTypeCellClass + ".capRule-td").hide();
    } else {
        newRow.find(".accrueRule-td" + balanceTypeCellClass).removeAttr("colspan");
        newRow.find(balanceTypeCellClass + ".resetRule-td, " + balanceTypeCellClass + ".capRule-td").removeAttr("style");
    }
};

UserListPage.prototype._fillInAccountSettingsData = function (newRow, userNameTokensHighlighter) {
    var record = newRow.data().record;
    var userText = UserNameFormat.formatLFM(record.firstName, record.lastName, record.middleInitial);
    var weekText = this._makeWeekText(record);

    var roles = record.roles;

    var manageAccountsButton = newRow.find(".accountTab-manageAccounts-td");

    if (!this._manageBalanceColumnHidden) {
        var manageBalanceButton = newRow.find(".accountTab-manageBalance-td");
        roles.allowedToManageLeaveBalanceSettings ? manageBalanceButton.addClass("canManage") : manageBalanceButton.removeClass("canManage");
    }
    roles.allowedToManageAccountSettings ? manageAccountsButton.addClass("canManage") : manageAccountsButton.removeClass("canManage");
    this._updateManageRequestsRoleAndUsersForApproverCellContent(newRow);

    newRow.find(".accountTab-userNameText-span").html(userNameTokensHighlighter.highlightTokens(userText));
    if (this._isUGREnabled()) newRow.find(".accountTab-userGroupText-div").html(escapeHtmlSymbols(this._getGroupNameForRecord(record)));
    if (this._isTZGEnabled()) newRow.find(".accountTab-timeZoneGroupText-div").html(escapeHtmlSymbols(this._getTimeZoneGroupNameForRecord(record)));
    newRow.find(".accountTab-weekText-span").html(weekText);
    newRow.find(".accountTab-accountStateText-span").html(this._makeAccountText(record));
    this._updateApprovedByCellContent(newRow);
};

UserListPage.prototype._getGroupNameForRecord = function (record) {
    var groupName;

    if (this._userGroupIdToGroupMap[record.userGroupId]) groupName = this._userGroupIdToGroupMap[record.userGroupId].name;else groupName = null;

    return groupName ? groupName : _messageResource2.default.getMessage("actiplans.user_list.js.not_assigned");
};

UserListPage.prototype._getTimeZoneGroupNameForRecord = function (record) {
    var timeZoneGroupName;

    if (this._timeZoneGroupIdToGroupMap[record.timeZoneGroupId]) timeZoneGroupName = this._timeZoneGroupIdToGroupMap[record.timeZoneGroupId].name;else timeZoneGroupName = null;

    return timeZoneGroupName ? timeZoneGroupName : " ";
};

UserListPage.prototype._makeWeekText = function (record) {

    if (record.defaultWorkSchedule) {
        return "<span class='defaultText'>" + _messageResource2.default.getMessage("actiplans.user_list.js.default") + " </span> " + "<span class='week duration'>(" + UserTime.formatTime(record.workingWeekTotal) + ")</span>";
    } else {
        return "<span class='week duration'> " + UserTime.formatTime(record.workingWeekTotal) + "</span>";
    }
};

UserListPage.prototype._makeAccountText = function (record) {
    return record.enabled ? _messageResource2.default.getMessage("actiplans.user_list.js.enabled") : _messageResource2.default.getMessage("actiplans.user_list.js.disabled");
};

UserListPage.prototype._makeClassesForCreatedRow = function (record, even) {
    var classes = [];

    classes = classes.concat(record.enabled ? "enabledUser" : "disabledUser");
    if (record.enabledInOtherProduct != null) {
        classes = classes.concat("linkedNotNull");
        if (record.enabledInOtherProduct == true) classes = classes.concat("linkedWithActitime");
    }
    classes = classes.concat(record.locked ? "locked" : "");
    classes = classes.concat(even ? "even" : "odd");
    classes = classes.concat(record.ptoData && !record.ptoData.notStarted ? "ptoON" : "");
    classes = classes.concat(record.sickDaysData && !record.sickDaysData.notStarted ? "sickON" : "");
    classes = classes.concat(record.ptoData ? "ptoHistoryOn" : "");
    classes = classes.concat(record.sickDaysData ? "sickHistoryOn" : "");
    classes = classes.concat(record.defaultWorkSchedule ? "userWithDefaultWorkSchedule" : "userWithCustomSchedule");
    classes = classes.concat(record.ptoData && record.ptoData.defaultRules ? "userWithDefaultPtoRules" : "");
    classes = classes.concat(record.sickDaysData && record.sickDaysData.defaultRules ? "userWithDefaultSickRules" : "");
    classes = classes.concat(record.roles.allowedToManageRequests && !record.canManageAllUsers && record.numberOfAssignedUsers == 0 ? "approverWithoutAssignedUsers" : "");

    return classes.join(" ");
};

UserListPage.prototype._updateRow = function (row) {
    var even = row.hasClass("even");

    row.removeClass("enabledUser disabledUser locked ptoON sickON ptoHistoryOn sickHistoryOn userWithDefaultWorkSchedule userWithCustomSchedule userWithDefaultPtoRules userWithDefaultSickRules linkedNotNull linkedWithActitime approverWithoutAssignedUsers");
    this._setNewRowData(row, even);
};

UserListPage.prototype._updateRowAndTips = function (row) {
    this._updateRow(row);
    PageOverlayTipsManager.getInstance().refreshDynamicTips();
};

UserListPage.prototype._updateGroupInAllRows = function () {
    var self = this;
    _jquery2.default.each(this._userListBody.find(".userRow"), function (index, row) {
        var groupNameText = self._getGroupNameForRecord((0, _jquery2.default)(row).data().record);
        groupNameText = groupNameText ? groupNameText : _messageResource2.default.getMessage('common.users_without_group');
        (0, _jquery2.default)(row).find(".accountTab-userGroupText-div").html(escapeHtmlSymbols(groupNameText));
    });
};

UserListPage.prototype._successHandler = function (userManagementResult) {
    this._licenseCounterManager.setLicenseCounter(userManagementResult.licenseCounters);
    this._licenseCounterManager.update();

    if (!this._updateGroups(userManagementResult.userGroups, userManagementResult.timeZoneGroups)) {
        return false;
    }
    if (this._validateIsChangeRightsManageBalanceAndAccountSettings(userManagementResult)) {
        return false;
    }

    this.setAddUserButtonStyleAccordingToLicense(userManagementResult.licenseCounters);
    this._setClassesForPage();

    return true;
};

UserListPage.prototype._callUserManagementService = function (row, service, params, userSettingKey, spinnerContainerId, customSuccessHandler, customErrorHandler) {
    this._abortRequestsBeforeUserSettingsUpdate(userSettingKey);

    this._spinnerController.spin(spinnerContainerId);
    var self = this;
    var successHandler = customSuccessHandler ? this._self(customSuccessHandler) : null;
    var errorHandler = customErrorHandler ? this._self(customErrorHandler) : null;
    var resultHandler = new UserManagementResultHandler(row, this._self(this._updateRowAndTips), function (userManagementResult) {
        self._spinnerController.stop();
        if (!self._successHandler(userManagementResult)) return;
        if (successHandler) successHandler(userManagementResult);
    }, function (jqXHR, textStatus, errorThrown) {
        self._spinnerController.stop();
        if (errorHandler) return errorHandler(jqXHR, textStatus, errorThrown);else return false;
    });

    this._userSettingsUpdateRequestObjects[userSettingKey] = (0, _jquery_rpc2.default)(service, params, resultHandler.successHandler, resultHandler.errorHandler);
};

UserListPage.prototype._onUserPtoControlClicked = function (jQueryEvent, balanceType) {
    var cell = (0, _jquery2.default)(jQueryEvent.delegateTarget);
    var row = cell.parents('tr');
    var userInfo = row.data().record;
    var balanceData = balanceType == BalanceType.PTO ? userInfo.ptoData : userInfo.sickDaysData;

    this._callUserManagementService(row, 'UserManagementService.setBalanceControlStatus', [userInfo.id, balanceType, balanceData === null], UserListPage.USER_SETTINGS_UPDATE_KEY_PTO_CONTROL_STATUS, "spinnerPlaceholder");
};

UserListPage.prototype._onAccountStateClicked = function (jQueryEvent) {
    var cell = (0, _jquery2.default)(jQueryEvent.delegateTarget);
    var row = cell.parents('tr');
    var userInfo = row.data().record;
    this._sendSetAccountStateRequest(row, userInfo, false, false, false);
};

UserListPage.prototype._sendSetAccountStateRequest = function (row, userInfo, forceChanges, forceLastLicenseManager, setAllUsersAutoApprovedOnSuccess) {
    var self = this;
    this._callUserManagementService(row, 'UserManagementService.setAccountStatus', [userInfo.id, !userInfo.enabled, forceChanges, forceLastLicenseManager], UserListPage.USER_SETTINGS_UPDATE_KEY_ACCOUNT_STATUS, "spinnerPlaceholder", setAllUsersAutoApprovedOnSuccess ? function () {
        self._setAllUsersAutoApproved();
    } : null, function (jqXHR, textStatus, errorThrown) {
        var _this2 = this;

        if (errorThrown.exception == 'com.actimind.common.administration.UserIsLastLeaveTimeManagerException') {
            if (confirm(_messageResource2.default.getMessage(EnabledFeatures.APWSD ? "actiplans.user_list.js.last_ltm_confirmation.disable.wsd_feature_on" : "actiplans.user_list.js.last_ltm_confirmation.disable"))) self._sendSetAccountStateRequest(row, userInfo, true, forceLastLicenseManager, true);
            return true;
        }
        if (errorThrown.exception == 'com.actimind.common.administration.UserIsLastLicensesManagerException') {
            this.disableApLastManagerInfo = new _LastManagerInfo2.default();
            this.disableApAlert = new _ConfirmationDialog2.default({
                onShow: function onShow() {
                    return _this2.disableApLastManagerInfo.setState({ userName: userInfo.firstName + " " + userInfo.lastName });
                },
                onHide: function onHide() {
                    return _this2.disableApAlert.getEl().remove();
                },
                onConfirm: function onConfirm() {
                    return self._sendSetAccountStateRequest(row, userInfo, forceChanges, true, setAllUsersAutoApprovedOnSuccess);
                },
                contentComponent: this.disableApLastManagerInfo
            }).init((0, _jquery2.default)('body'));
            this.disableApAlert.show();
            return true;
        }
        return false;
    });
};

UserListPage.prototype._onSetAccountManagerButtonClicked = function (jQueryEvent) {
    var cell = (0, _jquery2.default)(jQueryEvent.delegateTarget);
    var row = cell.parents('tr');
    var userInfo = row.data().record;

    this._callUserManagementService(row, 'UserManagementService.setUserRole', [userInfo.id, window.__GENERATED_CONSTANTS__.AccessRight.ACCOUNT_SETTINGS_MANAGER, !userInfo.roles.allowedToManageAccountSettings, false], UserListPage.USER_SETTINGS_UPDATE_KEY_ACCOUNT_SETTINGS_MANAGER_ROLE, "spinnerPlaceholder");
};

UserListPage.prototype._onSetLeaveBalanceManagerButtonClicked = function (jQueryEvent) {
    var cell = (0, _jquery2.default)(jQueryEvent.delegateTarget);
    var row = cell.parents('tr');
    var userInfo = row.data().record;

    var self = this;
    var updateTabs = userInfo.id == this._currentUserId ? function () {
        self._updateUserList("spinnerPlaceholder");
    } : null;

    this._callUserManagementService(row, 'UserManagementService.setUserRole', [userInfo.id, window.__GENERATED_CONSTANTS__.AccessRight.LEAVE_BALANCE_MANAGER, !userInfo.roles.allowedToManageLeaveBalanceSettings, false], UserListPage.USER_SETTINGS_UPDATE_KEY_BALANCE_MANAGER_ROLE, "spinnerPlaceholder", updateTabs);
};

UserListPage.prototype._onSetRequestsManagerButtonClicked = function (jQueryEvent) {
    var cell = (0, _jquery2.default)(jQueryEvent.delegateTarget);
    var row = cell.parents('tr');
    var userInfo = row.data().record;

    this._sendSetRequestsManagerRoleRequest(row, userInfo.id, !userInfo.roles.allowedToManageRequests, false, false);
};

UserListPage.prototype._sendSetRequestsManagerRoleRequest = function (row, id, allowedToManageRequests, forceChanges, setAllUsersAutoApprovedOnSuccess) {
    var self = this;
    this._callUserManagementService(row, 'UserManagementService.setUserRole', [id, window.__GENERATED_CONSTANTS__.AccessRight.LEAVE_TIME_MANAGER, allowedToManageRequests, forceChanges], UserListPage.USER_SETTINGS_UPDATE_KEY_LEAVE_TIME_MANAGER_ROLE, "spinnerPlaceholder", setAllUsersAutoApprovedOnSuccess ? function () {
        self._setAllUsersAutoApproved();
    } : null, forceChanges ? null : function (jqXHR, textStatus, errorThrown) {
        if (errorThrown.exception == 'com.actimind.actiplans.administration.WaitingForApprovalRequestsExistException') {
            var record = row.data().record;
            var name = UserNameFormat.formatFML(record.firstName, record.lastName, record.middleInitial);
            if (confirm(_messageResource2.default.getMessage("actiplans.user_list.js.manage_requests_confirmation", [name]))) self._sendSetRequestsManagerRoleRequest(row, id, allowedToManageRequests, true, false);
            return true;
        }
        if (errorThrown.exception == 'com.actimind.common.administration.UserIsLastLeaveTimeManagerException') {
            if (confirm(_messageResource2.default.getMessage(EnabledFeatures.APWSD ? "actiplans.user_list.js.last_ltm_confirmation.revoke_right.wsd_feature_on" : "actiplans.user_list.js.last_ltm_confirmation.revoke_right"))) self._sendSetRequestsManagerRoleRequest(row, id, false, true, true);
            return true;
        }
        return false;
    });
};

UserListPage.prototype._abortGetEditUserDataRequest = function () {
    if (this._getEditUserDataRequestObject) {
        this._getEditUserDataRequestObject.abort();
    }
};

UserListPage.prototype._onEditUserClicked = function (jQueryEvent) {

    this._abortAllRequests();
    var targetRow = (0, _jquery2.default)(jQueryEvent.delegateTarget).parents(".userRow");
    var targetRowData = targetRow.data();
    var userId = targetRowData.record.id;

    this._showLoadingPopup();
    var self = this;
    this._getEditUserDataRequestObject = (0, _jquery_rpc2.default)("UserManagementService.getEditUserData", [userId], function (editUserData) {
        if (EnabledFeatures.APWSD) {
            Promise.all([_ClassicBridge2.default.getUsersByClassicIds([userId]), _ClassicBridge2.default.getWorkStatusesForUserProfile()]).then(function (_ref) {
                var _ref2 = _slicedToArray(_ref, 2),
                    nextUserData = _ref2[0],
                    workStatuses = _ref2[1];

                editUserData.userManagementData.userNextId = nextUserData.items[0].id;
                editUserData.userManagementData.workStatuses = workStatuses.items;

                _ClassicBridge2.default.getDefaultWorkStatusPlanningByUserId(editUserData.userManagementData.userNextId).then(function (defaultWorkStatusPlanning) {
                    editUserData.userManagementData.defaultWorkStatusPlanning = defaultWorkStatusPlanning.items;
                    editUserData.userManagementData.defaultWorkStatusPlanningActions = defaultWorkStatusPlanning.actions;
                    self._showEditUserPopup(editUserData, targetRow);
                });
            });
        } else {
            self._showEditUserPopup(editUserData, targetRow);
        }
    }, function (jqXHR, textStatus, errorThrown) {
        self._hideLoadingPopup();

        if (errorThrown.exception == 'com.actimind.actitime.administration.NoSuchUserException') {
            alert(_messageResource2.default.getMessage('actiplans.user_list.error_user_was_deleted'));
            UserListPage.removeRow(targetRow);
            return true;
        }
        if (errorThrown.exception == 'com.actimind.actitime.services.NoRightsToManageAccountSettings') {
            alert(_messageResource2.default.getMessage('actiplans.user_list.noRightsForUserAccount'));
            document.location.reload();
            return true;
        }
        return false;
    });
};

UserListPage.prototype._showLoadingPopup = function () {
    this._loadingPopup = new LoadingPopup().init("userDataLoadingPopup");
    this._loadingPopup.show();
};

UserListPage.prototype._hideLoadingPopup = function () {
    this._loadingPopup.hide();
};

UserListPage.prototype._onUsersImported = function (importedUsersData) {
    var userIds = _.map(importedUsersData, function (data) {
        return data.id;
    });
    var warningsPerUserId = {};
    for (var i = 0; i < importedUsersData.length; i++) {
        if (importedUsersData[i].licenseViolated) {
            warningsPerUserId[importedUsersData[i].id] = [_constants.UserManagementConstants.WARNING_ACCOUNT_DISABLED_DUE_TO_LICENSE_TERMS];
        }
    }
    var self = this;

    (0, _jquery_rpc2.default)("UserManagementService.getCreatedUsers", [userIds], function (userManagementResult) {
        // add warnings
        for (var i = 0; i < userManagementResult.usersInfos.length; i++) {
            var user = userManagementResult.usersInfos[i];
            user.warnings = warningsPerUserId[user.id];
        }
        self._onSuccessfulUsersCreation(userManagementResult);
    });
};

UserListPage.prototype._onSuccessfulUsersCreation = function (userManagementResult) {
    this._licenseCounterManager.setLicenseCounter(userManagementResult.licenseCounters);
    this._licenseCounterManager.update();
    this.setAddUserButtonStyleAccordingToLicense(userManagementResult.licenseCounters);

    var noUsersRow = (0, _jquery2.default)("#userListTable").find(".actualContent").find(".noUsersRow");
    var noUsersOnPage = !!noUsersRow.get(0);
    if (noUsersOnPage) noUsersRow.remove();

    if (!this._updateGroups(userManagementResult.userGroups, userManagementResult.timeZoneGroups)) return;

    var $body = (0, _jquery2.default)("body");
    var scrollTop = $body.scrollTop();
    for (var i = userManagementResult.usersInfos.length - 1; i > -1; i--) {
        var userInfo = userManagementResult.usersInfos[i];
        var newRow = this._createRowAtFirstPosition(userInfo, userManagementResult.userApprovers, false);
        this._visibleOnPageUserIds.push(userInfo.id);

        var topSpacer = this._spacer.clone();
        topSpacer.addClass("apUserListTopSpacer");

        newRow.next(".apUserListTopSpacer").remove(); //remove spacer from previously added user if there is one
        newRow.before(topSpacer);

        if (!noUsersOnPage) {
            var bottomSpacer = this._spacer.clone();
            bottomSpacer.addClass("apUserListBottomSpacer");
            newRow.after(bottomSpacer);
        }

        newRow.addClass("apUserListNewUser");
        $body.scrollTop(scrollTop);
    }

    this._validateIsChangeRightsManageBalanceAndAccountSettings(userManagementResult);
    PageOverlayTipsManager.getInstance().refreshDynamicTips();
};

UserListPage.prototype._showInviteSeveralUsersPopup = function (inviteUsersData) {
    this._hideLoadingPopup();

    SystemSettings.dateFormat = inviteUsersData.userManagementData.dateFormat;

    var self = this,
        inviteUsersLightBox = new APInviteSeveralUsersLightBox().init(inviteUsersData);

    inviteUsersLightBox.setSuccessCallback(function (userFieldsArray) {
        if (userFieldsArray.length == 0) {
            return;
        }

        inviteUsersLightBox.disableUserInputWhileSaving();

        var successHandler = function successHandler(userManagementResult) {
            inviteUsersLightBox.enableUserInputWhileSaving();

            inviteUsersLightBox.switchToUsersInvitedState(userManagementResult.usersInfos);
            self._onSuccessfulUsersCreation(userManagementResult);
        };

        var exceptionMapExtender = {};
        exceptionMapExtender["com.actimind.actitime.services.InviteSeveralUsersException"] = function (row, errorThrown) {
            inviteUsersLightBox.showServerErrors(errorThrown.userTableErrors);
            inviteUsersLightBox.enableUserInputWhileSaving();
            return true; //prevent from passing to default error handler
        };
        exceptionMapExtender["com.actimind.actitime.administration.UserExistsException"] = function (row, errorThrown) {
            alert(_messageResource2.default.getMessage("userlist.js.invite_user_mode_popup.duplicate_username"));
            inviteUsersLightBox.enableUserInputWhileSaving();
            return true; //prevent from passing to default error handler
        };

        var resultHandler = new UserManagementResultHandler(null, function () {}, successHandler, null, exceptionMapExtender);

        (0, _jquery_rpc2.default)("UserManagementService.inviteUsers", [userFieldsArray], resultHandler.successHandler, resultHandler.errorHandler);
    });
    inviteUsersLightBox.setCancelCallback(function () {
        inviteUsersLightBox.hide();

        if (!self._updateGroups(inviteUsersData.userManagementData.allUserGroups, inviteUsersData.userManagementData.allTimeZoneGroups)) {
            return;
        }
        self._validateIsChangeRightsManageBalanceAndAccountSettings(inviteUsersData.userManagementData);
    });

    inviteUsersLightBox.show();
};

UserListPage.prototype._makeDefaultUserAccountSettings = function (userManagementData) {

    return {
        firstName: "",
        lastName: "",
        middleInitial: "",
        username: "",
        enabled: true,
        enabledInOtherProduct: true,
        userGroupId: _constants.UserManagementConstants.USER_GROUP_NOT_ASSIGNED_ID,
        timeZoneGroupId: _constants.UserManagementConstants.DEFAULT_TIME_ZONE_GROUP_ID,
        email: "",
        hireDate: currentUserTime().toJSON(),
        releaseDate: null,
        initialSchedule: userManagementData.defaultWorkSchedule.slice(0),
        defaultInitialSchedule: true,
        workSchedule: []
    };
};

UserListPage.prototype._handleNextRequestError = function (e, popup) {
    if (e.body && e.body.errorKey === _constants2.ApiErrorKeys.NotFoundEntity && e.body.entityType === 'user') {
        alert(_messageResource2.default.getMessage('userlist.js.error_no_such_user.edit_user'));
        popup.handlerIfNoSuchUserAfterAjax(popup.user.id);
        return true;
    } else if (e.body && e.body.errorKey === _constants2.ApiErrorKeys.NotFoundEntity && e.body.entityType === 'target') {
        alert(_messageResource2.default.getMessage('userlist.js.error_no_such_work_status.edit_user'));
        popup.hide();
        document.location.reload();
        return true;
    }
};

UserListPage.prototype._initAndShowCreateUserPopup = function (userData, userAccountSettings, currentTime, selectedUserId, showOvertime, otherProductStatusEditable) {
    SystemSettings.dateFormat = userData.userManagementData.dateFormat;
    this.otherProductStatusEditable = otherProductStatusEditable;

    var sectionBuilderParams = new CommonUserManagementSectionsBuilderParams().setPreparatoryStrategy(new CreateSectionsPreparatoryStrategy().init()).setWorkdayDurationsTableBuilder(new CreateWorkDayDurationsTableBuilder().init(userData.userManagementData)).setDefaultWorkStatusesBuilder(new CreateDefaultWorkStatusesBuilder().init(userData.userManagementData)).setUserManagementData(userData.userManagementData).setCurrentTime(currentTime).setAccountSettings(userAccountSettings).setEditedUserIsLoggedIn(false);
    var sectionsBuilder = new ActiplansUserManagementSectionsBuilder().init(sectionBuilderParams),
        self = this,
        createLightBox = new CreateUserLightBox().init(sectionsBuilder, userData.userManagementData, userAccountSettings, userData.allUsers, this._self(this._getCopyUserSettingsData), selectedUserId, this._self(this._abortGetCopyUserSettingsDataRequest), userData.userManagementData.viewerSettings.userGroupsEnabled, userData.userManagementData.viewerSettings.timeZoneGroupsEnabled, showOvertime, otherProductStatusEditable);

    createLightBox.setSuccessCallback(function (userId, accountSettings, newUserGroupName, newTimeZoneGroup, newPassword) {

        createLightBox.cancelAllServerSideChecks();

        var createUserRequest = function createUserRequest() {
            self._makeCreateUserRequest(createLightBox, accountSettings, newUserGroupName, newTimeZoneGroup, newPassword).then(function (_ref3) {
                var result = _ref3.result;

                if (EnabledFeatures.APWSD) {
                    _ClassicBridge2.default.syncChangesFromClassic().then(function () {
                        _ClassicBridge2.default.getUsersByClassicIds([result.userInfo.id]).then(function (result) {
                            var initial = userData.userManagementData.initialDefaultWorkStatus;
                            initial.dateFrom = undefined;
                            initial.dateTo = undefined;
                            initial.id = undefined;

                            _ClassicBridge2.default.putUserDefaultWorkStatuses(result.items[0].id, { items: [userData.userManagementData.initialDefaultWorkStatus] }).catch(function (e) {
                                return self._handleNextRequestError(e, createLightBox);
                            });
                        });
                    });
                }
            });
        };

        if (_constants.isOlVersion) {
            createLightBox.disableUserInputWhileSaving();
            self.getCurrentTime(accountSettings.timeZoneGroupId, function (currentTimeInfo) {
                createLightBox.enableUserInputWhileSaving();
                var hireDate = accountSettings.hireDate.parseJSONDate();
                if (hireDate.getTime() <= currentTimeInfo.currentTime.parseJSONDate().getTime()) //hire date isn't in future
                    createUserRequest();else {
                    var hireDatePlaceholder = (0, _jquery2.default)("#userDataLightBox_hireDatePlaceholder");
                    scrollToElementInPopup(createLightBox.innerContent, hireDatePlaceholder);
                    var invitationDialog = new InvitationDialog().init((0, _jquery2.default)("#userDataLightBox"));
                    var formattedHireDate = new DateFormat(SystemSettings.dateFormat).formatDate(hireDate);
                    invitationDialog.setContent(_messageResource2.default.getMessage("userlist.user_popup.confirmation.hire_date", [formattedHireDate]));
                    invitationDialog.show(hireDatePlaceholder, { offset: "0 7px" }, function () {
                        createUserRequest();
                        invitationDialog.hideAndRemove();
                    });
                }
            });
        } else {
            createUserRequest();
        }
    });
    createLightBox.setCancelCallback(function () {
        createLightBox.cancelAllServerSideChecks();
        createLightBox.hide();

        if (!createLightBox.isDataLoaded) return;

        if (!self._updateGroups(userData.userManagementData.allUserGroups, userData.userManagementData.allTimeZoneGroups)) {
            return;
        }
        self._validateIsChangeRightsManageBalanceAndAccountSettings(userData.userManagementData);
    });
    createLightBox.show();

    return createLightBox;
};

UserListPage.prototype._showCreateUserPopup = function (createUserData, targetRow) {

    this._hideLoadingPopup();

    var defaultCreateUserAccountSettings = this._makeDefaultUserAccountSettings(createUserData.userManagementData);
    var createLightBox = this._initAndShowCreateUserPopup(createUserData, defaultCreateUserAccountSettings, createUserData.currentTimeInDefaultTimeZone, null, false, createUserData.showATStatusControl);

    createLightBox.scrollToTop();
};

UserListPage.prototype._makeCreateUserRequest = function (createLightBox, accountSettings, newUserGroupName, newTimeZoneGroup, newPassword) {

    this._abortGetCopyUserSettingsDataRequest();

    createLightBox.disableUserInputWhileSaving();
    createLightBox.hideSpinner();
    var self = this;

    var exceptionMapExtender = {};
    exceptionMapExtender["com.actimind.common.services.UserEmailInvalidException"] = function () {
        createLightBox.handleSectionError(_constants.UserManagementConstants.ERROR_EMAIL_INVALID);
        createLightBox.enableUserInputWhileSaving();
        return true;
    };

    exceptionMapExtender["com.actimind.actitime.administration.DuplicateTimeZoneGroupNameException"] = function (row, errorThrown) {
        createLightBox.handleDuplicateTimeZoneError(errorThrown.timeZones);
        createLightBox.enableUserInputWhileSaving();
        return true;
    };

    var successHandler = function successHandler(userManagementResult) {
        createLightBox.enableUserInputWhileSaving();

        if (_constants.isOlVersion) createLightBox.switchToAccountCreatedState(userManagementResult.invitationSent, function () {
            self._onCreateUserButtonClicked();
        });else createLightBox.hide();

        self._licenseCounterManager.setLicenseCounter(userManagementResult.licenseCounters);
        self._licenseCounterManager.update();
        self.setAddUserButtonStyleAccordingToLicense(userManagementResult.licenseCounters);

        var noUsersRow = (0, _jquery2.default)("#userListTable").find(".actualContent").find(".noUsersRow");
        var noUsersOnPage = !!noUsersRow.get(0);
        if (noUsersOnPage) noUsersRow.remove();

        if (!self._updateGroups(userManagementResult.userGroups, userManagementResult.timeZoneGroups)) return;

        var userInfo = userManagementResult.userInfo;
        var newRow = self._createRowAtFirstPosition(userInfo, userManagementResult.userApprovers, false);

        self._visibleOnPageUserIds.push(userInfo.id);

        var topSpacer = self._spacer.clone();
        topSpacer.addClass("apUserListTopSpacer");

        newRow.next(".apUserListTopSpacer").remove(); //remove spacer from previously added user if there is one
        newRow.before(topSpacer);

        if (!noUsersOnPage) {
            var bottomSpacer = self._spacer.clone();
            bottomSpacer.addClass("apUserListBottomSpacer");
            newRow.after(bottomSpacer);
        }

        newRow.addClass("apUserListNewUser");

        if (!userManagementResult.userGroups && newUserGroupName) // show new user group name if User Groups was turned off concurrently
            {
                (0, _jquery2.default)(newRow).find(".accountTab-userGroupText-div").html(escapeHtmlSymbols(newUserGroupName));
            }

        if (!userManagementResult.timeZoneGroups && newTimeZoneGroup) // show new time zone group name if Time Zone Groups was turned off concurrently
            {
                (0, _jquery2.default)(newRow).find(".accountTab-userGroupText-div").html(escapeHtmlSymbols(newTimeZoneGroup.name));
            }

        self._validateIsChangeRightsManageBalanceAndAccountSettings(userManagementResult);
        PageOverlayTipsManager.getInstance().refreshDynamicTips();
    };

    var resultHandler = new UserManagementResultHandler(null, function () {}, successHandler, null, exceptionMapExtender);

    function failCallback(jqXHR, textStatus, errorThrown) {
        if (errorThrown.exception == "com.actimind.actitime.administration.UserExistsException") {
            alert(_messageResource2.default.getMessage("userlist.js.create_user_popup.duplicate_email"));
            createLightBox.enableUserInputWhileSaving();
            return true;
        }
        if (errorThrown.exception != "com.actimind.common.services.UserEmailInvalidException" && errorThrown.exception != "com.actimind.actitime.administration.DuplicateTimeZoneGroupNameException") {
            createLightBox.enableUserInputWhileSaving();
            createLightBox.hide();
        }

        return resultHandler.errorHandler(jqXHR, textStatus, errorThrown);
    }

    return (0, _jquery_rpc2.default)("UserManagementService.createUser", [accountSettings, newUserGroupName, newTimeZoneGroup, newPassword], resultHandler.successHandler, failCallback);
};

UserListPage.prototype._showEditUserPopup = function (editUserData, targetRow) {

    this._hideLoadingPopup();

    SystemSettings.dateFormat = editUserData.userManagementData.dateFormat;

    var editedUserIsLoggedIn = editUserData.userId == this._currentUserId,
        sectionsBuilderParams = new ActiplansUserManagementSectionsBuilderParams().setUserManagementSectionsBuilderParams(new CommonUserManagementSectionsBuilderParams().setPreparatoryStrategy(new EditSectionsPreparatoryStrategy().init(editUserData, editedUserIsLoggedIn)).setWorkdayDurationsTableBuilder(new EditWorkDayDurationsTableBuilder().init(editUserData.userManagementData, editUserData.currentTimeInUserTimeZone)).setDefaultWorkStatusesBuilder(new EditDefaultWorkStatusesBuilder().init(editUserData.userManagementData)).setUserManagementData(editUserData.userManagementData).setCurrentTime(editUserData.currentTimeInUserTimeZone).setUserId(editUserData.userId).setAccountSettings(editUserData.userAccountSettings).setEditedUserIsLoggedIn(editedUserIsLoggedIn).setFirstTTDate(editUserData.firstTTDate).setFirstRequestDate(editUserData.firstLeaveRequestDate)),
        sectionsBuilder = new ActiplansUserManagementSectionsBuilder().init(sectionsBuilderParams),
        record = targetRow.data().record,
        userInfo = {
        id: editUserData.userId,
        firstName: record.firstName,
        lastName: record.lastName,
        middleInitial: record.middleInitial
    },
        lb = new _EditUserLightBox2.default().init(sectionsBuilder, editUserData.userManagementData, editUserData.userAccountSettings, userInfo, editUserData.hasTimeTrack, editUserData.lastOtherProductAdmin, false, editUserData.lastLicensesManager, editUserData.otherProductStatusEditable, editUserData.lastLoginTime, function () {
        self.removeRow(editUserData.userId);
    }),
        self = this;

    lb.setSuccessCallback(function (userId, accountSettings, newUserGroupName, newTimeZoneGroup, newPassword) {
        lb.cancelAllServerSideChecks();
        new Promise(function (res) {
            return self._makeUpdateUserNextRequest(lb, editUserData.userManagementData.defaultWorkStatusesChanged, editUserData.userManagementData.userNextId, editUserData.userManagementData.defaultWorkStatusPlanning, res);
        }).then(function () {
            return self._makeUpdateUserClassicRequest(lb, userId, accountSettings, newUserGroupName, newTimeZoneGroup, newPassword, targetRow, editUserData.userAccountSettings.timeZoneGroupId, false, false);
        });
    });
    lb.setDeleteCallback(function (userId) {
        lb.cancelAllServerSideChecks();
        self._makeDeleteUserRequest(lb, userId, targetRow, false, false, false);
    });
    lb.setCancelCallback(function () {
        lb.cancelAllServerSideChecks();
        lb.hide();

        if (!self._updateGroups(editUserData.userManagementData.allUserGroups, editUserData.userManagementData.allTimeZoneGroups)) {
            return;
        }
        self._validateIsChangeRightsManageBalanceAndAccountSettings(editUserData.userManagementData);
    });
    lb.show();
    lb.scrollToTop();
};
UserListPage.prototype._makeDeleteUserRequest = function (editLightBox, userId, targetRow, forceChanges, setAllUsersAutoApprovedOnSuccess, forceLastLicenseManagerUpdate) {
    editLightBox.setDeleteButtonEnabled(false);
    editLightBox.disableButtons();

    var self = this;

    var exceptionMapExtender = {};

    exceptionMapExtender["com.actimind.actitime.services.NoRightsForRemoteCallException"] = function () {
        alert(_messageResource2.default.getMessage("actiplans.user_list.noRightsForUserAccount"));
        document.location.reload();
        return true; //prevent from passing to default error handler
    };

    exceptionMapExtender["com.actimind.actitime.administration.NoSuchUserException"] = function () {
        UserListPage.removeRow(targetRow);
        return true; //prevent from passing to default error handler
    };

    exceptionMapExtender["com.actimind.actitime.administration.UserCannotBeDeletedException"] = function () {
        alert(_messageResource2.default.getMessage('userlist.js.error_cant_delete'));
        return true; //prevent from passing to default error handler
    };

    var confirmationIsNeededExceptionFunction = function confirmationIsNeededExceptionFunction(row, errorThrown) {
        if (confirm(self._createDeleteConfirmationMsg(errorThrown))) {
            var setAllUsersAutoApprovedOnSuccess = false; // errorThrown.confirmationCodes contains LAST_MANAGER_ ...

            /*if ( confirmationCode == UserListPageConstants.CONFIRMATION_IS_NEEDED_ON_DELETE_DUE_TO_LAST_LTM ||
                 confirmationCode == UserListPageConstants.CONFIRMATION_IS_NEEDED_ON_DELETE_DUE_TO_LAST_LTM_AND_LEAVE_REQUESTS )
            {
                setAllUsersAutoApprovedOnSuccess = true;
            }*/
            self._makeDeleteUserRequest(editLightBox, userId, targetRow, true, setAllUsersAutoApprovedOnSuccess, forceLastLicenseManagerUpdate);
        }
        return true; //prevent from passing to default error handler
    };

    exceptionMapExtender["com.actimind.common.administration.EditUserConfirmationIsNeededException"] = confirmationIsNeededExceptionFunction;
    exceptionMapExtender["com.actimind.common.administration.DeleteUserConfirmationIsNeededException"] = confirmationIsNeededExceptionFunction;

    exceptionMapExtender["com.actimind.common.administration.UserIsLastLicensesManagerException"] = function () {
        var _this3 = this;

        this.deleteLastManagerInfo = new _LastManagerInfo2.default({ isDeleting: true });
        this.deleteAlert = new _ConfirmationDialog2.default({
            onShow: function onShow() {
                return _this3.deleteLastManagerInfo.setState({
                    userName: accountSettings.firstName + " " + accountSettings.lastName
                });
            },
            onConfirm: function onConfirm() {
                return self._makeDeleteUserRequest(editLightBox, userId, targetRow, forceChanges, setAllUsersAutoApprovedOnSuccess, true);
            },
            contentComponent: this.deleteLastManagerInfo
        }).init((0, _jquery2.default)('body'));
        this.deleteAlert.show();
        return true;
    };

    var successHandler = function successHandler(userManagementResult) {
        editLightBox.enableUserInputWhileSaving();
        editLightBox.hide();
        self._licenseCounterManager.setLicenseCounter(userManagementResult.licenseCounters);
        self._licenseCounterManager.update();
        self.setAddUserButtonStyleAccordingToLicense(userManagementResult.licenseCounters);

        UserListPage.removeRow(targetRow);

        (0, _jquery2.default)(".actualContent tr.apUserListBottomSpacer:last-child").remove();

        // remove userId from array of visible users
        self._visibleOnPageUserIds.splice(_jquery2.default.inArray(userId, self._visibleOnPageUserIds), 1);

        if (!self._updateGroups(userManagementResult.userGroups, userManagementResult.timeZoneGroups)) {
            return;
        }
        if (self._validateIsChangeRightsManageBalanceAndAccountSettings(userManagementResult)) {
            return;
        }

        if (setAllUsersAutoApprovedOnSuccess) self._setAllUsersAutoApproved();

        // 1 as userRow is in templateRow
        if (self._userListBody.find(".userRow").size() == 1) {
            self._pagerController.reloadEmptyPage();
        }
    };

    var resultHandler = new UserManagementResultHandler(null, function () {}, successHandler, null, exceptionMapExtender);

    function errorHandler(jqXHR, textStatus, errorThrown) {
        editLightBox.enableUserInputWhileSaving();
        editLightBox.hide();
        return resultHandler.errorHandler(jqXHR, textStatus, errorThrown);
    }

    (0, _jquery_rpc2.default)("UserManagementService.deleteUser", [userId, forceChanges], resultHandler.successHandler, errorHandler);
};

UserListPage.prototype._updateGroups = function (userGroups, timeZoneGroups) {
    var _this4 = this;

    var userGroupsEnabled = userGroups ? true : false;
    var timeZoneGroupsEnabled = timeZoneGroups ? true : false;
    if (this._isUGREnabled() != userGroupsEnabled) {
        this._onUGRChanged(true);
        return false;
    }
    if (this._isTZGEnabled() != timeZoneGroupsEnabled) {
        this._onTZGChanged(true);
        return false;
    }
    var state = this._stateController.getState();
    if (this._isUGREnabled() && userGroupsEnabled || this._isTZGEnabled() && timeZoneGroupsEnabled) {
        this._allUserGroups = userGroups;
        this._userGroupIdToGroupMap = makeMapForEntitiesArray(userGroups ? userGroups : []);
        this._allTimeZoneGroups = timeZoneGroups;
        this._timeZoneGroupIdToGroupMap = makeMapForEntitiesArray(timeZoneGroups ? timeZoneGroups : []);
        this._updateGroupInAllRows();
    }
    _ClassicBridge2.default.syncChangesFromClassic().then(function () {
        _this4._initUserFilter();
    });
    return true;
};

UserListPage.prototype._updateApproverName = function (userInfo) {
    var self = this;
    var updatedUserApprover = {
        firstName: userInfo.firstName,
        lastName: userInfo.lastName,
        middleInitial: userInfo.middleInitial,
        userName: userInfo.name,
        id: userInfo.id
    };

    _jquery2.default.each(this._userListBody.find(".userRow"), function (index, row) {
        var userApprovers = (0, _jquery2.default)(row).data().userApprovers;
        if (userApprovers != null) {
            for (var i = 0; i < userApprovers.length; i++) {
                if (userInfo.id == userApprovers[i].id) {
                    userApprovers[i] = updatedUserApprover;
                    self._updateApprovedByCellContent((0, _jquery2.default)(row));
                    break;
                }
            }
        }
    });
};

UserListPage.prototype._setAllUsersAutoApproved = function () {
    var self = this;

    _jquery2.default.each(this._userListBody.find(".userRow"), function (index, row) {
        var record = (0, _jquery2.default)(row).data().record;

        if (record.requiresApproval) {
            record.requiresApproval = false;
            self._updateApprovedByCellContent((0, _jquery2.default)(row));
        }

        if (record.roles.allowedToManageRequests && record.enabled) {
            record.roles.allowedToManageRequests = false;
            self._updateManageRequestsRoleAndUsersForApproverCellContent((0, _jquery2.default)(row));
        }
    });

    PageOverlayTipsManager.getInstance().refreshDynamicTips();
};

UserListPage.prototype._highlightRow = function (targetRow) {
    (0, _jquery2.default)(targetRow).addClass("apUserListUpdatedUser");
    setTimeout(function () {
        (0, _jquery2.default)(targetRow).removeClass('apUserListUpdatedUser');
    }, 1500);
};

UserListPage.prototype._makeUpdateUserNextRequest = function (editLightBox, defaultWorkStatusesChanged, userNextId, defaultWorkStatuses, successCallback) {
    editLightBox.disableUserInputWhileSaving();
    var self = this;

    if (EnabledFeatures.APWSD && defaultWorkStatusesChanged) {
        return _ClassicBridge2.default.putUserDefaultWorkStatuses(userNextId, { items: defaultWorkStatuses }).then(successCallback).catch(function (e) {
            editLightBox.enableUserInputWhileSaving();

            if (self._handleNextRequestError(e, editLightBox)) return;
            alert(_messageResource2.default.getMessage('error.js.lightbox_loader.unexpected_error', [PRODUCT_NAME]));
        });
    }

    return successCallback();
};

UserListPage.prototype._makeUpdateUserClassicRequest = function (editLightBox, userId, accountSettings, newUserGroupName, newTimeZoneGroup, newPassword, targetRow, previousTimeGroupZoneId, forceChanges, forceLastLicenseManagerUpdate) {
    editLightBox.disableUserInputWhileSaving();
    var self = this;

    var exceptionMapExtender = {};
    exceptionMapExtender["com.actimind.actitime.administration.UserExistsException"] = function () {
        editLightBox.handleSectionError(_constants.UserManagementConstants.ERROR_DUPLICATE_USERNAME);
        editLightBox.enableUserInputWhileSaving();
        return true; //prevent from passing to default error handler
    };

    exceptionMapExtender["com.actimind.actitime.administration.NoSuchUserException"] = function () {
        alert(_messageResource2.default.getMessage('actiplans.user_list.error_user_was_deleted'));
        UserListPage.removeRow(targetRow);
        return true; //prevent from passing to default error handler
    };

    exceptionMapExtender["com.actimind.common.administration.LastManagerInOtherProductException"] = function () {
        alert(_messageResource2.default.getMessage('user.edit.js.cannot_disable.last_admin_ap'));
        return true; //prevent from passing to default error handler
    };

    var confirmationIsNeededExceptionFunction = function confirmationIsNeededExceptionFunction(row, errorThrown) {
        if (confirm(self._createEditConfirmationMsg(errorThrown))) self._makeUpdateUserClassicRequest(editLightBox, userId, accountSettings, newUserGroupName, newTimeZoneGroup, newPassword, targetRow, previousTimeGroupZoneId, true, forceLastLicenseManagerUpdate);else editLightBox.enableUserInputWhileSaving();
        return true; //prevent from passing to default error handler
    };

    exceptionMapExtender["com.actimind.common.administration.EditUserConfirmationIsNeededException"] = confirmationIsNeededExceptionFunction;
    exceptionMapExtender["com.actimind.common.administration.DeleteUserConfirmationIsNeededException"] = confirmationIsNeededExceptionFunction;

    var $body = (0, _jquery2.default)("body");

    exceptionMapExtender["com.actimind.common.administration.UserIsLastLicensesManagerException"] = function () {
        var _this5 = this;

        this.disableAlert && this.disableAlert.getEl().remove();

        var productNames = _constants.PRODUCTS_INTEGRATED ? _constants.Product.actiTIME + " & " + _constants.Product.actiPLANS : _constants.CURRENT_PRODUCT;

        if (!editLightBox.accountInformation.isEnabled() && (editLightBox.accountInformation.isEnabledInOtherProduct() || editLightBox.accountInformation.isEnabledInOtherProduct() === editLightBox.accountSettings.enabled)) productNames = _constants.Product.actiPLANS;

        if ((editLightBox.accountInformation.isEnabled() || editLightBox.accountInformation.isEnabled() === editLightBox.accountSettings.enabled) && !editLightBox.accountInformation.isEnabledInOtherProduct()) productNames = _constants.Product.actiTIME;

        this.disableLastManagerInfo = new _LastManagerInfo2.default({ product: productNames });

        this.disableAlert = new _ConfirmationDialog2.default({
            onShow: function onShow() {
                return _this5.disableLastManagerInfo.setState({
                    userName: accountSettings.firstName + " " + accountSettings.lastName
                });
            },
            onConfirm: function onConfirm() {
                return self._makeUpdateUserClassicRequest(editLightBox, userId, accountSettings, newUserGroupName, newTimeZoneGroup, newPassword, targetRow, previousTimeGroupZoneId, forceChanges, true);
            },
            onCancel: function onCancel() {
                return editLightBox.enableUserInputWhileSaving();
            },
            contentComponent: this.disableLastManagerInfo
        }).init($body);
        this.disableAlert.show();

        return true;
    };

    exceptionMapExtender["com.actimind.common.services.UserEmailInvalidException"] = function () {
        editLightBox.handleSectionError(_constants.UserManagementConstants.ERROR_EMAIL_INVALID);
        editLightBox.enableUserInputWhileSaving();
        return true;
    };

    exceptionMapExtender["com.actimind.actitime.administration.DuplicateTimeZoneGroupNameException"] = function (row, errorThrown) {
        editLightBox.handleDuplicateTimeZoneError(errorThrown.timeZones);
        editLightBox.enableUserInputWhileSaving();
        return true;
    };

    var successHandler = function successHandler(userManagementResult) {
        editLightBox.enableUserInputWhileSaving();
        editLightBox.hide();

        // update user list if time zone has been changed
        if (userManagementResult.userInfo.id == self._currentUserId && previousTimeGroupZoneId != userManagementResult.userInfo.timeZoneGroupId) {
            self._abortAllRequests();
            alert(_messageResource2.default.getMessage('actiplans.user_list.message.time_zone_was_changed'));
            document.location.reload();
            return;
        }

        self._licenseCounterManager.setLicenseCounter(userManagementResult.licenseCounters);
        self._licenseCounterManager.update();
        self.setAddUserButtonStyleAccordingToLicense(userManagementResult.licenseCounters);

        self._highlightRow(targetRow);

        if (!self._updateGroups(userManagementResult.userGroups, userManagementResult.timeZoneGroups)) {
            return;
        }
        if (self._validateIsChangeRightsManageBalanceAndAccountSettings(userManagementResult)) {
            return;
        }

        self._updateApproverName(userManagementResult.userInfo);

        if (forceChanges) self._setAllUsersAutoApproved();
    };
    var resultHandler = new UserManagementResultHandler((0, _jquery2.default)(targetRow), this._self(this._updateRowAndTips), successHandler, null, exceptionMapExtender);

    function failCallback(jqXHR, textStatus, errorThrown) {
        if (errorThrown.exception != "com.actimind.actitime.administration.UserExistsException" && errorThrown.exception != "com.actimind.common.administration.EditUserConfirmationIsNeededException" && errorThrown.exception != "com.actimind.common.administration.DeleteUserConfirmationIsNeededException" && errorThrown.exception != "com.actimind.common.administration.UserIsLastLicensesManagerException" && errorThrown.exception != "com.actimind.common.services.UserEmailInvalidException" && errorThrown.exception != "com.actimind.actitime.administration.DuplicateTimeZoneGroupNameException") {
            editLightBox.enableUserInputWhileSaving();
            editLightBox.hide();
        }

        return resultHandler.errorHandler(jqXHR, textStatus, errorThrown);
    }

    return (0, _jquery_rpc2.default)("UserManagementService.updateUser", [userId, accountSettings, newUserGroupName, newTimeZoneGroup, newPassword, forceChanges, forceLastLicenseManagerUpdate], resultHandler.successHandler, function (jqXHR, textStatus, errorThrown) {
        return failCallback(jqXHR, textStatus, errorThrown);
    });
};

UserListPage.prototype._abortGetInviteSeveralUsersDataRequest = function () {
    if (this._getInviteSeveralUsersDataRequestObject) {
        this._getInviteSeveralUsersDataRequestObject.abort();
    }
};

UserListPage.prototype._onInviteSeveralUsersButtonClicked = function () {
    var _this6 = this;

    this._abortAllRequests();
    this._showLoadingPopup();
    this._getInviteSeveralUsersDataRequestObject = (0, _jquery_rpc2.default)("UserManagementService.getInviteUsersData", [], function (inviteUsersData) {
        _this6._showInviteSeveralUsersPopup(inviteUsersData);
    }, function (jqXHR, textStatus, errorThrown) {
        _this6._hideLoadingPopup();

        if (errorThrown.exception === 'com.actimind.actitime.services.NoRightsToManageAccountSettings') {
            alert(_messageResource2.default.getMessage('actiplans.user_list.error_cant_create_user_account'));
            document.location.reload();
            return true;
        }

        if (errorThrown.msg.indexOf('com.actimind.common.licensing.NoActiveLicensesException') !== -1) {
            alert(_messageResource2.default.getMessage('common.license_expired_exception.reload_page'));
            document.location.reload();
            return true;
        }

        return false;
    });
};

UserListPage.prototype._abortGetCreateUserDataRequest = function () {
    if (this._getCreateUserDataRequestObject) {
        this._getCreateUserDataRequestObject.abort();
    }
};

UserListPage.prototype._onCreateUserButtonClicked = function (jQueryEvent) {
    this._abortAllRequests();
    this._showLoadingPopup();
    var self = this;
    this._getCreateUserDataRequestObject = (0, _jquery_rpc2.default)("UserManagementService.getCreateUserData", [], function (createUserData) {
        if (EnabledFeatures.APWSD) {
            _ClassicBridge2.default.getWorkStatusesForUserProfile().then(function (workStatuses) {
                createUserData.userManagementData.workStatuses = workStatuses.items;

                var defaultWorkStatus = "";
                for (var i = 0; i < createUserData.userManagementData.workStatuses.length; i++) {
                    if (createUserData.userManagementData.workStatuses[i]["default"]) {
                        defaultWorkStatus = createUserData.userManagementData.workStatuses[i];
                    }
                }

                createUserData.userManagementData.initialDefaultWorkStatus = {
                    id: 1,
                    dateFrom: null,
                    workStatusId: defaultWorkStatus.id,
                    dateTo: null
                };

                self._showCreateUserPopup(createUserData);
            });
        } else {
            self._showCreateUserPopup(createUserData);
        }
    }, function (jqXHR, textStatus, errorThrown) {
        self._hideLoadingPopup();

        if (errorThrown.exception === 'com.actimind.actitime.services.NoRightsToManageAccountSettings') {
            alert(_messageResource2.default.getMessage('actiplans.user_list.error_cant_create_user_account'));
            document.location.reload();
            return true;
        }
        if (errorThrown.msg && errorThrown.msg.indexOf('com.actimind.common.licensing.NoActiveLicensesException') !== -1) {
            alert(_messageResource2.default.getMessage('common.license_expired_exception.reload_page'));
            document.location.reload();
            return true;
        }
        return false;
    });
};

UserListPage.prototype._getCopyUserSettingsData = function (createUserLightBox, userId) {
    this._abortGetCopyUserSettingsDataRequest();

    var self = this;
    this._getCopyUserSettingsDataRequestObject = (0, _jquery_rpc2.default)("UserManagementService.getCopyUserSettingsData", [userId], function (copyUserSettingsData) {
        var createUserLightBoxState = createUserLightBox.getLightBoxState();
        createUserLightBox.hide();

        if (EnabledFeatures.APWSD) {
            Promise.all([_ClassicBridge2.default.getUsersByClassicIds([userId]), _ClassicBridge2.default.getWorkStatusesForUserProfile()]).then(function (_ref4) {
                var _ref5 = _slicedToArray(_ref4, 2),
                    nextUsers = _ref5[0],
                    workStatuses = _ref5[1];

                var nextUser = nextUsers.items[0];
                _ClassicBridge2.default.getDefaultWorkStatusPlanningByUserId(nextUser.id).then(function (defaultWorkStatuses) {
                    copyUserSettingsData.userManagementData.initialDefaultWorkStatus = _ClassicBridge2.default.findCurrentInterval(Date.now(), defaultWorkStatuses.items);
                    copyUserSettingsData.userManagementData.workStatuses = workStatuses.items;

                    self._processCopyUserSettingsData(copyUserSettingsData, createUserLightBoxState.userInputData, createUserLightBoxState.errorState, createUserLightBoxState.scrollPosition);
                });
            });
        } else {
            self._processCopyUserSettingsData(copyUserSettingsData, createUserLightBoxState.userInputData, createUserLightBoxState.errorState, createUserLightBoxState.scrollPosition);
        }
    }, function (jqXHR, textStatus, errorThrown) {
        createUserLightBox.hideSpinner();
        if (errorThrown.exception == 'com.actimind.actitime.administration.NoSuchUserException') {
            alert(_messageResource2.default.getMessage('actiplans.user_list.error_user_was_deleted'));
            usersSelector.removeUser(userId);
            return true;
        }
        if (errorThrown.exception == 'com.actimind.actitime.services.NoRightsToManageAccountSettings') {
            alert(_messageResource2.default.getMessage('actiplans.user_list.error_cant_create_user_account'));
            document.location.reload();
            return true;
        }
        usersSelector.enableInput();
        usersSelector.rollbackSelection();
        return false;
    });
};

UserListPage.prototype._abortGetCopyUserSettingsDataRequest = function () {
    if (this._getCopyUserSettingsDataRequestObject) {
        this._getCopyUserSettingsDataRequestObject.abort();
        this._getCopyUserSettingsDataRequestObject = null;
    }
};

UserListPage.prototype._processCopyUserSettingsData = function (copyUserSettingsData, userInputData, errorState, scrollPosition) {
    copyUserSettingsData.userAccountSettings.firstName = userInputData.firstName;
    copyUserSettingsData.userAccountSettings.lastName = userInputData.lastName;
    copyUserSettingsData.userAccountSettings.middleInitial = userInputData.middleInitial;
    copyUserSettingsData.userAccountSettings.username = userInputData.username;
    copyUserSettingsData.userAccountSettings.enabled = userInputData.enabled;
    copyUserSettingsData.userAccountSettings.email = userInputData.email;
    copyUserSettingsData.userAccountSettings.releaseDate = userInputData.releaseDate;
    copyUserSettingsData.userAccountSettings.hireDate = userInputData.hireDate;
    copyUserSettingsData.userAccountSettings.passwordData = userInputData.passwordData;

    var lb = this._initAndShowCreateUserPopup(copyUserSettingsData, copyUserSettingsData.userAccountSettings, copyUserSettingsData.currentTimeInUserTimeZone, copyUserSettingsData.userId, true, this.otherProductStatusEditable);

    lb.restoreState(errorState, scrollPosition);
};

UserListPage.prototype._onBalanceClicked = function (jQueryEvent, balanceType) {
    var cell = (0, _jquery2.default)(jQueryEvent.delegateTarget);
    var row = cell.parents('tr');
    var record = row.data().record;
    var balanceData;
    var titleKey = "";
    if (balanceType === BalanceType.PTO) {
        balanceData = record.ptoData;
        titleKey = 'common.pto_editor.title';
    }
    if (balanceType === BalanceType.SICK) {
        balanceData = record.sickDaysData;
        titleKey = 'common.sick_editor.title';
    }

    if (balanceData && !balanceData.notStarted) {
        this._abortRequestsBeforeUserSettingsUpdate(UserListPage.USER_SETTINGS_UPDATE_KEY_PTO_BALANCE);

        var userName = UserNameFormat.formatFML(record.firstName, record.lastName, record.middleInitial);

        this._balanceEditor.setOnCloseCallback(function () {
            row.removeClass("selected");
        });

        this._balanceEditor.show(cell, balanceData.balance, userName, this._ptoHoursPerDay, balanceType, titleKey);
        this._balanceEditor.setOnApplyCallback(this._self(function (correctionType, valueInDays, comment) {
            this._callUserManagementService(row, "UserManagementService.addBalanceCorrection", [record.id, balanceType, correctionType, valueInDays, comment], UserListPage.USER_SETTINGS_UPDATE_KEY_PTO_BALANCE, null, function () {
                this._balanceEditor.hide();
                this._highlightRow(row);
            }, function (jqXHR, textStatus, errorThrown) {
                this._balanceEditor.busyModeOff();
                if (errorThrown.exception == 'com.actimind.actitime.administration.NoSuchUserException') {
                    this._balanceEditor.hide();
                } else if (errorThrown.exception == 'com.actimind.common.balance.BalanceCapExceededException') {
                    this._balanceEditor.showCapExceededError(errorThrown.cap);
                    return true;
                }
                return false;
            });
        }));

        row.addClass("selected");
    }
};

UserListPage.prototype._sendSetUserAutoApprovedRequest = function (row, id, requiresApproval, forceChanges) {
    var self = this;
    this._callUserManagementService(row, 'UserManagementService.setUserAutoApproved', [id, requiresApproval, forceChanges], UserListPage.USER_SETTINGS_UPDATE_KEY_APPROVED_BY, "spinnerPlaceholder", null, forceChanges ? null : function (jqXHR, textStatus, errorThrown) {
        if (errorThrown.exception == 'com.actimind.actiplans.administration.WaitingForApprovalRequestsExistException') {
            if (confirm(_messageResource2.default.getMessage("actiplans.user_list.js.auto_approved_confirmation"))) {
                self._sendSetUserAutoApprovedRequest(row, id, requiresApproval, true);
            }
            return true;
        }
        if (errorThrown.exception == 'com.actimind.actiplans.administration.NoLeaveTimeManagerException') {
            alert(_messageResource2.default.getMessage(EnabledFeatures.APWSD ? "actiplans.user_list.js.set_auto_approved.no_leave_request_managers.wsd_feature_on" : "actiplans.user_list.js.set_auto_approved.no_leave_request_managers"));
            self._setAllUsersAutoApproved();
            return true;
        }
        return false;
    });
};

UserListPage.prototype._addAccrualRulesHoveredState = function (jQueryEvent, balanceType) {
    var cell = (0, _jquery2.default)(jQueryEvent.delegateTarget);
    var row = cell.parents('tr');
    var record = cell.parents('tr').data().record;

    if (!record.ptoData && balanceType == BalanceType.PTO || !record.sickDaysData && balanceType == BalanceType.SICK) return;

    row.find(".accrueRule-td").addClass("hovered");
    row.find(".resetRule-td").addClass("hovered");
    row.find(".capRule-td").addClass("hovered");
};

UserListPage.prototype._removeAccrualRulesHoveredState = function (jQueryEvent) {
    var cell = (0, _jquery2.default)(jQueryEvent.delegateTarget);
    var row = cell.parents('tr');

    row.find(".accrueRule-td").removeClass("hovered");
    row.find(".resetRule-td").removeClass("hovered");
    row.find(".capRule-td").removeClass("hovered");
};

UserListPage.prototype._showUserWorkScheduleTooltip = function (jQueryEvent, offset) {
    var cell = (0, _jquery2.default)(jQueryEvent.delegateTarget);
    var row = cell.parents('tr');
    var record = row.data().record;

    var scheduleHeaderText = record.defaultWorkSchedule ? _messageResource2.default.getMessage("actiplans.user_list.js.tooltip.corporateSchedule") : _messageResource2.default.getMessage("actiplans.user_list.js.tooltip.personalSchedule");
    var weekText = "<span class='week duration'> " + UserTime.formatTime(record.workingWeekTotal) + "h" + "</span>";

    this._tablePlaceholder.html("");
    var workdayDurationViewer = new WorkdayDurationsViewer().init(record.effectiveSchedule, this._weekStartDay, function () {}, true, "");
    workdayDurationViewer.renderTo(this._tablePlaceholder[0]);

    this._scheduleHeader.html(scheduleHeaderText);
    this._weekTextPlaceholder.html(weekText);

    this._userWorkScheduleTooltip.show();
    if (offset) this._userWorkScheduleTooltip.offset(offset);
};

UserListPage.prototype._showApproversTooltip = function (jQueryEvent, offset) {
    var cell = (0, _jquery2.default)(jQueryEvent.delegateTarget);
    var userRowData = cell.parents('tr').data();

    this._approversTooltip.updateUIAndShow({
        requiresApproval: userRowData.record.requiresApproval,
        userIsManager: userRowData.record.roles.allowedToManageRequests,
        userApprovers: userRowData.userApprovers
    }, offset);
};

UserListPage.prototype._verifyCanAssignUsersToApprover = function (record) {
    return this._viewerSettings.allowedToManageAccountSettings && record.enabled && record.roles.allowedToManageRequests;
};

UserListPage.prototype._showUsersForApproverTooltip = function (jQueryEvent, offset) {
    var cell = (0, _jquery2.default)(jQueryEvent.delegateTarget);
    var record = cell.parents('tr').data().record;

    if (!this._verifyCanAssignUsersToApprover(record)) return;

    this._usersForApproverTooltip.show();
    if (offset) this._usersForApproverTooltip.offset(offset);
};

UserListPage.prototype._showAccrualRulesTooltip = function (jQueryEvent, balanceRulesManager, data) {
    var cell = (0, _jquery2.default)(jQueryEvent.delegateTarget);
    var record = cell.parents('tr').data().record;
    var tooltipData = record[data];
    if (tooltipData) {
        tooltipData.hireDate = record.hireDate;
    }
    balanceRulesManager.showAccrualRulesTooltip(jQueryEvent, tooltipData);
};

UserListPage.prototype._onEditRulesClicked = function (jQueryEvent, balanceType) {
    var cell = (0, _jquery2.default)(jQueryEvent.delegateTarget);
    var row = cell.parents('tr');
    var record = cell.parents('tr').data().record;

    var balanceData = balanceType == BalanceType.PTO ? record.ptoData : record.sickDaysData;
    var balanceRulesManager = balanceType == BalanceType.PTO ? this.ptoRulesManager : this.sickRulesManager;
    if (!balanceData) return;

    balanceRulesManager.hideAccrualRulesTooltip();
    balanceRulesManager.updateDialog(balanceData, record.today);

    var that = this;

    this._abortRequestsBeforeUserSettingsUpdate(UserListPage.USER_SETTINGS_UPDATE_KEY_PTO_RULES);

    balanceRulesManager.setModifyBalanceAccrualRulesOkClick(function () {
        that._modifyBalanceAccrualRulesOkClick(cell, row, record, balanceType);
        that._highlightRow(row);
    });
    balanceRulesManager.setOnCloseCallback(function () {
        row.removeClass("selected ptoDialogSelected");
    });

    balanceRulesManager.showDialogAt(balanceData.defaultRules ? row.find(".accrueRule-td:visible") : row.find(".resetRule-td:visible"), { offset: "5px -10px" });

    row.addClass("selected ptoDialogSelected");
};

UserListPage.prototype._onShowSickBalanceHistoryClicked = function (jQueryEvent) {
    this._balanceHistoryPanel.updateTitle(_messageResource2.default.getMessage("common.balance_history.balance_history_panel.title", [_messageResource2.default.getMessage("common.balance_history.table.sick")]));

    var config = {};
    config.balanceHistoryService = 'UserManagementService.getUserSickBalanceHistory';
    config.prefix = BalanceHistory.BalanceTypes.SICK;
    config.showBalanceInHours = SystemSettings.showSickInHours;
    config.balanceType = BalanceType.SICK;
    this._onShowBalanceHistoryClicked(jQueryEvent, config, BalanceType.SICK);
};

UserListPage.prototype._onShowPtoBalanceHistoryClicked = function (jQueryEvent) {
    this._balanceHistoryPanel.updateTitle(_messageResource2.default.getMessage("common.balance_history.balance_history_panel.title", [_messageResource2.default.getMessage("common.balance_history.table.pto")]));

    var config = {};
    config.balanceHistoryService = 'UserManagementService.getUserPtoBalanceHistory';
    config.prefix = BalanceHistory.BalanceTypes.PTO;
    config.balanceType = BalanceType.PTO;
    config.showBalanceInHours = SystemSettings.showPTOInHours;
    this._onShowBalanceHistoryClicked(jQueryEvent, config, BalanceType.PTO);
};

UserListPage.prototype._onShowBalanceHistoryClicked = function (jQueryEvent, config, balanceType) {
    var cell = (0, _jquery2.default)(jQueryEvent.delegateTarget);
    var row = cell.parents('tr');
    var record = cell.parents('tr').data().record;

    if (balanceType == BalanceType.PTO && !record.ptoData || balanceType == BalanceType.SICK && !record.sickDaysData) return;

    var that = this;

    this.addRowSelection(row);
    this.showLoadingHistoryProgress(cell);

    (0, _jquery_rpc2.default)(config.balanceHistoryService, [record.id], function (extendedUserPtoBalanceHistoryData) {
        new PanelBalanceHistoryTable(that.$tableContainerEl, extendedUserPtoBalanceHistoryData.userBalanceHistoryRecords.list, that._ptoHoursPerDay, config.showBalanceInHours, config.prefix).init();
        that._balanceHistoryPanel.setOnCloseCallback(function () {
            cell.removeClass("dialogSelected");that.clearRowSelection(row);
        });
        that._balanceHistoryPanel.updateLinkState(extendedUserPtoBalanceHistoryData.userBalanceHistoryRecords.list.length, record.id, config.balanceType);
        that._balanceHistoryPanel.showAt(row.find(".balanceHistoryShow-td:visible"));
        row.find(".balanceHistoryShow-td").removeClass("hovered");
        that.hideLoadingHistoryProgress(cell);
        cell.addClass("dialogSelected");
    }, function (jqXHR, textStatus, errorThrown) {
        that.clearRowSelection(row);
        that.hideLoadingHistoryProgress(cell);
        if (errorThrown.exception == "com.actimind.actitime.administration.NoSuchUserException") {
            alert(_messageResource2.default.getMessage('actiplans.user_list.error_user_was_deleted.short'));
            UserListPage.removeRow(row);
            return true;
        }
    });
};

UserListPage.prototype.addRowSelection = function (row) {
    row.addClass("selected");
};
UserListPage.prototype.clearRowSelection = function (row) {
    row.removeClass("selected");
};
UserListPage.prototype.showLoadingHistoryProgress = function (cell) {
    cell.find("img").hide();
    cell.addClass("loading");
    this._spinnerController.spinInElement(cell.find(".ptoHistorySpinnerPlaceholder"));
};

UserListPage.prototype.hideLoadingHistoryProgress = function (cell) {
    cell.find("img").show();
    cell.removeClass("loading");
    this._spinnerController.stop();
};

UserListPage.prototype._modifyBalanceAccrualRulesOkClick = function (cell, row, record, balanceType) {
    var balanceRulesManager = balanceType == BalanceType.PTO ? this.ptoRulesManager : this.sickRulesManager;
    var dialogValues = balanceRulesManager.getDialogValues();
    this._callUserManagementService(row, 'UserManagementService.setBalanceRules', [record.id, balanceType, dialogValues.useDefaults, dialogValues.accrualRule, dialogValues.resetRule, dialogValues.capRule], UserListPage.USER_SETTINGS_UPDATE_KEY_PTO_RULES, null, function () {
        balanceRulesManager.hideDialog();
    }, function () {
        balanceRulesManager.hideDialog();
    });
};

UserListPage.prototype._abortUserSettingsUpdateRequests = function () {
    for (var key in this._userSettingsUpdateRequestObjects) {
        if (this._userSettingsUpdateRequestObjects.hasOwnProperty(key)) {
            this._userSettingsUpdateRequestObjects[key].abort();
            delete this._userSettingsUpdateRequestObjects[key];
        }
    }
};

UserListPage.prototype._abortAllRequests = function () {
    this._abortUserListUpdateRequest(false);
    this._abortUserSettingsUpdateRequests();

    this._abortGetCreateUserDataRequest();
    this._abortGetEditUserDataRequest();
    this._abortGetInviteSeveralUsersDataRequest();
};

UserListPage.prototype._abortRequestsBeforeUserListUpdate = function () {
    this._abortUserListUpdateRequest(true);
    this._abortUserSettingsUpdateRequests();

    this._abortGetCreateUserDataRequest();
    this._abortGetEditUserDataRequest();
    this._abortGetInviteSeveralUsersDataRequest();
};

UserListPage.prototype._abortRequestsBeforeUserSettingsUpdate = function (userSettingKey) {
    this._abortUserListUpdateRequest(false);
    if (this._userSettingsUpdateRequestObjects[userSettingKey]) {
        this._userSettingsUpdateRequestObjects[userSettingKey].abort();
        delete this._userSettingsUpdateRequestObjects[userSettingKey];
    }

    this._abortGetCreateUserDataRequest();
    this._abortGetEditUserDataRequest();
    this._abortGetInviteSeveralUsersDataRequest();
};

UserListPage.prototype._onSortButtonClick = function (sortBy, spinnerContainerId) {
    var state = this._stateController.getProperties(['sortBy', 'isAscending', 'pageNum']);
    if (state.sortBy == sortBy) {
        state.isAscending = !state.isAscending;
    } else {
        state.sortBy = sortBy;
        state.isAscending = true;
    }
    state.pageNum = 1;
    this._stateController.setProperties(state);

    this._updateUserList(spinnerContainerId, true);
};

UserListPage.prototype._abortUserListUpdateRequest = function (isBeforeUserListUpdate) {
    if (this._updateUserListDelayTimer != null) {
        clearTimeout(this._updateUserListDelayTimer);
        this._updateUserListDelayTimer = null;
        if (!isBeforeUserListUpdate) this._stateController.loadState();
    }

    if (this._userListUpdateRequestObject != null) if (isBeforeUserListUpdate) this._userListUpdateRequestObject.abort('abortBeforeUserListUpdate');else this._userListUpdateRequestObject.abort();
};

UserListPage.prototype._updateUserListWithDelay = function (delay, spinnerContainerId) {
    this._abortRequestsBeforeUserListUpdate();
    var that = this;
    // Note: if timer will be stopped, then it must be set to null
    this._updateUserListDelayTimer = setTimeout(function () {
        that._updateUserList(spinnerContainerId, true);
        that._updateUserListDelayTimer = null;
    }, delay);
};

UserListPage.prototype._updateUserList = function (spinnerContainerId, showAlertOnReload) {
    this._abortRequestsBeforeUserListUpdate();

    var that = this;
    this._userListUpdateRequestObject = (0, _jquery_rpc2.default)("UserManagementService.getUsers", [this._stateController.getProperty("userListFilter"), this._getSearchUsersTokens(), this._stateController.getProperty("sortBy"), this._stateController.getProperty("isAscending"), this._stateController.getProperty("pageNum"), this._stateController.getProperty("recordsPerPage")], function (pageData) {
        that._spinnerController.stop();

        that._updatePage(pageData, showAlertOnReload);
        that._stateController.saveState();
        (0, _jquery2.default)(".apUserListBottomSpacer").remove();
        (0, _jquery2.default)(".apUserListTopSpacer").remove();
    }, function (jqXHR, textStatus, errorThrown) {
        that._spinnerController.stop();

        if (textStatus == 'abortBeforeUserListUpdate') {
            return true;
        } else {
            that._stateController.loadState();
        }
    });
    this._spinnerController.spin(spinnerContainerId);
};

UserListPage.prototype._getSearchUsersTokens = function () {
    return new StringTokenizer(StringTokenizer.PUNCTUATORS_FOR_SEARCH).getTokens(this._stateController.getProperty('userNameFilterText').toLowerCase());
};

UserListPage.prototype._getUserNameTokensHighlighter = function () {
    var tokens = this._getSearchUsersTokens();
    return tokens && tokens.length > 0 ? new TokensHighlighter(tokens, StringTokenizer.PUNCTUATORS_FOR_SEARCH) : new EmptyHighlighter();
};

UserListPage.prototype._createWarningMsgs = function (userInfo, isCreatingUser) {
    var warnings = userInfo.warnings;
    if (!warnings) return {};

    var warningMsgs = [];
    var infoMsgs = [];
    var errorMsgs = [];

    var fullName = UserNameFormat.formatFML(userInfo.firstName, userInfo.lastName, userInfo.middleInitial);

    for (var i = 0; i < warnings.length; i++) {
        var warningCode = warnings[i];

        if (warningCode == UserListPageConstants.WARNING_ACCOUNT_DISABLED_DUE_TO_LICENSE_TERMS || warningCode == UserListPageConstants.WARNING_ACCOUNT_DISABLED_IN_OTHER_PRODUCT_DUE_TO_LICENSE_TERMS || warningCode == UserListPageConstants.WARNING_ACCOUNT_DISABLED_IN_BOTH_PRODUCTS_DUE_TO_LICENSE_TERMS) {

            var key = warningCode == UserListPageConstants.WARNING_ACCOUNT_DISABLED_DUE_TO_LICENSE_TERMS ? "userlist.js.warning_account_disabled_due_to_license_terms_ap" : warningCode == UserListPageConstants.WARNING_ACCOUNT_DISABLED_IN_OTHER_PRODUCT_DUE_TO_LICENSE_TERMS ? "userlist.js.warning_account_disabled_due_to_license_terms_at" : "userlist.js.warning_account_disabled_due_to_license_terms_both_products";

            var messagePart1 = _messageResource2.default.getEscapedMessage(key, [fullName]);
            var messagePart2 = _messageResource2.default.getEscapedMessage("userlist.js.warning_account_disabled_due_to_license_terms_info", [fullName]);
            warningMsgs.push(messagePart1 + "<p class='sameMsgNewParagraph'>" + messagePart2 + "</p>");
        } else if (warningCode == UserListPageConstants.WARNING_ACCOUNT_DISABLED_DUE_TO_FUTURE_HIRE_DATE) {
            var formattedHireDate = new DateFormat(SystemSettings.dateFormat).formatDate(userInfo.hireDate.parseJSONDate());
            infoMsgs.push(_messageResource2.default.getEscapedMessage("userlist.js.warning_account_disabled_due_to_future_hire_date_ap", [formattedHireDate]));
        } else if (warningCode == UserListPageConstants.WARNING_ACCOUNT_DISABLED_IN_OTHER_PRODUCT_DUE_TO_FUTURE_HIRE_DATE) {
            var formattedHireDate = new DateFormat(SystemSettings.dateFormat).formatDate(userInfo.hireDate.parseJSONDate());
            infoMsgs.push(_messageResource2.default.getEscapedMessage("userlist.js.warning_account_disabled_due_to_future_hire_date_at", [formattedHireDate]));
        } else if (warningCode == UserListPageConstants.WARNING_ACCOUNT_DISABLED_IN_BOTH_PRODUCTS_DUE_TO_FUTURE_HIRE_DATE) {
            var formattedHireDate = new DateFormat(SystemSettings.dateFormat).formatDate(userInfo.hireDate.parseJSONDate());
            infoMsgs.push(_messageResource2.default.getEscapedMessage("userlist.js.warning_account_disabled_due_to_future_hire_date_both_products", [formattedHireDate]));
        } else if (warningCode == UserListPageConstants.WARNING_RELEASE_DATE_IS_BEFORE_HIRE_DATE) {
            errorMsgs.push(_messageResource2.default.getEscapedMessage("user.add_edit.release_date_before_hire_date"));
        } else if (warningCode == UserListPageConstants.WARNING_USER_GROUP_NO_LONGER_EXISTS) {
            warningMsgs.push(_messageResource2.default.getEscapedMessage("userlist.js.warning_user_group_no_longer_exists", [fullName]));
        } else if (warningCode == UserListPageConstants.WARNING_TIME_ZONE_GROUP_NO_LONGER_EXISTS) {
            warningMsgs.push(_messageResource2.default.getEscapedMessage("userlist.js.warning_time_zone_group_no_longer_exists", [fullName]));
        } else if (warningCode == UserListPageConstants.WARNING_NO_RIGHT_TO_EDIT_STATUS_IN_OTHER_PRODUCT) {
            warningMsgs.push(_messageResource2.default.getEscapedMessage(isCreatingUser ? "userlist.js.warning_no_right_to_edit_status_in_at.creating" : "userlist.js.warning_no_right_to_edit_status_in_at.editing"));
        } else throw "Unknown warning code has been received from the server: " + warningCode;
    }

    return { warningMsgs: warningMsgs, infoMsgs: infoMsgs, errorMsgs: errorMsgs };
};

UserListPage.prototype._createEditConfirmationMsg = function (errorThrown) {
    return new UserListConfirmation().createEditConfirmationMsg(errorThrown);
};

UserListPage.prototype._createDeleteConfirmationMsg = function (errorThrown) {
    return new UserListConfirmation().createDeleteConfirmationMsg(errorThrown);
};

UserListPage.prototype._manageDepartmentsPopupClosedAndSmthChanged = function (departmentController) {
    var state = this._stateController.getState();
    this._userGroupIdToGroupMap = {};
    var userIdToGroupIdMap = {};
    var self = this;

    this._allUserGroups = departmentController.storedData;
    _jquery2.default.each(departmentController.storedData, function (index, group) {

        if (group.id != SystemSettings.usersWithoutGroupId) self._userGroupIdToGroupMap[group.id] = group;

        _jquery2.default.each(group.users, function (index, user) {
            userIdToGroupIdMap[user.id] = group.id;
        });
    });

    _ClassicBridge2.default.syncChangesFromClassic().then(function () {
        self._initUserFilter();
    });

    _jquery2.default.each(this._userListBody.find(".userRow"), function (index, row) {
        var record = (0, _jquery2.default)(row).data().record;

        if (!userIdToGroupIdMap[record.id]) //if user was deleted but we see him at user list just skip
            return true; //continue

        record.userGroupId = userIdToGroupIdMap[record.id];

        (0, _jquery2.default)(row).find(".accountTab-userGroupText-div").html(escapeHtmlSymbols(self._getGroupNameForRecord(record)));
    });
};

UserListPage.prototype._manageTimeZoneGroupsPopupClosedAndSmthChanged = function (timeZoneGroupController) {
    var state = this._stateController.getState();
    this._timeZoneGroupIdToGroupMap = {};
    var userIdToGroupIdMap = {};
    var self = this;

    this._allTimeZoneGroups = timeZoneGroupController.storedData;
    _jquery2.default.each(timeZoneGroupController.storedData, function (index, group) {
        self._timeZoneGroupIdToGroupMap[group.id] = group;
        _jquery2.default.each(group.users, function (index, user) {
            userIdToGroupIdMap[user.id] = group.id;
        });
    });

    _ClassicBridge2.default.syncChangesFromClassic().then(function () {
        self._initUserFilter();
    });

    _jquery2.default.each(this._userListBody.find(".userRow"), function (index, row) {
        var record = (0, _jquery2.default)(row).data().record;

        if (!userIdToGroupIdMap[record.id]) //if user was deleted but we see him at user list just skip
            return true; //continue

        record.timeZoneGroupId = userIdToGroupIdMap[record.id];

        (0, _jquery2.default)(row).find(".accountTab-timeZoneGroupText-div").html(escapeHtmlSymbols(self._getTimeZoneGroupNameForRecord(record)));
    });
};

UserListPage.prototype._getUserGroupWrappersList = function (state, previouslySelectedGroupIds) {
    return this._isUGREnabled() ? this._getGroupWrappersList(this._allUserGroups, this._userGroupIdToGroupMap, state.userListFilter.groupType == GroupType.USER_GROUP ? previouslySelectedGroupIds : {}, true, SystemSettings.usersWithoutGroupId) : null;
};

UserListPage.prototype._getTimeZoneGroupWrappersList = function (state, previouslySelectedGroupIds) {
    return this._isTZGEnabled() ? this._getGroupWrappersList(this._allTimeZoneGroups, this._timeZoneGroupIdToGroupMap, state.userListFilter.groupType == GroupType.TIME_ZONE_GROUP ? previouslySelectedGroupIds : {}, false, DEFAULT_TIME_ZONE_GROUP_ID) : null;
};

UserListPage.prototype._groupAssignmentsChangedCallback = function () {
    var userListFilter = this._stateController.getProperty("userListFilter");
    var pageNum = this._stateController.getProperty("pageNum");
    if (userListFilter.groupIds && pageNum === 1) {
        this._pagerController.loadPage(1);
    }
};

UserListPage.prototype._showManageDepartmentsPopup = function (departmentsChangedCallback) {
    this._abortAllRequests();
    if (!this.manageDeparmentsController) {
        this.manageDeparmentsController = new _base_group_management_controller.APUserGroupManagementController();
        GroupManagementUtil.initializeGroupsLightBox(this.manageDeparmentsController, new UserGroupRenderer(), new _group_controller2.default(), new AddGroupController());
    }

    var self = this;

    var afterHideHandler = function afterHideHandler() {
        self.manageDeparmentsController.hideLightboxHandler(function () {
            departmentsChangedCallback(self.manageDeparmentsController);
            self._groupAssignmentsChangedCallback();
        });
    };

    var popup = createLightbox("groupManagementLightBox", afterHideHandler, makeHandler(this.manageDeparmentsController.isPermitToHideLightbox, this.manageDeparmentsController));

    this.manageDeparmentsController.setLightbox(popup);
    this.manageDeparmentsController.initAfterShowing();
};

UserListPage.prototype._showManageTimeZoneGroupsPopup = function (timeZoneGroupsChangedCallback) {
    this._abortAllRequests();
    if (!this.manageTimeZoneGroupsController) {
        this.manageTimeZoneGroupsController = GroupManagementUtil.initializeTimeZoneGroupsLightBox();
    }

    var self = this;

    var afterHideHandler = function afterHideHandler() {
        self.manageTimeZoneGroupsController.hideLightboxHandler(function () {
            timeZoneGroupsChangedCallback(self.manageTimeZoneGroupsController);
            self._groupAssignmentsChangedCallback();
        });
    };

    var popup = createLightbox("timeZoneGroupManagementLightBox", afterHideHandler, makeHandler(this.manageTimeZoneGroupsController.isPermitToHideLightbox, this.manageTimeZoneGroupsController));

    this.manageTimeZoneGroupsController.setLightbox(popup);
    this.manageTimeZoneGroupsController.initAfterShowing();
};

UserListPage.prototype._getGroupWrappersList = function (sortedGroupList, groupIdToNameMap, selectedGroupsArray, includeNullGroup, defaultGroupId) {
    if (!selectedGroupsArray) {
        selectedGroupsArray = [];
    }
    var selectedGroupsSet = {};
    _jquery2.default.each(selectedGroupsArray, function (idx, groupId) {
        selectedGroupsSet[groupId] = true;
    });

    var allGroups = [];
    if (includeNullGroup) {
        allGroups.push({
            id: SystemSettings.usersWithoutGroupId,
            name: _messageResource2.default.getMessage('common.users_without_group')
        });
    }
    allGroups = allGroups.concat(jQuery.map(sortedGroupList, function (group) {
        return groupIdToNameMap[group.id];
    }));

    allGroups = jQuery.map(allGroups, function (group) {
        return {
            id: group.id,
            name: group.name,
            selected: selectedGroupsSet[group.id] === true,
            isDefault: group.id == defaultGroupId
        };
    });

    return allGroups;
};

UserListPage.prototype.getCurrentTime = function (timeZoneGroupId, successCallback, errorCallback) {
    (0, _jquery_rpc2.default)("CurrentTimeInfoService.getCurrentTimeInfo", [timeZoneGroupId], successCallback, errorCallback);
};

/**
 * @static
 */
UserListPage.prototype.removeRow = function (userId) {
    UserListPage.removeRow(this.userIdRowMap[userId]);
};

/**
 * @static
 */
UserListPage.removeRow = function (row) {
    row = (0, _jquery2.default)(row);
    if (row.hasClass("apUserListNewUser")) {
        row.next().remove();
        if (row.prev().hasClass("apUserListTopSpacer") && !row.next().hasClass("apUserListNewUser")) row.prev().remove();
    }

    row.remove();

    PageOverlayTipsManager.getInstance().refreshDynamicTips();
};

exports.default = UserListPage;

/***/ }),
/* 1915 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = EditUserLightBox;

var _LastManagerInfo = __webpack_require__(560);

var _LastManagerInfo2 = _interopRequireDefault(_LastManagerInfo);

var _ConfirmationDialog = __webpack_require__(559);

var _ConfirmationDialog2 = _interopRequireDefault(_ConfirmationDialog);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _UserDataLightBox = __webpack_require__(581);

var _UserDataLightBox2 = _interopRequireDefault(_UserDataLightBox);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _constants = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function EditUserLightBox() {}

EditUserLightBox.prototype = new _UserDataLightBox2.default();

EditUserLightBox.prototype.close_tab_confirmation_message_key = "user.edit.js.close_tab_confirmation";

EditUserLightBox.prototype.init = function (sectionsBuilder, userManagementData, userAccountSettings, user, hasTimeTrack, isLastAdminInAT, isLastAdminInAP, lastLicensesManager, otherProductStatusEditable, lastLoginTime, handlerIfNoSuchUserAfterAjax) {
    this.handlerIfNoSuchUserAfterAjax = function (userId) {
        self.hide();
        if (handlerIfNoSuchUserAfterAjax) {
            handlerIfNoSuchUserAfterAjax(userId);
        }
    };

    _UserDataLightBox2.default.prototype.init.call(this, sectionsBuilder, userManagementData, user.id, userAccountSettings, true, otherProductStatusEditable);

    var self = this;

    this.deleteButton = document.getElementById(this.lightBoxEl.id + "_deleteBtn");
    this.lastLoginInfoPlaceholder = document.getElementById(this.lightBoxEl.id + "_lastLoginInfoPlaceholder");
    this.deleteButton.onclick = function () {
        self.deleteUser();
    };
    this.deleteCallback = null;
    this.dateFormat = SystemSettings.dateFormat;
    this.clockFormat = SystemSettings.clockFormat;

    this.setTitle("");
    this.setNameInTitle(this.formatUserName(user.firstName, user.lastName, user.middleInitial));

    if (isOlVersion) {
        this.setLastLoginInfoInTitle(lastLoginTime != null ? lastLoginTime : _messageResource2.default.getMessage("user.edit.js.never_logged_in"));
    }

    this.setCommitButtonTitle(_messageResource2.default.getMessage("user.edit.js.save_changes"));

    this.validateAll(false);

    this.setDeleteButtonVisibility(true);
    this.updateDeleteButton(hasTimeTrack, isLastAdminInAT, isLastAdminInAP);

    this.cancel_confirmation_message_key = "user.edit.js.cancel_confirmation";

    (0, _jquery2.default)(this.lightBoxEl).addClass("editMode");

    this.user = user;
    this.lastLicensesManager = lastLicensesManager;
    this.accountInformation = this._orderedSectionsList[0];

    return this;
};

EditUserLightBox.prototype.setLastLoginInfoInTitle = function (text) {
    this.lastLoginInfoPlaceholder.innerHTML = '(' + _messageResource2.default.getMessage("user.edit.js.last_login") + ' ' + text + ')';
};

EditUserLightBox.prototype.changesDetected = function () {
    this.getFooterEl().className = this.footerClassName + ' changesDetected';
};

EditUserLightBox.prototype.updateDeleteButton = function (hasTimeTrack, isLastAdminInAT, isLastAdminInAP) {
    if (hasTimeTrack) {
        this.setDeleteButtonEnabled(false, _messageResource2.default.getMessage("user.edit.js.cannot_delete.has_task_record"));
    } else if (isLastAdminInAT) {
        this.setDeleteButtonEnabled(false, _messageResource2.default.getMessage("user.edit.js.cannot_delete.last_admin_at"));
    } else if (isLastAdminInAP) {
        this.setDeleteButtonEnabled(false, _messageResource2.default.getMessage("user.edit.js.cannot_delete.last_admin_ap"));
    } else {
        this.setDeleteButtonEnabled(true);
    }
};

EditUserLightBox.prototype.deleteUser = function () {
    if (this.deleteCallback && confirm(_messageResource2.default.getMessage('userlist.js.confirm_delete_user'))) {
        this.lastLicensesManager ? this.deleteAlert.show() : this.deleteCallback(this.userId);
    }
};

EditUserLightBox.prototype.setDeleteButtonEnabled = function (enabled, tooltip) {
    this.deleteButton.disabled = !enabled;
    if (tooltip) {
        this.deleteButton.title = tooltip;
    } else {
        this.deleteButton.removeAttribute("title");
    }
};

EditUserLightBox.prototype.setDeleteCallback = function (deleteCallback) {
    this.deleteCallback = deleteCallback;
};

EditUserLightBox.prototype.show = function () {
    _UserDataLightBox2.default.prototype.show.call(this);
    this._sectionsBuilder.initAfterShowing(false);
};

/***/ }),
/* 1916 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _OverlayTips = __webpack_require__(86);

var _OverlayTips2 = _interopRequireDefault(_OverlayTips);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function EmailNotificationsPageOverlayTipsManager() {
    PageOverlayTipsManager.call(this);
}

EmailNotificationsPageOverlayTipsManager.prototype = _.create(PageOverlayTipsManager.prototype, {

    addBaseTips: function addBaseTips() {
        PageOverlayTipsManager.prototype.addBaseTips.apply(this);

        this.add($(".showCollapsibleBlockButton:eq(1)"), {
            messageKey: "tips.expand_section",
            direction: _OverlayTips2.default.DIRECTION_TOP_RIGHT,
            offsetX: 0,
            offsetY: -10
        });

        this.add($("#requestApproversBlockButton").parent(), {
            messageKey: "mail_notification.tips.settings.approvers",
            direction: _OverlayTips2.default.DIRECTION_TOP_LEFT,
            offsetX: 10,
            offsetY: -20,
            outside: {
                direction: _OverlayTips2.default.DIRECTION_TOP_RIGHT,
                anchor: _OverlayTips2.default.DIRECTION_TOP_LEFT,
                offsetX: 150,
                offsetY: 10
            }
        });

        this.add($("#regularUsersBlockButton").parent(), {
            messageKey: "mail_notification.tips.settings.regular_users",
            direction: _OverlayTips2.default.DIRECTION_TOP_LEFT,
            offsetX: 10,
            offsetY: -20,
            outside: {
                direction: _OverlayTips2.default.DIRECTION_TOP_RIGHT,
                anchor: _OverlayTips2.default.DIRECTION_TOP_LEFT,
                offsetX: 210,
                offsetY: -15
            }
        });

        this.add($("#messageParametersBlockButton").parent(), {
            messageKey: "mail_notification.tips.settings.message",
            direction: _OverlayTips2.default.DIRECTION_TOP_LEFT,
            offsetX: 10,
            offsetY: -20,
            outside: {
                direction: _OverlayTips2.default.DIRECTION_TOP_RIGHT,
                anchor: _OverlayTips2.default.DIRECTION_TOP_LEFT,
                offsetX: 120,
                offsetY: -10
            }
        });

        this.add($("#errorProcessingBlockButton").parent(), {
            messageKey: "mail_notification.tips.settings.error",
            direction: _OverlayTips2.default.DIRECTION_TOP_LEFT,
            offsetX: 10,
            offsetY: -20,
            outside: {
                direction: _OverlayTips2.default.DIRECTION_TOP_RIGHT,
                anchor: _OverlayTips2.default.DIRECTION_TOP_LEFT,
                offsetX: 160,
                offsetY: -20
            }
        });
    }
});

exports.default = EmailNotificationsPageOverlayTipsManager;

/***/ }),
/* 1917 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ApTipsUtils = __webpack_require__(956);

var _ApTipsUtils2 = _interopRequireDefault(_ApTipsUtils);

var _OverlayTips = __webpack_require__(86);

var _OverlayTips2 = _interopRequireDefault(_OverlayTips);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function LeaveTimePlanningPageOverlayTipsManager() {
    PageOverlayTipsManager.call(this);
}

LeaveTimePlanningPageOverlayTipsManager.prototype = _.create(PageOverlayTipsManager.prototype, {
    $tipNotApproved: (0, _jquery2.default)(),
    $tipApproved: (0, _jquery2.default)(),

    addBaseTips: function addBaseTips() {
        PageOverlayTipsManager.prototype.addBaseTips.apply(this);

        // Leave Time Requests tab
        this.add((0, _jquery2.default)("#leaveTimePlanningPage").find('.customHeaderTabs .tab').eq(1).find(".textTab"), {
            messageKey: "leave_time_planning.tips.tab.request",
            direction: _OverlayTips2.default.DIRECTION_TOP_RIGHT,
            offsetX: 7,
            offsetY: 0
        });

        // Sorting parameters
        this.add((0, _jquery2.default)("#tipLTPSorting"), {
            messageKey: "leave_time_planning.tips.sorting",
            direction: _OverlayTips2.default.DIRECTION_TOP_LEFT,
            offsetX: 5,
            offsetY: -10,
            outside: {
                direction: _OverlayTips2.default.DIRECTION_TOP_RIGHT,
                offsetX: 0,
                offsetY: 5
            }
        });

        // BalancesViewer
        // noinspection DuplicatedCode Copy from MySchedulePageOverlayTipsManager
        this.add(function () {
            var $elem = (0, _jquery2.default)('#balancesViewerPlaceholder').find('.balancesViewer');
            var isPto = $elem.hasClass("showPTO");
            var isSick = $elem.hasClass("showSick");
            if (!isPto && !isSick) //don't show the tip
                {
                    $elem = (0, _jquery2.default)();
                    $elem.config = {};
                } else {
                var messageKey = isPto && isSick ? "my_schedule.tips.balances_viewer" : isPto ? "my_schedule.tips.pto_balance_viewer" : "my_schedule.tips.sick_balance_viewer";
                $elem.config = {
                    messageKey: messageKey,
                    direction: _OverlayTips2.default.DIRECTION_TOP_LEFT,
                    offsetX: -6,
                    offsetY: -7
                };
            }
            return $elem;
        });

        this.add(_.bind(this._leaveWaitingApprovalTip, this));
        this.add(_.bind(this._leaveApprovedTip, this));
    },

    refreshDynamicTips: function refreshDynamicTips(animated) {
        if (this.enabled) _ApTipsUtils2.default.setLeaveChartTableTips(this, (0, _jquery2.default)('#leaveTimePlanningTablePlaceholder'));

        PageOverlayTipsManager.prototype.refreshDynamicTips.call(this, animated);
    },

    _leaveWaitingApprovalTip: function _leaveWaitingApprovalTip() {
        this.$tipNotApproved.config = _.defaults(this.$tipNotApproved.config || {}, {
            messageKey: "leave_time_planning.tips.waiting_approval",
            noFirstTimeAnimation: true,
            offsetX: -5,
            offsetY: 10
        });

        return this.$tipNotApproved;
    },

    _leaveApprovedTip: function _leaveApprovedTip() {
        this.$tipApproved.config = _.defaults(this.$tipApproved.config || {}, {
            noFirstTimeAnimation: true,
            messageKey: "leave_time_planning.tips.approved",
            offsetX: -5,
            offsetY: 10
        });

        return this.$tipApproved;
    }
});

exports.default = LeaveTimePlanningPageOverlayTipsManager;

/***/ }),
/* 1918 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _OverlayTips = __webpack_require__(86);

var _OverlayTips2 = _interopRequireDefault(_OverlayTips);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function LeaveTimeRequestPageOverlayTipsManager() {
    PageOverlayTipsManager.call(this);
}

LeaveTimeRequestPageOverlayTipsManager.prototype = _.create(PageOverlayTipsManager.prototype, {

    addBaseTips: function addBaseTips() {
        PageOverlayTipsManager.prototype.addBaseTips.apply(this);

        // Sorting parameters
        this.add($("#tipLTRSorting"), {
            messageKey: "leave_time_requests.tips.sorting",
            direction: _OverlayTips2.default.DIRECTION_TOP_LEFT,
            offsetX: 5,
            offsetY: -10,
            outside: {
                direction: _OverlayTips2.default.DIRECTION_TOP_RIGHT,
                offsetX: 0,
                offsetY: 5
            }
        });

        this.add(function () {
            var ret = $("#requestsTableContainer").find(".leaveType.has-comment .leaveTypeWithImg");
            if (ret.length > 0) ret = $(ret[ret.length >> 1]);
            return ret;
        }, {
            messageKey: "leave_time_requests.tips.leave_comment",
            direction: _OverlayTips2.default.DIRECTION_TOP_RIGHT,
            offsetX: 20,
            offsetY: -5
        });

        function rejectCommentTip() {
            return $("#requestsTableContainer").find('td.status.rejected.has-comment .byWhom');
        }

        this.add(rejectCommentTip, {
            messageKey: "leave_time_requests.tips.reject_comment",
            direction: _OverlayTips2.default.DIRECTION_BOTTOM_LEFT,
            anchor: _OverlayTips2.default.DIRECTION_BOTTOM_RIGHT,
            offsetX: -5,
            offsetY: 5
        });

        this.add(function () {
            return $("#requestsTableContainer").find('.actualContent').find('.request:not(.notApprovable)').find("td.select input").eqOrLast(3);
        }, {
            messageKey: "leave_time_requests.tips.select_checkbox",
            direction: _OverlayTips2.default.DIRECTION_TOP_LEFT,
            offsetX: -5,
            offsetY: -5
        });
    }
});

exports.default = LeaveTimeRequestPageOverlayTipsManager;

/***/ }),
/* 1919 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _OverlayTips = __webpack_require__(86);

var _OverlayTips2 = _interopRequireDefault(_OverlayTips);

var _PageOverlayTipsManager = __webpack_require__(408);

var _PageOverlayTipsManager2 = _interopRequireDefault(_PageOverlayTipsManager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function LeaveTypesPageOverlayTipsManager(ptoEnabled, sickEnabled) {
    _PageOverlayTipsManager2.default.call(this);
    this.ptoEnabled = ptoEnabled;
    this.sickEnabled = sickEnabled;
}

LeaveTypesPageOverlayTipsManager.prototype = _underscore2.default.create(_PageOverlayTipsManager2.default.prototype, {
    addBaseTips: function addBaseTips() {
        _PageOverlayTipsManager2.default.prototype.addBaseTips.apply(this);

        this.add((0, _jquery2.default)(".pageTitleWithSharedSettingsImage"), {
            messageKey: "tips.leave_types.title",
            direction: _OverlayTips2.default.DIRECTION_TOP_LEFT,
            offsetX: 10,
            offsetY: -10,
            outside: {
                direction: _OverlayTips2.default.DIRECTION_TOP_RIGHT,
                offsetY: 0
            }
        });

        this._addTableTips(window.SystemSettings.apPtoBalanceCalculationEnabled, window.SystemSettings.apSickBalanceCalculationEnabled);
    },

    _addTableTips: function _addTableTips(ptoEnabled, sickEnabled) {

        this.add(function () {
            if ((0, _jquery2.default)("#leaveTypeListTableContainer").find(".leaveTypeListRow").length < 2) {
                return (0, _jquery2.default)();
            }
            var $element = (0, _jquery2.default)("#leaveTypesListTableHeader").find(".leaveTypeChangeOrderCell");
            $element.config = {
                messageKey: "tips.leave_types.order",
                direction: _OverlayTips2.default.DIRECTION_TOP_LEFT,
                offsetX: -20,
                offsetY: -100,
                wrapInner: true,
                outside: {
                    direction: _OverlayTips2.default.DIRECTION_BOTTOM_RIGHT,
                    offsetY: 100
                }
            };
            return $element;
        });

        this.add(function () {
            return (0, _jquery2.default)("td.leaveTypeImageCell:gt(0)").eqOrLast(2);
        }, {
            messageKey: "tips.leave_types.icon",
            direction: _OverlayTips2.default.DIRECTION_TOP_RIGHT,
            offsetX: -20,
            offsetY: -10
        });

        this.add(function () {
            return (0, _jquery2.default)("td.leaveTypeStatusCell").eqOrLast(6);
        }, {
            messageKey: "tips.leave_type.change_status",
            direction: _OverlayTips2.default.DIRECTION_BOTTOM_RIGHT,
            offsetX: -40,
            offsetY: 10
        });

        var leaveTypeAffectedBalanceTipMessageKey = null;
        if (ptoEnabled && sickEnabled) {
            leaveTypeAffectedBalanceTipMessageKey = "tips.leave_types.pto_sick_days";
        } else if (ptoEnabled) {
            leaveTypeAffectedBalanceTipMessageKey = "tips.leave_types.pto";
        } else if (sickEnabled) {
            leaveTypeAffectedBalanceTipMessageKey = "tips.leave_types.sick";
        }

        if (leaveTypeAffectedBalanceTipMessageKey != null) {
            this.add(function () {
                return (0, _jquery2.default)("td.leaveTypeAffectedBalanceCell").eqOrLast(1);
            }, {
                messageKey: leaveTypeAffectedBalanceTipMessageKey,
                direction: _OverlayTips2.default.DIRECTION_TOP_RIGHT,
                offsetX: -40
            });
        }
    }
});

exports.default = LeaveTypesPageOverlayTipsManager;

/***/ }),
/* 1920 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _OverlayTips = __webpack_require__(86);

var _OverlayTips2 = _interopRequireDefault(_OverlayTips);

var _ApTipsUtils = __webpack_require__(956);

var _ApTipsUtils2 = _interopRequireDefault(_ApTipsUtils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function MySchedulePageOverlayTipsManager() {
    PageOverlayTipsManager.call(this);
}

MySchedulePageOverlayTipsManager.prototype = _.create(PageOverlayTipsManager.prototype, {

    $tipNotApproved: $(),
    $tipApproved: $(),
    $tipLeaveStatus: $(),

    addBaseTips: function addBaseTips() {
        PageOverlayTipsManager.prototype.addBaseTips.apply(this);

        // Requests tab
        this.add(function () {
            // if request tab can be disabled then we can check $('#2.disabled').length == 1 and return empty jquery object $()
            return $('#1.selected').find('.tabContainer');
        }, {
            messageKey: "my_schedule.tips.tab.request",
            direction: _OverlayTips2.default.DIRECTION_TOP_RIGHT,
            offsetX: 105,
            offsetY: -5
        });

        // BalancesViewer
        this.add(function () {
            var $elem = $('#balancesViewerPlaceholder').find('.balancesViewer');
            var isPto = $elem.hasClass("showPTO");
            var isSick = $elem.hasClass("showSick");
            if (!isPto && !isSick) //don't show the tip
                {
                    $elem = $();
                    $elem.config = {};
                } else {
                var messageKey = isPto && isSick ? "my_schedule.tips.balances_viewer" : isPto ? "my_schedule.tips.pto_balance_viewer" : "my_schedule.tips.sick_balance_viewer";
                $elem.config = {
                    messageKey: messageKey,
                    direction: _OverlayTips2.default.DIRECTION_TOP_LEFT,
                    offsetX: -6,
                    offsetY: -7
                };
            }
            return $elem;
        });

        // Schedule Tab content

        // click to date
        function clickToDateTipPosition() {
            var dayCells = $('#myScheduleTableContainer').find('.firstRow .dayCell');

            var checkCell = function checkCell($cell) {
                return $cell.hasClass('noLeave') && !$cell.hasClass('nonWorking') && !$cell.hasClass('pastDay');
            };

            var increaseIteration = function increaseIteration(from, to) {
                for (var i = from; i <= to; i++) {
                    var $cell = $(dayCells[i]);
                    if (checkCell($cell)) {
                        return $cell;
                    }
                }
            };

            var decreaseIteration = function decreaseIteration(from, to) {
                for (var i = to; i >= from; i--) {
                    var $cell = $(dayCells[i]);
                    if (checkCell($cell)) {
                        return $cell;
                    }
                }
            };

            var result = decreaseIteration(0, dayCells.length - 16);
            if (!_.isUndefined(result)) return result;

            result = increaseIteration(dayCells.length - 15, dayCells.length - 1);
            if (!_.isUndefined(result)) return result;

            return $();
        }

        this.add(clickToDateTipPosition, {
            messageKey: "my_schedule.tips.schedule.new_leave",
            direction: _OverlayTips2.default.DIRECTION_BOTTOM_RIGHT,
            offsetX: -5,
            offsetY: 3
        });

        this.add(_.bind(this._leaveWaitingApprovalTip, this));
        this.add(_.bind(this._leaveApprovedTip, this));
        this.add(_.bind(this._leaveStatusTip, this));

        // Requests tab content

        this.add(function () {
            return $('#leaveRequestsTable').find('.leaveTypeCell .sortingLink');
        }, {
            messageKey: "my_schedule.tips.request.sort.leave_type",
            direction: _OverlayTips2.default.DIRECTION_BOTTOM_RIGHT,
            offsetX: -35,
            offsetY: 10
        });

        this.add(function () {
            return $('#leaveRequestsTable').find('.periodCell .sortingLink');
        }, {
            messageKey: "my_schedule.tips.request.sort.period",
            direction: _OverlayTips2.default.DIRECTION_BOTTOM_RIGHT,
            offsetX: -5,
            offsetY: 3
        });

        this.add(function () {
            return $('#leaveRequestsTable').find('.statusCell .sortingLink');
        }, {
            messageKey: "my_schedule.tips.request.sort.status",
            direction: _OverlayTips2.default.DIRECTION_TOP_RIGHT,
            offsetX: -5,
            offsetY: 3
        });

        this.add(function () {
            return $('#leaveRequestsTable').find('.balanceTypeFilterBlock table');
        }, {
            messageKey: "my_schedule.tips.request.filter.balances",
            direction: _OverlayTips2.default.DIRECTION_TOP_RIGHT,
            offsetX: -160,
            offsetY: 25
        });
    },

    refreshDynamicTips: function refreshDynamicTips(animated) {
        if (this.enabled) {
            // if we on Schedule tab
            if ($('#1.selected').length == 1) _ApTipsUtils2.default.setLeaveChartTableTips(this, $('#colleaguesTable'));
        }

        PageOverlayTipsManager.prototype.refreshDynamicTips.call(this, animated);
    },

    _leaveWaitingApprovalTip: function _leaveWaitingApprovalTip() {
        this.$tipNotApproved.config = _.defaults(this.$tipNotApproved.config || {}, {
            messageKey: "my_schedule.tips.schedule.waiting_approval",
            noFirstTimeAnimation: true,
            offsetX: -5,
            offsetY: 10
        });

        return this.$tipNotApproved;
    },

    _leaveApprovedTip: function _leaveApprovedTip() {
        this.$tipApproved.config = _.defaults(this.$tipApproved.config || {}, {
            messageKey: "my_schedule.tips.schedule.approved",
            noFirstTimeAnimation: true,
            offsetX: -5,
            offsetY: 10
        });

        return this.$tipApproved;
    },

    _leaveStatusTip: function _leaveStatusTip() {
        this.$tipLeaveStatus.config = _.defaults(this.$tipLeaveStatus.config || {}, {
            messageKey: "my_schedule.tips.schedule.leave_status",
            anchor: _OverlayTips2.default.DIRECTION_TOP_RIGHT,
            noFirstTimeAnimation: true,
            offsetX: 0,
            offsetY: 30
        });

        return this.$tipLeaveStatus;
    }
});

exports.default = MySchedulePageOverlayTipsManager;

/***/ }),
/* 1921 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _OverlayTips = __webpack_require__(86);

var _OverlayTips2 = _interopRequireDefault(_OverlayTips);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function SettingsPageOverlayTipsManager() {
    PageOverlayTipsManager.call(this);
}

SettingsPageOverlayTipsManager.prototype = _.create(PageOverlayTipsManager.prototype, {

    addBaseTips: function addBaseTips() {
        PageOverlayTipsManager.prototype.addBaseTips.apply(this);

        this.add($(".collapsibleGroupHeader").eqOrLast(1), {
            messageKey: "tips.expand_section",
            direction: _OverlayTips2.default.DIRECTION_TOP_RIGHT,
            offsetX: 0,
            offsetY: -10
        });

        this.add($(".productsIntegrated .sharedImage").eq(1), {
            messageKey: "tips.shared_settings",
            direction: _OverlayTips2.default.DIRECTION_TOP_RIGHT,
            offsetX: 0,
            offsetY: 0
        });

        this.add($("#userGroupsSettingsBlockButton").parent(), {
            messageKey: "general_settings.tips.user_groups",
            direction: _OverlayTips2.default.DIRECTION_TOP_LEFT,
            offsetX: 10,
            offsetY: -20,
            outside: {
                direction: _OverlayTips2.default.DIRECTION_TOP_RIGHT,
                anchor: _OverlayTips2.default.DIRECTION_TOP_LEFT,
                offsetX: 120,
                offsetY: 10
            }
        });

        this.add($("#dateTimeSettingsBlockButton").parent(), {
            messageKey: "general_settings.tips.time_zone_and_calendar",
            direction: _OverlayTips2.default.DIRECTION_TOP_LEFT,
            offsetX: 10,
            offsetY: -20,
            outside: {
                direction: _OverlayTips2.default.DIRECTION_TOP_RIGHT,
                anchor: _OverlayTips2.default.DIRECTION_TOP_LEFT,
                offsetX: 40,
                offsetY: -12
            }
        });

        this.add($("#ptoAndSickBlockSectionButton").parent(), {
            messageKey: "general_settings.tips.balances",
            direction: _OverlayTips2.default.DIRECTION_TOP_LEFT,
            offsetX: 10,
            offsetY: -20,
            outside: {
                direction: _OverlayTips2.default.DIRECTION_TOP_RIGHT,
                anchor: _OverlayTips2.default.DIRECTION_TOP_LEFT,
                offsetX: 210,
                offsetY: -5
            }
        });

        this.add($("#scheduleBlockButton").parent(), {
            messageKey: "general_settings.tips.work_schedule",
            direction: _OverlayTips2.default.DIRECTION_TOP_LEFT,
            offsetX: 10,
            offsetY: -20,
            outside: {
                direction: _OverlayTips2.default.DIRECTION_TOP_RIGHT,
                anchor: _OverlayTips2.default.DIRECTION_TOP_LEFT,
                offsetX: 200,
                offsetY: -5
            }
        });

        this.add($("#personalSchedulesVisibilityBlockButton").parent(), {
            messageKey: "general_settings.tips.access_schedule",
            direction: _OverlayTips2.default.DIRECTION_TOP_LEFT,
            offsetX: 10,
            offsetY: -20,
            outside: {
                direction: _OverlayTips2.default.DIRECTION_TOP_RIGHT,
                anchor: _OverlayTips2.default.DIRECTION_TOP_LEFT,
                offsetX: 220,
                offsetY: 0
            }
        });

        this.add($("#ltmAccessBlockButton").parent(), {
            messageKey: "general_settings.tips.access_ltm",
            direction: _OverlayTips2.default.DIRECTION_TOP_LEFT,
            offsetX: 10,
            offsetY: -20,
            outside: {
                direction: _OverlayTips2.default.DIRECTION_TOP_RIGHT,
                anchor: _OverlayTips2.default.DIRECTION_TOP_LEFT,
                offsetX: 290,
                offsetY: -20
            }
        });

        // TODO: add after making "Automatic leave request processing" section
        // this.add($("#...").parent(), {
        //     messageKey: "general_settings.tips.auto_processing",
        //     direction: OverlayTips.DIRECTION_TOP_LEFT,
        //     offsetX: 10,
        //     offsetY: -20,
        //     outside: {
        //         direction: OverlayTips.DIRECTION_TOP_RIGHT,
        //         anchor: OverlayTips.DIRECTION_TOP_LEFT,
        //         offsetX: 230,
        //         offsetY: -5
        //     }
        // });

        this.add($("#formatsSettingsBlockButton").parent(), {
            messageKey: "general_settings.tips.number_format",
            direction: _OverlayTips2.default.DIRECTION_TOP_LEFT,
            offsetX: 10,
            offsetY: -20,
            outside: {
                direction: _OverlayTips2.default.DIRECTION_TOP_RIGHT,
                anchor: _OverlayTips2.default.DIRECTION_TOP_LEFT,
                offsetX: 150,
                offsetY: -25
            }
        });
    }
});

exports.default = SettingsPageOverlayTipsManager;

/***/ }),
/* 1922 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _OverlayTips = __webpack_require__(86);

var _OverlayTips2 = _interopRequireDefault(_OverlayTips);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function UserListPageOverlayTipsManager(config) {
    PageOverlayTipsManager.call(this);
    this.config = config;
}

UserListPageOverlayTipsManager.prototype = _.create(PageOverlayTipsManager.prototype, {

    addBaseTips: function addBaseTips() {
        PageOverlayTipsManager.prototype.addBaseTips.apply(this);

        this.add(this._createGetElementIfAccountSettingSelectedFunction($("#userListTableHeaderCell_filterCell").find(".userList_accountEnabledFilter-label")), {
            messageKey: "userlist.tips.show_disabled",
            direction: _OverlayTips2.default.DIRECTION_BOTTOM_RIGHT,
            anchor: _OverlayTips2.default.DIRECTION_TOP_LEFT,
            offsetX: 20,
            offsetY: 20
        });

        this.add(function () {
            var $tabAccountSettings = $("#tabAccountSettings");
            if ($tabAccountSettings.length == 0 || $tabAccountSettings.hasClass("selected")) {
                var $element = $("#userListPageContent.allowedToManageAccountSettings").find(".bulkInvitationsButton");
                if (!$element.hasClass("buttonIsDisabled")) {
                    $element.config = {
                        messageKey: "userlist.tips.add_users",
                        direction: _OverlayTips2.default.DIRECTION_TOP_RIGHT,
                        offsetX: 10,
                        offsetY: 0
                    };
                    if (!$("#licenseCountId").hasClass("licenseShown")) {
                        $element.config.offsetX = -50;
                        $element.config.offsetY = 15;
                    }
                    return $element;
                }
            }
            var $emptyObject = $();
            $emptyObject.config = {};
            return $emptyObject;
        });

        var permissionsSelector = ".actualContent .activeButton." + (this.isPTOEnabled() || this.isSickEnabled() ? "accountTab-manageBalance-td" : "accountTab-manageAccounts-td");

        this.add(function () {
            return $("#userListTable").find(permissionsSelector).eqOrLast(4);
        }, {
            messageKey: "userlist.tips.account_section.permissions",
            direction: _OverlayTips2.default.DIRECTION_BOTTOM_RIGHT,
            offsetX: -40,
            offsetY: 5
        });

        this.add(function () {
            return $("#userListTable").find(".accountTab-usersForApproverSelector-td.activeButton").eqOrLast(1);
        }, {
            messageKey: "userlist.tips.account_section.assigned_users",
            direction: _OverlayTips2.default.DIRECTION_BOTTOM_RIGHT,
            offsetX: -50,
            offsetY: 10
        });

        this._addBalanceTips({
            tabCellSelector: ".actualContent .ptoTabCell",
            changeBalanceMessageKey: "userlist.tips.pto_section.change_balance",
            changeStateMessageKey: "userlist.tips.pto_section.change_state"
        });

        this._addBalanceTips({
            tabCellSelector: ".actualContent .sickDaysTabCell",
            changeBalanceMessageKey: "userlist.tips.sick_section.change_balance",
            changeStateMessageKey: "userlist.tips.sick_section.change_state"
        });

        this._addTipsForTabs();
    },

    _addBalanceTips: function _addBalanceTips(config) {
        this.add(function () {
            return $("#userListTable").find(config.tabCellSelector + ".balance-td .balanceText-span:not(:empty)").eqOrLast(1);
        }, {
            messageKey: config.changeBalanceMessageKey,
            direction: _OverlayTips2.default.DIRECTION_BOTTOM_LEFT,
            offsetX: -10,
            offsetY: 12
        });

        this.add(function () {
            var $accrueRule = $("#userListTable").find(config.tabCellSelector + ".accrueRule-td:not(:empty)").eqOrLast(7);
            var isDefaultRules = $accrueRule.attr("colspan") == 3;
            $accrueRule.config = {
                messageKey: "userlist.tips.balances.accrual_rules",
                direction: _OverlayTips2.default.DIRECTION_BOTTOM_RIGHT,
                offsetX: isDefaultRules ? -130 : -40,
                offsetY: 10
            };
            return $accrueRule;
        });

        this.add(function () {
            return $("#userListTable").find(config.tabCellSelector + ".userBalanceEnabled-td").eqOrLast(5);
        }, {
            messageKey: config.changeStateMessageKey,
            direction: _OverlayTips2.default.DIRECTION_BOTTOM_RIGHT,
            offsetX: -20,
            offsetY: 5
        });
    },

    _addTipsForTabs: function _addTipsForTabs() {
        if (!(this.isPTOEnabled() || this.isSickEnabled())) return;

        var messageKey;
        var selector;
        var offsetX = 0;

        if (this.isPTOEnabled()) {
            if (this.isSickEnabled()) {
                selector = "#tabSickDaysSettings .titleSeparator";
                messageKey = "userlist.tips.tabs.balances";
            } else {
                selector = "#tabPTOSettings";
                messageKey = "userlist.tips.tabs.pto";
                offsetX = -50;
            }
        } else {
            selector = "#tabSickDaysSettings";
            messageKey = "userlist.tips.tabs.sick";
            offsetX = -50;
        }

        this.add(this._createGetElementIfAccountSettingSelectedFunction($(selector)), {
            messageKey: messageKey,
            direction: _OverlayTips2.default.DIRECTION_TOP_RIGHT,
            offsetX: offsetX,
            offsetY: 15
        });
    },

    isPTOEnabled: function isPTOEnabled() {
        return this.config.ptoEnabled;
    },

    isSickEnabled: function isSickEnabled() {
        return this.config.sickEnabled;
    },

    isUserGroupsEnabled: function isUserGroupsEnabled() {
        return this.config.ugrEnabled;
    },

    isTimeZoneGroupsEnabled: function isTimeZoneGroupsEnabled() {
        return this.config.tzgEnabled;
    },

    _createGetElementIfAccountSettingSelectedFunction: function _createGetElementIfAccountSettingSelectedFunction($element) {
        return function () {
            var $tabAccountSettings = $("#tabAccountSettings");
            return $tabAccountSettings.length == 0 || $tabAccountSettings.hasClass("selected") ? $element : $();
        };
    }
});

exports.default = UserListPageOverlayTipsManager;

/***/ }),
/* 1923 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _OverlayTips = __webpack_require__(86);

var _OverlayTips2 = _interopRequireDefault(_OverlayTips);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function LeaveTimeBalancesPageOverlayTipsManager() {
    PageOverlayTipsManager.call(this);
    this._refreshDynamicTipsDeferred = true;
}

LeaveTimeBalancesPageOverlayTipsManager.prototype = _.create(PageOverlayTipsManager.prototype, {

    addBaseTips: function addBaseTips() {
        PageOverlayTipsManager.prototype.addBaseTips.apply(this);

        this.add($("#pastLeavesCalendarTab"), {
            messageKey: "actiplans.reports.leave_time.tips.past_leaves_calendar_tab",
            direction: _OverlayTips2.default.DIRECTION_TOP_RIGHT,
            offsetX: -75,
            offsetY: 15
        });

        this.add($("#balanceHistoryTab").not(".disabled"), {
            messageKey: "actiplans.reports.leave_time.tips.balance_history_tab",
            direction: _OverlayTips2.default.DIRECTION_TOP_RIGHT,
            offsetX: -20,
            offsetY: 5
        });

        this.add($("#leaveTimeAndBalancesChartSectionContainer").find('.collapseButton'), {
            messageKey: "actiplans.reports.leave_time.tips.chart_button",
            direction: _OverlayTips2.default.DIRECTION_TOP_RIGHT,
            offsetX: 0,
            offsetY: -5
        });

        this.add($("#leaveTimeEditConfigSelector"), {
            messageKey: "actiplans.reports.tips.edit_config_button",
            direction: _OverlayTips2.default.DIRECTION_BOTTOM_RIGHT,
            offsetX: -100,
            offsetY: 15
        });

        this.add($("#leaveTimeExportSelector"), {
            messageKey: "actiplans.reports.tips.export",
            direction: _OverlayTips2.default.DIRECTION_TOP_LEFT,
            offsetX: -40,
            offsetY: 15
        });
    }
});

exports.default = LeaveTimeBalancesPageOverlayTipsManager;

/***/ }),
/* 1924 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _OverlayTips = __webpack_require__(86);

var _OverlayTips2 = _interopRequireDefault(_OverlayTips);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function BalanceHistoryPageOverlayTipsManager() {
    PageOverlayTipsManager.call(this);
    this._refreshDynamicTipsDeferred = true;
}

BalanceHistoryPageOverlayTipsManager.prototype = _.create(PageOverlayTipsManager.prototype, {

    addBaseTips: function addBaseTips() {
        PageOverlayTipsManager.prototype.addBaseTips.apply(this);

        this.add($("#balanceHistory_userSelector"), {
            messageKey: "actiplans.reports.balance_history.tips.user_selector",
            direction: _OverlayTips2.default.DIRECTION_TOP_LEFT,
            offsetX: -250,
            offsetY: -5
        });

        this.add($("#balanceHistory_typeSelector"), {
            messageKey: "actiplans.reports.balance_history.tips.balance_type_selector",
            direction: _OverlayTips2.default.DIRECTION_BOTTOM_RIGHT,
            offsetX: -120,
            offsetY: 11
        });

        this.add(function () {
            var $balanceHistoryPage = $("#balanceHistoryPage");
            if ($balanceHistoryPage.hasClass("sickControlOffWarn") || $balanceHistoryPage.hasClass("ptoControlOffWarn")) {
                return $();
            }
            return $("#balanceHistoryExportSelector");
        }, {
            messageKey: "actiplans.reports.tips.export",
            direction: _OverlayTips2.default.DIRECTION_TOP_LEFT,
            offsetX: -40,
            offsetY: 15
        });
    }
});

exports.default = BalanceHistoryPageOverlayTipsManager;

/***/ }),
/* 1925 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _OverlayTips = __webpack_require__(86);

var _OverlayTips2 = _interopRequireDefault(_OverlayTips);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function PastLeavesPageOverlayTipsManager() {
    PageOverlayTipsManager.call(this);
    this._refreshDynamicTipsDeferred = true;
}

PastLeavesPageOverlayTipsManager.prototype = _.create(PageOverlayTipsManager.prototype, {

    addBaseTips: function addBaseTips() {
        PageOverlayTipsManager.prototype.addBaseTips.apply(this);

        this.add($("#pastLeaveExportSelector"), {
            messageKey: "actiplans.reports.tips.export",
            direction: _OverlayTips2.default.DIRECTION_TOP_LEFT,
            offsetX: -40,
            offsetY: 15
        });

        this.add($("#leaveTypeFilter"), {
            messageKey: "actiplans.reports.past_leaves_calendar.tips.leave_types_filter",
            direction: _OverlayTips2.default.DIRECTION_BOTTOM_RIGHT,
            offsetX: -50,
            offsetY: 15
        });

        this.add($('#leaveTimeHistoryHeaderSelectors').find(".monthRangeSelector .selectorDescription"), {
            messageKey: "actiplans.reports.past_leaves_calendar.tips.date_range",
            direction: _OverlayTips2.default.DIRECTION_BOTTOM_RIGHT,
            offsetX: -16,
            offsetY: 11
        });

        this.add($("#sliderButton").find(".sliderImg"), {
            messageKey: "actiplans.reports.past_leaves_calendar.tips.details_button",
            direction: _OverlayTips2.default.DIRECTION_TOP_LEFT,
            offsetX: 0,
            offsetY: 0,
            outside: {
                direction: _OverlayTips2.default.DIRECTION_TOP_RIGHT,
                offsetX: 0,
                offsetY: 0
            }
        });

        this.add($("#leaveTimeTable").find(".period.sortHeader"), {
            messageKey: "actiplans.reports.past_leaves_calendar.tips.sorting",
            direction: _OverlayTips2.default.DIRECTION_TOP_RIGHT,
            anchor: _OverlayTips2.default.DIRECTION_TOP_LEFT,
            offsetX: 50,
            offsetY: 20
        });
    }
});

exports.default = PastLeavesPageOverlayTipsManager;

/***/ }),
/* 1926 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _InviteSeveralUsersLightBox = __webpack_require__(863);

var _InviteSeveralUsersLightBox2 = _interopRequireDefault(_InviteSeveralUsersLightBox);

var _InviteSeveralUsersRow = __webpack_require__(861);

var _InviteSeveralUsersRow2 = _interopRequireDefault(_InviteSeveralUsersRow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function APInviteSeveralUsersLightBox() {}

APInviteSeveralUsersLightBox.prototype = _underscore2.default.create(_InviteSeveralUsersLightBox2.default.prototype, {
    init: function init(inviteUsersData) {
        _InviteSeveralUsersLightBox2.default.prototype.init.call(this, inviteUsersData);
        return this;
    },

    _generateTable: function _generateTable() {
        this.rows = [];
        var $tableContainer = this.innerContent.find(".tableContainer");
        $tableContainer.empty();
        var $table = (0, _jquery2.default)('<table>');
        for (var i = 0; i < this.INITIAL_NUMBER_OF_ROWS; i++) {
            this._addRow($table, i, i === 0 ? "firstRow" : i === this.INITIAL_NUMBER_OF_ROWS - 1 ? "lastRow" : "");
        }
        $tableContainer.append($table);
    },

    _addEmptyRows: function _addEmptyRows(number) {
        if (this.rows.length + number > 10) {
            (0, _jquery2.default)(this.lightBoxEl).addClass("scrollable");
        }
        var rowCount = this.rows.length;
        this.rows[rowCount - 1].setSpecialRowClasses("");
        var $table = this.innerContent.find(".tableContainer table");
        for (var i = 0; i < number; i++) {
            this._addRow($table, i + rowCount, i == number - 1 ? "lastRow" : "");
        }
        this.updateUI();
    },

    _addRow: function _addRow($table, number, specialClass) {
        var row = new _InviteSeveralUsersRow2.default().init(number, specialClass, _jquery2.default.proxy(this._validateCallback, this), _jquery2.default.proxy(this._changesCallback, this), this.errorTooltip);
        this.rows.push(row);
        $table.append(row.getElement());
    }
});

exports.default = APInviteSeveralUsersLightBox;

/***/ }),
/* 1927 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _ExportCSVButton = __webpack_require__(932);

var _ExportCSVButton2 = _interopRequireDefault(_ExportCSVButton);

var _LocalStorage = __webpack_require__(72);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EXPORT_ON_RELOAD_FLAG = "runCSVExportOnReload";

var LeaveRequestsExportToCSVPanel = function (_TemplateView) {
    _inherits(LeaveRequestsExportToCSVPanel, _TemplateView);

    function LeaveRequestsExportToCSVPanel(_ref) {
        var _ref$onExportButtonCl = _ref.onExportButtonClick,
            onExportButtonClick = _ref$onExportButtonCl === undefined ? function () {} : _ref$onExportButtonCl;

        _classCallCheck(this, LeaveRequestsExportToCSVPanel);

        var _this = _possibleConstructorReturn(this, (LeaveRequestsExportToCSVPanel.__proto__ || Object.getPrototypeOf(LeaveRequestsExportToCSVPanel)).call(this));

        _this.state = {
            disabled: false,
            inProgress: false
        };
        _this.callbacks = {
            onExportButtonClick: onExportButtonClick
        };
        _this.onStatePropertyChanged("disabled", function (disabled) {
            _this.exportButton.setState({ disabled: disabled });
        });
        _this.onStatePropertyChanged("inProgress", function (inProgress) {
            _this.exportButton.setState({ inProgress: inProgress });
        });
        return _this;
    }

    _createClass(LeaveRequestsExportToCSVPanel, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return "<div class='leaveRequestExportPanel csvExportPanel'>" + "    <div class='csvExport container'/>" + "    <div class='separator'/>" + "</div>";
        }
    }, {
        key: 'onError',
        value: function onError(e) {
            console.error(e);
            if (e.isInstanceOfEntityNotFound) {
                // we need to reload page AND perform export right after load. so store temporary flag
                // which expires in 1 minute (reload must not take such long)
                (0, _LocalStorage.getLocalStorage)().setItem(EXPORT_ON_RELOAD_FLAG, new Date().getTime() + 60000);
                document.location.reload();
            } else {
                throw e;
            }
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            var _this2 = this;

            this.exportButton = new _ExportCSVButton2.default({
                labelMessageKey: "actiplans.corporate_requests.buttons.export_to_csv",
                noDataMessageKey: "actiplans.leave_time_requests.csv.no_data",
                exportAction: function exportAction() {
                    _this2.callbacks.onExportButtonClick();
                }
            }).init(this.find(".csvExport"));

            var reloadBefore = (0, _LocalStorage.getLocalStorage)().getItem(EXPORT_ON_RELOAD_FLAG);
            (0, _LocalStorage.getLocalStorage)().removeItem(EXPORT_ON_RELOAD_FLAG);
            if (reloadBefore && reloadBefore > new Date().getTime()) {
                setTimeout(function () {
                    return _this2.callbacks.onExportButtonClick();
                });
            }
        }
    }]);

    return LeaveRequestsExportToCSVPanel;
}(_TemplateView3.default);

exports.default = LeaveRequestsExportToCSVPanel;

/***/ }),
/* 1928 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.downloadLeaveRequestsListCsv = downloadLeaveRequestsListCsv;

var _utils = __webpack_require__(127);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _date_format = __webpack_require__(16);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _format = __webpack_require__(931);

var _EntityProvider = __webpack_require__(1929);

var _EntityProvider2 = _interopRequireDefault(_EntityProvider);

var _UserNameFormat = __webpack_require__(17);

var _UserNameFormat2 = _interopRequireDefault(_UserNameFormat);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function downloadLeaveRequestsListCsv(data, props, callback) {

    var provider = new _EntityProvider2.default(props);
    var json = {
        columnNames: csvColumnNames(),
        columns: csvColumns(data),
        table: csvRows(data, provider)
    };
    var fileName = _messageResource2.default.getMessage("actiplans.corporate_requests.list.export_name.csv", [new _date_format.DateFormat('MMM dd, yyyy').formatDate(window.currentUserTime())]);
    (0, _utils.downloadJsonAsCSV)([json], fileName, callback);
}

function csvColumnNames() {
    var days = [_messageResource2.default.getMessage("common.balance_units.days")];
    var hours = [_messageResource2.default.getMessage("common.balance_units.hours")];
    return {
        user: _messageResource2.default.getMessage("common.User"),
        userGroup: _messageResource2.default.getMessage("common.User_Group"),
        tzGroup: _messageResource2.default.getMessage("common.Time_Zone_Group"),
        leaveType: _messageResource2.default.getMessage("leave_type.leave_type"),
        startDate: _messageResource2.default.getMessage("common.start_date"),
        endDate: _messageResource2.default.getMessage("common.end_date"),
        daysRequested: _messageResource2.default.getMessage("actiplans.leave_time_requests.time_requested_with_units", days),
        hoursRequested: _messageResource2.default.getMessage("actiplans.leave_time_requests.time_requested_with_units", hours),
        userComment: _messageResource2.default.getMessage("actiplans.leave_time_requests.csv.user_comment"),

        balanceType: _messageResource2.default.getMessage("actiplans.leave_time_requests.balance_type"),
        balanceDaysBefore: _messageResource2.default.getMessage("actiplans.leave_time_requests.balance_before", days),
        balanceDaysAfter: _messageResource2.default.getMessage("actiplans.leave_time_requests.balance_after", days),
        balanceHoursBefore: _messageResource2.default.getMessage("actiplans.leave_time_requests.balance_before", hours),
        balanceHoursAfter: _messageResource2.default.getMessage("actiplans.leave_time_requests.balance_after", hours),

        status: _messageResource2.default.getMessage("actiplans.leave_time_requests.status"),
        statusDate: _messageResource2.default.getMessage("actiplans.leave_time_requests.csv.status_date"),
        manager: _messageResource2.default.getMessage("actiplans.leave_time_requests.csv.manager"),
        managerComment: _messageResource2.default.getMessage("actiplans.leave_time_requests.csv.manager_note"),

        balanceChangePTO: _messageResource2.default.getMessage("actiplans.leave_time_requests.csv.change_current_balance.pto"),
        balanceChangeSick: _messageResource2.default.getMessage("actiplans.leave_time_requests.csv.change_current_balance.sick")
    };
}

function hasChangedTodayBalance(_ref) {
    var request = _ref.request,
        userInfo = _ref.userInfo;

    return LeaveTimeRequestUtils.changedTodayBalanceObjectNotEmpty(LeaveTimeRequestUtils.getBalanceValueFromRequestWithChanges(request, userInfo).changedTodayBalance);
}

function csvColumns(data) {
    var columns = Object.keys(csvColumnNames());

    if (!data.userGroupsEnabled) columns = _underscore2.default.without(columns, "userGroup");
    if (!data.timeZoneGroupsEnabled) columns = _underscore2.default.without(columns, "tzGroup");

    if (!SystemSettings.apPtoBalanceCalculationEnabled && !SystemSettings.apSickBalanceCalculationEnabled) {
        columns = _underscore2.default.reject(columns, function (c) {
            return c.startsWith("balance");
        });
    }

    if (!SystemSettings.apPtoBalanceCalculationEnabled) columns = _underscore2.default.without(columns, "balanceChangePTO");
    if (!SystemSettings.apSickBalanceCalculationEnabled) columns = _underscore2.default.without(columns, "balanceChangeSick");

    if (!data.records.some(function (rec) {
        return hasChangedTodayBalance(rec);
    })) {
        columns = _underscore2.default.without(columns, "balanceChangePTO", "balanceChangeSick");
    }

    return columns;
}

function csvRows(data, provider) {

    return data.records.map(function (_ref2) {
        var request = _ref2.request,
            userInfo = _ref2.userInfo;

        var status = LeaveTimeRequestUtils.getStatusFromRequestWithChanges(request);
        var targetLeaveType = provider.getLeaveType(LeaveTimeRequestUtils.getLeaveTypeIdFromRequestWithChanges(request));
        var originalLeaveType = provider.getLeaveType(request.leaveTypeId);
        var balance = LeaveTimeRequestUtils.getBalanceValueFromRequestWithChanges(request, userInfo);

        var canUseBalanceChangeForTargetLeaveType = targetLeaveType.id === originalLeaveType.id || targetLeaveType.balanceType === originalLeaveType.balanceType && (targetLeaveType.ptoCoefficient === originalLeaveType.ptoCoefficient || targetLeaveType.balanceType !== BalanceType.PTO);

        var _ref3 = canUseBalanceChangeForTargetLeaveType ? balance : {},
            after = _ref3.after,
            before = _ref3.before;

        return {
            user: _UserNameFormat2.default.formatLFM(userInfo.firstName, userInfo.lastName, userInfo.middleInitial),
            userGroup: data.userGroupsEnabled ? (0, _format.nameWithArchivedMark)(provider.getUserGroup(userInfo.userGroupId)) : null,
            tzGroup: data.timeZoneGroupsEnabled ? (0, _format.nameWithArchivedMark)(provider.getTimeZoneGroup(userInfo.timeZoneGroupId)) : null,
            leaveType: (0, _format.nameWithArchivedMark)(targetLeaveType),

            startDate: (0, _format.columnValue)(request.firstDate, formatDate),
            endDate: (0, _format.columnValue)(request.lastDate, formatDate),
            daysRequested: (0, _format.columnValue)(LeaveTimeRequestUtils.getLeaveTimeTotalValueFromRequestWithChanges(request).days, _format.formatNumber),
            hoursRequested: (0, _format.columnValue)(LeaveTimeRequestUtils.getLeaveTimeTotalValueFromRequestWithChanges(request).hours),
            userComment: (0, _format.columnValueOrHyphen)(LeaveTimeRequestUtils.getCommentFromRequestWithChanges(request)),

            balanceType: (0, _format.columnValueOrHyphen)(formatBalanceType(targetLeaveType)),

            balanceDaysBefore: (0, _format.columnValueOrHyphen)(before, _format.formatNumber),
            balanceDaysAfter: (0, _format.columnValueOrHyphen)(after, _format.formatNumber),
            balanceHoursBefore: (0, _format.columnValueOrHyphen)(before, function (days) {
                return days * data.ptoHoursPerDay;
            }),
            balanceHoursAfter: (0, _format.columnValueOrHyphen)(after, function (days) {
                return days * data.ptoHoursPerDay;
            }),

            status: (0, _format.columnValue)(LeaveTimeRequestUtils.formatLeaveRequestStatus(status)),
            statusDate: (0, _format.columnValue)(status.statusDate, formatDate),
            manager: (0, _format.columnValueOrHyphen)(LeaveTimeRequestUtils.formatLeaveRequestApprovedBy(status, false)),
            managerComment: (0, _format.columnValueOrHyphen)(status.statusMessage),

            balanceChangePTO: (0, _format.columnValueOrHyphen)(balance.changedTodayBalance.PTOBalance, _format.formatNumber),
            balanceChangeSick: (0, _format.columnValueOrHyphen)(balance.changedTodayBalance.sickBalance, _format.formatNumber)

        };
    });
}

function formatBalanceType(leaveType) {
    switch (leaveType.balanceType) {
        case BalanceType.PTO:
            return _messageResource2.default.getMessage("actiplans.leaves_management.balance.pto");
        case BalanceType.SICK:
            return _messageResource2.default.getMessage("actiplans.leaves_management.balance.sick");
    }
}

var leaveRequestsCsvdateFormat = new _date_format.DateFormat("MMM dd, yyyy");

function formatDate(val) {
    return leaveRequestsCsvdateFormat.formatDate(Date.parseJSONDate(val));
}

/***/ }),
/* 1929 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var EntityProvider = function () {
    function EntityProvider(_ref) {
        var userGroups = _ref.userGroups,
            timeZoneGroups = _ref.timeZoneGroups,
            leaveTypes = _ref.leaveTypes;

        _classCallCheck(this, EntityProvider);

        this.userGroups = userGroups;
        this.timeZoneGroups = timeZoneGroups;
        this.leaveTypes = leaveTypes;
    }

    _createClass(EntityProvider, [{
        key: "getUserGroup",
        value: function getUserGroup(id) {
            return entityOrError("user group", this.userGroups, id);
        }
    }, {
        key: "getTimeZoneGroup",
        value: function getTimeZoneGroup(id) {
            return entityOrError("tz group", this.timeZoneGroups, id);
        }
    }, {
        key: "getLeaveType",
        value: function getLeaveType(id) {
            return entityOrError("leave type", this.leaveTypes, id);
        }
    }]);

    return EntityProvider;
}();

exports.default = EntityProvider;


function entityOrError(entityName, mapping, id) {
    if (mapping === null || mapping === undefined) {
        throw new MappingNotFound("Mapping for '" + entityName + "' not defined");
    }

    var ent = mapping[id];
    if (ent === null || ent === undefined) {
        throw new EntityNotFound("Not found '" + entityName + "' with id=" + id + ".\n\n Only found:\n " + JSON.stringify(mapping, null, 4) + " ");
    }
    return ent;
}

var EntityNotFound = exports.EntityNotFound = function (_Error) {
    _inherits(EntityNotFound, _Error);

    function EntityNotFound() {
        var _ref2;

        var _temp, _this, _ret;

        _classCallCheck(this, EntityNotFound);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = EntityNotFound.__proto__ || Object.getPrototypeOf(EntityNotFound)).call.apply(_ref2, [this].concat(args))), _this), _this.isInstanceOfEntityNotFound = true, _temp), _possibleConstructorReturn(_this, _ret);
    }

    return EntityNotFound;
}(Error);

var MappingNotFound = exports.MappingNotFound = function (_Error2) {
    _inherits(MappingNotFound, _Error2);

    function MappingNotFound() {
        _classCallCheck(this, MappingNotFound);

        return _possibleConstructorReturn(this, (MappingNotFound.__proto__ || Object.getPrototypeOf(MappingNotFound)).apply(this, arguments));
    }

    return MappingNotFound;
}(Error);

/***/ }),
/* 1930 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _TemplateView = __webpack_require__(1);

var _TemplateView2 = _interopRequireDefault(_TemplateView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function APReportsPage($containerEl) {
    _TemplateView2.default.call(this, $containerEl);
}

APReportsPage.prototype = _underscore2.default.create(_TemplateView2.default.prototype, {
    html: "<div id='apReportsContent'>" + "  <div id='apReportsHeaderPlaceholder'></div>" + "  <div id='apLeaveTimeReportPlaceholder'></div>" + "  <div id='apWorkStatusesReportPlaceholder'></div>" + "  <div id='apPastLeavesCalendarPlaceholder'></div>" + "  <div id='apBalanceHistoryPlaceholder'></div>" + "</div>"
});

exports.default = APReportsPage;

/***/ }),
/* 1931 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _ChartGenerator = __webpack_require__(291);

var _ChartGenerator2 = _interopRequireDefault(_ChartGenerator);

var _utils = __webpack_require__(565);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function BalancesChartGenerator() {}

BalancesChartGenerator.prototype = _underscore2.default.create(_ChartGenerator2.default.prototype, {
    MAX_VERTICAL_GRIDS: 7,

    _prepareChartSettings: function _prepareChartSettings(chartData, config) {
        var collectedData = this._getCollectedData(chartData, config);

        var colorScheme = config["colorScheme"];
        var balanceFormatFunction = config["balanceFormatFunction"];
        var chartScrollbar = this._getChartScrollbar(chartData, config);

        var categoryAxisLabelFunction = config["categoryAxisLabelFunction"];

        var maxMinScaleValues = this._getMaxMinScaleValues(collectedData, config);
        var gridCount = (0, _utils.getVerticalGridCount)(maxMinScaleValues.maxScaleValue, maxMinScaleValues.minScaleValue, this.MAX_VERTICAL_GRIDS);

        var chartMargins = this._getMargins(balanceFormatFunction(maxMinScaleValues.maxScaleValue), balanceFormatFunction(maxMinScaleValues.minScaleValue));

        var graphs = this._prepareChartGraphs(colorScheme, balanceFormatFunction, config["balloonConfig"]);
        var dataProvider = collectedData.balancesData;

        return {
            "type": "serial",
            "autoResize": false,

            "startDuration": 0,
            "startEffect": "easeOutSine",
            "sequencedAnimation": true,

            "theme": "light",
            "columnWidth": 0.55,
            "fontSize": 11,
            "addClassNames": true,

            "autoMargins": false,
            "marginTop": chartMargins["top"],
            "marginBottom": chartMargins["bottom"],
            "marginLeft": chartMargins["left"],
            "marginRight": chartMargins["right"],

            "graphs": graphs,

            "valueAxes": [{
                "id": "main",
                "maximum": maxMinScaleValues.maxScaleValue,
                "minimum": maxMinScaleValues.minScaleValue,
                "autoGridCount": false,
                "strictMinMax": true,
                "gridCount": gridCount,
                "labelFunction": balanceFormatFunction
            }, {
                "id": "hidden",
                "gridCount": 0,
                "position": "right",
                "synchronizeWith": "main",
                "synchronizationMultiplier": 1,
                "autoGridCount": false,
                "axisAlpha": 0.11,
                // it need for show axis if auto margin off (hack)
                "minimum": 0,
                "logarithmic": true
            }],

            "chartScrollbar": chartScrollbar,

            "categoryField": "category",
            "categoryAxis": {
                "gridPosition": "start",
                "color": "#414141",
                "categoryFunction": categoryAxisLabelFunction,
                "labelRotation": 48,
                "labelFrequency": 1,
                "minHorizontalGap": 65,
                "minVerticalGap": 50,
                "fontSize": 11
            },
            "dataProvider": dataProvider
        };
    },

    _getMaxMinScaleValues: function _getMaxMinScaleValues(collectedData, config) {
        var maxMinScaleValues;
        if (_underscore2.default.isUndefined(config["maxMinScaleValues"])) {
            maxMinScaleValues = (0, _utils.getMaxMinScaleValues)(collectedData.maxBalanceValue, collectedData.minBalanceValue, this.MAX_VERTICAL_GRIDS);
            this._maxMinScaleValues = maxMinScaleValues;
        } else {
            maxMinScaleValues = config["maxMinScaleValues"]; // maxMinScaleValues from config used when chart is exporting to pdf
        }
        return maxMinScaleValues;
    },

    _getChartScrollbar: function _getChartScrollbar(data, config) {
        if (!config["showScrollbar"] || data.length <= 22) {
            return null;
        } else {
            return {
                "scrollbarHeight": 16,
                "dragIconHeight": 30,
                "dragIconWidth": 30,
                "backgroundColor": "#f9f9f9",
                "backgroundAlpha": 1,
                "selectedBackgroundAlpha": 1,
                "selectedBackgroundColor": "#e8e8e8"
            };
        }
    },

    _getCollectedData: function _getCollectedData(chartData, config) {
        var minBalanceValue = Number.POSITIVE_INFINITY;
        var maxBalanceValue = Number.NEGATIVE_INFINITY;
        var balanceFieldName = config["balanceFieldName"];
        for (var i = 0; i < chartData.length; i++) {
            var balanceData = chartData[i];

            // Nulls are casted into 0 by + (unary operator)
            minBalanceValue = Math.min(minBalanceValue, +balanceData["balanceForFirstColumn"], +balanceData["balanceForSecondColumn"]);
            maxBalanceValue = Math.max(maxBalanceValue, +balanceData["balanceForFirstColumn"], +balanceData["balanceForSecondColumn"]);
        }

        return {
            "minBalanceValue": minBalanceValue,
            "maxBalanceValue": maxBalanceValue,
            "balancesData": chartData
        };
    },

    _getMargins: function _getMargins(formattedMaxScaleValue, formattedMinScaleValue) {
        var maxStringLength = Math.max(formattedMaxScaleValue.length, formattedMinScaleValue.length);
        var left = 72;

        if (maxStringLength > 8) {
            left += (maxStringLength - 8) * 8;
        }

        return {
            "top": 20,
            "bottom": 125,
            "left": left,
            "right": 20
        };
    },

    /**
     * Prepare graphs for chart. Every graph represents one type of column
     */
    _prepareChartGraphs: function _prepareChartGraphs(colorScheme, balanceFormatFunction, balloonConfig) {
        var balloonBalanceLabel = balloonConfig["balloonBalanceLabel"];
        var dateBefore = balloonConfig["dateBefore"];
        var dateAfter = balloonConfig["dateAfter"];
        var categoryFormatFunction = balloonConfig["categoryFormatFunction"];

        return [this._createBalanceDataGraph("balanceForFirstColumn", colorScheme["balanceForFirstColumn"], balloonBalanceLabel, balanceFormatFunction, dateBefore, categoryFormatFunction), this._createBalanceDataGraph("balanceForSecondColumn", colorScheme["balanceForSecondColumn"], balloonBalanceLabel, balanceFormatFunction, dateAfter, categoryFormatFunction)];
    },

    /**
     * Create balance graph
     */
    _createBalanceDataGraph: function _createBalanceDataGraph(valueField, color, balanceLabel, balanceFormatFunction, date, categoryFormatFunction) {
        return {
            "showBalloon": true,
            "fillAlphas": 1,
            "lineAlpha": 0,
            "type": "column",
            "valueField": valueField,
            "fillColors": color,
            "lineThickness": 0,
            "balloon": {
                "adjustBorderColor": true,
                "borderColor": "#FFFFFF",
                "borderThickness": 1,
                "fillAlpha": 0.85
            },
            "balloonFunction": this._createBalloonFunction(valueField, color, balanceLabel, balanceFormatFunction, date, categoryFormatFunction)
        };
    },

    _createBalloonFunction: function _createBalloonFunction(valueField, iconColor, balanceLabel, balanceFormatFunction, date, categoryFormatFunction) {
        var balloonTemplate = _underscore2.default.template("<div class='balanceChartBalloon'>" + "   <div class='category'><%-category%></div>" + "   <div class='icon' style='background-color: <%=iconColor%>'></div><%=balanceTypeText%>" + "   <div class='dateAndBalanceValue'><%=date%>:&nbsp;<span class='balanceValue <%=additionalBalanceClasses%>'><%=value%></span></div>" + "</div>");

        return function (item) {
            var balance = item.dataContext[valueField];
            if (+balance == 0) {
                return null;
            }
            return balloonTemplate({
                "iconColor": iconColor,
                "value": balanceFormatFunction(balance),
                "balanceTypeText": balanceLabel,
                "date": date,
                "category": categoryFormatFunction(item.dataContext.category),
                "additionalBalanceClasses": balance < 0 ? "negative" : ""
            });
        };
    },

    _getAdditionalEventListeners: function _getAdditionalEventListeners() {
        var self = this;
        return [{
            "event": "zoomed",
            "method": function method(event) {
                self._startIndex = event.startIndex;
                self._endIndex = event.endIndex;
            }
        }];
    },

    getExportChartConfig: function getExportChartConfig() {
        return {
            "startIndex": this._startIndex,
            "endIndex": this._endIndex,
            "maxMinScaleValues": this._maxMinScaleValues,
            "showScrollbar": false
        };
    },

    _updateSettingsForExport: function _updateSettingsForExport(settings, chartData, config) {
        var scales = this._getChartScales(config);
        settings["marginLeft"] *= scales.horizontal;
        settings["fontSize"] = settings["fontSize"] * scales.common;
        settings["categoryAxis"]["fontSize"] *= scales.common;
        settings["categoryAxis"]["minHorizontalGap"] *= scales.common;
        settings["categoryAxis"]["minVerticalGap"] *= scales.common;
        settings["marginBottom"] *= scales.vertical;
    }
});

exports.default = BalancesChartGenerator;

/***/ }),
/* 1932 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ChartGenerator = __webpack_require__(291);

var _ChartGenerator2 = _interopRequireDefault(_ChartGenerator);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _LeaveTypeStore = __webpack_require__(124);

var _LeaveTypeStore2 = _interopRequireDefault(_LeaveTypeStore);

var _utils = __webpack_require__(565);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function LeaveTimeChartGenerator() {}

LeaveTimeChartGenerator.prototype = _underscore2.default.create(_ChartGenerator2.default.prototype, {
    MAX_VERTICAL_GRIDS: 6,

    _prepareChartSettings: function _prepareChartSettings(chartData, config) {
        var leaveTypesIds = config["leaveTypesIdsOrdered"];
        var collectedData = this._getCollectedData(chartData);

        var colorScheme = config["colorScheme"];
        var chartScrollbar = this._getChartScrollbar(chartData, config);

        var categoryAxisLabelFunction = config["categoryAxisLabelFunction"];
        var valueAxisLabelFunction = config["valueAxisLabelFunction"];
        var categoryFormatFunctionForBalloon = config["categoryFormatFunctionForBalloon"];

        var maxScaleValue = this._getMaxScaleValue(collectedData, config);
        var gridCount = (0, _utils.getVerticalGridCount)(maxScaleValue, 0, this.MAX_VERTICAL_GRIDS);
        var chartMargins = this._getMargins(valueAxisLabelFunction(maxScaleValue));

        var dataProvider = this._prepareDataProvider(collectedData, leaveTypesIds, colorScheme, valueAxisLabelFunction);

        return {
            "type": "serial",
            "autoResize": false,

            "startDuration": 0,
            "startEffect": "easeOutSine",
            "sequencedAnimation": true,

            "theme": "light",
            "columnWidth": 0.6,
            "fontSize": 11,
            "addClassNames": true,

            "autoMargins": false,
            "marginTop": chartMargins["top"],
            "marginBottom": chartMargins["bottom"],
            "marginLeft": chartMargins["left"],
            "marginRight": chartMargins["right"],

            "graphs": this._prepareChartGraphs(leaveTypesIds, colorScheme, categoryFormatFunctionForBalloon),

            "valueAxes": [{
                "id": "main",
                "maximum": maxScaleValue,
                "autoGridCount": false,
                "strictMinMax": true,
                "gridCount": gridCount,
                "labelFunction": valueAxisLabelFunction,
                "stackType": "regular"
            }, {
                "id": "hidden",
                "gridCount": 0,
                "position": "right",
                "synchronizeWith": "main",
                "synchronizationMultiplier": 1,
                "autoGridCount": false,
                "axisAlpha": 0.11,
                // it need for show axis if auto margin off (hack)
                "minimum": 0,
                "logarithmic": true
            }],

            "chartCursor": {
                "oneBalloonOnly": true,
                "categoryBalloonEnabled": false,
                "balloonPointerOrientation": "horizontal",
                "cursorAlpha": 0,
                "zoomable": false
            },

            "chartScrollbar": chartScrollbar,

            "categoryField": "category",
            "categoryAxis": {
                "gridPosition": "start",
                "color": "#414141",
                "categoryFunction": categoryAxisLabelFunction,
                "labelRotation": 48,
                "labelFrequency": 1,
                "minHorizontalGap": 65,
                "minVerticalGap": 50,
                "fontSize": 11
            },
            "dataProvider": dataProvider
        };
    },

    _getMaxScaleValue: function _getMaxScaleValue(collectedData, config) {
        var maxScaleValue;
        if (_underscore2.default.isUndefined(config["maxScaleValue"])) {
            maxScaleValue = (0, _utils.getMaxScaleValue)(collectedData.maxSummaryLeaveValue, this.MAX_VERTICAL_GRIDS);
            this._maxScaleValue = maxScaleValue;
        } else {
            maxScaleValue = config["maxScaleValue"]; // maxScaleValue from config used when chart is exporting to pdf
        }
        return maxScaleValue;
    },

    _getChartScrollbar: function _getChartScrollbar(data, config) {
        if (!config["showScrollbar"] || data.length <= 26) {
            return null;
        } else {
            return {
                "scrollbarHeight": 16,
                "dragIconHeight": 30,
                "dragIconWidth": 30,
                "backgroundColor": "#f9f9f9",
                "backgroundAlpha": 1,
                "selectedBackgroundAlpha": 1,
                "selectedBackgroundColor": "#e8e8e8"
            };
        }
    },

    _prepareDataProvider: function _prepareDataProvider(collectedData, leaveTypeIds, colorScheme, timeFormatFunction) {
        var dataProvider = [];
        var leavesData = collectedData.leavesData;
        for (var i = 0; i < leavesData.length; i++) {
            var leaveData = leavesData[i];
            var contextData = {};
            contextData["category"] = leaveData["category"];
            contextData["balloon"] = leaveData["total"];

            var balloonContext = {};
            balloonContext["total"] = timeFormatFunction(leaveData["total"]);
            balloonContext["category"] = leaveData["category"];

            var spentTimeByLeaveIdMap = leaveData["spentTimeByLeaveIdMap"];
            var leavesDataToShow = [];
            var nonZeroLeaveTypeValues = 0;
            for (var index = leaveTypeIds.length - 1; index >= 0; index--) {
                var spentTime = spentTimeByLeaveIdMap[leaveTypeIds[index]];
                contextData["value-" + leaveTypeIds[index]] = spentTime;
                if (spentTime != 0) {
                    nonZeroLeaveTypeValues++;
                    if (leavesDataToShow.length < 5) // only 5 leave type infos with non-zero value were shown on balloon
                        {
                            var leaveType = _LeaveTypeStore2.default.getLeaveType(leaveTypeIds[index]);

                            leavesDataToShow.push({
                                "value": timeFormatFunction(spentTime),
                                "leaveTypeName": leaveType.name,
                                "archived": !!leaveType.archived,
                                "color": this._getColor(colorScheme, leaveTypeIds[index])
                            });
                        }
                }
            }
            balloonContext["leavesDataToShow"] = leavesDataToShow;
            balloonContext["more"] = nonZeroLeaveTypeValues - leavesDataToShow.length;
            contextData["balloonContext"] = balloonContext;

            dataProvider.push(contextData);
        }
        return dataProvider;
    },

    _getCollectedData: function _getCollectedData(items) {
        var maxSummaryValue = 0;
        var leavesData = [];
        for (var i = 0; i < items.length; i++) {
            var item = items[i];

            if (item["totalLeaveSpent"] > maxSummaryValue) {
                maxSummaryValue = item["totalLeaveSpent"];
            }

            var leaveData = {};
            leaveData["category"] = item["category"];

            var spentTimeByLeaveIdMap = {};
            _underscore2.default.each(item["leaveSpent"], function (leaveSpentObj) {
                spentTimeByLeaveIdMap[leaveSpentObj.leaveTypeId] = leaveSpentObj["leaveSpent"];
            });
            leaveData["spentTimeByLeaveIdMap"] = spentTimeByLeaveIdMap;
            leaveData["total"] = item["totalLeaveSpent"];
            leavesData.push(leaveData);
        }
        return {
            "maxSummaryLeaveValue": maxSummaryValue,
            "leavesData": leavesData
        };
    },

    /**
     * Prepare graphs for chart. Every graph represents one type of column
     */
    _prepareChartGraphs: function _prepareChartGraphs(leaveTypeIds, colorScheme, categoryFormatFunction) {
        var graphs = [];
        var self = this;

        _underscore2.default.each(leaveTypeIds, function (leaveTypeId) {
            graphs.push(self._createLeaveTimeDataGraph(leaveTypeId, self._getColor(colorScheme, leaveTypeId)));
        });

        var balloonGraph = {
            "showBalloon": true,
            "fillAlphas": 0,
            "lineAlpha": 0,
            "newStack": true,
            "type": "column",
            "clustered": false,
            "valueField": "balloon",
            "fillColors": "#FFFFFF",
            "balloonFunction": this._createBalloonFunction(categoryFormatFunction),
            "lineThickness": 0,
            "balloon": {
                "adjustBorderColor": false,
                "borderColor": "#b2b2b2",
                "borderThickness": 1,
                "fillAlpha": 0.85,
                "shadowAlpha": 0
            }
        };
        graphs.push(balloonGraph);
        return graphs;
    },

    /**
     * Create leave time graph
     */
    _createLeaveTimeDataGraph: function _createLeaveTimeDataGraph(id, color) {
        return {
            "showBalloon": false,
            "fillAlphas": 1,
            "lineAlpha": 0,
            "type": "column",
            "clustered": false,
            "valueField": "value-" + id,
            "fillColors": color
        };
    },

    _getMargins: function _getMargins(formattedMaxScaleValue) {
        var left = 72;

        if (formattedMaxScaleValue.length > 8) {
            left += (formattedMaxScaleValue.length - 8) * 8;
        }

        return {
            "top": 20,
            "bottom": 125,
            "left": left,
            "right": 20
        };
    },

    _createBalloonFunction: function _createBalloonFunction(categoryFormatFunction) {
        var balloonTemplate = _underscore2.default.template("<div class='leaveTimeChartBalloon'>" + "   <div class='category'><%-categoryFormatFunction(category)%></div>" + "   <div class='totalSection'><%=messageResource.getMessage('actiplans.reports.chart.total_leave_time')%>&nbsp;<%=total%></div>" + "   <% _.each(leavesDataToShow, function(leaveDataToShow) { %>" + "     <div class='leaveType'>" + "       <div class='icon' style='background-color: <%=leaveDataToShow.color%>'></div>" + "       <div class='leaveTypeName'><%-leaveDataToShow.leaveTypeName%></div>" +
        // Do not create additional spaces, it breaks padding
        "<% if (leaveDataToShow.archived) { %>" + "<div><%=messageResource.getMessage('common.archived')%></div>" + "<% } %>" + "<div>:&nbsp;<%=leaveDataToShow.value%></div>" + "     </div>" + "   <% })%>" + "   <% if (more > 0) { %>" + "     <div class='more'><%=messageResource.getMessage('actiplans.reports.chart.leave_time_tooltip.more', [more])%></div>" + "   <% } %>" + "</div>");

        return function (item) {
            return balloonTemplate(_underscore2.default.extend(item.dataContext["balloonContext"], { "categoryFormatFunction": categoryFormatFunction }));
        };
    },

    _getColor: function _getColor(colorScheme, leaveTypeId) {
        return colorScheme[_LeaveTypeStore2.default.getLeaveType(leaveTypeId).iconId];
    },

    _getAdditionalEventListeners: function _getAdditionalEventListeners() {
        var self = this;
        return [{
            "event": "zoomed",
            "method": function method(event) {
                self._startIndex = event.startIndex;
                self._endIndex = event.endIndex;
            }
        }];
    },

    getExportChartConfig: function getExportChartConfig() {
        return {
            "startIndex": this._startIndex,
            "endIndex": this._endIndex,
            "maxScaleValue": this._maxScaleValue,
            "showScrollbar": false
        };
    },

    _updateSettingsForExport: function _updateSettingsForExport(settings, chartData, config) {
        var scales = this._getChartScales(config);
        settings["marginLeft"] *= scales.horizontal;
        settings["fontSize"] = settings["fontSize"] * scales.common;
        settings["categoryAxis"]["fontSize"] *= scales.common;
        settings["categoryAxis"]["minHorizontalGap"] *= scales.common;
        settings["categoryAxis"]["minVerticalGap"] *= scales.common;
        settings["marginBottom"] *= scales.vertical;
    }
});

exports.default = LeaveTimeChartGenerator;

/***/ }),
/* 1933 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _date_format = __webpack_require__(16);

var _UserNameFormat = __webpack_require__(17);

var _UserNameFormat2 = _interopRequireDefault(_UserNameFormat);

var _atUtils = __webpack_require__(5);

var _utils = __webpack_require__(127);

var _BalanceFormatter = __webpack_require__(230);

var _BalanceHistoryTable = __webpack_require__(957);

var _LeaveTypeStore = __webpack_require__(124);

var _LeaveTypeStore2 = _interopRequireDefault(_LeaveTypeStore);

var _number_formatter = __webpack_require__(61);

var _number_formatter2 = _interopRequireDefault(_number_formatter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CSVConverter = function () {
    function CSVConverter() {
        _classCallCheck(this, CSVConverter);

        this.dateFormatter = new _date_format.DateFormat(window.SystemSettings.dateFormat);
        this.numberFormatter = new _number_formatter2.default(window.SystemSettings.decimalSeparator, window.SystemSettings.digitGroupingSymbol, 2, true);
        this.usersMap = (0, _atUtils.arrayToMap)(window.APReportsStore.getVisibleUsers());
    }

    _createClass(CSVConverter, [{
        key: 'convertAndSaveAsCSV',
        value: function convertAndSaveAsCSV(_ref) {
            var selectedUserId = _ref.selectedUserId,
                balanceType = _ref.balanceType,
                balanceModels = _ref.balanceModels,
                workHoursPerDay = _ref.workHoursPerDay,
                spinner = _ref.spinner;

            this.workHoursPerDay = workHoursPerDay;
            this.balanceFormatter = new _BalanceFormatter.BalanceFormatter().init(workHoursPerDay, false);
            var json = {
                columnNames: this.getColumnNames(),
                columns: this.getColumns(),
                table: this.getRows(balanceType, balanceModels)
            };

            (0, _utils.downloadJsonAsCSV)([json], this.getFilename(balanceType, selectedUserId), function () {
                return spinner.stop();
            });
        }
    }, {
        key: 'getColumnNames',
        value: function getColumnNames() {
            return {
                effectiveDate: _messageResource2.default.getMessage('common.balance_history.table.date_cell.title'),
                description: _messageResource2.default.getMessage('common.description'),
                comment: _messageResource2.default.getMessage('common.Comment'),
                valueD: _messageResource2.default.getMessage('common.balance_history.csv_file.value', [_messageResource2.default.getMessage('common.balance_units.days.short')]),
                valueH: _messageResource2.default.getMessage('common.balance_history.csv_file.value', [_messageResource2.default.getMessage('common.balance_units.hours.short')]),
                endingBalanceD: _messageResource2.default.getMessage('common.balance_history.csv_file.ending_balance', [_messageResource2.default.getMessage('common.balance_units.days.short')]),
                endingBalanceH: _messageResource2.default.getMessage('common.balance_history.csv_file.ending_balance', [_messageResource2.default.getMessage('common.balance_units.hours.short')])
            };
        }
    }, {
        key: 'getColumns',
        value: function getColumns() {
            return ['effectiveDate', 'description', 'comment', 'valueD', 'valueH', 'endingBalanceD', 'endingBalanceH'];
        }
    }, {
        key: 'getRows',
        value: function getRows(balanceType, balanceModels) {
            var _this = this;

            return balanceModels.map(function (balanceModel) {
                var rowModelParams = _this.getRowModelParams(balanceModel, balanceType);
                return {
                    effectiveDate: _this.dateFormatter.formatDate(Date.parseJSONDate(balanceModel.effectiveDate)),
                    description: rowModelParams.description,
                    comment: rowModelParams.comment,
                    valueD: rowModelParams.additionalSign + _this.balanceFormatter.format(balanceModel.differenceValue),
                    valueH: rowModelParams.additionalSign + _this.balanceFormatter.format(balanceModel.differenceValue, true),
                    endingBalanceD: _this.numberFormatter.format(balanceModel.endingBalance),
                    endingBalanceH: _this.numberFormatter.format(_this.recalculateFromDaysToHours(balanceModel.endingBalance))
                };
            });
        }
    }, {
        key: 'recalculateFromDaysToHours',
        value: function recalculateFromDaysToHours(days) {
            return days == null ? null : days * this.workHoursPerDay;
        }
    }, {
        key: 'getFilename',
        value: function getFilename(balanceType, selectedUserId) {
            var reportTypeText = _messageResource2.default.getMessage(balanceType === _BalanceHistoryTable.BalanceHistory.BalanceTypes.PTO ? 'common.balance_history.table.pto' : 'common.balance_history.table.sick');
            var user = this.usersMap[selectedUserId];
            return user.firstName + ' ' + user.lastName + ', ' + reportTypeText + ' Balance History (' + new _date_format.DateFormat('MMM dd, yyyy').formatDate(window.currentUserTime()) + ').csv';
        }
    }, {
        key: 'getRowModelParams',
        value: function getRowModelParams(model) {
            switch (model.type) {
                case _BalanceHistoryTable.BalanceHistory.TableRows.AUTOMATIC_BALANCE_ACCRUE_RECORD:
                    return {
                        description: _messageResource2.default.getMessage('common.balance_history.table.automatic_balance_accrue.label'),
                        comment: this.getColumnValue(model.comment),
                        additionalSign: '+'
                    };
                case _BalanceHistoryTable.BalanceHistory.TableRows.AUTOMATIC_BALANCE_LIMIT_RECORD:
                    return {
                        description: _messageResource2.default.getMessage('common.balance_history.table.automatic_balance_limit.label'),
                        comment: this.getColumnValue(model.comment),
                        additionalSign: ''
                    };
                case _BalanceHistoryTable.BalanceHistory.TableRows.AUTOMATIC_BALANCE_RESET_RECORD:
                    return {
                        description: _messageResource2.default.getMessage('common.balance_history.table.automatic_balance_reset.label'),
                        comment: this.getColumnValue(model.comment),
                        additionalSign: ''
                    };
                case _BalanceHistoryTable.BalanceHistory.TableRows.LEAVE_TIME_COMPLETED_RECORD:
                    {
                        var leaveType = _LeaveTypeStore2.default.getLeaveType(model.leaveTypeId);
                        return {
                            description: _messageResource2.default.getMessage('common.balance_history.table.leave_time_completed.label', [leaveType.name]),
                            comment: this.getColumnValue(model.comment),
                            additionalSign: '-'
                        };
                    }
                case _BalanceHistoryTable.BalanceHistory.TableRows.MANUAL_INCREASE_RECORD:
                    return {
                        description: _messageResource2.default.getMessage('common.balance_history.table.manual_increase.label'),
                        comment: this.getManualAdjustmentComment(model.balanceManagerInfo, model.comment),
                        additionalSign: '+'
                    };
                case _BalanceHistoryTable.BalanceHistory.TableRows.MANUAL_DECREASE_RECORD:
                    return {
                        description: _messageResource2.default.getMessage('common.balance_history.table.manual_decrease.label'),
                        comment: this.getManualAdjustmentComment(model.balanceManagerInfo, model.comment),
                        additionalSign: '-'
                    };
                case _BalanceHistoryTable.BalanceHistory.TableRows.MANUAL_SET_RECORD:
                    return {
                        description: _messageResource2.default.getMessage('common.balance_history.table.manual_set.label'),
                        comment: this.getManualAdjustmentComment(model.balanceManagerInfo, model.comment),
                        additionalSign: ''
                    };
            }
        }
    }, {
        key: 'getManualAdjustmentComment',
        value: function getManualAdjustmentComment(balanceManager, comment) {
            var balanceManagerInfo = _messageResource2.default.getMessage('common.balance_history.table.leave_time_completed.by.label', [_UserNameFormat2.default.formatFML(balanceManager.firstName, balanceManager.lastName, balanceManager.middleInitial)]);
            var commentInfo = comment && (0, _atUtils.isNotEmpty)(comment) ? ' - ' + comment : '';
            return balanceManagerInfo + commentInfo;
        }
    }, {
        key: 'getColumnValue',
        value: function getColumnValue(comment) {
            return comment ? comment : '';
        }
    }]);

    return CSVConverter;
}();

exports.default = CSVConverter;

/***/ }),
/* 1934 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _date_format = __webpack_require__(16);

var _UserNameFormat = __webpack_require__(17);

var _UserNameFormat2 = _interopRequireDefault(_UserNameFormat);

var _atUtils = __webpack_require__(5);

var _utils = __webpack_require__(127);

var _LeaveTypeStore = __webpack_require__(124);

var _LeaveTypeStore2 = _interopRequireDefault(_LeaveTypeStore);

var _BalanceType = __webpack_require__(253);

var _BalanceType2 = _interopRequireDefault(_BalanceType);

var _number_formatter = __webpack_require__(61);

var _number_formatter2 = _interopRequireDefault(_number_formatter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CSVConverter = function () {
    function CSVConverter() {
        _classCallCheck(this, CSVConverter);

        this.dateFormatter = new _date_format.DateFormat(window.SystemSettings.dateFormat);
        this.numberFormatter = new _number_formatter2.default(window.SystemSettings.decimalSeparator, window.SystemSettings.digitGroupingSymbol, 2, true);
        this.usersMap = (0, _atUtils.arrayToMap)(window.APReportsStore.getVisibleUsers());
    }

    _createClass(CSVConverter, [{
        key: 'convertAndSaveAsCSV',
        value: function convertAndSaveAsCSV(_ref) {
            var workHoursPerDay = _ref.workHoursPerDay,
                selectedUserId = _ref.selectedUserId,
                dateFrom = _ref.dateFrom,
                period = _ref.period,
                requests = _ref.requests,
                showBalances = _ref.showBalances,
                showComments = _ref.showComments,
                spinner = _ref.spinner;

            this.workHoursPerDay = workHoursPerDay;
            var json = {
                columnNames: this.getColumnNames(),
                columns: this.getColumns(showBalances, showComments),
                table: this.getRows(requests)
            };

            (0, _utils.downloadJsonAsCSV)([json], this.getFilename(selectedUserId, dateFrom, period), function () {
                return spinner.stop();
            });
        }
    }, {
        key: 'getColumnNames',
        value: function getColumnNames() {
            return {
                leaveType: _messageResource2.default.getMessage('actiplans.leave_time_requests.leave_type'),
                startDate: _messageResource2.default.getMessage('common.start_date'),
                endDate: _messageResource2.default.getMessage('common.end_date'),
                timeRequestedD: _messageResource2.default.getMessage('actiplans.leave_time_requests.time_requested_with_units', [_messageResource2.default.getMessage('common.balance_units.days.short')]),
                timeRequestedH: _messageResource2.default.getMessage('actiplans.leave_time_requests.time_requested_with_units', [_messageResource2.default.getMessage('common.balance_units.hours.short')]),
                balanceType: _messageResource2.default.getMessage('actiplans.leave_time_requests.balance_type'),
                balanceBeforeD: _messageResource2.default.getMessage('actiplans.leave_time_requests.balance_before', [_messageResource2.default.getMessage('common.balance_units.days.short')]),
                balanceAfterD: _messageResource2.default.getMessage('actiplans.leave_time_requests.balance_after', [_messageResource2.default.getMessage('common.balance_units.days.short')]),
                balanceBeforeH: _messageResource2.default.getMessage('actiplans.leave_time_requests.balance_before', [_messageResource2.default.getMessage('common.balance_units.hours.short')]),
                balanceAfterH: _messageResource2.default.getMessage('actiplans.leave_time_requests.balance_after', [_messageResource2.default.getMessage('common.balance_units.hours.short')]),
                comment: _messageResource2.default.getMessage('common.Comment'),
                status: _messageResource2.default.getMessage('actiplans.leave_time_requests.status'),
                statusNote: _messageResource2.default.getMessage('actiplans.leave_time_requests.status_note')
            };
        }
    }, {
        key: 'getColumns',
        value: function getColumns(showBalances, showComments) {
            return ['leaveType', 'startDate', 'endDate', 'timeRequestedD', 'timeRequestedH'].concat(_toConsumableArray(showBalances ? ['balanceType', 'balanceBeforeD', 'balanceAfterD', 'balanceBeforeH', 'balanceAfterH'] : []), _toConsumableArray(showComments ? ['comment'] : []), ['status', 'statusNote']);
        }
    }, {
        key: 'getRows',
        value: function getRows(requests) {
            var _this = this;

            return requests.map(function (request) {
                var leaveType = _LeaveTypeStore2.default.getLeaveType(request.leaveTypeId);
                return _extends({
                    leaveType: leaveType.name + (leaveType.active ? '' : ' ' + _messageResource2.default.getMessage('common.archived')),
                    startDate: _this.dateFormatter.formatDate(Date.parseJSONDate(request.firstDate)),
                    endDate: _this.dateFormatter.formatDate(Date.parseJSONDate(request.lastDate)),
                    timeRequestedD: _this.numberFormatter.format(request.leaveTimeTotal.days),
                    timeRequestedH: _this.numberFormatter.format(request.leaveTimeTotal.hours),
                    comment: request.comment ? request.comment : '-',
                    status: _messageResource2.default.getMessage('actiplans.request_status.approved'),
                    statusNote: _this.getStatusNote(request)
                }, _this.getBalanceInfo(request.balanceData, leaveType.balanceType));
            });
        }
    }, {
        key: 'getStatusNote',
        value: function getStatusNote(request) {
            var dateText = this.dateFormatter.formatDate(Date.parseJSONDate(request.statusDate));
            var approverText = request.approverInfo ? _messageResource2.default.getMessage('actiplans.request_status.by_user', [_UserNameFormat2.default.formatFML(request.approverInfo.firstName, request.approverInfo.lastName, request.approverInfo.middleInitial)]) : _messageResource2.default.getMessage('actiplans.request_status.automatic_approval');
            return dateText + ', ' + approverText;
        }
    }, {
        key: 'getBalanceInfo',
        value: function getBalanceInfo(balanceData, balanceType) {
            var affectsBalance = balanceData && balanceData.balanceChangeData;
            if (affectsBalance && (window.SystemSettings.apPtoBalanceCalculationEnabled || window.SystemSettings.apSickBalanceCalculationEnabled)) {
                if (balanceType === _BalanceType2.default.PTO && window.SystemSettings.apPtoBalanceCalculationEnabled) {
                    return _extends({
                        balanceType: _messageResource2.default.getMessage('common.balance_history.table.pto')
                    }, this.getBalanceValues(balanceData));
                } else if (balanceType === _BalanceType2.default.SICK && window.SystemSettings.apSickBalanceCalculationEnabled) {
                    return _extends({
                        balanceType: _messageResource2.default.getMessage('common.balance_history.table.sick')
                    }, this.getBalanceValues(balanceData));
                }
            } else {
                return {
                    balanceType: '-',
                    balanceBeforeD: '-',
                    balanceAfterD: '-',
                    balanceBeforeH: '-',
                    balanceAfterH: '-'
                };
            }
        }
    }, {
        key: 'getBalanceValues',
        value: function getBalanceValues(balanceData) {
            return {
                balanceBeforeD: this.numberFormatter.format(balanceData.balanceChangeData.startBalance),
                balanceAfterD: this.numberFormatter.format(balanceData.balanceChangeData.endBalance),
                balanceBeforeH: this.numberFormatter.format(this.recalculateFromDaysToHours(balanceData.balanceChangeData.startBalance)),
                balanceAfterH: this.numberFormatter.format(this.recalculateFromDaysToHours(balanceData.balanceChangeData.endBalance))
            };
        }
    }, {
        key: 'recalculateFromDaysToHours',
        value: function recalculateFromDaysToHours(days) {
            return days == null ? null : days * this.workHoursPerDay;
        }
    }, {
        key: 'getFilename',
        value: function getFilename(selectedUserId, dateFrom, period) {
            var user = this.usersMap[selectedUserId];
            var dateFormatter = new _date_format.DateFormat('MMM yyyy');
            var dateTo = period === 1 ? '' : ' - ' + dateFormatter.formatDate(new Date(dateFrom.getFullYear(), dateFrom.getMonth() + period - 1));
            return user.firstName + ' ' + user.lastName + ', ' + 'Leave Time Details (' + dateFormatter.formatDate(dateFrom) + dateTo + ').csv';
        }
    }]);

    return CSVConverter;
}();

exports.default = CSVConverter;

/***/ }),
/* 1935 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.LeaveTimeDetailsTable = LeaveTimeDetailsTable;

var _number_formatter = __webpack_require__(61);

var _number_formatter2 = _interopRequireDefault(_number_formatter);

var _CustomCheckbox = __webpack_require__(83);

var _CustomCheckbox2 = _interopRequireDefault(_CustomCheckbox);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _BalanceFormatter = __webpack_require__(230);

var _jquery_rpc = __webpack_require__(26);

var _jquery_rpc2 = _interopRequireDefault(_jquery_rpc);

var _LocalStorage = __webpack_require__(72);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AP_PAST_LEAVES_CALENDAR_COMMENTS_SHOWN = 'apPastLeavesCalendarCommentsShown';

function LeaveTimeDetailsTable() {}

LeaveTimeDetailsTable.prototype.init = function (leaveTimeDetailsSetting, nameService) {
    var self = this;

    this.daysFormatter = new _number_formatter2.default(SystemSettings.decimalSeparator, SystemSettings.digitGroupingSymbol, 2, true, '', 'd');
    this.hoursFormatter = new _number_formatter2.default(SystemSettings.decimalSeparator, SystemSettings.digitGroupingSymbol, 2, true, '', 'h');

    this.initSortMap(leaveTimeDetailsSetting);
    this.nameService = nameService;
    (0, _jquery2.default)("table.requests > thead .sortButton.leaveType").click(function () {
        self.onChangeCallback(self.sortMap.leaveType);
    });
    (0, _jquery2.default)("table.requests > thead .sortButton.period").click(function () {
        self.onChangeCallback(self.sortMap.period);
    });
    (0, _jquery2.default)("table.requests > thead .sortButton.timeRequested").click(function () {
        self.onChangeCallback(self.sortMap.timeRequested);
    });
    (0, _jquery2.default)("table.requests > thead .sortButton.status").click(function () {
        self.onChangeCallback(self.sortMap.status);
    });

    this.leaveBalancesFilter = new LeaveBalancesFilter().init((0, _jquery2.default)(".leaveBalancesFilterContainer")[0], function () {
        self.onChangeCallback(false);
    }, { value: leaveTimeDetailsSetting.leaveBalancesFilter });

    this.$showCommentsCheckbox = (0, _jquery2.default)('.showCommentsCheckbox');
    var showCommentsFromLocalStorage = this.getCommentsCheckboxStateFromLocalStorage();
    var showComments = showCommentsFromLocalStorage !== null ? showCommentsFromLocalStorage : true;
    (0, _jquery2.default)('#leaveTimeTable').toggleClass('hideComments', !showComments);
    this.showCommentsCheckbox = new _CustomCheckbox2.default({
        label: _messageResource2.default.getMessage('common.show_comments'),
        checked: showComments,
        onChange: this.onCommentsCheckboxChanged
    }).init(this.$showCommentsCheckbox);

    this.balancesColumnStrategy = null;
    this.isPTO = null;
    this.isSick = null;

    this.initSliderButton();
    return this;
};

LeaveTimeDetailsTable.prototype.onCommentsCheckboxChanged = function (_ref) {
    var checked = _ref.checked;

    (0, _LocalStorage.getLocalStorage)().setItem(AP_PAST_LEAVES_CALENDAR_COMMENTS_SHOWN, checked);
    (0, _jquery2.default)('#leaveTimeTable').toggleClass('hideComments', !checked);
};

LeaveTimeDetailsTable.prototype.getCommentsCheckboxStateFromLocalStorage = function () {
    return (0, _LocalStorage.getLocalStorage)().getItem(AP_PAST_LEAVES_CALENDAR_COMMENTS_SHOWN);
};

LeaveTimeDetailsTable.prototype.isCommentsShown = function () {
    return this.showCommentsCheckbox.isChecked();
};

LeaveTimeDetailsTable.prototype.getBalanceTypeFilterValue = function () {
    return this.balancesColumnStrategy.isBalanceFilterActive() ? this.leaveBalancesFilter.getValue() : LeaveBalanceFilter.ALL;
};

LeaveTimeDetailsTable.prototype.initSortMap = function (leaveTimeDetailsSetting) {
    var self = this;
    // inner sort always return leave sorted by asc, if they are equal sorted by period by asc.
    function innerSort(a, b) {
        var leaveTypeAPosition = LEAVE_TYPES[a.leaveTypeId].position;
        var leaveTypeBPosition = LEAVE_TYPES[b.leaveTypeId].position;
        var firstDateA = a.firstDate.parseJSONDate();
        var firstDateB = b.firstDate.parseJSONDate();
        return leaveTypeAPosition == leaveTypeBPosition ? firstDateA.getTime() < firstDateB.getTime() ? -1 : 1 : leaveTypeAPosition > leaveTypeBPosition ? 1 : -1;
    }

    function sortOnLeave(a, b) {
        var order = self.isAscending ? 1 : -1;
        var leaveTypeAPosition = LEAVE_TYPES[a.leaveTypeId].position;
        var leaveTypeBPosition = LEAVE_TYPES[b.leaveTypeId].position;
        return leaveTypeAPosition == leaveTypeBPosition ? innerSort(a, b) : leaveTypeAPosition > leaveTypeBPosition ? order : -order;
    }

    function sortOnPeriod(a, b) {
        var order = self.isAscending ? 1 : -1;
        var firstDateA = a.firstDate.parseJSONDate();
        var firstDateB = b.firstDate.parseJSONDate();
        return firstDateA.getTime() < firstDateB.getTime() ? -order : order;
    }

    function sortOnTimeRequested(a, b) {
        var order = self.isAscending ? 1 : -1;
        var requestedA = a.leaveTimeTotal.hours;
        var requestedB = b.leaveTimeTotal.hours;
        return requestedA == requestedB ? innerSort(a, b) : requestedA < requestedB ? -order : order;
    }

    function sortOnStatus(a, b) {
        var order = self.isAscending ? 1 : -1;
        var statusDateA = a.statusDate.parseJSONDate();
        var statusDateB = b.statusDate.parseJSONDate();
        return statusDateA.getTime() == statusDateB.getTime() ? innerSort(a, b) : statusDateA.getTime() < statusDateB.getTime() ? -order : order;
    }

    this.sortMap = {
        period: { name: "period", func: sortOnPeriod },
        leaveType: { name: "leaveType", func: sortOnLeave },
        timeRequested: { name: "timeRequested", func: sortOnTimeRequested },
        status: { name: "status", func: sortOnStatus }
    };

    this.isAscending = leaveTimeDetailsSetting.asc;
    this.sortBy = leaveTimeDetailsSetting.nameOrder;
};

LeaveTimeDetailsTable.prototype.initSliderButton = function () {
    var self = this;
    this.sliderButton = (0, _jquery2.default)(".sliderButton");
    this.sliderButton.click(function () {
        self.sliderButtonClick();
    });

    var isOpenTable = _jquery2.default.cookie("actiPLANS-leaveDetailsTableIsOpen");
    if (isOpenTable == "false") {
        this.sliderButton.toggleClass("expand");
        (0, _jquery2.default)("#leaveTimeTable").css('display', 'none');
        this.$showCommentsCheckbox.hide();
    }
};

LeaveTimeDetailsTable.prototype.onChangeCallback = function (sortColumn) {
    if (sortColumn) {
        if (this.sortBy == sortColumn.name) {
            this.isAscending = !this.isAscending;
        } else {
            this.sortBy = sortColumn.name;
            this.isAscending = sortColumn.name != this.sortMap.period.name;
        }
    }

    var self = this;
    (0, _jquery_rpc2.default)(self.nameService + '.saveLeaveTimeDetailsSetting', [{ nameOrder: self.sortBy, asc: self.isAscending, leaveBalancesFilter: self.getBalanceTypeFilterValue() }], function () {
        return false;
    });

    this.updateData(this.requestRecords, this.isPTO, this.isSick);
};

LeaveTimeDetailsTable.prototype.updateRow = function (row, rowData) {

    var leaveType = LEAVE_TYPES[rowData.leaveTypeId];

    row.toggleClass("archivedLeaveTime", !leaveType.active);
    row.find("td.period").html(this.formatRequestPeriod(rowData));
    row.find("td.leaveType img").attr("src", leaveType.getIconPath());
    row.find("td.leaveType .for-print-only img").attr("src", leaveType.getPrintIconPath());
    row.find("td.leaveType .leaveTypeName").text(leaveType.name);
    row.find("td.timeRequested").find(".timeRequestedInDays").text(this.daysFormatter.format(rowData.leaveTimeTotal.days));
    row.find("td.timeRequested").find(".timeRequestedInHours").text(this.hoursFormatter.format(rowData.leaveTimeTotal.hours));

    var commentTextEl = row.find('td.comment .text');
    if (rowData.comment == null) {
        row.find('td.comment .text').addClass('noComment');
        commentTextEl.text('--');
    } else {
        commentTextEl.text(rowData.comment);
        commentTextEl.attr('title', rowData.comment);
    }

    var statusCell = row.find("td.status");
    statusCell.find(".statusText").text(this.getStatusText(rowData));
    statusCell.find(".when").text(this.getStatusDateText(rowData));
    statusCell.find(".byWhom").text(this.getStatusApproverText(rowData));

    if (rowData.balanceData && rowData.balanceData.balanceChangeData) {
        var self = this;
        switch (leaveType.balanceType) {
            case BalanceType.PTO:
                if (SystemSettings.apPtoBalanceCalculationEnabled) this._addDataToLeaveBalanceCell(row, rowData.balanceData.balanceChangeData, function (value) {
                    return self.ptoFormatter.format(value);
                }, function (value) {
                    return self.ptoFormatter.isNegativePTO(value);
                });else this._paintAsNotApplicable(row);
                break;
            case BalanceType.SICK:
                if (SystemSettings.apSickBalanceCalculationEnabled) {
                    this._addDataToLeaveBalanceCell(row, rowData.balanceData.balanceChangeData, function (value) {
                        return self.sickFormatter.format(value);
                    }, function (value) {
                        return self.sickFormatter.isNegativePTO(value);
                    });
                    row.find("td.balance.before").append((0, _jquery2.default)("<span class='sickSpan'>" + "Sick Days Balance" + "</span>")).addClass("sickBalanceCell");
                    row.find("td.balance.after").addClass("sickBalanceCell");
                } else {
                    this._paintAsNotApplicable(row);
                }
                break;
        }
    } else {
        this._paintAsNotApplicable(row);
    }
};

LeaveTimeDetailsTable.prototype._paintAsNotApplicable = function (row) {
    row.find("td.balance.before").text('\u2013').addClass("na");
    row.find("td.balance.after").text('\u2013').addClass("na");
};

LeaveTimeDetailsTable.prototype._addDataToLeaveBalanceCell = function (row, balanceChangeData, formatValueFn, isNegativeFn) {
    var start = balanceChangeData.startBalance;
    var end = balanceChangeData.endBalance;

    var hasStartValue = start != null;
    var hasEndValue = end != null;

    var beforeEl = row.find("td.balance.before").text(hasStartValue ? formatValueFn(start) : '\u2013').removeClass("na", !hasStartValue);

    if (hasStartValue) beforeEl.toggleClass("negative", isNegativeFn(start));else beforeEl.addClass("beforeNA");

    row.find("td.balance.after").text(hasEndValue ? formatValueFn(end) : '\u2013').toggleClass("negative", hasEndValue && isNegativeFn(end)).removeClass("na", !hasEndValue);
};

LeaveTimeDetailsTable.prototype.getStatusText = function (request) {
    return _messageResource2.default.getMessage('actiplans.request_status.approved');
};

LeaveTimeDetailsTable.prototype.getStatusDateText = function (request) {
    return request.statusDate.parseJSONDate().format("M d, Y");
};

LeaveTimeDetailsTable.prototype.getStatusApproverText = function (request) {
    if (request.approverInfo) return _messageResource2.default.getMessage('actiplans.request_status.by_user', [UserNameFormat.formatFML(request.approverInfo.firstName, request.approverInfo.lastName, request.approverInfo.middleInitial)]);

    return _messageResource2.default.getMessage('actiplans.request_status.automatic_approval');
};

LeaveTimeDetailsTable.prototype.updateSortingIndicators = function () {
    var sortIndicator = (0, _jquery2.default)("table.requests > thead .sortHeader");
    sortIndicator.removeClass("ascending");
    sortIndicator.removeClass("descending");
    (0, _jquery2.default)("table.requests > thead ." + this.sortBy).addClass(this.isAscending ? "ascending" : "descending");
};

LeaveTimeDetailsTable.prototype.formatRequestPeriod = function (request) {
    var firstDate = request.firstDate.parseJSONDate();
    var lastDate = request.lastDate.parseJSONDate();

    if (firstDate.isSameDate(lastDate)) return firstDate.format("M d, Y");else return firstDate.format("M d") + " &ndash; " + lastDate.format("M d, Y");
};

LeaveTimeDetailsTable.prototype.initAndUpdate = function (requestRecords, ptoHoursPerDay, isPTO, isSick) {
    this.ptoFormatter = new _BalanceFormatter.PTOFormatter().init(ptoHoursPerDay);
    this.sickFormatter = new _BalanceFormatter.SickFormatter().init(ptoHoursPerDay);
    this.updateData(requestRecords, isPTO, isSick);
};

LeaveTimeDetailsTable.prototype.updateData = function (requestRecords, isPTO, isSick) {
    (0, _jquery2.default)("table.requests > tbody.actualContent tr").remove();

    this.isPTO = isPTO;
    this.isSick = isSick;
    this.balancesColumnStrategy = this.getBalanceColumnStrategy(isPTO, isSick);

    var self = this;
    this.requestRecords = requestRecords;
    var records = _jquery2.default.grep(this.requestRecords, function (value) {
        return self.filterRowByBalanceType(value);
    });

    if (records.length == 0) (0, _jquery2.default)("table.requests tbody.templates tr.emptyRequest").clone().appendTo("table.requests tbody.actualContent");else {
        records.sort(self.sortMap[self.sortBy].func);
        this.updateSortingIndicators();

        var even = false;

        _jquery2.default.each(records, function () {
            var newRow = (0, _jquery2.default)("table.requests tbody.templates tr.request").clone().appendTo("table.requests tbody.actualContent");
            self.updateRow(newRow, this);
            if (even) newRow.addClass('even');else newRow.addClass('odd');
            even = !even;
        });
    }
};

LeaveTimeDetailsTable.prototype.filterRowByBalanceType = function (rowData) {
    if (!this.balancesColumnStrategy.isBalancesColumnEnabled() || !this.balancesColumnStrategy.isBalanceFilterActive()) {
        return true;
    }
    if (this.balancesColumnStrategy.isBalanceFilterActive()) {
        var balanceType = LEAVE_TYPES[rowData.leaveTypeId].balanceType;
        switch (this.leaveBalancesFilter.getValue()) {
            case LeaveBalanceFilter.PTO:
                return balanceType == BalanceType.PTO && rowData.balanceData && rowData.balanceData.balanceChangeData;
            case LeaveBalanceFilter.SICK:
                return balanceType == BalanceType.SICK && rowData.balanceData && rowData.balanceData.balanceChangeData;
        }
    }
    return true;
};

LeaveTimeDetailsTable.prototype.sliderButtonClick = function () {
    this.sliderButton.toggleClass("expand");

    var hasClassExpand = !this.sliderButton.hasClass("expand");
    _jquery2.default.cookie("actiPLANS-leaveDetailsTableIsOpen", hasClassExpand);
    if (hasClassExpand) {
        (0, _jquery2.default)("html, body").animate({ scrollTop: (0, _jquery2.default)(document).scrollTop() + 200 }, "fast");
    }
    (0, _jquery2.default)("#leaveTimeTable").slideToggle("fast");
    this.$showCommentsCheckbox.toggle(hasClassExpand);
};

LeaveTimeDetailsTable.prototype.getBalanceColumnStrategy = function (isPTO, isSick) {
    if (isPTO && isSick) {
        return new LeaveTimeDetailsBalanceColumnWithFilterStrategy().init();
    } else if (isPTO) {
        return new LeaveTimeDetailsPtoBalanceColumnStrategy().init();
    } else if (isSick) {
        return new LeaveTimeDetailsSickBalanceColumnStrategy().init();
    }
    return new NoLeaveTimeDetailsBalanceColumnStrategy().init();
};

//-----------------------------------------------------------------------------------

function LeaveTimeDetailsBalanceColumnStrategy() {}

LeaveTimeDetailsBalanceColumnStrategy.prototype.init = function () {
    return this;
};

LeaveTimeDetailsBalanceColumnStrategy.prototype.isBalancesColumnEnabled = function () {
    // abstract
};

LeaveTimeDetailsBalanceColumnStrategy.prototype.isBalanceFilterActive = function () {
    // abstract
};

//-----------------------------------------------------------------------------------


function NoLeaveTimeDetailsBalanceColumnStrategy() {}

NoLeaveTimeDetailsBalanceColumnStrategy.prototype = new LeaveTimeDetailsBalanceColumnStrategy();

NoLeaveTimeDetailsBalanceColumnStrategy.prototype.init = function () {
    (0, _jquery2.default)(".leaveTimeHistoryTable").addClass("withoutBalancesColumn withoutBalancesFilter");
    return this;
};

NoLeaveTimeDetailsBalanceColumnStrategy.prototype.isBalancesColumnEnabled = function () {
    return false;
};

NoLeaveTimeDetailsBalanceColumnStrategy.prototype.isBalanceFilterActive = function () {
    return false;
};

//-----------------------------------------------------------------------------------


function LeaveTimeDetailsBalanceColumnWithFilterStrategy() {}

LeaveTimeDetailsBalanceColumnWithFilterStrategy.prototype = new LeaveTimeDetailsBalanceColumnStrategy();

LeaveTimeDetailsBalanceColumnWithFilterStrategy.prototype.init = function () {
    (0, _jquery2.default)(".leaveTimeHistoryTable").removeClass("withoutBalancesFilter withoutBalancesColumn");
    return this;
};

LeaveTimeDetailsBalanceColumnWithFilterStrategy.prototype.isBalancesColumnEnabled = function () {
    return true;
};

LeaveTimeDetailsBalanceColumnWithFilterStrategy.prototype.isBalanceFilterActive = function () {
    return true;
};

//-----------------------------------------------------------------------------------


function LeaveTimeDetailsPtoBalanceColumnStrategy() {}

LeaveTimeDetailsPtoBalanceColumnStrategy.prototype = new LeaveTimeDetailsBalanceColumnStrategy();

LeaveTimeDetailsPtoBalanceColumnStrategy.prototype.init = function () {
    (0, _jquery2.default)(".leaveTimeHistoryTable").addClass("withoutBalancesFilter").removeClass("withoutBalancesColumn");
    (0, _jquery2.default)(".leaveTimeHistoryTable table.requests thead td.balance.combined .withoutBalancesFilterHeaderDiv").text(_messageResource2.default.getMessage("leave_balances.header.pto") + '\xA0').append((0, _jquery2.default)("<span class='withoutBalancesFilterSpan'>" + _messageResource2.default.getMessage("leave_balances.header.smaller") + "</span>"));
    return this;
};

LeaveTimeDetailsPtoBalanceColumnStrategy.prototype.isBalancesColumnEnabled = function () {
    return true;
};

LeaveTimeDetailsPtoBalanceColumnStrategy.prototype.isBalanceFilterActive = function () {
    return false;
};

//-----------------------------------------------------------------------------------


function LeaveTimeDetailsSickBalanceColumnStrategy() {}

LeaveTimeDetailsSickBalanceColumnStrategy.prototype = new LeaveTimeDetailsBalanceColumnStrategy();

LeaveTimeDetailsSickBalanceColumnStrategy.prototype.init = function () {
    (0, _jquery2.default)(".leaveTimeHistoryTable").addClass("withoutBalancesFilter").removeClass("withoutBalancesColumn");
    (0, _jquery2.default)(".leaveTimeHistoryTable table.requests thead td.balance.combined .withoutBalancesFilterHeaderDiv").text(_messageResource2.default.getMessage("leave_balances.header.sick") + '\xA0').append((0, _jquery2.default)("<span class='withoutBalancesFilterSpan'>" + _messageResource2.default.getMessage("leave_balances.header.smaller") + "</span>"));
    return this;
};

LeaveTimeDetailsSickBalanceColumnStrategy.prototype.isBalancesColumnEnabled = function () {
    return true;
};

LeaveTimeDetailsSickBalanceColumnStrategy.prototype.isBalanceFilterActive = function () {
    return false;
};

/***/ }),
/* 1936 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = init;

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _ICalendarFeedsPage = __webpack_require__(1937);

var _ICalendarFeedsPage2 = _interopRequireDefault(_ICalendarFeedsPage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function init() {
    new _ICalendarFeedsPage2.default().init((0, _jquery2.default)('.iCalendarFeedsPage'));
}

/***/ }),
/* 1937 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _utils = __webpack_require__(6);

var _LoadingPopup = __webpack_require__(299);

var _LoadingPopup2 = _interopRequireDefault(_LoadingPopup);

var _redux = __webpack_require__(7);

var _FeedsContent = __webpack_require__(1938);

var _FeedsContent2 = _interopRequireDefault(_FeedsContent);

var _HeaderPanel = __webpack_require__(1958);

var _HeaderPanel2 = _interopRequireDefault(_HeaderPanel);

var _selectors = __webpack_require__(19);

var _selectors2 = __webpack_require__(128);

var _LoadingMoire = __webpack_require__(92);

var _LoadingMoire2 = _interopRequireDefault(_LoadingMoire);

var _actions = __webpack_require__(214);

var _EditFeedLightBox = __webpack_require__(1959);

var _EditFeedLightBox2 = _interopRequireDefault(_EditFeedLightBox);

var _actions2 = __webpack_require__(265);

var _ExportICalLightBox = __webpack_require__(1963);

var _ExportICalLightBox2 = _interopRequireDefault(_ExportICalLightBox);

var _selectors3 = __webpack_require__(266);

var _LoadingContainer = __webpack_require__(28);

var _LoadingContainer2 = _interopRequireDefault(_LoadingContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ICalendarFeedsPage = function (_TemplateView) {
    _inherits(ICalendarFeedsPage, _TemplateView);

    function ICalendarFeedsPage(_ref) {
        var startPageLoading = _ref.startPageLoading,
            openCreateFeedLightBox = _ref.openCreateFeedLightBox,
            openExportICalLightBox = _ref.openExportICalLightBox;

        _classCallCheck(this, ICalendarFeedsPage);

        var _this = _possibleConstructorReturn(this, (ICalendarFeedsPage.__proto__ || Object.getPrototypeOf(ICalendarFeedsPage)).call(this));

        _this.state = {
            tabsShown: true,
            loading: false,
            lightBoxLoading: false,
            feedsContentLoading: false
        };

        _this.actions = {
            startPageLoading: startPageLoading,
            openCreateFeedLightBox: openCreateFeedLightBox,
            openExportICalLightBox: openExportICalLightBox
        };

        _this.onStatePropertyChanged('tabsShown', function (tabsShown) {
            return _this.headerPanel.toggle(tabsShown);
        });

        _this.onStatePropertyChanged('loading', function (loading) {
            _this.loadingMoire.toggle(loading);
            _this.feedsContentContainer.toggle(!loading);
        });

        _this.onStatePropertyChanged('lightBoxLoading', function (lightBoxLoading) {
            return _this.loadingPopup.toggle(lightBoxLoading);
        });

        _this.onStatePropertyChanged('feedsContentLoading', function (feedsContentLoading) {
            return _this.feedsContentContainer.setState({ loading: feedsContentLoading });
        });
        return _this;
    }

    _createClass(ICalendarFeedsPage, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class=\'iCalPage\'>\n                    <div id="incorrectDateTooltip" class="yellowTooltip tooltipText">\n                        <div id="incorrectDateTooltip_textPlaceholder"/>\n                    </div>\n                    <div class=\'pageHeader\'>\n                        <%=pageHeader%>\n                    </div>\n                    <div class=\'iCalContent\'>\n                        <div class=\'headerPanelWrapper\'/>\n                        <div class=\'feedsContentArea\'/>\n                    </div>\n                    <div class=\'createLightboxPlaceholder\'/>\n                    <div class=\'editLightboxPlaceholder\'/>\n                </div>';
        }
    }, {
        key: 'messageKeys',
        value: function messageKeys() {
            return {
                pageHeader: 'icalendar.page.title'
            };
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            this.find('.yellowTooltip').hide();
            this.headerPanel = new _HeaderPanel2.default({
                onCreateButtonClick: this.actions.openCreateFeedLightBox,
                onExportButtonClick: this.actions.openExportICalLightBox
            }).init(this.find('.headerPanelWrapper'));

            this.feedsContentContainer = new _LoadingContainer2.default({
                contentComponent: new _FeedsContent2.default({
                    onCreateButtonClick: this.actions.openCreateFeedLightBox,
                    onExportButtonClick: this.actions.openExportICalLightBox
                }),
                loadingMoireConfig: {
                    additionalSpinnerSettings: {
                        radius: 17,
                        length: 13,
                        width: 4
                    }
                }
            }).init(this.find('.feedsContentArea'));

            this.loadingMoire = new _LoadingMoire2.default({
                additionalSpinnerSettings: {
                    radius: 17,
                    length: 13,
                    width: 4,
                    position: 'fixed'
                }
            }).init(this.getEl());

            this.actions.startPageLoading();

            new _EditFeedLightBox2.default().init(this.getEl());
            new _ExportICalLightBox2.default().init(this.getEl());

            this.loadingPopup = new _LoadingPopup2.default().init("contentLoadingPopup");
        }
    }]);

    return ICalendarFeedsPage;
}(_TemplateView3.default);

exports.default = (0, _utils.connect)(function (state) {
    return {
        tabsShown: (0, _selectors.canManageAccountsAndPermissions)(state),
        loading: (0, _selectors2.isLoading)(state),
        lightBoxLoading: (0, _selectors3.isLightBoxLoading)(state),
        feedsContentLoading: (0, _selectors2.isFeedsContentLoading)(state)
    };
}, function (dispatch) {
    return (0, _redux.bindActionCreators)({
        startPageLoading: _actions.startPageLoading,
        openCreateFeedLightBox: _actions2.openCreateFeedLightBox,
        openExportICalLightBox: _actions2.openExportICalLightBox
    }, dispatch);
})(ICalendarFeedsPage);

/***/ }),
/* 1938 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _NoFeedsArea = __webpack_require__(1939);

var _NoFeedsArea2 = _interopRequireDefault(_NoFeedsArea);

var _constants = __webpack_require__(51);

var _utils = __webpack_require__(6);

var _selectors = __webpack_require__(128);

var _redux = __webpack_require__(7);

var _selectors2 = __webpack_require__(19);

var _FeedsTable = __webpack_require__(1940);

var _FeedsTable2 = _interopRequireDefault(_FeedsTable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FeedsContent = function (_TemplateView) {
    _inherits(FeedsContent, _TemplateView);

    function FeedsContent(_ref) {
        var onCreateButtonClick = _ref.onCreateButtonClick,
            onExportButtonClick = _ref.onExportButtonClick;

        _classCallCheck(this, FeedsContent);

        var _this = _possibleConstructorReturn(this, (FeedsContent.__proto__ || Object.getPrototypeOf(FeedsContent)).call(this));

        _this.state = {
            activeTab: _constants.ICalTabType.USER_FEEDS,
            feedsEmpty: false,
            allFeedsAvailable: false
        };

        _this.callbacks = {
            onCreateButtonClick: onCreateButtonClick,
            onExportButtonClick: onExportButtonClick
        };

        _this.onStatePropertyChanged('activeTab', function (activeTab) {
            return _this.noFeedsArea.setState({ mode: activeTab });
        });

        _this.onStatePropertyChanged('feedsEmpty', function (feedsEmpty) {
            _this.feedsTable.toggle(!feedsEmpty);
            _this.noFeedsArea.toggle(feedsEmpty);
        });

        _this.onStatePropertyChanged('allFeedsAvailable', function (allFeedsAvailable) {
            return _this.noFeedsArea.setState({ allFeedsAvailable: allFeedsAvailable });
        });
        return _this;
    }

    _createClass(FeedsContent, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class=\'feedsContent\'>\n                    <div class=\'feedsTableWrapper\'/>\n                    <div class=\'noFeedsContentWrapper\'/>\n                </div>';
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            this.noFeedsArea = new _NoFeedsArea2.default({
                onCreateButtonClick: this.callbacks.onCreateButtonClick,
                onExportButtonClick: this.callbacks.onExportButtonClick
            }).init(this.find('.noFeedsContentWrapper'));

            this.feedsTable = new _FeedsTable2.default().init(this.find('.feedsTableWrapper'));
        }
    }]);

    return FeedsContent;
}(_TemplateView3.default);

exports.default = (0, _utils.connect)(function (state) {
    return {
        activeTab: (0, _selectors.getActiveTab)(state),
        feedsEmpty: (0, _selectors.isFeedsEmpty)(state),
        allFeedsAvailable: (0, _selectors2.canManageAccountsAndPermissions)(state)
    };
}, function (dispatch) {
    return (0, _redux.bindActionCreators)({}, dispatch);
})(FeedsContent);

/***/ }),
/* 1939 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _constants = __webpack_require__(51);

var _Button = __webpack_require__(33);

var _Button2 = _interopRequireDefault(_Button);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _Link = __webpack_require__(530);

var _Link2 = _interopRequireDefault(_Link);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NoFeedsArea = function (_TemplateView) {
    _inherits(NoFeedsArea, _TemplateView);

    function NoFeedsArea(_ref) {
        var onCreateButtonClick = _ref.onCreateButtonClick,
            onExportButtonClick = _ref.onExportButtonClick;

        _classCallCheck(this, NoFeedsArea);

        var _this = _possibleConstructorReturn(this, (NoFeedsArea.__proto__ || Object.getPrototypeOf(NoFeedsArea)).call(this));

        _this.state = {
            mode: _constants.ICalTabType.USER_FEEDS,
            allFeedsAvailable: false
        };

        _this.callbacks = {
            onCreateButtonClick: onCreateButtonClick,
            onExportButtonClick: onExportButtonClick
        };

        _this.onAnyStatePropertyChanged(['mode', 'allFeedsAvailable'], function () {
            _this.$allFeedsContent.toggle(_this.state.mode === _constants.ICalTabType.ALL_FEEDS && _this.state.allFeedsAvailable);
            _this.$sharedFeedsContent.toggle(_this.state.mode === _constants.ICalTabType.USER_FEEDS || !_this.state.allFeedsAvailable);
        });
        return _this;
    }

    _createClass(NoFeedsArea, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class=\'noFeedsContent\'>\n                    <div class=\'icon\'/>\n                    <div class=\'allFeedsContent content\'>\n                        <div class=\'description\'>\n                            <div class=\'commonText\'>\n                                <%=descriptionFirstPart%>\n                            </div>\n                            <div class=\'specialText\'>\n                                <%=allFeedsSpecialText%>\n                                <span class=\'learnLink\'/>\n                            </div>\n                        </div>\n                        <div class=\'buttonsArea\'>\n                            <div class=\'button createButton\'/>\n                            <div class=\'buttonsSeparator\'>\n                                <%=buttonsSeparatorText%>\n                            </div>\n                            <div class=\'button exportButton\'/>\n                        </div>\n                    </div>\n                    <div class=\'sharedFeedsContent content\'>\n                        <div class=\'description\'>\n                            <div class=\'commonText\'>\n                                <%=descriptionFirstPart%>\n                            </div>\n                            <div class=\'specialText\'>\n                                <%=sharedFeedsSpecialText%>\n                            </div>\n                        </div>\n                        <span class=\'learnLink\'/>\n                    </div>\n                </div>';
        }
    }, {
        key: 'messageKeys',
        value: function messageKeys() {
            return {
                descriptionFirstPart: 'icalendar.page.feeds.empty.part1',
                allFeedsSpecialText: 'icalendar.page.feeds.empty.part2.all',
                sharedFeedsSpecialText: 'icalendar.page.feeds.empty.part2.user',
                buttonsSeparatorText: 'common.or'
            };
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            this.$allFeedsContent = this.find('.allFeedsContent');
            this.$sharedFeedsContent = this.find('.sharedFeedsContent');

            new _Link2.default({
                text: _messageResource2.default.getMessage('icalendar.page.feeds.empty.learn'),
                extraClass: 'learnMore',
                reference: _constants.LEARN_MORE_URL
            }).init(this.$allFeedsContent.find('.learnLink'));

            new _Link2.default({
                text: _messageResource2.default.getMessage('icalendar.page.feeds.empty.learn'),
                extraClass: 'learnMore',
                reference: _constants.LEARN_MORE_URL
            }).init(this.$sharedFeedsContent.find('.learnLink'));

            new _Button2.default({
                label: _messageResource2.default.getMessage('icalendar.page.buttons.create'),
                withPlusIcon: true,
                onClickCb: this.callbacks.onCreateButtonClick
            }).init(this.find('.createButton'));

            new _Button2.default({
                label: _messageResource2.default.getMessage('icalendar.page.buttons.export'),
                withPlusIcon: true,
                onClickCb: this.callbacks.onExportButtonClick
            }).init(this.find('.exportButton'));

            this.renderInitialState();
        }
    }]);

    return NoFeedsArea;
}(_TemplateView3.default);

exports.default = NoFeedsArea;

/***/ }),
/* 1940 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _SharedFeedsTableHeader = __webpack_require__(1941);

var _SharedFeedsTableHeader2 = _interopRequireDefault(_SharedFeedsTableHeader);

var _AllFeedsTableHeader = __webpack_require__(1942);

var _AllFeedsTableHeader2 = _interopRequireDefault(_AllFeedsTableHeader);

var _constants = __webpack_require__(51);

var _utils = __webpack_require__(6);

var _selectors = __webpack_require__(128);

var _redux = __webpack_require__(7);

var _actions = __webpack_require__(214);

var _AllFeedsRow = __webpack_require__(1943);

var _AllFeedsRow2 = _interopRequireDefault(_AllFeedsRow);

var _SharedFeedsRow = __webpack_require__(1953);

var _SharedFeedsRow2 = _interopRequireDefault(_SharedFeedsRow);

var _FeedsTableContent = __webpack_require__(1956);

var _FeedsTableContent2 = _interopRequireDefault(_FeedsTableContent);

var _actions2 = __webpack_require__(265);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FeedsTable = function (_TemplateView) {
    _inherits(FeedsTable, _TemplateView);

    function FeedsTable(_ref) {
        var editFeed = _ref.editFeed,
            changeAllSorting = _ref.changeAllSorting,
            changeSharedSorting = _ref.changeSharedSorting,
            getFeedUrl = _ref.getFeedUrl,
            openEditFeedLightBox = _ref.openEditFeedLightBox;

        _classCallCheck(this, FeedsTable);

        var _this = _possibleConstructorReturn(this, (FeedsTable.__proto__ || Object.getPrototypeOf(FeedsTable)).call(this));

        _this.state = {
            activeTab: _constants.ICalTabType.USER_FEEDS,
            allFeeds: [],
            sharedFeeds: [],
            allSorting: _constants.DEFAULT_SORTING,
            sharedSorting: _constants.DEFAULT_SORTING
        };

        _this.actions = {
            editFeed: editFeed,
            changeAllSorting: changeAllSorting,
            changeSharedSorting: changeSharedSorting,
            getFeedUrl: getFeedUrl,
            openEditFeedLightBox: openEditFeedLightBox
        };

        _this.onStatePropertyChanged('activeTab', function (activeTab) {
            _this.$sharedFeedsWrapper.toggle(activeTab === _constants.ICalTabType.USER_FEEDS);
            _this.$allFeedsWrapper.toggle(activeTab === _constants.ICalTabType.ALL_FEEDS);
        });

        _this.onStatePropertyChanged('allFeeds', function (feeds) {
            _this.allFeedsContent.setState({ feeds: feeds });
        });

        _this.onStatePropertyChanged('sharedFeeds', function (feeds) {
            _this.sharedFeedsContent.setState({ feeds: feeds });
        });

        _this.onStatePropertyDeeplyChanged('allSorting', function (sorting) {
            _this.allFeedsHeader.setState({ sorting: sorting });
            _this.allFeedsContent.setState({ sorting: sorting });
        });

        _this.onStatePropertyDeeplyChanged('sharedSorting', function (sorting) {
            _this.sharedFeedsHeader.setState({ sorting: sorting });
            _this.sharedFeedsContent.setState({ sorting: sorting });
        });
        return _this;
    }

    _createClass(FeedsTable, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class=\'feedsTable\'>\n                    <div class=\'allFeedsWrapper\'/>\n                    <div class=\'sharedFeedsWrapper\'/>\n                </div>';
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            var _this2 = this;

            this.$allFeedsWrapper = this.find('.allFeedsWrapper');
            this.$sharedFeedsWrapper = this.find('.sharedFeedsWrapper');

            this.sharedFeedsHeader = new _SharedFeedsTableHeader2.default({
                changeSorting: this.actions.changeSharedSorting
            }).init(this.$sharedFeedsWrapper);
            this.sharedFeedsContent = new _FeedsTableContent2.default({
                renderFeed: function renderFeed(feed) {
                    return new _SharedFeedsRow2.default({
                        feed: feed,
                        users: _this2.state.users,
                        userGroups: _this2.state.userGroups,
                        timeZoneGroups: _this2.state.timeZoneGroups,
                        leaveTypes: _this2.state.leaveTypes,
                        getFeedUrl: _this2.actions.getFeedUrl
                    });
                }
            }).init(this.$sharedFeedsWrapper);

            this.allFeedsHeader = new _AllFeedsTableHeader2.default({
                changeSorting: this.actions.changeAllSorting
            }).init(this.$allFeedsWrapper);
            this.allFeedsContent = new _FeedsTableContent2.default({
                renderFeed: function renderFeed(feed) {
                    return new _AllFeedsRow2.default({
                        feed: feed,
                        users: _this2.state.users,
                        userGroups: _this2.state.userGroups,
                        timeZoneGroups: _this2.state.timeZoneGroups,
                        leaveTypes: _this2.state.leaveTypes,
                        onEditClick: _this2.actions.openEditFeedLightBox
                    });
                }
            }).init(this.$allFeedsWrapper);
        }
    }]);

    return FeedsTable;
}(_TemplateView3.default);

exports.default = (0, _utils.connect)(function (state) {
    return {
        activeTab: (0, _selectors.getActiveTab)(state),
        allFeeds: (0, _selectors.getAllFeedsForTable)(state),
        sharedFeeds: (0, _selectors.getSharedFeedsForTable)(state),
        allSorting: (0, _selectors.getAllFeedsSorting)(state),
        sharedSorting: (0, _selectors.getSharedFeedsSorting)(state)
    };
}, function (dispatch) {
    return (0, _redux.bindActionCreators)({
        editFeed: _actions.editFeed,
        changeAllSorting: _actions.changeAllSorting,
        changeSharedSorting: _actions.changeSharedSorting,
        getFeedUrl: _actions.getFeedUrl,
        openEditFeedLightBox: _actions2.openEditFeedLightBox
    }, dispatch);
})(FeedsTable);

/***/ }),
/* 1941 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _constants = __webpack_require__(51);

var _FeedsTableSortingMenu = __webpack_require__(958);

var _FeedsTableSortingMenu2 = _interopRequireDefault(_FeedsTableSortingMenu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SharedFeedsTableHeader = function (_TemplateView) {
    _inherits(SharedFeedsTableHeader, _TemplateView);

    function SharedFeedsTableHeader(_ref) {
        var changeSorting = _ref.changeSorting;

        _classCallCheck(this, SharedFeedsTableHeader);

        var _this = _possibleConstructorReturn(this, (SharedFeedsTableHeader.__proto__ || Object.getPrototypeOf(SharedFeedsTableHeader)).call(this));

        _this.state = {
            sorting: _constants.DEFAULT_SORTING
        };

        _this.callbacks = {
            changeSorting: changeSorting
        };

        _this.onStatePropertyDeeplyChanged('sorting', function (sorting) {
            return _this.sortingArea.setState({ sorting: sorting });
        });
        return _this;
    }

    _createClass(SharedFeedsTableHeader, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class=\'header sharedFeeds\'>\n                    <div class=\'feedNameColumn\'/>\n                    <div class=\'calendarDetailsColumn\'>\n                        <%=calendarDetailsTitle%>\n                    </div>\n                    <div class=\'feedUrlColumn\'>\n                        <%=feedUrlTitle%>\n                    </div>\n                </div>';
        }
    }, {
        key: 'messageKeys',
        value: function messageKeys() {
            return {
                calendarDetailsTitle: 'icalendar.page.table.column.details',
                feedUrlTitle: 'icalendar.page.table.columns.url'
            };
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            this.sortingArea = new _FeedsTableSortingMenu2.default({
                changeSorting: this.callbacks.changeSorting
            }).init(this.find('.feedNameColumn'));
        }
    }]);

    return SharedFeedsTableHeader;
}(_TemplateView3.default);

exports.default = SharedFeedsTableHeader;

/***/ }),
/* 1942 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _FeedsTableSortingMenu = __webpack_require__(958);

var _FeedsTableSortingMenu2 = _interopRequireDefault(_FeedsTableSortingMenu);

var _constants = __webpack_require__(51);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AllFeedsTableHeader = function (_TemplateView) {
    _inherits(AllFeedsTableHeader, _TemplateView);

    function AllFeedsTableHeader(_ref) {
        var changeSorting = _ref.changeSorting;

        _classCallCheck(this, AllFeedsTableHeader);

        var _this = _possibleConstructorReturn(this, (AllFeedsTableHeader.__proto__ || Object.getPrototypeOf(AllFeedsTableHeader)).call(this));

        _this.state = {
            sorting: _constants.DEFAULT_SORTING
        };

        _this.callbacks = {
            changeSorting: changeSorting
        };

        _this.onStatePropertyDeeplyChanged('sorting', function (sorting) {
            return _this.sortingArea.setState({ sorting: sorting });
        });
        return _this;
    }

    _createClass(AllFeedsTableHeader, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class=\'header allFeeds\'>\n                    <div class=\'feedNameColumn\'/>\n                    <div class=\'calendarDetailsColumn\'>\n                        <%=calendarDetailsTitle%>\n                    </div>\n                    <div class=\'sharedUsersColumn\'>\n                        <%=sharedWithTitle%>\n                    </div>\n                    <div class=\'lastSyncColumn\'>\n                        <%=lastSyncTitle%>\n                    </div>\n                    <div class=\'actionsColumn\'>\n                        <%=actionsTitle%>\n                    </div>\n                </div>';
        }
    }, {
        key: 'messageKeys',
        value: function messageKeys() {
            return {
                calendarDetailsTitle: 'icalendar.page.table.column.details',
                sharedWithTitle: 'icalendar.page.table.columns.shared',
                lastSyncTitle: 'icalendar.page.table.columns.sync',
                actionsTitle: 'icalendar.page.table.columns.actions'
            };
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            this.sortingArea = new _FeedsTableSortingMenu2.default({
                changeSorting: this.callbacks.changeSorting,
                isLastSyncSortingIncluded: true
            }).init(this.find('.feedNameColumn'));
        }
    }]);

    return AllFeedsTableHeader;
}(_TemplateView3.default);

exports.default = AllFeedsTableHeader;

/***/ }),
/* 1943 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _FeedNameCell = __webpack_require__(959);

var _FeedNameCell2 = _interopRequireDefault(_FeedNameCell);

var _FeedDetailsCell = __webpack_require__(960);

var _FeedDetailsCell2 = _interopRequireDefault(_FeedDetailsCell);

var _FeedUserSelection = __webpack_require__(961);

var _FeedUserSelection2 = _interopRequireDefault(_FeedUserSelection);

var _FeedActionsCell = __webpack_require__(1949);

var _FeedActionsCell2 = _interopRequireDefault(_FeedActionsCell);

var _FeedLastSyncCell = __webpack_require__(1950);

var _FeedLastSyncCell2 = _interopRequireDefault(_FeedLastSyncCell);

var _DeleteDialog = __webpack_require__(1951);

var _RegenerateLinksDialog = __webpack_require__(1952);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AllFeedsRow = function (_TemplateView) {
    _inherits(AllFeedsRow, _TemplateView);

    function AllFeedsRow(_ref) {
        var feed = _ref.feed,
            onEditClick = _ref.onEditClick;

        _classCallCheck(this, AllFeedsRow);

        var _this = _possibleConstructorReturn(this, (AllFeedsRow.__proto__ || Object.getPrototypeOf(AllFeedsRow)).call(this));

        _this.params = {
            id: feed.id
        };

        _this.state = {
            name: feed.name,
            createdDate: feed.createdDate,
            creator: feed.creator,
            editedDate: feed.editedDate,
            editor: feed.editor,
            leaveTypes: feed.leaveTypes,
            usersSelection: feed.usersSelection,
            sharedUsersSelection: feed.sharedUsersSelection,
            lastSyncDate: feed.lastSyncDate,
            recentlyConfiguredFeed: false
        };

        _this.callbacks = {
            onEditClick: onEditClick
        };

        _this.onStateDeeplyChanged(function () {
            _this.getEl().empty();
            _this._update();
        });
        return _this;
    }

    _createClass(AllFeedsRow, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class=\'feedRow allFeeds\'/>';
        }
    }, {
        key: '_update',
        value: function _update() {
            var _this2 = this;

            this.getEl().toggleClass('recentlyConfiguredFeed', this.state.recentlyConfiguredFeed);

            new _FeedNameCell2.default({
                name: this.state.name,
                createdDate: this.state.createdDate,
                creator: this.state.creator,
                editedDate: this.state.editedDate,
                editor: this.state.editor,
                onNameClick: function onNameClick() {
                    return _this2.callbacks.onEditClick(_this2.params.id);
                }
            }).init(this.getEl());

            new _FeedDetailsCell2.default({
                leaveTypes: this.state.leaveTypes,
                userSelection: this.state.userSelection
            }).init(this.getEl());

            new _FeedUserSelection2.default({
                extraClass: 'sharedWithCell',
                userSelection: this.state.sharedUserSelection,
                shared: true
            }).init(this.getEl());

            new _FeedLastSyncCell2.default({
                lastSyncDate: this.state.lastSyncDate
            }).init(this.getEl());

            this.regenerateDialog = (0, _RegenerateLinksDialog.getRegenerateDialog)();
            this.deleteDialog = (0, _DeleteDialog.getDeleteDialog)();
            this.feedActionsCell = new _FeedActionsCell2.default({
                onRegenerateClick: function onRegenerateClick($targetEl) {
                    _this2.regenerateDialog.setState({
                        iCalSettingsId: _this2.params.id
                    });
                    _this2.regenerateDialog.showAt($targetEl, function () {
                        return _this2.feedActionsCell.setState({ regenerateActive: false });
                    });
                    _this2.feedActionsCell.setState({ regenerateActive: true });
                },
                onDeleteClick: function onDeleteClick($targetEl) {
                    _this2.deleteDialog.setState({
                        iCalSettingsId: _this2.params.id
                    });
                    _this2.deleteDialog.showAt($targetEl, function () {
                        return _this2.feedActionsCell.setState({ deleteActive: false });
                    });
                    _this2.feedActionsCell.setState({ deleteActive: true });
                }
            }).init(this.getEl());
        }
    }]);

    return AllFeedsRow;
}(_TemplateView3.default);

exports.default = AllFeedsRow;

/***/ }),
/* 1944 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getInstance = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _DropdownDialogWithPointerWrapper = __webpack_require__(182);

var _DropdownDialogWithPointerWrapper2 = _interopRequireDefault(_DropdownDialogWithPointerWrapper);

var _ScrollableContainer = __webpack_require__(49);

var _ScrollableContainer2 = _interopRequireDefault(_ScrollableContainer);

var _UsersSelectionDetailedInfoContent = __webpack_require__(1945);

var _UsersSelectionDetailedInfoContent2 = _interopRequireDefault(_UsersSelectionDetailedInfoContent);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UsersSelectionDetailedInfo = function (_TemplateView) {
    _inherits(UsersSelectionDetailedInfo, _TemplateView);

    function UsersSelectionDetailedInfo() {
        _classCallCheck(this, UsersSelectionDetailedInfo);

        var _this = _possibleConstructorReturn(this, (UsersSelectionDetailedInfo.__proto__ || Object.getPrototypeOf(UsersSelectionDetailedInfo)).call(this));

        _this.state = {
            titleKey: '',
            groups: [],
            users: [],
            groupType: null
        };

        _this.onStateChanged(function (state) {
            return _this.usersTooltipContent.setState(state);
        });
        return _this;
    }

    _createClass(UsersSelectionDetailedInfo, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class=\'components_usersSelectionDetailedInfo\'/>';
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            this.usersTooltipContent = new _UsersSelectionDetailedInfoContent2.default({
                titleKey: this.state.titleKey,
                groups: this.state.groups,
                users: this.state.users,
                groupType: this.state.groupType
            });

            this.scrollableContainer = new _ScrollableContainer2.default(null, this.usersTooltipContent, {
                containerClass: 'usersSelectionDetailedInfoScroll'
            });

            this.dialog = new _DropdownDialogWithPointerWrapper2.default({
                dialog: this.scrollableContainer,
                dialogOffsets: {
                    top: 10,
                    left: 0
                },
                pointerLeftOffset: 0
            }).init(this.getEl());
        }
    }, {
        key: 'showAt',
        value: function showAt($el) {
            this.dialog.showAt($el, {
                my: 'left top',
                at: 'left bottom',
                collision: 'none'
            });
            this.scrollableContainer.forceUpdate();
        }
    }]);

    return UsersSelectionDetailedInfo;
}(_TemplateView3.default);

var instance = null;
var getInstance = exports.getInstance = function getInstance() {
    if (instance === null) {
        instance = new UsersSelectionDetailedInfo().init((0, _jquery2.default)('body'));
    }
    return instance;
};

/***/ }),
/* 1945 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _UserNameFormat = __webpack_require__(17);

var _UserNameFormat2 = _interopRequireDefault(_UserNameFormat);

var _GroupType = __webpack_require__(34);

var _GroupType2 = _interopRequireDefault(_GroupType);

var _UserSelectionInfoListItem = __webpack_require__(1946);

var _UserSelectionInfoListItem2 = _interopRequireDefault(_UserSelectionInfoListItem);

var _atUtils = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UsersSelectionDetailedInfoContent = function (_TemplateView) {
    _inherits(UsersSelectionDetailedInfoContent, _TemplateView);

    function UsersSelectionDetailedInfoContent() {
        _classCallCheck(this, UsersSelectionDetailedInfoContent);

        var _this = _possibleConstructorReturn(this, (UsersSelectionDetailedInfoContent.__proto__ || Object.getPrototypeOf(UsersSelectionDetailedInfoContent)).call(this));

        _this.state = {
            titleKey: '',
            groups: [],
            users: [],
            groupType: null
        };

        _this.onStateChanged(function () {
            return _this._update();
        });
        return _this;
    }

    _createClass(UsersSelectionDetailedInfoContent, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class=\'usersSelectionDetailedInfoContent\'>\n                    <div class=\'title\'/>\n                    <ul class=\'groupsList itemsList\'/>\n                    <div class=\'usersTitle\'><%=usersTitle%></div>\n                    <ul class=\'usersList itemsList\'/>\n                </div>';
        }
    }, {
        key: 'messageKeys',
        value: function messageKeys() {
            return {
                usersTitle: 'icalendar.page.table.users.detailedInfo.userList'
            };
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            this.$title = this.find('.title');
            this.$departmentsList = this.find('.groupsList');
            this.$usersList = this.find('.usersList');
            this.$usersTitle = this.find('.usersTitle');
        }
    }, {
        key: '_update',
        value: function _update() {
            var _this2 = this;

            this.$departmentsList.empty();
            this.$usersList.empty();

            var hasUserGroups = this.state.groups.length > 0;

            this.$title.text(_messageResource2.default.getMessage(this.state.titleKey, [this.getTitle()]));

            this.$usersTitle.toggle(hasUserGroups && this.state.users.length > 0);

            if (hasUserGroups) {
                this.state.groups.forEach(function (userGroup) {
                    new _UserSelectionInfoListItem2.default({
                        text: (0, _atUtils.escapeHtmlSymbols)(userGroup.name)
                    }).init(_this2.$departmentsList);
                });
            }

            this.state.users.forEach(function (user) {
                new _UserSelectionInfoListItem2.default({
                    text: (0, _atUtils.escapeHtmlSymbols)(_UserNameFormat2.default.formatLFM(user.firstName, user.lastName, user.middleInitial))
                }).init(_this2.$usersList);
            });
        }
    }, {
        key: 'getTitle',
        value: function getTitle() {
            return this.state.groups.length > 0 ? this.getUserGroupsPluralText(this.state.groupType) : _messageResource2.default.getMessage('common.users');
        }
    }, {
        key: 'getUserGroupsPluralText',
        value: function getUserGroupsPluralText(groupType) {
            return groupType === _GroupType2.default.TIME_ZONE_GROUP ? _messageResource2.default.getMessage('common.time_zone_groups') : _messageResource2.default.getMessage('common.user_groups');
        }
    }]);

    return UsersSelectionDetailedInfoContent;
}(_TemplateView3.default);

exports.default = UsersSelectionDetailedInfoContent;

/***/ }),
/* 1946 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UserSelectionInfoListItem = function (_TemplateView) {
    _inherits(UserSelectionInfoListItem, _TemplateView);

    function UserSelectionInfoListItem(_ref) {
        var text = _ref.text;

        _classCallCheck(this, UserSelectionInfoListItem);

        var _this = _possibleConstructorReturn(this, (UserSelectionInfoListItem.__proto__ || Object.getPrototypeOf(UserSelectionInfoListItem)).call(this));

        _this.params = {
            text: text
        };
        return _this;
    }

    _createClass(UserSelectionInfoListItem, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<li class="userSelectionInfoListItem"><%=text%></li>';
        }
    }, {
        key: 'templateModel',
        value: function templateModel() {
            return {
                text: this.params.text
            };
        }
    }]);

    return UserSelectionInfoListItem;
}(_TemplateView3.default);

exports.default = UserSelectionInfoListItem;

/***/ }),
/* 1947 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _constants = __webpack_require__(51);

var _LeaveTypeIcon = __webpack_require__(1948);

var _LeaveTypeIcon2 = _interopRequireDefault(_LeaveTypeIcon);

var _atUtils = __webpack_require__(5);

var _SimpleSingletonTooltip = __webpack_require__(45);

var _SimpleSingletonTooltip2 = _interopRequireDefault(_SimpleSingletonTooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FeedLeaveTypesSelection = function (_TemplateView) {
    _inherits(FeedLeaveTypesSelection, _TemplateView);

    function FeedLeaveTypesSelection(_ref) {
        var leaveTypes = _ref.leaveTypes;

        _classCallCheck(this, FeedLeaveTypesSelection);

        var _this = _possibleConstructorReturn(this, (FeedLeaveTypesSelection.__proto__ || Object.getPrototypeOf(FeedLeaveTypesSelection)).call(this));

        _this.params = {
            leaveTypes: leaveTypes
        };
        return _this;
    }

    _createClass(FeedLeaveTypesSelection, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class=\'leaveTypeSelection\'>\n                    <div class=\'emptyText\'>\n                        <%=emptyText%>\n                    </div>\n                    <div class=\'icons\'/>\n                    <div class=\'counter\'/>\n                </div>';
        }
    }, {
        key: 'messageKeys',
        value: function messageKeys() {
            return {
                emptyText: 'icalendar.page.table.leave_types.none'
            };
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            var _this2 = this;

            var leaveTypesAmount = this.params.leaveTypes.length;
            this.find('.emptyText').toggle(leaveTypesAmount === 0);

            if (leaveTypesAmount > _constants.RENDER_LEAVE_TYPES_LIMIT) this.find('.counter').text('+' + (leaveTypesAmount - _constants.RENDER_LEAVE_TYPES_LIMIT));

            this.params.leaveTypes.slice(0, _constants.RENDER_LEAVE_TYPES_LIMIT).forEach(function (leaveType) {
                new _LeaveTypeIcon2.default({
                    id: leaveType.id,
                    iconId: leaveType.iconId,
                    name: leaveType.name
                }).init(_this2.find('.icons'));
            });

            if (leaveTypesAmount > _constants.RENDER_LEAVE_TYPES_LIMIT) {

                var tooltipContent = this.params.leaveTypes.slice(_constants.RENDER_LEAVE_TYPES_LIMIT, leaveTypesAmount).map(function (leaveType) {
                    return '<div>' + (0, _atUtils.escapeHtmlSymbols)(leaveType.name) + '</div>';
                }).join('');

                (0, _SimpleSingletonTooltip2.default)(this.find('.counter'), {
                    html: tooltipContent,
                    extraClass: _constants.FEEDS_TOOLTIP_EXTRA_CLASS
                });
            }
        }
    }]);

    return FeedLeaveTypesSelection;
}(_TemplateView3.default);

exports.default = FeedLeaveTypesSelection;

/***/ }),
/* 1948 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _constants = __webpack_require__(51);

var _SimpleSingletonTooltip = __webpack_require__(45);

var _SimpleSingletonTooltip2 = _interopRequireDefault(_SimpleSingletonTooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LeaveTypeIcon = function (_TemplateView) {
    _inherits(LeaveTypeIcon, _TemplateView);

    function LeaveTypeIcon(_ref) {
        var name = _ref.name,
            iconId = _ref.iconId;

        _classCallCheck(this, LeaveTypeIcon);

        var _this = _possibleConstructorReturn(this, (LeaveTypeIcon.__proto__ || Object.getPrototypeOf(LeaveTypeIcon)).call(this));

        _this.params = {
            name: name,
            iconId: iconId
        };
        return _this;
    }

    _createClass(LeaveTypeIcon, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class=\'leaveTypeIcon\'>\n                    <img src=\'<%=iconPath%>\'/>\n                </div>';
        }
    }, {
        key: 'templateModel',
        value: function templateModel() {
            return {
                iconPath: window.getLeaveTypeIconPath(this.params.iconId)
            };
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            (0, _SimpleSingletonTooltip2.default)(this.getEl(), {
                text: this.params.name,
                extraClass: _constants.FEEDS_TOOLTIP_EXTRA_CLASS
            });
        }
    }]);

    return LeaveTypeIcon;
}(_TemplateView3.default);

exports.default = LeaveTypeIcon;

/***/ }),
/* 1949 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _constants = __webpack_require__(51);

var _SimpleSingletonTooltip = __webpack_require__(45);

var _SimpleSingletonTooltip2 = _interopRequireDefault(_SimpleSingletonTooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FeedActionsCell = function (_TemplateView) {
    _inherits(FeedActionsCell, _TemplateView);

    function FeedActionsCell(_ref) {
        var onRegenerateClick = _ref.onRegenerateClick,
            onDeleteClick = _ref.onDeleteClick;

        _classCallCheck(this, FeedActionsCell);

        var _this = _possibleConstructorReturn(this, (FeedActionsCell.__proto__ || Object.getPrototypeOf(FeedActionsCell)).call(this));

        _this.callbacks = {
            onRegenerateClick: onRegenerateClick,
            onDeleteClick: onDeleteClick
        };

        _this.state = {
            regenerateActive: false,
            deleteActive: false
        };

        _this.onStatePropertyChanged('regenerateActive', function (active) {
            _this.$regenerateButton.toggleClass('active', active);
        });

        _this.onStatePropertyChanged('deleteActive', function (active) {
            _this.$deleteButton.toggleClass('active', active);
        });
        return _this;
    }

    _createClass(FeedActionsCell, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class=\'actionsCell\'>\n                    <div class=\'separator\'/>\n                    <div class=\'regenerateFeed feedAction\'/>\n                    <div class=\'separator\'/>\n                    <div class=\'deleteFeed feedAction\'/>\n                </div>';
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            var _this2 = this;

            this.$regenerateButton = this.find('.regenerateFeed');
            this.$deleteButton = this.find('.deleteFeed');
            this.$regenerateButton.on('click', function () {
                return _this2.callbacks.onRegenerateClick(_this2.$regenerateButton);
            });
            this.$deleteButton.on('click', function () {
                return _this2.callbacks.onDeleteClick(_this2.$deleteButton);
            });

            (0, _SimpleSingletonTooltip2.default)(this.$regenerateButton, {
                extraClass: _constants.FEEDS_TOOLTIP_EXTRA_CLASS,
                text: _messageResource2.default.getMessage('icalendar.page.table.button.tooltip.regenerate')
            });

            (0, _SimpleSingletonTooltip2.default)(this.$deleteButton, {
                extraClass: _constants.FEEDS_TOOLTIP_EXTRA_CLASS,
                text: _messageResource2.default.getMessage('icalendar.page.table.button.tooltip.delete')
            });
        }
    }]);

    return FeedActionsCell;
}(_TemplateView3.default);

exports.default = FeedActionsCell;

/***/ }),
/* 1950 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _date_format = __webpack_require__(16);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FeedLastSyncCell = function (_TemplateView) {
    _inherits(FeedLastSyncCell, _TemplateView);

    function FeedLastSyncCell(_ref) {
        var lastSyncDate = _ref.lastSyncDate;

        _classCallCheck(this, FeedLastSyncCell);

        var _this = _possibleConstructorReturn(this, (FeedLastSyncCell.__proto__ || Object.getPrototypeOf(FeedLastSyncCell)).call(this));

        _this._getTextForLastSync = function (timestamp) {
            if (!timestamp) {
                return _messageResource2.default.getMessage('date.format.none');
            }

            var currentTime = window.currentUserTime();
            if (currentTime.isSameDate(timestamp)) {
                return _messageResource2.default.getMessage('date.format.today', [(0, _date_format.formatTime)(timestamp)]);
            } else {
                return _this._getTextForOffsetLastSync(timestamp, currentTime);
            }
        };

        _this._getTextForOffsetLastSync = function (lastSync, currentTime) {
            var offset = currentTime.offsetInDaysFrom(lastSync);
            if (offset === 1) {
                return _messageResource2.default.getMessage('date.format.yesterday');
            } else if (offset <= 7) {
                return _messageResource2.default.getMessage('date.format.past', [offset]);
            } else {
                var dateFormat = currentTime.getYear() === lastSync.getYear() ? new _date_format.DateFormat('MMM dd') : new _date_format.DateFormat('MMM dd, yyyy');
                return dateFormat.formatDate(lastSync);
            }
        };

        _this.params = {
            lastSyncDate: lastSyncDate
        };
        return _this;
    }

    _createClass(FeedLastSyncCell, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class=\'lastSyncCell\'>\n                    <div class=\'syncDate\'/>\n                </div>';
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            var convertedLastSyncDate = this.params.lastSyncDate ? window.convertFromSystemTimeZoneToUser(this.params.lastSyncDate) : null;
            this.find('.syncDate').text(this._getTextForLastSync(convertedLastSyncDate));
        }
    }]);

    return FeedLastSyncCell;
}(_TemplateView3.default);

exports.default = FeedLastSyncCell;

/***/ }),
/* 1951 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getDeleteDialog = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ModalAlert = __webpack_require__(318);

var _ModalAlert2 = _interopRequireDefault(_ModalAlert);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _constants = __webpack_require__(110);

var _View2 = __webpack_require__(20);

var _View3 = _interopRequireDefault(_View2);

var _utils = __webpack_require__(6);

var _actions = __webpack_require__(214);

var _redux = __webpack_require__(7);

var _selectors = __webpack_require__(128);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ICalDeleteDialog = function (_View) {
    _inherits(ICalDeleteDialog, _View);

    function ICalDeleteDialog(_ref) {
        var _ref$deleteFeed = _ref.deleteFeed,
            deleteFeed = _ref$deleteFeed === undefined ? function () {} : _ref$deleteFeed;

        _classCallCheck(this, ICalDeleteDialog);

        var _this = _possibleConstructorReturn(this, (ICalDeleteDialog.__proto__ || Object.getPrototypeOf(ICalDeleteDialog)).call(this));

        _this.state = {
            iCalSettingsId: 0,
            loading: false
        };

        _this.actions = {
            deleteFeed: deleteFeed
        };

        _this.onStatePropertyChanged('loading', function (loading) {
            return _this.modalAlert.setState({ loading: loading });
        });
        return _this;
    }

    _createClass(ICalDeleteDialog, [{
        key: 'afterRender',
        value: function afterRender() {
            var _this2 = this;

            this.modalAlert = new _ModalAlert2.default({
                showCancelButton: true,
                okButtonLabel: _messageResource2.default.getMessage('icalendar.dialog.delete.ok'),
                returnToInitialPosition: false,
                onConfirm: function onConfirm() {
                    return _this2.actions.deleteFeed(_this2.state.iCalSettingsId, function () {
                        return _this2.modalAlert.hide();
                    });
                },
                withLoading: true
            }).init((0, _jquery2.default)('body'));

            this.modalAlert.setState({
                header: _messageResource2.default.getMessage('icalendar.dialog.delete.header'),
                text: _messageResource2.default.getMessage('icalendar.dialog.delete.content'),
                additionalClass: 'iCalDeleteDialog',
                pointerPosition: _constants.ModalAlertPointerPosition.RIGHT,
                offsets: {
                    left: 19,
                    top: 0
                }
            });
        }
    }, {
        key: 'showAt',
        value: function showAt(element, onHideCb) {
            this.modalAlert.showAt(element, onHideCb);
        }
    }]);

    return ICalDeleteDialog;
}(_View3.default);

var ICalDeleteDialogConnected = (0, _utils.connect)(function (state) {
    return {
        loading: (0, _selectors.isUserActionLoading)(state)
    };
}, function (dispatch) {
    return {
        deleteFeed: (0, _redux.bindActionCreators)(_actions.deleteFeed, dispatch)
    };
})(ICalDeleteDialog);

var instance = null;
var getDeleteDialog = exports.getDeleteDialog = function getDeleteDialog() {
    if (!instance) {
        instance = new ICalDeleteDialogConnected().init();
    }
    return instance;
};

/***/ }),
/* 1952 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getRegenerateDialog = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _ModalAlert = __webpack_require__(318);

var _ModalAlert2 = _interopRequireDefault(_ModalAlert);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _constants = __webpack_require__(110);

var _View2 = __webpack_require__(20);

var _View3 = _interopRequireDefault(_View2);

var _utils = __webpack_require__(6);

var _actions = __webpack_require__(214);

var _redux = __webpack_require__(7);

var _selectors = __webpack_require__(128);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ICalRegenerateDialog = function (_View) {
    _inherits(ICalRegenerateDialog, _View);

    function ICalRegenerateDialog(_ref) {
        var _ref$regenerateFeedUr = _ref.regenerateFeedUrl,
            regenerateFeedUrl = _ref$regenerateFeedUr === undefined ? function () {} : _ref$regenerateFeedUr;

        _classCallCheck(this, ICalRegenerateDialog);

        var _this = _possibleConstructorReturn(this, (ICalRegenerateDialog.__proto__ || Object.getPrototypeOf(ICalRegenerateDialog)).call(this));

        _this.state = {
            iCalSettingsId: 0,
            loading: false
        };

        _this.actions = {
            regenerateFeedUrl: regenerateFeedUrl
        };

        _this.onStatePropertyChanged('loading', function (loading) {
            return _this.modalAlert.setState({ loading: loading });
        });
        return _this;
    }

    _createClass(ICalRegenerateDialog, [{
        key: 'afterRender',
        value: function afterRender() {
            var _this2 = this;

            this.modalAlert = new _ModalAlert2.default({
                showCancelButton: true,
                okButtonLabel: _messageResource2.default.getMessage('icalendar.dialog.regenerate.ok'),
                returnToInitialPosition: false,
                onConfirm: function onConfirm() {
                    return _this2.actions.regenerateFeedUrl(_this2.state.iCalSettingsId, function () {
                        return _this2.modalAlert.hide();
                    });
                },
                withLoading: true
            }).init((0, _jquery2.default)('body'));

            this.modalAlert.setState({
                header: _messageResource2.default.getMessage('icalendar.dialog.regenerate.header'),
                text: _messageResource2.default.getMessage('icalendar.dialog.regenerate.content'),
                additionalClass: 'iCalRegenerateDialog',
                pointerPosition: _constants.ModalAlertPointerPosition.RIGHT,
                offsets: {
                    left: 19,
                    top: 0
                }
            });
        }
    }, {
        key: 'showAt',
        value: function showAt(element, onHideCb) {
            this.modalAlert.showAt(element, onHideCb);
        }
    }]);

    return ICalRegenerateDialog;
}(_View3.default);

var ICalRegenerateDialogConnected = (0, _utils.connect)(function (state) {
    return {
        loading: (0, _selectors.isUserActionLoading)(state)
    };
}, function (dispatch) {
    return {
        regenerateFeedUrl: (0, _redux.bindActionCreators)(_actions.regenerateFeedUrl, dispatch)
    };
})(ICalRegenerateDialog);

var instance = null;
var getRegenerateDialog = exports.getRegenerateDialog = function getRegenerateDialog() {
    if (!instance) {
        instance = new ICalRegenerateDialogConnected().init();
    }
    return instance;
};

/***/ }),
/* 1953 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _FeedNameCell = __webpack_require__(959);

var _FeedNameCell2 = _interopRequireDefault(_FeedNameCell);

var _FeedDetailsCell = __webpack_require__(960);

var _FeedDetailsCell2 = _interopRequireDefault(_FeedDetailsCell);

var _FeedUrlCell = __webpack_require__(1954);

var _FeedUrlCell2 = _interopRequireDefault(_FeedUrlCell);

var _CopyLinkDialog = __webpack_require__(1955);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SharedFeedsRow = function (_TemplateView) {
    _inherits(SharedFeedsRow, _TemplateView);

    function SharedFeedsRow(_ref) {
        var feed = _ref.feed,
            getFeedUrl = _ref.getFeedUrl;

        _classCallCheck(this, SharedFeedsRow);

        var _this = _possibleConstructorReturn(this, (SharedFeedsRow.__proto__ || Object.getPrototypeOf(SharedFeedsRow)).call(this));

        _this.params = {
            id: feed.id
        };

        _this.state = {
            name: feed.name,
            createdDate: feed.createdDate,
            creator: feed.creator,
            editedDate: feed.editedDate,
            editor: feed.editor,
            leaveTypes: feed.leaveTypes,
            userSelection: feed.sharedUsersSelection
        };

        _this.callbacks = {
            getFeedUrl: getFeedUrl
        };

        _this.onStateDeeplyChanged(function () {
            _this.getEl().empty();
            _this._update();
        });
        return _this;
    }

    _createClass(SharedFeedsRow, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class=\'feedRow sharedFeeds\'/>';
        }
    }, {
        key: '_update',
        value: function _update() {
            var _this2 = this;

            new _FeedNameCell2.default({
                name: this.state.name,
                createdDate: this.state.createdDate,
                creator: this.state.creator,
                editedDate: this.state.editedDate,
                editor: this.state.editor
            }).init(this.getEl());

            new _FeedDetailsCell2.default({
                leaveTypes: this.state.leaveTypes,
                userSelection: this.state.userSelection
            }).init(this.getEl());

            this.copyDialog = (0, _CopyLinkDialog.getCopyDialog)();
            this.feedUrlCell = new _FeedUrlCell2.default({
                onClick: function onClick($targetEl) {
                    _this2.feedUrlCell.setState({ loading: true });
                    _this2.callbacks.getFeedUrl(_this2.params.id, function (linkForCopy) {
                        _this2.copyDialog.setState({ linkForCopy: linkForCopy });
                        _this2.copyDialog.showAt($targetEl, function () {
                            return _this2.feedUrlCell.setState({ active: false });
                        });
                        _this2.feedUrlCell.setState({
                            active: true,
                            loading: false
                        });
                    }, function () {
                        return _this2.feedUrlCell.setState({ loading: false });
                    });
                }
            }).init(this.getEl());
        }
    }]);

    return SharedFeedsRow;
}(_TemplateView3.default);

exports.default = SharedFeedsRow;

/***/ }),
/* 1954 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _LoadingSpinner = __webpack_require__(191);

var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FeedUrlCell = function (_TemplateView) {
    _inherits(FeedUrlCell, _TemplateView);

    function FeedUrlCell(_ref) {
        var onClick = _ref.onClick;

        _classCallCheck(this, FeedUrlCell);

        var _this = _possibleConstructorReturn(this, (FeedUrlCell.__proto__ || Object.getPrototypeOf(FeedUrlCell)).call(this));

        _this.callbacks = {
            onClick: onClick
        };

        _this.state = {
            active: false,
            loading: false
        };

        _this.onStatePropertyChanged('active', function (active) {
            _this.getEl().toggleClass('active', active);
        });

        _this.onStatePropertyChanged('loading', function (loading) {
            _this.loadingSpinner.setState({ show: loading });
        });
        return _this;
    }

    _createClass(FeedUrlCell, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class=\'feedUrlCell\'>\n                    <div class=\'spinnerContainer\'/>\n                    <div class=\'copyLinkIcon\'/>\n                    <div class=\'copyLinkText\'>\n                        <%=copyLinkText%>                \n                    </div>\n                </div>';
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            var _this2 = this;

            this.getEl().on('click', function () {
                return _this2.callbacks.onClick(_this2.getEl());
            });
            this.loadingSpinner = new _LoadingSpinner2.default({
                delay: 500
            }).init(this.find('.spinnerContainer'));
        }
    }, {
        key: 'messageKeys',
        value: function messageKeys() {
            return {
                copyLinkText: 'icalendar.page.table.copy_link'
            };
        }
    }]);

    return FeedUrlCell;
}(_TemplateView3.default);

exports.default = FeedUrlCell;

/***/ }),
/* 1955 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getCopyDialog = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _ModalAlert = __webpack_require__(318);

var _ModalAlert2 = _interopRequireDefault(_ModalAlert);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _constants = __webpack_require__(110);

var _View2 = __webpack_require__(20);

var _View3 = _interopRequireDefault(_View2);

var _utils = __webpack_require__(6);

var _actions = __webpack_require__(214);

var _redux = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ICalCopyDialog = function (_View) {
    _inherits(ICalCopyDialog, _View);

    function ICalCopyDialog(_ref) {
        var _ref$copyLink = _ref.copyLink,
            copyLink = _ref$copyLink === undefined ? function () {} : _ref$copyLink;

        _classCallCheck(this, ICalCopyDialog);

        var _this = _possibleConstructorReturn(this, (ICalCopyDialog.__proto__ || Object.getPrototypeOf(ICalCopyDialog)).call(this));

        _this.state = {
            linkForCopy: ''
        };

        _this.actions = {
            copyLink: copyLink
        };
        return _this;
    }

    _createClass(ICalCopyDialog, [{
        key: 'afterRender',
        value: function afterRender() {
            var _this2 = this;

            this.modalAlert = new _ModalAlert2.default({
                showCancelButton: true,
                okButtonLabel: _messageResource2.default.getMessage('icalendar.dialog.copy.ok'),
                returnToInitialPosition: false,
                onConfirm: function onConfirm() {
                    return _this2.actions.copyLink(_this2.state.linkForCopy);
                }
            }).init((0, _jquery2.default)('body'));

            this.modalAlert.setState({
                text: _messageResource2.default.getMessage('icalendar.dialog.copy.content'),
                additionalClass: 'iCalCopyDialog',
                pointerPosition: _constants.ModalAlertPointerPosition.RIGHT,
                offsets: {
                    left: 93,
                    top: 0
                }
            });
        }
    }, {
        key: 'showAt',
        value: function showAt(element, onHideCb) {
            this.modalAlert.showAt(element, onHideCb);
        }
    }]);

    return ICalCopyDialog;
}(_View3.default);

var ICalCopyDialogConnected = (0, _utils.connect)(function (state) {
    return {};
}, function (dispatch) {
    return {
        copyLink: (0, _redux.bindActionCreators)(_actions.copyLink, dispatch)
    };
})(ICalCopyDialog);

var instance = null;
var getCopyDialog = exports.getCopyDialog = function getCopyDialog() {
    if (!instance) {
        instance = new ICalCopyDialogConnected().init();
    }
    return instance;
};

/***/ }),
/* 1956 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _constants = __webpack_require__(51);

var _OrderedList = __webpack_require__(1957);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FeedsTableContent = function (_TemplateView) {
    _inherits(FeedsTableContent, _TemplateView);

    function FeedsTableContent(_ref) {
        var renderFeed = _ref.renderFeed;

        _classCallCheck(this, FeedsTableContent);

        var _this = _possibleConstructorReturn(this, (FeedsTableContent.__proto__ || Object.getPrototypeOf(FeedsTableContent)).call(this));

        _this.state = {
            feeds: [],
            sorting: _constants.DEFAULT_SORTING
        };

        _this.params = {
            renderFeed: renderFeed
        };

        _this.onStatePropertyChanged('feeds', function (feeds) {
            _this.feedsList.setState({ items: feeds });
        });

        _this.onStatePropertyDeeplyChanged('sorting', function (sorting) {
            _this.feedsList.setState({ reverseOrder: !sorting.isAsc });
        });
        return _this;
    }

    _createClass(FeedsTableContent, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class=\'feedsTableContent\'/>';
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            this.feedsList = new _OrderedList.OrderedList({
                itemToComponent: this.params.renderFeed
            }).init(this.getEl());
        }
    }]);

    return FeedsTableContent;
}(_TemplateView3.default);

exports.default = FeedsTableContent;

/***/ }),
/* 1957 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.OrderedList = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _atUtils = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * OrderedList allows render ordered list of components and handle items' states changes without rerender.
 * Items order implemented using flex-order on items elements.
 *
 * @state {
 *      items - array of elements
 *      reverseOrder - allows reverse whole list's items order without resetting flex-order styles attribute
 * }
 */
var OrderedList = exports.OrderedList = function (_TemplateView) {
    _inherits(OrderedList, _TemplateView);

    function OrderedList(_ref) {
        var _ref$itemToComponent = _ref.itemToComponent,
            itemToComponent = _ref$itemToComponent === undefined ? function (item) {
            return null;
        } : _ref$itemToComponent,
            _ref$itemToState = _ref.itemToState,
            itemToState = _ref$itemToState === undefined ? function (item) {
            return item;
        } : _ref$itemToState;

        _classCallCheck(this, OrderedList);

        var _this = _possibleConstructorReturn(this, (OrderedList.__proto__ || Object.getPrototypeOf(OrderedList)).call(this));

        _this.state = {
            items: [],
            reverseOrder: false
        };

        _this.params = {
            itemToComponent: itemToComponent,
            itemToState: itemToState
        };

        _this.itemRows = {};

        _this.onStatePropertyChanged('items', function (items) {
            return _this._updateRows(items);
        });
        _this.onStatePropertyChanged('reverseOrder', function (reverseOrder) {
            return _this.getEl().toggleClass('reverseOrder', reverseOrder);
        });
        return _this;
    }

    _createClass(OrderedList, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class=\'components_orderedList\'/>';
        }
    }, {
        key: '_updateRows',
        value: function _updateRows(items) {
            var _this2 = this;

            var itemsIds = (0, _atUtils.arrayToSet)(items.map(function (f) {
                return f.id;
            }));

            Object.keys(this.itemRows).filter(function (id) {
                return !itemsIds[id];
            }).forEach(function (id) {
                _this2.itemRows[id].getEl().remove();
                delete _this2.itemRows[id];
            });

            items.forEach(function (item, index) {
                if (!_this2.itemRows[item.id]) _this2.itemRows[item.id] = _this2.params.itemToComponent(item).init(_this2.getEl());

                _this2.itemRows[item.id].setState(_this2.params.itemToState(item));

                _this2.itemRows[item.id].getEl().css('order', index.toString());
            });
        }
    }]);

    return OrderedList;
}(_TemplateView3.default);

/***/ }),
/* 1958 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _constants = __webpack_require__(51);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _Button = __webpack_require__(33);

var _Button2 = _interopRequireDefault(_Button);

var _utils = __webpack_require__(6);

var _selectors = __webpack_require__(128);

var _actions = __webpack_require__(214);

var _redux = __webpack_require__(7);

var _Tab = __webpack_require__(563);

var _Tab2 = _interopRequireDefault(_Tab);

var _SimpleDiv = __webpack_require__(569);

var _SimpleDiv2 = _interopRequireDefault(_SimpleDiv);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var HeaderPanel = function (_TemplateView) {
    _inherits(HeaderPanel, _TemplateView);

    function HeaderPanel(_ref) {
        var changeActiveTab = _ref.changeActiveTab,
            onCreateButtonClick = _ref.onCreateButtonClick,
            onExportButtonClick = _ref.onExportButtonClick;

        _classCallCheck(this, HeaderPanel);

        var _this = _possibleConstructorReturn(this, (HeaderPanel.__proto__ || Object.getPrototypeOf(HeaderPanel)).call(this));

        _this.callbacks = {
            changeActiveTab: changeActiveTab,
            onCreateButtonClick: onCreateButtonClick,
            onExportButtonClick: onExportButtonClick
        };

        _this.state = {
            activeTab: _constants.ICalTabType.USER_FEEDS,
            showButtons: false
        };

        _this.onStatePropertyChanged('activeTab', function (activeTab) {
            _this.allFeedsTab.setState({ active: activeTab === _constants.ICalTabType.ALL_FEEDS });
            _this.sharedFeedsTab.setState({ active: activeTab === _constants.ICalTabType.USER_FEEDS });
        });

        _this.onStatePropertyChanged('showButtons', function (showButtons) {
            return _this.$buttonsArea.toggle(showButtons);
        });
        return _this;
    }

    _createClass(HeaderPanel, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class=\'headerPanel\'>\n                    <div class=\'tabsPanel\'/>\n                     <div class=\'buttonsArea\'>\n                        <div class=\'button createButton\'/>\n                        <div class=\'button exportButton\'/>\n                    </div>\n                </div>';
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            var _this2 = this;

            var $tabsPanel = this.find('.tabsPanel');

            this.allFeedsTab = new _Tab2.default({
                text: _messageResource2.default.getMessage('icalendar.page.tab.all'),
                onClick: function onClick() {
                    return _this2.callbacks.changeActiveTab(_constants.ICalTabType.ALL_FEEDS);
                }
            }).init($tabsPanel);

            new _SimpleDiv2.default({ additionalClass: 'tabSeparator' }).init($tabsPanel);

            this.sharedFeedsTab = new _Tab2.default({
                text: _messageResource2.default.getMessage('icalendar.page.tab.user'),
                onClick: function onClick() {
                    return _this2.callbacks.changeActiveTab(_constants.ICalTabType.USER_FEEDS);
                }
            }).init($tabsPanel);

            this.$buttonsArea = this.find('.buttonsArea');

            this.createButton = new _Button2.default({
                label: _messageResource2.default.getMessage('icalendar.page.buttons.create'),
                withPlusIcon: true,
                onClickCb: this.callbacks.onCreateButtonClick
            }).init(this.find('.createButton'));

            this.exportButton = new _Button2.default({
                label: _messageResource2.default.getMessage('icalendar.page.buttons.export.short'),
                withPlusIcon: true,
                onClickCb: this.callbacks.onExportButtonClick
            }).init(this.find('.exportButton'));
        }
    }]);

    return HeaderPanel;
}(_TemplateView3.default);

exports.default = (0, _utils.connect)(function (state) {
    return {
        activeTab: (0, _selectors.getActiveTab)(state),
        showButtons: (0, _selectors.isTopButtonsShown)(state)
    };
}, function (dispatch) {
    return (0, _redux.bindActionCreators)({
        changeActiveTab: _actions.changeActiveTab
    }, dispatch);
})(HeaderPanel);

/***/ }),
/* 1959 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _EditFeedLightBoxHeader = __webpack_require__(1960);

var _EditFeedLightBoxHeader2 = _interopRequireDefault(_EditFeedLightBoxHeader);

var _EditFeedLightboxFooter = __webpack_require__(1961);

var _EditFeedLightboxFooter2 = _interopRequireDefault(_EditFeedLightboxFooter);

var _EditFeedLightBoxContent = __webpack_require__(1962);

var _EditFeedLightBoxContent2 = _interopRequireDefault(_EditFeedLightBoxContent);

var _StateComponent2 = __webpack_require__(105);

var _StateComponent3 = _interopRequireDefault(_StateComponent2);

var _redux = __webpack_require__(7);

var _utils = __webpack_require__(6);

var _selectors = __webpack_require__(266);

var _actions = __webpack_require__(265);

var _LightBox = __webpack_require__(196);

var _LightBox2 = _interopRequireDefault(_LightBox);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _selectors2 = __webpack_require__(128);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EditFeedLightBox = function (_StateComponent) {
    _inherits(EditFeedLightBox, _StateComponent);

    function EditFeedLightBox(_ref) {
        var saveFeedSettings = _ref.saveFeedSettings,
            closeICalLightBox = _ref.closeICalLightBox;

        _classCallCheck(this, EditFeedLightBox);

        var _this = _possibleConstructorReturn(this, (EditFeedLightBox.__proto__ || Object.getPrototypeOf(EditFeedLightBox)).call(this));

        _this.actions = {
            saveFeedSettings: saveFeedSettings,
            closeICalLightBox: closeICalLightBox
        };

        _this.state = {
            type: null,
            shown: false,
            submitEnabled: true,
            dataChanged: false,
            loading: false
        };

        _this.onStatePropertyChanged('type', function (type) {
            _this.header.setState({ type: type });
            _this.footer.setState({ type: type });
        });

        _this.onStatePropertyChanged('shown', function (shown) {
            return _this._toggle(shown);
        });
        _this.onStatePropertyChanged('submitEnabled', function (submitEnabled) {
            return _this.footer.setState({ submitEnabled: submitEnabled });
        });
        _this.onStatePropertyChanged('dataChanged', function (dataChanged) {
            return _this.lightBox.dataChanged = dataChanged;
        });
        _this.onStatePropertyChanged('loading', function (loading) {
            return _this.footer.setState({ loading: loading });
        });
        return _this;
    }

    _createClass(EditFeedLightBox, [{
        key: 'init',
        value: function init() {
            this.header = new _EditFeedLightBoxHeader2.default();
            this.footer = new _EditFeedLightboxFooter2.default({
                onSubmitButtonClick: this.actions.saveFeedSettings,
                onCancelButtonClick: this.actions.closeICalLightBox
            });
            this.content = new _EditFeedLightBoxContent2.default();

            this.lightBox = new _LightBox2.default((0, _jquery2.default)('body'), {
                cancel_confirmation_message_key: 'lightbox.cancel_changes'
            }).init({
                id: 'editFeedLightBox',
                header: this.header,
                content: this.content,
                footer: this.footer,
                classNames: 'editFeedLightBox iCalLightBox',
                cancelCallback: this.actions.closeICalLightBox
            });

            return this;
        }
    }, {
        key: '_toggle',
        value: function _toggle(isShown) {
            this.lightBox.toggle(isShown);
            if (isShown) {
                this.content.onShow();
            }
        }
    }]);

    return EditFeedLightBox;
}(_StateComponent3.default);

exports.default = (0, _utils.connect)(function (state) {
    return {
        submitEnabled: (0, _selectors.isEditLightBoxSubmitEnabled)(state),
        type: (0, _selectors.getLightBoxType)(state),
        shown: (0, _selectors.isEditLightBoxShown)(state),
        dataChanged: (0, _selectors.isEditLightBoxDataChanged)(state),
        loading: (0, _selectors2.isUserActionLoading)(state)
    };
}, function (dispatch) {
    return (0, _redux.bindActionCreators)({
        saveFeedSettings: _actions.saveFeedSettings,
        closeICalLightBox: _actions.closeICalLightBox
    }, dispatch);
})(EditFeedLightBox);

/***/ }),
/* 1960 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _constants = __webpack_require__(51);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EditFeedLightBoxHeader = function (_TemplateView) {
    _inherits(EditFeedLightBoxHeader, _TemplateView);

    function EditFeedLightBoxHeader() {
        _classCallCheck(this, EditFeedLightBoxHeader);

        var _this = _possibleConstructorReturn(this, (EditFeedLightBoxHeader.__proto__ || Object.getPrototypeOf(EditFeedLightBoxHeader)).call(this));

        _this.state = {
            type: null
        };

        _this.onStatePropertyChanged('type', function (type) {
            _this.$lightBoxTitle.text(_messageResource2.default.getMessage(type === _constants.ICalLightboxType.CREATE ? 'icalendar.page.lightbox.create.title' : 'icalendar.page.lightbox.edit.title'));
        });
        return _this;
    }

    _createClass(EditFeedLightBoxHeader, [{
        key: 'getCloseButtonEl',
        value: function getCloseButtonEl() {
            return this.find('.closeButton');
        }
    }, {
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class=\'dialog-header iCalLightBoxHeader\'>\n                    <div class=\'closeButton\'/>\n                    <div class=\'lightBoxTitle\'/>\n                </div>';
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            this.$lightBoxTitle = this.find('.lightBoxTitle');

            this.renderInitialState();
        }
    }]);

    return EditFeedLightBoxHeader;
}(_TemplateView3.default);

exports.default = EditFeedLightBoxHeader;

/***/ }),
/* 1961 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Button = __webpack_require__(33);

var _Button2 = _interopRequireDefault(_Button);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _constants = __webpack_require__(51);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EditFedLightBoxFooter = function (_TemplateView) {
    _inherits(EditFedLightBoxFooter, _TemplateView);

    function EditFedLightBoxFooter() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            _ref$onSubmitButtonCl = _ref.onSubmitButtonClick,
            onSubmitButtonClick = _ref$onSubmitButtonCl === undefined ? function () {} : _ref$onSubmitButtonCl,
            _ref$onCancelButtonCl = _ref.onCancelButtonClick,
            onCancelButtonClick = _ref$onCancelButtonCl === undefined ? function () {} : _ref$onCancelButtonCl;

        _classCallCheck(this, EditFedLightBoxFooter);

        var _this = _possibleConstructorReturn(this, (EditFedLightBoxFooter.__proto__ || Object.getPrototypeOf(EditFedLightBoxFooter)).call(this));

        _this.callbacks = {
            onSubmitButtonClick: onSubmitButtonClick,
            onCancelButtonClick: onCancelButtonClick
        };

        _this.state = {
            type: null,
            submitEnabled: false,
            loading: false
        };

        _this.onStatePropertyChanged('type', function (type) {
            _this.submitButton.setState({
                label: _messageResource2.default.getMessage(type === _constants.ICalLightboxType.CREATE ? 'icalendar.page.lightbox.create.button' : 'common.buttons.save_changes'),
                withPlusIcon: type === _constants.ICalLightboxType.CREATE
            });
            _this.$submitButtonEl.toggleClass('createButton', type === _constants.ICalLightboxType.CREATE);
            _this.$submitButtonEl.toggleClass('editButton', type === _constants.ICalLightboxType.EDIT);
        });

        _this.onStatePropertyChanged('submitEnabled', function (submitEnabled) {
            return _this.submitButton.setState({ disabled: !submitEnabled });
        });
        _this.onStatePropertyChanged('loading', function (loading) {
            return _this.submitButton.setState({ loading: loading });
        });
        return _this;
    }

    _createClass(EditFedLightBoxFooter, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class=\'basicLightboxFooter\'>\n                    <div class=\'buttonsBox\'>\n                        <div class=\'submitButton\'/>\n                        <div class=\'cancelBtn\'>\n                            <%=cancelButtonLabel%>\n                        </div>\n                    </div>\n                </div>';
        }
    }, {
        key: 'messageKeys',
        value: function messageKeys() {
            return {
                cancelButtonLabel: 'common.cancel'
            };
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            this.$submitButtonEl = this.find('.submitButton');
            this.submitButton = new _Button2.default({
                onClickCb: this.callbacks.onSubmitButtonClick,
                withLoading: true
            }).init(this.$submitButtonEl);

            this.$cancelButtonEl = this.find('.cancelBtn');
        }

        //for compatibility with LightBox

    }, {
        key: 'getCommitBtnEl',
        value: function getCommitBtnEl() {
            return [];
        }
    }, {
        key: 'getCancelBtnEl',
        value: function getCancelBtnEl() {
            return this.$cancelButtonEl;
        }
    }]);

    return EditFedLightBoxFooter;
}(_TemplateView3.default);

exports.default = EditFedLightBoxFooter;

/***/ }),
/* 1962 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _InputField = __webpack_require__(942);

var _InputField2 = _interopRequireDefault(_InputField);

var _ICalFeedLeaveTypesSelector = __webpack_require__(962);

var _ICalFeedLeaveTypesSelector2 = _interopRequireDefault(_ICalFeedLeaveTypesSelector);

var _ICalFeedUserSelector = __webpack_require__(963);

var _ICalFeedUserSelector2 = _interopRequireDefault(_ICalFeedUserSelector);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _constants = __webpack_require__(264);

var _utils = __webpack_require__(6);

var _redux = __webpack_require__(7);

var _selectors = __webpack_require__(266);

var _selectors2 = __webpack_require__(14);

var _actions = __webpack_require__(265);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EditFeedLightBoxContent = function (_TemplateView) {
    _inherits(EditFeedLightBoxContent, _TemplateView);

    function EditFeedLightBoxContent(_ref) {
        var setFeedName = _ref.setFeedName,
            setUserSelection = _ref.setUserSelection,
            setSharedUserSelection = _ref.setSharedUserSelection,
            setFeedLeaveTypeSelection = _ref.setFeedLeaveTypeSelection,
            setIncludeNotApproved = _ref.setIncludeNotApproved;

        _classCallCheck(this, EditFeedLightBoxContent);

        var _this = _possibleConstructorReturn(this, (EditFeedLightBoxContent.__proto__ || Object.getPrototypeOf(EditFeedLightBoxContent)).call(this));

        _this.actions = {
            setFeedName: setFeedName,
            setUserSelection: setUserSelection,
            setSharedUserSelection: setSharedUserSelection,
            setFeedLeaveTypeSelection: setFeedLeaveTypeSelection,
            setIncludeNotApproved: setIncludeNotApproved
        };

        _this.state = {
            feedName: '',
            users: [],
            userGroups: [],
            timeZoneGroups: [],
            leaveTypes: [],
            userSelection: _constants.DEFAULT_USER_SELECTION,
            sharedUserSelection: _constants.DEFAULT_SHARED_WITH_USER_SELECTION,
            leaveTypeSelection: _constants.DEFAULT_LEAVE_TYPE_SELECTION,
            includeNotApproved: false
        };

        _this.onStatePropertyChanged('feedName', function (feedName) {
            if (feedName !== _this.feedNameInput.getValue()) {
                _this.feedNameInput.setValue(feedName);
            }
        });

        _this.onAnyStatePropertyChanged(['users', 'userGroups', 'timeZoneGroups'], function (state) {
            _this.userSelector.setState({
                users: state.users,
                userGroups: state.userGroups,
                timeZoneGroups: state.timeZoneGroups
            });
            _this.sharedUserSelector.setState({
                users: state.users,
                userGroups: state.userGroups,
                timeZoneGroups: state.timeZoneGroups
            });
        });

        _this.onStatePropertyDeeplyChanged('userSelection', function (userSelection) {
            return _this.userSelector.setState({ userSelection: userSelection });
        });
        _this.onStatePropertyDeeplyChanged('sharedUserSelection', function (userSelection) {
            return _this.sharedUserSelector.setState({ userSelection: userSelection });
        });

        _this.onAnyStatePropertyDeeplyChanged(['leaveTypes', 'leaveTypeSelection'], function () {
            _this.leaveTypeSelector.setState({
                leaveTypes: _this.state.leaveTypes,
                leaveTypeSelection: _this.state.leaveTypeSelection
            });
        });

        _this.onStatePropertyChanged('includeNotApproved', function (includeNotApproved) {
            return _this.leaveTypeSelector.setState({ includeNotApproved: includeNotApproved });
        });
        return _this;
    }

    _createClass(EditFeedLightBoxContent, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class=\'iCalLightBoxContent\'>\n                    <div class=\'topContainer\'>\n                        <div class=\'feedNameInputWrapper\'/>\n                    </div>\n                    <div class=\'mainContainer\'>\n                        <div class=\'userSelectorWrapper\'/>\n                        <div class=\'leaveTypesSelectorWrapper\'/>\n                        <div class=\'sharedUserSelectorWrapper\'/>\n                    </div>\n                </div>';
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            this.feedNameInput = new _InputField2.default({
                placeholder: _messageResource2.default.getMessage('icalendar.page.lightbox.name.placeholder'),
                additionalClass: 'feedNameInput',
                maxLength: 80,
                onChange: this.actions.setFeedName
            }).init(this.find('.feedNameInputWrapper'));

            this.userSelector = new _ICalFeedUserSelector2.default({
                title: _messageResource2.default.getMessage('icalendar.page.lightbox.userselection.description'),
                onSelectionChanged: this.actions.setUserSelection
            }).init(this.find('.userSelectorWrapper'));

            this.leaveTypeSelector = new _ICalFeedLeaveTypesSelector2.default({
                selectorId: 'editFeedLeaveTypeSelector',
                onLeaveTypeSelectionChanged: this.actions.setFeedLeaveTypeSelection,
                onCheckboxClick: this.actions.setIncludeNotApproved
            }).init(this.find('.leaveTypesSelectorWrapper'));

            this.sharedUserSelector = new _ICalFeedUserSelector2.default({
                title: _messageResource2.default.getMessage('icalendar.page.lightbox.userselection.shared.description'),
                shared: true,
                onSelectionChanged: this.actions.setSharedUserSelection,
                setAllUsersIfNoneSelected: false
            }).init(this.find('.sharedUserSelectorWrapper'));
        }
    }, {
        key: 'onShow',
        value: function onShow() {
            this.feedNameInput.focus();
        }
    }]);

    return EditFeedLightBoxContent;
}(_TemplateView3.default);

exports.default = (0, _utils.connect)(function (state) {
    return {
        feedName: (0, _selectors.getFeedName)(state),
        users: (0, _selectors2.getActiveUsersArray)(state),
        userGroups: (0, _selectors2.getUserGroupsArrayWithDefault)(state),
        timeZoneGroups: (0, _selectors2.getTimeZoneGroupsArray)(state),
        userSelection: (0, _selectors.getUserSelection)(state),
        sharedUserSelection: (0, _selectors.getSharedUserSelection)(state),
        leaveTypeSelection: (0, _selectors.getLeaveTypeSelection)(state),
        leaveTypes: (0, _selectors2.getLeaveTypesArray)(state),
        includeNotApproved: (0, _selectors.isIncludesNotApproved)(state)
    };
}, function (dispatch) {
    return (0, _redux.bindActionCreators)({
        setFeedName: _actions.setFeedName,
        setUserSelection: _actions.setUserSelection,
        setSharedUserSelection: _actions.setSharedUserSelection,
        setFeedLeaveTypeSelection: _actions.setFeedLeaveTypeSelection,
        setIncludeNotApproved: _actions.setIncludeNotApproved
    }, dispatch);
})(EditFeedLightBoxContent);

/***/ }),
/* 1963 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _StateComponent2 = __webpack_require__(105);

var _StateComponent3 = _interopRequireDefault(_StateComponent2);

var _LightBox = __webpack_require__(196);

var _LightBox2 = _interopRequireDefault(_LightBox);

var _ExportICalLightBoxHeader = __webpack_require__(1964);

var _ExportICalLightBoxHeader2 = _interopRequireDefault(_ExportICalLightBoxHeader);

var _ExportICalLightBoxFooter = __webpack_require__(1965);

var _ExportICalLightBoxFooter2 = _interopRequireDefault(_ExportICalLightBoxFooter);

var _ExportICalLightBoxContent = __webpack_require__(1966);

var _ExportICalLightBoxContent2 = _interopRequireDefault(_ExportICalLightBoxContent);

var _redux = __webpack_require__(7);

var _utils = __webpack_require__(6);

var _selectors = __webpack_require__(266);

var _actions = __webpack_require__(265);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _selectors2 = __webpack_require__(128);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ExportICalLightBox = function (_StateComponent) {
    _inherits(ExportICalLightBox, _StateComponent);

    function ExportICalLightBox(_ref) {
        var exportICal = _ref.exportICal,
            closeICalLightBox = _ref.closeICalLightBox;

        _classCallCheck(this, ExportICalLightBox);

        var _this = _possibleConstructorReturn(this, (ExportICalLightBox.__proto__ || Object.getPrototypeOf(ExportICalLightBox)).call(this));

        _this.actions = {
            exportICal: exportICal,
            closeICalLightBox: closeICalLightBox
        };

        _this.state = {
            shown: false,
            dateRangeSelectionValid: false,
            dataChanged: false,
            loading: false
        };

        _this.onStatePropertyChanged('shown', function (shown) {
            return _this.lightBox.toggle(shown);
        });
        _this.onStatePropertyChanged('dateRangeSelectionValid', function (dateRangeSelectionValid) {
            return _this.footer.setState({ getFileButtonEnabled: dateRangeSelectionValid });
        });
        _this.onStatePropertyChanged('dataChanged', function (dataChanged) {
            return _this.lightBox.dataChanged = dataChanged;
        });
        _this.onStatePropertyChanged('loading', function (loading) {
            return _this.footer.setState({ loading: loading });
        });

        return _this;
    }

    _createClass(ExportICalLightBox, [{
        key: 'init',
        value: function init() {
            this.header = new _ExportICalLightBoxHeader2.default();
            this.footer = new _ExportICalLightBoxFooter2.default({
                onCancelButtonClick: this.actions.closeICalLightBox,
                onGetFileButtonClick: this.actions.exportICal
            });
            this.content = new _ExportICalLightBoxContent2.default();

            this.lightBox = new _LightBox2.default((0, _jquery2.default)('body'), {
                cancel_confirmation_message_key: 'lightbox.cancel_changes'
            }).init({
                id: 'exportICalLightBox',
                header: this.header,
                content: this.content,
                footer: this.footer,
                classNames: 'exportFeedLightBox iCalLightBox',
                cancelCallback: this.actions.closeICalLightBox
            });

            return this;
        }
    }]);

    return ExportICalLightBox;
}(_StateComponent3.default);

exports.default = (0, _utils.connect)(function (state) {
    return {
        shown: (0, _selectors.isExportLightBoxShown)(state),
        dateRangeSelectionValid: (0, _selectors.isDateRangeSelectionValid)(state),
        dataChanged: (0, _selectors.isExportLightBoxDataChanged)(state),
        loading: (0, _selectors2.isUserActionLoading)(state)
    };
}, function (dispatch) {
    return (0, _redux.bindActionCreators)({
        exportICal: _actions.exportICal,
        closeICalLightBox: _actions.closeICalLightBox
    }, dispatch);
})(ExportICalLightBox);

/***/ }),
/* 1964 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ExportICalLightBoxHeader = function (_TemplateView) {
    _inherits(ExportICalLightBoxHeader, _TemplateView);

    function ExportICalLightBoxHeader() {
        _classCallCheck(this, ExportICalLightBoxHeader);

        return _possibleConstructorReturn(this, (ExportICalLightBoxHeader.__proto__ || Object.getPrototypeOf(ExportICalLightBoxHeader)).apply(this, arguments));
    }

    _createClass(ExportICalLightBoxHeader, [{
        key: 'getCloseButtonEl',
        value: function getCloseButtonEl() {
            return this.find('.closeButton');
        }
    }, {
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class=\'dialog-header iCalLightBoxHeader exportICalLightBoxHeader\'>\n                    <div class=\'closeButton\'/>\n                    <div class=\'lightBoxTitle\'>\n                        <%=title%>\n                    </div>\n                </div>';
        }
    }, {
        key: 'messageKeys',
        value: function messageKeys() {
            return {
                title: 'icalendar.page.lightbox.export.title'
            };
        }
    }]);

    return ExportICalLightBoxHeader;
}(_TemplateView3.default);

exports.default = ExportICalLightBoxHeader;

/***/ }),
/* 1965 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _Button = __webpack_require__(33);

var _Button2 = _interopRequireDefault(_Button);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ExportICalLightBoxFooter = function (_TemplateView) {
    _inherits(ExportICalLightBoxFooter, _TemplateView);

    function ExportICalLightBoxFooter() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            _ref$onGetFileButtonC = _ref.onGetFileButtonClick,
            onGetFileButtonClick = _ref$onGetFileButtonC === undefined ? function () {} : _ref$onGetFileButtonC,
            _ref$onCancelButtonCl = _ref.onCancelButtonClick,
            onCancelButtonClick = _ref$onCancelButtonCl === undefined ? function () {} : _ref$onCancelButtonCl;

        _classCallCheck(this, ExportICalLightBoxFooter);

        var _this = _possibleConstructorReturn(this, (ExportICalLightBoxFooter.__proto__ || Object.getPrototypeOf(ExportICalLightBoxFooter)).call(this));

        _this.state = {
            getFileButtonEnabled: false,
            loading: false
        };

        _this.callbacks = {
            onGetFileButtonClick: onGetFileButtonClick,
            onCancelButtonClick: onCancelButtonClick
        };

        _this.onStatePropertyChanged('getFileButtonEnabled', function (getFileButtonEnabled) {
            return _this.getFileButton.setState({ disabled: !getFileButtonEnabled });
        });
        _this.onStatePropertyChanged('loading', function (loading) {
            return _this.getFileButton.setState({ loading: loading });
        });
        return _this;
    }

    _createClass(ExportICalLightBoxFooter, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class=\'basicLightboxFooter\'>\n                    <div class=\'buttonsBox\'>\n                        <div class=\'getFileButton\'/>\n                        <div class=\'cancelBtn\'>\n                            <%=cancelButtonLabel%>\n                        </div>\n                    </div>\n                </div>';
        }
    }, {
        key: 'messageKeys',
        value: function messageKeys() {
            return {
                cancelButtonLabel: 'common.cancel'
            };
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            this.getFileButton = new _Button2.default({
                label: _messageResource2.default.getMessage('icalendar.page.lightbox.button.get'),
                onClickCb: this.callbacks.onGetFileButtonClick,
                withLoading: true
            }).init(this.find('.getFileButton'));

            this.$cancelButtonEl = this.find('.cancelBtn');
        }

        //for compatibility with LightBox

    }, {
        key: 'getCommitBtnEl',
        value: function getCommitBtnEl() {
            return [];
        }

        //for compatibility with LightBox

    }, {
        key: 'getCancelBtnEl',
        value: function getCancelBtnEl() {
            return this.$cancelButtonEl;
        }
    }]);

    return ExportICalLightBoxFooter;
}(_TemplateView3.default);

exports.default = ExportICalLightBoxFooter;

/***/ }),
/* 1966 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _ICalFeedUserSelector = __webpack_require__(963);

var _ICalFeedUserSelector2 = _interopRequireDefault(_ICalFeedUserSelector);

var _ICalFeedLeaveTypesSelector = __webpack_require__(962);

var _ICalFeedLeaveTypesSelector2 = _interopRequireDefault(_ICalFeedLeaveTypesSelector);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _redux = __webpack_require__(7);

var _ICalFeedDateRangeSelector = __webpack_require__(1967);

var _ICalFeedDateRangeSelector2 = _interopRequireDefault(_ICalFeedDateRangeSelector);

var _constants = __webpack_require__(264);

var _utils = __webpack_require__(6);

var _selectors = __webpack_require__(266);

var _selectors2 = __webpack_require__(14);

var _actions = __webpack_require__(265);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ExportICalLightBoxContent = function (_TemplateView) {
    _inherits(ExportICalLightBoxContent, _TemplateView);

    function ExportICalLightBoxContent(_ref) {
        var setUserSelection = _ref.setUserSelection,
            setFeedLeaveTypeSelection = _ref.setFeedLeaveTypeSelection,
            setIncludeNotApproved = _ref.setIncludeNotApproved,
            setDateRangeSelection = _ref.setDateRangeSelection;

        _classCallCheck(this, ExportICalLightBoxContent);

        var _this = _possibleConstructorReturn(this, (ExportICalLightBoxContent.__proto__ || Object.getPrototypeOf(ExportICalLightBoxContent)).call(this));

        _this.actions = {
            setUserSelection: setUserSelection,
            setFeedLeaveTypeSelection: setFeedLeaveTypeSelection,
            setIncludeNotApproved: setIncludeNotApproved,
            setDateRangeSelection: setDateRangeSelection
        };

        _this.state = {
            users: [],
            userGroups: [],
            timeZoneGroups: [],
            leaveTypes: [],
            userSelection: _constants.DEFAULT_USER_SELECTION,
            leaveTypeSelection: _constants.DEFAULT_LEAVE_TYPE_SELECTION,
            includeNotApproved: false,
            dateRangeSelection: null,
            dateRangeSelectionValid: false
        };

        _this.onAnyStatePropertyChanged(['users', 'userGroups', 'timeZoneGroups'], function (state) {
            _this.userSelector.setState({
                users: state.users,
                userGroups: state.userGroups,
                timeZoneGroups: state.timeZoneGroups
            });
        });

        _this.onStatePropertyDeeplyChanged('userSelection', function (userSelection) {
            return _this.userSelector.setState({ userSelection: userSelection });
        });

        _this.onAnyStatePropertyDeeplyChanged(['leaveTypes', 'leaveTypeSelection'], function () {
            _this.leaveTypeSelector.setState({
                leaveTypes: _this.state.leaveTypes,
                leaveTypeSelection: _this.state.leaveTypeSelection
            });
        });

        _this.onStatePropertyChanged('includeNotApproved', function (includeNotApproved) {
            return _this.leaveTypeSelector.setState({ includeNotApproved: includeNotApproved });
        });
        _this.onAnyStatePropertyDeeplyChanged(['dateRangeSelection', 'dateRangeSelectionValid'], function (state) {
            return _this.dateRangeSelector.setState({
                selection: state.dateRangeSelection,
                selectionValid: state.dateRangeSelectionValid
            });
        });
        return _this;
    }

    _createClass(ExportICalLightBoxContent, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class=\'iCalLightBoxContent exportFeedLightBoxContent\'>\n                    <div class=\'mainContainer\'>\n                        <div class=\'userSelectorWrapper\'/>\n                        <div class=\'leaveTypesSelectorWrapper\'/>\n                        <div class=\'dateRangeSelectorWrapper\'/>\n                    </div>\n                </div>';
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            this.userSelector = new _ICalFeedUserSelector2.default({
                title: _messageResource2.default.getMessage('icalendar.page.lightbox.userselection.description'),
                onSelectionChanged: this.actions.setUserSelection
            }).init(this.find('.userSelectorWrapper'));

            this.leaveTypeSelector = new _ICalFeedLeaveTypesSelector2.default({
                selectorId: 'exportICalLeaveTypeSelector',
                onLeaveTypeSelectionChanged: this.actions.setFeedLeaveTypeSelection,
                onCheckboxClick: this.actions.setIncludeNotApproved
            }).init(this.find('.leaveTypesSelectorWrapper'));

            this.dateRangeSelector = new _ICalFeedDateRangeSelector2.default({
                onSelectionChanged: this.actions.setDateRangeSelection
            }).init(this.find('.dateRangeSelectorWrapper'));
        }
    }]);

    return ExportICalLightBoxContent;
}(_TemplateView3.default);

exports.default = (0, _utils.connect)(function (state) {
    return {
        users: (0, _selectors2.getActiveUsersArray)(state),
        userGroups: (0, _selectors2.getUserGroupsArrayWithDefault)(state),
        leaveTypes: (0, _selectors2.getLeaveTypesArray)(state),
        timeZoneGroups: (0, _selectors2.getTimeZoneGroupsArray)(state),
        userSelection: (0, _selectors.getUserSelection)(state),
        leaveTypeSelection: (0, _selectors.getLeaveTypeSelection)(state),
        includeNotApproved: (0, _selectors.isIncludesNotApproved)(state),
        dateRangeSelection: (0, _selectors.getDateRangeSelection)(state),
        dateRangeSelectionValid: (0, _selectors.isDateRangeSelectionValid)(state)
    };
}, function (dispatch) {
    return (0, _redux.bindActionCreators)({
        setUserSelection: _actions.setUserSelection,
        setFeedLeaveTypeSelection: _actions.setFeedLeaveTypeSelection,
        setIncludeNotApproved: _actions.setIncludeNotApproved,
        setDateRangeSelection: _actions.setDateRangeSelection
    }, dispatch);
})(ExportICalLightBoxContent);

/***/ }),
/* 1967 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

var _DateRangeSelector = __webpack_require__(1968);

var _DateRangeSelector2 = _interopRequireDefault(_DateRangeSelector);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TWO_YEARS_RANGE = 365 * 2 + 1;

var ICalFeedDateRangeSelector = function (_TemplateView) {
    _inherits(ICalFeedDateRangeSelector, _TemplateView);

    function ICalFeedDateRangeSelector(_ref) {
        var onSelectionChanged = _ref.onSelectionChanged;

        _classCallCheck(this, ICalFeedDateRangeSelector);

        var _this = _possibleConstructorReturn(this, (ICalFeedDateRangeSelector.__proto__ || Object.getPrototypeOf(ICalFeedDateRangeSelector)).call(this));

        _this.callbacks = {
            onSelectionChanged: onSelectionChanged
        };

        _this.state = {
            selection: null,
            selectionValid: false
        };

        _this.onAnyStatePropertyDeeplyChanged(['selection', 'selectionValid'], function (state) {
            return _this.dateRangeSelector.setState({
                selection: state.selection,
                selectionValid: state.selectionValid
            });
        });
        return _this;
    }

    _createClass(ICalFeedDateRangeSelector, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div class=\'field\'>\n                    <div class=\'fieldTitle\'>\n                        <%=dateRangeSelectorTitle%>\n                    </div>\n                    <div class=\'dateRangeSelectorWrapper fieldInput\'/>\n                </div>';
        }
    }, {
        key: 'messageKeys',
        value: function messageKeys() {
            return {
                dateRangeSelectorTitle: 'icalendar.page.lightbox.field.date_range'
            };
        }
    }, {
        key: 'afterRender',
        value: function afterRender() {
            this.dateRangeSelector = new _DateRangeSelector2.default({
                selectorId: 'dateSelector',
                rangeMaxDays: TWO_YEARS_RANGE,
                rangeTooLongMessageKey: 'date_range_selector.range_error.longer_than_2_years',
                menuStates: [new window.AT.CurrentMonthMenuItem(), new window.AT.CurrentAndNextMonthMenuItem(), new window.AT.NextMonthMenuItem(), new window.AT.PreviousMonthMenuItem(), window.AT.DateRangeSelectorSeparator, new window.AT.CurrentYearMenuItem(), new window.AT.CurrentAndNextYearMenuItem(), new window.AT.NextYearMenuItem(), new window.AT.PreviousYearMenuItem(), window.AT.DateRangeSelectorSeparator, new window.AT.CustomDateRangeMenuItem()],
                onSelectionChanged: this.callbacks.onSelectionChanged
            }).init(this.find('.dateRangeSelectorWrapper'));
        }
    }]);

    return ICalFeedDateRangeSelector;
}(_TemplateView3.default);

exports.default = ICalFeedDateRangeSelector;

/***/ }),
/* 1968 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DateRangeSelector = function (_TemplateView) {
    _inherits(DateRangeSelector, _TemplateView);

    function DateRangeSelector(_ref) {
        var _ref$extraClass = _ref.extraClass,
            extraClass = _ref$extraClass === undefined ? '' : _ref$extraClass,
            selectorId = _ref.selectorId,
            rangeMaxDays = _ref.rangeMaxDays,
            rangeTooLongMessageKey = _ref.rangeTooLongMessageKey,
            menuStates = _ref.menuStates,
            _ref$onSelectionChang = _ref.onSelectionChanged,
            onSelectionChanged = _ref$onSelectionChang === undefined ? function () {} : _ref$onSelectionChang;

        _classCallCheck(this, DateRangeSelector);

        var _this = _possibleConstructorReturn(this, (DateRangeSelector.__proto__ || Object.getPrototypeOf(DateRangeSelector)).call(this));

        _this.params = {
            extraClass: extraClass,
            selectorId: selectorId,
            rangeMaxDays: rangeMaxDays,
            rangeTooLongMessageKey: rangeTooLongMessageKey,
            menuStates: menuStates
        };

        _this.callbacks = {
            onSelectionChanged: onSelectionChanged
        };

        _this.state = {
            selection: null,
            selectionValid: false
        };

        _this.onStatePropertyDeeplyChanged('selection', function (currentSelection, prevSelection) {
            if (currentSelection && !prevSelection) {
                _this._renderSelector(currentSelection);
            }
        });

        _this.onStatePropertyChanged('selectionValid', function (selectionValid) {
            return _this.getEl().toggleClass('incorrectDateRange', !selectionValid);
        });
        return _this;
    }

    _createClass(DateRangeSelector, [{
        key: 'templateHtml',
        value: function templateHtml() {
            return '<div id=\'<%=dateSelectorId%>\' class=\'<%=extraClass%> dateRangeSelector\'/>';
        }
    }, {
        key: 'templateModel',
        value: function templateModel() {
            return {
                extraClass: this.params.extraClass,
                dateSelectorId: this.params.selectorId
            };
        }
    }, {
        key: '_renderSelector',
        value: function _renderSelector(selection) {
            var _this2 = this;

            this.getEl().empty();

            this.dateSelectorController = new window.DateRangeSelectorController().init({
                dateRangeSelection: selection,
                dateRangeParsed: true,
                rangeMaxDays: this.params.rangeMaxDays,
                rangeTooLongMessageKey: this.params.rangeTooLongMessageKey,
                renderTo: this.params.selectorId,
                menuStates: this.params.menuStates,
                callOnChangeCallbackIfInvalid: true
            });

            this.dateSelectorController.setOnChangeCallback(function () {
                return _this2.callbacks.onSelectionChanged({
                    dateRangeSelection: _this2.dateSelectorController.getSelectedRange(),
                    dateRangeValid: !_this2.dateSelectorController.hasErrors()
                });
            });
        }
    }]);

    return DateRangeSelector;
}(_TemplateView3.default);

exports.default = DateRangeSelector;

/***/ }),
/* 1969 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Ext = __webpack_require__(12);

var _Ext2 = _interopRequireDefault(_Ext);

var _at_abstract_picker_button = __webpack_require__(535);

var _at_abstract_picker_button2 = _interopRequireDefault(_at_abstract_picker_button);

var _at_date_picker_menu = __webpack_require__(539);

var _at_date_picker_menu2 = _interopRequireDefault(_at_date_picker_menu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DateSelector = _Ext2.default.extend(_at_abstract_picker_button2.default, {
    showToday: true,
    showOkCancelButtons: true,
    scheduleCalculator: null,
    renderDateMenuToContent: true,
    menuListeners: {
        select: function select(m, d) {
            if (this.date || !this.menu.wasSelectionOnHide) this.updateValueAndFireIfChanged(m, d);else this.menu.onDatePickerCancel();
        },

        datePickerUpdate: function datePickerUpdate(date) {
            // display the given date, but don't actually change the date
            if (this.date) this.displayValue(date);
        },

        datePickerCancel: function datePickerCancel() {
            // display the stored value
            this.displayValue(this.getValue());
            // rollback changes made in the picker
            this.menu.picker.setValue(this.getValueOrDefaultValue());
        }
    },

    getValueOrDefaultValue: function getValueOrDefaultValue() {
        return this.getValue() ? this.getValue() : window.currentUserTime().clearTime();
    },

    createMenu: function createMenu() {
        return new _at_date_picker_menu2.default({
            mode: "dynamic",
            minDate: this.minValue,
            maxDate: this.maxValue,
            format: this.format,
            showToday: this.showToday,
            showOkCancelButtons: this.showOkCancelButtons,
            scheduleCalculator: this.scheduleCalculator,
            startDay: this.weekStartDay,
            value: this.getValueOrDefaultValue(),
            minText: this.minText,
            maxText: this.maxText,
            parentEl: this.renderDateMenuToContent ? this.renderTo : null
        });
    },

    hideMenuOnScrollOrResize: function hideMenuOnScrollOrResize() {
        if (this.getValue()) this.menu.picker.selectActiveDate();
        this.hideMenu(); // hides the menu faster than the previous call
    }
});

exports.default = DateSelector;

/***/ }),
/* 1970 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _at_abstract_picker_button = __webpack_require__(535);

var _at_abstract_picker_button2 = _interopRequireDefault(_at_abstract_picker_button);

var _at_week_picker_menu = __webpack_require__(841);

var _at_week_picker_menu2 = _interopRequireDefault(_at_week_picker_menu);

var _Ext = __webpack_require__(12);

var _Ext2 = _interopRequireDefault(_Ext);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WeekSelector = _Ext2.default.extend(_at_abstract_picker_button2.default, {
    createMenu: function createMenu() {
        return new _at_week_picker_menu2.default({
            minDate: this.minValue,
            maxDate: this.maxValue,
            format: this.format,
            scheduleCalculator: this.scheduleCalculator,
            startDay: this.weekStartDay,
            value: this.date ? this.date : new Date().clearTime(),
            minText: this.minText,
            maxText: this.maxText
        });
    }

});

exports.default = WeekSelector;

/***/ }),
/* 1971 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _ListSelector = __webpack_require__(96);

var _ListSelector2 = _interopRequireDefault(_ListSelector);

var _Ext = __webpack_require__(12);

var _Ext2 = _interopRequireDefault(_Ext);

var _constants = __webpack_require__(4);

var _atUtils = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TimeZoneGroupsListSelector = _Ext2.default.extend(_ListSelector2.default, {

    rawOffsetPropName: "rawOffset",

    createItem: function createItem(listItem) {
        var item = TimeZoneGroupsListSelector.superclass.createItem.call(this, listItem);
        var rawOffset = listItem[this.rawOffsetPropName];

        if (rawOffset || rawOffset === 0) {
            var text = item.text;
            var title = text;

            if (item.value == _constants.DEFAULT_TIME_ZONE_GROUP_ID) {
                var groupNote = _messageResource2.default.getMessage("users_selector.default_group");
                text = "<span class='defaultGroupName'>" + text + "</span>" + "<span class='defaultGroupNote'>" + groupNote + "</span>";
            }

            item.text = "<div class='timeZoneOffset'>" + _messageResource2.default.getMessage("time_zones_selector.js.gmt", [(0, _atUtils.formatRawSecondsOffset)(rawOffset)]) + "</div><div class='timeZoneGroupName' title='" + title + "'>" + text + "</div>";
        }

        return item;
    }

});

exports.default = TimeZoneGroupsListSelector;

/***/ }),
/* 1972 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _atBrowserUtils = __webpack_require__(8);

/**
 * @deprecated see "components/TumblerSwitch"
 */
function TumblerSwitch(enabled, switchCallback, small, readOnly) {
    this.small = small;
    this.switchCallback = switchCallback;
    this.readOnly = readOnly;
    this.img = document.createElement("IMG");

    if (enabled) this.setEnabled();else this.setDisabled();

    var me = this;
    this.img.onclick = function () {
        me.callback();
    };
}

TumblerSwitch.prototype.isEnabled = function () {
    return this.enabled;
};

TumblerSwitch.prototype.render = function (elementId) {
    this.appendAsChildTo(document.getElementById(elementId));
};

TumblerSwitch.prototype.appendAsChildTo = function (elementObj) {
    if (elementObj) elementObj.appendChild(this.img);
};

TumblerSwitch.prototype.callback = function () {
    if (this.readOnly) return;

    if (this.enabled) this.setDisabled();else this.setEnabled();
    this.switchCallback(this.enabled);
};

TumblerSwitch.prototype.setEnabled = function () {
    this.enabled = true;
    this.img.className = "tumblerSwitch move on" + (this.small ? " small" : "") + (this.readOnly ? " readOnly" : "");
    this.img.src = (0, _atBrowserUtils.atImgPath)(this.small ? "switcher_small_fg_on.png" : "switcher_fg_on.png");
};

TumblerSwitch.prototype.setDisabled = function () {
    this.enabled = false;
    this.img.className = "tumblerSwitch move off" + (this.small ? " small" : "") + (this.readOnly ? " readOnly" : "");
    this.img.src = (0, _atBrowserUtils.atImgPath)(this.small ? "switcher_small_fg_off.png" : "switcher_fg_off.png");
};

exports.default = TumblerSwitch;

/***/ }),
/* 1973 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _TabularDataTable = __webpack_require__(964);

var _TabularDataTable2 = _interopRequireDefault(_TabularDataTable);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function TabularDataWithEffectiveDatesTable() {}

TabularDataWithEffectiveDatesTable.prototype = _underscore2.default.create(_TabularDataTable2.default.prototype);

TabularDataWithEffectiveDatesTable.prototype.init = function (tHeadEl, changesCallback, validateCallback, currentTimeInUserTimeZone) {
    _TabularDataTable2.default.prototype.init.call(this, tHeadEl, changesCallback, validateCallback);

    this.todayInUserTimeZone = currentTimeInUserTimeZone.parseJSONDate().truncateTime();

    return this;
};

TabularDataWithEffectiveDatesTable.prototype.getEffectiveRowIdx = function () {
    var effectiveRowIdx = null;
    var effectiveDate = null;

    for (var i = 0; i < this.rows.length; i++) {
        var row = this.rows[i];
        var cell = row.cells[0];

        if (!row.isMarkedToRemove() && !cell.isEmpty() && cell.isValid() && this.todayInUserTimeZone >= cell.getValue() && (effectiveDate == null || effectiveDate < cell.getValue())) {
            effectiveRowIdx = i;
            effectiveDate = cell.getValue();
        }
    }

    return effectiveRowIdx;
};

TabularDataWithEffectiveDatesTable.prototype.updateEffectiveRow = function () {
    var effectiveRowIdx = this.getEffectiveRowIdx();
    var oldEffectiveRowIdx = null;

    for (var i = 0; i < this.rows.length; i++) {
        var row = this.rows[i];
        if (row.isEffective()) oldEffectiveRowIdx = i;
        row.setEffective(false);
    }

    if (effectiveRowIdx != null) {
        this.rows[effectiveRowIdx].setEffective(true);
        this.rows[effectiveRowIdx].updateRowClasses();
    }

    if (oldEffectiveRowIdx != null && oldEffectiveRowIdx != effectiveRowIdx) this.rows[oldEffectiveRowIdx].updateRowClasses();

    return effectiveRowIdx;
};

TabularDataWithEffectiveDatesTable.prototype.markRowsWithEqualEffectiveDatesAsInvalid = function () {
    var rowsArray = this.getRowsWithEqualEffectiveDates();
    var hasInvalid = false;
    for (var i = 0; i < this.rows.length; i++) {
        var cell = this.rows[i].cells[0];
        if (rowsArray[i]) {
            cell.setInvalid();
            hasInvalid = true;
        } else if (!cell.isEmpty()) {
            cell.setValid();
        }
        cell.updateUI();
    }
    return hasInvalid;
};

TabularDataWithEffectiveDatesTable.prototype.getRowsWithEqualEffectiveDates = function () {
    var datesSet = {};
    var rowsWithEqualMarks = [false];

    for (var i = 0; i < this.rows.length; i++) {
        if (this.rows[i].isMarkedToRemove()) continue;
        var date = this.rows[i].cells[0].getValue();
        if (date != null) {
            var dateStr = date.toJSON();
            if (datesSet.hasOwnProperty(dateStr)) {
                rowsWithEqualMarks[i] = true;
                rowsWithEqualMarks[datesSet[dateStr]] = true;
                continue;
            }
            datesSet[dateStr] = i;
        }
    }

    return rowsWithEqualMarks;
};

TabularDataWithEffectiveDatesTable.prototype.hasRowsWithEqualEffectiveDates = function () {
    var rowsWithEqualEffectiveDates = this.getRowsWithEqualEffectiveDates();
    for (var i = 0; i < rowsWithEqualEffectiveDates.length; i++) {
        if (rowsWithEqualEffectiveDates[i]) return true;
    }return false;
};

TabularDataWithEffectiveDatesTable.prototype.hasErrors = function () {
    return _TabularDataTable2.default.prototype.hasErrors.call(this) || this.hasRowsWithEqualEffectiveDates();
};

TabularDataWithEffectiveDatesTable.prototype.validate = function () {
    var valid = _TabularDataTable2.default.prototype.validate.call(this);
    var hasRowsWithEqualEffectiveDates = this.markRowsWithEqualEffectiveDatesAsInvalid();
    return valid && !hasRowsWithEqualEffectiveDates;
};

TabularDataWithEffectiveDatesTable.prototype.doToggleRemove = function (rowIdx) {
    _TabularDataTable2.default.prototype.doToggleRemove.call(this, rowIdx);
    this.markRowsWithEqualEffectiveDatesAsInvalid();
    this.updateEffectiveRow();
};

TabularDataWithEffectiveDatesTable.prototype.removeRowPermanently = function (rowIdx) {
    this.removeRow(rowIdx);
    this.markRowsWithEqualEffectiveDatesAsInvalid();
    this.updateEffectiveRow();
};

TabularDataWithEffectiveDatesTable.prototype.triggerUpdateEvent = function () {
    //    abstract
};

TabularDataWithEffectiveDatesTable.prototype.addEmptyRow = function () {
    _TabularDataTable2.default.prototype.addEmptyRow.call(this);
    this.updateEffectiveRow();
    this.onRowAmountChange();
};
TabularDataWithEffectiveDatesTable.prototype.buildDOM = function (containerEl) {
    _TabularDataTable2.default.prototype.buildDOM.call(this, containerEl);
    this.updateEffectiveRow();
};

TabularDataWithEffectiveDatesTable.prototype.setOpenedExtJSSelector = function (openedExtJSSelector) {
    this.openedExtJSSelector = openedExtJSSelector;
};
TabularDataWithEffectiveDatesTable.prototype.hideOpenedExtJSSelector = function () {
    if (this.openedExtJSSelector) {
        this.openedExtJSSelector.hideMenuOnScrollOrResize();
    }
};

exports.default = TabularDataWithEffectiveDatesTable;

/***/ }),
/* 1974 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _TableCellRenderer = __webpack_require__(63);

var _TableCellRenderer2 = _interopRequireDefault(_TableCellRenderer);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function EffectiveDateCellRenderer() {}

EffectiveDateCellRenderer.prototype = _underscore2.default.create(_TableCellRenderer2.default.prototype);

EffectiveDateCellRenderer.prototype.init = function (invertedDays, weekStartDay, changesCallback, prefix, scrollableContainer, corporateSchedule) {
    _TableCellRenderer2.default.call(this);
    this.invertedDays = invertedDays;
    this.weekStartDay = weekStartDay;
    this.changesCallback = changesCallback;
    this.prefix = prefix;
    this.scrollableContainer = scrollableContainer;
    this.corporateSchedule = corporateSchedule;
    return this;
};

EffectiveDateCellRenderer.prototype.generateContent = function (cell) {
    cell.getCellEl().innerHTML = "<table class='caption' cellpadding=0 cellspacing=0 border=0><tbody><tr><td>" + this.prefix + "</td><td></td><td>:</td></tr></tbody></table>" + "<div class ='current'>" + _messageResource2.default.getMessage("user.add_edit.js.wd_editor.working_schedule_current") + "</div>";

    var self = this;

    var dateSelector = window.ClassicBridge.integrateCalendar(cell.getCellEl().firstChild.firstChild.firstChild.firstChild.nextSibling, {
        selectedDay: cell.getValue(),
        type: 'day',
        placeholder: !cell.getValue() && _messageResource2.default.getMessage("common.date_selector.select_date"),
        onSelect: function onSelect(date) {
            cell.setValue(Date.parseJSONDate(date));
            cell.updateUI();
            dateSelector.setProps({ selectedDay: Date.parseJSONDate(date), placeholder: "" });
            self.changesCallback();
        },
        compactDate: true
    });

    cell.dateSelector = dateSelector;
};

EffectiveDateCellRenderer.prototype.getCellClassName = function (cell) {
    var classes = ["effectiveDateCell", "atNextMount"];
    if (!cell.isValid()) {
        classes.push("invalid");
        cell.dateSelector.setProps({ triggerClassName: "dateError" });
    } else {
        cell.dateSelector.setProps({ triggerClassName: "" });
    }
    return classes;
};

EffectiveDateCellRenderer.prototype.updateUI = function (cell) {
    _TableCellRenderer2.default.prototype.updateUI.call(this, cell);
    cell.dateSelector.setProps({ disabled: cell.getRow().isMarkedToRemove() });
};

exports.default = EffectiveDateCellRenderer;

/***/ }),
/* 1975 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _RemoveRowCellRenderer = __webpack_require__(582);

var _RemoveRowCellRenderer2 = _interopRequireDefault(_RemoveRowCellRenderer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EmptyRemoveRowCellRenderer = function (_RemoveRowCellRendere) {
    _inherits(EmptyRemoveRowCellRenderer, _RemoveRowCellRendere);

    function EmptyRemoveRowCellRenderer() {
        _classCallCheck(this, EmptyRemoveRowCellRenderer);

        return _possibleConstructorReturn(this, (EmptyRemoveRowCellRenderer.__proto__ || Object.getPrototypeOf(EmptyRemoveRowCellRenderer)).apply(this, arguments));
    }

    _createClass(EmptyRemoveRowCellRenderer, [{
        key: "generateContent",
        value: function generateContent(cell) {
            //do nothing
        }
    }]);

    return EmptyRemoveRowCellRenderer;
}(_RemoveRowCellRenderer2.default);

exports.default = EmptyRemoveRowCellRenderer;

/***/ }),
/* 1976 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _DeleteConfirmation = __webpack_require__(1977);

var _DeleteConfirmation2 = _interopRequireDefault(_DeleteConfirmation);

var _RemoveRowCellRenderer = __webpack_require__(582);

var _RemoveRowCellRenderer2 = _interopRequireDefault(_RemoveRowCellRenderer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RemoveRowWithConfirmationCellRenderer = function (_RemoveRowCellRendere) {
    _inherits(RemoveRowWithConfirmationCellRenderer, _RemoveRowCellRendere);

    function RemoveRowWithConfirmationCellRenderer() {
        _classCallCheck(this, RemoveRowWithConfirmationCellRenderer);

        return _possibleConstructorReturn(this, (RemoveRowWithConfirmationCellRenderer.__proto__ || Object.getPrototypeOf(RemoveRowWithConfirmationCellRenderer)).apply(this, arguments));
    }

    _createClass(RemoveRowWithConfirmationCellRenderer, [{
        key: "onRemoveClick",
        value: function onRemoveClick(cell) {
            var _this2 = this;

            var row = cell.getRow();
            this._hideCells(row);
            if (row.isEmpty()) {
                row.getTable().removeRowPermanently(row.getRowIdx());
                return;
            }
            if (!row.confirmDialog) row.confirmDialog = new _DeleteConfirmation2.default((0, _jquery2.default)(row.getRowEl()), "userlist.userdata.effective_date_row_delete_confirmation", {
                onConfirm: function onConfirm() {
                    (0, _jquery2.default)(row.getTable()).trigger("rowDeleted", [row]);
                },
                onCancel: function onCancel() {
                    _this2._showCells(row);
                }
            }).init();
        }
    }, {
        key: "_showCells",
        value: function _showCells(row) {
            row.setDeleteConfirmation(false);
            row.updateUI();
        }
    }, {
        key: "_hideCells",
        value: function _hideCells(row) {
            row.setDeleteConfirmation(true);
            row.updateUI();
        }
    }]);

    return RemoveRowWithConfirmationCellRenderer;
}(_RemoveRowCellRenderer2.default);

exports.default = RemoveRowWithConfirmationCellRenderer;

/***/ }),
/* 1977 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TemplateView2 = __webpack_require__(1);

var _TemplateView3 = _interopRequireDefault(_TemplateView2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DeleteConfirmationCell = function (_TemplateView) {
    _inherits(DeleteConfirmationCell, _TemplateView);

    function DeleteConfirmationCell($containerEl, deleteMessageKey, _ref) {
        var _ref$onConfirm = _ref.onConfirm,
            onConfirm = _ref$onConfirm === undefined ? function () {} : _ref$onConfirm,
            _ref$onCancel = _ref.onCancel,
            onCancel = _ref$onCancel === undefined ? function () {} : _ref$onCancel;

        _classCallCheck(this, DeleteConfirmationCell);

        var _this = _possibleConstructorReturn(this, (DeleteConfirmationCell.__proto__ || Object.getPrototypeOf(DeleteConfirmationCell)).call(this, $containerEl));

        _this.deleteMessageKey = deleteMessageKey;
        _this.params = {
            onConfirm: onConfirm,
            onCancel: onCancel
        };
        return _this;
    }

    _createClass(DeleteConfirmationCell, [{
        key: "templateHtml",
        value: function templateHtml() {
            return "<td class='deleteConfirmationRow' colspan='5'>" + "    <div class='messageWrapper'><span class='message'><%=message%></span></div>" + "    <div class='confirmBtn'><button><%=confirm%></button></div>" + "    <div class='cancelBtn'><%=cancel%></div>" + "</td>";
        }
    }, {
        key: "messageKeys",
        value: function messageKeys() {
            return {
                message: this.deleteMessageKey,
                confirm: "common.delete_confirm",
                cancel: "common.cancel"
            };
        }
    }, {
        key: "afterRender",
        value: function afterRender() {

            this.find('.confirmBtn').click(this.params.onConfirm);
            this.find('.cancelBtn').click(this.params.onCancel);
        }
    }, {
        key: "remove",
        value: function remove() {
            this.$el.remove();
        }
    }]);

    return DeleteConfirmationCell;
}(_TemplateView3.default);

exports.default = DeleteConfirmationCell;

/***/ }),
/* 1978 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _constants = __webpack_require__(4);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _date_format = __webpack_require__(16);

var _UserNameFormat = __webpack_require__(17);

var _UserNameFormat2 = _interopRequireDefault(_UserNameFormat);

var _UserDataLightBox = __webpack_require__(581);

var _UserDataLightBox2 = _interopRequireDefault(_UserDataLightBox);

var _spin = __webpack_require__(93);

var _spin2 = _interopRequireDefault(_spin);

var _CopyUserSettingsSelector = __webpack_require__(906);

var _CopyUserSettingsSelector2 = _interopRequireDefault(_CopyUserSettingsSelector);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CreateUserLightBox() {}

CreateUserLightBox.prototype = new _UserDataLightBox2.default();

CreateUserLightBox.prototype.close_tab_confirmation_message_key = "user.add.js.close_tab_confirmation";

CreateUserLightBox.prototype.init = function (sectionsBuilder, userManagementData, accountSettings, allUsers, copyUserSettingsSelectCallback, copiedUserId, onHideCallback, userGroupEnabled, timeZoneGroupEnabled, showOvertime, otherProductStatusEditable) {
    _UserDataLightBox2.default.prototype.init.call(this, sectionsBuilder, userManagementData, null, accountSettings, showOvertime, otherProductStatusEditable);

    this.isDataLoaded = true;
    this.setTitle(_messageResource2.default.getMessage("user.add.js.new"));
    this.setNameInTitle("");

    this.copyUserSettingsSelectCallback = copyUserSettingsSelectCallback;

    // UsersSelector should be created after show LightBox, otherwise it will be created with wrong width
    this.initAfterShowing = function () {
        var allGroups = userManagementData.allUserGroups ? userManagementData.allUserGroups : userManagementData.allTimeZoneGroups;
        this.cl(this.initUsersSelector(allGroups, allUsers, copiedUserId, userGroupEnabled, timeZoneGroupEnabled));
    };

    this.setDeleteButtonVisibility(false);

    var buttonMessageKey = _constants.isOlVersion ? "user.add.js.create_user_with_invitation" : "user.add.js.create_user";
    this.setCommitButtonTitle(_messageResource2.default.getMessage(buttonMessageKey));

    (0, _jquery2.default)(this.lightBoxEl).removeClass("editMode");
    (0, _jquery2.default)(this.lightBoxEl).addClass("createMode");

    this.cancel_confirmation_message_key = "user.add.js.cancel_confirmation";

    this.onHideCallback = onHideCallback;

    this.needToConfirmWhenCopySettings = false;

    var spinnerOptions = {
        lines: 11, // The number of lines to draw
        length: 3, // The length of each line
        width: 2, // The line thickness
        radius: 4, // The radius of the inner circle
        corners: 1, // Corner roundness (0..1)
        rotate: 0, // The rotation offset
        direction: 1, // 1: clockwise, -1: counterclockwise
        color: '#bbbbbb', // #rgb or #rrggbb
        speed: 1, // Rounds per second
        trail: 60, // Afterglow percentage
        shadow: false, // Whether to render a shadow
        hwaccel: false, // Whether to use hardware acceleration
        className: 'spinner', // The CSS class to assign to the spinner
        zIndex: 2e9, // The z-index (defaults to 2000000000)
        top: 'auto', // Top position relative to parent in px
        left: 'auto' // Left position relative to parent in px
    };
    this.spinner = new _spin2.default(spinnerOptions);
    this.spinnerPlaceholder = document.getElementById(this.lightBoxEl.id + "_usersSelectorSpinnerPlaceholder");

    return this;
};

CreateUserLightBox.prototype.cl = function (func) {
    var self = this;
    return function () {
        func.apply(self, arguments);
    };
};

CreateUserLightBox.prototype.getDataToCommit = function () {
    return this._userInputDataFetcher.getCreateUserInputData(this.userManagementData);
};

CreateUserLightBox.prototype.initUsersSelector = function (allUserGroups, allUsers, copiedUserId, ugrEnabled, tzgEnabled) {
    // TODO remove this in future
    window.usersSelector = new _CopyUserSettingsSelector2.default();
    window.usersSelector.init(allUserGroups, allUsers, this.cl(this.onCopyUserSettingsSelect), copiedUserId, ugrEnabled, tzgEnabled);
};

CreateUserLightBox.prototype.onCopyUserSettingsSelect = function (selectedUserId) {
    if (this.confirmCopySettingsIfNeeded()) {
        this.spinner.spin(this.spinnerPlaceholder);

        this.showOvertime = true;
        if (this.copyUserSettingsSelectCallback) this.copyUserSettingsSelectCallback(this, selectedUserId);
    } else {
        window.usersSelector.enableInput();
        window.usersSelector.rollbackSelection();
    }
};

CreateUserLightBox.prototype.getLightBoxState = function () {
    var userInputData = this._userInputDataFetcher.getUserInputDataThatNotWillBeCopied(this.userManagementData);

    var sectionsErrorState = [];
    for (var i = 0; i < this._orderedSectionsList.length; i++) {
        sectionsErrorState.push(this._orderedSectionsList[i].getErrorState());
    }var errorState = { hasErrorInFooter: this._hasErrorInFooter(), sectionsErrorState: sectionsErrorState };

    var scrollPosition = this.getScrollPosition();

    var collectedChanges = this.collectedChanges;

    return { userInputData: userInputData, errorState: errorState, scrollPosition: scrollPosition, collectedChanges: collectedChanges };
};

CreateUserLightBox.prototype.setNeedToConfirmWhenCopySettings = function (needToConfirmWhenCopySettings) {
    this.needToConfirmWhenCopySettings = needToConfirmWhenCopySettings;
};

CreateUserLightBox.prototype.confirmCopySettingsIfNeeded = function () {
    return !this.needToConfirmWhenCopySettings || confirm(_messageResource2.default.getMessage("user.add.js.copy_settings_confirmation"));
};

CreateUserLightBox.prototype.show = function () {
    _UserDataLightBox2.default.prototype.show.call(this);
    this.initAfterShowing();
    this._sectionsBuilder.initAfterShowing(true);
};

CreateUserLightBox.prototype.hide = function () {
    _UserDataLightBox2.default.prototype.hide.call(this);
    this.hideSpinner();
    // TODO remove this in future
    window.usersSelector.clean();
    (0, _jquery2.default)(this.lightBoxEl).removeClass("accountCreated");

    //see bug 47830: force usersSelector to close.
    if (window.usersSelector) window.usersSelector.usersCombo.collapse();

    if (this.onHideCallback) this.onHideCallback();
};

CreateUserLightBox.prototype.changesDetected = function () {};

CreateUserLightBox.prototype.hideSpinner = function () {
    this.spinner.stop();
};

CreateUserLightBox.prototype.disableUserInputWhileSaving = function () {
    _UserDataLightBox2.default.prototype.disableUserInputWhileSaving.call(this);
    // TODO remove this in future
    window.usersSelector.disable();
};

CreateUserLightBox.prototype.enableUserInputWhileSaving = function () {
    _UserDataLightBox2.default.prototype.enableUserInputWhileSaving.call(this);
    // TODO remove this in future
    window.usersSelector.enable();
};

CreateUserLightBox.prototype.restoreState = function (errorState, scrollPosition) {
    this._restoreErrorState(errorState);
    this.setScrollPosition(scrollPosition);

    this._restoreSectionAfterLoad();
    this._changesCallback();
};

CreateUserLightBox.prototype._restoreErrorState = function (errorState) {
    var hasNotReplacedErrors = false;
    for (var i = 0; i < this._orderedSectionsList.length; i++) {
        var errState = errorState.sectionsErrorState[i];

        if (errState) {
            for (var p in errState) {
                //noinspection JSUnfilteredForInLoop
                if (errState[p]) hasNotReplacedErrors = true;
            }
        }

        this._orderedSectionsList[i].setErrorState(errState);
    }

    if (errorState.hasErrorInFooter && hasNotReplacedErrors) this.printErrorInFooter(_messageResource2.default.getMessage("user.add_edit.js.footer_error.exist_invalid_fields"));
};

CreateUserLightBox.prototype._restoreSectionAfterLoad = function () {
    for (var i = 0; i < this._orderedSectionsList.length; i++) {
        if (this._orderedSectionsList[i].sectionWasLoaded) this._orderedSectionsList[i].sectionWasLoaded();
    }
};

CreateUserLightBox.prototype._showOvertime = function () {
    return true;
};

CreateUserLightBox.prototype.switchToAccountCreatedState = function (invitationSent, addOneMoreUserCallback) {
    var self = this;

    (0, _jquery2.default)(this.lightBoxEl).addClass("accountCreated");
    this.isDataLoaded = false;
    this._commitEnabled = false;
    this.dataChanged = false;
    // TODO remove this in future
    window.usersSelector.disable();

    var userInfo = this._userInputDataFetcher.getUserInputDataForAccountCreatedState(this.userManagementData);

    var accountCreatedSectionEl = (0, _jquery2.default)('#' + this.lightBoxEl.id + '_accountCreatedSection');

    var formattedUserName = _UserNameFormat2.default.formatFML(userInfo.firstName, userInfo.lastName, userInfo.middleInitial);
    var invitationInfoHeader = _messageResource2.default.getEscapedMessage("user.created.account_has_been_created", [formattedUserName]);
    accountCreatedSectionEl.find(".invitationInfoHeader").html(invitationInfoHeader);

    accountCreatedSectionEl.toggleClass("letterWillBeSent", !invitationSent);

    var formattedHireDate = new _date_format.DateFormat(window.SystemSettings.dateFormat).formatDate(userInfo.hireDate.parseJSONDate());
    var invitationInfoText = invitationSent ? _messageResource2.default.getEscapedMessage("user.created.invitation_info.letter_sent", [userInfo.email]) : _messageResource2.default.getEscapedMessage("user.created.invitation_info.hire_date_in_future", [userInfo.email, formattedHireDate]);
    accountCreatedSectionEl.find(".invitationInfo").html(invitationInfoText);

    var inviteOneMoreUserButton = accountCreatedSectionEl.find(".inviteOneMoreButton span");
    inviteOneMoreUserButton.click(function () {
        self.cancel();
        addOneMoreUserCallback();
    });

    var closeButton = accountCreatedSectionEl.find(".closeLink span");
    closeButton.click(function () {
        self.cancel();
    });

    var overlayDiv = (0, _jquery2.default)(this.lightBoxEl).find(".accountCreatedOverlay");
    if (overlayDiv.length == 0) {
        overlayDiv = (0, _jquery2.default)("<div class='accountCreatedOverlay'></div>");
        (0, _jquery2.default)(this.lightBoxEl).append(overlayDiv);
    }
};

exports.default = CreateUserLightBox;

/***/ }),
/* 1979 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _FormatUtils = __webpack_require__(142);

var _FormatUtils2 = _interopRequireDefault(_FormatUtils);

var _index = __webpack_require__(22);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OvertimeReportFormatUtils = function (_BaseReportFormatUtil) {
    _inherits(OvertimeReportFormatUtils, _BaseReportFormatUtil);

    function OvertimeReportFormatUtils() {
        _classCallCheck(this, OvertimeReportFormatUtils);

        return _possibleConstructorReturn(this, (OvertimeReportFormatUtils.__proto__ || Object.getPrototypeOf(OvertimeReportFormatUtils)).apply(this, arguments));
    }

    _createClass(OvertimeReportFormatUtils, null, [{
        key: "makePDFTitle",
        value: function makePDFTitle(selectedParameters, andSubstitutionKey) {
            andSubstitutionKey = _underscore2.default.isUndefined(andSubstitutionKey) ? 'common_report.pdf.header.amp' : andSubstitutionKey;
            var andMessage = _messageResource2.default.getMessage(andSubstitutionKey);

            if ((0, _index.isEnabled)(_index.Feature.OVR)) return _messageResource2.default.getMessage('overtime_report.pdf.header.time_balance_and_overtime', [andMessage]);

            return _messageResource2.default.getMessage('overtime_report.pdf.header.time_balance');
        }
    }]);

    return OvertimeReportFormatUtils;
}(_FormatUtils2.default);

exports.default = OvertimeReportFormatUtils;

/***/ }),
/* 1980 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _BasePDFDefinitionCreator = __webpack_require__(587);

var _BasePDFDefinitionCreator2 = _interopRequireDefault(_BasePDFDefinitionCreator);

var _LeavesReportUtils = __webpack_require__(584);

var _LeavesReportUtils2 = _interopRequireDefault(_LeavesReportUtils);

var _atBrowserUtils = __webpack_require__(8);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _BalanceType = __webpack_require__(253);

var _BalanceType2 = _interopRequireDefault(_BalanceType);

var _index = __webpack_require__(22);

var _PDFImageCache = __webpack_require__(122);

var _PDFImageCache2 = _interopRequireDefault(_PDFImageCache);

var _constants = __webpack_require__(100);

var _PDFDefinitionBuilder = __webpack_require__(969);

var _PDFDefinitionBuilder2 = _interopRequireDefault(_PDFDefinitionBuilder);

var _DataTableCreateDefinitionHelper = __webpack_require__(589);

var _DataTableCreateDefinitionHelper2 = _interopRequireDefault(_DataTableCreateDefinitionHelper);

var _PDFDefinitionColumnBuilder = __webpack_require__(1981);

var PDFDefinitionColumnBuilder = _interopRequireWildcard(_PDFDefinitionColumnBuilder);

var _FormatUtils = __webpack_require__(967);

var _FormatUtils2 = _interopRequireDefault(_FormatUtils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PDFDefinitionCreator = function (_BasePDFDefinitionCre) {
    _inherits(PDFDefinitionCreator, _BasePDFDefinitionCre);

    function PDFDefinitionCreator() {
        _classCallCheck(this, PDFDefinitionCreator);

        return _possibleConstructorReturn(this, (PDFDefinitionCreator.__proto__ || Object.getPrototypeOf(PDFDefinitionCreator)).apply(this, arguments));
    }

    _createClass(PDFDefinitionCreator, [{
        key: "createDocDefinition",
        value: function createDocDefinition(pdfConfig, parameterFormatter, store) {
            this.parameterFormatter = parameterFormatter;
            this.pdfPrintParams = pdfConfig.pdfPrintParameters;
            this.pdfData = pdfConfig.pdfData;
            this.pdfConfig = pdfConfig;
            this.reportParams = pdfConfig.reportParams;
            this.dateFormat = this.pdfConfig.dateFormat;

            var hasLeaves = _LeavesReportUtils2.default.reportParamsWithLeaves(this.reportParams);
            var hasPto = _LeavesReportUtils2.default.reportParamsWithPTO(this.reportParams);
            var hasSick = _LeavesReportUtils2.default.reportParamsWithSick(this.reportParams);
            var leavesNumber = this.pdfData.leaveTypeIds.length;

            var columns = [];
            columns.push(new PDFDefinitionColumnBuilder.Levels().init(this.reportParams, leavesNumber, hasLeaves, hasPto, hasSick, store, this.pdfPrintParams.paperOrientation));

            if (hasLeaves) {
                columns.push(new PDFDefinitionColumnBuilder.Totals().init(this.reportParams));
                for (var i = 0; i < leavesNumber; i++) {
                    var leaveTypeId = this.pdfData.leaveTypeIds[i];
                    columns.push(new PDFDefinitionColumnBuilder.Leave().init(this.reportParams, leaveTypeId, i));
                }
            }

            if (hasPto) {
                columns.push(new PDFDefinitionColumnBuilder.Balance().init(this.reportParams, _BalanceType2.default.PTO, this.pdfData.defaultWorkDayDuration));
            }

            if (hasSick) {
                columns.push(new PDFDefinitionColumnBuilder.Balance().init(this.reportParams, _BalanceType2.default.SICK, this.pdfData.defaultWorkDayDuration));
            }

            var ddb = new _PDFDefinitionBuilder2.default();
            ddb.init(this.pdfPrintParams.paperOrientation, this.pdfPrintParams.paperSize, columns);

            // start create doc definition
            return _PDFImageCache2.default.preloadImages(this._imagesMap(pdfConfig)) // preload needed images
            .then(_underscore2.default.bind(this._processCreateDocDefinition, this, ddb) // construct doc definition
            ).then(function () {
                // return object for generate pdf
                return {
                    "docDefinition": ddb.getDocDefinitionObject(),
                    "tableLayouts": ddb.getTableLayouts()
                };
            });
        }
    }, {
        key: "_imagesMap",
        value: function _imagesMap() {
            var imagesMap = {
                "logo": {
                    "url": _constants.REPORT_LOGO_PATH
                },
                "filterIcon": {
                    "url": (0, _atBrowserUtils.atImgPath)('filter-for-pdf.png'),
                    "saveAlpha": true
                },
                "noteIcon": {
                    "url": (0, _atBrowserUtils.atImgPath)('support/note_mark.gif'),
                    "saveAlpha": true
                }
            };

            _underscore2.default.each(LeaveTypeStore.getLeaveTypes(), function (leaveType) {
                var iconId = leaveType["iconId"];

                imagesMap["leaveTypeIcon_" + iconId] = {
                    "url": getLeaveTypeIconPath(iconId),
                    "saveAlpha": true
                };
            });

            return imagesMap;
        }
    }, {
        key: "_processCreateDocDefinition",
        value: function _processCreateDocDefinition(ddb) {
            ddb.initDocDefinitionObject(this.pdfPrintParams.showSignatureOnEachPage && this.pdfPrintParams.showSignature, this.pdfPrintParams.showHeaderOnEachPage);

            var headerData = this._createHeaderData();
            if (this.pdfPrintParams.paperOrientation === _constants.PaperOrientation.PORTRAIT) {
                ddb.addPortraitHeader(this.pdfPrintParams.showHeaderOnEachPage, this.pdfPrintParams.showLogoInHeader, headerData);
            } else {
                ddb.addLandscapeHeader(this.pdfPrintParams.showHeaderOnEachPage, this.pdfPrintParams.showLogoInHeader, headerData);
            }

            if (this.pdfConfig.chartSectionConfig.showChart && this.pdfData.chartImage != null) {
                var config = this.pdfConfig.chartSectionConfig;

                var grouping = _FormatUtils2.default.formatGroupingLevel(this.reportParams.firstGroupingLevel);
                var chartType = _FormatUtils2.default.formatChartType(config["chartType"]);

                var viewBy = _messageResource2.default.getMessage("common.pdf.chart.view_by_label", [chartType, grouping]);
                ddb.addChartImage(viewBy, this.pdfData.chartImage);

                var fromDateFormatted = this.dateFormat.formatDate(this.reportParams["dateRangeSelection"]["fromDate"]);
                var toDateFormatted = this.dateFormat.formatDate(this.reportParams["dateRangeSelection"]["toDate"]);
                var totals = this.pdfData.totals;

                var title;
                var total = "";
                var items = [];
                var unitsKey;
                var units;
                if (config["chartType"] == APReportChartType.LEAVE_TIME) {
                    title = _messageResource2.default.getMessage("common.leave.reports.pdf.total_leave_time");
                    total = _FormatUtils2.default.formatTime(totals.totalValue, this.reportParams.timeFormat);

                    _underscore2.default.each(this.pdfData.leaveTypeIds, function (leaveId) {
                        var leave = LeaveTypeStore.getLeaveType(leaveId);
                        items.push({
                            name: leave.name,
                            color: colorMap['leaveType' + leave['iconId']],
                            originalValue: totals.totalsMap[leaveId],
                            value: _FormatUtils2.default.formatTime(totals.totalsMap[leaveId], this.reportParams.timeFormat)
                        });
                    }, this);
                } else if (config["chartType"] == APReportChartType.PTO_BALANCE) {
                    unitsKey = window.SystemSettings.showPTOInHours ? "common.pto_units.hours" : "common.pto_units.days";
                    units = _messageResource2.default.getMessage(unitsKey);
                    title = _messageResource2.default.getMessage("common.pdf.chart.total_pto", [units]);

                    items.push({
                        name: _messageResource2.default.getMessage("common.pdf.chart.total_pto_as_of", [fromDateFormatted]),
                        color: colorMap['ptoBefore'],
                        originalValue: totals.ptoBalance['balanceForFirstColumn'],
                        value: _FormatUtils2.default.formatBalance(totals.ptoBalance['balanceForFirstColumn'], _BalanceType2.default.PTO, this.pdfData.defaultWorkDayDuration)
                    });
                    items.push({
                        name: _messageResource2.default.getMessage("common.pdf.chart.total_pto_as_of", [toDateFormatted]),
                        color: colorMap['ptoAfter'],
                        originalValue: totals.ptoBalance['balanceForSecondColumn'],
                        value: _FormatUtils2.default.formatBalance(totals.ptoBalance['balanceForSecondColumn'], _BalanceType2.default.PTO, this.pdfData.defaultWorkDayDuration)
                    });
                } else {
                    unitsKey = window.SystemSettings.showSickInHours ? "common.pto_units.hours" : "common.pto_units.days";
                    units = _messageResource2.default.getMessage(unitsKey);
                    title = _messageResource2.default.getMessage("common.pdf.chart.total_sick", [units]);

                    items.push({
                        name: _messageResource2.default.getMessage("common.pdf.chart.total_sick_as_of", [fromDateFormatted]),
                        color: colorMap['sickBefore'],
                        originalValue: totals.sickBalance['balanceForFirstColumn'],
                        value: _FormatUtils2.default.formatBalance(totals.sickBalance['balanceForFirstColumn'], _BalanceType2.default.SICK, this.pdfData.defaultWorkDayDuration)
                    });
                    items.push({
                        name: _messageResource2.default.getMessage("common.pdf.chart.total_sick_as_of", [toDateFormatted]),
                        color: colorMap['sickAfter'],
                        originalValue: totals.sickBalance['balanceForSecondColumn'],
                        value: _FormatUtils2.default.formatBalance(totals.sickBalance['balanceForSecondColumn'], _BalanceType2.default.SICK, this.pdfData.defaultWorkDayDuration)
                    });
                }

                ddb.addChartLegend(title, items, total);
            }

            this._addTableData(ddb);

            if (((0, _index.isEnabled)(_index.Feature.PTO) || (0, _index.isEnabled)(_index.Feature.SDB)) && (_LeavesReportUtils2.default.reportParamsWithPTO(this.reportParams) || _LeavesReportUtils2.default.reportParamsWithSick(this.reportParams))) this._addNotes(ddb);
        }
    }, {
        key: "getChartImageSizes",
        value: function getChartImageSizes(pdfPrintParameters) {
            var pdfParameters = _PDFDefinitionBuilder.parameters;
            if (pdfPrintParameters.paperOrientation === _constants.PaperOrientation.LANDSCAPE) {
                pdfParameters = pdfParameters.Landscape;
            } else {
                pdfParameters = pdfParameters.Portrait;
            }

            if (pdfPrintParameters.paperSize === _constants.PaperSize.A4) {
                pdfParameters = pdfParameters.A4;
            } else {
                pdfParameters = pdfParameters.Letter;
            }

            return {
                width: pdfParameters.chartImageSize.width * 2,
                height: pdfParameters.chartImageSize.height * 2
            };
        }
    }, {
        key: "_createHeaderData",
        value: function _createHeaderData() {
            var selectedParameters = this.pdfConfig.reportParams;
            var assignedInfo = this.pdfConfig.assignedInfo;

            return {
                informationTexts: {
                    title: this.parameterFormatter.formatChartPDFReportTitle(selectedParameters),
                    dateRange: this.parameterFormatter.formatChartPDFHeaderDateInformation(selectedParameters)
                },
                filterTexts: this.parameterFormatter.formatChartPDFFilterInformation(selectedParameters, assignedInfo),
                logo: _PDFImageCache2.default.getImage('logo')
            };
        }
    }, {
        key: "_addTableData",
        value: function _addTableData(ddb) {
            new _DataTableCreateDefinitionHelper2.default(ddb, this.pdfData.tableData, {
                dateFormat: this.dateFormat
            }).createTable();
        }
    }, {
        key: "_addNotes",
        value: function _addNotes(ddb) {
            var note = !(0, _index.isEnabled)(_index.Feature.SDB) ? "report.leaves.pto_shown_within_date_range" : !(0, _index.isEnabled)(_index.Feature.PTO) ? "report.leaves.sick_shown_within_date_range" : "report.leaves.balances_shown_within_date_range";

            ddb.addIconedNote(_messageResource2.default.getMessage(note));
        }
    }]);

    return PDFDefinitionCreator;
}(_BasePDFDefinitionCreator2.default);

exports.default = PDFDefinitionCreator;


var colorMap = {
    ptoBefore: '#6898D3',
    ptoAfter: '#86C087',
    sickBefore: '#D97B79',
    sickAfter: '#E3B463',

    leaveType1: '#F67C62',
    leaveType2: '#66A5F3',
    leaveType3: '#BEE470',
    leaveType4: '#FFD953',
    leaveType5: '#A68CDB',
    leaveType6: '#B6AE6C',
    leaveType7: '#C49B6F',
    leaveType8: '#E36AC9',
    leaveType9: '#646CC1',
    leaveType10: '#D88F64',
    leaveType11: '#ACC8E5',
    leaveType12: '#6ACE74',
    leaveType13: '#DC3030',
    leaveType14: '#8238E5',
    leaveType15: '#F1B61E',
    leaveType16: '#8B98A0',
    leaveType17: '#91DF75',
    leaveType18: '#F95660',
    leaveType19: '#A461FF',
    leaveType20: '#E2E53E',
    leaveType21: '#C47DFB',
    leaveType22: '#7DCCF9',
    leaveType23: '#FFA451',
    leaveType24: '#82E1DC'
};

/***/ }),
/* 1981 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Leave = exports.Balance = exports.Totals = exports.Levels = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _BasePDFDefinitionColumnBuilder = __webpack_require__(410);

var BaseColumnBuilder = _interopRequireWildcard(_BasePDFDefinitionColumnBuilder);

var _BalanceType = __webpack_require__(253);

var _BalanceType2 = _interopRequireDefault(_BalanceType);

var _LeaveReportConfig = __webpack_require__(129);

var _StringUtils = __webpack_require__(121);

var _constants = __webpack_require__(100);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _PDFImageCache = __webpack_require__(122);

var _PDFImageCache2 = _interopRequireDefault(_PDFImageCache);

var _constants2 = __webpack_require__(11);

var _PDFDefinitionBuilder = __webpack_require__(969);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PDFDefinitionColumnBuilder = function (_BasePDFDefinitionCol) {
    _inherits(PDFDefinitionColumnBuilder, _BasePDFDefinitionCol);

    function PDFDefinitionColumnBuilder() {
        _classCallCheck(this, PDFDefinitionColumnBuilder);

        var _this = _possibleConstructorReturn(this, (PDFDefinitionColumnBuilder.__proto__ || Object.getPrototypeOf(PDFDefinitionColumnBuilder)).call(this));

        _this.reportGroupingValues = ["reportFirstGroupingValue", "reportThirdGroupingValue"];
        return _this;
    }

    _createClass(PDFDefinitionColumnBuilder, [{
        key: "init",
        value: function init(config, rowSpanNumber) {
            _get(PDFDefinitionColumnBuilder.prototype.__proto__ || Object.getPrototypeOf(PDFDefinitionColumnBuilder.prototype), "init", this).call(this, config, rowSpanNumber ? rowSpanNumber : 2);
            return this;
        }
    }, {
        key: "pushWidth",
        value: function pushWidth(destination, sizes) {}
    }, {
        key: "makeHeader",
        value: function makeHeader() {}
    }, {
        key: "makeRow",
        value: function makeRow(lvl, data) {
            return this._makeRow(this.reportGroupingValues[lvl], data);
        }
    }, {
        key: "makeSubHeader",
        value: function makeSubHeader() {
            return '';
        }
    }, {
        key: "makeThirdLvlHeader",
        value: function makeThirdLvlHeader() {
            return '';
        }
    }, {
        key: "makeFirstRow",
        value: function makeFirstRow(data) {
            return this.makeRow(0, data);
        }
    }, {
        key: "makeSecondRow",
        value: function makeSecondRow(data) {
            return this.makeRow(1, data);
        }
    }]);

    return PDFDefinitionColumnBuilder;
}(BaseColumnBuilder.default);

var Levels = exports.Levels = function (_BaseColumnBuilder$Le) {
    _inherits(Levels, _BaseColumnBuilder$Le);

    function Levels() {
        _classCallCheck(this, Levels);

        return _possibleConstructorReturn(this, (Levels.__proto__ || Object.getPrototypeOf(Levels)).apply(this, arguments));
    }

    _createClass(Levels, [{
        key: "init",
        value: function init(config, leavesNumber, hasLeaves, hasPto, hasSick, store, paperOrientation) {
            _get(Levels.prototype.__proto__ || Object.getPrototypeOf(Levels.prototype), "init", this).call(this, config, 2);

            this.store = store;
            this.groupingLevels = [config.firstGroupingLevel, config.secondGroupingLevel];
            this.reportGroupingStyles = [["reportFirstGroupingRow", "reportFirstGroupingRowMargin"], ["reportThirdGroupingRow", "reportSecondGroupingRowMargin"]];

            this.leavesNumber = leavesNumber;
            this.hasLeaves = hasLeaves;
            this.hasPto = hasPto;
            this.hasSick = hasSick;
            this.maxLen = this.getMaxLen(paperOrientation);

            return this;
        }
    }, {
        key: "getMaxLen",
        value: function getMaxLen(paperOrientation) {
            var columnWidth = paperOrientation === _constants.PaperOrientation.LANDSCAPE ? _PDFDefinitionBuilder.parameters.Landscape.columnWidth : _PDFDefinitionBuilder.parameters.Portrait.columnWidth;

            var baseWidth = columnWidth.levels;
            var width = 100 - (this.hasLeaves ? columnWidth["totals"] : 0);
            width -= this.leavesNumber * columnWidth["leave"];
            width -= this.hasPto ? 2 * columnWidth["balance"] : 0;
            width -= this.hasSick ? 2 * columnWidth["balance"] : 0;

            if (width > baseWidth) baseWidth = width;

            return baseWidth < 15 ? 10 : baseWidth > 55 ? 32 : (baseWidth - columnWidth.levels) / 35 * 22 + 10;
        }
    }, {
        key: "_makeRow",
        value: function _makeRow(style, groupingLevel, identity) {
            var text = this._getTitle(groupingLevel, identity, this.maxLen);
            return this._makeRowDefinition(style, text);
        }
    }, {
        key: "pushWidth",
        value: function pushWidth(destination, sizes) {
            var baseWidth = sizes["levels"];
            var width = 100 - (this.hasLeaves ? sizes["totals"] : 0);
            width -= this.leavesNumber * sizes["leave"];
            width -= this.hasPto ? 2 * sizes["balance"] : 0;
            width -= this.hasSick ? 2 * sizes["balance"] : 0;

            if (width > baseWidth) baseWidth = width;

            destination.push(baseWidth + '%');
        }
    }, {
        key: "makeHeader",
        value: function makeHeader() {
            var firstLevelName = LeavesReportFormatUtils.formatGroupingLevel(this.groupingLevels[0]);
            var secondLevelName = this.groupingLevels[1] == _constants2.ReportGroupingLevel.NONE ? "" : ' / ' + LeavesReportFormatUtils.formatGroupingLevel(this.groupingLevels[1]);
            return this._makeHeaderDefinition(firstLevelName + secondLevelName, [this.tableHeaderStyleNoMargin, "reportLevelsTitle"]);
        }
    }, {
        key: "makeTotals",
        value: function makeTotals() {
            return this._makeRowDefinition("reportTotal", _messageResource2.default.getMessage("report.total"));
        }
    }, {
        key: "makeRow",
        value: function makeRow(lvl, data) {
            return this._makeRow(this.reportGroupingStyles[lvl], this.groupingLevels[lvl], data.id);
        }
    }]);

    return Levels;
}(BaseColumnBuilder.Levels);

var Totals = exports.Totals = function (_BaseColumnBuilder$To) {
    _inherits(Totals, _BaseColumnBuilder$To);

    function Totals() {
        _classCallCheck(this, Totals);

        var _this3 = _possibleConstructorReturn(this, (Totals.__proto__ || Object.getPrototypeOf(Totals)).call(this));

        _this3.reportGroupingValues = ["reportFirstGroupingValue", "reportThirdGroupingValue"];
        return _this3;
    }

    _createClass(Totals, [{
        key: "init",
        value: function init(config) {
            _get(Totals.prototype.__proto__ || Object.getPrototypeOf(Totals.prototype), "init", this).call(this, config, 2);

            this.onlyLeaves = config.columnsConfig === _LeaveReportConfig.LeaveTypeColumnConfig.LEAVE_TIME_ONLY;
            return this;
        }
    }, {
        key: "makeHeader",
        value: function makeHeader() {
            var text = _messageResource2.default.getMessage("common.leave.reports.pdf.total_leave_time") + "\n(" + LeavesReportFormatUtils.formatTimeFormat(this.timeFormat) + ")";

            return this.onlyLeaves ? this._makeHeaderDefinition(text) : this._makeHeaderDefinition(text, [this.tableHeaderStyleNoMargin, "reportTotalTitle"]);
        }
    }, {
        key: "_getValue",
        value: function _getValue(data) {
            return data.total;
        }
    }]);

    return Totals;
}(BaseColumnBuilder.Totals);

var Balance = exports.Balance = function (_PDFDefinitionColumnB) {
    _inherits(Balance, _PDFDefinitionColumnB);

    function Balance() {
        _classCallCheck(this, Balance);

        return _possibleConstructorReturn(this, (Balance.__proto__ || Object.getPrototypeOf(Balance)).apply(this, arguments));
    }

    _createClass(Balance, [{
        key: "init",
        value: function init(config, type, defaultWorkDayDuration) {
            _get(Balance.prototype.__proto__ || Object.getPrototypeOf(Balance.prototype), "init", this).call(this, config);

            this.type = type;
            this.defaultWorkDayDuration = defaultWorkDayDuration;
            var dateRange = config.dateRangeSelection;

            this.templateModel = LeavesReportFormatUtils.makeBalanceTemplateModel(this.type, config.firstGroupingLevel, config.secondGroupingLevel, dateRange.fromDate, dateRange.toDate);

            return this;
        }
    }, {
        key: "pushWidth",
        value: function pushWidth(destination, sizes) {
            var size = sizes["balance"] + '%';
            destination.push(size);
            destination.push(size);
        }
    }, {
        key: "makeHeader",
        value: function makeHeader() {
            return [{
                style: this.tableHeaderStyle,
                text: this.templateModel.title,
                colSpan: 2
            }, {}];
        }
    }, {
        key: "makeSubHeader",
        value: function makeSubHeader() {
            var firstColumnText = [{ text: this.templateModel.startDate }, { text: this.templateModel.startDateDetails, style: this.smallText }, { text: " (" + this.templateModel.unit + ")", style: this.smallText }];

            var secondColumnText = [{ text: this.templateModel.endDate }, { text: this.templateModel.endDateDetails, style: this.smallText }, { text: " (" + this.templateModel.unit + ")", style: this.smallText }];

            return [{
                style: this.tableHeaderStyle,
                stack: firstColumnText
            }, {
                style: this.tableHeaderStyle,
                text: secondColumnText
            }];
        }
    }, {
        key: "getBalance",
        value: function getBalance(data) {
            return this.type === _BalanceType2.default.PTO ? data.ptoBalances : data.sickBalances;
        }
    }, {
        key: "_makeRow",
        value: function _makeRow(style, data) {
            var balance = this.getBalance(data);
            var startStyle = balance.start < 0 ? [style, this.negativeValue] : style;
            var endStyle = balance.end < 0 ? [style, this.negativeValue] : style;
            return [{
                style: startStyle,
                text: LeavesReportFormatUtils.formatBalance(balance.start, this.type, this.defaultWorkDayDuration)
            }, {
                style: endStyle,
                text: LeavesReportFormatUtils.formatBalance(balance.end, this.type, this.defaultWorkDayDuration)
            }];
        }
    }]);

    return Balance;
}(PDFDefinitionColumnBuilder);

var Leave = exports.Leave = function (_PDFDefinitionColumnB2) {
    _inherits(Leave, _PDFDefinitionColumnB2);

    function Leave() {
        _classCallCheck(this, Leave);

        return _possibleConstructorReturn(this, (Leave.__proto__ || Object.getPrototypeOf(Leave)).apply(this, arguments));
    }

    _createClass(Leave, [{
        key: "init",
        value: function init(config, leaveTypeId, leaveTypeIndex) {
            _get(Leave.prototype.__proto__ || Object.getPrototypeOf(Leave.prototype), "init", this).call(this, config);

            this.leaveTypeId = leaveTypeId;
            this.leaveTypeIndex = leaveTypeIndex;
            this.leaveMaxLen = 18;

            this.onlyLeaves = config.columnsConfig === _LeaveReportConfig.LeaveTypeColumnConfig.LEAVE_TIME_ONLY;

            return this;
        }
    }, {
        key: "pushWidth",
        value: function pushWidth(destination, sizes) {
            destination.push(sizes["leave"] + '%');
        }
    }, {
        key: "makeHeader",
        value: function makeHeader() {
            var leaveType = LeaveTypeStore.getLeaveType(this.leaveTypeId);
            var style = this.onlyLeaves ? this.tableHeaderStyle : [this.tableHeaderStyleNoMargin, "reportLeaveTitle"];

            return {
                style: style,
                stack: [{ width: 9, image: _PDFImageCache2.default.getImage("leaveTypeIcon_" + leaveType["iconId"])["image"] }, { text: "\n" + (0, _StringUtils.cutLongText)(leaveType.name, this.leaveMaxLen) }],
                rowSpan: 2
            };
        }
    }, {
        key: "_makeRow",
        value: function _makeRow(style, data) {
            return this._makeRowDefinition(style, LeavesReportFormatUtils.formatTime(data.leaveTypeTotals[this.leaveTypeIndex], this.timeFormat));
        }
    }]);

    return Leave;
}(PDFDefinitionColumnBuilder);

/***/ }),
/* 1982 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _date_format = __webpack_require__(16);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _ChartPDFDateRangeFormattingStrategy = __webpack_require__(247);

var _ChartPDFDateRangeFormattingStrategy2 = _interopRequireDefault(_ChartPDFDateRangeFormattingStrategy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PDFParametersFormattingStrategy = function () {
    function PDFParametersFormattingStrategy() {
        _classCallCheck(this, PDFParametersFormattingStrategy);
    }

    _createClass(PDFParametersFormattingStrategy, [{
        key: "init",
        value: function init(config) {
            this.productSettingsValidator = config.productSettingsValidator;
            this.reportRightsValidator = config.reportRightsValidator;
            this.dateParametersFormattingStrategy = this.createDateParametersFormattingStrategy(config.dateFormat, config.dateFormatForFile);
            this.reportParamsStringBuilder = new config.reportParamsStringBuilderConstructor({
                data: {
                    users: config.users,
                    userGroupsFeatureEnabled: !_.isNull(config.userGroups) && this.productSettingsValidator.isUGREnabled(),
                    tzGroupsFeatureEnabled: !_.isNull(config.timeZoneGroups) && this.productSettingsValidator.isTZGEnabled(),
                    userGroups: config.userGroups,
                    timeZoneGroups: config.timeZoneGroups,
                    leaveTypesMap: config.leaveTypesMap,
                    manageableUserIds: config.manageableUserIds,
                    projectsWithMaIds: config.projectsWithMaIds
                },
                dateFormat: config.dateFormat,
                reportAuthorizationInfo: config.reportAuthorizationInfo
            });

            this.reportAuthorizationInfo = config.reportAuthorizationInfo;
            this.shortDateFormat = new _date_format.DateFormat(window.SystemSettings.dateFormat);
            return this;
        }
    }, {
        key: "createDateParametersFormattingStrategy",
        value: function createDateParametersFormattingStrategy(dateFormat, dateFormatForFile) {
            return new _ChartPDFDateRangeFormattingStrategy2.default(dateFormat, dateFormatForFile);
        }
    }, {
        key: "formatChartPDFFilterInformation",
        value: function formatChartPDFFilterInformation(selectedParameters, assignedInfo) {
            return {
                firstRow: this.formatUsersSelection(selectedParameters.userSelection, assignedInfo),
                secondRow: this.formatLeaveTypesSelection(selectedParameters.leaveTypeSelection)
            };
        }
    }, {
        key: "formatUsersSelection",
        value: function formatUsersSelection(userSelection, assignedInfo) {
            return this.reportParamsStringBuilder.getUserSelectionParamString(userSelection, assignedInfo);
        }
    }, {
        key: "formatLeaveTypesSelection",
        value: function formatLeaveTypesSelection(leaveTypeSelection) {
            return this.reportParamsStringBuilder.getLeaveTypeSelectionParamString(leaveTypeSelection);
        }
    }, {
        key: "formatChartPDFHeaderDateInformation",
        value: function formatChartPDFHeaderDateInformation(selectedParameters) {
            return this.dateParametersFormattingStrategy.formatDateInformation(selectedParameters);
        }
    }, {
        key: "formatChartPDFFileName",
        value: function formatChartPDFFileName(selectedParameters) {
            var dateRange = selectedParameters.dateRangeSelection;
            var formattedDateRange = "(" + this.shortDateFormat.formatDate(dateRange.fromDate) + " - " + this.shortDateFormat.formatDate(dateRange.toDate) + ")";

            var fileNameParts = [];
            fileNameParts.push(this._makePDFTitle('common.leave.reports.pdf.header.and'));
            fileNameParts.push(formattedDateRange);

            return _messageResource2.default.getMessage('common.leave.reports.pdf.file_name', fileNameParts);
        }
    }, {
        key: "_makePDFTitle",
        value: function _makePDFTitle(andSubstitutionKey) {
            andSubstitutionKey = _.isUndefined(andSubstitutionKey) ? 'common.leave.reports.pdf.header.amp' : andSubstitutionKey;
            var andMessage = _messageResource2.default.getMessage(andSubstitutionKey);

            var enabledPTO = this.reportAuthorizationInfo.ptoBalancesAvailable;
            var enabledSick = this.reportAuthorizationInfo.sickDaysBalancesAvailable;

            if (!enabledPTO && !enabledSick) return _messageResource2.default.getMessage('common.leave.reports.pdf.header.leave_time');

            var balanceMessage = andMessage + " " + this.reportParamsStringBuilder.getBalancesParamString(enabledPTO, enabledSick);
            return _messageResource2.default.getMessage('common.leave.reports.pdf.header.leave_time_and_balances', [balanceMessage]);
        }
    }, {
        key: "formatChartPDFHeaderTitle",
        value: function formatChartPDFHeaderTitle(selectedParameters) {
            return _messageResource2.default.getMessage('common.leave.reports.pdf.header.report', [this._makePDFTitle()]);
        }
    }, {
        key: "formatChartPDFReportTitle",
        value: function formatChartPDFReportTitle(selectedParameters) {
            var showBy = LeavesReportFormatUtils.formatGroupingLevel(selectedParameters.firstGroupingLevel);
            return _messageResource2.default.getMessage('common.leave.reports.pdf.header.report_by', [this._makePDFTitle(), showBy]);
        }
    }]);

    return PDFParametersFormattingStrategy;
}();

exports.default = PDFParametersFormattingStrategy;

/***/ }),
/* 1983 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _PDFPreviewLightbox = __webpack_require__(590);

var _PDFPreviewLightbox2 = _interopRequireDefault(_PDFPreviewLightbox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ApPdfPreviewLightbox = function ApPdfPreviewLightbox() {};

ApPdfPreviewLightbox.prototype = _.create(_PDFPreviewLightbox2.default.prototype, {
    createPDFLightboxController: function createPDFLightboxController(_ref) {
        var lightBoxEl = _ref.lightBoxEl,
            titleEl = _ref.titleEl,
            popupId = _ref.popupId,
            eventNamespace = _ref.eventNamespace;

        return new APReportsPage.PDFPreviewLightboxController().init({
            lightBoxEl: lightBoxEl,
            titleEl: titleEl,
            popupId: popupId,
            eventNamespace: eventNamespace,
            productSettingsValidator: new APProductSettingsValidator(),
            reportRightsValidator: new APReportRightsValidator()
        });
    }
});

exports.default = ApPdfPreviewLightbox;

/***/ }),
/* 1984 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _PDFPreviewController = __webpack_require__(380);

var _PDFPreviewController2 = _interopRequireDefault(_PDFPreviewController);

var _PDFSettingsPreview = __webpack_require__(1985);

var _PDFSettingsPreview2 = _interopRequireDefault(_PDFSettingsPreview);

var _ParametersFormattingStrategy = __webpack_require__(1987);

var _ParametersFormattingStrategy2 = _interopRequireDefault(_ParametersFormattingStrategy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PDFPreviewLightboxController = function PDFPreviewLightboxController() {};

PDFPreviewLightboxController.prototype = _.create(_PDFPreviewController2.default.prototype, {

    _initPdfSettingsPreview: function _initPdfSettingsPreview(elementsIdPrefix) {
        this.pdfSettingsPreview = new _PDFSettingsPreview2.default((0, _jquery2.default)(this.lightBoxEl).find(".pdfPreviewContainer"), elementsIdPrefix).init();
    },

    _subscribeForEvents: function _subscribeForEvents() {
        var self = this;
        (0, _jquery2.default)(document).on("viewTT.pdfGenerator.start", function () {
            self.onGeneratorStart();
        });
        (0, _jquery2.default)(ViewTTStore).on("generatedPDFChange", function () {
            self.onGeneratePDFCompleted();
        });
    },

    cancelAllExportingProcesses: function cancelAllExportingProcesses() {
        this.pdfViewer.interruptPreview();
    },

    onShow: function onShow() {
        this._setTitle(this.createFormattingStrategy(), this._getSelectedParameters());
    },

    createFormattingStrategy: function createFormattingStrategy() {
        return new _ParametersFormattingStrategy2.default().init({
            selectorsData: this._getSelectorsData(),
            dateFormat: this.dateFormat
        });
    },

    onGeneratorStart: function onGeneratorStart() {
        this.disableDownloadPDFButton();
        this.pdfSettingsPreview.beforePreviewUpdate();
        this.pdfViewer.showMoire();
    },

    onDownloadPDFBtnClicked: function onDownloadPDFBtnClicked() {
        if (!this.downloadPDFBtnEnabled) return;

        (0, _jquery2.default)(document).trigger("viewTT.downloadPDF");
    },

    onGeneratePDFCompleted: function onGeneratePDFCompleted() {
        this.pdfViewer.showPDF(ViewTTStore.getGeneratedPDF());
        this.enableDownloadPDFButton();
    },

    _getSelectorsData: function _getSelectorsData() {
        return {
            customersProjects: ViewTTStore.getMergedCpList()
        };
    },

    _getSelectedParameters: function _getSelectedParameters() {
        return {
            dateParameters: {
                dateRangeSelection: ViewTTStore.getDateRangeConfig()
            },
            statuses: ViewTTPageUtils.isFeatureEnabled(Features["TTA"]) ? ViewTTStore.getFilter().weekApprovalStatuses : null,
            cpSelection: ViewTTStore.getFilter().cpSelection,
            pageOwnerData: {
                otherUser: ViewTTStore.getSelectedUserId() != ViewTTStore.getViewerId(),
                user: ViewTTStore.getSelectedUser()
            }
        };
    }
});

exports.default = PDFPreviewLightboxController;

/***/ }),
/* 1985 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _PDFSettingsPreview2 = __webpack_require__(518);

var _PDFSettingsPreview3 = _interopRequireDefault(_PDFSettingsPreview2);

var _SignatureSettingsSection = __webpack_require__(1986);

var _SignatureSettingsSection2 = _interopRequireDefault(_SignatureSettingsSection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ViewTTPagePDFSettingsPreview = function (_PDFSettingsPreview) {
    _inherits(ViewTTPagePDFSettingsPreview, _PDFSettingsPreview);

    function ViewTTPagePDFSettingsPreview($containerEl, lightboxId) {
        _classCallCheck(this, ViewTTPagePDFSettingsPreview);

        return _possibleConstructorReturn(this, (ViewTTPagePDFSettingsPreview.__proto__ || Object.getPrototypeOf(ViewTTPagePDFSettingsPreview)).call(this, $containerEl, lightboxId));
    }

    _createClass(ViewTTPagePDFSettingsPreview, [{
        key: "afterRender",
        value: function afterRender() {
            _get(ViewTTPagePDFSettingsPreview.prototype.__proto__ || Object.getPrototypeOf(ViewTTPagePDFSettingsPreview.prototype), "afterRender", this).call(this);

            (0, _jquery2.default)(document.getElementById(this.lightboxId + "_numberOfPages")).hide();

            var self = this;
            this.signatureSettingsSection = new _SignatureSettingsSection2.default(this.getCustomSettingsSectionContainer(), this.lightboxId).init();
            (0, _jquery2.default)(this.signatureSettingsSection).on("change", function () {
                self.handleParameterChange();
            });
        }
    }, {
        key: "update",
        value: function update() {
            _get(ViewTTPagePDFSettingsPreview.prototype.__proto__ || Object.getPrototypeOf(ViewTTPagePDFSettingsPreview.prototype), "update", this).call(this);
            this.signatureSettingsSection.update();
        }
    }, {
        key: "subscribeToEvents",
        value: function subscribeToEvents() {
            _get(ViewTTPagePDFSettingsPreview.prototype.__proto__ || Object.getPrototypeOf(ViewTTPagePDFSettingsPreview.prototype), "subscribeToEvents", this).call(this);

            var self = this;
            (0, _jquery2.default)(document).on("viewTT.pdfPreview.lightbox.show", function () {
                self.update();
                var printParametersForGenerate = self.collectPrintParametersForGenerate();
                self.triggerIntermediatePrintParametersChange(printParametersForGenerate);
                self.triggerPrintParametersForGenerateChange(printParametersForGenerate);
            });
        }
    }, {
        key: "unsubscribeFromEvents",
        value: function unsubscribeFromEvents() {
            _get(ViewTTPagePDFSettingsPreview.prototype.__proto__ || Object.getPrototypeOf(ViewTTPagePDFSettingsPreview.prototype), "unsubscribeFromEvents", this).call(this);
            (0, _jquery2.default)(document).off("viewTT.pdfPreview.lightbox.show");
        }
    }, {
        key: "getStore",
        value: function getStore() {
            return ViewTTStore;
        }
    }, {
        key: "updateNumberOfPagesInformation",
        value: function updateNumberOfPagesInformation() {
            // do nothing
        }
    }, {
        key: "triggerIntermediatePrintParametersChange",
        value: function triggerIntermediatePrintParametersChange(newPrintParameters) {
            (0, _jquery2.default)(document).trigger("viewTT.pdfPreview.intermediatePrintParametersChange", newPrintParameters);
        }
    }, {
        key: "triggerPrintParametersForSaveChange",
        value: function triggerPrintParametersForSaveChange(printParametersForSave) {
            (0, _jquery2.default)(document).trigger("viewTT.pdfPreview.printParametersForSaveChange", printParametersForSave);
        }
    }, {
        key: "triggerPrintParametersForGenerateChange",
        value: function triggerPrintParametersForGenerateChange(printParametersForGenerate) {
            (0, _jquery2.default)(document).trigger("viewTT.pdfPreview.printParametersForGenerateChange", printParametersForGenerate);
        }
    }, {
        key: "collectPrintParametersForGenerate",
        value: function collectPrintParametersForGenerate() {
            var printParametersForGenerate = _get(ViewTTPagePDFSettingsPreview.prototype.__proto__ || Object.getPrototypeOf(ViewTTPagePDFSettingsPreview.prototype), "collectPrintParametersForGenerate", this).call(this);
            return _underscore2.default.extend(printParametersForGenerate, this.signatureSettingsSection.collectPrintParameters());
        }
    }, {
        key: "collectPrintParametersForSave",
        value: function collectPrintParametersForSave() {
            return this.collectPrintParametersForGenerate();
        }
    }]);

    return ViewTTPagePDFSettingsPreview;
}(_PDFSettingsPreview3.default);

exports.default = ViewTTPagePDFSettingsPreview;

/***/ }),
/* 1986 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _ViewTTStore = __webpack_require__(73);

var _ViewTTStore2 = _interopRequireDefault(_ViewTTStore);

var _TemplateView = __webpack_require__(1);

var _TemplateView2 = _interopRequireDefault(_TemplateView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SignatureSettingsSection = function SignatureSettingsSection($containerEl, elementsIdPrefix) {
    _TemplateView2.default.call(this, $containerEl);
    this.elementsIdPrefix = elementsIdPrefix;
};

SignatureSettingsSection.prototype = _underscore2.default.create(_TemplateView2.default.prototype, {
    html: "<div class='signatureSettingsSection dataLayoutSection'>" + "  <div>" + "    <table>" + "      <tr>" + "        <td><input id='<%=id%>_signatureSettings_showSignature' type='checkbox' class='showSignature'/></td>" + "        <td><label for='<%=id%>_signatureSettings_showSignature'><%=showSignatureLabel%></label></td>" + "      </tr>" + "    </table>" + "  </div>" + "  <div class='selectorContainer showSignatureSelectorCt'>" + "    <table>" + "      <tr>" + "        <td><input id='<%=id%>_signatureSettings_showSignatureRadio' type='radio' name='showSignature' class='eachPage'/></td>" + "        <td><label for='<%=id%>_signatureSettings_showSignatureRadio'><%=eachPageLabel%></label></td>" + "      </tr>" + "      <tr>" + "        <td><input id='<%=id%>_signatureSettings_hideSignatureRadio' type='radio' name='showSignature' class='lastPage'/></td>" + "        <td><label for='<%=id%>_signatureSettings_hideSignatureRadio'><%=lastPageLabel%></label></td>" + "      </tr>" + "    </table>" + "  </div>" + "</div>",

    templateModel: function templateModel() {
        return { id: this.elementsIdPrefix };
    },

    afterRender: function afterRender() {
        this.$showSignatureCheckbox = this.findAndBindClick(".showSignature", this._onParameterClick);
        this.$eachPageRadio = this.findAndBindClick(".eachPage", this._onParameterClick);
        this.$lastPageRadio = this.findAndBindClick(".lastPage", this._onParameterClick);
    },

    update: function update() {
        var printParameters = _ViewTTStore2.default.getPrintParametersForSave();
        this.$showSignatureCheckbox.attr("checked", printParameters.showSignature);
        this.$eachPageRadio.attr("checked", printParameters.showSignatureOnEachPage);
        this.$lastPageRadio.attr("checked", !printParameters.showSignatureOnEachPage);
        this._updateClasses();
    },

    messageKeys: function messageKeys() {
        return {
            showSignatureLabel: "view_tt.pdf_settings_preview.show_signature",
            eachPageLabel: "view_tt.pdf_settings_preview.show_signature.each_page",
            lastPageLabel: "view_tt.pdf_settings_preview.show_signature.last_page"
        };
    },

    collectPrintParameters: function collectPrintParameters() {
        return {
            showSignature: !!this.$showSignatureCheckbox.attr("checked"),
            showSignatureOnEachPage: !!this.$eachPageRadio.attr("checked")
        };
    },

    _updateClasses: function _updateClasses() {
        this.$el.toggleClass("showSignature", !!this.$showSignatureCheckbox.attr("checked"));
    },

    _onParameterClick: function _onParameterClick() {
        this._updateClasses();
        (0, _jquery2.default)(this).trigger("change");
    }
});

exports.default = SignatureSettingsSection;

/***/ }),
/* 1987 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _BaseParametersFormattingStrategy = __webpack_require__(248);

var _BaseParametersFormattingStrategy2 = _interopRequireDefault(_BaseParametersFormattingStrategy);

var _ParametersFormatter = __webpack_require__(246);

var _ParametersFormatter2 = _interopRequireDefault(_ParametersFormatter);

var _UserNameFormat = __webpack_require__(17);

var _UserNameFormat2 = _interopRequireDefault(_UserNameFormat);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _ATReportParamsStringBuilder = __webpack_require__(52);

var _ATReportParamsStringBuilder2 = _interopRequireDefault(_ATReportParamsStringBuilder);

var _DateRangeFormattingStrategy = __webpack_require__(165);

var _DateRangeFormattingStrategy2 = _interopRequireDefault(_DateRangeFormattingStrategy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ParametersFormattingStrategy = function ParametersFormattingStrategy() {};

ParametersFormattingStrategy.prototype = _.create(_BaseParametersFormattingStrategy2.default.prototype, {

    createParametersFormatter: function createParametersFormatter(_ref) {
        var selectorsData = _ref.selectorsData,
            dateFormat = _ref.dateFormat;

        return new _ParametersFormatter2.default().init({
            selectorsData: selectorsData,
            dateFormat: dateFormat,
            reportParamsStringBuilderConstructor: _ATReportParamsStringBuilder2.default
        });
    },

    createDateParametersFormattingStrategy: function createDateParametersFormattingStrategy(config) {
        return new _DateRangeFormattingStrategy2.default(config.dateFormat);
    },

    formatMainPartOfLightboxTitle: function formatMainPartOfLightboxTitle(selectedParameters) {
        var dateParameters = this.dateParametersFormattingStrategy.formatForDateInformation(selectedParameters.dateParameters);
        if (selectedParameters.pageOwnerData.otherUser) {
            var user = selectedParameters.pageOwnerData.user;
            var userAsString = _UserNameFormat2.default.formatFML(user.firstName, user.lastName, user.middleName);
            return _messageResource2.default.getMessage("view_tt.pdf_preview.other_user_title", [userAsString, dateParameters]);
        }
        return _messageResource2.default.getMessage("view_tt.pdf_preview.my_title", [dateParameters]);
    },

    formatParametersText: function formatParametersText(selectedParameters) {
        var statusesFilter = ViewTTPageUtils.makeStatusFilterToDisplay(selectedParameters.statuses);
        var statuses = _.isNull(statusesFilter) ? "" : this.parametersFormatter.formatStatusesSelection(statusesFilter) + "; ";
        return statuses + this.parametersFormatter.formatCustomersAndProjectsSelection(selectedParameters.cpSelection);
    }
});

exports.default = ParametersFormattingStrategy;

/***/ }),
/* 1988 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _PDFPreviewLightboxController = __webpack_require__(973);

var _PDFPreviewLightboxController2 = _interopRequireDefault(_PDFPreviewLightboxController);

var _PDFSettingsPreview = __webpack_require__(1989);

var _PDFSettingsPreview2 = _interopRequireDefault(_PDFSettingsPreview);

var _ParametersFormattingStrategy = __webpack_require__(1990);

var _ParametersFormattingStrategy2 = _interopRequireDefault(_ParametersFormattingStrategy);

var _OvertimeReportStore = __webpack_require__(411);

var _OvertimeReportStore2 = _interopRequireDefault(_OvertimeReportStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PDFPreviewLightboxController = function PDFPreviewLightboxController() {};

PDFPreviewLightboxController.prototype = _underscore2.default.create(_PDFPreviewLightboxController2.default.prototype, {

    _initPdfSettingsPreview: function _initPdfSettingsPreview(elementsIdPrefix) {
        this.pdfSettingsPreview = new _PDFSettingsPreview2.default((0, _jquery2.default)(this.lightBoxEl).find(".pdfPreviewContainer"), elementsIdPrefix, this.eventNamespace).init();
    },

    createFormattingStrategy: function createFormattingStrategy() {
        return new _ParametersFormattingStrategy2.default().init(this._getSelectorsData(), this.dateFormat, this.productSettingsValidator, this.reportRightsValidator, ATReportsStore.getReportAuthorizationInfo());
    },

    getStore: function getStore() {
        return _OvertimeReportStore2.default;
    },

    _getSelectedParameters: function _getSelectedParameters() {
        var reportParams = this.getStore().getReportParams();
        return {
            dateParameters: {
                dateRangeSelection: reportParams.dateRangeSelection
            },
            userSelection: reportParams.userSelection,
            firstGroupingLevel: reportParams.firstGroupingLevel,
            secondGroupingLevel: reportParams.secondGroupingLevel,
            columnsConfig: reportParams.columnsConfig
        };
    },

    _getSelectorsData: function _getSelectorsData() {
        var store = this.getGeneralStore();
        return {
            users: store.getVisibleUsers(),
            userGroupsEnabled: store.getUserGroupsEnabled(),
            timeZoneGroupsEnabled: store.getTimeZoneGroupsEnabled(),
            userGroups: store.getUserGroups(),
            timeZoneGroups: store.getTimeZoneGroups(),
            manageableUserIds: ATReportsStore.getManageableUserIds()
        };
    }
});

exports.default = PDFPreviewLightboxController;

/***/ }),
/* 1989 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _BaseReportPDFSettingsPreview = __webpack_require__(586);

var _BaseReportPDFSettingsPreview2 = _interopRequireDefault(_BaseReportPDFSettingsPreview);

var _OvertimeReportStore = __webpack_require__(411);

var _OvertimeReportStore2 = _interopRequireDefault(_OvertimeReportStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PDFSettingsPreview = function (_BaseReportPDFSetting) {
    _inherits(PDFSettingsPreview, _BaseReportPDFSetting);

    function PDFSettingsPreview($containerEl, lightboxId, eventNamespace) {
        _classCallCheck(this, PDFSettingsPreview);

        var _this = _possibleConstructorReturn(this, (PDFSettingsPreview.__proto__ || Object.getPrototypeOf(PDFSettingsPreview)).call(this, $containerEl, lightboxId));

        _this.eventNamespace = eventNamespace;
        return _this;
    }

    _createClass(PDFSettingsPreview, [{
        key: "getStore",
        value: function getStore() {
            return _OvertimeReportStore2.default;
        }
    }]);

    return PDFSettingsPreview;
}(_BaseReportPDFSettingsPreview2.default);

exports.default = PDFSettingsPreview;

/***/ }),
/* 1990 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _BaseParametersFormattingStrategy = __webpack_require__(248);

var _BaseParametersFormattingStrategy2 = _interopRequireDefault(_BaseParametersFormattingStrategy);

var _ParametersFormatter = __webpack_require__(246);

var _ParametersFormatter2 = _interopRequireDefault(_ParametersFormatter);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _ATReportParamsStringBuilder = __webpack_require__(52);

var _ATReportParamsStringBuilder2 = _interopRequireDefault(_ATReportParamsStringBuilder);

var _DateRangeFormattingStrategy = __webpack_require__(165);

var _DateRangeFormattingStrategy2 = _interopRequireDefault(_DateRangeFormattingStrategy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ParametersFormattingStrategy = function ParametersFormattingStrategy() {};

ParametersFormattingStrategy.prototype = _.create(_BaseParametersFormattingStrategy2.default.prototype, {

    init: function init(selectorsData, dateFormat, productSettingsValidator, reportRightsValidator, reportAuthorizationInfo) {
        _BaseParametersFormattingStrategy2.default.prototype.init.call(this, { selectorsData: selectorsData, dateFormat: dateFormat, reportAuthorizationInfo: reportAuthorizationInfo });
        this.productSettingsValidator = productSettingsValidator;
        this.reportRightsValidator = reportRightsValidator;
        this.assignedInfo = selectorsData.assignedInfo;
        this.formatUtil = OvertimeReportFormatUtils;

        return this;
    },

    createParametersFormatter: function createParametersFormatter(_ref) {
        var selectorsData = _ref.selectorsData,
            dateFormat = _ref.dateFormat,
            reportAuthorizationInfo = _ref.reportAuthorizationInfo;

        return new _ParametersFormatter2.default().init({
            selectorsData: selectorsData,
            dateFormat: dateFormat,
            reportAuthorizationInfo: reportAuthorizationInfo,
            reportParamsStringBuilderConstructor: _ATReportParamsStringBuilder2.default
        });
    },

    createDateParametersFormattingStrategy: function createDateParametersFormattingStrategy(config) {
        return new _DateRangeFormattingStrategy2.default(config.dateFormat);
    },

    formatMainPartOfLightboxTitle: function formatMainPartOfLightboxTitle(selectedParameters) {
        var reportName = this.formatUtil.makePDFTitle(selectedParameters);
        var showBy = this.formatUtil.formatGroupingLevel(selectedParameters.firstGroupingLevel);
        var dateParameters = this.dateParametersFormattingStrategy.formatForDateInformation(selectedParameters.dateParameters);
        return _messageResource2.default.getMessage("common_report.pdf.title", [reportName, showBy, dateParameters]);
    },

    formatParametersText: function formatParametersText(selectedParameters) {
        return this.parametersFormatter.formatUsersSelection(selectedParameters.userSelection);
    }
});

exports.default = ParametersFormattingStrategy;

/***/ }),
/* 1991 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _BasePDFDefinitionCreator = __webpack_require__(587);

var _BasePDFDefinitionCreator2 = _interopRequireDefault(_BasePDFDefinitionCreator);

var _DataTableCreateDefinitionHelper = __webpack_require__(589);

var _DataTableCreateDefinitionHelper2 = _interopRequireDefault(_DataTableCreateDefinitionHelper);

var _PDFImageCache = __webpack_require__(122);

var _PDFImageCache2 = _interopRequireDefault(_PDFImageCache);

var _constants = __webpack_require__(100);

var _atBrowserUtils = __webpack_require__(8);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _PDFDefinitionColumnBuilder = __webpack_require__(1992);

var PDFDefinitionColumnBuilder = _interopRequireWildcard(_PDFDefinitionColumnBuilder);

var _PDFDefinitionBuilder = __webpack_require__(1993);

var _PDFDefinitionBuilder2 = _interopRequireDefault(_PDFDefinitionBuilder);

var _ColumnsConfig = __webpack_require__(130);

var _index = __webpack_require__(22);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PDFDefinitionCreator = function (_BasePDFDefinitionCre) {
    _inherits(PDFDefinitionCreator, _BasePDFDefinitionCre);

    function PDFDefinitionCreator() {
        _classCallCheck(this, PDFDefinitionCreator);

        return _possibleConstructorReturn(this, (PDFDefinitionCreator.__proto__ || Object.getPrototypeOf(PDFDefinitionCreator)).apply(this, arguments));
    }

    _createClass(PDFDefinitionCreator, [{
        key: "createDocDefinition",
        value: function createDocDefinition(pdfConfig, parameterFormatter, store) {
            this.parameterFormatter = parameterFormatter;
            this.pdfPrintParams = pdfConfig.pdfPrintParameters;
            this.pdfData = pdfConfig.pdfData;
            this.pdfConfig = pdfConfig;
            this.reportParams = pdfConfig.reportParams;
            this.dateFormat = this.pdfConfig.dateFormat;

            var rowSpanNumber = 2;

            var columns = [];
            columns.push(new PDFDefinitionColumnBuilder.Levels().init(this.reportParams, store, rowSpanNumber));

            if (this.reportParams.columnsConfig !== _ColumnsConfig.ColumnsConfig.OVERTIME_ONLY) {
                columns.push(new PDFDefinitionColumnBuilder.TimeBalance().init(this.reportParams, rowSpanNumber));
            }

            if (this.reportParams.columnsConfig !== _ColumnsConfig.ColumnsConfig.TIME_BALANCE_ONLY) {
                columns.push(new PDFDefinitionColumnBuilder.Overtime().init(this.reportParams, rowSpanNumber));
            }

            var ddb = new _PDFDefinitionBuilder2.default();
            ddb.init(this.pdfPrintParams.paperOrientation, this.pdfPrintParams.paperSize, columns, rowSpanNumber, this.reportParams);

            // start create doc definition
            return _PDFImageCache2.default.preloadImages(this._imagesMap(pdfConfig)) // preload needed images
            .then(_underscore2.default.bind(this._processCreateDocDefinition, this, ddb) // construct doc definition
            ).then(function () {
                // return object for generate pdf
                return {
                    "docDefinition": ddb.getDocDefinitionObject(),
                    "tableLayouts": ddb.getTableLayouts()
                };
            });
        }
    }, {
        key: "_imagesMap",
        value: function _imagesMap() {
            return {
                "logo": {
                    "url": _constants.REPORT_LOGO_PATH
                },
                "filterIcon": {
                    "url": (0, _atBrowserUtils.atImgPath)('filter-for-pdf.png'),
                    "saveAlpha": true
                },
                "noteIcon": {
                    "url": (0, _atBrowserUtils.imgPath)('support/note_mark.gif'),
                    "saveAlpha": true
                }
            };
        }
    }, {
        key: "_processCreateDocDefinition",
        value: function _processCreateDocDefinition(ddb) {
            ddb.initDocDefinitionObject(this.pdfPrintParams.showSignatureOnEachPage && this.pdfPrintParams.showSignature, this.pdfPrintParams.showHeaderOnEachPage);

            var headerData = this._createHeaderData();
            if (this.pdfPrintParams.paperOrientation === _constants.PaperOrientation.PORTRAIT) {
                ddb.addPortraitHeader(this.pdfPrintParams.showHeaderOnEachPage, this.pdfPrintParams.showLogoInHeader, headerData);
            } else {
                ddb.addLandscapeHeader(this.pdfPrintParams.showHeaderOnEachPage, this.pdfPrintParams.showLogoInHeader, headerData);
            }

            this._addTableData(ddb);
            if ((0, _index.isEnabled)(_index.Feature.OVR) && this.reportParams.columnsConfig !== _ColumnsConfig.ColumnsConfig.TIME_BALANCE_ONLY) this._addNotes(ddb);
        }
    }, {
        key: "_createHeaderData",
        value: function _createHeaderData() {
            var selectedParameters = this.pdfConfig.reportParams;

            return {
                informationTexts: {
                    title: this.parameterFormatter.formatChartPDFReportTitle(selectedParameters),
                    dateRange: this.parameterFormatter.formatChartPDFHeaderDateInformation(selectedParameters)
                },
                filterTexts: this.parameterFormatter.formatChartPDFFilterInformation(selectedParameters),
                logo: _PDFImageCache2.default.getImage('logo')
            };
        }
    }, {
        key: "_addTableData",
        value: function _addTableData(ddb) {
            new _DataTableCreateDefinitionHelper2.default(ddb, this.pdfData.tableData, {
                dateFormat: this.dateFormat
            }).createTable();
        }
    }, {
        key: "_addNotes",
        value: function _addNotes(ddb) {
            ddb.addNotes(_messageResource2.default.getMessage("overtime_report.pdf.overtime_shown_only_for_note"), '*', true);

            var calculationKey = (0, _index.isEnabled)(_index.Feature.LVT) ? "overtime_report.pdf.overtime_with_leaves_calculation_note" : "overtime_report.pdf.overtime_calculation_note";

            ddb.addNotes(_messageResource2.default.getMessage("report.overtime.auto_calculated_for_user") + '\n' + _messageResource2.default.getMessage(calculationKey), '**', false);

            ddb.addIconedNote(_messageResource2.default.getMessage("report.overtime.auto_calculated_within_date_range"));
        }
    }]);

    return PDFDefinitionCreator;
}(_BasePDFDefinitionCreator2.default);

exports.default = PDFDefinitionCreator;

/***/ }),
/* 1992 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Overtime = exports.TimeBalance = exports.Levels = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _BasePDFDefinitionColumnBuilder = __webpack_require__(410);

var BaseColumnBuilder = _interopRequireWildcard(_BasePDFDefinitionColumnBuilder);

var _constants = __webpack_require__(11);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _ColumnsConfig = __webpack_require__(130);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PDFDefinitionColumnBuilder = function (_BasePDFDefinitionCol) {
    _inherits(PDFDefinitionColumnBuilder, _BasePDFDefinitionCol);

    function PDFDefinitionColumnBuilder() {
        _classCallCheck(this, PDFDefinitionColumnBuilder);

        return _possibleConstructorReturn(this, (PDFDefinitionColumnBuilder.__proto__ || Object.getPrototypeOf(PDFDefinitionColumnBuilder)).apply(this, arguments));
    }

    _createClass(PDFDefinitionColumnBuilder, [{
        key: "init",
        value: function init(config, rowSpanNumber) {
            _get(PDFDefinitionColumnBuilder.prototype.__proto__ || Object.getPrototypeOf(PDFDefinitionColumnBuilder.prototype), "init", this).call(this, config, rowSpanNumber);
            this.reportGroupingValues = ["reportFirstGroupingValue", "reportThirdGroupingValue"];

            return this;
        }
    }]);

    return PDFDefinitionColumnBuilder;
}(BaseColumnBuilder.default);

var Levels = exports.Levels = function (_BaseColumnBuilder$Le) {
    _inherits(Levels, _BaseColumnBuilder$Le);

    function Levels() {
        _classCallCheck(this, Levels);

        return _possibleConstructorReturn(this, (Levels.__proto__ || Object.getPrototypeOf(Levels)).apply(this, arguments));
    }

    _createClass(Levels, [{
        key: "init",
        value: function init(config, store, rowSpanNumber) {
            PDFDefinitionColumnBuilder.prototype.init.call(this, config, rowSpanNumber);

            this.store = store;
            this.groupingLevels = [config.firstGroupingLevel, config.secondGroupingLevel];
            this.reportGroupingStyles = ["reportFirstGroupingRow", "reportThirdGroupingRow"];
            this.reportGroupingMargins = ["reportFirstGroupingRowMargin", "reportSecondGroupingRowMargin"];

            this.isWide = config.columnsConfig != _ColumnsConfig.ColumnsConfig.TIME_BALANCE_AND_OVERTIME;
            this.maxUserNameLen = this.isWide ? "maxUserNameLenWide" : "maxUserNameLen";
            this.showWorkingAndLeaveTime = config.showWorkingAndLeaveTime;
            return this;
        }
    }, {
        key: "_makeCustomRow",
        value: function _makeCustomRow(style, groupingLevel, id) {
            var text = this._getTitle(groupingLevel, id, this.params[this.maxUserNameLen]);
            return this._makeRowDefinition(style, text);
        }
    }, {
        key: "pushWidth",
        value: function pushWidth(destination, sizes) {
            var baseWidth = this.isWide ? sizes["levelsWide"] : sizes["levels"];
            destination.push(baseWidth + '%');
        }
    }, {
        key: "makeHeader",
        value: function makeHeader() {
            var names = [];
            for (var i = 0; i < 2; i++) {
                if (this.groupingLevels[i] != _constants.ReportGroupingLevel.NONE) {
                    names.push(this.formatUtil.formatGroupingLevel(this.groupingLevels[i]));
                }
            }
            return this._makeHeaderDefinition(names.join(' / '), [this.tableHeaderStyleNoMargin, "reportLevelsTitle"]);
        }
    }, {
        key: "makeTotals",
        value: function makeTotals() {
            return this._makeRowDefinition("reportTotal", _messageResource2.default.getMessage("report.total"));
        }
    }, {
        key: "makeRow",
        value: function makeRow(lvl, data) {
            return this._makeCustomRow([this.reportGroupingStyles[lvl], this.reportGroupingMargins[lvl]], this.groupingLevels[lvl], data.id);
        }
    }]);

    return Levels;
}(BaseColumnBuilder.Levels);

var TimeBalance = exports.TimeBalance = function (_PDFDefinitionColumnB) {
    _inherits(TimeBalance, _PDFDefinitionColumnB);

    function TimeBalance() {
        _classCallCheck(this, TimeBalance);

        return _possibleConstructorReturn(this, (TimeBalance.__proto__ || Object.getPrototypeOf(TimeBalance)).apply(this, arguments));
    }

    _createClass(TimeBalance, [{
        key: "init",
        value: function init(config, rowSpanNumber) {
            _get(TimeBalance.prototype.__proto__ || Object.getPrototypeOf(TimeBalance.prototype), "init", this).call(this, config, rowSpanNumber);
            if (config.columnsConfig == _ColumnsConfig.ColumnsConfig.TIME_BALANCE_ONLY) {
                this.sizeName = config.showWorkingAndLeaveTime ? "timeBalance" : "timeBalanceWide";
            } else {
                this.sizeName = config.showWorkingAndLeaveTime ? "timeBalanceAll" : "timeBalance";
            }
            this.showWorkingAndLeaveTime = config.showWorkingAndLeaveTime;
            return this;
        }
    }, {
        key: "pushWidth",
        value: function pushWidth(destination, sizes) {
            destination.push(sizes[this.sizeName] + '%');
            destination.push(sizes[this.sizeName] + '%');
            destination.push(sizes[this.sizeName] + '%');

            if (this.showWorkingAndLeaveTime) {
                destination.push(sizes[this.sizeName] + '%');
                destination.push(sizes[this.sizeName] + '%');
            }
        }
    }, {
        key: "makeHeader",
        value: function makeHeader() {
            var varianceTxt = _messageResource2.default.getMessage("report.overtime.time_balance");

            var header = [{
                style: this.tableHeaderStyle,
                text: varianceTxt,
                colSpan: this.showWorkingAndLeaveTime ? 5 : 3
            }, {}, {}];

            if (this.showWorkingAndLeaveTime) {
                header.push({}, {});
            }
            return header;
        }
    }, {
        key: "makeSubHeader",
        value: function makeSubHeader() {
            var subHeader = [{
                style: this.tableHeaderStyle,
                text: _messageResource2.default.getMessage("report.overtime.time_balance.scheduled")
            }, {
                style: this.tableHeaderStyle,
                text: _messageResource2.default.getMessage("report.overtime.time_balance.reported")
            }, {
                style: this.tableHeaderStyle,
                text: _messageResource2.default.getMessage("report.overtime.time_balance.difference")
            }];

            if (this.showWorkingAndLeaveTime) {
                subHeader.splice(2, 0, {
                    style: this.tableHeaderStyle,
                    text: _messageResource2.default.getMessage("report.overtime.time_balance.working_time")
                }, {
                    style: this.tableHeaderStyle,
                    text: _messageResource2.default.getMessage("report.overtime.time_balance.leave_time")
                });
                subHeader[1].text = _messageResource2.default.getMessage("report.overtime.time_balance.total_reported");
            }

            return subHeader;
        }
    }, {
        key: "_makeRow",
        value: function _makeRow(style, data, valueMask) {
            var row = [this.makeTimeCell(data.scheduledTime, style), this.makeTimeCell(data.reportedTime, style), this.makeSignedTimeCell(data.differenceTime, style)];

            if (this.showWorkingAndLeaveTime) {
                row.splice(2, 0, this.makeTimeCell(data.workingTime, style), this.makeTimeCell(data.leaveTime, style));
            }
            return row;
        }
    }]);

    return TimeBalance;
}(PDFDefinitionColumnBuilder);

var Overtime = exports.Overtime = function (_PDFDefinitionColumnB2) {
    _inherits(Overtime, _PDFDefinitionColumnB2);

    function Overtime() {
        _classCallCheck(this, Overtime);

        return _possibleConstructorReturn(this, (Overtime.__proto__ || Object.getPrototypeOf(Overtime)).apply(this, arguments));
    }

    _createClass(Overtime, [{
        key: "init",
        value: function init(config, rowSpanNumber) {
            _get(Overtime.prototype.__proto__ || Object.getPrototypeOf(Overtime.prototype), "init", this).call(this, config, rowSpanNumber);
            this.sizeName = config.columnsConfig == _ColumnsConfig.ColumnsConfig.OVERTIME_ONLY ? "overtimeWide" : "overtime";
            this.showWorkingAndLeaveTime = config.showWorkingAndLeaveTime;
            return this;
        }
    }, {
        key: "pushWidth",
        value: function pushWidth(destination, sizes) {
            if (this.showWorkingAndLeaveTime) {
                destination.push(sizes["allColumnsOvertimeReported"] + '%');
                destination.push(sizes["allColumnsOvertimeAuto"] + '%');
            } else {
                destination.push(sizes[this.sizeName] + '%');
                destination.push(sizes[this.sizeName] + '%');
            }
        }
    }, {
        key: "makeHeader",
        value: function makeHeader() {
            var varianceTxt = _messageResource2.default.getMessage("report.overtime.overtime");

            return [{
                style: this.tableHeaderStyle,
                text: varianceTxt,
                colSpan: 2
            }, {}];
        }
    }, {
        key: "makeSubHeader",
        value: function makeSubHeader() {
            return [{
                noWrap: false,
                style: this.tableHeaderStyle,
                columns: this.addAsterisk(_messageResource2.default.getMessage("report.overtime.overtime.reported_by_user"), '*')
            }, {
                noWrap: false,
                style: this.tableHeaderStyle,
                columns: this.addAsterisk(_messageResource2.default.getMessage("report.overtime.overtime.auto_calculated"), '**')
            }];
        }
    }, {
        key: "_makeRow",
        value: function _makeRow(style, data, valueMask) {
            var reported = this.makeTimeCell(data.reportedOvertime, style);
            var autocalculated;

            if (data.isEmployed === false) {
                autocalculated = this.makeTextCell(_messageResource2.default.getMessage("report.overtime.not_employed"), this.grayText);
            } else {
                autocalculated = this.makeTimeCell(data.autoOvertime, style);
            }

            return [reported, autocalculated];
        }
    }]);

    return Overtime;
}(PDFDefinitionColumnBuilder);

/***/ }),
/* 1993 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _BaseReportPDFDefinitionBuilder = __webpack_require__(588);

var _BaseReportPDFDefinitionBuilder2 = _interopRequireDefault(_BaseReportPDFDefinitionBuilder);

var _ColumnsConfig = __webpack_require__(130);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PDFDefinitionBuilder = function (_BaseReportPDFDefinit) {
    _inherits(PDFDefinitionBuilder, _BaseReportPDFDefinit);

    function PDFDefinitionBuilder() {
        _classCallCheck(this, PDFDefinitionBuilder);

        return _possibleConstructorReturn(this, (PDFDefinitionBuilder.__proto__ || Object.getPrototypeOf(PDFDefinitionBuilder)).apply(this, arguments));
    }

    _createClass(PDFDefinitionBuilder, [{
        key: "init",
        value: function init(paperOrientation, paperSize, columnStrategies, headerRowsNumber, reportParams) {
            _BaseReportPDFDefinitionBuilder2.default.prototype.init.call(this, paperOrientation, paperSize, columnStrategies, headerRowsNumber);
            this.reportParams = reportParams;
            return this;
        }
    }, {
        key: "getAdditionalStyles",
        value: function getAdditionalStyles() {
            return _BaseReportPDFDefinitionBuilder.styles;
        }
    }, {
        key: "getAdditionalParameters",
        value: function getAdditionalParameters() {
            return parameters;
        }
    }, {
        key: "getAdditionalTableLayouts",
        value: function getAdditionalTableLayouts() {
            var layout = _jquery2.default.extend(true, {}, _BaseReportPDFDefinitionBuilder.tableLayouts);
            if (this.reportParams.columnsConfig === _ColumnsConfig.ColumnsConfig.TIME_BALANCE_AND_OVERTIME) {
                if (this.reportParams.showWorkingAndLeaveTime === true) {
                    layout.reportLayout.vLineWidth = this.timeBalanceAndOvertimeShowWorkingAndLayoutLineWidth;
                } else {
                    layout.reportLayout.vLineWidth = this.timeBalanceAndOvertimeLayoutLineWidth;
                }
            }
            if (this.reportParams.columnsConfig === _ColumnsConfig.ColumnsConfig.TIME_BALANCE_ONLY && this.reportParams.showWorkingAndLeaveTime === true) {
                layout.reportLayout.vLineWidth = this.timeBalanceOnlyShowWorkingAndLeaveLayoutLineWidth;
            }
            return layout;
        }
    }, {
        key: "timeBalanceAndOvertimeShowWorkingAndLayoutLineWidth",
        value: function timeBalanceAndOvertimeShowWorkingAndLayoutLineWidth(i, node) {
            if (i === 3 || i === 4) {
                return 0;
            }
            return i === 1 || i === node.table.widths.length - 2 ? 2 : 1;
        }
    }, {
        key: "timeBalanceAndOvertimeLayoutLineWidth",
        value: function timeBalanceAndOvertimeLayoutLineWidth(i, node) {
            return i === 1 || i === node.table.widths.length - 2 ? 2 : 1;
        }
    }, {
        key: "timeBalanceOnlyShowWorkingAndLeaveLayoutLineWidth",
        value: function timeBalanceOnlyShowWorkingAndLeaveLayoutLineWidth(i) {
            return i === 3 || i === 4 ? 0 : 1;
        }
    }]);

    return PDFDefinitionBuilder;
}(_BaseReportPDFDefinitionBuilder2.default);

exports.default = PDFDefinitionBuilder;


var parameters = {
    dataTableStyles: {
        tableStyle: 'reportRow'
    },

    Portrait: {
        reportParams: {
            maxUserNameLen: 16,
            maxUserNameLenWide: 22
        },
        columnWidth: {
            levels: 26,
            levelsWide: 40,
            overtime: 19,
            allColumnsOvertimeReported: 10,
            allColumnsOvertimeAuto: 14,
            overtimeWide: 30,
            timeBalance: 12,
            timeBalanceAll: 10,
            timeBalanceWide: 20
        },
        A4: {
            limitOfLinesInTextCell: 62
        },
        Letter: {
            limitOfLinesInTextCell: 56
        }
    },
    Landscape: {
        reportParams: {
            maxUserNameLen: 22,
            maxUserNameLenWide: 32
        },
        columnWidth: {
            levels: 26,
            levelsWide: 40,
            overtime: 19,
            allColumnsOvertimeReported: 10,
            allColumnsOvertimeAuto: 14,
            overtimeWide: 30,
            timeBalance: 12,
            timeBalanceAll: 10,
            timeBalanceWide: 20
        },
        A4: {
            limitOfLinesInTextCell: 40
        },
        Letter: {
            limitOfLinesInTextCell: 42
        }
    }
};

/***/ }),
/* 1994 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _date_format = __webpack_require__(16);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _ParametersFormatter = __webpack_require__(1995);

var _ParametersFormatter2 = _interopRequireDefault(_ParametersFormatter);

var _ChartPDFDateRangeFormattingStrategy = __webpack_require__(247);

var _ChartPDFDateRangeFormattingStrategy2 = _interopRequireDefault(_ChartPDFDateRangeFormattingStrategy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PDFParametersFormattingStrategy = function () {
    function PDFParametersFormattingStrategy() {
        _classCallCheck(this, PDFParametersFormattingStrategy);
    }

    _createClass(PDFParametersFormattingStrategy, [{
        key: "init",
        value: function init(config) {
            this.dateParametersFormattingStrategy = this.createDateParametersFormattingStrategy(config.dateFormat, config.dateFormatForFile);
            this.shortDateFormat = new _date_format.DateFormat(window.SystemSettings.dateFormat);
            this.parametersFormatter = new _ParametersFormatter2.default().init({
                selectorsData: config,
                dateFormat: config.dateFormat
            });

            return this;
        }
    }, {
        key: "createDateParametersFormattingStrategy",
        value: function createDateParametersFormattingStrategy(dateFormat, dateFormatForFile) {
            return new _ChartPDFDateRangeFormattingStrategy2.default(dateFormat, dateFormatForFile);
        }
    }, {
        key: "formatChartPDFFilterInformation",
        value: function formatChartPDFFilterInformation(selectedParameters) {
            return {
                firstRow: this.formatUsersSelection(selectedParameters)
            };
        }
    }, {
        key: "formatUsersSelection",
        value: function formatUsersSelection(selectedParameters) {
            return this.parametersFormatter.formatUsersSelection(selectedParameters.userSelection);
        }
    }, {
        key: "formatChartPDFHeaderDateInformation",
        value: function formatChartPDFHeaderDateInformation(selectedParameters) {
            return this.dateParametersFormattingStrategy.formatDateInformation(selectedParameters);
        }
    }, {
        key: "formatChartPDFFileName",
        value: function formatChartPDFFileName(selectedParameters) {
            var dateRange = selectedParameters.dateRangeSelection;
            var formattedDateRange = "(" + this.shortDateFormat.formatDate(dateRange.fromDate) + " - " + this.shortDateFormat.formatDate(dateRange.toDate) + ")";

            var fileNameParts = [];
            fileNameParts.push(this._makePDFTitle(selectedParameters, 'common_report.pdf.header.and'));
            fileNameParts.push(formattedDateRange);

            return _messageResource2.default.getMessage('common_report.pdf.file_name', fileNameParts);
        }
    }, {
        key: "_makePDFTitle",
        value: function _makePDFTitle(selectedParameters, andSubstitutionKey) {
            return OvertimeReportFormatUtils.makePDFTitle(selectedParameters, andSubstitutionKey);
        }
    }, {
        key: "formatChartPDFHeaderTitle",
        value: function formatChartPDFHeaderTitle(selectedParameters) {
            return _messageResource2.default.getMessage('common_report.pdf.header.report', [this._makePDFTitle(selectedParameters)]);
        }
    }, {
        key: "formatChartPDFReportTitle",
        value: function formatChartPDFReportTitle(selectedParameters) {
            var showBy = BaseReportFormatUtils.formatGroupingLevel(selectedParameters.firstGroupingLevel);
            return _messageResource2.default.getMessage('common_report.pdf.header.report_by', [this._makePDFTitle(selectedParameters), showBy]);
        }
    }]);

    return PDFParametersFormattingStrategy;
}();

exports.default = PDFParametersFormattingStrategy;

/***/ }),
/* 1995 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ParametersFormatter2 = __webpack_require__(246);

var _ParametersFormatter3 = _interopRequireDefault(_ParametersFormatter2);

var _ATReportParamsStringBuilder = __webpack_require__(52);

var _ATReportParamsStringBuilder2 = _interopRequireDefault(_ATReportParamsStringBuilder);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OvertimeReportParametersFormatter = function (_ParametersFormatter) {
    _inherits(OvertimeReportParametersFormatter, _ParametersFormatter);

    function OvertimeReportParametersFormatter() {
        _classCallCheck(this, OvertimeReportParametersFormatter);

        return _possibleConstructorReturn(this, (OvertimeReportParametersFormatter.__proto__ || Object.getPrototypeOf(OvertimeReportParametersFormatter)).apply(this, arguments));
    }

    _createClass(OvertimeReportParametersFormatter, [{
        key: "init",
        value: function init(_ref) {
            var selectorsData = _ref.selectorsData,
                dateFormat = _ref.dateFormat;

            this.reportParamsStringBuilder = new _ATReportParamsStringBuilder2.default({
                data: {
                    users: selectorsData.users,
                    userGroups: selectorsData.userGroups,
                    timeZoneGroups: selectorsData.timeZoneGroups,
                    manageableUserIds: selectorsData.manageableUserIds,
                    projectsWithMaIds: selectorsData.projectsWithMaIds
                },
                dateFormat: dateFormat,
                reportAuthorizationInfo: ATReportsStore.getReportAuthorizationInfo()
            });
            return this;
        }
    }]);

    return OvertimeReportParametersFormatter;
}(_ParametersFormatter3.default);

exports.default = OvertimeReportParametersFormatter;

/***/ }),
/* 1996 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _BaseTableDataConverter = __webpack_require__(409);

var _BaseTableDataConverter2 = _interopRequireDefault(_BaseTableDataConverter);

var _ColumnsConfig = __webpack_require__(130);

var _RowType = __webpack_require__(267);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TableDataConverter = function (_BaseTableDataConvert) {
    _inherits(TableDataConverter, _BaseTableDataConvert);

    function TableDataConverter(reportData, reportParams) {
        _classCallCheck(this, TableDataConverter);

        var _this = _possibleConstructorReturn(this, (TableDataConverter.__proto__ || Object.getPrototypeOf(TableDataConverter)).call(this, reportData, reportParams));

        _this.hasTimeBalance = _this.reportParams.columnsConfig !== _ColumnsConfig.ColumnsConfig.OVERTIME_ONLY;
        _this.hasOvertime = _this.reportParams.columnsConfig !== _ColumnsConfig.ColumnsConfig.TIME_BALANCE_ONLY;
        return _this;
    }

    _createClass(TableDataConverter, [{
        key: "_createHeader",
        value: function _createHeader() {
            return {
                type: _RowType.RowType.HEADER,
                hasTimeBalance: this.hasTimeBalance,
                hasOvertime: this.hasOvertime
            };
        }
    }, {
        key: "_createDataRow",
        value: function _createDataRow(level, type, groupingType, item) {
            var workingTime = item["workingTime"];
            var leaveTime = item["leaveTime"];
            var scheduledTime = item["scheduled"];
            var reportedTime = null;
            var differenceTime = null;
            if (!_.isNull(workingTime) || !_.isNull(leaveTime)) {
                reportedTime = workingTime + leaveTime;
                differenceTime = reportedTime - scheduledTime;
            }

            return {
                type: type,
                id: item["id"],
                scheduledTime: scheduledTime,
                reportedTime: reportedTime,
                workingTime: workingTime,
                leaveTime: leaveTime,
                differenceTime: differenceTime,
                reportedOvertime: item["reportedOvertime"],
                autoOvertime: item["autoCalculatedOvertime"],
                hasTimeBalance: this.hasTimeBalance,
                hasOvertime: this.hasOvertime,
                isEmployed: item["employed"]
            };
        }
    }]);

    return TableDataConverter;
}(_BaseTableDataConverter2.default);

exports.default = TableDataConverter;

/***/ }),
/* 1997 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _PDFPreviewLightboxController = __webpack_require__(973);

var _PDFPreviewLightboxController2 = _interopRequireDefault(_PDFPreviewLightboxController);

var _ParametersFormattingStrategy = __webpack_require__(1998);

var _ParametersFormattingStrategy2 = _interopRequireDefault(_ParametersFormattingStrategy);

var _PDFSettingsPreview = __webpack_require__(1999);

var _PDFSettingsPreview2 = _interopRequireDefault(_PDFSettingsPreview);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PDFPreviewLightboxController = function PDFPreviewLightboxController() {};

PDFPreviewLightboxController.prototype = _underscore2.default.create(_PDFPreviewLightboxController2.default.prototype, {

    _initPdfSettingsPreview: function _initPdfSettingsPreview(elementsIdPrefix) {
        this.pdfSettingsPreview = new _PDFSettingsPreview2.default((0, _jquery2.default)(this.lightBoxEl).find(".pdfPreviewContainer"), elementsIdPrefix, this.eventNamespace).init();
    },

    createFormattingStrategy: function createFormattingStrategy() {
        return new _ParametersFormattingStrategy2.default().init(this._getSelectorsData(), this.dateFormat, this.productSettingsValidator, this.reportRightsValidator);
    },

    getStore: function getStore() {
        return EVAReport.Store;
    },

    _getSelectedParameters: function _getSelectedParameters() {
        var reportParams = this.getStore().getReportParams();
        return {
            tasksConfig: reportParams.tasksConfig,
            firstGroupingLevel: reportParams.firstGroupingLevel,
            secondGroupingLevel: reportParams.secondGroupingLevel,
            thirdGroupingLevel: reportParams.thirdGroupingLevel,
            fourthGroupingLevel: reportParams.fourthGroupingLevel,
            dateParameters: {
                dateSelection: reportParams.dateSelection
            },
            customersProjectsSelection: reportParams.customersProjectsSelection,
            includeNotEstimated: reportParams.includeNotEstimated,
            includeNotStarted: reportParams.includeNotStarted
        };
    },

    _getSelectorsData: function _getSelectorsData() {
        var store = this.getGeneralStore();
        return {
            cpList: store.getCPList(),
            projectsWithMaIds: store.getProjectsWithMaIds()
        };
    }
});

exports.default = PDFPreviewLightboxController;

/***/ }),
/* 1998 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _BaseParametersFormattingStrategy = __webpack_require__(248);

var _BaseParametersFormattingStrategy2 = _interopRequireDefault(_BaseParametersFormattingStrategy);

var _ParametersFormatter = __webpack_require__(592);

var _ParametersFormatter2 = _interopRequireDefault(_ParametersFormatter);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _SingleDateFormattingStrategy = __webpack_require__(517);

var _SingleDateFormattingStrategy2 = _interopRequireDefault(_SingleDateFormattingStrategy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ParametersFormattingStrategy = function ParametersFormattingStrategy() {};

ParametersFormattingStrategy.prototype = _.create(_BaseParametersFormattingStrategy2.default.prototype, {

    init: function init(selectorsData, dateFormat, productSettingsValidator, reportRightsValidator) {
        _BaseParametersFormattingStrategy2.default.prototype.init.call(this, { selectorsData: selectorsData, dateFormat: dateFormat });
        this.productSettingsValidator = productSettingsValidator;
        this.reportRightsValidator = reportRightsValidator;
        this.assignedInfo = selectorsData.assignedInfo;

        return this;
    },

    createParametersFormatter: function createParametersFormatter(_ref) {
        var selectorsData = _ref.selectorsData,
            dateFormat = _ref.dateFormat;

        return new _ParametersFormatter2.default().init({ selectorsData: selectorsData, dateFormat: dateFormat });
    },

    createDateParametersFormattingStrategy: function createDateParametersFormattingStrategy(config) {
        return new _SingleDateFormattingStrategy2.default(config.dateFormat);
    },

    formatMainPartOfLightboxTitle: function formatMainPartOfLightboxTitle(selectedParameters) {
        var showBy = BaseReportFormatUtils.formatGroupingLevel(selectedParameters.firstGroupingLevel);
        var dateParameters = this.dateParametersFormattingStrategy.formatForDateInformation(selectedParameters.dateParameters);
        return _messageResource2.default.getMessage("estimate_vs_actual_report.title", [showBy, dateParameters]);
    },

    formatParametersText: function formatParametersText(selectedParameters) {
        return this.parametersFormatter.formatCustomersAndProjectsSelection(selectedParameters.customersProjectsSelection) + "; " + this.parametersFormatter.formatTaskSelectionParamsString(selectedParameters.tasksConfig, selectedParameters.includeNotEstimated, selectedParameters.includeNotStarted, { dateSelection: selectedParameters.dateParameters.dateSelection, isParsed: true });
    }
});

exports.default = ParametersFormattingStrategy;

/***/ }),
/* 1999 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _BaseReportPDFSettingsPreview = __webpack_require__(586);

var _BaseReportPDFSettingsPreview2 = _interopRequireDefault(_BaseReportPDFSettingsPreview);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PDFSettingsPreview = function (_BaseReportPDFSetting) {
    _inherits(PDFSettingsPreview, _BaseReportPDFSetting);

    function PDFSettingsPreview($containerEl, lightboxId, eventNamespace) {
        _classCallCheck(this, PDFSettingsPreview);

        var _this = _possibleConstructorReturn(this, (PDFSettingsPreview.__proto__ || Object.getPrototypeOf(PDFSettingsPreview)).call(this, $containerEl, lightboxId));

        _this.eventNamespace = eventNamespace;
        return _this;
    }

    _createClass(PDFSettingsPreview, [{
        key: "getStore",
        value: function getStore() {
            return EVAReport.Store;
        }
    }]);

    return PDFSettingsPreview;
}(_BaseReportPDFSettingsPreview2.default);

exports.default = PDFSettingsPreview;

/***/ }),
/* 2000 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _BasePDFDefinitionCreator = __webpack_require__(587);

var _BasePDFDefinitionCreator2 = _interopRequireDefault(_BasePDFDefinitionCreator);

var _DataTableCreateDefinitionHelper = __webpack_require__(589);

var _DataTableCreateDefinitionHelper2 = _interopRequireDefault(_DataTableCreateDefinitionHelper);

var _PDFImageCache = __webpack_require__(122);

var _PDFImageCache2 = _interopRequireDefault(_PDFImageCache);

var _atBrowserUtils = __webpack_require__(8);

var _PDFDefinitionBuilder = __webpack_require__(2001);

var _PDFDefinitionBuilder2 = _interopRequireDefault(_PDFDefinitionBuilder);

var _constants = __webpack_require__(100);

var _PDFDefinitionColumnBuilder = __webpack_require__(2002);

var PDFDefinitionColumnBuilder = _interopRequireWildcard(_PDFDefinitionColumnBuilder);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PDFDefinitionCreator = function (_BasePDFDefinitionCre) {
    _inherits(PDFDefinitionCreator, _BasePDFDefinitionCre);

    function PDFDefinitionCreator() {
        _classCallCheck(this, PDFDefinitionCreator);

        return _possibleConstructorReturn(this, (PDFDefinitionCreator.__proto__ || Object.getPrototypeOf(PDFDefinitionCreator)).apply(this, arguments));
    }

    _createClass(PDFDefinitionCreator, [{
        key: "createDocDefinition",
        value: function createDocDefinition(pdfConfig, parameterFormatter, store) {
            this.parameterFormatter = parameterFormatter;
            this.pdfPrintParams = pdfConfig.pdfPrintParameters;
            this.pdfData = pdfConfig.pdfData;
            this.pdfConfig = pdfConfig;
            this.reportParams = pdfConfig.reportParams;
            this.dateFormat = this.pdfConfig.dateFormat;

            var rowSpanNumber = this.reportParams.includeNotEstimated ? 3 : 2;

            var columns = [];
            columns.push(new PDFDefinitionColumnBuilder.Levels().init(this.reportParams, store, rowSpanNumber));

            if (this.reportParams.includeNotEstimated) {
                columns.push(new PDFDefinitionColumnBuilder.TotalSpentTime().init(this.reportParams, rowSpanNumber));
                columns.push(new PDFDefinitionColumnBuilder.SpentTimeForNotEstimated().init(this.reportParams, rowSpanNumber));
                columns.push(new PDFDefinitionColumnBuilder.EstimatedTasksBlock().init(this.reportParams, store, rowSpanNumber));
            } else {
                columns.push(new PDFDefinitionColumnBuilder.SpentTimeForEstimated().init(this.reportParams, rowSpanNumber));
                columns.push(new PDFDefinitionColumnBuilder.EstimatedTime().init(this.reportParams, rowSpanNumber));
                columns.push(new PDFDefinitionColumnBuilder.VarianceTime().init(this.reportParams, rowSpanNumber));
            }

            var ddb = new _PDFDefinitionBuilder2.default();
            ddb.init(this.pdfPrintParams.paperOrientation, this.pdfPrintParams.paperSize, columns, rowSpanNumber);

            // start create doc definition
            return _PDFImageCache2.default.preloadImages(this._imagesMap(pdfConfig)) // preload needed images
            .then(_underscore2.default.bind(this._processCreateDocDefinition, this, ddb) // construct doc definition
            ).then(function () {
                // return object for generate pdf
                return {
                    "docDefinition": ddb.getDocDefinitionObject(),
                    "tableLayouts": ddb.getTableLayouts()
                };
            });
        }
    }, {
        key: "_imagesMap",
        value: function _imagesMap() {
            return {
                "logo": {
                    "url": _constants.REPORT_LOGO_PATH
                },
                "filterIcon": {
                    "url": (0, _atBrowserUtils.atImgPath)('filter-for-pdf.png'),
                    "saveAlpha": true
                }
            };
        }
    }, {
        key: "_processCreateDocDefinition",
        value: function _processCreateDocDefinition(ddb) {
            ddb.initDocDefinitionObject(this.pdfPrintParams.showSignatureOnEachPage && this.pdfPrintParams.showSignature, this.pdfPrintParams.showHeaderOnEachPage);

            var headerData = this._createHeaderData();
            if (this.pdfPrintParams.paperOrientation == _constants.PaperOrientation.PORTRAIT) {
                ddb.addPortraitHeader(this.pdfPrintParams.showHeaderOnEachPage, this.pdfPrintParams.showLogoInHeader, headerData);
            } else {
                ddb.addLandscapeHeader(this.pdfPrintParams.showHeaderOnEachPage, this.pdfPrintParams.showLogoInHeader, headerData);
            }

            this._addTableData(ddb);
        }
    }, {
        key: "_createHeaderData",
        value: function _createHeaderData() {
            var selectedParameters = this.pdfConfig.reportParams;
            var assignedInfo = this.pdfConfig.assignedInfo;

            return {
                informationTexts: {
                    title: this.parameterFormatter.formatChartPDFReportTitle(selectedParameters),
                    dateRange: this.parameterFormatter.formatChartPDFHeaderDateInformation(selectedParameters)
                },
                filterTexts: this.parameterFormatter.formatChartPDFFilterInformation(selectedParameters, assignedInfo),
                logo: _PDFImageCache2.default.getImage('logo')
            };
        }
    }, {
        key: "_addTableData",
        value: function _addTableData(ddb) {
            new _DataTableCreateDefinitionHelper2.default(ddb, this.pdfData.tableData, {
                dateFormat: this.dateFormat
            }).createTable();
        }
    }]);

    return PDFDefinitionCreator;
}(_BasePDFDefinitionCreator2.default);

exports.default = PDFDefinitionCreator;

/***/ }),
/* 2001 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _BaseReportPDFDefinitionBuilder = __webpack_require__(588);

var _BaseReportPDFDefinitionBuilder2 = _interopRequireDefault(_BaseReportPDFDefinitionBuilder);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PDFDefinitionBuilder = function (_BaseReportPDFDefinit) {
    _inherits(PDFDefinitionBuilder, _BaseReportPDFDefinit);

    function PDFDefinitionBuilder() {
        _classCallCheck(this, PDFDefinitionBuilder);

        return _possibleConstructorReturn(this, (PDFDefinitionBuilder.__proto__ || Object.getPrototypeOf(PDFDefinitionBuilder)).apply(this, arguments));
    }

    _createClass(PDFDefinitionBuilder, [{
        key: "getAdditionalStyles",
        value: function getAdditionalStyles() {
            return styles;
        }
    }, {
        key: "getAdditionalParameters",
        value: function getAdditionalParameters() {
            return parameters;
        }
    }]);

    return PDFDefinitionBuilder;
}(_BaseReportPDFDefinitionBuilder2.default);

exports.default = PDFDefinitionBuilder;


var styles = Object.assign({}, _BaseReportPDFDefinitionBuilder.styles, {
    notEstimated: {
        fontSize: 7,
        color: '#808080',
        alignment: 'center'
    }
});

var parameters = Object.assign({}, _BaseReportPDFDefinitionBuilder.tableLayouts, {
    dataTableStyles: {
        tableStyle: 'reportRow'
    },

    Portrait: {
        columnWidth: {
            levels: 40,
            levelsWide: 60,
            totals: 10,
            estimatedTime: 10,
            variance: 10
        },
        A4: {
            limitOfLinesInTextCell: 62
        },
        Letter: {
            limitOfLinesInTextCell: 56
        }
    },
    Landscape: {
        columnWidth: {
            levels: 40,
            levelsWide: 60,
            totals: 10,
            estimatedTime: 10,
            variance: 10
        },
        A4: {
            limitOfLinesInTextCell: 40
        },
        Letter: {
            limitOfLinesInTextCell: 42
        }
    }
});

/***/ }),
/* 2002 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.EstimatedTasksBlock = exports.VarianceTime = exports.SpentTimeForEstimated = exports.EstimatedTime = exports.SpentTimeForNotEstimated = exports.TotalSpentTime = exports.Levels = exports.Totals = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _constants = __webpack_require__(11);

var _BasePDFDefinitionColumnBuilder = __webpack_require__(410);

var BaseColumnBuilder = _interopRequireWildcard(_BasePDFDefinitionColumnBuilder);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PDFDefinitionColumnBuilder = function (_BasePDFDefinitionCol) {
    _inherits(PDFDefinitionColumnBuilder, _BasePDFDefinitionCol);

    function PDFDefinitionColumnBuilder() {
        _classCallCheck(this, PDFDefinitionColumnBuilder);

        return _possibleConstructorReturn(this, (PDFDefinitionColumnBuilder.__proto__ || Object.getPrototypeOf(PDFDefinitionColumnBuilder)).apply(this, arguments));
    }

    _createClass(PDFDefinitionColumnBuilder, [{
        key: "init",
        value: function init(config, rowSpanNumber) {
            _get(PDFDefinitionColumnBuilder.prototype.__proto__ || Object.getPrototypeOf(PDFDefinitionColumnBuilder.prototype), "init", this).call(this, config, rowSpanNumber);

            if (config.fourthGroupingLevel == _constants.ReportGroupingLevel.USER) this.valueMask[3] = function (column) {
                return column.isUserMasked ? { msg: "" } : false;
            };

            return this;
        }
    }]);

    return PDFDefinitionColumnBuilder;
}(BaseColumnBuilder.default);

var Totals = exports.Totals = function (_BaseColumnBuilder$To) {
    _inherits(Totals, _BaseColumnBuilder$To);

    function Totals() {
        _classCallCheck(this, Totals);

        return _possibleConstructorReturn(this, (Totals.__proto__ || Object.getPrototypeOf(Totals)).apply(this, arguments));
    }

    _createClass(Totals, [{
        key: "init",
        value: function init(config, rowSpanNumber) {
            _get(Totals.prototype.__proto__ || Object.getPrototypeOf(Totals.prototype), "init", this).call(this, config, rowSpanNumber);

            if (config.fourthGroupingLevel == _constants.ReportGroupingLevel.USER) this.valueMask[3] = function (column) {
                return !_underscore2.default.isUndefined(column.isUserMasked) && column.isUserMasked ? { msg: "" } : false;
            };

            return this;
        }
    }]);

    return Totals;
}(BaseColumnBuilder.Totals);

var Levels = exports.Levels = function (_BaseColumnBuilder$Le) {
    _inherits(Levels, _BaseColumnBuilder$Le);

    function Levels() {
        _classCallCheck(this, Levels);

        return _possibleConstructorReturn(this, (Levels.__proto__ || Object.getPrototypeOf(Levels)).apply(this, arguments));
    }

    _createClass(Levels, [{
        key: "init",
        value: function init(config, store, rowSpanNumber) {
            _get(Levels.prototype.__proto__ || Object.getPrototypeOf(Levels.prototype), "init", this).call(this, config, rowSpanNumber);

            this.store = store;
            this.groupingLevels = [config.firstGroupingLevel, config.secondGroupingLevel, config.thirdGroupingLevel, config.fourthGroupingLevel];
            this.reportGroupingStyles = ["reportFirstGroupingRow", "reportSecondGroupingRow", "reportThirdGroupingRow", "reportFourthGroupingRow"];
            this.reportGroupingMargins = ["reportFirstGroupingRowMargin", "reportSecondGroupingRowMargin", "reportThirdGroupingRowMargin", "reportFourthGroupingRowMargin"];

            this.isWide = !config.includeNotEstimated;
            this.maxUserNameLen = 14;

            return this;
        }
    }, {
        key: "_makeCustomRow",
        value: function _makeCustomRow(style, groupingLevel, identity) {
            var text = this._getTitle(groupingLevel, identity, this.maxUserNameLen);
            return this._makeRowDefinition(style, text);
        }
    }, {
        key: "pushWidth",
        value: function pushWidth(destination, sizes) {
            var baseWidth = this.isWide ? sizes["levelsWide"] : sizes["levels"];
            destination.push(baseWidth + '%');
        }
    }, {
        key: "makeHeader",
        value: function makeHeader() {
            var names = [];
            for (var i = 0; i < 4; i++) {
                if (this.groupingLevels[i] != _constants.ReportGroupingLevel.NONE) {
                    names.push(this.formatUtil.formatGroupingLevel(this.groupingLevels[i]));
                }
            }
            return this._makeHeaderDefinition(names.join(' / '), [this.tableHeaderStyleNoMargin, "reportLevelsTitle"]);
        }
    }, {
        key: "makeTotals",
        value: function makeTotals() {
            return this._makeRowDefinition("reportTotal", _messageResource2.default.getMessage("report.total"));
        }
    }, {
        key: "makeRow",
        value: function makeRow(lvl, data) {
            return this._makeCustomRow([this.reportGroupingStyles[lvl], this.reportGroupingMargins[data.level]], this.groupingLevels[lvl], data.id);
        }
    }]);

    return Levels;
}(BaseColumnBuilder.Levels);

var TotalSpentTime = exports.TotalSpentTime = function (_Totals) {
    _inherits(TotalSpentTime, _Totals);

    function TotalSpentTime() {
        _classCallCheck(this, TotalSpentTime);

        return _possibleConstructorReturn(this, (TotalSpentTime.__proto__ || Object.getPrototypeOf(TotalSpentTime)).apply(this, arguments));
    }

    _createClass(TotalSpentTime, [{
        key: "_getValue",
        value: function _getValue(data) {
            return data.totalSpentTime;
        }
    }, {
        key: "makeHeader",
        value: function makeHeader() {
            return this._makeHeaderDefinition(_messageResource2.default.getMessage("report.budgeted_vs_actual.spent_time.total"), this.reportTitleBigMargin);
        }
    }]);

    return TotalSpentTime;
}(Totals);

var SpentTimeForNotEstimated = exports.SpentTimeForNotEstimated = function (_Totals2) {
    _inherits(SpentTimeForNotEstimated, _Totals2);

    function SpentTimeForNotEstimated() {
        _classCallCheck(this, SpentTimeForNotEstimated);

        return _possibleConstructorReturn(this, (SpentTimeForNotEstimated.__proto__ || Object.getPrototypeOf(SpentTimeForNotEstimated)).apply(this, arguments));
    }

    _createClass(SpentTimeForNotEstimated, [{
        key: "_getValue",
        value: function _getValue(data) {
            return data.spentTimeForNotEstimated;
        }
    }, {
        key: "makeHeader",
        value: function makeHeader() {
            return this._makeHeaderDefinition(_messageResource2.default.getMessage("report.budgeted_vs_actual.spent_time.nonbudgeted"), this.reportTitleSmallMargin);
        }
    }]);

    return SpentTimeForNotEstimated;
}(Totals);

var EstimatedTime = exports.EstimatedTime = function (_Totals3) {
    _inherits(EstimatedTime, _Totals3);

    function EstimatedTime() {
        _classCallCheck(this, EstimatedTime);

        var _this6 = _possibleConstructorReturn(this, (EstimatedTime.__proto__ || Object.getPrototypeOf(EstimatedTime)).call(this));

        _this6.isUserMasked = true;
        return _this6;
    }

    _createClass(EstimatedTime, [{
        key: "_getValue",
        value: function _getValue(data) {
            return data.estimatedTime;
        }
    }, {
        key: "makeHeader",
        value: function makeHeader() {
            return this._makeHeaderDefinition(_messageResource2.default.getMessage("report.budgeted_vs_actual.budgeted"), this.reportTitleNormalMargin);
        }
    }]);

    return EstimatedTime;
}(Totals);

var SpentTimeForEstimated = exports.SpentTimeForEstimated = function (_Totals4) {
    _inherits(SpentTimeForEstimated, _Totals4);

    function SpentTimeForEstimated() {
        _classCallCheck(this, SpentTimeForEstimated);

        return _possibleConstructorReturn(this, (SpentTimeForEstimated.__proto__ || Object.getPrototypeOf(SpentTimeForEstimated)).apply(this, arguments));
    }

    _createClass(SpentTimeForEstimated, [{
        key: "_getValue",
        value: function _getValue(data) {
            return data.spentTimeForEstimated;
        }
    }, {
        key: "makeHeader",
        value: function makeHeader() {
            return this._makeHeaderDefinition(_messageResource2.default.getMessage("report.budgeted_vs_actual.spent_time"), this.reportTitleNormalMargin);
        }
    }]);

    return SpentTimeForEstimated;
}(Totals);

var VarianceTime = exports.VarianceTime = function (_PDFDefinitionColumnB) {
    _inherits(VarianceTime, _PDFDefinitionColumnB);

    function VarianceTime() {
        _classCallCheck(this, VarianceTime);

        var _this8 = _possibleConstructorReturn(this, (VarianceTime.__proto__ || Object.getPrototypeOf(VarianceTime)).call(this));

        _this8.isUserMasked = true;
        return _this8;
    }

    _createClass(VarianceTime, [{
        key: "pushWidth",
        value: function pushWidth(destination, sizes) {
            destination.push(sizes["variance"] + '%');
            destination.push(sizes["variance"] + '%');
        }
    }, {
        key: "makeHeader",
        value: function makeHeader() {
            var varianceTxt = [{ text: _messageResource2.default.getMessage("report.budgeted_vs_actual.variance") }, { text: "\n(" + _messageResource2.default.getMessage("report.budgeted_vs_actual.budgeted_minus_spent") + ")", style: this.tinyText }];

            return [{
                style: this.tableHeaderStyle,
                text: varianceTxt,
                colSpan: 2
            }, {}];
        }
    }, {
        key: "makeSubHeader",
        value: function makeSubHeader() {
            return [{
                style: this.tableHeaderStyle,
                text: _messageResource2.default.getMessage("report.budgeted_vs_actual.variance.mh")
            }, {
                style: this.tableHeaderStyle,
                text: _messageResource2.default.getMessage("report.budgeted_vs_actual.variance.percent")
            }];
        }
    }, {
        key: "_makeRow",
        value: function _makeRow(style, data, valueMask) {
            var invalidPercentage = !_underscore2.default.isUndefined(data.estimatedTime) && data.estimatedTime < 0.0001;
            return [this.makeTimeCell(data.varianceTime, style, valueMask(this, data)), this.makePercentCell(invalidPercentage ? null : data.varianceTimeInPercentage, style, valueMask(this, data))];
        }
    }]);

    return VarianceTime;
}(PDFDefinitionColumnBuilder);

var EstimatedTasksBlock = exports.EstimatedTasksBlock = function (_PDFDefinitionColumnB2) {
    _inherits(EstimatedTasksBlock, _PDFDefinitionColumnB2);

    function EstimatedTasksBlock() {
        _classCallCheck(this, EstimatedTasksBlock);

        var _this9 = _possibleConstructorReturn(this, (EstimatedTasksBlock.__proto__ || Object.getPrototypeOf(EstimatedTasksBlock)).call(this));

        _this9.cellMasks = [{ isUserMasked: false }, { isUserMasked: true, maskedTaskValue: { msg: _messageResource2.default.getMessage("report.budgeted_vs_actual.not_budgeted"), style: "notEstimated" } }, { isUserMasked: true }, { isUserMasked: true, maskedTaskValue: { msg: "-" } }];
        return _this9;
    }

    _createClass(EstimatedTasksBlock, [{
        key: "init",
        value: function init(config, store, rowSpanNumber) {
            _get(EstimatedTasksBlock.prototype.__proto__ || Object.getPrototypeOf(EstimatedTasksBlock.prototype), "init", this).call(this, config, rowSpanNumber);

            var lvls = [config.firstGroupingLevel, config.secondGroupingLevel, config.thirdGroupingLevel, config.fourthGroupingLevel];
            for (var i = 0; i < 4; i++) {
                if (lvls[i] == _constants.ReportGroupingLevel.TASK) this.valueMask[i] = function (column, data) {
                    return !_underscore2.default.isUndefined(column.maskedTaskValue) && !store.getTask(data.id).estimated ? column.maskedTaskValue : false;
                };
            }

            return this;
        }
    }, {
        key: "pushWidth",
        value: function pushWidth(destination, sizes) {
            destination.push(sizes["estimatedTime"] + '%');
            destination.push(sizes["estimatedTime"] + '%');
            destination.push(sizes["variance"] + '%');
            destination.push(sizes["variance"] + '%');
        }
    }, {
        key: "makeHeader",
        value: function makeHeader() {
            return [{
                style: this.tableHeaderStyle,
                text: _messageResource2.default.getMessage("report.budgeted_vs_actual.spent.budgeted_tasks"),
                colSpan: 4
            }, {}, {}, {}];
        }
    }, {
        key: "makeSubHeader",
        value: function makeSubHeader() {
            var varianceTxt = [{ text: _messageResource2.default.getMessage("report.budgeted_vs_actual.variance") }, { text: "(" + _messageResource2.default.getMessage("report.budgeted_vs_actual.budgeted_minus_spent") + ")", style: this.tinyText }];

            return [{
                style: this.tableSubHeaderWithMarginStyle,
                text: _messageResource2.default.getMessage("report.budgeted_vs_actual.spent_time"),
                rowSpan: 2
            }, {
                style: this.tableSubHeaderWithMarginStyle,
                text: _messageResource2.default.getMessage("report.budgeted_vs_actual.budgeted"),
                rowSpan: 2
            }, {
                style: this.tableSubHeaderStyle,
                stack: varianceTxt,
                colSpan: 2
            }, {}];
        }
    }, {
        key: "makeThirdLvlHeader",
        value: function makeThirdLvlHeader() {
            return [{}, {}, {
                style: this.tableThirdLvlHeaderStyle,
                text: _messageResource2.default.getMessage("report.budgeted_vs_actual.variance.mh")
            }, {
                style: this.tableThirdLvlHeaderStyle,
                text: _messageResource2.default.getMessage("report.budgeted_vs_actual.variance.percent")
            }];
        }
    }, {
        key: "_makeRow",
        value: function _makeRow(style, data, valueMask) {
            var invalidPercentage = !_underscore2.default.isUndefined(data.estimatedTime) && data.estimatedTime < 0.0001;
            return [this.makeTimeCell(data.spentTimeForEstimated, style, valueMask(this.cellMasks[0], data)), this.makeTimeCell(data.estimatedTime, style, valueMask(this.cellMasks[1], data)), this.makeTimeCell(data.varianceTime, style, valueMask(this.cellMasks[2], data)), this.makePercentCell(invalidPercentage ? null : data.varianceTimeInPercentage, style, valueMask(this.cellMasks[3], data))];
        }
    }]);

    return EstimatedTasksBlock;
}(PDFDefinitionColumnBuilder);

/***/ }),
/* 2003 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _date_format = __webpack_require__(16);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _ParametersFormatter = __webpack_require__(592);

var _ParametersFormatter2 = _interopRequireDefault(_ParametersFormatter);

var _FormatUtils = __webpack_require__(142);

var _FormatUtils2 = _interopRequireDefault(_FormatUtils);

var _ChartPDFSingleDateFormattingStrategy = __webpack_require__(806);

var _ChartPDFSingleDateFormattingStrategy2 = _interopRequireDefault(_ChartPDFSingleDateFormattingStrategy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PDFParametersFormattingStrategy = function () {
    function PDFParametersFormattingStrategy() {
        _classCallCheck(this, PDFParametersFormattingStrategy);
    }

    _createClass(PDFParametersFormattingStrategy, [{
        key: "init",
        value: function init(config) {
            this.productSettingsValidator = config.productSettingsValidator;
            this.reportRightsValidator = config.reportRightsValidator;
            this.dateParametersFormattingStrategy = this.createDateParametersFormattingStrategy(config.dateFormat, config.dateFormatForFile);

            this.shortDateFormat = new _date_format.DateFormat(window.SystemSettings.dateFormat);
            this.parametersFormatter = new _ParametersFormatter2.default().init({ selectorsData: config, dateFormat: config.dateFormat });
            return this;
        }
    }, {
        key: "createDateParametersFormattingStrategy",
        value: function createDateParametersFormattingStrategy(dateFormat, dateFormatForFile) {
            return new _ChartPDFSingleDateFormattingStrategy2.default(dateFormat, dateFormatForFile);
        }
    }, {
        key: "formatChartPDFFilterInformation",
        value: function formatChartPDFFilterInformation(selectedParameters, assignedInfo) {
            return {
                firstRow: this.formatCPSelection(selectedParameters),
                secondRow: this.formatAdditionalInfo(selectedParameters)
            };
        }
    }, {
        key: "formatCPSelection",
        value: function formatCPSelection(selectedParameters) {
            return this.parametersFormatter.formatCustomersAndProjectsSelection(selectedParameters.customersProjectsSelection);
        }
    }, {
        key: "formatAdditionalInfo",
        value: function formatAdditionalInfo(selectedParameters) {
            return this.parametersFormatter.formatTaskSelectionParamsString(selectedParameters.tasksConfig, selectedParameters.includeNotEstimated, selectedParameters.includeNotStarted, { dateSelection: selectedParameters.dateSelection, isParsed: true });
        }
    }, {
        key: "formatChartPDFHeaderDateInformation",
        value: function formatChartPDFHeaderDateInformation(selectedParameters) {
            return this.dateParametersFormattingStrategy.formatDateInformation(selectedParameters);
        }
    }, {
        key: "formatChartPDFFileName",
        value: function formatChartPDFFileName(selectedParameters) {
            var dateRange = selectedParameters.dateSelection;
            var formattedDateRange = "(" + this.shortDateFormat.formatDate(dateRange.date) + ")";

            var fileNameParts = [];
            fileNameParts.push(_messageResource2.default.getMessage('estimate_vs_actual_report.pdf.title'));
            fileNameParts.push(formattedDateRange);

            return _messageResource2.default.getMessage('common.leave.reports.pdf.file_name', fileNameParts);
        }
    }, {
        key: "_makePDFTitle",
        value: function _makePDFTitle(andSubstitutionKey) {
            return _messageResource2.default.getMessage('estimate_vs_actual_report.pdf.title');
        }
    }, {
        key: "formatChartPDFHeaderTitle",
        value: function formatChartPDFHeaderTitle(selectedParameters) {
            return _messageResource2.default.getMessage('common.leave.reports.pdf.header.report', [this._makePDFTitle()]);
        }
    }, {
        key: "formatChartPDFReportTitle",
        value: function formatChartPDFReportTitle(selectedParameters) {
            var showBy = _FormatUtils2.default.formatGroupingLevel(selectedParameters.firstGroupingLevel);
            return _messageResource2.default.getMessage('common.leave.reports.pdf.header.report_by', [this._makePDFTitle(), showBy]);
        }
    }]);

    return PDFParametersFormattingStrategy;
}();

exports.default = PDFParametersFormattingStrategy;

/***/ }),
/* 2004 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _BaseTableDataConverter = __webpack_require__(409);

var _BaseTableDataConverter2 = _interopRequireDefault(_BaseTableDataConverter);

var _RowType = __webpack_require__(267);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TableDataConverter = function (_BaseTableDataConvert) {
    _inherits(TableDataConverter, _BaseTableDataConvert);

    function TableDataConverter(data, params) {
        _classCallCheck(this, TableDataConverter);

        var _this = _possibleConstructorReturn(this, (TableDataConverter.__proto__ || Object.getPrototypeOf(TableDataConverter)).call(this, data, params));

        _this.groupingLevels = [params.firstGroupingLevel, params.secondGroupingLevel, params.thirdGroupingLevel, params.fourthGroupingLevel];
        return _this;
    }

    _createClass(TableDataConverter, [{
        key: "_createHeader",
        value: function _createHeader() {
            return {
                type: _RowType.RowType.HEADER
            };
        }
    }, {
        key: "_createDataRow",
        value: function _createDataRow(level, type, groupingType, item) {
            var dataRow = _.pick(item, 'id', 'totalSpentTime', 'estimatedTime', 'spentTimeForEstimated', 'spentTimeForNotEstimated', 'varianceTime', 'varianceTimeInPercentage');
            dataRow.level = level;
            dataRow.type = type;
            dataRow.groupingType = groupingType;
            return dataRow;
        }
    }, {
        key: "getGroupingLevels",
        value: function getGroupingLevels(params) {
            var array = [];
            array.push(params.firstGroupingLevel);
            array.push(params.secondGroupingLevel);
            array.push(params.thirdGroupingLevel);
            array.push(params.fourthGroupingLevel);
            return array;
        }
    }, {
        key: "getGroupingLevelsCollapsed",
        value: function getGroupingLevelsCollapsed(groupingLevels) {
            return EVAReport.ConvertUtils.getGroupingLevelsCollapsed(groupingLevels);
        }
    }]);

    return TableDataConverter;
}(_BaseTableDataConverter2.default);

exports.default = TableDataConverter;

/***/ }),
/* 2005 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ReportConfigs;

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _pluralizeUtils = __webpack_require__(40);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _atUtils = __webpack_require__(5);

var _ATReportParamsStringBuilder = __webpack_require__(52);

var _ATReportParamsStringBuilder2 = _interopRequireDefault(_ATReportParamsStringBuilder);

var _constants = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ReportConfigs() {}

ReportConfigs.prototype.init = function (reports, users, userGroups, timeZoneGroups, cpList, customersWithMaIds, projectsWithMaIds, leaveTypesMap, manageableUserIds) {
    this.reports = reports;
    this.users = users;
    this.userGroups = userGroups;
    this.timeZoneGroups = timeZoneGroups;
    this.cpList = cpList;
    this.customersWithMaIds = customersWithMaIds;
    this.projectsWithMaIds = projectsWithMaIds;
    this.leaveTypesMap = leaveTypesMap;
    this.manageableUserIds = manageableUserIds;

    this.reportParamsStringBuilder = new _ATReportParamsStringBuilder2.default({
        data: {
            users: this.users,
            timeZoneGroups: this.timeZoneGroups,
            userGroups: this.userGroups,
            cpList: this.cpList,
            leaveTypesMap: this.leaveTypesMap,
            manageableUserIds: this.manageableUserIds,
            customersWithMaIds: customersWithMaIds,
            projectsWithMaIds: projectsWithMaIds
        },
        dataFormat: SystemSettings.dateFormat.replace(/MMMM/, 'MMM')
    });

    var titleStrings = this.buildTitlesStrings();
    var paramStrings = this.buildParamsStringsForReportConfigs();
    var dateRangeStrings = this.buildDateParamStringsForReportConfigs();

    for (var reportId in paramStrings) {
        if (paramStrings.hasOwnProperty(reportId)) {
            (0, _jquery2.default)("#" + reportId + " .type-title").html(titleStrings[reportId]);
            (0, _jquery2.default)("#" + reportId + " .otherParams").html(paramStrings[reportId]);
            (0, _jquery2.default)("#" + reportId + " .date-filter").html(dateRangeStrings[reportId]);
        }
    }
};

ReportConfigs.prototype.buildTitlesStrings = function () {
    var self = this;
    var reportTitlesStrings = [];
    var nodeIdBase = "reportConfig_";
    for (var i = 0; i < self.reports.length; i++) {
        reportTitlesStrings[nodeIdBase + self.reports[i].id] = self.getTitleString(self.reports[i]);
    }
    return reportTitlesStrings;
};

ReportConfigs.prototype.getTitleString = function (reportConfig) {
    var title = _messageResource2.default.getMessage(ReportChartNames[reportConfig.type]);
    if (reportConfig.isChart) {
        var self = this;
        title += " " + _messageResource2.default.getMessage("saved_reports.charts_title.part2", [_messageResource2.default.getEscapedMessage(this.getByTextForCharts(self.getParameters(reportConfig)))]);
    }
    return title;
};

ReportConfigs.prototype.getByTextForCharts = function (chartParams) {
    switch (chartParams.groupingLevel) {
        case ReportGroupingLevel.USER:
            return "report.common.users";
        case ReportGroupingLevel.USER_GROUP:
            return "common.User_Groups";
        case ReportGroupingLevel.TIME_ZONE_GROUP:
            return "common.Time_Zone_Groups";
        case ReportGroupingLevel.CUSTOMER:
            return "common.Customers";
        case ReportGroupingLevel.PROJECT:
            return "common.Projects";
        case ReportGroupingLevel.BILLING_TYPE:
            return "report.common.billing_types";
        case ReportGroupingLevel.DATE:
            return "report.common.dates";
        case ReportGroupingLevel.WEEK:
            return "report.common.weeks";
        case ReportGroupingLevel.MONTH:
            return "report.common.months";
        case ReportGroupingLevel.LEAVE_TYPE:
            return "report.common.leave_types";
    };
};

ReportConfigs.prototype.buildParamsStringsForReportConfigs = function () {
    var self = this;
    var nodeIdBase = "reportConfig_";
    var reportParamsStrings = [];
    for (var i = 0; i < self.reports.length; i++) {
        reportParamsStrings[nodeIdBase + self.reports[i].id] = self.getParamsString(self.reports[i]);
    }
    return reportParamsStrings;
};

ReportConfigs.prototype.buildDateParamStringsForReportConfigs = function () {
    var self = this;
    var nodeIdBase = "reportConfig_";
    var reportDateRangeStrings = [];
    for (var i = 0; i < self.reports.length; i++) {
        if (self.reports[i].type != "ESTIMATED_VS_ACTUAL" && self.reports[i].type != "PTO_BALANCE" && self.reports[i].type != "SICK_DAYS_BALANCE") reportDateRangeStrings[nodeIdBase + self.reports[i].id] = self.formatHTML(self.reportParamsStringBuilder.getDateRangeParamString(self.getParameters(self.reports[i]).dateRangeSelection), "dateRange", self.reportParamsStringBuilder.getDateRangeDetailsString(self.getParameters(self.reports[i]).dateRangeSelection));else reportDateRangeStrings[nodeIdBase + self.reports[i].id] = self.formatHTML(self.reportParamsStringBuilder.getEvaDateParamString(self.getParameters(self.reports[i]).dateSelection), "dateRange", self.reportParamsStringBuilder.getEvaDateDetailsString(self.getParameters(self.reports[i]).dateSelection));
    }
    return reportDateRangeStrings;
};

ReportConfigs.prototype.getParameters = function (report) {

    if (report.isChart) {
        return report.params.dataParameters;
    }
    return report.params;
};

ReportConfigs.prototype.getParamsString = function (reportConfig) {
    var DELIMITER = ";";
    var availableUserIds = this.users;
    if (!!reportConfig.reportAuthorizationInfo) {
        availableUserIds = filterArrayByArrayOfIds(this.users, reportConfig.reportAuthorizationInfo.availableUserIds);
    }
    var reportParamsStringBuilderWithAuthInfos = new _ATReportParamsStringBuilder2.default({
        data: {
            users: availableUserIds,
            timeZoneGroups: this.timeZoneGroups,
            userGroups: this.userGroups,
            cpList: this.cpList,
            leaveTypesMap: this.leaveTypes,
            manageableUserIds: this.manageableUserIds,
            projectsWithMaIds: this.projectsWithMaIds
        },
        dataFormat: SystemSettings.dateFormat.replace(/MMMM/, 'MMM'),
        reportAuthorizationInfo: reportConfig.reportAuthorizationInfo,
        userFormatter: reportConfig.isChart ? BaseReportFormatUtils.reportUserFormatterWithoutUsername : BaseReportFormatUtils.reportUserFormatterWithUsernameIfNeeded
    });

    if (reportConfig.type === "STAFF_PERFORMANCE" || reportConfig.type === "TIME_TRACK_IN_DETAIL" || reportConfig.type === "COST_OF_WORK" || reportConfig.type === "TOTAL_WORKING_HOURS" || reportConfig.type === "APPROVED_WORKING_HOURS" || reportConfig.type === "BILLABLE_AMOUNTS") {
        return this.getUserSelectionParamString(this.getParameters(reportConfig).userSelection, reportParamsStringBuilderWithAuthInfos, DELIMITER) + this.getCPSelectionParamString(this.getParameters(reportConfig).customersProjectsSelection);
    }

    if (reportConfig.type === "ESTIMATED_VS_ACTUAL" || reportConfig.type === "PROFIT_LOSS" || reportConfig.type === "INVOICING" || reportConfig.type === "BILLING_SUMMARY") {
        return this.getCPSelectionParamString(this.getParameters(reportConfig).customersProjectsSelection);
    }

    if (reportConfig.type === "OVERTIME" || reportConfig.type === "OVERTIME_HOURS") {
        return this.getUserSelectionParamString(this.getParameters(reportConfig).userSelection, reportParamsStringBuilderWithAuthInfos);
    }

    if (reportConfig.type === "PTO_BALANCE" || reportConfig.type === "SICK_DAYS_BALANCE") {
        return this.getUserSelectionParamString(this.getParameters(reportConfig).userSelection, reportParamsStringBuilderWithAuthInfos);
    }

    if (reportConfig.type === "LEAVE_TIME" || reportConfig.type === "LEAVE_HOURS") {
        return this.getUserSelectionParamString(this.getParameters(reportConfig).userSelection, reportParamsStringBuilderWithAuthInfos, DELIMITER) + this.getLeaveTypeSelectionParamString(this.getParameters(reportConfig).leaveTypeSelection);
    }
};

ReportConfigs.prototype.formatHTML = function (title, className, altTitle) {
    var result = "<span class=\"";
    result += className + "\"";
    if (altTitle) result += " title=\"" + (0, _atUtils.escapeHtmlSymbols)(altTitle) + "\"";
    result += ">" + (0, _atUtils.escapeHtmlSymbols)(title) + "</span>";
    return result.toString();
};

ReportConfigs.prototype.getUserSelectionParamString = function (userSelection, reportParamsStringBuilderWithAuthInfos, delimiter) {
    delimiter = !!delimiter ? delimiter : "";
    return this.formatHTML(reportParamsStringBuilderWithAuthInfos.getUserSelectionParamString(userSelection) + delimiter, reportParamsStringBuilderWithAuthInfos.getUserSelectionClass(userSelection), reportParamsStringBuilderWithAuthInfos.getUserSelectionDetailsString(userSelection));
};

ReportConfigs.prototype.getCPSelectionParamString = function (cpSelection) {
    var _this = this;

    var CLASS_NAME = "cp-selector";
    var CUSTOMERS_CLASS = "customers-filter";
    var PROJECTS_CLASS = "projects-filter";
    var ERROR_CLASS_NAME = "error-cp-selector";
    var AND_DELIMITER = this.formatHTML("&", "delimiter");

    var customerFormatter = {
        format: function format(customer) {
            return customer.name;
        }
    };

    var projectFormatter = {
        format: function format(project) {
            return project.name;
        }
    };

    if (cpSelection.qualifier == _constants.CustomersProjectsSelectionQualifier.ALL) return this.formatHTML(_messageResource2.default.getMessage("saved_reports.cp_selector.all_projects"), CLASS_NAME);

    if (cpSelection.qualifier == _constants.CustomersProjectsSelectionQualifier.ALL_ACTIVE) return this.formatHTML(_messageResource2.default.getMessage("saved_reports.cp_selector.all_active_projects"), CLASS_NAME);else {
        var customers = this.reportParamsStringBuilder.getFilteredCustomers(cpSelection);
        var projects = this.reportParamsStringBuilder.getFilteredProjects(cpSelection);

        if (customers.length == 0 && projects.length == 0) return this.formatHTML(_messageResource2.default.getMessage("saved_reports.cp_selector.emty_selection"), CLASS_NAME + " " + ERROR_CLASS_NAME);

        var message, alt, key, params;

        if (customers.length == 1 && projects.length == 0) {
            key = "saved_reports.cp_selector.single_element.customer";
            params = [customerFormatter.format(customers[0])];

            message = _messageResource2.default.getMessage(key, params);
            alt = _messageResource2.default.getMessage(key, params);

            return this.formatHTML(message, CUSTOMERS_CLASS, alt);
        }

        if (projects.length == 1 && customers.length == 0) {
            key = "saved_reports.cp_selector.single_element.project";
            params = [projectFormatter.format(projects[0])];

            message = _messageResource2.default.getMessage(key, params);
            alt = _messageResource2.default.getMessage(key, params);

            return this.formatHTML(message, PROJECTS_CLASS, alt);
        }

        var getCustomersPart = function getCustomersPart(customers, availableSuffix, activeProjectsSuffix) {
            var title = customers.length.toString() + " " + (0, _pluralizeUtils.customerNameLower)(customers.length) + " " + _messageResource2.default.getMessage("saved_reports.cp_selector.multiple_customer", [availableSuffix, activeProjectsSuffix]);
            var altTitle = _this.reportParamsStringBuilder.getTitle(_messageResource2.default.getMessage("saved_reports.cp_selector.title_header.customers"), customers, customerFormatter);

            return _this.formatHTML(title, CUSTOMERS_CLASS, altTitle);
        };

        var getProjectsPart = function getProjectsPart(projects) {
            var title = projects.length.toString() + " " + (0, _pluralizeUtils.projectNameLower)(projects.length);
            var altTitle = _this.reportParamsStringBuilder.getTitle(_messageResource2.default.getMessage("saved_reports.cp_selector.title_header.projects"), projects, projectFormatter);

            return _this.formatHTML(title, PROJECTS_CLASS, altTitle);
        };

        var customersPart = "",
            projectsPart = "";
        if (customers.length > 0) {
            customersPart = getCustomersPart(customers, "", "");
        }

        if (projects.length > 0) {
            projectsPart = getProjectsPart(projects);
        }
        return customersPart + (customersPart.length > 0 && projectsPart.length > 0 ? AND_DELIMITER : "") + projectsPart;
    }
};

ReportConfigs.prototype.getLeaveTypeSelectionParamString = function (leaveTypeSelection) {
    return this.formatHTML(this.reportParamsStringBuilder.getLeaveTypeSelectionParamString(leaveTypeSelection), this.reportParamsStringBuilder.getLeaveTypeSelectionClass(leaveTypeSelection), this.reportParamsStringBuilder.getLeaveTypeSelectionDetailsString(leaveTypeSelection));
};

/***/ }),
/* 2006 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = OvertimeFormMediator;

var _BaseFormMediator = __webpack_require__(269);

var _BaseFormMediator2 = _interopRequireDefault(_BaseFormMediator);

var _OvertimeEditFormConfigController = __webpack_require__(2007);

var _OvertimeEditFormConfigController2 = _interopRequireDefault(_OvertimeEditFormConfigController);

var _atUtils = __webpack_require__(5);

var _OvertimeReportStore = __webpack_require__(411);

var _OvertimeReportStore2 = _interopRequireDefault(_OvertimeReportStore);

var _OvertimeCSVPreviewGenerator = __webpack_require__(2010);

var _OvertimeCSVPreviewGenerator2 = _interopRequireDefault(_OvertimeCSVPreviewGenerator);

var _OvertimeHTMLPreviewGenerator = __webpack_require__(2013);

var _OvertimeHTMLPreviewGenerator2 = _interopRequireDefault(_OvertimeHTMLPreviewGenerator);

var _ATReportParamsStringBuilder = __webpack_require__(52);

var _ATReportParamsStringBuilder2 = _interopRequireDefault(_ATReportParamsStringBuilder);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function OvertimeFormMediator() {}

OvertimeFormMediator.prototype = new _BaseFormMediator2.default();

OvertimeFormMediator.prototype.init = function (config) {
    _BaseFormMediator2.default.prototype.init.call(this, config);

    ATReportsStore.setVisibleUsers(config.users);
    ATReportsStore.setUserGroups(config.userGroups);
    ATReportsStore.setTimeZoneGroups(config.timeZoneGroups);

    return this;
};

OvertimeFormMediator.prototype.initParamsStringBuilder = function (config) {
    return new _ATReportParamsStringBuilder2.default({
        data: {
            users: config.users,
            userGroups: config.userGroups,
            timeZoneGroups: config.timeZoneGroups,
            manageableUserIds: ATReportsStore.getManageableUserIds(),
            projectsWithMaIds: ATReportsStore.getProjectsWithMaIds()
        },
        reportAuthorizationInfo: ATReportsStore.getReportAuthorizationInfo()
    });
};

OvertimeFormMediator.prototype.initEditConfigController = function (config) {
    var self = this;
    return new _OvertimeEditFormConfigController2.default().init({
        panelId: "mainContainer",
        reportAuthorizationInfo: config.reportAuthorizationInfo,
        reportParameters: config.reportParameters,
        users: config.users,
        manageableUsersIds: config.manageableUserIds,
        userGroups: config.userGroups,
        timeZoneGroups: config.timeZoneGroups,
        changeCallback: function changeCallback() {
            self.changeParametersCallback();
        }
    });
};

OvertimeFormMediator.prototype.initCsvGenerator = function () {
    return new _OvertimeCSVPreviewGenerator2.default().init();
};

OvertimeFormMediator.prototype.initHtmlGenerator = function () {
    return new _OvertimeHTMLPreviewGenerator2.default().init();
};

OvertimeFormMediator.prototype.exportToCSV = function () {
    var reportParams = this.collectReportParameters();

    var successMethod = function successMethod(data) {
        var info = {};
        var groupingLevels = BaseReport.ConvertUtils.getGroupingLevels(reportParams);
        for (var i = 0; i < data["groupingLevelsInfoLists"].length; ++i) {
            var groupingType = BaseReport.ConvertUtils.getGroupingType(i, groupingLevels);
            info[groupingType] = (0, _atUtils.arrayToMap)(data["groupingLevelsInfoLists"][i]);
        }

        _OvertimeReportStore2.default.setReportData(data["rootItem"], info);
        _OvertimeReportStore2.default.setReportParams(reportParams);

        return new OvertimeCSVJsonConverter().init(_OvertimeReportStore2.default, ATReportsStore);
    };

    this._exportToCSV(reportParams, successMethod, "TimeBalanceAndOvertimeReportService.getReport", [this.makeServiceParams(reportParams)]);
};

OvertimeFormMediator.prototype.fillDateSelection = function (reportParametersObject) {
    reportParametersObject.dateRangeSelection = this.dateRangeSelector.getSelectedRange();
};

/***/ }),
/* 2007 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _OvertimeReportEditConfigController = __webpack_require__(979);

var _OvertimeReportEditConfigController2 = _interopRequireDefault(_OvertimeReportEditConfigController);

var _features = __webpack_require__(22);

var _constants = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OvertimeEditFormConfigController = function (_OvertimeReportEditCo) {
    _inherits(OvertimeEditFormConfigController, _OvertimeReportEditCo);

    function OvertimeEditFormConfigController() {
        _classCallCheck(this, OvertimeEditFormConfigController);

        return _possibleConstructorReturn(this, (OvertimeEditFormConfigController.__proto__ || Object.getPrototypeOf(OvertimeEditFormConfigController)).apply(this, arguments));
    }

    return OvertimeEditFormConfigController;
}(_OvertimeReportEditConfigController2.default);

exports.default = OvertimeEditFormConfigController;


OvertimeEditFormConfigController.prototype.makeReportParamsAccordingToFeatures = function (reportParameters) {
    var result = _extends({}, reportParameters);
    var groupings = null;
    if (!(0, _features.isEnabled)(_features.Feature.UGR)) {
        groupings = this.makeGroupingSelectorValuesAccordingToNotAvailableValueLevel(_constants.ReportGroupingLevel.USER_GROUP, [result.firstGroupingLevel, result.secondGroupingLevel], _constants.ReportGroupingLevel.USER);
        result.firstGroupingLevel = groupings[0];
        result.secondGroupingLevel = groupings[1];
    }
    if (!(0, _features.isEnabled)(_features.Feature.TZG)) {
        groupings = this.makeGroupingSelectorValuesAccordingToNotAvailableValueLevel(_constants.ReportGroupingLevel.TIME_ZONE_GROUP, [result.firstGroupingLevel, result.secondGroupingLevel], _constants.ReportGroupingLevel.USER);
        result.firstGroupingLevel = groupings[0];
        result.secondGroupingLevel = groupings[1];
    }
    return result;
};

/***/ }),
/* 2008 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _ColumnsConfig = __webpack_require__(130);

var _ListSelector = __webpack_require__(96);

var _ListSelector2 = _interopRequireDefault(_ListSelector);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OvertimeReportColumnsFormatSelector = function () {
    function OvertimeReportColumnsFormatSelector() {
        _classCallCheck(this, OvertimeReportColumnsFormatSelector);
    }

    _createClass(OvertimeReportColumnsFormatSelector, [{
        key: 'init',
        value: function init(columnsConfig, onConfigChanged) {
            this.columnsConfigSelector = new _ListSelector2.default({
                renderTo: "columnsTypeSelector",
                menuCls: "columnsFormatMenu"
            });

            this.columnsConfigSelector.addItems([{
                text: _messageResource2.default.getEscapedMessage("report.overtime.columns_config.time_balance_and_overtime"),
                value: _ColumnsConfig.ColumnsConfig.TIME_BALANCE_AND_OVERTIME
            }, {
                text: _messageResource2.default.getEscapedMessage("report.overtime.columns_config.time_balance_only"),
                value: _ColumnsConfig.ColumnsConfig.TIME_BALANCE_ONLY
            }, {
                text: _messageResource2.default.getEscapedMessage("report.overtime.columns_config.overtime_only"),
                value: _ColumnsConfig.ColumnsConfig.OVERTIME_ONLY
            }]);

            this.columnsConfigSelector.on("change", onConfigChanged);

            this.columnsConfigSelector.setActiveItemByValue(columnsConfig, true);

            return this.columnsConfigSelector;
        }
    }]);

    return OvertimeReportColumnsFormatSelector;
}();

exports.default = OvertimeReportColumnsFormatSelector;

/***/ }),
/* 2009 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = OvertimeGroupingSelector;

var _GroupingSelector = __webpack_require__(322);

var _GroupingSelector2 = _interopRequireDefault(_GroupingSelector);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _constants = __webpack_require__(11);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function OvertimeGroupingSelector() {
    this.constructor = OvertimeGroupingSelector;
}

OvertimeGroupingSelector.prototype = _underscore2.default.create(_GroupingSelector2.default.prototype, {
    init: function init(selectorId, selectedValues, isUGREnabled, isTZGEnabled, changesCallback) {
        this.UGREnabled = isUGREnabled;
        this.TZGEnabled = isTZGEnabled;

        _GroupingSelector2.default.prototype.init.call(this, selectorId, 2, selectedValues, changesCallback);

        return this;
    },

    fillListSelector: function fillListSelector(listSelector, level) {
        if (level > 0) {
            listSelector.addItems([{
                text: _messageResource2.default.getMessage("report.form.dont_use_2nd_grouping_level"),
                value: _constants.ReportGroupingLevel.NONE
            }]);
            listSelector.addSeparator();
        }

        listSelector.addItems([{
            text: _messageResource2.default.getMessage("report.common.users"),
            value: _constants.ReportGroupingLevel.USER
        }]);

        if (this.UGREnabled) {
            listSelector.addItems([{
                text: _messageResource2.default.getEscapedMessage("common.User_Groups"),
                value: _constants.ReportGroupingLevel.USER_GROUP
            }]);
        }

        if (this.TZGEnabled) {
            listSelector.addItems([{
                text: _messageResource2.default.getEscapedMessage("common.Time_Zone_Groups"),
                value: _constants.ReportGroupingLevel.TIME_ZONE_GROUP
            }]);
        }

        listSelector.addSeparator();

        listSelector.addItems([{ text: _messageResource2.default.getMessage("report.common.dates"), value: _constants.ReportGroupingLevel.DATE }, { text: _messageResource2.default.getMessage("report.common.weeks"), value: _constants.ReportGroupingLevel.WEEK }, { text: _messageResource2.default.getMessage("report.common.months"), value: _constants.ReportGroupingLevel.MONTH }]);
    },

    updateTree: function updateTree() {
        var secondShown = this.getListSelectorValue(1) !== _constants.ReportGroupingLevel.NONE;
        this.setRowClassName(1, secondShown ? "tree-row-A" : "tree-row-I");
    },

    validate: function validate() {
        if (!_GroupingSelector2.default.prototype.validate.call(this)) return false;

        return this.verifyDateGroupingOrderFroTwoLevels();
    }
});

/***/ }),
/* 2010 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = OvertimeCSVPreviewGenerator;

var _ColumnsConfig = __webpack_require__(130);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _OvertimeCSVPreviewHeader = __webpack_require__(2011);

var _OvertimeCSVPreviewHeader2 = _interopRequireDefault(_OvertimeCSVPreviewHeader);

var _CSVParametersBuilder = __webpack_require__(150);

var _CSVParametersBuilder2 = _interopRequireDefault(_CSVParametersBuilder);

var _CSVParametersSection = __webpack_require__(170);

var _CSVParametersSection2 = _interopRequireDefault(_CSVParametersSection);

var _OvertimeCSVPreviewGroupingSection = __webpack_require__(2012);

var _OvertimeCSVPreviewGroupingSection2 = _interopRequireDefault(_OvertimeCSVPreviewGroupingSection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function OvertimeCSVPreviewGenerator() {}

OvertimeCSVPreviewGenerator.prototype.init = function () {
    return this;
};

OvertimeCSVPreviewGenerator.prototype.generatePreviewTable = function (reportParameters, reportParamsStringBuilder) {

    var numOfGroupingColumns = ReportPreviewUtils.countNotEmptyLevels([reportParameters.firstGroupingLevel, reportParameters.secondGroupingLevel]);

    var columnNames = [];

    var numOfDataColumns = 0;
    if (reportParameters.columnsConfig !== _ColumnsConfig.ColumnsConfig.OVERTIME_ONLY) {
        numOfDataColumns += 3;
        columnNames.push(_messageResource2.default.getMessage("report.overtime.csv.time_balance.scheduled"));
        if (reportParameters.showWorkingAndLeaveTime) {
            numOfDataColumns += 2;
            columnNames.push(_messageResource2.default.getMessage("report.overtime.time_balance.total_reported"));
            columnNames.push(_messageResource2.default.getMessage("report.overtime.time_balance.working_time"));
            columnNames.push(_messageResource2.default.getMessage("report.overtime.time_balance.leave_time"));
        } else {
            columnNames.push(_messageResource2.default.getMessage("report.overtime.csv.time_balance.reported"));
        }
        columnNames.push(_messageResource2.default.getMessage("report.overtime.csv.time_balance.difference"));
    }

    if (reportParameters.columnsConfig !== _ColumnsConfig.ColumnsConfig.TIME_BALANCE_ONLY) {
        numOfDataColumns += 2;
        columnNames.push(_messageResource2.default.getMessage("report.overtime.csv.reported_by_user"));
        columnNames.push(_messageResource2.default.getMessage("report.overtime.csv.auto_calculated"));
    }

    var header = new _OvertimeCSVPreviewHeader2.default().init(reportParameters.firstGroupingLevel, reportParameters.secondGroupingLevel);

    var dataGroupingSection = new _OvertimeCSVPreviewGroupingSection2.default().init(reportParameters.firstGroupingLevel, reportParameters.secondGroupingLevel, numOfDataColumns, 2);

    var table = document.createElement("table");
    table.className = "reportCsvPreviewTable overtime";
    var tBody = document.createElement("tbody");
    table.appendChild(tBody);

    var totalColumnsNum = numOfGroupingColumns + numOfDataColumns;
    ReportPreviewUtils.addSheetHeaderRow(tBody, totalColumnsNum);

    var paramsBuilder = new _CSVParametersBuilder2.default().init();
    paramsBuilder.addDateRangeParam(reportParameters.dateRangeSelection, reportParamsStringBuilder);
    paramsBuilder.addOvertimeUsersParam(reportParameters.userSelection, reportParamsStringBuilder);

    var parametersSection = new _CSVParametersSection2.default().init(paramsBuilder, totalColumnsNum);

    parametersSection.addRows(tBody);
    header.addRows(tBody, columnNames);
    dataGroupingSection.addRows(tBody);

    return table;
};

/***/ }),
/* 2011 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = OvertimeCSVPreviewHeader;

var _CSVPreviewSection = __webpack_require__(43);

var _CSVPreviewSection2 = _interopRequireDefault(_CSVPreviewSection);

var _constants = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function OvertimeCSVPreviewHeader() {}

OvertimeCSVPreviewHeader.prototype = new _CSVPreviewSection2.default();

OvertimeCSVPreviewHeader.prototype.init = function (firstGroupingLevel, secondGroupingLevel) {
    _CSVPreviewSection2.default.prototype.init.call(this);
    this.firstGroupingLevel = firstGroupingLevel;
    this.secondGroupingLevel = secondGroupingLevel;
    return this;
};

OvertimeCSVPreviewHeader.prototype.addRows = function (tBody, columnNames) {
    var mainHeaderRow = this.createRow("headerRow");
    ReportPreviewUtils.addCell(mainHeaderRow, ReportPreviewUtils.getLevelPreviewName(this.firstGroupingLevel));

    if (this.secondGroupingLevel !== _constants.ReportGroupingLevel.NONE) {
        ReportPreviewUtils.addCell(mainHeaderRow, ReportPreviewUtils.getLevelPreviewName(this.secondGroupingLevel));
    }

    var self = this;
    _.each(columnNames, function (name) {
        self.addCell(mainHeaderRow, name);
    });

    this.addRow(tBody, mainHeaderRow);
};

/***/ }),
/* 2012 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = OvertimeCSVPreviewGroupingSection;

var _CSVPreviewSection = __webpack_require__(43);

var _CSVPreviewSection2 = _interopRequireDefault(_CSVPreviewSection);

var _constants = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function OvertimeCSVPreviewGroupingSection() {}

OvertimeCSVPreviewGroupingSection.prototype = new _CSVPreviewSection2.default();

OvertimeCSVPreviewGroupingSection.prototype.init = function (firstGroupingLevel, secondGroupingLevel, numOfDataColumns, numOfGroupingRows) {
    _CSVPreviewSection2.default.prototype.init.call(this);
    this.firstGroupingLevel = firstGroupingLevel;
    this.secondGroupingLevel = secondGroupingLevel;
    this.numOfDataColumns = numOfDataColumns;
    this.numOfGroupingRows = numOfGroupingRows;
    return this;
};

OvertimeCSVPreviewGroupingSection.prototype.addRows = function (tBody) {
    var withSecondLvl = this.secondGroupingLevel !== _constants.ReportGroupingLevel.NONE;
    var groupingLvls = withSecondLvl ? 2 : 1;
    var numOfGroupingRows = withSecondLvl ? this.numOfGroupingRows / 2 : this.numOfGroupingRows;

    for (var i = 0; i < numOfGroupingRows; i++) {
        var row = this.createRow();
        ReportPreviewUtils.addCell(row, ReportPreviewUtils.getLevelPreviewName(this.firstGroupingLevel));

        if (withSecondLvl) ReportPreviewUtils.addEmptyCell(row);

        for (var j = 0; j < this.numOfDataColumns; j++) {
            this.addTimeValueCell(row);
        }this.addRow(tBody, row);

        if (withSecondLvl) {
            var _row = this.createRow();
            ReportPreviewUtils.addEmptyCell(_row);
            ReportPreviewUtils.addCell(_row, ReportPreviewUtils.getLevelPreviewName(this.secondGroupingLevel));

            for (var _j = 0; _j < this.numOfDataColumns; _j++) {
                this.addTimeValueCell(_row);
            }this.addRow(tBody, _row);
        }
    }

    var emptyRow = this.createRow();
    var totalColumnsNum = this.numOfDataColumns + groupingLvls;

    for (var _i = 0; _i < totalColumnsNum; _i++) {
        ReportPreviewUtils.addEmptyCell(emptyRow);
    }this.addRow(tBody, emptyRow);

    var totalRow = this.createRow();
    this.addCell(totalRow, this.message("report.total"));
    for (var _i2 = 1; _i2 < groupingLvls; _i2++) {
        ReportPreviewUtils.addEmptyCell(totalRow);
    }for (var _i3 = 0; _i3 < this.numOfDataColumns; _i3++) {
        this.addValueCell(totalRow, ReportPreviewUtils.getCSVTimeValue());
    }this.addRow(tBody, totalRow);
};

/***/ }),
/* 2013 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = OvertimeHTMLPreviewGenerator;

var _ColumnsConfig = __webpack_require__(130);

var _OvertimeHTMLPreviewHeaderSection = __webpack_require__(2014);

var _OvertimeHTMLPreviewHeaderSection2 = _interopRequireDefault(_OvertimeHTMLPreviewHeaderSection);

var _OvertimeHTMLPreviewGroupingSection = __webpack_require__(2015);

var _OvertimeHTMLPreviewGroupingSection2 = _interopRequireDefault(_OvertimeHTMLPreviewGroupingSection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function OvertimeHTMLPreviewGenerator() {}

OvertimeHTMLPreviewGenerator.prototype.init = function () {
    return this;
};

OvertimeHTMLPreviewGenerator.prototype.generatePreviewTable = function (reportParameters) {
    var table = document.createElement("table");
    table.className = "reportHtmlPreviewTable overtime" + (EnabledFeatures.LVT ? "" : " lvtDisabled");
    var tBody = document.createElement("tbody");
    table.appendChild(tBody);

    var hasTimeBalance = reportParameters.columnsConfig !== _ColumnsConfig.ColumnsConfig.OVERTIME_ONLY;
    var hasOvertime = reportParameters.columnsConfig !== _ColumnsConfig.ColumnsConfig.TIME_BALANCE_ONLY;
    var showWorkingAndLeaveTime = reportParameters.showWorkingAndLeaveTime;

    var headerSection = new _OvertimeHTMLPreviewHeaderSection2.default().init(reportParameters.firstGroupingLevel, reportParameters.secondGroupingLevel, hasTimeBalance, hasOvertime, showWorkingAndLeaveTime);

    var groupingSection = new _OvertimeHTMLPreviewGroupingSection2.default().init(reportParameters.firstGroupingLevel, reportParameters.secondGroupingLevel, reportParameters.timeFormat, hasTimeBalance, hasOvertime, showWorkingAndLeaveTime);

    headerSection.addRows(tBody);
    groupingSection.addRows(tBody);

    return table;
};

/***/ }),
/* 2014 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = OvertimeHTMLPreviewHeaderSection;

var _PreviewSection = __webpack_require__(67);

var _PreviewSection2 = _interopRequireDefault(_PreviewSection);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function OvertimeHTMLPreviewHeaderSection() {}

OvertimeHTMLPreviewHeaderSection.prototype = _.create(_PreviewSection2.default.prototype, {
    init: function init(firstGroupingLevel, secondGroupingLevel, hasTimeBalance, hasOvertime, showWorkingAndLeaveTime) {
        _PreviewSection2.default.prototype.init.call(this);
        this.firstGroupingLevel = firstGroupingLevel;
        this.secondGroupingLevel = secondGroupingLevel;
        this.hasTimeBalance = hasTimeBalance;
        this.hasOvertime = hasOvertime;
        this.timeBalanceColsNum = showWorkingAndLeaveTime ? 5 : 3;
        return this;
    },

    addRows: function addRows(tBody) {
        var row1 = this.createRow("headerRow firstHeaderRow");
        var row2 = this.createRow("headerRow secondHeaderRow");

        this.addCell(row1, ReportPreviewUtils.makeGroupingHeader([this.firstGroupingLevel, this.secondGroupingLevel]), "groupingLevelsTitle", 1, 2);

        if (this.hasTimeBalance) {
            if (this.hasOvertime) this.addCell(row1, "", "emptyCell", 1, 2);
            this.addCell(row1, _messageResource2.default.getMessage("report.overtime.time_balance"), "timeSpentHeaderCell", this.timeBalanceColsNum, 1);
            this.addCell(row2, this.message("report.overtime.time_balance.scheduled"), "timeSpentHeaderCell");
            if (this.timeBalanceColsNum === 5) {
                this.addCell(row2, this.message("report.overtime.time_balance.total_reported"), "timeSpentHeaderCell withoutBorderRight");
                this.addCell(row2, this.message("report.overtime.time_balance.working_time"), "timeSpentHeaderCell withoutBorderRight");
                this.addCell(row2, this.message("report.overtime.time_balance.leave_time"), "timeSpentHeaderCell");
            } else {
                this.addCell(row2, this.message("report.overtime.time_balance.reported"), "timeSpentHeaderCell");
            }
            this.addCell(row2, this.message("report.overtime.time_balance.difference"), "timeSpentHeaderCell");
        }

        if (this.hasOvertime) {
            if (this.hasTimeBalance) this.addCell(row1, "", "emptyCell", 1, 2);
            this.addCell(row1, _messageResource2.default.getMessage("overtime.overtime"), "overtimeHeaderCell", 2, 1);
            this.addCell(row2, this.message("report.overtime.table.reported_by_user"), "overtimeHeaderCell");
            this.addCell(row2, this.message("report.overtime.table.auto_calculated"), "overtimeHeaderCell");
        }

        this.addRow(tBody, row1);
        this.addRow(tBody, row2);
    }
});

/***/ }),
/* 2015 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = OvertimeHTMLPreviewGroupingSection;

var _PreviewSection = __webpack_require__(67);

var _PreviewSection2 = _interopRequireDefault(_PreviewSection);

var _constants = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function OvertimeHTMLPreviewGroupingSection() {}

OvertimeHTMLPreviewGroupingSection.prototype = _.create(_PreviewSection2.default.prototype, {
    init: function init(firstGroupingLevel, secondGroupingLevel, timeFormat, hasTimeBalance, hasOvertime, showWorkingAndLeaveTime) {
        _PreviewSection2.default.prototype.init.call(this);
        this.firstGroupingLevel = firstGroupingLevel;
        this.secondGroupingLevel = secondGroupingLevel;
        this.timeFormat = timeFormat;
        this.hasTimeBalance = hasTimeBalance;
        this.hasOvertime = hasOvertime;
        this.showWorkingAndLeaveTime = showWorkingAndLeaveTime;
        return this;
    },

    addRows: function addRows(tBody) {
        this.addRowWithMainCell(tBody, this.message("report.total"), "totalCell", "totalRow");
        this.addFirstGroupingRow(tBody);
        if (this.secondGroupingLevel !== _constants.ReportGroupingLevel.NONE) {
            this.addSecondGroupingRow(tBody);
            if (ReportPreviewUtils.isLevelCanBeAddedMoreThanOnce(this.secondGroupingLevel, [this.firstGroupingLevel])) this.addSecondGroupingRow(tBody);else this.addFirstGroupingRow(tBody);
        } else {
            this.addFirstGroupingRow(tBody);
            this.addFirstGroupingRow(tBody);
        }
    },

    addFirstGroupingRow: function addFirstGroupingRow(tBody) {
        this.addRowWithMainCell(tBody, ReportPreviewUtils.getLevelPreviewName(this.firstGroupingLevel), "firstLevel", "firstGrouping");
    },

    addSecondGroupingRow: function addSecondGroupingRow(tBody) {
        this.addRowWithMainCell(tBody, ReportPreviewUtils.getLevelPreviewName(this.secondGroupingLevel), "secondLevel");
    },

    addRowWithMainCell: function addRowWithMainCell(tBody, text, mainCellClassName, rowClassName) {
        var row = this.createRow(rowClassName);
        this.addCell(row, text, mainCellClassName);
        this.addDataCells(row);
        this.addRow(tBody, row);
    },

    addDataCells: function addDataCells(row) {
        if (this.hasTimeBalance) {
            if (this.hasOvertime) this.addCell(row, "", "emptyCell");

            ReportPreviewUtils.addHTMLTimeValueCell(row, this.timeFormat);
            if (this.showWorkingAndLeaveTime) {
                ReportPreviewUtils.addHTMLTimeValueCell(row, this.timeFormat, "withoutBorderRight");
                ReportPreviewUtils.addHTMLTimeValueCell(row, this.timeFormat, "withoutBorderRight");
                ReportPreviewUtils.addHTMLTimeValueCell(row, this.timeFormat);
            } else {
                ReportPreviewUtils.addHTMLTimeValueCell(row, this.timeFormat);
            }
            ReportPreviewUtils.addHTMLTimeValueCell(row, this.timeFormat);
        }

        if (this.hasOvertime) {
            if (this.hasTimeBalance) this.addCell(row, "", "emptyCell");
            for (var i = 0; i < 2; i++) {
                ReportPreviewUtils.addHTMLTimeValueCell(row, this.timeFormat);
            }
        }
    }
});

/***/ }),
/* 2016 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = OvertimeReportMediator;

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _PDFPreviewLightbox = __webpack_require__(972);

var _PDFPreviewLightbox2 = _interopRequireDefault(_PDFPreviewLightbox);

var _PDFGenerator = __webpack_require__(974);

var _PDFGenerator2 = _interopRequireDefault(_PDFGenerator);

var _constants = __webpack_require__(11);

var _OvertimeReportEditConfigController = __webpack_require__(979);

var _OvertimeReportEditConfigController2 = _interopRequireDefault(_OvertimeReportEditConfigController);

var _ReportPrintableHeadersBuilder = __webpack_require__(171);

var _ReportPrintableHeadersBuilder2 = _interopRequireDefault(_ReportPrintableHeadersBuilder);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _constants2 = __webpack_require__(4);

var _jquery_rpc = __webpack_require__(26);

var _jquery_rpc2 = _interopRequireDefault(_jquery_rpc);

var _ColumnsConfig = __webpack_require__(130);

var _atUtils = __webpack_require__(5);

var _ReportMediator = __webpack_require__(321);

var _ReportMediator2 = _interopRequireDefault(_ReportMediator);

var _OvertimeReportStore = __webpack_require__(411);

var _OvertimeReportStore2 = _interopRequireDefault(_OvertimeReportStore);

var _utils = __webpack_require__(127);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function OvertimeReportMediator() {
    this.constructor = OvertimeReportMediator;
}

OvertimeReportMediator.prototype = _.create(_ReportMediator2.default.prototype);

OvertimeReportMediator.prototype.init = function (config) {
    _ReportMediator2.default.prototype.init.call(this, config);

    this._initStore(config);
    this._initControllers();

    this.eventNamespace = "OvertimeReport";
    this.store = _OvertimeReportStore2.default;

    this.productSettingsValidator = new ATProductSettingsValidator();
    this.reportRightsValidator = new ATReportRightsValidator();

    new BaseReport.PDFPreviewLightboxTemplateView((0, _jquery2.default)("body"), "OvertimePdfPreviewLightbox", "lightboxWithWhiteContent pdfPreviewLightbox noprint").init();

    this.pdfPreviewLightbox = new _PDFPreviewLightbox2.default().init({
        popupId: "OvertimePdfPreviewLightbox",
        closeBtnId: "closeViewTTPdfPreviewLightboxButton",
        eventNamespace: this.eventNamespace,
        productSettingsValidator: this.productSettingsValidator,
        reportRightsValidator: this.reportRightsValidator
    });

    this.initPDFEvents();

    this.initCSVEvents();

    ATReportsStore.setVisibleUsers(config.users);
    ATReportsStore.setUserGroups(config.userGroups);
    ATReportsStore.setTimeZoneGroups(config.timeZoneGroups);

    return this;
};

OvertimeReportMediator.prototype._initStore = function (config) {
    //
};

OvertimeReportMediator.prototype._initControllers = function () {
    var self = this;
    this.ExportSelector = new ExportPanel((0, _jquery2.default)("body"), "OvertimeReport.showPDFPreview", "OvertimeReport.createCSV").init();

    this.$exportButton = (0, _jquery2.default)(".export");
    this.$exportButton.click(function () {
        if (!self.$exportButton.hasClass('disabled')) self.ExportSelector.showAt((0, _jquery2.default)(this));
    });
};

OvertimeReportMediator.prototype.generateCSV = function () {
    var generator = new OvertimeCSVJsonConverter().init(this.store, ATReportsStore);
    var params = this.store.getReportParams();

    var jsonTitle = generator.convertTitle(params);
    var jsonTable = generator.convertLinearTable(params, this.store.getReportData());
    var jsonTotal = generator.convertTotal(params, this.store.getReportData());

    (0, _utils.downloadJsonAsCSV)([jsonTitle, jsonTable, jsonTotal], generator.generateCSVName(params));
};

OvertimeReportMediator.prototype.getEventName = function (event) {
    return this.eventNamespace + "." + event;
};

OvertimeReportMediator.prototype.cancelAllPDFExportingProcesses = function () {
    if (this.pdfGenerator) this.pdfGenerator.interruptGeneration();
    this.pdfPreviewLightbox.cancelAllExportingProcesses();
};

OvertimeReportMediator.prototype.generatePDF = function () {
    this.pdfGenerator = new _PDFGenerator2.default().init(this.store, ATReportsStore, this.productSettingsValidator, this.reportRightsValidator);

    (0, _jquery2.default)(document).trigger(this.getEventName("pdfGenerator.start"));
    var self = this;
    this.pdfGenerator.generatePDF(function (config, onDataProvided) {}).then(function (pdf) {
        self.store.setGeneratedPDF(pdf.encodedPDF);
        self.store.setPDFFileName(pdf.fileName);
    }, function (error) {
        if (error.message !== "abort") {
            console.error(error);
        }
    });
};

OvertimeReportMediator.prototype.getReportType = function () {
    return _constants.ReportType.OVERTIME;
};

OvertimeReportMediator.prototype.initEditConfigController = function (config) {
    var self = this;
    return new _OvertimeReportEditConfigController2.default().init({
        reportAuthorizationInfo: config.reportAuthorizationInfo,
        reportParameters: config.reportParameters,
        users: config.users,
        manageableUsersIds: config.manageableUserIds,
        userGroups: config.userGroups,
        timeZoneGroups: config.timeZoneGroups,
        changeCallback: function changeCallback() {
            self.changeParametersCallback();
        }
    });
};

OvertimeReportMediator.prototype.initPrintableHeadersBuilder = function (config) {
    return new _ReportPrintableHeadersBuilder2.default().init({
        users: config.users,
        reportParameters: config.reportParameters,
        userGroups: config.userGroups,
        timeZoneGroups: config.timeZoneGroups
    });
};

OvertimeReportMediator.prototype._populateHeadersArray = function (headersArray) {
    this.printableHeadersBuilder.addStaffSelectionParamsToArray(this.reportParameters.userSelection, headersArray); //staff
};

OvertimeReportMediator.prototype.requestGenerateReport = function (successHandler) {
    var self = this;

    function successMethod(data, textStatus, jqXHR) {
        if (successHandler) successHandler(data, textStatus, jqXHR);
        self.$exportButton.toggleClass('disabled', false);
    }

    function errorMethod(jqXHR, textStatus, errorThrown) {
        self.$exportButton.toggleClass('disabled', true);
        self.hideOverlay();

        if (textStatus === "rpc_noRights") {
            alert(_messageResource2.default.getMessage("common.no_rights_for_operation_anymore"));
            document.location.href = _constants2.ReportConfigConstants.REPORTS_DASHBOARD_URL;
            return true;
        }

        if (textStatus === "rpc_sessionExpired") return false;

        if (textStatus === "rpc_customException") {
            if (errorThrown.exception === "com.actimind.actitime.reports.AllSelectedUsersWereDeletedException") {
                self.showReportLoadingError(_messageResource2.default.getMessage("report.js.report_loading_error.no_selected_users"));
                return true;
            }
        } else {
            self.showReportLoadingError(_messageResource2.default.getMessage("report.js.report_loading_error.network_error", [PRODUCT_NAME]));
            return true;
        }

        return false;
    }

    return (0, _jquery_rpc2.default)("TimeBalanceAndOvertimeReportService.getReport", [this.makeServiceParams(this.reportParameters)], successMethod, errorMethod);
};

OvertimeReportMediator.prototype.renderGeneratedReport = function (data) {
    var reportParams = _.clone(this.reportParameters);

    var info = {};
    var groupingLevels = BaseReport.ConvertUtils.getGroupingLevels(reportParams);
    for (var i = 0; i < data["groupingLevelsInfoLists"].length; ++i) {
        var groupingType = BaseReport.ConvertUtils.getGroupingType(i, groupingLevels);
        info[groupingType] = (0, _atUtils.arrayToMap)(data["groupingLevelsInfoLists"][i]);
    }

    _OvertimeReportStore2.default.setReportData(data["rootItem"], info);
    _OvertimeReportStore2.default.setReportParams(reportParams);

    if (this.overtimeReportTable) this.overtimeReportTable.cancelRendering();

    this.reportPlaceholder.empty();
    this.overtimeReportTable = new OvertimeReport.Table(this.reportPlaceholder, _OvertimeReportStore2.default).init();
    this.overtimeReportTable.update();

    (0, _jquery2.default)("#overtimeExtraNotes").toggle(reportParams.columnsConfig !== _ColumnsConfig.ColumnsConfig.TIME_BALANCE_ONLY);
};

/***/ }),
/* 2017 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = BudgetedVsActualReportMediator;

var _ReportMediator = __webpack_require__(321);

var _ReportMediator2 = _interopRequireDefault(_ReportMediator);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _PDFPreviewLightbox = __webpack_require__(976);

var _PDFPreviewLightbox2 = _interopRequireDefault(_PDFPreviewLightbox);

var _PDFGenerator = __webpack_require__(977);

var _PDFGenerator2 = _interopRequireDefault(_PDFGenerator);

var _constants = __webpack_require__(11);

var _BudgetedVsActualResultConfigController = __webpack_require__(2018);

var _BudgetedVsActualResultConfigController2 = _interopRequireDefault(_BudgetedVsActualResultConfigController);

var _ReportPrintableHeadersBuilder = __webpack_require__(171);

var _ReportPrintableHeadersBuilder2 = _interopRequireDefault(_ReportPrintableHeadersBuilder);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _constants2 = __webpack_require__(4);

var _jquery_rpc = __webpack_require__(26);

var _jquery_rpc2 = _interopRequireDefault(_jquery_rpc);

var _utils = __webpack_require__(127);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function BudgetedVsActualReportMediator() {
    this.constructor = BudgetedVsActualReportMediator;
}

BudgetedVsActualReportMediator.prototype = new _ReportMediator2.default();

BudgetedVsActualReportMediator.prototype.init = function (config) {
    _ReportMediator2.default.prototype.init.call(this, config);
    this._initStore(config);
    this._initControllers();

    this.eventNamespace = "EVAReport";
    this.store = EVAReport.Store;

    var oldIE = isOldIE();
    if (!oldIE) {
        this.productSettingsValidator = new ATProductSettingsValidator();
        this.reportRightsValidator = new ATReportRightsValidator();

        new BaseReport.PDFPreviewLightboxTemplateView((0, _jquery2.default)("body"), "leaveTimeAndBalancesPdfPreviewLightbox", "lightboxWithWhiteContent pdfPreviewLightbox noprint").init();

        this.pdfPreviewLightbox = new _PDFPreviewLightbox2.default().init({
            popupId: "leaveTimeAndBalancesPdfPreviewLightbox",
            closeBtnId: "closeViewTTPdfPreviewLightboxButton",
            eventNamespace: this.eventNamespace,
            productSettingsValidator: this.productSettingsValidator,
            reportRightsValidator: this.reportRightsValidator
        });

        this.initPDFEvents();
    }

    this.initCSVEvents();

    this.setConfigDateRangeSelection(this.dateRangeSelector.getSelectedRange());

    return this;
};

BudgetedVsActualReportMediator.prototype.cancelAllPDFExportingProcesses = function () {
    if (this.pdfGenerator) this.pdfGenerator.interruptGeneration();
    this.pdfPreviewLightbox.cancelAllExportingProcesses();
};

BudgetedVsActualReportMediator.prototype.generatePDF = function () {
    this.pdfGenerator = new _PDFGenerator2.default().init(this.store, ATReportsStore, this.productSettingsValidator, this.reportRightsValidator);

    (0, _jquery2.default)(document).trigger(this.getEventName("pdfGenerator.start"));
    var self = this;
    this.pdfGenerator.generatePDF(function (config, onDataProvided) {}).then(function (pdf) {
        self.store.setGeneratedPDF(pdf.encodedPDF);
        self.store.setPDFFileName(pdf.fileName);
    }, function (error) {
        if (error.message !== "abort") {
            console.error(error);
        }
    });
};

BudgetedVsActualReportMediator.prototype._initStore = function (config) {
    ATReportsStore.setCPList(config.cpList);
};

BudgetedVsActualReportMediator.prototype.getEventName = function (event) {
    return this.eventNamespace + "." + event;
};

BudgetedVsActualReportMediator.prototype._initControllers = function () {
    var self = this;
    var oldIE = isOldIE();
    this.ExportSelector = new ExportPanel((0, _jquery2.default)("body"), oldIE ? null : "EVAReport.showPDFPreview", "EVAReport.createCSV").init();

    this.$exportButton = (0, _jquery2.default)(".export");
    this.$exportButton.click(function () {
        if (!self.$exportButton.hasClass('disabled')) self.ExportSelector.showAt((0, _jquery2.default)(this));
    });

    if (oldIE) // IE8 and IE9 don't support pdf preview and pdf generate
        {
            ReportUtils.generateOldIEPDFTooltip(this.ExportSelector.findPDFButton());
        }
};

BudgetedVsActualReportMediator.prototype.generateCSV = function () {
    var customersMap = _.extend(arrayToMapById(ATReportsStore.getCPList().customers), EVAReport.Store.getCustomers());
    var projectMap = _.extend(arrayToMapById(ATReportsStore.getCPList().projects), EVAReport.Store.getProjects());
    var tasksMap = EVAReport.Store.getTasks();
    var usersMap = EVAReport.Store.getUsers();
    var projectNamesMap = EVAReport.Store.getProjectNames();
    var taskNamesMap = EVAReport.Store.getTaskNames();
    var typesOfWorkMap = EVAReport.Store.getTypesOfWork();

    var generator = new EVACSVJsonConverter().init(customersMap, projectMap, tasksMap, usersMap, projectNamesMap, taskNamesMap, typesOfWorkMap, null, EVAReport.Store.getGroupingPresentationFlags(), EVAReport.Store);

    (0, _utils.downloadJsonAsCSV)(generator.getJsons(EVAReport.Store.getReportParams(), EVAReport.Store.getReportData()), generator.generateCSVName(EVAReport.Store.getReportParams()));
};

BudgetedVsActualReportMediator.prototype.getReportType = function () {
    return _constants.ReportType.ESTIMATED_VS_ACTUAL;
};

BudgetedVsActualReportMediator.prototype.initEditConfigController = function (config) {
    var self = this;
    this.controller = new _BudgetedVsActualResultConfigController2.default().init({
        reportParameters: config.reportParameters,
        cpList: config.cpList,
        customersWithMaIds: config.customersWithMaIds,
        projectsWithMaIds: config.projectsWithMaIds,
        changeCallback: function changeCallback() {
            self.changeParametersCallback();
        }
    });
    return this.controller;
};

BudgetedVsActualReportMediator.prototype.createDateRangeSelector = function (reportParameters) {
    var dateRangeSelectorConfig = {
        dateRangeSelection: reportParameters.dateSelection,
        menuStates: new DateRangeMenuItemsUtil().createDefaultSingleDateMenuItems(),
        dateRangeParsed: true
    };

    return new SingleDateSelectorController().init(dateRangeSelectorConfig);
};

BudgetedVsActualReportMediator.prototype.setDateRangeParameter = function (reportParameters) {
    this.dateRangeSelector.setSelectedRange(reportParameters.dateSelection);
};

BudgetedVsActualReportMediator.prototype.onDateRangeChanged = function () {
    this.setConfigDateRangeSelection(this.dateRangeSelector.getSelectedRange());

    if (this.hasErrors()) return;

    this.dateRangeSelector.setInitStateFromCurrent();
    this.registerChanges();
    this._createPrintableHeaders();
    this.generateReport(false); // do not verify if date range really changed
};

BudgetedVsActualReportMediator.prototype.setConfigDateRangeSelection = function (selection) {
    this.reportParameters.dateSelection = selection;
};

BudgetedVsActualReportMediator.prototype._populateHeadersArray = function (headersArray) {
    this.printableHeadersBuilder.addCPSelectionParamsStringToArray(this.reportParameters.customersProjectsSelection, headersArray); //customers and projects
    this.printableHeadersBuilder.addTaskSelectionParamsStringToArray(this.reportParameters.tasksConfig, this.reportParameters.includeNotEstimated, this.reportParameters.includeNotStarted, this.reportParameters.dateSelection, headersArray); //tasks
};

BudgetedVsActualReportMediator.prototype.initPrintableHeadersBuilder = function (config) {
    return new _ReportPrintableHeadersBuilder2.default().init({
        reportParameters: config.reportParameters,
        cpList: config.cpList,
        isFilteredByAssignments: config.isFilteredByAssignments
    });
};

BudgetedVsActualReportMediator.prototype._createPrintableDateRangeHeader = function () {
    return this.printableHeadersBuilder.addEvaDateHeaderStringParsed(this.reportParameters.dateSelection);
};

BudgetedVsActualReportMediator.prototype.requestGenerateReport = function (successHandler) {
    // service
    var self = this;

    function successMethod(data, textStatus, jqXHR) {
        if (successHandler) successHandler(data, textStatus, jqXHR);
        self.$exportButton.toggleClass('disabled', false);
    }

    function errorMethod(jqXHR, textStatus, errorThrown) {
        self.$exportButton.toggleClass('disabled', true);

        if (textStatus === "rpc_noRights") {
            alert(_messageResource2.default.getMessage("common.no_rights_for_operation_anymore"));
            document.location.href = _constants2.ReportConfigConstants.REPORTS_DASHBOARD_URL;
            return true;
        }
        return false;
    }

    var params = this.makeServiceParams(this.reportParameters);
    return (0, _jquery_rpc2.default)("EvAReportService.getReport", [params.dateSelection, EVAReport.ConvertUtils.getGroupingLevels(params), params.customersProjectsSelection, params.tasksConfig, params.includeNotStarted, params.includeNotEstimated], successMethod, errorMethod);
};

BudgetedVsActualReportMediator.prototype.makeServiceParams = function (reportParams) {
    var serviceParams = _.clone(reportParams);
    serviceParams.dateSelection = {
        qualifier: reportParams.dateSelection.qualifier,
        date: reportParams.dateSelection.date.toJSON()
    };

    return serviceParams;
};

BudgetedVsActualReportMediator.prototype.renderGeneratedReport = function (data) {
    var reportParams = _jquery2.default.extend(true, {}, this.reportParameters);

    var info = {};
    var groupingLevels = EVAReport.ConvertUtils.getGroupingLevels(reportParams);
    var groupingLevelsCollapsed = EVAReport.ConvertUtils.getGroupingLevelsCollapsed(groupingLevels);

    for (var i = 0; i < data["groupingLevelsInfoLists"].length; ++i) {
        info[groupingLevelsCollapsed[i]] = data["groupingLevelsInfoLists"][i];
    }

    var customers = arrayToMapById(info[_constants.ReportGroupingLevel.CUSTOMER]);
    var projects = arrayToMapById(info[_constants.ReportGroupingLevel.PROJECT]);
    var projectNames = arrayToMapById(info[_constants.ReportGroupingLevel.PROJECT_NAME]);
    var tasks = arrayToMapById(info[_constants.ReportGroupingLevel.TASK]);
    var taskNames = arrayToMapById(info[_constants.ReportGroupingLevel.TASK_NAME]);
    var typesOfWork = arrayToMapById(info[_constants.ReportGroupingLevel.BILLING_TYPE]);
    var users = arrayToMapById(info[_constants.ReportGroupingLevel.USER]);

    this.reportPlaceholder.empty();
    EVAReport.Store.setReportData(data["rootItem"], customers, projects, tasks, users, projectNames, taskNames, typesOfWork);
    EVAReport.Store.setReportParams(reportParams);

    new EVAReport.Table(this.reportPlaceholder, EVAReport.Store).init().update();
};

/***/ }),
/* 2018 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _BudgetedVsActualReportEditConfigController = __webpack_require__(981);

var _BudgetedVsActualReportEditConfigController2 = _interopRequireDefault(_BudgetedVsActualReportEditConfigController);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BudgetedVsActualResultConfigController = function (_BudgetedVsActualRepo) {
    _inherits(BudgetedVsActualResultConfigController, _BudgetedVsActualRepo);

    function BudgetedVsActualResultConfigController() {
        _classCallCheck(this, BudgetedVsActualResultConfigController);

        return _possibleConstructorReturn(this, (BudgetedVsActualResultConfigController.__proto__ || Object.getPrototypeOf(BudgetedVsActualResultConfigController)).apply(this, arguments));
    }

    return BudgetedVsActualResultConfigController;
}(_BudgetedVsActualReportEditConfigController2.default);

exports.default = BudgetedVsActualResultConfigController;


BudgetedVsActualResultConfigController.prototype.makeReportParamsAccordingToFeatures = function (reportParameters) {
    return reportParameters;
};

/***/ }),
/* 2019 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = BudgetGroupingSelector;

var _GroupingSelectorWithDetailsLevel = __webpack_require__(982);

var _GroupingSelectorWithDetailsLevel2 = _interopRequireDefault(_GroupingSelectorWithDetailsLevel);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _constants = __webpack_require__(11);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function BudgetGroupingSelector() {
    this.constructor = BudgetGroupingSelector;
}

BudgetGroupingSelector.prototype = _underscore2.default.create(_GroupingSelectorWithDetailsLevel2.default.prototype);

BudgetGroupingSelector.prototype.init = function (selectorId, selectedValues, isBTYEnabled, changesCallback) {
    this.isBTYEnabled = isBTYEnabled;

    _GroupingSelectorWithDetailsLevel2.default.prototype.init.call(this, selectorId, 3, selectedValues, changesCallback);

    return this;
};

BudgetGroupingSelector.prototype.fillListSelector = function (listSelector, level) {
    if (level <= 2) {
        if (level > 0) {
            var textKey = level === 1 ? "report.form.dont_use_2nd_grouping_level" : "report.form.dont_use_3rd_grouping_level";
            listSelector.addItems([{
                text: _messageResource2.default.getMessage(textKey),
                value: _constants.ReportGroupingLevel.NONE
            }]);
            listSelector.addSeparator();
        }
        listSelector.addItems([{
            text: _messageResource2.default.getEscapedMessage("common.Customers"),
            value: _constants.ReportGroupingLevel.CUSTOMER
        }, {
            text: _messageResource2.default.getEscapedMessage("common.Projects"),
            value: _constants.ReportGroupingLevel.PROJECT
        }, {
            text: _messageResource2.default.getEscapedMessage("report.form.projects_joined_by_name"),
            value: _constants.ReportGroupingLevel.PROJECT_NAME
        }, {
            text: _messageResource2.default.getEscapedMessage("common.Tasks"),
            value: _constants.ReportGroupingLevel.TASK
        }, {
            text: _messageResource2.default.getEscapedMessage("report.form.tasks_joined_by_name"),
            value: _constants.ReportGroupingLevel.TASK_NAME
        }]);
        if (this.isBTYEnabled) {
            listSelector.addItems([{
                text: _messageResource2.default.getMessage("report.common.billing_types"),
                value: _constants.ReportGroupingLevel.BILLING_TYPE
            }]);
        }
    } else {
        listSelector.addItems([{
            text: _messageResource2.default.getMessage("report.hide_details"),
            value: _constants.ReportGroupingLevel.NONE
        }, {
            text: _messageResource2.default.getEscapedMessage("common.Tasks"),
            value: _constants.ReportGroupingLevel.TASK
        }, {
            text: _messageResource2.default.getMessage("report.users"),
            value: _constants.ReportGroupingLevel.USER
        }]);
    }
};

BudgetGroupingSelector.prototype.thereAreNo = function (level) {
    var first = this.getListSelectorValue(0);
    var second = this.getListSelectorValue(1);
    var third = this.getListSelectorValue(2);

    return first !== level && second !== level && third !== level;
};

BudgetGroupingSelector.prototype.thereAre = function (level) {
    var first = this.getListSelectorValue(0);
    var second = this.getListSelectorValue(1);
    var third = this.getListSelectorValue(2);

    return first === level || second === level || third === level;
};

BudgetGroupingSelector.prototype.updateDetailsOptions = function () {
    var currentDetailsValue = this.getDetailsListSelectorValue();

    if (this.thereAreNo(_constants.ReportGroupingLevel.TASK)) {
        this.detailsListSelector.getItemByValue(_constants.ReportGroupingLevel.TASK).show();
    } else {
        this.detailsListSelector.getItemByValue(_constants.ReportGroupingLevel.TASK).hide();
        if (currentDetailsValue === _constants.ReportGroupingLevel.TASK) this.detailsListSelector.setActiveItemByValue(_constants.ReportGroupingLevel.USER);
    }
};

BudgetGroupingSelector.prototype.treeStyleMap = {
    '+++': ['tree-row-A', 'tree-row-SA', 'tree-row-SSA'],
    '++-': ['tree-row-A', 'tree-row-SA', 'tree-row-SSI'],
    '+-+': ['tree-row-A', 'tree-row-SJ', 'tree-row-SAL'],
    '+--': ['tree-row-A', 'tree-row-SI', 'tree-row-SSI'],
    '-++': ['tree-row-J', 'tree-row-AL', 'tree-row-SSA'],
    '-+-': ['tree-row-J', 'tree-row-AL', 'tree-row-SSI'],
    '--+': ['tree-row-J', 'tree-row-JL', 'tree-row-ALL'],
    '---': ['tree-row-I', 'tree-row-SI', 'tree-row-SSI']
};

BudgetGroupingSelector.prototype.updateTree = function () {
    var secondShown = this.getListSelectorValue(1) !== _constants.ReportGroupingLevel.NONE;
    var thirdShown = this.getListSelectorValue(2) !== _constants.ReportGroupingLevel.NONE;
    var detailsShown = this.getDetailsListSelectorValue() !== _constants.ReportGroupingLevel.NONE;

    var key = (secondShown ? '+' : '-') + (thirdShown ? '+' : '-') + (detailsShown ? '+' : '-');
    var styles = this.treeStyleMap[key];

    this.setRowClassName(1, styles[0]);
    this.setRowClassName(2, styles[1]);
    this.setRowClassName(3, styles[2]);
};

/***/ }),
/* 2020 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = LeaveTimeFormMediator;

var _LeavesEditFormConfigController = __webpack_require__(983);

var _LeavesEditFormConfigController2 = _interopRequireDefault(_LeavesEditFormConfigController);

var _BaseFormMediator = __webpack_require__(269);

var _BaseFormMediator2 = _interopRequireDefault(_BaseFormMediator);

var _ScrollUtils = __webpack_require__(39);

var _ScrollUtils2 = _interopRequireDefault(_ScrollUtils);

var _atUtils = __webpack_require__(5);

var _LeavesReportStore = __webpack_require__(199);

var _LeavesReportStore2 = _interopRequireDefault(_LeavesReportStore);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _LeaveHTMLPreviewGenerator = __webpack_require__(2022);

var _LeaveHTMLPreviewGenerator2 = _interopRequireDefault(_LeaveHTMLPreviewGenerator);

var _LeaveCSVPreviewGenerator = __webpack_require__(2031);

var _LeaveCSVPreviewGenerator2 = _interopRequireDefault(_LeaveCSVPreviewGenerator);

var _ATReportParamsStringBuilder = __webpack_require__(52);

var _ATReportParamsStringBuilder2 = _interopRequireDefault(_ATReportParamsStringBuilder);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function LeaveTimeFormMediator() {} /**
                                     * @author evdokimov
                                     */


LeaveTimeFormMediator.prototype = _underscore2.default.create(_BaseFormMediator2.default.prototype);

LeaveTimeFormMediator.prototype.init = function (config) {
    _BaseFormMediator2.default.prototype.init.call(this, config);

    ATReportsStore.setVisibleUsers(config.users);
    ATReportsStore.setUserGroups(config.userGroups);
    ATReportsStore.setTimeZoneGroups(config.timeZoneGroups);

    this.validateAndUpdateUIIfInvalid();
    return this;
};

LeaveTimeFormMediator.prototype.initParamsStringBuilder = function (config) {
    return new _ATReportParamsStringBuilder2.default({
        data: {
            users: config.users,
            userGroups: config.userGroups,
            timeZoneGroups: config.timeZoneGroups,
            leaveTypesMap: (0, _atUtils.arrayToMap)(config.leavesData),
            manageableUserIds: ATReportsStore.getManageableUserIds()
        },
        reportAuthorizationInfo: ATReportsStore.getReportAuthorizationInfo()
    });
};

LeaveTimeFormMediator.prototype.initEditConfigController = function (config) {
    var self = this;
    var controller = new _LeavesEditFormConfigController2.default();
    controller.setState({
        loggedInUserId: config.loggedInUserId
    });
    controller.init({
        panelId: "mainContainer",
        reportAuthorizationInfo: config.reportAuthorizationInfo,
        reportParameters: config.reportParameters,
        users: config.users,
        manageableUsersIds: config.manageableUserIds,
        userGroups: config.userGroups,
        timeZoneGroups: config.timeZoneGroups,
        leavesData: config.leavesData,
        changeCallback: function changeCallback() {
            self.changeParametersCallback();
        },
        productSettingsValidator: new ATProductSettingsValidator(),
        reportRightsValidator: new ATReportRightsValidator()
    });

    return controller;
};

LeaveTimeFormMediator.prototype.initCsvGenerator = function () {
    return new _LeaveCSVPreviewGenerator2.default().init();
};

LeaveTimeFormMediator.prototype.initHtmlGenerator = function () {
    return new _LeaveHTMLPreviewGenerator2.default();
};

LeaveTimeFormMediator.prototype.createDateRangeSelector = function (reportParameters) {
    var dateRangeMenuItemsUtil = new DateRangeMenuItemsUtil();
    var futureValidator = function futureValidator() {
        return dateRangeMenuItemsUtil.isShowTTFItems(reportParameters.dateRangeSelection.qualifier);
    };

    var dateRangeSelectorConfig = {
        dateRangeSelection: reportParameters.dateRangeSelection,
        menuStates: dateRangeMenuItemsUtil.createDateRangeMenuItemsWithFuture(futureValidator), //for future items
        shortDateFormat: true,
        callOnChangeCallbackIfInvalid: true
    };

    return new DateRangeSelectorController().init(dateRangeSelectorConfig);
};

LeaveTimeFormMediator.prototype.generateCSVPreview = function (reportParameters) {
    _BaseFormMediator2.default.prototype.generateCSVPreview.apply(this, arguments);
    this._initCSVPreviewCustomScroll(this.reportPreviewPlaceholder);
};

/**
 * NOTE: this method can be used for all csv previews (need to move it in base formMediator)
 * Init custom scroll used iScroll library
 * for ie8 used standard scroll with custom mousewhell event that prevent default scrolling and allow hor scrolling
 * @param placeholderEl placeholder element (scroll wrapper) important! first child will be scrolled
 * @private
 */
LeaveTimeFormMediator.prototype._initCSVPreviewCustomScroll = function (placeholderEl) {
    _ScrollUtils2.default.addHorizontalScroll(placeholderEl, { isFaded: false });
};

LeaveTimeFormMediator.prototype.exportToCSV = function () {
    var reportParams = this.collectReportParameters();

    var successMethod = function successMethod(data) {
        var info = {};
        var groupingLevels = BaseReport.ConvertUtils.getGroupingLevels(reportParams);
        for (var i = 0; i < data["groupingLevelsInfoLists"].length; ++i) {
            var groupingType = BaseReport.ConvertUtils.getGroupingType(i, groupingLevels);
            info[groupingType] = (0, _atUtils.arrayToMap)(data["groupingLevelsInfoLists"][i]);
        }

        _LeavesReportStore2.default.setReportData(data["rootItem"], info);
        _LeavesReportStore2.default.mergeGeneralStore(ATReportsStore);
        _LeavesReportStore2.default.setReportParams(reportParams);
        return new LeaveCSVJsonConverter().init({
            defaultWorkDayDuration: data.defaultWorkDayDuration,
            store: _LeavesReportStore2.default,
            reportParamsStringBuilderConstructor: _ATReportParamsStringBuilder2.default,
            manageableUserIds: ATReportsStore.getManageableUserIds(),
            reportAuthorizationInfo: ATReportsStore.getReportAuthorizationInfo()
        });
    };

    this._exportToCSV(reportParams, successMethod, "LeavesReportService.getLeavesReport", [this.makeServiceParams(reportParams)]);
};

LeaveTimeFormMediator.prototype.generateCSVName = function (generator, reportParams) {
    return generator.generateCSVName(reportParams, new ATProductSettingsValidator(), UserRights.MANAGE_PTO_AND_SICK);
};

/***/ }),
/* 2021 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = LeavesGroupingSelector;

var _GroupingSelector = __webpack_require__(322);

var _GroupingSelector2 = _interopRequireDefault(_GroupingSelector);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _constants = __webpack_require__(11);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function LeavesGroupingSelector() {
    this.constructor = LeavesGroupingSelector;
}

LeavesGroupingSelector.prototype = _underscore2.default.create(_GroupingSelector2.default.prototype, {
    init: function init(selectorId, selectedValues, isUGREnabled, isTZGEnabled, changesCallback) {
        this.UGREnabled = isUGREnabled;
        this.TZGEnabled = isTZGEnabled;

        _GroupingSelector2.default.prototype.init.call(this, selectorId, 2, selectedValues, changesCallback);

        return this;
    },

    fillListSelector: function fillListSelector(listSelector, level) {
        if (level > 0) {
            listSelector.addItems([{
                text: _messageResource2.default.getMessage("report.form.dont_use_2nd_grouping_level"),
                value: _constants.ReportGroupingLevel.NONE
            }]);
            listSelector.addSeparator();
        }
        listSelector.addItems([{
            text: _messageResource2.default.getMessage("report.common.users"),
            value: _constants.ReportGroupingLevel.USER
        }]);

        if (this.UGREnabled) {
            listSelector.addItems([{
                text: _messageResource2.default.getEscapedMessage("common.User_Groups"),
                value: _constants.ReportGroupingLevel.USER_GROUP
            }]);
        }

        if (this.TZGEnabled) {
            listSelector.addItems([{
                text: _messageResource2.default.getEscapedMessage("common.Time_Zone_Groups"),
                value: _constants.ReportGroupingLevel.TIME_ZONE_GROUP
            }]);
        }

        listSelector.addSeparator();

        listSelector.addItems([{ text: _messageResource2.default.getMessage("report.common.dates"), value: _constants.ReportGroupingLevel.DATE }, { text: _messageResource2.default.getMessage("report.common.weeks"), value: _constants.ReportGroupingLevel.WEEK }, { text: _messageResource2.default.getMessage("report.common.months"), value: _constants.ReportGroupingLevel.MONTH }]);
    },

    updateTree: function updateTree() {
        var secondShown = this.getListSelectorValue(1) !== _constants.ReportGroupingLevel.NONE;

        this.setRowClassName(1, secondShown ? "tree-row-A" : "tree-row-I");
    },

    validate: function validate() {
        if (!_GroupingSelector2.default.prototype.validate.call(this)) return false;

        return this.verifyDateGroupingOrderFroTwoLevels();
    }
});

/***/ }),
/* 2022 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _LeaveHTMLPreviewBalanceOnlyStrategy = __webpack_require__(2023);

var _LeaveHTMLPreviewBalanceOnlyStrategy2 = _interopRequireDefault(_LeaveHTMLPreviewBalanceOnlyStrategy);

var _LeaveReportConfig = __webpack_require__(129);

var _LeaveHTMLPreviewGroupingSection = __webpack_require__(2027);

var _LeaveHTMLPreviewGroupingSection2 = _interopRequireDefault(_LeaveHTMLPreviewGroupingSection);

var _LeaveHTMLPreviewHeaderSection = __webpack_require__(2028);

var _LeaveHTMLPreviewHeaderSection2 = _interopRequireDefault(_LeaveHTMLPreviewHeaderSection);

var _LeaveHTMLPreviewTimeOnlyStrategy = __webpack_require__(2029);

var _LeaveHTMLPreviewTimeOnlyStrategy2 = _interopRequireDefault(_LeaveHTMLPreviewTimeOnlyStrategy);

var _LeaveHTMLPreviewTimeAndBalanceStrategy = __webpack_require__(2030);

var _LeaveHTMLPreviewTimeAndBalanceStrategy2 = _interopRequireDefault(_LeaveHTMLPreviewTimeAndBalanceStrategy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /**
                                                                                                                                                           * Created by filatov on 16.09.2015.
                                                                                                                                                           */


var LeaveHTMLPreviewGenerator = function LeaveHTMLPreviewGenerator() {
    var _this = this;

    _classCallCheck(this, LeaveHTMLPreviewGenerator);

    this.generatePreviewTable = function (reportParameters) {
        var columnsStrategy = _this.createPreviewStrategy(reportParameters);

        var header = new _LeaveHTMLPreviewHeaderSection2.default().init(reportParameters.firstGroupingLevel, reportParameters.secondGroupingLevel, columnsStrategy);

        var dataGroupingSection = new _LeaveHTMLPreviewGroupingSection2.default().init(reportParameters.firstGroupingLevel, reportParameters.secondGroupingLevel, columnsStrategy);

        var table = document.createElement("table");
        table.className = "reportHtmlPreviewTable leave " + columnsStrategy.getStrategyCssClass();
        var tBody = document.createElement("tbody");
        table.appendChild(tBody);
        header.addRows(tBody);
        dataGroupingSection.addRows(tBody);

        return table;
    };

    this.createPreviewStrategy = function (reportParameters) {
        switch (reportParameters.columnsConfig) {
            case _LeaveReportConfig.LeaveTypeColumnConfig.LEAVE_TIME_ONLY:
                return new _LeaveHTMLPreviewTimeOnlyStrategy2.default().init(reportParameters.timeFormat);
            case _LeaveReportConfig.LeaveTypeColumnConfig.BALANCES_ONLY:
                return new _LeaveHTMLPreviewBalanceOnlyStrategy2.default().init(reportParameters.timeFormat, reportParameters.balanceQualifier);
            case _LeaveReportConfig.LeaveTypeColumnConfig.LEAVE_TIME_AND_BALANCES:
                return new _LeaveHTMLPreviewTimeAndBalanceStrategy2.default().init(reportParameters.timeFormat, reportParameters.balanceQualifier);
        }
    };
};

exports.default = LeaveHTMLPreviewGenerator;

/***/ }),
/* 2023 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = LeaveHTMLPreviewBalanceOnlyStrategy;

var _LeaveHTMLPreviewBaseStrategy = __webpack_require__(595);

var _LeaveHTMLPreviewBaseStrategy2 = _interopRequireDefault(_LeaveHTMLPreviewBaseStrategy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function LeaveHTMLPreviewBalanceOnlyStrategy() {} /**
                                                   * Created by filatov on 16.09.2015.
                                                   */


LeaveHTMLPreviewBalanceOnlyStrategy.prototype = new _LeaveHTMLPreviewBaseStrategy2.default();

LeaveHTMLPreviewBalanceOnlyStrategy.prototype.init = function (timeFormat, balanceQualifier) {
    _LeaveHTMLPreviewBaseStrategy2.default.prototype.init.call(this, timeFormat);

    this.balanceColumnsRender = this._initBalanceColumnsRenderConstructor(balanceQualifier, false);
    return this;
};

LeaveHTMLPreviewBalanceOnlyStrategy.prototype.addFirstHeaderRowCells = function (firstHeaderRow) {
    this.balanceColumnsRender.addHeaderFirstRowCells(firstHeaderRow);
};

LeaveHTMLPreviewBalanceOnlyStrategy.prototype.addSecondHeaderRowCells = function (secondHeaderRow) {
    this.balanceColumnsRender.addHeaderSecondRowCells(secondHeaderRow);
};

LeaveHTMLPreviewBalanceOnlyStrategy.prototype.getStrategyCssClass = function () {
    return "balanceOnly" + " " + this.balanceColumnsRender.getRenderSpecificCssClass();
};

LeaveHTMLPreviewBalanceOnlyStrategy.prototype.addDataCells = function (row) {
    this.balanceColumnsRender.addValueCells(row);
};

/***/ }),
/* 2024 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _LeaveHTMLPreviewBalanceColumnsRender = __webpack_require__(596);

var _LeaveHTMLPreviewBalanceColumnsRender2 = _interopRequireDefault(_LeaveHTMLPreviewBalanceColumnsRender);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LeaveHTMLPreviewBothBalanceColumnsRender = function (_LeaveHTMLPreviewBala) {
    _inherits(LeaveHTMLPreviewBothBalanceColumnsRender, _LeaveHTMLPreviewBala);

    function LeaveHTMLPreviewBothBalanceColumnsRender(withSpaces) {
        _classCallCheck(this, LeaveHTMLPreviewBothBalanceColumnsRender);

        var _this = _possibleConstructorReturn(this, (LeaveHTMLPreviewBothBalanceColumnsRender.__proto__ || Object.getPrototypeOf(LeaveHTMLPreviewBothBalanceColumnsRender)).call(this, withSpaces));

        _this.addHeaderFirstRowCells = function (fRow) {
            _this._addEmptyCellIfNeed(fRow);
            _this._addPTOFRowCells(fRow);
            _this._addEmptyCellIfNeed(fRow);
            _this._addSickDaysFRowCells(fRow);
        };

        _this.addHeaderSecondRowCells = function (sRow) {
            _this._addEmptyCellIfNeed(sRow);
            _this._addRangeSRowCells(_this.showPTOInHours, sRow);
            _this._addEmptyCellIfNeed(sRow);
            _this._addRangeSRowCells(_this.showSickInHours, sRow);
        };

        _this.addValueCells = function (row) {
            _this._addEmptyCellIfNeed(row);
            _this._addBalanceValueCell(row);
            _this._addBalanceValueCell(row);
            _this._addEmptyCellIfNeed(row);
            _this._addBalanceValueCell(row);
            _this._addBalanceValueCell(row);
        };

        _this.getRenderSpecificCssClass = function () {
            return "bothBalances";
        };

        return _this;
    }

    return LeaveHTMLPreviewBothBalanceColumnsRender;
}(_LeaveHTMLPreviewBalanceColumnsRender2.default);

exports.default = LeaveHTMLPreviewBothBalanceColumnsRender;

/***/ }),
/* 2025 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _LeaveHTMLPreviewBalanceColumnsRender = __webpack_require__(596);

var _LeaveHTMLPreviewBalanceColumnsRender2 = _interopRequireDefault(_LeaveHTMLPreviewBalanceColumnsRender);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LeaveHTMLPreviewSickDaysOnlyBalanceColumnsRender = function (_LeaveHTMLPreviewBala) {
    _inherits(LeaveHTMLPreviewSickDaysOnlyBalanceColumnsRender, _LeaveHTMLPreviewBala);

    function LeaveHTMLPreviewSickDaysOnlyBalanceColumnsRender(withSpaces) {
        _classCallCheck(this, LeaveHTMLPreviewSickDaysOnlyBalanceColumnsRender);

        var _this = _possibleConstructorReturn(this, (LeaveHTMLPreviewSickDaysOnlyBalanceColumnsRender.__proto__ || Object.getPrototypeOf(LeaveHTMLPreviewSickDaysOnlyBalanceColumnsRender)).call(this, withSpaces));

        _this.addHeaderFirstRowCells = function (fRow) {
            _this._addEmptyCellIfNeed(fRow);
            _this._addSickDaysFRowCells(fRow);
        };

        _this.addHeaderSecondRowCells = function (sRow) {
            _this._addEmptyCellIfNeed(sRow);
            _this._addRangeSRowCells(_this.showSickInHours, sRow);
        };

        _this.addValueCells = function (row) {
            _this._addEmptyCellIfNeed(row);
            _this._addBalanceValueCell(row);
            _this._addBalanceValueCell(row);
        };

        _this.getRenderSpecificCssClass = function () {
            return "oneBalance";
        };

        return _this;
    }

    return LeaveHTMLPreviewSickDaysOnlyBalanceColumnsRender;
}(_LeaveHTMLPreviewBalanceColumnsRender2.default);

exports.default = LeaveHTMLPreviewSickDaysOnlyBalanceColumnsRender;

/***/ }),
/* 2026 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _LeaveHTMLPreviewBalanceColumnsRender = __webpack_require__(596);

var _LeaveHTMLPreviewBalanceColumnsRender2 = _interopRequireDefault(_LeaveHTMLPreviewBalanceColumnsRender);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LeaveHTMLPreviewPTOOnlyBalanceColumnsRender = function (_LeaveHTMLPreviewBala) {
    _inherits(LeaveHTMLPreviewPTOOnlyBalanceColumnsRender, _LeaveHTMLPreviewBala);

    function LeaveHTMLPreviewPTOOnlyBalanceColumnsRender(withSpaces) {
        _classCallCheck(this, LeaveHTMLPreviewPTOOnlyBalanceColumnsRender);

        var _this = _possibleConstructorReturn(this, (LeaveHTMLPreviewPTOOnlyBalanceColumnsRender.__proto__ || Object.getPrototypeOf(LeaveHTMLPreviewPTOOnlyBalanceColumnsRender)).call(this, withSpaces));

        _this.addHeaderFirstRowCells = function (fRow) {
            _this._addEmptyCellIfNeed(fRow);
            _this._addPTOFRowCells(fRow);
        };

        _this.addHeaderSecondRowCells = function (sRow) {
            _this._addEmptyCellIfNeed(sRow);
            _this._addRangeSRowCells(_this.showPTOInHours, sRow);
        };

        _this.addValueCells = function (row) {
            _this._addEmptyCellIfNeed(row);
            _this._addBalanceValueCell(row);
            _this._addBalanceValueCell(row);
        };

        _this.getRenderSpecificCssClass = function () {
            return "oneBalance";
        };

        return _this;
    }

    return LeaveHTMLPreviewPTOOnlyBalanceColumnsRender;
}(_LeaveHTMLPreviewBalanceColumnsRender2.default);

exports.default = LeaveHTMLPreviewPTOOnlyBalanceColumnsRender;

/***/ }),
/* 2027 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = LeaveHTMLPreviewGroupingSection;

var _LeaveHTMLPreviewBaseSection = __webpack_require__(985);

var _LeaveHTMLPreviewBaseSection2 = _interopRequireDefault(_LeaveHTMLPreviewBaseSection);

var _constants = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function LeaveHTMLPreviewGroupingSection() {}

LeaveHTMLPreviewGroupingSection.prototype = new _LeaveHTMLPreviewBaseSection2.default();

LeaveHTMLPreviewGroupingSection.prototype.init = function (firstGroupingLevel, secondGroupingLevel, columnsStrategy) {
    _LeaveHTMLPreviewBaseSection2.default.prototype.init.call(this, columnsStrategy);

    this.firstGroupingLevel = firstGroupingLevel;
    this.secondGroupingLevel = secondGroupingLevel;
    return this;
};

LeaveHTMLPreviewGroupingSection.prototype.addRows = function (tBody) {
    this.addRow(tBody, this.makeGroupingTotalRow());

    var countRows = 5;
    var numberRow = 0;

    while (true) {
        this.addFirstGroupingRow(tBody);
        numberRow++;
        if (numberRow >= countRows) break;

        if (this.secondGroupingLevel !== _constants.ReportGroupingLevel.NONE) {
            this.addSecondGroupingRow(tBody);
            numberRow++;
            if (numberRow >= countRows) break;

            if (ReportPreviewUtils.isLevelCanBeAddedMoreThanOnce(this.secondGroupingLevel, [this.firstGroupingLevel])) {
                this.addSecondGroupingRow(tBody);
                numberRow++;
                if (numberRow >= countRows) break;
            }
        }
    }
};

LeaveHTMLPreviewGroupingSection.prototype.makeGroupingTotalRow = function () {
    return this.createRowWithMainAndDataCells("groupingTotal", this.message("report.total"), "groupingTotalCell");
};

LeaveHTMLPreviewGroupingSection.prototype.addFirstGroupingRow = function (tBody) {
    this.addRow(tBody, this.makeGroupingRow("firstGrouping", "firstLevel", this.firstGroupingLevel));
};

LeaveHTMLPreviewGroupingSection.prototype.addSecondGroupingRow = function (tBody) {
    this.addRow(tBody, this.makeGroupingRow("secondGrouping", "secondLevel", this.secondGroupingLevel));
};

LeaveHTMLPreviewGroupingSection.prototype.makeGroupingRow = function (rowClassName, cellClassName, groupingLevel) {
    return this.createRowWithMainAndDataCells(rowClassName, ReportPreviewUtils.getLevelPreviewName(groupingLevel), cellClassName);
};

/***/ }),
/* 2028 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = LeaveHTMLPreviewHeaderSection;

var _LeaveHTMLPreviewBaseSection = __webpack_require__(985);

var _LeaveHTMLPreviewBaseSection2 = _interopRequireDefault(_LeaveHTMLPreviewBaseSection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function LeaveHTMLPreviewHeaderSection() {}

LeaveHTMLPreviewHeaderSection.prototype = new _LeaveHTMLPreviewBaseSection2.default();

LeaveHTMLPreviewHeaderSection.prototype.init = function (firstGroupingLevel, secondGroupingLevel, columnsStrategy) {
    _LeaveHTMLPreviewBaseSection2.default.prototype.init.call(this, columnsStrategy);

    this.firstGroupingLevel = firstGroupingLevel;
    this.secondGroupingLevel = secondGroupingLevel;
    return this;
};

LeaveHTMLPreviewHeaderSection.prototype.addRows = function (tBody) {
    var fRow = this.createRow("headerRow firstRow");
    this.addCell(fRow, ReportPreviewUtils.makeGroupingHeader([this.firstGroupingLevel, this.secondGroupingLevel]), "groupingLevelsTitle", 1, 2);

    this.columnsStrategy.addFirstHeaderRowCells(fRow);
    this.addRow(tBody, fRow);
    var sRow = this.createRow("headerRow secondRow");
    this.columnsStrategy.addSecondHeaderRowCells(sRow);
    this.addRow(tBody, sRow);
};

/***/ }),
/* 2029 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = LeaveHTMLPreviewTimeOnlyStrategy;

var _LeaveHTMLPreviewBaseStrategy = __webpack_require__(595);

var _LeaveHTMLPreviewBaseStrategy2 = _interopRequireDefault(_LeaveHTMLPreviewBaseStrategy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function LeaveHTMLPreviewTimeOnlyStrategy() {} /**
                                                * Created by filatov on 16.09.2015.
                                                */


LeaveHTMLPreviewTimeOnlyStrategy.prototype = new _LeaveHTMLPreviewBaseStrategy2.default();

LeaveHTMLPreviewTimeOnlyStrategy.prototype.init = function (timeFormat) {
    _LeaveHTMLPreviewBaseStrategy2.default.prototype.init.call(this, timeFormat);
    return this;
};

LeaveHTMLPreviewTimeOnlyStrategy.prototype.addFirstHeaderRowCells = function (firstHeaderRow) {
    this.addCreatedCell(firstHeaderRow, this.createTotalLeaveTimeCell());
    this.addCreatedCell(firstHeaderRow, this.createLeaveHeaderCell());
    this.addCreatedCell(firstHeaderRow, this.createLeaveHeaderCell());
    this.addCreatedCell(firstHeaderRow, this.createLeaveHeaderCell());
};

LeaveHTMLPreviewTimeOnlyStrategy.prototype.addDataCells = function (row) {
    this.addTimeValueCell(row);
    this.addTimeValueCell(row);
    this.addTimeValueCell(row);
    this.addTimeValueCell(row);
};

LeaveHTMLPreviewTimeOnlyStrategy.prototype.getStrategyCssClass = function () {
    return "leaveTimeOnly";
};

/***/ }),
/* 2030 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = LeaveHTMLPreviewTimeAndBalanceOnlyStrategy;

var _LeaveHTMLPreviewBaseStrategy = __webpack_require__(595);

var _LeaveHTMLPreviewBaseStrategy2 = _interopRequireDefault(_LeaveHTMLPreviewBaseStrategy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function LeaveHTMLPreviewTimeAndBalanceOnlyStrategy() {} /**
                                                          * Created by filatov on 16.09.2015.
                                                          */


LeaveHTMLPreviewTimeAndBalanceOnlyStrategy.prototype = new _LeaveHTMLPreviewBaseStrategy2.default();

LeaveHTMLPreviewTimeAndBalanceOnlyStrategy.prototype.init = function (timeFormat, balanceQualifier) {
    _LeaveHTMLPreviewBaseStrategy2.default.prototype.init.call(this, timeFormat);

    this.balanceColumnsRender = this._initBalanceColumnsRenderConstructor(balanceQualifier, true);
    return this;
};

LeaveHTMLPreviewTimeAndBalanceOnlyStrategy.prototype.addFirstHeaderRowCells = function (firstHeaderRow) {
    this.addCreatedCell(firstHeaderRow, this.createTotalLeaveTimeCell());
    this.addCreatedCell(firstHeaderRow, this.createLeaveHeaderCell());
    this.addCreatedCell(firstHeaderRow, this.createLeaveHeaderCell());
    this.balanceColumnsRender.addHeaderFirstRowCells(firstHeaderRow);
};

LeaveHTMLPreviewTimeAndBalanceOnlyStrategy.prototype.addSecondHeaderRowCells = function (secondHeaderRow) {
    this.balanceColumnsRender.addHeaderSecondRowCells(secondHeaderRow);
};

LeaveHTMLPreviewTimeAndBalanceOnlyStrategy.prototype.getStrategyCssClass = function () {
    return "timeAndBalance" + " " + this.balanceColumnsRender.getRenderSpecificCssClass();
};

LeaveHTMLPreviewTimeAndBalanceOnlyStrategy.prototype.addDataCells = function (row) {
    this.addTimeValueCell(row);
    this.addTimeValueCell(row);
    this.addTimeValueCell(row);
    this.balanceColumnsRender.addValueCells(row);
};

/***/ }),
/* 2031 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = LeaveCSVPreviewGenerator;

var _LeaveCSVPreviewHeader = __webpack_require__(2032);

var _LeaveCSVPreviewHeader2 = _interopRequireDefault(_LeaveCSVPreviewHeader);

var _constants = __webpack_require__(11);

var _LeaveReportConfig = __webpack_require__(129);

var _LeaveCSVPreviewGroupingSection = __webpack_require__(2033);

var _LeaveCSVPreviewGroupingSection2 = _interopRequireDefault(_LeaveCSVPreviewGroupingSection);

var _CSVParametersBuilder = __webpack_require__(150);

var _CSVParametersBuilder2 = _interopRequireDefault(_CSVParametersBuilder);

var _CSVParametersSection = __webpack_require__(170);

var _CSVParametersSection2 = _interopRequireDefault(_CSVParametersSection);

var _LeaveCSVPreviewTimeAndBalancesStrategy = __webpack_require__(2034);

var _LeaveCSVPreviewTimeAndBalancesStrategy2 = _interopRequireDefault(_LeaveCSVPreviewTimeAndBalancesStrategy);

var _LeaveCSVPreviewBalancesOnlyStrategy = __webpack_require__(2035);

var _LeaveCSVPreviewBalancesOnlyStrategy2 = _interopRequireDefault(_LeaveCSVPreviewBalancesOnlyStrategy);

var _LeaveCSVPreviewTimeOnlyStrategy = __webpack_require__(2036);

var _LeaveCSVPreviewTimeOnlyStrategy2 = _interopRequireDefault(_LeaveCSVPreviewTimeOnlyStrategy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function LeaveCSVPreviewGenerator() {}
LeaveCSVPreviewGenerator.prototype.init = function () {
    return this;
};

LeaveCSVPreviewGenerator.NUM_OF_DATA_COLUMNS = 10; // (o/u reported by user, o/u auto calculated, working time, leave time)

LeaveCSVPreviewGenerator.prototype.generatePreviewTable = function (reportParameters, reportParamsStringBuilder) {

    var numOfGroupingColumns = ReportPreviewUtils.countNotEmptyLevels([reportParameters.firstGroupingLevel, reportParameters.secondGroupingLevel]);
    var columnsStrategy = this.createPreviewStrategy(reportParameters);
    var totalColumnsNum = numOfGroupingColumns + columnsStrategy.getNumOfDataColumns();
    var header = new _LeaveCSVPreviewHeader2.default().init(reportParameters.firstGroupingLevel, reportParameters.secondGroupingLevel, columnsStrategy, numOfGroupingColumns, reportParameters.columnsConfig);

    var dataGroupingSection = new _LeaveCSVPreviewGroupingSection2.default().init(reportParameters.firstGroupingLevel, reportParameters.secondGroupingLevel, columnsStrategy, numOfGroupingColumns, columnsStrategy.getNumOfDataColumns());

    var table = document.createElement("table");
    table.className = "reportCsvPreviewTable leave";
    var tBody = document.createElement("tbody");
    table.appendChild(tBody);

    ReportPreviewUtils.addSheetHeaderRow(tBody, totalColumnsNum);

    var paramsBuilder = new _CSVParametersBuilder2.default().init();
    paramsBuilder.addDateRangeParam(reportParameters.dateRangeSelection, reportParamsStringBuilder);
    paramsBuilder.addUsersParam(reportParameters.userSelection, reportParamsStringBuilder);
    paramsBuilder.addLeavesParam(reportParameters.leaveTypeSelection, reportParamsStringBuilder);

    var parametersSection = new _CSVParametersSection2.default().init(paramsBuilder, totalColumnsNum);

    parametersSection.addRows(tBody);
    header.addRows(tBody);
    dataGroupingSection.addRows(tBody);
    return table;
};

LeaveCSVPreviewGenerator.prototype.createPreviewStrategy = function (reportParameters) {
    switch (reportParameters.columnsConfig) {
        case _LeaveReportConfig.LeaveTypeColumnConfig.LEAVE_TIME_ONLY:
            return new _LeaveCSVPreviewTimeOnlyStrategy2.default().init();
            break;
        case _LeaveReportConfig.LeaveTypeColumnConfig.BALANCES_ONLY:
            return new _LeaveCSVPreviewBalancesOnlyStrategy2.default().init(reportParameters.balanceQualifier);
            break;
        case _LeaveReportConfig.LeaveTypeColumnConfig.LEAVE_TIME_AND_BALANCES:
            return new _LeaveCSVPreviewTimeAndBalancesStrategy2.default().init(reportParameters.balanceQualifier);
            break;
    }
};

/***/ }),
/* 2032 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = LeaveCSVPreviewHeader;

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _constants = __webpack_require__(11);

var _CSVPreviewSection = __webpack_require__(43);

var _CSVPreviewSection2 = _interopRequireDefault(_CSVPreviewSection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function LeaveCSVPreviewHeader() {}

LeaveCSVPreviewHeader.prototype = new _CSVPreviewSection2.default();

LeaveCSVPreviewHeader.prototype.init = function (firstGroupingLevel, secondGroupingLevel, columnsStrategy, numOfGroupingRows, columnsConfig) {
    _CSVPreviewSection2.default.prototype.init.call(this);
    this.firstGroupingLevel = firstGroupingLevel;
    this.secondGroupingLevel = secondGroupingLevel;
    this.columnsStrategy = columnsStrategy;
    this.numOfGroupingRows = numOfGroupingRows;
    this.columnsConfig = columnsConfig;
    return this;
};

LeaveCSVPreviewHeader.prototype.addRows = function (tBody) {
    var mainHeaderRow = this.createRow();
    (0, _jquery2.default)(mainHeaderRow).addClass("headerGroupingRow");
    ReportPreviewUtils.addCell(mainHeaderRow, ReportPreviewUtils.getLevelPreviewName(this.firstGroupingLevel));
    if (this.secondGroupingLevel !== _constants.ReportGroupingLevel.NONE) {
        ReportPreviewUtils.addCell(mainHeaderRow, ReportPreviewUtils.getLevelPreviewName(this.secondGroupingLevel));
    }

    this.columnsStrategy.addMainHeaderRowCells(mainHeaderRow);
    this.addRow(tBody, mainHeaderRow);
};

/***/ }),
/* 2033 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = LeaveCSVPreviewGroupingSection;

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _CSVPreviewSection = __webpack_require__(43);

var _CSVPreviewSection2 = _interopRequireDefault(_CSVPreviewSection);

var _constants = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function LeaveCSVPreviewGroupingSection() {}

LeaveCSVPreviewGroupingSection.prototype = new _CSVPreviewSection2.default();

LeaveCSVPreviewGroupingSection.prototype.rowsUsersWithMI = [1, 2];

LeaveCSVPreviewGroupingSection.prototype.init = function (firstGroupingLevel, secondGroupingLevel, columnsStrategy, numOfGroupingRows, numOfDataColumns) {
    _CSVPreviewSection2.default.prototype.init.call(this);
    this.firstGroupingLevel = firstGroupingLevel;
    this.secondGroupingLevel = secondGroupingLevel;
    this.columnsStrategy = columnsStrategy;
    this.numOfGroupingRows = numOfGroupingRows;
    this.numOfDataColumns = numOfDataColumns;
    return this;
};

LeaveCSVPreviewGroupingSection.prototype.addRows = function (tBody) {
    for (var i = 0; i < 6; i++) {
        var row = this.createRow();
        ReportPreviewUtils.addCell(row, ReportPreviewUtils.getLevelPreviewName(this.firstGroupingLevel));
        if (this.secondGroupingLevel !== _constants.ReportGroupingLevel.NONE) ReportPreviewUtils.addCell(row, ReportPreviewUtils.getLevelPreviewName(this.secondGroupingLevel));
        for (var j = 0; j < this.numOfDataColumns; j++) {
            this.addTimeValueCell(row);
        }this.addRow(tBody, row);
    }
};

/***/ }),
/* 2034 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = LeaveCSVPreviewTimeAndBalancesStrategy;

var _LeaveCSVPreviewBalanceColumnsRender = __webpack_require__(986);

var _LeaveCSVPreviewBalanceColumnsRender2 = _interopRequireDefault(_LeaveCSVPreviewBalanceColumnsRender);

var _LeaveCSVPreviewColumnsStrategy = __webpack_require__(597);

var _LeaveCSVPreviewColumnsStrategy2 = _interopRequireDefault(_LeaveCSVPreviewColumnsStrategy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Created by filatov on 15.09.2015.
 */
function LeaveCSVPreviewTimeAndBalancesStrategy() {}

LeaveCSVPreviewTimeAndBalancesStrategy.prototype = new _LeaveCSVPreviewColumnsStrategy2.default();

LeaveCSVPreviewTimeAndBalancesStrategy.prototype.init = function (balanceQualifier) {
    _LeaveCSVPreviewColumnsStrategy2.default.prototype.init.call(this);
    this.balanceColumnsRender = new _LeaveCSVPreviewBalanceColumnsRender2.default().init(balanceQualifier);

    return this;
};

LeaveCSVPreviewTimeAndBalancesStrategy.prototype.getNumOfDataColumns = function () {
    return 2 + this.balanceColumnsRender.getNumberOfDataBalancesCells();
};

LeaveCSVPreviewTimeAndBalancesStrategy.prototype.addMainHeaderRowCells = function (mainHeaderRow) {
    this.addLeaveTypeTotalCell(mainHeaderRow);
    this.addLeaveTypeCell(mainHeaderRow);
    this.balanceColumnsRender.addHeaderBalancesCells(mainHeaderRow);
};

/***/ }),
/* 2035 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = LeaveCSVPreviewBalancesOnlyStrategy;

var _LeaveCSVPreviewColumnsStrategy = __webpack_require__(597);

var _LeaveCSVPreviewColumnsStrategy2 = _interopRequireDefault(_LeaveCSVPreviewColumnsStrategy);

var _LeaveCSVPreviewBalanceColumnsRender = __webpack_require__(986);

var _LeaveCSVPreviewBalanceColumnsRender2 = _interopRequireDefault(_LeaveCSVPreviewBalanceColumnsRender);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Created by filatov on 15.09.2015.
 */
function LeaveCSVPreviewBalancesOnlyStrategy() {}

LeaveCSVPreviewBalancesOnlyStrategy.prototype = new _LeaveCSVPreviewColumnsStrategy2.default();

LeaveCSVPreviewBalancesOnlyStrategy.prototype.init = function (balanceQualifier) {
    _LeaveCSVPreviewColumnsStrategy2.default.prototype.init.call(this);

    this.balanceColumnsRender = new _LeaveCSVPreviewBalanceColumnsRender2.default().init(balanceQualifier);
    return this;
};

LeaveCSVPreviewBalancesOnlyStrategy.prototype.getNumOfDataColumns = function () {
    return this.balanceColumnsRender.getNumberOfDataBalancesCells();
};

LeaveCSVPreviewBalancesOnlyStrategy.prototype.addMainHeaderRowCells = function (mainHeaderRow) {
    this.balanceColumnsRender.addHeaderBalancesCells(mainHeaderRow);
};

/***/ }),
/* 2036 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = LeaveCSVPreviewLeaveTimeOnlyStrategy;

var _LeaveCSVPreviewColumnsStrategy = __webpack_require__(597);

var _LeaveCSVPreviewColumnsStrategy2 = _interopRequireDefault(_LeaveCSVPreviewColumnsStrategy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function LeaveCSVPreviewLeaveTimeOnlyStrategy() {}

LeaveCSVPreviewLeaveTimeOnlyStrategy.prototype = new _LeaveCSVPreviewColumnsStrategy2.default();

LeaveCSVPreviewLeaveTimeOnlyStrategy.prototype.init = function () {
    _LeaveCSVPreviewColumnsStrategy2.default.prototype.init.call(this);
    return this;
};

LeaveCSVPreviewLeaveTimeOnlyStrategy.prototype.getNumOfDataColumns = function () {
    return 4;
};

LeaveCSVPreviewLeaveTimeOnlyStrategy.prototype.addMainHeaderRowCells = function (mainHeaderRow) {
    this.addLeaveTypeTotalCell(mainHeaderRow);
    this.addLeaveTypeCells(mainHeaderRow, this.getNumOfDataColumns() - 1);
};

/***/ }),
/* 2037 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = EstimatedVsActualFormMediator;

var _BaseFormMediator = __webpack_require__(269);

var _BaseFormMediator2 = _interopRequireDefault(_BaseFormMediator);

var _BudgetedVsActualEditFormConfigController = __webpack_require__(2038);

var _BudgetedVsActualEditFormConfigController2 = _interopRequireDefault(_BudgetedVsActualEditFormConfigController);

var _EstimateVsActualHTMLPreviewGenerator = __webpack_require__(2039);

var _EstimateVsActualHTMLPreviewGenerator2 = _interopRequireDefault(_EstimateVsActualHTMLPreviewGenerator);

var _EstimateVsActualCSVPreviewGenerator = __webpack_require__(2044);

var _EstimateVsActualCSVPreviewGenerator2 = _interopRequireDefault(_EstimateVsActualCSVPreviewGenerator);

var _constants = __webpack_require__(11);

var _ATReportParamsStringBuilder = __webpack_require__(52);

var _ATReportParamsStringBuilder2 = _interopRequireDefault(_ATReportParamsStringBuilder);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @author evdokimov
 */
function EstimatedVsActualFormMediator() {}

EstimatedVsActualFormMediator.prototype = new _BaseFormMediator2.default();

EstimatedVsActualFormMediator.prototype.init = function (config) {
    _BaseFormMediator2.default.prototype.init.call(this, config);

    ATReportsStore.setCPList(config.cpList);

    return this;
};

EstimatedVsActualFormMediator.prototype.initEditConfigController = function (config) {
    var _this = this;

    return new _BudgetedVsActualEditFormConfigController2.default().init({
        panelId: "mainContainer",
        reportParameters: config.reportParameters,
        cpList: config.cpList,
        customersWithMaIds: config.customersWithMaIds,
        projectsWithMaIds: config.projectsWithMaIds,
        changeCallback: function changeCallback() {
            return _this.changeParametersCallback();
        },
        reportAuthorizationInfo: config.reportAuthorizationInfo
    });
};

EstimatedVsActualFormMediator.prototype.createDateRangeSelector = function (reportParameters) {
    var dateRangeSelectorConfig = {
        dateRangeSelection: reportParameters.dateSelection,
        menuStates: new DateRangeMenuItemsUtil().createDefaultSingleDateMenuItems(),
        shortDateFormat: true
    };

    return new SingleDateSelectorController().init(dateRangeSelectorConfig);
};

EstimatedVsActualFormMediator.prototype.initParamsStringBuilder = function (config) {
    return new _ATReportParamsStringBuilder2.default({
        data: {
            cpList: config.cpList,
            manageableUserIds: ATReportsStore.getManageableUserIds(),
            projectsWithMaIds: ATReportsStore.getProjectsWithMaIds()
        },
        reportAuthorizationInfo: ATReportsStore.getReportAuthorizationInfo()
    });
};

EstimatedVsActualFormMediator.prototype.fillDateSelection = function (reportParametersObject) {
    reportParametersObject.dateSelection = this.dateRangeSelector.getSelectedRange();
};

EstimatedVsActualFormMediator.prototype.initCsvGenerator = function () {
    return new _EstimateVsActualCSVPreviewGenerator2.default().init();
};

EstimatedVsActualFormMediator.prototype.initHtmlGenerator = function () {
    return new _EstimateVsActualHTMLPreviewGenerator2.default().init();
};

EstimatedVsActualFormMediator.prototype.exportToCSV = function () {
    var reportParams = this.collectReportParameters();

    var successMethod = function successMethod(result) {
        var info = {};
        var groupingLevels = EVAReport.ConvertUtils.getGroupingLevels(reportParams);
        var groupingLevelsCollapsed = EVAReport.ConvertUtils.getGroupingLevelsCollapsed(groupingLevels);
        for (var i = 0; i < result["groupingLevelsInfoLists"].length; ++i) {
            info[groupingLevelsCollapsed[i]] = result["groupingLevelsInfoLists"][i];
        }

        var customersMap = _.extend(arrayToMapById(ATReportsStore.getCPList().customers), arrayToMapById(info[_constants.ReportGroupingLevel.CUSTOMER]));
        var projectMap = _.extend(arrayToMapById(ATReportsStore.getCPList().projects), arrayToMapById(info[_constants.ReportGroupingLevel.PROJECT]));
        var projectNamesMap = arrayToMapById(info[_constants.ReportGroupingLevel.PROJECT_NAME]);
        var tasksMap = arrayToMapById(info[_constants.ReportGroupingLevel.TASK]);
        var taskNamesMap = arrayToMapById(info[_constants.ReportGroupingLevel.TASK_NAME]);
        var typesOfWorkMap = arrayToMapById(info[_constants.ReportGroupingLevel.BILLING_TYPE]);
        var usersMap = arrayToMapById(info[_constants.ReportGroupingLevel.USER]);

        return new EVACSVJsonConverter().init(customersMap, projectMap, tasksMap, usersMap, projectNamesMap, taskNamesMap, typesOfWorkMap, null, EVAReport.FormatUtils.makeGroupingPresentationFlags(groupingLevels));
    };

    var serviceParams = [{
        qualifier: reportParams.dateSelection.qualifier,
        date: reportParams.dateSelection.date.toJSON()
    }, EVAReport.ConvertUtils.getGroupingLevels(reportParams), reportParams.customersProjectsSelection, reportParams.tasksConfig, reportParams.includeNotStarted, reportParams.includeNotEstimated];

    this._exportToCSV(reportParams, successMethod, "EvAReportService.getReport", serviceParams);
};

/***/ }),
/* 2038 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _constants = __webpack_require__(11);

var _BudgetedVsActualReportEditConfigController = __webpack_require__(981);

var _BudgetedVsActualReportEditConfigController2 = _interopRequireDefault(_BudgetedVsActualReportEditConfigController);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BudgetedVsActualEditFormConfigController = function (_BudgetedVsActualRepo) {
    _inherits(BudgetedVsActualEditFormConfigController, _BudgetedVsActualRepo);

    function BudgetedVsActualEditFormConfigController() {
        _classCallCheck(this, BudgetedVsActualEditFormConfigController);

        return _possibleConstructorReturn(this, (BudgetedVsActualEditFormConfigController.__proto__ || Object.getPrototypeOf(BudgetedVsActualEditFormConfigController)).apply(this, arguments));
    }

    return BudgetedVsActualEditFormConfigController;
}(_BudgetedVsActualReportEditConfigController2.default);

exports.default = BudgetedVsActualEditFormConfigController;


BudgetedVsActualEditFormConfigController.prototype.makeReportParamsAccordingToFeatures = function (reportParameters) {
    var result = _jquery2.default.extend({}, reportParameters);

    if (!EnabledFeatures.BTY) {
        var groupings = this.makeGroupingSelectorValuesAccordingToNotAvailableValueLevel(_constants.ReportGroupingLevel.BILLING_TYPE, [result.firstGroupingLevel, result.secondGroupingLevel, result.thirdGroupingLevel], _constants.ReportGroupingLevel.CUSTOMER);
        result.firstGroupingLevel = groupings[0];
        result.secondGroupingLevel = groupings[1];
        result.thirdGroupingLevel = groupings[2];
    }
    return result;
};

/***/ }),
/* 2039 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = EstimateVsActualHTMLPreviewGenerator;

var _EstimatedTasksEvAHTMLPreviewStrategy = __webpack_require__(2040);

var _EstimatedTasksEvAHTMLPreviewStrategy2 = _interopRequireDefault(_EstimatedTasksEvAHTMLPreviewStrategy);

var _AllTasksEvAHTMLPreviewStrategy = __webpack_require__(2041);

var _AllTasksEvAHTMLPreviewStrategy2 = _interopRequireDefault(_AllTasksEvAHTMLPreviewStrategy);

var _constants = __webpack_require__(11);

var _EstimateVsActualHTMLPreviewHeaderSection = __webpack_require__(2042);

var _EstimateVsActualHTMLPreviewHeaderSection2 = _interopRequireDefault(_EstimateVsActualHTMLPreviewHeaderSection);

var _EstimateVsActualHTMLPreviewGroupingSection = __webpack_require__(2043);

var _EstimateVsActualHTMLPreviewGroupingSection2 = _interopRequireDefault(_EstimateVsActualHTMLPreviewGroupingSection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function EstimateVsActualHTMLPreviewGenerator() {}

EstimateVsActualHTMLPreviewGenerator.prototype.init = function () {
    return this;
};

EstimateVsActualHTMLPreviewGenerator.prototype.generatePreviewTable = function (reportParameters) {
    var table = document.createElement("table");
    var tBody = document.createElement("tbody");
    table.appendChild(tBody);

    var groupingLevelsArray = [reportParameters.firstGroupingLevel, reportParameters.secondGroupingLevel, reportParameters.thirdGroupingLevel, reportParameters.fourthGroupingLevel];

    var filteredLevelsArray = ReportPreviewUtils.filterNotEmptyLevels(groupingLevelsArray);
    var columnsStrategy = this.createPreviewStrategy(reportParameters);

    var headerSection = new _EstimateVsActualHTMLPreviewHeaderSection2.default().init(filteredLevelsArray, columnsStrategy);

    var reportAuthorizationInfo = reportParameters.reportAuthorizationInfo;
    var groupingSection = new _EstimateVsActualHTMLPreviewGroupingSection2.default().init(filteredLevelsArray, reportParameters.fourthGroupingLevel !== _constants.ReportGroupingLevel.NONE, columnsStrategy, reportParameters.timeFormat, reportAuthorizationInfo);

    headerSection.addRows(tBody);
    groupingSection.addRows(tBody);

    table.className = "reportHtmlPreviewTable eva " + columnsStrategy.getTableClass();

    return table;
};

EstimateVsActualHTMLPreviewGenerator.prototype.createPreviewStrategy = function (reportParameters) {
    if (reportParameters.includeNotEstimated) return new _AllTasksEvAHTMLPreviewStrategy2.default().init(reportParameters.timeFormat);

    return new _EstimatedTasksEvAHTMLPreviewStrategy2.default().init(reportParameters.timeFormat);
};

/***/ }),
/* 2040 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = EstimatedTasksEvAHTMLPreviewStrategy;

var _BaseTasksEvAHTMLPreviewStrategy = __webpack_require__(987);

var _BaseTasksEvAHTMLPreviewStrategy2 = _interopRequireDefault(_BaseTasksEvAHTMLPreviewStrategy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function EstimatedTasksEvAHTMLPreviewStrategy() {}

EstimatedTasksEvAHTMLPreviewStrategy.prototype = new _BaseTasksEvAHTMLPreviewStrategy2.default();

EstimatedTasksEvAHTMLPreviewStrategy.prototype.init = function (timeFormat) {
    _BaseTasksEvAHTMLPreviewStrategy2.default.prototype.init.call(this, timeFormat);
    return this;
};

EstimatedTasksEvAHTMLPreviewStrategy.prototype.getTableClass = function () {
    return "";
};

EstimatedTasksEvAHTMLPreviewStrategy.prototype.getColumnsNumber = function () {
    return 3;
};

EstimatedTasksEvAHTMLPreviewStrategy.prototype.addFirstHeaderRowCells = function (row) {
    this.addCell(row, this.message("report.budgeted_vs_actual.spent_time"), "spentTime", 1, 3);
    this.addCell(row, this.message("report.budgeted_vs_actual.estimated_time"), "estimatedTime", 1, 3);
    this.addCell(row, this.message("report.budgeted_vs_actual.variance.description"), "varianceDescr", 2, 1);
};

EstimatedTasksEvAHTMLPreviewStrategy.prototype.addSecondHeaderRowCells = function (row) {
    this.addCell(row, this.message("report.budgeted_vs_actual.variance.mh"), "varianceMh", 1, 2);
    this.addCell(row, this.message("report.budgeted_vs_actual.variance.percent"), "variancePercent", 1, 2);
};

/***/ }),
/* 2041 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = AllTasksEvAHTMLPreviewStrategy;

var _BaseTasksEvAHTMLPreviewStrategy = __webpack_require__(987);

var _BaseTasksEvAHTMLPreviewStrategy2 = _interopRequireDefault(_BaseTasksEvAHTMLPreviewStrategy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function AllTasksEvAHTMLPreviewStrategy() {}

AllTasksEvAHTMLPreviewStrategy.prototype = new _BaseTasksEvAHTMLPreviewStrategy2.default();

AllTasksEvAHTMLPreviewStrategy.prototype.init = function (timeFormat) {
    _BaseTasksEvAHTMLPreviewStrategy2.default.prototype.init.call(this, timeFormat);
    return this;
};

AllTasksEvAHTMLPreviewStrategy.prototype.getTableClass = function () {
    return "withThirdLvl";
};

AllTasksEvAHTMLPreviewStrategy.prototype.getColumnsNumber = function () {
    return 5;
};

AllTasksEvAHTMLPreviewStrategy.prototype.addFirstHeaderRowCells = function (row) {
    this.addCell(row, this.message("report.budgeted_vs_actual.spent_time.total"), "totalSpentTime", 1, 3);
    this.addCell(row, this.message("report.budgeted_vs_actual.spent_time.nonbudgeted"), "timeForNotEst", 1, 3);
    this.addCell(row, this.message("report.budgeted_vs_actual.estimated_time"), "estimatedGrTime", 4, 1);
};

AllTasksEvAHTMLPreviewStrategy.prototype.addSecondHeaderRowCells = function (row) {
    this.addCell(row, this.message("report.budgeted_vs_actual.spent_time"), "subSpentTime", 1, 2);
    this.addCell(row, this.message("report.budgeted_vs_actual.estimated_time"), "estTime", 1, 2);
    this.addCell(row, this.message("report.budgeted_vs_actual.variance"), "variance", 2, 1);
};

AllTasksEvAHTMLPreviewStrategy.prototype.addThirdHeaderRowCells = function (row) {
    this.addCell(row, this.message("report.budgeted_vs_actual.variance.mh"), "estTimeVarianceMh");
    this.addCell(row, this.message("report.budgeted_vs_actual.variance.percent"), "estTimeVariancePercent");
};

/***/ }),
/* 2042 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = EstimateVsActualHTMLPreviewHeaderSection;

var _PreviewSection = __webpack_require__(67);

var _PreviewSection2 = _interopRequireDefault(_PreviewSection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function EstimateVsActualHTMLPreviewHeaderSection() {}

EstimateVsActualHTMLPreviewHeaderSection.prototype = new _PreviewSection2.default();

EstimateVsActualHTMLPreviewHeaderSection.prototype.init = function (groupingLevelsArray, columnsStrategy) {
    _PreviewSection2.default.prototype.init.call(this);
    this.groupingLevelsArray = groupingLevelsArray;
    this.columnsStrategy = columnsStrategy;

    return this;
};

EstimateVsActualHTMLPreviewHeaderSection.prototype.addRows = function (tBody) {
    var row1 = this.createRow("headerRow firstHeaderRow");
    this.addCell(row1, ReportPreviewUtils.makeGroupingHeader(this.groupingLevelsArray), "groupingLevelsTitle", 1, 3);
    this.columnsStrategy.addFirstHeaderRowCells(row1);
    this.addRow(tBody, row1);

    var row2 = this.createRow("headerRow secondHeaderRow");
    this.columnsStrategy.addSecondHeaderRowCells(row2);
    this.addRow(tBody, row2);

    var row3 = this.createRow("headerRow thirdHeaderRow");
    this.columnsStrategy.addThirdHeaderRowCells(row3);
    this.addRow(tBody, row3);
};

/***/ }),
/* 2043 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = EstimateVsActualHTMLPreviewGroupingSection;

var _PreviewSection = __webpack_require__(67);

var _PreviewSection2 = _interopRequireDefault(_PreviewSection);

var _constants = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function EstimateVsActualHTMLPreviewGroupingSection() {}

EstimateVsActualHTMLPreviewGroupingSection.prototype = new _PreviewSection2.default();

EstimateVsActualHTMLPreviewGroupingSection.prototype.init = function (groupingLevelsArray, hasForthLevel, columnsStrategy, timeFormat, reportAuthorizationInfo) {
    _PreviewSection2.default.prototype.init.call(this);
    this.groupingLevelsArray = groupingLevelsArray;
    this.hasForthLevel = hasForthLevel;
    this.columnsStrategy = columnsStrategy;
    this.timeFormat = timeFormat;
    this.reportAuthorizationInfo = reportAuthorizationInfo;

    return this;
};

EstimateVsActualHTMLPreviewGroupingSection.prototype.levelClasses = ["firstLevel", "secondLevel", "thirdLevel", "forthLevel"];
EstimateVsActualHTMLPreviewGroupingSection.prototype.groupingClasses = ["firstGrouping", "secondGrouping", "thirdGrouping", "forthGrouping"];

EstimateVsActualHTMLPreviewGroupingSection.prototype.addRows = function (tBody) {
    this.addRowWithMainCell(tBody, this.message("report.budgeted_vs_actual.total_sc"), "totalRow", "totalValue");

    var length = this.groupingLevelsArray.length;
    var levels = void 0;

    if (length === 1) levels = [0, 0, 0, 0, 0, 0, 0, 0, 0];

    if (length === 2) {
        var lastLevelRows = this._getLastLevelRows(1);
        var firstRow = lastLevelRows.firstRow;
        if (ReportPreviewUtils.isLevelCanBeAddedMoreThanOnce(this.groupingLevelsArray[1], [this.groupingLevelsArray[0]])) {
            var secondRow = lastLevelRows.secondRow;
            levels = [0, firstRow, secondRow, 0, firstRow, secondRow, 0, firstRow, secondRow];
        } else {
            levels = [0, firstRow, 0, firstRow, 0, firstRow, 0, firstRow, 0];
        }
    }

    if (length === 3) {
        var _lastLevelRows = this._getLastLevelRows(2);
        var _firstRow = _lastLevelRows.firstRow;
        if (ReportPreviewUtils.isLevelCanBeAddedMoreThanOnce(this.groupingLevelsArray[2], this.groupingLevelsArray.slice(0, 2))) {
            var _secondRow = _lastLevelRows.secondRow;
            levels = [0, 1, _firstRow, _secondRow, 0, 1, _firstRow, _secondRow, 0];
        } else {
            levels = [0, 1, _firstRow, 0, 1, _firstRow, 0, 1, _firstRow];
        }
    }

    if (length > 3) {
        var _lastLevelRows2 = this._getLastLevelRows(3);
        var _firstRow2 = _lastLevelRows2.firstRow;
        if (ReportPreviewUtils.isLevelCanBeAddedMoreThanOnce(this.groupingLevelsArray[3], this.groupingLevelsArray.slice(0, 3)) && ReportPreviewUtils.isLevelCanBeAddedMoreThanOnce(this.groupingLevelsArray[2], this.groupingLevelsArray.slice(0, 2))) {
            var _secondRow2 = _lastLevelRows2.secondRow;
            levels = [0, 1, 2, _firstRow2, _secondRow2, 2, _firstRow2, _secondRow2, 0];
        } else {
            levels = [0, 1, 2, _firstRow2, 0, 1, 2, _firstRow2, 0];
        }
    }

    for (var i = 0; i < levels.length; ++i) {
        this.addGroupingRow(tBody, levels[i]);
    }
};

EstimateVsActualHTMLPreviewGroupingSection.prototype._getLastLevelRows = function (defaultLevel) {
    var hasUserLevel = this.groupingLevelsArray[defaultLevel] === _constants.ReportGroupingLevel.USER;
    var allUsersAvailable = this.reportAuthorizationInfo.allUsersAvailable;
    var anyOtherUsersAvailable = this.reportAuthorizationInfo.anyOtherUsersAvailable;
    var needSwitchToMe = hasUserLevel && !allUsersAvailable && !anyOtherUsersAvailable;
    var firstRow = needSwitchToMe ? 4 : defaultLevel;
    var needToShowOthers = hasUserLevel && !allUsersAvailable;
    var secondRow = needToShowOthers ? 5 : defaultLevel;
    return {
        firstRow: firstRow,
        secondRow: secondRow
    };
};

EstimateVsActualHTMLPreviewGroupingSection.prototype.addGroupingRow = function (tBody, index) {
    var groupingType = this.groupingLevelsArray[index];
    var levelPreviewName = void 0;
    if (index === 4) {
        levelPreviewName = this.message("report.common.me");
        index = this.groupingLevelsArray.length - 1;
    } else if (index === 5) {
        levelPreviewName = this.message("report.common.others");
        index = this.groupingLevelsArray.length - 1;
    } else {
        levelPreviewName = ReportPreviewUtils.getLevelPreviewName(groupingType);
    }

    // if this grouping level is the lowest and forth level is present, it means
    //  this grouping level is really forth (even if his index can be 1 or 2, because second and third level can be skipped).
    // in this case we should add css-class for forth grouping for this row, so grIndex must be 3.
    var grIndex = index === this.groupingLevelsArray.length - 1 && this.hasForthLevel ? 3 : index;

    this.addRowWithMainCell(tBody, levelPreviewName, this.groupingClasses[grIndex], this.levelClasses[index], groupingType);
};

EstimateVsActualHTMLPreviewGroupingSection.prototype.addRowWithMainCell = function (tBody, text, rowClassName, className, groupingType) {
    var row = this.createRow(rowClassName);
    this.addCell(row, text, className);
    this.addDataCells(row, groupingType);
    this.addRow(tBody, row);
};

EstimateVsActualHTMLPreviewGroupingSection.prototype.addDataCells = function (row, groupingType) {
    this.addTimeValueCell(row);
    if (groupingType && groupingType === _constants.ReportGroupingLevel.USER) this.columnsStrategy.addEmptyColumns(row);else this.columnsStrategy.addColumnValues(row);
};

EstimateVsActualHTMLPreviewGroupingSection.prototype.addTimeValueCell = function (row) {
    ReportPreviewUtils.addHTMLTimeValueCell(row, this.timeFormat);
};

/***/ }),
/* 2044 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = EstimateVsActualCSVPreviewGenerator;

var _CSVParametersBuilder = __webpack_require__(150);

var _CSVParametersBuilder2 = _interopRequireDefault(_CSVParametersBuilder);

var _CSVParametersSection = __webpack_require__(170);

var _CSVParametersSection2 = _interopRequireDefault(_CSVParametersSection);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _EstimateVsActualCSVPreviewHeader = __webpack_require__(2045);

var _EstimateVsActualCSVPreviewHeader2 = _interopRequireDefault(_EstimateVsActualCSVPreviewHeader);

var _EstimateVsActualCSVPreviewGroupingSection = __webpack_require__(2046);

var _EstimateVsActualCSVPreviewGroupingSection2 = _interopRequireDefault(_EstimateVsActualCSVPreviewGroupingSection);

var _AllTasksEvACSVPreviewColumnStrategy = __webpack_require__(2047);

var _AllTasksEvACSVPreviewColumnStrategy2 = _interopRequireDefault(_AllTasksEvACSVPreviewColumnStrategy);

var _TasksWithEstimatesEvACSVPreviewColumnStrategy = __webpack_require__(2048);

var _TasksWithEstimatesEvACSVPreviewColumnStrategy2 = _interopRequireDefault(_TasksWithEstimatesEvACSVPreviewColumnStrategy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function EstimateVsActualCSVPreviewGenerator() {}

EstimateVsActualCSVPreviewGenerator.prototype.init = function () {
    return this;
};

EstimateVsActualCSVPreviewGenerator.prototype.generatePreviewTable = function (reportParameters, reportParamsStringBuilder) {
    var taskParams = {
        tasksConfig: reportParameters.tasksConfig,
        includeNotEstimated: !!reportParameters.includeNotEstimated,
        includeNotStarted: !!reportParameters.includeNotStarted
    };

    var groupingLevelsArray = [reportParameters.firstGroupingLevel, reportParameters.secondGroupingLevel, reportParameters.thirdGroupingLevel, reportParameters.fourthGroupingLevel];

    var filteredLevelsArray = ReportPreviewUtils.filterNotEmptyLevels(groupingLevelsArray);

    var table = document.createElement("table");
    table.className = "reportCsvPreviewTable eva";
    var tBody = document.createElement("tbody");
    table.appendChild(tBody);

    var columnsStrategy = this.createPreviewStrategy(taskParams);
    var totalColumnsNum = filteredLevelsArray.length + 4 + columnsStrategy.getNumOfDataColumns(); // total spent, est time, variance mh, variance %

    ReportPreviewUtils.addSheetHeaderRow(tBody, totalColumnsNum);

    var header = new _EstimateVsActualCSVPreviewHeader2.default().init(filteredLevelsArray, columnsStrategy);

    var reportAuthorizationInfo = reportParameters.reportAuthorizationInfo;
    var dataGroupingSection = new _EstimateVsActualCSVPreviewGroupingSection2.default().init(filteredLevelsArray, columnsStrategy, reportAuthorizationInfo);
    var paramsBuilder = new _CSVParametersBuilder2.default().init();

    paramsBuilder.addCPParam(reportParameters.customersProjectsSelection, reportParamsStringBuilder);
    paramsBuilder.addEvATasksParam(taskParams, reportParameters.dateSelection, reportParamsStringBuilder);
    this.addDateParam(paramsBuilder, reportParameters.dateSelection, reportParamsStringBuilder);

    var parametersSection = new _CSVParametersSection2.default().init(paramsBuilder, totalColumnsNum);

    parametersSection.addRows(tBody);
    header.addRows(tBody);
    dataGroupingSection.addRows(tBody);

    return table;
};

EstimateVsActualCSVPreviewGenerator.prototype.addDateParam = function (paramsBuilder, dateSelection, reportParamsStringBuilder) {
    paramsBuilder.parameters.push([_messageResource2.default.getMessage("report.budgeted_vs_actual.date_label"), reportParamsStringBuilder.getEvaDateCSVString(dateSelection)]);
};

EstimateVsActualCSVPreviewGenerator.prototype.createPreviewStrategy = function (taskParams) {
    if (taskParams.includeNotEstimated) return new _AllTasksEvACSVPreviewColumnStrategy2.default();

    return new _TasksWithEstimatesEvACSVPreviewColumnStrategy2.default();
};

/***/ }),
/* 2045 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = EstimateVsActualCSVPreviewHeader;

var _CSVPreviewSection = __webpack_require__(43);

var _CSVPreviewSection2 = _interopRequireDefault(_CSVPreviewSection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function EstimateVsActualCSVPreviewHeader() {}

EstimateVsActualCSVPreviewHeader.prototype = new _CSVPreviewSection2.default();

EstimateVsActualCSVPreviewHeader.prototype.init = function (groupingLevelsArray, columnsConfig) {
    _CSVPreviewSection2.default.prototype.init.call(this);
    this.groupingLevelsArray = groupingLevelsArray;
    this.columnsConfig = columnsConfig;

    return this;
};

EstimateVsActualCSVPreviewHeader.prototype.addRows = function (tBody) {
    var mainHeaderRow = this.createRow("tableHeader");

    var length = this.groupingLevelsArray.length;
    for (var i = 0; i < length; ++i) {
        var level = this.groupingLevelsArray[i];
        ReportPreviewUtils.addCell(mainHeaderRow, ReportPreviewUtils.getLevelPreviewName(level));
    }

    this.addCell(mainHeaderRow, this.message("report.budgeted_vs_actual.spent_time.total"));

    this.columnsConfig.addDataColumns(mainHeaderRow);

    this.addCell(mainHeaderRow, this.message("report.budgeted_vs_actual.estimated_time"));
    this.addCell(mainHeaderRow, this.message("report.budgeted_vs_actual.variance_mh"));
    this.addCell(mainHeaderRow, this.message("report.budgeted_vs_actual.variance_percent"));

    this.addRowWithAdditionalClass(tBody, mainHeaderRow);
};

/***/ }),
/* 2046 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = EstimateVsActualCSVPreviewGroupingSection;

var _CSVPreviewSection = __webpack_require__(43);

var _CSVPreviewSection2 = _interopRequireDefault(_CSVPreviewSection);

var _constants = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function EstimateVsActualCSVPreviewGroupingSection() {}

EstimateVsActualCSVPreviewGroupingSection.prototype = new _CSVPreviewSection2.default();

EstimateVsActualCSVPreviewGroupingSection.prototype.init = function (groupingLevelsArray, columnsConfig, reportAuthorizationInfo) {
    _CSVPreviewSection2.default.prototype.init.call(this);

    this.groupingLevelsArray = groupingLevelsArray;
    this.columnsConfig = columnsConfig;
    this.reportAuthorizationInfo = reportAuthorizationInfo;

    this.numOfDataColumns = 4 + this.columnsConfig.getNumOfDataColumns(); // total spent, est time, variance mh, variance %
    this.numOfGroupingRows = this.groupingLevelsArray.length;

    return this;
};

EstimateVsActualCSVPreviewGroupingSection.prototype.isGroupinRowWithEstimates = function (groupingLevel) {
    return groupingLevel !== _constants.ReportGroupingLevel.USER;
};

EstimateVsActualCSVPreviewGroupingSection.prototype._addGroupCell = function (row, groupingLevel, secondRowOfLastLevel) {

    if (groupingLevel === _constants.ReportGroupingLevel.USER) {
        var allUsersAvailable = this.reportAuthorizationInfo.allUsersAvailable;
        var anyOtherUsersAvailable = this.reportAuthorizationInfo.anyOtherUsersAvailable;
        var needSwitchToMe = !allUsersAvailable && !anyOtherUsersAvailable;
        var needToShowOthers = !allUsersAvailable;

        if (secondRowOfLastLevel) {
            if (!needSwitchToMe && !needToShowOthers) {
                this.addCell(row, this.message("report.user"));
            } else {
                this.addCell(row, this.message("report.common.others"));
            }
        } else if (needSwitchToMe) {
            this.addCell(row, this.message("report.common.me"));
        } else {
            this.addCell(row, this.message("report.common.user"));
        }
    } else {
        this.addCell(row, ReportPreviewUtils.getLevelPreviewName(groupingLevel));
    }
};

EstimateVsActualCSVPreviewGroupingSection.prototype.addRows = function (tBody) {
    for (var i = 0; i < this.numOfGroupingRows + 1; i++) {
        var secondRowOfLastLevel = i >= this.numOfGroupingRows;
        var groupingLevelNumber = secondRowOfLastLevel ? this.numOfGroupingRows - 1 : i;
        var groupingLevel = this.groupingLevelsArray[groupingLevelNumber];
        var row = this.createRow();

        for (var j = 0; j < this.numOfGroupingRows; ++j) {
            if (i === j || secondRowOfLastLevel && j === groupingLevelNumber) {
                this._addGroupCell(row, groupingLevel, secondRowOfLastLevel);
            } else {
                ReportPreviewUtils.addEmptyCell(row);
            }
        }

        this.addValueCell(row, ReportPreviewUtils.getCSVTimeValue()); // total time spent

        this.columnsConfig.addCellValues(row, groupingLevel); // total time spent

        if (this.isGroupinRowWithEstimates(groupingLevel)) {
            this.addValueCell(row, ReportPreviewUtils.getCSVTimeValue()); // estimate time
            this.addValueCell(row, this.getCSVShortTimeValue()); // variance mh
            this.addValueCell(row, this.getCSVPercentValue()); // variance %
        } else {
            ReportPreviewUtils.addEmptyCell(row);
            ReportPreviewUtils.addEmptyCell(row);
            ReportPreviewUtils.addEmptyCell(row);
        }

        this.addRow(tBody, row);
    }

    var emptyRow = this.createRow();
    var totalColumnsNum = this.numOfGroupingRows + this.numOfDataColumns;

    for (var _i = 0; _i < totalColumnsNum; _i++) {
        ReportPreviewUtils.addEmptyCell(emptyRow);
    }this.addRow(tBody, emptyRow);

    var totalRow = this.createRow();
    this.addCell(totalRow, this.message("report.budgeted_vs_actual.total"));
    for (var _i2 = 1; _i2 < this.numOfGroupingRows; _i2++) {
        ReportPreviewUtils.addEmptyCell(totalRow);
    }this.addValueCell(totalRow, ReportPreviewUtils.getCSVTimeValue()); // total time spent
    this.columnsConfig.addCellValues(totalRow, null); // total time spent for...

    this.addValueCell(totalRow, ReportPreviewUtils.getCSVTimeValue()); // estimate time
    this.addValueCell(totalRow, this.getCSVShortTimeValue()); // variance mh
    this.addValueCell(totalRow, this.getCSVPercentValue()); // variance %

    this.addRow(tBody, totalRow);
};

EstimateVsActualCSVPreviewGroupingSection.prototype.getCSVShortTimeValue = function () {
    return "1" + SystemSettings.decimalSeparator + "23";
};

EstimateVsActualCSVPreviewGroupingSection.prototype.getCSVPercentValue = function () {
    return "1" + SystemSettings.decimalSeparator + "23%";
};

/***/ }),
/* 2047 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = AllTasksEvACSVPreviewColumnStrategy;

var _CSVPreviewSection = __webpack_require__(43);

var _CSVPreviewSection2 = _interopRequireDefault(_CSVPreviewSection);

var _constants = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function AllTasksEvACSVPreviewColumnStrategy() {}

AllTasksEvACSVPreviewColumnStrategy.prototype = new _CSVPreviewSection2.default();

AllTasksEvACSVPreviewColumnStrategy.prototype.getNumOfDataColumns = function () {
    return 2; // total for not est, total for est
};

AllTasksEvACSVPreviewColumnStrategy.prototype.addDataColumns = function (row) {
    this.addCell(row, this.message("report.budgeted_vs_actual.time_for_not_estimated_tasks"));
    this.addCell(row, this.message("report.budgeted_vs_actual.time_for_estimated_tasks"));
};

AllTasksEvACSVPreviewColumnStrategy.prototype.addCellValues = function (row, groupingLevel) {
    if (groupingLevel === _constants.ReportGroupingLevel.USER || groupingLevel === _constants.ReportGroupingLevel.TASK) this.addCell(row, "");else this.addTimeValueCell(row);

    this.addTimeValueCell(row);
};

/***/ }),
/* 2048 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = TasksWithEstimatesEvACSVPreviewColumnStrategy;

var _CSVPreviewSection = __webpack_require__(43);

var _CSVPreviewSection2 = _interopRequireDefault(_CSVPreviewSection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function TasksWithEstimatesEvACSVPreviewColumnStrategy() {}

TasksWithEstimatesEvACSVPreviewColumnStrategy.prototype = new _CSVPreviewSection2.default();

TasksWithEstimatesEvACSVPreviewColumnStrategy.prototype.getNumOfDataColumns = function () {
    return 0;
};

TasksWithEstimatesEvACSVPreviewColumnStrategy.prototype.addDataColumns = function () {
    // do nothing
};
TasksWithEstimatesEvACSVPreviewColumnStrategy.prototype.addCellValues = function () {
    // do nothing
};

/***/ }),
/* 2049 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = LeavesReportMediator;

var _ReportMediator = __webpack_require__(321);

var _ReportMediator2 = _interopRequireDefault(_ReportMediator);

var _LeaveTypeStore = __webpack_require__(124);

var _LeaveTypeStore2 = _interopRequireDefault(_LeaveTypeStore);

var _LeavesReportStore = __webpack_require__(199);

var _LeavesReportStore2 = _interopRequireDefault(_LeavesReportStore);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _PDFPreviewLightbox = __webpack_require__(590);

var _PDFPreviewLightbox2 = _interopRequireDefault(_PDFPreviewLightbox);

var _PDFGenerator = __webpack_require__(968);

var _PDFGenerator2 = _interopRequireDefault(_PDFGenerator);

var _constants = __webpack_require__(11);

var _ReportPrintableHeadersBuilder = __webpack_require__(171);

var _ReportPrintableHeadersBuilder2 = _interopRequireDefault(_ReportPrintableHeadersBuilder);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _constants2 = __webpack_require__(4);

var _features = __webpack_require__(22);

var _jquery_rpc = __webpack_require__(26);

var _jquery_rpc2 = _interopRequireDefault(_jquery_rpc);

var _atUtils = __webpack_require__(5);

var _LeavesReportEditConfigController = __webpack_require__(594);

var _LeavesReportEditConfigController2 = _interopRequireDefault(_LeavesReportEditConfigController);

var _utils = __webpack_require__(164);

var _ATReportParamsStringBuilder = __webpack_require__(52);

var _ATReportParamsStringBuilder2 = _interopRequireDefault(_ATReportParamsStringBuilder);

var _utils2 = __webpack_require__(127);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function LeavesReportMediator() {
    this.constructor = LeavesReportMediator;
}

LeavesReportMediator.prototype = new _ReportMediator2.default();

LeavesReportMediator.prototype.init = function (config) {
    _ReportMediator2.default.prototype.init.call(this, config);

    _LeaveTypeStore2.default.setLeaveTypes((0, _atUtils.arrayToMap)(config.leavesData));

    this.store = _LeavesReportStore2.default;

    var self = this;
    this.ExportSelector = new ExportPanel((0, _jquery2.default)("body"), "aTReports.leaveTime.showPDFPreview", "aTReports.leaveTime.createCSV").init();
    this.$exportButton = (0, _jquery2.default)(".export");
    this.$exportButton.click(function () {
        if (!self.$exportButton.hasClass('disabled')) self.ExportSelector.showAt((0, _jquery2.default)(this));
    });

    (0, _jquery2.default)(document).on("aTReports.leaveTime.createCSV", function () {
        self.generateCSV();
    });

    this.productSettingsValidator = new ATProductSettingsValidator();
    this.reportRightsValidator = new ATReportRightsValidator();

    new BaseReport.PDFPreviewLightboxTemplateView((0, _jquery2.default)("body"), "leaveTimeAndBalancesPdfPreviewLightbox", "lightboxWithWhiteContent pdfPreviewLightbox noprint").init();

    this.pdfPreviewLightbox = new _PDFPreviewLightbox2.default().init({
        popupId: "leaveTimeAndBalancesPdfPreviewLightbox",
        closeBtnId: "closeViewTTPdfPreviewLightboxButton",
        eventNamespace: "leavesReport",
        productSettingsValidator: this.productSettingsValidator,
        reportRightsValidator: this.reportRightsValidator
    });

    (0, _jquery2.default)(document).on("aTReports.leaveTime.showPDFPreview", function () {
        self.pdfPreviewLightbox.show();
    });
    (0, _jquery2.default)(document).on("leavesReport.pdfPreview.lightbox.hide", function () {
        //todo
    });
    (0, _jquery2.default)(document).on("leavesReport.pdfPreview.printParametersForSaveChange", function (event, printParametersForSave) {
        _LeavesReportStore2.default.setPrintParametersForSave(printParametersForSave);
    });
    (0, _jquery2.default)(document).on("leavesReport.pdfPreview.printParametersForGenerateChange", function (event, printParametersForGenerate) {
        _LeavesReportStore2.default.setPrintParametersForGenerate(printParametersForGenerate);
        self.cancelAllPDFExportingProcesses();
        self.generatePDF();
    });
    (0, _jquery2.default)(document).on("leavesReport.downloadPDF", function () {
        (0, _utils.downloadPDF)(_LeavesReportStore2.default.getGeneratedPDF(), _LeavesReportStore2.default.getPDFFileName());
    });

    ATReportsStore.setVisibleUsers(config.users);
    ATReportsStore.setUserGroups(config.userGroups);
    ATReportsStore.setTimeZoneGroups(config.timeZoneGroups);

    if (!this.editConfigController.validate()) this.editConfigController.updateUI(true);

    return this;
};

LeavesReportMediator.prototype.generateCSV = function () {

    var generator = new LeaveCSVJsonConverter().init({
        defaultWorkDayDuration: this.store.getDefaultWorkDayDuration(),
        store: this.store,
        reportParamsStringBuilderConstructor: _ATReportParamsStringBuilder2.default,
        manageableUserIds: ATReportsStore.getManageableUserIds(),
        projectsWithMaIds: ATReportsStore.getProjectsWithMaIds(),
        reportAuthorizationInfo: ATReportsStore.getReportAuthorizationInfo()
    });

    var reportParams = this.store.getReportParams();

    var jsons = generator.getJsons(reportParams, this.store.getReportData());
    var fileName = generator.generateCSVName(reportParams);
    (0, _utils2.downloadJsonAsCSV)(jsons, fileName);
};

LeavesReportMediator.prototype.generatePDF = function () {
    this.pdfGenerator = new _PDFGenerator2.default().init({
        store: _LeavesReportStore2.default,
        generalStore: ATReportsStore,
        productSettingsValidator: this.productSettingsValidator,
        reportRightsValidator: this.reportRightsValidator,
        manageableUserIds: ATReportsStore.getManageableUserIds(),
        projectsWithMaIds: ATReportsStore.getProjectsWithMaIds(),
        reportAuthorizationInfo: ATReportsStore.getReportAuthorizationInfo(),
        reportParamsStringBuilderConstructor: _ATReportParamsStringBuilder2.default
    });

    (0, _jquery2.default)(document).trigger("leavesReport.pdfGenerator.start");
    var self = this;
    this.pdfGenerator.generatePDF(function (config, onDataProvided) {
        self.chartController.exportChart(config["chartImageSizes"], function (img) {
            onDataProvided({
                chartImage: img
            });
        });
    }).then(function (pdf) {
        _LeavesReportStore2.default.setGeneratedPDF(pdf.encodedPDF);
        _LeavesReportStore2.default.setPDFFileName(pdf.fileName);
    }, function (error) {
        if (error.message !== "abort") {
            console.error(error);
        }
    });
};

LeavesReportMediator.prototype.cancelAllPDFExportingProcesses = function () {
    if (this.pdfGenerator) this.pdfGenerator.interruptGeneration();
    this.pdfPreviewLightbox.cancelAllExportingProcesses();
};

LeavesReportMediator.prototype.getReportType = function () {
    return _constants.ReportType.LEAVE_TIME;
};

LeavesReportMediator.prototype.initEditConfigController = function (config) {
    var self = this;
    var controller = new _LeavesReportEditConfigController2.default();
    controller.setState({
        loggedInUserId: config.loggedInUserId
    });
    controller.init({
        leavesData: config.leavesData,
        reportAuthorizationInfo: config.reportAuthorizationInfo,
        reportParameters: config.reportParameters,
        users: config.users,
        manageableUsersIds: ATReportsStore.getManageableUserIds(),
        userGroups: config.userGroups,
        timeZoneGroups: config.timeZoneGroups,
        changeCallback: function changeCallback() {
            self.changeParametersCallback();
        },
        productSettingsValidator: config.productSettingsValidator,
        reportRightsValidator: config.reportRightsValidator
    });

    return controller;
};

// override for date range selector
LeavesReportMediator.prototype.createDateRangeSelector = function (reportParameters) {
    var dateRangeMenuItemsUtil = new DateRangeMenuItemsUtil();
    var futureValidator = function futureValidator() {
        return dateRangeMenuItemsUtil.isShowTTFItems(reportParameters.dateRangeSelection.qualifier);
    };

    var dateRangeSelectorConfig = {
        dateRangeSelection: reportParameters.dateRangeSelection,
        menuStates: dateRangeMenuItemsUtil.createDateRangeMenuItemsWithFuture(futureValidator), //for future items
        dateRangeParsed: true,
        callOnChangeCallbackIfInvalid: true
    };

    return new DateRangeSelectorController().init(dateRangeSelectorConfig);
};

LeavesReportMediator.prototype.initPrintableHeadersBuilder = function (config) {
    this.reportConfig = config;
    return new _ReportPrintableHeadersBuilder2.default().init({
        users: config.users,
        reportParameters: config.reportParameters,
        userGroups: config.userGroups,
        timeZoneGroups: config.timeZoneGroups,
        leaveTypesMap: (0, _atUtils.arrayToMap)(config.leavesData),
        manageableUserIds: ATReportsStore.getManageableUserIds(),
        reportAuthorizationInfo: ATReportsStore.getReportAuthorizationInfo()
    });
};

LeavesReportMediator.prototype._populateHeadersArray = function (headersArray) {
    this.printableHeadersBuilder.addStaffSelectionParamsToArray(this.reportParameters.userSelection, headersArray); //staff
    this.printableHeadersBuilder.addLeaveTypesParamsToArray(this.reportParameters.leaveTypeSelection, this.reportParameters.columnsConfig, headersArray); //leave types
};

LeavesReportMediator.prototype.requestGenerateReport = function (successHandler) {
    var self = this;

    function successMethod(data, textStatus, jqXHR) {
        if (successHandler) successHandler(data, textStatus, jqXHR);
        self.$exportButton.toggleClass('disabled', false);
    }

    function errorMethod(jqXHR, textStatus, errorThrown) {
        self.$exportButton.toggleClass('disabled', true);
        self.hideOverlay();

        if (textStatus === "rpc_sessionExpired") return false;

        if (textStatus === "rpc_noRights") {
            alert(_messageResource2.default.getMessage("common.no_rights_for_operation_anymore"));
            document.location.href = _constants2.ReportConfigConstants.REPORTS_DASHBOARD_URL;
            return true;
        }

        if (textStatus === "rpc_customException") {
            var messageKey = void 0;
            switch (errorThrown.exception) {
                case "com.actimind.actitime.reports.NoRightsToManageBalancesException":
                    if ((0, _features.isEnabled)(_features.Feature.PTO) && (0, _features.isEnabled)(_features.Feature.SDB)) messageKey = "report.js.report_loading_error.no_rights_manage_pto_and_sick";else if ((0, _features.isEnabled)(_features.Feature.PTO)) messageKey = "report.js.report_loading_error.no_rights_manage_pto";else if ((0, _features.isEnabled)(_features.Feature.SDB)) messageKey = "report.js.report_loading_error.no_rights_manage_sick";
                    break;
                case "com.actimind.actitime.reports.AllSelectedUsersWereDeletedException":
                    messageKey = "report.js.report_loading_error.no_selected_users";
                    break;
                case "com.actimind.actitime.reports.AllSelectedLeaveTypesWereDeletedException":
                    messageKey = "report.js.report_loading_error.no_selected_leave_types";
                    break;
            }

            if (messageKey) {
                self.showReportLoadingError(_messageResource2.default.getMessage(messageKey));
                return true;
            }
        } else {
            self.showReportLoadingError(_messageResource2.default.getMessage("report.js.report_loading_error.network_error", [PRODUCT_NAME]));
            return true;
        }

        return false;
    }

    return (0, _jquery_rpc2.default)("LeavesReportService.getLeavesReport", [this.makeServiceParams(this.reportParameters)], successMethod, errorMethod);
};

LeavesReportMediator.prototype.validateGeneratedReport = function (data) {
    return true;
};

LeavesReportMediator.prototype.renderGeneratedReport = function (data) {
    var reportParams = _jquery2.default.extend(true, {}, this.reportParameters);
    var info = {};
    var groupingLevels = BaseReport.ConvertUtils.getGroupingLevels(reportParams);
    for (var i = 0; i < data["groupingLevelsInfoLists"].length; ++i) {
        var groupingType = BaseReport.ConvertUtils.getGroupingType(i, groupingLevels);
        info[groupingType] = (0, _atUtils.arrayToMap)(data["groupingLevelsInfoLists"][i]);
    }

    _LeavesReportStore2.default.setReportData(data["rootItem"], info);
    _LeavesReportStore2.default.mergeGeneralStore(ATReportsStore);
    _LeavesReportStore2.default.setReportParams(reportParams);
    _LeavesReportStore2.default.setDefaultWorkDayDuration(data["defaultWorkDayDuration"]);

    if (this.leavesReportTable) this.leavesReportTable.cancelRendering();

    this.reportPlaceholder.empty();
    this.leavesReportTable = new LeavesReport.Table(this.reportPlaceholder, _LeavesReportStore2.default).init();
    this.leavesReportTable.update();
};

/***/ }),
/* 2050 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = StaffOutputFormMediator;

var _OldBaseFormMediator = __webpack_require__(271);

var _OldBaseFormMediator2 = _interopRequireDefault(_OldBaseFormMediator);

var _StaffOutputReportEditFormConfigController = __webpack_require__(2051);

var _StaffOutputReportEditFormConfigController2 = _interopRequireDefault(_StaffOutputReportEditFormConfigController);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _StaffPerformanceHTMLPreviewGenerator = __webpack_require__(2053);

var _StaffPerformanceHTMLPreviewGenerator2 = _interopRequireDefault(_StaffPerformanceHTMLPreviewGenerator);

var _StaffPerformanceCSVPreviewGenerator = __webpack_require__(2061);

var _StaffPerformanceCSVPreviewGenerator2 = _interopRequireDefault(_StaffPerformanceCSVPreviewGenerator);

var _ATReportParamsStringBuilder = __webpack_require__(52);

var _ATReportParamsStringBuilder2 = _interopRequireDefault(_ATReportParamsStringBuilder);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @author evdokimov
 */
function StaffOutputFormMediator() {}

StaffOutputFormMediator.prototype = _underscore2.default.create(_OldBaseFormMediator2.default.prototype);

StaffOutputFormMediator.prototype.init = function (config) {
    _OldBaseFormMediator2.default.prototype.init.call(this, config);

    return this;
};

StaffOutputFormMediator.prototype.initParamsStringBuilder = function (config) {
    return new _ATReportParamsStringBuilder2.default({
        data: {
            users: config.users,
            userGroups: config.userGroups,
            timeZoneGroups: config.timeZoneGroups,
            cpList: config.cpList,
            manageableUserIds: ATReportsStore.getManageableUserIds(),
            projectsWithMaIds: ATReportsStore.getProjectsWithMaIds()
        },
        reportAuthorizationInfo: ATReportsStore.getReportAuthorizationInfo()
    });
};

StaffOutputFormMediator.prototype.initEditConfigController = function (config) {
    var _this = this;

    return new _StaffOutputReportEditFormConfigController2.default().init({
        panelId: "mainContainer",
        reportAuthorizationInfo: config.reportAuthorizationInfo,
        reportParameters: config.reportParameters,
        users: config.users,
        manageableUsersIds: config.manageableUserIds,
        userGroups: config.userGroups,
        timeZoneGroups: config.timeZoneGroups,
        cpList: config.cpList,
        customersWithMaIds: config.customersWithMaIds,
        projectsWithMaIds: config.projectsWithMaIds,
        changeCallback: function changeCallback() {
            return _this.changeParametersCallback();
        }
    });
};

StaffOutputFormMediator.prototype.initCsvGenerator = function () {
    return new _StaffPerformanceCSVPreviewGenerator2.default().init();
};

StaffOutputFormMediator.prototype.initHtmlGenerator = function () {
    return new _StaffPerformanceHTMLPreviewGenerator2.default().init();
};

/***/ }),
/* 2051 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _features = __webpack_require__(22);

var _constants = __webpack_require__(11);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _constants2 = __webpack_require__(4);

var _StaffOutputReportEditConfigController = __webpack_require__(988);

var _StaffOutputReportEditConfigController2 = _interopRequireDefault(_StaffOutputReportEditConfigController);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var StaffOutputReportEditFormConfigController = function (_StaffOutputReportEdi) {
    _inherits(StaffOutputReportEditFormConfigController, _StaffOutputReportEdi);

    function StaffOutputReportEditFormConfigController() {
        _classCallCheck(this, StaffOutputReportEditFormConfigController);

        return _possibleConstructorReturn(this, (StaffOutputReportEditFormConfigController.__proto__ || Object.getPrototypeOf(StaffOutputReportEditFormConfigController)).apply(this, arguments));
    }

    return StaffOutputReportEditFormConfigController;
}(_StaffOutputReportEditConfigController2.default);

exports.default = StaffOutputReportEditFormConfigController;


StaffOutputReportEditFormConfigController.prototype.makeReportParamsAccordingToFeatures = function (reportParameters) {
    var result = _jquery2.default.extend({}, reportParameters);
    if (!(0, _features.isEnabled)(_features.Feature.UGR)) {
        result.columnsConfig = _constants2.StaffPerformanceColumnsConfig.USERS_ONLY;
    }
    if (!(0, _features.isEnabled)(_features.Feature.TTA)) {
        result.timeApprovalStatus = _constants2.TimeApprovalStatus.BOTH;
    }
    if (!(0, _features.isEnabled)(_features.Feature.LVT)) {
        result.showLeaveTime = false;
    }
    if (!(0, _features.isEnabled)(_features.Feature.BTY)) {
        var groupings = this.makeGroupingSelectorValuesAccordingToNotAvailableValueLevel(_constants.ReportGroupingLevel.BILLING_TYPE, [result.firstGroupingLevel, result.secondGroupingLevel], _constants.ReportGroupingLevel.CUSTOMER);
        result.firstGroupingLevel = groupings[0];
        result.secondGroupingLevel = groupings[1];
    }

    return result;
};

/***/ }),
/* 2052 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = StaffoutputColumnsFormatSelector;

var _ListSelector = __webpack_require__(96);

var _ListSelector2 = _interopRequireDefault(_ListSelector);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _constants = __webpack_require__(4);

var _features = __webpack_require__(22);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function StaffoutputColumnsFormatSelector() {}

StaffoutputColumnsFormatSelector.prototype.init = function (id, initValue, onChangeCallback) {
    this.selector = new _ListSelector2.default({
        renderTo: _jquery2.default.find("#" + id)[0],
        menuCls: "columnsFormatMenu",
        ctCls: " i"
    });

    var preText = _messageResource2.default.getMessage("report.show") + "&nbsp";
    this.selector.addItems([{
        text: preText + _messageResource2.default.getEscapedMessage("report.staffoutput.configure_columns.user_no_format"),
        value: _constants.StaffPerformanceColumnsConfig.USERS_ONLY
    }]);
    if ((0, _features.isEnabled)(_features.Feature.UGR) || initValue === _constants.StaffPerformanceColumnsConfig.GROUPS_ONLY || initValue === _constants.StaffPerformanceColumnsConfig.USERS_BY_GROUPS_WITHOUT_SUBTOTALS || initValue === _constants.StaffPerformanceColumnsConfig.USERS_BY_GROUPS_WITH_SUBTOTALS) {
        this.selector.addSeparator();
        this.selector.addItems([{
            text: preText + _messageResource2.default.getEscapedMessage("report.staffoutput.configure_columns.user_group_no_format"),
            value: _constants.StaffPerformanceColumnsConfig.GROUPS_ONLY
        }, {
            text: preText + _messageResource2.default.getEscapedMessage("report.staffoutput.configure_columns.user_group_user_no_format"),
            value: _constants.StaffPerformanceColumnsConfig.USERS_BY_GROUPS_WITHOUT_SUBTOTALS
        }, {
            text: preText + _messageResource2.default.getEscapedMessage("report.staffoutput.configure_columns.user_group_user_with_subtotal_no_format"),
            value: _constants.StaffPerformanceColumnsConfig.USERS_BY_GROUPS_WITH_SUBTOTALS
        }]);
    }
    if ((0, _features.isEnabled)(_features.Feature.TZG) || initValue === _constants.StaffPerformanceColumnsConfig.TZ_GROUPS_ONLY || initValue === _constants.StaffPerformanceColumnsConfig.USERS_BY_TIME_ZONE_GROUPS_WITH_SUBTOTALS || initValue === _constants.StaffPerformanceColumnsConfig.USERS_BY_TIME_ZONE_GROUPS_WITHOUT_SUBTOTALS) {
        this.selector.addSeparator();
        this.selector.addItems([{
            text: preText + _messageResource2.default.getEscapedMessage("report.staffoutput.configure_columns.time_zone_group_no_format"),
            value: _constants.StaffPerformanceColumnsConfig.TZ_GROUPS_ONLY
        }, {
            text: preText + _messageResource2.default.getEscapedMessage("report.staffoutput.configure_columns.time_zone_group_user_no_format"),
            value: _constants.StaffPerformanceColumnsConfig.USERS_BY_TIME_ZONE_GROUPS_WITHOUT_SUBTOTALS
        }, {
            text: preText + _messageResource2.default.getEscapedMessage("report.staffoutput.configure_columns.time_zone_groups_user_with_subtotal_no_format"),
            value: _constants.StaffPerformanceColumnsConfig.USERS_BY_TIME_ZONE_GROUPS_WITH_SUBTOTALS
        }]);
    }

    this.selector.on("change", onChangeCallback);
    this.selector.setActiveItemByValue(initValue, true);
    return this;
};

StaffoutputColumnsFormatSelector.prototype.getValue = function () {
    return this.selector.getSelectedItem().value;
};

StaffoutputColumnsFormatSelector.prototype.setActiveItemByValue = function (value, suppressChangeEvent) {
    this.selector.setActiveItemByValue(value, suppressChangeEvent);
};

/***/ }),
/* 2053 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = StaffPerformanceHTMLPreviewGenerator;

var _constants = __webpack_require__(4);

var _StaffPerformanceHTMLPreviewUsersOnlyColumnsStrategy = __webpack_require__(2054);

var _StaffPerformanceHTMLPreviewUsersOnlyColumnsStrategy2 = _interopRequireDefault(_StaffPerformanceHTMLPreviewUsersOnlyColumnsStrategy);

var _StaffPerformanceHTMLPreviewGroupsOnlyColumnsStrategy = __webpack_require__(2055);

var _StaffPerformanceHTMLPreviewGroupsOnlyColumnsStrategy2 = _interopRequireDefault(_StaffPerformanceHTMLPreviewGroupsOnlyColumnsStrategy);

var _StaffPerformanceHTMLPreviewUsersByGroupsWithoutSubtotalsColumnsStrategy = __webpack_require__(2056);

var _StaffPerformanceHTMLPreviewUsersByGroupsWithoutSubtotalsColumnsStrategy2 = _interopRequireDefault(_StaffPerformanceHTMLPreviewUsersByGroupsWithoutSubtotalsColumnsStrategy);

var _StaffPerformanceHTMLPreviewUsersByGroupsWithSubtotalsColumnsStrategy = __webpack_require__(2057);

var _StaffPerformanceHTMLPreviewUsersByGroupsWithSubtotalsColumnsStrategy2 = _interopRequireDefault(_StaffPerformanceHTMLPreviewUsersByGroupsWithSubtotalsColumnsStrategy);

var _StaffPerformanceHTMLPreviewHeaderSection = __webpack_require__(2058);

var _StaffPerformanceHTMLPreviewHeaderSection2 = _interopRequireDefault(_StaffPerformanceHTMLPreviewHeaderSection);

var _StaffPerformanceHTMLPreviewGroupingSection = __webpack_require__(2059);

var _StaffPerformanceHTMLPreviewGroupingSection2 = _interopRequireDefault(_StaffPerformanceHTMLPreviewGroupingSection);

var _StaffPerformanceHTMLPreviewLeaveSection = __webpack_require__(2060);

var _StaffPerformanceHTMLPreviewLeaveSection2 = _interopRequireDefault(_StaffPerformanceHTMLPreviewLeaveSection);

var _UserGroupMessageProvider = __webpack_require__(990);

var _UserGroupMessageProvider2 = _interopRequireDefault(_UserGroupMessageProvider);

var _TimeZoneGroupMessageProvider = __webpack_require__(992);

var _TimeZoneGroupMessageProvider2 = _interopRequireDefault(_TimeZoneGroupMessageProvider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function StaffPerformanceHTMLPreviewGenerator() {}

StaffPerformanceHTMLPreviewGenerator.prototype.init = function () {
    return this;
};
StaffPerformanceHTMLPreviewGenerator.prototype.generatePreviewTable = function (reportParameters) {
    var columnsStrategy = void 0;
    var columnConfig = reportParameters.columnsConfig;
    var includeOtherUsersColumn = reportParameters.includeOtherUsersColumn;

    switch (columnConfig) {
        case _constants.StaffPerformanceColumnsConfig.USERS_ONLY:
            columnsStrategy = new _StaffPerformanceHTMLPreviewUsersOnlyColumnsStrategy2.default().init(reportParameters.timeFormat, includeOtherUsersColumn, reportParameters.needSwitchToMe);
            break;
        case _constants.StaffPerformanceColumnsConfig.GROUPS_ONLY:
        case _constants.StaffPerformanceColumnsConfig.TZ_GROUPS_ONLY:
            columnsStrategy = new _StaffPerformanceHTMLPreviewGroupsOnlyColumnsStrategy2.default().init(reportParameters.timeFormat, this.getGroupMessageProvider(columnConfig), includeOtherUsersColumn);
            break;
        case _constants.StaffPerformanceColumnsConfig.USERS_BY_GROUPS_WITHOUT_SUBTOTALS:
        case _constants.StaffPerformanceColumnsConfig.USERS_BY_TIME_ZONE_GROUPS_WITHOUT_SUBTOTALS:
            columnsStrategy = new _StaffPerformanceHTMLPreviewUsersByGroupsWithoutSubtotalsColumnsStrategy2.default().init(reportParameters.timeFormat, this.getGroupMessageProvider(columnConfig), includeOtherUsersColumn);
            break;
        case _constants.StaffPerformanceColumnsConfig.USERS_BY_GROUPS_WITH_SUBTOTALS:
        case _constants.StaffPerformanceColumnsConfig.USERS_BY_TIME_ZONE_GROUPS_WITH_SUBTOTALS:
            columnsStrategy = new _StaffPerformanceHTMLPreviewUsersByGroupsWithSubtotalsColumnsStrategy2.default().init(reportParameters.timeFormat, this.getGroupMessageProvider(columnConfig), includeOtherUsersColumn);
    }

    var header = new _StaffPerformanceHTMLPreviewHeaderSection2.default().init(reportParameters.firstGroupingLevel, reportParameters.secondGroupingLevel, reportParameters.thirdGroupingLevel, columnsStrategy);

    var dataGroupingSection = new _StaffPerformanceHTMLPreviewGroupingSection2.default().init(reportParameters.firstGroupingLevel, reportParameters.secondGroupingLevel, reportParameters.thirdGroupingLevel, !reportParameters.showLeaveTime, columnsStrategy);

    var table = document.createElement("table");
    table.className = "reportHtmlPreviewTable staffPerformance";
    var tBody = document.createElement("tbody");
    table.appendChild(tBody);
    header.addRows(tBody);

    if (reportParameters.showLeaveTime) new _StaffPerformanceHTMLPreviewLeaveSection2.default().init(columnsStrategy).addRows(tBody);

    dataGroupingSection.addRows(tBody);

    return table;
};

StaffPerformanceHTMLPreviewGenerator.prototype.getGroupMessageProvider = function (columnConfig) {
    switch (columnConfig) {
        case _constants.StaffPerformanceColumnsConfig.GROUPS_ONLY:
        case _constants.StaffPerformanceColumnsConfig.USERS_BY_GROUPS_WITH_SUBTOTALS:
        case _constants.StaffPerformanceColumnsConfig.USERS_BY_GROUPS_WITHOUT_SUBTOTALS:
            return new _UserGroupMessageProvider2.default();
        case _constants.StaffPerformanceColumnsConfig.USERS_BY_TIME_ZONE_GROUPS_WITHOUT_SUBTOTALS:
        case _constants.StaffPerformanceColumnsConfig.TZ_GROUPS_ONLY:
        case _constants.StaffPerformanceColumnsConfig.USERS_BY_TIME_ZONE_GROUPS_WITH_SUBTOTALS:
            return new _TimeZoneGroupMessageProvider2.default();
    }
};

/***/ }),
/* 2054 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = StaffPerformanceHTMLPreviewUsersOnlyColumnsStrategy;

var _StaffPerformanceHTMLPreviewBaseColumnsStrategy = __webpack_require__(598);

var _StaffPerformanceHTMLPreviewBaseColumnsStrategy2 = _interopRequireDefault(_StaffPerformanceHTMLPreviewBaseColumnsStrategy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function StaffPerformanceHTMLPreviewUsersOnlyColumnsStrategy() {}

StaffPerformanceHTMLPreviewUsersOnlyColumnsStrategy.prototype = new _StaffPerformanceHTMLPreviewBaseColumnsStrategy2.default();

StaffPerformanceHTMLPreviewUsersOnlyColumnsStrategy.prototype.init = function (timeFormat, includeOtherUsersColumn, needSwitchToMe) {
    _StaffPerformanceHTMLPreviewBaseColumnsStrategy2.default.prototype.init.call(this, timeFormat);
    this.needSwitchToMe = needSwitchToMe;
    this.includeOtherUsersColumn = includeOtherUsersColumn;
    return this;
};

StaffPerformanceHTMLPreviewUsersOnlyColumnsStrategy.prototype.addFirstHeaderRowCells = function (firstHeaderRow) {
    this.addCreatedCell(firstHeaderRow, this.createSpentHeaderCell());
    this.addCreatedCell(firstHeaderRow, this.needSwitchToMe ? this.createMeHeaderCell(2) : this.createUserHeaderCell(2));
    if (!this.needSwitchToMe) this.addCreatedCell(firstHeaderRow, this.createUserHeaderCell(2));
    if (this.includeOtherUsersColumn) this.addCreatedCell(firstHeaderRow, this.createOthersHeaderCell(2));
};

StaffPerformanceHTMLPreviewUsersOnlyColumnsStrategy.prototype.addSecondHeaderRowCells = function (secondHeaderRow) {
    // do nothing
};

_StaffPerformanceHTMLPreviewBaseColumnsStrategy2.default.prototype.createMeHeaderCell = function (rowSpan) {
    return ReportPreviewUtils.createCell(this.message("report.common.me"), "user", 1, rowSpan);
};

_StaffPerformanceHTMLPreviewBaseColumnsStrategy2.default.prototype.addDataCells = function (row) {
    this.addTimeValueCell(row, "spent");
    this.addTimeValueCell(row);
    if (!this.needSwitchToMe) this.addTimeValueCell(row);
    if (this.includeOtherUsersColumn) this.addTimeValueCell(row);
};

/***/ }),
/* 2055 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = StaffPerformanceHTMLPreviewGroupsOnlyColumnsStrategy;

var _StaffPerformanceHTMLPreviewBaseColumnsStrategy = __webpack_require__(598);

var _StaffPerformanceHTMLPreviewBaseColumnsStrategy2 = _interopRequireDefault(_StaffPerformanceHTMLPreviewBaseColumnsStrategy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function StaffPerformanceHTMLPreviewGroupsOnlyColumnsStrategy() {}

StaffPerformanceHTMLPreviewGroupsOnlyColumnsStrategy.prototype = new _StaffPerformanceHTMLPreviewBaseColumnsStrategy2.default();

StaffPerformanceHTMLPreviewGroupsOnlyColumnsStrategy.prototype.init = function (timeFormat, groupNameProvider, includeOtherUsersColumn) {
    _StaffPerformanceHTMLPreviewBaseColumnsStrategy2.default.prototype.init.call(this, timeFormat, groupNameProvider);
    this.includeOtherUsersColumn = includeOtherUsersColumn;
    return this;
};

StaffPerformanceHTMLPreviewGroupsOnlyColumnsStrategy.prototype.addFirstHeaderRowCells = function (firstHeaderRow) {
    this.addCreatedCell(firstHeaderRow, this.createSpentHeaderCell());
    this.addCell(firstHeaderRow, this.getGroupNameSingular(), "userGroup", 1, 2);
    this.addCell(firstHeaderRow, this.getGroupNameSingular(), "userGroup", 1, 2);
    if (this.includeOtherUsersColumn) this.addCreatedCell(firstHeaderRow, this.createOthersHeaderCell(2));
};

StaffPerformanceHTMLPreviewGroupsOnlyColumnsStrategy.prototype.addSecondHeaderRowCells = function (secondHeaderRow) {
    // do nothing
};

/***/ }),
/* 2056 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = StaffPerformanceHTMLPreviewUsersByGroupsWithoutSubtotalsColumnsStrategy;

var _StaffPerformanceHTMLPreviewUsersByGroupsBaseColumnsStrategy = __webpack_require__(989);

var _StaffPerformanceHTMLPreviewUsersByGroupsBaseColumnsStrategy2 = _interopRequireDefault(_StaffPerformanceHTMLPreviewUsersByGroupsBaseColumnsStrategy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function StaffPerformanceHTMLPreviewUsersByGroupsWithoutSubtotalsColumnsStrategy() {}

StaffPerformanceHTMLPreviewUsersByGroupsWithoutSubtotalsColumnsStrategy.prototype = new _StaffPerformanceHTMLPreviewUsersByGroupsBaseColumnsStrategy2.default();

StaffPerformanceHTMLPreviewUsersByGroupsWithoutSubtotalsColumnsStrategy.prototype.init = function (timeFormat, groupNameProvider, includeOtherUsersColumn) {
    _StaffPerformanceHTMLPreviewUsersByGroupsBaseColumnsStrategy2.default.prototype.init.call(this, timeFormat, groupNameProvider, includeOtherUsersColumn);
    return this;
};

StaffPerformanceHTMLPreviewUsersByGroupsWithoutSubtotalsColumnsStrategy.prototype.getDepartmentHeaderColumnWidth = function () {
    return 2;
};

StaffPerformanceHTMLPreviewUsersByGroupsWithoutSubtotalsColumnsStrategy.prototype.addDataCells = function (row) {
    this.addTimeValueCell(row, "spent");
    this.addTimeValueCell(row);
    this.addTimeValueCell(row);
    if (this.includeOtherUsersColumn) this.addTimeValueCell(row);
};

StaffPerformanceHTMLPreviewUsersByGroupsWithoutSubtotalsColumnsStrategy.prototype.addSecondHeaderRowCells = function (secondHeaderRow) {
    this.addCreatedCell(secondHeaderRow, this.createUserHeaderCell());
    this.addCreatedCell(secondHeaderRow, this.createUserHeaderCell());
};

/***/ }),
/* 2057 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = StaffPerformanceHTMLPreviewUsersByGroupsWithSubtotalsColumnsStrategy;

var _StaffPerformanceHTMLPreviewUsersByGroupsBaseColumnsStrategy = __webpack_require__(989);

var _StaffPerformanceHTMLPreviewUsersByGroupsBaseColumnsStrategy2 = _interopRequireDefault(_StaffPerformanceHTMLPreviewUsersByGroupsBaseColumnsStrategy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function StaffPerformanceHTMLPreviewUsersByGroupsWithSubtotalsColumnsStrategy() {}

StaffPerformanceHTMLPreviewUsersByGroupsWithSubtotalsColumnsStrategy.prototype = new _StaffPerformanceHTMLPreviewUsersByGroupsBaseColumnsStrategy2.default();

StaffPerformanceHTMLPreviewUsersByGroupsWithSubtotalsColumnsStrategy.prototype.init = function (timeFormat, groupNameProvider, includeOtherUsersColumn) {
    _StaffPerformanceHTMLPreviewUsersByGroupsBaseColumnsStrategy2.default.prototype.init.call(this, timeFormat, groupNameProvider);
    this.includeOtherUsersColumn = includeOtherUsersColumn;
    return this;
};

StaffPerformanceHTMLPreviewUsersByGroupsWithSubtotalsColumnsStrategy.prototype.getDepartmentHeaderColumnWidth = function () {
    return this.includeOtherUsersColumn ? 2 : 3;
};

StaffPerformanceHTMLPreviewUsersByGroupsWithSubtotalsColumnsStrategy.prototype.addSecondHeaderRowCells = function (secondHeaderRow) {
    this.addCell(secondHeaderRow, this.message("report.subtotal"), "subtotal");
    this.addCreatedCell(secondHeaderRow, this.createUserHeaderCell());
    if (!this.includeOtherUsersColumn) this.addCreatedCell(secondHeaderRow, this.createUserHeaderCell());
};

StaffPerformanceHTMLPreviewUsersByGroupsWithSubtotalsColumnsStrategy.prototype.addDataCells = function (row) {
    this.addTimeValueCell(row, "spent");
    this.addTimeValueCell(row);
    this.addTimeValueCell(row);
    this.addTimeValueCell(row);
};

/***/ }),
/* 2058 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = StaffPerformanceHTMLPreviewHeaderSection;

var _StaffPerformanceHTMLPreviewBaseSection = __webpack_require__(599);

var _StaffPerformanceHTMLPreviewBaseSection2 = _interopRequireDefault(_StaffPerformanceHTMLPreviewBaseSection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function StaffPerformanceHTMLPreviewHeaderSection() {}

StaffPerformanceHTMLPreviewHeaderSection.prototype = new _StaffPerformanceHTMLPreviewBaseSection2.default();

StaffPerformanceHTMLPreviewHeaderSection.prototype.init = function (firstGroupingLevel, secondGroupingLevel, thirdGroupingLevel, columnsStrategy) {
    _StaffPerformanceHTMLPreviewBaseSection2.default.prototype.init.call(this, columnsStrategy);

    this.firstGroupingLevel = firstGroupingLevel;
    this.secondGroupingLevel = secondGroupingLevel;
    this.thirdGroupingLevel = thirdGroupingLevel;
    return this;
};

StaffPerformanceHTMLPreviewHeaderSection.prototype.addRows = function (tBody) {
    this.addRow(tBody, this.createFirstHeaderRow());
    this.addRow(tBody, this.createSecondHeaderRow());
};

StaffPerformanceHTMLPreviewHeaderSection.prototype.createFirstHeaderRow = function () {
    var row = this.createRow("headerRow firstHeaderRow");
    this.addCell(row, ReportPreviewUtils.makeGroupingHeader([this.firstGroupingLevel, this.secondGroupingLevel, this.thirdGroupingLevel]), "groupingLevelsTitle firstChild", 1, 2);
    this.columnsStrategy.addFirstHeaderRowCells(row);
    return row;
};

StaffPerformanceHTMLPreviewHeaderSection.prototype.createSecondHeaderRow = function () {
    var row = this.createRow("headerRow secondHeaderRow");
    this.columnsStrategy.addSecondHeaderRowCells(row);
    return row;
};

/***/ }),
/* 2059 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = StaffPerformanceHTMLPreviewGroupingSection;

var _StaffPerformanceHTMLPreviewBaseSection = __webpack_require__(599);

var _StaffPerformanceHTMLPreviewBaseSection2 = _interopRequireDefault(_StaffPerformanceHTMLPreviewBaseSection);

var _constants = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function StaffPerformanceHTMLPreviewGroupingSection() {}

StaffPerformanceHTMLPreviewGroupingSection.prototype = new _StaffPerformanceHTMLPreviewBaseSection2.default();

StaffPerformanceHTMLPreviewGroupingSection.prototype.init = function (firstGroupingLevel, secondGroupingLevel, thirdGroupingLevel, longView, columnsStrategy) {
    _StaffPerformanceHTMLPreviewBaseSection2.default.prototype.init.call(this, columnsStrategy);

    this.firstGroupingLevel = firstGroupingLevel;
    this.secondGroupingLevel = secondGroupingLevel;
    this.thirdGroupingLevel = thirdGroupingLevel;
    this.longView = longView;
    return this;
};

StaffPerformanceHTMLPreviewGroupingSection.prototype.addRows = function (tBody) {
    this.addRow(tBody, this.makeGroupingTotalRow());

    var maxGroupingRows = this.longView ? 8 : 5;
    var groupingRows = 0;
    while (true) {
        this.addRow(tBody, this.makeGroupingRow("firstGrouping", "firstLevel", this.firstGroupingLevel));
        groupingRows++;
        if (groupingRows >= maxGroupingRows) break;

        if (this.secondGroupingLevel !== _constants.ReportGroupingLevel.NONE) {
            this.addRow(tBody, this.makeGroupingRow("secondGrouping", "secondLevel", this.secondGroupingLevel));
            groupingRows++;
            if (groupingRows >= maxGroupingRows) break;
        }

        if (this.thirdGroupingLevel !== _constants.ReportGroupingLevel.NONE) {
            var tgRow = this.makeThirdGroupingRow();
            this.addRow(tBody, tgRow);
            groupingRows++;
            if (groupingRows >= maxGroupingRows) break;
            if (this.secondGroupingLevel !== _constants.ReportGroupingLevel.NONE && groupingRows < maxGroupingRows && ReportPreviewUtils.isLevelCanBeAddedMoreThanOnce(this.thirdGroupingLevel, [this.firstGroupingLevel, this.secondGroupingLevel])) {
                tgRow = this.makeThirdGroupingRow();
                this.addRow(tBody, tgRow);
                groupingRows++;
                if (groupingRows >= maxGroupingRows) break;
            }
        }
    }
};

StaffPerformanceHTMLPreviewGroupingSection.prototype.makeGroupingTotalRow = function () {
    return this.createRowWithMainAndDataCells("groupingTotal", this.message("report.staffoutput.total_working_time"), "groupingTotalCell firstChild");
};

StaffPerformanceHTMLPreviewGroupingSection.prototype.makeThirdGroupingRow = function () {
    var cellClassName = this.secondGroupingLevel === _constants.ReportGroupingLevel.NONE ? "secondLevel" : "thirdLevel";
    return this.makeGroupingRow("thirdGrouping", cellClassName, this.thirdGroupingLevel);
};

StaffPerformanceHTMLPreviewGroupingSection.prototype.makeGroupingRow = function (rowClassName, cellClassName, groupingLevel) {
    return this.createRowWithMainAndDataCells(rowClassName, ReportPreviewUtils.getLevelPreviewName(groupingLevel), cellClassName + " firstChild");
};

/***/ }),
/* 2060 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = StaffPerformanceHTMLPreviewLeaveSection;

var _StaffPerformanceHTMLPreviewBaseSection = __webpack_require__(599);

var _StaffPerformanceHTMLPreviewBaseSection2 = _interopRequireDefault(_StaffPerformanceHTMLPreviewBaseSection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function StaffPerformanceHTMLPreviewLeaveSection() {}

StaffPerformanceHTMLPreviewLeaveSection.prototype = new _StaffPerformanceHTMLPreviewBaseSection2.default();

StaffPerformanceHTMLPreviewLeaveSection.prototype.init = function (columnsStrategy) {
    _StaffPerformanceHTMLPreviewBaseSection2.default.prototype.init.call(this, columnsStrategy);
    return this;
};

StaffPerformanceHTMLPreviewLeaveSection.prototype.addRows = function (tBody) {
    this.addRow(tBody, this.makeGrandTotalRow());
    this.addRow(tBody, this.makeLeaveRow());
    this.addRow(tBody, this.makeLeaveRow());
};

StaffPerformanceHTMLPreviewLeaveSection.prototype.makeGrandTotalRow = function () {
    return this.createRowWithMainAndDataCells("grandTotal", this.message("report.staffoutput.total_working_leave_time"), "grandTotalCell");
};

StaffPerformanceHTMLPreviewLeaveSection.prototype.makeLeaveRow = function () {
    return this.createRowWithMainAndDataCells("leave", this.message("report.preview.leave_type"), "leaveType");
};

/***/ }),
/* 2061 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = StaffPerformanceCSVPreviewGenerator;

var _CSVParametersBuilder = __webpack_require__(150);

var _CSVParametersBuilder2 = _interopRequireDefault(_CSVParametersBuilder);

var _constants = __webpack_require__(4);

var _StaffPerformanceCSVPreviewHeader = __webpack_require__(2062);

var _StaffPerformanceCSVPreviewHeader2 = _interopRequireDefault(_StaffPerformanceCSVPreviewHeader);

var _StaffPerformanceCSVPreviewGroupingSection = __webpack_require__(2063);

var _StaffPerformanceCSVPreviewGroupingSection2 = _interopRequireDefault(_StaffPerformanceCSVPreviewGroupingSection);

var _StaffPerformanceCSVPreviewLeavesSection = __webpack_require__(2064);

var _StaffPerformanceCSVPreviewLeavesSection2 = _interopRequireDefault(_StaffPerformanceCSVPreviewLeavesSection);

var _CSVPreviewEmptySection = __webpack_require__(324);

var _CSVPreviewEmptySection2 = _interopRequireDefault(_CSVPreviewEmptySection);

var _CSVParametersSection = __webpack_require__(170);

var _CSVParametersSection2 = _interopRequireDefault(_CSVParametersSection);

var _StaffPerformanceCSVPreviewOnlyUserColumnsStrategy = __webpack_require__(2065);

var _StaffPerformanceCSVPreviewOnlyUserColumnsStrategy2 = _interopRequireDefault(_StaffPerformanceCSVPreviewOnlyUserColumnsStrategy);

var _StaffPerformanceCSVPreviewOnlyGroupsColumnsStrategy = __webpack_require__(600);

var _StaffPerformanceCSVPreviewOnlyGroupsColumnsStrategy2 = _interopRequireDefault(_StaffPerformanceCSVPreviewOnlyGroupsColumnsStrategy);

var _StaffPerformanceCSVPreviewUsersByGroupsWithSubtotalsColumnsStrategy = __webpack_require__(2066);

var _StaffPerformanceCSVPreviewUsersByGroupsWithSubtotalsColumnsStrategy2 = _interopRequireDefault(_StaffPerformanceCSVPreviewUsersByGroupsWithSubtotalsColumnsStrategy);

var _UserGroupMessageProvider = __webpack_require__(990);

var _UserGroupMessageProvider2 = _interopRequireDefault(_UserGroupMessageProvider);

var _TimeZoneGroupMessageProvider = __webpack_require__(992);

var _TimeZoneGroupMessageProvider2 = _interopRequireDefault(_TimeZoneGroupMessageProvider);

var _StaffPerformanceCSVPreviewUsersByGroupsWithoutSubtotalsColumnsStrategy = __webpack_require__(2067);

var _StaffPerformanceCSVPreviewUsersByGroupsWithoutSubtotalsColumnsStrategy2 = _interopRequireDefault(_StaffPerformanceCSVPreviewUsersByGroupsWithoutSubtotalsColumnsStrategy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function StaffPerformanceCSVPreviewGenerator() {}

StaffPerformanceCSVPreviewGenerator.prototype.init = function () {
    return this;
};

StaffPerformanceCSVPreviewGenerator.prototype.generatePreviewTable = function (reportParameters, reportParamsStringBuilder) {
    var numOfGroupingColumns = ReportPreviewUtils.countNotEmptyLevels([reportParameters.firstGroupingLevel, reportParameters.secondGroupingLevel, reportParameters.thirdGroupingLevel]);

    var columnsConfig = reportParameters.columnsConfig;
    var groupMessageProvider = this.getGroupMessageProvider(columnsConfig);

    var needSwitchToMe = reportParameters.needSwitchToMe;
    var includeOtherUsersColumn = reportParameters.includeOtherUsersColumn;

    var columnsStrategy = void 0;

    switch (columnsConfig) {
        case _constants.StaffPerformanceColumnsConfig.USERS_ONLY:
            columnsStrategy = new _StaffPerformanceCSVPreviewOnlyUserColumnsStrategy2.default().init(includeOtherUsersColumn, needSwitchToMe);
            break;
        case _constants.StaffPerformanceColumnsConfig.GROUPS_ONLY:
        case _constants.StaffPerformanceColumnsConfig.TZ_GROUPS_ONLY:
            columnsStrategy = new _StaffPerformanceCSVPreviewOnlyGroupsColumnsStrategy2.default().init(includeOtherUsersColumn, groupMessageProvider);
            break;
        case _constants.StaffPerformanceColumnsConfig.USERS_BY_GROUPS_WITHOUT_SUBTOTALS:
        case _constants.StaffPerformanceColumnsConfig.USERS_BY_TIME_ZONE_GROUPS_WITHOUT_SUBTOTALS:
            columnsStrategy = new _StaffPerformanceCSVPreviewUsersByGroupsWithoutSubtotalsColumnsStrategy2.default().init(includeOtherUsersColumn, groupMessageProvider);
            break;
        case _constants.StaffPerformanceColumnsConfig.USERS_BY_GROUPS_WITH_SUBTOTALS:
        case _constants.StaffPerformanceColumnsConfig.USERS_BY_TIME_ZONE_GROUPS_WITH_SUBTOTALS:
            columnsStrategy = new _StaffPerformanceCSVPreviewUsersByGroupsWithSubtotalsColumnsStrategy2.default().init(includeOtherUsersColumn, groupMessageProvider);
            break;
    }

    var numOfDataColumns = columnsStrategy.getNumOfDataColumns();

    var header = new _StaffPerformanceCSVPreviewHeader2.default().init(reportParameters.firstGroupingLevel, reportParameters.secondGroupingLevel, reportParameters.thirdGroupingLevel, columnsStrategy, columnsConfig, numOfGroupingColumns, groupMessageProvider);

    var dataGroupingSection = new _StaffPerformanceCSVPreviewGroupingSection2.default().init(reportParameters.firstGroupingLevel, reportParameters.secondGroupingLevel, reportParameters.thirdGroupingLevel, columnsStrategy, header.hasGroupingRow() ? 2 : 3);

    var table = document.createElement("table");
    table.className = "reportCsvPreviewTable staffPerfomance";
    var tBody = document.createElement("tbody");
    table.appendChild(tBody);

    var totalColumnsNum = numOfGroupingColumns + numOfDataColumns;
    ReportPreviewUtils.addSheetHeaderRow(tBody, totalColumnsNum);

    var paramsBuilder = new _CSVParametersBuilder2.default().init();
    paramsBuilder.addDateRangeParam(reportParameters.dateRangeSelection, reportParamsStringBuilder);
    paramsBuilder.addCPParam(reportParameters.customersProjectsSelection, reportParamsStringBuilder);
    paramsBuilder.addUsersParam(reportParameters.userSelection, reportParamsStringBuilder);
    if (EnabledFeatures.TTA) paramsBuilder.addTimeTrackStatusParam(reportParameters.timeApprovalStatus);

    var parametersSection = new _CSVParametersSection2.default().init(paramsBuilder, totalColumnsNum);

    parametersSection.addRows(tBody);
    header.addRows(tBody);
    dataGroupingSection.addRows(tBody);

    if (reportParameters.showLeaveTime) new _StaffPerformanceCSVPreviewLeavesSection2.default().init(columnsStrategy, numOfGroupingColumns).addRows(tBody);else new _CSVPreviewEmptySection2.default().init(5, totalColumnsNum).addRows(tBody);

    return table;
};

StaffPerformanceCSVPreviewGenerator.prototype.getGroupMessageProvider = function (columnConfig) {
    switch (columnConfig) {
        case _constants.StaffPerformanceColumnsConfig.GROUPS_ONLY:
        case _constants.StaffPerformanceColumnsConfig.USERS_BY_GROUPS_WITH_SUBTOTALS:
        case _constants.StaffPerformanceColumnsConfig.USERS_BY_GROUPS_WITHOUT_SUBTOTALS:
            return new _UserGroupMessageProvider2.default();
        case _constants.StaffPerformanceColumnsConfig.USERS_BY_TIME_ZONE_GROUPS_WITHOUT_SUBTOTALS:
        case _constants.StaffPerformanceColumnsConfig.TZ_GROUPS_ONLY:
        case _constants.StaffPerformanceColumnsConfig.USERS_BY_TIME_ZONE_GROUPS_WITH_SUBTOTALS:
            return new _TimeZoneGroupMessageProvider2.default();
    }
};

/***/ }),
/* 2062 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = StaffPerformanceCSVPreviewHeader;

var _CSVPreviewSection = __webpack_require__(43);

var _CSVPreviewSection2 = _interopRequireDefault(_CSVPreviewSection);

var _constants = __webpack_require__(4);

var _constants2 = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function StaffPerformanceCSVPreviewHeader() {}

StaffPerformanceCSVPreviewHeader.prototype = new _CSVPreviewSection2.default();

StaffPerformanceCSVPreviewHeader.prototype.init = function (firstGroupingLevel, secondGroupingLevel, thirdGroupingLevel, columnsStrategy, columnsConfig, numOfGroupingCols) {
    _CSVPreviewSection2.default.prototype.init.call(this);
    this.firstGroupingLevel = firstGroupingLevel;
    this.secondGroupingLevel = secondGroupingLevel;
    this.thirdGroupingLevel = thirdGroupingLevel;
    this.columnsStrategy = columnsStrategy;
    this.columnsConfig = columnsConfig;
    this.numOfGroupingCols = numOfGroupingCols;
    return this;
};

StaffPerformanceCSVPreviewHeader.prototype.hasGroupingRow = function () {
    return this.columnsConfig === _constants.StaffPerformanceColumnsConfig.USERS_BY_GROUPS_WITH_SUBTOTALS || this.columnsConfig === _constants.StaffPerformanceColumnsConfig.USERS_BY_GROUPS_WITHOUT_SUBTOTALS || this.columnsConfig === _constants.StaffPerformanceColumnsConfig.USERS_BY_TIME_ZONE_GROUPS_WITH_SUBTOTALS || this.columnsConfig === _constants.StaffPerformanceColumnsConfig.USERS_BY_TIME_ZONE_GROUPS_WITHOUT_SUBTOTALS;
};

StaffPerformanceCSVPreviewHeader.prototype.addRows = function (tBody) {
    if (this.hasGroupingRow()) {
        var groupingHeaderRow = this.createRow();
        ReportPreviewUtils.addEmptyCells(groupingHeaderRow, this.numOfGroupingCols);
        this.columnsStrategy.addColumnGropingHeaderRowCells(groupingHeaderRow);
        this.addRow(tBody, groupingHeaderRow);
    }

    var mainHeaderRow = this.createRow();
    this.addCell(mainHeaderRow, ReportPreviewUtils.getLevelPreviewName(this.firstGroupingLevel));
    if (this.secondGroupingLevel !== _constants2.ReportGroupingLevel.NONE) this.addCell(mainHeaderRow, ReportPreviewUtils.getLevelPreviewName(this.secondGroupingLevel));
    if (this.thirdGroupingLevel !== _constants2.ReportGroupingLevel.NONE) this.addCell(mainHeaderRow, ReportPreviewUtils.getLevelPreviewName(this.thirdGroupingLevel));
    this.columnsStrategy.addMainHeaderRowCells(mainHeaderRow);
    this.addRow(tBody, mainHeaderRow);
};

/***/ }),
/* 2063 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = StaffPerformanceCSVPreviewGroupingSection;

var _CSVPreviewSection = __webpack_require__(43);

var _CSVPreviewSection2 = _interopRequireDefault(_CSVPreviewSection);

var _constants = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function StaffPerformanceCSVPreviewGroupingSection() {}

StaffPerformanceCSVPreviewGroupingSection.prototype = new _CSVPreviewSection2.default();
StaffPerformanceCSVPreviewGroupingSection.prototype.init = function (firstGroupingLevel, secondGroupingLevel, thirdGroupingLevel, columnsStrategy, numOfGroupingRows) {
    _CSVPreviewSection2.default.prototype.init.call(this);
    this.firstGroupingLevel = firstGroupingLevel;
    this.secondGroupingLevel = secondGroupingLevel;
    this.thirdGroupingLevel = thirdGroupingLevel;
    this.columnsStrategy = columnsStrategy;
    this.numOfGroupingCols = numOfGroupingRows;
    return this;
};

StaffPerformanceCSVPreviewGroupingSection.prototype.addRows = function (tBody) {
    var emptyRow = this.createRow();
    ReportPreviewUtils.addEmptyCell(emptyRow);

    var totalsRow = this.createRow();
    this.addCellWithFloatingContent(totalsRow, this.message("report.staffoutput.total_working_time"));

    for (var i = 0; i < this.numOfGroupingCols; i++) {
        var row = this.createRow();
        this.addCell(row, ReportPreviewUtils.getLevelPreviewName(this.firstGroupingLevel));
        if (this.secondGroupingLevel !== _constants.ReportGroupingLevel.NONE) this.addCell(row, ReportPreviewUtils.getLevelPreviewName(this.secondGroupingLevel));
        if (this.thirdGroupingLevel !== _constants.ReportGroupingLevel.NONE) this.addCell(row, ReportPreviewUtils.getLevelPreviewName(this.thirdGroupingLevel));
        this.columnsStrategy.addDataCells(row);
        this.addRow(tBody, row);
    }

    if (this.secondGroupingLevel !== _constants.ReportGroupingLevel.NONE) {
        ReportPreviewUtils.addEmptyCell(emptyRow);
        ReportPreviewUtils.addEmptyCell(totalsRow);
    }

    if (this.thirdGroupingLevel !== _constants.ReportGroupingLevel.NONE) {
        ReportPreviewUtils.addEmptyCell(emptyRow);
        ReportPreviewUtils.addEmptyCell(totalsRow);
    }

    this.columnsStrategy.addEmptyCells(emptyRow);
    this.addRow(tBody, emptyRow);

    this.columnsStrategy.addDataCells(totalsRow);
    this.addRow(tBody, totalsRow);
};

/***/ }),
/* 2064 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = StaffPerformanceCSVPreviewLeavesSection;

var _CSVPreviewSection = __webpack_require__(43);

var _CSVPreviewSection2 = _interopRequireDefault(_CSVPreviewSection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function StaffPerformanceCSVPreviewLeavesSection() {}

StaffPerformanceCSVPreviewLeavesSection.prototype = new _CSVPreviewSection2.default();

StaffPerformanceCSVPreviewLeavesSection.prototype.init = function (columnsStrategy, numOfGroupingCols) {
    _CSVPreviewSection2.default.prototype.init.call(this);
    this.columnsStrategy = columnsStrategy;
    this.numOfGroupingCols = numOfGroupingCols;
    return this;
};

StaffPerformanceCSVPreviewLeavesSection.prototype.addRows = function (tBody) {
    this.addEmptyRow(tBody);

    for (var i = 0; i < 2; i++) {
        var row = this.createRow();
        ReportPreviewUtils.addCell(row, this.message("leave_type.leave_type"));
        ReportPreviewUtils.addEmptyCells(row, this.numOfGroupingCols - 1);
        this.columnsStrategy.addDataCells(row);
        this.addRow(tBody, row);
    }

    this.addEmptyRow(tBody);

    var totalsRow = this.createRow();
    if (this.numOfGroupingCols === 1) this.addCell(totalsRow, this.message("report.staffoutput.total_working_leave_time"));else this.addCellWithFloatingContent(totalsRow, this.message("report.staffoutput.total_working_leave_time"));
    ReportPreviewUtils.addEmptyCells(totalsRow, this.numOfGroupingCols - 1);
    this.columnsStrategy.addDataCells(totalsRow);
    this.addRow(tBody, totalsRow);
};

StaffPerformanceCSVPreviewLeavesSection.prototype.addEmptyRow = function (tBody) {
    var emptyRow = this.createRow();
    ReportPreviewUtils.addEmptyCells(emptyRow, this.numOfGroupingCols);
    this.columnsStrategy.addEmptyCells(emptyRow);
    this.addRow(tBody, emptyRow);
};

/***/ }),
/* 2065 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = StaffPerformanceCSVPreviewOnlyUserColumnsStrategy;

var _StaffPerformanceCSVPreviewBaseColumnsStrategy = __webpack_require__(412);

var _StaffPerformanceCSVPreviewBaseColumnsStrategy2 = _interopRequireDefault(_StaffPerformanceCSVPreviewBaseColumnsStrategy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function StaffPerformanceCSVPreviewOnlyUserColumnsStrategy() {}

StaffPerformanceCSVPreviewOnlyUserColumnsStrategy.prototype = Object.create(_StaffPerformanceCSVPreviewBaseColumnsStrategy2.default.prototype);

StaffPerformanceCSVPreviewOnlyUserColumnsStrategy.prototype.init = function (includeOtherUsersColumn, needSwitchToMe) {
    _StaffPerformanceCSVPreviewBaseColumnsStrategy2.default.prototype.init.call(this, includeOtherUsersColumn);
    this.needSwitchToMe = needSwitchToMe;
    return this;
};

StaffPerformanceCSVPreviewOnlyUserColumnsStrategy.prototype.addMainHeaderRowCells = function (mainHeaderRow) {
    _StaffPerformanceCSVPreviewBaseColumnsStrategy2.default.prototype.addMainHeaderRowCells.call(this, mainHeaderRow);

    var colTitle = "";
    if (this.needSwitchToMe) {
        colTitle = this.message("report.common.me");
    } else {
        colTitle = this.message("report.common.user");
    }

    this.addCell(mainHeaderRow, colTitle);
    if (!this.needSwitchToMe) this.addCell(mainHeaderRow, colTitle);
    if (this.includeOtherUsersColumn) this.addCell(mainHeaderRow, this.message("report.common.others"));
};

StaffPerformanceCSVPreviewOnlyUserColumnsStrategy.prototype.addColumnGropingHeaderRowCells = function (colGroupingRow) {
    //do nothing
};

StaffPerformanceCSVPreviewOnlyUserColumnsStrategy.prototype.getNumOfDataColumns = function () {
    var numOfDataColumns = 2;
    if (!this.needSwitchToMe) numOfDataColumns++;
    if (this.includeOtherUsersColumn) numOfDataColumns++;

    return numOfDataColumns;
};

/***/ }),
/* 2066 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = StaffPerformanceCSVPreviewUsersByGroupsWithSubtotalsColumnsStrategy;

var _StaffPerformanceCSVPreviewBaseColumnsStrategy = __webpack_require__(412);

var _StaffPerformanceCSVPreviewBaseColumnsStrategy2 = _interopRequireDefault(_StaffPerformanceCSVPreviewBaseColumnsStrategy);

var _StaffPerformanceCSVPreviewOnlyGroupsColumnsStrategy = __webpack_require__(600);

var _StaffPerformanceCSVPreviewOnlyGroupsColumnsStrategy2 = _interopRequireDefault(_StaffPerformanceCSVPreviewOnlyGroupsColumnsStrategy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function StaffPerformanceCSVPreviewUsersByGroupsWithSubtotalsColumnsStrategy() {}

StaffPerformanceCSVPreviewUsersByGroupsWithSubtotalsColumnsStrategy.prototype = Object.create(_StaffPerformanceCSVPreviewOnlyGroupsColumnsStrategy2.default.prototype);

StaffPerformanceCSVPreviewUsersByGroupsWithSubtotalsColumnsStrategy.prototype.init = function (includeOtherUsersColumn, groupMessageProvider) {
    _StaffPerformanceCSVPreviewOnlyGroupsColumnsStrategy2.default.prototype.init.call(this, includeOtherUsersColumn, groupMessageProvider);
    return this;
};

StaffPerformanceCSVPreviewUsersByGroupsWithSubtotalsColumnsStrategy.prototype.addMainHeaderRowCells = function (mainHeaderRow) {
    _StaffPerformanceCSVPreviewBaseColumnsStrategy2.default.prototype.addMainHeaderRowCells.call(this, mainHeaderRow);

    var colTitle = this.message("report.common.user");

    this.addCell(mainHeaderRow, this.message("report.subtotal"));
    this.addCell(mainHeaderRow, colTitle);

    if (this.includeOtherUsersColumn) {
        this.addCell(mainHeaderRow, this.message("report.common.others"));
    } else {
        this.addCell(mainHeaderRow, colTitle);
    }
};

StaffPerformanceCSVPreviewUsersByGroupsWithSubtotalsColumnsStrategy.prototype.addColumnGropingHeaderRowCells = function (colGroupingRow) {
    _StaffPerformanceCSVPreviewBaseColumnsStrategy2.default.prototype.addColumnGropingHeaderRowCells.call(this, colGroupingRow);
    this.addCell(colGroupingRow, this.message(this.groupMessageProvider.getGroupNameSingularKey()));
    this.addCell(colGroupingRow, this.message(this.groupMessageProvider.getGroupNameSingularKey()));

    if (this.includeOtherUsersColumn) {
        this.addCell(colGroupingRow, ""); // above Others
    } else {
        this.addCell(colGroupingRow, this.message(this.groupMessageProvider.getGroupNameSingularKey()));
    }
};

StaffPerformanceCSVPreviewUsersByGroupsWithSubtotalsColumnsStrategy.prototype.getNumOfDataColumns = function () {
    return 4;
};

/***/ }),
/* 2067 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = StaffPerformanceCSVPreviewUsersByGroupsWithoutSubtotalsColumnsStrategy;

var _StaffPerformanceCSVPreviewBaseColumnsStrategy = __webpack_require__(412);

var _StaffPerformanceCSVPreviewBaseColumnsStrategy2 = _interopRequireDefault(_StaffPerformanceCSVPreviewBaseColumnsStrategy);

var _StaffPerformanceCSVPreviewOnlyGroupsColumnsStrategy = __webpack_require__(600);

var _StaffPerformanceCSVPreviewOnlyGroupsColumnsStrategy2 = _interopRequireDefault(_StaffPerformanceCSVPreviewOnlyGroupsColumnsStrategy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function StaffPerformanceCSVPreviewUsersByGroupsWithoutSubtotalsColumnsStrategy() {}

StaffPerformanceCSVPreviewUsersByGroupsWithoutSubtotalsColumnsStrategy.prototype = Object.create(_StaffPerformanceCSVPreviewOnlyGroupsColumnsStrategy2.default.prototype);

StaffPerformanceCSVPreviewUsersByGroupsWithoutSubtotalsColumnsStrategy.prototype.init = function (includeOtherUsersColumn, groupMessageProvider) {
    _StaffPerformanceCSVPreviewOnlyGroupsColumnsStrategy2.default.prototype.init.call(this, includeOtherUsersColumn, groupMessageProvider);
    return this;
};

StaffPerformanceCSVPreviewUsersByGroupsWithoutSubtotalsColumnsStrategy.prototype.addMainHeaderRowCells = function (mainHeaderRow) {
    _StaffPerformanceCSVPreviewBaseColumnsStrategy2.default.prototype.addMainHeaderRowCells.call(this, mainHeaderRow);

    var colTitle = this.message("report.common.user");

    this.addCell(mainHeaderRow, colTitle);
    this.addCell(mainHeaderRow, colTitle);

    if (this.includeOtherUsersColumn) this.addCell(mainHeaderRow, this.message("report.common.others"));
};

StaffPerformanceCSVPreviewUsersByGroupsWithoutSubtotalsColumnsStrategy.prototype.addColumnGropingHeaderRowCells = function (colGroupingRow) {
    _StaffPerformanceCSVPreviewBaseColumnsStrategy2.default.prototype.addColumnGropingHeaderRowCells.call(this, colGroupingRow);
    this.addCell(colGroupingRow, this.message(this.groupMessageProvider.getGroupNameSingularKey()));
    this.addCell(colGroupingRow, this.message(this.groupMessageProvider.getGroupNameSingularKey()));
    if (this.includeOtherUsersColumn) this.addCell(colGroupingRow, ""); // above Others
};

StaffPerformanceCSVPreviewUsersByGroupsWithoutSubtotalsColumnsStrategy.prototype.getNumOfDataColumns = function () {
    return this.includeOtherUsersColumn ? 4 : 3;
};

/***/ }),
/* 2068 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = StaffOutputReportMediator;

var _OldReportMediator = __webpack_require__(268);

var _OldReportMediator2 = _interopRequireDefault(_OldReportMediator);

var _constants = __webpack_require__(11);

var _StaffOutputReportEditConfigController = __webpack_require__(988);

var _StaffOutputReportEditConfigController2 = _interopRequireDefault(_StaffOutputReportEditConfigController);

var _jquery_rpc = __webpack_require__(26);

var _jquery_rpc2 = _interopRequireDefault(_jquery_rpc);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _ReportPrintableHeadersBuilder = __webpack_require__(171);

var _ReportPrintableHeadersBuilder2 = _interopRequireDefault(_ReportPrintableHeadersBuilder);

var _LoadingPopup = __webpack_require__(299);

var _LoadingPopup2 = _interopRequireDefault(_LoadingPopup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function StaffOutputReportMediator() {
    this.constructor = StaffOutputReportMediator;
}

StaffOutputReportMediator.prototype = _.create(_OldReportMediator2.default.prototype);

StaffOutputReportMediator.prototype.init = function (config) {
    _OldReportMediator2.default.prototype.init.call(this, config);

    this._loadingDataPopup = new _LoadingPopup2.default().init('commentsDataLoadingPopup');
    this.commentsLightBoxPopupId = 'commentsLightBox';

    return this;
};

StaffOutputReportMediator.prototype.getReportType = function () {
    return _constants.ReportType.STAFF_PERFORMANCE;
};

StaffOutputReportMediator.prototype.initEditConfigController = function (config) {
    var self = this;
    return new _StaffOutputReportEditConfigController2.default().init({
        reportParameters: config.reportParameters,
        reportAuthorizationInfo: config.reportAuthorizationInfo,
        users: config.users,
        manageableUsersIds: config.manageableUserIds,
        userGroups: config.userGroups,
        timeZoneGroups: config.timeZoneGroups,
        cpList: config.cpList,
        customersWithMaIds: config.customersWithMaIds,
        projectsWithMaIds: config.projectsWithMaIds,
        changeCallback: function changeCallback() {
            self.changeParametersCallback();
        }
    });
};

// show comments popup (make RPC call for loading comments)
StaffOutputReportMediator.prototype.showCommentsPopup = function (identity, whoseCommentsId) {
    this._loadingDataPopup.show();
    var self = this;
    // fill parameters for rpc call
    var params = [identity, whoseCommentsId, this.reportParameters.customersProjectsSelection, this.reportParameters.dateRangeSelection, this.reportParameters.timeApprovalStatus];

    (0, _jquery_rpc2.default)("RetrieveCommentsService.getComments", params, function (result) {
        self._successLoadingUserComments(result);
    }, function (jqXHR, textStatus, errorThrown) {
        if (self._errorLoadingUserComments(jqXHR, textStatus, errorThrown)) return true;
    });
};

// if data loading init comments popup and show
StaffOutputReportMediator.prototype._successLoadingUserComments = function (userCommentsData) {
    var commentsPopup = new ShowCommentsLightBox().init(userCommentsData, this.commentsLightBoxPopupId, this.reportParameters.timeFormat);
    // callback for close button
    commentsPopup.setCancelCallback(function () {
        commentsPopup.hide();
    });
    this._loadingDataPopup.hide(); // hide spinner
    commentsPopup.show();
};
// error handler
StaffOutputReportMediator.prototype._errorLoadingUserComments = function (jqXHR, textStatus, errorThrown) {
    this._loadingDataPopup.hide(); // hide spinner

    if (this._noRightsHandler(errorThrown)) return true;

    if (errorThrown.exception && errorThrown.exception === 'com.actimind.actitime.administration.NoSuchUserException') {
        alert(_messageResource2.default.getMessage("report_comments.no_such_user"));
        return true;
    }
};

StaffOutputReportMediator.prototype._populateHeadersArray = function (headersArray) {
    this.printableHeadersBuilder.addCPSelectionParamsStringToArray(this.reportParameters.customersProjectsSelection, headersArray); //customers and projects
    this.printableHeadersBuilder.addStaffSelectionParamsToArray(this.reportParameters.userSelection, headersArray); //staff
    this.printableHeadersBuilder.addTimeApprovalStatusToArray(this.reportParameters.timeApprovalStatus, headersArray); //time approval status
};

StaffOutputReportMediator.prototype.initPrintableHeadersBuilder = function (config) {
    return new _ReportPrintableHeadersBuilder2.default().init({
        users: config.users,
        reportParameters: config.reportParameters,
        cpList: config.cpList,
        isFilteredByAssignments: config.isFilteredByAssignments,
        userGroups: config.userGroups,
        timeZoneGroups: config.timeZoneGroups
    });
};

/***/ }),
/* 2069 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = TTDetailReportMediator;

var _OldReportMediator = __webpack_require__(268);

var _OldReportMediator2 = _interopRequireDefault(_OldReportMediator);

var _constants = __webpack_require__(11);

var _ReportPrintableHeadersBuilder = __webpack_require__(171);

var _ReportPrintableHeadersBuilder2 = _interopRequireDefault(_ReportPrintableHeadersBuilder);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _TTDetailReportEditResultConfigController = __webpack_require__(2070);

var _TTDetailReportEditResultConfigController2 = _interopRequireDefault(_TTDetailReportEditResultConfigController);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function TTDetailReportMediator() {
    this.constructor = TTDetailReportMediator;
}

TTDetailReportMediator.prototype = _underscore2.default.create(_OldReportMediator2.default.prototype);

TTDetailReportMediator.prototype.init = function (config) {
    _OldReportMediator2.default.prototype.init.call(this, config);

    return this;
};

TTDetailReportMediator.prototype.getReportType = function () {
    return _constants.ReportType.TIME_TRACK_IN_DETAIL;
};

TTDetailReportMediator.prototype.initEditConfigController = function (config) {
    var self = this;
    return new _TTDetailReportEditResultConfigController2.default().init({
        reportAuthorizationInfo: config.reportAuthorizationInfo,
        reportParameters: config.reportParameters,
        cpList: config.cpList,
        customersWithMaIds: config.customersWithMaIds,
        projectsWithMaIds: config.projectsWithMaIds,
        users: config.users,
        manageableUsersIds: config.manageableUserIds,
        userGroups: config.userGroups,
        timeZoneGroups: config.timeZoneGroups,
        changeCallback: function changeCallback() {
            self.changeParametersCallback();
        }
    });
};

TTDetailReportMediator.prototype.initPrintableHeadersBuilder = function (config) {
    return new _ReportPrintableHeadersBuilder2.default().init({
        reportParameters: config.reportParameters,
        cpList: config.cpList,
        users: config.users,
        userGroups: config.userGroups,
        timeZoneGroups: config.timeZoneGroups,
        isFilteredByAssignments: config.isFilteredByAssignments
    });
};

TTDetailReportMediator.prototype._populateHeadersArray = function (headersArray) {
    this.printableHeadersBuilder.addCPSelectionParamsStringToArray(this.reportParameters.customersProjectsSelection, headersArray); //customers and projects
    this.printableHeadersBuilder.addStaffSelectionParamsToArray(this.reportParameters.userSelection, headersArray); //staff
    this.printableHeadersBuilder.addTimeApprovalStatusToArray(this.reportParameters.timeApprovalStatus, headersArray); //time approval status
};

/***/ }),
/* 2070 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _TTDetailReportEditConfigController = __webpack_require__(993);

var _TTDetailReportEditConfigController2 = _interopRequireDefault(_TTDetailReportEditConfigController);

var _SimpleSingletonTooltip = __webpack_require__(45);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TTDetailReportEditResultConfigController = function (_TTDetailReportEditCo) {
    _inherits(TTDetailReportEditResultConfigController, _TTDetailReportEditCo);

    function TTDetailReportEditResultConfigController() {
        _classCallCheck(this, TTDetailReportEditResultConfigController);

        return _possibleConstructorReturn(this, (TTDetailReportEditResultConfigController.__proto__ || Object.getPrototypeOf(TTDetailReportEditResultConfigController)).apply(this, arguments));
    }

    return TTDetailReportEditResultConfigController;
}(_TTDetailReportEditConfigController2.default);

exports.default = TTDetailReportEditResultConfigController;


TTDetailReportEditResultConfigController.prototype.init = function (config) {
    _TTDetailReportEditConfigController2.default.prototype.init.call(this, config);

    (0, _jquery2.default)("#joinCommentsInfoContainer").show();

    (0, _SimpleSingletonTooltip.getInstance)().subscribeToMouseEvents((0, _jquery2.default)("#joinCommentsInfo"), function () {
        (0, _SimpleSingletonTooltip.getInstance)().setState({
            text: _messageResource2.default.getMessage('reports.comments_report.form.format.joined_comments_note'),
            extraClass: 'joinCommentsTooltip'
        });
    });

    return this;
};

TTDetailReportEditResultConfigController.prototype.makeReportParamsAccordingToFeatures = function (reportParameters) {
    return reportParameters;
};

/***/ }),
/* 2071 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = TTDetailsReportGroupingSelector;

var _GroupingSelector = __webpack_require__(322);

var _GroupingSelector2 = _interopRequireDefault(_GroupingSelector);

var _constants = __webpack_require__(11);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _features = __webpack_require__(22);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function TTDetailsReportGroupingSelector() {
    this.constructor = TTDetailsReportGroupingSelector;
}

TTDetailsReportGroupingSelector.prototype = _underscore2.default.create(_GroupingSelector2.default.prototype);

TTDetailsReportGroupingSelector.prototype.init = function (selectorId, selectedValues, changesCallback) {
    this.isBTYEnabled = (0, _features.isEnabled)(_features.Feature.BTY) || this._checkGroupingLevel(_constants.ReportGroupingLevel.BILLING_TYPE, selectedValues);
    this.isUGREnabled = (0, _features.isEnabled)(_features.Feature.UGR) || this._checkGroupingLevel(_constants.ReportGroupingLevel.USER_GROUP, selectedValues);

    this.dateGroupingOrderList = [_constants.ReportGroupingLevel.MONTH, _constants.ReportGroupingLevel.WEEK, _constants.ReportGroupingLevel.DATE];

    this.maxLevels = 3;

    this.numberOfVisibleLevels = this.maxLevels; // init show all levels

    _GroupingSelector2.default.prototype.init.call(this, selectorId, this.maxLevels, selectedValues, changesCallback);

    this.setNumberOfVisibleLevels(this.calculateNumberOfVisibleLevels(selectedValues)); // hide rows if need

    this.errorMessagesMap[_GroupingSelector2.default.ERROR_GROUPING_DUPLICATE] = _messageResource2.default.getMessage("report.form.choose_grouping_opts");

    return this;
};
TTDetailsReportGroupingSelector.prototype._checkGroupingLevel = function (levelValue, selectedValues) {
    for (var i = 0; i < selectedValues.length; i++) {
        if (selectedValues[i] === levelValue) {
            return true;
        }
    }
    return false;
};

TTDetailsReportGroupingSelector.prototype.initListSelector = function (level, selectedValue, changesCallback) {
    if (!selectedValue || selectedValue === _constants.ReportGroupingLevel.NONE) // set init values for selector if need
        selectedValue = level === 0 ? _constants.ReportGroupingLevel.CUSTOMER : level === 1 ? _constants.ReportGroupingLevel.PROJECT : _constants.ReportGroupingLevel.TASK;

    return _GroupingSelector2.default.prototype.initListSelector.call(this, level, selectedValue, changesCallback);
};

TTDetailsReportGroupingSelector.prototype.fillListSelector = function (listSelector) {
    listSelector.addItems([{
        text: _messageResource2.default.getEscapedMessage("common.Customers"),
        value: _constants.ReportGroupingLevel.CUSTOMER
    }, {
        text: _messageResource2.default.getEscapedMessage("common.Projects"),
        value: _constants.ReportGroupingLevel.PROJECT
    }, {
        text: _messageResource2.default.getMessage("report.form.smth_names", [_messageResource2.default.getEscapedMessage("common.Project")]),
        value: _constants.ReportGroupingLevel.PROJECT_NAME
    }, {
        text: _messageResource2.default.getEscapedMessage("common.Tasks"),
        value: _constants.ReportGroupingLevel.TASK
    }, {
        text: _messageResource2.default.getMessage("report.form.smth_names", [_messageResource2.default.getEscapedMessage("common.Task")]),
        value: _constants.ReportGroupingLevel.TASK_NAME
    }]);
    if (this.isBTYEnabled) {
        listSelector.addItems([{
            text: _messageResource2.default.getMessage("report.form.billing_types"),
            value: _constants.ReportGroupingLevel.BILLING_TYPE
        }]);
    }
    listSelector.addSeparator();
    listSelector.addItems([{
        text: _messageResource2.default.getMessage("report.form.users"),
        value: _constants.ReportGroupingLevel.USER
    }]);
    if (this.isUGREnabled) {
        listSelector.addItems([{
            text: _messageResource2.default.getEscapedMessage("common.User_Groups"),
            value: _constants.ReportGroupingLevel.USER_GROUP
        }]);
    }
    listSelector.addSeparator();
    listSelector.addItems([{
        text: _messageResource2.default.getMessage("reports.comments_report.form.dates"),
        value: _constants.ReportGroupingLevel.DATE
    }, {
        text: _messageResource2.default.getMessage("reports.comments_report.form.weeks"),
        value: _constants.ReportGroupingLevel.WEEK
    }, {
        text: _messageResource2.default.getMessage("reports.comments_report.form.months"),
        value: _constants.ReportGroupingLevel.MONTH
    }]);
};

TTDetailsReportGroupingSelector.prototype.validate = function () {
    if (!_GroupingSelector2.default.prototype.validate.call(this)) return false;

    if (!this.verifyDateGroupingOrder()) {
        this.error = _GroupingSelector2.default.ERROR_INCORRECT_GROUPING_ORDER;
        return false;
    }

    return true;
};

TTDetailsReportGroupingSelector.prototype.setValues = function (values) {
    _GroupingSelector2.default.prototype.setValues.call(this, values);
    this.setNumberOfVisibleLevels(this.calculateNumberOfVisibleLevels(values));
};

TTDetailsReportGroupingSelector.prototype.calculateNumberOfVisibleLevels = function (selection) {
    var nVisibleLevels = 0;
    for (var i = 0; i < selection.length; i++) {
        if (selection[i] !== _constants.ReportGroupingLevel.NONE) {
            nVisibleLevels++;
        }
    }
    return nVisibleLevels;
};

TTDetailsReportGroupingSelector.prototype.getValues = function () {
    var selection = [];

    for (var i = 0; i < this.getNumberOfMaxLevels(); i++) {
        if (i < this.getNumberOfVisibleLevels()) {
            selection.push(this.getListSelectorValue(i));
        } else {
            selection.push(_constants.ReportGroupingLevel.NONE);
        }
    }
    return selection;
};

TTDetailsReportGroupingSelector.prototype.getNumberOfVisibleLevels = function () {
    return this.numberOfVisibleLevels;
};

TTDetailsReportGroupingSelector.prototype.getNumberOfMaxLevels = function () {
    return this.maxLevels;
};

TTDetailsReportGroupingSelector.prototype.setNumberOfVisibleLevels = function (numberOfLevels) {
    var currentNumberOfLevels = this.getNumberOfVisibleLevels();

    var rowsToHide = currentNumberOfLevels - numberOfLevels;
    var rowsToShow = numberOfLevels - currentNumberOfLevels;

    var i = void 0;
    for (i = 0; i < rowsToHide; i++) {
        this.hideRow(currentNumberOfLevels - i - 1);
    }

    for (i = 0; i < rowsToShow; i++) {
        this.showRow(numberOfLevels - i - 1);
    }

    this.numberOfVisibleLevels = numberOfLevels;
};

TTDetailsReportGroupingSelector.prototype.verifyDateGroupingOrder = function () {
    if (this.getNumberOfVisibleLevels() <= 1) return true;

    var firstLevel = this.dateGroupingOrderList.indexOf(this.getListSelectorValue(0));
    var secondLevel = this.dateGroupingOrderList.indexOf(this.getListSelectorValue(1));

    if (secondLevel >= 0 && secondLevel < firstLevel) return false;

    if (this.getNumberOfVisibleLevels() === 2) return true;

    var thirdLevel = this.dateGroupingOrderList.indexOf(this.getListSelectorValue(2));

    if (thirdLevel < 0) return true;

    return !(thirdLevel < firstLevel || thirdLevel < secondLevel);
};

TTDetailsReportGroupingSelector.prototype.updateTree = function () {
    if (this.getNumberOfVisibleLevels() > 2) this.setRowClassName(2, "tree-row-SA");
    if (this.getNumberOfVisibleLevels() > 1) this.setRowClassName(1, "tree-row-A");
};

/***/ }),
/* 2072 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = TTDetailFormMediator;

var _OldBaseFormMediator = __webpack_require__(271);

var _OldBaseFormMediator2 = _interopRequireDefault(_OldBaseFormMediator);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _TTDetailReportEditFormConfigController = __webpack_require__(2073);

var _TTDetailReportEditFormConfigController2 = _interopRequireDefault(_TTDetailReportEditFormConfigController);

var _TTDetailCSVPreviewGenerator = __webpack_require__(2074);

var _TTDetailCSVPreviewGenerator2 = _interopRequireDefault(_TTDetailCSVPreviewGenerator);

var _TTDetailHTMLPreviewGenerator = __webpack_require__(2079);

var _TTDetailHTMLPreviewGenerator2 = _interopRequireDefault(_TTDetailHTMLPreviewGenerator);

var _ATReportParamsStringBuilder = __webpack_require__(52);

var _ATReportParamsStringBuilder2 = _interopRequireDefault(_ATReportParamsStringBuilder);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function TTDetailFormMediator() {}

TTDetailFormMediator.prototype = _underscore2.default.create(_OldBaseFormMediator2.default.prototype);

TTDetailFormMediator.prototype.init = function (config) {
    _OldBaseFormMediator2.default.prototype.init.call(this, config);
    this._showJoinedCommentsNote(config.reportParameters.joinCommentsByTask);
    return this;
};

TTDetailFormMediator.prototype.initParamsStringBuilder = function (config) {
    return new _ATReportParamsStringBuilder2.default({
        data: {
            cpList: config.cpList,
            users: config.users,
            userGroups: config.userGroups,
            timeZoneGroups: config.timeZoneGroups,
            manageableUserIds: ATReportsStore.getManageableUserIds(),
            projectsWithMaIds: ATReportsStore.getProjectsWithMaIds()
        },
        reportAuthorizationInfo: ATReportsStore.getReportAuthorizationInfo()
    });
};

TTDetailFormMediator.prototype.initEditConfigController = function (config) {
    var self = this;
    return new _TTDetailReportEditFormConfigController2.default().init({
        panelId: "mainContainer",
        reportAuthorizationInfo: config.reportAuthorizationInfo,
        reportParameters: config.reportParameters,
        cpList: config.cpList,
        customersWithMaIds: config.customersWithMaIds,
        projectsWithMaIds: config.projectsWithMaIds,
        users: config.users,
        manageableUsersIds: config.manageableUserIds,
        userGroups: config.userGroups,
        timeZoneGroups: config.timeZoneGroups,
        changeCallback: function changeCallback() {
            self.changeParametersCallback();
        }
    });
};

TTDetailFormMediator.prototype.initCsvGenerator = function () {
    return new _TTDetailCSVPreviewGenerator2.default().init();
};

TTDetailFormMediator.prototype.initHtmlGenerator = function () {
    return new _TTDetailHTMLPreviewGenerator2.default().init();
};

TTDetailFormMediator.prototype.changeParametersCallback = function () {
    _OldBaseFormMediator2.default.prototype.changeParametersCallback.call(this);
    if (this.configController) this._showJoinedCommentsNote(this.configController.getJoinCommentsByTask());
};

TTDetailFormMediator.prototype._createJoinedCommentsNote = function () {
    var element = (0, _jquery2.default)(document.createElement("div"));
    element.addClass("joinCommentsNote");
    element.html(_messageResource2.default.getMessage("reports.comments_report.form.format.joined_comments_note"));
    (0, _jquery2.default)(".reportPreviewArea").append(element);
    return element;
};
TTDetailFormMediator.prototype._showJoinedCommentsNote = function (isShowed) {
    if (!this.commentsNoteElement) {
        this.commentsNoteElement = this._createJoinedCommentsNote();
    }
    var element = this.commentsNoteElement;
    if (isShowed) {
        element.removeClass("hide");
    } else {
        element.addClass("hide");
    }
};

/***/ }),
/* 2073 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _constants = __webpack_require__(11);

var _features = __webpack_require__(22);

var _constants2 = __webpack_require__(4);

var _TTDetailReportEditConfigController = __webpack_require__(993);

var _TTDetailReportEditConfigController2 = _interopRequireDefault(_TTDetailReportEditConfigController);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TTDetailReportEditFormConfigController = function (_TTDetailReportEditCo) {
    _inherits(TTDetailReportEditFormConfigController, _TTDetailReportEditCo);

    function TTDetailReportEditFormConfigController() {
        _classCallCheck(this, TTDetailReportEditFormConfigController);

        return _possibleConstructorReturn(this, (TTDetailReportEditFormConfigController.__proto__ || Object.getPrototypeOf(TTDetailReportEditFormConfigController)).apply(this, arguments));
    }

    return TTDetailReportEditFormConfigController;
}(_TTDetailReportEditConfigController2.default);

exports.default = TTDetailReportEditFormConfigController;


TTDetailReportEditFormConfigController.prototype.makeReportParamsAccordingToFeatures = function (reportParameters) {
    var results = _jquery2.default.extend({}, reportParameters);
    var groupingSelection = [results.firstGroupingLevel, results.secondGroupingLevel, results.thirdGroupingLevel];

    if (!(0, _features.isEnabled)(_features.Feature.BTY)) {
        groupingSelection = this.makeGroupingSelectorValuesAccordingToNotAvailableValueLevel(_constants.ReportGroupingLevel.BILLING_TYPE, groupingSelection);
    }
    if (!(0, _features.isEnabled)(_features.Feature.UGR)) {
        groupingSelection = this.makeGroupingSelectorValuesAccordingToNotAvailableValueLevel(_constants.ReportGroupingLevel.USER_GROUP, groupingSelection);
    }
    if (!(0, _features.isEnabled)(_features.Feature.TTA)) {
        results.timeApprovalStatus = _constants2.TimeApprovalStatus.BOTH;
    }
    results.firstGroupingLevel = groupingSelection[0];
    results.secondGroupingLevel = groupingSelection[1];
    results.thirdGroupingLevel = groupingSelection[2];
    return results;
};

TTDetailReportEditFormConfigController.prototype.getJoinCommentsByTask = function () {
    return this.joinCommentsCheckbox.prop("checked");
};

/***/ }),
/* 2074 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = TTDetailCSVPreviewGenerator;

var _CSVPreviewEmptySection = __webpack_require__(324);

var _CSVPreviewEmptySection2 = _interopRequireDefault(_CSVPreviewEmptySection);

var _CSVParametersBuilder = __webpack_require__(150);

var _CSVParametersBuilder2 = _interopRequireDefault(_CSVParametersBuilder);

var _CSVParametersSection = __webpack_require__(170);

var _CSVParametersSection2 = _interopRequireDefault(_CSVParametersSection);

var _TTDetailCSVPreviewColumnsStrategy = __webpack_require__(2075);

var _TTDetailCSVPreviewColumnsStrategy2 = _interopRequireDefault(_TTDetailCSVPreviewColumnsStrategy);

var _TTDetailCSVPreviewHeader = __webpack_require__(2076);

var _TTDetailCSVPreviewHeader2 = _interopRequireDefault(_TTDetailCSVPreviewHeader);

var _TTDetailCSVPreviewGroupingSection = __webpack_require__(2077);

var _TTDetailCSVPreviewGroupingSection2 = _interopRequireDefault(_TTDetailCSVPreviewGroupingSection);

var _TTDetailCSVPreviewTotalSection = __webpack_require__(2078);

var _TTDetailCSVPreviewTotalSection2 = _interopRequireDefault(_TTDetailCSVPreviewTotalSection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function TTDetailCSVPreviewGenerator() {}

TTDetailCSVPreviewGenerator.prototype.init = function () {
    return this;
};

TTDetailCSVPreviewGenerator.prototype.generatePreviewTable = function (reportParameters, reportParamsStringBuilder) {

    // if there is collision clear third level
    var groupingLevels = TTDetailPreviewUtils.filterGroupingLevelsIfExistCollision([reportParameters.firstGroupingLevel, reportParameters.secondGroupingLevel, reportParameters.thirdGroupingLevel], reportParameters.joinCommentsByTask);

    var notEmptyGroupingLevels = ReportPreviewUtils.filterNotEmptyLevels(groupingLevels);

    var needSwitchToMe = reportParameters.needSwitchToMe;

    var columnStrategy = new _TTDetailCSVPreviewColumnsStrategy2.default().init(notEmptyGroupingLevels, reportParameters.joinCommentsByTask, needSwitchToMe);

    var headerSection = new _TTDetailCSVPreviewHeader2.default().init(columnStrategy);

    var groupingSection = new _TTDetailCSVPreviewGroupingSection2.default().init(notEmptyGroupingLevels.length, columnStrategy);
    var totalSection = new _TTDetailCSVPreviewTotalSection2.default().init(columnStrategy);

    var table = document.createElement("table");
    table.className = "reportCsvPreviewTable ttdetail";
    var tBody = document.createElement("tbody");
    table.appendChild(tBody);

    var totalColumnsNum = notEmptyGroupingLevels.length + columnStrategy.getNumberOfDetailsCells() + 1 + 1; // + total column + comments
    ReportPreviewUtils.addSheetHeaderRow(tBody, totalColumnsNum);

    var paramsBuilder = new _CSVParametersBuilder2.default().init();
    paramsBuilder.addDateRangeParam(reportParameters.dateRangeSelection, reportParamsStringBuilder);
    paramsBuilder.addCPParam(reportParameters.customersProjectsSelection, reportParamsStringBuilder);
    paramsBuilder.addUsersParam(reportParameters.userSelection, reportParamsStringBuilder);
    if (EnabledFeatures.TTA) paramsBuilder.addTimeTrackStatusParam(reportParameters.timeApprovalStatus);

    var parametersSection = new _CSVParametersSection2.default().init(paramsBuilder, totalColumnsNum);

    parametersSection.addRows(tBody);
    new _CSVPreviewEmptySection2.default().init(1, totalColumnsNum).addRows(tBody);
    headerSection.addRows(tBody);
    groupingSection.addRows(tBody);
    new _CSVPreviewEmptySection2.default().init(1, totalColumnsNum).addRows(tBody);
    totalSection.addRows(tBody);

    return table;
};

/***/ }),
/* 2075 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = TTDetailCSVPreviewColumnsStrategy;

var _CSVColumnsStrategy = __webpack_require__(413);

var _CSVColumnsStrategy2 = _interopRequireDefault(_CSVColumnsStrategy);

var _constants = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function TTDetailCSVPreviewColumnsStrategy() {}

TTDetailCSVPreviewColumnsStrategy.prototype = new _CSVColumnsStrategy2.default();
TTDetailCSVPreviewColumnsStrategy.prototype.constructor = TTDetailCSVPreviewColumnsStrategy;

TTDetailCSVPreviewColumnsStrategy.prototype.init = function (notEmptyGroupingLevels, joinCommentsByTask, needSwitchToMe) {
    this.notEmptyGroupingLevels = notEmptyGroupingLevels;
    this.joinCommentsByTask = joinCommentsByTask;
    // calculate detail cells
    this.detailCells = TTDetailPreviewUtils.calculateTTCDetailCells(notEmptyGroupingLevels, joinCommentsByTask);
    this.needSwitchToMe = needSwitchToMe;

    return this;
};

/**
 * Add cells  for main header row (grouping columns + details columns + total column + comment column)
 * @param headerRow
 */
TTDetailCSVPreviewColumnsStrategy.prototype.addFirstHeaderRowCells = function (headerRow) {
    for (var i = 0; i < this.notEmptyGroupingLevels.length; i++) {
        this.addCell(headerRow, ReportPreviewUtils.getLevelPreviewName(this.notEmptyGroupingLevels[i]));
    }
    for (var _i = 0; _i < this.detailCells.length; _i++) {
        var detailCell = this.detailCells[_i];
        var levelPreviewName = detailCell === _constants.ReportGroupingLevel.USER && this.needSwitchToMe ? this.message("report.common.me") : ReportPreviewUtils.getLevelPreviewName(detailCell);
        this.addCell(headerRow, levelPreviewName);
    }
    this.addCell(headerRow, this.message("reports.comments_report.report.spent"));
    this._addCommentsCell(headerRow, true);
};

/**
 * Add rows for hierarchy grouping section
 * Cust  ___  ____ position = 0
 *  ___  Prj  ____ position = 1
 *  ___  ___  Task position = 2
 * @param row current row
 * @param position position of row from 0 to 2 (depends grouping level)
 */
TTDetailCSVPreviewColumnsStrategy.prototype.addDataLevelRowCells = function (row, position) {
    for (var i = 0; i < position; i++) {
        ReportPreviewUtils.addEmptyCell(row);
    }
    var groupingLevel = this.notEmptyGroupingLevels[position];
    var levelPreviewName = void 0;
    if (this.needSwitchToMe && groupingLevel === _constants.ReportGroupingLevel.USER) {
        levelPreviewName = this.message("report.common.me");
    } else {
        levelPreviewName = ReportPreviewUtils.getLevelPreviewName(groupingLevel);
    }
    this.addCell(row, levelPreviewName);
    for (var _i2 = position + 1; _i2 < this.notEmptyGroupingLevels.length; _i2++) {
        ReportPreviewUtils.addEmptyCell(row);
    }
    for (var _i3 = 0; _i3 < this.getNumberOfDetailsCells(); _i3++) {
        ReportPreviewUtils.addEmptyCell(row);
    }
    this.addTimeValueCell(row); // total value
    ReportPreviewUtils.addEmptyCell(row);
};

TTDetailCSVPreviewColumnsStrategy.prototype.addDataRowCells = function (row) {
    for (var i = 0; i < this.notEmptyGroupingLevels.length; i++) {
        ReportPreviewUtils.addEmptyCell(row);
    }
    for (var _i4 = 0; _i4 < this.detailCells.length; _i4++) {
        var detailCell = this.detailCells[_i4];
        var levelPreviewName = detailCell === _constants.ReportGroupingLevel.USER && this.needSwitchToMe ? this.message("report.common.me") : ReportPreviewUtils.getLevelPreviewName(detailCell);
        this.addCell(row, levelPreviewName);
    }
    this.addTimeValueCell(row);
    this._addCommentsCell(row, false);
};

TTDetailCSVPreviewColumnsStrategy.prototype.addTotalRowCells = function (row) {
    var nBeforeEmptyCells = this.notEmptyGroupingLevels.length + this.getNumberOfDetailsCells() - 1;
    this._addTotalCell(row);
    for (var i = 0; i < nBeforeEmptyCells; i++) {
        ReportPreviewUtils.addEmptyCell(row);
    }
    this.addTimeValueCell(row);
    ReportPreviewUtils.addEmptyCell(row);
};

TTDetailCSVPreviewColumnsStrategy.prototype._addCommentsCell = function (row, isHeader) {
    if (isHeader || !this.joinCommentsByTask) {
        this.addCell(row, ReportPreviewUtils.getLevelPreviewName(_constants.ReportGroupingLevel.TT_COMMENTS));
    } else {
        this.addCell(row, this.message("reports.comments_report.form.preview.joined_comments"));
    }
};

TTDetailCSVPreviewColumnsStrategy.prototype._addTotalCell = function (row) {
    this.addCell(row, this.message("report.total"));
};

TTDetailCSVPreviewColumnsStrategy.prototype.getNumberOfDetailsCells = function () {
    return this.detailCells.length;
};

/***/ }),
/* 2076 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = TTDetailCSVPreviewHeader;

var _CSVPreviewSection = __webpack_require__(43);

var _CSVPreviewSection2 = _interopRequireDefault(_CSVPreviewSection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function TTDetailCSVPreviewHeader() {}

TTDetailCSVPreviewHeader.prototype = new _CSVPreviewSection2.default();
TTDetailCSVPreviewHeader.prototype.constructor = TTDetailCSVPreviewHeader;

TTDetailCSVPreviewHeader.prototype.init = function (columnStrategy) {
    _CSVPreviewSection2.default.prototype.init.call(this);

    this.columnStrategy = columnStrategy;
    return this;
};
TTDetailCSVPreviewHeader.prototype.addRows = function (tBody) {
    var firstHeaderRow = this.createRow("headerRow");
    this.columnStrategy.addFirstHeaderRowCells(firstHeaderRow);
    this.addRow(tBody, firstHeaderRow);
};

/***/ }),
/* 2077 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = TTDetailCSVPreviewGroupingSection;

var _CSVPreviewSection = __webpack_require__(43);

var _CSVPreviewSection2 = _interopRequireDefault(_CSVPreviewSection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function TTDetailCSVPreviewGroupingSection() {}

TTDetailCSVPreviewGroupingSection.prototype = new _CSVPreviewSection2.default();

TTDetailCSVPreviewGroupingSection.prototype.constructor = TTDetailCSVPreviewGroupingSection;

TTDetailCSVPreviewGroupingSection.prototype.init = function (numberOfSelectedLevels, columnStrategy) {
    _CSVPreviewSection2.default.prototype.init.call(this);

    this.numberOfLevels = numberOfSelectedLevels;
    this.numberOfDataRows = 4 - numberOfSelectedLevels;
    this.columnStrategy = columnStrategy;
    return this;
};

TTDetailCSVPreviewGroupingSection.prototype.addRows = function (tBody) {
    for (var i = 0; i < this.numberOfLevels; i++) {
        var row = this.createRow();
        this.columnStrategy.addDataLevelRowCells(row, i);
        this.addRow(tBody, row);
    }

    for (var _i = 0; _i < this.numberOfDataRows; _i++) {
        var _row = this.createRow();
        this.columnStrategy.addDataRowCells(_row);
        this.addRow(tBody, _row);
    }
};

/***/ }),
/* 2078 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = TTDetailCSVPreviewTotalSection;

var _CSVPreviewSection = __webpack_require__(43);

var _CSVPreviewSection2 = _interopRequireDefault(_CSVPreviewSection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function TTDetailCSVPreviewTotalSection() {}

TTDetailCSVPreviewTotalSection.prototype = new _CSVPreviewSection2.default();
TTDetailCSVPreviewTotalSection.prototype.constructor = TTDetailCSVPreviewTotalSection;

TTDetailCSVPreviewTotalSection.prototype.init = function (columnStrategy) {
    _CSVPreviewSection2.default.prototype.init.call(this);

    this.columnStrategy = columnStrategy;
    return this;
};

TTDetailCSVPreviewTotalSection.prototype.addRows = function (tBody) {
    var row = this.createRow();
    this.columnStrategy.addTotalRowCells(row);
    this.addRow(tBody, row);
};

/***/ }),
/* 2079 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = TTDetailHTMLPreviewGenerator;

var _TTDetailHTMLPreviewHeader = __webpack_require__(2080);

var _TTDetailHTMLPreviewHeader2 = _interopRequireDefault(_TTDetailHTMLPreviewHeader);

var _TTDetailHTMLPreviewTotalSection = __webpack_require__(2081);

var _TTDetailHTMLPreviewTotalSection2 = _interopRequireDefault(_TTDetailHTMLPreviewTotalSection);

var _TTDetailHTMLPreviewGroupingSection = __webpack_require__(2082);

var _TTDetailHTMLPreviewGroupingSection2 = _interopRequireDefault(_TTDetailHTMLPreviewGroupingSection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function TTDetailHTMLPreviewGenerator() {}

TTDetailHTMLPreviewGenerator.prototype.init = function () {
    return this;
};

TTDetailHTMLPreviewGenerator.prototype.generatePreviewTable = function (reportParameters) {
    // if there is collision clear third level
    var groupingLevels = TTDetailPreviewUtils.filterGroupingLevelsIfExistCollision([reportParameters.firstGroupingLevel, reportParameters.secondGroupingLevel, reportParameters.thirdGroupingLevel], reportParameters.joinCommentsByTask);

    var notEmptyGroupingLevels = ReportPreviewUtils.filterNotEmptyLevels(groupingLevels);
    var joinCommentsByTask = reportParameters.joinCommentsByTask;
    var detailsLevels = TTDetailPreviewUtils.calculateTTCDetailCells(notEmptyGroupingLevels, joinCommentsByTask);

    var needSwitchToMe = reportParameters.needSwitchToMe;
    var headerSection = new _TTDetailHTMLPreviewHeader2.default().init(notEmptyGroupingLevels, detailsLevels, joinCommentsByTask, needSwitchToMe);
    var totalSection = new _TTDetailHTMLPreviewTotalSection2.default().init(detailsLevels.length, reportParameters.timeFormat);
    var groupingSection = new _TTDetailHTMLPreviewGroupingSection2.default().init(notEmptyGroupingLevels, detailsLevels, joinCommentsByTask, reportParameters.timeFormat, needSwitchToMe);

    var table = document.createElement("table");
    table.className = "reportHtmlPreviewTable ttdetail";
    var tBody = document.createElement("tbody");
    table.appendChild(tBody);

    headerSection.addRows(tBody);
    totalSection.addRows(tBody);
    groupingSection.addRows(tBody);

    return table;
};

/***/ }),
/* 2080 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = TTDetailHTMLPreviewHeader;

var _PreviewSection = __webpack_require__(67);

var _PreviewSection2 = _interopRequireDefault(_PreviewSection);

var _constants = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function TTDetailHTMLPreviewHeader() {}

TTDetailHTMLPreviewHeader.prototype = new _PreviewSection2.default();

TTDetailHTMLPreviewHeader.prototype.constructor = TTDetailHTMLPreviewHeader;

TTDetailHTMLPreviewHeader.prototype.init = function (notEmptyGroupingLevels, detailLevels, joinCommentsByTask, needSwitchToMe) {
    _PreviewSection2.default.prototype.init.call(this);

    this.detailLevels = detailLevels;
    this.notEmptyGroupingLevels = notEmptyGroupingLevels;
    this.joinCommentsByTask = joinCommentsByTask;
    this.needSwitchToMe = needSwitchToMe;

    return this;
};

TTDetailHTMLPreviewHeader.prototype.addRows = function (tBody) {
    var headerRowClass = "headerRow";
    if (this.notEmptyGroupingLevels.length === 0) {
        headerRowClass += " raw"; // set class if data is raw
    } else {
        headerRowClass += " details" + (this.detailLevels.length - 1); // set number of detail cells in additional class
        headerRowClass += " floatCells" + this._getNumberOfFloatingCells(this.detailLevels.slice(1));
    }
    var row = this.createRow(headerRowClass);

    var headerGroupingLevels = this.notEmptyGroupingLevels.slice(); // copy array
    headerGroupingLevels.push(this.detailLevels[0]);
    this.addCell(row, ReportPreviewUtils.makeGroupingHeader(headerGroupingLevels), "firstHeaderCell");

    for (var i = 1; i < this.detailLevels.length; i++) {
        var detailsLevel = this.detailLevels[i];
        var levelPreviewName = detailsLevel === _constants.ReportGroupingLevel.USER && this.needSwitchToMe ? this.message("report.common.me") : ReportPreviewUtils.getLevelPreviewName(detailsLevel);
        this.addCell(row, levelPreviewName, this._getAdditionalClass(detailsLevel));
    }

    this.addCell(row, this.message("reports.comments_report.report.spent"), "spentTime");

    var commentsCellCls = "commentsCellHeader";
    if (this.joinCommentsByTask) commentsCellCls += " joined";
    this.addCell(row, this.message("reports.comments_report.report.comments"), commentsCellCls);

    this.addRow(tBody, row);
};

TTDetailHTMLPreviewHeader.prototype._getAdditionalClass = function (detailsLevel) {
    switch (detailsLevel) {
        case _constants.ReportGroupingLevel.BILLING_TYPE:
            return "typeOfWork";
        case _constants.ReportGroupingLevel.DATE:
            return "day";
        case _constants.ReportGroupingLevel.USER:
            return "user";
        case _constants.ReportGroupingLevel.TASK:
            return "task";
        case _constants.ReportGroupingLevel.USER_GROUP:
            return "group";
        case _constants.ReportGroupingLevel.PROJECT:
            return "project";
        default:
            return "";
    }
};

TTDetailHTMLPreviewHeader.prototype._getNumberOfFloatingCells = function (detailCells) {
    var n = 0;
    if (ReportPreviewUtils.checkGroupingLevel(_constants.ReportGroupingLevel.CUSTOMER, detailCells)) {
        n++;
    }
    if (ReportPreviewUtils.checkGroupingLevel(_constants.ReportGroupingLevel.TASK, detailCells)) {
        n++;
    }
    if (ReportPreviewUtils.checkGroupingLevel(_constants.ReportGroupingLevel.PROJECT, detailCells)) {
        n++;
    }
    return n;
};

/***/ }),
/* 2081 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = TTDetailHTMLPreviewTotalSection;

var _PreviewSection = __webpack_require__(67);

var _PreviewSection2 = _interopRequireDefault(_PreviewSection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function TTDetailHTMLPreviewTotalSection() {}

TTDetailHTMLPreviewTotalSection.prototype = new _PreviewSection2.default();

TTDetailHTMLPreviewTotalSection.prototype.constructor = TTDetailHTMLPreviewTotalSection;

TTDetailHTMLPreviewTotalSection.prototype.init = function (nDetailCells, timeFormat) {
    _PreviewSection2.default.prototype.init.call(this);

    this.nDetailCells = nDetailCells;
    this.timeFormat = timeFormat;

    return this;
};

TTDetailHTMLPreviewTotalSection.prototype.addRows = function (tBody) {
    var row = this.createRow();
    this.addCell(row, this.message("report.total"), "totalCell", this.nDetailCells);
    ReportPreviewUtils.addHTMLTimeValueCell(row, this.timeFormat, "spent");
    ReportPreviewUtils.addEmptyCell(row);
    this.addRow(tBody, row);
};

/***/ }),
/* 2082 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = TTDetailHTMLPreviewGroupingSection;

var _PreviewSection = __webpack_require__(67);

var _PreviewSection2 = _interopRequireDefault(_PreviewSection);

var _constants = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function TTDetailHTMLPreviewGroupingSection() {}

TTDetailHTMLPreviewGroupingSection.prototype = new _PreviewSection2.default();

TTDetailHTMLPreviewGroupingSection.prototype.constructor = TTDetailHTMLPreviewGroupingSection;

TTDetailHTMLPreviewGroupingSection.TOTAL_ROWS_NUMBER = 6;

TTDetailHTMLPreviewGroupingSection.prototype.init = function (notEmptyGroupingLevels, detailCells, joinCommentsByTask, timeFormat, needSwitchToMe) {
    _PreviewSection2.default.prototype.init.call(this);

    this.notEmptyGroupingLevels = notEmptyGroupingLevels;
    this.detailCells = detailCells;
    this.joinCommentsByTask = joinCommentsByTask;
    this.timeFormat = timeFormat;
    this.needSwitchToMe = needSwitchToMe;

    return this;
};

TTDetailHTMLPreviewGroupingSection.prototype.addRows = function (tBody) {
    var currentRowsNumber = 0;
    for (var i = 0; i < this.notEmptyGroupingLevels.length; i++) {
        var groupingLevel = this.notEmptyGroupingLevels[i];
        var levelPreviewName = void 0;
        if (groupingLevel === _constants.ReportGroupingLevel.USER && this.needSwitchToMe) {
            levelPreviewName = this.message("report.common.me");
        } else {
            levelPreviewName = ReportPreviewUtils.getLevelPreviewName(groupingLevel);
        }

        this.addRow(tBody, this._createDataLevelRow(i, levelPreviewName));
        currentRowsNumber++;
    }
    this.addRow(tBody, this._createDataRow());
    currentRowsNumber++;

    if (ReportPreviewUtils.isLevelCanBeAddedMoreThanOnce(this.detailCells[0], this.notEmptyGroupingLevels) && !this.needSwitchToMe) {
        while (currentRowsNumber < TTDetailHTMLPreviewGroupingSection.TOTAL_ROWS_NUMBER) {
            this.addRow(tBody, this._createDataRow());
            currentRowsNumber++;
        }
    } else {
        while (true) {
            for (var _i = 0; _i < this.notEmptyGroupingLevels.length; _i++) {
                var _groupingLevel = this.notEmptyGroupingLevels[_i];
                var _levelPreviewName = void 0;
                if (_groupingLevel === _constants.ReportGroupingLevel.USER && this.needSwitchToMe) {
                    if (_i === 0) continue;
                    _levelPreviewName = this.message("report.common.me");
                } else {
                    _levelPreviewName = ReportPreviewUtils.getLevelPreviewName(_groupingLevel);
                }
                this.addRow(tBody, this._createDataLevelRow(_i, _levelPreviewName));
                currentRowsNumber++;
                if (currentRowsNumber >= TTDetailHTMLPreviewGroupingSection.TOTAL_ROWS_NUMBER) break;
            }
            if (currentRowsNumber >= TTDetailHTMLPreviewGroupingSection.TOTAL_ROWS_NUMBER) break;

            this.addRow(tBody, this._createDataRow());
            currentRowsNumber++;
            if (currentRowsNumber >= TTDetailHTMLPreviewGroupingSection.TOTAL_ROWS_NUMBER) break;
        }
    }
};

TTDetailHTMLPreviewGroupingSection.prototype._createDataRow = function () {
    var row = this.createRow("dataRow");

    for (var i = 0; i < this.detailCells.length; i++) {
        // add css classes only for first cell in row, if groupingLevels are present
        var cellClass = null;
        if (i === 0 && this.notEmptyGroupingLevels.length !== 0) {
            cellClass = "firstDetailsCellAfterGrouping levelsAmount" + this.notEmptyGroupingLevels.length;
        }
        var detailCell = this.detailCells[i];
        var levelPreviewName = detailCell === _constants.ReportGroupingLevel.USER && this.needSwitchToMe ? this.message("report.common.me") : ReportPreviewUtils.getLevelPreviewName(detailCell);
        this.addCell(row, levelPreviewName, cellClass);
    }

    this.addSpentCell(row);
    this.addCommentsCell(row);

    return row;
};

TTDetailHTMLPreviewGroupingSection.prototype.addCommentsCell = function (row) {
    var commentsCellClass = "commentCell";
    if (this.joinCommentsByTask) {
        commentsCellClass += " joined";
        this.addCell(row, ReportPreviewUtils.checkGroupingLevel(_constants.ReportGroupingLevel.USER, this.notEmptyGroupingLevels) ? this.message("reports.comments_report.form.format.comments_joined_by_dates_without_format") : this.message("reports.comments_report.form.format.comments_joined_by_users_without_format"), commentsCellClass);
    } else {
        this.addCell(row, this.message("report.common.tt_comments"), commentsCellClass);
    }
};

TTDetailHTMLPreviewGroupingSection.prototype.addSpentCell = function (row) {
    ReportPreviewUtils.addHTMLTimeValueCell(row, this.timeFormat, "spent");
};

/**
 *
 * @param position 0 to 2
 * @param groupingLevel
 * @private
 */
TTDetailHTMLPreviewGroupingSection.prototype._createDataLevelRow = function (position, groupingLevelName) {
    var row = this.createRow("groupingLevel_" + (position + 1));
    this.addCell(row, groupingLevelName, "groupingLevelName", this.detailCells.length);
    this.addSpentCell(row);
    ReportPreviewUtils.addEmptyCell(row);
    return row;
};

/***/ }),
/* 2083 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = CostReportMediator;

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _OldReportMediator = __webpack_require__(268);

var _OldReportMediator2 = _interopRequireDefault(_OldReportMediator);

var _constants = __webpack_require__(11);

var _ReportPrintableHeadersBuilder = __webpack_require__(171);

var _ReportPrintableHeadersBuilder2 = _interopRequireDefault(_ReportPrintableHeadersBuilder);

var _CostReportEditConfigController = __webpack_require__(994);

var _CostReportEditConfigController2 = _interopRequireDefault(_CostReportEditConfigController);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CostReportMediator() {
    this.constructor = CostReportMediator;
}

CostReportMediator.prototype = _underscore2.default.create(_OldReportMediator2.default.prototype);

CostReportMediator.prototype.init = function (config) {
    _OldReportMediator2.default.prototype.init.call(this, config);

    return this;
};

CostReportMediator.prototype.getReportType = function () {
    return _constants.ReportType.COST_OF_WORK;
};

CostReportMediator.prototype.initEditConfigController = function (config) {
    var self = this;
    return new _CostReportEditConfigController2.default().init({
        reportAuthorizationInfo: config.reportAuthorizationInfo,
        reportParameters: config.reportParameters,
        users: config.users,
        manageableUsersIds: config.manageableUserIds,
        userGroups: config.userGroups,
        timeZoneGroups: config.timeZoneGroups,
        cpList: config.cpList,
        customersWithMaIds: config.customersWithMaIds,
        projectsWithMaIds: config.projectsWithMaIds,
        changeCallback: function changeCallback() {
            self.changeParametersCallback();
        }
    });
};

CostReportMediator.prototype._populateHeadersArray = function (headersArray) {
    this.printableHeadersBuilder.addCPSelectionParamsStringToArray(this.reportParameters.customersProjectsSelection, headersArray); //customers and projects
    this.printableHeadersBuilder.addStaffSelectionParamsToArray(this.reportParameters.userSelection, headersArray); //staff
};

CostReportMediator.prototype.initPrintableHeadersBuilder = function (config) {
    return new _ReportPrintableHeadersBuilder2.default().init({
        users: config.users,
        reportParameters: config.reportParameters,
        cpList: config.cpList,
        isFilteredByAssignments: config.isFilteredByAssignments,
        userGroups: config.userGroups,
        timeZoneGroups: config.timeZoneGroups
    });
};

/***/ }),
/* 2084 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ReportColumnsSelectorButtonsCostOfWork;

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _constants = __webpack_require__(4);

var _features = __webpack_require__(22);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ReportColumnsSelectorButtonsCostOfWork() {}

ReportColumnsSelectorButtonsCostOfWork.prototype.init = function (config) {
    this.showSpentTimeCheckbox = (0, _jquery2.default)("#showSpentTime");
    this.showAverageRatesCheckbox = (0, _jquery2.default)("#showAverageRates");
    this.showUserRatesCheckBox = (0, _jquery2.default)("#showUserRates");

    var configChangedCallback = config.changeCallback;
    this.showSpentTimeCheckbox.on("change", configChangedCallback);
    this.showAverageRatesCheckbox.on("change", configChangedCallback);
    this.showUserRatesCheckBox.on("change", configChangedCallback);

    if (this.verifyIsNeedGroupSelector(config.columnsFormat)) {
        (0, _jquery2.default)("#columnsFormatSectionCostWork").toggleClass("showUGR");
        (0, _jquery2.default)("#columnsFormatCheckboxesTable").toggleClass("showUGR");
        (0, _jquery2.default)("#columnsFormatSectionCostWork_selectorSection").show();
        (0, _jquery2.default)("#columnsFormatCheckboxesTable_showAverageRates").find("label").html(_messageResource2.default.getMessage("report.cost.show_average_rates.short"));
        (0, _jquery2.default)("#columnsFormatCheckboxesTable_showSpentTime").find("label").html(_messageResource2.default.getMessage("report.cost.show_spent_time.short"));
        (0, _jquery2.default)("#columnsFormatCheckboxesTable_showUserRates").find("label").html(_messageResource2.default.getMessage("report.cost.show_user_rates.short"));
        (0, _jquery2.default)("#columnsFormatCheckboxesTable_showSubtotalByDepartments").show();
    } else {
        (0, _jquery2.default)("#columnsFormatCheckboxesTable_showAverageRates").find("label").html(_messageResource2.default.getMessage("report.cost.show_average_rates"));
        (0, _jquery2.default)("#columnsFormatCheckboxesTable_showSpentTime").find("label").html(_messageResource2.default.getMessage("report.cost.show_spent_time"));
        (0, _jquery2.default)("#columnsFormatCheckboxesTable_showUserRates").find("label").html(_messageResource2.default.getMessage("report.cost.show_user_rates"));
    }

    if (config.selector) {
        this.selector = config.selector;
        this.showSubtotalByDepartmentsCheckbox = (0, _jquery2.default)("#showSubtotalByDepartments");
        this.showSubtotalByDepartmentsCheckbox.on("change", configChangedCallback);
        this.containerWithChexboxes = (0, _jquery2.default)("#" + config.containerId);
        var self = this;
        var toggleClass = function toggleClass() {
            self.containerWithChexboxes.toggleClass("hideSubtotalByDepartments", self.selector.getValue() === _constants.ReportColumnsFormatCostOfWork.USERS_ONLY);
            self.containerWithChexboxes.toggleClass("hideUserRatesAndSubtotalByDepartments ", self.selector.getValue() === _constants.ReportColumnsFormatCostOfWork.GROUPS_ONLY);
        };
        this.selector.on("change", function () {
            toggleClass();
        });
        toggleClass();
    }
    this.setValue(config.columnsFormat, config.showSpentTime, config.showAverageRates, config.showUserRates, config.showSubtotalsByDepartments);
    return this;
};

ReportColumnsSelectorButtonsCostOfWork.prototype.getSelection = function () {
    var result = {};
    result.columnsConfig = this.selector ? this.selector.getValue() : _constants.ReportColumnsFormatCostOfWork.USERS_ONLY;
    result.showSpentTime = this.showSpentTimeCheckbox.is(':checked');
    result.showAverageRates = this.showAverageRatesCheckbox.is(':checked');
    result.showUserRates = this.showUserRatesCheckBox.is(':checked') ? !(this.selector && this.selector.getValue() === _constants.ReportColumnsFormatCostOfWork.GROUPS_ONLY) : false;
    result.showSubtotalsByDepartments = this.showSubtotalByDepartmentsCheckbox && this.selector.getValue() === _constants.ReportColumnsFormatCostOfWork.USERS_BY_GROUPS && this.showSubtotalByDepartmentsCheckbox.is(':checked');
    return result;
};

ReportColumnsSelectorButtonsCostOfWork.prototype.setValue = function (columnsConfig, showSpentTime, showAverageRates, showUserRates, showSubtotalByDepartments) {
    if (this.selector) this.selector.setActiveItemByValue(columnsConfig);
    this.showSpentTimeCheckbox.prop('checked', showSpentTime);
    this.showAverageRatesCheckbox.prop('checked', showAverageRates);
    this.showUserRatesCheckBox.prop('checked', this.selector && this.selector.getValue() === _constants.ReportColumnsFormatCostOfWork.GROUPS_ONLY ? false : showUserRates);
    if (this.showSubtotalByDepartmentsCheckbox) this.showSubtotalByDepartmentsCheckbox.prop('checked', showSubtotalByDepartments && this.selector.getValue() === _constants.ReportColumnsFormatCostOfWork.USERS_BY_GROUPS);
};

ReportColumnsSelectorButtonsCostOfWork.prototype.verifyIsNeedGroupSelector = function (reportInfo) {
    return (0, _features.isEnabled)(_features.Feature.UGR) || reportInfo !== _constants.ReportColumnsFormatCostOfWork.USERS_ONLY;
};

/***/ }),
/* 2085 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = CostFormMediator;

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _OldBaseFormMediator = __webpack_require__(271);

var _OldBaseFormMediator2 = _interopRequireDefault(_OldBaseFormMediator);

var _CostReportEditFormConfigController = __webpack_require__(2086);

var _CostReportEditFormConfigController2 = _interopRequireDefault(_CostReportEditFormConfigController);

var _CostCSVPreviewGenerator = __webpack_require__(2087);

var _CostCSVPreviewGenerator2 = _interopRequireDefault(_CostCSVPreviewGenerator);

var _CostHTMLPreviewGenerator = __webpack_require__(2095);

var _CostHTMLPreviewGenerator2 = _interopRequireDefault(_CostHTMLPreviewGenerator);

var _BaseFormMediator = __webpack_require__(269);

var _BaseFormMediator2 = _interopRequireDefault(_BaseFormMediator);

var _ScrollUtils = __webpack_require__(39);

var _ScrollUtils2 = _interopRequireDefault(_ScrollUtils);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _ATReportParamsStringBuilder = __webpack_require__(52);

var _ATReportParamsStringBuilder2 = _interopRequireDefault(_ATReportParamsStringBuilder);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CostFormMediator() {}

CostFormMediator.prototype = _underscore2.default.create(_OldBaseFormMediator2.default.prototype);

CostFormMediator.prototype.init = function (config) {
    _OldBaseFormMediator2.default.prototype.init.call(this, config);
    return this;
};

CostFormMediator.prototype.initParamsStringBuilder = function (config) {
    return new _ATReportParamsStringBuilder2.default({
        data: {
            users: config.users,
            userGroups: config.userGroups,
            timeZoneGroups: config.timeZoneGroups,
            cpList: config.cpList,
            manageableUserIds: ATReportsStore.getManageableUserIds()
        },
        reportAuthorizationInfo: ATReportsStore.getReportAuthorizationInfo()
    });
};

CostFormMediator.prototype.initEditConfigController = function (config) {
    var self = this;
    return new _CostReportEditFormConfigController2.default().init({
        panelId: "mainContainer",
        reportAuthorizationInfo: config.reportAuthorizationInfo,
        reportParameters: config.reportParameters,
        users: config.users,
        manageableUsersIds: config.manageableUserIds,
        userGroups: config.userGroups,
        timeZoneGroups: config.timeZoneGroups,
        cpList: config.cpList,
        customersWithMaIds: config.customersWithMaIds,
        projectsWithMaIds: config.projectsWithMaIds,
        changeCallback: function changeCallback() {
            self.changeParametersCallback();
        }
    });
};

CostFormMediator.prototype.initCsvGenerator = function () {
    return new _CostCSVPreviewGenerator2.default().init();
};

CostFormMediator.prototype.initHtmlGenerator = function () {
    return new _CostHTMLPreviewGenerator2.default().init();
};

CostFormMediator.prototype.generateCSVPreview = function (reportParameters) {
    _BaseFormMediator2.default.prototype.generateCSVPreview.apply(this, arguments);
    this._initPreviewCustomScroll();
};

CostFormMediator.prototype.generateHtmlPreview = function (reportParameters) {
    _BaseFormMediator2.default.prototype.generateHtmlPreview.apply(this, arguments);
    this._initPreviewCustomScroll();
};

CostFormMediator.prototype._initPreviewCustomScroll = function () {
    _ScrollUtils2.default.addHorizontalScroll((0, _jquery2.default)("#reportPreviewPlaceholder"), { isFaded: false });
};

/***/ }),
/* 2086 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _features = __webpack_require__(22);

var _constants = __webpack_require__(4);

var _constants2 = __webpack_require__(11);

var _CostReportEditConfigController = __webpack_require__(994);

var _CostReportEditConfigController2 = _interopRequireDefault(_CostReportEditConfigController);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CostReportEditFormConfigController = function (_CostReportEditConfig) {
    _inherits(CostReportEditFormConfigController, _CostReportEditConfig);

    function CostReportEditFormConfigController() {
        _classCallCheck(this, CostReportEditFormConfigController);

        return _possibleConstructorReturn(this, (CostReportEditFormConfigController.__proto__ || Object.getPrototypeOf(CostReportEditFormConfigController)).apply(this, arguments));
    }

    return CostReportEditFormConfigController;
}(_CostReportEditConfigController2.default);

exports.default = CostReportEditFormConfigController;


CostReportEditFormConfigController.prototype.makeReportParamsAccordingToFeatures = function (reportParameters) {
    var result = _jquery2.default.extend({}, reportParameters);
    if (!(0, _features.isEnabled)(_features.Feature.UGR) && result.columnsConfig !== _constants.ReportColumnsFormatCostOfWork.USERS_ONLY) result.columnsConfig = _constants.ReportColumnsFormatCostOfWork.USERS_ONLY;

    if (!(0, _features.isEnabled)(_features.Feature.BTY)) {
        var groupings = this.makeGroupingSelectorValuesAccordingToNotAvailableValueLevel(_constants2.ReportGroupingLevel.BILLING_TYPE, [result.firstGroupingLevel, result.secondGroupingLevel], _constants2.ReportGroupingLevel.CUSTOMER);
        result.firstGroupingLevel = groupings[0];
        result.secondGroupingLevel = groupings[1];
    }

    if (!(0, _features.isEnabled)(_features.Feature.LVT)) result.showLeaveTimeCosts = false;

    if (!(0, _features.isEnabled)(_features.Feature.OVR)) result.showOvertimeAddition = false;

    return result;
};

/***/ }),
/* 2087 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = CostCSVPreviewGenerator;

var _CSVParametersBuilder = __webpack_require__(150);

var _CSVParametersBuilder2 = _interopRequireDefault(_CSVParametersBuilder);

var _CSVParametersSection = __webpack_require__(170);

var _CSVParametersSection2 = _interopRequireDefault(_CSVParametersSection);

var _CostCSVPreviewHeaderSection = __webpack_require__(2088);

var _CostCSVPreviewHeaderSection2 = _interopRequireDefault(_CostCSVPreviewHeaderSection);

var _CostCSVPreviewGroupingSection = __webpack_require__(2089);

var _CostCSVPreviewGroupingSection2 = _interopRequireDefault(_CostCSVPreviewGroupingSection);

var _CSVPreviewEmptySection = __webpack_require__(324);

var _CSVPreviewEmptySection2 = _interopRequireDefault(_CSVPreviewEmptySection);

var _CSVPreviewCostProfitLossAdditionalSection = __webpack_require__(995);

var _CSVPreviewCostProfitLossAdditionalSection2 = _interopRequireDefault(_CSVPreviewCostProfitLossAdditionalSection);

var _constants = __webpack_require__(4);

var _CostCSVPreviewTwoLevelsUsersOnlyColumnsStrategy = __webpack_require__(2090);

var _CostCSVPreviewTwoLevelsUsersOnlyColumnsStrategy2 = _interopRequireDefault(_CostCSVPreviewTwoLevelsUsersOnlyColumnsStrategy);

var _CostCSVPreviewOneLevelsColumnsStrategy = __webpack_require__(2091);

var _CostCSVPreviewOneLevelsColumnsStrategy2 = _interopRequireDefault(_CostCSVPreviewOneLevelsColumnsStrategy);

var _CostCSVPreviewTwoLevelsGroupsOnlyColumnsStrategy = __webpack_require__(2092);

var _CostCSVPreviewTwoLevelsGroupsOnlyColumnsStrategy2 = _interopRequireDefault(_CostCSVPreviewTwoLevelsGroupsOnlyColumnsStrategy);

var _CostCSVPreviewUserByGroupsThreeLevels = __webpack_require__(2093);

var _CostCSVPreviewUserByGroupsThreeLevels2 = _interopRequireDefault(_CostCSVPreviewUserByGroupsThreeLevels);

var _CostCSVPreviewUserByGroupsOnlyColumnsStrategy = __webpack_require__(2094);

var _CostCSVPreviewUserByGroupsOnlyColumnsStrategy2 = _interopRequireDefault(_CostCSVPreviewUserByGroupsOnlyColumnsStrategy);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _constants2 = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CostCSVPreviewGenerator() {}

CostCSVPreviewGenerator.prototype.init = function () {
    return this;
};

CostCSVPreviewGenerator.prototype.generatePreviewTable = function (reportParameters, reportParamsStringBuilder) {
    var numOfGroupingColumns = ReportPreviewUtils.countNotEmptyLevels([reportParameters.firstGroupingLevel, reportParameters.secondGroupingLevel, reportParameters.thirdGroupingLevel]);

    var columnsStrategy = this.getColumnsStrategy(reportParameters);
    var totalColumnsNum = numOfGroupingColumns + columnsStrategy.getNumOfDataColumns();
    var totalRowNum = 17;

    var table = document.createElement("table");
    table.className = "reportCsvPreviewTable cost";
    var tBody = document.createElement("tbody");
    table.appendChild(tBody);

    ReportPreviewUtils.addSheetHeaderRow(tBody, totalColumnsNum);

    var paramsBuilder = new _CSVParametersBuilder2.default().init();
    paramsBuilder.addDateRangeParam(reportParameters.dateRangeSelection, reportParamsStringBuilder);
    paramsBuilder.addCPParam(reportParameters.customersProjectsSelection, reportParamsStringBuilder);
    paramsBuilder.addUsersParam(reportParameters.userSelection, reportParamsStringBuilder);

    var parametersSection = new _CSVParametersSection2.default().init(paramsBuilder, totalColumnsNum);

    parametersSection.addRows(tBody);

    var headerSection = new _CostCSVPreviewHeaderSection2.default().init(columnsStrategy, reportParameters.firstGroupingLevel, reportParameters.secondGroupingLevel, reportParameters.thirdGroupingLevel, numOfGroupingColumns);

    var groupingSection = new _CostCSVPreviewGroupingSection2.default().init(reportParameters.firstGroupingLevel, reportParameters.secondGroupingLevel, reportParameters.thirdGroupingLevel, numOfGroupingColumns, columnsStrategy.getNumOfDataColumns(), 5);

    var emptySection = new _CSVPreviewEmptySection2.default().init(1, totalColumnsNum);

    headerSection.addRows(tBody);
    groupingSection.addRows(tBody);
    emptySection.addRows(tBody);
    if (reportParameters.showLeaveTimeCosts || reportParameters.showOvertimeAddition) {
        new _CSVPreviewCostProfitLossAdditionalSection2.default().init(columnsStrategy.getNumOfDataColumns(), numOfGroupingColumns, reportParameters.showOvertimeAddition, reportParameters.showLeaveTimeCosts).addRows(tBody);
    }
    this.addEmptySectionIfNeeded(totalRowNum, tBody, totalColumnsNum);
    return table;
};

CostCSVPreviewGenerator.prototype.getColumnsStrategy = function (reportParameters) {
    var showOthers = reportParameters.includeOtherUsersColumn;
    var $reportPreviewPlaceholder = (0, _jquery2.default)("#reportPreviewPlaceholder");
    $reportPreviewPlaceholder.removeClass("resizeForScroll");

    if (reportParameters.columnsConfig === _constants.ReportColumnsFormatCostOfWork.USERS_ONLY) {
        if (reportParameters.showSpentTime || reportParameters.showUserRates) {
            return new _CostCSVPreviewTwoLevelsUsersOnlyColumnsStrategy2.default().init({
                showSpentTime: reportParameters.showSpentTime,
                showAverageRates: reportParameters.showAverageRates,
                showUserRates: reportParameters.showUserRates,
                showOthers: showOthers
            });
        } else {
            return new _CostCSVPreviewOneLevelsColumnsStrategy2.default().init({
                showAverageRates: reportParameters.showAverageRates,
                headerLevelKey: "report.user",
                showOthers: showOthers
            });
        }
    } else if (reportParameters.columnsConfig === _constants.ReportColumnsFormatCostOfWork.GROUPS_ONLY) {
        if (reportParameters.showSpentTime || reportParameters.showAverageRates) {
            return new _CostCSVPreviewTwoLevelsGroupsOnlyColumnsStrategy2.default().init({
                showSpentTime: reportParameters.showSpentTime,
                showAverageRates: reportParameters.showAverageRates,
                showOthers: showOthers
            });
        } else {
            return new _CostCSVPreviewOneLevelsColumnsStrategy2.default().init({
                showAverageRates: reportParameters.showAverageRates,
                headerLevelKey: "user.group",
                showOthers: showOthers
            });
        }
    } else {
        if (reportParameters.showSpentTime || reportParameters.showUserRates) {
            var columnsCount = 0;
            if (reportParameters.showSpentTime) columnsCount++;
            if (reportParameters.showAverageRates) columnsCount++;
            if (reportParameters.showUserRates) columnsCount++;
            if (reportParameters.showSubtotalsByDepartments) columnsCount++;
            if (showOthers) columnsCount++;

            var twoGroupingLevels = reportParameters.firstGroupingLevel !== _constants2.ReportGroupingLevel.NONE && reportParameters.secondGroupingLevel !== _constants2.ReportGroupingLevel.NONE;
            if (columnsCount === 5 || columnsCount === 4 && twoGroupingLevels) {
                $reportPreviewPlaceholder.addClass("resizeForScroll");
            }
            return new _CostCSVPreviewUserByGroupsThreeLevels2.default().init({
                showSpentTime: reportParameters.showSpentTime,
                showAverageRates: reportParameters.showAverageRates,
                showUserRates: reportParameters.showUserRates,
                showSubtotalsByDepartments: reportParameters.showSubtotalsByDepartments,
                showOthers: showOthers
            });
        } else {
            return new _CostCSVPreviewUserByGroupsOnlyColumnsStrategy2.default().init({
                showAverageRates: reportParameters.showAverageRates,
                showSubtotalsByDepartments: reportParameters.showSubtotalsByDepartments,
                showOthers: showOthers
            });
        }
    }
};

CostCSVPreviewGenerator.prototype.addEmptySectionIfNeeded = function (totalRowsNum, tBody, totalColumnsNum) {
    var numOfEmptyRows = totalRowsNum + 1 - tBody.childNodes.length;
    if (numOfEmptyRows > 0) new _CSVPreviewEmptySection2.default().init(numOfEmptyRows, totalColumnsNum).addRows(tBody);
};

/***/ }),
/* 2088 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = CostCSVPreviewHeaderSection;

var _CSVPreviewSection = __webpack_require__(43);

var _CSVPreviewSection2 = _interopRequireDefault(_CSVPreviewSection);

var _PreviewSection = __webpack_require__(67);

var _PreviewSection2 = _interopRequireDefault(_PreviewSection);

var _constants = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CostCSVPreviewHeaderSection() {} /**
                                           * Created by filatov on 17.09.2015.
                                           */


CostCSVPreviewHeaderSection.prototype = new _CSVPreviewSection2.default();

CostCSVPreviewHeaderSection.prototype.init = function (columnsStrategy, firstGroupingLevel, secondGroupingLevel, thirdGroupingLevel, numOfGroupingLevels) {
    _PreviewSection2.default.prototype.init.call(this);
    this.columnsStrategy = columnsStrategy;
    this.firstGroupingLevel = firstGroupingLevel;
    this.secondGroupingLevel = secondGroupingLevel;
    this.thirdGroupingLevel = thirdGroupingLevel;
    this.numOfGroupingLevels = numOfGroupingLevels;

    return this;
};

CostCSVPreviewHeaderSection.prototype.addRows = function (tBody) {
    var countLevels = this.columnsStrategy.getCountGroupingRows();
    if (countLevels >= 3) {
        var thirdRow = this.createRow("headerGroupingRow");
        ReportPreviewUtils.addEmptyCells(thirdRow, this.numOfGroupingLevels);
        this.columnsStrategy.addThirdHeaderRowDataCells(thirdRow);
        this.addRow(tBody, thirdRow);
    }
    if (countLevels >= 2) {
        var secondRow = this.createRow("headerGroupingRow secondHeaderRow");
        ReportPreviewUtils.addEmptyCells(secondRow, this.numOfGroupingLevels);
        this.columnsStrategy.addSecondHeaderRowDataCells(secondRow);
        this.addRow(tBody, secondRow);
    }
    if (countLevels >= 1) {
        var firstRow = this.createRow("headerGroupingRow firstHeaderRow");
        this.addCell(firstRow, ReportPreviewUtils.getLevelPreviewName(this.firstGroupingLevel));
        if (this.secondGroupingLevel != _constants.ReportGroupingLevel.NONE) this.addCell(firstRow, ReportPreviewUtils.getLevelPreviewName(this.secondGroupingLevel));
        if (this.thirdGroupingLevel != _constants.ReportGroupingLevel.NONE) this.addCell(firstRow, ReportPreviewUtils.getLevelPreviewName(this.thirdGroupingLevel));
        this.columnsStrategy.addFirstHeaderRowDataCells(firstRow);
        this.addRow(tBody, firstRow);
    }
};

/***/ }),
/* 2089 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = CostCSVPreviewGroupingSection;

var _CSVPreviewSection = __webpack_require__(43);

var _CSVPreviewSection2 = _interopRequireDefault(_CSVPreviewSection);

var _constants = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Created by filatov on 18.09.2015.
 */
function CostCSVPreviewGroupingSection() {}

CostCSVPreviewGroupingSection.prototype = new _CSVPreviewSection2.default();

CostCSVPreviewGroupingSection.prototype.init = function (firstGroupingLevel, secondGroupingLevel, thirdGroupingLevel, countGroupingColumns, countDataColumns, countGroupingRows) {
    _CSVPreviewSection2.default.prototype.init.call(this);
    this.firstGroupingLevel = firstGroupingLevel;
    this.secondGroupingLevel = secondGroupingLevel;
    this.thirdGroupingLevel = thirdGroupingLevel;
    this.countDataColumns = countDataColumns;
    this.countGroupingColumns = countGroupingColumns;
    this.countGroupingRos = countGroupingRows;
    return this;
};

CostCSVPreviewGroupingSection.prototype.addRows = function (tBody) {
    for (var i = 0; i < 5; i++) {
        var row = this.createRow();
        this.addGroupingLevel(row, this.firstGroupingLevel);
        if (this.secondGroupingLevel != _constants.ReportGroupingLevel.NONE) this.addGroupingLevel(row, this.secondGroupingLevel);
        if (this.thirdGroupingLevel != _constants.ReportGroupingLevel.NONE) this.addGroupingLevel(row, this.thirdGroupingLevel);

        for (var j = 0; j < this.countDataColumns; j++) {
            this.addTimeValueCell(row);
        }this.addRow(tBody, row);
    }
};

CostCSVPreviewGroupingSection.prototype.addGroupingLevel = function (row, groupingLevel) {
    ReportPreviewUtils.addCell(row, ReportPreviewUtils.getLevelPreviewName(groupingLevel));
};

/***/ }),
/* 2090 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = CostCSVPreviewTwoLevelsUsersOnlyColumnsStrategy;

var _CostCSVPreviewTwoLevelsColumnsStrategy = __webpack_require__(996);

var _CostCSVPreviewTwoLevelsColumnsStrategy2 = _interopRequireDefault(_CostCSVPreviewTwoLevelsColumnsStrategy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CostCSVPreviewTwoLevelsUsersOnlyColumnsStrategy() {} /**
                                                               * Created by filatov on 18.09.2015.
                                                               */


CostCSVPreviewTwoLevelsUsersOnlyColumnsStrategy.prototype = new _CostCSVPreviewTwoLevelsColumnsStrategy2.default();

CostCSVPreviewTwoLevelsUsersOnlyColumnsStrategy.prototype.init = function (_ref) {
    var showSpentTime = _ref.showSpentTime,
        showAverageRates = _ref.showAverageRates,
        showUserRates = _ref.showUserRates,
        showOthers = _ref.showOthers;

    _CostCSVPreviewTwoLevelsColumnsStrategy2.default.prototype.init.call(this, {
        showSpentTime: showSpentTime,
        showAverageRates: showAverageRates,
        showOthers: showOthers
    });
    this.showUserRates = showUserRates;
    return this;
};

CostCSVPreviewTwoLevelsUsersOnlyColumnsStrategy.prototype.getLevelNameKey = function () {
    return "report.user";
};

CostCSVPreviewTwoLevelsUsersOnlyColumnsStrategy.prototype.isShowRatesForTopLevel = function () {
    return this.showUserRates;
};

/***/ }),
/* 2091 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = CostCSVPreviewOneLevelsColumnsStrategy;

var _CostCSVPreviewBaseColumnsStrategy = __webpack_require__(414);

var _CostCSVPreviewBaseColumnsStrategy2 = _interopRequireDefault(_CostCSVPreviewBaseColumnsStrategy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CostCSVPreviewOneLevelsColumnsStrategy() {} /**
                                                      * Created by filatov on 17.09.2015.
                                                      */


CostCSVPreviewOneLevelsColumnsStrategy.prototype = new _CostCSVPreviewBaseColumnsStrategy2.default();

CostCSVPreviewOneLevelsColumnsStrategy.prototype.init = function (_ref) {
    var showAverageRates = _ref.showAverageRates,
        headerLevelKey = _ref.headerLevelKey,
        showOthers = _ref.showOthers;

    _CostCSVPreviewBaseColumnsStrategy2.default.prototype.init.call(this, false, showAverageRates, false);
    this.headerLevelKey = headerLevelKey;
    this.showOthers = showOthers;
    return this;
};

CostCSVPreviewOneLevelsColumnsStrategy.prototype.getNumOfDetailsColumns = function () {
    return 3;
};

CostCSVPreviewOneLevelsColumnsStrategy.prototype.getCountGroupingRows = function () {
    return 1;
};

CostCSVPreviewOneLevelsColumnsStrategy.prototype.addFirstHeaderRowDataCells = function (row) {
    this.addOverallHeaderCells(row);

    var numDataCells = this.showOthers ? this.getNumOfDetailsColumns() - 1 : this.getNumOfDetailsColumns();
    for (var i = 0; i < numDataCells; ++i) {
        this.addCell(row, this.message(this.headerLevelKey));
    }

    if (this.showOthers) this.addCell(row, this.message("report.common.others"));
};

/***/ }),
/* 2092 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = CostCSVPreviewTwoLevelsGroupsOnlyColumnsStrategy;

var _CostCSVPreviewTwoLevelsColumnsStrategy = __webpack_require__(996);

var _CostCSVPreviewTwoLevelsColumnsStrategy2 = _interopRequireDefault(_CostCSVPreviewTwoLevelsColumnsStrategy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CostCSVPreviewTwoLevelsGroupsOnlyColumnsStrategy() {} /**
                                                                * Created by filatov on 18.09.2015.
                                                                */


CostCSVPreviewTwoLevelsGroupsOnlyColumnsStrategy.prototype = new _CostCSVPreviewTwoLevelsColumnsStrategy2.default();

CostCSVPreviewTwoLevelsGroupsOnlyColumnsStrategy.prototype.init = function (_ref) {
    var showSpentTime = _ref.showSpentTime,
        showAverageRates = _ref.showAverageRates,
        showOthers = _ref.showOthers;

    _CostCSVPreviewTwoLevelsColumnsStrategy2.default.prototype.init.call(this, {
        showSpentTime: showSpentTime,
        showAverageRates: showAverageRates,
        showOthers: showOthers
    });
    return this;
};

CostCSVPreviewTwoLevelsGroupsOnlyColumnsStrategy.prototype.getLevelNameKey = function () {
    return "user.group";
};

CostCSVPreviewTwoLevelsGroupsOnlyColumnsStrategy.prototype.isShowRatesForTopLevel = function () {
    return this.showAverageRates;
};

/***/ }),
/* 2093 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = CostCSVPreviewUserByGroupsThreeLevels;

var _CostCSVPreviewBaseColumnsStrategy = __webpack_require__(414);

var _CostCSVPreviewBaseColumnsStrategy2 = _interopRequireDefault(_CostCSVPreviewBaseColumnsStrategy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CostCSVPreviewUserByGroupsThreeLevels() {} /**
                                                     * Created by filatov on 17.09.2015.
                                                     */


CostCSVPreviewUserByGroupsThreeLevels.prototype = new _CostCSVPreviewBaseColumnsStrategy2.default();

CostCSVPreviewUserByGroupsThreeLevels.prototype.init = function (_ref) {
    var showSpentTime = _ref.showSpentTime,
        showAverageRates = _ref.showAverageRates,
        showUserRates = _ref.showUserRates,
        showSubtotalsByDepartments = _ref.showSubtotalsByDepartments,
        showOthers = _ref.showOthers;

    _CostCSVPreviewBaseColumnsStrategy2.default.prototype.init.call(this, showSpentTime, showAverageRates);
    this.showUserRates = showUserRates;
    this.showSubtotalsByDepartments = showSubtotalsByDepartments;
    this.showOthers = showOthers;
    return this;
};

CostCSVPreviewUserByGroupsThreeLevels.prototype.getNumOfDetailsColumns = function () {
    var numOfDetailsColumns = this._getNumOfSubtotalDetailsColumns() + this._getNumOfUserDetailsColumns();
    if (this.showOthers) numOfDetailsColumns += this._getNumOfUserDetailsColumns();
    return numOfDetailsColumns;
};

CostCSVPreviewUserByGroupsThreeLevels.prototype._getNumOfUserDetailsColumns = function () {
    var countText = 1;
    if (this.showSpentTime) countText++;
    if (this.showUserRates) countText++;
    return countText;
};

CostCSVPreviewUserByGroupsThreeLevels.prototype._getNumOfSubtotalDetailsColumns = function () {
    var countText = 0;
    if (this.showSubtotalsByDepartments) {
        countText++;

        if (this.showSpentTime) {
            countText++;
        }
    }
    return countText;
};

CostCSVPreviewUserByGroupsThreeLevels.prototype.addThirdHeaderRowDataCells = function (row) {
    ReportPreviewUtils.addEmptyCells(row, this.getOverallColumnsCount());
    var numOfUserDetailsSubColumns = this._getNumOfUserDetailsColumns();
    var numOfGropingHeadersColumns = numOfUserDetailsSubColumns + this._getNumOfSubtotalDetailsColumns();
    for (var i = 0; i < numOfGropingHeadersColumns; i++) {
        this.addCell(row, this.message("user.group"));
    }
    if (this.showOthers) ReportPreviewUtils.addEmptyCells(row, numOfUserDetailsSubColumns);
};

CostCSVPreviewUserByGroupsThreeLevels.prototype.addSecondHeaderRowDataCells = function (row) {
    ReportPreviewUtils.addEmptyCells(row, this.getOverallColumnsCount());
    var countUserColumns = this._getNumOfUserDetailsColumns();
    var countSubtotalColumns = this._getNumOfSubtotalDetailsColumns();
    for (var i = 0; i < countSubtotalColumns; i++) {
        this.addCell(row, this.message("report.subtotal"));
    }
    for (var _i = 0; _i < countUserColumns; _i++) {
        this.addCell(row, this.message("report.user"));
    }
    if (this.showOthers) {
        for (var _i2 = 0; _i2 < countUserColumns; _i2++) {
            this.addCell(row, this.message("report.common.others"));
        }
    }
};

CostCSVPreviewUserByGroupsThreeLevels.prototype.addFirstHeaderRowDataCells = function (row) {
    this.addOverallHeaderCells(row);
    if (this.showSubtotalsByDepartments) {
        if (this.showSpentTime) this.addCell(row, this.message("report.cost.spent"), "spent");
        this.addCell(row, this.message("report.cost.cost"), "cost");
    }
    this._addFirstHeaderRowUserDataCells(row);
    if (this.showOthers) this._addFirstHeaderRowUserDataCells(row);
};

CostCSVPreviewUserByGroupsThreeLevels.prototype._addFirstHeaderRowUserDataCells = function (row) {
    if (this.showSpentTime) this.addCell(row, this.message("report.cost.spent"), "spent");
    if (this.showUserRates) this.addCell(row, this.message("report.cost.rate"), "rate");
    this.addCell(row, this.message("report.cost.cost"), "cost");
};

CostCSVPreviewUserByGroupsThreeLevels.prototype.getCountGroupingRows = function (colGroupingRow) {
    return 3;
};

/***/ }),
/* 2094 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = CostCSVPreviewUserByGroupsOnlyColumnsStrategy;

var _CostCSVPreviewBaseColumnsStrategy = __webpack_require__(414);

var _CostCSVPreviewBaseColumnsStrategy2 = _interopRequireDefault(_CostCSVPreviewBaseColumnsStrategy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CostCSVPreviewUserByGroupsOnlyColumnsStrategy() {} /**
                                                             * Created by filatov on 17.09.2015.
                                                             */


CostCSVPreviewUserByGroupsOnlyColumnsStrategy.prototype = new _CostCSVPreviewBaseColumnsStrategy2.default();

CostCSVPreviewUserByGroupsOnlyColumnsStrategy.prototype.init = function (_ref) {
    var showAverageRates = _ref.showAverageRates,
        showSubtotalsByDepartments = _ref.showSubtotalsByDepartments,
        showOthers = _ref.showOthers;

    _CostCSVPreviewBaseColumnsStrategy2.default.prototype.init.call(this, false, showAverageRates);
    this.showSubtotalsByDepartments = showSubtotalsByDepartments;
    this.showOthers = showOthers;
    return this;
};

CostCSVPreviewUserByGroupsOnlyColumnsStrategy.prototype.getNumOfDetailsColumns = function () {
    return 3;
};

CostCSVPreviewUserByGroupsOnlyColumnsStrategy.prototype.addSecondHeaderRowDataCells = function (row) {
    ReportPreviewUtils.addEmptyCells(row, this.getOverallColumnsCount());
    var numGroupingHeaders = this.getNumOfDetailsColumns();
    if (this.showOthers) numGroupingHeaders--;
    for (var i = 0; i < numGroupingHeaders; i++) {
        this.addCell(row, this.message("user.group"));
    }
    if (this.showOthers) ReportPreviewUtils.addEmptyCell(row);
};

CostCSVPreviewUserByGroupsOnlyColumnsStrategy.prototype.addFirstHeaderRowDataCells = function (row) {
    this.addOverallHeaderCells(row);

    var numOfHeaderSubColumns = this.getNumOfDetailsColumns();
    if (this.showSubtotalsByDepartments) {
        this.addCell(row, this.message("report.subtotal"));
        numOfHeaderSubColumns--;
    }
    if (this.showOthers) numOfHeaderSubColumns--;
    for (var i = 0; i < numOfHeaderSubColumns; i++) {
        this.addCell(row, this.message("report.user"));
    }
    if (this.showOthers) this.addCell(row, this.message("report.common.others"));
};

CostCSVPreviewUserByGroupsOnlyColumnsStrategy.prototype.getCountGroupingRows = function () {
    return 2;
};

/***/ }),
/* 2095 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = CostHTMLPreviewGenerator;

var _CostHTMLPreviewGeneralCostsSection = __webpack_require__(2096);

var _CostHTMLPreviewGeneralCostsSection2 = _interopRequireDefault(_CostHTMLPreviewGeneralCostsSection);

var _CostHTMLPreviewGroupingSection = __webpack_require__(2097);

var _CostHTMLPreviewGroupingSection2 = _interopRequireDefault(_CostHTMLPreviewGroupingSection);

var _CostHTMLPreviewHeaderSection = __webpack_require__(2098);

var _CostHTMLPreviewHeaderSection2 = _interopRequireDefault(_CostHTMLPreviewHeaderSection);

var _CostHTMLPreviewGrandTotalSection = __webpack_require__(2099);

var _CostHTMLPreviewGrandTotalSection2 = _interopRequireDefault(_CostHTMLPreviewGrandTotalSection);

var _constants = __webpack_require__(4);

var _CostHTMLPreviewTwoLevelsHeaderUsersOnlyColumnsStrategy = __webpack_require__(2100);

var _CostHTMLPreviewTwoLevelsHeaderUsersOnlyColumnsStrategy2 = _interopRequireDefault(_CostHTMLPreviewTwoLevelsHeaderUsersOnlyColumnsStrategy);

var _CostHTMLPreviewOneLevelHeaderUsersOnlyColumnsStrategy = __webpack_require__(2101);

var _CostHTMLPreviewOneLevelHeaderUsersOnlyColumnsStrategy2 = _interopRequireDefault(_CostHTMLPreviewOneLevelHeaderUsersOnlyColumnsStrategy);

var _CostHTMLPreviewTwoLevelsHeaderGroupsOnlyColumnsStrategy = __webpack_require__(2102);

var _CostHTMLPreviewTwoLevelsHeaderGroupsOnlyColumnsStrategy2 = _interopRequireDefault(_CostHTMLPreviewTwoLevelsHeaderGroupsOnlyColumnsStrategy);

var _CostHTMLPreviewOneLevelHeaderGroupsOnlyColumnsStrategy = __webpack_require__(2103);

var _CostHTMLPreviewOneLevelHeaderGroupsOnlyColumnsStrategy2 = _interopRequireDefault(_CostHTMLPreviewOneLevelHeaderGroupsOnlyColumnsStrategy);

var _CostHTMLPreviewUsersByGroupsThreeLevelsColumnsStrategy = __webpack_require__(2104);

var _CostHTMLPreviewUsersByGroupsThreeLevelsColumnsStrategy2 = _interopRequireDefault(_CostHTMLPreviewUsersByGroupsThreeLevelsColumnsStrategy);

var _CostHTMLPreviewUsersByGroupsCostOnlyColumnsStrategy = __webpack_require__(2105);

var _CostHTMLPreviewUsersByGroupsCostOnlyColumnsStrategy2 = _interopRequireDefault(_CostHTMLPreviewUsersByGroupsCostOnlyColumnsStrategy);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CostHTMLPreviewGenerator() {}

CostHTMLPreviewGenerator.prototype.init = function () {
    return this;
};

CostHTMLPreviewGenerator.prototype.generatePreviewTable = function (reportParameters) {
    var table = document.createElement("table");
    table.className = "reportHtmlPreviewTable cost";
    var tBody = document.createElement("tbody");
    table.appendChild(tBody);

    var columnsStrategy = this.getColumnsStrategy(reportParameters);

    var groupingRowsCount = 3;
    var generalCostsSection = null;
    if (reportParameters.showLeaveTimeCosts || reportParameters.showOvertimeAddition) {
        generalCostsSection = new _CostHTMLPreviewGeneralCostsSection2.default().init(reportParameters.showLeaveTimeCosts, reportParameters.showOvertimeAddition, columnsStrategy);
        if (!reportParameters.showLeaveTimeCosts) groupingRowsCount += 3;
        if (!reportParameters.showOvertimeAddition) groupingRowsCount++;
    } else {
        groupingRowsCount += 5;
    }

    var groupingSection = new _CostHTMLPreviewGroupingSection2.default().init(reportParameters.firstGroupingLevel, reportParameters.secondGroupingLevel, reportParameters.thirdGroupingLevel, columnsStrategy, groupingRowsCount);

    var headerSection = new _CostHTMLPreviewHeaderSection2.default().init(columnsStrategy);

    var grandTotalSection = new _CostHTMLPreviewGrandTotalSection2.default().init(columnsStrategy);

    headerSection.addRows(tBody);
    groupingSection.addRows(tBody);
    if (generalCostsSection) generalCostsSection.addRows(tBody);
    grandTotalSection.addRows(tBody);

    return table;
};

CostHTMLPreviewGenerator.prototype.getColumnsStrategy = function (reportParameters) {
    var showOthers = reportParameters.includeOtherUsersColumn;
    var $reportPreviewPlaceholder = (0, _jquery2.default)("#reportPreviewPlaceholder");
    $reportPreviewPlaceholder.removeClass("resizeForScroll");

    if (reportParameters.columnsConfig === _constants.ReportColumnsFormatCostOfWork.USERS_ONLY) {
        if (reportParameters.showSpentTime || reportParameters.showUserRates) {
            return new _CostHTMLPreviewTwoLevelsHeaderUsersOnlyColumnsStrategy2.default().init({
                timeFormat: reportParameters.timeFormat,
                showSpentTime: reportParameters.showSpentTime,
                showAverageRates: reportParameters.showAverageRates,
                showUserRates: reportParameters.showUserRates,
                showOthers: showOthers
            });
        } else {
            return new _CostHTMLPreviewOneLevelHeaderUsersOnlyColumnsStrategy2.default().init({
                timeFormat: reportParameters.timeFormat,
                showAverageRates: reportParameters.showAverageRates,
                showOthers: showOthers
            });
        }
    } else if (reportParameters.columnsConfig === _constants.ReportColumnsFormatCostOfWork.GROUPS_ONLY) {
        if (reportParameters.showSpentTime || reportParameters.showAverageRates) {
            return new _CostHTMLPreviewTwoLevelsHeaderGroupsOnlyColumnsStrategy2.default().init({
                timeFormat: reportParameters.timeFormat,
                showSpentTime: reportParameters.showSpentTime,
                showAverageRates: reportParameters.showAverageRates,
                showOthers: showOthers
            });
        } else {
            return new _CostHTMLPreviewOneLevelHeaderGroupsOnlyColumnsStrategy2.default().init({
                timeFormat: reportParameters.timeFormat,
                showOthers: showOthers
            });
        }
    } else {
        if (reportParameters.showSpentTime || reportParameters.showUserRates) {
            if (reportParameters.showAverageRates && reportParameters.showSubtotalsByDepartments && reportParameters.showSpentTime && reportParameters.showUserRates && showOthers) {
                $reportPreviewPlaceholder.addClass("resizeForScroll");
            }
            return new _CostHTMLPreviewUsersByGroupsThreeLevelsColumnsStrategy2.default().init({
                timeFormat: reportParameters.timeFormat,
                showSpentTime: reportParameters.showSpentTime,
                showAverageRates: reportParameters.showAverageRates,
                showUserRates: reportParameters.showUserRates,
                showSubtotals: reportParameters.showSubtotalsByDepartments,
                showOthers: showOthers
            });
        } else {
            return new _CostHTMLPreviewUsersByGroupsCostOnlyColumnsStrategy2.default().init({
                timeFormat: reportParameters.timeFormat,
                showAverageRates: reportParameters.showAverageRates,
                showSubtotals: reportParameters.showSubtotalsByDepartments,
                showOthers: showOthers
            });
        }
    }
};

/***/ }),
/* 2096 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = CostHTMLPreviewGeneralCostsSection;

var _CostHTMLPreviewBaseSection = __webpack_require__(601);

var _CostHTMLPreviewBaseSection2 = _interopRequireDefault(_CostHTMLPreviewBaseSection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CostHTMLPreviewGeneralCostsSection() {}

CostHTMLPreviewGeneralCostsSection.prototype = new _CostHTMLPreviewBaseSection2.default();

CostHTMLPreviewGeneralCostsSection.prototype.init = function (showLeaveTime, showOvertimeAddition, columnsStrategy) {
    _CostHTMLPreviewBaseSection2.default.prototype.init.call(this, columnsStrategy);
    this.showLeaveTime = showLeaveTime;
    this.showOvertimeAddition = showOvertimeAddition;
    return this;
};

CostHTMLPreviewGeneralCostsSection.prototype.addRows = function (tBody) {
    var headerRow = this.createRow("generalCosts");
    this.addCell(headerRow, this.message("report.general_costs"), "", this.columnsStrategy.getDataColumnsCount() + 1);
    this.addRow(tBody, headerRow);

    if (this.showLeaveTime) {
        this.addRowWithMainCell(tBody, this.message("report.cost.total_for_leave"), "totalLeaveTimeCell", "totalLeaveTime");
        for (var i = 0; i < 2; i++) {
            this.addRowWithMainCell(tBody, this.message("leave_type.leave_type"), "leaveType");
        }
    }

    if (this.showOvertimeAddition) this.addRowWithMainCell(tBody, this.message("report.cost.overtime_bonus"), "overtimeAdditionCell", "overtimeAddition");
};

/***/ }),
/* 2097 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = CostHTMLPreviewGroupingSection;

var _CostHTMLPreviewBaseSection = __webpack_require__(601);

var _CostHTMLPreviewBaseSection2 = _interopRequireDefault(_CostHTMLPreviewBaseSection);

var _constants = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CostHTMLPreviewGroupingSection() {}

CostHTMLPreviewGroupingSection.prototype = new _CostHTMLPreviewBaseSection2.default();

CostHTMLPreviewGroupingSection.prototype.init = function (firstGroupingLevel, secondGroupingLevel, thirdGroupingLevel, columnsStrategy, groupingRowsCount) {
    _CostHTMLPreviewBaseSection2.default.prototype.init.call(this, columnsStrategy);
    this.firstGroupingLevel = firstGroupingLevel;
    this.secondGroupingLevel = secondGroupingLevel;
    this.thirdGroupingLevel = thirdGroupingLevel;
    this.groupingRowsCount = groupingRowsCount;
    return this;
};

CostHTMLPreviewGroupingSection.prototype.addRows = function (tBody) {
    this.addRowWithMainCell(tBody, this.message("report.cost.total_for_working_time"), "totalForWorkingTime", "totalForWorkingTimeRow");

    var rowsCount = 0;
    while (true) {
        this.addGroupingRow(tBody, this.firstGroupingLevel, "firstLevel", "firstGrouping");
        if (++rowsCount >= this.groupingRowsCount) break;

        if (this.secondGroupingLevel != _constants.ReportGroupingLevel.NONE) {
            this.addGroupingRow(tBody, this.secondGroupingLevel, "secondLevel", "secondGrouping");
            if (++rowsCount >= this.groupingRowsCount) break;
        }

        if (this.thirdGroupingLevel != _constants.ReportGroupingLevel.NONE) {
            this.addThirdGroupingRow(tBody);
            if (++rowsCount >= this.groupingRowsCount) break;

            if (ReportPreviewUtils.isLevelCanBeAddedMoreThanOnce(this.thirdGroupingLevel, [this.firstGroupingLevel, this.secondGroupingLevel])) {
                this.addThirdGroupingRow(tBody);
                if (++rowsCount >= this.groupingRowsCount) break;
            }
        }
    }
};

CostHTMLPreviewGroupingSection.prototype.addGroupingRow = function (tBody, groupingLevel, mainCellClassName, rowClassName) {
    this.addRowWithMainCell(tBody, ReportPreviewUtils.getLevelPreviewName(groupingLevel), mainCellClassName, rowClassName);
};

CostHTMLPreviewGroupingSection.prototype.addThirdGroupingRow = function (tBody) {
    this.addGroupingRow(tBody, this.thirdGroupingLevel, this.secondGroupingLevel == _constants.ReportGroupingLevel.NONE ? "secondLevel" : "thirdLevel");
};

/***/ }),
/* 2098 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = CostHTMLPreviewHeaderSection;

var _PreviewSection = __webpack_require__(67);

var _PreviewSection2 = _interopRequireDefault(_PreviewSection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CostHTMLPreviewHeaderSection() {}

CostHTMLPreviewHeaderSection.prototype = new _PreviewSection2.default();

CostHTMLPreviewHeaderSection.prototype.init = function (columnsStrategy) {
    _PreviewSection2.default.prototype.init.call(this);
    this.columnsStrategy = columnsStrategy;
    return this;
};

CostHTMLPreviewHeaderSection.prototype.addRows = function (tBody) {
    var twoRowsInHeader = this.columnsStrategy.areThereTwoRowsInHeader();

    var firstRow = this.createRow("headerRow firstHeaderRow " + (twoRowsInHeader ? "lowFirstRow" : ""));
    this.addCell(firstRow, this.message("report.cost_items"), "costItems", 1, 3);
    this.columnsStrategy.addFirstHeaderRowDataCells(firstRow);
    this.addRow(tBody, firstRow);

    var secondRow = this.createRow("headerRow secondHeaderRow");
    this.columnsStrategy.addSecondHeaderRowDataCells(secondRow);
    this.addRow(tBody, secondRow);

    var thirdRow = this.createRow("headerRow thirdHeaderRow " + (twoRowsInHeader ? "highThirdRow" : ""));
    this.columnsStrategy.addThirdHeaderRowDataCells(thirdRow);
    this.addRow(tBody, thirdRow);
};

/***/ }),
/* 2099 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = CostHTMLPreviewGrandTotalSection;

var _CostHTMLPreviewBaseSection = __webpack_require__(601);

var _CostHTMLPreviewBaseSection2 = _interopRequireDefault(_CostHTMLPreviewBaseSection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CostHTMLPreviewGrandTotalSection() {}

CostHTMLPreviewGrandTotalSection.prototype = new _CostHTMLPreviewBaseSection2.default();

CostHTMLPreviewGrandTotalSection.prototype.init = function (columnsStrategy) {
    _CostHTMLPreviewBaseSection2.default.prototype.init.call(this, columnsStrategy);
    return this;
};

CostHTMLPreviewGrandTotalSection.prototype.addRows = function (tBody) {
    var splitterRow = this.createRow("splitterRow");
    this.addCell(splitterRow, "", "", this.columnsStrategy.getDataColumnsCount() + 1);
    this.addRow(tBody, splitterRow);

    this.addRowWithMainCell(tBody, this.message("report.grand_total"), "grandTotalCell", "grandTotal");
};

/***/ }),
/* 2100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = CostHTMLPreviewTwoLevelsHeaderUsersOnlyColumnsStrategy;

var _CostHTMLPreviewTwoLevelsHeaderBaseColumnsStrategy = __webpack_require__(997);

var _CostHTMLPreviewTwoLevelsHeaderBaseColumnsStrategy2 = _interopRequireDefault(_CostHTMLPreviewTwoLevelsHeaderBaseColumnsStrategy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CostHTMLPreviewTwoLevelsHeaderUsersOnlyColumnsStrategy() {}

CostHTMLPreviewTwoLevelsHeaderUsersOnlyColumnsStrategy.prototype = new _CostHTMLPreviewTwoLevelsHeaderBaseColumnsStrategy2.default();

CostHTMLPreviewTwoLevelsHeaderUsersOnlyColumnsStrategy.prototype.init = function (_ref) {
    var timeFormat = _ref.timeFormat,
        showSpentTime = _ref.showSpentTime,
        showAverageRates = _ref.showAverageRates,
        showUserRates = _ref.showUserRates,
        showOthers = _ref.showOthers;

    _CostHTMLPreviewTwoLevelsHeaderBaseColumnsStrategy2.default.prototype.init.call(this, {
        timeFormat: timeFormat,
        showSpentTime: showSpentTime,
        showAverageRates: showAverageRates,
        showOthers: showOthers
    });
    this.showUserRates = showUserRates;
    return this;
};

CostHTMLPreviewTwoLevelsHeaderUsersOnlyColumnsStrategy.prototype.isShowRatesForTopLevel = function () {
    return this.showUserRates;
};

CostHTMLPreviewTwoLevelsHeaderUsersOnlyColumnsStrategy.prototype.getTopLevelNameKey = function () {
    return "report.user";
};

CostHTMLPreviewTwoLevelsHeaderUsersOnlyColumnsStrategy.prototype.getTopLevelHeaderCellClassName = function () {
    return this.showSpentTime ? "lightHeaderCell" : "lightGreenHeaderCell";
};

/***/ }),
/* 2101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = CostHTMLPreviewOneLevelHeaderUsersOnlyColumnsStrategy;

var _CostHTMLPreviewOneLevelHeaderBaseColumnsStrategy = __webpack_require__(998);

var _CostHTMLPreviewOneLevelHeaderBaseColumnsStrategy2 = _interopRequireDefault(_CostHTMLPreviewOneLevelHeaderBaseColumnsStrategy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CostHTMLPreviewOneLevelHeaderUsersOnlyColumnsStrategy() {}

CostHTMLPreviewOneLevelHeaderUsersOnlyColumnsStrategy.prototype = new _CostHTMLPreviewOneLevelHeaderBaseColumnsStrategy2.default();

CostHTMLPreviewOneLevelHeaderUsersOnlyColumnsStrategy.prototype.init = function (_ref) {
    var timeFormat = _ref.timeFormat,
        showAverageRates = _ref.showAverageRates,
        showOthers = _ref.showOthers;

    _CostHTMLPreviewOneLevelHeaderBaseColumnsStrategy2.default.prototype.init.call(this, {
        timeFormat: timeFormat,
        showAverageRates: showAverageRates,
        showOthers: showOthers
    });
    return this;
};

CostHTMLPreviewOneLevelHeaderUsersOnlyColumnsStrategy.prototype.getLevelNameKey = function () {
    return "report.user";
};

CostHTMLPreviewOneLevelHeaderUsersOnlyColumnsStrategy.prototype.getLevelCellsClassName = function () {
    return "lightGreenHeaderCell";
};

/***/ }),
/* 2102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = CostHTMLPreviewTwoLevelsHeaderGroupsOnlyColumnsStrategy;

var _CostHTMLPreviewTwoLevelsHeaderBaseColumnsStrategy = __webpack_require__(997);

var _CostHTMLPreviewTwoLevelsHeaderBaseColumnsStrategy2 = _interopRequireDefault(_CostHTMLPreviewTwoLevelsHeaderBaseColumnsStrategy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CostHTMLPreviewTwoLevelsHeaderGroupsOnlyColumnsStrategy() {}

CostHTMLPreviewTwoLevelsHeaderGroupsOnlyColumnsStrategy.prototype = new _CostHTMLPreviewTwoLevelsHeaderBaseColumnsStrategy2.default();

CostHTMLPreviewTwoLevelsHeaderGroupsOnlyColumnsStrategy.prototype.init = function (_ref) {
    var timeFormat = _ref.timeFormat,
        showSpentTime = _ref.showSpentTime,
        showAverageRates = _ref.showAverageRates,
        showOthers = _ref.showOthers;

    _CostHTMLPreviewTwoLevelsHeaderBaseColumnsStrategy2.default.prototype.init.call(this, {
        timeFormat: timeFormat,
        showSpentTime: showSpentTime,
        showAverageRates: showAverageRates,
        showOthers: showOthers
    });
    return this;
};

CostHTMLPreviewTwoLevelsHeaderGroupsOnlyColumnsStrategy.prototype.isShowRatesForTopLevel = function () {
    return this.showAverageRates;
};

CostHTMLPreviewTwoLevelsHeaderGroupsOnlyColumnsStrategy.prototype.getTopLevelNameKey = function () {
    return "user.group";
};

CostHTMLPreviewTwoLevelsHeaderGroupsOnlyColumnsStrategy.prototype.getTopLevelHeaderCellClassName = function () {
    return "userGroup " + (this.showSpentTime ? "darkHeaderCell" : "darkGreenHeaderCell");
};

/***/ }),
/* 2103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = CostHTMLPreviewOneLevelHeaderGroupsOnlyColumnsStrategy;

var _CostHTMLPreviewOneLevelHeaderBaseColumnsStrategy = __webpack_require__(998);

var _CostHTMLPreviewOneLevelHeaderBaseColumnsStrategy2 = _interopRequireDefault(_CostHTMLPreviewOneLevelHeaderBaseColumnsStrategy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CostHTMLPreviewOneLevelHeaderGroupsOnlyColumnsStrategy() {}

CostHTMLPreviewOneLevelHeaderGroupsOnlyColumnsStrategy.prototype = new _CostHTMLPreviewOneLevelHeaderBaseColumnsStrategy2.default();

CostHTMLPreviewOneLevelHeaderGroupsOnlyColumnsStrategy.prototype.init = function (_ref) {
    var timeFormat = _ref.timeFormat,
        showOthers = _ref.showOthers;

    _CostHTMLPreviewOneLevelHeaderBaseColumnsStrategy2.default.prototype.init.call(this, {
        timeFormat: timeFormat,
        showAverageRates: false,
        showOthers: showOthers
    });
    return this;
};

CostHTMLPreviewOneLevelHeaderGroupsOnlyColumnsStrategy.prototype.getLevelNameKey = function () {
    return "user.group";
};

CostHTMLPreviewOneLevelHeaderGroupsOnlyColumnsStrategy.prototype.getLevelCellsClassName = function () {
    return "darkGreenHeaderCell userGroup";
};

/***/ }),
/* 2104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = CostHTMLPreviewUsersByGroupsThreeLevelsColumnsStrategy;

var _CostHTMLPreviewBaseColumnsStrategy = __webpack_require__(415);

var _CostHTMLPreviewBaseColumnsStrategy2 = _interopRequireDefault(_CostHTMLPreviewBaseColumnsStrategy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CostHTMLPreviewUsersByGroupsThreeLevelsColumnsStrategy() {}

CostHTMLPreviewUsersByGroupsThreeLevelsColumnsStrategy.prototype = new _CostHTMLPreviewBaseColumnsStrategy2.default();

CostHTMLPreviewUsersByGroupsThreeLevelsColumnsStrategy.prototype.init = function (_ref) {
    var timeFormat = _ref.timeFormat,
        showSpentTime = _ref.showSpentTime,
        showAverageRates = _ref.showAverageRates,
        showUserRates = _ref.showUserRates,
        showSubtotals = _ref.showSubtotals,
        showOthers = _ref.showOthers;

    _CostHTMLPreviewBaseColumnsStrategy2.default.prototype.init.call(this, timeFormat, showSpentTime, showAverageRates);
    this.showUserRates = showUserRates;
    this.showSubtotals = showSubtotals;
    this.showOthers = showOthers;
    return this;
};

CostHTMLPreviewUsersByGroupsThreeLevelsColumnsStrategy.prototype.addFirstHeaderRowDataCells = function (row) {
    this.addOverallHeaderCells(row);
    var colSpan = 1;
    if (this.showSpentTime) colSpan++;
    if (this.showUserRates) colSpan++;
    if (this.showSubtotals) {
        colSpan++;
        if (this.showSpentTime) colSpan++;
    } else if (!this.showOthers) {
        colSpan = colSpan * 2;
    }
    this.addCell(row, SystemSettings.userGroupNamingSingular, "userGroup " + (this.showSpentTime ? "darkHeaderCell" : "darkGreenHeaderCell"), colSpan);

    if (this.showOthers) {
        var othersColSpan = 1;
        if (this.showSpentTime) othersColSpan++;
        if (this.showUserRates) othersColSpan++;
        this.addCell(row, this.message("report.common.others"), this.getUserHeaderCellClassName(), othersColSpan, 2);
    }
};

CostHTMLPreviewUsersByGroupsThreeLevelsColumnsStrategy.prototype.addSecondHeaderRowDataCells = function (row) {
    var userCellColSpan = this.showSpentTime && this.showUserRates ? 3 : 2;
    if (this.showSubtotals) {
        var rowSpan = this.showSpentTime ? 1 : 2;
        var colSpan = this.showSpentTime ? 2 : 1;
        this.addCell(row, this.message("report.subtotal"), this.showSpentTime ? "darkHeaderCell" : "darkGreenHeaderCell", colSpan, rowSpan);
    } else if (!this.showOthers) {
        this.addCell(row, this.message("report.user"), this.getUserHeaderCellClassName(), userCellColSpan);
    }
    this.addCell(row, this.message("report.user"), this.getUserHeaderCellClassName(), userCellColSpan);
};

CostHTMLPreviewUsersByGroupsThreeLevelsColumnsStrategy.prototype.addThirdHeaderRowDataCells = function (row) {
    if (this.showSubtotals) {
        if (this.showSpentTime) {
            this.addCell(row, this.message("report.cost.spent"), "spent");
            this.addCell(row, this.message("report.cost.cost"), "cost");
        }
    } else if (!this.showOthers) {
        this.addThirdLevelUserCols(row);
    }

    this.addThirdLevelUserCols(row);

    if (this.showOthers) this.addThirdLevelUserCols(row);
};

CostHTMLPreviewUsersByGroupsThreeLevelsColumnsStrategy.prototype.addThirdLevelUserCols = function (row) {
    if (this.showSpentTime) this.addCell(row, this.message("report.cost.spent"), "spent");
    if (this.showUserRates) this.addCell(row, this.message("report.cost.rate"), "rate");
    this.addCell(row, this.message("report.cost.cost"), "cost");
};

CostHTMLPreviewUsersByGroupsThreeLevelsColumnsStrategy.prototype.addUserCols = function (row) {
    if (this.showSpentTime) this.addTimeValueCell(row);
    if (this.showUserRates) this.addMoneyValueCell(row);
    this.addCostDataCell(row);
};

CostHTMLPreviewUsersByGroupsThreeLevelsColumnsStrategy.prototype.addDataCells = function (row) {
    this.addOverallDataCells(row);
    if (this.showSubtotals) {
        if (this.showSpentTime) this.addTimeValueCell(row);
        this.showSpentTime ? this.addCostDataCell(row) : this.addMoneyValueCell(row);
    } else if (!this.showOthers) {
        this.addUserCols(row);
    }
    this.addUserCols(row);

    if (this.showOthers) this.addUserCols(row);
};

CostHTMLPreviewUsersByGroupsThreeLevelsColumnsStrategy.prototype.getDataColumnsCount = function () {
    var oneUserColumnWidth = this.showSpentTime && this.showUserRates ? 3 : 2;
    var userCols = oneUserColumnWidth;
    var count = userCols;
    if (this.showSubtotals) {
        count++;
        if (this.showSpentTime) count++;
    } else if (!this.showOthers) {
        count += userCols;
    }

    if (this.showOthers) count += oneUserColumnWidth;

    return this.getOverallColumnsCount() + count;
};

CostHTMLPreviewUsersByGroupsThreeLevelsColumnsStrategy.prototype.getUserHeaderCellClassName = function () {
    return this.showSpentTime ? "lightHeaderCell" : "lightGreenHeaderCell";
};

/***/ }),
/* 2105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = CostHTMLPreviewUsersByGroupsCostOnlyColumnsStrategy;

var _CostHTMLPreviewBaseColumnsStrategy = __webpack_require__(415);

var _CostHTMLPreviewBaseColumnsStrategy2 = _interopRequireDefault(_CostHTMLPreviewBaseColumnsStrategy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CostHTMLPreviewUsersByGroupsCostOnlyColumnsStrategy() {}

CostHTMLPreviewUsersByGroupsCostOnlyColumnsStrategy.prototype = new _CostHTMLPreviewBaseColumnsStrategy2.default();

CostHTMLPreviewUsersByGroupsCostOnlyColumnsStrategy.prototype.init = function (_ref) {
    var timeFormat = _ref.timeFormat,
        showAverageRates = _ref.showAverageRates,
        showSubtotals = _ref.showSubtotals,
        showOthers = _ref.showOthers;

    _CostHTMLPreviewBaseColumnsStrategy2.default.prototype.init.call(this, timeFormat, false, showAverageRates);
    this.showSubtotals = showSubtotals;
    this.showOthers = showOthers;
    return this;
};

CostHTMLPreviewUsersByGroupsCostOnlyColumnsStrategy.prototype.addFirstHeaderRowDataCells = function (row) {
    this.addOverallHeaderCells(row);
    this.addCell(row, SystemSettings.userGroupNamingSingular, "darkGreenHeaderCell userGroup", this.showOthers ? 2 : 3, 2);
    if (this.showOthers) this.addCell(row, this.message("report.common.others"), "lightGreenHeaderCell userGroup", 1, 3);
};

CostHTMLPreviewUsersByGroupsCostOnlyColumnsStrategy.prototype.addSecondHeaderRowDataCells = function (row) {
    // do nothing
};

CostHTMLPreviewUsersByGroupsCostOnlyColumnsStrategy.prototype.addThirdHeaderRowDataCells = function (row) {
    if (this.showSubtotals) {
        this.addCell(row, this.message("report.subtotal"), "darkGreenHeaderCell");
    } else {
        this.addCell(row, this.message("report.user"), "lightGreenHeaderCell");
    }
    this.addCell(row, this.message("report.user"), "lightGreenHeaderCell");
    if (!this.showOthers) this.addCell(row, this.message("report.user"), "lightGreenHeaderCell");
};

CostHTMLPreviewUsersByGroupsCostOnlyColumnsStrategy.prototype.addDataCells = function (row) {
    this.addOverallDataCells(row);
    this.addMoneyValueCell(row);
    this.addMoneyValueCell(row);
    this.addMoneyValueCell(row);
};

CostHTMLPreviewUsersByGroupsCostOnlyColumnsStrategy.prototype.getDataColumnsCount = function () {
    return this.getOverallColumnsCount() + 3;
};

CostHTMLPreviewUsersByGroupsCostOnlyColumnsStrategy.prototype.areThereTwoRowsInHeader = function () {
    return true;
};

/***/ }),
/* 2106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = BillingSummaryFormMediator;

var _BillingSummaryCSVPreviewGenerator = __webpack_require__(2107);

var _BillingSummaryCSVPreviewGenerator2 = _interopRequireDefault(_BillingSummaryCSVPreviewGenerator);

var _OldBaseFormMediator = __webpack_require__(271);

var _OldBaseFormMediator2 = _interopRequireDefault(_OldBaseFormMediator);

var _BillingSummaryReportEditFormConfigController = __webpack_require__(2116);

var _BillingSummaryReportEditFormConfigController2 = _interopRequireDefault(_BillingSummaryReportEditFormConfigController);

var _BillingSummaryHTMLPreviewGenerator = __webpack_require__(2117);

var _BillingSummaryHTMLPreviewGenerator2 = _interopRequireDefault(_BillingSummaryHTMLPreviewGenerator);

var _ATReportParamsStringBuilder = __webpack_require__(52);

var _ATReportParamsStringBuilder2 = _interopRequireDefault(_ATReportParamsStringBuilder);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function BillingSummaryFormMediator() {} /**
                                          * @author evdokimov
                                          */


BillingSummaryFormMediator.prototype = new _OldBaseFormMediator2.default();

BillingSummaryFormMediator.prototype.init = function (config) {
    _OldBaseFormMediator2.default.prototype.init.call(this, config);

    return this;
};

BillingSummaryFormMediator.prototype.initParamsStringBuilder = function (config) {
    return new _ATReportParamsStringBuilder2.default({
        data: {
            cpList: config.cpList,
            manageableUsersIds: ATReportsStore.getManageableUserIds(),
            projectsWithMaIds: ATReportsStore.getProjectsWithMaIds()
        },
        reportAuthorizationInfo: ATReportsStore.getReportAuthorizationInfo()
    });
};

BillingSummaryFormMediator.prototype.initEditConfigController = function (config) {
    var _this = this;

    return new _BillingSummaryReportEditFormConfigController2.default().init({
        panelId: "mainContainer",
        reportParameters: config.reportParameters,
        reportAuthorizationInfo: ATReportsStore.getReportAuthorizationInfo(),
        cpList: config.cpList,
        customersWithMaIds: config.customersWithMaIds,
        projectsWithMaIds: config.projectsWithMaIds,
        changeCallback: function changeCallback() {
            return _this.changeParametersCallback();
        }
    });
};

BillingSummaryFormMediator.prototype.initCsvGenerator = function () {
    return new _BillingSummaryCSVPreviewGenerator2.default().init();
};

BillingSummaryFormMediator.prototype.initHtmlGenerator = function () {
    return new _BillingSummaryHTMLPreviewGenerator2.default().init();
};

/***/ }),
/* 2107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = BillingSummaryCSVPreviewGenerator;

var _BillingSummaryCSVPreviewTimeOnNonBillableTasksStrategy = __webpack_require__(2108);

var _BillingSummaryCSVPreviewTimeOnNonBillableTasksStrategy2 = _interopRequireDefault(_BillingSummaryCSVPreviewTimeOnNonBillableTasksStrategy);

var _BillingSummaryCSVPreviewUtils = __webpack_require__(602);

var _BillingSummaryCSVPreviewUtils2 = _interopRequireDefault(_BillingSummaryCSVPreviewUtils);

var _BillingSummaryCSVPreviewBillingTypesSection = __webpack_require__(2109);

var _BillingSummaryCSVPreviewBillingTypesSection2 = _interopRequireDefault(_BillingSummaryCSVPreviewBillingTypesSection);

var _BillingSummaryCSVPreviewHeader = __webpack_require__(2110);

var _BillingSummaryCSVPreviewHeader2 = _interopRequireDefault(_BillingSummaryCSVPreviewHeader);

var _BillingSummaryCSVPreviewGroupingSection = __webpack_require__(2111);

var _BillingSummaryCSVPreviewGroupingSection2 = _interopRequireDefault(_BillingSummaryCSVPreviewGroupingSection);

var _CSVParametersBuilder = __webpack_require__(150);

var _CSVParametersBuilder2 = _interopRequireDefault(_CSVParametersBuilder);

var _CSVParametersSection = __webpack_require__(170);

var _CSVParametersSection2 = _interopRequireDefault(_CSVParametersSection);

var _BillingSummaryCSVPreviewTimeOnBillableTasksStrategy = __webpack_require__(2112);

var _BillingSummaryCSVPreviewTimeOnBillableTasksStrategy2 = _interopRequireDefault(_BillingSummaryCSVPreviewTimeOnBillableTasksStrategy);

var _BillingSummaryCSVPreviewTimeOnBothBillableAndNonBillableTasksStrategy = __webpack_require__(2113);

var _BillingSummaryCSVPreviewTimeOnBothBillableAndNonBillableTasksStrategy2 = _interopRequireDefault(_BillingSummaryCSVPreviewTimeOnBothBillableAndNonBillableTasksStrategy);

var _BillingSummaryCSVPreviewBillableAmountStrategy = __webpack_require__(2114);

var _BillingSummaryCSVPreviewBillableAmountStrategy2 = _interopRequireDefault(_BillingSummaryCSVPreviewBillableAmountStrategy);

var _BillingSummaryCSVPreviewBillableTimeAndBillableAmountStrategy = __webpack_require__(2115);

var _BillingSummaryCSVPreviewBillableTimeAndBillableAmountStrategy2 = _interopRequireDefault(_BillingSummaryCSVPreviewBillableTimeAndBillableAmountStrategy);

var _CSVPreviewEmptySection = __webpack_require__(324);

var _CSVPreviewEmptySection2 = _interopRequireDefault(_CSVPreviewEmptySection);

var _constants = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function BillingSummaryCSVPreviewGenerator() {}
BillingSummaryCSVPreviewGenerator.prototype.init = function () {
    return this;
};

BillingSummaryCSVPreviewGenerator.prototype.generatePreviewTable = function (reportParameters, reportParamsStringBuilder) {
    var numOfGroupingColumns = _BillingSummaryCSVPreviewUtils2.default.getNumberOfGroupingLevelsCells(reportParameters.firstGroupingLevel, reportParameters.secondGroupingLevel, reportParameters.thirdGroupingLevel);
    var numOfDataRows = 5;

    var columnsStrategy = this.createPreviewStrategy(reportParameters.reportInfo);

    var totalColumnsNum = numOfGroupingColumns + columnsStrategy.getNumOfDataColumns();
    var totalRowNum = 18;

    var billingTypesSection = new _BillingSummaryCSVPreviewBillingTypesSection2.default().init(totalColumnsNum);

    var header = new _BillingSummaryCSVPreviewHeader2.default().init(reportParameters.firstGroupingLevel, reportParameters.secondGroupingLevel, reportParameters.thirdGroupingLevel, reportParameters.reportInfo, columnsStrategy, numOfGroupingColumns);

    var dataGroupingSection = new _BillingSummaryCSVPreviewGroupingSection2.default().init(reportParameters.firstGroupingLevel, reportParameters.secondGroupingLevel, reportParameters.thirdGroupingLevel, columnsStrategy, numOfGroupingColumns, numOfDataRows, reportParameters.reportAuthorizationInfo);

    var table = document.createElement("table");
    table.className = "reportCsvPreviewTable billingSummaryCsvPreview" + (numOfGroupingColumns == 4 ? " fourGroupingLevels" : "");
    var tBody = document.createElement("tbody");
    table.appendChild(tBody);

    ReportPreviewUtils.addSheetHeaderRow(tBody, totalColumnsNum);

    var paramsBuilder = new _CSVParametersBuilder2.default().init();
    paramsBuilder.addBillingSummaryReportTypeParam(reportParameters.reportType);
    paramsBuilder.addDateRangeParam(reportParameters.dateRangeSelection, reportParamsStringBuilder);
    paramsBuilder.addCPParam(reportParameters.customersProjectsSelection, reportParamsStringBuilder);
    paramsBuilder.addBillingSummaryTasksParam(reportParameters.reportInfo);
    if (EnabledFeatures.TTA) {
        paramsBuilder.addTimeTrackStatusParam(reportParameters.timeApprovalStatus);
    }

    var parametersSection = new _CSVParametersSection2.default().init(paramsBuilder, totalColumnsNum);

    parametersSection.addRows(tBody);

    if (this.isNeedToIncludeBillingRatesSection(reportParameters.reportInfo)) {
        billingTypesSection.addRows(tBody);
        this.addSectionSeparator(tBody, totalColumnsNum);
    }

    header.addRows(tBody);
    dataGroupingSection.addRows(tBody);

    this.addEmptySectionIfNeeded(totalRowNum, tBody, totalColumnsNum);

    return table;
};

BillingSummaryCSVPreviewGenerator.prototype.createPreviewStrategy = function (reportInfo) {
    switch (reportInfo) {
        case _constants.BillingSummaryReportInfo.TIME_ON_BILLABLE_TASKS:
            return new _BillingSummaryCSVPreviewTimeOnBillableTasksStrategy2.default().init();
            break;
        case _constants.BillingSummaryReportInfo.TIME_ON_NON_BILLABLE_TASKS:
            return new _BillingSummaryCSVPreviewTimeOnNonBillableTasksStrategy2.default().init();
            break;
        case _constants.BillingSummaryReportInfo.TIME_ON_BOTH_BILLABLE_AND_NON_BILLABLE_TASKS:
            return new _BillingSummaryCSVPreviewTimeOnBothBillableAndNonBillableTasksStrategy2.default().init();
            break;
        case _constants.BillingSummaryReportInfo.BILLABLE_AMOUNT:
            return new _BillingSummaryCSVPreviewBillableAmountStrategy2.default().init();
            break;
        case _constants.BillingSummaryReportInfo.BILLABLE_TIME_AND_BILLABLE_AMOUNT:
        case _constants.BillingSummaryReportInfo.BILLABLE_TIME_AND_BILLABLE_AMOUNT_WITH_AVERAGE_RATES:
            return new _BillingSummaryCSVPreviewBillableTimeAndBillableAmountStrategy2.default().init(reportInfo == _constants.BillingSummaryReportInfo.BILLABLE_TIME_AND_BILLABLE_AMOUNT_WITH_AVERAGE_RATES);
            break;
    }
};

BillingSummaryCSVPreviewGenerator.prototype.isNeedToIncludeBillingRatesSection = function (reportInfo) {
    return reportInfo == _constants.BillingSummaryReportInfo.BILLABLE_AMOUNT || reportInfo == _constants.BillingSummaryReportInfo.BILLABLE_TIME_AND_BILLABLE_AMOUNT || reportInfo == _constants.BillingSummaryReportInfo.BILLABLE_TIME_AND_BILLABLE_AMOUNT_WITH_AVERAGE_RATES;
};

BillingSummaryCSVPreviewGenerator.prototype.addSectionSeparator = function (tBody, totalColumnsNum) {
    new _CSVPreviewEmptySection2.default().init(1, totalColumnsNum).addRows(tBody);
};

BillingSummaryCSVPreviewGenerator.prototype.addEmptySectionIfNeeded = function (totalRowsNum, tBody, totalColumnsNum) {
    var numOfEmptyRows = totalRowsNum + 1 - tBody.childNodes.length;
    if (numOfEmptyRows > 0) new _CSVPreviewEmptySection2.default().init(numOfEmptyRows, totalColumnsNum).addRows(tBody);
};

/***/ }),
/* 2108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = BillingSummaryCSVPreviewTimeOnNonBillableTasksStrategy;

var _BillingSummaryCSVPreviewColumnsStrategy = __webpack_require__(325);

var _BillingSummaryCSVPreviewColumnsStrategy2 = _interopRequireDefault(_BillingSummaryCSVPreviewColumnsStrategy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function BillingSummaryCSVPreviewTimeOnNonBillableTasksStrategy() {}

BillingSummaryCSVPreviewTimeOnNonBillableTasksStrategy.prototype = new _BillingSummaryCSVPreviewColumnsStrategy2.default();

BillingSummaryCSVPreviewTimeOnNonBillableTasksStrategy.prototype.init = function () {
    _BillingSummaryCSVPreviewColumnsStrategy2.default.prototype.init.call(this);
    return this;
};

BillingSummaryCSVPreviewTimeOnNonBillableTasksStrategy.prototype.getNumOfDataColumns = function () {
    return 4;
};

BillingSummaryCSVPreviewTimeOnNonBillableTasksStrategy.prototype.addMainHeaderRowCells = function (mainHeaderRow) {
    this.addCell(mainHeaderRow, this.message("report.billing_summary.overall_spent.only_nonbillible.csv"));

    this.addBillingTypeCells(mainHeaderRow, this.getNumOfDataColumns() - 1);
};

BillingSummaryCSVPreviewTimeOnNonBillableTasksStrategy.prototype.addColumnGropingHeaderRowCells = function (colGroupingRow) {
    // do nothing
};

/***/ }),
/* 2109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = BillingSummaryCSVPreviewBillingTypesSection;

var _CSVPreviewSection = __webpack_require__(43);

var _CSVPreviewSection2 = _interopRequireDefault(_CSVPreviewSection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function BillingSummaryCSVPreviewBillingTypesSection() {}

BillingSummaryCSVPreviewBillingTypesSection.prototype = new _CSVPreviewSection2.default();

BillingSummaryCSVPreviewBillingTypesSection.prototype.init = function (totalColumnsNum) {
    _CSVPreviewSection2.default.prototype.init.call(this);
    this.totalColumnsNum = totalColumnsNum;
    return this;
};

BillingSummaryCSVPreviewBillingTypesSection.prototype.addRows = function (tBody) {
    var headerRow = this.createRow("billingTypesSectionRow");
    var dataRow = this.createRow("billingTypesSectionRow");

    for (var i = 0; i < this.totalColumnsNum - 3; i++) {
        ReportPreviewUtils.addEmptyCell(headerRow);
        ReportPreviewUtils.addEmptyCell(dataRow);
    }
    for (i = 0; i < 3; i++) {
        ReportPreviewUtils.addCell(headerRow, this.message("report.billing_type"));
    }
    this.addCell(dataRow, this.message("report.billing_summary.rate.csv", [SystemSettings.currencySign]));

    this.addTimeValueCell(dataRow);
    this.addTimeValueCell(dataRow);

    this.addRow(tBody, headerRow);
    this.addRow(tBody, dataRow);
};

/***/ }),
/* 2110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = BillingSummaryCSVPreviewHeader;

var _CSVPreviewSection = __webpack_require__(43);

var _CSVPreviewSection2 = _interopRequireDefault(_CSVPreviewSection);

var _constants = __webpack_require__(4);

var _BillingSummaryCSVPreviewUtils = __webpack_require__(602);

var _BillingSummaryCSVPreviewUtils2 = _interopRequireDefault(_BillingSummaryCSVPreviewUtils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function BillingSummaryCSVPreviewHeader() {}
BillingSummaryCSVPreviewHeader.prototype = new _CSVPreviewSection2.default();
BillingSummaryCSVPreviewHeader.prototype.init = function (firstGroupingLevel, secondGroupingLevel, thirdGroupingLevel, reportInfo, columnsStrategy, numOfGroupingCols) {
    _CSVPreviewSection2.default.prototype.init.call(this);
    this.firstGroupingLevel = firstGroupingLevel;
    this.secondGroupingLevel = secondGroupingLevel;
    this.thirdGroupingLevel = thirdGroupingLevel;
    this.reportInfo = reportInfo;
    this.columnsStrategy = columnsStrategy;
    this.numOfGroupingCols = numOfGroupingCols;
    return this;
};

BillingSummaryCSVPreviewHeader.prototype.hasGroupingRow = function () {
    return this.reportInfo == _constants.BillingSummaryReportInfo.BILLABLE_TIME_AND_BILLABLE_AMOUNT || this.reportInfo == _constants.BillingSummaryReportInfo.BILLABLE_TIME_AND_BILLABLE_AMOUNT_WITH_AVERAGE_RATES;
};

BillingSummaryCSVPreviewHeader.prototype.addRows = function (tBody) {
    if (this.hasGroupingRow()) {
        var groupingHeaderRow = this.createRow("reportHeaderRow");
        ReportPreviewUtils.addEmptyCells(groupingHeaderRow, this.numOfGroupingCols);
        this.columnsStrategy.addColumnGropingHeaderRowCells(groupingHeaderRow);
        this.addRow(tBody, groupingHeaderRow);
    }

    var mainHeaderRow = this.createRow("reportHeaderRow");
    _BillingSummaryCSVPreviewUtils2.default.addGroupingLevelsCells(mainHeaderRow, this.firstGroupingLevel, this.secondGroupingLevel, this.thirdGroupingLevel, false);

    this.columnsStrategy.addMainHeaderRowCells(mainHeaderRow);
    this.addRow(tBody, mainHeaderRow);
};

/***/ }),
/* 2111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = BillingSummaryCSVPreviewGroupingSection;

var _CSVPreviewSection = __webpack_require__(43);

var _CSVPreviewSection2 = _interopRequireDefault(_CSVPreviewSection);

var _BillingSummaryCSVPreviewUtils = __webpack_require__(602);

var _BillingSummaryCSVPreviewUtils2 = _interopRequireDefault(_BillingSummaryCSVPreviewUtils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function BillingSummaryCSVPreviewGroupingSection() {}
BillingSummaryCSVPreviewGroupingSection.prototype = new _CSVPreviewSection2.default();
BillingSummaryCSVPreviewGroupingSection.prototype.init = function (firstGroupingLevel, secondGroupingLevel, thirdGroupingLevel, columnsStrategy, numOfGroupingColumns, numOfGroupingRows, reportAuthorizationInfo) {
    _CSVPreviewSection2.default.prototype.init.call(this);
    this.firstGroupingLevel = firstGroupingLevel;
    this.secondGroupingLevel = secondGroupingLevel;
    this.thirdGroupingLevel = thirdGroupingLevel;
    this.columnsStrategy = columnsStrategy;
    this.numOfGroupingColumns = numOfGroupingColumns;
    this.numOfGroupingRows = numOfGroupingRows;
    this.reportAuthorizationInfo = reportAuthorizationInfo;
    return this;
};

BillingSummaryCSVPreviewGroupingSection.prototype.addRows = function (tBody) {
    var emptyRow = this.createRow();

    var totalsRow = this.createRow();
    this.addCell(totalsRow, this.message("report.total"));

    for (var i = 0; i < this.numOfGroupingRows; i++) {
        var row = this.createRow();
        var needOthers = !this.reportAuthorizationInfo.allUsersAvailable && i === this.numOfGroupingRows - 1;
        _BillingSummaryCSVPreviewUtils2.default.addGroupingLevelsCells(row, this.firstGroupingLevel, this.secondGroupingLevel, this.thirdGroupingLevel, i === 0, needOthers);

        this.columnsStrategy.addDataCells(row);
        this.addRow(tBody, row);
    }

    for (var _i = 0; _i < this.numOfGroupingColumns - 1; _i++) {
        ReportPreviewUtils.addEmptyCell(emptyRow);
        ReportPreviewUtils.addEmptyCell(totalsRow);
    }

    this.columnsStrategy.addEmptyCells(emptyRow);
    ReportPreviewUtils.addEmptyCell(emptyRow);
    this.columnsStrategy.addDataCells(totalsRow);
    this.addRow(tBody, emptyRow);
    this.addRow(tBody, totalsRow);
};

/***/ }),
/* 2112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = BillingSummaryCSVPreviewTimeOnBillableTasksStrategy;

var _BillingSummaryCSVPreviewColumnsStrategy = __webpack_require__(325);

var _BillingSummaryCSVPreviewColumnsStrategy2 = _interopRequireDefault(_BillingSummaryCSVPreviewColumnsStrategy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function BillingSummaryCSVPreviewTimeOnBillableTasksStrategy() {}

BillingSummaryCSVPreviewTimeOnBillableTasksStrategy.prototype = new _BillingSummaryCSVPreviewColumnsStrategy2.default();

BillingSummaryCSVPreviewTimeOnBillableTasksStrategy.prototype.init = function () {
    _BillingSummaryCSVPreviewColumnsStrategy2.default.prototype.init.call(this);
    return this;
};

BillingSummaryCSVPreviewTimeOnBillableTasksStrategy.prototype.getNumOfDataColumns = function () {
    return 4;
};

BillingSummaryCSVPreviewTimeOnBillableTasksStrategy.prototype.addMainHeaderRowCells = function (mainHeaderRow) {
    this.addCell(mainHeaderRow, this.message("report.billing_summary.overall_spent.only_billible.csv"));

    this.addBillingTypeCells(mainHeaderRow, this.getNumOfDataColumns() - 1);
};

_BillingSummaryCSVPreviewColumnsStrategy2.default.prototype.addColumnGropingHeaderRowCells = function (colGroupingRow) {
    // do nothing
};

/***/ }),
/* 2113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = BillingSummaryCSVPreviewTimeOnBothBillableAndNonBillableTasksStrategy;

var _BillingSummaryCSVPreviewColumnsStrategy = __webpack_require__(325);

var _BillingSummaryCSVPreviewColumnsStrategy2 = _interopRequireDefault(_BillingSummaryCSVPreviewColumnsStrategy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function BillingSummaryCSVPreviewTimeOnBothBillableAndNonBillableTasksStrategy() {}

BillingSummaryCSVPreviewTimeOnBothBillableAndNonBillableTasksStrategy.prototype = new _BillingSummaryCSVPreviewColumnsStrategy2.default();

BillingSummaryCSVPreviewTimeOnBothBillableAndNonBillableTasksStrategy.prototype.init = function () {
    _BillingSummaryCSVPreviewColumnsStrategy2.default.prototype.init.call(this);
    return this;
};

BillingSummaryCSVPreviewTimeOnBothBillableAndNonBillableTasksStrategy.prototype.getNumOfDataColumns = function () {
    return 5;
};

BillingSummaryCSVPreviewTimeOnBothBillableAndNonBillableTasksStrategy.prototype.addMainHeaderRowCells = function (mainHeaderRow) {
    this.addCell(mainHeaderRow, this.message("report.billing_summary.overall_spent.csv.detailed.overall"));
    this.addCell(mainHeaderRow, this.message("report.billing_summary.overall_spent.csv.detailed.billable"));
    this.addCell(mainHeaderRow, this.message("report.billing_summary.overall_spent.csv.detailed.nonbillable"));

    this.addBillingTypeCells(mainHeaderRow, this.getNumOfDataColumns() - 3);
};

BillingSummaryCSVPreviewTimeOnBothBillableAndNonBillableTasksStrategy.prototype.addColumnGropingHeaderRowCells = function (colGroupingRow) {
    // do nothing
};

BillingSummaryCSVPreviewTimeOnBothBillableAndNonBillableTasksStrategy.prototype.addDataCells = function (row) {
    for (var i = 0; i < this.getNumOfDataColumns(); i++) {
        this.addTimeValueCell(row);
    }
};

/***/ }),
/* 2114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = BillingSummaryCSVPreviewBillableAmountStrategy;

var _BillingSummaryCSVPreviewColumnsStrategy = __webpack_require__(325);

var _BillingSummaryCSVPreviewColumnsStrategy2 = _interopRequireDefault(_BillingSummaryCSVPreviewColumnsStrategy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function BillingSummaryCSVPreviewBillableAmountStrategy() {}

BillingSummaryCSVPreviewBillableAmountStrategy.prototype = new _BillingSummaryCSVPreviewColumnsStrategy2.default();

BillingSummaryCSVPreviewBillableAmountStrategy.prototype.init = function () {
    _BillingSummaryCSVPreviewColumnsStrategy2.default.prototype.init.call(this);
    return this;
};

BillingSummaryCSVPreviewBillableAmountStrategy.prototype.getNumOfDataColumns = function () {
    return 4;
};

BillingSummaryCSVPreviewBillableAmountStrategy.prototype.addMainHeaderRowCells = function (mainHeaderRow) {
    this.addCell(mainHeaderRow, this.message("report.billing_summary.overall_amount.csv", [SystemSettings.currencySign]));

    this.addBillingTypeCells(mainHeaderRow, this.getNumOfDataColumns() - 1);
};

BillingSummaryCSVPreviewBillableAmountStrategy.prototype.addColumnGropingHeaderRowCells = function (colGroupingRow) {
    // do nothing
};

/***/ }),
/* 2115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = BillingSummaryCSVPreviewBillableTimeAndBillableAmountStrategy;

var _BillingSummaryCSVPreviewColumnsStrategy = __webpack_require__(325);

var _BillingSummaryCSVPreviewColumnsStrategy2 = _interopRequireDefault(_BillingSummaryCSVPreviewColumnsStrategy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function BillingSummaryCSVPreviewBillableTimeAndBillableAmountStrategy() {}
BillingSummaryCSVPreviewBillableTimeAndBillableAmountStrategy.prototype = new _BillingSummaryCSVPreviewColumnsStrategy2.default();
BillingSummaryCSVPreviewBillableTimeAndBillableAmountStrategy.prototype.init = function (showAverageRates) {
    _BillingSummaryCSVPreviewColumnsStrategy2.default.prototype.init.call(this);
    this.showAverageRates = showAverageRates;
    return this;
};

BillingSummaryCSVPreviewBillableTimeAndBillableAmountStrategy.prototype.getNumOfDataColumns = function () {
    return this.showAverageRates ? 5 : 4;
};

BillingSummaryCSVPreviewBillableTimeAndBillableAmountStrategy.prototype.addMainHeaderRowCells = function (mainHeaderRow) {
    this.addCell(mainHeaderRow, this.message("report.billing_summary.overall_spent.only_billible.csv"));
    if (this.showAverageRates) this.addCell(mainHeaderRow, this.message("report.billing_summary.average_rate.csv", [SystemSettings.currencySign]));
    this.addCell(mainHeaderRow, this.message("report.billing_summary.overall_amount.csv", [SystemSettings.currencySign]));
    this.addCell(mainHeaderRow, this.message("report.billing_summary.spent"));
    this.addCell(mainHeaderRow, this.message("report.billing_summary.amount"));
};

BillingSummaryCSVPreviewBillableTimeAndBillableAmountStrategy.prototype.addColumnGropingHeaderRowCells = function (colGroupingRow) {
    var numOfEmptyCells = this.showAverageRates ? 3 : 2;
    ReportPreviewUtils.addEmptyCells(colGroupingRow, numOfEmptyCells);
    this.addBillingTypeCells(colGroupingRow, this.getNumOfDataColumns() - numOfEmptyCells);
};

/***/ }),
/* 2116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _constants = __webpack_require__(4);

var _constants2 = __webpack_require__(11);

var _BillingSummaryReportEditConfigController = __webpack_require__(999);

var _BillingSummaryReportEditConfigController2 = _interopRequireDefault(_BillingSummaryReportEditConfigController);

var _displayed_data_radiogroup_controls_bs_report = __webpack_require__(603);

var _displayed_data_radiogroup_controls_bs_report2 = _interopRequireDefault(_displayed_data_radiogroup_controls_bs_report);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BillingSummaryReportEditFormConfigController = function (_BillingSummaryReport) {
    _inherits(BillingSummaryReportEditFormConfigController, _BillingSummaryReport);

    function BillingSummaryReportEditFormConfigController() {
        _classCallCheck(this, BillingSummaryReportEditFormConfigController);

        return _possibleConstructorReturn(this, (BillingSummaryReportEditFormConfigController.__proto__ || Object.getPrototypeOf(BillingSummaryReportEditFormConfigController)).apply(this, arguments));
    }

    return BillingSummaryReportEditFormConfigController;
}(_BillingSummaryReportEditConfigController2.default);

exports.default = BillingSummaryReportEditFormConfigController;


BillingSummaryReportEditFormConfigController.prototype.makeReportParamsAccordingToFeatures = function (reportParameters) {
    var result = _jquery2.default.extend({}, reportParameters);

    if (!EnabledFeatures.BRA && _displayed_data_radiogroup_controls_bs_report2.default.prototype.isBillingTimeSelectorOption(reportParameters.reportInfo)) result.reportInfo = _constants.BillingSummaryReportInfo.TIME_ON_BILLABLE_TASKS;

    if (!EnabledFeatures.UGR) {
        var groupings = this.makeGroupingSelectorValuesAccordingToNotAvailableValueLevel(_constants2.ReportGroupingLevel.USER_GROUP, [result.firstGroupingLevel, result.secondGroupingLevel], _constants2.ReportGroupingLevel.USER);
        result.firstGroupingLevel = groupings[0];
        result.secondGroupingLevel = groupings[1];
    }
    if (!EnabledFeatures.TTA) {
        result.timeApprovalStatus = _constants.TimeApprovalStatus.BOTH;
    }

    return result;
};

/***/ }),
/* 2117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = BillingSummaryHTMLPreviewGenerator;

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _constants = __webpack_require__(4);

var _constants2 = __webpack_require__(11);

var _BSHtmlAllTasksStrategy = __webpack_require__(2118);

var _BSHtmlAllTasksStrategy2 = _interopRequireDefault(_BSHtmlAllTasksStrategy);

var _BSHtmlBillableBTTimeStrategy = __webpack_require__(2119);

var _BSHtmlBillableBTTimeStrategy2 = _interopRequireDefault(_BSHtmlBillableBTTimeStrategy);

var _BSHtmlNonBillableBTStrategy = __webpack_require__(2120);

var _BSHtmlNonBillableBTStrategy2 = _interopRequireDefault(_BSHtmlNonBillableBTStrategy);

var _BSHtmlBillableBTMoneyStrategy = __webpack_require__(2121);

var _BSHtmlBillableBTMoneyStrategy2 = _interopRequireDefault(_BSHtmlBillableBTMoneyStrategy);

var _BSHtmlBTWithAmountStrategy = __webpack_require__(2122);

var _BSHtmlBTWithAmountStrategy2 = _interopRequireDefault(_BSHtmlBTWithAmountStrategy);

var _BSHtmlBillableTasksStrategy = __webpack_require__(2123);

var _BSHtmlBillableTasksStrategy2 = _interopRequireDefault(_BSHtmlBillableTasksStrategy);

var _BSHtmlNonBillableTasksStrategy = __webpack_require__(2124);

var _BSHtmlNonBillableTasksStrategy2 = _interopRequireDefault(_BSHtmlNonBillableTasksStrategy);

var _BSHtmlAvrgRatesStrategy = __webpack_require__(2125);

var _BSHtmlAvrgRatesStrategy2 = _interopRequireDefault(_BSHtmlAvrgRatesStrategy);

var _BSHtmlBillableAmountStrategy = __webpack_require__(2126);

var _BSHtmlBillableAmountStrategy2 = _interopRequireDefault(_BSHtmlBillableAmountStrategy);

var _BSHtmlBillableTimeAndAmountStrategy = __webpack_require__(2127);

var _BSHtmlBillableTimeAndAmountStrategy2 = _interopRequireDefault(_BSHtmlBillableTimeAndAmountStrategy);

var _BSHtmlNullTasksStrategy = __webpack_require__(2128);

var _BSHtmlNullTasksStrategy2 = _interopRequireDefault(_BSHtmlNullTasksStrategy);

var _HTMLCompositeColumnsStrategy = __webpack_require__(2129);

var _HTMLCompositeColumnsStrategy2 = _interopRequireDefault(_HTMLCompositeColumnsStrategy);

var _BillingSummaryHTMLPreviewHeaderSection = __webpack_require__(2130);

var _BillingSummaryHTMLPreviewHeaderSection2 = _interopRequireDefault(_BillingSummaryHTMLPreviewHeaderSection);

var _BillingSummaryHTMLPreviewGroupingSection = __webpack_require__(2131);

var _BillingSummaryHTMLPreviewGroupingSection2 = _interopRequireDefault(_BillingSummaryHTMLPreviewGroupingSection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function BillingSummaryHTMLPreviewGenerator() {}

BillingSummaryHTMLPreviewGenerator.prototype.init = function () {
    return this;
};

BillingSummaryHTMLPreviewGenerator.prototype.generatePreviewTable = function (reportParameters) {
    var table = document.createElement("table");
    table.className = "reportHtmlPreviewTable billingSummary";
    var tBody = document.createElement("tbody");
    table.appendChild(tBody);

    var groupingLevelsArray = [reportParameters.firstGroupingLevel, reportParameters.secondGroupingLevel, reportParameters.thirdGroupingLevel];

    var filteredLevelsArray = ReportPreviewUtils.filterNotEmptyLevels(groupingLevelsArray);
    var reportInfo = reportParameters.reportInfo;
    var timeFormat = reportParameters.timeFormat;

    var columnsStrategy = this.createColumnsStrategy(reportInfo, timeFormat);

    var headerSection = new _BillingSummaryHTMLPreviewHeaderSection2.default().init(filteredLevelsArray, columnsStrategy);
    var groupingSection = new _BillingSummaryHTMLPreviewGroupingSection2.default().init(filteredLevelsArray, reportParameters.thirdGroupingLevel !== _constants2.ReportGroupingLevel.NONE, columnsStrategy, reportParameters.timeFormat, reportParameters.reportAuthorizationInfo);

    if (reportInfo == _constants.BillingSummaryReportInfo.TIME_ON_BOTH_BILLABLE_AND_NON_BILLABLE_TASKS || reportInfo == _constants.BillingSummaryReportInfo.BILLABLE_TIME_AND_BILLABLE_AMOUNT_WITH_AVERAGE_RATES) (0, _jquery2.default)(tBody).addClass("narrow");

    headerSection.addRows(tBody);
    groupingSection.addRows(tBody);

    return table;
};

BillingSummaryHTMLPreviewGenerator.prototype.createColumnsStrategy = function (reportInfo, timeformat) {
    var columns, firstBT, secondBT;
    switch (reportInfo) {
        case _constants.BillingSummaryReportInfo.TIME_ON_BILLABLE_TASKS:
            firstBT = new _BSHtmlBillableBTTimeStrategy2.default().init(timeformat);
            columns = [new _BSHtmlBillableTasksStrategy2.default().init(timeformat), firstBT, firstBT];
            break;

        case _constants.BillingSummaryReportInfo.TIME_ON_NON_BILLABLE_TASKS:
            firstBT = new _BSHtmlNonBillableBTStrategy2.default().init(timeformat);
            columns = [new _BSHtmlNonBillableTasksStrategy2.default().init(timeformat), firstBT, firstBT];
            break;

        case _constants.BillingSummaryReportInfo.TIME_ON_BOTH_BILLABLE_AND_NON_BILLABLE_TASKS:
            firstBT = new _BSHtmlBillableBTTimeStrategy2.default().init(timeformat);
            secondBT = new _BSHtmlNonBillableBTStrategy2.default().init(timeformat);
            columns = [new _BSHtmlAllTasksStrategy2.default().init(timeformat), firstBT, secondBT];
            break;

        case _constants.BillingSummaryReportInfo.BILLABLE_AMOUNT:
            firstBT = new _BSHtmlBillableBTMoneyStrategy2.default().init(timeformat);
            columns = [new _BSHtmlBillableAmountStrategy2.default().init(timeformat), firstBT, firstBT];
            break;

        case _constants.BillingSummaryReportInfo.BILLABLE_TIME_AND_BILLABLE_AMOUNT:
            firstBT = new _BSHtmlBTWithAmountStrategy2.default().init(timeformat);
            columns = [new _BSHtmlBillableTasksStrategy2.default().init(timeformat), new _BSHtmlBillableTimeAndAmountStrategy2.default().init(timeformat), firstBT, firstBT];
            break;

        case _constants.BillingSummaryReportInfo.BILLABLE_TIME_AND_BILLABLE_AMOUNT_WITH_AVERAGE_RATES:
            firstBT = new _BSHtmlBTWithAmountStrategy2.default().init(timeformat);
            columns = [new _BSHtmlBillableTasksStrategy2.default().init(timeformat), new _BSHtmlAvrgRatesStrategy2.default().init(timeformat), new _BSHtmlBillableTimeAndAmountStrategy2.default().init(timeformat), firstBT, firstBT];
            break;

        default:
            return new _BSHtmlNullTasksStrategy2.default().init(timeformat);
    }

    return new _HTMLCompositeColumnsStrategy2.default().init(columns); //[timeStrategy, moneyStrategy, btStrategy]
};

/***/ }),
/* 2118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = BSHtmlAllTasksStrategy;

var _BaseHTMLColumnStrategy = __webpack_require__(215);

var _BaseHTMLColumnStrategy2 = _interopRequireDefault(_BaseHTMLColumnStrategy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function BSHtmlAllTasksStrategy() {}

BSHtmlAllTasksStrategy.prototype = new _BaseHTMLColumnStrategy2.default();

BSHtmlAllTasksStrategy.prototype.getLevelsNumber = function () {
    return 2;
};

BSHtmlAllTasksStrategy.prototype.addFirstHeaderRowCells = function (row /*, levelsNumber*/) {
    this.addCell(row, this.message("report.billing_summary.overall_spent.detailed.superheader"), "totalForAll", 3, 1);
};

BSHtmlAllTasksStrategy.prototype.addSecondHeaderRowCells = function (row, levelsNumber) {
    var rowSpan = levelsNumber - 1;
    this.addCell(row, this.message("report.billing_summary.overall_spent.detailed.overall"), "subTotalSpent overall", 1, rowSpan);
    this.addCell(row, this.message("report.billing_summary.overall_spent.detailed.billable"), "subTotalSpent billable", 1, rowSpan);
    this.addCell(row, this.message("report.billing_summary.overall_spent.detailed.nonbillable"), "subTotalSpent nonBillable", 1, rowSpan);
};

BSHtmlAllTasksStrategy.prototype.addColumnValueCells = function (row) {
    this.addTimeValueCell(row);
    this.addTimeValueCell(row);
    this.addTimeValueCell(row);
};

/***/ }),
/* 2119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = BSHtmlBillableBTTimeStrategy;

var _BSHtmlBaseBTStrategy = __webpack_require__(416);

var _BSHtmlBaseBTStrategy2 = _interopRequireDefault(_BSHtmlBaseBTStrategy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function BSHtmlBillableBTTimeStrategy() {}

BSHtmlBillableBTTimeStrategy.prototype = new _BSHtmlBaseBTStrategy2.default();

BSHtmlBillableBTTimeStrategy.prototype.addFirstHeaderRowCells = function (row, levelsNumber) {
    this.addCreatedCell(row, this.createBillableCell(levelsNumber, "timeType"));
};

BSHtmlBillableBTTimeStrategy.prototype.addColumnValueCells = function (row) {
    this.addTimeColumnValueCells(row);
};

/***/ }),
/* 2120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = BSHtmlNonBillableBTStrategy;

var _BSHtmlBaseBTStrategy = __webpack_require__(416);

var _BSHtmlBaseBTStrategy2 = _interopRequireDefault(_BSHtmlBaseBTStrategy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function BSHtmlNonBillableBTStrategy() {}

BSHtmlNonBillableBTStrategy.prototype = new _BSHtmlBaseBTStrategy2.default();

BSHtmlNonBillableBTStrategy.prototype.addFirstHeaderRowCells = function (row, levelsNumber) {
    this.addCreatedCell(row, this.createNonBillableCell(levelsNumber));
};

BSHtmlNonBillableBTStrategy.prototype.addColumnValueCells = function (row) {
    this.addTimeColumnValueCells(row);
};

/***/ }),
/* 2121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = BSHtmlBillableBTMoneyStrategy;

var _BSHtmlBaseBTStrategy = __webpack_require__(416);

var _BSHtmlBaseBTStrategy2 = _interopRequireDefault(_BSHtmlBaseBTStrategy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function BSHtmlBillableBTMoneyStrategy() {}

BSHtmlBillableBTMoneyStrategy.prototype = new _BSHtmlBaseBTStrategy2.default();

BSHtmlBillableBTMoneyStrategy.prototype.addFirstHeaderRowCells = function (row, levelsNumber) {
    this.addCreatedCell(row, this.createBillableCell(levelsNumber, "moneyType"));
};

BSHtmlBillableBTMoneyStrategy.prototype.addColumnValueCells = function (row) {
    this.addMoneyColumnValueCells(row);
};

/***/ }),
/* 2122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = BSHtmlBTWithAmountStrategy;

var _BSHtmlBaseBTStrategy = __webpack_require__(416);

var _BSHtmlBaseBTStrategy2 = _interopRequireDefault(_BSHtmlBaseBTStrategy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function BSHtmlBTWithAmountStrategy() {}

BSHtmlBTWithAmountStrategy.prototype = new _BSHtmlBaseBTStrategy2.default();

BSHtmlBTWithAmountStrategy.prototype.addFirstHeaderRowCells = function (row /*, levelsNumber*/) {
    this.addCreatedCell(row, this.createBillableCell(1, "moneyType"));
};

BSHtmlBTWithAmountStrategy.prototype.getLevelsNumber = function () {
    return 2;
};

BSHtmlBTWithAmountStrategy.prototype.getColspan = function () {
    return 2;
};

BSHtmlBTWithAmountStrategy.prototype.createSpentCell = function (row, rowSpan) {
    return ReportPreviewUtils.createCell(this.message("report.billing_summary.spent"), "spentTime", 1, rowSpan);
};

BSHtmlBTWithAmountStrategy.prototype.createAmountCell = function (row, rowSpan) {
    return ReportPreviewUtils.createCell(this.message("report.billing_summary.amount"), "subAmount", 1, rowSpan);
};

BSHtmlBTWithAmountStrategy.prototype.addSecondHeaderRowCells = function (row, levelsNumber) {
    var rowSpan = levelsNumber - 1;

    this.addCreatedCell(row, this.createSpentCell(rowSpan));
    this.addCreatedCell(row, this.createAmountCell(rowSpan));
};

BSHtmlBTWithAmountStrategy.prototype.addColumnValueCells = function (row) {
    this.addTimeValueCell(row);
    this.addMoneyValueCell(row, "darkMoneyValueCell");
};

/***/ }),
/* 2123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = BSHtmlBillableTasksStrategy;

var _BaseHTMLColumnStrategy = __webpack_require__(215);

var _BaseHTMLColumnStrategy2 = _interopRequireDefault(_BaseHTMLColumnStrategy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function BSHtmlBillableTasksStrategy() {}

BSHtmlBillableTasksStrategy.prototype = new _BaseHTMLColumnStrategy2.default();

BSHtmlBillableTasksStrategy.prototype.getLevelsNumber = function () {
    return 1;
};

BSHtmlBillableTasksStrategy.prototype.addFirstHeaderRowCells = function (row, levelsNumber) {
    this.addCell(row, this.message("report.billing_summary.overall_spent.only_billible.html"), "totalBillable", 1, levelsNumber);
};

BSHtmlBillableTasksStrategy.prototype.addSecondHeaderRowCells = function (row, levelsNumber) {
    // do nothing
};

BSHtmlBillableTasksStrategy.prototype.addColumnValueCells = function (row) {
    this.addTimeValueCell(row);
};

/***/ }),
/* 2124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = BSHtmlNonBillableTasksStrategy;

var _BaseHTMLColumnStrategy = __webpack_require__(215);

var _BaseHTMLColumnStrategy2 = _interopRequireDefault(_BaseHTMLColumnStrategy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function BSHtmlNonBillableTasksStrategy() {}

BSHtmlNonBillableTasksStrategy.prototype = new _BaseHTMLColumnStrategy2.default();

BSHtmlNonBillableTasksStrategy.prototype.getLevelsNumber = function () {
    return 1;
};

BSHtmlNonBillableTasksStrategy.prototype.addFirstHeaderRowCells = function (row, levelsNumber) {
    this.addCell(row, this.message("report.billing_summary.overall_spent.non_billible.html"), "totalNonBillable", 1, levelsNumber);
};

BSHtmlNonBillableTasksStrategy.prototype.addSecondHeaderRowCells = function (row, levelsNumber) {
    // do nothing
};

BSHtmlNonBillableTasksStrategy.prototype.addColumnValueCells = function (row) {
    this.addTimeValueCell(row);
};

/***/ }),
/* 2125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = BSHtmlAvrgRatesStrategy;

var _BSHtmlBaseBillableStrategy = __webpack_require__(604);

var _BSHtmlBaseBillableStrategy2 = _interopRequireDefault(_BSHtmlBaseBillableStrategy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function BSHtmlAvrgRatesStrategy() {}

BSHtmlAvrgRatesStrategy.prototype = new _BSHtmlBaseBillableStrategy2.default();

BSHtmlAvrgRatesStrategy.prototype.addFirstHeaderRowCells = function (row, levelsNumber) {
    this.addCell(row, this.message("report.billing_summary.average_rate.html", [SystemSettings.currencySign]), "averageRate", 1, levelsNumber);
};

BSHtmlAvrgRatesStrategy.prototype.addColumnValueCells = function (row) {
    this.addMoneyValueCell(row);
};

/***/ }),
/* 2126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = BSHtmlBillableAmountStrategy;

var _BSHtmlBaseBillableStrategy = __webpack_require__(604);

var _BSHtmlBaseBillableStrategy2 = _interopRequireDefault(_BSHtmlBaseBillableStrategy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function BSHtmlBillableAmountStrategy() {}

BSHtmlBillableAmountStrategy.prototype = new _BSHtmlBaseBillableStrategy2.default();

BSHtmlBillableAmountStrategy.prototype.addFirstHeaderRowCells = function (row, levelsNumber) {
    this.addCell(row, this.message("report.billing_summary.overall_amount.html", [SystemSettings.currencySign]), "billableAmount", 1, levelsNumber);
};

BSHtmlBillableAmountStrategy.prototype.addColumnValueCells = function (row) {
    this.addMoneyValueCell(row);
};

/***/ }),
/* 2127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = BSHtmlBillableTimeAndAmountStrategy;

var _BSHtmlBaseBillableStrategy = __webpack_require__(604);

var _BSHtmlBaseBillableStrategy2 = _interopRequireDefault(_BSHtmlBaseBillableStrategy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function BSHtmlBillableTimeAndAmountStrategy() {}

BSHtmlBillableTimeAndAmountStrategy.prototype = new _BSHtmlBaseBillableStrategy2.default();

BSHtmlBillableTimeAndAmountStrategy.prototype.addFirstHeaderRowCells = function (row, levelsNumber) {
    this.addCell(row, this.message("report.billing_summary.overall_amount.html", [SystemSettings.currencySign]), "billableAmount", 1, levelsNumber);
};

BSHtmlBillableTimeAndAmountStrategy.prototype.addColumnValueCells = function (row) {
    this.addMoneyValueCell(row, "darkMoneyValueCell");
};

/***/ }),
/* 2128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = BSHtmlNullTasksStrategy;

var _BaseHTMLColumnStrategy = __webpack_require__(215);

var _BaseHTMLColumnStrategy2 = _interopRequireDefault(_BaseHTMLColumnStrategy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function BSHtmlNullTasksStrategy() {}

BSHtmlNullTasksStrategy.prototype = new _BaseHTMLColumnStrategy2.default();

BSHtmlNullTasksStrategy.prototype.getLevelsNumber = function () {
    return 0;
};

BSHtmlNullTasksStrategy.prototype.addFirstHeaderRowCells = function (row, levelsNumber) {
    // do nothing
};

BSHtmlNullTasksStrategy.prototype.addSecondHeaderRowCells = function (row, levelsNumber) {
    // do nothing
};

BSHtmlNullTasksStrategy.prototype.addColumnValueCells = function (row) {
    // do nothing
};

/***/ }),
/* 2129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = HTMLCompositeColumnsStrategy;

var _BaseHTMLColumnStrategy = __webpack_require__(215);

var _BaseHTMLColumnStrategy2 = _interopRequireDefault(_BaseHTMLColumnStrategy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function HTMLCompositeColumnsStrategy() {}

HTMLCompositeColumnsStrategy.prototype = new _BaseHTMLColumnStrategy2.default();

HTMLCompositeColumnsStrategy.prototype.init = function (strategies) {
    this.strategies = strategies;
    this.strategiesNumber = strategies.length;

    this.levelsNumber = 1;
    for (var i = 0; i < this.strategiesNumber; ++i) {
        this.levelsNumber = Math.max(this.levelsNumber, this.strategies[i].getLevelsNumber());
    }return this;
};

HTMLCompositeColumnsStrategy.prototype.getLevelsNumber = function () {
    return this.levelsNumber;
};

HTMLCompositeColumnsStrategy.prototype.addFirstHeaderRowCells = function (row, levelsNumber) {
    for (var i = 0; i < this.strategiesNumber; ++i) {
        this.strategies[i].addFirstHeaderRowCells(row, levelsNumber);
    }
};

HTMLCompositeColumnsStrategy.prototype.addSecondHeaderRowCells = function (row, levelsNumber) {
    for (var i = 0; i < this.strategiesNumber; ++i) {
        this.strategies[i].addSecondHeaderRowCells(row, levelsNumber);
    }
};

HTMLCompositeColumnsStrategy.prototype.addColumnValueCells = function (row) {
    for (var i = 0; i < this.strategiesNumber; ++i) {
        this.strategies[i].addColumnValueCells(row);
    }
};

/***/ }),
/* 2130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = BillingSummaryHTMLPreviewHeaderSection;

var _PreviewSection = __webpack_require__(67);

var _PreviewSection2 = _interopRequireDefault(_PreviewSection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function BillingSummaryHTMLPreviewHeaderSection() {}

BillingSummaryHTMLPreviewHeaderSection.prototype = new _PreviewSection2.default();

BillingSummaryHTMLPreviewHeaderSection.prototype.init = function (groupingLevelsArray, columnsStrategy) {
    _PreviewSection2.default.prototype.init.call(this);
    this.groupingLevelsArray = groupingLevelsArray;
    this.columnsStrategy = columnsStrategy;

    return this;
};

BillingSummaryHTMLPreviewHeaderSection.prototype.addRows = function (tBody) {
    var levelsNumber = this.columnsStrategy.getLevelsNumber();

    var row1 = this.createRow("headerRow firstHeaderRow");
    this.addCell(row1, ReportPreviewUtils.makeGroupingHeader(this.groupingLevelsArray), "groupingLevelsTitle", 1, levelsNumber);
    this.columnsStrategy.addFirstHeaderRowCells(row1, levelsNumber);
    this.addRow(tBody, row1);

    if (levelsNumber > 1) {
        var row2 = this.createRow("headerRow secondHeaderRow");
        this.columnsStrategy.addSecondHeaderRowCells(row2, levelsNumber);
        this.addRow(tBody, row2);
    }
};

/***/ }),
/* 2131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = BillingSummaryHTMLPreviewGroupingSection;

var _PreviewSection = __webpack_require__(67);

var _PreviewSection2 = _interopRequireDefault(_PreviewSection);

var _atUtils = __webpack_require__(5);

var _constants = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function BillingSummaryHTMLPreviewGroupingSection() {}

BillingSummaryHTMLPreviewGroupingSection.prototype = new _PreviewSection2.default();

BillingSummaryHTMLPreviewGroupingSection.prototype.init = function (groupingLevelsArray, hasNonGroupingLevel, columnsStrategy, timeFormat, reportAuthorizationInfo) {
    _PreviewSection2.default.prototype.init.call(this);
    this.groupingLevelsArray = groupingLevelsArray;
    this.columnsStrategy = columnsStrategy;
    this.timeFormat = timeFormat;
    this.hasNonGroupingLevel = hasNonGroupingLevel;
    this.allUsersAvailable = reportAuthorizationInfo.allUsersAvailable;
    this.othersStarted = false;

    return this;
};

BillingSummaryHTMLPreviewGroupingSection.prototype.levelClasses = ["firstLevel", "secondLevel", "thirdLevel"];
BillingSummaryHTMLPreviewGroupingSection.prototype.groupingClasses = ["firstGrouping", "secondGrouping", "thirdGrouping"];

BillingSummaryHTMLPreviewGroupingSection.prototype.addRows = function (tBody) {
    this.addRowWithMainCell(tBody, this.message("report.billing_summary.total_sc"), "", "totalValue");

    var length = this.groupingLevelsArray.length;
    var levels = void 0;
    if (length === 1) levels = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, this._getLastLevelNumber(0)];

    if (length === 2) {
        if (ReportPreviewUtils.isLevelCanBeAddedMoreThanOnce(this.groupingLevelsArray[1], [this.groupingLevelsArray[0]])) levels = [0, 1, 1, this._getLastLevelNumber(1), 0, 1, 1, this._getLastLevelNumber(1), this._getLastLevelNumber(0), 1, 1, this._getLastLevelNumber(1)];else levels = [0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1];
    }

    if (length > 2) {
        if (ReportPreviewUtils.isLevelCanBeAddedMoreThanOnce(this.groupingLevelsArray[2], this.groupingLevelsArray.slice(0, 2)) && ReportPreviewUtils.isLevelCanBeAddedMoreThanOnce(this.groupingLevelsArray[1], [this.groupingLevelsArray[0]])) levels = [0, 1, 2, 2, this._getLastLevelNumber(1), 2, 2, this._getLastLevelNumber(0), 1, 2, 2];else levels = [0, 1, 2, 0, 1, 2, 0, 1, 2, 0, 1, 2];
    }

    for (var i = 0; i < levels.length; ++i) {
        this.addGroupingRow(tBody, levels[i]);
    }
};

BillingSummaryHTMLPreviewGroupingSection.prototype._getLastLevelNumber = function (defaultNumber) {
    if (this.groupingLevelsArray[defaultNumber] === _constants.ReportGroupingLevel.USER && !this.allUsersAvailable) return 3;
    return defaultNumber;
};

BillingSummaryHTMLPreviewGroupingSection.prototype.addRowWithMainCell = function (tBody, escapedText, rowClassName, className) {
    var row = this.createRow(rowClassName);
    row.appendChild(ReportPreviewUtils.createCell(escapedText, className));
    this.addDataCells(row);
    this.addRow(tBody, row);
};

BillingSummaryHTMLPreviewGroupingSection.prototype.addDataCells = function (row) {
    this.columnsStrategy.addColumnValueCells(row);
};

BillingSummaryHTMLPreviewGroupingSection.prototype.addGroupingRow = function (tBody, index) {
    var levelName = void 0;
    if (index === 3) {
        levelName = this.message("report.common.others");
        index = this.groupingLevelsArray.indexOf(_constants.ReportGroupingLevel.USER);
        this.othersStarted = true;
    } else {
        if (index === 0) this.othersStarted = false;
        levelName = this._getLevelPreviewName(this.groupingLevelsArray[index]);
    }

    var grIndex = index === this.groupingLevelsArray.length - 1 && this.hasNonGroupingLevel ? 2 : index;

    !!levelName && this.addRowWithMainCell(tBody, levelName, this.groupingClasses[grIndex], this.levelClasses[index]);
};

// returns escaped level preview name
BillingSummaryHTMLPreviewGroupingSection.prototype._getLevelPreviewName = function (groupingType) {
    switch (groupingType) {
        case _constants.ReportGroupingLevel.TT_COMMENTS:
            return this._getCommentsCombinedLevelPreviewName();
        case _constants.ReportGroupingLevel.TASK_AND_TT_COMMENTS:
            return this._getCommentsCombinedLevelPreviewName(_constants.ReportGroupingLevel.TASK);
        case _constants.ReportGroupingLevel.PROJECT_AND_TT_COMMENTS:
            return this._getCommentsCombinedLevelPreviewName(_constants.ReportGroupingLevel.PROJECT);
        case _constants.ReportGroupingLevel.CUSTOMER_AND_TT_COMMENTS:
            return this._getCommentsCombinedLevelPreviewName(_constants.ReportGroupingLevel.CUSTOMER);

        default:
            return (0, _atUtils.escapeHtmlSymbols)(ReportPreviewUtils.getLevelPreviewName(groupingType));
    }
};

BillingSummaryHTMLPreviewGroupingSection.prototype._getCommentsCombinedLevelPreviewName = function (firstPartGroupingType) {
    var firstPart = firstPartGroupingType ? (0, _atUtils.escapeHtmlSymbols)(ReportPreviewUtils.getLevelPreviewName(firstPartGroupingType)) : "";

    if (this.othersStarted) {
        return firstPart;
    } else {
        if (!!firstPart) firstPart += ": ";
        return firstPart + "<i>" + ReportPreviewUtils.getLevelPreviewName(_constants.ReportGroupingLevel.TT_COMMENTS) + "</i>";
    }
};

/***/ }),
/* 2132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = BillingSummaryReportMediator;

var _BillingSummaryReportEditResultConfigController = __webpack_require__(2133);

var _BillingSummaryReportEditResultConfigController2 = _interopRequireDefault(_BillingSummaryReportEditResultConfigController);

var _constants = __webpack_require__(11);

var _OldReportMediator = __webpack_require__(268);

var _OldReportMediator2 = _interopRequireDefault(_OldReportMediator);

var _ReportPrintableHeadersBuilder = __webpack_require__(171);

var _ReportPrintableHeadersBuilder2 = _interopRequireDefault(_ReportPrintableHeadersBuilder);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function BillingSummaryReportMediator() {
    this.constructor = BillingSummaryReportMediator;
}

BillingSummaryReportMediator.prototype = new _OldReportMediator2.default();

BillingSummaryReportMediator.prototype.init = function (config) {
    _OldReportMediator2.default.prototype.init.call(this, config);

    return this;
};

BillingSummaryReportMediator.prototype.getReportType = function () {
    return _constants.ReportType.BILLING_SUMMARY;
};

BillingSummaryReportMediator.prototype.initEditConfigController = function (config) {
    var self = this;
    return new _BillingSummaryReportEditResultConfigController2.default().init({
        reportParameters: config.reportParameters,
        cpList: config.cpList,
        customersWithMaIds: config.customersWithMaIds,
        projectsWithMaIds: config.projectsWithMaIds,
        changeCallback: function changeCallback() {
            self.changeParametersCallback();
        }
    });
};

BillingSummaryReportMediator.prototype._populateHeadersArray = function (headersArray) {
    this.printableHeadersBuilder.addBillableReportTypeParamsStringToArray(this.reportParameters.reportType, headersArray); //report type
    this.printableHeadersBuilder.addCPSelectionParamsStringToArray(this.reportParameters.customersProjectsSelection, headersArray); //customers and projects
    this.printableHeadersBuilder.addBillableTaskSelectionParamsStringToArray(this.reportParameters.reportInfo, headersArray); //tasks
    this.printableHeadersBuilder.addTimeApprovalStatusToArray(this.reportParameters.timeApprovalStatus, headersArray); //time approval status
};

BillingSummaryReportMediator.prototype.initPrintableHeadersBuilder = function (config) {
    return new _ReportPrintableHeadersBuilder2.default().init({
        reportParameters: config.reportParameters,
        cpList: config.cpList,
        isFilteredByAssignments: config.isFilteredByAssignments
    });
};

/***/ }),
/* 2133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _BillingSummaryReportEditConfigController = __webpack_require__(999);

var _BillingSummaryReportEditConfigController2 = _interopRequireDefault(_BillingSummaryReportEditConfigController);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BillingSummaryReportEditResultConfigController = function (_BillingSummaryReport) {
    _inherits(BillingSummaryReportEditResultConfigController, _BillingSummaryReport);

    function BillingSummaryReportEditResultConfigController() {
        _classCallCheck(this, BillingSummaryReportEditResultConfigController);

        return _possibleConstructorReturn(this, (BillingSummaryReportEditResultConfigController.__proto__ || Object.getPrototypeOf(BillingSummaryReportEditResultConfigController)).apply(this, arguments));
    }

    return BillingSummaryReportEditResultConfigController;
}(_BillingSummaryReportEditConfigController2.default);

exports.default = BillingSummaryReportEditResultConfigController;


BillingSummaryReportEditResultConfigController.prototype.makeReportParamsAccordingToFeatures = function (reportParameters) {
    return reportParameters;
};

/***/ }),
/* 2134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = InvoiceFormMediator;

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _InvoicePreviewRenderer = __webpack_require__(2135);

var _InvoicePreviewRenderer2 = _interopRequireDefault(_InvoicePreviewRenderer);

var _OldBaseFormMediator = __webpack_require__(271);

var _OldBaseFormMediator2 = _interopRequireDefault(_OldBaseFormMediator);

var _InvoiceEditFormConfigController = __webpack_require__(2136);

var _InvoiceEditFormConfigController2 = _interopRequireDefault(_InvoiceEditFormConfigController);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @author filatov
 */
function InvoiceFormMediator() {}

InvoiceFormMediator.prototype = new _OldBaseFormMediator2.default();

InvoiceFormMediator.prototype.init = function (config) {
    _OldBaseFormMediator2.default.prototype.init.call(this, config);
    return this;
};

InvoiceFormMediator.prototype.initEditConfigController = function (config) {
    var _this = this;

    return new _InvoiceEditFormConfigController2.default().init({
        panelId: "mainContainer",
        reportParameters: config.reportParameters,
        reportAuthorizationInfo: config.reportAuthorizationInfo,
        cpList: config.cpList,
        customersWithMaIds: config.customersWithMaIds,
        projectsWithMaIds: config.projectsWithMaIds,
        changeCallback: function changeCallback() {
            return _this.changeParametersCallback();
        }
    });
};

InvoiceFormMediator.prototype.initPreviewGeneratorsAndGeneratePreview = function () {
    this.invoicePreviewRenderer = new _InvoicePreviewRenderer2.default().init();
    this.updatePreview();
};

InvoiceFormMediator.prototype.initButtons = function () {
    var _this2 = this;

    (0, _jquery2.default)("#applyReportConfiguration").click(function () {
        return _this2.onApply();
    });
    (0, _jquery2.default)("#cancelReportConfiguration").click(function () {
        return _this2.onCancel();
    });
};

InvoiceFormMediator.prototype.generatePreviewFnc = function (reportParameters) {
    this.invoicePreviewRenderer.updateGrouping(reportParameters);
};

/***/ }),
/* 2135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = InvoicePreviewRenderer;

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _constants = __webpack_require__(11);

var _atUtils = __webpack_require__(5);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Created by filatov on 08.09.2015.
 */
function InvoicePreviewRenderer() {}

InvoicePreviewRenderer.prototype.init = function () {
    this.itemsTable = (0, _jquery2.default)("#itemsTable");
    return this;
};

InvoicePreviewRenderer.prototype.updateGrouping = function (reportParameters) {

    this.itemsTable.find("tbody.itemsBody").empty();
    var levels = [];
    if (reportParameters.firstGroupingLevel !== _constants.ReportGroupingLevel.NONE) {
        levels.push(reportParameters.firstGroupingLevel);
    }
    if (reportParameters.secondGroupingLevel !== _constants.ReportGroupingLevel.NONE) {
        levels.push(reportParameters.secondGroupingLevel);
    }
    if (reportParameters.thirdGroupingLevel !== _constants.ReportGroupingLevel.NONE) {
        this._addLevelsDependsFromThirdLevel(levels, reportParameters.thirdGroupingLevel);
    }

    var allUsersAvailable = reportParameters.reportAuthorizationInfo.allUsersAvailable;

    var $template = (0, _jquery2.default)("#itemsTable").find("tbody.template");
    var $templateRow = $template.find("tr.templateRow").clone();
    levels.length > 0 ? $templateRow.find(".firstLayer").html(this._getEscapedLevelPreviewName(levels[0])) : $templateRow.find(".firstLayer").hide();
    levels.length > 1 ? $templateRow.find(".secondLayer").html(" - " + this._getEscapedLevelPreviewName(levels[1])) : $templateRow.find(".secondLayer").hide();
    levels.length > 2 ? $templateRow.find(".thirdLayer").html(" - " + this._getEscapedLevelPreviewName(levels[2])) : $templateRow.find(".thirdLayer").hide();
    levels.length > 3 ? $templateRow.find(".fourthLayer").html(" - " + this._getEscapedLevelPreviewName(levels[3])) : $templateRow.find(".fourthLayer").hide();

    if (levels.length === 1) {
        var isUserLevel = levels[0] === _constants.ReportGroupingLevel.USER;
        this._cloneRow($templateRow, 4);
        if (isUserLevel && !allUsersAvailable) {
            (0, _jquery2.default)('.itemsBody .firstLayer').last().text(this._getOthersLevelName());
        }
    } else if (levels.length === 2) {
        this._cloneRow($templateRow, 3);
        if (levels[0] === _constants.ReportGroupingLevel.USER && !allUsersAvailable) {
            (0, _jquery2.default)('.itemsBody .firstInRow').append('<div class="firstLayer">' + this._getOthersLevelName() + '</div>');
        } else if (levels[1] === _constants.ReportGroupingLevel.USER && !allUsersAvailable) {
            (0, _jquery2.default)('.itemsBody .firstInRow').append('<div class="secondLayer">' + ' - ' + this._getOthersLevelName() + '</div>');
        }
    } else if (levels.length > 2) {
        this._cloneRow($templateRow, 2);
        if (levels[0] === _constants.ReportGroupingLevel.USER && !allUsersAvailable) {
            (0, _jquery2.default)('.itemsBody .firstInRow').append('<div class="firstLayer">' + this._getOthersLevelName() + '</div>');
            if (levels[1] !== _constants.ReportGroupingLevel.TT_COMMENTS) (0, _jquery2.default)('.itemsBody .firstInRow').append('<div class="secondLayer">' + ' - ' + this._getEscapedLevelPreviewName(levels[1]) + '</div>');
            if (levels[2] !== _constants.ReportGroupingLevel.TT_COMMENTS) (0, _jquery2.default)('.itemsBody .firstInRow').append('<div class="thirdLayer">' + ' - ' + this._getEscapedLevelPreviewName(levels[2]) + '</div>');
        } else if (levels[1] === _constants.ReportGroupingLevel.USER && !allUsersAvailable) {
            (0, _jquery2.default)('.itemsBody .firstInRow').append('<div class="secondLayer">' + ' - ' + this._getOthersLevelName() + '</div>');
            if (levels[2] !== _constants.ReportGroupingLevel.TT_COMMENTS) (0, _jquery2.default)('.itemsBody .firstInRow').append('<div class="thirdLayer">' + ' - ' + this._getEscapedLevelPreviewName(levels[2]) + '</div>');
        }
    }
};

InvoicePreviewRenderer.prototype._getOthersLevelName = function () {
    return _messageResource2.default.getMessage("report.other_users");
};

InvoicePreviewRenderer.prototype._cloneRow = function ($templateRow, numberOfClones) {
    for (var i = 0; i < numberOfClones; i++) {
        var $row = $templateRow.clone();
        this.itemsTable.find(".itemsBody").append($row);
    }
};

InvoicePreviewRenderer.prototype._addLevelsDependsFromThirdLevel = function (levels, thirdGroupingLevel) {
    switch (thirdGroupingLevel) {
        case _constants.ReportGroupingLevel.TASK_AND_TT_COMMENTS:
            levels.push(_constants.ReportGroupingLevel.TASK);
            levels.push(_constants.ReportGroupingLevel.TT_COMMENTS);
            break;
        case _constants.ReportGroupingLevel.PROJECT_AND_TT_COMMENTS:
            levels.push(_constants.ReportGroupingLevel.PROJECT);
            levels.push(_constants.ReportGroupingLevel.TT_COMMENTS);
            break;
        case _constants.ReportGroupingLevel.CUSTOMER_AND_TT_COMMENTS:
            levels.push(_constants.ReportGroupingLevel.CUSTOMER);
            levels.push(_constants.ReportGroupingLevel.TT_COMMENTS);
            break;
        default:
            levels.push(thirdGroupingLevel);
    }
};

InvoicePreviewRenderer.prototype.getName = function (groupingLevelValue) {
    switch (groupingLevelValue) {
        case _constants.ReportGroupingLevel.CUSTOMER:
            return "customer";
        default:
            return "otherGrouping";
    }
};

InvoicePreviewRenderer.prototype._getEscapedLevelPreviewName = function (level) {
    return (0, _atUtils.escapeHtmlSymbols)(ReportPreviewUtils.getLevelPreviewName(level));
};

/***/ }),
/* 2136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _constants = __webpack_require__(11);

var _InvoiceReportEditConfigController = __webpack_require__(1000);

var _InvoiceReportEditConfigController2 = _interopRequireDefault(_InvoiceReportEditConfigController);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InvoiceEditFormConfigController = function (_InvoiceReportEditCon) {
    _inherits(InvoiceEditFormConfigController, _InvoiceReportEditCon);

    function InvoiceEditFormConfigController() {
        _classCallCheck(this, InvoiceEditFormConfigController);

        return _possibleConstructorReturn(this, (InvoiceEditFormConfigController.__proto__ || Object.getPrototypeOf(InvoiceEditFormConfigController)).apply(this, arguments));
    }

    return InvoiceEditFormConfigController;
}(_InvoiceReportEditConfigController2.default);

exports.default = InvoiceEditFormConfigController;


InvoiceEditFormConfigController.prototype.makeReportParamsAccordingToFeatures = function (reportParameters) {
    var result = _jquery2.default.extend({}, reportParameters);

    if (!EnabledFeatures.UGR) {
        var groupings = this.makeGroupingSelectorValuesAccordingToNotAvailableValueLevel(_constants.ReportGroupingLevel.USER_GROUP, [result.firstGroupingLevel, result.secondGroupingLevel], _constants.ReportGroupingLevel.CUSTOMER);
        result.firstGroupingLevel = groupings[0];
        result.secondGroupingLevel = groupings[1];
    }

    return result;
};

/***/ }),
/* 2137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ProfitLossFormMediator;

var _OldBaseFormMediator = __webpack_require__(271);

var _OldBaseFormMediator2 = _interopRequireDefault(_OldBaseFormMediator);

var _ProfitLossReportEditFormConfigController = __webpack_require__(2138);

var _ProfitLossReportEditFormConfigController2 = _interopRequireDefault(_ProfitLossReportEditFormConfigController);

var _ProfitLossCSVPreviewGenerator = __webpack_require__(2140);

var _ProfitLossCSVPreviewGenerator2 = _interopRequireDefault(_ProfitLossCSVPreviewGenerator);

var _ProfitLossHTMLPreviewGenerator = __webpack_require__(2143);

var _ProfitLossHTMLPreviewGenerator2 = _interopRequireDefault(_ProfitLossHTMLPreviewGenerator);

var _ATReportParamsStringBuilder = __webpack_require__(52);

var _ATReportParamsStringBuilder2 = _interopRequireDefault(_ATReportParamsStringBuilder);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ProfitLossFormMediator() {} /**
                                      * @author evdokimov
                                      */


ProfitLossFormMediator.prototype = new _OldBaseFormMediator2.default();

ProfitLossFormMediator.prototype.init = function (config) {
    _OldBaseFormMediator2.default.prototype.init.call(this, config);
    return this;
};

ProfitLossFormMediator.prototype.initParamsStringBuilder = function (config) {
    return new _ATReportParamsStringBuilder2.default({
        data: {
            cpList: config.cpList,
            manageableUserIds: ATReportsStore.getManageableUserIds(),
            projectsWithMaIds: ATReportsStore.getProjectsWithMaIds()
        },
        reportAuthorizationInfo: ATReportsStore.getReportAuthorizationInfo()
    });
};

ProfitLossFormMediator.prototype.initEditConfigController = function (config) {
    var _this = this;

    return new _ProfitLossReportEditFormConfigController2.default().init({
        panelId: "mainContainer",
        reportParameters: config.reportParameters,
        cpList: config.cpList,
        customersWithMaIds: config.customersWithMaIds,
        projectsWithMaIds: config.projectsWithMaIds,
        changeCallback: function changeCallback() {
            return _this.changeParametersCallback();
        }
    });
};

ProfitLossFormMediator.prototype.initCsvGenerator = function () {
    return new _ProfitLossCSVPreviewGenerator2.default().init();
};

ProfitLossFormMediator.prototype.initHtmlGenerator = function () {
    return new _ProfitLossHTMLPreviewGenerator2.default().init();
};

/***/ }),
/* 2138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _ProfitLossReportEditConfigController = __webpack_require__(1002);

var _ProfitLossReportEditConfigController2 = _interopRequireDefault(_ProfitLossReportEditConfigController);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ProfitLossReportEditFormConfigController = function (_ProfitLossReportEdit) {
    _inherits(ProfitLossReportEditFormConfigController, _ProfitLossReportEdit);

    function ProfitLossReportEditFormConfigController() {
        _classCallCheck(this, ProfitLossReportEditFormConfigController);

        return _possibleConstructorReturn(this, (ProfitLossReportEditFormConfigController.__proto__ || Object.getPrototypeOf(ProfitLossReportEditFormConfigController)).apply(this, arguments));
    }

    return ProfitLossReportEditFormConfigController;
}(_ProfitLossReportEditConfigController2.default);

exports.default = ProfitLossReportEditFormConfigController;


ProfitLossReportEditFormConfigController.prototype.makeReportParamsAccordingToFeatures = function (reportParameters) {
    var result = _jquery2.default.extend({}, reportParameters);

    if (!EnabledFeatures.LVT) result.showLeaveTimeCosts = false;

    if (!EnabledFeatures.OVR) result.showOvertimeAddition = false;

    return result;
};

/***/ }),
/* 2139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ProfitLossDisplayedDataSelector;

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _constants = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ProfitLossDisplayedDataSelector() {}

ProfitLossDisplayedDataSelector.prototype.init = function (radioGroupSelectorId, firstGroupingLevel, secondGroupingLevel, thirdGroupingLevel, changeCallback) {
    this.selectorId = (0, _jquery2.default)("#" + radioGroupSelectorId);
    this.customerGroupingChexBox = this.selectorId.find("[value=customerGrouping]");
    this.customerGroupingChexBox.on("change", changeCallback);
    this.customerProjectGroupingChexBox = this.selectorId.find("[value=customerProjectGrouping]");
    this.customerProjectGroupingChexBox.on("change", changeCallback);
    this.customerProjectTaskGroupingChexBox = this.selectorId.find("[value=customerProjectTaskGrouping]");
    this.customerProjectTaskGroupingChexBox.on("change", changeCallback);
    this.setValue(firstGroupingLevel, secondGroupingLevel, thirdGroupingLevel);
    return this;
};

ProfitLossDisplayedDataSelector.prototype.setValue = function (firstGroupingLevel, secondGroupingLevel, thirdGroupingLevel) {
    if (thirdGroupingLevel == _constants.ReportGroupingLevel.NONE) {
        if (secondGroupingLevel == _constants.ReportGroupingLevel.NONE) {
            this.customerGroupingChexBox.prop("checked", true);
            return;
        }
        this.customerProjectGroupingChexBox.prop("checked", true);
        return;
    }
    this.customerProjectTaskGroupingChexBox.prop("checked", true);
};

ProfitLossDisplayedDataSelector.prototype.getValue = function () {
    return {
        firstGroupingLevel: _constants.ReportGroupingLevel.CUSTOMER,
        secondGroupingLevel: this.customerGroupingChexBox.is(":checked") ? _constants.ReportGroupingLevel.NONE : _constants.ReportGroupingLevel.PROJECT,
        thirdGroupingLevel: this.customerProjectTaskGroupingChexBox.is(":checked") ? _constants.ReportGroupingLevel.TASK : _constants.ReportGroupingLevel.NONE
    };
};

/***/ }),
/* 2140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ProfitLossCSVPreviewGenerator;

var _constants = __webpack_require__(11);

var _CSVPreviewCostProfitLossAdditionalSection = __webpack_require__(995);

var _CSVPreviewCostProfitLossAdditionalSection2 = _interopRequireDefault(_CSVPreviewCostProfitLossAdditionalSection);

var _CSVPreviewEmptySection = __webpack_require__(324);

var _CSVPreviewEmptySection2 = _interopRequireDefault(_CSVPreviewEmptySection);

var _CSVParametersBuilder = __webpack_require__(150);

var _CSVParametersBuilder2 = _interopRequireDefault(_CSVParametersBuilder);

var _ProfitLossCSVPreviewHeader = __webpack_require__(2141);

var _ProfitLossCSVPreviewHeader2 = _interopRequireDefault(_ProfitLossCSVPreviewHeader);

var _ProfitLossCSVPreviewGroupingSection = __webpack_require__(2142);

var _ProfitLossCSVPreviewGroupingSection2 = _interopRequireDefault(_ProfitLossCSVPreviewGroupingSection);

var _CSVParametersSection = __webpack_require__(170);

var _CSVParametersSection2 = _interopRequireDefault(_CSVParametersSection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ProfitLossCSVPreviewGenerator() {}

ProfitLossCSVPreviewGenerator.prototype.init = function () {
    return this;
};

ProfitLossCSVPreviewGenerator.prototype.BASE_COUNT_DATA_COLUMNS = 3;

ProfitLossCSVPreviewGenerator.prototype.generatePreviewTable = function (reportParameters, reportParamsStringBuilder) {

    var numOfGroupingColumns = ReportPreviewUtils.countNotEmptyLevels([reportParameters.firstGroupingLevel, reportParameters.secondGroupingLevel, reportParameters.thirdGroupingLevel]);

    if (reportParameters.thirdGroupingLevel != _constants.ReportGroupingLevel.NONE) {
        numOfGroupingColumns++;
    }
    var countDataColumns = this.BASE_COUNT_DATA_COLUMNS;

    if (reportParameters.showSpentTime) {
        countDataColumns++;
    }

    if (reportParameters.showAverageRates) {
        countDataColumns += 2;
    }

    var totalColumnsNum = countDataColumns + numOfGroupingColumns;

    var header = new _ProfitLossCSVPreviewHeader2.default().init(reportParameters.firstGroupingLevel, reportParameters.secondGroupingLevel, reportParameters.thirdGroupingLevel, reportParameters.showSpentTime, reportParameters.showAverageRates);

    var dataGroupingSection = new _ProfitLossCSVPreviewGroupingSection2.default().init(reportParameters.firstGroupingLevel, reportParameters.secondGroupingLevel, reportParameters.thirdGroupingLevel, countDataColumns, numOfGroupingColumns);

    var additionalSection = new _CSVPreviewCostProfitLossAdditionalSection2.default().init(countDataColumns, numOfGroupingColumns, reportParameters.showOvertimeAddition, reportParameters.showLeaveTimeCosts);
    var emptySection = new _CSVPreviewEmptySection2.default().init(1, totalColumnsNum);

    var table = document.createElement("table");
    table.className = "reportCsvPreviewTable profitLoss";
    var tBody = document.createElement("tbody");
    table.appendChild(tBody);
    var totalRowNum = 15;

    ReportPreviewUtils.addSheetHeaderRow(tBody, totalColumnsNum);

    var paramsBuilder = new _CSVParametersBuilder2.default().init();
    paramsBuilder.addDateRangeParam(reportParameters.dateRangeSelection, reportParamsStringBuilder);
    paramsBuilder.addCPParam(reportParameters.customersProjectsSelection, reportParamsStringBuilder);

    var parametersSection = new _CSVParametersSection2.default().init(paramsBuilder, totalColumnsNum);

    parametersSection.addRows(tBody);
    header.addRows(tBody);
    dataGroupingSection.addRows(tBody);
    emptySection.addRows(tBody);
    additionalSection.addRows(tBody);
    this.addEmptySectionIfNeeded(totalRowNum, tBody, totalColumnsNum);

    return table;
};

ProfitLossCSVPreviewGenerator.prototype.addEmptySectionIfNeeded = function (totalRowsNum, tBody, totalColumnsNum) {
    var numOfEmptyRows = totalRowsNum + 1 - tBody.childNodes.length;
    if (numOfEmptyRows > 0) new _CSVPreviewEmptySection2.default().init(numOfEmptyRows, totalColumnsNum).addRows(tBody);
};

/***/ }),
/* 2141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ProfitLossCSVPreviewHeader;

var _CSVPreviewSection = __webpack_require__(43);

var _CSVPreviewSection2 = _interopRequireDefault(_CSVPreviewSection);

var _constants = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ProfitLossCSVPreviewHeader() {}

ProfitLossCSVPreviewHeader.prototype = new _CSVPreviewSection2.default();

ProfitLossCSVPreviewHeader.prototype.init = function (firstGroupingLevel, secondGroupingLevel, thirdGroupingLevel, showSpentTime, showAverageRates) {
    _CSVPreviewSection2.default.prototype.init.call(this);
    this.firstGroupingLevel = firstGroupingLevel;
    this.secondGroupingLevel = secondGroupingLevel;
    this.thirdGroupingLevel = thirdGroupingLevel;
    this.showSpentTime = showSpentTime;
    this.showAverageRates = showAverageRates;
    return this;
};

ProfitLossCSVPreviewHeader.prototype.addGroupingLevel = function (row, groupingLevel) {
    ReportPreviewUtils.addCell(row, ReportPreviewUtils.getLevelPreviewName(groupingLevel));
};

ProfitLossCSVPreviewHeader.prototype.addRows = function (tBody) {
    var mainHeaderRow = this.createRow();
    $(mainHeaderRow).addClass("headerGroupingRow");
    this.addGroupingLevel(mainHeaderRow, this.firstGroupingLevel);
    if (this.secondGroupingLevel != _constants.ReportGroupingLevel.NONE) this.addGroupingLevel(mainHeaderRow, this.secondGroupingLevel);
    if (this.thirdGroupingLevel != _constants.ReportGroupingLevel.NONE) {
        this.addGroupingLevel(mainHeaderRow, this.thirdGroupingLevel);
        this.addCell(mainHeaderRow, this.message("report.billing_type"));
    }

    var commonUnitText = " " + this.message("report.common.unit_rate", [SystemSettings.currencySign]) + " ";
    var currencySign = " (" + SystemSettings.currencySign + ") ";
    var unitWork = this.message("report.common.unit_work");

    if (this.showSpentTime) this.addCell(mainHeaderRow, this.message("report.profit_loss.spent.header") + " " + unitWork);
    if (this.showAverageRates) this.addCell(mainHeaderRow, this.message("report.profit_loss.billing_rate") + commonUnitText);
    this.addCell(mainHeaderRow, this.message("report.profit_loss.billable_amount.header") + currencySign);
    if (this.showAverageRates) this.addCell(mainHeaderRow, this.message("report.profit_loss.average_user_rate") + commonUnitText);
    this.addCell(mainHeaderRow, this.message("report.profit_loss.cost.header") + currencySign);
    this.addCell(mainHeaderRow, this.message("report.profit_loss.pl.header") + currencySign);
    this.addRow(tBody, mainHeaderRow);
};

/***/ }),
/* 2142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ProfitLossCSVPreviewGroupingSection;

var _CSVPreviewSection = __webpack_require__(43);

var _CSVPreviewSection2 = _interopRequireDefault(_CSVPreviewSection);

var _constants = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ProfitLossCSVPreviewGroupingSection() {}

ProfitLossCSVPreviewGroupingSection.prototype = new _CSVPreviewSection2.default();

ProfitLossCSVPreviewGroupingSection.prototype.init = function (firstGroupingLevel, secondGroupingLevel, thirdGroupingLevel, countDataColumns, countGroupingColumns) {
    _CSVPreviewSection2.default.prototype.init.call(this);
    this.firstGroupingLevel = firstGroupingLevel;
    this.secondGroupingLevel = secondGroupingLevel;
    this.thirdGroupingLevel = thirdGroupingLevel;
    this.countDataColumns = countDataColumns;
    this.countGroupingColumns = countGroupingColumns;
    return this;
};

ProfitLossCSVPreviewGroupingSection.prototype.addRows = function (tBody) {
    for (var i = 0; i < 5; i++) {
        var row = this.createRow();
        this.addGroupingLevel(row, this.firstGroupingLevel);
        if (this.secondGroupingLevel != _constants.ReportGroupingLevel.NONE) this.addGroupingLevel(row, this.secondGroupingLevel);
        if (this.thirdGroupingLevel != _constants.ReportGroupingLevel.NONE) {
            this.addGroupingLevel(row, this.thirdGroupingLevel);
            this.addCell(row, this.message("report.billing_type"));
        }

        for (var j = 0; j < this.countDataColumns; j++) {
            this.addTimeValueCell(row);
        }this.addRow(tBody, row);
    }
};

ProfitLossCSVPreviewGroupingSection.prototype.addGroupingLevel = function (row, groupingLevel) {
    ReportPreviewUtils.addCell(row, ReportPreviewUtils.getLevelPreviewName(groupingLevel));
};

/***/ }),
/* 2143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ProfitLossHTMLPreviewGenerator;

var _ProfitLossHTMLPreviewShowRatesStrategy = __webpack_require__(2144);

var _ProfitLossHTMLPreviewShowRatesStrategy2 = _interopRequireDefault(_ProfitLossHTMLPreviewShowRatesStrategy);

var _ProfitLossHTMLPreviewHideRatesStrategy = __webpack_require__(2145);

var _ProfitLossHTMLPreviewHideRatesStrategy2 = _interopRequireDefault(_ProfitLossHTMLPreviewHideRatesStrategy);

var _ProfitLossHTMLPreviewHeaderSection = __webpack_require__(2146);

var _ProfitLossHTMLPreviewHeaderSection2 = _interopRequireDefault(_ProfitLossHTMLPreviewHeaderSection);

var _ProfitLossHTMLPreviewGeneralCostsSection = __webpack_require__(2147);

var _ProfitLossHTMLPreviewGeneralCostsSection2 = _interopRequireDefault(_ProfitLossHTMLPreviewGeneralCostsSection);

var _ProfitLossHTMLPreviewGroupingSection = __webpack_require__(2148);

var _ProfitLossHTMLPreviewGroupingSection2 = _interopRequireDefault(_ProfitLossHTMLPreviewGroupingSection);

var _ProfitLossHTMLPreviewGrandTotalSection = __webpack_require__(2149);

var _ProfitLossHTMLPreviewGrandTotalSection2 = _interopRequireDefault(_ProfitLossHTMLPreviewGrandTotalSection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ProfitLossHTMLPreviewGenerator() {}

ProfitLossHTMLPreviewGenerator.prototype.init = function () {
    return this;
};

ProfitLossHTMLPreviewGenerator.prototype.generatePreviewTable = function (reportParameters) {
    var table = document.createElement("table");
    table.className = "reportHtmlPreviewTable profitLoss " + (reportParameters.showSpentTime ? "showSpentTime" : "");
    var tBody = document.createElement("tbody");
    table.appendChild(tBody);

    var columnsStrategy = reportParameters.showAverageRates ? new _ProfitLossHTMLPreviewShowRatesStrategy2.default().init(reportParameters.timeFormat, reportParameters.showSpentTime) : new _ProfitLossHTMLPreviewHideRatesStrategy2.default().init(reportParameters.timeFormat, reportParameters.showSpentTime);

    var header = new _ProfitLossHTMLPreviewHeaderSection2.default().init(columnsStrategy);

    var groupingRowsCount = 3;
    var generalCostsSection = null;
    if (reportParameters.showLeaveTimeCosts || reportParameters.showOvertimeAddition) {
        generalCostsSection = new _ProfitLossHTMLPreviewGeneralCostsSection2.default().init(reportParameters.showLeaveTimeCosts, reportParameters.showOvertimeAddition, columnsStrategy);
        if (!reportParameters.showLeaveTimeCosts) groupingRowsCount += 2;
        if (!reportParameters.showOvertimeAddition) groupingRowsCount++;
    } else {
        groupingRowsCount += 4;
    }

    var groupingSection = new _ProfitLossHTMLPreviewGroupingSection2.default().init(reportParameters.firstGroupingLevel, reportParameters.secondGroupingLevel, reportParameters.thirdGroupingLevel, columnsStrategy, groupingRowsCount);
    var grandTotalSection = new _ProfitLossHTMLPreviewGrandTotalSection2.default().init(columnsStrategy);

    header.addRows(tBody);
    groupingSection.addRows(tBody);
    if (generalCostsSection) generalCostsSection.addRows(tBody);
    grandTotalSection.addRows(tBody);

    return table;
};

/***/ }),
/* 2144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ProfitLossHTMLPreviewShowRatesStrategy;

var _ProfitLossHTMLPreviewBaseStrategy = __webpack_require__(1003);

var _ProfitLossHTMLPreviewBaseStrategy2 = _interopRequireDefault(_ProfitLossHTMLPreviewBaseStrategy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ProfitLossHTMLPreviewShowRatesStrategy() {}

ProfitLossHTMLPreviewShowRatesStrategy.prototype = new _ProfitLossHTMLPreviewBaseStrategy2.default();

ProfitLossHTMLPreviewShowRatesStrategy.prototype.init = function (timeFormat, showSpentTime) {
    _ProfitLossHTMLPreviewBaseStrategy2.default.prototype.init.call(this, timeFormat, showSpentTime);
    return this;
};

ProfitLossHTMLPreviewShowRatesStrategy.prototype.getBillableAmountColHeaderText = function () {
    return this.message("report.profit_loss.billable_amount.header");
};

ProfitLossHTMLPreviewShowRatesStrategy.prototype.getCostOfWorkColHeaderText = function () {
    return this.message("report.profit_loss.cost.header");
};

ProfitLossHTMLPreviewShowRatesStrategy.prototype.getBillableAmountColSpan = function () {
    return 2;
};

ProfitLossHTMLPreviewShowRatesStrategy.prototype.getBillableAmountRowSpan = function () {
    return 1;
};

ProfitLossHTMLPreviewShowRatesStrategy.prototype.getCostOfWorkColSpan = function () {
    return 2;
};

ProfitLossHTMLPreviewShowRatesStrategy.prototype.getCostOfWorkRowSpan = function () {
    return 1;
};

ProfitLossHTMLPreviewShowRatesStrategy.prototype.addSecondHeaderRowCells = function (secondHeaderRow) {
    this.addCell(secondHeaderRow, this.message("report.profit_loss.rate.subheader") + " " + this.message("report.common.unit_rate", [SystemSettings.currencySign]), "rate");

    this.addCell(secondHeaderRow, this.message("report.profit_loss.billable_amount.subheader") + " (" + SystemSettings.currencySign + ")", "amount");

    this.addCell(secondHeaderRow, this.message("report.profit_loss.rate.subheader") + " " + this.message("report.common.unit_rate", [SystemSettings.currencySign]), "rate");

    this.addCell(secondHeaderRow, this.message("report.profit_loss.cost.subheader") + " (" + SystemSettings.currencySign + ")", "cost");
};

ProfitLossHTMLPreviewShowRatesStrategy.prototype.addDataCells = function (row) {
    if (this.showSpentTime) this.addTimeValueCell(row, "spent");

    this.addMoneyValueCell(row);
    this.addMoneyValueCell(row, "darkMoneyValueCell");
    this.addMoneyValueCell(row);
    this.addMoneyValueCell(row, "darkMoneyValueCell");
    this.addMoneyValueCell(row);
};

ProfitLossHTMLPreviewShowRatesStrategy.prototype.getDataColumnsCount = function () {
    return this.showSpentTime ? 6 : 5;
};

/***/ }),
/* 2145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ProfitLossHTMLPreviewHideRatesStrategy;

var _ProfitLossHTMLPreviewBaseStrategy = __webpack_require__(1003);

var _ProfitLossHTMLPreviewBaseStrategy2 = _interopRequireDefault(_ProfitLossHTMLPreviewBaseStrategy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ProfitLossHTMLPreviewHideRatesStrategy() {}

ProfitLossHTMLPreviewHideRatesStrategy.prototype = new _ProfitLossHTMLPreviewBaseStrategy2.default();

ProfitLossHTMLPreviewHideRatesStrategy.prototype.init = function (timeFormat, showSpentTime) {
    _ProfitLossHTMLPreviewBaseStrategy2.default.prototype.init.call(this, timeFormat, showSpentTime);
    return this;
};

ProfitLossHTMLPreviewHideRatesStrategy.prototype.getBillableAmountColHeaderText = function () {
    return this.message("report.profit_loss.billable_amount.header") + " (" + SystemSettings.currencySign + ")";
};

ProfitLossHTMLPreviewHideRatesStrategy.prototype.getCostOfWorkColHeaderText = function () {
    return this.message("report.profit_loss.cost.header") + " (" + SystemSettings.currencySign + ")";
};

ProfitLossHTMLPreviewHideRatesStrategy.prototype.getBillableAmountColSpan = function () {
    return 1;
};

ProfitLossHTMLPreviewHideRatesStrategy.prototype.getBillableAmountRowSpan = function () {
    return 2;
};

ProfitLossHTMLPreviewHideRatesStrategy.prototype.getCostOfWorkColSpan = function () {
    return 1;
};

ProfitLossHTMLPreviewHideRatesStrategy.prototype.getCostOfWorkRowSpan = function () {
    return 2;
};

ProfitLossHTMLPreviewHideRatesStrategy.prototype.addSecondHeaderRowCells = function (secondHeaderRow) {
    // do nothing
};

ProfitLossHTMLPreviewHideRatesStrategy.prototype.addDataCells = function (row) {
    if (this.showSpentTime) this.addTimeValueCell(row, "spent");

    this.addMoneyValueCell(row);
    this.addMoneyValueCell(row);
    this.addMoneyValueCell(row);
};

ProfitLossHTMLPreviewHideRatesStrategy.prototype.getDataColumnsCount = function () {
    return this.showSpentTime ? 4 : 3;
};

/***/ }),
/* 2146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ProfitLossHTMLPreviewHeaderSection;

var _ProfitLossHTMLPreviewBaseSection = __webpack_require__(417);

var _ProfitLossHTMLPreviewBaseSection2 = _interopRequireDefault(_ProfitLossHTMLPreviewBaseSection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ProfitLossHTMLPreviewHeaderSection() {}

ProfitLossHTMLPreviewHeaderSection.prototype = new _ProfitLossHTMLPreviewBaseSection2.default();

ProfitLossHTMLPreviewHeaderSection.prototype.init = function (columnsStrategy) {
    _ProfitLossHTMLPreviewBaseSection2.default.prototype.init.call(this, columnsStrategy);
    return this;
};

ProfitLossHTMLPreviewHeaderSection.prototype.addRows = function (tBody) {
    var row1 = this.createRow("headerRow firstHeaderRow");
    this.addCell(row1, this.message("report.cost_items"), "costItems", 1, 2);
    this.columnsStrategy.addFirstHeaderRowCells(row1);

    var row2 = this.createRow("headerRow secondHeaderRow");
    this.columnsStrategy.addSecondHeaderRowCells(row2);

    this.addRow(tBody, row1);
    this.addRow(tBody, row2);
};

/***/ }),
/* 2147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ProfitLossHTMLPreviewGeneralCostsSection;

var _ProfitLossHTMLPreviewBaseSection = __webpack_require__(417);

var _ProfitLossHTMLPreviewBaseSection2 = _interopRequireDefault(_ProfitLossHTMLPreviewBaseSection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ProfitLossHTMLPreviewGeneralCostsSection() {}

ProfitLossHTMLPreviewGeneralCostsSection.prototype = new _ProfitLossHTMLPreviewBaseSection2.default();

ProfitLossHTMLPreviewGeneralCostsSection.prototype.init = function (showLeaveTimeCosts, showOvertimeAddition, columnsStrategy) {
    _ProfitLossHTMLPreviewBaseSection2.default.prototype.init.call(this, columnsStrategy);
    this.showLeaveTimeCosts = showLeaveTimeCosts;
    this.showOvertimeAddition = showOvertimeAddition;
    return this;
};

ProfitLossHTMLPreviewGeneralCostsSection.prototype.addRows = function (tBody) {
    var headerRow = this.createRow("generalCosts");
    this.addCell(headerRow, this.message("report.general_costs"), "", this.columnsStrategy.getDataColumnsCount() + 1);
    this.addRow(tBody, headerRow);

    if (this.showLeaveTimeCosts) {
        this.addRowWithMainCell(tBody, this.message("report.profit_loss.total_leave"), "totalLeaveTimeCell", "totalLeaveTime");
        this.addRowWithMainCell(tBody, this.message("leave_type.leave_type"), "leaveType");
    }

    if (this.showOvertimeAddition) this.addRowWithMainCell(tBody, this.message("report.profit_loss.overtime_bonus"), "overtimeAdditionCell", "overtimeAddition");
};

/***/ }),
/* 2148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ProfitLossHTMLPreviewGroupingSection;

var _ProfitLossHTMLPreviewBaseSection = __webpack_require__(417);

var _ProfitLossHTMLPreviewBaseSection2 = _interopRequireDefault(_ProfitLossHTMLPreviewBaseSection);

var _constants = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ProfitLossHTMLPreviewGroupingSection() {}

ProfitLossHTMLPreviewGroupingSection.prototype = new _ProfitLossHTMLPreviewBaseSection2.default();

ProfitLossHTMLPreviewGroupingSection.prototype.init = function (firstGroupingLevel, secondGroupingLevel, thirdGroupingLevel, columnsStrategy, groupingRowsCount) {
    _ProfitLossHTMLPreviewBaseSection2.default.prototype.init.call(this, columnsStrategy);
    this.firstGroupingLevel = firstGroupingLevel;
    this.secondGroupingLevel = secondGroupingLevel;
    this.thirdGroupingLevel = thirdGroupingLevel;
    this.groupingRowsCount = groupingRowsCount;
    return this;
};

ProfitLossHTMLPreviewGroupingSection.prototype.addRows = function (tBody) {
    this.addRowWithMainCell(tBody, this.message("report.profit_loss.total_for_working_time"), "totalForWorkingTime", "totalForWorkingTimeRow");

    var rowsCount = 0;
    while (true) {
        this.addGroupingRow(tBody, this.firstGroupingLevel, "firstLevel", "firstGrouping");
        if (++rowsCount >= this.groupingRowsCount) break;

        if (this.secondGroupingLevel != _constants.ReportGroupingLevel.NONE) {
            this.addGroupingRow(tBody, this.secondGroupingLevel, "secondLevel", "secondGrouping");
            if (++rowsCount >= this.groupingRowsCount) break;
        }

        if (this.thirdGroupingLevel != _constants.ReportGroupingLevel.NONE) {
            this.addGroupingRow(tBody, this.thirdGroupingLevel, "thirdLevel");
            if (++rowsCount >= this.groupingRowsCount) break;
            this.addGroupingRow(tBody, this.thirdGroupingLevel, "thirdLevel");
            if (++rowsCount >= this.groupingRowsCount) break;
        }
    }
};

ProfitLossHTMLPreviewGroupingSection.prototype.addGroupingRow = function (tBody, groupingLevel, mainCellClassName, rowClassName) {
    this.addRowWithMainCell(tBody, ReportPreviewUtils.getLevelPreviewName(groupingLevel), mainCellClassName, rowClassName);
};

/***/ }),
/* 2149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ProfitLossHTMLPreviewGrandTotalSection;

var _ProfitLossHTMLPreviewBaseSection = __webpack_require__(417);

var _ProfitLossHTMLPreviewBaseSection2 = _interopRequireDefault(_ProfitLossHTMLPreviewBaseSection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ProfitLossHTMLPreviewGrandTotalSection() {}

ProfitLossHTMLPreviewGrandTotalSection.prototype = new _ProfitLossHTMLPreviewBaseSection2.default();

ProfitLossHTMLPreviewGrandTotalSection.prototype.init = function (columnsStrategy) {
    _ProfitLossHTMLPreviewBaseSection2.default.prototype.init.call(this, columnsStrategy);
    return this;
};

ProfitLossHTMLPreviewGrandTotalSection.prototype.addRows = function (tBody) {
    var splitterRow = this.createRow("splitterRow");
    this.addCell(splitterRow, "", "", this.columnsStrategy.getDataColumnsCount() + 1);
    this.addRow(tBody, splitterRow);

    this.addRowWithMainCell(tBody, this.message("report.grand_total"), "grandTotalCell", "grandTotal");
};

/***/ }),
/* 2150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ProfitLossReportMediator;

var _ProfitLossReportEditResultConfigController = __webpack_require__(2151);

var _ProfitLossReportEditResultConfigController2 = _interopRequireDefault(_ProfitLossReportEditResultConfigController);

var _OldReportMediator = __webpack_require__(268);

var _OldReportMediator2 = _interopRequireDefault(_OldReportMediator);

var _constants = __webpack_require__(11);

var _ReportPrintableHeadersBuilder = __webpack_require__(171);

var _ReportPrintableHeadersBuilder2 = _interopRequireDefault(_ReportPrintableHeadersBuilder);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ProfitLossReportMediator() {
    this.constructor = ProfitLossReportMediator;
}

ProfitLossReportMediator.prototype = new _OldReportMediator2.default();

ProfitLossReportMediator.prototype.init = function (config) {
    _OldReportMediator2.default.prototype.init.call(this, config);

    return this;
};

ProfitLossReportMediator.prototype.getReportType = function () {
    return _constants.ReportType.PROFIT_LOSS;
};

ProfitLossReportMediator.prototype.initEditConfigController = function (config) {
    var self = this;
    return new _ProfitLossReportEditResultConfigController2.default().init({
        reportParameters: config.reportParameters,
        cpList: config.cpList,
        customersWithMaIds: config.customersWithMaIds,
        projectsWithMaIds: config.projectsWithMaIds,
        changeCallback: function changeCallback() {
            self.changeParametersCallback();
        }
    });
};

ProfitLossReportMediator.prototype._populateHeadersArray = function (headersArray) {
    this.printableHeadersBuilder.addCPSelectionParamsStringToArray(this.reportParameters.customersProjectsSelection, headersArray); //customers and projects
};

ProfitLossReportMediator.prototype.initPrintableHeadersBuilder = function (config) {
    return new _ReportPrintableHeadersBuilder2.default().init({
        reportParameters: config.reportParameters,
        cpList: config.cpList,
        isFilteredByAssignments: config.isFilteredByAssignments
    });
};

/***/ }),
/* 2151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ProfitLossReportEditConfigController = __webpack_require__(1002);

var _ProfitLossReportEditConfigController2 = _interopRequireDefault(_ProfitLossReportEditConfigController);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ProfitLossReportEditResultConfigController = function (_ProfitLossReportEdit) {
    _inherits(ProfitLossReportEditResultConfigController, _ProfitLossReportEdit);

    function ProfitLossReportEditResultConfigController() {
        _classCallCheck(this, ProfitLossReportEditResultConfigController);

        return _possibleConstructorReturn(this, (ProfitLossReportEditResultConfigController.__proto__ || Object.getPrototypeOf(ProfitLossReportEditResultConfigController)).apply(this, arguments));
    }

    return ProfitLossReportEditResultConfigController;
}(_ProfitLossReportEditConfigController2.default);

exports.default = ProfitLossReportEditResultConfigController;


ProfitLossReportEditResultConfigController.prototype.makeReportParamsAccordingToFeatures = function (reportParameters) {
    return reportParameters;
};

/***/ }),
/* 2152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _InvoiceReportEditConfigController = __webpack_require__(1000);

var _InvoiceReportEditConfigController2 = _interopRequireDefault(_InvoiceReportEditConfigController);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InvoiceEditResultConfigController = function (_InvoiceReportEditCon) {
    _inherits(InvoiceEditResultConfigController, _InvoiceReportEditCon);

    function InvoiceEditResultConfigController() {
        _classCallCheck(this, InvoiceEditResultConfigController);

        return _possibleConstructorReturn(this, (InvoiceEditResultConfigController.__proto__ || Object.getPrototypeOf(InvoiceEditResultConfigController)).apply(this, arguments));
    }

    return InvoiceEditResultConfigController;
}(_InvoiceReportEditConfigController2.default);

exports.default = InvoiceEditResultConfigController;


InvoiceEditResultConfigController.prototype.makeReportParamsAccordingToFeatures = function (reportParameters) {
    return reportParameters;
};

/***/ }),
/* 2153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ShareReportUserSelectorButton = __webpack_require__(2154);

var _ShareReportUserSelectorButton2 = _interopRequireDefault(_ShareReportUserSelectorButton);

var _constants = __webpack_require__(4);

var _atUtils = __webpack_require__(5);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _jquery_rpc = __webpack_require__(26);

var _jquery_rpc2 = _interopRequireDefault(_jquery_rpc);

var _utils = __webpack_require__(833);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _UserNameFormat = __webpack_require__(17);

var _UserNameFormat2 = _interopRequireDefault(_UserNameFormat);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ReportConfig = function () {
    function ReportConfig(node, id, users, userGroupsEnabled, userGroups, timeZoneGroupsEnabled, timeZoneGroups, configFormat, configType, manageableUsersIds, loggedInUserId) {
        _classCallCheck(this, ReportConfig);

        this.activeClass = 'active';
        this.active = false;

        this.node = node;
        this.id = id;
        this.configFormat = configFormat;
        this.configType = configType;

        addListener(this.node, 'mousedown', makeHandler(this._mouseDown, this));
        addListener(this.node, 'mouseup', makeHandler(this._mouseUp, this));

        this.createShareButton(configType, users, userGroupsEnabled, userGroups, timeZoneGroupsEnabled, timeZoneGroups, configFormat, manageableUsersIds, loggedInUserId);
    }

    _createClass(ReportConfig, [{
        key: 'createShareButton',
        value: function createShareButton(configType, users, userGroupsEnabled, userGroups, timeZoneGroupsEnabled, timeZoneGroups, configFormat, manageableUsersIds, loggedInUserId) {
            var _this = this;

            this.shareButton = new _ShareReportUserSelectorButton2.default({
                selectorId: 'shareConfig' + this.id,
                userSelection: {
                    allUsers: true,
                    selectedUsers: [],
                    selectedGroups: [],
                    showDisabled: false,
                    groupType: null,
                    includeUserTeamOnly: false
                },
                changeCallback: function changeCallback() {
                    return _this._shareSavedConfig();
                },
                withApplyButton: true,
                needAdditionalCheckbox: false,
                includeUsersWithoutDataDefaultValue: true
            });
            var selectorUsers = this._filterSharedSelectorUsers(users, configType);
            selectorUsers = this._convertSharedSelectorUsers(selectorUsers);
            var loggedInUserNotInTeam = !!manageableUsersIds && manageableUsersIds.indexOf(parseInt(loggedInUserId)) === -1 && users.some(function (u) {
                return u.id === parseInt(loggedInUserId);
            });
            this.shareButton.updateSelector(selectorUsers, userGroupsEnabled, userGroups, timeZoneGroupsEnabled, timeZoneGroups, manageableUsersIds, false, loggedInUserNotInTeam);

            this.shareButton.updateButton();
        }
    }, {
        key: 'isActive',
        value: function isActive() {
            return this.active;
        }
    }, {
        key: '_filterSharedSelectorUsers',
        value: function _filterSharedSelectorUsers(users, configType) {
            return users.filter(function (u) {
                if (!u.active) return false;

                var accessRightsMap = (0, _atUtils.arrayToSet)(u.accessRights);

                var moneyReportTypes = (0, _atUtils.arrayToSet)([_constants.ReportType.BILLING_SUMMARY, _constants.ReportType.INVOICING, _constants.ReportType.COST_OF_WORK, _constants.ReportType.PROFIT_LOSS, _constants.ReportType.COST_OF_WORK, _constants.ReportChartType.BILLABLE_AMOUNTS]);

                if (moneyReportTypes[configType]) {
                    return !!accessRightsMap[_constants.AccessRights.GENERATE_MONEY_REPORTS];
                }

                var taskReportTypes = (0, _atUtils.arrayToSet)([_constants.ReportType.STAFF_PERFORMANCE, _constants.ReportType.TIME_TRACK_IN_DETAIL, _constants.ReportType.ESTIMATED_VS_ACTUAL, _constants.ReportChartType.TOTAL_WORKING_HOURS, _constants.ReportChartType.APPROVED_WORKING_HOURS]);

                if (taskReportTypes[configType]) {
                    return !!accessRightsMap[_constants.AccessRights.SUBMIT_TIME_TRACK] || !!accessRightsMap[_constants.AccessRights.SUBMIT_OTHER_USER_TIME_TRACK] || !!accessRightsMap[_constants.AccessRights.EDIT_HIERARCHY] || !!accessRightsMap[_constants.AccessRights.GENERATE_MONEY_REPORTS] || !!accessRightsMap[_constants.AccessRights.MANAGE_USERS];
                }

                // Without PTO_BALANCE, SICK_DAYS_BALANCE and OVERTIME_HOURS, they are special, described separately
                var userReportTypes = (0, _atUtils.arrayToSet)([_constants.ReportType.OVERTIME, _constants.ReportType.LEAVE_TIME, _constants.ReportChartType.LEAVE_HOURS]);

                if (userReportTypes[configType]) {
                    return !!accessRightsMap[_constants.AccessRights.SUBMIT_TIME_TRACK] || !!accessRightsMap[_constants.AccessRights.SUBMIT_OTHER_USER_TIME_TRACK] || !!accessRightsMap[_constants.AccessRights.GENERATE_MONEY_REPORTS] || !!accessRightsMap[_constants.AccessRights.MANAGE_USERS];
                }

                if (configType === _constants.ReportChartType.PTO_BALANCE || configType === _constants.ReportChartType.SICK_DAYS_BALANCE || configType === _constants.ReportChartType.OVERTIME_HOURS) {
                    if (!!accessRightsMap[_constants.AccessRights.MANAGE_USERS] || !!accessRightsMap[_constants.AccessRights.SUBMIT_OTHER_USER_TIME_TRACK] || !!accessRightsMap[_constants.AccessRights.MANAGE_PTO_AND_SICK]) return true;

                    if (!!accessRightsMap[_constants.AccessRights.SUBMIT_TIME_TRACK]) {
                        if (configType === _constants.ReportChartType.PTO_BALANCE) {
                            return u.isPTO;
                        }
                        if (configType === _constants.ReportChartType.SICK_DAYS_BALANCE) {
                            return u.isSick;
                        }
                        if (configType === _constants.ReportChartType.OVERTIME_HOURS) {
                            return u.isOvertimeTracking && (u.overtimeTrackingLevel === parseInt(_constants.OvertimeTrackingLevel.READONLY) || u.overtimeTrackingLevel === parseInt(_constants.OvertimeTrackingLevel.TRUSTED));
                        }
                    }

                    return false;
                }

                return !!accessRightsMap[_constants.AccessRights.SUBMIT_TIME_TRACK];
            });
        }
    }, {
        key: '_convertSharedSelectorUsers',
        value: function _convertSharedSelectorUsers(users) {
            return users.map(function (u) {
                return {
                    id: u.id,
                    firstName: u.firstName,
                    lastName: u.lastName,
                    middleName: u.middleName,
                    username: u.username,
                    enabled: u.active,
                    emailExists: u.emailExists,
                    userGroupId: u.userGroupId,
                    timeZoneGroupId: u.timeZoneGroupId
                };
            });
        }
    }, {
        key: '_mouseDown',
        value: function _mouseDown(event) {
            if (event.preventDefault) event.preventDefault();else // IE8
                {
                    event.returnValue = false;
                    if (event.button && event.button && 4) // scroll is clicked
                        {
                            event.which = 2;
                            this.mouseUp(event);
                        }
                }
            return false;
        }
    }, {
        key: '_mouseUp',
        value: function _mouseUp(event) {
            var _this2 = this;

            if (!event.which && event.button) // IE8
                {
                    if (event.button && 1) // left mouse button is clicked
                        event.which = 1;else return;
                }

            if (event.which === 3) return;

            var isScrollClicked = event.which === 2;
            var target = getEventTarget(event);
            if (ReportConfigFactory.isActiveThisOrNone(this) && this._isGenerateReportArea(target) && this._isEnabled(target)) {
                var submitCSVForm = function submitCSVForm(generateCSVUrl, isScrollClicked) {
                    var form = (0, _jquery2.default)('#csvConfigForm');
                    form.attr('action', generateCSVUrl);
                    form.find('input[name=configId]').val(_this2.id);
                    if (isScrollClicked) form.attr('target', '_blank');else form.attr('target', '_self');
                    form.submit();
                };
                if (this.configFormat === 'CHART') {
                    showChart(this.id);
                } else if (this.configFormat === 'CSV') {
                    submitCSVForm(reportCSVPathFromDB[this.configType], isScrollClicked);
                } else {
                    showReport(this.id, isScrollClicked);
                }
            }
        }
    }, {
        key: '_isGenerateReportArea',
        value: function _isGenerateReportArea(node) {
            hasParentWithClassName('configHeaderShareCell');
            return this._isConfigBody(node) && !hasParentWithClassName(node, 'configHeaderRemoveCell') && !hasParentWithClassName(node, 'configHeaderShareCell');
        }
    }, {
        key: '_isEnabled',
        value: function _isEnabled(node) {
            return hasParentWithClassName(node, 'enabled');
        }
    }, {
        key: '_isConfigBody',
        value: function _isConfigBody(node) {
            return node != null && hasParentWithClassName(node, 'config') && !hasParentWithClassName(node, 'space') && !hasParentWithClassName(node, 'transparent-blank-cell');
        }
    }, {
        key: '_shareSavedConfig',
        value: function _shareSavedConfig() {
            var users = this.shareButton.getSelectedUsers();
            var userIds = users.map(function (u) {
                return u.id;
            });

            (0, _jquery_rpc2.default)('SavedReportConfigsService.copyConfig', [this.id, userIds], function (successfullyCopiedUserIds) {
                if (successfullyCopiedUserIds.length === 1) {
                    var targetUser = users.find(function () {
                        return successfullyCopiedUserIds[0];
                    });
                    var nameFormated = _UserNameFormat2.default.formatFL(targetUser);
                    (0, _utils.toast)(_messageResource2.default.getMessage('saved_reports.share.success_toast', [nameFormated]));
                } else {
                    (0, _utils.toast)(_messageResource2.default.getMessage('saved_reports.share.success_toast', [successfullyCopiedUserIds.length + ' ' + _messageResource2.default.getMessage('common.users')]));
                }
            }, function (jqXHR, textStatus, errorThrown) {
                if (errorThrown.exception === 'com.actimind.actitime.reports.ReportConfigNotAvailableException') {
                    alert(_messageResource2.default.getMessage('saved_reports.common.config_not_available'));
                    document.location.reload();
                    return true;
                }
            });
        }
    }]);

    return ReportConfig;
}();

exports.default = ReportConfig;

/***/ }),
/* 2154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Ext = __webpack_require__(12);

var _Ext2 = _interopRequireDefault(_Ext);

var _at_selector_panel_with_apply_button_object = __webpack_require__(231);

var _at_selector_panel_with_apply_button_object2 = _interopRequireDefault(_at_selector_panel_with_apply_button_object);

var _at_shared_user_button_menu = __webpack_require__(159);

var _at_shared_user_button_menu2 = _interopRequireDefault(_at_shared_user_button_menu);

var _at_hierarchy_selector_dropdown_button = __webpack_require__(232);

var _at_hierarchy_selector_dropdown_button2 = _interopRequireDefault(_at_hierarchy_selector_dropdown_button);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _User = __webpack_require__(119);

var _User2 = _interopRequireDefault(_User);

var _two_level_selection = __webpack_require__(70);

var _two_level_selection2 = _interopRequireDefault(_two_level_selection);

var _ShareReportsSelectorUsersPanel = __webpack_require__(2155);

var _ShareReportsSelectorUsersPanel2 = _interopRequireDefault(_ShareReportsSelectorUsersPanel);

var _groupUtils = __webpack_require__(71);

var _constants = __webpack_require__(2156);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ShareReportUserSelectorButton = function () {
    function ShareReportUserSelectorButton(config) {
        var _this = this;

        _classCallCheck(this, ShareReportUserSelectorButton);

        this.containerId = config.selectorId;

        this.predefinedUserSelection = {};
        var reportConfigUserSelection = config.userSelection;

        this.settedWithPredefinedValues = !!reportConfigUserSelection;
        this.predefinedUserSelection.selectedUsers = reportConfigUserSelection && reportConfigUserSelection.selectedUsers ? reportConfigUserSelection.selectedUsers : [];
        this.predefinedUserSelection.selectedGroups = reportConfigUserSelection && reportConfigUserSelection.selectedGroups ? reportConfigUserSelection.selectedGroups : [];
        this.predefinedUserSelection.showDisabled = reportConfigUserSelection ? !!reportConfigUserSelection.showDisabled : true;
        this.predefinedUserSelection.groupType = reportConfigUserSelection ? reportConfigUserSelection.groupType : null;
        this.predefinedUserSelection.includeUserTeamOnly = reportConfigUserSelection ? reportConfigUserSelection.includeUserTeamOnly : false;

        var params = config.report_name ? { collapsedCookiesKey: config.report_name } : {};
        var panelConstructor = _ShareReportsSelectorUsersPanel2.default;
        var applyButtonExtension = _at_selector_panel_with_apply_button_object2.default.getApplyButtonExtension(panelConstructor);
        applyButtonExtension.closeButtonLabelKey = 'saved_reports.common.copy_to';
        _Ext2.default.apply(params, applyButtonExtension);

        this.panel = new panelConstructor(params);

        this.panel.setPredefinedState(this.convertPredefinedStateFromSelection(this.predefinedUserSelection));
        this.userSelectorMenu = new _at_shared_user_button_menu2.default({ panel: this.panel });

        this._createUserButton(this.containerId, this.userSelectorMenu, _constants.SHARE_REPORT_SELECTOR_PANEL_HEIGHT);

        this.panel.closeButton.on('click', function () {
            if (config.changeCallback && _this.panel.validateIsUsersSelected()) {
                config.changeCallback();
                _this.panel.resetState(true);
            }
        });
    }

    _createClass(ShareReportUserSelectorButton, [{
        key: '_createUserButton',
        value: function _createUserButton(containerId, userSelectorMenu, selectorPanelHeight) {
            this.chooseUserButton = new _at_hierarchy_selector_dropdown_button2.default({
                labelCls: 'hierarchySelectorButton',
                renderTo: containerId,
                menu: userSelectorMenu,
                selectorPanelHeight: selectorPanelHeight
            });
            this.chooseUserButton.setText(_messageResource2.default.getMessage('users_selector.reports.loading'));
            this.chooseUserButton.setEnabled(false);
        }
    }, {
        key: 'updateButton',
        value: function updateButton() {
            this.chooseUserButton.updateButton();
        }
    }, {
        key: 'getButton',
        value: function getButton() {
            return this.chooseUserButton;
        }
    }, {
        key: 'setInitialValueFromCurrent',
        value: function setInitialValueFromCurrent() {
            this.panel.setInitialValueFromCurrent();
        }
    }, {
        key: 'updateSelector',
        value: function updateSelector(users, userGroupsEnabled, userGroups, timeZoneGroupsEnabled, timeZoneGroups, manageableUsersIds, showTeamOnly, loggedInUserNotInTeam) {
            var convertedUserGroups = userGroups == null ? null : (0, _groupUtils.transformListToGroups)(userGroups);
            var convertedTimeZoneGroups = timeZoneGroups == null ? null : (0, _groupUtils.transformListToGroups)(timeZoneGroups);
            this.initializeData(userGroupsEnabled, timeZoneGroupsEnabled, this._convertUserInfoToJsUsers(users), manageableUsersIds, convertedUserGroups, convertedTimeZoneGroups, showTeamOnly, loggedInUserNotInTeam);
        }
    }, {
        key: 'initializeData',
        value: function initializeData(userGroupsEnabled, timeZoneGroupsEnabled, users, manageableUsersIds, userGroups, timeZoneGroups, showTeamOnly, loggedInUserNotInTeam) {
            this.panelWasConstructing = true;
            this.panel.initialize({
                userGroupsEnabled: userGroupsEnabled,
                timeZoneGroupsEnabled: timeZoneGroupsEnabled,
                users: users,
                manageableUsersIds: manageableUsersIds,
                userGroups: userGroups,
                timeZoneGroups: timeZoneGroups,
                showTeamOnly: showTeamOnly,
                loggedInUserNotInTeam: loggedInUserNotInTeam
            });
            this.chooseUserButton.setEnabled(true);
        }
    }, {
        key: 'getSelectedUsers',
        value: function getSelectedUsers() {
            return this.panel.getOnlyUsersSelection();
        }
    }, {
        key: 'setSelection',
        value: function setSelection(userSelection) {
            var predefinedState = this.convertPredefinedStateFromSelection(userSelection);
            this.panel.setPredefinedState(predefinedState);
            if (this.panelWasConstructing) {
                this.panel.loadState(predefinedState);
            }
        }
    }, {
        key: '_convertUserInfoToJsUsers',
        value: function _convertUserInfoToJsUsers(userbeans) {
            var users = [];
            for (var i = 0; i < userbeans.length; ++i) {
                var u = userbeans[i];
                users.push(new _User2.default(u.id, u.firstName, u.lastName, u.middleName, u.username, u.enabled, undefined, u.userGroupId, u.timeZoneGroupId));
            }
            return users;
        }
    }, {
        key: 'validateIsUserSelected',
        value: function validateIsUserSelected() {
            return this.settedWithPredefinedValues || this.panel.isAlreadyShown() ? this.panel.validateIsUsersSelected() : this.predefinedUserSelection.allUsers || this.predefinedUserSelection.selectedUsers !== [] || this.predefinedUserSelection.selectedGroups !== [];
        }
    }, {
        key: 'convertPredefinedStateFromSelection',
        value: function convertPredefinedStateFromSelection(selection) {
            return {
                selection: selection.allUsers ? _two_level_selection2.default.emptySelection() : new _two_level_selection2.default(selection.selectedGroups, selection.selectedUsers),
                optionValue: selection.allUsers,
                showInactive: selection.showDisabled,
                groupType: selection.groupType
            };
        }
    }, {
        key: 'isStateChanged',
        value: function isStateChanged() {
            return this.panel.isStateChanged();
        }
    }]);

    return ShareReportUserSelectorButton;
}();

exports.default = ShareReportUserSelectorButton;

/***/ }),
/* 2155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Ext = __webpack_require__(12);

var _Ext2 = _interopRequireDefault(_Ext);

var _at_users_selector_panel = __webpack_require__(162);

var _at_users_selector_panel2 = _interopRequireDefault(_at_users_selector_panel);

var _SwitcherWithWrapper = __webpack_require__(478);

var _SwitcherWithWrapper2 = _interopRequireDefault(_SwitcherWithWrapper);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _ReportsUsersSelectorFilter = __webpack_require__(796);

var _ReportsUsersSelectorFilter2 = _interopRequireDefault(_ReportsUsersSelectorFilter);

var _ReportsUserSelectorTreeBuilderObserver = __webpack_require__(797);

var _ReportsUserSelectorTreeBuilderObserver2 = _interopRequireDefault(_ReportsUserSelectorTreeBuilderObserver);

var _atBrowserUtils = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ShareReportsSelectorUsersPanel = _Ext2.default.extend(_at_users_selector_panel2.default, {
    showInactiveLabelKey: 'users_selector.reports.show_disabled',
    predefinedState: null,
    hasPanel: true,
    resetOnHide: true,
    allUsersAvailable: true,
    loggedInUserNotInTeam: false,
    allItemsOptionValue: false,

    setSelectorFilter: function setSelectorFilter() {
        this.selectorFilter = new _ReportsUsersSelectorFilter2.default({
            tree: this.selectorTree,
            searchIndex: this.searchIndex,
            allActiveSet: this.allActiveSet,
            myTeamNodesSet: this.treeBuilderObserver.getManageableUsersNodeSet(),
            accessibleParentNodes: this.treeBuilderObserver.getAccessibleParentNodes(),
            showTeamOnly: this.showTeamOnly
        });
    },
    createUserSelectorTreeBuilderObserver: function createUserSelectorTreeBuilderObserver(searchIndex, allActiveSet) {
        this.treeBuilderObserver = new _ReportsUserSelectorTreeBuilderObserver2.default({
            searchIndex: searchIndex,
            allActiveSet: allActiveSet,
            manageableUsersIdsSet: this.manageableUsersIdsSet
        });
        return this.treeBuilderObserver;
    },
    initialize: function initialize(_ref) {
        var userGroupsEnabled = _ref.userGroupsEnabled,
            timeZoneGroupsEnabled = _ref.timeZoneGroupsEnabled,
            users = _ref.users,
            manageableUsersIds = _ref.manageableUsersIds,
            userGroups = _ref.userGroups,
            timeZoneGroups = _ref.timeZoneGroups,
            showTeamOnly = _ref.showTeamOnly,
            loggedInUserNotInTeam = _ref.loggedInUserNotInTeam;

        var state = this.predefinedState;
        this.manageableUsersIdsSet = manageableUsersIds && manageableUsersIds.length > 0 ? new Set(manageableUsersIds) : null;
        this.loggedInUserNotInTeam = loggedInUserNotInTeam;

        if (!state.optionValue && !state.showInactive) {
            var selectedUserIds = state.selection.getSecondLevel();

            for (var i = 0; i < users.length; i++) {
                if (selectedUserIds.indexOf(users[i].id) !== -1) {
                    if (!users[i].active) {
                        state.showInactive = true;
                        break;
                    }
                }
            }
        }

        ShareReportsSelectorUsersPanel.superclass.initialize.call(this, userGroupsEnabled, timeZoneGroupsEnabled, users, userGroups, timeZoneGroups);

        this.showTeamOnly = showTeamOnly;
        this.showTeamOnlyInit = showTeamOnly;
        this.alreadyShown = false;
        this.clearPanel();

        this.loadState(state);

        this.selectorFilter.setShowInactive(state.showInactive);
    },
    createCustomOption: function createCustomOption() {
        this.customOption = undefined;
    },
    createGenericOptions: function createGenericOptions() {
        this.genericOptions = [];
    },
    disableTextSelectionForNeededElements: function disableTextSelectionForNeededElements() {
        (0, _atBrowserUtils.disableTextSelection)(this.customOptionsContainer.el.dom);
    },
    getCurrentOptionValue: function getCurrentOptionValue() {
        return this.customOptionValue;
    },
    isCustomOptionSelected: function isCustomOptionSelected() {
        return true;
    },
    getCustomOptionSection: function getCustomOptionSection() {
        var customOptionControls = [];
        // from left to right
        customOptionControls.push(this.viewByPanel);
        customOptionControls.push(this.getCustomOptionButtonsSection());

        this.customControlsContainer = new _Ext2.default.Container({
            cls: 'userSelectorCustomControlsContainer',
            autoEl: 'div',
            items: customOptionControls
        });
        return [this.mainLabel, this.customControlsContainer];
    },
    getDetailsSection: function getDetailsSection() {
        return [this.selectorTree];
    },
    getDescription: function getDescription(selectionHelper, dropdownButtonId) {
        return _messageResource2.default.getMessage('saved_reports.common.copy_to');
    },
    setPredefinedState: function setPredefinedState(predefinedState) {
        this.predefinedState = predefinedState;
    },
    createComponents: function createComponents() {
        var _this = this;

        ShareReportsSelectorUsersPanel.superclass.createComponents.call(this);

        this.mainLabel = new _Ext2.default.Panel({
            html: _messageResource2.default.getMessage('saved_reports.common.user_selector.copy_report_config_to'),
            cls: 'text main-label'
        });

        this.on('afterlayout', function () {
            if (_this._isTeamOnlySwitcherAvailable()) {
                var $container = (0, _jquery2.default)(_this.el.dom).find('.custom');
                var switcherText = _messageResource2.default.getMessage('saved_reports.common.user_selector.copy_report_team_switcher');
                _this.showTeamOnlySwither = new _SwitcherWithWrapper2.default({
                    containerAdditionalClass: 'teamSwitcherContainer',
                    switcherTextAdditionalClass: 'teamSwitcherText',
                    switcherAdditionalClass: 'teamSwitcher',
                    onSwitchCallback: function onSwitchCallback(show) {
                        return _this._teamSwitchedHandler(show);
                    },
                    switcherText: switcherText
                }).init($container);
                _this.showTeamOnlySwither.setState({ enabled: _this.showTeamOnly });
            }
        });

        this.addClass('shareConfigUserSelectorPanel');
    },
    _isTeamOnlySwitcherAvailable: function _isTeamOnlySwitcherAvailable() {
        return this.manageableUsersIdsSet !== null && this.manageableUsersIdsSet.size !== this.users.length;
    },
    _teamSwitchedHandler: function _teamSwitchedHandler(show) {
        this.showTeamOnly = show;
        this.showTeamOnlySwither.setState({ enabled: show });
        this.selectorFilter.setShowUsersFromMyTeamOnly(show);
        this.onChange();
    },
    validateIsUsersSelected: function validateIsUsersSelected() {
        return !this.isCustomOptionSelected() || !this.getSelection().isEmpty();
    },
    makeSelectionTree: function makeSelectionTree() {
        //do nothing
    },
    setInitialValueFromCurrent: function setInitialValueFromCurrent() {
        if (this.isAlreadyShown()) {
            this.setFilterFlag(this.getShowInactive());
            this.selectorTree.initializeByNodeSet(this.makeNodeSet(this.getSelection()));
            this.setInitialOptionValue(!this.isCustomOptionSelected());
            this.updateInitialTreeSet();
            this.updateInitialGroupType();
            this.showTeamOnlyInit = this.showTeamOnly;
        }
    },
    initComponent: function initComponent() {
        ShareReportsSelectorUsersPanel.superclass.initComponent.call(this);
        this.collapsedCookiesKey += 'CollapsedUsers';
        this.on('afterlayout', function () {
            var parentNode = this.getEl().findParentNode('div.at-selector-menu', 10, true);
            if (parentNode) parentNode.addClass('usersSelectorType');
        }, this);
    },
    isStateChanged: function isStateChanged() {
        if (this.isAlreadyShown()) {
            return ShareReportsSelectorUsersPanel.superclass.isStateChanged.call(this);
        } else {
            return false;
        }
    },
    resetState: function resetState(isEnableActiveActions) {
        if (this._isTeamOnlySwitcherAvailable()) {
            this._teamSwitchedHandler(this.showTeamOnlyInit);
        }

        ShareReportsSelectorUsersPanel.superclass.resetState.call(this, isEnableActiveActions);
    }
});

_Ext2.default.reg('at_reports_selector_users_panel', ShareReportsSelectorUsersPanel);

exports.default = ShareReportsSelectorUsersPanel;

/***/ }),
/* 2156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var SHARE_REPORT_SELECTOR_PANEL_HEIGHT = exports.SHARE_REPORT_SELECTOR_PANEL_HEIGHT = 450;

/***/ }),
/* 2157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _underscore = __webpack_require__(3);

var _underscore2 = _interopRequireDefault(_underscore);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _messageResource = __webpack_require__(0);

var _messageResource2 = _interopRequireDefault(_messageResource);

var _UserSelectorUtils = __webpack_require__(514);

var _UserSelectorUtils2 = _interopRequireDefault(_UserSelectorUtils);

var _BaseReportParamsStringBuilder = __webpack_require__(803);

var _BaseReportParamsStringBuilder2 = _interopRequireDefault(_BaseReportParamsStringBuilder);

var _FormatUtils = __webpack_require__(142);

var _FormatUtils2 = _interopRequireDefault(_FormatUtils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var APReportParamsStringBuilder = function (_BaseReportParamsStri) {
    _inherits(APReportParamsStringBuilder, _BaseReportParamsStri);

    function APReportParamsStringBuilder(_ref) {
        var data = _ref.data,
            dateFormat = _ref.dateFormat,
            reportAuthorizationInfo = _ref.reportAuthorizationInfo;

        _classCallCheck(this, APReportParamsStringBuilder);

        var _this = _possibleConstructorReturn(this, (APReportParamsStringBuilder.__proto__ || Object.getPrototypeOf(APReportParamsStringBuilder)).call(this, { data: data, dateFormat: dateFormat, userFormatter: _FormatUtils2.default.reportUserFormatterWithoutUsername }));

        _this.userGroupsFeatureEnabled = data.userGroupsFeatureEnabled;
        _this.tzGroupsFeatureEnabled = data.tzGroupsFeatureEnabled;
        _this.reportAuthorizationInfo = reportAuthorizationInfo;
        return _this;
    }

    _createClass(APReportParamsStringBuilder, [{
        key: "getUserSelectionParamString",
        value: function getUserSelectionParamString(userSelection, assignedInfo) {
            var _this2 = this;

            if (this.reportAuthorizationInfo && !this.reportAuthorizationInfo.allUsersAvailable && !this.reportAuthorizationInfo.anyOtherUsersAvailable) {
                return this.userFormatter.format(assignedInfo.viewerInfo);
            }
            return _get(APReportParamsStringBuilder.prototype.__proto__ || Object.getPrototypeOf(APReportParamsStringBuilder.prototype), "getUserSelectionParamString", this).call(this, userSelection, function () {
                return _this2._getAllUsersMessage(assignedInfo);
            });
        }
    }, {
        key: "_getAllUsersMessage",
        value: function _getAllUsersMessage(assignedInfo) {
            if (!_underscore2.default.isUndefined(assignedInfo) && assignedInfo.isShowOnlyAssigned) {
                return _messageResource2.default.getMessage("common.report.all_staff.assigned_to_me", [assignedInfo.viewerInfo.formatNameFML()]);
            } else {
                return _messageResource2.default.getMessage("common.pdf.formatting.all_staff");
            }
        }
    }, {
        key: "_convertSelectedGroupsToSelectedUsersIfNecessary",
        value: function _convertSelectedGroupsToSelectedUsersIfNecessary(users, userSelection) {
            var convertedUsers = _UserSelectorUtils2.default.convertSelectedGroupsIntoSelectedUsersIfNecessary(this.users, userSelection.groupType, userSelection.allUsers, userSelection.showDisabled, userSelection.selectedGroups, this.userGroupsFeatureEnabled, this.tzGroupsFeatureEnabled);

            return _jquery2.default.merge(users, convertedUsers);
        }
    }, {
        key: "_getIncludeUserTeamOnlyMessage",
        value: function _getIncludeUserTeamOnlyMessage(users) {
            // doesn't support in AP
        }
    }]);

    return APReportParamsStringBuilder;
}(_BaseReportParamsStringBuilder2.default);

exports.default = APReportParamsStringBuilder;

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// globals.webpack.js